(function(){"use strict";try{if(typeof document<"u"){var t=document.createElement("style");t.appendChild(document.createTextNode(`*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:var(--font-sans),ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}[type=text],input:where(:not([type])),[type=email],[type=url],[type=password],[type=number],[type=date],[type=datetime-local],[type=month],[type=search],[type=tel],[type=time],[type=week],[multiple],textarea,select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;border-color:#6b7280;border-width:1px;border-radius:0;padding:.5rem .75rem;font-size:1rem;line-height:1.5rem;--tw-shadow: 0 0 #0000}[type=text]:focus,input:where(:not([type])):focus,[type=email]:focus,[type=url]:focus,[type=password]:focus,[type=number]:focus,[type=date]:focus,[type=datetime-local]:focus,[type=month]:focus,[type=search]:focus,[type=tel]:focus,[type=time]:focus,[type=week]:focus,[multiple]:focus,textarea:focus,select:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: #2563eb;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow);border-color:#2563eb}input::-moz-placeholder,textarea::-moz-placeholder{color:#6b7280;opacity:1}input::placeholder,textarea::placeholder{color:#6b7280;opacity:1}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-date-and-time-value{min-height:1.5em;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-top:0;padding-bottom:0}select{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;padding-right:2.5rem;-webkit-print-color-adjust:exact;print-color-adjust:exact}[multiple],[size]:where(select:not([size="1"])){background-image:initial;background-position:initial;background-repeat:unset;background-size:initial;padding-right:.75rem;-webkit-print-color-adjust:unset;print-color-adjust:unset}[type=checkbox],[type=radio]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact;display:inline-block;vertical-align:middle;background-origin:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;flex-shrink:0;height:1rem;width:1rem;color:#2563eb;background-color:#fff;border-color:#6b7280;border-width:1px;--tw-shadow: 0 0 #0000}[type=checkbox]{border-radius:0}[type=radio]{border-radius:100%}[type=checkbox]:focus,[type=radio]:focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-inset: var(--tw-empty, );--tw-ring-offset-width: 2px;--tw-ring-offset-color: #fff;--tw-ring-color: #2563eb;--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}[type=checkbox]:checked,[type=radio]:checked{border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}[type=checkbox]:checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e")}@media (forced-colors: active){[type=checkbox]:checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=radio]:checked{background-image:url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e")}@media (forced-colors: active){[type=radio]:checked{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=checkbox]:checked:hover,[type=checkbox]:checked:focus,[type=radio]:checked:hover,[type=radio]:checked:focus{border-color:transparent;background-color:currentColor}[type=checkbox]:indeterminate{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e");border-color:transparent;background-color:currentColor;background-size:100% 100%;background-position:center;background-repeat:no-repeat}@media (forced-colors: active){[type=checkbox]:indeterminate{-webkit-appearance:auto;-moz-appearance:auto;appearance:auto}}[type=checkbox]:indeterminate:hover,[type=checkbox]:indeterminate:focus{border-color:transparent;background-color:currentColor}[type=file]{background:unset;border-color:inherit;border-width:0;border-radius:0;padding:0;font-size:unset;line-height:inherit}[type=file]:focus{outline:1px solid ButtonText;outline:1px auto -webkit-focus-ring-color}:root{--background: 0 0% 100%;--foreground: 222.2 47.4% 11.2%;--muted: 210 40% 96.1%;--muted-foreground: 215.4 16.3% 46.9%;--popover: 0 0% 100%;--popover-foreground: 222.2 47.4% 11.2%;--border: 214.3 31.8% 91.4%;--input: 214.3 31.8% 91.4%;--card: 0 0% 100%;--card-foreground: 222.2 47.4% 11.2%;--primary: 222.2 47.4% 11.2%;--primary-foreground: 210 40% 98%;--secondary: 210 40% 96.1%;--secondary-foreground: 222.2 47.4% 11.2%;--accent: 210 40% 96.1%;--accent-foreground: 222.2 47.4% 11.2%;--destructive: 0 100% 50%;--destructive-foreground: 210 40% 98%;--ring: 215 20.2% 65.1%;--radius: .5rem}.dark{--background: 224 71% 4%;--foreground: 213 31% 91%;--muted: 223 47% 11%;--muted-foreground: 215.4 16.3% 56.9%;--accent: 216 34% 17%;--accent-foreground: 210 40% 98%;--popover: 224 71% 4%;--popover-foreground: 215 20.2% 65.1%;--border: 216 34% 17%;--input: 216 34% 17%;--card: 224 71% 4%;--card-foreground: 213 31% 91%;--primary: 210 40% 98%;--primary-foreground: 222.2 47.4% 1.2%;--secondary: 222.2 47.4% 11.2%;--secondary-foreground: 210 40% 98%;--destructive: 0 63% 31%;--destructive-foreground: 210 40% 98%;--ring: 216 34% 17%;--radius: .5rem}*{border-color:hsl(var(--border))}body{background-color:hsl(var(--background));color:hsl(var(--foreground));font-feature-settings:"rlig" 1,"calt" 1}.container{width:100%;margin-right:auto;margin-left:auto;padding-right:2rem;padding-left:2rem}@media (min-width: 1400px){.container{max-width:1400px}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.visible{visibility:visible}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.inset-y-2{top:.5rem;bottom:.5rem}.bottom-0{bottom:0}.left-2{left:.5rem}.left-\\[50\\%\\]{left:50%}.right-0{right:0}.right-4{right:1rem}.top-0{top:0}.top-4{top:1rem}.top-\\[50\\%\\]{top:50%}.z-50{z-index:50}.\\!-m-0{margin:-0px!important}.-mx-1{margin-left:-.25rem;margin-right:-.25rem}.mx-auto{margin-left:auto;margin-right:auto}.my-1{margin-top:.25rem;margin-bottom:.25rem}.-mb-px{margin-bottom:-1px}.mb-0{margin-bottom:0}.mb-1\\.5{margin-bottom:.375rem}.ml-auto{margin-left:auto}.mt-1{margin-top:.25rem}.mt-2{margin-top:.5rem}.mt-4{margin-top:1rem}.block{display:block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.contents{display:contents}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.size-2{width:.5rem;height:.5rem}.size-4{width:1rem;height:1rem}.size-5{width:1.25rem;height:1.25rem}.size-6{width:1.5rem;height:1.5rem}.size-full{width:100%;height:100%}.h-10{height:2.5rem}.h-2{height:.5rem}.h-3\\.5{height:.875rem}.h-4{height:1rem}.h-40{height:10rem}.h-8{height:2rem}.h-80{height:20rem}.h-9{height:2.25rem}.h-\\[3px\\]{height:3px}.h-full{height:100%}.h-px{height:1px}.h-screen{height:100vh}.w-2{width:.5rem}.w-3\\.5{width:.875rem}.w-4{width:1rem}.w-40{width:10rem}.w-5{width:1.25rem}.w-56{width:14rem}.w-9{width:2.25rem}.w-\\[95vw\\]{width:95vw}.w-full{width:100%}.min-w-10{min-width:2.5rem}.min-w-8{min-width:2rem}.min-w-9{min-width:2.25rem}.min-w-\\[8rem\\]{min-width:8rem}.max-w-\\[200px\\]{max-width:200px}.max-w-full{max-width:100%}.max-w-lg{max-width:32rem}.flex-1{flex:1 1 0%}.shrink-0{flex-shrink:0}.translate-x-\\[-50\\%\\]{--tw-translate-x: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.translate-y-\\[-50\\%\\]{--tw-translate-y: -50%;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.rotate-1{--tw-rotate: 1deg;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}@keyframes spin{to{transform:rotate(360deg)}}.animate-spin{animation:spin 1s linear infinite}.cursor-default{cursor:default}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}.resize{resize:both}.snap-mandatory{--tw-scroll-snap-strictness: mandatory}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.flex-col{flex-direction:column}.flex-col-reverse{flex-direction:column-reverse}.flex-wrap{flex-wrap:wrap}.flex-nowrap{flex-wrap:nowrap}.items-start{align-items:flex-start}.items-center{align-items:center}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.gap-1\\.5{gap:.375rem}.gap-2{gap:.5rem}.gap-4{gap:1rem}.gap-x-4{-moz-column-gap:1rem;column-gap:1rem}.gap-y-1{row-gap:.25rem}.space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.space-x-6>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(1.5rem * var(--tw-space-x-reverse));margin-left:calc(1.5rem * calc(1 - var(--tw-space-x-reverse)))}.space-x-8>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(2rem * var(--tw-space-x-reverse));margin-left:calc(2rem * calc(1 - var(--tw-space-x-reverse)))}.space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.25rem * var(--tw-space-y-reverse))}.space-y-1\\.5>:not([hidden])~:not([hidden]){--tw-space-y-reverse: 0;margin-top:calc(.375rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(.375rem * var(--tw-space-y-reverse))}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.whitespace-nowrap{white-space:nowrap}.rounded{border-radius:.25rem}.rounded-full{border-radius:9999px}.rounded-md{border-radius:calc(var(--radius) - 2px)}.rounded-sm{border-radius:calc(var(--radius) - 4px)}.border{border-width:1px}.border-0{border-width:0px}.border-\\[1px\\]{border-width:1px}.border-b{border-bottom-width:1px}.border-b-2{border-bottom-width:2px}.border-t{border-top-width:1px}.border-black{--tw-border-opacity: 1;border-color:rgb(0 0 0 / var(--tw-border-opacity, 1))}.border-gray-200{--tw-border-opacity: 1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}.border-gray-300{--tw-border-opacity: 1;border-color:rgb(209 213 219 / var(--tw-border-opacity, 1))}.border-inherit{border-color:inherit}.border-input{border-color:hsl(var(--input))}.border-red-500{--tw-border-opacity: 1;border-color:rgb(239 68 68 / var(--tw-border-opacity, 1))}.border-transparent{border-color:transparent}.bg-amber-500{--tw-bg-opacity: 1;background-color:rgb(245 158 11 / var(--tw-bg-opacity, 1))}.bg-background{background-color:hsl(var(--background))}.bg-black\\/30{background-color:#0000004d}.bg-black\\/80{background-color:#000c}.bg-blue-200{--tw-bg-opacity: 1;background-color:rgb(191 219 254 / var(--tw-bg-opacity, 1))}.bg-blue-500{--tw-bg-opacity: 1;background-color:rgb(59 130 246 / var(--tw-bg-opacity, 1))}.bg-cyan-500{--tw-bg-opacity: 1;background-color:rgb(6 182 212 / var(--tw-bg-opacity, 1))}.bg-destructive{background-color:hsl(var(--destructive))}.bg-emerald-500{--tw-bg-opacity: 1;background-color:rgb(16 185 129 / var(--tw-bg-opacity, 1))}.bg-fuchsia-500{--tw-bg-opacity: 1;background-color:rgb(217 70 239 / var(--tw-bg-opacity, 1))}.bg-gray-100{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.bg-gray-200{--tw-bg-opacity: 1;background-color:rgb(229 231 235 / var(--tw-bg-opacity, 1))}.bg-gray-500{--tw-bg-opacity: 1;background-color:rgb(107 114 128 / var(--tw-bg-opacity, 1))}.bg-lime-500{--tw-bg-opacity: 1;background-color:rgb(132 204 22 / var(--tw-bg-opacity, 1))}.bg-muted{background-color:hsl(var(--muted))}.bg-pink-500{--tw-bg-opacity: 1;background-color:rgb(236 72 153 / var(--tw-bg-opacity, 1))}.bg-popover{background-color:hsl(var(--popover))}.bg-primary{background-color:hsl(var(--primary))}.bg-red-600{--tw-bg-opacity: 1;background-color:rgb(220 38 38 / var(--tw-bg-opacity, 1))}.bg-secondary{background-color:hsl(var(--secondary))}.bg-transparent{background-color:transparent}.bg-violet-500{--tw-bg-opacity: 1;background-color:rgb(139 92 246 / var(--tw-bg-opacity, 1))}.bg-white{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.bg-yellow-100{--tw-bg-opacity: 1;background-color:rgb(254 249 195 / var(--tw-bg-opacity, 1))}.fill-amber-500{fill:#f59e0b}.fill-blue-500{fill:#3b82f6}.fill-current{fill:currentColor}.fill-cyan-500{fill:#06b6d4}.fill-emerald-500{fill:#10b981}.fill-fuchsia-500{fill:#d946ef}.fill-gray-500{fill:#6b7280}.fill-gray-700{fill:#374151}.fill-gray-800{fill:#1f2937}.fill-lime-500{fill:#84cc16}.fill-pink-500{fill:#ec4899}.fill-violet-500{fill:#8b5cf6}.stroke-amber-500{stroke:#f59e0b}.stroke-blue-500{stroke:#3b82f6}.stroke-cyan-500{stroke:#06b6d4}.stroke-emerald-500{stroke:#10b981}.stroke-fuchsia-500{stroke:#d946ef}.stroke-gray-200{stroke:#e5e7eb}.stroke-gray-500{stroke:#6b7280}.stroke-lime-500{stroke:#84cc16}.stroke-pink-500{stroke:#ec4899}.stroke-violet-500{stroke:#8b5cf6}.stroke-white{stroke:#fff}.stroke-1{stroke-width:1}.p-0{padding:0}.p-1{padding:.25rem}.p-2{padding:.5rem}.p-4{padding:1rem}.p-6{padding:1.5rem}.px-1\\.5{padding-left:.375rem;padding-right:.375rem}.px-2{padding-left:.5rem;padding-right:.5rem}.px-2\\.5{padding-left:.625rem;padding-right:.625rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-8{padding-left:2rem;padding-right:2rem}.py-1{padding-top:.25rem;padding-bottom:.25rem}.py-1\\.5{padding-top:.375rem;padding-bottom:.375rem}.py-2{padding-top:.5rem;padding-bottom:.5rem}.py-4{padding-top:1rem;padding-bottom:1rem}.pb-2{padding-bottom:.5rem}.pb-4{padding-bottom:1rem}.pl-4{padding-left:1rem}.pl-8{padding-left:2rem}.pr-1{padding-right:.25rem}.pr-12{padding-right:3rem}.pr-2{padding-right:.5rem}.pt-4{padding-top:1rem}.text-center{text-align:center}.text-right{text-align:right}.text-base{font-size:1rem;line-height:1.5rem}.text-lg{font-size:1.125rem;line-height:1.75rem}.text-sm{font-size:.875rem;line-height:1.25rem}.text-xs{font-size:.75rem;line-height:1rem}.font-medium{font-weight:500}.font-semibold{font-weight:600}.uppercase{text-transform:uppercase}.italic{font-style:italic}.tabular-nums{--tw-numeric-spacing: tabular-nums;font-variant-numeric:var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction)}.leading-none{line-height:1}.tracking-tight{letter-spacing:-.025em}.tracking-widest{letter-spacing:.1em}.text-amber-500{--tw-text-opacity: 1;color:rgb(245 158 11 / var(--tw-text-opacity, 1))}.text-blue-500{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.text-blue-700{--tw-text-opacity: 1;color:rgb(29 78 216 / var(--tw-text-opacity, 1))}.text-cyan-500{--tw-text-opacity: 1;color:rgb(6 182 212 / var(--tw-text-opacity, 1))}.text-destructive-foreground{color:hsl(var(--destructive-foreground))}.text-emerald-500{--tw-text-opacity: 1;color:rgb(16 185 129 / var(--tw-text-opacity, 1))}.text-fuchsia-500{--tw-text-opacity: 1;color:rgb(217 70 239 / var(--tw-text-opacity, 1))}.text-gray-400{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}.text-gray-500{--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}.text-gray-700{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.text-gray-900{--tw-text-opacity: 1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}.text-lime-500{--tw-text-opacity: 1;color:rgb(132 204 22 / var(--tw-text-opacity, 1))}.text-muted-foreground{color:hsl(var(--muted-foreground))}.text-pink-500{--tw-text-opacity: 1;color:rgb(236 72 153 / var(--tw-text-opacity, 1))}.text-popover-foreground{color:hsl(var(--popover-foreground))}.text-primary{color:hsl(var(--primary))}.text-primary-foreground{color:hsl(var(--primary-foreground))}.text-secondary-foreground{color:hsl(var(--secondary-foreground))}.text-violet-500{--tw-text-opacity: 1;color:rgb(139 92 246 / var(--tw-text-opacity, 1))}.text-white{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.underline-offset-2{text-underline-offset:2px}.underline-offset-4{text-underline-offset:4px}.opacity-100{opacity:1}.opacity-40{opacity:.4}.opacity-60{opacity:.6}.opacity-70{opacity:.7}.shadow{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px rgb(0 0 0 / .1), 0 4px 6px -4px rgb(0 0 0 / .1);--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-md{--tw-shadow: 0 4px 6px -1px rgb(0 0 0 / .1), 0 2px 4px -2px rgb(0 0 0 / .1);--tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-none{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-sm{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.shadow-xl{--tw-shadow: 0 20px 25px -5px rgb(0 0 0 / .1), 0 8px 10px -6px rgb(0 0 0 / .1);--tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-0{outline-width:0px}.outline-offset-2{outline-offset:2px}.outline-blue-500{outline-color:#3b82f6}.ring{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-1{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-2{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.ring-inset{--tw-ring-inset: inset}.ring-red-200{--tw-ring-opacity: 1;--tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1))}.ring-transparent{--tw-ring-color: transparent}.ring-offset-background{--tw-ring-offset-color: hsl(var(--background))}.\\!filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)!important}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-colors{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-100{transition-duration:.1s}.duration-200{transition-duration:.2s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}@keyframes enter{0%{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0),var(--tw-enter-translate-y, 0),0) scale3d(var(--tw-enter-scale, 1),var(--tw-enter-scale, 1),var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0),var(--tw-exit-translate-y, 0),0) scale3d(var(--tw-exit-scale, 1),var(--tw-exit-scale, 1),var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}.fade-in{--tw-enter-opacity: 0}.duration-100{animation-duration:.1s}.duration-200{animation-duration:.2s}.ease-in-out{animation-timing-function:cubic-bezier(.4,0,.2,1)}.\\[scrollbar-width\\:none\\]{scrollbar-width:none}@keyframes bounce{0%,to{transform:translateY(0)}15%{transform:translateY(-6px)}30%,to{transform:translateY(0)}}.bounce{animation:bounce 1.5s infinite}.bounce-delay-1{animation-delay:0s}.bounce-delay-2{animation-delay:.1s}.bounce-delay-3{animation-delay:.2s}.hide-scroll-background{overflow-y:scroll;scrollbar-color:#999 transparent}.hover\\:cursor-pointer:hover{cursor:pointer}.hover\\:border-gray-300:hover{--tw-border-opacity: 1;border-color:rgb(209 213 219 / var(--tw-border-opacity, 1))}.hover\\:bg-accent:hover{background-color:hsl(var(--accent))}.hover\\:bg-blue-600:hover{--tw-bg-opacity: 1;background-color:rgb(37 99 235 / var(--tw-bg-opacity, 1))}.hover\\:bg-destructive\\/90:hover{background-color:hsl(var(--destructive) / .9)}.hover\\:bg-gray-100:hover{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.hover\\:bg-gray-300\\/70:hover{background-color:#d1d5dbb3}.hover\\:bg-gray-50:hover{--tw-bg-opacity: 1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}.hover\\:bg-muted:hover{background-color:hsl(var(--muted))}.hover\\:bg-primary\\/90:hover{background-color:hsl(var(--primary) / .9)}.hover\\:bg-red-700:hover{--tw-bg-opacity: 1;background-color:rgb(185 28 28 / var(--tw-bg-opacity, 1))}.hover\\:bg-secondary\\/80:hover{background-color:hsl(var(--secondary) / .8)}.hover\\:text-accent-foreground:hover{color:hsl(var(--accent-foreground))}.hover\\:text-gray-700:hover{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.hover\\:text-gray-900:hover{--tw-text-opacity: 1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}.hover\\:text-muted-foreground:hover{color:hsl(var(--muted-foreground))}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:underline-offset-2:hover{text-underline-offset:2px}.hover\\:opacity-100:hover{opacity:1}.hover\\:shadow:hover{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.focus\\:border-blue-500:focus{--tw-border-opacity: 1;border-color:rgb(59 130 246 / var(--tw-border-opacity, 1))}.focus\\:bg-accent:focus{background-color:hsl(var(--accent))}.focus\\:text-accent-foreground:focus{color:hsl(var(--accent-foreground))}.focus\\:outline-none:focus{outline:2px solid transparent;outline-offset:2px}.focus\\:ring-2:focus{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus\\:ring-blue-200:focus{--tw-ring-opacity: 1;--tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1))}.focus\\:ring-ring:focus{--tw-ring-color: hsl(var(--ring))}.focus\\:ring-offset-2:focus{--tw-ring-offset-width: 2px}.focus-visible\\:outline-none:focus-visible{outline:2px solid transparent;outline-offset:2px}.focus-visible\\:outline-2:focus-visible{outline-width:2px}.focus-visible\\:ring-1:focus-visible{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus-visible\\:ring-2:focus-visible{--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow, 0 0 #0000)}.focus-visible\\:ring-ring:focus-visible{--tw-ring-color: hsl(var(--ring))}.focus-visible\\:ring-offset-2:focus-visible{--tw-ring-offset-width: 2px}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:bg-blue-300:disabled{--tw-bg-opacity: 1;background-color:rgb(147 197 253 / var(--tw-bg-opacity, 1))}.disabled\\:bg-gray-100:disabled{--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}.disabled\\:bg-red-300:disabled{--tw-bg-opacity: 1;background-color:rgb(252 165 165 / var(--tw-bg-opacity, 1))}.disabled\\:text-gray-400:disabled{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}.disabled\\:text-white:disabled{--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.disabled\\:opacity-50:disabled{opacity:.5}.disabled\\:shadow-none:disabled{--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.group:hover .group-hover\\:bg-blue-300{--tw-bg-opacity: 1;background-color:rgb(147 197 253 / var(--tw-bg-opacity, 1))}.group:hover .group-hover\\:text-gray-900{--tw-text-opacity: 1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{pointer-events:none}@keyframes drawerSlideRightAndFade{0%{opacity:1;transform:translate(0)}to{opacity:0;transform:translate(100%)}}.data-\\[state\\=closed\\]\\:animate-drawerSlideRightAndFade[data-state=closed]{animation:drawerSlideRightAndFade .15s ease-in}@keyframes hide{0%{opacity:1}to{opacity:0}}.data-\\[state\\=closed\\]\\:animate-hide[data-state=closed]{animation:hide .15s cubic-bezier(.16,1,.3,1)}@keyframes dialogOverlayShow{0%{opacity:0}to{opacity:1}}.data-\\[state\\=open\\]\\:animate-dialogOverlayShow[data-state=open]{animation:dialogOverlayShow .15s cubic-bezier(.16,1,.3,1)}@keyframes drawerSlideLeftAndFade{0%{opacity:0;transform:translate(100%)}to{opacity:1;transform:translate(0)}}.data-\\[state\\=open\\]\\:animate-drawerSlideLeftAndFade[data-state=open]{animation:drawerSlideLeftAndFade .15s cubic-bezier(.16,1,.3,1)}.data-\\[state\\=active\\]\\:border-blue-500[data-state=active]{--tw-border-opacity: 1;border-color:rgb(59 130 246 / var(--tw-border-opacity, 1))}.data-\\[state\\=active\\]\\:bg-background[data-state=active]{background-color:hsl(var(--background))}.data-\\[state\\=active\\]\\:bg-white[data-state=active]{--tw-bg-opacity: 1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}.data-\\[state\\=on\\]\\:bg-accent[data-state=on],.data-\\[state\\=open\\]\\:bg-accent[data-state=open]{background-color:hsl(var(--accent))}.data-\\[disabled\\]\\:text-gray-300[data-disabled]{--tw-text-opacity: 1;color:rgb(209 213 219 / var(--tw-text-opacity, 1))}.data-\\[disabled\\]\\:text-gray-400[data-disabled]{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}.data-\\[state\\=active\\]\\:text-blue-500[data-state=active]{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.data-\\[state\\=active\\]\\:text-foreground[data-state=active]{color:hsl(var(--foreground))}.data-\\[state\\=active\\]\\:text-gray-900[data-state=active]{--tw-text-opacity: 1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}.data-\\[state\\=on\\]\\:text-accent-foreground[data-state=on]{color:hsl(var(--accent-foreground))}.data-\\[state\\=open\\]\\:text-muted-foreground[data-state=open]{color:hsl(var(--muted-foreground))}.data-\\[disabled\\]\\:opacity-50[data-disabled]{opacity:.5}.data-\\[state\\=active\\]\\:shadow[data-state=active]{--tw-shadow: 0 1px 3px 0 rgb(0 0 0 / .1), 0 1px 2px -1px rgb(0 0 0 / .1);--tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.data-\\[state\\=active\\]\\:shadow-sm[data-state=active]{--tw-shadow: 0 1px 2px 0 rgb(0 0 0 / .05);--tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.data-\\[state\\=open\\]\\:animate-in[data-state=open]{animation-name:enter;animation-duration:.15s;--tw-enter-opacity: initial;--tw-enter-scale: initial;--tw-enter-rotate: initial;--tw-enter-translate-x: initial;--tw-enter-translate-y: initial}.data-\\[state\\=closed\\]\\:animate-out[data-state=closed]{animation-name:exit;animation-duration:.15s;--tw-exit-opacity: initial;--tw-exit-scale: initial;--tw-exit-rotate: initial;--tw-exit-translate-x: initial;--tw-exit-translate-y: initial}.data-\\[state\\=closed\\]\\:fade-out-0[data-state=closed]{--tw-exit-opacity: 0}.data-\\[state\\=open\\]\\:fade-in-0[data-state=open]{--tw-enter-opacity: 0}.data-\\[state\\=closed\\]\\:zoom-out-95[data-state=closed]{--tw-exit-scale: .95}.data-\\[state\\=open\\]\\:zoom-in-95[data-state=open]{--tw-enter-scale: .95}.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side=bottom]{--tw-enter-translate-y: -.5rem}.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side=left]{--tw-enter-translate-x: .5rem}.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side=right]{--tw-enter-translate-x: -.5rem}.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side=top]{--tw-enter-translate-y: .5rem}.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state=closed]{--tw-exit-translate-x: -50%}.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state=closed]{--tw-exit-translate-y: -48%}.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state=open]{--tw-enter-translate-x: -50%}.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state=open]{--tw-enter-translate-y: -48%}.dark\\:border-gray-800:is(.dark *){--tw-border-opacity: 1;border-color:rgb(31 41 55 / var(--tw-border-opacity, 1))}.dark\\:border-gray-900:is(.dark *){--tw-border-opacity: 1;border-color:rgb(17 24 39 / var(--tw-border-opacity, 1))}.dark\\:border-red-700:is(.dark *){--tw-border-opacity: 1;border-color:rgb(185 28 28 / var(--tw-border-opacity, 1))}.dark\\:bg-\\[\\#090E1A\\]:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(9 14 26 / var(--tw-bg-opacity, 1))}.dark\\:bg-blue-500:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(59 130 246 / var(--tw-bg-opacity, 1))}.dark\\:bg-blue-900:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(30 58 138 / var(--tw-bg-opacity, 1))}.dark\\:bg-gray-900:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(17 24 39 / var(--tw-bg-opacity, 1))}.dark\\:bg-gray-950:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(3 7 18 / var(--tw-bg-opacity, 1))}.dark\\:bg-red-700:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(185 28 28 / var(--tw-bg-opacity, 1))}.dark\\:fill-gray-200:is(.dark *){fill:#e5e7eb}.dark\\:fill-gray-300:is(.dark *){fill:#d1d5db}.dark\\:fill-gray-500:is(.dark *){fill:#6b7280}.dark\\:stroke-gray-800:is(.dark *){stroke:#1f2937}.dark\\:stroke-gray-950:is(.dark *){stroke:#030712}.dark\\:text-gray-300:is(.dark *){--tw-text-opacity: 1;color:rgb(209 213 219 / var(--tw-text-opacity, 1))}.dark\\:text-gray-400:is(.dark *){--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}.dark\\:text-gray-50:is(.dark *){--tw-text-opacity: 1;color:rgb(249 250 251 / var(--tw-text-opacity, 1))}.dark\\:text-gray-500:is(.dark *){--tw-text-opacity: 1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}.dark\\:text-gray-600:is(.dark *){--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.dark\\:text-white:is(.dark *){--tw-text-opacity: 1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}.dark\\:outline-blue-500:is(.dark *){outline-color:#3b82f6}.dark\\:ring-red-700\\/30:is(.dark *){--tw-ring-color: rgb(185 28 28 / .3)}.hover\\:dark\\:border-gray-400:is(.dark *):hover{--tw-border-opacity: 1;border-color:rgb(156 163 175 / var(--tw-border-opacity, 1))}.dark\\:hover\\:bg-blue-600:hover:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(37 99 235 / var(--tw-bg-opacity, 1))}.dark\\:hover\\:bg-gray-800:hover:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(31 41 55 / var(--tw-bg-opacity, 1))}.dark\\:hover\\:bg-gray-800\\/80:hover:is(.dark *){background-color:#1f2937cc}.dark\\:hover\\:bg-gray-900\\/60:hover:is(.dark *){background-color:#11182799}.dark\\:hover\\:bg-red-600:hover:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(220 38 38 / var(--tw-bg-opacity, 1))}.hover\\:dark\\:bg-gray-400\\/10:is(.dark *):hover{background-color:#9ca3af1a}.hover\\:dark\\:bg-gray-900:is(.dark *):hover{--tw-bg-opacity: 1;background-color:rgb(17 24 39 / var(--tw-bg-opacity, 1))}.dark\\:hover\\:text-gray-50:hover:is(.dark *){--tw-text-opacity: 1;color:rgb(249 250 251 / var(--tw-text-opacity, 1))}.hover\\:dark\\:text-gray-200:is(.dark *):hover{--tw-text-opacity: 1;color:rgb(229 231 235 / var(--tw-text-opacity, 1))}.hover\\:dark\\:text-gray-400:is(.dark *):hover{--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}.focus\\:dark\\:border-blue-700:is(.dark *):focus{--tw-border-opacity: 1;border-color:rgb(29 78 216 / var(--tw-border-opacity, 1))}.focus\\:dark\\:ring-blue-700\\/30:is(.dark *):focus{--tw-ring-color: rgb(29 78 216 / .3)}.disabled\\:dark\\:bg-blue-800:is(.dark *):disabled{--tw-bg-opacity: 1;background-color:rgb(30 64 175 / var(--tw-bg-opacity, 1))}.disabled\\:dark\\:bg-gray-800:is(.dark *):disabled{--tw-bg-opacity: 1;background-color:rgb(31 41 55 / var(--tw-bg-opacity, 1))}.disabled\\:dark\\:bg-red-950:is(.dark *):disabled{--tw-bg-opacity: 1;background-color:rgb(69 10 10 / var(--tw-bg-opacity, 1))}.disabled\\:dark\\:text-blue-400:is(.dark *):disabled{--tw-text-opacity: 1;color:rgb(96 165 250 / var(--tw-text-opacity, 1))}.disabled\\:dark\\:text-gray-600:is(.dark *):disabled{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.disabled\\:dark\\:text-red-400:is(.dark *):disabled{--tw-text-opacity: 1;color:rgb(248 113 113 / var(--tw-text-opacity, 1))}.group:hover .group-hover\\:dark\\:bg-blue-800:is(.dark *){--tw-bg-opacity: 1;background-color:rgb(30 64 175 / var(--tw-bg-opacity, 1))}.group:hover .dark\\:group-hover\\:text-gray-50:is(.dark *){--tw-text-opacity: 1;color:rgb(249 250 251 / var(--tw-text-opacity, 1))}.data-\\[state\\=active\\]\\:dark\\:border-blue-500:is(.dark *)[data-state=active]{--tw-border-opacity: 1;border-color:rgb(59 130 246 / var(--tw-border-opacity, 1))}.data-\\[state\\=active\\]\\:dark\\:bg-gray-950:is(.dark *)[data-state=active]{--tw-bg-opacity: 1;background-color:rgb(3 7 18 / var(--tw-bg-opacity, 1))}.data-\\[disabled\\]\\:dark\\:text-gray-600:is(.dark *)[data-disabled]{--tw-text-opacity: 1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}.data-\\[disabled\\]\\:dark\\:text-gray-700:is(.dark *)[data-disabled]{--tw-text-opacity: 1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}.data-\\[state\\=active\\]\\:dark\\:text-blue-500:is(.dark *)[data-state=active]{--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity, 1))}.data-\\[state\\=active\\]\\:dark\\:text-gray-50:is(.dark *)[data-state=active]{--tw-text-opacity: 1;color:rgb(249 250 251 / var(--tw-text-opacity, 1))}@media not all and (min-width: 640px){.max-sm\\:inset-x-2{left:.5rem;right:.5rem}}@media (min-width: 640px){.sm\\:inset-y-2{top:.5rem;bottom:.5rem}.sm\\:right-2{right:.5rem}.sm\\:max-w-lg{max-width:32rem}.sm\\:flex-row{flex-direction:row}.sm\\:justify-end{justify-content:flex-end}.sm\\:space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse: 0;margin-right:calc(.5rem * var(--tw-space-x-reverse));margin-left:calc(.5rem * calc(1 - var(--tw-space-x-reverse)))}.sm\\:rounded-lg{border-radius:var(--radius)}.sm\\:rounded-none{border-radius:0}.sm\\:p-6{padding:1.5rem}.sm\\:text-left{text-align:left}}@media (min-width: 768px){.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (min-width: 1024px){.lg\\:w-3\\/4{width:75%}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}}@media (min-width: 1280px){.xl\\:grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar{display:none}.\\[\\&\\>svg\\]\\:size-4>svg{width:1rem;height:1rem}.\\[\\&\\>svg\\]\\:shrink-0>svg{flex-shrink:0}.\\[\\&_\\.recharts-pie-sector\\]\\:outline-none .recharts-pie-sector{outline:2px solid transparent;outline-offset:2px}.\\[\\&_svg\\]\\:pointer-events-none svg{pointer-events:none}.\\[\\&_svg\\]\\:size-4 svg{width:1rem;height:1rem}.\\[\\&_svg\\]\\:shrink-0 svg{flex-shrink:0}._markdownContainer_lrcxp_1{display:flex;flex-direction:column;gap:1rem}button[data-paste-element=BUTTON][data-paste-override=ghost-button]{box-shadow:none}button[data-paste-element=BUTTON][data-paste-override=ghost-button]:hover{color:unset;background-color:#f5f5f5}button[data-paste-element=BUTTON][data-paste-override=ghost-button]:active{background-color:#eee}._emptyStateContainerHorizontal_5t59e_1{align-items:center;display:flex;gap:1.5rem;justify-content:center}._emptyStateContainerVertical_5t59e_8{align-items:center;display:flex;flex-direction:column;gap:1rem;justify-content:center}._emptyStateImageContainer_5t59e_16{align-items:center;display:flex;height:18rem}._emptyStateImage_5t59e_16{width:100%}._emptyStateRenderContainer_5t59e_26{margin-top:1.5rem}@media only screen and (max-width: 600px){._emptyStateContainerHorizontal_5t59e_1{align-items:center;flex-direction:column;gap:1rem;justify-content:center}}._imageContainer_bh8rp_1{min-height:200px;min-width:200px;position:relative;display:flex;align-items:center;justify-content:center}._image_bh8rp_1{height:auto;max-width:100%;border-radius:12px;cursor:pointer}._imageBlur_bh8rp_17{transition:filter .3s ease;filter:blur(4px)}._imageWrap_bh8rp_22{position:relative;display:inline-block;overflow:hidden;border-radius:8px}._imageDownloadButton_bh8rp_29{position:absolute;bottom:10px;right:10px;padding:8px}._tiptap_bi719_2{height:100%;font-family:system-ui,sans-serif;line-height:1.6;font-size:1rem;color:#333;max-width:100%;word-wrap:break-word}._tiptap_bi719_2 :first-child{margin-top:0}._tiptap_bi719_2 h1{font-size:2rem;font-weight:700;margin:1rem 0}._tiptap_bi719_2 h2{font-size:1.75rem;font-weight:700;margin:1rem 0}._tiptap_bi719_2 h3{font-size:1.5rem;font-weight:700;margin:.75rem 0}._tiptap_bi719_2 h4{font-size:1.25rem;font-weight:700;margin:.5rem 0}._tiptap_bi719_2 h5,._tiptap_bi719_2 h6{font-size:1rem;font-weight:700;margin:.5rem 0}._tiptap_bi719_2 p{margin:.5rem 0}._tiptap_bi719_2 strong{font-weight:700}._tiptap_bi719_2 em{font-style:italic}._tiptap_bi719_2 blockquote{border-left:4px solid #f5f5f5;padding:.5rem 1rem;margin:1rem 0;color:#666;font-style:italic}._tiptap_bi719_2 ul{list-style-type:disc;padding-left:1.5rem}._tiptap_bi719_2 ol{list-style-type:decimal;padding-left:1.5rem}._tiptap_bi719_2 li{margin:.25rem 0}._tiptap_bi719_2 pre{background:#f5f5f5;padding:1rem;border-radius:4px;overflow-x:auto}._tiptap_bi719_2 code{background:#f5f5f5;padding:.2rem .4rem;border-radius:3px;font-family:monospace}._tiptap_bi719_2 hr{border:none;height:1px;background-color:#ddd;margin:1rem 0}._tiptap_bi719_2 a{color:#007bff;text-decoration:none}._tiptap_bi719_2 a:hover{text-decoration:underline}._tiptap_bi719_2 table{width:100%;border-collapse:collapse;margin:1rem 0}._tiptap_bi719_2 th,._tiptap_bi719_2 td{border:1px solid #ddd;padding:.5rem;text-align:left}._tiptap_bi719_2 th{background-color:#f5f5f5;font-weight:700}._tiptap_bi719_2 img{max-width:100%;height:auto;display:block;margin:1rem 0}._tiptap_bi719_2 br{display:block;margin:.5rem 0}.input-container{position:relative}.scroll-to-bottom-button{position:absolute;left:50%;transform:translate(-50%,-100%);padding-bottom:20px}.react-flow{direction:ltr;--xy-edge-stroke-default: #b1b1b7;--xy-edge-stroke-width-default: 1;--xy-edge-stroke-selected-default: #555;--xy-connectionline-stroke-default: #b1b1b7;--xy-connectionline-stroke-width-default: 1;--xy-attribution-background-color-default: rgba(255, 255, 255, .5);--xy-minimap-background-color-default: #fff;--xy-minimap-mask-background-color-default: rgb(240, 240, 240, .6);--xy-minimap-mask-stroke-color-default: transparent;--xy-minimap-mask-stroke-width-default: 1;--xy-minimap-node-background-color-default: #e2e2e2;--xy-minimap-node-stroke-color-default: transparent;--xy-minimap-node-stroke-width-default: 2;--xy-background-color-default: transparent;--xy-background-pattern-dots-color-default: #91919a;--xy-background-pattern-lines-color-default: #eee;--xy-background-pattern-cross-color-default: #e2e2e2;background-color:var(--xy-background-color, var(--xy-background-color-default));--xy-node-color-default: inherit;--xy-node-border-default: 1px solid #1a192b;--xy-node-background-color-default: #fff;--xy-node-group-background-color-default: rgba(240, 240, 240, .25);--xy-node-boxshadow-hover-default: 0 1px 4px 1px rgba(0, 0, 0, .08);--xy-node-boxshadow-selected-default: 0 0 0 .5px #1a192b;--xy-node-border-radius-default: 3px;--xy-handle-background-color-default: #1a192b;--xy-handle-border-color-default: #fff;--xy-selection-background-color-default: rgba(0, 89, 220, .08);--xy-selection-border-default: 1px dotted rgba(0, 89, 220, .8);--xy-controls-button-background-color-default: #fefefe;--xy-controls-button-background-color-hover-default: #f4f4f4;--xy-controls-button-color-default: inherit;--xy-controls-button-color-hover-default: inherit;--xy-controls-button-border-color-default: #eee;--xy-controls-box-shadow-default: 0 0 2px 1px rgba(0, 0, 0, .08);--xy-edge-label-background-color-default: #ffffff;--xy-edge-label-color-default: inherit;--xy-resize-background-color-default: #3367d9}.react-flow.dark{--xy-edge-stroke-default: #3e3e3e;--xy-edge-stroke-width-default: 1;--xy-edge-stroke-selected-default: #727272;--xy-connectionline-stroke-default: #b1b1b7;--xy-connectionline-stroke-width-default: 1;--xy-attribution-background-color-default: rgba(150, 150, 150, .25);--xy-minimap-background-color-default: #141414;--xy-minimap-mask-background-color-default: rgb(60, 60, 60, .6);--xy-minimap-mask-stroke-color-default: transparent;--xy-minimap-mask-stroke-width-default: 1;--xy-minimap-node-background-color-default: #2b2b2b;--xy-minimap-node-stroke-color-default: transparent;--xy-minimap-node-stroke-width-default: 2;--xy-background-color-default: #141414;--xy-background-pattern-dots-color-default: #777;--xy-background-pattern-lines-color-default: #777;--xy-background-pattern-cross-color-default: #777;--xy-node-color-default: #f8f8f8;--xy-node-border-default: 1px solid #3c3c3c;--xy-node-background-color-default: #1e1e1e;--xy-node-group-background-color-default: rgba(240, 240, 240, .25);--xy-node-boxshadow-hover-default: 0 1px 4px 1px rgba(255, 255, 255, .08);--xy-node-boxshadow-selected-default: 0 0 0 .5px #999;--xy-handle-background-color-default: #bebebe;--xy-handle-border-color-default: #1e1e1e;--xy-selection-background-color-default: rgba(200, 200, 220, .08);--xy-selection-border-default: 1px dotted rgba(200, 200, 220, .8);--xy-controls-button-background-color-default: #2b2b2b;--xy-controls-button-background-color-hover-default: #3e3e3e;--xy-controls-button-color-default: #f8f8f8;--xy-controls-button-color-hover-default: #fff;--xy-controls-button-border-color-default: #5b5b5b;--xy-controls-box-shadow-default: 0 0 2px 1px rgba(0, 0, 0, .08);--xy-edge-label-background-color-default: #141414;--xy-edge-label-color-default: #f8f8f8}.react-flow__background{background-color:var(--xy-background-color, var(--xy-background-color-props, var(--xy-background-color-default)));pointer-events:none;z-index:-1}.react-flow__container{position:absolute;width:100%;height:100%;top:0;left:0}.react-flow__pane{z-index:1}.react-flow__pane.draggable{cursor:grab}.react-flow__pane.dragging{cursor:grabbing}.react-flow__pane.selection{cursor:pointer}.react-flow__viewport{transform-origin:0 0;z-index:2;pointer-events:none}.react-flow__renderer{z-index:4}.react-flow__selection{z-index:6}.react-flow__nodesselection-rect:focus,.react-flow__nodesselection-rect:focus-visible{outline:none}.react-flow__edge-path{stroke:var(--xy-edge-stroke, var(--xy-edge-stroke-default));stroke-width:var(--xy-edge-stroke-width, var(--xy-edge-stroke-width-default));fill:none}.react-flow__connection-path{stroke:var(--xy-connectionline-stroke, var(--xy-connectionline-stroke-default));stroke-width:var(--xy-connectionline-stroke-width, var(--xy-connectionline-stroke-width-default));fill:none}.react-flow .react-flow__edges{position:absolute}.react-flow .react-flow__edges svg{overflow:visible;position:absolute;pointer-events:none}.react-flow__edge{pointer-events:visibleStroke}.react-flow__edge.selectable{cursor:pointer}.react-flow__edge.animated path{stroke-dasharray:5;animation:dashdraw .5s linear infinite}.react-flow__edge.animated path.react-flow__edge-interaction{stroke-dasharray:none;animation:none}.react-flow__edge.inactive{pointer-events:none}.react-flow__edge.selected,.react-flow__edge:focus,.react-flow__edge:focus-visible{outline:none}.react-flow__edge.selected .react-flow__edge-path,.react-flow__edge.selectable:focus .react-flow__edge-path,.react-flow__edge.selectable:focus-visible .react-flow__edge-path{stroke:var(--xy-edge-stroke-selected, var(--xy-edge-stroke-selected-default))}.react-flow__edge-textwrapper{pointer-events:all}.react-flow__edge .react-flow__edge-text{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.react-flow__connection{pointer-events:none}.react-flow__connection .animated{stroke-dasharray:5;animation:dashdraw .5s linear infinite}svg.react-flow__connectionline{z-index:1001;overflow:visible;position:absolute}.react-flow__nodes{pointer-events:none;transform-origin:0 0}.react-flow__node{position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none;pointer-events:all;transform-origin:0 0;box-sizing:border-box;cursor:default}.react-flow__node.selectable{cursor:pointer}.react-flow__node.draggable{cursor:grab;pointer-events:all}.react-flow__node.draggable.dragging{cursor:grabbing}.react-flow__nodesselection{z-index:3;transform-origin:left top;pointer-events:none}.react-flow__nodesselection-rect{position:absolute;pointer-events:all;cursor:grab}.react-flow__handle{position:absolute;pointer-events:none;min-width:5px;min-height:5px;width:6px;height:6px;background-color:var(--xy-handle-background-color, var(--xy-handle-background-color-default));border:1px solid var(--xy-handle-border-color, var(--xy-handle-border-color-default));border-radius:100%}.react-flow__handle.connectingfrom{pointer-events:all}.react-flow__handle.connectionindicator{pointer-events:all;cursor:crosshair}.react-flow__handle-bottom{top:auto;left:50%;bottom:0;transform:translate(-50%,50%)}.react-flow__handle-top{top:0;left:50%;transform:translate(-50%,-50%)}.react-flow__handle-left{top:50%;left:0;transform:translate(-50%,-50%)}.react-flow__handle-right{top:50%;right:0;transform:translate(50%,-50%)}.react-flow__edgeupdater{cursor:move;pointer-events:all}.react-flow__panel{position:absolute;z-index:5;margin:15px}.react-flow__panel.top{top:0}.react-flow__panel.bottom{bottom:0}.react-flow__panel.left{left:0}.react-flow__panel.right{right:0}.react-flow__panel.center{left:50%;transform:translate(-50%)}.react-flow__attribution{font-size:10px;background:var(--xy-attribution-background-color, var(--xy-attribution-background-color-default));padding:2px 3px;margin:0}.react-flow__attribution a{text-decoration:none;color:#999}@keyframes dashdraw{0%{stroke-dashoffset:10}}.react-flow__edgelabel-renderer{position:absolute;width:100%;height:100%;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;left:0;top:0}.react-flow__viewport-portal{position:absolute;width:100%;height:100%;left:0;top:0;-webkit-user-select:none;-moz-user-select:none;user-select:none}.react-flow__minimap{background:var( --xy-minimap-background-color-props, var(--xy-minimap-background-color, var(--xy-minimap-background-color-default)) )}.react-flow__minimap-svg{display:block}.react-flow__minimap-mask{fill:var( --xy-minimap-mask-background-color-props, var(--xy-minimap-mask-background-color, var(--xy-minimap-mask-background-color-default)) );stroke:var( --xy-minimap-mask-stroke-color-props, var(--xy-minimap-mask-stroke-color, var(--xy-minimap-mask-stroke-color-default)) );stroke-width:var( --xy-minimap-mask-stroke-width-props, var(--xy-minimap-mask-stroke-width, var(--xy-minimap-mask-stroke-width-default)) )}.react-flow__minimap-node{fill:var( --xy-minimap-node-background-color-props, var(--xy-minimap-node-background-color, var(--xy-minimap-node-background-color-default)) );stroke:var( --xy-minimap-node-stroke-color-props, var(--xy-minimap-node-stroke-color, var(--xy-minimap-node-stroke-color-default)) );stroke-width:var( --xy-minimap-node-stroke-width-props, var(--xy-minimap-node-stroke-width, var(--xy-minimap-node-stroke-width-default)) )}.react-flow__background-pattern.dots{fill:var( --xy-background-pattern-color-props, var(--xy-background-pattern-color, var(--xy-background-pattern-dots-color-default)) )}.react-flow__background-pattern.lines{stroke:var( --xy-background-pattern-color-props, var(--xy-background-pattern-color, var(--xy-background-pattern-lines-color-default)) )}.react-flow__background-pattern.cross{stroke:var( --xy-background-pattern-color-props, var(--xy-background-pattern-color, var(--xy-background-pattern-cross-color-default)) )}.react-flow__controls{display:flex;flex-direction:column;box-shadow:var(--xy-controls-box-shadow, var(--xy-controls-box-shadow-default))}.react-flow__controls.horizontal{flex-direction:row}.react-flow__controls-button{display:flex;justify-content:center;align-items:center;height:26px;width:26px;padding:4px;border:none;background:var(--xy-controls-button-background-color, var(--xy-controls-button-background-color-default));border-bottom:1px solid var( --xy-controls-button-border-color-props, var(--xy-controls-button-border-color, var(--xy-controls-button-border-color-default)) );color:var( --xy-controls-button-color-props, var(--xy-controls-button-color, var(--xy-controls-button-color-default)) );cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.react-flow__controls-button svg{width:100%;max-width:12px;max-height:12px;fill:currentColor}.react-flow__edge.updating .react-flow__edge-path{stroke:#777}.react-flow__edge-text{font-size:10px}.react-flow__node.selectable:focus,.react-flow__node.selectable:focus-visible{outline:none}.react-flow__node-input,.react-flow__node-default,.react-flow__node-output,.react-flow__node-group{padding:10px;border-radius:var(--xy-node-border-radius, var(--xy-node-border-radius-default));width:150px;font-size:12px;color:var(--xy-node-color, var(--xy-node-color-default));text-align:center;border:var(--xy-node-border, var(--xy-node-border-default));background-color:var(--xy-node-background-color, var(--xy-node-background-color-default))}.react-flow__node-input.selectable:hover,.react-flow__node-default.selectable:hover,.react-flow__node-output.selectable:hover,.react-flow__node-group.selectable:hover{box-shadow:var(--xy-node-boxshadow-hover, var(--xy-node-boxshadow-hover-default))}.react-flow__node-input.selectable.selected,.react-flow__node-input.selectable:focus,.react-flow__node-input.selectable:focus-visible,.react-flow__node-default.selectable.selected,.react-flow__node-default.selectable:focus,.react-flow__node-default.selectable:focus-visible,.react-flow__node-output.selectable.selected,.react-flow__node-output.selectable:focus,.react-flow__node-output.selectable:focus-visible,.react-flow__node-group.selectable.selected,.react-flow__node-group.selectable:focus,.react-flow__node-group.selectable:focus-visible{box-shadow:var(--xy-node-boxshadow-selected, var(--xy-node-boxshadow-selected-default))}.react-flow__node-group{background-color:var(--xy-node-group-background-color, var(--xy-node-group-background-color-default))}.react-flow__nodesselection-rect,.react-flow__selection{background:var(--xy-selection-background-color, var(--xy-selection-background-color-default));border:var(--xy-selection-border, var(--xy-selection-border-default))}.react-flow__nodesselection-rect:focus,.react-flow__nodesselection-rect:focus-visible,.react-flow__selection:focus,.react-flow__selection:focus-visible{outline:none}.react-flow__controls-button:hover{background:var( --xy-controls-button-background-color-hover-props, var(--xy-controls-button-background-color-hover, var(--xy-controls-button-background-color-hover-default)) );color:var( --xy-controls-button-color-hover-props, var(--xy-controls-button-color-hover, var(--xy-controls-button-color-hover-default)) )}.react-flow__controls-button:disabled{pointer-events:none}.react-flow__controls-button:disabled svg{fill-opacity:.4}.react-flow__controls-button:last-child{border-bottom:none}.react-flow__resize-control{position:absolute}.react-flow__resize-control.left,.react-flow__resize-control.right{cursor:ew-resize}.react-flow__resize-control.top,.react-flow__resize-control.bottom{cursor:ns-resize}.react-flow__resize-control.top.left,.react-flow__resize-control.bottom.right{cursor:nwse-resize}.react-flow__resize-control.bottom.left,.react-flow__resize-control.top.right{cursor:nesw-resize}.react-flow__resize-control.handle{width:4px;height:4px;border:1px solid #fff;border-radius:1px;background-color:var(--xy-resize-background-color, var(--xy-resize-background-color-default));transform:translate(-50%,-50%)}.react-flow__resize-control.handle.left{left:0;top:50%}.react-flow__resize-control.handle.right{left:100%;top:50%}.react-flow__resize-control.handle.top{left:50%;top:0}.react-flow__resize-control.handle.bottom{left:50%;top:100%}.react-flow__resize-control.handle.top.left,.react-flow__resize-control.handle.bottom.left{left:0}.react-flow__resize-control.handle.top.right,.react-flow__resize-control.handle.bottom.right{left:100%}.react-flow__resize-control.line{border-color:var(--xy-resize-background-color, var(--xy-resize-background-color-default));border-width:0;border-style:solid}.react-flow__resize-control.line.left,.react-flow__resize-control.line.right{width:1px;transform:translate(-50%);top:0;height:100%}.react-flow__resize-control.line.left{left:0;border-left-width:1px}.react-flow__resize-control.line.right{left:100%;border-right-width:1px}.react-flow__resize-control.line.top,.react-flow__resize-control.line.bottom{height:1px;transform:translateY(-50%);left:0;width:100%}.react-flow__resize-control.line.top{top:0;border-top-width:1px}.react-flow__resize-control.line.bottom{border-bottom-width:1px;top:100%}.react-flow__edge-textbg{fill:var(--xy-edge-label-background-color, var(--xy-edge-label-background-color-default))}.react-flow__edge-text{fill:var(--xy-edge-label-color, var(--xy-edge-label-color-default))}`)),document.head.appendChild(t)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
var e5t = Object.defineProperty;
var t5t = (t, e, r) => e in t ? e5t(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Za = (t, e, r) => t5t(t, typeof e != "symbol" ? e + "" : e, r);
import * as P from "react";
import Te, { useCallback as sr, useDebugValue as Mv, useMemo as fa, useState as Yt, useEffect as Ut, useRef as Zt, useLayoutEffect as qh, useContext as Qn, forwardRef as Ml, createContext as Bo, memo as Ls, useReducer as AI, createElement as Ds, cloneElement as xl, Component as QF, PureComponent as g0, useId as s1e, useInsertionEffect as VGe, Children as Pv, isValidElement as ef, Fragment as qGe, useImperativeHandle as KGe, createRef as r5t } from "react";
import { Box as _r, Heading as Am, ListItem as n5t, UnorderedList as a5t, OrderedList as i5t, Anchor as ZGe, InlineCode as o5t, Paragraph as JGe, Spinner as YGe, Alert as XGe, Truncate as QGe, Separator as eWe, Button as as, Tooltip as al, Card as tWe, Stack as s5t, SkeletonLoader as i7, Text as kb, AIChatMessage as ez, AIChatMessageAuthor as tz, useToaster as l5t, Toaster as c5t, TextArea as u5t, Label as z$, Select as d5t, Option as f5t, CodeBlock as O7, Badge as h5t, CheckboxGroup as p5t, Checkbox as m5t, FormControl as sle, Input as g5t, DatePicker as c5e, HelpText as v5t, Flex as y5t, Pagination as b5t, PaginationItems as x5t, PaginationArrow as u5e, DataGridBody as C5t, DataGridRow as w5t, DataGridCell as S5t } from "@twilio-paste/core";
import * as rWe from "react-dom";
import nWe, { unstable_batchedUpdates as _5t, flushSync as d5e, createPortal as aWe } from "react-dom";
import { $getRoot as k5t, useLexicalComposerContext as A5t, KEY_ENTER_COMMAND as T5t, COMMAND_PRIORITY_HIGH as E5t, CLEAR_EDITOR_COMMAND as I5t, ClearEditorPlugin as M5t } from "@twilio-paste/core/lexical-library";
import { LexicalComposer as P5t, AutoLinkNode as R5t, RichTextPlugin as O5t, ErrorBoundary as B5t, ContentEditable as N5t, OnChangePlugin as $5t, HistoryPlugin as D5t, EditorRefPlugin as L5t, $getRoot as j5t, $createParagraphNode as F5t, $createTextNode as z5t, AutoLinkPlugin as G5t, useLexicalComposerContext as W5t } from "@twilio-paste/lexical-library";
import { useNavigate as W5, Link as iWe, useParams as eu, Outlet as H5t, useSearchParams as U5t } from "react-router-dom";
var wl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gi(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function aa(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
function V5t(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var oWe = { exports: {} }, dl = oWe.exports = {}, G2, W2;
function lle() {
  throw new Error("setTimeout has not been defined");
}
function cle() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? G2 = setTimeout : G2 = lle;
  } catch {
    G2 = lle;
  }
  try {
    typeof clearTimeout == "function" ? W2 = clearTimeout : W2 = cle;
  } catch {
    W2 = cle;
  }
})();
function sWe(t) {
  if (G2 === setTimeout)
    return setTimeout(t, 0);
  if ((G2 === lle || !G2) && setTimeout)
    return G2 = setTimeout, setTimeout(t, 0);
  try {
    return G2(t, 0);
  } catch {
    try {
      return G2.call(null, t, 0);
    } catch {
      return G2.call(this, t, 0);
    }
  }
}
function q5t(t) {
  if (W2 === clearTimeout)
    return clearTimeout(t);
  if ((W2 === cle || !W2) && clearTimeout)
    return W2 = clearTimeout, clearTimeout(t);
  try {
    return W2(t);
  } catch {
    try {
      return W2.call(null, t);
    } catch {
      return W2.call(this, t);
    }
  }
}
var gm = [], o7 = !1, cb, NN = -1;
function K5t() {
  !o7 || !cb || (o7 = !1, cb.length ? gm = cb.concat(gm) : NN = -1, gm.length && lWe());
}
function lWe() {
  if (!o7) {
    var t = sWe(K5t);
    o7 = !0;
    for (var e = gm.length; e; ) {
      for (cb = gm, gm = []; ++NN < e; )
        cb && cb[NN].run();
      NN = -1, e = gm.length;
    }
    cb = null, o7 = !1, q5t(t);
  }
}
dl.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  gm.push(new cWe(t, e)), gm.length === 1 && !o7 && sWe(lWe);
};
function cWe(t, e) {
  this.fun = t, this.array = e;
}
cWe.prototype.run = function() {
  this.fun.apply(null, this.array);
};
dl.title = "browser";
dl.browser = !0;
dl.env = {};
dl.argv = [];
dl.version = "";
dl.versions = {};
function ig() {
}
dl.on = ig;
dl.addListener = ig;
dl.once = ig;
dl.off = ig;
dl.removeListener = ig;
dl.removeAllListeners = ig;
dl.emit = ig;
dl.prependListener = ig;
dl.prependOnceListener = ig;
dl.listeners = function(t) {
  return [];
};
dl.binding = function(t) {
  throw new Error("process.binding is not supported");
};
dl.cwd = function() {
  return "/";
};
dl.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
dl.umask = function() {
  return 0;
};
var Z5t = oWe.exports;
const Ar = /* @__PURE__ */ V5t(Z5t);
var jO = { exports: {} }, jw = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f5e;
function J5t() {
  if (f5e) return jw;
  f5e = 1;
  var t = Te, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, c) {
    var u, f = {}, h = null, p = null;
    c !== void 0 && (h = "" + c), l.key !== void 0 && (h = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) n.call(l, u) && !i.hasOwnProperty(u) && (f[u] = l[u]);
    if (s && s.defaultProps) for (u in l = s.defaultProps, l) f[u] === void 0 && (f[u] = l[u]);
    return { $$typeof: e, type: s, key: h, ref: p, props: f, _owner: a.current };
  }
  return jw.Fragment = r, jw.jsx = o, jw.jsxs = o, jw;
}
var Fw = {}, h5e;
function Y5t() {
  return h5e || (h5e = 1, Ar.env.NODE_ENV !== "production" && function() {
    var t = Te, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, y = "@@iterator";
    function b(at) {
      if (at === null || typeof at != "object")
        return null;
      var Vt = g && at[g] || at[y];
      return typeof Vt == "function" ? Vt : null;
    }
    var w = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(at) {
      {
        for (var Vt = arguments.length, er = new Array(Vt > 1 ? Vt - 1 : 0), fr = 1; fr < Vt; fr++)
          er[fr - 1] = arguments[fr];
        C("error", at, er);
      }
    }
    function C(at, Vt, er) {
      {
        var fr = w.ReactDebugCurrentFrame, tn = fr.getStackAddendum();
        tn !== "" && (Vt += "%s", er = er.concat([tn]));
        var Kn = er.map(function(Pr) {
          return String(Pr);
        });
        Kn.unshift("Warning: " + Vt), Function.prototype.apply.call(console[at], console, Kn);
      }
    }
    var x = !1, S = !1, A = !1, I = !1, M = !1, B;
    B = Symbol.for("react.module.reference");
    function L(at) {
      return !!(typeof at == "string" || typeof at == "function" || at === n || at === i || M || at === a || at === c || at === u || I || at === p || x || S || A || typeof at == "object" && at !== null && (at.$$typeof === h || at.$$typeof === f || at.$$typeof === o || at.$$typeof === s || at.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      at.$$typeof === B || at.getModuleId !== void 0));
    }
    function N(at, Vt, er) {
      var fr = at.displayName;
      if (fr)
        return fr;
      var tn = Vt.displayName || Vt.name || "";
      return tn !== "" ? er + "(" + tn + ")" : er;
    }
    function d(at) {
      return at.displayName || "Context";
    }
    function m(at) {
      if (at == null)
        return null;
      if (typeof at.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof at == "function")
        return at.displayName || at.name || null;
      if (typeof at == "string")
        return at;
      switch (at) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof at == "object")
        switch (at.$$typeof) {
          case s:
            var Vt = at;
            return d(Vt) + ".Consumer";
          case o:
            var er = at;
            return d(er._context) + ".Provider";
          case l:
            return N(at, at.render, "ForwardRef");
          case f:
            var fr = at.displayName || null;
            return fr !== null ? fr : m(at.type) || "Memo";
          case h: {
            var tn = at, Kn = tn._payload, Pr = tn._init;
            try {
              return m(Pr(Kn));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v = Object.assign, k = 0, O, G, H, j, F, z, W;
    function U() {
    }
    U.__reactDisabledLog = !0;
    function Z() {
      {
        if (k === 0) {
          O = console.log, G = console.info, H = console.warn, j = console.error, F = console.group, z = console.groupCollapsed, W = console.groupEnd;
          var at = {
            configurable: !0,
            enumerable: !0,
            value: U,
            writable: !0
          };
          Object.defineProperties(console, {
            info: at,
            log: at,
            warn: at,
            error: at,
            group: at,
            groupCollapsed: at,
            groupEnd: at
          });
        }
        k++;
      }
    }
    function V() {
      {
        if (k--, k === 0) {
          var at = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: v({}, at, {
              value: O
            }),
            info: v({}, at, {
              value: G
            }),
            warn: v({}, at, {
              value: H
            }),
            error: v({}, at, {
              value: j
            }),
            group: v({}, at, {
              value: F
            }),
            groupCollapsed: v({}, at, {
              value: z
            }),
            groupEnd: v({}, at, {
              value: W
            })
          });
        }
        k < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Y = w.ReactCurrentDispatcher, ge;
    function ce(at, Vt, er) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (tn) {
            var fr = tn.stack.trim().match(/\n( *(at )?)/);
            ge = fr && fr[1] || "";
          }
        return `
` + ge + at;
      }
    }
    var ee = !1, Se;
    {
      var Ce = typeof WeakMap == "function" ? WeakMap : Map;
      Se = new Ce();
    }
    function we(at, Vt) {
      if (!at || ee)
        return "";
      {
        var er = Se.get(at);
        if (er !== void 0)
          return er;
      }
      var fr;
      ee = !0;
      var tn = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Kn;
      Kn = Y.current, Y.current = null, Z();
      try {
        if (Vt) {
          var Pr = function() {
            throw Error();
          };
          if (Object.defineProperty(Pr.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Pr, []);
            } catch (Da) {
              fr = Da;
            }
            Reflect.construct(at, [], Pr);
          } else {
            try {
              Pr.call();
            } catch (Da) {
              fr = Da;
            }
            at.call(Pr.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Da) {
            fr = Da;
          }
          at();
        }
      } catch (Da) {
        if (Da && fr && typeof Da.stack == "string") {
          for (var Pt = Da.stack.split(`
`), or = fr.stack.split(`
`), Ht = Pt.length - 1, Mt = or.length - 1; Ht >= 1 && Mt >= 0 && Pt[Ht] !== or[Mt]; )
            Mt--;
          for (; Ht >= 1 && Mt >= 0; Ht--, Mt--)
            if (Pt[Ht] !== or[Mt]) {
              if (Ht !== 1 || Mt !== 1)
                do
                  if (Ht--, Mt--, Mt < 0 || Pt[Ht] !== or[Mt]) {
                    var Qt = `
` + Pt[Ht].replace(" at new ", " at ");
                    return at.displayName && Qt.includes("<anonymous>") && (Qt = Qt.replace("<anonymous>", at.displayName)), typeof at == "function" && Se.set(at, Qt), Qt;
                  }
                while (Ht >= 1 && Mt >= 0);
              break;
            }
        }
      } finally {
        ee = !1, Y.current = Kn, V(), Error.prepareStackTrace = tn;
      }
      var pn = at ? at.displayName || at.name : "", Kr = pn ? ce(pn) : "";
      return typeof at == "function" && Se.set(at, Kr), Kr;
    }
    function We(at, Vt, er) {
      return we(at, !1);
    }
    function Fe(at) {
      var Vt = at.prototype;
      return !!(Vt && Vt.isReactComponent);
    }
    function it(at, Vt, er) {
      if (at == null)
        return "";
      if (typeof at == "function")
        return we(at, Fe(at));
      if (typeof at == "string")
        return ce(at);
      switch (at) {
        case c:
          return ce("Suspense");
        case u:
          return ce("SuspenseList");
      }
      if (typeof at == "object")
        switch (at.$$typeof) {
          case l:
            return We(at.render);
          case f:
            return it(at.type, Vt, er);
          case h: {
            var fr = at, tn = fr._payload, Kn = fr._init;
            try {
              return it(Kn(tn), Vt, er);
            } catch {
            }
          }
        }
      return "";
    }
    var gt = Object.prototype.hasOwnProperty, Ze = {}, Ne = w.ReactDebugCurrentFrame;
    function ze(at) {
      if (at) {
        var Vt = at._owner, er = it(at.type, at._source, Vt ? Vt.type : null);
        Ne.setExtraStackFrame(er);
      } else
        Ne.setExtraStackFrame(null);
    }
    function ct(at, Vt, er, fr, tn) {
      {
        var Kn = Function.call.bind(gt);
        for (var Pr in at)
          if (Kn(at, Pr)) {
            var Pt = void 0;
            try {
              if (typeof at[Pr] != "function") {
                var or = Error((fr || "React class") + ": " + er + " type `" + Pr + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof at[Pr] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw or.name = "Invariant Violation", or;
              }
              Pt = at[Pr](Vt, Pr, fr, er, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ht) {
              Pt = Ht;
            }
            Pt && !(Pt instanceof Error) && (ze(tn), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", fr || "React class", er, Pr, typeof Pt), ze(null)), Pt instanceof Error && !(Pt.message in Ze) && (Ze[Pt.message] = !0, ze(tn), _("Failed %s type: %s", er, Pt.message), ze(null));
          }
      }
    }
    var rt = Array.isArray;
    function qe(at) {
      return rt(at);
    }
    function nt(at) {
      {
        var Vt = typeof Symbol == "function" && Symbol.toStringTag, er = Vt && at[Symbol.toStringTag] || at.constructor.name || "Object";
        return er;
      }
    }
    function Rt(at) {
      try {
        return Ot(at), !1;
      } catch {
        return !0;
      }
    }
    function Ot(at) {
      return "" + at;
    }
    function lt(at) {
      if (Rt(at))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", nt(at)), Ot(at);
    }
    var mt = w.ReactCurrentOwner, jt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Jt, ne;
    function re(at) {
      if (gt.call(at, "ref")) {
        var Vt = Object.getOwnPropertyDescriptor(at, "ref").get;
        if (Vt && Vt.isReactWarning)
          return !1;
      }
      return at.ref !== void 0;
    }
    function ie(at) {
      if (gt.call(at, "key")) {
        var Vt = Object.getOwnPropertyDescriptor(at, "key").get;
        if (Vt && Vt.isReactWarning)
          return !1;
      }
      return at.key !== void 0;
    }
    function Ie(at, Vt) {
      typeof at.ref == "string" && mt.current;
    }
    function Ke(at, Vt) {
      {
        var er = function() {
          Jt || (Jt = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vt));
        };
        er.isReactWarning = !0, Object.defineProperty(at, "key", {
          get: er,
          configurable: !0
        });
      }
    }
    function Le(at, Vt) {
      {
        var er = function() {
          ne || (ne = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Vt));
        };
        er.isReactWarning = !0, Object.defineProperty(at, "ref", {
          get: er,
          configurable: !0
        });
      }
    }
    var Ge = function(at, Vt, er, fr, tn, Kn, Pr) {
      var Pt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: at,
        key: Vt,
        ref: er,
        props: Pr,
        // Record the component responsible for creating this element.
        _owner: Kn
      };
      return Pt._store = {}, Object.defineProperty(Pt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Pt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: fr
      }), Object.defineProperty(Pt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: tn
      }), Object.freeze && (Object.freeze(Pt.props), Object.freeze(Pt)), Pt;
    };
    function ft(at, Vt, er, fr, tn) {
      {
        var Kn, Pr = {}, Pt = null, or = null;
        er !== void 0 && (lt(er), Pt = "" + er), ie(Vt) && (lt(Vt.key), Pt = "" + Vt.key), re(Vt) && (or = Vt.ref, Ie(Vt, tn));
        for (Kn in Vt)
          gt.call(Vt, Kn) && !jt.hasOwnProperty(Kn) && (Pr[Kn] = Vt[Kn]);
        if (at && at.defaultProps) {
          var Ht = at.defaultProps;
          for (Kn in Ht)
            Pr[Kn] === void 0 && (Pr[Kn] = Ht[Kn]);
        }
        if (Pt || or) {
          var Mt = typeof at == "function" ? at.displayName || at.name || "Unknown" : at;
          Pt && Ke(Pr, Mt), or && Le(Pr, Mt);
        }
        return Ge(at, Pt, or, tn, fr, mt.current, Pr);
      }
    }
    var ot = w.ReactCurrentOwner, Ye = w.ReactDebugCurrentFrame;
    function Je(at) {
      if (at) {
        var Vt = at._owner, er = it(at.type, at._source, Vt ? Vt.type : null);
        Ye.setExtraStackFrame(er);
      } else
        Ye.setExtraStackFrame(null);
    }
    var tt;
    tt = !1;
    function kt(at) {
      return typeof at == "object" && at !== null && at.$$typeof === e;
    }
    function Ft() {
      {
        if (ot.current) {
          var at = m(ot.current.type);
          if (at)
            return `

Check the render method of \`` + at + "`.";
        }
        return "";
      }
    }
    function bt(at) {
      return "";
    }
    var At = {};
    function vt(at) {
      {
        var Vt = Ft();
        if (!Vt) {
          var er = typeof at == "string" ? at : at.displayName || at.name;
          er && (Vt = `

Check the top-level render call using <` + er + ">.");
        }
        return Vt;
      }
    }
    function _t(at, Vt) {
      {
        if (!at._store || at._store.validated || at.key != null)
          return;
        at._store.validated = !0;
        var er = vt(Vt);
        if (At[er])
          return;
        At[er] = !0;
        var fr = "";
        at && at._owner && at._owner !== ot.current && (fr = " It was passed a child from " + m(at._owner.type) + "."), Je(at), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', er, fr), Je(null);
      }
    }
    function yt(at, Vt) {
      {
        if (typeof at != "object")
          return;
        if (qe(at))
          for (var er = 0; er < at.length; er++) {
            var fr = at[er];
            kt(fr) && _t(fr, Vt);
          }
        else if (kt(at))
          at._store && (at._store.validated = !0);
        else if (at) {
          var tn = b(at);
          if (typeof tn == "function" && tn !== at.entries)
            for (var Kn = tn.call(at), Pr; !(Pr = Kn.next()).done; )
              kt(Pr.value) && _t(Pr.value, Vt);
        }
      }
    }
    function xr(at) {
      {
        var Vt = at.type;
        if (Vt == null || typeof Vt == "string")
          return;
        var er;
        if (typeof Vt == "function")
          er = Vt.propTypes;
        else if (typeof Vt == "object" && (Vt.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Vt.$$typeof === f))
          er = Vt.propTypes;
        else
          return;
        if (er) {
          var fr = m(Vt);
          ct(er, at.props, "prop", fr, at);
        } else if (Vt.PropTypes !== void 0 && !tt) {
          tt = !0;
          var tn = m(Vt);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", tn || "Unknown");
        }
        typeof Vt.getDefaultProps == "function" && !Vt.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dr(at) {
      {
        for (var Vt = Object.keys(at.props), er = 0; er < Vt.length; er++) {
          var fr = Vt[er];
          if (fr !== "children" && fr !== "key") {
            Je(at), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", fr), Je(null);
            break;
          }
        }
        at.ref !== null && (Je(at), _("Invalid attribute `ref` supplied to `React.Fragment`."), Je(null));
      }
    }
    function Er(at, Vt, er, fr, tn, Kn) {
      {
        var Pr = L(at);
        if (!Pr) {
          var Pt = "";
          (at === void 0 || typeof at == "object" && at !== null && Object.keys(at).length === 0) && (Pt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var or = bt();
          or ? Pt += or : Pt += Ft();
          var Ht;
          at === null ? Ht = "null" : qe(at) ? Ht = "array" : at !== void 0 && at.$$typeof === e ? (Ht = "<" + (m(at.type) || "Unknown") + " />", Pt = " Did you accidentally export a JSX literal instead of a component?") : Ht = typeof at, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ht, Pt);
        }
        var Mt = ft(at, Vt, er, tn, Kn);
        if (Mt == null)
          return Mt;
        if (Pr) {
          var Qt = Vt.children;
          if (Qt !== void 0)
            if (fr)
              if (qe(Qt)) {
                for (var pn = 0; pn < Qt.length; pn++)
                  yt(Qt[pn], at);
                Object.freeze && Object.freeze(Qt);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              yt(Qt, at);
        }
        return at === n ? dr(Mt) : xr(Mt), Mt;
      }
    }
    function gr(at, Vt, er) {
      return Er(at, Vt, er, !0);
    }
    function pr(at, Vt, er) {
      return Er(at, Vt, er, !1);
    }
    var Xr = pr, Yr = gr;
    Fw.Fragment = n, Fw.jsx = Xr, Fw.jsxs = Yr;
  }()), Fw;
}
var p5e;
function X5t() {
  return p5e || (p5e = 1, Ar.env.NODE_ENV === "production" ? jO.exports = J5t() : jO.exports = Y5t()), jO.exports;
}
var R = X5t();
const tk = { wiseOwlChat: { helpAssistantMediaObject: "help-assistant-media-object", submitButton: "wiseOwlChat-submit-button", userMediaObject: "user-media-object" }, liveChat: { chatComposer: "live-chat-composer" } };
var m5e, g5e, v5e, y5e;
(function(t) {
  t.celebration = "celebration", t.create = "create", t.dependency = "dependency", t.noData = "noData", t.noResults = "noResults", t.oops = "oops", t.unauthorized = "unauthorized";
})(m5e || (m5e = {})), function(t) {
  t[t.button = 0] = "button", t[t.anchor = 1] = "anchor";
}(g5e || (g5e = {})), function(t) {
  t.horizontal = "horizontal", t.vertical = "vertical";
}(v5e || (v5e = {})), function(t) {
  t.nudge = "esc_type_nudge", t.fire = "esc_type_fire";
}(y5e || (y5e = {}));
const hm = { Waiting: "waiting", Active: "active", Ended: "ended" };
var b5e, wc, rh, k9;
(function(t) {
  t.open = "2", t.suspended = "4,16,32", t.closed = "8", t.all = "all";
})(b5e || (b5e = {})), function(t) {
  t.local = "local", t.dev = "dev", t.stage = "stage", t.prod = "prod";
}(wc || (wc = {})), function(t) {
  t.prod = "www.twilio.com", t.stage = "www.stage.twilio.com", t.dev = "www.dev.twilio.com", t.local = "www.local.twilio.com";
}(rh || (rh = {})), function(t) {
  t.twilio = "twilio", t.sendGrid = "sendGrid", t.segment = "segment", t.zipwhip = "zipwhip";
}(k9 || (k9 = {}));
const ule = { sandbox: 1019469, prod: 1019473 };
var dle, x5e, C5e, w5e, fle;
(function(t) {
  t.sendGrid = "sghc", t.twilio = "twlo";
})(dle || (dle = {})), function(t) {
  t.VERY_HIGH = "VERY_HIGH", t.HIGH = "HIGH", t.MEDIUM = "MEDIUM", t.LOW = "LOW";
}(x5e || (x5e = {})), function(t) {
  t.relevant = "relevant", t.notRelevant = "notRelevant";
}(C5e || (C5e = {})), function(t) {
  t.ANSWER = "ANSWER", t.DOCUMENT = "DOCUMENT", t.QUESTION_ANSWER = "QUESTION_ANSWER";
}(w5e || (w5e = {})), function(t) {
  t.unpersisted = "unpersisted", t.initialized = "initialized", t.active = "active", t.suspended = "suspended", t.deleted = "deleted", t.parentSuspended = "parent_suspended", t.suspendedByParent = "suspended_by_Parent";
}(fle || (fle = {}));
var S5e, _5e, k5e, A5e, T5e, E5e;
(function(t) {
  t.active = "active", t.pending = "pending";
})(S5e || (S5e = {})), function(t) {
  t.sendGrid = "sg", t.twilio = "tw";
}(_5e || (_5e = {})), function(t) {
  t.developer = "BIdeveloperSupport", t.bootstrap = "BIeb42386c52bbba15168d95967a134486", t.bootstrapAnnualPre2018 = "BI6fdcc456e164344d1a7677f1f0752e14", t.bootstrapOld = "BIac31b4b41a7540a984e8a68ead12a530", t.business = "BIceadf727df10952652bae76a26d43f77", t.doGood = "BIf44d1c5612bfe7503f256e6e21d38f59", t.partnerAdvanced = "BIba7db56115701aa106f8ec958c7a0a61", t.personalized = "BIb84abcf4eed7773c71c4365e21b32ce9", t.personalizedPartnerMso = "BI961b38eb29b07b4cfe1d75f3ab4da979", t.personalizedPartnerMss = "BIb270fd45485f9816cd3967691b870a8c", t.personalizedPre2018 = "BId24ea45931375ef6aee9ad91f67e31aa", t.premium = "BI8d5215fedc19839fa6ade96b25b10d47", t.premiumAnnualPre2018 = "BI9ce6b0aa534e735c210c6856504d20d8", t.premiumComplimentaryPre2018 = "BIada0a7f499b46bc4f33d5dfeb98bd246", t.premiumPhone = "BI01baad4736d34b79ae729691e2dcdcb2", t.premiumPresalesPre2018 = "BI55bda356dd494b96a989f9830f6da957", t.premium24x7 = "BI7af2924c7cb04e1d864f45978ad9a7bd", t.production = "BIc01c5cdd547a811e081aa9232ec6e254", t.sendGridPersonalized = "BIsendGridPersonalizedPlan";
}(k5e || (k5e = {})), function(t) {
  t.email = "email", t.firstName = "firstName", t.lastName = "lastName", t.phoneNumber = "phoneNumber";
}(A5e || (A5e = {})), function(t) {
  t.accept = "accept", t.info = "info", t.minus = "minus";
}(T5e || (T5e = {})), function(t) {
  t.Business = "Business", t.Developer = "Developer", t.Personalized = "Personalized", t.Production = "Production";
}(E5e || (E5e = {}));
var I5e, M5e, P5e, R5e, O5e, B5e, N5e;
(function(t) {
  t.attachments = "attachments", t.comment = "comment";
})(I5e || (I5e = {})), function(t) {
  t.id = "id", t.priority = "priority", t.updatedAt = "updatedAt", t.status = "status", t.escalation = "escalation";
}(M5e || (M5e = {})), function(t) {
  t.back = "back", t.forward = "forward", t.toPage = "toPage";
}(P5e || (P5e = {})), function(t) {
  t.noData = "noData", t.noResults = "noResults", t.initialLoadError = "initialLoadError", t.searchError = "searchError";
}(R5e || (R5e = {})), function(t) {
  t.requester = "requester", t.account = "account";
}(O5e || (O5e = {})), function(t) {
  t.new = "new", t.open = "open", t.pending = "pending", t.hold = "hold", t.solved = "solved", t.closed = "closed";
}(B5e || (B5e = {})), function(t) {
  t.p1 = "p1_critical_system_outage", t.p2 = "p2_degraded_service", t.p3 = "p3_general_issue";
}(N5e || (N5e = {}));
var $5e;
(function(t) {
  t.attachments = "attachments", t.comment = "comment", t.email = "email", t.collaborators = "collaborators", t.priorityLevel = "priorityLevel", t.subject = "subject", t.followUpQuestions = "followUpQuestions", t.followUpAnswers = "followUpAnswers", t.followUpData = "followUpData", t.product = "product", t.issueArea = "issueArea";
})($5e || ($5e = {}));
var ol;
(function(t) {
  t.console = "console", t.osc = "osc", t.oscUngated = "oscUngated", t.zendesk = "zendesk", t.salesforce = "salesforce", t.sendGrid = "sendGrid", t.wiseOwlApp = "WISEOWL_APP", t.wiseOwlAppV2 = "WISEOWL_APP_V2";
})(ol || (ol = {}));
var D5e, Al, Tl;
(function(t) {
  t.InProgress = "inProgress", t.Complete = "complete", t.Error = "error";
})(D5e || (D5e = {})), function(t) {
  t.Message = "message", t.ToolCall = "tool-call", t.CardGroup = "card-group", t.LinkGroup = "link-group", t.LiveChat = "live-chat", t.ButtonGroup = "button-group", t.PromptSuggestionGroup = "prompt-suggestion-group", t.SubmitTicketForm = "submit-ticket-form", t.ToolCallStatusLine = "tool-call-status-line", t.TableBlock = "table", t.IntelligentDiscoveryHome = "intelligent-discovery-home", t.LoginCTA = "login-cta", t.DataGrid = "data-grid", t.SupportCta = "support-cta", t.Feedback = "feedback", t.Combobox = "combobox", t.HomeInsights = "home-insights", t.UpsellCTA = "upsell-cta";
}(Al || (Al = {})), function(t) {
  t.Persistent = "persistent", t.Transient = "transient";
}(Tl || (Tl = {}));
const Hv = { Assistant: "assistant", User: "human" };
var G$, y_;
(function(t) {
  t.SubmitTicket = "submit-ticket";
})(G$ || (G$ = {})), function(t) {
  t.Event = "event", t.Redirect = "redirect", t.DeepLink = "deep-link", t.Modal = "modal", t.LiveChat = "live-chat", t.UserSay = "user-say", t.CallbackRequest = "callback-request";
}(y_ || (y_ = {}));
const Q5t = { LiveChat: "live-chat" };
var L5e, Rv, Y0;
(function(t) {
  t.PhoneSupport = "phone", t.SubmitTicket = "ticket", t.LiveChat = "chat";
})(L5e || (L5e = {})), function(t) {
  t.OneAdmin = "ONE_ADMIN", t.OneSupportCenter = "ONE_SUPPORT_CENTER", t.Salesforce = "SALESFORCE", t.Zendesk = "ZENDESK";
}(Rv || (Rv = {})), function(t) {
  t.User = "USER", t.Assistant = "ASSISTANT", t.System = "SYSTEM";
}(Y0 || (Y0 = {}));
var j5e, F5e;
(function(t) {
  t.chatId = "chatId", t.input = "input";
})(j5e || (j5e = {})), function(t) {
  t.None = "none", t.Loading = "loading", t.Complete = "complete";
}(F5e || (F5e = {}));
var z5e, G5e, W5e, b_, H5e, U5e;
(function(t) {
  t.Feedback = "feedback";
})(z5e || (z5e = {})), function(t) {
  t.TwilioCom = "TWILIO_COM", t.SendGridCom = "SENDGRID_COM", t.SegmentCom = "SEGMENT_COM", t.HelpTwilioCom = "HELP_TWILIO_COM", t.AuthyCom = "AUTHY_COM", t.GoogleDrive = "GOOGLE_DRIVE", t.TwilioOrg = "TWILIO_ORG";
}(G5e || (G5e = {})), function(t) {
  t.Web = "WEB";
}(W5e || (W5e = {})), function(t) {
  t.local = "local", t.sandbox = "sandbox", t.prod = "prod";
}(b_ || (b_ = {})), function(t) {
  t.prod = "twilio.zendesk.com", t.sandbox = "twilio1444173614.zendesk.com", t.local = "localhost";
}(H5e || (H5e = {})), function(t) {
  t.creationSourceRequestCallback = "sg_hc_callback", t.creationSourceSupportRequest = "sg_hc_supportForm", t.creationSourceDoNotActivate = "sg_hc_account_access_issue", t.creationSourceUauthorizedAccess = "sg_hc_unauthorized", t.creationSourceOneSupportCenterUngated = "osc_ungated", t.creationSourceOneSupportCenterGated = "osc_gated", t.creationSourceOscWiseOwlGated = "hca_gated", t.creationSourceOscWiseOwlUngated = "hca_ungated", t.ingressSourceOscWiseOwlNegativeFeedback = "hca_negative_feedback", t.directLiveChatCreation = "direct_live_chat", t.questionsAskedInChat = "hca_ci_chat_questions", t.questionsRelevant = "hca_ci_form_relevant", t.questionsNotRelevant = "hca_ci_form_not_relevant";
}(U5e || (U5e = {}));
var A9, V5e;
(function(t) {
  t.local = "local", t.dev = "dev", t.stage = "stage", t.prod = "prod";
})(A9 || (A9 = {})), function(t) {
  t.prod = "wiseowl.twilio.com", t.stage = "wiseowl.stage.twilio.com", t.dev = "wiseowl.dev.twilio.com", t.local = "localhost";
}(V5e || (V5e = {}));
wc.prod + "", rh.prod, wc.stage + "", rh.stage, wc.dev + "", rh.dev, wc.local + "", rh.local;
const FO = "1.0.570", e6t = (t) => t.includes("apps.zdusercontent") ? t.includes(ule.sandbox.toString()) ? wc.stage : wc.prod : null, t6t = (t) => t.includes("sendgrid") ? t.includes("sendgridtest") ? wc.stage : t.includes("support.sendgrid") ? wc.prod : null : null, r6t = (t) => {
  const e = e6t(t);
  if (e) return e;
  const r = t6t(t);
  if (r) return r;
  const n = t.match(/(?<realm>local)host/), a = t.match(/(help|console)\.(?<realm>dev|stage|local)\.twilio/), i = t.match(/wiseowl-salesforce\.(?<realm>dev|stage)/), o = t.match(/wiseowl\.(?<realm>dev|stage)/), s = n || a || i || o;
  return s && s.groups ? s.groups.realm : wc.prod;
}, TI = () => {
  const t = r6t(window.location.hostname) || wc.prod, e = { chatWidgetSourceFile: "one-support-center-widget.js", incidentStatusPage: { [k9.twilio]: "https://status.twilio.com", [k9.sendGrid]: "https://status.sendgrid.com", [k9.segment]: "https://status.segment.com", [k9.zipwhip]: "https://app-status.zipwhip.com" }, searchIndex: dle.twilio, realm: t }, r = { [wc.prod]: Object.assign(Object.assign({}, e), { chatWidgetSource: `https://assets.twilio.com/public_assets/support/${FO}/${e.chatWidgetSourceFile}`, csrfEndpoint: "https://www.twilio.com/api/csrf", hostName: "https://help.twilio.com", currentAccountCookieDomain: ".www.twilio.com", priorityLevelFieldId: "20551717", segmentWriteKey: "kAjvDMcGCgzvdvyUuc6EBC8Geclvum1x", splitAuthorizationKey: "eo858j4suqc1d9l34ieet2e71bh1cjde52ng", supportApiEndpoint: "https://www.twilio.com/console/osc/api", helpCenterApiEndpoint: "https://www.twilio.com/help-center", ticketingApiEndpoint: "https://www.twilio.com/ticketing", wiseOwlAPIEndpoint: "https://www.twilio.com/wise-owl/api", supportAuthorizerEndpoint: "https://6yftbi9f04.execute-api.us-east-1.amazonaws.com/support-authorizer/v1", recaptchaSiteKey: "6Ld0t6glAAAAAIiwPaRRFL0VeM4IKprsXeb8GrLj", consoleEndpoint: "https://www.twilio.com/console", webEndpoint: rh.prod, ticketEscalationDelayMinutes: 30 }), [wc.stage]: Object.assign(Object.assign({}, e), { chatWidgetSource: `https://assets.twilio.com/public_assets/support/${FO}/${e.chatWidgetSourceFile}`, csrfEndpoint: "https://www.stage.twilio.com/api/csrf", hostName: "https://help.stage.twilio.com", currentAccountCookieDomain: ".www.stage.twilio.com", priorityLevelFieldId: "28245318", segmentWriteKey: "1rooaFSZEzDxdB9kpJegqDGfRoqD1B8Q", splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5", supportApiEndpoint: "https://www.stage.twilio.com/console/osc/api", helpCenterApiEndpoint: "https://www.stage.twilio.com/help-center", ticketingApiEndpoint: "https://www.stage.twilio.com/ticketing", wiseOwlAPIEndpoint: "https://www.stage.twilio.com/wise-owl/api", supportAuthorizerEndpoint: "https://44r1dcr1ma.execute-api.us-east-1.amazonaws.com/support-authorizer/v1", recaptchaSiteKey: "6Ldxt6glAAAAAOygpaQ3md2sWNMekNSliGFTvNnS", consoleEndpoint: "https://www.stage.twilio.com/console", webEndpoint: rh.stage, ticketEscalationDelayMinutes: 30 }), [wc.dev]: Object.assign(Object.assign({}, e), { chatWidgetSource: `https://assets.twilio.com/public_assets/support/${FO}/${e.chatWidgetSourceFile}`, csrfEndpoint: "https://www.dev.twilio.com/api/csrf", hostName: "https://help.dev.twilio.com", currentAccountCookieDomain: ".www.dev.twilio.com", priorityLevelFieldId: "28245318", segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP", splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5", supportApiEndpoint: "https://www.dev.twilio.com/console/osc/api", helpCenterApiEndpoint: "https://www.dev.twilio.com/help-center", ticketingApiEndpoint: "https://www.dev.twilio.com/ticketing", wiseOwlAPIEndpoint: "https://www.dev.twilio.com/wise-owl/api", supportAuthorizerEndpoint: "https://44r1dcr1ma.execute-api.us-east-1.amazonaws.com/support-authorizer/v1", recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP", consoleEndpoint: "https://www.dev.twilio.com/console", webEndpoint: rh.dev, ticketEscalationDelayMinutes: 30 }), [wc.local]: Object.assign(Object.assign({}, e), { chatWidgetSource: `https://assets.twilio.com/public_assets/support/${FO}/${e.chatWidgetSourceFile}`, csrfEndpoint: `${window.location.protocol}//www.local.twilio.com/api/csrf`, hostName: `${window.location.protocol}//help.local.twilio.com`, currentAccountCookieDomain: ".www.local.twilio.com", priorityLevelFieldId: "28245318", segmentWriteKey: "8XclIx4jSPDyeVxTdeLqnnk78hTusRIP", splitAuthorizationKey: "1s2p8gdot9t60t768ktoi616e4cocb6ebmj5", recaptchaSiteKey: "6Ldvt6glAAAAAA-fUuXNdaERxxUUrwhyTNgUxwQP", supportApiEndpoint: `${window.location.protocol}//www.local.twilio.com/console/osc/api`, helpCenterApiEndpoint: `${window.location.protocol}//www.local.twilio.com/help-center`, ticketingApiEndpoint: `${window.location.protocol}//www.local.twilio.com/ticketing`, wiseOwlAPIEndpoint: `${window.location.protocol}//www.local.twilio.com/wise-owl/api`, supportAuthorizerEndpoint: `${window.location.protocol}//localhost:7990/v1`, consoleEndpoint: `${window.location.protocol}//www.local.twilio.com/console`, webEndpoint: rh.local, ticketEscalationDelayMinutes: 30 }) };
  return r[t] || r[wc.local];
}, { supportApiEndpoint: mK, supportAuthorizerEndpoint: n6t, wiseOwlAPIEndpoint: q5e } = TI(), vm = { local: "http://localhost:17823/v1", dev: "https://comms-gpt.aws-otk-dev-general-use1-001.otk.twilioinfra.com/v1", stage: "https://comms-gpt.aws-otk-stage-general-use1-001.otk.twilioinfra.com/v1", prod: "https://comms-gpt.aws-otk-prod-general-use1-001.otk.twilioinfra.com/v1" }, Tm = { local: "localhost:4567", sandbox: `${ule.sandbox}.apps.zdusercontent.com`, prod: `${ule.prod}.apps.zdusercontent.com` }, zO = { local: "localhost:4400", dev: "wiseowl-salesforce.dev.twilio.com", stage: "wiseowl-salesforce.stage.twilio.com", prod: "wiseowl-salesforce.twilio.com" }, GO = { local: "localhost:4300", dev: "wiseowl.dev.twilio.com", stage: "wiseowl.stage.twilio.com", prod: "wiseowl.twilio.com" };
Tm.local + "", b_.local, Tm.sandbox + "", b_.sandbox, Tm.prod + "", b_.prod;
GO.local + "", A9.local, GO.dev + "", A9.dev, GO.stage + "", A9.stage, GO.prod + "", A9.prod;
const a6t = { [Tm.local]: vm.dev, [Tm.sandbox]: vm.stage, [Tm.prod]: vm.prod }, i6t = { [zO.local]: vm.local, [zO.dev]: vm.dev, [zO.stage]: vm.stage, [zO.prod]: vm.prod }, o6t = () => a6t[window.location.host] || vm.prod, s6t = () => i6t[window.location.host] || vm.prod;
ol.osc + "", `${mK}`, ol.oscUngated + "", `${mK}`, ol.console + "", `${mK}`, ol.wiseOwlApp + "", `${q5e}`, ol.wiseOwlAppV2 + "", `${q5e}`, ol.sendGrid + "", `${n6t}`, ol.salesforce + "", s6t(), ol.zendesk + "", o6t();
const { supportApiEndpoint: gK, supportAuthorizerEndpoint: l6t } = TI(), s7 = { dev: "https://help-center.aws-otk-dev-general-use1-001.otk.twilioinfra.com/v1", stage: "https://help-center.aws-otk-stage-general-use1-001.otk.twilioinfra.com/v1", prod: "https://help-center.aws-otk-prod-general-use1-001.otk.twilioinfra.com/v1" }, c6t = { [Tm.local]: s7.dev, [Tm.sandbox]: s7.stage, [Tm.prod]: s7.prod }, u6t = () => s7.prod, K5e = () => s7.prod, d6t = () => c6t[window.location.host] || s7.prod;
ol.osc + "", `${gK}`, ol.oscUngated + "", `${gK}`, ol.console + "", `${gK}`, ol.salesforce + "", u6t(), ol.zendesk + "", d6t(), ol.wiseOwlApp + "", K5e(), ol.wiseOwlAppV2 + "", K5e(), ol.sendGrid + "", `${l6t}`;
const { helpCenterApiEndpoint: zmn } = TI(), { ticketingApiEndpoint: Gmn } = TI(), f6t = { ticketSubmission: "/submit" }, Z5e = "Assistant", h6t = "You", hle = { WISE_OWL_CHAT_LOG_CONTAINER: "WISE_OWL_CHAT_LOG_CONTAINER", WISE_OWL_LIVE_CHAT_BLOCK: "WISE_OWL_LIVE_CHAT_BLOCK" }, p6t = { liveChatDisclaimer: "Please do not include any personal data, including sensitive personal data or protected health information, in the Live Chat or attachments you upload to the Live Chat. Twilio analyzes the type, frequency, and patterns of requests we receive to help identify ways to improve our support services and anonymizes any personal data prior to conducting any analysis." };
Al.PromptSuggestionGroup, Tl.Persistent;
Al.ToolCall, Tl.Persistent, Al.ToolCall, Tl.Persistent;
Al.Message, Tl.Persistent, Hv.User, Al.Message, Tl.Persistent, Hv.Assistant;
Al.LinkGroup, Tl.Persistent;
Al.ButtonGroup, Tl.Persistent, y_.Redirect, y_.Event, G$.SubmitTicket, y_.Event, G$.SubmitTicket;
Al.IntelligentDiscoveryHome, Tl.Persistent;
Al.Feedback, Tl.Persistent;
Al.Feedback, Tl.Persistent;
const m6t = { type: Al.TableBlock, values: { records: [{ status: "FAILED", from_phone_number: "+16505766372", status_span: 1, from_phone_number_span: 1, total: 124172, error_code: "30500", error_code_span: 1 }, { status: "UNDELIVERED", from_phone_number: "+14151235085", status_span: 1, from_phone_number_span: 1, total: 27239, error_code: "30008", error_code_span: 1 }, { status: "DELIVERY_UNKNOWN", from_phone_number: "", status_span: 2, from_phone_number_span: 1, total: 21159, error_code: "0", error_code_span: 2 }, { status: "DELIVERY_UNKNOWN", from_phone_number: "+16505766372", status_span: 0, from_phone_number_span: 1, total: 19507, error_code: "0", error_code_span: 0 }, { status: "FAILED", from_phone_number: "+12015562933", status_span: 1, from_phone_number_span: 1, total: 16627, error_code: "12300", error_code_span: 1 }, { status: "UNDELIVERED", from_phone_number: "+12015593193", status_span: 2, from_phone_number_span: 1, total: 15249, error_code: "30008", error_code_span: 1 }, { status: "UNDELIVERED", from_phone_number: "+16505766372", status_span: 0, from_phone_number_span: 2, total: 14093, error_code: "0", error_code_span: 2 }, { status: "FAILED", from_phone_number: "+16505766372", status_span: 2, from_phone_number_span: 0, total: 14051, error_code: "0", error_code_span: 0 }, { status: "FAILED", from_phone_number: "whatsapp:+12092224703", status_span: 0, from_phone_number_span: 1, total: 9963, error_code: "63007", error_code_span: 1 }, { status: "UNDELIVERED", from_phone_number: "+14155552345", status_span: 1, from_phone_number_span: 1, total: 6993, error_code: "30008", error_code_span: 1 }] }, display: Tl.Persistent };
Al.TableBlock, Tl.Persistent;
Al.Message, Hv.Assistant, Tl.Persistent;
Rv.OneSupportCenter, Y0.User, Y0.Assistant, Y0.User, Y0.Assistant;
const g6t = new File(["(⌐□_□)"], "chucknorris.png", { type: "image/png" });
Object.defineProperty(g6t, "size", { value: 10485760 });
new File(["(⌐□_□)"], "chucknorris-is-a-scary-scary-scary-person.png", { type: "image/png" });
const v6t = new File(["(⌐□_□)"], "chucknorris.png", { type: "image/png" });
Object.defineProperty(v6t, "size", { value: 104857600 });
const y6t = new File(["(⌐□_□)"], "also-chucknorris.png", { type: "image/png" });
Object.defineProperty(y6t, "size", { value: 104857600 });
fle.active;
const b6t = "csrf", uWe = "token", x6t = "b441d9ac-65b8-4af3-aa1f-04d75104e0fe", l1e = { "Content-type": "application/json" };
Object.assign(Object.assign({}, l1e), { "x-twilio-csrf": b6t });
Object.assign(Object.assign({}, l1e), { "salesforce-auth": uWe });
Object.assign(Object.assign({}, l1e), { "wozd-auth": uWe });
const C6t = { input: "I think you are way cool, Wise Owl", stream: !0 }, w6t = Object.assign({}, C6t);
Object.assign(Object.assign({}, w6t), { stargateUngatedUserId: x6t });
const S6t = { feedback: "", positive: !0 };
Object.assign({}, S6t);
Rv.OneSupportCenter, Y0.User, Y0.Assistant;
Rv.OneAdmin, Y0.User, Y0.Assistant, Y0.User, Y0.Assistant;
Rv.OneAdmin, Rv.OneAdmin, Rv.OneAdmin;
Al.PromptSuggestionGroup, Tl.Persistent;
Al.IntelligentDiscoveryHome, Tl.Persistent;
Al.PromptSuggestionGroup, Tl.Persistent;
Al.PromptSuggestionGroup, Tl.Persistent;
const _6t = { accountSid: "AC541262dd2c401687d00656d3811553ab", email: "hhartigan@twilio.com", friendlyName: "Hugh Hartigan", identity: "hhartigan@twilio.com", location: "https://help.stage.twilio.com", metadata: "%7B%22account%22%3A%7B%22sid%22%3A%22AC541262dd2c401687d00656d3811553ab%22%7D%2C%22user%22%3A%7B%22sid%22%3A%22US046e8c33ddaa77748de95b406cc454cc%22%2C%22email%22%3A%22hhartigan%40twilio.com%22%2C%22fullName%22%3A%22Hugh%20Hartigan%22%7D%2C%22customFields%22%3A%5B%7B%22id%22%3A28239607%2C%22value%22%3A%22AC541262dd2c401687d00656d3811553ab%22%7D%2C%7B%22id%22%3A28239617%2C%22value%22%3A%22US046e8c33ddaa77748de95b406cc454cc%22%7D%2C%7B%22id%22%3A28245318%2C%22value%22%3A%22p3_general_issue%22%7D%5D%2C%22tags%22%3A%5B%22sof_chat%22%5D%2C%22hcaCsatProps%22%3Anull%7D", productCategory: "support_accounts_billing", question: "I'd like to know when my invoice will be available and where I can find it. Additionally, I am encountering error code 30004 while trying to deliver messages. The assistant mentioned several possible causes, including the recipient's number being on a Do Not Disturb list, service plan limitations, carrier blocking, and device issues. I've attempted troubleshooting as suggested, including checking the Twilio Status Page and following SMS guidelines, but the issue persists. I need further assistance to resolve this.", url: "https://help.stage.twilio.com", userSid: "US046e8c33ddaa77748de95b406cc454cc" };
JSON.stringify(_6t);
Al.LiveChat, Tl.Persistent;
function k6t(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var dWe = { exports: {} }, fl = dWe.exports = {}, H2, U2;
function ple() {
  throw new Error("setTimeout has not been defined");
}
function mle() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? H2 = setTimeout : H2 = ple;
  } catch {
    H2 = ple;
  }
  try {
    typeof clearTimeout == "function" ? U2 = clearTimeout : U2 = mle;
  } catch {
    U2 = mle;
  }
})();
function fWe(t) {
  if (H2 === setTimeout)
    return setTimeout(t, 0);
  if ((H2 === ple || !H2) && setTimeout)
    return H2 = setTimeout, setTimeout(t, 0);
  try {
    return H2(t, 0);
  } catch {
    try {
      return H2.call(null, t, 0);
    } catch {
      return H2.call(this, t, 0);
    }
  }
}
function A6t(t) {
  if (U2 === clearTimeout)
    return clearTimeout(t);
  if ((U2 === mle || !U2) && clearTimeout)
    return U2 = clearTimeout, clearTimeout(t);
  try {
    return U2(t);
  } catch {
    try {
      return U2.call(null, t);
    } catch {
      return U2.call(this, t);
    }
  }
}
var ym = [], l7 = !1, ub, $N = -1;
function T6t() {
  !l7 || !ub || (l7 = !1, ub.length ? ym = ub.concat(ym) : $N = -1, ym.length && hWe());
}
function hWe() {
  if (!l7) {
    var t = fWe(T6t);
    l7 = !0;
    for (var e = ym.length; e; ) {
      for (ub = ym, ym = []; ++$N < e; )
        ub && ub[$N].run();
      $N = -1, e = ym.length;
    }
    ub = null, l7 = !1, A6t(t);
  }
}
fl.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  ym.push(new pWe(t, e)), ym.length === 1 && !l7 && fWe(hWe);
};
function pWe(t, e) {
  this.fun = t, this.array = e;
}
pWe.prototype.run = function() {
  this.fun.apply(null, this.array);
};
fl.title = "browser";
fl.browser = !0;
fl.env = {};
fl.argv = [];
fl.version = "";
fl.versions = {};
function og() {
}
fl.on = og;
fl.addListener = og;
fl.once = og;
fl.off = og;
fl.removeListener = og;
fl.removeAllListeners = og;
fl.emit = og;
fl.prependListener = og;
fl.prependOnceListener = og;
fl.listeners = function(t) {
  return [];
};
fl.binding = function(t) {
  throw new Error("process.binding is not supported");
};
fl.cwd = function() {
  return "/";
};
fl.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
fl.umask = function() {
  return 0;
};
var E6t = dWe.exports;
const Qa = /* @__PURE__ */ k6t(E6t);
function vc(t) {
  return `Minified Redux error #${t}; visit https://redux.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
}
var I6t = typeof Symbol == "function" && Symbol.observable || "@@observable", J5e = I6t, vK = () => Math.random().toString(36).substring(7).split("").join("."), M6t = {
  INIT: `@@redux/INIT${/* @__PURE__ */ vK()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ vK()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${vK()}`
}, Ab = M6t;
function Th(t) {
  if (typeof t != "object" || t === null)
    return !1;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e || Object.getPrototypeOf(t) === null;
}
function P6t(t) {
  if (t === void 0)
    return "undefined";
  if (t === null)
    return "null";
  const e = typeof t;
  switch (e) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return e;
  }
  if (Array.isArray(t))
    return "array";
  if (B6t(t))
    return "date";
  if (O6t(t))
    return "error";
  const r = R6t(t);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(t).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function R6t(t) {
  return typeof t.constructor == "function" ? t.constructor.name : null;
}
function O6t(t) {
  return t instanceof Error || typeof t.message == "string" && t.constructor && typeof t.constructor.stackTraceLimit == "number";
}
function B6t(t) {
  return t instanceof Date ? !0 : typeof t.toDateString == "function" && typeof t.getDate == "function" && typeof t.setDate == "function";
}
function iv(t) {
  let e = typeof t;
  return Qa.env.NODE_ENV !== "production" && (e = P6t(t)), e;
}
function mWe(t, e, r) {
  if (typeof t != "function")
    throw new Error(Qa.env.NODE_ENV === "production" ? vc(2) : `Expected the root reducer to be a function. Instead, received: '${iv(t)}'`);
  if (typeof e == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(Qa.env.NODE_ENV === "production" ? vc(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof e == "function" && typeof r > "u" && (r = e, e = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(1) : `Expected the enhancer to be a function. Instead, received: '${iv(r)}'`);
    return r(mWe)(t, e);
  }
  let n = t, a = e, i = /* @__PURE__ */ new Map(), o = i, s = 0, l = !1;
  function c() {
    o === i && (o = /* @__PURE__ */ new Map(), i.forEach((b, w) => {
      o.set(w, b);
    }));
  }
  function u() {
    if (l)
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return a;
  }
  function f(b) {
    if (typeof b != "function")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(4) : `Expected the listener to be a function. Instead, received: '${iv(b)}'`);
    if (l)
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let w = !0;
    c();
    const _ = s++;
    return o.set(_, b), function() {
      if (w) {
        if (l)
          throw new Error(Qa.env.NODE_ENV === "production" ? vc(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        w = !1, c(), o.delete(_), i = null;
      }
    };
  }
  function h(b) {
    if (!Th(b))
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(7) : `Actions must be plain objects. Instead, the actual type was: '${iv(b)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof b.type > "u")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof b.type != "string")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(17) : `Action "type" property must be a string. Instead, the actual type was: '${iv(b.type)}'. Value was: '${b.type}' (stringified)`);
    if (l)
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, a = n(a, b);
    } finally {
      l = !1;
    }
    return (i = o).forEach((_) => {
      _();
    }), b;
  }
  function p(b) {
    if (typeof b != "function")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(10) : `Expected the nextReducer to be a function. Instead, received: '${iv(b)}`);
    n = b, h({
      type: Ab.REPLACE
    });
  }
  function g() {
    const b = f;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(w) {
        if (typeof w != "object" || w === null)
          throw new Error(Qa.env.NODE_ENV === "production" ? vc(11) : `Expected the observer to be an object. Instead, received: '${iv(w)}'`);
        function _() {
          const x = w;
          x.next && x.next(u());
        }
        return _(), {
          unsubscribe: b(_)
        };
      },
      [J5e]() {
        return this;
      }
    };
  }
  return h({
    type: Ab.INIT
  }), {
    dispatch: h,
    subscribe: f,
    getState: u,
    replaceReducer: p,
    [J5e]: g
  };
}
function Y5e(t) {
  typeof console < "u" && typeof console.error == "function" && console.error(t);
  try {
    throw new Error(t);
  } catch {
  }
}
function N6t(t, e, r, n) {
  const a = Object.keys(e), i = r && r.type === Ab.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (a.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Th(t))
    return `The ${i} has unexpected type of "${iv(t)}". Expected argument to be an object with the following keys: "${a.join('", "')}"`;
  const o = Object.keys(t).filter((s) => !e.hasOwnProperty(s) && !n[s]);
  if (o.forEach((s) => {
    n[s] = !0;
  }), !(r && r.type === Ab.REPLACE) && o.length > 0)
    return `Unexpected ${o.length > 1 ? "keys" : "key"} "${o.join('", "')}" found in ${i}. Expected to find one of the known reducer keys instead: "${a.join('", "')}". Unexpected keys will be ignored.`;
}
function $6t(t) {
  Object.keys(t).forEach((e) => {
    const r = t[e];
    if (typeof r(void 0, {
      type: Ab.INIT
    }) > "u")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(12) : `The slice reducer for key "${e}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: Ab.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(13) : `The slice reducer for key "${e}" returned undefined when probed with a random type. Don't try to handle '${Ab.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function gWe(t) {
  const e = Object.keys(t), r = {};
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    Qa.env.NODE_ENV !== "production" && typeof t[s] > "u" && Y5e(`No reducer provided for key "${s}"`), typeof t[s] == "function" && (r[s] = t[s]);
  }
  const n = Object.keys(r);
  let a;
  Qa.env.NODE_ENV !== "production" && (a = {});
  let i;
  try {
    $6t(r);
  } catch (o) {
    i = o;
  }
  return function(s = {}, l) {
    if (i)
      throw i;
    if (Qa.env.NODE_ENV !== "production") {
      const f = N6t(s, r, l, a);
      f && Y5e(f);
    }
    let c = !1;
    const u = {};
    for (let f = 0; f < n.length; f++) {
      const h = n[f], p = r[h], g = s[h], y = p(g, l);
      if (typeof y > "u") {
        const b = l && l.type;
        throw new Error(Qa.env.NODE_ENV === "production" ? vc(14) : `When called with an action of type ${b ? `"${String(b)}"` : "(unknown type)"}, the slice reducer for key "${h}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      u[h] = y, c = c || y !== g;
    }
    return c = c || n.length !== Object.keys(s).length, c ? u : s;
  };
}
function W$(...t) {
  return t.length === 0 ? (e) => e : t.length === 1 ? t[0] : t.reduce((e, r) => (...n) => e(r(...n)));
}
function D6t(...t) {
  return (e) => (r, n) => {
    const a = e(r, n);
    let i = () => {
      throw new Error(Qa.env.NODE_ENV === "production" ? vc(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const o = {
      getState: a.getState,
      dispatch: (l, ...c) => i(l, ...c)
    }, s = t.map((l) => l(o));
    return i = W$(...s)(a.dispatch), {
      ...a,
      dispatch: i
    };
  };
}
function c1e(t) {
  return Th(t) && "type" in t && typeof t.type == "string";
}
var u1e = Symbol.for("immer-nothing"), x_ = Symbol.for("immer-draftable"), yd = Symbol.for("immer-state"), vWe = Ar.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(t) {
    return `The plugin for '${t}' has not been loaded into Immer. To enable the plugin, import and call \`enable${t}()\` when initializing your application.`;
  },
  function(t) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${t}'`;
  },
  "This object has been frozen and should not be mutated",
  function(t) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(t) {
    return `'current' expects a draft, got: ${t}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(t) {
    return `'original' expects a draft, got: ${t}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Cl(t, ...e) {
  if (Ar.env.NODE_ENV !== "production") {
    const r = vWe[t], n = typeof r == "function" ? r.apply(null, e) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Xb = Object.getPrototypeOf;
function Eh(t) {
  return !!t && !!t[yd];
}
function B1(t) {
  var e;
  return t ? yWe(t) || Array.isArray(t) || !!t[x_] || !!((e = t.constructor) != null && e[x_]) || EI(t) || II(t) : !1;
}
var L6t = Object.prototype.constructor.toString();
function yWe(t) {
  if (!t || typeof t != "object")
    return !1;
  const e = Xb(t);
  if (e === null)
    return !0;
  const r = Object.hasOwnProperty.call(e, "constructor") && e.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === L6t;
}
function j6t(t) {
  return Eh(t) || Cl(15, t), t[yd].base_;
}
function rk(t, e) {
  Qb(t) === 0 ? Reflect.ownKeys(t).forEach((r) => {
    e(r, t[r], t);
  }) : t.forEach((r, n) => e(n, r, t));
}
function Qb(t) {
  const e = t[yd];
  return e ? e.type_ : Array.isArray(t) ? 1 : EI(t) ? 2 : II(t) ? 3 : 0;
}
function nk(t, e) {
  return Qb(t) === 2 ? t.has(e) : Object.prototype.hasOwnProperty.call(t, e);
}
function yK(t, e) {
  return Qb(t) === 2 ? t.get(e) : t[e];
}
function bWe(t, e, r) {
  const n = Qb(t);
  n === 2 ? t.set(e, r) : n === 3 ? t.add(r) : t[e] = r;
}
function F6t(t, e) {
  return t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function EI(t) {
  return t instanceof Map;
}
function II(t) {
  return t instanceof Set;
}
function J3(t) {
  return t.copy_ || t.base_;
}
function gle(t, e) {
  if (EI(t))
    return new Map(t);
  if (II(t))
    return new Set(t);
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  const r = yWe(t);
  if (e === !0 || e === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(t);
    delete n[yd];
    let a = Reflect.ownKeys(n);
    for (let i = 0; i < a.length; i++) {
      const o = a[i], s = n[o];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[o] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: t[o]
      });
    }
    return Object.create(Xb(t), n);
  } else {
    const n = Xb(t);
    if (n !== null && r)
      return { ...t };
    const a = Object.create(n);
    return Object.assign(a, t);
  }
}
function d1e(t, e = !1) {
  return rz(t) || Eh(t) || !B1(t) || (Qb(t) > 1 && (t.set = t.add = t.clear = t.delete = z6t), Object.freeze(t), e && Object.entries(t).forEach(([r, n]) => d1e(n, !0))), t;
}
function z6t() {
  Cl(2);
}
function rz(t) {
  return Object.isFrozen(t);
}
var vle = {};
function e5(t) {
  const e = vle[t];
  return e || Cl(0, t), e;
}
function G6t(t, e) {
  vle[t] || (vle[t] = e);
}
var ak;
function xWe() {
  return ak;
}
function W6t(t, e) {
  return {
    drafts_: [],
    parent_: t,
    immer_: e,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function X5e(t, e) {
  e && (e5("Patches"), t.patches_ = [], t.inversePatches_ = [], t.patchListener_ = e);
}
function yle(t) {
  ble(t), t.drafts_.forEach(H6t), t.drafts_ = null;
}
function ble(t) {
  t === ak && (ak = t.parent_);
}
function Q5e(t) {
  return ak = W6t(ak, t);
}
function H6t(t) {
  const e = t[yd];
  e.type_ === 0 || e.type_ === 1 ? e.revoke_() : e.revoked_ = !0;
}
function e6e(t, e) {
  e.unfinalizedDrafts_ = e.drafts_.length;
  const r = e.drafts_[0];
  return t !== void 0 && t !== r ? (r[yd].modified_ && (yle(e), Cl(4)), B1(t) && (t = H$(e, t), e.parent_ || U$(e, t)), e.patches_ && e5("Patches").generateReplacementPatches_(
    r[yd].base_,
    t,
    e.patches_,
    e.inversePatches_
  )) : t = H$(e, r, []), yle(e), e.patches_ && e.patchListener_(e.patches_, e.inversePatches_), t !== u1e ? t : void 0;
}
function H$(t, e, r) {
  if (rz(e))
    return e;
  const n = e[yd];
  if (!n)
    return rk(
      e,
      (a, i) => t6e(t, n, e, a, i, r)
    ), e;
  if (n.scope_ !== t)
    return e;
  if (!n.modified_)
    return U$(t, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const a = n.copy_;
    let i = a, o = !1;
    n.type_ === 3 && (i = new Set(a), a.clear(), o = !0), rk(
      i,
      (s, l) => t6e(t, n, a, s, l, r, o)
    ), U$(t, a, !1), r && t.patches_ && e5("Patches").generatePatches_(
      n,
      r,
      t.patches_,
      t.inversePatches_
    );
  }
  return n.copy_;
}
function t6e(t, e, r, n, a, i, o) {
  if (Ar.env.NODE_ENV !== "production" && a === r && Cl(5), Eh(a)) {
    const s = i && e && e.type_ !== 3 && // Set objects are atomic since they have no keys.
    !nk(e.assigned_, n) ? i.concat(n) : void 0, l = H$(t, a, s);
    if (bWe(r, n, l), Eh(l))
      t.canAutoFreeze_ = !1;
    else
      return;
  } else o && r.add(a);
  if (B1(a) && !rz(a)) {
    if (!t.immer_.autoFreeze_ && t.unfinalizedDrafts_ < 1)
      return;
    H$(t, a), (!e || !e.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && U$(t, a);
  }
}
function U$(t, e, r = !1) {
  !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && d1e(e, r);
}
function U6t(t, e) {
  const r = Array.isArray(t), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: e ? e.scope_ : xWe(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: e,
    // The base state.
    base_: t,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let a = n, i = f1e;
  r && (a = [n], i = ik);
  const { revoke: o, proxy: s } = Proxy.revocable(a, i);
  return n.draft_ = s, n.revoke_ = o, s;
}
var f1e = {
  get(t, e) {
    if (e === yd)
      return t;
    const r = J3(t);
    if (!nk(r, e))
      return V6t(t, r, e);
    const n = r[e];
    return t.finalized_ || !B1(n) ? n : n === bK(t.base_, e) ? (xK(t), t.copy_[e] = Cle(n, t)) : n;
  },
  has(t, e) {
    return e in J3(t);
  },
  ownKeys(t) {
    return Reflect.ownKeys(J3(t));
  },
  set(t, e, r) {
    const n = CWe(J3(t), e);
    if (n != null && n.set)
      return n.set.call(t.draft_, r), !0;
    if (!t.modified_) {
      const a = bK(J3(t), e), i = a == null ? void 0 : a[yd];
      if (i && i.base_ === r)
        return t.copy_[e] = r, t.assigned_[e] = !1, !0;
      if (F6t(r, a) && (r !== void 0 || nk(t.base_, e)))
        return !0;
      xK(t), xle(t);
    }
    return t.copy_[e] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || e in t.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(t.copy_[e]) || (t.copy_[e] = r, t.assigned_[e] = !0), !0;
  },
  deleteProperty(t, e) {
    return bK(t.base_, e) !== void 0 || e in t.base_ ? (t.assigned_[e] = !1, xK(t), xle(t)) : delete t.assigned_[e], t.copy_ && delete t.copy_[e], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(t, e) {
    const r = J3(t), n = Reflect.getOwnPropertyDescriptor(r, e);
    return n && {
      writable: !0,
      configurable: t.type_ !== 1 || e !== "length",
      enumerable: n.enumerable,
      value: r[e]
    };
  },
  defineProperty() {
    Cl(11);
  },
  getPrototypeOf(t) {
    return Xb(t.base_);
  },
  setPrototypeOf() {
    Cl(12);
  }
}, ik = {};
rk(f1e, (t, e) => {
  ik[t] = function() {
    return arguments[0] = arguments[0][0], e.apply(this, arguments);
  };
});
ik.deleteProperty = function(t, e) {
  return Ar.env.NODE_ENV !== "production" && isNaN(parseInt(e)) && Cl(13), ik.set.call(this, t, e, void 0);
};
ik.set = function(t, e, r) {
  return Ar.env.NODE_ENV !== "production" && e !== "length" && isNaN(parseInt(e)) && Cl(14), f1e.set.call(this, t[0], e, r, t[0]);
};
function bK(t, e) {
  const r = t[yd];
  return (r ? J3(r) : t)[e];
}
function V6t(t, e, r) {
  var a;
  const n = CWe(e, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (a = n.get) == null ? void 0 : a.call(t.draft_)
  ) : void 0;
}
function CWe(t, e) {
  if (!(e in t))
    return;
  let r = Xb(t);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, e);
    if (n)
      return n;
    r = Xb(r);
  }
}
function xle(t) {
  t.modified_ || (t.modified_ = !0, t.parent_ && xle(t.parent_));
}
function xK(t) {
  t.copy_ || (t.copy_ = gle(
    t.base_,
    t.scope_.immer_.useStrictShallowCopy_
  ));
}
var q6t = class {
  constructor(t) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (e, r, n) => {
      if (typeof e == "function" && typeof r != "function") {
        const i = r;
        r = e;
        const o = this;
        return function(l = i, ...c) {
          return o.produce(l, (u) => r.call(this, u, ...c));
        };
      }
      typeof r != "function" && Cl(6), n !== void 0 && typeof n != "function" && Cl(7);
      let a;
      if (B1(e)) {
        const i = Q5e(this), o = Cle(e, void 0);
        let s = !0;
        try {
          a = r(o), s = !1;
        } finally {
          s ? yle(i) : ble(i);
        }
        return X5e(i, n), e6e(a, i);
      } else if (!e || typeof e != "object") {
        if (a = r(e), a === void 0 && (a = e), a === u1e && (a = void 0), this.autoFreeze_ && d1e(a, !0), n) {
          const i = [], o = [];
          e5("Patches").generateReplacementPatches_(e, a, i, o), n(i, o);
        }
        return a;
      } else
        Cl(1, e);
    }, this.produceWithPatches = (e, r) => {
      if (typeof e == "function")
        return (o, ...s) => this.produceWithPatches(o, (l) => e(l, ...s));
      let n, a;
      return [this.produce(e, r, (o, s) => {
        n = o, a = s;
      }), n, a];
    }, typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof (t == null ? void 0 : t.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  createDraft(t) {
    B1(t) || Cl(8), Eh(t) && (t = K6t(t));
    const e = Q5e(this), r = Cle(t, void 0);
    return r[yd].isManual_ = !0, ble(e), r;
  }
  finishDraft(t, e) {
    const r = t && t[yd];
    (!r || !r.isManual_) && Cl(9);
    const { scope_: n } = r;
    return X5e(n, e), e6e(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(t) {
    this.autoFreeze_ = t;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(t) {
    this.useStrictShallowCopy_ = t;
  }
  applyPatches(t, e) {
    let r;
    for (r = e.length - 1; r >= 0; r--) {
      const a = e[r];
      if (a.path.length === 0 && a.op === "replace") {
        t = a.value;
        break;
      }
    }
    r > -1 && (e = e.slice(r + 1));
    const n = e5("Patches").applyPatches_;
    return Eh(t) ? n(t, e) : this.produce(
      t,
      (a) => n(a, e)
    );
  }
};
function Cle(t, e) {
  const r = EI(t) ? e5("MapSet").proxyMap_(t, e) : II(t) ? e5("MapSet").proxySet_(t, e) : U6t(t, e);
  return (e ? e.scope_ : xWe()).drafts_.push(r), r;
}
function K6t(t) {
  return Eh(t) || Cl(10, t), wWe(t);
}
function wWe(t) {
  if (!B1(t) || rz(t))
    return t;
  const e = t[yd];
  let r;
  if (e) {
    if (!e.modified_)
      return e.base_;
    e.finalized_ = !0, r = gle(t, e.scope_.immer_.useStrictShallowCopy_);
  } else
    r = gle(t, !0);
  return rk(r, (n, a) => {
    bWe(r, n, wWe(a));
  }), e && (e.finalized_ = !1), r;
}
function Z6t() {
  Ar.env.NODE_ENV !== "production" && vWe.push(
    'Sets cannot have "replace" patches.',
    function(h) {
      return "Unsupported patch operation: " + h;
    },
    function(h) {
      return "Cannot apply patch, path doesn't resolve: " + h;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const e = "replace", r = "add", n = "remove";
  function a(h, p, g, y) {
    switch (h.type_) {
      case 0:
      case 2:
        return o(
          h,
          p,
          g,
          y
        );
      case 1:
        return i(h, p, g, y);
      case 3:
        return s(
          h,
          p,
          g,
          y
        );
    }
  }
  function i(h, p, g, y) {
    let { base_: b, assigned_: w } = h, _ = h.copy_;
    _.length < b.length && ([b, _] = [_, b], [g, y] = [y, g]);
    for (let C = 0; C < b.length; C++)
      if (w[C] && _[C] !== b[C]) {
        const x = p.concat([C]);
        g.push({
          op: e,
          path: x,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: f(_[C])
        }), y.push({
          op: e,
          path: x,
          value: f(b[C])
        });
      }
    for (let C = b.length; C < _.length; C++) {
      const x = p.concat([C]);
      g.push({
        op: r,
        path: x,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: f(_[C])
      });
    }
    for (let C = _.length - 1; b.length <= C; --C) {
      const x = p.concat([C]);
      y.push({
        op: n,
        path: x
      });
    }
  }
  function o(h, p, g, y) {
    const { base_: b, copy_: w } = h;
    rk(h.assigned_, (_, C) => {
      const x = yK(b, _), S = yK(w, _), A = C ? nk(b, _) ? e : r : n;
      if (x === S && A === e)
        return;
      const I = p.concat(_);
      g.push(A === n ? { op: A, path: I } : { op: A, path: I, value: S }), y.push(
        A === r ? { op: n, path: I } : A === n ? { op: r, path: I, value: f(x) } : { op: e, path: I, value: f(x) }
      );
    });
  }
  function s(h, p, g, y) {
    let { base_: b, copy_: w } = h, _ = 0;
    b.forEach((C) => {
      if (!w.has(C)) {
        const x = p.concat([_]);
        g.push({
          op: n,
          path: x,
          value: C
        }), y.unshift({
          op: r,
          path: x,
          value: C
        });
      }
      _++;
    }), _ = 0, w.forEach((C) => {
      if (!b.has(C)) {
        const x = p.concat([_]);
        g.push({
          op: r,
          path: x,
          value: C
        }), y.unshift({
          op: n,
          path: x,
          value: C
        });
      }
      _++;
    });
  }
  function l(h, p, g, y) {
    g.push({
      op: e,
      path: [],
      value: p === u1e ? void 0 : p
    }), y.push({
      op: e,
      path: [],
      value: h
    });
  }
  function c(h, p) {
    return p.forEach((g) => {
      const { path: y, op: b } = g;
      let w = h;
      for (let S = 0; S < y.length - 1; S++) {
        const A = Qb(w);
        let I = y[S];
        typeof I != "string" && typeof I != "number" && (I = "" + I), (A === 0 || A === 1) && (I === "__proto__" || I === "constructor") && Cl(19), typeof w == "function" && I === "prototype" && Cl(19), w = yK(w, I), typeof w != "object" && Cl(18, y.join("/"));
      }
      const _ = Qb(w), C = u(g.value), x = y[y.length - 1];
      switch (b) {
        case e:
          switch (_) {
            case 2:
              return w.set(x, C);
            case 3:
              Cl(16);
            default:
              return w[x] = C;
          }
        case r:
          switch (_) {
            case 1:
              return x === "-" ? w.push(C) : w.splice(x, 0, C);
            case 2:
              return w.set(x, C);
            case 3:
              return w.add(C);
            default:
              return w[x] = C;
          }
        case n:
          switch (_) {
            case 1:
              return w.splice(x, 1);
            case 2:
              return w.delete(x);
            case 3:
              return w.delete(g.value);
            default:
              return delete w[x];
          }
        default:
          Cl(17, b);
      }
    }), h;
  }
  function u(h) {
    if (!B1(h))
      return h;
    if (Array.isArray(h))
      return h.map(u);
    if (EI(h))
      return new Map(
        Array.from(h.entries()).map(([g, y]) => [g, u(y)])
      );
    if (II(h))
      return new Set(Array.from(h).map(u));
    const p = Object.create(Xb(h));
    for (const g in h)
      p[g] = u(h[g]);
    return nk(h, x_) && (p[x_] = h[x_]), p;
  }
  function f(h) {
    return Eh(h) ? u(h) : h;
  }
  G6t("Patches", {
    applyPatches_: c,
    generatePatches_: a,
    generateReplacementPatches_: l
  });
}
var h0 = new q6t(), MI = h0.produce, SWe = h0.produceWithPatches.bind(
  h0
);
h0.setAutoFreeze.bind(h0);
h0.setUseStrictShallowCopy.bind(h0);
var r6e = h0.applyPatches.bind(h0);
h0.createDraft.bind(h0);
h0.finishDraft.bind(h0);
var J6t = (t, e, r) => {
  if (e.length === 1 && e[0] === r) {
    let n = !1;
    try {
      const a = {};
      t(a) === a && (n = !0);
    } catch {
    }
    if (n) {
      let a;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: a } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: a }
      );
    }
  }
}, Y6t = (t, e, r) => {
  const { memoize: n, memoizeOptions: a } = e, { inputSelectorResults: i, inputSelectorResultsCopy: o } = t, s = n(() => ({}), ...a);
  if (!(s.apply(null, i) === s.apply(null, o))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: i,
        secondInputs: o,
        stack: c
      }
    );
  }
}, X6t = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function Q6t(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function e4t(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function t4t(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((r) => typeof r == "function")) {
    const r = t.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${e}[${r}]`);
  }
}
var n6e = (t) => Array.isArray(t) ? t : [t];
function r4t(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return t4t(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function a6e(t, e) {
  const r = [], { length: n } = t;
  for (let a = 0; a < n; a++)
    r.push(t[a].apply(null, e));
  return r;
}
var n4t = (t, e) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...X6t,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && t,
      run: J6t
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: Y6t
    }
  };
}, a4t = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, i4t = typeof WeakRef < "u" ? WeakRef : a4t, o4t = 0, i6e = 1;
function WO() {
  return {
    s: o4t,
    v: void 0,
    o: null,
    p: null
  };
}
function V$(t, e = {}) {
  let r = WO();
  const { resultEqualityCheck: n } = e;
  let a, i = 0;
  function o() {
    var f;
    let s = r;
    const { length: l } = arguments;
    for (let h = 0, p = l; h < p; h++) {
      const g = arguments[h];
      if (typeof g == "function" || typeof g == "object" && g !== null) {
        let y = s.o;
        y === null && (s.o = y = /* @__PURE__ */ new WeakMap());
        const b = y.get(g);
        b === void 0 ? (s = WO(), y.set(g, s)) : s = b;
      } else {
        let y = s.p;
        y === null && (s.p = y = /* @__PURE__ */ new Map());
        const b = y.get(g);
        b === void 0 ? (s = WO(), y.set(g, s)) : s = b;
      }
    }
    const c = s;
    let u;
    if (s.s === i6e)
      u = s.v;
    else if (u = t.apply(null, arguments), i++, n) {
      const h = ((f = a == null ? void 0 : a.deref) == null ? void 0 : f.call(a)) ?? a;
      h != null && n(h, u) && (u = h, i !== 0 && i--), a = typeof u == "object" && u !== null || typeof u == "function" ? new i4t(u) : u;
    }
    return c.s = i6e, c.v = u, u;
  }
  return o.clearCache = () => {
    r = WO(), o.resetResultsCount();
  }, o.resultsCount = () => i, o.resetResultsCount = () => {
    i = 0;
  }, o;
}
function s4t(t, ...e) {
  const r = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, n = (...a) => {
    let i = 0, o = 0, s, l = {}, c = a.pop();
    typeof c == "object" && (l = c, c = a.pop()), Q6t(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...r,
      ...l
    }, {
      memoize: f,
      memoizeOptions: h = [],
      argsMemoize: p = V$,
      argsMemoizeOptions: g = [],
      devModeChecks: y = {}
    } = u, b = n6e(h), w = n6e(g), _ = r4t(a), C = f(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...b);
    let x = !0;
    const S = p(function() {
      o++;
      const I = a6e(
        _,
        arguments
      );
      if (s = C.apply(null, I), Qa.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: M, inputStabilityCheck: B } = n4t(x, y);
        if (M.shouldRun && M.run(
          c,
          I,
          s
        ), B.shouldRun) {
          const L = a6e(
            _,
            arguments
          );
          B.run(
            { inputSelectorResults: I, inputSelectorResultsCopy: L },
            { memoize: f, memoizeOptions: b },
            arguments
          );
        }
        x && (x = !1);
      }
      return s;
    }, ...w);
    return Object.assign(S, {
      resultFunc: c,
      memoizedResultFunc: C,
      dependencies: _,
      dependencyRecomputations: () => o,
      resetDependencyRecomputations: () => {
        o = 0;
      },
      lastResult: () => s,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: f,
      argsMemoize: p
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var h1e = /* @__PURE__ */ s4t(V$), l4t = Object.assign(
  (t, e = h1e) => {
    e4t(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const r = Object.keys(t), n = r.map(
      (i) => t[i]
    );
    return e(
      n,
      (...i) => i.reduce((o, s, l) => (o[r[l]] = s, o), {})
    );
  },
  { withTypes: () => l4t }
);
function _We(t) {
  return ({ dispatch: r, getState: n }) => (a) => (i) => typeof i == "function" ? i(r, n, t) : a(i);
}
var c4t = _We(), u4t = _We, d4t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? W$ : W$.apply(null, arguments);
}, kWe = (t) => t && typeof t.match == "function";
function C1(t, e) {
  function r(...n) {
    if (e) {
      let a = e(...n);
      if (!a)
        throw new Error(Ar.env.NODE_ENV === "production" ? go(0) : "prepareAction did not return an object");
      return {
        type: t,
        payload: a.payload,
        ..."meta" in a && {
          meta: a.meta
        },
        ..."error" in a && {
          error: a.error
        }
      };
    }
    return {
      type: t,
      payload: n[0]
    };
  }
  return r.toString = () => `${t}`, r.type = t, r.match = (n) => c1e(n) && n.type === t, r;
}
function f4t(t) {
  return typeof t == "function" && "type" in t && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  kWe(t);
}
function h4t(t) {
  const e = t ? `${t}`.split("/") : [], r = e[e.length - 1] || "actionCreator";
  return `Detected an action creator with type "${t || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`;
}
function p4t(t = {}) {
  if (Ar.env.NODE_ENV === "production")
    return () => (r) => (n) => r(n);
  const {
    isActionCreator: e = f4t
  } = t;
  return () => (r) => (n) => (e(n) && console.warn(h4t(n.type)), r(n));
}
function AWe(t, e) {
  let r = 0;
  return {
    measureTime(n) {
      const a = Date.now();
      try {
        return n();
      } finally {
        const i = Date.now();
        r += i - a;
      }
    },
    warnIfExceeded() {
      r > t && console.warn(`${e} took ${r}ms, which is more than the warning threshold of ${t}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var TWe = class kS extends Array {
  constructor(...e) {
    super(...e), Object.setPrototypeOf(this, kS.prototype);
  }
  static get [Symbol.species]() {
    return kS;
  }
  concat(...e) {
    return super.concat.apply(this, e);
  }
  prepend(...e) {
    return e.length === 1 && Array.isArray(e[0]) ? new kS(...e[0].concat(this)) : new kS(...e.concat(this));
  }
};
function o6e(t) {
  return B1(t) ? MI(t, () => {
  }) : t;
}
function s6e(t, e, r) {
  return t.has(e) ? t.get(e) : t.set(e, r(e)).get(e);
}
function m4t(t) {
  return typeof t != "object" || t == null || Object.isFrozen(t);
}
function g4t(t, e, r) {
  const n = EWe(t, e, r);
  return {
    detectMutations() {
      return IWe(t, e, n, r);
    }
  };
}
function EWe(t, e = [], r, n = "", a = /* @__PURE__ */ new Set()) {
  const i = {
    value: r
  };
  if (!t(r) && !a.has(r)) {
    a.add(r), i.children = {};
    for (const o in r) {
      const s = n ? n + "." + o : o;
      e.length && e.indexOf(s) !== -1 || (i.children[o] = EWe(t, e, r[o], s));
    }
  }
  return i;
}
function IWe(t, e = [], r, n, a = !1, i = "") {
  const o = r ? r.value : void 0, s = o === n;
  if (a && !s && !Number.isNaN(n))
    return {
      wasMutated: !0,
      path: i
    };
  if (t(o) || t(n))
    return {
      wasMutated: !1
    };
  const l = {};
  for (let u in r.children)
    l[u] = !0;
  for (let u in n)
    l[u] = !0;
  const c = e.length > 0;
  for (let u in l) {
    const f = i ? i + "." + u : u;
    if (c && e.some((g) => g instanceof RegExp ? g.test(f) : f === g))
      continue;
    const h = IWe(t, e, r.children[u], n[u], s, f);
    if (h.wasMutated)
      return h;
  }
  return {
    wasMutated: !1
  };
}
function v4t(t = {}) {
  if (Ar.env.NODE_ENV === "production")
    return () => (e) => (r) => e(r);
  {
    let e = function(s, l, c, u) {
      return JSON.stringify(s, r(l, u), c);
    }, r = function(s, l) {
      let c = [], u = [];
      return l || (l = function(f, h) {
        return c[0] === h ? "[Circular ~]" : "[Circular ~." + u.slice(0, c.indexOf(h)).join(".") + "]";
      }), function(f, h) {
        if (c.length > 0) {
          var p = c.indexOf(this);
          ~p ? c.splice(p + 1) : c.push(this), ~p ? u.splice(p, 1 / 0, f) : u.push(f), ~c.indexOf(h) && (h = l.call(this, f, h));
        } else c.push(h);
        return s == null ? h : s.call(this, f, h);
      };
    }, {
      isImmutable: n = m4t,
      ignoredPaths: a,
      warnAfter: i = 32
    } = t;
    const o = g4t.bind(null, n, a);
    return ({
      getState: s
    }) => {
      let l = s(), c = o(l), u;
      return (f) => (h) => {
        const p = AWe(i, "ImmutableStateInvariantMiddleware");
        p.measureTime(() => {
          if (l = s(), u = c.detectMutations(), c = o(l), u.wasMutated)
            throw new Error(Ar.env.NODE_ENV === "production" ? go(19) : `A state mutation was detected between dispatches, in the path '${u.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const g = f(h);
        return p.measureTime(() => {
          if (l = s(), u = c.detectMutations(), c = o(l), u.wasMutated)
            throw new Error(Ar.env.NODE_ENV === "production" ? go(20) : `A state mutation was detected inside a dispatch, in the path: ${u.path || ""}. Take a look at the reducer(s) handling the action ${e(h)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), p.warnIfExceeded(), g;
      };
    };
  }
}
function MWe(t) {
  const e = typeof t;
  return t == null || e === "string" || e === "boolean" || e === "number" || Array.isArray(t) || Th(t);
}
function wle(t, e = "", r = MWe, n, a = [], i) {
  let o;
  if (!r(t))
    return {
      keyPath: e || "<root>",
      value: t
    };
  if (typeof t != "object" || t === null || i != null && i.has(t)) return !1;
  const s = n != null ? n(t) : Object.entries(t), l = a.length > 0;
  for (const [c, u] of s) {
    const f = e ? e + "." + c : c;
    if (!(l && a.some((p) => p instanceof RegExp ? p.test(f) : f === p))) {
      if (!r(u))
        return {
          keyPath: f,
          value: u
        };
      if (typeof u == "object" && (o = wle(u, f, r, n, a, i), o))
        return o;
    }
  }
  return i && PWe(t) && i.add(t), !1;
}
function PWe(t) {
  if (!Object.isFrozen(t)) return !1;
  for (const e of Object.values(t))
    if (!(typeof e != "object" || e === null) && !PWe(e))
      return !1;
  return !0;
}
function y4t(t = {}) {
  if (Ar.env.NODE_ENV === "production")
    return () => (e) => (r) => e(r);
  {
    const {
      isSerializable: e = MWe,
      getEntries: r,
      ignoredActions: n = [],
      ignoredActionPaths: a = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: i = [],
      warnAfter: o = 32,
      ignoreState: s = !1,
      ignoreActions: l = !1,
      disableCache: c = !1
    } = t, u = !c && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (f) => (h) => (p) => {
      if (!c1e(p))
        return h(p);
      const g = h(p), y = AWe(o, "SerializableStateInvariantMiddleware");
      return !l && !(n.length && n.indexOf(p.type) !== -1) && y.measureTime(() => {
        const b = wle(p, "", e, r, a, u);
        if (b) {
          const {
            keyPath: w,
            value: _
          } = b;
          console.error(`A non-serializable value was detected in an action, in the path: \`${w}\`. Value:`, _, `
Take a look at the logic that dispatched this action: `, p, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), s || (y.measureTime(() => {
        const b = f.getState(), w = wle(b, "", e, r, i, u);
        if (w) {
          const {
            keyPath: _,
            value: C
          } = w;
          console.error(`A non-serializable value was detected in the state, in the path: \`${_}\`. Value:`, C, `
Take a look at the reducer(s) handling this action type: ${p.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), y.warnIfExceeded()), g;
    };
  }
}
function HO(t) {
  return typeof t == "boolean";
}
var b4t = () => function(e) {
  const {
    thunk: r = !0,
    immutableCheck: n = !0,
    serializableCheck: a = !0,
    actionCreatorCheck: i = !0
  } = e ?? {};
  let o = new TWe();
  if (r && (HO(r) ? o.push(c4t) : o.push(u4t(r.extraArgument))), Ar.env.NODE_ENV !== "production") {
    if (n) {
      let s = {};
      HO(n) || (s = n), o.unshift(v4t(s));
    }
    if (a) {
      let s = {};
      HO(a) || (s = a), o.push(y4t(s));
    }
    if (i) {
      let s = {};
      HO(i) || (s = i), o.unshift(p4t(s));
    }
  }
  return o;
}, nz = "RTK_autoBatch", zw = () => (t) => ({
  payload: t,
  meta: {
    [nz]: !0
  }
}), l6e = (t) => (e) => {
  setTimeout(e, t);
}, x4t = (t = {
  type: "raf"
}) => (e) => (...r) => {
  const n = e(...r);
  let a = !0, i = !1, o = !1;
  const s = /* @__PURE__ */ new Set(), l = t.type === "tick" ? queueMicrotask : t.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : l6e(10)
  ) : t.type === "callback" ? t.queueNotification : l6e(t.timeout), c = () => {
    o = !1, i && (i = !1, s.forEach((u) => u()));
  };
  return Object.assign({}, n, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(u) {
      const f = () => a && u(), h = n.subscribe(f);
      return s.add(u), () => {
        h(), s.delete(u);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(u) {
      var f;
      try {
        return a = !((f = u == null ? void 0 : u.meta) != null && f[nz]), i = !a, i && (o || (o = !0, l(c))), n.dispatch(u);
      } finally {
        a = !0;
      }
    }
  });
}, C4t = (t) => function(r) {
  const {
    autoBatch: n = !0
  } = r ?? {};
  let a = new TWe(t);
  return n && a.push(x4t(typeof n == "object" ? n : void 0)), a;
};
function w4t(t) {
  const e = b4t(), {
    reducer: r = void 0,
    middleware: n,
    devTools: a = !0,
    preloadedState: i = void 0,
    enhancers: o = void 0
  } = t || {};
  let s;
  if (typeof r == "function")
    s = r;
  else if (Th(r))
    s = gWe(r);
  else
    throw new Error(Ar.env.NODE_ENV === "production" ? go(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (Ar.env.NODE_ENV !== "production" && n && typeof n != "function")
    throw new Error(Ar.env.NODE_ENV === "production" ? go(2) : "`middleware` field must be a callback");
  let l;
  if (typeof n == "function") {
    if (l = n(e), Ar.env.NODE_ENV !== "production" && !Array.isArray(l))
      throw new Error(Ar.env.NODE_ENV === "production" ? go(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    l = e();
  if (Ar.env.NODE_ENV !== "production" && l.some((g) => typeof g != "function"))
    throw new Error(Ar.env.NODE_ENV === "production" ? go(4) : "each middleware provided to configureStore must be a function");
  let c = W$;
  a && (c = d4t({
    // Enable capture of stack traces for dispatched Redux actions
    trace: Ar.env.NODE_ENV !== "production",
    ...typeof a == "object" && a
  }));
  const u = D6t(...l), f = C4t(u);
  if (Ar.env.NODE_ENV !== "production" && o && typeof o != "function")
    throw new Error(Ar.env.NODE_ENV === "production" ? go(5) : "`enhancers` field must be a callback");
  let h = typeof o == "function" ? o(f) : f();
  if (Ar.env.NODE_ENV !== "production" && !Array.isArray(h))
    throw new Error(Ar.env.NODE_ENV === "production" ? go(6) : "`enhancers` callback must return an array");
  if (Ar.env.NODE_ENV !== "production" && h.some((g) => typeof g != "function"))
    throw new Error(Ar.env.NODE_ENV === "production" ? go(7) : "each enhancer provided to configureStore must be a function");
  Ar.env.NODE_ENV !== "production" && l.length && !h.includes(u) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const p = c(...h);
  return mWe(s, i, p);
}
function RWe(t) {
  const e = {}, r = [];
  let n;
  const a = {
    addCase(i, o) {
      if (Ar.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(Ar.env.NODE_ENV === "production" ? go(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(Ar.env.NODE_ENV === "production" ? go(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const s = typeof i == "string" ? i : i.type;
      if (!s)
        throw new Error(Ar.env.NODE_ENV === "production" ? go(28) : "`builder.addCase` cannot be called with an empty action type");
      if (s in e)
        throw new Error(Ar.env.NODE_ENV === "production" ? go(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${s}'`);
      return e[s] = o, a;
    },
    addMatcher(i, o) {
      if (Ar.env.NODE_ENV !== "production" && n)
        throw new Error(Ar.env.NODE_ENV === "production" ? go(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: i,
        reducer: o
      }), a;
    },
    addDefaultCase(i) {
      if (Ar.env.NODE_ENV !== "production" && n)
        throw new Error(Ar.env.NODE_ENV === "production" ? go(31) : "`builder.addDefaultCase` can only be called once");
      return n = i, a;
    }
  };
  return t(a), [e, r, n];
}
function S4t(t) {
  return typeof t == "function";
}
function _4t(t, e) {
  if (Ar.env.NODE_ENV !== "production" && typeof e == "object")
    throw new Error(Ar.env.NODE_ENV === "production" ? go(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, a] = RWe(e), i;
  if (S4t(t))
    i = () => o6e(t());
  else {
    const s = o6e(t);
    i = () => s;
  }
  function o(s = i(), l) {
    let c = [r[l.type], ...n.filter(({
      matcher: u
    }) => u(l)).map(({
      reducer: u
    }) => u)];
    return c.filter((u) => !!u).length === 0 && (c = [a]), c.reduce((u, f) => {
      if (f)
        if (Eh(u)) {
          const p = f(u, l);
          return p === void 0 ? u : p;
        } else {
          if (B1(u))
            return MI(u, (h) => f(h, l));
          {
            const h = f(u, l);
            if (h === void 0) {
              if (u === null)
                return u;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return h;
          }
        }
      return u;
    }, s);
  }
  return o.getInitialState = i, o;
}
var OWe = (t, e) => kWe(t) ? t.match(e) : t(e);
function Nm(...t) {
  return (e) => t.some((r) => OWe(r, e));
}
function C_(...t) {
  return (e) => t.every((r) => OWe(r, e));
}
function az(t, e) {
  if (!t || !t.meta) return !1;
  const r = typeof t.meta.requestId == "string", n = e.indexOf(t.meta.requestStatus) > -1;
  return r && n;
}
function PI(t) {
  return typeof t[0] == "function" && "pending" in t[0] && "fulfilled" in t[0] && "rejected" in t[0];
}
function p1e(...t) {
  return t.length === 0 ? (e) => az(e, ["pending"]) : PI(t) ? Nm(...t.map((e) => e.pending)) : p1e()(t[0]);
}
function B7(...t) {
  return t.length === 0 ? (e) => az(e, ["rejected"]) : PI(t) ? Nm(...t.map((e) => e.rejected)) : B7()(t[0]);
}
function iz(...t) {
  const e = (r) => r && r.meta && r.meta.rejectedWithValue;
  return t.length === 0 ? C_(B7(...t), e) : PI(t) ? C_(B7(...t), e) : iz()(t[0]);
}
function Uv(...t) {
  return t.length === 0 ? (e) => az(e, ["fulfilled"]) : PI(t) ? Nm(...t.map((e) => e.fulfilled)) : Uv()(t[0]);
}
function Sle(...t) {
  return t.length === 0 ? (e) => az(e, ["pending", "fulfilled", "rejected"]) : PI(t) ? Nm(...t.flatMap((e) => [e.pending, e.rejected, e.fulfilled])) : Sle()(t[0]);
}
var k4t = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", m1e = (t = 21) => {
  let e = "", r = t;
  for (; r--; )
    e += k4t[Math.random() * 64 | 0];
  return e;
}, A4t = ["name", "message", "stack", "code"], CK = class {
  constructor(t, e) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Za(this, "_type");
    this.payload = t, this.meta = e;
  }
}, c6e = class {
  constructor(t, e) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Za(this, "_type");
    this.payload = t, this.meta = e;
  }
}, T4t = (t) => {
  if (typeof t == "object" && t !== null) {
    const e = {};
    for (const r of A4t)
      typeof t[r] == "string" && (e[r] = t[r]);
    return e;
  }
  return {
    message: String(t)
  };
}, u6e = /* @__PURE__ */ (() => {
  function t(e, r, n) {
    const a = C1(e + "/fulfilled", (l, c, u, f) => ({
      payload: l,
      meta: {
        ...f || {},
        arg: u,
        requestId: c,
        requestStatus: "fulfilled"
      }
    })), i = C1(e + "/pending", (l, c, u) => ({
      payload: void 0,
      meta: {
        ...u || {},
        arg: c,
        requestId: l,
        requestStatus: "pending"
      }
    })), o = C1(e + "/rejected", (l, c, u, f, h) => ({
      payload: f,
      error: (n && n.serializeError || T4t)(l || "Rejected"),
      meta: {
        ...h || {},
        arg: u,
        requestId: c,
        rejectedWithValue: !!f,
        requestStatus: "rejected",
        aborted: (l == null ? void 0 : l.name) === "AbortError",
        condition: (l == null ? void 0 : l.name) === "ConditionError"
      }
    }));
    function s(l) {
      return (c, u, f) => {
        const h = n != null && n.idGenerator ? n.idGenerator(l) : m1e(), p = new AbortController();
        let g, y;
        function b(_) {
          y = _, p.abort();
        }
        const w = async function() {
          var x, S;
          let _;
          try {
            let A = (x = n == null ? void 0 : n.condition) == null ? void 0 : x.call(n, l, {
              getState: u,
              extra: f
            });
            if (I4t(A) && (A = await A), A === !1 || p.signal.aborted)
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            const I = new Promise((M, B) => {
              g = () => {
                B({
                  name: "AbortError",
                  message: y || "Aborted"
                });
              }, p.signal.addEventListener("abort", g);
            });
            c(i(h, l, (S = n == null ? void 0 : n.getPendingMeta) == null ? void 0 : S.call(n, {
              requestId: h,
              arg: l
            }, {
              getState: u,
              extra: f
            }))), _ = await Promise.race([I, Promise.resolve(r(l, {
              dispatch: c,
              getState: u,
              extra: f,
              requestId: h,
              signal: p.signal,
              abort: b,
              rejectWithValue: (M, B) => new CK(M, B),
              fulfillWithValue: (M, B) => new c6e(M, B)
            })).then((M) => {
              if (M instanceof CK)
                throw M;
              return M instanceof c6e ? a(M.payload, h, l, M.meta) : a(M, h, l);
            })]);
          } catch (A) {
            _ = A instanceof CK ? o(null, h, l, A.payload, A.meta) : o(A, h, l);
          } finally {
            g && p.signal.removeEventListener("abort", g);
          }
          return n && !n.dispatchConditionRejection && o.match(_) && _.meta.condition || c(_), _;
        }();
        return Object.assign(w, {
          abort: b,
          requestId: h,
          arg: l,
          unwrap() {
            return w.then(E4t);
          }
        });
      };
    }
    return Object.assign(s, {
      pending: i,
      rejected: o,
      fulfilled: a,
      settled: Nm(o, a),
      typePrefix: e
    });
  }
  return t.withTypes = () => t, t;
})();
function E4t(t) {
  if (t.meta && t.meta.rejectedWithValue)
    throw t.payload;
  if (t.error)
    throw t.error;
  return t.payload;
}
function I4t(t) {
  return t !== null && typeof t == "object" && typeof t.then == "function";
}
var M4t = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function P4t(t, e) {
  return `${t}/${e}`;
}
function R4t({
  creators: t
} = {}) {
  var r;
  const e = (r = t == null ? void 0 : t.asyncThunk) == null ? void 0 : r[M4t];
  return function(a) {
    const {
      name: i,
      reducerPath: o = i
    } = a;
    if (!i)
      throw new Error(Ar.env.NODE_ENV === "production" ? go(11) : "`name` is a required option for createSlice");
    typeof Ar < "u" && Ar.env.NODE_ENV === "development" && a.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const s = (typeof a.reducers == "function" ? a.reducers(B4t()) : a.reducers) || {}, l = Object.keys(s), c = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, u = {
      addCase(C, x) {
        const S = typeof C == "string" ? C : C.type;
        if (!S)
          throw new Error(Ar.env.NODE_ENV === "production" ? go(12) : "`context.addCase` cannot be called with an empty action type");
        if (S in c.sliceCaseReducersByType)
          throw new Error(Ar.env.NODE_ENV === "production" ? go(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + S);
        return c.sliceCaseReducersByType[S] = x, u;
      },
      addMatcher(C, x) {
        return c.sliceMatchers.push({
          matcher: C,
          reducer: x
        }), u;
      },
      exposeAction(C, x) {
        return c.actionCreators[C] = x, u;
      },
      exposeCaseReducer(C, x) {
        return c.sliceCaseReducersByName[C] = x, u;
      }
    };
    l.forEach((C) => {
      const x = s[C], S = {
        reducerName: C,
        type: P4t(i, C),
        createNotation: typeof a.reducers == "function"
      };
      $4t(x) ? L4t(S, x, u, e) : N4t(S, x, u);
    });
    function f() {
      if (Ar.env.NODE_ENV !== "production" && typeof a.extraReducers == "object")
        throw new Error(Ar.env.NODE_ENV === "production" ? go(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [C = {}, x = [], S = void 0] = typeof a.extraReducers == "function" ? RWe(a.extraReducers) : [a.extraReducers], A = {
        ...C,
        ...c.sliceCaseReducersByType
      };
      return _4t(a.initialState, (I) => {
        for (let M in A)
          I.addCase(M, A[M]);
        for (let M of c.sliceMatchers)
          I.addMatcher(M.matcher, M.reducer);
        for (let M of x)
          I.addMatcher(M.matcher, M.reducer);
        S && I.addDefaultCase(S);
      });
    }
    const h = (C) => C, p = /* @__PURE__ */ new Map();
    let g;
    function y(C, x) {
      return g || (g = f()), g(C, x);
    }
    function b() {
      return g || (g = f()), g.getInitialState();
    }
    function w(C, x = !1) {
      function S(I) {
        let M = I[C];
        if (typeof M > "u") {
          if (x)
            M = b();
          else if (Ar.env.NODE_ENV !== "production")
            throw new Error(Ar.env.NODE_ENV === "production" ? go(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return M;
      }
      function A(I = h) {
        const M = s6e(p, x, () => /* @__PURE__ */ new WeakMap());
        return s6e(M, I, () => {
          const B = {};
          for (const [L, N] of Object.entries(a.selectors ?? {}))
            B[L] = O4t(N, I, b, x);
          return B;
        });
      }
      return {
        reducerPath: C,
        getSelectors: A,
        get selectors() {
          return A(S);
        },
        selectSlice: S
      };
    }
    const _ = {
      name: i,
      reducer: y,
      actions: c.actionCreators,
      caseReducers: c.sliceCaseReducersByName,
      getInitialState: b,
      ...w(o),
      injectInto(C, {
        reducerPath: x,
        ...S
      } = {}) {
        const A = x ?? o;
        return C.inject({
          reducerPath: A,
          reducer: y
        }, S), {
          ..._,
          ...w(A, !0)
        };
      }
    };
    return _;
  };
}
function O4t(t, e, r, n) {
  function a(i, ...o) {
    let s = e(i);
    if (typeof s > "u") {
      if (n)
        s = r();
      else if (Ar.env.NODE_ENV !== "production")
        throw new Error(Ar.env.NODE_ENV === "production" ? go(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return t(s, ...o);
  }
  return a.unwrapped = t, a;
}
var u1 = /* @__PURE__ */ R4t();
function B4t() {
  function t(e, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: e,
      ...r
    };
  }
  return t.withTypes = () => t, {
    reducer(e) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [e.name](...r) {
          return e(...r);
        }
      }[e.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(e, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: e,
        reducer: r
      };
    },
    asyncThunk: t
  };
}
function N4t({
  type: t,
  reducerName: e,
  createNotation: r
}, n, a) {
  let i, o;
  if ("reducer" in n) {
    if (r && !D4t(n))
      throw new Error(Ar.env.NODE_ENV === "production" ? go(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    i = n.reducer, o = n.prepare;
  } else
    i = n;
  a.addCase(t, i).exposeCaseReducer(e, i).exposeAction(e, o ? C1(t, o) : C1(t));
}
function $4t(t) {
  return t._reducerDefinitionType === "asyncThunk";
}
function D4t(t) {
  return t._reducerDefinitionType === "reducerWithPrepare";
}
function L4t({
  type: t,
  reducerName: e
}, r, n, a) {
  if (!a)
    throw new Error(Ar.env.NODE_ENV === "production" ? go(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: i,
    fulfilled: o,
    pending: s,
    rejected: l,
    settled: c,
    options: u
  } = r, f = a(t, i, u);
  n.exposeAction(e, f), o && n.addCase(f.fulfilled, o), s && n.addCase(f.pending, s), l && n.addCase(f.rejected, l), c && n.addMatcher(f.settled, c), n.exposeCaseReducer(e, {
    fulfilled: o || UO,
    pending: s || UO,
    rejected: l || UO,
    settled: c || UO
  });
}
function UO() {
}
function go(t) {
  return `Minified Redux Toolkit error #${t}; visit https://redux-toolkit.js.org/Errors?code=${t} for the full message or use the non-minified dev environment for full errors. `;
}
const j4t = {
  user: {
    firstName: "",
    lastName: ""
  },
  applicationId: "",
  systemContext: {},
  ingress: "osc",
  displayName: ""
}, BWe = u1({
  name: "config",
  initialState: j4t,
  reducers: {
    setConfig: (t, e) => {
      t.user = e.payload.user, t.applicationId = e.payload.applicationId, t.systemContext = e.payload.systemContext, t.ingress = e.payload.ingress, t.displayName = e.payload.displayName, t.surveyId = e.payload.surveyId;
    }
  }
}), { setConfig: F4t } = BWe.actions, z4t = BWe.reducer, N7 = {
  Idle: "Idle",
  Loading: "Loading",
  Error: "Error"
}, Bp = {
  conversationId: void 0,
  messages: [],
  partialUserMessage: null,
  partialAssistantMessage: null,
  loadingMessages: [],
  status: N7.Idle,
  retryAttempts: 0,
  canvasContents: "",
  isCanvasOpen: !1,
  canvasId: null,
  liveChatId: null,
  isTransferring: !1,
  transfer: null,
  chatId: void 0
}, NWe = u1({
  name: "conversation",
  initialState: Bp,
  reducers: {
    setConversationId: (t, e) => {
      e.payload !== t.conversationId && (t.conversationId = e.payload, t.messages = Bp.messages, t.partialUserMessage = Bp.partialUserMessage, t.partialAssistantMessage = Bp.partialAssistantMessage, t.loadingMessages = Bp.loadingMessages, t.status = Bp.status, t.canvasContents = Bp.canvasContents, t.canvasId = Bp.canvasId, t.isCanvasOpen = Bp.isCanvasOpen, t.liveChatId = null, t.isTransferring = !1);
    },
    setConversationChatId: (t, e) => {
      t.chatId = e.payload;
    },
    setMessages(t, e) {
      t.messages = e.payload;
    },
    appendMessage(t, e) {
      t.messages.push(e.payload);
    },
    setPartialUserMessage(t, e) {
      t.partialUserMessage = e.payload;
    },
    setPartialAssistantMessage(t, e) {
      t.partialAssistantMessage = e.payload;
    },
    setLoadingMessages(t, e) {
      t.loadingMessages = e.payload;
    },
    addLoadingMessage(t, e) {
      t.loadingMessages.push(e.payload);
    },
    setStatus(t, e) {
      t.status = e.payload;
    },
    setRetryAttempts(t, e) {
      t.retryAttempts = e.payload;
    },
    incrementRetryAttempts(t) {
      t.retryAttempts += 1;
    },
    setCanvasContents(t, e) {
      t.canvasContents = e.payload;
    },
    setIsCanvasOpen(t, e) {
      t.isCanvasOpen = e.payload;
    },
    setCanvasId(t, e) {
      t.canvasId = e.payload;
    },
    setIsTransferring(t, e) {
      t.isTransferring = e.payload;
    },
    setLiveChatId(t, e) {
      t.liveChatId = e.payload;
    },
    setTransfer(t, e) {
      t.transfer = e.payload;
    }
  }
}), {
  setMessages: G4t,
  setPartialUserMessage: $We,
  setPartialAssistantMessage: q$,
  setConversationId: _le,
  setLoadingMessages: AS,
  setStatus: kle,
  addLoadingMessage: Wmn,
  setRetryAttempts: W4t,
  incrementRetryAttempts: H4t,
  setCanvasContents: g1e,
  setIsCanvasOpen: oz,
  setCanvasId: DWe,
  setLiveChatId: v1e,
  setIsTransferring: K$,
  appendMessage: d6e,
  setTransfer: U4t,
  setConversationChatId: LWe
} = NWe.actions, V4t = NWe.reducer;
var VO = { exports: {} }, wK = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f6e;
function q4t() {
  if (f6e) return wK;
  f6e = 1;
  var t = Te;
  function e(l, c) {
    return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useSyncExternalStore, a = t.useRef, i = t.useEffect, o = t.useMemo, s = t.useDebugValue;
  return wK.useSyncExternalStoreWithSelector = function(l, c, u, f, h) {
    var p = a(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else g = p.current;
    p = o(
      function() {
        function b(S) {
          if (!w) {
            if (w = !0, _ = S, S = f(S), h !== void 0 && g.hasValue) {
              var A = g.value;
              if (h(A, S))
                return C = A;
            }
            return C = S;
          }
          if (A = C, r(_, S)) return A;
          var I = f(S);
          return h !== void 0 && h(A, I) ? (_ = S, A) : (_ = S, C = I);
        }
        var w = !1, _, C, x = u === void 0 ? null : u;
        return [
          function() {
            return b(c());
          },
          x === null ? void 0 : function() {
            return b(x());
          }
        ];
      },
      [c, u, f, h]
    );
    var y = n(l, p[0], p[1]);
    return i(
      function() {
        g.hasValue = !0, g.value = y;
      },
      [y]
    ), s(y), y;
  }, wK;
}
var SK = {}, h6e;
function K4t() {
  return h6e || (h6e = 1, Qa.env.NODE_ENV !== "production" && function() {
    function t(l, c) {
      return l === c && (l !== 0 || 1 / l === 1 / c) || l !== l && c !== c;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Te, r = typeof Object.is == "function" ? Object.is : t, n = e.useSyncExternalStore, a = e.useRef, i = e.useEffect, o = e.useMemo, s = e.useDebugValue;
    SK.useSyncExternalStoreWithSelector = function(l, c, u, f, h) {
      var p = a(null);
      if (p.current === null) {
        var g = { hasValue: !1, value: null };
        p.current = g;
      } else g = p.current;
      p = o(
        function() {
          function b(S) {
            if (!w) {
              if (w = !0, _ = S, S = f(S), h !== void 0 && g.hasValue) {
                var A = g.value;
                if (h(A, S))
                  return C = A;
              }
              return C = S;
            }
            if (A = C, r(_, S))
              return A;
            var I = f(S);
            return h !== void 0 && h(A, I) ? (_ = S, A) : (_ = S, C = I);
          }
          var w = !1, _, C, x = u === void 0 ? null : u;
          return [
            function() {
              return b(c());
            },
            x === null ? void 0 : function() {
              return b(x());
            }
          ];
        },
        [c, u, f, h]
      );
      var y = n(l, p[0], p[1]);
      return i(
        function() {
          g.hasValue = !0, g.value = y;
        },
        [y]
      ), s(y), y;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), SK;
}
var p6e;
function Z4t() {
  return p6e || (p6e = 1, Qa.env.NODE_ENV === "production" ? VO.exports = q4t() : VO.exports = K4t()), VO.exports;
}
var J4t = Z4t(), i0 = (
  // prettier-ignore
  // @ts-ignore
  "default" in P ? P.default : P
), m6e = Symbol.for("react-redux-context"), g6e = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Y4t() {
  if (!i0.createContext)
    return {};
  const t = g6e[m6e] ?? (g6e[m6e] = /* @__PURE__ */ new Map());
  let e = t.get(i0.createContext);
  return e || (e = i0.createContext(
    null
  ), Ar.env.NODE_ENV !== "production" && (e.displayName = "ReactRedux"), t.set(i0.createContext, e)), e;
}
var Vv = /* @__PURE__ */ Y4t(), X4t = () => {
  throw new Error("uSES not initialized!");
};
function y1e(t = Vv) {
  return function() {
    const r = i0.useContext(t);
    if (Ar.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var jWe = /* @__PURE__ */ y1e(), FWe = X4t, Q4t = (t) => {
  FWe = t;
}, e9t = (t, e) => t === e;
function t9t(t = Vv) {
  const e = t === Vv ? jWe : y1e(t), r = (n, a = {}) => {
    const { equalityFn: i = e9t, devModeChecks: o = {} } = typeof a == "function" ? { equalityFn: a } : a;
    if (Ar.env.NODE_ENV !== "production") {
      if (!n)
        throw new Error("You must pass a selector to useSelector");
      if (typeof n != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const {
      store: s,
      subscription: l,
      getServerState: c,
      stabilityCheck: u,
      identityFunctionCheck: f
    } = e(), h = i0.useRef(!0), p = i0.useCallback(
      {
        [n.name](y) {
          const b = n(y);
          if (Ar.env.NODE_ENV !== "production") {
            const {
              identityFunctionCheck: w,
              stabilityCheck: _
            } = {
              stabilityCheck: u,
              identityFunctionCheck: f,
              ...o
            };
            if (_ === "always" || _ === "once" && h.current) {
              const C = n(y);
              if (!i(b, C)) {
                let x;
                try {
                  throw new Error();
                } catch (S) {
                  ({ stack: x } = S);
                }
                console.warn(
                  "Selector " + (n.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: y,
                    selected: b,
                    selected2: C,
                    stack: x
                  }
                );
              }
            }
            if ((w === "always" || w === "once" && h.current) && b === y) {
              let C;
              try {
                throw new Error();
              } catch (x) {
                ({ stack: C } = x);
              }
              console.warn(
                "Selector " + (n.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: C }
              );
            }
            h.current && (h.current = !1);
          }
          return b;
        }
      }[n.name],
      [n, u, o.stabilityCheck]
    ), g = FWe(
      l.addNestedSub,
      s.getState,
      c || s.getState,
      p,
      i
    );
    return i0.useDebugValue(g), g;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var zWe = /* @__PURE__ */ t9t();
function GWe(t) {
  t();
}
function r9t() {
  let t = null, e = null;
  return {
    clear() {
      t = null, e = null;
    },
    notify() {
      GWe(() => {
        let r = t;
        for (; r; )
          r.callback(), r = r.next;
      });
    },
    get() {
      const r = [];
      let n = t;
      for (; n; )
        r.push(n), n = n.next;
      return r;
    },
    subscribe(r) {
      let n = !0;
      const a = e = {
        callback: r,
        next: null,
        prev: e
      };
      return a.prev ? a.prev.next = a : t = a, function() {
        !n || t === null || (n = !1, a.next ? a.next.prev = a.prev : e = a.prev, a.prev ? a.prev.next = a.next : t = a.next);
      };
    }
  };
}
var v6e = {
  notify() {
  },
  get: () => []
};
function n9t(t, e) {
  let r, n = v6e, a = 0, i = !1;
  function o(y) {
    u();
    const b = n.subscribe(y);
    let w = !1;
    return () => {
      w || (w = !0, b(), f());
    };
  }
  function s() {
    n.notify();
  }
  function l() {
    g.onStateChange && g.onStateChange();
  }
  function c() {
    return i;
  }
  function u() {
    a++, r || (r = t.subscribe(l), n = r9t());
  }
  function f() {
    a--, r && a === 0 && (r(), r = void 0, n.clear(), n = v6e);
  }
  function h() {
    i || (i = !0, u());
  }
  function p() {
    i && (i = !1, f());
  }
  const g = {
    addNestedSub: o,
    notifyNestedSubs: s,
    handleChangeWrapper: l,
    isSubscribed: c,
    trySubscribe: h,
    tryUnsubscribe: p,
    getListeners: () => n
  };
  return g;
}
var a9t = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", i9t = typeof navigator < "u" && navigator.product === "ReactNative", o9t = a9t || i9t ? i0.useLayoutEffect : i0.useEffect;
function y6e(t, e) {
  return t === e ? t !== 0 || e !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
function w_(t, e) {
  if (y6e(t, e))
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (let a = 0; a < r.length; a++)
    if (!Object.prototype.hasOwnProperty.call(e, r[a]) || !y6e(t[r[a]], e[r[a]]))
      return !1;
  return !0;
}
function s9t({
  store: t,
  context: e,
  children: r,
  serverState: n,
  stabilityCheck: a = "once",
  identityFunctionCheck: i = "once"
}) {
  const o = i0.useMemo(() => {
    const c = n9t(t);
    return {
      store: t,
      subscription: c,
      getServerState: n ? () => n : void 0,
      stabilityCheck: a,
      identityFunctionCheck: i
    };
  }, [t, n, a, i]), s = i0.useMemo(() => t.getState(), [t]);
  o9t(() => {
    const { subscription: c } = o;
    return c.onStateChange = c.notifyNestedSubs, c.trySubscribe(), s !== t.getState() && c.notifyNestedSubs(), () => {
      c.tryUnsubscribe(), c.onStateChange = void 0;
    };
  }, [o, s]);
  const l = e || Vv;
  return /* @__PURE__ */ i0.createElement(l.Provider, { value: o }, r);
}
var l9t = s9t;
function WWe(t = Vv) {
  const e = t === Vv ? jWe : (
    // @ts-ignore
    y1e(t)
  ), r = () => {
    const { store: n } = e();
    return n;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var HWe = /* @__PURE__ */ WWe();
function c9t(t = Vv) {
  const e = t === Vv ? HWe : WWe(t), r = () => e().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var UWe = /* @__PURE__ */ c9t(), u9t = GWe;
Q4t(J4t.useSyncExternalStoreWithSelector);
var VWe = /* @__PURE__ */ ((t) => (t.uninitialized = "uninitialized", t.pending = "pending", t.fulfilled = "fulfilled", t.rejected = "rejected", t))(VWe || {});
function b6e(t) {
  return {
    status: t,
    isUninitialized: t === "uninitialized",
    isLoading: t === "pending",
    isSuccess: t === "fulfilled",
    isError: t === "rejected"
    /* rejected */
  };
}
var x6e = Th;
function qWe(t, e) {
  if (t === e || !(x6e(t) && x6e(e) || Array.isArray(t) && Array.isArray(e)))
    return e;
  const r = Object.keys(e), n = Object.keys(t);
  let a = r.length === n.length;
  const i = Array.isArray(e) ? [] : {};
  for (const o of r)
    i[o] = qWe(t[o], e[o]), a && (a = t[o] === i[o]);
  return a ? t : i;
}
function c7(t) {
  let e = 0;
  for (const r in t)
    e++;
  return e;
}
var C6e = (t) => [].concat(...t);
function d9t(t) {
  return new RegExp("(^|:)//").test(t);
}
function f9t() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
function Z$(t) {
  return t != null;
}
function h9t() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
var p9t = (t) => t.replace(/\/$/, ""), m9t = (t) => t.replace(/^\//, "");
function g9t(t, e) {
  if (!t)
    return e;
  if (!e)
    return t;
  if (d9t(e))
    return e;
  const r = t.endsWith("/") || !e.startsWith("?") ? "/" : "";
  return t = p9t(t), e = m9t(e), `${t}${r}${e}`;
}
function v9t(t, e, r) {
  return t.has(e) ? t.get(e) : t.set(e, r).get(e);
}
var w6e = (...t) => fetch(...t), y9t = (t) => t.status >= 200 && t.status <= 299, b9t = (t) => (
  /*applicat*/
  /ion\/(vnd\.api\+)?json/.test(t.get("content-type") || "")
);
function S6e(t) {
  if (!Th(t))
    return t;
  const e = {
    ...t
  };
  for (const [r, n] of Object.entries(e))
    n === void 0 && delete e[r];
  return e;
}
function KWe({
  baseUrl: t,
  prepareHeaders: e = (f) => f,
  fetchFn: r = w6e,
  paramsSerializer: n,
  isJsonContentType: a = b9t,
  jsonContentType: i = "application/json",
  jsonReplacer: o,
  timeout: s,
  responseHandler: l,
  validateStatus: c,
  ...u
} = {}) {
  return typeof fetch > "u" && r === w6e && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), async (h, p, g) => {
    const {
      getState: y,
      extra: b,
      endpoint: w,
      forced: _,
      type: C
    } = p;
    let x, {
      url: S,
      headers: A = new Headers(u.headers),
      params: I = void 0,
      responseHandler: M = l ?? "json",
      validateStatus: B = c ?? y9t,
      timeout: L = s,
      ...N
    } = typeof h == "string" ? {
      url: h
    } : h, d, m = p.signal;
    L && (d = new AbortController(), p.signal.addEventListener("abort", d.abort), m = d.signal);
    let v = {
      ...u,
      signal: m,
      ...N
    };
    A = new Headers(S6e(A)), v.headers = await e(A, {
      getState: y,
      arg: h,
      extra: b,
      endpoint: w,
      forced: _,
      type: C,
      extraOptions: g
    }) || A;
    const k = (Z) => typeof Z == "object" && (Th(Z) || Array.isArray(Z) || typeof Z.toJSON == "function");
    if (!v.headers.has("content-type") && k(v.body) && v.headers.set("content-type", i), k(v.body) && a(v.headers) && (v.body = JSON.stringify(v.body, o)), I) {
      const Z = ~S.indexOf("?") ? "&" : "?", V = n ? n(I) : new URLSearchParams(S6e(I));
      S += Z + V;
    }
    S = g9t(t, S);
    const O = new Request(S, v);
    x = {
      request: new Request(S, v)
    };
    let H, j = !1, F = d && setTimeout(() => {
      j = !0, d.abort();
    }, L);
    try {
      H = await r(O);
    } catch (Z) {
      return {
        error: {
          status: j ? "TIMEOUT_ERROR" : "FETCH_ERROR",
          error: String(Z)
        },
        meta: x
      };
    } finally {
      F && clearTimeout(F), d == null || d.signal.removeEventListener("abort", d.abort);
    }
    const z = H.clone();
    x.response = z;
    let W, U = "";
    try {
      let Z;
      if (await Promise.all([
        f(H, M).then((V) => W = V, (V) => Z = V),
        // see https://github.com/node-fetch/node-fetch/issues/665#issuecomment-538995182
        // we *have* to "use up" both streams at the same time or they will stop running in node-fetch scenarios
        z.text().then((V) => U = V, () => {
        })
      ]), Z) throw Z;
    } catch (Z) {
      return {
        error: {
          status: "PARSING_ERROR",
          originalStatus: H.status,
          data: U,
          error: String(Z)
        },
        meta: x
      };
    }
    return B(H, W) ? {
      data: W,
      meta: x
    } : {
      error: {
        status: H.status,
        data: W
      },
      meta: x
    };
  };
  async function f(h, p) {
    if (typeof p == "function")
      return p(h);
    if (p === "content-type" && (p = a(h.headers) ? "json" : "text"), p === "json") {
      const g = await h.text();
      return g.length ? JSON.parse(g) : null;
    }
    return h.text();
  }
}
var _6e = class {
  constructor(t, e = void 0) {
    this.value = t, this.meta = e;
  }
}, b1e = /* @__PURE__ */ C1("__rtkq/focused"), ZWe = /* @__PURE__ */ C1("__rtkq/unfocused"), x1e = /* @__PURE__ */ C1("__rtkq/online"), JWe = /* @__PURE__ */ C1("__rtkq/offline");
function C1e(t) {
  return t.type === "query";
}
function x9t(t) {
  return t.type === "mutation";
}
function sz(t) {
  return t.type === "infinitequery";
}
function w1e(t, e, r, n, a, i) {
  return C9t(t) ? t(e, r, n, a).filter(Z$).map(Ale).map(i) : Array.isArray(t) ? t.map(Ale).map(i) : [];
}
function C9t(t) {
  return typeof t == "function";
}
function Ale(t) {
  return typeof t == "string" ? {
    type: t
  } : t;
}
function w9t(t, e) {
  return t.catch(e);
}
var ok = Symbol("forceQueryFn"), Tle = (t) => typeof t[ok] == "function";
function S9t({
  serializeQueryArgs: t,
  queryThunk: e,
  infiniteQueryThunk: r,
  mutationThunk: n,
  api: a,
  context: i
}) {
  const o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), {
    unsubscribeQueryResult: l,
    removeMutationResult: c,
    updateSubscriptionOptions: u
  } = a.internalActions;
  return {
    buildInitiateQuery: w,
    buildInitiateInfiniteQuery: _,
    buildInitiateMutation: C,
    getRunningQueryThunk: f,
    getRunningMutationThunk: h,
    getRunningQueriesThunk: p,
    getRunningMutationsThunk: g
  };
  function f(x, S) {
    return (A) => {
      var B;
      const I = i.endpointDefinitions[x], M = t({
        queryArgs: S,
        endpointDefinition: I,
        endpointName: x
      });
      return (B = o.get(A)) == null ? void 0 : B[M];
    };
  }
  function h(x, S) {
    return (A) => {
      var I;
      return (I = s.get(A)) == null ? void 0 : I[S];
    };
  }
  function p() {
    return (x) => Object.values(o.get(x) || {}).filter(Z$);
  }
  function g() {
    return (x) => Object.values(s.get(x) || {}).filter(Z$);
  }
  function y(x) {
    if (Ar.env.NODE_ENV !== "production") {
      if (y.triggered) return;
      const S = x(a.internalActions.internal_getRTKQSubscriptions());
      if (y.triggered = !0, typeof S != "object" || typeof (S == null ? void 0 : S.type) == "string")
        throw new Error(Ar.env.NODE_ENV === "production" ? go(34) : `Warning: Middleware for RTK-Query API at reducerPath "${a.reducerPath}" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function b(x, S) {
    const A = (I, {
      subscribe: M = !0,
      forceRefetch: B,
      subscriptionOptions: L,
      [ok]: N,
      ...d
    } = {}) => (m, v) => {
      var ge;
      const k = t({
        queryArgs: I,
        endpointDefinition: S,
        endpointName: x
      });
      let O;
      const G = {
        ...d,
        type: "query",
        subscribe: M,
        forceRefetch: B,
        subscriptionOptions: L,
        endpointName: x,
        originalArgs: I,
        queryCacheKey: k,
        [ok]: N
      };
      if (C1e(S))
        O = e(G);
      else {
        const {
          direction: ce,
          initialPageParam: ee
        } = d;
        O = r({
          ...G,
          // Supply these even if undefined. This helps with a field existence
          // check over in `buildSlice.ts`
          direction: ce,
          initialPageParam: ee
        });
      }
      const H = a.endpoints[x].select(I), j = m(O), F = H(v());
      y(m);
      const {
        requestId: z,
        abort: W
      } = j, U = F.requestId !== z, Z = (ge = o.get(m)) == null ? void 0 : ge[k], V = () => H(v()), Y = Object.assign(N ? (
        // a query has been forced (upsertQueryData)
        // -> we want to resolve it once data has been written with the data that will be written
        j.then(V)
      ) : U && !Z ? (
        // a query has been skipped due to a condition and we do not have any currently running query
        // -> we want to resolve it immediately with the current data
        Promise.resolve(F)
      ) : (
        // query just started or one is already in flight
        // -> wait for the running query, then resolve with data from after that
        Promise.all([Z, j]).then(V)
      ), {
        arg: I,
        requestId: z,
        subscriptionOptions: L,
        queryCacheKey: k,
        abort: W,
        async unwrap() {
          const ce = await Y;
          if (ce.isError)
            throw ce.error;
          return ce.data;
        },
        refetch: () => m(A(I, {
          subscribe: !1,
          forceRefetch: !0
        })),
        unsubscribe() {
          M && m(l({
            queryCacheKey: k,
            requestId: z
          }));
        },
        updateSubscriptionOptions(ce) {
          Y.subscriptionOptions = ce, m(u({
            endpointName: x,
            requestId: z,
            queryCacheKey: k,
            options: ce
          }));
        }
      });
      if (!Z && !U && !N) {
        const ce = v9t(o, m, {});
        ce[k] = Y, Y.then(() => {
          delete ce[k], c7(ce) || o.delete(m);
        });
      }
      return Y;
    };
    return A;
  }
  function w(x, S) {
    return b(x, S);
  }
  function _(x, S) {
    return b(x, S);
  }
  function C(x) {
    return (S, {
      track: A = !0,
      fixedCacheKey: I
    } = {}) => (M, B) => {
      const L = n({
        type: "mutation",
        endpointName: x,
        originalArgs: S,
        track: A,
        fixedCacheKey: I
      }), N = M(L);
      y(M);
      const {
        requestId: d,
        abort: m,
        unwrap: v
      } = N, k = w9t(N.unwrap().then((j) => ({
        data: j
      })), (j) => ({
        error: j
      })), O = () => {
        M(c({
          requestId: d,
          fixedCacheKey: I
        }));
      }, G = Object.assign(k, {
        arg: N.arg,
        requestId: d,
        abort: m,
        unwrap: v,
        reset: O
      }), H = s.get(M) || {};
      return s.set(M, H), H[d] = G, G.then(() => {
        delete H[d], c7(H) || s.delete(M);
      }), I && (H[I] = G, G.then(() => {
        H[I] === G && (delete H[I], c7(H) || s.delete(M));
      })), G;
    };
  }
}
function _9t(t) {
  return t;
}
var qO = (t = {}) => ({
  ...t,
  [nz]: !0
});
function k9t({
  reducerPath: t,
  baseQuery: e,
  context: {
    endpointDefinitions: r
  },
  serializeQueryArgs: n,
  api: a,
  assertTagType: i,
  selectors: o
}) {
  const s = (M, B, L, N) => (d, m) => {
    const v = r[M], k = n({
      queryArgs: B,
      endpointDefinition: v,
      endpointName: M
    });
    if (d(a.internalActions.queryResultPatched({
      queryCacheKey: k,
      patches: L
    })), !N)
      return;
    const O = a.endpoints[M].select(B)(
      // Work around TS 4.1 mismatch
      m()
    ), G = w1e(v.providesTags, O.data, void 0, B, {}, i);
    d(a.internalActions.updateProvidedBy({
      queryCacheKey: k,
      providedTags: G
    }));
  };
  function l(M, B, L = 0) {
    const N = [B, ...M];
    return L && N.length > L ? N.slice(0, -1) : N;
  }
  function c(M, B, L = 0) {
    const N = [...M, B];
    return L && N.length > L ? N.slice(1) : N;
  }
  const u = (M, B, L, N = !0) => (d, m) => {
    const k = a.endpoints[M].select(B)(
      // Work around TS 4.1 mismatch
      m()
    ), O = {
      patches: [],
      inversePatches: [],
      undo: () => d(a.util.patchQueryData(M, B, O.inversePatches, N))
    };
    if (k.status === "uninitialized")
      return O;
    let G;
    if ("data" in k)
      if (B1(k.data)) {
        const [H, j, F] = SWe(k.data, L);
        O.patches.push(...j), O.inversePatches.push(...F), G = H;
      } else
        G = L(k.data), O.patches.push({
          op: "replace",
          path: [],
          value: G
        }), O.inversePatches.push({
          op: "replace",
          path: [],
          value: k.data
        });
    return O.patches.length === 0 || d(a.util.patchQueryData(M, B, O.patches, N)), O;
  }, f = (M, B, L) => (N) => N(a.endpoints[M].initiate(B, {
    subscribe: !1,
    forceRefetch: !0,
    [ok]: () => ({
      data: L
    })
  })), h = (M, B) => M.query && M[B] ? M[B] : _9t, p = async (M, {
    signal: B,
    abort: L,
    rejectWithValue: N,
    fulfillWithValue: d,
    dispatch: m,
    getState: v,
    extra: k
  }) => {
    var G;
    const O = r[M.endpointName];
    try {
      let H = h(O, "transformResponse");
      const j = {
        signal: B,
        abort: L,
        dispatch: m,
        getState: v,
        extra: k,
        endpoint: M.endpointName,
        type: M.type,
        forced: M.type === "query" ? g(M, v()) : void 0,
        queryCacheKey: M.type === "query" ? M.queryCacheKey : void 0
      }, F = M.type === "query" ? M[ok] : void 0;
      let z;
      const W = async (Z, V, Y, ge) => {
        if (V == null && Z.pages.length)
          return Promise.resolve({
            data: Z
          });
        const ce = {
          queryArg: M.originalArgs,
          pageParam: V
        }, ee = await U(ce), Se = ge ? l : c;
        return {
          data: {
            pages: Se(Z.pages, ee.data, Y),
            pageParams: Se(Z.pageParams, V, Y)
          }
        };
      };
      async function U(Z) {
        let V;
        const {
          extraOptions: Y
        } = O;
        if (F ? V = F() : O.query ? V = await e(O.query(Z), j, Y) : V = await O.queryFn(Z, j, Y, (ce) => e(ce, j, Y)), typeof Ar < "u" && Ar.env.NODE_ENV === "development") {
          const ce = O.query ? "`baseQuery`" : "`queryFn`";
          let ee;
          if (!V)
            ee = `${ce} did not return anything.`;
          else if (typeof V != "object")
            ee = `${ce} did not return an object.`;
          else if (V.error && V.data)
            ee = `${ce} returned an object containing both \`error\` and \`result\`.`;
          else if (V.error === void 0 && V.data === void 0)
            ee = `${ce} returned an object containing neither a valid \`error\` and \`result\`. At least one of them should not be \`undefined\``;
          else
            for (const Se of Object.keys(V))
              if (Se !== "error" && Se !== "data" && Se !== "meta") {
                ee = `The object returned by ${ce} has the unknown property ${Se}.`;
                break;
              }
          ee && console.error(`Error encountered handling the endpoint ${M.endpointName}.
                  ${ee}
                  It needs to return an object with either the shape \`{ data: <value> }\` or \`{ error: <value> }\` that may contain an optional \`meta\` property.
                  Object returned was:`, V);
        }
        if (V.error) throw new _6e(V.error, V.meta);
        const ge = await H(V.data, V.meta, Z);
        return {
          ...V,
          data: ge
        };
      }
      if (M.type === "query" && "infiniteQueryOptions" in O) {
        const {
          infiniteQueryOptions: Z
        } = O, {
          maxPages: V = 1 / 0
        } = Z;
        let Y;
        const ge = {
          pages: [],
          pageParams: []
        }, ce = (G = o.selectQueryEntry(v(), M.queryCacheKey)) == null ? void 0 : G.data, Se = /* arg.forceRefetch */ g(M, v()) && !M.direction || !ce ? ge : ce;
        if ("direction" in M && M.direction && Se.pages.length) {
          const Ce = M.direction === "backward", We = (Ce ? YWe : Ele)(Z, Se);
          Y = await W(Se, We, V, Ce);
        } else {
          const {
            initialPageParam: Ce = Z.initialPageParam
          } = M, we = (ce == null ? void 0 : ce.pageParams) ?? [], We = we[0] ?? Ce, Fe = we.length;
          Y = await W(Se, We, V), F && (Y = {
            data: Y.data.pages[0]
          });
          for (let it = 1; it < Fe; it++) {
            const gt = Ele(Z, Y.data);
            Y = await W(Y.data, gt, V);
          }
        }
        z = Y;
      } else
        z = await U(M.originalArgs);
      return d(z.data, qO({
        fulfilledTimeStamp: Date.now(),
        baseQueryMeta: z.meta
      }));
    } catch (H) {
      let j = H;
      if (j instanceof _6e) {
        let F = h(O, "transformErrorResponse");
        try {
          return N(await F(j.value, j.meta, M.originalArgs), qO({
            baseQueryMeta: j.meta
          }));
        } catch (z) {
          j = z;
        }
      }
      throw typeof Ar < "u" && Ar.env.NODE_ENV !== "production" ? console.error(`An unhandled error occurred processing a request for the endpoint "${M.endpointName}".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, j) : console.error(j), j;
    }
  };
  function g(M, B) {
    const L = o.selectQueryEntry(B, M.queryCacheKey), N = o.selectConfig(B).refetchOnMountOrArgChange, d = L == null ? void 0 : L.fulfilledTimeStamp, m = M.forceRefetch ?? (M.subscribe && N);
    return m ? m === !0 || (Number(/* @__PURE__ */ new Date()) - Number(d)) / 1e3 >= m : !1;
  }
  const y = () => u6e(`${t}/executeQuery`, p, {
    getPendingMeta({
      arg: B
    }) {
      const L = r[B.endpointName];
      return qO({
        startedTimeStamp: Date.now(),
        ...sz(L) ? {
          direction: B.direction
        } : {}
      });
    },
    condition(B, {
      getState: L
    }) {
      var H;
      const N = L(), d = o.selectQueryEntry(N, B.queryCacheKey), m = d == null ? void 0 : d.fulfilledTimeStamp, v = B.originalArgs, k = d == null ? void 0 : d.originalArgs, O = r[B.endpointName], G = B.direction;
      return Tle(B) ? !0 : (d == null ? void 0 : d.status) === "pending" ? !1 : g(B, N) || C1e(O) && ((H = O == null ? void 0 : O.forceRefetch) != null && H.call(O, {
        currentArg: v,
        previousArg: k,
        endpointState: d,
        state: N
      })) ? !0 : !(m && !G);
    },
    dispatchConditionRejection: !0
  }), b = y(), w = y(), _ = u6e(`${t}/executeMutation`, p, {
    getPendingMeta() {
      return qO({
        startedTimeStamp: Date.now()
      });
    }
  }), C = (M) => "force" in M, x = (M) => "ifOlderThan" in M, S = (M, B, L) => (N, d) => {
    const m = C(L) && L.force, v = x(L) && L.ifOlderThan, k = (G = !0) => {
      const H = {
        forceRefetch: G,
        isPrefetch: !0
      };
      return a.endpoints[M].initiate(B, H);
    }, O = a.endpoints[M].select(B)(d());
    if (m)
      N(k());
    else if (v) {
      const G = O == null ? void 0 : O.fulfilledTimeStamp;
      if (!G) {
        N(k());
        return;
      }
      (Number(/* @__PURE__ */ new Date()) - Number(new Date(G))) / 1e3 >= v && N(k());
    } else
      N(k(!1));
  };
  function A(M) {
    return (B) => {
      var L, N;
      return ((N = (L = B == null ? void 0 : B.meta) == null ? void 0 : L.arg) == null ? void 0 : N.endpointName) === M;
    };
  }
  function I(M, B) {
    return {
      matchPending: C_(p1e(M), A(B)),
      matchFulfilled: C_(Uv(M), A(B)),
      matchRejected: C_(B7(M), A(B))
    };
  }
  return {
    queryThunk: b,
    mutationThunk: _,
    infiniteQueryThunk: w,
    prefetch: S,
    updateQueryData: u,
    upsertQueryData: f,
    patchQueryData: s,
    buildMatchThunkActions: I
  };
}
function Ele(t, {
  pages: e,
  pageParams: r
}) {
  const n = e.length - 1;
  return t.getNextPageParam(e[n], e, r[n], r);
}
function YWe(t, {
  pages: e,
  pageParams: r
}) {
  var n;
  return (n = t.getPreviousPageParam) == null ? void 0 : n.call(t, e[0], e, r[0], r);
}
function XWe(t, e, r, n) {
  return w1e(r[t.meta.arg.endpointName][e], Uv(t) ? t.payload : void 0, iz(t) ? t.payload : void 0, t.meta.arg.originalArgs, "baseQueryMeta" in t.meta ? t.meta.baseQueryMeta : void 0, n);
}
function KO(t, e, r) {
  const n = t[e];
  n && r(n);
}
function sk(t) {
  return ("arg" in t ? t.arg.fixedCacheKey : t.fixedCacheKey) ?? t.requestId;
}
function k6e(t, e, r) {
  const n = t[sk(e)];
  n && r(n);
}
var Gw = {};
function A9t({
  reducerPath: t,
  queryThunk: e,
  mutationThunk: r,
  serializeQueryArgs: n,
  context: {
    endpointDefinitions: a,
    apiUid: i,
    extractRehydrationInfo: o,
    hasRehydrationInfo: s
  },
  assertTagType: l,
  config: c
}) {
  const u = C1(`${t}/resetApiState`);
  function f(A, I, M, B) {
    var L;
    A[L = I.queryCacheKey] ?? (A[L] = {
      status: "uninitialized",
      endpointName: I.endpointName
    }), KO(A, I.queryCacheKey, (N) => {
      N.status = "pending", N.requestId = M && N.requestId ? (
        // for `upsertQuery` **updates**, keep the current `requestId`
        N.requestId
      ) : (
        // for normal queries or `upsertQuery` **inserts** always update the `requestId`
        B.requestId
      ), I.originalArgs !== void 0 && (N.originalArgs = I.originalArgs), N.startedTimeStamp = B.startedTimeStamp;
      const d = a[B.arg.endpointName];
      sz(d) && "direction" in I && (N.direction = I.direction);
    });
  }
  function h(A, I, M, B) {
    KO(A, I.arg.queryCacheKey, (L) => {
      if (L.requestId !== I.requestId && !B) return;
      const {
        merge: N
      } = a[I.arg.endpointName];
      if (L.status = "fulfilled", N)
        if (L.data !== void 0) {
          const {
            fulfilledTimeStamp: d,
            arg: m,
            baseQueryMeta: v,
            requestId: k
          } = I;
          let O = MI(L.data, (G) => N(G, M, {
            arg: m.originalArgs,
            baseQueryMeta: v,
            fulfilledTimeStamp: d,
            requestId: k
          }));
          L.data = O;
        } else
          L.data = M;
      else
        L.data = a[I.arg.endpointName].structuralSharing ?? !0 ? qWe(Eh(L.data) ? j6t(L.data) : L.data, M) : M;
      delete L.error, L.fulfilledTimeStamp = I.fulfilledTimeStamp;
    });
  }
  const p = u1({
    name: `${t}/queries`,
    initialState: Gw,
    reducers: {
      removeQueryResult: {
        reducer(A, {
          payload: {
            queryCacheKey: I
          }
        }) {
          delete A[I];
        },
        prepare: zw()
      },
      cacheEntriesUpserted: {
        reducer(A, I) {
          for (const M of I.payload) {
            const {
              queryDescription: B,
              value: L
            } = M;
            f(A, B, !0, {
              arg: B,
              requestId: I.meta.requestId,
              startedTimeStamp: I.meta.timestamp
            }), h(
              A,
              {
                arg: B,
                requestId: I.meta.requestId,
                fulfilledTimeStamp: I.meta.timestamp,
                baseQueryMeta: {}
              },
              L,
              // We know we're upserting here
              !0
            );
          }
        },
        prepare: (A) => ({
          payload: A.map((B) => {
            const {
              endpointName: L,
              arg: N,
              value: d
            } = B, m = a[L];
            return {
              queryDescription: {
                type: "query",
                endpointName: L,
                originalArgs: B.arg,
                queryCacheKey: n({
                  queryArgs: N,
                  endpointDefinition: m,
                  endpointName: L
                })
              },
              value: d
            };
          }),
          meta: {
            [nz]: !0,
            requestId: m1e(),
            timestamp: Date.now()
          }
        })
      },
      queryResultPatched: {
        reducer(A, {
          payload: {
            queryCacheKey: I,
            patches: M
          }
        }) {
          KO(A, I, (B) => {
            B.data = r6e(B.data, M.concat());
          });
        },
        prepare: zw()
      }
    },
    extraReducers(A) {
      A.addCase(e.pending, (I, {
        meta: M,
        meta: {
          arg: B
        }
      }) => {
        const L = Tle(B);
        f(I, B, L, M);
      }).addCase(e.fulfilled, (I, {
        meta: M,
        payload: B
      }) => {
        const L = Tle(M.arg);
        h(I, M, B, L);
      }).addCase(e.rejected, (I, {
        meta: {
          condition: M,
          arg: B,
          requestId: L
        },
        error: N,
        payload: d
      }) => {
        KO(I, B.queryCacheKey, (m) => {
          if (!M) {
            if (m.requestId !== L) return;
            m.status = "rejected", m.error = d ?? N;
          }
        });
      }).addMatcher(s, (I, M) => {
        const {
          queries: B
        } = o(M);
        for (const [L, N] of Object.entries(B))
          // do not rehydrate entries that were currently in flight.
          ((N == null ? void 0 : N.status) === "fulfilled" || (N == null ? void 0 : N.status) === "rejected") && (I[L] = N);
      });
    }
  }), g = u1({
    name: `${t}/mutations`,
    initialState: Gw,
    reducers: {
      removeMutationResult: {
        reducer(A, {
          payload: I
        }) {
          const M = sk(I);
          M in A && delete A[M];
        },
        prepare: zw()
      }
    },
    extraReducers(A) {
      A.addCase(r.pending, (I, {
        meta: M,
        meta: {
          requestId: B,
          arg: L,
          startedTimeStamp: N
        }
      }) => {
        L.track && (I[sk(M)] = {
          requestId: B,
          status: "pending",
          endpointName: L.endpointName,
          startedTimeStamp: N
        });
      }).addCase(r.fulfilled, (I, {
        payload: M,
        meta: B
      }) => {
        B.arg.track && k6e(I, B, (L) => {
          L.requestId === B.requestId && (L.status = "fulfilled", L.data = M, L.fulfilledTimeStamp = B.fulfilledTimeStamp);
        });
      }).addCase(r.rejected, (I, {
        payload: M,
        error: B,
        meta: L
      }) => {
        L.arg.track && k6e(I, L, (N) => {
          N.requestId === L.requestId && (N.status = "rejected", N.error = M ?? B);
        });
      }).addMatcher(s, (I, M) => {
        const {
          mutations: B
        } = o(M);
        for (const [L, N] of Object.entries(B))
          // do not rehydrate entries that were currently in flight.
          ((N == null ? void 0 : N.status) === "fulfilled" || (N == null ? void 0 : N.status) === "rejected") && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
          L !== (N == null ? void 0 : N.requestId) && (I[L] = N);
      });
    }
  }), y = u1({
    name: `${t}/invalidation`,
    initialState: Gw,
    reducers: {
      updateProvidedBy: {
        reducer(A, I) {
          var L, N;
          const {
            queryCacheKey: M,
            providedTags: B
          } = I.payload;
          for (const d of Object.values(A))
            for (const m of Object.values(d)) {
              const v = m.indexOf(M);
              v !== -1 && m.splice(v, 1);
            }
          for (const {
            type: d,
            id: m
          } of B) {
            const v = (L = A[d] ?? (A[d] = {}))[N = m || "__internal_without_id"] ?? (L[N] = []);
            v.includes(M) || v.push(M);
          }
        },
        prepare: zw()
      }
    },
    extraReducers(A) {
      A.addCase(p.actions.removeQueryResult, (I, {
        payload: {
          queryCacheKey: M
        }
      }) => {
        for (const B of Object.values(I))
          for (const L of Object.values(B)) {
            const N = L.indexOf(M);
            N !== -1 && L.splice(N, 1);
          }
      }).addMatcher(s, (I, M) => {
        var L, N;
        const {
          provided: B
        } = o(M);
        for (const [d, m] of Object.entries(B))
          for (const [v, k] of Object.entries(m)) {
            const O = (L = I[d] ?? (I[d] = {}))[N = v || "__internal_without_id"] ?? (L[N] = []);
            for (const G of k)
              O.includes(G) || O.push(G);
          }
      }).addMatcher(Nm(Uv(e), iz(e)), (I, M) => {
        const B = XWe(M, "providesTags", a, l), {
          queryCacheKey: L
        } = M.meta.arg;
        y.caseReducers.updateProvidedBy(I, y.actions.updateProvidedBy({
          queryCacheKey: L,
          providedTags: B
        }));
      });
    }
  }), b = u1({
    name: `${t}/subscriptions`,
    initialState: Gw,
    reducers: {
      updateSubscriptionOptions(A, I) {
      },
      unsubscribeQueryResult(A, I) {
      },
      internal_getRTKQSubscriptions() {
      }
    }
  }), w = u1({
    name: `${t}/internalSubscriptions`,
    initialState: Gw,
    reducers: {
      subscriptionsUpdated: {
        reducer(A, I) {
          return r6e(A, I.payload);
        },
        prepare: zw()
      }
    }
  }), _ = u1({
    name: `${t}/config`,
    initialState: {
      online: h9t(),
      focused: f9t(),
      middlewareRegistered: !1,
      ...c
    },
    reducers: {
      middlewareRegistered(A, {
        payload: I
      }) {
        A.middlewareRegistered = A.middlewareRegistered === "conflict" || i !== I ? "conflict" : !0;
      }
    },
    extraReducers: (A) => {
      A.addCase(x1e, (I) => {
        I.online = !0;
      }).addCase(JWe, (I) => {
        I.online = !1;
      }).addCase(b1e, (I) => {
        I.focused = !0;
      }).addCase(ZWe, (I) => {
        I.focused = !1;
      }).addMatcher(s, (I) => ({
        ...I
      }));
    }
  }), C = gWe({
    queries: p.reducer,
    mutations: g.reducer,
    provided: y.reducer,
    subscriptions: w.reducer,
    config: _.reducer
  }), x = (A, I) => C(u.match(I) ? void 0 : A, I), S = {
    ..._.actions,
    ...p.actions,
    ...b.actions,
    ...w.actions,
    ...g.actions,
    ...y.actions,
    resetApiState: u
  };
  return {
    reducer: x,
    actions: S
  };
}
var tm = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), QWe = {
  status: "uninitialized"
  /* uninitialized */
}, A6e = /* @__PURE__ */ MI(QWe, () => {
}), T6e = /* @__PURE__ */ MI(QWe, () => {
});
function T9t({
  serializeQueryArgs: t,
  reducerPath: e,
  createSelector: r
}) {
  const n = (C) => A6e, a = (C) => T6e;
  return {
    buildQuerySelector: h,
    buildInfiniteQuerySelector: p,
    buildMutationSelector: g,
    selectInvalidatedBy: y,
    selectCachedArgsForQuery: b,
    selectApiState: o,
    selectQueries: s,
    selectMutations: c,
    selectQueryEntry: l,
    selectConfig: u
  };
  function i(C) {
    return {
      ...C,
      ...b6e(C.status)
    };
  }
  function o(C) {
    const x = C[e];
    if (Ar.env.NODE_ENV !== "production" && !x) {
      if (o.triggered) return x;
      o.triggered = !0, console.error(`Error: No data found at \`state.${e}\`. Did you forget to add the reducer to the store?`);
    }
    return x;
  }
  function s(C) {
    var x;
    return (x = o(C)) == null ? void 0 : x.queries;
  }
  function l(C, x) {
    var S;
    return (S = s(C)) == null ? void 0 : S[x];
  }
  function c(C) {
    var x;
    return (x = o(C)) == null ? void 0 : x.mutations;
  }
  function u(C) {
    var x;
    return (x = o(C)) == null ? void 0 : x.config;
  }
  function f(C, x, S) {
    return (A) => {
      if (A === tm)
        return r(n, S);
      const I = t({
        queryArgs: A,
        endpointDefinition: x,
        endpointName: C
      });
      return r((B) => l(B, I) ?? A6e, S);
    };
  }
  function h(C, x) {
    return f(C, x, i);
  }
  function p(C, x) {
    const {
      infiniteQueryOptions: S
    } = x;
    function A(I) {
      const M = {
        ...I,
        ...b6e(I.status)
      }, {
        isLoading: B,
        isError: L,
        direction: N
      } = M, d = N === "forward", m = N === "backward";
      return {
        ...M,
        hasNextPage: w(S, M.data),
        hasPreviousPage: _(S, M.data),
        isFetchingNextPage: B && d,
        isFetchingPreviousPage: B && m,
        isFetchNextPageError: L && d,
        isFetchPreviousPageError: L && m
      };
    }
    return f(C, x, A);
  }
  function g() {
    return (C) => {
      let x;
      return typeof C == "object" ? x = sk(C) ?? tm : x = C, r(x === tm ? a : (I) => {
        var M, B;
        return ((B = (M = o(I)) == null ? void 0 : M.mutations) == null ? void 0 : B[x]) ?? T6e;
      }, i);
    };
  }
  function y(C, x) {
    const S = C[e], A = /* @__PURE__ */ new Set();
    for (const I of x.filter(Z$).map(Ale)) {
      const M = S.provided[I.type];
      if (!M)
        continue;
      let B = (I.id !== void 0 ? (
        // id given: invalidate all queries that provide this type & id
        M[I.id]
      ) : (
        // no id: invalidate all queries that provide this type
        C6e(Object.values(M))
      )) ?? [];
      for (const L of B)
        A.add(L);
    }
    return C6e(Array.from(A.values()).map((I) => {
      const M = S.queries[I];
      return M ? [{
        queryCacheKey: I,
        endpointName: M.endpointName,
        originalArgs: M.originalArgs
      }] : [];
    }));
  }
  function b(C, x) {
    return Object.values(s(C)).filter(
      (S) => (S == null ? void 0 : S.endpointName) === x && S.status !== "uninitialized"
      /* uninitialized */
    ).map((S) => S.originalArgs);
  }
  function w(C, x) {
    return x ? Ele(C, x) != null : !1;
  }
  function _(C, x) {
    return !x || !C.getPreviousPageParam ? !1 : YWe(C, x) != null;
  }
}
var L4 = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, Ile = ({
  endpointName: t,
  queryArgs: e
}) => {
  let r = "";
  const n = L4 == null ? void 0 : L4.get(e);
  if (typeof n == "string")
    r = n;
  else {
    const a = JSON.stringify(e, (i, o) => (o = typeof o == "bigint" ? {
      $bigint: o.toString()
    } : o, o = Th(o) ? Object.keys(o).sort().reduce((s, l) => (s[l] = o[l], s), {}) : o, o));
    Th(e) && (L4 == null || L4.set(e, a)), r = a;
  }
  return `${t}(${r})`;
};
function eHe(...t) {
  return function(r) {
    const n = V$((c) => {
      var u;
      return (u = r.extractRehydrationInfo) == null ? void 0 : u.call(r, c, {
        reducerPath: r.reducerPath ?? "api"
      });
    }), a = {
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1,
      invalidationBehavior: "delayed",
      ...r,
      extractRehydrationInfo: n,
      serializeQueryArgs(c) {
        let u = Ile;
        if ("serializeQueryArgs" in c.endpointDefinition) {
          const f = c.endpointDefinition.serializeQueryArgs;
          u = (h) => {
            const p = f(h);
            return typeof p == "string" ? p : Ile({
              ...h,
              queryArgs: p
            });
          };
        } else r.serializeQueryArgs && (u = r.serializeQueryArgs);
        return u(c);
      },
      tagTypes: [...r.tagTypes || []]
    }, i = {
      endpointDefinitions: {},
      batch(c) {
        c();
      },
      apiUid: m1e(),
      extractRehydrationInfo: n,
      hasRehydrationInfo: V$((c) => n(c) != null)
    }, o = {
      injectEndpoints: l,
      enhanceEndpoints({
        addTagTypes: c,
        endpoints: u
      }) {
        if (c)
          for (const f of c)
            a.tagTypes.includes(f) || a.tagTypes.push(f);
        if (u)
          for (const [f, h] of Object.entries(u))
            typeof h == "function" ? h(i.endpointDefinitions[f]) : Object.assign(i.endpointDefinitions[f] || {}, h);
        return o;
      }
    }, s = t.map((c) => c.init(o, a, i));
    function l(c) {
      const u = c.endpoints({
        query: (f) => ({
          ...f,
          type: "query"
          /* query */
        }),
        mutation: (f) => ({
          ...f,
          type: "mutation"
          /* mutation */
        }),
        infiniteQuery: (f) => ({
          ...f,
          type: "infinitequery"
          /* infinitequery */
        })
      });
      for (const [f, h] of Object.entries(u)) {
        if (c.overrideExisting !== !0 && f in i.endpointDefinitions) {
          if (c.overrideExisting === "throw")
            throw new Error(Ar.env.NODE_ENV === "production" ? go(39) : `called \`injectEndpoints\` to override already-existing endpointName ${f} without specifying \`overrideExisting: true\``);
          typeof Ar < "u" && Ar.env.NODE_ENV === "development" && console.error(`called \`injectEndpoints\` to override already-existing endpointName ${f} without specifying \`overrideExisting: true\``);
          continue;
        }
        if (typeof Ar < "u" && Ar.env.NODE_ENV === "development" && sz(h)) {
          const {
            infiniteQueryOptions: p
          } = h, {
            maxPages: g,
            getPreviousPageParam: y
          } = p;
          if (typeof g == "number") {
            if (g < 1)
              throw new Error(Ar.env.NODE_ENV === "production" ? go(40) : `maxPages for endpoint '${f}' must be a number greater than 0`);
            if (typeof y != "function")
              throw new Error(Ar.env.NODE_ENV === "production" ? go(41) : `getPreviousPageParam for endpoint '${f}' must be a function if maxPages is used`);
          }
        }
        i.endpointDefinitions[f] = h;
        for (const p of s)
          p.injectEndpoint(f, h);
      }
      return o;
    }
    return o.injectEndpoints({
      endpoints: r.endpoints
    });
  };
}
function Np(t, ...e) {
  return Object.assign(t, ...e);
}
var E9t = ({
  api: t,
  queryThunk: e,
  internalState: r
}) => {
  const n = `${t.reducerPath}/subscriptions`;
  let a = null, i = null;
  const {
    updateSubscriptionOptions: o,
    unsubscribeQueryResult: s
  } = t.internalActions, l = (p, g) => {
    var b, w, _;
    if (o.match(g)) {
      const {
        queryCacheKey: C,
        requestId: x,
        options: S
      } = g.payload;
      return (b = p == null ? void 0 : p[C]) != null && b[x] && (p[C][x] = S), !0;
    }
    if (s.match(g)) {
      const {
        queryCacheKey: C,
        requestId: x
      } = g.payload;
      return p[C] && delete p[C][x], !0;
    }
    if (t.internalActions.removeQueryResult.match(g))
      return delete p[g.payload.queryCacheKey], !0;
    if (e.pending.match(g)) {
      const {
        meta: {
          arg: C,
          requestId: x
        }
      } = g, S = p[w = C.queryCacheKey] ?? (p[w] = {});
      return S[`${x}_running`] = {}, C.subscribe && (S[x] = C.subscriptionOptions ?? S[x] ?? {}), !0;
    }
    let y = !1;
    if (e.fulfilled.match(g) || e.rejected.match(g)) {
      const C = p[g.meta.arg.queryCacheKey] || {}, x = `${g.meta.requestId}_running`;
      y || (y = !!C[x]), delete C[x];
    }
    if (e.rejected.match(g)) {
      const {
        meta: {
          condition: C,
          arg: x,
          requestId: S
        }
      } = g;
      if (C && x.subscribe) {
        const A = p[_ = x.queryCacheKey] ?? (p[_] = {});
        A[S] = x.subscriptionOptions ?? A[S] ?? {}, y = !0;
      }
    }
    return y;
  }, c = () => r.currentSubscriptions, h = {
    getSubscriptions: c,
    getSubscriptionCount: (p) => {
      const y = c()[p] ?? {};
      return c7(y);
    },
    isRequestSubscribed: (p, g) => {
      var b;
      const y = c();
      return !!((b = y == null ? void 0 : y[p]) != null && b[g]);
    }
  };
  return (p, g) => {
    if (a || (a = JSON.parse(JSON.stringify(r.currentSubscriptions))), t.util.resetApiState.match(p))
      return a = r.currentSubscriptions = {}, i = null, [!0, !1];
    if (t.internalActions.internal_getRTKQSubscriptions.match(p))
      return [!1, h];
    const y = l(r.currentSubscriptions, p);
    let b = !0;
    if (y) {
      i || (i = setTimeout(() => {
        const C = JSON.parse(JSON.stringify(r.currentSubscriptions)), [, x] = SWe(a, () => C);
        g.next(t.internalActions.subscriptionsUpdated(x)), a = C, i = null;
      }, 500));
      const w = typeof p.type == "string" && !!p.type.startsWith(n), _ = e.rejected.match(p) && p.meta.condition && !!p.meta.arg.subscribe;
      b = !w && !_;
    }
    return [b, !1];
  };
};
function I9t(t) {
  for (const e in t)
    return !1;
  return !0;
}
var M9t = 2147483647 / 1e3 - 1, P9t = ({
  reducerPath: t,
  api: e,
  queryThunk: r,
  context: n,
  internalState: a,
  selectors: {
    selectQueryEntry: i,
    selectConfig: o
  }
}) => {
  const {
    removeQueryResult: s,
    unsubscribeQueryResult: l,
    cacheEntriesUpserted: c
  } = e.internalActions, u = Nm(l.match, r.fulfilled, r.rejected, c.match);
  function f(b) {
    const w = a.currentSubscriptions[b];
    return !!w && !I9t(w);
  }
  const h = {}, p = (b, w, _) => {
    const C = w.getState(), x = o(C);
    if (u(b)) {
      let S;
      if (c.match(b))
        S = b.payload.map((A) => A.queryDescription.queryCacheKey);
      else {
        const {
          queryCacheKey: A
        } = l.match(b) ? b.payload : b.meta.arg;
        S = [A];
      }
      g(S, w, x);
    }
    if (e.util.resetApiState.match(b))
      for (const [S, A] of Object.entries(h))
        A && clearTimeout(A), delete h[S];
    if (n.hasRehydrationInfo(b)) {
      const {
        queries: S
      } = n.extractRehydrationInfo(b);
      g(Object.keys(S), w, x);
    }
  };
  function g(b, w, _) {
    const C = w.getState();
    for (const x of b) {
      const S = i(C, x);
      y(x, S == null ? void 0 : S.endpointName, w, _);
    }
  }
  function y(b, w, _, C) {
    const x = n.endpointDefinitions[w], S = (x == null ? void 0 : x.keepUnusedDataFor) ?? C.keepUnusedDataFor;
    if (S === 1 / 0)
      return;
    const A = Math.max(0, Math.min(S, M9t));
    if (!f(b)) {
      const I = h[b];
      I && clearTimeout(I), h[b] = setTimeout(() => {
        f(b) || _.dispatch(s({
          queryCacheKey: b
        })), delete h[b];
      }, A * 1e3);
    }
  }
  return p;
}, E6e = new Error("Promise never resolved before cacheEntryRemoved."), R9t = ({
  api: t,
  reducerPath: e,
  context: r,
  queryThunk: n,
  mutationThunk: a,
  internalState: i,
  selectors: {
    selectQueryEntry: o,
    selectApiState: s
  }
}) => {
  const l = Sle(n), c = Sle(a), u = Uv(n, a), f = {};
  function h(w, _, C) {
    const x = f[w];
    x != null && x.valueResolved && (x.valueResolved({
      data: _,
      meta: C
    }), delete x.valueResolved);
  }
  function p(w) {
    const _ = f[w];
    _ && (delete f[w], _.cacheEntryRemoved());
  }
  const g = (w, _, C) => {
    const x = y(w);
    function S(A, I, M, B) {
      const L = o(C, I), N = o(_.getState(), I);
      !L && N && b(A, B, I, _, M);
    }
    if (n.pending.match(w))
      S(w.meta.arg.endpointName, x, w.meta.requestId, w.meta.arg.originalArgs);
    else if (t.internalActions.cacheEntriesUpserted.match(w))
      for (const {
        queryDescription: A,
        value: I
      } of w.payload) {
        const {
          endpointName: M,
          originalArgs: B,
          queryCacheKey: L
        } = A;
        S(M, L, w.meta.requestId, B), h(L, I, {});
      }
    else if (a.pending.match(w))
      _.getState()[e].mutations[x] && b(w.meta.arg.endpointName, w.meta.arg.originalArgs, x, _, w.meta.requestId);
    else if (u(w))
      h(x, w.payload, w.meta.baseQueryMeta);
    else if (t.internalActions.removeQueryResult.match(w) || t.internalActions.removeMutationResult.match(w))
      p(x);
    else if (t.util.resetApiState.match(w))
      for (const A of Object.keys(f))
        p(A);
  };
  function y(w) {
    return l(w) ? w.meta.arg.queryCacheKey : c(w) ? w.meta.arg.fixedCacheKey ?? w.meta.requestId : t.internalActions.removeQueryResult.match(w) ? w.payload.queryCacheKey : t.internalActions.removeMutationResult.match(w) ? sk(w.payload) : "";
  }
  function b(w, _, C, x, S) {
    const A = r.endpointDefinitions[w], I = A == null ? void 0 : A.onCacheEntryAdded;
    if (!I) return;
    const M = {}, B = new Promise((k) => {
      M.cacheEntryRemoved = k;
    }), L = Promise.race([new Promise((k) => {
      M.valueResolved = k;
    }), B.then(() => {
      throw E6e;
    })]);
    L.catch(() => {
    }), f[C] = M;
    const N = t.endpoints[w].select(A.type === "query" ? _ : C), d = x.dispatch((k, O, G) => G), m = {
      ...x,
      getCacheEntry: () => N(x.getState()),
      requestId: S,
      extra: d,
      updateCachedData: A.type === "query" ? (k) => x.dispatch(t.util.updateQueryData(w, _, k)) : void 0,
      cacheDataLoaded: L,
      cacheEntryRemoved: B
    }, v = I(_, m);
    Promise.resolve(v).catch((k) => {
      if (k !== E6e)
        throw k;
    });
  }
  return g;
}, O9t = ({
  api: t,
  context: {
    apiUid: e
  },
  reducerPath: r
}) => (n, a) => {
  var i, o;
  t.util.resetApiState.match(n) && a.dispatch(t.internalActions.middlewareRegistered(e)), typeof Ar < "u" && Ar.env.NODE_ENV === "development" && t.internalActions.middlewareRegistered.match(n) && n.payload === e && ((o = (i = a.getState()[r]) == null ? void 0 : i.config) == null ? void 0 : o.middlewareRegistered) === "conflict" && console.warn(`There is a mismatch between slice and middleware for the reducerPath "${r}".
You can only have one api per reducer path, this will lead to crashes in various situations!${r === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""}`);
}, B9t = ({
  reducerPath: t,
  context: e,
  context: {
    endpointDefinitions: r
  },
  mutationThunk: n,
  queryThunk: a,
  api: i,
  assertTagType: o,
  refetchQuery: s,
  internalState: l
}) => {
  const {
    removeQueryResult: c
  } = i.internalActions, u = Nm(Uv(n), iz(n)), f = Nm(Uv(n, a), B7(n, a));
  let h = [];
  const p = (b, w) => {
    u(b) ? y(XWe(b, "invalidatesTags", r, o), w) : f(b) ? y([], w) : i.util.invalidateTags.match(b) && y(w1e(b.payload, void 0, void 0, void 0, void 0, o), w);
  };
  function g(b) {
    var C;
    const {
      queries: w,
      mutations: _
    } = b;
    for (const x of [w, _])
      for (const S in x)
        if (((C = x[S]) == null ? void 0 : C.status) === "pending") return !0;
    return !1;
  }
  function y(b, w) {
    const _ = w.getState(), C = _[t];
    if (h.push(...b), C.config.invalidationBehavior === "delayed" && g(C))
      return;
    const x = h;
    if (h = [], x.length === 0) return;
    const S = i.util.selectInvalidatedBy(_, x);
    e.batch(() => {
      const A = Array.from(S.values());
      for (const {
        queryCacheKey: I
      } of A) {
        const M = C.queries[I], B = l.currentSubscriptions[I] ?? {};
        M && (c7(B) === 0 ? w.dispatch(c({
          queryCacheKey: I
        })) : M.status !== "uninitialized" && w.dispatch(s(M)));
      }
    });
  }
  return p;
}, N9t = ({
  reducerPath: t,
  queryThunk: e,
  api: r,
  refetchQuery: n,
  internalState: a
}) => {
  const i = {}, o = (h, p) => {
    (r.internalActions.updateSubscriptionOptions.match(h) || r.internalActions.unsubscribeQueryResult.match(h)) && l(h.payload, p), (e.pending.match(h) || e.rejected.match(h) && h.meta.condition) && l(h.meta.arg, p), (e.fulfilled.match(h) || e.rejected.match(h) && !h.meta.condition) && s(h.meta.arg, p), r.util.resetApiState.match(h) && u();
  };
  function s({
    queryCacheKey: h
  }, p) {
    const g = p.getState()[t], y = g.queries[h], b = a.currentSubscriptions[h];
    if (!y || y.status === "uninitialized") return;
    const {
      lowestPollingInterval: w,
      skipPollingIfUnfocused: _
    } = f(b);
    if (!Number.isFinite(w)) return;
    const C = i[h];
    C != null && C.timeout && (clearTimeout(C.timeout), C.timeout = void 0);
    const x = Date.now() + w;
    i[h] = {
      nextPollTimestamp: x,
      pollingInterval: w,
      timeout: setTimeout(() => {
        (g.config.focused || !_) && p.dispatch(n(y)), s({
          queryCacheKey: h
        }, p);
      }, w)
    };
  }
  function l({
    queryCacheKey: h
  }, p) {
    const y = p.getState()[t].queries[h], b = a.currentSubscriptions[h];
    if (!y || y.status === "uninitialized")
      return;
    const {
      lowestPollingInterval: w
    } = f(b);
    if (!Number.isFinite(w)) {
      c(h);
      return;
    }
    const _ = i[h], C = Date.now() + w;
    (!_ || C < _.nextPollTimestamp) && s({
      queryCacheKey: h
    }, p);
  }
  function c(h) {
    const p = i[h];
    p != null && p.timeout && clearTimeout(p.timeout), delete i[h];
  }
  function u() {
    for (const h of Object.keys(i))
      c(h);
  }
  function f(h = {}) {
    let p = !1, g = Number.POSITIVE_INFINITY;
    for (let y in h)
      h[y].pollingInterval && (g = Math.min(h[y].pollingInterval, g), p = h[y].skipPollingIfUnfocused || p);
    return {
      lowestPollingInterval: g,
      skipPollingIfUnfocused: p
    };
  }
  return o;
}, $9t = ({
  api: t,
  context: e,
  queryThunk: r,
  mutationThunk: n
}) => {
  const a = p1e(r, n), i = B7(r, n), o = Uv(r, n), s = {};
  return (c, u) => {
    var f, h;
    if (a(c)) {
      const {
        requestId: p,
        arg: {
          endpointName: g,
          originalArgs: y
        }
      } = c.meta, b = e.endpointDefinitions[g], w = b == null ? void 0 : b.onQueryStarted;
      if (w) {
        const _ = {}, C = new Promise((I, M) => {
          _.resolve = I, _.reject = M;
        });
        C.catch(() => {
        }), s[p] = _;
        const x = t.endpoints[g].select(b.type === "query" ? y : p), S = u.dispatch((I, M, B) => B), A = {
          ...u,
          getCacheEntry: () => x(u.getState()),
          requestId: p,
          extra: S,
          updateCachedData: b.type === "query" ? (I) => u.dispatch(t.util.updateQueryData(g, y, I)) : void 0,
          queryFulfilled: C
        };
        w(y, A);
      }
    } else if (o(c)) {
      const {
        requestId: p,
        baseQueryMeta: g
      } = c.meta;
      (f = s[p]) == null || f.resolve({
        data: c.payload,
        meta: g
      }), delete s[p];
    } else if (i(c)) {
      const {
        requestId: p,
        rejectedWithValue: g,
        baseQueryMeta: y
      } = c.meta;
      (h = s[p]) == null || h.reject({
        error: c.payload ?? c.error,
        isUnhandledError: !g,
        meta: y
      }), delete s[p];
    }
  };
}, D9t = ({
  reducerPath: t,
  context: e,
  api: r,
  refetchQuery: n,
  internalState: a
}) => {
  const {
    removeQueryResult: i
  } = r.internalActions, o = (l, c) => {
    b1e.match(l) && s(c, "refetchOnFocus"), x1e.match(l) && s(c, "refetchOnReconnect");
  };
  function s(l, c) {
    const u = l.getState()[t], f = u.queries, h = a.currentSubscriptions;
    e.batch(() => {
      for (const p of Object.keys(h)) {
        const g = f[p], y = h[p];
        if (!y || !g) continue;
        (Object.values(y).some((w) => w[c] === !0) || Object.values(y).every((w) => w[c] === void 0) && u.config[c]) && (c7(y) === 0 ? l.dispatch(i({
          queryCacheKey: p
        })) : g.status !== "uninitialized" && l.dispatch(n(g)));
      }
    });
  }
  return o;
};
function L9t(t) {
  const {
    reducerPath: e,
    queryThunk: r,
    api: n,
    context: a
  } = t, {
    apiUid: i
  } = a, o = {
    invalidateTags: C1(`${e}/invalidateTags`)
  }, s = (f) => f.type.startsWith(`${e}/`), l = [O9t, P9t, B9t, N9t, R9t, $9t];
  return {
    middleware: (f) => {
      let h = !1;
      const g = {
        ...t,
        internalState: {
          currentSubscriptions: {}
        },
        refetchQuery: u,
        isThisApiSliceAction: s
      }, y = l.map((_) => _(g)), b = E9t(g), w = D9t(g);
      return (_) => (C) => {
        if (!c1e(C))
          return _(C);
        h || (h = !0, f.dispatch(n.internalActions.middlewareRegistered(i)));
        const x = {
          ...f,
          next: _
        }, S = f.getState(), [A, I] = b(C, x, S);
        let M;
        if (A ? M = _(C) : M = I, f.getState()[e] && (w(C, x, S), s(C) || a.hasRehydrationInfo(C)))
          for (const B of y)
            B(C, x, S);
        return M;
      };
    },
    actions: o
  };
  function u(f) {
    return t.api.endpoints[f.endpointName].initiate(f.originalArgs, {
      subscribe: !1,
      forceRefetch: !0
    });
  }
}
var I6e = /* @__PURE__ */ Symbol(), tHe = ({
  createSelector: t = h1e
} = {}) => ({
  name: I6e,
  init(e, {
    baseQuery: r,
    tagTypes: n,
    reducerPath: a,
    serializeQueryArgs: i,
    keepUnusedDataFor: o,
    refetchOnMountOrArgChange: s,
    refetchOnFocus: l,
    refetchOnReconnect: c,
    invalidationBehavior: u
  }, f) {
    Z6t();
    const h = (W) => (typeof Ar < "u" && Ar.env.NODE_ENV === "development" && (n.includes(W.type) || console.error(`Tag type '${W.type}' was used, but not specified in \`tagTypes\`!`)), W);
    Object.assign(e, {
      reducerPath: a,
      endpoints: {},
      internalActions: {
        onOnline: x1e,
        onOffline: JWe,
        onFocus: b1e,
        onFocusLost: ZWe
      },
      util: {}
    });
    const p = T9t({
      serializeQueryArgs: i,
      reducerPath: a,
      createSelector: t
    }), {
      selectInvalidatedBy: g,
      selectCachedArgsForQuery: y,
      buildQuerySelector: b,
      buildInfiniteQuerySelector: w,
      buildMutationSelector: _
    } = p;
    Np(e.util, {
      selectInvalidatedBy: g,
      selectCachedArgsForQuery: y
    });
    const {
      queryThunk: C,
      infiniteQueryThunk: x,
      mutationThunk: S,
      patchQueryData: A,
      updateQueryData: I,
      upsertQueryData: M,
      prefetch: B,
      buildMatchThunkActions: L
    } = k9t({
      baseQuery: r,
      reducerPath: a,
      context: f,
      api: e,
      serializeQueryArgs: i,
      assertTagType: h,
      selectors: p
    }), {
      reducer: N,
      actions: d
    } = A9t({
      context: f,
      queryThunk: C,
      mutationThunk: S,
      serializeQueryArgs: i,
      reducerPath: a,
      assertTagType: h,
      config: {
        refetchOnFocus: l,
        refetchOnReconnect: c,
        refetchOnMountOrArgChange: s,
        keepUnusedDataFor: o,
        reducerPath: a,
        invalidationBehavior: u
      }
    });
    Np(e.util, {
      patchQueryData: A,
      updateQueryData: I,
      upsertQueryData: M,
      prefetch: B,
      resetApiState: d.resetApiState,
      upsertQueryEntries: d.cacheEntriesUpserted
    }), Np(e.internalActions, d);
    const {
      middleware: m,
      actions: v
    } = L9t({
      reducerPath: a,
      context: f,
      queryThunk: C,
      mutationThunk: S,
      infiniteQueryThunk: x,
      api: e,
      assertTagType: h,
      selectors: p
    });
    Np(e.util, v), Np(e, {
      reducer: N,
      middleware: m
    });
    const {
      buildInitiateQuery: k,
      buildInitiateInfiniteQuery: O,
      buildInitiateMutation: G,
      getRunningMutationThunk: H,
      getRunningMutationsThunk: j,
      getRunningQueriesThunk: F,
      getRunningQueryThunk: z
    } = S9t({
      queryThunk: C,
      mutationThunk: S,
      infiniteQueryThunk: x,
      api: e,
      serializeQueryArgs: i,
      context: f
    });
    return Np(e.util, {
      getRunningMutationThunk: H,
      getRunningMutationsThunk: j,
      getRunningQueryThunk: z,
      getRunningQueriesThunk: F
    }), {
      name: I6e,
      injectEndpoint(W, U) {
        var Y;
        const V = (Y = e.endpoints)[W] ?? (Y[W] = {});
        C1e(U) && Np(V, {
          name: W,
          select: b(W, U),
          initiate: k(W, U)
        }, L(C, W)), x9t(U) && Np(V, {
          name: W,
          select: _(),
          initiate: G(W)
        }, L(S, W)), sz(U) && Np(V, {
          name: W,
          select: w(W, U),
          initiate: O(W, U)
        }, L(C, W));
      }
    };
  }
});
tHe();
function ZO(t) {
  return t.replace(t[0], t[0].toUpperCase());
}
function j9t(t) {
  let e = 0;
  for (const r in t)
    e++;
  return e;
}
function F9t(t) {
  return t.type === "query";
}
function z9t(t) {
  return t.type === "mutation";
}
function rHe(t) {
  return t.type === "infinitequery";
}
function Ww(t, ...e) {
  return Object.assign(t, ...e);
}
var _K = Symbol();
function M6e(t, e, r, n) {
  const a = fa(() => ({
    queryArgs: t,
    serialized: typeof t == "object" ? e({
      queryArgs: t,
      endpointDefinition: r,
      endpointName: n
    }) : t
  }), [t, e, r, n]), i = Zt(a);
  return Ut(() => {
    i.current.serialized !== a.serialized && (i.current = a);
  }, [a]), i.current.serialized === a.serialized ? i.current.queryArgs : t;
}
function JO(t) {
  const e = Zt(t);
  return Ut(() => {
    w_(e.current, t) || (e.current = t);
  }, [t]), w_(e.current, t) ? e.current : t;
}
var G9t = () => typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", W9t = /* @__PURE__ */ G9t(), H9t = () => typeof navigator < "u" && navigator.product === "ReactNative", U9t = /* @__PURE__ */ H9t(), V9t = () => W9t || U9t ? qh : Ut, q9t = /* @__PURE__ */ V9t(), P6e = (t) => t.isUninitialized ? {
  ...t,
  isUninitialized: !1,
  isFetching: !0,
  isLoading: t.data === void 0,
  status: VWe.pending
} : t;
function kK(t, ...e) {
  const r = {};
  return e.forEach((n) => {
    r[n] = t[n];
  }), r;
}
var AK = ["data", "status", "isLoading", "isSuccess", "isError", "error"];
function K9t({
  api: t,
  moduleOptions: {
    batch: e,
    hooks: {
      useDispatch: r,
      useSelector: n,
      useStore: a
    },
    unstable__sideEffectsInRender: i,
    createSelector: o
  },
  serializeQueryArgs: s,
  context: l
}) {
  const c = i ? (x) => x() : Ut;
  return {
    buildQueryHooks: w,
    buildInfiniteQueryHooks: _,
    buildMutationHook: C,
    usePrefetch: h
  };
  function u(x, S, A) {
    if (S != null && S.endpointName && x.isUninitialized) {
      const {
        endpointName: d
      } = S, m = l.endpointDefinitions[d];
      A !== tm && s({
        queryArgs: S.originalArgs,
        endpointDefinition: m,
        endpointName: d
      }) === s({
        queryArgs: A,
        endpointDefinition: m,
        endpointName: d
      }) && (S = void 0);
    }
    let I = x.isSuccess ? x.data : S == null ? void 0 : S.data;
    I === void 0 && (I = x.data);
    const M = I !== void 0, B = x.isLoading, L = (!S || S.isLoading || S.isUninitialized) && !M && B, N = x.isSuccess || M && (B && !(S != null && S.isError) || x.isUninitialized);
    return {
      ...x,
      data: I,
      currentData: x.data,
      isFetching: B,
      isLoading: L,
      isSuccess: N
    };
  }
  function f(x, S, A) {
    if (S != null && S.endpointName && x.isUninitialized) {
      const {
        endpointName: d
      } = S, m = l.endpointDefinitions[d];
      s({
        queryArgs: S.originalArgs,
        endpointDefinition: m,
        endpointName: d
      }) === s({
        queryArgs: A,
        endpointDefinition: m,
        endpointName: d
      }) && (S = void 0);
    }
    let I = x.isSuccess ? x.data : S == null ? void 0 : S.data;
    I === void 0 && (I = x.data);
    const M = I !== void 0, B = x.isLoading, L = (!S || S.isLoading || S.isUninitialized) && !M && B, N = x.isSuccess || B && M;
    return {
      ...x,
      data: I,
      currentData: x.data,
      isFetching: B,
      isLoading: L,
      isSuccess: N
    };
  }
  function h(x, S) {
    const A = r(), I = JO(S);
    return sr((M, B) => A(t.util.prefetch(x, M, {
      ...I,
      ...B
    })), [x, A, I]);
  }
  function p(x, S, {
    refetchOnReconnect: A,
    refetchOnFocus: I,
    refetchOnMountOrArgChange: M,
    skip: B = !1,
    pollingInterval: L = 0,
    skipPollingIfUnfocused: N = !1,
    ...d
  } = {}) {
    const {
      initiate: m
    } = t.endpoints[x], v = r(), k = Zt(void 0);
    if (!k.current) {
      const Y = v(t.internalActions.internal_getRTKQSubscriptions());
      if (Ar.env.NODE_ENV !== "production" && (typeof Y != "object" || typeof (Y == null ? void 0 : Y.type) == "string"))
        throw new Error(Ar.env.NODE_ENV === "production" ? go(37) : `Warning: Middleware for RTK-Query API at reducerPath "${t.reducerPath}" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
      k.current = Y;
    }
    const O = M6e(
      B ? tm : S,
      // Even if the user provided a per-endpoint `serializeQueryArgs` with
      // a consistent return value, _here_ we want to use the default behavior
      // so we can tell if _anything_ actually changed. Otherwise, we can end up
      // with a case where the query args did change but the serialization doesn't,
      // and then we never try to initiate a refetch.
      Ile,
      l.endpointDefinitions[x],
      x
    ), G = JO({
      refetchOnReconnect: A,
      refetchOnFocus: I,
      pollingInterval: L,
      skipPollingIfUnfocused: N
    }), H = Zt(!1), j = d.initialPageParam, F = JO(j), z = Zt(void 0);
    let {
      queryCacheKey: W,
      requestId: U
    } = z.current || {}, Z = !1;
    W && U && (Z = k.current.isRequestSubscribed(W, U));
    const V = !Z && H.current;
    return c(() => {
      H.current = Z;
    }), c(() => {
      V && (z.current = void 0);
    }, [V]), c(() => {
      var ce;
      const Y = z.current;
      if (typeof Ar < "u" && Ar.env.NODE_ENV === "removeMeOnCompilation" && console.log(V), O === tm) {
        Y == null || Y.unsubscribe(), z.current = void 0;
        return;
      }
      const ge = (ce = z.current) == null ? void 0 : ce.subscriptionOptions;
      if (!Y || Y.arg !== O) {
        Y == null || Y.unsubscribe();
        const ee = v(m(O, {
          subscriptionOptions: G,
          forceRefetch: M,
          ...rHe(l.endpointDefinitions[x]) ? {
            initialPageParam: F
          } : {}
        }));
        z.current = ee;
      } else G !== ge && Y.updateSubscriptionOptions(G);
    }, [v, m, M, O, G, V, F, x]), [z, v, m, G];
  }
  function g(x, S) {
    return (I, {
      skip: M = !1,
      selectFromResult: B
    } = {}) => {
      const {
        select: L
      } = t.endpoints[x], N = M6e(M ? tm : I, s, l.endpointDefinitions[x], x), d = Zt(void 0), m = fa(() => (
        // Normally ts-ignores are bad and should be avoided, but we're
        // already casting this selector to be `Selector<any>` anyway,
        // so the inconsistencies don't matter here
        // @ts-ignore
        o([
          // @ts-ignore
          L(N),
          (H, j) => j,
          (H) => N
        ], S, {
          memoizeOptions: {
            resultEqualityCheck: w_
          }
        })
      ), [L, N]), v = fa(() => B ? o([m], B, {
        devModeChecks: {
          identityFunctionCheck: "never"
        }
      }) : m, [m, B]), k = n((H) => v(H, d.current), w_), O = a(), G = m(O.getState(), d.current);
      return q9t(() => {
        d.current = G;
      }, [G]), k;
    };
  }
  function y(x) {
    Ut(() => () => {
      var S, A;
      (A = (S = x.current) == null ? void 0 : S.unsubscribe) == null || A.call(S), x.current = void 0;
    }, [x]);
  }
  function b(x) {
    if (!x.current) throw new Error(Ar.env.NODE_ENV === "production" ? go(38) : "Cannot refetch a query that has not been started yet.");
    return x.current.refetch();
  }
  function w(x) {
    const S = (M, B = {}) => {
      const [L] = p(x, M, B);
      return y(L), fa(() => ({
        /**
         * A method to manually refetch data for the query
         */
        refetch: () => b(L)
      }), [L]);
    }, A = ({
      refetchOnReconnect: M,
      refetchOnFocus: B,
      pollingInterval: L = 0,
      skipPollingIfUnfocused: N = !1
    } = {}) => {
      const {
        initiate: d
      } = t.endpoints[x], m = r(), [v, k] = Yt(_K), O = Zt(void 0), G = JO({
        refetchOnReconnect: M,
        refetchOnFocus: B,
        pollingInterval: L,
        skipPollingIfUnfocused: N
      });
      c(() => {
        var W, U;
        const z = (W = O.current) == null ? void 0 : W.subscriptionOptions;
        G !== z && ((U = O.current) == null || U.updateSubscriptionOptions(G));
      }, [G]);
      const H = Zt(G);
      c(() => {
        H.current = G;
      }, [G]);
      const j = sr(function(z, W = !1) {
        let U;
        return e(() => {
          var Z;
          (Z = O.current) == null || Z.unsubscribe(), O.current = U = m(d(z, {
            subscriptionOptions: H.current,
            forceRefetch: !W
          })), k(z);
        }), U;
      }, [m, d]), F = sr(() => {
        var z, W;
        (z = O.current) != null && z.queryCacheKey && m(t.internalActions.removeQueryResult({
          queryCacheKey: (W = O.current) == null ? void 0 : W.queryCacheKey
        }));
      }, [m]);
      return Ut(() => () => {
        var z;
        (z = O == null ? void 0 : O.current) == null || z.unsubscribe();
      }, []), Ut(() => {
        v !== _K && !O.current && j(v, !0);
      }, [v, j]), fa(() => [j, v, {
        reset: F
      }], [j, v, F]);
    }, I = g(x, u);
    return {
      useQueryState: I,
      useQuerySubscription: S,
      useLazyQuerySubscription: A,
      useLazyQuery(M) {
        const [B, L, {
          reset: N
        }] = A(M), d = I(L, {
          ...M,
          skip: L === _K
        }), m = fa(() => ({
          lastArg: L
        }), [L]);
        return fa(() => [B, {
          ...d,
          reset: N
        }, m], [B, d, N, m]);
      },
      useQuery(M, B) {
        const L = S(M, B), N = I(M, {
          selectFromResult: M === tm || B != null && B.skip ? void 0 : P6e,
          ...B
        }), d = kK(N, ...AK);
        return Mv(d), fa(() => ({
          ...N,
          ...L
        }), [N, L]);
      }
    };
  }
  function _(x) {
    const S = (I, M = {}) => {
      const [B, L, N, d] = p(x, I, M), m = Zt(d);
      c(() => {
        m.current = d;
      }, [d]);
      const v = sr(function(k, O) {
        let G;
        return e(() => {
          var H;
          (H = B.current) == null || H.unsubscribe(), B.current = G = L(N(k, {
            subscriptionOptions: m.current,
            direction: O
          }));
        }), G;
      }, [B, L, N]);
      return y(B), fa(() => ({
        trigger: v,
        /**
         * A method to manually refetch data for the query
         */
        refetch: () => b(B),
        fetchNextPage: () => v(I, "forward"),
        fetchPreviousPage: () => v(I, "backward")
      }), [B, v, I]);
    }, A = g(x, f);
    return {
      useInfiniteQueryState: A,
      useInfiniteQuerySubscription: S,
      useInfiniteQuery(I, M) {
        const {
          refetch: B,
          fetchNextPage: L,
          fetchPreviousPage: N
        } = S(I, M), d = A(I, {
          selectFromResult: I === tm || M != null && M.skip ? void 0 : P6e,
          ...M
        }), m = kK(d, ...AK, "hasNextPage", "hasPreviousPage");
        return Mv(m), fa(() => ({
          ...d,
          fetchNextPage: L,
          fetchPreviousPage: N,
          refetch: B
        }), [d, L, N, B]);
      }
    };
  }
  function C(x) {
    return ({
      selectFromResult: S,
      fixedCacheKey: A
    } = {}) => {
      const {
        select: I,
        initiate: M
      } = t.endpoints[x], B = r(), [L, N] = Yt();
      Ut(() => () => {
        L != null && L.arg.fixedCacheKey || L == null || L.reset();
      }, [L]);
      const d = sr(function(z) {
        const W = B(M(z, {
          fixedCacheKey: A
        }));
        return N(W), W;
      }, [B, M, A]), {
        requestId: m
      } = L || {}, v = fa(() => I({
        fixedCacheKey: A,
        requestId: L == null ? void 0 : L.requestId
      }), [A, L, I]), k = fa(() => S ? o([v], S) : v, [S, v]), O = n(k, w_), G = A == null ? L == null ? void 0 : L.arg.originalArgs : void 0, H = sr(() => {
        e(() => {
          L && N(void 0), A && B(t.internalActions.removeMutationResult({
            requestId: m,
            fixedCacheKey: A
          }));
        });
      }, [B, A, L, m]), j = kK(O, ...AK, "endpointName");
      Mv(j);
      const F = fa(() => ({
        ...O,
        originalArgs: G,
        reset: H
      }), [O, G, H]);
      return fa(() => [d, F], [d, F]);
    };
  }
}
var Z9t = /* @__PURE__ */ Symbol(), J9t = ({
  batch: t = u9t,
  hooks: e = {
    useDispatch: UWe,
    useSelector: zWe,
    useStore: HWe
  },
  createSelector: r = h1e,
  unstable__sideEffectsInRender: n = !1,
  ...a
} = {}) => {
  if (Ar.env.NODE_ENV !== "production") {
    const i = ["useDispatch", "useSelector", "useStore"];
    let o = !1;
    for (const s of i)
      if (j9t(a) > 0 && (a[s] && (o || (console.warn("As of RTK 2.0, the hooks now need to be specified as one object, provided under a `hooks` key:\n`reactHooksModule({ hooks: { useDispatch, useSelector, useStore } })`"), o = !0)), e[s] = a[s]), typeof e[s] != "function")
        throw new Error(Ar.env.NODE_ENV === "production" ? go(36) : `When using custom hooks for context, all ${i.length} hooks need to be provided: ${i.join(", ")}.
Hook ${s} was either not provided or not a function.`);
  }
  return {
    name: Z9t,
    init(i, {
      serializeQueryArgs: o
    }, s) {
      const l = i, {
        buildQueryHooks: c,
        buildInfiniteQueryHooks: u,
        buildMutationHook: f,
        usePrefetch: h
      } = K9t({
        api: i,
        moduleOptions: {
          batch: t,
          hooks: e,
          unstable__sideEffectsInRender: n,
          createSelector: r
        },
        serializeQueryArgs: o,
        context: s
      });
      return Ww(l, {
        usePrefetch: h
      }), Ww(s, {
        batch: t
      }), {
        injectEndpoint(p, g) {
          if (F9t(g)) {
            const {
              useQuery: y,
              useLazyQuery: b,
              useLazyQuerySubscription: w,
              useQueryState: _,
              useQuerySubscription: C
            } = c(p);
            Ww(l.endpoints[p], {
              useQuery: y,
              useLazyQuery: b,
              useLazyQuerySubscription: w,
              useQueryState: _,
              useQuerySubscription: C
            }), i[`use${ZO(p)}Query`] = y, i[`useLazy${ZO(p)}Query`] = b;
          }
          if (z9t(g)) {
            const y = f(p);
            Ww(l.endpoints[p], {
              useMutation: y
            }), i[`use${ZO(p)}Mutation`] = y;
          } else if (rHe(g)) {
            const {
              useInfiniteQuery: y,
              useInfiniteQuerySubscription: b,
              useInfiniteQueryState: w
            } = u(p);
            Ww(l.endpoints[p], {
              useInfiniteQuery: y,
              useInfiniteQuerySubscription: b,
              useInfiniteQueryState: w
            }), i[`use${ZO(p)}InfiniteQuery`] = y;
          }
        }
      };
    }
  };
}, nHe = /* @__PURE__ */ eHe(tHe(), J9t()), Yi;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(Yi || (Yi = {}));
var Mle;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Mle || (Mle = {}));
const yn = Yi.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), rm = (t) => {
  switch (typeof t) {
    case "undefined":
      return yn.undefined;
    case "string":
      return yn.string;
    case "number":
      return isNaN(t) ? yn.nan : yn.number;
    case "boolean":
      return yn.boolean;
    case "function":
      return yn.function;
    case "bigint":
      return yn.bigint;
    case "symbol":
      return yn.symbol;
    case "object":
      return Array.isArray(t) ? yn.array : t === null ? yn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? yn.promise : typeof Map < "u" && t instanceof Map ? yn.map : typeof Set < "u" && t instanceof Set ? yn.set : typeof Date < "u" && t instanceof Date ? yn.date : yn.object;
    default:
      return yn.unknown;
  }
}, Br = Yi.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Y9t = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let w1 = class aHe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof aHe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Yi.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
w1.create = (t) => new w1(t);
const $7 = (t, e) => {
  let r;
  switch (t.code) {
    case Br.invalid_type:
      t.received === yn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Br.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, Yi.jsonStringifyReplacer)}`;
      break;
    case Br.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Yi.joinValues(t.keys, ", ")}`;
      break;
    case Br.invalid_union:
      r = "Invalid input";
      break;
    case Br.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Yi.joinValues(t.options)}`;
      break;
    case Br.invalid_enum_value:
      r = `Invalid enum value. Expected ${Yi.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Br.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Br.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Br.invalid_date:
      r = "Invalid date";
      break;
    case Br.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : Yi.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Br.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Br.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Br.custom:
      r = "Invalid input";
      break;
    case Br.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Br.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Br.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, Yi.assertNever(t);
  }
  return { message: r };
};
let iHe = $7;
function X9t(t) {
  iHe = t;
}
function J$() {
  return iHe;
}
const Y$ = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, Q9t = [];
function nn(t, e) {
  const r = J$(), n = Y$({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === $7 ? void 0 : $7
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let bd = class oHe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return _a;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return oHe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return _a;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const _a = Object.freeze({
  status: "aborted"
}), T9 = (t) => ({ status: "dirty", value: t }), Au = (t) => ({ status: "valid", value: t }), Ple = (t) => t.status === "aborted", Rle = (t) => t.status === "dirty", t5 = (t) => t.status === "valid", lk = (t) => typeof Promise < "u" && t instanceof Promise;
function X$(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function sHe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var On;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(On || (On = {}));
var TS, ES;
let Ih = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const R6e = (t, e) => {
  if (t5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new w1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function si(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let _i = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return rm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: rm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new bd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: rm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (lk(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: rm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return R6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: rm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return t5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => t5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: rm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (lk(a) ? a : Promise.resolve(a));
    return R6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Br.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new N1({
      schema: this,
      typeName: pa.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return lh.create(this, this._def);
  }
  nullable() {
    return Kv.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return r5.create(this);
  }
  promise() {
    return j7.create(this, this._def);
  }
  or(e) {
    return mk.create([this, e], this._def);
  }
  and(e) {
    return gk.create(this, e, this._def);
  }
  transform(e) {
    return new N1({
      ...si(this._def),
      schema: this,
      typeName: pa.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new xk({
      ...si(this._def),
      innerType: this,
      defaultValue: r,
      typeName: pa.ZodDefault
    });
  }
  brand() {
    return new S1e({
      typeName: pa.ZodBranded,
      type: this,
      ...si(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Ck({
      ...si(this._def),
      innerType: this,
      catchValue: r,
      typeName: pa.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return _1e.create(this, e);
  }
  readonly() {
    return wk.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const e7t = /^c[^\s-]{8,}$/i, t7t = /^[0-9a-z]+$/, r7t = /^[0-9A-HJKMNP-TV-Z]{26}$/i, n7t = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, a7t = /^[a-z0-9_-]{21}$/i, i7t = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, o7t = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, s7t = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, l7t = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let TK;
const c7t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, u7t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, d7t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, f7t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, h7t = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, p7t = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, lHe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", m7t = new RegExp(`^${lHe}$`);
function cHe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function g7t(t) {
  return new RegExp(`^${cHe(t)}$`);
}
function uHe(t) {
  let e = `${lHe}T${cHe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function v7t(t, e) {
  return !!((e === "v4" || !e) && c7t.test(t) || (e === "v6" || !e) && d7t.test(t));
}
function y7t(t, e) {
  if (!i7t.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function b7t(t, e) {
  return !!((e === "v4" || !e) && u7t.test(t) || (e === "v6" || !e) && f7t.test(t));
}
let D7 = class IS extends _i {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== yn.string) {
      const i = this._getOrReturnCtx(e);
      return nn(i, {
        code: Br.invalid_type,
        expected: yn.string,
        received: i.parsedType
      }), _a;
    }
    const n = new bd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), nn(a, {
          code: Br.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), nn(a, {
          code: Br.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? nn(a, {
          code: Br.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && nn(a, {
          code: Br.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        s7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "email",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        TK || (TK = new RegExp(l7t, "u")), TK.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "emoji",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        n7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "uuid",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        a7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "nanoid",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        e7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "cuid",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        t7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "cuid2",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        r7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
          validation: "ulid",
          code: Br.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), nn(a, {
            validation: "url",
            code: Br.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "regex",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? uHe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? m7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? g7t(i).test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? o7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "duration",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? v7t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "ip",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? y7t(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "jwt",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? b7t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "cidr",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? h7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "base64",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? p7t.test(e.data) || (a = this._getOrReturnCtx(e, a), nn(a, {
        validation: "base64url",
        code: Br.invalid_string,
        message: i.message
      }), n.dirty()) : Yi.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Br.invalid_string,
      ...On.errToObj(n)
    });
  }
  _addCheck(e) {
    return new IS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...On.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...On.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...On.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...On.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...On.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...On.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...On.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...On.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...On.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...On.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...On.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...On.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...On.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...On.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...On.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...On.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...On.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...On.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...On.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...On.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...On.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...On.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...On.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, On.errToObj(e));
  }
  trim() {
    return new IS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new IS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new IS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
D7.create = (t) => {
  var e;
  return new D7({
    checks: [],
    typeName: pa.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...si(t)
  });
};
function x7t(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let ck = class Ole extends _i {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== yn.number) {
      const i = this._getOrReturnCtx(e);
      return nn(i, {
        code: Br.invalid_type,
        expected: yn.number,
        received: i.parsedType
      }), _a;
    }
    let n;
    const a = new bd();
    for (const i of this._def.checks)
      i.kind === "int" ? Yi.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? x7t(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.not_finite,
        message: i.message
      }), a.dirty()) : Yi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, On.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, On.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, On.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, On.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Ole({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: On.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ole({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: On.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: On.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: On.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: On.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: On.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: On.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: On.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: On.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: On.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Yi.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
ck.create = (t) => new ck({
  checks: [],
  typeName: pa.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...si(t)
});
let uk = class Ble extends _i {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== yn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new bd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), nn(n, {
        code: Br.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : Yi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return nn(r, {
      code: Br.invalid_type,
      expected: yn.bigint,
      received: r.parsedType
    }), _a;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, On.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, On.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, On.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, On.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Ble({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: On.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ble({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: On.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: On.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: On.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: On.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: On.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
uk.create = (t) => {
  var e;
  return new uk({
    checks: [],
    typeName: pa.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...si(t)
  });
};
let dk = class extends _i {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== yn.boolean) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.boolean,
        received: n.parsedType
      }), _a;
    }
    return Au(e.data);
  }
};
dk.create = (t) => new dk({
  typeName: pa.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...si(t)
});
let fk = class dHe extends _i {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== yn.date) {
      const i = this._getOrReturnCtx(e);
      return nn(i, {
        code: Br.invalid_type,
        expected: yn.date,
        received: i.parsedType
      }), _a;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return nn(i, {
        code: Br.invalid_date
      }), _a;
    }
    const n = new bd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), nn(a, {
        code: Br.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : Yi.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new dHe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: On.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: On.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
fk.create = (t) => new fk({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: pa.ZodDate,
  ...si(t)
});
let Q$ = class extends _i {
  _parse(e) {
    if (this._getType(e) !== yn.symbol) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.symbol,
        received: n.parsedType
      }), _a;
    }
    return Au(e.data);
  }
};
Q$.create = (t) => new Q$({
  typeName: pa.ZodSymbol,
  ...si(t)
});
let hk = class extends _i {
  _parse(e) {
    if (this._getType(e) !== yn.undefined) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.undefined,
        received: n.parsedType
      }), _a;
    }
    return Au(e.data);
  }
};
hk.create = (t) => new hk({
  typeName: pa.ZodUndefined,
  ...si(t)
});
let pk = class extends _i {
  _parse(e) {
    if (this._getType(e) !== yn.null) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.null,
        received: n.parsedType
      }), _a;
    }
    return Au(e.data);
  }
};
pk.create = (t) => new pk({
  typeName: pa.ZodNull,
  ...si(t)
});
let L7 = class extends _i {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Au(e.data);
  }
};
L7.create = (t) => new L7({
  typeName: pa.ZodAny,
  ...si(t)
});
let Tb = class extends _i {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Au(e.data);
  }
};
Tb.create = (t) => new Tb({
  typeName: pa.ZodUnknown,
  ...si(t)
});
let $m = class extends _i {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return nn(r, {
      code: Br.invalid_type,
      expected: yn.never,
      received: r.parsedType
    }), _a;
  }
};
$m.create = (t) => new $m({
  typeName: pa.ZodNever,
  ...si(t)
});
let eD = class extends _i {
  _parse(e) {
    if (this._getType(e) !== yn.undefined) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.void,
        received: n.parsedType
      }), _a;
    }
    return Au(e.data);
  }
};
eD.create = (t) => new eD({
  typeName: pa.ZodVoid,
  ...si(t)
});
let r5 = class DN extends _i {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== yn.array)
      return nn(r, {
        code: Br.invalid_type,
        expected: yn.array,
        received: r.parsedType
      }), _a;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (nn(r, {
        code: o ? Br.too_big : Br.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (nn(r, {
      code: Br.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (nn(r, {
      code: Br.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Ih(r, o, r.path, s)))).then((o) => bd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Ih(r, o, r.path, s)));
    return bd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new DN({
      ...this._def,
      minLength: { value: e, message: On.toString(r) }
    });
  }
  max(e, r) {
    return new DN({
      ...this._def,
      maxLength: { value: e, message: On.toString(r) }
    });
  }
  length(e, r) {
    return new DN({
      ...this._def,
      exactLength: { value: e, message: On.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
r5.create = (t, e) => new r5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: pa.ZodArray,
  ...si(e)
});
function d9(t) {
  if (t instanceof nf) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = lh.create(d9(n));
    }
    return new nf({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof r5 ? new r5({
    ...t._def,
    type: d9(t.element)
  }) : t instanceof lh ? lh.create(d9(t.unwrap())) : t instanceof Kv ? Kv.create(d9(t.unwrap())) : t instanceof qv ? qv.create(t.items.map((e) => d9(e))) : t;
}
let nf = class Zf extends _i {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = Yi.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== yn.object) {
      const c = this._getOrReturnCtx(e);
      return nn(c, {
        code: Br.invalid_type,
        expected: yn.object,
        received: c.parsedType
      }), _a;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof $m && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Ih(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof $m) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (nn(a, {
          code: Br.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Ih(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => bd.mergeObjectSync(n, c)) : bd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return On.errToObj, new Zf({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = On.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Zf({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Zf({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Zf({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Zf({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: pa.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Zf({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return Yi.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Zf({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return Yi.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Zf({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return d9(this);
  }
  partial(e) {
    const r = {};
    return Yi.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Zf({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return Yi.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof lh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Zf({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return vHe(Yi.objectKeys(this.shape));
  }
};
nf.create = (t, e) => new nf({
  shape: () => t,
  unknownKeys: "strip",
  catchall: $m.create(),
  typeName: pa.ZodObject,
  ...si(e)
});
nf.strictCreate = (t, e) => new nf({
  shape: () => t,
  unknownKeys: "strict",
  catchall: $m.create(),
  typeName: pa.ZodObject,
  ...si(e)
});
nf.lazycreate = (t, e) => new nf({
  shape: t,
  unknownKeys: "strip",
  catchall: $m.create(),
  typeName: pa.ZodObject,
  ...si(e)
});
let mk = class extends _i {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new w1(s.ctx.common.issues));
      return nn(r, {
        code: Br.invalid_union,
        unionErrors: o
      }), _a;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new w1(l));
      return nn(r, {
        code: Br.invalid_union,
        unionErrors: s
      }), _a;
    }
  }
  get options() {
    return this._def.options;
  }
};
mk.create = (t, e) => new mk({
  options: t,
  typeName: pa.ZodUnion,
  ...si(e)
});
const Gp = (t) => t instanceof vk ? Gp(t.schema) : t instanceof N1 ? Gp(t.innerType()) : t instanceof yk ? [t.value] : t instanceof RI ? t.options : t instanceof bk ? Yi.objectValues(t.enum) : t instanceof xk ? Gp(t._def.innerType) : t instanceof hk ? [void 0] : t instanceof pk ? [null] : t instanceof lh ? [void 0, ...Gp(t.unwrap())] : t instanceof Kv ? [null, ...Gp(t.unwrap())] : t instanceof S1e || t instanceof wk ? Gp(t.unwrap()) : t instanceof Ck ? Gp(t._def.innerType) : [];
let fHe = class hHe extends _i {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== yn.object)
      return nn(r, {
        code: Br.invalid_type,
        expected: yn.object,
        received: r.parsedType
      }), _a;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (nn(r, {
      code: Br.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), _a);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Gp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new hHe({
      typeName: pa.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...si(n)
    });
  }
};
function Nle(t, e) {
  const r = rm(t), n = rm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === yn.object && n === yn.object) {
    const a = Yi.objectKeys(e), i = Yi.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Nle(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === yn.array && n === yn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Nle(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === yn.date && n === yn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let gk = class extends _i {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Ple(i) || Ple(o))
        return _a;
      const s = Nle(i.value, o.value);
      return s.valid ? ((Rle(i) || Rle(o)) && r.dirty(), { status: r.value, value: s.data }) : (nn(n, {
        code: Br.invalid_intersection_types
      }), _a);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
gk.create = (t, e, r) => new gk({
  left: t,
  right: e,
  typeName: pa.ZodIntersection,
  ...si(r)
});
let qv = class pHe extends _i {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== yn.array)
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.array,
        received: n.parsedType
      }), _a;
    if (n.data.length < this._def.items.length)
      return nn(n, {
        code: Br.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), _a;
    !this._def.rest && n.data.length > this._def.items.length && (nn(n, {
      code: Br.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Ih(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => bd.mergeArray(r, o)) : bd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new pHe({
      ...this._def,
      rest: e
    });
  }
};
qv.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new qv({
    items: t,
    typeName: pa.ZodTuple,
    rest: null,
    ...si(e)
  });
};
let mHe = class $le extends _i {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== yn.object)
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.object,
        received: n.parsedType
      }), _a;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Ih(n, s, n.path, s)),
        value: o._parse(new Ih(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? bd.mergeObjectAsync(r, a) : bd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof _i ? new $le({
      keyType: e,
      valueType: r,
      typeName: pa.ZodRecord,
      ...si(n)
    }) : new $le({
      keyType: D7.create(),
      valueType: e,
      typeName: pa.ZodRecord,
      ...si(r)
    });
  }
}, tD = class extends _i {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== yn.map)
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.map,
        received: n.parsedType
      }), _a;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Ih(n, s, n.path, [c, "key"])),
      value: i._parse(new Ih(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return _a;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return _a;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
tD.create = (t, e, r) => new tD({
  valueType: e,
  keyType: t,
  typeName: pa.ZodMap,
  ...si(r)
});
let rD = class Dle extends _i {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== yn.set)
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.set,
        received: n.parsedType
      }), _a;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (nn(n, {
      code: Br.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (nn(n, {
      code: Br.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return _a;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Ih(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new Dle({
      ...this._def,
      minSize: { value: e, message: On.toString(r) }
    });
  }
  max(e, r) {
    return new Dle({
      ...this._def,
      maxSize: { value: e, message: On.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
rD.create = (t, e) => new rD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: pa.ZodSet,
  ...si(e)
});
let gHe = class LN extends _i {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== yn.function)
      return nn(r, {
        code: Br.invalid_type,
        expected: yn.function,
        received: r.parsedType
      }), _a;
    function n(s, l) {
      return Y$({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          J$(),
          $7
        ].filter((c) => !!c),
        issueData: {
          code: Br.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return Y$({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          J$(),
          $7
        ].filter((c) => !!c),
        issueData: {
          code: Br.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof j7) {
      const s = this;
      return Au(async function(...l) {
        const c = new w1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Au(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new w1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new w1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new LN({
      ...this._def,
      args: qv.create(e).rest(Tb.create())
    });
  }
  returns(e) {
    return new LN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new LN({
      args: e || qv.create([]).rest(Tb.create()),
      returns: r || Tb.create(),
      typeName: pa.ZodFunction,
      ...si(n)
    });
  }
}, vk = class extends _i {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
vk.create = (t, e) => new vk({
  getter: t,
  typeName: pa.ZodLazy,
  ...si(e)
});
let yk = class extends _i {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return nn(r, {
        received: r.data,
        code: Br.invalid_literal,
        expected: this._def.value
      }), _a;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
yk.create = (t, e) => new yk({
  value: t,
  typeName: pa.ZodLiteral,
  ...si(e)
});
function vHe(t, e) {
  return new RI({
    values: t,
    typeName: pa.ZodEnum,
    ...si(e)
  });
}
let RI = class Lle extends _i {
  constructor() {
    super(...arguments), TS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return nn(r, {
        expected: Yi.joinValues(n),
        received: r.parsedType,
        code: Br.invalid_type
      }), _a;
    }
    if (X$(this, TS) || sHe(this, TS, new Set(this._def.values)), !X$(this, TS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return nn(r, {
        received: r.data,
        code: Br.invalid_enum_value,
        options: n
      }), _a;
    }
    return Au(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Lle.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Lle.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
TS = /* @__PURE__ */ new WeakMap();
RI.create = vHe;
let bk = class extends _i {
  constructor() {
    super(...arguments), ES.set(this, void 0);
  }
  _parse(e) {
    const r = Yi.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== yn.string && n.parsedType !== yn.number) {
      const a = Yi.objectValues(r);
      return nn(n, {
        expected: Yi.joinValues(a),
        received: n.parsedType,
        code: Br.invalid_type
      }), _a;
    }
    if (X$(this, ES) || sHe(this, ES, new Set(Yi.getValidEnumValues(this._def.values))), !X$(this, ES).has(e.data)) {
      const a = Yi.objectValues(r);
      return nn(n, {
        received: n.data,
        code: Br.invalid_enum_value,
        options: a
      }), _a;
    }
    return Au(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
ES = /* @__PURE__ */ new WeakMap();
bk.create = (t, e) => new bk({
  values: t,
  typeName: pa.ZodNativeEnum,
  ...si(e)
});
let j7 = class extends _i {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== yn.promise && r.common.async === !1)
      return nn(r, {
        code: Br.invalid_type,
        expected: yn.promise,
        received: r.parsedType
      }), _a;
    const n = r.parsedType === yn.promise ? r.data : Promise.resolve(r.data);
    return Au(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
j7.create = (t, e) => new j7({
  type: t,
  typeName: pa.ZodPromise,
  ...si(e)
});
let N1 = class extends _i {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === pa.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        nn(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return _a;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? _a : l.status === "dirty" || r.value === "dirty" ? T9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return _a;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? _a : s.status === "dirty" || r.value === "dirty" ? T9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? _a : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? _a : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!t5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => t5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    Yi.assertNever(a);
  }
};
N1.create = (t, e, r) => new N1({
  schema: t,
  typeName: pa.ZodEffects,
  effect: e,
  ...si(r)
});
N1.createWithPreprocess = (t, e, r) => new N1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: pa.ZodEffects,
  ...si(r)
});
let lh = class extends _i {
  _parse(e) {
    return this._getType(e) === yn.undefined ? Au(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
lh.create = (t, e) => new lh({
  innerType: t,
  typeName: pa.ZodOptional,
  ...si(e)
});
let Kv = class extends _i {
  _parse(e) {
    return this._getType(e) === yn.null ? Au(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Kv.create = (t, e) => new Kv({
  innerType: t,
  typeName: pa.ZodNullable,
  ...si(e)
});
let xk = class extends _i {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === yn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
xk.create = (t, e) => new xk({
  innerType: t,
  typeName: pa.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...si(e)
});
let Ck = class extends _i {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return lk(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new w1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new w1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
Ck.create = (t, e) => new Ck({
  innerType: t,
  typeName: pa.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...si(e)
});
let nD = class extends _i {
  _parse(e) {
    if (this._getType(e) !== yn.nan) {
      const n = this._getOrReturnCtx(e);
      return nn(n, {
        code: Br.invalid_type,
        expected: yn.nan,
        received: n.parsedType
      }), _a;
    }
    return { status: "valid", value: e.data };
  }
};
nD.create = (t) => new nD({
  typeName: pa.ZodNaN,
  ...si(t)
});
const C7t = Symbol("zod_brand");
let S1e = class extends _i {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, _1e = class yHe extends _i {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? _a : i.status === "dirty" ? (r.dirty(), T9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? _a : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new yHe({
      in: e,
      out: r,
      typeName: pa.ZodPipeline
    });
  }
}, wk = class extends _i {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (t5(a) && (a.value = Object.freeze(a.value)), a);
    return lk(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
wk.create = (t, e) => new wk({
  innerType: t,
  typeName: pa.ZodReadonly,
  ...si(e)
});
function bHe(t, e = {}, r) {
  return t ? L7.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : L7.create();
}
const w7t = {
  object: nf.lazycreate
};
var pa;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(pa || (pa = {}));
const S7t = (t, e = {
  message: `Input not instance of ${t.name}`
}) => bHe((r) => r instanceof t, e), xHe = D7.create, CHe = ck.create, _7t = nD.create, k7t = uk.create, wHe = dk.create, A7t = fk.create, T7t = Q$.create, E7t = hk.create, I7t = pk.create, M7t = L7.create, P7t = Tb.create, R7t = $m.create, O7t = eD.create, B7t = r5.create, N7t = nf.create, $7t = nf.strictCreate, D7t = mk.create, L7t = fHe.create, j7t = gk.create, F7t = qv.create, z7t = mHe.create, G7t = tD.create, W7t = rD.create, H7t = gHe.create, U7t = vk.create, V7t = yk.create, q7t = RI.create, K7t = bk.create, Z7t = j7.create, O6e = N1.create, J7t = lh.create, Y7t = Kv.create, X7t = N1.createWithPreprocess, Q7t = _1e.create, ext = () => xHe().optional(), txt = () => CHe().optional(), rxt = () => wHe().optional(), nxt = {
  string: (t) => D7.create({ ...t, coerce: !0 }),
  number: (t) => ck.create({ ...t, coerce: !0 }),
  boolean: (t) => dk.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => uk.create({ ...t, coerce: !0 }),
  date: (t) => fk.create({ ...t, coerce: !0 })
}, axt = _a;
var se = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: $7,
  setErrorMap: X9t,
  getErrorMap: J$,
  makeIssue: Y$,
  EMPTY_PATH: Q9t,
  addIssueToContext: nn,
  ParseStatus: bd,
  INVALID: _a,
  DIRTY: T9,
  OK: Au,
  isAborted: Ple,
  isDirty: Rle,
  isValid: t5,
  isAsync: lk,
  get util() {
    return Yi;
  },
  get objectUtil() {
    return Mle;
  },
  ZodParsedType: yn,
  getParsedType: rm,
  ZodType: _i,
  datetimeRegex: uHe,
  ZodString: D7,
  ZodNumber: ck,
  ZodBigInt: uk,
  ZodBoolean: dk,
  ZodDate: fk,
  ZodSymbol: Q$,
  ZodUndefined: hk,
  ZodNull: pk,
  ZodAny: L7,
  ZodUnknown: Tb,
  ZodNever: $m,
  ZodVoid: eD,
  ZodArray: r5,
  ZodObject: nf,
  ZodUnion: mk,
  ZodDiscriminatedUnion: fHe,
  ZodIntersection: gk,
  ZodTuple: qv,
  ZodRecord: mHe,
  ZodMap: tD,
  ZodSet: rD,
  ZodFunction: gHe,
  ZodLazy: vk,
  ZodLiteral: yk,
  ZodEnum: RI,
  ZodNativeEnum: bk,
  ZodPromise: j7,
  ZodEffects: N1,
  ZodTransformer: N1,
  ZodOptional: lh,
  ZodNullable: Kv,
  ZodDefault: xk,
  ZodCatch: Ck,
  ZodNaN: nD,
  BRAND: C7t,
  ZodBranded: S1e,
  ZodPipeline: _1e,
  ZodReadonly: wk,
  custom: bHe,
  Schema: _i,
  ZodSchema: _i,
  late: w7t,
  get ZodFirstPartyTypeKind() {
    return pa;
  },
  coerce: nxt,
  any: M7t,
  array: B7t,
  bigint: k7t,
  boolean: wHe,
  date: A7t,
  discriminatedUnion: L7t,
  effect: O6e,
  enum: q7t,
  function: H7t,
  instanceof: S7t,
  intersection: j7t,
  lazy: U7t,
  literal: V7t,
  map: G7t,
  nan: _7t,
  nativeEnum: K7t,
  never: R7t,
  null: I7t,
  nullable: Y7t,
  number: CHe,
  object: N7t,
  oboolean: rxt,
  onumber: txt,
  optional: J7t,
  ostring: ext,
  pipeline: Q7t,
  preprocess: X7t,
  promise: Z7t,
  record: z7t,
  set: W7t,
  strictObject: $7t,
  string: xHe,
  symbol: T7t,
  transformer: O6e,
  tuple: F7t,
  undefined: E7t,
  union: D7t,
  unknown: P7t,
  void: O7t,
  NEVER: axt,
  ZodIssueCode: Br,
  quotelessJson: Y9t,
  ZodError: w1
});
const aD = "AC", F7 = 34, B6e = "US";
var YO = { exports: {} }, N6e;
function ixt() {
  if (N6e) return YO.exports;
  N6e = 1;
  var t = typeof Reflect == "object" ? Reflect : null, e = t && typeof t.apply == "function" ? t.apply : function(S, A, I) {
    return Function.prototype.apply.call(S, A, I);
  }, r;
  t && typeof t.ownKeys == "function" ? r = t.ownKeys : Object.getOwnPropertySymbols ? r = function(S) {
    return Object.getOwnPropertyNames(S).concat(Object.getOwnPropertySymbols(S));
  } : r = function(S) {
    return Object.getOwnPropertyNames(S);
  };
  function n(x) {
    console && console.warn && console.warn(x);
  }
  var a = Number.isNaN || function(S) {
    return S !== S;
  };
  function i() {
    i.init.call(this);
  }
  YO.exports = i, YO.exports.once = w, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var o = 10;
  function s(x) {
    if (typeof x != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof x);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return o;
    },
    set: function(x) {
      if (typeof x != "number" || x < 0 || a(x))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + x + ".");
      o = x;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(S) {
    if (typeof S != "number" || S < 0 || a(S))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + S + ".");
    return this._maxListeners = S, this;
  };
  function l(x) {
    return x._maxListeners === void 0 ? i.defaultMaxListeners : x._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return l(this);
  }, i.prototype.emit = function(S) {
    for (var A = [], I = 1; I < arguments.length; I++) A.push(arguments[I]);
    var M = S === "error", B = this._events;
    if (B !== void 0)
      M = M && B.error === void 0;
    else if (!M)
      return !1;
    if (M) {
      var L;
      if (A.length > 0 && (L = A[0]), L instanceof Error)
        throw L;
      var N = new Error("Unhandled error." + (L ? " (" + L.message + ")" : ""));
      throw N.context = L, N;
    }
    var d = B[S];
    if (d === void 0)
      return !1;
    if (typeof d == "function")
      e(d, this, A);
    else
      for (var m = d.length, v = g(d, m), I = 0; I < m; ++I)
        e(v[I], this, A);
    return !0;
  };
  function c(x, S, A, I) {
    var M, B, L;
    if (s(A), B = x._events, B === void 0 ? (B = x._events = /* @__PURE__ */ Object.create(null), x._eventsCount = 0) : (B.newListener !== void 0 && (x.emit(
      "newListener",
      S,
      A.listener ? A.listener : A
    ), B = x._events), L = B[S]), L === void 0)
      L = B[S] = A, ++x._eventsCount;
    else if (typeof L == "function" ? L = B[S] = I ? [A, L] : [L, A] : I ? L.unshift(A) : L.push(A), M = l(x), M > 0 && L.length > M && !L.warned) {
      L.warned = !0;
      var N = new Error("Possible EventEmitter memory leak detected. " + L.length + " " + String(S) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      N.name = "MaxListenersExceededWarning", N.emitter = x, N.type = S, N.count = L.length, n(N);
    }
    return x;
  }
  i.prototype.addListener = function(S, A) {
    return c(this, S, A, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(S, A) {
    return c(this, S, A, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(x, S, A) {
    var I = { fired: !1, wrapFn: void 0, target: x, type: S, listener: A }, M = u.bind(I);
    return M.listener = A, I.wrapFn = M, M;
  }
  i.prototype.once = function(S, A) {
    return s(A), this.on(S, f(this, S, A)), this;
  }, i.prototype.prependOnceListener = function(S, A) {
    return s(A), this.prependListener(S, f(this, S, A)), this;
  }, i.prototype.removeListener = function(S, A) {
    var I, M, B, L, N;
    if (s(A), M = this._events, M === void 0)
      return this;
    if (I = M[S], I === void 0)
      return this;
    if (I === A || I.listener === A)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete M[S], M.removeListener && this.emit("removeListener", S, I.listener || A));
    else if (typeof I != "function") {
      for (B = -1, L = I.length - 1; L >= 0; L--)
        if (I[L] === A || I[L].listener === A) {
          N = I[L].listener, B = L;
          break;
        }
      if (B < 0)
        return this;
      B === 0 ? I.shift() : y(I, B), I.length === 1 && (M[S] = I[0]), M.removeListener !== void 0 && this.emit("removeListener", S, N || A);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(S) {
    var A, I, M;
    if (I = this._events, I === void 0)
      return this;
    if (I.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : I[S] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete I[S]), this;
    if (arguments.length === 0) {
      var B = Object.keys(I), L;
      for (M = 0; M < B.length; ++M)
        L = B[M], L !== "removeListener" && this.removeAllListeners(L);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (A = I[S], typeof A == "function")
      this.removeListener(S, A);
    else if (A !== void 0)
      for (M = A.length - 1; M >= 0; M--)
        this.removeListener(S, A[M]);
    return this;
  };
  function h(x, S, A) {
    var I = x._events;
    if (I === void 0)
      return [];
    var M = I[S];
    return M === void 0 ? [] : typeof M == "function" ? A ? [M.listener || M] : [M] : A ? b(M) : g(M, M.length);
  }
  i.prototype.listeners = function(S) {
    return h(this, S, !0);
  }, i.prototype.rawListeners = function(S) {
    return h(this, S, !1);
  }, i.listenerCount = function(x, S) {
    return typeof x.listenerCount == "function" ? x.listenerCount(S) : p.call(x, S);
  }, i.prototype.listenerCount = p;
  function p(x) {
    var S = this._events;
    if (S !== void 0) {
      var A = S[x];
      if (typeof A == "function")
        return 1;
      if (A !== void 0)
        return A.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function g(x, S) {
    for (var A = new Array(S), I = 0; I < S; ++I)
      A[I] = x[I];
    return A;
  }
  function y(x, S) {
    for (; S + 1 < x.length; S++)
      x[S] = x[S + 1];
    x.pop();
  }
  function b(x) {
    for (var S = new Array(x.length), A = 0; A < S.length; ++A)
      S[A] = x[A].listener || x[A];
    return S;
  }
  function w(x, S) {
    return new Promise(function(A, I) {
      function M(L) {
        x.removeListener(S, B), I(L);
      }
      function B() {
        typeof x.removeListener == "function" && x.removeListener("error", M), A([].slice.call(arguments));
      }
      C(x, S, B, { once: !0 }), S !== "error" && _(x, M, { once: !0 });
    });
  }
  function _(x, S, A) {
    typeof x.on == "function" && C(x, "error", S, A);
  }
  function C(x, S, A, I) {
    if (typeof x.on == "function")
      I.once ? x.once(S, A) : x.on(S, A);
    else if (typeof x.addEventListener == "function")
      x.addEventListener(S, function M(B) {
        I.once && x.removeEventListener(S, M), A(B);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof x);
  }
  return YO.exports;
}
ixt();
var Xi;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(Xi || (Xi = {}));
var jle;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(jle || (jle = {}));
const bn = Xi.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), nm = (t) => {
  switch (typeof t) {
    case "undefined":
      return bn.undefined;
    case "string":
      return bn.string;
    case "number":
      return isNaN(t) ? bn.nan : bn.number;
    case "boolean":
      return bn.boolean;
    case "function":
      return bn.function;
    case "bigint":
      return bn.bigint;
    case "symbol":
      return bn.symbol;
    case "object":
      return Array.isArray(t) ? bn.array : t === null ? bn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? bn.promise : typeof Map < "u" && t instanceof Map ? bn.map : typeof Set < "u" && t instanceof Set ? bn.set : typeof Date < "u" && t instanceof Date ? bn.date : bn.object;
    default:
      return bn.unknown;
  }
}, Nr = Xi.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), oxt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let S1 = class SHe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof SHe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Xi.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
S1.create = (t) => new S1(t);
const z7 = (t, e) => {
  let r;
  switch (t.code) {
    case Nr.invalid_type:
      t.received === bn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Nr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, Xi.jsonStringifyReplacer)}`;
      break;
    case Nr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Xi.joinValues(t.keys, ", ")}`;
      break;
    case Nr.invalid_union:
      r = "Invalid input";
      break;
    case Nr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Xi.joinValues(t.options)}`;
      break;
    case Nr.invalid_enum_value:
      r = `Invalid enum value. Expected ${Xi.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Nr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Nr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Nr.invalid_date:
      r = "Invalid date";
      break;
    case Nr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : Xi.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Nr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Nr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Nr.custom:
      r = "Invalid input";
      break;
    case Nr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Nr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Nr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, Xi.assertNever(t);
  }
  return { message: r };
};
let _He = z7;
function sxt(t) {
  _He = t;
}
function iD() {
  return _He;
}
const oD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, lxt = [];
function an(t, e) {
  const r = iD(), n = oD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === z7 ? void 0 : z7
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let xd = class kHe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return ka;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return kHe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return ka;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const ka = Object.freeze({
  status: "aborted"
}), E9 = (t) => ({ status: "dirty", value: t }), Tu = (t) => ({ status: "valid", value: t }), Fle = (t) => t.status === "aborted", zle = (t) => t.status === "dirty", n5 = (t) => t.status === "valid", Sk = (t) => typeof Promise < "u" && t instanceof Promise;
function sD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function AHe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Bn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(Bn || (Bn = {}));
var MS, PS;
let Mh = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const $6e = (t, e) => {
  if (n5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new S1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function li(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let ki = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return nm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: nm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new xd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: nm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Sk(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: nm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return $6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: nm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return n5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => n5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: nm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (Sk(a) ? a : Promise.resolve(a));
    return $6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Nr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new $1({
      schema: this,
      typeName: ma.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return ch.create(this, this._def);
  }
  nullable() {
    return Jv.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return a5.create(this);
  }
  promise() {
    return H7.create(this, this._def);
  }
  or(e) {
    return Mk.create([this, e], this._def);
  }
  and(e) {
    return Pk.create(this, e, this._def);
  }
  transform(e) {
    return new $1({
      ...li(this._def),
      schema: this,
      typeName: ma.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Nk({
      ...li(this._def),
      innerType: this,
      defaultValue: r,
      typeName: ma.ZodDefault
    });
  }
  brand() {
    return new k1e({
      typeName: ma.ZodBranded,
      type: this,
      ...li(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new $k({
      ...li(this._def),
      innerType: this,
      catchValue: r,
      typeName: ma.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return A1e.create(this, e);
  }
  readonly() {
    return Dk.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const cxt = /^c[^\s-]{8,}$/i, uxt = /^[0-9a-z]+$/, dxt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, fxt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, hxt = /^[a-z0-9_-]{21}$/i, pxt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, mxt = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, gxt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, vxt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let EK;
const yxt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, bxt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, xxt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Cxt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, wxt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Sxt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, THe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", _xt = new RegExp(`^${THe}$`);
function EHe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function kxt(t) {
  return new RegExp(`^${EHe(t)}$`);
}
function IHe(t) {
  let e = `${THe}T${EHe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function Axt(t, e) {
  return !!((e === "v4" || !e) && yxt.test(t) || (e === "v6" || !e) && xxt.test(t));
}
function Txt(t, e) {
  if (!pxt.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function Ext(t, e) {
  return !!((e === "v4" || !e) && bxt.test(t) || (e === "v6" || !e) && Cxt.test(t));
}
let G7 = class RS extends ki {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== bn.string) {
      const i = this._getOrReturnCtx(e);
      return an(i, {
        code: Nr.invalid_type,
        expected: bn.string,
        received: i.parsedType
      }), ka;
    }
    const n = new xd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), an(a, {
          code: Nr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), an(a, {
          code: Nr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? an(a, {
          code: Nr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && an(a, {
          code: Nr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        gxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "email",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        EK || (EK = new RegExp(vxt, "u")), EK.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "emoji",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        fxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "uuid",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        hxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "nanoid",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        cxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "cuid",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        uxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "cuid2",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        dxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
          validation: "ulid",
          code: Nr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), an(a, {
            validation: "url",
            code: Nr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "regex",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? IHe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? _xt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? kxt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? mxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "duration",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? Axt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "ip",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? Txt(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "jwt",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? Ext(e.data, i.version) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "cidr",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? wxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "base64",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? Sxt.test(e.data) || (a = this._getOrReturnCtx(e, a), an(a, {
        validation: "base64url",
        code: Nr.invalid_string,
        message: i.message
      }), n.dirty()) : Xi.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Nr.invalid_string,
      ...Bn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new RS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Bn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Bn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Bn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Bn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Bn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Bn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Bn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Bn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Bn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Bn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Bn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Bn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Bn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...Bn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...Bn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Bn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Bn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...Bn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Bn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Bn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Bn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Bn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Bn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Bn.errToObj(e));
  }
  trim() {
    return new RS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new RS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new RS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
G7.create = (t) => {
  var e;
  return new G7({
    checks: [],
    typeName: ma.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...li(t)
  });
};
function Ixt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let _k = class Gle extends ki {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== bn.number) {
      const i = this._getOrReturnCtx(e);
      return an(i, {
        code: Nr.invalid_type,
        expected: bn.number,
        received: i.parsedType
      }), ka;
    }
    let n;
    const a = new xd();
    for (const i of this._def.checks)
      i.kind === "int" ? Xi.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? Ixt(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.not_finite,
        message: i.message
      }), a.dirty()) : Xi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Bn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Bn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Bn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Bn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Gle({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Bn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Gle({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Bn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Bn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Bn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Bn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Bn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Bn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Bn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Bn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Bn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Xi.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
_k.create = (t) => new _k({
  checks: [],
  typeName: ma.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...li(t)
});
let kk = class Wle extends ki {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== bn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new xd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), an(n, {
        code: Nr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : Xi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return an(r, {
      code: Nr.invalid_type,
      expected: bn.bigint,
      received: r.parsedType
    }), ka;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Bn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Bn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Bn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Bn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Wle({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Bn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Wle({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Bn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Bn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Bn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Bn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Bn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
kk.create = (t) => {
  var e;
  return new kk({
    checks: [],
    typeName: ma.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...li(t)
  });
};
let Ak = class extends ki {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== bn.boolean) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.boolean,
        received: n.parsedType
      }), ka;
    }
    return Tu(e.data);
  }
};
Ak.create = (t) => new Ak({
  typeName: ma.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...li(t)
});
let Tk = class MHe extends ki {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== bn.date) {
      const i = this._getOrReturnCtx(e);
      return an(i, {
        code: Nr.invalid_type,
        expected: bn.date,
        received: i.parsedType
      }), ka;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return an(i, {
        code: Nr.invalid_date
      }), ka;
    }
    const n = new xd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), an(a, {
        code: Nr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : Xi.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new MHe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Bn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Bn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
Tk.create = (t) => new Tk({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: ma.ZodDate,
  ...li(t)
});
let lD = class extends ki {
  _parse(e) {
    if (this._getType(e) !== bn.symbol) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.symbol,
        received: n.parsedType
      }), ka;
    }
    return Tu(e.data);
  }
};
lD.create = (t) => new lD({
  typeName: ma.ZodSymbol,
  ...li(t)
});
let Ek = class extends ki {
  _parse(e) {
    if (this._getType(e) !== bn.undefined) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.undefined,
        received: n.parsedType
      }), ka;
    }
    return Tu(e.data);
  }
};
Ek.create = (t) => new Ek({
  typeName: ma.ZodUndefined,
  ...li(t)
});
let Ik = class extends ki {
  _parse(e) {
    if (this._getType(e) !== bn.null) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.null,
        received: n.parsedType
      }), ka;
    }
    return Tu(e.data);
  }
};
Ik.create = (t) => new Ik({
  typeName: ma.ZodNull,
  ...li(t)
});
let W7 = class extends ki {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Tu(e.data);
  }
};
W7.create = (t) => new W7({
  typeName: ma.ZodAny,
  ...li(t)
});
let Eb = class extends ki {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Tu(e.data);
  }
};
Eb.create = (t) => new Eb({
  typeName: ma.ZodUnknown,
  ...li(t)
});
let Dm = class extends ki {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return an(r, {
      code: Nr.invalid_type,
      expected: bn.never,
      received: r.parsedType
    }), ka;
  }
};
Dm.create = (t) => new Dm({
  typeName: ma.ZodNever,
  ...li(t)
});
let cD = class extends ki {
  _parse(e) {
    if (this._getType(e) !== bn.undefined) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.void,
        received: n.parsedType
      }), ka;
    }
    return Tu(e.data);
  }
};
cD.create = (t) => new cD({
  typeName: ma.ZodVoid,
  ...li(t)
});
let a5 = class jN extends ki {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== bn.array)
      return an(r, {
        code: Nr.invalid_type,
        expected: bn.array,
        received: r.parsedType
      }), ka;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (an(r, {
        code: o ? Nr.too_big : Nr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (an(r, {
      code: Nr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (an(r, {
      code: Nr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Mh(r, o, r.path, s)))).then((o) => xd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Mh(r, o, r.path, s)));
    return xd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new jN({
      ...this._def,
      minLength: { value: e, message: Bn.toString(r) }
    });
  }
  max(e, r) {
    return new jN({
      ...this._def,
      maxLength: { value: e, message: Bn.toString(r) }
    });
  }
  length(e, r) {
    return new jN({
      ...this._def,
      exactLength: { value: e, message: Bn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
a5.create = (t, e) => new a5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ma.ZodArray,
  ...li(e)
});
function f9(t) {
  if (t instanceof af) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = ch.create(f9(n));
    }
    return new af({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof a5 ? new a5({
    ...t._def,
    type: f9(t.element)
  }) : t instanceof ch ? ch.create(f9(t.unwrap())) : t instanceof Jv ? Jv.create(f9(t.unwrap())) : t instanceof Zv ? Zv.create(t.items.map((e) => f9(e))) : t;
}
let af = class Jf extends ki {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = Xi.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== bn.object) {
      const c = this._getOrReturnCtx(e);
      return an(c, {
        code: Nr.invalid_type,
        expected: bn.object,
        received: c.parsedType
      }), ka;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Dm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Mh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Dm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (an(a, {
          code: Nr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Mh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => xd.mergeObjectSync(n, c)) : xd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Bn.errToObj, new Jf({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Bn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Jf({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Jf({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Jf({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Jf({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: ma.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Jf({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return Xi.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Jf({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return Xi.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Jf({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return f9(this);
  }
  partial(e) {
    const r = {};
    return Xi.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Jf({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return Xi.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof ch; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Jf({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return $He(Xi.objectKeys(this.shape));
  }
};
af.create = (t, e) => new af({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Dm.create(),
  typeName: ma.ZodObject,
  ...li(e)
});
af.strictCreate = (t, e) => new af({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Dm.create(),
  typeName: ma.ZodObject,
  ...li(e)
});
af.lazycreate = (t, e) => new af({
  shape: t,
  unknownKeys: "strip",
  catchall: Dm.create(),
  typeName: ma.ZodObject,
  ...li(e)
});
let Mk = class extends ki {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new S1(s.ctx.common.issues));
      return an(r, {
        code: Nr.invalid_union,
        unionErrors: o
      }), ka;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new S1(l));
      return an(r, {
        code: Nr.invalid_union,
        unionErrors: s
      }), ka;
    }
  }
  get options() {
    return this._def.options;
  }
};
Mk.create = (t, e) => new Mk({
  options: t,
  typeName: ma.ZodUnion,
  ...li(e)
});
const Wp = (t) => t instanceof Rk ? Wp(t.schema) : t instanceof $1 ? Wp(t.innerType()) : t instanceof Ok ? [t.value] : t instanceof OI ? t.options : t instanceof Bk ? Xi.objectValues(t.enum) : t instanceof Nk ? Wp(t._def.innerType) : t instanceof Ek ? [void 0] : t instanceof Ik ? [null] : t instanceof ch ? [void 0, ...Wp(t.unwrap())] : t instanceof Jv ? [null, ...Wp(t.unwrap())] : t instanceof k1e || t instanceof Dk ? Wp(t.unwrap()) : t instanceof $k ? Wp(t._def.innerType) : [];
let PHe = class RHe extends ki {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== bn.object)
      return an(r, {
        code: Nr.invalid_type,
        expected: bn.object,
        received: r.parsedType
      }), ka;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (an(r, {
      code: Nr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), ka);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Wp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new RHe({
      typeName: ma.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...li(n)
    });
  }
};
function Hle(t, e) {
  const r = nm(t), n = nm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === bn.object && n === bn.object) {
    const a = Xi.objectKeys(e), i = Xi.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Hle(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === bn.array && n === bn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Hle(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === bn.date && n === bn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let Pk = class extends ki {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Fle(i) || Fle(o))
        return ka;
      const s = Hle(i.value, o.value);
      return s.valid ? ((zle(i) || zle(o)) && r.dirty(), { status: r.value, value: s.data }) : (an(n, {
        code: Nr.invalid_intersection_types
      }), ka);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
Pk.create = (t, e, r) => new Pk({
  left: t,
  right: e,
  typeName: ma.ZodIntersection,
  ...li(r)
});
let Zv = class OHe extends ki {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== bn.array)
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.array,
        received: n.parsedType
      }), ka;
    if (n.data.length < this._def.items.length)
      return an(n, {
        code: Nr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), ka;
    !this._def.rest && n.data.length > this._def.items.length && (an(n, {
      code: Nr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Mh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => xd.mergeArray(r, o)) : xd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new OHe({
      ...this._def,
      rest: e
    });
  }
};
Zv.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Zv({
    items: t,
    typeName: ma.ZodTuple,
    rest: null,
    ...li(e)
  });
};
let BHe = class Ule extends ki {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== bn.object)
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.object,
        received: n.parsedType
      }), ka;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Mh(n, s, n.path, s)),
        value: o._parse(new Mh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? xd.mergeObjectAsync(r, a) : xd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof ki ? new Ule({
      keyType: e,
      valueType: r,
      typeName: ma.ZodRecord,
      ...li(n)
    }) : new Ule({
      keyType: G7.create(),
      valueType: e,
      typeName: ma.ZodRecord,
      ...li(r)
    });
  }
}, uD = class extends ki {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== bn.map)
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.map,
        received: n.parsedType
      }), ka;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Mh(n, s, n.path, [c, "key"])),
      value: i._parse(new Mh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return ka;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return ka;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
uD.create = (t, e, r) => new uD({
  valueType: e,
  keyType: t,
  typeName: ma.ZodMap,
  ...li(r)
});
let dD = class Vle extends ki {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== bn.set)
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.set,
        received: n.parsedType
      }), ka;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (an(n, {
      code: Nr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (an(n, {
      code: Nr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return ka;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Mh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new Vle({
      ...this._def,
      minSize: { value: e, message: Bn.toString(r) }
    });
  }
  max(e, r) {
    return new Vle({
      ...this._def,
      maxSize: { value: e, message: Bn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
dD.create = (t, e) => new dD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: ma.ZodSet,
  ...li(e)
});
let NHe = class FN extends ki {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== bn.function)
      return an(r, {
        code: Nr.invalid_type,
        expected: bn.function,
        received: r.parsedType
      }), ka;
    function n(s, l) {
      return oD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          iD(),
          z7
        ].filter((c) => !!c),
        issueData: {
          code: Nr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return oD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          iD(),
          z7
        ].filter((c) => !!c),
        issueData: {
          code: Nr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof H7) {
      const s = this;
      return Tu(async function(...l) {
        const c = new S1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Tu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new S1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new S1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new FN({
      ...this._def,
      args: Zv.create(e).rest(Eb.create())
    });
  }
  returns(e) {
    return new FN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new FN({
      args: e || Zv.create([]).rest(Eb.create()),
      returns: r || Eb.create(),
      typeName: ma.ZodFunction,
      ...li(n)
    });
  }
}, Rk = class extends ki {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
Rk.create = (t, e) => new Rk({
  getter: t,
  typeName: ma.ZodLazy,
  ...li(e)
});
let Ok = class extends ki {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return an(r, {
        received: r.data,
        code: Nr.invalid_literal,
        expected: this._def.value
      }), ka;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
Ok.create = (t, e) => new Ok({
  value: t,
  typeName: ma.ZodLiteral,
  ...li(e)
});
function $He(t, e) {
  return new OI({
    values: t,
    typeName: ma.ZodEnum,
    ...li(e)
  });
}
let OI = class qle extends ki {
  constructor() {
    super(...arguments), MS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return an(r, {
        expected: Xi.joinValues(n),
        received: r.parsedType,
        code: Nr.invalid_type
      }), ka;
    }
    if (sD(this, MS) || AHe(this, MS, new Set(this._def.values)), !sD(this, MS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return an(r, {
        received: r.data,
        code: Nr.invalid_enum_value,
        options: n
      }), ka;
    }
    return Tu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return qle.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return qle.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
MS = /* @__PURE__ */ new WeakMap();
OI.create = $He;
let Bk = class extends ki {
  constructor() {
    super(...arguments), PS.set(this, void 0);
  }
  _parse(e) {
    const r = Xi.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== bn.string && n.parsedType !== bn.number) {
      const a = Xi.objectValues(r);
      return an(n, {
        expected: Xi.joinValues(a),
        received: n.parsedType,
        code: Nr.invalid_type
      }), ka;
    }
    if (sD(this, PS) || AHe(this, PS, new Set(Xi.getValidEnumValues(this._def.values))), !sD(this, PS).has(e.data)) {
      const a = Xi.objectValues(r);
      return an(n, {
        received: n.data,
        code: Nr.invalid_enum_value,
        options: a
      }), ka;
    }
    return Tu(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
PS = /* @__PURE__ */ new WeakMap();
Bk.create = (t, e) => new Bk({
  values: t,
  typeName: ma.ZodNativeEnum,
  ...li(e)
});
let H7 = class extends ki {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== bn.promise && r.common.async === !1)
      return an(r, {
        code: Nr.invalid_type,
        expected: bn.promise,
        received: r.parsedType
      }), ka;
    const n = r.parsedType === bn.promise ? r.data : Promise.resolve(r.data);
    return Tu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
H7.create = (t, e) => new H7({
  type: t,
  typeName: ma.ZodPromise,
  ...li(e)
});
let $1 = class extends ki {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ma.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        an(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return ka;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? ka : l.status === "dirty" || r.value === "dirty" ? E9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return ka;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? ka : s.status === "dirty" || r.value === "dirty" ? E9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? ka : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? ka : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!n5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => n5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    Xi.assertNever(a);
  }
};
$1.create = (t, e, r) => new $1({
  schema: t,
  typeName: ma.ZodEffects,
  effect: e,
  ...li(r)
});
$1.createWithPreprocess = (t, e, r) => new $1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: ma.ZodEffects,
  ...li(r)
});
let ch = class extends ki {
  _parse(e) {
    return this._getType(e) === bn.undefined ? Tu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ch.create = (t, e) => new ch({
  innerType: t,
  typeName: ma.ZodOptional,
  ...li(e)
});
let Jv = class extends ki {
  _parse(e) {
    return this._getType(e) === bn.null ? Tu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Jv.create = (t, e) => new Jv({
  innerType: t,
  typeName: ma.ZodNullable,
  ...li(e)
});
let Nk = class extends ki {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === bn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
Nk.create = (t, e) => new Nk({
  innerType: t,
  typeName: ma.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...li(e)
});
let $k = class extends ki {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Sk(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new S1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new S1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
$k.create = (t, e) => new $k({
  innerType: t,
  typeName: ma.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...li(e)
});
let fD = class extends ki {
  _parse(e) {
    if (this._getType(e) !== bn.nan) {
      const n = this._getOrReturnCtx(e);
      return an(n, {
        code: Nr.invalid_type,
        expected: bn.nan,
        received: n.parsedType
      }), ka;
    }
    return { status: "valid", value: e.data };
  }
};
fD.create = (t) => new fD({
  typeName: ma.ZodNaN,
  ...li(t)
});
const Mxt = Symbol("zod_brand");
let k1e = class extends ki {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, A1e = class DHe extends ki {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? ka : i.status === "dirty" ? (r.dirty(), E9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? ka : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new DHe({
      in: e,
      out: r,
      typeName: ma.ZodPipeline
    });
  }
}, Dk = class extends ki {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (n5(a) && (a.value = Object.freeze(a.value)), a);
    return Sk(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Dk.create = (t, e) => new Dk({
  innerType: t,
  typeName: ma.ZodReadonly,
  ...li(e)
});
function LHe(t, e = {}, r) {
  return t ? W7.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : W7.create();
}
const Pxt = {
  object: af.lazycreate
};
var ma;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(ma || (ma = {}));
const Rxt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => LHe((r) => r instanceof t, e), jHe = G7.create, FHe = _k.create, Oxt = fD.create, Bxt = kk.create, zHe = Ak.create, Nxt = Tk.create, $xt = lD.create, Dxt = Ek.create, Lxt = Ik.create, jxt = W7.create, Fxt = Eb.create, zxt = Dm.create, Gxt = cD.create, Wxt = a5.create, Hxt = af.create, Uxt = af.strictCreate, Vxt = Mk.create, qxt = PHe.create, Kxt = Pk.create, Zxt = Zv.create, Jxt = BHe.create, Yxt = uD.create, Xxt = dD.create, Qxt = NHe.create, e8t = Rk.create, t8t = Ok.create, r8t = OI.create, n8t = Bk.create, a8t = H7.create, D6e = $1.create, i8t = ch.create, o8t = Jv.create, s8t = $1.createWithPreprocess, l8t = A1e.create, c8t = () => jHe().optional(), u8t = () => FHe().optional(), d8t = () => zHe().optional(), f8t = {
  string: (t) => G7.create({ ...t, coerce: !0 }),
  number: (t) => _k.create({ ...t, coerce: !0 }),
  boolean: (t) => Ak.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => kk.create({ ...t, coerce: !0 }),
  date: (t) => Tk.create({ ...t, coerce: !0 })
}, h8t = ka;
var GHe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: z7,
  setErrorMap: sxt,
  getErrorMap: iD,
  makeIssue: oD,
  EMPTY_PATH: lxt,
  addIssueToContext: an,
  ParseStatus: xd,
  INVALID: ka,
  DIRTY: E9,
  OK: Tu,
  isAborted: Fle,
  isDirty: zle,
  isValid: n5,
  isAsync: Sk,
  get util() {
    return Xi;
  },
  get objectUtil() {
    return jle;
  },
  ZodParsedType: bn,
  getParsedType: nm,
  ZodType: ki,
  datetimeRegex: IHe,
  ZodString: G7,
  ZodNumber: _k,
  ZodBigInt: kk,
  ZodBoolean: Ak,
  ZodDate: Tk,
  ZodSymbol: lD,
  ZodUndefined: Ek,
  ZodNull: Ik,
  ZodAny: W7,
  ZodUnknown: Eb,
  ZodNever: Dm,
  ZodVoid: cD,
  ZodArray: a5,
  ZodObject: af,
  ZodUnion: Mk,
  ZodDiscriminatedUnion: PHe,
  ZodIntersection: Pk,
  ZodTuple: Zv,
  ZodRecord: BHe,
  ZodMap: uD,
  ZodSet: dD,
  ZodFunction: NHe,
  ZodLazy: Rk,
  ZodLiteral: Ok,
  ZodEnum: OI,
  ZodNativeEnum: Bk,
  ZodPromise: H7,
  ZodEffects: $1,
  ZodTransformer: $1,
  ZodOptional: ch,
  ZodNullable: Jv,
  ZodDefault: Nk,
  ZodCatch: $k,
  ZodNaN: fD,
  BRAND: Mxt,
  ZodBranded: k1e,
  ZodPipeline: A1e,
  ZodReadonly: Dk,
  custom: LHe,
  Schema: ki,
  ZodSchema: ki,
  late: Pxt,
  get ZodFirstPartyTypeKind() {
    return ma;
  },
  coerce: f8t,
  any: jxt,
  array: Wxt,
  bigint: Bxt,
  boolean: zHe,
  date: Nxt,
  discriminatedUnion: qxt,
  effect: D6e,
  enum: r8t,
  function: Qxt,
  instanceof: Rxt,
  intersection: Kxt,
  lazy: e8t,
  literal: t8t,
  map: Yxt,
  nan: Oxt,
  nativeEnum: n8t,
  never: zxt,
  null: Lxt,
  nullable: o8t,
  number: FHe,
  object: Hxt,
  oboolean: d8t,
  onumber: u8t,
  optional: i8t,
  ostring: c8t,
  pipeline: l8t,
  preprocess: s8t,
  promise: a8t,
  record: Jxt,
  set: Xxt,
  strictObject: Uxt,
  string: jHe,
  symbol: $xt,
  transformer: D6e,
  tuple: Zxt,
  undefined: Dxt,
  union: Vxt,
  unknown: Fxt,
  void: Gxt,
  NEVER: h8t,
  ZodIssueCode: Nr,
  quotelessJson: oxt,
  ZodError: S1
});
const p8t = 1, m8t = GHe.string().min(p8t), T1e = () => m8t.brand(), E1e = () => GHe.string().uuid().brand();
var Qi;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(Qi || (Qi = {}));
var Kle;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Kle || (Kle = {}));
const xn = Qi.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), am = (t) => {
  switch (typeof t) {
    case "undefined":
      return xn.undefined;
    case "string":
      return xn.string;
    case "number":
      return isNaN(t) ? xn.nan : xn.number;
    case "boolean":
      return xn.boolean;
    case "function":
      return xn.function;
    case "bigint":
      return xn.bigint;
    case "symbol":
      return xn.symbol;
    case "object":
      return Array.isArray(t) ? xn.array : t === null ? xn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? xn.promise : typeof Map < "u" && t instanceof Map ? xn.map : typeof Set < "u" && t instanceof Set ? xn.set : typeof Date < "u" && t instanceof Date ? xn.date : xn.object;
    default:
      return xn.unknown;
  }
}, $r = Qi.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), g8t = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let _1 = class WHe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof WHe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Qi.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
_1.create = (t) => new _1(t);
const U7 = (t, e) => {
  let r;
  switch (t.code) {
    case $r.invalid_type:
      t.received === xn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case $r.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, Qi.jsonStringifyReplacer)}`;
      break;
    case $r.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Qi.joinValues(t.keys, ", ")}`;
      break;
    case $r.invalid_union:
      r = "Invalid input";
      break;
    case $r.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Qi.joinValues(t.options)}`;
      break;
    case $r.invalid_enum_value:
      r = `Invalid enum value. Expected ${Qi.joinValues(t.options)}, received '${t.received}'`;
      break;
    case $r.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case $r.invalid_return_type:
      r = "Invalid function return type";
      break;
    case $r.invalid_date:
      r = "Invalid date";
      break;
    case $r.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : Qi.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case $r.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case $r.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case $r.custom:
      r = "Invalid input";
      break;
    case $r.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case $r.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case $r.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, Qi.assertNever(t);
  }
  return { message: r };
};
let HHe = U7;
function v8t(t) {
  HHe = t;
}
function hD() {
  return HHe;
}
const pD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, y8t = [];
function on(t, e) {
  const r = hD(), n = pD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === U7 ? void 0 : U7
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let Cd = class UHe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Aa;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return UHe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Aa;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Aa = Object.freeze({
  status: "aborted"
}), I9 = (t) => ({ status: "dirty", value: t }), Eu = (t) => ({ status: "valid", value: t }), Zle = (t) => t.status === "aborted", Jle = (t) => t.status === "dirty", i5 = (t) => t.status === "valid", Lk = (t) => typeof Promise < "u" && t instanceof Promise;
function mD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function VHe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Nn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(Nn || (Nn = {}));
var OS, BS;
let Ph = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const L6e = (t, e) => {
  if (i5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new _1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function ci(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Ai = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return am(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: am(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Cd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: am(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Lk(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: am(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return L6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: am(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return i5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => i5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: am(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (Lk(a) ? a : Promise.resolve(a));
    return L6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: $r.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new D1({
      schema: this,
      typeName: ga.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return uh.create(this, this._def);
  }
  nullable() {
    return Xv.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return o5.create(this);
  }
  promise() {
    return K7.create(this, this._def);
  }
  or(e) {
    return Uk.create([this, e], this._def);
  }
  and(e) {
    return Vk.create(this, e, this._def);
  }
  transform(e) {
    return new D1({
      ...ci(this._def),
      schema: this,
      typeName: ga.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Jk({
      ...ci(this._def),
      innerType: this,
      defaultValue: r,
      typeName: ga.ZodDefault
    });
  }
  brand() {
    return new I1e({
      typeName: ga.ZodBranded,
      type: this,
      ...ci(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Yk({
      ...ci(this._def),
      innerType: this,
      catchValue: r,
      typeName: ga.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return M1e.create(this, e);
  }
  readonly() {
    return Xk.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const b8t = /^c[^\s-]{8,}$/i, x8t = /^[0-9a-z]+$/, C8t = /^[0-9A-HJKMNP-TV-Z]{26}$/i, w8t = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, S8t = /^[a-z0-9_-]{21}$/i, _8t = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, k8t = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, A8t = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, T8t = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let IK;
const E8t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, I8t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, M8t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, P8t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, R8t = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, O8t = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, qHe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", B8t = new RegExp(`^${qHe}$`);
function KHe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function N8t(t) {
  return new RegExp(`^${KHe(t)}$`);
}
function ZHe(t) {
  let e = `${qHe}T${KHe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function $8t(t, e) {
  return !!((e === "v4" || !e) && E8t.test(t) || (e === "v6" || !e) && M8t.test(t));
}
function D8t(t, e) {
  if (!_8t.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function L8t(t, e) {
  return !!((e === "v4" || !e) && I8t.test(t) || (e === "v6" || !e) && P8t.test(t));
}
let V7 = class NS extends Ai {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== xn.string) {
      const i = this._getOrReturnCtx(e);
      return on(i, {
        code: $r.invalid_type,
        expected: xn.string,
        received: i.parsedType
      }), Aa;
    }
    const n = new Cd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), on(a, {
          code: $r.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), on(a, {
          code: $r.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? on(a, {
          code: $r.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && on(a, {
          code: $r.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        A8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "email",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        IK || (IK = new RegExp(T8t, "u")), IK.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "emoji",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        w8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "uuid",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        S8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "nanoid",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        b8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "cuid",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        x8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "cuid2",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        C8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
          validation: "ulid",
          code: $r.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), on(a, {
            validation: "url",
            code: $r.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "regex",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? ZHe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? B8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? N8t(i).test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? k8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "duration",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? $8t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "ip",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? D8t(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "jwt",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? L8t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "cidr",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? R8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "base64",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? O8t.test(e.data) || (a = this._getOrReturnCtx(e, a), on(a, {
        validation: "base64url",
        code: $r.invalid_string,
        message: i.message
      }), n.dirty()) : Qi.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: $r.invalid_string,
      ...Nn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new NS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Nn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Nn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Nn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Nn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Nn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Nn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Nn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Nn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Nn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Nn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Nn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Nn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Nn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...Nn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...Nn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Nn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Nn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...Nn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Nn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Nn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Nn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Nn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Nn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Nn.errToObj(e));
  }
  trim() {
    return new NS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new NS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new NS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
V7.create = (t) => {
  var e;
  return new V7({
    checks: [],
    typeName: ga.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...ci(t)
  });
};
function j8t(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let jk = class Yle extends Ai {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== xn.number) {
      const i = this._getOrReturnCtx(e);
      return on(i, {
        code: $r.invalid_type,
        expected: xn.number,
        received: i.parsedType
      }), Aa;
    }
    let n;
    const a = new Cd();
    for (const i of this._def.checks)
      i.kind === "int" ? Qi.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? j8t(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.not_finite,
        message: i.message
      }), a.dirty()) : Qi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Nn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Nn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Nn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Nn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Yle({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Nn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Yle({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Nn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Nn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Nn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Nn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Nn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Nn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Nn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Nn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Nn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && Qi.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
jk.create = (t) => new jk({
  checks: [],
  typeName: ga.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...ci(t)
});
let Fk = class Xle extends Ai {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== xn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new Cd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), on(n, {
        code: $r.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : Qi.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return on(r, {
      code: $r.invalid_type,
      expected: xn.bigint,
      received: r.parsedType
    }), Aa;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Nn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Nn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Nn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Nn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Xle({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Nn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Xle({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Nn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Nn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Nn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Nn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Nn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
Fk.create = (t) => {
  var e;
  return new Fk({
    checks: [],
    typeName: ga.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...ci(t)
  });
};
let zk = class extends Ai {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== xn.boolean) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.boolean,
        received: n.parsedType
      }), Aa;
    }
    return Eu(e.data);
  }
};
zk.create = (t) => new zk({
  typeName: ga.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...ci(t)
});
let Gk = class JHe extends Ai {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== xn.date) {
      const i = this._getOrReturnCtx(e);
      return on(i, {
        code: $r.invalid_type,
        expected: xn.date,
        received: i.parsedType
      }), Aa;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return on(i, {
        code: $r.invalid_date
      }), Aa;
    }
    const n = new Cd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), on(a, {
        code: $r.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : Qi.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new JHe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Nn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Nn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
Gk.create = (t) => new Gk({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: ga.ZodDate,
  ...ci(t)
});
let gD = class extends Ai {
  _parse(e) {
    if (this._getType(e) !== xn.symbol) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.symbol,
        received: n.parsedType
      }), Aa;
    }
    return Eu(e.data);
  }
};
gD.create = (t) => new gD({
  typeName: ga.ZodSymbol,
  ...ci(t)
});
let Wk = class extends Ai {
  _parse(e) {
    if (this._getType(e) !== xn.undefined) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.undefined,
        received: n.parsedType
      }), Aa;
    }
    return Eu(e.data);
  }
};
Wk.create = (t) => new Wk({
  typeName: ga.ZodUndefined,
  ...ci(t)
});
let Hk = class extends Ai {
  _parse(e) {
    if (this._getType(e) !== xn.null) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.null,
        received: n.parsedType
      }), Aa;
    }
    return Eu(e.data);
  }
};
Hk.create = (t) => new Hk({
  typeName: ga.ZodNull,
  ...ci(t)
});
let q7 = class extends Ai {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Eu(e.data);
  }
};
q7.create = (t) => new q7({
  typeName: ga.ZodAny,
  ...ci(t)
});
let Ib = class extends Ai {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Eu(e.data);
  }
};
Ib.create = (t) => new Ib({
  typeName: ga.ZodUnknown,
  ...ci(t)
});
let Lm = class extends Ai {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return on(r, {
      code: $r.invalid_type,
      expected: xn.never,
      received: r.parsedType
    }), Aa;
  }
};
Lm.create = (t) => new Lm({
  typeName: ga.ZodNever,
  ...ci(t)
});
let vD = class extends Ai {
  _parse(e) {
    if (this._getType(e) !== xn.undefined) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.void,
        received: n.parsedType
      }), Aa;
    }
    return Eu(e.data);
  }
};
vD.create = (t) => new vD({
  typeName: ga.ZodVoid,
  ...ci(t)
});
let o5 = class zN extends Ai {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== xn.array)
      return on(r, {
        code: $r.invalid_type,
        expected: xn.array,
        received: r.parsedType
      }), Aa;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (on(r, {
        code: o ? $r.too_big : $r.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (on(r, {
      code: $r.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (on(r, {
      code: $r.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Ph(r, o, r.path, s)))).then((o) => Cd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Ph(r, o, r.path, s)));
    return Cd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new zN({
      ...this._def,
      minLength: { value: e, message: Nn.toString(r) }
    });
  }
  max(e, r) {
    return new zN({
      ...this._def,
      maxLength: { value: e, message: Nn.toString(r) }
    });
  }
  length(e, r) {
    return new zN({
      ...this._def,
      exactLength: { value: e, message: Nn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
o5.create = (t, e) => new o5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ga.ZodArray,
  ...ci(e)
});
function h9(t) {
  if (t instanceof of) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = uh.create(h9(n));
    }
    return new of({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof o5 ? new o5({
    ...t._def,
    type: h9(t.element)
  }) : t instanceof uh ? uh.create(h9(t.unwrap())) : t instanceof Xv ? Xv.create(h9(t.unwrap())) : t instanceof Yv ? Yv.create(t.items.map((e) => h9(e))) : t;
}
let of = class Yf extends Ai {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = Qi.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== xn.object) {
      const c = this._getOrReturnCtx(e);
      return on(c, {
        code: $r.invalid_type,
        expected: xn.object,
        received: c.parsedType
      }), Aa;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Lm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Ph(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Lm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (on(a, {
          code: $r.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Ph(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Cd.mergeObjectSync(n, c)) : Cd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Nn.errToObj, new Yf({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Nn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Yf({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Yf({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Yf({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Yf({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: ga.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Yf({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return Qi.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Yf({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return Qi.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Yf({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return h9(this);
  }
  partial(e) {
    const r = {};
    return Qi.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Yf({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return Qi.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof uh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Yf({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return rUe(Qi.objectKeys(this.shape));
  }
};
of.create = (t, e) => new of({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Lm.create(),
  typeName: ga.ZodObject,
  ...ci(e)
});
of.strictCreate = (t, e) => new of({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Lm.create(),
  typeName: ga.ZodObject,
  ...ci(e)
});
of.lazycreate = (t, e) => new of({
  shape: t,
  unknownKeys: "strip",
  catchall: Lm.create(),
  typeName: ga.ZodObject,
  ...ci(e)
});
let Uk = class extends Ai {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new _1(s.ctx.common.issues));
      return on(r, {
        code: $r.invalid_union,
        unionErrors: o
      }), Aa;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new _1(l));
      return on(r, {
        code: $r.invalid_union,
        unionErrors: s
      }), Aa;
    }
  }
  get options() {
    return this._def.options;
  }
};
Uk.create = (t, e) => new Uk({
  options: t,
  typeName: ga.ZodUnion,
  ...ci(e)
});
const Hp = (t) => t instanceof qk ? Hp(t.schema) : t instanceof D1 ? Hp(t.innerType()) : t instanceof Kk ? [t.value] : t instanceof BI ? t.options : t instanceof Zk ? Qi.objectValues(t.enum) : t instanceof Jk ? Hp(t._def.innerType) : t instanceof Wk ? [void 0] : t instanceof Hk ? [null] : t instanceof uh ? [void 0, ...Hp(t.unwrap())] : t instanceof Xv ? [null, ...Hp(t.unwrap())] : t instanceof I1e || t instanceof Xk ? Hp(t.unwrap()) : t instanceof Yk ? Hp(t._def.innerType) : [];
let YHe = class XHe extends Ai {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== xn.object)
      return on(r, {
        code: $r.invalid_type,
        expected: xn.object,
        received: r.parsedType
      }), Aa;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (on(r, {
      code: $r.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Aa);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Hp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new XHe({
      typeName: ga.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...ci(n)
    });
  }
};
function Qle(t, e) {
  const r = am(t), n = am(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === xn.object && n === xn.object) {
    const a = Qi.objectKeys(e), i = Qi.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Qle(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === xn.array && n === xn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Qle(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === xn.date && n === xn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let Vk = class extends Ai {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Zle(i) || Zle(o))
        return Aa;
      const s = Qle(i.value, o.value);
      return s.valid ? ((Jle(i) || Jle(o)) && r.dirty(), { status: r.value, value: s.data }) : (on(n, {
        code: $r.invalid_intersection_types
      }), Aa);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
Vk.create = (t, e, r) => new Vk({
  left: t,
  right: e,
  typeName: ga.ZodIntersection,
  ...ci(r)
});
let Yv = class QHe extends Ai {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== xn.array)
      return on(n, {
        code: $r.invalid_type,
        expected: xn.array,
        received: n.parsedType
      }), Aa;
    if (n.data.length < this._def.items.length)
      return on(n, {
        code: $r.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Aa;
    !this._def.rest && n.data.length > this._def.items.length && (on(n, {
      code: $r.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Ph(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => Cd.mergeArray(r, o)) : Cd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new QHe({
      ...this._def,
      rest: e
    });
  }
};
Yv.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Yv({
    items: t,
    typeName: ga.ZodTuple,
    rest: null,
    ...ci(e)
  });
};
let eUe = class ece extends Ai {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== xn.object)
      return on(n, {
        code: $r.invalid_type,
        expected: xn.object,
        received: n.parsedType
      }), Aa;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Ph(n, s, n.path, s)),
        value: o._parse(new Ph(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? Cd.mergeObjectAsync(r, a) : Cd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Ai ? new ece({
      keyType: e,
      valueType: r,
      typeName: ga.ZodRecord,
      ...ci(n)
    }) : new ece({
      keyType: V7.create(),
      valueType: e,
      typeName: ga.ZodRecord,
      ...ci(r)
    });
  }
}, yD = class extends Ai {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== xn.map)
      return on(n, {
        code: $r.invalid_type,
        expected: xn.map,
        received: n.parsedType
      }), Aa;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Ph(n, s, n.path, [c, "key"])),
      value: i._parse(new Ph(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Aa;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Aa;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
yD.create = (t, e, r) => new yD({
  valueType: e,
  keyType: t,
  typeName: ga.ZodMap,
  ...ci(r)
});
let bD = class tce extends Ai {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== xn.set)
      return on(n, {
        code: $r.invalid_type,
        expected: xn.set,
        received: n.parsedType
      }), Aa;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (on(n, {
      code: $r.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (on(n, {
      code: $r.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Aa;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Ph(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new tce({
      ...this._def,
      minSize: { value: e, message: Nn.toString(r) }
    });
  }
  max(e, r) {
    return new tce({
      ...this._def,
      maxSize: { value: e, message: Nn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
bD.create = (t, e) => new bD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: ga.ZodSet,
  ...ci(e)
});
let tUe = class GN extends Ai {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== xn.function)
      return on(r, {
        code: $r.invalid_type,
        expected: xn.function,
        received: r.parsedType
      }), Aa;
    function n(s, l) {
      return pD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          hD(),
          U7
        ].filter((c) => !!c),
        issueData: {
          code: $r.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return pD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          hD(),
          U7
        ].filter((c) => !!c),
        issueData: {
          code: $r.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof K7) {
      const s = this;
      return Eu(async function(...l) {
        const c = new _1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Eu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new _1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new _1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new GN({
      ...this._def,
      args: Yv.create(e).rest(Ib.create())
    });
  }
  returns(e) {
    return new GN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new GN({
      args: e || Yv.create([]).rest(Ib.create()),
      returns: r || Ib.create(),
      typeName: ga.ZodFunction,
      ...ci(n)
    });
  }
}, qk = class extends Ai {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
qk.create = (t, e) => new qk({
  getter: t,
  typeName: ga.ZodLazy,
  ...ci(e)
});
let Kk = class extends Ai {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return on(r, {
        received: r.data,
        code: $r.invalid_literal,
        expected: this._def.value
      }), Aa;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
Kk.create = (t, e) => new Kk({
  value: t,
  typeName: ga.ZodLiteral,
  ...ci(e)
});
function rUe(t, e) {
  return new BI({
    values: t,
    typeName: ga.ZodEnum,
    ...ci(e)
  });
}
let BI = class rce extends Ai {
  constructor() {
    super(...arguments), OS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return on(r, {
        expected: Qi.joinValues(n),
        received: r.parsedType,
        code: $r.invalid_type
      }), Aa;
    }
    if (mD(this, OS) || VHe(this, OS, new Set(this._def.values)), !mD(this, OS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return on(r, {
        received: r.data,
        code: $r.invalid_enum_value,
        options: n
      }), Aa;
    }
    return Eu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return rce.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return rce.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
OS = /* @__PURE__ */ new WeakMap();
BI.create = rUe;
let Zk = class extends Ai {
  constructor() {
    super(...arguments), BS.set(this, void 0);
  }
  _parse(e) {
    const r = Qi.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== xn.string && n.parsedType !== xn.number) {
      const a = Qi.objectValues(r);
      return on(n, {
        expected: Qi.joinValues(a),
        received: n.parsedType,
        code: $r.invalid_type
      }), Aa;
    }
    if (mD(this, BS) || VHe(this, BS, new Set(Qi.getValidEnumValues(this._def.values))), !mD(this, BS).has(e.data)) {
      const a = Qi.objectValues(r);
      return on(n, {
        received: n.data,
        code: $r.invalid_enum_value,
        options: a
      }), Aa;
    }
    return Eu(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
BS = /* @__PURE__ */ new WeakMap();
Zk.create = (t, e) => new Zk({
  values: t,
  typeName: ga.ZodNativeEnum,
  ...ci(e)
});
let K7 = class extends Ai {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== xn.promise && r.common.async === !1)
      return on(r, {
        code: $r.invalid_type,
        expected: xn.promise,
        received: r.parsedType
      }), Aa;
    const n = r.parsedType === xn.promise ? r.data : Promise.resolve(r.data);
    return Eu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
K7.create = (t, e) => new K7({
  type: t,
  typeName: ga.ZodPromise,
  ...ci(e)
});
let D1 = class extends Ai {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ga.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        on(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Aa;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Aa : l.status === "dirty" || r.value === "dirty" ? I9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Aa;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Aa : s.status === "dirty" || r.value === "dirty" ? I9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Aa : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Aa : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!i5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => i5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    Qi.assertNever(a);
  }
};
D1.create = (t, e, r) => new D1({
  schema: t,
  typeName: ga.ZodEffects,
  effect: e,
  ...ci(r)
});
D1.createWithPreprocess = (t, e, r) => new D1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: ga.ZodEffects,
  ...ci(r)
});
let uh = class extends Ai {
  _parse(e) {
    return this._getType(e) === xn.undefined ? Eu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
uh.create = (t, e) => new uh({
  innerType: t,
  typeName: ga.ZodOptional,
  ...ci(e)
});
let Xv = class extends Ai {
  _parse(e) {
    return this._getType(e) === xn.null ? Eu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Xv.create = (t, e) => new Xv({
  innerType: t,
  typeName: ga.ZodNullable,
  ...ci(e)
});
let Jk = class extends Ai {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === xn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
Jk.create = (t, e) => new Jk({
  innerType: t,
  typeName: ga.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...ci(e)
});
let Yk = class extends Ai {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Lk(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new _1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new _1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
Yk.create = (t, e) => new Yk({
  innerType: t,
  typeName: ga.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...ci(e)
});
let xD = class extends Ai {
  _parse(e) {
    if (this._getType(e) !== xn.nan) {
      const n = this._getOrReturnCtx(e);
      return on(n, {
        code: $r.invalid_type,
        expected: xn.nan,
        received: n.parsedType
      }), Aa;
    }
    return { status: "valid", value: e.data };
  }
};
xD.create = (t) => new xD({
  typeName: ga.ZodNaN,
  ...ci(t)
});
const F8t = Symbol("zod_brand");
let I1e = class extends Ai {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, M1e = class nUe extends Ai {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Aa : i.status === "dirty" ? (r.dirty(), I9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Aa : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new nUe({
      in: e,
      out: r,
      typeName: ga.ZodPipeline
    });
  }
}, Xk = class extends Ai {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (i5(a) && (a.value = Object.freeze(a.value)), a);
    return Lk(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Xk.create = (t, e) => new Xk({
  innerType: t,
  typeName: ga.ZodReadonly,
  ...ci(e)
});
function aUe(t, e = {}, r) {
  return t ? q7.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : q7.create();
}
const z8t = {
  object: of.lazycreate
};
var ga;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(ga || (ga = {}));
const G8t = (t, e = {
  message: `Input not instance of ${t.name}`
}) => aUe((r) => r instanceof t, e), iUe = V7.create, oUe = jk.create, W8t = xD.create, H8t = Fk.create, sUe = zk.create, U8t = Gk.create, V8t = gD.create, q8t = Wk.create, K8t = Hk.create, Z8t = q7.create, J8t = Ib.create, Y8t = Lm.create, X8t = vD.create, Q8t = o5.create, eCt = of.create, tCt = of.strictCreate, rCt = Uk.create, nCt = YHe.create, aCt = Vk.create, iCt = Yv.create, oCt = eUe.create, sCt = yD.create, lCt = bD.create, cCt = tUe.create, uCt = qk.create, dCt = Kk.create, fCt = BI.create, hCt = Zk.create, pCt = K7.create, j6e = D1.create, mCt = uh.create, gCt = Xv.create, vCt = D1.createWithPreprocess, yCt = M1e.create, bCt = () => iUe().optional(), xCt = () => oUe().optional(), CCt = () => sUe().optional(), wCt = {
  string: (t) => V7.create({ ...t, coerce: !0 }),
  number: (t) => jk.create({ ...t, coerce: !0 }),
  boolean: (t) => zk.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => Fk.create({ ...t, coerce: !0 }),
  date: (t) => Gk.create({ ...t, coerce: !0 })
}, SCt = Aa;
var P1e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: U7,
  setErrorMap: v8t,
  getErrorMap: hD,
  makeIssue: pD,
  EMPTY_PATH: y8t,
  addIssueToContext: on,
  ParseStatus: Cd,
  INVALID: Aa,
  DIRTY: I9,
  OK: Eu,
  isAborted: Zle,
  isDirty: Jle,
  isValid: i5,
  isAsync: Lk,
  get util() {
    return Qi;
  },
  get objectUtil() {
    return Kle;
  },
  ZodParsedType: xn,
  getParsedType: am,
  ZodType: Ai,
  datetimeRegex: ZHe,
  ZodString: V7,
  ZodNumber: jk,
  ZodBigInt: Fk,
  ZodBoolean: zk,
  ZodDate: Gk,
  ZodSymbol: gD,
  ZodUndefined: Wk,
  ZodNull: Hk,
  ZodAny: q7,
  ZodUnknown: Ib,
  ZodNever: Lm,
  ZodVoid: vD,
  ZodArray: o5,
  ZodObject: of,
  ZodUnion: Uk,
  ZodDiscriminatedUnion: YHe,
  ZodIntersection: Vk,
  ZodTuple: Yv,
  ZodRecord: eUe,
  ZodMap: yD,
  ZodSet: bD,
  ZodFunction: tUe,
  ZodLazy: qk,
  ZodLiteral: Kk,
  ZodEnum: BI,
  ZodNativeEnum: Zk,
  ZodPromise: K7,
  ZodEffects: D1,
  ZodTransformer: D1,
  ZodOptional: uh,
  ZodNullable: Xv,
  ZodDefault: Jk,
  ZodCatch: Yk,
  ZodNaN: xD,
  BRAND: F8t,
  ZodBranded: I1e,
  ZodPipeline: M1e,
  ZodReadonly: Xk,
  custom: aUe,
  Schema: Ai,
  ZodSchema: Ai,
  late: z8t,
  get ZodFirstPartyTypeKind() {
    return ga;
  },
  coerce: wCt,
  any: Z8t,
  array: Q8t,
  bigint: H8t,
  boolean: sUe,
  date: U8t,
  discriminatedUnion: nCt,
  effect: j6e,
  enum: fCt,
  function: cCt,
  instanceof: G8t,
  intersection: aCt,
  lazy: uCt,
  literal: dCt,
  map: sCt,
  nan: W8t,
  nativeEnum: hCt,
  never: Y8t,
  null: K8t,
  nullable: gCt,
  number: oUe,
  object: eCt,
  oboolean: CCt,
  onumber: xCt,
  optional: mCt,
  ostring: bCt,
  pipeline: yCt,
  preprocess: vCt,
  promise: pCt,
  record: oCt,
  set: lCt,
  strictObject: tCt,
  string: iUe,
  symbol: V8t,
  transformer: j6e,
  tuple: iCt,
  undefined: q8t,
  union: rCt,
  unknown: J8t,
  void: X8t,
  NEVER: SCt,
  ZodIssueCode: $r,
  quotelessJson: g8t,
  ZodError: _1
});
const Ov = T1e().refine(
  (t) => t.startsWith(aD) && t.length === F7,
  {
    message: `AccountSID must start with ${aD} and be ${F7} characters long`
  }
), _Ct = {
  PLAYGROUND: "PLAYGROUND",
  SLACK: "SLACK",
  ONE_ADMIN: "ONE_ADMIN",
  ONE_SUPPORT_CENTER: "ONE_SUPPORT_CENTER",
  SENDGRID_HELP_CENTER: "SENDGRID_HELP_CENTER",
  ZENDESK: "ZENDESK",
  SALESFORCE: "SALESFORCE",
  MESSAGING_INSIGHTS: "MESSAGING_INSIGHTS",
  CONSOLE_MESSAGING_LOGS: "CONSOLE_MESSAGING_LOGS",
  CONSOLE_MESSAGING_LOGS_DETAILS: "CONSOLE_MESSAGING_LOGS_DETAILS",
  WISEOWL_APP: "WISEOWL_APP",
  VOICE_INSIGHTS: "VOICE_INSIGHTS",
  ISA: "ISA"
}, lz = P1e.nativeEnum(_Ct), kCt = {
  CHAT: "CHAT",
  CONVERSATION: "CONVERSATION"
}, lUe = P1e.nativeEnum(kCt), ACt = P1e.string().nullable().optional().transform((t) => t ?? null);
ACt.refine(
  (t) => t === null || t.startsWith(aD) && t.length === F7,
  {
    message: `AccountSID must start with ${aD} and be ${F7} characters long`
  }
);
const S_ = T1e().refine((t) => /^\d+$/.test(t), {
  message: "SendGridUserId must contain only digits"
}), Qk = T1e().refine(
  (t) => t.startsWith(B6e) && t.length === F7,
  {
    message: `UserSID must start with ${B6e} and be ${F7} characters long`
  }
);
E1e();
const s5 = E1e(), cUe = E1e();
var uUe = {}, cz = {};
cz.byteLength = ICt;
cz.toByteArray = PCt;
cz.fromByteArray = BCt;
var Y2 = [], G0 = [], TCt = typeof Uint8Array < "u" ? Uint8Array : Array, MK = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var j4 = 0, ECt = MK.length; j4 < ECt; ++j4)
  Y2[j4] = MK[j4], G0[MK.charCodeAt(j4)] = j4;
G0[45] = 62;
G0[95] = 63;
function dUe(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function ICt(t) {
  var e = dUe(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function MCt(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function PCt(t) {
  var e, r = dUe(t), n = r[0], a = r[1], i = new TCt(MCt(t, n, a)), o = 0, s = a > 0 ? n - 4 : n, l;
  for (l = 0; l < s; l += 4)
    e = G0[t.charCodeAt(l)] << 18 | G0[t.charCodeAt(l + 1)] << 12 | G0[t.charCodeAt(l + 2)] << 6 | G0[t.charCodeAt(l + 3)], i[o++] = e >> 16 & 255, i[o++] = e >> 8 & 255, i[o++] = e & 255;
  return a === 2 && (e = G0[t.charCodeAt(l)] << 2 | G0[t.charCodeAt(l + 1)] >> 4, i[o++] = e & 255), a === 1 && (e = G0[t.charCodeAt(l)] << 10 | G0[t.charCodeAt(l + 1)] << 4 | G0[t.charCodeAt(l + 2)] >> 2, i[o++] = e >> 8 & 255, i[o++] = e & 255), i;
}
function RCt(t) {
  return Y2[t >> 18 & 63] + Y2[t >> 12 & 63] + Y2[t >> 6 & 63] + Y2[t & 63];
}
function OCt(t, e, r) {
  for (var n, a = [], i = e; i < r; i += 3)
    n = (t[i] << 16 & 16711680) + (t[i + 1] << 8 & 65280) + (t[i + 2] & 255), a.push(RCt(n));
  return a.join("");
}
function BCt(t) {
  for (var e, r = t.length, n = r % 3, a = [], i = 16383, o = 0, s = r - n; o < s; o += i)
    a.push(OCt(t, o, o + i > s ? s : o + i));
  return n === 1 ? (e = t[r - 1], a.push(
    Y2[e >> 2] + Y2[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], a.push(
    Y2[e >> 10] + Y2[e >> 4 & 63] + Y2[e << 2 & 63] + "="
  )), a.join("");
}
var R1e = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
R1e.read = function(t, e, r, n, a) {
  var i, o, s = a * 8 - n - 1, l = (1 << s) - 1, c = l >> 1, u = -7, f = r ? a - 1 : 0, h = r ? -1 : 1, p = t[e + f];
  for (f += h, i = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; i = i * 256 + t[e + f], f += h, u -= 8)
    ;
  for (o = i & (1 << -u) - 1, i >>= -u, u += n; u > 0; o = o * 256 + t[e + f], f += h, u -= 8)
    ;
  if (i === 0)
    i = 1 - c;
  else {
    if (i === l)
      return o ? NaN : (p ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, n), i = i - c;
  }
  return (p ? -1 : 1) * o * Math.pow(2, i - n);
};
R1e.write = function(t, e, r, n, a, i) {
  var o, s, l, c = i * 8 - a - 1, u = (1 << c) - 1, f = u >> 1, h = a === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = n ? 0 : i - 1, g = n ? 1 : -1, y = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + f >= 1 ? e += h / l : e += h * Math.pow(2, 1 - f), e * l >= 2 && (o++, l /= 2), o + f >= u ? (s = 0, o = u) : o + f >= 1 ? (s = (e * l - 1) * Math.pow(2, a), o = o + f) : (s = e * Math.pow(2, f - 1) * Math.pow(2, a), o = 0)); a >= 8; t[r + p] = s & 255, p += g, s /= 256, a -= 8)
    ;
  for (o = o << a | s, c += a; c > 0; t[r + p] = o & 255, p += g, o /= 256, c -= 8)
    ;
  t[r + p - g] |= y * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = cz, r = R1e, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = u, t.SlowBuffer = S, t.INSPECT_MAX_BYTES = 50;
  const a = 2147483647;
  t.kMaxLength = a;
  const { Uint8Array: i, ArrayBuffer: o, SharedArrayBuffer: s } = globalThis;
  u.TYPED_ARRAY_SUPPORT = l(), !u.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function l() {
    try {
      const ne = new i(1), re = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(re, i.prototype), Object.setPrototypeOf(ne, re), ne.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(u.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(u.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (u.isBuffer(this))
        return this.byteOffset;
    }
  });
  function c(ne) {
    if (ne > a)
      throw new RangeError('The value "' + ne + '" is invalid for option "size"');
    const re = new i(ne);
    return Object.setPrototypeOf(re, u.prototype), re;
  }
  function u(ne, re, ie) {
    if (typeof ne == "number") {
      if (typeof re == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return g(ne);
    }
    return f(ne, re, ie);
  }
  u.poolSize = 8192;
  function f(ne, re, ie) {
    if (typeof ne == "string")
      return y(ne, re);
    if (o.isView(ne))
      return w(ne);
    if (ne == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ne
      );
    if (Ot(ne, o) || ne && Ot(ne.buffer, o) || typeof s < "u" && (Ot(ne, s) || ne && Ot(ne.buffer, s)))
      return _(ne, re, ie);
    if (typeof ne == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const Ie = ne.valueOf && ne.valueOf();
    if (Ie != null && Ie !== ne)
      return u.from(Ie, re, ie);
    const Ke = C(ne);
    if (Ke) return Ke;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof ne[Symbol.toPrimitive] == "function")
      return u.from(ne[Symbol.toPrimitive]("string"), re, ie);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof ne
    );
  }
  u.from = function(ne, re, ie) {
    return f(ne, re, ie);
  }, Object.setPrototypeOf(u.prototype, i.prototype), Object.setPrototypeOf(u, i);
  function h(ne) {
    if (typeof ne != "number")
      throw new TypeError('"size" argument must be of type number');
    if (ne < 0)
      throw new RangeError('The value "' + ne + '" is invalid for option "size"');
  }
  function p(ne, re, ie) {
    return h(ne), ne <= 0 ? c(ne) : re !== void 0 ? typeof ie == "string" ? c(ne).fill(re, ie) : c(ne).fill(re) : c(ne);
  }
  u.alloc = function(ne, re, ie) {
    return p(ne, re, ie);
  };
  function g(ne) {
    return h(ne), c(ne < 0 ? 0 : x(ne) | 0);
  }
  u.allocUnsafe = function(ne) {
    return g(ne);
  }, u.allocUnsafeSlow = function(ne) {
    return g(ne);
  };
  function y(ne, re) {
    if ((typeof re != "string" || re === "") && (re = "utf8"), !u.isEncoding(re))
      throw new TypeError("Unknown encoding: " + re);
    const ie = A(ne, re) | 0;
    let Ie = c(ie);
    const Ke = Ie.write(ne, re);
    return Ke !== ie && (Ie = Ie.slice(0, Ke)), Ie;
  }
  function b(ne) {
    const re = ne.length < 0 ? 0 : x(ne.length) | 0, ie = c(re);
    for (let Ie = 0; Ie < re; Ie += 1)
      ie[Ie] = ne[Ie] & 255;
    return ie;
  }
  function w(ne) {
    if (Ot(ne, i)) {
      const re = new i(ne);
      return _(re.buffer, re.byteOffset, re.byteLength);
    }
    return b(ne);
  }
  function _(ne, re, ie) {
    if (re < 0 || ne.byteLength < re)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (ne.byteLength < re + (ie || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let Ie;
    return re === void 0 && ie === void 0 ? Ie = new i(ne) : ie === void 0 ? Ie = new i(ne, re) : Ie = new i(ne, re, ie), Object.setPrototypeOf(Ie, u.prototype), Ie;
  }
  function C(ne) {
    if (u.isBuffer(ne)) {
      const re = x(ne.length) | 0, ie = c(re);
      return ie.length === 0 || ne.copy(ie, 0, 0, re), ie;
    }
    if (ne.length !== void 0)
      return typeof ne.length != "number" || lt(ne.length) ? c(0) : b(ne);
    if (ne.type === "Buffer" && Array.isArray(ne.data))
      return b(ne.data);
  }
  function x(ne) {
    if (ne >= a)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a.toString(16) + " bytes");
    return ne | 0;
  }
  function S(ne) {
    return +ne != ne && (ne = 0), u.alloc(+ne);
  }
  u.isBuffer = function(re) {
    return re != null && re._isBuffer === !0 && re !== u.prototype;
  }, u.compare = function(re, ie) {
    if (Ot(re, i) && (re = u.from(re, re.offset, re.byteLength)), Ot(ie, i) && (ie = u.from(ie, ie.offset, ie.byteLength)), !u.isBuffer(re) || !u.isBuffer(ie))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (re === ie) return 0;
    let Ie = re.length, Ke = ie.length;
    for (let Le = 0, Ge = Math.min(Ie, Ke); Le < Ge; ++Le)
      if (re[Le] !== ie[Le]) {
        Ie = re[Le], Ke = ie[Le];
        break;
      }
    return Ie < Ke ? -1 : Ke < Ie ? 1 : 0;
  }, u.isEncoding = function(re) {
    switch (String(re).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, u.concat = function(re, ie) {
    if (!Array.isArray(re))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (re.length === 0)
      return u.alloc(0);
    let Ie;
    if (ie === void 0)
      for (ie = 0, Ie = 0; Ie < re.length; ++Ie)
        ie += re[Ie].length;
    const Ke = u.allocUnsafe(ie);
    let Le = 0;
    for (Ie = 0; Ie < re.length; ++Ie) {
      let Ge = re[Ie];
      if (Ot(Ge, i))
        Le + Ge.length > Ke.length ? (u.isBuffer(Ge) || (Ge = u.from(Ge)), Ge.copy(Ke, Le)) : i.prototype.set.call(
          Ke,
          Ge,
          Le
        );
      else if (u.isBuffer(Ge))
        Ge.copy(Ke, Le);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Le += Ge.length;
    }
    return Ke;
  };
  function A(ne, re) {
    if (u.isBuffer(ne))
      return ne.length;
    if (o.isView(ne) || Ot(ne, o))
      return ne.byteLength;
    if (typeof ne != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof ne
      );
    const ie = ne.length, Ie = arguments.length > 2 && arguments[2] === !0;
    if (!Ie && ie === 0) return 0;
    let Ke = !1;
    for (; ; )
      switch (re) {
        case "ascii":
        case "latin1":
        case "binary":
          return ie;
        case "utf8":
        case "utf-8":
          return ct(ne).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ie * 2;
        case "hex":
          return ie >>> 1;
        case "base64":
          return nt(ne).length;
        default:
          if (Ke)
            return Ie ? -1 : ct(ne).length;
          re = ("" + re).toLowerCase(), Ke = !0;
      }
  }
  u.byteLength = A;
  function I(ne, re, ie) {
    let Ie = !1;
    if ((re === void 0 || re < 0) && (re = 0), re > this.length || ((ie === void 0 || ie > this.length) && (ie = this.length), ie <= 0) || (ie >>>= 0, re >>>= 0, ie <= re))
      return "";
    for (ne || (ne = "utf8"); ; )
      switch (ne) {
        case "hex":
          return W(this, re, ie);
        case "utf8":
        case "utf-8":
          return G(this, re, ie);
        case "ascii":
          return F(this, re, ie);
        case "latin1":
        case "binary":
          return z(this, re, ie);
        case "base64":
          return O(this, re, ie);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return U(this, re, ie);
        default:
          if (Ie) throw new TypeError("Unknown encoding: " + ne);
          ne = (ne + "").toLowerCase(), Ie = !0;
      }
  }
  u.prototype._isBuffer = !0;
  function M(ne, re, ie) {
    const Ie = ne[re];
    ne[re] = ne[ie], ne[ie] = Ie;
  }
  u.prototype.swap16 = function() {
    const re = this.length;
    if (re % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let ie = 0; ie < re; ie += 2)
      M(this, ie, ie + 1);
    return this;
  }, u.prototype.swap32 = function() {
    const re = this.length;
    if (re % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let ie = 0; ie < re; ie += 4)
      M(this, ie, ie + 3), M(this, ie + 1, ie + 2);
    return this;
  }, u.prototype.swap64 = function() {
    const re = this.length;
    if (re % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let ie = 0; ie < re; ie += 8)
      M(this, ie, ie + 7), M(this, ie + 1, ie + 6), M(this, ie + 2, ie + 5), M(this, ie + 3, ie + 4);
    return this;
  }, u.prototype.toString = function() {
    const re = this.length;
    return re === 0 ? "" : arguments.length === 0 ? G(this, 0, re) : I.apply(this, arguments);
  }, u.prototype.toLocaleString = u.prototype.toString, u.prototype.equals = function(re) {
    if (!u.isBuffer(re)) throw new TypeError("Argument must be a Buffer");
    return this === re ? !0 : u.compare(this, re) === 0;
  }, u.prototype.inspect = function() {
    let re = "";
    const ie = t.INSPECT_MAX_BYTES;
    return re = this.toString("hex", 0, ie).replace(/(.{2})/g, "$1 ").trim(), this.length > ie && (re += " ... "), "<Buffer " + re + ">";
  }, n && (u.prototype[n] = u.prototype.inspect), u.prototype.compare = function(re, ie, Ie, Ke, Le) {
    if (Ot(re, i) && (re = u.from(re, re.offset, re.byteLength)), !u.isBuffer(re))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof re
      );
    if (ie === void 0 && (ie = 0), Ie === void 0 && (Ie = re ? re.length : 0), Ke === void 0 && (Ke = 0), Le === void 0 && (Le = this.length), ie < 0 || Ie > re.length || Ke < 0 || Le > this.length)
      throw new RangeError("out of range index");
    if (Ke >= Le && ie >= Ie)
      return 0;
    if (Ke >= Le)
      return -1;
    if (ie >= Ie)
      return 1;
    if (ie >>>= 0, Ie >>>= 0, Ke >>>= 0, Le >>>= 0, this === re) return 0;
    let Ge = Le - Ke, ft = Ie - ie;
    const ot = Math.min(Ge, ft), Ye = this.slice(Ke, Le), Je = re.slice(ie, Ie);
    for (let tt = 0; tt < ot; ++tt)
      if (Ye[tt] !== Je[tt]) {
        Ge = Ye[tt], ft = Je[tt];
        break;
      }
    return Ge < ft ? -1 : ft < Ge ? 1 : 0;
  };
  function B(ne, re, ie, Ie, Ke) {
    if (ne.length === 0) return -1;
    if (typeof ie == "string" ? (Ie = ie, ie = 0) : ie > 2147483647 ? ie = 2147483647 : ie < -2147483648 && (ie = -2147483648), ie = +ie, lt(ie) && (ie = Ke ? 0 : ne.length - 1), ie < 0 && (ie = ne.length + ie), ie >= ne.length) {
      if (Ke) return -1;
      ie = ne.length - 1;
    } else if (ie < 0)
      if (Ke) ie = 0;
      else return -1;
    if (typeof re == "string" && (re = u.from(re, Ie)), u.isBuffer(re))
      return re.length === 0 ? -1 : L(ne, re, ie, Ie, Ke);
    if (typeof re == "number")
      return re = re & 255, typeof i.prototype.indexOf == "function" ? Ke ? i.prototype.indexOf.call(ne, re, ie) : i.prototype.lastIndexOf.call(ne, re, ie) : L(ne, [re], ie, Ie, Ke);
    throw new TypeError("val must be string, number or Buffer");
  }
  function L(ne, re, ie, Ie, Ke) {
    let Le = 1, Ge = ne.length, ft = re.length;
    if (Ie !== void 0 && (Ie = String(Ie).toLowerCase(), Ie === "ucs2" || Ie === "ucs-2" || Ie === "utf16le" || Ie === "utf-16le")) {
      if (ne.length < 2 || re.length < 2)
        return -1;
      Le = 2, Ge /= 2, ft /= 2, ie /= 2;
    }
    function ot(Je, tt) {
      return Le === 1 ? Je[tt] : Je.readUInt16BE(tt * Le);
    }
    let Ye;
    if (Ke) {
      let Je = -1;
      for (Ye = ie; Ye < Ge; Ye++)
        if (ot(ne, Ye) === ot(re, Je === -1 ? 0 : Ye - Je)) {
          if (Je === -1 && (Je = Ye), Ye - Je + 1 === ft) return Je * Le;
        } else
          Je !== -1 && (Ye -= Ye - Je), Je = -1;
    } else
      for (ie + ft > Ge && (ie = Ge - ft), Ye = ie; Ye >= 0; Ye--) {
        let Je = !0;
        for (let tt = 0; tt < ft; tt++)
          if (ot(ne, Ye + tt) !== ot(re, tt)) {
            Je = !1;
            break;
          }
        if (Je) return Ye;
      }
    return -1;
  }
  u.prototype.includes = function(re, ie, Ie) {
    return this.indexOf(re, ie, Ie) !== -1;
  }, u.prototype.indexOf = function(re, ie, Ie) {
    return B(this, re, ie, Ie, !0);
  }, u.prototype.lastIndexOf = function(re, ie, Ie) {
    return B(this, re, ie, Ie, !1);
  };
  function N(ne, re, ie, Ie) {
    ie = Number(ie) || 0;
    const Ke = ne.length - ie;
    Ie ? (Ie = Number(Ie), Ie > Ke && (Ie = Ke)) : Ie = Ke;
    const Le = re.length;
    Ie > Le / 2 && (Ie = Le / 2);
    let Ge;
    for (Ge = 0; Ge < Ie; ++Ge) {
      const ft = parseInt(re.substr(Ge * 2, 2), 16);
      if (lt(ft)) return Ge;
      ne[ie + Ge] = ft;
    }
    return Ge;
  }
  function d(ne, re, ie, Ie) {
    return Rt(ct(re, ne.length - ie), ne, ie, Ie);
  }
  function m(ne, re, ie, Ie) {
    return Rt(rt(re), ne, ie, Ie);
  }
  function v(ne, re, ie, Ie) {
    return Rt(nt(re), ne, ie, Ie);
  }
  function k(ne, re, ie, Ie) {
    return Rt(qe(re, ne.length - ie), ne, ie, Ie);
  }
  u.prototype.write = function(re, ie, Ie, Ke) {
    if (ie === void 0)
      Ke = "utf8", Ie = this.length, ie = 0;
    else if (Ie === void 0 && typeof ie == "string")
      Ke = ie, Ie = this.length, ie = 0;
    else if (isFinite(ie))
      ie = ie >>> 0, isFinite(Ie) ? (Ie = Ie >>> 0, Ke === void 0 && (Ke = "utf8")) : (Ke = Ie, Ie = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Le = this.length - ie;
    if ((Ie === void 0 || Ie > Le) && (Ie = Le), re.length > 0 && (Ie < 0 || ie < 0) || ie > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Ke || (Ke = "utf8");
    let Ge = !1;
    for (; ; )
      switch (Ke) {
        case "hex":
          return N(this, re, ie, Ie);
        case "utf8":
        case "utf-8":
          return d(this, re, ie, Ie);
        case "ascii":
        case "latin1":
        case "binary":
          return m(this, re, ie, Ie);
        case "base64":
          return v(this, re, ie, Ie);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return k(this, re, ie, Ie);
        default:
          if (Ge) throw new TypeError("Unknown encoding: " + Ke);
          Ke = ("" + Ke).toLowerCase(), Ge = !0;
      }
  }, u.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function O(ne, re, ie) {
    return re === 0 && ie === ne.length ? e.fromByteArray(ne) : e.fromByteArray(ne.slice(re, ie));
  }
  function G(ne, re, ie) {
    ie = Math.min(ne.length, ie);
    const Ie = [];
    let Ke = re;
    for (; Ke < ie; ) {
      const Le = ne[Ke];
      let Ge = null, ft = Le > 239 ? 4 : Le > 223 ? 3 : Le > 191 ? 2 : 1;
      if (Ke + ft <= ie) {
        let ot, Ye, Je, tt;
        switch (ft) {
          case 1:
            Le < 128 && (Ge = Le);
            break;
          case 2:
            ot = ne[Ke + 1], (ot & 192) === 128 && (tt = (Le & 31) << 6 | ot & 63, tt > 127 && (Ge = tt));
            break;
          case 3:
            ot = ne[Ke + 1], Ye = ne[Ke + 2], (ot & 192) === 128 && (Ye & 192) === 128 && (tt = (Le & 15) << 12 | (ot & 63) << 6 | Ye & 63, tt > 2047 && (tt < 55296 || tt > 57343) && (Ge = tt));
            break;
          case 4:
            ot = ne[Ke + 1], Ye = ne[Ke + 2], Je = ne[Ke + 3], (ot & 192) === 128 && (Ye & 192) === 128 && (Je & 192) === 128 && (tt = (Le & 15) << 18 | (ot & 63) << 12 | (Ye & 63) << 6 | Je & 63, tt > 65535 && tt < 1114112 && (Ge = tt));
        }
      }
      Ge === null ? (Ge = 65533, ft = 1) : Ge > 65535 && (Ge -= 65536, Ie.push(Ge >>> 10 & 1023 | 55296), Ge = 56320 | Ge & 1023), Ie.push(Ge), Ke += ft;
    }
    return j(Ie);
  }
  const H = 4096;
  function j(ne) {
    const re = ne.length;
    if (re <= H)
      return String.fromCharCode.apply(String, ne);
    let ie = "", Ie = 0;
    for (; Ie < re; )
      ie += String.fromCharCode.apply(
        String,
        ne.slice(Ie, Ie += H)
      );
    return ie;
  }
  function F(ne, re, ie) {
    let Ie = "";
    ie = Math.min(ne.length, ie);
    for (let Ke = re; Ke < ie; ++Ke)
      Ie += String.fromCharCode(ne[Ke] & 127);
    return Ie;
  }
  function z(ne, re, ie) {
    let Ie = "";
    ie = Math.min(ne.length, ie);
    for (let Ke = re; Ke < ie; ++Ke)
      Ie += String.fromCharCode(ne[Ke]);
    return Ie;
  }
  function W(ne, re, ie) {
    const Ie = ne.length;
    (!re || re < 0) && (re = 0), (!ie || ie < 0 || ie > Ie) && (ie = Ie);
    let Ke = "";
    for (let Le = re; Le < ie; ++Le)
      Ke += mt[ne[Le]];
    return Ke;
  }
  function U(ne, re, ie) {
    const Ie = ne.slice(re, ie);
    let Ke = "";
    for (let Le = 0; Le < Ie.length - 1; Le += 2)
      Ke += String.fromCharCode(Ie[Le] + Ie[Le + 1] * 256);
    return Ke;
  }
  u.prototype.slice = function(re, ie) {
    const Ie = this.length;
    re = ~~re, ie = ie === void 0 ? Ie : ~~ie, re < 0 ? (re += Ie, re < 0 && (re = 0)) : re > Ie && (re = Ie), ie < 0 ? (ie += Ie, ie < 0 && (ie = 0)) : ie > Ie && (ie = Ie), ie < re && (ie = re);
    const Ke = this.subarray(re, ie);
    return Object.setPrototypeOf(Ke, u.prototype), Ke;
  };
  function Z(ne, re, ie) {
    if (ne % 1 !== 0 || ne < 0) throw new RangeError("offset is not uint");
    if (ne + re > ie) throw new RangeError("Trying to access beyond buffer length");
  }
  u.prototype.readUintLE = u.prototype.readUIntLE = function(re, ie, Ie) {
    re = re >>> 0, ie = ie >>> 0, Ie || Z(re, ie, this.length);
    let Ke = this[re], Le = 1, Ge = 0;
    for (; ++Ge < ie && (Le *= 256); )
      Ke += this[re + Ge] * Le;
    return Ke;
  }, u.prototype.readUintBE = u.prototype.readUIntBE = function(re, ie, Ie) {
    re = re >>> 0, ie = ie >>> 0, Ie || Z(re, ie, this.length);
    let Ke = this[re + --ie], Le = 1;
    for (; ie > 0 && (Le *= 256); )
      Ke += this[re + --ie] * Le;
    return Ke;
  }, u.prototype.readUint8 = u.prototype.readUInt8 = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 1, this.length), this[re];
  }, u.prototype.readUint16LE = u.prototype.readUInt16LE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 2, this.length), this[re] | this[re + 1] << 8;
  }, u.prototype.readUint16BE = u.prototype.readUInt16BE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 2, this.length), this[re] << 8 | this[re + 1];
  }, u.prototype.readUint32LE = u.prototype.readUInt32LE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), (this[re] | this[re + 1] << 8 | this[re + 2] << 16) + this[re + 3] * 16777216;
  }, u.prototype.readUint32BE = u.prototype.readUInt32BE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), this[re] * 16777216 + (this[re + 1] << 16 | this[re + 2] << 8 | this[re + 3]);
  }, u.prototype.readBigUInt64LE = jt(function(re) {
    re = re >>> 0, gt(re, "offset");
    const ie = this[re], Ie = this[re + 7];
    (ie === void 0 || Ie === void 0) && Ze(re, this.length - 8);
    const Ke = ie + this[++re] * 2 ** 8 + this[++re] * 2 ** 16 + this[++re] * 2 ** 24, Le = this[++re] + this[++re] * 2 ** 8 + this[++re] * 2 ** 16 + Ie * 2 ** 24;
    return BigInt(Ke) + (BigInt(Le) << BigInt(32));
  }), u.prototype.readBigUInt64BE = jt(function(re) {
    re = re >>> 0, gt(re, "offset");
    const ie = this[re], Ie = this[re + 7];
    (ie === void 0 || Ie === void 0) && Ze(re, this.length - 8);
    const Ke = ie * 2 ** 24 + this[++re] * 2 ** 16 + this[++re] * 2 ** 8 + this[++re], Le = this[++re] * 2 ** 24 + this[++re] * 2 ** 16 + this[++re] * 2 ** 8 + Ie;
    return (BigInt(Ke) << BigInt(32)) + BigInt(Le);
  }), u.prototype.readIntLE = function(re, ie, Ie) {
    re = re >>> 0, ie = ie >>> 0, Ie || Z(re, ie, this.length);
    let Ke = this[re], Le = 1, Ge = 0;
    for (; ++Ge < ie && (Le *= 256); )
      Ke += this[re + Ge] * Le;
    return Le *= 128, Ke >= Le && (Ke -= Math.pow(2, 8 * ie)), Ke;
  }, u.prototype.readIntBE = function(re, ie, Ie) {
    re = re >>> 0, ie = ie >>> 0, Ie || Z(re, ie, this.length);
    let Ke = ie, Le = 1, Ge = this[re + --Ke];
    for (; Ke > 0 && (Le *= 256); )
      Ge += this[re + --Ke] * Le;
    return Le *= 128, Ge >= Le && (Ge -= Math.pow(2, 8 * ie)), Ge;
  }, u.prototype.readInt8 = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 1, this.length), this[re] & 128 ? (255 - this[re] + 1) * -1 : this[re];
  }, u.prototype.readInt16LE = function(re, ie) {
    re = re >>> 0, ie || Z(re, 2, this.length);
    const Ie = this[re] | this[re + 1] << 8;
    return Ie & 32768 ? Ie | 4294901760 : Ie;
  }, u.prototype.readInt16BE = function(re, ie) {
    re = re >>> 0, ie || Z(re, 2, this.length);
    const Ie = this[re + 1] | this[re] << 8;
    return Ie & 32768 ? Ie | 4294901760 : Ie;
  }, u.prototype.readInt32LE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), this[re] | this[re + 1] << 8 | this[re + 2] << 16 | this[re + 3] << 24;
  }, u.prototype.readInt32BE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), this[re] << 24 | this[re + 1] << 16 | this[re + 2] << 8 | this[re + 3];
  }, u.prototype.readBigInt64LE = jt(function(re) {
    re = re >>> 0, gt(re, "offset");
    const ie = this[re], Ie = this[re + 7];
    (ie === void 0 || Ie === void 0) && Ze(re, this.length - 8);
    const Ke = this[re + 4] + this[re + 5] * 2 ** 8 + this[re + 6] * 2 ** 16 + (Ie << 24);
    return (BigInt(Ke) << BigInt(32)) + BigInt(ie + this[++re] * 2 ** 8 + this[++re] * 2 ** 16 + this[++re] * 2 ** 24);
  }), u.prototype.readBigInt64BE = jt(function(re) {
    re = re >>> 0, gt(re, "offset");
    const ie = this[re], Ie = this[re + 7];
    (ie === void 0 || Ie === void 0) && Ze(re, this.length - 8);
    const Ke = (ie << 24) + // Overflow
    this[++re] * 2 ** 16 + this[++re] * 2 ** 8 + this[++re];
    return (BigInt(Ke) << BigInt(32)) + BigInt(this[++re] * 2 ** 24 + this[++re] * 2 ** 16 + this[++re] * 2 ** 8 + Ie);
  }), u.prototype.readFloatLE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), r.read(this, re, !0, 23, 4);
  }, u.prototype.readFloatBE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 4, this.length), r.read(this, re, !1, 23, 4);
  }, u.prototype.readDoubleLE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 8, this.length), r.read(this, re, !0, 52, 8);
  }, u.prototype.readDoubleBE = function(re, ie) {
    return re = re >>> 0, ie || Z(re, 8, this.length), r.read(this, re, !1, 52, 8);
  };
  function V(ne, re, ie, Ie, Ke, Le) {
    if (!u.isBuffer(ne)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (re > Ke || re < Le) throw new RangeError('"value" argument is out of bounds');
    if (ie + Ie > ne.length) throw new RangeError("Index out of range");
  }
  u.prototype.writeUintLE = u.prototype.writeUIntLE = function(re, ie, Ie, Ke) {
    if (re = +re, ie = ie >>> 0, Ie = Ie >>> 0, !Ke) {
      const ft = Math.pow(2, 8 * Ie) - 1;
      V(this, re, ie, Ie, ft, 0);
    }
    let Le = 1, Ge = 0;
    for (this[ie] = re & 255; ++Ge < Ie && (Le *= 256); )
      this[ie + Ge] = re / Le & 255;
    return ie + Ie;
  }, u.prototype.writeUintBE = u.prototype.writeUIntBE = function(re, ie, Ie, Ke) {
    if (re = +re, ie = ie >>> 0, Ie = Ie >>> 0, !Ke) {
      const ft = Math.pow(2, 8 * Ie) - 1;
      V(this, re, ie, Ie, ft, 0);
    }
    let Le = Ie - 1, Ge = 1;
    for (this[ie + Le] = re & 255; --Le >= 0 && (Ge *= 256); )
      this[ie + Le] = re / Ge & 255;
    return ie + Ie;
  }, u.prototype.writeUint8 = u.prototype.writeUInt8 = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 1, 255, 0), this[ie] = re & 255, ie + 1;
  }, u.prototype.writeUint16LE = u.prototype.writeUInt16LE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 2, 65535, 0), this[ie] = re & 255, this[ie + 1] = re >>> 8, ie + 2;
  }, u.prototype.writeUint16BE = u.prototype.writeUInt16BE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 2, 65535, 0), this[ie] = re >>> 8, this[ie + 1] = re & 255, ie + 2;
  }, u.prototype.writeUint32LE = u.prototype.writeUInt32LE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 4, 4294967295, 0), this[ie + 3] = re >>> 24, this[ie + 2] = re >>> 16, this[ie + 1] = re >>> 8, this[ie] = re & 255, ie + 4;
  }, u.prototype.writeUint32BE = u.prototype.writeUInt32BE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 4, 4294967295, 0), this[ie] = re >>> 24, this[ie + 1] = re >>> 16, this[ie + 2] = re >>> 8, this[ie + 3] = re & 255, ie + 4;
  };
  function Y(ne, re, ie, Ie, Ke) {
    it(re, Ie, Ke, ne, ie, 7);
    let Le = Number(re & BigInt(4294967295));
    ne[ie++] = Le, Le = Le >> 8, ne[ie++] = Le, Le = Le >> 8, ne[ie++] = Le, Le = Le >> 8, ne[ie++] = Le;
    let Ge = Number(re >> BigInt(32) & BigInt(4294967295));
    return ne[ie++] = Ge, Ge = Ge >> 8, ne[ie++] = Ge, Ge = Ge >> 8, ne[ie++] = Ge, Ge = Ge >> 8, ne[ie++] = Ge, ie;
  }
  function ge(ne, re, ie, Ie, Ke) {
    it(re, Ie, Ke, ne, ie, 7);
    let Le = Number(re & BigInt(4294967295));
    ne[ie + 7] = Le, Le = Le >> 8, ne[ie + 6] = Le, Le = Le >> 8, ne[ie + 5] = Le, Le = Le >> 8, ne[ie + 4] = Le;
    let Ge = Number(re >> BigInt(32) & BigInt(4294967295));
    return ne[ie + 3] = Ge, Ge = Ge >> 8, ne[ie + 2] = Ge, Ge = Ge >> 8, ne[ie + 1] = Ge, Ge = Ge >> 8, ne[ie] = Ge, ie + 8;
  }
  u.prototype.writeBigUInt64LE = jt(function(re, ie = 0) {
    return Y(this, re, ie, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeBigUInt64BE = jt(function(re, ie = 0) {
    return ge(this, re, ie, BigInt(0), BigInt("0xffffffffffffffff"));
  }), u.prototype.writeIntLE = function(re, ie, Ie, Ke) {
    if (re = +re, ie = ie >>> 0, !Ke) {
      const ot = Math.pow(2, 8 * Ie - 1);
      V(this, re, ie, Ie, ot - 1, -ot);
    }
    let Le = 0, Ge = 1, ft = 0;
    for (this[ie] = re & 255; ++Le < Ie && (Ge *= 256); )
      re < 0 && ft === 0 && this[ie + Le - 1] !== 0 && (ft = 1), this[ie + Le] = (re / Ge >> 0) - ft & 255;
    return ie + Ie;
  }, u.prototype.writeIntBE = function(re, ie, Ie, Ke) {
    if (re = +re, ie = ie >>> 0, !Ke) {
      const ot = Math.pow(2, 8 * Ie - 1);
      V(this, re, ie, Ie, ot - 1, -ot);
    }
    let Le = Ie - 1, Ge = 1, ft = 0;
    for (this[ie + Le] = re & 255; --Le >= 0 && (Ge *= 256); )
      re < 0 && ft === 0 && this[ie + Le + 1] !== 0 && (ft = 1), this[ie + Le] = (re / Ge >> 0) - ft & 255;
    return ie + Ie;
  }, u.prototype.writeInt8 = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 1, 127, -128), re < 0 && (re = 255 + re + 1), this[ie] = re & 255, ie + 1;
  }, u.prototype.writeInt16LE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 2, 32767, -32768), this[ie] = re & 255, this[ie + 1] = re >>> 8, ie + 2;
  }, u.prototype.writeInt16BE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 2, 32767, -32768), this[ie] = re >>> 8, this[ie + 1] = re & 255, ie + 2;
  }, u.prototype.writeInt32LE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 4, 2147483647, -2147483648), this[ie] = re & 255, this[ie + 1] = re >>> 8, this[ie + 2] = re >>> 16, this[ie + 3] = re >>> 24, ie + 4;
  }, u.prototype.writeInt32BE = function(re, ie, Ie) {
    return re = +re, ie = ie >>> 0, Ie || V(this, re, ie, 4, 2147483647, -2147483648), re < 0 && (re = 4294967295 + re + 1), this[ie] = re >>> 24, this[ie + 1] = re >>> 16, this[ie + 2] = re >>> 8, this[ie + 3] = re & 255, ie + 4;
  }, u.prototype.writeBigInt64LE = jt(function(re, ie = 0) {
    return Y(this, re, ie, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), u.prototype.writeBigInt64BE = jt(function(re, ie = 0) {
    return ge(this, re, ie, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ce(ne, re, ie, Ie, Ke, Le) {
    if (ie + Ie > ne.length) throw new RangeError("Index out of range");
    if (ie < 0) throw new RangeError("Index out of range");
  }
  function ee(ne, re, ie, Ie, Ke) {
    return re = +re, ie = ie >>> 0, Ke || ce(ne, re, ie, 4), r.write(ne, re, ie, Ie, 23, 4), ie + 4;
  }
  u.prototype.writeFloatLE = function(re, ie, Ie) {
    return ee(this, re, ie, !0, Ie);
  }, u.prototype.writeFloatBE = function(re, ie, Ie) {
    return ee(this, re, ie, !1, Ie);
  };
  function Se(ne, re, ie, Ie, Ke) {
    return re = +re, ie = ie >>> 0, Ke || ce(ne, re, ie, 8), r.write(ne, re, ie, Ie, 52, 8), ie + 8;
  }
  u.prototype.writeDoubleLE = function(re, ie, Ie) {
    return Se(this, re, ie, !0, Ie);
  }, u.prototype.writeDoubleBE = function(re, ie, Ie) {
    return Se(this, re, ie, !1, Ie);
  }, u.prototype.copy = function(re, ie, Ie, Ke) {
    if (!u.isBuffer(re)) throw new TypeError("argument should be a Buffer");
    if (Ie || (Ie = 0), !Ke && Ke !== 0 && (Ke = this.length), ie >= re.length && (ie = re.length), ie || (ie = 0), Ke > 0 && Ke < Ie && (Ke = Ie), Ke === Ie || re.length === 0 || this.length === 0) return 0;
    if (ie < 0)
      throw new RangeError("targetStart out of bounds");
    if (Ie < 0 || Ie >= this.length) throw new RangeError("Index out of range");
    if (Ke < 0) throw new RangeError("sourceEnd out of bounds");
    Ke > this.length && (Ke = this.length), re.length - ie < Ke - Ie && (Ke = re.length - ie + Ie);
    const Le = Ke - Ie;
    return this === re && typeof i.prototype.copyWithin == "function" ? this.copyWithin(ie, Ie, Ke) : i.prototype.set.call(
      re,
      this.subarray(Ie, Ke),
      ie
    ), Le;
  }, u.prototype.fill = function(re, ie, Ie, Ke) {
    if (typeof re == "string") {
      if (typeof ie == "string" ? (Ke = ie, ie = 0, Ie = this.length) : typeof Ie == "string" && (Ke = Ie, Ie = this.length), Ke !== void 0 && typeof Ke != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Ke == "string" && !u.isEncoding(Ke))
        throw new TypeError("Unknown encoding: " + Ke);
      if (re.length === 1) {
        const Ge = re.charCodeAt(0);
        (Ke === "utf8" && Ge < 128 || Ke === "latin1") && (re = Ge);
      }
    } else typeof re == "number" ? re = re & 255 : typeof re == "boolean" && (re = Number(re));
    if (ie < 0 || this.length < ie || this.length < Ie)
      throw new RangeError("Out of range index");
    if (Ie <= ie)
      return this;
    ie = ie >>> 0, Ie = Ie === void 0 ? this.length : Ie >>> 0, re || (re = 0);
    let Le;
    if (typeof re == "number")
      for (Le = ie; Le < Ie; ++Le)
        this[Le] = re;
    else {
      const Ge = u.isBuffer(re) ? re : u.from(re, Ke), ft = Ge.length;
      if (ft === 0)
        throw new TypeError('The value "' + re + '" is invalid for argument "value"');
      for (Le = 0; Le < Ie - ie; ++Le)
        this[Le + ie] = Ge[Le % ft];
    }
    return this;
  };
  const Ce = {};
  function we(ne, re, ie) {
    Ce[ne] = class extends ie {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: re.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${ne}]`, this.stack, delete this.name;
      }
      get code() {
        return ne;
      }
      set code(Ke) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Ke,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${ne}]: ${this.message}`;
      }
    };
  }
  we(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(ne) {
      return ne ? `${ne} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), we(
    "ERR_INVALID_ARG_TYPE",
    function(ne, re) {
      return `The "${ne}" argument must be of type number. Received type ${typeof re}`;
    },
    TypeError
  ), we(
    "ERR_OUT_OF_RANGE",
    function(ne, re, ie) {
      let Ie = `The value of "${ne}" is out of range.`, Ke = ie;
      return Number.isInteger(ie) && Math.abs(ie) > 2 ** 32 ? Ke = We(String(ie)) : typeof ie == "bigint" && (Ke = String(ie), (ie > BigInt(2) ** BigInt(32) || ie < -(BigInt(2) ** BigInt(32))) && (Ke = We(Ke)), Ke += "n"), Ie += ` It must be ${re}. Received ${Ke}`, Ie;
    },
    RangeError
  );
  function We(ne) {
    let re = "", ie = ne.length;
    const Ie = ne[0] === "-" ? 1 : 0;
    for (; ie >= Ie + 4; ie -= 3)
      re = `_${ne.slice(ie - 3, ie)}${re}`;
    return `${ne.slice(0, ie)}${re}`;
  }
  function Fe(ne, re, ie) {
    gt(re, "offset"), (ne[re] === void 0 || ne[re + ie] === void 0) && Ze(re, ne.length - (ie + 1));
  }
  function it(ne, re, ie, Ie, Ke, Le) {
    if (ne > ie || ne < re) {
      const Ge = typeof re == "bigint" ? "n" : "";
      let ft;
      throw re === 0 || re === BigInt(0) ? ft = `>= 0${Ge} and < 2${Ge} ** ${(Le + 1) * 8}${Ge}` : ft = `>= -(2${Ge} ** ${(Le + 1) * 8 - 1}${Ge}) and < 2 ** ${(Le + 1) * 8 - 1}${Ge}`, new Ce.ERR_OUT_OF_RANGE("value", ft, ne);
    }
    Fe(Ie, Ke, Le);
  }
  function gt(ne, re) {
    if (typeof ne != "number")
      throw new Ce.ERR_INVALID_ARG_TYPE(re, "number", ne);
  }
  function Ze(ne, re, ie) {
    throw Math.floor(ne) !== ne ? (gt(ne, ie), new Ce.ERR_OUT_OF_RANGE("offset", "an integer", ne)) : re < 0 ? new Ce.ERR_BUFFER_OUT_OF_BOUNDS() : new Ce.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${re}`,
      ne
    );
  }
  const Ne = /[^+/0-9A-Za-z-_]/g;
  function ze(ne) {
    if (ne = ne.split("=")[0], ne = ne.trim().replace(Ne, ""), ne.length < 2) return "";
    for (; ne.length % 4 !== 0; )
      ne = ne + "=";
    return ne;
  }
  function ct(ne, re) {
    re = re || 1 / 0;
    let ie;
    const Ie = ne.length;
    let Ke = null;
    const Le = [];
    for (let Ge = 0; Ge < Ie; ++Ge) {
      if (ie = ne.charCodeAt(Ge), ie > 55295 && ie < 57344) {
        if (!Ke) {
          if (ie > 56319) {
            (re -= 3) > -1 && Le.push(239, 191, 189);
            continue;
          } else if (Ge + 1 === Ie) {
            (re -= 3) > -1 && Le.push(239, 191, 189);
            continue;
          }
          Ke = ie;
          continue;
        }
        if (ie < 56320) {
          (re -= 3) > -1 && Le.push(239, 191, 189), Ke = ie;
          continue;
        }
        ie = (Ke - 55296 << 10 | ie - 56320) + 65536;
      } else Ke && (re -= 3) > -1 && Le.push(239, 191, 189);
      if (Ke = null, ie < 128) {
        if ((re -= 1) < 0) break;
        Le.push(ie);
      } else if (ie < 2048) {
        if ((re -= 2) < 0) break;
        Le.push(
          ie >> 6 | 192,
          ie & 63 | 128
        );
      } else if (ie < 65536) {
        if ((re -= 3) < 0) break;
        Le.push(
          ie >> 12 | 224,
          ie >> 6 & 63 | 128,
          ie & 63 | 128
        );
      } else if (ie < 1114112) {
        if ((re -= 4) < 0) break;
        Le.push(
          ie >> 18 | 240,
          ie >> 12 & 63 | 128,
          ie >> 6 & 63 | 128,
          ie & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Le;
  }
  function rt(ne) {
    const re = [];
    for (let ie = 0; ie < ne.length; ++ie)
      re.push(ne.charCodeAt(ie) & 255);
    return re;
  }
  function qe(ne, re) {
    let ie, Ie, Ke;
    const Le = [];
    for (let Ge = 0; Ge < ne.length && !((re -= 2) < 0); ++Ge)
      ie = ne.charCodeAt(Ge), Ie = ie >> 8, Ke = ie % 256, Le.push(Ke), Le.push(Ie);
    return Le;
  }
  function nt(ne) {
    return e.toByteArray(ze(ne));
  }
  function Rt(ne, re, ie, Ie) {
    let Ke;
    for (Ke = 0; Ke < Ie && !(Ke + ie >= re.length || Ke >= ne.length); ++Ke)
      re[Ke + ie] = ne[Ke];
    return Ke;
  }
  function Ot(ne, re) {
    return ne instanceof re || ne != null && ne.constructor != null && ne.constructor.name != null && ne.constructor.name === re.name;
  }
  function lt(ne) {
    return ne !== ne;
  }
  const mt = function() {
    const ne = "0123456789abcdef", re = new Array(256);
    for (let ie = 0; ie < 16; ++ie) {
      const Ie = ie * 16;
      for (let Ke = 0; Ke < 16; ++Ke)
        re[Ie + Ke] = ne[ie] + ne[Ke];
    }
    return re;
  }();
  function jt(ne) {
    return typeof BigInt > "u" ? Jt : ne;
  }
  function Jt() {
    throw new Error("BigInt not supported");
  }
})(uUe);
const nc = uUe.Buffer;
var XO = { exports: {} }, F6e;
function NCt() {
  return F6e || (F6e = 1, function(t, e) {
    (function() {
      var r = 9007199254740992, n = -9007199254740992, a = "0123456789", i = "abcdefghijklmnopqrstuvwxyz", o = i.toUpperCase(), s = a + "abcdef";
      function l(d) {
        this.name = "UnsupportedError", this.message = d || "This feature is not supported on this platform";
      }
      l.prototype = new Error(), l.prototype.constructor = l;
      var c = Array.prototype.slice;
      function u(d) {
        if (!(this instanceof u))
          return d || (d = null), d === null ? new u() : new u(d);
        if (typeof d == "function")
          return this.random = d, this;
        arguments.length && (this.seed = 0);
        for (var m = 0; m < arguments.length; m++) {
          var v = 0;
          if (Object.prototype.toString.call(arguments[m]) === "[object String]")
            for (var k = 0; k < arguments[m].length; k++) {
              for (var O = 0, G = 0; G < arguments[m].length; G++)
                O = arguments[m].charCodeAt(G) + (O << 6) + (O << 16) - O;
              v += O;
            }
          else
            v = arguments[m];
          this.seed += (arguments.length - m) * v;
        }
        return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function() {
          return this.mt.random(this.seed);
        }, this;
      }
      u.prototype.VERSION = "1.1.12";
      function f(d, m) {
        if (d = d || {}, m)
          for (var v in m)
            typeof d[v] > "u" && (d[v] = m[v]);
        return d;
      }
      function h(d) {
        return Array.apply(null, Array(d)).map(function(m, v) {
          return v;
        });
      }
      function p(d, m) {
        if (d)
          throw new RangeError(m);
      }
      var g = function() {
        throw new Error("No Base64 encoder available.");
      };
      (function() {
        typeof btoa == "function" ? g = btoa : typeof nc == "function" && (g = function(m) {
          return new nc(m).toString("base64");
        });
      })(), u.prototype.bool = function(d) {
        return d = f(d, { likelihood: 50 }), p(
          d.likelihood < 0 || d.likelihood > 100,
          "Chance: Likelihood accepts values from 0 to 100."
        ), this.random() * 100 < d.likelihood;
      }, u.prototype.falsy = function(d) {
        d = f(d, { pool: [!1, null, 0, NaN, "", void 0] });
        var m = d.pool, v = this.integer({ min: 0, max: m.length - 1 }), k = m[v];
        return k;
      }, u.prototype.animal = function(d) {
        if (d = f(d), typeof d.type < "u")
          return p(
            !this.get("animals")[d.type.toLowerCase()],
            "Please pick from desert, ocean, grassland, forest, zoo, pets, farm."
          ), this.pick(this.get("animals")[d.type.toLowerCase()]);
        var m = ["desert", "forest", "ocean", "zoo", "farm", "pet", "grassland"];
        return this.pick(this.get("animals")[this.pick(m)]);
      }, u.prototype.character = function(d) {
        d = f(d);
        var m = "!@#$%^&*()[]", v, k;
        return d.casing === "lower" ? v = i : d.casing === "upper" ? v = o : v = i + o, d.pool ? k = d.pool : (k = "", d.alpha && (k += v), d.numeric && (k += a), d.symbols && (k += m), k || (k = v + a + m)), k.charAt(this.natural({ max: k.length - 1 }));
      }, u.prototype.floating = function(d) {
        d = f(d, { fixed: 4 }), p(
          d.fixed && d.precision,
          "Chance: Cannot specify both fixed and precision."
        );
        var m, v = Math.pow(10, d.fixed), k = r / v, O = -k;
        p(
          d.min && d.fixed && d.min < O,
          "Chance: Min specified is out of range with fixed. Min should be, at least, " + O
        ), p(
          d.max && d.fixed && d.max > k,
          "Chance: Max specified is out of range with fixed. Max should be, at most, " + k
        ), d = f(d, { min: O, max: k }), m = this.integer({ min: d.min * v, max: d.max * v });
        var G = (m / v).toFixed(d.fixed);
        return parseFloat(G);
      }, u.prototype.integer = function(d) {
        return d = f(d, { min: n, max: r }), p(d.min > d.max, "Chance: Min cannot be greater than Max."), Math.floor(this.random() * (d.max - d.min + 1) + d.min);
      }, u.prototype.natural = function(d) {
        if (d = f(d, { min: 0, max: r }), typeof d.numerals == "number" && (p(d.numerals < 1, "Chance: Numerals cannot be less than one."), d.min = Math.pow(10, d.numerals - 1), d.max = Math.pow(10, d.numerals) - 1), p(d.min < 0, "Chance: Min cannot be less than zero."), d.exclude) {
          p(!Array.isArray(d.exclude), "Chance: exclude must be an array.");
          for (var m in d.exclude)
            p(!Number.isInteger(d.exclude[m]), "Chance: exclude must be numbers.");
          var v = d.min + this.natural({ max: d.max - d.min - d.exclude.length }), k = d.exclude.sort();
          for (var O in k) {
            if (v < k[O])
              break;
            v++;
          }
          return v;
        }
        return this.integer(d);
      }, u.prototype.prime = function(d) {
        d = f(d, { min: 0, max: 1e4 }), p(d.min < 0, "Chance: Min cannot be less than zero."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = x.primes[x.primes.length - 1];
        if (d.max > m)
          for (var v = m + 2; v <= d.max; ++v)
            this.is_prime(v) && x.primes.push(v);
        var k = x.primes.filter(function(O) {
          return O >= d.min && O <= d.max;
        });
        return this.pick(k);
      }, u.prototype.is_prime = function(d) {
        if (d % 1 || d < 2)
          return !1;
        if (d % 2 === 0)
          return d === 2;
        if (d % 3 === 0)
          return d === 3;
        for (var m = Math.sqrt(d), v = 5; v <= m; v += 6)
          if (d % v === 0 || d % (v + 2) === 0)
            return !1;
        return !0;
      }, u.prototype.hex = function(d) {
        d = f(d, { min: 0, max: r, casing: "lower" }), p(d.min < 0, "Chance: Min cannot be less than zero.");
        var m = this.natural({ min: d.min, max: d.max });
        return d.casing === "upper" ? m.toString(16).toUpperCase() : m.toString(16);
      }, u.prototype.letter = function(d) {
        d = f(d, { casing: "lower" });
        var m = "abcdefghijklmnopqrstuvwxyz", v = this.character({ pool: m });
        return d.casing === "upper" && (v = v.toUpperCase()), v;
      }, u.prototype.string = function(d) {
        d = f(d, { min: 5, max: 20 }), d.length !== 0 && !d.length && (d.length = this.natural({ min: d.min, max: d.max })), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return v.join("");
      };
      function y(d) {
        this.c = d;
      }
      y.prototype = {
        substitute: function() {
          return this.c;
        }
      };
      function b(d) {
        this.c = d;
      }
      b.prototype = {
        substitute: function() {
          if (!/[{}\\]/.test(this.c))
            throw new Error('Invalid escape sequence: "\\' + this.c + '".');
          return this.c;
        }
      };
      function w(d) {
        this.c = d;
      }
      w.prototype = {
        replacers: {
          "#": function(d) {
            return d.character({ pool: a });
          },
          A: function(d) {
            return d.character({ pool: o });
          },
          a: function(d) {
            return d.character({ pool: i });
          }
        },
        substitute: function(d) {
          var m = this.replacers[this.c];
          if (!m)
            throw new Error('Invalid replacement character: "' + this.c + '".');
          return m(d);
        }
      };
      function _(d) {
        for (var m = [], v = "identity", k = 0; k < d.length; k++) {
          var O = d[k];
          switch (v) {
            case "escape":
              m.push(new b(O)), v = "identity";
              break;
            case "identity":
              O === "{" ? v = "replace" : O === "\\" ? v = "escape" : m.push(new y(O));
              break;
            case "replace":
              O === "}" ? v = "identity" : m.push(new w(O));
              break;
          }
        }
        return m;
      }
      u.prototype.template = function(d) {
        if (!d)
          throw new Error("Template string is required");
        var m = this;
        return _(d).map(function(v) {
          return v.substitute(m);
        }).join("");
      }, u.prototype.buffer = function(d) {
        if (typeof nc > "u")
          throw new l("Sorry, the buffer() function is not supported on your platform");
        d = f(d, { length: this.natural({ min: 5, max: 20 }) }), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return nc.from(v);
      }, u.prototype.capitalize = function(d) {
        return d.charAt(0).toUpperCase() + d.substr(1);
      }, u.prototype.mixin = function(d) {
        for (var m in d)
          this[m] = d[m];
        return this;
      }, u.prototype.unique = function(d, m, v) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        );
        var k = function(W, U) {
          return W.indexOf(U) !== -1;
        };
        v && (k = v.comparator || k);
        for (var O = [], G = 0, H, j = m * 50, F = c.call(arguments, 2); O.length < m; ) {
          var z = JSON.parse(JSON.stringify(F));
          if (H = d.apply(this, z), k(O, H) || (O.push(H), G = 0), ++G > j)
            throw new RangeError("Chance: num is likely too large for sample set");
        }
        return O;
      }, u.prototype.n = function(d, m) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        ), typeof m > "u" && (m = 1);
        var v = m, k = [], O = c.call(arguments, 2);
        for (v = Math.max(0, v), null; v--; null)
          k.push(d.apply(this, O));
        return k;
      }, u.prototype.pad = function(d, m, v) {
        return v = v || "0", d = d + "", d.length >= m ? d : new Array(m - d.length + 1).join(v) + d;
      }, u.prototype.pick = function(d, m) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pick() from an empty array");
        return !m || m === 1 ? d[this.natural({ max: d.length - 1 })] : this.shuffle(d).slice(0, m);
      }, u.prototype.pickone = function(d) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickone() from an empty array");
        return d[this.natural({ max: d.length - 1 })];
      }, u.prototype.pickset = function(d, m) {
        if (m === 0)
          return [];
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (m < 0)
          throw new RangeError("Chance: Count must be a positive number");
        if (!m || m === 1)
          return [this.pickone(d)];
        var v = d.slice(0), k = v.length;
        return this.n(function() {
          var O = this.natural({ max: --k }), G = v[O];
          return v[O] = v[k], G;
        }, Math.min(k, m));
      }, u.prototype.shuffle = function(d) {
        for (var m = [], v = 0, k = Number(d.length), O = h(k), G = k - 1, H, j = 0; j < k; j++)
          H = this.natural({ max: G }), v = O[H], m[j] = d[v], O[H] = O[G], G -= 1;
        return m;
      }, u.prototype.weighted = function(d, m, v) {
        if (d.length !== m.length)
          throw new RangeError("Chance: Length of array and weights must match");
        for (var k = 0, O, G = 0; G < m.length; ++G) {
          if (O = m[G], isNaN(O))
            throw new RangeError("Chance: All weights must be numbers");
          O > 0 && (k += O);
        }
        if (k === 0)
          throw new RangeError("Chance: No valid entries in array weights");
        var H = this.random() * k, j = 0, F = -1, z;
        for (G = 0; G < m.length; ++G) {
          if (O = m[G], j += O, O > 0) {
            if (H <= j) {
              z = G;
              break;
            }
            F = G;
          }
          G === m.length - 1 && (z = F);
        }
        var W = d[z];
        return v = typeof v > "u" ? !1 : v, v && (d.splice(z, 1), m.splice(z, 1)), W;
      }, u.prototype.paragraph = function(d) {
        d = f(d);
        var m = d.sentences || this.natural({ min: 3, max: 7 }), v = this.n(this.sentence, m), k = d.linebreak === !0 ? `
` : " ";
        return v.join(k);
      }, u.prototype.sentence = function(d) {
        d = f(d);
        var m = d.words || this.natural({ min: 12, max: 18 }), v = d.punctuation, k, O = this.n(this.word, m);
        return k = O.join(" "), k = this.capitalize(k), v !== !1 && !/^[.?;!:]$/.test(v) && (v = "."), v && (k += v), k;
      }, u.prototype.syllable = function(d) {
        d = f(d);
        for (var m = d.length || this.natural({ min: 2, max: 3 }), v = "bcdfghjklmnprstvwz", k = "aeiou", O = v + k, G = "", H, j = 0; j < m; j++)
          j === 0 ? H = this.character({ pool: O }) : v.indexOf(H) === -1 ? H = this.character({ pool: v }) : H = this.character({ pool: k }), G += H;
        return d.capitalize && (G = this.capitalize(G)), G;
      }, u.prototype.word = function(d) {
        d = f(d), p(
          d.syllables && d.length,
          "Chance: Cannot specify both syllables AND length."
        );
        var m = d.syllables || this.natural({ min: 1, max: 3 }), v = "";
        if (d.length) {
          do
            v += this.syllable();
          while (v.length < d.length);
          v = v.substring(0, d.length);
        } else
          for (var k = 0; k < m; k++)
            v += this.syllable();
        return d.capitalize && (v = this.capitalize(v)), v;
      }, u.prototype.emoji = function(d) {
        d = f(d, { category: "all", length: 1 }), p(
          d.length < 1 || BigInt(d.length) > BigInt(r),
          "Chance: length must be between 1 and " + String(r)
        );
        var m = this.get("emojis");
        d.category === "all" && (d.category = this.pickone(Object.keys(m)));
        var v = m[d.category];
        return p(
          v === void 0,
          "Chance: Unrecognised emoji category: [" + d.category + "]."
        ), this.pickset(v, d.length).map(function(k) {
          return String.fromCodePoint(k);
        }).join("");
      }, u.prototype.age = function(d) {
        d = f(d);
        var m;
        switch (d.type) {
          case "child":
            m = { min: 0, max: 12 };
            break;
          case "teen":
            m = { min: 13, max: 19 };
            break;
          case "adult":
            m = { min: 18, max: 65 };
            break;
          case "senior":
            m = { min: 65, max: 100 };
            break;
          case "all":
            m = { min: 0, max: 100 };
            break;
          default:
            m = { min: 18, max: 65 };
            break;
        }
        return this.natural(m);
      }, u.prototype.birthday = function(d) {
        var m = this.age(d), v = /* @__PURE__ */ new Date(), k = v.getFullYear();
        if (d && d.type) {
          var O = /* @__PURE__ */ new Date(), G = /* @__PURE__ */ new Date();
          O.setFullYear(k - m - 1), G.setFullYear(k - m), d = f(d, {
            min: O,
            max: G
          });
        } else if (d && (d.minAge !== void 0 || d.maxAge !== void 0)) {
          p(d.minAge < 0, "Chance: MinAge cannot be less than zero."), p(d.minAge > d.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
          var H = d.minAge !== void 0 ? d.minAge : 0, j = d.maxAge !== void 0 ? d.maxAge : 100, F = new Date(k - j - 1, v.getMonth(), v.getDate()), z = new Date(k - H, v.getMonth(), v.getDate());
          F.setDate(F.getDate() + 1), z.setDate(z.getDate() + 1), z.setMilliseconds(z.getMilliseconds() - 1), d = f(d, {
            min: F,
            max: z
          });
        } else
          d = f(d, {
            year: k - m
          });
        return this.date(d);
      }, u.prototype.cpf = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 9, { max: 9 }), v = m[8] * 2 + m[7] * 3 + m[6] * 4 + m[5] * 5 + m[4] * 6 + m[3] * 7 + m[2] * 8 + m[1] * 9 + m[0] * 10;
        v = 11 - v % 11, v >= 10 && (v = 0);
        var k = v * 2 + m[8] * 3 + m[7] * 4 + m[6] * 5 + m[5] * 6 + m[4] * 7 + m[3] * 8 + m[2] * 9 + m[1] * 10 + m[0] * 11;
        k = 11 - k % 11, k >= 10 && (k = 0);
        var O = "" + m[0] + m[1] + m[2] + "." + m[3] + m[4] + m[5] + "." + m[6] + m[7] + m[8] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.cnpj = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 12, { max: 12 }), v = m[11] * 2 + m[10] * 3 + m[9] * 4 + m[8] * 5 + m[7] * 6 + m[6] * 7 + m[5] * 8 + m[4] * 9 + m[3] * 2 + m[2] * 3 + m[1] * 4 + m[0] * 5;
        v = 11 - v % 11, v < 2 && (v = 0);
        var k = v * 2 + m[11] * 3 + m[10] * 4 + m[9] * 5 + m[8] * 6 + m[7] * 7 + m[6] * 8 + m[5] * 9 + m[4] * 2 + m[3] * 3 + m[2] * 4 + m[1] * 5 + m[0] * 6;
        k = 11 - k % 11, k < 2 && (k = 0);
        var O = "" + m[0] + m[1] + "." + m[2] + m[3] + m[4] + "." + m[5] + m[6] + m[7] + "/" + m[8] + m[9] + m[10] + m[11] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.first = function(d) {
        return d = f(d, { gender: this.gender(), nationality: "en" }), this.pick(this.get("firstNames")[d.gender.toLowerCase()][d.nationality.toLowerCase()]);
      }, u.prototype.profession = function(d) {
        return d = f(d), d.rank ? this.pick(["Apprentice ", "Junior ", "Senior ", "Lead "]) + this.pick(this.get("profession")) : this.pick(this.get("profession"));
      }, u.prototype.company = function() {
        return this.pick(this.get("company"));
      }, u.prototype.gender = function(d) {
        return d = f(d, { extraGenders: [] }), this.pick(["Male", "Female"].concat(d.extraGenders));
      }, u.prototype.last = function(d) {
        if (d = f(d, { nationality: "*" }), d.nationality === "*") {
          var m = [], v = this.get("lastNames");
          return Object.keys(v).forEach(function(k) {
            m = m.concat(v[k]);
          }), this.pick(m);
        } else
          return this.pick(this.get("lastNames")[d.nationality.toLowerCase()]);
      }, u.prototype.israelId = function() {
        for (var d = this.string({ pool: "0123456789", length: 8 }), m = 0, v = 0; v < d.length; v++) {
          var k = d[v] * (v / 2 === parseInt(v / 2) ? 1 : 2);
          k = this.pad(k, 2).toString(), k = parseInt(k[0]) + parseInt(k[1]), m = m + k;
        }
        return d = d + (10 - parseInt(m.toString().slice(-1))).toString().slice(-1), d;
      }, u.prototype.mrz = function(d) {
        var m = function(O) {
          var G = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(""), H = [7, 3, 1], j = 0;
          return typeof O != "string" && (O = O.toString()), O.split("").forEach(function(F, z) {
            var W = G.indexOf(F);
            W !== -1 ? F = W === 0 ? 0 : W + 9 : F = parseInt(F, 10), F *= H[z % H.length], j += F;
          }), j % 10;
        }, v = function(O) {
          var G = function(j) {
            return new Array(j + 1).join("<");
          }, H = [
            "P<",
            O.issuer,
            O.last.toUpperCase(),
            "<<",
            O.first.toUpperCase(),
            G(39 - (O.last.length + O.first.length + 2)),
            O.passportNumber,
            m(O.passportNumber),
            O.nationality,
            O.dob,
            m(O.dob),
            O.gender,
            O.expiry,
            m(O.expiry),
            G(14),
            m(G(14))
          ].join("");
          return H + m(H.substr(44, 10) + H.substr(57, 7) + H.substr(65, 7));
        }, k = this;
        return d = f(d, {
          first: this.first(),
          last: this.last(),
          passportNumber: this.integer({ min: 1e8, max: 999999999 }),
          dob: function() {
            var O = k.birthday({ type: "adult" });
            return [
              O.getFullYear().toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          expiry: function() {
            var O = /* @__PURE__ */ new Date();
            return [
              (O.getFullYear() + 5).toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          gender: this.gender() === "Female" ? "F" : "M",
          issuer: "GBR",
          nationality: "GBR"
        }), v(d);
      }, u.prototype.name = function(d) {
        d = f(d);
        var m = this.first(d), v = this.last(d), k;
        return d.middle ? k = m + " " + this.first(d) + " " + v : d.middle_initial ? k = m + " " + this.character({ alpha: !0, casing: "upper" }) + ". " + v : k = m + " " + v, d.prefix && (k = this.prefix(d) + " " + k), d.suffix && (k = k + " " + this.suffix(d)), k;
      }, u.prototype.name_prefixes = function(d) {
        d = d || "all", d = d.toLowerCase();
        var m = [
          { name: "Doctor", abbreviation: "Dr." }
        ];
        return (d === "male" || d === "all") && m.push({ name: "Mister", abbreviation: "Mr." }), (d === "female" || d === "all") && (m.push({ name: "Miss", abbreviation: "Miss" }), m.push({ name: "Misses", abbreviation: "Mrs." })), m;
      }, u.prototype.prefix = function(d) {
        return this.name_prefix(d);
      }, u.prototype.name_prefix = function(d) {
        return d = f(d, { gender: "all" }), d.full ? this.pick(this.name_prefixes(d.gender)).name : this.pick(this.name_prefixes(d.gender)).abbreviation;
      }, u.prototype.HIDN = function() {
        var d = "0123456789", m = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ", v = "";
        return v += this.string({ pool: d, length: 6 }), v += this.string({ pool: m, length: 2 }), v;
      }, u.prototype.ssn = function(d) {
        d = f(d, { ssnFour: !1, dashes: !0 });
        var m = "1234567890", v, k = d.dashes ? "-" : "";
        return d.ssnFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 3 }) + k + this.string({ pool: m, length: 2 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.aadhar = function(d) {
        d = f(d, { onlyLastFour: !1, separatedByWhiteSpace: !0 });
        var m = "1234567890", v, k = d.separatedByWhiteSpace ? " " : "";
        return d.onlyLastFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.name_suffixes = function() {
        var d = [
          { name: "Doctor of Osteopathic Medicine", abbreviation: "D.O." },
          { name: "Doctor of Philosophy", abbreviation: "Ph.D." },
          { name: "Esquire", abbreviation: "Esq." },
          { name: "Junior", abbreviation: "Jr." },
          { name: "Juris Doctor", abbreviation: "J.D." },
          { name: "Master of Arts", abbreviation: "M.A." },
          { name: "Master of Business Administration", abbreviation: "M.B.A." },
          { name: "Master of Science", abbreviation: "M.S." },
          { name: "Medical Doctor", abbreviation: "M.D." },
          { name: "Senior", abbreviation: "Sr." },
          { name: "The Third", abbreviation: "III" },
          { name: "The Fourth", abbreviation: "IV" },
          { name: "Bachelor of Engineering", abbreviation: "B.E" },
          { name: "Bachelor of Technology", abbreviation: "B.TECH" }
        ];
        return d;
      }, u.prototype.suffix = function(d) {
        return this.name_suffix(d);
      }, u.prototype.name_suffix = function(d) {
        return d = f(d), d.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
      }, u.prototype.nationalities = function() {
        return this.get("nationalities");
      }, u.prototype.nationality = function() {
        var d = this.pick(this.nationalities());
        return d.name;
      }, u.prototype.zodiac = function() {
        const d = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];
        return this.pickone(d);
      }, u.prototype.android_id = function() {
        return "APA91" + this.string({ pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_", length: 178 });
      }, u.prototype.apple_token = function() {
        return this.string({ pool: "abcdef1234567890", length: 64 });
      }, u.prototype.wp8_anid2 = function() {
        return g(this.hash({ length: 32 }));
      }, u.prototype.wp7_anid = function() {
        return "A=" + this.guid().replace(/-/g, "").toUpperCase() + "&E=" + this.hash({ length: 3 }) + "&W=" + this.integer({ min: 0, max: 9 });
      }, u.prototype.bb_pin = function() {
        return this.hash({ length: 8 });
      }, u.prototype.avatar = function(d) {
        var m = null, v = "//www.gravatar.com/avatar/", k = {
          http: "http",
          https: "https"
        }, O = {
          bmp: "bmp",
          gif: "gif",
          jpg: "jpg",
          png: "png"
        }, G = {
          404: "404",
          // Return 404 if not found
          mm: "mm",
          // Mystery man
          identicon: "identicon",
          // Geometric pattern based on hash
          monsterid: "monsterid",
          // A generated monster icon
          wavatar: "wavatar",
          // A generated face
          retro: "retro",
          // 8-bit icon
          blank: "blank"
          // A transparent png
        }, H = {
          g: "g",
          pg: "pg",
          r: "r",
          x: "x"
        }, j = {
          protocol: null,
          email: null,
          fileExtension: null,
          size: null,
          fallback: null,
          rating: null
        };
        if (!d)
          j.email = this.email(), d = {};
        else if (typeof d == "string")
          j.email = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        return j = f(d, j), j.email || (j.email = this.email()), j.protocol = k[j.protocol] ? j.protocol + ":" : "", j.size = parseInt(j.size, 0) ? j.size : "", j.rating = H[j.rating] ? j.rating : "", j.fallback = G[j.fallback] ? j.fallback : "", j.fileExtension = O[j.fileExtension] ? j.fileExtension : "", m = j.protocol + v + this.bimd5.md5(j.email) + (j.fileExtension ? "." + j.fileExtension : "") + (j.size || j.rating || j.fallback ? "?" : "") + (j.size ? "&s=" + j.size.toString() : "") + (j.rating ? "&r=" + j.rating : "") + (j.fallback ? "&d=" + j.fallback : ""), m;
      }, u.prototype.color = function(d) {
        function m(ce, ee) {
          return [ce, ce, ce].join(ee || "");
        }
        function v(ce) {
          var ee = ce ? "rgba" : "rgb", Se = ce ? "," + this.floating({ min: V, max: Y }) : "", Ce = O ? m(this.natural({ min: G, max: H }), ",") : this.natural({ min: z, max: W }) + "," + this.natural({ min: U, max: Z }) + "," + this.natural({ max: 255 });
          return ee + "(" + Ce + Se + ")";
        }
        function k(ce, ee, Se) {
          var Ce = Se ? "#" : "", we = "";
          return O ? (we = m(this.pad(this.hex({ min: G, max: H }), 2)), d.format === "shorthex" && (we = m(this.hex({ min: 0, max: 15 })))) : d.format === "shorthex" ? we = this.pad(this.hex({ min: Math.floor(j / 16), max: Math.floor(F / 16) }), 1) + this.pad(this.hex({ min: Math.floor(z / 16), max: Math.floor(W / 16) }), 1) + this.pad(this.hex({ min: Math.floor(U / 16), max: Math.floor(Z / 16) }), 1) : j !== void 0 || F !== void 0 || z !== void 0 || W !== void 0 || U !== void 0 || Z !== void 0 ? we = this.pad(this.hex({ min: j, max: F }), 2) + this.pad(this.hex({ min: z, max: W }), 2) + this.pad(this.hex({ min: U, max: Z }), 2) : we = this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2), Ce + we;
        }
        d = f(d, {
          format: this.pick(["hex", "shorthex", "rgb", "rgba", "0x", "name"]),
          grayscale: !1,
          casing: "lower",
          min: 0,
          max: 255,
          min_red: void 0,
          max_red: void 0,
          min_green: void 0,
          max_green: void 0,
          min_blue: void 0,
          max_blue: void 0,
          min_alpha: 0,
          max_alpha: 1
        });
        var O = d.grayscale, G = d.min, H = d.max, j = d.min_red, F = d.max_red, z = d.min_green, W = d.max_green, U = d.min_blue, Z = d.max_blue, V = d.min_alpha, Y = d.max_alpha;
        d.min_red === void 0 && (j = G), d.max_red === void 0 && (F = H), d.min_green === void 0 && (z = G), d.max_green === void 0 && (W = H), d.min_blue === void 0 && (U = G), d.max_blue === void 0 && (Z = H), d.min_alpha === void 0 && (V = 0), d.max_alpha === void 0 && (Y = 1), O && G === 0 && H === 255 && j !== void 0 && F !== void 0 && (G = (j + z + U) / 3, H = (F + W + Z) / 3);
        var ge;
        if (d.format === "hex")
          ge = k.call(this, 2, 6, !0);
        else if (d.format === "shorthex")
          ge = k.call(this, 1, 3, !0);
        else if (d.format === "rgb")
          ge = v.call(this, !1);
        else if (d.format === "rgba")
          ge = v.call(this, !0);
        else if (d.format === "0x")
          ge = "0x" + k.call(this, 2, 6);
        else {
          if (d.format === "name")
            return this.pick(this.get("colorNames"));
          throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        }
        return d.casing === "upper" && (ge = ge.toUpperCase()), ge;
      }, u.prototype.domain = function(d) {
        return d = f(d), this.word() + "." + (d.tld || this.tld());
      }, u.prototype.email = function(d) {
        return d = f(d), this.word({ length: d.length }) + "@" + (d.domain || this.domain());
      }, u.prototype.fbid = function() {
        return "10000" + this.string({ pool: "1234567890", length: 11 });
      }, u.prototype.google_analytics = function() {
        var d = this.pad(this.natural({ max: 999999 }), 6), m = this.pad(this.natural({ max: 99 }), 2);
        return "UA-" + d + "-" + m;
      }, u.prototype.hashtag = function() {
        return "#" + this.word();
      }, u.prototype.ip = function() {
        return this.natural({ min: 1, max: 254 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ min: 1, max: 254 });
      }, u.prototype.ipv6 = function() {
        var d = this.n(this.hash, 8, { length: 4 });
        return d.join(":");
      }, u.prototype.klout = function() {
        return this.natural({ min: 1, max: 99 });
      }, u.prototype.mac = function(d) {
        return d = f(d, { delimiter: ":" }), this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2);
      }, u.prototype.semver = function(d) {
        d = f(d, { include_prerelease: !0 });
        var m = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
        d.range && (m = d.range);
        var v = "";
        return d.include_prerelease && (v = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1])), m + this.rpg("3d10").join(".") + v;
      }, u.prototype.tlds = function() {
        return ["com", "org", "edu", "gov", "co.uk", "net", "io", "ac", "ad", "ae", "af", "ag", "ai", "al", "am", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bm", "bn", "bo", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "eu", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "su", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "uk", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"];
      }, u.prototype.tld = function() {
        return this.pick(this.tlds());
      }, u.prototype.twitter = function() {
        return "@" + this.word();
      }, u.prototype.url = function(d) {
        d = f(d, { protocol: "http", domain: this.domain(d), domain_prefix: "", path: this.word(), extensions: [] });
        var m = d.extensions.length > 0 ? "." + this.pick(d.extensions) : "", v = d.domain_prefix ? d.domain_prefix + "." + d.domain : d.domain;
        return d.protocol + "://" + v + "/" + d.path + m;
      }, u.prototype.port = function() {
        return this.integer({ min: 0, max: 65535 });
      }, u.prototype.locale = function(d) {
        return d = f(d), d.region ? this.pick(this.get("locale_regions")) : this.pick(this.get("locale_languages"));
      }, u.prototype.locales = function(d) {
        return d = f(d), d.region ? this.get("locale_regions") : this.get("locale_languages");
      }, u.prototype.loremPicsum = function(d) {
        d = f(d, { width: 500, height: 500, greyscale: !1, blurred: !1 });
        var m = d.greyscale ? "g/" : "", v = d.blurred ? "/?blur" : "/?random";
        return "https://picsum.photos/" + m + d.width + "/" + d.height + v;
      }, u.prototype.address = function(d) {
        return d = f(d), this.natural({ min: 5, max: 2e3 }) + " " + this.street(d);
      }, u.prototype.altitude = function(d) {
        return d = f(d, { fixed: 5, min: 0, max: 8848 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.areacode = function(d) {
        d = f(d, { parens: !0 });
        var m = d.exampleNumber ? "555" : this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 8 }).toString() + this.natural({ min: 0, max: 9 }).toString();
        return d.parens ? "(" + m + ")" : m;
      }, u.prototype.city = function() {
        return this.capitalize(this.word({ syllables: 3 }));
      }, u.prototype.coordinates = function(d) {
        return this.latitude(d) + ", " + this.longitude(d);
      }, u.prototype.countries = function() {
        return this.get("countries");
      }, u.prototype.country = function(d) {
        d = f(d);
        var m = this.pick(this.countries());
        return d.raw ? m : d.full ? m.name : m.abbreviation;
      }, u.prototype.depth = function(d) {
        return d = f(d, { fixed: 5, min: -10994, max: 0 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.geohash = function(d) {
        return d = f(d, { length: 7 }), this.string({ length: d.length, pool: "0123456789bcdefghjkmnpqrstuvwxyz" });
      }, u.prototype.geojson = function(d) {
        return this.latitude(d) + ", " + this.longitude(d) + ", " + this.altitude(d);
      }, u.prototype.latitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 89, fixed: 4 } : { fixed: 5, min: -90, max: 90, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89"), p(d.max < 0 || d.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.longitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 179, fixed: 4 } : { fixed: 5, min: -180, max: 180, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179"), p(d.max < 0 || d.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.phone = function(d) {
        var m = this, v, k = function(U) {
          var Z = [];
          return U.sections.forEach(function(V) {
            Z.push(m.string({ pool: "0123456789", length: V }));
          }), U.area + Z.join(" ");
        };
        d = f(d, {
          formatted: !0,
          country: "us",
          mobile: !1,
          exampleNumber: !1
        }), d.formatted || (d.parens = !1);
        var O;
        switch (d.country) {
          case "fr":
            d.mobile ? (v = this.pick(["06", "07"]) + m.string({ pool: "0123456789", length: 8 }), O = d.formatted ? v.match(/../g).join(" ") : v) : (v = this.pick([
              // Valid zone and département codes.
              "01" + this.pick(["30", "34", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "53", "55", "56", "58", "60", "64", "69", "70", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83"]) + m.string({ pool: "0123456789", length: 6 }),
              "02" + this.pick(["14", "18", "22", "23", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "40", "41", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "56", "57", "61", "62", "69", "72", "76", "77", "78", "85", "90", "96", "97", "98", "99"]) + m.string({ pool: "0123456789", length: 6 }),
              "03" + this.pick(["10", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "39", "44", "45", "51", "52", "54", "55", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90"]) + m.string({ pool: "0123456789", length: 6 }),
              "04" + this.pick(["11", "13", "15", "20", "22", "26", "27", "30", "32", "34", "37", "42", "43", "44", "50", "56", "57", "63", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "88", "89", "90", "91", "92", "93", "94", "95", "97", "98"]) + m.string({ pool: "0123456789", length: 6 }),
              "05" + this.pick(["08", "16", "17", "19", "24", "31", "32", "33", "34", "35", "40", "45", "46", "47", "49", "53", "55", "56", "57", "58", "59", "61", "62", "63", "64", "65", "67", "79", "81", "82", "86", "87", "90", "94"]) + m.string({ pool: "0123456789", length: 6 }),
              "09" + m.string({ pool: "0123456789", length: 8 })
            ]), O = d.formatted ? v.match(/../g).join(" ") : v);
            break;
          case "uk":
            d.mobile ? (v = this.pick([
              { area: "07" + this.pick(["4", "5", "7", "8", "9"]), sections: [2, 6] },
              { area: "07624 ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "")) : (v = this.pick([
              //valid area codes of major cities/counties followed by random numbers in required format.
              { area: "01" + this.character({ pool: "234569" }) + "1 ", sections: [3, 4] },
              { area: "020 " + this.character({ pool: "378" }), sections: [3, 4] },
              { area: "023 " + this.character({ pool: "89" }), sections: [3, 4] },
              { area: "024 7", sections: [3, 4] },
              { area: "028 " + this.pick(["25", "28", "37", "71", "82", "90", "92", "95"]), sections: [2, 4] },
              { area: "012" + this.pick(["04", "08", "54", "76", "97", "98"]) + " ", sections: [6] },
              { area: "013" + this.pick(["63", "64", "84", "86"]) + " ", sections: [6] },
              { area: "014" + this.pick(["04", "20", "60", "61", "80", "88"]) + " ", sections: [6] },
              { area: "015" + this.pick(["24", "27", "62", "66"]) + " ", sections: [6] },
              { area: "016" + this.pick(["06", "29", "35", "47", "59", "95"]) + " ", sections: [6] },
              { area: "017" + this.pick(["26", "44", "50", "68"]) + " ", sections: [6] },
              { area: "018" + this.pick(["27", "37", "84", "97"]) + " ", sections: [6] },
              { area: "019" + this.pick(["00", "05", "35", "46", "49", "63", "95"]) + " ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "", "g"));
            break;
          case "za":
            d.mobile ? (v = this.pick([
              "060" + this.pick(["3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "061" + this.pick(["0", "1", "2", "3", "4", "5", "8"]) + m.string({ pool: "0123456789", length: 6 }),
              "06" + m.string({ pool: "0123456789", length: 7 }),
              "071" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "07" + this.pick(["2", "3", "4", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "08" + this.pick(["0", "1", "2", "3", "4", "5"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v) : (v = this.pick([
              "01" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "02" + this.pick(["1", "2", "3", "4", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "03" + this.pick(["1", "2", "3", "5", "6", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "04" + this.pick(["1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "05" + this.pick(["1", "3", "4", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v);
            break;
          case "us":
            var G = this.areacode(d).toString(), H = this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString(), j = this.natural({ min: 1e3, max: 9999 }).toString();
            O = d.formatted ? G + " " + H + "-" + j : G + H + j;
            break;
          case "br":
            var F = this.pick(["11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", "94", "95", "96", "97", "98", "99"]), z;
            d.mobile ? z = "9" + m.string({ pool: "0123456789", length: 4 }) : z = this.natural({ min: 2e3, max: 5999 }).toString();
            var W = m.string({ pool: "0123456789", length: 4 });
            O = d.formatted ? "(" + F + ") " + z + "-" + W : F + z + W;
            break;
        }
        return O;
      }, u.prototype.postal = function() {
        var d = this.character({ pool: "XVTSRPNKLMHJGECBA" }), m = d + this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }), v = this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }) + this.natural({ max: 9 });
        return m + " " + v;
      }, u.prototype.postcode = function() {
        var d = this.pick(this.get("postcodeAreas")).code, m = this.natural({ max: 9 }), v = this.bool() ? this.character({ alpha: !0, casing: "upper" }) : "", k = d + m + v, O = this.natural({ max: 9 }), G = this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }), H = O + G;
        return k + " " + H;
      }, u.prototype.counties = function(d) {
        return d = f(d, { country: "uk" }), this.get("counties")[d.country.toLowerCase()];
      }, u.prototype.county = function(d) {
        return this.pick(this.counties(d)).name;
      }, u.prototype.provinces = function(d) {
        return d = f(d, { country: "ca" }), this.get("provinces")[d.country.toLowerCase()];
      }, u.prototype.province = function(d) {
        return d && d.full ? this.pick(this.provinces(d)).name : this.pick(this.provinces(d)).abbreviation;
      }, u.prototype.state = function(d) {
        return d && d.full ? this.pick(this.states(d)).name : this.pick(this.states(d)).abbreviation;
      }, u.prototype.states = function(d) {
        d = f(d, { country: "us", us_states_and_dc: !0 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            var v = this.get("us_states_and_dc"), k = this.get("territories"), O = this.get("armed_forces");
            m = [], d.us_states_and_dc && (m = m.concat(v)), d.territories && (m = m.concat(k)), d.armed_forces && (m = m.concat(O));
            break;
          case "it":
          case "mx":
            m = this.get("country_regions")[d.country.toLowerCase()];
            break;
          case "uk":
            m = this.get("counties")[d.country.toLowerCase()];
            break;
        }
        return m;
      }, u.prototype.street = function(d) {
        d = f(d, { country: "us", syllables: 2 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m += " ", m += d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name;
            break;
          case "it":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m = (d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name) + " " + m;
            break;
        }
        return m;
      }, u.prototype.street_suffix = function(d) {
        return d = f(d, { country: "us" }), this.pick(this.street_suffixes(d));
      }, u.prototype.street_suffixes = function(d) {
        return d = f(d, { country: "us" }), this.get("street_suffixes")[d.country.toLowerCase()];
      }, u.prototype.zip = function(d) {
        var m = this.n(this.natural, 5, { max: 9 });
        return d && d.plusfour === !0 && (m.push("-"), m = m.concat(this.n(this.natural, 4, { max: 9 }))), m.join("");
      }, u.prototype.ampm = function() {
        return this.bool() ? "am" : "pm";
      }, u.prototype.date = function(d) {
        var m, v;
        if (d && (d.min || d.max)) {
          d = f(d, {
            american: !0,
            string: !1
          });
          var k = typeof d.min < "u" ? d.min.getTime() : 1, O = typeof d.max < "u" ? d.max.getTime() : 864e13;
          v = new Date(this.integer({ min: k, max: O }));
        } else {
          var G = this.month({ raw: !0 }), H = G.days;
          d && d.month && (H = this.get("months")[(d.month % 12 + 12) % 12].days), d = f(d, {
            year: parseInt(this.year(), 10),
            // Necessary to subtract 1 because Date() 0-indexes month but not day or year
            // for some reason.
            month: G.numeric - 1,
            day: this.natural({ min: 1, max: H }),
            hour: this.hour({ twentyfour: !0 }),
            minute: this.minute(),
            second: this.second(),
            millisecond: this.millisecond(),
            american: !0,
            string: !1
          }), v = new Date(d.year, d.month, d.day, d.hour, d.minute, d.second, d.millisecond);
        }
        return d.american ? m = v.getMonth() + 1 + "/" + v.getDate() + "/" + v.getFullYear() : m = v.getDate() + "/" + (v.getMonth() + 1) + "/" + v.getFullYear(), d.string ? m : v;
      }, u.prototype.hammertime = function(d) {
        return this.date(d).getTime();
      }, u.prototype.hour = function(d) {
        return d = f(d, {
          min: d && d.twentyfour ? 0 : 1,
          max: d && d.twentyfour ? 23 : 12
        }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.twentyfour && d.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option."), p(!d.twentyfour && d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.millisecond = function() {
        return this.natural({ max: 999 });
      }, u.prototype.minute = u.prototype.second = function(d) {
        return d = f(d, { min: 0, max: 59 }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.max > 59, "Chance: Max cannot be greater than 59."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.month = function(d) {
        d = f(d, { min: 1, max: 12 }), p(d.min < 1, "Chance: Min cannot be less than 1."), p(d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = this.pick(this.months().slice(d.min - 1, d.max));
        return d.raw ? m : m.name;
      }, u.prototype.months = function() {
        return this.get("months");
      }, u.prototype.second = function() {
        return this.natural({ max: 59 });
      }, u.prototype.timestamp = function() {
        return this.natural({ min: 1, max: parseInt((/* @__PURE__ */ new Date()).getTime() / 1e3, 10) });
      }, u.prototype.weekday = function(d) {
        d = f(d, { weekday_only: !1 });
        var m = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        return d.weekday_only || (m.push("Saturday"), m.push("Sunday")), this.pickone(m);
      }, u.prototype.year = function(d) {
        return d = f(d, { min: (/* @__PURE__ */ new Date()).getFullYear() }), d.max = typeof d.max < "u" ? d.max : d.min + 100, this.natural(d).toString();
      }, u.prototype.cc = function(d) {
        d = f(d);
        var m, v, k;
        return m = d.type ? this.cc_type({ name: d.type, raw: !0 }) : this.cc_type({ raw: !0 }), v = m.prefix.split(""), k = m.length - m.prefix.length - 1, v = v.concat(this.n(this.integer, k, { min: 0, max: 9 })), v.push(this.luhn_calculate(v.join(""))), v.join("");
      }, u.prototype.cc_types = function() {
        return this.get("cc_types");
      }, u.prototype.cc_type = function(d) {
        d = f(d);
        var m = this.cc_types(), v = null;
        if (d.name) {
          for (var k = 0; k < m.length; k++)
            if (m[k].name === d.name || m[k].short_name === d.name) {
              v = m[k];
              break;
            }
          if (v === null)
            throw new RangeError("Chance: Credit card type '" + d.name + "' is not supported");
        } else
          v = this.pick(m);
        return d.raw ? v : v.name;
      }, u.prototype.currency_types = function() {
        return this.get("currency_types");
      }, u.prototype.currency = function() {
        return this.pick(this.currency_types());
      }, u.prototype.timezones = function() {
        return this.get("timezones");
      }, u.prototype.timezone = function() {
        return this.pick(this.timezones());
      }, u.prototype.currency_pair = function(d) {
        var m = this.unique(this.currency, 2, {
          comparator: function(v, k) {
            return v.reduce(function(O, G) {
              return O || G.code === k.code;
            }, !1);
          }
        });
        return d ? m[0].code + "/" + m[1].code : m;
      }, u.prototype.dollar = function(d) {
        d = f(d, { max: 1e4, min: 0 });
        var m = this.floating({ min: d.min, max: d.max, fixed: 2 }).toString(), v = m.split(".")[1];
        return v === void 0 ? m += ".00" : v.length < 2 && (m = m + "0"), m < 0 ? "-$" + m.replace("-", "") : "$" + m;
      }, u.prototype.euro = function(d) {
        return Number(this.dollar(d).replace("$", "")).toLocaleString() + "€";
      }, u.prototype.exp = function(d) {
        d = f(d);
        var m = {};
        return m.year = this.exp_year(), m.year === (/* @__PURE__ */ new Date()).getFullYear().toString() ? m.month = this.exp_month({ future: !0 }) : m.month = this.exp_month(), d.raw ? m : m.month + "/" + m.year;
      }, u.prototype.exp_month = function(d) {
        d = f(d);
        var m, v, k = (/* @__PURE__ */ new Date()).getMonth() + 1;
        if (d.future && k !== 12)
          do
            m = this.month({ raw: !0 }).numeric, v = parseInt(m, 10);
          while (v <= k);
        else
          m = this.month({ raw: !0 }).numeric;
        return m;
      }, u.prototype.exp_year = function() {
        var d = (/* @__PURE__ */ new Date()).getMonth() + 1, m = (/* @__PURE__ */ new Date()).getFullYear();
        return this.year({ min: d === 12 ? m + 1 : m, max: m + 10 });
      }, u.prototype.vat = function(d) {
        switch (d = f(d, { country: "it" }), d.country.toLowerCase()) {
          case "it":
            return this.it_vat();
        }
      }, u.prototype.iban = function() {
        var d = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", m = d + "0123456789", v = this.string({ length: 2, pool: d }) + this.pad(this.integer({ min: 0, max: 99 }), 2) + this.string({ length: 4, pool: m }) + this.pad(this.natural(), this.natural({ min: 6, max: 26 }));
        return v;
      }, u.prototype.it_vat = function() {
        var d = this.natural({ min: 1, max: 18e5 });
        return d = this.pad(d, 7) + this.pad(this.pick(this.provinces({ country: "it" })).code, 3), d + this.luhn_calculate(d);
      }, u.prototype.cf = function(d) {
        d = d || {};
        var m = d.gender ? d.gender : this.gender(), v = d.first ? d.first : this.first({ gender: m, nationality: "it" }), k = d.last ? d.last : this.last({ nationality: "it" }), O = d.birthday ? d.birthday : this.birthday(), G = d.city ? d.city : this.pickone(["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M", "Z"]) + this.pad(this.natural({ max: 999 }), 3), H = [], j = function(W, U) {
          var Z, V = [];
          return W.length < 3 ? V = W.split("").concat("XXX".split("")).splice(0, 3) : (Z = W.toUpperCase().split("").map(function(Y) {
            return "BCDFGHJKLMNPRSTVWZ".indexOf(Y) !== -1 ? Y : void 0;
          }).join(""), Z.length > 3 && (U ? Z = Z.substr(0, 3) : Z = Z[0] + Z.substr(2, 2)), Z.length < 3 && (V = Z, Z = W.toUpperCase().split("").map(function(Y) {
            return "AEIOU".indexOf(Y) !== -1 ? Y : void 0;
          }).join("").substr(0, 3 - V.length)), V = V + Z), V;
        }, F = function(W, U, Z) {
          var V = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];
          return W.getFullYear().toString().substr(2) + V[W.getMonth()] + Z.pad(W.getDate() + (U.toLowerCase() === "female" ? 40 : 0), 2);
        }, z = function(W) {
          for (var U = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", Z = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", V = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", Y = "BAKPLCQDREVOSFTGUHMINJWZYX", ge = 0, ce = 0; ce < 15; ce++)
            ce % 2 !== 0 ? ge += V.indexOf(Z[U.indexOf(W[ce])]) : ge += Y.indexOf(Z[U.indexOf(W[ce])]);
          return V[ge % 26];
        };
        return H = H.concat(j(k, !0), j(v), F(O, m, this), G.toUpperCase().split("")).join(""), H += z(H.toUpperCase()), H.toUpperCase();
      }, u.prototype.pl_pesel = function() {
        for (var d = this.natural({ min: 1, max: 9999999999 }), m = this.pad(d, 10).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (1 * m[0] + 3 * m[1] + 7 * m[2] + 9 * m[3] + 1 * m[4] + 3 * m[5] + 7 * m[6] + 9 * m[7] + 1 * m[8] + 3 * m[9]) % 10;
        return k !== 0 && (k = 10 - k), m.join("") + k;
      }, u.prototype.pl_nip = function() {
        for (var d = this.natural({ min: 1, max: 999999999 }), m = this.pad(d, 9).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (6 * m[0] + 5 * m[1] + 7 * m[2] + 2 * m[3] + 3 * m[4] + 4 * m[5] + 5 * m[6] + 6 * m[7] + 7 * m[8]) % 11;
        return k === 10 ? this.pl_nip() : m.join("") + k;
      }, u.prototype.pl_regon = function() {
        for (var d = this.natural({ min: 1, max: 99999999 }), m = this.pad(d, 8).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (8 * m[0] + 9 * m[1] + 2 * m[2] + 3 * m[3] + 4 * m[4] + 5 * m[5] + 6 * m[6] + 7 * m[7]) % 11;
        return k === 10 && (k = 0), m.join("") + k;
      }, u.prototype.music_genre = function(d = "general") {
        if (!(d.toLowerCase() in x.music_genres))
          throw new Error(`Unsupported genre: ${d}`);
        const m = x.music_genres[d.toLowerCase()], v = this.integer({ min: 0, max: m.length - 1 });
        return m[v];
      }, u.prototype.note = function(d) {
        d = f(d, { notes: "flatKey" });
        var m = {
          naturals: ["C", "D", "E", "F", "G", "A", "B"],
          flats: ["D♭", "E♭", "G♭", "A♭", "B♭"],
          sharps: ["C♯", "D♯", "F♯", "G♯", "A♯"]
        };
        return m.all = m.naturals.concat(m.flats.concat(m.sharps)), m.flatKey = m.naturals.concat(m.flats), m.sharpKey = m.naturals.concat(m.sharps), this.pickone(m[d.notes]);
      }, u.prototype.midi_note = function(d) {
        var m = 0, v = 127;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.chord_quality = function(d) {
        d = f(d, { jazz: !0 });
        var m = ["maj", "min", "aug", "dim"];
        return d.jazz && (m = [
          "maj7",
          "min7",
          "7",
          "sus",
          "dim",
          "ø"
        ]), this.pickone(m);
      }, u.prototype.chord = function(d) {
        return d = f(d), this.note(d) + this.chord_quality(d);
      }, u.prototype.tempo = function(d) {
        var m = 40, v = 320;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
      };
      function C(d) {
        return function() {
          return this.natural(d);
        };
      }
      u.prototype.d4 = C({ min: 1, max: 4 }), u.prototype.d6 = C({ min: 1, max: 6 }), u.prototype.d8 = C({ min: 1, max: 8 }), u.prototype.d10 = C({ min: 1, max: 10 }), u.prototype.d12 = C({ min: 1, max: 12 }), u.prototype.d20 = C({ min: 1, max: 20 }), u.prototype.d30 = C({ min: 1, max: 30 }), u.prototype.d100 = C({ min: 1, max: 100 }), u.prototype.rpg = function(d, m) {
        if (m = f(m), d) {
          var v = d.toLowerCase().split("d"), k = [];
          if (v.length !== 2 || !parseInt(v[0], 10) || !parseInt(v[1], 10))
            throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
          for (var O = v[0]; O > 0; O--)
            k[O - 1] = this.natural({ min: 1, max: v[1] });
          return typeof m.sum < "u" && m.sum ? k.reduce(function(G, H) {
            return G + H;
          }) : k;
        } else
          throw new RangeError("Chance: A type of die roll must be included");
      }, u.prototype.guid = function(d) {
        d = f(d, { version: 5 });
        var m = "abcdef1234567890", v = "ab89", k = this.string({ pool: m, length: 8 }) + "-" + this.string({ pool: m, length: 4 }) + "-" + // The Version
        d.version + this.string({ pool: m, length: 3 }) + "-" + // The Variant
        this.string({ pool: v, length: 1 }) + this.string({ pool: m, length: 3 }) + "-" + this.string({ pool: m, length: 12 });
        return k;
      }, u.prototype.hash = function(d) {
        d = f(d, { length: 40, casing: "lower" });
        var m = d.casing === "upper" ? s.toUpperCase() : s;
        return this.string({ pool: m, length: d.length });
      }, u.prototype.luhn_check = function(d) {
        var m = d.toString(), v = +m.substring(m.length - 1);
        return v === this.luhn_calculate(+m.substring(0, m.length - 1));
      }, u.prototype.luhn_calculate = function(d) {
        for (var m = d.toString().split("").reverse(), v = 0, k, O = 0, G = m.length; G > O; ++O)
          k = +m[O], O % 2 === 0 && (k *= 2, k > 9 && (k -= 9)), v += k;
        return v * 9 % 10;
      }, u.prototype.md5 = function(d) {
        var m = { str: "", key: null, raw: !1 };
        if (!d)
          m.str = this.string(), d = {};
        else if (typeof d == "string")
          m.str = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        if (m = f(d, m), !m.str)
          throw new Error("A parameter is required to return an md5 hash.");
        return this.bimd5.md5(m.str, m.key, m.raw);
      }, u.prototype.file = function(d) {
        var m = d || {}, v = "fileExtension", k = Object.keys(this.get("fileExtension")), O, G;
        if (O = this.word({ length: m.length }), m.extension)
          return G = m.extension, O + "." + G;
        if (m.extensions) {
          if (Array.isArray(m.extensions))
            return G = this.pickone(m.extensions), O + "." + G;
          if (m.extensions.constructor === Object) {
            var H = m.extensions, j = Object.keys(H);
            return G = this.pickone(H[this.pickone(j)]), O + "." + G;
          }
          throw new Error("Chance: Extensions must be an Array or Object");
        }
        if (m.fileType) {
          var F = m.fileType;
          if (k.indexOf(F) !== -1)
            return G = this.pickone(this.get(v)[F]), O + "." + G;
          throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        return G = this.pickone(this.get(v)[this.pickone(k)]), O + "." + G;
      }, u.prototype.fileWithContent = function(d) {
        var m = d || {}, v = "fileName" in m ? m.fileName : this.file().split(".")[0];
        if (v += "." + ("fileExtension" in m ? m.fileExtension : this.file().split(".")[1]), typeof m.fileSize != "number")
          throw new Error("File size must be an integer");
        var k = {
          fileData: this.buffer({ length: m.fileSize }),
          fileName: v
        };
        return k;
      };
      var x = {
        firstNames: {
          male: {
            en: ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
            it: ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Aaron", "Abel", "Adam", "Adriaan", "Albert", "Alexander", "Ali", "Arjen", "Arno", "Bart", "Bas", "Bastiaan", "Benjamin", "Bob", "Boris", "Bram", "Brent", "Cas", "Casper", "Chris", "Christiaan", "Cornelis", "Daan", "Daley", "Damian", "Dani", "Daniel", "Daniël", "David", "Dean", "Dirk", "Dylan", "Egbert", "Elijah", "Erik", "Erwin", "Evert", "Ezra", "Fabian", "Fedde", "Finn", "Florian", "Floris", "Frank", "Frans", "Frederik", "Freek", "Geert", "Gerard", "Gerben", "Gerrit", "Gijs", "Guus", "Hans", "Hendrik", "Henk", "Herman", "Hidde", "Hugo", "Jaap", "Jan Jaap", "Jan-Willem", "Jack", "Jacob", "Jan", "Jason", "Jasper", "Jayden", "Jelle", "Jelte", "Jens", "Jeroen", "Jesse", "Jim", "Job", "Joep", "Johannes", "John", "Jonathan", "Joris", "Joshua", "Joël", "Julian", "Kees", "Kevin", "Koen", "Lars", "Laurens", "Leendert", "Lennard", "Lodewijk", "Luc", "Luca", "Lucas", "Lukas", "Luuk", "Maarten", "Marcus", "Martijn", "Martin", "Matthijs", "Maurits", "Max", "Mees", "Melle", "Mick", "Mika", "Milan", "Mohamed", "Mohammed", "Morris", "Muhammed", "Nathan", "Nick", "Nico", "Niek", "Niels", "Noah", "Noud", "Olivier", "Oscar", "Owen", "Paul", "Pepijn", "Peter", "Pieter", "Pim", "Quinten", "Reinier", "Rens", "Robin", "Ruben", "Sam", "Samuel", "Sander", "Sebastiaan", "Sem", "Sep", "Sepp", "Siem", "Simon", "Stan", "Stef", "Steven", "Stijn", "Sven", "Teun", "Thijmen", "Thijs", "Thomas", "Tijn", "Tim", "Timo", "Tobias", "Tom", "Victor", "Vince", "Willem", "Wim", "Wouter", "Yusuf"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Aaron", "Abdon", "Abel", "Abélard", "Abelin", "Abondance", "Abraham", "Absalon", "Acace", "Achaire", "Achille", "Adalard", "Adalbald", "Adalbéron", "Adalbert", "Adalric", "Adam", "Adegrin", "Adel", "Adelin", "Andelin", "Adelphe", "Adam", "Adéodat", "Adhémar", "Adjutor", "Adolphe", "Adonis", "Adon", "Adrien", "Agapet", "Agathange", "Agathon", "Agilbert", "Agénor", "Agnan", "Aignan", "Agrippin", "Aimable", "Aimé", "Alain", "Alban", "Albin", "Aubin", "Albéric", "Albert", "Albertet", "Alcibiade", "Alcide", "Alcée", "Alcime", "Aldonce", "Aldric", "Aldéric", "Aleaume", "Alexandre", "Alexis", "Alix", "Alliaume", "Aleaume", "Almine", "Almire", "Aloïs", "Alphée", "Alphonse", "Alpinien", "Alverède", "Amalric", "Amaury", "Amandin", "Amant", "Ambroise", "Amédée", "Amélien", "Amiel", "Amour", "Anaël", "Anastase", "Anatole", "Ancelin", "Andéol", "Andoche", "André", "Andoche", "Ange", "Angelin", "Angilbe", "Anglebert", "Angoustan", "Anicet", "Anne", "Annibal", "Ansbert", "Anselme", "Anthelme", "Antheaume", "Anthime", "Antide", "Antoine", "Antonius", "Antonin", "Apollinaire", "Apollon", "Aquilin", "Arcade", "Archambaud", "Archambeau", "Archange", "Archibald", "Arian", "Ariel", "Ariste", "Aristide", "Armand", "Armel", "Armin", "Arnould", "Arnaud", "Arolde", "Arsène", "Arsinoé", "Arthaud", "Arthème", "Arthur", "Ascelin", "Athanase", "Aubry", "Audebert", "Audouin", "Audran", "Audric", "Auguste", "Augustin", "Aurèle", "Aurélien", "Aurian", "Auxence", "Axel", "Aymard", "Aymeric", "Aymon", "Aymond", "Balthazar", "Baptiste", "Barnabé", "Barthélemy", "Bartimée", "Basile", "Bastien", "Baudouin", "Bénigne", "Benjamin", "Benoît", "Bérenger", "Bérard", "Bernard", "Bertrand", "Blaise", "Bon", "Boniface", "Bouchard", "Brice", "Brieuc", "Bruno", "Brunon", "Calixte", "Calliste", "Camélien", "Camille", "Camillien", "Candide", "Caribert", "Carloman", "Cassandre", "Cassien", "Cédric", "Céleste", "Célestin", "Célien", "Césaire", "César", "Charles", "Charlemagne", "Childebert", "Chilpéric", "Chrétien", "Christian", "Christodule", "Christophe", "Chrysostome", "Clarence", "Claude", "Claudien", "Cléandre", "Clément", "Clotaire", "Côme", "Constance", "Constant", "Constantin", "Corentin", "Cyprien", "Cyriaque", "Cyrille", "Cyril", "Damien", "Daniel", "David", "Delphin", "Denis", "Désiré", "Didier", "Dieudonné", "Dimitri", "Dominique", "Dorian", "Dorothée", "Edgard", "Edmond", "Édouard", "Éleuthère", "Élie", "Élisée", "Émeric", "Émile", "Émilien", "Emmanuel", "Enguerrand", "Épiphane", "Éric", "Esprit", "Ernest", "Étienne", "Eubert", "Eudes", "Eudoxe", "Eugène", "Eusèbe", "Eustache", "Évariste", "Évrard", "Fabien", "Fabrice", "Falba", "Félicité", "Félix", "Ferdinand", "Fiacre", "Fidèle", "Firmin", "Flavien", "Flodoard", "Florent", "Florentin", "Florestan", "Florian", "Fortuné", "Foulques", "Francisque", "François", "Français", "Franciscus", "Francs", "Frédéric", "Fulbert", "Fulcran", "Fulgence", "Gabin", "Gabriel", "Gaël", "Garnier", "Gaston", "Gaspard", "Gatien", "Gaud", "Gautier", "Gédéon", "Geoffroy", "Georges", "Géraud", "Gérard", "Gerbert", "Germain", "Gervais", "Ghislain", "Gilbert", "Gilles", "Girart", "Gislebert", "Gondebaud", "Gonthier", "Gontran", "Gonzague", "Grégoire", "Guérin", "Gui", "Guillaume", "Gustave", "Guy", "Guyot", "Hardouin", "Hector", "Hédelin", "Hélier", "Henri", "Herbert", "Herluin", "Hervé", "Hilaire", "Hildebert", "Hincmar", "Hippolyte", "Honoré", "Hubert", "Hugues", "Innocent", "Isabeau", "Isidore", "Jacques", "Japhet", "Jason", "Jean", "Jeannel", "Jeannot", "Jérémie", "Jérôme", "Joachim", "Joanny", "Job", "Jocelyn", "Joël", "Johan", "Jonas", "Jonathan", "Joseph", "Josse", "Josselin", "Jourdain", "Jude", "Judicaël", "Jules", "Julien", "Juste", "Justin", "Lambert", "Landry", "Laurent", "Lazare", "Léandre", "Léon", "Léonard", "Léopold", "Leu", "Loup", "Leufroy", "Libère", "Liétald", "Lionel", "Loïc", "Longin", "Lorrain", "Lorraine", "Lothaire", "Louis", "Loup", "Luc", "Lucas", "Lucien", "Ludolphe", "Ludovic", "Macaire", "Malo", "Mamert", "Manassé", "Marc", "Marceau", "Marcel", "Marcelin", "Marius", "Marseille", "Martial", "Martin", "Mathurin", "Matthias", "Mathias", "Matthieu", "Maugis", "Maurice", "Mauricet", "Maxence", "Maxime", "Maximilien", "Mayeul", "Médéric", "Melchior", "Mence", "Merlin", "Mérovée", "Michaël", "Michel", "Moïse", "Morgan", "Nathan", "Nathanaël", "Narcisse", "Néhémie", "Nestor", "Nestor", "Nicéphore", "Nicolas", "Noé", "Noël", "Norbert", "Normand", "Normands", "Octave", "Odilon", "Odon", "Oger", "Olivier", "Oury", "Pacôme", "Palémon", "Parfait", "Pascal", "Paterne", "Patrice", "Paul", "Pépin", "Perceval", "Philémon", "Philibert", "Philippe", "Philothée", "Pie", "Pierre", "Pierrick", "Prosper", "Quentin", "Raoul", "Raphaël", "Raymond", "Régis", "Réjean", "Rémi", "Renaud", "René", "Reybaud", "Richard", "Robert", "Roch", "Rodolphe", "Rodrigue", "Roger", "Roland", "Romain", "Romuald", "Roméo", "Rome", "Ronan", "Roselin", "Salomon", "Samuel", "Savin", "Savinien", "Scholastique", "Sébastien", "Séraphin", "Serge", "Séverin", "Sidoine", "Sigebert", "Sigismond", "Silvère", "Simon", "Siméon", "Sixte", "Stanislas", "Stéphane", "Stephan", "Sylvain", "Sylvestre", "Tancrède", "Tanguy", "Taurin", "Théodore", "Théodose", "Théophile", "Théophraste", "Thibault", "Thibert", "Thierry", "Thomas", "Timoléon", "Timothée", "Titien", "Tonnin", "Toussaint", "Trajan", "Tristan", "Turold", "Tim", "Ulysse", "Urbain", "Valentin", "Valère", "Valéry", "Venance", "Venant", "Venceslas", "Vianney", "Victor", "Victorien", "Victorin", "Vigile", "Vincent", "Vital", "Vitalien", "Vivien", "Waleran", "Wandrille", "Xavier", "Xénophon", "Yves", "Zacharie", "Zaché", "Zéphirin"]
          },
          female: {
            en: ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
            it: ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Lea", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Ada", "Arianne", "Afke", "Amanda", "Amber", "Amy", "Aniek", "Anita", "Anja", "Anna", "Anne", "Annelies", "Annemarie", "Annette", "Anouk", "Astrid", "Aukje", "Barbara", "Bianca", "Carla", "Carlijn", "Carolien", "Chantal", "Charlotte", "Claudia", "Daniëlle", "Debora", "Diane", "Dora", "Eline", "Elise", "Ella", "Ellen", "Emma", "Esmee", "Evelien", "Esther", "Erica", "Eva", "Femke", "Fleur", "Floor", "Froukje", "Gea", "Gerda", "Hanna", "Hanneke", "Heleen", "Hilde", "Ilona", "Ina", "Inge", "Ingrid", "Iris", "Isabel", "Isabelle", "Janneke", "Jasmijn", "Jeanine", "Jennifer", "Jessica", "Johanna", "Joke", "Julia", "Julie", "Karen", "Karin", "Katja", "Kim", "Lara", "Laura", "Lena", "Lianne", "Lieke", "Lilian", "Linda", "Lisa", "Lisanne", "Lotte", "Louise", "Maaike", "Manon", "Marga", "Maria", "Marissa", "Marit", "Marjolein", "Martine", "Marleen", "Melissa", "Merel", "Miranda", "Michelle", "Mirjam", "Mirthe", "Naomi", "Natalie", "Nienke", "Nina", "Noortje", "Olivia", "Patricia", "Paula", "Paulien", "Ramona", "Ria", "Rianne", "Roos", "Rosanne", "Ruth", "Sabrina", "Sandra", "Sanne", "Sara", "Saskia", "Silvia", "Sofia", "Sophie", "Sonja", "Suzanne", "Tamara", "Tess", "Tessa", "Tineke", "Valerie", "Vanessa", "Veerle", "Vera", "Victoria", "Wendy", "Willeke", "Yvonne", "Zoë"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Abdon", "Abel", "Abigaëlle", "Abigaïl", "Acacius", "Acanthe", "Adalbert", "Adalsinde", "Adegrine", "Adélaïde", "Adèle", "Adélie", "Adeline", "Adeltrude", "Adolphe", "Adonis", "Adrastée", "Adrehilde", "Adrienne", "Agathe", "Agilbert", "Aglaé", "Aignan", "Agneflète", "Agnès", "Agrippine", "Aimé", "Alaine", "Alaïs", "Albane", "Albérade", "Alberte", "Alcide", "Alcine", "Alcyone", "Aldegonde", "Aleth", "Alexandrine", "Alexine", "Alice", "Aliénor", "Aliette", "Aline", "Alix", "Alizé", "Aloïse", "Aloyse", "Alphonsine", "Althée", "Amaliane", "Amalthée", "Amande", "Amandine", "Amant", "Amarande", "Amaranthe", "Amaryllis", "Ambre", "Ambroisie", "Amélie", "Améthyste", "Aminte", "Anaël", "Anaïs", "Anastasie", "Anatole", "Ancelin", "Andrée", "Anémone", "Angadrême", "Angèle", "Angeline", "Angélique", "Angilbert", "Anicet", "Annabelle", "Anne", "Annette", "Annick", "Annie", "Annonciade", "Ansbert", "Anstrudie", "Anthelme", "Antigone", "Antoinette", "Antonine", "Aphélie", "Apolline", "Apollonie", "Aquiline", "Arabelle", "Arcadie", "Archange", "Argine", "Ariane", "Aricie", "Ariel", "Arielle", "Arlette", "Armance", "Armande", "Armandine", "Armelle", "Armide", "Armelle", "Armin", "Arnaud", "Arsène", "Arsinoé", "Artémis", "Arthur", "Ascelin", "Ascension", "Assomption", "Astarté", "Astérie", "Astrée", "Astrid", "Athalie", "Athanasie", "Athina", "Aube", "Albert", "Aude", "Audrey", "Augustine", "Aure", "Aurélie", "Aurélien", "Aurèle", "Aurore", "Auxence", "Aveline", "Abigaëlle", "Avoye", "Axelle", "Aymard", "Azalée", "Adèle", "Adeline", "Barbe", "Basilisse", "Bathilde", "Béatrice", "Béatrix", "Bénédicte", "Bérengère", "Bernadette", "Berthe", "Bertille", "Beuve", "Blanche", "Blanc", "Blandine", "Brigitte", "Brune", "Brunehilde", "Callista", "Camille", "Capucine", "Carine", "Caroline", "Cassandre", "Catherine", "Cécile", "Céleste", "Célestine", "Céline", "Chantal", "Charlène", "Charline", "Charlotte", "Chloé", "Christelle", "Christiane", "Christine", "Claire", "Clara", "Claude", "Claudine", "Clarisse", "Clémence", "Clémentine", "Cléo", "Clio", "Clotilde", "Coline", "Conception", "Constance", "Coralie", "Coraline", "Corentine", "Corinne", "Cyrielle", "Daniel", "Daniel", "Daphné", "Débora", "Delphine", "Denise", "Diane", "Dieudonné", "Dominique", "Doriane", "Dorothée", "Douce", "Édith", "Edmée", "Éléonore", "Éliane", "Élia", "Éliette", "Élisabeth", "Élise", "Ella", "Élodie", "Éloïse", "Elsa", "Émeline", "Émérance", "Émérentienne", "Émérencie", "Émilie", "Emma", "Emmanuelle", "Emmelie", "Ernestine", "Esther", "Estelle", "Eudoxie", "Eugénie", "Eulalie", "Euphrasie", "Eusébie", "Évangéline", "Eva", "Ève", "Évelyne", "Fanny", "Fantine", "Faustine", "Félicie", "Fernande", "Flavie", "Fleur", "Flore", "Florence", "Florie", "Fortuné", "France", "Francia", "Françoise", "Francine", "Gabrielle", "Gaëlle", "Garance", "Geneviève", "Georgette", "Gerberge", "Germaine", "Gertrude", "Gisèle", "Guenièvre", "Guilhemine", "Guillemette", "Gustave", "Gwenael", "Hélène", "Héloïse", "Henriette", "Hermine", "Hermione", "Hippolyte", "Honorine", "Hortense", "Huguette", "Ines", "Irène", "Irina", "Iris", "Isabeau", "Isabelle", "Iseult", "Isolde", "Ismérie", "Jacinthe", "Jacqueline", "Jade", "Janine", "Jeanne", "Jocelyne", "Joëlle", "Joséphine", "Judith", "Julia", "Julie", "Jules", "Juliette", "Justine", "Katy", "Kathy", "Katie", "Laura", "Laure", "Laureline", "Laurence", "Laurene", "Lauriane", "Laurianne", "Laurine", "Léa", "Léna", "Léonie", "Léon", "Léontine", "Lorraine", "Lucie", "Lucienne", "Lucille", "Ludivine", "Lydie", "Lydie", "Megane", "Madeleine", "Magali", "Maguelone", "Mallaury", "Manon", "Marceline", "Margot", "Marguerite", "Marianne", "Marie", "Myriam", "Marie", "Marine", "Marion", "Marlène", "Marthe", "Martine", "Mathilde", "Maud", "Maureen", "Mauricette", "Maxime", "Mélanie", "Melissa", "Mélissandre", "Mélisande", "Mélodie", "Michel", "Micheline", "Mireille", "Miriam", "Moïse", "Monique", "Morgane", "Muriel", "Mylène", "Nadège", "Nadine", "Nathalie", "Nicole", "Nicolette", "Nine", "Noël", "Noémie", "Océane", "Odette", "Odile", "Olive", "Olivia", "Olympe", "Ombline", "Ombeline", "Ophélie", "Oriande", "Oriane", "Ozanne", "Pascale", "Pascaline", "Paule", "Paulette", "Pauline", "Priscille", "Prisca", "Prisque", "Pécine", "Pélagie", "Pénélope", "Perrine", "Pétronille", "Philippine", "Philomène", "Philothée", "Primerose", "Prudence", "Pulchérie", "Quentine", "Quiéta", "Quintia", "Quintilla", "Rachel", "Raphaëlle", "Raymonde", "Rebecca", "Régine", "Réjeanne", "René", "Rita", "Rita", "Rolande", "Romane", "Rosalie", "Rose", "Roseline", "Sabine", "Salomé", "Sandra", "Sandrine", "Sarah", "Ségolène", "Séverine", "Sibylle", "Simone", "Sixt", "Solange", "Soline", "Solène", "Sophie", "Stéphanie", "Suzanne", "Sylvain", "Sylvie", "Tatiana", "Thaïs", "Théodora", "Thérèse", "Tiphaine", "Ursule", "Valentine", "Valérie", "Véronique", "Victoire", "Victorine", "Vinciane", "Violette", "Virginie", "Viviane", "Xavière", "Yolande", "Ysaline", "Yvette", "Yvonne", "Zélie", "Zita", "Zoé"]
          }
        },
        lastNames: {
          en: ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes", "Myers", "Ford", "Hamilton", "Graham", "Sullivan", "Wallace", "Woods", "Cole", "West", "Jordan", "Owens", "Reynolds", "Fisher", "Ellis", "Harrison", "Gibson", "McDonald", "Cruz", "Marshall", "Ortiz", "Gomez", "Murray", "Freeman", "Wells", "Webb", "Simpson", "Stevens", "Tucker", "Porter", "Hunter", "Hicks", "Crawford", "Henry", "Boyd", "Mason", "Morales", "Kennedy", "Warren", "Dixon", "Ramos", "Reyes", "Burns", "Gordon", "Shaw", "Holmes", "Rice", "Robertson", "Hunt", "Black", "Daniels", "Palmer", "Mills", "Nichols", "Grant", "Knight", "Ferguson", "Rose", "Stone", "Hawkins", "Dunn", "Perkins", "Hudson", "Spencer", "Gardner", "Stephens", "Payne", "Pierce", "Berry", "Matthews", "Arnold", "Wagner", "Willis", "Ray", "Watkins", "Olson", "Carroll", "Duncan", "Snyder", "Hart", "Cunningham", "Bradley", "Lane", "Andrews", "Ruiz", "Harper", "Fox", "Riley", "Armstrong", "Carpenter", "Weaver", "Greene", "Lawrence", "Elliott", "Chavez", "Sims", "Austin", "Peters", "Kelley", "Franklin", "Lawson", "Fields", "Gutierrez", "Ryan", "Schmidt", "Carr", "Vasquez", "Castillo", "Wheeler", "Chapman", "Oliver", "Montgomery", "Richards", "Williamson", "Johnston", "Banks", "Meyer", "Bishop", "McCoy", "Howell", "Alvarez", "Morrison", "Hansen", "Fernandez", "Garza", "Harvey", "Little", "Burton", "Stanley", "Nguyen", "George", "Jacobs", "Reid", "Kim", "Fuller", "Lynch", "Dean", "Gilbert", "Garrett", "Romero", "Welch", "Larson", "Frazier", "Burke", "Hanson", "Day", "Mendoza", "Moreno", "Bowman", "Medina", "Fowler", "Brewer", "Hoffman", "Carlson", "Silva", "Pearson", "Holland", "Douglas", "Fleming", "Jensen", "Vargas", "Byrd", "Davidson", "Hopkins", "May", "Terry", "Herrera", "Wade", "Soto", "Walters", "Curtis", "Neal", "Caldwell", "Lowe", "Jennings", "Barnett", "Graves", "Jimenez", "Horton", "Shelton", "Barrett", "Obrien", "Castro", "Sutton", "Gregory", "McKinney", "Lucas", "Miles", "Craig", "Rodriquez", "Chambers", "Holt", "Lambert", "Fletcher", "Watts", "Bates", "Hale", "Rhodes", "Pena", "Beck", "Newman", "Haynes", "McDaniel", "Mendez", "Bush", "Vaughn", "Parks", "Dawson", "Santiago", "Norris", "Hardy", "Love", "Steele", "Curry", "Powers", "Schultz", "Barker", "Guzman", "Page", "Munoz", "Ball", "Keller", "Chandler", "Weber", "Leonard", "Walsh", "Lyons", "Ramsey", "Wolfe", "Schneider", "Mullins", "Benson", "Sharp", "Bowen", "Daniel", "Barber", "Cummings", "Hines", "Baldwin", "Griffith", "Valdez", "Hubbard", "Salazar", "Reeves", "Warner", "Stevenson", "Burgess", "Santos", "Tate", "Cross", "Garner", "Mann", "Mack", "Moss", "Thornton", "Dennis", "McGee", "Farmer", "Delgado", "Aguilar", "Vega", "Glover", "Manning", "Cohen", "Harmon", "Rodgers", "Robbins", "Newton", "Todd", "Blair", "Higgins", "Ingram", "Reese", "Cannon", "Strickland", "Townsend", "Potter", "Goodwin", "Walton", "Rowe", "Hampton", "Ortega", "Patton", "Swanson", "Joseph", "Francis", "Goodman", "Maldonado", "Yates", "Becker", "Erickson", "Hodges", "Rios", "Conner", "Adkins", "Webster", "Norman", "Malone", "Hammond", "Flowers", "Cobb", "Moody", "Quinn", "Blake", "Maxwell", "Pope", "Floyd", "Osborne", "Paul", "McCarthy", "Guerrero", "Lindsey", "Estrada", "Sandoval", "Gibbs", "Tyler", "Gross", "Fitzgerald", "Stokes", "Doyle", "Sherman", "Saunders", "Wise", "Colon", "Gill", "Alvarado", "Greer", "Padilla", "Simon", "Waters", "Nunez", "Ballard", "Schwartz", "McBride", "Houston", "Christensen", "Klein", "Pratt", "Briggs", "Parsons", "McLaughlin", "Zimmerman", "French", "Buchanan", "Moran", "Copeland", "Roy", "Pittman", "Brady", "McCormick", "Holloway", "Brock", "Poole", "Frank", "Logan", "Owen", "Bass", "Marsh", "Drake", "Wong", "Jefferson", "Park", "Morton", "Abbott", "Sparks", "Patrick", "Norton", "Huff", "Clayton", "Massey", "Lloyd", "Figueroa", "Carson", "Bowers", "Roberson", "Barton", "Tran", "Lamb", "Harrington", "Casey", "Boone", "Cortez", "Clarke", "Mathis", "Singleton", "Wilkins", "Cain", "Bryan", "Underwood", "Hogan", "McKenzie", "Collier", "Luna", "Phelps", "McGuire", "Allison", "Bridges", "Wilkerson", "Nash", "Summers", "Atkins"],
          // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
          it: ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"],
          // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
          nl: ["Albers", "Alblas", "Appelman", "Baars", "Baas", "Bakker", "Blank", "Bleeker", "Blok", "Blom", "Boer", "Boers", "Boldewijn", "Boon", "Boot", "Bos", "Bosch", "Bosma", "Bosman", "Bouma", "Bouman", "Bouwman", "Brands", "Brouwer", "Burger", "Buijs", "Buitenhuis", "Ceder", "Cohen", "Dekker", "Dekkers", "Dijkman", "Dijkstra", "Driessen", "Drost", "Engel", "Evers", "Faber", "Franke", "Gerritsen", "Goedhart", "Goossens", "Groen", "Groenenberg", "Groot", "Haan", "Hart", "Heemskerk", "Hendriks", "Hermans", "Hoekstra", "Hofman", "Hopman", "Huisman", "Jacobs", "Jansen", "Janssen", "Jonker", "Jaspers", "Keijzer", "Klaassen", "Klein", "Koek", "Koenders", "Kok", "Kool", "Koopman", "Koopmans", "Koning", "Koster", "Kramer", "Kroon", "Kuijpers", "Kuiper", "Kuipers", "Kurt", "Koster", "Kwakman", "Los", "Lubbers", "Maas", "Markus", "Martens", "Meijer", "Mol", "Molenaar", "Mulder", "Nieuwenhuis", "Peeters", "Peters", "Pengel", "Pieters", "Pool", "Post", "Postma", "Prins", "Pronk", "Reijnders", "Rietveld", "Roest", "Roos", "Sanders", "Schaap", "Scheffer", "Schenk", "Schilder", "Schipper", "Schmidt", "Scholten", "Schouten", "Schut", "Schutte", "Schuurman", "Simons", "Smeets", "Smit", "Smits", "Snel", "Swinkels", "Tas", "Terpstra", "Timmermans", "Tol", "Tromp", "Troost", "Valk", "Veenstra", "Veldkamp", "Verbeek", "Verheul", "Verhoeven", "Vermeer", "Vermeulen", "Verweij", "Vink", "Visser", "Voorn", "Vos", "Wagenaar", "Wiersema", "Willems", "Willemsen", "Witteveen", "Wolff", "Wolters", "Zijlstra", "Zwart", "de Beer", "de Boer", "de Bruijn", "de Bruin", "de Graaf", "de Groot", "de Haan", "de Haas", "de Jager", "de Jong", "de Jonge", "de Koning", "de Lange", "de Leeuw", "de Ridder", "de Rooij", "de Ruiter", "de Vos", "de Vries", "de Waal", "de Wit", "de Zwart", "van Beek", "van Boven", "van Dam", "van Dijk", "van Dongen", "van Doorn", "van Egmond", "van Eijk", "van Es", "van Gelder", "van Gelderen", "van Houten", "van Hulst", "van Kempen", "van Kesteren", "van Leeuwen", "van Loon", "van Mill", "van Noord", "van Ommen", "van Ommeren", "van Oosten", "van Oostveen", "van Rijn", "van Schaik", "van Veen", "van Vliet", "van Wijk", "van Wijngaarden", "van den Poel", "van de Pol", "van den Ploeg", "van de Ven", "van den Berg", "van den Bosch", "van den Brink", "van den Broek", "van den Heuvel", "van der Heijden", "van der Horst", "van der Hulst", "van der Kroon", "van der Laan", "van der Linden", "van der Meer", "van der Meij", "van der Meulen", "van der Molen", "van der Sluis", "van der Spek", "van der Veen", "van der Velde", "van der Velden", "van der Vliet", "van der Wal"],
          // https://surnames.behindthename.com/top/lists/england-wales/1991
          uk: ["Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans", "Wilson", "Thomas", "Johnson", "Roberts", "Robinson", "Thompson", "Wright", "Walker", "White", "Edwards", "Hughes", "Green", "Hall", "Lewis", "Harris", "Clarke", "Patel", "Jackson", "Wood", "Turner", "Martin", "Cooper", "Hill", "Ward", "Morris", "Moore", "Clark", "Lee", "King", "Baker", "Harrison", "Morgan", "Allen", "James", "Scott", "Phillips", "Watson", "Davis", "Parker", "Price", "Bennett", "Young", "Griffiths", "Mitchell", "Kelly", "Cook", "Carter", "Richardson", "Bailey", "Collins", "Bell", "Shaw", "Murphy", "Miller", "Cox", "Richards", "Khan", "Marshall", "Anderson", "Simpson", "Ellis", "Adams", "Singh", "Begum", "Wilkinson", "Foster", "Chapman", "Powell", "Webb", "Rogers", "Gray", "Mason", "Ali", "Hunt", "Hussain", "Campbell", "Matthews", "Owen", "Palmer", "Holmes", "Mills", "Barnes", "Knight", "Lloyd", "Butler", "Russell", "Barker", "Fisher", "Stevens", "Jenkins", "Murray", "Dixon", "Harvey", "Graham", "Pearson", "Ahmed", "Fletcher", "Walsh", "Kaur", "Gibson", "Howard", "Andrews", "Stewart", "Elliott", "Reynolds", "Saunders", "Payne", "Fox", "Ford", "Pearce", "Day", "Brooks", "West", "Lawrence", "Cole", "Atkinson", "Bradley", "Spencer", "Gill", "Dawson", "Ball", "Burton", "O'brien", "Watts", "Rose", "Booth", "Perry", "Ryan", "Grant", "Wells", "Armstrong", "Francis", "Rees", "Hayes", "Hart", "Hudson", "Newman", "Barrett", "Webster", "Hunter", "Gregory", "Carr", "Lowe", "Page", "Marsh", "Riley", "Dunn", "Woods", "Parsons", "Berry", "Stone", "Reid", "Holland", "Hawkins", "Harding", "Porter", "Robertson", "Newton", "Oliver", "Reed", "Kennedy", "Williamson", "Bird", "Gardner", "Shah", "Dean", "Lane", "Cooke", "Bates", "Henderson", "Parry", "Burgess", "Bishop", "Walton", "Burns", "Nicholson", "Shepherd", "Ross", "Cross", "Long", "Freeman", "Warren", "Nicholls", "Hamilton", "Byrne", "Sutton", "Mcdonald", "Yates", "Hodgson", "Robson", "Curtis", "Hopkins", "O'connor", "Harper", "Coleman", "Watkins", "Moss", "Mccarthy", "Chambers", "O'neill", "Griffin", "Sharp", "Hardy", "Wheeler", "Potter", "Osborne", "Johnston", "Gordon", "Doyle", "Wallace", "George", "Jordan", "Hutchinson", "Rowe", "Burke", "May", "Pritchard", "Gilbert", "Willis", "Higgins", "Read", "Miles", "Stevenson", "Stephenson", "Hammond", "Arnold", "Buckley", "Walters", "Hewitt", "Barber", "Nelson", "Slater", "Austin", "Sullivan", "Whitehead", "Mann", "Frost", "Lambert", "Stephens", "Blake", "Akhtar", "Lynch", "Goodwin", "Barton", "Woodward", "Thomson", "Cunningham", "Quinn", "Barnett", "Baxter", "Bibi", "Clayton", "Nash", "Greenwood", "Jennings", "Holt", "Kemp", "Poole", "Gallagher", "Bond", "Stokes", "Tucker", "Davidson", "Fowler", "Heath", "Norman", "Middleton", "Lawson", "Banks", "French", "Stanley", "Jarvis", "Gibbs", "Ferguson", "Hayward", "Carroll", "Douglas", "Dickinson", "Todd", "Barlow", "Peters", "Lucas", "Knowles", "Hartley", "Miah", "Simmons", "Morton", "Alexander", "Field", "Morrison", "Norris", "Townsend", "Preston", "Hancock", "Thornton", "Baldwin", "Burrows", "Briggs", "Parkinson", "Reeves", "Macdonald", "Lamb", "Black", "Abbott", "Sanders", "Thorpe", "Holden", "Tomlinson", "Perkins", "Ashton", "Rhodes", "Fuller", "Howe", "Bryant", "Vaughan", "Dale", "Davey", "Weston", "Bartlett", "Whittaker", "Davison", "Kent", "Skinner", "Birch", "Morley", "Daniels", "Glover", "Howell", "Cartwright", "Pugh", "Humphreys", "Goddard", "Brennan", "Wall", "Kirby", "Bowen", "Savage", "Bull", "Wong", "Dobson", "Smart", "Wilkins", "Kirk", "Fraser", "Duffy", "Hicks", "Patterson", "Bradshaw", "Little", "Archer", "Warner", "Waters", "O'sullivan", "Farrell", "Brookes", "Atkins", "Kay", "Dodd", "Bentley", "Flynn", "John", "Schofield", "Short", "Haynes", "Wade", "Butcher", "Henry", "Sanderson", "Crawford", "Sheppard", "Bolton", "Coates", "Giles", "Gould", "Houghton", "Gibbons", "Pratt", "Manning", "Law", "Hooper", "Noble", "Dyer", "Rahman", "Clements", "Moran", "Sykes", "Chan", "Doherty", "Connolly", "Joyce", "Franklin", "Hobbs", "Coles", "Herbert", "Steele", "Kerr", "Leach", "Winter", "Owens", "Duncan", "Naylor", "Fleming", "Horton", "Finch", "Fitzgerald", "Randall", "Carpenter", "Marsden", "Browne", "Garner", "Pickering", "Hale", "Dennis", "Vincent", "Chadwick", "Chandler", "Sharpe", "Nolan", "Lyons", "Hurst", "Collier", "Peacock", "Howarth", "Faulkner", "Rice", "Pollard", "Welch", "Norton", "Gough", "Sinclair", "Blackburn", "Bryan", "Conway", "Power", "Cameron", "Daly", "Allan", "Hanson", "Gardiner", "Boyle", "Myers", "Turnbull", "Wallis", "Mahmood", "Sims", "Swift", "Iqbal", "Pope", "Brady", "Chamberlain", "Rowley", "Tyler", "Farmer", "Metcalfe", "Hilton", "Godfrey", "Holloway", "Parkin", "Bray", "Talbot", "Donnelly", "Nixon", "Charlton", "Benson", "Whitehouse", "Barry", "Hope", "Lord", "North", "Storey", "Connor", "Potts", "Bevan", "Hargreaves", "Mclean", "Mistry", "Bruce", "Howells", "Hyde", "Parkes", "Wyatt", "Fry", "Lees", "O'donnell", "Craig", "Forster", "Mckenzie", "Humphries", "Mellor", "Carey", "Ingram", "Summers", "Leonard"],
          // https://surnames.behindthename.com/top/lists/germany/2017
          de: ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann", "Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", "Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler", "Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Pfeiffer"],
          // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
          jp: ["Sato", "Suzuki", "Takahashi", "Tanaka", "Watanabe", "Ito", "Yamamoto", "Nakamura", "Kobayashi", "Kato", "Yoshida", "Yamada", "Sasaki", "Yamaguchi", "Saito", "Matsumoto", "Inoue", "Kimura", "Hayashi", "Shimizu", "Yamazaki", "Mori", "Abe", "Ikeda", "Hashimoto", "Yamashita", "Ishikawa", "Nakajima", "Maeda", "Fujita", "Ogawa", "Goto", "Okada", "Hasegawa", "Murakami", "Kondo", "Ishii", "Saito", "Sakamoto", "Endo", "Aoki", "Fujii", "Nishimura", "Fukuda", "Ota", "Miura", "Fujiwara", "Okamoto", "Matsuda", "Nakagawa", "Nakano", "Harada", "Ono", "Tamura", "Takeuchi", "Kaneko", "Wada", "Nakayama", "Ishida", "Ueda", "Morita", "Hara", "Shibata", "Sakai", "Kudo", "Yokoyama", "Miyazaki", "Miyamoto", "Uchida", "Takagi", "Ando", "Taniguchi", "Ohno", "Maruyama", "Imai", "Takada", "Fujimoto", "Takeda", "Murata", "Ueno", "Sugiyama", "Masuda", "Sugawara", "Hirano", "Kojima", "Otsuka", "Chiba", "Kubo", "Matsui", "Iwasaki", "Sakurai", "Kinoshita", "Noguchi", "Matsuo", "Nomura", "Kikuchi", "Sano", "Onishi", "Sugimoto", "Arai"],
          // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
          es: ["Garcia", "Fernandez", "Lopez", "Martinez", "Gonzalez", "Rodriguez", "Sanchez", "Perez", "Martin", "Gomez", "Ruiz", "Diaz", "Hernandez", "Alvarez", "Jimenez", "Moreno", "Munoz", "Alonso", "Romero", "Navarro", "Gutierrez", "Torres", "Dominguez", "Gil", "Vazquez", "Blanco", "Serrano", "Ramos", "Castro", "Suarez", "Sanz", "Rubio", "Ortega", "Molina", "Delgado", "Ortiz", "Morales", "Ramirez", "Marin", "Iglesias", "Santos", "Castillo", "Garrido", "Calvo", "Pena", "Cruz", "Cano", "Nunez", "Prieto", "Diez", "Lozano", "Vidal", "Pascual", "Ferrer", "Medina", "Vega", "Leon", "Herrero", "Vicente", "Mendez", "Guerrero", "Fuentes", "Campos", "Nieto", "Cortes", "Caballero", "Ibanez", "Lorenzo", "Pastor", "Gimenez", "Saez", "Soler", "Marquez", "Carrasco", "Herrera", "Montero", "Arias", "Crespo", "Flores", "Andres", "Aguilar", "Hidalgo", "Cabrera", "Mora", "Duran", "Velasco", "Rey", "Pardo", "Roman", "Vila", "Bravo", "Merino", "Moya", "Soto", "Izquierdo", "Reyes", "Redondo", "Marcos", "Carmona", "Menendez"],
          // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
          fr: ["Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefèvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard", "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Müller", "Lefèvre", "Faure", "André", "Mercier", "Blanc", "Guérin", "Boyer", "Garnier", "Chevalier", "François", "Legrand", "Gauthier", "Garcia", "Perrin", "Robin", "Clément", "Morin", "Nicolas", "Henry", "Roussel", "Matthieu", "Gautier", "Masson", "Marchand", "Duval", "Denis", "Dumont", "Marie", "Lemaire", "Noël", "Meyer", "Dufour", "Meunier", "Brun", "Blanchard", "Giraud", "Joly", "Rivière", "Lucas", "Brunet", "Gaillard", "Barbier", "Arnaud", "Martínez", "Gérard", "Roche", "Renard", "Schmitt", "Roy", "Leroux", "Colin", "Vidal", "Caron", "Picard", "Roger", "Fabre", "Aubert", "Lemoine", "Renaud", "Dumas", "Lacroix", "Olivier", "Philippe", "Bourgeois", "Pierre", "Benoît", "Rey", "Leclerc", "Payet", "Rolland", "Leclercq", "Guillaume", "Lecomte", "López", "Jean", "Dupuy", "Guillot", "Hubert", "Berger", "Carpentier", "Sánchez", "Dupuis", "Moulin", "Louis", "Deschamps", "Huet", "Vasseur", "Perez", "Boucher", "Fleury", "Royer", "Klein", "Jacquet", "Adam", "Paris", "Poirier", "Marty", "Aubry", "Guyot", "Carré", "Charles", "Renault", "Charpentier", "Ménard", "Maillard", "Baron", "Bertin", "Bailly", "Hervé", "Schneider", "Fernández", "Le GallGall", "Collet", "Léger", "Bouvier", "Julien", "Prévost", "Millet", "Perrot", "Daniel", "Le RouxRoux", "Cousin", "Germain", "Breton", "Besson", "Langlois", "Rémi", "Le GoffGoff", "Pelletier", "Lévêque", "Perrier", "Leblanc", "Barré", "Lebrun", "Marchal", "Weber", "Mallet", "Hamon", "Boulanger", "Jacob", "Monnier", "Michaud", "Rodríguez", "Guichard", "Gillet", "Étienne", "Grondin", "Poulain", "Tessier", "Chevallier", "Collin", "Chauvin", "Da SilvaSilva", "Bouchet", "Gay", "Lemaître", "Bénard", "Maréchal", "Humbert", "Reynaud", "Antoine", "Hoarau", "Perret", "Barthélemy", "Cordier", "Pichon", "Lejeune", "Gilbert", "Lamy", "Delaunay", "Pasquier", "Carlier", "LaporteLaporte"]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [{ code: "AB" }, { code: "AL" }, { code: "B" }, { code: "BA" }, { code: "BB" }, { code: "BD" }, { code: "BH" }, { code: "BL" }, { code: "BN" }, { code: "BR" }, { code: "BS" }, { code: "BT" }, { code: "CA" }, { code: "CB" }, { code: "CF" }, { code: "CH" }, { code: "CM" }, { code: "CO" }, { code: "CR" }, { code: "CT" }, { code: "CV" }, { code: "CW" }, { code: "DA" }, { code: "DD" }, { code: "DE" }, { code: "DG" }, { code: "DH" }, { code: "DL" }, { code: "DN" }, { code: "DT" }, { code: "DY" }, { code: "E" }, { code: "EC" }, { code: "EH" }, { code: "EN" }, { code: "EX" }, { code: "FK" }, { code: "FY" }, { code: "G" }, { code: "GL" }, { code: "GU" }, { code: "GY" }, { code: "HA" }, { code: "HD" }, { code: "HG" }, { code: "HP" }, { code: "HR" }, { code: "HS" }, { code: "HU" }, { code: "HX" }, { code: "IG" }, { code: "IM" }, { code: "IP" }, { code: "IV" }, { code: "JE" }, { code: "KA" }, { code: "KT" }, { code: "KW" }, { code: "KY" }, { code: "L" }, { code: "LA" }, { code: "LD" }, { code: "LE" }, { code: "LL" }, { code: "LN" }, { code: "LS" }, { code: "LU" }, { code: "M" }, { code: "ME" }, { code: "MK" }, { code: "ML" }, { code: "N" }, { code: "NE" }, { code: "NG" }, { code: "NN" }, { code: "NP" }, { code: "NR" }, { code: "NW" }, { code: "OL" }, { code: "OX" }, { code: "PA" }, { code: "PE" }, { code: "PH" }, { code: "PL" }, { code: "PO" }, { code: "PR" }, { code: "RG" }, { code: "RH" }, { code: "RM" }, { code: "S" }, { code: "SA" }, { code: "SE" }, { code: "SG" }, { code: "SK" }, { code: "SL" }, { code: "SM" }, { code: "SN" }, { code: "SO" }, { code: "SP" }, { code: "SR" }, { code: "SS" }, { code: "ST" }, { code: "SW" }, { code: "SY" }, { code: "TA" }, { code: "TD" }, { code: "TF" }, { code: "TN" }, { code: "TQ" }, { code: "TR" }, { code: "TS" }, { code: "TW" }, { code: "UB" }, { code: "W" }, { code: "WA" }, { code: "WC" }, { code: "WD" }, { code: "WF" }, { code: "WN" }, { code: "WR" }, { code: "WS" }, { code: "WV" }, { code: "YO" }, { code: "ZE" }],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [{ name: "Afghanistan", abbreviation: "AF" }, { name: "Åland Islands", abbreviation: "AX" }, { name: "Albania", abbreviation: "AL" }, { name: "Algeria", abbreviation: "DZ" }, { name: "American Samoa", abbreviation: "AS" }, { name: "Andorra", abbreviation: "AD" }, { name: "Angola", abbreviation: "AO" }, { name: "Anguilla", abbreviation: "AI" }, { name: "Antarctica", abbreviation: "AQ" }, { name: "Antigua and Barbuda", abbreviation: "AG" }, { name: "Argentina", abbreviation: "AR" }, { name: "Armenia", abbreviation: "AM" }, { name: "Aruba", abbreviation: "AW" }, { name: "Australia", abbreviation: "AU" }, { name: "Austria", abbreviation: "AT" }, { name: "Azerbaijan", abbreviation: "AZ" }, { name: "Bahamas", abbreviation: "BS" }, { name: "Bahrain", abbreviation: "BH" }, { name: "Bangladesh", abbreviation: "BD" }, { name: "Barbados", abbreviation: "BB" }, { name: "Belarus", abbreviation: "BY" }, { name: "Belgium", abbreviation: "BE" }, { name: "Belize", abbreviation: "BZ" }, { name: "Benin", abbreviation: "BJ" }, { name: "Bermuda", abbreviation: "BM" }, { name: "Bhutan", abbreviation: "BT" }, { name: "Plurinational State of Bolivia", abbreviation: "BO" }, { name: "Bonaire, Sint Eustatius and Saba", abbreviation: "BQ" }, { name: "Bosnia and Herzegovina", abbreviation: "BA" }, { name: "Botswana", abbreviation: "BW" }, { name: "Bouvet Island", abbreviation: "BV" }, { name: "Brazil", abbreviation: "BR" }, { name: "British Indian Ocean Territory", abbreviation: "IO" }, { name: "Brunei Darussalam", abbreviation: "BN" }, { name: "Bulgaria", abbreviation: "BG" }, { name: "Burkina Faso", abbreviation: "BF" }, { name: "Burundi", abbreviation: "BI" }, { name: "Cabo Verde", abbreviation: "CV" }, { name: "Cambodia", abbreviation: "KH" }, { name: "Cameroon", abbreviation: "CM" }, { name: "Canada", abbreviation: "CA" }, { name: "Cayman Islands", abbreviation: "KY" }, { name: "Central African Republic", abbreviation: "CF" }, { name: "Chad", abbreviation: "TD" }, { name: "Chile", abbreviation: "CL" }, { name: "China", abbreviation: "CN" }, { name: "Christmas Island", abbreviation: "CX" }, { name: "Cocos (Keeling) Islands", abbreviation: "CC" }, { name: "Colombia", abbreviation: "CO" }, { name: "Comoros", abbreviation: "KM" }, { name: "Congo", abbreviation: "CG" }, { name: "Democratic Republic of the Congo", abbreviation: "CD" }, { name: "Cook Islands", abbreviation: "CK" }, { name: "Costa Rica", abbreviation: "CR" }, { name: "Côte d'Ivoire", abbreviation: "CI" }, { name: "Croatia", abbreviation: "HR" }, { name: "Cuba", abbreviation: "CU" }, { name: "Curaçao", abbreviation: "CW" }, { name: "Cyprus", abbreviation: "CY" }, { name: "Czechia", abbreviation: "CZ" }, { name: "Denmark", abbreviation: "DK" }, { name: "Djibouti", abbreviation: "DJ" }, { name: "Dominica", abbreviation: "DM" }, { name: "Dominican Republic", abbreviation: "DO" }, { name: "Ecuador", abbreviation: "EC" }, { name: "Egypt", abbreviation: "EG" }, { name: "El Salvador", abbreviation: "SV" }, { name: "Equatorial Guinea", abbreviation: "GQ" }, { name: "Eritrea", abbreviation: "ER" }, { name: "Estonia", abbreviation: "EE" }, { name: "Eswatini", abbreviation: "SZ" }, { name: "Ethiopia", abbreviation: "ET" }, { name: "Falkland Islands (Malvinas)", abbreviation: "FK" }, { name: "Faroe Islands", abbreviation: "FO" }, { name: "Fiji", abbreviation: "FJ" }, { name: "Finland", abbreviation: "FI" }, { name: "France", abbreviation: "FR" }, { name: "French Guiana", abbreviation: "GF" }, { name: "French Polynesia", abbreviation: "PF" }, { name: "French Southern Territories", abbreviation: "TF" }, { name: "Gabon", abbreviation: "GA" }, { name: "Gambia", abbreviation: "GM" }, { name: "Georgia", abbreviation: "GE" }, { name: "Germany", abbreviation: "DE" }, { name: "Ghana", abbreviation: "GH" }, { name: "Gibraltar", abbreviation: "GI" }, { name: "Greece", abbreviation: "GR" }, { name: "Greenland", abbreviation: "GL" }, { name: "Grenada", abbreviation: "GD" }, { name: "Guadeloupe", abbreviation: "GP" }, { name: "Guam", abbreviation: "GU" }, { name: "Guatemala", abbreviation: "GT" }, { name: "Guernsey", abbreviation: "GG" }, { name: "Guinea", abbreviation: "GN" }, { name: "Guinea-Bissau", abbreviation: "GW" }, { name: "Guyana", abbreviation: "GY" }, { name: "Haiti", abbreviation: "HT" }, { name: "Heard Island and McDonald Islands", abbreviation: "HM" }, { name: "Holy See", abbreviation: "VA" }, { name: "Honduras", abbreviation: "HN" }, { name: "Hong Kong", abbreviation: "HK" }, { name: "Hungary", abbreviation: "HU" }, { name: "Iceland", abbreviation: "IS" }, { name: "India", abbreviation: "IN" }, { name: "Indonesia", abbreviation: "ID" }, { name: "Islamic Republic of Iran", abbreviation: "IR" }, { name: "Iraq", abbreviation: "IQ" }, { name: "Ireland", abbreviation: "IE" }, { name: "Isle of Man", abbreviation: "IM" }, { name: "Israel", abbreviation: "IL" }, { name: "Italy", abbreviation: "IT" }, { name: "Jamaica", abbreviation: "JM" }, { name: "Japan", abbreviation: "JP" }, { name: "Jersey", abbreviation: "JE" }, { name: "Jordan", abbreviation: "JO" }, { name: "Kazakhstan", abbreviation: "KZ" }, { name: "Kenya", abbreviation: "KE" }, { name: "Kiribati", abbreviation: "KI" }, { name: "Democratic People's Republic of Korea", abbreviation: "KP" }, { name: "Republic of Korea", abbreviation: "KR" }, { name: "Kuwait", abbreviation: "KW" }, { name: "Kyrgyzstan", abbreviation: "KG" }, { name: "Lao People's Democratic Republic", abbreviation: "LA" }, { name: "Latvia", abbreviation: "LV" }, { name: "Lebanon", abbreviation: "LB" }, { name: "Lesotho", abbreviation: "LS" }, { name: "Liberia", abbreviation: "LR" }, { name: "Libya", abbreviation: "LY" }, { name: "Liechtenstein", abbreviation: "LI" }, { name: "Lithuania", abbreviation: "LT" }, { name: "Luxembourg", abbreviation: "LU" }, { name: "Macao", abbreviation: "MO" }, { name: "Madagascar", abbreviation: "MG" }, { name: "Malawi", abbreviation: "MW" }, { name: "Malaysia", abbreviation: "MY" }, { name: "Maldives", abbreviation: "MV" }, { name: "Mali", abbreviation: "ML" }, { name: "Malta", abbreviation: "MT" }, { name: "Marshall Islands", abbreviation: "MH" }, { name: "Martinique", abbreviation: "MQ" }, { name: "Mauritania", abbreviation: "MR" }, { name: "Mauritius", abbreviation: "MU" }, { name: "Mayotte", abbreviation: "YT" }, { name: "Mexico", abbreviation: "MX" }, { name: "Federated States of Micronesia", abbreviation: "FM" }, { name: "Republic of Moldova", abbreviation: "MD" }, { name: "Monaco", abbreviation: "MC" }, { name: "Mongolia", abbreviation: "MN" }, { name: "Montenegro", abbreviation: "ME" }, { name: "Montserrat", abbreviation: "MS" }, { name: "Morocco", abbreviation: "MA" }, { name: "Mozambique", abbreviation: "MZ" }, { name: "Myanmar", abbreviation: "MM" }, { name: "Namibia", abbreviation: "NA" }, { name: "Nauru", abbreviation: "NR" }, { name: "Nepal", abbreviation: "NP" }, { name: "Kingdom of the Netherlands", abbreviation: "NL" }, { name: "New Caledonia", abbreviation: "NC" }, { name: "New Zealand", abbreviation: "NZ" }, { name: "Nicaragua", abbreviation: "NI" }, { name: "Niger", abbreviation: "NE" }, { name: "Nigeria", abbreviation: "NG" }, { name: "Niue", abbreviation: "NU" }, { name: "Norfolk Island", abbreviation: "NF" }, { name: "North Macedonia", abbreviation: "MK" }, { name: "Northern Mariana Islands", abbreviation: "MP" }, { name: "Norway", abbreviation: "NO" }, { name: "Oman", abbreviation: "OM" }, { name: "Pakistan", abbreviation: "PK" }, { name: "Palau", abbreviation: "PW" }, { name: "State of Palestine", abbreviation: "PS" }, { name: "Panama", abbreviation: "PA" }, { name: "Papua New Guinea", abbreviation: "PG" }, { name: "Paraguay", abbreviation: "PY" }, { name: "Peru", abbreviation: "PE" }, { name: "Philippines", abbreviation: "PH" }, { name: "Pitcairn", abbreviation: "PN" }, { name: "Poland", abbreviation: "PL" }, { name: "Portugal", abbreviation: "PT" }, { name: "Puerto Rico", abbreviation: "PR" }, { name: "Qatar", abbreviation: "QA" }, { name: "Réunion", abbreviation: "RE" }, { name: "Romania", abbreviation: "RO" }, { name: "Russian Federation", abbreviation: "RU" }, { name: "Rwanda", abbreviation: "RW" }, { name: "Saint Barthélemy", abbreviation: "BL" }, { name: "Saint Helena, Ascension and Tristan da Cunha", abbreviation: "SH" }, { name: "Saint Kitts and Nevis", abbreviation: "KN" }, { name: "Saint Lucia", abbreviation: "LC" }, { name: "Saint Martin (French part)", abbreviation: "MF" }, { name: "Saint Pierre and Miquelon", abbreviation: "PM" }, { name: "Saint Vincent and the Grenadines", abbreviation: "VC" }, { name: "Samoa", abbreviation: "WS" }, { name: "San Marino", abbreviation: "SM" }, { name: "Sao Tome and Principe", abbreviation: "ST" }, { name: "Saudi Arabia", abbreviation: "SA" }, { name: "Senegal", abbreviation: "SN" }, { name: "Serbia", abbreviation: "RS" }, { name: "Seychelles", abbreviation: "SC" }, { name: "Sierra Leone", abbreviation: "SL" }, { name: "Singapore", abbreviation: "SG" }, { name: "Sint Maarten (Dutch part)", abbreviation: "SX" }, { name: "Slovakia", abbreviation: "SK" }, { name: "Slovenia", abbreviation: "SI" }, { name: "Solomon Islands", abbreviation: "SB" }, { name: "Somalia", abbreviation: "SO" }, { name: "South Africa", abbreviation: "ZA" }, { name: "South Georgia and the South Sandwich Islands", abbreviation: "GS" }, { name: "South Sudan", abbreviation: "SS" }, { name: "Spain", abbreviation: "ES" }, { name: "Sri Lanka", abbreviation: "LK" }, { name: "Sudan", abbreviation: "SD" }, { name: "Suriname", abbreviation: "SR" }, { name: "Svalbard and Jan Mayen", abbreviation: "SJ" }, { name: "Sweden", abbreviation: "SE" }, { name: "Switzerland", abbreviation: "CH" }, { name: "Syrian Arab Republic", abbreviation: "SY" }, { name: "Taiwan, Province of China", abbreviation: "TW" }, { name: "Tajikistan", abbreviation: "TJ" }, { name: "United Republic of Tanzania", abbreviation: "TZ" }, { name: "Thailand", abbreviation: "TH" }, { name: "Timor-Leste", abbreviation: "TL" }, { name: "Togo", abbreviation: "TG" }, { name: "Tokelau", abbreviation: "TK" }, { name: "Tonga", abbreviation: "TO" }, { name: "Trinidad and Tobago", abbreviation: "TT" }, { name: "Tunisia", abbreviation: "TN" }, { name: "Türkiye", abbreviation: "TR" }, { name: "Turkmenistan", abbreviation: "TM" }, { name: "Turks and Caicos Islands", abbreviation: "TC" }, { name: "Tuvalu", abbreviation: "TV" }, { name: "Uganda", abbreviation: "UG" }, { name: "Ukraine", abbreviation: "UA" }, { name: "United Arab Emirates", abbreviation: "AE" }, { name: "United Kingdom of Great Britain and Northern Ireland", abbreviation: "GB" }, { name: "United States Minor Outlying Islands", abbreviation: "UM" }, { name: "United States of America", abbreviation: "US" }, { name: "Uruguay", abbreviation: "UY" }, { name: "Uzbekistan", abbreviation: "UZ" }, { name: "Vanuatu", abbreviation: "VU" }, { name: "Bolivarian Republic of Venezuela", abbreviation: "VE" }, { name: "Viet Nam", abbreviation: "VN" }, { name: "Virgin Islands (British)", abbreviation: "VG" }, { name: "Virgin Islands (U.S.)", abbreviation: "VI" }, { name: "Wallis and Futuna", abbreviation: "WF" }, { name: "Western Sahara", abbreviation: "EH" }, { name: "Yemen", abbreviation: "YE" }, { name: "Zambia", abbreviation: "ZM" }, { name: "Zimbabwe", abbreviation: "ZW" }],
        counties: {
          // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
          uk: [
            { name: "Bath and North East Somerset" },
            { name: "Aberdeenshire" },
            { name: "Anglesey" },
            { name: "Angus" },
            { name: "Bedford" },
            { name: "Blackburn with Darwen" },
            { name: "Blackpool" },
            { name: "Bournemouth" },
            { name: "Bracknell Forest" },
            { name: "Brighton & Hove" },
            { name: "Bristol" },
            { name: "Buckinghamshire" },
            { name: "Cambridgeshire" },
            { name: "Carmarthenshire" },
            { name: "Central Bedfordshire" },
            { name: "Ceredigion" },
            { name: "Cheshire East" },
            { name: "Cheshire West and Chester" },
            { name: "Clackmannanshire" },
            { name: "Conwy" },
            { name: "Cornwall" },
            { name: "County Antrim" },
            { name: "County Armagh" },
            { name: "County Down" },
            { name: "County Durham" },
            { name: "County Fermanagh" },
            { name: "County Londonderry" },
            { name: "County Tyrone" },
            { name: "Cumbria" },
            { name: "Darlington" },
            { name: "Denbighshire" },
            { name: "Derby" },
            { name: "Derbyshire" },
            { name: "Devon" },
            { name: "Dorset" },
            { name: "Dumfries and Galloway" },
            { name: "Dundee" },
            { name: "East Lothian" },
            { name: "East Riding of Yorkshire" },
            { name: "East Sussex" },
            { name: "Edinburgh?" },
            { name: "Essex" },
            { name: "Falkirk" },
            { name: "Fife" },
            { name: "Flintshire" },
            { name: "Gloucestershire" },
            { name: "Greater London" },
            { name: "Greater Manchester" },
            { name: "Gwent" },
            { name: "Gwynedd" },
            { name: "Halton" },
            { name: "Hampshire" },
            { name: "Hartlepool" },
            { name: "Herefordshire" },
            { name: "Hertfordshire" },
            { name: "Highlands" },
            { name: "Hull" },
            { name: "Isle of Wight" },
            { name: "Isles of Scilly" },
            { name: "Kent" },
            { name: "Lancashire" },
            { name: "Leicester" },
            { name: "Leicestershire" },
            { name: "Lincolnshire" },
            { name: "Lothian" },
            { name: "Luton" },
            { name: "Medway" },
            { name: "Merseyside" },
            { name: "Mid Glamorgan" },
            { name: "Middlesbrough" },
            { name: "Milton Keynes" },
            { name: "Monmouthshire" },
            { name: "Moray" },
            { name: "Norfolk" },
            { name: "North East Lincolnshire" },
            { name: "North Lincolnshire" },
            { name: "North Somerset" },
            { name: "North Yorkshire" },
            { name: "Northamptonshire" },
            { name: "Northumberland" },
            { name: "Nottingham" },
            { name: "Nottinghamshire" },
            { name: "Oxfordshire" },
            { name: "Pembrokeshire" },
            { name: "Perth and Kinross" },
            { name: "Peterborough" },
            { name: "Plymouth" },
            { name: "Poole" },
            { name: "Portsmouth" },
            { name: "Powys" },
            { name: "Reading" },
            { name: "Redcar and Cleveland" },
            { name: "Rutland" },
            { name: "Scottish Borders" },
            { name: "Shropshire" },
            { name: "Slough" },
            { name: "Somerset" },
            { name: "South Glamorgan" },
            { name: "South Gloucestershire" },
            { name: "South Yorkshire" },
            { name: "Southampton" },
            { name: "Southend-on-Sea" },
            { name: "Staffordshire" },
            { name: "Stirlingshire" },
            { name: "Stockton-on-Tees" },
            { name: "Stoke-on-Trent" },
            { name: "Strathclyde" },
            { name: "Suffolk" },
            { name: "Surrey" },
            { name: "Swindon" },
            { name: "Telford and Wrekin" },
            { name: "Thurrock" },
            { name: "Torbay" },
            { name: "Tyne and Wear" },
            { name: "Warrington" },
            { name: "Warwickshire" },
            { name: "West Berkshire" },
            { name: "West Glamorgan" },
            { name: "West Lothian" },
            { name: "West Midlands" },
            { name: "West Sussex" },
            { name: "West Yorkshire" },
            { name: "Western Isles" },
            { name: "Wiltshire" },
            { name: "Windsor and Maidenhead" },
            { name: "Wokingham" },
            { name: "Worcestershire" },
            { name: "Wrexham" },
            { name: "York" }
          ]
        },
        provinces: {
          ca: [
            { name: "Alberta", abbreviation: "AB" },
            { name: "British Columbia", abbreviation: "BC" },
            { name: "Manitoba", abbreviation: "MB" },
            { name: "New Brunswick", abbreviation: "NB" },
            { name: "Newfoundland and Labrador", abbreviation: "NL" },
            { name: "Nova Scotia", abbreviation: "NS" },
            { name: "Ontario", abbreviation: "ON" },
            { name: "Prince Edward Island", abbreviation: "PE" },
            { name: "Quebec", abbreviation: "QC" },
            { name: "Saskatchewan", abbreviation: "SK" },
            // The case could be made that the following are not actually provinces
            // since they are technically considered "territories" however they all
            // look the same on an envelope!
            { name: "Northwest Territories", abbreviation: "NT" },
            { name: "Nunavut", abbreviation: "NU" },
            { name: "Yukon", abbreviation: "YT" }
          ],
          it: [
            { name: "Agrigento", abbreviation: "AG", code: 84 },
            { name: "Alessandria", abbreviation: "AL", code: 6 },
            { name: "Ancona", abbreviation: "AN", code: 42 },
            { name: "Aosta", abbreviation: "AO", code: 7 },
            { name: "L'Aquila", abbreviation: "AQ", code: 66 },
            { name: "Arezzo", abbreviation: "AR", code: 51 },
            { name: "Ascoli-Piceno", abbreviation: "AP", code: 44 },
            { name: "Asti", abbreviation: "AT", code: 5 },
            { name: "Avellino", abbreviation: "AV", code: 64 },
            { name: "Bari", abbreviation: "BA", code: 72 },
            { name: "Barletta-Andria-Trani", abbreviation: "BT", code: 72 },
            { name: "Belluno", abbreviation: "BL", code: 25 },
            { name: "Benevento", abbreviation: "BN", code: 62 },
            { name: "Bergamo", abbreviation: "BG", code: 16 },
            { name: "Biella", abbreviation: "BI", code: 96 },
            { name: "Bologna", abbreviation: "BO", code: 37 },
            { name: "Bolzano", abbreviation: "BZ", code: 21 },
            { name: "Brescia", abbreviation: "BS", code: 17 },
            { name: "Brindisi", abbreviation: "BR", code: 74 },
            { name: "Cagliari", abbreviation: "CA", code: 92 },
            { name: "Caltanissetta", abbreviation: "CL", code: 85 },
            { name: "Campobasso", abbreviation: "CB", code: 70 },
            { name: "Carbonia Iglesias", abbreviation: "CI", code: 70 },
            { name: "Caserta", abbreviation: "CE", code: 61 },
            { name: "Catania", abbreviation: "CT", code: 87 },
            { name: "Catanzaro", abbreviation: "CZ", code: 79 },
            { name: "Chieti", abbreviation: "CH", code: 69 },
            { name: "Como", abbreviation: "CO", code: 13 },
            { name: "Cosenza", abbreviation: "CS", code: 78 },
            { name: "Cremona", abbreviation: "CR", code: 19 },
            { name: "Crotone", abbreviation: "KR", code: 101 },
            { name: "Cuneo", abbreviation: "CN", code: 4 },
            { name: "Enna", abbreviation: "EN", code: 86 },
            { name: "Fermo", abbreviation: "FM", code: 86 },
            { name: "Ferrara", abbreviation: "FE", code: 38 },
            { name: "Firenze", abbreviation: "FI", code: 48 },
            { name: "Foggia", abbreviation: "FG", code: 71 },
            { name: "Forli-Cesena", abbreviation: "FC", code: 71 },
            { name: "Frosinone", abbreviation: "FR", code: 60 },
            { name: "Genova", abbreviation: "GE", code: 10 },
            { name: "Gorizia", abbreviation: "GO", code: 31 },
            { name: "Grosseto", abbreviation: "GR", code: 53 },
            { name: "Imperia", abbreviation: "IM", code: 8 },
            { name: "Isernia", abbreviation: "IS", code: 94 },
            { name: "La-Spezia", abbreviation: "SP", code: 66 },
            { name: "Latina", abbreviation: "LT", code: 59 },
            { name: "Lecce", abbreviation: "LE", code: 75 },
            { name: "Lecco", abbreviation: "LC", code: 97 },
            { name: "Livorno", abbreviation: "LI", code: 49 },
            { name: "Lodi", abbreviation: "LO", code: 98 },
            { name: "Lucca", abbreviation: "LU", code: 46 },
            { name: "Macerata", abbreviation: "MC", code: 43 },
            { name: "Mantova", abbreviation: "MN", code: 20 },
            { name: "Massa-Carrara", abbreviation: "MS", code: 45 },
            { name: "Matera", abbreviation: "MT", code: 77 },
            { name: "Medio Campidano", abbreviation: "VS", code: 77 },
            { name: "Messina", abbreviation: "ME", code: 83 },
            { name: "Milano", abbreviation: "MI", code: 15 },
            { name: "Modena", abbreviation: "MO", code: 36 },
            { name: "Monza-Brianza", abbreviation: "MB", code: 36 },
            { name: "Napoli", abbreviation: "NA", code: 63 },
            { name: "Novara", abbreviation: "NO", code: 3 },
            { name: "Nuoro", abbreviation: "NU", code: 91 },
            { name: "Ogliastra", abbreviation: "OG", code: 91 },
            { name: "Olbia Tempio", abbreviation: "OT", code: 91 },
            { name: "Oristano", abbreviation: "OR", code: 95 },
            { name: "Padova", abbreviation: "PD", code: 28 },
            { name: "Palermo", abbreviation: "PA", code: 82 },
            { name: "Parma", abbreviation: "PR", code: 34 },
            { name: "Pavia", abbreviation: "PV", code: 18 },
            { name: "Perugia", abbreviation: "PG", code: 54 },
            { name: "Pesaro-Urbino", abbreviation: "PU", code: 41 },
            { name: "Pescara", abbreviation: "PE", code: 68 },
            { name: "Piacenza", abbreviation: "PC", code: 33 },
            { name: "Pisa", abbreviation: "PI", code: 50 },
            { name: "Pistoia", abbreviation: "PT", code: 47 },
            { name: "Pordenone", abbreviation: "PN", code: 93 },
            { name: "Potenza", abbreviation: "PZ", code: 76 },
            { name: "Prato", abbreviation: "PO", code: 100 },
            { name: "Ragusa", abbreviation: "RG", code: 88 },
            { name: "Ravenna", abbreviation: "RA", code: 39 },
            { name: "Reggio-Calabria", abbreviation: "RC", code: 35 },
            { name: "Reggio-Emilia", abbreviation: "RE", code: 35 },
            { name: "Rieti", abbreviation: "RI", code: 57 },
            { name: "Rimini", abbreviation: "RN", code: 99 },
            { name: "Roma", abbreviation: "Roma", code: 58 },
            { name: "Rovigo", abbreviation: "RO", code: 29 },
            { name: "Salerno", abbreviation: "SA", code: 65 },
            { name: "Sassari", abbreviation: "SS", code: 90 },
            { name: "Savona", abbreviation: "SV", code: 9 },
            { name: "Siena", abbreviation: "SI", code: 52 },
            { name: "Siracusa", abbreviation: "SR", code: 89 },
            { name: "Sondrio", abbreviation: "SO", code: 14 },
            { name: "Taranto", abbreviation: "TA", code: 73 },
            { name: "Teramo", abbreviation: "TE", code: 67 },
            { name: "Terni", abbreviation: "TR", code: 55 },
            { name: "Torino", abbreviation: "TO", code: 1 },
            { name: "Trapani", abbreviation: "TP", code: 81 },
            { name: "Trento", abbreviation: "TN", code: 22 },
            { name: "Treviso", abbreviation: "TV", code: 26 },
            { name: "Trieste", abbreviation: "TS", code: 32 },
            { name: "Udine", abbreviation: "UD", code: 30 },
            { name: "Varese", abbreviation: "VA", code: 12 },
            { name: "Venezia", abbreviation: "VE", code: 27 },
            { name: "Verbania", abbreviation: "VB", code: 27 },
            { name: "Vercelli", abbreviation: "VC", code: 2 },
            { name: "Verona", abbreviation: "VR", code: 23 },
            { name: "Vibo-Valentia", abbreviation: "VV", code: 102 },
            { name: "Vicenza", abbreviation: "VI", code: 24 },
            { name: "Viterbo", abbreviation: "VT", code: 56 }
          ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
          { name: "Afghan" },
          { name: "Albanian" },
          { name: "Algerian" },
          { name: "American" },
          { name: "Andorran" },
          { name: "Angolan" },
          { name: "Antiguans" },
          { name: "Argentinean" },
          { name: "Armenian" },
          { name: "Australian" },
          { name: "Austrian" },
          { name: "Azerbaijani" },
          { name: "Bahami" },
          { name: "Bahraini" },
          { name: "Bangladeshi" },
          { name: "Barbadian" },
          { name: "Barbudans" },
          { name: "Batswana" },
          { name: "Belarusian" },
          { name: "Belgian" },
          { name: "Belizean" },
          { name: "Beninese" },
          { name: "Bhutanese" },
          { name: "Bolivian" },
          { name: "Bosnian" },
          { name: "Brazilian" },
          { name: "British" },
          { name: "Bruneian" },
          { name: "Bulgarian" },
          { name: "Burkinabe" },
          { name: "Burmese" },
          { name: "Burundian" },
          { name: "Cambodian" },
          { name: "Cameroonian" },
          { name: "Canadian" },
          { name: "Cape Verdean" },
          { name: "Central African" },
          { name: "Chadian" },
          { name: "Chilean" },
          { name: "Chinese" },
          { name: "Colombian" },
          { name: "Comoran" },
          { name: "Congolese" },
          { name: "Costa Rican" },
          { name: "Croatian" },
          { name: "Cuban" },
          { name: "Cypriot" },
          { name: "Czech" },
          { name: "Danish" },
          { name: "Djibouti" },
          { name: "Dominican" },
          { name: "Dutch" },
          { name: "East Timorese" },
          { name: "Ecuadorean" },
          { name: "Egyptian" },
          { name: "Emirian" },
          { name: "Equatorial Guinean" },
          { name: "Eritrean" },
          { name: "Estonian" },
          { name: "Ethiopian" },
          { name: "Fijian" },
          { name: "Filipino" },
          { name: "Finnish" },
          { name: "French" },
          { name: "Gabonese" },
          { name: "Gambian" },
          { name: "Georgian" },
          { name: "German" },
          { name: "Ghanaian" },
          { name: "Greek" },
          { name: "Grenadian" },
          { name: "Guatemalan" },
          { name: "Guinea-Bissauan" },
          { name: "Guinean" },
          { name: "Guyanese" },
          { name: "Haitian" },
          { name: "Herzegovinian" },
          { name: "Honduran" },
          { name: "Hungarian" },
          { name: "I-Kiribati" },
          { name: "Icelander" },
          { name: "Indian" },
          { name: "Indonesian" },
          { name: "Iranian" },
          { name: "Iraqi" },
          { name: "Irish" },
          { name: "Israeli" },
          { name: "Italian" },
          { name: "Ivorian" },
          { name: "Jamaican" },
          { name: "Japanese" },
          { name: "Jordanian" },
          { name: "Kazakhstani" },
          { name: "Kenyan" },
          { name: "Kittian and Nevisian" },
          { name: "Kuwaiti" },
          { name: "Kyrgyz" },
          { name: "Laotian" },
          { name: "Latvian" },
          { name: "Lebanese" },
          { name: "Liberian" },
          { name: "Libyan" },
          { name: "Liechtensteiner" },
          { name: "Lithuanian" },
          { name: "Luxembourger" },
          { name: "Macedonian" },
          { name: "Malagasy" },
          { name: "Malawian" },
          { name: "Malaysian" },
          { name: "Maldivan" },
          { name: "Malian" },
          { name: "Maltese" },
          { name: "Marshallese" },
          { name: "Mauritanian" },
          { name: "Mauritian" },
          { name: "Mexican" },
          { name: "Micronesian" },
          { name: "Moldovan" },
          { name: "Monacan" },
          { name: "Mongolian" },
          { name: "Moroccan" },
          { name: "Mosotho" },
          { name: "Motswana" },
          { name: "Mozambican" },
          { name: "Namibian" },
          { name: "Nauruan" },
          { name: "Nepalese" },
          { name: "New Zealander" },
          { name: "Nicaraguan" },
          { name: "Nigerian" },
          { name: "Nigerien" },
          { name: "North Korean" },
          { name: "Northern Irish" },
          { name: "Norwegian" },
          { name: "Omani" },
          { name: "Pakistani" },
          { name: "Palauan" },
          { name: "Panamanian" },
          { name: "Papua New Guinean" },
          { name: "Paraguayan" },
          { name: "Peruvian" },
          { name: "Polish" },
          { name: "Portuguese" },
          { name: "Qatari" },
          { name: "Romani" },
          { name: "Russian" },
          { name: "Rwandan" },
          { name: "Saint Lucian" },
          { name: "Salvadoran" },
          { name: "Samoan" },
          { name: "San Marinese" },
          { name: "Sao Tomean" },
          { name: "Saudi" },
          { name: "Scottish" },
          { name: "Senegalese" },
          { name: "Serbian" },
          { name: "Seychellois" },
          { name: "Sierra Leonean" },
          { name: "Singaporean" },
          { name: "Slovakian" },
          { name: "Slovenian" },
          { name: "Solomon Islander" },
          { name: "Somali" },
          { name: "South African" },
          { name: "South Korean" },
          { name: "Spanish" },
          { name: "Sri Lankan" },
          { name: "Sudanese" },
          { name: "Surinamer" },
          { name: "Swazi" },
          { name: "Swedish" },
          { name: "Swiss" },
          { name: "Syrian" },
          { name: "Taiwanese" },
          { name: "Tajik" },
          { name: "Tanzanian" },
          { name: "Thai" },
          { name: "Togolese" },
          { name: "Tongan" },
          { name: "Trinidadian or Tobagonian" },
          { name: "Tunisian" },
          { name: "Turkish" },
          { name: "Tuvaluan" },
          { name: "Ugandan" },
          { name: "Ukrainian" },
          { name: "Uruguaya" },
          { name: "Uzbekistani" },
          { name: "Venezuela" },
          { name: "Vietnamese" },
          { name: "Wels" },
          { name: "Yemenit" },
          { name: "Zambia" },
          { name: "Zimbabwe" }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
          "aa",
          "ab",
          "ae",
          "af",
          "ak",
          "am",
          "an",
          "ar",
          "as",
          "av",
          "ay",
          "az",
          "ba",
          "be",
          "bg",
          "bh",
          "bi",
          "bm",
          "bn",
          "bo",
          "br",
          "bs",
          "ca",
          "ce",
          "ch",
          "co",
          "cr",
          "cs",
          "cu",
          "cv",
          "cy",
          "da",
          "de",
          "dv",
          "dz",
          "ee",
          "el",
          "en",
          "eo",
          "es",
          "et",
          "eu",
          "fa",
          "ff",
          "fi",
          "fj",
          "fo",
          "fr",
          "fy",
          "ga",
          "gd",
          "gl",
          "gn",
          "gu",
          "gv",
          "ha",
          "he",
          "hi",
          "ho",
          "hr",
          "ht",
          "hu",
          "hy",
          "hz",
          "ia",
          "id",
          "ie",
          "ig",
          "ii",
          "ik",
          "io",
          "is",
          "it",
          "iu",
          "ja",
          "jv",
          "ka",
          "kg",
          "ki",
          "kj",
          "kk",
          "kl",
          "km",
          "kn",
          "ko",
          "kr",
          "ks",
          "ku",
          "kv",
          "kw",
          "ky",
          "la",
          "lb",
          "lg",
          "li",
          "ln",
          "lo",
          "lt",
          "lu",
          "lv",
          "mg",
          "mh",
          "mi",
          "mk",
          "ml",
          "mn",
          "mr",
          "ms",
          "mt",
          "my",
          "na",
          "nb",
          "nd",
          "ne",
          "ng",
          "nl",
          "nn",
          "no",
          "nr",
          "nv",
          "ny",
          "oc",
          "oj",
          "om",
          "or",
          "os",
          "pa",
          "pi",
          "pl",
          "ps",
          "pt",
          "qu",
          "rm",
          "rn",
          "ro",
          "ru",
          "rw",
          "sa",
          "sc",
          "sd",
          "se",
          "sg",
          "si",
          "sk",
          "sl",
          "sm",
          "sn",
          "so",
          "sq",
          "sr",
          "ss",
          "st",
          "su",
          "sv",
          "sw",
          "ta",
          "te",
          "tg",
          "th",
          "ti",
          "tk",
          "tl",
          "tn",
          "to",
          "tr",
          "ts",
          "tt",
          "tw",
          "ty",
          "ug",
          "uk",
          "ur",
          "uz",
          "ve",
          "vi",
          "vo",
          "wa",
          "wo",
          "xh",
          "yi",
          "yo",
          "za",
          "zh",
          "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
          "agq-CM",
          "asa-TZ",
          "ast-ES",
          "bas-CM",
          "bem-ZM",
          "bez-TZ",
          "brx-IN",
          "cgg-UG",
          "chr-US",
          "dav-KE",
          "dje-NE",
          "dsb-DE",
          "dua-CM",
          "dyo-SN",
          "ebu-KE",
          "ewo-CM",
          "fil-PH",
          "fur-IT",
          "gsw-CH",
          "gsw-FR",
          "gsw-LI",
          "guz-KE",
          "haw-US",
          "hsb-DE",
          "jgo-CM",
          "jmc-TZ",
          "kab-DZ",
          "kam-KE",
          "kde-TZ",
          "kea-CV",
          "khq-ML",
          "kkj-CM",
          "kln-KE",
          "kok-IN",
          "ksb-TZ",
          "ksf-CM",
          "ksh-DE",
          "lag-TZ",
          "lkt-US",
          "luo-KE",
          "luy-KE",
          "mas-KE",
          "mas-TZ",
          "mer-KE",
          "mfe-MU",
          "mgh-MZ",
          "mgo-CM",
          "mua-CM",
          "naq-NA",
          "nmg-CM",
          "nnh-CM",
          "nus-SD",
          "nyn-UG",
          "rof-TZ",
          "rwk-TZ",
          "sah-RU",
          "saq-KE",
          "sbp-TZ",
          "seh-MZ",
          "ses-ML",
          "shi-Latn",
          "shi-Latn-MA",
          "shi-Tfng",
          "shi-Tfng-MA",
          "smn-FI",
          "teo-KE",
          "teo-UG",
          "twq-NE",
          "tzm-Latn",
          "tzm-Latn-MA",
          "vai-Latn",
          "vai-Latn-LR",
          "vai-Vaii",
          "vai-Vaii-LR",
          "vun-TZ",
          "wae-CH",
          "xog-UG",
          "yav-CM",
          "zgh-MA",
          "af-NA",
          "af-ZA",
          "ak-GH",
          "am-ET",
          "ar-001",
          "ar-AE",
          "ar-BH",
          "ar-DJ",
          "ar-DZ",
          "ar-EG",
          "ar-EH",
          "ar-ER",
          "ar-IL",
          "ar-IQ",
          "ar-JO",
          "ar-KM",
          "ar-KW",
          "ar-LB",
          "ar-LY",
          "ar-MA",
          "ar-MR",
          "ar-OM",
          "ar-PS",
          "ar-QA",
          "ar-SA",
          "ar-SD",
          "ar-SO",
          "ar-SS",
          "ar-SY",
          "ar-TD",
          "ar-TN",
          "ar-YE",
          "as-IN",
          "az-Cyrl",
          "az-Cyrl-AZ",
          "az-Latn",
          "az-Latn-AZ",
          "be-BY",
          "bg-BG",
          "bm-Latn",
          "bm-Latn-ML",
          "bn-BD",
          "bn-IN",
          "bo-CN",
          "bo-IN",
          "br-FR",
          "bs-Cyrl",
          "bs-Cyrl-BA",
          "bs-Latn",
          "bs-Latn-BA",
          "ca-AD",
          "ca-ES",
          "ca-ES-VALENCIA",
          "ca-FR",
          "ca-IT",
          "cs-CZ",
          "cy-GB",
          "da-DK",
          "da-GL",
          "de-AT",
          "de-BE",
          "de-CH",
          "de-DE",
          "de-LI",
          "de-LU",
          "dz-BT",
          "ee-GH",
          "ee-TG",
          "el-CY",
          "el-GR",
          "en-001",
          "en-150",
          "en-AG",
          "en-AI",
          "en-AS",
          "en-AU",
          "en-BB",
          "en-BE",
          "en-BM",
          "en-BS",
          "en-BW",
          "en-BZ",
          "en-CA",
          "en-CC",
          "en-CK",
          "en-CM",
          "en-CX",
          "en-DG",
          "en-DM",
          "en-ER",
          "en-FJ",
          "en-FK",
          "en-FM",
          "en-GB",
          "en-GD",
          "en-GG",
          "en-GH",
          "en-GI",
          "en-GM",
          "en-GU",
          "en-GY",
          "en-HK",
          "en-IE",
          "en-IM",
          "en-IN",
          "en-IO",
          "en-JE",
          "en-JM",
          "en-KE",
          "en-KI",
          "en-KN",
          "en-KY",
          "en-LC",
          "en-LR",
          "en-LS",
          "en-MG",
          "en-MH",
          "en-MO",
          "en-MP",
          "en-MS",
          "en-MT",
          "en-MU",
          "en-MW",
          "en-MY",
          "en-NA",
          "en-NF",
          "en-NG",
          "en-NR",
          "en-NU",
          "en-NZ",
          "en-PG",
          "en-PH",
          "en-PK",
          "en-PN",
          "en-PR",
          "en-PW",
          "en-RW",
          "en-SB",
          "en-SC",
          "en-SD",
          "en-SG",
          "en-SH",
          "en-SL",
          "en-SS",
          "en-SX",
          "en-SZ",
          "en-TC",
          "en-TK",
          "en-TO",
          "en-TT",
          "en-TV",
          "en-TZ",
          "en-UG",
          "en-UM",
          "en-US",
          "en-US-POSIX",
          "en-VC",
          "en-VG",
          "en-VI",
          "en-VU",
          "en-WS",
          "en-ZA",
          "en-ZM",
          "en-ZW",
          "eo-001",
          "es-419",
          "es-AR",
          "es-BO",
          "es-CL",
          "es-CO",
          "es-CR",
          "es-CU",
          "es-DO",
          "es-EA",
          "es-EC",
          "es-ES",
          "es-GQ",
          "es-GT",
          "es-HN",
          "es-IC",
          "es-MX",
          "es-NI",
          "es-PA",
          "es-PE",
          "es-PH",
          "es-PR",
          "es-PY",
          "es-SV",
          "es-US",
          "es-UY",
          "es-VE",
          "et-EE",
          "eu-ES",
          "fa-AF",
          "fa-IR",
          "ff-CM",
          "ff-GN",
          "ff-MR",
          "ff-SN",
          "fi-FI",
          "fo-FO",
          "fr-BE",
          "fr-BF",
          "fr-BI",
          "fr-BJ",
          "fr-BL",
          "fr-CA",
          "fr-CD",
          "fr-CF",
          "fr-CG",
          "fr-CH",
          "fr-CI",
          "fr-CM",
          "fr-DJ",
          "fr-DZ",
          "fr-FR",
          "fr-GA",
          "fr-GF",
          "fr-GN",
          "fr-GP",
          "fr-GQ",
          "fr-HT",
          "fr-KM",
          "fr-LU",
          "fr-MA",
          "fr-MC",
          "fr-MF",
          "fr-MG",
          "fr-ML",
          "fr-MQ",
          "fr-MR",
          "fr-MU",
          "fr-NC",
          "fr-NE",
          "fr-PF",
          "fr-PM",
          "fr-RE",
          "fr-RW",
          "fr-SC",
          "fr-SN",
          "fr-SY",
          "fr-TD",
          "fr-TG",
          "fr-TN",
          "fr-VU",
          "fr-WF",
          "fr-YT",
          "fy-NL",
          "ga-IE",
          "gd-GB",
          "gl-ES",
          "gu-IN",
          "gv-IM",
          "ha-Latn",
          "ha-Latn-GH",
          "ha-Latn-NE",
          "ha-Latn-NG",
          "he-IL",
          "hi-IN",
          "hr-BA",
          "hr-HR",
          "hu-HU",
          "hy-AM",
          "id-ID",
          "ig-NG",
          "ii-CN",
          "is-IS",
          "it-CH",
          "it-IT",
          "it-SM",
          "ja-JP",
          "ka-GE",
          "ki-KE",
          "kk-Cyrl",
          "kk-Cyrl-KZ",
          "kl-GL",
          "km-KH",
          "kn-IN",
          "ko-KP",
          "ko-KR",
          "ks-Arab",
          "ks-Arab-IN",
          "kw-GB",
          "ky-Cyrl",
          "ky-Cyrl-KG",
          "lb-LU",
          "lg-UG",
          "ln-AO",
          "ln-CD",
          "ln-CF",
          "ln-CG",
          "lo-LA",
          "lt-LT",
          "lu-CD",
          "lv-LV",
          "mg-MG",
          "mk-MK",
          "ml-IN",
          "mn-Cyrl",
          "mn-Cyrl-MN",
          "mr-IN",
          "ms-Latn",
          "ms-Latn-BN",
          "ms-Latn-MY",
          "ms-Latn-SG",
          "mt-MT",
          "my-MM",
          "nb-NO",
          "nb-SJ",
          "nd-ZW",
          "ne-IN",
          "ne-NP",
          "nl-AW",
          "nl-BE",
          "nl-BQ",
          "nl-CW",
          "nl-NL",
          "nl-SR",
          "nl-SX",
          "nn-NO",
          "om-ET",
          "om-KE",
          "or-IN",
          "os-GE",
          "os-RU",
          "pa-Arab",
          "pa-Arab-PK",
          "pa-Guru",
          "pa-Guru-IN",
          "pl-PL",
          "ps-AF",
          "pt-AO",
          "pt-BR",
          "pt-CV",
          "pt-GW",
          "pt-MO",
          "pt-MZ",
          "pt-PT",
          "pt-ST",
          "pt-TL",
          "qu-BO",
          "qu-EC",
          "qu-PE",
          "rm-CH",
          "rn-BI",
          "ro-MD",
          "ro-RO",
          "ru-BY",
          "ru-KG",
          "ru-KZ",
          "ru-MD",
          "ru-RU",
          "ru-UA",
          "rw-RW",
          "se-FI",
          "se-NO",
          "se-SE",
          "sg-CF",
          "si-LK",
          "sk-SK",
          "sl-SI",
          "sn-ZW",
          "so-DJ",
          "so-ET",
          "so-KE",
          "so-SO",
          "sq-AL",
          "sq-MK",
          "sq-XK",
          "sr-Cyrl",
          "sr-Cyrl-BA",
          "sr-Cyrl-ME",
          "sr-Cyrl-RS",
          "sr-Cyrl-XK",
          "sr-Latn",
          "sr-Latn-BA",
          "sr-Latn-ME",
          "sr-Latn-RS",
          "sr-Latn-XK",
          "sv-AX",
          "sv-FI",
          "sv-SE",
          "sw-CD",
          "sw-KE",
          "sw-TZ",
          "sw-UG",
          "ta-IN",
          "ta-LK",
          "ta-MY",
          "ta-SG",
          "te-IN",
          "th-TH",
          "ti-ER",
          "ti-ET",
          "to-TO",
          "tr-CY",
          "tr-TR",
          "ug-Arab",
          "ug-Arab-CN",
          "uk-UA",
          "ur-IN",
          "ur-PK",
          "uz-Arab",
          "uz-Arab-AF",
          "uz-Cyrl",
          "uz-Cyrl-UZ",
          "uz-Latn",
          "uz-Latn-UZ",
          "vi-VN",
          "yi-001",
          "yo-BJ",
          "yo-NG",
          "zh-Hans",
          "zh-Hans-CN",
          "zh-Hans-HK",
          "zh-Hans-MO",
          "zh-Hans-SG",
          "zh-Hant",
          "zh-Hant-HK",
          "zh-Hant-MO",
          "zh-Hant-TW",
          "zu-ZA"
        ],
        us_states_and_dc: [
          { name: "Alabama", abbreviation: "AL" },
          { name: "Alaska", abbreviation: "AK" },
          { name: "Arizona", abbreviation: "AZ" },
          { name: "Arkansas", abbreviation: "AR" },
          { name: "California", abbreviation: "CA" },
          { name: "Colorado", abbreviation: "CO" },
          { name: "Connecticut", abbreviation: "CT" },
          { name: "Delaware", abbreviation: "DE" },
          { name: "District of Columbia", abbreviation: "DC" },
          { name: "Florida", abbreviation: "FL" },
          { name: "Georgia", abbreviation: "GA" },
          { name: "Hawaii", abbreviation: "HI" },
          { name: "Idaho", abbreviation: "ID" },
          { name: "Illinois", abbreviation: "IL" },
          { name: "Indiana", abbreviation: "IN" },
          { name: "Iowa", abbreviation: "IA" },
          { name: "Kansas", abbreviation: "KS" },
          { name: "Kentucky", abbreviation: "KY" },
          { name: "Louisiana", abbreviation: "LA" },
          { name: "Maine", abbreviation: "ME" },
          { name: "Maryland", abbreviation: "MD" },
          { name: "Massachusetts", abbreviation: "MA" },
          { name: "Michigan", abbreviation: "MI" },
          { name: "Minnesota", abbreviation: "MN" },
          { name: "Mississippi", abbreviation: "MS" },
          { name: "Missouri", abbreviation: "MO" },
          { name: "Montana", abbreviation: "MT" },
          { name: "Nebraska", abbreviation: "NE" },
          { name: "Nevada", abbreviation: "NV" },
          { name: "New Hampshire", abbreviation: "NH" },
          { name: "New Jersey", abbreviation: "NJ" },
          { name: "New Mexico", abbreviation: "NM" },
          { name: "New York", abbreviation: "NY" },
          { name: "North Carolina", abbreviation: "NC" },
          { name: "North Dakota", abbreviation: "ND" },
          { name: "Ohio", abbreviation: "OH" },
          { name: "Oklahoma", abbreviation: "OK" },
          { name: "Oregon", abbreviation: "OR" },
          { name: "Pennsylvania", abbreviation: "PA" },
          { name: "Rhode Island", abbreviation: "RI" },
          { name: "South Carolina", abbreviation: "SC" },
          { name: "South Dakota", abbreviation: "SD" },
          { name: "Tennessee", abbreviation: "TN" },
          { name: "Texas", abbreviation: "TX" },
          { name: "Utah", abbreviation: "UT" },
          { name: "Vermont", abbreviation: "VT" },
          { name: "Virginia", abbreviation: "VA" },
          { name: "Washington", abbreviation: "WA" },
          { name: "West Virginia", abbreviation: "WV" },
          { name: "Wisconsin", abbreviation: "WI" },
          { name: "Wyoming", abbreviation: "WY" }
        ],
        territories: [
          { name: "American Samoa", abbreviation: "AS" },
          { name: "Federated States of Micronesia", abbreviation: "FM" },
          { name: "Guam", abbreviation: "GU" },
          { name: "Marshall Islands", abbreviation: "MH" },
          { name: "Northern Mariana Islands", abbreviation: "MP" },
          { name: "Puerto Rico", abbreviation: "PR" },
          { name: "Virgin Islands, U.S.", abbreviation: "VI" }
        ],
        armed_forces: [
          { name: "Armed Forces Europe", abbreviation: "AE" },
          { name: "Armed Forces Pacific", abbreviation: "AP" },
          { name: "Armed Forces the Americas", abbreviation: "AA" }
        ],
        country_regions: {
          it: [
            { name: "Valle d'Aosta", abbreviation: "VDA" },
            { name: "Piemonte", abbreviation: "PIE" },
            { name: "Lombardia", abbreviation: "LOM" },
            { name: "Veneto", abbreviation: "VEN" },
            { name: "Trentino Alto Adige", abbreviation: "TAA" },
            { name: "Friuli Venezia Giulia", abbreviation: "FVG" },
            { name: "Liguria", abbreviation: "LIG" },
            { name: "Emilia Romagna", abbreviation: "EMR" },
            { name: "Toscana", abbreviation: "TOS" },
            { name: "Umbria", abbreviation: "UMB" },
            { name: "Marche", abbreviation: "MAR" },
            { name: "Abruzzo", abbreviation: "ABR" },
            { name: "Lazio", abbreviation: "LAZ" },
            { name: "Campania", abbreviation: "CAM" },
            { name: "Puglia", abbreviation: "PUG" },
            { name: "Basilicata", abbreviation: "BAS" },
            { name: "Molise", abbreviation: "MOL" },
            { name: "Calabria", abbreviation: "CAL" },
            { name: "Sicilia", abbreviation: "SIC" },
            { name: "Sardegna", abbreviation: "SAR" }
          ],
          mx: [
            { name: "Aguascalientes", abbreviation: "AGU" },
            { name: "Baja California", abbreviation: "BCN" },
            { name: "Baja California Sur", abbreviation: "BCS" },
            { name: "Campeche", abbreviation: "CAM" },
            { name: "Chiapas", abbreviation: "CHP" },
            { name: "Chihuahua", abbreviation: "CHH" },
            { name: "Ciudad de México", abbreviation: "DIF" },
            { name: "Coahuila", abbreviation: "COA" },
            { name: "Colima", abbreviation: "COL" },
            { name: "Durango", abbreviation: "DUR" },
            { name: "Guanajuato", abbreviation: "GUA" },
            { name: "Guerrero", abbreviation: "GRO" },
            { name: "Hidalgo", abbreviation: "HID" },
            { name: "Jalisco", abbreviation: "JAL" },
            { name: "México", abbreviation: "MEX" },
            { name: "Michoacán", abbreviation: "MIC" },
            { name: "Morelos", abbreviation: "MOR" },
            { name: "Nayarit", abbreviation: "NAY" },
            { name: "Nuevo León", abbreviation: "NLE" },
            { name: "Oaxaca", abbreviation: "OAX" },
            { name: "Puebla", abbreviation: "PUE" },
            { name: "Querétaro", abbreviation: "QUE" },
            { name: "Quintana Roo", abbreviation: "ROO" },
            { name: "San Luis Potosí", abbreviation: "SLP" },
            { name: "Sinaloa", abbreviation: "SIN" },
            { name: "Sonora", abbreviation: "SON" },
            { name: "Tabasco", abbreviation: "TAB" },
            { name: "Tamaulipas", abbreviation: "TAM" },
            { name: "Tlaxcala", abbreviation: "TLA" },
            { name: "Veracruz", abbreviation: "VER" },
            { name: "Yucatán", abbreviation: "YUC" },
            { name: "Zacatecas", abbreviation: "ZAC" }
          ]
        },
        street_suffixes: {
          us: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Boulevard", abbreviation: "Blvd" },
            { name: "Center", abbreviation: "Ctr" },
            { name: "Circle", abbreviation: "Cir" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Extension", abbreviation: "Ext" },
            { name: "Glen", abbreviation: "Gln" },
            { name: "Grove", abbreviation: "Grv" },
            { name: "Heights", abbreviation: "Hts" },
            { name: "Highway", abbreviation: "Hwy" },
            { name: "Junction", abbreviation: "Jct" },
            { name: "Key", abbreviation: "Key" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Loop", abbreviation: "Loop" },
            { name: "Manor", abbreviation: "Mnr" },
            { name: "Mill", abbreviation: "Mill" },
            { name: "Park", abbreviation: "Park" },
            { name: "Parkway", abbreviation: "Pkwy" },
            { name: "Pass", abbreviation: "Pass" },
            { name: "Path", abbreviation: "Path" },
            { name: "Pike", abbreviation: "Pike" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Plaza", abbreviation: "Plz" },
            { name: "Point", abbreviation: "Pt" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "River", abbreviation: "Riv" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Trail", abbreviation: "Trl" },
            { name: "Turnpike", abbreviation: "Tpke" },
            { name: "View", abbreviation: "Vw" },
            { name: "Way", abbreviation: "Way" }
          ],
          it: [
            { name: "Accesso", abbreviation: "Acc." },
            { name: "Alzaia", abbreviation: "Alz." },
            { name: "Arco", abbreviation: "Arco" },
            { name: "Archivolto", abbreviation: "Acv." },
            { name: "Arena", abbreviation: "Arena" },
            { name: "Argine", abbreviation: "Argine" },
            { name: "Bacino", abbreviation: "Bacino" },
            { name: "Banchi", abbreviation: "Banchi" },
            { name: "Banchina", abbreviation: "Ban." },
            { name: "Bastioni", abbreviation: "Bas." },
            { name: "Belvedere", abbreviation: "Belv." },
            { name: "Borgata", abbreviation: "B.ta" },
            { name: "Borgo", abbreviation: "B.go" },
            { name: "Calata", abbreviation: "Cal." },
            { name: "Calle", abbreviation: "Calle" },
            { name: "Campiello", abbreviation: "Cam." },
            { name: "Campo", abbreviation: "Cam." },
            { name: "Canale", abbreviation: "Can." },
            { name: "Carraia", abbreviation: "Carr." },
            { name: "Cascina", abbreviation: "Cascina" },
            { name: "Case sparse", abbreviation: "c.s." },
            { name: "Cavalcavia", abbreviation: "Cv." },
            { name: "Circonvallazione", abbreviation: "Cv." },
            { name: "Complanare", abbreviation: "C.re" },
            { name: "Contrada", abbreviation: "C.da" },
            { name: "Corso", abbreviation: "C.so" },
            { name: "Corte", abbreviation: "C.te" },
            { name: "Cortile", abbreviation: "C.le" },
            { name: "Diramazione", abbreviation: "Dir." },
            { name: "Fondaco", abbreviation: "F.co" },
            { name: "Fondamenta", abbreviation: "F.ta" },
            { name: "Fondo", abbreviation: "F.do" },
            { name: "Frazione", abbreviation: "Fr." },
            { name: "Isola", abbreviation: "Is." },
            { name: "Largo", abbreviation: "L.go" },
            { name: "Litoranea", abbreviation: "Lit." },
            { name: "Lungolago", abbreviation: "L.go lago" },
            { name: "Lungo Po", abbreviation: "l.go Po" },
            { name: "Molo", abbreviation: "Molo" },
            { name: "Mura", abbreviation: "Mura" },
            { name: "Passaggio privato", abbreviation: "pass. priv." },
            { name: "Passeggiata", abbreviation: "Pass." },
            { name: "Piazza", abbreviation: "P.zza" },
            { name: "Piazzale", abbreviation: "P.le" },
            { name: "Ponte", abbreviation: "P.te" },
            { name: "Portico", abbreviation: "P.co" },
            { name: "Rampa", abbreviation: "Rampa" },
            { name: "Regione", abbreviation: "Reg." },
            { name: "Rione", abbreviation: "R.ne" },
            { name: "Rio", abbreviation: "Rio" },
            { name: "Ripa", abbreviation: "Ripa" },
            { name: "Riva", abbreviation: "Riva" },
            { name: "Rondò", abbreviation: "Rondò" },
            { name: "Rotonda", abbreviation: "Rot." },
            { name: "Sagrato", abbreviation: "Sagr." },
            { name: "Salita", abbreviation: "Sal." },
            { name: "Scalinata", abbreviation: "Scal." },
            { name: "Scalone", abbreviation: "Scal." },
            { name: "Slargo", abbreviation: "Sl." },
            { name: "Sottoportico", abbreviation: "Sott." },
            { name: "Strada", abbreviation: "Str." },
            { name: "Stradale", abbreviation: "Str.le" },
            { name: "Strettoia", abbreviation: "Strett." },
            { name: "Traversa", abbreviation: "Trav." },
            { name: "Via", abbreviation: "V." },
            { name: "Viale", abbreviation: "V.le" },
            { name: "Vicinale", abbreviation: "Vic.le" },
            { name: "Vicolo", abbreviation: "Vic." }
          ],
          uk: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Close", abbreviation: "Cl" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Crescent", abbreviation: "Cr" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Garden", abbreviation: "Gdn" },
            { name: "Gardens", abbreviation: "Gdns" },
            { name: "Green", abbreviation: "Gn" },
            { name: "Grove", abbreviation: "Gr" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Mount", abbreviation: "Mt" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Park", abbreviation: "Pk" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Valley", abbreviation: "Val" }
          ]
        },
        months: [
          { name: "January", short_name: "Jan", numeric: "01", days: 31 },
          // Not messing with leap years...
          { name: "February", short_name: "Feb", numeric: "02", days: 28 },
          { name: "March", short_name: "Mar", numeric: "03", days: 31 },
          { name: "April", short_name: "Apr", numeric: "04", days: 30 },
          { name: "May", short_name: "May", numeric: "05", days: 31 },
          { name: "June", short_name: "Jun", numeric: "06", days: 30 },
          { name: "July", short_name: "Jul", numeric: "07", days: 31 },
          { name: "August", short_name: "Aug", numeric: "08", days: 31 },
          { name: "September", short_name: "Sep", numeric: "09", days: 30 },
          { name: "October", short_name: "Oct", numeric: "10", days: 31 },
          { name: "November", short_name: "Nov", numeric: "11", days: 30 },
          { name: "December", short_name: "Dec", numeric: "12", days: 31 }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
          { name: "American Express", short_name: "amex", prefix: "34", length: 15 },
          { name: "Bankcard", short_name: "bankcard", prefix: "5610", length: 16 },
          { name: "China UnionPay", short_name: "chinaunion", prefix: "62", length: 16 },
          { name: "Diners Club Carte Blanche", short_name: "dccarte", prefix: "300", length: 14 },
          { name: "Diners Club enRoute", short_name: "dcenroute", prefix: "2014", length: 15 },
          { name: "Diners Club International", short_name: "dcintl", prefix: "36", length: 14 },
          { name: "Diners Club United States & Canada", short_name: "dcusc", prefix: "54", length: 16 },
          { name: "Discover Card", short_name: "discover", prefix: "6011", length: 16 },
          { name: "InstaPayment", short_name: "instapay", prefix: "637", length: 16 },
          { name: "JCB", short_name: "jcb", prefix: "3528", length: 16 },
          { name: "Laser", short_name: "laser", prefix: "6304", length: 16 },
          { name: "Maestro", short_name: "maestro", prefix: "5018", length: 16 },
          { name: "Mastercard", short_name: "mc", prefix: "51", length: 16 },
          { name: "Solo", short_name: "solo", prefix: "6334", length: 16 },
          { name: "Switch", short_name: "switch", prefix: "4903", length: 16 },
          { name: "Visa", short_name: "visa", prefix: "4", length: 16 },
          { name: "Visa Electron", short_name: "electron", prefix: "4026", length: 16 }
        ],
        //return all world currency by ISO 4217
        currency_types: [
          { code: "AED", name: "United Arab Emirates Dirham" },
          { code: "AFN", name: "Afghanistan Afghani" },
          { code: "ALL", name: "Albania Lek" },
          { code: "AMD", name: "Armenia Dram" },
          { code: "ANG", name: "Netherlands Antilles Guilder" },
          { code: "AOA", name: "Angola Kwanza" },
          { code: "ARS", name: "Argentina Peso" },
          { code: "AUD", name: "Australia Dollar" },
          { code: "AWG", name: "Aruba Guilder" },
          { code: "AZN", name: "Azerbaijan New Manat" },
          { code: "BAM", name: "Bosnia and Herzegovina Convertible Marka" },
          { code: "BBD", name: "Barbados Dollar" },
          { code: "BDT", name: "Bangladesh Taka" },
          { code: "BGN", name: "Bulgaria Lev" },
          { code: "BHD", name: "Bahrain Dinar" },
          { code: "BIF", name: "Burundi Franc" },
          { code: "BMD", name: "Bermuda Dollar" },
          { code: "BND", name: "Brunei Darussalam Dollar" },
          { code: "BOB", name: "Bolivia Boliviano" },
          { code: "BRL", name: "Brazil Real" },
          { code: "BSD", name: "Bahamas Dollar" },
          { code: "BTN", name: "Bhutan Ngultrum" },
          { code: "BWP", name: "Botswana Pula" },
          { code: "BYR", name: "Belarus Ruble" },
          { code: "BZD", name: "Belize Dollar" },
          { code: "CAD", name: "Canada Dollar" },
          { code: "CDF", name: "Congo/Kinshasa Franc" },
          { code: "CHF", name: "Switzerland Franc" },
          { code: "CLP", name: "Chile Peso" },
          { code: "CNY", name: "China Yuan Renminbi" },
          { code: "COP", name: "Colombia Peso" },
          { code: "CRC", name: "Costa Rica Colon" },
          { code: "CUC", name: "Cuba Convertible Peso" },
          { code: "CUP", name: "Cuba Peso" },
          { code: "CVE", name: "Cape Verde Escudo" },
          { code: "CZK", name: "Czech Republic Koruna" },
          { code: "DJF", name: "Djibouti Franc" },
          { code: "DKK", name: "Denmark Krone" },
          { code: "DOP", name: "Dominican Republic Peso" },
          { code: "DZD", name: "Algeria Dinar" },
          { code: "EGP", name: "Egypt Pound" },
          { code: "ERN", name: "Eritrea Nakfa" },
          { code: "ETB", name: "Ethiopia Birr" },
          { code: "EUR", name: "Euro Member Countries" },
          { code: "FJD", name: "Fiji Dollar" },
          { code: "FKP", name: "Falkland Islands (Malvinas) Pound" },
          { code: "GBP", name: "United Kingdom Pound" },
          { code: "GEL", name: "Georgia Lari" },
          { code: "GGP", name: "Guernsey Pound" },
          { code: "GHS", name: "Ghana Cedi" },
          { code: "GIP", name: "Gibraltar Pound" },
          { code: "GMD", name: "Gambia Dalasi" },
          { code: "GNF", name: "Guinea Franc" },
          { code: "GTQ", name: "Guatemala Quetzal" },
          { code: "GYD", name: "Guyana Dollar" },
          { code: "HKD", name: "Hong Kong Dollar" },
          { code: "HNL", name: "Honduras Lempira" },
          { code: "HRK", name: "Croatia Kuna" },
          { code: "HTG", name: "Haiti Gourde" },
          { code: "HUF", name: "Hungary Forint" },
          { code: "IDR", name: "Indonesia Rupiah" },
          { code: "ILS", name: "Israel Shekel" },
          { code: "IMP", name: "Isle of Man Pound" },
          { code: "INR", name: "India Rupee" },
          { code: "IQD", name: "Iraq Dinar" },
          { code: "IRR", name: "Iran Rial" },
          { code: "ISK", name: "Iceland Krona" },
          { code: "JEP", name: "Jersey Pound" },
          { code: "JMD", name: "Jamaica Dollar" },
          { code: "JOD", name: "Jordan Dinar" },
          { code: "JPY", name: "Japan Yen" },
          { code: "KES", name: "Kenya Shilling" },
          { code: "KGS", name: "Kyrgyzstan Som" },
          { code: "KHR", name: "Cambodia Riel" },
          { code: "KMF", name: "Comoros Franc" },
          { code: "KPW", name: "Korea (North) Won" },
          { code: "KRW", name: "Korea (South) Won" },
          { code: "KWD", name: "Kuwait Dinar" },
          { code: "KYD", name: "Cayman Islands Dollar" },
          { code: "KZT", name: "Kazakhstan Tenge" },
          { code: "LAK", name: "Laos Kip" },
          { code: "LBP", name: "Lebanon Pound" },
          { code: "LKR", name: "Sri Lanka Rupee" },
          { code: "LRD", name: "Liberia Dollar" },
          { code: "LSL", name: "Lesotho Loti" },
          { code: "LTL", name: "Lithuania Litas" },
          { code: "LYD", name: "Libya Dinar" },
          { code: "MAD", name: "Morocco Dirham" },
          { code: "MDL", name: "Moldova Leu" },
          { code: "MGA", name: "Madagascar Ariary" },
          { code: "MKD", name: "Macedonia Denar" },
          { code: "MMK", name: "Myanmar (Burma) Kyat" },
          { code: "MNT", name: "Mongolia Tughrik" },
          { code: "MOP", name: "Macau Pataca" },
          { code: "MRO", name: "Mauritania Ouguiya" },
          { code: "MUR", name: "Mauritius Rupee" },
          { code: "MVR", name: "Maldives (Maldive Islands) Rufiyaa" },
          { code: "MWK", name: "Malawi Kwacha" },
          { code: "MXN", name: "Mexico Peso" },
          { code: "MYR", name: "Malaysia Ringgit" },
          { code: "MZN", name: "Mozambique Metical" },
          { code: "NAD", name: "Namibia Dollar" },
          { code: "NGN", name: "Nigeria Naira" },
          { code: "NIO", name: "Nicaragua Cordoba" },
          { code: "NOK", name: "Norway Krone" },
          { code: "NPR", name: "Nepal Rupee" },
          { code: "NZD", name: "New Zealand Dollar" },
          { code: "OMR", name: "Oman Rial" },
          { code: "PAB", name: "Panama Balboa" },
          { code: "PEN", name: "Peru Nuevo Sol" },
          { code: "PGK", name: "Papua New Guinea Kina" },
          { code: "PHP", name: "Philippines Peso" },
          { code: "PKR", name: "Pakistan Rupee" },
          { code: "PLN", name: "Poland Zloty" },
          { code: "PYG", name: "Paraguay Guarani" },
          { code: "QAR", name: "Qatar Riyal" },
          { code: "RON", name: "Romania New Leu" },
          { code: "RSD", name: "Serbia Dinar" },
          { code: "RUB", name: "Russia Ruble" },
          { code: "RWF", name: "Rwanda Franc" },
          { code: "SAR", name: "Saudi Arabia Riyal" },
          { code: "SBD", name: "Solomon Islands Dollar" },
          { code: "SCR", name: "Seychelles Rupee" },
          { code: "SDG", name: "Sudan Pound" },
          { code: "SEK", name: "Sweden Krona" },
          { code: "SGD", name: "Singapore Dollar" },
          { code: "SHP", name: "Saint Helena Pound" },
          { code: "SLL", name: "Sierra Leone Leone" },
          { code: "SOS", name: "Somalia Shilling" },
          { code: "SPL", name: "Seborga Luigino" },
          { code: "SRD", name: "Suriname Dollar" },
          { code: "STD", name: "São Tomé and Príncipe Dobra" },
          { code: "SVC", name: "El Salvador Colon" },
          { code: "SYP", name: "Syria Pound" },
          { code: "SZL", name: "Swaziland Lilangeni" },
          { code: "THB", name: "Thailand Baht" },
          { code: "TJS", name: "Tajikistan Somoni" },
          { code: "TMT", name: "Turkmenistan Manat" },
          { code: "TND", name: "Tunisia Dinar" },
          { code: "TOP", name: "Tonga Pa'anga" },
          { code: "TRY", name: "Turkey Lira" },
          { code: "TTD", name: "Trinidad and Tobago Dollar" },
          { code: "TVD", name: "Tuvalu Dollar" },
          { code: "TWD", name: "Taiwan New Dollar" },
          { code: "TZS", name: "Tanzania Shilling" },
          { code: "UAH", name: "Ukraine Hryvnia" },
          { code: "UGX", name: "Uganda Shilling" },
          { code: "USD", name: "United States Dollar" },
          { code: "UYU", name: "Uruguay Peso" },
          { code: "UZS", name: "Uzbekistan Som" },
          { code: "VEF", name: "Venezuela Bolivar" },
          { code: "VND", name: "Viet Nam Dong" },
          { code: "VUV", name: "Vanuatu Vatu" },
          { code: "WST", name: "Samoa Tala" },
          { code: "XAF", name: "Communauté Financière Africaine (BEAC) CFA Franc BEAC" },
          { code: "XCD", name: "East Caribbean Dollar" },
          { code: "XDR", name: "International Monetary Fund (IMF) Special Drawing Rights" },
          { code: "XOF", name: "Communauté Financière Africaine (BCEAO) Franc" },
          { code: "XPF", name: "Comptoirs Français du Pacifique (CFP) Franc" },
          { code: "YER", name: "Yemen Rial" },
          { code: "ZAR", name: "South Africa Rand" },
          { code: "ZMW", name: "Zambia Kwacha" },
          { code: "ZWD", name: "Zimbabwe Dollar" }
        ],
        // return the names of all valide colors
        colorNames: [
          "AliceBlue",
          "Black",
          "Navy",
          "DarkBlue",
          "MediumBlue",
          "Blue",
          "DarkGreen",
          "Green",
          "Teal",
          "DarkCyan",
          "DeepSkyBlue",
          "DarkTurquoise",
          "MediumSpringGreen",
          "Lime",
          "SpringGreen",
          "Aqua",
          "Cyan",
          "MidnightBlue",
          "DodgerBlue",
          "LightSeaGreen",
          "ForestGreen",
          "SeaGreen",
          "DarkSlateGray",
          "LimeGreen",
          "MediumSeaGreen",
          "Turquoise",
          "RoyalBlue",
          "SteelBlue",
          "DarkSlateBlue",
          "MediumTurquoise",
          "Indigo",
          "DarkOliveGreen",
          "CadetBlue",
          "CornflowerBlue",
          "RebeccaPurple",
          "MediumAquaMarine",
          "DimGray",
          "SlateBlue",
          "OliveDrab",
          "SlateGray",
          "LightSlateGray",
          "MediumSlateBlue",
          "LawnGreen",
          "Chartreuse",
          "Aquamarine",
          "Maroon",
          "Purple",
          "Olive",
          "Gray",
          "SkyBlue",
          "LightSkyBlue",
          "BlueViolet",
          "DarkRed",
          "DarkMagenta",
          "SaddleBrown",
          "Ivory",
          "White",
          "DarkSeaGreen",
          "LightGreen",
          "MediumPurple",
          "DarkViolet",
          "PaleGreen",
          "DarkOrchid",
          "YellowGreen",
          "Sienna",
          "Brown",
          "DarkGray",
          "LightBlue",
          "GreenYellow",
          "PaleTurquoise",
          "LightSteelBlue",
          "PowderBlue",
          "FireBrick",
          "DarkGoldenRod",
          "MediumOrchid",
          "RosyBrown",
          "DarkKhaki",
          "Silver",
          "MediumVioletRed",
          "IndianRed",
          "Peru",
          "Chocolate",
          "Tan",
          "LightGray",
          "Thistle",
          "Orchid",
          "GoldenRod",
          "PaleVioletRed",
          "Crimson",
          "Gainsboro",
          "Plum",
          "BurlyWood",
          "LightCyan",
          "Lavender",
          "DarkSalmon",
          "Violet",
          "PaleGoldenRod",
          "LightCoral",
          "Khaki",
          "AliceBlue",
          "HoneyDew",
          "Azure",
          "SandyBrown",
          "Wheat",
          "Beige",
          "WhiteSmoke",
          "MintCream",
          "GhostWhite",
          "Salmon",
          "AntiqueWhite",
          "Linen",
          "LightGoldenRodYellow",
          "OldLace",
          "Red",
          "Fuchsia",
          "Magenta",
          "DeepPink",
          "OrangeRed",
          "Tomato",
          "HotPink",
          "Coral",
          "DarkOrange",
          "LightSalmon",
          "Orange",
          "LightPink",
          "Pink",
          "Gold",
          "PeachPuff",
          "NavajoWhite",
          "Moccasin",
          "Bisque",
          "MistyRose",
          "BlanchedAlmond",
          "PapayaWhip",
          "LavenderBlush",
          "SeaShell",
          "Cornsilk",
          "LemonChiffon",
          "FloralWhite",
          "Snow",
          "Yellow",
          "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
          "3Com Corp",
          "3M Company",
          "A.G. Edwards Inc.",
          "Abbott Laboratories",
          "Abercrombie & Fitch Co.",
          "ABM Industries Incorporated",
          "Ace Hardware Corporation",
          "ACT Manufacturing Inc.",
          "Acterna Corp.",
          "Adams Resources & Energy, Inc.",
          "ADC Telecommunications, Inc.",
          "Adelphia Communications Corporation",
          "Administaff, Inc.",
          "Adobe Systems Incorporated",
          "Adolph Coors Company",
          "Advance Auto Parts, Inc.",
          "Advanced Micro Devices, Inc.",
          "AdvancePCS, Inc.",
          "Advantica Restaurant Group, Inc.",
          "The AES Corporation",
          "Aetna Inc.",
          "Affiliated Computer Services, Inc.",
          "AFLAC Incorporated",
          "AGCO Corporation",
          "Agilent Technologies, Inc.",
          "Agway Inc.",
          "Apartment Investment and Management Company",
          "Air Products and Chemicals, Inc.",
          "Airborne, Inc.",
          "Airgas, Inc.",
          "AK Steel Holding Corporation",
          "Alaska Air Group, Inc.",
          "Alberto-Culver Company",
          "Albertson's, Inc.",
          "Alcoa Inc.",
          "Alleghany Corporation",
          "Allegheny Energy, Inc.",
          "Allegheny Technologies Incorporated",
          "Allergan, Inc.",
          "ALLETE, Inc.",
          "Alliant Energy Corporation",
          "Allied Waste Industries, Inc.",
          "Allmerica Financial Corporation",
          "The Allstate Corporation",
          "ALLTEL Corporation",
          "The Alpine Group, Inc.",
          "Amazon.com, Inc.",
          "AMC Entertainment Inc.",
          "American Power Conversion Corporation",
          "Amerada Hess Corporation",
          "AMERCO",
          "Ameren Corporation",
          "America West Holdings Corporation",
          "American Axle & Manufacturing Holdings, Inc.",
          "American Eagle Outfitters, Inc.",
          "American Electric Power Company, Inc.",
          "American Express Company",
          "American Financial Group, Inc.",
          "American Greetings Corporation",
          "American International Group, Inc.",
          "American Standard Companies Inc.",
          "American Water Works Company, Inc.",
          "AmerisourceBergen Corporation",
          "Ames Department Stores, Inc.",
          "Amgen Inc.",
          "Amkor Technology, Inc.",
          "AMR Corporation",
          "AmSouth Bancorp.",
          "Amtran, Inc.",
          "Anadarko Petroleum Corporation",
          "Analog Devices, Inc.",
          "Anheuser-Busch Companies, Inc.",
          "Anixter International Inc.",
          "AnnTaylor Inc.",
          "Anthem, Inc.",
          "AOL Time Warner Inc.",
          "Aon Corporation",
          "Apache Corporation",
          "Apple Computer, Inc.",
          "Applera Corporation",
          "Applied Industrial Technologies, Inc.",
          "Applied Materials, Inc.",
          "Aquila, Inc.",
          "ARAMARK Corporation",
          "Arch Coal, Inc.",
          "Archer Daniels Midland Company",
          "Arkansas Best Corporation",
          "Armstrong Holdings, Inc.",
          "Arrow Electronics, Inc.",
          "ArvinMeritor, Inc.",
          "Ashland Inc.",
          "Astoria Financial Corporation",
          "AT&T Corp.",
          "Atmel Corporation",
          "Atmos Energy Corporation",
          "Audiovox Corporation",
          "Autoliv, Inc.",
          "Automatic Data Processing, Inc.",
          "AutoNation, Inc.",
          "AutoZone, Inc.",
          "Avaya Inc.",
          "Avery Dennison Corporation",
          "Avista Corporation",
          "Avnet, Inc.",
          "Avon Products, Inc.",
          "Baker Hughes Incorporated",
          "Ball Corporation",
          "Bank of America Corporation",
          "The Bank of New York Company, Inc.",
          "Bank One Corporation",
          "Banknorth Group, Inc.",
          "Banta Corporation",
          "Barnes & Noble, Inc.",
          "Bausch & Lomb Incorporated",
          "Baxter International Inc.",
          "BB&T Corporation",
          "The Bear Stearns Companies Inc.",
          "Beazer Homes USA, Inc.",
          "Beckman Coulter, Inc.",
          "Becton, Dickinson and Company",
          "Bed Bath & Beyond Inc.",
          "Belk, Inc.",
          "Bell Microproducts Inc.",
          "BellSouth Corporation",
          "Belo Corp.",
          "Bemis Company, Inc.",
          "Benchmark Electronics, Inc.",
          "Berkshire Hathaway Inc.",
          "Best Buy Co., Inc.",
          "Bethlehem Steel Corporation",
          "Beverly Enterprises, Inc.",
          "Big Lots, Inc.",
          "BJ Services Company",
          "BJ's Wholesale Club, Inc.",
          "The Black & Decker Corporation",
          "Black Hills Corporation",
          "BMC Software, Inc.",
          "The Boeing Company",
          "Boise Cascade Corporation",
          "Borders Group, Inc.",
          "BorgWarner Inc.",
          "Boston Scientific Corporation",
          "Bowater Incorporated",
          "Briggs & Stratton Corporation",
          "Brightpoint, Inc.",
          "Brinker International, Inc.",
          "Bristol-Myers Squibb Company",
          "Broadwing, Inc.",
          "Brown Shoe Company, Inc.",
          "Brown-Forman Corporation",
          "Brunswick Corporation",
          "Budget Group, Inc.",
          "Burlington Coat Factory Warehouse Corporation",
          "Burlington Industries, Inc.",
          "Burlington Northern Santa Fe Corporation",
          "Burlington Resources Inc.",
          "C. H. Robinson Worldwide Inc.",
          "Cablevision Systems Corp",
          "Cabot Corp",
          "Cadence Design Systems, Inc.",
          "Calpine Corp.",
          "Campbell Soup Co.",
          "Capital One Financial Corp.",
          "Cardinal Health Inc.",
          "Caremark Rx Inc.",
          "Carlisle Cos. Inc.",
          "Carpenter Technology Corp.",
          "Casey's General Stores Inc.",
          "Caterpillar Inc.",
          "CBRL Group Inc.",
          "CDI Corp.",
          "CDW Computer Centers Inc.",
          "CellStar Corp.",
          "Cendant Corp",
          "Cenex Harvest States Cooperatives",
          "Centex Corp.",
          "CenturyTel Inc.",
          "Ceridian Corp.",
          "CH2M Hill Cos. Ltd.",
          "Champion Enterprises Inc.",
          "Charles Schwab Corp.",
          "Charming Shoppes Inc.",
          "Charter Communications Inc.",
          "Charter One Financial Inc.",
          "ChevronTexaco Corp.",
          "Chiquita Brands International Inc.",
          "Chubb Corp",
          "Ciena Corp.",
          "Cigna Corp",
          "Cincinnati Financial Corp.",
          "Cinergy Corp.",
          "Cintas Corp.",
          "Circuit City Stores Inc.",
          "Cisco Systems Inc.",
          "Citigroup, Inc",
          "Citizens Communications Co.",
          "CKE Restaurants Inc.",
          "Clear Channel Communications Inc.",
          "The Clorox Co.",
          "CMGI Inc.",
          "CMS Energy Corp.",
          "CNF Inc.",
          "Coca-Cola Co.",
          "Coca-Cola Enterprises Inc.",
          "Colgate-Palmolive Co.",
          "Collins & Aikman Corp.",
          "Comcast Corp.",
          "Comdisco Inc.",
          "Comerica Inc.",
          "Comfort Systems USA Inc.",
          "Commercial Metals Co.",
          "Community Health Systems Inc.",
          "Compass Bancshares Inc",
          "Computer Associates International Inc.",
          "Computer Sciences Corp.",
          "Compuware Corp.",
          "Comverse Technology Inc.",
          "ConAgra Foods Inc.",
          "Concord EFS Inc.",
          "Conectiv, Inc",
          "Conoco Inc",
          "Conseco Inc.",
          "Consolidated Freightways Corp.",
          "Consolidated Edison Inc.",
          "Constellation Brands Inc.",
          "Constellation Emergy Group Inc.",
          "Continental Airlines Inc.",
          "Convergys Corp.",
          "Cooper Cameron Corp.",
          "Cooper Industries Ltd.",
          "Cooper Tire & Rubber Co.",
          "Corn Products International Inc.",
          "Corning Inc.",
          "Costco Wholesale Corp.",
          "Countrywide Credit Industries Inc.",
          "Coventry Health Care Inc.",
          "Cox Communications Inc.",
          "Crane Co.",
          "Crompton Corp.",
          "Crown Cork & Seal Co. Inc.",
          "CSK Auto Corp.",
          "CSX Corp.",
          "Cummins Inc.",
          "CVS Corp.",
          "Cytec Industries Inc.",
          "D&K Healthcare Resources, Inc.",
          "D.R. Horton Inc.",
          "Dana Corporation",
          "Danaher Corporation",
          "Darden Restaurants Inc.",
          "DaVita Inc.",
          "Dean Foods Company",
          "Deere & Company",
          "Del Monte Foods Co",
          "Dell Computer Corporation",
          "Delphi Corp.",
          "Delta Air Lines Inc.",
          "Deluxe Corporation",
          "Devon Energy Corporation",
          "Di Giorgio Corporation",
          "Dial Corporation",
          "Diebold Incorporated",
          "Dillard's Inc.",
          "DIMON Incorporated",
          "Dole Food Company, Inc.",
          "Dollar General Corporation",
          "Dollar Tree Stores, Inc.",
          "Dominion Resources, Inc.",
          "Domino's Pizza LLC",
          "Dover Corporation, Inc.",
          "Dow Chemical Company",
          "Dow Jones & Company, Inc.",
          "DPL Inc.",
          "DQE Inc.",
          "Dreyer's Grand Ice Cream, Inc.",
          "DST Systems, Inc.",
          "DTE Energy Co.",
          "E.I. Du Pont de Nemours and Company",
          "Duke Energy Corp",
          "Dun & Bradstreet Inc.",
          "DURA Automotive Systems Inc.",
          "DynCorp",
          "Dynegy Inc.",
          "E*Trade Group, Inc.",
          "E.W. Scripps Company",
          "Earthlink, Inc.",
          "Eastman Chemical Company",
          "Eastman Kodak Company",
          "Eaton Corporation",
          "Echostar Communications Corporation",
          "Ecolab Inc.",
          "Edison International",
          "EGL Inc.",
          "El Paso Corporation",
          "Electronic Arts Inc.",
          "Electronic Data Systems Corp.",
          "Eli Lilly and Company",
          "EMC Corporation",
          "Emcor Group Inc.",
          "Emerson Electric Co.",
          "Encompass Services Corporation",
          "Energizer Holdings Inc.",
          "Energy East Corporation",
          "Engelhard Corporation",
          "Enron Corp.",
          "Entergy Corporation",
          "Enterprise Products Partners L.P.",
          "EOG Resources, Inc.",
          "Equifax Inc.",
          "Equitable Resources Inc.",
          "Equity Office Properties Trust",
          "Equity Residential Properties Trust",
          "Estee Lauder Companies Inc.",
          "Exelon Corporation",
          "Exide Technologies",
          "Expeditors International of Washington Inc.",
          "Express Scripts Inc.",
          "ExxonMobil Corporation",
          "Fairchild Semiconductor International Inc.",
          "Family Dollar Stores Inc.",
          "Farmland Industries Inc.",
          "Federal Mogul Corp.",
          "Federated Department Stores Inc.",
          "Federal Express Corp.",
          "Felcor Lodging Trust Inc.",
          "Ferro Corp.",
          "Fidelity National Financial Inc.",
          "Fifth Third Bancorp",
          "First American Financial Corp.",
          "First Data Corp.",
          "First National of Nebraska Inc.",
          "First Tennessee National Corp.",
          "FirstEnergy Corp.",
          "Fiserv Inc.",
          "Fisher Scientific International Inc.",
          "FleetBoston Financial Co.",
          "Fleetwood Enterprises Inc.",
          "Fleming Companies Inc.",
          "Flowers Foods Inc.",
          "Flowserv Corp",
          "Fluor Corp",
          "FMC Corp",
          "Foamex International Inc",
          "Foot Locker Inc",
          "Footstar Inc.",
          "Ford Motor Co",
          "Forest Laboratories Inc.",
          "Fortune Brands Inc.",
          "Foster Wheeler Ltd.",
          "FPL Group Inc.",
          "Franklin Resources Inc.",
          "Freeport McMoran Copper & Gold Inc.",
          "Frontier Oil Corp",
          "Furniture Brands International Inc.",
          "Gannett Co., Inc.",
          "Gap Inc.",
          "Gateway Inc.",
          "GATX Corporation",
          "Gemstar-TV Guide International Inc.",
          "GenCorp Inc.",
          "General Cable Corporation",
          "General Dynamics Corporation",
          "General Electric Company",
          "General Mills Inc",
          "General Motors Corporation",
          "Genesis Health Ventures Inc.",
          "Gentek Inc.",
          "Gentiva Health Services Inc.",
          "Genuine Parts Company",
          "Genuity Inc.",
          "Genzyme Corporation",
          "Georgia Gulf Corporation",
          "Georgia-Pacific Corporation",
          "Gillette Company",
          "Gold Kist Inc.",
          "Golden State Bancorp Inc.",
          "Golden West Financial Corporation",
          "Goldman Sachs Group Inc.",
          "Goodrich Corporation",
          "The Goodyear Tire & Rubber Company",
          "Granite Construction Incorporated",
          "Graybar Electric Company Inc.",
          "Great Lakes Chemical Corporation",
          "Great Plains Energy Inc.",
          "GreenPoint Financial Corp.",
          "Greif Bros. Corporation",
          "Grey Global Group Inc.",
          "Group 1 Automotive Inc.",
          "Guidant Corporation",
          "H&R Block Inc.",
          "H.B. Fuller Company",
          "H.J. Heinz Company",
          "Halliburton Co.",
          "Harley-Davidson Inc.",
          "Harman International Industries Inc.",
          "Harrah's Entertainment Inc.",
          "Harris Corp.",
          "Harsco Corp.",
          "Hartford Financial Services Group Inc.",
          "Hasbro Inc.",
          "Hawaiian Electric Industries Inc.",
          "HCA Inc.",
          "Health Management Associates Inc.",
          "Health Net Inc.",
          "Healthsouth Corp",
          "Henry Schein Inc.",
          "Hercules Inc.",
          "Herman Miller Inc.",
          "Hershey Foods Corp.",
          "Hewlett-Packard Company",
          "Hibernia Corp.",
          "Hillenbrand Industries Inc.",
          "Hilton Hotels Corp.",
          "Hollywood Entertainment Corp.",
          "Home Depot Inc.",
          "Hon Industries Inc.",
          "Honeywell International Inc.",
          "Hormel Foods Corp.",
          "Host Marriott Corp.",
          "Household International Corp.",
          "Hovnanian Enterprises Inc.",
          "Hub Group Inc.",
          "Hubbell Inc.",
          "Hughes Supply Inc.",
          "Humana Inc.",
          "Huntington Bancshares Inc.",
          "Idacorp Inc.",
          "IDT Corporation",
          "IKON Office Solutions Inc.",
          "Illinois Tool Works Inc.",
          "IMC Global Inc.",
          "Imperial Sugar Company",
          "IMS Health Inc.",
          "Ingles Market Inc",
          "Ingram Micro Inc.",
          "Insight Enterprises Inc.",
          "Integrated Electrical Services Inc.",
          "Intel Corporation",
          "International Paper Co.",
          "Interpublic Group of Companies Inc.",
          "Interstate Bakeries Corporation",
          "International Business Machines Corp.",
          "International Flavors & Fragrances Inc.",
          "International Multifoods Corporation",
          "Intuit Inc.",
          "IT Group Inc.",
          "ITT Industries Inc.",
          "Ivax Corp.",
          "J.B. Hunt Transport Services Inc.",
          "J.C. Penny Co.",
          "J.P. Morgan Chase & Co.",
          "Jabil Circuit Inc.",
          "Jack In The Box Inc.",
          "Jacobs Engineering Group Inc.",
          "JDS Uniphase Corp.",
          "Jefferson-Pilot Co.",
          "John Hancock Financial Services Inc.",
          "Johnson & Johnson",
          "Johnson Controls Inc.",
          "Jones Apparel Group Inc.",
          "KB Home",
          "Kellogg Company",
          "Kellwood Company",
          "Kelly Services Inc.",
          "Kemet Corp.",
          "Kennametal Inc.",
          "Kerr-McGee Corporation",
          "KeyCorp",
          "KeySpan Corp.",
          "Kimball International Inc.",
          "Kimberly-Clark Corporation",
          "Kindred Healthcare Inc.",
          "KLA-Tencor Corporation",
          "K-Mart Corp.",
          "Knight-Ridder Inc.",
          "Kohl's Corp.",
          "KPMG Consulting Inc.",
          "Kroger Co.",
          "L-3 Communications Holdings Inc.",
          "Laboratory Corporation of America Holdings",
          "Lam Research Corporation",
          "LandAmerica Financial Group Inc.",
          "Lands' End Inc.",
          "Landstar System Inc.",
          "La-Z-Boy Inc.",
          "Lear Corporation",
          "Legg Mason Inc.",
          "Leggett & Platt Inc.",
          "Lehman Brothers Holdings Inc.",
          "Lennar Corporation",
          "Lennox International Inc.",
          "Level 3 Communications Inc.",
          "Levi Strauss & Co.",
          "Lexmark International Inc.",
          "Limited Inc.",
          "Lincoln National Corporation",
          "Linens 'n Things Inc.",
          "Lithia Motors Inc.",
          "Liz Claiborne Inc.",
          "Lockheed Martin Corporation",
          "Loews Corporation",
          "Longs Drug Stores Corporation",
          "Louisiana-Pacific Corporation",
          "Lowe's Companies Inc.",
          "LSI Logic Corporation",
          "The LTV Corporation",
          "The Lubrizol Corporation",
          "Lucent Technologies Inc.",
          "Lyondell Chemical Company",
          "M & T Bank Corporation",
          "Magellan Health Services Inc.",
          "Mail-Well Inc.",
          "Mandalay Resort Group",
          "Manor Care Inc.",
          "Manpower Inc.",
          "Marathon Oil Corporation",
          "Mariner Health Care Inc.",
          "Markel Corporation",
          "Marriott International Inc.",
          "Marsh & McLennan Companies Inc.",
          "Marsh Supermarkets Inc.",
          "Marshall & Ilsley Corporation",
          "Martin Marietta Materials Inc.",
          "Masco Corporation",
          "Massey Energy Company",
          "MasTec Inc.",
          "Mattel Inc.",
          "Maxim Integrated Products Inc.",
          "Maxtor Corporation",
          "Maxxam Inc.",
          "The May Department Stores Company",
          "Maytag Corporation",
          "MBNA Corporation",
          "McCormick & Company Incorporated",
          "McDonald's Corporation",
          "The McGraw-Hill Companies Inc.",
          "McKesson Corporation",
          "McLeodUSA Incorporated",
          "M.D.C. Holdings Inc.",
          "MDU Resources Group Inc.",
          "MeadWestvaco Corporation",
          "Medtronic Inc.",
          "Mellon Financial Corporation",
          "The Men's Wearhouse Inc.",
          "Merck & Co., Inc.",
          "Mercury General Corporation",
          "Merrill Lynch & Co. Inc.",
          "Metaldyne Corporation",
          "Metals USA Inc.",
          "MetLife Inc.",
          "Metris Companies Inc",
          "MGIC Investment Corporation",
          "MGM Mirage",
          "Michaels Stores Inc.",
          "Micron Technology Inc.",
          "Microsoft Corporation",
          "Milacron Inc.",
          "Millennium Chemicals Inc.",
          "Mirant Corporation",
          "Mohawk Industries Inc.",
          "Molex Incorporated",
          "The MONY Group Inc.",
          "Morgan Stanley Dean Witter & Co.",
          "Motorola Inc.",
          "MPS Group Inc.",
          "Murphy Oil Corporation",
          "Nabors Industries Inc",
          "Nacco Industries Inc",
          "Nash Finch Company",
          "National City Corp.",
          "National Commerce Financial Corporation",
          "National Fuel Gas Company",
          "National Oilwell Inc",
          "National Rural Utilities Cooperative Finance Corporation",
          "National Semiconductor Corporation",
          "National Service Industries Inc",
          "Navistar International Corporation",
          "NCR Corporation",
          "The Neiman Marcus Group Inc.",
          "New Jersey Resources Corporation",
          "New York Times Company",
          "Newell Rubbermaid Inc",
          "Newmont Mining Corporation",
          "Nextel Communications Inc",
          "Nicor Inc",
          "Nike Inc",
          "NiSource Inc",
          "Noble Energy Inc",
          "Nordstrom Inc",
          "Norfolk Southern Corporation",
          "Nortek Inc",
          "North Fork Bancorporation Inc",
          "Northeast Utilities System",
          "Northern Trust Corporation",
          "Northrop Grumman Corporation",
          "NorthWestern Corporation",
          "Novellus Systems Inc",
          "NSTAR",
          "NTL Incorporated",
          "Nucor Corp",
          "Nvidia Corp",
          "NVR Inc",
          "Northwest Airlines Corp",
          "Occidental Petroleum Corp",
          "Ocean Energy Inc",
          "Office Depot Inc.",
          "OfficeMax Inc",
          "OGE Energy Corp",
          "Oglethorpe Power Corp.",
          "Ohio Casualty Corp.",
          "Old Republic International Corp.",
          "Olin Corp.",
          "OM Group Inc",
          "Omnicare Inc",
          "Omnicom Group",
          "On Semiconductor Corp",
          "ONEOK Inc",
          "Oracle Corp",
          "Oshkosh Truck Corp",
          "Outback Steakhouse Inc.",
          "Owens & Minor Inc.",
          "Owens Corning",
          "Owens-Illinois Inc",
          "Oxford Health Plans Inc",
          "Paccar Inc",
          "PacifiCare Health Systems Inc",
          "Packaging Corp. of America",
          "Pactiv Corp",
          "Pall Corp",
          "Pantry Inc",
          "Park Place Entertainment Corp",
          "Parker Hannifin Corp.",
          "Pathmark Stores Inc.",
          "Paychex Inc",
          "Payless Shoesource Inc",
          "Penn Traffic Co.",
          "Pennzoil-Quaker State Company",
          "Pentair Inc",
          "Peoples Energy Corp.",
          "PeopleSoft Inc",
          "Pep Boys Manny, Moe & Jack",
          "Potomac Electric Power Co.",
          "Pepsi Bottling Group Inc.",
          "PepsiAmericas Inc.",
          "PepsiCo Inc.",
          "Performance Food Group Co.",
          "Perini Corp",
          "PerkinElmer Inc",
          "Perot Systems Corp",
          "Petco Animal Supplies Inc.",
          "Peter Kiewit Sons', Inc.",
          "PETsMART Inc",
          "Pfizer Inc",
          "Pacific Gas & Electric Corp.",
          "Pharmacia Corp",
          "Phar Mor Inc.",
          "Phelps Dodge Corp.",
          "Philip Morris Companies Inc.",
          "Phillips Petroleum Co",
          "Phillips Van Heusen Corp.",
          "Phoenix Companies Inc",
          "Pier 1 Imports Inc.",
          "Pilgrim's Pride Corporation",
          "Pinnacle West Capital Corp",
          "Pioneer-Standard Electronics Inc.",
          "Pitney Bowes Inc.",
          "Pittston Brinks Group",
          "Plains All American Pipeline LP",
          "PNC Financial Services Group Inc.",
          "PNM Resources Inc",
          "Polaris Industries Inc.",
          "Polo Ralph Lauren Corp",
          "PolyOne Corp",
          "Popular Inc",
          "Potlatch Corp",
          "PPG Industries Inc",
          "PPL Corp",
          "Praxair Inc",
          "Precision Castparts Corp",
          "Premcor Inc.",
          "Pride International Inc",
          "Primedia Inc",
          "Principal Financial Group Inc.",
          "Procter & Gamble Co.",
          "Pro-Fac Cooperative Inc.",
          "Progress Energy Inc",
          "Progressive Corporation",
          "Protective Life Corp",
          "Provident Financial Group",
          "Providian Financial Corp.",
          "Prudential Financial Inc.",
          "PSS World Medical Inc",
          "Public Service Enterprise Group Inc.",
          "Publix Super Markets Inc.",
          "Puget Energy Inc.",
          "Pulte Homes Inc",
          "Qualcomm Inc",
          "Quanta Services Inc.",
          "Quantum Corp",
          "Quest Diagnostics Inc.",
          "Questar Corp",
          "Quintiles Transnational",
          "Qwest Communications Intl Inc",
          "R.J. Reynolds Tobacco Company",
          "R.R. Donnelley & Sons Company",
          "Radio Shack Corporation",
          "Raymond James Financial Inc.",
          "Raytheon Company",
          "Reader's Digest Association Inc.",
          "Reebok International Ltd.",
          "Regions Financial Corp.",
          "Regis Corporation",
          "Reliance Steel & Aluminum Co.",
          "Reliant Energy Inc.",
          "Rent A Center Inc",
          "Republic Services Inc",
          "Revlon Inc",
          "RGS Energy Group Inc",
          "Rite Aid Corp",
          "Riverwood Holding Inc.",
          "RoadwayCorp",
          "Robert Half International Inc.",
          "Rock-Tenn Co",
          "Rockwell Automation Inc",
          "Rockwell Collins Inc",
          "Rohm & Haas Co.",
          "Ross Stores Inc",
          "RPM Inc.",
          "Ruddick Corp",
          "Ryder System Inc",
          "Ryerson Tull Inc",
          "Ryland Group Inc.",
          "Sabre Holdings Corp",
          "Safeco Corp",
          "Safeguard Scientifics Inc.",
          "Safeway Inc",
          "Saks Inc",
          "Sanmina-SCI Inc",
          "Sara Lee Corp",
          "SBC Communications Inc",
          "Scana Corp.",
          "Schering-Plough Corp",
          "Scholastic Corp",
          "SCI Systems Onc.",
          "Science Applications Intl. Inc.",
          "Scientific-Atlanta Inc",
          "Scotts Company",
          "Seaboard Corp",
          "Sealed Air Corp",
          "Sears Roebuck & Co",
          "Sempra Energy",
          "Sequa Corp",
          "Service Corp. International",
          "ServiceMaster Co",
          "Shaw Group Inc",
          "Sherwin-Williams Company",
          "Shopko Stores Inc",
          "Siebel Systems Inc",
          "Sierra Health Services Inc",
          "Sierra Pacific Resources",
          "Silgan Holdings Inc.",
          "Silicon Graphics Inc",
          "Simon Property Group Inc",
          "SLM Corporation",
          "Smith International Inc",
          "Smithfield Foods Inc",
          "Smurfit-Stone Container Corp",
          "Snap-On Inc",
          "Solectron Corp",
          "Solutia Inc",
          "Sonic Automotive Inc.",
          "Sonoco Products Co.",
          "Southern Company",
          "Southern Union Company",
          "SouthTrust Corp.",
          "Southwest Airlines Co",
          "Southwest Gas Corp",
          "Sovereign Bancorp Inc.",
          "Spartan Stores Inc",
          "Spherion Corp",
          "Sports Authority Inc",
          "Sprint Corp.",
          "SPX Corp",
          "St. Jude Medical Inc",
          "St. Paul Cos.",
          "Staff Leasing Inc.",
          "StanCorp Financial Group Inc",
          "Standard Pacific Corp.",
          "Stanley Works",
          "Staples Inc",
          "Starbucks Corp",
          "Starwood Hotels & Resorts Worldwide Inc",
          "State Street Corp.",
          "Stater Bros. Holdings Inc.",
          "Steelcase Inc",
          "Stein Mart Inc",
          "Stewart & Stevenson Services Inc",
          "Stewart Information Services Corp",
          "Stilwell Financial Inc",
          "Storage Technology Corporation",
          "Stryker Corp",
          "Sun Healthcare Group Inc.",
          "Sun Microsystems Inc.",
          "SunGard Data Systems Inc.",
          "Sunoco Inc.",
          "SunTrust Banks Inc",
          "Supervalu Inc",
          "Swift Transportation, Co., Inc",
          "Symbol Technologies Inc",
          "Synovus Financial Corp.",
          "Sysco Corp",
          "Systemax Inc.",
          "Target Corp.",
          "Tech Data Corporation",
          "TECO Energy Inc",
          "Tecumseh Products Company",
          "Tektronix Inc",
          "Teleflex Incorporated",
          "Telephone & Data Systems Inc",
          "Tellabs Inc.",
          "Temple-Inland Inc",
          "Tenet Healthcare Corporation",
          "Tenneco Automotive Inc.",
          "Teradyne Inc",
          "Terex Corp",
          "Tesoro Petroleum Corp.",
          "Texas Industries Inc.",
          "Texas Instruments Incorporated",
          "Textron Inc",
          "Thermo Electron Corporation",
          "Thomas & Betts Corporation",
          "Tiffany & Co",
          "Timken Company",
          "TJX Companies Inc",
          "TMP Worldwide Inc",
          "Toll Brothers Inc",
          "Torchmark Corporation",
          "Toro Company",
          "Tower Automotive Inc.",
          "Toys 'R' Us Inc",
          "Trans World Entertainment Corp.",
          "TransMontaigne Inc",
          "Transocean Inc",
          "TravelCenters of America Inc.",
          "Triad Hospitals Inc",
          "Tribune Company",
          "Trigon Healthcare Inc.",
          "Trinity Industries Inc",
          "Trump Hotels & Casino Resorts Inc.",
          "TruServ Corporation",
          "TRW Inc",
          "TXU Corp",
          "Tyson Foods Inc",
          "U.S. Bancorp",
          "U.S. Industries Inc.",
          "UAL Corporation",
          "UGI Corporation",
          "Unified Western Grocers Inc",
          "Union Pacific Corporation",
          "Union Planters Corp",
          "Unisource Energy Corp",
          "Unisys Corporation",
          "United Auto Group Inc",
          "United Defense Industries Inc.",
          "United Parcel Service Inc",
          "United Rentals Inc",
          "United Stationers Inc",
          "United Technologies Corporation",
          "UnitedHealth Group Incorporated",
          "Unitrin Inc",
          "Universal Corporation",
          "Universal Forest Products Inc",
          "Universal Health Services Inc",
          "Unocal Corporation",
          "Unova Inc",
          "UnumProvident Corporation",
          "URS Corporation",
          "US Airways Group Inc",
          "US Oncology Inc",
          "USA Interactive",
          "USFreighways Corporation",
          "USG Corporation",
          "UST Inc",
          "Valero Energy Corporation",
          "Valspar Corporation",
          "Value City Department Stores Inc",
          "Varco International Inc",
          "Vectren Corporation",
          "Veritas Software Corporation",
          "Verizon Communications Inc",
          "VF Corporation",
          "Viacom Inc",
          "Viad Corp",
          "Viasystems Group Inc",
          "Vishay Intertechnology Inc",
          "Visteon Corporation",
          "Volt Information Sciences Inc",
          "Vulcan Materials Company",
          "W.R. Berkley Corporation",
          "W.R. Grace & Co",
          "W.W. Grainger Inc",
          "Wachovia Corporation",
          "Wakenhut Corporation",
          "Walgreen Co",
          "Wallace Computer Services Inc",
          "Wal-Mart Stores Inc",
          "Walt Disney Co",
          "Walter Industries Inc",
          "Washington Mutual Inc",
          "Washington Post Co.",
          "Waste Management Inc",
          "Watsco Inc",
          "Weatherford International Inc",
          "Weis Markets Inc.",
          "Wellpoint Health Networks Inc",
          "Wells Fargo & Company",
          "Wendy's International Inc",
          "Werner Enterprises Inc",
          "WESCO International Inc",
          "Western Digital Inc",
          "Western Gas Resources Inc",
          "WestPoint Stevens Inc",
          "Weyerhauser Company",
          "WGL Holdings Inc",
          "Whirlpool Corporation",
          "Whole Foods Market Inc",
          "Willamette Industries Inc.",
          "Williams Companies Inc",
          "Williams Sonoma Inc",
          "Winn Dixie Stores Inc",
          "Wisconsin Energy Corporation",
          "Wm Wrigley Jr Company",
          "World Fuel Services Corporation",
          "WorldCom Inc",
          "Worthington Industries Inc",
          "WPS Resources Corporation",
          "Wyeth",
          "Wyndham International Inc",
          "Xcel Energy Inc",
          "Xerox Corp",
          "Xilinx Inc",
          "XO Communications Inc",
          "Yellow Corporation",
          "York International Corp",
          "Yum Brands Inc.",
          "Zale Corporation",
          "Zions Bancorporation"
        ],
        fileExtension: {
          raster: ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
          vector: ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
          "3d": ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
          document: ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
          {
            name: "Dateline Standard Time",
            abbr: "DST",
            offset: -12,
            isdst: !1,
            text: "(UTC-12:00) International Date Line West",
            utc: [
              "Etc/GMT+12"
            ]
          },
          {
            name: "UTC-11",
            abbr: "U",
            offset: -11,
            isdst: !1,
            text: "(UTC-11:00) Coordinated Universal Time-11",
            utc: [
              "Etc/GMT+11",
              "Pacific/Midway",
              "Pacific/Niue",
              "Pacific/Pago_Pago"
            ]
          },
          {
            name: "Hawaiian Standard Time",
            abbr: "HST",
            offset: -10,
            isdst: !1,
            text: "(UTC-10:00) Hawaii",
            utc: [
              "Etc/GMT+10",
              "Pacific/Honolulu",
              "Pacific/Johnston",
              "Pacific/Rarotonga",
              "Pacific/Tahiti"
            ]
          },
          {
            name: "Alaskan Standard Time",
            abbr: "AKDT",
            offset: -8,
            isdst: !0,
            text: "(UTC-09:00) Alaska",
            utc: [
              "America/Anchorage",
              "America/Juneau",
              "America/Nome",
              "America/Sitka",
              "America/Yakutat"
            ]
          },
          {
            name: "Pacific Standard Time (Mexico)",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-08:00) Baja California",
            utc: [
              "America/Santa_Isabel"
            ]
          },
          {
            name: "Pacific Daylight Time",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-07:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse"
            ]
          },
          {
            name: "Pacific Standard Time",
            abbr: "PST",
            offset: -8,
            isdst: !1,
            text: "(UTC-08:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse",
              "PST8PDT"
            ]
          },
          {
            name: "US Mountain Standard Time",
            abbr: "UMST",
            offset: -7,
            isdst: !1,
            text: "(UTC-07:00) Arizona",
            utc: [
              "America/Creston",
              "America/Dawson_Creek",
              "America/Hermosillo",
              "America/Phoenix",
              "Etc/GMT+7"
            ]
          },
          {
            name: "Mountain Standard Time (Mexico)",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
            utc: [
              "America/Chihuahua",
              "America/Mazatlan"
            ]
          },
          {
            name: "Mountain Standard Time",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Mountain Time (US & Canada)",
            utc: [
              "America/Boise",
              "America/Cambridge_Bay",
              "America/Denver",
              "America/Edmonton",
              "America/Inuvik",
              "America/Ojinaga",
              "America/Yellowknife",
              "MST7MDT"
            ]
          },
          {
            name: "Central America Standard Time",
            abbr: "CAST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Central America",
            utc: [
              "America/Belize",
              "America/Costa_Rica",
              "America/El_Salvador",
              "America/Guatemala",
              "America/Managua",
              "America/Tegucigalpa",
              "Etc/GMT+6",
              "Pacific/Galapagos"
            ]
          },
          {
            name: "Central Standard Time",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Central Time (US & Canada)",
            utc: [
              "America/Chicago",
              "America/Indiana/Knox",
              "America/Indiana/Tell_City",
              "America/Matamoros",
              "America/Menominee",
              "America/North_Dakota/Beulah",
              "America/North_Dakota/Center",
              "America/North_Dakota/New_Salem",
              "America/Rainy_River",
              "America/Rankin_Inlet",
              "America/Resolute",
              "America/Winnipeg",
              "CST6CDT"
            ]
          },
          {
            name: "Central Standard Time (Mexico)",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
            utc: [
              "America/Bahia_Banderas",
              "America/Cancun",
              "America/Merida",
              "America/Mexico_City",
              "America/Monterrey"
            ]
          },
          {
            name: "Canada Central Standard Time",
            abbr: "CCST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Saskatchewan",
            utc: [
              "America/Regina",
              "America/Swift_Current"
            ]
          },
          {
            name: "SA Pacific Standard Time",
            abbr: "SPST",
            offset: -5,
            isdst: !1,
            text: "(UTC-05:00) Bogota, Lima, Quito",
            utc: [
              "America/Bogota",
              "America/Cayman",
              "America/Coral_Harbour",
              "America/Eirunepe",
              "America/Guayaquil",
              "America/Jamaica",
              "America/Lima",
              "America/Panama",
              "America/Rio_Branco",
              "Etc/GMT+5"
            ]
          },
          {
            name: "Eastern Standard Time",
            abbr: "EDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Eastern Time (US & Canada)",
            utc: [
              "America/Detroit",
              "America/Havana",
              "America/Indiana/Petersburg",
              "America/Indiana/Vincennes",
              "America/Indiana/Winamac",
              "America/Iqaluit",
              "America/Kentucky/Monticello",
              "America/Louisville",
              "America/Montreal",
              "America/Nassau",
              "America/New_York",
              "America/Nipigon",
              "America/Pangnirtung",
              "America/Port-au-Prince",
              "America/Thunder_Bay",
              "America/Toronto",
              "EST5EDT"
            ]
          },
          {
            name: "US Eastern Standard Time",
            abbr: "UEDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Indiana (East)",
            utc: [
              "America/Indiana/Marengo",
              "America/Indiana/Vevay",
              "America/Indianapolis"
            ]
          },
          {
            name: "Venezuela Standard Time",
            abbr: "VST",
            offset: -4.5,
            isdst: !1,
            text: "(UTC-04:30) Caracas",
            utc: [
              "America/Caracas"
            ]
          },
          {
            name: "Paraguay Standard Time",
            abbr: "PYT",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Asuncion",
            utc: [
              "America/Asuncion"
            ]
          },
          {
            name: "Atlantic Standard Time",
            abbr: "ADT",
            offset: -3,
            isdst: !0,
            text: "(UTC-04:00) Atlantic Time (Canada)",
            utc: [
              "America/Glace_Bay",
              "America/Goose_Bay",
              "America/Halifax",
              "America/Moncton",
              "America/Thule",
              "Atlantic/Bermuda"
            ]
          },
          {
            name: "Central Brazilian Standard Time",
            abbr: "CBST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Cuiaba",
            utc: [
              "America/Campo_Grande",
              "America/Cuiaba"
            ]
          },
          {
            name: "SA Western Standard Time",
            abbr: "SWST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
            utc: [
              "America/Anguilla",
              "America/Antigua",
              "America/Aruba",
              "America/Barbados",
              "America/Blanc-Sablon",
              "America/Boa_Vista",
              "America/Curacao",
              "America/Dominica",
              "America/Grand_Turk",
              "America/Grenada",
              "America/Guadeloupe",
              "America/Guyana",
              "America/Kralendijk",
              "America/La_Paz",
              "America/Lower_Princes",
              "America/Manaus",
              "America/Marigot",
              "America/Martinique",
              "America/Montserrat",
              "America/Port_of_Spain",
              "America/Porto_Velho",
              "America/Puerto_Rico",
              "America/Santo_Domingo",
              "America/St_Barthelemy",
              "America/St_Kitts",
              "America/St_Lucia",
              "America/St_Thomas",
              "America/St_Vincent",
              "America/Tortola",
              "Etc/GMT+4"
            ]
          },
          {
            name: "Pacific SA Standard Time",
            abbr: "PSST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Santiago",
            utc: [
              "America/Santiago",
              "Antarctica/Palmer"
            ]
          },
          {
            name: "Newfoundland Standard Time",
            abbr: "NDT",
            offset: -2.5,
            isdst: !0,
            text: "(UTC-03:30) Newfoundland",
            utc: [
              "America/St_Johns"
            ]
          },
          {
            name: "E. South America Standard Time",
            abbr: "ESAST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Brasilia",
            utc: [
              "America/Sao_Paulo"
            ]
          },
          {
            name: "Argentina Standard Time",
            abbr: "AST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Buenos Aires",
            utc: [
              "America/Argentina/La_Rioja",
              "America/Argentina/Rio_Gallegos",
              "America/Argentina/Salta",
              "America/Argentina/San_Juan",
              "America/Argentina/San_Luis",
              "America/Argentina/Tucuman",
              "America/Argentina/Ushuaia",
              "America/Buenos_Aires",
              "America/Catamarca",
              "America/Cordoba",
              "America/Jujuy",
              "America/Mendoza"
            ]
          },
          {
            name: "SA Eastern Standard Time",
            abbr: "SEST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Cayenne, Fortaleza",
            utc: [
              "America/Araguaina",
              "America/Belem",
              "America/Cayenne",
              "America/Fortaleza",
              "America/Maceio",
              "America/Paramaribo",
              "America/Recife",
              "America/Santarem",
              "Antarctica/Rothera",
              "Atlantic/Stanley",
              "Etc/GMT+3"
            ]
          },
          {
            name: "Greenland Standard Time",
            abbr: "GDT",
            offset: -3,
            isdst: !0,
            text: "(UTC-03:00) Greenland",
            utc: [
              "America/Godthab"
            ]
          },
          {
            name: "Montevideo Standard Time",
            abbr: "MST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Montevideo",
            utc: [
              "America/Montevideo"
            ]
          },
          {
            name: "Bahia Standard Time",
            abbr: "BST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Salvador",
            utc: [
              "America/Bahia"
            ]
          },
          {
            name: "UTC-02",
            abbr: "U",
            offset: -2,
            isdst: !1,
            text: "(UTC-02:00) Coordinated Universal Time-02",
            utc: [
              "America/Noronha",
              "Atlantic/South_Georgia",
              "Etc/GMT+2"
            ]
          },
          {
            name: "Mid-Atlantic Standard Time",
            abbr: "MDT",
            offset: -1,
            isdst: !0,
            text: "(UTC-02:00) Mid-Atlantic - Old",
            utc: []
          },
          {
            name: "Azores Standard Time",
            abbr: "ADT",
            offset: 0,
            isdst: !0,
            text: "(UTC-01:00) Azores",
            utc: [
              "America/Scoresbysund",
              "Atlantic/Azores"
            ]
          },
          {
            name: "Cape Verde Standard Time",
            abbr: "CVST",
            offset: -1,
            isdst: !1,
            text: "(UTC-01:00) Cape Verde Is.",
            utc: [
              "Atlantic/Cape_Verde",
              "Etc/GMT+1"
            ]
          },
          {
            name: "Morocco Standard Time",
            abbr: "MDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Casablanca",
            utc: [
              "Africa/Casablanca",
              "Africa/El_Aaiun"
            ]
          },
          {
            name: "UTC",
            abbr: "UTC",
            offset: 0,
            isdst: !1,
            text: "(UTC) Coordinated Universal Time",
            utc: [
              "America/Danmarkshavn",
              "Etc/GMT"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GMT",
            offset: 0,
            isdst: !1,
            text: "(UTC) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "British Summer Time",
            abbr: "BST",
            offset: 1,
            isdst: !0,
            text: "(UTC+01:00) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Dublin, Lisbon",
            utc: [
              "Atlantic/Canary",
              "Atlantic/Faeroe",
              "Atlantic/Madeira",
              "Europe/Dublin",
              "Europe/Lisbon"
            ]
          },
          {
            name: "Greenwich Standard Time",
            abbr: "GST",
            offset: 0,
            isdst: !1,
            text: "(UTC) Monrovia, Reykjavik",
            utc: [
              "Africa/Abidjan",
              "Africa/Accra",
              "Africa/Bamako",
              "Africa/Banjul",
              "Africa/Bissau",
              "Africa/Conakry",
              "Africa/Dakar",
              "Africa/Freetown",
              "Africa/Lome",
              "Africa/Monrovia",
              "Africa/Nouakchott",
              "Africa/Ouagadougou",
              "Africa/Sao_Tome",
              "Atlantic/Reykjavik",
              "Atlantic/St_Helena"
            ]
          },
          {
            name: "W. Europe Standard Time",
            abbr: "WEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            utc: [
              "Arctic/Longyearbyen",
              "Europe/Amsterdam",
              "Europe/Andorra",
              "Europe/Berlin",
              "Europe/Busingen",
              "Europe/Gibraltar",
              "Europe/Luxembourg",
              "Europe/Malta",
              "Europe/Monaco",
              "Europe/Oslo",
              "Europe/Rome",
              "Europe/San_Marino",
              "Europe/Stockholm",
              "Europe/Vaduz",
              "Europe/Vatican",
              "Europe/Vienna",
              "Europe/Zurich"
            ]
          },
          {
            name: "Central Europe Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            utc: [
              "Europe/Belgrade",
              "Europe/Bratislava",
              "Europe/Budapest",
              "Europe/Ljubljana",
              "Europe/Podgorica",
              "Europe/Prague",
              "Europe/Tirane"
            ]
          },
          {
            name: "Romance Standard Time",
            abbr: "RDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
            utc: [
              "Africa/Ceuta",
              "Europe/Brussels",
              "Europe/Copenhagen",
              "Europe/Madrid",
              "Europe/Paris"
            ]
          },
          {
            name: "Central European Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            utc: [
              "Europe/Sarajevo",
              "Europe/Skopje",
              "Europe/Warsaw",
              "Europe/Zagreb"
            ]
          },
          {
            name: "W. Central Africa Standard Time",
            abbr: "WCAST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) West Central Africa",
            utc: [
              "Africa/Algiers",
              "Africa/Bangui",
              "Africa/Brazzaville",
              "Africa/Douala",
              "Africa/Kinshasa",
              "Africa/Lagos",
              "Africa/Libreville",
              "Africa/Luanda",
              "Africa/Malabo",
              "Africa/Ndjamena",
              "Africa/Niamey",
              "Africa/Porto-Novo",
              "Africa/Tunis",
              "Etc/GMT-1"
            ]
          },
          {
            name: "Namibia Standard Time",
            abbr: "NST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) Windhoek",
            utc: [
              "Africa/Windhoek"
            ]
          },
          {
            name: "GTB Standard Time",
            abbr: "GDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Athens, Bucharest",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau"
            ]
          },
          {
            name: "Middle East Standard Time",
            abbr: "MEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Beirut",
            utc: [
              "Asia/Beirut"
            ]
          },
          {
            name: "Egypt Standard Time",
            abbr: "EST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Cairo",
            utc: [
              "Africa/Cairo"
            ]
          },
          {
            name: "Syria Standard Time",
            abbr: "SDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Damascus",
            utc: [
              "Asia/Damascus"
            ]
          },
          {
            name: "E. Europe Standard Time",
            abbr: "EEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) E. Europe",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau",
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Nicosia",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "South Africa Standard Time",
            abbr: "SAST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Harare, Pretoria",
            utc: [
              "Africa/Blantyre",
              "Africa/Bujumbura",
              "Africa/Gaborone",
              "Africa/Harare",
              "Africa/Johannesburg",
              "Africa/Kigali",
              "Africa/Lubumbashi",
              "Africa/Lusaka",
              "Africa/Maputo",
              "Africa/Maseru",
              "Africa/Mbabane",
              "Etc/GMT-2"
            ]
          },
          {
            name: "FLE Standard Time",
            abbr: "FDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            utc: [
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "Turkey Standard Time",
            abbr: "TDT",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Istanbul",
            utc: [
              "Europe/Istanbul"
            ]
          },
          {
            name: "Israel Standard Time",
            abbr: "JDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Jerusalem",
            utc: [
              "Asia/Jerusalem"
            ]
          },
          {
            name: "Libya Standard Time",
            abbr: "LST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Tripoli",
            utc: [
              "Africa/Tripoli"
            ]
          },
          {
            name: "Jordan Standard Time",
            abbr: "JST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Amman",
            utc: [
              "Asia/Amman"
            ]
          },
          {
            name: "Arabic Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Baghdad",
            utc: [
              "Asia/Baghdad"
            ]
          },
          {
            name: "Kaliningrad Standard Time",
            abbr: "KST",
            offset: 3,
            isdst: !1,
            text: "(UTC+02:00) Kaliningrad",
            utc: [
              "Europe/Kaliningrad"
            ]
          },
          {
            name: "Arab Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Kuwait, Riyadh",
            utc: [
              "Asia/Aden",
              "Asia/Bahrain",
              "Asia/Kuwait",
              "Asia/Qatar",
              "Asia/Riyadh"
            ]
          },
          {
            name: "E. Africa Standard Time",
            abbr: "EAST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Nairobi",
            utc: [
              "Africa/Addis_Ababa",
              "Africa/Asmera",
              "Africa/Dar_es_Salaam",
              "Africa/Djibouti",
              "Africa/Juba",
              "Africa/Kampala",
              "Africa/Khartoum",
              "Africa/Mogadishu",
              "Africa/Nairobi",
              "Antarctica/Syowa",
              "Etc/GMT-3",
              "Indian/Antananarivo",
              "Indian/Comoro",
              "Indian/Mayotte"
            ]
          },
          {
            name: "Moscow Standard Time",
            abbr: "MSK",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
            utc: [
              "Europe/Kirov",
              "Europe/Moscow",
              "Europe/Simferopol",
              "Europe/Volgograd",
              "Europe/Minsk"
            ]
          },
          {
            name: "Samara Time",
            abbr: "SAMT",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
            utc: [
              "Europe/Astrakhan",
              "Europe/Samara",
              "Europe/Ulyanovsk"
            ]
          },
          {
            name: "Iran Standard Time",
            abbr: "IDT",
            offset: 4.5,
            isdst: !0,
            text: "(UTC+03:30) Tehran",
            utc: [
              "Asia/Tehran"
            ]
          },
          {
            name: "Arabian Standard Time",
            abbr: "AST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Abu Dhabi, Muscat",
            utc: [
              "Asia/Dubai",
              "Asia/Muscat",
              "Etc/GMT-4"
            ]
          },
          {
            name: "Azerbaijan Standard Time",
            abbr: "ADT",
            offset: 5,
            isdst: !0,
            text: "(UTC+04:00) Baku",
            utc: [
              "Asia/Baku"
            ]
          },
          {
            name: "Mauritius Standard Time",
            abbr: "MST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Port Louis",
            utc: [
              "Indian/Mahe",
              "Indian/Mauritius",
              "Indian/Reunion"
            ]
          },
          {
            name: "Georgian Standard Time",
            abbr: "GET",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Tbilisi",
            utc: [
              "Asia/Tbilisi"
            ]
          },
          {
            name: "Caucasus Standard Time",
            abbr: "CST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Yerevan",
            utc: [
              "Asia/Yerevan"
            ]
          },
          {
            name: "Afghanistan Standard Time",
            abbr: "AST",
            offset: 4.5,
            isdst: !1,
            text: "(UTC+04:30) Kabul",
            utc: [
              "Asia/Kabul"
            ]
          },
          {
            name: "West Asia Standard Time",
            abbr: "WAST",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Ashgabat, Tashkent",
            utc: [
              "Antarctica/Mawson",
              "Asia/Aqtau",
              "Asia/Aqtobe",
              "Asia/Ashgabat",
              "Asia/Dushanbe",
              "Asia/Oral",
              "Asia/Samarkand",
              "Asia/Tashkent",
              "Etc/GMT-5",
              "Indian/Kerguelen",
              "Indian/Maldives"
            ]
          },
          {
            name: "Yekaterinburg Time",
            abbr: "YEKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Yekaterinburg",
            utc: [
              "Asia/Yekaterinburg"
            ]
          },
          {
            name: "Pakistan Standard Time",
            abbr: "PKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Islamabad, Karachi",
            utc: [
              "Asia/Karachi"
            ]
          },
          {
            name: "India Standard Time",
            abbr: "IST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            utc: [
              "Asia/Kolkata"
            ]
          },
          {
            name: "Sri Lanka Standard Time",
            abbr: "SLST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Sri Jayawardenepura",
            utc: [
              "Asia/Colombo"
            ]
          },
          {
            name: "Nepal Standard Time",
            abbr: "NST",
            offset: 5.75,
            isdst: !1,
            text: "(UTC+05:45) Kathmandu",
            utc: [
              "Asia/Kathmandu"
            ]
          },
          {
            name: "Central Asia Standard Time",
            abbr: "CAST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Nur-Sultan (Astana)",
            utc: [
              "Antarctica/Vostok",
              "Asia/Almaty",
              "Asia/Bishkek",
              "Asia/Qyzylorda",
              "Asia/Urumqi",
              "Etc/GMT-6",
              "Indian/Chagos"
            ]
          },
          {
            name: "Bangladesh Standard Time",
            abbr: "BST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Dhaka",
            utc: [
              "Asia/Dhaka",
              "Asia/Thimphu"
            ]
          },
          {
            name: "Myanmar Standard Time",
            abbr: "MST",
            offset: 6.5,
            isdst: !1,
            text: "(UTC+06:30) Yangon (Rangoon)",
            utc: [
              "Asia/Rangoon",
              "Indian/Cocos"
            ]
          },
          {
            name: "SE Asia Standard Time",
            abbr: "SAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
            utc: [
              "Antarctica/Davis",
              "Asia/Bangkok",
              "Asia/Hovd",
              "Asia/Jakarta",
              "Asia/Phnom_Penh",
              "Asia/Pontianak",
              "Asia/Saigon",
              "Asia/Vientiane",
              "Etc/GMT-7",
              "Indian/Christmas"
            ]
          },
          {
            name: "N. Central Asia Standard Time",
            abbr: "NCAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Novosibirsk",
            utc: [
              "Asia/Novokuznetsk",
              "Asia/Novosibirsk",
              "Asia/Omsk"
            ]
          },
          {
            name: "China Standard Time",
            abbr: "CST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            utc: [
              "Asia/Hong_Kong",
              "Asia/Macau",
              "Asia/Shanghai"
            ]
          },
          {
            name: "North Asia Standard Time",
            abbr: "NAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Krasnoyarsk",
            utc: [
              "Asia/Krasnoyarsk"
            ]
          },
          {
            name: "Singapore Standard Time",
            abbr: "MPST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Kuala Lumpur, Singapore",
            utc: [
              "Asia/Brunei",
              "Asia/Kuala_Lumpur",
              "Asia/Kuching",
              "Asia/Makassar",
              "Asia/Manila",
              "Asia/Singapore",
              "Etc/GMT-8"
            ]
          },
          {
            name: "W. Australia Standard Time",
            abbr: "WAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Perth",
            utc: [
              "Antarctica/Casey",
              "Australia/Perth"
            ]
          },
          {
            name: "Taipei Standard Time",
            abbr: "TST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Taipei",
            utc: [
              "Asia/Taipei"
            ]
          },
          {
            name: "Ulaanbaatar Standard Time",
            abbr: "UST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Ulaanbaatar",
            utc: [
              "Asia/Choibalsan",
              "Asia/Ulaanbaatar"
            ]
          },
          {
            name: "North Asia East Standard Time",
            abbr: "NAEST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Irkutsk",
            utc: [
              "Asia/Irkutsk"
            ]
          },
          {
            name: "Japan Standard Time",
            abbr: "JST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
            utc: [
              "Asia/Dili",
              "Asia/Jayapura",
              "Asia/Tokyo",
              "Etc/GMT-9",
              "Pacific/Palau"
            ]
          },
          {
            name: "Korea Standard Time",
            abbr: "KST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Seoul",
            utc: [
              "Asia/Pyongyang",
              "Asia/Seoul"
            ]
          },
          {
            name: "Cen. Australia Standard Time",
            abbr: "CAST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Adelaide",
            utc: [
              "Australia/Adelaide",
              "Australia/Broken_Hill"
            ]
          },
          {
            name: "AUS Central Standard Time",
            abbr: "ACST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Darwin",
            utc: [
              "Australia/Darwin"
            ]
          },
          {
            name: "E. Australia Standard Time",
            abbr: "EAST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Brisbane",
            utc: [
              "Australia/Brisbane",
              "Australia/Lindeman"
            ]
          },
          {
            name: "AUS Eastern Standard Time",
            abbr: "AEST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Canberra, Melbourne, Sydney",
            utc: [
              "Australia/Melbourne",
              "Australia/Sydney"
            ]
          },
          {
            name: "West Pacific Standard Time",
            abbr: "WPST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Guam, Port Moresby",
            utc: [
              "Antarctica/DumontDUrville",
              "Etc/GMT-10",
              "Pacific/Guam",
              "Pacific/Port_Moresby",
              "Pacific/Saipan",
              "Pacific/Truk"
            ]
          },
          {
            name: "Tasmania Standard Time",
            abbr: "TST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Hobart",
            utc: [
              "Australia/Currie",
              "Australia/Hobart"
            ]
          },
          {
            name: "Yakutsk Standard Time",
            abbr: "YST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Yakutsk",
            utc: [
              "Asia/Chita",
              "Asia/Khandyga",
              "Asia/Yakutsk"
            ]
          },
          {
            name: "Central Pacific Standard Time",
            abbr: "CPST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Solomon Is., New Caledonia",
            utc: [
              "Antarctica/Macquarie",
              "Etc/GMT-11",
              "Pacific/Efate",
              "Pacific/Guadalcanal",
              "Pacific/Kosrae",
              "Pacific/Noumea",
              "Pacific/Ponape"
            ]
          },
          {
            name: "Vladivostok Standard Time",
            abbr: "VST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Vladivostok",
            utc: [
              "Asia/Sakhalin",
              "Asia/Ust-Nera",
              "Asia/Vladivostok"
            ]
          },
          {
            name: "New Zealand Standard Time",
            abbr: "NZST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Auckland, Wellington",
            utc: [
              "Antarctica/McMurdo",
              "Pacific/Auckland"
            ]
          },
          {
            name: "UTC+12",
            abbr: "U",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Coordinated Universal Time+12",
            utc: [
              "Etc/GMT-12",
              "Pacific/Funafuti",
              "Pacific/Kwajalein",
              "Pacific/Majuro",
              "Pacific/Nauru",
              "Pacific/Tarawa",
              "Pacific/Wake",
              "Pacific/Wallis"
            ]
          },
          {
            name: "Fiji Standard Time",
            abbr: "FST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Fiji",
            utc: [
              "Pacific/Fiji"
            ]
          },
          {
            name: "Magadan Standard Time",
            abbr: "MST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Magadan",
            utc: [
              "Asia/Anadyr",
              "Asia/Kamchatka",
              "Asia/Magadan",
              "Asia/Srednekolymsk"
            ]
          },
          {
            name: "Kamchatka Standard Time",
            abbr: "KDT",
            offset: 13,
            isdst: !0,
            text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
            utc: [
              "Asia/Kamchatka"
            ]
          },
          {
            name: "Tonga Standard Time",
            abbr: "TST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Nuku'alofa",
            utc: [
              "Etc/GMT-13",
              "Pacific/Enderbury",
              "Pacific/Fakaofo",
              "Pacific/Tongatapu"
            ]
          },
          {
            name: "Samoa Standard Time",
            abbr: "SST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Samoa",
            utc: [
              "Pacific/Apia"
            ]
          }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
          "Airline Pilot",
          "Academic Team",
          "Accountant",
          "Account Executive",
          "Actor",
          "Actuary",
          "Acquisition Analyst",
          "Administrative Asst.",
          "Administrative Analyst",
          "Administrator",
          "Advertising Director",
          "Aerospace Engineer",
          "Agent",
          "Agricultural Inspector",
          "Agricultural Scientist",
          "Air Traffic Controller",
          "Animal Trainer",
          "Anthropologist",
          "Appraiser",
          "Architect",
          "Art Director",
          "Artist",
          "Astronomer",
          "Athletic Coach",
          "Auditor",
          "Author",
          "Baker",
          "Banker",
          "Bankruptcy Attorney",
          "Benefits Manager",
          "Biologist",
          "Bio-feedback Specialist",
          "Biomedical Engineer",
          "Biotechnical Researcher",
          "Broadcaster",
          "Broker",
          "Building Manager",
          "Building Contractor",
          "Building Inspector",
          "Business Analyst",
          "Business Planner",
          "Business Manager",
          "Buyer",
          "Call Center Manager",
          "Career Counselor",
          "Cash Manager",
          "Ceramic Engineer",
          "Chief Executive Officer",
          "Chief Operation Officer",
          "Chef",
          "Chemical Engineer",
          "Chemist",
          "Child Care Manager",
          "Chief Medical Officer",
          "Chiropractor",
          "Cinematographer",
          "City Housing Manager",
          "City Manager",
          "Civil Engineer",
          "Claims Manager",
          "Clinical Research Assistant",
          "Collections Manager",
          "Compliance Manager",
          "Comptroller",
          "Computer Manager",
          "Commercial Artist",
          "Communications Affairs Director",
          "Communications Director",
          "Communications Engineer",
          "Compensation Analyst",
          "Computer Programmer",
          "Computer Ops. Manager",
          "Computer Engineer",
          "Computer Operator",
          "Computer Graphics Specialist",
          "Construction Engineer",
          "Construction Manager",
          "Consultant",
          "Consumer Relations Manager",
          "Contract Administrator",
          "Copyright Attorney",
          "Copywriter",
          "Corporate Planner",
          "Corrections Officer",
          "Cosmetologist",
          "Credit Analyst",
          "Cruise Director",
          "Chief Information Officer",
          "Chief Technology Officer",
          "Customer Service Manager",
          "Cryptologist",
          "Dancer",
          "Data Security Manager",
          "Database Manager",
          "Day Care Instructor",
          "Dentist",
          "Designer",
          "Design Engineer",
          "Desktop Publisher",
          "Developer",
          "Development Officer",
          "Diamond Merchant",
          "Dietitian",
          "Direct Marketer",
          "Director",
          "Distribution Manager",
          "Diversity Manager",
          "Economist",
          "EEO Compliance Manager",
          "Editor",
          "Education Adminator",
          "Electrical Engineer",
          "Electro Optical Engineer",
          "Electronics Engineer",
          "Embassy Management",
          "Employment Agent",
          "Engineer Technician",
          "Entrepreneur",
          "Environmental Analyst",
          "Environmental Attorney",
          "Environmental Engineer",
          "Environmental Specialist",
          "Escrow Officer",
          "Estimator",
          "Executive Assistant",
          "Executive Director",
          "Executive Recruiter",
          "Facilities Manager",
          "Family Counselor",
          "Fashion Events Manager",
          "Fashion Merchandiser",
          "Fast Food Manager",
          "Film Producer",
          "Film Production Assistant",
          "Financial Analyst",
          "Financial Planner",
          "Financier",
          "Fine Artist",
          "Wildlife Specialist",
          "Fitness Consultant",
          "Flight Attendant",
          "Flight Engineer",
          "Floral Designer",
          "Food & Beverage Director",
          "Food Service Manager",
          "Forestry Technician",
          "Franchise Management",
          "Franchise Sales",
          "Fraud Investigator",
          "Freelance Writer",
          "Fund Raiser",
          "General Manager",
          "Geologist",
          "General Counsel",
          "Geriatric Specialist",
          "Gerontologist",
          "Glamour Photographer",
          "Golf Club Manager",
          "Gourmet Chef",
          "Graphic Designer",
          "Grounds Keeper",
          "Hazardous Waste Manager",
          "Health Care Manager",
          "Health Therapist",
          "Health Service Administrator",
          "Hearing Officer",
          "Home Economist",
          "Horticulturist",
          "Hospital Administrator",
          "Hotel Manager",
          "Human Resources Manager",
          "Importer",
          "Industrial Designer",
          "Industrial Engineer",
          "Information Director",
          "Inside Sales",
          "Insurance Adjuster",
          "Interior Decorator",
          "Internal Controls Director",
          "International Acct.",
          "International Courier",
          "International Lawyer",
          "Interpreter",
          "Investigator",
          "Investment Banker",
          "Investment Manager",
          "IT Architect",
          "IT Project Manager",
          "IT Systems Analyst",
          "Jeweler",
          "Joint Venture Manager",
          "Journalist",
          "Labor Negotiator",
          "Labor Organizer",
          "Labor Relations Manager",
          "Lab Services Director",
          "Lab Technician",
          "Land Developer",
          "Landscape Architect",
          "Law Enforcement Officer",
          "Lawyer",
          "Lead Software Engineer",
          "Lead Software Test Engineer",
          "Leasing Manager",
          "Legal Secretary",
          "Library Manager",
          "Litigation Attorney",
          "Loan Officer",
          "Lobbyist",
          "Logistics Manager",
          "Maintenance Manager",
          "Management Consultant",
          "Managed Care Director",
          "Managing Partner",
          "Manufacturing Director",
          "Manpower Planner",
          "Marine Biologist",
          "Market Res. Analyst",
          "Marketing Director",
          "Materials Manager",
          "Mathematician",
          "Membership Chairman",
          "Mechanic",
          "Mechanical Engineer",
          "Media Buyer",
          "Medical Investor",
          "Medical Secretary",
          "Medical Technician",
          "Mental Health Counselor",
          "Merchandiser",
          "Metallurgical Engineering",
          "Meteorologist",
          "Microbiologist",
          "MIS Manager",
          "Motion Picture Director",
          "Multimedia Director",
          "Musician",
          "Network Administrator",
          "Network Specialist",
          "Network Operator",
          "New Product Manager",
          "Novelist",
          "Nuclear Engineer",
          "Nuclear Specialist",
          "Nutritionist",
          "Nursing Administrator",
          "Occupational Therapist",
          "Oceanographer",
          "Office Manager",
          "Operations Manager",
          "Operations Research Director",
          "Optical Technician",
          "Optometrist",
          "Organizational Development Manager",
          "Outplacement Specialist",
          "Paralegal",
          "Park Ranger",
          "Patent Attorney",
          "Payroll Specialist",
          "Personnel Specialist",
          "Petroleum Engineer",
          "Pharmacist",
          "Photographer",
          "Physical Therapist",
          "Physician",
          "Physician Assistant",
          "Physicist",
          "Planning Director",
          "Podiatrist",
          "Political Analyst",
          "Political Scientist",
          "Politician",
          "Portfolio Manager",
          "Preschool Management",
          "Preschool Teacher",
          "Principal",
          "Private Banker",
          "Private Investigator",
          "Probation Officer",
          "Process Engineer",
          "Producer",
          "Product Manager",
          "Product Engineer",
          "Production Engineer",
          "Production Planner",
          "Professional Athlete",
          "Professional Coach",
          "Professor",
          "Project Engineer",
          "Project Manager",
          "Program Manager",
          "Property Manager",
          "Public Administrator",
          "Public Safety Director",
          "PR Specialist",
          "Publisher",
          "Purchasing Agent",
          "Publishing Director",
          "Quality Assurance Specialist",
          "Quality Control Engineer",
          "Quality Control Inspector",
          "Radiology Manager",
          "Railroad Engineer",
          "Real Estate Broker",
          "Recreational Director",
          "Recruiter",
          "Redevelopment Specialist",
          "Regulatory Affairs Manager",
          "Registered Nurse",
          "Rehabilitation Counselor",
          "Relocation Manager",
          "Reporter",
          "Research Specialist",
          "Restaurant Manager",
          "Retail Store Manager",
          "Risk Analyst",
          "Safety Engineer",
          "Sales Engineer",
          "Sales Trainer",
          "Sales Promotion Manager",
          "Sales Representative",
          "Sales Manager",
          "Service Manager",
          "Sanitation Engineer",
          "Scientific Programmer",
          "Scientific Writer",
          "Securities Analyst",
          "Security Consultant",
          "Security Director",
          "Seminar Presenter",
          "Ship's Officer",
          "Singer",
          "Social Director",
          "Social Program Planner",
          "Social Research",
          "Social Scientist",
          "Social Worker",
          "Sociologist",
          "Software Developer",
          "Software Engineer",
          "Software Test Engineer",
          "Soil Scientist",
          "Special Events Manager",
          "Special Education Teacher",
          "Special Projects Director",
          "Speech Pathologist",
          "Speech Writer",
          "Sports Event Manager",
          "Statistician",
          "Store Manager",
          "Strategic Alliance Director",
          "Strategic Planning Director",
          "Stress Reduction Specialist",
          "Stockbroker",
          "Surveyor",
          "Structural Engineer",
          "Superintendent",
          "Supply Chain Director",
          "System Engineer",
          "Systems Analyst",
          "Systems Programmer",
          "System Administrator",
          "Tax Specialist",
          "Teacher",
          "Technical Support Specialist",
          "Technical Illustrator",
          "Technical Writer",
          "Technology Director",
          "Telecom Analyst",
          "Telemarketer",
          "Theatrical Director",
          "Title Examiner",
          "Tour Escort",
          "Tour Guide Director",
          "Traffic Manager",
          "Trainer Translator",
          "Transportation Manager",
          "Travel Agent",
          "Treasurer",
          "TV Programmer",
          "Underwriter",
          "Union Representative",
          "University Administrator",
          "University Dean",
          "Urban Planner",
          "Veterinarian",
          "Vendor Relations Director",
          "Viticulturist",
          "Warehouse Manager"
        ],
        animals: {
          //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
          ocean: ["Acantharea", "Anemone", "Angelfish King", "Ahi Tuna", "Albacore", "American Oyster", "Anchovy", "Armored Snail", "Arctic Char", "Atlantic Bluefin Tuna", "Atlantic Cod", "Atlantic Goliath Grouper", "Atlantic Trumpetfish", "Atlantic Wolffish", "Baleen Whale", "Banded Butterflyfish", "Banded Coral Shrimp", "Banded Sea Krait", "Barnacle", "Barndoor Skate", "Barracuda", "Basking Shark", "Bass", "Beluga Whale", "Bluebanded Goby", "Bluehead Wrasse", "Bluefish", "Bluestreak Cleaner-Wrasse", "Blue Marlin", "Blue Shark", "Blue Spiny Lobster", "Blue Tang", "Blue Whale", "Broadclub Cuttlefish", "Bull Shark", "Chambered Nautilus", "Chilean Basket Star", "Chilean Jack Mackerel", "Chinook Salmon", "Christmas Tree Worm", "Clam", "Clown Anemonefish", "Clown Triggerfish", "Cod", "Coelacanth", "Cockscomb Cup Coral", "Common Fangtooth", "Conch", "Cookiecutter Shark", "Copepod", "Coral", "Corydoras", "Cownose Ray", "Crab", "Crown-of-Thorns Starfish", "Cushion Star", "Cuttlefish", "California Sea Otters", "Dolphin", "Dolphinfish", "Dory", "Devil Fish", "Dugong", "Dumbo Octopus", "Dungeness Crab", "Eccentric Sand Dollar", "Edible Sea Cucumber", "Eel", "Elephant Seal", "Elkhorn Coral", "Emperor Shrimp", "Estuarine Crocodile", "Fathead Sculpin", "Fiddler Crab", "Fin Whale", "Flameback", "Flamingo Tongue Snail", "Flashlight Fish", "Flatback Turtle", "Flatfish", "Flying Fish", "Flounder", "Fluke", "French Angelfish", "Frilled Shark", "Fugu (also called Pufferfish)", "Gar", "Geoduck", "Giant Barrel Sponge", "Giant Caribbean Sea Anemone", "Giant Clam", "Giant Isopod", "Giant Kingfish", "Giant Oarfish", "Giant Pacific Octopus", "Giant Pyrosome", "Giant Sea Star", "Giant Squid", "Glowing Sucker Octopus", "Giant Tube Worm", "Goblin Shark", "Goosefish", "Great White Shark", "Greenland Shark", "Grey Atlantic Seal", "Grouper", "Grunion", "Guineafowl Puffer", "Haddock", "Hake", "Halibut", "Hammerhead Shark", "Hapuka", "Harbor Porpoise", "Harbor Seal", "Hatchetfish", "Hawaiian Monk Seal", "Hawksbill Turtle", "Hector's Dolphin", "Hermit Crab", "Herring", "Hoki", "Horn Shark", "Horseshoe Crab", "Humpback Anglerfish", "Humpback Whale", "Icefish", "Imperator Angelfish", "Irukandji Jellyfish", "Isopod", "Ivory Bush Coral", "Japanese Spider Crab", "Jellyfish", "John Dory", "Juan Fernandez Fur Seal", "Killer Whale", "Kiwa Hirsuta", "Krill", "Lagoon Triggerfish", "Lamprey", "Leafy Seadragon", "Leopard Seal", "Limpet", "Ling", "Lionfish", "Lions Mane Jellyfish", "Lobe Coral", "Lobster", "Loggerhead Turtle", "Longnose Sawshark", "Longsnout Seahorse", "Lophelia Coral", "Marrus Orthocanna", "Manatee", "Manta Ray", "Marlin", "Megamouth Shark", "Mexican Lookdown", "Mimic Octopus", "Moon Jelly", "Mollusk", "Monkfish", "Moray Eel", "Mullet", "Mussel", "Megaladon", "Napoleon Wrasse", "Nassau Grouper", "Narwhal", "Nautilus", "Needlefish", "Northern Seahorse", "North Atlantic Right Whale", "Northern Red Snapper", "Norway Lobster", "Nudibranch", "Nurse Shark", "Oarfish", "Ocean Sunfish", "Oceanic Whitetip Shark", "Octopus", "Olive Sea Snake", "Orange Roughy", "Ostracod", "Otter", "Oyster", "Pacific Angelshark", "Pacific Blackdragon", "Pacific Halibut", "Pacific Sardine", "Pacific Sea Nettle Jellyfish", "Pacific White Sided Dolphin", "Pantropical Spotted Dolphin", "Patagonian Toothfish", "Peacock Mantis Shrimp", "Pelagic Thresher Shark", "Penguin", "Peruvian Anchoveta", "Pilchard", "Pink Salmon", "Pinniped", "Plankton", "Porpoise", "Polar Bear", "Portuguese Man o' War", "Pycnogonid Sea Spider", "Quahog", "Queen Angelfish", "Queen Conch", "Queen Parrotfish", "Queensland Grouper", "Ragfish", "Ratfish", "Rattail Fish", "Ray", "Red Drum", "Red King Crab", "Ringed Seal", "Risso's Dolphin", "Ross Seals", "Sablefish", "Salmon", "Sand Dollar", "Sandbar Shark", "Sawfish", "Sarcastic Fringehead", "Scalloped Hammerhead Shark", "Seahorse", "Sea Cucumber", "Sea Lion", "Sea Urchin", "Seal", "Shark", "Shortfin Mako Shark", "Shovelnose Guitarfish", "Shrimp", "Silverside Fish", "Skipjack Tuna", "Slender Snipe Eel", "Smalltooth Sawfish", "Smelts", "Sockeye Salmon", "Southern Stingray", "Sponge", "Spotted Porcupinefish", "Spotted Dolphin", "Spotted Eagle Ray", "Spotted Moray", "Squid", "Squidworm", "Starfish", "Stickleback", "Stonefish", "Stoplight Loosejaw", "Sturgeon", "Swordfish", "Tan Bristlemouth", "Tasseled Wobbegong", "Terrible Claw Lobster", "Threespot Damselfish", "Tiger Prawn", "Tiger Shark", "Tilefish", "Toadfish", "Tropical Two-Wing Flyfish", "Tuna", "Umbrella Squid", "Velvet Crab", "Venus Flytrap Sea Anemone", "Vigtorniella Worm", "Viperfish", "Vampire Squid", "Vaquita", "Wahoo", "Walrus", "West Indian Manatee", "Whale", "Whale Shark", "Whiptail Gulper", "White-Beaked Dolphin", "White-Ring Garden Eel", "White Shrimp", "Wobbegong", "Wrasse", "Wreckfish", "Xiphosura", "Yellowtail Damselfish", "Yelloweye Rockfish", "Yellow Cup Black Coral", "Yellow Tube Sponge", "Yellowfin Tuna", "Zebrashark", "Zooplankton"],
          //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
          desert: ["Aardwolf", "Addax", "African Wild Ass", "Ant", "Antelope", "Armadillo", "Baboon", "Badger", "Bat", "Bearded Dragon", "Beetle", "Bird", "Black-footed Cat", "Boa", "Brown Bear", "Bustard", "Butterfly", "Camel", "Caracal", "Caracara", "Caterpillar", "Centipede", "Cheetah", "Chipmunk", "Chuckwalla", "Climbing Mouse", "Coati", "Cobra", "Cotton Rat", "Cougar", "Courser", "Crane Fly", "Crow", "Dassie Rat", "Dove", "Dunnart", "Eagle", "Echidna", "Elephant", "Emu", "Falcon", "Fly", "Fox", "Frogmouth", "Gecko", "Geoffroy's Cat", "Gerbil", "Grasshopper", "Guanaco", "Gundi", "Hamster", "Hawk", "Hedgehog", "Hyena", "Hyrax", "Jackal", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kowari", "Kultarr", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Oryx", "Ostrich", "Owl", "Pronghorn", "Python", "Rabbit", "Raccoon", "Rattlesnake", "Rhinoceros", "Sand Cat", "Spectacled Bear", "Spiny Mouse", "Starling", "Stick Bug", "Tarantula", "Tit", "Toad", "Tortoise", "Tyrant Flycatcher", "Viper", "Vulture", "Waxwing", "Xerus", "Zebra"],
          grassland: ["Aardvark", "Aardwolf", "Accentor", "African Buffalo", "African Wild Dog", "Alpaca", "Anaconda", "Ant", "Anteater", "Antelope", "Armadillo", "Baboon", "Badger", "Bandicoot", "Barbet", "Bat", "Bee", "Bee-eater", "Beetle", "Bird", "Bison", "Black-footed Cat", "Black-footed Ferret", "Bluebird", "Boa", "Bowerbird", "Brown Bear", "Bush Dog", "Bushshrike", "Bustard", "Butterfly", "Buzzard", "Caracal", "Caracara", "Cardinal", "Caterpillar", "Cheetah", "Chipmunk", "Civet", "Climbing Mouse", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Common Genet", "Cotton Rat", "Cougar", "Courser", "Coyote", "Crane", "Crane Fly", "Cricket", "Crow", "Culpeo", "Death Adder", "Deer", "Deer Mouse", "Dingo", "Dinosaur", "Dove", "Drongo", "Duck", "Duiker", "Dunnart", "Eagle", "Echidna", "Elephant", "Elk", "Emu", "Falcon", "Finch", "Flea", "Fly", "Flying Frog", "Fox", "Frog", "Frogmouth", "Garter Snake", "Gazelle", "Gecko", "Geoffroy's Cat", "Gerbil", "Giant Tortoise", "Giraffe", "Grasshopper", "Grison", "Groundhog", "Grouse", "Guanaco", "Guinea Pig", "Hamster", "Harrier", "Hartebeest", "Hawk", "Hedgehog", "Helmetshrike", "Hippopotamus", "Hornbill", "Hyena", "Hyrax", "Impala", "Jackal", "Jaguar", "Jaguarundi", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kultarr", "Ladybug", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Newt", "Oryx", "Ostrich", "Owl", "Pangolin", "Pheasant", "Prairie Dog", "Pronghorn", "Przewalski's Horse", "Python", "Quoll", "Rabbit", "Raven", "Rhinoceros", "Shelduck", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Tamandua", "Tasmanian Devil", "Thornbill", "Thrush", "Toad", "Tortoise"],
          forest: ["Agouti", "Anaconda", "Anoa", "Ant", "Anteater", "Antelope", "Armadillo", "Asian Black Bear", "Aye-aye", "Babirusa", "Baboon", "Badger", "Bandicoot", "Banteng", "Barbet", "Basilisk", "Bat", "Bearded Dragon", "Bee", "Bee-eater", "Beetle", "Bettong", "Binturong", "Bird-of-paradise", "Bongo", "Bowerbird", "Bulbul", "Bush Dog", "Bushbaby", "Bushshrike", "Butterfly", "Buzzard", "Caecilian", "Cardinal", "Cassowary", "Caterpillar", "Centipede", "Chameleon", "Chimpanzee", "Cicada", "Civet", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Colugo", "Cotinga", "Cotton Rat", "Cougar", "Crane Fly", "Cricket", "Crocodile", "Crow", "Cuckoo", "Cuscus", "Death Adder", "Deer", "Dhole", "Dingo", "Dinosaur", "Drongo", "Duck", "Duiker", "Eagle", "Echidna", "Elephant", "Finch", "Flat-headed Cat", "Flea", "Flowerpecker", "Fly", "Flying Frog", "Fossa", "Frog", "Frogmouth", "Gaur", "Gecko", "Gorilla", "Grison", "Hawaiian Honeycreeper", "Hawk", "Hedgehog", "Helmetshrike", "Hornbill", "Hyrax", "Iguana", "Jackal", "Jaguar", "Jaguarundi", "Kestrel", "Ladybug", "Lemur", "Leopard", "Lion", "Macaw", "Mandrill", "Margay", "Monkey", "Mouse", "Mouse Deer", "Newt", "Okapi", "Old World Flycatcher", "Orangutan", "Owl", "Pangolin", "Peafowl", "Pheasant", "Possum", "Python", "Quokka", "Rabbit", "Raccoon", "Red Panda", "Red River Hog", "Rhinoceros", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Sun Bear", "Tamandua", "Tamarin", "Tapir", "Tarantula", "Thrush", "Tiger", "Tit", "Toad", "Tortoise", "Toucan", "Trogon", "Trumpeter", "Turaco", "Turtle", "Tyrant Flycatcher", "Viper", "Vulture", "Wallaby", "Warbler", "Wasp", "Waxwing", "Weaver", "Weaver-finch", "Whistler", "White-eye", "Whydah", "Woodswallow", "Worm", "Wren", "Xenops", "Yellowjacket", "Accentor", "African Buffalo", "American Black Bear", "Anole", "Bird", "Bison", "Boa", "Brown Bear", "Chipmunk", "Common Genet", "Copperhead", "Coyote", "Deer Mouse", "Dormouse", "Elk", "Emu", "Fisher", "Fox", "Garter Snake", "Giant Panda", "Giant Tortoise", "Groundhog", "Grouse", "Guanaco", "Himalayan Tahr", "Kangaroo", "Koala", "Numbat", "Quoll", "Raccoon dog", "Tasmanian Devil", "Thornbill", "Turkey", "Vole", "Weasel", "Wildcat", "Wolf", "Wombat", "Woodchuck", "Woodpecker"],
          //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
          farm: ["Alpaca", "Buffalo", "Banteng", "Cow", "Cat", "Chicken", "Carp", "Camel", "Donkey", "Dog", "Duck", "Emu", "Goat", "Gayal", "Guinea", "Goose", "Horse", "Honey", "Llama", "Pig", "Pigeon", "Rhea", "Rabbit", "Sheep", "Silkworm", "Turkey", "Yak", "Zebu"],
          //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
          pet: ["Bearded Dragon", "Birds", "Burro", "Cats", "Chameleons", "Chickens", "Chinchillas", "Chinese Water Dragon", "Cows", "Dogs", "Donkey", "Ducks", "Ferrets", "Fish", "Geckos", "Geese", "Gerbils", "Goats", "Guinea Fowl", "Guinea Pigs", "Hamsters", "Hedgehogs", "Horses", "Iguanas", "Llamas", "Lizards", "Mice", "Mule", "Peafowl", "Pigs and Hogs", "Pigeons", "Ponies", "Pot Bellied Pig", "Rabbits", "Rats", "Sheep", "Skinks", "Snakes", "Stick Insects", "Sugar Gliders", "Tarantula", "Turkeys", "Turtles"],
          //list of zoo animals comes from https://bronxzoo.com/animals
          zoo: ["Aardvark", "African Wild Dog", "Aldabra Tortoise", "American Alligator", "American Bison", "Amur Tiger", "Anaconda", "Andean Condor", "Asian Elephant", "Baby Doll Sheep", "Bald Eagle", "Barred Owl", "Blue Iguana", "Boer Goat", "California Sea Lion", "Caribbean Flamingo", "Chinchilla", "Collared Lemur", "Coquerel's Sifaka", "Cuban Amazon Parrot", "Ebony Langur", "Fennec Fox", "Fossa", "Gelada", "Giant Anteater", "Giraffe", "Gorilla", "Grizzly Bear", "Henkel's Leaf-tailed Gecko", "Indian Gharial", "Indian Rhinoceros", "King Cobra", "King Vulture", "Komodo Dragon", "Linne's Two-toed Sloth", "Lion", "Little Penguin", "Madagascar Tree Boa", "Magellanic Penguin", "Malayan Tapir", "Malayan Tiger", "Matschies Tree Kangaroo", "Mini Donkey", "Monarch Butterfly", "Nile crocodile", "North American Porcupine", "Nubian Ibex", "Okapi", "Poison Dart Frog", "Polar Bear", "Pygmy Marmoset", "Radiated Tortoise", "Red Panda", "Red Ruffed Lemur", "Ring-tailed Lemur", "Ring-tailed Mongoose", "Rock Hyrax", "Small Clawed Asian Otter", "Snow Leopard", "Snowy Owl", "Southern White-faced Owl", "Southern White Rhinocerous", "Squirrel Monkey", "Tufted Puffin", "White Cheeked Gibbon", "White-throated Bee Eater", "Zebra"]
        },
        primes: [
          // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
          2,
          3,
          5,
          7,
          11,
          13,
          17,
          19,
          23,
          29,
          31,
          37,
          41,
          43,
          47,
          53,
          59,
          61,
          67,
          71,
          73,
          79,
          83,
          89,
          97,
          101,
          103,
          107,
          109,
          113,
          127,
          131,
          137,
          139,
          149,
          151,
          157,
          163,
          167,
          173,
          179,
          181,
          191,
          193,
          197,
          199,
          211,
          223,
          227,
          229,
          233,
          239,
          241,
          251,
          257,
          263,
          269,
          271,
          277,
          281,
          283,
          293,
          307,
          311,
          313,
          317,
          331,
          337,
          347,
          349,
          353,
          359,
          367,
          373,
          379,
          383,
          389,
          397,
          401,
          409,
          419,
          421,
          431,
          433,
          439,
          443,
          449,
          457,
          461,
          463,
          467,
          479,
          487,
          491,
          499,
          503,
          509,
          521,
          523,
          541,
          547,
          557,
          563,
          569,
          571,
          577,
          587,
          593,
          599,
          601,
          607,
          613,
          617,
          619,
          631,
          641,
          643,
          647,
          653,
          659,
          661,
          673,
          677,
          683,
          691,
          701,
          709,
          719,
          727,
          733,
          739,
          743,
          751,
          757,
          761,
          769,
          773,
          787,
          797,
          809,
          811,
          821,
          823,
          827,
          829,
          839,
          853,
          857,
          859,
          863,
          877,
          881,
          883,
          887,
          907,
          911,
          919,
          929,
          937,
          941,
          947,
          953,
          967,
          971,
          977,
          983,
          991,
          997,
          1009,
          1013,
          1019,
          1021,
          1031,
          1033,
          1039,
          1049,
          1051,
          1061,
          1063,
          1069,
          1087,
          1091,
          1093,
          1097,
          1103,
          1109,
          1117,
          1123,
          1129,
          1151,
          1153,
          1163,
          1171,
          1181,
          1187,
          1193,
          1201,
          1213,
          1217,
          1223,
          1229,
          1231,
          1237,
          1249,
          1259,
          1277,
          1279,
          1283,
          1289,
          1291,
          1297,
          1301,
          1303,
          1307,
          1319,
          1321,
          1327,
          1361,
          1367,
          1373,
          1381,
          1399,
          1409,
          1423,
          1427,
          1429,
          1433,
          1439,
          1447,
          1451,
          1453,
          1459,
          1471,
          1481,
          1483,
          1487,
          1489,
          1493,
          1499,
          1511,
          1523,
          1531,
          1543,
          1549,
          1553,
          1559,
          1567,
          1571,
          1579,
          1583,
          1597,
          1601,
          1607,
          1609,
          1613,
          1619,
          1621,
          1627,
          1637,
          1657,
          1663,
          1667,
          1669,
          1693,
          1697,
          1699,
          1709,
          1721,
          1723,
          1733,
          1741,
          1747,
          1753,
          1759,
          1777,
          1783,
          1787,
          1789,
          1801,
          1811,
          1823,
          1831,
          1847,
          1861,
          1867,
          1871,
          1873,
          1877,
          1879,
          1889,
          1901,
          1907,
          1913,
          1931,
          1933,
          1949,
          1951,
          1973,
          1979,
          1987,
          1993,
          1997,
          1999,
          2003,
          2011,
          2017,
          2027,
          2029,
          2039,
          2053,
          2063,
          2069,
          2081,
          2083,
          2087,
          2089,
          2099,
          2111,
          2113,
          2129,
          2131,
          2137,
          2141,
          2143,
          2153,
          2161,
          2179,
          2203,
          2207,
          2213,
          2221,
          2237,
          2239,
          2243,
          2251,
          2267,
          2269,
          2273,
          2281,
          2287,
          2293,
          2297,
          2309,
          2311,
          2333,
          2339,
          2341,
          2347,
          2351,
          2357,
          2371,
          2377,
          2381,
          2383,
          2389,
          2393,
          2399,
          2411,
          2417,
          2423,
          2437,
          2441,
          2447,
          2459,
          2467,
          2473,
          2477,
          2503,
          2521,
          2531,
          2539,
          2543,
          2549,
          2551,
          2557,
          2579,
          2591,
          2593,
          2609,
          2617,
          2621,
          2633,
          2647,
          2657,
          2659,
          2663,
          2671,
          2677,
          2683,
          2687,
          2689,
          2693,
          2699,
          2707,
          2711,
          2713,
          2719,
          2729,
          2731,
          2741,
          2749,
          2753,
          2767,
          2777,
          2789,
          2791,
          2797,
          2801,
          2803,
          2819,
          2833,
          2837,
          2843,
          2851,
          2857,
          2861,
          2879,
          2887,
          2897,
          2903,
          2909,
          2917,
          2927,
          2939,
          2953,
          2957,
          2963,
          2969,
          2971,
          2999,
          3001,
          3011,
          3019,
          3023,
          3037,
          3041,
          3049,
          3061,
          3067,
          3079,
          3083,
          3089,
          3109,
          3119,
          3121,
          3137,
          3163,
          3167,
          3169,
          3181,
          3187,
          3191,
          3203,
          3209,
          3217,
          3221,
          3229,
          3251,
          3253,
          3257,
          3259,
          3271,
          3299,
          3301,
          3307,
          3313,
          3319,
          3323,
          3329,
          3331,
          3343,
          3347,
          3359,
          3361,
          3371,
          3373,
          3389,
          3391,
          3407,
          3413,
          3433,
          3449,
          3457,
          3461,
          3463,
          3467,
          3469,
          3491,
          3499,
          3511,
          3517,
          3527,
          3529,
          3533,
          3539,
          3541,
          3547,
          3557,
          3559,
          3571,
          3581,
          3583,
          3593,
          3607,
          3613,
          3617,
          3623,
          3631,
          3637,
          3643,
          3659,
          3671,
          3673,
          3677,
          3691,
          3697,
          3701,
          3709,
          3719,
          3727,
          3733,
          3739,
          3761,
          3767,
          3769,
          3779,
          3793,
          3797,
          3803,
          3821,
          3823,
          3833,
          3847,
          3851,
          3853,
          3863,
          3877,
          3881,
          3889,
          3907,
          3911,
          3917,
          3919,
          3923,
          3929,
          3931,
          3943,
          3947,
          3967,
          3989,
          4001,
          4003,
          4007,
          4013,
          4019,
          4021,
          4027,
          4049,
          4051,
          4057,
          4073,
          4079,
          4091,
          4093,
          4099,
          4111,
          4127,
          4129,
          4133,
          4139,
          4153,
          4157,
          4159,
          4177,
          4201,
          4211,
          4217,
          4219,
          4229,
          4231,
          4241,
          4243,
          4253,
          4259,
          4261,
          4271,
          4273,
          4283,
          4289,
          4297,
          4327,
          4337,
          4339,
          4349,
          4357,
          4363,
          4373,
          4391,
          4397,
          4409,
          4421,
          4423,
          4441,
          4447,
          4451,
          4457,
          4463,
          4481,
          4483,
          4493,
          4507,
          4513,
          4517,
          4519,
          4523,
          4547,
          4549,
          4561,
          4567,
          4583,
          4591,
          4597,
          4603,
          4621,
          4637,
          4639,
          4643,
          4649,
          4651,
          4657,
          4663,
          4673,
          4679,
          4691,
          4703,
          4721,
          4723,
          4729,
          4733,
          4751,
          4759,
          4783,
          4787,
          4789,
          4793,
          4799,
          4801,
          4813,
          4817,
          4831,
          4861,
          4871,
          4877,
          4889,
          4903,
          4909,
          4919,
          4931,
          4933,
          4937,
          4943,
          4951,
          4957,
          4967,
          4969,
          4973,
          4987,
          4993,
          4999,
          5003,
          5009,
          5011,
          5021,
          5023,
          5039,
          5051,
          5059,
          5077,
          5081,
          5087,
          5099,
          5101,
          5107,
          5113,
          5119,
          5147,
          5153,
          5167,
          5171,
          5179,
          5189,
          5197,
          5209,
          5227,
          5231,
          5233,
          5237,
          5261,
          5273,
          5279,
          5281,
          5297,
          5303,
          5309,
          5323,
          5333,
          5347,
          5351,
          5381,
          5387,
          5393,
          5399,
          5407,
          5413,
          5417,
          5419,
          5431,
          5437,
          5441,
          5443,
          5449,
          5471,
          5477,
          5479,
          5483,
          5501,
          5503,
          5507,
          5519,
          5521,
          5527,
          5531,
          5557,
          5563,
          5569,
          5573,
          5581,
          5591,
          5623,
          5639,
          5641,
          5647,
          5651,
          5653,
          5657,
          5659,
          5669,
          5683,
          5689,
          5693,
          5701,
          5711,
          5717,
          5737,
          5741,
          5743,
          5749,
          5779,
          5783,
          5791,
          5801,
          5807,
          5813,
          5821,
          5827,
          5839,
          5843,
          5849,
          5851,
          5857,
          5861,
          5867,
          5869,
          5879,
          5881,
          5897,
          5903,
          5923,
          5927,
          5939,
          5953,
          5981,
          5987,
          6007,
          6011,
          6029,
          6037,
          6043,
          6047,
          6053,
          6067,
          6073,
          6079,
          6089,
          6091,
          6101,
          6113,
          6121,
          6131,
          6133,
          6143,
          6151,
          6163,
          6173,
          6197,
          6199,
          6203,
          6211,
          6217,
          6221,
          6229,
          6247,
          6257,
          6263,
          6269,
          6271,
          6277,
          6287,
          6299,
          6301,
          6311,
          6317,
          6323,
          6329,
          6337,
          6343,
          6353,
          6359,
          6361,
          6367,
          6373,
          6379,
          6389,
          6397,
          6421,
          6427,
          6449,
          6451,
          6469,
          6473,
          6481,
          6491,
          6521,
          6529,
          6547,
          6551,
          6553,
          6563,
          6569,
          6571,
          6577,
          6581,
          6599,
          6607,
          6619,
          6637,
          6653,
          6659,
          6661,
          6673,
          6679,
          6689,
          6691,
          6701,
          6703,
          6709,
          6719,
          6733,
          6737,
          6761,
          6763,
          6779,
          6781,
          6791,
          6793,
          6803,
          6823,
          6827,
          6829,
          6833,
          6841,
          6857,
          6863,
          6869,
          6871,
          6883,
          6899,
          6907,
          6911,
          6917,
          6947,
          6949,
          6959,
          6961,
          6967,
          6971,
          6977,
          6983,
          6991,
          6997,
          7001,
          7013,
          7019,
          7027,
          7039,
          7043,
          7057,
          7069,
          7079,
          7103,
          7109,
          7121,
          7127,
          7129,
          7151,
          7159,
          7177,
          7187,
          7193,
          7207,
          7211,
          7213,
          7219,
          7229,
          7237,
          7243,
          7247,
          7253,
          7283,
          7297,
          7307,
          7309,
          7321,
          7331,
          7333,
          7349,
          7351,
          7369,
          7393,
          7411,
          7417,
          7433,
          7451,
          7457,
          7459,
          7477,
          7481,
          7487,
          7489,
          7499,
          7507,
          7517,
          7523,
          7529,
          7537,
          7541,
          7547,
          7549,
          7559,
          7561,
          7573,
          7577,
          7583,
          7589,
          7591,
          7603,
          7607,
          7621,
          7639,
          7643,
          7649,
          7669,
          7673,
          7681,
          7687,
          7691,
          7699,
          7703,
          7717,
          7723,
          7727,
          7741,
          7753,
          7757,
          7759,
          7789,
          7793,
          7817,
          7823,
          7829,
          7841,
          7853,
          7867,
          7873,
          7877,
          7879,
          7883,
          7901,
          7907,
          7919,
          7927,
          7933,
          7937,
          7949,
          7951,
          7963,
          7993,
          8009,
          8011,
          8017,
          8039,
          8053,
          8059,
          8069,
          8081,
          8087,
          8089,
          8093,
          8101,
          8111,
          8117,
          8123,
          8147,
          8161,
          8167,
          8171,
          8179,
          8191,
          8209,
          8219,
          8221,
          8231,
          8233,
          8237,
          8243,
          8263,
          8269,
          8273,
          8287,
          8291,
          8293,
          8297,
          8311,
          8317,
          8329,
          8353,
          8363,
          8369,
          8377,
          8387,
          8389,
          8419,
          8423,
          8429,
          8431,
          8443,
          8447,
          8461,
          8467,
          8501,
          8513,
          8521,
          8527,
          8537,
          8539,
          8543,
          8563,
          8573,
          8581,
          8597,
          8599,
          8609,
          8623,
          8627,
          8629,
          8641,
          8647,
          8663,
          8669,
          8677,
          8681,
          8689,
          8693,
          8699,
          8707,
          8713,
          8719,
          8731,
          8737,
          8741,
          8747,
          8753,
          8761,
          8779,
          8783,
          8803,
          8807,
          8819,
          8821,
          8831,
          8837,
          8839,
          8849,
          8861,
          8863,
          8867,
          8887,
          8893,
          8923,
          8929,
          8933,
          8941,
          8951,
          8963,
          8969,
          8971,
          8999,
          9001,
          9007,
          9011,
          9013,
          9029,
          9041,
          9043,
          9049,
          9059,
          9067,
          9091,
          9103,
          9109,
          9127,
          9133,
          9137,
          9151,
          9157,
          9161,
          9173,
          9181,
          9187,
          9199,
          9203,
          9209,
          9221,
          9227,
          9239,
          9241,
          9257,
          9277,
          9281,
          9283,
          9293,
          9311,
          9319,
          9323,
          9337,
          9341,
          9343,
          9349,
          9371,
          9377,
          9391,
          9397,
          9403,
          9413,
          9419,
          9421,
          9431,
          9433,
          9437,
          9439,
          9461,
          9463,
          9467,
          9473,
          9479,
          9491,
          9497,
          9511,
          9521,
          9533,
          9539,
          9547,
          9551,
          9587,
          9601,
          9613,
          9619,
          9623,
          9629,
          9631,
          9643,
          9649,
          9661,
          9677,
          9679,
          9689,
          9697,
          9719,
          9721,
          9733,
          9739,
          9743,
          9749,
          9767,
          9769,
          9781,
          9787,
          9791,
          9803,
          9811,
          9817,
          9829,
          9833,
          9839,
          9851,
          9857,
          9859,
          9871,
          9883,
          9887,
          9901,
          9907,
          9923,
          9929,
          9931,
          9941,
          9949,
          9967,
          9973,
          10007
        ],
        emotions: [
          "love",
          "joy",
          "surprise",
          "anger",
          "sadness",
          "fear"
        ],
        music_genres: {
          general: [
            "Rock",
            "Pop",
            "Hip-Hop",
            "Jazz",
            "Classical",
            "Electronic",
            "Country",
            "R&B",
            "Reggae",
            "Blues",
            "Metal",
            "Folk",
            "Alternative",
            "Punk",
            "Disco",
            "Funk",
            "Techno",
            "Indie",
            "Gospel",
            "Dance",
            "Children's",
            "World"
          ],
          alternative: [
            "Art Punk",
            "Alternative Rock",
            "Britpunk",
            "College Rock",
            "Crossover Thrash",
            "Crust Punk",
            "Emo / Emocore",
            "Experimental Rock",
            "Folk Punk",
            "Goth / Gothic Rock",
            "Grunge",
            "Hardcore Punk",
            "Hard Rock",
            "Indie Rock",
            "Lo-fi",
            "Musique Concrète",
            "New Wave",
            "Progressive Rock",
            "Punk",
            "Shoegaze",
            "Steampunk"
          ],
          blues: [
            "Acoustic Blues",
            "African Blues",
            "Blues Rock",
            "Blues Shouter",
            "British Blues",
            "Canadian Blues",
            "Chicago Blues",
            "Classic Blues",
            "Classic Female Blues",
            "Contemporary Blues",
            "Country Blues",
            "Dark Blues",
            "Delta Blues",
            "Detroit Blues",
            "Doom Blues",
            "Electric Blues",
            "Folk Blues",
            "Gospel Blues",
            "Harmonica Blues",
            "Hill Country Blues",
            "Hokum Blues",
            "Jazz Blues",
            "Jump Blues",
            "Kansas City Blues",
            "Louisiana Blues",
            "Memphis Blues",
            "Modern Blues",
            "New Orlean Blues",
            "NY Blues",
            "Piano Blues",
            "Piedmont Blues",
            "Punk Blues",
            "Ragtime Blues",
            "Rhythm Blues",
            "Soul Blues",
            "St.Louis Blues",
            "Soul Blues",
            "Swamp Blues",
            "Texas Blues",
            "Urban Blues",
            "Vandeville",
            "West Coast Blues"
          ],
          "children's": [
            "Lullabies",
            "Sing - Along",
            "Stories"
          ],
          classical: [
            "Avant-Garde",
            "Ballet",
            "Baroque",
            "Cantata",
            "Chamber Music",
            "String Quartet",
            "Chant",
            "Choral",
            "Classical Crossover",
            "Concerto",
            "Concerto Grosso",
            "Contemporary Classical",
            "Early Music",
            "Expressionist",
            "High Classical",
            "Impressionist",
            "Mass Requiem",
            "Medieval",
            "Minimalism",
            "Modern Composition",
            "Modern Classical",
            "Opera",
            "Oratorio",
            "Orchestral",
            "Organum",
            "Renaissance",
            "Romantic (early period)",
            "Romantic (later period)",
            "Sonata",
            "Symphonic",
            "Symphony",
            "Twelve-tone",
            "Wedding Music"
          ],
          country: [
            "Alternative Country",
            "Americana",
            "Australian Country",
            "Bakersfield Sound",
            "Bluegrass",
            "Blues Country",
            "Cajun Fiddle Tunes",
            "Christian Country",
            "Classic Country",
            "Close Harmony",
            "Contemporary Bluegrass",
            "Contemporary Country",
            "Country Gospel",
            "Country Pop",
            "Country Rap",
            "Country Rock",
            "Country Soul",
            "Cowboy / Western",
            "Cowpunk",
            "Dansband",
            "Honky Tonk",
            "Franco-Country",
            "Gulf and Western",
            "Hellbilly Music",
            "Honky Tonk",
            "Instrumental Country",
            "Lubbock Sound",
            "Nashville Sound",
            "Neotraditional Country",
            "Outlaw Country",
            "Progressive",
            "Psychobilly / Punkabilly",
            "Red Dirt",
            "Sertanejo",
            "Texas County",
            "Traditional Bluegrass",
            "Traditional Country",
            "Truck-Driving Country",
            "Urban Cowboy",
            "Western Swing"
          ],
          dance: [
            "Club / Club Dance",
            "Breakcore",
            "Breakbeat / Breakstep",
            "Chillstep",
            "Deep House",
            "Dubstep",
            "Dancehall",
            "Electro House",
            "Electroswing",
            "Exercise",
            "Future Garage",
            "Garage",
            "Glitch Hop",
            "Glitch Pop",
            "Grime",
            "Hardcore",
            "Hard Dance",
            "Hi-NRG / Eurodance",
            "Horrorcore",
            "House",
            "Jackin House",
            "Jungle / Drum n bass",
            "Liquid Dub",
            "Regstep",
            "Speedcore",
            "Techno",
            "Trance",
            "Trap"
          ],
          electronic: [
            "2-Step",
            "8bit",
            "Ambient",
            "Asian Underground",
            "Bassline",
            "Chillwave",
            "Chiptune",
            "Crunk",
            "Downtempo",
            "Drum & Bass",
            "Hard Step",
            "Electro",
            "Electro-swing",
            "Electroacoustic",
            "Electronica",
            "Electronic Rock",
            "Eurodance",
            "Hardstyle",
            "Hi-Nrg",
            "IDM/Experimental",
            "Industrial",
            "Trip Hop",
            "Vaporwave",
            "UK Garage",
            "House",
            "Dubstep",
            "Deep House",
            "EDM",
            "Future Bass",
            "Psychedelic trance"
          ],
          jazz: [
            "Acid Jazz",
            "Afro-Cuban Jazz",
            "Avant-Garde Jazz",
            "Bebop",
            "Big Band",
            "Blue Note",
            "British Dance Band (Jazz)",
            "Cape Jazz",
            "Chamber Jazz",
            "Contemporary Jazz",
            "Continental Jazz",
            "Cool Jazz",
            "Crossover Jazz",
            "Dark Jazz",
            "Dixieland",
            "Early Jazz",
            "Electro Swing (Jazz)",
            "Ethio-jazz",
            "Ethno-Jazz",
            "European Free Jazz",
            "Free Funk (Avant-Garde / Funk Jazz)",
            "Free Jazz",
            "Fusion",
            "Gypsy Jazz",
            "Hard Bop",
            "Indo Jazz",
            "Jazz Blues",
            "Jazz-Funk (see Free Funk)",
            "Jazz-Fusion",
            "Jazz Rap",
            "Jazz Rock",
            "Kansas City Jazz",
            "Latin Jazz",
            "M-Base Jazz",
            "Mainstream Jazz",
            "Modal Jazz",
            "Neo-Bop",
            "Neo-Swing",
            "Nu Jazz",
            "Orchestral Jazz",
            "Post-Bop",
            "Punk Jazz",
            "Ragtime",
            "Ska Jazz",
            "Skiffle (also Folk)",
            "Smooth Jazz",
            "Soul Jazz",
            "Swing Jazz",
            "Straight-Ahead Jazz",
            "Trad Jazz",
            "Third Stream",
            "Jazz-Funk",
            "Free Jazz",
            "West Coast Jazz"
          ],
          metal: [
            "Heavy Metal",
            "Speed Metal",
            "Thrash Metal",
            "Power Metal",
            "Death Metal",
            "Black Metal",
            "Pagan Metal",
            "Viking Metal",
            "Folk Metal",
            "Symphonic Metal",
            "Gothic Metal",
            "Glam Metal",
            "Hair Metal",
            "Doom Metal",
            "Groove Metal",
            "Industrial Metal",
            "Modern Metal",
            "Neoclassical Metal",
            "New Wave Of British Heavy Metal",
            "Post Metal",
            "Progressive Metal",
            "Avantgarde Metal",
            "Sludge",
            "Djent",
            "Drone",
            "Kawaii Metal",
            "Pirate Metal",
            "Nu Metal",
            "Neue Deutsche Härte",
            "Math Metal",
            "Crossover",
            "Grindcore",
            "Hardcore",
            "Metalcore",
            "Deathcore",
            "Post Hardcore",
            "Mathcore"
          ],
          folk: [
            "American Folk Revival",
            "Anti - Folk",
            "British Folk Revival",
            "Contemporary Folk",
            "Filk Music",
            "Freak Folk",
            "Indie Folk",
            "Industrial Folk",
            "Neofolk",
            "Progressive Folk",
            "Psychedelic Folk",
            "Sung Poetry",
            "Techno - Folk",
            "Folk Rock",
            "Old-time Music",
            "Bluegrass",
            "Appalachian",
            "Roots Revival",
            "Celtic",
            "Indie Folk"
          ],
          pop: [
            "Adult Contemporary",
            "Arab Pop",
            "Baroque",
            "Britpop",
            "Bubblegum Pop",
            "Chamber Pop",
            "Chanson",
            "Christian Pop",
            "Classical Crossover",
            "Europop",
            "Austropop",
            "Balkan Pop",
            "French Pop",
            "Korean Pop",
            "Japanese Pop",
            "Chinese Pop",
            "Latin Pop",
            "Laïkó",
            "Nederpop",
            "Russian Pop",
            "Dance Pop",
            "Dream Pop",
            "Electro Pop",
            "Iranian Pop",
            "Jangle Pop",
            "Latin Ballad",
            "Levenslied",
            "Louisiana Swamp Pop",
            "Mexican Pop",
            "Motorpop",
            "New Romanticism",
            "Orchestral Pop",
            "Pop Rap",
            "Popera",
            "Pop / Rock",
            "Pop Punk",
            "Power Pop",
            "Psychedelic Pop",
            "Russian Pop",
            "Schlager",
            "Soft Rock",
            "Sophisti - Pop",
            "Space Age Pop",
            "Sunshine Pop",
            "Surf Pop",
            "Synthpop",
            "Teen Pop",
            "Traditional Pop Music",
            "Turkish Pop",
            "Vispop",
            "Wonky Pop"
          ],
          "r&b": [
            "(Carolina) Beach Music",
            "Contemporary R & B",
            "Disco",
            "Doo Wop",
            "Funk",
            "Modern Soul",
            "Motown",
            "Neo - Soul",
            "Northern Soul",
            "Psychedelic Soul",
            "Quiet Storm",
            "Soul",
            "Soul Blues",
            "Southern Soul"
          ],
          reggae: [
            "2 - Tone",
            "Dub",
            "Roots Reggae",
            "Reggae Fusion",
            "Reggae en Español",
            "Spanish Reggae",
            "Reggae 110",
            "Reggae Bultrón",
            "Romantic Flow",
            "Lovers Rock",
            "Raggamuffin",
            "Ragga",
            "Dancehall",
            "Ska"
          ],
          rock: [
            "Acid Rock",
            "Adult - Oriented Rock",
            "Afro Punk",
            "Adult Alternative",
            "Alternative Rock",
            "American Traditional Rock",
            "Anatolian Rock",
            "Arena Rock",
            "Art Rock",
            "Blues - Rock",
            "British Invasion",
            "Cock Rock",
            "Death Metal / Black Metal",
            "Doom Metal",
            "Glam Rock",
            "Gothic Metal",
            "Grind Core",
            "Hair Metal",
            "Hard Rock",
            "Math Metal",
            "Math Rock",
            "Metal",
            "Metal Core",
            "Noise Rock",
            "Jam Bands",
            "Post Punk",
            "Post Rock",
            "Prog - Rock / Art Rock",
            "Progressive Metal",
            "Psychedelic",
            "Rock & Roll",
            "Rockabilly",
            "Roots Rock",
            "Singer / Songwriter",
            "Southern Rock",
            "Spazzcore",
            "Stoner Metal",
            "Surf",
            "Technical Death Metal",
            "Tex - Mex",
            "Thrash Metal",
            "Time Lord Rock(Trock)",
            "Trip - hop",
            "Yacht Rock",
            "School House Rock"
          ],
          "hip-hop": [
            "Alternative Rap",
            "Avant - Garde",
            "Bounce",
            "Chap Hop",
            "Christian Hip Hop",
            "Conscious Hip Hop",
            "Country - Rap",
            "Grunk",
            "Crunkcore",
            "Cumbia Rap",
            "Dirty South",
            "East Coast",
            "Brick City Club",
            "Hardcore Hip Hop",
            "Mafioso Rap",
            "New Jersey Hip Hop",
            "Freestyle Rap",
            "G - Funk",
            "Gangsta Rap",
            "Golden Age",
            "Grime",
            "Hardcore Rap",
            "Hip - Hop",
            "Hip Pop",
            "Horrorcore",
            "Hyphy",
            "Industrial Hip Hop",
            "Instrumental Hip Hop",
            "Jazz Rap",
            "Latin Rap",
            "Low Bap",
            "Lyrical Hip Hop",
            "Merenrap",
            "Midwest Hip Hop",
            "Chicago Hip Hop",
            "Detroit Hip Hop",
            "Horrorcore",
            "St.Louis Hip Hop",
            "Twin Cities Hip Hop",
            "Motswako",
            "Nerdcore",
            "New Jack Swing",
            "New School Hip Hop",
            "Old School Rap",
            "Rap",
            "Trap",
            "Turntablism",
            "Underground Rap",
            "West Coast Rap",
            "East Coast Rap",
            "Trap",
            "UK Grime",
            "Hyphy",
            "Emo-rap",
            "Cloud rap",
            "G-funk",
            "Boom Bap",
            "Mumble",
            "Drill",
            "UK Drill",
            "Soundcloud Rap",
            "Lo-fi"
          ],
          punk: [
            "Afro-punk",
            "Anarcho punk",
            "Art punk",
            "Christian punk",
            "Crust punk",
            "Deathrock",
            "Egg punk",
            "Garage punk",
            "Glam punk",
            "Hardcore punk",
            "Horror punk",
            "Incelcore/e-punk",
            "Oi!",
            "Peace punk",
            "Punk pathetique",
            "Queercore",
            "Riot Grrrl",
            "Skate punk",
            "Street punk",
            "Taqwacore",
            "Trallpunk"
          ],
          disco: [
            "Nu-disco",
            "Disco-funk",
            "Hi-NRG",
            "Italo Disco",
            "Eurodisco",
            "Boogie",
            "Space Disco",
            "Post-disco",
            "Electro Disco",
            "Disco House",
            "Disco Pop",
            "Soulful House"
          ],
          funk: [
            "Funk Rock",
            "P-Funk (Parliament-Funkadelic)",
            "Psychedelic Funk",
            "Funk Metal",
            "Electro-Funk",
            "Go-go",
            "Boogie-Funk",
            "Jazz-Funk",
            "Soul-Funk",
            "Funky Disco",
            "Nu-Funk",
            "Afrobeat",
            "Latin Funk",
            "G-Funk",
            "Acid Jazz",
            "Funktronica",
            "Folk-Funk",
            "Space Funk",
            "Ambient Funk",
            "Hard Funk",
            "Fusion Funk"
          ],
          techno: [
            "Acid Techno",
            "Ambient Techno",
            "Detroit Techno",
            "Dub Techno",
            "Minimal Techno",
            "Industrial Techno",
            "Hard Techno",
            "Trance",
            "Progressive Techno",
            "Tech House",
            "Electronica",
            "Breakbeat Techno",
            "Electro Techno",
            "Melodic Techno",
            "Experimental Techno",
            "Dark Techno",
            "Ebm",
            "Hypnotic Techno",
            "Psychedelic Techno",
            "Rave Techno",
            "Techno-Pop"
          ],
          indie: [
            "Indie Rock",
            "Indie Pop",
            "Indie Folk",
            "Indie Electronic",
            "Indie Punk",
            "Indie Hip-Hop",
            "Dream Pop",
            "Shoegaze",
            "Lo-fi",
            "Chillwave",
            "Freak Folk",
            "Noise Pop",
            "Math Rock",
            "Post-Punk",
            "Garage Rock",
            "Experimental Indie",
            "Surf Rock",
            "Alternative Country",
            "Indie Soul",
            "Art Rock",
            "Indie R&B",
            "Indietronica",
            "Emo",
            "Post-Rock",
            "Indie Pop-Rock",
            "Indie Synthpop",
            "Noise Rock",
            "Psych Folk",
            "Indie Blues"
          ],
          gospel: [
            "Traditional Gospel",
            "Contemporary Gospel",
            "Southern Gospel",
            "Black Gospel",
            "Urban Contemporary Gospel",
            "Gospel Blues",
            "Bluegrass Gospel",
            "Country Gospel",
            "Praise and Worship",
            "Christian Hip-Hop",
            "Gospel Jazz",
            "Reggae Gospel",
            "African Gospel",
            "Latin Gospel",
            "R&B Gospel",
            "Gospel Choir",
            "Acappella Gospel",
            "Instrumental Gospel",
            "Gospel Rap"
          ],
          world: [
            "African",
            "Arabic",
            "Asian",
            "Caribbean",
            "Celtic",
            "European",
            "Latin American",
            "Middle Eastern",
            "Native American",
            "Polynesian",
            "Reggae",
            "Ska",
            "Salsa",
            "Flamenco",
            "Bossa Nova",
            "Tango",
            "Fado",
            "Klezmer",
            "Balkan",
            "Afrobeat",
            "Mongolian Throat Singing",
            "Indian Classical",
            "Gamelan",
            "Sufi Music",
            "Zydeco",
            "Kora Music",
            "Andean Music",
            "Irish Traditional",
            "Gypsy Jazz",
            "Bollywood",
            "Bhangra",
            "Jawaiian",
            "Hawaiian Slack Key Guitar",
            "Calypso",
            "Cuban Son",
            "Taiko Drumming",
            "African Highlife",
            "Merengue",
            "Tuvan Throat Singing"
          ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
          smileys_and_emotion: [
            "0x1f600",
            "0x1f603",
            "0x1f604",
            "0x1f601",
            "0x1f606",
            "0x1f605",
            "0x1f923",
            "0x1f602",
            "0x1f642",
            "0x1f643",
            "0x1fae0",
            "0x1f609",
            "0x1f60a",
            "0x1f607",
            "0x1f970",
            "0x1f60d",
            "0x1f929",
            "0x1f618",
            "0x1f617",
            "0x263a",
            "0x1f61a",
            "0x1f619",
            "0x1f972",
            "0x1f60b",
            "0x1f61b",
            "0x1f61c",
            "0x1f92a",
            "0x1f61d",
            "0x1f911",
            "0x1f917",
            "0x1f92d",
            "0x1fae2",
            "0x1fae3",
            "0x1f92b",
            "0x1f914",
            "0x1fae1",
            "0x1f910",
            "0x1f928",
            "0x1f610",
            "0x1f611",
            "0x1f636",
            "0x1fae5",
            "0x1f636",
            "0x200d",
            "0x1f32b",
            "0xfe0f",
            "0x1f60f",
            "0x1f612",
            "0x1f644",
            "0x1f62c",
            "0x1f62e",
            "0x200d",
            "0x1f4a8",
            "0x1f925",
            "0x1fae8",
            "0x1f642",
            "0x200d",
            "0x2194",
            "0xfe0f",
            "0x1f642",
            "0x200d",
            "0x2195",
            "0xfe0f",
            "0x1f60c",
            "0x1f614",
            "0x1f62a",
            "0x1f924",
            "0x1f634",
            "0x1f637",
            "0x1f912",
            "0x1f915",
            "0x1f922",
            "0x1f92e",
            "0x1f927",
            "0x1f975",
            "0x1f976",
            "0x1f974",
            "0x1f635",
            "0x1f635",
            "0x200d",
            "0x1f4ab",
            "0x1f92f",
            "0x1f920",
            "0x1f973",
            "0x1f978",
            "0x1f60e",
            "0x1f913",
            "0x1f9d0",
            "0x1f615",
            "0x1fae4",
            "0x1f61f",
            "0x1f641",
            "0x2639",
            "0x1f62e",
            "0x1f62f",
            "0x1f632",
            "0x1f633",
            "0x1f97a",
            "0x1f979",
            "0x1f626",
            "0x1f627",
            "0x1f628",
            "0x1f630",
            "0x1f625",
            "0x1f622",
            "0x1f62d",
            "0x1f631",
            "0x1f616",
            "0x1f623",
            "0x1f61e",
            "0x1f613",
            "0x1f629",
            "0x1f62b",
            "0x1f971",
            "0x1f624",
            "0x1f621",
            "0x1f620",
            "0x1f92c",
            "0x1f608",
            "0x1f47f",
            "0x1f480",
            "0x2620",
            "0x1f4a9",
            "0x1f921",
            "0x1f479",
            "0x1f47a",
            "0x1f47b",
            "0x1f47d",
            "0x1f47e",
            "0x1f916",
            "0x1f63a",
            "0x1f638",
            "0x1f639",
            "0x1f63b",
            "0x1f63c",
            "0x1f63d",
            "0x1f640",
            "0x1f63f",
            "0x1f63e",
            "0x1f648",
            "0x1f649",
            "0x1f64a",
            "0x1f48c",
            "0x1f498",
            "0x1f49d",
            "0x1f496",
            "0x1f497",
            "0x1f493",
            "0x1f49e",
            "0x1f495",
            "0x1f49f",
            "0x2763",
            "0x1f494",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f525",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1fa79",
            "0x2764",
            "0x1fa77",
            "0x1f9e1",
            "0x1f49b",
            "0x1f49a",
            "0x1f499",
            "0x1fa75",
            "0x1f49c",
            "0x1f90e",
            "0x1f5a4",
            "0x1fa76",
            "0x1f90d",
            "0x1f48b",
            "0x1f4af",
            "0x1f4a2",
            "0x1f4a5",
            "0x1f4ab",
            "0x1f4a6",
            "0x1f4a8",
            "0x1f573",
            "0x1f4ac",
            "0x1f441",
            "0xfe0f",
            "0x200d",
            "0x1f5e8",
            "0xfe0f",
            "0x1f5e8",
            "0x1f5ef",
            "0x1f4ad",
            "0x1f4a4"
          ],
          people_and_body: [
            "0x1f44b",
            "0x1f91a",
            "0x1f590",
            "0x270b",
            "0x1f596",
            "0x1faf1",
            "0x1faf2",
            "0x1faf3",
            "0x1faf4",
            "0x1faf7",
            "0x1faf8",
            "0x1f44c",
            "0x1f90c",
            "0x1f90f",
            "0x270c",
            "0x1f91e",
            "0x1faf0",
            "0x1f91f",
            "0x1f918",
            "0x1f919",
            "0x1f448",
            "0x1f449",
            "0x1f446",
            "0x1f595",
            "0x1f447",
            "0x261d",
            "0x1faf5",
            "0x1f44d",
            "0x1f44e",
            "0x270a",
            "0x1f44a",
            "0x1f91b",
            "0x1f91c",
            "0x1f44f",
            "0x1f64c",
            "0x1faf6",
            "0x1f450",
            "0x1f932",
            "0x1f91d",
            "0x1f64f",
            "0x270d",
            "0x1f485",
            "0x1f933",
            "0x1f4aa",
            "0x1f9be",
            "0x1f9bf",
            "0x1f9b5",
            "0x1f9b6",
            "0x1f442",
            "0x1f9bb",
            "0x1f443",
            "0x1f9e0",
            "0x1fac0",
            "0x1fac1",
            "0x1f9b7",
            "0x1f9b4",
            "0x1f440",
            "0x1f441",
            "0x1f445",
            "0x1f444",
            "0x1fae6",
            "0x1f476",
            "0x1f9d2",
            "0x1f466",
            "0x1f467",
            "0x1f9d1",
            "0x1f471",
            "0x1f468",
            "0x1f9d4",
            "0x1f9d4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9b0",
            "0x1f468",
            "0x200d",
            "0x1f9b1",
            "0x1f468",
            "0x200d",
            "0x1f9b3",
            "0x1f468",
            "0x200d",
            "0x1f9b2",
            "0x1f469",
            "0x1f469",
            "0x200d",
            "0x1f9b0",
            "0x1f9d1",
            "0x200d",
            "0x1f9b0",
            "0x1f469",
            "0x200d",
            "0x1f9b1",
            "0x1f9d1",
            "0x200d",
            "0x1f9b1",
            "0x1f469",
            "0x200d",
            "0x1f9b3",
            "0x1f9d1",
            "0x200d",
            "0x1f9b3",
            "0x1f469",
            "0x200d",
            "0x1f9b2",
            "0x1f9d1",
            "0x200d",
            "0x1f9b2",
            "0x1f471",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f471",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d3",
            "0x1f474",
            "0x1f475",
            "0x1f64d",
            "0x1f64d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64e",
            "0x1f64e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f645",
            "0x1f645",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f645",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f646",
            "0x1f646",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f646",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f481",
            "0x1f481",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f481",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64b",
            "0x1f64b",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64b",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cf",
            "0x1f9cf",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cf",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f647",
            "0x1f647",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f647",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f926",
            "0x1f926",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f926",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f937",
            "0x1f937",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f937",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f393",
            "0x1f468",
            "0x200d",
            "0x1f393",
            "0x1f469",
            "0x200d",
            "0x1f393",
            "0x1f9d1",
            "0x200d",
            "0x1f3eb",
            "0x1f468",
            "0x200d",
            "0x1f3eb",
            "0x1f469",
            "0x200d",
            "0x1f3eb",
            "0x1f9d1",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f33e",
            "0x1f468",
            "0x200d",
            "0x1f33e",
            "0x1f469",
            "0x200d",
            "0x1f33e",
            "0x1f9d1",
            "0x200d",
            "0x1f373",
            "0x1f468",
            "0x200d",
            "0x1f373",
            "0x1f469",
            "0x200d",
            "0x1f373",
            "0x1f9d1",
            "0x200d",
            "0x1f527",
            "0x1f468",
            "0x200d",
            "0x1f527",
            "0x1f469",
            "0x200d",
            "0x1f527",
            "0x1f9d1",
            "0x200d",
            "0x1f3ed",
            "0x1f468",
            "0x200d",
            "0x1f3ed",
            "0x1f469",
            "0x200d",
            "0x1f3ed",
            "0x1f9d1",
            "0x200d",
            "0x1f4bc",
            "0x1f468",
            "0x200d",
            "0x1f4bc",
            "0x1f469",
            "0x200d",
            "0x1f4bc",
            "0x1f9d1",
            "0x200d",
            "0x1f52c",
            "0x1f468",
            "0x200d",
            "0x1f52c",
            "0x1f469",
            "0x200d",
            "0x1f52c",
            "0x1f9d1",
            "0x200d",
            "0x1f4bb",
            "0x1f468",
            "0x200d",
            "0x1f4bb",
            "0x1f469",
            "0x200d",
            "0x1f4bb",
            "0x1f9d1",
            "0x200d",
            "0x1f3a4",
            "0x1f468",
            "0x200d",
            "0x1f3a4",
            "0x1f469",
            "0x200d",
            "0x1f3a4",
            "0x1f9d1",
            "0x200d",
            "0x1f3a8",
            "0x1f468",
            "0x200d",
            "0x1f3a8",
            "0x1f469",
            "0x200d",
            "0x1f3a8",
            "0x1f9d1",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f680",
            "0x1f468",
            "0x200d",
            "0x1f680",
            "0x1f469",
            "0x200d",
            "0x1f680",
            "0x1f9d1",
            "0x200d",
            "0x1f692",
            "0x1f468",
            "0x200d",
            "0x1f692",
            "0x1f469",
            "0x200d",
            "0x1f692",
            "0x1f46e",
            "0x1f46e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f575",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f482",
            "0x1f482",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f482",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f977",
            "0x1f477",
            "0x1f477",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f477",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1fac5",
            "0x1f934",
            "0x1f478",
            "0x1f473",
            "0x1f473",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f473",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f472",
            "0x1f9d5",
            "0x1f935",
            "0x1f935",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f935",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f470",
            "0x1f470",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f470",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f930",
            "0x1fac3",
            "0x1fac4",
            "0x1f931",
            "0x1f469",
            "0x200d",
            "0x1f37c",
            "0x1f468",
            "0x200d",
            "0x1f37c",
            "0x1f9d1",
            "0x200d",
            "0x1f37c",
            "0x1f47c",
            "0x1f385",
            "0x1f936",
            "0x1f9d1",
            "0x200d",
            "0x1f384",
            "0x1f9b8",
            "0x1f9b8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9b9",
            "0x1f9b9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d9",
            "0x1f9d9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9da",
            "0x1f9da",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9da",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9db",
            "0x1f9db",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9db",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dc",
            "0x1f9dc",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dc",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dd",
            "0x1f9dd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9de",
            "0x1f9de",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9de",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9df",
            "0x1f9df",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9df",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cc",
            "0x1f486",
            "0x1f486",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f486",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f487",
            "0x1f487",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f487",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9cd",
            "0x1f9cd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f483",
            "0x1f57a",
            "0x1f574",
            "0x1f46f",
            "0x1f46f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d6",
            "0x1f9d6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d7",
            "0x1f9d7",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d7",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93a",
            "0x1f3c7",
            "0x26f7",
            "0x1f3c2",
            "0x1f3cc",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c4",
            "0x1f3c4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6a3",
            "0x1f6a3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6a3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3ca",
            "0x1f3ca",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3ca",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x26f9",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3cb",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b4",
            "0x1f6b4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b5",
            "0x1f6b5",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b5",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f938",
            "0x1f938",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f938",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93c",
            "0x1f93c",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93c",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93d",
            "0x1f93d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93e",
            "0x1f93e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f939",
            "0x1f939",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f939",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d8",
            "0x1f9d8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6c0",
            "0x1f6cc",
            "0x1f9d1",
            "0x200d",
            "0x1f91d",
            "0x200d",
            "0x1f9d1",
            "0x1f46d",
            "0x1f46b",
            "0x1f46c",
            "0x1f48f",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f469",
            "0x1f491",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f469",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f5e3",
            "0x1f464",
            "0x1f465",
            "0x1fac2",
            "0x1f46a",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f463"
          ],
          animals_and_nature: [
            "0x1f435",
            "0x1f412",
            "0x1f98d",
            "0x1f9a7",
            "0x1f436",
            "0x1f415",
            "0x1f9ae",
            "0x1f415",
            "0x200d",
            "0x1f9ba",
            "0x1f429",
            "0x1f43a",
            "0x1f98a",
            "0x1f99d",
            "0x1f431",
            "0x1f408",
            "0x1f408",
            "0x200d",
            "0x2b1b",
            "0x1f981",
            "0x1f42f",
            "0x1f405",
            "0x1f406",
            "0x1f434",
            "0x1face",
            "0x1facf",
            "0x1f40e",
            "0x1f984",
            "0x1f993",
            "0x1f98c",
            "0x1f9ac",
            "0x1f42e",
            "0x1f402",
            "0x1f403",
            "0x1f404",
            "0x1f437",
            "0x1f416",
            "0x1f417",
            "0x1f43d",
            "0x1f40f",
            "0x1f411",
            "0x1f410",
            "0x1f42a",
            "0x1f42b",
            "0x1f999",
            "0x1f992",
            "0x1f418",
            "0x1f9a3",
            "0x1f98f",
            "0x1f99b",
            "0x1f42d",
            "0x1f401",
            "0x1f400",
            "0x1f439",
            "0x1f430",
            "0x1f407",
            "0x1f43f",
            "0x1f9ab",
            "0x1f994",
            "0x1f987",
            "0x1f43b",
            "0x1f43b",
            "0x200d",
            "0x2744",
            "0xfe0f",
            "0x1f428",
            "0x1f43c",
            "0x1f9a5",
            "0x1f9a6",
            "0x1f9a8",
            "0x1f998",
            "0x1f9a1",
            "0x1f43e",
            "0x1f983",
            "0x1f414",
            "0x1f413",
            "0x1f423",
            "0x1f424",
            "0x1f425",
            "0x1f426",
            "0x1f427",
            "0x1f54a",
            "0x1f985",
            "0x1f986",
            "0x1f9a2",
            "0x1f989",
            "0x1f9a4",
            "0x1fab6",
            "0x1f9a9",
            "0x1f99a",
            "0x1f99c",
            "0x1fabd",
            "0x1f426",
            "0x200d",
            "0x2b1b",
            "0x1fabf",
            "0x1f426",
            "0x200d",
            "0x1f525",
            "0x1f438",
            "0x1f40a",
            "0x1f422",
            "0x1f98e",
            "0x1f40d",
            "0x1f432",
            "0x1f409",
            "0x1f995",
            "0x1f996",
            "0x1f433",
            "0x1f40b",
            "0x1f42c",
            "0x1f9ad",
            "0x1f41f",
            "0x1f420",
            "0x1f421",
            "0x1f988",
            "0x1f419",
            "0x1f41a",
            "0x1fab8",
            "0x1fabc",
            "0x1f40c",
            "0x1f98b",
            "0x1f41b",
            "0x1f41c",
            "0x1f41d",
            "0x1fab2",
            "0x1f41e",
            "0x1f997",
            "0x1fab3",
            "0x1f577",
            "0x1f578",
            "0x1f982",
            "0x1f99f",
            "0x1fab0",
            "0x1fab1",
            "0x1f9a0",
            "0x1f490",
            "0x1f338",
            "0x1f4ae",
            "0x1fab7",
            "0x1f3f5",
            "0x1f339",
            "0x1f940",
            "0x1f33a",
            "0x1f33b",
            "0x1f33c",
            "0x1f337",
            "0x1fabb",
            "0x1f331",
            "0x1fab4",
            "0x1f332",
            "0x1f333",
            "0x1f334",
            "0x1f335",
            "0x1f33e",
            "0x1f33f",
            "0x2618",
            "0x1f340",
            "0x1f341",
            "0x1f342",
            "0x1f343",
            "0x1fab9",
            "0x1faba",
            "0x1f344"
          ],
          food_and_drink: [
            "0x1f347",
            "0x1f348",
            "0x1f349",
            "0x1f34a",
            "0x1f34b",
            "0x1f34b",
            "0x200d",
            "0x1f7e9",
            "0x1f34c",
            "0x1f34d",
            "0x1f96d",
            "0x1f34e",
            "0x1f34f",
            "0x1f350",
            "0x1f351",
            "0x1f352",
            "0x1f353",
            "0x1fad0",
            "0x1f95d",
            "0x1f345",
            "0x1fad2",
            "0x1f965",
            "0x1f951",
            "0x1f346",
            "0x1f954",
            "0x1f955",
            "0x1f33d",
            "0x1f336",
            "0x1fad1",
            "0x1f952",
            "0x1f96c",
            "0x1f966",
            "0x1f9c4",
            "0x1f9c5",
            "0x1f95c",
            "0x1fad8",
            "0x1f330",
            "0x1fada",
            "0x1fadb",
            "0x1f344",
            "0x200d",
            "0x1f7eb",
            "0x1f35e",
            "0x1f950",
            "0x1f956",
            "0x1fad3",
            "0x1f968",
            "0x1f96f",
            "0x1f95e",
            "0x1f9c7",
            "0x1f9c0",
            "0x1f356",
            "0x1f357",
            "0x1f969",
            "0x1f953",
            "0x1f354",
            "0x1f35f",
            "0x1f355",
            "0x1f32d",
            "0x1f96a",
            "0x1f32e",
            "0x1f32f",
            "0x1fad4",
            "0x1f959",
            "0x1f9c6",
            "0x1f95a",
            "0x1f373",
            "0x1f958",
            "0x1f372",
            "0x1fad5",
            "0x1f963",
            "0x1f957",
            "0x1f37f",
            "0x1f9c8",
            "0x1f9c2",
            "0x1f96b",
            "0x1f371",
            "0x1f358",
            "0x1f359",
            "0x1f35a",
            "0x1f35b",
            "0x1f35c",
            "0x1f35d",
            "0x1f360",
            "0x1f362",
            "0x1f363",
            "0x1f364",
            "0x1f365",
            "0x1f96e",
            "0x1f361",
            "0x1f95f",
            "0x1f960",
            "0x1f961",
            "0x1f980",
            "0x1f99e",
            "0x1f990",
            "0x1f991",
            "0x1f9aa",
            "0x1f366",
            "0x1f367",
            "0x1f368",
            "0x1f369",
            "0x1f36a",
            "0x1f382",
            "0x1f370",
            "0x1f9c1",
            "0x1f967",
            "0x1f36b",
            "0x1f36c",
            "0x1f36d",
            "0x1f36e",
            "0x1f36f",
            "0x1f37c",
            "0x1f95b",
            "0x2615",
            "0x1fad6",
            "0x1f375",
            "0x1f376",
            "0x1f37e",
            "0x1f377",
            "0x1f378",
            "0x1f379",
            "0x1f37a",
            "0x1f37b",
            "0x1f942",
            "0x1f943",
            "0x1fad7",
            "0x1f964",
            "0x1f9cb",
            "0x1f9c3",
            "0x1f9c9",
            "0x1f9ca",
            "0x1f962",
            "0x1f37d",
            "0x1f374",
            "0x1f944",
            "0x1f52a",
            "0x1fad9",
            "0x1f3fa"
          ],
          travel_and_places: [
            "0x1f30d",
            "0x1f30e",
            "0x1f30f",
            "0x1f310",
            "0x1f5fa",
            "0x1f5fe",
            "0x1f9ed",
            "0x1f3d4",
            "0x26f0",
            "0x1f30b",
            "0x1f5fb",
            "0x1f3d5",
            "0x1f3d6",
            "0x1f3dc",
            "0x1f3dd",
            "0x1f3de",
            "0x1f3df",
            "0x1f3db",
            "0x1f3d7",
            "0x1f9f1",
            "0x1faa8",
            "0x1fab5",
            "0x1f6d6",
            "0x1f3d8",
            "0x1f3da",
            "0x1f3e0",
            "0x1f3e1",
            "0x1f3e2",
            "0x1f3e3",
            "0x1f3e4",
            "0x1f3e5",
            "0x1f3e6",
            "0x1f3e8",
            "0x1f3e9",
            "0x1f3ea",
            "0x1f3eb",
            "0x1f3ec",
            "0x1f3ed",
            "0x1f3ef",
            "0x1f3f0",
            "0x1f492",
            "0x1f5fc",
            "0x1f5fd",
            "0x26ea",
            "0x1f54c",
            "0x1f6d5",
            "0x1f54d",
            "0x26e9",
            "0x1f54b",
            "0x26f2",
            "0x26fa",
            "0x1f301",
            "0x1f303",
            "0x1f3d9",
            "0x1f304",
            "0x1f305",
            "0x1f306",
            "0x1f307",
            "0x1f309",
            "0x2668",
            "0x1f3a0",
            "0x1f6dd",
            "0x1f3a1",
            "0x1f3a2",
            "0x1f488",
            "0x1f3aa",
            "0x1f682",
            "0x1f683",
            "0x1f684",
            "0x1f685",
            "0x1f686",
            "0x1f687",
            "0x1f688",
            "0x1f689",
            "0x1f68a",
            "0x1f69d",
            "0x1f69e",
            "0x1f68b",
            "0x1f68c",
            "0x1f68d",
            "0x1f68e",
            "0x1f690",
            "0x1f691",
            "0x1f692",
            "0x1f693",
            "0x1f694",
            "0x1f695",
            "0x1f696",
            "0x1f697",
            "0x1f698",
            "0x1f699",
            "0x1f6fb",
            "0x1f69a",
            "0x1f69b",
            "0x1f69c",
            "0x1f3ce",
            "0x1f3cd",
            "0x1f6f5",
            "0x1f9bd",
            "0x1f9bc",
            "0x1f6fa",
            "0x1f6b2",
            "0x1f6f4",
            "0x1f6f9",
            "0x1f6fc",
            "0x1f68f",
            "0x1f6e3",
            "0x1f6e4",
            "0x1f6e2",
            "0x26fd",
            "0x1f6de",
            "0x1f6a8",
            "0x1f6a5",
            "0x1f6a6",
            "0x1f6d1",
            "0x1f6a7",
            "0x2693",
            "0x1f6df",
            "0x26f5",
            "0x1f6f6",
            "0x1f6a4",
            "0x1f6f3",
            "0x26f4",
            "0x1f6e5",
            "0x1f6a2",
            "0x2708",
            "0x1f6e9",
            "0x1f6eb",
            "0x1f6ec",
            "0x1fa82",
            "0x1f4ba",
            "0x1f681",
            "0x1f69f",
            "0x1f6a0",
            "0x1f6a1",
            "0x1f6f0",
            "0x1f680",
            "0x1f6f8",
            "0x1f6ce",
            "0x1f9f3",
            "0x231b",
            "0x23f3",
            "0x231a",
            "0x23f0",
            "0x23f1",
            "0x23f2",
            "0x1f570",
            "0x1f55b",
            "0x1f567",
            "0x1f550",
            "0x1f55c",
            "0x1f551",
            "0x1f55d",
            "0x1f552",
            "0x1f55e",
            "0x1f553",
            "0x1f55f",
            "0x1f554",
            "0x1f560",
            "0x1f555",
            "0x1f561",
            "0x1f556",
            "0x1f562",
            "0x1f557",
            "0x1f563",
            "0x1f558",
            "0x1f564",
            "0x1f559",
            "0x1f565",
            "0x1f55a",
            "0x1f566",
            "0x1f311",
            "0x1f312",
            "0x1f313",
            "0x1f314",
            "0x1f315",
            "0x1f316",
            "0x1f317",
            "0x1f318",
            "0x1f319",
            "0x1f31a",
            "0x1f31b",
            "0x1f31c",
            "0x1f321",
            "0x2600",
            "0x1f31d",
            "0x1f31e",
            "0x1fa90",
            "0x2b50",
            "0x1f31f",
            "0x1f320",
            "0x1f30c",
            "0x2601",
            "0x26c5",
            "0x26c8",
            "0x1f324",
            "0x1f325",
            "0x1f326",
            "0x1f327",
            "0x1f328",
            "0x1f329",
            "0x1f32a",
            "0x1f32b",
            "0x1f32c",
            "0x1f300",
            "0x1f308",
            "0x1f302",
            "0x2602",
            "0x2614",
            "0x26f1",
            "0x26a1",
            "0x2744",
            "0x2603",
            "0x26c4",
            "0x2604",
            "0x1f525",
            "0x1f4a7",
            "0x1f30a"
          ],
          activities: [
            "0x1f383",
            "0x1f384",
            "0x1f386",
            "0x1f387",
            "0x1f9e8",
            "0x2728",
            "0x1f388",
            "0x1f389",
            "0x1f38a",
            "0x1f38b",
            "0x1f38d",
            "0x1f38e",
            "0x1f38f",
            "0x1f390",
            "0x1f391",
            "0x1f9e7",
            "0x1f380",
            "0x1f381",
            "0x1f397",
            "0x1f39f",
            "0x1f3ab",
            "0x1f396",
            "0x1f3c6",
            "0x1f3c5",
            "0x1f947",
            "0x1f948",
            "0x1f949",
            "0x26bd",
            "0x26be",
            "0x1f94e",
            "0x1f3c0",
            "0x1f3d0",
            "0x1f3c8",
            "0x1f3c9",
            "0x1f3be",
            "0x1f94f",
            "0x1f3b3",
            "0x1f3cf",
            "0x1f3d1",
            "0x1f3d2",
            "0x1f94d",
            "0x1f3d3",
            "0x1f3f8",
            "0x1f94a",
            "0x1f94b",
            "0x1f945",
            "0x26f3",
            "0x26f8",
            "0x1f3a3",
            "0x1f93f",
            "0x1f3bd",
            "0x1f3bf",
            "0x1f6f7",
            "0x1f94c",
            "0x1f3af",
            "0x1fa80",
            "0x1fa81",
            "0x1f52b",
            "0x1f3b1",
            "0x1f52e",
            "0x1fa84",
            "0x1f3ae",
            "0x1f579",
            "0x1f3b0",
            "0x1f3b2",
            "0x1f9e9",
            "0x1f9f8",
            "0x1fa85",
            "0x1faa9",
            "0x1fa86",
            "0x2660",
            "0x2665",
            "0x2666",
            "0x2663",
            "0x265f",
            "0x1f0cf",
            "0x1f004",
            "0x1f3b4",
            "0x1f3ad",
            "0x1f5bc",
            "0x1f3a8",
            "0x1f9f5",
            "0x1faa1",
            "0x1f9f6",
            "0x1faa2"
          ],
          objects: [
            "0x1f453",
            "0x1f576",
            "0x1f97d",
            "0x1f97c",
            "0x1f9ba",
            "0x1f454",
            "0x1f455",
            "0x1f456",
            "0x1f9e3",
            "0x1f9e4",
            "0x1f9e5",
            "0x1f9e6",
            "0x1f457",
            "0x1f458",
            "0x1f97b",
            "0x1fa71",
            "0x1fa72",
            "0x1fa73",
            "0x1f459",
            "0x1f45a",
            "0x1faad",
            "0x1f45b",
            "0x1f45c",
            "0x1f45d",
            "0x1f6cd",
            "0x1f392",
            "0x1fa74",
            "0x1f45e",
            "0x1f45f",
            "0x1f97e",
            "0x1f97f",
            "0x1f460",
            "0x1f461",
            "0x1fa70",
            "0x1f462",
            "0x1faae",
            "0x1f451",
            "0x1f452",
            "0x1f3a9",
            "0x1f393",
            "0x1f9e2",
            "0x1fa96",
            "0x26d1",
            "0x1f4ff",
            "0x1f484",
            "0x1f48d",
            "0x1f48e",
            "0x1f507",
            "0x1f508",
            "0x1f509",
            "0x1f50a",
            "0x1f4e2",
            "0x1f4e3",
            "0x1f4ef",
            "0x1f514",
            "0x1f515",
            "0x1f3bc",
            "0x1f3b5",
            "0x1f3b6",
            "0x1f399",
            "0x1f39a",
            "0x1f39b",
            "0x1f3a4",
            "0x1f3a7",
            "0x1f4fb",
            "0x1f3b7",
            "0x1fa97",
            "0x1f3b8",
            "0x1f3b9",
            "0x1f3ba",
            "0x1f3bb",
            "0x1fa95",
            "0x1f941",
            "0x1fa98",
            "0x1fa87",
            "0x1fa88",
            "0x1f4f1",
            "0x1f4f2",
            "0x260e",
            "0x1f4de",
            "0x1f4df",
            "0x1f4e0",
            "0x1f50b",
            "0x1faab",
            "0x1f50c",
            "0x1f4bb",
            "0x1f5a5",
            "0x1f5a8",
            "0x2328",
            "0x1f5b1",
            "0x1f5b2",
            "0x1f4bd",
            "0x1f4be",
            "0x1f4bf",
            "0x1f4c0",
            "0x1f9ee",
            "0x1f3a5",
            "0x1f39e",
            "0x1f4fd",
            "0x1f3ac",
            "0x1f4fa",
            "0x1f4f7",
            "0x1f4f8",
            "0x1f4f9",
            "0x1f4fc",
            "0x1f50d",
            "0x1f50e",
            "0x1f56f",
            "0x1f4a1",
            "0x1f526",
            "0x1f3ee",
            "0x1fa94",
            "0x1f4d4",
            "0x1f4d5",
            "0x1f4d6",
            "0x1f4d7",
            "0x1f4d8",
            "0x1f4d9",
            "0x1f4da",
            "0x1f4d3",
            "0x1f4d2",
            "0x1f4c3",
            "0x1f4dc",
            "0x1f4c4",
            "0x1f4f0",
            "0x1f5de",
            "0x1f4d1",
            "0x1f516",
            "0x1f3f7",
            "0x1f4b0",
            "0x1fa99",
            "0x1f4b4",
            "0x1f4b5",
            "0x1f4b6",
            "0x1f4b7",
            "0x1f4b8",
            "0x1f4b3",
            "0x1f9fe",
            "0x1f4b9",
            "0x2709",
            "0x1f4e7",
            "0x1f4e8",
            "0x1f4e9",
            "0x1f4e4",
            "0x1f4e5",
            "0x1f4e6",
            "0x1f4eb",
            "0x1f4ea",
            "0x1f4ec",
            "0x1f4ed",
            "0x1f4ee",
            "0x1f5f3",
            "0x270f",
            "0x2712",
            "0x1f58b",
            "0x1f58a",
            "0x1f58c",
            "0x1f58d",
            "0x1f4dd",
            "0x1f4bc",
            "0x1f4c1",
            "0x1f4c2",
            "0x1f5c2",
            "0x1f4c5",
            "0x1f4c6",
            "0x1f5d2",
            "0x1f5d3",
            "0x1f4c7",
            "0x1f4c8",
            "0x1f4c9",
            "0x1f4ca",
            "0x1f4cb",
            "0x1f4cc",
            "0x1f4cd",
            "0x1f4ce",
            "0x1f587",
            "0x1f4cf",
            "0x1f4d0",
            "0x2702",
            "0x1f5c3",
            "0x1f5c4",
            "0x1f5d1",
            "0x1f512",
            "0x1f513",
            "0x1f50f",
            "0x1f510",
            "0x1f511",
            "0x1f5dd",
            "0x1f528",
            "0x1fa93",
            "0x26cf",
            "0x2692",
            "0x1f6e0",
            "0x1f5e1",
            "0x2694",
            "0x1f4a3",
            "0x1fa83",
            "0x1f3f9",
            "0x1f6e1",
            "0x1fa9a",
            "0x1f527",
            "0x1fa9b",
            "0x1f529",
            "0x2699",
            "0x1f5dc",
            "0x2696",
            "0x1f9af",
            "0x1f517",
            "0x26d3",
            "0xfe0f",
            "0x200d",
            "0x1f4a5",
            "0x26d3",
            "0x1fa9d",
            "0x1f9f0",
            "0x1f9f2",
            "0x1fa9c",
            "0x2697",
            "0x1f9ea",
            "0x1f9eb",
            "0x1f9ec",
            "0x1f52c",
            "0x1f52d",
            "0x1f4e1",
            "0x1f489",
            "0x1fa78",
            "0x1f48a",
            "0x1fa79",
            "0x1fa7c",
            "0x1fa7a",
            "0x1fa7b",
            "0x1f6aa",
            "0x1f6d7",
            "0x1fa9e",
            "0x1fa9f",
            "0x1f6cf",
            "0x1f6cb",
            "0x1fa91",
            "0x1f6bd",
            "0x1faa0",
            "0x1f6bf",
            "0x1f6c1",
            "0x1faa4",
            "0x1fa92",
            "0x1f9f4",
            "0x1f9f7",
            "0x1f9f9",
            "0x1f9fa",
            "0x1f9fb",
            "0x1faa3",
            "0x1f9fc",
            "0x1fae7",
            "0x1faa5",
            "0x1f9fd",
            "0x1f9ef",
            "0x1f6d2",
            "0x1f6ac",
            "0x26b0",
            "0x1faa6",
            "0x26b1",
            "0x1f9ff",
            "0x1faac",
            "0x1f5ff",
            "0x1faa7",
            "0x1faaa"
          ],
          symbols: [
            "0x1f3e7",
            "0x1f6ae",
            "0x1f6b0",
            "0x267f",
            "0x1f6b9",
            "0x1f6ba",
            "0x1f6bb",
            "0x1f6bc",
            "0x1f6be",
            "0x1f6c2",
            "0x1f6c3",
            "0x1f6c4",
            "0x1f6c5",
            "0x26a0",
            "0x1f6b8",
            "0x26d4",
            "0x1f6ab",
            "0x1f6b3",
            "0x1f6ad",
            "0x1f6af",
            "0x1f6b1",
            "0x1f6b7",
            "0x1f4f5",
            "0x1f51e",
            "0x2622",
            "0x2623",
            "0x2b06",
            "0x2197",
            "0x27a1",
            "0x2198",
            "0x2b07",
            "0x2199",
            "0x2b05",
            "0x2196",
            "0x2195",
            "0x2194",
            "0x21a9",
            "0x21aa",
            "0x2934",
            "0x2935",
            "0x1f503",
            "0x1f504",
            "0x1f519",
            "0x1f51a",
            "0x1f51b",
            "0x1f51c",
            "0x1f51d",
            "0x1f6d0",
            "0x269b",
            "0x1f549",
            "0x2721",
            "0x2638",
            "0x262f",
            "0x271d",
            "0x2626",
            "0x262a",
            "0x262e",
            "0x1f54e",
            "0x1f52f",
            "0x1faaf",
            "0x2648",
            "0x2649",
            "0x264a",
            "0x264b",
            "0x264c",
            "0x264d",
            "0x264e",
            "0x264f",
            "0x2650",
            "0x2651",
            "0x2652",
            "0x2653",
            "0x26ce",
            "0x1f500",
            "0x1f501",
            "0x1f502",
            "0x25b6",
            "0x23e9",
            "0x23ed",
            "0x23ef",
            "0x25c0",
            "0x23ea",
            "0x23ee",
            "0x1f53c",
            "0x23eb",
            "0x1f53d",
            "0x23ec",
            "0x23f8",
            "0x23f9",
            "0x23fa",
            "0x23cf",
            "0x1f3a6",
            "0x1f505",
            "0x1f506",
            "0x1f4f6",
            "0x1f6dc",
            "0x1f4f3",
            "0x1f4f4",
            "0x2640",
            "0x2642",
            "0x26a7",
            "0x2716",
            "0x2795",
            "0x2796",
            "0x2797",
            "0x1f7f0",
            "0x267e",
            "0x203c",
            "0x2049",
            "0x2753",
            "0x2754",
            "0x2755",
            "0x2757",
            "0x3030",
            "0x1f4b1",
            "0x1f4b2",
            "0x2695",
            "0x267b",
            "0x269c",
            "0x1f531",
            "0x1f4db",
            "0x1f530",
            "0x2b55",
            "0x2705",
            "0x2611",
            "0x2714",
            "0x274c",
            "0x274e",
            "0x27b0",
            "0x27bf",
            "0x303d",
            "0x2733",
            "0x2734",
            "0x2747",
            "0x00a9",
            "0x00ae",
            "0x2122",
            "0x0023",
            "0xfe0f",
            "0x20e3",
            "0x002a",
            "0xfe0f",
            "0x20e3",
            "0x0030",
            "0xfe0f",
            "0x20e3",
            "0x0031",
            "0xfe0f",
            "0x20e3",
            "0x0032",
            "0xfe0f",
            "0x20e3",
            "0x0033",
            "0xfe0f",
            "0x20e3",
            "0x0034",
            "0xfe0f",
            "0x20e3",
            "0x0035",
            "0xfe0f",
            "0x20e3",
            "0x0036",
            "0xfe0f",
            "0x20e3",
            "0x0037",
            "0xfe0f",
            "0x20e3",
            "0x0038",
            "0xfe0f",
            "0x20e3",
            "0x0039",
            "0xfe0f",
            "0x20e3",
            "0x1f51f",
            "0x1f520",
            "0x1f521",
            "0x1f522",
            "0x1f523",
            "0x1f524",
            "0x1f170",
            "0x1f18e",
            "0x1f171",
            "0x1f191",
            "0x1f192",
            "0x1f193",
            "0x2139",
            "0x1f194",
            "0x24c2",
            "0x1f195",
            "0x1f196",
            "0x1f17e",
            "0x1f197",
            "0x1f17f",
            "0x1f198",
            "0x1f199",
            "0x1f19a",
            "0x1f201",
            "0x1f202",
            "0x1f237",
            "0x1f236",
            "0x1f22f",
            "0x1f250",
            "0x1f239",
            "0x1f21a",
            "0x1f232",
            "0x1f251",
            "0x1f238",
            "0x1f234",
            "0x1f233",
            "0x3297",
            "0x3299",
            "0x1f23a",
            "0x1f235",
            "0x1f534",
            "0x1f7e0",
            "0x1f7e1",
            "0x1f7e2",
            "0x1f535",
            "0x1f7e3",
            "0x1f7e4",
            "0x26ab",
            "0x26aa",
            "0x1f7e5",
            "0x1f7e7",
            "0x1f7e8",
            "0x1f7e9",
            "0x1f7e6",
            "0x1f7ea",
            "0x1f7eb",
            "0x2b1b",
            "0x2b1c",
            "0x25fc",
            "0x25fb",
            "0x25fe",
            "0x25fd",
            "0x25aa",
            "0x25ab",
            "0x1f536",
            "0x1f537",
            "0x1f538",
            "0x1f539",
            "0x1f53a",
            "0x1f53b",
            "0x1f4a0",
            "0x1f518",
            "0x1f533",
            "0x1f532"
          ],
          flags: [
            "0x1f3c1",
            "0x1f6a9",
            "0x1f38c",
            "0x1f3f4",
            "0x1f3f3",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x1f308",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x26a7",
            "0xfe0f",
            "0x1f3f4",
            "0x200d",
            "0x2620",
            "0xfe0f",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e9",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1eb",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ee",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f4",
            "0x1f1e6",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fc",
            "0x1f1e6",
            "0x1f1fd",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1e7",
            "0x1f1e6",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e9",
            "0x1f1e7",
            "0x1f1ea",
            "0x1f1e7",
            "0x1f1eb",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ed",
            "0x1f1e7",
            "0x1f1ee",
            "0x1f1e7",
            "0x1f1ef",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f2",
            "0x1f1e7",
            "0x1f1f3",
            "0x1f1e7",
            "0x1f1f4",
            "0x1f1e7",
            "0x1f1f6",
            "0x1f1e7",
            "0x1f1f7",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f9",
            "0x1f1e7",
            "0x1f1fb",
            "0x1f1e7",
            "0x1f1fc",
            "0x1f1e7",
            "0x1f1fe",
            "0x1f1e7",
            "0x1f1ff",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e9",
            "0x1f1e8",
            "0x1f1eb",
            "0x1f1e8",
            "0x1f1ec",
            "0x1f1e8",
            "0x1f1ed",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1f0",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f4",
            "0x1f1e8",
            "0x1f1f5",
            "0x1f1e8",
            "0x1f1f7",
            "0x1f1e8",
            "0x1f1fa",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fc",
            "0x1f1e8",
            "0x1f1fd",
            "0x1f1e8",
            "0x1f1fe",
            "0x1f1e8",
            "0x1f1ff",
            "0x1f1e9",
            "0x1f1ea",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ef",
            "0x1f1e9",
            "0x1f1f0",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f4",
            "0x1f1e9",
            "0x1f1ff",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e8",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ed",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f9",
            "0x1f1ea",
            "0x1f1fa",
            "0x1f1eb",
            "0x1f1ee",
            "0x1f1eb",
            "0x1f1ef",
            "0x1f1eb",
            "0x1f1f0",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f4",
            "0x1f1eb",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1eb",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ed",
            "0x1f1ec",
            "0x1f1ee",
            "0x1f1ec",
            "0x1f1f1",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f6",
            "0x1f1ec",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fc",
            "0x1f1ec",
            "0x1f1fe",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f3",
            "0x1f1ed",
            "0x1f1f7",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1fa",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e9",
            "0x1f1ee",
            "0x1f1ea",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f2",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f4",
            "0x1f1ee",
            "0x1f1f6",
            "0x1f1ee",
            "0x1f1f7",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1ea",
            "0x1f1ef",
            "0x1f1f2",
            "0x1f1ef",
            "0x1f1f4",
            "0x1f1ef",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1ea",
            "0x1f1f0",
            "0x1f1ec",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ee",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f3",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f7",
            "0x1f1f0",
            "0x1f1fc",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1f0",
            "0x1f1ff",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1f0",
            "0x1f1f1",
            "0x1f1f7",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1fa",
            "0x1f1f1",
            "0x1f1fb",
            "0x1f1f1",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1ea",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f1",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f3",
            "0x1f1f2",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f6",
            "0x1f1f2",
            "0x1f1f7",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fb",
            "0x1f1f2",
            "0x1f1fc",
            "0x1f1f2",
            "0x1f1fd",
            "0x1f1f2",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1f3",
            "0x1f1e6",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1ea",
            "0x1f1f3",
            "0x1f1eb",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1f1",
            "0x1f1f3",
            "0x1f1f4",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f7",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1ff",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1e6",
            "0x1f1f5",
            "0x1f1ea",
            "0x1f1f5",
            "0x1f1eb",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ed",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f1",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f7",
            "0x1f1f5",
            "0x1f1f8",
            "0x1f1f5",
            "0x1f1f9",
            "0x1f1f5",
            "0x1f1fc",
            "0x1f1f5",
            "0x1f1fe",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1f4",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1fa",
            "0x1f1f7",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e8",
            "0x1f1f8",
            "0x1f1e9",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ed",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ef",
            "0x1f1f8",
            "0x1f1f0",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f3",
            "0x1f1f8",
            "0x1f1f4",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f9",
            "0x1f1f8",
            "0x1f1fb",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f8",
            "0x1f1fe",
            "0x1f1f8",
            "0x1f1ff",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e8",
            "0x1f1f9",
            "0x1f1e9",
            "0x1f1f9",
            "0x1f1eb",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1f9",
            "0x1f1f0",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f3",
            "0x1f1f9",
            "0x1f1f4",
            "0x1f1f9",
            "0x1f1f7",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1fb",
            "0x1f1f9",
            "0x1f1fc",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f8",
            "0x1f1fa",
            "0x1f1fe",
            "0x1f1fa",
            "0x1f1ff",
            "0x1f1fb",
            "0x1f1e6",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1ea",
            "0x1f1fb",
            "0x1f1ec",
            "0x1f1fb",
            "0x1f1ee",
            "0x1f1fb",
            "0x1f1f3",
            "0x1f1fb",
            "0x1f1fa",
            "0x1f1fc",
            "0x1f1eb",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1ea",
            "0x1f1fe",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1fc",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0065",
            "0xe006e",
            "0xe0067",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0073",
            "0xe0063",
            "0xe0074",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0077",
            "0xe006c",
            "0xe0073",
            "0xe007f"
          ]
        }
      }, S = Object.prototype.hasOwnProperty, A = Object.keys || function(d) {
        var m = [];
        for (var v in d)
          S.call(d, v) && m.push(v);
        return m;
      };
      function I(d, m) {
        for (var v = A(d), k, O = 0, G = v.length; O < G; O++)
          k = v[O], m[k] = d[k] || m[k];
      }
      function M(d, m) {
        for (var v = 0, k = d.length; v < k; v++)
          m[v] = d[v];
      }
      function B(d, m) {
        var v = Array.isArray(d), k = m || (v ? new Array(d.length) : {});
        return v ? M(d, k) : I(d, k), k;
      }
      u.prototype.get = function(d) {
        return B(x[d]);
      }, u.prototype.mac_address = function(d) {
        d = f(d), d.separator || (d.separator = d.networkVersion ? "." : ":");
        var m = "ABCDEF1234567890", v = "";
        return d.networkVersion ? v = this.n(this.string, 3, { pool: m, length: 4 }).join(d.separator) : v = this.n(this.string, 6, { pool: m, length: 2 }).join(d.separator), v;
      }, u.prototype.normal = function(d) {
        if (d = f(d, { mean: 0, dev: 1, pool: [] }), p(
          d.pool.constructor !== Array,
          "Chance: The pool option must be a valid array."
        ), p(
          typeof d.mean != "number",
          "Chance: Mean (mean) must be a number"
        ), p(
          typeof d.dev != "number",
          "Chance: Standard deviation (dev) must be a number"
        ), d.pool.length > 0)
          return this.normal_pool(d);
        var m, v, k, O, G = d.mean, H = d.dev;
        do
          v = this.random() * 2 - 1, k = this.random() * 2 - 1, m = v * v + k * k;
        while (m >= 1);
        return O = v * Math.sqrt(-2 * Math.log(m) / m), H * O + G;
      }, u.prototype.normal_pool = function(d) {
        var m = 0;
        do {
          var v = Math.round(this.normal({ mean: d.mean, dev: d.dev }));
          if (v < d.pool.length && v >= 0)
            return d.pool[v];
          m++;
        } while (m < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
      }, u.prototype.radio = function(d) {
        d = f(d, { side: "?" });
        var m = "";
        switch (d.side.toLowerCase()) {
          case "east":
          case "e":
            m = "W";
            break;
          case "west":
          case "w":
            m = "K";
            break;
          default:
            m = this.character({ pool: "KW" });
            break;
        }
        return m + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" });
      }, u.prototype.set = function(d, m) {
        typeof d == "string" ? x[d] = m : x = B(d, x);
      }, u.prototype.tv = function(d) {
        return this.radio(d);
      }, u.prototype.cnpj = function() {
        var d = this.n(this.natural, 8, { max: 9 }), m = 2 + d[7] * 6 + d[6] * 7 + d[5] * 8 + d[4] * 9 + d[3] * 2 + d[2] * 3 + d[1] * 4 + d[0] * 5;
        m = 11 - m % 11, m >= 10 && (m = 0);
        var v = m * 2 + 3 + d[7] * 7 + d[6] * 8 + d[5] * 9 + d[4] * 2 + d[3] * 3 + d[2] * 4 + d[1] * 5 + d[0] * 6;
        return v = 11 - v % 11, v >= 10 && (v = 0), "" + d[0] + d[1] + "." + d[2] + d[3] + d[4] + "." + d[5] + d[6] + d[7] + "/0001-" + m + v;
      }, u.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
      }, u.prototype.mersenne_twister = function(d) {
        return new L(d);
      }, u.prototype.blueimp_md5 = function() {
        return new N();
      };
      var L = function(d) {
        d === void 0 && (d = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(d);
      };
      L.prototype.init_genrand = function(d) {
        for (this.mt[0] = d >>> 0, this.mti = 1; this.mti < this.N; this.mti++)
          d = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (((d & 4294901760) >>> 16) * 1812433253 << 16) + (d & 65535) * 1812433253 + this.mti, this.mt[this.mti] >>>= 0;
      }, L.prototype.init_by_array = function(d, m) {
        var v = 1, k = 0, O, G;
        for (this.init_genrand(19650218), O = this.N > m ? this.N : m; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1664525 << 16) + (G & 65535) * 1664525) + d[k] + k, this.mt[v] >>>= 0, v++, k++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1), k >= m && (k = 0);
        for (O = this.N - 1; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1566083941 << 16) + (G & 65535) * 1566083941) - v, this.mt[v] >>>= 0, v++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1);
        this.mt[0] = 2147483648;
      }, L.prototype.genrand_int32 = function() {
        var d, m = new Array(0, this.MATRIX_A);
        if (this.mti >= this.N) {
          var v;
          for (this.mti === this.N + 1 && this.init_genrand(5489), v = 0; v < this.N - this.M; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + this.M] ^ d >>> 1 ^ m[d & 1];
          for (; v < this.N - 1; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + (this.M - this.N)] ^ d >>> 1 ^ m[d & 1];
          d = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ d >>> 1 ^ m[d & 1], this.mti = 0;
        }
        return d = this.mt[this.mti++], d ^= d >>> 11, d ^= d << 7 & 2636928640, d ^= d << 15 & 4022730752, d ^= d >>> 18, d >>> 0;
      }, L.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
      }, L.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1 / 4294967295);
      }, L.prototype.random = function() {
        return this.genrand_int32() * (1 / 4294967296);
      }, L.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1 / 4294967296);
      }, L.prototype.genrand_res53 = function() {
        var d = this.genrand_int32() >>> 5, m = this.genrand_int32() >>> 6;
        return (d * 67108864 + m) * (1 / 9007199254740992);
      };
      var N = function() {
      };
      N.prototype.VERSION = "1.0.1", N.prototype.safe_add = function(m, v) {
        var k = (m & 65535) + (v & 65535), O = (m >> 16) + (v >> 16) + (k >> 16);
        return O << 16 | k & 65535;
      }, N.prototype.bit_roll = function(d, m) {
        return d << m | d >>> 32 - m;
      }, N.prototype.md5_cmn = function(d, m, v, k, O, G) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(m, d), this.safe_add(k, G)), O), v);
      }, N.prototype.md5_ff = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & v | ~m & k, d, m, O, G, H);
      }, N.prototype.md5_gg = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & k | v & ~k, d, m, O, G, H);
      }, N.prototype.md5_hh = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m ^ v ^ k, d, m, O, G, H);
      }, N.prototype.md5_ii = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(v ^ (m | ~k), d, m, O, G, H);
      }, N.prototype.binl_md5 = function(d, m) {
        d[m >> 5] |= 128 << m % 32, d[(m + 64 >>> 9 << 4) + 14] = m;
        var v, k, O, G, H, j = 1732584193, F = -271733879, z = -1732584194, W = 271733878;
        for (v = 0; v < d.length; v += 16)
          k = j, O = F, G = z, H = W, j = this.md5_ff(j, F, z, W, d[v], 7, -680876936), W = this.md5_ff(W, j, F, z, d[v + 1], 12, -389564586), z = this.md5_ff(z, W, j, F, d[v + 2], 17, 606105819), F = this.md5_ff(F, z, W, j, d[v + 3], 22, -1044525330), j = this.md5_ff(j, F, z, W, d[v + 4], 7, -176418897), W = this.md5_ff(W, j, F, z, d[v + 5], 12, 1200080426), z = this.md5_ff(z, W, j, F, d[v + 6], 17, -1473231341), F = this.md5_ff(F, z, W, j, d[v + 7], 22, -45705983), j = this.md5_ff(j, F, z, W, d[v + 8], 7, 1770035416), W = this.md5_ff(W, j, F, z, d[v + 9], 12, -1958414417), z = this.md5_ff(z, W, j, F, d[v + 10], 17, -42063), F = this.md5_ff(F, z, W, j, d[v + 11], 22, -1990404162), j = this.md5_ff(j, F, z, W, d[v + 12], 7, 1804603682), W = this.md5_ff(W, j, F, z, d[v + 13], 12, -40341101), z = this.md5_ff(z, W, j, F, d[v + 14], 17, -1502002290), F = this.md5_ff(F, z, W, j, d[v + 15], 22, 1236535329), j = this.md5_gg(j, F, z, W, d[v + 1], 5, -165796510), W = this.md5_gg(W, j, F, z, d[v + 6], 9, -1069501632), z = this.md5_gg(z, W, j, F, d[v + 11], 14, 643717713), F = this.md5_gg(F, z, W, j, d[v], 20, -373897302), j = this.md5_gg(j, F, z, W, d[v + 5], 5, -701558691), W = this.md5_gg(W, j, F, z, d[v + 10], 9, 38016083), z = this.md5_gg(z, W, j, F, d[v + 15], 14, -660478335), F = this.md5_gg(F, z, W, j, d[v + 4], 20, -405537848), j = this.md5_gg(j, F, z, W, d[v + 9], 5, 568446438), W = this.md5_gg(W, j, F, z, d[v + 14], 9, -1019803690), z = this.md5_gg(z, W, j, F, d[v + 3], 14, -187363961), F = this.md5_gg(F, z, W, j, d[v + 8], 20, 1163531501), j = this.md5_gg(j, F, z, W, d[v + 13], 5, -1444681467), W = this.md5_gg(W, j, F, z, d[v + 2], 9, -51403784), z = this.md5_gg(z, W, j, F, d[v + 7], 14, 1735328473), F = this.md5_gg(F, z, W, j, d[v + 12], 20, -1926607734), j = this.md5_hh(j, F, z, W, d[v + 5], 4, -378558), W = this.md5_hh(W, j, F, z, d[v + 8], 11, -2022574463), z = this.md5_hh(z, W, j, F, d[v + 11], 16, 1839030562), F = this.md5_hh(F, z, W, j, d[v + 14], 23, -35309556), j = this.md5_hh(j, F, z, W, d[v + 1], 4, -1530992060), W = this.md5_hh(W, j, F, z, d[v + 4], 11, 1272893353), z = this.md5_hh(z, W, j, F, d[v + 7], 16, -155497632), F = this.md5_hh(F, z, W, j, d[v + 10], 23, -1094730640), j = this.md5_hh(j, F, z, W, d[v + 13], 4, 681279174), W = this.md5_hh(W, j, F, z, d[v], 11, -358537222), z = this.md5_hh(z, W, j, F, d[v + 3], 16, -722521979), F = this.md5_hh(F, z, W, j, d[v + 6], 23, 76029189), j = this.md5_hh(j, F, z, W, d[v + 9], 4, -640364487), W = this.md5_hh(W, j, F, z, d[v + 12], 11, -421815835), z = this.md5_hh(z, W, j, F, d[v + 15], 16, 530742520), F = this.md5_hh(F, z, W, j, d[v + 2], 23, -995338651), j = this.md5_ii(j, F, z, W, d[v], 6, -198630844), W = this.md5_ii(W, j, F, z, d[v + 7], 10, 1126891415), z = this.md5_ii(z, W, j, F, d[v + 14], 15, -1416354905), F = this.md5_ii(F, z, W, j, d[v + 5], 21, -57434055), j = this.md5_ii(j, F, z, W, d[v + 12], 6, 1700485571), W = this.md5_ii(W, j, F, z, d[v + 3], 10, -1894986606), z = this.md5_ii(z, W, j, F, d[v + 10], 15, -1051523), F = this.md5_ii(F, z, W, j, d[v + 1], 21, -2054922799), j = this.md5_ii(j, F, z, W, d[v + 8], 6, 1873313359), W = this.md5_ii(W, j, F, z, d[v + 15], 10, -30611744), z = this.md5_ii(z, W, j, F, d[v + 6], 15, -1560198380), F = this.md5_ii(F, z, W, j, d[v + 13], 21, 1309151649), j = this.md5_ii(j, F, z, W, d[v + 4], 6, -145523070), W = this.md5_ii(W, j, F, z, d[v + 11], 10, -1120210379), z = this.md5_ii(z, W, j, F, d[v + 2], 15, 718787259), F = this.md5_ii(F, z, W, j, d[v + 9], 21, -343485551), j = this.safe_add(j, k), F = this.safe_add(F, O), z = this.safe_add(z, G), W = this.safe_add(W, H);
        return [j, F, z, W];
      }, N.prototype.binl2rstr = function(d) {
        var m, v = "";
        for (m = 0; m < d.length * 32; m += 8)
          v += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return v;
      }, N.prototype.rstr2binl = function(d) {
        var m, v = [];
        for (v[(d.length >> 2) - 1] = void 0, m = 0; m < v.length; m += 1)
          v[m] = 0;
        for (m = 0; m < d.length * 8; m += 8)
          v[m >> 5] |= (d.charCodeAt(m / 8) & 255) << m % 32;
        return v;
      }, N.prototype.rstr_md5 = function(d) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(d), d.length * 8));
      }, N.prototype.rstr_hmac_md5 = function(d, m) {
        var v, k = this.rstr2binl(d), O = [], G = [], H;
        for (O[15] = G[15] = void 0, k.length > 16 && (k = this.binl_md5(k, d.length * 8)), v = 0; v < 16; v += 1)
          O[v] = k[v] ^ 909522486, G[v] = k[v] ^ 1549556828;
        return H = this.binl_md5(O.concat(this.rstr2binl(m)), 512 + m.length * 8), this.binl2rstr(this.binl_md5(G.concat(H), 640));
      }, N.prototype.rstr2hex = function(d) {
        var m = "0123456789abcdef", v = "", k, O;
        for (O = 0; O < d.length; O += 1)
          k = d.charCodeAt(O), v += m.charAt(k >>> 4 & 15) + m.charAt(k & 15);
        return v;
      }, N.prototype.str2rstr_utf8 = function(d) {
        return unescape(encodeURIComponent(d));
      }, N.prototype.raw_md5 = function(d) {
        return this.rstr_md5(this.str2rstr_utf8(d));
      }, N.prototype.hex_md5 = function(d) {
        return this.rstr2hex(this.raw_md5(d));
      }, N.prototype.raw_hmac_md5 = function(d, m) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(d), this.str2rstr_utf8(m));
      }, N.prototype.hex_hmac_md5 = function(d, m) {
        return this.rstr2hex(this.raw_hmac_md5(d, m));
      }, N.prototype.md5 = function(d, m, v) {
        return m ? v ? this.raw_hmac_md5(m, d) : this.hex_hmac_md5(m, d) : v ? this.raw_md5(d) : this.hex_md5(d);
      }, t.exports && (e = t.exports = u), e.Chance = u, typeof importScripts < "u" && (chance = new u(), self.Chance = u), typeof window == "object" && typeof window.document == "object" && (window.Chance = u, window.chance = new u());
    })();
  }(XO, XO.exports)), XO.exports;
}
var $Ct = NCt();
const DCt = /* @__PURE__ */ Gi($Ct);
new DCt();
var eo;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(eo || (eo = {}));
var nce;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(nce || (nce = {}));
const Cn = eo.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), im = (t) => {
  switch (typeof t) {
    case "undefined":
      return Cn.undefined;
    case "string":
      return Cn.string;
    case "number":
      return isNaN(t) ? Cn.nan : Cn.number;
    case "boolean":
      return Cn.boolean;
    case "function":
      return Cn.function;
    case "bigint":
      return Cn.bigint;
    case "symbol":
      return Cn.symbol;
    case "object":
      return Array.isArray(t) ? Cn.array : t === null ? Cn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? Cn.promise : typeof Map < "u" && t instanceof Map ? Cn.map : typeof Set < "u" && t instanceof Set ? Cn.set : typeof Date < "u" && t instanceof Date ? Cn.date : Cn.object;
    default:
      return Cn.unknown;
  }
}, Dr = eo.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), LCt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let k1 = class fUe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof fUe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, eo.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
k1.create = (t) => new k1(t);
const Z7 = (t, e) => {
  let r;
  switch (t.code) {
    case Dr.invalid_type:
      t.received === Cn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Dr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, eo.jsonStringifyReplacer)}`;
      break;
    case Dr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${eo.joinValues(t.keys, ", ")}`;
      break;
    case Dr.invalid_union:
      r = "Invalid input";
      break;
    case Dr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${eo.joinValues(t.options)}`;
      break;
    case Dr.invalid_enum_value:
      r = `Invalid enum value. Expected ${eo.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Dr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Dr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Dr.invalid_date:
      r = "Invalid date";
      break;
    case Dr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : eo.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Dr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Dr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Dr.custom:
      r = "Invalid input";
      break;
    case Dr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Dr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Dr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, eo.assertNever(t);
  }
  return { message: r };
};
let hUe = Z7;
function jCt(t) {
  hUe = t;
}
function CD() {
  return hUe;
}
const wD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, FCt = [];
function sn(t, e) {
  const r = CD(), n = wD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Z7 ? void 0 : Z7
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let wd = class pUe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Ta;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return pUe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Ta;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Ta = Object.freeze({
  status: "aborted"
}), M9 = (t) => ({ status: "dirty", value: t }), Iu = (t) => ({ status: "valid", value: t }), ace = (t) => t.status === "aborted", ice = (t) => t.status === "dirty", l5 = (t) => t.status === "valid", eA = (t) => typeof Promise < "u" && t instanceof Promise;
function SD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function mUe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var $n;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})($n || ($n = {}));
var $S, DS;
let Rh = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const z6e = (t, e) => {
  if (l5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new k1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function ui(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Ti = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return im(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: im(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new wd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: im(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (eA(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: im(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return z6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: im(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return l5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => l5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: im(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (eA(a) ? a : Promise.resolve(a));
    return z6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Dr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new L1({
      schema: this,
      typeName: va.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return dh.create(this, this._def);
  }
  nullable() {
    return ey.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return c5.create(this);
  }
  promise() {
    return X7.create(this, this._def);
  }
  or(e) {
    return sA.create([this, e], this._def);
  }
  and(e) {
    return lA.create(this, e, this._def);
  }
  transform(e) {
    return new L1({
      ...ui(this._def),
      schema: this,
      typeName: va.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new fA({
      ...ui(this._def),
      innerType: this,
      defaultValue: r,
      typeName: va.ZodDefault
    });
  }
  brand() {
    return new O1e({
      typeName: va.ZodBranded,
      type: this,
      ...ui(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new hA({
      ...ui(this._def),
      innerType: this,
      catchValue: r,
      typeName: va.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return B1e.create(this, e);
  }
  readonly() {
    return pA.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const zCt = /^c[^\s-]{8,}$/i, GCt = /^[0-9a-z]+$/, WCt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, HCt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, UCt = /^[a-z0-9_-]{21}$/i, VCt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, qCt = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, KCt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, ZCt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let PK;
const JCt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, YCt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, XCt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, QCt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ewt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, twt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, gUe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", rwt = new RegExp(`^${gUe}$`);
function vUe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function nwt(t) {
  return new RegExp(`^${vUe(t)}$`);
}
function yUe(t) {
  let e = `${gUe}T${vUe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function awt(t, e) {
  return !!((e === "v4" || !e) && JCt.test(t) || (e === "v6" || !e) && XCt.test(t));
}
function iwt(t, e) {
  if (!VCt.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function owt(t, e) {
  return !!((e === "v4" || !e) && YCt.test(t) || (e === "v6" || !e) && QCt.test(t));
}
let J7 = class LS extends Ti {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== Cn.string) {
      const i = this._getOrReturnCtx(e);
      return sn(i, {
        code: Dr.invalid_type,
        expected: Cn.string,
        received: i.parsedType
      }), Ta;
    }
    const n = new wd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), sn(a, {
          code: Dr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), sn(a, {
          code: Dr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? sn(a, {
          code: Dr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && sn(a, {
          code: Dr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        KCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "email",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        PK || (PK = new RegExp(ZCt, "u")), PK.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "emoji",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        HCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "uuid",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        UCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "nanoid",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        zCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "cuid",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        GCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "cuid2",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        WCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
          validation: "ulid",
          code: Dr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), sn(a, {
            validation: "url",
            code: Dr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "regex",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? yUe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? rwt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? nwt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? qCt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "duration",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? awt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "ip",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? iwt(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "jwt",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? owt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "cidr",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? ewt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "base64",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? twt.test(e.data) || (a = this._getOrReturnCtx(e, a), sn(a, {
        validation: "base64url",
        code: Dr.invalid_string,
        message: i.message
      }), n.dirty()) : eo.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Dr.invalid_string,
      ...$n.errToObj(n)
    });
  }
  _addCheck(e) {
    return new LS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...$n.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...$n.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...$n.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...$n.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...$n.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...$n.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...$n.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...$n.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...$n.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...$n.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...$n.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...$n.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...$n.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...$n.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...$n.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...$n.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...$n.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...$n.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...$n.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...$n.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...$n.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...$n.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...$n.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, $n.errToObj(e));
  }
  trim() {
    return new LS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new LS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new LS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
J7.create = (t) => {
  var e;
  return new J7({
    checks: [],
    typeName: va.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...ui(t)
  });
};
function swt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let tA = class oce extends Ti {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== Cn.number) {
      const i = this._getOrReturnCtx(e);
      return sn(i, {
        code: Dr.invalid_type,
        expected: Cn.number,
        received: i.parsedType
      }), Ta;
    }
    let n;
    const a = new wd();
    for (const i of this._def.checks)
      i.kind === "int" ? eo.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? swt(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.not_finite,
        message: i.message
      }), a.dirty()) : eo.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, $n.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, $n.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, $n.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, $n.toString(r));
  }
  setLimit(e, r, n, a) {
    return new oce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: $n.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new oce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: $n.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: $n.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: $n.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: $n.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: $n.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: $n.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: $n.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: $n.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: $n.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && eo.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
tA.create = (t) => new tA({
  checks: [],
  typeName: va.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...ui(t)
});
let rA = class sce extends Ti {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== Cn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new wd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), sn(n, {
        code: Dr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : eo.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return sn(r, {
      code: Dr.invalid_type,
      expected: Cn.bigint,
      received: r.parsedType
    }), Ta;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, $n.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, $n.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, $n.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, $n.toString(r));
  }
  setLimit(e, r, n, a) {
    return new sce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: $n.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new sce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: $n.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: $n.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: $n.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: $n.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: $n.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
rA.create = (t) => {
  var e;
  return new rA({
    checks: [],
    typeName: va.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...ui(t)
  });
};
let nA = class extends Ti {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== Cn.boolean) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.boolean,
        received: n.parsedType
      }), Ta;
    }
    return Iu(e.data);
  }
};
nA.create = (t) => new nA({
  typeName: va.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...ui(t)
});
let aA = class bUe extends Ti {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== Cn.date) {
      const i = this._getOrReturnCtx(e);
      return sn(i, {
        code: Dr.invalid_type,
        expected: Cn.date,
        received: i.parsedType
      }), Ta;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return sn(i, {
        code: Dr.invalid_date
      }), Ta;
    }
    const n = new wd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), sn(a, {
        code: Dr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : eo.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new bUe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: $n.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: $n.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
aA.create = (t) => new aA({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: va.ZodDate,
  ...ui(t)
});
let _D = class extends Ti {
  _parse(e) {
    if (this._getType(e) !== Cn.symbol) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.symbol,
        received: n.parsedType
      }), Ta;
    }
    return Iu(e.data);
  }
};
_D.create = (t) => new _D({
  typeName: va.ZodSymbol,
  ...ui(t)
});
let iA = class extends Ti {
  _parse(e) {
    if (this._getType(e) !== Cn.undefined) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.undefined,
        received: n.parsedType
      }), Ta;
    }
    return Iu(e.data);
  }
};
iA.create = (t) => new iA({
  typeName: va.ZodUndefined,
  ...ui(t)
});
let oA = class extends Ti {
  _parse(e) {
    if (this._getType(e) !== Cn.null) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.null,
        received: n.parsedType
      }), Ta;
    }
    return Iu(e.data);
  }
};
oA.create = (t) => new oA({
  typeName: va.ZodNull,
  ...ui(t)
});
let Y7 = class extends Ti {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Iu(e.data);
  }
};
Y7.create = (t) => new Y7({
  typeName: va.ZodAny,
  ...ui(t)
});
let Mb = class extends Ti {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Iu(e.data);
  }
};
Mb.create = (t) => new Mb({
  typeName: va.ZodUnknown,
  ...ui(t)
});
let jm = class extends Ti {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return sn(r, {
      code: Dr.invalid_type,
      expected: Cn.never,
      received: r.parsedType
    }), Ta;
  }
};
jm.create = (t) => new jm({
  typeName: va.ZodNever,
  ...ui(t)
});
let kD = class extends Ti {
  _parse(e) {
    if (this._getType(e) !== Cn.undefined) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.void,
        received: n.parsedType
      }), Ta;
    }
    return Iu(e.data);
  }
};
kD.create = (t) => new kD({
  typeName: va.ZodVoid,
  ...ui(t)
});
let c5 = class WN extends Ti {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== Cn.array)
      return sn(r, {
        code: Dr.invalid_type,
        expected: Cn.array,
        received: r.parsedType
      }), Ta;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (sn(r, {
        code: o ? Dr.too_big : Dr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (sn(r, {
      code: Dr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (sn(r, {
      code: Dr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Rh(r, o, r.path, s)))).then((o) => wd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Rh(r, o, r.path, s)));
    return wd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new WN({
      ...this._def,
      minLength: { value: e, message: $n.toString(r) }
    });
  }
  max(e, r) {
    return new WN({
      ...this._def,
      maxLength: { value: e, message: $n.toString(r) }
    });
  }
  length(e, r) {
    return new WN({
      ...this._def,
      exactLength: { value: e, message: $n.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
c5.create = (t, e) => new c5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: va.ZodArray,
  ...ui(e)
});
function p9(t) {
  if (t instanceof sf) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = dh.create(p9(n));
    }
    return new sf({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof c5 ? new c5({
    ...t._def,
    type: p9(t.element)
  }) : t instanceof dh ? dh.create(p9(t.unwrap())) : t instanceof ey ? ey.create(p9(t.unwrap())) : t instanceof Qv ? Qv.create(t.items.map((e) => p9(e))) : t;
}
let sf = class Xf extends Ti {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = eo.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== Cn.object) {
      const c = this._getOrReturnCtx(e);
      return sn(c, {
        code: Dr.invalid_type,
        expected: Cn.object,
        received: c.parsedType
      }), Ta;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof jm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Rh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof jm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (sn(a, {
          code: Dr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Rh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => wd.mergeObjectSync(n, c)) : wd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return $n.errToObj, new Xf({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = $n.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Xf({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Xf({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Xf({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Xf({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: va.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Xf({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return eo.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Xf({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return eo.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Xf({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return p9(this);
  }
  partial(e) {
    const r = {};
    return eo.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Xf({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return eo.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof dh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Xf({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return kUe(eo.objectKeys(this.shape));
  }
};
sf.create = (t, e) => new sf({
  shape: () => t,
  unknownKeys: "strip",
  catchall: jm.create(),
  typeName: va.ZodObject,
  ...ui(e)
});
sf.strictCreate = (t, e) => new sf({
  shape: () => t,
  unknownKeys: "strict",
  catchall: jm.create(),
  typeName: va.ZodObject,
  ...ui(e)
});
sf.lazycreate = (t, e) => new sf({
  shape: t,
  unknownKeys: "strip",
  catchall: jm.create(),
  typeName: va.ZodObject,
  ...ui(e)
});
let sA = class extends Ti {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new k1(s.ctx.common.issues));
      return sn(r, {
        code: Dr.invalid_union,
        unionErrors: o
      }), Ta;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new k1(l));
      return sn(r, {
        code: Dr.invalid_union,
        unionErrors: s
      }), Ta;
    }
  }
  get options() {
    return this._def.options;
  }
};
sA.create = (t, e) => new sA({
  options: t,
  typeName: va.ZodUnion,
  ...ui(e)
});
const Up = (t) => t instanceof cA ? Up(t.schema) : t instanceof L1 ? Up(t.innerType()) : t instanceof uA ? [t.value] : t instanceof NI ? t.options : t instanceof dA ? eo.objectValues(t.enum) : t instanceof fA ? Up(t._def.innerType) : t instanceof iA ? [void 0] : t instanceof oA ? [null] : t instanceof dh ? [void 0, ...Up(t.unwrap())] : t instanceof ey ? [null, ...Up(t.unwrap())] : t instanceof O1e || t instanceof pA ? Up(t.unwrap()) : t instanceof hA ? Up(t._def.innerType) : [];
let xUe = class CUe extends Ti {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Cn.object)
      return sn(r, {
        code: Dr.invalid_type,
        expected: Cn.object,
        received: r.parsedType
      }), Ta;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (sn(r, {
      code: Dr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Ta);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Up(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new CUe({
      typeName: va.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...ui(n)
    });
  }
};
function lce(t, e) {
  const r = im(t), n = im(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === Cn.object && n === Cn.object) {
    const a = eo.objectKeys(e), i = eo.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = lce(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Cn.array && n === Cn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = lce(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === Cn.date && n === Cn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let lA = class extends Ti {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (ace(i) || ace(o))
        return Ta;
      const s = lce(i.value, o.value);
      return s.valid ? ((ice(i) || ice(o)) && r.dirty(), { status: r.value, value: s.data }) : (sn(n, {
        code: Dr.invalid_intersection_types
      }), Ta);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
lA.create = (t, e, r) => new lA({
  left: t,
  right: e,
  typeName: va.ZodIntersection,
  ...ui(r)
});
let Qv = class wUe extends Ti {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Cn.array)
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.array,
        received: n.parsedType
      }), Ta;
    if (n.data.length < this._def.items.length)
      return sn(n, {
        code: Dr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ta;
    !this._def.rest && n.data.length > this._def.items.length && (sn(n, {
      code: Dr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Rh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => wd.mergeArray(r, o)) : wd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new wUe({
      ...this._def,
      rest: e
    });
  }
};
Qv.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Qv({
    items: t,
    typeName: va.ZodTuple,
    rest: null,
    ...ui(e)
  });
};
let SUe = class cce extends Ti {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Cn.object)
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.object,
        received: n.parsedType
      }), Ta;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Rh(n, s, n.path, s)),
        value: o._parse(new Rh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? wd.mergeObjectAsync(r, a) : wd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Ti ? new cce({
      keyType: e,
      valueType: r,
      typeName: va.ZodRecord,
      ...ui(n)
    }) : new cce({
      keyType: J7.create(),
      valueType: e,
      typeName: va.ZodRecord,
      ...ui(r)
    });
  }
}, AD = class extends Ti {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Cn.map)
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.map,
        received: n.parsedType
      }), Ta;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Rh(n, s, n.path, [c, "key"])),
      value: i._parse(new Rh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ta;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ta;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
AD.create = (t, e, r) => new AD({
  valueType: e,
  keyType: t,
  typeName: va.ZodMap,
  ...ui(r)
});
let TD = class uce extends Ti {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Cn.set)
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.set,
        received: n.parsedType
      }), Ta;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (sn(n, {
      code: Dr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (sn(n, {
      code: Dr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ta;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Rh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new uce({
      ...this._def,
      minSize: { value: e, message: $n.toString(r) }
    });
  }
  max(e, r) {
    return new uce({
      ...this._def,
      maxSize: { value: e, message: $n.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
TD.create = (t, e) => new TD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: va.ZodSet,
  ...ui(e)
});
let _Ue = class HN extends Ti {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Cn.function)
      return sn(r, {
        code: Dr.invalid_type,
        expected: Cn.function,
        received: r.parsedType
      }), Ta;
    function n(s, l) {
      return wD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          CD(),
          Z7
        ].filter((c) => !!c),
        issueData: {
          code: Dr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return wD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          CD(),
          Z7
        ].filter((c) => !!c),
        issueData: {
          code: Dr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof X7) {
      const s = this;
      return Iu(async function(...l) {
        const c = new k1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Iu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new k1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new k1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new HN({
      ...this._def,
      args: Qv.create(e).rest(Mb.create())
    });
  }
  returns(e) {
    return new HN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new HN({
      args: e || Qv.create([]).rest(Mb.create()),
      returns: r || Mb.create(),
      typeName: va.ZodFunction,
      ...ui(n)
    });
  }
}, cA = class extends Ti {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
cA.create = (t, e) => new cA({
  getter: t,
  typeName: va.ZodLazy,
  ...ui(e)
});
let uA = class extends Ti {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return sn(r, {
        received: r.data,
        code: Dr.invalid_literal,
        expected: this._def.value
      }), Ta;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
uA.create = (t, e) => new uA({
  value: t,
  typeName: va.ZodLiteral,
  ...ui(e)
});
function kUe(t, e) {
  return new NI({
    values: t,
    typeName: va.ZodEnum,
    ...ui(e)
  });
}
let NI = class dce extends Ti {
  constructor() {
    super(...arguments), $S.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return sn(r, {
        expected: eo.joinValues(n),
        received: r.parsedType,
        code: Dr.invalid_type
      }), Ta;
    }
    if (SD(this, $S) || mUe(this, $S, new Set(this._def.values)), !SD(this, $S).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return sn(r, {
        received: r.data,
        code: Dr.invalid_enum_value,
        options: n
      }), Ta;
    }
    return Iu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return dce.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return dce.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
$S = /* @__PURE__ */ new WeakMap();
NI.create = kUe;
let dA = class extends Ti {
  constructor() {
    super(...arguments), DS.set(this, void 0);
  }
  _parse(e) {
    const r = eo.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== Cn.string && n.parsedType !== Cn.number) {
      const a = eo.objectValues(r);
      return sn(n, {
        expected: eo.joinValues(a),
        received: n.parsedType,
        code: Dr.invalid_type
      }), Ta;
    }
    if (SD(this, DS) || mUe(this, DS, new Set(eo.getValidEnumValues(this._def.values))), !SD(this, DS).has(e.data)) {
      const a = eo.objectValues(r);
      return sn(n, {
        received: n.data,
        code: Dr.invalid_enum_value,
        options: a
      }), Ta;
    }
    return Iu(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
DS = /* @__PURE__ */ new WeakMap();
dA.create = (t, e) => new dA({
  values: t,
  typeName: va.ZodNativeEnum,
  ...ui(e)
});
let X7 = class extends Ti {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Cn.promise && r.common.async === !1)
      return sn(r, {
        code: Dr.invalid_type,
        expected: Cn.promise,
        received: r.parsedType
      }), Ta;
    const n = r.parsedType === Cn.promise ? r.data : Promise.resolve(r.data);
    return Iu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
X7.create = (t, e) => new X7({
  type: t,
  typeName: va.ZodPromise,
  ...ui(e)
});
let L1 = class extends Ti {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === va.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        sn(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Ta;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Ta : l.status === "dirty" || r.value === "dirty" ? M9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Ta;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ta : s.status === "dirty" || r.value === "dirty" ? M9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ta : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Ta : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!l5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => l5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    eo.assertNever(a);
  }
};
L1.create = (t, e, r) => new L1({
  schema: t,
  typeName: va.ZodEffects,
  effect: e,
  ...ui(r)
});
L1.createWithPreprocess = (t, e, r) => new L1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: va.ZodEffects,
  ...ui(r)
});
let dh = class extends Ti {
  _parse(e) {
    return this._getType(e) === Cn.undefined ? Iu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
dh.create = (t, e) => new dh({
  innerType: t,
  typeName: va.ZodOptional,
  ...ui(e)
});
let ey = class extends Ti {
  _parse(e) {
    return this._getType(e) === Cn.null ? Iu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ey.create = (t, e) => new ey({
  innerType: t,
  typeName: va.ZodNullable,
  ...ui(e)
});
let fA = class extends Ti {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === Cn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
fA.create = (t, e) => new fA({
  innerType: t,
  typeName: va.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...ui(e)
});
let hA = class extends Ti {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return eA(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new k1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new k1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
hA.create = (t, e) => new hA({
  innerType: t,
  typeName: va.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...ui(e)
});
let ED = class extends Ti {
  _parse(e) {
    if (this._getType(e) !== Cn.nan) {
      const n = this._getOrReturnCtx(e);
      return sn(n, {
        code: Dr.invalid_type,
        expected: Cn.nan,
        received: n.parsedType
      }), Ta;
    }
    return { status: "valid", value: e.data };
  }
};
ED.create = (t) => new ED({
  typeName: va.ZodNaN,
  ...ui(t)
});
const lwt = Symbol("zod_brand");
let O1e = class extends Ti {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, B1e = class AUe extends Ti {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Ta : i.status === "dirty" ? (r.dirty(), M9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Ta : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new AUe({
      in: e,
      out: r,
      typeName: va.ZodPipeline
    });
  }
}, pA = class extends Ti {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (l5(a) && (a.value = Object.freeze(a.value)), a);
    return eA(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
pA.create = (t, e) => new pA({
  innerType: t,
  typeName: va.ZodReadonly,
  ...ui(e)
});
function TUe(t, e = {}, r) {
  return t ? Y7.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : Y7.create();
}
const cwt = {
  object: sf.lazycreate
};
var va;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(va || (va = {}));
const uwt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => TUe((r) => r instanceof t, e), EUe = J7.create, IUe = tA.create, dwt = ED.create, fwt = rA.create, MUe = nA.create, hwt = aA.create, pwt = _D.create, mwt = iA.create, gwt = oA.create, vwt = Y7.create, ywt = Mb.create, bwt = jm.create, xwt = kD.create, Cwt = c5.create, wwt = sf.create, Swt = sf.strictCreate, _wt = sA.create, kwt = xUe.create, Awt = lA.create, Twt = Qv.create, Ewt = SUe.create, Iwt = AD.create, Mwt = TD.create, Pwt = _Ue.create, Rwt = cA.create, Owt = uA.create, Bwt = NI.create, Nwt = dA.create, $wt = X7.create, G6e = L1.create, Dwt = dh.create, Lwt = ey.create, jwt = L1.createWithPreprocess, Fwt = B1e.create, zwt = () => EUe().optional(), Gwt = () => IUe().optional(), Wwt = () => MUe().optional(), Hwt = {
  string: (t) => J7.create({ ...t, coerce: !0 }),
  number: (t) => tA.create({ ...t, coerce: !0 }),
  boolean: (t) => nA.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => rA.create({ ...t, coerce: !0 }),
  date: (t) => aA.create({ ...t, coerce: !0 })
}, Uwt = Ta;
var PUe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Z7,
  setErrorMap: jCt,
  getErrorMap: CD,
  makeIssue: wD,
  EMPTY_PATH: FCt,
  addIssueToContext: sn,
  ParseStatus: wd,
  INVALID: Ta,
  DIRTY: M9,
  OK: Iu,
  isAborted: ace,
  isDirty: ice,
  isValid: l5,
  isAsync: eA,
  get util() {
    return eo;
  },
  get objectUtil() {
    return nce;
  },
  ZodParsedType: Cn,
  getParsedType: im,
  ZodType: Ti,
  datetimeRegex: yUe,
  ZodString: J7,
  ZodNumber: tA,
  ZodBigInt: rA,
  ZodBoolean: nA,
  ZodDate: aA,
  ZodSymbol: _D,
  ZodUndefined: iA,
  ZodNull: oA,
  ZodAny: Y7,
  ZodUnknown: Mb,
  ZodNever: jm,
  ZodVoid: kD,
  ZodArray: c5,
  ZodObject: sf,
  ZodUnion: sA,
  ZodDiscriminatedUnion: xUe,
  ZodIntersection: lA,
  ZodTuple: Qv,
  ZodRecord: SUe,
  ZodMap: AD,
  ZodSet: TD,
  ZodFunction: _Ue,
  ZodLazy: cA,
  ZodLiteral: uA,
  ZodEnum: NI,
  ZodNativeEnum: dA,
  ZodPromise: X7,
  ZodEffects: L1,
  ZodTransformer: L1,
  ZodOptional: dh,
  ZodNullable: ey,
  ZodDefault: fA,
  ZodCatch: hA,
  ZodNaN: ED,
  BRAND: lwt,
  ZodBranded: O1e,
  ZodPipeline: B1e,
  ZodReadonly: pA,
  custom: TUe,
  Schema: Ti,
  ZodSchema: Ti,
  late: cwt,
  get ZodFirstPartyTypeKind() {
    return va;
  },
  coerce: Hwt,
  any: vwt,
  array: Cwt,
  bigint: fwt,
  boolean: MUe,
  date: hwt,
  discriminatedUnion: kwt,
  effect: G6e,
  enum: Bwt,
  function: Pwt,
  instanceof: uwt,
  intersection: Awt,
  lazy: Rwt,
  literal: Owt,
  map: Iwt,
  nan: dwt,
  nativeEnum: Nwt,
  never: bwt,
  null: gwt,
  nullable: Lwt,
  number: IUe,
  object: wwt,
  oboolean: Wwt,
  onumber: Gwt,
  optional: Dwt,
  ostring: zwt,
  pipeline: Fwt,
  preprocess: jwt,
  promise: $wt,
  record: Ewt,
  set: Mwt,
  strictObject: Swt,
  string: EUe,
  symbol: pwt,
  transformer: G6e,
  tuple: Twt,
  undefined: mwt,
  union: _wt,
  unknown: ywt,
  void: xwt,
  NEVER: Uwt,
  ZodIssueCode: Dr,
  quotelessJson: LCt,
  ZodError: k1
});
const Vwt = () => (t) => t, qwt = 1, Nt = PUe.string().min(qwt), RUe = () => Nt.brand(), v0 = () => PUe.string().uuid().brand(), OUe = v0(), $I = v0(), Kwt = v0(), Zwt = v0(), Mu = {
  SYSTEM: "SYSTEM",
  USER: "USER",
  ASSISTANT: "ASSISTANT"
}, Jwt = se.nativeEnum(Mu), bm = {
  THUMBS_UP: "THUMBS_UP",
  THUMBS_DOWN: "THUMBS_DOWN"
}, BUe = se.nativeEnum(bm), Ywt = se.object({
  id: Zwt,
  createdAt: se.date(),
  updatedAt: se.date(),
  messageId: $I,
  content: se.string().optional(),
  type: BUe
}), Xwt = se.object({
  id: Kwt,
  createdAt: se.date(),
  updatedAt: se.date(),
  messageId: $I,
  name: Nt,
  input: Nt,
  // Making output and formattedOutput nullable because their possibly null for WOZD chats.
  output: Nt.optional().nullable(),
  formattedOutput: Nt.optional().nullable(),
  providedBlocks: se.array(se.any())
  // TODO WOBK parsers
}), Qwt = se.object({
  id: $I,
  createdAt: se.date(),
  updatedAt: se.date(),
  chatId: OUe,
  messageRole: Jwt,
  content: se.string(),
  redactedContent: se.string().nullable(),
  userId: Nt.nullish(),
  slackMessageTimestamp: Nt.nullish(),
  isComplete: se.boolean().nullish(),
  feedback: Ywt.nullish(),
  toolCalls: se.array(Xwt),
  llmPromptTokens: se.number().nullish(),
  llmCompletionTokens: se.number().nullish(),
  llmTotalTokens: se.number().nullish(),
  llmCost: se.number().nullish()
});
Vwt()(
  se.object({
    userId: se.string(),
    accountSid: se.string().optional(),
    ingress: lz,
    origin: lUe,
    userMessage: se.string(),
    slackThreadTimestamp: se.string().nullable(),
    slackConversationId: se.string().nullable(),
    aboutTicketId: se.string().optional()
  })
);
se.object({
  id: OUe,
  createdAt: se.date(),
  updatedAt: se.date(),
  messages: se.array(Qwt),
  userId: Nt,
  accountSid: Ov.nullish(),
  ingress: lz,
  origin: lUe,
  title: se.string().nullish(),
  aboutTicketId: Nt.nullish(),
  createdTicketId: Nt.nullish(),
  createdLiveChatId: Nt.nullish(),
  slackThreadTimestamp: Nt.nullish(),
  slackConversationId: Nt.nullish()
});
var QO = { exports: {} }, W6e;
function eSt() {
  return W6e || (W6e = 1, function(t, e) {
    (function() {
      var r = 9007199254740992, n = -9007199254740992, a = "0123456789", i = "abcdefghijklmnopqrstuvwxyz", o = i.toUpperCase(), s = a + "abcdef";
      function l(d) {
        this.name = "UnsupportedError", this.message = d || "This feature is not supported on this platform";
      }
      l.prototype = new Error(), l.prototype.constructor = l;
      var c = Array.prototype.slice;
      function u(d) {
        if (!(this instanceof u))
          return d || (d = null), d === null ? new u() : new u(d);
        if (typeof d == "function")
          return this.random = d, this;
        arguments.length && (this.seed = 0);
        for (var m = 0; m < arguments.length; m++) {
          var v = 0;
          if (Object.prototype.toString.call(arguments[m]) === "[object String]")
            for (var k = 0; k < arguments[m].length; k++) {
              for (var O = 0, G = 0; G < arguments[m].length; G++)
                O = arguments[m].charCodeAt(G) + (O << 6) + (O << 16) - O;
              v += O;
            }
          else
            v = arguments[m];
          this.seed += (arguments.length - m) * v;
        }
        return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function() {
          return this.mt.random(this.seed);
        }, this;
      }
      u.prototype.VERSION = "1.1.12";
      function f(d, m) {
        if (d = d || {}, m)
          for (var v in m)
            typeof d[v] > "u" && (d[v] = m[v]);
        return d;
      }
      function h(d) {
        return Array.apply(null, Array(d)).map(function(m, v) {
          return v;
        });
      }
      function p(d, m) {
        if (d)
          throw new RangeError(m);
      }
      var g = function() {
        throw new Error("No Base64 encoder available.");
      };
      (function() {
        typeof btoa == "function" ? g = btoa : typeof nc == "function" && (g = function(m) {
          return new nc(m).toString("base64");
        });
      })(), u.prototype.bool = function(d) {
        return d = f(d, { likelihood: 50 }), p(
          d.likelihood < 0 || d.likelihood > 100,
          "Chance: Likelihood accepts values from 0 to 100."
        ), this.random() * 100 < d.likelihood;
      }, u.prototype.falsy = function(d) {
        d = f(d, { pool: [!1, null, 0, NaN, "", void 0] });
        var m = d.pool, v = this.integer({ min: 0, max: m.length - 1 }), k = m[v];
        return k;
      }, u.prototype.animal = function(d) {
        if (d = f(d), typeof d.type < "u")
          return p(
            !this.get("animals")[d.type.toLowerCase()],
            "Please pick from desert, ocean, grassland, forest, zoo, pets, farm."
          ), this.pick(this.get("animals")[d.type.toLowerCase()]);
        var m = ["desert", "forest", "ocean", "zoo", "farm", "pet", "grassland"];
        return this.pick(this.get("animals")[this.pick(m)]);
      }, u.prototype.character = function(d) {
        d = f(d);
        var m = "!@#$%^&*()[]", v, k;
        return d.casing === "lower" ? v = i : d.casing === "upper" ? v = o : v = i + o, d.pool ? k = d.pool : (k = "", d.alpha && (k += v), d.numeric && (k += a), d.symbols && (k += m), k || (k = v + a + m)), k.charAt(this.natural({ max: k.length - 1 }));
      }, u.prototype.floating = function(d) {
        d = f(d, { fixed: 4 }), p(
          d.fixed && d.precision,
          "Chance: Cannot specify both fixed and precision."
        );
        var m, v = Math.pow(10, d.fixed), k = r / v, O = -k;
        p(
          d.min && d.fixed && d.min < O,
          "Chance: Min specified is out of range with fixed. Min should be, at least, " + O
        ), p(
          d.max && d.fixed && d.max > k,
          "Chance: Max specified is out of range with fixed. Max should be, at most, " + k
        ), d = f(d, { min: O, max: k }), m = this.integer({ min: d.min * v, max: d.max * v });
        var G = (m / v).toFixed(d.fixed);
        return parseFloat(G);
      }, u.prototype.integer = function(d) {
        return d = f(d, { min: n, max: r }), p(d.min > d.max, "Chance: Min cannot be greater than Max."), Math.floor(this.random() * (d.max - d.min + 1) + d.min);
      }, u.prototype.natural = function(d) {
        if (d = f(d, { min: 0, max: r }), typeof d.numerals == "number" && (p(d.numerals < 1, "Chance: Numerals cannot be less than one."), d.min = Math.pow(10, d.numerals - 1), d.max = Math.pow(10, d.numerals) - 1), p(d.min < 0, "Chance: Min cannot be less than zero."), d.exclude) {
          p(!Array.isArray(d.exclude), "Chance: exclude must be an array.");
          for (var m in d.exclude)
            p(!Number.isInteger(d.exclude[m]), "Chance: exclude must be numbers.");
          var v = d.min + this.natural({ max: d.max - d.min - d.exclude.length }), k = d.exclude.sort();
          for (var O in k) {
            if (v < k[O])
              break;
            v++;
          }
          return v;
        }
        return this.integer(d);
      }, u.prototype.prime = function(d) {
        d = f(d, { min: 0, max: 1e4 }), p(d.min < 0, "Chance: Min cannot be less than zero."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = x.primes[x.primes.length - 1];
        if (d.max > m)
          for (var v = m + 2; v <= d.max; ++v)
            this.is_prime(v) && x.primes.push(v);
        var k = x.primes.filter(function(O) {
          return O >= d.min && O <= d.max;
        });
        return this.pick(k);
      }, u.prototype.is_prime = function(d) {
        if (d % 1 || d < 2)
          return !1;
        if (d % 2 === 0)
          return d === 2;
        if (d % 3 === 0)
          return d === 3;
        for (var m = Math.sqrt(d), v = 5; v <= m; v += 6)
          if (d % v === 0 || d % (v + 2) === 0)
            return !1;
        return !0;
      }, u.prototype.hex = function(d) {
        d = f(d, { min: 0, max: r, casing: "lower" }), p(d.min < 0, "Chance: Min cannot be less than zero.");
        var m = this.natural({ min: d.min, max: d.max });
        return d.casing === "upper" ? m.toString(16).toUpperCase() : m.toString(16);
      }, u.prototype.letter = function(d) {
        d = f(d, { casing: "lower" });
        var m = "abcdefghijklmnopqrstuvwxyz", v = this.character({ pool: m });
        return d.casing === "upper" && (v = v.toUpperCase()), v;
      }, u.prototype.string = function(d) {
        d = f(d, { min: 5, max: 20 }), d.length !== 0 && !d.length && (d.length = this.natural({ min: d.min, max: d.max })), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return v.join("");
      };
      function y(d) {
        this.c = d;
      }
      y.prototype = {
        substitute: function() {
          return this.c;
        }
      };
      function b(d) {
        this.c = d;
      }
      b.prototype = {
        substitute: function() {
          if (!/[{}\\]/.test(this.c))
            throw new Error('Invalid escape sequence: "\\' + this.c + '".');
          return this.c;
        }
      };
      function w(d) {
        this.c = d;
      }
      w.prototype = {
        replacers: {
          "#": function(d) {
            return d.character({ pool: a });
          },
          A: function(d) {
            return d.character({ pool: o });
          },
          a: function(d) {
            return d.character({ pool: i });
          }
        },
        substitute: function(d) {
          var m = this.replacers[this.c];
          if (!m)
            throw new Error('Invalid replacement character: "' + this.c + '".');
          return m(d);
        }
      };
      function _(d) {
        for (var m = [], v = "identity", k = 0; k < d.length; k++) {
          var O = d[k];
          switch (v) {
            case "escape":
              m.push(new b(O)), v = "identity";
              break;
            case "identity":
              O === "{" ? v = "replace" : O === "\\" ? v = "escape" : m.push(new y(O));
              break;
            case "replace":
              O === "}" ? v = "identity" : m.push(new w(O));
              break;
          }
        }
        return m;
      }
      u.prototype.template = function(d) {
        if (!d)
          throw new Error("Template string is required");
        var m = this;
        return _(d).map(function(v) {
          return v.substitute(m);
        }).join("");
      }, u.prototype.buffer = function(d) {
        if (typeof nc > "u")
          throw new l("Sorry, the buffer() function is not supported on your platform");
        d = f(d, { length: this.natural({ min: 5, max: 20 }) }), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return nc.from(v);
      }, u.prototype.capitalize = function(d) {
        return d.charAt(0).toUpperCase() + d.substr(1);
      }, u.prototype.mixin = function(d) {
        for (var m in d)
          this[m] = d[m];
        return this;
      }, u.prototype.unique = function(d, m, v) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        );
        var k = function(W, U) {
          return W.indexOf(U) !== -1;
        };
        v && (k = v.comparator || k);
        for (var O = [], G = 0, H, j = m * 50, F = c.call(arguments, 2); O.length < m; ) {
          var z = JSON.parse(JSON.stringify(F));
          if (H = d.apply(this, z), k(O, H) || (O.push(H), G = 0), ++G > j)
            throw new RangeError("Chance: num is likely too large for sample set");
        }
        return O;
      }, u.prototype.n = function(d, m) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        ), typeof m > "u" && (m = 1);
        var v = m, k = [], O = c.call(arguments, 2);
        for (v = Math.max(0, v), null; v--; null)
          k.push(d.apply(this, O));
        return k;
      }, u.prototype.pad = function(d, m, v) {
        return v = v || "0", d = d + "", d.length >= m ? d : new Array(m - d.length + 1).join(v) + d;
      }, u.prototype.pick = function(d, m) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pick() from an empty array");
        return !m || m === 1 ? d[this.natural({ max: d.length - 1 })] : this.shuffle(d).slice(0, m);
      }, u.prototype.pickone = function(d) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickone() from an empty array");
        return d[this.natural({ max: d.length - 1 })];
      }, u.prototype.pickset = function(d, m) {
        if (m === 0)
          return [];
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (m < 0)
          throw new RangeError("Chance: Count must be a positive number");
        if (!m || m === 1)
          return [this.pickone(d)];
        var v = d.slice(0), k = v.length;
        return this.n(function() {
          var O = this.natural({ max: --k }), G = v[O];
          return v[O] = v[k], G;
        }, Math.min(k, m));
      }, u.prototype.shuffle = function(d) {
        for (var m = [], v = 0, k = Number(d.length), O = h(k), G = k - 1, H, j = 0; j < k; j++)
          H = this.natural({ max: G }), v = O[H], m[j] = d[v], O[H] = O[G], G -= 1;
        return m;
      }, u.prototype.weighted = function(d, m, v) {
        if (d.length !== m.length)
          throw new RangeError("Chance: Length of array and weights must match");
        for (var k = 0, O, G = 0; G < m.length; ++G) {
          if (O = m[G], isNaN(O))
            throw new RangeError("Chance: All weights must be numbers");
          O > 0 && (k += O);
        }
        if (k === 0)
          throw new RangeError("Chance: No valid entries in array weights");
        var H = this.random() * k, j = 0, F = -1, z;
        for (G = 0; G < m.length; ++G) {
          if (O = m[G], j += O, O > 0) {
            if (H <= j) {
              z = G;
              break;
            }
            F = G;
          }
          G === m.length - 1 && (z = F);
        }
        var W = d[z];
        return v = typeof v > "u" ? !1 : v, v && (d.splice(z, 1), m.splice(z, 1)), W;
      }, u.prototype.paragraph = function(d) {
        d = f(d);
        var m = d.sentences || this.natural({ min: 3, max: 7 }), v = this.n(this.sentence, m), k = d.linebreak === !0 ? `
` : " ";
        return v.join(k);
      }, u.prototype.sentence = function(d) {
        d = f(d);
        var m = d.words || this.natural({ min: 12, max: 18 }), v = d.punctuation, k, O = this.n(this.word, m);
        return k = O.join(" "), k = this.capitalize(k), v !== !1 && !/^[.?;!:]$/.test(v) && (v = "."), v && (k += v), k;
      }, u.prototype.syllable = function(d) {
        d = f(d);
        for (var m = d.length || this.natural({ min: 2, max: 3 }), v = "bcdfghjklmnprstvwz", k = "aeiou", O = v + k, G = "", H, j = 0; j < m; j++)
          j === 0 ? H = this.character({ pool: O }) : v.indexOf(H) === -1 ? H = this.character({ pool: v }) : H = this.character({ pool: k }), G += H;
        return d.capitalize && (G = this.capitalize(G)), G;
      }, u.prototype.word = function(d) {
        d = f(d), p(
          d.syllables && d.length,
          "Chance: Cannot specify both syllables AND length."
        );
        var m = d.syllables || this.natural({ min: 1, max: 3 }), v = "";
        if (d.length) {
          do
            v += this.syllable();
          while (v.length < d.length);
          v = v.substring(0, d.length);
        } else
          for (var k = 0; k < m; k++)
            v += this.syllable();
        return d.capitalize && (v = this.capitalize(v)), v;
      }, u.prototype.emoji = function(d) {
        d = f(d, { category: "all", length: 1 }), p(
          d.length < 1 || BigInt(d.length) > BigInt(r),
          "Chance: length must be between 1 and " + String(r)
        );
        var m = this.get("emojis");
        d.category === "all" && (d.category = this.pickone(Object.keys(m)));
        var v = m[d.category];
        return p(
          v === void 0,
          "Chance: Unrecognised emoji category: [" + d.category + "]."
        ), this.pickset(v, d.length).map(function(k) {
          return String.fromCodePoint(k);
        }).join("");
      }, u.prototype.age = function(d) {
        d = f(d);
        var m;
        switch (d.type) {
          case "child":
            m = { min: 0, max: 12 };
            break;
          case "teen":
            m = { min: 13, max: 19 };
            break;
          case "adult":
            m = { min: 18, max: 65 };
            break;
          case "senior":
            m = { min: 65, max: 100 };
            break;
          case "all":
            m = { min: 0, max: 100 };
            break;
          default:
            m = { min: 18, max: 65 };
            break;
        }
        return this.natural(m);
      }, u.prototype.birthday = function(d) {
        var m = this.age(d), v = /* @__PURE__ */ new Date(), k = v.getFullYear();
        if (d && d.type) {
          var O = /* @__PURE__ */ new Date(), G = /* @__PURE__ */ new Date();
          O.setFullYear(k - m - 1), G.setFullYear(k - m), d = f(d, {
            min: O,
            max: G
          });
        } else if (d && (d.minAge !== void 0 || d.maxAge !== void 0)) {
          p(d.minAge < 0, "Chance: MinAge cannot be less than zero."), p(d.minAge > d.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
          var H = d.minAge !== void 0 ? d.minAge : 0, j = d.maxAge !== void 0 ? d.maxAge : 100, F = new Date(k - j - 1, v.getMonth(), v.getDate()), z = new Date(k - H, v.getMonth(), v.getDate());
          F.setDate(F.getDate() + 1), z.setDate(z.getDate() + 1), z.setMilliseconds(z.getMilliseconds() - 1), d = f(d, {
            min: F,
            max: z
          });
        } else
          d = f(d, {
            year: k - m
          });
        return this.date(d);
      }, u.prototype.cpf = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 9, { max: 9 }), v = m[8] * 2 + m[7] * 3 + m[6] * 4 + m[5] * 5 + m[4] * 6 + m[3] * 7 + m[2] * 8 + m[1] * 9 + m[0] * 10;
        v = 11 - v % 11, v >= 10 && (v = 0);
        var k = v * 2 + m[8] * 3 + m[7] * 4 + m[6] * 5 + m[5] * 6 + m[4] * 7 + m[3] * 8 + m[2] * 9 + m[1] * 10 + m[0] * 11;
        k = 11 - k % 11, k >= 10 && (k = 0);
        var O = "" + m[0] + m[1] + m[2] + "." + m[3] + m[4] + m[5] + "." + m[6] + m[7] + m[8] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.cnpj = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 12, { max: 12 }), v = m[11] * 2 + m[10] * 3 + m[9] * 4 + m[8] * 5 + m[7] * 6 + m[6] * 7 + m[5] * 8 + m[4] * 9 + m[3] * 2 + m[2] * 3 + m[1] * 4 + m[0] * 5;
        v = 11 - v % 11, v < 2 && (v = 0);
        var k = v * 2 + m[11] * 3 + m[10] * 4 + m[9] * 5 + m[8] * 6 + m[7] * 7 + m[6] * 8 + m[5] * 9 + m[4] * 2 + m[3] * 3 + m[2] * 4 + m[1] * 5 + m[0] * 6;
        k = 11 - k % 11, k < 2 && (k = 0);
        var O = "" + m[0] + m[1] + "." + m[2] + m[3] + m[4] + "." + m[5] + m[6] + m[7] + "/" + m[8] + m[9] + m[10] + m[11] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.first = function(d) {
        return d = f(d, { gender: this.gender(), nationality: "en" }), this.pick(this.get("firstNames")[d.gender.toLowerCase()][d.nationality.toLowerCase()]);
      }, u.prototype.profession = function(d) {
        return d = f(d), d.rank ? this.pick(["Apprentice ", "Junior ", "Senior ", "Lead "]) + this.pick(this.get("profession")) : this.pick(this.get("profession"));
      }, u.prototype.company = function() {
        return this.pick(this.get("company"));
      }, u.prototype.gender = function(d) {
        return d = f(d, { extraGenders: [] }), this.pick(["Male", "Female"].concat(d.extraGenders));
      }, u.prototype.last = function(d) {
        if (d = f(d, { nationality: "*" }), d.nationality === "*") {
          var m = [], v = this.get("lastNames");
          return Object.keys(v).forEach(function(k) {
            m = m.concat(v[k]);
          }), this.pick(m);
        } else
          return this.pick(this.get("lastNames")[d.nationality.toLowerCase()]);
      }, u.prototype.israelId = function() {
        for (var d = this.string({ pool: "0123456789", length: 8 }), m = 0, v = 0; v < d.length; v++) {
          var k = d[v] * (v / 2 === parseInt(v / 2) ? 1 : 2);
          k = this.pad(k, 2).toString(), k = parseInt(k[0]) + parseInt(k[1]), m = m + k;
        }
        return d = d + (10 - parseInt(m.toString().slice(-1))).toString().slice(-1), d;
      }, u.prototype.mrz = function(d) {
        var m = function(O) {
          var G = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(""), H = [7, 3, 1], j = 0;
          return typeof O != "string" && (O = O.toString()), O.split("").forEach(function(F, z) {
            var W = G.indexOf(F);
            W !== -1 ? F = W === 0 ? 0 : W + 9 : F = parseInt(F, 10), F *= H[z % H.length], j += F;
          }), j % 10;
        }, v = function(O) {
          var G = function(j) {
            return new Array(j + 1).join("<");
          }, H = [
            "P<",
            O.issuer,
            O.last.toUpperCase(),
            "<<",
            O.first.toUpperCase(),
            G(39 - (O.last.length + O.first.length + 2)),
            O.passportNumber,
            m(O.passportNumber),
            O.nationality,
            O.dob,
            m(O.dob),
            O.gender,
            O.expiry,
            m(O.expiry),
            G(14),
            m(G(14))
          ].join("");
          return H + m(H.substr(44, 10) + H.substr(57, 7) + H.substr(65, 7));
        }, k = this;
        return d = f(d, {
          first: this.first(),
          last: this.last(),
          passportNumber: this.integer({ min: 1e8, max: 999999999 }),
          dob: function() {
            var O = k.birthday({ type: "adult" });
            return [
              O.getFullYear().toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          expiry: function() {
            var O = /* @__PURE__ */ new Date();
            return [
              (O.getFullYear() + 5).toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          gender: this.gender() === "Female" ? "F" : "M",
          issuer: "GBR",
          nationality: "GBR"
        }), v(d);
      }, u.prototype.name = function(d) {
        d = f(d);
        var m = this.first(d), v = this.last(d), k;
        return d.middle ? k = m + " " + this.first(d) + " " + v : d.middle_initial ? k = m + " " + this.character({ alpha: !0, casing: "upper" }) + ". " + v : k = m + " " + v, d.prefix && (k = this.prefix(d) + " " + k), d.suffix && (k = k + " " + this.suffix(d)), k;
      }, u.prototype.name_prefixes = function(d) {
        d = d || "all", d = d.toLowerCase();
        var m = [
          { name: "Doctor", abbreviation: "Dr." }
        ];
        return (d === "male" || d === "all") && m.push({ name: "Mister", abbreviation: "Mr." }), (d === "female" || d === "all") && (m.push({ name: "Miss", abbreviation: "Miss" }), m.push({ name: "Misses", abbreviation: "Mrs." })), m;
      }, u.prototype.prefix = function(d) {
        return this.name_prefix(d);
      }, u.prototype.name_prefix = function(d) {
        return d = f(d, { gender: "all" }), d.full ? this.pick(this.name_prefixes(d.gender)).name : this.pick(this.name_prefixes(d.gender)).abbreviation;
      }, u.prototype.HIDN = function() {
        var d = "0123456789", m = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ", v = "";
        return v += this.string({ pool: d, length: 6 }), v += this.string({ pool: m, length: 2 }), v;
      }, u.prototype.ssn = function(d) {
        d = f(d, { ssnFour: !1, dashes: !0 });
        var m = "1234567890", v, k = d.dashes ? "-" : "";
        return d.ssnFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 3 }) + k + this.string({ pool: m, length: 2 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.aadhar = function(d) {
        d = f(d, { onlyLastFour: !1, separatedByWhiteSpace: !0 });
        var m = "1234567890", v, k = d.separatedByWhiteSpace ? " " : "";
        return d.onlyLastFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.name_suffixes = function() {
        var d = [
          { name: "Doctor of Osteopathic Medicine", abbreviation: "D.O." },
          { name: "Doctor of Philosophy", abbreviation: "Ph.D." },
          { name: "Esquire", abbreviation: "Esq." },
          { name: "Junior", abbreviation: "Jr." },
          { name: "Juris Doctor", abbreviation: "J.D." },
          { name: "Master of Arts", abbreviation: "M.A." },
          { name: "Master of Business Administration", abbreviation: "M.B.A." },
          { name: "Master of Science", abbreviation: "M.S." },
          { name: "Medical Doctor", abbreviation: "M.D." },
          { name: "Senior", abbreviation: "Sr." },
          { name: "The Third", abbreviation: "III" },
          { name: "The Fourth", abbreviation: "IV" },
          { name: "Bachelor of Engineering", abbreviation: "B.E" },
          { name: "Bachelor of Technology", abbreviation: "B.TECH" }
        ];
        return d;
      }, u.prototype.suffix = function(d) {
        return this.name_suffix(d);
      }, u.prototype.name_suffix = function(d) {
        return d = f(d), d.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
      }, u.prototype.nationalities = function() {
        return this.get("nationalities");
      }, u.prototype.nationality = function() {
        var d = this.pick(this.nationalities());
        return d.name;
      }, u.prototype.zodiac = function() {
        const d = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];
        return this.pickone(d);
      }, u.prototype.android_id = function() {
        return "APA91" + this.string({ pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_", length: 178 });
      }, u.prototype.apple_token = function() {
        return this.string({ pool: "abcdef1234567890", length: 64 });
      }, u.prototype.wp8_anid2 = function() {
        return g(this.hash({ length: 32 }));
      }, u.prototype.wp7_anid = function() {
        return "A=" + this.guid().replace(/-/g, "").toUpperCase() + "&E=" + this.hash({ length: 3 }) + "&W=" + this.integer({ min: 0, max: 9 });
      }, u.prototype.bb_pin = function() {
        return this.hash({ length: 8 });
      }, u.prototype.avatar = function(d) {
        var m = null, v = "//www.gravatar.com/avatar/", k = {
          http: "http",
          https: "https"
        }, O = {
          bmp: "bmp",
          gif: "gif",
          jpg: "jpg",
          png: "png"
        }, G = {
          404: "404",
          // Return 404 if not found
          mm: "mm",
          // Mystery man
          identicon: "identicon",
          // Geometric pattern based on hash
          monsterid: "monsterid",
          // A generated monster icon
          wavatar: "wavatar",
          // A generated face
          retro: "retro",
          // 8-bit icon
          blank: "blank"
          // A transparent png
        }, H = {
          g: "g",
          pg: "pg",
          r: "r",
          x: "x"
        }, j = {
          protocol: null,
          email: null,
          fileExtension: null,
          size: null,
          fallback: null,
          rating: null
        };
        if (!d)
          j.email = this.email(), d = {};
        else if (typeof d == "string")
          j.email = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        return j = f(d, j), j.email || (j.email = this.email()), j.protocol = k[j.protocol] ? j.protocol + ":" : "", j.size = parseInt(j.size, 0) ? j.size : "", j.rating = H[j.rating] ? j.rating : "", j.fallback = G[j.fallback] ? j.fallback : "", j.fileExtension = O[j.fileExtension] ? j.fileExtension : "", m = j.protocol + v + this.bimd5.md5(j.email) + (j.fileExtension ? "." + j.fileExtension : "") + (j.size || j.rating || j.fallback ? "?" : "") + (j.size ? "&s=" + j.size.toString() : "") + (j.rating ? "&r=" + j.rating : "") + (j.fallback ? "&d=" + j.fallback : ""), m;
      }, u.prototype.color = function(d) {
        function m(ce, ee) {
          return [ce, ce, ce].join(ee || "");
        }
        function v(ce) {
          var ee = ce ? "rgba" : "rgb", Se = ce ? "," + this.floating({ min: V, max: Y }) : "", Ce = O ? m(this.natural({ min: G, max: H }), ",") : this.natural({ min: z, max: W }) + "," + this.natural({ min: U, max: Z }) + "," + this.natural({ max: 255 });
          return ee + "(" + Ce + Se + ")";
        }
        function k(ce, ee, Se) {
          var Ce = Se ? "#" : "", we = "";
          return O ? (we = m(this.pad(this.hex({ min: G, max: H }), 2)), d.format === "shorthex" && (we = m(this.hex({ min: 0, max: 15 })))) : d.format === "shorthex" ? we = this.pad(this.hex({ min: Math.floor(j / 16), max: Math.floor(F / 16) }), 1) + this.pad(this.hex({ min: Math.floor(z / 16), max: Math.floor(W / 16) }), 1) + this.pad(this.hex({ min: Math.floor(U / 16), max: Math.floor(Z / 16) }), 1) : j !== void 0 || F !== void 0 || z !== void 0 || W !== void 0 || U !== void 0 || Z !== void 0 ? we = this.pad(this.hex({ min: j, max: F }), 2) + this.pad(this.hex({ min: z, max: W }), 2) + this.pad(this.hex({ min: U, max: Z }), 2) : we = this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2), Ce + we;
        }
        d = f(d, {
          format: this.pick(["hex", "shorthex", "rgb", "rgba", "0x", "name"]),
          grayscale: !1,
          casing: "lower",
          min: 0,
          max: 255,
          min_red: void 0,
          max_red: void 0,
          min_green: void 0,
          max_green: void 0,
          min_blue: void 0,
          max_blue: void 0,
          min_alpha: 0,
          max_alpha: 1
        });
        var O = d.grayscale, G = d.min, H = d.max, j = d.min_red, F = d.max_red, z = d.min_green, W = d.max_green, U = d.min_blue, Z = d.max_blue, V = d.min_alpha, Y = d.max_alpha;
        d.min_red === void 0 && (j = G), d.max_red === void 0 && (F = H), d.min_green === void 0 && (z = G), d.max_green === void 0 && (W = H), d.min_blue === void 0 && (U = G), d.max_blue === void 0 && (Z = H), d.min_alpha === void 0 && (V = 0), d.max_alpha === void 0 && (Y = 1), O && G === 0 && H === 255 && j !== void 0 && F !== void 0 && (G = (j + z + U) / 3, H = (F + W + Z) / 3);
        var ge;
        if (d.format === "hex")
          ge = k.call(this, 2, 6, !0);
        else if (d.format === "shorthex")
          ge = k.call(this, 1, 3, !0);
        else if (d.format === "rgb")
          ge = v.call(this, !1);
        else if (d.format === "rgba")
          ge = v.call(this, !0);
        else if (d.format === "0x")
          ge = "0x" + k.call(this, 2, 6);
        else {
          if (d.format === "name")
            return this.pick(this.get("colorNames"));
          throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        }
        return d.casing === "upper" && (ge = ge.toUpperCase()), ge;
      }, u.prototype.domain = function(d) {
        return d = f(d), this.word() + "." + (d.tld || this.tld());
      }, u.prototype.email = function(d) {
        return d = f(d), this.word({ length: d.length }) + "@" + (d.domain || this.domain());
      }, u.prototype.fbid = function() {
        return "10000" + this.string({ pool: "1234567890", length: 11 });
      }, u.prototype.google_analytics = function() {
        var d = this.pad(this.natural({ max: 999999 }), 6), m = this.pad(this.natural({ max: 99 }), 2);
        return "UA-" + d + "-" + m;
      }, u.prototype.hashtag = function() {
        return "#" + this.word();
      }, u.prototype.ip = function() {
        return this.natural({ min: 1, max: 254 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ min: 1, max: 254 });
      }, u.prototype.ipv6 = function() {
        var d = this.n(this.hash, 8, { length: 4 });
        return d.join(":");
      }, u.prototype.klout = function() {
        return this.natural({ min: 1, max: 99 });
      }, u.prototype.mac = function(d) {
        return d = f(d, { delimiter: ":" }), this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2);
      }, u.prototype.semver = function(d) {
        d = f(d, { include_prerelease: !0 });
        var m = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
        d.range && (m = d.range);
        var v = "";
        return d.include_prerelease && (v = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1])), m + this.rpg("3d10").join(".") + v;
      }, u.prototype.tlds = function() {
        return ["com", "org", "edu", "gov", "co.uk", "net", "io", "ac", "ad", "ae", "af", "ag", "ai", "al", "am", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bm", "bn", "bo", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "eu", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "su", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "uk", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"];
      }, u.prototype.tld = function() {
        return this.pick(this.tlds());
      }, u.prototype.twitter = function() {
        return "@" + this.word();
      }, u.prototype.url = function(d) {
        d = f(d, { protocol: "http", domain: this.domain(d), domain_prefix: "", path: this.word(), extensions: [] });
        var m = d.extensions.length > 0 ? "." + this.pick(d.extensions) : "", v = d.domain_prefix ? d.domain_prefix + "." + d.domain : d.domain;
        return d.protocol + "://" + v + "/" + d.path + m;
      }, u.prototype.port = function() {
        return this.integer({ min: 0, max: 65535 });
      }, u.prototype.locale = function(d) {
        return d = f(d), d.region ? this.pick(this.get("locale_regions")) : this.pick(this.get("locale_languages"));
      }, u.prototype.locales = function(d) {
        return d = f(d), d.region ? this.get("locale_regions") : this.get("locale_languages");
      }, u.prototype.loremPicsum = function(d) {
        d = f(d, { width: 500, height: 500, greyscale: !1, blurred: !1 });
        var m = d.greyscale ? "g/" : "", v = d.blurred ? "/?blur" : "/?random";
        return "https://picsum.photos/" + m + d.width + "/" + d.height + v;
      }, u.prototype.address = function(d) {
        return d = f(d), this.natural({ min: 5, max: 2e3 }) + " " + this.street(d);
      }, u.prototype.altitude = function(d) {
        return d = f(d, { fixed: 5, min: 0, max: 8848 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.areacode = function(d) {
        d = f(d, { parens: !0 });
        var m = d.exampleNumber ? "555" : this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 8 }).toString() + this.natural({ min: 0, max: 9 }).toString();
        return d.parens ? "(" + m + ")" : m;
      }, u.prototype.city = function() {
        return this.capitalize(this.word({ syllables: 3 }));
      }, u.prototype.coordinates = function(d) {
        return this.latitude(d) + ", " + this.longitude(d);
      }, u.prototype.countries = function() {
        return this.get("countries");
      }, u.prototype.country = function(d) {
        d = f(d);
        var m = this.pick(this.countries());
        return d.raw ? m : d.full ? m.name : m.abbreviation;
      }, u.prototype.depth = function(d) {
        return d = f(d, { fixed: 5, min: -10994, max: 0 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.geohash = function(d) {
        return d = f(d, { length: 7 }), this.string({ length: d.length, pool: "0123456789bcdefghjkmnpqrstuvwxyz" });
      }, u.prototype.geojson = function(d) {
        return this.latitude(d) + ", " + this.longitude(d) + ", " + this.altitude(d);
      }, u.prototype.latitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 89, fixed: 4 } : { fixed: 5, min: -90, max: 90, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89"), p(d.max < 0 || d.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.longitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 179, fixed: 4 } : { fixed: 5, min: -180, max: 180, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179"), p(d.max < 0 || d.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.phone = function(d) {
        var m = this, v, k = function(U) {
          var Z = [];
          return U.sections.forEach(function(V) {
            Z.push(m.string({ pool: "0123456789", length: V }));
          }), U.area + Z.join(" ");
        };
        d = f(d, {
          formatted: !0,
          country: "us",
          mobile: !1,
          exampleNumber: !1
        }), d.formatted || (d.parens = !1);
        var O;
        switch (d.country) {
          case "fr":
            d.mobile ? (v = this.pick(["06", "07"]) + m.string({ pool: "0123456789", length: 8 }), O = d.formatted ? v.match(/../g).join(" ") : v) : (v = this.pick([
              // Valid zone and département codes.
              "01" + this.pick(["30", "34", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "53", "55", "56", "58", "60", "64", "69", "70", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83"]) + m.string({ pool: "0123456789", length: 6 }),
              "02" + this.pick(["14", "18", "22", "23", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "40", "41", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "56", "57", "61", "62", "69", "72", "76", "77", "78", "85", "90", "96", "97", "98", "99"]) + m.string({ pool: "0123456789", length: 6 }),
              "03" + this.pick(["10", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "39", "44", "45", "51", "52", "54", "55", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90"]) + m.string({ pool: "0123456789", length: 6 }),
              "04" + this.pick(["11", "13", "15", "20", "22", "26", "27", "30", "32", "34", "37", "42", "43", "44", "50", "56", "57", "63", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "88", "89", "90", "91", "92", "93", "94", "95", "97", "98"]) + m.string({ pool: "0123456789", length: 6 }),
              "05" + this.pick(["08", "16", "17", "19", "24", "31", "32", "33", "34", "35", "40", "45", "46", "47", "49", "53", "55", "56", "57", "58", "59", "61", "62", "63", "64", "65", "67", "79", "81", "82", "86", "87", "90", "94"]) + m.string({ pool: "0123456789", length: 6 }),
              "09" + m.string({ pool: "0123456789", length: 8 })
            ]), O = d.formatted ? v.match(/../g).join(" ") : v);
            break;
          case "uk":
            d.mobile ? (v = this.pick([
              { area: "07" + this.pick(["4", "5", "7", "8", "9"]), sections: [2, 6] },
              { area: "07624 ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "")) : (v = this.pick([
              //valid area codes of major cities/counties followed by random numbers in required format.
              { area: "01" + this.character({ pool: "234569" }) + "1 ", sections: [3, 4] },
              { area: "020 " + this.character({ pool: "378" }), sections: [3, 4] },
              { area: "023 " + this.character({ pool: "89" }), sections: [3, 4] },
              { area: "024 7", sections: [3, 4] },
              { area: "028 " + this.pick(["25", "28", "37", "71", "82", "90", "92", "95"]), sections: [2, 4] },
              { area: "012" + this.pick(["04", "08", "54", "76", "97", "98"]) + " ", sections: [6] },
              { area: "013" + this.pick(["63", "64", "84", "86"]) + " ", sections: [6] },
              { area: "014" + this.pick(["04", "20", "60", "61", "80", "88"]) + " ", sections: [6] },
              { area: "015" + this.pick(["24", "27", "62", "66"]) + " ", sections: [6] },
              { area: "016" + this.pick(["06", "29", "35", "47", "59", "95"]) + " ", sections: [6] },
              { area: "017" + this.pick(["26", "44", "50", "68"]) + " ", sections: [6] },
              { area: "018" + this.pick(["27", "37", "84", "97"]) + " ", sections: [6] },
              { area: "019" + this.pick(["00", "05", "35", "46", "49", "63", "95"]) + " ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "", "g"));
            break;
          case "za":
            d.mobile ? (v = this.pick([
              "060" + this.pick(["3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "061" + this.pick(["0", "1", "2", "3", "4", "5", "8"]) + m.string({ pool: "0123456789", length: 6 }),
              "06" + m.string({ pool: "0123456789", length: 7 }),
              "071" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "07" + this.pick(["2", "3", "4", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "08" + this.pick(["0", "1", "2", "3", "4", "5"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v) : (v = this.pick([
              "01" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "02" + this.pick(["1", "2", "3", "4", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "03" + this.pick(["1", "2", "3", "5", "6", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "04" + this.pick(["1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "05" + this.pick(["1", "3", "4", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v);
            break;
          case "us":
            var G = this.areacode(d).toString(), H = this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString(), j = this.natural({ min: 1e3, max: 9999 }).toString();
            O = d.formatted ? G + " " + H + "-" + j : G + H + j;
            break;
          case "br":
            var F = this.pick(["11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", "94", "95", "96", "97", "98", "99"]), z;
            d.mobile ? z = "9" + m.string({ pool: "0123456789", length: 4 }) : z = this.natural({ min: 2e3, max: 5999 }).toString();
            var W = m.string({ pool: "0123456789", length: 4 });
            O = d.formatted ? "(" + F + ") " + z + "-" + W : F + z + W;
            break;
        }
        return O;
      }, u.prototype.postal = function() {
        var d = this.character({ pool: "XVTSRPNKLMHJGECBA" }), m = d + this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }), v = this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }) + this.natural({ max: 9 });
        return m + " " + v;
      }, u.prototype.postcode = function() {
        var d = this.pick(this.get("postcodeAreas")).code, m = this.natural({ max: 9 }), v = this.bool() ? this.character({ alpha: !0, casing: "upper" }) : "", k = d + m + v, O = this.natural({ max: 9 }), G = this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }), H = O + G;
        return k + " " + H;
      }, u.prototype.counties = function(d) {
        return d = f(d, { country: "uk" }), this.get("counties")[d.country.toLowerCase()];
      }, u.prototype.county = function(d) {
        return this.pick(this.counties(d)).name;
      }, u.prototype.provinces = function(d) {
        return d = f(d, { country: "ca" }), this.get("provinces")[d.country.toLowerCase()];
      }, u.prototype.province = function(d) {
        return d && d.full ? this.pick(this.provinces(d)).name : this.pick(this.provinces(d)).abbreviation;
      }, u.prototype.state = function(d) {
        return d && d.full ? this.pick(this.states(d)).name : this.pick(this.states(d)).abbreviation;
      }, u.prototype.states = function(d) {
        d = f(d, { country: "us", us_states_and_dc: !0 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            var v = this.get("us_states_and_dc"), k = this.get("territories"), O = this.get("armed_forces");
            m = [], d.us_states_and_dc && (m = m.concat(v)), d.territories && (m = m.concat(k)), d.armed_forces && (m = m.concat(O));
            break;
          case "it":
          case "mx":
            m = this.get("country_regions")[d.country.toLowerCase()];
            break;
          case "uk":
            m = this.get("counties")[d.country.toLowerCase()];
            break;
        }
        return m;
      }, u.prototype.street = function(d) {
        d = f(d, { country: "us", syllables: 2 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m += " ", m += d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name;
            break;
          case "it":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m = (d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name) + " " + m;
            break;
        }
        return m;
      }, u.prototype.street_suffix = function(d) {
        return d = f(d, { country: "us" }), this.pick(this.street_suffixes(d));
      }, u.prototype.street_suffixes = function(d) {
        return d = f(d, { country: "us" }), this.get("street_suffixes")[d.country.toLowerCase()];
      }, u.prototype.zip = function(d) {
        var m = this.n(this.natural, 5, { max: 9 });
        return d && d.plusfour === !0 && (m.push("-"), m = m.concat(this.n(this.natural, 4, { max: 9 }))), m.join("");
      }, u.prototype.ampm = function() {
        return this.bool() ? "am" : "pm";
      }, u.prototype.date = function(d) {
        var m, v;
        if (d && (d.min || d.max)) {
          d = f(d, {
            american: !0,
            string: !1
          });
          var k = typeof d.min < "u" ? d.min.getTime() : 1, O = typeof d.max < "u" ? d.max.getTime() : 864e13;
          v = new Date(this.integer({ min: k, max: O }));
        } else {
          var G = this.month({ raw: !0 }), H = G.days;
          d && d.month && (H = this.get("months")[(d.month % 12 + 12) % 12].days), d = f(d, {
            year: parseInt(this.year(), 10),
            // Necessary to subtract 1 because Date() 0-indexes month but not day or year
            // for some reason.
            month: G.numeric - 1,
            day: this.natural({ min: 1, max: H }),
            hour: this.hour({ twentyfour: !0 }),
            minute: this.minute(),
            second: this.second(),
            millisecond: this.millisecond(),
            american: !0,
            string: !1
          }), v = new Date(d.year, d.month, d.day, d.hour, d.minute, d.second, d.millisecond);
        }
        return d.american ? m = v.getMonth() + 1 + "/" + v.getDate() + "/" + v.getFullYear() : m = v.getDate() + "/" + (v.getMonth() + 1) + "/" + v.getFullYear(), d.string ? m : v;
      }, u.prototype.hammertime = function(d) {
        return this.date(d).getTime();
      }, u.prototype.hour = function(d) {
        return d = f(d, {
          min: d && d.twentyfour ? 0 : 1,
          max: d && d.twentyfour ? 23 : 12
        }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.twentyfour && d.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option."), p(!d.twentyfour && d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.millisecond = function() {
        return this.natural({ max: 999 });
      }, u.prototype.minute = u.prototype.second = function(d) {
        return d = f(d, { min: 0, max: 59 }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.max > 59, "Chance: Max cannot be greater than 59."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.month = function(d) {
        d = f(d, { min: 1, max: 12 }), p(d.min < 1, "Chance: Min cannot be less than 1."), p(d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = this.pick(this.months().slice(d.min - 1, d.max));
        return d.raw ? m : m.name;
      }, u.prototype.months = function() {
        return this.get("months");
      }, u.prototype.second = function() {
        return this.natural({ max: 59 });
      }, u.prototype.timestamp = function() {
        return this.natural({ min: 1, max: parseInt((/* @__PURE__ */ new Date()).getTime() / 1e3, 10) });
      }, u.prototype.weekday = function(d) {
        d = f(d, { weekday_only: !1 });
        var m = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        return d.weekday_only || (m.push("Saturday"), m.push("Sunday")), this.pickone(m);
      }, u.prototype.year = function(d) {
        return d = f(d, { min: (/* @__PURE__ */ new Date()).getFullYear() }), d.max = typeof d.max < "u" ? d.max : d.min + 100, this.natural(d).toString();
      }, u.prototype.cc = function(d) {
        d = f(d);
        var m, v, k;
        return m = d.type ? this.cc_type({ name: d.type, raw: !0 }) : this.cc_type({ raw: !0 }), v = m.prefix.split(""), k = m.length - m.prefix.length - 1, v = v.concat(this.n(this.integer, k, { min: 0, max: 9 })), v.push(this.luhn_calculate(v.join(""))), v.join("");
      }, u.prototype.cc_types = function() {
        return this.get("cc_types");
      }, u.prototype.cc_type = function(d) {
        d = f(d);
        var m = this.cc_types(), v = null;
        if (d.name) {
          for (var k = 0; k < m.length; k++)
            if (m[k].name === d.name || m[k].short_name === d.name) {
              v = m[k];
              break;
            }
          if (v === null)
            throw new RangeError("Chance: Credit card type '" + d.name + "' is not supported");
        } else
          v = this.pick(m);
        return d.raw ? v : v.name;
      }, u.prototype.currency_types = function() {
        return this.get("currency_types");
      }, u.prototype.currency = function() {
        return this.pick(this.currency_types());
      }, u.prototype.timezones = function() {
        return this.get("timezones");
      }, u.prototype.timezone = function() {
        return this.pick(this.timezones());
      }, u.prototype.currency_pair = function(d) {
        var m = this.unique(this.currency, 2, {
          comparator: function(v, k) {
            return v.reduce(function(O, G) {
              return O || G.code === k.code;
            }, !1);
          }
        });
        return d ? m[0].code + "/" + m[1].code : m;
      }, u.prototype.dollar = function(d) {
        d = f(d, { max: 1e4, min: 0 });
        var m = this.floating({ min: d.min, max: d.max, fixed: 2 }).toString(), v = m.split(".")[1];
        return v === void 0 ? m += ".00" : v.length < 2 && (m = m + "0"), m < 0 ? "-$" + m.replace("-", "") : "$" + m;
      }, u.prototype.euro = function(d) {
        return Number(this.dollar(d).replace("$", "")).toLocaleString() + "€";
      }, u.prototype.exp = function(d) {
        d = f(d);
        var m = {};
        return m.year = this.exp_year(), m.year === (/* @__PURE__ */ new Date()).getFullYear().toString() ? m.month = this.exp_month({ future: !0 }) : m.month = this.exp_month(), d.raw ? m : m.month + "/" + m.year;
      }, u.prototype.exp_month = function(d) {
        d = f(d);
        var m, v, k = (/* @__PURE__ */ new Date()).getMonth() + 1;
        if (d.future && k !== 12)
          do
            m = this.month({ raw: !0 }).numeric, v = parseInt(m, 10);
          while (v <= k);
        else
          m = this.month({ raw: !0 }).numeric;
        return m;
      }, u.prototype.exp_year = function() {
        var d = (/* @__PURE__ */ new Date()).getMonth() + 1, m = (/* @__PURE__ */ new Date()).getFullYear();
        return this.year({ min: d === 12 ? m + 1 : m, max: m + 10 });
      }, u.prototype.vat = function(d) {
        switch (d = f(d, { country: "it" }), d.country.toLowerCase()) {
          case "it":
            return this.it_vat();
        }
      }, u.prototype.iban = function() {
        var d = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", m = d + "0123456789", v = this.string({ length: 2, pool: d }) + this.pad(this.integer({ min: 0, max: 99 }), 2) + this.string({ length: 4, pool: m }) + this.pad(this.natural(), this.natural({ min: 6, max: 26 }));
        return v;
      }, u.prototype.it_vat = function() {
        var d = this.natural({ min: 1, max: 18e5 });
        return d = this.pad(d, 7) + this.pad(this.pick(this.provinces({ country: "it" })).code, 3), d + this.luhn_calculate(d);
      }, u.prototype.cf = function(d) {
        d = d || {};
        var m = d.gender ? d.gender : this.gender(), v = d.first ? d.first : this.first({ gender: m, nationality: "it" }), k = d.last ? d.last : this.last({ nationality: "it" }), O = d.birthday ? d.birthday : this.birthday(), G = d.city ? d.city : this.pickone(["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M", "Z"]) + this.pad(this.natural({ max: 999 }), 3), H = [], j = function(W, U) {
          var Z, V = [];
          return W.length < 3 ? V = W.split("").concat("XXX".split("")).splice(0, 3) : (Z = W.toUpperCase().split("").map(function(Y) {
            return "BCDFGHJKLMNPRSTVWZ".indexOf(Y) !== -1 ? Y : void 0;
          }).join(""), Z.length > 3 && (U ? Z = Z.substr(0, 3) : Z = Z[0] + Z.substr(2, 2)), Z.length < 3 && (V = Z, Z = W.toUpperCase().split("").map(function(Y) {
            return "AEIOU".indexOf(Y) !== -1 ? Y : void 0;
          }).join("").substr(0, 3 - V.length)), V = V + Z), V;
        }, F = function(W, U, Z) {
          var V = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];
          return W.getFullYear().toString().substr(2) + V[W.getMonth()] + Z.pad(W.getDate() + (U.toLowerCase() === "female" ? 40 : 0), 2);
        }, z = function(W) {
          for (var U = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", Z = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", V = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", Y = "BAKPLCQDREVOSFTGUHMINJWZYX", ge = 0, ce = 0; ce < 15; ce++)
            ce % 2 !== 0 ? ge += V.indexOf(Z[U.indexOf(W[ce])]) : ge += Y.indexOf(Z[U.indexOf(W[ce])]);
          return V[ge % 26];
        };
        return H = H.concat(j(k, !0), j(v), F(O, m, this), G.toUpperCase().split("")).join(""), H += z(H.toUpperCase()), H.toUpperCase();
      }, u.prototype.pl_pesel = function() {
        for (var d = this.natural({ min: 1, max: 9999999999 }), m = this.pad(d, 10).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (1 * m[0] + 3 * m[1] + 7 * m[2] + 9 * m[3] + 1 * m[4] + 3 * m[5] + 7 * m[6] + 9 * m[7] + 1 * m[8] + 3 * m[9]) % 10;
        return k !== 0 && (k = 10 - k), m.join("") + k;
      }, u.prototype.pl_nip = function() {
        for (var d = this.natural({ min: 1, max: 999999999 }), m = this.pad(d, 9).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (6 * m[0] + 5 * m[1] + 7 * m[2] + 2 * m[3] + 3 * m[4] + 4 * m[5] + 5 * m[6] + 6 * m[7] + 7 * m[8]) % 11;
        return k === 10 ? this.pl_nip() : m.join("") + k;
      }, u.prototype.pl_regon = function() {
        for (var d = this.natural({ min: 1, max: 99999999 }), m = this.pad(d, 8).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (8 * m[0] + 9 * m[1] + 2 * m[2] + 3 * m[3] + 4 * m[4] + 5 * m[5] + 6 * m[6] + 7 * m[7]) % 11;
        return k === 10 && (k = 0), m.join("") + k;
      }, u.prototype.music_genre = function(d = "general") {
        if (!(d.toLowerCase() in x.music_genres))
          throw new Error(`Unsupported genre: ${d}`);
        const m = x.music_genres[d.toLowerCase()], v = this.integer({ min: 0, max: m.length - 1 });
        return m[v];
      }, u.prototype.note = function(d) {
        d = f(d, { notes: "flatKey" });
        var m = {
          naturals: ["C", "D", "E", "F", "G", "A", "B"],
          flats: ["D♭", "E♭", "G♭", "A♭", "B♭"],
          sharps: ["C♯", "D♯", "F♯", "G♯", "A♯"]
        };
        return m.all = m.naturals.concat(m.flats.concat(m.sharps)), m.flatKey = m.naturals.concat(m.flats), m.sharpKey = m.naturals.concat(m.sharps), this.pickone(m[d.notes]);
      }, u.prototype.midi_note = function(d) {
        var m = 0, v = 127;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.chord_quality = function(d) {
        d = f(d, { jazz: !0 });
        var m = ["maj", "min", "aug", "dim"];
        return d.jazz && (m = [
          "maj7",
          "min7",
          "7",
          "sus",
          "dim",
          "ø"
        ]), this.pickone(m);
      }, u.prototype.chord = function(d) {
        return d = f(d), this.note(d) + this.chord_quality(d);
      }, u.prototype.tempo = function(d) {
        var m = 40, v = 320;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
      };
      function C(d) {
        return function() {
          return this.natural(d);
        };
      }
      u.prototype.d4 = C({ min: 1, max: 4 }), u.prototype.d6 = C({ min: 1, max: 6 }), u.prototype.d8 = C({ min: 1, max: 8 }), u.prototype.d10 = C({ min: 1, max: 10 }), u.prototype.d12 = C({ min: 1, max: 12 }), u.prototype.d20 = C({ min: 1, max: 20 }), u.prototype.d30 = C({ min: 1, max: 30 }), u.prototype.d100 = C({ min: 1, max: 100 }), u.prototype.rpg = function(d, m) {
        if (m = f(m), d) {
          var v = d.toLowerCase().split("d"), k = [];
          if (v.length !== 2 || !parseInt(v[0], 10) || !parseInt(v[1], 10))
            throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
          for (var O = v[0]; O > 0; O--)
            k[O - 1] = this.natural({ min: 1, max: v[1] });
          return typeof m.sum < "u" && m.sum ? k.reduce(function(G, H) {
            return G + H;
          }) : k;
        } else
          throw new RangeError("Chance: A type of die roll must be included");
      }, u.prototype.guid = function(d) {
        d = f(d, { version: 5 });
        var m = "abcdef1234567890", v = "ab89", k = this.string({ pool: m, length: 8 }) + "-" + this.string({ pool: m, length: 4 }) + "-" + // The Version
        d.version + this.string({ pool: m, length: 3 }) + "-" + // The Variant
        this.string({ pool: v, length: 1 }) + this.string({ pool: m, length: 3 }) + "-" + this.string({ pool: m, length: 12 });
        return k;
      }, u.prototype.hash = function(d) {
        d = f(d, { length: 40, casing: "lower" });
        var m = d.casing === "upper" ? s.toUpperCase() : s;
        return this.string({ pool: m, length: d.length });
      }, u.prototype.luhn_check = function(d) {
        var m = d.toString(), v = +m.substring(m.length - 1);
        return v === this.luhn_calculate(+m.substring(0, m.length - 1));
      }, u.prototype.luhn_calculate = function(d) {
        for (var m = d.toString().split("").reverse(), v = 0, k, O = 0, G = m.length; G > O; ++O)
          k = +m[O], O % 2 === 0 && (k *= 2, k > 9 && (k -= 9)), v += k;
        return v * 9 % 10;
      }, u.prototype.md5 = function(d) {
        var m = { str: "", key: null, raw: !1 };
        if (!d)
          m.str = this.string(), d = {};
        else if (typeof d == "string")
          m.str = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        if (m = f(d, m), !m.str)
          throw new Error("A parameter is required to return an md5 hash.");
        return this.bimd5.md5(m.str, m.key, m.raw);
      }, u.prototype.file = function(d) {
        var m = d || {}, v = "fileExtension", k = Object.keys(this.get("fileExtension")), O, G;
        if (O = this.word({ length: m.length }), m.extension)
          return G = m.extension, O + "." + G;
        if (m.extensions) {
          if (Array.isArray(m.extensions))
            return G = this.pickone(m.extensions), O + "." + G;
          if (m.extensions.constructor === Object) {
            var H = m.extensions, j = Object.keys(H);
            return G = this.pickone(H[this.pickone(j)]), O + "." + G;
          }
          throw new Error("Chance: Extensions must be an Array or Object");
        }
        if (m.fileType) {
          var F = m.fileType;
          if (k.indexOf(F) !== -1)
            return G = this.pickone(this.get(v)[F]), O + "." + G;
          throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        return G = this.pickone(this.get(v)[this.pickone(k)]), O + "." + G;
      }, u.prototype.fileWithContent = function(d) {
        var m = d || {}, v = "fileName" in m ? m.fileName : this.file().split(".")[0];
        if (v += "." + ("fileExtension" in m ? m.fileExtension : this.file().split(".")[1]), typeof m.fileSize != "number")
          throw new Error("File size must be an integer");
        var k = {
          fileData: this.buffer({ length: m.fileSize }),
          fileName: v
        };
        return k;
      };
      var x = {
        firstNames: {
          male: {
            en: ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
            it: ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Aaron", "Abel", "Adam", "Adriaan", "Albert", "Alexander", "Ali", "Arjen", "Arno", "Bart", "Bas", "Bastiaan", "Benjamin", "Bob", "Boris", "Bram", "Brent", "Cas", "Casper", "Chris", "Christiaan", "Cornelis", "Daan", "Daley", "Damian", "Dani", "Daniel", "Daniël", "David", "Dean", "Dirk", "Dylan", "Egbert", "Elijah", "Erik", "Erwin", "Evert", "Ezra", "Fabian", "Fedde", "Finn", "Florian", "Floris", "Frank", "Frans", "Frederik", "Freek", "Geert", "Gerard", "Gerben", "Gerrit", "Gijs", "Guus", "Hans", "Hendrik", "Henk", "Herman", "Hidde", "Hugo", "Jaap", "Jan Jaap", "Jan-Willem", "Jack", "Jacob", "Jan", "Jason", "Jasper", "Jayden", "Jelle", "Jelte", "Jens", "Jeroen", "Jesse", "Jim", "Job", "Joep", "Johannes", "John", "Jonathan", "Joris", "Joshua", "Joël", "Julian", "Kees", "Kevin", "Koen", "Lars", "Laurens", "Leendert", "Lennard", "Lodewijk", "Luc", "Luca", "Lucas", "Lukas", "Luuk", "Maarten", "Marcus", "Martijn", "Martin", "Matthijs", "Maurits", "Max", "Mees", "Melle", "Mick", "Mika", "Milan", "Mohamed", "Mohammed", "Morris", "Muhammed", "Nathan", "Nick", "Nico", "Niek", "Niels", "Noah", "Noud", "Olivier", "Oscar", "Owen", "Paul", "Pepijn", "Peter", "Pieter", "Pim", "Quinten", "Reinier", "Rens", "Robin", "Ruben", "Sam", "Samuel", "Sander", "Sebastiaan", "Sem", "Sep", "Sepp", "Siem", "Simon", "Stan", "Stef", "Steven", "Stijn", "Sven", "Teun", "Thijmen", "Thijs", "Thomas", "Tijn", "Tim", "Timo", "Tobias", "Tom", "Victor", "Vince", "Willem", "Wim", "Wouter", "Yusuf"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Aaron", "Abdon", "Abel", "Abélard", "Abelin", "Abondance", "Abraham", "Absalon", "Acace", "Achaire", "Achille", "Adalard", "Adalbald", "Adalbéron", "Adalbert", "Adalric", "Adam", "Adegrin", "Adel", "Adelin", "Andelin", "Adelphe", "Adam", "Adéodat", "Adhémar", "Adjutor", "Adolphe", "Adonis", "Adon", "Adrien", "Agapet", "Agathange", "Agathon", "Agilbert", "Agénor", "Agnan", "Aignan", "Agrippin", "Aimable", "Aimé", "Alain", "Alban", "Albin", "Aubin", "Albéric", "Albert", "Albertet", "Alcibiade", "Alcide", "Alcée", "Alcime", "Aldonce", "Aldric", "Aldéric", "Aleaume", "Alexandre", "Alexis", "Alix", "Alliaume", "Aleaume", "Almine", "Almire", "Aloïs", "Alphée", "Alphonse", "Alpinien", "Alverède", "Amalric", "Amaury", "Amandin", "Amant", "Ambroise", "Amédée", "Amélien", "Amiel", "Amour", "Anaël", "Anastase", "Anatole", "Ancelin", "Andéol", "Andoche", "André", "Andoche", "Ange", "Angelin", "Angilbe", "Anglebert", "Angoustan", "Anicet", "Anne", "Annibal", "Ansbert", "Anselme", "Anthelme", "Antheaume", "Anthime", "Antide", "Antoine", "Antonius", "Antonin", "Apollinaire", "Apollon", "Aquilin", "Arcade", "Archambaud", "Archambeau", "Archange", "Archibald", "Arian", "Ariel", "Ariste", "Aristide", "Armand", "Armel", "Armin", "Arnould", "Arnaud", "Arolde", "Arsène", "Arsinoé", "Arthaud", "Arthème", "Arthur", "Ascelin", "Athanase", "Aubry", "Audebert", "Audouin", "Audran", "Audric", "Auguste", "Augustin", "Aurèle", "Aurélien", "Aurian", "Auxence", "Axel", "Aymard", "Aymeric", "Aymon", "Aymond", "Balthazar", "Baptiste", "Barnabé", "Barthélemy", "Bartimée", "Basile", "Bastien", "Baudouin", "Bénigne", "Benjamin", "Benoît", "Bérenger", "Bérard", "Bernard", "Bertrand", "Blaise", "Bon", "Boniface", "Bouchard", "Brice", "Brieuc", "Bruno", "Brunon", "Calixte", "Calliste", "Camélien", "Camille", "Camillien", "Candide", "Caribert", "Carloman", "Cassandre", "Cassien", "Cédric", "Céleste", "Célestin", "Célien", "Césaire", "César", "Charles", "Charlemagne", "Childebert", "Chilpéric", "Chrétien", "Christian", "Christodule", "Christophe", "Chrysostome", "Clarence", "Claude", "Claudien", "Cléandre", "Clément", "Clotaire", "Côme", "Constance", "Constant", "Constantin", "Corentin", "Cyprien", "Cyriaque", "Cyrille", "Cyril", "Damien", "Daniel", "David", "Delphin", "Denis", "Désiré", "Didier", "Dieudonné", "Dimitri", "Dominique", "Dorian", "Dorothée", "Edgard", "Edmond", "Édouard", "Éleuthère", "Élie", "Élisée", "Émeric", "Émile", "Émilien", "Emmanuel", "Enguerrand", "Épiphane", "Éric", "Esprit", "Ernest", "Étienne", "Eubert", "Eudes", "Eudoxe", "Eugène", "Eusèbe", "Eustache", "Évariste", "Évrard", "Fabien", "Fabrice", "Falba", "Félicité", "Félix", "Ferdinand", "Fiacre", "Fidèle", "Firmin", "Flavien", "Flodoard", "Florent", "Florentin", "Florestan", "Florian", "Fortuné", "Foulques", "Francisque", "François", "Français", "Franciscus", "Francs", "Frédéric", "Fulbert", "Fulcran", "Fulgence", "Gabin", "Gabriel", "Gaël", "Garnier", "Gaston", "Gaspard", "Gatien", "Gaud", "Gautier", "Gédéon", "Geoffroy", "Georges", "Géraud", "Gérard", "Gerbert", "Germain", "Gervais", "Ghislain", "Gilbert", "Gilles", "Girart", "Gislebert", "Gondebaud", "Gonthier", "Gontran", "Gonzague", "Grégoire", "Guérin", "Gui", "Guillaume", "Gustave", "Guy", "Guyot", "Hardouin", "Hector", "Hédelin", "Hélier", "Henri", "Herbert", "Herluin", "Hervé", "Hilaire", "Hildebert", "Hincmar", "Hippolyte", "Honoré", "Hubert", "Hugues", "Innocent", "Isabeau", "Isidore", "Jacques", "Japhet", "Jason", "Jean", "Jeannel", "Jeannot", "Jérémie", "Jérôme", "Joachim", "Joanny", "Job", "Jocelyn", "Joël", "Johan", "Jonas", "Jonathan", "Joseph", "Josse", "Josselin", "Jourdain", "Jude", "Judicaël", "Jules", "Julien", "Juste", "Justin", "Lambert", "Landry", "Laurent", "Lazare", "Léandre", "Léon", "Léonard", "Léopold", "Leu", "Loup", "Leufroy", "Libère", "Liétald", "Lionel", "Loïc", "Longin", "Lorrain", "Lorraine", "Lothaire", "Louis", "Loup", "Luc", "Lucas", "Lucien", "Ludolphe", "Ludovic", "Macaire", "Malo", "Mamert", "Manassé", "Marc", "Marceau", "Marcel", "Marcelin", "Marius", "Marseille", "Martial", "Martin", "Mathurin", "Matthias", "Mathias", "Matthieu", "Maugis", "Maurice", "Mauricet", "Maxence", "Maxime", "Maximilien", "Mayeul", "Médéric", "Melchior", "Mence", "Merlin", "Mérovée", "Michaël", "Michel", "Moïse", "Morgan", "Nathan", "Nathanaël", "Narcisse", "Néhémie", "Nestor", "Nestor", "Nicéphore", "Nicolas", "Noé", "Noël", "Norbert", "Normand", "Normands", "Octave", "Odilon", "Odon", "Oger", "Olivier", "Oury", "Pacôme", "Palémon", "Parfait", "Pascal", "Paterne", "Patrice", "Paul", "Pépin", "Perceval", "Philémon", "Philibert", "Philippe", "Philothée", "Pie", "Pierre", "Pierrick", "Prosper", "Quentin", "Raoul", "Raphaël", "Raymond", "Régis", "Réjean", "Rémi", "Renaud", "René", "Reybaud", "Richard", "Robert", "Roch", "Rodolphe", "Rodrigue", "Roger", "Roland", "Romain", "Romuald", "Roméo", "Rome", "Ronan", "Roselin", "Salomon", "Samuel", "Savin", "Savinien", "Scholastique", "Sébastien", "Séraphin", "Serge", "Séverin", "Sidoine", "Sigebert", "Sigismond", "Silvère", "Simon", "Siméon", "Sixte", "Stanislas", "Stéphane", "Stephan", "Sylvain", "Sylvestre", "Tancrède", "Tanguy", "Taurin", "Théodore", "Théodose", "Théophile", "Théophraste", "Thibault", "Thibert", "Thierry", "Thomas", "Timoléon", "Timothée", "Titien", "Tonnin", "Toussaint", "Trajan", "Tristan", "Turold", "Tim", "Ulysse", "Urbain", "Valentin", "Valère", "Valéry", "Venance", "Venant", "Venceslas", "Vianney", "Victor", "Victorien", "Victorin", "Vigile", "Vincent", "Vital", "Vitalien", "Vivien", "Waleran", "Wandrille", "Xavier", "Xénophon", "Yves", "Zacharie", "Zaché", "Zéphirin"]
          },
          female: {
            en: ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
            it: ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Lea", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Ada", "Arianne", "Afke", "Amanda", "Amber", "Amy", "Aniek", "Anita", "Anja", "Anna", "Anne", "Annelies", "Annemarie", "Annette", "Anouk", "Astrid", "Aukje", "Barbara", "Bianca", "Carla", "Carlijn", "Carolien", "Chantal", "Charlotte", "Claudia", "Daniëlle", "Debora", "Diane", "Dora", "Eline", "Elise", "Ella", "Ellen", "Emma", "Esmee", "Evelien", "Esther", "Erica", "Eva", "Femke", "Fleur", "Floor", "Froukje", "Gea", "Gerda", "Hanna", "Hanneke", "Heleen", "Hilde", "Ilona", "Ina", "Inge", "Ingrid", "Iris", "Isabel", "Isabelle", "Janneke", "Jasmijn", "Jeanine", "Jennifer", "Jessica", "Johanna", "Joke", "Julia", "Julie", "Karen", "Karin", "Katja", "Kim", "Lara", "Laura", "Lena", "Lianne", "Lieke", "Lilian", "Linda", "Lisa", "Lisanne", "Lotte", "Louise", "Maaike", "Manon", "Marga", "Maria", "Marissa", "Marit", "Marjolein", "Martine", "Marleen", "Melissa", "Merel", "Miranda", "Michelle", "Mirjam", "Mirthe", "Naomi", "Natalie", "Nienke", "Nina", "Noortje", "Olivia", "Patricia", "Paula", "Paulien", "Ramona", "Ria", "Rianne", "Roos", "Rosanne", "Ruth", "Sabrina", "Sandra", "Sanne", "Sara", "Saskia", "Silvia", "Sofia", "Sophie", "Sonja", "Suzanne", "Tamara", "Tess", "Tessa", "Tineke", "Valerie", "Vanessa", "Veerle", "Vera", "Victoria", "Wendy", "Willeke", "Yvonne", "Zoë"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Abdon", "Abel", "Abigaëlle", "Abigaïl", "Acacius", "Acanthe", "Adalbert", "Adalsinde", "Adegrine", "Adélaïde", "Adèle", "Adélie", "Adeline", "Adeltrude", "Adolphe", "Adonis", "Adrastée", "Adrehilde", "Adrienne", "Agathe", "Agilbert", "Aglaé", "Aignan", "Agneflète", "Agnès", "Agrippine", "Aimé", "Alaine", "Alaïs", "Albane", "Albérade", "Alberte", "Alcide", "Alcine", "Alcyone", "Aldegonde", "Aleth", "Alexandrine", "Alexine", "Alice", "Aliénor", "Aliette", "Aline", "Alix", "Alizé", "Aloïse", "Aloyse", "Alphonsine", "Althée", "Amaliane", "Amalthée", "Amande", "Amandine", "Amant", "Amarande", "Amaranthe", "Amaryllis", "Ambre", "Ambroisie", "Amélie", "Améthyste", "Aminte", "Anaël", "Anaïs", "Anastasie", "Anatole", "Ancelin", "Andrée", "Anémone", "Angadrême", "Angèle", "Angeline", "Angélique", "Angilbert", "Anicet", "Annabelle", "Anne", "Annette", "Annick", "Annie", "Annonciade", "Ansbert", "Anstrudie", "Anthelme", "Antigone", "Antoinette", "Antonine", "Aphélie", "Apolline", "Apollonie", "Aquiline", "Arabelle", "Arcadie", "Archange", "Argine", "Ariane", "Aricie", "Ariel", "Arielle", "Arlette", "Armance", "Armande", "Armandine", "Armelle", "Armide", "Armelle", "Armin", "Arnaud", "Arsène", "Arsinoé", "Artémis", "Arthur", "Ascelin", "Ascension", "Assomption", "Astarté", "Astérie", "Astrée", "Astrid", "Athalie", "Athanasie", "Athina", "Aube", "Albert", "Aude", "Audrey", "Augustine", "Aure", "Aurélie", "Aurélien", "Aurèle", "Aurore", "Auxence", "Aveline", "Abigaëlle", "Avoye", "Axelle", "Aymard", "Azalée", "Adèle", "Adeline", "Barbe", "Basilisse", "Bathilde", "Béatrice", "Béatrix", "Bénédicte", "Bérengère", "Bernadette", "Berthe", "Bertille", "Beuve", "Blanche", "Blanc", "Blandine", "Brigitte", "Brune", "Brunehilde", "Callista", "Camille", "Capucine", "Carine", "Caroline", "Cassandre", "Catherine", "Cécile", "Céleste", "Célestine", "Céline", "Chantal", "Charlène", "Charline", "Charlotte", "Chloé", "Christelle", "Christiane", "Christine", "Claire", "Clara", "Claude", "Claudine", "Clarisse", "Clémence", "Clémentine", "Cléo", "Clio", "Clotilde", "Coline", "Conception", "Constance", "Coralie", "Coraline", "Corentine", "Corinne", "Cyrielle", "Daniel", "Daniel", "Daphné", "Débora", "Delphine", "Denise", "Diane", "Dieudonné", "Dominique", "Doriane", "Dorothée", "Douce", "Édith", "Edmée", "Éléonore", "Éliane", "Élia", "Éliette", "Élisabeth", "Élise", "Ella", "Élodie", "Éloïse", "Elsa", "Émeline", "Émérance", "Émérentienne", "Émérencie", "Émilie", "Emma", "Emmanuelle", "Emmelie", "Ernestine", "Esther", "Estelle", "Eudoxie", "Eugénie", "Eulalie", "Euphrasie", "Eusébie", "Évangéline", "Eva", "Ève", "Évelyne", "Fanny", "Fantine", "Faustine", "Félicie", "Fernande", "Flavie", "Fleur", "Flore", "Florence", "Florie", "Fortuné", "France", "Francia", "Françoise", "Francine", "Gabrielle", "Gaëlle", "Garance", "Geneviève", "Georgette", "Gerberge", "Germaine", "Gertrude", "Gisèle", "Guenièvre", "Guilhemine", "Guillemette", "Gustave", "Gwenael", "Hélène", "Héloïse", "Henriette", "Hermine", "Hermione", "Hippolyte", "Honorine", "Hortense", "Huguette", "Ines", "Irène", "Irina", "Iris", "Isabeau", "Isabelle", "Iseult", "Isolde", "Ismérie", "Jacinthe", "Jacqueline", "Jade", "Janine", "Jeanne", "Jocelyne", "Joëlle", "Joséphine", "Judith", "Julia", "Julie", "Jules", "Juliette", "Justine", "Katy", "Kathy", "Katie", "Laura", "Laure", "Laureline", "Laurence", "Laurene", "Lauriane", "Laurianne", "Laurine", "Léa", "Léna", "Léonie", "Léon", "Léontine", "Lorraine", "Lucie", "Lucienne", "Lucille", "Ludivine", "Lydie", "Lydie", "Megane", "Madeleine", "Magali", "Maguelone", "Mallaury", "Manon", "Marceline", "Margot", "Marguerite", "Marianne", "Marie", "Myriam", "Marie", "Marine", "Marion", "Marlène", "Marthe", "Martine", "Mathilde", "Maud", "Maureen", "Mauricette", "Maxime", "Mélanie", "Melissa", "Mélissandre", "Mélisande", "Mélodie", "Michel", "Micheline", "Mireille", "Miriam", "Moïse", "Monique", "Morgane", "Muriel", "Mylène", "Nadège", "Nadine", "Nathalie", "Nicole", "Nicolette", "Nine", "Noël", "Noémie", "Océane", "Odette", "Odile", "Olive", "Olivia", "Olympe", "Ombline", "Ombeline", "Ophélie", "Oriande", "Oriane", "Ozanne", "Pascale", "Pascaline", "Paule", "Paulette", "Pauline", "Priscille", "Prisca", "Prisque", "Pécine", "Pélagie", "Pénélope", "Perrine", "Pétronille", "Philippine", "Philomène", "Philothée", "Primerose", "Prudence", "Pulchérie", "Quentine", "Quiéta", "Quintia", "Quintilla", "Rachel", "Raphaëlle", "Raymonde", "Rebecca", "Régine", "Réjeanne", "René", "Rita", "Rita", "Rolande", "Romane", "Rosalie", "Rose", "Roseline", "Sabine", "Salomé", "Sandra", "Sandrine", "Sarah", "Ségolène", "Séverine", "Sibylle", "Simone", "Sixt", "Solange", "Soline", "Solène", "Sophie", "Stéphanie", "Suzanne", "Sylvain", "Sylvie", "Tatiana", "Thaïs", "Théodora", "Thérèse", "Tiphaine", "Ursule", "Valentine", "Valérie", "Véronique", "Victoire", "Victorine", "Vinciane", "Violette", "Virginie", "Viviane", "Xavière", "Yolande", "Ysaline", "Yvette", "Yvonne", "Zélie", "Zita", "Zoé"]
          }
        },
        lastNames: {
          en: ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes", "Myers", "Ford", "Hamilton", "Graham", "Sullivan", "Wallace", "Woods", "Cole", "West", "Jordan", "Owens", "Reynolds", "Fisher", "Ellis", "Harrison", "Gibson", "McDonald", "Cruz", "Marshall", "Ortiz", "Gomez", "Murray", "Freeman", "Wells", "Webb", "Simpson", "Stevens", "Tucker", "Porter", "Hunter", "Hicks", "Crawford", "Henry", "Boyd", "Mason", "Morales", "Kennedy", "Warren", "Dixon", "Ramos", "Reyes", "Burns", "Gordon", "Shaw", "Holmes", "Rice", "Robertson", "Hunt", "Black", "Daniels", "Palmer", "Mills", "Nichols", "Grant", "Knight", "Ferguson", "Rose", "Stone", "Hawkins", "Dunn", "Perkins", "Hudson", "Spencer", "Gardner", "Stephens", "Payne", "Pierce", "Berry", "Matthews", "Arnold", "Wagner", "Willis", "Ray", "Watkins", "Olson", "Carroll", "Duncan", "Snyder", "Hart", "Cunningham", "Bradley", "Lane", "Andrews", "Ruiz", "Harper", "Fox", "Riley", "Armstrong", "Carpenter", "Weaver", "Greene", "Lawrence", "Elliott", "Chavez", "Sims", "Austin", "Peters", "Kelley", "Franklin", "Lawson", "Fields", "Gutierrez", "Ryan", "Schmidt", "Carr", "Vasquez", "Castillo", "Wheeler", "Chapman", "Oliver", "Montgomery", "Richards", "Williamson", "Johnston", "Banks", "Meyer", "Bishop", "McCoy", "Howell", "Alvarez", "Morrison", "Hansen", "Fernandez", "Garza", "Harvey", "Little", "Burton", "Stanley", "Nguyen", "George", "Jacobs", "Reid", "Kim", "Fuller", "Lynch", "Dean", "Gilbert", "Garrett", "Romero", "Welch", "Larson", "Frazier", "Burke", "Hanson", "Day", "Mendoza", "Moreno", "Bowman", "Medina", "Fowler", "Brewer", "Hoffman", "Carlson", "Silva", "Pearson", "Holland", "Douglas", "Fleming", "Jensen", "Vargas", "Byrd", "Davidson", "Hopkins", "May", "Terry", "Herrera", "Wade", "Soto", "Walters", "Curtis", "Neal", "Caldwell", "Lowe", "Jennings", "Barnett", "Graves", "Jimenez", "Horton", "Shelton", "Barrett", "Obrien", "Castro", "Sutton", "Gregory", "McKinney", "Lucas", "Miles", "Craig", "Rodriquez", "Chambers", "Holt", "Lambert", "Fletcher", "Watts", "Bates", "Hale", "Rhodes", "Pena", "Beck", "Newman", "Haynes", "McDaniel", "Mendez", "Bush", "Vaughn", "Parks", "Dawson", "Santiago", "Norris", "Hardy", "Love", "Steele", "Curry", "Powers", "Schultz", "Barker", "Guzman", "Page", "Munoz", "Ball", "Keller", "Chandler", "Weber", "Leonard", "Walsh", "Lyons", "Ramsey", "Wolfe", "Schneider", "Mullins", "Benson", "Sharp", "Bowen", "Daniel", "Barber", "Cummings", "Hines", "Baldwin", "Griffith", "Valdez", "Hubbard", "Salazar", "Reeves", "Warner", "Stevenson", "Burgess", "Santos", "Tate", "Cross", "Garner", "Mann", "Mack", "Moss", "Thornton", "Dennis", "McGee", "Farmer", "Delgado", "Aguilar", "Vega", "Glover", "Manning", "Cohen", "Harmon", "Rodgers", "Robbins", "Newton", "Todd", "Blair", "Higgins", "Ingram", "Reese", "Cannon", "Strickland", "Townsend", "Potter", "Goodwin", "Walton", "Rowe", "Hampton", "Ortega", "Patton", "Swanson", "Joseph", "Francis", "Goodman", "Maldonado", "Yates", "Becker", "Erickson", "Hodges", "Rios", "Conner", "Adkins", "Webster", "Norman", "Malone", "Hammond", "Flowers", "Cobb", "Moody", "Quinn", "Blake", "Maxwell", "Pope", "Floyd", "Osborne", "Paul", "McCarthy", "Guerrero", "Lindsey", "Estrada", "Sandoval", "Gibbs", "Tyler", "Gross", "Fitzgerald", "Stokes", "Doyle", "Sherman", "Saunders", "Wise", "Colon", "Gill", "Alvarado", "Greer", "Padilla", "Simon", "Waters", "Nunez", "Ballard", "Schwartz", "McBride", "Houston", "Christensen", "Klein", "Pratt", "Briggs", "Parsons", "McLaughlin", "Zimmerman", "French", "Buchanan", "Moran", "Copeland", "Roy", "Pittman", "Brady", "McCormick", "Holloway", "Brock", "Poole", "Frank", "Logan", "Owen", "Bass", "Marsh", "Drake", "Wong", "Jefferson", "Park", "Morton", "Abbott", "Sparks", "Patrick", "Norton", "Huff", "Clayton", "Massey", "Lloyd", "Figueroa", "Carson", "Bowers", "Roberson", "Barton", "Tran", "Lamb", "Harrington", "Casey", "Boone", "Cortez", "Clarke", "Mathis", "Singleton", "Wilkins", "Cain", "Bryan", "Underwood", "Hogan", "McKenzie", "Collier", "Luna", "Phelps", "McGuire", "Allison", "Bridges", "Wilkerson", "Nash", "Summers", "Atkins"],
          // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
          it: ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"],
          // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
          nl: ["Albers", "Alblas", "Appelman", "Baars", "Baas", "Bakker", "Blank", "Bleeker", "Blok", "Blom", "Boer", "Boers", "Boldewijn", "Boon", "Boot", "Bos", "Bosch", "Bosma", "Bosman", "Bouma", "Bouman", "Bouwman", "Brands", "Brouwer", "Burger", "Buijs", "Buitenhuis", "Ceder", "Cohen", "Dekker", "Dekkers", "Dijkman", "Dijkstra", "Driessen", "Drost", "Engel", "Evers", "Faber", "Franke", "Gerritsen", "Goedhart", "Goossens", "Groen", "Groenenberg", "Groot", "Haan", "Hart", "Heemskerk", "Hendriks", "Hermans", "Hoekstra", "Hofman", "Hopman", "Huisman", "Jacobs", "Jansen", "Janssen", "Jonker", "Jaspers", "Keijzer", "Klaassen", "Klein", "Koek", "Koenders", "Kok", "Kool", "Koopman", "Koopmans", "Koning", "Koster", "Kramer", "Kroon", "Kuijpers", "Kuiper", "Kuipers", "Kurt", "Koster", "Kwakman", "Los", "Lubbers", "Maas", "Markus", "Martens", "Meijer", "Mol", "Molenaar", "Mulder", "Nieuwenhuis", "Peeters", "Peters", "Pengel", "Pieters", "Pool", "Post", "Postma", "Prins", "Pronk", "Reijnders", "Rietveld", "Roest", "Roos", "Sanders", "Schaap", "Scheffer", "Schenk", "Schilder", "Schipper", "Schmidt", "Scholten", "Schouten", "Schut", "Schutte", "Schuurman", "Simons", "Smeets", "Smit", "Smits", "Snel", "Swinkels", "Tas", "Terpstra", "Timmermans", "Tol", "Tromp", "Troost", "Valk", "Veenstra", "Veldkamp", "Verbeek", "Verheul", "Verhoeven", "Vermeer", "Vermeulen", "Verweij", "Vink", "Visser", "Voorn", "Vos", "Wagenaar", "Wiersema", "Willems", "Willemsen", "Witteveen", "Wolff", "Wolters", "Zijlstra", "Zwart", "de Beer", "de Boer", "de Bruijn", "de Bruin", "de Graaf", "de Groot", "de Haan", "de Haas", "de Jager", "de Jong", "de Jonge", "de Koning", "de Lange", "de Leeuw", "de Ridder", "de Rooij", "de Ruiter", "de Vos", "de Vries", "de Waal", "de Wit", "de Zwart", "van Beek", "van Boven", "van Dam", "van Dijk", "van Dongen", "van Doorn", "van Egmond", "van Eijk", "van Es", "van Gelder", "van Gelderen", "van Houten", "van Hulst", "van Kempen", "van Kesteren", "van Leeuwen", "van Loon", "van Mill", "van Noord", "van Ommen", "van Ommeren", "van Oosten", "van Oostveen", "van Rijn", "van Schaik", "van Veen", "van Vliet", "van Wijk", "van Wijngaarden", "van den Poel", "van de Pol", "van den Ploeg", "van de Ven", "van den Berg", "van den Bosch", "van den Brink", "van den Broek", "van den Heuvel", "van der Heijden", "van der Horst", "van der Hulst", "van der Kroon", "van der Laan", "van der Linden", "van der Meer", "van der Meij", "van der Meulen", "van der Molen", "van der Sluis", "van der Spek", "van der Veen", "van der Velde", "van der Velden", "van der Vliet", "van der Wal"],
          // https://surnames.behindthename.com/top/lists/england-wales/1991
          uk: ["Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans", "Wilson", "Thomas", "Johnson", "Roberts", "Robinson", "Thompson", "Wright", "Walker", "White", "Edwards", "Hughes", "Green", "Hall", "Lewis", "Harris", "Clarke", "Patel", "Jackson", "Wood", "Turner", "Martin", "Cooper", "Hill", "Ward", "Morris", "Moore", "Clark", "Lee", "King", "Baker", "Harrison", "Morgan", "Allen", "James", "Scott", "Phillips", "Watson", "Davis", "Parker", "Price", "Bennett", "Young", "Griffiths", "Mitchell", "Kelly", "Cook", "Carter", "Richardson", "Bailey", "Collins", "Bell", "Shaw", "Murphy", "Miller", "Cox", "Richards", "Khan", "Marshall", "Anderson", "Simpson", "Ellis", "Adams", "Singh", "Begum", "Wilkinson", "Foster", "Chapman", "Powell", "Webb", "Rogers", "Gray", "Mason", "Ali", "Hunt", "Hussain", "Campbell", "Matthews", "Owen", "Palmer", "Holmes", "Mills", "Barnes", "Knight", "Lloyd", "Butler", "Russell", "Barker", "Fisher", "Stevens", "Jenkins", "Murray", "Dixon", "Harvey", "Graham", "Pearson", "Ahmed", "Fletcher", "Walsh", "Kaur", "Gibson", "Howard", "Andrews", "Stewart", "Elliott", "Reynolds", "Saunders", "Payne", "Fox", "Ford", "Pearce", "Day", "Brooks", "West", "Lawrence", "Cole", "Atkinson", "Bradley", "Spencer", "Gill", "Dawson", "Ball", "Burton", "O'brien", "Watts", "Rose", "Booth", "Perry", "Ryan", "Grant", "Wells", "Armstrong", "Francis", "Rees", "Hayes", "Hart", "Hudson", "Newman", "Barrett", "Webster", "Hunter", "Gregory", "Carr", "Lowe", "Page", "Marsh", "Riley", "Dunn", "Woods", "Parsons", "Berry", "Stone", "Reid", "Holland", "Hawkins", "Harding", "Porter", "Robertson", "Newton", "Oliver", "Reed", "Kennedy", "Williamson", "Bird", "Gardner", "Shah", "Dean", "Lane", "Cooke", "Bates", "Henderson", "Parry", "Burgess", "Bishop", "Walton", "Burns", "Nicholson", "Shepherd", "Ross", "Cross", "Long", "Freeman", "Warren", "Nicholls", "Hamilton", "Byrne", "Sutton", "Mcdonald", "Yates", "Hodgson", "Robson", "Curtis", "Hopkins", "O'connor", "Harper", "Coleman", "Watkins", "Moss", "Mccarthy", "Chambers", "O'neill", "Griffin", "Sharp", "Hardy", "Wheeler", "Potter", "Osborne", "Johnston", "Gordon", "Doyle", "Wallace", "George", "Jordan", "Hutchinson", "Rowe", "Burke", "May", "Pritchard", "Gilbert", "Willis", "Higgins", "Read", "Miles", "Stevenson", "Stephenson", "Hammond", "Arnold", "Buckley", "Walters", "Hewitt", "Barber", "Nelson", "Slater", "Austin", "Sullivan", "Whitehead", "Mann", "Frost", "Lambert", "Stephens", "Blake", "Akhtar", "Lynch", "Goodwin", "Barton", "Woodward", "Thomson", "Cunningham", "Quinn", "Barnett", "Baxter", "Bibi", "Clayton", "Nash", "Greenwood", "Jennings", "Holt", "Kemp", "Poole", "Gallagher", "Bond", "Stokes", "Tucker", "Davidson", "Fowler", "Heath", "Norman", "Middleton", "Lawson", "Banks", "French", "Stanley", "Jarvis", "Gibbs", "Ferguson", "Hayward", "Carroll", "Douglas", "Dickinson", "Todd", "Barlow", "Peters", "Lucas", "Knowles", "Hartley", "Miah", "Simmons", "Morton", "Alexander", "Field", "Morrison", "Norris", "Townsend", "Preston", "Hancock", "Thornton", "Baldwin", "Burrows", "Briggs", "Parkinson", "Reeves", "Macdonald", "Lamb", "Black", "Abbott", "Sanders", "Thorpe", "Holden", "Tomlinson", "Perkins", "Ashton", "Rhodes", "Fuller", "Howe", "Bryant", "Vaughan", "Dale", "Davey", "Weston", "Bartlett", "Whittaker", "Davison", "Kent", "Skinner", "Birch", "Morley", "Daniels", "Glover", "Howell", "Cartwright", "Pugh", "Humphreys", "Goddard", "Brennan", "Wall", "Kirby", "Bowen", "Savage", "Bull", "Wong", "Dobson", "Smart", "Wilkins", "Kirk", "Fraser", "Duffy", "Hicks", "Patterson", "Bradshaw", "Little", "Archer", "Warner", "Waters", "O'sullivan", "Farrell", "Brookes", "Atkins", "Kay", "Dodd", "Bentley", "Flynn", "John", "Schofield", "Short", "Haynes", "Wade", "Butcher", "Henry", "Sanderson", "Crawford", "Sheppard", "Bolton", "Coates", "Giles", "Gould", "Houghton", "Gibbons", "Pratt", "Manning", "Law", "Hooper", "Noble", "Dyer", "Rahman", "Clements", "Moran", "Sykes", "Chan", "Doherty", "Connolly", "Joyce", "Franklin", "Hobbs", "Coles", "Herbert", "Steele", "Kerr", "Leach", "Winter", "Owens", "Duncan", "Naylor", "Fleming", "Horton", "Finch", "Fitzgerald", "Randall", "Carpenter", "Marsden", "Browne", "Garner", "Pickering", "Hale", "Dennis", "Vincent", "Chadwick", "Chandler", "Sharpe", "Nolan", "Lyons", "Hurst", "Collier", "Peacock", "Howarth", "Faulkner", "Rice", "Pollard", "Welch", "Norton", "Gough", "Sinclair", "Blackburn", "Bryan", "Conway", "Power", "Cameron", "Daly", "Allan", "Hanson", "Gardiner", "Boyle", "Myers", "Turnbull", "Wallis", "Mahmood", "Sims", "Swift", "Iqbal", "Pope", "Brady", "Chamberlain", "Rowley", "Tyler", "Farmer", "Metcalfe", "Hilton", "Godfrey", "Holloway", "Parkin", "Bray", "Talbot", "Donnelly", "Nixon", "Charlton", "Benson", "Whitehouse", "Barry", "Hope", "Lord", "North", "Storey", "Connor", "Potts", "Bevan", "Hargreaves", "Mclean", "Mistry", "Bruce", "Howells", "Hyde", "Parkes", "Wyatt", "Fry", "Lees", "O'donnell", "Craig", "Forster", "Mckenzie", "Humphries", "Mellor", "Carey", "Ingram", "Summers", "Leonard"],
          // https://surnames.behindthename.com/top/lists/germany/2017
          de: ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann", "Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", "Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler", "Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Pfeiffer"],
          // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
          jp: ["Sato", "Suzuki", "Takahashi", "Tanaka", "Watanabe", "Ito", "Yamamoto", "Nakamura", "Kobayashi", "Kato", "Yoshida", "Yamada", "Sasaki", "Yamaguchi", "Saito", "Matsumoto", "Inoue", "Kimura", "Hayashi", "Shimizu", "Yamazaki", "Mori", "Abe", "Ikeda", "Hashimoto", "Yamashita", "Ishikawa", "Nakajima", "Maeda", "Fujita", "Ogawa", "Goto", "Okada", "Hasegawa", "Murakami", "Kondo", "Ishii", "Saito", "Sakamoto", "Endo", "Aoki", "Fujii", "Nishimura", "Fukuda", "Ota", "Miura", "Fujiwara", "Okamoto", "Matsuda", "Nakagawa", "Nakano", "Harada", "Ono", "Tamura", "Takeuchi", "Kaneko", "Wada", "Nakayama", "Ishida", "Ueda", "Morita", "Hara", "Shibata", "Sakai", "Kudo", "Yokoyama", "Miyazaki", "Miyamoto", "Uchida", "Takagi", "Ando", "Taniguchi", "Ohno", "Maruyama", "Imai", "Takada", "Fujimoto", "Takeda", "Murata", "Ueno", "Sugiyama", "Masuda", "Sugawara", "Hirano", "Kojima", "Otsuka", "Chiba", "Kubo", "Matsui", "Iwasaki", "Sakurai", "Kinoshita", "Noguchi", "Matsuo", "Nomura", "Kikuchi", "Sano", "Onishi", "Sugimoto", "Arai"],
          // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
          es: ["Garcia", "Fernandez", "Lopez", "Martinez", "Gonzalez", "Rodriguez", "Sanchez", "Perez", "Martin", "Gomez", "Ruiz", "Diaz", "Hernandez", "Alvarez", "Jimenez", "Moreno", "Munoz", "Alonso", "Romero", "Navarro", "Gutierrez", "Torres", "Dominguez", "Gil", "Vazquez", "Blanco", "Serrano", "Ramos", "Castro", "Suarez", "Sanz", "Rubio", "Ortega", "Molina", "Delgado", "Ortiz", "Morales", "Ramirez", "Marin", "Iglesias", "Santos", "Castillo", "Garrido", "Calvo", "Pena", "Cruz", "Cano", "Nunez", "Prieto", "Diez", "Lozano", "Vidal", "Pascual", "Ferrer", "Medina", "Vega", "Leon", "Herrero", "Vicente", "Mendez", "Guerrero", "Fuentes", "Campos", "Nieto", "Cortes", "Caballero", "Ibanez", "Lorenzo", "Pastor", "Gimenez", "Saez", "Soler", "Marquez", "Carrasco", "Herrera", "Montero", "Arias", "Crespo", "Flores", "Andres", "Aguilar", "Hidalgo", "Cabrera", "Mora", "Duran", "Velasco", "Rey", "Pardo", "Roman", "Vila", "Bravo", "Merino", "Moya", "Soto", "Izquierdo", "Reyes", "Redondo", "Marcos", "Carmona", "Menendez"],
          // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
          fr: ["Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefèvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard", "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Müller", "Lefèvre", "Faure", "André", "Mercier", "Blanc", "Guérin", "Boyer", "Garnier", "Chevalier", "François", "Legrand", "Gauthier", "Garcia", "Perrin", "Robin", "Clément", "Morin", "Nicolas", "Henry", "Roussel", "Matthieu", "Gautier", "Masson", "Marchand", "Duval", "Denis", "Dumont", "Marie", "Lemaire", "Noël", "Meyer", "Dufour", "Meunier", "Brun", "Blanchard", "Giraud", "Joly", "Rivière", "Lucas", "Brunet", "Gaillard", "Barbier", "Arnaud", "Martínez", "Gérard", "Roche", "Renard", "Schmitt", "Roy", "Leroux", "Colin", "Vidal", "Caron", "Picard", "Roger", "Fabre", "Aubert", "Lemoine", "Renaud", "Dumas", "Lacroix", "Olivier", "Philippe", "Bourgeois", "Pierre", "Benoît", "Rey", "Leclerc", "Payet", "Rolland", "Leclercq", "Guillaume", "Lecomte", "López", "Jean", "Dupuy", "Guillot", "Hubert", "Berger", "Carpentier", "Sánchez", "Dupuis", "Moulin", "Louis", "Deschamps", "Huet", "Vasseur", "Perez", "Boucher", "Fleury", "Royer", "Klein", "Jacquet", "Adam", "Paris", "Poirier", "Marty", "Aubry", "Guyot", "Carré", "Charles", "Renault", "Charpentier", "Ménard", "Maillard", "Baron", "Bertin", "Bailly", "Hervé", "Schneider", "Fernández", "Le GallGall", "Collet", "Léger", "Bouvier", "Julien", "Prévost", "Millet", "Perrot", "Daniel", "Le RouxRoux", "Cousin", "Germain", "Breton", "Besson", "Langlois", "Rémi", "Le GoffGoff", "Pelletier", "Lévêque", "Perrier", "Leblanc", "Barré", "Lebrun", "Marchal", "Weber", "Mallet", "Hamon", "Boulanger", "Jacob", "Monnier", "Michaud", "Rodríguez", "Guichard", "Gillet", "Étienne", "Grondin", "Poulain", "Tessier", "Chevallier", "Collin", "Chauvin", "Da SilvaSilva", "Bouchet", "Gay", "Lemaître", "Bénard", "Maréchal", "Humbert", "Reynaud", "Antoine", "Hoarau", "Perret", "Barthélemy", "Cordier", "Pichon", "Lejeune", "Gilbert", "Lamy", "Delaunay", "Pasquier", "Carlier", "LaporteLaporte"]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [{ code: "AB" }, { code: "AL" }, { code: "B" }, { code: "BA" }, { code: "BB" }, { code: "BD" }, { code: "BH" }, { code: "BL" }, { code: "BN" }, { code: "BR" }, { code: "BS" }, { code: "BT" }, { code: "CA" }, { code: "CB" }, { code: "CF" }, { code: "CH" }, { code: "CM" }, { code: "CO" }, { code: "CR" }, { code: "CT" }, { code: "CV" }, { code: "CW" }, { code: "DA" }, { code: "DD" }, { code: "DE" }, { code: "DG" }, { code: "DH" }, { code: "DL" }, { code: "DN" }, { code: "DT" }, { code: "DY" }, { code: "E" }, { code: "EC" }, { code: "EH" }, { code: "EN" }, { code: "EX" }, { code: "FK" }, { code: "FY" }, { code: "G" }, { code: "GL" }, { code: "GU" }, { code: "GY" }, { code: "HA" }, { code: "HD" }, { code: "HG" }, { code: "HP" }, { code: "HR" }, { code: "HS" }, { code: "HU" }, { code: "HX" }, { code: "IG" }, { code: "IM" }, { code: "IP" }, { code: "IV" }, { code: "JE" }, { code: "KA" }, { code: "KT" }, { code: "KW" }, { code: "KY" }, { code: "L" }, { code: "LA" }, { code: "LD" }, { code: "LE" }, { code: "LL" }, { code: "LN" }, { code: "LS" }, { code: "LU" }, { code: "M" }, { code: "ME" }, { code: "MK" }, { code: "ML" }, { code: "N" }, { code: "NE" }, { code: "NG" }, { code: "NN" }, { code: "NP" }, { code: "NR" }, { code: "NW" }, { code: "OL" }, { code: "OX" }, { code: "PA" }, { code: "PE" }, { code: "PH" }, { code: "PL" }, { code: "PO" }, { code: "PR" }, { code: "RG" }, { code: "RH" }, { code: "RM" }, { code: "S" }, { code: "SA" }, { code: "SE" }, { code: "SG" }, { code: "SK" }, { code: "SL" }, { code: "SM" }, { code: "SN" }, { code: "SO" }, { code: "SP" }, { code: "SR" }, { code: "SS" }, { code: "ST" }, { code: "SW" }, { code: "SY" }, { code: "TA" }, { code: "TD" }, { code: "TF" }, { code: "TN" }, { code: "TQ" }, { code: "TR" }, { code: "TS" }, { code: "TW" }, { code: "UB" }, { code: "W" }, { code: "WA" }, { code: "WC" }, { code: "WD" }, { code: "WF" }, { code: "WN" }, { code: "WR" }, { code: "WS" }, { code: "WV" }, { code: "YO" }, { code: "ZE" }],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [{ name: "Afghanistan", abbreviation: "AF" }, { name: "Åland Islands", abbreviation: "AX" }, { name: "Albania", abbreviation: "AL" }, { name: "Algeria", abbreviation: "DZ" }, { name: "American Samoa", abbreviation: "AS" }, { name: "Andorra", abbreviation: "AD" }, { name: "Angola", abbreviation: "AO" }, { name: "Anguilla", abbreviation: "AI" }, { name: "Antarctica", abbreviation: "AQ" }, { name: "Antigua and Barbuda", abbreviation: "AG" }, { name: "Argentina", abbreviation: "AR" }, { name: "Armenia", abbreviation: "AM" }, { name: "Aruba", abbreviation: "AW" }, { name: "Australia", abbreviation: "AU" }, { name: "Austria", abbreviation: "AT" }, { name: "Azerbaijan", abbreviation: "AZ" }, { name: "Bahamas", abbreviation: "BS" }, { name: "Bahrain", abbreviation: "BH" }, { name: "Bangladesh", abbreviation: "BD" }, { name: "Barbados", abbreviation: "BB" }, { name: "Belarus", abbreviation: "BY" }, { name: "Belgium", abbreviation: "BE" }, { name: "Belize", abbreviation: "BZ" }, { name: "Benin", abbreviation: "BJ" }, { name: "Bermuda", abbreviation: "BM" }, { name: "Bhutan", abbreviation: "BT" }, { name: "Plurinational State of Bolivia", abbreviation: "BO" }, { name: "Bonaire, Sint Eustatius and Saba", abbreviation: "BQ" }, { name: "Bosnia and Herzegovina", abbreviation: "BA" }, { name: "Botswana", abbreviation: "BW" }, { name: "Bouvet Island", abbreviation: "BV" }, { name: "Brazil", abbreviation: "BR" }, { name: "British Indian Ocean Territory", abbreviation: "IO" }, { name: "Brunei Darussalam", abbreviation: "BN" }, { name: "Bulgaria", abbreviation: "BG" }, { name: "Burkina Faso", abbreviation: "BF" }, { name: "Burundi", abbreviation: "BI" }, { name: "Cabo Verde", abbreviation: "CV" }, { name: "Cambodia", abbreviation: "KH" }, { name: "Cameroon", abbreviation: "CM" }, { name: "Canada", abbreviation: "CA" }, { name: "Cayman Islands", abbreviation: "KY" }, { name: "Central African Republic", abbreviation: "CF" }, { name: "Chad", abbreviation: "TD" }, { name: "Chile", abbreviation: "CL" }, { name: "China", abbreviation: "CN" }, { name: "Christmas Island", abbreviation: "CX" }, { name: "Cocos (Keeling) Islands", abbreviation: "CC" }, { name: "Colombia", abbreviation: "CO" }, { name: "Comoros", abbreviation: "KM" }, { name: "Congo", abbreviation: "CG" }, { name: "Democratic Republic of the Congo", abbreviation: "CD" }, { name: "Cook Islands", abbreviation: "CK" }, { name: "Costa Rica", abbreviation: "CR" }, { name: "Côte d'Ivoire", abbreviation: "CI" }, { name: "Croatia", abbreviation: "HR" }, { name: "Cuba", abbreviation: "CU" }, { name: "Curaçao", abbreviation: "CW" }, { name: "Cyprus", abbreviation: "CY" }, { name: "Czechia", abbreviation: "CZ" }, { name: "Denmark", abbreviation: "DK" }, { name: "Djibouti", abbreviation: "DJ" }, { name: "Dominica", abbreviation: "DM" }, { name: "Dominican Republic", abbreviation: "DO" }, { name: "Ecuador", abbreviation: "EC" }, { name: "Egypt", abbreviation: "EG" }, { name: "El Salvador", abbreviation: "SV" }, { name: "Equatorial Guinea", abbreviation: "GQ" }, { name: "Eritrea", abbreviation: "ER" }, { name: "Estonia", abbreviation: "EE" }, { name: "Eswatini", abbreviation: "SZ" }, { name: "Ethiopia", abbreviation: "ET" }, { name: "Falkland Islands (Malvinas)", abbreviation: "FK" }, { name: "Faroe Islands", abbreviation: "FO" }, { name: "Fiji", abbreviation: "FJ" }, { name: "Finland", abbreviation: "FI" }, { name: "France", abbreviation: "FR" }, { name: "French Guiana", abbreviation: "GF" }, { name: "French Polynesia", abbreviation: "PF" }, { name: "French Southern Territories", abbreviation: "TF" }, { name: "Gabon", abbreviation: "GA" }, { name: "Gambia", abbreviation: "GM" }, { name: "Georgia", abbreviation: "GE" }, { name: "Germany", abbreviation: "DE" }, { name: "Ghana", abbreviation: "GH" }, { name: "Gibraltar", abbreviation: "GI" }, { name: "Greece", abbreviation: "GR" }, { name: "Greenland", abbreviation: "GL" }, { name: "Grenada", abbreviation: "GD" }, { name: "Guadeloupe", abbreviation: "GP" }, { name: "Guam", abbreviation: "GU" }, { name: "Guatemala", abbreviation: "GT" }, { name: "Guernsey", abbreviation: "GG" }, { name: "Guinea", abbreviation: "GN" }, { name: "Guinea-Bissau", abbreviation: "GW" }, { name: "Guyana", abbreviation: "GY" }, { name: "Haiti", abbreviation: "HT" }, { name: "Heard Island and McDonald Islands", abbreviation: "HM" }, { name: "Holy See", abbreviation: "VA" }, { name: "Honduras", abbreviation: "HN" }, { name: "Hong Kong", abbreviation: "HK" }, { name: "Hungary", abbreviation: "HU" }, { name: "Iceland", abbreviation: "IS" }, { name: "India", abbreviation: "IN" }, { name: "Indonesia", abbreviation: "ID" }, { name: "Islamic Republic of Iran", abbreviation: "IR" }, { name: "Iraq", abbreviation: "IQ" }, { name: "Ireland", abbreviation: "IE" }, { name: "Isle of Man", abbreviation: "IM" }, { name: "Israel", abbreviation: "IL" }, { name: "Italy", abbreviation: "IT" }, { name: "Jamaica", abbreviation: "JM" }, { name: "Japan", abbreviation: "JP" }, { name: "Jersey", abbreviation: "JE" }, { name: "Jordan", abbreviation: "JO" }, { name: "Kazakhstan", abbreviation: "KZ" }, { name: "Kenya", abbreviation: "KE" }, { name: "Kiribati", abbreviation: "KI" }, { name: "Democratic People's Republic of Korea", abbreviation: "KP" }, { name: "Republic of Korea", abbreviation: "KR" }, { name: "Kuwait", abbreviation: "KW" }, { name: "Kyrgyzstan", abbreviation: "KG" }, { name: "Lao People's Democratic Republic", abbreviation: "LA" }, { name: "Latvia", abbreviation: "LV" }, { name: "Lebanon", abbreviation: "LB" }, { name: "Lesotho", abbreviation: "LS" }, { name: "Liberia", abbreviation: "LR" }, { name: "Libya", abbreviation: "LY" }, { name: "Liechtenstein", abbreviation: "LI" }, { name: "Lithuania", abbreviation: "LT" }, { name: "Luxembourg", abbreviation: "LU" }, { name: "Macao", abbreviation: "MO" }, { name: "Madagascar", abbreviation: "MG" }, { name: "Malawi", abbreviation: "MW" }, { name: "Malaysia", abbreviation: "MY" }, { name: "Maldives", abbreviation: "MV" }, { name: "Mali", abbreviation: "ML" }, { name: "Malta", abbreviation: "MT" }, { name: "Marshall Islands", abbreviation: "MH" }, { name: "Martinique", abbreviation: "MQ" }, { name: "Mauritania", abbreviation: "MR" }, { name: "Mauritius", abbreviation: "MU" }, { name: "Mayotte", abbreviation: "YT" }, { name: "Mexico", abbreviation: "MX" }, { name: "Federated States of Micronesia", abbreviation: "FM" }, { name: "Republic of Moldova", abbreviation: "MD" }, { name: "Monaco", abbreviation: "MC" }, { name: "Mongolia", abbreviation: "MN" }, { name: "Montenegro", abbreviation: "ME" }, { name: "Montserrat", abbreviation: "MS" }, { name: "Morocco", abbreviation: "MA" }, { name: "Mozambique", abbreviation: "MZ" }, { name: "Myanmar", abbreviation: "MM" }, { name: "Namibia", abbreviation: "NA" }, { name: "Nauru", abbreviation: "NR" }, { name: "Nepal", abbreviation: "NP" }, { name: "Kingdom of the Netherlands", abbreviation: "NL" }, { name: "New Caledonia", abbreviation: "NC" }, { name: "New Zealand", abbreviation: "NZ" }, { name: "Nicaragua", abbreviation: "NI" }, { name: "Niger", abbreviation: "NE" }, { name: "Nigeria", abbreviation: "NG" }, { name: "Niue", abbreviation: "NU" }, { name: "Norfolk Island", abbreviation: "NF" }, { name: "North Macedonia", abbreviation: "MK" }, { name: "Northern Mariana Islands", abbreviation: "MP" }, { name: "Norway", abbreviation: "NO" }, { name: "Oman", abbreviation: "OM" }, { name: "Pakistan", abbreviation: "PK" }, { name: "Palau", abbreviation: "PW" }, { name: "State of Palestine", abbreviation: "PS" }, { name: "Panama", abbreviation: "PA" }, { name: "Papua New Guinea", abbreviation: "PG" }, { name: "Paraguay", abbreviation: "PY" }, { name: "Peru", abbreviation: "PE" }, { name: "Philippines", abbreviation: "PH" }, { name: "Pitcairn", abbreviation: "PN" }, { name: "Poland", abbreviation: "PL" }, { name: "Portugal", abbreviation: "PT" }, { name: "Puerto Rico", abbreviation: "PR" }, { name: "Qatar", abbreviation: "QA" }, { name: "Réunion", abbreviation: "RE" }, { name: "Romania", abbreviation: "RO" }, { name: "Russian Federation", abbreviation: "RU" }, { name: "Rwanda", abbreviation: "RW" }, { name: "Saint Barthélemy", abbreviation: "BL" }, { name: "Saint Helena, Ascension and Tristan da Cunha", abbreviation: "SH" }, { name: "Saint Kitts and Nevis", abbreviation: "KN" }, { name: "Saint Lucia", abbreviation: "LC" }, { name: "Saint Martin (French part)", abbreviation: "MF" }, { name: "Saint Pierre and Miquelon", abbreviation: "PM" }, { name: "Saint Vincent and the Grenadines", abbreviation: "VC" }, { name: "Samoa", abbreviation: "WS" }, { name: "San Marino", abbreviation: "SM" }, { name: "Sao Tome and Principe", abbreviation: "ST" }, { name: "Saudi Arabia", abbreviation: "SA" }, { name: "Senegal", abbreviation: "SN" }, { name: "Serbia", abbreviation: "RS" }, { name: "Seychelles", abbreviation: "SC" }, { name: "Sierra Leone", abbreviation: "SL" }, { name: "Singapore", abbreviation: "SG" }, { name: "Sint Maarten (Dutch part)", abbreviation: "SX" }, { name: "Slovakia", abbreviation: "SK" }, { name: "Slovenia", abbreviation: "SI" }, { name: "Solomon Islands", abbreviation: "SB" }, { name: "Somalia", abbreviation: "SO" }, { name: "South Africa", abbreviation: "ZA" }, { name: "South Georgia and the South Sandwich Islands", abbreviation: "GS" }, { name: "South Sudan", abbreviation: "SS" }, { name: "Spain", abbreviation: "ES" }, { name: "Sri Lanka", abbreviation: "LK" }, { name: "Sudan", abbreviation: "SD" }, { name: "Suriname", abbreviation: "SR" }, { name: "Svalbard and Jan Mayen", abbreviation: "SJ" }, { name: "Sweden", abbreviation: "SE" }, { name: "Switzerland", abbreviation: "CH" }, { name: "Syrian Arab Republic", abbreviation: "SY" }, { name: "Taiwan, Province of China", abbreviation: "TW" }, { name: "Tajikistan", abbreviation: "TJ" }, { name: "United Republic of Tanzania", abbreviation: "TZ" }, { name: "Thailand", abbreviation: "TH" }, { name: "Timor-Leste", abbreviation: "TL" }, { name: "Togo", abbreviation: "TG" }, { name: "Tokelau", abbreviation: "TK" }, { name: "Tonga", abbreviation: "TO" }, { name: "Trinidad and Tobago", abbreviation: "TT" }, { name: "Tunisia", abbreviation: "TN" }, { name: "Türkiye", abbreviation: "TR" }, { name: "Turkmenistan", abbreviation: "TM" }, { name: "Turks and Caicos Islands", abbreviation: "TC" }, { name: "Tuvalu", abbreviation: "TV" }, { name: "Uganda", abbreviation: "UG" }, { name: "Ukraine", abbreviation: "UA" }, { name: "United Arab Emirates", abbreviation: "AE" }, { name: "United Kingdom of Great Britain and Northern Ireland", abbreviation: "GB" }, { name: "United States Minor Outlying Islands", abbreviation: "UM" }, { name: "United States of America", abbreviation: "US" }, { name: "Uruguay", abbreviation: "UY" }, { name: "Uzbekistan", abbreviation: "UZ" }, { name: "Vanuatu", abbreviation: "VU" }, { name: "Bolivarian Republic of Venezuela", abbreviation: "VE" }, { name: "Viet Nam", abbreviation: "VN" }, { name: "Virgin Islands (British)", abbreviation: "VG" }, { name: "Virgin Islands (U.S.)", abbreviation: "VI" }, { name: "Wallis and Futuna", abbreviation: "WF" }, { name: "Western Sahara", abbreviation: "EH" }, { name: "Yemen", abbreviation: "YE" }, { name: "Zambia", abbreviation: "ZM" }, { name: "Zimbabwe", abbreviation: "ZW" }],
        counties: {
          // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
          uk: [
            { name: "Bath and North East Somerset" },
            { name: "Aberdeenshire" },
            { name: "Anglesey" },
            { name: "Angus" },
            { name: "Bedford" },
            { name: "Blackburn with Darwen" },
            { name: "Blackpool" },
            { name: "Bournemouth" },
            { name: "Bracknell Forest" },
            { name: "Brighton & Hove" },
            { name: "Bristol" },
            { name: "Buckinghamshire" },
            { name: "Cambridgeshire" },
            { name: "Carmarthenshire" },
            { name: "Central Bedfordshire" },
            { name: "Ceredigion" },
            { name: "Cheshire East" },
            { name: "Cheshire West and Chester" },
            { name: "Clackmannanshire" },
            { name: "Conwy" },
            { name: "Cornwall" },
            { name: "County Antrim" },
            { name: "County Armagh" },
            { name: "County Down" },
            { name: "County Durham" },
            { name: "County Fermanagh" },
            { name: "County Londonderry" },
            { name: "County Tyrone" },
            { name: "Cumbria" },
            { name: "Darlington" },
            { name: "Denbighshire" },
            { name: "Derby" },
            { name: "Derbyshire" },
            { name: "Devon" },
            { name: "Dorset" },
            { name: "Dumfries and Galloway" },
            { name: "Dundee" },
            { name: "East Lothian" },
            { name: "East Riding of Yorkshire" },
            { name: "East Sussex" },
            { name: "Edinburgh?" },
            { name: "Essex" },
            { name: "Falkirk" },
            { name: "Fife" },
            { name: "Flintshire" },
            { name: "Gloucestershire" },
            { name: "Greater London" },
            { name: "Greater Manchester" },
            { name: "Gwent" },
            { name: "Gwynedd" },
            { name: "Halton" },
            { name: "Hampshire" },
            { name: "Hartlepool" },
            { name: "Herefordshire" },
            { name: "Hertfordshire" },
            { name: "Highlands" },
            { name: "Hull" },
            { name: "Isle of Wight" },
            { name: "Isles of Scilly" },
            { name: "Kent" },
            { name: "Lancashire" },
            { name: "Leicester" },
            { name: "Leicestershire" },
            { name: "Lincolnshire" },
            { name: "Lothian" },
            { name: "Luton" },
            { name: "Medway" },
            { name: "Merseyside" },
            { name: "Mid Glamorgan" },
            { name: "Middlesbrough" },
            { name: "Milton Keynes" },
            { name: "Monmouthshire" },
            { name: "Moray" },
            { name: "Norfolk" },
            { name: "North East Lincolnshire" },
            { name: "North Lincolnshire" },
            { name: "North Somerset" },
            { name: "North Yorkshire" },
            { name: "Northamptonshire" },
            { name: "Northumberland" },
            { name: "Nottingham" },
            { name: "Nottinghamshire" },
            { name: "Oxfordshire" },
            { name: "Pembrokeshire" },
            { name: "Perth and Kinross" },
            { name: "Peterborough" },
            { name: "Plymouth" },
            { name: "Poole" },
            { name: "Portsmouth" },
            { name: "Powys" },
            { name: "Reading" },
            { name: "Redcar and Cleveland" },
            { name: "Rutland" },
            { name: "Scottish Borders" },
            { name: "Shropshire" },
            { name: "Slough" },
            { name: "Somerset" },
            { name: "South Glamorgan" },
            { name: "South Gloucestershire" },
            { name: "South Yorkshire" },
            { name: "Southampton" },
            { name: "Southend-on-Sea" },
            { name: "Staffordshire" },
            { name: "Stirlingshire" },
            { name: "Stockton-on-Tees" },
            { name: "Stoke-on-Trent" },
            { name: "Strathclyde" },
            { name: "Suffolk" },
            { name: "Surrey" },
            { name: "Swindon" },
            { name: "Telford and Wrekin" },
            { name: "Thurrock" },
            { name: "Torbay" },
            { name: "Tyne and Wear" },
            { name: "Warrington" },
            { name: "Warwickshire" },
            { name: "West Berkshire" },
            { name: "West Glamorgan" },
            { name: "West Lothian" },
            { name: "West Midlands" },
            { name: "West Sussex" },
            { name: "West Yorkshire" },
            { name: "Western Isles" },
            { name: "Wiltshire" },
            { name: "Windsor and Maidenhead" },
            { name: "Wokingham" },
            { name: "Worcestershire" },
            { name: "Wrexham" },
            { name: "York" }
          ]
        },
        provinces: {
          ca: [
            { name: "Alberta", abbreviation: "AB" },
            { name: "British Columbia", abbreviation: "BC" },
            { name: "Manitoba", abbreviation: "MB" },
            { name: "New Brunswick", abbreviation: "NB" },
            { name: "Newfoundland and Labrador", abbreviation: "NL" },
            { name: "Nova Scotia", abbreviation: "NS" },
            { name: "Ontario", abbreviation: "ON" },
            { name: "Prince Edward Island", abbreviation: "PE" },
            { name: "Quebec", abbreviation: "QC" },
            { name: "Saskatchewan", abbreviation: "SK" },
            // The case could be made that the following are not actually provinces
            // since they are technically considered "territories" however they all
            // look the same on an envelope!
            { name: "Northwest Territories", abbreviation: "NT" },
            { name: "Nunavut", abbreviation: "NU" },
            { name: "Yukon", abbreviation: "YT" }
          ],
          it: [
            { name: "Agrigento", abbreviation: "AG", code: 84 },
            { name: "Alessandria", abbreviation: "AL", code: 6 },
            { name: "Ancona", abbreviation: "AN", code: 42 },
            { name: "Aosta", abbreviation: "AO", code: 7 },
            { name: "L'Aquila", abbreviation: "AQ", code: 66 },
            { name: "Arezzo", abbreviation: "AR", code: 51 },
            { name: "Ascoli-Piceno", abbreviation: "AP", code: 44 },
            { name: "Asti", abbreviation: "AT", code: 5 },
            { name: "Avellino", abbreviation: "AV", code: 64 },
            { name: "Bari", abbreviation: "BA", code: 72 },
            { name: "Barletta-Andria-Trani", abbreviation: "BT", code: 72 },
            { name: "Belluno", abbreviation: "BL", code: 25 },
            { name: "Benevento", abbreviation: "BN", code: 62 },
            { name: "Bergamo", abbreviation: "BG", code: 16 },
            { name: "Biella", abbreviation: "BI", code: 96 },
            { name: "Bologna", abbreviation: "BO", code: 37 },
            { name: "Bolzano", abbreviation: "BZ", code: 21 },
            { name: "Brescia", abbreviation: "BS", code: 17 },
            { name: "Brindisi", abbreviation: "BR", code: 74 },
            { name: "Cagliari", abbreviation: "CA", code: 92 },
            { name: "Caltanissetta", abbreviation: "CL", code: 85 },
            { name: "Campobasso", abbreviation: "CB", code: 70 },
            { name: "Carbonia Iglesias", abbreviation: "CI", code: 70 },
            { name: "Caserta", abbreviation: "CE", code: 61 },
            { name: "Catania", abbreviation: "CT", code: 87 },
            { name: "Catanzaro", abbreviation: "CZ", code: 79 },
            { name: "Chieti", abbreviation: "CH", code: 69 },
            { name: "Como", abbreviation: "CO", code: 13 },
            { name: "Cosenza", abbreviation: "CS", code: 78 },
            { name: "Cremona", abbreviation: "CR", code: 19 },
            { name: "Crotone", abbreviation: "KR", code: 101 },
            { name: "Cuneo", abbreviation: "CN", code: 4 },
            { name: "Enna", abbreviation: "EN", code: 86 },
            { name: "Fermo", abbreviation: "FM", code: 86 },
            { name: "Ferrara", abbreviation: "FE", code: 38 },
            { name: "Firenze", abbreviation: "FI", code: 48 },
            { name: "Foggia", abbreviation: "FG", code: 71 },
            { name: "Forli-Cesena", abbreviation: "FC", code: 71 },
            { name: "Frosinone", abbreviation: "FR", code: 60 },
            { name: "Genova", abbreviation: "GE", code: 10 },
            { name: "Gorizia", abbreviation: "GO", code: 31 },
            { name: "Grosseto", abbreviation: "GR", code: 53 },
            { name: "Imperia", abbreviation: "IM", code: 8 },
            { name: "Isernia", abbreviation: "IS", code: 94 },
            { name: "La-Spezia", abbreviation: "SP", code: 66 },
            { name: "Latina", abbreviation: "LT", code: 59 },
            { name: "Lecce", abbreviation: "LE", code: 75 },
            { name: "Lecco", abbreviation: "LC", code: 97 },
            { name: "Livorno", abbreviation: "LI", code: 49 },
            { name: "Lodi", abbreviation: "LO", code: 98 },
            { name: "Lucca", abbreviation: "LU", code: 46 },
            { name: "Macerata", abbreviation: "MC", code: 43 },
            { name: "Mantova", abbreviation: "MN", code: 20 },
            { name: "Massa-Carrara", abbreviation: "MS", code: 45 },
            { name: "Matera", abbreviation: "MT", code: 77 },
            { name: "Medio Campidano", abbreviation: "VS", code: 77 },
            { name: "Messina", abbreviation: "ME", code: 83 },
            { name: "Milano", abbreviation: "MI", code: 15 },
            { name: "Modena", abbreviation: "MO", code: 36 },
            { name: "Monza-Brianza", abbreviation: "MB", code: 36 },
            { name: "Napoli", abbreviation: "NA", code: 63 },
            { name: "Novara", abbreviation: "NO", code: 3 },
            { name: "Nuoro", abbreviation: "NU", code: 91 },
            { name: "Ogliastra", abbreviation: "OG", code: 91 },
            { name: "Olbia Tempio", abbreviation: "OT", code: 91 },
            { name: "Oristano", abbreviation: "OR", code: 95 },
            { name: "Padova", abbreviation: "PD", code: 28 },
            { name: "Palermo", abbreviation: "PA", code: 82 },
            { name: "Parma", abbreviation: "PR", code: 34 },
            { name: "Pavia", abbreviation: "PV", code: 18 },
            { name: "Perugia", abbreviation: "PG", code: 54 },
            { name: "Pesaro-Urbino", abbreviation: "PU", code: 41 },
            { name: "Pescara", abbreviation: "PE", code: 68 },
            { name: "Piacenza", abbreviation: "PC", code: 33 },
            { name: "Pisa", abbreviation: "PI", code: 50 },
            { name: "Pistoia", abbreviation: "PT", code: 47 },
            { name: "Pordenone", abbreviation: "PN", code: 93 },
            { name: "Potenza", abbreviation: "PZ", code: 76 },
            { name: "Prato", abbreviation: "PO", code: 100 },
            { name: "Ragusa", abbreviation: "RG", code: 88 },
            { name: "Ravenna", abbreviation: "RA", code: 39 },
            { name: "Reggio-Calabria", abbreviation: "RC", code: 35 },
            { name: "Reggio-Emilia", abbreviation: "RE", code: 35 },
            { name: "Rieti", abbreviation: "RI", code: 57 },
            { name: "Rimini", abbreviation: "RN", code: 99 },
            { name: "Roma", abbreviation: "Roma", code: 58 },
            { name: "Rovigo", abbreviation: "RO", code: 29 },
            { name: "Salerno", abbreviation: "SA", code: 65 },
            { name: "Sassari", abbreviation: "SS", code: 90 },
            { name: "Savona", abbreviation: "SV", code: 9 },
            { name: "Siena", abbreviation: "SI", code: 52 },
            { name: "Siracusa", abbreviation: "SR", code: 89 },
            { name: "Sondrio", abbreviation: "SO", code: 14 },
            { name: "Taranto", abbreviation: "TA", code: 73 },
            { name: "Teramo", abbreviation: "TE", code: 67 },
            { name: "Terni", abbreviation: "TR", code: 55 },
            { name: "Torino", abbreviation: "TO", code: 1 },
            { name: "Trapani", abbreviation: "TP", code: 81 },
            { name: "Trento", abbreviation: "TN", code: 22 },
            { name: "Treviso", abbreviation: "TV", code: 26 },
            { name: "Trieste", abbreviation: "TS", code: 32 },
            { name: "Udine", abbreviation: "UD", code: 30 },
            { name: "Varese", abbreviation: "VA", code: 12 },
            { name: "Venezia", abbreviation: "VE", code: 27 },
            { name: "Verbania", abbreviation: "VB", code: 27 },
            { name: "Vercelli", abbreviation: "VC", code: 2 },
            { name: "Verona", abbreviation: "VR", code: 23 },
            { name: "Vibo-Valentia", abbreviation: "VV", code: 102 },
            { name: "Vicenza", abbreviation: "VI", code: 24 },
            { name: "Viterbo", abbreviation: "VT", code: 56 }
          ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
          { name: "Afghan" },
          { name: "Albanian" },
          { name: "Algerian" },
          { name: "American" },
          { name: "Andorran" },
          { name: "Angolan" },
          { name: "Antiguans" },
          { name: "Argentinean" },
          { name: "Armenian" },
          { name: "Australian" },
          { name: "Austrian" },
          { name: "Azerbaijani" },
          { name: "Bahami" },
          { name: "Bahraini" },
          { name: "Bangladeshi" },
          { name: "Barbadian" },
          { name: "Barbudans" },
          { name: "Batswana" },
          { name: "Belarusian" },
          { name: "Belgian" },
          { name: "Belizean" },
          { name: "Beninese" },
          { name: "Bhutanese" },
          { name: "Bolivian" },
          { name: "Bosnian" },
          { name: "Brazilian" },
          { name: "British" },
          { name: "Bruneian" },
          { name: "Bulgarian" },
          { name: "Burkinabe" },
          { name: "Burmese" },
          { name: "Burundian" },
          { name: "Cambodian" },
          { name: "Cameroonian" },
          { name: "Canadian" },
          { name: "Cape Verdean" },
          { name: "Central African" },
          { name: "Chadian" },
          { name: "Chilean" },
          { name: "Chinese" },
          { name: "Colombian" },
          { name: "Comoran" },
          { name: "Congolese" },
          { name: "Costa Rican" },
          { name: "Croatian" },
          { name: "Cuban" },
          { name: "Cypriot" },
          { name: "Czech" },
          { name: "Danish" },
          { name: "Djibouti" },
          { name: "Dominican" },
          { name: "Dutch" },
          { name: "East Timorese" },
          { name: "Ecuadorean" },
          { name: "Egyptian" },
          { name: "Emirian" },
          { name: "Equatorial Guinean" },
          { name: "Eritrean" },
          { name: "Estonian" },
          { name: "Ethiopian" },
          { name: "Fijian" },
          { name: "Filipino" },
          { name: "Finnish" },
          { name: "French" },
          { name: "Gabonese" },
          { name: "Gambian" },
          { name: "Georgian" },
          { name: "German" },
          { name: "Ghanaian" },
          { name: "Greek" },
          { name: "Grenadian" },
          { name: "Guatemalan" },
          { name: "Guinea-Bissauan" },
          { name: "Guinean" },
          { name: "Guyanese" },
          { name: "Haitian" },
          { name: "Herzegovinian" },
          { name: "Honduran" },
          { name: "Hungarian" },
          { name: "I-Kiribati" },
          { name: "Icelander" },
          { name: "Indian" },
          { name: "Indonesian" },
          { name: "Iranian" },
          { name: "Iraqi" },
          { name: "Irish" },
          { name: "Israeli" },
          { name: "Italian" },
          { name: "Ivorian" },
          { name: "Jamaican" },
          { name: "Japanese" },
          { name: "Jordanian" },
          { name: "Kazakhstani" },
          { name: "Kenyan" },
          { name: "Kittian and Nevisian" },
          { name: "Kuwaiti" },
          { name: "Kyrgyz" },
          { name: "Laotian" },
          { name: "Latvian" },
          { name: "Lebanese" },
          { name: "Liberian" },
          { name: "Libyan" },
          { name: "Liechtensteiner" },
          { name: "Lithuanian" },
          { name: "Luxembourger" },
          { name: "Macedonian" },
          { name: "Malagasy" },
          { name: "Malawian" },
          { name: "Malaysian" },
          { name: "Maldivan" },
          { name: "Malian" },
          { name: "Maltese" },
          { name: "Marshallese" },
          { name: "Mauritanian" },
          { name: "Mauritian" },
          { name: "Mexican" },
          { name: "Micronesian" },
          { name: "Moldovan" },
          { name: "Monacan" },
          { name: "Mongolian" },
          { name: "Moroccan" },
          { name: "Mosotho" },
          { name: "Motswana" },
          { name: "Mozambican" },
          { name: "Namibian" },
          { name: "Nauruan" },
          { name: "Nepalese" },
          { name: "New Zealander" },
          { name: "Nicaraguan" },
          { name: "Nigerian" },
          { name: "Nigerien" },
          { name: "North Korean" },
          { name: "Northern Irish" },
          { name: "Norwegian" },
          { name: "Omani" },
          { name: "Pakistani" },
          { name: "Palauan" },
          { name: "Panamanian" },
          { name: "Papua New Guinean" },
          { name: "Paraguayan" },
          { name: "Peruvian" },
          { name: "Polish" },
          { name: "Portuguese" },
          { name: "Qatari" },
          { name: "Romani" },
          { name: "Russian" },
          { name: "Rwandan" },
          { name: "Saint Lucian" },
          { name: "Salvadoran" },
          { name: "Samoan" },
          { name: "San Marinese" },
          { name: "Sao Tomean" },
          { name: "Saudi" },
          { name: "Scottish" },
          { name: "Senegalese" },
          { name: "Serbian" },
          { name: "Seychellois" },
          { name: "Sierra Leonean" },
          { name: "Singaporean" },
          { name: "Slovakian" },
          { name: "Slovenian" },
          { name: "Solomon Islander" },
          { name: "Somali" },
          { name: "South African" },
          { name: "South Korean" },
          { name: "Spanish" },
          { name: "Sri Lankan" },
          { name: "Sudanese" },
          { name: "Surinamer" },
          { name: "Swazi" },
          { name: "Swedish" },
          { name: "Swiss" },
          { name: "Syrian" },
          { name: "Taiwanese" },
          { name: "Tajik" },
          { name: "Tanzanian" },
          { name: "Thai" },
          { name: "Togolese" },
          { name: "Tongan" },
          { name: "Trinidadian or Tobagonian" },
          { name: "Tunisian" },
          { name: "Turkish" },
          { name: "Tuvaluan" },
          { name: "Ugandan" },
          { name: "Ukrainian" },
          { name: "Uruguaya" },
          { name: "Uzbekistani" },
          { name: "Venezuela" },
          { name: "Vietnamese" },
          { name: "Wels" },
          { name: "Yemenit" },
          { name: "Zambia" },
          { name: "Zimbabwe" }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
          "aa",
          "ab",
          "ae",
          "af",
          "ak",
          "am",
          "an",
          "ar",
          "as",
          "av",
          "ay",
          "az",
          "ba",
          "be",
          "bg",
          "bh",
          "bi",
          "bm",
          "bn",
          "bo",
          "br",
          "bs",
          "ca",
          "ce",
          "ch",
          "co",
          "cr",
          "cs",
          "cu",
          "cv",
          "cy",
          "da",
          "de",
          "dv",
          "dz",
          "ee",
          "el",
          "en",
          "eo",
          "es",
          "et",
          "eu",
          "fa",
          "ff",
          "fi",
          "fj",
          "fo",
          "fr",
          "fy",
          "ga",
          "gd",
          "gl",
          "gn",
          "gu",
          "gv",
          "ha",
          "he",
          "hi",
          "ho",
          "hr",
          "ht",
          "hu",
          "hy",
          "hz",
          "ia",
          "id",
          "ie",
          "ig",
          "ii",
          "ik",
          "io",
          "is",
          "it",
          "iu",
          "ja",
          "jv",
          "ka",
          "kg",
          "ki",
          "kj",
          "kk",
          "kl",
          "km",
          "kn",
          "ko",
          "kr",
          "ks",
          "ku",
          "kv",
          "kw",
          "ky",
          "la",
          "lb",
          "lg",
          "li",
          "ln",
          "lo",
          "lt",
          "lu",
          "lv",
          "mg",
          "mh",
          "mi",
          "mk",
          "ml",
          "mn",
          "mr",
          "ms",
          "mt",
          "my",
          "na",
          "nb",
          "nd",
          "ne",
          "ng",
          "nl",
          "nn",
          "no",
          "nr",
          "nv",
          "ny",
          "oc",
          "oj",
          "om",
          "or",
          "os",
          "pa",
          "pi",
          "pl",
          "ps",
          "pt",
          "qu",
          "rm",
          "rn",
          "ro",
          "ru",
          "rw",
          "sa",
          "sc",
          "sd",
          "se",
          "sg",
          "si",
          "sk",
          "sl",
          "sm",
          "sn",
          "so",
          "sq",
          "sr",
          "ss",
          "st",
          "su",
          "sv",
          "sw",
          "ta",
          "te",
          "tg",
          "th",
          "ti",
          "tk",
          "tl",
          "tn",
          "to",
          "tr",
          "ts",
          "tt",
          "tw",
          "ty",
          "ug",
          "uk",
          "ur",
          "uz",
          "ve",
          "vi",
          "vo",
          "wa",
          "wo",
          "xh",
          "yi",
          "yo",
          "za",
          "zh",
          "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
          "agq-CM",
          "asa-TZ",
          "ast-ES",
          "bas-CM",
          "bem-ZM",
          "bez-TZ",
          "brx-IN",
          "cgg-UG",
          "chr-US",
          "dav-KE",
          "dje-NE",
          "dsb-DE",
          "dua-CM",
          "dyo-SN",
          "ebu-KE",
          "ewo-CM",
          "fil-PH",
          "fur-IT",
          "gsw-CH",
          "gsw-FR",
          "gsw-LI",
          "guz-KE",
          "haw-US",
          "hsb-DE",
          "jgo-CM",
          "jmc-TZ",
          "kab-DZ",
          "kam-KE",
          "kde-TZ",
          "kea-CV",
          "khq-ML",
          "kkj-CM",
          "kln-KE",
          "kok-IN",
          "ksb-TZ",
          "ksf-CM",
          "ksh-DE",
          "lag-TZ",
          "lkt-US",
          "luo-KE",
          "luy-KE",
          "mas-KE",
          "mas-TZ",
          "mer-KE",
          "mfe-MU",
          "mgh-MZ",
          "mgo-CM",
          "mua-CM",
          "naq-NA",
          "nmg-CM",
          "nnh-CM",
          "nus-SD",
          "nyn-UG",
          "rof-TZ",
          "rwk-TZ",
          "sah-RU",
          "saq-KE",
          "sbp-TZ",
          "seh-MZ",
          "ses-ML",
          "shi-Latn",
          "shi-Latn-MA",
          "shi-Tfng",
          "shi-Tfng-MA",
          "smn-FI",
          "teo-KE",
          "teo-UG",
          "twq-NE",
          "tzm-Latn",
          "tzm-Latn-MA",
          "vai-Latn",
          "vai-Latn-LR",
          "vai-Vaii",
          "vai-Vaii-LR",
          "vun-TZ",
          "wae-CH",
          "xog-UG",
          "yav-CM",
          "zgh-MA",
          "af-NA",
          "af-ZA",
          "ak-GH",
          "am-ET",
          "ar-001",
          "ar-AE",
          "ar-BH",
          "ar-DJ",
          "ar-DZ",
          "ar-EG",
          "ar-EH",
          "ar-ER",
          "ar-IL",
          "ar-IQ",
          "ar-JO",
          "ar-KM",
          "ar-KW",
          "ar-LB",
          "ar-LY",
          "ar-MA",
          "ar-MR",
          "ar-OM",
          "ar-PS",
          "ar-QA",
          "ar-SA",
          "ar-SD",
          "ar-SO",
          "ar-SS",
          "ar-SY",
          "ar-TD",
          "ar-TN",
          "ar-YE",
          "as-IN",
          "az-Cyrl",
          "az-Cyrl-AZ",
          "az-Latn",
          "az-Latn-AZ",
          "be-BY",
          "bg-BG",
          "bm-Latn",
          "bm-Latn-ML",
          "bn-BD",
          "bn-IN",
          "bo-CN",
          "bo-IN",
          "br-FR",
          "bs-Cyrl",
          "bs-Cyrl-BA",
          "bs-Latn",
          "bs-Latn-BA",
          "ca-AD",
          "ca-ES",
          "ca-ES-VALENCIA",
          "ca-FR",
          "ca-IT",
          "cs-CZ",
          "cy-GB",
          "da-DK",
          "da-GL",
          "de-AT",
          "de-BE",
          "de-CH",
          "de-DE",
          "de-LI",
          "de-LU",
          "dz-BT",
          "ee-GH",
          "ee-TG",
          "el-CY",
          "el-GR",
          "en-001",
          "en-150",
          "en-AG",
          "en-AI",
          "en-AS",
          "en-AU",
          "en-BB",
          "en-BE",
          "en-BM",
          "en-BS",
          "en-BW",
          "en-BZ",
          "en-CA",
          "en-CC",
          "en-CK",
          "en-CM",
          "en-CX",
          "en-DG",
          "en-DM",
          "en-ER",
          "en-FJ",
          "en-FK",
          "en-FM",
          "en-GB",
          "en-GD",
          "en-GG",
          "en-GH",
          "en-GI",
          "en-GM",
          "en-GU",
          "en-GY",
          "en-HK",
          "en-IE",
          "en-IM",
          "en-IN",
          "en-IO",
          "en-JE",
          "en-JM",
          "en-KE",
          "en-KI",
          "en-KN",
          "en-KY",
          "en-LC",
          "en-LR",
          "en-LS",
          "en-MG",
          "en-MH",
          "en-MO",
          "en-MP",
          "en-MS",
          "en-MT",
          "en-MU",
          "en-MW",
          "en-MY",
          "en-NA",
          "en-NF",
          "en-NG",
          "en-NR",
          "en-NU",
          "en-NZ",
          "en-PG",
          "en-PH",
          "en-PK",
          "en-PN",
          "en-PR",
          "en-PW",
          "en-RW",
          "en-SB",
          "en-SC",
          "en-SD",
          "en-SG",
          "en-SH",
          "en-SL",
          "en-SS",
          "en-SX",
          "en-SZ",
          "en-TC",
          "en-TK",
          "en-TO",
          "en-TT",
          "en-TV",
          "en-TZ",
          "en-UG",
          "en-UM",
          "en-US",
          "en-US-POSIX",
          "en-VC",
          "en-VG",
          "en-VI",
          "en-VU",
          "en-WS",
          "en-ZA",
          "en-ZM",
          "en-ZW",
          "eo-001",
          "es-419",
          "es-AR",
          "es-BO",
          "es-CL",
          "es-CO",
          "es-CR",
          "es-CU",
          "es-DO",
          "es-EA",
          "es-EC",
          "es-ES",
          "es-GQ",
          "es-GT",
          "es-HN",
          "es-IC",
          "es-MX",
          "es-NI",
          "es-PA",
          "es-PE",
          "es-PH",
          "es-PR",
          "es-PY",
          "es-SV",
          "es-US",
          "es-UY",
          "es-VE",
          "et-EE",
          "eu-ES",
          "fa-AF",
          "fa-IR",
          "ff-CM",
          "ff-GN",
          "ff-MR",
          "ff-SN",
          "fi-FI",
          "fo-FO",
          "fr-BE",
          "fr-BF",
          "fr-BI",
          "fr-BJ",
          "fr-BL",
          "fr-CA",
          "fr-CD",
          "fr-CF",
          "fr-CG",
          "fr-CH",
          "fr-CI",
          "fr-CM",
          "fr-DJ",
          "fr-DZ",
          "fr-FR",
          "fr-GA",
          "fr-GF",
          "fr-GN",
          "fr-GP",
          "fr-GQ",
          "fr-HT",
          "fr-KM",
          "fr-LU",
          "fr-MA",
          "fr-MC",
          "fr-MF",
          "fr-MG",
          "fr-ML",
          "fr-MQ",
          "fr-MR",
          "fr-MU",
          "fr-NC",
          "fr-NE",
          "fr-PF",
          "fr-PM",
          "fr-RE",
          "fr-RW",
          "fr-SC",
          "fr-SN",
          "fr-SY",
          "fr-TD",
          "fr-TG",
          "fr-TN",
          "fr-VU",
          "fr-WF",
          "fr-YT",
          "fy-NL",
          "ga-IE",
          "gd-GB",
          "gl-ES",
          "gu-IN",
          "gv-IM",
          "ha-Latn",
          "ha-Latn-GH",
          "ha-Latn-NE",
          "ha-Latn-NG",
          "he-IL",
          "hi-IN",
          "hr-BA",
          "hr-HR",
          "hu-HU",
          "hy-AM",
          "id-ID",
          "ig-NG",
          "ii-CN",
          "is-IS",
          "it-CH",
          "it-IT",
          "it-SM",
          "ja-JP",
          "ka-GE",
          "ki-KE",
          "kk-Cyrl",
          "kk-Cyrl-KZ",
          "kl-GL",
          "km-KH",
          "kn-IN",
          "ko-KP",
          "ko-KR",
          "ks-Arab",
          "ks-Arab-IN",
          "kw-GB",
          "ky-Cyrl",
          "ky-Cyrl-KG",
          "lb-LU",
          "lg-UG",
          "ln-AO",
          "ln-CD",
          "ln-CF",
          "ln-CG",
          "lo-LA",
          "lt-LT",
          "lu-CD",
          "lv-LV",
          "mg-MG",
          "mk-MK",
          "ml-IN",
          "mn-Cyrl",
          "mn-Cyrl-MN",
          "mr-IN",
          "ms-Latn",
          "ms-Latn-BN",
          "ms-Latn-MY",
          "ms-Latn-SG",
          "mt-MT",
          "my-MM",
          "nb-NO",
          "nb-SJ",
          "nd-ZW",
          "ne-IN",
          "ne-NP",
          "nl-AW",
          "nl-BE",
          "nl-BQ",
          "nl-CW",
          "nl-NL",
          "nl-SR",
          "nl-SX",
          "nn-NO",
          "om-ET",
          "om-KE",
          "or-IN",
          "os-GE",
          "os-RU",
          "pa-Arab",
          "pa-Arab-PK",
          "pa-Guru",
          "pa-Guru-IN",
          "pl-PL",
          "ps-AF",
          "pt-AO",
          "pt-BR",
          "pt-CV",
          "pt-GW",
          "pt-MO",
          "pt-MZ",
          "pt-PT",
          "pt-ST",
          "pt-TL",
          "qu-BO",
          "qu-EC",
          "qu-PE",
          "rm-CH",
          "rn-BI",
          "ro-MD",
          "ro-RO",
          "ru-BY",
          "ru-KG",
          "ru-KZ",
          "ru-MD",
          "ru-RU",
          "ru-UA",
          "rw-RW",
          "se-FI",
          "se-NO",
          "se-SE",
          "sg-CF",
          "si-LK",
          "sk-SK",
          "sl-SI",
          "sn-ZW",
          "so-DJ",
          "so-ET",
          "so-KE",
          "so-SO",
          "sq-AL",
          "sq-MK",
          "sq-XK",
          "sr-Cyrl",
          "sr-Cyrl-BA",
          "sr-Cyrl-ME",
          "sr-Cyrl-RS",
          "sr-Cyrl-XK",
          "sr-Latn",
          "sr-Latn-BA",
          "sr-Latn-ME",
          "sr-Latn-RS",
          "sr-Latn-XK",
          "sv-AX",
          "sv-FI",
          "sv-SE",
          "sw-CD",
          "sw-KE",
          "sw-TZ",
          "sw-UG",
          "ta-IN",
          "ta-LK",
          "ta-MY",
          "ta-SG",
          "te-IN",
          "th-TH",
          "ti-ER",
          "ti-ET",
          "to-TO",
          "tr-CY",
          "tr-TR",
          "ug-Arab",
          "ug-Arab-CN",
          "uk-UA",
          "ur-IN",
          "ur-PK",
          "uz-Arab",
          "uz-Arab-AF",
          "uz-Cyrl",
          "uz-Cyrl-UZ",
          "uz-Latn",
          "uz-Latn-UZ",
          "vi-VN",
          "yi-001",
          "yo-BJ",
          "yo-NG",
          "zh-Hans",
          "zh-Hans-CN",
          "zh-Hans-HK",
          "zh-Hans-MO",
          "zh-Hans-SG",
          "zh-Hant",
          "zh-Hant-HK",
          "zh-Hant-MO",
          "zh-Hant-TW",
          "zu-ZA"
        ],
        us_states_and_dc: [
          { name: "Alabama", abbreviation: "AL" },
          { name: "Alaska", abbreviation: "AK" },
          { name: "Arizona", abbreviation: "AZ" },
          { name: "Arkansas", abbreviation: "AR" },
          { name: "California", abbreviation: "CA" },
          { name: "Colorado", abbreviation: "CO" },
          { name: "Connecticut", abbreviation: "CT" },
          { name: "Delaware", abbreviation: "DE" },
          { name: "District of Columbia", abbreviation: "DC" },
          { name: "Florida", abbreviation: "FL" },
          { name: "Georgia", abbreviation: "GA" },
          { name: "Hawaii", abbreviation: "HI" },
          { name: "Idaho", abbreviation: "ID" },
          { name: "Illinois", abbreviation: "IL" },
          { name: "Indiana", abbreviation: "IN" },
          { name: "Iowa", abbreviation: "IA" },
          { name: "Kansas", abbreviation: "KS" },
          { name: "Kentucky", abbreviation: "KY" },
          { name: "Louisiana", abbreviation: "LA" },
          { name: "Maine", abbreviation: "ME" },
          { name: "Maryland", abbreviation: "MD" },
          { name: "Massachusetts", abbreviation: "MA" },
          { name: "Michigan", abbreviation: "MI" },
          { name: "Minnesota", abbreviation: "MN" },
          { name: "Mississippi", abbreviation: "MS" },
          { name: "Missouri", abbreviation: "MO" },
          { name: "Montana", abbreviation: "MT" },
          { name: "Nebraska", abbreviation: "NE" },
          { name: "Nevada", abbreviation: "NV" },
          { name: "New Hampshire", abbreviation: "NH" },
          { name: "New Jersey", abbreviation: "NJ" },
          { name: "New Mexico", abbreviation: "NM" },
          { name: "New York", abbreviation: "NY" },
          { name: "North Carolina", abbreviation: "NC" },
          { name: "North Dakota", abbreviation: "ND" },
          { name: "Ohio", abbreviation: "OH" },
          { name: "Oklahoma", abbreviation: "OK" },
          { name: "Oregon", abbreviation: "OR" },
          { name: "Pennsylvania", abbreviation: "PA" },
          { name: "Rhode Island", abbreviation: "RI" },
          { name: "South Carolina", abbreviation: "SC" },
          { name: "South Dakota", abbreviation: "SD" },
          { name: "Tennessee", abbreviation: "TN" },
          { name: "Texas", abbreviation: "TX" },
          { name: "Utah", abbreviation: "UT" },
          { name: "Vermont", abbreviation: "VT" },
          { name: "Virginia", abbreviation: "VA" },
          { name: "Washington", abbreviation: "WA" },
          { name: "West Virginia", abbreviation: "WV" },
          { name: "Wisconsin", abbreviation: "WI" },
          { name: "Wyoming", abbreviation: "WY" }
        ],
        territories: [
          { name: "American Samoa", abbreviation: "AS" },
          { name: "Federated States of Micronesia", abbreviation: "FM" },
          { name: "Guam", abbreviation: "GU" },
          { name: "Marshall Islands", abbreviation: "MH" },
          { name: "Northern Mariana Islands", abbreviation: "MP" },
          { name: "Puerto Rico", abbreviation: "PR" },
          { name: "Virgin Islands, U.S.", abbreviation: "VI" }
        ],
        armed_forces: [
          { name: "Armed Forces Europe", abbreviation: "AE" },
          { name: "Armed Forces Pacific", abbreviation: "AP" },
          { name: "Armed Forces the Americas", abbreviation: "AA" }
        ],
        country_regions: {
          it: [
            { name: "Valle d'Aosta", abbreviation: "VDA" },
            { name: "Piemonte", abbreviation: "PIE" },
            { name: "Lombardia", abbreviation: "LOM" },
            { name: "Veneto", abbreviation: "VEN" },
            { name: "Trentino Alto Adige", abbreviation: "TAA" },
            { name: "Friuli Venezia Giulia", abbreviation: "FVG" },
            { name: "Liguria", abbreviation: "LIG" },
            { name: "Emilia Romagna", abbreviation: "EMR" },
            { name: "Toscana", abbreviation: "TOS" },
            { name: "Umbria", abbreviation: "UMB" },
            { name: "Marche", abbreviation: "MAR" },
            { name: "Abruzzo", abbreviation: "ABR" },
            { name: "Lazio", abbreviation: "LAZ" },
            { name: "Campania", abbreviation: "CAM" },
            { name: "Puglia", abbreviation: "PUG" },
            { name: "Basilicata", abbreviation: "BAS" },
            { name: "Molise", abbreviation: "MOL" },
            { name: "Calabria", abbreviation: "CAL" },
            { name: "Sicilia", abbreviation: "SIC" },
            { name: "Sardegna", abbreviation: "SAR" }
          ],
          mx: [
            { name: "Aguascalientes", abbreviation: "AGU" },
            { name: "Baja California", abbreviation: "BCN" },
            { name: "Baja California Sur", abbreviation: "BCS" },
            { name: "Campeche", abbreviation: "CAM" },
            { name: "Chiapas", abbreviation: "CHP" },
            { name: "Chihuahua", abbreviation: "CHH" },
            { name: "Ciudad de México", abbreviation: "DIF" },
            { name: "Coahuila", abbreviation: "COA" },
            { name: "Colima", abbreviation: "COL" },
            { name: "Durango", abbreviation: "DUR" },
            { name: "Guanajuato", abbreviation: "GUA" },
            { name: "Guerrero", abbreviation: "GRO" },
            { name: "Hidalgo", abbreviation: "HID" },
            { name: "Jalisco", abbreviation: "JAL" },
            { name: "México", abbreviation: "MEX" },
            { name: "Michoacán", abbreviation: "MIC" },
            { name: "Morelos", abbreviation: "MOR" },
            { name: "Nayarit", abbreviation: "NAY" },
            { name: "Nuevo León", abbreviation: "NLE" },
            { name: "Oaxaca", abbreviation: "OAX" },
            { name: "Puebla", abbreviation: "PUE" },
            { name: "Querétaro", abbreviation: "QUE" },
            { name: "Quintana Roo", abbreviation: "ROO" },
            { name: "San Luis Potosí", abbreviation: "SLP" },
            { name: "Sinaloa", abbreviation: "SIN" },
            { name: "Sonora", abbreviation: "SON" },
            { name: "Tabasco", abbreviation: "TAB" },
            { name: "Tamaulipas", abbreviation: "TAM" },
            { name: "Tlaxcala", abbreviation: "TLA" },
            { name: "Veracruz", abbreviation: "VER" },
            { name: "Yucatán", abbreviation: "YUC" },
            { name: "Zacatecas", abbreviation: "ZAC" }
          ]
        },
        street_suffixes: {
          us: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Boulevard", abbreviation: "Blvd" },
            { name: "Center", abbreviation: "Ctr" },
            { name: "Circle", abbreviation: "Cir" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Extension", abbreviation: "Ext" },
            { name: "Glen", abbreviation: "Gln" },
            { name: "Grove", abbreviation: "Grv" },
            { name: "Heights", abbreviation: "Hts" },
            { name: "Highway", abbreviation: "Hwy" },
            { name: "Junction", abbreviation: "Jct" },
            { name: "Key", abbreviation: "Key" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Loop", abbreviation: "Loop" },
            { name: "Manor", abbreviation: "Mnr" },
            { name: "Mill", abbreviation: "Mill" },
            { name: "Park", abbreviation: "Park" },
            { name: "Parkway", abbreviation: "Pkwy" },
            { name: "Pass", abbreviation: "Pass" },
            { name: "Path", abbreviation: "Path" },
            { name: "Pike", abbreviation: "Pike" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Plaza", abbreviation: "Plz" },
            { name: "Point", abbreviation: "Pt" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "River", abbreviation: "Riv" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Trail", abbreviation: "Trl" },
            { name: "Turnpike", abbreviation: "Tpke" },
            { name: "View", abbreviation: "Vw" },
            { name: "Way", abbreviation: "Way" }
          ],
          it: [
            { name: "Accesso", abbreviation: "Acc." },
            { name: "Alzaia", abbreviation: "Alz." },
            { name: "Arco", abbreviation: "Arco" },
            { name: "Archivolto", abbreviation: "Acv." },
            { name: "Arena", abbreviation: "Arena" },
            { name: "Argine", abbreviation: "Argine" },
            { name: "Bacino", abbreviation: "Bacino" },
            { name: "Banchi", abbreviation: "Banchi" },
            { name: "Banchina", abbreviation: "Ban." },
            { name: "Bastioni", abbreviation: "Bas." },
            { name: "Belvedere", abbreviation: "Belv." },
            { name: "Borgata", abbreviation: "B.ta" },
            { name: "Borgo", abbreviation: "B.go" },
            { name: "Calata", abbreviation: "Cal." },
            { name: "Calle", abbreviation: "Calle" },
            { name: "Campiello", abbreviation: "Cam." },
            { name: "Campo", abbreviation: "Cam." },
            { name: "Canale", abbreviation: "Can." },
            { name: "Carraia", abbreviation: "Carr." },
            { name: "Cascina", abbreviation: "Cascina" },
            { name: "Case sparse", abbreviation: "c.s." },
            { name: "Cavalcavia", abbreviation: "Cv." },
            { name: "Circonvallazione", abbreviation: "Cv." },
            { name: "Complanare", abbreviation: "C.re" },
            { name: "Contrada", abbreviation: "C.da" },
            { name: "Corso", abbreviation: "C.so" },
            { name: "Corte", abbreviation: "C.te" },
            { name: "Cortile", abbreviation: "C.le" },
            { name: "Diramazione", abbreviation: "Dir." },
            { name: "Fondaco", abbreviation: "F.co" },
            { name: "Fondamenta", abbreviation: "F.ta" },
            { name: "Fondo", abbreviation: "F.do" },
            { name: "Frazione", abbreviation: "Fr." },
            { name: "Isola", abbreviation: "Is." },
            { name: "Largo", abbreviation: "L.go" },
            { name: "Litoranea", abbreviation: "Lit." },
            { name: "Lungolago", abbreviation: "L.go lago" },
            { name: "Lungo Po", abbreviation: "l.go Po" },
            { name: "Molo", abbreviation: "Molo" },
            { name: "Mura", abbreviation: "Mura" },
            { name: "Passaggio privato", abbreviation: "pass. priv." },
            { name: "Passeggiata", abbreviation: "Pass." },
            { name: "Piazza", abbreviation: "P.zza" },
            { name: "Piazzale", abbreviation: "P.le" },
            { name: "Ponte", abbreviation: "P.te" },
            { name: "Portico", abbreviation: "P.co" },
            { name: "Rampa", abbreviation: "Rampa" },
            { name: "Regione", abbreviation: "Reg." },
            { name: "Rione", abbreviation: "R.ne" },
            { name: "Rio", abbreviation: "Rio" },
            { name: "Ripa", abbreviation: "Ripa" },
            { name: "Riva", abbreviation: "Riva" },
            { name: "Rondò", abbreviation: "Rondò" },
            { name: "Rotonda", abbreviation: "Rot." },
            { name: "Sagrato", abbreviation: "Sagr." },
            { name: "Salita", abbreviation: "Sal." },
            { name: "Scalinata", abbreviation: "Scal." },
            { name: "Scalone", abbreviation: "Scal." },
            { name: "Slargo", abbreviation: "Sl." },
            { name: "Sottoportico", abbreviation: "Sott." },
            { name: "Strada", abbreviation: "Str." },
            { name: "Stradale", abbreviation: "Str.le" },
            { name: "Strettoia", abbreviation: "Strett." },
            { name: "Traversa", abbreviation: "Trav." },
            { name: "Via", abbreviation: "V." },
            { name: "Viale", abbreviation: "V.le" },
            { name: "Vicinale", abbreviation: "Vic.le" },
            { name: "Vicolo", abbreviation: "Vic." }
          ],
          uk: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Close", abbreviation: "Cl" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Crescent", abbreviation: "Cr" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Garden", abbreviation: "Gdn" },
            { name: "Gardens", abbreviation: "Gdns" },
            { name: "Green", abbreviation: "Gn" },
            { name: "Grove", abbreviation: "Gr" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Mount", abbreviation: "Mt" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Park", abbreviation: "Pk" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Valley", abbreviation: "Val" }
          ]
        },
        months: [
          { name: "January", short_name: "Jan", numeric: "01", days: 31 },
          // Not messing with leap years...
          { name: "February", short_name: "Feb", numeric: "02", days: 28 },
          { name: "March", short_name: "Mar", numeric: "03", days: 31 },
          { name: "April", short_name: "Apr", numeric: "04", days: 30 },
          { name: "May", short_name: "May", numeric: "05", days: 31 },
          { name: "June", short_name: "Jun", numeric: "06", days: 30 },
          { name: "July", short_name: "Jul", numeric: "07", days: 31 },
          { name: "August", short_name: "Aug", numeric: "08", days: 31 },
          { name: "September", short_name: "Sep", numeric: "09", days: 30 },
          { name: "October", short_name: "Oct", numeric: "10", days: 31 },
          { name: "November", short_name: "Nov", numeric: "11", days: 30 },
          { name: "December", short_name: "Dec", numeric: "12", days: 31 }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
          { name: "American Express", short_name: "amex", prefix: "34", length: 15 },
          { name: "Bankcard", short_name: "bankcard", prefix: "5610", length: 16 },
          { name: "China UnionPay", short_name: "chinaunion", prefix: "62", length: 16 },
          { name: "Diners Club Carte Blanche", short_name: "dccarte", prefix: "300", length: 14 },
          { name: "Diners Club enRoute", short_name: "dcenroute", prefix: "2014", length: 15 },
          { name: "Diners Club International", short_name: "dcintl", prefix: "36", length: 14 },
          { name: "Diners Club United States & Canada", short_name: "dcusc", prefix: "54", length: 16 },
          { name: "Discover Card", short_name: "discover", prefix: "6011", length: 16 },
          { name: "InstaPayment", short_name: "instapay", prefix: "637", length: 16 },
          { name: "JCB", short_name: "jcb", prefix: "3528", length: 16 },
          { name: "Laser", short_name: "laser", prefix: "6304", length: 16 },
          { name: "Maestro", short_name: "maestro", prefix: "5018", length: 16 },
          { name: "Mastercard", short_name: "mc", prefix: "51", length: 16 },
          { name: "Solo", short_name: "solo", prefix: "6334", length: 16 },
          { name: "Switch", short_name: "switch", prefix: "4903", length: 16 },
          { name: "Visa", short_name: "visa", prefix: "4", length: 16 },
          { name: "Visa Electron", short_name: "electron", prefix: "4026", length: 16 }
        ],
        //return all world currency by ISO 4217
        currency_types: [
          { code: "AED", name: "United Arab Emirates Dirham" },
          { code: "AFN", name: "Afghanistan Afghani" },
          { code: "ALL", name: "Albania Lek" },
          { code: "AMD", name: "Armenia Dram" },
          { code: "ANG", name: "Netherlands Antilles Guilder" },
          { code: "AOA", name: "Angola Kwanza" },
          { code: "ARS", name: "Argentina Peso" },
          { code: "AUD", name: "Australia Dollar" },
          { code: "AWG", name: "Aruba Guilder" },
          { code: "AZN", name: "Azerbaijan New Manat" },
          { code: "BAM", name: "Bosnia and Herzegovina Convertible Marka" },
          { code: "BBD", name: "Barbados Dollar" },
          { code: "BDT", name: "Bangladesh Taka" },
          { code: "BGN", name: "Bulgaria Lev" },
          { code: "BHD", name: "Bahrain Dinar" },
          { code: "BIF", name: "Burundi Franc" },
          { code: "BMD", name: "Bermuda Dollar" },
          { code: "BND", name: "Brunei Darussalam Dollar" },
          { code: "BOB", name: "Bolivia Boliviano" },
          { code: "BRL", name: "Brazil Real" },
          { code: "BSD", name: "Bahamas Dollar" },
          { code: "BTN", name: "Bhutan Ngultrum" },
          { code: "BWP", name: "Botswana Pula" },
          { code: "BYR", name: "Belarus Ruble" },
          { code: "BZD", name: "Belize Dollar" },
          { code: "CAD", name: "Canada Dollar" },
          { code: "CDF", name: "Congo/Kinshasa Franc" },
          { code: "CHF", name: "Switzerland Franc" },
          { code: "CLP", name: "Chile Peso" },
          { code: "CNY", name: "China Yuan Renminbi" },
          { code: "COP", name: "Colombia Peso" },
          { code: "CRC", name: "Costa Rica Colon" },
          { code: "CUC", name: "Cuba Convertible Peso" },
          { code: "CUP", name: "Cuba Peso" },
          { code: "CVE", name: "Cape Verde Escudo" },
          { code: "CZK", name: "Czech Republic Koruna" },
          { code: "DJF", name: "Djibouti Franc" },
          { code: "DKK", name: "Denmark Krone" },
          { code: "DOP", name: "Dominican Republic Peso" },
          { code: "DZD", name: "Algeria Dinar" },
          { code: "EGP", name: "Egypt Pound" },
          { code: "ERN", name: "Eritrea Nakfa" },
          { code: "ETB", name: "Ethiopia Birr" },
          { code: "EUR", name: "Euro Member Countries" },
          { code: "FJD", name: "Fiji Dollar" },
          { code: "FKP", name: "Falkland Islands (Malvinas) Pound" },
          { code: "GBP", name: "United Kingdom Pound" },
          { code: "GEL", name: "Georgia Lari" },
          { code: "GGP", name: "Guernsey Pound" },
          { code: "GHS", name: "Ghana Cedi" },
          { code: "GIP", name: "Gibraltar Pound" },
          { code: "GMD", name: "Gambia Dalasi" },
          { code: "GNF", name: "Guinea Franc" },
          { code: "GTQ", name: "Guatemala Quetzal" },
          { code: "GYD", name: "Guyana Dollar" },
          { code: "HKD", name: "Hong Kong Dollar" },
          { code: "HNL", name: "Honduras Lempira" },
          { code: "HRK", name: "Croatia Kuna" },
          { code: "HTG", name: "Haiti Gourde" },
          { code: "HUF", name: "Hungary Forint" },
          { code: "IDR", name: "Indonesia Rupiah" },
          { code: "ILS", name: "Israel Shekel" },
          { code: "IMP", name: "Isle of Man Pound" },
          { code: "INR", name: "India Rupee" },
          { code: "IQD", name: "Iraq Dinar" },
          { code: "IRR", name: "Iran Rial" },
          { code: "ISK", name: "Iceland Krona" },
          { code: "JEP", name: "Jersey Pound" },
          { code: "JMD", name: "Jamaica Dollar" },
          { code: "JOD", name: "Jordan Dinar" },
          { code: "JPY", name: "Japan Yen" },
          { code: "KES", name: "Kenya Shilling" },
          { code: "KGS", name: "Kyrgyzstan Som" },
          { code: "KHR", name: "Cambodia Riel" },
          { code: "KMF", name: "Comoros Franc" },
          { code: "KPW", name: "Korea (North) Won" },
          { code: "KRW", name: "Korea (South) Won" },
          { code: "KWD", name: "Kuwait Dinar" },
          { code: "KYD", name: "Cayman Islands Dollar" },
          { code: "KZT", name: "Kazakhstan Tenge" },
          { code: "LAK", name: "Laos Kip" },
          { code: "LBP", name: "Lebanon Pound" },
          { code: "LKR", name: "Sri Lanka Rupee" },
          { code: "LRD", name: "Liberia Dollar" },
          { code: "LSL", name: "Lesotho Loti" },
          { code: "LTL", name: "Lithuania Litas" },
          { code: "LYD", name: "Libya Dinar" },
          { code: "MAD", name: "Morocco Dirham" },
          { code: "MDL", name: "Moldova Leu" },
          { code: "MGA", name: "Madagascar Ariary" },
          { code: "MKD", name: "Macedonia Denar" },
          { code: "MMK", name: "Myanmar (Burma) Kyat" },
          { code: "MNT", name: "Mongolia Tughrik" },
          { code: "MOP", name: "Macau Pataca" },
          { code: "MRO", name: "Mauritania Ouguiya" },
          { code: "MUR", name: "Mauritius Rupee" },
          { code: "MVR", name: "Maldives (Maldive Islands) Rufiyaa" },
          { code: "MWK", name: "Malawi Kwacha" },
          { code: "MXN", name: "Mexico Peso" },
          { code: "MYR", name: "Malaysia Ringgit" },
          { code: "MZN", name: "Mozambique Metical" },
          { code: "NAD", name: "Namibia Dollar" },
          { code: "NGN", name: "Nigeria Naira" },
          { code: "NIO", name: "Nicaragua Cordoba" },
          { code: "NOK", name: "Norway Krone" },
          { code: "NPR", name: "Nepal Rupee" },
          { code: "NZD", name: "New Zealand Dollar" },
          { code: "OMR", name: "Oman Rial" },
          { code: "PAB", name: "Panama Balboa" },
          { code: "PEN", name: "Peru Nuevo Sol" },
          { code: "PGK", name: "Papua New Guinea Kina" },
          { code: "PHP", name: "Philippines Peso" },
          { code: "PKR", name: "Pakistan Rupee" },
          { code: "PLN", name: "Poland Zloty" },
          { code: "PYG", name: "Paraguay Guarani" },
          { code: "QAR", name: "Qatar Riyal" },
          { code: "RON", name: "Romania New Leu" },
          { code: "RSD", name: "Serbia Dinar" },
          { code: "RUB", name: "Russia Ruble" },
          { code: "RWF", name: "Rwanda Franc" },
          { code: "SAR", name: "Saudi Arabia Riyal" },
          { code: "SBD", name: "Solomon Islands Dollar" },
          { code: "SCR", name: "Seychelles Rupee" },
          { code: "SDG", name: "Sudan Pound" },
          { code: "SEK", name: "Sweden Krona" },
          { code: "SGD", name: "Singapore Dollar" },
          { code: "SHP", name: "Saint Helena Pound" },
          { code: "SLL", name: "Sierra Leone Leone" },
          { code: "SOS", name: "Somalia Shilling" },
          { code: "SPL", name: "Seborga Luigino" },
          { code: "SRD", name: "Suriname Dollar" },
          { code: "STD", name: "São Tomé and Príncipe Dobra" },
          { code: "SVC", name: "El Salvador Colon" },
          { code: "SYP", name: "Syria Pound" },
          { code: "SZL", name: "Swaziland Lilangeni" },
          { code: "THB", name: "Thailand Baht" },
          { code: "TJS", name: "Tajikistan Somoni" },
          { code: "TMT", name: "Turkmenistan Manat" },
          { code: "TND", name: "Tunisia Dinar" },
          { code: "TOP", name: "Tonga Pa'anga" },
          { code: "TRY", name: "Turkey Lira" },
          { code: "TTD", name: "Trinidad and Tobago Dollar" },
          { code: "TVD", name: "Tuvalu Dollar" },
          { code: "TWD", name: "Taiwan New Dollar" },
          { code: "TZS", name: "Tanzania Shilling" },
          { code: "UAH", name: "Ukraine Hryvnia" },
          { code: "UGX", name: "Uganda Shilling" },
          { code: "USD", name: "United States Dollar" },
          { code: "UYU", name: "Uruguay Peso" },
          { code: "UZS", name: "Uzbekistan Som" },
          { code: "VEF", name: "Venezuela Bolivar" },
          { code: "VND", name: "Viet Nam Dong" },
          { code: "VUV", name: "Vanuatu Vatu" },
          { code: "WST", name: "Samoa Tala" },
          { code: "XAF", name: "Communauté Financière Africaine (BEAC) CFA Franc BEAC" },
          { code: "XCD", name: "East Caribbean Dollar" },
          { code: "XDR", name: "International Monetary Fund (IMF) Special Drawing Rights" },
          { code: "XOF", name: "Communauté Financière Africaine (BCEAO) Franc" },
          { code: "XPF", name: "Comptoirs Français du Pacifique (CFP) Franc" },
          { code: "YER", name: "Yemen Rial" },
          { code: "ZAR", name: "South Africa Rand" },
          { code: "ZMW", name: "Zambia Kwacha" },
          { code: "ZWD", name: "Zimbabwe Dollar" }
        ],
        // return the names of all valide colors
        colorNames: [
          "AliceBlue",
          "Black",
          "Navy",
          "DarkBlue",
          "MediumBlue",
          "Blue",
          "DarkGreen",
          "Green",
          "Teal",
          "DarkCyan",
          "DeepSkyBlue",
          "DarkTurquoise",
          "MediumSpringGreen",
          "Lime",
          "SpringGreen",
          "Aqua",
          "Cyan",
          "MidnightBlue",
          "DodgerBlue",
          "LightSeaGreen",
          "ForestGreen",
          "SeaGreen",
          "DarkSlateGray",
          "LimeGreen",
          "MediumSeaGreen",
          "Turquoise",
          "RoyalBlue",
          "SteelBlue",
          "DarkSlateBlue",
          "MediumTurquoise",
          "Indigo",
          "DarkOliveGreen",
          "CadetBlue",
          "CornflowerBlue",
          "RebeccaPurple",
          "MediumAquaMarine",
          "DimGray",
          "SlateBlue",
          "OliveDrab",
          "SlateGray",
          "LightSlateGray",
          "MediumSlateBlue",
          "LawnGreen",
          "Chartreuse",
          "Aquamarine",
          "Maroon",
          "Purple",
          "Olive",
          "Gray",
          "SkyBlue",
          "LightSkyBlue",
          "BlueViolet",
          "DarkRed",
          "DarkMagenta",
          "SaddleBrown",
          "Ivory",
          "White",
          "DarkSeaGreen",
          "LightGreen",
          "MediumPurple",
          "DarkViolet",
          "PaleGreen",
          "DarkOrchid",
          "YellowGreen",
          "Sienna",
          "Brown",
          "DarkGray",
          "LightBlue",
          "GreenYellow",
          "PaleTurquoise",
          "LightSteelBlue",
          "PowderBlue",
          "FireBrick",
          "DarkGoldenRod",
          "MediumOrchid",
          "RosyBrown",
          "DarkKhaki",
          "Silver",
          "MediumVioletRed",
          "IndianRed",
          "Peru",
          "Chocolate",
          "Tan",
          "LightGray",
          "Thistle",
          "Orchid",
          "GoldenRod",
          "PaleVioletRed",
          "Crimson",
          "Gainsboro",
          "Plum",
          "BurlyWood",
          "LightCyan",
          "Lavender",
          "DarkSalmon",
          "Violet",
          "PaleGoldenRod",
          "LightCoral",
          "Khaki",
          "AliceBlue",
          "HoneyDew",
          "Azure",
          "SandyBrown",
          "Wheat",
          "Beige",
          "WhiteSmoke",
          "MintCream",
          "GhostWhite",
          "Salmon",
          "AntiqueWhite",
          "Linen",
          "LightGoldenRodYellow",
          "OldLace",
          "Red",
          "Fuchsia",
          "Magenta",
          "DeepPink",
          "OrangeRed",
          "Tomato",
          "HotPink",
          "Coral",
          "DarkOrange",
          "LightSalmon",
          "Orange",
          "LightPink",
          "Pink",
          "Gold",
          "PeachPuff",
          "NavajoWhite",
          "Moccasin",
          "Bisque",
          "MistyRose",
          "BlanchedAlmond",
          "PapayaWhip",
          "LavenderBlush",
          "SeaShell",
          "Cornsilk",
          "LemonChiffon",
          "FloralWhite",
          "Snow",
          "Yellow",
          "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
          "3Com Corp",
          "3M Company",
          "A.G. Edwards Inc.",
          "Abbott Laboratories",
          "Abercrombie & Fitch Co.",
          "ABM Industries Incorporated",
          "Ace Hardware Corporation",
          "ACT Manufacturing Inc.",
          "Acterna Corp.",
          "Adams Resources & Energy, Inc.",
          "ADC Telecommunications, Inc.",
          "Adelphia Communications Corporation",
          "Administaff, Inc.",
          "Adobe Systems Incorporated",
          "Adolph Coors Company",
          "Advance Auto Parts, Inc.",
          "Advanced Micro Devices, Inc.",
          "AdvancePCS, Inc.",
          "Advantica Restaurant Group, Inc.",
          "The AES Corporation",
          "Aetna Inc.",
          "Affiliated Computer Services, Inc.",
          "AFLAC Incorporated",
          "AGCO Corporation",
          "Agilent Technologies, Inc.",
          "Agway Inc.",
          "Apartment Investment and Management Company",
          "Air Products and Chemicals, Inc.",
          "Airborne, Inc.",
          "Airgas, Inc.",
          "AK Steel Holding Corporation",
          "Alaska Air Group, Inc.",
          "Alberto-Culver Company",
          "Albertson's, Inc.",
          "Alcoa Inc.",
          "Alleghany Corporation",
          "Allegheny Energy, Inc.",
          "Allegheny Technologies Incorporated",
          "Allergan, Inc.",
          "ALLETE, Inc.",
          "Alliant Energy Corporation",
          "Allied Waste Industries, Inc.",
          "Allmerica Financial Corporation",
          "The Allstate Corporation",
          "ALLTEL Corporation",
          "The Alpine Group, Inc.",
          "Amazon.com, Inc.",
          "AMC Entertainment Inc.",
          "American Power Conversion Corporation",
          "Amerada Hess Corporation",
          "AMERCO",
          "Ameren Corporation",
          "America West Holdings Corporation",
          "American Axle & Manufacturing Holdings, Inc.",
          "American Eagle Outfitters, Inc.",
          "American Electric Power Company, Inc.",
          "American Express Company",
          "American Financial Group, Inc.",
          "American Greetings Corporation",
          "American International Group, Inc.",
          "American Standard Companies Inc.",
          "American Water Works Company, Inc.",
          "AmerisourceBergen Corporation",
          "Ames Department Stores, Inc.",
          "Amgen Inc.",
          "Amkor Technology, Inc.",
          "AMR Corporation",
          "AmSouth Bancorp.",
          "Amtran, Inc.",
          "Anadarko Petroleum Corporation",
          "Analog Devices, Inc.",
          "Anheuser-Busch Companies, Inc.",
          "Anixter International Inc.",
          "AnnTaylor Inc.",
          "Anthem, Inc.",
          "AOL Time Warner Inc.",
          "Aon Corporation",
          "Apache Corporation",
          "Apple Computer, Inc.",
          "Applera Corporation",
          "Applied Industrial Technologies, Inc.",
          "Applied Materials, Inc.",
          "Aquila, Inc.",
          "ARAMARK Corporation",
          "Arch Coal, Inc.",
          "Archer Daniels Midland Company",
          "Arkansas Best Corporation",
          "Armstrong Holdings, Inc.",
          "Arrow Electronics, Inc.",
          "ArvinMeritor, Inc.",
          "Ashland Inc.",
          "Astoria Financial Corporation",
          "AT&T Corp.",
          "Atmel Corporation",
          "Atmos Energy Corporation",
          "Audiovox Corporation",
          "Autoliv, Inc.",
          "Automatic Data Processing, Inc.",
          "AutoNation, Inc.",
          "AutoZone, Inc.",
          "Avaya Inc.",
          "Avery Dennison Corporation",
          "Avista Corporation",
          "Avnet, Inc.",
          "Avon Products, Inc.",
          "Baker Hughes Incorporated",
          "Ball Corporation",
          "Bank of America Corporation",
          "The Bank of New York Company, Inc.",
          "Bank One Corporation",
          "Banknorth Group, Inc.",
          "Banta Corporation",
          "Barnes & Noble, Inc.",
          "Bausch & Lomb Incorporated",
          "Baxter International Inc.",
          "BB&T Corporation",
          "The Bear Stearns Companies Inc.",
          "Beazer Homes USA, Inc.",
          "Beckman Coulter, Inc.",
          "Becton, Dickinson and Company",
          "Bed Bath & Beyond Inc.",
          "Belk, Inc.",
          "Bell Microproducts Inc.",
          "BellSouth Corporation",
          "Belo Corp.",
          "Bemis Company, Inc.",
          "Benchmark Electronics, Inc.",
          "Berkshire Hathaway Inc.",
          "Best Buy Co., Inc.",
          "Bethlehem Steel Corporation",
          "Beverly Enterprises, Inc.",
          "Big Lots, Inc.",
          "BJ Services Company",
          "BJ's Wholesale Club, Inc.",
          "The Black & Decker Corporation",
          "Black Hills Corporation",
          "BMC Software, Inc.",
          "The Boeing Company",
          "Boise Cascade Corporation",
          "Borders Group, Inc.",
          "BorgWarner Inc.",
          "Boston Scientific Corporation",
          "Bowater Incorporated",
          "Briggs & Stratton Corporation",
          "Brightpoint, Inc.",
          "Brinker International, Inc.",
          "Bristol-Myers Squibb Company",
          "Broadwing, Inc.",
          "Brown Shoe Company, Inc.",
          "Brown-Forman Corporation",
          "Brunswick Corporation",
          "Budget Group, Inc.",
          "Burlington Coat Factory Warehouse Corporation",
          "Burlington Industries, Inc.",
          "Burlington Northern Santa Fe Corporation",
          "Burlington Resources Inc.",
          "C. H. Robinson Worldwide Inc.",
          "Cablevision Systems Corp",
          "Cabot Corp",
          "Cadence Design Systems, Inc.",
          "Calpine Corp.",
          "Campbell Soup Co.",
          "Capital One Financial Corp.",
          "Cardinal Health Inc.",
          "Caremark Rx Inc.",
          "Carlisle Cos. Inc.",
          "Carpenter Technology Corp.",
          "Casey's General Stores Inc.",
          "Caterpillar Inc.",
          "CBRL Group Inc.",
          "CDI Corp.",
          "CDW Computer Centers Inc.",
          "CellStar Corp.",
          "Cendant Corp",
          "Cenex Harvest States Cooperatives",
          "Centex Corp.",
          "CenturyTel Inc.",
          "Ceridian Corp.",
          "CH2M Hill Cos. Ltd.",
          "Champion Enterprises Inc.",
          "Charles Schwab Corp.",
          "Charming Shoppes Inc.",
          "Charter Communications Inc.",
          "Charter One Financial Inc.",
          "ChevronTexaco Corp.",
          "Chiquita Brands International Inc.",
          "Chubb Corp",
          "Ciena Corp.",
          "Cigna Corp",
          "Cincinnati Financial Corp.",
          "Cinergy Corp.",
          "Cintas Corp.",
          "Circuit City Stores Inc.",
          "Cisco Systems Inc.",
          "Citigroup, Inc",
          "Citizens Communications Co.",
          "CKE Restaurants Inc.",
          "Clear Channel Communications Inc.",
          "The Clorox Co.",
          "CMGI Inc.",
          "CMS Energy Corp.",
          "CNF Inc.",
          "Coca-Cola Co.",
          "Coca-Cola Enterprises Inc.",
          "Colgate-Palmolive Co.",
          "Collins & Aikman Corp.",
          "Comcast Corp.",
          "Comdisco Inc.",
          "Comerica Inc.",
          "Comfort Systems USA Inc.",
          "Commercial Metals Co.",
          "Community Health Systems Inc.",
          "Compass Bancshares Inc",
          "Computer Associates International Inc.",
          "Computer Sciences Corp.",
          "Compuware Corp.",
          "Comverse Technology Inc.",
          "ConAgra Foods Inc.",
          "Concord EFS Inc.",
          "Conectiv, Inc",
          "Conoco Inc",
          "Conseco Inc.",
          "Consolidated Freightways Corp.",
          "Consolidated Edison Inc.",
          "Constellation Brands Inc.",
          "Constellation Emergy Group Inc.",
          "Continental Airlines Inc.",
          "Convergys Corp.",
          "Cooper Cameron Corp.",
          "Cooper Industries Ltd.",
          "Cooper Tire & Rubber Co.",
          "Corn Products International Inc.",
          "Corning Inc.",
          "Costco Wholesale Corp.",
          "Countrywide Credit Industries Inc.",
          "Coventry Health Care Inc.",
          "Cox Communications Inc.",
          "Crane Co.",
          "Crompton Corp.",
          "Crown Cork & Seal Co. Inc.",
          "CSK Auto Corp.",
          "CSX Corp.",
          "Cummins Inc.",
          "CVS Corp.",
          "Cytec Industries Inc.",
          "D&K Healthcare Resources, Inc.",
          "D.R. Horton Inc.",
          "Dana Corporation",
          "Danaher Corporation",
          "Darden Restaurants Inc.",
          "DaVita Inc.",
          "Dean Foods Company",
          "Deere & Company",
          "Del Monte Foods Co",
          "Dell Computer Corporation",
          "Delphi Corp.",
          "Delta Air Lines Inc.",
          "Deluxe Corporation",
          "Devon Energy Corporation",
          "Di Giorgio Corporation",
          "Dial Corporation",
          "Diebold Incorporated",
          "Dillard's Inc.",
          "DIMON Incorporated",
          "Dole Food Company, Inc.",
          "Dollar General Corporation",
          "Dollar Tree Stores, Inc.",
          "Dominion Resources, Inc.",
          "Domino's Pizza LLC",
          "Dover Corporation, Inc.",
          "Dow Chemical Company",
          "Dow Jones & Company, Inc.",
          "DPL Inc.",
          "DQE Inc.",
          "Dreyer's Grand Ice Cream, Inc.",
          "DST Systems, Inc.",
          "DTE Energy Co.",
          "E.I. Du Pont de Nemours and Company",
          "Duke Energy Corp",
          "Dun & Bradstreet Inc.",
          "DURA Automotive Systems Inc.",
          "DynCorp",
          "Dynegy Inc.",
          "E*Trade Group, Inc.",
          "E.W. Scripps Company",
          "Earthlink, Inc.",
          "Eastman Chemical Company",
          "Eastman Kodak Company",
          "Eaton Corporation",
          "Echostar Communications Corporation",
          "Ecolab Inc.",
          "Edison International",
          "EGL Inc.",
          "El Paso Corporation",
          "Electronic Arts Inc.",
          "Electronic Data Systems Corp.",
          "Eli Lilly and Company",
          "EMC Corporation",
          "Emcor Group Inc.",
          "Emerson Electric Co.",
          "Encompass Services Corporation",
          "Energizer Holdings Inc.",
          "Energy East Corporation",
          "Engelhard Corporation",
          "Enron Corp.",
          "Entergy Corporation",
          "Enterprise Products Partners L.P.",
          "EOG Resources, Inc.",
          "Equifax Inc.",
          "Equitable Resources Inc.",
          "Equity Office Properties Trust",
          "Equity Residential Properties Trust",
          "Estee Lauder Companies Inc.",
          "Exelon Corporation",
          "Exide Technologies",
          "Expeditors International of Washington Inc.",
          "Express Scripts Inc.",
          "ExxonMobil Corporation",
          "Fairchild Semiconductor International Inc.",
          "Family Dollar Stores Inc.",
          "Farmland Industries Inc.",
          "Federal Mogul Corp.",
          "Federated Department Stores Inc.",
          "Federal Express Corp.",
          "Felcor Lodging Trust Inc.",
          "Ferro Corp.",
          "Fidelity National Financial Inc.",
          "Fifth Third Bancorp",
          "First American Financial Corp.",
          "First Data Corp.",
          "First National of Nebraska Inc.",
          "First Tennessee National Corp.",
          "FirstEnergy Corp.",
          "Fiserv Inc.",
          "Fisher Scientific International Inc.",
          "FleetBoston Financial Co.",
          "Fleetwood Enterprises Inc.",
          "Fleming Companies Inc.",
          "Flowers Foods Inc.",
          "Flowserv Corp",
          "Fluor Corp",
          "FMC Corp",
          "Foamex International Inc",
          "Foot Locker Inc",
          "Footstar Inc.",
          "Ford Motor Co",
          "Forest Laboratories Inc.",
          "Fortune Brands Inc.",
          "Foster Wheeler Ltd.",
          "FPL Group Inc.",
          "Franklin Resources Inc.",
          "Freeport McMoran Copper & Gold Inc.",
          "Frontier Oil Corp",
          "Furniture Brands International Inc.",
          "Gannett Co., Inc.",
          "Gap Inc.",
          "Gateway Inc.",
          "GATX Corporation",
          "Gemstar-TV Guide International Inc.",
          "GenCorp Inc.",
          "General Cable Corporation",
          "General Dynamics Corporation",
          "General Electric Company",
          "General Mills Inc",
          "General Motors Corporation",
          "Genesis Health Ventures Inc.",
          "Gentek Inc.",
          "Gentiva Health Services Inc.",
          "Genuine Parts Company",
          "Genuity Inc.",
          "Genzyme Corporation",
          "Georgia Gulf Corporation",
          "Georgia-Pacific Corporation",
          "Gillette Company",
          "Gold Kist Inc.",
          "Golden State Bancorp Inc.",
          "Golden West Financial Corporation",
          "Goldman Sachs Group Inc.",
          "Goodrich Corporation",
          "The Goodyear Tire & Rubber Company",
          "Granite Construction Incorporated",
          "Graybar Electric Company Inc.",
          "Great Lakes Chemical Corporation",
          "Great Plains Energy Inc.",
          "GreenPoint Financial Corp.",
          "Greif Bros. Corporation",
          "Grey Global Group Inc.",
          "Group 1 Automotive Inc.",
          "Guidant Corporation",
          "H&R Block Inc.",
          "H.B. Fuller Company",
          "H.J. Heinz Company",
          "Halliburton Co.",
          "Harley-Davidson Inc.",
          "Harman International Industries Inc.",
          "Harrah's Entertainment Inc.",
          "Harris Corp.",
          "Harsco Corp.",
          "Hartford Financial Services Group Inc.",
          "Hasbro Inc.",
          "Hawaiian Electric Industries Inc.",
          "HCA Inc.",
          "Health Management Associates Inc.",
          "Health Net Inc.",
          "Healthsouth Corp",
          "Henry Schein Inc.",
          "Hercules Inc.",
          "Herman Miller Inc.",
          "Hershey Foods Corp.",
          "Hewlett-Packard Company",
          "Hibernia Corp.",
          "Hillenbrand Industries Inc.",
          "Hilton Hotels Corp.",
          "Hollywood Entertainment Corp.",
          "Home Depot Inc.",
          "Hon Industries Inc.",
          "Honeywell International Inc.",
          "Hormel Foods Corp.",
          "Host Marriott Corp.",
          "Household International Corp.",
          "Hovnanian Enterprises Inc.",
          "Hub Group Inc.",
          "Hubbell Inc.",
          "Hughes Supply Inc.",
          "Humana Inc.",
          "Huntington Bancshares Inc.",
          "Idacorp Inc.",
          "IDT Corporation",
          "IKON Office Solutions Inc.",
          "Illinois Tool Works Inc.",
          "IMC Global Inc.",
          "Imperial Sugar Company",
          "IMS Health Inc.",
          "Ingles Market Inc",
          "Ingram Micro Inc.",
          "Insight Enterprises Inc.",
          "Integrated Electrical Services Inc.",
          "Intel Corporation",
          "International Paper Co.",
          "Interpublic Group of Companies Inc.",
          "Interstate Bakeries Corporation",
          "International Business Machines Corp.",
          "International Flavors & Fragrances Inc.",
          "International Multifoods Corporation",
          "Intuit Inc.",
          "IT Group Inc.",
          "ITT Industries Inc.",
          "Ivax Corp.",
          "J.B. Hunt Transport Services Inc.",
          "J.C. Penny Co.",
          "J.P. Morgan Chase & Co.",
          "Jabil Circuit Inc.",
          "Jack In The Box Inc.",
          "Jacobs Engineering Group Inc.",
          "JDS Uniphase Corp.",
          "Jefferson-Pilot Co.",
          "John Hancock Financial Services Inc.",
          "Johnson & Johnson",
          "Johnson Controls Inc.",
          "Jones Apparel Group Inc.",
          "KB Home",
          "Kellogg Company",
          "Kellwood Company",
          "Kelly Services Inc.",
          "Kemet Corp.",
          "Kennametal Inc.",
          "Kerr-McGee Corporation",
          "KeyCorp",
          "KeySpan Corp.",
          "Kimball International Inc.",
          "Kimberly-Clark Corporation",
          "Kindred Healthcare Inc.",
          "KLA-Tencor Corporation",
          "K-Mart Corp.",
          "Knight-Ridder Inc.",
          "Kohl's Corp.",
          "KPMG Consulting Inc.",
          "Kroger Co.",
          "L-3 Communications Holdings Inc.",
          "Laboratory Corporation of America Holdings",
          "Lam Research Corporation",
          "LandAmerica Financial Group Inc.",
          "Lands' End Inc.",
          "Landstar System Inc.",
          "La-Z-Boy Inc.",
          "Lear Corporation",
          "Legg Mason Inc.",
          "Leggett & Platt Inc.",
          "Lehman Brothers Holdings Inc.",
          "Lennar Corporation",
          "Lennox International Inc.",
          "Level 3 Communications Inc.",
          "Levi Strauss & Co.",
          "Lexmark International Inc.",
          "Limited Inc.",
          "Lincoln National Corporation",
          "Linens 'n Things Inc.",
          "Lithia Motors Inc.",
          "Liz Claiborne Inc.",
          "Lockheed Martin Corporation",
          "Loews Corporation",
          "Longs Drug Stores Corporation",
          "Louisiana-Pacific Corporation",
          "Lowe's Companies Inc.",
          "LSI Logic Corporation",
          "The LTV Corporation",
          "The Lubrizol Corporation",
          "Lucent Technologies Inc.",
          "Lyondell Chemical Company",
          "M & T Bank Corporation",
          "Magellan Health Services Inc.",
          "Mail-Well Inc.",
          "Mandalay Resort Group",
          "Manor Care Inc.",
          "Manpower Inc.",
          "Marathon Oil Corporation",
          "Mariner Health Care Inc.",
          "Markel Corporation",
          "Marriott International Inc.",
          "Marsh & McLennan Companies Inc.",
          "Marsh Supermarkets Inc.",
          "Marshall & Ilsley Corporation",
          "Martin Marietta Materials Inc.",
          "Masco Corporation",
          "Massey Energy Company",
          "MasTec Inc.",
          "Mattel Inc.",
          "Maxim Integrated Products Inc.",
          "Maxtor Corporation",
          "Maxxam Inc.",
          "The May Department Stores Company",
          "Maytag Corporation",
          "MBNA Corporation",
          "McCormick & Company Incorporated",
          "McDonald's Corporation",
          "The McGraw-Hill Companies Inc.",
          "McKesson Corporation",
          "McLeodUSA Incorporated",
          "M.D.C. Holdings Inc.",
          "MDU Resources Group Inc.",
          "MeadWestvaco Corporation",
          "Medtronic Inc.",
          "Mellon Financial Corporation",
          "The Men's Wearhouse Inc.",
          "Merck & Co., Inc.",
          "Mercury General Corporation",
          "Merrill Lynch & Co. Inc.",
          "Metaldyne Corporation",
          "Metals USA Inc.",
          "MetLife Inc.",
          "Metris Companies Inc",
          "MGIC Investment Corporation",
          "MGM Mirage",
          "Michaels Stores Inc.",
          "Micron Technology Inc.",
          "Microsoft Corporation",
          "Milacron Inc.",
          "Millennium Chemicals Inc.",
          "Mirant Corporation",
          "Mohawk Industries Inc.",
          "Molex Incorporated",
          "The MONY Group Inc.",
          "Morgan Stanley Dean Witter & Co.",
          "Motorola Inc.",
          "MPS Group Inc.",
          "Murphy Oil Corporation",
          "Nabors Industries Inc",
          "Nacco Industries Inc",
          "Nash Finch Company",
          "National City Corp.",
          "National Commerce Financial Corporation",
          "National Fuel Gas Company",
          "National Oilwell Inc",
          "National Rural Utilities Cooperative Finance Corporation",
          "National Semiconductor Corporation",
          "National Service Industries Inc",
          "Navistar International Corporation",
          "NCR Corporation",
          "The Neiman Marcus Group Inc.",
          "New Jersey Resources Corporation",
          "New York Times Company",
          "Newell Rubbermaid Inc",
          "Newmont Mining Corporation",
          "Nextel Communications Inc",
          "Nicor Inc",
          "Nike Inc",
          "NiSource Inc",
          "Noble Energy Inc",
          "Nordstrom Inc",
          "Norfolk Southern Corporation",
          "Nortek Inc",
          "North Fork Bancorporation Inc",
          "Northeast Utilities System",
          "Northern Trust Corporation",
          "Northrop Grumman Corporation",
          "NorthWestern Corporation",
          "Novellus Systems Inc",
          "NSTAR",
          "NTL Incorporated",
          "Nucor Corp",
          "Nvidia Corp",
          "NVR Inc",
          "Northwest Airlines Corp",
          "Occidental Petroleum Corp",
          "Ocean Energy Inc",
          "Office Depot Inc.",
          "OfficeMax Inc",
          "OGE Energy Corp",
          "Oglethorpe Power Corp.",
          "Ohio Casualty Corp.",
          "Old Republic International Corp.",
          "Olin Corp.",
          "OM Group Inc",
          "Omnicare Inc",
          "Omnicom Group",
          "On Semiconductor Corp",
          "ONEOK Inc",
          "Oracle Corp",
          "Oshkosh Truck Corp",
          "Outback Steakhouse Inc.",
          "Owens & Minor Inc.",
          "Owens Corning",
          "Owens-Illinois Inc",
          "Oxford Health Plans Inc",
          "Paccar Inc",
          "PacifiCare Health Systems Inc",
          "Packaging Corp. of America",
          "Pactiv Corp",
          "Pall Corp",
          "Pantry Inc",
          "Park Place Entertainment Corp",
          "Parker Hannifin Corp.",
          "Pathmark Stores Inc.",
          "Paychex Inc",
          "Payless Shoesource Inc",
          "Penn Traffic Co.",
          "Pennzoil-Quaker State Company",
          "Pentair Inc",
          "Peoples Energy Corp.",
          "PeopleSoft Inc",
          "Pep Boys Manny, Moe & Jack",
          "Potomac Electric Power Co.",
          "Pepsi Bottling Group Inc.",
          "PepsiAmericas Inc.",
          "PepsiCo Inc.",
          "Performance Food Group Co.",
          "Perini Corp",
          "PerkinElmer Inc",
          "Perot Systems Corp",
          "Petco Animal Supplies Inc.",
          "Peter Kiewit Sons', Inc.",
          "PETsMART Inc",
          "Pfizer Inc",
          "Pacific Gas & Electric Corp.",
          "Pharmacia Corp",
          "Phar Mor Inc.",
          "Phelps Dodge Corp.",
          "Philip Morris Companies Inc.",
          "Phillips Petroleum Co",
          "Phillips Van Heusen Corp.",
          "Phoenix Companies Inc",
          "Pier 1 Imports Inc.",
          "Pilgrim's Pride Corporation",
          "Pinnacle West Capital Corp",
          "Pioneer-Standard Electronics Inc.",
          "Pitney Bowes Inc.",
          "Pittston Brinks Group",
          "Plains All American Pipeline LP",
          "PNC Financial Services Group Inc.",
          "PNM Resources Inc",
          "Polaris Industries Inc.",
          "Polo Ralph Lauren Corp",
          "PolyOne Corp",
          "Popular Inc",
          "Potlatch Corp",
          "PPG Industries Inc",
          "PPL Corp",
          "Praxair Inc",
          "Precision Castparts Corp",
          "Premcor Inc.",
          "Pride International Inc",
          "Primedia Inc",
          "Principal Financial Group Inc.",
          "Procter & Gamble Co.",
          "Pro-Fac Cooperative Inc.",
          "Progress Energy Inc",
          "Progressive Corporation",
          "Protective Life Corp",
          "Provident Financial Group",
          "Providian Financial Corp.",
          "Prudential Financial Inc.",
          "PSS World Medical Inc",
          "Public Service Enterprise Group Inc.",
          "Publix Super Markets Inc.",
          "Puget Energy Inc.",
          "Pulte Homes Inc",
          "Qualcomm Inc",
          "Quanta Services Inc.",
          "Quantum Corp",
          "Quest Diagnostics Inc.",
          "Questar Corp",
          "Quintiles Transnational",
          "Qwest Communications Intl Inc",
          "R.J. Reynolds Tobacco Company",
          "R.R. Donnelley & Sons Company",
          "Radio Shack Corporation",
          "Raymond James Financial Inc.",
          "Raytheon Company",
          "Reader's Digest Association Inc.",
          "Reebok International Ltd.",
          "Regions Financial Corp.",
          "Regis Corporation",
          "Reliance Steel & Aluminum Co.",
          "Reliant Energy Inc.",
          "Rent A Center Inc",
          "Republic Services Inc",
          "Revlon Inc",
          "RGS Energy Group Inc",
          "Rite Aid Corp",
          "Riverwood Holding Inc.",
          "RoadwayCorp",
          "Robert Half International Inc.",
          "Rock-Tenn Co",
          "Rockwell Automation Inc",
          "Rockwell Collins Inc",
          "Rohm & Haas Co.",
          "Ross Stores Inc",
          "RPM Inc.",
          "Ruddick Corp",
          "Ryder System Inc",
          "Ryerson Tull Inc",
          "Ryland Group Inc.",
          "Sabre Holdings Corp",
          "Safeco Corp",
          "Safeguard Scientifics Inc.",
          "Safeway Inc",
          "Saks Inc",
          "Sanmina-SCI Inc",
          "Sara Lee Corp",
          "SBC Communications Inc",
          "Scana Corp.",
          "Schering-Plough Corp",
          "Scholastic Corp",
          "SCI Systems Onc.",
          "Science Applications Intl. Inc.",
          "Scientific-Atlanta Inc",
          "Scotts Company",
          "Seaboard Corp",
          "Sealed Air Corp",
          "Sears Roebuck & Co",
          "Sempra Energy",
          "Sequa Corp",
          "Service Corp. International",
          "ServiceMaster Co",
          "Shaw Group Inc",
          "Sherwin-Williams Company",
          "Shopko Stores Inc",
          "Siebel Systems Inc",
          "Sierra Health Services Inc",
          "Sierra Pacific Resources",
          "Silgan Holdings Inc.",
          "Silicon Graphics Inc",
          "Simon Property Group Inc",
          "SLM Corporation",
          "Smith International Inc",
          "Smithfield Foods Inc",
          "Smurfit-Stone Container Corp",
          "Snap-On Inc",
          "Solectron Corp",
          "Solutia Inc",
          "Sonic Automotive Inc.",
          "Sonoco Products Co.",
          "Southern Company",
          "Southern Union Company",
          "SouthTrust Corp.",
          "Southwest Airlines Co",
          "Southwest Gas Corp",
          "Sovereign Bancorp Inc.",
          "Spartan Stores Inc",
          "Spherion Corp",
          "Sports Authority Inc",
          "Sprint Corp.",
          "SPX Corp",
          "St. Jude Medical Inc",
          "St. Paul Cos.",
          "Staff Leasing Inc.",
          "StanCorp Financial Group Inc",
          "Standard Pacific Corp.",
          "Stanley Works",
          "Staples Inc",
          "Starbucks Corp",
          "Starwood Hotels & Resorts Worldwide Inc",
          "State Street Corp.",
          "Stater Bros. Holdings Inc.",
          "Steelcase Inc",
          "Stein Mart Inc",
          "Stewart & Stevenson Services Inc",
          "Stewart Information Services Corp",
          "Stilwell Financial Inc",
          "Storage Technology Corporation",
          "Stryker Corp",
          "Sun Healthcare Group Inc.",
          "Sun Microsystems Inc.",
          "SunGard Data Systems Inc.",
          "Sunoco Inc.",
          "SunTrust Banks Inc",
          "Supervalu Inc",
          "Swift Transportation, Co., Inc",
          "Symbol Technologies Inc",
          "Synovus Financial Corp.",
          "Sysco Corp",
          "Systemax Inc.",
          "Target Corp.",
          "Tech Data Corporation",
          "TECO Energy Inc",
          "Tecumseh Products Company",
          "Tektronix Inc",
          "Teleflex Incorporated",
          "Telephone & Data Systems Inc",
          "Tellabs Inc.",
          "Temple-Inland Inc",
          "Tenet Healthcare Corporation",
          "Tenneco Automotive Inc.",
          "Teradyne Inc",
          "Terex Corp",
          "Tesoro Petroleum Corp.",
          "Texas Industries Inc.",
          "Texas Instruments Incorporated",
          "Textron Inc",
          "Thermo Electron Corporation",
          "Thomas & Betts Corporation",
          "Tiffany & Co",
          "Timken Company",
          "TJX Companies Inc",
          "TMP Worldwide Inc",
          "Toll Brothers Inc",
          "Torchmark Corporation",
          "Toro Company",
          "Tower Automotive Inc.",
          "Toys 'R' Us Inc",
          "Trans World Entertainment Corp.",
          "TransMontaigne Inc",
          "Transocean Inc",
          "TravelCenters of America Inc.",
          "Triad Hospitals Inc",
          "Tribune Company",
          "Trigon Healthcare Inc.",
          "Trinity Industries Inc",
          "Trump Hotels & Casino Resorts Inc.",
          "TruServ Corporation",
          "TRW Inc",
          "TXU Corp",
          "Tyson Foods Inc",
          "U.S. Bancorp",
          "U.S. Industries Inc.",
          "UAL Corporation",
          "UGI Corporation",
          "Unified Western Grocers Inc",
          "Union Pacific Corporation",
          "Union Planters Corp",
          "Unisource Energy Corp",
          "Unisys Corporation",
          "United Auto Group Inc",
          "United Defense Industries Inc.",
          "United Parcel Service Inc",
          "United Rentals Inc",
          "United Stationers Inc",
          "United Technologies Corporation",
          "UnitedHealth Group Incorporated",
          "Unitrin Inc",
          "Universal Corporation",
          "Universal Forest Products Inc",
          "Universal Health Services Inc",
          "Unocal Corporation",
          "Unova Inc",
          "UnumProvident Corporation",
          "URS Corporation",
          "US Airways Group Inc",
          "US Oncology Inc",
          "USA Interactive",
          "USFreighways Corporation",
          "USG Corporation",
          "UST Inc",
          "Valero Energy Corporation",
          "Valspar Corporation",
          "Value City Department Stores Inc",
          "Varco International Inc",
          "Vectren Corporation",
          "Veritas Software Corporation",
          "Verizon Communications Inc",
          "VF Corporation",
          "Viacom Inc",
          "Viad Corp",
          "Viasystems Group Inc",
          "Vishay Intertechnology Inc",
          "Visteon Corporation",
          "Volt Information Sciences Inc",
          "Vulcan Materials Company",
          "W.R. Berkley Corporation",
          "W.R. Grace & Co",
          "W.W. Grainger Inc",
          "Wachovia Corporation",
          "Wakenhut Corporation",
          "Walgreen Co",
          "Wallace Computer Services Inc",
          "Wal-Mart Stores Inc",
          "Walt Disney Co",
          "Walter Industries Inc",
          "Washington Mutual Inc",
          "Washington Post Co.",
          "Waste Management Inc",
          "Watsco Inc",
          "Weatherford International Inc",
          "Weis Markets Inc.",
          "Wellpoint Health Networks Inc",
          "Wells Fargo & Company",
          "Wendy's International Inc",
          "Werner Enterprises Inc",
          "WESCO International Inc",
          "Western Digital Inc",
          "Western Gas Resources Inc",
          "WestPoint Stevens Inc",
          "Weyerhauser Company",
          "WGL Holdings Inc",
          "Whirlpool Corporation",
          "Whole Foods Market Inc",
          "Willamette Industries Inc.",
          "Williams Companies Inc",
          "Williams Sonoma Inc",
          "Winn Dixie Stores Inc",
          "Wisconsin Energy Corporation",
          "Wm Wrigley Jr Company",
          "World Fuel Services Corporation",
          "WorldCom Inc",
          "Worthington Industries Inc",
          "WPS Resources Corporation",
          "Wyeth",
          "Wyndham International Inc",
          "Xcel Energy Inc",
          "Xerox Corp",
          "Xilinx Inc",
          "XO Communications Inc",
          "Yellow Corporation",
          "York International Corp",
          "Yum Brands Inc.",
          "Zale Corporation",
          "Zions Bancorporation"
        ],
        fileExtension: {
          raster: ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
          vector: ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
          "3d": ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
          document: ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
          {
            name: "Dateline Standard Time",
            abbr: "DST",
            offset: -12,
            isdst: !1,
            text: "(UTC-12:00) International Date Line West",
            utc: [
              "Etc/GMT+12"
            ]
          },
          {
            name: "UTC-11",
            abbr: "U",
            offset: -11,
            isdst: !1,
            text: "(UTC-11:00) Coordinated Universal Time-11",
            utc: [
              "Etc/GMT+11",
              "Pacific/Midway",
              "Pacific/Niue",
              "Pacific/Pago_Pago"
            ]
          },
          {
            name: "Hawaiian Standard Time",
            abbr: "HST",
            offset: -10,
            isdst: !1,
            text: "(UTC-10:00) Hawaii",
            utc: [
              "Etc/GMT+10",
              "Pacific/Honolulu",
              "Pacific/Johnston",
              "Pacific/Rarotonga",
              "Pacific/Tahiti"
            ]
          },
          {
            name: "Alaskan Standard Time",
            abbr: "AKDT",
            offset: -8,
            isdst: !0,
            text: "(UTC-09:00) Alaska",
            utc: [
              "America/Anchorage",
              "America/Juneau",
              "America/Nome",
              "America/Sitka",
              "America/Yakutat"
            ]
          },
          {
            name: "Pacific Standard Time (Mexico)",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-08:00) Baja California",
            utc: [
              "America/Santa_Isabel"
            ]
          },
          {
            name: "Pacific Daylight Time",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-07:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse"
            ]
          },
          {
            name: "Pacific Standard Time",
            abbr: "PST",
            offset: -8,
            isdst: !1,
            text: "(UTC-08:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse",
              "PST8PDT"
            ]
          },
          {
            name: "US Mountain Standard Time",
            abbr: "UMST",
            offset: -7,
            isdst: !1,
            text: "(UTC-07:00) Arizona",
            utc: [
              "America/Creston",
              "America/Dawson_Creek",
              "America/Hermosillo",
              "America/Phoenix",
              "Etc/GMT+7"
            ]
          },
          {
            name: "Mountain Standard Time (Mexico)",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
            utc: [
              "America/Chihuahua",
              "America/Mazatlan"
            ]
          },
          {
            name: "Mountain Standard Time",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Mountain Time (US & Canada)",
            utc: [
              "America/Boise",
              "America/Cambridge_Bay",
              "America/Denver",
              "America/Edmonton",
              "America/Inuvik",
              "America/Ojinaga",
              "America/Yellowknife",
              "MST7MDT"
            ]
          },
          {
            name: "Central America Standard Time",
            abbr: "CAST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Central America",
            utc: [
              "America/Belize",
              "America/Costa_Rica",
              "America/El_Salvador",
              "America/Guatemala",
              "America/Managua",
              "America/Tegucigalpa",
              "Etc/GMT+6",
              "Pacific/Galapagos"
            ]
          },
          {
            name: "Central Standard Time",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Central Time (US & Canada)",
            utc: [
              "America/Chicago",
              "America/Indiana/Knox",
              "America/Indiana/Tell_City",
              "America/Matamoros",
              "America/Menominee",
              "America/North_Dakota/Beulah",
              "America/North_Dakota/Center",
              "America/North_Dakota/New_Salem",
              "America/Rainy_River",
              "America/Rankin_Inlet",
              "America/Resolute",
              "America/Winnipeg",
              "CST6CDT"
            ]
          },
          {
            name: "Central Standard Time (Mexico)",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
            utc: [
              "America/Bahia_Banderas",
              "America/Cancun",
              "America/Merida",
              "America/Mexico_City",
              "America/Monterrey"
            ]
          },
          {
            name: "Canada Central Standard Time",
            abbr: "CCST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Saskatchewan",
            utc: [
              "America/Regina",
              "America/Swift_Current"
            ]
          },
          {
            name: "SA Pacific Standard Time",
            abbr: "SPST",
            offset: -5,
            isdst: !1,
            text: "(UTC-05:00) Bogota, Lima, Quito",
            utc: [
              "America/Bogota",
              "America/Cayman",
              "America/Coral_Harbour",
              "America/Eirunepe",
              "America/Guayaquil",
              "America/Jamaica",
              "America/Lima",
              "America/Panama",
              "America/Rio_Branco",
              "Etc/GMT+5"
            ]
          },
          {
            name: "Eastern Standard Time",
            abbr: "EDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Eastern Time (US & Canada)",
            utc: [
              "America/Detroit",
              "America/Havana",
              "America/Indiana/Petersburg",
              "America/Indiana/Vincennes",
              "America/Indiana/Winamac",
              "America/Iqaluit",
              "America/Kentucky/Monticello",
              "America/Louisville",
              "America/Montreal",
              "America/Nassau",
              "America/New_York",
              "America/Nipigon",
              "America/Pangnirtung",
              "America/Port-au-Prince",
              "America/Thunder_Bay",
              "America/Toronto",
              "EST5EDT"
            ]
          },
          {
            name: "US Eastern Standard Time",
            abbr: "UEDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Indiana (East)",
            utc: [
              "America/Indiana/Marengo",
              "America/Indiana/Vevay",
              "America/Indianapolis"
            ]
          },
          {
            name: "Venezuela Standard Time",
            abbr: "VST",
            offset: -4.5,
            isdst: !1,
            text: "(UTC-04:30) Caracas",
            utc: [
              "America/Caracas"
            ]
          },
          {
            name: "Paraguay Standard Time",
            abbr: "PYT",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Asuncion",
            utc: [
              "America/Asuncion"
            ]
          },
          {
            name: "Atlantic Standard Time",
            abbr: "ADT",
            offset: -3,
            isdst: !0,
            text: "(UTC-04:00) Atlantic Time (Canada)",
            utc: [
              "America/Glace_Bay",
              "America/Goose_Bay",
              "America/Halifax",
              "America/Moncton",
              "America/Thule",
              "Atlantic/Bermuda"
            ]
          },
          {
            name: "Central Brazilian Standard Time",
            abbr: "CBST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Cuiaba",
            utc: [
              "America/Campo_Grande",
              "America/Cuiaba"
            ]
          },
          {
            name: "SA Western Standard Time",
            abbr: "SWST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
            utc: [
              "America/Anguilla",
              "America/Antigua",
              "America/Aruba",
              "America/Barbados",
              "America/Blanc-Sablon",
              "America/Boa_Vista",
              "America/Curacao",
              "America/Dominica",
              "America/Grand_Turk",
              "America/Grenada",
              "America/Guadeloupe",
              "America/Guyana",
              "America/Kralendijk",
              "America/La_Paz",
              "America/Lower_Princes",
              "America/Manaus",
              "America/Marigot",
              "America/Martinique",
              "America/Montserrat",
              "America/Port_of_Spain",
              "America/Porto_Velho",
              "America/Puerto_Rico",
              "America/Santo_Domingo",
              "America/St_Barthelemy",
              "America/St_Kitts",
              "America/St_Lucia",
              "America/St_Thomas",
              "America/St_Vincent",
              "America/Tortola",
              "Etc/GMT+4"
            ]
          },
          {
            name: "Pacific SA Standard Time",
            abbr: "PSST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Santiago",
            utc: [
              "America/Santiago",
              "Antarctica/Palmer"
            ]
          },
          {
            name: "Newfoundland Standard Time",
            abbr: "NDT",
            offset: -2.5,
            isdst: !0,
            text: "(UTC-03:30) Newfoundland",
            utc: [
              "America/St_Johns"
            ]
          },
          {
            name: "E. South America Standard Time",
            abbr: "ESAST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Brasilia",
            utc: [
              "America/Sao_Paulo"
            ]
          },
          {
            name: "Argentina Standard Time",
            abbr: "AST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Buenos Aires",
            utc: [
              "America/Argentina/La_Rioja",
              "America/Argentina/Rio_Gallegos",
              "America/Argentina/Salta",
              "America/Argentina/San_Juan",
              "America/Argentina/San_Luis",
              "America/Argentina/Tucuman",
              "America/Argentina/Ushuaia",
              "America/Buenos_Aires",
              "America/Catamarca",
              "America/Cordoba",
              "America/Jujuy",
              "America/Mendoza"
            ]
          },
          {
            name: "SA Eastern Standard Time",
            abbr: "SEST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Cayenne, Fortaleza",
            utc: [
              "America/Araguaina",
              "America/Belem",
              "America/Cayenne",
              "America/Fortaleza",
              "America/Maceio",
              "America/Paramaribo",
              "America/Recife",
              "America/Santarem",
              "Antarctica/Rothera",
              "Atlantic/Stanley",
              "Etc/GMT+3"
            ]
          },
          {
            name: "Greenland Standard Time",
            abbr: "GDT",
            offset: -3,
            isdst: !0,
            text: "(UTC-03:00) Greenland",
            utc: [
              "America/Godthab"
            ]
          },
          {
            name: "Montevideo Standard Time",
            abbr: "MST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Montevideo",
            utc: [
              "America/Montevideo"
            ]
          },
          {
            name: "Bahia Standard Time",
            abbr: "BST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Salvador",
            utc: [
              "America/Bahia"
            ]
          },
          {
            name: "UTC-02",
            abbr: "U",
            offset: -2,
            isdst: !1,
            text: "(UTC-02:00) Coordinated Universal Time-02",
            utc: [
              "America/Noronha",
              "Atlantic/South_Georgia",
              "Etc/GMT+2"
            ]
          },
          {
            name: "Mid-Atlantic Standard Time",
            abbr: "MDT",
            offset: -1,
            isdst: !0,
            text: "(UTC-02:00) Mid-Atlantic - Old",
            utc: []
          },
          {
            name: "Azores Standard Time",
            abbr: "ADT",
            offset: 0,
            isdst: !0,
            text: "(UTC-01:00) Azores",
            utc: [
              "America/Scoresbysund",
              "Atlantic/Azores"
            ]
          },
          {
            name: "Cape Verde Standard Time",
            abbr: "CVST",
            offset: -1,
            isdst: !1,
            text: "(UTC-01:00) Cape Verde Is.",
            utc: [
              "Atlantic/Cape_Verde",
              "Etc/GMT+1"
            ]
          },
          {
            name: "Morocco Standard Time",
            abbr: "MDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Casablanca",
            utc: [
              "Africa/Casablanca",
              "Africa/El_Aaiun"
            ]
          },
          {
            name: "UTC",
            abbr: "UTC",
            offset: 0,
            isdst: !1,
            text: "(UTC) Coordinated Universal Time",
            utc: [
              "America/Danmarkshavn",
              "Etc/GMT"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GMT",
            offset: 0,
            isdst: !1,
            text: "(UTC) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "British Summer Time",
            abbr: "BST",
            offset: 1,
            isdst: !0,
            text: "(UTC+01:00) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Dublin, Lisbon",
            utc: [
              "Atlantic/Canary",
              "Atlantic/Faeroe",
              "Atlantic/Madeira",
              "Europe/Dublin",
              "Europe/Lisbon"
            ]
          },
          {
            name: "Greenwich Standard Time",
            abbr: "GST",
            offset: 0,
            isdst: !1,
            text: "(UTC) Monrovia, Reykjavik",
            utc: [
              "Africa/Abidjan",
              "Africa/Accra",
              "Africa/Bamako",
              "Africa/Banjul",
              "Africa/Bissau",
              "Africa/Conakry",
              "Africa/Dakar",
              "Africa/Freetown",
              "Africa/Lome",
              "Africa/Monrovia",
              "Africa/Nouakchott",
              "Africa/Ouagadougou",
              "Africa/Sao_Tome",
              "Atlantic/Reykjavik",
              "Atlantic/St_Helena"
            ]
          },
          {
            name: "W. Europe Standard Time",
            abbr: "WEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            utc: [
              "Arctic/Longyearbyen",
              "Europe/Amsterdam",
              "Europe/Andorra",
              "Europe/Berlin",
              "Europe/Busingen",
              "Europe/Gibraltar",
              "Europe/Luxembourg",
              "Europe/Malta",
              "Europe/Monaco",
              "Europe/Oslo",
              "Europe/Rome",
              "Europe/San_Marino",
              "Europe/Stockholm",
              "Europe/Vaduz",
              "Europe/Vatican",
              "Europe/Vienna",
              "Europe/Zurich"
            ]
          },
          {
            name: "Central Europe Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            utc: [
              "Europe/Belgrade",
              "Europe/Bratislava",
              "Europe/Budapest",
              "Europe/Ljubljana",
              "Europe/Podgorica",
              "Europe/Prague",
              "Europe/Tirane"
            ]
          },
          {
            name: "Romance Standard Time",
            abbr: "RDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
            utc: [
              "Africa/Ceuta",
              "Europe/Brussels",
              "Europe/Copenhagen",
              "Europe/Madrid",
              "Europe/Paris"
            ]
          },
          {
            name: "Central European Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            utc: [
              "Europe/Sarajevo",
              "Europe/Skopje",
              "Europe/Warsaw",
              "Europe/Zagreb"
            ]
          },
          {
            name: "W. Central Africa Standard Time",
            abbr: "WCAST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) West Central Africa",
            utc: [
              "Africa/Algiers",
              "Africa/Bangui",
              "Africa/Brazzaville",
              "Africa/Douala",
              "Africa/Kinshasa",
              "Africa/Lagos",
              "Africa/Libreville",
              "Africa/Luanda",
              "Africa/Malabo",
              "Africa/Ndjamena",
              "Africa/Niamey",
              "Africa/Porto-Novo",
              "Africa/Tunis",
              "Etc/GMT-1"
            ]
          },
          {
            name: "Namibia Standard Time",
            abbr: "NST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) Windhoek",
            utc: [
              "Africa/Windhoek"
            ]
          },
          {
            name: "GTB Standard Time",
            abbr: "GDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Athens, Bucharest",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau"
            ]
          },
          {
            name: "Middle East Standard Time",
            abbr: "MEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Beirut",
            utc: [
              "Asia/Beirut"
            ]
          },
          {
            name: "Egypt Standard Time",
            abbr: "EST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Cairo",
            utc: [
              "Africa/Cairo"
            ]
          },
          {
            name: "Syria Standard Time",
            abbr: "SDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Damascus",
            utc: [
              "Asia/Damascus"
            ]
          },
          {
            name: "E. Europe Standard Time",
            abbr: "EEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) E. Europe",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau",
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Nicosia",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "South Africa Standard Time",
            abbr: "SAST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Harare, Pretoria",
            utc: [
              "Africa/Blantyre",
              "Africa/Bujumbura",
              "Africa/Gaborone",
              "Africa/Harare",
              "Africa/Johannesburg",
              "Africa/Kigali",
              "Africa/Lubumbashi",
              "Africa/Lusaka",
              "Africa/Maputo",
              "Africa/Maseru",
              "Africa/Mbabane",
              "Etc/GMT-2"
            ]
          },
          {
            name: "FLE Standard Time",
            abbr: "FDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            utc: [
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "Turkey Standard Time",
            abbr: "TDT",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Istanbul",
            utc: [
              "Europe/Istanbul"
            ]
          },
          {
            name: "Israel Standard Time",
            abbr: "JDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Jerusalem",
            utc: [
              "Asia/Jerusalem"
            ]
          },
          {
            name: "Libya Standard Time",
            abbr: "LST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Tripoli",
            utc: [
              "Africa/Tripoli"
            ]
          },
          {
            name: "Jordan Standard Time",
            abbr: "JST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Amman",
            utc: [
              "Asia/Amman"
            ]
          },
          {
            name: "Arabic Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Baghdad",
            utc: [
              "Asia/Baghdad"
            ]
          },
          {
            name: "Kaliningrad Standard Time",
            abbr: "KST",
            offset: 3,
            isdst: !1,
            text: "(UTC+02:00) Kaliningrad",
            utc: [
              "Europe/Kaliningrad"
            ]
          },
          {
            name: "Arab Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Kuwait, Riyadh",
            utc: [
              "Asia/Aden",
              "Asia/Bahrain",
              "Asia/Kuwait",
              "Asia/Qatar",
              "Asia/Riyadh"
            ]
          },
          {
            name: "E. Africa Standard Time",
            abbr: "EAST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Nairobi",
            utc: [
              "Africa/Addis_Ababa",
              "Africa/Asmera",
              "Africa/Dar_es_Salaam",
              "Africa/Djibouti",
              "Africa/Juba",
              "Africa/Kampala",
              "Africa/Khartoum",
              "Africa/Mogadishu",
              "Africa/Nairobi",
              "Antarctica/Syowa",
              "Etc/GMT-3",
              "Indian/Antananarivo",
              "Indian/Comoro",
              "Indian/Mayotte"
            ]
          },
          {
            name: "Moscow Standard Time",
            abbr: "MSK",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
            utc: [
              "Europe/Kirov",
              "Europe/Moscow",
              "Europe/Simferopol",
              "Europe/Volgograd",
              "Europe/Minsk"
            ]
          },
          {
            name: "Samara Time",
            abbr: "SAMT",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
            utc: [
              "Europe/Astrakhan",
              "Europe/Samara",
              "Europe/Ulyanovsk"
            ]
          },
          {
            name: "Iran Standard Time",
            abbr: "IDT",
            offset: 4.5,
            isdst: !0,
            text: "(UTC+03:30) Tehran",
            utc: [
              "Asia/Tehran"
            ]
          },
          {
            name: "Arabian Standard Time",
            abbr: "AST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Abu Dhabi, Muscat",
            utc: [
              "Asia/Dubai",
              "Asia/Muscat",
              "Etc/GMT-4"
            ]
          },
          {
            name: "Azerbaijan Standard Time",
            abbr: "ADT",
            offset: 5,
            isdst: !0,
            text: "(UTC+04:00) Baku",
            utc: [
              "Asia/Baku"
            ]
          },
          {
            name: "Mauritius Standard Time",
            abbr: "MST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Port Louis",
            utc: [
              "Indian/Mahe",
              "Indian/Mauritius",
              "Indian/Reunion"
            ]
          },
          {
            name: "Georgian Standard Time",
            abbr: "GET",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Tbilisi",
            utc: [
              "Asia/Tbilisi"
            ]
          },
          {
            name: "Caucasus Standard Time",
            abbr: "CST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Yerevan",
            utc: [
              "Asia/Yerevan"
            ]
          },
          {
            name: "Afghanistan Standard Time",
            abbr: "AST",
            offset: 4.5,
            isdst: !1,
            text: "(UTC+04:30) Kabul",
            utc: [
              "Asia/Kabul"
            ]
          },
          {
            name: "West Asia Standard Time",
            abbr: "WAST",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Ashgabat, Tashkent",
            utc: [
              "Antarctica/Mawson",
              "Asia/Aqtau",
              "Asia/Aqtobe",
              "Asia/Ashgabat",
              "Asia/Dushanbe",
              "Asia/Oral",
              "Asia/Samarkand",
              "Asia/Tashkent",
              "Etc/GMT-5",
              "Indian/Kerguelen",
              "Indian/Maldives"
            ]
          },
          {
            name: "Yekaterinburg Time",
            abbr: "YEKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Yekaterinburg",
            utc: [
              "Asia/Yekaterinburg"
            ]
          },
          {
            name: "Pakistan Standard Time",
            abbr: "PKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Islamabad, Karachi",
            utc: [
              "Asia/Karachi"
            ]
          },
          {
            name: "India Standard Time",
            abbr: "IST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            utc: [
              "Asia/Kolkata"
            ]
          },
          {
            name: "Sri Lanka Standard Time",
            abbr: "SLST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Sri Jayawardenepura",
            utc: [
              "Asia/Colombo"
            ]
          },
          {
            name: "Nepal Standard Time",
            abbr: "NST",
            offset: 5.75,
            isdst: !1,
            text: "(UTC+05:45) Kathmandu",
            utc: [
              "Asia/Kathmandu"
            ]
          },
          {
            name: "Central Asia Standard Time",
            abbr: "CAST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Nur-Sultan (Astana)",
            utc: [
              "Antarctica/Vostok",
              "Asia/Almaty",
              "Asia/Bishkek",
              "Asia/Qyzylorda",
              "Asia/Urumqi",
              "Etc/GMT-6",
              "Indian/Chagos"
            ]
          },
          {
            name: "Bangladesh Standard Time",
            abbr: "BST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Dhaka",
            utc: [
              "Asia/Dhaka",
              "Asia/Thimphu"
            ]
          },
          {
            name: "Myanmar Standard Time",
            abbr: "MST",
            offset: 6.5,
            isdst: !1,
            text: "(UTC+06:30) Yangon (Rangoon)",
            utc: [
              "Asia/Rangoon",
              "Indian/Cocos"
            ]
          },
          {
            name: "SE Asia Standard Time",
            abbr: "SAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
            utc: [
              "Antarctica/Davis",
              "Asia/Bangkok",
              "Asia/Hovd",
              "Asia/Jakarta",
              "Asia/Phnom_Penh",
              "Asia/Pontianak",
              "Asia/Saigon",
              "Asia/Vientiane",
              "Etc/GMT-7",
              "Indian/Christmas"
            ]
          },
          {
            name: "N. Central Asia Standard Time",
            abbr: "NCAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Novosibirsk",
            utc: [
              "Asia/Novokuznetsk",
              "Asia/Novosibirsk",
              "Asia/Omsk"
            ]
          },
          {
            name: "China Standard Time",
            abbr: "CST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            utc: [
              "Asia/Hong_Kong",
              "Asia/Macau",
              "Asia/Shanghai"
            ]
          },
          {
            name: "North Asia Standard Time",
            abbr: "NAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Krasnoyarsk",
            utc: [
              "Asia/Krasnoyarsk"
            ]
          },
          {
            name: "Singapore Standard Time",
            abbr: "MPST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Kuala Lumpur, Singapore",
            utc: [
              "Asia/Brunei",
              "Asia/Kuala_Lumpur",
              "Asia/Kuching",
              "Asia/Makassar",
              "Asia/Manila",
              "Asia/Singapore",
              "Etc/GMT-8"
            ]
          },
          {
            name: "W. Australia Standard Time",
            abbr: "WAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Perth",
            utc: [
              "Antarctica/Casey",
              "Australia/Perth"
            ]
          },
          {
            name: "Taipei Standard Time",
            abbr: "TST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Taipei",
            utc: [
              "Asia/Taipei"
            ]
          },
          {
            name: "Ulaanbaatar Standard Time",
            abbr: "UST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Ulaanbaatar",
            utc: [
              "Asia/Choibalsan",
              "Asia/Ulaanbaatar"
            ]
          },
          {
            name: "North Asia East Standard Time",
            abbr: "NAEST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Irkutsk",
            utc: [
              "Asia/Irkutsk"
            ]
          },
          {
            name: "Japan Standard Time",
            abbr: "JST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
            utc: [
              "Asia/Dili",
              "Asia/Jayapura",
              "Asia/Tokyo",
              "Etc/GMT-9",
              "Pacific/Palau"
            ]
          },
          {
            name: "Korea Standard Time",
            abbr: "KST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Seoul",
            utc: [
              "Asia/Pyongyang",
              "Asia/Seoul"
            ]
          },
          {
            name: "Cen. Australia Standard Time",
            abbr: "CAST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Adelaide",
            utc: [
              "Australia/Adelaide",
              "Australia/Broken_Hill"
            ]
          },
          {
            name: "AUS Central Standard Time",
            abbr: "ACST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Darwin",
            utc: [
              "Australia/Darwin"
            ]
          },
          {
            name: "E. Australia Standard Time",
            abbr: "EAST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Brisbane",
            utc: [
              "Australia/Brisbane",
              "Australia/Lindeman"
            ]
          },
          {
            name: "AUS Eastern Standard Time",
            abbr: "AEST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Canberra, Melbourne, Sydney",
            utc: [
              "Australia/Melbourne",
              "Australia/Sydney"
            ]
          },
          {
            name: "West Pacific Standard Time",
            abbr: "WPST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Guam, Port Moresby",
            utc: [
              "Antarctica/DumontDUrville",
              "Etc/GMT-10",
              "Pacific/Guam",
              "Pacific/Port_Moresby",
              "Pacific/Saipan",
              "Pacific/Truk"
            ]
          },
          {
            name: "Tasmania Standard Time",
            abbr: "TST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Hobart",
            utc: [
              "Australia/Currie",
              "Australia/Hobart"
            ]
          },
          {
            name: "Yakutsk Standard Time",
            abbr: "YST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Yakutsk",
            utc: [
              "Asia/Chita",
              "Asia/Khandyga",
              "Asia/Yakutsk"
            ]
          },
          {
            name: "Central Pacific Standard Time",
            abbr: "CPST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Solomon Is., New Caledonia",
            utc: [
              "Antarctica/Macquarie",
              "Etc/GMT-11",
              "Pacific/Efate",
              "Pacific/Guadalcanal",
              "Pacific/Kosrae",
              "Pacific/Noumea",
              "Pacific/Ponape"
            ]
          },
          {
            name: "Vladivostok Standard Time",
            abbr: "VST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Vladivostok",
            utc: [
              "Asia/Sakhalin",
              "Asia/Ust-Nera",
              "Asia/Vladivostok"
            ]
          },
          {
            name: "New Zealand Standard Time",
            abbr: "NZST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Auckland, Wellington",
            utc: [
              "Antarctica/McMurdo",
              "Pacific/Auckland"
            ]
          },
          {
            name: "UTC+12",
            abbr: "U",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Coordinated Universal Time+12",
            utc: [
              "Etc/GMT-12",
              "Pacific/Funafuti",
              "Pacific/Kwajalein",
              "Pacific/Majuro",
              "Pacific/Nauru",
              "Pacific/Tarawa",
              "Pacific/Wake",
              "Pacific/Wallis"
            ]
          },
          {
            name: "Fiji Standard Time",
            abbr: "FST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Fiji",
            utc: [
              "Pacific/Fiji"
            ]
          },
          {
            name: "Magadan Standard Time",
            abbr: "MST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Magadan",
            utc: [
              "Asia/Anadyr",
              "Asia/Kamchatka",
              "Asia/Magadan",
              "Asia/Srednekolymsk"
            ]
          },
          {
            name: "Kamchatka Standard Time",
            abbr: "KDT",
            offset: 13,
            isdst: !0,
            text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
            utc: [
              "Asia/Kamchatka"
            ]
          },
          {
            name: "Tonga Standard Time",
            abbr: "TST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Nuku'alofa",
            utc: [
              "Etc/GMT-13",
              "Pacific/Enderbury",
              "Pacific/Fakaofo",
              "Pacific/Tongatapu"
            ]
          },
          {
            name: "Samoa Standard Time",
            abbr: "SST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Samoa",
            utc: [
              "Pacific/Apia"
            ]
          }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
          "Airline Pilot",
          "Academic Team",
          "Accountant",
          "Account Executive",
          "Actor",
          "Actuary",
          "Acquisition Analyst",
          "Administrative Asst.",
          "Administrative Analyst",
          "Administrator",
          "Advertising Director",
          "Aerospace Engineer",
          "Agent",
          "Agricultural Inspector",
          "Agricultural Scientist",
          "Air Traffic Controller",
          "Animal Trainer",
          "Anthropologist",
          "Appraiser",
          "Architect",
          "Art Director",
          "Artist",
          "Astronomer",
          "Athletic Coach",
          "Auditor",
          "Author",
          "Baker",
          "Banker",
          "Bankruptcy Attorney",
          "Benefits Manager",
          "Biologist",
          "Bio-feedback Specialist",
          "Biomedical Engineer",
          "Biotechnical Researcher",
          "Broadcaster",
          "Broker",
          "Building Manager",
          "Building Contractor",
          "Building Inspector",
          "Business Analyst",
          "Business Planner",
          "Business Manager",
          "Buyer",
          "Call Center Manager",
          "Career Counselor",
          "Cash Manager",
          "Ceramic Engineer",
          "Chief Executive Officer",
          "Chief Operation Officer",
          "Chef",
          "Chemical Engineer",
          "Chemist",
          "Child Care Manager",
          "Chief Medical Officer",
          "Chiropractor",
          "Cinematographer",
          "City Housing Manager",
          "City Manager",
          "Civil Engineer",
          "Claims Manager",
          "Clinical Research Assistant",
          "Collections Manager",
          "Compliance Manager",
          "Comptroller",
          "Computer Manager",
          "Commercial Artist",
          "Communications Affairs Director",
          "Communications Director",
          "Communications Engineer",
          "Compensation Analyst",
          "Computer Programmer",
          "Computer Ops. Manager",
          "Computer Engineer",
          "Computer Operator",
          "Computer Graphics Specialist",
          "Construction Engineer",
          "Construction Manager",
          "Consultant",
          "Consumer Relations Manager",
          "Contract Administrator",
          "Copyright Attorney",
          "Copywriter",
          "Corporate Planner",
          "Corrections Officer",
          "Cosmetologist",
          "Credit Analyst",
          "Cruise Director",
          "Chief Information Officer",
          "Chief Technology Officer",
          "Customer Service Manager",
          "Cryptologist",
          "Dancer",
          "Data Security Manager",
          "Database Manager",
          "Day Care Instructor",
          "Dentist",
          "Designer",
          "Design Engineer",
          "Desktop Publisher",
          "Developer",
          "Development Officer",
          "Diamond Merchant",
          "Dietitian",
          "Direct Marketer",
          "Director",
          "Distribution Manager",
          "Diversity Manager",
          "Economist",
          "EEO Compliance Manager",
          "Editor",
          "Education Adminator",
          "Electrical Engineer",
          "Electro Optical Engineer",
          "Electronics Engineer",
          "Embassy Management",
          "Employment Agent",
          "Engineer Technician",
          "Entrepreneur",
          "Environmental Analyst",
          "Environmental Attorney",
          "Environmental Engineer",
          "Environmental Specialist",
          "Escrow Officer",
          "Estimator",
          "Executive Assistant",
          "Executive Director",
          "Executive Recruiter",
          "Facilities Manager",
          "Family Counselor",
          "Fashion Events Manager",
          "Fashion Merchandiser",
          "Fast Food Manager",
          "Film Producer",
          "Film Production Assistant",
          "Financial Analyst",
          "Financial Planner",
          "Financier",
          "Fine Artist",
          "Wildlife Specialist",
          "Fitness Consultant",
          "Flight Attendant",
          "Flight Engineer",
          "Floral Designer",
          "Food & Beverage Director",
          "Food Service Manager",
          "Forestry Technician",
          "Franchise Management",
          "Franchise Sales",
          "Fraud Investigator",
          "Freelance Writer",
          "Fund Raiser",
          "General Manager",
          "Geologist",
          "General Counsel",
          "Geriatric Specialist",
          "Gerontologist",
          "Glamour Photographer",
          "Golf Club Manager",
          "Gourmet Chef",
          "Graphic Designer",
          "Grounds Keeper",
          "Hazardous Waste Manager",
          "Health Care Manager",
          "Health Therapist",
          "Health Service Administrator",
          "Hearing Officer",
          "Home Economist",
          "Horticulturist",
          "Hospital Administrator",
          "Hotel Manager",
          "Human Resources Manager",
          "Importer",
          "Industrial Designer",
          "Industrial Engineer",
          "Information Director",
          "Inside Sales",
          "Insurance Adjuster",
          "Interior Decorator",
          "Internal Controls Director",
          "International Acct.",
          "International Courier",
          "International Lawyer",
          "Interpreter",
          "Investigator",
          "Investment Banker",
          "Investment Manager",
          "IT Architect",
          "IT Project Manager",
          "IT Systems Analyst",
          "Jeweler",
          "Joint Venture Manager",
          "Journalist",
          "Labor Negotiator",
          "Labor Organizer",
          "Labor Relations Manager",
          "Lab Services Director",
          "Lab Technician",
          "Land Developer",
          "Landscape Architect",
          "Law Enforcement Officer",
          "Lawyer",
          "Lead Software Engineer",
          "Lead Software Test Engineer",
          "Leasing Manager",
          "Legal Secretary",
          "Library Manager",
          "Litigation Attorney",
          "Loan Officer",
          "Lobbyist",
          "Logistics Manager",
          "Maintenance Manager",
          "Management Consultant",
          "Managed Care Director",
          "Managing Partner",
          "Manufacturing Director",
          "Manpower Planner",
          "Marine Biologist",
          "Market Res. Analyst",
          "Marketing Director",
          "Materials Manager",
          "Mathematician",
          "Membership Chairman",
          "Mechanic",
          "Mechanical Engineer",
          "Media Buyer",
          "Medical Investor",
          "Medical Secretary",
          "Medical Technician",
          "Mental Health Counselor",
          "Merchandiser",
          "Metallurgical Engineering",
          "Meteorologist",
          "Microbiologist",
          "MIS Manager",
          "Motion Picture Director",
          "Multimedia Director",
          "Musician",
          "Network Administrator",
          "Network Specialist",
          "Network Operator",
          "New Product Manager",
          "Novelist",
          "Nuclear Engineer",
          "Nuclear Specialist",
          "Nutritionist",
          "Nursing Administrator",
          "Occupational Therapist",
          "Oceanographer",
          "Office Manager",
          "Operations Manager",
          "Operations Research Director",
          "Optical Technician",
          "Optometrist",
          "Organizational Development Manager",
          "Outplacement Specialist",
          "Paralegal",
          "Park Ranger",
          "Patent Attorney",
          "Payroll Specialist",
          "Personnel Specialist",
          "Petroleum Engineer",
          "Pharmacist",
          "Photographer",
          "Physical Therapist",
          "Physician",
          "Physician Assistant",
          "Physicist",
          "Planning Director",
          "Podiatrist",
          "Political Analyst",
          "Political Scientist",
          "Politician",
          "Portfolio Manager",
          "Preschool Management",
          "Preschool Teacher",
          "Principal",
          "Private Banker",
          "Private Investigator",
          "Probation Officer",
          "Process Engineer",
          "Producer",
          "Product Manager",
          "Product Engineer",
          "Production Engineer",
          "Production Planner",
          "Professional Athlete",
          "Professional Coach",
          "Professor",
          "Project Engineer",
          "Project Manager",
          "Program Manager",
          "Property Manager",
          "Public Administrator",
          "Public Safety Director",
          "PR Specialist",
          "Publisher",
          "Purchasing Agent",
          "Publishing Director",
          "Quality Assurance Specialist",
          "Quality Control Engineer",
          "Quality Control Inspector",
          "Radiology Manager",
          "Railroad Engineer",
          "Real Estate Broker",
          "Recreational Director",
          "Recruiter",
          "Redevelopment Specialist",
          "Regulatory Affairs Manager",
          "Registered Nurse",
          "Rehabilitation Counselor",
          "Relocation Manager",
          "Reporter",
          "Research Specialist",
          "Restaurant Manager",
          "Retail Store Manager",
          "Risk Analyst",
          "Safety Engineer",
          "Sales Engineer",
          "Sales Trainer",
          "Sales Promotion Manager",
          "Sales Representative",
          "Sales Manager",
          "Service Manager",
          "Sanitation Engineer",
          "Scientific Programmer",
          "Scientific Writer",
          "Securities Analyst",
          "Security Consultant",
          "Security Director",
          "Seminar Presenter",
          "Ship's Officer",
          "Singer",
          "Social Director",
          "Social Program Planner",
          "Social Research",
          "Social Scientist",
          "Social Worker",
          "Sociologist",
          "Software Developer",
          "Software Engineer",
          "Software Test Engineer",
          "Soil Scientist",
          "Special Events Manager",
          "Special Education Teacher",
          "Special Projects Director",
          "Speech Pathologist",
          "Speech Writer",
          "Sports Event Manager",
          "Statistician",
          "Store Manager",
          "Strategic Alliance Director",
          "Strategic Planning Director",
          "Stress Reduction Specialist",
          "Stockbroker",
          "Surveyor",
          "Structural Engineer",
          "Superintendent",
          "Supply Chain Director",
          "System Engineer",
          "Systems Analyst",
          "Systems Programmer",
          "System Administrator",
          "Tax Specialist",
          "Teacher",
          "Technical Support Specialist",
          "Technical Illustrator",
          "Technical Writer",
          "Technology Director",
          "Telecom Analyst",
          "Telemarketer",
          "Theatrical Director",
          "Title Examiner",
          "Tour Escort",
          "Tour Guide Director",
          "Traffic Manager",
          "Trainer Translator",
          "Transportation Manager",
          "Travel Agent",
          "Treasurer",
          "TV Programmer",
          "Underwriter",
          "Union Representative",
          "University Administrator",
          "University Dean",
          "Urban Planner",
          "Veterinarian",
          "Vendor Relations Director",
          "Viticulturist",
          "Warehouse Manager"
        ],
        animals: {
          //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
          ocean: ["Acantharea", "Anemone", "Angelfish King", "Ahi Tuna", "Albacore", "American Oyster", "Anchovy", "Armored Snail", "Arctic Char", "Atlantic Bluefin Tuna", "Atlantic Cod", "Atlantic Goliath Grouper", "Atlantic Trumpetfish", "Atlantic Wolffish", "Baleen Whale", "Banded Butterflyfish", "Banded Coral Shrimp", "Banded Sea Krait", "Barnacle", "Barndoor Skate", "Barracuda", "Basking Shark", "Bass", "Beluga Whale", "Bluebanded Goby", "Bluehead Wrasse", "Bluefish", "Bluestreak Cleaner-Wrasse", "Blue Marlin", "Blue Shark", "Blue Spiny Lobster", "Blue Tang", "Blue Whale", "Broadclub Cuttlefish", "Bull Shark", "Chambered Nautilus", "Chilean Basket Star", "Chilean Jack Mackerel", "Chinook Salmon", "Christmas Tree Worm", "Clam", "Clown Anemonefish", "Clown Triggerfish", "Cod", "Coelacanth", "Cockscomb Cup Coral", "Common Fangtooth", "Conch", "Cookiecutter Shark", "Copepod", "Coral", "Corydoras", "Cownose Ray", "Crab", "Crown-of-Thorns Starfish", "Cushion Star", "Cuttlefish", "California Sea Otters", "Dolphin", "Dolphinfish", "Dory", "Devil Fish", "Dugong", "Dumbo Octopus", "Dungeness Crab", "Eccentric Sand Dollar", "Edible Sea Cucumber", "Eel", "Elephant Seal", "Elkhorn Coral", "Emperor Shrimp", "Estuarine Crocodile", "Fathead Sculpin", "Fiddler Crab", "Fin Whale", "Flameback", "Flamingo Tongue Snail", "Flashlight Fish", "Flatback Turtle", "Flatfish", "Flying Fish", "Flounder", "Fluke", "French Angelfish", "Frilled Shark", "Fugu (also called Pufferfish)", "Gar", "Geoduck", "Giant Barrel Sponge", "Giant Caribbean Sea Anemone", "Giant Clam", "Giant Isopod", "Giant Kingfish", "Giant Oarfish", "Giant Pacific Octopus", "Giant Pyrosome", "Giant Sea Star", "Giant Squid", "Glowing Sucker Octopus", "Giant Tube Worm", "Goblin Shark", "Goosefish", "Great White Shark", "Greenland Shark", "Grey Atlantic Seal", "Grouper", "Grunion", "Guineafowl Puffer", "Haddock", "Hake", "Halibut", "Hammerhead Shark", "Hapuka", "Harbor Porpoise", "Harbor Seal", "Hatchetfish", "Hawaiian Monk Seal", "Hawksbill Turtle", "Hector's Dolphin", "Hermit Crab", "Herring", "Hoki", "Horn Shark", "Horseshoe Crab", "Humpback Anglerfish", "Humpback Whale", "Icefish", "Imperator Angelfish", "Irukandji Jellyfish", "Isopod", "Ivory Bush Coral", "Japanese Spider Crab", "Jellyfish", "John Dory", "Juan Fernandez Fur Seal", "Killer Whale", "Kiwa Hirsuta", "Krill", "Lagoon Triggerfish", "Lamprey", "Leafy Seadragon", "Leopard Seal", "Limpet", "Ling", "Lionfish", "Lions Mane Jellyfish", "Lobe Coral", "Lobster", "Loggerhead Turtle", "Longnose Sawshark", "Longsnout Seahorse", "Lophelia Coral", "Marrus Orthocanna", "Manatee", "Manta Ray", "Marlin", "Megamouth Shark", "Mexican Lookdown", "Mimic Octopus", "Moon Jelly", "Mollusk", "Monkfish", "Moray Eel", "Mullet", "Mussel", "Megaladon", "Napoleon Wrasse", "Nassau Grouper", "Narwhal", "Nautilus", "Needlefish", "Northern Seahorse", "North Atlantic Right Whale", "Northern Red Snapper", "Norway Lobster", "Nudibranch", "Nurse Shark", "Oarfish", "Ocean Sunfish", "Oceanic Whitetip Shark", "Octopus", "Olive Sea Snake", "Orange Roughy", "Ostracod", "Otter", "Oyster", "Pacific Angelshark", "Pacific Blackdragon", "Pacific Halibut", "Pacific Sardine", "Pacific Sea Nettle Jellyfish", "Pacific White Sided Dolphin", "Pantropical Spotted Dolphin", "Patagonian Toothfish", "Peacock Mantis Shrimp", "Pelagic Thresher Shark", "Penguin", "Peruvian Anchoveta", "Pilchard", "Pink Salmon", "Pinniped", "Plankton", "Porpoise", "Polar Bear", "Portuguese Man o' War", "Pycnogonid Sea Spider", "Quahog", "Queen Angelfish", "Queen Conch", "Queen Parrotfish", "Queensland Grouper", "Ragfish", "Ratfish", "Rattail Fish", "Ray", "Red Drum", "Red King Crab", "Ringed Seal", "Risso's Dolphin", "Ross Seals", "Sablefish", "Salmon", "Sand Dollar", "Sandbar Shark", "Sawfish", "Sarcastic Fringehead", "Scalloped Hammerhead Shark", "Seahorse", "Sea Cucumber", "Sea Lion", "Sea Urchin", "Seal", "Shark", "Shortfin Mako Shark", "Shovelnose Guitarfish", "Shrimp", "Silverside Fish", "Skipjack Tuna", "Slender Snipe Eel", "Smalltooth Sawfish", "Smelts", "Sockeye Salmon", "Southern Stingray", "Sponge", "Spotted Porcupinefish", "Spotted Dolphin", "Spotted Eagle Ray", "Spotted Moray", "Squid", "Squidworm", "Starfish", "Stickleback", "Stonefish", "Stoplight Loosejaw", "Sturgeon", "Swordfish", "Tan Bristlemouth", "Tasseled Wobbegong", "Terrible Claw Lobster", "Threespot Damselfish", "Tiger Prawn", "Tiger Shark", "Tilefish", "Toadfish", "Tropical Two-Wing Flyfish", "Tuna", "Umbrella Squid", "Velvet Crab", "Venus Flytrap Sea Anemone", "Vigtorniella Worm", "Viperfish", "Vampire Squid", "Vaquita", "Wahoo", "Walrus", "West Indian Manatee", "Whale", "Whale Shark", "Whiptail Gulper", "White-Beaked Dolphin", "White-Ring Garden Eel", "White Shrimp", "Wobbegong", "Wrasse", "Wreckfish", "Xiphosura", "Yellowtail Damselfish", "Yelloweye Rockfish", "Yellow Cup Black Coral", "Yellow Tube Sponge", "Yellowfin Tuna", "Zebrashark", "Zooplankton"],
          //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
          desert: ["Aardwolf", "Addax", "African Wild Ass", "Ant", "Antelope", "Armadillo", "Baboon", "Badger", "Bat", "Bearded Dragon", "Beetle", "Bird", "Black-footed Cat", "Boa", "Brown Bear", "Bustard", "Butterfly", "Camel", "Caracal", "Caracara", "Caterpillar", "Centipede", "Cheetah", "Chipmunk", "Chuckwalla", "Climbing Mouse", "Coati", "Cobra", "Cotton Rat", "Cougar", "Courser", "Crane Fly", "Crow", "Dassie Rat", "Dove", "Dunnart", "Eagle", "Echidna", "Elephant", "Emu", "Falcon", "Fly", "Fox", "Frogmouth", "Gecko", "Geoffroy's Cat", "Gerbil", "Grasshopper", "Guanaco", "Gundi", "Hamster", "Hawk", "Hedgehog", "Hyena", "Hyrax", "Jackal", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kowari", "Kultarr", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Oryx", "Ostrich", "Owl", "Pronghorn", "Python", "Rabbit", "Raccoon", "Rattlesnake", "Rhinoceros", "Sand Cat", "Spectacled Bear", "Spiny Mouse", "Starling", "Stick Bug", "Tarantula", "Tit", "Toad", "Tortoise", "Tyrant Flycatcher", "Viper", "Vulture", "Waxwing", "Xerus", "Zebra"],
          grassland: ["Aardvark", "Aardwolf", "Accentor", "African Buffalo", "African Wild Dog", "Alpaca", "Anaconda", "Ant", "Anteater", "Antelope", "Armadillo", "Baboon", "Badger", "Bandicoot", "Barbet", "Bat", "Bee", "Bee-eater", "Beetle", "Bird", "Bison", "Black-footed Cat", "Black-footed Ferret", "Bluebird", "Boa", "Bowerbird", "Brown Bear", "Bush Dog", "Bushshrike", "Bustard", "Butterfly", "Buzzard", "Caracal", "Caracara", "Cardinal", "Caterpillar", "Cheetah", "Chipmunk", "Civet", "Climbing Mouse", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Common Genet", "Cotton Rat", "Cougar", "Courser", "Coyote", "Crane", "Crane Fly", "Cricket", "Crow", "Culpeo", "Death Adder", "Deer", "Deer Mouse", "Dingo", "Dinosaur", "Dove", "Drongo", "Duck", "Duiker", "Dunnart", "Eagle", "Echidna", "Elephant", "Elk", "Emu", "Falcon", "Finch", "Flea", "Fly", "Flying Frog", "Fox", "Frog", "Frogmouth", "Garter Snake", "Gazelle", "Gecko", "Geoffroy's Cat", "Gerbil", "Giant Tortoise", "Giraffe", "Grasshopper", "Grison", "Groundhog", "Grouse", "Guanaco", "Guinea Pig", "Hamster", "Harrier", "Hartebeest", "Hawk", "Hedgehog", "Helmetshrike", "Hippopotamus", "Hornbill", "Hyena", "Hyrax", "Impala", "Jackal", "Jaguar", "Jaguarundi", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kultarr", "Ladybug", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Newt", "Oryx", "Ostrich", "Owl", "Pangolin", "Pheasant", "Prairie Dog", "Pronghorn", "Przewalski's Horse", "Python", "Quoll", "Rabbit", "Raven", "Rhinoceros", "Shelduck", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Tamandua", "Tasmanian Devil", "Thornbill", "Thrush", "Toad", "Tortoise"],
          forest: ["Agouti", "Anaconda", "Anoa", "Ant", "Anteater", "Antelope", "Armadillo", "Asian Black Bear", "Aye-aye", "Babirusa", "Baboon", "Badger", "Bandicoot", "Banteng", "Barbet", "Basilisk", "Bat", "Bearded Dragon", "Bee", "Bee-eater", "Beetle", "Bettong", "Binturong", "Bird-of-paradise", "Bongo", "Bowerbird", "Bulbul", "Bush Dog", "Bushbaby", "Bushshrike", "Butterfly", "Buzzard", "Caecilian", "Cardinal", "Cassowary", "Caterpillar", "Centipede", "Chameleon", "Chimpanzee", "Cicada", "Civet", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Colugo", "Cotinga", "Cotton Rat", "Cougar", "Crane Fly", "Cricket", "Crocodile", "Crow", "Cuckoo", "Cuscus", "Death Adder", "Deer", "Dhole", "Dingo", "Dinosaur", "Drongo", "Duck", "Duiker", "Eagle", "Echidna", "Elephant", "Finch", "Flat-headed Cat", "Flea", "Flowerpecker", "Fly", "Flying Frog", "Fossa", "Frog", "Frogmouth", "Gaur", "Gecko", "Gorilla", "Grison", "Hawaiian Honeycreeper", "Hawk", "Hedgehog", "Helmetshrike", "Hornbill", "Hyrax", "Iguana", "Jackal", "Jaguar", "Jaguarundi", "Kestrel", "Ladybug", "Lemur", "Leopard", "Lion", "Macaw", "Mandrill", "Margay", "Monkey", "Mouse", "Mouse Deer", "Newt", "Okapi", "Old World Flycatcher", "Orangutan", "Owl", "Pangolin", "Peafowl", "Pheasant", "Possum", "Python", "Quokka", "Rabbit", "Raccoon", "Red Panda", "Red River Hog", "Rhinoceros", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Sun Bear", "Tamandua", "Tamarin", "Tapir", "Tarantula", "Thrush", "Tiger", "Tit", "Toad", "Tortoise", "Toucan", "Trogon", "Trumpeter", "Turaco", "Turtle", "Tyrant Flycatcher", "Viper", "Vulture", "Wallaby", "Warbler", "Wasp", "Waxwing", "Weaver", "Weaver-finch", "Whistler", "White-eye", "Whydah", "Woodswallow", "Worm", "Wren", "Xenops", "Yellowjacket", "Accentor", "African Buffalo", "American Black Bear", "Anole", "Bird", "Bison", "Boa", "Brown Bear", "Chipmunk", "Common Genet", "Copperhead", "Coyote", "Deer Mouse", "Dormouse", "Elk", "Emu", "Fisher", "Fox", "Garter Snake", "Giant Panda", "Giant Tortoise", "Groundhog", "Grouse", "Guanaco", "Himalayan Tahr", "Kangaroo", "Koala", "Numbat", "Quoll", "Raccoon dog", "Tasmanian Devil", "Thornbill", "Turkey", "Vole", "Weasel", "Wildcat", "Wolf", "Wombat", "Woodchuck", "Woodpecker"],
          //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
          farm: ["Alpaca", "Buffalo", "Banteng", "Cow", "Cat", "Chicken", "Carp", "Camel", "Donkey", "Dog", "Duck", "Emu", "Goat", "Gayal", "Guinea", "Goose", "Horse", "Honey", "Llama", "Pig", "Pigeon", "Rhea", "Rabbit", "Sheep", "Silkworm", "Turkey", "Yak", "Zebu"],
          //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
          pet: ["Bearded Dragon", "Birds", "Burro", "Cats", "Chameleons", "Chickens", "Chinchillas", "Chinese Water Dragon", "Cows", "Dogs", "Donkey", "Ducks", "Ferrets", "Fish", "Geckos", "Geese", "Gerbils", "Goats", "Guinea Fowl", "Guinea Pigs", "Hamsters", "Hedgehogs", "Horses", "Iguanas", "Llamas", "Lizards", "Mice", "Mule", "Peafowl", "Pigs and Hogs", "Pigeons", "Ponies", "Pot Bellied Pig", "Rabbits", "Rats", "Sheep", "Skinks", "Snakes", "Stick Insects", "Sugar Gliders", "Tarantula", "Turkeys", "Turtles"],
          //list of zoo animals comes from https://bronxzoo.com/animals
          zoo: ["Aardvark", "African Wild Dog", "Aldabra Tortoise", "American Alligator", "American Bison", "Amur Tiger", "Anaconda", "Andean Condor", "Asian Elephant", "Baby Doll Sheep", "Bald Eagle", "Barred Owl", "Blue Iguana", "Boer Goat", "California Sea Lion", "Caribbean Flamingo", "Chinchilla", "Collared Lemur", "Coquerel's Sifaka", "Cuban Amazon Parrot", "Ebony Langur", "Fennec Fox", "Fossa", "Gelada", "Giant Anteater", "Giraffe", "Gorilla", "Grizzly Bear", "Henkel's Leaf-tailed Gecko", "Indian Gharial", "Indian Rhinoceros", "King Cobra", "King Vulture", "Komodo Dragon", "Linne's Two-toed Sloth", "Lion", "Little Penguin", "Madagascar Tree Boa", "Magellanic Penguin", "Malayan Tapir", "Malayan Tiger", "Matschies Tree Kangaroo", "Mini Donkey", "Monarch Butterfly", "Nile crocodile", "North American Porcupine", "Nubian Ibex", "Okapi", "Poison Dart Frog", "Polar Bear", "Pygmy Marmoset", "Radiated Tortoise", "Red Panda", "Red Ruffed Lemur", "Ring-tailed Lemur", "Ring-tailed Mongoose", "Rock Hyrax", "Small Clawed Asian Otter", "Snow Leopard", "Snowy Owl", "Southern White-faced Owl", "Southern White Rhinocerous", "Squirrel Monkey", "Tufted Puffin", "White Cheeked Gibbon", "White-throated Bee Eater", "Zebra"]
        },
        primes: [
          // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
          2,
          3,
          5,
          7,
          11,
          13,
          17,
          19,
          23,
          29,
          31,
          37,
          41,
          43,
          47,
          53,
          59,
          61,
          67,
          71,
          73,
          79,
          83,
          89,
          97,
          101,
          103,
          107,
          109,
          113,
          127,
          131,
          137,
          139,
          149,
          151,
          157,
          163,
          167,
          173,
          179,
          181,
          191,
          193,
          197,
          199,
          211,
          223,
          227,
          229,
          233,
          239,
          241,
          251,
          257,
          263,
          269,
          271,
          277,
          281,
          283,
          293,
          307,
          311,
          313,
          317,
          331,
          337,
          347,
          349,
          353,
          359,
          367,
          373,
          379,
          383,
          389,
          397,
          401,
          409,
          419,
          421,
          431,
          433,
          439,
          443,
          449,
          457,
          461,
          463,
          467,
          479,
          487,
          491,
          499,
          503,
          509,
          521,
          523,
          541,
          547,
          557,
          563,
          569,
          571,
          577,
          587,
          593,
          599,
          601,
          607,
          613,
          617,
          619,
          631,
          641,
          643,
          647,
          653,
          659,
          661,
          673,
          677,
          683,
          691,
          701,
          709,
          719,
          727,
          733,
          739,
          743,
          751,
          757,
          761,
          769,
          773,
          787,
          797,
          809,
          811,
          821,
          823,
          827,
          829,
          839,
          853,
          857,
          859,
          863,
          877,
          881,
          883,
          887,
          907,
          911,
          919,
          929,
          937,
          941,
          947,
          953,
          967,
          971,
          977,
          983,
          991,
          997,
          1009,
          1013,
          1019,
          1021,
          1031,
          1033,
          1039,
          1049,
          1051,
          1061,
          1063,
          1069,
          1087,
          1091,
          1093,
          1097,
          1103,
          1109,
          1117,
          1123,
          1129,
          1151,
          1153,
          1163,
          1171,
          1181,
          1187,
          1193,
          1201,
          1213,
          1217,
          1223,
          1229,
          1231,
          1237,
          1249,
          1259,
          1277,
          1279,
          1283,
          1289,
          1291,
          1297,
          1301,
          1303,
          1307,
          1319,
          1321,
          1327,
          1361,
          1367,
          1373,
          1381,
          1399,
          1409,
          1423,
          1427,
          1429,
          1433,
          1439,
          1447,
          1451,
          1453,
          1459,
          1471,
          1481,
          1483,
          1487,
          1489,
          1493,
          1499,
          1511,
          1523,
          1531,
          1543,
          1549,
          1553,
          1559,
          1567,
          1571,
          1579,
          1583,
          1597,
          1601,
          1607,
          1609,
          1613,
          1619,
          1621,
          1627,
          1637,
          1657,
          1663,
          1667,
          1669,
          1693,
          1697,
          1699,
          1709,
          1721,
          1723,
          1733,
          1741,
          1747,
          1753,
          1759,
          1777,
          1783,
          1787,
          1789,
          1801,
          1811,
          1823,
          1831,
          1847,
          1861,
          1867,
          1871,
          1873,
          1877,
          1879,
          1889,
          1901,
          1907,
          1913,
          1931,
          1933,
          1949,
          1951,
          1973,
          1979,
          1987,
          1993,
          1997,
          1999,
          2003,
          2011,
          2017,
          2027,
          2029,
          2039,
          2053,
          2063,
          2069,
          2081,
          2083,
          2087,
          2089,
          2099,
          2111,
          2113,
          2129,
          2131,
          2137,
          2141,
          2143,
          2153,
          2161,
          2179,
          2203,
          2207,
          2213,
          2221,
          2237,
          2239,
          2243,
          2251,
          2267,
          2269,
          2273,
          2281,
          2287,
          2293,
          2297,
          2309,
          2311,
          2333,
          2339,
          2341,
          2347,
          2351,
          2357,
          2371,
          2377,
          2381,
          2383,
          2389,
          2393,
          2399,
          2411,
          2417,
          2423,
          2437,
          2441,
          2447,
          2459,
          2467,
          2473,
          2477,
          2503,
          2521,
          2531,
          2539,
          2543,
          2549,
          2551,
          2557,
          2579,
          2591,
          2593,
          2609,
          2617,
          2621,
          2633,
          2647,
          2657,
          2659,
          2663,
          2671,
          2677,
          2683,
          2687,
          2689,
          2693,
          2699,
          2707,
          2711,
          2713,
          2719,
          2729,
          2731,
          2741,
          2749,
          2753,
          2767,
          2777,
          2789,
          2791,
          2797,
          2801,
          2803,
          2819,
          2833,
          2837,
          2843,
          2851,
          2857,
          2861,
          2879,
          2887,
          2897,
          2903,
          2909,
          2917,
          2927,
          2939,
          2953,
          2957,
          2963,
          2969,
          2971,
          2999,
          3001,
          3011,
          3019,
          3023,
          3037,
          3041,
          3049,
          3061,
          3067,
          3079,
          3083,
          3089,
          3109,
          3119,
          3121,
          3137,
          3163,
          3167,
          3169,
          3181,
          3187,
          3191,
          3203,
          3209,
          3217,
          3221,
          3229,
          3251,
          3253,
          3257,
          3259,
          3271,
          3299,
          3301,
          3307,
          3313,
          3319,
          3323,
          3329,
          3331,
          3343,
          3347,
          3359,
          3361,
          3371,
          3373,
          3389,
          3391,
          3407,
          3413,
          3433,
          3449,
          3457,
          3461,
          3463,
          3467,
          3469,
          3491,
          3499,
          3511,
          3517,
          3527,
          3529,
          3533,
          3539,
          3541,
          3547,
          3557,
          3559,
          3571,
          3581,
          3583,
          3593,
          3607,
          3613,
          3617,
          3623,
          3631,
          3637,
          3643,
          3659,
          3671,
          3673,
          3677,
          3691,
          3697,
          3701,
          3709,
          3719,
          3727,
          3733,
          3739,
          3761,
          3767,
          3769,
          3779,
          3793,
          3797,
          3803,
          3821,
          3823,
          3833,
          3847,
          3851,
          3853,
          3863,
          3877,
          3881,
          3889,
          3907,
          3911,
          3917,
          3919,
          3923,
          3929,
          3931,
          3943,
          3947,
          3967,
          3989,
          4001,
          4003,
          4007,
          4013,
          4019,
          4021,
          4027,
          4049,
          4051,
          4057,
          4073,
          4079,
          4091,
          4093,
          4099,
          4111,
          4127,
          4129,
          4133,
          4139,
          4153,
          4157,
          4159,
          4177,
          4201,
          4211,
          4217,
          4219,
          4229,
          4231,
          4241,
          4243,
          4253,
          4259,
          4261,
          4271,
          4273,
          4283,
          4289,
          4297,
          4327,
          4337,
          4339,
          4349,
          4357,
          4363,
          4373,
          4391,
          4397,
          4409,
          4421,
          4423,
          4441,
          4447,
          4451,
          4457,
          4463,
          4481,
          4483,
          4493,
          4507,
          4513,
          4517,
          4519,
          4523,
          4547,
          4549,
          4561,
          4567,
          4583,
          4591,
          4597,
          4603,
          4621,
          4637,
          4639,
          4643,
          4649,
          4651,
          4657,
          4663,
          4673,
          4679,
          4691,
          4703,
          4721,
          4723,
          4729,
          4733,
          4751,
          4759,
          4783,
          4787,
          4789,
          4793,
          4799,
          4801,
          4813,
          4817,
          4831,
          4861,
          4871,
          4877,
          4889,
          4903,
          4909,
          4919,
          4931,
          4933,
          4937,
          4943,
          4951,
          4957,
          4967,
          4969,
          4973,
          4987,
          4993,
          4999,
          5003,
          5009,
          5011,
          5021,
          5023,
          5039,
          5051,
          5059,
          5077,
          5081,
          5087,
          5099,
          5101,
          5107,
          5113,
          5119,
          5147,
          5153,
          5167,
          5171,
          5179,
          5189,
          5197,
          5209,
          5227,
          5231,
          5233,
          5237,
          5261,
          5273,
          5279,
          5281,
          5297,
          5303,
          5309,
          5323,
          5333,
          5347,
          5351,
          5381,
          5387,
          5393,
          5399,
          5407,
          5413,
          5417,
          5419,
          5431,
          5437,
          5441,
          5443,
          5449,
          5471,
          5477,
          5479,
          5483,
          5501,
          5503,
          5507,
          5519,
          5521,
          5527,
          5531,
          5557,
          5563,
          5569,
          5573,
          5581,
          5591,
          5623,
          5639,
          5641,
          5647,
          5651,
          5653,
          5657,
          5659,
          5669,
          5683,
          5689,
          5693,
          5701,
          5711,
          5717,
          5737,
          5741,
          5743,
          5749,
          5779,
          5783,
          5791,
          5801,
          5807,
          5813,
          5821,
          5827,
          5839,
          5843,
          5849,
          5851,
          5857,
          5861,
          5867,
          5869,
          5879,
          5881,
          5897,
          5903,
          5923,
          5927,
          5939,
          5953,
          5981,
          5987,
          6007,
          6011,
          6029,
          6037,
          6043,
          6047,
          6053,
          6067,
          6073,
          6079,
          6089,
          6091,
          6101,
          6113,
          6121,
          6131,
          6133,
          6143,
          6151,
          6163,
          6173,
          6197,
          6199,
          6203,
          6211,
          6217,
          6221,
          6229,
          6247,
          6257,
          6263,
          6269,
          6271,
          6277,
          6287,
          6299,
          6301,
          6311,
          6317,
          6323,
          6329,
          6337,
          6343,
          6353,
          6359,
          6361,
          6367,
          6373,
          6379,
          6389,
          6397,
          6421,
          6427,
          6449,
          6451,
          6469,
          6473,
          6481,
          6491,
          6521,
          6529,
          6547,
          6551,
          6553,
          6563,
          6569,
          6571,
          6577,
          6581,
          6599,
          6607,
          6619,
          6637,
          6653,
          6659,
          6661,
          6673,
          6679,
          6689,
          6691,
          6701,
          6703,
          6709,
          6719,
          6733,
          6737,
          6761,
          6763,
          6779,
          6781,
          6791,
          6793,
          6803,
          6823,
          6827,
          6829,
          6833,
          6841,
          6857,
          6863,
          6869,
          6871,
          6883,
          6899,
          6907,
          6911,
          6917,
          6947,
          6949,
          6959,
          6961,
          6967,
          6971,
          6977,
          6983,
          6991,
          6997,
          7001,
          7013,
          7019,
          7027,
          7039,
          7043,
          7057,
          7069,
          7079,
          7103,
          7109,
          7121,
          7127,
          7129,
          7151,
          7159,
          7177,
          7187,
          7193,
          7207,
          7211,
          7213,
          7219,
          7229,
          7237,
          7243,
          7247,
          7253,
          7283,
          7297,
          7307,
          7309,
          7321,
          7331,
          7333,
          7349,
          7351,
          7369,
          7393,
          7411,
          7417,
          7433,
          7451,
          7457,
          7459,
          7477,
          7481,
          7487,
          7489,
          7499,
          7507,
          7517,
          7523,
          7529,
          7537,
          7541,
          7547,
          7549,
          7559,
          7561,
          7573,
          7577,
          7583,
          7589,
          7591,
          7603,
          7607,
          7621,
          7639,
          7643,
          7649,
          7669,
          7673,
          7681,
          7687,
          7691,
          7699,
          7703,
          7717,
          7723,
          7727,
          7741,
          7753,
          7757,
          7759,
          7789,
          7793,
          7817,
          7823,
          7829,
          7841,
          7853,
          7867,
          7873,
          7877,
          7879,
          7883,
          7901,
          7907,
          7919,
          7927,
          7933,
          7937,
          7949,
          7951,
          7963,
          7993,
          8009,
          8011,
          8017,
          8039,
          8053,
          8059,
          8069,
          8081,
          8087,
          8089,
          8093,
          8101,
          8111,
          8117,
          8123,
          8147,
          8161,
          8167,
          8171,
          8179,
          8191,
          8209,
          8219,
          8221,
          8231,
          8233,
          8237,
          8243,
          8263,
          8269,
          8273,
          8287,
          8291,
          8293,
          8297,
          8311,
          8317,
          8329,
          8353,
          8363,
          8369,
          8377,
          8387,
          8389,
          8419,
          8423,
          8429,
          8431,
          8443,
          8447,
          8461,
          8467,
          8501,
          8513,
          8521,
          8527,
          8537,
          8539,
          8543,
          8563,
          8573,
          8581,
          8597,
          8599,
          8609,
          8623,
          8627,
          8629,
          8641,
          8647,
          8663,
          8669,
          8677,
          8681,
          8689,
          8693,
          8699,
          8707,
          8713,
          8719,
          8731,
          8737,
          8741,
          8747,
          8753,
          8761,
          8779,
          8783,
          8803,
          8807,
          8819,
          8821,
          8831,
          8837,
          8839,
          8849,
          8861,
          8863,
          8867,
          8887,
          8893,
          8923,
          8929,
          8933,
          8941,
          8951,
          8963,
          8969,
          8971,
          8999,
          9001,
          9007,
          9011,
          9013,
          9029,
          9041,
          9043,
          9049,
          9059,
          9067,
          9091,
          9103,
          9109,
          9127,
          9133,
          9137,
          9151,
          9157,
          9161,
          9173,
          9181,
          9187,
          9199,
          9203,
          9209,
          9221,
          9227,
          9239,
          9241,
          9257,
          9277,
          9281,
          9283,
          9293,
          9311,
          9319,
          9323,
          9337,
          9341,
          9343,
          9349,
          9371,
          9377,
          9391,
          9397,
          9403,
          9413,
          9419,
          9421,
          9431,
          9433,
          9437,
          9439,
          9461,
          9463,
          9467,
          9473,
          9479,
          9491,
          9497,
          9511,
          9521,
          9533,
          9539,
          9547,
          9551,
          9587,
          9601,
          9613,
          9619,
          9623,
          9629,
          9631,
          9643,
          9649,
          9661,
          9677,
          9679,
          9689,
          9697,
          9719,
          9721,
          9733,
          9739,
          9743,
          9749,
          9767,
          9769,
          9781,
          9787,
          9791,
          9803,
          9811,
          9817,
          9829,
          9833,
          9839,
          9851,
          9857,
          9859,
          9871,
          9883,
          9887,
          9901,
          9907,
          9923,
          9929,
          9931,
          9941,
          9949,
          9967,
          9973,
          10007
        ],
        emotions: [
          "love",
          "joy",
          "surprise",
          "anger",
          "sadness",
          "fear"
        ],
        music_genres: {
          general: [
            "Rock",
            "Pop",
            "Hip-Hop",
            "Jazz",
            "Classical",
            "Electronic",
            "Country",
            "R&B",
            "Reggae",
            "Blues",
            "Metal",
            "Folk",
            "Alternative",
            "Punk",
            "Disco",
            "Funk",
            "Techno",
            "Indie",
            "Gospel",
            "Dance",
            "Children's",
            "World"
          ],
          alternative: [
            "Art Punk",
            "Alternative Rock",
            "Britpunk",
            "College Rock",
            "Crossover Thrash",
            "Crust Punk",
            "Emo / Emocore",
            "Experimental Rock",
            "Folk Punk",
            "Goth / Gothic Rock",
            "Grunge",
            "Hardcore Punk",
            "Hard Rock",
            "Indie Rock",
            "Lo-fi",
            "Musique Concrète",
            "New Wave",
            "Progressive Rock",
            "Punk",
            "Shoegaze",
            "Steampunk"
          ],
          blues: [
            "Acoustic Blues",
            "African Blues",
            "Blues Rock",
            "Blues Shouter",
            "British Blues",
            "Canadian Blues",
            "Chicago Blues",
            "Classic Blues",
            "Classic Female Blues",
            "Contemporary Blues",
            "Country Blues",
            "Dark Blues",
            "Delta Blues",
            "Detroit Blues",
            "Doom Blues",
            "Electric Blues",
            "Folk Blues",
            "Gospel Blues",
            "Harmonica Blues",
            "Hill Country Blues",
            "Hokum Blues",
            "Jazz Blues",
            "Jump Blues",
            "Kansas City Blues",
            "Louisiana Blues",
            "Memphis Blues",
            "Modern Blues",
            "New Orlean Blues",
            "NY Blues",
            "Piano Blues",
            "Piedmont Blues",
            "Punk Blues",
            "Ragtime Blues",
            "Rhythm Blues",
            "Soul Blues",
            "St.Louis Blues",
            "Soul Blues",
            "Swamp Blues",
            "Texas Blues",
            "Urban Blues",
            "Vandeville",
            "West Coast Blues"
          ],
          "children's": [
            "Lullabies",
            "Sing - Along",
            "Stories"
          ],
          classical: [
            "Avant-Garde",
            "Ballet",
            "Baroque",
            "Cantata",
            "Chamber Music",
            "String Quartet",
            "Chant",
            "Choral",
            "Classical Crossover",
            "Concerto",
            "Concerto Grosso",
            "Contemporary Classical",
            "Early Music",
            "Expressionist",
            "High Classical",
            "Impressionist",
            "Mass Requiem",
            "Medieval",
            "Minimalism",
            "Modern Composition",
            "Modern Classical",
            "Opera",
            "Oratorio",
            "Orchestral",
            "Organum",
            "Renaissance",
            "Romantic (early period)",
            "Romantic (later period)",
            "Sonata",
            "Symphonic",
            "Symphony",
            "Twelve-tone",
            "Wedding Music"
          ],
          country: [
            "Alternative Country",
            "Americana",
            "Australian Country",
            "Bakersfield Sound",
            "Bluegrass",
            "Blues Country",
            "Cajun Fiddle Tunes",
            "Christian Country",
            "Classic Country",
            "Close Harmony",
            "Contemporary Bluegrass",
            "Contemporary Country",
            "Country Gospel",
            "Country Pop",
            "Country Rap",
            "Country Rock",
            "Country Soul",
            "Cowboy / Western",
            "Cowpunk",
            "Dansband",
            "Honky Tonk",
            "Franco-Country",
            "Gulf and Western",
            "Hellbilly Music",
            "Honky Tonk",
            "Instrumental Country",
            "Lubbock Sound",
            "Nashville Sound",
            "Neotraditional Country",
            "Outlaw Country",
            "Progressive",
            "Psychobilly / Punkabilly",
            "Red Dirt",
            "Sertanejo",
            "Texas County",
            "Traditional Bluegrass",
            "Traditional Country",
            "Truck-Driving Country",
            "Urban Cowboy",
            "Western Swing"
          ],
          dance: [
            "Club / Club Dance",
            "Breakcore",
            "Breakbeat / Breakstep",
            "Chillstep",
            "Deep House",
            "Dubstep",
            "Dancehall",
            "Electro House",
            "Electroswing",
            "Exercise",
            "Future Garage",
            "Garage",
            "Glitch Hop",
            "Glitch Pop",
            "Grime",
            "Hardcore",
            "Hard Dance",
            "Hi-NRG / Eurodance",
            "Horrorcore",
            "House",
            "Jackin House",
            "Jungle / Drum n bass",
            "Liquid Dub",
            "Regstep",
            "Speedcore",
            "Techno",
            "Trance",
            "Trap"
          ],
          electronic: [
            "2-Step",
            "8bit",
            "Ambient",
            "Asian Underground",
            "Bassline",
            "Chillwave",
            "Chiptune",
            "Crunk",
            "Downtempo",
            "Drum & Bass",
            "Hard Step",
            "Electro",
            "Electro-swing",
            "Electroacoustic",
            "Electronica",
            "Electronic Rock",
            "Eurodance",
            "Hardstyle",
            "Hi-Nrg",
            "IDM/Experimental",
            "Industrial",
            "Trip Hop",
            "Vaporwave",
            "UK Garage",
            "House",
            "Dubstep",
            "Deep House",
            "EDM",
            "Future Bass",
            "Psychedelic trance"
          ],
          jazz: [
            "Acid Jazz",
            "Afro-Cuban Jazz",
            "Avant-Garde Jazz",
            "Bebop",
            "Big Band",
            "Blue Note",
            "British Dance Band (Jazz)",
            "Cape Jazz",
            "Chamber Jazz",
            "Contemporary Jazz",
            "Continental Jazz",
            "Cool Jazz",
            "Crossover Jazz",
            "Dark Jazz",
            "Dixieland",
            "Early Jazz",
            "Electro Swing (Jazz)",
            "Ethio-jazz",
            "Ethno-Jazz",
            "European Free Jazz",
            "Free Funk (Avant-Garde / Funk Jazz)",
            "Free Jazz",
            "Fusion",
            "Gypsy Jazz",
            "Hard Bop",
            "Indo Jazz",
            "Jazz Blues",
            "Jazz-Funk (see Free Funk)",
            "Jazz-Fusion",
            "Jazz Rap",
            "Jazz Rock",
            "Kansas City Jazz",
            "Latin Jazz",
            "M-Base Jazz",
            "Mainstream Jazz",
            "Modal Jazz",
            "Neo-Bop",
            "Neo-Swing",
            "Nu Jazz",
            "Orchestral Jazz",
            "Post-Bop",
            "Punk Jazz",
            "Ragtime",
            "Ska Jazz",
            "Skiffle (also Folk)",
            "Smooth Jazz",
            "Soul Jazz",
            "Swing Jazz",
            "Straight-Ahead Jazz",
            "Trad Jazz",
            "Third Stream",
            "Jazz-Funk",
            "Free Jazz",
            "West Coast Jazz"
          ],
          metal: [
            "Heavy Metal",
            "Speed Metal",
            "Thrash Metal",
            "Power Metal",
            "Death Metal",
            "Black Metal",
            "Pagan Metal",
            "Viking Metal",
            "Folk Metal",
            "Symphonic Metal",
            "Gothic Metal",
            "Glam Metal",
            "Hair Metal",
            "Doom Metal",
            "Groove Metal",
            "Industrial Metal",
            "Modern Metal",
            "Neoclassical Metal",
            "New Wave Of British Heavy Metal",
            "Post Metal",
            "Progressive Metal",
            "Avantgarde Metal",
            "Sludge",
            "Djent",
            "Drone",
            "Kawaii Metal",
            "Pirate Metal",
            "Nu Metal",
            "Neue Deutsche Härte",
            "Math Metal",
            "Crossover",
            "Grindcore",
            "Hardcore",
            "Metalcore",
            "Deathcore",
            "Post Hardcore",
            "Mathcore"
          ],
          folk: [
            "American Folk Revival",
            "Anti - Folk",
            "British Folk Revival",
            "Contemporary Folk",
            "Filk Music",
            "Freak Folk",
            "Indie Folk",
            "Industrial Folk",
            "Neofolk",
            "Progressive Folk",
            "Psychedelic Folk",
            "Sung Poetry",
            "Techno - Folk",
            "Folk Rock",
            "Old-time Music",
            "Bluegrass",
            "Appalachian",
            "Roots Revival",
            "Celtic",
            "Indie Folk"
          ],
          pop: [
            "Adult Contemporary",
            "Arab Pop",
            "Baroque",
            "Britpop",
            "Bubblegum Pop",
            "Chamber Pop",
            "Chanson",
            "Christian Pop",
            "Classical Crossover",
            "Europop",
            "Austropop",
            "Balkan Pop",
            "French Pop",
            "Korean Pop",
            "Japanese Pop",
            "Chinese Pop",
            "Latin Pop",
            "Laïkó",
            "Nederpop",
            "Russian Pop",
            "Dance Pop",
            "Dream Pop",
            "Electro Pop",
            "Iranian Pop",
            "Jangle Pop",
            "Latin Ballad",
            "Levenslied",
            "Louisiana Swamp Pop",
            "Mexican Pop",
            "Motorpop",
            "New Romanticism",
            "Orchestral Pop",
            "Pop Rap",
            "Popera",
            "Pop / Rock",
            "Pop Punk",
            "Power Pop",
            "Psychedelic Pop",
            "Russian Pop",
            "Schlager",
            "Soft Rock",
            "Sophisti - Pop",
            "Space Age Pop",
            "Sunshine Pop",
            "Surf Pop",
            "Synthpop",
            "Teen Pop",
            "Traditional Pop Music",
            "Turkish Pop",
            "Vispop",
            "Wonky Pop"
          ],
          "r&b": [
            "(Carolina) Beach Music",
            "Contemporary R & B",
            "Disco",
            "Doo Wop",
            "Funk",
            "Modern Soul",
            "Motown",
            "Neo - Soul",
            "Northern Soul",
            "Psychedelic Soul",
            "Quiet Storm",
            "Soul",
            "Soul Blues",
            "Southern Soul"
          ],
          reggae: [
            "2 - Tone",
            "Dub",
            "Roots Reggae",
            "Reggae Fusion",
            "Reggae en Español",
            "Spanish Reggae",
            "Reggae 110",
            "Reggae Bultrón",
            "Romantic Flow",
            "Lovers Rock",
            "Raggamuffin",
            "Ragga",
            "Dancehall",
            "Ska"
          ],
          rock: [
            "Acid Rock",
            "Adult - Oriented Rock",
            "Afro Punk",
            "Adult Alternative",
            "Alternative Rock",
            "American Traditional Rock",
            "Anatolian Rock",
            "Arena Rock",
            "Art Rock",
            "Blues - Rock",
            "British Invasion",
            "Cock Rock",
            "Death Metal / Black Metal",
            "Doom Metal",
            "Glam Rock",
            "Gothic Metal",
            "Grind Core",
            "Hair Metal",
            "Hard Rock",
            "Math Metal",
            "Math Rock",
            "Metal",
            "Metal Core",
            "Noise Rock",
            "Jam Bands",
            "Post Punk",
            "Post Rock",
            "Prog - Rock / Art Rock",
            "Progressive Metal",
            "Psychedelic",
            "Rock & Roll",
            "Rockabilly",
            "Roots Rock",
            "Singer / Songwriter",
            "Southern Rock",
            "Spazzcore",
            "Stoner Metal",
            "Surf",
            "Technical Death Metal",
            "Tex - Mex",
            "Thrash Metal",
            "Time Lord Rock(Trock)",
            "Trip - hop",
            "Yacht Rock",
            "School House Rock"
          ],
          "hip-hop": [
            "Alternative Rap",
            "Avant - Garde",
            "Bounce",
            "Chap Hop",
            "Christian Hip Hop",
            "Conscious Hip Hop",
            "Country - Rap",
            "Grunk",
            "Crunkcore",
            "Cumbia Rap",
            "Dirty South",
            "East Coast",
            "Brick City Club",
            "Hardcore Hip Hop",
            "Mafioso Rap",
            "New Jersey Hip Hop",
            "Freestyle Rap",
            "G - Funk",
            "Gangsta Rap",
            "Golden Age",
            "Grime",
            "Hardcore Rap",
            "Hip - Hop",
            "Hip Pop",
            "Horrorcore",
            "Hyphy",
            "Industrial Hip Hop",
            "Instrumental Hip Hop",
            "Jazz Rap",
            "Latin Rap",
            "Low Bap",
            "Lyrical Hip Hop",
            "Merenrap",
            "Midwest Hip Hop",
            "Chicago Hip Hop",
            "Detroit Hip Hop",
            "Horrorcore",
            "St.Louis Hip Hop",
            "Twin Cities Hip Hop",
            "Motswako",
            "Nerdcore",
            "New Jack Swing",
            "New School Hip Hop",
            "Old School Rap",
            "Rap",
            "Trap",
            "Turntablism",
            "Underground Rap",
            "West Coast Rap",
            "East Coast Rap",
            "Trap",
            "UK Grime",
            "Hyphy",
            "Emo-rap",
            "Cloud rap",
            "G-funk",
            "Boom Bap",
            "Mumble",
            "Drill",
            "UK Drill",
            "Soundcloud Rap",
            "Lo-fi"
          ],
          punk: [
            "Afro-punk",
            "Anarcho punk",
            "Art punk",
            "Christian punk",
            "Crust punk",
            "Deathrock",
            "Egg punk",
            "Garage punk",
            "Glam punk",
            "Hardcore punk",
            "Horror punk",
            "Incelcore/e-punk",
            "Oi!",
            "Peace punk",
            "Punk pathetique",
            "Queercore",
            "Riot Grrrl",
            "Skate punk",
            "Street punk",
            "Taqwacore",
            "Trallpunk"
          ],
          disco: [
            "Nu-disco",
            "Disco-funk",
            "Hi-NRG",
            "Italo Disco",
            "Eurodisco",
            "Boogie",
            "Space Disco",
            "Post-disco",
            "Electro Disco",
            "Disco House",
            "Disco Pop",
            "Soulful House"
          ],
          funk: [
            "Funk Rock",
            "P-Funk (Parliament-Funkadelic)",
            "Psychedelic Funk",
            "Funk Metal",
            "Electro-Funk",
            "Go-go",
            "Boogie-Funk",
            "Jazz-Funk",
            "Soul-Funk",
            "Funky Disco",
            "Nu-Funk",
            "Afrobeat",
            "Latin Funk",
            "G-Funk",
            "Acid Jazz",
            "Funktronica",
            "Folk-Funk",
            "Space Funk",
            "Ambient Funk",
            "Hard Funk",
            "Fusion Funk"
          ],
          techno: [
            "Acid Techno",
            "Ambient Techno",
            "Detroit Techno",
            "Dub Techno",
            "Minimal Techno",
            "Industrial Techno",
            "Hard Techno",
            "Trance",
            "Progressive Techno",
            "Tech House",
            "Electronica",
            "Breakbeat Techno",
            "Electro Techno",
            "Melodic Techno",
            "Experimental Techno",
            "Dark Techno",
            "Ebm",
            "Hypnotic Techno",
            "Psychedelic Techno",
            "Rave Techno",
            "Techno-Pop"
          ],
          indie: [
            "Indie Rock",
            "Indie Pop",
            "Indie Folk",
            "Indie Electronic",
            "Indie Punk",
            "Indie Hip-Hop",
            "Dream Pop",
            "Shoegaze",
            "Lo-fi",
            "Chillwave",
            "Freak Folk",
            "Noise Pop",
            "Math Rock",
            "Post-Punk",
            "Garage Rock",
            "Experimental Indie",
            "Surf Rock",
            "Alternative Country",
            "Indie Soul",
            "Art Rock",
            "Indie R&B",
            "Indietronica",
            "Emo",
            "Post-Rock",
            "Indie Pop-Rock",
            "Indie Synthpop",
            "Noise Rock",
            "Psych Folk",
            "Indie Blues"
          ],
          gospel: [
            "Traditional Gospel",
            "Contemporary Gospel",
            "Southern Gospel",
            "Black Gospel",
            "Urban Contemporary Gospel",
            "Gospel Blues",
            "Bluegrass Gospel",
            "Country Gospel",
            "Praise and Worship",
            "Christian Hip-Hop",
            "Gospel Jazz",
            "Reggae Gospel",
            "African Gospel",
            "Latin Gospel",
            "R&B Gospel",
            "Gospel Choir",
            "Acappella Gospel",
            "Instrumental Gospel",
            "Gospel Rap"
          ],
          world: [
            "African",
            "Arabic",
            "Asian",
            "Caribbean",
            "Celtic",
            "European",
            "Latin American",
            "Middle Eastern",
            "Native American",
            "Polynesian",
            "Reggae",
            "Ska",
            "Salsa",
            "Flamenco",
            "Bossa Nova",
            "Tango",
            "Fado",
            "Klezmer",
            "Balkan",
            "Afrobeat",
            "Mongolian Throat Singing",
            "Indian Classical",
            "Gamelan",
            "Sufi Music",
            "Zydeco",
            "Kora Music",
            "Andean Music",
            "Irish Traditional",
            "Gypsy Jazz",
            "Bollywood",
            "Bhangra",
            "Jawaiian",
            "Hawaiian Slack Key Guitar",
            "Calypso",
            "Cuban Son",
            "Taiko Drumming",
            "African Highlife",
            "Merengue",
            "Tuvan Throat Singing"
          ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
          smileys_and_emotion: [
            "0x1f600",
            "0x1f603",
            "0x1f604",
            "0x1f601",
            "0x1f606",
            "0x1f605",
            "0x1f923",
            "0x1f602",
            "0x1f642",
            "0x1f643",
            "0x1fae0",
            "0x1f609",
            "0x1f60a",
            "0x1f607",
            "0x1f970",
            "0x1f60d",
            "0x1f929",
            "0x1f618",
            "0x1f617",
            "0x263a",
            "0x1f61a",
            "0x1f619",
            "0x1f972",
            "0x1f60b",
            "0x1f61b",
            "0x1f61c",
            "0x1f92a",
            "0x1f61d",
            "0x1f911",
            "0x1f917",
            "0x1f92d",
            "0x1fae2",
            "0x1fae3",
            "0x1f92b",
            "0x1f914",
            "0x1fae1",
            "0x1f910",
            "0x1f928",
            "0x1f610",
            "0x1f611",
            "0x1f636",
            "0x1fae5",
            "0x1f636",
            "0x200d",
            "0x1f32b",
            "0xfe0f",
            "0x1f60f",
            "0x1f612",
            "0x1f644",
            "0x1f62c",
            "0x1f62e",
            "0x200d",
            "0x1f4a8",
            "0x1f925",
            "0x1fae8",
            "0x1f642",
            "0x200d",
            "0x2194",
            "0xfe0f",
            "0x1f642",
            "0x200d",
            "0x2195",
            "0xfe0f",
            "0x1f60c",
            "0x1f614",
            "0x1f62a",
            "0x1f924",
            "0x1f634",
            "0x1f637",
            "0x1f912",
            "0x1f915",
            "0x1f922",
            "0x1f92e",
            "0x1f927",
            "0x1f975",
            "0x1f976",
            "0x1f974",
            "0x1f635",
            "0x1f635",
            "0x200d",
            "0x1f4ab",
            "0x1f92f",
            "0x1f920",
            "0x1f973",
            "0x1f978",
            "0x1f60e",
            "0x1f913",
            "0x1f9d0",
            "0x1f615",
            "0x1fae4",
            "0x1f61f",
            "0x1f641",
            "0x2639",
            "0x1f62e",
            "0x1f62f",
            "0x1f632",
            "0x1f633",
            "0x1f97a",
            "0x1f979",
            "0x1f626",
            "0x1f627",
            "0x1f628",
            "0x1f630",
            "0x1f625",
            "0x1f622",
            "0x1f62d",
            "0x1f631",
            "0x1f616",
            "0x1f623",
            "0x1f61e",
            "0x1f613",
            "0x1f629",
            "0x1f62b",
            "0x1f971",
            "0x1f624",
            "0x1f621",
            "0x1f620",
            "0x1f92c",
            "0x1f608",
            "0x1f47f",
            "0x1f480",
            "0x2620",
            "0x1f4a9",
            "0x1f921",
            "0x1f479",
            "0x1f47a",
            "0x1f47b",
            "0x1f47d",
            "0x1f47e",
            "0x1f916",
            "0x1f63a",
            "0x1f638",
            "0x1f639",
            "0x1f63b",
            "0x1f63c",
            "0x1f63d",
            "0x1f640",
            "0x1f63f",
            "0x1f63e",
            "0x1f648",
            "0x1f649",
            "0x1f64a",
            "0x1f48c",
            "0x1f498",
            "0x1f49d",
            "0x1f496",
            "0x1f497",
            "0x1f493",
            "0x1f49e",
            "0x1f495",
            "0x1f49f",
            "0x2763",
            "0x1f494",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f525",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1fa79",
            "0x2764",
            "0x1fa77",
            "0x1f9e1",
            "0x1f49b",
            "0x1f49a",
            "0x1f499",
            "0x1fa75",
            "0x1f49c",
            "0x1f90e",
            "0x1f5a4",
            "0x1fa76",
            "0x1f90d",
            "0x1f48b",
            "0x1f4af",
            "0x1f4a2",
            "0x1f4a5",
            "0x1f4ab",
            "0x1f4a6",
            "0x1f4a8",
            "0x1f573",
            "0x1f4ac",
            "0x1f441",
            "0xfe0f",
            "0x200d",
            "0x1f5e8",
            "0xfe0f",
            "0x1f5e8",
            "0x1f5ef",
            "0x1f4ad",
            "0x1f4a4"
          ],
          people_and_body: [
            "0x1f44b",
            "0x1f91a",
            "0x1f590",
            "0x270b",
            "0x1f596",
            "0x1faf1",
            "0x1faf2",
            "0x1faf3",
            "0x1faf4",
            "0x1faf7",
            "0x1faf8",
            "0x1f44c",
            "0x1f90c",
            "0x1f90f",
            "0x270c",
            "0x1f91e",
            "0x1faf0",
            "0x1f91f",
            "0x1f918",
            "0x1f919",
            "0x1f448",
            "0x1f449",
            "0x1f446",
            "0x1f595",
            "0x1f447",
            "0x261d",
            "0x1faf5",
            "0x1f44d",
            "0x1f44e",
            "0x270a",
            "0x1f44a",
            "0x1f91b",
            "0x1f91c",
            "0x1f44f",
            "0x1f64c",
            "0x1faf6",
            "0x1f450",
            "0x1f932",
            "0x1f91d",
            "0x1f64f",
            "0x270d",
            "0x1f485",
            "0x1f933",
            "0x1f4aa",
            "0x1f9be",
            "0x1f9bf",
            "0x1f9b5",
            "0x1f9b6",
            "0x1f442",
            "0x1f9bb",
            "0x1f443",
            "0x1f9e0",
            "0x1fac0",
            "0x1fac1",
            "0x1f9b7",
            "0x1f9b4",
            "0x1f440",
            "0x1f441",
            "0x1f445",
            "0x1f444",
            "0x1fae6",
            "0x1f476",
            "0x1f9d2",
            "0x1f466",
            "0x1f467",
            "0x1f9d1",
            "0x1f471",
            "0x1f468",
            "0x1f9d4",
            "0x1f9d4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9b0",
            "0x1f468",
            "0x200d",
            "0x1f9b1",
            "0x1f468",
            "0x200d",
            "0x1f9b3",
            "0x1f468",
            "0x200d",
            "0x1f9b2",
            "0x1f469",
            "0x1f469",
            "0x200d",
            "0x1f9b0",
            "0x1f9d1",
            "0x200d",
            "0x1f9b0",
            "0x1f469",
            "0x200d",
            "0x1f9b1",
            "0x1f9d1",
            "0x200d",
            "0x1f9b1",
            "0x1f469",
            "0x200d",
            "0x1f9b3",
            "0x1f9d1",
            "0x200d",
            "0x1f9b3",
            "0x1f469",
            "0x200d",
            "0x1f9b2",
            "0x1f9d1",
            "0x200d",
            "0x1f9b2",
            "0x1f471",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f471",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d3",
            "0x1f474",
            "0x1f475",
            "0x1f64d",
            "0x1f64d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64e",
            "0x1f64e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f645",
            "0x1f645",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f645",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f646",
            "0x1f646",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f646",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f481",
            "0x1f481",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f481",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64b",
            "0x1f64b",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64b",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cf",
            "0x1f9cf",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cf",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f647",
            "0x1f647",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f647",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f926",
            "0x1f926",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f926",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f937",
            "0x1f937",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f937",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f393",
            "0x1f468",
            "0x200d",
            "0x1f393",
            "0x1f469",
            "0x200d",
            "0x1f393",
            "0x1f9d1",
            "0x200d",
            "0x1f3eb",
            "0x1f468",
            "0x200d",
            "0x1f3eb",
            "0x1f469",
            "0x200d",
            "0x1f3eb",
            "0x1f9d1",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f33e",
            "0x1f468",
            "0x200d",
            "0x1f33e",
            "0x1f469",
            "0x200d",
            "0x1f33e",
            "0x1f9d1",
            "0x200d",
            "0x1f373",
            "0x1f468",
            "0x200d",
            "0x1f373",
            "0x1f469",
            "0x200d",
            "0x1f373",
            "0x1f9d1",
            "0x200d",
            "0x1f527",
            "0x1f468",
            "0x200d",
            "0x1f527",
            "0x1f469",
            "0x200d",
            "0x1f527",
            "0x1f9d1",
            "0x200d",
            "0x1f3ed",
            "0x1f468",
            "0x200d",
            "0x1f3ed",
            "0x1f469",
            "0x200d",
            "0x1f3ed",
            "0x1f9d1",
            "0x200d",
            "0x1f4bc",
            "0x1f468",
            "0x200d",
            "0x1f4bc",
            "0x1f469",
            "0x200d",
            "0x1f4bc",
            "0x1f9d1",
            "0x200d",
            "0x1f52c",
            "0x1f468",
            "0x200d",
            "0x1f52c",
            "0x1f469",
            "0x200d",
            "0x1f52c",
            "0x1f9d1",
            "0x200d",
            "0x1f4bb",
            "0x1f468",
            "0x200d",
            "0x1f4bb",
            "0x1f469",
            "0x200d",
            "0x1f4bb",
            "0x1f9d1",
            "0x200d",
            "0x1f3a4",
            "0x1f468",
            "0x200d",
            "0x1f3a4",
            "0x1f469",
            "0x200d",
            "0x1f3a4",
            "0x1f9d1",
            "0x200d",
            "0x1f3a8",
            "0x1f468",
            "0x200d",
            "0x1f3a8",
            "0x1f469",
            "0x200d",
            "0x1f3a8",
            "0x1f9d1",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f680",
            "0x1f468",
            "0x200d",
            "0x1f680",
            "0x1f469",
            "0x200d",
            "0x1f680",
            "0x1f9d1",
            "0x200d",
            "0x1f692",
            "0x1f468",
            "0x200d",
            "0x1f692",
            "0x1f469",
            "0x200d",
            "0x1f692",
            "0x1f46e",
            "0x1f46e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f575",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f482",
            "0x1f482",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f482",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f977",
            "0x1f477",
            "0x1f477",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f477",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1fac5",
            "0x1f934",
            "0x1f478",
            "0x1f473",
            "0x1f473",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f473",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f472",
            "0x1f9d5",
            "0x1f935",
            "0x1f935",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f935",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f470",
            "0x1f470",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f470",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f930",
            "0x1fac3",
            "0x1fac4",
            "0x1f931",
            "0x1f469",
            "0x200d",
            "0x1f37c",
            "0x1f468",
            "0x200d",
            "0x1f37c",
            "0x1f9d1",
            "0x200d",
            "0x1f37c",
            "0x1f47c",
            "0x1f385",
            "0x1f936",
            "0x1f9d1",
            "0x200d",
            "0x1f384",
            "0x1f9b8",
            "0x1f9b8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9b9",
            "0x1f9b9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d9",
            "0x1f9d9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9da",
            "0x1f9da",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9da",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9db",
            "0x1f9db",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9db",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dc",
            "0x1f9dc",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dc",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dd",
            "0x1f9dd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9de",
            "0x1f9de",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9de",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9df",
            "0x1f9df",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9df",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cc",
            "0x1f486",
            "0x1f486",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f486",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f487",
            "0x1f487",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f487",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9cd",
            "0x1f9cd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f483",
            "0x1f57a",
            "0x1f574",
            "0x1f46f",
            "0x1f46f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d6",
            "0x1f9d6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d7",
            "0x1f9d7",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d7",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93a",
            "0x1f3c7",
            "0x26f7",
            "0x1f3c2",
            "0x1f3cc",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c4",
            "0x1f3c4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6a3",
            "0x1f6a3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6a3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3ca",
            "0x1f3ca",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3ca",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x26f9",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3cb",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b4",
            "0x1f6b4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b5",
            "0x1f6b5",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b5",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f938",
            "0x1f938",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f938",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93c",
            "0x1f93c",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93c",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93d",
            "0x1f93d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93e",
            "0x1f93e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f939",
            "0x1f939",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f939",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d8",
            "0x1f9d8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6c0",
            "0x1f6cc",
            "0x1f9d1",
            "0x200d",
            "0x1f91d",
            "0x200d",
            "0x1f9d1",
            "0x1f46d",
            "0x1f46b",
            "0x1f46c",
            "0x1f48f",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f469",
            "0x1f491",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f469",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f5e3",
            "0x1f464",
            "0x1f465",
            "0x1fac2",
            "0x1f46a",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f463"
          ],
          animals_and_nature: [
            "0x1f435",
            "0x1f412",
            "0x1f98d",
            "0x1f9a7",
            "0x1f436",
            "0x1f415",
            "0x1f9ae",
            "0x1f415",
            "0x200d",
            "0x1f9ba",
            "0x1f429",
            "0x1f43a",
            "0x1f98a",
            "0x1f99d",
            "0x1f431",
            "0x1f408",
            "0x1f408",
            "0x200d",
            "0x2b1b",
            "0x1f981",
            "0x1f42f",
            "0x1f405",
            "0x1f406",
            "0x1f434",
            "0x1face",
            "0x1facf",
            "0x1f40e",
            "0x1f984",
            "0x1f993",
            "0x1f98c",
            "0x1f9ac",
            "0x1f42e",
            "0x1f402",
            "0x1f403",
            "0x1f404",
            "0x1f437",
            "0x1f416",
            "0x1f417",
            "0x1f43d",
            "0x1f40f",
            "0x1f411",
            "0x1f410",
            "0x1f42a",
            "0x1f42b",
            "0x1f999",
            "0x1f992",
            "0x1f418",
            "0x1f9a3",
            "0x1f98f",
            "0x1f99b",
            "0x1f42d",
            "0x1f401",
            "0x1f400",
            "0x1f439",
            "0x1f430",
            "0x1f407",
            "0x1f43f",
            "0x1f9ab",
            "0x1f994",
            "0x1f987",
            "0x1f43b",
            "0x1f43b",
            "0x200d",
            "0x2744",
            "0xfe0f",
            "0x1f428",
            "0x1f43c",
            "0x1f9a5",
            "0x1f9a6",
            "0x1f9a8",
            "0x1f998",
            "0x1f9a1",
            "0x1f43e",
            "0x1f983",
            "0x1f414",
            "0x1f413",
            "0x1f423",
            "0x1f424",
            "0x1f425",
            "0x1f426",
            "0x1f427",
            "0x1f54a",
            "0x1f985",
            "0x1f986",
            "0x1f9a2",
            "0x1f989",
            "0x1f9a4",
            "0x1fab6",
            "0x1f9a9",
            "0x1f99a",
            "0x1f99c",
            "0x1fabd",
            "0x1f426",
            "0x200d",
            "0x2b1b",
            "0x1fabf",
            "0x1f426",
            "0x200d",
            "0x1f525",
            "0x1f438",
            "0x1f40a",
            "0x1f422",
            "0x1f98e",
            "0x1f40d",
            "0x1f432",
            "0x1f409",
            "0x1f995",
            "0x1f996",
            "0x1f433",
            "0x1f40b",
            "0x1f42c",
            "0x1f9ad",
            "0x1f41f",
            "0x1f420",
            "0x1f421",
            "0x1f988",
            "0x1f419",
            "0x1f41a",
            "0x1fab8",
            "0x1fabc",
            "0x1f40c",
            "0x1f98b",
            "0x1f41b",
            "0x1f41c",
            "0x1f41d",
            "0x1fab2",
            "0x1f41e",
            "0x1f997",
            "0x1fab3",
            "0x1f577",
            "0x1f578",
            "0x1f982",
            "0x1f99f",
            "0x1fab0",
            "0x1fab1",
            "0x1f9a0",
            "0x1f490",
            "0x1f338",
            "0x1f4ae",
            "0x1fab7",
            "0x1f3f5",
            "0x1f339",
            "0x1f940",
            "0x1f33a",
            "0x1f33b",
            "0x1f33c",
            "0x1f337",
            "0x1fabb",
            "0x1f331",
            "0x1fab4",
            "0x1f332",
            "0x1f333",
            "0x1f334",
            "0x1f335",
            "0x1f33e",
            "0x1f33f",
            "0x2618",
            "0x1f340",
            "0x1f341",
            "0x1f342",
            "0x1f343",
            "0x1fab9",
            "0x1faba",
            "0x1f344"
          ],
          food_and_drink: [
            "0x1f347",
            "0x1f348",
            "0x1f349",
            "0x1f34a",
            "0x1f34b",
            "0x1f34b",
            "0x200d",
            "0x1f7e9",
            "0x1f34c",
            "0x1f34d",
            "0x1f96d",
            "0x1f34e",
            "0x1f34f",
            "0x1f350",
            "0x1f351",
            "0x1f352",
            "0x1f353",
            "0x1fad0",
            "0x1f95d",
            "0x1f345",
            "0x1fad2",
            "0x1f965",
            "0x1f951",
            "0x1f346",
            "0x1f954",
            "0x1f955",
            "0x1f33d",
            "0x1f336",
            "0x1fad1",
            "0x1f952",
            "0x1f96c",
            "0x1f966",
            "0x1f9c4",
            "0x1f9c5",
            "0x1f95c",
            "0x1fad8",
            "0x1f330",
            "0x1fada",
            "0x1fadb",
            "0x1f344",
            "0x200d",
            "0x1f7eb",
            "0x1f35e",
            "0x1f950",
            "0x1f956",
            "0x1fad3",
            "0x1f968",
            "0x1f96f",
            "0x1f95e",
            "0x1f9c7",
            "0x1f9c0",
            "0x1f356",
            "0x1f357",
            "0x1f969",
            "0x1f953",
            "0x1f354",
            "0x1f35f",
            "0x1f355",
            "0x1f32d",
            "0x1f96a",
            "0x1f32e",
            "0x1f32f",
            "0x1fad4",
            "0x1f959",
            "0x1f9c6",
            "0x1f95a",
            "0x1f373",
            "0x1f958",
            "0x1f372",
            "0x1fad5",
            "0x1f963",
            "0x1f957",
            "0x1f37f",
            "0x1f9c8",
            "0x1f9c2",
            "0x1f96b",
            "0x1f371",
            "0x1f358",
            "0x1f359",
            "0x1f35a",
            "0x1f35b",
            "0x1f35c",
            "0x1f35d",
            "0x1f360",
            "0x1f362",
            "0x1f363",
            "0x1f364",
            "0x1f365",
            "0x1f96e",
            "0x1f361",
            "0x1f95f",
            "0x1f960",
            "0x1f961",
            "0x1f980",
            "0x1f99e",
            "0x1f990",
            "0x1f991",
            "0x1f9aa",
            "0x1f366",
            "0x1f367",
            "0x1f368",
            "0x1f369",
            "0x1f36a",
            "0x1f382",
            "0x1f370",
            "0x1f9c1",
            "0x1f967",
            "0x1f36b",
            "0x1f36c",
            "0x1f36d",
            "0x1f36e",
            "0x1f36f",
            "0x1f37c",
            "0x1f95b",
            "0x2615",
            "0x1fad6",
            "0x1f375",
            "0x1f376",
            "0x1f37e",
            "0x1f377",
            "0x1f378",
            "0x1f379",
            "0x1f37a",
            "0x1f37b",
            "0x1f942",
            "0x1f943",
            "0x1fad7",
            "0x1f964",
            "0x1f9cb",
            "0x1f9c3",
            "0x1f9c9",
            "0x1f9ca",
            "0x1f962",
            "0x1f37d",
            "0x1f374",
            "0x1f944",
            "0x1f52a",
            "0x1fad9",
            "0x1f3fa"
          ],
          travel_and_places: [
            "0x1f30d",
            "0x1f30e",
            "0x1f30f",
            "0x1f310",
            "0x1f5fa",
            "0x1f5fe",
            "0x1f9ed",
            "0x1f3d4",
            "0x26f0",
            "0x1f30b",
            "0x1f5fb",
            "0x1f3d5",
            "0x1f3d6",
            "0x1f3dc",
            "0x1f3dd",
            "0x1f3de",
            "0x1f3df",
            "0x1f3db",
            "0x1f3d7",
            "0x1f9f1",
            "0x1faa8",
            "0x1fab5",
            "0x1f6d6",
            "0x1f3d8",
            "0x1f3da",
            "0x1f3e0",
            "0x1f3e1",
            "0x1f3e2",
            "0x1f3e3",
            "0x1f3e4",
            "0x1f3e5",
            "0x1f3e6",
            "0x1f3e8",
            "0x1f3e9",
            "0x1f3ea",
            "0x1f3eb",
            "0x1f3ec",
            "0x1f3ed",
            "0x1f3ef",
            "0x1f3f0",
            "0x1f492",
            "0x1f5fc",
            "0x1f5fd",
            "0x26ea",
            "0x1f54c",
            "0x1f6d5",
            "0x1f54d",
            "0x26e9",
            "0x1f54b",
            "0x26f2",
            "0x26fa",
            "0x1f301",
            "0x1f303",
            "0x1f3d9",
            "0x1f304",
            "0x1f305",
            "0x1f306",
            "0x1f307",
            "0x1f309",
            "0x2668",
            "0x1f3a0",
            "0x1f6dd",
            "0x1f3a1",
            "0x1f3a2",
            "0x1f488",
            "0x1f3aa",
            "0x1f682",
            "0x1f683",
            "0x1f684",
            "0x1f685",
            "0x1f686",
            "0x1f687",
            "0x1f688",
            "0x1f689",
            "0x1f68a",
            "0x1f69d",
            "0x1f69e",
            "0x1f68b",
            "0x1f68c",
            "0x1f68d",
            "0x1f68e",
            "0x1f690",
            "0x1f691",
            "0x1f692",
            "0x1f693",
            "0x1f694",
            "0x1f695",
            "0x1f696",
            "0x1f697",
            "0x1f698",
            "0x1f699",
            "0x1f6fb",
            "0x1f69a",
            "0x1f69b",
            "0x1f69c",
            "0x1f3ce",
            "0x1f3cd",
            "0x1f6f5",
            "0x1f9bd",
            "0x1f9bc",
            "0x1f6fa",
            "0x1f6b2",
            "0x1f6f4",
            "0x1f6f9",
            "0x1f6fc",
            "0x1f68f",
            "0x1f6e3",
            "0x1f6e4",
            "0x1f6e2",
            "0x26fd",
            "0x1f6de",
            "0x1f6a8",
            "0x1f6a5",
            "0x1f6a6",
            "0x1f6d1",
            "0x1f6a7",
            "0x2693",
            "0x1f6df",
            "0x26f5",
            "0x1f6f6",
            "0x1f6a4",
            "0x1f6f3",
            "0x26f4",
            "0x1f6e5",
            "0x1f6a2",
            "0x2708",
            "0x1f6e9",
            "0x1f6eb",
            "0x1f6ec",
            "0x1fa82",
            "0x1f4ba",
            "0x1f681",
            "0x1f69f",
            "0x1f6a0",
            "0x1f6a1",
            "0x1f6f0",
            "0x1f680",
            "0x1f6f8",
            "0x1f6ce",
            "0x1f9f3",
            "0x231b",
            "0x23f3",
            "0x231a",
            "0x23f0",
            "0x23f1",
            "0x23f2",
            "0x1f570",
            "0x1f55b",
            "0x1f567",
            "0x1f550",
            "0x1f55c",
            "0x1f551",
            "0x1f55d",
            "0x1f552",
            "0x1f55e",
            "0x1f553",
            "0x1f55f",
            "0x1f554",
            "0x1f560",
            "0x1f555",
            "0x1f561",
            "0x1f556",
            "0x1f562",
            "0x1f557",
            "0x1f563",
            "0x1f558",
            "0x1f564",
            "0x1f559",
            "0x1f565",
            "0x1f55a",
            "0x1f566",
            "0x1f311",
            "0x1f312",
            "0x1f313",
            "0x1f314",
            "0x1f315",
            "0x1f316",
            "0x1f317",
            "0x1f318",
            "0x1f319",
            "0x1f31a",
            "0x1f31b",
            "0x1f31c",
            "0x1f321",
            "0x2600",
            "0x1f31d",
            "0x1f31e",
            "0x1fa90",
            "0x2b50",
            "0x1f31f",
            "0x1f320",
            "0x1f30c",
            "0x2601",
            "0x26c5",
            "0x26c8",
            "0x1f324",
            "0x1f325",
            "0x1f326",
            "0x1f327",
            "0x1f328",
            "0x1f329",
            "0x1f32a",
            "0x1f32b",
            "0x1f32c",
            "0x1f300",
            "0x1f308",
            "0x1f302",
            "0x2602",
            "0x2614",
            "0x26f1",
            "0x26a1",
            "0x2744",
            "0x2603",
            "0x26c4",
            "0x2604",
            "0x1f525",
            "0x1f4a7",
            "0x1f30a"
          ],
          activities: [
            "0x1f383",
            "0x1f384",
            "0x1f386",
            "0x1f387",
            "0x1f9e8",
            "0x2728",
            "0x1f388",
            "0x1f389",
            "0x1f38a",
            "0x1f38b",
            "0x1f38d",
            "0x1f38e",
            "0x1f38f",
            "0x1f390",
            "0x1f391",
            "0x1f9e7",
            "0x1f380",
            "0x1f381",
            "0x1f397",
            "0x1f39f",
            "0x1f3ab",
            "0x1f396",
            "0x1f3c6",
            "0x1f3c5",
            "0x1f947",
            "0x1f948",
            "0x1f949",
            "0x26bd",
            "0x26be",
            "0x1f94e",
            "0x1f3c0",
            "0x1f3d0",
            "0x1f3c8",
            "0x1f3c9",
            "0x1f3be",
            "0x1f94f",
            "0x1f3b3",
            "0x1f3cf",
            "0x1f3d1",
            "0x1f3d2",
            "0x1f94d",
            "0x1f3d3",
            "0x1f3f8",
            "0x1f94a",
            "0x1f94b",
            "0x1f945",
            "0x26f3",
            "0x26f8",
            "0x1f3a3",
            "0x1f93f",
            "0x1f3bd",
            "0x1f3bf",
            "0x1f6f7",
            "0x1f94c",
            "0x1f3af",
            "0x1fa80",
            "0x1fa81",
            "0x1f52b",
            "0x1f3b1",
            "0x1f52e",
            "0x1fa84",
            "0x1f3ae",
            "0x1f579",
            "0x1f3b0",
            "0x1f3b2",
            "0x1f9e9",
            "0x1f9f8",
            "0x1fa85",
            "0x1faa9",
            "0x1fa86",
            "0x2660",
            "0x2665",
            "0x2666",
            "0x2663",
            "0x265f",
            "0x1f0cf",
            "0x1f004",
            "0x1f3b4",
            "0x1f3ad",
            "0x1f5bc",
            "0x1f3a8",
            "0x1f9f5",
            "0x1faa1",
            "0x1f9f6",
            "0x1faa2"
          ],
          objects: [
            "0x1f453",
            "0x1f576",
            "0x1f97d",
            "0x1f97c",
            "0x1f9ba",
            "0x1f454",
            "0x1f455",
            "0x1f456",
            "0x1f9e3",
            "0x1f9e4",
            "0x1f9e5",
            "0x1f9e6",
            "0x1f457",
            "0x1f458",
            "0x1f97b",
            "0x1fa71",
            "0x1fa72",
            "0x1fa73",
            "0x1f459",
            "0x1f45a",
            "0x1faad",
            "0x1f45b",
            "0x1f45c",
            "0x1f45d",
            "0x1f6cd",
            "0x1f392",
            "0x1fa74",
            "0x1f45e",
            "0x1f45f",
            "0x1f97e",
            "0x1f97f",
            "0x1f460",
            "0x1f461",
            "0x1fa70",
            "0x1f462",
            "0x1faae",
            "0x1f451",
            "0x1f452",
            "0x1f3a9",
            "0x1f393",
            "0x1f9e2",
            "0x1fa96",
            "0x26d1",
            "0x1f4ff",
            "0x1f484",
            "0x1f48d",
            "0x1f48e",
            "0x1f507",
            "0x1f508",
            "0x1f509",
            "0x1f50a",
            "0x1f4e2",
            "0x1f4e3",
            "0x1f4ef",
            "0x1f514",
            "0x1f515",
            "0x1f3bc",
            "0x1f3b5",
            "0x1f3b6",
            "0x1f399",
            "0x1f39a",
            "0x1f39b",
            "0x1f3a4",
            "0x1f3a7",
            "0x1f4fb",
            "0x1f3b7",
            "0x1fa97",
            "0x1f3b8",
            "0x1f3b9",
            "0x1f3ba",
            "0x1f3bb",
            "0x1fa95",
            "0x1f941",
            "0x1fa98",
            "0x1fa87",
            "0x1fa88",
            "0x1f4f1",
            "0x1f4f2",
            "0x260e",
            "0x1f4de",
            "0x1f4df",
            "0x1f4e0",
            "0x1f50b",
            "0x1faab",
            "0x1f50c",
            "0x1f4bb",
            "0x1f5a5",
            "0x1f5a8",
            "0x2328",
            "0x1f5b1",
            "0x1f5b2",
            "0x1f4bd",
            "0x1f4be",
            "0x1f4bf",
            "0x1f4c0",
            "0x1f9ee",
            "0x1f3a5",
            "0x1f39e",
            "0x1f4fd",
            "0x1f3ac",
            "0x1f4fa",
            "0x1f4f7",
            "0x1f4f8",
            "0x1f4f9",
            "0x1f4fc",
            "0x1f50d",
            "0x1f50e",
            "0x1f56f",
            "0x1f4a1",
            "0x1f526",
            "0x1f3ee",
            "0x1fa94",
            "0x1f4d4",
            "0x1f4d5",
            "0x1f4d6",
            "0x1f4d7",
            "0x1f4d8",
            "0x1f4d9",
            "0x1f4da",
            "0x1f4d3",
            "0x1f4d2",
            "0x1f4c3",
            "0x1f4dc",
            "0x1f4c4",
            "0x1f4f0",
            "0x1f5de",
            "0x1f4d1",
            "0x1f516",
            "0x1f3f7",
            "0x1f4b0",
            "0x1fa99",
            "0x1f4b4",
            "0x1f4b5",
            "0x1f4b6",
            "0x1f4b7",
            "0x1f4b8",
            "0x1f4b3",
            "0x1f9fe",
            "0x1f4b9",
            "0x2709",
            "0x1f4e7",
            "0x1f4e8",
            "0x1f4e9",
            "0x1f4e4",
            "0x1f4e5",
            "0x1f4e6",
            "0x1f4eb",
            "0x1f4ea",
            "0x1f4ec",
            "0x1f4ed",
            "0x1f4ee",
            "0x1f5f3",
            "0x270f",
            "0x2712",
            "0x1f58b",
            "0x1f58a",
            "0x1f58c",
            "0x1f58d",
            "0x1f4dd",
            "0x1f4bc",
            "0x1f4c1",
            "0x1f4c2",
            "0x1f5c2",
            "0x1f4c5",
            "0x1f4c6",
            "0x1f5d2",
            "0x1f5d3",
            "0x1f4c7",
            "0x1f4c8",
            "0x1f4c9",
            "0x1f4ca",
            "0x1f4cb",
            "0x1f4cc",
            "0x1f4cd",
            "0x1f4ce",
            "0x1f587",
            "0x1f4cf",
            "0x1f4d0",
            "0x2702",
            "0x1f5c3",
            "0x1f5c4",
            "0x1f5d1",
            "0x1f512",
            "0x1f513",
            "0x1f50f",
            "0x1f510",
            "0x1f511",
            "0x1f5dd",
            "0x1f528",
            "0x1fa93",
            "0x26cf",
            "0x2692",
            "0x1f6e0",
            "0x1f5e1",
            "0x2694",
            "0x1f4a3",
            "0x1fa83",
            "0x1f3f9",
            "0x1f6e1",
            "0x1fa9a",
            "0x1f527",
            "0x1fa9b",
            "0x1f529",
            "0x2699",
            "0x1f5dc",
            "0x2696",
            "0x1f9af",
            "0x1f517",
            "0x26d3",
            "0xfe0f",
            "0x200d",
            "0x1f4a5",
            "0x26d3",
            "0x1fa9d",
            "0x1f9f0",
            "0x1f9f2",
            "0x1fa9c",
            "0x2697",
            "0x1f9ea",
            "0x1f9eb",
            "0x1f9ec",
            "0x1f52c",
            "0x1f52d",
            "0x1f4e1",
            "0x1f489",
            "0x1fa78",
            "0x1f48a",
            "0x1fa79",
            "0x1fa7c",
            "0x1fa7a",
            "0x1fa7b",
            "0x1f6aa",
            "0x1f6d7",
            "0x1fa9e",
            "0x1fa9f",
            "0x1f6cf",
            "0x1f6cb",
            "0x1fa91",
            "0x1f6bd",
            "0x1faa0",
            "0x1f6bf",
            "0x1f6c1",
            "0x1faa4",
            "0x1fa92",
            "0x1f9f4",
            "0x1f9f7",
            "0x1f9f9",
            "0x1f9fa",
            "0x1f9fb",
            "0x1faa3",
            "0x1f9fc",
            "0x1fae7",
            "0x1faa5",
            "0x1f9fd",
            "0x1f9ef",
            "0x1f6d2",
            "0x1f6ac",
            "0x26b0",
            "0x1faa6",
            "0x26b1",
            "0x1f9ff",
            "0x1faac",
            "0x1f5ff",
            "0x1faa7",
            "0x1faaa"
          ],
          symbols: [
            "0x1f3e7",
            "0x1f6ae",
            "0x1f6b0",
            "0x267f",
            "0x1f6b9",
            "0x1f6ba",
            "0x1f6bb",
            "0x1f6bc",
            "0x1f6be",
            "0x1f6c2",
            "0x1f6c3",
            "0x1f6c4",
            "0x1f6c5",
            "0x26a0",
            "0x1f6b8",
            "0x26d4",
            "0x1f6ab",
            "0x1f6b3",
            "0x1f6ad",
            "0x1f6af",
            "0x1f6b1",
            "0x1f6b7",
            "0x1f4f5",
            "0x1f51e",
            "0x2622",
            "0x2623",
            "0x2b06",
            "0x2197",
            "0x27a1",
            "0x2198",
            "0x2b07",
            "0x2199",
            "0x2b05",
            "0x2196",
            "0x2195",
            "0x2194",
            "0x21a9",
            "0x21aa",
            "0x2934",
            "0x2935",
            "0x1f503",
            "0x1f504",
            "0x1f519",
            "0x1f51a",
            "0x1f51b",
            "0x1f51c",
            "0x1f51d",
            "0x1f6d0",
            "0x269b",
            "0x1f549",
            "0x2721",
            "0x2638",
            "0x262f",
            "0x271d",
            "0x2626",
            "0x262a",
            "0x262e",
            "0x1f54e",
            "0x1f52f",
            "0x1faaf",
            "0x2648",
            "0x2649",
            "0x264a",
            "0x264b",
            "0x264c",
            "0x264d",
            "0x264e",
            "0x264f",
            "0x2650",
            "0x2651",
            "0x2652",
            "0x2653",
            "0x26ce",
            "0x1f500",
            "0x1f501",
            "0x1f502",
            "0x25b6",
            "0x23e9",
            "0x23ed",
            "0x23ef",
            "0x25c0",
            "0x23ea",
            "0x23ee",
            "0x1f53c",
            "0x23eb",
            "0x1f53d",
            "0x23ec",
            "0x23f8",
            "0x23f9",
            "0x23fa",
            "0x23cf",
            "0x1f3a6",
            "0x1f505",
            "0x1f506",
            "0x1f4f6",
            "0x1f6dc",
            "0x1f4f3",
            "0x1f4f4",
            "0x2640",
            "0x2642",
            "0x26a7",
            "0x2716",
            "0x2795",
            "0x2796",
            "0x2797",
            "0x1f7f0",
            "0x267e",
            "0x203c",
            "0x2049",
            "0x2753",
            "0x2754",
            "0x2755",
            "0x2757",
            "0x3030",
            "0x1f4b1",
            "0x1f4b2",
            "0x2695",
            "0x267b",
            "0x269c",
            "0x1f531",
            "0x1f4db",
            "0x1f530",
            "0x2b55",
            "0x2705",
            "0x2611",
            "0x2714",
            "0x274c",
            "0x274e",
            "0x27b0",
            "0x27bf",
            "0x303d",
            "0x2733",
            "0x2734",
            "0x2747",
            "0x00a9",
            "0x00ae",
            "0x2122",
            "0x0023",
            "0xfe0f",
            "0x20e3",
            "0x002a",
            "0xfe0f",
            "0x20e3",
            "0x0030",
            "0xfe0f",
            "0x20e3",
            "0x0031",
            "0xfe0f",
            "0x20e3",
            "0x0032",
            "0xfe0f",
            "0x20e3",
            "0x0033",
            "0xfe0f",
            "0x20e3",
            "0x0034",
            "0xfe0f",
            "0x20e3",
            "0x0035",
            "0xfe0f",
            "0x20e3",
            "0x0036",
            "0xfe0f",
            "0x20e3",
            "0x0037",
            "0xfe0f",
            "0x20e3",
            "0x0038",
            "0xfe0f",
            "0x20e3",
            "0x0039",
            "0xfe0f",
            "0x20e3",
            "0x1f51f",
            "0x1f520",
            "0x1f521",
            "0x1f522",
            "0x1f523",
            "0x1f524",
            "0x1f170",
            "0x1f18e",
            "0x1f171",
            "0x1f191",
            "0x1f192",
            "0x1f193",
            "0x2139",
            "0x1f194",
            "0x24c2",
            "0x1f195",
            "0x1f196",
            "0x1f17e",
            "0x1f197",
            "0x1f17f",
            "0x1f198",
            "0x1f199",
            "0x1f19a",
            "0x1f201",
            "0x1f202",
            "0x1f237",
            "0x1f236",
            "0x1f22f",
            "0x1f250",
            "0x1f239",
            "0x1f21a",
            "0x1f232",
            "0x1f251",
            "0x1f238",
            "0x1f234",
            "0x1f233",
            "0x3297",
            "0x3299",
            "0x1f23a",
            "0x1f235",
            "0x1f534",
            "0x1f7e0",
            "0x1f7e1",
            "0x1f7e2",
            "0x1f535",
            "0x1f7e3",
            "0x1f7e4",
            "0x26ab",
            "0x26aa",
            "0x1f7e5",
            "0x1f7e7",
            "0x1f7e8",
            "0x1f7e9",
            "0x1f7e6",
            "0x1f7ea",
            "0x1f7eb",
            "0x2b1b",
            "0x2b1c",
            "0x25fc",
            "0x25fb",
            "0x25fe",
            "0x25fd",
            "0x25aa",
            "0x25ab",
            "0x1f536",
            "0x1f537",
            "0x1f538",
            "0x1f539",
            "0x1f53a",
            "0x1f53b",
            "0x1f4a0",
            "0x1f518",
            "0x1f533",
            "0x1f532"
          ],
          flags: [
            "0x1f3c1",
            "0x1f6a9",
            "0x1f38c",
            "0x1f3f4",
            "0x1f3f3",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x1f308",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x26a7",
            "0xfe0f",
            "0x1f3f4",
            "0x200d",
            "0x2620",
            "0xfe0f",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e9",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1eb",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ee",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f4",
            "0x1f1e6",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fc",
            "0x1f1e6",
            "0x1f1fd",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1e7",
            "0x1f1e6",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e9",
            "0x1f1e7",
            "0x1f1ea",
            "0x1f1e7",
            "0x1f1eb",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ed",
            "0x1f1e7",
            "0x1f1ee",
            "0x1f1e7",
            "0x1f1ef",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f2",
            "0x1f1e7",
            "0x1f1f3",
            "0x1f1e7",
            "0x1f1f4",
            "0x1f1e7",
            "0x1f1f6",
            "0x1f1e7",
            "0x1f1f7",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f9",
            "0x1f1e7",
            "0x1f1fb",
            "0x1f1e7",
            "0x1f1fc",
            "0x1f1e7",
            "0x1f1fe",
            "0x1f1e7",
            "0x1f1ff",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e9",
            "0x1f1e8",
            "0x1f1eb",
            "0x1f1e8",
            "0x1f1ec",
            "0x1f1e8",
            "0x1f1ed",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1f0",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f4",
            "0x1f1e8",
            "0x1f1f5",
            "0x1f1e8",
            "0x1f1f7",
            "0x1f1e8",
            "0x1f1fa",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fc",
            "0x1f1e8",
            "0x1f1fd",
            "0x1f1e8",
            "0x1f1fe",
            "0x1f1e8",
            "0x1f1ff",
            "0x1f1e9",
            "0x1f1ea",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ef",
            "0x1f1e9",
            "0x1f1f0",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f4",
            "0x1f1e9",
            "0x1f1ff",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e8",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ed",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f9",
            "0x1f1ea",
            "0x1f1fa",
            "0x1f1eb",
            "0x1f1ee",
            "0x1f1eb",
            "0x1f1ef",
            "0x1f1eb",
            "0x1f1f0",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f4",
            "0x1f1eb",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1eb",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ed",
            "0x1f1ec",
            "0x1f1ee",
            "0x1f1ec",
            "0x1f1f1",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f6",
            "0x1f1ec",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fc",
            "0x1f1ec",
            "0x1f1fe",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f3",
            "0x1f1ed",
            "0x1f1f7",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1fa",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e9",
            "0x1f1ee",
            "0x1f1ea",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f2",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f4",
            "0x1f1ee",
            "0x1f1f6",
            "0x1f1ee",
            "0x1f1f7",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1ea",
            "0x1f1ef",
            "0x1f1f2",
            "0x1f1ef",
            "0x1f1f4",
            "0x1f1ef",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1ea",
            "0x1f1f0",
            "0x1f1ec",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ee",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f3",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f7",
            "0x1f1f0",
            "0x1f1fc",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1f0",
            "0x1f1ff",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1f0",
            "0x1f1f1",
            "0x1f1f7",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1fa",
            "0x1f1f1",
            "0x1f1fb",
            "0x1f1f1",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1ea",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f1",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f3",
            "0x1f1f2",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f6",
            "0x1f1f2",
            "0x1f1f7",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fb",
            "0x1f1f2",
            "0x1f1fc",
            "0x1f1f2",
            "0x1f1fd",
            "0x1f1f2",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1f3",
            "0x1f1e6",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1ea",
            "0x1f1f3",
            "0x1f1eb",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1f1",
            "0x1f1f3",
            "0x1f1f4",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f7",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1ff",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1e6",
            "0x1f1f5",
            "0x1f1ea",
            "0x1f1f5",
            "0x1f1eb",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ed",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f1",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f7",
            "0x1f1f5",
            "0x1f1f8",
            "0x1f1f5",
            "0x1f1f9",
            "0x1f1f5",
            "0x1f1fc",
            "0x1f1f5",
            "0x1f1fe",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1f4",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1fa",
            "0x1f1f7",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e8",
            "0x1f1f8",
            "0x1f1e9",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ed",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ef",
            "0x1f1f8",
            "0x1f1f0",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f3",
            "0x1f1f8",
            "0x1f1f4",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f9",
            "0x1f1f8",
            "0x1f1fb",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f8",
            "0x1f1fe",
            "0x1f1f8",
            "0x1f1ff",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e8",
            "0x1f1f9",
            "0x1f1e9",
            "0x1f1f9",
            "0x1f1eb",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1f9",
            "0x1f1f0",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f3",
            "0x1f1f9",
            "0x1f1f4",
            "0x1f1f9",
            "0x1f1f7",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1fb",
            "0x1f1f9",
            "0x1f1fc",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f8",
            "0x1f1fa",
            "0x1f1fe",
            "0x1f1fa",
            "0x1f1ff",
            "0x1f1fb",
            "0x1f1e6",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1ea",
            "0x1f1fb",
            "0x1f1ec",
            "0x1f1fb",
            "0x1f1ee",
            "0x1f1fb",
            "0x1f1f3",
            "0x1f1fb",
            "0x1f1fa",
            "0x1f1fc",
            "0x1f1eb",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1ea",
            "0x1f1fe",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1fc",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0065",
            "0xe006e",
            "0xe0067",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0073",
            "0xe0063",
            "0xe0074",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0077",
            "0xe006c",
            "0xe0073",
            "0xe007f"
          ]
        }
      }, S = Object.prototype.hasOwnProperty, A = Object.keys || function(d) {
        var m = [];
        for (var v in d)
          S.call(d, v) && m.push(v);
        return m;
      };
      function I(d, m) {
        for (var v = A(d), k, O = 0, G = v.length; O < G; O++)
          k = v[O], m[k] = d[k] || m[k];
      }
      function M(d, m) {
        for (var v = 0, k = d.length; v < k; v++)
          m[v] = d[v];
      }
      function B(d, m) {
        var v = Array.isArray(d), k = m || (v ? new Array(d.length) : {});
        return v ? M(d, k) : I(d, k), k;
      }
      u.prototype.get = function(d) {
        return B(x[d]);
      }, u.prototype.mac_address = function(d) {
        d = f(d), d.separator || (d.separator = d.networkVersion ? "." : ":");
        var m = "ABCDEF1234567890", v = "";
        return d.networkVersion ? v = this.n(this.string, 3, { pool: m, length: 4 }).join(d.separator) : v = this.n(this.string, 6, { pool: m, length: 2 }).join(d.separator), v;
      }, u.prototype.normal = function(d) {
        if (d = f(d, { mean: 0, dev: 1, pool: [] }), p(
          d.pool.constructor !== Array,
          "Chance: The pool option must be a valid array."
        ), p(
          typeof d.mean != "number",
          "Chance: Mean (mean) must be a number"
        ), p(
          typeof d.dev != "number",
          "Chance: Standard deviation (dev) must be a number"
        ), d.pool.length > 0)
          return this.normal_pool(d);
        var m, v, k, O, G = d.mean, H = d.dev;
        do
          v = this.random() * 2 - 1, k = this.random() * 2 - 1, m = v * v + k * k;
        while (m >= 1);
        return O = v * Math.sqrt(-2 * Math.log(m) / m), H * O + G;
      }, u.prototype.normal_pool = function(d) {
        var m = 0;
        do {
          var v = Math.round(this.normal({ mean: d.mean, dev: d.dev }));
          if (v < d.pool.length && v >= 0)
            return d.pool[v];
          m++;
        } while (m < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
      }, u.prototype.radio = function(d) {
        d = f(d, { side: "?" });
        var m = "";
        switch (d.side.toLowerCase()) {
          case "east":
          case "e":
            m = "W";
            break;
          case "west":
          case "w":
            m = "K";
            break;
          default:
            m = this.character({ pool: "KW" });
            break;
        }
        return m + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" });
      }, u.prototype.set = function(d, m) {
        typeof d == "string" ? x[d] = m : x = B(d, x);
      }, u.prototype.tv = function(d) {
        return this.radio(d);
      }, u.prototype.cnpj = function() {
        var d = this.n(this.natural, 8, { max: 9 }), m = 2 + d[7] * 6 + d[6] * 7 + d[5] * 8 + d[4] * 9 + d[3] * 2 + d[2] * 3 + d[1] * 4 + d[0] * 5;
        m = 11 - m % 11, m >= 10 && (m = 0);
        var v = m * 2 + 3 + d[7] * 7 + d[6] * 8 + d[5] * 9 + d[4] * 2 + d[3] * 3 + d[2] * 4 + d[1] * 5 + d[0] * 6;
        return v = 11 - v % 11, v >= 10 && (v = 0), "" + d[0] + d[1] + "." + d[2] + d[3] + d[4] + "." + d[5] + d[6] + d[7] + "/0001-" + m + v;
      }, u.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
      }, u.prototype.mersenne_twister = function(d) {
        return new L(d);
      }, u.prototype.blueimp_md5 = function() {
        return new N();
      };
      var L = function(d) {
        d === void 0 && (d = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(d);
      };
      L.prototype.init_genrand = function(d) {
        for (this.mt[0] = d >>> 0, this.mti = 1; this.mti < this.N; this.mti++)
          d = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (((d & 4294901760) >>> 16) * 1812433253 << 16) + (d & 65535) * 1812433253 + this.mti, this.mt[this.mti] >>>= 0;
      }, L.prototype.init_by_array = function(d, m) {
        var v = 1, k = 0, O, G;
        for (this.init_genrand(19650218), O = this.N > m ? this.N : m; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1664525 << 16) + (G & 65535) * 1664525) + d[k] + k, this.mt[v] >>>= 0, v++, k++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1), k >= m && (k = 0);
        for (O = this.N - 1; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1566083941 << 16) + (G & 65535) * 1566083941) - v, this.mt[v] >>>= 0, v++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1);
        this.mt[0] = 2147483648;
      }, L.prototype.genrand_int32 = function() {
        var d, m = new Array(0, this.MATRIX_A);
        if (this.mti >= this.N) {
          var v;
          for (this.mti === this.N + 1 && this.init_genrand(5489), v = 0; v < this.N - this.M; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + this.M] ^ d >>> 1 ^ m[d & 1];
          for (; v < this.N - 1; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + (this.M - this.N)] ^ d >>> 1 ^ m[d & 1];
          d = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ d >>> 1 ^ m[d & 1], this.mti = 0;
        }
        return d = this.mt[this.mti++], d ^= d >>> 11, d ^= d << 7 & 2636928640, d ^= d << 15 & 4022730752, d ^= d >>> 18, d >>> 0;
      }, L.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
      }, L.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1 / 4294967295);
      }, L.prototype.random = function() {
        return this.genrand_int32() * (1 / 4294967296);
      }, L.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1 / 4294967296);
      }, L.prototype.genrand_res53 = function() {
        var d = this.genrand_int32() >>> 5, m = this.genrand_int32() >>> 6;
        return (d * 67108864 + m) * (1 / 9007199254740992);
      };
      var N = function() {
      };
      N.prototype.VERSION = "1.0.1", N.prototype.safe_add = function(m, v) {
        var k = (m & 65535) + (v & 65535), O = (m >> 16) + (v >> 16) + (k >> 16);
        return O << 16 | k & 65535;
      }, N.prototype.bit_roll = function(d, m) {
        return d << m | d >>> 32 - m;
      }, N.prototype.md5_cmn = function(d, m, v, k, O, G) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(m, d), this.safe_add(k, G)), O), v);
      }, N.prototype.md5_ff = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & v | ~m & k, d, m, O, G, H);
      }, N.prototype.md5_gg = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & k | v & ~k, d, m, O, G, H);
      }, N.prototype.md5_hh = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m ^ v ^ k, d, m, O, G, H);
      }, N.prototype.md5_ii = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(v ^ (m | ~k), d, m, O, G, H);
      }, N.prototype.binl_md5 = function(d, m) {
        d[m >> 5] |= 128 << m % 32, d[(m + 64 >>> 9 << 4) + 14] = m;
        var v, k, O, G, H, j = 1732584193, F = -271733879, z = -1732584194, W = 271733878;
        for (v = 0; v < d.length; v += 16)
          k = j, O = F, G = z, H = W, j = this.md5_ff(j, F, z, W, d[v], 7, -680876936), W = this.md5_ff(W, j, F, z, d[v + 1], 12, -389564586), z = this.md5_ff(z, W, j, F, d[v + 2], 17, 606105819), F = this.md5_ff(F, z, W, j, d[v + 3], 22, -1044525330), j = this.md5_ff(j, F, z, W, d[v + 4], 7, -176418897), W = this.md5_ff(W, j, F, z, d[v + 5], 12, 1200080426), z = this.md5_ff(z, W, j, F, d[v + 6], 17, -1473231341), F = this.md5_ff(F, z, W, j, d[v + 7], 22, -45705983), j = this.md5_ff(j, F, z, W, d[v + 8], 7, 1770035416), W = this.md5_ff(W, j, F, z, d[v + 9], 12, -1958414417), z = this.md5_ff(z, W, j, F, d[v + 10], 17, -42063), F = this.md5_ff(F, z, W, j, d[v + 11], 22, -1990404162), j = this.md5_ff(j, F, z, W, d[v + 12], 7, 1804603682), W = this.md5_ff(W, j, F, z, d[v + 13], 12, -40341101), z = this.md5_ff(z, W, j, F, d[v + 14], 17, -1502002290), F = this.md5_ff(F, z, W, j, d[v + 15], 22, 1236535329), j = this.md5_gg(j, F, z, W, d[v + 1], 5, -165796510), W = this.md5_gg(W, j, F, z, d[v + 6], 9, -1069501632), z = this.md5_gg(z, W, j, F, d[v + 11], 14, 643717713), F = this.md5_gg(F, z, W, j, d[v], 20, -373897302), j = this.md5_gg(j, F, z, W, d[v + 5], 5, -701558691), W = this.md5_gg(W, j, F, z, d[v + 10], 9, 38016083), z = this.md5_gg(z, W, j, F, d[v + 15], 14, -660478335), F = this.md5_gg(F, z, W, j, d[v + 4], 20, -405537848), j = this.md5_gg(j, F, z, W, d[v + 9], 5, 568446438), W = this.md5_gg(W, j, F, z, d[v + 14], 9, -1019803690), z = this.md5_gg(z, W, j, F, d[v + 3], 14, -187363961), F = this.md5_gg(F, z, W, j, d[v + 8], 20, 1163531501), j = this.md5_gg(j, F, z, W, d[v + 13], 5, -1444681467), W = this.md5_gg(W, j, F, z, d[v + 2], 9, -51403784), z = this.md5_gg(z, W, j, F, d[v + 7], 14, 1735328473), F = this.md5_gg(F, z, W, j, d[v + 12], 20, -1926607734), j = this.md5_hh(j, F, z, W, d[v + 5], 4, -378558), W = this.md5_hh(W, j, F, z, d[v + 8], 11, -2022574463), z = this.md5_hh(z, W, j, F, d[v + 11], 16, 1839030562), F = this.md5_hh(F, z, W, j, d[v + 14], 23, -35309556), j = this.md5_hh(j, F, z, W, d[v + 1], 4, -1530992060), W = this.md5_hh(W, j, F, z, d[v + 4], 11, 1272893353), z = this.md5_hh(z, W, j, F, d[v + 7], 16, -155497632), F = this.md5_hh(F, z, W, j, d[v + 10], 23, -1094730640), j = this.md5_hh(j, F, z, W, d[v + 13], 4, 681279174), W = this.md5_hh(W, j, F, z, d[v], 11, -358537222), z = this.md5_hh(z, W, j, F, d[v + 3], 16, -722521979), F = this.md5_hh(F, z, W, j, d[v + 6], 23, 76029189), j = this.md5_hh(j, F, z, W, d[v + 9], 4, -640364487), W = this.md5_hh(W, j, F, z, d[v + 12], 11, -421815835), z = this.md5_hh(z, W, j, F, d[v + 15], 16, 530742520), F = this.md5_hh(F, z, W, j, d[v + 2], 23, -995338651), j = this.md5_ii(j, F, z, W, d[v], 6, -198630844), W = this.md5_ii(W, j, F, z, d[v + 7], 10, 1126891415), z = this.md5_ii(z, W, j, F, d[v + 14], 15, -1416354905), F = this.md5_ii(F, z, W, j, d[v + 5], 21, -57434055), j = this.md5_ii(j, F, z, W, d[v + 12], 6, 1700485571), W = this.md5_ii(W, j, F, z, d[v + 3], 10, -1894986606), z = this.md5_ii(z, W, j, F, d[v + 10], 15, -1051523), F = this.md5_ii(F, z, W, j, d[v + 1], 21, -2054922799), j = this.md5_ii(j, F, z, W, d[v + 8], 6, 1873313359), W = this.md5_ii(W, j, F, z, d[v + 15], 10, -30611744), z = this.md5_ii(z, W, j, F, d[v + 6], 15, -1560198380), F = this.md5_ii(F, z, W, j, d[v + 13], 21, 1309151649), j = this.md5_ii(j, F, z, W, d[v + 4], 6, -145523070), W = this.md5_ii(W, j, F, z, d[v + 11], 10, -1120210379), z = this.md5_ii(z, W, j, F, d[v + 2], 15, 718787259), F = this.md5_ii(F, z, W, j, d[v + 9], 21, -343485551), j = this.safe_add(j, k), F = this.safe_add(F, O), z = this.safe_add(z, G), W = this.safe_add(W, H);
        return [j, F, z, W];
      }, N.prototype.binl2rstr = function(d) {
        var m, v = "";
        for (m = 0; m < d.length * 32; m += 8)
          v += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return v;
      }, N.prototype.rstr2binl = function(d) {
        var m, v = [];
        for (v[(d.length >> 2) - 1] = void 0, m = 0; m < v.length; m += 1)
          v[m] = 0;
        for (m = 0; m < d.length * 8; m += 8)
          v[m >> 5] |= (d.charCodeAt(m / 8) & 255) << m % 32;
        return v;
      }, N.prototype.rstr_md5 = function(d) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(d), d.length * 8));
      }, N.prototype.rstr_hmac_md5 = function(d, m) {
        var v, k = this.rstr2binl(d), O = [], G = [], H;
        for (O[15] = G[15] = void 0, k.length > 16 && (k = this.binl_md5(k, d.length * 8)), v = 0; v < 16; v += 1)
          O[v] = k[v] ^ 909522486, G[v] = k[v] ^ 1549556828;
        return H = this.binl_md5(O.concat(this.rstr2binl(m)), 512 + m.length * 8), this.binl2rstr(this.binl_md5(G.concat(H), 640));
      }, N.prototype.rstr2hex = function(d) {
        var m = "0123456789abcdef", v = "", k, O;
        for (O = 0; O < d.length; O += 1)
          k = d.charCodeAt(O), v += m.charAt(k >>> 4 & 15) + m.charAt(k & 15);
        return v;
      }, N.prototype.str2rstr_utf8 = function(d) {
        return unescape(encodeURIComponent(d));
      }, N.prototype.raw_md5 = function(d) {
        return this.rstr_md5(this.str2rstr_utf8(d));
      }, N.prototype.hex_md5 = function(d) {
        return this.rstr2hex(this.raw_md5(d));
      }, N.prototype.raw_hmac_md5 = function(d, m) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(d), this.str2rstr_utf8(m));
      }, N.prototype.hex_hmac_md5 = function(d, m) {
        return this.rstr2hex(this.raw_hmac_md5(d, m));
      }, N.prototype.md5 = function(d, m, v) {
        return m ? v ? this.raw_hmac_md5(m, d) : this.hex_hmac_md5(m, d) : v ? this.raw_md5(d) : this.hex_md5(d);
      }, t.exports && (e = t.exports = u), e.Chance = u, typeof importScripts < "u" && (chance = new u(), self.Chance = u), typeof window == "object" && typeof window.document == "object" && (window.Chance = u, window.chance = new u());
    })();
  }(QO, QO.exports)), QO.exports;
}
var tSt = eSt();
const NUe = /* @__PURE__ */ Gi(tSt);
var to;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(to || (to = {}));
var fce;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(fce || (fce = {}));
const wn = to.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), om = (t) => {
  switch (typeof t) {
    case "undefined":
      return wn.undefined;
    case "string":
      return wn.string;
    case "number":
      return isNaN(t) ? wn.nan : wn.number;
    case "boolean":
      return wn.boolean;
    case "function":
      return wn.function;
    case "bigint":
      return wn.bigint;
    case "symbol":
      return wn.symbol;
    case "object":
      return Array.isArray(t) ? wn.array : t === null ? wn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? wn.promise : typeof Map < "u" && t instanceof Map ? wn.map : typeof Set < "u" && t instanceof Set ? wn.set : typeof Date < "u" && t instanceof Date ? wn.date : wn.object;
    default:
      return wn.unknown;
  }
}, Lr = to.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), rSt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let A1 = class $Ue extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof $Ue))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, to.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
A1.create = (t) => new A1(t);
const Q7 = (t, e) => {
  let r;
  switch (t.code) {
    case Lr.invalid_type:
      t.received === wn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Lr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, to.jsonStringifyReplacer)}`;
      break;
    case Lr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${to.joinValues(t.keys, ", ")}`;
      break;
    case Lr.invalid_union:
      r = "Invalid input";
      break;
    case Lr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${to.joinValues(t.options)}`;
      break;
    case Lr.invalid_enum_value:
      r = `Invalid enum value. Expected ${to.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Lr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Lr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Lr.invalid_date:
      r = "Invalid date";
      break;
    case Lr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : to.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Lr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Lr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Lr.custom:
      r = "Invalid input";
      break;
    case Lr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Lr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Lr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, to.assertNever(t);
  }
  return { message: r };
};
let DUe = Q7;
function nSt(t) {
  DUe = t;
}
function ID() {
  return DUe;
}
const MD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, aSt = [];
function ln(t, e) {
  const r = ID(), n = MD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === Q7 ? void 0 : Q7
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let Sd = class LUe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Ea;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return LUe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Ea;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Ea = Object.freeze({
  status: "aborted"
}), P9 = (t) => ({ status: "dirty", value: t }), Pu = (t) => ({ status: "valid", value: t }), hce = (t) => t.status === "aborted", pce = (t) => t.status === "dirty", u5 = (t) => t.status === "valid", mA = (t) => typeof Promise < "u" && t instanceof Promise;
function PD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function jUe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Dn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(Dn || (Dn = {}));
var jS, FS;
let Oh = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const H6e = (t, e) => {
  if (u5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new A1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function di(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Ei = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return om(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: om(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Sd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: om(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (mA(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: om(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return H6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: om(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return u5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => u5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: om(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (mA(a) ? a : Promise.resolve(a));
    return H6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Lr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new j1({
      schema: this,
      typeName: ya.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return fh.create(this, this._def);
  }
  nullable() {
    return ry.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return d5.create(this);
  }
  promise() {
    return rx.create(this, this._def);
  }
  or(e) {
    return wA.create([this, e], this._def);
  }
  and(e) {
    return SA.create(this, e, this._def);
  }
  transform(e) {
    return new j1({
      ...di(this._def),
      schema: this,
      typeName: ya.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new TA({
      ...di(this._def),
      innerType: this,
      defaultValue: r,
      typeName: ya.ZodDefault
    });
  }
  brand() {
    return new N1e({
      typeName: ya.ZodBranded,
      type: this,
      ...di(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new EA({
      ...di(this._def),
      innerType: this,
      catchValue: r,
      typeName: ya.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return $1e.create(this, e);
  }
  readonly() {
    return IA.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const iSt = /^c[^\s-]{8,}$/i, oSt = /^[0-9a-z]+$/, sSt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, lSt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, cSt = /^[a-z0-9_-]{21}$/i, uSt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, dSt = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, fSt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, hSt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let RK;
const pSt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mSt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, gSt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, vSt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ySt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, bSt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, FUe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", xSt = new RegExp(`^${FUe}$`);
function zUe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function CSt(t) {
  return new RegExp(`^${zUe(t)}$`);
}
function GUe(t) {
  let e = `${FUe}T${zUe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function wSt(t, e) {
  return !!((e === "v4" || !e) && pSt.test(t) || (e === "v6" || !e) && gSt.test(t));
}
function SSt(t, e) {
  if (!uSt.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function _St(t, e) {
  return !!((e === "v4" || !e) && mSt.test(t) || (e === "v6" || !e) && vSt.test(t));
}
let ex = class zS extends Ei {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== wn.string) {
      const i = this._getOrReturnCtx(e);
      return ln(i, {
        code: Lr.invalid_type,
        expected: wn.string,
        received: i.parsedType
      }), Ea;
    }
    const n = new Sd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), ln(a, {
          code: Lr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), ln(a, {
          code: Lr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? ln(a, {
          code: Lr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && ln(a, {
          code: Lr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        fSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "email",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        RK || (RK = new RegExp(hSt, "u")), RK.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "emoji",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        lSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "uuid",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        cSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "nanoid",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        iSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "cuid",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        oSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "cuid2",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        sSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
          validation: "ulid",
          code: Lr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), ln(a, {
            validation: "url",
            code: Lr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "regex",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? GUe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? xSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? CSt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? dSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "duration",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? wSt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "ip",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? SSt(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "jwt",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? _St(e.data, i.version) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "cidr",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? ySt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "base64",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? bSt.test(e.data) || (a = this._getOrReturnCtx(e, a), ln(a, {
        validation: "base64url",
        code: Lr.invalid_string,
        message: i.message
      }), n.dirty()) : to.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Lr.invalid_string,
      ...Dn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new zS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Dn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Dn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Dn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Dn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Dn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Dn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Dn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Dn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Dn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Dn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Dn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Dn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Dn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...Dn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...Dn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Dn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Dn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...Dn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Dn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Dn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Dn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Dn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Dn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Dn.errToObj(e));
  }
  trim() {
    return new zS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new zS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new zS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
ex.create = (t) => {
  var e;
  return new ex({
    checks: [],
    typeName: ya.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...di(t)
  });
};
function kSt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let gA = class mce extends Ei {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== wn.number) {
      const i = this._getOrReturnCtx(e);
      return ln(i, {
        code: Lr.invalid_type,
        expected: wn.number,
        received: i.parsedType
      }), Ea;
    }
    let n;
    const a = new Sd();
    for (const i of this._def.checks)
      i.kind === "int" ? to.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? kSt(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.not_finite,
        message: i.message
      }), a.dirty()) : to.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Dn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Dn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Dn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Dn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new mce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Dn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new mce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Dn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Dn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Dn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Dn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Dn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Dn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Dn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Dn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Dn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && to.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
gA.create = (t) => new gA({
  checks: [],
  typeName: ya.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...di(t)
});
let vA = class gce extends Ei {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== wn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new Sd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), ln(n, {
        code: Lr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : to.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return ln(r, {
      code: Lr.invalid_type,
      expected: wn.bigint,
      received: r.parsedType
    }), Ea;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Dn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Dn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Dn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Dn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new gce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Dn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new gce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Dn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Dn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Dn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Dn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Dn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
vA.create = (t) => {
  var e;
  return new vA({
    checks: [],
    typeName: ya.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...di(t)
  });
};
let yA = class extends Ei {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== wn.boolean) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.boolean,
        received: n.parsedType
      }), Ea;
    }
    return Pu(e.data);
  }
};
yA.create = (t) => new yA({
  typeName: ya.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...di(t)
});
let bA = class WUe extends Ei {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== wn.date) {
      const i = this._getOrReturnCtx(e);
      return ln(i, {
        code: Lr.invalid_type,
        expected: wn.date,
        received: i.parsedType
      }), Ea;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return ln(i, {
        code: Lr.invalid_date
      }), Ea;
    }
    const n = new Sd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), ln(a, {
        code: Lr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : to.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new WUe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Dn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Dn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
bA.create = (t) => new bA({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: ya.ZodDate,
  ...di(t)
});
let RD = class extends Ei {
  _parse(e) {
    if (this._getType(e) !== wn.symbol) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.symbol,
        received: n.parsedType
      }), Ea;
    }
    return Pu(e.data);
  }
};
RD.create = (t) => new RD({
  typeName: ya.ZodSymbol,
  ...di(t)
});
let xA = class extends Ei {
  _parse(e) {
    if (this._getType(e) !== wn.undefined) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.undefined,
        received: n.parsedType
      }), Ea;
    }
    return Pu(e.data);
  }
};
xA.create = (t) => new xA({
  typeName: ya.ZodUndefined,
  ...di(t)
});
let CA = class extends Ei {
  _parse(e) {
    if (this._getType(e) !== wn.null) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.null,
        received: n.parsedType
      }), Ea;
    }
    return Pu(e.data);
  }
};
CA.create = (t) => new CA({
  typeName: ya.ZodNull,
  ...di(t)
});
let tx = class extends Ei {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Pu(e.data);
  }
};
tx.create = (t) => new tx({
  typeName: ya.ZodAny,
  ...di(t)
});
let Pb = class extends Ei {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Pu(e.data);
  }
};
Pb.create = (t) => new Pb({
  typeName: ya.ZodUnknown,
  ...di(t)
});
let Fm = class extends Ei {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return ln(r, {
      code: Lr.invalid_type,
      expected: wn.never,
      received: r.parsedType
    }), Ea;
  }
};
Fm.create = (t) => new Fm({
  typeName: ya.ZodNever,
  ...di(t)
});
let OD = class extends Ei {
  _parse(e) {
    if (this._getType(e) !== wn.undefined) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.void,
        received: n.parsedType
      }), Ea;
    }
    return Pu(e.data);
  }
};
OD.create = (t) => new OD({
  typeName: ya.ZodVoid,
  ...di(t)
});
let d5 = class UN extends Ei {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== wn.array)
      return ln(r, {
        code: Lr.invalid_type,
        expected: wn.array,
        received: r.parsedType
      }), Ea;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (ln(r, {
        code: o ? Lr.too_big : Lr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (ln(r, {
      code: Lr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (ln(r, {
      code: Lr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Oh(r, o, r.path, s)))).then((o) => Sd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Oh(r, o, r.path, s)));
    return Sd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new UN({
      ...this._def,
      minLength: { value: e, message: Dn.toString(r) }
    });
  }
  max(e, r) {
    return new UN({
      ...this._def,
      maxLength: { value: e, message: Dn.toString(r) }
    });
  }
  length(e, r) {
    return new UN({
      ...this._def,
      exactLength: { value: e, message: Dn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
d5.create = (t, e) => new d5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ya.ZodArray,
  ...di(e)
});
function m9(t) {
  if (t instanceof lf) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = fh.create(m9(n));
    }
    return new lf({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof d5 ? new d5({
    ...t._def,
    type: m9(t.element)
  }) : t instanceof fh ? fh.create(m9(t.unwrap())) : t instanceof ry ? ry.create(m9(t.unwrap())) : t instanceof ty ? ty.create(t.items.map((e) => m9(e))) : t;
}
let lf = class Qf extends Ei {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = to.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== wn.object) {
      const c = this._getOrReturnCtx(e);
      return ln(c, {
        code: Lr.invalid_type,
        expected: wn.object,
        received: c.parsedType
      }), Ea;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Fm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Oh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Fm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (ln(a, {
          code: Lr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Oh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Sd.mergeObjectSync(n, c)) : Sd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Dn.errToObj, new Qf({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Dn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Qf({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Qf({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Qf({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Qf({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: ya.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Qf({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return to.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Qf({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return to.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Qf({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return m9(this);
  }
  partial(e) {
    const r = {};
    return to.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Qf({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return to.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof fh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Qf({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return ZUe(to.objectKeys(this.shape));
  }
};
lf.create = (t, e) => new lf({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Fm.create(),
  typeName: ya.ZodObject,
  ...di(e)
});
lf.strictCreate = (t, e) => new lf({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Fm.create(),
  typeName: ya.ZodObject,
  ...di(e)
});
lf.lazycreate = (t, e) => new lf({
  shape: t,
  unknownKeys: "strip",
  catchall: Fm.create(),
  typeName: ya.ZodObject,
  ...di(e)
});
let wA = class extends Ei {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new A1(s.ctx.common.issues));
      return ln(r, {
        code: Lr.invalid_union,
        unionErrors: o
      }), Ea;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new A1(l));
      return ln(r, {
        code: Lr.invalid_union,
        unionErrors: s
      }), Ea;
    }
  }
  get options() {
    return this._def.options;
  }
};
wA.create = (t, e) => new wA({
  options: t,
  typeName: ya.ZodUnion,
  ...di(e)
});
const Vp = (t) => t instanceof _A ? Vp(t.schema) : t instanceof j1 ? Vp(t.innerType()) : t instanceof kA ? [t.value] : t instanceof DI ? t.options : t instanceof AA ? to.objectValues(t.enum) : t instanceof TA ? Vp(t._def.innerType) : t instanceof xA ? [void 0] : t instanceof CA ? [null] : t instanceof fh ? [void 0, ...Vp(t.unwrap())] : t instanceof ry ? [null, ...Vp(t.unwrap())] : t instanceof N1e || t instanceof IA ? Vp(t.unwrap()) : t instanceof EA ? Vp(t._def.innerType) : [];
let HUe = class UUe extends Ei {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== wn.object)
      return ln(r, {
        code: Lr.invalid_type,
        expected: wn.object,
        received: r.parsedType
      }), Ea;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (ln(r, {
      code: Lr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Ea);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Vp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new UUe({
      typeName: ya.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...di(n)
    });
  }
};
function vce(t, e) {
  const r = om(t), n = om(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === wn.object && n === wn.object) {
    const a = to.objectKeys(e), i = to.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = vce(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === wn.array && n === wn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = vce(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === wn.date && n === wn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let SA = class extends Ei {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (hce(i) || hce(o))
        return Ea;
      const s = vce(i.value, o.value);
      return s.valid ? ((pce(i) || pce(o)) && r.dirty(), { status: r.value, value: s.data }) : (ln(n, {
        code: Lr.invalid_intersection_types
      }), Ea);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
SA.create = (t, e, r) => new SA({
  left: t,
  right: e,
  typeName: ya.ZodIntersection,
  ...di(r)
});
let ty = class VUe extends Ei {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== wn.array)
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.array,
        received: n.parsedType
      }), Ea;
    if (n.data.length < this._def.items.length)
      return ln(n, {
        code: Lr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ea;
    !this._def.rest && n.data.length > this._def.items.length && (ln(n, {
      code: Lr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Oh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => Sd.mergeArray(r, o)) : Sd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new VUe({
      ...this._def,
      rest: e
    });
  }
};
ty.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ty({
    items: t,
    typeName: ya.ZodTuple,
    rest: null,
    ...di(e)
  });
};
let qUe = class yce extends Ei {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== wn.object)
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.object,
        received: n.parsedType
      }), Ea;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Oh(n, s, n.path, s)),
        value: o._parse(new Oh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? Sd.mergeObjectAsync(r, a) : Sd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Ei ? new yce({
      keyType: e,
      valueType: r,
      typeName: ya.ZodRecord,
      ...di(n)
    }) : new yce({
      keyType: ex.create(),
      valueType: e,
      typeName: ya.ZodRecord,
      ...di(r)
    });
  }
}, BD = class extends Ei {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== wn.map)
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.map,
        received: n.parsedType
      }), Ea;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Oh(n, s, n.path, [c, "key"])),
      value: i._parse(new Oh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ea;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ea;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
BD.create = (t, e, r) => new BD({
  valueType: e,
  keyType: t,
  typeName: ya.ZodMap,
  ...di(r)
});
let ND = class bce extends Ei {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== wn.set)
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.set,
        received: n.parsedType
      }), Ea;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (ln(n, {
      code: Lr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (ln(n, {
      code: Lr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ea;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Oh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new bce({
      ...this._def,
      minSize: { value: e, message: Dn.toString(r) }
    });
  }
  max(e, r) {
    return new bce({
      ...this._def,
      maxSize: { value: e, message: Dn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
ND.create = (t, e) => new ND({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: ya.ZodSet,
  ...di(e)
});
let KUe = class VN extends Ei {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== wn.function)
      return ln(r, {
        code: Lr.invalid_type,
        expected: wn.function,
        received: r.parsedType
      }), Ea;
    function n(s, l) {
      return MD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ID(),
          Q7
        ].filter((c) => !!c),
        issueData: {
          code: Lr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return MD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ID(),
          Q7
        ].filter((c) => !!c),
        issueData: {
          code: Lr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof rx) {
      const s = this;
      return Pu(async function(...l) {
        const c = new A1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Pu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new A1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new A1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new VN({
      ...this._def,
      args: ty.create(e).rest(Pb.create())
    });
  }
  returns(e) {
    return new VN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new VN({
      args: e || ty.create([]).rest(Pb.create()),
      returns: r || Pb.create(),
      typeName: ya.ZodFunction,
      ...di(n)
    });
  }
}, _A = class extends Ei {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
_A.create = (t, e) => new _A({
  getter: t,
  typeName: ya.ZodLazy,
  ...di(e)
});
let kA = class extends Ei {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return ln(r, {
        received: r.data,
        code: Lr.invalid_literal,
        expected: this._def.value
      }), Ea;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
kA.create = (t, e) => new kA({
  value: t,
  typeName: ya.ZodLiteral,
  ...di(e)
});
function ZUe(t, e) {
  return new DI({
    values: t,
    typeName: ya.ZodEnum,
    ...di(e)
  });
}
let DI = class xce extends Ei {
  constructor() {
    super(...arguments), jS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return ln(r, {
        expected: to.joinValues(n),
        received: r.parsedType,
        code: Lr.invalid_type
      }), Ea;
    }
    if (PD(this, jS) || jUe(this, jS, new Set(this._def.values)), !PD(this, jS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return ln(r, {
        received: r.data,
        code: Lr.invalid_enum_value,
        options: n
      }), Ea;
    }
    return Pu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return xce.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return xce.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
jS = /* @__PURE__ */ new WeakMap();
DI.create = ZUe;
let AA = class extends Ei {
  constructor() {
    super(...arguments), FS.set(this, void 0);
  }
  _parse(e) {
    const r = to.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== wn.string && n.parsedType !== wn.number) {
      const a = to.objectValues(r);
      return ln(n, {
        expected: to.joinValues(a),
        received: n.parsedType,
        code: Lr.invalid_type
      }), Ea;
    }
    if (PD(this, FS) || jUe(this, FS, new Set(to.getValidEnumValues(this._def.values))), !PD(this, FS).has(e.data)) {
      const a = to.objectValues(r);
      return ln(n, {
        received: n.data,
        code: Lr.invalid_enum_value,
        options: a
      }), Ea;
    }
    return Pu(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
FS = /* @__PURE__ */ new WeakMap();
AA.create = (t, e) => new AA({
  values: t,
  typeName: ya.ZodNativeEnum,
  ...di(e)
});
let rx = class extends Ei {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== wn.promise && r.common.async === !1)
      return ln(r, {
        code: Lr.invalid_type,
        expected: wn.promise,
        received: r.parsedType
      }), Ea;
    const n = r.parsedType === wn.promise ? r.data : Promise.resolve(r.data);
    return Pu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
rx.create = (t, e) => new rx({
  type: t,
  typeName: ya.ZodPromise,
  ...di(e)
});
let j1 = class extends Ei {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ya.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        ln(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Ea;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Ea : l.status === "dirty" || r.value === "dirty" ? P9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Ea;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ea : s.status === "dirty" || r.value === "dirty" ? P9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ea : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Ea : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!u5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => u5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    to.assertNever(a);
  }
};
j1.create = (t, e, r) => new j1({
  schema: t,
  typeName: ya.ZodEffects,
  effect: e,
  ...di(r)
});
j1.createWithPreprocess = (t, e, r) => new j1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: ya.ZodEffects,
  ...di(r)
});
let fh = class extends Ei {
  _parse(e) {
    return this._getType(e) === wn.undefined ? Pu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
fh.create = (t, e) => new fh({
  innerType: t,
  typeName: ya.ZodOptional,
  ...di(e)
});
let ry = class extends Ei {
  _parse(e) {
    return this._getType(e) === wn.null ? Pu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ry.create = (t, e) => new ry({
  innerType: t,
  typeName: ya.ZodNullable,
  ...di(e)
});
let TA = class extends Ei {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === wn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
TA.create = (t, e) => new TA({
  innerType: t,
  typeName: ya.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...di(e)
});
let EA = class extends Ei {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return mA(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new A1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new A1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
EA.create = (t, e) => new EA({
  innerType: t,
  typeName: ya.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...di(e)
});
let $D = class extends Ei {
  _parse(e) {
    if (this._getType(e) !== wn.nan) {
      const n = this._getOrReturnCtx(e);
      return ln(n, {
        code: Lr.invalid_type,
        expected: wn.nan,
        received: n.parsedType
      }), Ea;
    }
    return { status: "valid", value: e.data };
  }
};
$D.create = (t) => new $D({
  typeName: ya.ZodNaN,
  ...di(t)
});
const ASt = Symbol("zod_brand");
let N1e = class extends Ei {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, $1e = class JUe extends Ei {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Ea : i.status === "dirty" ? (r.dirty(), P9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Ea : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new JUe({
      in: e,
      out: r,
      typeName: ya.ZodPipeline
    });
  }
}, IA = class extends Ei {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (u5(a) && (a.value = Object.freeze(a.value)), a);
    return mA(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
IA.create = (t, e) => new IA({
  innerType: t,
  typeName: ya.ZodReadonly,
  ...di(e)
});
function YUe(t, e = {}, r) {
  return t ? tx.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : tx.create();
}
const TSt = {
  object: lf.lazycreate
};
var ya;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(ya || (ya = {}));
const ESt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => YUe((r) => r instanceof t, e), XUe = ex.create, QUe = gA.create, ISt = $D.create, MSt = vA.create, eVe = yA.create, PSt = bA.create, RSt = RD.create, OSt = xA.create, BSt = CA.create, NSt = tx.create, $St = Pb.create, DSt = Fm.create, LSt = OD.create, jSt = d5.create, FSt = lf.create, zSt = lf.strictCreate, GSt = wA.create, WSt = HUe.create, HSt = SA.create, USt = ty.create, VSt = qUe.create, qSt = BD.create, KSt = ND.create, ZSt = KUe.create, JSt = _A.create, YSt = kA.create, XSt = DI.create, QSt = AA.create, e_t = rx.create, U6e = j1.create, t_t = fh.create, r_t = ry.create, n_t = j1.createWithPreprocess, a_t = $1e.create, i_t = () => XUe().optional(), o_t = () => QUe().optional(), s_t = () => eVe().optional(), l_t = {
  string: (t) => ex.create({ ...t, coerce: !0 }),
  number: (t) => gA.create({ ...t, coerce: !0 }),
  boolean: (t) => yA.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => vA.create({ ...t, coerce: !0 }),
  date: (t) => bA.create({ ...t, coerce: !0 })
}, c_t = Ea;
var ho = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Q7,
  setErrorMap: nSt,
  getErrorMap: ID,
  makeIssue: MD,
  EMPTY_PATH: aSt,
  addIssueToContext: ln,
  ParseStatus: Sd,
  INVALID: Ea,
  DIRTY: P9,
  OK: Pu,
  isAborted: hce,
  isDirty: pce,
  isValid: u5,
  isAsync: mA,
  get util() {
    return to;
  },
  get objectUtil() {
    return fce;
  },
  ZodParsedType: wn,
  getParsedType: om,
  ZodType: Ei,
  datetimeRegex: GUe,
  ZodString: ex,
  ZodNumber: gA,
  ZodBigInt: vA,
  ZodBoolean: yA,
  ZodDate: bA,
  ZodSymbol: RD,
  ZodUndefined: xA,
  ZodNull: CA,
  ZodAny: tx,
  ZodUnknown: Pb,
  ZodNever: Fm,
  ZodVoid: OD,
  ZodArray: d5,
  ZodObject: lf,
  ZodUnion: wA,
  ZodDiscriminatedUnion: HUe,
  ZodIntersection: SA,
  ZodTuple: ty,
  ZodRecord: qUe,
  ZodMap: BD,
  ZodSet: ND,
  ZodFunction: KUe,
  ZodLazy: _A,
  ZodLiteral: kA,
  ZodEnum: DI,
  ZodNativeEnum: AA,
  ZodPromise: rx,
  ZodEffects: j1,
  ZodTransformer: j1,
  ZodOptional: fh,
  ZodNullable: ry,
  ZodDefault: TA,
  ZodCatch: EA,
  ZodNaN: $D,
  BRAND: ASt,
  ZodBranded: N1e,
  ZodPipeline: $1e,
  ZodReadonly: IA,
  custom: YUe,
  Schema: Ei,
  ZodSchema: Ei,
  late: TSt,
  get ZodFirstPartyTypeKind() {
    return ya;
  },
  coerce: l_t,
  any: NSt,
  array: jSt,
  bigint: MSt,
  boolean: eVe,
  date: PSt,
  discriminatedUnion: WSt,
  effect: U6e,
  enum: XSt,
  function: ZSt,
  instanceof: ESt,
  intersection: HSt,
  lazy: JSt,
  literal: YSt,
  map: qSt,
  nan: ISt,
  nativeEnum: QSt,
  never: DSt,
  null: BSt,
  nullable: r_t,
  number: QUe,
  object: FSt,
  oboolean: s_t,
  onumber: o_t,
  optional: t_t,
  ostring: i_t,
  pipeline: a_t,
  preprocess: n_t,
  promise: e_t,
  record: VSt,
  set: KSt,
  strictObject: zSt,
  string: XUe,
  symbol: RSt,
  transformer: U6e,
  tuple: USt,
  undefined: OSt,
  union: GSt,
  unknown: $St,
  void: LSt,
  NEVER: c_t,
  ZodIssueCode: Lr,
  quotelessJson: rSt,
  ZodError: A1
}), ro;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(ro || (ro = {}));
var Cce;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Cce || (Cce = {}));
const Sn = ro.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), sm = (t) => {
  switch (typeof t) {
    case "undefined":
      return Sn.undefined;
    case "string":
      return Sn.string;
    case "number":
      return isNaN(t) ? Sn.nan : Sn.number;
    case "boolean":
      return Sn.boolean;
    case "function":
      return Sn.function;
    case "bigint":
      return Sn.bigint;
    case "symbol":
      return Sn.symbol;
    case "object":
      return Array.isArray(t) ? Sn.array : t === null ? Sn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? Sn.promise : typeof Map < "u" && t instanceof Map ? Sn.map : typeof Set < "u" && t instanceof Set ? Sn.set : typeof Date < "u" && t instanceof Date ? Sn.date : Sn.object;
    default:
      return Sn.unknown;
  }
}, jr = ro.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), u_t = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let T1 = class tVe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof tVe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ro.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
T1.create = (t) => new T1(t);
const nx = (t, e) => {
  let r;
  switch (t.code) {
    case jr.invalid_type:
      t.received === Sn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case jr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, ro.jsonStringifyReplacer)}`;
      break;
    case jr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${ro.joinValues(t.keys, ", ")}`;
      break;
    case jr.invalid_union:
      r = "Invalid input";
      break;
    case jr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${ro.joinValues(t.options)}`;
      break;
    case jr.invalid_enum_value:
      r = `Invalid enum value. Expected ${ro.joinValues(t.options)}, received '${t.received}'`;
      break;
    case jr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case jr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case jr.invalid_date:
      r = "Invalid date";
      break;
    case jr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : ro.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case jr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case jr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case jr.custom:
      r = "Invalid input";
      break;
    case jr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case jr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case jr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, ro.assertNever(t);
  }
  return { message: r };
};
let rVe = nx;
function d_t(t) {
  rVe = t;
}
function DD() {
  return rVe;
}
const LD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, f_t = [];
function cn(t, e) {
  const r = DD(), n = LD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === nx ? void 0 : nx
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let _d = class nVe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Ia;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return nVe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Ia;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Ia = Object.freeze({
  status: "aborted"
}), R9 = (t) => ({ status: "dirty", value: t }), Ru = (t) => ({ status: "valid", value: t }), wce = (t) => t.status === "aborted", Sce = (t) => t.status === "dirty", f5 = (t) => t.status === "valid", MA = (t) => typeof Promise < "u" && t instanceof Promise;
function jD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function aVe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Ln;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(Ln || (Ln = {}));
var GS, WS;
let Bh = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const V6e = (t, e) => {
  if (f5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new T1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function fi(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Ii = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return sm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: sm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new _d(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: sm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (MA(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: sm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return V6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: sm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return f5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => f5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: sm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (MA(a) ? a : Promise.resolve(a));
    return V6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: jr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new F1({
      schema: this,
      typeName: ba.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return hh.create(this, this._def);
  }
  nullable() {
    return ay.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return h5.create(this);
  }
  promise() {
    return ox.create(this, this._def);
  }
  or(e) {
    return DA.create([this, e], this._def);
  }
  and(e) {
    return LA.create(this, e, this._def);
  }
  transform(e) {
    return new F1({
      ...fi(this._def),
      schema: this,
      typeName: ba.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new GA({
      ...fi(this._def),
      innerType: this,
      defaultValue: r,
      typeName: ba.ZodDefault
    });
  }
  brand() {
    return new D1e({
      typeName: ba.ZodBranded,
      type: this,
      ...fi(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new WA({
      ...fi(this._def),
      innerType: this,
      catchValue: r,
      typeName: ba.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return L1e.create(this, e);
  }
  readonly() {
    return HA.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const h_t = /^c[^\s-]{8,}$/i, p_t = /^[0-9a-z]+$/, m_t = /^[0-9A-HJKMNP-TV-Z]{26}$/i, g_t = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, v_t = /^[a-z0-9_-]{21}$/i, y_t = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, b_t = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, x_t = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, C_t = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let OK;
const w_t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, S_t = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, __t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, k_t = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, A_t = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, T_t = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, iVe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", E_t = new RegExp(`^${iVe}$`);
function oVe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function I_t(t) {
  return new RegExp(`^${oVe(t)}$`);
}
function sVe(t) {
  let e = `${iVe}T${oVe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function M_t(t, e) {
  return !!((e === "v4" || !e) && w_t.test(t) || (e === "v6" || !e) && __t.test(t));
}
function P_t(t, e) {
  if (!y_t.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function R_t(t, e) {
  return !!((e === "v4" || !e) && S_t.test(t) || (e === "v6" || !e) && k_t.test(t));
}
let ax = class HS extends Ii {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== Sn.string) {
      const i = this._getOrReturnCtx(e);
      return cn(i, {
        code: jr.invalid_type,
        expected: Sn.string,
        received: i.parsedType
      }), Ia;
    }
    const n = new _d();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), cn(a, {
          code: jr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), cn(a, {
          code: jr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? cn(a, {
          code: jr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && cn(a, {
          code: jr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        x_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "email",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        OK || (OK = new RegExp(C_t, "u")), OK.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "emoji",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        g_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "uuid",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        v_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "nanoid",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        h_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "cuid",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        p_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "cuid2",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        m_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
          validation: "ulid",
          code: jr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), cn(a, {
            validation: "url",
            code: jr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "regex",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? sVe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? E_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? I_t(i).test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? b_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "duration",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? M_t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "ip",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? P_t(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "jwt",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? R_t(e.data, i.version) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "cidr",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? A_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "base64",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? T_t.test(e.data) || (a = this._getOrReturnCtx(e, a), cn(a, {
        validation: "base64url",
        code: jr.invalid_string,
        message: i.message
      }), n.dirty()) : ro.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: jr.invalid_string,
      ...Ln.errToObj(n)
    });
  }
  _addCheck(e) {
    return new HS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Ln.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Ln.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Ln.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Ln.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Ln.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Ln.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Ln.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Ln.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Ln.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Ln.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Ln.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Ln.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Ln.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...Ln.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...Ln.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Ln.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Ln.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...Ln.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Ln.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Ln.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Ln.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Ln.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Ln.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Ln.errToObj(e));
  }
  trim() {
    return new HS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new HS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new HS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
ax.create = (t) => {
  var e;
  return new ax({
    checks: [],
    typeName: ba.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...fi(t)
  });
};
function O_t(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let PA = class _ce extends Ii {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== Sn.number) {
      const i = this._getOrReturnCtx(e);
      return cn(i, {
        code: jr.invalid_type,
        expected: Sn.number,
        received: i.parsedType
      }), Ia;
    }
    let n;
    const a = new _d();
    for (const i of this._def.checks)
      i.kind === "int" ? ro.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? O_t(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.not_finite,
        message: i.message
      }), a.dirty()) : ro.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Ln.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Ln.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Ln.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Ln.toString(r));
  }
  setLimit(e, r, n, a) {
    return new _ce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Ln.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new _ce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Ln.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ln.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ln.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ln.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ln.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Ln.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Ln.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ln.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ln.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ro.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
PA.create = (t) => new PA({
  checks: [],
  typeName: ba.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...fi(t)
});
let RA = class kce extends Ii {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== Sn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new _d();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), cn(n, {
        code: jr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : ro.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return cn(r, {
      code: jr.invalid_type,
      expected: Sn.bigint,
      received: r.parsedType
    }), Ia;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Ln.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Ln.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Ln.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Ln.toString(r));
  }
  setLimit(e, r, n, a) {
    return new kce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Ln.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new kce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ln.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ln.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ln.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ln.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Ln.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
RA.create = (t) => {
  var e;
  return new RA({
    checks: [],
    typeName: ba.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...fi(t)
  });
};
let OA = class extends Ii {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== Sn.boolean) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.boolean,
        received: n.parsedType
      }), Ia;
    }
    return Ru(e.data);
  }
};
OA.create = (t) => new OA({
  typeName: ba.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...fi(t)
});
let BA = class lVe extends Ii {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== Sn.date) {
      const i = this._getOrReturnCtx(e);
      return cn(i, {
        code: jr.invalid_type,
        expected: Sn.date,
        received: i.parsedType
      }), Ia;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return cn(i, {
        code: jr.invalid_date
      }), Ia;
    }
    const n = new _d();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), cn(a, {
        code: jr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : ro.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new lVe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Ln.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Ln.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
BA.create = (t) => new BA({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: ba.ZodDate,
  ...fi(t)
});
let FD = class extends Ii {
  _parse(e) {
    if (this._getType(e) !== Sn.symbol) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.symbol,
        received: n.parsedType
      }), Ia;
    }
    return Ru(e.data);
  }
};
FD.create = (t) => new FD({
  typeName: ba.ZodSymbol,
  ...fi(t)
});
let NA = class extends Ii {
  _parse(e) {
    if (this._getType(e) !== Sn.undefined) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.undefined,
        received: n.parsedType
      }), Ia;
    }
    return Ru(e.data);
  }
};
NA.create = (t) => new NA({
  typeName: ba.ZodUndefined,
  ...fi(t)
});
let $A = class extends Ii {
  _parse(e) {
    if (this._getType(e) !== Sn.null) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.null,
        received: n.parsedType
      }), Ia;
    }
    return Ru(e.data);
  }
};
$A.create = (t) => new $A({
  typeName: ba.ZodNull,
  ...fi(t)
});
let ix = class extends Ii {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Ru(e.data);
  }
};
ix.create = (t) => new ix({
  typeName: ba.ZodAny,
  ...fi(t)
});
let Rb = class extends Ii {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Ru(e.data);
  }
};
Rb.create = (t) => new Rb({
  typeName: ba.ZodUnknown,
  ...fi(t)
});
let zm = class extends Ii {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return cn(r, {
      code: jr.invalid_type,
      expected: Sn.never,
      received: r.parsedType
    }), Ia;
  }
};
zm.create = (t) => new zm({
  typeName: ba.ZodNever,
  ...fi(t)
});
let zD = class extends Ii {
  _parse(e) {
    if (this._getType(e) !== Sn.undefined) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.void,
        received: n.parsedType
      }), Ia;
    }
    return Ru(e.data);
  }
};
zD.create = (t) => new zD({
  typeName: ba.ZodVoid,
  ...fi(t)
});
let h5 = class qN extends Ii {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== Sn.array)
      return cn(r, {
        code: jr.invalid_type,
        expected: Sn.array,
        received: r.parsedType
      }), Ia;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (cn(r, {
        code: o ? jr.too_big : jr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (cn(r, {
      code: jr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (cn(r, {
      code: jr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Bh(r, o, r.path, s)))).then((o) => _d.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Bh(r, o, r.path, s)));
    return _d.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new qN({
      ...this._def,
      minLength: { value: e, message: Ln.toString(r) }
    });
  }
  max(e, r) {
    return new qN({
      ...this._def,
      maxLength: { value: e, message: Ln.toString(r) }
    });
  }
  length(e, r) {
    return new qN({
      ...this._def,
      exactLength: { value: e, message: Ln.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
h5.create = (t, e) => new h5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: ba.ZodArray,
  ...fi(e)
});
function g9(t) {
  if (t instanceof cf) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = hh.create(g9(n));
    }
    return new cf({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof h5 ? new h5({
    ...t._def,
    type: g9(t.element)
  }) : t instanceof hh ? hh.create(g9(t.unwrap())) : t instanceof ay ? ay.create(g9(t.unwrap())) : t instanceof ny ? ny.create(t.items.map((e) => g9(e))) : t;
}
let cf = class e1 extends Ii {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = ro.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== Sn.object) {
      const c = this._getOrReturnCtx(e);
      return cn(c, {
        code: jr.invalid_type,
        expected: Sn.object,
        received: c.parsedType
      }), Ia;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof zm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Bh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof zm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (cn(a, {
          code: jr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Bh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => _d.mergeObjectSync(n, c)) : _d.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Ln.errToObj, new e1({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Ln.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new e1({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new e1({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new e1({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new e1({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: ba.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new e1({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return ro.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new e1({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return ro.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new e1({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return g9(this);
  }
  partial(e) {
    const r = {};
    return ro.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new e1({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return ro.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof hh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new e1({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return pVe(ro.objectKeys(this.shape));
  }
};
cf.create = (t, e) => new cf({
  shape: () => t,
  unknownKeys: "strip",
  catchall: zm.create(),
  typeName: ba.ZodObject,
  ...fi(e)
});
cf.strictCreate = (t, e) => new cf({
  shape: () => t,
  unknownKeys: "strict",
  catchall: zm.create(),
  typeName: ba.ZodObject,
  ...fi(e)
});
cf.lazycreate = (t, e) => new cf({
  shape: t,
  unknownKeys: "strip",
  catchall: zm.create(),
  typeName: ba.ZodObject,
  ...fi(e)
});
let DA = class extends Ii {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new T1(s.ctx.common.issues));
      return cn(r, {
        code: jr.invalid_union,
        unionErrors: o
      }), Ia;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new T1(l));
      return cn(r, {
        code: jr.invalid_union,
        unionErrors: s
      }), Ia;
    }
  }
  get options() {
    return this._def.options;
  }
};
DA.create = (t, e) => new DA({
  options: t,
  typeName: ba.ZodUnion,
  ...fi(e)
});
const qp = (t) => t instanceof jA ? qp(t.schema) : t instanceof F1 ? qp(t.innerType()) : t instanceof FA ? [t.value] : t instanceof LI ? t.options : t instanceof zA ? ro.objectValues(t.enum) : t instanceof GA ? qp(t._def.innerType) : t instanceof NA ? [void 0] : t instanceof $A ? [null] : t instanceof hh ? [void 0, ...qp(t.unwrap())] : t instanceof ay ? [null, ...qp(t.unwrap())] : t instanceof D1e || t instanceof HA ? qp(t.unwrap()) : t instanceof WA ? qp(t._def.innerType) : [];
let cVe = class uVe extends Ii {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Sn.object)
      return cn(r, {
        code: jr.invalid_type,
        expected: Sn.object,
        received: r.parsedType
      }), Ia;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (cn(r, {
      code: jr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Ia);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = qp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new uVe({
      typeName: ba.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...fi(n)
    });
  }
};
function Ace(t, e) {
  const r = sm(t), n = sm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === Sn.object && n === Sn.object) {
    const a = ro.objectKeys(e), i = ro.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Ace(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === Sn.array && n === Sn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Ace(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === Sn.date && n === Sn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let LA = class extends Ii {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (wce(i) || wce(o))
        return Ia;
      const s = Ace(i.value, o.value);
      return s.valid ? ((Sce(i) || Sce(o)) && r.dirty(), { status: r.value, value: s.data }) : (cn(n, {
        code: jr.invalid_intersection_types
      }), Ia);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
LA.create = (t, e, r) => new LA({
  left: t,
  right: e,
  typeName: ba.ZodIntersection,
  ...fi(r)
});
let ny = class dVe extends Ii {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Sn.array)
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.array,
        received: n.parsedType
      }), Ia;
    if (n.data.length < this._def.items.length)
      return cn(n, {
        code: jr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ia;
    !this._def.rest && n.data.length > this._def.items.length && (cn(n, {
      code: jr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Bh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => _d.mergeArray(r, o)) : _d.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new dVe({
      ...this._def,
      rest: e
    });
  }
};
ny.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ny({
    items: t,
    typeName: ba.ZodTuple,
    rest: null,
    ...fi(e)
  });
};
let fVe = class Tce extends Ii {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Sn.object)
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.object,
        received: n.parsedType
      }), Ia;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Bh(n, s, n.path, s)),
        value: o._parse(new Bh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? _d.mergeObjectAsync(r, a) : _d.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Ii ? new Tce({
      keyType: e,
      valueType: r,
      typeName: ba.ZodRecord,
      ...fi(n)
    }) : new Tce({
      keyType: ax.create(),
      valueType: e,
      typeName: ba.ZodRecord,
      ...fi(r)
    });
  }
}, GD = class extends Ii {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Sn.map)
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.map,
        received: n.parsedType
      }), Ia;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Bh(n, s, n.path, [c, "key"])),
      value: i._parse(new Bh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ia;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ia;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
GD.create = (t, e, r) => new GD({
  valueType: e,
  keyType: t,
  typeName: ba.ZodMap,
  ...fi(r)
});
let WD = class Ece extends Ii {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== Sn.set)
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.set,
        received: n.parsedType
      }), Ia;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (cn(n, {
      code: jr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (cn(n, {
      code: jr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ia;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Bh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new Ece({
      ...this._def,
      minSize: { value: e, message: Ln.toString(r) }
    });
  }
  max(e, r) {
    return new Ece({
      ...this._def,
      maxSize: { value: e, message: Ln.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
WD.create = (t, e) => new WD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: ba.ZodSet,
  ...fi(e)
});
let hVe = class KN extends Ii {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Sn.function)
      return cn(r, {
        code: jr.invalid_type,
        expected: Sn.function,
        received: r.parsedType
      }), Ia;
    function n(s, l) {
      return LD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          DD(),
          nx
        ].filter((c) => !!c),
        issueData: {
          code: jr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return LD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          DD(),
          nx
        ].filter((c) => !!c),
        issueData: {
          code: jr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof ox) {
      const s = this;
      return Ru(async function(...l) {
        const c = new T1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Ru(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new T1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new T1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new KN({
      ...this._def,
      args: ny.create(e).rest(Rb.create())
    });
  }
  returns(e) {
    return new KN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new KN({
      args: e || ny.create([]).rest(Rb.create()),
      returns: r || Rb.create(),
      typeName: ba.ZodFunction,
      ...fi(n)
    });
  }
}, jA = class extends Ii {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
jA.create = (t, e) => new jA({
  getter: t,
  typeName: ba.ZodLazy,
  ...fi(e)
});
let FA = class extends Ii {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return cn(r, {
        received: r.data,
        code: jr.invalid_literal,
        expected: this._def.value
      }), Ia;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
FA.create = (t, e) => new FA({
  value: t,
  typeName: ba.ZodLiteral,
  ...fi(e)
});
function pVe(t, e) {
  return new LI({
    values: t,
    typeName: ba.ZodEnum,
    ...fi(e)
  });
}
let LI = class Ice extends Ii {
  constructor() {
    super(...arguments), GS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return cn(r, {
        expected: ro.joinValues(n),
        received: r.parsedType,
        code: jr.invalid_type
      }), Ia;
    }
    if (jD(this, GS) || aVe(this, GS, new Set(this._def.values)), !jD(this, GS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return cn(r, {
        received: r.data,
        code: jr.invalid_enum_value,
        options: n
      }), Ia;
    }
    return Ru(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Ice.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Ice.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
GS = /* @__PURE__ */ new WeakMap();
LI.create = pVe;
let zA = class extends Ii {
  constructor() {
    super(...arguments), WS.set(this, void 0);
  }
  _parse(e) {
    const r = ro.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== Sn.string && n.parsedType !== Sn.number) {
      const a = ro.objectValues(r);
      return cn(n, {
        expected: ro.joinValues(a),
        received: n.parsedType,
        code: jr.invalid_type
      }), Ia;
    }
    if (jD(this, WS) || aVe(this, WS, new Set(ro.getValidEnumValues(this._def.values))), !jD(this, WS).has(e.data)) {
      const a = ro.objectValues(r);
      return cn(n, {
        received: n.data,
        code: jr.invalid_enum_value,
        options: a
      }), Ia;
    }
    return Ru(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
WS = /* @__PURE__ */ new WeakMap();
zA.create = (t, e) => new zA({
  values: t,
  typeName: ba.ZodNativeEnum,
  ...fi(e)
});
let ox = class extends Ii {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== Sn.promise && r.common.async === !1)
      return cn(r, {
        code: jr.invalid_type,
        expected: Sn.promise,
        received: r.parsedType
      }), Ia;
    const n = r.parsedType === Sn.promise ? r.data : Promise.resolve(r.data);
    return Ru(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
ox.create = (t, e) => new ox({
  type: t,
  typeName: ba.ZodPromise,
  ...fi(e)
});
let F1 = class extends Ii {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ba.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        cn(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Ia;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Ia : l.status === "dirty" || r.value === "dirty" ? R9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Ia;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ia : s.status === "dirty" || r.value === "dirty" ? R9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ia : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Ia : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!f5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => f5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    ro.assertNever(a);
  }
};
F1.create = (t, e, r) => new F1({
  schema: t,
  typeName: ba.ZodEffects,
  effect: e,
  ...fi(r)
});
F1.createWithPreprocess = (t, e, r) => new F1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: ba.ZodEffects,
  ...fi(r)
});
let hh = class extends Ii {
  _parse(e) {
    return this._getType(e) === Sn.undefined ? Ru(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
hh.create = (t, e) => new hh({
  innerType: t,
  typeName: ba.ZodOptional,
  ...fi(e)
});
let ay = class extends Ii {
  _parse(e) {
    return this._getType(e) === Sn.null ? Ru(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ay.create = (t, e) => new ay({
  innerType: t,
  typeName: ba.ZodNullable,
  ...fi(e)
});
let GA = class extends Ii {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === Sn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
GA.create = (t, e) => new GA({
  innerType: t,
  typeName: ba.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...fi(e)
});
let WA = class extends Ii {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return MA(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new T1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new T1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
WA.create = (t, e) => new WA({
  innerType: t,
  typeName: ba.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...fi(e)
});
let HD = class extends Ii {
  _parse(e) {
    if (this._getType(e) !== Sn.nan) {
      const n = this._getOrReturnCtx(e);
      return cn(n, {
        code: jr.invalid_type,
        expected: Sn.nan,
        received: n.parsedType
      }), Ia;
    }
    return { status: "valid", value: e.data };
  }
};
HD.create = (t) => new HD({
  typeName: ba.ZodNaN,
  ...fi(t)
});
const B_t = Symbol("zod_brand");
let D1e = class extends Ii {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, L1e = class mVe extends Ii {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Ia : i.status === "dirty" ? (r.dirty(), R9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Ia : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new mVe({
      in: e,
      out: r,
      typeName: ba.ZodPipeline
    });
  }
}, HA = class extends Ii {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (f5(a) && (a.value = Object.freeze(a.value)), a);
    return MA(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
HA.create = (t, e) => new HA({
  innerType: t,
  typeName: ba.ZodReadonly,
  ...fi(e)
});
function gVe(t, e = {}, r) {
  return t ? ix.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : ix.create();
}
const N_t = {
  object: cf.lazycreate
};
var ba;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(ba || (ba = {}));
const $_t = (t, e = {
  message: `Input not instance of ${t.name}`
}) => gVe((r) => r instanceof t, e), vVe = ax.create, yVe = PA.create, D_t = HD.create, L_t = RA.create, bVe = OA.create, j_t = BA.create, F_t = FD.create, z_t = NA.create, G_t = $A.create, W_t = ix.create, H_t = Rb.create, U_t = zm.create, V_t = zD.create, q_t = h5.create, K_t = cf.create, Z_t = cf.strictCreate, J_t = DA.create, Y_t = cVe.create, X_t = LA.create, Q_t = ny.create, ekt = fVe.create, tkt = GD.create, rkt = WD.create, nkt = hVe.create, akt = jA.create, ikt = FA.create, okt = LI.create, skt = zA.create, lkt = ox.create, q6e = F1.create, ckt = hh.create, ukt = ay.create, dkt = F1.createWithPreprocess, fkt = L1e.create, hkt = () => vVe().optional(), pkt = () => yVe().optional(), mkt = () => bVe().optional(), gkt = {
  string: (t) => ax.create({ ...t, coerce: !0 }),
  number: (t) => PA.create({ ...t, coerce: !0 }),
  boolean: (t) => OA.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => RA.create({ ...t, coerce: !0 }),
  date: (t) => BA.create({ ...t, coerce: !0 })
}, vkt = Ia;
var ykt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: nx,
  setErrorMap: d_t,
  getErrorMap: DD,
  makeIssue: LD,
  EMPTY_PATH: f_t,
  addIssueToContext: cn,
  ParseStatus: _d,
  INVALID: Ia,
  DIRTY: R9,
  OK: Ru,
  isAborted: wce,
  isDirty: Sce,
  isValid: f5,
  isAsync: MA,
  get util() {
    return ro;
  },
  get objectUtil() {
    return Cce;
  },
  ZodParsedType: Sn,
  getParsedType: sm,
  ZodType: Ii,
  datetimeRegex: sVe,
  ZodString: ax,
  ZodNumber: PA,
  ZodBigInt: RA,
  ZodBoolean: OA,
  ZodDate: BA,
  ZodSymbol: FD,
  ZodUndefined: NA,
  ZodNull: $A,
  ZodAny: ix,
  ZodUnknown: Rb,
  ZodNever: zm,
  ZodVoid: zD,
  ZodArray: h5,
  ZodObject: cf,
  ZodUnion: DA,
  ZodDiscriminatedUnion: cVe,
  ZodIntersection: LA,
  ZodTuple: ny,
  ZodRecord: fVe,
  ZodMap: GD,
  ZodSet: WD,
  ZodFunction: hVe,
  ZodLazy: jA,
  ZodLiteral: FA,
  ZodEnum: LI,
  ZodNativeEnum: zA,
  ZodPromise: ox,
  ZodEffects: F1,
  ZodTransformer: F1,
  ZodOptional: hh,
  ZodNullable: ay,
  ZodDefault: GA,
  ZodCatch: WA,
  ZodNaN: HD,
  BRAND: B_t,
  ZodBranded: D1e,
  ZodPipeline: L1e,
  ZodReadonly: HA,
  custom: gVe,
  Schema: Ii,
  ZodSchema: Ii,
  late: N_t,
  get ZodFirstPartyTypeKind() {
    return ba;
  },
  coerce: gkt,
  any: W_t,
  array: q_t,
  bigint: L_t,
  boolean: bVe,
  date: j_t,
  discriminatedUnion: Y_t,
  effect: q6e,
  enum: okt,
  function: nkt,
  instanceof: $_t,
  intersection: X_t,
  lazy: akt,
  literal: ikt,
  map: tkt,
  nan: D_t,
  nativeEnum: skt,
  never: U_t,
  null: G_t,
  nullable: ukt,
  number: yVe,
  object: K_t,
  oboolean: mkt,
  onumber: pkt,
  optional: ckt,
  ostring: hkt,
  pipeline: fkt,
  preprocess: dkt,
  promise: lkt,
  record: ekt,
  set: rkt,
  strictObject: Z_t,
  string: vVe,
  symbol: F_t,
  transformer: q6e,
  tuple: Q_t,
  undefined: z_t,
  union: J_t,
  unknown: H_t,
  void: V_t,
  NEVER: vkt,
  ZodIssueCode: jr,
  quotelessJson: u_t,
  ZodError: T1
});
const xVe = () => (t) => t, bkt = 1, CVe = ykt.string().min(bkt), j1e = () => CVe.brand(), gc = [];
for (let t = 0; t < 256; ++t)
  gc.push((t + 256).toString(16).slice(1));
function xkt(t, e = 0) {
  return (gc[t[e + 0]] + gc[t[e + 1]] + gc[t[e + 2]] + gc[t[e + 3]] + "-" + gc[t[e + 4]] + gc[t[e + 5]] + "-" + gc[t[e + 6]] + gc[t[e + 7]] + "-" + gc[t[e + 8]] + gc[t[e + 9]] + "-" + gc[t[e + 10]] + gc[t[e + 11]] + gc[t[e + 12]] + gc[t[e + 13]] + gc[t[e + 14]] + gc[t[e + 15]]).toLowerCase();
}
let BK;
const Ckt = new Uint8Array(16);
function wkt() {
  if (!BK) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    BK = crypto.getRandomValues.bind(crypto);
  }
  return BK(Ckt);
}
const Skt = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), K6e = { randomUUID: Skt };
function _kt(t, e, r) {
  var a;
  if (K6e.randomUUID && !t)
    return K6e.randomUUID();
  t = t || {};
  const n = t.random ?? ((a = t.rng) == null ? void 0 : a.call(t)) ?? wkt();
  if (n.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, xkt(n);
}
const wVe = (t, e = 0) => Array.from(Array(e), t), kkt = () => _kt(), Akt = j1e(), Tkt = {
  ESPRESSO: "espresso",
  LATTE: "latte",
  CAPPUCCINO: "cappuccino",
  MOCHA: "mocha",
  AMERICANO: "americano",
  MACCHIATO: "macciato"
};
ho.nativeEnum(Tkt);
const UD = "AC", iy = 34, Z6e = "US";
var no;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(no || (no = {}));
var Mce;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Mce || (Mce = {}));
const _n = no.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), lm = (t) => {
  switch (typeof t) {
    case "undefined":
      return _n.undefined;
    case "string":
      return _n.string;
    case "number":
      return isNaN(t) ? _n.nan : _n.number;
    case "boolean":
      return _n.boolean;
    case "function":
      return _n.function;
    case "bigint":
      return _n.bigint;
    case "symbol":
      return _n.symbol;
    case "object":
      return Array.isArray(t) ? _n.array : t === null ? _n.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? _n.promise : typeof Map < "u" && t instanceof Map ? _n.map : typeof Set < "u" && t instanceof Set ? _n.set : typeof Date < "u" && t instanceof Date ? _n.date : _n.object;
    default:
      return _n.unknown;
  }
}, Fr = no.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Ekt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let E1 = class SVe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof SVe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, no.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
E1.create = (t) => new E1(t);
const sx = (t, e) => {
  let r;
  switch (t.code) {
    case Fr.invalid_type:
      t.received === _n.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Fr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, no.jsonStringifyReplacer)}`;
      break;
    case Fr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${no.joinValues(t.keys, ", ")}`;
      break;
    case Fr.invalid_union:
      r = "Invalid input";
      break;
    case Fr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${no.joinValues(t.options)}`;
      break;
    case Fr.invalid_enum_value:
      r = `Invalid enum value. Expected ${no.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Fr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Fr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Fr.invalid_date:
      r = "Invalid date";
      break;
    case Fr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : no.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Fr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Fr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Fr.custom:
      r = "Invalid input";
      break;
    case Fr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Fr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Fr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, no.assertNever(t);
  }
  return { message: r };
};
let _Ve = sx;
function Ikt(t) {
  _Ve = t;
}
function VD() {
  return _Ve;
}
const qD = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, Mkt = [];
function un(t, e) {
  const r = VD(), n = qD({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === sx ? void 0 : sx
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let kd = class kVe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Ma;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return kVe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Ma;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Ma = Object.freeze({
  status: "aborted"
}), O9 = (t) => ({ status: "dirty", value: t }), Ou = (t) => ({ status: "valid", value: t }), Pce = (t) => t.status === "aborted", Rce = (t) => t.status === "dirty", p5 = (t) => t.status === "valid", UA = (t) => typeof Promise < "u" && t instanceof Promise;
function KD(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function AVe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var jn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(jn || (jn = {}));
var US, VS;
let Nh = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const J6e = (t, e) => {
  if (p5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new E1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function hi(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Mi = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return lm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: lm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new kd(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: lm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (UA(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: lm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return J6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: lm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return p5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => p5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: lm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (UA(a) ? a : Promise.resolve(a));
    return J6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Fr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new z1({
      schema: this,
      typeName: xa.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return ph.create(this, this._def);
  }
  nullable() {
    return sy.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return m5.create(this);
  }
  promise() {
    return ux.create(this, this._def);
  }
  or(e) {
    return XA.create([this, e], this._def);
  }
  and(e) {
    return QA.create(this, e, this._def);
  }
  transform(e) {
    return new z1({
      ...hi(this._def),
      schema: this,
      typeName: xa.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new nT({
      ...hi(this._def),
      innerType: this,
      defaultValue: r,
      typeName: xa.ZodDefault
    });
  }
  brand() {
    return new F1e({
      typeName: xa.ZodBranded,
      type: this,
      ...hi(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new aT({
      ...hi(this._def),
      innerType: this,
      catchValue: r,
      typeName: xa.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return z1e.create(this, e);
  }
  readonly() {
    return iT.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const Pkt = /^c[^\s-]{8,}$/i, Rkt = /^[0-9a-z]+$/, Okt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Bkt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Nkt = /^[a-z0-9_-]{21}$/i, $kt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Dkt = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Lkt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, jkt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let NK;
const Fkt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, zkt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Gkt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Wkt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Hkt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ukt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, TVe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Vkt = new RegExp(`^${TVe}$`);
function EVe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function qkt(t) {
  return new RegExp(`^${EVe(t)}$`);
}
function IVe(t) {
  let e = `${TVe}T${EVe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function Kkt(t, e) {
  return !!((e === "v4" || !e) && Fkt.test(t) || (e === "v6" || !e) && Gkt.test(t));
}
function Zkt(t, e) {
  if (!$kt.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function Jkt(t, e) {
  return !!((e === "v4" || !e) && zkt.test(t) || (e === "v6" || !e) && Wkt.test(t));
}
let lx = class qS extends Mi {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== _n.string) {
      const i = this._getOrReturnCtx(e);
      return un(i, {
        code: Fr.invalid_type,
        expected: _n.string,
        received: i.parsedType
      }), Ma;
    }
    const n = new kd();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), un(a, {
          code: Fr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), un(a, {
          code: Fr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? un(a, {
          code: Fr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && un(a, {
          code: Fr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        Lkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "email",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        NK || (NK = new RegExp(jkt, "u")), NK.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "emoji",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        Bkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "uuid",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        Nkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "nanoid",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        Pkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "cuid",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        Rkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "cuid2",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        Okt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
          validation: "ulid",
          code: Fr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), un(a, {
            validation: "url",
            code: Fr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "regex",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? IVe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? Vkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? qkt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? Dkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "duration",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? Kkt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "ip",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? Zkt(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "jwt",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? Jkt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "cidr",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? Hkt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "base64",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? Ukt.test(e.data) || (a = this._getOrReturnCtx(e, a), un(a, {
        validation: "base64url",
        code: Fr.invalid_string,
        message: i.message
      }), n.dirty()) : no.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Fr.invalid_string,
      ...jn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new qS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...jn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...jn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...jn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...jn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...jn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...jn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...jn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...jn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...jn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...jn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...jn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...jn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...jn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...jn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...jn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...jn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...jn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...jn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...jn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...jn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...jn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...jn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...jn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, jn.errToObj(e));
  }
  trim() {
    return new qS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new qS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new qS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
lx.create = (t) => {
  var e;
  return new lx({
    checks: [],
    typeName: xa.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...hi(t)
  });
};
function Ykt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let VA = class Oce extends Mi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== _n.number) {
      const i = this._getOrReturnCtx(e);
      return un(i, {
        code: Fr.invalid_type,
        expected: _n.number,
        received: i.parsedType
      }), Ma;
    }
    let n;
    const a = new kd();
    for (const i of this._def.checks)
      i.kind === "int" ? no.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? Ykt(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.not_finite,
        message: i.message
      }), a.dirty()) : no.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, jn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, jn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, jn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, jn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Oce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: jn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Oce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: jn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: jn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: jn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: jn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: jn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: jn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: jn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: jn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: jn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && no.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
VA.create = (t) => new VA({
  checks: [],
  typeName: xa.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...hi(t)
});
let qA = class Bce extends Mi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== _n.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new kd();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), un(n, {
        code: Fr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : no.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return un(r, {
      code: Fr.invalid_type,
      expected: _n.bigint,
      received: r.parsedType
    }), Ma;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, jn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, jn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, jn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, jn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Bce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: jn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Bce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: jn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: jn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: jn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: jn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: jn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
qA.create = (t) => {
  var e;
  return new qA({
    checks: [],
    typeName: xa.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...hi(t)
  });
};
let KA = class extends Mi {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== _n.boolean) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.boolean,
        received: n.parsedType
      }), Ma;
    }
    return Ou(e.data);
  }
};
KA.create = (t) => new KA({
  typeName: xa.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...hi(t)
});
let ZA = class MVe extends Mi {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== _n.date) {
      const i = this._getOrReturnCtx(e);
      return un(i, {
        code: Fr.invalid_type,
        expected: _n.date,
        received: i.parsedType
      }), Ma;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return un(i, {
        code: Fr.invalid_date
      }), Ma;
    }
    const n = new kd();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), un(a, {
        code: Fr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : no.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new MVe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: jn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: jn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
ZA.create = (t) => new ZA({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: xa.ZodDate,
  ...hi(t)
});
let ZD = class extends Mi {
  _parse(e) {
    if (this._getType(e) !== _n.symbol) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.symbol,
        received: n.parsedType
      }), Ma;
    }
    return Ou(e.data);
  }
};
ZD.create = (t) => new ZD({
  typeName: xa.ZodSymbol,
  ...hi(t)
});
let JA = class extends Mi {
  _parse(e) {
    if (this._getType(e) !== _n.undefined) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.undefined,
        received: n.parsedType
      }), Ma;
    }
    return Ou(e.data);
  }
};
JA.create = (t) => new JA({
  typeName: xa.ZodUndefined,
  ...hi(t)
});
let YA = class extends Mi {
  _parse(e) {
    if (this._getType(e) !== _n.null) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.null,
        received: n.parsedType
      }), Ma;
    }
    return Ou(e.data);
  }
};
YA.create = (t) => new YA({
  typeName: xa.ZodNull,
  ...hi(t)
});
let cx = class extends Mi {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Ou(e.data);
  }
};
cx.create = (t) => new cx({
  typeName: xa.ZodAny,
  ...hi(t)
});
let Ob = class extends Mi {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Ou(e.data);
  }
};
Ob.create = (t) => new Ob({
  typeName: xa.ZodUnknown,
  ...hi(t)
});
let Gm = class extends Mi {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return un(r, {
      code: Fr.invalid_type,
      expected: _n.never,
      received: r.parsedType
    }), Ma;
  }
};
Gm.create = (t) => new Gm({
  typeName: xa.ZodNever,
  ...hi(t)
});
let JD = class extends Mi {
  _parse(e) {
    if (this._getType(e) !== _n.undefined) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.void,
        received: n.parsedType
      }), Ma;
    }
    return Ou(e.data);
  }
};
JD.create = (t) => new JD({
  typeName: xa.ZodVoid,
  ...hi(t)
});
let m5 = class ZN extends Mi {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== _n.array)
      return un(r, {
        code: Fr.invalid_type,
        expected: _n.array,
        received: r.parsedType
      }), Ma;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (un(r, {
        code: o ? Fr.too_big : Fr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (un(r, {
      code: Fr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (un(r, {
      code: Fr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new Nh(r, o, r.path, s)))).then((o) => kd.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new Nh(r, o, r.path, s)));
    return kd.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new ZN({
      ...this._def,
      minLength: { value: e, message: jn.toString(r) }
    });
  }
  max(e, r) {
    return new ZN({
      ...this._def,
      maxLength: { value: e, message: jn.toString(r) }
    });
  }
  length(e, r) {
    return new ZN({
      ...this._def,
      exactLength: { value: e, message: jn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
m5.create = (t, e) => new m5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: xa.ZodArray,
  ...hi(e)
});
function v9(t) {
  if (t instanceof uf) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = ph.create(v9(n));
    }
    return new uf({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof m5 ? new m5({
    ...t._def,
    type: v9(t.element)
  }) : t instanceof ph ? ph.create(v9(t.unwrap())) : t instanceof sy ? sy.create(v9(t.unwrap())) : t instanceof oy ? oy.create(t.items.map((e) => v9(e))) : t;
}
let uf = class t1 extends Mi {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = no.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== _n.object) {
      const c = this._getOrReturnCtx(e);
      return un(c, {
        code: Fr.invalid_type,
        expected: _n.object,
        received: c.parsedType
      }), Ma;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Gm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Nh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Gm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (un(a, {
          code: Fr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Nh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => kd.mergeObjectSync(n, c)) : kd.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return jn.errToObj, new t1({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = jn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new t1({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new t1({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new t1({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new t1({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: xa.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new t1({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return no.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new t1({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return no.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new t1({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return v9(this);
  }
  partial(e) {
    const r = {};
    return no.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new t1({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return no.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof ph; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new t1({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return $Ve(no.objectKeys(this.shape));
  }
};
uf.create = (t, e) => new uf({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Gm.create(),
  typeName: xa.ZodObject,
  ...hi(e)
});
uf.strictCreate = (t, e) => new uf({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Gm.create(),
  typeName: xa.ZodObject,
  ...hi(e)
});
uf.lazycreate = (t, e) => new uf({
  shape: t,
  unknownKeys: "strip",
  catchall: Gm.create(),
  typeName: xa.ZodObject,
  ...hi(e)
});
let XA = class extends Mi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new E1(s.ctx.common.issues));
      return un(r, {
        code: Fr.invalid_union,
        unionErrors: o
      }), Ma;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new E1(l));
      return un(r, {
        code: Fr.invalid_union,
        unionErrors: s
      }), Ma;
    }
  }
  get options() {
    return this._def.options;
  }
};
XA.create = (t, e) => new XA({
  options: t,
  typeName: xa.ZodUnion,
  ...hi(e)
});
const Kp = (t) => t instanceof eT ? Kp(t.schema) : t instanceof z1 ? Kp(t.innerType()) : t instanceof tT ? [t.value] : t instanceof jI ? t.options : t instanceof rT ? no.objectValues(t.enum) : t instanceof nT ? Kp(t._def.innerType) : t instanceof JA ? [void 0] : t instanceof YA ? [null] : t instanceof ph ? [void 0, ...Kp(t.unwrap())] : t instanceof sy ? [null, ...Kp(t.unwrap())] : t instanceof F1e || t instanceof iT ? Kp(t.unwrap()) : t instanceof aT ? Kp(t._def.innerType) : [];
let PVe = class RVe extends Mi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _n.object)
      return un(r, {
        code: Fr.invalid_type,
        expected: _n.object,
        received: r.parsedType
      }), Ma;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (un(r, {
      code: Fr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Ma);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Kp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new RVe({
      typeName: xa.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...hi(n)
    });
  }
};
function Nce(t, e) {
  const r = lm(t), n = lm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === _n.object && n === _n.object) {
    const a = no.objectKeys(e), i = no.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Nce(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === _n.array && n === _n.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Nce(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === _n.date && n === _n.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let QA = class extends Mi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Pce(i) || Pce(o))
        return Ma;
      const s = Nce(i.value, o.value);
      return s.valid ? ((Rce(i) || Rce(o)) && r.dirty(), { status: r.value, value: s.data }) : (un(n, {
        code: Fr.invalid_intersection_types
      }), Ma);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
QA.create = (t, e, r) => new QA({
  left: t,
  right: e,
  typeName: xa.ZodIntersection,
  ...hi(r)
});
let oy = class OVe extends Mi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _n.array)
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.array,
        received: n.parsedType
      }), Ma;
    if (n.data.length < this._def.items.length)
      return un(n, {
        code: Fr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ma;
    !this._def.rest && n.data.length > this._def.items.length && (un(n, {
      code: Fr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new Nh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => kd.mergeArray(r, o)) : kd.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new OVe({
      ...this._def,
      rest: e
    });
  }
};
oy.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new oy({
    items: t,
    typeName: xa.ZodTuple,
    rest: null,
    ...hi(e)
  });
};
let BVe = class $ce extends Mi {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _n.object)
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.object,
        received: n.parsedType
      }), Ma;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new Nh(n, s, n.path, s)),
        value: o._parse(new Nh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? kd.mergeObjectAsync(r, a) : kd.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Mi ? new $ce({
      keyType: e,
      valueType: r,
      typeName: xa.ZodRecord,
      ...hi(n)
    }) : new $ce({
      keyType: lx.create(),
      valueType: e,
      typeName: xa.ZodRecord,
      ...hi(r)
    });
  }
}, YD = class extends Mi {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _n.map)
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.map,
        received: n.parsedType
      }), Ma;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new Nh(n, s, n.path, [c, "key"])),
      value: i._parse(new Nh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ma;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ma;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
YD.create = (t, e, r) => new YD({
  valueType: e,
  keyType: t,
  typeName: xa.ZodMap,
  ...hi(r)
});
let XD = class Dce extends Mi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== _n.set)
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.set,
        received: n.parsedType
      }), Ma;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (un(n, {
      code: Fr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (un(n, {
      code: Fr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ma;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new Nh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new Dce({
      ...this._def,
      minSize: { value: e, message: jn.toString(r) }
    });
  }
  max(e, r) {
    return new Dce({
      ...this._def,
      maxSize: { value: e, message: jn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
XD.create = (t, e) => new XD({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: xa.ZodSet,
  ...hi(e)
});
let NVe = class JN extends Mi {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _n.function)
      return un(r, {
        code: Fr.invalid_type,
        expected: _n.function,
        received: r.parsedType
      }), Ma;
    function n(s, l) {
      return qD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          VD(),
          sx
        ].filter((c) => !!c),
        issueData: {
          code: Fr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return qD({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          VD(),
          sx
        ].filter((c) => !!c),
        issueData: {
          code: Fr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof ux) {
      const s = this;
      return Ou(async function(...l) {
        const c = new E1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Ou(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new E1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new E1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new JN({
      ...this._def,
      args: oy.create(e).rest(Ob.create())
    });
  }
  returns(e) {
    return new JN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new JN({
      args: e || oy.create([]).rest(Ob.create()),
      returns: r || Ob.create(),
      typeName: xa.ZodFunction,
      ...hi(n)
    });
  }
}, eT = class extends Mi {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
eT.create = (t, e) => new eT({
  getter: t,
  typeName: xa.ZodLazy,
  ...hi(e)
});
let tT = class extends Mi {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return un(r, {
        received: r.data,
        code: Fr.invalid_literal,
        expected: this._def.value
      }), Ma;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
tT.create = (t, e) => new tT({
  value: t,
  typeName: xa.ZodLiteral,
  ...hi(e)
});
function $Ve(t, e) {
  return new jI({
    values: t,
    typeName: xa.ZodEnum,
    ...hi(e)
  });
}
let jI = class Lce extends Mi {
  constructor() {
    super(...arguments), US.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return un(r, {
        expected: no.joinValues(n),
        received: r.parsedType,
        code: Fr.invalid_type
      }), Ma;
    }
    if (KD(this, US) || AVe(this, US, new Set(this._def.values)), !KD(this, US).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return un(r, {
        received: r.data,
        code: Fr.invalid_enum_value,
        options: n
      }), Ma;
    }
    return Ou(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Lce.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Lce.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
US = /* @__PURE__ */ new WeakMap();
jI.create = $Ve;
let rT = class extends Mi {
  constructor() {
    super(...arguments), VS.set(this, void 0);
  }
  _parse(e) {
    const r = no.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== _n.string && n.parsedType !== _n.number) {
      const a = no.objectValues(r);
      return un(n, {
        expected: no.joinValues(a),
        received: n.parsedType,
        code: Fr.invalid_type
      }), Ma;
    }
    if (KD(this, VS) || AVe(this, VS, new Set(no.getValidEnumValues(this._def.values))), !KD(this, VS).has(e.data)) {
      const a = no.objectValues(r);
      return un(n, {
        received: n.data,
        code: Fr.invalid_enum_value,
        options: a
      }), Ma;
    }
    return Ou(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
VS = /* @__PURE__ */ new WeakMap();
rT.create = (t, e) => new rT({
  values: t,
  typeName: xa.ZodNativeEnum,
  ...hi(e)
});
let ux = class extends Mi {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== _n.promise && r.common.async === !1)
      return un(r, {
        code: Fr.invalid_type,
        expected: _n.promise,
        received: r.parsedType
      }), Ma;
    const n = r.parsedType === _n.promise ? r.data : Promise.resolve(r.data);
    return Ou(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
ux.create = (t, e) => new ux({
  type: t,
  typeName: xa.ZodPromise,
  ...hi(e)
});
let z1 = class extends Mi {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === xa.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        un(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Ma;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Ma : l.status === "dirty" || r.value === "dirty" ? O9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Ma;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ma : s.status === "dirty" || r.value === "dirty" ? O9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ma : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Ma : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!p5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => p5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    no.assertNever(a);
  }
};
z1.create = (t, e, r) => new z1({
  schema: t,
  typeName: xa.ZodEffects,
  effect: e,
  ...hi(r)
});
z1.createWithPreprocess = (t, e, r) => new z1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: xa.ZodEffects,
  ...hi(r)
});
let ph = class extends Mi {
  _parse(e) {
    return this._getType(e) === _n.undefined ? Ou(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ph.create = (t, e) => new ph({
  innerType: t,
  typeName: xa.ZodOptional,
  ...hi(e)
});
let sy = class extends Mi {
  _parse(e) {
    return this._getType(e) === _n.null ? Ou(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
sy.create = (t, e) => new sy({
  innerType: t,
  typeName: xa.ZodNullable,
  ...hi(e)
});
let nT = class extends Mi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === _n.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
nT.create = (t, e) => new nT({
  innerType: t,
  typeName: xa.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...hi(e)
});
let aT = class extends Mi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return UA(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new E1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new E1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
aT.create = (t, e) => new aT({
  innerType: t,
  typeName: xa.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...hi(e)
});
let QD = class extends Mi {
  _parse(e) {
    if (this._getType(e) !== _n.nan) {
      const n = this._getOrReturnCtx(e);
      return un(n, {
        code: Fr.invalid_type,
        expected: _n.nan,
        received: n.parsedType
      }), Ma;
    }
    return { status: "valid", value: e.data };
  }
};
QD.create = (t) => new QD({
  typeName: xa.ZodNaN,
  ...hi(t)
});
const Xkt = Symbol("zod_brand");
let F1e = class extends Mi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, z1e = class DVe extends Mi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Ma : i.status === "dirty" ? (r.dirty(), O9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Ma : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new DVe({
      in: e,
      out: r,
      typeName: xa.ZodPipeline
    });
  }
}, iT = class extends Mi {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (p5(a) && (a.value = Object.freeze(a.value)), a);
    return UA(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
iT.create = (t, e) => new iT({
  innerType: t,
  typeName: xa.ZodReadonly,
  ...hi(e)
});
function LVe(t, e = {}, r) {
  return t ? cx.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : cx.create();
}
const Qkt = {
  object: uf.lazycreate
};
var xa;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(xa || (xa = {}));
const eAt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => LVe((r) => r instanceof t, e), jVe = lx.create, FVe = VA.create, tAt = QD.create, rAt = qA.create, zVe = KA.create, nAt = ZA.create, aAt = ZD.create, iAt = JA.create, oAt = YA.create, sAt = cx.create, lAt = Ob.create, cAt = Gm.create, uAt = JD.create, dAt = m5.create, fAt = uf.create, hAt = uf.strictCreate, pAt = XA.create, mAt = PVe.create, gAt = QA.create, vAt = oy.create, yAt = BVe.create, bAt = YD.create, xAt = XD.create, CAt = NVe.create, wAt = eT.create, SAt = tT.create, _At = jI.create, kAt = rT.create, AAt = ux.create, Y6e = z1.create, TAt = ph.create, EAt = sy.create, IAt = z1.createWithPreprocess, MAt = z1e.create, PAt = () => jVe().optional(), RAt = () => FVe().optional(), OAt = () => zVe().optional(), BAt = {
  string: (t) => lx.create({ ...t, coerce: !0 }),
  number: (t) => VA.create({ ...t, coerce: !0 }),
  boolean: (t) => KA.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => qA.create({ ...t, coerce: !0 }),
  date: (t) => ZA.create({ ...t, coerce: !0 })
}, NAt = Ma;
var GVe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: sx,
  setErrorMap: Ikt,
  getErrorMap: VD,
  makeIssue: qD,
  EMPTY_PATH: Mkt,
  addIssueToContext: un,
  ParseStatus: kd,
  INVALID: Ma,
  DIRTY: O9,
  OK: Ou,
  isAborted: Pce,
  isDirty: Rce,
  isValid: p5,
  isAsync: UA,
  get util() {
    return no;
  },
  get objectUtil() {
    return Mce;
  },
  ZodParsedType: _n,
  getParsedType: lm,
  ZodType: Mi,
  datetimeRegex: IVe,
  ZodString: lx,
  ZodNumber: VA,
  ZodBigInt: qA,
  ZodBoolean: KA,
  ZodDate: ZA,
  ZodSymbol: ZD,
  ZodUndefined: JA,
  ZodNull: YA,
  ZodAny: cx,
  ZodUnknown: Ob,
  ZodNever: Gm,
  ZodVoid: JD,
  ZodArray: m5,
  ZodObject: uf,
  ZodUnion: XA,
  ZodDiscriminatedUnion: PVe,
  ZodIntersection: QA,
  ZodTuple: oy,
  ZodRecord: BVe,
  ZodMap: YD,
  ZodSet: XD,
  ZodFunction: NVe,
  ZodLazy: eT,
  ZodLiteral: tT,
  ZodEnum: jI,
  ZodNativeEnum: rT,
  ZodPromise: ux,
  ZodEffects: z1,
  ZodTransformer: z1,
  ZodOptional: ph,
  ZodNullable: sy,
  ZodDefault: nT,
  ZodCatch: aT,
  ZodNaN: QD,
  BRAND: Xkt,
  ZodBranded: F1e,
  ZodPipeline: z1e,
  ZodReadonly: iT,
  custom: LVe,
  Schema: Mi,
  ZodSchema: Mi,
  late: Qkt,
  get ZodFirstPartyTypeKind() {
    return xa;
  },
  coerce: BAt,
  any: sAt,
  array: dAt,
  bigint: rAt,
  boolean: zVe,
  date: nAt,
  discriminatedUnion: mAt,
  effect: Y6e,
  enum: _At,
  function: CAt,
  instanceof: eAt,
  intersection: gAt,
  lazy: wAt,
  literal: SAt,
  map: bAt,
  nan: tAt,
  nativeEnum: kAt,
  never: cAt,
  null: oAt,
  nullable: EAt,
  number: FVe,
  object: fAt,
  oboolean: OAt,
  onumber: RAt,
  optional: TAt,
  ostring: PAt,
  pipeline: MAt,
  preprocess: IAt,
  promise: AAt,
  record: yAt,
  set: xAt,
  strictObject: hAt,
  string: jVe,
  symbol: aAt,
  transformer: Y6e,
  tuple: vAt,
  undefined: iAt,
  union: pAt,
  unknown: lAt,
  void: uAt,
  NEVER: NAt,
  ZodIssueCode: Fr,
  quotelessJson: Ekt,
  ZodError: E1
});
const $At = 1, DAt = GVe.string().min($At), G1e = () => DAt.brand(), W1e = () => GVe.string().uuid().brand();
var ao;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(ao || (ao = {}));
var jce;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(jce || (jce = {}));
const kn = ao.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), cm = (t) => {
  switch (typeof t) {
    case "undefined":
      return kn.undefined;
    case "string":
      return kn.string;
    case "number":
      return isNaN(t) ? kn.nan : kn.number;
    case "boolean":
      return kn.boolean;
    case "function":
      return kn.function;
    case "bigint":
      return kn.bigint;
    case "symbol":
      return kn.symbol;
    case "object":
      return Array.isArray(t) ? kn.array : t === null ? kn.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? kn.promise : typeof Map < "u" && t instanceof Map ? kn.map : typeof Set < "u" && t instanceof Set ? kn.set : typeof Date < "u" && t instanceof Date ? kn.date : kn.object;
    default:
      return kn.unknown;
  }
}, zr = ao.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), LAt = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
let I1 = class WVe extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof WVe))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ao.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
};
I1.create = (t) => new I1(t);
const dx = (t, e) => {
  let r;
  switch (t.code) {
    case zr.invalid_type:
      t.received === kn.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case zr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, ao.jsonStringifyReplacer)}`;
      break;
    case zr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${ao.joinValues(t.keys, ", ")}`;
      break;
    case zr.invalid_union:
      r = "Invalid input";
      break;
    case zr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${ao.joinValues(t.options)}`;
      break;
    case zr.invalid_enum_value:
      r = `Invalid enum value. Expected ${ao.joinValues(t.options)}, received '${t.received}'`;
      break;
    case zr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case zr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case zr.invalid_date:
      r = "Invalid date";
      break;
    case zr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : ao.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case zr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case zr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case zr.custom:
      r = "Invalid input";
      break;
    case zr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case zr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case zr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, ao.assertNever(t);
  }
  return { message: r };
};
let HVe = dx;
function jAt(t) {
  HVe = t;
}
function eL() {
  return HVe;
}
const tL = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, FAt = [];
function dn(t, e) {
  const r = eL(), n = tL({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === dx ? void 0 : dx
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
let Ad = class UVe {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Pa;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return UVe.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Pa;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
};
const Pa = Object.freeze({
  status: "aborted"
}), B9 = (t) => ({ status: "dirty", value: t }), Bu = (t) => ({ status: "valid", value: t }), Fce = (t) => t.status === "aborted", zce = (t) => t.status === "dirty", g5 = (t) => t.status === "valid", oT = (t) => typeof Promise < "u" && t instanceof Promise;
function rL(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function VVe(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var Fn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(Fn || (Fn = {}));
var KS, ZS;
let $h = class {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const X6e = (t, e) => {
  if (g5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new I1(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function pi(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
let Pi = class {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return cm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: cm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Ad(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: cm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (oT(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: cm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return X6e(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: cm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return g5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => g5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: cm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (oT(a) ? a : Promise.resolve(a));
    return X6e(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: zr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new G1({
      schema: this,
      typeName: Ca.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return mh.create(this, this._def);
  }
  nullable() {
    return cy.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return v5.create(this);
  }
  promise() {
    return px.create(this, this._def);
  }
  or(e) {
    return hT.create([this, e], this._def);
  }
  and(e) {
    return pT.create(this, e, this._def);
  }
  transform(e) {
    return new G1({
      ...pi(this._def),
      schema: this,
      typeName: Ca.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new yT({
      ...pi(this._def),
      innerType: this,
      defaultValue: r,
      typeName: Ca.ZodDefault
    });
  }
  brand() {
    return new H1e({
      typeName: Ca.ZodBranded,
      type: this,
      ...pi(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new bT({
      ...pi(this._def),
      innerType: this,
      catchValue: r,
      typeName: Ca.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return U1e.create(this, e);
  }
  readonly() {
    return xT.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const zAt = /^c[^\s-]{8,}$/i, GAt = /^[0-9a-z]+$/, WAt = /^[0-9A-HJKMNP-TV-Z]{26}$/i, HAt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, UAt = /^[a-z0-9_-]{21}$/i, VAt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, qAt = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, KAt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, ZAt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let $K;
const JAt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, YAt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, XAt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, QAt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, eTt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, tTt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, qVe = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", rTt = new RegExp(`^${qVe}$`);
function KVe(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function nTt(t) {
  return new RegExp(`^${KVe(t)}$`);
}
function ZVe(t) {
  let e = `${qVe}T${KVe(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function aTt(t, e) {
  return !!((e === "v4" || !e) && JAt.test(t) || (e === "v6" || !e) && XAt.test(t));
}
function iTt(t, e) {
  if (!VAt.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function oTt(t, e) {
  return !!((e === "v4" || !e) && YAt.test(t) || (e === "v6" || !e) && QAt.test(t));
}
let fx = class JS extends Pi {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== kn.string) {
      const i = this._getOrReturnCtx(e);
      return dn(i, {
        code: zr.invalid_type,
        expected: kn.string,
        received: i.parsedType
      }), Pa;
    }
    const n = new Ad();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), dn(a, {
          code: zr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), dn(a, {
          code: zr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? dn(a, {
          code: zr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && dn(a, {
          code: zr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        KAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "email",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        $K || ($K = new RegExp(ZAt, "u")), $K.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "emoji",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        HAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "uuid",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        UAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "nanoid",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        zAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "cuid",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        GAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "cuid2",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        WAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
          validation: "ulid",
          code: zr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), dn(a, {
            validation: "url",
            code: zr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "regex",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? ZVe(i).test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? rTt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? nTt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? qAt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "duration",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? aTt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "ip",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? iTt(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "jwt",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? oTt(e.data, i.version) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "cidr",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? eTt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "base64",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? tTt.test(e.data) || (a = this._getOrReturnCtx(e, a), dn(a, {
        validation: "base64url",
        code: zr.invalid_string,
        message: i.message
      }), n.dirty()) : ao.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: zr.invalid_string,
      ...Fn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new JS({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...Fn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...Fn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...Fn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...Fn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...Fn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...Fn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...Fn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...Fn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...Fn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...Fn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...Fn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...Fn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...Fn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...Fn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...Fn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...Fn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...Fn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...Fn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...Fn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...Fn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...Fn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...Fn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...Fn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, Fn.errToObj(e));
  }
  trim() {
    return new JS({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new JS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new JS({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
fx.create = (t) => {
  var e;
  return new fx({
    checks: [],
    typeName: Ca.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...pi(t)
  });
};
function sTt(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
let sT = class Gce extends Pi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== kn.number) {
      const i = this._getOrReturnCtx(e);
      return dn(i, {
        code: zr.invalid_type,
        expected: kn.number,
        received: i.parsedType
      }), Pa;
    }
    let n;
    const a = new Ad();
    for (const i of this._def.checks)
      i.kind === "int" ? ao.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? sTt(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.not_finite,
        message: i.message
      }), a.dirty()) : ao.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Fn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Fn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Fn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Fn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Gce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Fn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Gce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: Fn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Fn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Fn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Fn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Fn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Fn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: Fn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Fn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Fn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ao.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
};
sT.create = (t) => new sT({
  checks: [],
  typeName: Ca.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...pi(t)
});
let lT = class Wce extends Pi {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== kn.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new Ad();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), dn(n, {
        code: zr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : ao.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return dn(r, {
      code: zr.invalid_type,
      expected: kn.bigint,
      received: r.parsedType
    }), Pa;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, Fn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, Fn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, Fn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, Fn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new Wce({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: Fn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Wce({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Fn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Fn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Fn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Fn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: Fn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
};
lT.create = (t) => {
  var e;
  return new lT({
    checks: [],
    typeName: Ca.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...pi(t)
  });
};
let cT = class extends Pi {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== kn.boolean) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.boolean,
        received: n.parsedType
      }), Pa;
    }
    return Bu(e.data);
  }
};
cT.create = (t) => new cT({
  typeName: Ca.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...pi(t)
});
let uT = class JVe extends Pi {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== kn.date) {
      const i = this._getOrReturnCtx(e);
      return dn(i, {
        code: zr.invalid_type,
        expected: kn.date,
        received: i.parsedType
      }), Pa;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return dn(i, {
        code: zr.invalid_date
      }), Pa;
    }
    const n = new Ad();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), dn(a, {
        code: zr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : ao.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new JVe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: Fn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: Fn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
};
uT.create = (t) => new uT({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: Ca.ZodDate,
  ...pi(t)
});
let nL = class extends Pi {
  _parse(e) {
    if (this._getType(e) !== kn.symbol) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.symbol,
        received: n.parsedType
      }), Pa;
    }
    return Bu(e.data);
  }
};
nL.create = (t) => new nL({
  typeName: Ca.ZodSymbol,
  ...pi(t)
});
let dT = class extends Pi {
  _parse(e) {
    if (this._getType(e) !== kn.undefined) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.undefined,
        received: n.parsedType
      }), Pa;
    }
    return Bu(e.data);
  }
};
dT.create = (t) => new dT({
  typeName: Ca.ZodUndefined,
  ...pi(t)
});
let fT = class extends Pi {
  _parse(e) {
    if (this._getType(e) !== kn.null) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.null,
        received: n.parsedType
      }), Pa;
    }
    return Bu(e.data);
  }
};
fT.create = (t) => new fT({
  typeName: Ca.ZodNull,
  ...pi(t)
});
let hx = class extends Pi {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Bu(e.data);
  }
};
hx.create = (t) => new hx({
  typeName: Ca.ZodAny,
  ...pi(t)
});
let Bb = class extends Pi {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Bu(e.data);
  }
};
Bb.create = (t) => new Bb({
  typeName: Ca.ZodUnknown,
  ...pi(t)
});
let Wm = class extends Pi {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return dn(r, {
      code: zr.invalid_type,
      expected: kn.never,
      received: r.parsedType
    }), Pa;
  }
};
Wm.create = (t) => new Wm({
  typeName: Ca.ZodNever,
  ...pi(t)
});
let aL = class extends Pi {
  _parse(e) {
    if (this._getType(e) !== kn.undefined) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.void,
        received: n.parsedType
      }), Pa;
    }
    return Bu(e.data);
  }
};
aL.create = (t) => new aL({
  typeName: Ca.ZodVoid,
  ...pi(t)
});
let v5 = class YN extends Pi {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== kn.array)
      return dn(r, {
        code: zr.invalid_type,
        expected: kn.array,
        received: r.parsedType
      }), Pa;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (dn(r, {
        code: o ? zr.too_big : zr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (dn(r, {
      code: zr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (dn(r, {
      code: zr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new $h(r, o, r.path, s)))).then((o) => Ad.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new $h(r, o, r.path, s)));
    return Ad.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new YN({
      ...this._def,
      minLength: { value: e, message: Fn.toString(r) }
    });
  }
  max(e, r) {
    return new YN({
      ...this._def,
      maxLength: { value: e, message: Fn.toString(r) }
    });
  }
  length(e, r) {
    return new YN({
      ...this._def,
      exactLength: { value: e, message: Fn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
v5.create = (t, e) => new v5({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ca.ZodArray,
  ...pi(e)
});
function y9(t) {
  if (t instanceof df) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = mh.create(y9(n));
    }
    return new df({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof v5 ? new v5({
    ...t._def,
    type: y9(t.element)
  }) : t instanceof mh ? mh.create(y9(t.unwrap())) : t instanceof cy ? cy.create(y9(t.unwrap())) : t instanceof ly ? ly.create(t.items.map((e) => y9(e))) : t;
}
let df = class r1 extends Pi {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = ao.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== kn.object) {
      const c = this._getOrReturnCtx(e);
      return dn(c, {
        code: zr.invalid_type,
        expected: kn.object,
        received: c.parsedType
      }), Pa;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Wm && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new $h(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Wm) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (dn(a, {
          code: zr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new $h(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Ad.mergeObjectSync(n, c)) : Ad.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return Fn.errToObj, new r1({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = Fn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new r1({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new r1({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new r1({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new r1({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: Ca.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new r1({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return ao.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new r1({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return ao.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new r1({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return y9(this);
  }
  partial(e) {
    const r = {};
    return ao.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new r1({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return ao.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof mh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new r1({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return rqe(ao.objectKeys(this.shape));
  }
};
df.create = (t, e) => new df({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Wm.create(),
  typeName: Ca.ZodObject,
  ...pi(e)
});
df.strictCreate = (t, e) => new df({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Wm.create(),
  typeName: Ca.ZodObject,
  ...pi(e)
});
df.lazycreate = (t, e) => new df({
  shape: t,
  unknownKeys: "strip",
  catchall: Wm.create(),
  typeName: Ca.ZodObject,
  ...pi(e)
});
let hT = class extends Pi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new I1(s.ctx.common.issues));
      return dn(r, {
        code: zr.invalid_union,
        unionErrors: o
      }), Pa;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new I1(l));
      return dn(r, {
        code: zr.invalid_union,
        unionErrors: s
      }), Pa;
    }
  }
  get options() {
    return this._def.options;
  }
};
hT.create = (t, e) => new hT({
  options: t,
  typeName: Ca.ZodUnion,
  ...pi(e)
});
const Zp = (t) => t instanceof mT ? Zp(t.schema) : t instanceof G1 ? Zp(t.innerType()) : t instanceof gT ? [t.value] : t instanceof FI ? t.options : t instanceof vT ? ao.objectValues(t.enum) : t instanceof yT ? Zp(t._def.innerType) : t instanceof dT ? [void 0] : t instanceof fT ? [null] : t instanceof mh ? [void 0, ...Zp(t.unwrap())] : t instanceof cy ? [null, ...Zp(t.unwrap())] : t instanceof H1e || t instanceof xT ? Zp(t.unwrap()) : t instanceof bT ? Zp(t._def.innerType) : [];
let YVe = class XVe extends Pi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== kn.object)
      return dn(r, {
        code: zr.invalid_type,
        expected: kn.object,
        received: r.parsedType
      }), Pa;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (dn(r, {
      code: zr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Pa);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Zp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new XVe({
      typeName: Ca.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...pi(n)
    });
  }
};
function Hce(t, e) {
  const r = cm(t), n = cm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === kn.object && n === kn.object) {
    const a = ao.objectKeys(e), i = ao.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Hce(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === kn.array && n === kn.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Hce(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === kn.date && n === kn.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
let pT = class extends Pi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Fce(i) || Fce(o))
        return Pa;
      const s = Hce(i.value, o.value);
      return s.valid ? ((zce(i) || zce(o)) && r.dirty(), { status: r.value, value: s.data }) : (dn(n, {
        code: zr.invalid_intersection_types
      }), Pa);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
};
pT.create = (t, e, r) => new pT({
  left: t,
  right: e,
  typeName: Ca.ZodIntersection,
  ...pi(r)
});
let ly = class QVe extends Pi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== kn.array)
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.array,
        received: n.parsedType
      }), Pa;
    if (n.data.length < this._def.items.length)
      return dn(n, {
        code: zr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Pa;
    !this._def.rest && n.data.length > this._def.items.length && (dn(n, {
      code: zr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new $h(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => Ad.mergeArray(r, o)) : Ad.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new QVe({
      ...this._def,
      rest: e
    });
  }
};
ly.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ly({
    items: t,
    typeName: Ca.ZodTuple,
    rest: null,
    ...pi(e)
  });
};
let eqe = class Uce extends Pi {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== kn.object)
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.object,
        received: n.parsedType
      }), Pa;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new $h(n, s, n.path, s)),
        value: o._parse(new $h(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? Ad.mergeObjectAsync(r, a) : Ad.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Pi ? new Uce({
      keyType: e,
      valueType: r,
      typeName: Ca.ZodRecord,
      ...pi(n)
    }) : new Uce({
      keyType: fx.create(),
      valueType: e,
      typeName: Ca.ZodRecord,
      ...pi(r)
    });
  }
}, iL = class extends Pi {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== kn.map)
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.map,
        received: n.parsedType
      }), Pa;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new $h(n, s, n.path, [c, "key"])),
      value: i._parse(new $h(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Pa;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Pa;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
};
iL.create = (t, e, r) => new iL({
  valueType: e,
  keyType: t,
  typeName: Ca.ZodMap,
  ...pi(r)
});
let oL = class Vce extends Pi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== kn.set)
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.set,
        received: n.parsedType
      }), Pa;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (dn(n, {
      code: zr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (dn(n, {
      code: zr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Pa;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new $h(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new Vce({
      ...this._def,
      minSize: { value: e, message: Fn.toString(r) }
    });
  }
  max(e, r) {
    return new Vce({
      ...this._def,
      maxSize: { value: e, message: Fn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
};
oL.create = (t, e) => new oL({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: Ca.ZodSet,
  ...pi(e)
});
let tqe = class XN extends Pi {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== kn.function)
      return dn(r, {
        code: zr.invalid_type,
        expected: kn.function,
        received: r.parsedType
      }), Pa;
    function n(s, l) {
      return tL({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          eL(),
          dx
        ].filter((c) => !!c),
        issueData: {
          code: zr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return tL({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          eL(),
          dx
        ].filter((c) => !!c),
        issueData: {
          code: zr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof px) {
      const s = this;
      return Bu(async function(...l) {
        const c = new I1([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Bu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new I1([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new I1([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new XN({
      ...this._def,
      args: ly.create(e).rest(Bb.create())
    });
  }
  returns(e) {
    return new XN({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new XN({
      args: e || ly.create([]).rest(Bb.create()),
      returns: r || Bb.create(),
      typeName: Ca.ZodFunction,
      ...pi(n)
    });
  }
}, mT = class extends Pi {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
};
mT.create = (t, e) => new mT({
  getter: t,
  typeName: Ca.ZodLazy,
  ...pi(e)
});
let gT = class extends Pi {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return dn(r, {
        received: r.data,
        code: zr.invalid_literal,
        expected: this._def.value
      }), Pa;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
};
gT.create = (t, e) => new gT({
  value: t,
  typeName: Ca.ZodLiteral,
  ...pi(e)
});
function rqe(t, e) {
  return new FI({
    values: t,
    typeName: Ca.ZodEnum,
    ...pi(e)
  });
}
let FI = class qce extends Pi {
  constructor() {
    super(...arguments), KS.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return dn(r, {
        expected: ao.joinValues(n),
        received: r.parsedType,
        code: zr.invalid_type
      }), Pa;
    }
    if (rL(this, KS) || VVe(this, KS, new Set(this._def.values)), !rL(this, KS).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return dn(r, {
        received: r.data,
        code: zr.invalid_enum_value,
        options: n
      }), Pa;
    }
    return Bu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return qce.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return qce.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
};
KS = /* @__PURE__ */ new WeakMap();
FI.create = rqe;
let vT = class extends Pi {
  constructor() {
    super(...arguments), ZS.set(this, void 0);
  }
  _parse(e) {
    const r = ao.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== kn.string && n.parsedType !== kn.number) {
      const a = ao.objectValues(r);
      return dn(n, {
        expected: ao.joinValues(a),
        received: n.parsedType,
        code: zr.invalid_type
      }), Pa;
    }
    if (rL(this, ZS) || VVe(this, ZS, new Set(ao.getValidEnumValues(this._def.values))), !rL(this, ZS).has(e.data)) {
      const a = ao.objectValues(r);
      return dn(n, {
        received: n.data,
        code: zr.invalid_enum_value,
        options: a
      }), Pa;
    }
    return Bu(e.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZS = /* @__PURE__ */ new WeakMap();
vT.create = (t, e) => new vT({
  values: t,
  typeName: Ca.ZodNativeEnum,
  ...pi(e)
});
let px = class extends Pi {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== kn.promise && r.common.async === !1)
      return dn(r, {
        code: zr.invalid_type,
        expected: kn.promise,
        received: r.parsedType
      }), Pa;
    const n = r.parsedType === kn.promise ? r.data : Promise.resolve(r.data);
    return Bu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
};
px.create = (t, e) => new px({
  type: t,
  typeName: Ca.ZodPromise,
  ...pi(e)
});
let G1 = class extends Pi {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ca.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        dn(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Pa;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Pa : l.status === "dirty" || r.value === "dirty" ? B9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Pa;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Pa : s.status === "dirty" || r.value === "dirty" ? B9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Pa : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Pa : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!g5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => g5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    ao.assertNever(a);
  }
};
G1.create = (t, e, r) => new G1({
  schema: t,
  typeName: Ca.ZodEffects,
  effect: e,
  ...pi(r)
});
G1.createWithPreprocess = (t, e, r) => new G1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: Ca.ZodEffects,
  ...pi(r)
});
let mh = class extends Pi {
  _parse(e) {
    return this._getType(e) === kn.undefined ? Bu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
mh.create = (t, e) => new mh({
  innerType: t,
  typeName: Ca.ZodOptional,
  ...pi(e)
});
let cy = class extends Pi {
  _parse(e) {
    return this._getType(e) === kn.null ? Bu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
};
cy.create = (t, e) => new cy({
  innerType: t,
  typeName: Ca.ZodNullable,
  ...pi(e)
});
let yT = class extends Pi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === kn.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
yT.create = (t, e) => new yT({
  innerType: t,
  typeName: Ca.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...pi(e)
});
let bT = class extends Pi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return oT(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new I1(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new I1(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
bT.create = (t, e) => new bT({
  innerType: t,
  typeName: Ca.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...pi(e)
});
let sL = class extends Pi {
  _parse(e) {
    if (this._getType(e) !== kn.nan) {
      const n = this._getOrReturnCtx(e);
      return dn(n, {
        code: zr.invalid_type,
        expected: kn.nan,
        received: n.parsedType
      }), Pa;
    }
    return { status: "valid", value: e.data };
  }
};
sL.create = (t) => new sL({
  typeName: Ca.ZodNaN,
  ...pi(t)
});
const lTt = Symbol("zod_brand");
let H1e = class extends Pi {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}, U1e = class nqe extends Pi {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Pa : i.status === "dirty" ? (r.dirty(), B9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Pa : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new nqe({
      in: e,
      out: r,
      typeName: Ca.ZodPipeline
    });
  }
}, xT = class extends Pi {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (g5(a) && (a.value = Object.freeze(a.value)), a);
    return oT(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
};
xT.create = (t, e) => new xT({
  innerType: t,
  typeName: Ca.ZodReadonly,
  ...pi(e)
});
function aqe(t, e = {}, r) {
  return t ? hx.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : hx.create();
}
const cTt = {
  object: df.lazycreate
};
var Ca;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(Ca || (Ca = {}));
const uTt = (t, e = {
  message: `Input not instance of ${t.name}`
}) => aqe((r) => r instanceof t, e), iqe = fx.create, oqe = sT.create, dTt = sL.create, fTt = lT.create, sqe = cT.create, hTt = uT.create, pTt = nL.create, mTt = dT.create, gTt = fT.create, vTt = hx.create, yTt = Bb.create, bTt = Wm.create, xTt = aL.create, CTt = v5.create, wTt = df.create, STt = df.strictCreate, _Tt = hT.create, kTt = YVe.create, ATt = pT.create, TTt = ly.create, ETt = eqe.create, ITt = iL.create, MTt = oL.create, PTt = tqe.create, RTt = mT.create, OTt = gT.create, BTt = FI.create, NTt = vT.create, $Tt = px.create, Q6e = G1.create, DTt = mh.create, LTt = cy.create, jTt = G1.createWithPreprocess, FTt = U1e.create, zTt = () => iqe().optional(), GTt = () => oqe().optional(), WTt = () => sqe().optional(), HTt = {
  string: (t) => fx.create({ ...t, coerce: !0 }),
  number: (t) => sT.create({ ...t, coerce: !0 }),
  boolean: (t) => cT.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => lT.create({ ...t, coerce: !0 }),
  date: (t) => uT.create({ ...t, coerce: !0 })
}, UTt = Pa;
var V1e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: dx,
  setErrorMap: jAt,
  getErrorMap: eL,
  makeIssue: tL,
  EMPTY_PATH: FAt,
  addIssueToContext: dn,
  ParseStatus: Ad,
  INVALID: Pa,
  DIRTY: B9,
  OK: Bu,
  isAborted: Fce,
  isDirty: zce,
  isValid: g5,
  isAsync: oT,
  get util() {
    return ao;
  },
  get objectUtil() {
    return jce;
  },
  ZodParsedType: kn,
  getParsedType: cm,
  ZodType: Pi,
  datetimeRegex: ZVe,
  ZodString: fx,
  ZodNumber: sT,
  ZodBigInt: lT,
  ZodBoolean: cT,
  ZodDate: uT,
  ZodSymbol: nL,
  ZodUndefined: dT,
  ZodNull: fT,
  ZodAny: hx,
  ZodUnknown: Bb,
  ZodNever: Wm,
  ZodVoid: aL,
  ZodArray: v5,
  ZodObject: df,
  ZodUnion: hT,
  ZodDiscriminatedUnion: YVe,
  ZodIntersection: pT,
  ZodTuple: ly,
  ZodRecord: eqe,
  ZodMap: iL,
  ZodSet: oL,
  ZodFunction: tqe,
  ZodLazy: mT,
  ZodLiteral: gT,
  ZodEnum: FI,
  ZodNativeEnum: vT,
  ZodPromise: px,
  ZodEffects: G1,
  ZodTransformer: G1,
  ZodOptional: mh,
  ZodNullable: cy,
  ZodDefault: yT,
  ZodCatch: bT,
  ZodNaN: sL,
  BRAND: lTt,
  ZodBranded: H1e,
  ZodPipeline: U1e,
  ZodReadonly: xT,
  custom: aqe,
  Schema: Pi,
  ZodSchema: Pi,
  late: cTt,
  get ZodFirstPartyTypeKind() {
    return Ca;
  },
  coerce: HTt,
  any: vTt,
  array: CTt,
  bigint: fTt,
  boolean: sqe,
  date: hTt,
  discriminatedUnion: kTt,
  effect: Q6e,
  enum: BTt,
  function: PTt,
  instanceof: uTt,
  intersection: ATt,
  lazy: RTt,
  literal: OTt,
  map: ITt,
  nan: dTt,
  nativeEnum: NTt,
  never: bTt,
  null: gTt,
  nullable: LTt,
  number: oqe,
  object: wTt,
  oboolean: WTt,
  onumber: GTt,
  optional: DTt,
  ostring: zTt,
  pipeline: FTt,
  preprocess: jTt,
  promise: $Tt,
  record: ETt,
  set: MTt,
  strictObject: STt,
  string: iqe,
  symbol: pTt,
  transformer: Q6e,
  tuple: TTt,
  undefined: mTt,
  union: _Tt,
  unknown: yTt,
  void: xTt,
  NEVER: UTt,
  ZodIssueCode: zr,
  quotelessJson: LAt,
  ZodError: I1
});
G1e().refine(
  (t) => t.startsWith(UD) && t.length === iy,
  {
    message: `AccountSID must start with ${UD} and be ${iy} characters long`
  }
);
const VTt = {
  PLAYGROUND: "PLAYGROUND",
  SLACK: "SLACK",
  ONE_ADMIN: "ONE_ADMIN",
  ONE_SUPPORT_CENTER: "ONE_SUPPORT_CENTER",
  SENDGRID_HELP_CENTER: "SENDGRID_HELP_CENTER",
  ZENDESK: "ZENDESK",
  SALESFORCE: "SALESFORCE",
  MESSAGING_INSIGHTS: "MESSAGING_INSIGHTS",
  CONSOLE_MESSAGING_LOGS: "CONSOLE_MESSAGING_LOGS",
  CONSOLE_MESSAGING_LOGS_DETAILS: "CONSOLE_MESSAGING_LOGS_DETAILS",
  WISEOWL_APP: "WISEOWL_APP",
  VOICE_INSIGHTS: "VOICE_INSIGHTS",
  ISA: "ISA"
};
V1e.nativeEnum(VTt);
const qTt = {
  CHAT: "CHAT",
  CONVERSATION: "CONVERSATION"
};
V1e.nativeEnum(qTt);
const KTt = V1e.string().nullable().optional().transform((t) => t ?? null);
KTt.refine(
  (t) => t === null || t.startsWith(UD) && t.length === iy,
  {
    message: `AccountSID must start with ${UD} and be ${iy} characters long`
  }
);
G1e().refine((t) => /^\d+$/.test(t), {
  message: "SendGridUserId must contain only digits"
});
G1e().refine(
  (t) => t.startsWith(Z6e) && t.length === iy,
  {
    message: `UserSID must start with ${Z6e} and be ${iy} characters long`
  }
);
W1e();
W1e();
W1e();
var eB = { exports: {} }, e4e;
function ZTt() {
  return e4e || (e4e = 1, function(t, e) {
    (function() {
      var r = 9007199254740992, n = -9007199254740992, a = "0123456789", i = "abcdefghijklmnopqrstuvwxyz", o = i.toUpperCase(), s = a + "abcdef";
      function l(d) {
        this.name = "UnsupportedError", this.message = d || "This feature is not supported on this platform";
      }
      l.prototype = new Error(), l.prototype.constructor = l;
      var c = Array.prototype.slice;
      function u(d) {
        if (!(this instanceof u))
          return d || (d = null), d === null ? new u() : new u(d);
        if (typeof d == "function")
          return this.random = d, this;
        arguments.length && (this.seed = 0);
        for (var m = 0; m < arguments.length; m++) {
          var v = 0;
          if (Object.prototype.toString.call(arguments[m]) === "[object String]")
            for (var k = 0; k < arguments[m].length; k++) {
              for (var O = 0, G = 0; G < arguments[m].length; G++)
                O = arguments[m].charCodeAt(G) + (O << 6) + (O << 16) - O;
              v += O;
            }
          else
            v = arguments[m];
          this.seed += (arguments.length - m) * v;
        }
        return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function() {
          return this.mt.random(this.seed);
        }, this;
      }
      u.prototype.VERSION = "1.1.12";
      function f(d, m) {
        if (d = d || {}, m)
          for (var v in m)
            typeof d[v] > "u" && (d[v] = m[v]);
        return d;
      }
      function h(d) {
        return Array.apply(null, Array(d)).map(function(m, v) {
          return v;
        });
      }
      function p(d, m) {
        if (d)
          throw new RangeError(m);
      }
      var g = function() {
        throw new Error("No Base64 encoder available.");
      };
      (function() {
        typeof btoa == "function" ? g = btoa : typeof nc == "function" && (g = function(m) {
          return new nc(m).toString("base64");
        });
      })(), u.prototype.bool = function(d) {
        return d = f(d, { likelihood: 50 }), p(
          d.likelihood < 0 || d.likelihood > 100,
          "Chance: Likelihood accepts values from 0 to 100."
        ), this.random() * 100 < d.likelihood;
      }, u.prototype.falsy = function(d) {
        d = f(d, { pool: [!1, null, 0, NaN, "", void 0] });
        var m = d.pool, v = this.integer({ min: 0, max: m.length - 1 }), k = m[v];
        return k;
      }, u.prototype.animal = function(d) {
        if (d = f(d), typeof d.type < "u")
          return p(
            !this.get("animals")[d.type.toLowerCase()],
            "Please pick from desert, ocean, grassland, forest, zoo, pets, farm."
          ), this.pick(this.get("animals")[d.type.toLowerCase()]);
        var m = ["desert", "forest", "ocean", "zoo", "farm", "pet", "grassland"];
        return this.pick(this.get("animals")[this.pick(m)]);
      }, u.prototype.character = function(d) {
        d = f(d);
        var m = "!@#$%^&*()[]", v, k;
        return d.casing === "lower" ? v = i : d.casing === "upper" ? v = o : v = i + o, d.pool ? k = d.pool : (k = "", d.alpha && (k += v), d.numeric && (k += a), d.symbols && (k += m), k || (k = v + a + m)), k.charAt(this.natural({ max: k.length - 1 }));
      }, u.prototype.floating = function(d) {
        d = f(d, { fixed: 4 }), p(
          d.fixed && d.precision,
          "Chance: Cannot specify both fixed and precision."
        );
        var m, v = Math.pow(10, d.fixed), k = r / v, O = -k;
        p(
          d.min && d.fixed && d.min < O,
          "Chance: Min specified is out of range with fixed. Min should be, at least, " + O
        ), p(
          d.max && d.fixed && d.max > k,
          "Chance: Max specified is out of range with fixed. Max should be, at most, " + k
        ), d = f(d, { min: O, max: k }), m = this.integer({ min: d.min * v, max: d.max * v });
        var G = (m / v).toFixed(d.fixed);
        return parseFloat(G);
      }, u.prototype.integer = function(d) {
        return d = f(d, { min: n, max: r }), p(d.min > d.max, "Chance: Min cannot be greater than Max."), Math.floor(this.random() * (d.max - d.min + 1) + d.min);
      }, u.prototype.natural = function(d) {
        if (d = f(d, { min: 0, max: r }), typeof d.numerals == "number" && (p(d.numerals < 1, "Chance: Numerals cannot be less than one."), d.min = Math.pow(10, d.numerals - 1), d.max = Math.pow(10, d.numerals) - 1), p(d.min < 0, "Chance: Min cannot be less than zero."), d.exclude) {
          p(!Array.isArray(d.exclude), "Chance: exclude must be an array.");
          for (var m in d.exclude)
            p(!Number.isInteger(d.exclude[m]), "Chance: exclude must be numbers.");
          var v = d.min + this.natural({ max: d.max - d.min - d.exclude.length }), k = d.exclude.sort();
          for (var O in k) {
            if (v < k[O])
              break;
            v++;
          }
          return v;
        }
        return this.integer(d);
      }, u.prototype.prime = function(d) {
        d = f(d, { min: 0, max: 1e4 }), p(d.min < 0, "Chance: Min cannot be less than zero."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = x.primes[x.primes.length - 1];
        if (d.max > m)
          for (var v = m + 2; v <= d.max; ++v)
            this.is_prime(v) && x.primes.push(v);
        var k = x.primes.filter(function(O) {
          return O >= d.min && O <= d.max;
        });
        return this.pick(k);
      }, u.prototype.is_prime = function(d) {
        if (d % 1 || d < 2)
          return !1;
        if (d % 2 === 0)
          return d === 2;
        if (d % 3 === 0)
          return d === 3;
        for (var m = Math.sqrt(d), v = 5; v <= m; v += 6)
          if (d % v === 0 || d % (v + 2) === 0)
            return !1;
        return !0;
      }, u.prototype.hex = function(d) {
        d = f(d, { min: 0, max: r, casing: "lower" }), p(d.min < 0, "Chance: Min cannot be less than zero.");
        var m = this.natural({ min: d.min, max: d.max });
        return d.casing === "upper" ? m.toString(16).toUpperCase() : m.toString(16);
      }, u.prototype.letter = function(d) {
        d = f(d, { casing: "lower" });
        var m = "abcdefghijklmnopqrstuvwxyz", v = this.character({ pool: m });
        return d.casing === "upper" && (v = v.toUpperCase()), v;
      }, u.prototype.string = function(d) {
        d = f(d, { min: 5, max: 20 }), d.length !== 0 && !d.length && (d.length = this.natural({ min: d.min, max: d.max })), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return v.join("");
      };
      function y(d) {
        this.c = d;
      }
      y.prototype = {
        substitute: function() {
          return this.c;
        }
      };
      function b(d) {
        this.c = d;
      }
      b.prototype = {
        substitute: function() {
          if (!/[{}\\]/.test(this.c))
            throw new Error('Invalid escape sequence: "\\' + this.c + '".');
          return this.c;
        }
      };
      function w(d) {
        this.c = d;
      }
      w.prototype = {
        replacers: {
          "#": function(d) {
            return d.character({ pool: a });
          },
          A: function(d) {
            return d.character({ pool: o });
          },
          a: function(d) {
            return d.character({ pool: i });
          }
        },
        substitute: function(d) {
          var m = this.replacers[this.c];
          if (!m)
            throw new Error('Invalid replacement character: "' + this.c + '".');
          return m(d);
        }
      };
      function _(d) {
        for (var m = [], v = "identity", k = 0; k < d.length; k++) {
          var O = d[k];
          switch (v) {
            case "escape":
              m.push(new b(O)), v = "identity";
              break;
            case "identity":
              O === "{" ? v = "replace" : O === "\\" ? v = "escape" : m.push(new y(O));
              break;
            case "replace":
              O === "}" ? v = "identity" : m.push(new w(O));
              break;
          }
        }
        return m;
      }
      u.prototype.template = function(d) {
        if (!d)
          throw new Error("Template string is required");
        var m = this;
        return _(d).map(function(v) {
          return v.substitute(m);
        }).join("");
      }, u.prototype.buffer = function(d) {
        if (typeof nc > "u")
          throw new l("Sorry, the buffer() function is not supported on your platform");
        d = f(d, { length: this.natural({ min: 5, max: 20 }) }), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return nc.from(v);
      }, u.prototype.capitalize = function(d) {
        return d.charAt(0).toUpperCase() + d.substr(1);
      }, u.prototype.mixin = function(d) {
        for (var m in d)
          this[m] = d[m];
        return this;
      }, u.prototype.unique = function(d, m, v) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        );
        var k = function(W, U) {
          return W.indexOf(U) !== -1;
        };
        v && (k = v.comparator || k);
        for (var O = [], G = 0, H, j = m * 50, F = c.call(arguments, 2); O.length < m; ) {
          var z = JSON.parse(JSON.stringify(F));
          if (H = d.apply(this, z), k(O, H) || (O.push(H), G = 0), ++G > j)
            throw new RangeError("Chance: num is likely too large for sample set");
        }
        return O;
      }, u.prototype.n = function(d, m) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        ), typeof m > "u" && (m = 1);
        var v = m, k = [], O = c.call(arguments, 2);
        for (v = Math.max(0, v), null; v--; null)
          k.push(d.apply(this, O));
        return k;
      }, u.prototype.pad = function(d, m, v) {
        return v = v || "0", d = d + "", d.length >= m ? d : new Array(m - d.length + 1).join(v) + d;
      }, u.prototype.pick = function(d, m) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pick() from an empty array");
        return !m || m === 1 ? d[this.natural({ max: d.length - 1 })] : this.shuffle(d).slice(0, m);
      }, u.prototype.pickone = function(d) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickone() from an empty array");
        return d[this.natural({ max: d.length - 1 })];
      }, u.prototype.pickset = function(d, m) {
        if (m === 0)
          return [];
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (m < 0)
          throw new RangeError("Chance: Count must be a positive number");
        if (!m || m === 1)
          return [this.pickone(d)];
        var v = d.slice(0), k = v.length;
        return this.n(function() {
          var O = this.natural({ max: --k }), G = v[O];
          return v[O] = v[k], G;
        }, Math.min(k, m));
      }, u.prototype.shuffle = function(d) {
        for (var m = [], v = 0, k = Number(d.length), O = h(k), G = k - 1, H, j = 0; j < k; j++)
          H = this.natural({ max: G }), v = O[H], m[j] = d[v], O[H] = O[G], G -= 1;
        return m;
      }, u.prototype.weighted = function(d, m, v) {
        if (d.length !== m.length)
          throw new RangeError("Chance: Length of array and weights must match");
        for (var k = 0, O, G = 0; G < m.length; ++G) {
          if (O = m[G], isNaN(O))
            throw new RangeError("Chance: All weights must be numbers");
          O > 0 && (k += O);
        }
        if (k === 0)
          throw new RangeError("Chance: No valid entries in array weights");
        var H = this.random() * k, j = 0, F = -1, z;
        for (G = 0; G < m.length; ++G) {
          if (O = m[G], j += O, O > 0) {
            if (H <= j) {
              z = G;
              break;
            }
            F = G;
          }
          G === m.length - 1 && (z = F);
        }
        var W = d[z];
        return v = typeof v > "u" ? !1 : v, v && (d.splice(z, 1), m.splice(z, 1)), W;
      }, u.prototype.paragraph = function(d) {
        d = f(d);
        var m = d.sentences || this.natural({ min: 3, max: 7 }), v = this.n(this.sentence, m), k = d.linebreak === !0 ? `
` : " ";
        return v.join(k);
      }, u.prototype.sentence = function(d) {
        d = f(d);
        var m = d.words || this.natural({ min: 12, max: 18 }), v = d.punctuation, k, O = this.n(this.word, m);
        return k = O.join(" "), k = this.capitalize(k), v !== !1 && !/^[.?;!:]$/.test(v) && (v = "."), v && (k += v), k;
      }, u.prototype.syllable = function(d) {
        d = f(d);
        for (var m = d.length || this.natural({ min: 2, max: 3 }), v = "bcdfghjklmnprstvwz", k = "aeiou", O = v + k, G = "", H, j = 0; j < m; j++)
          j === 0 ? H = this.character({ pool: O }) : v.indexOf(H) === -1 ? H = this.character({ pool: v }) : H = this.character({ pool: k }), G += H;
        return d.capitalize && (G = this.capitalize(G)), G;
      }, u.prototype.word = function(d) {
        d = f(d), p(
          d.syllables && d.length,
          "Chance: Cannot specify both syllables AND length."
        );
        var m = d.syllables || this.natural({ min: 1, max: 3 }), v = "";
        if (d.length) {
          do
            v += this.syllable();
          while (v.length < d.length);
          v = v.substring(0, d.length);
        } else
          for (var k = 0; k < m; k++)
            v += this.syllable();
        return d.capitalize && (v = this.capitalize(v)), v;
      }, u.prototype.emoji = function(d) {
        d = f(d, { category: "all", length: 1 }), p(
          d.length < 1 || BigInt(d.length) > BigInt(r),
          "Chance: length must be between 1 and " + String(r)
        );
        var m = this.get("emojis");
        d.category === "all" && (d.category = this.pickone(Object.keys(m)));
        var v = m[d.category];
        return p(
          v === void 0,
          "Chance: Unrecognised emoji category: [" + d.category + "]."
        ), this.pickset(v, d.length).map(function(k) {
          return String.fromCodePoint(k);
        }).join("");
      }, u.prototype.age = function(d) {
        d = f(d);
        var m;
        switch (d.type) {
          case "child":
            m = { min: 0, max: 12 };
            break;
          case "teen":
            m = { min: 13, max: 19 };
            break;
          case "adult":
            m = { min: 18, max: 65 };
            break;
          case "senior":
            m = { min: 65, max: 100 };
            break;
          case "all":
            m = { min: 0, max: 100 };
            break;
          default:
            m = { min: 18, max: 65 };
            break;
        }
        return this.natural(m);
      }, u.prototype.birthday = function(d) {
        var m = this.age(d), v = /* @__PURE__ */ new Date(), k = v.getFullYear();
        if (d && d.type) {
          var O = /* @__PURE__ */ new Date(), G = /* @__PURE__ */ new Date();
          O.setFullYear(k - m - 1), G.setFullYear(k - m), d = f(d, {
            min: O,
            max: G
          });
        } else if (d && (d.minAge !== void 0 || d.maxAge !== void 0)) {
          p(d.minAge < 0, "Chance: MinAge cannot be less than zero."), p(d.minAge > d.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
          var H = d.minAge !== void 0 ? d.minAge : 0, j = d.maxAge !== void 0 ? d.maxAge : 100, F = new Date(k - j - 1, v.getMonth(), v.getDate()), z = new Date(k - H, v.getMonth(), v.getDate());
          F.setDate(F.getDate() + 1), z.setDate(z.getDate() + 1), z.setMilliseconds(z.getMilliseconds() - 1), d = f(d, {
            min: F,
            max: z
          });
        } else
          d = f(d, {
            year: k - m
          });
        return this.date(d);
      }, u.prototype.cpf = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 9, { max: 9 }), v = m[8] * 2 + m[7] * 3 + m[6] * 4 + m[5] * 5 + m[4] * 6 + m[3] * 7 + m[2] * 8 + m[1] * 9 + m[0] * 10;
        v = 11 - v % 11, v >= 10 && (v = 0);
        var k = v * 2 + m[8] * 3 + m[7] * 4 + m[6] * 5 + m[5] * 6 + m[4] * 7 + m[3] * 8 + m[2] * 9 + m[1] * 10 + m[0] * 11;
        k = 11 - k % 11, k >= 10 && (k = 0);
        var O = "" + m[0] + m[1] + m[2] + "." + m[3] + m[4] + m[5] + "." + m[6] + m[7] + m[8] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.cnpj = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 12, { max: 12 }), v = m[11] * 2 + m[10] * 3 + m[9] * 4 + m[8] * 5 + m[7] * 6 + m[6] * 7 + m[5] * 8 + m[4] * 9 + m[3] * 2 + m[2] * 3 + m[1] * 4 + m[0] * 5;
        v = 11 - v % 11, v < 2 && (v = 0);
        var k = v * 2 + m[11] * 3 + m[10] * 4 + m[9] * 5 + m[8] * 6 + m[7] * 7 + m[6] * 8 + m[5] * 9 + m[4] * 2 + m[3] * 3 + m[2] * 4 + m[1] * 5 + m[0] * 6;
        k = 11 - k % 11, k < 2 && (k = 0);
        var O = "" + m[0] + m[1] + "." + m[2] + m[3] + m[4] + "." + m[5] + m[6] + m[7] + "/" + m[8] + m[9] + m[10] + m[11] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.first = function(d) {
        return d = f(d, { gender: this.gender(), nationality: "en" }), this.pick(this.get("firstNames")[d.gender.toLowerCase()][d.nationality.toLowerCase()]);
      }, u.prototype.profession = function(d) {
        return d = f(d), d.rank ? this.pick(["Apprentice ", "Junior ", "Senior ", "Lead "]) + this.pick(this.get("profession")) : this.pick(this.get("profession"));
      }, u.prototype.company = function() {
        return this.pick(this.get("company"));
      }, u.prototype.gender = function(d) {
        return d = f(d, { extraGenders: [] }), this.pick(["Male", "Female"].concat(d.extraGenders));
      }, u.prototype.last = function(d) {
        if (d = f(d, { nationality: "*" }), d.nationality === "*") {
          var m = [], v = this.get("lastNames");
          return Object.keys(v).forEach(function(k) {
            m = m.concat(v[k]);
          }), this.pick(m);
        } else
          return this.pick(this.get("lastNames")[d.nationality.toLowerCase()]);
      }, u.prototype.israelId = function() {
        for (var d = this.string({ pool: "0123456789", length: 8 }), m = 0, v = 0; v < d.length; v++) {
          var k = d[v] * (v / 2 === parseInt(v / 2) ? 1 : 2);
          k = this.pad(k, 2).toString(), k = parseInt(k[0]) + parseInt(k[1]), m = m + k;
        }
        return d = d + (10 - parseInt(m.toString().slice(-1))).toString().slice(-1), d;
      }, u.prototype.mrz = function(d) {
        var m = function(O) {
          var G = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(""), H = [7, 3, 1], j = 0;
          return typeof O != "string" && (O = O.toString()), O.split("").forEach(function(F, z) {
            var W = G.indexOf(F);
            W !== -1 ? F = W === 0 ? 0 : W + 9 : F = parseInt(F, 10), F *= H[z % H.length], j += F;
          }), j % 10;
        }, v = function(O) {
          var G = function(j) {
            return new Array(j + 1).join("<");
          }, H = [
            "P<",
            O.issuer,
            O.last.toUpperCase(),
            "<<",
            O.first.toUpperCase(),
            G(39 - (O.last.length + O.first.length + 2)),
            O.passportNumber,
            m(O.passportNumber),
            O.nationality,
            O.dob,
            m(O.dob),
            O.gender,
            O.expiry,
            m(O.expiry),
            G(14),
            m(G(14))
          ].join("");
          return H + m(H.substr(44, 10) + H.substr(57, 7) + H.substr(65, 7));
        }, k = this;
        return d = f(d, {
          first: this.first(),
          last: this.last(),
          passportNumber: this.integer({ min: 1e8, max: 999999999 }),
          dob: function() {
            var O = k.birthday({ type: "adult" });
            return [
              O.getFullYear().toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          expiry: function() {
            var O = /* @__PURE__ */ new Date();
            return [
              (O.getFullYear() + 5).toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          gender: this.gender() === "Female" ? "F" : "M",
          issuer: "GBR",
          nationality: "GBR"
        }), v(d);
      }, u.prototype.name = function(d) {
        d = f(d);
        var m = this.first(d), v = this.last(d), k;
        return d.middle ? k = m + " " + this.first(d) + " " + v : d.middle_initial ? k = m + " " + this.character({ alpha: !0, casing: "upper" }) + ". " + v : k = m + " " + v, d.prefix && (k = this.prefix(d) + " " + k), d.suffix && (k = k + " " + this.suffix(d)), k;
      }, u.prototype.name_prefixes = function(d) {
        d = d || "all", d = d.toLowerCase();
        var m = [
          { name: "Doctor", abbreviation: "Dr." }
        ];
        return (d === "male" || d === "all") && m.push({ name: "Mister", abbreviation: "Mr." }), (d === "female" || d === "all") && (m.push({ name: "Miss", abbreviation: "Miss" }), m.push({ name: "Misses", abbreviation: "Mrs." })), m;
      }, u.prototype.prefix = function(d) {
        return this.name_prefix(d);
      }, u.prototype.name_prefix = function(d) {
        return d = f(d, { gender: "all" }), d.full ? this.pick(this.name_prefixes(d.gender)).name : this.pick(this.name_prefixes(d.gender)).abbreviation;
      }, u.prototype.HIDN = function() {
        var d = "0123456789", m = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ", v = "";
        return v += this.string({ pool: d, length: 6 }), v += this.string({ pool: m, length: 2 }), v;
      }, u.prototype.ssn = function(d) {
        d = f(d, { ssnFour: !1, dashes: !0 });
        var m = "1234567890", v, k = d.dashes ? "-" : "";
        return d.ssnFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 3 }) + k + this.string({ pool: m, length: 2 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.aadhar = function(d) {
        d = f(d, { onlyLastFour: !1, separatedByWhiteSpace: !0 });
        var m = "1234567890", v, k = d.separatedByWhiteSpace ? " " : "";
        return d.onlyLastFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.name_suffixes = function() {
        var d = [
          { name: "Doctor of Osteopathic Medicine", abbreviation: "D.O." },
          { name: "Doctor of Philosophy", abbreviation: "Ph.D." },
          { name: "Esquire", abbreviation: "Esq." },
          { name: "Junior", abbreviation: "Jr." },
          { name: "Juris Doctor", abbreviation: "J.D." },
          { name: "Master of Arts", abbreviation: "M.A." },
          { name: "Master of Business Administration", abbreviation: "M.B.A." },
          { name: "Master of Science", abbreviation: "M.S." },
          { name: "Medical Doctor", abbreviation: "M.D." },
          { name: "Senior", abbreviation: "Sr." },
          { name: "The Third", abbreviation: "III" },
          { name: "The Fourth", abbreviation: "IV" },
          { name: "Bachelor of Engineering", abbreviation: "B.E" },
          { name: "Bachelor of Technology", abbreviation: "B.TECH" }
        ];
        return d;
      }, u.prototype.suffix = function(d) {
        return this.name_suffix(d);
      }, u.prototype.name_suffix = function(d) {
        return d = f(d), d.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
      }, u.prototype.nationalities = function() {
        return this.get("nationalities");
      }, u.prototype.nationality = function() {
        var d = this.pick(this.nationalities());
        return d.name;
      }, u.prototype.zodiac = function() {
        const d = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];
        return this.pickone(d);
      }, u.prototype.android_id = function() {
        return "APA91" + this.string({ pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_", length: 178 });
      }, u.prototype.apple_token = function() {
        return this.string({ pool: "abcdef1234567890", length: 64 });
      }, u.prototype.wp8_anid2 = function() {
        return g(this.hash({ length: 32 }));
      }, u.prototype.wp7_anid = function() {
        return "A=" + this.guid().replace(/-/g, "").toUpperCase() + "&E=" + this.hash({ length: 3 }) + "&W=" + this.integer({ min: 0, max: 9 });
      }, u.prototype.bb_pin = function() {
        return this.hash({ length: 8 });
      }, u.prototype.avatar = function(d) {
        var m = null, v = "//www.gravatar.com/avatar/", k = {
          http: "http",
          https: "https"
        }, O = {
          bmp: "bmp",
          gif: "gif",
          jpg: "jpg",
          png: "png"
        }, G = {
          404: "404",
          // Return 404 if not found
          mm: "mm",
          // Mystery man
          identicon: "identicon",
          // Geometric pattern based on hash
          monsterid: "monsterid",
          // A generated monster icon
          wavatar: "wavatar",
          // A generated face
          retro: "retro",
          // 8-bit icon
          blank: "blank"
          // A transparent png
        }, H = {
          g: "g",
          pg: "pg",
          r: "r",
          x: "x"
        }, j = {
          protocol: null,
          email: null,
          fileExtension: null,
          size: null,
          fallback: null,
          rating: null
        };
        if (!d)
          j.email = this.email(), d = {};
        else if (typeof d == "string")
          j.email = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        return j = f(d, j), j.email || (j.email = this.email()), j.protocol = k[j.protocol] ? j.protocol + ":" : "", j.size = parseInt(j.size, 0) ? j.size : "", j.rating = H[j.rating] ? j.rating : "", j.fallback = G[j.fallback] ? j.fallback : "", j.fileExtension = O[j.fileExtension] ? j.fileExtension : "", m = j.protocol + v + this.bimd5.md5(j.email) + (j.fileExtension ? "." + j.fileExtension : "") + (j.size || j.rating || j.fallback ? "?" : "") + (j.size ? "&s=" + j.size.toString() : "") + (j.rating ? "&r=" + j.rating : "") + (j.fallback ? "&d=" + j.fallback : ""), m;
      }, u.prototype.color = function(d) {
        function m(ce, ee) {
          return [ce, ce, ce].join(ee || "");
        }
        function v(ce) {
          var ee = ce ? "rgba" : "rgb", Se = ce ? "," + this.floating({ min: V, max: Y }) : "", Ce = O ? m(this.natural({ min: G, max: H }), ",") : this.natural({ min: z, max: W }) + "," + this.natural({ min: U, max: Z }) + "," + this.natural({ max: 255 });
          return ee + "(" + Ce + Se + ")";
        }
        function k(ce, ee, Se) {
          var Ce = Se ? "#" : "", we = "";
          return O ? (we = m(this.pad(this.hex({ min: G, max: H }), 2)), d.format === "shorthex" && (we = m(this.hex({ min: 0, max: 15 })))) : d.format === "shorthex" ? we = this.pad(this.hex({ min: Math.floor(j / 16), max: Math.floor(F / 16) }), 1) + this.pad(this.hex({ min: Math.floor(z / 16), max: Math.floor(W / 16) }), 1) + this.pad(this.hex({ min: Math.floor(U / 16), max: Math.floor(Z / 16) }), 1) : j !== void 0 || F !== void 0 || z !== void 0 || W !== void 0 || U !== void 0 || Z !== void 0 ? we = this.pad(this.hex({ min: j, max: F }), 2) + this.pad(this.hex({ min: z, max: W }), 2) + this.pad(this.hex({ min: U, max: Z }), 2) : we = this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2), Ce + we;
        }
        d = f(d, {
          format: this.pick(["hex", "shorthex", "rgb", "rgba", "0x", "name"]),
          grayscale: !1,
          casing: "lower",
          min: 0,
          max: 255,
          min_red: void 0,
          max_red: void 0,
          min_green: void 0,
          max_green: void 0,
          min_blue: void 0,
          max_blue: void 0,
          min_alpha: 0,
          max_alpha: 1
        });
        var O = d.grayscale, G = d.min, H = d.max, j = d.min_red, F = d.max_red, z = d.min_green, W = d.max_green, U = d.min_blue, Z = d.max_blue, V = d.min_alpha, Y = d.max_alpha;
        d.min_red === void 0 && (j = G), d.max_red === void 0 && (F = H), d.min_green === void 0 && (z = G), d.max_green === void 0 && (W = H), d.min_blue === void 0 && (U = G), d.max_blue === void 0 && (Z = H), d.min_alpha === void 0 && (V = 0), d.max_alpha === void 0 && (Y = 1), O && G === 0 && H === 255 && j !== void 0 && F !== void 0 && (G = (j + z + U) / 3, H = (F + W + Z) / 3);
        var ge;
        if (d.format === "hex")
          ge = k.call(this, 2, 6, !0);
        else if (d.format === "shorthex")
          ge = k.call(this, 1, 3, !0);
        else if (d.format === "rgb")
          ge = v.call(this, !1);
        else if (d.format === "rgba")
          ge = v.call(this, !0);
        else if (d.format === "0x")
          ge = "0x" + k.call(this, 2, 6);
        else {
          if (d.format === "name")
            return this.pick(this.get("colorNames"));
          throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        }
        return d.casing === "upper" && (ge = ge.toUpperCase()), ge;
      }, u.prototype.domain = function(d) {
        return d = f(d), this.word() + "." + (d.tld || this.tld());
      }, u.prototype.email = function(d) {
        return d = f(d), this.word({ length: d.length }) + "@" + (d.domain || this.domain());
      }, u.prototype.fbid = function() {
        return "10000" + this.string({ pool: "1234567890", length: 11 });
      }, u.prototype.google_analytics = function() {
        var d = this.pad(this.natural({ max: 999999 }), 6), m = this.pad(this.natural({ max: 99 }), 2);
        return "UA-" + d + "-" + m;
      }, u.prototype.hashtag = function() {
        return "#" + this.word();
      }, u.prototype.ip = function() {
        return this.natural({ min: 1, max: 254 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ min: 1, max: 254 });
      }, u.prototype.ipv6 = function() {
        var d = this.n(this.hash, 8, { length: 4 });
        return d.join(":");
      }, u.prototype.klout = function() {
        return this.natural({ min: 1, max: 99 });
      }, u.prototype.mac = function(d) {
        return d = f(d, { delimiter: ":" }), this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2);
      }, u.prototype.semver = function(d) {
        d = f(d, { include_prerelease: !0 });
        var m = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
        d.range && (m = d.range);
        var v = "";
        return d.include_prerelease && (v = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1])), m + this.rpg("3d10").join(".") + v;
      }, u.prototype.tlds = function() {
        return ["com", "org", "edu", "gov", "co.uk", "net", "io", "ac", "ad", "ae", "af", "ag", "ai", "al", "am", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bm", "bn", "bo", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "eu", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "su", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "uk", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"];
      }, u.prototype.tld = function() {
        return this.pick(this.tlds());
      }, u.prototype.twitter = function() {
        return "@" + this.word();
      }, u.prototype.url = function(d) {
        d = f(d, { protocol: "http", domain: this.domain(d), domain_prefix: "", path: this.word(), extensions: [] });
        var m = d.extensions.length > 0 ? "." + this.pick(d.extensions) : "", v = d.domain_prefix ? d.domain_prefix + "." + d.domain : d.domain;
        return d.protocol + "://" + v + "/" + d.path + m;
      }, u.prototype.port = function() {
        return this.integer({ min: 0, max: 65535 });
      }, u.prototype.locale = function(d) {
        return d = f(d), d.region ? this.pick(this.get("locale_regions")) : this.pick(this.get("locale_languages"));
      }, u.prototype.locales = function(d) {
        return d = f(d), d.region ? this.get("locale_regions") : this.get("locale_languages");
      }, u.prototype.loremPicsum = function(d) {
        d = f(d, { width: 500, height: 500, greyscale: !1, blurred: !1 });
        var m = d.greyscale ? "g/" : "", v = d.blurred ? "/?blur" : "/?random";
        return "https://picsum.photos/" + m + d.width + "/" + d.height + v;
      }, u.prototype.address = function(d) {
        return d = f(d), this.natural({ min: 5, max: 2e3 }) + " " + this.street(d);
      }, u.prototype.altitude = function(d) {
        return d = f(d, { fixed: 5, min: 0, max: 8848 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.areacode = function(d) {
        d = f(d, { parens: !0 });
        var m = d.exampleNumber ? "555" : this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 8 }).toString() + this.natural({ min: 0, max: 9 }).toString();
        return d.parens ? "(" + m + ")" : m;
      }, u.prototype.city = function() {
        return this.capitalize(this.word({ syllables: 3 }));
      }, u.prototype.coordinates = function(d) {
        return this.latitude(d) + ", " + this.longitude(d);
      }, u.prototype.countries = function() {
        return this.get("countries");
      }, u.prototype.country = function(d) {
        d = f(d);
        var m = this.pick(this.countries());
        return d.raw ? m : d.full ? m.name : m.abbreviation;
      }, u.prototype.depth = function(d) {
        return d = f(d, { fixed: 5, min: -10994, max: 0 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.geohash = function(d) {
        return d = f(d, { length: 7 }), this.string({ length: d.length, pool: "0123456789bcdefghjkmnpqrstuvwxyz" });
      }, u.prototype.geojson = function(d) {
        return this.latitude(d) + ", " + this.longitude(d) + ", " + this.altitude(d);
      }, u.prototype.latitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 89, fixed: 4 } : { fixed: 5, min: -90, max: 90, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89"), p(d.max < 0 || d.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.longitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 179, fixed: 4 } : { fixed: 5, min: -180, max: 180, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179"), p(d.max < 0 || d.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.phone = function(d) {
        var m = this, v, k = function(U) {
          var Z = [];
          return U.sections.forEach(function(V) {
            Z.push(m.string({ pool: "0123456789", length: V }));
          }), U.area + Z.join(" ");
        };
        d = f(d, {
          formatted: !0,
          country: "us",
          mobile: !1,
          exampleNumber: !1
        }), d.formatted || (d.parens = !1);
        var O;
        switch (d.country) {
          case "fr":
            d.mobile ? (v = this.pick(["06", "07"]) + m.string({ pool: "0123456789", length: 8 }), O = d.formatted ? v.match(/../g).join(" ") : v) : (v = this.pick([
              // Valid zone and département codes.
              "01" + this.pick(["30", "34", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "53", "55", "56", "58", "60", "64", "69", "70", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83"]) + m.string({ pool: "0123456789", length: 6 }),
              "02" + this.pick(["14", "18", "22", "23", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "40", "41", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "56", "57", "61", "62", "69", "72", "76", "77", "78", "85", "90", "96", "97", "98", "99"]) + m.string({ pool: "0123456789", length: 6 }),
              "03" + this.pick(["10", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "39", "44", "45", "51", "52", "54", "55", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90"]) + m.string({ pool: "0123456789", length: 6 }),
              "04" + this.pick(["11", "13", "15", "20", "22", "26", "27", "30", "32", "34", "37", "42", "43", "44", "50", "56", "57", "63", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "88", "89", "90", "91", "92", "93", "94", "95", "97", "98"]) + m.string({ pool: "0123456789", length: 6 }),
              "05" + this.pick(["08", "16", "17", "19", "24", "31", "32", "33", "34", "35", "40", "45", "46", "47", "49", "53", "55", "56", "57", "58", "59", "61", "62", "63", "64", "65", "67", "79", "81", "82", "86", "87", "90", "94"]) + m.string({ pool: "0123456789", length: 6 }),
              "09" + m.string({ pool: "0123456789", length: 8 })
            ]), O = d.formatted ? v.match(/../g).join(" ") : v);
            break;
          case "uk":
            d.mobile ? (v = this.pick([
              { area: "07" + this.pick(["4", "5", "7", "8", "9"]), sections: [2, 6] },
              { area: "07624 ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "")) : (v = this.pick([
              //valid area codes of major cities/counties followed by random numbers in required format.
              { area: "01" + this.character({ pool: "234569" }) + "1 ", sections: [3, 4] },
              { area: "020 " + this.character({ pool: "378" }), sections: [3, 4] },
              { area: "023 " + this.character({ pool: "89" }), sections: [3, 4] },
              { area: "024 7", sections: [3, 4] },
              { area: "028 " + this.pick(["25", "28", "37", "71", "82", "90", "92", "95"]), sections: [2, 4] },
              { area: "012" + this.pick(["04", "08", "54", "76", "97", "98"]) + " ", sections: [6] },
              { area: "013" + this.pick(["63", "64", "84", "86"]) + " ", sections: [6] },
              { area: "014" + this.pick(["04", "20", "60", "61", "80", "88"]) + " ", sections: [6] },
              { area: "015" + this.pick(["24", "27", "62", "66"]) + " ", sections: [6] },
              { area: "016" + this.pick(["06", "29", "35", "47", "59", "95"]) + " ", sections: [6] },
              { area: "017" + this.pick(["26", "44", "50", "68"]) + " ", sections: [6] },
              { area: "018" + this.pick(["27", "37", "84", "97"]) + " ", sections: [6] },
              { area: "019" + this.pick(["00", "05", "35", "46", "49", "63", "95"]) + " ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "", "g"));
            break;
          case "za":
            d.mobile ? (v = this.pick([
              "060" + this.pick(["3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "061" + this.pick(["0", "1", "2", "3", "4", "5", "8"]) + m.string({ pool: "0123456789", length: 6 }),
              "06" + m.string({ pool: "0123456789", length: 7 }),
              "071" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "07" + this.pick(["2", "3", "4", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "08" + this.pick(["0", "1", "2", "3", "4", "5"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v) : (v = this.pick([
              "01" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "02" + this.pick(["1", "2", "3", "4", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "03" + this.pick(["1", "2", "3", "5", "6", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "04" + this.pick(["1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "05" + this.pick(["1", "3", "4", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v);
            break;
          case "us":
            var G = this.areacode(d).toString(), H = this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString(), j = this.natural({ min: 1e3, max: 9999 }).toString();
            O = d.formatted ? G + " " + H + "-" + j : G + H + j;
            break;
          case "br":
            var F = this.pick(["11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", "94", "95", "96", "97", "98", "99"]), z;
            d.mobile ? z = "9" + m.string({ pool: "0123456789", length: 4 }) : z = this.natural({ min: 2e3, max: 5999 }).toString();
            var W = m.string({ pool: "0123456789", length: 4 });
            O = d.formatted ? "(" + F + ") " + z + "-" + W : F + z + W;
            break;
        }
        return O;
      }, u.prototype.postal = function() {
        var d = this.character({ pool: "XVTSRPNKLMHJGECBA" }), m = d + this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }), v = this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }) + this.natural({ max: 9 });
        return m + " " + v;
      }, u.prototype.postcode = function() {
        var d = this.pick(this.get("postcodeAreas")).code, m = this.natural({ max: 9 }), v = this.bool() ? this.character({ alpha: !0, casing: "upper" }) : "", k = d + m + v, O = this.natural({ max: 9 }), G = this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }), H = O + G;
        return k + " " + H;
      }, u.prototype.counties = function(d) {
        return d = f(d, { country: "uk" }), this.get("counties")[d.country.toLowerCase()];
      }, u.prototype.county = function(d) {
        return this.pick(this.counties(d)).name;
      }, u.prototype.provinces = function(d) {
        return d = f(d, { country: "ca" }), this.get("provinces")[d.country.toLowerCase()];
      }, u.prototype.province = function(d) {
        return d && d.full ? this.pick(this.provinces(d)).name : this.pick(this.provinces(d)).abbreviation;
      }, u.prototype.state = function(d) {
        return d && d.full ? this.pick(this.states(d)).name : this.pick(this.states(d)).abbreviation;
      }, u.prototype.states = function(d) {
        d = f(d, { country: "us", us_states_and_dc: !0 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            var v = this.get("us_states_and_dc"), k = this.get("territories"), O = this.get("armed_forces");
            m = [], d.us_states_and_dc && (m = m.concat(v)), d.territories && (m = m.concat(k)), d.armed_forces && (m = m.concat(O));
            break;
          case "it":
          case "mx":
            m = this.get("country_regions")[d.country.toLowerCase()];
            break;
          case "uk":
            m = this.get("counties")[d.country.toLowerCase()];
            break;
        }
        return m;
      }, u.prototype.street = function(d) {
        d = f(d, { country: "us", syllables: 2 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m += " ", m += d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name;
            break;
          case "it":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m = (d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name) + " " + m;
            break;
        }
        return m;
      }, u.prototype.street_suffix = function(d) {
        return d = f(d, { country: "us" }), this.pick(this.street_suffixes(d));
      }, u.prototype.street_suffixes = function(d) {
        return d = f(d, { country: "us" }), this.get("street_suffixes")[d.country.toLowerCase()];
      }, u.prototype.zip = function(d) {
        var m = this.n(this.natural, 5, { max: 9 });
        return d && d.plusfour === !0 && (m.push("-"), m = m.concat(this.n(this.natural, 4, { max: 9 }))), m.join("");
      }, u.prototype.ampm = function() {
        return this.bool() ? "am" : "pm";
      }, u.prototype.date = function(d) {
        var m, v;
        if (d && (d.min || d.max)) {
          d = f(d, {
            american: !0,
            string: !1
          });
          var k = typeof d.min < "u" ? d.min.getTime() : 1, O = typeof d.max < "u" ? d.max.getTime() : 864e13;
          v = new Date(this.integer({ min: k, max: O }));
        } else {
          var G = this.month({ raw: !0 }), H = G.days;
          d && d.month && (H = this.get("months")[(d.month % 12 + 12) % 12].days), d = f(d, {
            year: parseInt(this.year(), 10),
            // Necessary to subtract 1 because Date() 0-indexes month but not day or year
            // for some reason.
            month: G.numeric - 1,
            day: this.natural({ min: 1, max: H }),
            hour: this.hour({ twentyfour: !0 }),
            minute: this.minute(),
            second: this.second(),
            millisecond: this.millisecond(),
            american: !0,
            string: !1
          }), v = new Date(d.year, d.month, d.day, d.hour, d.minute, d.second, d.millisecond);
        }
        return d.american ? m = v.getMonth() + 1 + "/" + v.getDate() + "/" + v.getFullYear() : m = v.getDate() + "/" + (v.getMonth() + 1) + "/" + v.getFullYear(), d.string ? m : v;
      }, u.prototype.hammertime = function(d) {
        return this.date(d).getTime();
      }, u.prototype.hour = function(d) {
        return d = f(d, {
          min: d && d.twentyfour ? 0 : 1,
          max: d && d.twentyfour ? 23 : 12
        }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.twentyfour && d.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option."), p(!d.twentyfour && d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.millisecond = function() {
        return this.natural({ max: 999 });
      }, u.prototype.minute = u.prototype.second = function(d) {
        return d = f(d, { min: 0, max: 59 }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.max > 59, "Chance: Max cannot be greater than 59."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.month = function(d) {
        d = f(d, { min: 1, max: 12 }), p(d.min < 1, "Chance: Min cannot be less than 1."), p(d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = this.pick(this.months().slice(d.min - 1, d.max));
        return d.raw ? m : m.name;
      }, u.prototype.months = function() {
        return this.get("months");
      }, u.prototype.second = function() {
        return this.natural({ max: 59 });
      }, u.prototype.timestamp = function() {
        return this.natural({ min: 1, max: parseInt((/* @__PURE__ */ new Date()).getTime() / 1e3, 10) });
      }, u.prototype.weekday = function(d) {
        d = f(d, { weekday_only: !1 });
        var m = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        return d.weekday_only || (m.push("Saturday"), m.push("Sunday")), this.pickone(m);
      }, u.prototype.year = function(d) {
        return d = f(d, { min: (/* @__PURE__ */ new Date()).getFullYear() }), d.max = typeof d.max < "u" ? d.max : d.min + 100, this.natural(d).toString();
      }, u.prototype.cc = function(d) {
        d = f(d);
        var m, v, k;
        return m = d.type ? this.cc_type({ name: d.type, raw: !0 }) : this.cc_type({ raw: !0 }), v = m.prefix.split(""), k = m.length - m.prefix.length - 1, v = v.concat(this.n(this.integer, k, { min: 0, max: 9 })), v.push(this.luhn_calculate(v.join(""))), v.join("");
      }, u.prototype.cc_types = function() {
        return this.get("cc_types");
      }, u.prototype.cc_type = function(d) {
        d = f(d);
        var m = this.cc_types(), v = null;
        if (d.name) {
          for (var k = 0; k < m.length; k++)
            if (m[k].name === d.name || m[k].short_name === d.name) {
              v = m[k];
              break;
            }
          if (v === null)
            throw new RangeError("Chance: Credit card type '" + d.name + "' is not supported");
        } else
          v = this.pick(m);
        return d.raw ? v : v.name;
      }, u.prototype.currency_types = function() {
        return this.get("currency_types");
      }, u.prototype.currency = function() {
        return this.pick(this.currency_types());
      }, u.prototype.timezones = function() {
        return this.get("timezones");
      }, u.prototype.timezone = function() {
        return this.pick(this.timezones());
      }, u.prototype.currency_pair = function(d) {
        var m = this.unique(this.currency, 2, {
          comparator: function(v, k) {
            return v.reduce(function(O, G) {
              return O || G.code === k.code;
            }, !1);
          }
        });
        return d ? m[0].code + "/" + m[1].code : m;
      }, u.prototype.dollar = function(d) {
        d = f(d, { max: 1e4, min: 0 });
        var m = this.floating({ min: d.min, max: d.max, fixed: 2 }).toString(), v = m.split(".")[1];
        return v === void 0 ? m += ".00" : v.length < 2 && (m = m + "0"), m < 0 ? "-$" + m.replace("-", "") : "$" + m;
      }, u.prototype.euro = function(d) {
        return Number(this.dollar(d).replace("$", "")).toLocaleString() + "€";
      }, u.prototype.exp = function(d) {
        d = f(d);
        var m = {};
        return m.year = this.exp_year(), m.year === (/* @__PURE__ */ new Date()).getFullYear().toString() ? m.month = this.exp_month({ future: !0 }) : m.month = this.exp_month(), d.raw ? m : m.month + "/" + m.year;
      }, u.prototype.exp_month = function(d) {
        d = f(d);
        var m, v, k = (/* @__PURE__ */ new Date()).getMonth() + 1;
        if (d.future && k !== 12)
          do
            m = this.month({ raw: !0 }).numeric, v = parseInt(m, 10);
          while (v <= k);
        else
          m = this.month({ raw: !0 }).numeric;
        return m;
      }, u.prototype.exp_year = function() {
        var d = (/* @__PURE__ */ new Date()).getMonth() + 1, m = (/* @__PURE__ */ new Date()).getFullYear();
        return this.year({ min: d === 12 ? m + 1 : m, max: m + 10 });
      }, u.prototype.vat = function(d) {
        switch (d = f(d, { country: "it" }), d.country.toLowerCase()) {
          case "it":
            return this.it_vat();
        }
      }, u.prototype.iban = function() {
        var d = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", m = d + "0123456789", v = this.string({ length: 2, pool: d }) + this.pad(this.integer({ min: 0, max: 99 }), 2) + this.string({ length: 4, pool: m }) + this.pad(this.natural(), this.natural({ min: 6, max: 26 }));
        return v;
      }, u.prototype.it_vat = function() {
        var d = this.natural({ min: 1, max: 18e5 });
        return d = this.pad(d, 7) + this.pad(this.pick(this.provinces({ country: "it" })).code, 3), d + this.luhn_calculate(d);
      }, u.prototype.cf = function(d) {
        d = d || {};
        var m = d.gender ? d.gender : this.gender(), v = d.first ? d.first : this.first({ gender: m, nationality: "it" }), k = d.last ? d.last : this.last({ nationality: "it" }), O = d.birthday ? d.birthday : this.birthday(), G = d.city ? d.city : this.pickone(["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M", "Z"]) + this.pad(this.natural({ max: 999 }), 3), H = [], j = function(W, U) {
          var Z, V = [];
          return W.length < 3 ? V = W.split("").concat("XXX".split("")).splice(0, 3) : (Z = W.toUpperCase().split("").map(function(Y) {
            return "BCDFGHJKLMNPRSTVWZ".indexOf(Y) !== -1 ? Y : void 0;
          }).join(""), Z.length > 3 && (U ? Z = Z.substr(0, 3) : Z = Z[0] + Z.substr(2, 2)), Z.length < 3 && (V = Z, Z = W.toUpperCase().split("").map(function(Y) {
            return "AEIOU".indexOf(Y) !== -1 ? Y : void 0;
          }).join("").substr(0, 3 - V.length)), V = V + Z), V;
        }, F = function(W, U, Z) {
          var V = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];
          return W.getFullYear().toString().substr(2) + V[W.getMonth()] + Z.pad(W.getDate() + (U.toLowerCase() === "female" ? 40 : 0), 2);
        }, z = function(W) {
          for (var U = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", Z = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", V = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", Y = "BAKPLCQDREVOSFTGUHMINJWZYX", ge = 0, ce = 0; ce < 15; ce++)
            ce % 2 !== 0 ? ge += V.indexOf(Z[U.indexOf(W[ce])]) : ge += Y.indexOf(Z[U.indexOf(W[ce])]);
          return V[ge % 26];
        };
        return H = H.concat(j(k, !0), j(v), F(O, m, this), G.toUpperCase().split("")).join(""), H += z(H.toUpperCase()), H.toUpperCase();
      }, u.prototype.pl_pesel = function() {
        for (var d = this.natural({ min: 1, max: 9999999999 }), m = this.pad(d, 10).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (1 * m[0] + 3 * m[1] + 7 * m[2] + 9 * m[3] + 1 * m[4] + 3 * m[5] + 7 * m[6] + 9 * m[7] + 1 * m[8] + 3 * m[9]) % 10;
        return k !== 0 && (k = 10 - k), m.join("") + k;
      }, u.prototype.pl_nip = function() {
        for (var d = this.natural({ min: 1, max: 999999999 }), m = this.pad(d, 9).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (6 * m[0] + 5 * m[1] + 7 * m[2] + 2 * m[3] + 3 * m[4] + 4 * m[5] + 5 * m[6] + 6 * m[7] + 7 * m[8]) % 11;
        return k === 10 ? this.pl_nip() : m.join("") + k;
      }, u.prototype.pl_regon = function() {
        for (var d = this.natural({ min: 1, max: 99999999 }), m = this.pad(d, 8).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (8 * m[0] + 9 * m[1] + 2 * m[2] + 3 * m[3] + 4 * m[4] + 5 * m[5] + 6 * m[6] + 7 * m[7]) % 11;
        return k === 10 && (k = 0), m.join("") + k;
      }, u.prototype.music_genre = function(d = "general") {
        if (!(d.toLowerCase() in x.music_genres))
          throw new Error(`Unsupported genre: ${d}`);
        const m = x.music_genres[d.toLowerCase()], v = this.integer({ min: 0, max: m.length - 1 });
        return m[v];
      }, u.prototype.note = function(d) {
        d = f(d, { notes: "flatKey" });
        var m = {
          naturals: ["C", "D", "E", "F", "G", "A", "B"],
          flats: ["D♭", "E♭", "G♭", "A♭", "B♭"],
          sharps: ["C♯", "D♯", "F♯", "G♯", "A♯"]
        };
        return m.all = m.naturals.concat(m.flats.concat(m.sharps)), m.flatKey = m.naturals.concat(m.flats), m.sharpKey = m.naturals.concat(m.sharps), this.pickone(m[d.notes]);
      }, u.prototype.midi_note = function(d) {
        var m = 0, v = 127;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.chord_quality = function(d) {
        d = f(d, { jazz: !0 });
        var m = ["maj", "min", "aug", "dim"];
        return d.jazz && (m = [
          "maj7",
          "min7",
          "7",
          "sus",
          "dim",
          "ø"
        ]), this.pickone(m);
      }, u.prototype.chord = function(d) {
        return d = f(d), this.note(d) + this.chord_quality(d);
      }, u.prototype.tempo = function(d) {
        var m = 40, v = 320;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
      };
      function C(d) {
        return function() {
          return this.natural(d);
        };
      }
      u.prototype.d4 = C({ min: 1, max: 4 }), u.prototype.d6 = C({ min: 1, max: 6 }), u.prototype.d8 = C({ min: 1, max: 8 }), u.prototype.d10 = C({ min: 1, max: 10 }), u.prototype.d12 = C({ min: 1, max: 12 }), u.prototype.d20 = C({ min: 1, max: 20 }), u.prototype.d30 = C({ min: 1, max: 30 }), u.prototype.d100 = C({ min: 1, max: 100 }), u.prototype.rpg = function(d, m) {
        if (m = f(m), d) {
          var v = d.toLowerCase().split("d"), k = [];
          if (v.length !== 2 || !parseInt(v[0], 10) || !parseInt(v[1], 10))
            throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
          for (var O = v[0]; O > 0; O--)
            k[O - 1] = this.natural({ min: 1, max: v[1] });
          return typeof m.sum < "u" && m.sum ? k.reduce(function(G, H) {
            return G + H;
          }) : k;
        } else
          throw new RangeError("Chance: A type of die roll must be included");
      }, u.prototype.guid = function(d) {
        d = f(d, { version: 5 });
        var m = "abcdef1234567890", v = "ab89", k = this.string({ pool: m, length: 8 }) + "-" + this.string({ pool: m, length: 4 }) + "-" + // The Version
        d.version + this.string({ pool: m, length: 3 }) + "-" + // The Variant
        this.string({ pool: v, length: 1 }) + this.string({ pool: m, length: 3 }) + "-" + this.string({ pool: m, length: 12 });
        return k;
      }, u.prototype.hash = function(d) {
        d = f(d, { length: 40, casing: "lower" });
        var m = d.casing === "upper" ? s.toUpperCase() : s;
        return this.string({ pool: m, length: d.length });
      }, u.prototype.luhn_check = function(d) {
        var m = d.toString(), v = +m.substring(m.length - 1);
        return v === this.luhn_calculate(+m.substring(0, m.length - 1));
      }, u.prototype.luhn_calculate = function(d) {
        for (var m = d.toString().split("").reverse(), v = 0, k, O = 0, G = m.length; G > O; ++O)
          k = +m[O], O % 2 === 0 && (k *= 2, k > 9 && (k -= 9)), v += k;
        return v * 9 % 10;
      }, u.prototype.md5 = function(d) {
        var m = { str: "", key: null, raw: !1 };
        if (!d)
          m.str = this.string(), d = {};
        else if (typeof d == "string")
          m.str = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        if (m = f(d, m), !m.str)
          throw new Error("A parameter is required to return an md5 hash.");
        return this.bimd5.md5(m.str, m.key, m.raw);
      }, u.prototype.file = function(d) {
        var m = d || {}, v = "fileExtension", k = Object.keys(this.get("fileExtension")), O, G;
        if (O = this.word({ length: m.length }), m.extension)
          return G = m.extension, O + "." + G;
        if (m.extensions) {
          if (Array.isArray(m.extensions))
            return G = this.pickone(m.extensions), O + "." + G;
          if (m.extensions.constructor === Object) {
            var H = m.extensions, j = Object.keys(H);
            return G = this.pickone(H[this.pickone(j)]), O + "." + G;
          }
          throw new Error("Chance: Extensions must be an Array or Object");
        }
        if (m.fileType) {
          var F = m.fileType;
          if (k.indexOf(F) !== -1)
            return G = this.pickone(this.get(v)[F]), O + "." + G;
          throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        return G = this.pickone(this.get(v)[this.pickone(k)]), O + "." + G;
      }, u.prototype.fileWithContent = function(d) {
        var m = d || {}, v = "fileName" in m ? m.fileName : this.file().split(".")[0];
        if (v += "." + ("fileExtension" in m ? m.fileExtension : this.file().split(".")[1]), typeof m.fileSize != "number")
          throw new Error("File size must be an integer");
        var k = {
          fileData: this.buffer({ length: m.fileSize }),
          fileName: v
        };
        return k;
      };
      var x = {
        firstNames: {
          male: {
            en: ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
            it: ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Aaron", "Abel", "Adam", "Adriaan", "Albert", "Alexander", "Ali", "Arjen", "Arno", "Bart", "Bas", "Bastiaan", "Benjamin", "Bob", "Boris", "Bram", "Brent", "Cas", "Casper", "Chris", "Christiaan", "Cornelis", "Daan", "Daley", "Damian", "Dani", "Daniel", "Daniël", "David", "Dean", "Dirk", "Dylan", "Egbert", "Elijah", "Erik", "Erwin", "Evert", "Ezra", "Fabian", "Fedde", "Finn", "Florian", "Floris", "Frank", "Frans", "Frederik", "Freek", "Geert", "Gerard", "Gerben", "Gerrit", "Gijs", "Guus", "Hans", "Hendrik", "Henk", "Herman", "Hidde", "Hugo", "Jaap", "Jan Jaap", "Jan-Willem", "Jack", "Jacob", "Jan", "Jason", "Jasper", "Jayden", "Jelle", "Jelte", "Jens", "Jeroen", "Jesse", "Jim", "Job", "Joep", "Johannes", "John", "Jonathan", "Joris", "Joshua", "Joël", "Julian", "Kees", "Kevin", "Koen", "Lars", "Laurens", "Leendert", "Lennard", "Lodewijk", "Luc", "Luca", "Lucas", "Lukas", "Luuk", "Maarten", "Marcus", "Martijn", "Martin", "Matthijs", "Maurits", "Max", "Mees", "Melle", "Mick", "Mika", "Milan", "Mohamed", "Mohammed", "Morris", "Muhammed", "Nathan", "Nick", "Nico", "Niek", "Niels", "Noah", "Noud", "Olivier", "Oscar", "Owen", "Paul", "Pepijn", "Peter", "Pieter", "Pim", "Quinten", "Reinier", "Rens", "Robin", "Ruben", "Sam", "Samuel", "Sander", "Sebastiaan", "Sem", "Sep", "Sepp", "Siem", "Simon", "Stan", "Stef", "Steven", "Stijn", "Sven", "Teun", "Thijmen", "Thijs", "Thomas", "Tijn", "Tim", "Timo", "Tobias", "Tom", "Victor", "Vince", "Willem", "Wim", "Wouter", "Yusuf"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Aaron", "Abdon", "Abel", "Abélard", "Abelin", "Abondance", "Abraham", "Absalon", "Acace", "Achaire", "Achille", "Adalard", "Adalbald", "Adalbéron", "Adalbert", "Adalric", "Adam", "Adegrin", "Adel", "Adelin", "Andelin", "Adelphe", "Adam", "Adéodat", "Adhémar", "Adjutor", "Adolphe", "Adonis", "Adon", "Adrien", "Agapet", "Agathange", "Agathon", "Agilbert", "Agénor", "Agnan", "Aignan", "Agrippin", "Aimable", "Aimé", "Alain", "Alban", "Albin", "Aubin", "Albéric", "Albert", "Albertet", "Alcibiade", "Alcide", "Alcée", "Alcime", "Aldonce", "Aldric", "Aldéric", "Aleaume", "Alexandre", "Alexis", "Alix", "Alliaume", "Aleaume", "Almine", "Almire", "Aloïs", "Alphée", "Alphonse", "Alpinien", "Alverède", "Amalric", "Amaury", "Amandin", "Amant", "Ambroise", "Amédée", "Amélien", "Amiel", "Amour", "Anaël", "Anastase", "Anatole", "Ancelin", "Andéol", "Andoche", "André", "Andoche", "Ange", "Angelin", "Angilbe", "Anglebert", "Angoustan", "Anicet", "Anne", "Annibal", "Ansbert", "Anselme", "Anthelme", "Antheaume", "Anthime", "Antide", "Antoine", "Antonius", "Antonin", "Apollinaire", "Apollon", "Aquilin", "Arcade", "Archambaud", "Archambeau", "Archange", "Archibald", "Arian", "Ariel", "Ariste", "Aristide", "Armand", "Armel", "Armin", "Arnould", "Arnaud", "Arolde", "Arsène", "Arsinoé", "Arthaud", "Arthème", "Arthur", "Ascelin", "Athanase", "Aubry", "Audebert", "Audouin", "Audran", "Audric", "Auguste", "Augustin", "Aurèle", "Aurélien", "Aurian", "Auxence", "Axel", "Aymard", "Aymeric", "Aymon", "Aymond", "Balthazar", "Baptiste", "Barnabé", "Barthélemy", "Bartimée", "Basile", "Bastien", "Baudouin", "Bénigne", "Benjamin", "Benoît", "Bérenger", "Bérard", "Bernard", "Bertrand", "Blaise", "Bon", "Boniface", "Bouchard", "Brice", "Brieuc", "Bruno", "Brunon", "Calixte", "Calliste", "Camélien", "Camille", "Camillien", "Candide", "Caribert", "Carloman", "Cassandre", "Cassien", "Cédric", "Céleste", "Célestin", "Célien", "Césaire", "César", "Charles", "Charlemagne", "Childebert", "Chilpéric", "Chrétien", "Christian", "Christodule", "Christophe", "Chrysostome", "Clarence", "Claude", "Claudien", "Cléandre", "Clément", "Clotaire", "Côme", "Constance", "Constant", "Constantin", "Corentin", "Cyprien", "Cyriaque", "Cyrille", "Cyril", "Damien", "Daniel", "David", "Delphin", "Denis", "Désiré", "Didier", "Dieudonné", "Dimitri", "Dominique", "Dorian", "Dorothée", "Edgard", "Edmond", "Édouard", "Éleuthère", "Élie", "Élisée", "Émeric", "Émile", "Émilien", "Emmanuel", "Enguerrand", "Épiphane", "Éric", "Esprit", "Ernest", "Étienne", "Eubert", "Eudes", "Eudoxe", "Eugène", "Eusèbe", "Eustache", "Évariste", "Évrard", "Fabien", "Fabrice", "Falba", "Félicité", "Félix", "Ferdinand", "Fiacre", "Fidèle", "Firmin", "Flavien", "Flodoard", "Florent", "Florentin", "Florestan", "Florian", "Fortuné", "Foulques", "Francisque", "François", "Français", "Franciscus", "Francs", "Frédéric", "Fulbert", "Fulcran", "Fulgence", "Gabin", "Gabriel", "Gaël", "Garnier", "Gaston", "Gaspard", "Gatien", "Gaud", "Gautier", "Gédéon", "Geoffroy", "Georges", "Géraud", "Gérard", "Gerbert", "Germain", "Gervais", "Ghislain", "Gilbert", "Gilles", "Girart", "Gislebert", "Gondebaud", "Gonthier", "Gontran", "Gonzague", "Grégoire", "Guérin", "Gui", "Guillaume", "Gustave", "Guy", "Guyot", "Hardouin", "Hector", "Hédelin", "Hélier", "Henri", "Herbert", "Herluin", "Hervé", "Hilaire", "Hildebert", "Hincmar", "Hippolyte", "Honoré", "Hubert", "Hugues", "Innocent", "Isabeau", "Isidore", "Jacques", "Japhet", "Jason", "Jean", "Jeannel", "Jeannot", "Jérémie", "Jérôme", "Joachim", "Joanny", "Job", "Jocelyn", "Joël", "Johan", "Jonas", "Jonathan", "Joseph", "Josse", "Josselin", "Jourdain", "Jude", "Judicaël", "Jules", "Julien", "Juste", "Justin", "Lambert", "Landry", "Laurent", "Lazare", "Léandre", "Léon", "Léonard", "Léopold", "Leu", "Loup", "Leufroy", "Libère", "Liétald", "Lionel", "Loïc", "Longin", "Lorrain", "Lorraine", "Lothaire", "Louis", "Loup", "Luc", "Lucas", "Lucien", "Ludolphe", "Ludovic", "Macaire", "Malo", "Mamert", "Manassé", "Marc", "Marceau", "Marcel", "Marcelin", "Marius", "Marseille", "Martial", "Martin", "Mathurin", "Matthias", "Mathias", "Matthieu", "Maugis", "Maurice", "Mauricet", "Maxence", "Maxime", "Maximilien", "Mayeul", "Médéric", "Melchior", "Mence", "Merlin", "Mérovée", "Michaël", "Michel", "Moïse", "Morgan", "Nathan", "Nathanaël", "Narcisse", "Néhémie", "Nestor", "Nestor", "Nicéphore", "Nicolas", "Noé", "Noël", "Norbert", "Normand", "Normands", "Octave", "Odilon", "Odon", "Oger", "Olivier", "Oury", "Pacôme", "Palémon", "Parfait", "Pascal", "Paterne", "Patrice", "Paul", "Pépin", "Perceval", "Philémon", "Philibert", "Philippe", "Philothée", "Pie", "Pierre", "Pierrick", "Prosper", "Quentin", "Raoul", "Raphaël", "Raymond", "Régis", "Réjean", "Rémi", "Renaud", "René", "Reybaud", "Richard", "Robert", "Roch", "Rodolphe", "Rodrigue", "Roger", "Roland", "Romain", "Romuald", "Roméo", "Rome", "Ronan", "Roselin", "Salomon", "Samuel", "Savin", "Savinien", "Scholastique", "Sébastien", "Séraphin", "Serge", "Séverin", "Sidoine", "Sigebert", "Sigismond", "Silvère", "Simon", "Siméon", "Sixte", "Stanislas", "Stéphane", "Stephan", "Sylvain", "Sylvestre", "Tancrède", "Tanguy", "Taurin", "Théodore", "Théodose", "Théophile", "Théophraste", "Thibault", "Thibert", "Thierry", "Thomas", "Timoléon", "Timothée", "Titien", "Tonnin", "Toussaint", "Trajan", "Tristan", "Turold", "Tim", "Ulysse", "Urbain", "Valentin", "Valère", "Valéry", "Venance", "Venant", "Venceslas", "Vianney", "Victor", "Victorien", "Victorin", "Vigile", "Vincent", "Vital", "Vitalien", "Vivien", "Waleran", "Wandrille", "Xavier", "Xénophon", "Yves", "Zacharie", "Zaché", "Zéphirin"]
          },
          female: {
            en: ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
            it: ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Lea", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Ada", "Arianne", "Afke", "Amanda", "Amber", "Amy", "Aniek", "Anita", "Anja", "Anna", "Anne", "Annelies", "Annemarie", "Annette", "Anouk", "Astrid", "Aukje", "Barbara", "Bianca", "Carla", "Carlijn", "Carolien", "Chantal", "Charlotte", "Claudia", "Daniëlle", "Debora", "Diane", "Dora", "Eline", "Elise", "Ella", "Ellen", "Emma", "Esmee", "Evelien", "Esther", "Erica", "Eva", "Femke", "Fleur", "Floor", "Froukje", "Gea", "Gerda", "Hanna", "Hanneke", "Heleen", "Hilde", "Ilona", "Ina", "Inge", "Ingrid", "Iris", "Isabel", "Isabelle", "Janneke", "Jasmijn", "Jeanine", "Jennifer", "Jessica", "Johanna", "Joke", "Julia", "Julie", "Karen", "Karin", "Katja", "Kim", "Lara", "Laura", "Lena", "Lianne", "Lieke", "Lilian", "Linda", "Lisa", "Lisanne", "Lotte", "Louise", "Maaike", "Manon", "Marga", "Maria", "Marissa", "Marit", "Marjolein", "Martine", "Marleen", "Melissa", "Merel", "Miranda", "Michelle", "Mirjam", "Mirthe", "Naomi", "Natalie", "Nienke", "Nina", "Noortje", "Olivia", "Patricia", "Paula", "Paulien", "Ramona", "Ria", "Rianne", "Roos", "Rosanne", "Ruth", "Sabrina", "Sandra", "Sanne", "Sara", "Saskia", "Silvia", "Sofia", "Sophie", "Sonja", "Suzanne", "Tamara", "Tess", "Tessa", "Tineke", "Valerie", "Vanessa", "Veerle", "Vera", "Victoria", "Wendy", "Willeke", "Yvonne", "Zoë"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Abdon", "Abel", "Abigaëlle", "Abigaïl", "Acacius", "Acanthe", "Adalbert", "Adalsinde", "Adegrine", "Adélaïde", "Adèle", "Adélie", "Adeline", "Adeltrude", "Adolphe", "Adonis", "Adrastée", "Adrehilde", "Adrienne", "Agathe", "Agilbert", "Aglaé", "Aignan", "Agneflète", "Agnès", "Agrippine", "Aimé", "Alaine", "Alaïs", "Albane", "Albérade", "Alberte", "Alcide", "Alcine", "Alcyone", "Aldegonde", "Aleth", "Alexandrine", "Alexine", "Alice", "Aliénor", "Aliette", "Aline", "Alix", "Alizé", "Aloïse", "Aloyse", "Alphonsine", "Althée", "Amaliane", "Amalthée", "Amande", "Amandine", "Amant", "Amarande", "Amaranthe", "Amaryllis", "Ambre", "Ambroisie", "Amélie", "Améthyste", "Aminte", "Anaël", "Anaïs", "Anastasie", "Anatole", "Ancelin", "Andrée", "Anémone", "Angadrême", "Angèle", "Angeline", "Angélique", "Angilbert", "Anicet", "Annabelle", "Anne", "Annette", "Annick", "Annie", "Annonciade", "Ansbert", "Anstrudie", "Anthelme", "Antigone", "Antoinette", "Antonine", "Aphélie", "Apolline", "Apollonie", "Aquiline", "Arabelle", "Arcadie", "Archange", "Argine", "Ariane", "Aricie", "Ariel", "Arielle", "Arlette", "Armance", "Armande", "Armandine", "Armelle", "Armide", "Armelle", "Armin", "Arnaud", "Arsène", "Arsinoé", "Artémis", "Arthur", "Ascelin", "Ascension", "Assomption", "Astarté", "Astérie", "Astrée", "Astrid", "Athalie", "Athanasie", "Athina", "Aube", "Albert", "Aude", "Audrey", "Augustine", "Aure", "Aurélie", "Aurélien", "Aurèle", "Aurore", "Auxence", "Aveline", "Abigaëlle", "Avoye", "Axelle", "Aymard", "Azalée", "Adèle", "Adeline", "Barbe", "Basilisse", "Bathilde", "Béatrice", "Béatrix", "Bénédicte", "Bérengère", "Bernadette", "Berthe", "Bertille", "Beuve", "Blanche", "Blanc", "Blandine", "Brigitte", "Brune", "Brunehilde", "Callista", "Camille", "Capucine", "Carine", "Caroline", "Cassandre", "Catherine", "Cécile", "Céleste", "Célestine", "Céline", "Chantal", "Charlène", "Charline", "Charlotte", "Chloé", "Christelle", "Christiane", "Christine", "Claire", "Clara", "Claude", "Claudine", "Clarisse", "Clémence", "Clémentine", "Cléo", "Clio", "Clotilde", "Coline", "Conception", "Constance", "Coralie", "Coraline", "Corentine", "Corinne", "Cyrielle", "Daniel", "Daniel", "Daphné", "Débora", "Delphine", "Denise", "Diane", "Dieudonné", "Dominique", "Doriane", "Dorothée", "Douce", "Édith", "Edmée", "Éléonore", "Éliane", "Élia", "Éliette", "Élisabeth", "Élise", "Ella", "Élodie", "Éloïse", "Elsa", "Émeline", "Émérance", "Émérentienne", "Émérencie", "Émilie", "Emma", "Emmanuelle", "Emmelie", "Ernestine", "Esther", "Estelle", "Eudoxie", "Eugénie", "Eulalie", "Euphrasie", "Eusébie", "Évangéline", "Eva", "Ève", "Évelyne", "Fanny", "Fantine", "Faustine", "Félicie", "Fernande", "Flavie", "Fleur", "Flore", "Florence", "Florie", "Fortuné", "France", "Francia", "Françoise", "Francine", "Gabrielle", "Gaëlle", "Garance", "Geneviève", "Georgette", "Gerberge", "Germaine", "Gertrude", "Gisèle", "Guenièvre", "Guilhemine", "Guillemette", "Gustave", "Gwenael", "Hélène", "Héloïse", "Henriette", "Hermine", "Hermione", "Hippolyte", "Honorine", "Hortense", "Huguette", "Ines", "Irène", "Irina", "Iris", "Isabeau", "Isabelle", "Iseult", "Isolde", "Ismérie", "Jacinthe", "Jacqueline", "Jade", "Janine", "Jeanne", "Jocelyne", "Joëlle", "Joséphine", "Judith", "Julia", "Julie", "Jules", "Juliette", "Justine", "Katy", "Kathy", "Katie", "Laura", "Laure", "Laureline", "Laurence", "Laurene", "Lauriane", "Laurianne", "Laurine", "Léa", "Léna", "Léonie", "Léon", "Léontine", "Lorraine", "Lucie", "Lucienne", "Lucille", "Ludivine", "Lydie", "Lydie", "Megane", "Madeleine", "Magali", "Maguelone", "Mallaury", "Manon", "Marceline", "Margot", "Marguerite", "Marianne", "Marie", "Myriam", "Marie", "Marine", "Marion", "Marlène", "Marthe", "Martine", "Mathilde", "Maud", "Maureen", "Mauricette", "Maxime", "Mélanie", "Melissa", "Mélissandre", "Mélisande", "Mélodie", "Michel", "Micheline", "Mireille", "Miriam", "Moïse", "Monique", "Morgane", "Muriel", "Mylène", "Nadège", "Nadine", "Nathalie", "Nicole", "Nicolette", "Nine", "Noël", "Noémie", "Océane", "Odette", "Odile", "Olive", "Olivia", "Olympe", "Ombline", "Ombeline", "Ophélie", "Oriande", "Oriane", "Ozanne", "Pascale", "Pascaline", "Paule", "Paulette", "Pauline", "Priscille", "Prisca", "Prisque", "Pécine", "Pélagie", "Pénélope", "Perrine", "Pétronille", "Philippine", "Philomène", "Philothée", "Primerose", "Prudence", "Pulchérie", "Quentine", "Quiéta", "Quintia", "Quintilla", "Rachel", "Raphaëlle", "Raymonde", "Rebecca", "Régine", "Réjeanne", "René", "Rita", "Rita", "Rolande", "Romane", "Rosalie", "Rose", "Roseline", "Sabine", "Salomé", "Sandra", "Sandrine", "Sarah", "Ségolène", "Séverine", "Sibylle", "Simone", "Sixt", "Solange", "Soline", "Solène", "Sophie", "Stéphanie", "Suzanne", "Sylvain", "Sylvie", "Tatiana", "Thaïs", "Théodora", "Thérèse", "Tiphaine", "Ursule", "Valentine", "Valérie", "Véronique", "Victoire", "Victorine", "Vinciane", "Violette", "Virginie", "Viviane", "Xavière", "Yolande", "Ysaline", "Yvette", "Yvonne", "Zélie", "Zita", "Zoé"]
          }
        },
        lastNames: {
          en: ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes", "Myers", "Ford", "Hamilton", "Graham", "Sullivan", "Wallace", "Woods", "Cole", "West", "Jordan", "Owens", "Reynolds", "Fisher", "Ellis", "Harrison", "Gibson", "McDonald", "Cruz", "Marshall", "Ortiz", "Gomez", "Murray", "Freeman", "Wells", "Webb", "Simpson", "Stevens", "Tucker", "Porter", "Hunter", "Hicks", "Crawford", "Henry", "Boyd", "Mason", "Morales", "Kennedy", "Warren", "Dixon", "Ramos", "Reyes", "Burns", "Gordon", "Shaw", "Holmes", "Rice", "Robertson", "Hunt", "Black", "Daniels", "Palmer", "Mills", "Nichols", "Grant", "Knight", "Ferguson", "Rose", "Stone", "Hawkins", "Dunn", "Perkins", "Hudson", "Spencer", "Gardner", "Stephens", "Payne", "Pierce", "Berry", "Matthews", "Arnold", "Wagner", "Willis", "Ray", "Watkins", "Olson", "Carroll", "Duncan", "Snyder", "Hart", "Cunningham", "Bradley", "Lane", "Andrews", "Ruiz", "Harper", "Fox", "Riley", "Armstrong", "Carpenter", "Weaver", "Greene", "Lawrence", "Elliott", "Chavez", "Sims", "Austin", "Peters", "Kelley", "Franklin", "Lawson", "Fields", "Gutierrez", "Ryan", "Schmidt", "Carr", "Vasquez", "Castillo", "Wheeler", "Chapman", "Oliver", "Montgomery", "Richards", "Williamson", "Johnston", "Banks", "Meyer", "Bishop", "McCoy", "Howell", "Alvarez", "Morrison", "Hansen", "Fernandez", "Garza", "Harvey", "Little", "Burton", "Stanley", "Nguyen", "George", "Jacobs", "Reid", "Kim", "Fuller", "Lynch", "Dean", "Gilbert", "Garrett", "Romero", "Welch", "Larson", "Frazier", "Burke", "Hanson", "Day", "Mendoza", "Moreno", "Bowman", "Medina", "Fowler", "Brewer", "Hoffman", "Carlson", "Silva", "Pearson", "Holland", "Douglas", "Fleming", "Jensen", "Vargas", "Byrd", "Davidson", "Hopkins", "May", "Terry", "Herrera", "Wade", "Soto", "Walters", "Curtis", "Neal", "Caldwell", "Lowe", "Jennings", "Barnett", "Graves", "Jimenez", "Horton", "Shelton", "Barrett", "Obrien", "Castro", "Sutton", "Gregory", "McKinney", "Lucas", "Miles", "Craig", "Rodriquez", "Chambers", "Holt", "Lambert", "Fletcher", "Watts", "Bates", "Hale", "Rhodes", "Pena", "Beck", "Newman", "Haynes", "McDaniel", "Mendez", "Bush", "Vaughn", "Parks", "Dawson", "Santiago", "Norris", "Hardy", "Love", "Steele", "Curry", "Powers", "Schultz", "Barker", "Guzman", "Page", "Munoz", "Ball", "Keller", "Chandler", "Weber", "Leonard", "Walsh", "Lyons", "Ramsey", "Wolfe", "Schneider", "Mullins", "Benson", "Sharp", "Bowen", "Daniel", "Barber", "Cummings", "Hines", "Baldwin", "Griffith", "Valdez", "Hubbard", "Salazar", "Reeves", "Warner", "Stevenson", "Burgess", "Santos", "Tate", "Cross", "Garner", "Mann", "Mack", "Moss", "Thornton", "Dennis", "McGee", "Farmer", "Delgado", "Aguilar", "Vega", "Glover", "Manning", "Cohen", "Harmon", "Rodgers", "Robbins", "Newton", "Todd", "Blair", "Higgins", "Ingram", "Reese", "Cannon", "Strickland", "Townsend", "Potter", "Goodwin", "Walton", "Rowe", "Hampton", "Ortega", "Patton", "Swanson", "Joseph", "Francis", "Goodman", "Maldonado", "Yates", "Becker", "Erickson", "Hodges", "Rios", "Conner", "Adkins", "Webster", "Norman", "Malone", "Hammond", "Flowers", "Cobb", "Moody", "Quinn", "Blake", "Maxwell", "Pope", "Floyd", "Osborne", "Paul", "McCarthy", "Guerrero", "Lindsey", "Estrada", "Sandoval", "Gibbs", "Tyler", "Gross", "Fitzgerald", "Stokes", "Doyle", "Sherman", "Saunders", "Wise", "Colon", "Gill", "Alvarado", "Greer", "Padilla", "Simon", "Waters", "Nunez", "Ballard", "Schwartz", "McBride", "Houston", "Christensen", "Klein", "Pratt", "Briggs", "Parsons", "McLaughlin", "Zimmerman", "French", "Buchanan", "Moran", "Copeland", "Roy", "Pittman", "Brady", "McCormick", "Holloway", "Brock", "Poole", "Frank", "Logan", "Owen", "Bass", "Marsh", "Drake", "Wong", "Jefferson", "Park", "Morton", "Abbott", "Sparks", "Patrick", "Norton", "Huff", "Clayton", "Massey", "Lloyd", "Figueroa", "Carson", "Bowers", "Roberson", "Barton", "Tran", "Lamb", "Harrington", "Casey", "Boone", "Cortez", "Clarke", "Mathis", "Singleton", "Wilkins", "Cain", "Bryan", "Underwood", "Hogan", "McKenzie", "Collier", "Luna", "Phelps", "McGuire", "Allison", "Bridges", "Wilkerson", "Nash", "Summers", "Atkins"],
          // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
          it: ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"],
          // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
          nl: ["Albers", "Alblas", "Appelman", "Baars", "Baas", "Bakker", "Blank", "Bleeker", "Blok", "Blom", "Boer", "Boers", "Boldewijn", "Boon", "Boot", "Bos", "Bosch", "Bosma", "Bosman", "Bouma", "Bouman", "Bouwman", "Brands", "Brouwer", "Burger", "Buijs", "Buitenhuis", "Ceder", "Cohen", "Dekker", "Dekkers", "Dijkman", "Dijkstra", "Driessen", "Drost", "Engel", "Evers", "Faber", "Franke", "Gerritsen", "Goedhart", "Goossens", "Groen", "Groenenberg", "Groot", "Haan", "Hart", "Heemskerk", "Hendriks", "Hermans", "Hoekstra", "Hofman", "Hopman", "Huisman", "Jacobs", "Jansen", "Janssen", "Jonker", "Jaspers", "Keijzer", "Klaassen", "Klein", "Koek", "Koenders", "Kok", "Kool", "Koopman", "Koopmans", "Koning", "Koster", "Kramer", "Kroon", "Kuijpers", "Kuiper", "Kuipers", "Kurt", "Koster", "Kwakman", "Los", "Lubbers", "Maas", "Markus", "Martens", "Meijer", "Mol", "Molenaar", "Mulder", "Nieuwenhuis", "Peeters", "Peters", "Pengel", "Pieters", "Pool", "Post", "Postma", "Prins", "Pronk", "Reijnders", "Rietveld", "Roest", "Roos", "Sanders", "Schaap", "Scheffer", "Schenk", "Schilder", "Schipper", "Schmidt", "Scholten", "Schouten", "Schut", "Schutte", "Schuurman", "Simons", "Smeets", "Smit", "Smits", "Snel", "Swinkels", "Tas", "Terpstra", "Timmermans", "Tol", "Tromp", "Troost", "Valk", "Veenstra", "Veldkamp", "Verbeek", "Verheul", "Verhoeven", "Vermeer", "Vermeulen", "Verweij", "Vink", "Visser", "Voorn", "Vos", "Wagenaar", "Wiersema", "Willems", "Willemsen", "Witteveen", "Wolff", "Wolters", "Zijlstra", "Zwart", "de Beer", "de Boer", "de Bruijn", "de Bruin", "de Graaf", "de Groot", "de Haan", "de Haas", "de Jager", "de Jong", "de Jonge", "de Koning", "de Lange", "de Leeuw", "de Ridder", "de Rooij", "de Ruiter", "de Vos", "de Vries", "de Waal", "de Wit", "de Zwart", "van Beek", "van Boven", "van Dam", "van Dijk", "van Dongen", "van Doorn", "van Egmond", "van Eijk", "van Es", "van Gelder", "van Gelderen", "van Houten", "van Hulst", "van Kempen", "van Kesteren", "van Leeuwen", "van Loon", "van Mill", "van Noord", "van Ommen", "van Ommeren", "van Oosten", "van Oostveen", "van Rijn", "van Schaik", "van Veen", "van Vliet", "van Wijk", "van Wijngaarden", "van den Poel", "van de Pol", "van den Ploeg", "van de Ven", "van den Berg", "van den Bosch", "van den Brink", "van den Broek", "van den Heuvel", "van der Heijden", "van der Horst", "van der Hulst", "van der Kroon", "van der Laan", "van der Linden", "van der Meer", "van der Meij", "van der Meulen", "van der Molen", "van der Sluis", "van der Spek", "van der Veen", "van der Velde", "van der Velden", "van der Vliet", "van der Wal"],
          // https://surnames.behindthename.com/top/lists/england-wales/1991
          uk: ["Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans", "Wilson", "Thomas", "Johnson", "Roberts", "Robinson", "Thompson", "Wright", "Walker", "White", "Edwards", "Hughes", "Green", "Hall", "Lewis", "Harris", "Clarke", "Patel", "Jackson", "Wood", "Turner", "Martin", "Cooper", "Hill", "Ward", "Morris", "Moore", "Clark", "Lee", "King", "Baker", "Harrison", "Morgan", "Allen", "James", "Scott", "Phillips", "Watson", "Davis", "Parker", "Price", "Bennett", "Young", "Griffiths", "Mitchell", "Kelly", "Cook", "Carter", "Richardson", "Bailey", "Collins", "Bell", "Shaw", "Murphy", "Miller", "Cox", "Richards", "Khan", "Marshall", "Anderson", "Simpson", "Ellis", "Adams", "Singh", "Begum", "Wilkinson", "Foster", "Chapman", "Powell", "Webb", "Rogers", "Gray", "Mason", "Ali", "Hunt", "Hussain", "Campbell", "Matthews", "Owen", "Palmer", "Holmes", "Mills", "Barnes", "Knight", "Lloyd", "Butler", "Russell", "Barker", "Fisher", "Stevens", "Jenkins", "Murray", "Dixon", "Harvey", "Graham", "Pearson", "Ahmed", "Fletcher", "Walsh", "Kaur", "Gibson", "Howard", "Andrews", "Stewart", "Elliott", "Reynolds", "Saunders", "Payne", "Fox", "Ford", "Pearce", "Day", "Brooks", "West", "Lawrence", "Cole", "Atkinson", "Bradley", "Spencer", "Gill", "Dawson", "Ball", "Burton", "O'brien", "Watts", "Rose", "Booth", "Perry", "Ryan", "Grant", "Wells", "Armstrong", "Francis", "Rees", "Hayes", "Hart", "Hudson", "Newman", "Barrett", "Webster", "Hunter", "Gregory", "Carr", "Lowe", "Page", "Marsh", "Riley", "Dunn", "Woods", "Parsons", "Berry", "Stone", "Reid", "Holland", "Hawkins", "Harding", "Porter", "Robertson", "Newton", "Oliver", "Reed", "Kennedy", "Williamson", "Bird", "Gardner", "Shah", "Dean", "Lane", "Cooke", "Bates", "Henderson", "Parry", "Burgess", "Bishop", "Walton", "Burns", "Nicholson", "Shepherd", "Ross", "Cross", "Long", "Freeman", "Warren", "Nicholls", "Hamilton", "Byrne", "Sutton", "Mcdonald", "Yates", "Hodgson", "Robson", "Curtis", "Hopkins", "O'connor", "Harper", "Coleman", "Watkins", "Moss", "Mccarthy", "Chambers", "O'neill", "Griffin", "Sharp", "Hardy", "Wheeler", "Potter", "Osborne", "Johnston", "Gordon", "Doyle", "Wallace", "George", "Jordan", "Hutchinson", "Rowe", "Burke", "May", "Pritchard", "Gilbert", "Willis", "Higgins", "Read", "Miles", "Stevenson", "Stephenson", "Hammond", "Arnold", "Buckley", "Walters", "Hewitt", "Barber", "Nelson", "Slater", "Austin", "Sullivan", "Whitehead", "Mann", "Frost", "Lambert", "Stephens", "Blake", "Akhtar", "Lynch", "Goodwin", "Barton", "Woodward", "Thomson", "Cunningham", "Quinn", "Barnett", "Baxter", "Bibi", "Clayton", "Nash", "Greenwood", "Jennings", "Holt", "Kemp", "Poole", "Gallagher", "Bond", "Stokes", "Tucker", "Davidson", "Fowler", "Heath", "Norman", "Middleton", "Lawson", "Banks", "French", "Stanley", "Jarvis", "Gibbs", "Ferguson", "Hayward", "Carroll", "Douglas", "Dickinson", "Todd", "Barlow", "Peters", "Lucas", "Knowles", "Hartley", "Miah", "Simmons", "Morton", "Alexander", "Field", "Morrison", "Norris", "Townsend", "Preston", "Hancock", "Thornton", "Baldwin", "Burrows", "Briggs", "Parkinson", "Reeves", "Macdonald", "Lamb", "Black", "Abbott", "Sanders", "Thorpe", "Holden", "Tomlinson", "Perkins", "Ashton", "Rhodes", "Fuller", "Howe", "Bryant", "Vaughan", "Dale", "Davey", "Weston", "Bartlett", "Whittaker", "Davison", "Kent", "Skinner", "Birch", "Morley", "Daniels", "Glover", "Howell", "Cartwright", "Pugh", "Humphreys", "Goddard", "Brennan", "Wall", "Kirby", "Bowen", "Savage", "Bull", "Wong", "Dobson", "Smart", "Wilkins", "Kirk", "Fraser", "Duffy", "Hicks", "Patterson", "Bradshaw", "Little", "Archer", "Warner", "Waters", "O'sullivan", "Farrell", "Brookes", "Atkins", "Kay", "Dodd", "Bentley", "Flynn", "John", "Schofield", "Short", "Haynes", "Wade", "Butcher", "Henry", "Sanderson", "Crawford", "Sheppard", "Bolton", "Coates", "Giles", "Gould", "Houghton", "Gibbons", "Pratt", "Manning", "Law", "Hooper", "Noble", "Dyer", "Rahman", "Clements", "Moran", "Sykes", "Chan", "Doherty", "Connolly", "Joyce", "Franklin", "Hobbs", "Coles", "Herbert", "Steele", "Kerr", "Leach", "Winter", "Owens", "Duncan", "Naylor", "Fleming", "Horton", "Finch", "Fitzgerald", "Randall", "Carpenter", "Marsden", "Browne", "Garner", "Pickering", "Hale", "Dennis", "Vincent", "Chadwick", "Chandler", "Sharpe", "Nolan", "Lyons", "Hurst", "Collier", "Peacock", "Howarth", "Faulkner", "Rice", "Pollard", "Welch", "Norton", "Gough", "Sinclair", "Blackburn", "Bryan", "Conway", "Power", "Cameron", "Daly", "Allan", "Hanson", "Gardiner", "Boyle", "Myers", "Turnbull", "Wallis", "Mahmood", "Sims", "Swift", "Iqbal", "Pope", "Brady", "Chamberlain", "Rowley", "Tyler", "Farmer", "Metcalfe", "Hilton", "Godfrey", "Holloway", "Parkin", "Bray", "Talbot", "Donnelly", "Nixon", "Charlton", "Benson", "Whitehouse", "Barry", "Hope", "Lord", "North", "Storey", "Connor", "Potts", "Bevan", "Hargreaves", "Mclean", "Mistry", "Bruce", "Howells", "Hyde", "Parkes", "Wyatt", "Fry", "Lees", "O'donnell", "Craig", "Forster", "Mckenzie", "Humphries", "Mellor", "Carey", "Ingram", "Summers", "Leonard"],
          // https://surnames.behindthename.com/top/lists/germany/2017
          de: ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann", "Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", "Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler", "Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Pfeiffer"],
          // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
          jp: ["Sato", "Suzuki", "Takahashi", "Tanaka", "Watanabe", "Ito", "Yamamoto", "Nakamura", "Kobayashi", "Kato", "Yoshida", "Yamada", "Sasaki", "Yamaguchi", "Saito", "Matsumoto", "Inoue", "Kimura", "Hayashi", "Shimizu", "Yamazaki", "Mori", "Abe", "Ikeda", "Hashimoto", "Yamashita", "Ishikawa", "Nakajima", "Maeda", "Fujita", "Ogawa", "Goto", "Okada", "Hasegawa", "Murakami", "Kondo", "Ishii", "Saito", "Sakamoto", "Endo", "Aoki", "Fujii", "Nishimura", "Fukuda", "Ota", "Miura", "Fujiwara", "Okamoto", "Matsuda", "Nakagawa", "Nakano", "Harada", "Ono", "Tamura", "Takeuchi", "Kaneko", "Wada", "Nakayama", "Ishida", "Ueda", "Morita", "Hara", "Shibata", "Sakai", "Kudo", "Yokoyama", "Miyazaki", "Miyamoto", "Uchida", "Takagi", "Ando", "Taniguchi", "Ohno", "Maruyama", "Imai", "Takada", "Fujimoto", "Takeda", "Murata", "Ueno", "Sugiyama", "Masuda", "Sugawara", "Hirano", "Kojima", "Otsuka", "Chiba", "Kubo", "Matsui", "Iwasaki", "Sakurai", "Kinoshita", "Noguchi", "Matsuo", "Nomura", "Kikuchi", "Sano", "Onishi", "Sugimoto", "Arai"],
          // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
          es: ["Garcia", "Fernandez", "Lopez", "Martinez", "Gonzalez", "Rodriguez", "Sanchez", "Perez", "Martin", "Gomez", "Ruiz", "Diaz", "Hernandez", "Alvarez", "Jimenez", "Moreno", "Munoz", "Alonso", "Romero", "Navarro", "Gutierrez", "Torres", "Dominguez", "Gil", "Vazquez", "Blanco", "Serrano", "Ramos", "Castro", "Suarez", "Sanz", "Rubio", "Ortega", "Molina", "Delgado", "Ortiz", "Morales", "Ramirez", "Marin", "Iglesias", "Santos", "Castillo", "Garrido", "Calvo", "Pena", "Cruz", "Cano", "Nunez", "Prieto", "Diez", "Lozano", "Vidal", "Pascual", "Ferrer", "Medina", "Vega", "Leon", "Herrero", "Vicente", "Mendez", "Guerrero", "Fuentes", "Campos", "Nieto", "Cortes", "Caballero", "Ibanez", "Lorenzo", "Pastor", "Gimenez", "Saez", "Soler", "Marquez", "Carrasco", "Herrera", "Montero", "Arias", "Crespo", "Flores", "Andres", "Aguilar", "Hidalgo", "Cabrera", "Mora", "Duran", "Velasco", "Rey", "Pardo", "Roman", "Vila", "Bravo", "Merino", "Moya", "Soto", "Izquierdo", "Reyes", "Redondo", "Marcos", "Carmona", "Menendez"],
          // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
          fr: ["Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefèvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard", "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Müller", "Lefèvre", "Faure", "André", "Mercier", "Blanc", "Guérin", "Boyer", "Garnier", "Chevalier", "François", "Legrand", "Gauthier", "Garcia", "Perrin", "Robin", "Clément", "Morin", "Nicolas", "Henry", "Roussel", "Matthieu", "Gautier", "Masson", "Marchand", "Duval", "Denis", "Dumont", "Marie", "Lemaire", "Noël", "Meyer", "Dufour", "Meunier", "Brun", "Blanchard", "Giraud", "Joly", "Rivière", "Lucas", "Brunet", "Gaillard", "Barbier", "Arnaud", "Martínez", "Gérard", "Roche", "Renard", "Schmitt", "Roy", "Leroux", "Colin", "Vidal", "Caron", "Picard", "Roger", "Fabre", "Aubert", "Lemoine", "Renaud", "Dumas", "Lacroix", "Olivier", "Philippe", "Bourgeois", "Pierre", "Benoît", "Rey", "Leclerc", "Payet", "Rolland", "Leclercq", "Guillaume", "Lecomte", "López", "Jean", "Dupuy", "Guillot", "Hubert", "Berger", "Carpentier", "Sánchez", "Dupuis", "Moulin", "Louis", "Deschamps", "Huet", "Vasseur", "Perez", "Boucher", "Fleury", "Royer", "Klein", "Jacquet", "Adam", "Paris", "Poirier", "Marty", "Aubry", "Guyot", "Carré", "Charles", "Renault", "Charpentier", "Ménard", "Maillard", "Baron", "Bertin", "Bailly", "Hervé", "Schneider", "Fernández", "Le GallGall", "Collet", "Léger", "Bouvier", "Julien", "Prévost", "Millet", "Perrot", "Daniel", "Le RouxRoux", "Cousin", "Germain", "Breton", "Besson", "Langlois", "Rémi", "Le GoffGoff", "Pelletier", "Lévêque", "Perrier", "Leblanc", "Barré", "Lebrun", "Marchal", "Weber", "Mallet", "Hamon", "Boulanger", "Jacob", "Monnier", "Michaud", "Rodríguez", "Guichard", "Gillet", "Étienne", "Grondin", "Poulain", "Tessier", "Chevallier", "Collin", "Chauvin", "Da SilvaSilva", "Bouchet", "Gay", "Lemaître", "Bénard", "Maréchal", "Humbert", "Reynaud", "Antoine", "Hoarau", "Perret", "Barthélemy", "Cordier", "Pichon", "Lejeune", "Gilbert", "Lamy", "Delaunay", "Pasquier", "Carlier", "LaporteLaporte"]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [{ code: "AB" }, { code: "AL" }, { code: "B" }, { code: "BA" }, { code: "BB" }, { code: "BD" }, { code: "BH" }, { code: "BL" }, { code: "BN" }, { code: "BR" }, { code: "BS" }, { code: "BT" }, { code: "CA" }, { code: "CB" }, { code: "CF" }, { code: "CH" }, { code: "CM" }, { code: "CO" }, { code: "CR" }, { code: "CT" }, { code: "CV" }, { code: "CW" }, { code: "DA" }, { code: "DD" }, { code: "DE" }, { code: "DG" }, { code: "DH" }, { code: "DL" }, { code: "DN" }, { code: "DT" }, { code: "DY" }, { code: "E" }, { code: "EC" }, { code: "EH" }, { code: "EN" }, { code: "EX" }, { code: "FK" }, { code: "FY" }, { code: "G" }, { code: "GL" }, { code: "GU" }, { code: "GY" }, { code: "HA" }, { code: "HD" }, { code: "HG" }, { code: "HP" }, { code: "HR" }, { code: "HS" }, { code: "HU" }, { code: "HX" }, { code: "IG" }, { code: "IM" }, { code: "IP" }, { code: "IV" }, { code: "JE" }, { code: "KA" }, { code: "KT" }, { code: "KW" }, { code: "KY" }, { code: "L" }, { code: "LA" }, { code: "LD" }, { code: "LE" }, { code: "LL" }, { code: "LN" }, { code: "LS" }, { code: "LU" }, { code: "M" }, { code: "ME" }, { code: "MK" }, { code: "ML" }, { code: "N" }, { code: "NE" }, { code: "NG" }, { code: "NN" }, { code: "NP" }, { code: "NR" }, { code: "NW" }, { code: "OL" }, { code: "OX" }, { code: "PA" }, { code: "PE" }, { code: "PH" }, { code: "PL" }, { code: "PO" }, { code: "PR" }, { code: "RG" }, { code: "RH" }, { code: "RM" }, { code: "S" }, { code: "SA" }, { code: "SE" }, { code: "SG" }, { code: "SK" }, { code: "SL" }, { code: "SM" }, { code: "SN" }, { code: "SO" }, { code: "SP" }, { code: "SR" }, { code: "SS" }, { code: "ST" }, { code: "SW" }, { code: "SY" }, { code: "TA" }, { code: "TD" }, { code: "TF" }, { code: "TN" }, { code: "TQ" }, { code: "TR" }, { code: "TS" }, { code: "TW" }, { code: "UB" }, { code: "W" }, { code: "WA" }, { code: "WC" }, { code: "WD" }, { code: "WF" }, { code: "WN" }, { code: "WR" }, { code: "WS" }, { code: "WV" }, { code: "YO" }, { code: "ZE" }],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [{ name: "Afghanistan", abbreviation: "AF" }, { name: "Åland Islands", abbreviation: "AX" }, { name: "Albania", abbreviation: "AL" }, { name: "Algeria", abbreviation: "DZ" }, { name: "American Samoa", abbreviation: "AS" }, { name: "Andorra", abbreviation: "AD" }, { name: "Angola", abbreviation: "AO" }, { name: "Anguilla", abbreviation: "AI" }, { name: "Antarctica", abbreviation: "AQ" }, { name: "Antigua and Barbuda", abbreviation: "AG" }, { name: "Argentina", abbreviation: "AR" }, { name: "Armenia", abbreviation: "AM" }, { name: "Aruba", abbreviation: "AW" }, { name: "Australia", abbreviation: "AU" }, { name: "Austria", abbreviation: "AT" }, { name: "Azerbaijan", abbreviation: "AZ" }, { name: "Bahamas", abbreviation: "BS" }, { name: "Bahrain", abbreviation: "BH" }, { name: "Bangladesh", abbreviation: "BD" }, { name: "Barbados", abbreviation: "BB" }, { name: "Belarus", abbreviation: "BY" }, { name: "Belgium", abbreviation: "BE" }, { name: "Belize", abbreviation: "BZ" }, { name: "Benin", abbreviation: "BJ" }, { name: "Bermuda", abbreviation: "BM" }, { name: "Bhutan", abbreviation: "BT" }, { name: "Plurinational State of Bolivia", abbreviation: "BO" }, { name: "Bonaire, Sint Eustatius and Saba", abbreviation: "BQ" }, { name: "Bosnia and Herzegovina", abbreviation: "BA" }, { name: "Botswana", abbreviation: "BW" }, { name: "Bouvet Island", abbreviation: "BV" }, { name: "Brazil", abbreviation: "BR" }, { name: "British Indian Ocean Territory", abbreviation: "IO" }, { name: "Brunei Darussalam", abbreviation: "BN" }, { name: "Bulgaria", abbreviation: "BG" }, { name: "Burkina Faso", abbreviation: "BF" }, { name: "Burundi", abbreviation: "BI" }, { name: "Cabo Verde", abbreviation: "CV" }, { name: "Cambodia", abbreviation: "KH" }, { name: "Cameroon", abbreviation: "CM" }, { name: "Canada", abbreviation: "CA" }, { name: "Cayman Islands", abbreviation: "KY" }, { name: "Central African Republic", abbreviation: "CF" }, { name: "Chad", abbreviation: "TD" }, { name: "Chile", abbreviation: "CL" }, { name: "China", abbreviation: "CN" }, { name: "Christmas Island", abbreviation: "CX" }, { name: "Cocos (Keeling) Islands", abbreviation: "CC" }, { name: "Colombia", abbreviation: "CO" }, { name: "Comoros", abbreviation: "KM" }, { name: "Congo", abbreviation: "CG" }, { name: "Democratic Republic of the Congo", abbreviation: "CD" }, { name: "Cook Islands", abbreviation: "CK" }, { name: "Costa Rica", abbreviation: "CR" }, { name: "Côte d'Ivoire", abbreviation: "CI" }, { name: "Croatia", abbreviation: "HR" }, { name: "Cuba", abbreviation: "CU" }, { name: "Curaçao", abbreviation: "CW" }, { name: "Cyprus", abbreviation: "CY" }, { name: "Czechia", abbreviation: "CZ" }, { name: "Denmark", abbreviation: "DK" }, { name: "Djibouti", abbreviation: "DJ" }, { name: "Dominica", abbreviation: "DM" }, { name: "Dominican Republic", abbreviation: "DO" }, { name: "Ecuador", abbreviation: "EC" }, { name: "Egypt", abbreviation: "EG" }, { name: "El Salvador", abbreviation: "SV" }, { name: "Equatorial Guinea", abbreviation: "GQ" }, { name: "Eritrea", abbreviation: "ER" }, { name: "Estonia", abbreviation: "EE" }, { name: "Eswatini", abbreviation: "SZ" }, { name: "Ethiopia", abbreviation: "ET" }, { name: "Falkland Islands (Malvinas)", abbreviation: "FK" }, { name: "Faroe Islands", abbreviation: "FO" }, { name: "Fiji", abbreviation: "FJ" }, { name: "Finland", abbreviation: "FI" }, { name: "France", abbreviation: "FR" }, { name: "French Guiana", abbreviation: "GF" }, { name: "French Polynesia", abbreviation: "PF" }, { name: "French Southern Territories", abbreviation: "TF" }, { name: "Gabon", abbreviation: "GA" }, { name: "Gambia", abbreviation: "GM" }, { name: "Georgia", abbreviation: "GE" }, { name: "Germany", abbreviation: "DE" }, { name: "Ghana", abbreviation: "GH" }, { name: "Gibraltar", abbreviation: "GI" }, { name: "Greece", abbreviation: "GR" }, { name: "Greenland", abbreviation: "GL" }, { name: "Grenada", abbreviation: "GD" }, { name: "Guadeloupe", abbreviation: "GP" }, { name: "Guam", abbreviation: "GU" }, { name: "Guatemala", abbreviation: "GT" }, { name: "Guernsey", abbreviation: "GG" }, { name: "Guinea", abbreviation: "GN" }, { name: "Guinea-Bissau", abbreviation: "GW" }, { name: "Guyana", abbreviation: "GY" }, { name: "Haiti", abbreviation: "HT" }, { name: "Heard Island and McDonald Islands", abbreviation: "HM" }, { name: "Holy See", abbreviation: "VA" }, { name: "Honduras", abbreviation: "HN" }, { name: "Hong Kong", abbreviation: "HK" }, { name: "Hungary", abbreviation: "HU" }, { name: "Iceland", abbreviation: "IS" }, { name: "India", abbreviation: "IN" }, { name: "Indonesia", abbreviation: "ID" }, { name: "Islamic Republic of Iran", abbreviation: "IR" }, { name: "Iraq", abbreviation: "IQ" }, { name: "Ireland", abbreviation: "IE" }, { name: "Isle of Man", abbreviation: "IM" }, { name: "Israel", abbreviation: "IL" }, { name: "Italy", abbreviation: "IT" }, { name: "Jamaica", abbreviation: "JM" }, { name: "Japan", abbreviation: "JP" }, { name: "Jersey", abbreviation: "JE" }, { name: "Jordan", abbreviation: "JO" }, { name: "Kazakhstan", abbreviation: "KZ" }, { name: "Kenya", abbreviation: "KE" }, { name: "Kiribati", abbreviation: "KI" }, { name: "Democratic People's Republic of Korea", abbreviation: "KP" }, { name: "Republic of Korea", abbreviation: "KR" }, { name: "Kuwait", abbreviation: "KW" }, { name: "Kyrgyzstan", abbreviation: "KG" }, { name: "Lao People's Democratic Republic", abbreviation: "LA" }, { name: "Latvia", abbreviation: "LV" }, { name: "Lebanon", abbreviation: "LB" }, { name: "Lesotho", abbreviation: "LS" }, { name: "Liberia", abbreviation: "LR" }, { name: "Libya", abbreviation: "LY" }, { name: "Liechtenstein", abbreviation: "LI" }, { name: "Lithuania", abbreviation: "LT" }, { name: "Luxembourg", abbreviation: "LU" }, { name: "Macao", abbreviation: "MO" }, { name: "Madagascar", abbreviation: "MG" }, { name: "Malawi", abbreviation: "MW" }, { name: "Malaysia", abbreviation: "MY" }, { name: "Maldives", abbreviation: "MV" }, { name: "Mali", abbreviation: "ML" }, { name: "Malta", abbreviation: "MT" }, { name: "Marshall Islands", abbreviation: "MH" }, { name: "Martinique", abbreviation: "MQ" }, { name: "Mauritania", abbreviation: "MR" }, { name: "Mauritius", abbreviation: "MU" }, { name: "Mayotte", abbreviation: "YT" }, { name: "Mexico", abbreviation: "MX" }, { name: "Federated States of Micronesia", abbreviation: "FM" }, { name: "Republic of Moldova", abbreviation: "MD" }, { name: "Monaco", abbreviation: "MC" }, { name: "Mongolia", abbreviation: "MN" }, { name: "Montenegro", abbreviation: "ME" }, { name: "Montserrat", abbreviation: "MS" }, { name: "Morocco", abbreviation: "MA" }, { name: "Mozambique", abbreviation: "MZ" }, { name: "Myanmar", abbreviation: "MM" }, { name: "Namibia", abbreviation: "NA" }, { name: "Nauru", abbreviation: "NR" }, { name: "Nepal", abbreviation: "NP" }, { name: "Kingdom of the Netherlands", abbreviation: "NL" }, { name: "New Caledonia", abbreviation: "NC" }, { name: "New Zealand", abbreviation: "NZ" }, { name: "Nicaragua", abbreviation: "NI" }, { name: "Niger", abbreviation: "NE" }, { name: "Nigeria", abbreviation: "NG" }, { name: "Niue", abbreviation: "NU" }, { name: "Norfolk Island", abbreviation: "NF" }, { name: "North Macedonia", abbreviation: "MK" }, { name: "Northern Mariana Islands", abbreviation: "MP" }, { name: "Norway", abbreviation: "NO" }, { name: "Oman", abbreviation: "OM" }, { name: "Pakistan", abbreviation: "PK" }, { name: "Palau", abbreviation: "PW" }, { name: "State of Palestine", abbreviation: "PS" }, { name: "Panama", abbreviation: "PA" }, { name: "Papua New Guinea", abbreviation: "PG" }, { name: "Paraguay", abbreviation: "PY" }, { name: "Peru", abbreviation: "PE" }, { name: "Philippines", abbreviation: "PH" }, { name: "Pitcairn", abbreviation: "PN" }, { name: "Poland", abbreviation: "PL" }, { name: "Portugal", abbreviation: "PT" }, { name: "Puerto Rico", abbreviation: "PR" }, { name: "Qatar", abbreviation: "QA" }, { name: "Réunion", abbreviation: "RE" }, { name: "Romania", abbreviation: "RO" }, { name: "Russian Federation", abbreviation: "RU" }, { name: "Rwanda", abbreviation: "RW" }, { name: "Saint Barthélemy", abbreviation: "BL" }, { name: "Saint Helena, Ascension and Tristan da Cunha", abbreviation: "SH" }, { name: "Saint Kitts and Nevis", abbreviation: "KN" }, { name: "Saint Lucia", abbreviation: "LC" }, { name: "Saint Martin (French part)", abbreviation: "MF" }, { name: "Saint Pierre and Miquelon", abbreviation: "PM" }, { name: "Saint Vincent and the Grenadines", abbreviation: "VC" }, { name: "Samoa", abbreviation: "WS" }, { name: "San Marino", abbreviation: "SM" }, { name: "Sao Tome and Principe", abbreviation: "ST" }, { name: "Saudi Arabia", abbreviation: "SA" }, { name: "Senegal", abbreviation: "SN" }, { name: "Serbia", abbreviation: "RS" }, { name: "Seychelles", abbreviation: "SC" }, { name: "Sierra Leone", abbreviation: "SL" }, { name: "Singapore", abbreviation: "SG" }, { name: "Sint Maarten (Dutch part)", abbreviation: "SX" }, { name: "Slovakia", abbreviation: "SK" }, { name: "Slovenia", abbreviation: "SI" }, { name: "Solomon Islands", abbreviation: "SB" }, { name: "Somalia", abbreviation: "SO" }, { name: "South Africa", abbreviation: "ZA" }, { name: "South Georgia and the South Sandwich Islands", abbreviation: "GS" }, { name: "South Sudan", abbreviation: "SS" }, { name: "Spain", abbreviation: "ES" }, { name: "Sri Lanka", abbreviation: "LK" }, { name: "Sudan", abbreviation: "SD" }, { name: "Suriname", abbreviation: "SR" }, { name: "Svalbard and Jan Mayen", abbreviation: "SJ" }, { name: "Sweden", abbreviation: "SE" }, { name: "Switzerland", abbreviation: "CH" }, { name: "Syrian Arab Republic", abbreviation: "SY" }, { name: "Taiwan, Province of China", abbreviation: "TW" }, { name: "Tajikistan", abbreviation: "TJ" }, { name: "United Republic of Tanzania", abbreviation: "TZ" }, { name: "Thailand", abbreviation: "TH" }, { name: "Timor-Leste", abbreviation: "TL" }, { name: "Togo", abbreviation: "TG" }, { name: "Tokelau", abbreviation: "TK" }, { name: "Tonga", abbreviation: "TO" }, { name: "Trinidad and Tobago", abbreviation: "TT" }, { name: "Tunisia", abbreviation: "TN" }, { name: "Türkiye", abbreviation: "TR" }, { name: "Turkmenistan", abbreviation: "TM" }, { name: "Turks and Caicos Islands", abbreviation: "TC" }, { name: "Tuvalu", abbreviation: "TV" }, { name: "Uganda", abbreviation: "UG" }, { name: "Ukraine", abbreviation: "UA" }, { name: "United Arab Emirates", abbreviation: "AE" }, { name: "United Kingdom of Great Britain and Northern Ireland", abbreviation: "GB" }, { name: "United States Minor Outlying Islands", abbreviation: "UM" }, { name: "United States of America", abbreviation: "US" }, { name: "Uruguay", abbreviation: "UY" }, { name: "Uzbekistan", abbreviation: "UZ" }, { name: "Vanuatu", abbreviation: "VU" }, { name: "Bolivarian Republic of Venezuela", abbreviation: "VE" }, { name: "Viet Nam", abbreviation: "VN" }, { name: "Virgin Islands (British)", abbreviation: "VG" }, { name: "Virgin Islands (U.S.)", abbreviation: "VI" }, { name: "Wallis and Futuna", abbreviation: "WF" }, { name: "Western Sahara", abbreviation: "EH" }, { name: "Yemen", abbreviation: "YE" }, { name: "Zambia", abbreviation: "ZM" }, { name: "Zimbabwe", abbreviation: "ZW" }],
        counties: {
          // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
          uk: [
            { name: "Bath and North East Somerset" },
            { name: "Aberdeenshire" },
            { name: "Anglesey" },
            { name: "Angus" },
            { name: "Bedford" },
            { name: "Blackburn with Darwen" },
            { name: "Blackpool" },
            { name: "Bournemouth" },
            { name: "Bracknell Forest" },
            { name: "Brighton & Hove" },
            { name: "Bristol" },
            { name: "Buckinghamshire" },
            { name: "Cambridgeshire" },
            { name: "Carmarthenshire" },
            { name: "Central Bedfordshire" },
            { name: "Ceredigion" },
            { name: "Cheshire East" },
            { name: "Cheshire West and Chester" },
            { name: "Clackmannanshire" },
            { name: "Conwy" },
            { name: "Cornwall" },
            { name: "County Antrim" },
            { name: "County Armagh" },
            { name: "County Down" },
            { name: "County Durham" },
            { name: "County Fermanagh" },
            { name: "County Londonderry" },
            { name: "County Tyrone" },
            { name: "Cumbria" },
            { name: "Darlington" },
            { name: "Denbighshire" },
            { name: "Derby" },
            { name: "Derbyshire" },
            { name: "Devon" },
            { name: "Dorset" },
            { name: "Dumfries and Galloway" },
            { name: "Dundee" },
            { name: "East Lothian" },
            { name: "East Riding of Yorkshire" },
            { name: "East Sussex" },
            { name: "Edinburgh?" },
            { name: "Essex" },
            { name: "Falkirk" },
            { name: "Fife" },
            { name: "Flintshire" },
            { name: "Gloucestershire" },
            { name: "Greater London" },
            { name: "Greater Manchester" },
            { name: "Gwent" },
            { name: "Gwynedd" },
            { name: "Halton" },
            { name: "Hampshire" },
            { name: "Hartlepool" },
            { name: "Herefordshire" },
            { name: "Hertfordshire" },
            { name: "Highlands" },
            { name: "Hull" },
            { name: "Isle of Wight" },
            { name: "Isles of Scilly" },
            { name: "Kent" },
            { name: "Lancashire" },
            { name: "Leicester" },
            { name: "Leicestershire" },
            { name: "Lincolnshire" },
            { name: "Lothian" },
            { name: "Luton" },
            { name: "Medway" },
            { name: "Merseyside" },
            { name: "Mid Glamorgan" },
            { name: "Middlesbrough" },
            { name: "Milton Keynes" },
            { name: "Monmouthshire" },
            { name: "Moray" },
            { name: "Norfolk" },
            { name: "North East Lincolnshire" },
            { name: "North Lincolnshire" },
            { name: "North Somerset" },
            { name: "North Yorkshire" },
            { name: "Northamptonshire" },
            { name: "Northumberland" },
            { name: "Nottingham" },
            { name: "Nottinghamshire" },
            { name: "Oxfordshire" },
            { name: "Pembrokeshire" },
            { name: "Perth and Kinross" },
            { name: "Peterborough" },
            { name: "Plymouth" },
            { name: "Poole" },
            { name: "Portsmouth" },
            { name: "Powys" },
            { name: "Reading" },
            { name: "Redcar and Cleveland" },
            { name: "Rutland" },
            { name: "Scottish Borders" },
            { name: "Shropshire" },
            { name: "Slough" },
            { name: "Somerset" },
            { name: "South Glamorgan" },
            { name: "South Gloucestershire" },
            { name: "South Yorkshire" },
            { name: "Southampton" },
            { name: "Southend-on-Sea" },
            { name: "Staffordshire" },
            { name: "Stirlingshire" },
            { name: "Stockton-on-Tees" },
            { name: "Stoke-on-Trent" },
            { name: "Strathclyde" },
            { name: "Suffolk" },
            { name: "Surrey" },
            { name: "Swindon" },
            { name: "Telford and Wrekin" },
            { name: "Thurrock" },
            { name: "Torbay" },
            { name: "Tyne and Wear" },
            { name: "Warrington" },
            { name: "Warwickshire" },
            { name: "West Berkshire" },
            { name: "West Glamorgan" },
            { name: "West Lothian" },
            { name: "West Midlands" },
            { name: "West Sussex" },
            { name: "West Yorkshire" },
            { name: "Western Isles" },
            { name: "Wiltshire" },
            { name: "Windsor and Maidenhead" },
            { name: "Wokingham" },
            { name: "Worcestershire" },
            { name: "Wrexham" },
            { name: "York" }
          ]
        },
        provinces: {
          ca: [
            { name: "Alberta", abbreviation: "AB" },
            { name: "British Columbia", abbreviation: "BC" },
            { name: "Manitoba", abbreviation: "MB" },
            { name: "New Brunswick", abbreviation: "NB" },
            { name: "Newfoundland and Labrador", abbreviation: "NL" },
            { name: "Nova Scotia", abbreviation: "NS" },
            { name: "Ontario", abbreviation: "ON" },
            { name: "Prince Edward Island", abbreviation: "PE" },
            { name: "Quebec", abbreviation: "QC" },
            { name: "Saskatchewan", abbreviation: "SK" },
            // The case could be made that the following are not actually provinces
            // since they are technically considered "territories" however they all
            // look the same on an envelope!
            { name: "Northwest Territories", abbreviation: "NT" },
            { name: "Nunavut", abbreviation: "NU" },
            { name: "Yukon", abbreviation: "YT" }
          ],
          it: [
            { name: "Agrigento", abbreviation: "AG", code: 84 },
            { name: "Alessandria", abbreviation: "AL", code: 6 },
            { name: "Ancona", abbreviation: "AN", code: 42 },
            { name: "Aosta", abbreviation: "AO", code: 7 },
            { name: "L'Aquila", abbreviation: "AQ", code: 66 },
            { name: "Arezzo", abbreviation: "AR", code: 51 },
            { name: "Ascoli-Piceno", abbreviation: "AP", code: 44 },
            { name: "Asti", abbreviation: "AT", code: 5 },
            { name: "Avellino", abbreviation: "AV", code: 64 },
            { name: "Bari", abbreviation: "BA", code: 72 },
            { name: "Barletta-Andria-Trani", abbreviation: "BT", code: 72 },
            { name: "Belluno", abbreviation: "BL", code: 25 },
            { name: "Benevento", abbreviation: "BN", code: 62 },
            { name: "Bergamo", abbreviation: "BG", code: 16 },
            { name: "Biella", abbreviation: "BI", code: 96 },
            { name: "Bologna", abbreviation: "BO", code: 37 },
            { name: "Bolzano", abbreviation: "BZ", code: 21 },
            { name: "Brescia", abbreviation: "BS", code: 17 },
            { name: "Brindisi", abbreviation: "BR", code: 74 },
            { name: "Cagliari", abbreviation: "CA", code: 92 },
            { name: "Caltanissetta", abbreviation: "CL", code: 85 },
            { name: "Campobasso", abbreviation: "CB", code: 70 },
            { name: "Carbonia Iglesias", abbreviation: "CI", code: 70 },
            { name: "Caserta", abbreviation: "CE", code: 61 },
            { name: "Catania", abbreviation: "CT", code: 87 },
            { name: "Catanzaro", abbreviation: "CZ", code: 79 },
            { name: "Chieti", abbreviation: "CH", code: 69 },
            { name: "Como", abbreviation: "CO", code: 13 },
            { name: "Cosenza", abbreviation: "CS", code: 78 },
            { name: "Cremona", abbreviation: "CR", code: 19 },
            { name: "Crotone", abbreviation: "KR", code: 101 },
            { name: "Cuneo", abbreviation: "CN", code: 4 },
            { name: "Enna", abbreviation: "EN", code: 86 },
            { name: "Fermo", abbreviation: "FM", code: 86 },
            { name: "Ferrara", abbreviation: "FE", code: 38 },
            { name: "Firenze", abbreviation: "FI", code: 48 },
            { name: "Foggia", abbreviation: "FG", code: 71 },
            { name: "Forli-Cesena", abbreviation: "FC", code: 71 },
            { name: "Frosinone", abbreviation: "FR", code: 60 },
            { name: "Genova", abbreviation: "GE", code: 10 },
            { name: "Gorizia", abbreviation: "GO", code: 31 },
            { name: "Grosseto", abbreviation: "GR", code: 53 },
            { name: "Imperia", abbreviation: "IM", code: 8 },
            { name: "Isernia", abbreviation: "IS", code: 94 },
            { name: "La-Spezia", abbreviation: "SP", code: 66 },
            { name: "Latina", abbreviation: "LT", code: 59 },
            { name: "Lecce", abbreviation: "LE", code: 75 },
            { name: "Lecco", abbreviation: "LC", code: 97 },
            { name: "Livorno", abbreviation: "LI", code: 49 },
            { name: "Lodi", abbreviation: "LO", code: 98 },
            { name: "Lucca", abbreviation: "LU", code: 46 },
            { name: "Macerata", abbreviation: "MC", code: 43 },
            { name: "Mantova", abbreviation: "MN", code: 20 },
            { name: "Massa-Carrara", abbreviation: "MS", code: 45 },
            { name: "Matera", abbreviation: "MT", code: 77 },
            { name: "Medio Campidano", abbreviation: "VS", code: 77 },
            { name: "Messina", abbreviation: "ME", code: 83 },
            { name: "Milano", abbreviation: "MI", code: 15 },
            { name: "Modena", abbreviation: "MO", code: 36 },
            { name: "Monza-Brianza", abbreviation: "MB", code: 36 },
            { name: "Napoli", abbreviation: "NA", code: 63 },
            { name: "Novara", abbreviation: "NO", code: 3 },
            { name: "Nuoro", abbreviation: "NU", code: 91 },
            { name: "Ogliastra", abbreviation: "OG", code: 91 },
            { name: "Olbia Tempio", abbreviation: "OT", code: 91 },
            { name: "Oristano", abbreviation: "OR", code: 95 },
            { name: "Padova", abbreviation: "PD", code: 28 },
            { name: "Palermo", abbreviation: "PA", code: 82 },
            { name: "Parma", abbreviation: "PR", code: 34 },
            { name: "Pavia", abbreviation: "PV", code: 18 },
            { name: "Perugia", abbreviation: "PG", code: 54 },
            { name: "Pesaro-Urbino", abbreviation: "PU", code: 41 },
            { name: "Pescara", abbreviation: "PE", code: 68 },
            { name: "Piacenza", abbreviation: "PC", code: 33 },
            { name: "Pisa", abbreviation: "PI", code: 50 },
            { name: "Pistoia", abbreviation: "PT", code: 47 },
            { name: "Pordenone", abbreviation: "PN", code: 93 },
            { name: "Potenza", abbreviation: "PZ", code: 76 },
            { name: "Prato", abbreviation: "PO", code: 100 },
            { name: "Ragusa", abbreviation: "RG", code: 88 },
            { name: "Ravenna", abbreviation: "RA", code: 39 },
            { name: "Reggio-Calabria", abbreviation: "RC", code: 35 },
            { name: "Reggio-Emilia", abbreviation: "RE", code: 35 },
            { name: "Rieti", abbreviation: "RI", code: 57 },
            { name: "Rimini", abbreviation: "RN", code: 99 },
            { name: "Roma", abbreviation: "Roma", code: 58 },
            { name: "Rovigo", abbreviation: "RO", code: 29 },
            { name: "Salerno", abbreviation: "SA", code: 65 },
            { name: "Sassari", abbreviation: "SS", code: 90 },
            { name: "Savona", abbreviation: "SV", code: 9 },
            { name: "Siena", abbreviation: "SI", code: 52 },
            { name: "Siracusa", abbreviation: "SR", code: 89 },
            { name: "Sondrio", abbreviation: "SO", code: 14 },
            { name: "Taranto", abbreviation: "TA", code: 73 },
            { name: "Teramo", abbreviation: "TE", code: 67 },
            { name: "Terni", abbreviation: "TR", code: 55 },
            { name: "Torino", abbreviation: "TO", code: 1 },
            { name: "Trapani", abbreviation: "TP", code: 81 },
            { name: "Trento", abbreviation: "TN", code: 22 },
            { name: "Treviso", abbreviation: "TV", code: 26 },
            { name: "Trieste", abbreviation: "TS", code: 32 },
            { name: "Udine", abbreviation: "UD", code: 30 },
            { name: "Varese", abbreviation: "VA", code: 12 },
            { name: "Venezia", abbreviation: "VE", code: 27 },
            { name: "Verbania", abbreviation: "VB", code: 27 },
            { name: "Vercelli", abbreviation: "VC", code: 2 },
            { name: "Verona", abbreviation: "VR", code: 23 },
            { name: "Vibo-Valentia", abbreviation: "VV", code: 102 },
            { name: "Vicenza", abbreviation: "VI", code: 24 },
            { name: "Viterbo", abbreviation: "VT", code: 56 }
          ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
          { name: "Afghan" },
          { name: "Albanian" },
          { name: "Algerian" },
          { name: "American" },
          { name: "Andorran" },
          { name: "Angolan" },
          { name: "Antiguans" },
          { name: "Argentinean" },
          { name: "Armenian" },
          { name: "Australian" },
          { name: "Austrian" },
          { name: "Azerbaijani" },
          { name: "Bahami" },
          { name: "Bahraini" },
          { name: "Bangladeshi" },
          { name: "Barbadian" },
          { name: "Barbudans" },
          { name: "Batswana" },
          { name: "Belarusian" },
          { name: "Belgian" },
          { name: "Belizean" },
          { name: "Beninese" },
          { name: "Bhutanese" },
          { name: "Bolivian" },
          { name: "Bosnian" },
          { name: "Brazilian" },
          { name: "British" },
          { name: "Bruneian" },
          { name: "Bulgarian" },
          { name: "Burkinabe" },
          { name: "Burmese" },
          { name: "Burundian" },
          { name: "Cambodian" },
          { name: "Cameroonian" },
          { name: "Canadian" },
          { name: "Cape Verdean" },
          { name: "Central African" },
          { name: "Chadian" },
          { name: "Chilean" },
          { name: "Chinese" },
          { name: "Colombian" },
          { name: "Comoran" },
          { name: "Congolese" },
          { name: "Costa Rican" },
          { name: "Croatian" },
          { name: "Cuban" },
          { name: "Cypriot" },
          { name: "Czech" },
          { name: "Danish" },
          { name: "Djibouti" },
          { name: "Dominican" },
          { name: "Dutch" },
          { name: "East Timorese" },
          { name: "Ecuadorean" },
          { name: "Egyptian" },
          { name: "Emirian" },
          { name: "Equatorial Guinean" },
          { name: "Eritrean" },
          { name: "Estonian" },
          { name: "Ethiopian" },
          { name: "Fijian" },
          { name: "Filipino" },
          { name: "Finnish" },
          { name: "French" },
          { name: "Gabonese" },
          { name: "Gambian" },
          { name: "Georgian" },
          { name: "German" },
          { name: "Ghanaian" },
          { name: "Greek" },
          { name: "Grenadian" },
          { name: "Guatemalan" },
          { name: "Guinea-Bissauan" },
          { name: "Guinean" },
          { name: "Guyanese" },
          { name: "Haitian" },
          { name: "Herzegovinian" },
          { name: "Honduran" },
          { name: "Hungarian" },
          { name: "I-Kiribati" },
          { name: "Icelander" },
          { name: "Indian" },
          { name: "Indonesian" },
          { name: "Iranian" },
          { name: "Iraqi" },
          { name: "Irish" },
          { name: "Israeli" },
          { name: "Italian" },
          { name: "Ivorian" },
          { name: "Jamaican" },
          { name: "Japanese" },
          { name: "Jordanian" },
          { name: "Kazakhstani" },
          { name: "Kenyan" },
          { name: "Kittian and Nevisian" },
          { name: "Kuwaiti" },
          { name: "Kyrgyz" },
          { name: "Laotian" },
          { name: "Latvian" },
          { name: "Lebanese" },
          { name: "Liberian" },
          { name: "Libyan" },
          { name: "Liechtensteiner" },
          { name: "Lithuanian" },
          { name: "Luxembourger" },
          { name: "Macedonian" },
          { name: "Malagasy" },
          { name: "Malawian" },
          { name: "Malaysian" },
          { name: "Maldivan" },
          { name: "Malian" },
          { name: "Maltese" },
          { name: "Marshallese" },
          { name: "Mauritanian" },
          { name: "Mauritian" },
          { name: "Mexican" },
          { name: "Micronesian" },
          { name: "Moldovan" },
          { name: "Monacan" },
          { name: "Mongolian" },
          { name: "Moroccan" },
          { name: "Mosotho" },
          { name: "Motswana" },
          { name: "Mozambican" },
          { name: "Namibian" },
          { name: "Nauruan" },
          { name: "Nepalese" },
          { name: "New Zealander" },
          { name: "Nicaraguan" },
          { name: "Nigerian" },
          { name: "Nigerien" },
          { name: "North Korean" },
          { name: "Northern Irish" },
          { name: "Norwegian" },
          { name: "Omani" },
          { name: "Pakistani" },
          { name: "Palauan" },
          { name: "Panamanian" },
          { name: "Papua New Guinean" },
          { name: "Paraguayan" },
          { name: "Peruvian" },
          { name: "Polish" },
          { name: "Portuguese" },
          { name: "Qatari" },
          { name: "Romani" },
          { name: "Russian" },
          { name: "Rwandan" },
          { name: "Saint Lucian" },
          { name: "Salvadoran" },
          { name: "Samoan" },
          { name: "San Marinese" },
          { name: "Sao Tomean" },
          { name: "Saudi" },
          { name: "Scottish" },
          { name: "Senegalese" },
          { name: "Serbian" },
          { name: "Seychellois" },
          { name: "Sierra Leonean" },
          { name: "Singaporean" },
          { name: "Slovakian" },
          { name: "Slovenian" },
          { name: "Solomon Islander" },
          { name: "Somali" },
          { name: "South African" },
          { name: "South Korean" },
          { name: "Spanish" },
          { name: "Sri Lankan" },
          { name: "Sudanese" },
          { name: "Surinamer" },
          { name: "Swazi" },
          { name: "Swedish" },
          { name: "Swiss" },
          { name: "Syrian" },
          { name: "Taiwanese" },
          { name: "Tajik" },
          { name: "Tanzanian" },
          { name: "Thai" },
          { name: "Togolese" },
          { name: "Tongan" },
          { name: "Trinidadian or Tobagonian" },
          { name: "Tunisian" },
          { name: "Turkish" },
          { name: "Tuvaluan" },
          { name: "Ugandan" },
          { name: "Ukrainian" },
          { name: "Uruguaya" },
          { name: "Uzbekistani" },
          { name: "Venezuela" },
          { name: "Vietnamese" },
          { name: "Wels" },
          { name: "Yemenit" },
          { name: "Zambia" },
          { name: "Zimbabwe" }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
          "aa",
          "ab",
          "ae",
          "af",
          "ak",
          "am",
          "an",
          "ar",
          "as",
          "av",
          "ay",
          "az",
          "ba",
          "be",
          "bg",
          "bh",
          "bi",
          "bm",
          "bn",
          "bo",
          "br",
          "bs",
          "ca",
          "ce",
          "ch",
          "co",
          "cr",
          "cs",
          "cu",
          "cv",
          "cy",
          "da",
          "de",
          "dv",
          "dz",
          "ee",
          "el",
          "en",
          "eo",
          "es",
          "et",
          "eu",
          "fa",
          "ff",
          "fi",
          "fj",
          "fo",
          "fr",
          "fy",
          "ga",
          "gd",
          "gl",
          "gn",
          "gu",
          "gv",
          "ha",
          "he",
          "hi",
          "ho",
          "hr",
          "ht",
          "hu",
          "hy",
          "hz",
          "ia",
          "id",
          "ie",
          "ig",
          "ii",
          "ik",
          "io",
          "is",
          "it",
          "iu",
          "ja",
          "jv",
          "ka",
          "kg",
          "ki",
          "kj",
          "kk",
          "kl",
          "km",
          "kn",
          "ko",
          "kr",
          "ks",
          "ku",
          "kv",
          "kw",
          "ky",
          "la",
          "lb",
          "lg",
          "li",
          "ln",
          "lo",
          "lt",
          "lu",
          "lv",
          "mg",
          "mh",
          "mi",
          "mk",
          "ml",
          "mn",
          "mr",
          "ms",
          "mt",
          "my",
          "na",
          "nb",
          "nd",
          "ne",
          "ng",
          "nl",
          "nn",
          "no",
          "nr",
          "nv",
          "ny",
          "oc",
          "oj",
          "om",
          "or",
          "os",
          "pa",
          "pi",
          "pl",
          "ps",
          "pt",
          "qu",
          "rm",
          "rn",
          "ro",
          "ru",
          "rw",
          "sa",
          "sc",
          "sd",
          "se",
          "sg",
          "si",
          "sk",
          "sl",
          "sm",
          "sn",
          "so",
          "sq",
          "sr",
          "ss",
          "st",
          "su",
          "sv",
          "sw",
          "ta",
          "te",
          "tg",
          "th",
          "ti",
          "tk",
          "tl",
          "tn",
          "to",
          "tr",
          "ts",
          "tt",
          "tw",
          "ty",
          "ug",
          "uk",
          "ur",
          "uz",
          "ve",
          "vi",
          "vo",
          "wa",
          "wo",
          "xh",
          "yi",
          "yo",
          "za",
          "zh",
          "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
          "agq-CM",
          "asa-TZ",
          "ast-ES",
          "bas-CM",
          "bem-ZM",
          "bez-TZ",
          "brx-IN",
          "cgg-UG",
          "chr-US",
          "dav-KE",
          "dje-NE",
          "dsb-DE",
          "dua-CM",
          "dyo-SN",
          "ebu-KE",
          "ewo-CM",
          "fil-PH",
          "fur-IT",
          "gsw-CH",
          "gsw-FR",
          "gsw-LI",
          "guz-KE",
          "haw-US",
          "hsb-DE",
          "jgo-CM",
          "jmc-TZ",
          "kab-DZ",
          "kam-KE",
          "kde-TZ",
          "kea-CV",
          "khq-ML",
          "kkj-CM",
          "kln-KE",
          "kok-IN",
          "ksb-TZ",
          "ksf-CM",
          "ksh-DE",
          "lag-TZ",
          "lkt-US",
          "luo-KE",
          "luy-KE",
          "mas-KE",
          "mas-TZ",
          "mer-KE",
          "mfe-MU",
          "mgh-MZ",
          "mgo-CM",
          "mua-CM",
          "naq-NA",
          "nmg-CM",
          "nnh-CM",
          "nus-SD",
          "nyn-UG",
          "rof-TZ",
          "rwk-TZ",
          "sah-RU",
          "saq-KE",
          "sbp-TZ",
          "seh-MZ",
          "ses-ML",
          "shi-Latn",
          "shi-Latn-MA",
          "shi-Tfng",
          "shi-Tfng-MA",
          "smn-FI",
          "teo-KE",
          "teo-UG",
          "twq-NE",
          "tzm-Latn",
          "tzm-Latn-MA",
          "vai-Latn",
          "vai-Latn-LR",
          "vai-Vaii",
          "vai-Vaii-LR",
          "vun-TZ",
          "wae-CH",
          "xog-UG",
          "yav-CM",
          "zgh-MA",
          "af-NA",
          "af-ZA",
          "ak-GH",
          "am-ET",
          "ar-001",
          "ar-AE",
          "ar-BH",
          "ar-DJ",
          "ar-DZ",
          "ar-EG",
          "ar-EH",
          "ar-ER",
          "ar-IL",
          "ar-IQ",
          "ar-JO",
          "ar-KM",
          "ar-KW",
          "ar-LB",
          "ar-LY",
          "ar-MA",
          "ar-MR",
          "ar-OM",
          "ar-PS",
          "ar-QA",
          "ar-SA",
          "ar-SD",
          "ar-SO",
          "ar-SS",
          "ar-SY",
          "ar-TD",
          "ar-TN",
          "ar-YE",
          "as-IN",
          "az-Cyrl",
          "az-Cyrl-AZ",
          "az-Latn",
          "az-Latn-AZ",
          "be-BY",
          "bg-BG",
          "bm-Latn",
          "bm-Latn-ML",
          "bn-BD",
          "bn-IN",
          "bo-CN",
          "bo-IN",
          "br-FR",
          "bs-Cyrl",
          "bs-Cyrl-BA",
          "bs-Latn",
          "bs-Latn-BA",
          "ca-AD",
          "ca-ES",
          "ca-ES-VALENCIA",
          "ca-FR",
          "ca-IT",
          "cs-CZ",
          "cy-GB",
          "da-DK",
          "da-GL",
          "de-AT",
          "de-BE",
          "de-CH",
          "de-DE",
          "de-LI",
          "de-LU",
          "dz-BT",
          "ee-GH",
          "ee-TG",
          "el-CY",
          "el-GR",
          "en-001",
          "en-150",
          "en-AG",
          "en-AI",
          "en-AS",
          "en-AU",
          "en-BB",
          "en-BE",
          "en-BM",
          "en-BS",
          "en-BW",
          "en-BZ",
          "en-CA",
          "en-CC",
          "en-CK",
          "en-CM",
          "en-CX",
          "en-DG",
          "en-DM",
          "en-ER",
          "en-FJ",
          "en-FK",
          "en-FM",
          "en-GB",
          "en-GD",
          "en-GG",
          "en-GH",
          "en-GI",
          "en-GM",
          "en-GU",
          "en-GY",
          "en-HK",
          "en-IE",
          "en-IM",
          "en-IN",
          "en-IO",
          "en-JE",
          "en-JM",
          "en-KE",
          "en-KI",
          "en-KN",
          "en-KY",
          "en-LC",
          "en-LR",
          "en-LS",
          "en-MG",
          "en-MH",
          "en-MO",
          "en-MP",
          "en-MS",
          "en-MT",
          "en-MU",
          "en-MW",
          "en-MY",
          "en-NA",
          "en-NF",
          "en-NG",
          "en-NR",
          "en-NU",
          "en-NZ",
          "en-PG",
          "en-PH",
          "en-PK",
          "en-PN",
          "en-PR",
          "en-PW",
          "en-RW",
          "en-SB",
          "en-SC",
          "en-SD",
          "en-SG",
          "en-SH",
          "en-SL",
          "en-SS",
          "en-SX",
          "en-SZ",
          "en-TC",
          "en-TK",
          "en-TO",
          "en-TT",
          "en-TV",
          "en-TZ",
          "en-UG",
          "en-UM",
          "en-US",
          "en-US-POSIX",
          "en-VC",
          "en-VG",
          "en-VI",
          "en-VU",
          "en-WS",
          "en-ZA",
          "en-ZM",
          "en-ZW",
          "eo-001",
          "es-419",
          "es-AR",
          "es-BO",
          "es-CL",
          "es-CO",
          "es-CR",
          "es-CU",
          "es-DO",
          "es-EA",
          "es-EC",
          "es-ES",
          "es-GQ",
          "es-GT",
          "es-HN",
          "es-IC",
          "es-MX",
          "es-NI",
          "es-PA",
          "es-PE",
          "es-PH",
          "es-PR",
          "es-PY",
          "es-SV",
          "es-US",
          "es-UY",
          "es-VE",
          "et-EE",
          "eu-ES",
          "fa-AF",
          "fa-IR",
          "ff-CM",
          "ff-GN",
          "ff-MR",
          "ff-SN",
          "fi-FI",
          "fo-FO",
          "fr-BE",
          "fr-BF",
          "fr-BI",
          "fr-BJ",
          "fr-BL",
          "fr-CA",
          "fr-CD",
          "fr-CF",
          "fr-CG",
          "fr-CH",
          "fr-CI",
          "fr-CM",
          "fr-DJ",
          "fr-DZ",
          "fr-FR",
          "fr-GA",
          "fr-GF",
          "fr-GN",
          "fr-GP",
          "fr-GQ",
          "fr-HT",
          "fr-KM",
          "fr-LU",
          "fr-MA",
          "fr-MC",
          "fr-MF",
          "fr-MG",
          "fr-ML",
          "fr-MQ",
          "fr-MR",
          "fr-MU",
          "fr-NC",
          "fr-NE",
          "fr-PF",
          "fr-PM",
          "fr-RE",
          "fr-RW",
          "fr-SC",
          "fr-SN",
          "fr-SY",
          "fr-TD",
          "fr-TG",
          "fr-TN",
          "fr-VU",
          "fr-WF",
          "fr-YT",
          "fy-NL",
          "ga-IE",
          "gd-GB",
          "gl-ES",
          "gu-IN",
          "gv-IM",
          "ha-Latn",
          "ha-Latn-GH",
          "ha-Latn-NE",
          "ha-Latn-NG",
          "he-IL",
          "hi-IN",
          "hr-BA",
          "hr-HR",
          "hu-HU",
          "hy-AM",
          "id-ID",
          "ig-NG",
          "ii-CN",
          "is-IS",
          "it-CH",
          "it-IT",
          "it-SM",
          "ja-JP",
          "ka-GE",
          "ki-KE",
          "kk-Cyrl",
          "kk-Cyrl-KZ",
          "kl-GL",
          "km-KH",
          "kn-IN",
          "ko-KP",
          "ko-KR",
          "ks-Arab",
          "ks-Arab-IN",
          "kw-GB",
          "ky-Cyrl",
          "ky-Cyrl-KG",
          "lb-LU",
          "lg-UG",
          "ln-AO",
          "ln-CD",
          "ln-CF",
          "ln-CG",
          "lo-LA",
          "lt-LT",
          "lu-CD",
          "lv-LV",
          "mg-MG",
          "mk-MK",
          "ml-IN",
          "mn-Cyrl",
          "mn-Cyrl-MN",
          "mr-IN",
          "ms-Latn",
          "ms-Latn-BN",
          "ms-Latn-MY",
          "ms-Latn-SG",
          "mt-MT",
          "my-MM",
          "nb-NO",
          "nb-SJ",
          "nd-ZW",
          "ne-IN",
          "ne-NP",
          "nl-AW",
          "nl-BE",
          "nl-BQ",
          "nl-CW",
          "nl-NL",
          "nl-SR",
          "nl-SX",
          "nn-NO",
          "om-ET",
          "om-KE",
          "or-IN",
          "os-GE",
          "os-RU",
          "pa-Arab",
          "pa-Arab-PK",
          "pa-Guru",
          "pa-Guru-IN",
          "pl-PL",
          "ps-AF",
          "pt-AO",
          "pt-BR",
          "pt-CV",
          "pt-GW",
          "pt-MO",
          "pt-MZ",
          "pt-PT",
          "pt-ST",
          "pt-TL",
          "qu-BO",
          "qu-EC",
          "qu-PE",
          "rm-CH",
          "rn-BI",
          "ro-MD",
          "ro-RO",
          "ru-BY",
          "ru-KG",
          "ru-KZ",
          "ru-MD",
          "ru-RU",
          "ru-UA",
          "rw-RW",
          "se-FI",
          "se-NO",
          "se-SE",
          "sg-CF",
          "si-LK",
          "sk-SK",
          "sl-SI",
          "sn-ZW",
          "so-DJ",
          "so-ET",
          "so-KE",
          "so-SO",
          "sq-AL",
          "sq-MK",
          "sq-XK",
          "sr-Cyrl",
          "sr-Cyrl-BA",
          "sr-Cyrl-ME",
          "sr-Cyrl-RS",
          "sr-Cyrl-XK",
          "sr-Latn",
          "sr-Latn-BA",
          "sr-Latn-ME",
          "sr-Latn-RS",
          "sr-Latn-XK",
          "sv-AX",
          "sv-FI",
          "sv-SE",
          "sw-CD",
          "sw-KE",
          "sw-TZ",
          "sw-UG",
          "ta-IN",
          "ta-LK",
          "ta-MY",
          "ta-SG",
          "te-IN",
          "th-TH",
          "ti-ER",
          "ti-ET",
          "to-TO",
          "tr-CY",
          "tr-TR",
          "ug-Arab",
          "ug-Arab-CN",
          "uk-UA",
          "ur-IN",
          "ur-PK",
          "uz-Arab",
          "uz-Arab-AF",
          "uz-Cyrl",
          "uz-Cyrl-UZ",
          "uz-Latn",
          "uz-Latn-UZ",
          "vi-VN",
          "yi-001",
          "yo-BJ",
          "yo-NG",
          "zh-Hans",
          "zh-Hans-CN",
          "zh-Hans-HK",
          "zh-Hans-MO",
          "zh-Hans-SG",
          "zh-Hant",
          "zh-Hant-HK",
          "zh-Hant-MO",
          "zh-Hant-TW",
          "zu-ZA"
        ],
        us_states_and_dc: [
          { name: "Alabama", abbreviation: "AL" },
          { name: "Alaska", abbreviation: "AK" },
          { name: "Arizona", abbreviation: "AZ" },
          { name: "Arkansas", abbreviation: "AR" },
          { name: "California", abbreviation: "CA" },
          { name: "Colorado", abbreviation: "CO" },
          { name: "Connecticut", abbreviation: "CT" },
          { name: "Delaware", abbreviation: "DE" },
          { name: "District of Columbia", abbreviation: "DC" },
          { name: "Florida", abbreviation: "FL" },
          { name: "Georgia", abbreviation: "GA" },
          { name: "Hawaii", abbreviation: "HI" },
          { name: "Idaho", abbreviation: "ID" },
          { name: "Illinois", abbreviation: "IL" },
          { name: "Indiana", abbreviation: "IN" },
          { name: "Iowa", abbreviation: "IA" },
          { name: "Kansas", abbreviation: "KS" },
          { name: "Kentucky", abbreviation: "KY" },
          { name: "Louisiana", abbreviation: "LA" },
          { name: "Maine", abbreviation: "ME" },
          { name: "Maryland", abbreviation: "MD" },
          { name: "Massachusetts", abbreviation: "MA" },
          { name: "Michigan", abbreviation: "MI" },
          { name: "Minnesota", abbreviation: "MN" },
          { name: "Mississippi", abbreviation: "MS" },
          { name: "Missouri", abbreviation: "MO" },
          { name: "Montana", abbreviation: "MT" },
          { name: "Nebraska", abbreviation: "NE" },
          { name: "Nevada", abbreviation: "NV" },
          { name: "New Hampshire", abbreviation: "NH" },
          { name: "New Jersey", abbreviation: "NJ" },
          { name: "New Mexico", abbreviation: "NM" },
          { name: "New York", abbreviation: "NY" },
          { name: "North Carolina", abbreviation: "NC" },
          { name: "North Dakota", abbreviation: "ND" },
          { name: "Ohio", abbreviation: "OH" },
          { name: "Oklahoma", abbreviation: "OK" },
          { name: "Oregon", abbreviation: "OR" },
          { name: "Pennsylvania", abbreviation: "PA" },
          { name: "Rhode Island", abbreviation: "RI" },
          { name: "South Carolina", abbreviation: "SC" },
          { name: "South Dakota", abbreviation: "SD" },
          { name: "Tennessee", abbreviation: "TN" },
          { name: "Texas", abbreviation: "TX" },
          { name: "Utah", abbreviation: "UT" },
          { name: "Vermont", abbreviation: "VT" },
          { name: "Virginia", abbreviation: "VA" },
          { name: "Washington", abbreviation: "WA" },
          { name: "West Virginia", abbreviation: "WV" },
          { name: "Wisconsin", abbreviation: "WI" },
          { name: "Wyoming", abbreviation: "WY" }
        ],
        territories: [
          { name: "American Samoa", abbreviation: "AS" },
          { name: "Federated States of Micronesia", abbreviation: "FM" },
          { name: "Guam", abbreviation: "GU" },
          { name: "Marshall Islands", abbreviation: "MH" },
          { name: "Northern Mariana Islands", abbreviation: "MP" },
          { name: "Puerto Rico", abbreviation: "PR" },
          { name: "Virgin Islands, U.S.", abbreviation: "VI" }
        ],
        armed_forces: [
          { name: "Armed Forces Europe", abbreviation: "AE" },
          { name: "Armed Forces Pacific", abbreviation: "AP" },
          { name: "Armed Forces the Americas", abbreviation: "AA" }
        ],
        country_regions: {
          it: [
            { name: "Valle d'Aosta", abbreviation: "VDA" },
            { name: "Piemonte", abbreviation: "PIE" },
            { name: "Lombardia", abbreviation: "LOM" },
            { name: "Veneto", abbreviation: "VEN" },
            { name: "Trentino Alto Adige", abbreviation: "TAA" },
            { name: "Friuli Venezia Giulia", abbreviation: "FVG" },
            { name: "Liguria", abbreviation: "LIG" },
            { name: "Emilia Romagna", abbreviation: "EMR" },
            { name: "Toscana", abbreviation: "TOS" },
            { name: "Umbria", abbreviation: "UMB" },
            { name: "Marche", abbreviation: "MAR" },
            { name: "Abruzzo", abbreviation: "ABR" },
            { name: "Lazio", abbreviation: "LAZ" },
            { name: "Campania", abbreviation: "CAM" },
            { name: "Puglia", abbreviation: "PUG" },
            { name: "Basilicata", abbreviation: "BAS" },
            { name: "Molise", abbreviation: "MOL" },
            { name: "Calabria", abbreviation: "CAL" },
            { name: "Sicilia", abbreviation: "SIC" },
            { name: "Sardegna", abbreviation: "SAR" }
          ],
          mx: [
            { name: "Aguascalientes", abbreviation: "AGU" },
            { name: "Baja California", abbreviation: "BCN" },
            { name: "Baja California Sur", abbreviation: "BCS" },
            { name: "Campeche", abbreviation: "CAM" },
            { name: "Chiapas", abbreviation: "CHP" },
            { name: "Chihuahua", abbreviation: "CHH" },
            { name: "Ciudad de México", abbreviation: "DIF" },
            { name: "Coahuila", abbreviation: "COA" },
            { name: "Colima", abbreviation: "COL" },
            { name: "Durango", abbreviation: "DUR" },
            { name: "Guanajuato", abbreviation: "GUA" },
            { name: "Guerrero", abbreviation: "GRO" },
            { name: "Hidalgo", abbreviation: "HID" },
            { name: "Jalisco", abbreviation: "JAL" },
            { name: "México", abbreviation: "MEX" },
            { name: "Michoacán", abbreviation: "MIC" },
            { name: "Morelos", abbreviation: "MOR" },
            { name: "Nayarit", abbreviation: "NAY" },
            { name: "Nuevo León", abbreviation: "NLE" },
            { name: "Oaxaca", abbreviation: "OAX" },
            { name: "Puebla", abbreviation: "PUE" },
            { name: "Querétaro", abbreviation: "QUE" },
            { name: "Quintana Roo", abbreviation: "ROO" },
            { name: "San Luis Potosí", abbreviation: "SLP" },
            { name: "Sinaloa", abbreviation: "SIN" },
            { name: "Sonora", abbreviation: "SON" },
            { name: "Tabasco", abbreviation: "TAB" },
            { name: "Tamaulipas", abbreviation: "TAM" },
            { name: "Tlaxcala", abbreviation: "TLA" },
            { name: "Veracruz", abbreviation: "VER" },
            { name: "Yucatán", abbreviation: "YUC" },
            { name: "Zacatecas", abbreviation: "ZAC" }
          ]
        },
        street_suffixes: {
          us: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Boulevard", abbreviation: "Blvd" },
            { name: "Center", abbreviation: "Ctr" },
            { name: "Circle", abbreviation: "Cir" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Extension", abbreviation: "Ext" },
            { name: "Glen", abbreviation: "Gln" },
            { name: "Grove", abbreviation: "Grv" },
            { name: "Heights", abbreviation: "Hts" },
            { name: "Highway", abbreviation: "Hwy" },
            { name: "Junction", abbreviation: "Jct" },
            { name: "Key", abbreviation: "Key" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Loop", abbreviation: "Loop" },
            { name: "Manor", abbreviation: "Mnr" },
            { name: "Mill", abbreviation: "Mill" },
            { name: "Park", abbreviation: "Park" },
            { name: "Parkway", abbreviation: "Pkwy" },
            { name: "Pass", abbreviation: "Pass" },
            { name: "Path", abbreviation: "Path" },
            { name: "Pike", abbreviation: "Pike" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Plaza", abbreviation: "Plz" },
            { name: "Point", abbreviation: "Pt" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "River", abbreviation: "Riv" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Trail", abbreviation: "Trl" },
            { name: "Turnpike", abbreviation: "Tpke" },
            { name: "View", abbreviation: "Vw" },
            { name: "Way", abbreviation: "Way" }
          ],
          it: [
            { name: "Accesso", abbreviation: "Acc." },
            { name: "Alzaia", abbreviation: "Alz." },
            { name: "Arco", abbreviation: "Arco" },
            { name: "Archivolto", abbreviation: "Acv." },
            { name: "Arena", abbreviation: "Arena" },
            { name: "Argine", abbreviation: "Argine" },
            { name: "Bacino", abbreviation: "Bacino" },
            { name: "Banchi", abbreviation: "Banchi" },
            { name: "Banchina", abbreviation: "Ban." },
            { name: "Bastioni", abbreviation: "Bas." },
            { name: "Belvedere", abbreviation: "Belv." },
            { name: "Borgata", abbreviation: "B.ta" },
            { name: "Borgo", abbreviation: "B.go" },
            { name: "Calata", abbreviation: "Cal." },
            { name: "Calle", abbreviation: "Calle" },
            { name: "Campiello", abbreviation: "Cam." },
            { name: "Campo", abbreviation: "Cam." },
            { name: "Canale", abbreviation: "Can." },
            { name: "Carraia", abbreviation: "Carr." },
            { name: "Cascina", abbreviation: "Cascina" },
            { name: "Case sparse", abbreviation: "c.s." },
            { name: "Cavalcavia", abbreviation: "Cv." },
            { name: "Circonvallazione", abbreviation: "Cv." },
            { name: "Complanare", abbreviation: "C.re" },
            { name: "Contrada", abbreviation: "C.da" },
            { name: "Corso", abbreviation: "C.so" },
            { name: "Corte", abbreviation: "C.te" },
            { name: "Cortile", abbreviation: "C.le" },
            { name: "Diramazione", abbreviation: "Dir." },
            { name: "Fondaco", abbreviation: "F.co" },
            { name: "Fondamenta", abbreviation: "F.ta" },
            { name: "Fondo", abbreviation: "F.do" },
            { name: "Frazione", abbreviation: "Fr." },
            { name: "Isola", abbreviation: "Is." },
            { name: "Largo", abbreviation: "L.go" },
            { name: "Litoranea", abbreviation: "Lit." },
            { name: "Lungolago", abbreviation: "L.go lago" },
            { name: "Lungo Po", abbreviation: "l.go Po" },
            { name: "Molo", abbreviation: "Molo" },
            { name: "Mura", abbreviation: "Mura" },
            { name: "Passaggio privato", abbreviation: "pass. priv." },
            { name: "Passeggiata", abbreviation: "Pass." },
            { name: "Piazza", abbreviation: "P.zza" },
            { name: "Piazzale", abbreviation: "P.le" },
            { name: "Ponte", abbreviation: "P.te" },
            { name: "Portico", abbreviation: "P.co" },
            { name: "Rampa", abbreviation: "Rampa" },
            { name: "Regione", abbreviation: "Reg." },
            { name: "Rione", abbreviation: "R.ne" },
            { name: "Rio", abbreviation: "Rio" },
            { name: "Ripa", abbreviation: "Ripa" },
            { name: "Riva", abbreviation: "Riva" },
            { name: "Rondò", abbreviation: "Rondò" },
            { name: "Rotonda", abbreviation: "Rot." },
            { name: "Sagrato", abbreviation: "Sagr." },
            { name: "Salita", abbreviation: "Sal." },
            { name: "Scalinata", abbreviation: "Scal." },
            { name: "Scalone", abbreviation: "Scal." },
            { name: "Slargo", abbreviation: "Sl." },
            { name: "Sottoportico", abbreviation: "Sott." },
            { name: "Strada", abbreviation: "Str." },
            { name: "Stradale", abbreviation: "Str.le" },
            { name: "Strettoia", abbreviation: "Strett." },
            { name: "Traversa", abbreviation: "Trav." },
            { name: "Via", abbreviation: "V." },
            { name: "Viale", abbreviation: "V.le" },
            { name: "Vicinale", abbreviation: "Vic.le" },
            { name: "Vicolo", abbreviation: "Vic." }
          ],
          uk: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Close", abbreviation: "Cl" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Crescent", abbreviation: "Cr" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Garden", abbreviation: "Gdn" },
            { name: "Gardens", abbreviation: "Gdns" },
            { name: "Green", abbreviation: "Gn" },
            { name: "Grove", abbreviation: "Gr" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Mount", abbreviation: "Mt" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Park", abbreviation: "Pk" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Valley", abbreviation: "Val" }
          ]
        },
        months: [
          { name: "January", short_name: "Jan", numeric: "01", days: 31 },
          // Not messing with leap years...
          { name: "February", short_name: "Feb", numeric: "02", days: 28 },
          { name: "March", short_name: "Mar", numeric: "03", days: 31 },
          { name: "April", short_name: "Apr", numeric: "04", days: 30 },
          { name: "May", short_name: "May", numeric: "05", days: 31 },
          { name: "June", short_name: "Jun", numeric: "06", days: 30 },
          { name: "July", short_name: "Jul", numeric: "07", days: 31 },
          { name: "August", short_name: "Aug", numeric: "08", days: 31 },
          { name: "September", short_name: "Sep", numeric: "09", days: 30 },
          { name: "October", short_name: "Oct", numeric: "10", days: 31 },
          { name: "November", short_name: "Nov", numeric: "11", days: 30 },
          { name: "December", short_name: "Dec", numeric: "12", days: 31 }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
          { name: "American Express", short_name: "amex", prefix: "34", length: 15 },
          { name: "Bankcard", short_name: "bankcard", prefix: "5610", length: 16 },
          { name: "China UnionPay", short_name: "chinaunion", prefix: "62", length: 16 },
          { name: "Diners Club Carte Blanche", short_name: "dccarte", prefix: "300", length: 14 },
          { name: "Diners Club enRoute", short_name: "dcenroute", prefix: "2014", length: 15 },
          { name: "Diners Club International", short_name: "dcintl", prefix: "36", length: 14 },
          { name: "Diners Club United States & Canada", short_name: "dcusc", prefix: "54", length: 16 },
          { name: "Discover Card", short_name: "discover", prefix: "6011", length: 16 },
          { name: "InstaPayment", short_name: "instapay", prefix: "637", length: 16 },
          { name: "JCB", short_name: "jcb", prefix: "3528", length: 16 },
          { name: "Laser", short_name: "laser", prefix: "6304", length: 16 },
          { name: "Maestro", short_name: "maestro", prefix: "5018", length: 16 },
          { name: "Mastercard", short_name: "mc", prefix: "51", length: 16 },
          { name: "Solo", short_name: "solo", prefix: "6334", length: 16 },
          { name: "Switch", short_name: "switch", prefix: "4903", length: 16 },
          { name: "Visa", short_name: "visa", prefix: "4", length: 16 },
          { name: "Visa Electron", short_name: "electron", prefix: "4026", length: 16 }
        ],
        //return all world currency by ISO 4217
        currency_types: [
          { code: "AED", name: "United Arab Emirates Dirham" },
          { code: "AFN", name: "Afghanistan Afghani" },
          { code: "ALL", name: "Albania Lek" },
          { code: "AMD", name: "Armenia Dram" },
          { code: "ANG", name: "Netherlands Antilles Guilder" },
          { code: "AOA", name: "Angola Kwanza" },
          { code: "ARS", name: "Argentina Peso" },
          { code: "AUD", name: "Australia Dollar" },
          { code: "AWG", name: "Aruba Guilder" },
          { code: "AZN", name: "Azerbaijan New Manat" },
          { code: "BAM", name: "Bosnia and Herzegovina Convertible Marka" },
          { code: "BBD", name: "Barbados Dollar" },
          { code: "BDT", name: "Bangladesh Taka" },
          { code: "BGN", name: "Bulgaria Lev" },
          { code: "BHD", name: "Bahrain Dinar" },
          { code: "BIF", name: "Burundi Franc" },
          { code: "BMD", name: "Bermuda Dollar" },
          { code: "BND", name: "Brunei Darussalam Dollar" },
          { code: "BOB", name: "Bolivia Boliviano" },
          { code: "BRL", name: "Brazil Real" },
          { code: "BSD", name: "Bahamas Dollar" },
          { code: "BTN", name: "Bhutan Ngultrum" },
          { code: "BWP", name: "Botswana Pula" },
          { code: "BYR", name: "Belarus Ruble" },
          { code: "BZD", name: "Belize Dollar" },
          { code: "CAD", name: "Canada Dollar" },
          { code: "CDF", name: "Congo/Kinshasa Franc" },
          { code: "CHF", name: "Switzerland Franc" },
          { code: "CLP", name: "Chile Peso" },
          { code: "CNY", name: "China Yuan Renminbi" },
          { code: "COP", name: "Colombia Peso" },
          { code: "CRC", name: "Costa Rica Colon" },
          { code: "CUC", name: "Cuba Convertible Peso" },
          { code: "CUP", name: "Cuba Peso" },
          { code: "CVE", name: "Cape Verde Escudo" },
          { code: "CZK", name: "Czech Republic Koruna" },
          { code: "DJF", name: "Djibouti Franc" },
          { code: "DKK", name: "Denmark Krone" },
          { code: "DOP", name: "Dominican Republic Peso" },
          { code: "DZD", name: "Algeria Dinar" },
          { code: "EGP", name: "Egypt Pound" },
          { code: "ERN", name: "Eritrea Nakfa" },
          { code: "ETB", name: "Ethiopia Birr" },
          { code: "EUR", name: "Euro Member Countries" },
          { code: "FJD", name: "Fiji Dollar" },
          { code: "FKP", name: "Falkland Islands (Malvinas) Pound" },
          { code: "GBP", name: "United Kingdom Pound" },
          { code: "GEL", name: "Georgia Lari" },
          { code: "GGP", name: "Guernsey Pound" },
          { code: "GHS", name: "Ghana Cedi" },
          { code: "GIP", name: "Gibraltar Pound" },
          { code: "GMD", name: "Gambia Dalasi" },
          { code: "GNF", name: "Guinea Franc" },
          { code: "GTQ", name: "Guatemala Quetzal" },
          { code: "GYD", name: "Guyana Dollar" },
          { code: "HKD", name: "Hong Kong Dollar" },
          { code: "HNL", name: "Honduras Lempira" },
          { code: "HRK", name: "Croatia Kuna" },
          { code: "HTG", name: "Haiti Gourde" },
          { code: "HUF", name: "Hungary Forint" },
          { code: "IDR", name: "Indonesia Rupiah" },
          { code: "ILS", name: "Israel Shekel" },
          { code: "IMP", name: "Isle of Man Pound" },
          { code: "INR", name: "India Rupee" },
          { code: "IQD", name: "Iraq Dinar" },
          { code: "IRR", name: "Iran Rial" },
          { code: "ISK", name: "Iceland Krona" },
          { code: "JEP", name: "Jersey Pound" },
          { code: "JMD", name: "Jamaica Dollar" },
          { code: "JOD", name: "Jordan Dinar" },
          { code: "JPY", name: "Japan Yen" },
          { code: "KES", name: "Kenya Shilling" },
          { code: "KGS", name: "Kyrgyzstan Som" },
          { code: "KHR", name: "Cambodia Riel" },
          { code: "KMF", name: "Comoros Franc" },
          { code: "KPW", name: "Korea (North) Won" },
          { code: "KRW", name: "Korea (South) Won" },
          { code: "KWD", name: "Kuwait Dinar" },
          { code: "KYD", name: "Cayman Islands Dollar" },
          { code: "KZT", name: "Kazakhstan Tenge" },
          { code: "LAK", name: "Laos Kip" },
          { code: "LBP", name: "Lebanon Pound" },
          { code: "LKR", name: "Sri Lanka Rupee" },
          { code: "LRD", name: "Liberia Dollar" },
          { code: "LSL", name: "Lesotho Loti" },
          { code: "LTL", name: "Lithuania Litas" },
          { code: "LYD", name: "Libya Dinar" },
          { code: "MAD", name: "Morocco Dirham" },
          { code: "MDL", name: "Moldova Leu" },
          { code: "MGA", name: "Madagascar Ariary" },
          { code: "MKD", name: "Macedonia Denar" },
          { code: "MMK", name: "Myanmar (Burma) Kyat" },
          { code: "MNT", name: "Mongolia Tughrik" },
          { code: "MOP", name: "Macau Pataca" },
          { code: "MRO", name: "Mauritania Ouguiya" },
          { code: "MUR", name: "Mauritius Rupee" },
          { code: "MVR", name: "Maldives (Maldive Islands) Rufiyaa" },
          { code: "MWK", name: "Malawi Kwacha" },
          { code: "MXN", name: "Mexico Peso" },
          { code: "MYR", name: "Malaysia Ringgit" },
          { code: "MZN", name: "Mozambique Metical" },
          { code: "NAD", name: "Namibia Dollar" },
          { code: "NGN", name: "Nigeria Naira" },
          { code: "NIO", name: "Nicaragua Cordoba" },
          { code: "NOK", name: "Norway Krone" },
          { code: "NPR", name: "Nepal Rupee" },
          { code: "NZD", name: "New Zealand Dollar" },
          { code: "OMR", name: "Oman Rial" },
          { code: "PAB", name: "Panama Balboa" },
          { code: "PEN", name: "Peru Nuevo Sol" },
          { code: "PGK", name: "Papua New Guinea Kina" },
          { code: "PHP", name: "Philippines Peso" },
          { code: "PKR", name: "Pakistan Rupee" },
          { code: "PLN", name: "Poland Zloty" },
          { code: "PYG", name: "Paraguay Guarani" },
          { code: "QAR", name: "Qatar Riyal" },
          { code: "RON", name: "Romania New Leu" },
          { code: "RSD", name: "Serbia Dinar" },
          { code: "RUB", name: "Russia Ruble" },
          { code: "RWF", name: "Rwanda Franc" },
          { code: "SAR", name: "Saudi Arabia Riyal" },
          { code: "SBD", name: "Solomon Islands Dollar" },
          { code: "SCR", name: "Seychelles Rupee" },
          { code: "SDG", name: "Sudan Pound" },
          { code: "SEK", name: "Sweden Krona" },
          { code: "SGD", name: "Singapore Dollar" },
          { code: "SHP", name: "Saint Helena Pound" },
          { code: "SLL", name: "Sierra Leone Leone" },
          { code: "SOS", name: "Somalia Shilling" },
          { code: "SPL", name: "Seborga Luigino" },
          { code: "SRD", name: "Suriname Dollar" },
          { code: "STD", name: "São Tomé and Príncipe Dobra" },
          { code: "SVC", name: "El Salvador Colon" },
          { code: "SYP", name: "Syria Pound" },
          { code: "SZL", name: "Swaziland Lilangeni" },
          { code: "THB", name: "Thailand Baht" },
          { code: "TJS", name: "Tajikistan Somoni" },
          { code: "TMT", name: "Turkmenistan Manat" },
          { code: "TND", name: "Tunisia Dinar" },
          { code: "TOP", name: "Tonga Pa'anga" },
          { code: "TRY", name: "Turkey Lira" },
          { code: "TTD", name: "Trinidad and Tobago Dollar" },
          { code: "TVD", name: "Tuvalu Dollar" },
          { code: "TWD", name: "Taiwan New Dollar" },
          { code: "TZS", name: "Tanzania Shilling" },
          { code: "UAH", name: "Ukraine Hryvnia" },
          { code: "UGX", name: "Uganda Shilling" },
          { code: "USD", name: "United States Dollar" },
          { code: "UYU", name: "Uruguay Peso" },
          { code: "UZS", name: "Uzbekistan Som" },
          { code: "VEF", name: "Venezuela Bolivar" },
          { code: "VND", name: "Viet Nam Dong" },
          { code: "VUV", name: "Vanuatu Vatu" },
          { code: "WST", name: "Samoa Tala" },
          { code: "XAF", name: "Communauté Financière Africaine (BEAC) CFA Franc BEAC" },
          { code: "XCD", name: "East Caribbean Dollar" },
          { code: "XDR", name: "International Monetary Fund (IMF) Special Drawing Rights" },
          { code: "XOF", name: "Communauté Financière Africaine (BCEAO) Franc" },
          { code: "XPF", name: "Comptoirs Français du Pacifique (CFP) Franc" },
          { code: "YER", name: "Yemen Rial" },
          { code: "ZAR", name: "South Africa Rand" },
          { code: "ZMW", name: "Zambia Kwacha" },
          { code: "ZWD", name: "Zimbabwe Dollar" }
        ],
        // return the names of all valide colors
        colorNames: [
          "AliceBlue",
          "Black",
          "Navy",
          "DarkBlue",
          "MediumBlue",
          "Blue",
          "DarkGreen",
          "Green",
          "Teal",
          "DarkCyan",
          "DeepSkyBlue",
          "DarkTurquoise",
          "MediumSpringGreen",
          "Lime",
          "SpringGreen",
          "Aqua",
          "Cyan",
          "MidnightBlue",
          "DodgerBlue",
          "LightSeaGreen",
          "ForestGreen",
          "SeaGreen",
          "DarkSlateGray",
          "LimeGreen",
          "MediumSeaGreen",
          "Turquoise",
          "RoyalBlue",
          "SteelBlue",
          "DarkSlateBlue",
          "MediumTurquoise",
          "Indigo",
          "DarkOliveGreen",
          "CadetBlue",
          "CornflowerBlue",
          "RebeccaPurple",
          "MediumAquaMarine",
          "DimGray",
          "SlateBlue",
          "OliveDrab",
          "SlateGray",
          "LightSlateGray",
          "MediumSlateBlue",
          "LawnGreen",
          "Chartreuse",
          "Aquamarine",
          "Maroon",
          "Purple",
          "Olive",
          "Gray",
          "SkyBlue",
          "LightSkyBlue",
          "BlueViolet",
          "DarkRed",
          "DarkMagenta",
          "SaddleBrown",
          "Ivory",
          "White",
          "DarkSeaGreen",
          "LightGreen",
          "MediumPurple",
          "DarkViolet",
          "PaleGreen",
          "DarkOrchid",
          "YellowGreen",
          "Sienna",
          "Brown",
          "DarkGray",
          "LightBlue",
          "GreenYellow",
          "PaleTurquoise",
          "LightSteelBlue",
          "PowderBlue",
          "FireBrick",
          "DarkGoldenRod",
          "MediumOrchid",
          "RosyBrown",
          "DarkKhaki",
          "Silver",
          "MediumVioletRed",
          "IndianRed",
          "Peru",
          "Chocolate",
          "Tan",
          "LightGray",
          "Thistle",
          "Orchid",
          "GoldenRod",
          "PaleVioletRed",
          "Crimson",
          "Gainsboro",
          "Plum",
          "BurlyWood",
          "LightCyan",
          "Lavender",
          "DarkSalmon",
          "Violet",
          "PaleGoldenRod",
          "LightCoral",
          "Khaki",
          "AliceBlue",
          "HoneyDew",
          "Azure",
          "SandyBrown",
          "Wheat",
          "Beige",
          "WhiteSmoke",
          "MintCream",
          "GhostWhite",
          "Salmon",
          "AntiqueWhite",
          "Linen",
          "LightGoldenRodYellow",
          "OldLace",
          "Red",
          "Fuchsia",
          "Magenta",
          "DeepPink",
          "OrangeRed",
          "Tomato",
          "HotPink",
          "Coral",
          "DarkOrange",
          "LightSalmon",
          "Orange",
          "LightPink",
          "Pink",
          "Gold",
          "PeachPuff",
          "NavajoWhite",
          "Moccasin",
          "Bisque",
          "MistyRose",
          "BlanchedAlmond",
          "PapayaWhip",
          "LavenderBlush",
          "SeaShell",
          "Cornsilk",
          "LemonChiffon",
          "FloralWhite",
          "Snow",
          "Yellow",
          "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
          "3Com Corp",
          "3M Company",
          "A.G. Edwards Inc.",
          "Abbott Laboratories",
          "Abercrombie & Fitch Co.",
          "ABM Industries Incorporated",
          "Ace Hardware Corporation",
          "ACT Manufacturing Inc.",
          "Acterna Corp.",
          "Adams Resources & Energy, Inc.",
          "ADC Telecommunications, Inc.",
          "Adelphia Communications Corporation",
          "Administaff, Inc.",
          "Adobe Systems Incorporated",
          "Adolph Coors Company",
          "Advance Auto Parts, Inc.",
          "Advanced Micro Devices, Inc.",
          "AdvancePCS, Inc.",
          "Advantica Restaurant Group, Inc.",
          "The AES Corporation",
          "Aetna Inc.",
          "Affiliated Computer Services, Inc.",
          "AFLAC Incorporated",
          "AGCO Corporation",
          "Agilent Technologies, Inc.",
          "Agway Inc.",
          "Apartment Investment and Management Company",
          "Air Products and Chemicals, Inc.",
          "Airborne, Inc.",
          "Airgas, Inc.",
          "AK Steel Holding Corporation",
          "Alaska Air Group, Inc.",
          "Alberto-Culver Company",
          "Albertson's, Inc.",
          "Alcoa Inc.",
          "Alleghany Corporation",
          "Allegheny Energy, Inc.",
          "Allegheny Technologies Incorporated",
          "Allergan, Inc.",
          "ALLETE, Inc.",
          "Alliant Energy Corporation",
          "Allied Waste Industries, Inc.",
          "Allmerica Financial Corporation",
          "The Allstate Corporation",
          "ALLTEL Corporation",
          "The Alpine Group, Inc.",
          "Amazon.com, Inc.",
          "AMC Entertainment Inc.",
          "American Power Conversion Corporation",
          "Amerada Hess Corporation",
          "AMERCO",
          "Ameren Corporation",
          "America West Holdings Corporation",
          "American Axle & Manufacturing Holdings, Inc.",
          "American Eagle Outfitters, Inc.",
          "American Electric Power Company, Inc.",
          "American Express Company",
          "American Financial Group, Inc.",
          "American Greetings Corporation",
          "American International Group, Inc.",
          "American Standard Companies Inc.",
          "American Water Works Company, Inc.",
          "AmerisourceBergen Corporation",
          "Ames Department Stores, Inc.",
          "Amgen Inc.",
          "Amkor Technology, Inc.",
          "AMR Corporation",
          "AmSouth Bancorp.",
          "Amtran, Inc.",
          "Anadarko Petroleum Corporation",
          "Analog Devices, Inc.",
          "Anheuser-Busch Companies, Inc.",
          "Anixter International Inc.",
          "AnnTaylor Inc.",
          "Anthem, Inc.",
          "AOL Time Warner Inc.",
          "Aon Corporation",
          "Apache Corporation",
          "Apple Computer, Inc.",
          "Applera Corporation",
          "Applied Industrial Technologies, Inc.",
          "Applied Materials, Inc.",
          "Aquila, Inc.",
          "ARAMARK Corporation",
          "Arch Coal, Inc.",
          "Archer Daniels Midland Company",
          "Arkansas Best Corporation",
          "Armstrong Holdings, Inc.",
          "Arrow Electronics, Inc.",
          "ArvinMeritor, Inc.",
          "Ashland Inc.",
          "Astoria Financial Corporation",
          "AT&T Corp.",
          "Atmel Corporation",
          "Atmos Energy Corporation",
          "Audiovox Corporation",
          "Autoliv, Inc.",
          "Automatic Data Processing, Inc.",
          "AutoNation, Inc.",
          "AutoZone, Inc.",
          "Avaya Inc.",
          "Avery Dennison Corporation",
          "Avista Corporation",
          "Avnet, Inc.",
          "Avon Products, Inc.",
          "Baker Hughes Incorporated",
          "Ball Corporation",
          "Bank of America Corporation",
          "The Bank of New York Company, Inc.",
          "Bank One Corporation",
          "Banknorth Group, Inc.",
          "Banta Corporation",
          "Barnes & Noble, Inc.",
          "Bausch & Lomb Incorporated",
          "Baxter International Inc.",
          "BB&T Corporation",
          "The Bear Stearns Companies Inc.",
          "Beazer Homes USA, Inc.",
          "Beckman Coulter, Inc.",
          "Becton, Dickinson and Company",
          "Bed Bath & Beyond Inc.",
          "Belk, Inc.",
          "Bell Microproducts Inc.",
          "BellSouth Corporation",
          "Belo Corp.",
          "Bemis Company, Inc.",
          "Benchmark Electronics, Inc.",
          "Berkshire Hathaway Inc.",
          "Best Buy Co., Inc.",
          "Bethlehem Steel Corporation",
          "Beverly Enterprises, Inc.",
          "Big Lots, Inc.",
          "BJ Services Company",
          "BJ's Wholesale Club, Inc.",
          "The Black & Decker Corporation",
          "Black Hills Corporation",
          "BMC Software, Inc.",
          "The Boeing Company",
          "Boise Cascade Corporation",
          "Borders Group, Inc.",
          "BorgWarner Inc.",
          "Boston Scientific Corporation",
          "Bowater Incorporated",
          "Briggs & Stratton Corporation",
          "Brightpoint, Inc.",
          "Brinker International, Inc.",
          "Bristol-Myers Squibb Company",
          "Broadwing, Inc.",
          "Brown Shoe Company, Inc.",
          "Brown-Forman Corporation",
          "Brunswick Corporation",
          "Budget Group, Inc.",
          "Burlington Coat Factory Warehouse Corporation",
          "Burlington Industries, Inc.",
          "Burlington Northern Santa Fe Corporation",
          "Burlington Resources Inc.",
          "C. H. Robinson Worldwide Inc.",
          "Cablevision Systems Corp",
          "Cabot Corp",
          "Cadence Design Systems, Inc.",
          "Calpine Corp.",
          "Campbell Soup Co.",
          "Capital One Financial Corp.",
          "Cardinal Health Inc.",
          "Caremark Rx Inc.",
          "Carlisle Cos. Inc.",
          "Carpenter Technology Corp.",
          "Casey's General Stores Inc.",
          "Caterpillar Inc.",
          "CBRL Group Inc.",
          "CDI Corp.",
          "CDW Computer Centers Inc.",
          "CellStar Corp.",
          "Cendant Corp",
          "Cenex Harvest States Cooperatives",
          "Centex Corp.",
          "CenturyTel Inc.",
          "Ceridian Corp.",
          "CH2M Hill Cos. Ltd.",
          "Champion Enterprises Inc.",
          "Charles Schwab Corp.",
          "Charming Shoppes Inc.",
          "Charter Communications Inc.",
          "Charter One Financial Inc.",
          "ChevronTexaco Corp.",
          "Chiquita Brands International Inc.",
          "Chubb Corp",
          "Ciena Corp.",
          "Cigna Corp",
          "Cincinnati Financial Corp.",
          "Cinergy Corp.",
          "Cintas Corp.",
          "Circuit City Stores Inc.",
          "Cisco Systems Inc.",
          "Citigroup, Inc",
          "Citizens Communications Co.",
          "CKE Restaurants Inc.",
          "Clear Channel Communications Inc.",
          "The Clorox Co.",
          "CMGI Inc.",
          "CMS Energy Corp.",
          "CNF Inc.",
          "Coca-Cola Co.",
          "Coca-Cola Enterprises Inc.",
          "Colgate-Palmolive Co.",
          "Collins & Aikman Corp.",
          "Comcast Corp.",
          "Comdisco Inc.",
          "Comerica Inc.",
          "Comfort Systems USA Inc.",
          "Commercial Metals Co.",
          "Community Health Systems Inc.",
          "Compass Bancshares Inc",
          "Computer Associates International Inc.",
          "Computer Sciences Corp.",
          "Compuware Corp.",
          "Comverse Technology Inc.",
          "ConAgra Foods Inc.",
          "Concord EFS Inc.",
          "Conectiv, Inc",
          "Conoco Inc",
          "Conseco Inc.",
          "Consolidated Freightways Corp.",
          "Consolidated Edison Inc.",
          "Constellation Brands Inc.",
          "Constellation Emergy Group Inc.",
          "Continental Airlines Inc.",
          "Convergys Corp.",
          "Cooper Cameron Corp.",
          "Cooper Industries Ltd.",
          "Cooper Tire & Rubber Co.",
          "Corn Products International Inc.",
          "Corning Inc.",
          "Costco Wholesale Corp.",
          "Countrywide Credit Industries Inc.",
          "Coventry Health Care Inc.",
          "Cox Communications Inc.",
          "Crane Co.",
          "Crompton Corp.",
          "Crown Cork & Seal Co. Inc.",
          "CSK Auto Corp.",
          "CSX Corp.",
          "Cummins Inc.",
          "CVS Corp.",
          "Cytec Industries Inc.",
          "D&K Healthcare Resources, Inc.",
          "D.R. Horton Inc.",
          "Dana Corporation",
          "Danaher Corporation",
          "Darden Restaurants Inc.",
          "DaVita Inc.",
          "Dean Foods Company",
          "Deere & Company",
          "Del Monte Foods Co",
          "Dell Computer Corporation",
          "Delphi Corp.",
          "Delta Air Lines Inc.",
          "Deluxe Corporation",
          "Devon Energy Corporation",
          "Di Giorgio Corporation",
          "Dial Corporation",
          "Diebold Incorporated",
          "Dillard's Inc.",
          "DIMON Incorporated",
          "Dole Food Company, Inc.",
          "Dollar General Corporation",
          "Dollar Tree Stores, Inc.",
          "Dominion Resources, Inc.",
          "Domino's Pizza LLC",
          "Dover Corporation, Inc.",
          "Dow Chemical Company",
          "Dow Jones & Company, Inc.",
          "DPL Inc.",
          "DQE Inc.",
          "Dreyer's Grand Ice Cream, Inc.",
          "DST Systems, Inc.",
          "DTE Energy Co.",
          "E.I. Du Pont de Nemours and Company",
          "Duke Energy Corp",
          "Dun & Bradstreet Inc.",
          "DURA Automotive Systems Inc.",
          "DynCorp",
          "Dynegy Inc.",
          "E*Trade Group, Inc.",
          "E.W. Scripps Company",
          "Earthlink, Inc.",
          "Eastman Chemical Company",
          "Eastman Kodak Company",
          "Eaton Corporation",
          "Echostar Communications Corporation",
          "Ecolab Inc.",
          "Edison International",
          "EGL Inc.",
          "El Paso Corporation",
          "Electronic Arts Inc.",
          "Electronic Data Systems Corp.",
          "Eli Lilly and Company",
          "EMC Corporation",
          "Emcor Group Inc.",
          "Emerson Electric Co.",
          "Encompass Services Corporation",
          "Energizer Holdings Inc.",
          "Energy East Corporation",
          "Engelhard Corporation",
          "Enron Corp.",
          "Entergy Corporation",
          "Enterprise Products Partners L.P.",
          "EOG Resources, Inc.",
          "Equifax Inc.",
          "Equitable Resources Inc.",
          "Equity Office Properties Trust",
          "Equity Residential Properties Trust",
          "Estee Lauder Companies Inc.",
          "Exelon Corporation",
          "Exide Technologies",
          "Expeditors International of Washington Inc.",
          "Express Scripts Inc.",
          "ExxonMobil Corporation",
          "Fairchild Semiconductor International Inc.",
          "Family Dollar Stores Inc.",
          "Farmland Industries Inc.",
          "Federal Mogul Corp.",
          "Federated Department Stores Inc.",
          "Federal Express Corp.",
          "Felcor Lodging Trust Inc.",
          "Ferro Corp.",
          "Fidelity National Financial Inc.",
          "Fifth Third Bancorp",
          "First American Financial Corp.",
          "First Data Corp.",
          "First National of Nebraska Inc.",
          "First Tennessee National Corp.",
          "FirstEnergy Corp.",
          "Fiserv Inc.",
          "Fisher Scientific International Inc.",
          "FleetBoston Financial Co.",
          "Fleetwood Enterprises Inc.",
          "Fleming Companies Inc.",
          "Flowers Foods Inc.",
          "Flowserv Corp",
          "Fluor Corp",
          "FMC Corp",
          "Foamex International Inc",
          "Foot Locker Inc",
          "Footstar Inc.",
          "Ford Motor Co",
          "Forest Laboratories Inc.",
          "Fortune Brands Inc.",
          "Foster Wheeler Ltd.",
          "FPL Group Inc.",
          "Franklin Resources Inc.",
          "Freeport McMoran Copper & Gold Inc.",
          "Frontier Oil Corp",
          "Furniture Brands International Inc.",
          "Gannett Co., Inc.",
          "Gap Inc.",
          "Gateway Inc.",
          "GATX Corporation",
          "Gemstar-TV Guide International Inc.",
          "GenCorp Inc.",
          "General Cable Corporation",
          "General Dynamics Corporation",
          "General Electric Company",
          "General Mills Inc",
          "General Motors Corporation",
          "Genesis Health Ventures Inc.",
          "Gentek Inc.",
          "Gentiva Health Services Inc.",
          "Genuine Parts Company",
          "Genuity Inc.",
          "Genzyme Corporation",
          "Georgia Gulf Corporation",
          "Georgia-Pacific Corporation",
          "Gillette Company",
          "Gold Kist Inc.",
          "Golden State Bancorp Inc.",
          "Golden West Financial Corporation",
          "Goldman Sachs Group Inc.",
          "Goodrich Corporation",
          "The Goodyear Tire & Rubber Company",
          "Granite Construction Incorporated",
          "Graybar Electric Company Inc.",
          "Great Lakes Chemical Corporation",
          "Great Plains Energy Inc.",
          "GreenPoint Financial Corp.",
          "Greif Bros. Corporation",
          "Grey Global Group Inc.",
          "Group 1 Automotive Inc.",
          "Guidant Corporation",
          "H&R Block Inc.",
          "H.B. Fuller Company",
          "H.J. Heinz Company",
          "Halliburton Co.",
          "Harley-Davidson Inc.",
          "Harman International Industries Inc.",
          "Harrah's Entertainment Inc.",
          "Harris Corp.",
          "Harsco Corp.",
          "Hartford Financial Services Group Inc.",
          "Hasbro Inc.",
          "Hawaiian Electric Industries Inc.",
          "HCA Inc.",
          "Health Management Associates Inc.",
          "Health Net Inc.",
          "Healthsouth Corp",
          "Henry Schein Inc.",
          "Hercules Inc.",
          "Herman Miller Inc.",
          "Hershey Foods Corp.",
          "Hewlett-Packard Company",
          "Hibernia Corp.",
          "Hillenbrand Industries Inc.",
          "Hilton Hotels Corp.",
          "Hollywood Entertainment Corp.",
          "Home Depot Inc.",
          "Hon Industries Inc.",
          "Honeywell International Inc.",
          "Hormel Foods Corp.",
          "Host Marriott Corp.",
          "Household International Corp.",
          "Hovnanian Enterprises Inc.",
          "Hub Group Inc.",
          "Hubbell Inc.",
          "Hughes Supply Inc.",
          "Humana Inc.",
          "Huntington Bancshares Inc.",
          "Idacorp Inc.",
          "IDT Corporation",
          "IKON Office Solutions Inc.",
          "Illinois Tool Works Inc.",
          "IMC Global Inc.",
          "Imperial Sugar Company",
          "IMS Health Inc.",
          "Ingles Market Inc",
          "Ingram Micro Inc.",
          "Insight Enterprises Inc.",
          "Integrated Electrical Services Inc.",
          "Intel Corporation",
          "International Paper Co.",
          "Interpublic Group of Companies Inc.",
          "Interstate Bakeries Corporation",
          "International Business Machines Corp.",
          "International Flavors & Fragrances Inc.",
          "International Multifoods Corporation",
          "Intuit Inc.",
          "IT Group Inc.",
          "ITT Industries Inc.",
          "Ivax Corp.",
          "J.B. Hunt Transport Services Inc.",
          "J.C. Penny Co.",
          "J.P. Morgan Chase & Co.",
          "Jabil Circuit Inc.",
          "Jack In The Box Inc.",
          "Jacobs Engineering Group Inc.",
          "JDS Uniphase Corp.",
          "Jefferson-Pilot Co.",
          "John Hancock Financial Services Inc.",
          "Johnson & Johnson",
          "Johnson Controls Inc.",
          "Jones Apparel Group Inc.",
          "KB Home",
          "Kellogg Company",
          "Kellwood Company",
          "Kelly Services Inc.",
          "Kemet Corp.",
          "Kennametal Inc.",
          "Kerr-McGee Corporation",
          "KeyCorp",
          "KeySpan Corp.",
          "Kimball International Inc.",
          "Kimberly-Clark Corporation",
          "Kindred Healthcare Inc.",
          "KLA-Tencor Corporation",
          "K-Mart Corp.",
          "Knight-Ridder Inc.",
          "Kohl's Corp.",
          "KPMG Consulting Inc.",
          "Kroger Co.",
          "L-3 Communications Holdings Inc.",
          "Laboratory Corporation of America Holdings",
          "Lam Research Corporation",
          "LandAmerica Financial Group Inc.",
          "Lands' End Inc.",
          "Landstar System Inc.",
          "La-Z-Boy Inc.",
          "Lear Corporation",
          "Legg Mason Inc.",
          "Leggett & Platt Inc.",
          "Lehman Brothers Holdings Inc.",
          "Lennar Corporation",
          "Lennox International Inc.",
          "Level 3 Communications Inc.",
          "Levi Strauss & Co.",
          "Lexmark International Inc.",
          "Limited Inc.",
          "Lincoln National Corporation",
          "Linens 'n Things Inc.",
          "Lithia Motors Inc.",
          "Liz Claiborne Inc.",
          "Lockheed Martin Corporation",
          "Loews Corporation",
          "Longs Drug Stores Corporation",
          "Louisiana-Pacific Corporation",
          "Lowe's Companies Inc.",
          "LSI Logic Corporation",
          "The LTV Corporation",
          "The Lubrizol Corporation",
          "Lucent Technologies Inc.",
          "Lyondell Chemical Company",
          "M & T Bank Corporation",
          "Magellan Health Services Inc.",
          "Mail-Well Inc.",
          "Mandalay Resort Group",
          "Manor Care Inc.",
          "Manpower Inc.",
          "Marathon Oil Corporation",
          "Mariner Health Care Inc.",
          "Markel Corporation",
          "Marriott International Inc.",
          "Marsh & McLennan Companies Inc.",
          "Marsh Supermarkets Inc.",
          "Marshall & Ilsley Corporation",
          "Martin Marietta Materials Inc.",
          "Masco Corporation",
          "Massey Energy Company",
          "MasTec Inc.",
          "Mattel Inc.",
          "Maxim Integrated Products Inc.",
          "Maxtor Corporation",
          "Maxxam Inc.",
          "The May Department Stores Company",
          "Maytag Corporation",
          "MBNA Corporation",
          "McCormick & Company Incorporated",
          "McDonald's Corporation",
          "The McGraw-Hill Companies Inc.",
          "McKesson Corporation",
          "McLeodUSA Incorporated",
          "M.D.C. Holdings Inc.",
          "MDU Resources Group Inc.",
          "MeadWestvaco Corporation",
          "Medtronic Inc.",
          "Mellon Financial Corporation",
          "The Men's Wearhouse Inc.",
          "Merck & Co., Inc.",
          "Mercury General Corporation",
          "Merrill Lynch & Co. Inc.",
          "Metaldyne Corporation",
          "Metals USA Inc.",
          "MetLife Inc.",
          "Metris Companies Inc",
          "MGIC Investment Corporation",
          "MGM Mirage",
          "Michaels Stores Inc.",
          "Micron Technology Inc.",
          "Microsoft Corporation",
          "Milacron Inc.",
          "Millennium Chemicals Inc.",
          "Mirant Corporation",
          "Mohawk Industries Inc.",
          "Molex Incorporated",
          "The MONY Group Inc.",
          "Morgan Stanley Dean Witter & Co.",
          "Motorola Inc.",
          "MPS Group Inc.",
          "Murphy Oil Corporation",
          "Nabors Industries Inc",
          "Nacco Industries Inc",
          "Nash Finch Company",
          "National City Corp.",
          "National Commerce Financial Corporation",
          "National Fuel Gas Company",
          "National Oilwell Inc",
          "National Rural Utilities Cooperative Finance Corporation",
          "National Semiconductor Corporation",
          "National Service Industries Inc",
          "Navistar International Corporation",
          "NCR Corporation",
          "The Neiman Marcus Group Inc.",
          "New Jersey Resources Corporation",
          "New York Times Company",
          "Newell Rubbermaid Inc",
          "Newmont Mining Corporation",
          "Nextel Communications Inc",
          "Nicor Inc",
          "Nike Inc",
          "NiSource Inc",
          "Noble Energy Inc",
          "Nordstrom Inc",
          "Norfolk Southern Corporation",
          "Nortek Inc",
          "North Fork Bancorporation Inc",
          "Northeast Utilities System",
          "Northern Trust Corporation",
          "Northrop Grumman Corporation",
          "NorthWestern Corporation",
          "Novellus Systems Inc",
          "NSTAR",
          "NTL Incorporated",
          "Nucor Corp",
          "Nvidia Corp",
          "NVR Inc",
          "Northwest Airlines Corp",
          "Occidental Petroleum Corp",
          "Ocean Energy Inc",
          "Office Depot Inc.",
          "OfficeMax Inc",
          "OGE Energy Corp",
          "Oglethorpe Power Corp.",
          "Ohio Casualty Corp.",
          "Old Republic International Corp.",
          "Olin Corp.",
          "OM Group Inc",
          "Omnicare Inc",
          "Omnicom Group",
          "On Semiconductor Corp",
          "ONEOK Inc",
          "Oracle Corp",
          "Oshkosh Truck Corp",
          "Outback Steakhouse Inc.",
          "Owens & Minor Inc.",
          "Owens Corning",
          "Owens-Illinois Inc",
          "Oxford Health Plans Inc",
          "Paccar Inc",
          "PacifiCare Health Systems Inc",
          "Packaging Corp. of America",
          "Pactiv Corp",
          "Pall Corp",
          "Pantry Inc",
          "Park Place Entertainment Corp",
          "Parker Hannifin Corp.",
          "Pathmark Stores Inc.",
          "Paychex Inc",
          "Payless Shoesource Inc",
          "Penn Traffic Co.",
          "Pennzoil-Quaker State Company",
          "Pentair Inc",
          "Peoples Energy Corp.",
          "PeopleSoft Inc",
          "Pep Boys Manny, Moe & Jack",
          "Potomac Electric Power Co.",
          "Pepsi Bottling Group Inc.",
          "PepsiAmericas Inc.",
          "PepsiCo Inc.",
          "Performance Food Group Co.",
          "Perini Corp",
          "PerkinElmer Inc",
          "Perot Systems Corp",
          "Petco Animal Supplies Inc.",
          "Peter Kiewit Sons', Inc.",
          "PETsMART Inc",
          "Pfizer Inc",
          "Pacific Gas & Electric Corp.",
          "Pharmacia Corp",
          "Phar Mor Inc.",
          "Phelps Dodge Corp.",
          "Philip Morris Companies Inc.",
          "Phillips Petroleum Co",
          "Phillips Van Heusen Corp.",
          "Phoenix Companies Inc",
          "Pier 1 Imports Inc.",
          "Pilgrim's Pride Corporation",
          "Pinnacle West Capital Corp",
          "Pioneer-Standard Electronics Inc.",
          "Pitney Bowes Inc.",
          "Pittston Brinks Group",
          "Plains All American Pipeline LP",
          "PNC Financial Services Group Inc.",
          "PNM Resources Inc",
          "Polaris Industries Inc.",
          "Polo Ralph Lauren Corp",
          "PolyOne Corp",
          "Popular Inc",
          "Potlatch Corp",
          "PPG Industries Inc",
          "PPL Corp",
          "Praxair Inc",
          "Precision Castparts Corp",
          "Premcor Inc.",
          "Pride International Inc",
          "Primedia Inc",
          "Principal Financial Group Inc.",
          "Procter & Gamble Co.",
          "Pro-Fac Cooperative Inc.",
          "Progress Energy Inc",
          "Progressive Corporation",
          "Protective Life Corp",
          "Provident Financial Group",
          "Providian Financial Corp.",
          "Prudential Financial Inc.",
          "PSS World Medical Inc",
          "Public Service Enterprise Group Inc.",
          "Publix Super Markets Inc.",
          "Puget Energy Inc.",
          "Pulte Homes Inc",
          "Qualcomm Inc",
          "Quanta Services Inc.",
          "Quantum Corp",
          "Quest Diagnostics Inc.",
          "Questar Corp",
          "Quintiles Transnational",
          "Qwest Communications Intl Inc",
          "R.J. Reynolds Tobacco Company",
          "R.R. Donnelley & Sons Company",
          "Radio Shack Corporation",
          "Raymond James Financial Inc.",
          "Raytheon Company",
          "Reader's Digest Association Inc.",
          "Reebok International Ltd.",
          "Regions Financial Corp.",
          "Regis Corporation",
          "Reliance Steel & Aluminum Co.",
          "Reliant Energy Inc.",
          "Rent A Center Inc",
          "Republic Services Inc",
          "Revlon Inc",
          "RGS Energy Group Inc",
          "Rite Aid Corp",
          "Riverwood Holding Inc.",
          "RoadwayCorp",
          "Robert Half International Inc.",
          "Rock-Tenn Co",
          "Rockwell Automation Inc",
          "Rockwell Collins Inc",
          "Rohm & Haas Co.",
          "Ross Stores Inc",
          "RPM Inc.",
          "Ruddick Corp",
          "Ryder System Inc",
          "Ryerson Tull Inc",
          "Ryland Group Inc.",
          "Sabre Holdings Corp",
          "Safeco Corp",
          "Safeguard Scientifics Inc.",
          "Safeway Inc",
          "Saks Inc",
          "Sanmina-SCI Inc",
          "Sara Lee Corp",
          "SBC Communications Inc",
          "Scana Corp.",
          "Schering-Plough Corp",
          "Scholastic Corp",
          "SCI Systems Onc.",
          "Science Applications Intl. Inc.",
          "Scientific-Atlanta Inc",
          "Scotts Company",
          "Seaboard Corp",
          "Sealed Air Corp",
          "Sears Roebuck & Co",
          "Sempra Energy",
          "Sequa Corp",
          "Service Corp. International",
          "ServiceMaster Co",
          "Shaw Group Inc",
          "Sherwin-Williams Company",
          "Shopko Stores Inc",
          "Siebel Systems Inc",
          "Sierra Health Services Inc",
          "Sierra Pacific Resources",
          "Silgan Holdings Inc.",
          "Silicon Graphics Inc",
          "Simon Property Group Inc",
          "SLM Corporation",
          "Smith International Inc",
          "Smithfield Foods Inc",
          "Smurfit-Stone Container Corp",
          "Snap-On Inc",
          "Solectron Corp",
          "Solutia Inc",
          "Sonic Automotive Inc.",
          "Sonoco Products Co.",
          "Southern Company",
          "Southern Union Company",
          "SouthTrust Corp.",
          "Southwest Airlines Co",
          "Southwest Gas Corp",
          "Sovereign Bancorp Inc.",
          "Spartan Stores Inc",
          "Spherion Corp",
          "Sports Authority Inc",
          "Sprint Corp.",
          "SPX Corp",
          "St. Jude Medical Inc",
          "St. Paul Cos.",
          "Staff Leasing Inc.",
          "StanCorp Financial Group Inc",
          "Standard Pacific Corp.",
          "Stanley Works",
          "Staples Inc",
          "Starbucks Corp",
          "Starwood Hotels & Resorts Worldwide Inc",
          "State Street Corp.",
          "Stater Bros. Holdings Inc.",
          "Steelcase Inc",
          "Stein Mart Inc",
          "Stewart & Stevenson Services Inc",
          "Stewart Information Services Corp",
          "Stilwell Financial Inc",
          "Storage Technology Corporation",
          "Stryker Corp",
          "Sun Healthcare Group Inc.",
          "Sun Microsystems Inc.",
          "SunGard Data Systems Inc.",
          "Sunoco Inc.",
          "SunTrust Banks Inc",
          "Supervalu Inc",
          "Swift Transportation, Co., Inc",
          "Symbol Technologies Inc",
          "Synovus Financial Corp.",
          "Sysco Corp",
          "Systemax Inc.",
          "Target Corp.",
          "Tech Data Corporation",
          "TECO Energy Inc",
          "Tecumseh Products Company",
          "Tektronix Inc",
          "Teleflex Incorporated",
          "Telephone & Data Systems Inc",
          "Tellabs Inc.",
          "Temple-Inland Inc",
          "Tenet Healthcare Corporation",
          "Tenneco Automotive Inc.",
          "Teradyne Inc",
          "Terex Corp",
          "Tesoro Petroleum Corp.",
          "Texas Industries Inc.",
          "Texas Instruments Incorporated",
          "Textron Inc",
          "Thermo Electron Corporation",
          "Thomas & Betts Corporation",
          "Tiffany & Co",
          "Timken Company",
          "TJX Companies Inc",
          "TMP Worldwide Inc",
          "Toll Brothers Inc",
          "Torchmark Corporation",
          "Toro Company",
          "Tower Automotive Inc.",
          "Toys 'R' Us Inc",
          "Trans World Entertainment Corp.",
          "TransMontaigne Inc",
          "Transocean Inc",
          "TravelCenters of America Inc.",
          "Triad Hospitals Inc",
          "Tribune Company",
          "Trigon Healthcare Inc.",
          "Trinity Industries Inc",
          "Trump Hotels & Casino Resorts Inc.",
          "TruServ Corporation",
          "TRW Inc",
          "TXU Corp",
          "Tyson Foods Inc",
          "U.S. Bancorp",
          "U.S. Industries Inc.",
          "UAL Corporation",
          "UGI Corporation",
          "Unified Western Grocers Inc",
          "Union Pacific Corporation",
          "Union Planters Corp",
          "Unisource Energy Corp",
          "Unisys Corporation",
          "United Auto Group Inc",
          "United Defense Industries Inc.",
          "United Parcel Service Inc",
          "United Rentals Inc",
          "United Stationers Inc",
          "United Technologies Corporation",
          "UnitedHealth Group Incorporated",
          "Unitrin Inc",
          "Universal Corporation",
          "Universal Forest Products Inc",
          "Universal Health Services Inc",
          "Unocal Corporation",
          "Unova Inc",
          "UnumProvident Corporation",
          "URS Corporation",
          "US Airways Group Inc",
          "US Oncology Inc",
          "USA Interactive",
          "USFreighways Corporation",
          "USG Corporation",
          "UST Inc",
          "Valero Energy Corporation",
          "Valspar Corporation",
          "Value City Department Stores Inc",
          "Varco International Inc",
          "Vectren Corporation",
          "Veritas Software Corporation",
          "Verizon Communications Inc",
          "VF Corporation",
          "Viacom Inc",
          "Viad Corp",
          "Viasystems Group Inc",
          "Vishay Intertechnology Inc",
          "Visteon Corporation",
          "Volt Information Sciences Inc",
          "Vulcan Materials Company",
          "W.R. Berkley Corporation",
          "W.R. Grace & Co",
          "W.W. Grainger Inc",
          "Wachovia Corporation",
          "Wakenhut Corporation",
          "Walgreen Co",
          "Wallace Computer Services Inc",
          "Wal-Mart Stores Inc",
          "Walt Disney Co",
          "Walter Industries Inc",
          "Washington Mutual Inc",
          "Washington Post Co.",
          "Waste Management Inc",
          "Watsco Inc",
          "Weatherford International Inc",
          "Weis Markets Inc.",
          "Wellpoint Health Networks Inc",
          "Wells Fargo & Company",
          "Wendy's International Inc",
          "Werner Enterprises Inc",
          "WESCO International Inc",
          "Western Digital Inc",
          "Western Gas Resources Inc",
          "WestPoint Stevens Inc",
          "Weyerhauser Company",
          "WGL Holdings Inc",
          "Whirlpool Corporation",
          "Whole Foods Market Inc",
          "Willamette Industries Inc.",
          "Williams Companies Inc",
          "Williams Sonoma Inc",
          "Winn Dixie Stores Inc",
          "Wisconsin Energy Corporation",
          "Wm Wrigley Jr Company",
          "World Fuel Services Corporation",
          "WorldCom Inc",
          "Worthington Industries Inc",
          "WPS Resources Corporation",
          "Wyeth",
          "Wyndham International Inc",
          "Xcel Energy Inc",
          "Xerox Corp",
          "Xilinx Inc",
          "XO Communications Inc",
          "Yellow Corporation",
          "York International Corp",
          "Yum Brands Inc.",
          "Zale Corporation",
          "Zions Bancorporation"
        ],
        fileExtension: {
          raster: ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
          vector: ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
          "3d": ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
          document: ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
          {
            name: "Dateline Standard Time",
            abbr: "DST",
            offset: -12,
            isdst: !1,
            text: "(UTC-12:00) International Date Line West",
            utc: [
              "Etc/GMT+12"
            ]
          },
          {
            name: "UTC-11",
            abbr: "U",
            offset: -11,
            isdst: !1,
            text: "(UTC-11:00) Coordinated Universal Time-11",
            utc: [
              "Etc/GMT+11",
              "Pacific/Midway",
              "Pacific/Niue",
              "Pacific/Pago_Pago"
            ]
          },
          {
            name: "Hawaiian Standard Time",
            abbr: "HST",
            offset: -10,
            isdst: !1,
            text: "(UTC-10:00) Hawaii",
            utc: [
              "Etc/GMT+10",
              "Pacific/Honolulu",
              "Pacific/Johnston",
              "Pacific/Rarotonga",
              "Pacific/Tahiti"
            ]
          },
          {
            name: "Alaskan Standard Time",
            abbr: "AKDT",
            offset: -8,
            isdst: !0,
            text: "(UTC-09:00) Alaska",
            utc: [
              "America/Anchorage",
              "America/Juneau",
              "America/Nome",
              "America/Sitka",
              "America/Yakutat"
            ]
          },
          {
            name: "Pacific Standard Time (Mexico)",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-08:00) Baja California",
            utc: [
              "America/Santa_Isabel"
            ]
          },
          {
            name: "Pacific Daylight Time",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-07:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse"
            ]
          },
          {
            name: "Pacific Standard Time",
            abbr: "PST",
            offset: -8,
            isdst: !1,
            text: "(UTC-08:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse",
              "PST8PDT"
            ]
          },
          {
            name: "US Mountain Standard Time",
            abbr: "UMST",
            offset: -7,
            isdst: !1,
            text: "(UTC-07:00) Arizona",
            utc: [
              "America/Creston",
              "America/Dawson_Creek",
              "America/Hermosillo",
              "America/Phoenix",
              "Etc/GMT+7"
            ]
          },
          {
            name: "Mountain Standard Time (Mexico)",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
            utc: [
              "America/Chihuahua",
              "America/Mazatlan"
            ]
          },
          {
            name: "Mountain Standard Time",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Mountain Time (US & Canada)",
            utc: [
              "America/Boise",
              "America/Cambridge_Bay",
              "America/Denver",
              "America/Edmonton",
              "America/Inuvik",
              "America/Ojinaga",
              "America/Yellowknife",
              "MST7MDT"
            ]
          },
          {
            name: "Central America Standard Time",
            abbr: "CAST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Central America",
            utc: [
              "America/Belize",
              "America/Costa_Rica",
              "America/El_Salvador",
              "America/Guatemala",
              "America/Managua",
              "America/Tegucigalpa",
              "Etc/GMT+6",
              "Pacific/Galapagos"
            ]
          },
          {
            name: "Central Standard Time",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Central Time (US & Canada)",
            utc: [
              "America/Chicago",
              "America/Indiana/Knox",
              "America/Indiana/Tell_City",
              "America/Matamoros",
              "America/Menominee",
              "America/North_Dakota/Beulah",
              "America/North_Dakota/Center",
              "America/North_Dakota/New_Salem",
              "America/Rainy_River",
              "America/Rankin_Inlet",
              "America/Resolute",
              "America/Winnipeg",
              "CST6CDT"
            ]
          },
          {
            name: "Central Standard Time (Mexico)",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
            utc: [
              "America/Bahia_Banderas",
              "America/Cancun",
              "America/Merida",
              "America/Mexico_City",
              "America/Monterrey"
            ]
          },
          {
            name: "Canada Central Standard Time",
            abbr: "CCST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Saskatchewan",
            utc: [
              "America/Regina",
              "America/Swift_Current"
            ]
          },
          {
            name: "SA Pacific Standard Time",
            abbr: "SPST",
            offset: -5,
            isdst: !1,
            text: "(UTC-05:00) Bogota, Lima, Quito",
            utc: [
              "America/Bogota",
              "America/Cayman",
              "America/Coral_Harbour",
              "America/Eirunepe",
              "America/Guayaquil",
              "America/Jamaica",
              "America/Lima",
              "America/Panama",
              "America/Rio_Branco",
              "Etc/GMT+5"
            ]
          },
          {
            name: "Eastern Standard Time",
            abbr: "EDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Eastern Time (US & Canada)",
            utc: [
              "America/Detroit",
              "America/Havana",
              "America/Indiana/Petersburg",
              "America/Indiana/Vincennes",
              "America/Indiana/Winamac",
              "America/Iqaluit",
              "America/Kentucky/Monticello",
              "America/Louisville",
              "America/Montreal",
              "America/Nassau",
              "America/New_York",
              "America/Nipigon",
              "America/Pangnirtung",
              "America/Port-au-Prince",
              "America/Thunder_Bay",
              "America/Toronto",
              "EST5EDT"
            ]
          },
          {
            name: "US Eastern Standard Time",
            abbr: "UEDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Indiana (East)",
            utc: [
              "America/Indiana/Marengo",
              "America/Indiana/Vevay",
              "America/Indianapolis"
            ]
          },
          {
            name: "Venezuela Standard Time",
            abbr: "VST",
            offset: -4.5,
            isdst: !1,
            text: "(UTC-04:30) Caracas",
            utc: [
              "America/Caracas"
            ]
          },
          {
            name: "Paraguay Standard Time",
            abbr: "PYT",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Asuncion",
            utc: [
              "America/Asuncion"
            ]
          },
          {
            name: "Atlantic Standard Time",
            abbr: "ADT",
            offset: -3,
            isdst: !0,
            text: "(UTC-04:00) Atlantic Time (Canada)",
            utc: [
              "America/Glace_Bay",
              "America/Goose_Bay",
              "America/Halifax",
              "America/Moncton",
              "America/Thule",
              "Atlantic/Bermuda"
            ]
          },
          {
            name: "Central Brazilian Standard Time",
            abbr: "CBST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Cuiaba",
            utc: [
              "America/Campo_Grande",
              "America/Cuiaba"
            ]
          },
          {
            name: "SA Western Standard Time",
            abbr: "SWST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
            utc: [
              "America/Anguilla",
              "America/Antigua",
              "America/Aruba",
              "America/Barbados",
              "America/Blanc-Sablon",
              "America/Boa_Vista",
              "America/Curacao",
              "America/Dominica",
              "America/Grand_Turk",
              "America/Grenada",
              "America/Guadeloupe",
              "America/Guyana",
              "America/Kralendijk",
              "America/La_Paz",
              "America/Lower_Princes",
              "America/Manaus",
              "America/Marigot",
              "America/Martinique",
              "America/Montserrat",
              "America/Port_of_Spain",
              "America/Porto_Velho",
              "America/Puerto_Rico",
              "America/Santo_Domingo",
              "America/St_Barthelemy",
              "America/St_Kitts",
              "America/St_Lucia",
              "America/St_Thomas",
              "America/St_Vincent",
              "America/Tortola",
              "Etc/GMT+4"
            ]
          },
          {
            name: "Pacific SA Standard Time",
            abbr: "PSST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Santiago",
            utc: [
              "America/Santiago",
              "Antarctica/Palmer"
            ]
          },
          {
            name: "Newfoundland Standard Time",
            abbr: "NDT",
            offset: -2.5,
            isdst: !0,
            text: "(UTC-03:30) Newfoundland",
            utc: [
              "America/St_Johns"
            ]
          },
          {
            name: "E. South America Standard Time",
            abbr: "ESAST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Brasilia",
            utc: [
              "America/Sao_Paulo"
            ]
          },
          {
            name: "Argentina Standard Time",
            abbr: "AST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Buenos Aires",
            utc: [
              "America/Argentina/La_Rioja",
              "America/Argentina/Rio_Gallegos",
              "America/Argentina/Salta",
              "America/Argentina/San_Juan",
              "America/Argentina/San_Luis",
              "America/Argentina/Tucuman",
              "America/Argentina/Ushuaia",
              "America/Buenos_Aires",
              "America/Catamarca",
              "America/Cordoba",
              "America/Jujuy",
              "America/Mendoza"
            ]
          },
          {
            name: "SA Eastern Standard Time",
            abbr: "SEST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Cayenne, Fortaleza",
            utc: [
              "America/Araguaina",
              "America/Belem",
              "America/Cayenne",
              "America/Fortaleza",
              "America/Maceio",
              "America/Paramaribo",
              "America/Recife",
              "America/Santarem",
              "Antarctica/Rothera",
              "Atlantic/Stanley",
              "Etc/GMT+3"
            ]
          },
          {
            name: "Greenland Standard Time",
            abbr: "GDT",
            offset: -3,
            isdst: !0,
            text: "(UTC-03:00) Greenland",
            utc: [
              "America/Godthab"
            ]
          },
          {
            name: "Montevideo Standard Time",
            abbr: "MST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Montevideo",
            utc: [
              "America/Montevideo"
            ]
          },
          {
            name: "Bahia Standard Time",
            abbr: "BST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Salvador",
            utc: [
              "America/Bahia"
            ]
          },
          {
            name: "UTC-02",
            abbr: "U",
            offset: -2,
            isdst: !1,
            text: "(UTC-02:00) Coordinated Universal Time-02",
            utc: [
              "America/Noronha",
              "Atlantic/South_Georgia",
              "Etc/GMT+2"
            ]
          },
          {
            name: "Mid-Atlantic Standard Time",
            abbr: "MDT",
            offset: -1,
            isdst: !0,
            text: "(UTC-02:00) Mid-Atlantic - Old",
            utc: []
          },
          {
            name: "Azores Standard Time",
            abbr: "ADT",
            offset: 0,
            isdst: !0,
            text: "(UTC-01:00) Azores",
            utc: [
              "America/Scoresbysund",
              "Atlantic/Azores"
            ]
          },
          {
            name: "Cape Verde Standard Time",
            abbr: "CVST",
            offset: -1,
            isdst: !1,
            text: "(UTC-01:00) Cape Verde Is.",
            utc: [
              "Atlantic/Cape_Verde",
              "Etc/GMT+1"
            ]
          },
          {
            name: "Morocco Standard Time",
            abbr: "MDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Casablanca",
            utc: [
              "Africa/Casablanca",
              "Africa/El_Aaiun"
            ]
          },
          {
            name: "UTC",
            abbr: "UTC",
            offset: 0,
            isdst: !1,
            text: "(UTC) Coordinated Universal Time",
            utc: [
              "America/Danmarkshavn",
              "Etc/GMT"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GMT",
            offset: 0,
            isdst: !1,
            text: "(UTC) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "British Summer Time",
            abbr: "BST",
            offset: 1,
            isdst: !0,
            text: "(UTC+01:00) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Dublin, Lisbon",
            utc: [
              "Atlantic/Canary",
              "Atlantic/Faeroe",
              "Atlantic/Madeira",
              "Europe/Dublin",
              "Europe/Lisbon"
            ]
          },
          {
            name: "Greenwich Standard Time",
            abbr: "GST",
            offset: 0,
            isdst: !1,
            text: "(UTC) Monrovia, Reykjavik",
            utc: [
              "Africa/Abidjan",
              "Africa/Accra",
              "Africa/Bamako",
              "Africa/Banjul",
              "Africa/Bissau",
              "Africa/Conakry",
              "Africa/Dakar",
              "Africa/Freetown",
              "Africa/Lome",
              "Africa/Monrovia",
              "Africa/Nouakchott",
              "Africa/Ouagadougou",
              "Africa/Sao_Tome",
              "Atlantic/Reykjavik",
              "Atlantic/St_Helena"
            ]
          },
          {
            name: "W. Europe Standard Time",
            abbr: "WEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            utc: [
              "Arctic/Longyearbyen",
              "Europe/Amsterdam",
              "Europe/Andorra",
              "Europe/Berlin",
              "Europe/Busingen",
              "Europe/Gibraltar",
              "Europe/Luxembourg",
              "Europe/Malta",
              "Europe/Monaco",
              "Europe/Oslo",
              "Europe/Rome",
              "Europe/San_Marino",
              "Europe/Stockholm",
              "Europe/Vaduz",
              "Europe/Vatican",
              "Europe/Vienna",
              "Europe/Zurich"
            ]
          },
          {
            name: "Central Europe Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            utc: [
              "Europe/Belgrade",
              "Europe/Bratislava",
              "Europe/Budapest",
              "Europe/Ljubljana",
              "Europe/Podgorica",
              "Europe/Prague",
              "Europe/Tirane"
            ]
          },
          {
            name: "Romance Standard Time",
            abbr: "RDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
            utc: [
              "Africa/Ceuta",
              "Europe/Brussels",
              "Europe/Copenhagen",
              "Europe/Madrid",
              "Europe/Paris"
            ]
          },
          {
            name: "Central European Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            utc: [
              "Europe/Sarajevo",
              "Europe/Skopje",
              "Europe/Warsaw",
              "Europe/Zagreb"
            ]
          },
          {
            name: "W. Central Africa Standard Time",
            abbr: "WCAST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) West Central Africa",
            utc: [
              "Africa/Algiers",
              "Africa/Bangui",
              "Africa/Brazzaville",
              "Africa/Douala",
              "Africa/Kinshasa",
              "Africa/Lagos",
              "Africa/Libreville",
              "Africa/Luanda",
              "Africa/Malabo",
              "Africa/Ndjamena",
              "Africa/Niamey",
              "Africa/Porto-Novo",
              "Africa/Tunis",
              "Etc/GMT-1"
            ]
          },
          {
            name: "Namibia Standard Time",
            abbr: "NST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) Windhoek",
            utc: [
              "Africa/Windhoek"
            ]
          },
          {
            name: "GTB Standard Time",
            abbr: "GDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Athens, Bucharest",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau"
            ]
          },
          {
            name: "Middle East Standard Time",
            abbr: "MEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Beirut",
            utc: [
              "Asia/Beirut"
            ]
          },
          {
            name: "Egypt Standard Time",
            abbr: "EST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Cairo",
            utc: [
              "Africa/Cairo"
            ]
          },
          {
            name: "Syria Standard Time",
            abbr: "SDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Damascus",
            utc: [
              "Asia/Damascus"
            ]
          },
          {
            name: "E. Europe Standard Time",
            abbr: "EEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) E. Europe",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau",
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Nicosia",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "South Africa Standard Time",
            abbr: "SAST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Harare, Pretoria",
            utc: [
              "Africa/Blantyre",
              "Africa/Bujumbura",
              "Africa/Gaborone",
              "Africa/Harare",
              "Africa/Johannesburg",
              "Africa/Kigali",
              "Africa/Lubumbashi",
              "Africa/Lusaka",
              "Africa/Maputo",
              "Africa/Maseru",
              "Africa/Mbabane",
              "Etc/GMT-2"
            ]
          },
          {
            name: "FLE Standard Time",
            abbr: "FDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            utc: [
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "Turkey Standard Time",
            abbr: "TDT",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Istanbul",
            utc: [
              "Europe/Istanbul"
            ]
          },
          {
            name: "Israel Standard Time",
            abbr: "JDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Jerusalem",
            utc: [
              "Asia/Jerusalem"
            ]
          },
          {
            name: "Libya Standard Time",
            abbr: "LST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Tripoli",
            utc: [
              "Africa/Tripoli"
            ]
          },
          {
            name: "Jordan Standard Time",
            abbr: "JST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Amman",
            utc: [
              "Asia/Amman"
            ]
          },
          {
            name: "Arabic Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Baghdad",
            utc: [
              "Asia/Baghdad"
            ]
          },
          {
            name: "Kaliningrad Standard Time",
            abbr: "KST",
            offset: 3,
            isdst: !1,
            text: "(UTC+02:00) Kaliningrad",
            utc: [
              "Europe/Kaliningrad"
            ]
          },
          {
            name: "Arab Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Kuwait, Riyadh",
            utc: [
              "Asia/Aden",
              "Asia/Bahrain",
              "Asia/Kuwait",
              "Asia/Qatar",
              "Asia/Riyadh"
            ]
          },
          {
            name: "E. Africa Standard Time",
            abbr: "EAST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Nairobi",
            utc: [
              "Africa/Addis_Ababa",
              "Africa/Asmera",
              "Africa/Dar_es_Salaam",
              "Africa/Djibouti",
              "Africa/Juba",
              "Africa/Kampala",
              "Africa/Khartoum",
              "Africa/Mogadishu",
              "Africa/Nairobi",
              "Antarctica/Syowa",
              "Etc/GMT-3",
              "Indian/Antananarivo",
              "Indian/Comoro",
              "Indian/Mayotte"
            ]
          },
          {
            name: "Moscow Standard Time",
            abbr: "MSK",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
            utc: [
              "Europe/Kirov",
              "Europe/Moscow",
              "Europe/Simferopol",
              "Europe/Volgograd",
              "Europe/Minsk"
            ]
          },
          {
            name: "Samara Time",
            abbr: "SAMT",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
            utc: [
              "Europe/Astrakhan",
              "Europe/Samara",
              "Europe/Ulyanovsk"
            ]
          },
          {
            name: "Iran Standard Time",
            abbr: "IDT",
            offset: 4.5,
            isdst: !0,
            text: "(UTC+03:30) Tehran",
            utc: [
              "Asia/Tehran"
            ]
          },
          {
            name: "Arabian Standard Time",
            abbr: "AST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Abu Dhabi, Muscat",
            utc: [
              "Asia/Dubai",
              "Asia/Muscat",
              "Etc/GMT-4"
            ]
          },
          {
            name: "Azerbaijan Standard Time",
            abbr: "ADT",
            offset: 5,
            isdst: !0,
            text: "(UTC+04:00) Baku",
            utc: [
              "Asia/Baku"
            ]
          },
          {
            name: "Mauritius Standard Time",
            abbr: "MST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Port Louis",
            utc: [
              "Indian/Mahe",
              "Indian/Mauritius",
              "Indian/Reunion"
            ]
          },
          {
            name: "Georgian Standard Time",
            abbr: "GET",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Tbilisi",
            utc: [
              "Asia/Tbilisi"
            ]
          },
          {
            name: "Caucasus Standard Time",
            abbr: "CST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Yerevan",
            utc: [
              "Asia/Yerevan"
            ]
          },
          {
            name: "Afghanistan Standard Time",
            abbr: "AST",
            offset: 4.5,
            isdst: !1,
            text: "(UTC+04:30) Kabul",
            utc: [
              "Asia/Kabul"
            ]
          },
          {
            name: "West Asia Standard Time",
            abbr: "WAST",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Ashgabat, Tashkent",
            utc: [
              "Antarctica/Mawson",
              "Asia/Aqtau",
              "Asia/Aqtobe",
              "Asia/Ashgabat",
              "Asia/Dushanbe",
              "Asia/Oral",
              "Asia/Samarkand",
              "Asia/Tashkent",
              "Etc/GMT-5",
              "Indian/Kerguelen",
              "Indian/Maldives"
            ]
          },
          {
            name: "Yekaterinburg Time",
            abbr: "YEKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Yekaterinburg",
            utc: [
              "Asia/Yekaterinburg"
            ]
          },
          {
            name: "Pakistan Standard Time",
            abbr: "PKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Islamabad, Karachi",
            utc: [
              "Asia/Karachi"
            ]
          },
          {
            name: "India Standard Time",
            abbr: "IST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            utc: [
              "Asia/Kolkata"
            ]
          },
          {
            name: "Sri Lanka Standard Time",
            abbr: "SLST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Sri Jayawardenepura",
            utc: [
              "Asia/Colombo"
            ]
          },
          {
            name: "Nepal Standard Time",
            abbr: "NST",
            offset: 5.75,
            isdst: !1,
            text: "(UTC+05:45) Kathmandu",
            utc: [
              "Asia/Kathmandu"
            ]
          },
          {
            name: "Central Asia Standard Time",
            abbr: "CAST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Nur-Sultan (Astana)",
            utc: [
              "Antarctica/Vostok",
              "Asia/Almaty",
              "Asia/Bishkek",
              "Asia/Qyzylorda",
              "Asia/Urumqi",
              "Etc/GMT-6",
              "Indian/Chagos"
            ]
          },
          {
            name: "Bangladesh Standard Time",
            abbr: "BST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Dhaka",
            utc: [
              "Asia/Dhaka",
              "Asia/Thimphu"
            ]
          },
          {
            name: "Myanmar Standard Time",
            abbr: "MST",
            offset: 6.5,
            isdst: !1,
            text: "(UTC+06:30) Yangon (Rangoon)",
            utc: [
              "Asia/Rangoon",
              "Indian/Cocos"
            ]
          },
          {
            name: "SE Asia Standard Time",
            abbr: "SAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
            utc: [
              "Antarctica/Davis",
              "Asia/Bangkok",
              "Asia/Hovd",
              "Asia/Jakarta",
              "Asia/Phnom_Penh",
              "Asia/Pontianak",
              "Asia/Saigon",
              "Asia/Vientiane",
              "Etc/GMT-7",
              "Indian/Christmas"
            ]
          },
          {
            name: "N. Central Asia Standard Time",
            abbr: "NCAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Novosibirsk",
            utc: [
              "Asia/Novokuznetsk",
              "Asia/Novosibirsk",
              "Asia/Omsk"
            ]
          },
          {
            name: "China Standard Time",
            abbr: "CST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            utc: [
              "Asia/Hong_Kong",
              "Asia/Macau",
              "Asia/Shanghai"
            ]
          },
          {
            name: "North Asia Standard Time",
            abbr: "NAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Krasnoyarsk",
            utc: [
              "Asia/Krasnoyarsk"
            ]
          },
          {
            name: "Singapore Standard Time",
            abbr: "MPST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Kuala Lumpur, Singapore",
            utc: [
              "Asia/Brunei",
              "Asia/Kuala_Lumpur",
              "Asia/Kuching",
              "Asia/Makassar",
              "Asia/Manila",
              "Asia/Singapore",
              "Etc/GMT-8"
            ]
          },
          {
            name: "W. Australia Standard Time",
            abbr: "WAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Perth",
            utc: [
              "Antarctica/Casey",
              "Australia/Perth"
            ]
          },
          {
            name: "Taipei Standard Time",
            abbr: "TST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Taipei",
            utc: [
              "Asia/Taipei"
            ]
          },
          {
            name: "Ulaanbaatar Standard Time",
            abbr: "UST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Ulaanbaatar",
            utc: [
              "Asia/Choibalsan",
              "Asia/Ulaanbaatar"
            ]
          },
          {
            name: "North Asia East Standard Time",
            abbr: "NAEST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Irkutsk",
            utc: [
              "Asia/Irkutsk"
            ]
          },
          {
            name: "Japan Standard Time",
            abbr: "JST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
            utc: [
              "Asia/Dili",
              "Asia/Jayapura",
              "Asia/Tokyo",
              "Etc/GMT-9",
              "Pacific/Palau"
            ]
          },
          {
            name: "Korea Standard Time",
            abbr: "KST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Seoul",
            utc: [
              "Asia/Pyongyang",
              "Asia/Seoul"
            ]
          },
          {
            name: "Cen. Australia Standard Time",
            abbr: "CAST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Adelaide",
            utc: [
              "Australia/Adelaide",
              "Australia/Broken_Hill"
            ]
          },
          {
            name: "AUS Central Standard Time",
            abbr: "ACST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Darwin",
            utc: [
              "Australia/Darwin"
            ]
          },
          {
            name: "E. Australia Standard Time",
            abbr: "EAST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Brisbane",
            utc: [
              "Australia/Brisbane",
              "Australia/Lindeman"
            ]
          },
          {
            name: "AUS Eastern Standard Time",
            abbr: "AEST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Canberra, Melbourne, Sydney",
            utc: [
              "Australia/Melbourne",
              "Australia/Sydney"
            ]
          },
          {
            name: "West Pacific Standard Time",
            abbr: "WPST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Guam, Port Moresby",
            utc: [
              "Antarctica/DumontDUrville",
              "Etc/GMT-10",
              "Pacific/Guam",
              "Pacific/Port_Moresby",
              "Pacific/Saipan",
              "Pacific/Truk"
            ]
          },
          {
            name: "Tasmania Standard Time",
            abbr: "TST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Hobart",
            utc: [
              "Australia/Currie",
              "Australia/Hobart"
            ]
          },
          {
            name: "Yakutsk Standard Time",
            abbr: "YST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Yakutsk",
            utc: [
              "Asia/Chita",
              "Asia/Khandyga",
              "Asia/Yakutsk"
            ]
          },
          {
            name: "Central Pacific Standard Time",
            abbr: "CPST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Solomon Is., New Caledonia",
            utc: [
              "Antarctica/Macquarie",
              "Etc/GMT-11",
              "Pacific/Efate",
              "Pacific/Guadalcanal",
              "Pacific/Kosrae",
              "Pacific/Noumea",
              "Pacific/Ponape"
            ]
          },
          {
            name: "Vladivostok Standard Time",
            abbr: "VST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Vladivostok",
            utc: [
              "Asia/Sakhalin",
              "Asia/Ust-Nera",
              "Asia/Vladivostok"
            ]
          },
          {
            name: "New Zealand Standard Time",
            abbr: "NZST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Auckland, Wellington",
            utc: [
              "Antarctica/McMurdo",
              "Pacific/Auckland"
            ]
          },
          {
            name: "UTC+12",
            abbr: "U",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Coordinated Universal Time+12",
            utc: [
              "Etc/GMT-12",
              "Pacific/Funafuti",
              "Pacific/Kwajalein",
              "Pacific/Majuro",
              "Pacific/Nauru",
              "Pacific/Tarawa",
              "Pacific/Wake",
              "Pacific/Wallis"
            ]
          },
          {
            name: "Fiji Standard Time",
            abbr: "FST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Fiji",
            utc: [
              "Pacific/Fiji"
            ]
          },
          {
            name: "Magadan Standard Time",
            abbr: "MST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Magadan",
            utc: [
              "Asia/Anadyr",
              "Asia/Kamchatka",
              "Asia/Magadan",
              "Asia/Srednekolymsk"
            ]
          },
          {
            name: "Kamchatka Standard Time",
            abbr: "KDT",
            offset: 13,
            isdst: !0,
            text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
            utc: [
              "Asia/Kamchatka"
            ]
          },
          {
            name: "Tonga Standard Time",
            abbr: "TST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Nuku'alofa",
            utc: [
              "Etc/GMT-13",
              "Pacific/Enderbury",
              "Pacific/Fakaofo",
              "Pacific/Tongatapu"
            ]
          },
          {
            name: "Samoa Standard Time",
            abbr: "SST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Samoa",
            utc: [
              "Pacific/Apia"
            ]
          }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
          "Airline Pilot",
          "Academic Team",
          "Accountant",
          "Account Executive",
          "Actor",
          "Actuary",
          "Acquisition Analyst",
          "Administrative Asst.",
          "Administrative Analyst",
          "Administrator",
          "Advertising Director",
          "Aerospace Engineer",
          "Agent",
          "Agricultural Inspector",
          "Agricultural Scientist",
          "Air Traffic Controller",
          "Animal Trainer",
          "Anthropologist",
          "Appraiser",
          "Architect",
          "Art Director",
          "Artist",
          "Astronomer",
          "Athletic Coach",
          "Auditor",
          "Author",
          "Baker",
          "Banker",
          "Bankruptcy Attorney",
          "Benefits Manager",
          "Biologist",
          "Bio-feedback Specialist",
          "Biomedical Engineer",
          "Biotechnical Researcher",
          "Broadcaster",
          "Broker",
          "Building Manager",
          "Building Contractor",
          "Building Inspector",
          "Business Analyst",
          "Business Planner",
          "Business Manager",
          "Buyer",
          "Call Center Manager",
          "Career Counselor",
          "Cash Manager",
          "Ceramic Engineer",
          "Chief Executive Officer",
          "Chief Operation Officer",
          "Chef",
          "Chemical Engineer",
          "Chemist",
          "Child Care Manager",
          "Chief Medical Officer",
          "Chiropractor",
          "Cinematographer",
          "City Housing Manager",
          "City Manager",
          "Civil Engineer",
          "Claims Manager",
          "Clinical Research Assistant",
          "Collections Manager",
          "Compliance Manager",
          "Comptroller",
          "Computer Manager",
          "Commercial Artist",
          "Communications Affairs Director",
          "Communications Director",
          "Communications Engineer",
          "Compensation Analyst",
          "Computer Programmer",
          "Computer Ops. Manager",
          "Computer Engineer",
          "Computer Operator",
          "Computer Graphics Specialist",
          "Construction Engineer",
          "Construction Manager",
          "Consultant",
          "Consumer Relations Manager",
          "Contract Administrator",
          "Copyright Attorney",
          "Copywriter",
          "Corporate Planner",
          "Corrections Officer",
          "Cosmetologist",
          "Credit Analyst",
          "Cruise Director",
          "Chief Information Officer",
          "Chief Technology Officer",
          "Customer Service Manager",
          "Cryptologist",
          "Dancer",
          "Data Security Manager",
          "Database Manager",
          "Day Care Instructor",
          "Dentist",
          "Designer",
          "Design Engineer",
          "Desktop Publisher",
          "Developer",
          "Development Officer",
          "Diamond Merchant",
          "Dietitian",
          "Direct Marketer",
          "Director",
          "Distribution Manager",
          "Diversity Manager",
          "Economist",
          "EEO Compliance Manager",
          "Editor",
          "Education Adminator",
          "Electrical Engineer",
          "Electro Optical Engineer",
          "Electronics Engineer",
          "Embassy Management",
          "Employment Agent",
          "Engineer Technician",
          "Entrepreneur",
          "Environmental Analyst",
          "Environmental Attorney",
          "Environmental Engineer",
          "Environmental Specialist",
          "Escrow Officer",
          "Estimator",
          "Executive Assistant",
          "Executive Director",
          "Executive Recruiter",
          "Facilities Manager",
          "Family Counselor",
          "Fashion Events Manager",
          "Fashion Merchandiser",
          "Fast Food Manager",
          "Film Producer",
          "Film Production Assistant",
          "Financial Analyst",
          "Financial Planner",
          "Financier",
          "Fine Artist",
          "Wildlife Specialist",
          "Fitness Consultant",
          "Flight Attendant",
          "Flight Engineer",
          "Floral Designer",
          "Food & Beverage Director",
          "Food Service Manager",
          "Forestry Technician",
          "Franchise Management",
          "Franchise Sales",
          "Fraud Investigator",
          "Freelance Writer",
          "Fund Raiser",
          "General Manager",
          "Geologist",
          "General Counsel",
          "Geriatric Specialist",
          "Gerontologist",
          "Glamour Photographer",
          "Golf Club Manager",
          "Gourmet Chef",
          "Graphic Designer",
          "Grounds Keeper",
          "Hazardous Waste Manager",
          "Health Care Manager",
          "Health Therapist",
          "Health Service Administrator",
          "Hearing Officer",
          "Home Economist",
          "Horticulturist",
          "Hospital Administrator",
          "Hotel Manager",
          "Human Resources Manager",
          "Importer",
          "Industrial Designer",
          "Industrial Engineer",
          "Information Director",
          "Inside Sales",
          "Insurance Adjuster",
          "Interior Decorator",
          "Internal Controls Director",
          "International Acct.",
          "International Courier",
          "International Lawyer",
          "Interpreter",
          "Investigator",
          "Investment Banker",
          "Investment Manager",
          "IT Architect",
          "IT Project Manager",
          "IT Systems Analyst",
          "Jeweler",
          "Joint Venture Manager",
          "Journalist",
          "Labor Negotiator",
          "Labor Organizer",
          "Labor Relations Manager",
          "Lab Services Director",
          "Lab Technician",
          "Land Developer",
          "Landscape Architect",
          "Law Enforcement Officer",
          "Lawyer",
          "Lead Software Engineer",
          "Lead Software Test Engineer",
          "Leasing Manager",
          "Legal Secretary",
          "Library Manager",
          "Litigation Attorney",
          "Loan Officer",
          "Lobbyist",
          "Logistics Manager",
          "Maintenance Manager",
          "Management Consultant",
          "Managed Care Director",
          "Managing Partner",
          "Manufacturing Director",
          "Manpower Planner",
          "Marine Biologist",
          "Market Res. Analyst",
          "Marketing Director",
          "Materials Manager",
          "Mathematician",
          "Membership Chairman",
          "Mechanic",
          "Mechanical Engineer",
          "Media Buyer",
          "Medical Investor",
          "Medical Secretary",
          "Medical Technician",
          "Mental Health Counselor",
          "Merchandiser",
          "Metallurgical Engineering",
          "Meteorologist",
          "Microbiologist",
          "MIS Manager",
          "Motion Picture Director",
          "Multimedia Director",
          "Musician",
          "Network Administrator",
          "Network Specialist",
          "Network Operator",
          "New Product Manager",
          "Novelist",
          "Nuclear Engineer",
          "Nuclear Specialist",
          "Nutritionist",
          "Nursing Administrator",
          "Occupational Therapist",
          "Oceanographer",
          "Office Manager",
          "Operations Manager",
          "Operations Research Director",
          "Optical Technician",
          "Optometrist",
          "Organizational Development Manager",
          "Outplacement Specialist",
          "Paralegal",
          "Park Ranger",
          "Patent Attorney",
          "Payroll Specialist",
          "Personnel Specialist",
          "Petroleum Engineer",
          "Pharmacist",
          "Photographer",
          "Physical Therapist",
          "Physician",
          "Physician Assistant",
          "Physicist",
          "Planning Director",
          "Podiatrist",
          "Political Analyst",
          "Political Scientist",
          "Politician",
          "Portfolio Manager",
          "Preschool Management",
          "Preschool Teacher",
          "Principal",
          "Private Banker",
          "Private Investigator",
          "Probation Officer",
          "Process Engineer",
          "Producer",
          "Product Manager",
          "Product Engineer",
          "Production Engineer",
          "Production Planner",
          "Professional Athlete",
          "Professional Coach",
          "Professor",
          "Project Engineer",
          "Project Manager",
          "Program Manager",
          "Property Manager",
          "Public Administrator",
          "Public Safety Director",
          "PR Specialist",
          "Publisher",
          "Purchasing Agent",
          "Publishing Director",
          "Quality Assurance Specialist",
          "Quality Control Engineer",
          "Quality Control Inspector",
          "Radiology Manager",
          "Railroad Engineer",
          "Real Estate Broker",
          "Recreational Director",
          "Recruiter",
          "Redevelopment Specialist",
          "Regulatory Affairs Manager",
          "Registered Nurse",
          "Rehabilitation Counselor",
          "Relocation Manager",
          "Reporter",
          "Research Specialist",
          "Restaurant Manager",
          "Retail Store Manager",
          "Risk Analyst",
          "Safety Engineer",
          "Sales Engineer",
          "Sales Trainer",
          "Sales Promotion Manager",
          "Sales Representative",
          "Sales Manager",
          "Service Manager",
          "Sanitation Engineer",
          "Scientific Programmer",
          "Scientific Writer",
          "Securities Analyst",
          "Security Consultant",
          "Security Director",
          "Seminar Presenter",
          "Ship's Officer",
          "Singer",
          "Social Director",
          "Social Program Planner",
          "Social Research",
          "Social Scientist",
          "Social Worker",
          "Sociologist",
          "Software Developer",
          "Software Engineer",
          "Software Test Engineer",
          "Soil Scientist",
          "Special Events Manager",
          "Special Education Teacher",
          "Special Projects Director",
          "Speech Pathologist",
          "Speech Writer",
          "Sports Event Manager",
          "Statistician",
          "Store Manager",
          "Strategic Alliance Director",
          "Strategic Planning Director",
          "Stress Reduction Specialist",
          "Stockbroker",
          "Surveyor",
          "Structural Engineer",
          "Superintendent",
          "Supply Chain Director",
          "System Engineer",
          "Systems Analyst",
          "Systems Programmer",
          "System Administrator",
          "Tax Specialist",
          "Teacher",
          "Technical Support Specialist",
          "Technical Illustrator",
          "Technical Writer",
          "Technology Director",
          "Telecom Analyst",
          "Telemarketer",
          "Theatrical Director",
          "Title Examiner",
          "Tour Escort",
          "Tour Guide Director",
          "Traffic Manager",
          "Trainer Translator",
          "Transportation Manager",
          "Travel Agent",
          "Treasurer",
          "TV Programmer",
          "Underwriter",
          "Union Representative",
          "University Administrator",
          "University Dean",
          "Urban Planner",
          "Veterinarian",
          "Vendor Relations Director",
          "Viticulturist",
          "Warehouse Manager"
        ],
        animals: {
          //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
          ocean: ["Acantharea", "Anemone", "Angelfish King", "Ahi Tuna", "Albacore", "American Oyster", "Anchovy", "Armored Snail", "Arctic Char", "Atlantic Bluefin Tuna", "Atlantic Cod", "Atlantic Goliath Grouper", "Atlantic Trumpetfish", "Atlantic Wolffish", "Baleen Whale", "Banded Butterflyfish", "Banded Coral Shrimp", "Banded Sea Krait", "Barnacle", "Barndoor Skate", "Barracuda", "Basking Shark", "Bass", "Beluga Whale", "Bluebanded Goby", "Bluehead Wrasse", "Bluefish", "Bluestreak Cleaner-Wrasse", "Blue Marlin", "Blue Shark", "Blue Spiny Lobster", "Blue Tang", "Blue Whale", "Broadclub Cuttlefish", "Bull Shark", "Chambered Nautilus", "Chilean Basket Star", "Chilean Jack Mackerel", "Chinook Salmon", "Christmas Tree Worm", "Clam", "Clown Anemonefish", "Clown Triggerfish", "Cod", "Coelacanth", "Cockscomb Cup Coral", "Common Fangtooth", "Conch", "Cookiecutter Shark", "Copepod", "Coral", "Corydoras", "Cownose Ray", "Crab", "Crown-of-Thorns Starfish", "Cushion Star", "Cuttlefish", "California Sea Otters", "Dolphin", "Dolphinfish", "Dory", "Devil Fish", "Dugong", "Dumbo Octopus", "Dungeness Crab", "Eccentric Sand Dollar", "Edible Sea Cucumber", "Eel", "Elephant Seal", "Elkhorn Coral", "Emperor Shrimp", "Estuarine Crocodile", "Fathead Sculpin", "Fiddler Crab", "Fin Whale", "Flameback", "Flamingo Tongue Snail", "Flashlight Fish", "Flatback Turtle", "Flatfish", "Flying Fish", "Flounder", "Fluke", "French Angelfish", "Frilled Shark", "Fugu (also called Pufferfish)", "Gar", "Geoduck", "Giant Barrel Sponge", "Giant Caribbean Sea Anemone", "Giant Clam", "Giant Isopod", "Giant Kingfish", "Giant Oarfish", "Giant Pacific Octopus", "Giant Pyrosome", "Giant Sea Star", "Giant Squid", "Glowing Sucker Octopus", "Giant Tube Worm", "Goblin Shark", "Goosefish", "Great White Shark", "Greenland Shark", "Grey Atlantic Seal", "Grouper", "Grunion", "Guineafowl Puffer", "Haddock", "Hake", "Halibut", "Hammerhead Shark", "Hapuka", "Harbor Porpoise", "Harbor Seal", "Hatchetfish", "Hawaiian Monk Seal", "Hawksbill Turtle", "Hector's Dolphin", "Hermit Crab", "Herring", "Hoki", "Horn Shark", "Horseshoe Crab", "Humpback Anglerfish", "Humpback Whale", "Icefish", "Imperator Angelfish", "Irukandji Jellyfish", "Isopod", "Ivory Bush Coral", "Japanese Spider Crab", "Jellyfish", "John Dory", "Juan Fernandez Fur Seal", "Killer Whale", "Kiwa Hirsuta", "Krill", "Lagoon Triggerfish", "Lamprey", "Leafy Seadragon", "Leopard Seal", "Limpet", "Ling", "Lionfish", "Lions Mane Jellyfish", "Lobe Coral", "Lobster", "Loggerhead Turtle", "Longnose Sawshark", "Longsnout Seahorse", "Lophelia Coral", "Marrus Orthocanna", "Manatee", "Manta Ray", "Marlin", "Megamouth Shark", "Mexican Lookdown", "Mimic Octopus", "Moon Jelly", "Mollusk", "Monkfish", "Moray Eel", "Mullet", "Mussel", "Megaladon", "Napoleon Wrasse", "Nassau Grouper", "Narwhal", "Nautilus", "Needlefish", "Northern Seahorse", "North Atlantic Right Whale", "Northern Red Snapper", "Norway Lobster", "Nudibranch", "Nurse Shark", "Oarfish", "Ocean Sunfish", "Oceanic Whitetip Shark", "Octopus", "Olive Sea Snake", "Orange Roughy", "Ostracod", "Otter", "Oyster", "Pacific Angelshark", "Pacific Blackdragon", "Pacific Halibut", "Pacific Sardine", "Pacific Sea Nettle Jellyfish", "Pacific White Sided Dolphin", "Pantropical Spotted Dolphin", "Patagonian Toothfish", "Peacock Mantis Shrimp", "Pelagic Thresher Shark", "Penguin", "Peruvian Anchoveta", "Pilchard", "Pink Salmon", "Pinniped", "Plankton", "Porpoise", "Polar Bear", "Portuguese Man o' War", "Pycnogonid Sea Spider", "Quahog", "Queen Angelfish", "Queen Conch", "Queen Parrotfish", "Queensland Grouper", "Ragfish", "Ratfish", "Rattail Fish", "Ray", "Red Drum", "Red King Crab", "Ringed Seal", "Risso's Dolphin", "Ross Seals", "Sablefish", "Salmon", "Sand Dollar", "Sandbar Shark", "Sawfish", "Sarcastic Fringehead", "Scalloped Hammerhead Shark", "Seahorse", "Sea Cucumber", "Sea Lion", "Sea Urchin", "Seal", "Shark", "Shortfin Mako Shark", "Shovelnose Guitarfish", "Shrimp", "Silverside Fish", "Skipjack Tuna", "Slender Snipe Eel", "Smalltooth Sawfish", "Smelts", "Sockeye Salmon", "Southern Stingray", "Sponge", "Spotted Porcupinefish", "Spotted Dolphin", "Spotted Eagle Ray", "Spotted Moray", "Squid", "Squidworm", "Starfish", "Stickleback", "Stonefish", "Stoplight Loosejaw", "Sturgeon", "Swordfish", "Tan Bristlemouth", "Tasseled Wobbegong", "Terrible Claw Lobster", "Threespot Damselfish", "Tiger Prawn", "Tiger Shark", "Tilefish", "Toadfish", "Tropical Two-Wing Flyfish", "Tuna", "Umbrella Squid", "Velvet Crab", "Venus Flytrap Sea Anemone", "Vigtorniella Worm", "Viperfish", "Vampire Squid", "Vaquita", "Wahoo", "Walrus", "West Indian Manatee", "Whale", "Whale Shark", "Whiptail Gulper", "White-Beaked Dolphin", "White-Ring Garden Eel", "White Shrimp", "Wobbegong", "Wrasse", "Wreckfish", "Xiphosura", "Yellowtail Damselfish", "Yelloweye Rockfish", "Yellow Cup Black Coral", "Yellow Tube Sponge", "Yellowfin Tuna", "Zebrashark", "Zooplankton"],
          //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
          desert: ["Aardwolf", "Addax", "African Wild Ass", "Ant", "Antelope", "Armadillo", "Baboon", "Badger", "Bat", "Bearded Dragon", "Beetle", "Bird", "Black-footed Cat", "Boa", "Brown Bear", "Bustard", "Butterfly", "Camel", "Caracal", "Caracara", "Caterpillar", "Centipede", "Cheetah", "Chipmunk", "Chuckwalla", "Climbing Mouse", "Coati", "Cobra", "Cotton Rat", "Cougar", "Courser", "Crane Fly", "Crow", "Dassie Rat", "Dove", "Dunnart", "Eagle", "Echidna", "Elephant", "Emu", "Falcon", "Fly", "Fox", "Frogmouth", "Gecko", "Geoffroy's Cat", "Gerbil", "Grasshopper", "Guanaco", "Gundi", "Hamster", "Hawk", "Hedgehog", "Hyena", "Hyrax", "Jackal", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kowari", "Kultarr", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Oryx", "Ostrich", "Owl", "Pronghorn", "Python", "Rabbit", "Raccoon", "Rattlesnake", "Rhinoceros", "Sand Cat", "Spectacled Bear", "Spiny Mouse", "Starling", "Stick Bug", "Tarantula", "Tit", "Toad", "Tortoise", "Tyrant Flycatcher", "Viper", "Vulture", "Waxwing", "Xerus", "Zebra"],
          grassland: ["Aardvark", "Aardwolf", "Accentor", "African Buffalo", "African Wild Dog", "Alpaca", "Anaconda", "Ant", "Anteater", "Antelope", "Armadillo", "Baboon", "Badger", "Bandicoot", "Barbet", "Bat", "Bee", "Bee-eater", "Beetle", "Bird", "Bison", "Black-footed Cat", "Black-footed Ferret", "Bluebird", "Boa", "Bowerbird", "Brown Bear", "Bush Dog", "Bushshrike", "Bustard", "Butterfly", "Buzzard", "Caracal", "Caracara", "Cardinal", "Caterpillar", "Cheetah", "Chipmunk", "Civet", "Climbing Mouse", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Common Genet", "Cotton Rat", "Cougar", "Courser", "Coyote", "Crane", "Crane Fly", "Cricket", "Crow", "Culpeo", "Death Adder", "Deer", "Deer Mouse", "Dingo", "Dinosaur", "Dove", "Drongo", "Duck", "Duiker", "Dunnart", "Eagle", "Echidna", "Elephant", "Elk", "Emu", "Falcon", "Finch", "Flea", "Fly", "Flying Frog", "Fox", "Frog", "Frogmouth", "Garter Snake", "Gazelle", "Gecko", "Geoffroy's Cat", "Gerbil", "Giant Tortoise", "Giraffe", "Grasshopper", "Grison", "Groundhog", "Grouse", "Guanaco", "Guinea Pig", "Hamster", "Harrier", "Hartebeest", "Hawk", "Hedgehog", "Helmetshrike", "Hippopotamus", "Hornbill", "Hyena", "Hyrax", "Impala", "Jackal", "Jaguar", "Jaguarundi", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kultarr", "Ladybug", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Newt", "Oryx", "Ostrich", "Owl", "Pangolin", "Pheasant", "Prairie Dog", "Pronghorn", "Przewalski's Horse", "Python", "Quoll", "Rabbit", "Raven", "Rhinoceros", "Shelduck", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Tamandua", "Tasmanian Devil", "Thornbill", "Thrush", "Toad", "Tortoise"],
          forest: ["Agouti", "Anaconda", "Anoa", "Ant", "Anteater", "Antelope", "Armadillo", "Asian Black Bear", "Aye-aye", "Babirusa", "Baboon", "Badger", "Bandicoot", "Banteng", "Barbet", "Basilisk", "Bat", "Bearded Dragon", "Bee", "Bee-eater", "Beetle", "Bettong", "Binturong", "Bird-of-paradise", "Bongo", "Bowerbird", "Bulbul", "Bush Dog", "Bushbaby", "Bushshrike", "Butterfly", "Buzzard", "Caecilian", "Cardinal", "Cassowary", "Caterpillar", "Centipede", "Chameleon", "Chimpanzee", "Cicada", "Civet", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Colugo", "Cotinga", "Cotton Rat", "Cougar", "Crane Fly", "Cricket", "Crocodile", "Crow", "Cuckoo", "Cuscus", "Death Adder", "Deer", "Dhole", "Dingo", "Dinosaur", "Drongo", "Duck", "Duiker", "Eagle", "Echidna", "Elephant", "Finch", "Flat-headed Cat", "Flea", "Flowerpecker", "Fly", "Flying Frog", "Fossa", "Frog", "Frogmouth", "Gaur", "Gecko", "Gorilla", "Grison", "Hawaiian Honeycreeper", "Hawk", "Hedgehog", "Helmetshrike", "Hornbill", "Hyrax", "Iguana", "Jackal", "Jaguar", "Jaguarundi", "Kestrel", "Ladybug", "Lemur", "Leopard", "Lion", "Macaw", "Mandrill", "Margay", "Monkey", "Mouse", "Mouse Deer", "Newt", "Okapi", "Old World Flycatcher", "Orangutan", "Owl", "Pangolin", "Peafowl", "Pheasant", "Possum", "Python", "Quokka", "Rabbit", "Raccoon", "Red Panda", "Red River Hog", "Rhinoceros", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Sun Bear", "Tamandua", "Tamarin", "Tapir", "Tarantula", "Thrush", "Tiger", "Tit", "Toad", "Tortoise", "Toucan", "Trogon", "Trumpeter", "Turaco", "Turtle", "Tyrant Flycatcher", "Viper", "Vulture", "Wallaby", "Warbler", "Wasp", "Waxwing", "Weaver", "Weaver-finch", "Whistler", "White-eye", "Whydah", "Woodswallow", "Worm", "Wren", "Xenops", "Yellowjacket", "Accentor", "African Buffalo", "American Black Bear", "Anole", "Bird", "Bison", "Boa", "Brown Bear", "Chipmunk", "Common Genet", "Copperhead", "Coyote", "Deer Mouse", "Dormouse", "Elk", "Emu", "Fisher", "Fox", "Garter Snake", "Giant Panda", "Giant Tortoise", "Groundhog", "Grouse", "Guanaco", "Himalayan Tahr", "Kangaroo", "Koala", "Numbat", "Quoll", "Raccoon dog", "Tasmanian Devil", "Thornbill", "Turkey", "Vole", "Weasel", "Wildcat", "Wolf", "Wombat", "Woodchuck", "Woodpecker"],
          //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
          farm: ["Alpaca", "Buffalo", "Banteng", "Cow", "Cat", "Chicken", "Carp", "Camel", "Donkey", "Dog", "Duck", "Emu", "Goat", "Gayal", "Guinea", "Goose", "Horse", "Honey", "Llama", "Pig", "Pigeon", "Rhea", "Rabbit", "Sheep", "Silkworm", "Turkey", "Yak", "Zebu"],
          //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
          pet: ["Bearded Dragon", "Birds", "Burro", "Cats", "Chameleons", "Chickens", "Chinchillas", "Chinese Water Dragon", "Cows", "Dogs", "Donkey", "Ducks", "Ferrets", "Fish", "Geckos", "Geese", "Gerbils", "Goats", "Guinea Fowl", "Guinea Pigs", "Hamsters", "Hedgehogs", "Horses", "Iguanas", "Llamas", "Lizards", "Mice", "Mule", "Peafowl", "Pigs and Hogs", "Pigeons", "Ponies", "Pot Bellied Pig", "Rabbits", "Rats", "Sheep", "Skinks", "Snakes", "Stick Insects", "Sugar Gliders", "Tarantula", "Turkeys", "Turtles"],
          //list of zoo animals comes from https://bronxzoo.com/animals
          zoo: ["Aardvark", "African Wild Dog", "Aldabra Tortoise", "American Alligator", "American Bison", "Amur Tiger", "Anaconda", "Andean Condor", "Asian Elephant", "Baby Doll Sheep", "Bald Eagle", "Barred Owl", "Blue Iguana", "Boer Goat", "California Sea Lion", "Caribbean Flamingo", "Chinchilla", "Collared Lemur", "Coquerel's Sifaka", "Cuban Amazon Parrot", "Ebony Langur", "Fennec Fox", "Fossa", "Gelada", "Giant Anteater", "Giraffe", "Gorilla", "Grizzly Bear", "Henkel's Leaf-tailed Gecko", "Indian Gharial", "Indian Rhinoceros", "King Cobra", "King Vulture", "Komodo Dragon", "Linne's Two-toed Sloth", "Lion", "Little Penguin", "Madagascar Tree Boa", "Magellanic Penguin", "Malayan Tapir", "Malayan Tiger", "Matschies Tree Kangaroo", "Mini Donkey", "Monarch Butterfly", "Nile crocodile", "North American Porcupine", "Nubian Ibex", "Okapi", "Poison Dart Frog", "Polar Bear", "Pygmy Marmoset", "Radiated Tortoise", "Red Panda", "Red Ruffed Lemur", "Ring-tailed Lemur", "Ring-tailed Mongoose", "Rock Hyrax", "Small Clawed Asian Otter", "Snow Leopard", "Snowy Owl", "Southern White-faced Owl", "Southern White Rhinocerous", "Squirrel Monkey", "Tufted Puffin", "White Cheeked Gibbon", "White-throated Bee Eater", "Zebra"]
        },
        primes: [
          // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
          2,
          3,
          5,
          7,
          11,
          13,
          17,
          19,
          23,
          29,
          31,
          37,
          41,
          43,
          47,
          53,
          59,
          61,
          67,
          71,
          73,
          79,
          83,
          89,
          97,
          101,
          103,
          107,
          109,
          113,
          127,
          131,
          137,
          139,
          149,
          151,
          157,
          163,
          167,
          173,
          179,
          181,
          191,
          193,
          197,
          199,
          211,
          223,
          227,
          229,
          233,
          239,
          241,
          251,
          257,
          263,
          269,
          271,
          277,
          281,
          283,
          293,
          307,
          311,
          313,
          317,
          331,
          337,
          347,
          349,
          353,
          359,
          367,
          373,
          379,
          383,
          389,
          397,
          401,
          409,
          419,
          421,
          431,
          433,
          439,
          443,
          449,
          457,
          461,
          463,
          467,
          479,
          487,
          491,
          499,
          503,
          509,
          521,
          523,
          541,
          547,
          557,
          563,
          569,
          571,
          577,
          587,
          593,
          599,
          601,
          607,
          613,
          617,
          619,
          631,
          641,
          643,
          647,
          653,
          659,
          661,
          673,
          677,
          683,
          691,
          701,
          709,
          719,
          727,
          733,
          739,
          743,
          751,
          757,
          761,
          769,
          773,
          787,
          797,
          809,
          811,
          821,
          823,
          827,
          829,
          839,
          853,
          857,
          859,
          863,
          877,
          881,
          883,
          887,
          907,
          911,
          919,
          929,
          937,
          941,
          947,
          953,
          967,
          971,
          977,
          983,
          991,
          997,
          1009,
          1013,
          1019,
          1021,
          1031,
          1033,
          1039,
          1049,
          1051,
          1061,
          1063,
          1069,
          1087,
          1091,
          1093,
          1097,
          1103,
          1109,
          1117,
          1123,
          1129,
          1151,
          1153,
          1163,
          1171,
          1181,
          1187,
          1193,
          1201,
          1213,
          1217,
          1223,
          1229,
          1231,
          1237,
          1249,
          1259,
          1277,
          1279,
          1283,
          1289,
          1291,
          1297,
          1301,
          1303,
          1307,
          1319,
          1321,
          1327,
          1361,
          1367,
          1373,
          1381,
          1399,
          1409,
          1423,
          1427,
          1429,
          1433,
          1439,
          1447,
          1451,
          1453,
          1459,
          1471,
          1481,
          1483,
          1487,
          1489,
          1493,
          1499,
          1511,
          1523,
          1531,
          1543,
          1549,
          1553,
          1559,
          1567,
          1571,
          1579,
          1583,
          1597,
          1601,
          1607,
          1609,
          1613,
          1619,
          1621,
          1627,
          1637,
          1657,
          1663,
          1667,
          1669,
          1693,
          1697,
          1699,
          1709,
          1721,
          1723,
          1733,
          1741,
          1747,
          1753,
          1759,
          1777,
          1783,
          1787,
          1789,
          1801,
          1811,
          1823,
          1831,
          1847,
          1861,
          1867,
          1871,
          1873,
          1877,
          1879,
          1889,
          1901,
          1907,
          1913,
          1931,
          1933,
          1949,
          1951,
          1973,
          1979,
          1987,
          1993,
          1997,
          1999,
          2003,
          2011,
          2017,
          2027,
          2029,
          2039,
          2053,
          2063,
          2069,
          2081,
          2083,
          2087,
          2089,
          2099,
          2111,
          2113,
          2129,
          2131,
          2137,
          2141,
          2143,
          2153,
          2161,
          2179,
          2203,
          2207,
          2213,
          2221,
          2237,
          2239,
          2243,
          2251,
          2267,
          2269,
          2273,
          2281,
          2287,
          2293,
          2297,
          2309,
          2311,
          2333,
          2339,
          2341,
          2347,
          2351,
          2357,
          2371,
          2377,
          2381,
          2383,
          2389,
          2393,
          2399,
          2411,
          2417,
          2423,
          2437,
          2441,
          2447,
          2459,
          2467,
          2473,
          2477,
          2503,
          2521,
          2531,
          2539,
          2543,
          2549,
          2551,
          2557,
          2579,
          2591,
          2593,
          2609,
          2617,
          2621,
          2633,
          2647,
          2657,
          2659,
          2663,
          2671,
          2677,
          2683,
          2687,
          2689,
          2693,
          2699,
          2707,
          2711,
          2713,
          2719,
          2729,
          2731,
          2741,
          2749,
          2753,
          2767,
          2777,
          2789,
          2791,
          2797,
          2801,
          2803,
          2819,
          2833,
          2837,
          2843,
          2851,
          2857,
          2861,
          2879,
          2887,
          2897,
          2903,
          2909,
          2917,
          2927,
          2939,
          2953,
          2957,
          2963,
          2969,
          2971,
          2999,
          3001,
          3011,
          3019,
          3023,
          3037,
          3041,
          3049,
          3061,
          3067,
          3079,
          3083,
          3089,
          3109,
          3119,
          3121,
          3137,
          3163,
          3167,
          3169,
          3181,
          3187,
          3191,
          3203,
          3209,
          3217,
          3221,
          3229,
          3251,
          3253,
          3257,
          3259,
          3271,
          3299,
          3301,
          3307,
          3313,
          3319,
          3323,
          3329,
          3331,
          3343,
          3347,
          3359,
          3361,
          3371,
          3373,
          3389,
          3391,
          3407,
          3413,
          3433,
          3449,
          3457,
          3461,
          3463,
          3467,
          3469,
          3491,
          3499,
          3511,
          3517,
          3527,
          3529,
          3533,
          3539,
          3541,
          3547,
          3557,
          3559,
          3571,
          3581,
          3583,
          3593,
          3607,
          3613,
          3617,
          3623,
          3631,
          3637,
          3643,
          3659,
          3671,
          3673,
          3677,
          3691,
          3697,
          3701,
          3709,
          3719,
          3727,
          3733,
          3739,
          3761,
          3767,
          3769,
          3779,
          3793,
          3797,
          3803,
          3821,
          3823,
          3833,
          3847,
          3851,
          3853,
          3863,
          3877,
          3881,
          3889,
          3907,
          3911,
          3917,
          3919,
          3923,
          3929,
          3931,
          3943,
          3947,
          3967,
          3989,
          4001,
          4003,
          4007,
          4013,
          4019,
          4021,
          4027,
          4049,
          4051,
          4057,
          4073,
          4079,
          4091,
          4093,
          4099,
          4111,
          4127,
          4129,
          4133,
          4139,
          4153,
          4157,
          4159,
          4177,
          4201,
          4211,
          4217,
          4219,
          4229,
          4231,
          4241,
          4243,
          4253,
          4259,
          4261,
          4271,
          4273,
          4283,
          4289,
          4297,
          4327,
          4337,
          4339,
          4349,
          4357,
          4363,
          4373,
          4391,
          4397,
          4409,
          4421,
          4423,
          4441,
          4447,
          4451,
          4457,
          4463,
          4481,
          4483,
          4493,
          4507,
          4513,
          4517,
          4519,
          4523,
          4547,
          4549,
          4561,
          4567,
          4583,
          4591,
          4597,
          4603,
          4621,
          4637,
          4639,
          4643,
          4649,
          4651,
          4657,
          4663,
          4673,
          4679,
          4691,
          4703,
          4721,
          4723,
          4729,
          4733,
          4751,
          4759,
          4783,
          4787,
          4789,
          4793,
          4799,
          4801,
          4813,
          4817,
          4831,
          4861,
          4871,
          4877,
          4889,
          4903,
          4909,
          4919,
          4931,
          4933,
          4937,
          4943,
          4951,
          4957,
          4967,
          4969,
          4973,
          4987,
          4993,
          4999,
          5003,
          5009,
          5011,
          5021,
          5023,
          5039,
          5051,
          5059,
          5077,
          5081,
          5087,
          5099,
          5101,
          5107,
          5113,
          5119,
          5147,
          5153,
          5167,
          5171,
          5179,
          5189,
          5197,
          5209,
          5227,
          5231,
          5233,
          5237,
          5261,
          5273,
          5279,
          5281,
          5297,
          5303,
          5309,
          5323,
          5333,
          5347,
          5351,
          5381,
          5387,
          5393,
          5399,
          5407,
          5413,
          5417,
          5419,
          5431,
          5437,
          5441,
          5443,
          5449,
          5471,
          5477,
          5479,
          5483,
          5501,
          5503,
          5507,
          5519,
          5521,
          5527,
          5531,
          5557,
          5563,
          5569,
          5573,
          5581,
          5591,
          5623,
          5639,
          5641,
          5647,
          5651,
          5653,
          5657,
          5659,
          5669,
          5683,
          5689,
          5693,
          5701,
          5711,
          5717,
          5737,
          5741,
          5743,
          5749,
          5779,
          5783,
          5791,
          5801,
          5807,
          5813,
          5821,
          5827,
          5839,
          5843,
          5849,
          5851,
          5857,
          5861,
          5867,
          5869,
          5879,
          5881,
          5897,
          5903,
          5923,
          5927,
          5939,
          5953,
          5981,
          5987,
          6007,
          6011,
          6029,
          6037,
          6043,
          6047,
          6053,
          6067,
          6073,
          6079,
          6089,
          6091,
          6101,
          6113,
          6121,
          6131,
          6133,
          6143,
          6151,
          6163,
          6173,
          6197,
          6199,
          6203,
          6211,
          6217,
          6221,
          6229,
          6247,
          6257,
          6263,
          6269,
          6271,
          6277,
          6287,
          6299,
          6301,
          6311,
          6317,
          6323,
          6329,
          6337,
          6343,
          6353,
          6359,
          6361,
          6367,
          6373,
          6379,
          6389,
          6397,
          6421,
          6427,
          6449,
          6451,
          6469,
          6473,
          6481,
          6491,
          6521,
          6529,
          6547,
          6551,
          6553,
          6563,
          6569,
          6571,
          6577,
          6581,
          6599,
          6607,
          6619,
          6637,
          6653,
          6659,
          6661,
          6673,
          6679,
          6689,
          6691,
          6701,
          6703,
          6709,
          6719,
          6733,
          6737,
          6761,
          6763,
          6779,
          6781,
          6791,
          6793,
          6803,
          6823,
          6827,
          6829,
          6833,
          6841,
          6857,
          6863,
          6869,
          6871,
          6883,
          6899,
          6907,
          6911,
          6917,
          6947,
          6949,
          6959,
          6961,
          6967,
          6971,
          6977,
          6983,
          6991,
          6997,
          7001,
          7013,
          7019,
          7027,
          7039,
          7043,
          7057,
          7069,
          7079,
          7103,
          7109,
          7121,
          7127,
          7129,
          7151,
          7159,
          7177,
          7187,
          7193,
          7207,
          7211,
          7213,
          7219,
          7229,
          7237,
          7243,
          7247,
          7253,
          7283,
          7297,
          7307,
          7309,
          7321,
          7331,
          7333,
          7349,
          7351,
          7369,
          7393,
          7411,
          7417,
          7433,
          7451,
          7457,
          7459,
          7477,
          7481,
          7487,
          7489,
          7499,
          7507,
          7517,
          7523,
          7529,
          7537,
          7541,
          7547,
          7549,
          7559,
          7561,
          7573,
          7577,
          7583,
          7589,
          7591,
          7603,
          7607,
          7621,
          7639,
          7643,
          7649,
          7669,
          7673,
          7681,
          7687,
          7691,
          7699,
          7703,
          7717,
          7723,
          7727,
          7741,
          7753,
          7757,
          7759,
          7789,
          7793,
          7817,
          7823,
          7829,
          7841,
          7853,
          7867,
          7873,
          7877,
          7879,
          7883,
          7901,
          7907,
          7919,
          7927,
          7933,
          7937,
          7949,
          7951,
          7963,
          7993,
          8009,
          8011,
          8017,
          8039,
          8053,
          8059,
          8069,
          8081,
          8087,
          8089,
          8093,
          8101,
          8111,
          8117,
          8123,
          8147,
          8161,
          8167,
          8171,
          8179,
          8191,
          8209,
          8219,
          8221,
          8231,
          8233,
          8237,
          8243,
          8263,
          8269,
          8273,
          8287,
          8291,
          8293,
          8297,
          8311,
          8317,
          8329,
          8353,
          8363,
          8369,
          8377,
          8387,
          8389,
          8419,
          8423,
          8429,
          8431,
          8443,
          8447,
          8461,
          8467,
          8501,
          8513,
          8521,
          8527,
          8537,
          8539,
          8543,
          8563,
          8573,
          8581,
          8597,
          8599,
          8609,
          8623,
          8627,
          8629,
          8641,
          8647,
          8663,
          8669,
          8677,
          8681,
          8689,
          8693,
          8699,
          8707,
          8713,
          8719,
          8731,
          8737,
          8741,
          8747,
          8753,
          8761,
          8779,
          8783,
          8803,
          8807,
          8819,
          8821,
          8831,
          8837,
          8839,
          8849,
          8861,
          8863,
          8867,
          8887,
          8893,
          8923,
          8929,
          8933,
          8941,
          8951,
          8963,
          8969,
          8971,
          8999,
          9001,
          9007,
          9011,
          9013,
          9029,
          9041,
          9043,
          9049,
          9059,
          9067,
          9091,
          9103,
          9109,
          9127,
          9133,
          9137,
          9151,
          9157,
          9161,
          9173,
          9181,
          9187,
          9199,
          9203,
          9209,
          9221,
          9227,
          9239,
          9241,
          9257,
          9277,
          9281,
          9283,
          9293,
          9311,
          9319,
          9323,
          9337,
          9341,
          9343,
          9349,
          9371,
          9377,
          9391,
          9397,
          9403,
          9413,
          9419,
          9421,
          9431,
          9433,
          9437,
          9439,
          9461,
          9463,
          9467,
          9473,
          9479,
          9491,
          9497,
          9511,
          9521,
          9533,
          9539,
          9547,
          9551,
          9587,
          9601,
          9613,
          9619,
          9623,
          9629,
          9631,
          9643,
          9649,
          9661,
          9677,
          9679,
          9689,
          9697,
          9719,
          9721,
          9733,
          9739,
          9743,
          9749,
          9767,
          9769,
          9781,
          9787,
          9791,
          9803,
          9811,
          9817,
          9829,
          9833,
          9839,
          9851,
          9857,
          9859,
          9871,
          9883,
          9887,
          9901,
          9907,
          9923,
          9929,
          9931,
          9941,
          9949,
          9967,
          9973,
          10007
        ],
        emotions: [
          "love",
          "joy",
          "surprise",
          "anger",
          "sadness",
          "fear"
        ],
        music_genres: {
          general: [
            "Rock",
            "Pop",
            "Hip-Hop",
            "Jazz",
            "Classical",
            "Electronic",
            "Country",
            "R&B",
            "Reggae",
            "Blues",
            "Metal",
            "Folk",
            "Alternative",
            "Punk",
            "Disco",
            "Funk",
            "Techno",
            "Indie",
            "Gospel",
            "Dance",
            "Children's",
            "World"
          ],
          alternative: [
            "Art Punk",
            "Alternative Rock",
            "Britpunk",
            "College Rock",
            "Crossover Thrash",
            "Crust Punk",
            "Emo / Emocore",
            "Experimental Rock",
            "Folk Punk",
            "Goth / Gothic Rock",
            "Grunge",
            "Hardcore Punk",
            "Hard Rock",
            "Indie Rock",
            "Lo-fi",
            "Musique Concrète",
            "New Wave",
            "Progressive Rock",
            "Punk",
            "Shoegaze",
            "Steampunk"
          ],
          blues: [
            "Acoustic Blues",
            "African Blues",
            "Blues Rock",
            "Blues Shouter",
            "British Blues",
            "Canadian Blues",
            "Chicago Blues",
            "Classic Blues",
            "Classic Female Blues",
            "Contemporary Blues",
            "Country Blues",
            "Dark Blues",
            "Delta Blues",
            "Detroit Blues",
            "Doom Blues",
            "Electric Blues",
            "Folk Blues",
            "Gospel Blues",
            "Harmonica Blues",
            "Hill Country Blues",
            "Hokum Blues",
            "Jazz Blues",
            "Jump Blues",
            "Kansas City Blues",
            "Louisiana Blues",
            "Memphis Blues",
            "Modern Blues",
            "New Orlean Blues",
            "NY Blues",
            "Piano Blues",
            "Piedmont Blues",
            "Punk Blues",
            "Ragtime Blues",
            "Rhythm Blues",
            "Soul Blues",
            "St.Louis Blues",
            "Soul Blues",
            "Swamp Blues",
            "Texas Blues",
            "Urban Blues",
            "Vandeville",
            "West Coast Blues"
          ],
          "children's": [
            "Lullabies",
            "Sing - Along",
            "Stories"
          ],
          classical: [
            "Avant-Garde",
            "Ballet",
            "Baroque",
            "Cantata",
            "Chamber Music",
            "String Quartet",
            "Chant",
            "Choral",
            "Classical Crossover",
            "Concerto",
            "Concerto Grosso",
            "Contemporary Classical",
            "Early Music",
            "Expressionist",
            "High Classical",
            "Impressionist",
            "Mass Requiem",
            "Medieval",
            "Minimalism",
            "Modern Composition",
            "Modern Classical",
            "Opera",
            "Oratorio",
            "Orchestral",
            "Organum",
            "Renaissance",
            "Romantic (early period)",
            "Romantic (later period)",
            "Sonata",
            "Symphonic",
            "Symphony",
            "Twelve-tone",
            "Wedding Music"
          ],
          country: [
            "Alternative Country",
            "Americana",
            "Australian Country",
            "Bakersfield Sound",
            "Bluegrass",
            "Blues Country",
            "Cajun Fiddle Tunes",
            "Christian Country",
            "Classic Country",
            "Close Harmony",
            "Contemporary Bluegrass",
            "Contemporary Country",
            "Country Gospel",
            "Country Pop",
            "Country Rap",
            "Country Rock",
            "Country Soul",
            "Cowboy / Western",
            "Cowpunk",
            "Dansband",
            "Honky Tonk",
            "Franco-Country",
            "Gulf and Western",
            "Hellbilly Music",
            "Honky Tonk",
            "Instrumental Country",
            "Lubbock Sound",
            "Nashville Sound",
            "Neotraditional Country",
            "Outlaw Country",
            "Progressive",
            "Psychobilly / Punkabilly",
            "Red Dirt",
            "Sertanejo",
            "Texas County",
            "Traditional Bluegrass",
            "Traditional Country",
            "Truck-Driving Country",
            "Urban Cowboy",
            "Western Swing"
          ],
          dance: [
            "Club / Club Dance",
            "Breakcore",
            "Breakbeat / Breakstep",
            "Chillstep",
            "Deep House",
            "Dubstep",
            "Dancehall",
            "Electro House",
            "Electroswing",
            "Exercise",
            "Future Garage",
            "Garage",
            "Glitch Hop",
            "Glitch Pop",
            "Grime",
            "Hardcore",
            "Hard Dance",
            "Hi-NRG / Eurodance",
            "Horrorcore",
            "House",
            "Jackin House",
            "Jungle / Drum n bass",
            "Liquid Dub",
            "Regstep",
            "Speedcore",
            "Techno",
            "Trance",
            "Trap"
          ],
          electronic: [
            "2-Step",
            "8bit",
            "Ambient",
            "Asian Underground",
            "Bassline",
            "Chillwave",
            "Chiptune",
            "Crunk",
            "Downtempo",
            "Drum & Bass",
            "Hard Step",
            "Electro",
            "Electro-swing",
            "Electroacoustic",
            "Electronica",
            "Electronic Rock",
            "Eurodance",
            "Hardstyle",
            "Hi-Nrg",
            "IDM/Experimental",
            "Industrial",
            "Trip Hop",
            "Vaporwave",
            "UK Garage",
            "House",
            "Dubstep",
            "Deep House",
            "EDM",
            "Future Bass",
            "Psychedelic trance"
          ],
          jazz: [
            "Acid Jazz",
            "Afro-Cuban Jazz",
            "Avant-Garde Jazz",
            "Bebop",
            "Big Band",
            "Blue Note",
            "British Dance Band (Jazz)",
            "Cape Jazz",
            "Chamber Jazz",
            "Contemporary Jazz",
            "Continental Jazz",
            "Cool Jazz",
            "Crossover Jazz",
            "Dark Jazz",
            "Dixieland",
            "Early Jazz",
            "Electro Swing (Jazz)",
            "Ethio-jazz",
            "Ethno-Jazz",
            "European Free Jazz",
            "Free Funk (Avant-Garde / Funk Jazz)",
            "Free Jazz",
            "Fusion",
            "Gypsy Jazz",
            "Hard Bop",
            "Indo Jazz",
            "Jazz Blues",
            "Jazz-Funk (see Free Funk)",
            "Jazz-Fusion",
            "Jazz Rap",
            "Jazz Rock",
            "Kansas City Jazz",
            "Latin Jazz",
            "M-Base Jazz",
            "Mainstream Jazz",
            "Modal Jazz",
            "Neo-Bop",
            "Neo-Swing",
            "Nu Jazz",
            "Orchestral Jazz",
            "Post-Bop",
            "Punk Jazz",
            "Ragtime",
            "Ska Jazz",
            "Skiffle (also Folk)",
            "Smooth Jazz",
            "Soul Jazz",
            "Swing Jazz",
            "Straight-Ahead Jazz",
            "Trad Jazz",
            "Third Stream",
            "Jazz-Funk",
            "Free Jazz",
            "West Coast Jazz"
          ],
          metal: [
            "Heavy Metal",
            "Speed Metal",
            "Thrash Metal",
            "Power Metal",
            "Death Metal",
            "Black Metal",
            "Pagan Metal",
            "Viking Metal",
            "Folk Metal",
            "Symphonic Metal",
            "Gothic Metal",
            "Glam Metal",
            "Hair Metal",
            "Doom Metal",
            "Groove Metal",
            "Industrial Metal",
            "Modern Metal",
            "Neoclassical Metal",
            "New Wave Of British Heavy Metal",
            "Post Metal",
            "Progressive Metal",
            "Avantgarde Metal",
            "Sludge",
            "Djent",
            "Drone",
            "Kawaii Metal",
            "Pirate Metal",
            "Nu Metal",
            "Neue Deutsche Härte",
            "Math Metal",
            "Crossover",
            "Grindcore",
            "Hardcore",
            "Metalcore",
            "Deathcore",
            "Post Hardcore",
            "Mathcore"
          ],
          folk: [
            "American Folk Revival",
            "Anti - Folk",
            "British Folk Revival",
            "Contemporary Folk",
            "Filk Music",
            "Freak Folk",
            "Indie Folk",
            "Industrial Folk",
            "Neofolk",
            "Progressive Folk",
            "Psychedelic Folk",
            "Sung Poetry",
            "Techno - Folk",
            "Folk Rock",
            "Old-time Music",
            "Bluegrass",
            "Appalachian",
            "Roots Revival",
            "Celtic",
            "Indie Folk"
          ],
          pop: [
            "Adult Contemporary",
            "Arab Pop",
            "Baroque",
            "Britpop",
            "Bubblegum Pop",
            "Chamber Pop",
            "Chanson",
            "Christian Pop",
            "Classical Crossover",
            "Europop",
            "Austropop",
            "Balkan Pop",
            "French Pop",
            "Korean Pop",
            "Japanese Pop",
            "Chinese Pop",
            "Latin Pop",
            "Laïkó",
            "Nederpop",
            "Russian Pop",
            "Dance Pop",
            "Dream Pop",
            "Electro Pop",
            "Iranian Pop",
            "Jangle Pop",
            "Latin Ballad",
            "Levenslied",
            "Louisiana Swamp Pop",
            "Mexican Pop",
            "Motorpop",
            "New Romanticism",
            "Orchestral Pop",
            "Pop Rap",
            "Popera",
            "Pop / Rock",
            "Pop Punk",
            "Power Pop",
            "Psychedelic Pop",
            "Russian Pop",
            "Schlager",
            "Soft Rock",
            "Sophisti - Pop",
            "Space Age Pop",
            "Sunshine Pop",
            "Surf Pop",
            "Synthpop",
            "Teen Pop",
            "Traditional Pop Music",
            "Turkish Pop",
            "Vispop",
            "Wonky Pop"
          ],
          "r&b": [
            "(Carolina) Beach Music",
            "Contemporary R & B",
            "Disco",
            "Doo Wop",
            "Funk",
            "Modern Soul",
            "Motown",
            "Neo - Soul",
            "Northern Soul",
            "Psychedelic Soul",
            "Quiet Storm",
            "Soul",
            "Soul Blues",
            "Southern Soul"
          ],
          reggae: [
            "2 - Tone",
            "Dub",
            "Roots Reggae",
            "Reggae Fusion",
            "Reggae en Español",
            "Spanish Reggae",
            "Reggae 110",
            "Reggae Bultrón",
            "Romantic Flow",
            "Lovers Rock",
            "Raggamuffin",
            "Ragga",
            "Dancehall",
            "Ska"
          ],
          rock: [
            "Acid Rock",
            "Adult - Oriented Rock",
            "Afro Punk",
            "Adult Alternative",
            "Alternative Rock",
            "American Traditional Rock",
            "Anatolian Rock",
            "Arena Rock",
            "Art Rock",
            "Blues - Rock",
            "British Invasion",
            "Cock Rock",
            "Death Metal / Black Metal",
            "Doom Metal",
            "Glam Rock",
            "Gothic Metal",
            "Grind Core",
            "Hair Metal",
            "Hard Rock",
            "Math Metal",
            "Math Rock",
            "Metal",
            "Metal Core",
            "Noise Rock",
            "Jam Bands",
            "Post Punk",
            "Post Rock",
            "Prog - Rock / Art Rock",
            "Progressive Metal",
            "Psychedelic",
            "Rock & Roll",
            "Rockabilly",
            "Roots Rock",
            "Singer / Songwriter",
            "Southern Rock",
            "Spazzcore",
            "Stoner Metal",
            "Surf",
            "Technical Death Metal",
            "Tex - Mex",
            "Thrash Metal",
            "Time Lord Rock(Trock)",
            "Trip - hop",
            "Yacht Rock",
            "School House Rock"
          ],
          "hip-hop": [
            "Alternative Rap",
            "Avant - Garde",
            "Bounce",
            "Chap Hop",
            "Christian Hip Hop",
            "Conscious Hip Hop",
            "Country - Rap",
            "Grunk",
            "Crunkcore",
            "Cumbia Rap",
            "Dirty South",
            "East Coast",
            "Brick City Club",
            "Hardcore Hip Hop",
            "Mafioso Rap",
            "New Jersey Hip Hop",
            "Freestyle Rap",
            "G - Funk",
            "Gangsta Rap",
            "Golden Age",
            "Grime",
            "Hardcore Rap",
            "Hip - Hop",
            "Hip Pop",
            "Horrorcore",
            "Hyphy",
            "Industrial Hip Hop",
            "Instrumental Hip Hop",
            "Jazz Rap",
            "Latin Rap",
            "Low Bap",
            "Lyrical Hip Hop",
            "Merenrap",
            "Midwest Hip Hop",
            "Chicago Hip Hop",
            "Detroit Hip Hop",
            "Horrorcore",
            "St.Louis Hip Hop",
            "Twin Cities Hip Hop",
            "Motswako",
            "Nerdcore",
            "New Jack Swing",
            "New School Hip Hop",
            "Old School Rap",
            "Rap",
            "Trap",
            "Turntablism",
            "Underground Rap",
            "West Coast Rap",
            "East Coast Rap",
            "Trap",
            "UK Grime",
            "Hyphy",
            "Emo-rap",
            "Cloud rap",
            "G-funk",
            "Boom Bap",
            "Mumble",
            "Drill",
            "UK Drill",
            "Soundcloud Rap",
            "Lo-fi"
          ],
          punk: [
            "Afro-punk",
            "Anarcho punk",
            "Art punk",
            "Christian punk",
            "Crust punk",
            "Deathrock",
            "Egg punk",
            "Garage punk",
            "Glam punk",
            "Hardcore punk",
            "Horror punk",
            "Incelcore/e-punk",
            "Oi!",
            "Peace punk",
            "Punk pathetique",
            "Queercore",
            "Riot Grrrl",
            "Skate punk",
            "Street punk",
            "Taqwacore",
            "Trallpunk"
          ],
          disco: [
            "Nu-disco",
            "Disco-funk",
            "Hi-NRG",
            "Italo Disco",
            "Eurodisco",
            "Boogie",
            "Space Disco",
            "Post-disco",
            "Electro Disco",
            "Disco House",
            "Disco Pop",
            "Soulful House"
          ],
          funk: [
            "Funk Rock",
            "P-Funk (Parliament-Funkadelic)",
            "Psychedelic Funk",
            "Funk Metal",
            "Electro-Funk",
            "Go-go",
            "Boogie-Funk",
            "Jazz-Funk",
            "Soul-Funk",
            "Funky Disco",
            "Nu-Funk",
            "Afrobeat",
            "Latin Funk",
            "G-Funk",
            "Acid Jazz",
            "Funktronica",
            "Folk-Funk",
            "Space Funk",
            "Ambient Funk",
            "Hard Funk",
            "Fusion Funk"
          ],
          techno: [
            "Acid Techno",
            "Ambient Techno",
            "Detroit Techno",
            "Dub Techno",
            "Minimal Techno",
            "Industrial Techno",
            "Hard Techno",
            "Trance",
            "Progressive Techno",
            "Tech House",
            "Electronica",
            "Breakbeat Techno",
            "Electro Techno",
            "Melodic Techno",
            "Experimental Techno",
            "Dark Techno",
            "Ebm",
            "Hypnotic Techno",
            "Psychedelic Techno",
            "Rave Techno",
            "Techno-Pop"
          ],
          indie: [
            "Indie Rock",
            "Indie Pop",
            "Indie Folk",
            "Indie Electronic",
            "Indie Punk",
            "Indie Hip-Hop",
            "Dream Pop",
            "Shoegaze",
            "Lo-fi",
            "Chillwave",
            "Freak Folk",
            "Noise Pop",
            "Math Rock",
            "Post-Punk",
            "Garage Rock",
            "Experimental Indie",
            "Surf Rock",
            "Alternative Country",
            "Indie Soul",
            "Art Rock",
            "Indie R&B",
            "Indietronica",
            "Emo",
            "Post-Rock",
            "Indie Pop-Rock",
            "Indie Synthpop",
            "Noise Rock",
            "Psych Folk",
            "Indie Blues"
          ],
          gospel: [
            "Traditional Gospel",
            "Contemporary Gospel",
            "Southern Gospel",
            "Black Gospel",
            "Urban Contemporary Gospel",
            "Gospel Blues",
            "Bluegrass Gospel",
            "Country Gospel",
            "Praise and Worship",
            "Christian Hip-Hop",
            "Gospel Jazz",
            "Reggae Gospel",
            "African Gospel",
            "Latin Gospel",
            "R&B Gospel",
            "Gospel Choir",
            "Acappella Gospel",
            "Instrumental Gospel",
            "Gospel Rap"
          ],
          world: [
            "African",
            "Arabic",
            "Asian",
            "Caribbean",
            "Celtic",
            "European",
            "Latin American",
            "Middle Eastern",
            "Native American",
            "Polynesian",
            "Reggae",
            "Ska",
            "Salsa",
            "Flamenco",
            "Bossa Nova",
            "Tango",
            "Fado",
            "Klezmer",
            "Balkan",
            "Afrobeat",
            "Mongolian Throat Singing",
            "Indian Classical",
            "Gamelan",
            "Sufi Music",
            "Zydeco",
            "Kora Music",
            "Andean Music",
            "Irish Traditional",
            "Gypsy Jazz",
            "Bollywood",
            "Bhangra",
            "Jawaiian",
            "Hawaiian Slack Key Guitar",
            "Calypso",
            "Cuban Son",
            "Taiko Drumming",
            "African Highlife",
            "Merengue",
            "Tuvan Throat Singing"
          ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
          smileys_and_emotion: [
            "0x1f600",
            "0x1f603",
            "0x1f604",
            "0x1f601",
            "0x1f606",
            "0x1f605",
            "0x1f923",
            "0x1f602",
            "0x1f642",
            "0x1f643",
            "0x1fae0",
            "0x1f609",
            "0x1f60a",
            "0x1f607",
            "0x1f970",
            "0x1f60d",
            "0x1f929",
            "0x1f618",
            "0x1f617",
            "0x263a",
            "0x1f61a",
            "0x1f619",
            "0x1f972",
            "0x1f60b",
            "0x1f61b",
            "0x1f61c",
            "0x1f92a",
            "0x1f61d",
            "0x1f911",
            "0x1f917",
            "0x1f92d",
            "0x1fae2",
            "0x1fae3",
            "0x1f92b",
            "0x1f914",
            "0x1fae1",
            "0x1f910",
            "0x1f928",
            "0x1f610",
            "0x1f611",
            "0x1f636",
            "0x1fae5",
            "0x1f636",
            "0x200d",
            "0x1f32b",
            "0xfe0f",
            "0x1f60f",
            "0x1f612",
            "0x1f644",
            "0x1f62c",
            "0x1f62e",
            "0x200d",
            "0x1f4a8",
            "0x1f925",
            "0x1fae8",
            "0x1f642",
            "0x200d",
            "0x2194",
            "0xfe0f",
            "0x1f642",
            "0x200d",
            "0x2195",
            "0xfe0f",
            "0x1f60c",
            "0x1f614",
            "0x1f62a",
            "0x1f924",
            "0x1f634",
            "0x1f637",
            "0x1f912",
            "0x1f915",
            "0x1f922",
            "0x1f92e",
            "0x1f927",
            "0x1f975",
            "0x1f976",
            "0x1f974",
            "0x1f635",
            "0x1f635",
            "0x200d",
            "0x1f4ab",
            "0x1f92f",
            "0x1f920",
            "0x1f973",
            "0x1f978",
            "0x1f60e",
            "0x1f913",
            "0x1f9d0",
            "0x1f615",
            "0x1fae4",
            "0x1f61f",
            "0x1f641",
            "0x2639",
            "0x1f62e",
            "0x1f62f",
            "0x1f632",
            "0x1f633",
            "0x1f97a",
            "0x1f979",
            "0x1f626",
            "0x1f627",
            "0x1f628",
            "0x1f630",
            "0x1f625",
            "0x1f622",
            "0x1f62d",
            "0x1f631",
            "0x1f616",
            "0x1f623",
            "0x1f61e",
            "0x1f613",
            "0x1f629",
            "0x1f62b",
            "0x1f971",
            "0x1f624",
            "0x1f621",
            "0x1f620",
            "0x1f92c",
            "0x1f608",
            "0x1f47f",
            "0x1f480",
            "0x2620",
            "0x1f4a9",
            "0x1f921",
            "0x1f479",
            "0x1f47a",
            "0x1f47b",
            "0x1f47d",
            "0x1f47e",
            "0x1f916",
            "0x1f63a",
            "0x1f638",
            "0x1f639",
            "0x1f63b",
            "0x1f63c",
            "0x1f63d",
            "0x1f640",
            "0x1f63f",
            "0x1f63e",
            "0x1f648",
            "0x1f649",
            "0x1f64a",
            "0x1f48c",
            "0x1f498",
            "0x1f49d",
            "0x1f496",
            "0x1f497",
            "0x1f493",
            "0x1f49e",
            "0x1f495",
            "0x1f49f",
            "0x2763",
            "0x1f494",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f525",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1fa79",
            "0x2764",
            "0x1fa77",
            "0x1f9e1",
            "0x1f49b",
            "0x1f49a",
            "0x1f499",
            "0x1fa75",
            "0x1f49c",
            "0x1f90e",
            "0x1f5a4",
            "0x1fa76",
            "0x1f90d",
            "0x1f48b",
            "0x1f4af",
            "0x1f4a2",
            "0x1f4a5",
            "0x1f4ab",
            "0x1f4a6",
            "0x1f4a8",
            "0x1f573",
            "0x1f4ac",
            "0x1f441",
            "0xfe0f",
            "0x200d",
            "0x1f5e8",
            "0xfe0f",
            "0x1f5e8",
            "0x1f5ef",
            "0x1f4ad",
            "0x1f4a4"
          ],
          people_and_body: [
            "0x1f44b",
            "0x1f91a",
            "0x1f590",
            "0x270b",
            "0x1f596",
            "0x1faf1",
            "0x1faf2",
            "0x1faf3",
            "0x1faf4",
            "0x1faf7",
            "0x1faf8",
            "0x1f44c",
            "0x1f90c",
            "0x1f90f",
            "0x270c",
            "0x1f91e",
            "0x1faf0",
            "0x1f91f",
            "0x1f918",
            "0x1f919",
            "0x1f448",
            "0x1f449",
            "0x1f446",
            "0x1f595",
            "0x1f447",
            "0x261d",
            "0x1faf5",
            "0x1f44d",
            "0x1f44e",
            "0x270a",
            "0x1f44a",
            "0x1f91b",
            "0x1f91c",
            "0x1f44f",
            "0x1f64c",
            "0x1faf6",
            "0x1f450",
            "0x1f932",
            "0x1f91d",
            "0x1f64f",
            "0x270d",
            "0x1f485",
            "0x1f933",
            "0x1f4aa",
            "0x1f9be",
            "0x1f9bf",
            "0x1f9b5",
            "0x1f9b6",
            "0x1f442",
            "0x1f9bb",
            "0x1f443",
            "0x1f9e0",
            "0x1fac0",
            "0x1fac1",
            "0x1f9b7",
            "0x1f9b4",
            "0x1f440",
            "0x1f441",
            "0x1f445",
            "0x1f444",
            "0x1fae6",
            "0x1f476",
            "0x1f9d2",
            "0x1f466",
            "0x1f467",
            "0x1f9d1",
            "0x1f471",
            "0x1f468",
            "0x1f9d4",
            "0x1f9d4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9b0",
            "0x1f468",
            "0x200d",
            "0x1f9b1",
            "0x1f468",
            "0x200d",
            "0x1f9b3",
            "0x1f468",
            "0x200d",
            "0x1f9b2",
            "0x1f469",
            "0x1f469",
            "0x200d",
            "0x1f9b0",
            "0x1f9d1",
            "0x200d",
            "0x1f9b0",
            "0x1f469",
            "0x200d",
            "0x1f9b1",
            "0x1f9d1",
            "0x200d",
            "0x1f9b1",
            "0x1f469",
            "0x200d",
            "0x1f9b3",
            "0x1f9d1",
            "0x200d",
            "0x1f9b3",
            "0x1f469",
            "0x200d",
            "0x1f9b2",
            "0x1f9d1",
            "0x200d",
            "0x1f9b2",
            "0x1f471",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f471",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d3",
            "0x1f474",
            "0x1f475",
            "0x1f64d",
            "0x1f64d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64e",
            "0x1f64e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f645",
            "0x1f645",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f645",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f646",
            "0x1f646",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f646",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f481",
            "0x1f481",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f481",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64b",
            "0x1f64b",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64b",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cf",
            "0x1f9cf",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cf",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f647",
            "0x1f647",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f647",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f926",
            "0x1f926",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f926",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f937",
            "0x1f937",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f937",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f393",
            "0x1f468",
            "0x200d",
            "0x1f393",
            "0x1f469",
            "0x200d",
            "0x1f393",
            "0x1f9d1",
            "0x200d",
            "0x1f3eb",
            "0x1f468",
            "0x200d",
            "0x1f3eb",
            "0x1f469",
            "0x200d",
            "0x1f3eb",
            "0x1f9d1",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f33e",
            "0x1f468",
            "0x200d",
            "0x1f33e",
            "0x1f469",
            "0x200d",
            "0x1f33e",
            "0x1f9d1",
            "0x200d",
            "0x1f373",
            "0x1f468",
            "0x200d",
            "0x1f373",
            "0x1f469",
            "0x200d",
            "0x1f373",
            "0x1f9d1",
            "0x200d",
            "0x1f527",
            "0x1f468",
            "0x200d",
            "0x1f527",
            "0x1f469",
            "0x200d",
            "0x1f527",
            "0x1f9d1",
            "0x200d",
            "0x1f3ed",
            "0x1f468",
            "0x200d",
            "0x1f3ed",
            "0x1f469",
            "0x200d",
            "0x1f3ed",
            "0x1f9d1",
            "0x200d",
            "0x1f4bc",
            "0x1f468",
            "0x200d",
            "0x1f4bc",
            "0x1f469",
            "0x200d",
            "0x1f4bc",
            "0x1f9d1",
            "0x200d",
            "0x1f52c",
            "0x1f468",
            "0x200d",
            "0x1f52c",
            "0x1f469",
            "0x200d",
            "0x1f52c",
            "0x1f9d1",
            "0x200d",
            "0x1f4bb",
            "0x1f468",
            "0x200d",
            "0x1f4bb",
            "0x1f469",
            "0x200d",
            "0x1f4bb",
            "0x1f9d1",
            "0x200d",
            "0x1f3a4",
            "0x1f468",
            "0x200d",
            "0x1f3a4",
            "0x1f469",
            "0x200d",
            "0x1f3a4",
            "0x1f9d1",
            "0x200d",
            "0x1f3a8",
            "0x1f468",
            "0x200d",
            "0x1f3a8",
            "0x1f469",
            "0x200d",
            "0x1f3a8",
            "0x1f9d1",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f680",
            "0x1f468",
            "0x200d",
            "0x1f680",
            "0x1f469",
            "0x200d",
            "0x1f680",
            "0x1f9d1",
            "0x200d",
            "0x1f692",
            "0x1f468",
            "0x200d",
            "0x1f692",
            "0x1f469",
            "0x200d",
            "0x1f692",
            "0x1f46e",
            "0x1f46e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f575",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f482",
            "0x1f482",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f482",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f977",
            "0x1f477",
            "0x1f477",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f477",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1fac5",
            "0x1f934",
            "0x1f478",
            "0x1f473",
            "0x1f473",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f473",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f472",
            "0x1f9d5",
            "0x1f935",
            "0x1f935",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f935",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f470",
            "0x1f470",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f470",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f930",
            "0x1fac3",
            "0x1fac4",
            "0x1f931",
            "0x1f469",
            "0x200d",
            "0x1f37c",
            "0x1f468",
            "0x200d",
            "0x1f37c",
            "0x1f9d1",
            "0x200d",
            "0x1f37c",
            "0x1f47c",
            "0x1f385",
            "0x1f936",
            "0x1f9d1",
            "0x200d",
            "0x1f384",
            "0x1f9b8",
            "0x1f9b8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9b9",
            "0x1f9b9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d9",
            "0x1f9d9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9da",
            "0x1f9da",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9da",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9db",
            "0x1f9db",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9db",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dc",
            "0x1f9dc",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dc",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dd",
            "0x1f9dd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9de",
            "0x1f9de",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9de",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9df",
            "0x1f9df",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9df",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cc",
            "0x1f486",
            "0x1f486",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f486",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f487",
            "0x1f487",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f487",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9cd",
            "0x1f9cd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f483",
            "0x1f57a",
            "0x1f574",
            "0x1f46f",
            "0x1f46f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d6",
            "0x1f9d6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d7",
            "0x1f9d7",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d7",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93a",
            "0x1f3c7",
            "0x26f7",
            "0x1f3c2",
            "0x1f3cc",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c4",
            "0x1f3c4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6a3",
            "0x1f6a3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6a3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3ca",
            "0x1f3ca",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3ca",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x26f9",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3cb",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b4",
            "0x1f6b4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b5",
            "0x1f6b5",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b5",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f938",
            "0x1f938",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f938",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93c",
            "0x1f93c",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93c",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93d",
            "0x1f93d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93e",
            "0x1f93e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f939",
            "0x1f939",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f939",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d8",
            "0x1f9d8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6c0",
            "0x1f6cc",
            "0x1f9d1",
            "0x200d",
            "0x1f91d",
            "0x200d",
            "0x1f9d1",
            "0x1f46d",
            "0x1f46b",
            "0x1f46c",
            "0x1f48f",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f469",
            "0x1f491",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f469",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f5e3",
            "0x1f464",
            "0x1f465",
            "0x1fac2",
            "0x1f46a",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f463"
          ],
          animals_and_nature: [
            "0x1f435",
            "0x1f412",
            "0x1f98d",
            "0x1f9a7",
            "0x1f436",
            "0x1f415",
            "0x1f9ae",
            "0x1f415",
            "0x200d",
            "0x1f9ba",
            "0x1f429",
            "0x1f43a",
            "0x1f98a",
            "0x1f99d",
            "0x1f431",
            "0x1f408",
            "0x1f408",
            "0x200d",
            "0x2b1b",
            "0x1f981",
            "0x1f42f",
            "0x1f405",
            "0x1f406",
            "0x1f434",
            "0x1face",
            "0x1facf",
            "0x1f40e",
            "0x1f984",
            "0x1f993",
            "0x1f98c",
            "0x1f9ac",
            "0x1f42e",
            "0x1f402",
            "0x1f403",
            "0x1f404",
            "0x1f437",
            "0x1f416",
            "0x1f417",
            "0x1f43d",
            "0x1f40f",
            "0x1f411",
            "0x1f410",
            "0x1f42a",
            "0x1f42b",
            "0x1f999",
            "0x1f992",
            "0x1f418",
            "0x1f9a3",
            "0x1f98f",
            "0x1f99b",
            "0x1f42d",
            "0x1f401",
            "0x1f400",
            "0x1f439",
            "0x1f430",
            "0x1f407",
            "0x1f43f",
            "0x1f9ab",
            "0x1f994",
            "0x1f987",
            "0x1f43b",
            "0x1f43b",
            "0x200d",
            "0x2744",
            "0xfe0f",
            "0x1f428",
            "0x1f43c",
            "0x1f9a5",
            "0x1f9a6",
            "0x1f9a8",
            "0x1f998",
            "0x1f9a1",
            "0x1f43e",
            "0x1f983",
            "0x1f414",
            "0x1f413",
            "0x1f423",
            "0x1f424",
            "0x1f425",
            "0x1f426",
            "0x1f427",
            "0x1f54a",
            "0x1f985",
            "0x1f986",
            "0x1f9a2",
            "0x1f989",
            "0x1f9a4",
            "0x1fab6",
            "0x1f9a9",
            "0x1f99a",
            "0x1f99c",
            "0x1fabd",
            "0x1f426",
            "0x200d",
            "0x2b1b",
            "0x1fabf",
            "0x1f426",
            "0x200d",
            "0x1f525",
            "0x1f438",
            "0x1f40a",
            "0x1f422",
            "0x1f98e",
            "0x1f40d",
            "0x1f432",
            "0x1f409",
            "0x1f995",
            "0x1f996",
            "0x1f433",
            "0x1f40b",
            "0x1f42c",
            "0x1f9ad",
            "0x1f41f",
            "0x1f420",
            "0x1f421",
            "0x1f988",
            "0x1f419",
            "0x1f41a",
            "0x1fab8",
            "0x1fabc",
            "0x1f40c",
            "0x1f98b",
            "0x1f41b",
            "0x1f41c",
            "0x1f41d",
            "0x1fab2",
            "0x1f41e",
            "0x1f997",
            "0x1fab3",
            "0x1f577",
            "0x1f578",
            "0x1f982",
            "0x1f99f",
            "0x1fab0",
            "0x1fab1",
            "0x1f9a0",
            "0x1f490",
            "0x1f338",
            "0x1f4ae",
            "0x1fab7",
            "0x1f3f5",
            "0x1f339",
            "0x1f940",
            "0x1f33a",
            "0x1f33b",
            "0x1f33c",
            "0x1f337",
            "0x1fabb",
            "0x1f331",
            "0x1fab4",
            "0x1f332",
            "0x1f333",
            "0x1f334",
            "0x1f335",
            "0x1f33e",
            "0x1f33f",
            "0x2618",
            "0x1f340",
            "0x1f341",
            "0x1f342",
            "0x1f343",
            "0x1fab9",
            "0x1faba",
            "0x1f344"
          ],
          food_and_drink: [
            "0x1f347",
            "0x1f348",
            "0x1f349",
            "0x1f34a",
            "0x1f34b",
            "0x1f34b",
            "0x200d",
            "0x1f7e9",
            "0x1f34c",
            "0x1f34d",
            "0x1f96d",
            "0x1f34e",
            "0x1f34f",
            "0x1f350",
            "0x1f351",
            "0x1f352",
            "0x1f353",
            "0x1fad0",
            "0x1f95d",
            "0x1f345",
            "0x1fad2",
            "0x1f965",
            "0x1f951",
            "0x1f346",
            "0x1f954",
            "0x1f955",
            "0x1f33d",
            "0x1f336",
            "0x1fad1",
            "0x1f952",
            "0x1f96c",
            "0x1f966",
            "0x1f9c4",
            "0x1f9c5",
            "0x1f95c",
            "0x1fad8",
            "0x1f330",
            "0x1fada",
            "0x1fadb",
            "0x1f344",
            "0x200d",
            "0x1f7eb",
            "0x1f35e",
            "0x1f950",
            "0x1f956",
            "0x1fad3",
            "0x1f968",
            "0x1f96f",
            "0x1f95e",
            "0x1f9c7",
            "0x1f9c0",
            "0x1f356",
            "0x1f357",
            "0x1f969",
            "0x1f953",
            "0x1f354",
            "0x1f35f",
            "0x1f355",
            "0x1f32d",
            "0x1f96a",
            "0x1f32e",
            "0x1f32f",
            "0x1fad4",
            "0x1f959",
            "0x1f9c6",
            "0x1f95a",
            "0x1f373",
            "0x1f958",
            "0x1f372",
            "0x1fad5",
            "0x1f963",
            "0x1f957",
            "0x1f37f",
            "0x1f9c8",
            "0x1f9c2",
            "0x1f96b",
            "0x1f371",
            "0x1f358",
            "0x1f359",
            "0x1f35a",
            "0x1f35b",
            "0x1f35c",
            "0x1f35d",
            "0x1f360",
            "0x1f362",
            "0x1f363",
            "0x1f364",
            "0x1f365",
            "0x1f96e",
            "0x1f361",
            "0x1f95f",
            "0x1f960",
            "0x1f961",
            "0x1f980",
            "0x1f99e",
            "0x1f990",
            "0x1f991",
            "0x1f9aa",
            "0x1f366",
            "0x1f367",
            "0x1f368",
            "0x1f369",
            "0x1f36a",
            "0x1f382",
            "0x1f370",
            "0x1f9c1",
            "0x1f967",
            "0x1f36b",
            "0x1f36c",
            "0x1f36d",
            "0x1f36e",
            "0x1f36f",
            "0x1f37c",
            "0x1f95b",
            "0x2615",
            "0x1fad6",
            "0x1f375",
            "0x1f376",
            "0x1f37e",
            "0x1f377",
            "0x1f378",
            "0x1f379",
            "0x1f37a",
            "0x1f37b",
            "0x1f942",
            "0x1f943",
            "0x1fad7",
            "0x1f964",
            "0x1f9cb",
            "0x1f9c3",
            "0x1f9c9",
            "0x1f9ca",
            "0x1f962",
            "0x1f37d",
            "0x1f374",
            "0x1f944",
            "0x1f52a",
            "0x1fad9",
            "0x1f3fa"
          ],
          travel_and_places: [
            "0x1f30d",
            "0x1f30e",
            "0x1f30f",
            "0x1f310",
            "0x1f5fa",
            "0x1f5fe",
            "0x1f9ed",
            "0x1f3d4",
            "0x26f0",
            "0x1f30b",
            "0x1f5fb",
            "0x1f3d5",
            "0x1f3d6",
            "0x1f3dc",
            "0x1f3dd",
            "0x1f3de",
            "0x1f3df",
            "0x1f3db",
            "0x1f3d7",
            "0x1f9f1",
            "0x1faa8",
            "0x1fab5",
            "0x1f6d6",
            "0x1f3d8",
            "0x1f3da",
            "0x1f3e0",
            "0x1f3e1",
            "0x1f3e2",
            "0x1f3e3",
            "0x1f3e4",
            "0x1f3e5",
            "0x1f3e6",
            "0x1f3e8",
            "0x1f3e9",
            "0x1f3ea",
            "0x1f3eb",
            "0x1f3ec",
            "0x1f3ed",
            "0x1f3ef",
            "0x1f3f0",
            "0x1f492",
            "0x1f5fc",
            "0x1f5fd",
            "0x26ea",
            "0x1f54c",
            "0x1f6d5",
            "0x1f54d",
            "0x26e9",
            "0x1f54b",
            "0x26f2",
            "0x26fa",
            "0x1f301",
            "0x1f303",
            "0x1f3d9",
            "0x1f304",
            "0x1f305",
            "0x1f306",
            "0x1f307",
            "0x1f309",
            "0x2668",
            "0x1f3a0",
            "0x1f6dd",
            "0x1f3a1",
            "0x1f3a2",
            "0x1f488",
            "0x1f3aa",
            "0x1f682",
            "0x1f683",
            "0x1f684",
            "0x1f685",
            "0x1f686",
            "0x1f687",
            "0x1f688",
            "0x1f689",
            "0x1f68a",
            "0x1f69d",
            "0x1f69e",
            "0x1f68b",
            "0x1f68c",
            "0x1f68d",
            "0x1f68e",
            "0x1f690",
            "0x1f691",
            "0x1f692",
            "0x1f693",
            "0x1f694",
            "0x1f695",
            "0x1f696",
            "0x1f697",
            "0x1f698",
            "0x1f699",
            "0x1f6fb",
            "0x1f69a",
            "0x1f69b",
            "0x1f69c",
            "0x1f3ce",
            "0x1f3cd",
            "0x1f6f5",
            "0x1f9bd",
            "0x1f9bc",
            "0x1f6fa",
            "0x1f6b2",
            "0x1f6f4",
            "0x1f6f9",
            "0x1f6fc",
            "0x1f68f",
            "0x1f6e3",
            "0x1f6e4",
            "0x1f6e2",
            "0x26fd",
            "0x1f6de",
            "0x1f6a8",
            "0x1f6a5",
            "0x1f6a6",
            "0x1f6d1",
            "0x1f6a7",
            "0x2693",
            "0x1f6df",
            "0x26f5",
            "0x1f6f6",
            "0x1f6a4",
            "0x1f6f3",
            "0x26f4",
            "0x1f6e5",
            "0x1f6a2",
            "0x2708",
            "0x1f6e9",
            "0x1f6eb",
            "0x1f6ec",
            "0x1fa82",
            "0x1f4ba",
            "0x1f681",
            "0x1f69f",
            "0x1f6a0",
            "0x1f6a1",
            "0x1f6f0",
            "0x1f680",
            "0x1f6f8",
            "0x1f6ce",
            "0x1f9f3",
            "0x231b",
            "0x23f3",
            "0x231a",
            "0x23f0",
            "0x23f1",
            "0x23f2",
            "0x1f570",
            "0x1f55b",
            "0x1f567",
            "0x1f550",
            "0x1f55c",
            "0x1f551",
            "0x1f55d",
            "0x1f552",
            "0x1f55e",
            "0x1f553",
            "0x1f55f",
            "0x1f554",
            "0x1f560",
            "0x1f555",
            "0x1f561",
            "0x1f556",
            "0x1f562",
            "0x1f557",
            "0x1f563",
            "0x1f558",
            "0x1f564",
            "0x1f559",
            "0x1f565",
            "0x1f55a",
            "0x1f566",
            "0x1f311",
            "0x1f312",
            "0x1f313",
            "0x1f314",
            "0x1f315",
            "0x1f316",
            "0x1f317",
            "0x1f318",
            "0x1f319",
            "0x1f31a",
            "0x1f31b",
            "0x1f31c",
            "0x1f321",
            "0x2600",
            "0x1f31d",
            "0x1f31e",
            "0x1fa90",
            "0x2b50",
            "0x1f31f",
            "0x1f320",
            "0x1f30c",
            "0x2601",
            "0x26c5",
            "0x26c8",
            "0x1f324",
            "0x1f325",
            "0x1f326",
            "0x1f327",
            "0x1f328",
            "0x1f329",
            "0x1f32a",
            "0x1f32b",
            "0x1f32c",
            "0x1f300",
            "0x1f308",
            "0x1f302",
            "0x2602",
            "0x2614",
            "0x26f1",
            "0x26a1",
            "0x2744",
            "0x2603",
            "0x26c4",
            "0x2604",
            "0x1f525",
            "0x1f4a7",
            "0x1f30a"
          ],
          activities: [
            "0x1f383",
            "0x1f384",
            "0x1f386",
            "0x1f387",
            "0x1f9e8",
            "0x2728",
            "0x1f388",
            "0x1f389",
            "0x1f38a",
            "0x1f38b",
            "0x1f38d",
            "0x1f38e",
            "0x1f38f",
            "0x1f390",
            "0x1f391",
            "0x1f9e7",
            "0x1f380",
            "0x1f381",
            "0x1f397",
            "0x1f39f",
            "0x1f3ab",
            "0x1f396",
            "0x1f3c6",
            "0x1f3c5",
            "0x1f947",
            "0x1f948",
            "0x1f949",
            "0x26bd",
            "0x26be",
            "0x1f94e",
            "0x1f3c0",
            "0x1f3d0",
            "0x1f3c8",
            "0x1f3c9",
            "0x1f3be",
            "0x1f94f",
            "0x1f3b3",
            "0x1f3cf",
            "0x1f3d1",
            "0x1f3d2",
            "0x1f94d",
            "0x1f3d3",
            "0x1f3f8",
            "0x1f94a",
            "0x1f94b",
            "0x1f945",
            "0x26f3",
            "0x26f8",
            "0x1f3a3",
            "0x1f93f",
            "0x1f3bd",
            "0x1f3bf",
            "0x1f6f7",
            "0x1f94c",
            "0x1f3af",
            "0x1fa80",
            "0x1fa81",
            "0x1f52b",
            "0x1f3b1",
            "0x1f52e",
            "0x1fa84",
            "0x1f3ae",
            "0x1f579",
            "0x1f3b0",
            "0x1f3b2",
            "0x1f9e9",
            "0x1f9f8",
            "0x1fa85",
            "0x1faa9",
            "0x1fa86",
            "0x2660",
            "0x2665",
            "0x2666",
            "0x2663",
            "0x265f",
            "0x1f0cf",
            "0x1f004",
            "0x1f3b4",
            "0x1f3ad",
            "0x1f5bc",
            "0x1f3a8",
            "0x1f9f5",
            "0x1faa1",
            "0x1f9f6",
            "0x1faa2"
          ],
          objects: [
            "0x1f453",
            "0x1f576",
            "0x1f97d",
            "0x1f97c",
            "0x1f9ba",
            "0x1f454",
            "0x1f455",
            "0x1f456",
            "0x1f9e3",
            "0x1f9e4",
            "0x1f9e5",
            "0x1f9e6",
            "0x1f457",
            "0x1f458",
            "0x1f97b",
            "0x1fa71",
            "0x1fa72",
            "0x1fa73",
            "0x1f459",
            "0x1f45a",
            "0x1faad",
            "0x1f45b",
            "0x1f45c",
            "0x1f45d",
            "0x1f6cd",
            "0x1f392",
            "0x1fa74",
            "0x1f45e",
            "0x1f45f",
            "0x1f97e",
            "0x1f97f",
            "0x1f460",
            "0x1f461",
            "0x1fa70",
            "0x1f462",
            "0x1faae",
            "0x1f451",
            "0x1f452",
            "0x1f3a9",
            "0x1f393",
            "0x1f9e2",
            "0x1fa96",
            "0x26d1",
            "0x1f4ff",
            "0x1f484",
            "0x1f48d",
            "0x1f48e",
            "0x1f507",
            "0x1f508",
            "0x1f509",
            "0x1f50a",
            "0x1f4e2",
            "0x1f4e3",
            "0x1f4ef",
            "0x1f514",
            "0x1f515",
            "0x1f3bc",
            "0x1f3b5",
            "0x1f3b6",
            "0x1f399",
            "0x1f39a",
            "0x1f39b",
            "0x1f3a4",
            "0x1f3a7",
            "0x1f4fb",
            "0x1f3b7",
            "0x1fa97",
            "0x1f3b8",
            "0x1f3b9",
            "0x1f3ba",
            "0x1f3bb",
            "0x1fa95",
            "0x1f941",
            "0x1fa98",
            "0x1fa87",
            "0x1fa88",
            "0x1f4f1",
            "0x1f4f2",
            "0x260e",
            "0x1f4de",
            "0x1f4df",
            "0x1f4e0",
            "0x1f50b",
            "0x1faab",
            "0x1f50c",
            "0x1f4bb",
            "0x1f5a5",
            "0x1f5a8",
            "0x2328",
            "0x1f5b1",
            "0x1f5b2",
            "0x1f4bd",
            "0x1f4be",
            "0x1f4bf",
            "0x1f4c0",
            "0x1f9ee",
            "0x1f3a5",
            "0x1f39e",
            "0x1f4fd",
            "0x1f3ac",
            "0x1f4fa",
            "0x1f4f7",
            "0x1f4f8",
            "0x1f4f9",
            "0x1f4fc",
            "0x1f50d",
            "0x1f50e",
            "0x1f56f",
            "0x1f4a1",
            "0x1f526",
            "0x1f3ee",
            "0x1fa94",
            "0x1f4d4",
            "0x1f4d5",
            "0x1f4d6",
            "0x1f4d7",
            "0x1f4d8",
            "0x1f4d9",
            "0x1f4da",
            "0x1f4d3",
            "0x1f4d2",
            "0x1f4c3",
            "0x1f4dc",
            "0x1f4c4",
            "0x1f4f0",
            "0x1f5de",
            "0x1f4d1",
            "0x1f516",
            "0x1f3f7",
            "0x1f4b0",
            "0x1fa99",
            "0x1f4b4",
            "0x1f4b5",
            "0x1f4b6",
            "0x1f4b7",
            "0x1f4b8",
            "0x1f4b3",
            "0x1f9fe",
            "0x1f4b9",
            "0x2709",
            "0x1f4e7",
            "0x1f4e8",
            "0x1f4e9",
            "0x1f4e4",
            "0x1f4e5",
            "0x1f4e6",
            "0x1f4eb",
            "0x1f4ea",
            "0x1f4ec",
            "0x1f4ed",
            "0x1f4ee",
            "0x1f5f3",
            "0x270f",
            "0x2712",
            "0x1f58b",
            "0x1f58a",
            "0x1f58c",
            "0x1f58d",
            "0x1f4dd",
            "0x1f4bc",
            "0x1f4c1",
            "0x1f4c2",
            "0x1f5c2",
            "0x1f4c5",
            "0x1f4c6",
            "0x1f5d2",
            "0x1f5d3",
            "0x1f4c7",
            "0x1f4c8",
            "0x1f4c9",
            "0x1f4ca",
            "0x1f4cb",
            "0x1f4cc",
            "0x1f4cd",
            "0x1f4ce",
            "0x1f587",
            "0x1f4cf",
            "0x1f4d0",
            "0x2702",
            "0x1f5c3",
            "0x1f5c4",
            "0x1f5d1",
            "0x1f512",
            "0x1f513",
            "0x1f50f",
            "0x1f510",
            "0x1f511",
            "0x1f5dd",
            "0x1f528",
            "0x1fa93",
            "0x26cf",
            "0x2692",
            "0x1f6e0",
            "0x1f5e1",
            "0x2694",
            "0x1f4a3",
            "0x1fa83",
            "0x1f3f9",
            "0x1f6e1",
            "0x1fa9a",
            "0x1f527",
            "0x1fa9b",
            "0x1f529",
            "0x2699",
            "0x1f5dc",
            "0x2696",
            "0x1f9af",
            "0x1f517",
            "0x26d3",
            "0xfe0f",
            "0x200d",
            "0x1f4a5",
            "0x26d3",
            "0x1fa9d",
            "0x1f9f0",
            "0x1f9f2",
            "0x1fa9c",
            "0x2697",
            "0x1f9ea",
            "0x1f9eb",
            "0x1f9ec",
            "0x1f52c",
            "0x1f52d",
            "0x1f4e1",
            "0x1f489",
            "0x1fa78",
            "0x1f48a",
            "0x1fa79",
            "0x1fa7c",
            "0x1fa7a",
            "0x1fa7b",
            "0x1f6aa",
            "0x1f6d7",
            "0x1fa9e",
            "0x1fa9f",
            "0x1f6cf",
            "0x1f6cb",
            "0x1fa91",
            "0x1f6bd",
            "0x1faa0",
            "0x1f6bf",
            "0x1f6c1",
            "0x1faa4",
            "0x1fa92",
            "0x1f9f4",
            "0x1f9f7",
            "0x1f9f9",
            "0x1f9fa",
            "0x1f9fb",
            "0x1faa3",
            "0x1f9fc",
            "0x1fae7",
            "0x1faa5",
            "0x1f9fd",
            "0x1f9ef",
            "0x1f6d2",
            "0x1f6ac",
            "0x26b0",
            "0x1faa6",
            "0x26b1",
            "0x1f9ff",
            "0x1faac",
            "0x1f5ff",
            "0x1faa7",
            "0x1faaa"
          ],
          symbols: [
            "0x1f3e7",
            "0x1f6ae",
            "0x1f6b0",
            "0x267f",
            "0x1f6b9",
            "0x1f6ba",
            "0x1f6bb",
            "0x1f6bc",
            "0x1f6be",
            "0x1f6c2",
            "0x1f6c3",
            "0x1f6c4",
            "0x1f6c5",
            "0x26a0",
            "0x1f6b8",
            "0x26d4",
            "0x1f6ab",
            "0x1f6b3",
            "0x1f6ad",
            "0x1f6af",
            "0x1f6b1",
            "0x1f6b7",
            "0x1f4f5",
            "0x1f51e",
            "0x2622",
            "0x2623",
            "0x2b06",
            "0x2197",
            "0x27a1",
            "0x2198",
            "0x2b07",
            "0x2199",
            "0x2b05",
            "0x2196",
            "0x2195",
            "0x2194",
            "0x21a9",
            "0x21aa",
            "0x2934",
            "0x2935",
            "0x1f503",
            "0x1f504",
            "0x1f519",
            "0x1f51a",
            "0x1f51b",
            "0x1f51c",
            "0x1f51d",
            "0x1f6d0",
            "0x269b",
            "0x1f549",
            "0x2721",
            "0x2638",
            "0x262f",
            "0x271d",
            "0x2626",
            "0x262a",
            "0x262e",
            "0x1f54e",
            "0x1f52f",
            "0x1faaf",
            "0x2648",
            "0x2649",
            "0x264a",
            "0x264b",
            "0x264c",
            "0x264d",
            "0x264e",
            "0x264f",
            "0x2650",
            "0x2651",
            "0x2652",
            "0x2653",
            "0x26ce",
            "0x1f500",
            "0x1f501",
            "0x1f502",
            "0x25b6",
            "0x23e9",
            "0x23ed",
            "0x23ef",
            "0x25c0",
            "0x23ea",
            "0x23ee",
            "0x1f53c",
            "0x23eb",
            "0x1f53d",
            "0x23ec",
            "0x23f8",
            "0x23f9",
            "0x23fa",
            "0x23cf",
            "0x1f3a6",
            "0x1f505",
            "0x1f506",
            "0x1f4f6",
            "0x1f6dc",
            "0x1f4f3",
            "0x1f4f4",
            "0x2640",
            "0x2642",
            "0x26a7",
            "0x2716",
            "0x2795",
            "0x2796",
            "0x2797",
            "0x1f7f0",
            "0x267e",
            "0x203c",
            "0x2049",
            "0x2753",
            "0x2754",
            "0x2755",
            "0x2757",
            "0x3030",
            "0x1f4b1",
            "0x1f4b2",
            "0x2695",
            "0x267b",
            "0x269c",
            "0x1f531",
            "0x1f4db",
            "0x1f530",
            "0x2b55",
            "0x2705",
            "0x2611",
            "0x2714",
            "0x274c",
            "0x274e",
            "0x27b0",
            "0x27bf",
            "0x303d",
            "0x2733",
            "0x2734",
            "0x2747",
            "0x00a9",
            "0x00ae",
            "0x2122",
            "0x0023",
            "0xfe0f",
            "0x20e3",
            "0x002a",
            "0xfe0f",
            "0x20e3",
            "0x0030",
            "0xfe0f",
            "0x20e3",
            "0x0031",
            "0xfe0f",
            "0x20e3",
            "0x0032",
            "0xfe0f",
            "0x20e3",
            "0x0033",
            "0xfe0f",
            "0x20e3",
            "0x0034",
            "0xfe0f",
            "0x20e3",
            "0x0035",
            "0xfe0f",
            "0x20e3",
            "0x0036",
            "0xfe0f",
            "0x20e3",
            "0x0037",
            "0xfe0f",
            "0x20e3",
            "0x0038",
            "0xfe0f",
            "0x20e3",
            "0x0039",
            "0xfe0f",
            "0x20e3",
            "0x1f51f",
            "0x1f520",
            "0x1f521",
            "0x1f522",
            "0x1f523",
            "0x1f524",
            "0x1f170",
            "0x1f18e",
            "0x1f171",
            "0x1f191",
            "0x1f192",
            "0x1f193",
            "0x2139",
            "0x1f194",
            "0x24c2",
            "0x1f195",
            "0x1f196",
            "0x1f17e",
            "0x1f197",
            "0x1f17f",
            "0x1f198",
            "0x1f199",
            "0x1f19a",
            "0x1f201",
            "0x1f202",
            "0x1f237",
            "0x1f236",
            "0x1f22f",
            "0x1f250",
            "0x1f239",
            "0x1f21a",
            "0x1f232",
            "0x1f251",
            "0x1f238",
            "0x1f234",
            "0x1f233",
            "0x3297",
            "0x3299",
            "0x1f23a",
            "0x1f235",
            "0x1f534",
            "0x1f7e0",
            "0x1f7e1",
            "0x1f7e2",
            "0x1f535",
            "0x1f7e3",
            "0x1f7e4",
            "0x26ab",
            "0x26aa",
            "0x1f7e5",
            "0x1f7e7",
            "0x1f7e8",
            "0x1f7e9",
            "0x1f7e6",
            "0x1f7ea",
            "0x1f7eb",
            "0x2b1b",
            "0x2b1c",
            "0x25fc",
            "0x25fb",
            "0x25fe",
            "0x25fd",
            "0x25aa",
            "0x25ab",
            "0x1f536",
            "0x1f537",
            "0x1f538",
            "0x1f539",
            "0x1f53a",
            "0x1f53b",
            "0x1f4a0",
            "0x1f518",
            "0x1f533",
            "0x1f532"
          ],
          flags: [
            "0x1f3c1",
            "0x1f6a9",
            "0x1f38c",
            "0x1f3f4",
            "0x1f3f3",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x1f308",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x26a7",
            "0xfe0f",
            "0x1f3f4",
            "0x200d",
            "0x2620",
            "0xfe0f",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e9",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1eb",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ee",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f4",
            "0x1f1e6",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fc",
            "0x1f1e6",
            "0x1f1fd",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1e7",
            "0x1f1e6",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e9",
            "0x1f1e7",
            "0x1f1ea",
            "0x1f1e7",
            "0x1f1eb",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ed",
            "0x1f1e7",
            "0x1f1ee",
            "0x1f1e7",
            "0x1f1ef",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f2",
            "0x1f1e7",
            "0x1f1f3",
            "0x1f1e7",
            "0x1f1f4",
            "0x1f1e7",
            "0x1f1f6",
            "0x1f1e7",
            "0x1f1f7",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f9",
            "0x1f1e7",
            "0x1f1fb",
            "0x1f1e7",
            "0x1f1fc",
            "0x1f1e7",
            "0x1f1fe",
            "0x1f1e7",
            "0x1f1ff",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e9",
            "0x1f1e8",
            "0x1f1eb",
            "0x1f1e8",
            "0x1f1ec",
            "0x1f1e8",
            "0x1f1ed",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1f0",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f4",
            "0x1f1e8",
            "0x1f1f5",
            "0x1f1e8",
            "0x1f1f7",
            "0x1f1e8",
            "0x1f1fa",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fc",
            "0x1f1e8",
            "0x1f1fd",
            "0x1f1e8",
            "0x1f1fe",
            "0x1f1e8",
            "0x1f1ff",
            "0x1f1e9",
            "0x1f1ea",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ef",
            "0x1f1e9",
            "0x1f1f0",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f4",
            "0x1f1e9",
            "0x1f1ff",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e8",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ed",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f9",
            "0x1f1ea",
            "0x1f1fa",
            "0x1f1eb",
            "0x1f1ee",
            "0x1f1eb",
            "0x1f1ef",
            "0x1f1eb",
            "0x1f1f0",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f4",
            "0x1f1eb",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1eb",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ed",
            "0x1f1ec",
            "0x1f1ee",
            "0x1f1ec",
            "0x1f1f1",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f6",
            "0x1f1ec",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fc",
            "0x1f1ec",
            "0x1f1fe",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f3",
            "0x1f1ed",
            "0x1f1f7",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1fa",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e9",
            "0x1f1ee",
            "0x1f1ea",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f2",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f4",
            "0x1f1ee",
            "0x1f1f6",
            "0x1f1ee",
            "0x1f1f7",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1ea",
            "0x1f1ef",
            "0x1f1f2",
            "0x1f1ef",
            "0x1f1f4",
            "0x1f1ef",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1ea",
            "0x1f1f0",
            "0x1f1ec",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ee",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f3",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f7",
            "0x1f1f0",
            "0x1f1fc",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1f0",
            "0x1f1ff",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1f0",
            "0x1f1f1",
            "0x1f1f7",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1fa",
            "0x1f1f1",
            "0x1f1fb",
            "0x1f1f1",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1ea",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f1",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f3",
            "0x1f1f2",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f6",
            "0x1f1f2",
            "0x1f1f7",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fb",
            "0x1f1f2",
            "0x1f1fc",
            "0x1f1f2",
            "0x1f1fd",
            "0x1f1f2",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1f3",
            "0x1f1e6",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1ea",
            "0x1f1f3",
            "0x1f1eb",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1f1",
            "0x1f1f3",
            "0x1f1f4",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f7",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1ff",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1e6",
            "0x1f1f5",
            "0x1f1ea",
            "0x1f1f5",
            "0x1f1eb",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ed",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f1",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f7",
            "0x1f1f5",
            "0x1f1f8",
            "0x1f1f5",
            "0x1f1f9",
            "0x1f1f5",
            "0x1f1fc",
            "0x1f1f5",
            "0x1f1fe",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1f4",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1fa",
            "0x1f1f7",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e8",
            "0x1f1f8",
            "0x1f1e9",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ed",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ef",
            "0x1f1f8",
            "0x1f1f0",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f3",
            "0x1f1f8",
            "0x1f1f4",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f9",
            "0x1f1f8",
            "0x1f1fb",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f8",
            "0x1f1fe",
            "0x1f1f8",
            "0x1f1ff",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e8",
            "0x1f1f9",
            "0x1f1e9",
            "0x1f1f9",
            "0x1f1eb",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1f9",
            "0x1f1f0",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f3",
            "0x1f1f9",
            "0x1f1f4",
            "0x1f1f9",
            "0x1f1f7",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1fb",
            "0x1f1f9",
            "0x1f1fc",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f8",
            "0x1f1fa",
            "0x1f1fe",
            "0x1f1fa",
            "0x1f1ff",
            "0x1f1fb",
            "0x1f1e6",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1ea",
            "0x1f1fb",
            "0x1f1ec",
            "0x1f1fb",
            "0x1f1ee",
            "0x1f1fb",
            "0x1f1f3",
            "0x1f1fb",
            "0x1f1fa",
            "0x1f1fc",
            "0x1f1eb",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1ea",
            "0x1f1fe",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1fc",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0065",
            "0xe006e",
            "0xe0067",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0073",
            "0xe0063",
            "0xe0074",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0077",
            "0xe006c",
            "0xe0073",
            "0xe007f"
          ]
        }
      }, S = Object.prototype.hasOwnProperty, A = Object.keys || function(d) {
        var m = [];
        for (var v in d)
          S.call(d, v) && m.push(v);
        return m;
      };
      function I(d, m) {
        for (var v = A(d), k, O = 0, G = v.length; O < G; O++)
          k = v[O], m[k] = d[k] || m[k];
      }
      function M(d, m) {
        for (var v = 0, k = d.length; v < k; v++)
          m[v] = d[v];
      }
      function B(d, m) {
        var v = Array.isArray(d), k = m || (v ? new Array(d.length) : {});
        return v ? M(d, k) : I(d, k), k;
      }
      u.prototype.get = function(d) {
        return B(x[d]);
      }, u.prototype.mac_address = function(d) {
        d = f(d), d.separator || (d.separator = d.networkVersion ? "." : ":");
        var m = "ABCDEF1234567890", v = "";
        return d.networkVersion ? v = this.n(this.string, 3, { pool: m, length: 4 }).join(d.separator) : v = this.n(this.string, 6, { pool: m, length: 2 }).join(d.separator), v;
      }, u.prototype.normal = function(d) {
        if (d = f(d, { mean: 0, dev: 1, pool: [] }), p(
          d.pool.constructor !== Array,
          "Chance: The pool option must be a valid array."
        ), p(
          typeof d.mean != "number",
          "Chance: Mean (mean) must be a number"
        ), p(
          typeof d.dev != "number",
          "Chance: Standard deviation (dev) must be a number"
        ), d.pool.length > 0)
          return this.normal_pool(d);
        var m, v, k, O, G = d.mean, H = d.dev;
        do
          v = this.random() * 2 - 1, k = this.random() * 2 - 1, m = v * v + k * k;
        while (m >= 1);
        return O = v * Math.sqrt(-2 * Math.log(m) / m), H * O + G;
      }, u.prototype.normal_pool = function(d) {
        var m = 0;
        do {
          var v = Math.round(this.normal({ mean: d.mean, dev: d.dev }));
          if (v < d.pool.length && v >= 0)
            return d.pool[v];
          m++;
        } while (m < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
      }, u.prototype.radio = function(d) {
        d = f(d, { side: "?" });
        var m = "";
        switch (d.side.toLowerCase()) {
          case "east":
          case "e":
            m = "W";
            break;
          case "west":
          case "w":
            m = "K";
            break;
          default:
            m = this.character({ pool: "KW" });
            break;
        }
        return m + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" });
      }, u.prototype.set = function(d, m) {
        typeof d == "string" ? x[d] = m : x = B(d, x);
      }, u.prototype.tv = function(d) {
        return this.radio(d);
      }, u.prototype.cnpj = function() {
        var d = this.n(this.natural, 8, { max: 9 }), m = 2 + d[7] * 6 + d[6] * 7 + d[5] * 8 + d[4] * 9 + d[3] * 2 + d[2] * 3 + d[1] * 4 + d[0] * 5;
        m = 11 - m % 11, m >= 10 && (m = 0);
        var v = m * 2 + 3 + d[7] * 7 + d[6] * 8 + d[5] * 9 + d[4] * 2 + d[3] * 3 + d[2] * 4 + d[1] * 5 + d[0] * 6;
        return v = 11 - v % 11, v >= 10 && (v = 0), "" + d[0] + d[1] + "." + d[2] + d[3] + d[4] + "." + d[5] + d[6] + d[7] + "/0001-" + m + v;
      }, u.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
      }, u.prototype.mersenne_twister = function(d) {
        return new L(d);
      }, u.prototype.blueimp_md5 = function() {
        return new N();
      };
      var L = function(d) {
        d === void 0 && (d = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(d);
      };
      L.prototype.init_genrand = function(d) {
        for (this.mt[0] = d >>> 0, this.mti = 1; this.mti < this.N; this.mti++)
          d = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (((d & 4294901760) >>> 16) * 1812433253 << 16) + (d & 65535) * 1812433253 + this.mti, this.mt[this.mti] >>>= 0;
      }, L.prototype.init_by_array = function(d, m) {
        var v = 1, k = 0, O, G;
        for (this.init_genrand(19650218), O = this.N > m ? this.N : m; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1664525 << 16) + (G & 65535) * 1664525) + d[k] + k, this.mt[v] >>>= 0, v++, k++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1), k >= m && (k = 0);
        for (O = this.N - 1; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1566083941 << 16) + (G & 65535) * 1566083941) - v, this.mt[v] >>>= 0, v++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1);
        this.mt[0] = 2147483648;
      }, L.prototype.genrand_int32 = function() {
        var d, m = new Array(0, this.MATRIX_A);
        if (this.mti >= this.N) {
          var v;
          for (this.mti === this.N + 1 && this.init_genrand(5489), v = 0; v < this.N - this.M; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + this.M] ^ d >>> 1 ^ m[d & 1];
          for (; v < this.N - 1; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + (this.M - this.N)] ^ d >>> 1 ^ m[d & 1];
          d = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ d >>> 1 ^ m[d & 1], this.mti = 0;
        }
        return d = this.mt[this.mti++], d ^= d >>> 11, d ^= d << 7 & 2636928640, d ^= d << 15 & 4022730752, d ^= d >>> 18, d >>> 0;
      }, L.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
      }, L.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1 / 4294967295);
      }, L.prototype.random = function() {
        return this.genrand_int32() * (1 / 4294967296);
      }, L.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1 / 4294967296);
      }, L.prototype.genrand_res53 = function() {
        var d = this.genrand_int32() >>> 5, m = this.genrand_int32() >>> 6;
        return (d * 67108864 + m) * (1 / 9007199254740992);
      };
      var N = function() {
      };
      N.prototype.VERSION = "1.0.1", N.prototype.safe_add = function(m, v) {
        var k = (m & 65535) + (v & 65535), O = (m >> 16) + (v >> 16) + (k >> 16);
        return O << 16 | k & 65535;
      }, N.prototype.bit_roll = function(d, m) {
        return d << m | d >>> 32 - m;
      }, N.prototype.md5_cmn = function(d, m, v, k, O, G) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(m, d), this.safe_add(k, G)), O), v);
      }, N.prototype.md5_ff = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & v | ~m & k, d, m, O, G, H);
      }, N.prototype.md5_gg = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & k | v & ~k, d, m, O, G, H);
      }, N.prototype.md5_hh = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m ^ v ^ k, d, m, O, G, H);
      }, N.prototype.md5_ii = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(v ^ (m | ~k), d, m, O, G, H);
      }, N.prototype.binl_md5 = function(d, m) {
        d[m >> 5] |= 128 << m % 32, d[(m + 64 >>> 9 << 4) + 14] = m;
        var v, k, O, G, H, j = 1732584193, F = -271733879, z = -1732584194, W = 271733878;
        for (v = 0; v < d.length; v += 16)
          k = j, O = F, G = z, H = W, j = this.md5_ff(j, F, z, W, d[v], 7, -680876936), W = this.md5_ff(W, j, F, z, d[v + 1], 12, -389564586), z = this.md5_ff(z, W, j, F, d[v + 2], 17, 606105819), F = this.md5_ff(F, z, W, j, d[v + 3], 22, -1044525330), j = this.md5_ff(j, F, z, W, d[v + 4], 7, -176418897), W = this.md5_ff(W, j, F, z, d[v + 5], 12, 1200080426), z = this.md5_ff(z, W, j, F, d[v + 6], 17, -1473231341), F = this.md5_ff(F, z, W, j, d[v + 7], 22, -45705983), j = this.md5_ff(j, F, z, W, d[v + 8], 7, 1770035416), W = this.md5_ff(W, j, F, z, d[v + 9], 12, -1958414417), z = this.md5_ff(z, W, j, F, d[v + 10], 17, -42063), F = this.md5_ff(F, z, W, j, d[v + 11], 22, -1990404162), j = this.md5_ff(j, F, z, W, d[v + 12], 7, 1804603682), W = this.md5_ff(W, j, F, z, d[v + 13], 12, -40341101), z = this.md5_ff(z, W, j, F, d[v + 14], 17, -1502002290), F = this.md5_ff(F, z, W, j, d[v + 15], 22, 1236535329), j = this.md5_gg(j, F, z, W, d[v + 1], 5, -165796510), W = this.md5_gg(W, j, F, z, d[v + 6], 9, -1069501632), z = this.md5_gg(z, W, j, F, d[v + 11], 14, 643717713), F = this.md5_gg(F, z, W, j, d[v], 20, -373897302), j = this.md5_gg(j, F, z, W, d[v + 5], 5, -701558691), W = this.md5_gg(W, j, F, z, d[v + 10], 9, 38016083), z = this.md5_gg(z, W, j, F, d[v + 15], 14, -660478335), F = this.md5_gg(F, z, W, j, d[v + 4], 20, -405537848), j = this.md5_gg(j, F, z, W, d[v + 9], 5, 568446438), W = this.md5_gg(W, j, F, z, d[v + 14], 9, -1019803690), z = this.md5_gg(z, W, j, F, d[v + 3], 14, -187363961), F = this.md5_gg(F, z, W, j, d[v + 8], 20, 1163531501), j = this.md5_gg(j, F, z, W, d[v + 13], 5, -1444681467), W = this.md5_gg(W, j, F, z, d[v + 2], 9, -51403784), z = this.md5_gg(z, W, j, F, d[v + 7], 14, 1735328473), F = this.md5_gg(F, z, W, j, d[v + 12], 20, -1926607734), j = this.md5_hh(j, F, z, W, d[v + 5], 4, -378558), W = this.md5_hh(W, j, F, z, d[v + 8], 11, -2022574463), z = this.md5_hh(z, W, j, F, d[v + 11], 16, 1839030562), F = this.md5_hh(F, z, W, j, d[v + 14], 23, -35309556), j = this.md5_hh(j, F, z, W, d[v + 1], 4, -1530992060), W = this.md5_hh(W, j, F, z, d[v + 4], 11, 1272893353), z = this.md5_hh(z, W, j, F, d[v + 7], 16, -155497632), F = this.md5_hh(F, z, W, j, d[v + 10], 23, -1094730640), j = this.md5_hh(j, F, z, W, d[v + 13], 4, 681279174), W = this.md5_hh(W, j, F, z, d[v], 11, -358537222), z = this.md5_hh(z, W, j, F, d[v + 3], 16, -722521979), F = this.md5_hh(F, z, W, j, d[v + 6], 23, 76029189), j = this.md5_hh(j, F, z, W, d[v + 9], 4, -640364487), W = this.md5_hh(W, j, F, z, d[v + 12], 11, -421815835), z = this.md5_hh(z, W, j, F, d[v + 15], 16, 530742520), F = this.md5_hh(F, z, W, j, d[v + 2], 23, -995338651), j = this.md5_ii(j, F, z, W, d[v], 6, -198630844), W = this.md5_ii(W, j, F, z, d[v + 7], 10, 1126891415), z = this.md5_ii(z, W, j, F, d[v + 14], 15, -1416354905), F = this.md5_ii(F, z, W, j, d[v + 5], 21, -57434055), j = this.md5_ii(j, F, z, W, d[v + 12], 6, 1700485571), W = this.md5_ii(W, j, F, z, d[v + 3], 10, -1894986606), z = this.md5_ii(z, W, j, F, d[v + 10], 15, -1051523), F = this.md5_ii(F, z, W, j, d[v + 1], 21, -2054922799), j = this.md5_ii(j, F, z, W, d[v + 8], 6, 1873313359), W = this.md5_ii(W, j, F, z, d[v + 15], 10, -30611744), z = this.md5_ii(z, W, j, F, d[v + 6], 15, -1560198380), F = this.md5_ii(F, z, W, j, d[v + 13], 21, 1309151649), j = this.md5_ii(j, F, z, W, d[v + 4], 6, -145523070), W = this.md5_ii(W, j, F, z, d[v + 11], 10, -1120210379), z = this.md5_ii(z, W, j, F, d[v + 2], 15, 718787259), F = this.md5_ii(F, z, W, j, d[v + 9], 21, -343485551), j = this.safe_add(j, k), F = this.safe_add(F, O), z = this.safe_add(z, G), W = this.safe_add(W, H);
        return [j, F, z, W];
      }, N.prototype.binl2rstr = function(d) {
        var m, v = "";
        for (m = 0; m < d.length * 32; m += 8)
          v += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return v;
      }, N.prototype.rstr2binl = function(d) {
        var m, v = [];
        for (v[(d.length >> 2) - 1] = void 0, m = 0; m < v.length; m += 1)
          v[m] = 0;
        for (m = 0; m < d.length * 8; m += 8)
          v[m >> 5] |= (d.charCodeAt(m / 8) & 255) << m % 32;
        return v;
      }, N.prototype.rstr_md5 = function(d) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(d), d.length * 8));
      }, N.prototype.rstr_hmac_md5 = function(d, m) {
        var v, k = this.rstr2binl(d), O = [], G = [], H;
        for (O[15] = G[15] = void 0, k.length > 16 && (k = this.binl_md5(k, d.length * 8)), v = 0; v < 16; v += 1)
          O[v] = k[v] ^ 909522486, G[v] = k[v] ^ 1549556828;
        return H = this.binl_md5(O.concat(this.rstr2binl(m)), 512 + m.length * 8), this.binl2rstr(this.binl_md5(G.concat(H), 640));
      }, N.prototype.rstr2hex = function(d) {
        var m = "0123456789abcdef", v = "", k, O;
        for (O = 0; O < d.length; O += 1)
          k = d.charCodeAt(O), v += m.charAt(k >>> 4 & 15) + m.charAt(k & 15);
        return v;
      }, N.prototype.str2rstr_utf8 = function(d) {
        return unescape(encodeURIComponent(d));
      }, N.prototype.raw_md5 = function(d) {
        return this.rstr_md5(this.str2rstr_utf8(d));
      }, N.prototype.hex_md5 = function(d) {
        return this.rstr2hex(this.raw_md5(d));
      }, N.prototype.raw_hmac_md5 = function(d, m) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(d), this.str2rstr_utf8(m));
      }, N.prototype.hex_hmac_md5 = function(d, m) {
        return this.rstr2hex(this.raw_hmac_md5(d, m));
      }, N.prototype.md5 = function(d, m, v) {
        return m ? v ? this.raw_hmac_md5(m, d) : this.hex_hmac_md5(m, d) : v ? this.raw_md5(d) : this.hex_md5(d);
      }, t.exports && (e = t.exports = u), e.Chance = u, typeof importScripts < "u" && (chance = new u(), self.Chance = u), typeof window == "object" && typeof window.document == "object" && (window.Chance = u, window.chance = new u());
    })();
  }(eB, eB.exports)), eB.exports;
}
var JTt = ZTt();
const YTt = /* @__PURE__ */ Gi(JTt);
new YTt();
const XTt = "CH", QTt = "IG";
j1e().refine(
  (t) => t.startsWith(XTt) && t.length === iy,
  {
    message: "ConversationSid must start with CH"
  }
);
const eEt = j1e().refine(
  (t) => t.startsWith(QTt) && t.length === iy,
  {
    message: "AddressSid must be 34 characters long"
  }
), tEt = {
  OPEN: "open",
  PENDING: "pending",
  SOLVED: "solved",
  CLOSED: "closed"
}, rEt = ho.nativeEnum(tEt), nEt = {
  LOW: "low",
  NORMAL: "normal",
  HIGH: "high",
  URGENT: "urgent"
}, aEt = ho.nativeEnum(
  nEt
), iEt = ho.object({
  id: Akt,
  description: CVe,
  caffieneAmount: ho.number()
});
xVe()(
  ho.object({
    addressSid: eEt,
    chatFriendlyName: ho.string(),
    customerFriendlyName: ho.string(),
    preEngagementData: ho.string()
  })
);
var tB = { exports: {} }, t4e;
function oEt() {
  return t4e || (t4e = 1, function(t, e) {
    (function() {
      var r = 9007199254740992, n = -9007199254740992, a = "0123456789", i = "abcdefghijklmnopqrstuvwxyz", o = i.toUpperCase(), s = a + "abcdef";
      function l(d) {
        this.name = "UnsupportedError", this.message = d || "This feature is not supported on this platform";
      }
      l.prototype = new Error(), l.prototype.constructor = l;
      var c = Array.prototype.slice;
      function u(d) {
        if (!(this instanceof u))
          return d || (d = null), d === null ? new u() : new u(d);
        if (typeof d == "function")
          return this.random = d, this;
        arguments.length && (this.seed = 0);
        for (var m = 0; m < arguments.length; m++) {
          var v = 0;
          if (Object.prototype.toString.call(arguments[m]) === "[object String]")
            for (var k = 0; k < arguments[m].length; k++) {
              for (var O = 0, G = 0; G < arguments[m].length; G++)
                O = arguments[m].charCodeAt(G) + (O << 6) + (O << 16) - O;
              v += O;
            }
          else
            v = arguments[m];
          this.seed += (arguments.length - m) * v;
        }
        return this.mt = this.mersenne_twister(this.seed), this.bimd5 = this.blueimp_md5(), this.random = function() {
          return this.mt.random(this.seed);
        }, this;
      }
      u.prototype.VERSION = "1.1.12";
      function f(d, m) {
        if (d = d || {}, m)
          for (var v in m)
            typeof d[v] > "u" && (d[v] = m[v]);
        return d;
      }
      function h(d) {
        return Array.apply(null, Array(d)).map(function(m, v) {
          return v;
        });
      }
      function p(d, m) {
        if (d)
          throw new RangeError(m);
      }
      var g = function() {
        throw new Error("No Base64 encoder available.");
      };
      (function() {
        typeof btoa == "function" ? g = btoa : typeof nc == "function" && (g = function(m) {
          return new nc(m).toString("base64");
        });
      })(), u.prototype.bool = function(d) {
        return d = f(d, { likelihood: 50 }), p(
          d.likelihood < 0 || d.likelihood > 100,
          "Chance: Likelihood accepts values from 0 to 100."
        ), this.random() * 100 < d.likelihood;
      }, u.prototype.falsy = function(d) {
        d = f(d, { pool: [!1, null, 0, NaN, "", void 0] });
        var m = d.pool, v = this.integer({ min: 0, max: m.length - 1 }), k = m[v];
        return k;
      }, u.prototype.animal = function(d) {
        if (d = f(d), typeof d.type < "u")
          return p(
            !this.get("animals")[d.type.toLowerCase()],
            "Please pick from desert, ocean, grassland, forest, zoo, pets, farm."
          ), this.pick(this.get("animals")[d.type.toLowerCase()]);
        var m = ["desert", "forest", "ocean", "zoo", "farm", "pet", "grassland"];
        return this.pick(this.get("animals")[this.pick(m)]);
      }, u.prototype.character = function(d) {
        d = f(d);
        var m = "!@#$%^&*()[]", v, k;
        return d.casing === "lower" ? v = i : d.casing === "upper" ? v = o : v = i + o, d.pool ? k = d.pool : (k = "", d.alpha && (k += v), d.numeric && (k += a), d.symbols && (k += m), k || (k = v + a + m)), k.charAt(this.natural({ max: k.length - 1 }));
      }, u.prototype.floating = function(d) {
        d = f(d, { fixed: 4 }), p(
          d.fixed && d.precision,
          "Chance: Cannot specify both fixed and precision."
        );
        var m, v = Math.pow(10, d.fixed), k = r / v, O = -k;
        p(
          d.min && d.fixed && d.min < O,
          "Chance: Min specified is out of range with fixed. Min should be, at least, " + O
        ), p(
          d.max && d.fixed && d.max > k,
          "Chance: Max specified is out of range with fixed. Max should be, at most, " + k
        ), d = f(d, { min: O, max: k }), m = this.integer({ min: d.min * v, max: d.max * v });
        var G = (m / v).toFixed(d.fixed);
        return parseFloat(G);
      }, u.prototype.integer = function(d) {
        return d = f(d, { min: n, max: r }), p(d.min > d.max, "Chance: Min cannot be greater than Max."), Math.floor(this.random() * (d.max - d.min + 1) + d.min);
      }, u.prototype.natural = function(d) {
        if (d = f(d, { min: 0, max: r }), typeof d.numerals == "number" && (p(d.numerals < 1, "Chance: Numerals cannot be less than one."), d.min = Math.pow(10, d.numerals - 1), d.max = Math.pow(10, d.numerals) - 1), p(d.min < 0, "Chance: Min cannot be less than zero."), d.exclude) {
          p(!Array.isArray(d.exclude), "Chance: exclude must be an array.");
          for (var m in d.exclude)
            p(!Number.isInteger(d.exclude[m]), "Chance: exclude must be numbers.");
          var v = d.min + this.natural({ max: d.max - d.min - d.exclude.length }), k = d.exclude.sort();
          for (var O in k) {
            if (v < k[O])
              break;
            v++;
          }
          return v;
        }
        return this.integer(d);
      }, u.prototype.prime = function(d) {
        d = f(d, { min: 0, max: 1e4 }), p(d.min < 0, "Chance: Min cannot be less than zero."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = x.primes[x.primes.length - 1];
        if (d.max > m)
          for (var v = m + 2; v <= d.max; ++v)
            this.is_prime(v) && x.primes.push(v);
        var k = x.primes.filter(function(O) {
          return O >= d.min && O <= d.max;
        });
        return this.pick(k);
      }, u.prototype.is_prime = function(d) {
        if (d % 1 || d < 2)
          return !1;
        if (d % 2 === 0)
          return d === 2;
        if (d % 3 === 0)
          return d === 3;
        for (var m = Math.sqrt(d), v = 5; v <= m; v += 6)
          if (d % v === 0 || d % (v + 2) === 0)
            return !1;
        return !0;
      }, u.prototype.hex = function(d) {
        d = f(d, { min: 0, max: r, casing: "lower" }), p(d.min < 0, "Chance: Min cannot be less than zero.");
        var m = this.natural({ min: d.min, max: d.max });
        return d.casing === "upper" ? m.toString(16).toUpperCase() : m.toString(16);
      }, u.prototype.letter = function(d) {
        d = f(d, { casing: "lower" });
        var m = "abcdefghijklmnopqrstuvwxyz", v = this.character({ pool: m });
        return d.casing === "upper" && (v = v.toUpperCase()), v;
      }, u.prototype.string = function(d) {
        d = f(d, { min: 5, max: 20 }), d.length !== 0 && !d.length && (d.length = this.natural({ min: d.min, max: d.max })), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return v.join("");
      };
      function y(d) {
        this.c = d;
      }
      y.prototype = {
        substitute: function() {
          return this.c;
        }
      };
      function b(d) {
        this.c = d;
      }
      b.prototype = {
        substitute: function() {
          if (!/[{}\\]/.test(this.c))
            throw new Error('Invalid escape sequence: "\\' + this.c + '".');
          return this.c;
        }
      };
      function w(d) {
        this.c = d;
      }
      w.prototype = {
        replacers: {
          "#": function(d) {
            return d.character({ pool: a });
          },
          A: function(d) {
            return d.character({ pool: o });
          },
          a: function(d) {
            return d.character({ pool: i });
          }
        },
        substitute: function(d) {
          var m = this.replacers[this.c];
          if (!m)
            throw new Error('Invalid replacement character: "' + this.c + '".');
          return m(d);
        }
      };
      function _(d) {
        for (var m = [], v = "identity", k = 0; k < d.length; k++) {
          var O = d[k];
          switch (v) {
            case "escape":
              m.push(new b(O)), v = "identity";
              break;
            case "identity":
              O === "{" ? v = "replace" : O === "\\" ? v = "escape" : m.push(new y(O));
              break;
            case "replace":
              O === "}" ? v = "identity" : m.push(new w(O));
              break;
          }
        }
        return m;
      }
      u.prototype.template = function(d) {
        if (!d)
          throw new Error("Template string is required");
        var m = this;
        return _(d).map(function(v) {
          return v.substitute(m);
        }).join("");
      }, u.prototype.buffer = function(d) {
        if (typeof nc > "u")
          throw new l("Sorry, the buffer() function is not supported on your platform");
        d = f(d, { length: this.natural({ min: 5, max: 20 }) }), p(d.length < 0, "Chance: Length cannot be less than zero.");
        var m = d.length, v = this.n(this.character, m, d);
        return nc.from(v);
      }, u.prototype.capitalize = function(d) {
        return d.charAt(0).toUpperCase() + d.substr(1);
      }, u.prototype.mixin = function(d) {
        for (var m in d)
          this[m] = d[m];
        return this;
      }, u.prototype.unique = function(d, m, v) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        );
        var k = function(W, U) {
          return W.indexOf(U) !== -1;
        };
        v && (k = v.comparator || k);
        for (var O = [], G = 0, H, j = m * 50, F = c.call(arguments, 2); O.length < m; ) {
          var z = JSON.parse(JSON.stringify(F));
          if (H = d.apply(this, z), k(O, H) || (O.push(H), G = 0), ++G > j)
            throw new RangeError("Chance: num is likely too large for sample set");
        }
        return O;
      }, u.prototype.n = function(d, m) {
        p(
          typeof d != "function",
          "Chance: The first argument must be a function."
        ), typeof m > "u" && (m = 1);
        var v = m, k = [], O = c.call(arguments, 2);
        for (v = Math.max(0, v), null; v--; null)
          k.push(d.apply(this, O));
        return k;
      }, u.prototype.pad = function(d, m, v) {
        return v = v || "0", d = d + "", d.length >= m ? d : new Array(m - d.length + 1).join(v) + d;
      }, u.prototype.pick = function(d, m) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pick() from an empty array");
        return !m || m === 1 ? d[this.natural({ max: d.length - 1 })] : this.shuffle(d).slice(0, m);
      }, u.prototype.pickone = function(d) {
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickone() from an empty array");
        return d[this.natural({ max: d.length - 1 })];
      }, u.prototype.pickset = function(d, m) {
        if (m === 0)
          return [];
        if (d.length === 0)
          throw new RangeError("Chance: Cannot pickset() from an empty array");
        if (m < 0)
          throw new RangeError("Chance: Count must be a positive number");
        if (!m || m === 1)
          return [this.pickone(d)];
        var v = d.slice(0), k = v.length;
        return this.n(function() {
          var O = this.natural({ max: --k }), G = v[O];
          return v[O] = v[k], G;
        }, Math.min(k, m));
      }, u.prototype.shuffle = function(d) {
        for (var m = [], v = 0, k = Number(d.length), O = h(k), G = k - 1, H, j = 0; j < k; j++)
          H = this.natural({ max: G }), v = O[H], m[j] = d[v], O[H] = O[G], G -= 1;
        return m;
      }, u.prototype.weighted = function(d, m, v) {
        if (d.length !== m.length)
          throw new RangeError("Chance: Length of array and weights must match");
        for (var k = 0, O, G = 0; G < m.length; ++G) {
          if (O = m[G], isNaN(O))
            throw new RangeError("Chance: All weights must be numbers");
          O > 0 && (k += O);
        }
        if (k === 0)
          throw new RangeError("Chance: No valid entries in array weights");
        var H = this.random() * k, j = 0, F = -1, z;
        for (G = 0; G < m.length; ++G) {
          if (O = m[G], j += O, O > 0) {
            if (H <= j) {
              z = G;
              break;
            }
            F = G;
          }
          G === m.length - 1 && (z = F);
        }
        var W = d[z];
        return v = typeof v > "u" ? !1 : v, v && (d.splice(z, 1), m.splice(z, 1)), W;
      }, u.prototype.paragraph = function(d) {
        d = f(d);
        var m = d.sentences || this.natural({ min: 3, max: 7 }), v = this.n(this.sentence, m), k = d.linebreak === !0 ? `
` : " ";
        return v.join(k);
      }, u.prototype.sentence = function(d) {
        d = f(d);
        var m = d.words || this.natural({ min: 12, max: 18 }), v = d.punctuation, k, O = this.n(this.word, m);
        return k = O.join(" "), k = this.capitalize(k), v !== !1 && !/^[.?;!:]$/.test(v) && (v = "."), v && (k += v), k;
      }, u.prototype.syllable = function(d) {
        d = f(d);
        for (var m = d.length || this.natural({ min: 2, max: 3 }), v = "bcdfghjklmnprstvwz", k = "aeiou", O = v + k, G = "", H, j = 0; j < m; j++)
          j === 0 ? H = this.character({ pool: O }) : v.indexOf(H) === -1 ? H = this.character({ pool: v }) : H = this.character({ pool: k }), G += H;
        return d.capitalize && (G = this.capitalize(G)), G;
      }, u.prototype.word = function(d) {
        d = f(d), p(
          d.syllables && d.length,
          "Chance: Cannot specify both syllables AND length."
        );
        var m = d.syllables || this.natural({ min: 1, max: 3 }), v = "";
        if (d.length) {
          do
            v += this.syllable();
          while (v.length < d.length);
          v = v.substring(0, d.length);
        } else
          for (var k = 0; k < m; k++)
            v += this.syllable();
        return d.capitalize && (v = this.capitalize(v)), v;
      }, u.prototype.emoji = function(d) {
        d = f(d, { category: "all", length: 1 }), p(
          d.length < 1 || BigInt(d.length) > BigInt(r),
          "Chance: length must be between 1 and " + String(r)
        );
        var m = this.get("emojis");
        d.category === "all" && (d.category = this.pickone(Object.keys(m)));
        var v = m[d.category];
        return p(
          v === void 0,
          "Chance: Unrecognised emoji category: [" + d.category + "]."
        ), this.pickset(v, d.length).map(function(k) {
          return String.fromCodePoint(k);
        }).join("");
      }, u.prototype.age = function(d) {
        d = f(d);
        var m;
        switch (d.type) {
          case "child":
            m = { min: 0, max: 12 };
            break;
          case "teen":
            m = { min: 13, max: 19 };
            break;
          case "adult":
            m = { min: 18, max: 65 };
            break;
          case "senior":
            m = { min: 65, max: 100 };
            break;
          case "all":
            m = { min: 0, max: 100 };
            break;
          default:
            m = { min: 18, max: 65 };
            break;
        }
        return this.natural(m);
      }, u.prototype.birthday = function(d) {
        var m = this.age(d), v = /* @__PURE__ */ new Date(), k = v.getFullYear();
        if (d && d.type) {
          var O = /* @__PURE__ */ new Date(), G = /* @__PURE__ */ new Date();
          O.setFullYear(k - m - 1), G.setFullYear(k - m), d = f(d, {
            min: O,
            max: G
          });
        } else if (d && (d.minAge !== void 0 || d.maxAge !== void 0)) {
          p(d.minAge < 0, "Chance: MinAge cannot be less than zero."), p(d.minAge > d.maxAge, "Chance: MinAge cannot be greater than MaxAge.");
          var H = d.minAge !== void 0 ? d.minAge : 0, j = d.maxAge !== void 0 ? d.maxAge : 100, F = new Date(k - j - 1, v.getMonth(), v.getDate()), z = new Date(k - H, v.getMonth(), v.getDate());
          F.setDate(F.getDate() + 1), z.setDate(z.getDate() + 1), z.setMilliseconds(z.getMilliseconds() - 1), d = f(d, {
            min: F,
            max: z
          });
        } else
          d = f(d, {
            year: k - m
          });
        return this.date(d);
      }, u.prototype.cpf = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 9, { max: 9 }), v = m[8] * 2 + m[7] * 3 + m[6] * 4 + m[5] * 5 + m[4] * 6 + m[3] * 7 + m[2] * 8 + m[1] * 9 + m[0] * 10;
        v = 11 - v % 11, v >= 10 && (v = 0);
        var k = v * 2 + m[8] * 3 + m[7] * 4 + m[6] * 5 + m[5] * 6 + m[4] * 7 + m[3] * 8 + m[2] * 9 + m[1] * 10 + m[0] * 11;
        k = 11 - k % 11, k >= 10 && (k = 0);
        var O = "" + m[0] + m[1] + m[2] + "." + m[3] + m[4] + m[5] + "." + m[6] + m[7] + m[8] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.cnpj = function(d) {
        d = f(d, {
          formatted: !0
        });
        var m = this.n(this.natural, 12, { max: 12 }), v = m[11] * 2 + m[10] * 3 + m[9] * 4 + m[8] * 5 + m[7] * 6 + m[6] * 7 + m[5] * 8 + m[4] * 9 + m[3] * 2 + m[2] * 3 + m[1] * 4 + m[0] * 5;
        v = 11 - v % 11, v < 2 && (v = 0);
        var k = v * 2 + m[11] * 3 + m[10] * 4 + m[9] * 5 + m[8] * 6 + m[7] * 7 + m[6] * 8 + m[5] * 9 + m[4] * 2 + m[3] * 3 + m[2] * 4 + m[1] * 5 + m[0] * 6;
        k = 11 - k % 11, k < 2 && (k = 0);
        var O = "" + m[0] + m[1] + "." + m[2] + m[3] + m[4] + "." + m[5] + m[6] + m[7] + "/" + m[8] + m[9] + m[10] + m[11] + "-" + v + k;
        return d.formatted ? O : O.replace(/\D/g, "");
      }, u.prototype.first = function(d) {
        return d = f(d, { gender: this.gender(), nationality: "en" }), this.pick(this.get("firstNames")[d.gender.toLowerCase()][d.nationality.toLowerCase()]);
      }, u.prototype.profession = function(d) {
        return d = f(d), d.rank ? this.pick(["Apprentice ", "Junior ", "Senior ", "Lead "]) + this.pick(this.get("profession")) : this.pick(this.get("profession"));
      }, u.prototype.company = function() {
        return this.pick(this.get("company"));
      }, u.prototype.gender = function(d) {
        return d = f(d, { extraGenders: [] }), this.pick(["Male", "Female"].concat(d.extraGenders));
      }, u.prototype.last = function(d) {
        if (d = f(d, { nationality: "*" }), d.nationality === "*") {
          var m = [], v = this.get("lastNames");
          return Object.keys(v).forEach(function(k) {
            m = m.concat(v[k]);
          }), this.pick(m);
        } else
          return this.pick(this.get("lastNames")[d.nationality.toLowerCase()]);
      }, u.prototype.israelId = function() {
        for (var d = this.string({ pool: "0123456789", length: 8 }), m = 0, v = 0; v < d.length; v++) {
          var k = d[v] * (v / 2 === parseInt(v / 2) ? 1 : 2);
          k = this.pad(k, 2).toString(), k = parseInt(k[0]) + parseInt(k[1]), m = m + k;
        }
        return d = d + (10 - parseInt(m.toString().slice(-1))).toString().slice(-1), d;
      }, u.prototype.mrz = function(d) {
        var m = function(O) {
          var G = "<ABCDEFGHIJKLMNOPQRSTUVWXYXZ".split(""), H = [7, 3, 1], j = 0;
          return typeof O != "string" && (O = O.toString()), O.split("").forEach(function(F, z) {
            var W = G.indexOf(F);
            W !== -1 ? F = W === 0 ? 0 : W + 9 : F = parseInt(F, 10), F *= H[z % H.length], j += F;
          }), j % 10;
        }, v = function(O) {
          var G = function(j) {
            return new Array(j + 1).join("<");
          }, H = [
            "P<",
            O.issuer,
            O.last.toUpperCase(),
            "<<",
            O.first.toUpperCase(),
            G(39 - (O.last.length + O.first.length + 2)),
            O.passportNumber,
            m(O.passportNumber),
            O.nationality,
            O.dob,
            m(O.dob),
            O.gender,
            O.expiry,
            m(O.expiry),
            G(14),
            m(G(14))
          ].join("");
          return H + m(H.substr(44, 10) + H.substr(57, 7) + H.substr(65, 7));
        }, k = this;
        return d = f(d, {
          first: this.first(),
          last: this.last(),
          passportNumber: this.integer({ min: 1e8, max: 999999999 }),
          dob: function() {
            var O = k.birthday({ type: "adult" });
            return [
              O.getFullYear().toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          expiry: function() {
            var O = /* @__PURE__ */ new Date();
            return [
              (O.getFullYear() + 5).toString().substr(2),
              k.pad(O.getMonth() + 1, 2),
              k.pad(O.getDate(), 2)
            ].join("");
          }(),
          gender: this.gender() === "Female" ? "F" : "M",
          issuer: "GBR",
          nationality: "GBR"
        }), v(d);
      }, u.prototype.name = function(d) {
        d = f(d);
        var m = this.first(d), v = this.last(d), k;
        return d.middle ? k = m + " " + this.first(d) + " " + v : d.middle_initial ? k = m + " " + this.character({ alpha: !0, casing: "upper" }) + ". " + v : k = m + " " + v, d.prefix && (k = this.prefix(d) + " " + k), d.suffix && (k = k + " " + this.suffix(d)), k;
      }, u.prototype.name_prefixes = function(d) {
        d = d || "all", d = d.toLowerCase();
        var m = [
          { name: "Doctor", abbreviation: "Dr." }
        ];
        return (d === "male" || d === "all") && m.push({ name: "Mister", abbreviation: "Mr." }), (d === "female" || d === "all") && (m.push({ name: "Miss", abbreviation: "Miss" }), m.push({ name: "Misses", abbreviation: "Mrs." })), m;
      }, u.prototype.prefix = function(d) {
        return this.name_prefix(d);
      }, u.prototype.name_prefix = function(d) {
        return d = f(d, { gender: "all" }), d.full ? this.pick(this.name_prefixes(d.gender)).name : this.pick(this.name_prefixes(d.gender)).abbreviation;
      }, u.prototype.HIDN = function() {
        var d = "0123456789", m = "ABCDEFGHIJKLMNOPQRSTUVWXYXZ", v = "";
        return v += this.string({ pool: d, length: 6 }), v += this.string({ pool: m, length: 2 }), v;
      }, u.prototype.ssn = function(d) {
        d = f(d, { ssnFour: !1, dashes: !0 });
        var m = "1234567890", v, k = d.dashes ? "-" : "";
        return d.ssnFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 3 }) + k + this.string({ pool: m, length: 2 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.aadhar = function(d) {
        d = f(d, { onlyLastFour: !1, separatedByWhiteSpace: !0 });
        var m = "1234567890", v, k = d.separatedByWhiteSpace ? " " : "";
        return d.onlyLastFour ? v = this.string({ pool: m, length: 4 }) : v = this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }) + k + this.string({ pool: m, length: 4 }), v;
      }, u.prototype.name_suffixes = function() {
        var d = [
          { name: "Doctor of Osteopathic Medicine", abbreviation: "D.O." },
          { name: "Doctor of Philosophy", abbreviation: "Ph.D." },
          { name: "Esquire", abbreviation: "Esq." },
          { name: "Junior", abbreviation: "Jr." },
          { name: "Juris Doctor", abbreviation: "J.D." },
          { name: "Master of Arts", abbreviation: "M.A." },
          { name: "Master of Business Administration", abbreviation: "M.B.A." },
          { name: "Master of Science", abbreviation: "M.S." },
          { name: "Medical Doctor", abbreviation: "M.D." },
          { name: "Senior", abbreviation: "Sr." },
          { name: "The Third", abbreviation: "III" },
          { name: "The Fourth", abbreviation: "IV" },
          { name: "Bachelor of Engineering", abbreviation: "B.E" },
          { name: "Bachelor of Technology", abbreviation: "B.TECH" }
        ];
        return d;
      }, u.prototype.suffix = function(d) {
        return this.name_suffix(d);
      }, u.prototype.name_suffix = function(d) {
        return d = f(d), d.full ? this.pick(this.name_suffixes()).name : this.pick(this.name_suffixes()).abbreviation;
      }, u.prototype.nationalities = function() {
        return this.get("nationalities");
      }, u.prototype.nationality = function() {
        var d = this.pick(this.nationalities());
        return d.name;
      }, u.prototype.zodiac = function() {
        const d = ["Aries", "Taurus", "Gemini", "Cancer", "Leo", "Virgo", "Libra", "Scorpio", "Sagittarius", "Capricorn", "Aquarius", "Pisces"];
        return this.pickone(d);
      }, u.prototype.android_id = function() {
        return "APA91" + this.string({ pool: "0123456789abcefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-_", length: 178 });
      }, u.prototype.apple_token = function() {
        return this.string({ pool: "abcdef1234567890", length: 64 });
      }, u.prototype.wp8_anid2 = function() {
        return g(this.hash({ length: 32 }));
      }, u.prototype.wp7_anid = function() {
        return "A=" + this.guid().replace(/-/g, "").toUpperCase() + "&E=" + this.hash({ length: 3 }) + "&W=" + this.integer({ min: 0, max: 9 });
      }, u.prototype.bb_pin = function() {
        return this.hash({ length: 8 });
      }, u.prototype.avatar = function(d) {
        var m = null, v = "//www.gravatar.com/avatar/", k = {
          http: "http",
          https: "https"
        }, O = {
          bmp: "bmp",
          gif: "gif",
          jpg: "jpg",
          png: "png"
        }, G = {
          404: "404",
          // Return 404 if not found
          mm: "mm",
          // Mystery man
          identicon: "identicon",
          // Geometric pattern based on hash
          monsterid: "monsterid",
          // A generated monster icon
          wavatar: "wavatar",
          // A generated face
          retro: "retro",
          // 8-bit icon
          blank: "blank"
          // A transparent png
        }, H = {
          g: "g",
          pg: "pg",
          r: "r",
          x: "x"
        }, j = {
          protocol: null,
          email: null,
          fileExtension: null,
          size: null,
          fallback: null,
          rating: null
        };
        if (!d)
          j.email = this.email(), d = {};
        else if (typeof d == "string")
          j.email = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        return j = f(d, j), j.email || (j.email = this.email()), j.protocol = k[j.protocol] ? j.protocol + ":" : "", j.size = parseInt(j.size, 0) ? j.size : "", j.rating = H[j.rating] ? j.rating : "", j.fallback = G[j.fallback] ? j.fallback : "", j.fileExtension = O[j.fileExtension] ? j.fileExtension : "", m = j.protocol + v + this.bimd5.md5(j.email) + (j.fileExtension ? "." + j.fileExtension : "") + (j.size || j.rating || j.fallback ? "?" : "") + (j.size ? "&s=" + j.size.toString() : "") + (j.rating ? "&r=" + j.rating : "") + (j.fallback ? "&d=" + j.fallback : ""), m;
      }, u.prototype.color = function(d) {
        function m(ce, ee) {
          return [ce, ce, ce].join(ee || "");
        }
        function v(ce) {
          var ee = ce ? "rgba" : "rgb", Se = ce ? "," + this.floating({ min: V, max: Y }) : "", Ce = O ? m(this.natural({ min: G, max: H }), ",") : this.natural({ min: z, max: W }) + "," + this.natural({ min: U, max: Z }) + "," + this.natural({ max: 255 });
          return ee + "(" + Ce + Se + ")";
        }
        function k(ce, ee, Se) {
          var Ce = Se ? "#" : "", we = "";
          return O ? (we = m(this.pad(this.hex({ min: G, max: H }), 2)), d.format === "shorthex" && (we = m(this.hex({ min: 0, max: 15 })))) : d.format === "shorthex" ? we = this.pad(this.hex({ min: Math.floor(j / 16), max: Math.floor(F / 16) }), 1) + this.pad(this.hex({ min: Math.floor(z / 16), max: Math.floor(W / 16) }), 1) + this.pad(this.hex({ min: Math.floor(U / 16), max: Math.floor(Z / 16) }), 1) : j !== void 0 || F !== void 0 || z !== void 0 || W !== void 0 || U !== void 0 || Z !== void 0 ? we = this.pad(this.hex({ min: j, max: F }), 2) + this.pad(this.hex({ min: z, max: W }), 2) + this.pad(this.hex({ min: U, max: Z }), 2) : we = this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2) + this.pad(this.hex({ min: G, max: H }), 2), Ce + we;
        }
        d = f(d, {
          format: this.pick(["hex", "shorthex", "rgb", "rgba", "0x", "name"]),
          grayscale: !1,
          casing: "lower",
          min: 0,
          max: 255,
          min_red: void 0,
          max_red: void 0,
          min_green: void 0,
          max_green: void 0,
          min_blue: void 0,
          max_blue: void 0,
          min_alpha: 0,
          max_alpha: 1
        });
        var O = d.grayscale, G = d.min, H = d.max, j = d.min_red, F = d.max_red, z = d.min_green, W = d.max_green, U = d.min_blue, Z = d.max_blue, V = d.min_alpha, Y = d.max_alpha;
        d.min_red === void 0 && (j = G), d.max_red === void 0 && (F = H), d.min_green === void 0 && (z = G), d.max_green === void 0 && (W = H), d.min_blue === void 0 && (U = G), d.max_blue === void 0 && (Z = H), d.min_alpha === void 0 && (V = 0), d.max_alpha === void 0 && (Y = 1), O && G === 0 && H === 255 && j !== void 0 && F !== void 0 && (G = (j + z + U) / 3, H = (F + W + Z) / 3);
        var ge;
        if (d.format === "hex")
          ge = k.call(this, 2, 6, !0);
        else if (d.format === "shorthex")
          ge = k.call(this, 1, 3, !0);
        else if (d.format === "rgb")
          ge = v.call(this, !1);
        else if (d.format === "rgba")
          ge = v.call(this, !0);
        else if (d.format === "0x")
          ge = "0x" + k.call(this, 2, 6);
        else {
          if (d.format === "name")
            return this.pick(this.get("colorNames"));
          throw new RangeError('Invalid format provided. Please provide one of "hex", "shorthex", "rgb", "rgba", "0x" or "name".');
        }
        return d.casing === "upper" && (ge = ge.toUpperCase()), ge;
      }, u.prototype.domain = function(d) {
        return d = f(d), this.word() + "." + (d.tld || this.tld());
      }, u.prototype.email = function(d) {
        return d = f(d), this.word({ length: d.length }) + "@" + (d.domain || this.domain());
      }, u.prototype.fbid = function() {
        return "10000" + this.string({ pool: "1234567890", length: 11 });
      }, u.prototype.google_analytics = function() {
        var d = this.pad(this.natural({ max: 999999 }), 6), m = this.pad(this.natural({ max: 99 }), 2);
        return "UA-" + d + "-" + m;
      }, u.prototype.hashtag = function() {
        return "#" + this.word();
      }, u.prototype.ip = function() {
        return this.natural({ min: 1, max: 254 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ max: 255 }) + "." + this.natural({ min: 1, max: 254 });
      }, u.prototype.ipv6 = function() {
        var d = this.n(this.hash, 8, { length: 4 });
        return d.join(":");
      }, u.prototype.klout = function() {
        return this.natural({ min: 1, max: 99 });
      }, u.prototype.mac = function(d) {
        return d = f(d, { delimiter: ":" }), this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2) + d.delimiter + this.pad(this.natural({ max: 255 }).toString(16), 2);
      }, u.prototype.semver = function(d) {
        d = f(d, { include_prerelease: !0 });
        var m = this.pickone(["^", "~", "<", ">", "<=", ">=", "="]);
        d.range && (m = d.range);
        var v = "";
        return d.include_prerelease && (v = this.weighted(["", "-dev", "-beta", "-alpha"], [50, 10, 5, 1])), m + this.rpg("3d10").join(".") + v;
      }, u.prototype.tlds = function() {
        return ["com", "org", "edu", "gov", "co.uk", "net", "io", "ac", "ad", "ae", "af", "ag", "ai", "al", "am", "ao", "aq", "ar", "as", "at", "au", "aw", "ax", "az", "ba", "bb", "bd", "be", "bf", "bg", "bh", "bi", "bj", "bm", "bn", "bo", "br", "bs", "bt", "bv", "bw", "by", "bz", "ca", "cc", "cd", "cf", "cg", "ch", "ci", "ck", "cl", "cm", "cn", "co", "cr", "cu", "cv", "cw", "cx", "cy", "cz", "de", "dj", "dk", "dm", "do", "dz", "ec", "ee", "eg", "eh", "er", "es", "et", "eu", "fi", "fj", "fk", "fm", "fo", "fr", "ga", "gb", "gd", "ge", "gf", "gg", "gh", "gi", "gl", "gm", "gn", "gp", "gq", "gr", "gs", "gt", "gu", "gw", "gy", "hk", "hm", "hn", "hr", "ht", "hu", "id", "ie", "il", "im", "in", "io", "iq", "ir", "is", "it", "je", "jm", "jo", "jp", "ke", "kg", "kh", "ki", "km", "kn", "kp", "kr", "kw", "ky", "kz", "la", "lb", "lc", "li", "lk", "lr", "ls", "lt", "lu", "lv", "ly", "ma", "mc", "md", "me", "mg", "mh", "mk", "ml", "mm", "mn", "mo", "mp", "mq", "mr", "ms", "mt", "mu", "mv", "mw", "mx", "my", "mz", "na", "nc", "ne", "nf", "ng", "ni", "nl", "no", "np", "nr", "nu", "nz", "om", "pa", "pe", "pf", "pg", "ph", "pk", "pl", "pm", "pn", "pr", "ps", "pt", "pw", "py", "qa", "re", "ro", "rs", "ru", "rw", "sa", "sb", "sc", "sd", "se", "sg", "sh", "si", "sj", "sk", "sl", "sm", "sn", "so", "sr", "ss", "st", "su", "sv", "sx", "sy", "sz", "tc", "td", "tf", "tg", "th", "tj", "tk", "tl", "tm", "tn", "to", "tr", "tt", "tv", "tw", "tz", "ua", "ug", "uk", "us", "uy", "uz", "va", "vc", "ve", "vg", "vi", "vn", "vu", "wf", "ws", "ye", "yt", "za", "zm", "zw"];
      }, u.prototype.tld = function() {
        return this.pick(this.tlds());
      }, u.prototype.twitter = function() {
        return "@" + this.word();
      }, u.prototype.url = function(d) {
        d = f(d, { protocol: "http", domain: this.domain(d), domain_prefix: "", path: this.word(), extensions: [] });
        var m = d.extensions.length > 0 ? "." + this.pick(d.extensions) : "", v = d.domain_prefix ? d.domain_prefix + "." + d.domain : d.domain;
        return d.protocol + "://" + v + "/" + d.path + m;
      }, u.prototype.port = function() {
        return this.integer({ min: 0, max: 65535 });
      }, u.prototype.locale = function(d) {
        return d = f(d), d.region ? this.pick(this.get("locale_regions")) : this.pick(this.get("locale_languages"));
      }, u.prototype.locales = function(d) {
        return d = f(d), d.region ? this.get("locale_regions") : this.get("locale_languages");
      }, u.prototype.loremPicsum = function(d) {
        d = f(d, { width: 500, height: 500, greyscale: !1, blurred: !1 });
        var m = d.greyscale ? "g/" : "", v = d.blurred ? "/?blur" : "/?random";
        return "https://picsum.photos/" + m + d.width + "/" + d.height + v;
      }, u.prototype.address = function(d) {
        return d = f(d), this.natural({ min: 5, max: 2e3 }) + " " + this.street(d);
      }, u.prototype.altitude = function(d) {
        return d = f(d, { fixed: 5, min: 0, max: 8848 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.areacode = function(d) {
        d = f(d, { parens: !0 });
        var m = d.exampleNumber ? "555" : this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 8 }).toString() + this.natural({ min: 0, max: 9 }).toString();
        return d.parens ? "(" + m + ")" : m;
      }, u.prototype.city = function() {
        return this.capitalize(this.word({ syllables: 3 }));
      }, u.prototype.coordinates = function(d) {
        return this.latitude(d) + ", " + this.longitude(d);
      }, u.prototype.countries = function() {
        return this.get("countries");
      }, u.prototype.country = function(d) {
        d = f(d);
        var m = this.pick(this.countries());
        return d.raw ? m : d.full ? m.name : m.abbreviation;
      }, u.prototype.depth = function(d) {
        return d = f(d, { fixed: 5, min: -10994, max: 0 }), this.floating({
          min: d.min,
          max: d.max,
          fixed: d.fixed
        });
      }, u.prototype.geohash = function(d) {
        return d = f(d, { length: 7 }), this.string({ length: d.length, pool: "0123456789bcdefghjkmnpqrstuvwxyz" });
      }, u.prototype.geojson = function(d) {
        return this.latitude(d) + ", " + this.longitude(d) + ", " + this.altitude(d);
      }, u.prototype.latitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 89, fixed: 4 } : { fixed: 5, min: -90, max: 90, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 89, "Chance: Min specified is out of range. Should be between 0 - 89"), p(d.max < 0 || d.max > 89, "Chance: Max specified is out of range. Should be between 0 - 89"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.longitude = function(d) {
        var [m, v, k] = ["ddm", "dms", "dd"];
        d = f(
          d,
          d && d.format && [m, v].includes(d.format.toLowerCase()) ? { min: 0, max: 179, fixed: 4 } : { fixed: 5, min: -180, max: 180, format: k }
        );
        var O = d.format.toLowerCase();
        switch ((O === m || O === v) && (p(d.min < 0 || d.min > 179, "Chance: Min specified is out of range. Should be between 0 - 179"), p(d.max < 0 || d.max > 179, "Chance: Max specified is out of range. Should be between 0 - 179"), p(d.fixed > 4, "Chance: Fixed specified should be below or equal to 4")), O) {
          case m:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed });
          case v:
            return this.integer({ min: d.min, max: d.max }) + "°" + this.integer({ min: 0, max: 59 }) + "’" + this.floating({ min: 0, max: 59.9999, fixed: d.fixed }) + "”";
          case k:
          default:
            return this.floating({ min: d.min, max: d.max, fixed: d.fixed });
        }
      }, u.prototype.phone = function(d) {
        var m = this, v, k = function(U) {
          var Z = [];
          return U.sections.forEach(function(V) {
            Z.push(m.string({ pool: "0123456789", length: V }));
          }), U.area + Z.join(" ");
        };
        d = f(d, {
          formatted: !0,
          country: "us",
          mobile: !1,
          exampleNumber: !1
        }), d.formatted || (d.parens = !1);
        var O;
        switch (d.country) {
          case "fr":
            d.mobile ? (v = this.pick(["06", "07"]) + m.string({ pool: "0123456789", length: 8 }), O = d.formatted ? v.match(/../g).join(" ") : v) : (v = this.pick([
              // Valid zone and département codes.
              "01" + this.pick(["30", "34", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "53", "55", "56", "58", "60", "64", "69", "70", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83"]) + m.string({ pool: "0123456789", length: 6 }),
              "02" + this.pick(["14", "18", "22", "23", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "40", "41", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "56", "57", "61", "62", "69", "72", "76", "77", "78", "85", "90", "96", "97", "98", "99"]) + m.string({ pool: "0123456789", length: 6 }),
              "03" + this.pick(["10", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "39", "44", "45", "51", "52", "54", "55", "57", "58", "59", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "70", "71", "72", "73", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "90"]) + m.string({ pool: "0123456789", length: 6 }),
              "04" + this.pick(["11", "13", "15", "20", "22", "26", "27", "30", "32", "34", "37", "42", "43", "44", "50", "56", "57", "63", "66", "67", "68", "69", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "80", "81", "82", "83", "84", "85", "86", "88", "89", "90", "91", "92", "93", "94", "95", "97", "98"]) + m.string({ pool: "0123456789", length: 6 }),
              "05" + this.pick(["08", "16", "17", "19", "24", "31", "32", "33", "34", "35", "40", "45", "46", "47", "49", "53", "55", "56", "57", "58", "59", "61", "62", "63", "64", "65", "67", "79", "81", "82", "86", "87", "90", "94"]) + m.string({ pool: "0123456789", length: 6 }),
              "09" + m.string({ pool: "0123456789", length: 8 })
            ]), O = d.formatted ? v.match(/../g).join(" ") : v);
            break;
          case "uk":
            d.mobile ? (v = this.pick([
              { area: "07" + this.pick(["4", "5", "7", "8", "9"]), sections: [2, 6] },
              { area: "07624 ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "")) : (v = this.pick([
              //valid area codes of major cities/counties followed by random numbers in required format.
              { area: "01" + this.character({ pool: "234569" }) + "1 ", sections: [3, 4] },
              { area: "020 " + this.character({ pool: "378" }), sections: [3, 4] },
              { area: "023 " + this.character({ pool: "89" }), sections: [3, 4] },
              { area: "024 7", sections: [3, 4] },
              { area: "028 " + this.pick(["25", "28", "37", "71", "82", "90", "92", "95"]), sections: [2, 4] },
              { area: "012" + this.pick(["04", "08", "54", "76", "97", "98"]) + " ", sections: [6] },
              { area: "013" + this.pick(["63", "64", "84", "86"]) + " ", sections: [6] },
              { area: "014" + this.pick(["04", "20", "60", "61", "80", "88"]) + " ", sections: [6] },
              { area: "015" + this.pick(["24", "27", "62", "66"]) + " ", sections: [6] },
              { area: "016" + this.pick(["06", "29", "35", "47", "59", "95"]) + " ", sections: [6] },
              { area: "017" + this.pick(["26", "44", "50", "68"]) + " ", sections: [6] },
              { area: "018" + this.pick(["27", "37", "84", "97"]) + " ", sections: [6] },
              { area: "019" + this.pick(["00", "05", "35", "46", "49", "63", "95"]) + " ", sections: [6] }
            ]), O = d.formatted ? k(v) : k(v).replace(" ", "", "g"));
            break;
          case "za":
            d.mobile ? (v = this.pick([
              "060" + this.pick(["3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "061" + this.pick(["0", "1", "2", "3", "4", "5", "8"]) + m.string({ pool: "0123456789", length: 6 }),
              "06" + m.string({ pool: "0123456789", length: 7 }),
              "071" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 6 }),
              "07" + this.pick(["2", "3", "4", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "08" + this.pick(["0", "1", "2", "3", "4", "5"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v) : (v = this.pick([
              "01" + this.pick(["0", "1", "2", "3", "4", "5", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "02" + this.pick(["1", "2", "3", "4", "7", "8"]) + m.string({ pool: "0123456789", length: 7 }),
              "03" + this.pick(["1", "2", "3", "5", "6", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "04" + this.pick(["1", "2", "3", "4", "5", "6", "7", "8", "9"]) + m.string({ pool: "0123456789", length: 7 }),
              "05" + this.pick(["1", "3", "4", "6", "7", "8"]) + m.string({ pool: "0123456789", length: 7 })
            ]), O = d.formatted || v);
            break;
          case "us":
            var G = this.areacode(d).toString(), H = this.natural({ min: 2, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString() + this.natural({ min: 0, max: 9 }).toString(), j = this.natural({ min: 1e3, max: 9999 }).toString();
            O = d.formatted ? G + " " + H + "-" + j : G + H + j;
            break;
          case "br":
            var F = this.pick(["11", "12", "13", "14", "15", "16", "17", "18", "19", "21", "22", "24", "27", "28", "31", "32", "33", "34", "35", "37", "38", "41", "42", "43", "44", "45", "46", "47", "48", "49", "51", "53", "54", "55", "61", "62", "63", "64", "65", "66", "67", "68", "69", "71", "73", "74", "75", "77", "79", "81", "82", "83", "84", "85", "86", "87", "88", "89", "91", "92", "93", "94", "95", "96", "97", "98", "99"]), z;
            d.mobile ? z = "9" + m.string({ pool: "0123456789", length: 4 }) : z = this.natural({ min: 2e3, max: 5999 }).toString();
            var W = m.string({ pool: "0123456789", length: 4 });
            O = d.formatted ? "(" + F + ") " + z + "-" + W : F + z + W;
            break;
        }
        return O;
      }, u.prototype.postal = function() {
        var d = this.character({ pool: "XVTSRPNKLMHJGECBA" }), m = d + this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }), v = this.natural({ max: 9 }) + this.character({ alpha: !0, casing: "upper" }) + this.natural({ max: 9 });
        return m + " " + v;
      }, u.prototype.postcode = function() {
        var d = this.pick(this.get("postcodeAreas")).code, m = this.natural({ max: 9 }), v = this.bool() ? this.character({ alpha: !0, casing: "upper" }) : "", k = d + m + v, O = this.natural({ max: 9 }), G = this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }), H = O + G;
        return k + " " + H;
      }, u.prototype.counties = function(d) {
        return d = f(d, { country: "uk" }), this.get("counties")[d.country.toLowerCase()];
      }, u.prototype.county = function(d) {
        return this.pick(this.counties(d)).name;
      }, u.prototype.provinces = function(d) {
        return d = f(d, { country: "ca" }), this.get("provinces")[d.country.toLowerCase()];
      }, u.prototype.province = function(d) {
        return d && d.full ? this.pick(this.provinces(d)).name : this.pick(this.provinces(d)).abbreviation;
      }, u.prototype.state = function(d) {
        return d && d.full ? this.pick(this.states(d)).name : this.pick(this.states(d)).abbreviation;
      }, u.prototype.states = function(d) {
        d = f(d, { country: "us", us_states_and_dc: !0 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            var v = this.get("us_states_and_dc"), k = this.get("territories"), O = this.get("armed_forces");
            m = [], d.us_states_and_dc && (m = m.concat(v)), d.territories && (m = m.concat(k)), d.armed_forces && (m = m.concat(O));
            break;
          case "it":
          case "mx":
            m = this.get("country_regions")[d.country.toLowerCase()];
            break;
          case "uk":
            m = this.get("counties")[d.country.toLowerCase()];
            break;
        }
        return m;
      }, u.prototype.street = function(d) {
        d = f(d, { country: "us", syllables: 2 });
        var m;
        switch (d.country.toLowerCase()) {
          case "us":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m += " ", m += d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name;
            break;
          case "it":
            m = this.word({ syllables: d.syllables }), m = this.capitalize(m), m = (d.short_suffix ? this.street_suffix(d).abbreviation : this.street_suffix(d).name) + " " + m;
            break;
        }
        return m;
      }, u.prototype.street_suffix = function(d) {
        return d = f(d, { country: "us" }), this.pick(this.street_suffixes(d));
      }, u.prototype.street_suffixes = function(d) {
        return d = f(d, { country: "us" }), this.get("street_suffixes")[d.country.toLowerCase()];
      }, u.prototype.zip = function(d) {
        var m = this.n(this.natural, 5, { max: 9 });
        return d && d.plusfour === !0 && (m.push("-"), m = m.concat(this.n(this.natural, 4, { max: 9 }))), m.join("");
      }, u.prototype.ampm = function() {
        return this.bool() ? "am" : "pm";
      }, u.prototype.date = function(d) {
        var m, v;
        if (d && (d.min || d.max)) {
          d = f(d, {
            american: !0,
            string: !1
          });
          var k = typeof d.min < "u" ? d.min.getTime() : 1, O = typeof d.max < "u" ? d.max.getTime() : 864e13;
          v = new Date(this.integer({ min: k, max: O }));
        } else {
          var G = this.month({ raw: !0 }), H = G.days;
          d && d.month && (H = this.get("months")[(d.month % 12 + 12) % 12].days), d = f(d, {
            year: parseInt(this.year(), 10),
            // Necessary to subtract 1 because Date() 0-indexes month but not day or year
            // for some reason.
            month: G.numeric - 1,
            day: this.natural({ min: 1, max: H }),
            hour: this.hour({ twentyfour: !0 }),
            minute: this.minute(),
            second: this.second(),
            millisecond: this.millisecond(),
            american: !0,
            string: !1
          }), v = new Date(d.year, d.month, d.day, d.hour, d.minute, d.second, d.millisecond);
        }
        return d.american ? m = v.getMonth() + 1 + "/" + v.getDate() + "/" + v.getFullYear() : m = v.getDate() + "/" + (v.getMonth() + 1) + "/" + v.getFullYear(), d.string ? m : v;
      }, u.prototype.hammertime = function(d) {
        return this.date(d).getTime();
      }, u.prototype.hour = function(d) {
        return d = f(d, {
          min: d && d.twentyfour ? 0 : 1,
          max: d && d.twentyfour ? 23 : 12
        }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.twentyfour && d.max > 23, "Chance: Max cannot be greater than 23 for twentyfour option."), p(!d.twentyfour && d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.millisecond = function() {
        return this.natural({ max: 999 });
      }, u.prototype.minute = u.prototype.second = function(d) {
        return d = f(d, { min: 0, max: 59 }), p(d.min < 0, "Chance: Min cannot be less than 0."), p(d.max > 59, "Chance: Max cannot be greater than 59."), p(d.min > d.max, "Chance: Min cannot be greater than Max."), this.natural({ min: d.min, max: d.max });
      }, u.prototype.month = function(d) {
        d = f(d, { min: 1, max: 12 }), p(d.min < 1, "Chance: Min cannot be less than 1."), p(d.max > 12, "Chance: Max cannot be greater than 12."), p(d.min > d.max, "Chance: Min cannot be greater than Max.");
        var m = this.pick(this.months().slice(d.min - 1, d.max));
        return d.raw ? m : m.name;
      }, u.prototype.months = function() {
        return this.get("months");
      }, u.prototype.second = function() {
        return this.natural({ max: 59 });
      }, u.prototype.timestamp = function() {
        return this.natural({ min: 1, max: parseInt((/* @__PURE__ */ new Date()).getTime() / 1e3, 10) });
      }, u.prototype.weekday = function(d) {
        d = f(d, { weekday_only: !1 });
        var m = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        return d.weekday_only || (m.push("Saturday"), m.push("Sunday")), this.pickone(m);
      }, u.prototype.year = function(d) {
        return d = f(d, { min: (/* @__PURE__ */ new Date()).getFullYear() }), d.max = typeof d.max < "u" ? d.max : d.min + 100, this.natural(d).toString();
      }, u.prototype.cc = function(d) {
        d = f(d);
        var m, v, k;
        return m = d.type ? this.cc_type({ name: d.type, raw: !0 }) : this.cc_type({ raw: !0 }), v = m.prefix.split(""), k = m.length - m.prefix.length - 1, v = v.concat(this.n(this.integer, k, { min: 0, max: 9 })), v.push(this.luhn_calculate(v.join(""))), v.join("");
      }, u.prototype.cc_types = function() {
        return this.get("cc_types");
      }, u.prototype.cc_type = function(d) {
        d = f(d);
        var m = this.cc_types(), v = null;
        if (d.name) {
          for (var k = 0; k < m.length; k++)
            if (m[k].name === d.name || m[k].short_name === d.name) {
              v = m[k];
              break;
            }
          if (v === null)
            throw new RangeError("Chance: Credit card type '" + d.name + "' is not supported");
        } else
          v = this.pick(m);
        return d.raw ? v : v.name;
      }, u.prototype.currency_types = function() {
        return this.get("currency_types");
      }, u.prototype.currency = function() {
        return this.pick(this.currency_types());
      }, u.prototype.timezones = function() {
        return this.get("timezones");
      }, u.prototype.timezone = function() {
        return this.pick(this.timezones());
      }, u.prototype.currency_pair = function(d) {
        var m = this.unique(this.currency, 2, {
          comparator: function(v, k) {
            return v.reduce(function(O, G) {
              return O || G.code === k.code;
            }, !1);
          }
        });
        return d ? m[0].code + "/" + m[1].code : m;
      }, u.prototype.dollar = function(d) {
        d = f(d, { max: 1e4, min: 0 });
        var m = this.floating({ min: d.min, max: d.max, fixed: 2 }).toString(), v = m.split(".")[1];
        return v === void 0 ? m += ".00" : v.length < 2 && (m = m + "0"), m < 0 ? "-$" + m.replace("-", "") : "$" + m;
      }, u.prototype.euro = function(d) {
        return Number(this.dollar(d).replace("$", "")).toLocaleString() + "€";
      }, u.prototype.exp = function(d) {
        d = f(d);
        var m = {};
        return m.year = this.exp_year(), m.year === (/* @__PURE__ */ new Date()).getFullYear().toString() ? m.month = this.exp_month({ future: !0 }) : m.month = this.exp_month(), d.raw ? m : m.month + "/" + m.year;
      }, u.prototype.exp_month = function(d) {
        d = f(d);
        var m, v, k = (/* @__PURE__ */ new Date()).getMonth() + 1;
        if (d.future && k !== 12)
          do
            m = this.month({ raw: !0 }).numeric, v = parseInt(m, 10);
          while (v <= k);
        else
          m = this.month({ raw: !0 }).numeric;
        return m;
      }, u.prototype.exp_year = function() {
        var d = (/* @__PURE__ */ new Date()).getMonth() + 1, m = (/* @__PURE__ */ new Date()).getFullYear();
        return this.year({ min: d === 12 ? m + 1 : m, max: m + 10 });
      }, u.prototype.vat = function(d) {
        switch (d = f(d, { country: "it" }), d.country.toLowerCase()) {
          case "it":
            return this.it_vat();
        }
      }, u.prototype.iban = function() {
        var d = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", m = d + "0123456789", v = this.string({ length: 2, pool: d }) + this.pad(this.integer({ min: 0, max: 99 }), 2) + this.string({ length: 4, pool: m }) + this.pad(this.natural(), this.natural({ min: 6, max: 26 }));
        return v;
      }, u.prototype.it_vat = function() {
        var d = this.natural({ min: 1, max: 18e5 });
        return d = this.pad(d, 7) + this.pad(this.pick(this.provinces({ country: "it" })).code, 3), d + this.luhn_calculate(d);
      }, u.prototype.cf = function(d) {
        d = d || {};
        var m = d.gender ? d.gender : this.gender(), v = d.first ? d.first : this.first({ gender: m, nationality: "it" }), k = d.last ? d.last : this.last({ nationality: "it" }), O = d.birthday ? d.birthday : this.birthday(), G = d.city ? d.city : this.pickone(["A", "B", "C", "D", "E", "F", "G", "H", "I", "L", "M", "Z"]) + this.pad(this.natural({ max: 999 }), 3), H = [], j = function(W, U) {
          var Z, V = [];
          return W.length < 3 ? V = W.split("").concat("XXX".split("")).splice(0, 3) : (Z = W.toUpperCase().split("").map(function(Y) {
            return "BCDFGHJKLMNPRSTVWZ".indexOf(Y) !== -1 ? Y : void 0;
          }).join(""), Z.length > 3 && (U ? Z = Z.substr(0, 3) : Z = Z[0] + Z.substr(2, 2)), Z.length < 3 && (V = Z, Z = W.toUpperCase().split("").map(function(Y) {
            return "AEIOU".indexOf(Y) !== -1 ? Y : void 0;
          }).join("").substr(0, 3 - V.length)), V = V + Z), V;
        }, F = function(W, U, Z) {
          var V = ["A", "B", "C", "D", "E", "H", "L", "M", "P", "R", "S", "T"];
          return W.getFullYear().toString().substr(2) + V[W.getMonth()] + Z.pad(W.getDate() + (U.toLowerCase() === "female" ? 40 : 0), 2);
        }, z = function(W) {
          for (var U = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ", Z = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ", V = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", Y = "BAKPLCQDREVOSFTGUHMINJWZYX", ge = 0, ce = 0; ce < 15; ce++)
            ce % 2 !== 0 ? ge += V.indexOf(Z[U.indexOf(W[ce])]) : ge += Y.indexOf(Z[U.indexOf(W[ce])]);
          return V[ge % 26];
        };
        return H = H.concat(j(k, !0), j(v), F(O, m, this), G.toUpperCase().split("")).join(""), H += z(H.toUpperCase()), H.toUpperCase();
      }, u.prototype.pl_pesel = function() {
        for (var d = this.natural({ min: 1, max: 9999999999 }), m = this.pad(d, 10).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (1 * m[0] + 3 * m[1] + 7 * m[2] + 9 * m[3] + 1 * m[4] + 3 * m[5] + 7 * m[6] + 9 * m[7] + 1 * m[8] + 3 * m[9]) % 10;
        return k !== 0 && (k = 10 - k), m.join("") + k;
      }, u.prototype.pl_nip = function() {
        for (var d = this.natural({ min: 1, max: 999999999 }), m = this.pad(d, 9).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (6 * m[0] + 5 * m[1] + 7 * m[2] + 2 * m[3] + 3 * m[4] + 4 * m[5] + 5 * m[6] + 6 * m[7] + 7 * m[8]) % 11;
        return k === 10 ? this.pl_nip() : m.join("") + k;
      }, u.prototype.pl_regon = function() {
        for (var d = this.natural({ min: 1, max: 99999999 }), m = this.pad(d, 8).split(""), v = 0; v < m.length; v++)
          m[v] = parseInt(m[v]);
        var k = (8 * m[0] + 9 * m[1] + 2 * m[2] + 3 * m[3] + 4 * m[4] + 5 * m[5] + 6 * m[6] + 7 * m[7]) % 11;
        return k === 10 && (k = 0), m.join("") + k;
      }, u.prototype.music_genre = function(d = "general") {
        if (!(d.toLowerCase() in x.music_genres))
          throw new Error(`Unsupported genre: ${d}`);
        const m = x.music_genres[d.toLowerCase()], v = this.integer({ min: 0, max: m.length - 1 });
        return m[v];
      }, u.prototype.note = function(d) {
        d = f(d, { notes: "flatKey" });
        var m = {
          naturals: ["C", "D", "E", "F", "G", "A", "B"],
          flats: ["D♭", "E♭", "G♭", "A♭", "B♭"],
          sharps: ["C♯", "D♯", "F♯", "G♯", "A♯"]
        };
        return m.all = m.naturals.concat(m.flats.concat(m.sharps)), m.flatKey = m.naturals.concat(m.flats), m.sharpKey = m.naturals.concat(m.sharps), this.pickone(m[d.notes]);
      }, u.prototype.midi_note = function(d) {
        var m = 0, v = 127;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.chord_quality = function(d) {
        d = f(d, { jazz: !0 });
        var m = ["maj", "min", "aug", "dim"];
        return d.jazz && (m = [
          "maj7",
          "min7",
          "7",
          "sus",
          "dim",
          "ø"
        ]), this.pickone(m);
      }, u.prototype.chord = function(d) {
        return d = f(d), this.note(d) + this.chord_quality(d);
      }, u.prototype.tempo = function(d) {
        var m = 40, v = 320;
        return d = f(d, { min: m, max: v }), this.integer({ min: d.min, max: d.max });
      }, u.prototype.coin = function() {
        return this.bool() ? "heads" : "tails";
      };
      function C(d) {
        return function() {
          return this.natural(d);
        };
      }
      u.prototype.d4 = C({ min: 1, max: 4 }), u.prototype.d6 = C({ min: 1, max: 6 }), u.prototype.d8 = C({ min: 1, max: 8 }), u.prototype.d10 = C({ min: 1, max: 10 }), u.prototype.d12 = C({ min: 1, max: 12 }), u.prototype.d20 = C({ min: 1, max: 20 }), u.prototype.d30 = C({ min: 1, max: 30 }), u.prototype.d100 = C({ min: 1, max: 100 }), u.prototype.rpg = function(d, m) {
        if (m = f(m), d) {
          var v = d.toLowerCase().split("d"), k = [];
          if (v.length !== 2 || !parseInt(v[0], 10) || !parseInt(v[1], 10))
            throw new Error("Chance: Invalid format provided. Please provide #d# where the first # is the number of dice to roll, the second # is the max of each die");
          for (var O = v[0]; O > 0; O--)
            k[O - 1] = this.natural({ min: 1, max: v[1] });
          return typeof m.sum < "u" && m.sum ? k.reduce(function(G, H) {
            return G + H;
          }) : k;
        } else
          throw new RangeError("Chance: A type of die roll must be included");
      }, u.prototype.guid = function(d) {
        d = f(d, { version: 5 });
        var m = "abcdef1234567890", v = "ab89", k = this.string({ pool: m, length: 8 }) + "-" + this.string({ pool: m, length: 4 }) + "-" + // The Version
        d.version + this.string({ pool: m, length: 3 }) + "-" + // The Variant
        this.string({ pool: v, length: 1 }) + this.string({ pool: m, length: 3 }) + "-" + this.string({ pool: m, length: 12 });
        return k;
      }, u.prototype.hash = function(d) {
        d = f(d, { length: 40, casing: "lower" });
        var m = d.casing === "upper" ? s.toUpperCase() : s;
        return this.string({ pool: m, length: d.length });
      }, u.prototype.luhn_check = function(d) {
        var m = d.toString(), v = +m.substring(m.length - 1);
        return v === this.luhn_calculate(+m.substring(0, m.length - 1));
      }, u.prototype.luhn_calculate = function(d) {
        for (var m = d.toString().split("").reverse(), v = 0, k, O = 0, G = m.length; G > O; ++O)
          k = +m[O], O % 2 === 0 && (k *= 2, k > 9 && (k -= 9)), v += k;
        return v * 9 % 10;
      }, u.prototype.md5 = function(d) {
        var m = { str: "", key: null, raw: !1 };
        if (!d)
          m.str = this.string(), d = {};
        else if (typeof d == "string")
          m.str = d, d = {};
        else {
          if (typeof d != "object")
            return null;
          if (d.constructor === "Array")
            return null;
        }
        if (m = f(d, m), !m.str)
          throw new Error("A parameter is required to return an md5 hash.");
        return this.bimd5.md5(m.str, m.key, m.raw);
      }, u.prototype.file = function(d) {
        var m = d || {}, v = "fileExtension", k = Object.keys(this.get("fileExtension")), O, G;
        if (O = this.word({ length: m.length }), m.extension)
          return G = m.extension, O + "." + G;
        if (m.extensions) {
          if (Array.isArray(m.extensions))
            return G = this.pickone(m.extensions), O + "." + G;
          if (m.extensions.constructor === Object) {
            var H = m.extensions, j = Object.keys(H);
            return G = this.pickone(H[this.pickone(j)]), O + "." + G;
          }
          throw new Error("Chance: Extensions must be an Array or Object");
        }
        if (m.fileType) {
          var F = m.fileType;
          if (k.indexOf(F) !== -1)
            return G = this.pickone(this.get(v)[F]), O + "." + G;
          throw new RangeError("Chance: Expect file type value to be 'raster', 'vector', '3d' or 'document'");
        }
        return G = this.pickone(this.get(v)[this.pickone(k)]), O + "." + G;
      }, u.prototype.fileWithContent = function(d) {
        var m = d || {}, v = "fileName" in m ? m.fileName : this.file().split(".")[0];
        if (v += "." + ("fileExtension" in m ? m.fileExtension : this.file().split(".")[1]), typeof m.fileSize != "number")
          throw new Error("File size must be an integer");
        var k = {
          fileData: this.buffer({ length: m.fileSize }),
          fileName: v
        };
        return k;
      };
      var x = {
        firstNames: {
          male: {
            en: ["James", "John", "Robert", "Michael", "William", "David", "Richard", "Joseph", "Charles", "Thomas", "Christopher", "Daniel", "Matthew", "George", "Donald", "Anthony", "Paul", "Mark", "Edward", "Steven", "Kenneth", "Andrew", "Brian", "Joshua", "Kevin", "Ronald", "Timothy", "Jason", "Jeffrey", "Frank", "Gary", "Ryan", "Nicholas", "Eric", "Stephen", "Jacob", "Larry", "Jonathan", "Scott", "Raymond", "Justin", "Brandon", "Gregory", "Samuel", "Benjamin", "Patrick", "Jack", "Henry", "Walter", "Dennis", "Jerry", "Alexander", "Peter", "Tyler", "Douglas", "Harold", "Aaron", "Jose", "Adam", "Arthur", "Zachary", "Carl", "Nathan", "Albert", "Kyle", "Lawrence", "Joe", "Willie", "Gerald", "Roger", "Keith", "Jeremy", "Terry", "Harry", "Ralph", "Sean", "Jesse", "Roy", "Louis", "Billy", "Austin", "Bruce", "Eugene", "Christian", "Bryan", "Wayne", "Russell", "Howard", "Fred", "Ethan", "Jordan", "Philip", "Alan", "Juan", "Randy", "Vincent", "Bobby", "Dylan", "Johnny", "Phillip", "Victor", "Clarence", "Ernest", "Martin", "Craig", "Stanley", "Shawn", "Travis", "Bradley", "Leonard", "Earl", "Gabriel", "Jimmy", "Francis", "Todd", "Noah", "Danny", "Dale", "Cody", "Carlos", "Allen", "Frederick", "Logan", "Curtis", "Alex", "Joel", "Luis", "Norman", "Marvin", "Glenn", "Tony", "Nathaniel", "Rodney", "Melvin", "Alfred", "Steve", "Cameron", "Chad", "Edwin", "Caleb", "Evan", "Antonio", "Lee", "Herbert", "Jeffery", "Isaac", "Derek", "Ricky", "Marcus", "Theodore", "Elijah", "Luke", "Jesus", "Eddie", "Troy", "Mike", "Dustin", "Ray", "Adrian", "Bernard", "Leroy", "Angel", "Randall", "Wesley", "Ian", "Jared", "Mason", "Hunter", "Calvin", "Oscar", "Clifford", "Jay", "Shane", "Ronnie", "Barry", "Lucas", "Corey", "Manuel", "Leo", "Tommy", "Warren", "Jackson", "Isaiah", "Connor", "Don", "Dean", "Jon", "Julian", "Miguel", "Bill", "Lloyd", "Charlie", "Mitchell", "Leon", "Jerome", "Darrell", "Jeremiah", "Alvin", "Brett", "Seth", "Floyd", "Jim", "Blake", "Micheal", "Gordon", "Trevor", "Lewis", "Erik", "Edgar", "Vernon", "Devin", "Gavin", "Jayden", "Chris", "Clyde", "Tom", "Derrick", "Mario", "Brent", "Marc", "Herman", "Chase", "Dominic", "Ricardo", "Franklin", "Maurice", "Max", "Aiden", "Owen", "Lester", "Gilbert", "Elmer", "Gene", "Francisco", "Glen", "Cory", "Garrett", "Clayton", "Sam", "Jorge", "Chester", "Alejandro", "Jeff", "Harvey", "Milton", "Cole", "Ivan", "Andre", "Duane", "Landon"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0163
            it: ["Adolfo", "Alberto", "Aldo", "Alessandro", "Alessio", "Alfredo", "Alvaro", "Andrea", "Angelo", "Angiolo", "Antonino", "Antonio", "Attilio", "Benito", "Bernardo", "Bruno", "Carlo", "Cesare", "Christian", "Claudio", "Corrado", "Cosimo", "Cristian", "Cristiano", "Daniele", "Dario", "David", "Davide", "Diego", "Dino", "Domenico", "Duccio", "Edoardo", "Elia", "Elio", "Emanuele", "Emiliano", "Emilio", "Enrico", "Enzo", "Ettore", "Fabio", "Fabrizio", "Federico", "Ferdinando", "Fernando", "Filippo", "Francesco", "Franco", "Gabriele", "Giacomo", "Giampaolo", "Giampiero", "Giancarlo", "Gianfranco", "Gianluca", "Gianmarco", "Gianni", "Gino", "Giorgio", "Giovanni", "Giuliano", "Giulio", "Giuseppe", "Graziano", "Gregorio", "Guido", "Iacopo", "Jacopo", "Lapo", "Leonardo", "Lorenzo", "Luca", "Luciano", "Luigi", "Manuel", "Marcello", "Marco", "Marino", "Mario", "Massimiliano", "Massimo", "Matteo", "Mattia", "Maurizio", "Mauro", "Michele", "Mirko", "Mohamed", "Nello", "Neri", "Niccolò", "Nicola", "Osvaldo", "Otello", "Paolo", "Pier Luigi", "Piero", "Pietro", "Raffaele", "Remo", "Renato", "Renzo", "Riccardo", "Roberto", "Rolando", "Romano", "Salvatore", "Samuele", "Sandro", "Sergio", "Silvano", "Simone", "Stefano", "Thomas", "Tommaso", "Ubaldo", "Ugo", "Umberto", "Valerio", "Valter", "Vasco", "Vincenzo", "Vittorio"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Aaron", "Abel", "Adam", "Adriaan", "Albert", "Alexander", "Ali", "Arjen", "Arno", "Bart", "Bas", "Bastiaan", "Benjamin", "Bob", "Boris", "Bram", "Brent", "Cas", "Casper", "Chris", "Christiaan", "Cornelis", "Daan", "Daley", "Damian", "Dani", "Daniel", "Daniël", "David", "Dean", "Dirk", "Dylan", "Egbert", "Elijah", "Erik", "Erwin", "Evert", "Ezra", "Fabian", "Fedde", "Finn", "Florian", "Floris", "Frank", "Frans", "Frederik", "Freek", "Geert", "Gerard", "Gerben", "Gerrit", "Gijs", "Guus", "Hans", "Hendrik", "Henk", "Herman", "Hidde", "Hugo", "Jaap", "Jan Jaap", "Jan-Willem", "Jack", "Jacob", "Jan", "Jason", "Jasper", "Jayden", "Jelle", "Jelte", "Jens", "Jeroen", "Jesse", "Jim", "Job", "Joep", "Johannes", "John", "Jonathan", "Joris", "Joshua", "Joël", "Julian", "Kees", "Kevin", "Koen", "Lars", "Laurens", "Leendert", "Lennard", "Lodewijk", "Luc", "Luca", "Lucas", "Lukas", "Luuk", "Maarten", "Marcus", "Martijn", "Martin", "Matthijs", "Maurits", "Max", "Mees", "Melle", "Mick", "Mika", "Milan", "Mohamed", "Mohammed", "Morris", "Muhammed", "Nathan", "Nick", "Nico", "Niek", "Niels", "Noah", "Noud", "Olivier", "Oscar", "Owen", "Paul", "Pepijn", "Peter", "Pieter", "Pim", "Quinten", "Reinier", "Rens", "Robin", "Ruben", "Sam", "Samuel", "Sander", "Sebastiaan", "Sem", "Sep", "Sepp", "Siem", "Simon", "Stan", "Stef", "Steven", "Stijn", "Sven", "Teun", "Thijmen", "Thijs", "Thomas", "Tijn", "Tim", "Timo", "Tobias", "Tom", "Victor", "Vince", "Willem", "Wim", "Wouter", "Yusuf"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Aaron", "Abdon", "Abel", "Abélard", "Abelin", "Abondance", "Abraham", "Absalon", "Acace", "Achaire", "Achille", "Adalard", "Adalbald", "Adalbéron", "Adalbert", "Adalric", "Adam", "Adegrin", "Adel", "Adelin", "Andelin", "Adelphe", "Adam", "Adéodat", "Adhémar", "Adjutor", "Adolphe", "Adonis", "Adon", "Adrien", "Agapet", "Agathange", "Agathon", "Agilbert", "Agénor", "Agnan", "Aignan", "Agrippin", "Aimable", "Aimé", "Alain", "Alban", "Albin", "Aubin", "Albéric", "Albert", "Albertet", "Alcibiade", "Alcide", "Alcée", "Alcime", "Aldonce", "Aldric", "Aldéric", "Aleaume", "Alexandre", "Alexis", "Alix", "Alliaume", "Aleaume", "Almine", "Almire", "Aloïs", "Alphée", "Alphonse", "Alpinien", "Alverède", "Amalric", "Amaury", "Amandin", "Amant", "Ambroise", "Amédée", "Amélien", "Amiel", "Amour", "Anaël", "Anastase", "Anatole", "Ancelin", "Andéol", "Andoche", "André", "Andoche", "Ange", "Angelin", "Angilbe", "Anglebert", "Angoustan", "Anicet", "Anne", "Annibal", "Ansbert", "Anselme", "Anthelme", "Antheaume", "Anthime", "Antide", "Antoine", "Antonius", "Antonin", "Apollinaire", "Apollon", "Aquilin", "Arcade", "Archambaud", "Archambeau", "Archange", "Archibald", "Arian", "Ariel", "Ariste", "Aristide", "Armand", "Armel", "Armin", "Arnould", "Arnaud", "Arolde", "Arsène", "Arsinoé", "Arthaud", "Arthème", "Arthur", "Ascelin", "Athanase", "Aubry", "Audebert", "Audouin", "Audran", "Audric", "Auguste", "Augustin", "Aurèle", "Aurélien", "Aurian", "Auxence", "Axel", "Aymard", "Aymeric", "Aymon", "Aymond", "Balthazar", "Baptiste", "Barnabé", "Barthélemy", "Bartimée", "Basile", "Bastien", "Baudouin", "Bénigne", "Benjamin", "Benoît", "Bérenger", "Bérard", "Bernard", "Bertrand", "Blaise", "Bon", "Boniface", "Bouchard", "Brice", "Brieuc", "Bruno", "Brunon", "Calixte", "Calliste", "Camélien", "Camille", "Camillien", "Candide", "Caribert", "Carloman", "Cassandre", "Cassien", "Cédric", "Céleste", "Célestin", "Célien", "Césaire", "César", "Charles", "Charlemagne", "Childebert", "Chilpéric", "Chrétien", "Christian", "Christodule", "Christophe", "Chrysostome", "Clarence", "Claude", "Claudien", "Cléandre", "Clément", "Clotaire", "Côme", "Constance", "Constant", "Constantin", "Corentin", "Cyprien", "Cyriaque", "Cyrille", "Cyril", "Damien", "Daniel", "David", "Delphin", "Denis", "Désiré", "Didier", "Dieudonné", "Dimitri", "Dominique", "Dorian", "Dorothée", "Edgard", "Edmond", "Édouard", "Éleuthère", "Élie", "Élisée", "Émeric", "Émile", "Émilien", "Emmanuel", "Enguerrand", "Épiphane", "Éric", "Esprit", "Ernest", "Étienne", "Eubert", "Eudes", "Eudoxe", "Eugène", "Eusèbe", "Eustache", "Évariste", "Évrard", "Fabien", "Fabrice", "Falba", "Félicité", "Félix", "Ferdinand", "Fiacre", "Fidèle", "Firmin", "Flavien", "Flodoard", "Florent", "Florentin", "Florestan", "Florian", "Fortuné", "Foulques", "Francisque", "François", "Français", "Franciscus", "Francs", "Frédéric", "Fulbert", "Fulcran", "Fulgence", "Gabin", "Gabriel", "Gaël", "Garnier", "Gaston", "Gaspard", "Gatien", "Gaud", "Gautier", "Gédéon", "Geoffroy", "Georges", "Géraud", "Gérard", "Gerbert", "Germain", "Gervais", "Ghislain", "Gilbert", "Gilles", "Girart", "Gislebert", "Gondebaud", "Gonthier", "Gontran", "Gonzague", "Grégoire", "Guérin", "Gui", "Guillaume", "Gustave", "Guy", "Guyot", "Hardouin", "Hector", "Hédelin", "Hélier", "Henri", "Herbert", "Herluin", "Hervé", "Hilaire", "Hildebert", "Hincmar", "Hippolyte", "Honoré", "Hubert", "Hugues", "Innocent", "Isabeau", "Isidore", "Jacques", "Japhet", "Jason", "Jean", "Jeannel", "Jeannot", "Jérémie", "Jérôme", "Joachim", "Joanny", "Job", "Jocelyn", "Joël", "Johan", "Jonas", "Jonathan", "Joseph", "Josse", "Josselin", "Jourdain", "Jude", "Judicaël", "Jules", "Julien", "Juste", "Justin", "Lambert", "Landry", "Laurent", "Lazare", "Léandre", "Léon", "Léonard", "Léopold", "Leu", "Loup", "Leufroy", "Libère", "Liétald", "Lionel", "Loïc", "Longin", "Lorrain", "Lorraine", "Lothaire", "Louis", "Loup", "Luc", "Lucas", "Lucien", "Ludolphe", "Ludovic", "Macaire", "Malo", "Mamert", "Manassé", "Marc", "Marceau", "Marcel", "Marcelin", "Marius", "Marseille", "Martial", "Martin", "Mathurin", "Matthias", "Mathias", "Matthieu", "Maugis", "Maurice", "Mauricet", "Maxence", "Maxime", "Maximilien", "Mayeul", "Médéric", "Melchior", "Mence", "Merlin", "Mérovée", "Michaël", "Michel", "Moïse", "Morgan", "Nathan", "Nathanaël", "Narcisse", "Néhémie", "Nestor", "Nestor", "Nicéphore", "Nicolas", "Noé", "Noël", "Norbert", "Normand", "Normands", "Octave", "Odilon", "Odon", "Oger", "Olivier", "Oury", "Pacôme", "Palémon", "Parfait", "Pascal", "Paterne", "Patrice", "Paul", "Pépin", "Perceval", "Philémon", "Philibert", "Philippe", "Philothée", "Pie", "Pierre", "Pierrick", "Prosper", "Quentin", "Raoul", "Raphaël", "Raymond", "Régis", "Réjean", "Rémi", "Renaud", "René", "Reybaud", "Richard", "Robert", "Roch", "Rodolphe", "Rodrigue", "Roger", "Roland", "Romain", "Romuald", "Roméo", "Rome", "Ronan", "Roselin", "Salomon", "Samuel", "Savin", "Savinien", "Scholastique", "Sébastien", "Séraphin", "Serge", "Séverin", "Sidoine", "Sigebert", "Sigismond", "Silvère", "Simon", "Siméon", "Sixte", "Stanislas", "Stéphane", "Stephan", "Sylvain", "Sylvestre", "Tancrède", "Tanguy", "Taurin", "Théodore", "Théodose", "Théophile", "Théophraste", "Thibault", "Thibert", "Thierry", "Thomas", "Timoléon", "Timothée", "Titien", "Tonnin", "Toussaint", "Trajan", "Tristan", "Turold", "Tim", "Ulysse", "Urbain", "Valentin", "Valère", "Valéry", "Venance", "Venant", "Venceslas", "Vianney", "Victor", "Victorien", "Victorin", "Vigile", "Vincent", "Vital", "Vitalien", "Vivien", "Waleran", "Wandrille", "Xavier", "Xénophon", "Yves", "Zacharie", "Zaché", "Zéphirin"]
          },
          female: {
            en: ["Mary", "Emma", "Elizabeth", "Minnie", "Margaret", "Ida", "Alice", "Bertha", "Sarah", "Annie", "Clara", "Ella", "Florence", "Cora", "Martha", "Laura", "Nellie", "Grace", "Carrie", "Maude", "Mabel", "Bessie", "Jennie", "Gertrude", "Julia", "Hattie", "Edith", "Mattie", "Rose", "Catherine", "Lillian", "Ada", "Lillie", "Helen", "Jessie", "Louise", "Ethel", "Lula", "Myrtle", "Eva", "Frances", "Lena", "Lucy", "Edna", "Maggie", "Pearl", "Daisy", "Fannie", "Josephine", "Dora", "Rosa", "Katherine", "Agnes", "Marie", "Nora", "May", "Mamie", "Blanche", "Stella", "Ellen", "Nancy", "Effie", "Sallie", "Nettie", "Della", "Lizzie", "Flora", "Susie", "Maud", "Mae", "Etta", "Harriet", "Sadie", "Caroline", "Katie", "Lydia", "Elsie", "Kate", "Susan", "Mollie", "Alma", "Addie", "Georgia", "Eliza", "Lulu", "Nannie", "Lottie", "Amanda", "Belle", "Charlotte", "Rebecca", "Ruth", "Viola", "Olive", "Amelia", "Hannah", "Jane", "Virginia", "Emily", "Matilda", "Irene", "Kathryn", "Esther", "Willie", "Henrietta", "Ollie", "Amy", "Rachel", "Sara", "Estella", "Theresa", "Augusta", "Ora", "Pauline", "Josie", "Lola", "Sophia", "Leona", "Anne", "Mildred", "Ann", "Beulah", "Callie", "Lou", "Delia", "Eleanor", "Barbara", "Iva", "Louisa", "Maria", "Mayme", "Evelyn", "Estelle", "Nina", "Betty", "Marion", "Bettie", "Dorothy", "Luella", "Inez", "Lela", "Rosie", "Allie", "Millie", "Janie", "Cornelia", "Victoria", "Ruby", "Winifred", "Alta", "Celia", "Christine", "Beatrice", "Birdie", "Harriett", "Mable", "Myra", "Sophie", "Tillie", "Isabel", "Sylvia", "Carolyn", "Isabelle", "Leila", "Sally", "Ina", "Essie", "Bertie", "Nell", "Alberta", "Katharine", "Lora", "Rena", "Mina", "Rhoda", "Mathilda", "Abbie", "Eula", "Dollie", "Hettie", "Eunice", "Fanny", "Ola", "Lenora", "Adelaide", "Christina", "Lelia", "Nelle", "Sue", "Johanna", "Lilly", "Lucinda", "Minerva", "Lettie", "Roxie", "Cynthia", "Helena", "Hilda", "Hulda", "Bernice", "Genevieve", "Jean", "Cordelia", "Marian", "Francis", "Jeanette", "Adeline", "Gussie", "Leah", "Lois", "Lura", "Mittie", "Hallie", "Isabella", "Olga", "Phoebe", "Teresa", "Hester", "Lida", "Lina", "Winnie", "Claudia", "Marguerite", "Vera", "Cecelia", "Bess", "Emilie", "Rosetta", "Verna", "Myrtie", "Cecilia", "Elva", "Olivia", "Ophelia", "Georgie", "Elnora", "Violet", "Adele", "Lily", "Linnie", "Loretta", "Madge", "Polly", "Virgie", "Eugenia", "Lucile", "Lucille", "Mabelle", "Rosalie"],
            // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0162
            it: ["Ada", "Adriana", "Alessandra", "Alessia", "Alice", "Angela", "Anna", "Anna Maria", "Annalisa", "Annita", "Annunziata", "Antonella", "Arianna", "Asia", "Assunta", "Aurora", "Barbara", "Beatrice", "Benedetta", "Bianca", "Bruna", "Camilla", "Carla", "Carlotta", "Carmela", "Carolina", "Caterina", "Catia", "Cecilia", "Chiara", "Cinzia", "Clara", "Claudia", "Costanza", "Cristina", "Daniela", "Debora", "Diletta", "Dina", "Donatella", "Elena", "Eleonora", "Elisa", "Elisabetta", "Emanuela", "Emma", "Eva", "Federica", "Fernanda", "Fiorella", "Fiorenza", "Flora", "Franca", "Francesca", "Gabriella", "Gaia", "Gemma", "Giada", "Gianna", "Gina", "Ginevra", "Giorgia", "Giovanna", "Giulia", "Giuliana", "Giuseppa", "Giuseppina", "Grazia", "Graziella", "Greta", "Ida", "Ilaria", "Ines", "Iolanda", "Irene", "Irma", "Isabella", "Jessica", "Laura", "Lea", "Letizia", "Licia", "Lidia", "Liliana", "Lina", "Linda", "Lisa", "Livia", "Loretta", "Luana", "Lucia", "Luciana", "Lucrezia", "Luisa", "Manuela", "Mara", "Marcella", "Margherita", "Maria", "Maria Cristina", "Maria Grazia", "Maria Luisa", "Maria Pia", "Maria Teresa", "Marina", "Marisa", "Marta", "Martina", "Marzia", "Matilde", "Melissa", "Michela", "Milena", "Mirella", "Monica", "Natalina", "Nella", "Nicoletta", "Noemi", "Olga", "Paola", "Patrizia", "Piera", "Pierina", "Raffaella", "Rebecca", "Renata", "Rina", "Rita", "Roberta", "Rosa", "Rosanna", "Rossana", "Rossella", "Sabrina", "Sandra", "Sara", "Serena", "Silvana", "Silvia", "Simona", "Simonetta", "Sofia", "Sonia", "Stefania", "Susanna", "Teresa", "Tina", "Tiziana", "Tosca", "Valentina", "Valeria", "Vanda", "Vanessa", "Vanna", "Vera", "Veronica", "Vilma", "Viola", "Virginia", "Vittoria"],
            // Data taken from http://www.svbkindernamen.nl/int/nl/kindernamen/index.html
            nl: ["Ada", "Arianne", "Afke", "Amanda", "Amber", "Amy", "Aniek", "Anita", "Anja", "Anna", "Anne", "Annelies", "Annemarie", "Annette", "Anouk", "Astrid", "Aukje", "Barbara", "Bianca", "Carla", "Carlijn", "Carolien", "Chantal", "Charlotte", "Claudia", "Daniëlle", "Debora", "Diane", "Dora", "Eline", "Elise", "Ella", "Ellen", "Emma", "Esmee", "Evelien", "Esther", "Erica", "Eva", "Femke", "Fleur", "Floor", "Froukje", "Gea", "Gerda", "Hanna", "Hanneke", "Heleen", "Hilde", "Ilona", "Ina", "Inge", "Ingrid", "Iris", "Isabel", "Isabelle", "Janneke", "Jasmijn", "Jeanine", "Jennifer", "Jessica", "Johanna", "Joke", "Julia", "Julie", "Karen", "Karin", "Katja", "Kim", "Lara", "Laura", "Lena", "Lianne", "Lieke", "Lilian", "Linda", "Lisa", "Lisanne", "Lotte", "Louise", "Maaike", "Manon", "Marga", "Maria", "Marissa", "Marit", "Marjolein", "Martine", "Marleen", "Melissa", "Merel", "Miranda", "Michelle", "Mirjam", "Mirthe", "Naomi", "Natalie", "Nienke", "Nina", "Noortje", "Olivia", "Patricia", "Paula", "Paulien", "Ramona", "Ria", "Rianne", "Roos", "Rosanne", "Ruth", "Sabrina", "Sandra", "Sanne", "Sara", "Saskia", "Silvia", "Sofia", "Sophie", "Sonja", "Suzanne", "Tamara", "Tess", "Tessa", "Tineke", "Valerie", "Vanessa", "Veerle", "Vera", "Victoria", "Wendy", "Willeke", "Yvonne", "Zoë"],
            // Data taken from https://fr.wikipedia.org/wiki/Liste_de_pr%C3%A9noms_fran%C3%A7ais_et_de_la_francophonie
            fr: ["Abdon", "Abel", "Abigaëlle", "Abigaïl", "Acacius", "Acanthe", "Adalbert", "Adalsinde", "Adegrine", "Adélaïde", "Adèle", "Adélie", "Adeline", "Adeltrude", "Adolphe", "Adonis", "Adrastée", "Adrehilde", "Adrienne", "Agathe", "Agilbert", "Aglaé", "Aignan", "Agneflète", "Agnès", "Agrippine", "Aimé", "Alaine", "Alaïs", "Albane", "Albérade", "Alberte", "Alcide", "Alcine", "Alcyone", "Aldegonde", "Aleth", "Alexandrine", "Alexine", "Alice", "Aliénor", "Aliette", "Aline", "Alix", "Alizé", "Aloïse", "Aloyse", "Alphonsine", "Althée", "Amaliane", "Amalthée", "Amande", "Amandine", "Amant", "Amarande", "Amaranthe", "Amaryllis", "Ambre", "Ambroisie", "Amélie", "Améthyste", "Aminte", "Anaël", "Anaïs", "Anastasie", "Anatole", "Ancelin", "Andrée", "Anémone", "Angadrême", "Angèle", "Angeline", "Angélique", "Angilbert", "Anicet", "Annabelle", "Anne", "Annette", "Annick", "Annie", "Annonciade", "Ansbert", "Anstrudie", "Anthelme", "Antigone", "Antoinette", "Antonine", "Aphélie", "Apolline", "Apollonie", "Aquiline", "Arabelle", "Arcadie", "Archange", "Argine", "Ariane", "Aricie", "Ariel", "Arielle", "Arlette", "Armance", "Armande", "Armandine", "Armelle", "Armide", "Armelle", "Armin", "Arnaud", "Arsène", "Arsinoé", "Artémis", "Arthur", "Ascelin", "Ascension", "Assomption", "Astarté", "Astérie", "Astrée", "Astrid", "Athalie", "Athanasie", "Athina", "Aube", "Albert", "Aude", "Audrey", "Augustine", "Aure", "Aurélie", "Aurélien", "Aurèle", "Aurore", "Auxence", "Aveline", "Abigaëlle", "Avoye", "Axelle", "Aymard", "Azalée", "Adèle", "Adeline", "Barbe", "Basilisse", "Bathilde", "Béatrice", "Béatrix", "Bénédicte", "Bérengère", "Bernadette", "Berthe", "Bertille", "Beuve", "Blanche", "Blanc", "Blandine", "Brigitte", "Brune", "Brunehilde", "Callista", "Camille", "Capucine", "Carine", "Caroline", "Cassandre", "Catherine", "Cécile", "Céleste", "Célestine", "Céline", "Chantal", "Charlène", "Charline", "Charlotte", "Chloé", "Christelle", "Christiane", "Christine", "Claire", "Clara", "Claude", "Claudine", "Clarisse", "Clémence", "Clémentine", "Cléo", "Clio", "Clotilde", "Coline", "Conception", "Constance", "Coralie", "Coraline", "Corentine", "Corinne", "Cyrielle", "Daniel", "Daniel", "Daphné", "Débora", "Delphine", "Denise", "Diane", "Dieudonné", "Dominique", "Doriane", "Dorothée", "Douce", "Édith", "Edmée", "Éléonore", "Éliane", "Élia", "Éliette", "Élisabeth", "Élise", "Ella", "Élodie", "Éloïse", "Elsa", "Émeline", "Émérance", "Émérentienne", "Émérencie", "Émilie", "Emma", "Emmanuelle", "Emmelie", "Ernestine", "Esther", "Estelle", "Eudoxie", "Eugénie", "Eulalie", "Euphrasie", "Eusébie", "Évangéline", "Eva", "Ève", "Évelyne", "Fanny", "Fantine", "Faustine", "Félicie", "Fernande", "Flavie", "Fleur", "Flore", "Florence", "Florie", "Fortuné", "France", "Francia", "Françoise", "Francine", "Gabrielle", "Gaëlle", "Garance", "Geneviève", "Georgette", "Gerberge", "Germaine", "Gertrude", "Gisèle", "Guenièvre", "Guilhemine", "Guillemette", "Gustave", "Gwenael", "Hélène", "Héloïse", "Henriette", "Hermine", "Hermione", "Hippolyte", "Honorine", "Hortense", "Huguette", "Ines", "Irène", "Irina", "Iris", "Isabeau", "Isabelle", "Iseult", "Isolde", "Ismérie", "Jacinthe", "Jacqueline", "Jade", "Janine", "Jeanne", "Jocelyne", "Joëlle", "Joséphine", "Judith", "Julia", "Julie", "Jules", "Juliette", "Justine", "Katy", "Kathy", "Katie", "Laura", "Laure", "Laureline", "Laurence", "Laurene", "Lauriane", "Laurianne", "Laurine", "Léa", "Léna", "Léonie", "Léon", "Léontine", "Lorraine", "Lucie", "Lucienne", "Lucille", "Ludivine", "Lydie", "Lydie", "Megane", "Madeleine", "Magali", "Maguelone", "Mallaury", "Manon", "Marceline", "Margot", "Marguerite", "Marianne", "Marie", "Myriam", "Marie", "Marine", "Marion", "Marlène", "Marthe", "Martine", "Mathilde", "Maud", "Maureen", "Mauricette", "Maxime", "Mélanie", "Melissa", "Mélissandre", "Mélisande", "Mélodie", "Michel", "Micheline", "Mireille", "Miriam", "Moïse", "Monique", "Morgane", "Muriel", "Mylène", "Nadège", "Nadine", "Nathalie", "Nicole", "Nicolette", "Nine", "Noël", "Noémie", "Océane", "Odette", "Odile", "Olive", "Olivia", "Olympe", "Ombline", "Ombeline", "Ophélie", "Oriande", "Oriane", "Ozanne", "Pascale", "Pascaline", "Paule", "Paulette", "Pauline", "Priscille", "Prisca", "Prisque", "Pécine", "Pélagie", "Pénélope", "Perrine", "Pétronille", "Philippine", "Philomène", "Philothée", "Primerose", "Prudence", "Pulchérie", "Quentine", "Quiéta", "Quintia", "Quintilla", "Rachel", "Raphaëlle", "Raymonde", "Rebecca", "Régine", "Réjeanne", "René", "Rita", "Rita", "Rolande", "Romane", "Rosalie", "Rose", "Roseline", "Sabine", "Salomé", "Sandra", "Sandrine", "Sarah", "Ségolène", "Séverine", "Sibylle", "Simone", "Sixt", "Solange", "Soline", "Solène", "Sophie", "Stéphanie", "Suzanne", "Sylvain", "Sylvie", "Tatiana", "Thaïs", "Théodora", "Thérèse", "Tiphaine", "Ursule", "Valentine", "Valérie", "Véronique", "Victoire", "Victorine", "Vinciane", "Violette", "Virginie", "Viviane", "Xavière", "Yolande", "Ysaline", "Yvette", "Yvonne", "Zélie", "Zita", "Zoé"]
          }
        },
        lastNames: {
          en: ["Smith", "Johnson", "Williams", "Jones", "Brown", "Davis", "Miller", "Wilson", "Moore", "Taylor", "Anderson", "Thomas", "Jackson", "White", "Harris", "Martin", "Thompson", "Garcia", "Martinez", "Robinson", "Clark", "Rodriguez", "Lewis", "Lee", "Walker", "Hall", "Allen", "Young", "Hernandez", "King", "Wright", "Lopez", "Hill", "Scott", "Green", "Adams", "Baker", "Gonzalez", "Nelson", "Carter", "Mitchell", "Perez", "Roberts", "Turner", "Phillips", "Campbell", "Parker", "Evans", "Edwards", "Collins", "Stewart", "Sanchez", "Morris", "Rogers", "Reed", "Cook", "Morgan", "Bell", "Murphy", "Bailey", "Rivera", "Cooper", "Richardson", "Cox", "Howard", "Ward", "Torres", "Peterson", "Gray", "Ramirez", "James", "Watson", "Brooks", "Kelly", "Sanders", "Price", "Bennett", "Wood", "Barnes", "Ross", "Henderson", "Coleman", "Jenkins", "Perry", "Powell", "Long", "Patterson", "Hughes", "Flores", "Washington", "Butler", "Simmons", "Foster", "Gonzales", "Bryant", "Alexander", "Russell", "Griffin", "Diaz", "Hayes", "Myers", "Ford", "Hamilton", "Graham", "Sullivan", "Wallace", "Woods", "Cole", "West", "Jordan", "Owens", "Reynolds", "Fisher", "Ellis", "Harrison", "Gibson", "McDonald", "Cruz", "Marshall", "Ortiz", "Gomez", "Murray", "Freeman", "Wells", "Webb", "Simpson", "Stevens", "Tucker", "Porter", "Hunter", "Hicks", "Crawford", "Henry", "Boyd", "Mason", "Morales", "Kennedy", "Warren", "Dixon", "Ramos", "Reyes", "Burns", "Gordon", "Shaw", "Holmes", "Rice", "Robertson", "Hunt", "Black", "Daniels", "Palmer", "Mills", "Nichols", "Grant", "Knight", "Ferguson", "Rose", "Stone", "Hawkins", "Dunn", "Perkins", "Hudson", "Spencer", "Gardner", "Stephens", "Payne", "Pierce", "Berry", "Matthews", "Arnold", "Wagner", "Willis", "Ray", "Watkins", "Olson", "Carroll", "Duncan", "Snyder", "Hart", "Cunningham", "Bradley", "Lane", "Andrews", "Ruiz", "Harper", "Fox", "Riley", "Armstrong", "Carpenter", "Weaver", "Greene", "Lawrence", "Elliott", "Chavez", "Sims", "Austin", "Peters", "Kelley", "Franklin", "Lawson", "Fields", "Gutierrez", "Ryan", "Schmidt", "Carr", "Vasquez", "Castillo", "Wheeler", "Chapman", "Oliver", "Montgomery", "Richards", "Williamson", "Johnston", "Banks", "Meyer", "Bishop", "McCoy", "Howell", "Alvarez", "Morrison", "Hansen", "Fernandez", "Garza", "Harvey", "Little", "Burton", "Stanley", "Nguyen", "George", "Jacobs", "Reid", "Kim", "Fuller", "Lynch", "Dean", "Gilbert", "Garrett", "Romero", "Welch", "Larson", "Frazier", "Burke", "Hanson", "Day", "Mendoza", "Moreno", "Bowman", "Medina", "Fowler", "Brewer", "Hoffman", "Carlson", "Silva", "Pearson", "Holland", "Douglas", "Fleming", "Jensen", "Vargas", "Byrd", "Davidson", "Hopkins", "May", "Terry", "Herrera", "Wade", "Soto", "Walters", "Curtis", "Neal", "Caldwell", "Lowe", "Jennings", "Barnett", "Graves", "Jimenez", "Horton", "Shelton", "Barrett", "Obrien", "Castro", "Sutton", "Gregory", "McKinney", "Lucas", "Miles", "Craig", "Rodriquez", "Chambers", "Holt", "Lambert", "Fletcher", "Watts", "Bates", "Hale", "Rhodes", "Pena", "Beck", "Newman", "Haynes", "McDaniel", "Mendez", "Bush", "Vaughn", "Parks", "Dawson", "Santiago", "Norris", "Hardy", "Love", "Steele", "Curry", "Powers", "Schultz", "Barker", "Guzman", "Page", "Munoz", "Ball", "Keller", "Chandler", "Weber", "Leonard", "Walsh", "Lyons", "Ramsey", "Wolfe", "Schneider", "Mullins", "Benson", "Sharp", "Bowen", "Daniel", "Barber", "Cummings", "Hines", "Baldwin", "Griffith", "Valdez", "Hubbard", "Salazar", "Reeves", "Warner", "Stevenson", "Burgess", "Santos", "Tate", "Cross", "Garner", "Mann", "Mack", "Moss", "Thornton", "Dennis", "McGee", "Farmer", "Delgado", "Aguilar", "Vega", "Glover", "Manning", "Cohen", "Harmon", "Rodgers", "Robbins", "Newton", "Todd", "Blair", "Higgins", "Ingram", "Reese", "Cannon", "Strickland", "Townsend", "Potter", "Goodwin", "Walton", "Rowe", "Hampton", "Ortega", "Patton", "Swanson", "Joseph", "Francis", "Goodman", "Maldonado", "Yates", "Becker", "Erickson", "Hodges", "Rios", "Conner", "Adkins", "Webster", "Norman", "Malone", "Hammond", "Flowers", "Cobb", "Moody", "Quinn", "Blake", "Maxwell", "Pope", "Floyd", "Osborne", "Paul", "McCarthy", "Guerrero", "Lindsey", "Estrada", "Sandoval", "Gibbs", "Tyler", "Gross", "Fitzgerald", "Stokes", "Doyle", "Sherman", "Saunders", "Wise", "Colon", "Gill", "Alvarado", "Greer", "Padilla", "Simon", "Waters", "Nunez", "Ballard", "Schwartz", "McBride", "Houston", "Christensen", "Klein", "Pratt", "Briggs", "Parsons", "McLaughlin", "Zimmerman", "French", "Buchanan", "Moran", "Copeland", "Roy", "Pittman", "Brady", "McCormick", "Holloway", "Brock", "Poole", "Frank", "Logan", "Owen", "Bass", "Marsh", "Drake", "Wong", "Jefferson", "Park", "Morton", "Abbott", "Sparks", "Patrick", "Norton", "Huff", "Clayton", "Massey", "Lloyd", "Figueroa", "Carson", "Bowers", "Roberson", "Barton", "Tran", "Lamb", "Harrington", "Casey", "Boone", "Cortez", "Clarke", "Mathis", "Singleton", "Wilkins", "Cain", "Bryan", "Underwood", "Hogan", "McKenzie", "Collier", "Luna", "Phelps", "McGuire", "Allison", "Bridges", "Wilkerson", "Nash", "Summers", "Atkins"],
          // Data taken from http://www.dati.gov.it/dataset/comune-di-firenze_0164 (first 1000)
          it: ["Acciai", "Aglietti", "Agostini", "Agresti", "Ahmed", "Aiazzi", "Albanese", "Alberti", "Alessi", "Alfani", "Alinari", "Alterini", "Amato", "Ammannati", "Ancillotti", "Andrei", "Andreini", "Andreoni", "Angeli", "Anichini", "Antonelli", "Antonini", "Arena", "Ariani", "Arnetoli", "Arrighi", "Baccani", "Baccetti", "Bacci", "Bacherini", "Badii", "Baggiani", "Baglioni", "Bagni", "Bagnoli", "Baldassini", "Baldi", "Baldini", "Ballerini", "Balli", "Ballini", "Balloni", "Bambi", "Banchi", "Bandinelli", "Bandini", "Bani", "Barbetti", "Barbieri", "Barchielli", "Bardazzi", "Bardelli", "Bardi", "Barducci", "Bargellini", "Bargiacchi", "Barni", "Baroncelli", "Baroncini", "Barone", "Baroni", "Baronti", "Bartalesi", "Bartoletti", "Bartoli", "Bartolini", "Bartoloni", "Bartolozzi", "Basagni", "Basile", "Bassi", "Batacchi", "Battaglia", "Battaglini", "Bausi", "Becagli", "Becattini", "Becchi", "Becucci", "Bellandi", "Bellesi", "Belli", "Bellini", "Bellucci", "Bencini", "Benedetti", "Benelli", "Beni", "Benini", "Bensi", "Benucci", "Benvenuti", "Berlincioni", "Bernacchioni", "Bernardi", "Bernardini", "Berni", "Bernini", "Bertelli", "Berti", "Bertini", "Bessi", "Betti", "Bettini", "Biagi", "Biagini", "Biagioni", "Biagiotti", "Biancalani", "Bianchi", "Bianchini", "Bianco", "Biffoli", "Bigazzi", "Bigi", "Biliotti", "Billi", "Binazzi", "Bindi", "Bini", "Biondi", "Bizzarri", "Bocci", "Bogani", "Bolognesi", "Bonaiuti", "Bonanni", "Bonciani", "Boncinelli", "Bondi", "Bonechi", "Bongini", "Boni", "Bonini", "Borchi", "Boretti", "Borghi", "Borghini", "Borgioli", "Borri", "Borselli", "Boschi", "Bottai", "Bracci", "Braccini", "Brandi", "Braschi", "Bravi", "Brazzini", "Breschi", "Brilli", "Brizzi", "Brogelli", "Brogi", "Brogioni", "Brunelli", "Brunetti", "Bruni", "Bruno", "Brunori", "Bruschi", "Bucci", "Bucciarelli", "Buccioni", "Bucelli", "Bulli", "Burberi", "Burchi", "Burgassi", "Burroni", "Bussotti", "Buti", "Caciolli", "Caiani", "Calabrese", "Calamai", "Calamandrei", "Caldini", "Calo'", "Calonaci", "Calosi", "Calvelli", "Cambi", "Camiciottoli", "Cammelli", "Cammilli", "Campolmi", "Cantini", "Capanni", "Capecchi", "Caponi", "Cappelletti", "Cappelli", "Cappellini", "Cappugi", "Capretti", "Caputo", "Carbone", "Carboni", "Cardini", "Carlesi", "Carletti", "Carli", "Caroti", "Carotti", "Carrai", "Carraresi", "Carta", "Caruso", "Casalini", "Casati", "Caselli", "Casini", "Castagnoli", "Castellani", "Castelli", "Castellucci", "Catalano", "Catarzi", "Catelani", "Cavaciocchi", "Cavallaro", "Cavallini", "Cavicchi", "Cavini", "Ceccarelli", "Ceccatelli", "Ceccherelli", "Ceccherini", "Cecchi", "Cecchini", "Cecconi", "Cei", "Cellai", "Celli", "Cellini", "Cencetti", "Ceni", "Cenni", "Cerbai", "Cesari", "Ceseri", "Checcacci", "Checchi", "Checcucci", "Cheli", "Chellini", "Chen", "Cheng", "Cherici", "Cherubini", "Chiaramonti", "Chiarantini", "Chiarelli", "Chiari", "Chiarini", "Chiarugi", "Chiavacci", "Chiesi", "Chimenti", "Chini", "Chirici", "Chiti", "Ciabatti", "Ciampi", "Cianchi", "Cianfanelli", "Cianferoni", "Ciani", "Ciapetti", "Ciappi", "Ciardi", "Ciatti", "Cicali", "Ciccone", "Cinelli", "Cini", "Ciobanu", "Ciolli", "Cioni", "Cipriani", "Cirillo", "Cirri", "Ciucchi", "Ciuffi", "Ciulli", "Ciullini", "Clemente", "Cocchi", "Cognome", "Coli", "Collini", "Colombo", "Colzi", "Comparini", "Conforti", "Consigli", "Conte", "Conti", "Contini", "Coppini", "Coppola", "Corsi", "Corsini", "Corti", "Cortini", "Cosi", "Costa", "Costantini", "Costantino", "Cozzi", "Cresci", "Crescioli", "Cresti", "Crini", "Curradi", "D'Agostino", "D'Alessandro", "D'Amico", "D'Angelo", "Daddi", "Dainelli", "Dallai", "Danti", "Davitti", "De Angelis", "De Luca", "De Marco", "De Rosa", "De Santis", "De Simone", "De Vita", "Degl'Innocenti", "Degli Innocenti", "Dei", "Del Lungo", "Del Re", "Di Marco", "Di Stefano", "Dini", "Diop", "Dobre", "Dolfi", "Donati", "Dondoli", "Dong", "Donnini", "Ducci", "Dumitru", "Ermini", "Esposito", "Evangelisti", "Fabbri", "Fabbrini", "Fabbrizzi", "Fabbroni", "Fabbrucci", "Fabiani", "Facchini", "Faggi", "Fagioli", "Failli", "Faini", "Falciani", "Falcini", "Falcone", "Fallani", "Falorni", "Falsini", "Falugiani", "Fancelli", "Fanelli", "Fanetti", "Fanfani", "Fani", "Fantappie'", "Fantechi", "Fanti", "Fantini", "Fantoni", "Farina", "Fattori", "Favilli", "Fedi", "Fei", "Ferrante", "Ferrara", "Ferrari", "Ferraro", "Ferretti", "Ferri", "Ferrini", "Ferroni", "Fiaschi", "Fibbi", "Fiesoli", "Filippi", "Filippini", "Fini", "Fioravanti", "Fiore", "Fiorentini", "Fiorini", "Fissi", "Focardi", "Foggi", "Fontana", "Fontanelli", "Fontani", "Forconi", "Formigli", "Forte", "Forti", "Fortini", "Fossati", "Fossi", "Francalanci", "Franceschi", "Franceschini", "Franchi", "Franchini", "Franci", "Francini", "Francioni", "Franco", "Frassineti", "Frati", "Fratini", "Frilli", "Frizzi", "Frosali", "Frosini", "Frullini", "Fusco", "Fusi", "Gabbrielli", "Gabellini", "Gagliardi", "Galanti", "Galardi", "Galeotti", "Galletti", "Galli", "Gallo", "Gallori", "Gambacciani", "Gargani", "Garofalo", "Garuglieri", "Gashi", "Gasperini", "Gatti", "Gelli", "Gensini", "Gentile", "Gentili", "Geri", "Gerini", "Gheri", "Ghini", "Giachetti", "Giachi", "Giacomelli", "Gianassi", "Giani", "Giannelli", "Giannetti", "Gianni", "Giannini", "Giannoni", "Giannotti", "Giannozzi", "Gigli", "Giordano", "Giorgetti", "Giorgi", "Giovacchini", "Giovannelli", "Giovannetti", "Giovannini", "Giovannoni", "Giuliani", "Giunti", "Giuntini", "Giusti", "Gonnelli", "Goretti", "Gori", "Gradi", "Gramigni", "Grassi", "Grasso", "Graziani", "Grazzini", "Greco", "Grifoni", "Grillo", "Grimaldi", "Grossi", "Gualtieri", "Guarducci", "Guarino", "Guarnieri", "Guasti", "Guerra", "Guerri", "Guerrini", "Guidi", "Guidotti", "He", "Hoxha", "Hu", "Huang", "Iandelli", "Ignesti", "Innocenti", "Jin", "La Rosa", "Lai", "Landi", "Landini", "Lanini", "Lapi", "Lapini", "Lari", "Lascialfari", "Lastrucci", "Latini", "Lazzeri", "Lazzerini", "Lelli", "Lenzi", "Leonardi", "Leoncini", "Leone", "Leoni", "Lepri", "Li", "Liao", "Lin", "Linari", "Lippi", "Lisi", "Livi", "Lombardi", "Lombardini", "Lombardo", "Longo", "Lopez", "Lorenzi", "Lorenzini", "Lorini", "Lotti", "Lu", "Lucchesi", "Lucherini", "Lunghi", "Lupi", "Madiai", "Maestrini", "Maffei", "Maggi", "Maggini", "Magherini", "Magini", "Magnani", "Magnelli", "Magni", "Magnolfi", "Magrini", "Malavolti", "Malevolti", "Manca", "Mancini", "Manetti", "Manfredi", "Mangani", "Mannelli", "Manni", "Mannini", "Mannucci", "Manuelli", "Manzini", "Marcelli", "Marchese", "Marchetti", "Marchi", "Marchiani", "Marchionni", "Marconi", "Marcucci", "Margheri", "Mari", "Mariani", "Marilli", "Marinai", "Marinari", "Marinelli", "Marini", "Marino", "Mariotti", "Marsili", "Martelli", "Martinelli", "Martini", "Martino", "Marzi", "Masi", "Masini", "Masoni", "Massai", "Materassi", "Mattei", "Matteini", "Matteucci", "Matteuzzi", "Mattioli", "Mattolini", "Matucci", "Mauro", "Mazzanti", "Mazzei", "Mazzetti", "Mazzi", "Mazzini", "Mazzocchi", "Mazzoli", "Mazzoni", "Mazzuoli", "Meacci", "Mecocci", "Meini", "Melani", "Mele", "Meli", "Mengoni", "Menichetti", "Meoni", "Merlini", "Messeri", "Messina", "Meucci", "Miccinesi", "Miceli", "Micheli", "Michelini", "Michelozzi", "Migliori", "Migliorini", "Milani", "Miniati", "Misuri", "Monaco", "Montagnani", "Montagni", "Montanari", "Montelatici", "Monti", "Montigiani", "Montini", "Morandi", "Morandini", "Morelli", "Moretti", "Morganti", "Mori", "Morini", "Moroni", "Morozzi", "Mugnai", "Mugnaini", "Mustafa", "Naldi", "Naldini", "Nannelli", "Nanni", "Nannini", "Nannucci", "Nardi", "Nardini", "Nardoni", "Natali", "Ndiaye", "Nencetti", "Nencini", "Nencioni", "Neri", "Nesi", "Nesti", "Niccolai", "Niccoli", "Niccolini", "Nigi", "Nistri", "Nocentini", "Noferini", "Novelli", "Nucci", "Nuti", "Nutini", "Oliva", "Olivieri", "Olmi", "Orlandi", "Orlandini", "Orlando", "Orsini", "Ortolani", "Ottanelli", "Pacciani", "Pace", "Paci", "Pacini", "Pagani", "Pagano", "Paggetti", "Pagliai", "Pagni", "Pagnini", "Paladini", "Palagi", "Palchetti", "Palloni", "Palmieri", "Palumbo", "Pampaloni", "Pancani", "Pandolfi", "Pandolfini", "Panerai", "Panichi", "Paoletti", "Paoli", "Paolini", "Papi", "Papini", "Papucci", "Parenti", "Parigi", "Parisi", "Parri", "Parrini", "Pasquini", "Passeri", "Pecchioli", "Pecorini", "Pellegrini", "Pepi", "Perini", "Perrone", "Peruzzi", "Pesci", "Pestelli", "Petri", "Petrini", "Petrucci", "Pettini", "Pezzati", "Pezzatini", "Piani", "Piazza", "Piazzesi", "Piazzini", "Piccardi", "Picchi", "Piccini", "Piccioli", "Pieraccini", "Pieraccioni", "Pieralli", "Pierattini", "Pieri", "Pierini", "Pieroni", "Pietrini", "Pini", "Pinna", "Pinto", "Pinzani", "Pinzauti", "Piras", "Pisani", "Pistolesi", "Poggesi", "Poggi", "Poggiali", "Poggiolini", "Poli", "Pollastri", "Porciani", "Pozzi", "Pratellesi", "Pratesi", "Prosperi", "Pruneti", "Pucci", "Puccini", "Puccioni", "Pugi", "Pugliese", "Puliti", "Querci", "Quercioli", "Raddi", "Radu", "Raffaelli", "Ragazzini", "Ranfagni", "Ranieri", "Rastrelli", "Raugei", "Raveggi", "Renai", "Renzi", "Rettori", "Ricci", "Ricciardi", "Ridi", "Ridolfi", "Rigacci", "Righi", "Righini", "Rinaldi", "Risaliti", "Ristori", "Rizzo", "Rocchi", "Rocchini", "Rogai", "Romagnoli", "Romanelli", "Romani", "Romano", "Romei", "Romeo", "Romiti", "Romoli", "Romolini", "Rontini", "Rosati", "Roselli", "Rosi", "Rossetti", "Rossi", "Rossini", "Rovai", "Ruggeri", "Ruggiero", "Russo", "Sabatini", "Saccardi", "Sacchetti", "Sacchi", "Sacco", "Salerno", "Salimbeni", "Salucci", "Salvadori", "Salvestrini", "Salvi", "Salvini", "Sanesi", "Sani", "Sanna", "Santi", "Santini", "Santoni", "Santoro", "Santucci", "Sardi", "Sarri", "Sarti", "Sassi", "Sbolci", "Scali", "Scarpelli", "Scarselli", "Scopetani", "Secci", "Selvi", "Senatori", "Senesi", "Serafini", "Sereni", "Serra", "Sestini", "Sguanci", "Sieni", "Signorini", "Silvestri", "Simoncini", "Simonetti", "Simoni", "Singh", "Sodi", "Soldi", "Somigli", "Sorbi", "Sorelli", "Sorrentino", "Sottili", "Spina", "Spinelli", "Staccioli", "Staderini", "Stefanelli", "Stefani", "Stefanini", "Stella", "Susini", "Tacchi", "Tacconi", "Taddei", "Tagliaferri", "Tamburini", "Tanganelli", "Tani", "Tanini", "Tapinassi", "Tarchi", "Tarchiani", "Targioni", "Tassi", "Tassini", "Tempesti", "Terzani", "Tesi", "Testa", "Testi", "Tilli", "Tinti", "Tirinnanzi", "Toccafondi", "Tofanari", "Tofani", "Tognaccini", "Tonelli", "Tonini", "Torelli", "Torrini", "Tosi", "Toti", "Tozzi", "Trambusti", "Trapani", "Tucci", "Turchi", "Ugolini", "Ulivi", "Valente", "Valenti", "Valentini", "Vangelisti", "Vanni", "Vannini", "Vannoni", "Vannozzi", "Vannucchi", "Vannucci", "Ventura", "Venturi", "Venturini", "Vestri", "Vettori", "Vichi", "Viciani", "Vieri", "Vigiani", "Vignoli", "Vignolini", "Vignozzi", "Villani", "Vinci", "Visani", "Vitale", "Vitali", "Viti", "Viviani", "Vivoli", "Volpe", "Volpi", "Wang", "Wu", "Xu", "Yang", "Ye", "Zagli", "Zani", "Zanieri", "Zanobini", "Zecchi", "Zetti", "Zhang", "Zheng", "Zhou", "Zhu", "Zingoni", "Zini", "Zoppi"],
          // http://www.voornamelijk.nl/meest-voorkomende-achternamen-in-nederland-en-amsterdam/
          nl: ["Albers", "Alblas", "Appelman", "Baars", "Baas", "Bakker", "Blank", "Bleeker", "Blok", "Blom", "Boer", "Boers", "Boldewijn", "Boon", "Boot", "Bos", "Bosch", "Bosma", "Bosman", "Bouma", "Bouman", "Bouwman", "Brands", "Brouwer", "Burger", "Buijs", "Buitenhuis", "Ceder", "Cohen", "Dekker", "Dekkers", "Dijkman", "Dijkstra", "Driessen", "Drost", "Engel", "Evers", "Faber", "Franke", "Gerritsen", "Goedhart", "Goossens", "Groen", "Groenenberg", "Groot", "Haan", "Hart", "Heemskerk", "Hendriks", "Hermans", "Hoekstra", "Hofman", "Hopman", "Huisman", "Jacobs", "Jansen", "Janssen", "Jonker", "Jaspers", "Keijzer", "Klaassen", "Klein", "Koek", "Koenders", "Kok", "Kool", "Koopman", "Koopmans", "Koning", "Koster", "Kramer", "Kroon", "Kuijpers", "Kuiper", "Kuipers", "Kurt", "Koster", "Kwakman", "Los", "Lubbers", "Maas", "Markus", "Martens", "Meijer", "Mol", "Molenaar", "Mulder", "Nieuwenhuis", "Peeters", "Peters", "Pengel", "Pieters", "Pool", "Post", "Postma", "Prins", "Pronk", "Reijnders", "Rietveld", "Roest", "Roos", "Sanders", "Schaap", "Scheffer", "Schenk", "Schilder", "Schipper", "Schmidt", "Scholten", "Schouten", "Schut", "Schutte", "Schuurman", "Simons", "Smeets", "Smit", "Smits", "Snel", "Swinkels", "Tas", "Terpstra", "Timmermans", "Tol", "Tromp", "Troost", "Valk", "Veenstra", "Veldkamp", "Verbeek", "Verheul", "Verhoeven", "Vermeer", "Vermeulen", "Verweij", "Vink", "Visser", "Voorn", "Vos", "Wagenaar", "Wiersema", "Willems", "Willemsen", "Witteveen", "Wolff", "Wolters", "Zijlstra", "Zwart", "de Beer", "de Boer", "de Bruijn", "de Bruin", "de Graaf", "de Groot", "de Haan", "de Haas", "de Jager", "de Jong", "de Jonge", "de Koning", "de Lange", "de Leeuw", "de Ridder", "de Rooij", "de Ruiter", "de Vos", "de Vries", "de Waal", "de Wit", "de Zwart", "van Beek", "van Boven", "van Dam", "van Dijk", "van Dongen", "van Doorn", "van Egmond", "van Eijk", "van Es", "van Gelder", "van Gelderen", "van Houten", "van Hulst", "van Kempen", "van Kesteren", "van Leeuwen", "van Loon", "van Mill", "van Noord", "van Ommen", "van Ommeren", "van Oosten", "van Oostveen", "van Rijn", "van Schaik", "van Veen", "van Vliet", "van Wijk", "van Wijngaarden", "van den Poel", "van de Pol", "van den Ploeg", "van de Ven", "van den Berg", "van den Bosch", "van den Brink", "van den Broek", "van den Heuvel", "van der Heijden", "van der Horst", "van der Hulst", "van der Kroon", "van der Laan", "van der Linden", "van der Meer", "van der Meij", "van der Meulen", "van der Molen", "van der Sluis", "van der Spek", "van der Veen", "van der Velde", "van der Velden", "van der Vliet", "van der Wal"],
          // https://surnames.behindthename.com/top/lists/england-wales/1991
          uk: ["Smith", "Jones", "Williams", "Taylor", "Brown", "Davies", "Evans", "Wilson", "Thomas", "Johnson", "Roberts", "Robinson", "Thompson", "Wright", "Walker", "White", "Edwards", "Hughes", "Green", "Hall", "Lewis", "Harris", "Clarke", "Patel", "Jackson", "Wood", "Turner", "Martin", "Cooper", "Hill", "Ward", "Morris", "Moore", "Clark", "Lee", "King", "Baker", "Harrison", "Morgan", "Allen", "James", "Scott", "Phillips", "Watson", "Davis", "Parker", "Price", "Bennett", "Young", "Griffiths", "Mitchell", "Kelly", "Cook", "Carter", "Richardson", "Bailey", "Collins", "Bell", "Shaw", "Murphy", "Miller", "Cox", "Richards", "Khan", "Marshall", "Anderson", "Simpson", "Ellis", "Adams", "Singh", "Begum", "Wilkinson", "Foster", "Chapman", "Powell", "Webb", "Rogers", "Gray", "Mason", "Ali", "Hunt", "Hussain", "Campbell", "Matthews", "Owen", "Palmer", "Holmes", "Mills", "Barnes", "Knight", "Lloyd", "Butler", "Russell", "Barker", "Fisher", "Stevens", "Jenkins", "Murray", "Dixon", "Harvey", "Graham", "Pearson", "Ahmed", "Fletcher", "Walsh", "Kaur", "Gibson", "Howard", "Andrews", "Stewart", "Elliott", "Reynolds", "Saunders", "Payne", "Fox", "Ford", "Pearce", "Day", "Brooks", "West", "Lawrence", "Cole", "Atkinson", "Bradley", "Spencer", "Gill", "Dawson", "Ball", "Burton", "O'brien", "Watts", "Rose", "Booth", "Perry", "Ryan", "Grant", "Wells", "Armstrong", "Francis", "Rees", "Hayes", "Hart", "Hudson", "Newman", "Barrett", "Webster", "Hunter", "Gregory", "Carr", "Lowe", "Page", "Marsh", "Riley", "Dunn", "Woods", "Parsons", "Berry", "Stone", "Reid", "Holland", "Hawkins", "Harding", "Porter", "Robertson", "Newton", "Oliver", "Reed", "Kennedy", "Williamson", "Bird", "Gardner", "Shah", "Dean", "Lane", "Cooke", "Bates", "Henderson", "Parry", "Burgess", "Bishop", "Walton", "Burns", "Nicholson", "Shepherd", "Ross", "Cross", "Long", "Freeman", "Warren", "Nicholls", "Hamilton", "Byrne", "Sutton", "Mcdonald", "Yates", "Hodgson", "Robson", "Curtis", "Hopkins", "O'connor", "Harper", "Coleman", "Watkins", "Moss", "Mccarthy", "Chambers", "O'neill", "Griffin", "Sharp", "Hardy", "Wheeler", "Potter", "Osborne", "Johnston", "Gordon", "Doyle", "Wallace", "George", "Jordan", "Hutchinson", "Rowe", "Burke", "May", "Pritchard", "Gilbert", "Willis", "Higgins", "Read", "Miles", "Stevenson", "Stephenson", "Hammond", "Arnold", "Buckley", "Walters", "Hewitt", "Barber", "Nelson", "Slater", "Austin", "Sullivan", "Whitehead", "Mann", "Frost", "Lambert", "Stephens", "Blake", "Akhtar", "Lynch", "Goodwin", "Barton", "Woodward", "Thomson", "Cunningham", "Quinn", "Barnett", "Baxter", "Bibi", "Clayton", "Nash", "Greenwood", "Jennings", "Holt", "Kemp", "Poole", "Gallagher", "Bond", "Stokes", "Tucker", "Davidson", "Fowler", "Heath", "Norman", "Middleton", "Lawson", "Banks", "French", "Stanley", "Jarvis", "Gibbs", "Ferguson", "Hayward", "Carroll", "Douglas", "Dickinson", "Todd", "Barlow", "Peters", "Lucas", "Knowles", "Hartley", "Miah", "Simmons", "Morton", "Alexander", "Field", "Morrison", "Norris", "Townsend", "Preston", "Hancock", "Thornton", "Baldwin", "Burrows", "Briggs", "Parkinson", "Reeves", "Macdonald", "Lamb", "Black", "Abbott", "Sanders", "Thorpe", "Holden", "Tomlinson", "Perkins", "Ashton", "Rhodes", "Fuller", "Howe", "Bryant", "Vaughan", "Dale", "Davey", "Weston", "Bartlett", "Whittaker", "Davison", "Kent", "Skinner", "Birch", "Morley", "Daniels", "Glover", "Howell", "Cartwright", "Pugh", "Humphreys", "Goddard", "Brennan", "Wall", "Kirby", "Bowen", "Savage", "Bull", "Wong", "Dobson", "Smart", "Wilkins", "Kirk", "Fraser", "Duffy", "Hicks", "Patterson", "Bradshaw", "Little", "Archer", "Warner", "Waters", "O'sullivan", "Farrell", "Brookes", "Atkins", "Kay", "Dodd", "Bentley", "Flynn", "John", "Schofield", "Short", "Haynes", "Wade", "Butcher", "Henry", "Sanderson", "Crawford", "Sheppard", "Bolton", "Coates", "Giles", "Gould", "Houghton", "Gibbons", "Pratt", "Manning", "Law", "Hooper", "Noble", "Dyer", "Rahman", "Clements", "Moran", "Sykes", "Chan", "Doherty", "Connolly", "Joyce", "Franklin", "Hobbs", "Coles", "Herbert", "Steele", "Kerr", "Leach", "Winter", "Owens", "Duncan", "Naylor", "Fleming", "Horton", "Finch", "Fitzgerald", "Randall", "Carpenter", "Marsden", "Browne", "Garner", "Pickering", "Hale", "Dennis", "Vincent", "Chadwick", "Chandler", "Sharpe", "Nolan", "Lyons", "Hurst", "Collier", "Peacock", "Howarth", "Faulkner", "Rice", "Pollard", "Welch", "Norton", "Gough", "Sinclair", "Blackburn", "Bryan", "Conway", "Power", "Cameron", "Daly", "Allan", "Hanson", "Gardiner", "Boyle", "Myers", "Turnbull", "Wallis", "Mahmood", "Sims", "Swift", "Iqbal", "Pope", "Brady", "Chamberlain", "Rowley", "Tyler", "Farmer", "Metcalfe", "Hilton", "Godfrey", "Holloway", "Parkin", "Bray", "Talbot", "Donnelly", "Nixon", "Charlton", "Benson", "Whitehouse", "Barry", "Hope", "Lord", "North", "Storey", "Connor", "Potts", "Bevan", "Hargreaves", "Mclean", "Mistry", "Bruce", "Howells", "Hyde", "Parkes", "Wyatt", "Fry", "Lees", "O'donnell", "Craig", "Forster", "Mckenzie", "Humphries", "Mellor", "Carey", "Ingram", "Summers", "Leonard"],
          // https://surnames.behindthename.com/top/lists/germany/2017
          de: ["Müller", "Schmidt", "Schneider", "Fischer", "Weber", "Meyer", "Wagner", "Becker", "Schulz", "Hoffmann", "Schäfer", "Koch", "Bauer", "Richter", "Klein", "Wolf", "Schröder", "Neumann", "Schwarz", "Zimmermann", "Braun", "Krüger", "Hofmann", "Hartmann", "Lange", "Schmitt", "Werner", "Schmitz", "Krause", "Meier", "Lehmann", "Schmid", "Schulze", "Maier", "Köhler", "Herrmann", "König", "Walter", "Mayer", "Huber", "Kaiser", "Fuchs", "Peters", "Lang", "Scholz", "Möller", "Weiß", "Jung", "Hahn", "Schubert", "Vogel", "Friedrich", "Keller", "Günther", "Frank", "Berger", "Winkler", "Roth", "Beck", "Lorenz", "Baumann", "Franke", "Albrecht", "Schuster", "Simon", "Ludwig", "Böhm", "Winter", "Kraus", "Martin", "Schumacher", "Krämer", "Vogt", "Stein", "Jäger", "Otto", "Sommer", "Groß", "Seidel", "Heinrich", "Brandt", "Haas", "Schreiber", "Graf", "Schulte", "Dietrich", "Ziegler", "Kuhn", "Kühn", "Pohl", "Engel", "Horn", "Busch", "Bergmann", "Thomas", "Voigt", "Sauer", "Arnold", "Wolff", "Pfeiffer"],
          // http://www.japantimes.co.jp/life/2009/10/11/lifestyle/japans-top-100-most-common-family-names/
          jp: ["Sato", "Suzuki", "Takahashi", "Tanaka", "Watanabe", "Ito", "Yamamoto", "Nakamura", "Kobayashi", "Kato", "Yoshida", "Yamada", "Sasaki", "Yamaguchi", "Saito", "Matsumoto", "Inoue", "Kimura", "Hayashi", "Shimizu", "Yamazaki", "Mori", "Abe", "Ikeda", "Hashimoto", "Yamashita", "Ishikawa", "Nakajima", "Maeda", "Fujita", "Ogawa", "Goto", "Okada", "Hasegawa", "Murakami", "Kondo", "Ishii", "Saito", "Sakamoto", "Endo", "Aoki", "Fujii", "Nishimura", "Fukuda", "Ota", "Miura", "Fujiwara", "Okamoto", "Matsuda", "Nakagawa", "Nakano", "Harada", "Ono", "Tamura", "Takeuchi", "Kaneko", "Wada", "Nakayama", "Ishida", "Ueda", "Morita", "Hara", "Shibata", "Sakai", "Kudo", "Yokoyama", "Miyazaki", "Miyamoto", "Uchida", "Takagi", "Ando", "Taniguchi", "Ohno", "Maruyama", "Imai", "Takada", "Fujimoto", "Takeda", "Murata", "Ueno", "Sugiyama", "Masuda", "Sugawara", "Hirano", "Kojima", "Otsuka", "Chiba", "Kubo", "Matsui", "Iwasaki", "Sakurai", "Kinoshita", "Noguchi", "Matsuo", "Nomura", "Kikuchi", "Sano", "Onishi", "Sugimoto", "Arai"],
          // http://www.lowchensaustralia.com/names/popular-spanish-names.htm
          es: ["Garcia", "Fernandez", "Lopez", "Martinez", "Gonzalez", "Rodriguez", "Sanchez", "Perez", "Martin", "Gomez", "Ruiz", "Diaz", "Hernandez", "Alvarez", "Jimenez", "Moreno", "Munoz", "Alonso", "Romero", "Navarro", "Gutierrez", "Torres", "Dominguez", "Gil", "Vazquez", "Blanco", "Serrano", "Ramos", "Castro", "Suarez", "Sanz", "Rubio", "Ortega", "Molina", "Delgado", "Ortiz", "Morales", "Ramirez", "Marin", "Iglesias", "Santos", "Castillo", "Garrido", "Calvo", "Pena", "Cruz", "Cano", "Nunez", "Prieto", "Diez", "Lozano", "Vidal", "Pascual", "Ferrer", "Medina", "Vega", "Leon", "Herrero", "Vicente", "Mendez", "Guerrero", "Fuentes", "Campos", "Nieto", "Cortes", "Caballero", "Ibanez", "Lorenzo", "Pastor", "Gimenez", "Saez", "Soler", "Marquez", "Carrasco", "Herrera", "Montero", "Arias", "Crespo", "Flores", "Andres", "Aguilar", "Hidalgo", "Cabrera", "Mora", "Duran", "Velasco", "Rey", "Pardo", "Roman", "Vila", "Bravo", "Merino", "Moya", "Soto", "Izquierdo", "Reyes", "Redondo", "Marcos", "Carmona", "Menendez"],
          // Data taken from https://fr.wikipedia.org/wiki/Liste_des_noms_de_famille_les_plus_courants_en_France
          fr: ["Martin", "Bernard", "Thomas", "Petit", "Robert", "Richard", "Durand", "Dubois", "Moreau", "Laurent", "Simon", "Michel", "Lefèvre", "Leroy", "Roux", "David", "Bertrand", "Morel", "Fournier", "Girard", "Bonnet", "Dupont", "Lambert", "Fontaine", "Rousseau", "Vincent", "Müller", "Lefèvre", "Faure", "André", "Mercier", "Blanc", "Guérin", "Boyer", "Garnier", "Chevalier", "François", "Legrand", "Gauthier", "Garcia", "Perrin", "Robin", "Clément", "Morin", "Nicolas", "Henry", "Roussel", "Matthieu", "Gautier", "Masson", "Marchand", "Duval", "Denis", "Dumont", "Marie", "Lemaire", "Noël", "Meyer", "Dufour", "Meunier", "Brun", "Blanchard", "Giraud", "Joly", "Rivière", "Lucas", "Brunet", "Gaillard", "Barbier", "Arnaud", "Martínez", "Gérard", "Roche", "Renard", "Schmitt", "Roy", "Leroux", "Colin", "Vidal", "Caron", "Picard", "Roger", "Fabre", "Aubert", "Lemoine", "Renaud", "Dumas", "Lacroix", "Olivier", "Philippe", "Bourgeois", "Pierre", "Benoît", "Rey", "Leclerc", "Payet", "Rolland", "Leclercq", "Guillaume", "Lecomte", "López", "Jean", "Dupuy", "Guillot", "Hubert", "Berger", "Carpentier", "Sánchez", "Dupuis", "Moulin", "Louis", "Deschamps", "Huet", "Vasseur", "Perez", "Boucher", "Fleury", "Royer", "Klein", "Jacquet", "Adam", "Paris", "Poirier", "Marty", "Aubry", "Guyot", "Carré", "Charles", "Renault", "Charpentier", "Ménard", "Maillard", "Baron", "Bertin", "Bailly", "Hervé", "Schneider", "Fernández", "Le GallGall", "Collet", "Léger", "Bouvier", "Julien", "Prévost", "Millet", "Perrot", "Daniel", "Le RouxRoux", "Cousin", "Germain", "Breton", "Besson", "Langlois", "Rémi", "Le GoffGoff", "Pelletier", "Lévêque", "Perrier", "Leblanc", "Barré", "Lebrun", "Marchal", "Weber", "Mallet", "Hamon", "Boulanger", "Jacob", "Monnier", "Michaud", "Rodríguez", "Guichard", "Gillet", "Étienne", "Grondin", "Poulain", "Tessier", "Chevallier", "Collin", "Chauvin", "Da SilvaSilva", "Bouchet", "Gay", "Lemaître", "Bénard", "Maréchal", "Humbert", "Reynaud", "Antoine", "Hoarau", "Perret", "Barthélemy", "Cordier", "Pichon", "Lejeune", "Gilbert", "Lamy", "Delaunay", "Pasquier", "Carlier", "LaporteLaporte"]
        },
        // Data taken from http://geoportal.statistics.gov.uk/datasets/ons-postcode-directory-latest-centroids
        postcodeAreas: [{ code: "AB" }, { code: "AL" }, { code: "B" }, { code: "BA" }, { code: "BB" }, { code: "BD" }, { code: "BH" }, { code: "BL" }, { code: "BN" }, { code: "BR" }, { code: "BS" }, { code: "BT" }, { code: "CA" }, { code: "CB" }, { code: "CF" }, { code: "CH" }, { code: "CM" }, { code: "CO" }, { code: "CR" }, { code: "CT" }, { code: "CV" }, { code: "CW" }, { code: "DA" }, { code: "DD" }, { code: "DE" }, { code: "DG" }, { code: "DH" }, { code: "DL" }, { code: "DN" }, { code: "DT" }, { code: "DY" }, { code: "E" }, { code: "EC" }, { code: "EH" }, { code: "EN" }, { code: "EX" }, { code: "FK" }, { code: "FY" }, { code: "G" }, { code: "GL" }, { code: "GU" }, { code: "GY" }, { code: "HA" }, { code: "HD" }, { code: "HG" }, { code: "HP" }, { code: "HR" }, { code: "HS" }, { code: "HU" }, { code: "HX" }, { code: "IG" }, { code: "IM" }, { code: "IP" }, { code: "IV" }, { code: "JE" }, { code: "KA" }, { code: "KT" }, { code: "KW" }, { code: "KY" }, { code: "L" }, { code: "LA" }, { code: "LD" }, { code: "LE" }, { code: "LL" }, { code: "LN" }, { code: "LS" }, { code: "LU" }, { code: "M" }, { code: "ME" }, { code: "MK" }, { code: "ML" }, { code: "N" }, { code: "NE" }, { code: "NG" }, { code: "NN" }, { code: "NP" }, { code: "NR" }, { code: "NW" }, { code: "OL" }, { code: "OX" }, { code: "PA" }, { code: "PE" }, { code: "PH" }, { code: "PL" }, { code: "PO" }, { code: "PR" }, { code: "RG" }, { code: "RH" }, { code: "RM" }, { code: "S" }, { code: "SA" }, { code: "SE" }, { code: "SG" }, { code: "SK" }, { code: "SL" }, { code: "SM" }, { code: "SN" }, { code: "SO" }, { code: "SP" }, { code: "SR" }, { code: "SS" }, { code: "ST" }, { code: "SW" }, { code: "SY" }, { code: "TA" }, { code: "TD" }, { code: "TF" }, { code: "TN" }, { code: "TQ" }, { code: "TR" }, { code: "TS" }, { code: "TW" }, { code: "UB" }, { code: "W" }, { code: "WA" }, { code: "WC" }, { code: "WD" }, { code: "WF" }, { code: "WN" }, { code: "WR" }, { code: "WS" }, { code: "WV" }, { code: "YO" }, { code: "ZE" }],
        // Data taken from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
        countries: [{ name: "Afghanistan", abbreviation: "AF" }, { name: "Åland Islands", abbreviation: "AX" }, { name: "Albania", abbreviation: "AL" }, { name: "Algeria", abbreviation: "DZ" }, { name: "American Samoa", abbreviation: "AS" }, { name: "Andorra", abbreviation: "AD" }, { name: "Angola", abbreviation: "AO" }, { name: "Anguilla", abbreviation: "AI" }, { name: "Antarctica", abbreviation: "AQ" }, { name: "Antigua and Barbuda", abbreviation: "AG" }, { name: "Argentina", abbreviation: "AR" }, { name: "Armenia", abbreviation: "AM" }, { name: "Aruba", abbreviation: "AW" }, { name: "Australia", abbreviation: "AU" }, { name: "Austria", abbreviation: "AT" }, { name: "Azerbaijan", abbreviation: "AZ" }, { name: "Bahamas", abbreviation: "BS" }, { name: "Bahrain", abbreviation: "BH" }, { name: "Bangladesh", abbreviation: "BD" }, { name: "Barbados", abbreviation: "BB" }, { name: "Belarus", abbreviation: "BY" }, { name: "Belgium", abbreviation: "BE" }, { name: "Belize", abbreviation: "BZ" }, { name: "Benin", abbreviation: "BJ" }, { name: "Bermuda", abbreviation: "BM" }, { name: "Bhutan", abbreviation: "BT" }, { name: "Plurinational State of Bolivia", abbreviation: "BO" }, { name: "Bonaire, Sint Eustatius and Saba", abbreviation: "BQ" }, { name: "Bosnia and Herzegovina", abbreviation: "BA" }, { name: "Botswana", abbreviation: "BW" }, { name: "Bouvet Island", abbreviation: "BV" }, { name: "Brazil", abbreviation: "BR" }, { name: "British Indian Ocean Territory", abbreviation: "IO" }, { name: "Brunei Darussalam", abbreviation: "BN" }, { name: "Bulgaria", abbreviation: "BG" }, { name: "Burkina Faso", abbreviation: "BF" }, { name: "Burundi", abbreviation: "BI" }, { name: "Cabo Verde", abbreviation: "CV" }, { name: "Cambodia", abbreviation: "KH" }, { name: "Cameroon", abbreviation: "CM" }, { name: "Canada", abbreviation: "CA" }, { name: "Cayman Islands", abbreviation: "KY" }, { name: "Central African Republic", abbreviation: "CF" }, { name: "Chad", abbreviation: "TD" }, { name: "Chile", abbreviation: "CL" }, { name: "China", abbreviation: "CN" }, { name: "Christmas Island", abbreviation: "CX" }, { name: "Cocos (Keeling) Islands", abbreviation: "CC" }, { name: "Colombia", abbreviation: "CO" }, { name: "Comoros", abbreviation: "KM" }, { name: "Congo", abbreviation: "CG" }, { name: "Democratic Republic of the Congo", abbreviation: "CD" }, { name: "Cook Islands", abbreviation: "CK" }, { name: "Costa Rica", abbreviation: "CR" }, { name: "Côte d'Ivoire", abbreviation: "CI" }, { name: "Croatia", abbreviation: "HR" }, { name: "Cuba", abbreviation: "CU" }, { name: "Curaçao", abbreviation: "CW" }, { name: "Cyprus", abbreviation: "CY" }, { name: "Czechia", abbreviation: "CZ" }, { name: "Denmark", abbreviation: "DK" }, { name: "Djibouti", abbreviation: "DJ" }, { name: "Dominica", abbreviation: "DM" }, { name: "Dominican Republic", abbreviation: "DO" }, { name: "Ecuador", abbreviation: "EC" }, { name: "Egypt", abbreviation: "EG" }, { name: "El Salvador", abbreviation: "SV" }, { name: "Equatorial Guinea", abbreviation: "GQ" }, { name: "Eritrea", abbreviation: "ER" }, { name: "Estonia", abbreviation: "EE" }, { name: "Eswatini", abbreviation: "SZ" }, { name: "Ethiopia", abbreviation: "ET" }, { name: "Falkland Islands (Malvinas)", abbreviation: "FK" }, { name: "Faroe Islands", abbreviation: "FO" }, { name: "Fiji", abbreviation: "FJ" }, { name: "Finland", abbreviation: "FI" }, { name: "France", abbreviation: "FR" }, { name: "French Guiana", abbreviation: "GF" }, { name: "French Polynesia", abbreviation: "PF" }, { name: "French Southern Territories", abbreviation: "TF" }, { name: "Gabon", abbreviation: "GA" }, { name: "Gambia", abbreviation: "GM" }, { name: "Georgia", abbreviation: "GE" }, { name: "Germany", abbreviation: "DE" }, { name: "Ghana", abbreviation: "GH" }, { name: "Gibraltar", abbreviation: "GI" }, { name: "Greece", abbreviation: "GR" }, { name: "Greenland", abbreviation: "GL" }, { name: "Grenada", abbreviation: "GD" }, { name: "Guadeloupe", abbreviation: "GP" }, { name: "Guam", abbreviation: "GU" }, { name: "Guatemala", abbreviation: "GT" }, { name: "Guernsey", abbreviation: "GG" }, { name: "Guinea", abbreviation: "GN" }, { name: "Guinea-Bissau", abbreviation: "GW" }, { name: "Guyana", abbreviation: "GY" }, { name: "Haiti", abbreviation: "HT" }, { name: "Heard Island and McDonald Islands", abbreviation: "HM" }, { name: "Holy See", abbreviation: "VA" }, { name: "Honduras", abbreviation: "HN" }, { name: "Hong Kong", abbreviation: "HK" }, { name: "Hungary", abbreviation: "HU" }, { name: "Iceland", abbreviation: "IS" }, { name: "India", abbreviation: "IN" }, { name: "Indonesia", abbreviation: "ID" }, { name: "Islamic Republic of Iran", abbreviation: "IR" }, { name: "Iraq", abbreviation: "IQ" }, { name: "Ireland", abbreviation: "IE" }, { name: "Isle of Man", abbreviation: "IM" }, { name: "Israel", abbreviation: "IL" }, { name: "Italy", abbreviation: "IT" }, { name: "Jamaica", abbreviation: "JM" }, { name: "Japan", abbreviation: "JP" }, { name: "Jersey", abbreviation: "JE" }, { name: "Jordan", abbreviation: "JO" }, { name: "Kazakhstan", abbreviation: "KZ" }, { name: "Kenya", abbreviation: "KE" }, { name: "Kiribati", abbreviation: "KI" }, { name: "Democratic People's Republic of Korea", abbreviation: "KP" }, { name: "Republic of Korea", abbreviation: "KR" }, { name: "Kuwait", abbreviation: "KW" }, { name: "Kyrgyzstan", abbreviation: "KG" }, { name: "Lao People's Democratic Republic", abbreviation: "LA" }, { name: "Latvia", abbreviation: "LV" }, { name: "Lebanon", abbreviation: "LB" }, { name: "Lesotho", abbreviation: "LS" }, { name: "Liberia", abbreviation: "LR" }, { name: "Libya", abbreviation: "LY" }, { name: "Liechtenstein", abbreviation: "LI" }, { name: "Lithuania", abbreviation: "LT" }, { name: "Luxembourg", abbreviation: "LU" }, { name: "Macao", abbreviation: "MO" }, { name: "Madagascar", abbreviation: "MG" }, { name: "Malawi", abbreviation: "MW" }, { name: "Malaysia", abbreviation: "MY" }, { name: "Maldives", abbreviation: "MV" }, { name: "Mali", abbreviation: "ML" }, { name: "Malta", abbreviation: "MT" }, { name: "Marshall Islands", abbreviation: "MH" }, { name: "Martinique", abbreviation: "MQ" }, { name: "Mauritania", abbreviation: "MR" }, { name: "Mauritius", abbreviation: "MU" }, { name: "Mayotte", abbreviation: "YT" }, { name: "Mexico", abbreviation: "MX" }, { name: "Federated States of Micronesia", abbreviation: "FM" }, { name: "Republic of Moldova", abbreviation: "MD" }, { name: "Monaco", abbreviation: "MC" }, { name: "Mongolia", abbreviation: "MN" }, { name: "Montenegro", abbreviation: "ME" }, { name: "Montserrat", abbreviation: "MS" }, { name: "Morocco", abbreviation: "MA" }, { name: "Mozambique", abbreviation: "MZ" }, { name: "Myanmar", abbreviation: "MM" }, { name: "Namibia", abbreviation: "NA" }, { name: "Nauru", abbreviation: "NR" }, { name: "Nepal", abbreviation: "NP" }, { name: "Kingdom of the Netherlands", abbreviation: "NL" }, { name: "New Caledonia", abbreviation: "NC" }, { name: "New Zealand", abbreviation: "NZ" }, { name: "Nicaragua", abbreviation: "NI" }, { name: "Niger", abbreviation: "NE" }, { name: "Nigeria", abbreviation: "NG" }, { name: "Niue", abbreviation: "NU" }, { name: "Norfolk Island", abbreviation: "NF" }, { name: "North Macedonia", abbreviation: "MK" }, { name: "Northern Mariana Islands", abbreviation: "MP" }, { name: "Norway", abbreviation: "NO" }, { name: "Oman", abbreviation: "OM" }, { name: "Pakistan", abbreviation: "PK" }, { name: "Palau", abbreviation: "PW" }, { name: "State of Palestine", abbreviation: "PS" }, { name: "Panama", abbreviation: "PA" }, { name: "Papua New Guinea", abbreviation: "PG" }, { name: "Paraguay", abbreviation: "PY" }, { name: "Peru", abbreviation: "PE" }, { name: "Philippines", abbreviation: "PH" }, { name: "Pitcairn", abbreviation: "PN" }, { name: "Poland", abbreviation: "PL" }, { name: "Portugal", abbreviation: "PT" }, { name: "Puerto Rico", abbreviation: "PR" }, { name: "Qatar", abbreviation: "QA" }, { name: "Réunion", abbreviation: "RE" }, { name: "Romania", abbreviation: "RO" }, { name: "Russian Federation", abbreviation: "RU" }, { name: "Rwanda", abbreviation: "RW" }, { name: "Saint Barthélemy", abbreviation: "BL" }, { name: "Saint Helena, Ascension and Tristan da Cunha", abbreviation: "SH" }, { name: "Saint Kitts and Nevis", abbreviation: "KN" }, { name: "Saint Lucia", abbreviation: "LC" }, { name: "Saint Martin (French part)", abbreviation: "MF" }, { name: "Saint Pierre and Miquelon", abbreviation: "PM" }, { name: "Saint Vincent and the Grenadines", abbreviation: "VC" }, { name: "Samoa", abbreviation: "WS" }, { name: "San Marino", abbreviation: "SM" }, { name: "Sao Tome and Principe", abbreviation: "ST" }, { name: "Saudi Arabia", abbreviation: "SA" }, { name: "Senegal", abbreviation: "SN" }, { name: "Serbia", abbreviation: "RS" }, { name: "Seychelles", abbreviation: "SC" }, { name: "Sierra Leone", abbreviation: "SL" }, { name: "Singapore", abbreviation: "SG" }, { name: "Sint Maarten (Dutch part)", abbreviation: "SX" }, { name: "Slovakia", abbreviation: "SK" }, { name: "Slovenia", abbreviation: "SI" }, { name: "Solomon Islands", abbreviation: "SB" }, { name: "Somalia", abbreviation: "SO" }, { name: "South Africa", abbreviation: "ZA" }, { name: "South Georgia and the South Sandwich Islands", abbreviation: "GS" }, { name: "South Sudan", abbreviation: "SS" }, { name: "Spain", abbreviation: "ES" }, { name: "Sri Lanka", abbreviation: "LK" }, { name: "Sudan", abbreviation: "SD" }, { name: "Suriname", abbreviation: "SR" }, { name: "Svalbard and Jan Mayen", abbreviation: "SJ" }, { name: "Sweden", abbreviation: "SE" }, { name: "Switzerland", abbreviation: "CH" }, { name: "Syrian Arab Republic", abbreviation: "SY" }, { name: "Taiwan, Province of China", abbreviation: "TW" }, { name: "Tajikistan", abbreviation: "TJ" }, { name: "United Republic of Tanzania", abbreviation: "TZ" }, { name: "Thailand", abbreviation: "TH" }, { name: "Timor-Leste", abbreviation: "TL" }, { name: "Togo", abbreviation: "TG" }, { name: "Tokelau", abbreviation: "TK" }, { name: "Tonga", abbreviation: "TO" }, { name: "Trinidad and Tobago", abbreviation: "TT" }, { name: "Tunisia", abbreviation: "TN" }, { name: "Türkiye", abbreviation: "TR" }, { name: "Turkmenistan", abbreviation: "TM" }, { name: "Turks and Caicos Islands", abbreviation: "TC" }, { name: "Tuvalu", abbreviation: "TV" }, { name: "Uganda", abbreviation: "UG" }, { name: "Ukraine", abbreviation: "UA" }, { name: "United Arab Emirates", abbreviation: "AE" }, { name: "United Kingdom of Great Britain and Northern Ireland", abbreviation: "GB" }, { name: "United States Minor Outlying Islands", abbreviation: "UM" }, { name: "United States of America", abbreviation: "US" }, { name: "Uruguay", abbreviation: "UY" }, { name: "Uzbekistan", abbreviation: "UZ" }, { name: "Vanuatu", abbreviation: "VU" }, { name: "Bolivarian Republic of Venezuela", abbreviation: "VE" }, { name: "Viet Nam", abbreviation: "VN" }, { name: "Virgin Islands (British)", abbreviation: "VG" }, { name: "Virgin Islands (U.S.)", abbreviation: "VI" }, { name: "Wallis and Futuna", abbreviation: "WF" }, { name: "Western Sahara", abbreviation: "EH" }, { name: "Yemen", abbreviation: "YE" }, { name: "Zambia", abbreviation: "ZM" }, { name: "Zimbabwe", abbreviation: "ZW" }],
        counties: {
          // Data taken from http://www.downloadexcelfiles.com/gb_en/download-excel-file-list-counties-uk
          uk: [
            { name: "Bath and North East Somerset" },
            { name: "Aberdeenshire" },
            { name: "Anglesey" },
            { name: "Angus" },
            { name: "Bedford" },
            { name: "Blackburn with Darwen" },
            { name: "Blackpool" },
            { name: "Bournemouth" },
            { name: "Bracknell Forest" },
            { name: "Brighton & Hove" },
            { name: "Bristol" },
            { name: "Buckinghamshire" },
            { name: "Cambridgeshire" },
            { name: "Carmarthenshire" },
            { name: "Central Bedfordshire" },
            { name: "Ceredigion" },
            { name: "Cheshire East" },
            { name: "Cheshire West and Chester" },
            { name: "Clackmannanshire" },
            { name: "Conwy" },
            { name: "Cornwall" },
            { name: "County Antrim" },
            { name: "County Armagh" },
            { name: "County Down" },
            { name: "County Durham" },
            { name: "County Fermanagh" },
            { name: "County Londonderry" },
            { name: "County Tyrone" },
            { name: "Cumbria" },
            { name: "Darlington" },
            { name: "Denbighshire" },
            { name: "Derby" },
            { name: "Derbyshire" },
            { name: "Devon" },
            { name: "Dorset" },
            { name: "Dumfries and Galloway" },
            { name: "Dundee" },
            { name: "East Lothian" },
            { name: "East Riding of Yorkshire" },
            { name: "East Sussex" },
            { name: "Edinburgh?" },
            { name: "Essex" },
            { name: "Falkirk" },
            { name: "Fife" },
            { name: "Flintshire" },
            { name: "Gloucestershire" },
            { name: "Greater London" },
            { name: "Greater Manchester" },
            { name: "Gwent" },
            { name: "Gwynedd" },
            { name: "Halton" },
            { name: "Hampshire" },
            { name: "Hartlepool" },
            { name: "Herefordshire" },
            { name: "Hertfordshire" },
            { name: "Highlands" },
            { name: "Hull" },
            { name: "Isle of Wight" },
            { name: "Isles of Scilly" },
            { name: "Kent" },
            { name: "Lancashire" },
            { name: "Leicester" },
            { name: "Leicestershire" },
            { name: "Lincolnshire" },
            { name: "Lothian" },
            { name: "Luton" },
            { name: "Medway" },
            { name: "Merseyside" },
            { name: "Mid Glamorgan" },
            { name: "Middlesbrough" },
            { name: "Milton Keynes" },
            { name: "Monmouthshire" },
            { name: "Moray" },
            { name: "Norfolk" },
            { name: "North East Lincolnshire" },
            { name: "North Lincolnshire" },
            { name: "North Somerset" },
            { name: "North Yorkshire" },
            { name: "Northamptonshire" },
            { name: "Northumberland" },
            { name: "Nottingham" },
            { name: "Nottinghamshire" },
            { name: "Oxfordshire" },
            { name: "Pembrokeshire" },
            { name: "Perth and Kinross" },
            { name: "Peterborough" },
            { name: "Plymouth" },
            { name: "Poole" },
            { name: "Portsmouth" },
            { name: "Powys" },
            { name: "Reading" },
            { name: "Redcar and Cleveland" },
            { name: "Rutland" },
            { name: "Scottish Borders" },
            { name: "Shropshire" },
            { name: "Slough" },
            { name: "Somerset" },
            { name: "South Glamorgan" },
            { name: "South Gloucestershire" },
            { name: "South Yorkshire" },
            { name: "Southampton" },
            { name: "Southend-on-Sea" },
            { name: "Staffordshire" },
            { name: "Stirlingshire" },
            { name: "Stockton-on-Tees" },
            { name: "Stoke-on-Trent" },
            { name: "Strathclyde" },
            { name: "Suffolk" },
            { name: "Surrey" },
            { name: "Swindon" },
            { name: "Telford and Wrekin" },
            { name: "Thurrock" },
            { name: "Torbay" },
            { name: "Tyne and Wear" },
            { name: "Warrington" },
            { name: "Warwickshire" },
            { name: "West Berkshire" },
            { name: "West Glamorgan" },
            { name: "West Lothian" },
            { name: "West Midlands" },
            { name: "West Sussex" },
            { name: "West Yorkshire" },
            { name: "Western Isles" },
            { name: "Wiltshire" },
            { name: "Windsor and Maidenhead" },
            { name: "Wokingham" },
            { name: "Worcestershire" },
            { name: "Wrexham" },
            { name: "York" }
          ]
        },
        provinces: {
          ca: [
            { name: "Alberta", abbreviation: "AB" },
            { name: "British Columbia", abbreviation: "BC" },
            { name: "Manitoba", abbreviation: "MB" },
            { name: "New Brunswick", abbreviation: "NB" },
            { name: "Newfoundland and Labrador", abbreviation: "NL" },
            { name: "Nova Scotia", abbreviation: "NS" },
            { name: "Ontario", abbreviation: "ON" },
            { name: "Prince Edward Island", abbreviation: "PE" },
            { name: "Quebec", abbreviation: "QC" },
            { name: "Saskatchewan", abbreviation: "SK" },
            // The case could be made that the following are not actually provinces
            // since they are technically considered "territories" however they all
            // look the same on an envelope!
            { name: "Northwest Territories", abbreviation: "NT" },
            { name: "Nunavut", abbreviation: "NU" },
            { name: "Yukon", abbreviation: "YT" }
          ],
          it: [
            { name: "Agrigento", abbreviation: "AG", code: 84 },
            { name: "Alessandria", abbreviation: "AL", code: 6 },
            { name: "Ancona", abbreviation: "AN", code: 42 },
            { name: "Aosta", abbreviation: "AO", code: 7 },
            { name: "L'Aquila", abbreviation: "AQ", code: 66 },
            { name: "Arezzo", abbreviation: "AR", code: 51 },
            { name: "Ascoli-Piceno", abbreviation: "AP", code: 44 },
            { name: "Asti", abbreviation: "AT", code: 5 },
            { name: "Avellino", abbreviation: "AV", code: 64 },
            { name: "Bari", abbreviation: "BA", code: 72 },
            { name: "Barletta-Andria-Trani", abbreviation: "BT", code: 72 },
            { name: "Belluno", abbreviation: "BL", code: 25 },
            { name: "Benevento", abbreviation: "BN", code: 62 },
            { name: "Bergamo", abbreviation: "BG", code: 16 },
            { name: "Biella", abbreviation: "BI", code: 96 },
            { name: "Bologna", abbreviation: "BO", code: 37 },
            { name: "Bolzano", abbreviation: "BZ", code: 21 },
            { name: "Brescia", abbreviation: "BS", code: 17 },
            { name: "Brindisi", abbreviation: "BR", code: 74 },
            { name: "Cagliari", abbreviation: "CA", code: 92 },
            { name: "Caltanissetta", abbreviation: "CL", code: 85 },
            { name: "Campobasso", abbreviation: "CB", code: 70 },
            { name: "Carbonia Iglesias", abbreviation: "CI", code: 70 },
            { name: "Caserta", abbreviation: "CE", code: 61 },
            { name: "Catania", abbreviation: "CT", code: 87 },
            { name: "Catanzaro", abbreviation: "CZ", code: 79 },
            { name: "Chieti", abbreviation: "CH", code: 69 },
            { name: "Como", abbreviation: "CO", code: 13 },
            { name: "Cosenza", abbreviation: "CS", code: 78 },
            { name: "Cremona", abbreviation: "CR", code: 19 },
            { name: "Crotone", abbreviation: "KR", code: 101 },
            { name: "Cuneo", abbreviation: "CN", code: 4 },
            { name: "Enna", abbreviation: "EN", code: 86 },
            { name: "Fermo", abbreviation: "FM", code: 86 },
            { name: "Ferrara", abbreviation: "FE", code: 38 },
            { name: "Firenze", abbreviation: "FI", code: 48 },
            { name: "Foggia", abbreviation: "FG", code: 71 },
            { name: "Forli-Cesena", abbreviation: "FC", code: 71 },
            { name: "Frosinone", abbreviation: "FR", code: 60 },
            { name: "Genova", abbreviation: "GE", code: 10 },
            { name: "Gorizia", abbreviation: "GO", code: 31 },
            { name: "Grosseto", abbreviation: "GR", code: 53 },
            { name: "Imperia", abbreviation: "IM", code: 8 },
            { name: "Isernia", abbreviation: "IS", code: 94 },
            { name: "La-Spezia", abbreviation: "SP", code: 66 },
            { name: "Latina", abbreviation: "LT", code: 59 },
            { name: "Lecce", abbreviation: "LE", code: 75 },
            { name: "Lecco", abbreviation: "LC", code: 97 },
            { name: "Livorno", abbreviation: "LI", code: 49 },
            { name: "Lodi", abbreviation: "LO", code: 98 },
            { name: "Lucca", abbreviation: "LU", code: 46 },
            { name: "Macerata", abbreviation: "MC", code: 43 },
            { name: "Mantova", abbreviation: "MN", code: 20 },
            { name: "Massa-Carrara", abbreviation: "MS", code: 45 },
            { name: "Matera", abbreviation: "MT", code: 77 },
            { name: "Medio Campidano", abbreviation: "VS", code: 77 },
            { name: "Messina", abbreviation: "ME", code: 83 },
            { name: "Milano", abbreviation: "MI", code: 15 },
            { name: "Modena", abbreviation: "MO", code: 36 },
            { name: "Monza-Brianza", abbreviation: "MB", code: 36 },
            { name: "Napoli", abbreviation: "NA", code: 63 },
            { name: "Novara", abbreviation: "NO", code: 3 },
            { name: "Nuoro", abbreviation: "NU", code: 91 },
            { name: "Ogliastra", abbreviation: "OG", code: 91 },
            { name: "Olbia Tempio", abbreviation: "OT", code: 91 },
            { name: "Oristano", abbreviation: "OR", code: 95 },
            { name: "Padova", abbreviation: "PD", code: 28 },
            { name: "Palermo", abbreviation: "PA", code: 82 },
            { name: "Parma", abbreviation: "PR", code: 34 },
            { name: "Pavia", abbreviation: "PV", code: 18 },
            { name: "Perugia", abbreviation: "PG", code: 54 },
            { name: "Pesaro-Urbino", abbreviation: "PU", code: 41 },
            { name: "Pescara", abbreviation: "PE", code: 68 },
            { name: "Piacenza", abbreviation: "PC", code: 33 },
            { name: "Pisa", abbreviation: "PI", code: 50 },
            { name: "Pistoia", abbreviation: "PT", code: 47 },
            { name: "Pordenone", abbreviation: "PN", code: 93 },
            { name: "Potenza", abbreviation: "PZ", code: 76 },
            { name: "Prato", abbreviation: "PO", code: 100 },
            { name: "Ragusa", abbreviation: "RG", code: 88 },
            { name: "Ravenna", abbreviation: "RA", code: 39 },
            { name: "Reggio-Calabria", abbreviation: "RC", code: 35 },
            { name: "Reggio-Emilia", abbreviation: "RE", code: 35 },
            { name: "Rieti", abbreviation: "RI", code: 57 },
            { name: "Rimini", abbreviation: "RN", code: 99 },
            { name: "Roma", abbreviation: "Roma", code: 58 },
            { name: "Rovigo", abbreviation: "RO", code: 29 },
            { name: "Salerno", abbreviation: "SA", code: 65 },
            { name: "Sassari", abbreviation: "SS", code: 90 },
            { name: "Savona", abbreviation: "SV", code: 9 },
            { name: "Siena", abbreviation: "SI", code: 52 },
            { name: "Siracusa", abbreviation: "SR", code: 89 },
            { name: "Sondrio", abbreviation: "SO", code: 14 },
            { name: "Taranto", abbreviation: "TA", code: 73 },
            { name: "Teramo", abbreviation: "TE", code: 67 },
            { name: "Terni", abbreviation: "TR", code: 55 },
            { name: "Torino", abbreviation: "TO", code: 1 },
            { name: "Trapani", abbreviation: "TP", code: 81 },
            { name: "Trento", abbreviation: "TN", code: 22 },
            { name: "Treviso", abbreviation: "TV", code: 26 },
            { name: "Trieste", abbreviation: "TS", code: 32 },
            { name: "Udine", abbreviation: "UD", code: 30 },
            { name: "Varese", abbreviation: "VA", code: 12 },
            { name: "Venezia", abbreviation: "VE", code: 27 },
            { name: "Verbania", abbreviation: "VB", code: 27 },
            { name: "Vercelli", abbreviation: "VC", code: 2 },
            { name: "Verona", abbreviation: "VR", code: 23 },
            { name: "Vibo-Valentia", abbreviation: "VV", code: 102 },
            { name: "Vicenza", abbreviation: "VI", code: 24 },
            { name: "Viterbo", abbreviation: "VT", code: 56 }
          ]
        },
        // from: https://github.com/samsargent/Useful-Autocomplete-Data/blob/master/data/nationalities.json
        nationalities: [
          { name: "Afghan" },
          { name: "Albanian" },
          { name: "Algerian" },
          { name: "American" },
          { name: "Andorran" },
          { name: "Angolan" },
          { name: "Antiguans" },
          { name: "Argentinean" },
          { name: "Armenian" },
          { name: "Australian" },
          { name: "Austrian" },
          { name: "Azerbaijani" },
          { name: "Bahami" },
          { name: "Bahraini" },
          { name: "Bangladeshi" },
          { name: "Barbadian" },
          { name: "Barbudans" },
          { name: "Batswana" },
          { name: "Belarusian" },
          { name: "Belgian" },
          { name: "Belizean" },
          { name: "Beninese" },
          { name: "Bhutanese" },
          { name: "Bolivian" },
          { name: "Bosnian" },
          { name: "Brazilian" },
          { name: "British" },
          { name: "Bruneian" },
          { name: "Bulgarian" },
          { name: "Burkinabe" },
          { name: "Burmese" },
          { name: "Burundian" },
          { name: "Cambodian" },
          { name: "Cameroonian" },
          { name: "Canadian" },
          { name: "Cape Verdean" },
          { name: "Central African" },
          { name: "Chadian" },
          { name: "Chilean" },
          { name: "Chinese" },
          { name: "Colombian" },
          { name: "Comoran" },
          { name: "Congolese" },
          { name: "Costa Rican" },
          { name: "Croatian" },
          { name: "Cuban" },
          { name: "Cypriot" },
          { name: "Czech" },
          { name: "Danish" },
          { name: "Djibouti" },
          { name: "Dominican" },
          { name: "Dutch" },
          { name: "East Timorese" },
          { name: "Ecuadorean" },
          { name: "Egyptian" },
          { name: "Emirian" },
          { name: "Equatorial Guinean" },
          { name: "Eritrean" },
          { name: "Estonian" },
          { name: "Ethiopian" },
          { name: "Fijian" },
          { name: "Filipino" },
          { name: "Finnish" },
          { name: "French" },
          { name: "Gabonese" },
          { name: "Gambian" },
          { name: "Georgian" },
          { name: "German" },
          { name: "Ghanaian" },
          { name: "Greek" },
          { name: "Grenadian" },
          { name: "Guatemalan" },
          { name: "Guinea-Bissauan" },
          { name: "Guinean" },
          { name: "Guyanese" },
          { name: "Haitian" },
          { name: "Herzegovinian" },
          { name: "Honduran" },
          { name: "Hungarian" },
          { name: "I-Kiribati" },
          { name: "Icelander" },
          { name: "Indian" },
          { name: "Indonesian" },
          { name: "Iranian" },
          { name: "Iraqi" },
          { name: "Irish" },
          { name: "Israeli" },
          { name: "Italian" },
          { name: "Ivorian" },
          { name: "Jamaican" },
          { name: "Japanese" },
          { name: "Jordanian" },
          { name: "Kazakhstani" },
          { name: "Kenyan" },
          { name: "Kittian and Nevisian" },
          { name: "Kuwaiti" },
          { name: "Kyrgyz" },
          { name: "Laotian" },
          { name: "Latvian" },
          { name: "Lebanese" },
          { name: "Liberian" },
          { name: "Libyan" },
          { name: "Liechtensteiner" },
          { name: "Lithuanian" },
          { name: "Luxembourger" },
          { name: "Macedonian" },
          { name: "Malagasy" },
          { name: "Malawian" },
          { name: "Malaysian" },
          { name: "Maldivan" },
          { name: "Malian" },
          { name: "Maltese" },
          { name: "Marshallese" },
          { name: "Mauritanian" },
          { name: "Mauritian" },
          { name: "Mexican" },
          { name: "Micronesian" },
          { name: "Moldovan" },
          { name: "Monacan" },
          { name: "Mongolian" },
          { name: "Moroccan" },
          { name: "Mosotho" },
          { name: "Motswana" },
          { name: "Mozambican" },
          { name: "Namibian" },
          { name: "Nauruan" },
          { name: "Nepalese" },
          { name: "New Zealander" },
          { name: "Nicaraguan" },
          { name: "Nigerian" },
          { name: "Nigerien" },
          { name: "North Korean" },
          { name: "Northern Irish" },
          { name: "Norwegian" },
          { name: "Omani" },
          { name: "Pakistani" },
          { name: "Palauan" },
          { name: "Panamanian" },
          { name: "Papua New Guinean" },
          { name: "Paraguayan" },
          { name: "Peruvian" },
          { name: "Polish" },
          { name: "Portuguese" },
          { name: "Qatari" },
          { name: "Romani" },
          { name: "Russian" },
          { name: "Rwandan" },
          { name: "Saint Lucian" },
          { name: "Salvadoran" },
          { name: "Samoan" },
          { name: "San Marinese" },
          { name: "Sao Tomean" },
          { name: "Saudi" },
          { name: "Scottish" },
          { name: "Senegalese" },
          { name: "Serbian" },
          { name: "Seychellois" },
          { name: "Sierra Leonean" },
          { name: "Singaporean" },
          { name: "Slovakian" },
          { name: "Slovenian" },
          { name: "Solomon Islander" },
          { name: "Somali" },
          { name: "South African" },
          { name: "South Korean" },
          { name: "Spanish" },
          { name: "Sri Lankan" },
          { name: "Sudanese" },
          { name: "Surinamer" },
          { name: "Swazi" },
          { name: "Swedish" },
          { name: "Swiss" },
          { name: "Syrian" },
          { name: "Taiwanese" },
          { name: "Tajik" },
          { name: "Tanzanian" },
          { name: "Thai" },
          { name: "Togolese" },
          { name: "Tongan" },
          { name: "Trinidadian or Tobagonian" },
          { name: "Tunisian" },
          { name: "Turkish" },
          { name: "Tuvaluan" },
          { name: "Ugandan" },
          { name: "Ukrainian" },
          { name: "Uruguaya" },
          { name: "Uzbekistani" },
          { name: "Venezuela" },
          { name: "Vietnamese" },
          { name: "Wels" },
          { name: "Yemenit" },
          { name: "Zambia" },
          { name: "Zimbabwe" }
        ],
        // http://www.loc.gov/standards/iso639-2/php/code_list.php (ISO-639-1 codes)
        locale_languages: [
          "aa",
          "ab",
          "ae",
          "af",
          "ak",
          "am",
          "an",
          "ar",
          "as",
          "av",
          "ay",
          "az",
          "ba",
          "be",
          "bg",
          "bh",
          "bi",
          "bm",
          "bn",
          "bo",
          "br",
          "bs",
          "ca",
          "ce",
          "ch",
          "co",
          "cr",
          "cs",
          "cu",
          "cv",
          "cy",
          "da",
          "de",
          "dv",
          "dz",
          "ee",
          "el",
          "en",
          "eo",
          "es",
          "et",
          "eu",
          "fa",
          "ff",
          "fi",
          "fj",
          "fo",
          "fr",
          "fy",
          "ga",
          "gd",
          "gl",
          "gn",
          "gu",
          "gv",
          "ha",
          "he",
          "hi",
          "ho",
          "hr",
          "ht",
          "hu",
          "hy",
          "hz",
          "ia",
          "id",
          "ie",
          "ig",
          "ii",
          "ik",
          "io",
          "is",
          "it",
          "iu",
          "ja",
          "jv",
          "ka",
          "kg",
          "ki",
          "kj",
          "kk",
          "kl",
          "km",
          "kn",
          "ko",
          "kr",
          "ks",
          "ku",
          "kv",
          "kw",
          "ky",
          "la",
          "lb",
          "lg",
          "li",
          "ln",
          "lo",
          "lt",
          "lu",
          "lv",
          "mg",
          "mh",
          "mi",
          "mk",
          "ml",
          "mn",
          "mr",
          "ms",
          "mt",
          "my",
          "na",
          "nb",
          "nd",
          "ne",
          "ng",
          "nl",
          "nn",
          "no",
          "nr",
          "nv",
          "ny",
          "oc",
          "oj",
          "om",
          "or",
          "os",
          "pa",
          "pi",
          "pl",
          "ps",
          "pt",
          "qu",
          "rm",
          "rn",
          "ro",
          "ru",
          "rw",
          "sa",
          "sc",
          "sd",
          "se",
          "sg",
          "si",
          "sk",
          "sl",
          "sm",
          "sn",
          "so",
          "sq",
          "sr",
          "ss",
          "st",
          "su",
          "sv",
          "sw",
          "ta",
          "te",
          "tg",
          "th",
          "ti",
          "tk",
          "tl",
          "tn",
          "to",
          "tr",
          "ts",
          "tt",
          "tw",
          "ty",
          "ug",
          "uk",
          "ur",
          "uz",
          "ve",
          "vi",
          "vo",
          "wa",
          "wo",
          "xh",
          "yi",
          "yo",
          "za",
          "zh",
          "zu"
        ],
        // From http://data.okfn.org/data/core/language-codes#resource-language-codes-full (IETF language tags)
        locale_regions: [
          "agq-CM",
          "asa-TZ",
          "ast-ES",
          "bas-CM",
          "bem-ZM",
          "bez-TZ",
          "brx-IN",
          "cgg-UG",
          "chr-US",
          "dav-KE",
          "dje-NE",
          "dsb-DE",
          "dua-CM",
          "dyo-SN",
          "ebu-KE",
          "ewo-CM",
          "fil-PH",
          "fur-IT",
          "gsw-CH",
          "gsw-FR",
          "gsw-LI",
          "guz-KE",
          "haw-US",
          "hsb-DE",
          "jgo-CM",
          "jmc-TZ",
          "kab-DZ",
          "kam-KE",
          "kde-TZ",
          "kea-CV",
          "khq-ML",
          "kkj-CM",
          "kln-KE",
          "kok-IN",
          "ksb-TZ",
          "ksf-CM",
          "ksh-DE",
          "lag-TZ",
          "lkt-US",
          "luo-KE",
          "luy-KE",
          "mas-KE",
          "mas-TZ",
          "mer-KE",
          "mfe-MU",
          "mgh-MZ",
          "mgo-CM",
          "mua-CM",
          "naq-NA",
          "nmg-CM",
          "nnh-CM",
          "nus-SD",
          "nyn-UG",
          "rof-TZ",
          "rwk-TZ",
          "sah-RU",
          "saq-KE",
          "sbp-TZ",
          "seh-MZ",
          "ses-ML",
          "shi-Latn",
          "shi-Latn-MA",
          "shi-Tfng",
          "shi-Tfng-MA",
          "smn-FI",
          "teo-KE",
          "teo-UG",
          "twq-NE",
          "tzm-Latn",
          "tzm-Latn-MA",
          "vai-Latn",
          "vai-Latn-LR",
          "vai-Vaii",
          "vai-Vaii-LR",
          "vun-TZ",
          "wae-CH",
          "xog-UG",
          "yav-CM",
          "zgh-MA",
          "af-NA",
          "af-ZA",
          "ak-GH",
          "am-ET",
          "ar-001",
          "ar-AE",
          "ar-BH",
          "ar-DJ",
          "ar-DZ",
          "ar-EG",
          "ar-EH",
          "ar-ER",
          "ar-IL",
          "ar-IQ",
          "ar-JO",
          "ar-KM",
          "ar-KW",
          "ar-LB",
          "ar-LY",
          "ar-MA",
          "ar-MR",
          "ar-OM",
          "ar-PS",
          "ar-QA",
          "ar-SA",
          "ar-SD",
          "ar-SO",
          "ar-SS",
          "ar-SY",
          "ar-TD",
          "ar-TN",
          "ar-YE",
          "as-IN",
          "az-Cyrl",
          "az-Cyrl-AZ",
          "az-Latn",
          "az-Latn-AZ",
          "be-BY",
          "bg-BG",
          "bm-Latn",
          "bm-Latn-ML",
          "bn-BD",
          "bn-IN",
          "bo-CN",
          "bo-IN",
          "br-FR",
          "bs-Cyrl",
          "bs-Cyrl-BA",
          "bs-Latn",
          "bs-Latn-BA",
          "ca-AD",
          "ca-ES",
          "ca-ES-VALENCIA",
          "ca-FR",
          "ca-IT",
          "cs-CZ",
          "cy-GB",
          "da-DK",
          "da-GL",
          "de-AT",
          "de-BE",
          "de-CH",
          "de-DE",
          "de-LI",
          "de-LU",
          "dz-BT",
          "ee-GH",
          "ee-TG",
          "el-CY",
          "el-GR",
          "en-001",
          "en-150",
          "en-AG",
          "en-AI",
          "en-AS",
          "en-AU",
          "en-BB",
          "en-BE",
          "en-BM",
          "en-BS",
          "en-BW",
          "en-BZ",
          "en-CA",
          "en-CC",
          "en-CK",
          "en-CM",
          "en-CX",
          "en-DG",
          "en-DM",
          "en-ER",
          "en-FJ",
          "en-FK",
          "en-FM",
          "en-GB",
          "en-GD",
          "en-GG",
          "en-GH",
          "en-GI",
          "en-GM",
          "en-GU",
          "en-GY",
          "en-HK",
          "en-IE",
          "en-IM",
          "en-IN",
          "en-IO",
          "en-JE",
          "en-JM",
          "en-KE",
          "en-KI",
          "en-KN",
          "en-KY",
          "en-LC",
          "en-LR",
          "en-LS",
          "en-MG",
          "en-MH",
          "en-MO",
          "en-MP",
          "en-MS",
          "en-MT",
          "en-MU",
          "en-MW",
          "en-MY",
          "en-NA",
          "en-NF",
          "en-NG",
          "en-NR",
          "en-NU",
          "en-NZ",
          "en-PG",
          "en-PH",
          "en-PK",
          "en-PN",
          "en-PR",
          "en-PW",
          "en-RW",
          "en-SB",
          "en-SC",
          "en-SD",
          "en-SG",
          "en-SH",
          "en-SL",
          "en-SS",
          "en-SX",
          "en-SZ",
          "en-TC",
          "en-TK",
          "en-TO",
          "en-TT",
          "en-TV",
          "en-TZ",
          "en-UG",
          "en-UM",
          "en-US",
          "en-US-POSIX",
          "en-VC",
          "en-VG",
          "en-VI",
          "en-VU",
          "en-WS",
          "en-ZA",
          "en-ZM",
          "en-ZW",
          "eo-001",
          "es-419",
          "es-AR",
          "es-BO",
          "es-CL",
          "es-CO",
          "es-CR",
          "es-CU",
          "es-DO",
          "es-EA",
          "es-EC",
          "es-ES",
          "es-GQ",
          "es-GT",
          "es-HN",
          "es-IC",
          "es-MX",
          "es-NI",
          "es-PA",
          "es-PE",
          "es-PH",
          "es-PR",
          "es-PY",
          "es-SV",
          "es-US",
          "es-UY",
          "es-VE",
          "et-EE",
          "eu-ES",
          "fa-AF",
          "fa-IR",
          "ff-CM",
          "ff-GN",
          "ff-MR",
          "ff-SN",
          "fi-FI",
          "fo-FO",
          "fr-BE",
          "fr-BF",
          "fr-BI",
          "fr-BJ",
          "fr-BL",
          "fr-CA",
          "fr-CD",
          "fr-CF",
          "fr-CG",
          "fr-CH",
          "fr-CI",
          "fr-CM",
          "fr-DJ",
          "fr-DZ",
          "fr-FR",
          "fr-GA",
          "fr-GF",
          "fr-GN",
          "fr-GP",
          "fr-GQ",
          "fr-HT",
          "fr-KM",
          "fr-LU",
          "fr-MA",
          "fr-MC",
          "fr-MF",
          "fr-MG",
          "fr-ML",
          "fr-MQ",
          "fr-MR",
          "fr-MU",
          "fr-NC",
          "fr-NE",
          "fr-PF",
          "fr-PM",
          "fr-RE",
          "fr-RW",
          "fr-SC",
          "fr-SN",
          "fr-SY",
          "fr-TD",
          "fr-TG",
          "fr-TN",
          "fr-VU",
          "fr-WF",
          "fr-YT",
          "fy-NL",
          "ga-IE",
          "gd-GB",
          "gl-ES",
          "gu-IN",
          "gv-IM",
          "ha-Latn",
          "ha-Latn-GH",
          "ha-Latn-NE",
          "ha-Latn-NG",
          "he-IL",
          "hi-IN",
          "hr-BA",
          "hr-HR",
          "hu-HU",
          "hy-AM",
          "id-ID",
          "ig-NG",
          "ii-CN",
          "is-IS",
          "it-CH",
          "it-IT",
          "it-SM",
          "ja-JP",
          "ka-GE",
          "ki-KE",
          "kk-Cyrl",
          "kk-Cyrl-KZ",
          "kl-GL",
          "km-KH",
          "kn-IN",
          "ko-KP",
          "ko-KR",
          "ks-Arab",
          "ks-Arab-IN",
          "kw-GB",
          "ky-Cyrl",
          "ky-Cyrl-KG",
          "lb-LU",
          "lg-UG",
          "ln-AO",
          "ln-CD",
          "ln-CF",
          "ln-CG",
          "lo-LA",
          "lt-LT",
          "lu-CD",
          "lv-LV",
          "mg-MG",
          "mk-MK",
          "ml-IN",
          "mn-Cyrl",
          "mn-Cyrl-MN",
          "mr-IN",
          "ms-Latn",
          "ms-Latn-BN",
          "ms-Latn-MY",
          "ms-Latn-SG",
          "mt-MT",
          "my-MM",
          "nb-NO",
          "nb-SJ",
          "nd-ZW",
          "ne-IN",
          "ne-NP",
          "nl-AW",
          "nl-BE",
          "nl-BQ",
          "nl-CW",
          "nl-NL",
          "nl-SR",
          "nl-SX",
          "nn-NO",
          "om-ET",
          "om-KE",
          "or-IN",
          "os-GE",
          "os-RU",
          "pa-Arab",
          "pa-Arab-PK",
          "pa-Guru",
          "pa-Guru-IN",
          "pl-PL",
          "ps-AF",
          "pt-AO",
          "pt-BR",
          "pt-CV",
          "pt-GW",
          "pt-MO",
          "pt-MZ",
          "pt-PT",
          "pt-ST",
          "pt-TL",
          "qu-BO",
          "qu-EC",
          "qu-PE",
          "rm-CH",
          "rn-BI",
          "ro-MD",
          "ro-RO",
          "ru-BY",
          "ru-KG",
          "ru-KZ",
          "ru-MD",
          "ru-RU",
          "ru-UA",
          "rw-RW",
          "se-FI",
          "se-NO",
          "se-SE",
          "sg-CF",
          "si-LK",
          "sk-SK",
          "sl-SI",
          "sn-ZW",
          "so-DJ",
          "so-ET",
          "so-KE",
          "so-SO",
          "sq-AL",
          "sq-MK",
          "sq-XK",
          "sr-Cyrl",
          "sr-Cyrl-BA",
          "sr-Cyrl-ME",
          "sr-Cyrl-RS",
          "sr-Cyrl-XK",
          "sr-Latn",
          "sr-Latn-BA",
          "sr-Latn-ME",
          "sr-Latn-RS",
          "sr-Latn-XK",
          "sv-AX",
          "sv-FI",
          "sv-SE",
          "sw-CD",
          "sw-KE",
          "sw-TZ",
          "sw-UG",
          "ta-IN",
          "ta-LK",
          "ta-MY",
          "ta-SG",
          "te-IN",
          "th-TH",
          "ti-ER",
          "ti-ET",
          "to-TO",
          "tr-CY",
          "tr-TR",
          "ug-Arab",
          "ug-Arab-CN",
          "uk-UA",
          "ur-IN",
          "ur-PK",
          "uz-Arab",
          "uz-Arab-AF",
          "uz-Cyrl",
          "uz-Cyrl-UZ",
          "uz-Latn",
          "uz-Latn-UZ",
          "vi-VN",
          "yi-001",
          "yo-BJ",
          "yo-NG",
          "zh-Hans",
          "zh-Hans-CN",
          "zh-Hans-HK",
          "zh-Hans-MO",
          "zh-Hans-SG",
          "zh-Hant",
          "zh-Hant-HK",
          "zh-Hant-MO",
          "zh-Hant-TW",
          "zu-ZA"
        ],
        us_states_and_dc: [
          { name: "Alabama", abbreviation: "AL" },
          { name: "Alaska", abbreviation: "AK" },
          { name: "Arizona", abbreviation: "AZ" },
          { name: "Arkansas", abbreviation: "AR" },
          { name: "California", abbreviation: "CA" },
          { name: "Colorado", abbreviation: "CO" },
          { name: "Connecticut", abbreviation: "CT" },
          { name: "Delaware", abbreviation: "DE" },
          { name: "District of Columbia", abbreviation: "DC" },
          { name: "Florida", abbreviation: "FL" },
          { name: "Georgia", abbreviation: "GA" },
          { name: "Hawaii", abbreviation: "HI" },
          { name: "Idaho", abbreviation: "ID" },
          { name: "Illinois", abbreviation: "IL" },
          { name: "Indiana", abbreviation: "IN" },
          { name: "Iowa", abbreviation: "IA" },
          { name: "Kansas", abbreviation: "KS" },
          { name: "Kentucky", abbreviation: "KY" },
          { name: "Louisiana", abbreviation: "LA" },
          { name: "Maine", abbreviation: "ME" },
          { name: "Maryland", abbreviation: "MD" },
          { name: "Massachusetts", abbreviation: "MA" },
          { name: "Michigan", abbreviation: "MI" },
          { name: "Minnesota", abbreviation: "MN" },
          { name: "Mississippi", abbreviation: "MS" },
          { name: "Missouri", abbreviation: "MO" },
          { name: "Montana", abbreviation: "MT" },
          { name: "Nebraska", abbreviation: "NE" },
          { name: "Nevada", abbreviation: "NV" },
          { name: "New Hampshire", abbreviation: "NH" },
          { name: "New Jersey", abbreviation: "NJ" },
          { name: "New Mexico", abbreviation: "NM" },
          { name: "New York", abbreviation: "NY" },
          { name: "North Carolina", abbreviation: "NC" },
          { name: "North Dakota", abbreviation: "ND" },
          { name: "Ohio", abbreviation: "OH" },
          { name: "Oklahoma", abbreviation: "OK" },
          { name: "Oregon", abbreviation: "OR" },
          { name: "Pennsylvania", abbreviation: "PA" },
          { name: "Rhode Island", abbreviation: "RI" },
          { name: "South Carolina", abbreviation: "SC" },
          { name: "South Dakota", abbreviation: "SD" },
          { name: "Tennessee", abbreviation: "TN" },
          { name: "Texas", abbreviation: "TX" },
          { name: "Utah", abbreviation: "UT" },
          { name: "Vermont", abbreviation: "VT" },
          { name: "Virginia", abbreviation: "VA" },
          { name: "Washington", abbreviation: "WA" },
          { name: "West Virginia", abbreviation: "WV" },
          { name: "Wisconsin", abbreviation: "WI" },
          { name: "Wyoming", abbreviation: "WY" }
        ],
        territories: [
          { name: "American Samoa", abbreviation: "AS" },
          { name: "Federated States of Micronesia", abbreviation: "FM" },
          { name: "Guam", abbreviation: "GU" },
          { name: "Marshall Islands", abbreviation: "MH" },
          { name: "Northern Mariana Islands", abbreviation: "MP" },
          { name: "Puerto Rico", abbreviation: "PR" },
          { name: "Virgin Islands, U.S.", abbreviation: "VI" }
        ],
        armed_forces: [
          { name: "Armed Forces Europe", abbreviation: "AE" },
          { name: "Armed Forces Pacific", abbreviation: "AP" },
          { name: "Armed Forces the Americas", abbreviation: "AA" }
        ],
        country_regions: {
          it: [
            { name: "Valle d'Aosta", abbreviation: "VDA" },
            { name: "Piemonte", abbreviation: "PIE" },
            { name: "Lombardia", abbreviation: "LOM" },
            { name: "Veneto", abbreviation: "VEN" },
            { name: "Trentino Alto Adige", abbreviation: "TAA" },
            { name: "Friuli Venezia Giulia", abbreviation: "FVG" },
            { name: "Liguria", abbreviation: "LIG" },
            { name: "Emilia Romagna", abbreviation: "EMR" },
            { name: "Toscana", abbreviation: "TOS" },
            { name: "Umbria", abbreviation: "UMB" },
            { name: "Marche", abbreviation: "MAR" },
            { name: "Abruzzo", abbreviation: "ABR" },
            { name: "Lazio", abbreviation: "LAZ" },
            { name: "Campania", abbreviation: "CAM" },
            { name: "Puglia", abbreviation: "PUG" },
            { name: "Basilicata", abbreviation: "BAS" },
            { name: "Molise", abbreviation: "MOL" },
            { name: "Calabria", abbreviation: "CAL" },
            { name: "Sicilia", abbreviation: "SIC" },
            { name: "Sardegna", abbreviation: "SAR" }
          ],
          mx: [
            { name: "Aguascalientes", abbreviation: "AGU" },
            { name: "Baja California", abbreviation: "BCN" },
            { name: "Baja California Sur", abbreviation: "BCS" },
            { name: "Campeche", abbreviation: "CAM" },
            { name: "Chiapas", abbreviation: "CHP" },
            { name: "Chihuahua", abbreviation: "CHH" },
            { name: "Ciudad de México", abbreviation: "DIF" },
            { name: "Coahuila", abbreviation: "COA" },
            { name: "Colima", abbreviation: "COL" },
            { name: "Durango", abbreviation: "DUR" },
            { name: "Guanajuato", abbreviation: "GUA" },
            { name: "Guerrero", abbreviation: "GRO" },
            { name: "Hidalgo", abbreviation: "HID" },
            { name: "Jalisco", abbreviation: "JAL" },
            { name: "México", abbreviation: "MEX" },
            { name: "Michoacán", abbreviation: "MIC" },
            { name: "Morelos", abbreviation: "MOR" },
            { name: "Nayarit", abbreviation: "NAY" },
            { name: "Nuevo León", abbreviation: "NLE" },
            { name: "Oaxaca", abbreviation: "OAX" },
            { name: "Puebla", abbreviation: "PUE" },
            { name: "Querétaro", abbreviation: "QUE" },
            { name: "Quintana Roo", abbreviation: "ROO" },
            { name: "San Luis Potosí", abbreviation: "SLP" },
            { name: "Sinaloa", abbreviation: "SIN" },
            { name: "Sonora", abbreviation: "SON" },
            { name: "Tabasco", abbreviation: "TAB" },
            { name: "Tamaulipas", abbreviation: "TAM" },
            { name: "Tlaxcala", abbreviation: "TLA" },
            { name: "Veracruz", abbreviation: "VER" },
            { name: "Yucatán", abbreviation: "YUC" },
            { name: "Zacatecas", abbreviation: "ZAC" }
          ]
        },
        street_suffixes: {
          us: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Boulevard", abbreviation: "Blvd" },
            { name: "Center", abbreviation: "Ctr" },
            { name: "Circle", abbreviation: "Cir" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Extension", abbreviation: "Ext" },
            { name: "Glen", abbreviation: "Gln" },
            { name: "Grove", abbreviation: "Grv" },
            { name: "Heights", abbreviation: "Hts" },
            { name: "Highway", abbreviation: "Hwy" },
            { name: "Junction", abbreviation: "Jct" },
            { name: "Key", abbreviation: "Key" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Loop", abbreviation: "Loop" },
            { name: "Manor", abbreviation: "Mnr" },
            { name: "Mill", abbreviation: "Mill" },
            { name: "Park", abbreviation: "Park" },
            { name: "Parkway", abbreviation: "Pkwy" },
            { name: "Pass", abbreviation: "Pass" },
            { name: "Path", abbreviation: "Path" },
            { name: "Pike", abbreviation: "Pike" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Plaza", abbreviation: "Plz" },
            { name: "Point", abbreviation: "Pt" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "River", abbreviation: "Riv" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Trail", abbreviation: "Trl" },
            { name: "Turnpike", abbreviation: "Tpke" },
            { name: "View", abbreviation: "Vw" },
            { name: "Way", abbreviation: "Way" }
          ],
          it: [
            { name: "Accesso", abbreviation: "Acc." },
            { name: "Alzaia", abbreviation: "Alz." },
            { name: "Arco", abbreviation: "Arco" },
            { name: "Archivolto", abbreviation: "Acv." },
            { name: "Arena", abbreviation: "Arena" },
            { name: "Argine", abbreviation: "Argine" },
            { name: "Bacino", abbreviation: "Bacino" },
            { name: "Banchi", abbreviation: "Banchi" },
            { name: "Banchina", abbreviation: "Ban." },
            { name: "Bastioni", abbreviation: "Bas." },
            { name: "Belvedere", abbreviation: "Belv." },
            { name: "Borgata", abbreviation: "B.ta" },
            { name: "Borgo", abbreviation: "B.go" },
            { name: "Calata", abbreviation: "Cal." },
            { name: "Calle", abbreviation: "Calle" },
            { name: "Campiello", abbreviation: "Cam." },
            { name: "Campo", abbreviation: "Cam." },
            { name: "Canale", abbreviation: "Can." },
            { name: "Carraia", abbreviation: "Carr." },
            { name: "Cascina", abbreviation: "Cascina" },
            { name: "Case sparse", abbreviation: "c.s." },
            { name: "Cavalcavia", abbreviation: "Cv." },
            { name: "Circonvallazione", abbreviation: "Cv." },
            { name: "Complanare", abbreviation: "C.re" },
            { name: "Contrada", abbreviation: "C.da" },
            { name: "Corso", abbreviation: "C.so" },
            { name: "Corte", abbreviation: "C.te" },
            { name: "Cortile", abbreviation: "C.le" },
            { name: "Diramazione", abbreviation: "Dir." },
            { name: "Fondaco", abbreviation: "F.co" },
            { name: "Fondamenta", abbreviation: "F.ta" },
            { name: "Fondo", abbreviation: "F.do" },
            { name: "Frazione", abbreviation: "Fr." },
            { name: "Isola", abbreviation: "Is." },
            { name: "Largo", abbreviation: "L.go" },
            { name: "Litoranea", abbreviation: "Lit." },
            { name: "Lungolago", abbreviation: "L.go lago" },
            { name: "Lungo Po", abbreviation: "l.go Po" },
            { name: "Molo", abbreviation: "Molo" },
            { name: "Mura", abbreviation: "Mura" },
            { name: "Passaggio privato", abbreviation: "pass. priv." },
            { name: "Passeggiata", abbreviation: "Pass." },
            { name: "Piazza", abbreviation: "P.zza" },
            { name: "Piazzale", abbreviation: "P.le" },
            { name: "Ponte", abbreviation: "P.te" },
            { name: "Portico", abbreviation: "P.co" },
            { name: "Rampa", abbreviation: "Rampa" },
            { name: "Regione", abbreviation: "Reg." },
            { name: "Rione", abbreviation: "R.ne" },
            { name: "Rio", abbreviation: "Rio" },
            { name: "Ripa", abbreviation: "Ripa" },
            { name: "Riva", abbreviation: "Riva" },
            { name: "Rondò", abbreviation: "Rondò" },
            { name: "Rotonda", abbreviation: "Rot." },
            { name: "Sagrato", abbreviation: "Sagr." },
            { name: "Salita", abbreviation: "Sal." },
            { name: "Scalinata", abbreviation: "Scal." },
            { name: "Scalone", abbreviation: "Scal." },
            { name: "Slargo", abbreviation: "Sl." },
            { name: "Sottoportico", abbreviation: "Sott." },
            { name: "Strada", abbreviation: "Str." },
            { name: "Stradale", abbreviation: "Str.le" },
            { name: "Strettoia", abbreviation: "Strett." },
            { name: "Traversa", abbreviation: "Trav." },
            { name: "Via", abbreviation: "V." },
            { name: "Viale", abbreviation: "V.le" },
            { name: "Vicinale", abbreviation: "Vic.le" },
            { name: "Vicolo", abbreviation: "Vic." }
          ],
          uk: [
            { name: "Avenue", abbreviation: "Ave" },
            { name: "Close", abbreviation: "Cl" },
            { name: "Court", abbreviation: "Ct" },
            { name: "Crescent", abbreviation: "Cr" },
            { name: "Drive", abbreviation: "Dr" },
            { name: "Garden", abbreviation: "Gdn" },
            { name: "Gardens", abbreviation: "Gdns" },
            { name: "Green", abbreviation: "Gn" },
            { name: "Grove", abbreviation: "Gr" },
            { name: "Lane", abbreviation: "Ln" },
            { name: "Mount", abbreviation: "Mt" },
            { name: "Place", abbreviation: "Pl" },
            { name: "Park", abbreviation: "Pk" },
            { name: "Ridge", abbreviation: "Rdg" },
            { name: "Road", abbreviation: "Rd" },
            { name: "Square", abbreviation: "Sq" },
            { name: "Street", abbreviation: "St" },
            { name: "Terrace", abbreviation: "Ter" },
            { name: "Valley", abbreviation: "Val" }
          ]
        },
        months: [
          { name: "January", short_name: "Jan", numeric: "01", days: 31 },
          // Not messing with leap years...
          { name: "February", short_name: "Feb", numeric: "02", days: 28 },
          { name: "March", short_name: "Mar", numeric: "03", days: 31 },
          { name: "April", short_name: "Apr", numeric: "04", days: 30 },
          { name: "May", short_name: "May", numeric: "05", days: 31 },
          { name: "June", short_name: "Jun", numeric: "06", days: 30 },
          { name: "July", short_name: "Jul", numeric: "07", days: 31 },
          { name: "August", short_name: "Aug", numeric: "08", days: 31 },
          { name: "September", short_name: "Sep", numeric: "09", days: 30 },
          { name: "October", short_name: "Oct", numeric: "10", days: 31 },
          { name: "November", short_name: "Nov", numeric: "11", days: 30 },
          { name: "December", short_name: "Dec", numeric: "12", days: 31 }
        ],
        // http://en.wikipedia.org/wiki/Bank_card_number#Issuer_identification_number_.28IIN.29
        cc_types: [
          { name: "American Express", short_name: "amex", prefix: "34", length: 15 },
          { name: "Bankcard", short_name: "bankcard", prefix: "5610", length: 16 },
          { name: "China UnionPay", short_name: "chinaunion", prefix: "62", length: 16 },
          { name: "Diners Club Carte Blanche", short_name: "dccarte", prefix: "300", length: 14 },
          { name: "Diners Club enRoute", short_name: "dcenroute", prefix: "2014", length: 15 },
          { name: "Diners Club International", short_name: "dcintl", prefix: "36", length: 14 },
          { name: "Diners Club United States & Canada", short_name: "dcusc", prefix: "54", length: 16 },
          { name: "Discover Card", short_name: "discover", prefix: "6011", length: 16 },
          { name: "InstaPayment", short_name: "instapay", prefix: "637", length: 16 },
          { name: "JCB", short_name: "jcb", prefix: "3528", length: 16 },
          { name: "Laser", short_name: "laser", prefix: "6304", length: 16 },
          { name: "Maestro", short_name: "maestro", prefix: "5018", length: 16 },
          { name: "Mastercard", short_name: "mc", prefix: "51", length: 16 },
          { name: "Solo", short_name: "solo", prefix: "6334", length: 16 },
          { name: "Switch", short_name: "switch", prefix: "4903", length: 16 },
          { name: "Visa", short_name: "visa", prefix: "4", length: 16 },
          { name: "Visa Electron", short_name: "electron", prefix: "4026", length: 16 }
        ],
        //return all world currency by ISO 4217
        currency_types: [
          { code: "AED", name: "United Arab Emirates Dirham" },
          { code: "AFN", name: "Afghanistan Afghani" },
          { code: "ALL", name: "Albania Lek" },
          { code: "AMD", name: "Armenia Dram" },
          { code: "ANG", name: "Netherlands Antilles Guilder" },
          { code: "AOA", name: "Angola Kwanza" },
          { code: "ARS", name: "Argentina Peso" },
          { code: "AUD", name: "Australia Dollar" },
          { code: "AWG", name: "Aruba Guilder" },
          { code: "AZN", name: "Azerbaijan New Manat" },
          { code: "BAM", name: "Bosnia and Herzegovina Convertible Marka" },
          { code: "BBD", name: "Barbados Dollar" },
          { code: "BDT", name: "Bangladesh Taka" },
          { code: "BGN", name: "Bulgaria Lev" },
          { code: "BHD", name: "Bahrain Dinar" },
          { code: "BIF", name: "Burundi Franc" },
          { code: "BMD", name: "Bermuda Dollar" },
          { code: "BND", name: "Brunei Darussalam Dollar" },
          { code: "BOB", name: "Bolivia Boliviano" },
          { code: "BRL", name: "Brazil Real" },
          { code: "BSD", name: "Bahamas Dollar" },
          { code: "BTN", name: "Bhutan Ngultrum" },
          { code: "BWP", name: "Botswana Pula" },
          { code: "BYR", name: "Belarus Ruble" },
          { code: "BZD", name: "Belize Dollar" },
          { code: "CAD", name: "Canada Dollar" },
          { code: "CDF", name: "Congo/Kinshasa Franc" },
          { code: "CHF", name: "Switzerland Franc" },
          { code: "CLP", name: "Chile Peso" },
          { code: "CNY", name: "China Yuan Renminbi" },
          { code: "COP", name: "Colombia Peso" },
          { code: "CRC", name: "Costa Rica Colon" },
          { code: "CUC", name: "Cuba Convertible Peso" },
          { code: "CUP", name: "Cuba Peso" },
          { code: "CVE", name: "Cape Verde Escudo" },
          { code: "CZK", name: "Czech Republic Koruna" },
          { code: "DJF", name: "Djibouti Franc" },
          { code: "DKK", name: "Denmark Krone" },
          { code: "DOP", name: "Dominican Republic Peso" },
          { code: "DZD", name: "Algeria Dinar" },
          { code: "EGP", name: "Egypt Pound" },
          { code: "ERN", name: "Eritrea Nakfa" },
          { code: "ETB", name: "Ethiopia Birr" },
          { code: "EUR", name: "Euro Member Countries" },
          { code: "FJD", name: "Fiji Dollar" },
          { code: "FKP", name: "Falkland Islands (Malvinas) Pound" },
          { code: "GBP", name: "United Kingdom Pound" },
          { code: "GEL", name: "Georgia Lari" },
          { code: "GGP", name: "Guernsey Pound" },
          { code: "GHS", name: "Ghana Cedi" },
          { code: "GIP", name: "Gibraltar Pound" },
          { code: "GMD", name: "Gambia Dalasi" },
          { code: "GNF", name: "Guinea Franc" },
          { code: "GTQ", name: "Guatemala Quetzal" },
          { code: "GYD", name: "Guyana Dollar" },
          { code: "HKD", name: "Hong Kong Dollar" },
          { code: "HNL", name: "Honduras Lempira" },
          { code: "HRK", name: "Croatia Kuna" },
          { code: "HTG", name: "Haiti Gourde" },
          { code: "HUF", name: "Hungary Forint" },
          { code: "IDR", name: "Indonesia Rupiah" },
          { code: "ILS", name: "Israel Shekel" },
          { code: "IMP", name: "Isle of Man Pound" },
          { code: "INR", name: "India Rupee" },
          { code: "IQD", name: "Iraq Dinar" },
          { code: "IRR", name: "Iran Rial" },
          { code: "ISK", name: "Iceland Krona" },
          { code: "JEP", name: "Jersey Pound" },
          { code: "JMD", name: "Jamaica Dollar" },
          { code: "JOD", name: "Jordan Dinar" },
          { code: "JPY", name: "Japan Yen" },
          { code: "KES", name: "Kenya Shilling" },
          { code: "KGS", name: "Kyrgyzstan Som" },
          { code: "KHR", name: "Cambodia Riel" },
          { code: "KMF", name: "Comoros Franc" },
          { code: "KPW", name: "Korea (North) Won" },
          { code: "KRW", name: "Korea (South) Won" },
          { code: "KWD", name: "Kuwait Dinar" },
          { code: "KYD", name: "Cayman Islands Dollar" },
          { code: "KZT", name: "Kazakhstan Tenge" },
          { code: "LAK", name: "Laos Kip" },
          { code: "LBP", name: "Lebanon Pound" },
          { code: "LKR", name: "Sri Lanka Rupee" },
          { code: "LRD", name: "Liberia Dollar" },
          { code: "LSL", name: "Lesotho Loti" },
          { code: "LTL", name: "Lithuania Litas" },
          { code: "LYD", name: "Libya Dinar" },
          { code: "MAD", name: "Morocco Dirham" },
          { code: "MDL", name: "Moldova Leu" },
          { code: "MGA", name: "Madagascar Ariary" },
          { code: "MKD", name: "Macedonia Denar" },
          { code: "MMK", name: "Myanmar (Burma) Kyat" },
          { code: "MNT", name: "Mongolia Tughrik" },
          { code: "MOP", name: "Macau Pataca" },
          { code: "MRO", name: "Mauritania Ouguiya" },
          { code: "MUR", name: "Mauritius Rupee" },
          { code: "MVR", name: "Maldives (Maldive Islands) Rufiyaa" },
          { code: "MWK", name: "Malawi Kwacha" },
          { code: "MXN", name: "Mexico Peso" },
          { code: "MYR", name: "Malaysia Ringgit" },
          { code: "MZN", name: "Mozambique Metical" },
          { code: "NAD", name: "Namibia Dollar" },
          { code: "NGN", name: "Nigeria Naira" },
          { code: "NIO", name: "Nicaragua Cordoba" },
          { code: "NOK", name: "Norway Krone" },
          { code: "NPR", name: "Nepal Rupee" },
          { code: "NZD", name: "New Zealand Dollar" },
          { code: "OMR", name: "Oman Rial" },
          { code: "PAB", name: "Panama Balboa" },
          { code: "PEN", name: "Peru Nuevo Sol" },
          { code: "PGK", name: "Papua New Guinea Kina" },
          { code: "PHP", name: "Philippines Peso" },
          { code: "PKR", name: "Pakistan Rupee" },
          { code: "PLN", name: "Poland Zloty" },
          { code: "PYG", name: "Paraguay Guarani" },
          { code: "QAR", name: "Qatar Riyal" },
          { code: "RON", name: "Romania New Leu" },
          { code: "RSD", name: "Serbia Dinar" },
          { code: "RUB", name: "Russia Ruble" },
          { code: "RWF", name: "Rwanda Franc" },
          { code: "SAR", name: "Saudi Arabia Riyal" },
          { code: "SBD", name: "Solomon Islands Dollar" },
          { code: "SCR", name: "Seychelles Rupee" },
          { code: "SDG", name: "Sudan Pound" },
          { code: "SEK", name: "Sweden Krona" },
          { code: "SGD", name: "Singapore Dollar" },
          { code: "SHP", name: "Saint Helena Pound" },
          { code: "SLL", name: "Sierra Leone Leone" },
          { code: "SOS", name: "Somalia Shilling" },
          { code: "SPL", name: "Seborga Luigino" },
          { code: "SRD", name: "Suriname Dollar" },
          { code: "STD", name: "São Tomé and Príncipe Dobra" },
          { code: "SVC", name: "El Salvador Colon" },
          { code: "SYP", name: "Syria Pound" },
          { code: "SZL", name: "Swaziland Lilangeni" },
          { code: "THB", name: "Thailand Baht" },
          { code: "TJS", name: "Tajikistan Somoni" },
          { code: "TMT", name: "Turkmenistan Manat" },
          { code: "TND", name: "Tunisia Dinar" },
          { code: "TOP", name: "Tonga Pa'anga" },
          { code: "TRY", name: "Turkey Lira" },
          { code: "TTD", name: "Trinidad and Tobago Dollar" },
          { code: "TVD", name: "Tuvalu Dollar" },
          { code: "TWD", name: "Taiwan New Dollar" },
          { code: "TZS", name: "Tanzania Shilling" },
          { code: "UAH", name: "Ukraine Hryvnia" },
          { code: "UGX", name: "Uganda Shilling" },
          { code: "USD", name: "United States Dollar" },
          { code: "UYU", name: "Uruguay Peso" },
          { code: "UZS", name: "Uzbekistan Som" },
          { code: "VEF", name: "Venezuela Bolivar" },
          { code: "VND", name: "Viet Nam Dong" },
          { code: "VUV", name: "Vanuatu Vatu" },
          { code: "WST", name: "Samoa Tala" },
          { code: "XAF", name: "Communauté Financière Africaine (BEAC) CFA Franc BEAC" },
          { code: "XCD", name: "East Caribbean Dollar" },
          { code: "XDR", name: "International Monetary Fund (IMF) Special Drawing Rights" },
          { code: "XOF", name: "Communauté Financière Africaine (BCEAO) Franc" },
          { code: "XPF", name: "Comptoirs Français du Pacifique (CFP) Franc" },
          { code: "YER", name: "Yemen Rial" },
          { code: "ZAR", name: "South Africa Rand" },
          { code: "ZMW", name: "Zambia Kwacha" },
          { code: "ZWD", name: "Zimbabwe Dollar" }
        ],
        // return the names of all valide colors
        colorNames: [
          "AliceBlue",
          "Black",
          "Navy",
          "DarkBlue",
          "MediumBlue",
          "Blue",
          "DarkGreen",
          "Green",
          "Teal",
          "DarkCyan",
          "DeepSkyBlue",
          "DarkTurquoise",
          "MediumSpringGreen",
          "Lime",
          "SpringGreen",
          "Aqua",
          "Cyan",
          "MidnightBlue",
          "DodgerBlue",
          "LightSeaGreen",
          "ForestGreen",
          "SeaGreen",
          "DarkSlateGray",
          "LimeGreen",
          "MediumSeaGreen",
          "Turquoise",
          "RoyalBlue",
          "SteelBlue",
          "DarkSlateBlue",
          "MediumTurquoise",
          "Indigo",
          "DarkOliveGreen",
          "CadetBlue",
          "CornflowerBlue",
          "RebeccaPurple",
          "MediumAquaMarine",
          "DimGray",
          "SlateBlue",
          "OliveDrab",
          "SlateGray",
          "LightSlateGray",
          "MediumSlateBlue",
          "LawnGreen",
          "Chartreuse",
          "Aquamarine",
          "Maroon",
          "Purple",
          "Olive",
          "Gray",
          "SkyBlue",
          "LightSkyBlue",
          "BlueViolet",
          "DarkRed",
          "DarkMagenta",
          "SaddleBrown",
          "Ivory",
          "White",
          "DarkSeaGreen",
          "LightGreen",
          "MediumPurple",
          "DarkViolet",
          "PaleGreen",
          "DarkOrchid",
          "YellowGreen",
          "Sienna",
          "Brown",
          "DarkGray",
          "LightBlue",
          "GreenYellow",
          "PaleTurquoise",
          "LightSteelBlue",
          "PowderBlue",
          "FireBrick",
          "DarkGoldenRod",
          "MediumOrchid",
          "RosyBrown",
          "DarkKhaki",
          "Silver",
          "MediumVioletRed",
          "IndianRed",
          "Peru",
          "Chocolate",
          "Tan",
          "LightGray",
          "Thistle",
          "Orchid",
          "GoldenRod",
          "PaleVioletRed",
          "Crimson",
          "Gainsboro",
          "Plum",
          "BurlyWood",
          "LightCyan",
          "Lavender",
          "DarkSalmon",
          "Violet",
          "PaleGoldenRod",
          "LightCoral",
          "Khaki",
          "AliceBlue",
          "HoneyDew",
          "Azure",
          "SandyBrown",
          "Wheat",
          "Beige",
          "WhiteSmoke",
          "MintCream",
          "GhostWhite",
          "Salmon",
          "AntiqueWhite",
          "Linen",
          "LightGoldenRodYellow",
          "OldLace",
          "Red",
          "Fuchsia",
          "Magenta",
          "DeepPink",
          "OrangeRed",
          "Tomato",
          "HotPink",
          "Coral",
          "DarkOrange",
          "LightSalmon",
          "Orange",
          "LightPink",
          "Pink",
          "Gold",
          "PeachPuff",
          "NavajoWhite",
          "Moccasin",
          "Bisque",
          "MistyRose",
          "BlanchedAlmond",
          "PapayaWhip",
          "LavenderBlush",
          "SeaShell",
          "Cornsilk",
          "LemonChiffon",
          "FloralWhite",
          "Snow",
          "Yellow",
          "LightYellow"
        ],
        // Data taken from https://www.sec.gov/rules/other/4-460list.htm
        company: [
          "3Com Corp",
          "3M Company",
          "A.G. Edwards Inc.",
          "Abbott Laboratories",
          "Abercrombie & Fitch Co.",
          "ABM Industries Incorporated",
          "Ace Hardware Corporation",
          "ACT Manufacturing Inc.",
          "Acterna Corp.",
          "Adams Resources & Energy, Inc.",
          "ADC Telecommunications, Inc.",
          "Adelphia Communications Corporation",
          "Administaff, Inc.",
          "Adobe Systems Incorporated",
          "Adolph Coors Company",
          "Advance Auto Parts, Inc.",
          "Advanced Micro Devices, Inc.",
          "AdvancePCS, Inc.",
          "Advantica Restaurant Group, Inc.",
          "The AES Corporation",
          "Aetna Inc.",
          "Affiliated Computer Services, Inc.",
          "AFLAC Incorporated",
          "AGCO Corporation",
          "Agilent Technologies, Inc.",
          "Agway Inc.",
          "Apartment Investment and Management Company",
          "Air Products and Chemicals, Inc.",
          "Airborne, Inc.",
          "Airgas, Inc.",
          "AK Steel Holding Corporation",
          "Alaska Air Group, Inc.",
          "Alberto-Culver Company",
          "Albertson's, Inc.",
          "Alcoa Inc.",
          "Alleghany Corporation",
          "Allegheny Energy, Inc.",
          "Allegheny Technologies Incorporated",
          "Allergan, Inc.",
          "ALLETE, Inc.",
          "Alliant Energy Corporation",
          "Allied Waste Industries, Inc.",
          "Allmerica Financial Corporation",
          "The Allstate Corporation",
          "ALLTEL Corporation",
          "The Alpine Group, Inc.",
          "Amazon.com, Inc.",
          "AMC Entertainment Inc.",
          "American Power Conversion Corporation",
          "Amerada Hess Corporation",
          "AMERCO",
          "Ameren Corporation",
          "America West Holdings Corporation",
          "American Axle & Manufacturing Holdings, Inc.",
          "American Eagle Outfitters, Inc.",
          "American Electric Power Company, Inc.",
          "American Express Company",
          "American Financial Group, Inc.",
          "American Greetings Corporation",
          "American International Group, Inc.",
          "American Standard Companies Inc.",
          "American Water Works Company, Inc.",
          "AmerisourceBergen Corporation",
          "Ames Department Stores, Inc.",
          "Amgen Inc.",
          "Amkor Technology, Inc.",
          "AMR Corporation",
          "AmSouth Bancorp.",
          "Amtran, Inc.",
          "Anadarko Petroleum Corporation",
          "Analog Devices, Inc.",
          "Anheuser-Busch Companies, Inc.",
          "Anixter International Inc.",
          "AnnTaylor Inc.",
          "Anthem, Inc.",
          "AOL Time Warner Inc.",
          "Aon Corporation",
          "Apache Corporation",
          "Apple Computer, Inc.",
          "Applera Corporation",
          "Applied Industrial Technologies, Inc.",
          "Applied Materials, Inc.",
          "Aquila, Inc.",
          "ARAMARK Corporation",
          "Arch Coal, Inc.",
          "Archer Daniels Midland Company",
          "Arkansas Best Corporation",
          "Armstrong Holdings, Inc.",
          "Arrow Electronics, Inc.",
          "ArvinMeritor, Inc.",
          "Ashland Inc.",
          "Astoria Financial Corporation",
          "AT&T Corp.",
          "Atmel Corporation",
          "Atmos Energy Corporation",
          "Audiovox Corporation",
          "Autoliv, Inc.",
          "Automatic Data Processing, Inc.",
          "AutoNation, Inc.",
          "AutoZone, Inc.",
          "Avaya Inc.",
          "Avery Dennison Corporation",
          "Avista Corporation",
          "Avnet, Inc.",
          "Avon Products, Inc.",
          "Baker Hughes Incorporated",
          "Ball Corporation",
          "Bank of America Corporation",
          "The Bank of New York Company, Inc.",
          "Bank One Corporation",
          "Banknorth Group, Inc.",
          "Banta Corporation",
          "Barnes & Noble, Inc.",
          "Bausch & Lomb Incorporated",
          "Baxter International Inc.",
          "BB&T Corporation",
          "The Bear Stearns Companies Inc.",
          "Beazer Homes USA, Inc.",
          "Beckman Coulter, Inc.",
          "Becton, Dickinson and Company",
          "Bed Bath & Beyond Inc.",
          "Belk, Inc.",
          "Bell Microproducts Inc.",
          "BellSouth Corporation",
          "Belo Corp.",
          "Bemis Company, Inc.",
          "Benchmark Electronics, Inc.",
          "Berkshire Hathaway Inc.",
          "Best Buy Co., Inc.",
          "Bethlehem Steel Corporation",
          "Beverly Enterprises, Inc.",
          "Big Lots, Inc.",
          "BJ Services Company",
          "BJ's Wholesale Club, Inc.",
          "The Black & Decker Corporation",
          "Black Hills Corporation",
          "BMC Software, Inc.",
          "The Boeing Company",
          "Boise Cascade Corporation",
          "Borders Group, Inc.",
          "BorgWarner Inc.",
          "Boston Scientific Corporation",
          "Bowater Incorporated",
          "Briggs & Stratton Corporation",
          "Brightpoint, Inc.",
          "Brinker International, Inc.",
          "Bristol-Myers Squibb Company",
          "Broadwing, Inc.",
          "Brown Shoe Company, Inc.",
          "Brown-Forman Corporation",
          "Brunswick Corporation",
          "Budget Group, Inc.",
          "Burlington Coat Factory Warehouse Corporation",
          "Burlington Industries, Inc.",
          "Burlington Northern Santa Fe Corporation",
          "Burlington Resources Inc.",
          "C. H. Robinson Worldwide Inc.",
          "Cablevision Systems Corp",
          "Cabot Corp",
          "Cadence Design Systems, Inc.",
          "Calpine Corp.",
          "Campbell Soup Co.",
          "Capital One Financial Corp.",
          "Cardinal Health Inc.",
          "Caremark Rx Inc.",
          "Carlisle Cos. Inc.",
          "Carpenter Technology Corp.",
          "Casey's General Stores Inc.",
          "Caterpillar Inc.",
          "CBRL Group Inc.",
          "CDI Corp.",
          "CDW Computer Centers Inc.",
          "CellStar Corp.",
          "Cendant Corp",
          "Cenex Harvest States Cooperatives",
          "Centex Corp.",
          "CenturyTel Inc.",
          "Ceridian Corp.",
          "CH2M Hill Cos. Ltd.",
          "Champion Enterprises Inc.",
          "Charles Schwab Corp.",
          "Charming Shoppes Inc.",
          "Charter Communications Inc.",
          "Charter One Financial Inc.",
          "ChevronTexaco Corp.",
          "Chiquita Brands International Inc.",
          "Chubb Corp",
          "Ciena Corp.",
          "Cigna Corp",
          "Cincinnati Financial Corp.",
          "Cinergy Corp.",
          "Cintas Corp.",
          "Circuit City Stores Inc.",
          "Cisco Systems Inc.",
          "Citigroup, Inc",
          "Citizens Communications Co.",
          "CKE Restaurants Inc.",
          "Clear Channel Communications Inc.",
          "The Clorox Co.",
          "CMGI Inc.",
          "CMS Energy Corp.",
          "CNF Inc.",
          "Coca-Cola Co.",
          "Coca-Cola Enterprises Inc.",
          "Colgate-Palmolive Co.",
          "Collins & Aikman Corp.",
          "Comcast Corp.",
          "Comdisco Inc.",
          "Comerica Inc.",
          "Comfort Systems USA Inc.",
          "Commercial Metals Co.",
          "Community Health Systems Inc.",
          "Compass Bancshares Inc",
          "Computer Associates International Inc.",
          "Computer Sciences Corp.",
          "Compuware Corp.",
          "Comverse Technology Inc.",
          "ConAgra Foods Inc.",
          "Concord EFS Inc.",
          "Conectiv, Inc",
          "Conoco Inc",
          "Conseco Inc.",
          "Consolidated Freightways Corp.",
          "Consolidated Edison Inc.",
          "Constellation Brands Inc.",
          "Constellation Emergy Group Inc.",
          "Continental Airlines Inc.",
          "Convergys Corp.",
          "Cooper Cameron Corp.",
          "Cooper Industries Ltd.",
          "Cooper Tire & Rubber Co.",
          "Corn Products International Inc.",
          "Corning Inc.",
          "Costco Wholesale Corp.",
          "Countrywide Credit Industries Inc.",
          "Coventry Health Care Inc.",
          "Cox Communications Inc.",
          "Crane Co.",
          "Crompton Corp.",
          "Crown Cork & Seal Co. Inc.",
          "CSK Auto Corp.",
          "CSX Corp.",
          "Cummins Inc.",
          "CVS Corp.",
          "Cytec Industries Inc.",
          "D&K Healthcare Resources, Inc.",
          "D.R. Horton Inc.",
          "Dana Corporation",
          "Danaher Corporation",
          "Darden Restaurants Inc.",
          "DaVita Inc.",
          "Dean Foods Company",
          "Deere & Company",
          "Del Monte Foods Co",
          "Dell Computer Corporation",
          "Delphi Corp.",
          "Delta Air Lines Inc.",
          "Deluxe Corporation",
          "Devon Energy Corporation",
          "Di Giorgio Corporation",
          "Dial Corporation",
          "Diebold Incorporated",
          "Dillard's Inc.",
          "DIMON Incorporated",
          "Dole Food Company, Inc.",
          "Dollar General Corporation",
          "Dollar Tree Stores, Inc.",
          "Dominion Resources, Inc.",
          "Domino's Pizza LLC",
          "Dover Corporation, Inc.",
          "Dow Chemical Company",
          "Dow Jones & Company, Inc.",
          "DPL Inc.",
          "DQE Inc.",
          "Dreyer's Grand Ice Cream, Inc.",
          "DST Systems, Inc.",
          "DTE Energy Co.",
          "E.I. Du Pont de Nemours and Company",
          "Duke Energy Corp",
          "Dun & Bradstreet Inc.",
          "DURA Automotive Systems Inc.",
          "DynCorp",
          "Dynegy Inc.",
          "E*Trade Group, Inc.",
          "E.W. Scripps Company",
          "Earthlink, Inc.",
          "Eastman Chemical Company",
          "Eastman Kodak Company",
          "Eaton Corporation",
          "Echostar Communications Corporation",
          "Ecolab Inc.",
          "Edison International",
          "EGL Inc.",
          "El Paso Corporation",
          "Electronic Arts Inc.",
          "Electronic Data Systems Corp.",
          "Eli Lilly and Company",
          "EMC Corporation",
          "Emcor Group Inc.",
          "Emerson Electric Co.",
          "Encompass Services Corporation",
          "Energizer Holdings Inc.",
          "Energy East Corporation",
          "Engelhard Corporation",
          "Enron Corp.",
          "Entergy Corporation",
          "Enterprise Products Partners L.P.",
          "EOG Resources, Inc.",
          "Equifax Inc.",
          "Equitable Resources Inc.",
          "Equity Office Properties Trust",
          "Equity Residential Properties Trust",
          "Estee Lauder Companies Inc.",
          "Exelon Corporation",
          "Exide Technologies",
          "Expeditors International of Washington Inc.",
          "Express Scripts Inc.",
          "ExxonMobil Corporation",
          "Fairchild Semiconductor International Inc.",
          "Family Dollar Stores Inc.",
          "Farmland Industries Inc.",
          "Federal Mogul Corp.",
          "Federated Department Stores Inc.",
          "Federal Express Corp.",
          "Felcor Lodging Trust Inc.",
          "Ferro Corp.",
          "Fidelity National Financial Inc.",
          "Fifth Third Bancorp",
          "First American Financial Corp.",
          "First Data Corp.",
          "First National of Nebraska Inc.",
          "First Tennessee National Corp.",
          "FirstEnergy Corp.",
          "Fiserv Inc.",
          "Fisher Scientific International Inc.",
          "FleetBoston Financial Co.",
          "Fleetwood Enterprises Inc.",
          "Fleming Companies Inc.",
          "Flowers Foods Inc.",
          "Flowserv Corp",
          "Fluor Corp",
          "FMC Corp",
          "Foamex International Inc",
          "Foot Locker Inc",
          "Footstar Inc.",
          "Ford Motor Co",
          "Forest Laboratories Inc.",
          "Fortune Brands Inc.",
          "Foster Wheeler Ltd.",
          "FPL Group Inc.",
          "Franklin Resources Inc.",
          "Freeport McMoran Copper & Gold Inc.",
          "Frontier Oil Corp",
          "Furniture Brands International Inc.",
          "Gannett Co., Inc.",
          "Gap Inc.",
          "Gateway Inc.",
          "GATX Corporation",
          "Gemstar-TV Guide International Inc.",
          "GenCorp Inc.",
          "General Cable Corporation",
          "General Dynamics Corporation",
          "General Electric Company",
          "General Mills Inc",
          "General Motors Corporation",
          "Genesis Health Ventures Inc.",
          "Gentek Inc.",
          "Gentiva Health Services Inc.",
          "Genuine Parts Company",
          "Genuity Inc.",
          "Genzyme Corporation",
          "Georgia Gulf Corporation",
          "Georgia-Pacific Corporation",
          "Gillette Company",
          "Gold Kist Inc.",
          "Golden State Bancorp Inc.",
          "Golden West Financial Corporation",
          "Goldman Sachs Group Inc.",
          "Goodrich Corporation",
          "The Goodyear Tire & Rubber Company",
          "Granite Construction Incorporated",
          "Graybar Electric Company Inc.",
          "Great Lakes Chemical Corporation",
          "Great Plains Energy Inc.",
          "GreenPoint Financial Corp.",
          "Greif Bros. Corporation",
          "Grey Global Group Inc.",
          "Group 1 Automotive Inc.",
          "Guidant Corporation",
          "H&R Block Inc.",
          "H.B. Fuller Company",
          "H.J. Heinz Company",
          "Halliburton Co.",
          "Harley-Davidson Inc.",
          "Harman International Industries Inc.",
          "Harrah's Entertainment Inc.",
          "Harris Corp.",
          "Harsco Corp.",
          "Hartford Financial Services Group Inc.",
          "Hasbro Inc.",
          "Hawaiian Electric Industries Inc.",
          "HCA Inc.",
          "Health Management Associates Inc.",
          "Health Net Inc.",
          "Healthsouth Corp",
          "Henry Schein Inc.",
          "Hercules Inc.",
          "Herman Miller Inc.",
          "Hershey Foods Corp.",
          "Hewlett-Packard Company",
          "Hibernia Corp.",
          "Hillenbrand Industries Inc.",
          "Hilton Hotels Corp.",
          "Hollywood Entertainment Corp.",
          "Home Depot Inc.",
          "Hon Industries Inc.",
          "Honeywell International Inc.",
          "Hormel Foods Corp.",
          "Host Marriott Corp.",
          "Household International Corp.",
          "Hovnanian Enterprises Inc.",
          "Hub Group Inc.",
          "Hubbell Inc.",
          "Hughes Supply Inc.",
          "Humana Inc.",
          "Huntington Bancshares Inc.",
          "Idacorp Inc.",
          "IDT Corporation",
          "IKON Office Solutions Inc.",
          "Illinois Tool Works Inc.",
          "IMC Global Inc.",
          "Imperial Sugar Company",
          "IMS Health Inc.",
          "Ingles Market Inc",
          "Ingram Micro Inc.",
          "Insight Enterprises Inc.",
          "Integrated Electrical Services Inc.",
          "Intel Corporation",
          "International Paper Co.",
          "Interpublic Group of Companies Inc.",
          "Interstate Bakeries Corporation",
          "International Business Machines Corp.",
          "International Flavors & Fragrances Inc.",
          "International Multifoods Corporation",
          "Intuit Inc.",
          "IT Group Inc.",
          "ITT Industries Inc.",
          "Ivax Corp.",
          "J.B. Hunt Transport Services Inc.",
          "J.C. Penny Co.",
          "J.P. Morgan Chase & Co.",
          "Jabil Circuit Inc.",
          "Jack In The Box Inc.",
          "Jacobs Engineering Group Inc.",
          "JDS Uniphase Corp.",
          "Jefferson-Pilot Co.",
          "John Hancock Financial Services Inc.",
          "Johnson & Johnson",
          "Johnson Controls Inc.",
          "Jones Apparel Group Inc.",
          "KB Home",
          "Kellogg Company",
          "Kellwood Company",
          "Kelly Services Inc.",
          "Kemet Corp.",
          "Kennametal Inc.",
          "Kerr-McGee Corporation",
          "KeyCorp",
          "KeySpan Corp.",
          "Kimball International Inc.",
          "Kimberly-Clark Corporation",
          "Kindred Healthcare Inc.",
          "KLA-Tencor Corporation",
          "K-Mart Corp.",
          "Knight-Ridder Inc.",
          "Kohl's Corp.",
          "KPMG Consulting Inc.",
          "Kroger Co.",
          "L-3 Communications Holdings Inc.",
          "Laboratory Corporation of America Holdings",
          "Lam Research Corporation",
          "LandAmerica Financial Group Inc.",
          "Lands' End Inc.",
          "Landstar System Inc.",
          "La-Z-Boy Inc.",
          "Lear Corporation",
          "Legg Mason Inc.",
          "Leggett & Platt Inc.",
          "Lehman Brothers Holdings Inc.",
          "Lennar Corporation",
          "Lennox International Inc.",
          "Level 3 Communications Inc.",
          "Levi Strauss & Co.",
          "Lexmark International Inc.",
          "Limited Inc.",
          "Lincoln National Corporation",
          "Linens 'n Things Inc.",
          "Lithia Motors Inc.",
          "Liz Claiborne Inc.",
          "Lockheed Martin Corporation",
          "Loews Corporation",
          "Longs Drug Stores Corporation",
          "Louisiana-Pacific Corporation",
          "Lowe's Companies Inc.",
          "LSI Logic Corporation",
          "The LTV Corporation",
          "The Lubrizol Corporation",
          "Lucent Technologies Inc.",
          "Lyondell Chemical Company",
          "M & T Bank Corporation",
          "Magellan Health Services Inc.",
          "Mail-Well Inc.",
          "Mandalay Resort Group",
          "Manor Care Inc.",
          "Manpower Inc.",
          "Marathon Oil Corporation",
          "Mariner Health Care Inc.",
          "Markel Corporation",
          "Marriott International Inc.",
          "Marsh & McLennan Companies Inc.",
          "Marsh Supermarkets Inc.",
          "Marshall & Ilsley Corporation",
          "Martin Marietta Materials Inc.",
          "Masco Corporation",
          "Massey Energy Company",
          "MasTec Inc.",
          "Mattel Inc.",
          "Maxim Integrated Products Inc.",
          "Maxtor Corporation",
          "Maxxam Inc.",
          "The May Department Stores Company",
          "Maytag Corporation",
          "MBNA Corporation",
          "McCormick & Company Incorporated",
          "McDonald's Corporation",
          "The McGraw-Hill Companies Inc.",
          "McKesson Corporation",
          "McLeodUSA Incorporated",
          "M.D.C. Holdings Inc.",
          "MDU Resources Group Inc.",
          "MeadWestvaco Corporation",
          "Medtronic Inc.",
          "Mellon Financial Corporation",
          "The Men's Wearhouse Inc.",
          "Merck & Co., Inc.",
          "Mercury General Corporation",
          "Merrill Lynch & Co. Inc.",
          "Metaldyne Corporation",
          "Metals USA Inc.",
          "MetLife Inc.",
          "Metris Companies Inc",
          "MGIC Investment Corporation",
          "MGM Mirage",
          "Michaels Stores Inc.",
          "Micron Technology Inc.",
          "Microsoft Corporation",
          "Milacron Inc.",
          "Millennium Chemicals Inc.",
          "Mirant Corporation",
          "Mohawk Industries Inc.",
          "Molex Incorporated",
          "The MONY Group Inc.",
          "Morgan Stanley Dean Witter & Co.",
          "Motorola Inc.",
          "MPS Group Inc.",
          "Murphy Oil Corporation",
          "Nabors Industries Inc",
          "Nacco Industries Inc",
          "Nash Finch Company",
          "National City Corp.",
          "National Commerce Financial Corporation",
          "National Fuel Gas Company",
          "National Oilwell Inc",
          "National Rural Utilities Cooperative Finance Corporation",
          "National Semiconductor Corporation",
          "National Service Industries Inc",
          "Navistar International Corporation",
          "NCR Corporation",
          "The Neiman Marcus Group Inc.",
          "New Jersey Resources Corporation",
          "New York Times Company",
          "Newell Rubbermaid Inc",
          "Newmont Mining Corporation",
          "Nextel Communications Inc",
          "Nicor Inc",
          "Nike Inc",
          "NiSource Inc",
          "Noble Energy Inc",
          "Nordstrom Inc",
          "Norfolk Southern Corporation",
          "Nortek Inc",
          "North Fork Bancorporation Inc",
          "Northeast Utilities System",
          "Northern Trust Corporation",
          "Northrop Grumman Corporation",
          "NorthWestern Corporation",
          "Novellus Systems Inc",
          "NSTAR",
          "NTL Incorporated",
          "Nucor Corp",
          "Nvidia Corp",
          "NVR Inc",
          "Northwest Airlines Corp",
          "Occidental Petroleum Corp",
          "Ocean Energy Inc",
          "Office Depot Inc.",
          "OfficeMax Inc",
          "OGE Energy Corp",
          "Oglethorpe Power Corp.",
          "Ohio Casualty Corp.",
          "Old Republic International Corp.",
          "Olin Corp.",
          "OM Group Inc",
          "Omnicare Inc",
          "Omnicom Group",
          "On Semiconductor Corp",
          "ONEOK Inc",
          "Oracle Corp",
          "Oshkosh Truck Corp",
          "Outback Steakhouse Inc.",
          "Owens & Minor Inc.",
          "Owens Corning",
          "Owens-Illinois Inc",
          "Oxford Health Plans Inc",
          "Paccar Inc",
          "PacifiCare Health Systems Inc",
          "Packaging Corp. of America",
          "Pactiv Corp",
          "Pall Corp",
          "Pantry Inc",
          "Park Place Entertainment Corp",
          "Parker Hannifin Corp.",
          "Pathmark Stores Inc.",
          "Paychex Inc",
          "Payless Shoesource Inc",
          "Penn Traffic Co.",
          "Pennzoil-Quaker State Company",
          "Pentair Inc",
          "Peoples Energy Corp.",
          "PeopleSoft Inc",
          "Pep Boys Manny, Moe & Jack",
          "Potomac Electric Power Co.",
          "Pepsi Bottling Group Inc.",
          "PepsiAmericas Inc.",
          "PepsiCo Inc.",
          "Performance Food Group Co.",
          "Perini Corp",
          "PerkinElmer Inc",
          "Perot Systems Corp",
          "Petco Animal Supplies Inc.",
          "Peter Kiewit Sons', Inc.",
          "PETsMART Inc",
          "Pfizer Inc",
          "Pacific Gas & Electric Corp.",
          "Pharmacia Corp",
          "Phar Mor Inc.",
          "Phelps Dodge Corp.",
          "Philip Morris Companies Inc.",
          "Phillips Petroleum Co",
          "Phillips Van Heusen Corp.",
          "Phoenix Companies Inc",
          "Pier 1 Imports Inc.",
          "Pilgrim's Pride Corporation",
          "Pinnacle West Capital Corp",
          "Pioneer-Standard Electronics Inc.",
          "Pitney Bowes Inc.",
          "Pittston Brinks Group",
          "Plains All American Pipeline LP",
          "PNC Financial Services Group Inc.",
          "PNM Resources Inc",
          "Polaris Industries Inc.",
          "Polo Ralph Lauren Corp",
          "PolyOne Corp",
          "Popular Inc",
          "Potlatch Corp",
          "PPG Industries Inc",
          "PPL Corp",
          "Praxair Inc",
          "Precision Castparts Corp",
          "Premcor Inc.",
          "Pride International Inc",
          "Primedia Inc",
          "Principal Financial Group Inc.",
          "Procter & Gamble Co.",
          "Pro-Fac Cooperative Inc.",
          "Progress Energy Inc",
          "Progressive Corporation",
          "Protective Life Corp",
          "Provident Financial Group",
          "Providian Financial Corp.",
          "Prudential Financial Inc.",
          "PSS World Medical Inc",
          "Public Service Enterprise Group Inc.",
          "Publix Super Markets Inc.",
          "Puget Energy Inc.",
          "Pulte Homes Inc",
          "Qualcomm Inc",
          "Quanta Services Inc.",
          "Quantum Corp",
          "Quest Diagnostics Inc.",
          "Questar Corp",
          "Quintiles Transnational",
          "Qwest Communications Intl Inc",
          "R.J. Reynolds Tobacco Company",
          "R.R. Donnelley & Sons Company",
          "Radio Shack Corporation",
          "Raymond James Financial Inc.",
          "Raytheon Company",
          "Reader's Digest Association Inc.",
          "Reebok International Ltd.",
          "Regions Financial Corp.",
          "Regis Corporation",
          "Reliance Steel & Aluminum Co.",
          "Reliant Energy Inc.",
          "Rent A Center Inc",
          "Republic Services Inc",
          "Revlon Inc",
          "RGS Energy Group Inc",
          "Rite Aid Corp",
          "Riverwood Holding Inc.",
          "RoadwayCorp",
          "Robert Half International Inc.",
          "Rock-Tenn Co",
          "Rockwell Automation Inc",
          "Rockwell Collins Inc",
          "Rohm & Haas Co.",
          "Ross Stores Inc",
          "RPM Inc.",
          "Ruddick Corp",
          "Ryder System Inc",
          "Ryerson Tull Inc",
          "Ryland Group Inc.",
          "Sabre Holdings Corp",
          "Safeco Corp",
          "Safeguard Scientifics Inc.",
          "Safeway Inc",
          "Saks Inc",
          "Sanmina-SCI Inc",
          "Sara Lee Corp",
          "SBC Communications Inc",
          "Scana Corp.",
          "Schering-Plough Corp",
          "Scholastic Corp",
          "SCI Systems Onc.",
          "Science Applications Intl. Inc.",
          "Scientific-Atlanta Inc",
          "Scotts Company",
          "Seaboard Corp",
          "Sealed Air Corp",
          "Sears Roebuck & Co",
          "Sempra Energy",
          "Sequa Corp",
          "Service Corp. International",
          "ServiceMaster Co",
          "Shaw Group Inc",
          "Sherwin-Williams Company",
          "Shopko Stores Inc",
          "Siebel Systems Inc",
          "Sierra Health Services Inc",
          "Sierra Pacific Resources",
          "Silgan Holdings Inc.",
          "Silicon Graphics Inc",
          "Simon Property Group Inc",
          "SLM Corporation",
          "Smith International Inc",
          "Smithfield Foods Inc",
          "Smurfit-Stone Container Corp",
          "Snap-On Inc",
          "Solectron Corp",
          "Solutia Inc",
          "Sonic Automotive Inc.",
          "Sonoco Products Co.",
          "Southern Company",
          "Southern Union Company",
          "SouthTrust Corp.",
          "Southwest Airlines Co",
          "Southwest Gas Corp",
          "Sovereign Bancorp Inc.",
          "Spartan Stores Inc",
          "Spherion Corp",
          "Sports Authority Inc",
          "Sprint Corp.",
          "SPX Corp",
          "St. Jude Medical Inc",
          "St. Paul Cos.",
          "Staff Leasing Inc.",
          "StanCorp Financial Group Inc",
          "Standard Pacific Corp.",
          "Stanley Works",
          "Staples Inc",
          "Starbucks Corp",
          "Starwood Hotels & Resorts Worldwide Inc",
          "State Street Corp.",
          "Stater Bros. Holdings Inc.",
          "Steelcase Inc",
          "Stein Mart Inc",
          "Stewart & Stevenson Services Inc",
          "Stewart Information Services Corp",
          "Stilwell Financial Inc",
          "Storage Technology Corporation",
          "Stryker Corp",
          "Sun Healthcare Group Inc.",
          "Sun Microsystems Inc.",
          "SunGard Data Systems Inc.",
          "Sunoco Inc.",
          "SunTrust Banks Inc",
          "Supervalu Inc",
          "Swift Transportation, Co., Inc",
          "Symbol Technologies Inc",
          "Synovus Financial Corp.",
          "Sysco Corp",
          "Systemax Inc.",
          "Target Corp.",
          "Tech Data Corporation",
          "TECO Energy Inc",
          "Tecumseh Products Company",
          "Tektronix Inc",
          "Teleflex Incorporated",
          "Telephone & Data Systems Inc",
          "Tellabs Inc.",
          "Temple-Inland Inc",
          "Tenet Healthcare Corporation",
          "Tenneco Automotive Inc.",
          "Teradyne Inc",
          "Terex Corp",
          "Tesoro Petroleum Corp.",
          "Texas Industries Inc.",
          "Texas Instruments Incorporated",
          "Textron Inc",
          "Thermo Electron Corporation",
          "Thomas & Betts Corporation",
          "Tiffany & Co",
          "Timken Company",
          "TJX Companies Inc",
          "TMP Worldwide Inc",
          "Toll Brothers Inc",
          "Torchmark Corporation",
          "Toro Company",
          "Tower Automotive Inc.",
          "Toys 'R' Us Inc",
          "Trans World Entertainment Corp.",
          "TransMontaigne Inc",
          "Transocean Inc",
          "TravelCenters of America Inc.",
          "Triad Hospitals Inc",
          "Tribune Company",
          "Trigon Healthcare Inc.",
          "Trinity Industries Inc",
          "Trump Hotels & Casino Resorts Inc.",
          "TruServ Corporation",
          "TRW Inc",
          "TXU Corp",
          "Tyson Foods Inc",
          "U.S. Bancorp",
          "U.S. Industries Inc.",
          "UAL Corporation",
          "UGI Corporation",
          "Unified Western Grocers Inc",
          "Union Pacific Corporation",
          "Union Planters Corp",
          "Unisource Energy Corp",
          "Unisys Corporation",
          "United Auto Group Inc",
          "United Defense Industries Inc.",
          "United Parcel Service Inc",
          "United Rentals Inc",
          "United Stationers Inc",
          "United Technologies Corporation",
          "UnitedHealth Group Incorporated",
          "Unitrin Inc",
          "Universal Corporation",
          "Universal Forest Products Inc",
          "Universal Health Services Inc",
          "Unocal Corporation",
          "Unova Inc",
          "UnumProvident Corporation",
          "URS Corporation",
          "US Airways Group Inc",
          "US Oncology Inc",
          "USA Interactive",
          "USFreighways Corporation",
          "USG Corporation",
          "UST Inc",
          "Valero Energy Corporation",
          "Valspar Corporation",
          "Value City Department Stores Inc",
          "Varco International Inc",
          "Vectren Corporation",
          "Veritas Software Corporation",
          "Verizon Communications Inc",
          "VF Corporation",
          "Viacom Inc",
          "Viad Corp",
          "Viasystems Group Inc",
          "Vishay Intertechnology Inc",
          "Visteon Corporation",
          "Volt Information Sciences Inc",
          "Vulcan Materials Company",
          "W.R. Berkley Corporation",
          "W.R. Grace & Co",
          "W.W. Grainger Inc",
          "Wachovia Corporation",
          "Wakenhut Corporation",
          "Walgreen Co",
          "Wallace Computer Services Inc",
          "Wal-Mart Stores Inc",
          "Walt Disney Co",
          "Walter Industries Inc",
          "Washington Mutual Inc",
          "Washington Post Co.",
          "Waste Management Inc",
          "Watsco Inc",
          "Weatherford International Inc",
          "Weis Markets Inc.",
          "Wellpoint Health Networks Inc",
          "Wells Fargo & Company",
          "Wendy's International Inc",
          "Werner Enterprises Inc",
          "WESCO International Inc",
          "Western Digital Inc",
          "Western Gas Resources Inc",
          "WestPoint Stevens Inc",
          "Weyerhauser Company",
          "WGL Holdings Inc",
          "Whirlpool Corporation",
          "Whole Foods Market Inc",
          "Willamette Industries Inc.",
          "Williams Companies Inc",
          "Williams Sonoma Inc",
          "Winn Dixie Stores Inc",
          "Wisconsin Energy Corporation",
          "Wm Wrigley Jr Company",
          "World Fuel Services Corporation",
          "WorldCom Inc",
          "Worthington Industries Inc",
          "WPS Resources Corporation",
          "Wyeth",
          "Wyndham International Inc",
          "Xcel Energy Inc",
          "Xerox Corp",
          "Xilinx Inc",
          "XO Communications Inc",
          "Yellow Corporation",
          "York International Corp",
          "Yum Brands Inc.",
          "Zale Corporation",
          "Zions Bancorporation"
        ],
        fileExtension: {
          raster: ["bmp", "gif", "gpl", "ico", "jpeg", "psd", "png", "psp", "raw", "tiff"],
          vector: ["3dv", "amf", "awg", "ai", "cgm", "cdr", "cmx", "dxf", "e2d", "egt", "eps", "fs", "odg", "svg", "xar"],
          "3d": ["3dmf", "3dm", "3mf", "3ds", "an8", "aoi", "blend", "cal3d", "cob", "ctm", "iob", "jas", "max", "mb", "mdx", "obj", "x", "x3d"],
          document: ["doc", "docx", "dot", "html", "xml", "odt", "odm", "ott", "csv", "rtf", "tex", "xhtml", "xps"]
        },
        // Data taken from https://github.com/dmfilipenko/timezones.json/blob/master/timezones.json
        timezones: [
          {
            name: "Dateline Standard Time",
            abbr: "DST",
            offset: -12,
            isdst: !1,
            text: "(UTC-12:00) International Date Line West",
            utc: [
              "Etc/GMT+12"
            ]
          },
          {
            name: "UTC-11",
            abbr: "U",
            offset: -11,
            isdst: !1,
            text: "(UTC-11:00) Coordinated Universal Time-11",
            utc: [
              "Etc/GMT+11",
              "Pacific/Midway",
              "Pacific/Niue",
              "Pacific/Pago_Pago"
            ]
          },
          {
            name: "Hawaiian Standard Time",
            abbr: "HST",
            offset: -10,
            isdst: !1,
            text: "(UTC-10:00) Hawaii",
            utc: [
              "Etc/GMT+10",
              "Pacific/Honolulu",
              "Pacific/Johnston",
              "Pacific/Rarotonga",
              "Pacific/Tahiti"
            ]
          },
          {
            name: "Alaskan Standard Time",
            abbr: "AKDT",
            offset: -8,
            isdst: !0,
            text: "(UTC-09:00) Alaska",
            utc: [
              "America/Anchorage",
              "America/Juneau",
              "America/Nome",
              "America/Sitka",
              "America/Yakutat"
            ]
          },
          {
            name: "Pacific Standard Time (Mexico)",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-08:00) Baja California",
            utc: [
              "America/Santa_Isabel"
            ]
          },
          {
            name: "Pacific Daylight Time",
            abbr: "PDT",
            offset: -7,
            isdst: !0,
            text: "(UTC-07:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse"
            ]
          },
          {
            name: "Pacific Standard Time",
            abbr: "PST",
            offset: -8,
            isdst: !1,
            text: "(UTC-08:00) Pacific Time (US & Canada)",
            utc: [
              "America/Dawson",
              "America/Los_Angeles",
              "America/Tijuana",
              "America/Vancouver",
              "America/Whitehorse",
              "PST8PDT"
            ]
          },
          {
            name: "US Mountain Standard Time",
            abbr: "UMST",
            offset: -7,
            isdst: !1,
            text: "(UTC-07:00) Arizona",
            utc: [
              "America/Creston",
              "America/Dawson_Creek",
              "America/Hermosillo",
              "America/Phoenix",
              "Etc/GMT+7"
            ]
          },
          {
            name: "Mountain Standard Time (Mexico)",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
            utc: [
              "America/Chihuahua",
              "America/Mazatlan"
            ]
          },
          {
            name: "Mountain Standard Time",
            abbr: "MDT",
            offset: -6,
            isdst: !0,
            text: "(UTC-07:00) Mountain Time (US & Canada)",
            utc: [
              "America/Boise",
              "America/Cambridge_Bay",
              "America/Denver",
              "America/Edmonton",
              "America/Inuvik",
              "America/Ojinaga",
              "America/Yellowknife",
              "MST7MDT"
            ]
          },
          {
            name: "Central America Standard Time",
            abbr: "CAST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Central America",
            utc: [
              "America/Belize",
              "America/Costa_Rica",
              "America/El_Salvador",
              "America/Guatemala",
              "America/Managua",
              "America/Tegucigalpa",
              "Etc/GMT+6",
              "Pacific/Galapagos"
            ]
          },
          {
            name: "Central Standard Time",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Central Time (US & Canada)",
            utc: [
              "America/Chicago",
              "America/Indiana/Knox",
              "America/Indiana/Tell_City",
              "America/Matamoros",
              "America/Menominee",
              "America/North_Dakota/Beulah",
              "America/North_Dakota/Center",
              "America/North_Dakota/New_Salem",
              "America/Rainy_River",
              "America/Rankin_Inlet",
              "America/Resolute",
              "America/Winnipeg",
              "CST6CDT"
            ]
          },
          {
            name: "Central Standard Time (Mexico)",
            abbr: "CDT",
            offset: -5,
            isdst: !0,
            text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
            utc: [
              "America/Bahia_Banderas",
              "America/Cancun",
              "America/Merida",
              "America/Mexico_City",
              "America/Monterrey"
            ]
          },
          {
            name: "Canada Central Standard Time",
            abbr: "CCST",
            offset: -6,
            isdst: !1,
            text: "(UTC-06:00) Saskatchewan",
            utc: [
              "America/Regina",
              "America/Swift_Current"
            ]
          },
          {
            name: "SA Pacific Standard Time",
            abbr: "SPST",
            offset: -5,
            isdst: !1,
            text: "(UTC-05:00) Bogota, Lima, Quito",
            utc: [
              "America/Bogota",
              "America/Cayman",
              "America/Coral_Harbour",
              "America/Eirunepe",
              "America/Guayaquil",
              "America/Jamaica",
              "America/Lima",
              "America/Panama",
              "America/Rio_Branco",
              "Etc/GMT+5"
            ]
          },
          {
            name: "Eastern Standard Time",
            abbr: "EDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Eastern Time (US & Canada)",
            utc: [
              "America/Detroit",
              "America/Havana",
              "America/Indiana/Petersburg",
              "America/Indiana/Vincennes",
              "America/Indiana/Winamac",
              "America/Iqaluit",
              "America/Kentucky/Monticello",
              "America/Louisville",
              "America/Montreal",
              "America/Nassau",
              "America/New_York",
              "America/Nipigon",
              "America/Pangnirtung",
              "America/Port-au-Prince",
              "America/Thunder_Bay",
              "America/Toronto",
              "EST5EDT"
            ]
          },
          {
            name: "US Eastern Standard Time",
            abbr: "UEDT",
            offset: -4,
            isdst: !0,
            text: "(UTC-05:00) Indiana (East)",
            utc: [
              "America/Indiana/Marengo",
              "America/Indiana/Vevay",
              "America/Indianapolis"
            ]
          },
          {
            name: "Venezuela Standard Time",
            abbr: "VST",
            offset: -4.5,
            isdst: !1,
            text: "(UTC-04:30) Caracas",
            utc: [
              "America/Caracas"
            ]
          },
          {
            name: "Paraguay Standard Time",
            abbr: "PYT",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Asuncion",
            utc: [
              "America/Asuncion"
            ]
          },
          {
            name: "Atlantic Standard Time",
            abbr: "ADT",
            offset: -3,
            isdst: !0,
            text: "(UTC-04:00) Atlantic Time (Canada)",
            utc: [
              "America/Glace_Bay",
              "America/Goose_Bay",
              "America/Halifax",
              "America/Moncton",
              "America/Thule",
              "Atlantic/Bermuda"
            ]
          },
          {
            name: "Central Brazilian Standard Time",
            abbr: "CBST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Cuiaba",
            utc: [
              "America/Campo_Grande",
              "America/Cuiaba"
            ]
          },
          {
            name: "SA Western Standard Time",
            abbr: "SWST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
            utc: [
              "America/Anguilla",
              "America/Antigua",
              "America/Aruba",
              "America/Barbados",
              "America/Blanc-Sablon",
              "America/Boa_Vista",
              "America/Curacao",
              "America/Dominica",
              "America/Grand_Turk",
              "America/Grenada",
              "America/Guadeloupe",
              "America/Guyana",
              "America/Kralendijk",
              "America/La_Paz",
              "America/Lower_Princes",
              "America/Manaus",
              "America/Marigot",
              "America/Martinique",
              "America/Montserrat",
              "America/Port_of_Spain",
              "America/Porto_Velho",
              "America/Puerto_Rico",
              "America/Santo_Domingo",
              "America/St_Barthelemy",
              "America/St_Kitts",
              "America/St_Lucia",
              "America/St_Thomas",
              "America/St_Vincent",
              "America/Tortola",
              "Etc/GMT+4"
            ]
          },
          {
            name: "Pacific SA Standard Time",
            abbr: "PSST",
            offset: -4,
            isdst: !1,
            text: "(UTC-04:00) Santiago",
            utc: [
              "America/Santiago",
              "Antarctica/Palmer"
            ]
          },
          {
            name: "Newfoundland Standard Time",
            abbr: "NDT",
            offset: -2.5,
            isdst: !0,
            text: "(UTC-03:30) Newfoundland",
            utc: [
              "America/St_Johns"
            ]
          },
          {
            name: "E. South America Standard Time",
            abbr: "ESAST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Brasilia",
            utc: [
              "America/Sao_Paulo"
            ]
          },
          {
            name: "Argentina Standard Time",
            abbr: "AST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Buenos Aires",
            utc: [
              "America/Argentina/La_Rioja",
              "America/Argentina/Rio_Gallegos",
              "America/Argentina/Salta",
              "America/Argentina/San_Juan",
              "America/Argentina/San_Luis",
              "America/Argentina/Tucuman",
              "America/Argentina/Ushuaia",
              "America/Buenos_Aires",
              "America/Catamarca",
              "America/Cordoba",
              "America/Jujuy",
              "America/Mendoza"
            ]
          },
          {
            name: "SA Eastern Standard Time",
            abbr: "SEST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Cayenne, Fortaleza",
            utc: [
              "America/Araguaina",
              "America/Belem",
              "America/Cayenne",
              "America/Fortaleza",
              "America/Maceio",
              "America/Paramaribo",
              "America/Recife",
              "America/Santarem",
              "Antarctica/Rothera",
              "Atlantic/Stanley",
              "Etc/GMT+3"
            ]
          },
          {
            name: "Greenland Standard Time",
            abbr: "GDT",
            offset: -3,
            isdst: !0,
            text: "(UTC-03:00) Greenland",
            utc: [
              "America/Godthab"
            ]
          },
          {
            name: "Montevideo Standard Time",
            abbr: "MST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Montevideo",
            utc: [
              "America/Montevideo"
            ]
          },
          {
            name: "Bahia Standard Time",
            abbr: "BST",
            offset: -3,
            isdst: !1,
            text: "(UTC-03:00) Salvador",
            utc: [
              "America/Bahia"
            ]
          },
          {
            name: "UTC-02",
            abbr: "U",
            offset: -2,
            isdst: !1,
            text: "(UTC-02:00) Coordinated Universal Time-02",
            utc: [
              "America/Noronha",
              "Atlantic/South_Georgia",
              "Etc/GMT+2"
            ]
          },
          {
            name: "Mid-Atlantic Standard Time",
            abbr: "MDT",
            offset: -1,
            isdst: !0,
            text: "(UTC-02:00) Mid-Atlantic - Old",
            utc: []
          },
          {
            name: "Azores Standard Time",
            abbr: "ADT",
            offset: 0,
            isdst: !0,
            text: "(UTC-01:00) Azores",
            utc: [
              "America/Scoresbysund",
              "Atlantic/Azores"
            ]
          },
          {
            name: "Cape Verde Standard Time",
            abbr: "CVST",
            offset: -1,
            isdst: !1,
            text: "(UTC-01:00) Cape Verde Is.",
            utc: [
              "Atlantic/Cape_Verde",
              "Etc/GMT+1"
            ]
          },
          {
            name: "Morocco Standard Time",
            abbr: "MDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Casablanca",
            utc: [
              "Africa/Casablanca",
              "Africa/El_Aaiun"
            ]
          },
          {
            name: "UTC",
            abbr: "UTC",
            offset: 0,
            isdst: !1,
            text: "(UTC) Coordinated Universal Time",
            utc: [
              "America/Danmarkshavn",
              "Etc/GMT"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GMT",
            offset: 0,
            isdst: !1,
            text: "(UTC) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "British Summer Time",
            abbr: "BST",
            offset: 1,
            isdst: !0,
            text: "(UTC+01:00) Edinburgh, London",
            utc: [
              "Europe/Isle_of_Man",
              "Europe/Guernsey",
              "Europe/Jersey",
              "Europe/London"
            ]
          },
          {
            name: "GMT Standard Time",
            abbr: "GDT",
            offset: 1,
            isdst: !0,
            text: "(UTC) Dublin, Lisbon",
            utc: [
              "Atlantic/Canary",
              "Atlantic/Faeroe",
              "Atlantic/Madeira",
              "Europe/Dublin",
              "Europe/Lisbon"
            ]
          },
          {
            name: "Greenwich Standard Time",
            abbr: "GST",
            offset: 0,
            isdst: !1,
            text: "(UTC) Monrovia, Reykjavik",
            utc: [
              "Africa/Abidjan",
              "Africa/Accra",
              "Africa/Bamako",
              "Africa/Banjul",
              "Africa/Bissau",
              "Africa/Conakry",
              "Africa/Dakar",
              "Africa/Freetown",
              "Africa/Lome",
              "Africa/Monrovia",
              "Africa/Nouakchott",
              "Africa/Ouagadougou",
              "Africa/Sao_Tome",
              "Atlantic/Reykjavik",
              "Atlantic/St_Helena"
            ]
          },
          {
            name: "W. Europe Standard Time",
            abbr: "WEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            utc: [
              "Arctic/Longyearbyen",
              "Europe/Amsterdam",
              "Europe/Andorra",
              "Europe/Berlin",
              "Europe/Busingen",
              "Europe/Gibraltar",
              "Europe/Luxembourg",
              "Europe/Malta",
              "Europe/Monaco",
              "Europe/Oslo",
              "Europe/Rome",
              "Europe/San_Marino",
              "Europe/Stockholm",
              "Europe/Vaduz",
              "Europe/Vatican",
              "Europe/Vienna",
              "Europe/Zurich"
            ]
          },
          {
            name: "Central Europe Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            utc: [
              "Europe/Belgrade",
              "Europe/Bratislava",
              "Europe/Budapest",
              "Europe/Ljubljana",
              "Europe/Podgorica",
              "Europe/Prague",
              "Europe/Tirane"
            ]
          },
          {
            name: "Romance Standard Time",
            abbr: "RDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
            utc: [
              "Africa/Ceuta",
              "Europe/Brussels",
              "Europe/Copenhagen",
              "Europe/Madrid",
              "Europe/Paris"
            ]
          },
          {
            name: "Central European Standard Time",
            abbr: "CEDT",
            offset: 2,
            isdst: !0,
            text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            utc: [
              "Europe/Sarajevo",
              "Europe/Skopje",
              "Europe/Warsaw",
              "Europe/Zagreb"
            ]
          },
          {
            name: "W. Central Africa Standard Time",
            abbr: "WCAST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) West Central Africa",
            utc: [
              "Africa/Algiers",
              "Africa/Bangui",
              "Africa/Brazzaville",
              "Africa/Douala",
              "Africa/Kinshasa",
              "Africa/Lagos",
              "Africa/Libreville",
              "Africa/Luanda",
              "Africa/Malabo",
              "Africa/Ndjamena",
              "Africa/Niamey",
              "Africa/Porto-Novo",
              "Africa/Tunis",
              "Etc/GMT-1"
            ]
          },
          {
            name: "Namibia Standard Time",
            abbr: "NST",
            offset: 1,
            isdst: !1,
            text: "(UTC+01:00) Windhoek",
            utc: [
              "Africa/Windhoek"
            ]
          },
          {
            name: "GTB Standard Time",
            abbr: "GDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Athens, Bucharest",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau"
            ]
          },
          {
            name: "Middle East Standard Time",
            abbr: "MEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Beirut",
            utc: [
              "Asia/Beirut"
            ]
          },
          {
            name: "Egypt Standard Time",
            abbr: "EST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Cairo",
            utc: [
              "Africa/Cairo"
            ]
          },
          {
            name: "Syria Standard Time",
            abbr: "SDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Damascus",
            utc: [
              "Asia/Damascus"
            ]
          },
          {
            name: "E. Europe Standard Time",
            abbr: "EEDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) E. Europe",
            utc: [
              "Asia/Nicosia",
              "Europe/Athens",
              "Europe/Bucharest",
              "Europe/Chisinau",
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Nicosia",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "South Africa Standard Time",
            abbr: "SAST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Harare, Pretoria",
            utc: [
              "Africa/Blantyre",
              "Africa/Bujumbura",
              "Africa/Gaborone",
              "Africa/Harare",
              "Africa/Johannesburg",
              "Africa/Kigali",
              "Africa/Lubumbashi",
              "Africa/Lusaka",
              "Africa/Maputo",
              "Africa/Maseru",
              "Africa/Mbabane",
              "Etc/GMT-2"
            ]
          },
          {
            name: "FLE Standard Time",
            abbr: "FDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            utc: [
              "Europe/Helsinki",
              "Europe/Kiev",
              "Europe/Mariehamn",
              "Europe/Riga",
              "Europe/Sofia",
              "Europe/Tallinn",
              "Europe/Uzhgorod",
              "Europe/Vilnius",
              "Europe/Zaporozhye"
            ]
          },
          {
            name: "Turkey Standard Time",
            abbr: "TDT",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Istanbul",
            utc: [
              "Europe/Istanbul"
            ]
          },
          {
            name: "Israel Standard Time",
            abbr: "JDT",
            offset: 3,
            isdst: !0,
            text: "(UTC+02:00) Jerusalem",
            utc: [
              "Asia/Jerusalem"
            ]
          },
          {
            name: "Libya Standard Time",
            abbr: "LST",
            offset: 2,
            isdst: !1,
            text: "(UTC+02:00) Tripoli",
            utc: [
              "Africa/Tripoli"
            ]
          },
          {
            name: "Jordan Standard Time",
            abbr: "JST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Amman",
            utc: [
              "Asia/Amman"
            ]
          },
          {
            name: "Arabic Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Baghdad",
            utc: [
              "Asia/Baghdad"
            ]
          },
          {
            name: "Kaliningrad Standard Time",
            abbr: "KST",
            offset: 3,
            isdst: !1,
            text: "(UTC+02:00) Kaliningrad",
            utc: [
              "Europe/Kaliningrad"
            ]
          },
          {
            name: "Arab Standard Time",
            abbr: "AST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Kuwait, Riyadh",
            utc: [
              "Asia/Aden",
              "Asia/Bahrain",
              "Asia/Kuwait",
              "Asia/Qatar",
              "Asia/Riyadh"
            ]
          },
          {
            name: "E. Africa Standard Time",
            abbr: "EAST",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Nairobi",
            utc: [
              "Africa/Addis_Ababa",
              "Africa/Asmera",
              "Africa/Dar_es_Salaam",
              "Africa/Djibouti",
              "Africa/Juba",
              "Africa/Kampala",
              "Africa/Khartoum",
              "Africa/Mogadishu",
              "Africa/Nairobi",
              "Antarctica/Syowa",
              "Etc/GMT-3",
              "Indian/Antananarivo",
              "Indian/Comoro",
              "Indian/Mayotte"
            ]
          },
          {
            name: "Moscow Standard Time",
            abbr: "MSK",
            offset: 3,
            isdst: !1,
            text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
            utc: [
              "Europe/Kirov",
              "Europe/Moscow",
              "Europe/Simferopol",
              "Europe/Volgograd",
              "Europe/Minsk"
            ]
          },
          {
            name: "Samara Time",
            abbr: "SAMT",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
            utc: [
              "Europe/Astrakhan",
              "Europe/Samara",
              "Europe/Ulyanovsk"
            ]
          },
          {
            name: "Iran Standard Time",
            abbr: "IDT",
            offset: 4.5,
            isdst: !0,
            text: "(UTC+03:30) Tehran",
            utc: [
              "Asia/Tehran"
            ]
          },
          {
            name: "Arabian Standard Time",
            abbr: "AST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Abu Dhabi, Muscat",
            utc: [
              "Asia/Dubai",
              "Asia/Muscat",
              "Etc/GMT-4"
            ]
          },
          {
            name: "Azerbaijan Standard Time",
            abbr: "ADT",
            offset: 5,
            isdst: !0,
            text: "(UTC+04:00) Baku",
            utc: [
              "Asia/Baku"
            ]
          },
          {
            name: "Mauritius Standard Time",
            abbr: "MST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Port Louis",
            utc: [
              "Indian/Mahe",
              "Indian/Mauritius",
              "Indian/Reunion"
            ]
          },
          {
            name: "Georgian Standard Time",
            abbr: "GET",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Tbilisi",
            utc: [
              "Asia/Tbilisi"
            ]
          },
          {
            name: "Caucasus Standard Time",
            abbr: "CST",
            offset: 4,
            isdst: !1,
            text: "(UTC+04:00) Yerevan",
            utc: [
              "Asia/Yerevan"
            ]
          },
          {
            name: "Afghanistan Standard Time",
            abbr: "AST",
            offset: 4.5,
            isdst: !1,
            text: "(UTC+04:30) Kabul",
            utc: [
              "Asia/Kabul"
            ]
          },
          {
            name: "West Asia Standard Time",
            abbr: "WAST",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Ashgabat, Tashkent",
            utc: [
              "Antarctica/Mawson",
              "Asia/Aqtau",
              "Asia/Aqtobe",
              "Asia/Ashgabat",
              "Asia/Dushanbe",
              "Asia/Oral",
              "Asia/Samarkand",
              "Asia/Tashkent",
              "Etc/GMT-5",
              "Indian/Kerguelen",
              "Indian/Maldives"
            ]
          },
          {
            name: "Yekaterinburg Time",
            abbr: "YEKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Yekaterinburg",
            utc: [
              "Asia/Yekaterinburg"
            ]
          },
          {
            name: "Pakistan Standard Time",
            abbr: "PKT",
            offset: 5,
            isdst: !1,
            text: "(UTC+05:00) Islamabad, Karachi",
            utc: [
              "Asia/Karachi"
            ]
          },
          {
            name: "India Standard Time",
            abbr: "IST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            utc: [
              "Asia/Kolkata"
            ]
          },
          {
            name: "Sri Lanka Standard Time",
            abbr: "SLST",
            offset: 5.5,
            isdst: !1,
            text: "(UTC+05:30) Sri Jayawardenepura",
            utc: [
              "Asia/Colombo"
            ]
          },
          {
            name: "Nepal Standard Time",
            abbr: "NST",
            offset: 5.75,
            isdst: !1,
            text: "(UTC+05:45) Kathmandu",
            utc: [
              "Asia/Kathmandu"
            ]
          },
          {
            name: "Central Asia Standard Time",
            abbr: "CAST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Nur-Sultan (Astana)",
            utc: [
              "Antarctica/Vostok",
              "Asia/Almaty",
              "Asia/Bishkek",
              "Asia/Qyzylorda",
              "Asia/Urumqi",
              "Etc/GMT-6",
              "Indian/Chagos"
            ]
          },
          {
            name: "Bangladesh Standard Time",
            abbr: "BST",
            offset: 6,
            isdst: !1,
            text: "(UTC+06:00) Dhaka",
            utc: [
              "Asia/Dhaka",
              "Asia/Thimphu"
            ]
          },
          {
            name: "Myanmar Standard Time",
            abbr: "MST",
            offset: 6.5,
            isdst: !1,
            text: "(UTC+06:30) Yangon (Rangoon)",
            utc: [
              "Asia/Rangoon",
              "Indian/Cocos"
            ]
          },
          {
            name: "SE Asia Standard Time",
            abbr: "SAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
            utc: [
              "Antarctica/Davis",
              "Asia/Bangkok",
              "Asia/Hovd",
              "Asia/Jakarta",
              "Asia/Phnom_Penh",
              "Asia/Pontianak",
              "Asia/Saigon",
              "Asia/Vientiane",
              "Etc/GMT-7",
              "Indian/Christmas"
            ]
          },
          {
            name: "N. Central Asia Standard Time",
            abbr: "NCAST",
            offset: 7,
            isdst: !1,
            text: "(UTC+07:00) Novosibirsk",
            utc: [
              "Asia/Novokuznetsk",
              "Asia/Novosibirsk",
              "Asia/Omsk"
            ]
          },
          {
            name: "China Standard Time",
            abbr: "CST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            utc: [
              "Asia/Hong_Kong",
              "Asia/Macau",
              "Asia/Shanghai"
            ]
          },
          {
            name: "North Asia Standard Time",
            abbr: "NAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Krasnoyarsk",
            utc: [
              "Asia/Krasnoyarsk"
            ]
          },
          {
            name: "Singapore Standard Time",
            abbr: "MPST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Kuala Lumpur, Singapore",
            utc: [
              "Asia/Brunei",
              "Asia/Kuala_Lumpur",
              "Asia/Kuching",
              "Asia/Makassar",
              "Asia/Manila",
              "Asia/Singapore",
              "Etc/GMT-8"
            ]
          },
          {
            name: "W. Australia Standard Time",
            abbr: "WAST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Perth",
            utc: [
              "Antarctica/Casey",
              "Australia/Perth"
            ]
          },
          {
            name: "Taipei Standard Time",
            abbr: "TST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Taipei",
            utc: [
              "Asia/Taipei"
            ]
          },
          {
            name: "Ulaanbaatar Standard Time",
            abbr: "UST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Ulaanbaatar",
            utc: [
              "Asia/Choibalsan",
              "Asia/Ulaanbaatar"
            ]
          },
          {
            name: "North Asia East Standard Time",
            abbr: "NAEST",
            offset: 8,
            isdst: !1,
            text: "(UTC+08:00) Irkutsk",
            utc: [
              "Asia/Irkutsk"
            ]
          },
          {
            name: "Japan Standard Time",
            abbr: "JST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
            utc: [
              "Asia/Dili",
              "Asia/Jayapura",
              "Asia/Tokyo",
              "Etc/GMT-9",
              "Pacific/Palau"
            ]
          },
          {
            name: "Korea Standard Time",
            abbr: "KST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Seoul",
            utc: [
              "Asia/Pyongyang",
              "Asia/Seoul"
            ]
          },
          {
            name: "Cen. Australia Standard Time",
            abbr: "CAST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Adelaide",
            utc: [
              "Australia/Adelaide",
              "Australia/Broken_Hill"
            ]
          },
          {
            name: "AUS Central Standard Time",
            abbr: "ACST",
            offset: 9.5,
            isdst: !1,
            text: "(UTC+09:30) Darwin",
            utc: [
              "Australia/Darwin"
            ]
          },
          {
            name: "E. Australia Standard Time",
            abbr: "EAST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Brisbane",
            utc: [
              "Australia/Brisbane",
              "Australia/Lindeman"
            ]
          },
          {
            name: "AUS Eastern Standard Time",
            abbr: "AEST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Canberra, Melbourne, Sydney",
            utc: [
              "Australia/Melbourne",
              "Australia/Sydney"
            ]
          },
          {
            name: "West Pacific Standard Time",
            abbr: "WPST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Guam, Port Moresby",
            utc: [
              "Antarctica/DumontDUrville",
              "Etc/GMT-10",
              "Pacific/Guam",
              "Pacific/Port_Moresby",
              "Pacific/Saipan",
              "Pacific/Truk"
            ]
          },
          {
            name: "Tasmania Standard Time",
            abbr: "TST",
            offset: 10,
            isdst: !1,
            text: "(UTC+10:00) Hobart",
            utc: [
              "Australia/Currie",
              "Australia/Hobart"
            ]
          },
          {
            name: "Yakutsk Standard Time",
            abbr: "YST",
            offset: 9,
            isdst: !1,
            text: "(UTC+09:00) Yakutsk",
            utc: [
              "Asia/Chita",
              "Asia/Khandyga",
              "Asia/Yakutsk"
            ]
          },
          {
            name: "Central Pacific Standard Time",
            abbr: "CPST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Solomon Is., New Caledonia",
            utc: [
              "Antarctica/Macquarie",
              "Etc/GMT-11",
              "Pacific/Efate",
              "Pacific/Guadalcanal",
              "Pacific/Kosrae",
              "Pacific/Noumea",
              "Pacific/Ponape"
            ]
          },
          {
            name: "Vladivostok Standard Time",
            abbr: "VST",
            offset: 11,
            isdst: !1,
            text: "(UTC+11:00) Vladivostok",
            utc: [
              "Asia/Sakhalin",
              "Asia/Ust-Nera",
              "Asia/Vladivostok"
            ]
          },
          {
            name: "New Zealand Standard Time",
            abbr: "NZST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Auckland, Wellington",
            utc: [
              "Antarctica/McMurdo",
              "Pacific/Auckland"
            ]
          },
          {
            name: "UTC+12",
            abbr: "U",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Coordinated Universal Time+12",
            utc: [
              "Etc/GMT-12",
              "Pacific/Funafuti",
              "Pacific/Kwajalein",
              "Pacific/Majuro",
              "Pacific/Nauru",
              "Pacific/Tarawa",
              "Pacific/Wake",
              "Pacific/Wallis"
            ]
          },
          {
            name: "Fiji Standard Time",
            abbr: "FST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Fiji",
            utc: [
              "Pacific/Fiji"
            ]
          },
          {
            name: "Magadan Standard Time",
            abbr: "MST",
            offset: 12,
            isdst: !1,
            text: "(UTC+12:00) Magadan",
            utc: [
              "Asia/Anadyr",
              "Asia/Kamchatka",
              "Asia/Magadan",
              "Asia/Srednekolymsk"
            ]
          },
          {
            name: "Kamchatka Standard Time",
            abbr: "KDT",
            offset: 13,
            isdst: !0,
            text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
            utc: [
              "Asia/Kamchatka"
            ]
          },
          {
            name: "Tonga Standard Time",
            abbr: "TST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Nuku'alofa",
            utc: [
              "Etc/GMT-13",
              "Pacific/Enderbury",
              "Pacific/Fakaofo",
              "Pacific/Tongatapu"
            ]
          },
          {
            name: "Samoa Standard Time",
            abbr: "SST",
            offset: 13,
            isdst: !1,
            text: "(UTC+13:00) Samoa",
            utc: [
              "Pacific/Apia"
            ]
          }
        ],
        //List source: http://answers.google.com/answers/threadview/id/589312.html
        profession: [
          "Airline Pilot",
          "Academic Team",
          "Accountant",
          "Account Executive",
          "Actor",
          "Actuary",
          "Acquisition Analyst",
          "Administrative Asst.",
          "Administrative Analyst",
          "Administrator",
          "Advertising Director",
          "Aerospace Engineer",
          "Agent",
          "Agricultural Inspector",
          "Agricultural Scientist",
          "Air Traffic Controller",
          "Animal Trainer",
          "Anthropologist",
          "Appraiser",
          "Architect",
          "Art Director",
          "Artist",
          "Astronomer",
          "Athletic Coach",
          "Auditor",
          "Author",
          "Baker",
          "Banker",
          "Bankruptcy Attorney",
          "Benefits Manager",
          "Biologist",
          "Bio-feedback Specialist",
          "Biomedical Engineer",
          "Biotechnical Researcher",
          "Broadcaster",
          "Broker",
          "Building Manager",
          "Building Contractor",
          "Building Inspector",
          "Business Analyst",
          "Business Planner",
          "Business Manager",
          "Buyer",
          "Call Center Manager",
          "Career Counselor",
          "Cash Manager",
          "Ceramic Engineer",
          "Chief Executive Officer",
          "Chief Operation Officer",
          "Chef",
          "Chemical Engineer",
          "Chemist",
          "Child Care Manager",
          "Chief Medical Officer",
          "Chiropractor",
          "Cinematographer",
          "City Housing Manager",
          "City Manager",
          "Civil Engineer",
          "Claims Manager",
          "Clinical Research Assistant",
          "Collections Manager",
          "Compliance Manager",
          "Comptroller",
          "Computer Manager",
          "Commercial Artist",
          "Communications Affairs Director",
          "Communications Director",
          "Communications Engineer",
          "Compensation Analyst",
          "Computer Programmer",
          "Computer Ops. Manager",
          "Computer Engineer",
          "Computer Operator",
          "Computer Graphics Specialist",
          "Construction Engineer",
          "Construction Manager",
          "Consultant",
          "Consumer Relations Manager",
          "Contract Administrator",
          "Copyright Attorney",
          "Copywriter",
          "Corporate Planner",
          "Corrections Officer",
          "Cosmetologist",
          "Credit Analyst",
          "Cruise Director",
          "Chief Information Officer",
          "Chief Technology Officer",
          "Customer Service Manager",
          "Cryptologist",
          "Dancer",
          "Data Security Manager",
          "Database Manager",
          "Day Care Instructor",
          "Dentist",
          "Designer",
          "Design Engineer",
          "Desktop Publisher",
          "Developer",
          "Development Officer",
          "Diamond Merchant",
          "Dietitian",
          "Direct Marketer",
          "Director",
          "Distribution Manager",
          "Diversity Manager",
          "Economist",
          "EEO Compliance Manager",
          "Editor",
          "Education Adminator",
          "Electrical Engineer",
          "Electro Optical Engineer",
          "Electronics Engineer",
          "Embassy Management",
          "Employment Agent",
          "Engineer Technician",
          "Entrepreneur",
          "Environmental Analyst",
          "Environmental Attorney",
          "Environmental Engineer",
          "Environmental Specialist",
          "Escrow Officer",
          "Estimator",
          "Executive Assistant",
          "Executive Director",
          "Executive Recruiter",
          "Facilities Manager",
          "Family Counselor",
          "Fashion Events Manager",
          "Fashion Merchandiser",
          "Fast Food Manager",
          "Film Producer",
          "Film Production Assistant",
          "Financial Analyst",
          "Financial Planner",
          "Financier",
          "Fine Artist",
          "Wildlife Specialist",
          "Fitness Consultant",
          "Flight Attendant",
          "Flight Engineer",
          "Floral Designer",
          "Food & Beverage Director",
          "Food Service Manager",
          "Forestry Technician",
          "Franchise Management",
          "Franchise Sales",
          "Fraud Investigator",
          "Freelance Writer",
          "Fund Raiser",
          "General Manager",
          "Geologist",
          "General Counsel",
          "Geriatric Specialist",
          "Gerontologist",
          "Glamour Photographer",
          "Golf Club Manager",
          "Gourmet Chef",
          "Graphic Designer",
          "Grounds Keeper",
          "Hazardous Waste Manager",
          "Health Care Manager",
          "Health Therapist",
          "Health Service Administrator",
          "Hearing Officer",
          "Home Economist",
          "Horticulturist",
          "Hospital Administrator",
          "Hotel Manager",
          "Human Resources Manager",
          "Importer",
          "Industrial Designer",
          "Industrial Engineer",
          "Information Director",
          "Inside Sales",
          "Insurance Adjuster",
          "Interior Decorator",
          "Internal Controls Director",
          "International Acct.",
          "International Courier",
          "International Lawyer",
          "Interpreter",
          "Investigator",
          "Investment Banker",
          "Investment Manager",
          "IT Architect",
          "IT Project Manager",
          "IT Systems Analyst",
          "Jeweler",
          "Joint Venture Manager",
          "Journalist",
          "Labor Negotiator",
          "Labor Organizer",
          "Labor Relations Manager",
          "Lab Services Director",
          "Lab Technician",
          "Land Developer",
          "Landscape Architect",
          "Law Enforcement Officer",
          "Lawyer",
          "Lead Software Engineer",
          "Lead Software Test Engineer",
          "Leasing Manager",
          "Legal Secretary",
          "Library Manager",
          "Litigation Attorney",
          "Loan Officer",
          "Lobbyist",
          "Logistics Manager",
          "Maintenance Manager",
          "Management Consultant",
          "Managed Care Director",
          "Managing Partner",
          "Manufacturing Director",
          "Manpower Planner",
          "Marine Biologist",
          "Market Res. Analyst",
          "Marketing Director",
          "Materials Manager",
          "Mathematician",
          "Membership Chairman",
          "Mechanic",
          "Mechanical Engineer",
          "Media Buyer",
          "Medical Investor",
          "Medical Secretary",
          "Medical Technician",
          "Mental Health Counselor",
          "Merchandiser",
          "Metallurgical Engineering",
          "Meteorologist",
          "Microbiologist",
          "MIS Manager",
          "Motion Picture Director",
          "Multimedia Director",
          "Musician",
          "Network Administrator",
          "Network Specialist",
          "Network Operator",
          "New Product Manager",
          "Novelist",
          "Nuclear Engineer",
          "Nuclear Specialist",
          "Nutritionist",
          "Nursing Administrator",
          "Occupational Therapist",
          "Oceanographer",
          "Office Manager",
          "Operations Manager",
          "Operations Research Director",
          "Optical Technician",
          "Optometrist",
          "Organizational Development Manager",
          "Outplacement Specialist",
          "Paralegal",
          "Park Ranger",
          "Patent Attorney",
          "Payroll Specialist",
          "Personnel Specialist",
          "Petroleum Engineer",
          "Pharmacist",
          "Photographer",
          "Physical Therapist",
          "Physician",
          "Physician Assistant",
          "Physicist",
          "Planning Director",
          "Podiatrist",
          "Political Analyst",
          "Political Scientist",
          "Politician",
          "Portfolio Manager",
          "Preschool Management",
          "Preschool Teacher",
          "Principal",
          "Private Banker",
          "Private Investigator",
          "Probation Officer",
          "Process Engineer",
          "Producer",
          "Product Manager",
          "Product Engineer",
          "Production Engineer",
          "Production Planner",
          "Professional Athlete",
          "Professional Coach",
          "Professor",
          "Project Engineer",
          "Project Manager",
          "Program Manager",
          "Property Manager",
          "Public Administrator",
          "Public Safety Director",
          "PR Specialist",
          "Publisher",
          "Purchasing Agent",
          "Publishing Director",
          "Quality Assurance Specialist",
          "Quality Control Engineer",
          "Quality Control Inspector",
          "Radiology Manager",
          "Railroad Engineer",
          "Real Estate Broker",
          "Recreational Director",
          "Recruiter",
          "Redevelopment Specialist",
          "Regulatory Affairs Manager",
          "Registered Nurse",
          "Rehabilitation Counselor",
          "Relocation Manager",
          "Reporter",
          "Research Specialist",
          "Restaurant Manager",
          "Retail Store Manager",
          "Risk Analyst",
          "Safety Engineer",
          "Sales Engineer",
          "Sales Trainer",
          "Sales Promotion Manager",
          "Sales Representative",
          "Sales Manager",
          "Service Manager",
          "Sanitation Engineer",
          "Scientific Programmer",
          "Scientific Writer",
          "Securities Analyst",
          "Security Consultant",
          "Security Director",
          "Seminar Presenter",
          "Ship's Officer",
          "Singer",
          "Social Director",
          "Social Program Planner",
          "Social Research",
          "Social Scientist",
          "Social Worker",
          "Sociologist",
          "Software Developer",
          "Software Engineer",
          "Software Test Engineer",
          "Soil Scientist",
          "Special Events Manager",
          "Special Education Teacher",
          "Special Projects Director",
          "Speech Pathologist",
          "Speech Writer",
          "Sports Event Manager",
          "Statistician",
          "Store Manager",
          "Strategic Alliance Director",
          "Strategic Planning Director",
          "Stress Reduction Specialist",
          "Stockbroker",
          "Surveyor",
          "Structural Engineer",
          "Superintendent",
          "Supply Chain Director",
          "System Engineer",
          "Systems Analyst",
          "Systems Programmer",
          "System Administrator",
          "Tax Specialist",
          "Teacher",
          "Technical Support Specialist",
          "Technical Illustrator",
          "Technical Writer",
          "Technology Director",
          "Telecom Analyst",
          "Telemarketer",
          "Theatrical Director",
          "Title Examiner",
          "Tour Escort",
          "Tour Guide Director",
          "Traffic Manager",
          "Trainer Translator",
          "Transportation Manager",
          "Travel Agent",
          "Treasurer",
          "TV Programmer",
          "Underwriter",
          "Union Representative",
          "University Administrator",
          "University Dean",
          "Urban Planner",
          "Veterinarian",
          "Vendor Relations Director",
          "Viticulturist",
          "Warehouse Manager"
        ],
        animals: {
          //list of ocean animals comes from https://owlcation.com/stem/list-of-ocean-animals
          ocean: ["Acantharea", "Anemone", "Angelfish King", "Ahi Tuna", "Albacore", "American Oyster", "Anchovy", "Armored Snail", "Arctic Char", "Atlantic Bluefin Tuna", "Atlantic Cod", "Atlantic Goliath Grouper", "Atlantic Trumpetfish", "Atlantic Wolffish", "Baleen Whale", "Banded Butterflyfish", "Banded Coral Shrimp", "Banded Sea Krait", "Barnacle", "Barndoor Skate", "Barracuda", "Basking Shark", "Bass", "Beluga Whale", "Bluebanded Goby", "Bluehead Wrasse", "Bluefish", "Bluestreak Cleaner-Wrasse", "Blue Marlin", "Blue Shark", "Blue Spiny Lobster", "Blue Tang", "Blue Whale", "Broadclub Cuttlefish", "Bull Shark", "Chambered Nautilus", "Chilean Basket Star", "Chilean Jack Mackerel", "Chinook Salmon", "Christmas Tree Worm", "Clam", "Clown Anemonefish", "Clown Triggerfish", "Cod", "Coelacanth", "Cockscomb Cup Coral", "Common Fangtooth", "Conch", "Cookiecutter Shark", "Copepod", "Coral", "Corydoras", "Cownose Ray", "Crab", "Crown-of-Thorns Starfish", "Cushion Star", "Cuttlefish", "California Sea Otters", "Dolphin", "Dolphinfish", "Dory", "Devil Fish", "Dugong", "Dumbo Octopus", "Dungeness Crab", "Eccentric Sand Dollar", "Edible Sea Cucumber", "Eel", "Elephant Seal", "Elkhorn Coral", "Emperor Shrimp", "Estuarine Crocodile", "Fathead Sculpin", "Fiddler Crab", "Fin Whale", "Flameback", "Flamingo Tongue Snail", "Flashlight Fish", "Flatback Turtle", "Flatfish", "Flying Fish", "Flounder", "Fluke", "French Angelfish", "Frilled Shark", "Fugu (also called Pufferfish)", "Gar", "Geoduck", "Giant Barrel Sponge", "Giant Caribbean Sea Anemone", "Giant Clam", "Giant Isopod", "Giant Kingfish", "Giant Oarfish", "Giant Pacific Octopus", "Giant Pyrosome", "Giant Sea Star", "Giant Squid", "Glowing Sucker Octopus", "Giant Tube Worm", "Goblin Shark", "Goosefish", "Great White Shark", "Greenland Shark", "Grey Atlantic Seal", "Grouper", "Grunion", "Guineafowl Puffer", "Haddock", "Hake", "Halibut", "Hammerhead Shark", "Hapuka", "Harbor Porpoise", "Harbor Seal", "Hatchetfish", "Hawaiian Monk Seal", "Hawksbill Turtle", "Hector's Dolphin", "Hermit Crab", "Herring", "Hoki", "Horn Shark", "Horseshoe Crab", "Humpback Anglerfish", "Humpback Whale", "Icefish", "Imperator Angelfish", "Irukandji Jellyfish", "Isopod", "Ivory Bush Coral", "Japanese Spider Crab", "Jellyfish", "John Dory", "Juan Fernandez Fur Seal", "Killer Whale", "Kiwa Hirsuta", "Krill", "Lagoon Triggerfish", "Lamprey", "Leafy Seadragon", "Leopard Seal", "Limpet", "Ling", "Lionfish", "Lions Mane Jellyfish", "Lobe Coral", "Lobster", "Loggerhead Turtle", "Longnose Sawshark", "Longsnout Seahorse", "Lophelia Coral", "Marrus Orthocanna", "Manatee", "Manta Ray", "Marlin", "Megamouth Shark", "Mexican Lookdown", "Mimic Octopus", "Moon Jelly", "Mollusk", "Monkfish", "Moray Eel", "Mullet", "Mussel", "Megaladon", "Napoleon Wrasse", "Nassau Grouper", "Narwhal", "Nautilus", "Needlefish", "Northern Seahorse", "North Atlantic Right Whale", "Northern Red Snapper", "Norway Lobster", "Nudibranch", "Nurse Shark", "Oarfish", "Ocean Sunfish", "Oceanic Whitetip Shark", "Octopus", "Olive Sea Snake", "Orange Roughy", "Ostracod", "Otter", "Oyster", "Pacific Angelshark", "Pacific Blackdragon", "Pacific Halibut", "Pacific Sardine", "Pacific Sea Nettle Jellyfish", "Pacific White Sided Dolphin", "Pantropical Spotted Dolphin", "Patagonian Toothfish", "Peacock Mantis Shrimp", "Pelagic Thresher Shark", "Penguin", "Peruvian Anchoveta", "Pilchard", "Pink Salmon", "Pinniped", "Plankton", "Porpoise", "Polar Bear", "Portuguese Man o' War", "Pycnogonid Sea Spider", "Quahog", "Queen Angelfish", "Queen Conch", "Queen Parrotfish", "Queensland Grouper", "Ragfish", "Ratfish", "Rattail Fish", "Ray", "Red Drum", "Red King Crab", "Ringed Seal", "Risso's Dolphin", "Ross Seals", "Sablefish", "Salmon", "Sand Dollar", "Sandbar Shark", "Sawfish", "Sarcastic Fringehead", "Scalloped Hammerhead Shark", "Seahorse", "Sea Cucumber", "Sea Lion", "Sea Urchin", "Seal", "Shark", "Shortfin Mako Shark", "Shovelnose Guitarfish", "Shrimp", "Silverside Fish", "Skipjack Tuna", "Slender Snipe Eel", "Smalltooth Sawfish", "Smelts", "Sockeye Salmon", "Southern Stingray", "Sponge", "Spotted Porcupinefish", "Spotted Dolphin", "Spotted Eagle Ray", "Spotted Moray", "Squid", "Squidworm", "Starfish", "Stickleback", "Stonefish", "Stoplight Loosejaw", "Sturgeon", "Swordfish", "Tan Bristlemouth", "Tasseled Wobbegong", "Terrible Claw Lobster", "Threespot Damselfish", "Tiger Prawn", "Tiger Shark", "Tilefish", "Toadfish", "Tropical Two-Wing Flyfish", "Tuna", "Umbrella Squid", "Velvet Crab", "Venus Flytrap Sea Anemone", "Vigtorniella Worm", "Viperfish", "Vampire Squid", "Vaquita", "Wahoo", "Walrus", "West Indian Manatee", "Whale", "Whale Shark", "Whiptail Gulper", "White-Beaked Dolphin", "White-Ring Garden Eel", "White Shrimp", "Wobbegong", "Wrasse", "Wreckfish", "Xiphosura", "Yellowtail Damselfish", "Yelloweye Rockfish", "Yellow Cup Black Coral", "Yellow Tube Sponge", "Yellowfin Tuna", "Zebrashark", "Zooplankton"],
          //list of desert, grassland, and forest animals comes from http://www.skyenimals.com/
          desert: ["Aardwolf", "Addax", "African Wild Ass", "Ant", "Antelope", "Armadillo", "Baboon", "Badger", "Bat", "Bearded Dragon", "Beetle", "Bird", "Black-footed Cat", "Boa", "Brown Bear", "Bustard", "Butterfly", "Camel", "Caracal", "Caracara", "Caterpillar", "Centipede", "Cheetah", "Chipmunk", "Chuckwalla", "Climbing Mouse", "Coati", "Cobra", "Cotton Rat", "Cougar", "Courser", "Crane Fly", "Crow", "Dassie Rat", "Dove", "Dunnart", "Eagle", "Echidna", "Elephant", "Emu", "Falcon", "Fly", "Fox", "Frogmouth", "Gecko", "Geoffroy's Cat", "Gerbil", "Grasshopper", "Guanaco", "Gundi", "Hamster", "Hawk", "Hedgehog", "Hyena", "Hyrax", "Jackal", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kowari", "Kultarr", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Oryx", "Ostrich", "Owl", "Pronghorn", "Python", "Rabbit", "Raccoon", "Rattlesnake", "Rhinoceros", "Sand Cat", "Spectacled Bear", "Spiny Mouse", "Starling", "Stick Bug", "Tarantula", "Tit", "Toad", "Tortoise", "Tyrant Flycatcher", "Viper", "Vulture", "Waxwing", "Xerus", "Zebra"],
          grassland: ["Aardvark", "Aardwolf", "Accentor", "African Buffalo", "African Wild Dog", "Alpaca", "Anaconda", "Ant", "Anteater", "Antelope", "Armadillo", "Baboon", "Badger", "Bandicoot", "Barbet", "Bat", "Bee", "Bee-eater", "Beetle", "Bird", "Bison", "Black-footed Cat", "Black-footed Ferret", "Bluebird", "Boa", "Bowerbird", "Brown Bear", "Bush Dog", "Bushshrike", "Bustard", "Butterfly", "Buzzard", "Caracal", "Caracara", "Cardinal", "Caterpillar", "Cheetah", "Chipmunk", "Civet", "Climbing Mouse", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Common Genet", "Cotton Rat", "Cougar", "Courser", "Coyote", "Crane", "Crane Fly", "Cricket", "Crow", "Culpeo", "Death Adder", "Deer", "Deer Mouse", "Dingo", "Dinosaur", "Dove", "Drongo", "Duck", "Duiker", "Dunnart", "Eagle", "Echidna", "Elephant", "Elk", "Emu", "Falcon", "Finch", "Flea", "Fly", "Flying Frog", "Fox", "Frog", "Frogmouth", "Garter Snake", "Gazelle", "Gecko", "Geoffroy's Cat", "Gerbil", "Giant Tortoise", "Giraffe", "Grasshopper", "Grison", "Groundhog", "Grouse", "Guanaco", "Guinea Pig", "Hamster", "Harrier", "Hartebeest", "Hawk", "Hedgehog", "Helmetshrike", "Hippopotamus", "Hornbill", "Hyena", "Hyrax", "Impala", "Jackal", "Jaguar", "Jaguarundi", "Kangaroo", "Kangaroo Rat", "Kestrel", "Kultarr", "Ladybug", "Leopard", "Lion", "Macaw", "Meerkat", "Mouse", "Newt", "Oryx", "Ostrich", "Owl", "Pangolin", "Pheasant", "Prairie Dog", "Pronghorn", "Przewalski's Horse", "Python", "Quoll", "Rabbit", "Raven", "Rhinoceros", "Shelduck", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Tamandua", "Tasmanian Devil", "Thornbill", "Thrush", "Toad", "Tortoise"],
          forest: ["Agouti", "Anaconda", "Anoa", "Ant", "Anteater", "Antelope", "Armadillo", "Asian Black Bear", "Aye-aye", "Babirusa", "Baboon", "Badger", "Bandicoot", "Banteng", "Barbet", "Basilisk", "Bat", "Bearded Dragon", "Bee", "Bee-eater", "Beetle", "Bettong", "Binturong", "Bird-of-paradise", "Bongo", "Bowerbird", "Bulbul", "Bush Dog", "Bushbaby", "Bushshrike", "Butterfly", "Buzzard", "Caecilian", "Cardinal", "Cassowary", "Caterpillar", "Centipede", "Chameleon", "Chimpanzee", "Cicada", "Civet", "Clouded Leopard", "Coati", "Cobra", "Cockatoo", "Cockroach", "Colugo", "Cotinga", "Cotton Rat", "Cougar", "Crane Fly", "Cricket", "Crocodile", "Crow", "Cuckoo", "Cuscus", "Death Adder", "Deer", "Dhole", "Dingo", "Dinosaur", "Drongo", "Duck", "Duiker", "Eagle", "Echidna", "Elephant", "Finch", "Flat-headed Cat", "Flea", "Flowerpecker", "Fly", "Flying Frog", "Fossa", "Frog", "Frogmouth", "Gaur", "Gecko", "Gorilla", "Grison", "Hawaiian Honeycreeper", "Hawk", "Hedgehog", "Helmetshrike", "Hornbill", "Hyrax", "Iguana", "Jackal", "Jaguar", "Jaguarundi", "Kestrel", "Ladybug", "Lemur", "Leopard", "Lion", "Macaw", "Mandrill", "Margay", "Monkey", "Mouse", "Mouse Deer", "Newt", "Okapi", "Old World Flycatcher", "Orangutan", "Owl", "Pangolin", "Peafowl", "Pheasant", "Possum", "Python", "Quokka", "Rabbit", "Raccoon", "Red Panda", "Red River Hog", "Rhinoceros", "Sloth Bear", "Spectacled Bear", "Squirrel", "Starling", "Stick Bug", "Sun Bear", "Tamandua", "Tamarin", "Tapir", "Tarantula", "Thrush", "Tiger", "Tit", "Toad", "Tortoise", "Toucan", "Trogon", "Trumpeter", "Turaco", "Turtle", "Tyrant Flycatcher", "Viper", "Vulture", "Wallaby", "Warbler", "Wasp", "Waxwing", "Weaver", "Weaver-finch", "Whistler", "White-eye", "Whydah", "Woodswallow", "Worm", "Wren", "Xenops", "Yellowjacket", "Accentor", "African Buffalo", "American Black Bear", "Anole", "Bird", "Bison", "Boa", "Brown Bear", "Chipmunk", "Common Genet", "Copperhead", "Coyote", "Deer Mouse", "Dormouse", "Elk", "Emu", "Fisher", "Fox", "Garter Snake", "Giant Panda", "Giant Tortoise", "Groundhog", "Grouse", "Guanaco", "Himalayan Tahr", "Kangaroo", "Koala", "Numbat", "Quoll", "Raccoon dog", "Tasmanian Devil", "Thornbill", "Turkey", "Vole", "Weasel", "Wildcat", "Wolf", "Wombat", "Woodchuck", "Woodpecker"],
          //list of farm animals comes from https://www.buzzle.com/articles/farm-animals-list.html
          farm: ["Alpaca", "Buffalo", "Banteng", "Cow", "Cat", "Chicken", "Carp", "Camel", "Donkey", "Dog", "Duck", "Emu", "Goat", "Gayal", "Guinea", "Goose", "Horse", "Honey", "Llama", "Pig", "Pigeon", "Rhea", "Rabbit", "Sheep", "Silkworm", "Turkey", "Yak", "Zebu"],
          //list of pet animals comes from https://www.dogbreedinfo.com/pets/pet.htm
          pet: ["Bearded Dragon", "Birds", "Burro", "Cats", "Chameleons", "Chickens", "Chinchillas", "Chinese Water Dragon", "Cows", "Dogs", "Donkey", "Ducks", "Ferrets", "Fish", "Geckos", "Geese", "Gerbils", "Goats", "Guinea Fowl", "Guinea Pigs", "Hamsters", "Hedgehogs", "Horses", "Iguanas", "Llamas", "Lizards", "Mice", "Mule", "Peafowl", "Pigs and Hogs", "Pigeons", "Ponies", "Pot Bellied Pig", "Rabbits", "Rats", "Sheep", "Skinks", "Snakes", "Stick Insects", "Sugar Gliders", "Tarantula", "Turkeys", "Turtles"],
          //list of zoo animals comes from https://bronxzoo.com/animals
          zoo: ["Aardvark", "African Wild Dog", "Aldabra Tortoise", "American Alligator", "American Bison", "Amur Tiger", "Anaconda", "Andean Condor", "Asian Elephant", "Baby Doll Sheep", "Bald Eagle", "Barred Owl", "Blue Iguana", "Boer Goat", "California Sea Lion", "Caribbean Flamingo", "Chinchilla", "Collared Lemur", "Coquerel's Sifaka", "Cuban Amazon Parrot", "Ebony Langur", "Fennec Fox", "Fossa", "Gelada", "Giant Anteater", "Giraffe", "Gorilla", "Grizzly Bear", "Henkel's Leaf-tailed Gecko", "Indian Gharial", "Indian Rhinoceros", "King Cobra", "King Vulture", "Komodo Dragon", "Linne's Two-toed Sloth", "Lion", "Little Penguin", "Madagascar Tree Boa", "Magellanic Penguin", "Malayan Tapir", "Malayan Tiger", "Matschies Tree Kangaroo", "Mini Donkey", "Monarch Butterfly", "Nile crocodile", "North American Porcupine", "Nubian Ibex", "Okapi", "Poison Dart Frog", "Polar Bear", "Pygmy Marmoset", "Radiated Tortoise", "Red Panda", "Red Ruffed Lemur", "Ring-tailed Lemur", "Ring-tailed Mongoose", "Rock Hyrax", "Small Clawed Asian Otter", "Snow Leopard", "Snowy Owl", "Southern White-faced Owl", "Southern White Rhinocerous", "Squirrel Monkey", "Tufted Puffin", "White Cheeked Gibbon", "White-throated Bee Eater", "Zebra"]
        },
        primes: [
          // 1230 first primes, i.e. all primes up to the first one greater than 10000, inclusive.
          2,
          3,
          5,
          7,
          11,
          13,
          17,
          19,
          23,
          29,
          31,
          37,
          41,
          43,
          47,
          53,
          59,
          61,
          67,
          71,
          73,
          79,
          83,
          89,
          97,
          101,
          103,
          107,
          109,
          113,
          127,
          131,
          137,
          139,
          149,
          151,
          157,
          163,
          167,
          173,
          179,
          181,
          191,
          193,
          197,
          199,
          211,
          223,
          227,
          229,
          233,
          239,
          241,
          251,
          257,
          263,
          269,
          271,
          277,
          281,
          283,
          293,
          307,
          311,
          313,
          317,
          331,
          337,
          347,
          349,
          353,
          359,
          367,
          373,
          379,
          383,
          389,
          397,
          401,
          409,
          419,
          421,
          431,
          433,
          439,
          443,
          449,
          457,
          461,
          463,
          467,
          479,
          487,
          491,
          499,
          503,
          509,
          521,
          523,
          541,
          547,
          557,
          563,
          569,
          571,
          577,
          587,
          593,
          599,
          601,
          607,
          613,
          617,
          619,
          631,
          641,
          643,
          647,
          653,
          659,
          661,
          673,
          677,
          683,
          691,
          701,
          709,
          719,
          727,
          733,
          739,
          743,
          751,
          757,
          761,
          769,
          773,
          787,
          797,
          809,
          811,
          821,
          823,
          827,
          829,
          839,
          853,
          857,
          859,
          863,
          877,
          881,
          883,
          887,
          907,
          911,
          919,
          929,
          937,
          941,
          947,
          953,
          967,
          971,
          977,
          983,
          991,
          997,
          1009,
          1013,
          1019,
          1021,
          1031,
          1033,
          1039,
          1049,
          1051,
          1061,
          1063,
          1069,
          1087,
          1091,
          1093,
          1097,
          1103,
          1109,
          1117,
          1123,
          1129,
          1151,
          1153,
          1163,
          1171,
          1181,
          1187,
          1193,
          1201,
          1213,
          1217,
          1223,
          1229,
          1231,
          1237,
          1249,
          1259,
          1277,
          1279,
          1283,
          1289,
          1291,
          1297,
          1301,
          1303,
          1307,
          1319,
          1321,
          1327,
          1361,
          1367,
          1373,
          1381,
          1399,
          1409,
          1423,
          1427,
          1429,
          1433,
          1439,
          1447,
          1451,
          1453,
          1459,
          1471,
          1481,
          1483,
          1487,
          1489,
          1493,
          1499,
          1511,
          1523,
          1531,
          1543,
          1549,
          1553,
          1559,
          1567,
          1571,
          1579,
          1583,
          1597,
          1601,
          1607,
          1609,
          1613,
          1619,
          1621,
          1627,
          1637,
          1657,
          1663,
          1667,
          1669,
          1693,
          1697,
          1699,
          1709,
          1721,
          1723,
          1733,
          1741,
          1747,
          1753,
          1759,
          1777,
          1783,
          1787,
          1789,
          1801,
          1811,
          1823,
          1831,
          1847,
          1861,
          1867,
          1871,
          1873,
          1877,
          1879,
          1889,
          1901,
          1907,
          1913,
          1931,
          1933,
          1949,
          1951,
          1973,
          1979,
          1987,
          1993,
          1997,
          1999,
          2003,
          2011,
          2017,
          2027,
          2029,
          2039,
          2053,
          2063,
          2069,
          2081,
          2083,
          2087,
          2089,
          2099,
          2111,
          2113,
          2129,
          2131,
          2137,
          2141,
          2143,
          2153,
          2161,
          2179,
          2203,
          2207,
          2213,
          2221,
          2237,
          2239,
          2243,
          2251,
          2267,
          2269,
          2273,
          2281,
          2287,
          2293,
          2297,
          2309,
          2311,
          2333,
          2339,
          2341,
          2347,
          2351,
          2357,
          2371,
          2377,
          2381,
          2383,
          2389,
          2393,
          2399,
          2411,
          2417,
          2423,
          2437,
          2441,
          2447,
          2459,
          2467,
          2473,
          2477,
          2503,
          2521,
          2531,
          2539,
          2543,
          2549,
          2551,
          2557,
          2579,
          2591,
          2593,
          2609,
          2617,
          2621,
          2633,
          2647,
          2657,
          2659,
          2663,
          2671,
          2677,
          2683,
          2687,
          2689,
          2693,
          2699,
          2707,
          2711,
          2713,
          2719,
          2729,
          2731,
          2741,
          2749,
          2753,
          2767,
          2777,
          2789,
          2791,
          2797,
          2801,
          2803,
          2819,
          2833,
          2837,
          2843,
          2851,
          2857,
          2861,
          2879,
          2887,
          2897,
          2903,
          2909,
          2917,
          2927,
          2939,
          2953,
          2957,
          2963,
          2969,
          2971,
          2999,
          3001,
          3011,
          3019,
          3023,
          3037,
          3041,
          3049,
          3061,
          3067,
          3079,
          3083,
          3089,
          3109,
          3119,
          3121,
          3137,
          3163,
          3167,
          3169,
          3181,
          3187,
          3191,
          3203,
          3209,
          3217,
          3221,
          3229,
          3251,
          3253,
          3257,
          3259,
          3271,
          3299,
          3301,
          3307,
          3313,
          3319,
          3323,
          3329,
          3331,
          3343,
          3347,
          3359,
          3361,
          3371,
          3373,
          3389,
          3391,
          3407,
          3413,
          3433,
          3449,
          3457,
          3461,
          3463,
          3467,
          3469,
          3491,
          3499,
          3511,
          3517,
          3527,
          3529,
          3533,
          3539,
          3541,
          3547,
          3557,
          3559,
          3571,
          3581,
          3583,
          3593,
          3607,
          3613,
          3617,
          3623,
          3631,
          3637,
          3643,
          3659,
          3671,
          3673,
          3677,
          3691,
          3697,
          3701,
          3709,
          3719,
          3727,
          3733,
          3739,
          3761,
          3767,
          3769,
          3779,
          3793,
          3797,
          3803,
          3821,
          3823,
          3833,
          3847,
          3851,
          3853,
          3863,
          3877,
          3881,
          3889,
          3907,
          3911,
          3917,
          3919,
          3923,
          3929,
          3931,
          3943,
          3947,
          3967,
          3989,
          4001,
          4003,
          4007,
          4013,
          4019,
          4021,
          4027,
          4049,
          4051,
          4057,
          4073,
          4079,
          4091,
          4093,
          4099,
          4111,
          4127,
          4129,
          4133,
          4139,
          4153,
          4157,
          4159,
          4177,
          4201,
          4211,
          4217,
          4219,
          4229,
          4231,
          4241,
          4243,
          4253,
          4259,
          4261,
          4271,
          4273,
          4283,
          4289,
          4297,
          4327,
          4337,
          4339,
          4349,
          4357,
          4363,
          4373,
          4391,
          4397,
          4409,
          4421,
          4423,
          4441,
          4447,
          4451,
          4457,
          4463,
          4481,
          4483,
          4493,
          4507,
          4513,
          4517,
          4519,
          4523,
          4547,
          4549,
          4561,
          4567,
          4583,
          4591,
          4597,
          4603,
          4621,
          4637,
          4639,
          4643,
          4649,
          4651,
          4657,
          4663,
          4673,
          4679,
          4691,
          4703,
          4721,
          4723,
          4729,
          4733,
          4751,
          4759,
          4783,
          4787,
          4789,
          4793,
          4799,
          4801,
          4813,
          4817,
          4831,
          4861,
          4871,
          4877,
          4889,
          4903,
          4909,
          4919,
          4931,
          4933,
          4937,
          4943,
          4951,
          4957,
          4967,
          4969,
          4973,
          4987,
          4993,
          4999,
          5003,
          5009,
          5011,
          5021,
          5023,
          5039,
          5051,
          5059,
          5077,
          5081,
          5087,
          5099,
          5101,
          5107,
          5113,
          5119,
          5147,
          5153,
          5167,
          5171,
          5179,
          5189,
          5197,
          5209,
          5227,
          5231,
          5233,
          5237,
          5261,
          5273,
          5279,
          5281,
          5297,
          5303,
          5309,
          5323,
          5333,
          5347,
          5351,
          5381,
          5387,
          5393,
          5399,
          5407,
          5413,
          5417,
          5419,
          5431,
          5437,
          5441,
          5443,
          5449,
          5471,
          5477,
          5479,
          5483,
          5501,
          5503,
          5507,
          5519,
          5521,
          5527,
          5531,
          5557,
          5563,
          5569,
          5573,
          5581,
          5591,
          5623,
          5639,
          5641,
          5647,
          5651,
          5653,
          5657,
          5659,
          5669,
          5683,
          5689,
          5693,
          5701,
          5711,
          5717,
          5737,
          5741,
          5743,
          5749,
          5779,
          5783,
          5791,
          5801,
          5807,
          5813,
          5821,
          5827,
          5839,
          5843,
          5849,
          5851,
          5857,
          5861,
          5867,
          5869,
          5879,
          5881,
          5897,
          5903,
          5923,
          5927,
          5939,
          5953,
          5981,
          5987,
          6007,
          6011,
          6029,
          6037,
          6043,
          6047,
          6053,
          6067,
          6073,
          6079,
          6089,
          6091,
          6101,
          6113,
          6121,
          6131,
          6133,
          6143,
          6151,
          6163,
          6173,
          6197,
          6199,
          6203,
          6211,
          6217,
          6221,
          6229,
          6247,
          6257,
          6263,
          6269,
          6271,
          6277,
          6287,
          6299,
          6301,
          6311,
          6317,
          6323,
          6329,
          6337,
          6343,
          6353,
          6359,
          6361,
          6367,
          6373,
          6379,
          6389,
          6397,
          6421,
          6427,
          6449,
          6451,
          6469,
          6473,
          6481,
          6491,
          6521,
          6529,
          6547,
          6551,
          6553,
          6563,
          6569,
          6571,
          6577,
          6581,
          6599,
          6607,
          6619,
          6637,
          6653,
          6659,
          6661,
          6673,
          6679,
          6689,
          6691,
          6701,
          6703,
          6709,
          6719,
          6733,
          6737,
          6761,
          6763,
          6779,
          6781,
          6791,
          6793,
          6803,
          6823,
          6827,
          6829,
          6833,
          6841,
          6857,
          6863,
          6869,
          6871,
          6883,
          6899,
          6907,
          6911,
          6917,
          6947,
          6949,
          6959,
          6961,
          6967,
          6971,
          6977,
          6983,
          6991,
          6997,
          7001,
          7013,
          7019,
          7027,
          7039,
          7043,
          7057,
          7069,
          7079,
          7103,
          7109,
          7121,
          7127,
          7129,
          7151,
          7159,
          7177,
          7187,
          7193,
          7207,
          7211,
          7213,
          7219,
          7229,
          7237,
          7243,
          7247,
          7253,
          7283,
          7297,
          7307,
          7309,
          7321,
          7331,
          7333,
          7349,
          7351,
          7369,
          7393,
          7411,
          7417,
          7433,
          7451,
          7457,
          7459,
          7477,
          7481,
          7487,
          7489,
          7499,
          7507,
          7517,
          7523,
          7529,
          7537,
          7541,
          7547,
          7549,
          7559,
          7561,
          7573,
          7577,
          7583,
          7589,
          7591,
          7603,
          7607,
          7621,
          7639,
          7643,
          7649,
          7669,
          7673,
          7681,
          7687,
          7691,
          7699,
          7703,
          7717,
          7723,
          7727,
          7741,
          7753,
          7757,
          7759,
          7789,
          7793,
          7817,
          7823,
          7829,
          7841,
          7853,
          7867,
          7873,
          7877,
          7879,
          7883,
          7901,
          7907,
          7919,
          7927,
          7933,
          7937,
          7949,
          7951,
          7963,
          7993,
          8009,
          8011,
          8017,
          8039,
          8053,
          8059,
          8069,
          8081,
          8087,
          8089,
          8093,
          8101,
          8111,
          8117,
          8123,
          8147,
          8161,
          8167,
          8171,
          8179,
          8191,
          8209,
          8219,
          8221,
          8231,
          8233,
          8237,
          8243,
          8263,
          8269,
          8273,
          8287,
          8291,
          8293,
          8297,
          8311,
          8317,
          8329,
          8353,
          8363,
          8369,
          8377,
          8387,
          8389,
          8419,
          8423,
          8429,
          8431,
          8443,
          8447,
          8461,
          8467,
          8501,
          8513,
          8521,
          8527,
          8537,
          8539,
          8543,
          8563,
          8573,
          8581,
          8597,
          8599,
          8609,
          8623,
          8627,
          8629,
          8641,
          8647,
          8663,
          8669,
          8677,
          8681,
          8689,
          8693,
          8699,
          8707,
          8713,
          8719,
          8731,
          8737,
          8741,
          8747,
          8753,
          8761,
          8779,
          8783,
          8803,
          8807,
          8819,
          8821,
          8831,
          8837,
          8839,
          8849,
          8861,
          8863,
          8867,
          8887,
          8893,
          8923,
          8929,
          8933,
          8941,
          8951,
          8963,
          8969,
          8971,
          8999,
          9001,
          9007,
          9011,
          9013,
          9029,
          9041,
          9043,
          9049,
          9059,
          9067,
          9091,
          9103,
          9109,
          9127,
          9133,
          9137,
          9151,
          9157,
          9161,
          9173,
          9181,
          9187,
          9199,
          9203,
          9209,
          9221,
          9227,
          9239,
          9241,
          9257,
          9277,
          9281,
          9283,
          9293,
          9311,
          9319,
          9323,
          9337,
          9341,
          9343,
          9349,
          9371,
          9377,
          9391,
          9397,
          9403,
          9413,
          9419,
          9421,
          9431,
          9433,
          9437,
          9439,
          9461,
          9463,
          9467,
          9473,
          9479,
          9491,
          9497,
          9511,
          9521,
          9533,
          9539,
          9547,
          9551,
          9587,
          9601,
          9613,
          9619,
          9623,
          9629,
          9631,
          9643,
          9649,
          9661,
          9677,
          9679,
          9689,
          9697,
          9719,
          9721,
          9733,
          9739,
          9743,
          9749,
          9767,
          9769,
          9781,
          9787,
          9791,
          9803,
          9811,
          9817,
          9829,
          9833,
          9839,
          9851,
          9857,
          9859,
          9871,
          9883,
          9887,
          9901,
          9907,
          9923,
          9929,
          9931,
          9941,
          9949,
          9967,
          9973,
          10007
        ],
        emotions: [
          "love",
          "joy",
          "surprise",
          "anger",
          "sadness",
          "fear"
        ],
        music_genres: {
          general: [
            "Rock",
            "Pop",
            "Hip-Hop",
            "Jazz",
            "Classical",
            "Electronic",
            "Country",
            "R&B",
            "Reggae",
            "Blues",
            "Metal",
            "Folk",
            "Alternative",
            "Punk",
            "Disco",
            "Funk",
            "Techno",
            "Indie",
            "Gospel",
            "Dance",
            "Children's",
            "World"
          ],
          alternative: [
            "Art Punk",
            "Alternative Rock",
            "Britpunk",
            "College Rock",
            "Crossover Thrash",
            "Crust Punk",
            "Emo / Emocore",
            "Experimental Rock",
            "Folk Punk",
            "Goth / Gothic Rock",
            "Grunge",
            "Hardcore Punk",
            "Hard Rock",
            "Indie Rock",
            "Lo-fi",
            "Musique Concrète",
            "New Wave",
            "Progressive Rock",
            "Punk",
            "Shoegaze",
            "Steampunk"
          ],
          blues: [
            "Acoustic Blues",
            "African Blues",
            "Blues Rock",
            "Blues Shouter",
            "British Blues",
            "Canadian Blues",
            "Chicago Blues",
            "Classic Blues",
            "Classic Female Blues",
            "Contemporary Blues",
            "Country Blues",
            "Dark Blues",
            "Delta Blues",
            "Detroit Blues",
            "Doom Blues",
            "Electric Blues",
            "Folk Blues",
            "Gospel Blues",
            "Harmonica Blues",
            "Hill Country Blues",
            "Hokum Blues",
            "Jazz Blues",
            "Jump Blues",
            "Kansas City Blues",
            "Louisiana Blues",
            "Memphis Blues",
            "Modern Blues",
            "New Orlean Blues",
            "NY Blues",
            "Piano Blues",
            "Piedmont Blues",
            "Punk Blues",
            "Ragtime Blues",
            "Rhythm Blues",
            "Soul Blues",
            "St.Louis Blues",
            "Soul Blues",
            "Swamp Blues",
            "Texas Blues",
            "Urban Blues",
            "Vandeville",
            "West Coast Blues"
          ],
          "children's": [
            "Lullabies",
            "Sing - Along",
            "Stories"
          ],
          classical: [
            "Avant-Garde",
            "Ballet",
            "Baroque",
            "Cantata",
            "Chamber Music",
            "String Quartet",
            "Chant",
            "Choral",
            "Classical Crossover",
            "Concerto",
            "Concerto Grosso",
            "Contemporary Classical",
            "Early Music",
            "Expressionist",
            "High Classical",
            "Impressionist",
            "Mass Requiem",
            "Medieval",
            "Minimalism",
            "Modern Composition",
            "Modern Classical",
            "Opera",
            "Oratorio",
            "Orchestral",
            "Organum",
            "Renaissance",
            "Romantic (early period)",
            "Romantic (later period)",
            "Sonata",
            "Symphonic",
            "Symphony",
            "Twelve-tone",
            "Wedding Music"
          ],
          country: [
            "Alternative Country",
            "Americana",
            "Australian Country",
            "Bakersfield Sound",
            "Bluegrass",
            "Blues Country",
            "Cajun Fiddle Tunes",
            "Christian Country",
            "Classic Country",
            "Close Harmony",
            "Contemporary Bluegrass",
            "Contemporary Country",
            "Country Gospel",
            "Country Pop",
            "Country Rap",
            "Country Rock",
            "Country Soul",
            "Cowboy / Western",
            "Cowpunk",
            "Dansband",
            "Honky Tonk",
            "Franco-Country",
            "Gulf and Western",
            "Hellbilly Music",
            "Honky Tonk",
            "Instrumental Country",
            "Lubbock Sound",
            "Nashville Sound",
            "Neotraditional Country",
            "Outlaw Country",
            "Progressive",
            "Psychobilly / Punkabilly",
            "Red Dirt",
            "Sertanejo",
            "Texas County",
            "Traditional Bluegrass",
            "Traditional Country",
            "Truck-Driving Country",
            "Urban Cowboy",
            "Western Swing"
          ],
          dance: [
            "Club / Club Dance",
            "Breakcore",
            "Breakbeat / Breakstep",
            "Chillstep",
            "Deep House",
            "Dubstep",
            "Dancehall",
            "Electro House",
            "Electroswing",
            "Exercise",
            "Future Garage",
            "Garage",
            "Glitch Hop",
            "Glitch Pop",
            "Grime",
            "Hardcore",
            "Hard Dance",
            "Hi-NRG / Eurodance",
            "Horrorcore",
            "House",
            "Jackin House",
            "Jungle / Drum n bass",
            "Liquid Dub",
            "Regstep",
            "Speedcore",
            "Techno",
            "Trance",
            "Trap"
          ],
          electronic: [
            "2-Step",
            "8bit",
            "Ambient",
            "Asian Underground",
            "Bassline",
            "Chillwave",
            "Chiptune",
            "Crunk",
            "Downtempo",
            "Drum & Bass",
            "Hard Step",
            "Electro",
            "Electro-swing",
            "Electroacoustic",
            "Electronica",
            "Electronic Rock",
            "Eurodance",
            "Hardstyle",
            "Hi-Nrg",
            "IDM/Experimental",
            "Industrial",
            "Trip Hop",
            "Vaporwave",
            "UK Garage",
            "House",
            "Dubstep",
            "Deep House",
            "EDM",
            "Future Bass",
            "Psychedelic trance"
          ],
          jazz: [
            "Acid Jazz",
            "Afro-Cuban Jazz",
            "Avant-Garde Jazz",
            "Bebop",
            "Big Band",
            "Blue Note",
            "British Dance Band (Jazz)",
            "Cape Jazz",
            "Chamber Jazz",
            "Contemporary Jazz",
            "Continental Jazz",
            "Cool Jazz",
            "Crossover Jazz",
            "Dark Jazz",
            "Dixieland",
            "Early Jazz",
            "Electro Swing (Jazz)",
            "Ethio-jazz",
            "Ethno-Jazz",
            "European Free Jazz",
            "Free Funk (Avant-Garde / Funk Jazz)",
            "Free Jazz",
            "Fusion",
            "Gypsy Jazz",
            "Hard Bop",
            "Indo Jazz",
            "Jazz Blues",
            "Jazz-Funk (see Free Funk)",
            "Jazz-Fusion",
            "Jazz Rap",
            "Jazz Rock",
            "Kansas City Jazz",
            "Latin Jazz",
            "M-Base Jazz",
            "Mainstream Jazz",
            "Modal Jazz",
            "Neo-Bop",
            "Neo-Swing",
            "Nu Jazz",
            "Orchestral Jazz",
            "Post-Bop",
            "Punk Jazz",
            "Ragtime",
            "Ska Jazz",
            "Skiffle (also Folk)",
            "Smooth Jazz",
            "Soul Jazz",
            "Swing Jazz",
            "Straight-Ahead Jazz",
            "Trad Jazz",
            "Third Stream",
            "Jazz-Funk",
            "Free Jazz",
            "West Coast Jazz"
          ],
          metal: [
            "Heavy Metal",
            "Speed Metal",
            "Thrash Metal",
            "Power Metal",
            "Death Metal",
            "Black Metal",
            "Pagan Metal",
            "Viking Metal",
            "Folk Metal",
            "Symphonic Metal",
            "Gothic Metal",
            "Glam Metal",
            "Hair Metal",
            "Doom Metal",
            "Groove Metal",
            "Industrial Metal",
            "Modern Metal",
            "Neoclassical Metal",
            "New Wave Of British Heavy Metal",
            "Post Metal",
            "Progressive Metal",
            "Avantgarde Metal",
            "Sludge",
            "Djent",
            "Drone",
            "Kawaii Metal",
            "Pirate Metal",
            "Nu Metal",
            "Neue Deutsche Härte",
            "Math Metal",
            "Crossover",
            "Grindcore",
            "Hardcore",
            "Metalcore",
            "Deathcore",
            "Post Hardcore",
            "Mathcore"
          ],
          folk: [
            "American Folk Revival",
            "Anti - Folk",
            "British Folk Revival",
            "Contemporary Folk",
            "Filk Music",
            "Freak Folk",
            "Indie Folk",
            "Industrial Folk",
            "Neofolk",
            "Progressive Folk",
            "Psychedelic Folk",
            "Sung Poetry",
            "Techno - Folk",
            "Folk Rock",
            "Old-time Music",
            "Bluegrass",
            "Appalachian",
            "Roots Revival",
            "Celtic",
            "Indie Folk"
          ],
          pop: [
            "Adult Contemporary",
            "Arab Pop",
            "Baroque",
            "Britpop",
            "Bubblegum Pop",
            "Chamber Pop",
            "Chanson",
            "Christian Pop",
            "Classical Crossover",
            "Europop",
            "Austropop",
            "Balkan Pop",
            "French Pop",
            "Korean Pop",
            "Japanese Pop",
            "Chinese Pop",
            "Latin Pop",
            "Laïkó",
            "Nederpop",
            "Russian Pop",
            "Dance Pop",
            "Dream Pop",
            "Electro Pop",
            "Iranian Pop",
            "Jangle Pop",
            "Latin Ballad",
            "Levenslied",
            "Louisiana Swamp Pop",
            "Mexican Pop",
            "Motorpop",
            "New Romanticism",
            "Orchestral Pop",
            "Pop Rap",
            "Popera",
            "Pop / Rock",
            "Pop Punk",
            "Power Pop",
            "Psychedelic Pop",
            "Russian Pop",
            "Schlager",
            "Soft Rock",
            "Sophisti - Pop",
            "Space Age Pop",
            "Sunshine Pop",
            "Surf Pop",
            "Synthpop",
            "Teen Pop",
            "Traditional Pop Music",
            "Turkish Pop",
            "Vispop",
            "Wonky Pop"
          ],
          "r&b": [
            "(Carolina) Beach Music",
            "Contemporary R & B",
            "Disco",
            "Doo Wop",
            "Funk",
            "Modern Soul",
            "Motown",
            "Neo - Soul",
            "Northern Soul",
            "Psychedelic Soul",
            "Quiet Storm",
            "Soul",
            "Soul Blues",
            "Southern Soul"
          ],
          reggae: [
            "2 - Tone",
            "Dub",
            "Roots Reggae",
            "Reggae Fusion",
            "Reggae en Español",
            "Spanish Reggae",
            "Reggae 110",
            "Reggae Bultrón",
            "Romantic Flow",
            "Lovers Rock",
            "Raggamuffin",
            "Ragga",
            "Dancehall",
            "Ska"
          ],
          rock: [
            "Acid Rock",
            "Adult - Oriented Rock",
            "Afro Punk",
            "Adult Alternative",
            "Alternative Rock",
            "American Traditional Rock",
            "Anatolian Rock",
            "Arena Rock",
            "Art Rock",
            "Blues - Rock",
            "British Invasion",
            "Cock Rock",
            "Death Metal / Black Metal",
            "Doom Metal",
            "Glam Rock",
            "Gothic Metal",
            "Grind Core",
            "Hair Metal",
            "Hard Rock",
            "Math Metal",
            "Math Rock",
            "Metal",
            "Metal Core",
            "Noise Rock",
            "Jam Bands",
            "Post Punk",
            "Post Rock",
            "Prog - Rock / Art Rock",
            "Progressive Metal",
            "Psychedelic",
            "Rock & Roll",
            "Rockabilly",
            "Roots Rock",
            "Singer / Songwriter",
            "Southern Rock",
            "Spazzcore",
            "Stoner Metal",
            "Surf",
            "Technical Death Metal",
            "Tex - Mex",
            "Thrash Metal",
            "Time Lord Rock(Trock)",
            "Trip - hop",
            "Yacht Rock",
            "School House Rock"
          ],
          "hip-hop": [
            "Alternative Rap",
            "Avant - Garde",
            "Bounce",
            "Chap Hop",
            "Christian Hip Hop",
            "Conscious Hip Hop",
            "Country - Rap",
            "Grunk",
            "Crunkcore",
            "Cumbia Rap",
            "Dirty South",
            "East Coast",
            "Brick City Club",
            "Hardcore Hip Hop",
            "Mafioso Rap",
            "New Jersey Hip Hop",
            "Freestyle Rap",
            "G - Funk",
            "Gangsta Rap",
            "Golden Age",
            "Grime",
            "Hardcore Rap",
            "Hip - Hop",
            "Hip Pop",
            "Horrorcore",
            "Hyphy",
            "Industrial Hip Hop",
            "Instrumental Hip Hop",
            "Jazz Rap",
            "Latin Rap",
            "Low Bap",
            "Lyrical Hip Hop",
            "Merenrap",
            "Midwest Hip Hop",
            "Chicago Hip Hop",
            "Detroit Hip Hop",
            "Horrorcore",
            "St.Louis Hip Hop",
            "Twin Cities Hip Hop",
            "Motswako",
            "Nerdcore",
            "New Jack Swing",
            "New School Hip Hop",
            "Old School Rap",
            "Rap",
            "Trap",
            "Turntablism",
            "Underground Rap",
            "West Coast Rap",
            "East Coast Rap",
            "Trap",
            "UK Grime",
            "Hyphy",
            "Emo-rap",
            "Cloud rap",
            "G-funk",
            "Boom Bap",
            "Mumble",
            "Drill",
            "UK Drill",
            "Soundcloud Rap",
            "Lo-fi"
          ],
          punk: [
            "Afro-punk",
            "Anarcho punk",
            "Art punk",
            "Christian punk",
            "Crust punk",
            "Deathrock",
            "Egg punk",
            "Garage punk",
            "Glam punk",
            "Hardcore punk",
            "Horror punk",
            "Incelcore/e-punk",
            "Oi!",
            "Peace punk",
            "Punk pathetique",
            "Queercore",
            "Riot Grrrl",
            "Skate punk",
            "Street punk",
            "Taqwacore",
            "Trallpunk"
          ],
          disco: [
            "Nu-disco",
            "Disco-funk",
            "Hi-NRG",
            "Italo Disco",
            "Eurodisco",
            "Boogie",
            "Space Disco",
            "Post-disco",
            "Electro Disco",
            "Disco House",
            "Disco Pop",
            "Soulful House"
          ],
          funk: [
            "Funk Rock",
            "P-Funk (Parliament-Funkadelic)",
            "Psychedelic Funk",
            "Funk Metal",
            "Electro-Funk",
            "Go-go",
            "Boogie-Funk",
            "Jazz-Funk",
            "Soul-Funk",
            "Funky Disco",
            "Nu-Funk",
            "Afrobeat",
            "Latin Funk",
            "G-Funk",
            "Acid Jazz",
            "Funktronica",
            "Folk-Funk",
            "Space Funk",
            "Ambient Funk",
            "Hard Funk",
            "Fusion Funk"
          ],
          techno: [
            "Acid Techno",
            "Ambient Techno",
            "Detroit Techno",
            "Dub Techno",
            "Minimal Techno",
            "Industrial Techno",
            "Hard Techno",
            "Trance",
            "Progressive Techno",
            "Tech House",
            "Electronica",
            "Breakbeat Techno",
            "Electro Techno",
            "Melodic Techno",
            "Experimental Techno",
            "Dark Techno",
            "Ebm",
            "Hypnotic Techno",
            "Psychedelic Techno",
            "Rave Techno",
            "Techno-Pop"
          ],
          indie: [
            "Indie Rock",
            "Indie Pop",
            "Indie Folk",
            "Indie Electronic",
            "Indie Punk",
            "Indie Hip-Hop",
            "Dream Pop",
            "Shoegaze",
            "Lo-fi",
            "Chillwave",
            "Freak Folk",
            "Noise Pop",
            "Math Rock",
            "Post-Punk",
            "Garage Rock",
            "Experimental Indie",
            "Surf Rock",
            "Alternative Country",
            "Indie Soul",
            "Art Rock",
            "Indie R&B",
            "Indietronica",
            "Emo",
            "Post-Rock",
            "Indie Pop-Rock",
            "Indie Synthpop",
            "Noise Rock",
            "Psych Folk",
            "Indie Blues"
          ],
          gospel: [
            "Traditional Gospel",
            "Contemporary Gospel",
            "Southern Gospel",
            "Black Gospel",
            "Urban Contemporary Gospel",
            "Gospel Blues",
            "Bluegrass Gospel",
            "Country Gospel",
            "Praise and Worship",
            "Christian Hip-Hop",
            "Gospel Jazz",
            "Reggae Gospel",
            "African Gospel",
            "Latin Gospel",
            "R&B Gospel",
            "Gospel Choir",
            "Acappella Gospel",
            "Instrumental Gospel",
            "Gospel Rap"
          ],
          world: [
            "African",
            "Arabic",
            "Asian",
            "Caribbean",
            "Celtic",
            "European",
            "Latin American",
            "Middle Eastern",
            "Native American",
            "Polynesian",
            "Reggae",
            "Ska",
            "Salsa",
            "Flamenco",
            "Bossa Nova",
            "Tango",
            "Fado",
            "Klezmer",
            "Balkan",
            "Afrobeat",
            "Mongolian Throat Singing",
            "Indian Classical",
            "Gamelan",
            "Sufi Music",
            "Zydeco",
            "Kora Music",
            "Andean Music",
            "Irish Traditional",
            "Gypsy Jazz",
            "Bollywood",
            "Bhangra",
            "Jawaiian",
            "Hawaiian Slack Key Guitar",
            "Calypso",
            "Cuban Son",
            "Taiko Drumming",
            "African Highlife",
            "Merengue",
            "Tuvan Throat Singing"
          ]
        },
        // Data sourced from https://unicode.org/emoji/charts/full-emoji-list.html
        emojis: {
          smileys_and_emotion: [
            "0x1f600",
            "0x1f603",
            "0x1f604",
            "0x1f601",
            "0x1f606",
            "0x1f605",
            "0x1f923",
            "0x1f602",
            "0x1f642",
            "0x1f643",
            "0x1fae0",
            "0x1f609",
            "0x1f60a",
            "0x1f607",
            "0x1f970",
            "0x1f60d",
            "0x1f929",
            "0x1f618",
            "0x1f617",
            "0x263a",
            "0x1f61a",
            "0x1f619",
            "0x1f972",
            "0x1f60b",
            "0x1f61b",
            "0x1f61c",
            "0x1f92a",
            "0x1f61d",
            "0x1f911",
            "0x1f917",
            "0x1f92d",
            "0x1fae2",
            "0x1fae3",
            "0x1f92b",
            "0x1f914",
            "0x1fae1",
            "0x1f910",
            "0x1f928",
            "0x1f610",
            "0x1f611",
            "0x1f636",
            "0x1fae5",
            "0x1f636",
            "0x200d",
            "0x1f32b",
            "0xfe0f",
            "0x1f60f",
            "0x1f612",
            "0x1f644",
            "0x1f62c",
            "0x1f62e",
            "0x200d",
            "0x1f4a8",
            "0x1f925",
            "0x1fae8",
            "0x1f642",
            "0x200d",
            "0x2194",
            "0xfe0f",
            "0x1f642",
            "0x200d",
            "0x2195",
            "0xfe0f",
            "0x1f60c",
            "0x1f614",
            "0x1f62a",
            "0x1f924",
            "0x1f634",
            "0x1f637",
            "0x1f912",
            "0x1f915",
            "0x1f922",
            "0x1f92e",
            "0x1f927",
            "0x1f975",
            "0x1f976",
            "0x1f974",
            "0x1f635",
            "0x1f635",
            "0x200d",
            "0x1f4ab",
            "0x1f92f",
            "0x1f920",
            "0x1f973",
            "0x1f978",
            "0x1f60e",
            "0x1f913",
            "0x1f9d0",
            "0x1f615",
            "0x1fae4",
            "0x1f61f",
            "0x1f641",
            "0x2639",
            "0x1f62e",
            "0x1f62f",
            "0x1f632",
            "0x1f633",
            "0x1f97a",
            "0x1f979",
            "0x1f626",
            "0x1f627",
            "0x1f628",
            "0x1f630",
            "0x1f625",
            "0x1f622",
            "0x1f62d",
            "0x1f631",
            "0x1f616",
            "0x1f623",
            "0x1f61e",
            "0x1f613",
            "0x1f629",
            "0x1f62b",
            "0x1f971",
            "0x1f624",
            "0x1f621",
            "0x1f620",
            "0x1f92c",
            "0x1f608",
            "0x1f47f",
            "0x1f480",
            "0x2620",
            "0x1f4a9",
            "0x1f921",
            "0x1f479",
            "0x1f47a",
            "0x1f47b",
            "0x1f47d",
            "0x1f47e",
            "0x1f916",
            "0x1f63a",
            "0x1f638",
            "0x1f639",
            "0x1f63b",
            "0x1f63c",
            "0x1f63d",
            "0x1f640",
            "0x1f63f",
            "0x1f63e",
            "0x1f648",
            "0x1f649",
            "0x1f64a",
            "0x1f48c",
            "0x1f498",
            "0x1f49d",
            "0x1f496",
            "0x1f497",
            "0x1f493",
            "0x1f49e",
            "0x1f495",
            "0x1f49f",
            "0x2763",
            "0x1f494",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f525",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1fa79",
            "0x2764",
            "0x1fa77",
            "0x1f9e1",
            "0x1f49b",
            "0x1f49a",
            "0x1f499",
            "0x1fa75",
            "0x1f49c",
            "0x1f90e",
            "0x1f5a4",
            "0x1fa76",
            "0x1f90d",
            "0x1f48b",
            "0x1f4af",
            "0x1f4a2",
            "0x1f4a5",
            "0x1f4ab",
            "0x1f4a6",
            "0x1f4a8",
            "0x1f573",
            "0x1f4ac",
            "0x1f441",
            "0xfe0f",
            "0x200d",
            "0x1f5e8",
            "0xfe0f",
            "0x1f5e8",
            "0x1f5ef",
            "0x1f4ad",
            "0x1f4a4"
          ],
          people_and_body: [
            "0x1f44b",
            "0x1f91a",
            "0x1f590",
            "0x270b",
            "0x1f596",
            "0x1faf1",
            "0x1faf2",
            "0x1faf3",
            "0x1faf4",
            "0x1faf7",
            "0x1faf8",
            "0x1f44c",
            "0x1f90c",
            "0x1f90f",
            "0x270c",
            "0x1f91e",
            "0x1faf0",
            "0x1f91f",
            "0x1f918",
            "0x1f919",
            "0x1f448",
            "0x1f449",
            "0x1f446",
            "0x1f595",
            "0x1f447",
            "0x261d",
            "0x1faf5",
            "0x1f44d",
            "0x1f44e",
            "0x270a",
            "0x1f44a",
            "0x1f91b",
            "0x1f91c",
            "0x1f44f",
            "0x1f64c",
            "0x1faf6",
            "0x1f450",
            "0x1f932",
            "0x1f91d",
            "0x1f64f",
            "0x270d",
            "0x1f485",
            "0x1f933",
            "0x1f4aa",
            "0x1f9be",
            "0x1f9bf",
            "0x1f9b5",
            "0x1f9b6",
            "0x1f442",
            "0x1f9bb",
            "0x1f443",
            "0x1f9e0",
            "0x1fac0",
            "0x1fac1",
            "0x1f9b7",
            "0x1f9b4",
            "0x1f440",
            "0x1f441",
            "0x1f445",
            "0x1f444",
            "0x1fae6",
            "0x1f476",
            "0x1f9d2",
            "0x1f466",
            "0x1f467",
            "0x1f9d1",
            "0x1f471",
            "0x1f468",
            "0x1f9d4",
            "0x1f9d4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9b0",
            "0x1f468",
            "0x200d",
            "0x1f9b1",
            "0x1f468",
            "0x200d",
            "0x1f9b3",
            "0x1f468",
            "0x200d",
            "0x1f9b2",
            "0x1f469",
            "0x1f469",
            "0x200d",
            "0x1f9b0",
            "0x1f9d1",
            "0x200d",
            "0x1f9b0",
            "0x1f469",
            "0x200d",
            "0x1f9b1",
            "0x1f9d1",
            "0x200d",
            "0x1f9b1",
            "0x1f469",
            "0x200d",
            "0x1f9b3",
            "0x1f9d1",
            "0x200d",
            "0x1f9b3",
            "0x1f469",
            "0x200d",
            "0x1f9b2",
            "0x1f9d1",
            "0x200d",
            "0x1f9b2",
            "0x1f471",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f471",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d3",
            "0x1f474",
            "0x1f475",
            "0x1f64d",
            "0x1f64d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64e",
            "0x1f64e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f645",
            "0x1f645",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f645",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f646",
            "0x1f646",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f646",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f481",
            "0x1f481",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f481",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f64b",
            "0x1f64b",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f64b",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cf",
            "0x1f9cf",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cf",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f647",
            "0x1f647",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f647",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f926",
            "0x1f926",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f926",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f937",
            "0x1f937",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f937",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2695",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f393",
            "0x1f468",
            "0x200d",
            "0x1f393",
            "0x1f469",
            "0x200d",
            "0x1f393",
            "0x1f9d1",
            "0x200d",
            "0x1f3eb",
            "0x1f468",
            "0x200d",
            "0x1f3eb",
            "0x1f469",
            "0x200d",
            "0x1f3eb",
            "0x1f9d1",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2696",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f33e",
            "0x1f468",
            "0x200d",
            "0x1f33e",
            "0x1f469",
            "0x200d",
            "0x1f33e",
            "0x1f9d1",
            "0x200d",
            "0x1f373",
            "0x1f468",
            "0x200d",
            "0x1f373",
            "0x1f469",
            "0x200d",
            "0x1f373",
            "0x1f9d1",
            "0x200d",
            "0x1f527",
            "0x1f468",
            "0x200d",
            "0x1f527",
            "0x1f469",
            "0x200d",
            "0x1f527",
            "0x1f9d1",
            "0x200d",
            "0x1f3ed",
            "0x1f468",
            "0x200d",
            "0x1f3ed",
            "0x1f469",
            "0x200d",
            "0x1f3ed",
            "0x1f9d1",
            "0x200d",
            "0x1f4bc",
            "0x1f468",
            "0x200d",
            "0x1f4bc",
            "0x1f469",
            "0x200d",
            "0x1f4bc",
            "0x1f9d1",
            "0x200d",
            "0x1f52c",
            "0x1f468",
            "0x200d",
            "0x1f52c",
            "0x1f469",
            "0x200d",
            "0x1f52c",
            "0x1f9d1",
            "0x200d",
            "0x1f4bb",
            "0x1f468",
            "0x200d",
            "0x1f4bb",
            "0x1f469",
            "0x200d",
            "0x1f4bb",
            "0x1f9d1",
            "0x200d",
            "0x1f3a4",
            "0x1f468",
            "0x200d",
            "0x1f3a4",
            "0x1f469",
            "0x200d",
            "0x1f3a4",
            "0x1f9d1",
            "0x200d",
            "0x1f3a8",
            "0x1f468",
            "0x200d",
            "0x1f3a8",
            "0x1f469",
            "0x200d",
            "0x1f3a8",
            "0x1f9d1",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x2708",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f680",
            "0x1f468",
            "0x200d",
            "0x1f680",
            "0x1f469",
            "0x200d",
            "0x1f680",
            "0x1f9d1",
            "0x200d",
            "0x1f692",
            "0x1f468",
            "0x200d",
            "0x1f692",
            "0x1f469",
            "0x200d",
            "0x1f692",
            "0x1f46e",
            "0x1f46e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f575",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f575",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f482",
            "0x1f482",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f482",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f977",
            "0x1f477",
            "0x1f477",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f477",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1fac5",
            "0x1f934",
            "0x1f478",
            "0x1f473",
            "0x1f473",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f473",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f472",
            "0x1f9d5",
            "0x1f935",
            "0x1f935",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f935",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f470",
            "0x1f470",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f470",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f930",
            "0x1fac3",
            "0x1fac4",
            "0x1f931",
            "0x1f469",
            "0x200d",
            "0x1f37c",
            "0x1f468",
            "0x200d",
            "0x1f37c",
            "0x1f9d1",
            "0x200d",
            "0x1f37c",
            "0x1f47c",
            "0x1f385",
            "0x1f936",
            "0x1f9d1",
            "0x200d",
            "0x1f384",
            "0x1f9b8",
            "0x1f9b8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9b9",
            "0x1f9b9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9b9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d9",
            "0x1f9d9",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d9",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9da",
            "0x1f9da",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9da",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9db",
            "0x1f9db",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9db",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dc",
            "0x1f9dc",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dc",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9dd",
            "0x1f9dd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9dd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9de",
            "0x1f9de",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9de",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9df",
            "0x1f9df",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9df",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9cc",
            "0x1f486",
            "0x1f486",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f486",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f487",
            "0x1f487",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f487",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f6b6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9cd",
            "0x1f9cd",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9cd",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9ce",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x1f9d1",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x1f468",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x1f469",
            "0x200d",
            "0x1f9af",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x1f9d1",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x1f468",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x1f469",
            "0x200d",
            "0x1f9bc",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x1f9d1",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x1f468",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x1f469",
            "0x200d",
            "0x1f9bd",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f3c3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x200d",
            "0x27a1",
            "0xfe0f",
            "0x1f483",
            "0x1f57a",
            "0x1f574",
            "0x1f46f",
            "0x1f46f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f46f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d6",
            "0x1f9d6",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d6",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d7",
            "0x1f9d7",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d7",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93a",
            "0x1f3c7",
            "0x26f7",
            "0x1f3c2",
            "0x1f3cc",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cc",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3c4",
            "0x1f3c4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3c4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6a3",
            "0x1f6a3",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6a3",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3ca",
            "0x1f3ca",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3ca",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x26f9",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x26f9",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f3cb",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f3cb",
            "0xfe0f",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b4",
            "0x1f6b4",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b4",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6b5",
            "0x1f6b5",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f6b5",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f938",
            "0x1f938",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f938",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93c",
            "0x1f93c",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93c",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93d",
            "0x1f93d",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93d",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f93e",
            "0x1f93e",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f93e",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f939",
            "0x1f939",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f939",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f9d8",
            "0x1f9d8",
            "0x200d",
            "0x2642",
            "0xfe0f",
            "0x1f9d8",
            "0x200d",
            "0x2640",
            "0xfe0f",
            "0x1f6c0",
            "0x1f6cc",
            "0x1f9d1",
            "0x200d",
            "0x1f91d",
            "0x200d",
            "0x1f9d1",
            "0x1f46d",
            "0x1f46b",
            "0x1f46c",
            "0x1f48f",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f48b",
            "0x200d",
            "0x1f469",
            "0x1f491",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f468",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f468",
            "0x1f469",
            "0x200d",
            "0x2764",
            "0xfe0f",
            "0x200d",
            "0x1f469",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f468",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f466",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f466",
            "0x1f469",
            "0x200d",
            "0x1f467",
            "0x200d",
            "0x1f467",
            "0x1f5e3",
            "0x1f464",
            "0x1f465",
            "0x1fac2",
            "0x1f46a",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x1f9d1",
            "0x200d",
            "0x1f9d2",
            "0x200d",
            "0x1f9d2",
            "0x1f463"
          ],
          animals_and_nature: [
            "0x1f435",
            "0x1f412",
            "0x1f98d",
            "0x1f9a7",
            "0x1f436",
            "0x1f415",
            "0x1f9ae",
            "0x1f415",
            "0x200d",
            "0x1f9ba",
            "0x1f429",
            "0x1f43a",
            "0x1f98a",
            "0x1f99d",
            "0x1f431",
            "0x1f408",
            "0x1f408",
            "0x200d",
            "0x2b1b",
            "0x1f981",
            "0x1f42f",
            "0x1f405",
            "0x1f406",
            "0x1f434",
            "0x1face",
            "0x1facf",
            "0x1f40e",
            "0x1f984",
            "0x1f993",
            "0x1f98c",
            "0x1f9ac",
            "0x1f42e",
            "0x1f402",
            "0x1f403",
            "0x1f404",
            "0x1f437",
            "0x1f416",
            "0x1f417",
            "0x1f43d",
            "0x1f40f",
            "0x1f411",
            "0x1f410",
            "0x1f42a",
            "0x1f42b",
            "0x1f999",
            "0x1f992",
            "0x1f418",
            "0x1f9a3",
            "0x1f98f",
            "0x1f99b",
            "0x1f42d",
            "0x1f401",
            "0x1f400",
            "0x1f439",
            "0x1f430",
            "0x1f407",
            "0x1f43f",
            "0x1f9ab",
            "0x1f994",
            "0x1f987",
            "0x1f43b",
            "0x1f43b",
            "0x200d",
            "0x2744",
            "0xfe0f",
            "0x1f428",
            "0x1f43c",
            "0x1f9a5",
            "0x1f9a6",
            "0x1f9a8",
            "0x1f998",
            "0x1f9a1",
            "0x1f43e",
            "0x1f983",
            "0x1f414",
            "0x1f413",
            "0x1f423",
            "0x1f424",
            "0x1f425",
            "0x1f426",
            "0x1f427",
            "0x1f54a",
            "0x1f985",
            "0x1f986",
            "0x1f9a2",
            "0x1f989",
            "0x1f9a4",
            "0x1fab6",
            "0x1f9a9",
            "0x1f99a",
            "0x1f99c",
            "0x1fabd",
            "0x1f426",
            "0x200d",
            "0x2b1b",
            "0x1fabf",
            "0x1f426",
            "0x200d",
            "0x1f525",
            "0x1f438",
            "0x1f40a",
            "0x1f422",
            "0x1f98e",
            "0x1f40d",
            "0x1f432",
            "0x1f409",
            "0x1f995",
            "0x1f996",
            "0x1f433",
            "0x1f40b",
            "0x1f42c",
            "0x1f9ad",
            "0x1f41f",
            "0x1f420",
            "0x1f421",
            "0x1f988",
            "0x1f419",
            "0x1f41a",
            "0x1fab8",
            "0x1fabc",
            "0x1f40c",
            "0x1f98b",
            "0x1f41b",
            "0x1f41c",
            "0x1f41d",
            "0x1fab2",
            "0x1f41e",
            "0x1f997",
            "0x1fab3",
            "0x1f577",
            "0x1f578",
            "0x1f982",
            "0x1f99f",
            "0x1fab0",
            "0x1fab1",
            "0x1f9a0",
            "0x1f490",
            "0x1f338",
            "0x1f4ae",
            "0x1fab7",
            "0x1f3f5",
            "0x1f339",
            "0x1f940",
            "0x1f33a",
            "0x1f33b",
            "0x1f33c",
            "0x1f337",
            "0x1fabb",
            "0x1f331",
            "0x1fab4",
            "0x1f332",
            "0x1f333",
            "0x1f334",
            "0x1f335",
            "0x1f33e",
            "0x1f33f",
            "0x2618",
            "0x1f340",
            "0x1f341",
            "0x1f342",
            "0x1f343",
            "0x1fab9",
            "0x1faba",
            "0x1f344"
          ],
          food_and_drink: [
            "0x1f347",
            "0x1f348",
            "0x1f349",
            "0x1f34a",
            "0x1f34b",
            "0x1f34b",
            "0x200d",
            "0x1f7e9",
            "0x1f34c",
            "0x1f34d",
            "0x1f96d",
            "0x1f34e",
            "0x1f34f",
            "0x1f350",
            "0x1f351",
            "0x1f352",
            "0x1f353",
            "0x1fad0",
            "0x1f95d",
            "0x1f345",
            "0x1fad2",
            "0x1f965",
            "0x1f951",
            "0x1f346",
            "0x1f954",
            "0x1f955",
            "0x1f33d",
            "0x1f336",
            "0x1fad1",
            "0x1f952",
            "0x1f96c",
            "0x1f966",
            "0x1f9c4",
            "0x1f9c5",
            "0x1f95c",
            "0x1fad8",
            "0x1f330",
            "0x1fada",
            "0x1fadb",
            "0x1f344",
            "0x200d",
            "0x1f7eb",
            "0x1f35e",
            "0x1f950",
            "0x1f956",
            "0x1fad3",
            "0x1f968",
            "0x1f96f",
            "0x1f95e",
            "0x1f9c7",
            "0x1f9c0",
            "0x1f356",
            "0x1f357",
            "0x1f969",
            "0x1f953",
            "0x1f354",
            "0x1f35f",
            "0x1f355",
            "0x1f32d",
            "0x1f96a",
            "0x1f32e",
            "0x1f32f",
            "0x1fad4",
            "0x1f959",
            "0x1f9c6",
            "0x1f95a",
            "0x1f373",
            "0x1f958",
            "0x1f372",
            "0x1fad5",
            "0x1f963",
            "0x1f957",
            "0x1f37f",
            "0x1f9c8",
            "0x1f9c2",
            "0x1f96b",
            "0x1f371",
            "0x1f358",
            "0x1f359",
            "0x1f35a",
            "0x1f35b",
            "0x1f35c",
            "0x1f35d",
            "0x1f360",
            "0x1f362",
            "0x1f363",
            "0x1f364",
            "0x1f365",
            "0x1f96e",
            "0x1f361",
            "0x1f95f",
            "0x1f960",
            "0x1f961",
            "0x1f980",
            "0x1f99e",
            "0x1f990",
            "0x1f991",
            "0x1f9aa",
            "0x1f366",
            "0x1f367",
            "0x1f368",
            "0x1f369",
            "0x1f36a",
            "0x1f382",
            "0x1f370",
            "0x1f9c1",
            "0x1f967",
            "0x1f36b",
            "0x1f36c",
            "0x1f36d",
            "0x1f36e",
            "0x1f36f",
            "0x1f37c",
            "0x1f95b",
            "0x2615",
            "0x1fad6",
            "0x1f375",
            "0x1f376",
            "0x1f37e",
            "0x1f377",
            "0x1f378",
            "0x1f379",
            "0x1f37a",
            "0x1f37b",
            "0x1f942",
            "0x1f943",
            "0x1fad7",
            "0x1f964",
            "0x1f9cb",
            "0x1f9c3",
            "0x1f9c9",
            "0x1f9ca",
            "0x1f962",
            "0x1f37d",
            "0x1f374",
            "0x1f944",
            "0x1f52a",
            "0x1fad9",
            "0x1f3fa"
          ],
          travel_and_places: [
            "0x1f30d",
            "0x1f30e",
            "0x1f30f",
            "0x1f310",
            "0x1f5fa",
            "0x1f5fe",
            "0x1f9ed",
            "0x1f3d4",
            "0x26f0",
            "0x1f30b",
            "0x1f5fb",
            "0x1f3d5",
            "0x1f3d6",
            "0x1f3dc",
            "0x1f3dd",
            "0x1f3de",
            "0x1f3df",
            "0x1f3db",
            "0x1f3d7",
            "0x1f9f1",
            "0x1faa8",
            "0x1fab5",
            "0x1f6d6",
            "0x1f3d8",
            "0x1f3da",
            "0x1f3e0",
            "0x1f3e1",
            "0x1f3e2",
            "0x1f3e3",
            "0x1f3e4",
            "0x1f3e5",
            "0x1f3e6",
            "0x1f3e8",
            "0x1f3e9",
            "0x1f3ea",
            "0x1f3eb",
            "0x1f3ec",
            "0x1f3ed",
            "0x1f3ef",
            "0x1f3f0",
            "0x1f492",
            "0x1f5fc",
            "0x1f5fd",
            "0x26ea",
            "0x1f54c",
            "0x1f6d5",
            "0x1f54d",
            "0x26e9",
            "0x1f54b",
            "0x26f2",
            "0x26fa",
            "0x1f301",
            "0x1f303",
            "0x1f3d9",
            "0x1f304",
            "0x1f305",
            "0x1f306",
            "0x1f307",
            "0x1f309",
            "0x2668",
            "0x1f3a0",
            "0x1f6dd",
            "0x1f3a1",
            "0x1f3a2",
            "0x1f488",
            "0x1f3aa",
            "0x1f682",
            "0x1f683",
            "0x1f684",
            "0x1f685",
            "0x1f686",
            "0x1f687",
            "0x1f688",
            "0x1f689",
            "0x1f68a",
            "0x1f69d",
            "0x1f69e",
            "0x1f68b",
            "0x1f68c",
            "0x1f68d",
            "0x1f68e",
            "0x1f690",
            "0x1f691",
            "0x1f692",
            "0x1f693",
            "0x1f694",
            "0x1f695",
            "0x1f696",
            "0x1f697",
            "0x1f698",
            "0x1f699",
            "0x1f6fb",
            "0x1f69a",
            "0x1f69b",
            "0x1f69c",
            "0x1f3ce",
            "0x1f3cd",
            "0x1f6f5",
            "0x1f9bd",
            "0x1f9bc",
            "0x1f6fa",
            "0x1f6b2",
            "0x1f6f4",
            "0x1f6f9",
            "0x1f6fc",
            "0x1f68f",
            "0x1f6e3",
            "0x1f6e4",
            "0x1f6e2",
            "0x26fd",
            "0x1f6de",
            "0x1f6a8",
            "0x1f6a5",
            "0x1f6a6",
            "0x1f6d1",
            "0x1f6a7",
            "0x2693",
            "0x1f6df",
            "0x26f5",
            "0x1f6f6",
            "0x1f6a4",
            "0x1f6f3",
            "0x26f4",
            "0x1f6e5",
            "0x1f6a2",
            "0x2708",
            "0x1f6e9",
            "0x1f6eb",
            "0x1f6ec",
            "0x1fa82",
            "0x1f4ba",
            "0x1f681",
            "0x1f69f",
            "0x1f6a0",
            "0x1f6a1",
            "0x1f6f0",
            "0x1f680",
            "0x1f6f8",
            "0x1f6ce",
            "0x1f9f3",
            "0x231b",
            "0x23f3",
            "0x231a",
            "0x23f0",
            "0x23f1",
            "0x23f2",
            "0x1f570",
            "0x1f55b",
            "0x1f567",
            "0x1f550",
            "0x1f55c",
            "0x1f551",
            "0x1f55d",
            "0x1f552",
            "0x1f55e",
            "0x1f553",
            "0x1f55f",
            "0x1f554",
            "0x1f560",
            "0x1f555",
            "0x1f561",
            "0x1f556",
            "0x1f562",
            "0x1f557",
            "0x1f563",
            "0x1f558",
            "0x1f564",
            "0x1f559",
            "0x1f565",
            "0x1f55a",
            "0x1f566",
            "0x1f311",
            "0x1f312",
            "0x1f313",
            "0x1f314",
            "0x1f315",
            "0x1f316",
            "0x1f317",
            "0x1f318",
            "0x1f319",
            "0x1f31a",
            "0x1f31b",
            "0x1f31c",
            "0x1f321",
            "0x2600",
            "0x1f31d",
            "0x1f31e",
            "0x1fa90",
            "0x2b50",
            "0x1f31f",
            "0x1f320",
            "0x1f30c",
            "0x2601",
            "0x26c5",
            "0x26c8",
            "0x1f324",
            "0x1f325",
            "0x1f326",
            "0x1f327",
            "0x1f328",
            "0x1f329",
            "0x1f32a",
            "0x1f32b",
            "0x1f32c",
            "0x1f300",
            "0x1f308",
            "0x1f302",
            "0x2602",
            "0x2614",
            "0x26f1",
            "0x26a1",
            "0x2744",
            "0x2603",
            "0x26c4",
            "0x2604",
            "0x1f525",
            "0x1f4a7",
            "0x1f30a"
          ],
          activities: [
            "0x1f383",
            "0x1f384",
            "0x1f386",
            "0x1f387",
            "0x1f9e8",
            "0x2728",
            "0x1f388",
            "0x1f389",
            "0x1f38a",
            "0x1f38b",
            "0x1f38d",
            "0x1f38e",
            "0x1f38f",
            "0x1f390",
            "0x1f391",
            "0x1f9e7",
            "0x1f380",
            "0x1f381",
            "0x1f397",
            "0x1f39f",
            "0x1f3ab",
            "0x1f396",
            "0x1f3c6",
            "0x1f3c5",
            "0x1f947",
            "0x1f948",
            "0x1f949",
            "0x26bd",
            "0x26be",
            "0x1f94e",
            "0x1f3c0",
            "0x1f3d0",
            "0x1f3c8",
            "0x1f3c9",
            "0x1f3be",
            "0x1f94f",
            "0x1f3b3",
            "0x1f3cf",
            "0x1f3d1",
            "0x1f3d2",
            "0x1f94d",
            "0x1f3d3",
            "0x1f3f8",
            "0x1f94a",
            "0x1f94b",
            "0x1f945",
            "0x26f3",
            "0x26f8",
            "0x1f3a3",
            "0x1f93f",
            "0x1f3bd",
            "0x1f3bf",
            "0x1f6f7",
            "0x1f94c",
            "0x1f3af",
            "0x1fa80",
            "0x1fa81",
            "0x1f52b",
            "0x1f3b1",
            "0x1f52e",
            "0x1fa84",
            "0x1f3ae",
            "0x1f579",
            "0x1f3b0",
            "0x1f3b2",
            "0x1f9e9",
            "0x1f9f8",
            "0x1fa85",
            "0x1faa9",
            "0x1fa86",
            "0x2660",
            "0x2665",
            "0x2666",
            "0x2663",
            "0x265f",
            "0x1f0cf",
            "0x1f004",
            "0x1f3b4",
            "0x1f3ad",
            "0x1f5bc",
            "0x1f3a8",
            "0x1f9f5",
            "0x1faa1",
            "0x1f9f6",
            "0x1faa2"
          ],
          objects: [
            "0x1f453",
            "0x1f576",
            "0x1f97d",
            "0x1f97c",
            "0x1f9ba",
            "0x1f454",
            "0x1f455",
            "0x1f456",
            "0x1f9e3",
            "0x1f9e4",
            "0x1f9e5",
            "0x1f9e6",
            "0x1f457",
            "0x1f458",
            "0x1f97b",
            "0x1fa71",
            "0x1fa72",
            "0x1fa73",
            "0x1f459",
            "0x1f45a",
            "0x1faad",
            "0x1f45b",
            "0x1f45c",
            "0x1f45d",
            "0x1f6cd",
            "0x1f392",
            "0x1fa74",
            "0x1f45e",
            "0x1f45f",
            "0x1f97e",
            "0x1f97f",
            "0x1f460",
            "0x1f461",
            "0x1fa70",
            "0x1f462",
            "0x1faae",
            "0x1f451",
            "0x1f452",
            "0x1f3a9",
            "0x1f393",
            "0x1f9e2",
            "0x1fa96",
            "0x26d1",
            "0x1f4ff",
            "0x1f484",
            "0x1f48d",
            "0x1f48e",
            "0x1f507",
            "0x1f508",
            "0x1f509",
            "0x1f50a",
            "0x1f4e2",
            "0x1f4e3",
            "0x1f4ef",
            "0x1f514",
            "0x1f515",
            "0x1f3bc",
            "0x1f3b5",
            "0x1f3b6",
            "0x1f399",
            "0x1f39a",
            "0x1f39b",
            "0x1f3a4",
            "0x1f3a7",
            "0x1f4fb",
            "0x1f3b7",
            "0x1fa97",
            "0x1f3b8",
            "0x1f3b9",
            "0x1f3ba",
            "0x1f3bb",
            "0x1fa95",
            "0x1f941",
            "0x1fa98",
            "0x1fa87",
            "0x1fa88",
            "0x1f4f1",
            "0x1f4f2",
            "0x260e",
            "0x1f4de",
            "0x1f4df",
            "0x1f4e0",
            "0x1f50b",
            "0x1faab",
            "0x1f50c",
            "0x1f4bb",
            "0x1f5a5",
            "0x1f5a8",
            "0x2328",
            "0x1f5b1",
            "0x1f5b2",
            "0x1f4bd",
            "0x1f4be",
            "0x1f4bf",
            "0x1f4c0",
            "0x1f9ee",
            "0x1f3a5",
            "0x1f39e",
            "0x1f4fd",
            "0x1f3ac",
            "0x1f4fa",
            "0x1f4f7",
            "0x1f4f8",
            "0x1f4f9",
            "0x1f4fc",
            "0x1f50d",
            "0x1f50e",
            "0x1f56f",
            "0x1f4a1",
            "0x1f526",
            "0x1f3ee",
            "0x1fa94",
            "0x1f4d4",
            "0x1f4d5",
            "0x1f4d6",
            "0x1f4d7",
            "0x1f4d8",
            "0x1f4d9",
            "0x1f4da",
            "0x1f4d3",
            "0x1f4d2",
            "0x1f4c3",
            "0x1f4dc",
            "0x1f4c4",
            "0x1f4f0",
            "0x1f5de",
            "0x1f4d1",
            "0x1f516",
            "0x1f3f7",
            "0x1f4b0",
            "0x1fa99",
            "0x1f4b4",
            "0x1f4b5",
            "0x1f4b6",
            "0x1f4b7",
            "0x1f4b8",
            "0x1f4b3",
            "0x1f9fe",
            "0x1f4b9",
            "0x2709",
            "0x1f4e7",
            "0x1f4e8",
            "0x1f4e9",
            "0x1f4e4",
            "0x1f4e5",
            "0x1f4e6",
            "0x1f4eb",
            "0x1f4ea",
            "0x1f4ec",
            "0x1f4ed",
            "0x1f4ee",
            "0x1f5f3",
            "0x270f",
            "0x2712",
            "0x1f58b",
            "0x1f58a",
            "0x1f58c",
            "0x1f58d",
            "0x1f4dd",
            "0x1f4bc",
            "0x1f4c1",
            "0x1f4c2",
            "0x1f5c2",
            "0x1f4c5",
            "0x1f4c6",
            "0x1f5d2",
            "0x1f5d3",
            "0x1f4c7",
            "0x1f4c8",
            "0x1f4c9",
            "0x1f4ca",
            "0x1f4cb",
            "0x1f4cc",
            "0x1f4cd",
            "0x1f4ce",
            "0x1f587",
            "0x1f4cf",
            "0x1f4d0",
            "0x2702",
            "0x1f5c3",
            "0x1f5c4",
            "0x1f5d1",
            "0x1f512",
            "0x1f513",
            "0x1f50f",
            "0x1f510",
            "0x1f511",
            "0x1f5dd",
            "0x1f528",
            "0x1fa93",
            "0x26cf",
            "0x2692",
            "0x1f6e0",
            "0x1f5e1",
            "0x2694",
            "0x1f4a3",
            "0x1fa83",
            "0x1f3f9",
            "0x1f6e1",
            "0x1fa9a",
            "0x1f527",
            "0x1fa9b",
            "0x1f529",
            "0x2699",
            "0x1f5dc",
            "0x2696",
            "0x1f9af",
            "0x1f517",
            "0x26d3",
            "0xfe0f",
            "0x200d",
            "0x1f4a5",
            "0x26d3",
            "0x1fa9d",
            "0x1f9f0",
            "0x1f9f2",
            "0x1fa9c",
            "0x2697",
            "0x1f9ea",
            "0x1f9eb",
            "0x1f9ec",
            "0x1f52c",
            "0x1f52d",
            "0x1f4e1",
            "0x1f489",
            "0x1fa78",
            "0x1f48a",
            "0x1fa79",
            "0x1fa7c",
            "0x1fa7a",
            "0x1fa7b",
            "0x1f6aa",
            "0x1f6d7",
            "0x1fa9e",
            "0x1fa9f",
            "0x1f6cf",
            "0x1f6cb",
            "0x1fa91",
            "0x1f6bd",
            "0x1faa0",
            "0x1f6bf",
            "0x1f6c1",
            "0x1faa4",
            "0x1fa92",
            "0x1f9f4",
            "0x1f9f7",
            "0x1f9f9",
            "0x1f9fa",
            "0x1f9fb",
            "0x1faa3",
            "0x1f9fc",
            "0x1fae7",
            "0x1faa5",
            "0x1f9fd",
            "0x1f9ef",
            "0x1f6d2",
            "0x1f6ac",
            "0x26b0",
            "0x1faa6",
            "0x26b1",
            "0x1f9ff",
            "0x1faac",
            "0x1f5ff",
            "0x1faa7",
            "0x1faaa"
          ],
          symbols: [
            "0x1f3e7",
            "0x1f6ae",
            "0x1f6b0",
            "0x267f",
            "0x1f6b9",
            "0x1f6ba",
            "0x1f6bb",
            "0x1f6bc",
            "0x1f6be",
            "0x1f6c2",
            "0x1f6c3",
            "0x1f6c4",
            "0x1f6c5",
            "0x26a0",
            "0x1f6b8",
            "0x26d4",
            "0x1f6ab",
            "0x1f6b3",
            "0x1f6ad",
            "0x1f6af",
            "0x1f6b1",
            "0x1f6b7",
            "0x1f4f5",
            "0x1f51e",
            "0x2622",
            "0x2623",
            "0x2b06",
            "0x2197",
            "0x27a1",
            "0x2198",
            "0x2b07",
            "0x2199",
            "0x2b05",
            "0x2196",
            "0x2195",
            "0x2194",
            "0x21a9",
            "0x21aa",
            "0x2934",
            "0x2935",
            "0x1f503",
            "0x1f504",
            "0x1f519",
            "0x1f51a",
            "0x1f51b",
            "0x1f51c",
            "0x1f51d",
            "0x1f6d0",
            "0x269b",
            "0x1f549",
            "0x2721",
            "0x2638",
            "0x262f",
            "0x271d",
            "0x2626",
            "0x262a",
            "0x262e",
            "0x1f54e",
            "0x1f52f",
            "0x1faaf",
            "0x2648",
            "0x2649",
            "0x264a",
            "0x264b",
            "0x264c",
            "0x264d",
            "0x264e",
            "0x264f",
            "0x2650",
            "0x2651",
            "0x2652",
            "0x2653",
            "0x26ce",
            "0x1f500",
            "0x1f501",
            "0x1f502",
            "0x25b6",
            "0x23e9",
            "0x23ed",
            "0x23ef",
            "0x25c0",
            "0x23ea",
            "0x23ee",
            "0x1f53c",
            "0x23eb",
            "0x1f53d",
            "0x23ec",
            "0x23f8",
            "0x23f9",
            "0x23fa",
            "0x23cf",
            "0x1f3a6",
            "0x1f505",
            "0x1f506",
            "0x1f4f6",
            "0x1f6dc",
            "0x1f4f3",
            "0x1f4f4",
            "0x2640",
            "0x2642",
            "0x26a7",
            "0x2716",
            "0x2795",
            "0x2796",
            "0x2797",
            "0x1f7f0",
            "0x267e",
            "0x203c",
            "0x2049",
            "0x2753",
            "0x2754",
            "0x2755",
            "0x2757",
            "0x3030",
            "0x1f4b1",
            "0x1f4b2",
            "0x2695",
            "0x267b",
            "0x269c",
            "0x1f531",
            "0x1f4db",
            "0x1f530",
            "0x2b55",
            "0x2705",
            "0x2611",
            "0x2714",
            "0x274c",
            "0x274e",
            "0x27b0",
            "0x27bf",
            "0x303d",
            "0x2733",
            "0x2734",
            "0x2747",
            "0x00a9",
            "0x00ae",
            "0x2122",
            "0x0023",
            "0xfe0f",
            "0x20e3",
            "0x002a",
            "0xfe0f",
            "0x20e3",
            "0x0030",
            "0xfe0f",
            "0x20e3",
            "0x0031",
            "0xfe0f",
            "0x20e3",
            "0x0032",
            "0xfe0f",
            "0x20e3",
            "0x0033",
            "0xfe0f",
            "0x20e3",
            "0x0034",
            "0xfe0f",
            "0x20e3",
            "0x0035",
            "0xfe0f",
            "0x20e3",
            "0x0036",
            "0xfe0f",
            "0x20e3",
            "0x0037",
            "0xfe0f",
            "0x20e3",
            "0x0038",
            "0xfe0f",
            "0x20e3",
            "0x0039",
            "0xfe0f",
            "0x20e3",
            "0x1f51f",
            "0x1f520",
            "0x1f521",
            "0x1f522",
            "0x1f523",
            "0x1f524",
            "0x1f170",
            "0x1f18e",
            "0x1f171",
            "0x1f191",
            "0x1f192",
            "0x1f193",
            "0x2139",
            "0x1f194",
            "0x24c2",
            "0x1f195",
            "0x1f196",
            "0x1f17e",
            "0x1f197",
            "0x1f17f",
            "0x1f198",
            "0x1f199",
            "0x1f19a",
            "0x1f201",
            "0x1f202",
            "0x1f237",
            "0x1f236",
            "0x1f22f",
            "0x1f250",
            "0x1f239",
            "0x1f21a",
            "0x1f232",
            "0x1f251",
            "0x1f238",
            "0x1f234",
            "0x1f233",
            "0x3297",
            "0x3299",
            "0x1f23a",
            "0x1f235",
            "0x1f534",
            "0x1f7e0",
            "0x1f7e1",
            "0x1f7e2",
            "0x1f535",
            "0x1f7e3",
            "0x1f7e4",
            "0x26ab",
            "0x26aa",
            "0x1f7e5",
            "0x1f7e7",
            "0x1f7e8",
            "0x1f7e9",
            "0x1f7e6",
            "0x1f7ea",
            "0x1f7eb",
            "0x2b1b",
            "0x2b1c",
            "0x25fc",
            "0x25fb",
            "0x25fe",
            "0x25fd",
            "0x25aa",
            "0x25ab",
            "0x1f536",
            "0x1f537",
            "0x1f538",
            "0x1f539",
            "0x1f53a",
            "0x1f53b",
            "0x1f4a0",
            "0x1f518",
            "0x1f533",
            "0x1f532"
          ],
          flags: [
            "0x1f3c1",
            "0x1f6a9",
            "0x1f38c",
            "0x1f3f4",
            "0x1f3f3",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x1f308",
            "0x1f3f3",
            "0xfe0f",
            "0x200d",
            "0x26a7",
            "0xfe0f",
            "0x1f3f4",
            "0x200d",
            "0x2620",
            "0xfe0f",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e9",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1eb",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ee",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f4",
            "0x1f1e6",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fc",
            "0x1f1e6",
            "0x1f1fd",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1e7",
            "0x1f1e6",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e7",
            "0x1f1e9",
            "0x1f1e7",
            "0x1f1ea",
            "0x1f1e7",
            "0x1f1eb",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ed",
            "0x1f1e7",
            "0x1f1ee",
            "0x1f1e7",
            "0x1f1ef",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f2",
            "0x1f1e7",
            "0x1f1f3",
            "0x1f1e7",
            "0x1f1f4",
            "0x1f1e7",
            "0x1f1f6",
            "0x1f1e7",
            "0x1f1f7",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f9",
            "0x1f1e7",
            "0x1f1fb",
            "0x1f1e7",
            "0x1f1fc",
            "0x1f1e7",
            "0x1f1fe",
            "0x1f1e7",
            "0x1f1ff",
            "0x1f1e8",
            "0x1f1e6",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e8",
            "0x1f1e9",
            "0x1f1e8",
            "0x1f1eb",
            "0x1f1e8",
            "0x1f1ec",
            "0x1f1e8",
            "0x1f1ed",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1f0",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f4",
            "0x1f1e8",
            "0x1f1f5",
            "0x1f1e8",
            "0x1f1f7",
            "0x1f1e8",
            "0x1f1fa",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fc",
            "0x1f1e8",
            "0x1f1fd",
            "0x1f1e8",
            "0x1f1fe",
            "0x1f1e8",
            "0x1f1ff",
            "0x1f1e9",
            "0x1f1ea",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ef",
            "0x1f1e9",
            "0x1f1f0",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f4",
            "0x1f1e9",
            "0x1f1ff",
            "0x1f1ea",
            "0x1f1e6",
            "0x1f1ea",
            "0x1f1e8",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ed",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f9",
            "0x1f1ea",
            "0x1f1fa",
            "0x1f1eb",
            "0x1f1ee",
            "0x1f1eb",
            "0x1f1ef",
            "0x1f1eb",
            "0x1f1f0",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f4",
            "0x1f1eb",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1e6",
            "0x1f1ec",
            "0x1f1e7",
            "0x1f1ec",
            "0x1f1e9",
            "0x1f1ec",
            "0x1f1ea",
            "0x1f1ec",
            "0x1f1eb",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ec",
            "0x1f1ed",
            "0x1f1ec",
            "0x1f1ee",
            "0x1f1ec",
            "0x1f1f1",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f6",
            "0x1f1ec",
            "0x1f1f7",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fc",
            "0x1f1ec",
            "0x1f1fe",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f3",
            "0x1f1ed",
            "0x1f1f7",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1fa",
            "0x1f1ee",
            "0x1f1e8",
            "0x1f1ee",
            "0x1f1e9",
            "0x1f1ee",
            "0x1f1ea",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f2",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f4",
            "0x1f1ee",
            "0x1f1f6",
            "0x1f1ee",
            "0x1f1f7",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1ea",
            "0x1f1ef",
            "0x1f1f2",
            "0x1f1ef",
            "0x1f1f4",
            "0x1f1ef",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1ea",
            "0x1f1f0",
            "0x1f1ec",
            "0x1f1f0",
            "0x1f1ed",
            "0x1f1f0",
            "0x1f1ee",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f3",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f7",
            "0x1f1f0",
            "0x1f1fc",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1f0",
            "0x1f1ff",
            "0x1f1f1",
            "0x1f1e6",
            "0x1f1f1",
            "0x1f1e7",
            "0x1f1f1",
            "0x1f1e8",
            "0x1f1f1",
            "0x1f1ee",
            "0x1f1f1",
            "0x1f1f0",
            "0x1f1f1",
            "0x1f1f7",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1fa",
            "0x1f1f1",
            "0x1f1fb",
            "0x1f1f1",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1e6",
            "0x1f1f2",
            "0x1f1e8",
            "0x1f1f2",
            "0x1f1e9",
            "0x1f1f2",
            "0x1f1ea",
            "0x1f1f2",
            "0x1f1eb",
            "0x1f1f2",
            "0x1f1ec",
            "0x1f1f2",
            "0x1f1ed",
            "0x1f1f2",
            "0x1f1f0",
            "0x1f1f2",
            "0x1f1f1",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f2",
            "0x1f1f3",
            "0x1f1f2",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f6",
            "0x1f1f2",
            "0x1f1f7",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fb",
            "0x1f1f2",
            "0x1f1fc",
            "0x1f1f2",
            "0x1f1fd",
            "0x1f1f2",
            "0x1f1fe",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1f3",
            "0x1f1e6",
            "0x1f1f3",
            "0x1f1e8",
            "0x1f1f3",
            "0x1f1ea",
            "0x1f1f3",
            "0x1f1eb",
            "0x1f1f3",
            "0x1f1ec",
            "0x1f1f3",
            "0x1f1ee",
            "0x1f1f3",
            "0x1f1f1",
            "0x1f1f3",
            "0x1f1f4",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f7",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1ff",
            "0x1f1f4",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1e6",
            "0x1f1f5",
            "0x1f1ea",
            "0x1f1f5",
            "0x1f1eb",
            "0x1f1f5",
            "0x1f1ec",
            "0x1f1f5",
            "0x1f1ed",
            "0x1f1f5",
            "0x1f1f0",
            "0x1f1f5",
            "0x1f1f1",
            "0x1f1f5",
            "0x1f1f2",
            "0x1f1f5",
            "0x1f1f3",
            "0x1f1f5",
            "0x1f1f7",
            "0x1f1f5",
            "0x1f1f8",
            "0x1f1f5",
            "0x1f1f9",
            "0x1f1f5",
            "0x1f1fc",
            "0x1f1f5",
            "0x1f1fe",
            "0x1f1f6",
            "0x1f1e6",
            "0x1f1f7",
            "0x1f1ea",
            "0x1f1f7",
            "0x1f1f4",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1fa",
            "0x1f1f7",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1e6",
            "0x1f1f8",
            "0x1f1e7",
            "0x1f1f8",
            "0x1f1e8",
            "0x1f1f8",
            "0x1f1e9",
            "0x1f1f8",
            "0x1f1ea",
            "0x1f1f8",
            "0x1f1ec",
            "0x1f1f8",
            "0x1f1ed",
            "0x1f1f8",
            "0x1f1ee",
            "0x1f1f8",
            "0x1f1ef",
            "0x1f1f8",
            "0x1f1f0",
            "0x1f1f8",
            "0x1f1f1",
            "0x1f1f8",
            "0x1f1f2",
            "0x1f1f8",
            "0x1f1f3",
            "0x1f1f8",
            "0x1f1f4",
            "0x1f1f8",
            "0x1f1f7",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f8",
            "0x1f1f9",
            "0x1f1f8",
            "0x1f1fb",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f8",
            "0x1f1fe",
            "0x1f1f8",
            "0x1f1ff",
            "0x1f1f9",
            "0x1f1e6",
            "0x1f1f9",
            "0x1f1e8",
            "0x1f1f9",
            "0x1f1e9",
            "0x1f1f9",
            "0x1f1eb",
            "0x1f1f9",
            "0x1f1ec",
            "0x1f1f9",
            "0x1f1ed",
            "0x1f1f9",
            "0x1f1ef",
            "0x1f1f9",
            "0x1f1f0",
            "0x1f1f9",
            "0x1f1f1",
            "0x1f1f9",
            "0x1f1f2",
            "0x1f1f9",
            "0x1f1f3",
            "0x1f1f9",
            "0x1f1f4",
            "0x1f1f9",
            "0x1f1f7",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1f9",
            "0x1f1fb",
            "0x1f1f9",
            "0x1f1fc",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1fa",
            "0x1f1e6",
            "0x1f1fa",
            "0x1f1ec",
            "0x1f1fa",
            "0x1f1f2",
            "0x1f1fa",
            "0x1f1f3",
            "0x1f1fa",
            "0x1f1f8",
            "0x1f1fa",
            "0x1f1fe",
            "0x1f1fa",
            "0x1f1ff",
            "0x1f1fb",
            "0x1f1e6",
            "0x1f1fb",
            "0x1f1e8",
            "0x1f1fb",
            "0x1f1ea",
            "0x1f1fb",
            "0x1f1ec",
            "0x1f1fb",
            "0x1f1ee",
            "0x1f1fb",
            "0x1f1f3",
            "0x1f1fb",
            "0x1f1fa",
            "0x1f1fc",
            "0x1f1eb",
            "0x1f1fc",
            "0x1f1f8",
            "0x1f1fd",
            "0x1f1f0",
            "0x1f1fe",
            "0x1f1ea",
            "0x1f1fe",
            "0x1f1f9",
            "0x1f1ff",
            "0x1f1e6",
            "0x1f1ff",
            "0x1f1f2",
            "0x1f1ff",
            "0x1f1fc",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0065",
            "0xe006e",
            "0xe0067",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0073",
            "0xe0063",
            "0xe0074",
            "0xe007f",
            "0x1f3f4",
            "0xe0067",
            "0xe0062",
            "0xe0077",
            "0xe006c",
            "0xe0073",
            "0xe007f"
          ]
        }
      }, S = Object.prototype.hasOwnProperty, A = Object.keys || function(d) {
        var m = [];
        for (var v in d)
          S.call(d, v) && m.push(v);
        return m;
      };
      function I(d, m) {
        for (var v = A(d), k, O = 0, G = v.length; O < G; O++)
          k = v[O], m[k] = d[k] || m[k];
      }
      function M(d, m) {
        for (var v = 0, k = d.length; v < k; v++)
          m[v] = d[v];
      }
      function B(d, m) {
        var v = Array.isArray(d), k = m || (v ? new Array(d.length) : {});
        return v ? M(d, k) : I(d, k), k;
      }
      u.prototype.get = function(d) {
        return B(x[d]);
      }, u.prototype.mac_address = function(d) {
        d = f(d), d.separator || (d.separator = d.networkVersion ? "." : ":");
        var m = "ABCDEF1234567890", v = "";
        return d.networkVersion ? v = this.n(this.string, 3, { pool: m, length: 4 }).join(d.separator) : v = this.n(this.string, 6, { pool: m, length: 2 }).join(d.separator), v;
      }, u.prototype.normal = function(d) {
        if (d = f(d, { mean: 0, dev: 1, pool: [] }), p(
          d.pool.constructor !== Array,
          "Chance: The pool option must be a valid array."
        ), p(
          typeof d.mean != "number",
          "Chance: Mean (mean) must be a number"
        ), p(
          typeof d.dev != "number",
          "Chance: Standard deviation (dev) must be a number"
        ), d.pool.length > 0)
          return this.normal_pool(d);
        var m, v, k, O, G = d.mean, H = d.dev;
        do
          v = this.random() * 2 - 1, k = this.random() * 2 - 1, m = v * v + k * k;
        while (m >= 1);
        return O = v * Math.sqrt(-2 * Math.log(m) / m), H * O + G;
      }, u.prototype.normal_pool = function(d) {
        var m = 0;
        do {
          var v = Math.round(this.normal({ mean: d.mean, dev: d.dev }));
          if (v < d.pool.length && v >= 0)
            return d.pool[v];
          m++;
        } while (m < 100);
        throw new RangeError("Chance: Your pool is too small for the given mean and standard deviation. Please adjust.");
      }, u.prototype.radio = function(d) {
        d = f(d, { side: "?" });
        var m = "";
        switch (d.side.toLowerCase()) {
          case "east":
          case "e":
            m = "W";
            break;
          case "west":
          case "w":
            m = "K";
            break;
          default:
            m = this.character({ pool: "KW" });
            break;
        }
        return m + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" }) + this.character({ alpha: !0, casing: "upper" });
      }, u.prototype.set = function(d, m) {
        typeof d == "string" ? x[d] = m : x = B(d, x);
      }, u.prototype.tv = function(d) {
        return this.radio(d);
      }, u.prototype.cnpj = function() {
        var d = this.n(this.natural, 8, { max: 9 }), m = 2 + d[7] * 6 + d[6] * 7 + d[5] * 8 + d[4] * 9 + d[3] * 2 + d[2] * 3 + d[1] * 4 + d[0] * 5;
        m = 11 - m % 11, m >= 10 && (m = 0);
        var v = m * 2 + 3 + d[7] * 7 + d[6] * 8 + d[5] * 9 + d[4] * 2 + d[3] * 3 + d[2] * 4 + d[1] * 5 + d[0] * 6;
        return v = 11 - v % 11, v >= 10 && (v = 0), "" + d[0] + d[1] + "." + d[2] + d[3] + d[4] + "." + d[5] + d[6] + d[7] + "/0001-" + m + v;
      }, u.prototype.emotion = function() {
        return this.pick(this.get("emotions"));
      }, u.prototype.mersenne_twister = function(d) {
        return new L(d);
      }, u.prototype.blueimp_md5 = function() {
        return new N();
      };
      var L = function(d) {
        d === void 0 && (d = Math.floor(Math.random() * Math.pow(10, 13))), this.N = 624, this.M = 397, this.MATRIX_A = 2567483615, this.UPPER_MASK = 2147483648, this.LOWER_MASK = 2147483647, this.mt = new Array(this.N), this.mti = this.N + 1, this.init_genrand(d);
      };
      L.prototype.init_genrand = function(d) {
        for (this.mt[0] = d >>> 0, this.mti = 1; this.mti < this.N; this.mti++)
          d = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30, this.mt[this.mti] = (((d & 4294901760) >>> 16) * 1812433253 << 16) + (d & 65535) * 1812433253 + this.mti, this.mt[this.mti] >>>= 0;
      }, L.prototype.init_by_array = function(d, m) {
        var v = 1, k = 0, O, G;
        for (this.init_genrand(19650218), O = this.N > m ? this.N : m; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1664525 << 16) + (G & 65535) * 1664525) + d[k] + k, this.mt[v] >>>= 0, v++, k++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1), k >= m && (k = 0);
        for (O = this.N - 1; O; O--)
          G = this.mt[v - 1] ^ this.mt[v - 1] >>> 30, this.mt[v] = (this.mt[v] ^ (((G & 4294901760) >>> 16) * 1566083941 << 16) + (G & 65535) * 1566083941) - v, this.mt[v] >>>= 0, v++, v >= this.N && (this.mt[0] = this.mt[this.N - 1], v = 1);
        this.mt[0] = 2147483648;
      }, L.prototype.genrand_int32 = function() {
        var d, m = new Array(0, this.MATRIX_A);
        if (this.mti >= this.N) {
          var v;
          for (this.mti === this.N + 1 && this.init_genrand(5489), v = 0; v < this.N - this.M; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + this.M] ^ d >>> 1 ^ m[d & 1];
          for (; v < this.N - 1; v++)
            d = this.mt[v] & this.UPPER_MASK | this.mt[v + 1] & this.LOWER_MASK, this.mt[v] = this.mt[v + (this.M - this.N)] ^ d >>> 1 ^ m[d & 1];
          d = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK, this.mt[this.N - 1] = this.mt[this.M - 1] ^ d >>> 1 ^ m[d & 1], this.mti = 0;
        }
        return d = this.mt[this.mti++], d ^= d >>> 11, d ^= d << 7 & 2636928640, d ^= d << 15 & 4022730752, d ^= d >>> 18, d >>> 0;
      }, L.prototype.genrand_int31 = function() {
        return this.genrand_int32() >>> 1;
      }, L.prototype.genrand_real1 = function() {
        return this.genrand_int32() * (1 / 4294967295);
      }, L.prototype.random = function() {
        return this.genrand_int32() * (1 / 4294967296);
      }, L.prototype.genrand_real3 = function() {
        return (this.genrand_int32() + 0.5) * (1 / 4294967296);
      }, L.prototype.genrand_res53 = function() {
        var d = this.genrand_int32() >>> 5, m = this.genrand_int32() >>> 6;
        return (d * 67108864 + m) * (1 / 9007199254740992);
      };
      var N = function() {
      };
      N.prototype.VERSION = "1.0.1", N.prototype.safe_add = function(m, v) {
        var k = (m & 65535) + (v & 65535), O = (m >> 16) + (v >> 16) + (k >> 16);
        return O << 16 | k & 65535;
      }, N.prototype.bit_roll = function(d, m) {
        return d << m | d >>> 32 - m;
      }, N.prototype.md5_cmn = function(d, m, v, k, O, G) {
        return this.safe_add(this.bit_roll(this.safe_add(this.safe_add(m, d), this.safe_add(k, G)), O), v);
      }, N.prototype.md5_ff = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & v | ~m & k, d, m, O, G, H);
      }, N.prototype.md5_gg = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m & k | v & ~k, d, m, O, G, H);
      }, N.prototype.md5_hh = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(m ^ v ^ k, d, m, O, G, H);
      }, N.prototype.md5_ii = function(d, m, v, k, O, G, H) {
        return this.md5_cmn(v ^ (m | ~k), d, m, O, G, H);
      }, N.prototype.binl_md5 = function(d, m) {
        d[m >> 5] |= 128 << m % 32, d[(m + 64 >>> 9 << 4) + 14] = m;
        var v, k, O, G, H, j = 1732584193, F = -271733879, z = -1732584194, W = 271733878;
        for (v = 0; v < d.length; v += 16)
          k = j, O = F, G = z, H = W, j = this.md5_ff(j, F, z, W, d[v], 7, -680876936), W = this.md5_ff(W, j, F, z, d[v + 1], 12, -389564586), z = this.md5_ff(z, W, j, F, d[v + 2], 17, 606105819), F = this.md5_ff(F, z, W, j, d[v + 3], 22, -1044525330), j = this.md5_ff(j, F, z, W, d[v + 4], 7, -176418897), W = this.md5_ff(W, j, F, z, d[v + 5], 12, 1200080426), z = this.md5_ff(z, W, j, F, d[v + 6], 17, -1473231341), F = this.md5_ff(F, z, W, j, d[v + 7], 22, -45705983), j = this.md5_ff(j, F, z, W, d[v + 8], 7, 1770035416), W = this.md5_ff(W, j, F, z, d[v + 9], 12, -1958414417), z = this.md5_ff(z, W, j, F, d[v + 10], 17, -42063), F = this.md5_ff(F, z, W, j, d[v + 11], 22, -1990404162), j = this.md5_ff(j, F, z, W, d[v + 12], 7, 1804603682), W = this.md5_ff(W, j, F, z, d[v + 13], 12, -40341101), z = this.md5_ff(z, W, j, F, d[v + 14], 17, -1502002290), F = this.md5_ff(F, z, W, j, d[v + 15], 22, 1236535329), j = this.md5_gg(j, F, z, W, d[v + 1], 5, -165796510), W = this.md5_gg(W, j, F, z, d[v + 6], 9, -1069501632), z = this.md5_gg(z, W, j, F, d[v + 11], 14, 643717713), F = this.md5_gg(F, z, W, j, d[v], 20, -373897302), j = this.md5_gg(j, F, z, W, d[v + 5], 5, -701558691), W = this.md5_gg(W, j, F, z, d[v + 10], 9, 38016083), z = this.md5_gg(z, W, j, F, d[v + 15], 14, -660478335), F = this.md5_gg(F, z, W, j, d[v + 4], 20, -405537848), j = this.md5_gg(j, F, z, W, d[v + 9], 5, 568446438), W = this.md5_gg(W, j, F, z, d[v + 14], 9, -1019803690), z = this.md5_gg(z, W, j, F, d[v + 3], 14, -187363961), F = this.md5_gg(F, z, W, j, d[v + 8], 20, 1163531501), j = this.md5_gg(j, F, z, W, d[v + 13], 5, -1444681467), W = this.md5_gg(W, j, F, z, d[v + 2], 9, -51403784), z = this.md5_gg(z, W, j, F, d[v + 7], 14, 1735328473), F = this.md5_gg(F, z, W, j, d[v + 12], 20, -1926607734), j = this.md5_hh(j, F, z, W, d[v + 5], 4, -378558), W = this.md5_hh(W, j, F, z, d[v + 8], 11, -2022574463), z = this.md5_hh(z, W, j, F, d[v + 11], 16, 1839030562), F = this.md5_hh(F, z, W, j, d[v + 14], 23, -35309556), j = this.md5_hh(j, F, z, W, d[v + 1], 4, -1530992060), W = this.md5_hh(W, j, F, z, d[v + 4], 11, 1272893353), z = this.md5_hh(z, W, j, F, d[v + 7], 16, -155497632), F = this.md5_hh(F, z, W, j, d[v + 10], 23, -1094730640), j = this.md5_hh(j, F, z, W, d[v + 13], 4, 681279174), W = this.md5_hh(W, j, F, z, d[v], 11, -358537222), z = this.md5_hh(z, W, j, F, d[v + 3], 16, -722521979), F = this.md5_hh(F, z, W, j, d[v + 6], 23, 76029189), j = this.md5_hh(j, F, z, W, d[v + 9], 4, -640364487), W = this.md5_hh(W, j, F, z, d[v + 12], 11, -421815835), z = this.md5_hh(z, W, j, F, d[v + 15], 16, 530742520), F = this.md5_hh(F, z, W, j, d[v + 2], 23, -995338651), j = this.md5_ii(j, F, z, W, d[v], 6, -198630844), W = this.md5_ii(W, j, F, z, d[v + 7], 10, 1126891415), z = this.md5_ii(z, W, j, F, d[v + 14], 15, -1416354905), F = this.md5_ii(F, z, W, j, d[v + 5], 21, -57434055), j = this.md5_ii(j, F, z, W, d[v + 12], 6, 1700485571), W = this.md5_ii(W, j, F, z, d[v + 3], 10, -1894986606), z = this.md5_ii(z, W, j, F, d[v + 10], 15, -1051523), F = this.md5_ii(F, z, W, j, d[v + 1], 21, -2054922799), j = this.md5_ii(j, F, z, W, d[v + 8], 6, 1873313359), W = this.md5_ii(W, j, F, z, d[v + 15], 10, -30611744), z = this.md5_ii(z, W, j, F, d[v + 6], 15, -1560198380), F = this.md5_ii(F, z, W, j, d[v + 13], 21, 1309151649), j = this.md5_ii(j, F, z, W, d[v + 4], 6, -145523070), W = this.md5_ii(W, j, F, z, d[v + 11], 10, -1120210379), z = this.md5_ii(z, W, j, F, d[v + 2], 15, 718787259), F = this.md5_ii(F, z, W, j, d[v + 9], 21, -343485551), j = this.safe_add(j, k), F = this.safe_add(F, O), z = this.safe_add(z, G), W = this.safe_add(W, H);
        return [j, F, z, W];
      }, N.prototype.binl2rstr = function(d) {
        var m, v = "";
        for (m = 0; m < d.length * 32; m += 8)
          v += String.fromCharCode(d[m >> 5] >>> m % 32 & 255);
        return v;
      }, N.prototype.rstr2binl = function(d) {
        var m, v = [];
        for (v[(d.length >> 2) - 1] = void 0, m = 0; m < v.length; m += 1)
          v[m] = 0;
        for (m = 0; m < d.length * 8; m += 8)
          v[m >> 5] |= (d.charCodeAt(m / 8) & 255) << m % 32;
        return v;
      }, N.prototype.rstr_md5 = function(d) {
        return this.binl2rstr(this.binl_md5(this.rstr2binl(d), d.length * 8));
      }, N.prototype.rstr_hmac_md5 = function(d, m) {
        var v, k = this.rstr2binl(d), O = [], G = [], H;
        for (O[15] = G[15] = void 0, k.length > 16 && (k = this.binl_md5(k, d.length * 8)), v = 0; v < 16; v += 1)
          O[v] = k[v] ^ 909522486, G[v] = k[v] ^ 1549556828;
        return H = this.binl_md5(O.concat(this.rstr2binl(m)), 512 + m.length * 8), this.binl2rstr(this.binl_md5(G.concat(H), 640));
      }, N.prototype.rstr2hex = function(d) {
        var m = "0123456789abcdef", v = "", k, O;
        for (O = 0; O < d.length; O += 1)
          k = d.charCodeAt(O), v += m.charAt(k >>> 4 & 15) + m.charAt(k & 15);
        return v;
      }, N.prototype.str2rstr_utf8 = function(d) {
        return unescape(encodeURIComponent(d));
      }, N.prototype.raw_md5 = function(d) {
        return this.rstr_md5(this.str2rstr_utf8(d));
      }, N.prototype.hex_md5 = function(d) {
        return this.rstr2hex(this.raw_md5(d));
      }, N.prototype.raw_hmac_md5 = function(d, m) {
        return this.rstr_hmac_md5(this.str2rstr_utf8(d), this.str2rstr_utf8(m));
      }, N.prototype.hex_hmac_md5 = function(d, m) {
        return this.rstr2hex(this.raw_hmac_md5(d, m));
      }, N.prototype.md5 = function(d, m, v) {
        return m ? v ? this.raw_hmac_md5(m, d) : this.hex_hmac_md5(m, d) : v ? this.raw_md5(d) : this.hex_md5(d);
      }, t.exports && (e = t.exports = u), e.Chance = u, typeof importScripts < "u" && (chance = new u(), self.Chance = u), typeof window == "object" && typeof window.document == "object" && (window.Chance = u, window.chance = new u());
    })();
  }(tB, tB.exports)), tB.exports;
}
var sEt = oEt();
const lEt = /* @__PURE__ */ Gi(sEt);
xVe()(
  ho.object({
    id: ho.number(),
    requester_id: ho.number(),
    created_at: ho.string(),
    updated_at: ho.string(),
    subject: ho.string(),
    description: ho.string(),
    status: rEt,
    priority: aEt,
    via: ho.object({
      channel: ho.string()
    }),
    assignee_email: ho.string(),
    tags: ho.array(ho.string()),
    custom_fields: ho.array(
      ho.object({
        id: ho.number(),
        value: ho.string()
      })
    ),
    allow_attachments: ho.boolean(),
    allow_channelback: ho.boolean(),
    followup_ids: ho.array(ho.number()),
    from_messaging_channel: ho.boolean(),
    has_incidents: ho.boolean(),
    is_public: ho.boolean(),
    url: ho.string()
  })
);
const j2 = new lEt(), cEt = (t) => iEt.parse({
  id: kkt(),
  description: j2.sentence(),
  caffieneAmount: j2.integer({ min: 0, max: 200 }),
  ...t
});
wVe(cEt, 3);
const uEt = (t) => ({
  accountSid: `AC${j2.string({
    length: 32,
    alpha: !0,
    numeric: !0
  })}`,
  age: j2.integer(),
  assignmentStatus: j2.pickone([
    "wrapping",
    "pending",
    "reserved",
    "completed"
  ]),
  addons: JSON.stringify({}),
  sid: `WT${j2.string({ length: 32, alpha: !0, numeric: !0 })}`,
  attributes: JSON.stringify({
    productCategory: j2.pickone([
      "support_billing",
      "support_email",
      "support_chat"
    ]),
    ticket_id: j2.integer()
  }),
  taskQueueSid: `WQ${j2.string({
    length: 32,
    alpha: !0,
    numeric: !0
  })}`,
  taskQueueFriendlyName: "support_chat_email",
  taskChannelSid: `TC${j2.string({
    length: 32,
    alpha: !0,
    numeric: !0
  })}`,
  taskChannelUniqueName: "chat",
  timeout: 86400,
  dateCreated: /* @__PURE__ */ new Date(),
  dateUpdated: /* @__PURE__ */ new Date(),
  ...t
});
wVe(uEt, 3);
new NUe();
const dEt = se.enum(["internal", "external"]);
se.enum([
  "support-engineering",
  "support-operations",
  "sales-operations"
]);
const lqe = se.string().min(2).refine(
  (t) => /^v\d+\.\d+\.\d+(-[a-zA-Z0-9]+(\.\d+)*)?$/.test(t ?? ""),
  "Invalid entity version format"
), fEt = se.object({
  team: se.string(),
  slackChannel: se.string()
}), cqe = se.object({
  name: Nt,
  description: Nt,
  tags: se.string().array().optional(),
  // This allows the developer to choose multiple audiences from the enum
  audience: se.array(dEt),
  contact: fEt.optional()
}), t2 = se.object({
  apiVersion: lqe,
  kind: Nt,
  id: Nt
}).extend(cqe.shape), hEt = se.object({
  apiVersion: lqe,
  kind: Nt,
  id: Nt,
  metadata: cqe
}), r2 = (t) => hEt.extend({
  spec: t
});
v0();
const pEt = v0(), n2 = v0(), mEt = v0(), gEt = v0(), uqe = RUe(), vEt = RUe(), dqe = v0(), uz = v0(), yEt = v0(), Us = {
  USER_MESSAGE: "USER_MESSAGE",
  ASSISTANT_MESSAGE: "ASSISTANT_MESSAGE",
  ASSISTANT_CALL: "ASSISTANT_CALL",
  ASSISTANT_RETURN: "ASSISTANT_RETURN",
  TOOL_CALL: "TOOL_CALL",
  SYSTEM_CONTEXT: "SYSTEM_CONTEXT",
  ASSISTANT_PLAN: "ASSISTANT_PLAN",
  RETRIEVE_KNOWLEDGE: "RETRIEVE_KNOWLEDGE",
  CONVERSATION_FEEDBACK: "CONVERSATION_FEEDBACK",
  GENERATE_BLOCK_INSTANCE: "GENERATE_BLOCK_INSTANCE",
  TRANSFER_CONVERSATION_TO_HUMAN: "TRANSFER_CONVERSATION_TO_HUMAN",
  ASSIGN_TASK: "ASSIGN_TASK",
  COMPLETE_TASK: "COMPLETE_TASK",
  UPDATE_CANVAS: "UPDATE_CANVAS",
  GATE: "GATE"
}, bEt = se.nativeEnum(
  Us
), dz = se.record(se.any()), fz = se.record(se.any()), Kd = se.record(se.any()), hz = se.record(se.string()), N9 = {
  ERROR: "error",
  LOADING_MESSAGE: "loadingMessage",
  CONTENT: "content",
  DONE: "done",
  CANVAS_CONTENT: "canvasContent",
  CANVAS_DONE: "canvasDone"
}, a2 = {
  ARRAY_CONTAINS: "array_contains",
  EQUALS: "equals",
  LESS_THAN_OR_EQUAL: "lte",
  GREATER_THAN_OR_EQUAL: "gte"
}, i2 = (t, e, r) => se.object({
  property: se.literal(t),
  operator: se.literal(e),
  value: r
}), DK = {};
function o2(t, e, r, n) {
  DK[t] || (DK[t] = {}), DK[t][e] = { schema: r, transformer: n };
}
const fqe = se.object({
  tag: Nt,
  attributes: se.record(Nt).optional(),
  text: Nt.optional(),
  children: se.lazy(() => fqe.array()).optional()
}), mx = {
  default: "default",
  transient: "transient"
}, xEt = se.object({
  type: se.literal("renderer")
}), CEt = se.object({
  type: se.literal("html"),
  node: fqe
}), hqe = se.union([
  xEt,
  CEt
]), CT = se.record(se.any()), pqe = t2.extend({
  valuesSchema: CT,
  exampleValues: CT,
  display: hqe,
  displayPersistence: se.nativeEnum(mx).default(mx.default)
}), zI = se.object({
  id: Nt,
  values: CT,
  displayPersistence: se.nativeEnum(mx).default(mx.default)
}), wEt = r2(
  se.object({
    valuesSchema: Kd,
    exampleValues: CT,
    display: hqe,
    displayPersistence: se.nativeEnum(mx).default(mx.default)
  })
), SEt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  valuesSchema: t.spec.valuesSchema,
  exampleValues: t.spec.exampleValues,
  display: t.spec.display,
  displayPersistence: t.spec.displayPersistence
});
o2(
  "Block",
  "v1.0.0",
  wEt,
  SEt
);
const m8 = se.object({
  id: yEt,
  createdAt: se.date(),
  updatedAt: se.date(),
  text: se.string(),
  canvasId: uz
});
se.object({
  text: se.string(),
  canvasId: uz
});
se.object({
  text: se.string()
});
se.object({
  text: se.string()
});
se.object({
  text: se.string()
});
const H5 = se.object({
  id: uz,
  createdAt: se.date(),
  updatedAt: se.date(),
  canvasVersions: se.array(m8).optional(),
  conversationId: n2
});
H5.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0
});
se.object({
  conversationId: n2
});
se.object({});
se.object({});
const _Et = {
  High: "High",
  Medium: "Medium",
  Low: "Low"
}, mqe = se.object({
  label: Nt,
  information: Kd
}), gqe = t2.extend({
  additionalOutputsSchema: Kd.optional(),
  categories: se.array(mqe)
}), kEt = r2(
  se.object({
    categories: se.array(mqe),
    additionalOutputs: se.record(se.any()).optional()
  })
), AEt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  additionalOutputs: t.spec.additionalOutputs,
  categories: t.spec.categories
});
o2(
  "Classifier",
  "v1.0.0",
  kEt,
  AEt
);
const TEt = se.object({
  reasoning: Nt,
  label: Nt,
  confidence: se.nativeEnum(_Et),
  additionalOutputs: se.record(se.any()).optional()
}), db = {
  Local: "local",
  Dev: "dev",
  Stage: "stage",
  Prod: "prod"
};
se.nativeEnum(db);
const EEt = se.object({
  type: se.literal("abba"),
  role: se.string(),
  documentation: se.string()
}), IEt = se.object({
  type: se.literal("otk"),
  service: se.string(),
  documentation: se.string()
}), MEt = se.object({
  type: se.literal("external"),
  name: se.string(),
  documentation: se.string()
}), PEt = se.discriminatedUnion("type", [
  EEt,
  IEt,
  MEt
]), vqe = se.object({
  mockResponse: Nt.optional(),
  loadingMessage: Nt,
  source: se.object({
    fn: Nt
  }).optional(),
  upstream: PEt,
  request: se.object({
    url: Nt,
    method: Nt.optional(),
    data: Kd.optional(),
    headers: Kd.optional(),
    params: Kd.optional()
  }).optional(),
  config: se.object({
    [db.Local]: Kd.optional(),
    [db.Dev]: Kd.optional(),
    [db.Stage]: Kd.optional(),
    [db.Prod]: Kd.optional()
  }).optional(),
  inputSchema: Kd,
  exampleInput: fz,
  optionsSchema: Kd,
  exampleOptions: dz,
  requiresAuthentication: se.boolean()
}), q1e = t2.extend({
  ...vqe.shape
}).refine(
  (t) => t.source || t.request,
  {
    message: "Either source or request must be provided",
    path: ["source", "request"]
  }
), REt = r2(vqe), OEt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  loadingMessage: t.spec.loadingMessage,
  request: t.spec.request,
  config: t.spec.config,
  inputSchema: t.spec.inputSchema,
  exampleInput: t.spec.exampleInput,
  optionsSchema: t.spec.optionsSchema,
  source: t.spec.source,
  exampleOptions: t.spec.exampleOptions,
  mockResponse: t.spec.mockResponse,
  requiresAuthentication: t.spec.requiresAuthentication,
  upstream: t.spec.upstream
});
o2(
  "Tool",
  "v1.0.0",
  REt,
  OEt
);
const yqe = se.object({
  tool: q1e,
  options: dz
}), K1e = t2.extend({
  toolInstance: yqe,
  input: se.object({
    prompt: Nt
  }),
  output: se.object({
    prompt: Nt,
    block: se.object({
      id: Nt
    })
  })
}), BEt = r2(
  se.object({
    input: se.object({
      prompt: Nt
    }),
    output: se.object({
      prompt: Nt,
      block: se.object({
        id: Nt
      })
    }),
    toolInstance: se.object({
      tool: se.object({ id: Nt }),
      options: se.record(se.any())
    })
  })
), NEt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  toolInstance: t.spec.toolInstance,
  input: t.spec.input,
  output: t.spec.output
});
o2(
  "Component",
  "v1.0.0",
  BEt,
  NEt
);
const y5 = se.union([
  Qk,
  // Twilio
  S_,
  // Sendgrid
  s5,
  // Unauthenticated
  cUe
  // E2 User
]), GI = se.union([
  Ov,
  S_
]), Z1e = se.object({
  type: se.literal("twilio")
}), $Et = Z1e.extend({
  isAuthenticated: se.literal(!1),
  userId: s5,
  accountId: se.literal(void 0),
  sessionId: s5
}), DEt = Z1e.extend({
  isAuthenticated: se.literal(!0),
  userId: Qk,
  accountId: Ov,
  userSid: Qk,
  accountSid: Ov,
  parentAccountSid: Ov.optional(),
  sessionId: s5,
  accessToken: se.string().optional()
}), LEt = se.union([
  DEt,
  $Et
]), jEt = Z1e.extend({
  isAuthenticated: se.literal(!0),
  userId: Qk,
  accountId: Ov.optional()
}), bqe = se.object({
  type: se.literal("sendgrid")
}), FEt = bqe.extend({
  isAuthenticated: se.literal(!1),
  userId: s5,
  accountId: se.literal(void 0),
  sessionId: s5
}), zEt = bqe.extend({
  isAuthenticated: se.literal(!0),
  userId: S_,
  accountId: S_,
  sendgridUserId: S_,
  sessionId: s5
}), GEt = se.union([
  zEt,
  FEt
]), WEt = se.object({
  type: se.literal("e2-user")
}), HEt = WEt.extend({
  isAuthenticated: se.literal(!0),
  userId: cUe,
  userSids: Qk.array(),
  // TODO: Refactor other WiseOwlUser types to use AccountSIDParser.array(), user can have multiple accounts
  accountId: Ov.optional(),
  accountIds: Ov.array(),
  accessToken: se.string().optional()
});
se.union([
  LEt,
  jEt,
  GEt,
  HEt
]);
se.object({
  firstName: Nt,
  lastName: Nt,
  accountSid: se.string().optional(),
  userSid: se.string().optional(),
  sendGridUserId: se.string().optional(),
  /**
   * Live Chat requires email address as an identity
   */
  emailAddr: se.string().optional(),
  /**
   * Can serve multiple purposes, but currently used for:
   * - OSC unauthenticated users
   */
  sessionId: se.string().optional()
});
const UEt = {
  APPLICATION: "application",
  ASSISTANT: "assistant"
}, VEt = {
  ASSISTANT: "assistant",
  TOOL: "tool"
}, qEt = se.object({
  type: se.nativeEnum(UEt),
  id: se.string()
}), KEt = se.object({
  type: se.nativeEnum(VEt),
  id: se.string()
}), J1e = se.object({
  caller: qEt,
  called: KEt
}), vf = se.object({
  id: pEt,
  createdAt: se.coerce.date(),
  updatedAt: se.coerce.date(),
  userId: y5,
  accountId: GI.optional(),
  runId: dqe,
  depth: se.number(),
  type: bEt,
  elapsedTime: se.number(),
  assistantId: Nt,
  promptTokens: se.number(),
  completionTokens: se.number(),
  totalTokens: se.number()
}), r4e = se.object({
  context: J1e,
  ask: Nt.describe("The ask for the assistant")
}), Y1e = vf.extend({
  type: se.literal(Us.ASSISTANT_CALL),
  values: r4e,
  redactedValues: r4e
}), xqe = se.object({
  sourceId: Nt,
  sourceName: Nt,
  uri: Nt,
  title: Nt,
  preview: Nt,
  badgeColor: Nt
}), xv = se.object({
  kendraIndexId: Nt,
  kendraDataSourceId: Nt
}), X1e = t2.extend({
  local: xv,
  dev: xv,
  stage: xv,
  prod: xv,
  badgeColor: Nt
}), ZEt = r2(
  se.object({
    local: xv,
    dev: xv,
    stage: xv,
    prod: xv,
    badgeColor: Nt
  })
), JEt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  local: t.spec.local,
  dev: t.spec.dev,
  stage: t.spec.stage,
  prod: t.spec.prod,
  badgeColor: t.spec.badgeColor
});
o2(
  "KnowledgeSource",
  "v1.0.0",
  ZEt,
  JEt
);
const U5 = se.object({
  id: mEt,
  createdAt: se.coerce.date(),
  updatedAt: se.coerce.date(),
  userId: y5,
  messageId: $I,
  accountId: GI.optional(),
  type: BUe,
  content: Nt.optional()
});
U5.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  userId: !0,
  accountId: !0
});
U5.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0
});
U5.omit({
  createdAt: !0,
  updatedAt: !0,
  userId: !0,
  accountId: !0
}).partial({
  type: !0
});
U5.omit({
  createdAt: !0,
  updatedAt: !0
}).partial({
  type: !0
});
const Cqe = se.object({
  label: Nt,
  value: Nt
}), YEt = se.object({
  id: se.literal("ticket-submission"),
  redirectLink: Nt.optional(),
  ticketUrl: Nt.optional()
}), XEt = se.object({
  id: se.literal("phone-support"),
  supportPhoneNumber: Nt.optional(),
  upgradeLink: Nt.optional(),
  ticketUrl: Nt.optional()
}), QEt = se.object({
  id: se.literal("live-chat"),
  productCategories: se.array(Cqe).optional(),
  upgradeLink: Nt.optional(),
  ticketUrl: Nt.optional()
}), eIt = se.array(
  se.discriminatedUnion("id", [
    YEt,
    XEt,
    QEt
  ])
), wqe = se.record(
  se.nativeEnum(db),
  eIt
), tIt = se.object({
  isEntitled: se.boolean(),
  isOpen: se.boolean(),
  cardValues: se.object({
    heading: se.string(),
    body: se.string().optional(),
    buttonLabel: se.string()
  }).optional(),
  inferredProductCategory: se.string().optional(),
  inferredSummary: se.string().optional(),
  productCategories: se.array(Cqe).optional(),
  upgradeLink: se.string().optional()
}), rIt = se.object({
  isEntitled: se.boolean(),
  cardValues: se.object({
    heading: se.string(),
    body: se.string().optional(),
    buttonLabel: se.string(),
    modalBody: se.string().optional()
  }).optional(),
  supportPhoneNumber: Nt.optional(),
  upgradeLink: se.string().optional()
}), nIt = se.object({
  isEntitled: se.boolean(),
  cardValues: se.object({
    heading: se.string(),
    body: se.string().optional(),
    buttonLabel: se.string()
  }).optional(),
  inferredSubject: se.string().optional(),
  inferredDescription: se.string().optional(),
  // modifying this introduces circular dep
  conversationId: se.custom().optional(),
  redirectLink: se.string().optional()
}), Sqe = se.object({
  liveChat: tIt,
  phoneSupport: rIt,
  ticketSubmission: nIt
}), aIt = se.object({
  loading: se.boolean(),
  options: Sqe.optional()
}), e0 = {
  BLOCK: "BLOCK",
  MARKDOWN: "MARKDOWN",
  CANVAS_PREVIEW: "CANVAS_PREVIEW",
  TRANSFER_CONVERSATION_TO_HUMAN: "TRANSFER_CONVERSATION_TO_HUMAN",
  GATE: "GATE"
}, iIt = se.object({
  type: se.literal(e0.CANVAS_PREVIEW)
}), oIt = se.object({
  type: se.literal(e0.BLOCK),
  block: zI
}), sIt = se.object({
  type: se.literal(e0.MARKDOWN),
  content: Nt
}), lIt = se.object({
  type: se.literal(e0.TRANSFER_CONVERSATION_TO_HUMAN),
  data: aIt
}), cIt = se.object({
  loginText: se.string(),
  signUpText: se.string()
}), uIt = se.object({
  type: se.literal(e0.GATE),
  data: cIt
}), Kce = se.discriminatedUnion("type", [
  oIt,
  sIt,
  iIt,
  lIt,
  uIt
]), _qe = se.object({
  id: $I,
  // Note to self. Coercing these to strings because we can't store dates in
  // Redux which makes this hard to use on the FE.
  createdAt: se.coerce.string(),
  updatedAt: se.coerce.string(),
  runId: dqe,
  conversationId: n2,
  userId: y5,
  accountId: GI.optional(),
  role: se.nativeEnum(Mu),
  messageId: se.string().optional()
}), pz = _qe.extend({
  role: se.literal(Mu.USER),
  content: Nt,
  redactedContent: Nt.optional()
}), g8 = _qe.extend({
  role: se.literal(Mu.ASSISTANT),
  complete: se.boolean(),
  parts: Kce.array(),
  redactedParts: Kce.array().optional(),
  retrievedKnowledge: xqe.array(),
  feedback: U5.optional()
}), kqe = se.discriminatedUnion("role", [
  pz,
  g8
]), Aqe = {
  id: !0,
  createdAt: !0,
  updatedAt: !0
}, dIt = pz.omit(
  Aqe
).extend({
  createdAt: se.date().optional()
}), fIt = g8.omit({
  ...Aqe,
  feedback: !0
}).extend({ createdAt: se.date().optional() });
se.discriminatedUnion(
  "role",
  [dIt, fIt]
);
const Tqe = {
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  userId: !0,
  accountId: !0
}, hIt = g8.omit({
  ...Tqe,
  feedback: !0
}).extend({
  createdAt: se.date().optional()
}), pIt = pz.omit(
  Tqe
).extend({
  createdAt: se.date().optional()
});
se.discriminatedUnion(
  "role",
  [
    pIt,
    hIt
  ]
);
const Eqe = se.object({
  role: se.literal(Mu.ASSISTANT),
  complete: se.literal(!1),
  parts: Kce.array()
}), mIt = se.object({
  role: se.literal(Mu.USER),
  content: Nt
});
se.discriminatedUnion("role", [
  mIt,
  Eqe
]);
const n4e = se.object({
  context: J1e,
  message: g8
}), Q1e = vf.extend({
  type: se.literal(Us.ASSISTANT_RETURN),
  values: n4e,
  redactedValues: n4e
}), a4e = se.object({
  toolId: Nt,
  context: J1e,
  input: fz,
  options: dz,
  requestConfig: Kd,
  output: Nt,
  // This is different than the totalTokens attribute on
  // BaseConversationEvent. That is intended to track the tokens that we
  // actually spend on completion. Separately, it is also useful to know the
  // actual size of a tool call output. This is what this attribute tracks.
  // The totalTokens on this event will be 0 since the tool call output tokens
  // are incorporated into the planEvent totalTokens
  tokens: se.number()
}), e2e = vf.extend({
  type: se.literal(Us.TOOL_CALL),
  values: a4e,
  redactedValues: a4e
}), i4e = se.object({
  systemContext: hz
}), t2e = vf.extend({
  type: se.literal(Us.SYSTEM_CONTEXT),
  values: i4e,
  redactedValues: i4e
}), y0 = {
  RESPOND: "respond",
  CALL_TOOL: "call-tool",
  RETRIEVE_KNOWLEDGE: "retrieve-knowledge",
  GENERATE_BLOCK_INSTANCE: "generate-block-instance",
  TRANSFER_CONVERSATION_TO_HUMAN: "transfer-conversation-to-human",
  ASSIGN_TASK: "assign-task",
  COMPLETE_TASK: "complete-task",
  UPDATE_CANVAS: "update-canvas",
  CALL_ASSISTANT: "call-assistant"
}, Ty = se.object({
  prompt: Nt,
  thought: Nt,
  workflowId: Nt.nullable(),
  workflowNodeId: Nt.nullable()
}), gIt = Ty.extend({
  action: se.literal(y0.RESPOND),
  actionInput: se.object({
    response: Nt.describe("The response to the user")
  })
}), vIt = Ty.extend({
  action: se.literal(y0.UPDATE_CANVAS),
  actionInput: se.object({
    text: se.string().describe("The contents of the canvas")
  })
}), yIt = Ty.extend({
  action: se.literal(y0.CALL_TOOL),
  actionInput: se.object({
    toolId: Nt.describe("The ID of the tool to call"),
    toolInput: fz.describe("The input for the tool")
  })
}), bIt = Ty.extend({
  action: se.literal(y0.RETRIEVE_KNOWLEDGE),
  actionInput: se.object({
    query: Nt.describe("The query to retrieve knowledge for")
  })
}), xIt = Ty.extend({
  action: se.literal(y0.ASSIGN_TASK),
  actionInput: se.object({
    assistantId: Nt.describe(
      "The ID of the assistant to handoff to"
    ),
    task: Nt.describe("The context to handoff with")
  })
}), CIt = Ty.extend({
  action: se.literal(y0.COMPLETE_TASK),
  actionInput: se.object({
    output: Nt
  })
}), wIt = Ty.extend({
  action: se.literal(y0.GENERATE_BLOCK_INSTANCE),
  actionInput: se.object({
    blockId: Nt.describe(
      "The ID of the block to generate an instance of"
    ),
    values: CT.describe(
      "The values to use for the block instance"
    )
  })
}), SIt = Ty.extend({
  action: se.literal(y0.TRANSFER_CONVERSATION_TO_HUMAN),
  actionInput: se.object({
    reason: Nt.describe(
      "The summarization of why the customer wants to talk to a human"
    )
  })
}), _It = se.discriminatedUnion("action", [
  gIt,
  yIt,
  bIt,
  wIt,
  SIt,
  xIt,
  CIt,
  vIt
]), o4e = se.object({
  assistantId: Nt.describe(
    "The ID of the assistant doing the planning"
  ),
  plan: _It
}), r2e = vf.extend({
  type: se.literal(Us.ASSISTANT_PLAN),
  values: o4e,
  redactedValues: o4e
}), s4e = se.object({
  query: Nt,
  sourceIds: Nt.array(),
  retrievedKnowledge: xqe.array()
}), n2e = vf.extend({
  type: se.literal(Us.RETRIEVE_KNOWLEDGE),
  values: s4e,
  redactedValues: s4e
}), l4e = se.object({
  blockInstance: zI
}), a2e = vf.extend({
  type: se.literal(Us.GENERATE_BLOCK_INSTANCE),
  values: l4e,
  redactedValues: l4e
}), c4e = se.object({
  didInitiateTransfer: se.boolean(),
  reason: se.string()
}), i2e = vf.extend({
  type: se.literal(Us.TRANSFER_CONVERSATION_TO_HUMAN),
  values: c4e,
  redactedValues: c4e
}), u4e = se.object({
  assistantId: Nt,
  task: Nt
}), o2e = vf.extend({
  type: se.literal(Us.ASSIGN_TASK),
  values: u4e,
  redactedValues: u4e
}), d4e = se.object({
  output: Nt
}), s2e = vf.extend({
  type: se.literal(Us.COMPLETE_TASK),
  values: d4e,
  redactedValues: d4e
}), f4e = se.object({
  text: se.string()
}), l2e = vf.extend({
  type: se.literal(Us.UPDATE_CANVAS),
  values: f4e,
  redactedValues: f4e
}), h4e = se.object({
  pass: se.boolean(),
  description: Nt
}), c2e = vf.extend({
  type: se.literal(Us.GATE),
  values: h4e,
  redactedValues: h4e
}), kIt = se.discriminatedUnion("type", [
  Y1e,
  Q1e,
  e2e,
  t2e,
  r2e,
  n2e,
  a2e,
  i2e,
  o2e,
  s2e,
  l2e,
  c2e
]), N0 = {
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  userId: !0,
  accountId: !0
};
se.discriminatedUnion(
  "type",
  [
    Y1e.omit(N0),
    Q1e.omit(N0),
    e2e.omit(N0),
    t2e.omit(N0),
    r2e.omit(N0),
    n2e.omit(N0),
    a2e.omit(N0),
    i2e.omit(N0),
    o2e.omit(N0),
    s2e.omit(N0),
    l2e.omit(N0),
    c2e.omit(N0)
  ]
);
const $0 = {
  id: !0,
  createdAt: !0,
  updatedAt: !0
};
se.discriminatedUnion(
  "type",
  [
    Y1e.omit($0),
    Q1e.omit($0),
    e2e.omit($0),
    t2e.omit($0),
    r2e.omit($0),
    n2e.omit($0),
    a2e.omit($0),
    i2e.omit($0),
    o2e.omit($0),
    s2e.omit($0),
    l2e.omit($0),
    c2e.omit($0)
  ]
);
const v8 = se.object({
  id: Nt,
  instructions: Nt
}), AIt = v8.extend({
  type: se.literal(y0.CALL_TOOL),
  tool: se.object({
    id: Nt
  })
}), TIt = v8.extend({
  type: se.literal(y0.CALL_ASSISTANT),
  assistant: se.object({
    id: Nt
  })
}), EIt = v8.extend({
  type: se.literal("follow-workflow"),
  workflow: se.object({
    id: Nt
  })
}), IIt = v8.extend({
  type: se.literal(y0.GENERATE_BLOCK_INSTANCE),
  blockId: Nt
}), MIt = v8.extend({
  type: se.literal(y0.RETRIEVE_KNOWLEDGE)
}), PIt = v8.extend({
  type: se.literal(y0.RESPOND)
}), Iqe = se.discriminatedUnion("type", [
  AIt,
  TIt,
  EIt,
  MIt,
  PIt,
  IIt
]), Mqe = se.object({
  from: Nt,
  to: Nt,
  condition: Nt.optional()
}), u2e = t2.extend({
  whenToUse: Nt,
  graph: se.object({
    nodes: Iqe.array(),
    edges: Mqe.array()
  }),
  featureFlag: Nt.optional()
}), RIt = r2(
  se.object({
    whenToUse: Nt,
    graph: se.object({
      nodes: Iqe.array(),
      edges: Mqe.array()
    })
  })
), OIt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  whenToUse: t.spec.whenToUse,
  graph: {
    nodes: t.spec.graph.nodes.map((e) => e),
    edges: t.spec.graph.edges
  }
});
o2(
  "Workflow",
  "v1.0.0",
  RIt,
  OIt
);
const mz = t2.extend({
  objective: Nt,
  role: Nt,
  assistants: se.lazy(() => mz).array(),
  toolInstances: yqe.array(),
  workflows: u2e.array(),
  knowledgeSources: X1e.array(),
  promptSuffix: Nt.optional()
}), BIt = r2(
  se.object({
    objective: Nt,
    role: Nt,
    assistants: se.array(se.object({ id: Nt })),
    toolInstances: se.array(
      se.object({
        tool: se.object({
          id: Nt
        }),
        options: se.record(se.any())
      })
    ),
    workflows: se.object({
      id: Nt,
      featureFlag: Nt.optional()
    }).array(),
    knowledgeSources: se.object({
      id: Nt
    }).array(),
    promptSuffix: Nt.optional()
  })
), NIt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  objective: t.spec.objective,
  name: t.metadata.name,
  description: t.metadata.description,
  audience: t.metadata.audience,
  tags: t.metadata.tags,
  role: t.spec.role,
  assistants: t.spec.assistants.map(
    (e) => e
  ),
  toolInstances: t.spec.toolInstances.map(
    (e) => e
  ),
  workflows: t.spec.workflows.map((e) => e),
  knowledgeSources: t.spec.knowledgeSources.map(
    (e) => e
  ),
  promptSuffix: t.spec.promptSuffix
});
o2(
  "Assistant",
  "v1.0.0",
  BIt,
  NIt
);
const QN = {
  blocks: "blocks",
  canvas: "canvas",
  transferToHuman: "transferToHuman",
  promptLibrary: "promptLibrary"
}, Pqe = se.nativeEnum(QN), $It = se.array(zI), DIt = se.object({
  tool: se.object({
    id: Nt,
    options: se.record(se.any()),
    input: se.record(se.any())
  })
}), LIt = se.object({
  toolInstances: se.array(DIt)
}), Rqe = se.object({
  header: se.object({
    heading: Nt,
    secondaryHeading: Nt.optional(),
    subHeading: Nt.optional()
  }),
  legalDisclaimer: Nt.optional(),
  blocks: $It.optional(),
  applicationDynamicContent: LIt.optional()
}), Oqe = se.object({
  displayName: Nt,
  inputPlaceholder: Nt
}), Bqe = t2.extend({
  systemContext: hz,
  assistant: mz,
  ui: Oqe,
  home: Rqe,
  transfer: wqe.optional(),
  optionalFeatures: Pqe.array(),
  moreLinks: se.array(
    se.object({
      id: se.string().optional(),
      icon: Nt.optional(),
      label: Nt,
      href: se.string().url()
    })
  ).optional()
}), jIt = r2(
  se.object({
    systemContext: hz,
    assistant: se.object({ id: Nt }),
    home: Rqe,
    transfer: wqe.optional(),
    optionalFeatures: se.array(Pqe).optional(),
    ui: Oqe,
    moreLinks: se.array(
      se.object({
        id: se.string().optional(),
        icon: Nt.optional(),
        label: Nt,
        href: se.string().url()
      })
    ).optional()
  })
), FIt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  systemContext: t.spec.systemContext,
  assistant: t.spec.assistant,
  home: t.spec.home ?? void 0,
  transfer: t.spec.transfer ?? void 0,
  optionalFeatures: t.spec.optionalFeatures ?? [],
  moreLinks: t.spec.moreLinks ?? [],
  ui: t.spec.ui
});
o2(
  "Application",
  "v1.0.0",
  jIt,
  FIt
);
const zIt = v0(), gz = {
  EMAIL: "EMAIL",
  LIVE_CHAT: "LIVE_CHAT",
  PHONE: "PHONE"
}, vz = {
  INITIATED: "INITIATED",
  COMPLETE: "COMPLETE"
}, d2e = se.object({
  ticketId: se.number().optional(),
  liveChatId: se.string().optional()
}), GIt = se.object({
  id: zIt,
  conversationId: n2,
  channel: se.nativeEnum(gz).optional(),
  status: se.nativeEnum(vz),
  reason: se.string(),
  metadata: d2e.optional(),
  createdAt: se.date(),
  updatedAt: se.date()
});
se.object({
  conversationId: n2,
  channel: se.nativeEnum(gz).optional(),
  reason: se.string(),
  metadata: d2e.optional(),
  status: se.nativeEnum(vz).optional()
});
se.object({
  status: se.nativeEnum(vz).optional(),
  reason: se.string().optional(),
  metadata: d2e.optional(),
  channel: se.nativeEnum(gz).optional()
});
const y8 = se.object({
  id: n2,
  createdAt: se.coerce.date(),
  updatedAt: se.coerce.date(),
  userId: y5,
  accountId: GI.optional(),
  messages: kqe.array(),
  workflowIds: se.array(Nt),
  toolIds: se.array(Nt),
  applicationIds: se.array(Nt),
  canvas: H5.optional(),
  transfer: GIt.optional(),
  chatId: se.string().optional()
});
se.object({
  interruptedConversationId: n2.optional()
});
y8.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  accountId: !0,
  messages: !0,
  workflowIds: !0,
  toolIds: !0,
  applicationIds: !0,
  canvas: !0,
  transfer: !0
}).extend({ userId: y5.optional() });
const WIt = y8.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  userId: !0,
  accountId: !0,
  messages: !0,
  canvas: !0
});
y8.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  messages: !0,
  canvas: !0,
  transfer: !0
});
WIt.partial();
const Nqe = i2(
  "createdAt",
  a2.GREATER_THAN_OR_EQUAL,
  se.string().datetime()
), $qe = i2(
  "createdAt",
  a2.LESS_THAN_OR_EQUAL,
  se.string().datetime()
), Dqe = i2(
  "id",
  a2.EQUALS,
  Nt
), Lqe = i2(
  "applicationIds",
  a2.ARRAY_CONTAINS,
  se.array(Nt)
), jqe = i2(
  "toolIds",
  a2.ARRAY_CONTAINS,
  se.array(Nt)
), Fqe = i2(
  "workflowIds",
  a2.ARRAY_CONTAINS,
  se.array(Nt)
), zqe = i2(
  "accountId",
  a2.EQUALS,
  Nt
), HIt = i2(
  "userId",
  a2.EQUALS,
  Nt
), UIt = se.union([
  Dqe,
  Lqe,
  jqe,
  Fqe,
  zqe,
  HIt,
  Nqe,
  $qe
]), VIt = se.union([
  Dqe,
  Lqe,
  jqe,
  Fqe,
  zqe,
  Nqe,
  $qe
]), qIt = se.object({
  type: se.literal("select"),
  label: Nt,
  value: Nt,
  defaultOption: Nt,
  options: se.object({ value: Nt, label: Nt }).array()
});
se.record(Nt);
const KIt = qIt, Gqe = se.object({
  application: se.object({ id: Nt }),
  layout: se.object({
    grid: se.object({
      templateColumns: Nt,
      templateRows: Nt,
      gap: Nt
    }),
    items: se.object({
      gridColumn: Nt,
      gridRow: Nt
    }).array()
  }),
  inputs: KIt.array()
}), Wqe = t2.extend({
  ...Gqe.shape,
  components: K1e.array()
}), ZIt = r2(
  Gqe.extend({
    components: se.object({
      id: Nt
    }).array()
  })
), JIt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  application: t.spec.application,
  layout: t.spec.layout,
  inputs: t.spec.inputs,
  components: t.spec.components.map(
    (e) => e
  )
});
o2(
  "Page",
  "v1.0.0",
  ZIt,
  JIt
);
const f2e = se.object({
  id: Nt,
  label: Nt,
  validation: se.object({
    required: se.boolean()
  })
}), YIt = f2e.extend({
  type: se.literal("input"),
  inputType: Nt.optional(),
  placeholder: Nt.optional(),
  defaultValue: Nt.optional()
}), XIt = f2e.extend({
  type: se.literal("textarea"),
  placeholder: Nt.optional(),
  defaultValue: Nt.optional()
}), QIt = se.object({
  label: Nt,
  value: Nt
}), eMt = f2e.extend({
  type: se.literal("select"),
  options: QIt.array(),
  defaultValue: Nt.optional()
}), Hqe = se.union([
  YIt,
  XIt,
  eMt
]), Uqe = t2.extend({
  fields: Hqe.array(),
  controls: se.object({
    submit: se.object({
      text: Nt
    })
  })
}), tMt = r2(
  se.object({
    fields: Hqe.array(),
    controls: se.object({
      submit: se.object({
        text: Nt
      })
    })
  })
), rMt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  fields: t.spec.fields,
  controls: t.spec.controls
});
o2(
  "Form",
  "v1.0.0",
  tMt,
  rMt
);
const __ = {
  USER: "USER",
  GLOBAL: "GLOBAL"
}, nMt = se.object({
  label: Nt,
  key: Nt,
  default: Nt
}), V5 = se.object({
  id: gEt,
  createdAt: se.date(),
  updatedAt: se.date(),
  createdByUserId: y5,
  updatedByUserId: y5,
  createdByAccountId: GI.nullable().transform((t) => t ?? void 0).optional(),
  type: se.nativeEnum(__),
  name: Nt,
  description: Nt,
  template: Nt,
  variables: nMt.array(),
  applicationIds: Nt.array().describe("The applications that this prompt is associated with")
}), aMt = V5.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  createdByUserId: !0,
  updatedByUserId: !0,
  createdByAccountId: !0
}), iMt = V5.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0
});
aMt.partial();
iMt.partial();
const oMt = i2(
  "type",
  a2.EQUALS,
  se.nativeEnum(__)
), sMt = i2(
  "applicationIds",
  a2.ARRAY_CONTAINS,
  Nt.array()
), lMt = i2(
  "createdByUserId",
  a2.EQUALS,
  Nt
), Vqe = se.union([
  oMt,
  sMt,
  lMt
]);
se.object({
  conversationId: n2,
  liveChatId: Nt,
  token: Nt,
  identity: Nt,
  ticketId: se.number(),
  chatActivitySyncMapId: Nt
});
const cMt = se.object({
  liveChatId: Nt,
  token: Nt,
  identity: Nt,
  ticketId: se.number(),
  chatActivitySyncMapId: Nt
});
se.object({
  chatFriendlyName: Nt,
  customerFriendlyName: Nt,
  preEngagementData: Nt
});
se.object({
  conversationId: n2,
  liveChatId: Nt,
  identity: Nt,
  token: Nt,
  ticketId: se.number(),
  chatActivitySyncMapId: Nt
});
const uMt = se.object({
  type: se.literal("loading"),
  content: Nt
}), dMt = se.object({
  type: se.literal("content"),
  message: Eqe
}), fMt = se.object({
  type: se.literal("done"),
  message: se.tuple([pz, g8])
}), hMt = se.object({
  type: se.literal("error")
}), pMt = se.object({
  type: se.literal("canvas-content"),
  content: Nt
}), mMt = se.object({
  type: se.literal("canvas-done"),
  canvasId: uz
}), gMt = se.discriminatedUnion("type", [
  dMt,
  fMt,
  uMt,
  hMt,
  pMt,
  mMt
]);
se.object({
  conversation: y8
});
se.object({
  syncDocumentSid: Nt,
  accessToken: Nt
});
const qqe = (t) => Nt.refine(
  (e) => {
    try {
      return JSON.parse(e), !0;
    } catch {
      return !1;
    }
  },
  { message: "Invalid filters" }
).transform((e) => JSON.parse(e)).pipe(t.array()), vMt = se.object({
  limit: se.coerce.number().optional(),
  cursor: se.coerce.string().optional(),
  sortBy: se.coerce.string().optional(),
  order: se.coerce.string().optional(),
  filters: qqe(UIt).optional()
});
vMt.extend({
  filters: qqe(
    VIt
  ).optional()
});
se.object({
  conversations: y8.array(),
  page: se.object({
    hasPrevPage: se.boolean(),
    hasNextPage: se.boolean(),
    limit: se.number(),
    cursor: se.string().optional(),
    total: se.number()
  })
});
se.object({
  summary: se.object({
    description: se.string(),
    subject: se.string(),
    wasTranslated: se.boolean()
  })
});
se.object({
  conversation: y8,
  messages: kqe.array().optional(),
  liveChat: cMt.optional(),
  transferOptions: Sqe.optional()
});
se.object({
  applicationId: Nt
});
se.object({
  applicationId: Nt,
  input: Nt,
  streamMode: se.enum(["chunked", "sync"]).optional(),
  systemContext: hz
});
se.object({
  events: kIt.array()
});
se.object({
  feedback: U5
});
se.object({
  feedback: U5
});
se.object({
  components: K1e.array()
});
se.object({
  component: K1e
});
se.object({
  block: zI
});
se.object({
  pages: Wqe.array()
});
se.object({
  page: Wqe
});
se.object({
  tools: q1e.array()
});
se.object({
  tool: q1e
});
const yMt = se.object({
  input: fz,
  options: dz
});
se.object({
  output: Nt
});
se.object({
  assistants: mz.array()
});
se.object({
  assistant: mz
});
se.object({
  applications: Bqe.array()
});
se.object({
  application: Bqe
});
se.object({
  blocks: zI.array()
});
se.object({
  blocks: pqe.array()
});
se.object({
  block: pqe
});
se.object({
  simulations: se.array(se.string())
});
se.object({
  simulation: se.string()
});
se.object({
  workflows: u2e.array()
});
se.object({
  workflow: u2e
});
se.object({
  forms: Uqe.array()
});
se.object({
  form: Uqe
});
se.object({
  knowledgeSources: X1e.array()
});
se.object({
  knowledgeSource: X1e
});
const h2e = Nt.refine(
  (t) => {
    try {
      return JSON.parse(t), !0;
    } catch {
      return !1;
    }
  },
  { message: "Invalid filters" }
).transform((t) => JSON.parse(t)).pipe(Vqe.array());
se.object({
  limit: se.coerce.number().optional(),
  offset: se.coerce.number().optional(),
  filters: h2e.optional(),
  search: Nt.optional()
});
se.object({
  page: se.object({
    limit: se.number(),
    offset: se.number(),
    total: se.number()
  }),
  filters: Vqe.array(),
  search: Nt.optional(),
  prompts: V5.array()
});
se.object({
  prompt: V5
});
se.object({
  prompt: V5
});
se.object({
  prompt: V5
});
se.object({
  prompt: V5
});
se.object({
  classifiers: se.array(gqe)
});
se.object({
  classifier: gqe
});
se.object({
  classification: TEt
});
se.object({
  textToClassify: Nt
});
se.object({
  limit: se.coerce.number().optional(),
  offset: se.coerce.number().optional(),
  filters: h2e.optional(),
  search: Nt.optional()
});
se.object({
  page: se.object({
    limit: se.number(),
    offset: se.number(),
    total: se.number()
  }),
  canvases: H5.array()
});
se.object({
  canvas: H5
});
se.object({
  conversationId: n2
});
se.object({
  canvas: H5
});
se.object({});
se.object({
  canvas: H5
});
se.object({
  canvas: H5
});
se.object({
  limit: se.coerce.number().optional(),
  offset: se.coerce.number().optional(),
  filters: h2e.optional(),
  search: Nt.optional()
});
se.object({
  page: se.object({
    limit: se.number(),
    offset: se.number(),
    total: se.number()
  }),
  canvasVersions: m8.array()
});
se.object({
  canvasVersion: m8
});
se.object({
  text: se.string()
});
se.object({
  canvasVersion: m8
});
se.object({
  text: se.string()
});
se.object({
  canvasVersion: m8
});
se.object({
  canvasVersion: m8
});
const bMt = se.record(
  se.nativeEnum(db),
  /* Should be: AuthDetailsParser, but because it comes from shared/utils-unified-user-identification,
   * where Logger is used - which relies on async_hooks node modules - wise-owl-ui cannot build as it relies
   * on wise-owl-domain.
   *
   * In the future types/parserse there should be moved to wise-owl-domain. For now leaving as any().
   */
  se.any()
), xMt = {
  ENQUEUED: "ENQUEUED",
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}, CMt = se.nativeEnum(
  xMt
), wMt = {
  PASS: "PASS",
  FAIL: "FAIL"
}, SMt = se.nativeEnum(
  wMt
), p2e = se.object({
  id: vEt,
  simulationId: se.string(),
  runId: uqe,
  createdAt: se.date(),
  updatedAt: se.date(),
  url: se.string().nullable().optional(),
  errorDetails: se.string().nullable().optional(),
  rawResults: se.any().nullable().optional(),
  grade: SMt.nullable().optional(),
  status: CMt.optional()
});
p2e.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  url: !0,
  errorDetails: !0,
  rawResults: !0,
  status: !0,
  grade: !0
});
p2e.omit({
  id: !0,
  simulationId: !0,
  runId: !0,
  createdAt: !0,
  updatedAt: !0
});
const _Mt = {
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED"
}, kMt = se.nativeEnum(_Mt), Kqe = se.object({
  id: uqe,
  assistant: se.string(),
  filter: se.string().nullable().optional(),
  createdAt: se.date(),
  updatedAt: se.date(),
  completedAt: se.date().nullable().optional(),
  commit: se.string().nullable().optional(),
  status: kMt,
  evaluations: se.array(p2e).optional()
});
Kqe.omit({
  id: !0,
  createdAt: !0,
  updatedAt: !0,
  completedAt: !0,
  status: !0,
  evaluations: !0
}).extend({
  filter: se.string().optional(),
  commit: se.string().optional()
});
Kqe.omit({
  id: !0,
  assistant: !0,
  createdAt: !0,
  updatedAt: !0,
  commit: !0
});
const AMt = se.object({
  auth: bMt,
  context: se.string(),
  objective: se.string(),
  script: se.string().optional()
});
se.object({
  message: se.string(),
  objectiveComplete: se.boolean()
});
const m2e = se.object({
  maxTurns: se.number().optional(),
  customer: AMt,
  basePath: se.string().optional()
}), Zqe = m2e.extend({
  type: se.literal("wise-owl-framework")
}), TMt = m2e.extend({
  type: se.literal("wise-owl-legacy"),
  ingress: lz
}), EMt = se.discriminatedUnion("type", [
  Zqe,
  TMt
]), IMt = Zqe.extend({
  applicationId: se.string(),
  simulationId: se.string()
});
se.object({
  config: IMt
});
const MMt = m2e.extend({
  ingress: lz
});
se.object({
  config: MMt
});
const PMt = se.object({
  type: se.string(),
  value: se.union([se.string(), se.array(se.string())])
}), RMt = se.object({
  vars: se.object({
    prompt: se.string()
  }),
  assert: se.array(PMt)
}), OMt = se.object({
  id: se.string(),
  label: se.string(),
  config: EMt
}), Jqe = se.object({
  targets: se.array(OMt),
  tests: se.array(RMt)
});
t2.extend({
  ...Jqe.shape
});
const BMt = r2(Jqe), NMt = (t) => ({
  apiVersion: t.apiVersion,
  kind: t.kind,
  id: t.id,
  name: t.metadata.name,
  description: t.metadata.description,
  tags: t.metadata.tags,
  audience: t.metadata.audience,
  targets: t.spec.targets,
  tests: t.spec.tests
});
o2(
  "Simulation",
  "v1.0.0",
  BMt,
  NMt
);
const $Mt = {
  USER: "user",
  ASSISTANT: "assistant",
  SYSTEM: "system"
};
se.object({
  role: se.nativeEnum($Mt),
  content: se.string()
});
se.object({
  userId: Nt
});
const DMt = {
  Q1: "January_2021_Base_Forecast_Finance__c",
  Q2: "April_2021_Base_Forecast_Finance__c",
  Q3: "July_2021_Base_Forecast_Finance__c",
  Q4: "October_2021_Base_Forecast_Finance__c"
}, LMt = Math.ceil(((/* @__PURE__ */ new Date()).getMonth() + 1) / 3), jMt = DMt[`Q${LMt}`], FMt = se.object({
  "Account.Name": se.string(),
  "Account.CY_Comms_Territory__c": se.string(),
  [`Account.${jMt}`]: se.string().optional()
});
se.object({
  CloseDate: se.string(),
  ForecastCategoryName: se.string(),
  GTM_Product__c: se.string(),
  Incremental_ACV__c: se.number(),
  Name: se.string(),
  NextStep: se.string(),
  Opportunity_Age__c: se.number(),
  Owner_Name__c: se.string(),
  Owner_Mgr_Email__c: se.string(),
  StageName: se.string(),
  Opportunity_18_ID__c: se.string(),
  Account: FMt
});
const zMt = se.object({
  opportunityId: se.string(),
  accountName: se.string().nullable().optional(),
  closeDate: se.string().nullable().optional(),
  forecastCategoryName: se.string().nullable().optional(),
  gtmProduct: se.string().nullable().optional(),
  incrementalACV: se.number().nullable().optional(),
  opportunityName: se.string().nullable().optional(),
  nextStep: se.string().nullable().optional(),
  opportunityAge: se.number().nullable().optional(),
  ownerName: se.string().nullable().optional(),
  ownerManagerEmail: se.string().nullable().optional(),
  status: se.string().nullable().optional(),
  territoryName: se.string().nullable().optional(),
  revenuePacing: se.number().nullable().optional()
});
se.object({
  Target_Measure_B_Q1__c: se.number().optional(),
  Target_Measure_B_Q2__c: se.number().optional(),
  Target_Measure_B_Q3__c: se.number().optional(),
  Target_Measure_B_Q4__c: se.number().optional(),
  Target_Measure_A_Q1__c: se.number().optional(),
  Target_Measure_A_Q2__c: se.number().optional(),
  Target_Measure_A_Q3__c: se.number().optional(),
  Target_Measure_A_Q4__c: se.number().optional()
});
se.object({
  targetMeasureBQ1: se.number().optional(),
  targetMeasureBQ2: se.number().optional(),
  targetMeasureBQ3: se.number().optional(),
  targetMeasureBQ4: se.number().optional(),
  targetMeasureAQ1: se.number().optional(),
  targetMeasureAQ2: se.number().optional(),
  targetMeasureAQ3: se.number().optional(),
  targetMeasureAQ4: se.number().optional()
});
se.object({
  opportunities: zMt.array(),
  chart: se.object({
    revenuePacing: se.number(),
    closedWonTarget: se.number(),
    revenueTarget: se.number()
  })
});
const g2e = {
  AGENT: "AGENT",
  HELP_CENTER_ASSISTANT: "HCA"
}, Zce = {
  MultipleChoice: "mc",
  TextEntry: "te"
};
new NUe();
const yz = {
  helpCenter: "helpCenter",
  wiseOwl: "wiseOwl"
}, p4e = (t, e) => {
  const n = t.split("\0").map((s) => {
    try {
      return gMt.parse(JSON.parse(s));
    } catch {
      return s;
    }
  }), a = n.filter(
    (s) => typeof s != "string"
  ), i = n.filter(
    (s) => typeof s == "string" && s.length > 0
  );
  return a.forEach(e), i.map((s) => `${s}\0`).join("");
}, GMt = async (t, e, r) => {
  const { requestTransformer: n, ...a } = t, i = KWe({
    baseUrl: "undefined/v2/"
  }), o = n(a, yz.wiseOwl);
  return await i(o, e, r);
}, k_ = nHe({
  reducerPath: "wiseOwlApi",
  baseQuery: GMt,
  tagTypes: ["Conversation", "Prompts"],
  endpoints: (t) => ({
    getConversationSummary: t.query({
      query: ({ requestTransformer: e, conversationId: r }) => ({
        url: `conversations/${r}/summary`,
        method: "GET",
        requestTransformer: e
      })
    }),
    getWorkflow: t.query({
      query: ({ requestTransformer: e, workflowId: r }) => ({
        url: `workflows/${r}`,
        method: "GET",
        requestTransformer: e
      })
    }),
    listWorkflows: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "workflows/",
        requestTransformer: e
      })
    }),
    getPage: t.query({
      query: ({ requestTransformer: e, pageId: r }) => ({
        url: `pages/${r}`,
        requestTransformer: e
      })
    }),
    listPages: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "pages/",
        requestTransformer: e
      })
    }),
    getBlock: t.query({
      query: ({ requestTransformer: e, blockId: r }) => ({
        url: `blocks/${r}`,
        requestTransformer: e
      })
    }),
    listBlocks: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "blocks/",
        requestTransformer: e
      })
    }),
    getApplication: t.query({
      query: ({ requestTransformer: e, applicationId: r }) => ({
        url: `applications/${r}`,
        requestTransformer: e
      })
    }),
    listApplications: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "applications/",
        requestTransformer: e
      })
    }),
    getApplicationHome: t.query({
      query: ({ requestTransformer: e, applicationId: r }) => ({
        url: `applications/${r}/home/dynamicContent`,
        requestTransformer: e
      })
    }),
    getAssistant: t.query({
      query: ({ requestTransformer: e, assistantId: r }) => ({
        url: `assistants/${r}`,
        requestTransformer: e
      })
    }),
    listAssistants: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "assistants/",
        requestTransformer: e
      })
    }),
    listPrompts: t.query({
      query: ({ requestTransformer: e, offset: r, limit: n, search: a }) => ({
        url: `prompts?offset=${r}&limit=${n}${a && a.length > 1 ? `&search=${a}` : ""}`,
        requestTransformer: e
      }),
      providesTags: ["Prompts"]
    }),
    createPrompt: t.mutation({
      query: ({ requestTransformer: e, body: r }) => ({
        url: "prompts/",
        method: "POST",
        body: { ...r },
        requestTransformer: e
      }),
      invalidatesTags: ["Prompts"]
    }),
    updatePrompt: t.mutation({
      query: ({ requestTransformer: e, body: r, id: n }) => ({
        url: `prompts/${n}`,
        method: "PUT",
        body: r,
        requestTransformer: e
      }),
      invalidatesTags: ["Prompts"]
    }),
    deletePrompt: t.mutation({
      query: ({ requestTransformer: e, promptId: r }) => ({
        url: `prompts/${r}`,
        method: "DELETE",
        requestTransformer: e
      }),
      invalidatesTags: ["Prompts"]
    }),
    getKnowledgeSource: t.query({
      query: ({ requestTransformer: e, knowledgeSourceId: r }) => ({
        url: `knowledge-sources/${r}`,
        requestTransformer: e
      })
    }),
    listKnowledgeSources: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "knowledge-sources/",
        requestTransformer: e
      })
    }),
    getTool: t.query({
      query: ({ requestTransformer: e, toolId: r }) => ({
        url: `tools/${r}`,
        requestTransformer: e
      })
    }),
    listTools: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "tools/",
        requestTransformer: e
      })
    }),
    runTool: t.mutation({
      query: ({ requestTransformer: e, toolId: r, body: n }) => ({
        url: `tools/${r}/run`,
        method: "POST",
        body: n,
        requestTransformer: e
      })
    }),
    getComponent: t.query({
      query: ({ requestTransformer: e, componentId: r }) => ({
        url: `components/${r}`,
        requestTransformer: e
      })
    }),
    listComponents: t.query({
      query: ({ requestTransformer: e }) => ({
        url: "components/",
        requestTransformer: e
      })
    }),
    getComponentBlock: t.query({
      query: ({ requestTransformer: e, componentId: r, pageInputValues: n }) => ({
        url: `components/${r}/block?${new URLSearchParams(
          n
        ).toString()}`,
        requestTransformer: e
      })
    }),
    createCanvasVersion: t.mutation({
      query: ({ requestTransformer: e, canvasId: r, ...n }) => ({
        url: `canvases/${r}/versions`,
        method: "POST",
        body: n,
        requestTransformer: e
      })
    }),
    createConversation: t.mutation({
      query: ({ requestTransformer: e, ...r }) => ({
        url: "conversations/",
        method: "POST",
        body: r,
        requestTransformer: e
      })
    }),
    getConversation: t.query({
      query: ({ requestTransformer: e, conversationId: r, params: n }) => ({
        url: `conversations/${r}`,
        requestTransformer: e,
        params: n
      }),
      providesTags: (e, r, { conversationId: n }) => [
        { type: "Conversation", id: n }
      ]
    }),
    createMessageFeedback: t.mutation({
      query: ({ requestTransformer: e, body: r, conversationId: n, messageId: a }) => ({
        url: `conversations/${n}/messages/${a}/feedback`,
        method: "POST",
        body: r,
        requestTransformer: e
      })
    }),
    updateMessageFeedback: t.mutation({
      query: ({
        requestTransformer: e,
        body: r,
        conversationId: n,
        messageId: a,
        feedbackId: i
      }) => ({
        url: `conversations/${n}/messages/${a}/feedback/${i}`,
        method: "PUT",
        body: r,
        requestTransformer: e
      })
    }),
    analyticsListConversationEvents: t.query({
      query: ({ requestTransformer: e, conversationId: r }) => ({
        url: `analytics/conversations/${r}/events`,
        requestTransformer: e
      })
    }),
    analyticsGetConversation: t.query({
      query: ({ requestTransformer: e, conversationId: r }) => ({
        url: `analytics/conversations/${r}`,
        requestTransformer: e
      })
    }),
    transferToLiveChat: t.mutation({
      query: ({ requestTransformer: e, body: r, conversationId: n }) => ({
        url: `conversations/${n}/transfer/liveChat`,
        method: "POST",
        body: r,
        requestTransformer: e
      })
    }),
    directTransferToLiveChat: t.mutation({
      query: ({ requestTransformer: e, body: r }) => ({
        url: "conversations/transfer/liveChat/direct",
        method: "POST",
        body: r,
        requestTransformer: e
      })
    }),
    updateConversationSync: t.mutation({
      query: ({ requestTransformer: e, conversationId: r, body: n }) => ({
        url: `conversations/${r}`,
        method: "PUT",
        body: n,
        requestTransformer: e
      })
    }),
    updateConversationChunked: t.mutation({
      // Custom queryFn to handle chunked response
      queryFn: async ({
        conversationId: e,
        body: r,
        handleChunk: n,
        requestTransformer: a
      }) => {
        try {
          const i = a(
            {
              url: `conversations/${e}`,
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: r
            },
            yz.wiseOwl
          ), o = i.url, l = o.startsWith("http") ? o : `undefined/v2/${o}`, c = await fetch(l, {
            method: i.method,
            headers: i.headers,
            body: JSON.stringify(i.body),
            credentials: i.credentials
          });
          if (!c.body)
            throw new Error("No response body");
          const u = c.body.getReader(), f = new TextDecoder();
          let h = "";
          for (; ; ) {
            const { done: p, value: g } = await u.read();
            if (p)
              break;
            const y = f.decode(g, { stream: !0 });
            h += y, h = p4e(h, n);
          }
          return h && p4e(h, n), {
            data: !0
          };
        } catch (i) {
          return { error: { status: "FETCH_ERROR", error: i.message } };
        }
      },
      invalidatesTags: (e, r, { conversationId: n }) => [
        { type: "Conversation", id: n }
      ]
    }),
    listConversations: t.query({
      query: ({ requestTransformer: e, filters: r, limit: n, cursor: a = "", order: i, sortBy: o }) => {
        const s = Object.entries(r).filter(([c, u]) => Array.isArray(u) ? u.length > 0 : !!u).map((c) => {
          let u = "equals", f = c[0], h = c[1];
          return f === "createdAtStart" && (f = "createdAt", u = "gte", h = new Date(h).toISOString()), f === "createdAtEnd" && (f = "createdAt", u = "lte", h = new Date(h).toISOString()), Array.isArray(h) && (u = "array_contains"), {
            property: f,
            operator: u,
            value: h
          };
        }), l = {
          filters: JSON.stringify(s),
          limit: n,
          cursor: a,
          sortBy: o,
          order: i
        };
        return {
          url: `analytics/conversations?${new URLSearchParams(l)}`,
          requestTransformer: e
        };
      }
    })
  })
}), {
  useLazyGetConversationSummaryQuery: WMt,
  useCreateConversationMutation: HMt,
  useUpdateConversationChunkedMutation: I3n,
  useGetConversationQuery: UMt,
  useGetComponentBlockQuery: VMt,
  useGetPageQuery: Yqe,
  useLazyGetComponentBlockQuery: qMt,
  useListToolsQuery: Xqe,
  useGetToolQuery: Qqe,
  useGetAssistantQuery: eKe,
  useListAssistantsQuery: KMt,
  useGetApplicationQuery: WI,
  useListApplicationsQuery: tKe,
  useGetApplicationHomeQuery: ZMt,
  useGetBlockQuery: rKe,
  useListBlocksQuery: JMt,
  useListPagesQuery: YMt,
  useGetComponentQuery: XMt,
  useListComponentsQuery: QMt,
  useListPromptsQuery: nKe,
  useCreatePromptMutation: ePt,
  useUpdatePromptMutation: tPt,
  useDeletePromptMutation: rPt,
  useAnalyticsListConversationEventsQuery: nPt,
  useAnalyticsGetConversationQuery: aPt,
  useListConversationsQuery: iPt,
  useGetWorkflowQuery: aKe,
  useListWorkflowsQuery: iKe,
  useRunToolMutation: oPt,
  useListKnowledgeSourcesQuery: sPt,
  useGetKnowledgeSourceQuery: lPt,
  useCreateMessageFeedbackMutation: cPt,
  useCreateCanvasVersionMutation: uPt,
  useTransferToLiveChatMutation: dPt,
  useUpdateConversationSyncMutation: fPt,
  useDirectTransferToLiveChatMutation: hPt,
  useUpdateMessageFeedbackMutation: pPt
} = k_, mPt = {
  events: []
}, oKe = u1({
  name: "event",
  initialState: mPt,
  reducers: {
    emitEvent: (t, e) => {
      t.events.push(e.payload);
    },
    clearEvent: (t) => {
      t.events.shift();
    }
  }
}), { emitEvent: Jce, clearEvent: gPt } = oKe.actions, vPt = oKe.reducer, m4e = {
  isSurveyVisible: !1,
  isSubmitting: !1,
  isSurveySubmitted: !1,
  surveyResponse: {},
  SurveyVariant: g2e.HELP_CENTER_ASSISTANT
}, sKe = u1({
  name: "csatSurvey",
  initialState: m4e,
  reducers: {
    showSurvey(t, e) {
      e.payload && (t.SurveyVariant = e.payload), t.isSurveyVisible = !0;
    },
    hideSurvey(t) {
      t.isSurveyVisible = !1, t.surveyResponse = {};
    },
    setSurveyResponse(t, e) {
      t.surveyResponse = e.payload;
    },
    submitSurveyStart(t) {
      t.isSubmitting = !0;
    },
    submitSurveySuccess(t) {
      t.isSubmitting = !1, t.isSurveyVisible = !1, t.surveyResponse = {};
    },
    markSurveyAsSubmitted(t) {
      t.isSurveySubmitted = !0;
    },
    resetSurvey() {
      return m4e;
    }
  }
}), {
  hideSurvey: yPt,
  resetSurvey: bPt,
  showSurvey: lKe,
  setSurveyResponse: xPt,
  submitSurveyStart: M3n,
  submitSurveySuccess: P3n,
  markSurveyAsSubmitted: CPt
} = sKe.actions, wPt = sKe.reducer, SPt = {
  liveChatId: void 0,
  identity: void 0,
  token: void 0,
  ticketId: void 0,
  chatActivitySyncMapId: void 0,
  conversationId: void 0,
  isConnected: !1
}, cKe = u1({
  name: "liveChat",
  initialState: SPt,
  reducers: {
    setLiveChatValues: (t, e) => {
      const {
        liveChatId: r,
        identity: n,
        token: a,
        ticketId: i,
        chatActivitySyncMapId: o,
        conversationId: s
      } = e.payload;
      t.liveChatId = r, t.identity = n, t.token = a, t.ticketId = i, t.chatActivitySyncMapId = o, t.conversationId = s;
    },
    resetLiveChatValues: (t) => {
      t.liveChatId = void 0, t.identity = void 0, t.token = void 0, t.ticketId = void 0, t.chatActivitySyncMapId = void 0, t.conversationId = void 0, t.isConnected = !1;
    },
    setLiveChatConnectionStatus: (t, e) => {
      const { isConnected: r = t.isConnected } = e.payload;
      t.isConnected = r;
    }
  }
}), {
  setLiveChatValues: v2e,
  resetLiveChatValues: R3n,
  setLiveChatConnectionStatus: y2e
} = cKe.actions, _Pt = cKe.reducer, kPt = (t) => t.isConnected && !!t.liveChatId && !!t.identity && !!t.token && typeof t.ticketId == "number" && !!t.chatActivitySyncMapId && !!t.conversationId, APt = async (t, e, r) => {
  const { requestTransformer: n, ...a } = t, i = KWe({
    baseUrl: "undefined/v1/"
  }), o = n(
    a,
    yz.helpCenter
  );
  return await i(o, e, r);
}, e$ = nHe({
  reducerPath: "helpCenterApi",
  baseQuery: APt,
  endpoints: (t) => ({
    getLiveChat: t.query({
      query: ({ requestTransformer: e, liveChatId: r }) => ({
        url: `live-chats-playground/${r}`,
        requestTransformer: e
      })
    }),
    refreshToken: t.mutation({
      query: ({ requestTransformer: e, identity: r }) => ({
        url: "live-chats-playground/refreshToken",
        method: "POST",
        body: { identity: r },
        requestTransformer: e
      })
    }),
    endLiveChat: t.mutation({
      query: ({ requestTransformer: e, liveChatId: r, chatEndedBy: n }) => ({
        url: `live-chats-playground/${r}`,
        method: "PATCH",
        body: {
          action: "end",
          chat_ended_by: n
        },
        requestTransformer: e
      })
    }),
    requestSupportNotification: t.mutation({
      query: ({
        requestTransformer: e,
        liveChatId: r,
        phoneNumber: n,
        preferredContactMethod: a
      }) => ({
        url: `live-chats-playground/${r}/notification`,
        method: "POST",
        body: { phoneNumber: n, preferredContactMethod: a },
        requestTransformer: e
      })
    }),
    createSurveySession: t.mutation({
      query: ({ requestTransformer: e, surveyId: r, surveyVariant: n }) => ({
        url: `surveys/${r}/sessions`,
        method: "POST",
        body: { surveyVariant: n },
        requestTransformer: e
      })
    }),
    updateSurveySession: t.mutation({
      query: ({
        requestTransformer: e,
        surveyId: r,
        sessionId: n,
        embeddedData: a,
        responses: i
      }) => ({
        url: `surveys/${r}/sessions/${n}`,
        method: "POST",
        body: { embeddedData: a, responses: i },
        requestTransformer: e
      })
    }),
    getSurveyResponseReceipts: t.mutation({
      query: ({ requestTransformer: e, liveChatId: r }) => ({
        url: "surveys",
        method: "POST",
        body: { liveChatId: r },
        requestTransformer: e
      })
    })
  })
}), {
  useGetLiveChatQuery: O3n,
  useRefreshTokenMutation: B3n,
  useEndLiveChatMutation: N3n,
  useRequestSupportNotificationMutation: TPt,
  useCreateSurveySessionMutation: EPt,
  useUpdateSurveySessionMutation: IPt,
  useGetSurveyResponseReceiptsMutation: MPt
} = e$, uKe = w4t({
  reducer: {
    conversation: V4t,
    config: z4t,
    event: vPt,
    liveChat: _Pt,
    csatSurvey: wPt,
    [k_.reducerPath]: k_.reducer,
    [e$.reducerPath]: e$.reducer
  },
  middleware: (t) => t({
    serializableCheck: {
      ignoredPaths: [
        // ignore storage of requestTransformer in wiseOwlApi
        /^wiseOwlApi\.queries\..*\.originalArgs\.requestTransformer$/
      ]
    }
  }).concat(k_.middleware).concat(e$.middleware)
}), s2 = UWe.withTypes(), Gn = zWe.withTypes();
var LK = {}, PPt = Object.create, bz = Object.defineProperty, RPt = Object.getOwnPropertyDescriptor, b2e = Object.getOwnPropertyNames, OPt = Object.getPrototypeOf, BPt = Object.prototype.hasOwnProperty, NPt = (t, e) => function() {
  return t && (e = (0, t[b2e(t)[0]])(t = 0)), e;
}, po = (t, e) => function() {
  return e || (0, t[b2e(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, $Pt = (t, e) => {
  for (var r in e) bz(t, r, { get: e[r], enumerable: !0 });
}, x2e = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of b2e(e)) !BPt.call(t, a) && a !== r && bz(t, a, { get: () => e[a], enumerable: !(n = RPt(e, a)) || n.enumerable });
  return t;
}, DPt = (t, e, r) => (x2e(t, e, "default"), r), xz = (t, e, r) => (r = t != null ? PPt(OPt(t)) : {}, x2e(!t || !t.__esModule ? bz(r, "default", { value: t, enumerable: !0 }) : r, t)), Cz = (t) => x2e(bz({}, "__esModule", { value: !0 }), t), LPt = po({ "../../../node_modules/@emotion/sheet/dist/emotion-sheet.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(a) {
    if (a.sheet) return a.sheet;
    for (var i = 0; i < document.styleSheets.length; i++) if (document.styleSheets[i].ownerNode === a) return document.styleSheets[i];
  }
  function r(a) {
    var i = document.createElement("style");
    return i.setAttribute("data-emotion", a.key), a.nonce !== void 0 && i.setAttribute("nonce", a.nonce), i.appendChild(document.createTextNode("")), i.setAttribute("data-s", ""), i;
  }
  var n = function() {
    function a(o) {
      var s = this;
      this._insertTag = function(l) {
        var c;
        s.tags.length === 0 ? s.insertionPoint ? c = s.insertionPoint.nextSibling : s.prepend ? c = s.container.firstChild : c = s.before : c = s.tags[s.tags.length - 1].nextSibling, s.container.insertBefore(l, c), s.tags.push(l);
      }, this.isSpeedy = o.speedy === void 0 ? !0 : o.speedy, this.tags = [], this.ctr = 0, this.nonce = o.nonce, this.key = o.key, this.container = o.container, this.prepend = o.prepend, this.insertionPoint = o.insertionPoint, this.before = null;
    }
    var i = a.prototype;
    return i.hydrate = function(o) {
      o.forEach(this._insertTag);
    }, i.insert = function(o) {
      this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(r(this));
      var s = this.tags[this.tags.length - 1];
      if (this.isSpeedy) {
        var l = e(s);
        try {
          l.insertRule(o, l.cssRules.length);
        } catch {
        }
      } else s.appendChild(document.createTextNode(o));
      this.ctr++;
    }, i.flush = function() {
      this.tags.forEach(function(o) {
        return o.parentNode && o.parentNode.removeChild(o);
      }), this.tags = [], this.ctr = 0;
    }, a;
  }();
  t.StyleSheet = n;
} }), jPt = po({ "../../../node_modules/@emotion/sheet/dist/emotion-sheet.cjs.js"(t, e) {
  e.exports = LPt();
} }), FPt = po({ "../../../node_modules/stylis/dist/umd/stylis.js"(t, e) {
  (function(r, n) {
    typeof t == "object" && typeof e < "u" ? n(t) : typeof define == "function" && define.amd ? define(["exports"], n) : (r = r || self, n(r.stylis = {}));
  })(t, function(r) {
    var n = "-ms-", a = "-moz-", i = "-webkit-", o = "comm", s = "rule", l = "decl", c = "@page", u = "@media", f = "@import", h = "@charset", p = "@viewport", g = "@supports", y = "@document", b = "@namespace", w = "@keyframes", _ = "@font-face", C = "@counter-style", x = "@font-feature-values", S = Math.abs, A = String.fromCharCode, I = Object.assign;
    function M(ne, re) {
      return m(ne, 0) ^ 45 ? (((re << 2 ^ m(ne, 0)) << 2 ^ m(ne, 1)) << 2 ^ m(ne, 2)) << 2 ^ m(ne, 3) : 0;
    }
    function B(ne) {
      return ne.trim();
    }
    function L(ne, re) {
      return (ne = re.exec(ne)) ? ne[0] : ne;
    }
    function N(ne, re, ie) {
      return ne.replace(re, ie);
    }
    function d(ne, re) {
      return ne.indexOf(re);
    }
    function m(ne, re) {
      return ne.charCodeAt(re) | 0;
    }
    function v(ne, re, ie) {
      return ne.slice(re, ie);
    }
    function k(ne) {
      return ne.length;
    }
    function O(ne) {
      return ne.length;
    }
    function G(ne, re) {
      return re.push(ne), ne;
    }
    function H(ne, re) {
      return ne.map(re).join("");
    }
    r.line = 1, r.column = 1, r.length = 0, r.position = 0, r.character = 0, r.characters = "";
    function j(ne, re, ie, Ie, Ke, Le, Ge) {
      return { value: ne, root: re, parent: ie, type: Ie, props: Ke, children: Le, line: r.line, column: r.column, length: Ge, return: "" };
    }
    function F(ne, re) {
      return I(j("", null, null, "", null, null, 0), ne, { length: -ne.length }, re);
    }
    function z() {
      return r.character;
    }
    function W() {
      return r.character = r.position > 0 ? m(r.characters, --r.position) : 0, r.column--, r.character === 10 && (r.column = 1, r.line--), r.character;
    }
    function U() {
      return r.character = r.position < r.length ? m(r.characters, r.position++) : 0, r.column++, r.character === 10 && (r.column = 1, r.line++), r.character;
    }
    function Z() {
      return m(r.characters, r.position);
    }
    function V() {
      return r.position;
    }
    function Y(ne, re) {
      return v(r.characters, ne, re);
    }
    function ge(ne) {
      switch (ne) {
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
          return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
          return 4;
        case 58:
          return 3;
        case 34:
        case 39:
        case 40:
        case 91:
          return 2;
        case 41:
        case 93:
          return 1;
      }
      return 0;
    }
    function ce(ne) {
      return r.line = r.column = 1, r.length = k(r.characters = ne), r.position = 0, [];
    }
    function ee(ne) {
      return r.characters = "", ne;
    }
    function Se(ne) {
      return B(Y(r.position - 1, it(ne === 91 ? ne + 2 : ne === 40 ? ne + 1 : ne)));
    }
    function Ce(ne) {
      return ee(We(ce(ne)));
    }
    function we(ne) {
      for (; (r.character = Z()) && r.character < 33; ) U();
      return ge(ne) > 2 || ge(r.character) > 3 ? "" : " ";
    }
    function We(ne) {
      for (; U(); ) switch (ge(r.character)) {
        case 0:
          G(Ze(r.position - 1), ne);
          break;
        case 2:
          G(Se(r.character), ne);
          break;
        default:
          G(A(r.character), ne);
      }
      return ne;
    }
    function Fe(ne, re) {
      for (; --re && U() && !(r.character < 48 || r.character > 102 || r.character > 57 && r.character < 65 || r.character > 70 && r.character < 97); ) ;
      return Y(ne, V() + (re < 6 && Z() == 32 && U() == 32));
    }
    function it(ne) {
      for (; U(); ) switch (r.character) {
        case ne:
          return r.position;
        case 34:
        case 39:
          ne !== 34 && ne !== 39 && it(r.character);
          break;
        case 40:
          ne === 41 && it(ne);
          break;
        case 92:
          U();
          break;
      }
      return r.position;
    }
    function gt(ne, re) {
      for (; U() && ne + r.character !== 57 && !(ne + r.character === 84 && Z() === 47); ) ;
      return "/*" + Y(re, r.position - 1) + "*" + A(ne === 47 ? ne : U());
    }
    function Ze(ne) {
      for (; !ge(Z()); ) U();
      return Y(ne, r.position);
    }
    function Ne(ne) {
      return ee(ze("", null, null, null, [""], ne = ce(ne), 0, [0], ne));
    }
    function ze(ne, re, ie, Ie, Ke, Le, Ge, ft, ot) {
      for (var Ye = 0, Je = 0, tt = Ge, kt = 0, Ft = 0, bt = 0, At = 1, vt = 1, _t = 1, yt = 0, xr = "", dr = Ke, Er = Le, gr = Ie, pr = xr; vt; ) switch (bt = yt, yt = U()) {
        case 40:
          if (bt != 108 && m(pr, tt - 1) == 58) {
            d(pr += N(Se(yt), "&", "&\f"), "&\f") != -1 && (_t = -1);
            break;
          }
        case 34:
        case 39:
        case 91:
          pr += Se(yt);
          break;
        case 9:
        case 10:
        case 13:
        case 32:
          pr += we(bt);
          break;
        case 92:
          pr += Fe(V() - 1, 7);
          continue;
        case 47:
          switch (Z()) {
            case 42:
            case 47:
              G(rt(gt(U(), V()), re, ie), ot);
              break;
            default:
              pr += "/";
          }
          break;
        case 123 * At:
          ft[Ye++] = k(pr) * _t;
        case 125 * At:
        case 59:
        case 0:
          switch (yt) {
            case 0:
            case 125:
              vt = 0;
            case 59 + Je:
              Ft > 0 && k(pr) - tt && G(Ft > 32 ? qe(pr + ";", Ie, ie, tt - 1) : qe(N(pr, " ", "") + ";", Ie, ie, tt - 2), ot);
              break;
            case 59:
              pr += ";";
            default:
              if (G(gr = ct(pr, re, ie, Ye, Je, Ke, ft, xr, dr = [], Er = [], tt), Le), yt === 123) if (Je === 0) ze(pr, re, gr, gr, dr, Le, tt, ft, Er);
              else switch (kt === 99 && m(pr, 3) === 110 ? 100 : kt) {
                case 100:
                case 109:
                case 115:
                  ze(ne, gr, gr, Ie && G(ct(ne, gr, gr, 0, 0, Ke, ft, xr, Ke, dr = [], tt), Er), Ke, Er, tt, ft, Ie ? dr : Er);
                  break;
                default:
                  ze(pr, gr, gr, gr, [""], Er, 0, ft, Er);
              }
          }
          Ye = Je = Ft = 0, At = _t = 1, xr = pr = "", tt = Ge;
          break;
        case 58:
          tt = 1 + k(pr), Ft = bt;
        default:
          if (At < 1) {
            if (yt == 123) --At;
            else if (yt == 125 && At++ == 0 && W() == 125) continue;
          }
          switch (pr += A(yt), yt * At) {
            case 38:
              _t = Je > 0 ? 1 : (pr += "\f", -1);
              break;
            case 44:
              ft[Ye++] = (k(pr) - 1) * _t, _t = 1;
              break;
            case 64:
              Z() === 45 && (pr += Se(U())), kt = Z(), Je = tt = k(xr = pr += Ze(V())), yt++;
              break;
            case 45:
              bt === 45 && k(pr) == 2 && (At = 0);
          }
      }
      return Le;
    }
    function ct(ne, re, ie, Ie, Ke, Le, Ge, ft, ot, Ye, Je) {
      for (var tt = Ke - 1, kt = Ke === 0 ? Le : [""], Ft = O(kt), bt = 0, At = 0, vt = 0; bt < Ie; ++bt) for (var _t = 0, yt = v(ne, tt + 1, tt = S(At = Ge[bt])), xr = ne; _t < Ft; ++_t) (xr = B(At > 0 ? kt[_t] + " " + yt : N(yt, /&\f/g, kt[_t]))) && (ot[vt++] = xr);
      return j(ne, re, ie, Ke === 0 ? s : ft, ot, Ye, Je);
    }
    function rt(ne, re, ie) {
      return j(ne, re, ie, o, A(z()), v(ne, 2, -2), 0);
    }
    function qe(ne, re, ie, Ie) {
      return j(ne, re, ie, l, v(ne, 0, Ie), v(ne, Ie + 1, -1), Ie);
    }
    function nt(ne, re, ie) {
      switch (M(ne, re)) {
        case 5103:
          return i + "print-" + ne + ne;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
          return i + ne + ne;
        case 4789:
          return a + ne + ne;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
          return i + ne + a + ne + n + ne + ne;
        case 5936:
          switch (m(ne, re + 11)) {
            case 114:
              return i + ne + n + N(ne, /[svh]\w+-[tblr]{2}/, "tb") + ne;
            case 108:
              return i + ne + n + N(ne, /[svh]\w+-[tblr]{2}/, "tb-rl") + ne;
            case 45:
              return i + ne + n + N(ne, /[svh]\w+-[tblr]{2}/, "lr") + ne;
          }
        case 6828:
        case 4268:
        case 2903:
          return i + ne + n + ne + ne;
        case 6165:
          return i + ne + n + "flex-" + ne + ne;
        case 5187:
          return i + ne + N(ne, /(\w+).+(:[^]+)/, i + "box-$1$2" + n + "flex-$1$2") + ne;
        case 5443:
          return i + ne + n + "flex-item-" + N(ne, /flex-|-self/g, "") + (L(ne, /flex-|baseline/) ? "" : n + "grid-row-" + N(ne, /flex-|-self/g, "")) + ne;
        case 4675:
          return i + ne + n + "flex-line-pack" + N(ne, /align-content|flex-|-self/g, "") + ne;
        case 5548:
          return i + ne + n + N(ne, "shrink", "negative") + ne;
        case 5292:
          return i + ne + n + N(ne, "basis", "preferred-size") + ne;
        case 6060:
          return i + "box-" + N(ne, "-grow", "") + i + ne + n + N(ne, "grow", "positive") + ne;
        case 4554:
          return i + N(ne, /([^-])(transform)/g, "$1" + i + "$2") + ne;
        case 6187:
          return N(N(N(ne, /(zoom-|grab)/, i + "$1"), /(image-set)/, i + "$1"), ne, "") + ne;
        case 5495:
        case 3959:
          return N(ne, /(image-set\([^]*)/, i + "$1$`$1");
        case 4968:
          return N(N(ne, /(.+:)(flex-)?(.*)/, i + "box-pack:$3" + n + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + i + ne + ne;
        case 4200:
          if (!L(ne, /flex-|baseline/)) return n + "grid-column-align" + v(ne, re) + ne;
          break;
        case 2592:
        case 3360:
          return n + N(ne, "template-", "") + ne;
        case 4384:
        case 3616:
          return ie && ie.some(function(Ie, Ke) {
            return re = Ke, L(Ie.props, /grid-\w+-end/);
          }) ? ~d(ne + (ie = ie[re].value), "span") ? ne : n + N(ne, "-start", "") + ne + n + "grid-row-span:" + (~d(ie, "span") ? L(ie, /\d+/) : +L(ie, /\d+/) - +L(ne, /\d+/)) + ";" : n + N(ne, "-start", "") + ne;
        case 4896:
        case 4128:
          return ie && ie.some(function(Ie) {
            return L(Ie.props, /grid-\w+-start/);
          }) ? ne : n + N(N(ne, "-end", "-span"), "span ", "") + ne;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
          return N(ne, /(.+)-inline(.+)/, i + "$1$2") + ne;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
          if (k(ne) - 1 - re > 6) switch (m(ne, re + 1)) {
            case 109:
              if (m(ne, re + 4) !== 45) break;
            case 102:
              return N(ne, /(.+:)(.+)-([^]+)/, "$1" + i + "$2-$3$1" + a + (m(ne, re + 3) == 108 ? "$3" : "$2-$3")) + ne;
            case 115:
              return ~d(ne, "stretch") ? nt(N(ne, "stretch", "fill-available"), re, ie) + ne : ne;
          }
          break;
        case 5152:
        case 5920:
          return N(ne, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(Ie, Ke, Le, Ge, ft, ot, Ye) {
            return n + Ke + ":" + Le + Ye + (Ge ? n + Ke + "-span:" + (ft ? ot : +ot - +Le) + Ye : "") + ne;
          });
        case 4949:
          if (m(ne, re + 6) === 121) return N(ne, ":", ":" + i) + ne;
          break;
        case 6444:
          switch (m(ne, m(ne, 14) === 45 ? 18 : 11)) {
            case 120:
              return N(ne, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + i + (m(ne, 14) === 45 ? "inline-" : "") + "box$3$1" + i + "$2$3$1" + n + "$2box$3") + ne;
            case 100:
              return N(ne, ":", ":" + n) + ne;
          }
          break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
          return N(ne, "scroll-", "scroll-snap-") + ne;
      }
      return ne;
    }
    function Rt(ne, re) {
      for (var ie = "", Ie = O(ne), Ke = 0; Ke < Ie; Ke++) ie += re(ne[Ke], Ke, ne, re) || "";
      return ie;
    }
    function Ot(ne, re, ie, Ie) {
      switch (ne.type) {
        case f:
        case l:
          return ne.return = ne.return || ne.value;
        case o:
          return "";
        case w:
          return ne.return = ne.value + "{" + Rt(ne.children, Ie) + "}";
        case s:
          ne.value = ne.props.join(",");
      }
      return k(ie = Rt(ne.children, Ie)) ? ne.return = ne.value + "{" + ie + "}" : "";
    }
    function lt(ne) {
      var re = O(ne);
      return function(ie, Ie, Ke, Le) {
        for (var Ge = "", ft = 0; ft < re; ft++) Ge += ne[ft](ie, Ie, Ke, Le) || "";
        return Ge;
      };
    }
    function mt(ne) {
      return function(re) {
        re.root || (re = re.return) && ne(re);
      };
    }
    function jt(ne, re, ie, Ie) {
      if (ne.length > -1 && !ne.return) switch (ne.type) {
        case l:
          ne.return = nt(ne.value, ne.length, ie);
          return;
        case w:
          return Rt([F(ne, { value: N(ne.value, "@", "@" + i) })], Ie);
        case s:
          if (ne.length) return H(ne.props, function(Ke) {
            switch (L(Ke, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Rt([F(ne, { props: [N(Ke, /:(read-\w+)/, ":" + a + "$1")] })], Ie);
              case "::placeholder":
                return Rt([F(ne, { props: [N(Ke, /:(plac\w+)/, ":" + i + "input-$1")] }), F(ne, { props: [N(Ke, /:(plac\w+)/, ":" + a + "$1")] }), F(ne, { props: [N(Ke, /:(plac\w+)/, n + "input-$1")] })], Ie);
            }
            return "";
          });
      }
    }
    function Jt(ne) {
      switch (ne.type) {
        case s:
          ne.props = ne.props.map(function(re) {
            return H(Ce(re), function(ie, Ie, Ke) {
              switch (m(ie, 0)) {
                case 12:
                  return v(ie, 1, k(ie));
                case 0:
                case 40:
                case 43:
                case 62:
                case 126:
                  return ie;
                case 58:
                  Ke[++Ie] === "global" && (Ke[Ie] = "", Ke[++Ie] = "\f" + v(Ke[Ie], Ie = 1, -1));
                case 32:
                  return Ie === 1 ? "" : ie;
                default:
                  switch (Ie) {
                    case 0:
                      return ne = ie, O(Ke) > 1 ? "" : ie;
                    case (Ie = O(Ke) - 1):
                    case 2:
                      return Ie === 2 ? ie + ne + ne : ie + ne;
                    default:
                      return ie;
                  }
              }
            });
          });
      }
    }
    r.CHARSET = h, r.COMMENT = o, r.COUNTER_STYLE = C, r.DECLARATION = l, r.DOCUMENT = y, r.FONT_FACE = _, r.FONT_FEATURE_VALUES = x, r.IMPORT = f, r.KEYFRAMES = w, r.MEDIA = u, r.MOZ = a, r.MS = n, r.NAMESPACE = b, r.PAGE = c, r.RULESET = s, r.SUPPORTS = g, r.VIEWPORT = p, r.WEBKIT = i, r.abs = S, r.alloc = ce, r.append = G, r.assign = I, r.caret = V, r.char = z, r.charat = m, r.combine = H, r.comment = rt, r.commenter = gt, r.compile = Ne, r.copy = F, r.dealloc = ee, r.declaration = qe, r.delimit = Se, r.delimiter = it, r.escaping = Fe, r.from = A, r.hash = M, r.identifier = Ze, r.indexof = d, r.match = L, r.middleware = lt, r.namespace = Jt, r.next = U, r.node = j, r.parse = ze, r.peek = Z, r.prefix = nt, r.prefixer = jt, r.prev = W, r.replace = N, r.ruleset = ct, r.rulesheet = mt, r.serialize = Rt, r.sizeof = O, r.slice = Y, r.stringify = Ot, r.strlen = k, r.substr = v, r.token = ge, r.tokenize = Ce, r.tokenizer = We, r.trim = B, r.whitespace = we, Object.defineProperty(r, "__esModule", { value: !0 });
  });
} }), zPt = po({ "../../../node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = function(r) {
    var n = /* @__PURE__ */ new WeakMap();
    return function(a) {
      if (n.has(a)) return n.get(a);
      var i = r(a);
      return n.set(a, i), i;
    };
  };
  t.default = e;
} }), C2e = po({ "../../../node_modules/@emotion/weak-memoize/dist/emotion-weak-memoize.cjs.js"(t, e) {
  e.exports = zPt();
} }), GPt = po({ "../../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(r) {
    var n = /* @__PURE__ */ Object.create(null);
    return function(a) {
      return n[a] === void 0 && (n[a] = r(a)), n[a];
    };
  }
  t.default = e;
} }), w2e = po({ "../../../node_modules/@emotion/memoize/dist/emotion-memoize.cjs.js"(t, e) {
  e.exports = GPt();
} }), WPt = po({ "../../../node_modules/@emotion/cache/dist/emotion-cache.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = jPt(), r = FPt(), n = C2e(), a = w2e();
  function i(x) {
    return x && x.__esModule ? x : { default: x };
  }
  var o = i(n), s = i(a), l = function(x, S, A) {
    for (var I = 0, M = 0; I = M, M = r.peek(), I === 38 && M === 12 && (S[A] = 1), !r.token(M); ) r.next();
    return r.slice(x, r.position);
  }, c = function(x, S) {
    var A = -1, I = 44;
    do
      switch (r.token(I)) {
        case 0:
          I === 38 && r.peek() === 12 && (S[A] = 1), x[A] += l(r.position - 1, S, A);
          break;
        case 2:
          x[A] += r.delimit(I);
          break;
        case 4:
          if (I === 44) {
            x[++A] = r.peek() === 58 ? "&\f" : "", S[A] = x[A].length;
            break;
          }
        default:
          x[A] += r.from(I);
      }
    while (I = r.next());
    return x;
  }, u = function(x, S) {
    return r.dealloc(c(r.alloc(x), S));
  }, f = /* @__PURE__ */ new WeakMap(), h = function(x) {
    if (!(x.type !== "rule" || !x.parent || x.length < 1)) {
      for (var S = x.value, A = x.parent, I = x.column === A.column && x.line === A.line; A.type !== "rule"; ) if (A = A.parent, !A) return;
      if (!(x.props.length === 1 && S.charCodeAt(0) !== 58 && !f.get(A)) && !I) {
        f.set(x, !0);
        for (var M = [], B = u(S, M), L = A.props, N = 0, d = 0; N < B.length; N++) for (var m = 0; m < L.length; m++, d++) x.props[d] = M[N] ? B[N].replace(/&\f/g, L[m]) : L[m] + " " + B[N];
      }
    }
  }, p = function(x) {
    if (x.type === "decl") {
      var S = x.value;
      S.charCodeAt(0) === 108 && S.charCodeAt(2) === 98 && (x.return = "", x.value = "");
    }
  };
  function g(x, S) {
    switch (r.hash(x, S)) {
      case 5103:
        return r.WEBKIT + "print-" + x + x;
      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921:
      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005:
      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855:
      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return r.WEBKIT + x + x;
      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return r.WEBKIT + x + r.MOZ + x + r.MS + x + x;
      case 6828:
      case 4268:
        return r.WEBKIT + x + r.MS + x + x;
      case 6165:
        return r.WEBKIT + x + r.MS + "flex-" + x + x;
      case 5187:
        return r.WEBKIT + x + r.replace(x, /(\w+).+(:[^]+)/, r.WEBKIT + "box-$1$2" + r.MS + "flex-$1$2") + x;
      case 5443:
        return r.WEBKIT + x + r.MS + "flex-item-" + r.replace(x, /flex-|-self/, "") + x;
      case 4675:
        return r.WEBKIT + x + r.MS + "flex-line-pack" + r.replace(x, /align-content|flex-|-self/, "") + x;
      case 5548:
        return r.WEBKIT + x + r.MS + r.replace(x, "shrink", "negative") + x;
      case 5292:
        return r.WEBKIT + x + r.MS + r.replace(x, "basis", "preferred-size") + x;
      case 6060:
        return r.WEBKIT + "box-" + r.replace(x, "-grow", "") + r.WEBKIT + x + r.MS + r.replace(x, "grow", "positive") + x;
      case 4554:
        return r.WEBKIT + r.replace(x, /([^-])(transform)/g, "$1" + r.WEBKIT + "$2") + x;
      case 6187:
        return r.replace(r.replace(r.replace(x, /(zoom-|grab)/, r.WEBKIT + "$1"), /(image-set)/, r.WEBKIT + "$1"), x, "") + x;
      case 5495:
      case 3959:
        return r.replace(x, /(image-set\([^]*)/, r.WEBKIT + "$1$`$1");
      case 4968:
        return r.replace(r.replace(x, /(.+:)(flex-)?(.*)/, r.WEBKIT + "box-pack:$3" + r.MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + r.WEBKIT + x + x;
      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return r.replace(x, /(.+)-inline(.+)/, r.WEBKIT + "$1$2") + x;
      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        if (r.strlen(x) - 1 - S > 6) switch (r.charat(x, S + 1)) {
          case 109:
            if (r.charat(x, S + 4) !== 45) break;
          case 102:
            return r.replace(x, /(.+:)(.+)-([^]+)/, "$1" + r.WEBKIT + "$2-$3$1" + r.MOZ + (r.charat(x, S + 3) == 108 ? "$3" : "$2-$3")) + x;
          case 115:
            return ~r.indexof(x, "stretch") ? g(r.replace(x, "stretch", "fill-available"), S) + x : x;
        }
        break;
      case 4949:
        if (r.charat(x, S + 1) !== 115) break;
      case 6444:
        switch (r.charat(x, r.strlen(x) - 3 - (~r.indexof(x, "!important") && 10))) {
          case 107:
            return r.replace(x, ":", ":" + r.WEBKIT) + x;
          case 101:
            return r.replace(x, /(.+:)([^;!]+)(;|!.+)?/, "$1" + r.WEBKIT + (r.charat(x, 14) === 45 ? "inline-" : "") + "box$3$1" + r.WEBKIT + "$2$3$1" + r.MS + "$2box$3") + x;
        }
        break;
      case 5936:
        switch (r.charat(x, S + 11)) {
          case 114:
            return r.WEBKIT + x + r.MS + r.replace(x, /[svh]\w+-[tblr]{2}/, "tb") + x;
          case 108:
            return r.WEBKIT + x + r.MS + r.replace(x, /[svh]\w+-[tblr]{2}/, "tb-rl") + x;
          case 45:
            return r.WEBKIT + x + r.MS + r.replace(x, /[svh]\w+-[tblr]{2}/, "lr") + x;
        }
        return r.WEBKIT + x + r.MS + x + x;
    }
    return x;
  }
  var y = function(x, S, A, I) {
    if (x.length > -1 && !x.return) switch (x.type) {
      case r.DECLARATION:
        x.return = g(x.value, x.length);
        break;
      case r.KEYFRAMES:
        return r.serialize([r.copy(x, { value: r.replace(x.value, "@", "@" + r.WEBKIT) })], I);
      case r.RULESET:
        if (x.length) return r.combine(x.props, function(M) {
          switch (r.match(M, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return r.serialize([r.copy(x, { props: [r.replace(M, /:(read-\w+)/, ":" + r.MOZ + "$1")] })], I);
            case "::placeholder":
              return r.serialize([r.copy(x, { props: [r.replace(M, /:(plac\w+)/, ":" + r.WEBKIT + "input-$1")] }), r.copy(x, { props: [r.replace(M, /:(plac\w+)/, ":" + r.MOZ + "$1")] }), r.copy(x, { props: [r.replace(M, /:(plac\w+)/, r.MS + "input-$1")] })], I);
          }
          return "";
        });
    }
  }, b = typeof document < "u", w = b ? void 0 : o.default(function() {
    return s.default(function() {
      var x = {};
      return function(S) {
        return x[S];
      };
    });
  }), _ = [y], C = function(x) {
    var S = x.key;
    if (b && S === "css") {
      var A = document.querySelectorAll("style[data-emotion]:not([data-s])");
      Array.prototype.forEach.call(A, function(U) {
        var Z = U.getAttribute("data-emotion");
        Z.indexOf(" ") !== -1 && (document.head.appendChild(U), U.setAttribute("data-s", ""));
      });
    }
    var I = x.stylisPlugins || _, M = {}, B, L = [];
    b && (B = x.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + S + ' "]'), function(U) {
      for (var Z = U.getAttribute("data-emotion").split(" "), V = 1; V < Z.length; V++) M[Z[V]] = !0;
      L.push(U);
    }));
    var N, d = [h, p];
    if (b) {
      var m, v = [r.stringify, r.rulesheet(function(U) {
        m.insert(U);
      })], k = r.middleware(d.concat(I, v)), O = function(U) {
        return r.serialize(r.compile(U), k);
      };
      N = function(U, Z, V, Y) {
        m = V, O(U ? U + "{" + Z.styles + "}" : Z.styles), Y && (W.inserted[Z.name] = !0);
      };
    } else {
      var G = [r.stringify], H = r.middleware(d.concat(I, G)), j = function(U) {
        return r.serialize(r.compile(U), H);
      }, F = w(I)(S), z = function(U, Z) {
        var V = Z.name;
        return F[V] === void 0 && (F[V] = j(U ? U + "{" + Z.styles + "}" : Z.styles)), F[V];
      };
      N = function(U, Z, V, Y) {
        var ge = Z.name, ce = z(U, Z);
        if (W.compat === void 0) return Y && (W.inserted[ge] = !0), ce;
        if (Y) W.inserted[ge] = ce;
        else return ce;
      };
    }
    var W = { key: S, sheet: new e.StyleSheet({ key: S, container: B, nonce: x.nonce, speedy: x.speedy, prepend: x.prepend, insertionPoint: x.insertionPoint }), nonce: x.nonce, inserted: M, registered: {}, insert: N };
    return W.sheet.hydrate(L), W;
  };
  t.default = C;
} }), S2e = po({ "../../../node_modules/@emotion/cache/dist/emotion-cache.cjs.js"(t, e) {
  e.exports = WPt();
} }), wz = po({ "../../../node_modules/@babel/runtime/helpers/extends.js"(t, e) {
  function r() {
    return e.exports = r = Object.assign ? Object.assign.bind() : function(n) {
      for (var a = 1; a < arguments.length; a++) {
        var i = arguments[a];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
      }
      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(this, arguments);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
} }), b8 = {};
$Pt(b8, { default: () => P });
var HI = NPt({ "esm-externals:react"() {
  DPt(b8, P);
} }), HPt = po({ "../../../node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = w2e();
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var n = r(e), a = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, i = n.default(function(o) {
    return a.test(o) || o.charCodeAt(0) === 111 && o.charCodeAt(1) === 110 && o.charCodeAt(2) < 91;
  });
  t.default = i;
} }), dKe = po({ "../../../node_modules/@emotion/styled/node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.cjs.js"(t, e) {
  e.exports = HPt();
} }), UPt = po({ "../../../node_modules/hoist-non-react-statics/node_modules/react-is/cjs/react-is.production.min.js"(t) {
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function x(A) {
    if (typeof A == "object" && A !== null) {
      var I = A.$$typeof;
      switch (I) {
        case r:
          switch (A = A.type, A) {
            case c:
            case u:
            case a:
            case o:
            case i:
            case h:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case l:
                case f:
                case y:
                case g:
                case s:
                  return A;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function S(A) {
    return x(A) === u;
  }
  t.AsyncMode = c, t.ConcurrentMode = u, t.ContextConsumer = l, t.ContextProvider = s, t.Element = r, t.ForwardRef = f, t.Fragment = a, t.Lazy = y, t.Memo = g, t.Portal = n, t.Profiler = o, t.StrictMode = i, t.Suspense = h, t.isAsyncMode = function(A) {
    return S(A) || x(A) === c;
  }, t.isConcurrentMode = S, t.isContextConsumer = function(A) {
    return x(A) === l;
  }, t.isContextProvider = function(A) {
    return x(A) === s;
  }, t.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === r;
  }, t.isForwardRef = function(A) {
    return x(A) === f;
  }, t.isFragment = function(A) {
    return x(A) === a;
  }, t.isLazy = function(A) {
    return x(A) === y;
  }, t.isMemo = function(A) {
    return x(A) === g;
  }, t.isPortal = function(A) {
    return x(A) === n;
  }, t.isProfiler = function(A) {
    return x(A) === o;
  }, t.isStrictMode = function(A) {
    return x(A) === i;
  }, t.isSuspense = function(A) {
    return x(A) === h;
  }, t.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === a || A === u || A === o || A === i || A === h || A === p || typeof A == "object" && A !== null && (A.$$typeof === y || A.$$typeof === g || A.$$typeof === s || A.$$typeof === l || A.$$typeof === f || A.$$typeof === w || A.$$typeof === _ || A.$$typeof === C || A.$$typeof === b);
  }, t.typeOf = x;
} }), VPt = po({ "../../../node_modules/hoist-non-react-statics/node_modules/react-is/index.js"(t, e) {
  e.exports = UPt();
} }), fKe = po({ "../../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(t, e) {
  var r = VPt(), n = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, a = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, i = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, o = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, s = {};
  s[r.ForwardRef] = i, s[r.Memo] = o;
  function l(b) {
    return r.isMemo(b) ? o : s[b.$$typeof] || n;
  }
  var c = Object.defineProperty, u = Object.getOwnPropertyNames, f = Object.getOwnPropertySymbols, h = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, g = Object.prototype;
  function y(b, w, _) {
    if (typeof w != "string") {
      if (g) {
        var C = p(w);
        C && C !== g && y(b, C, _);
      }
      var x = u(w);
      f && (x = x.concat(f(w)));
      for (var S = l(b), A = l(w), I = 0; I < x.length; ++I) {
        var M = x[I];
        if (!a[M] && !(_ && _[M]) && !(A && A[M]) && !(S && S[M])) {
          var B = h(w, M);
          try {
            c(b, M, B);
          } catch {
          }
        }
      }
    }
    return b;
  }
  e.exports = y;
} }), hKe = po({ "../../../node_modules/@emotion/react/_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = fKe();
  function r(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var n = r(e), a = function(i, o) {
    return n.default(i, o);
  };
  t.default = a;
} }), qPt = po({ "../../../node_modules/@emotion/utils/dist/emotion-utils.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = typeof document < "u";
  function r(i, o, s) {
    var l = "";
    return s.split(" ").forEach(function(c) {
      i[c] !== void 0 ? o.push(i[c] + ";") : l += c + " ";
    }), l;
  }
  var n = function(i, o, s) {
    var l = i.key + "-" + o.name;
    (s === !1 || e === !1 && i.compat !== void 0) && i.registered[l] === void 0 && (i.registered[l] = o.styles);
  }, a = function(i, o, s) {
    n(i, o, s);
    var l = i.key + "-" + o.name;
    if (i.inserted[o.name] === void 0) {
      var c = "", u = o;
      do {
        var f = i.insert(o === u ? "." + l : "", u, i.sheet, !0);
        !e && f !== void 0 && (c += f), u = u.next;
      } while (u !== void 0);
      if (!e && c.length !== 0) return c;
    }
  };
  t.getRegisteredStyles = r, t.insertStyles = a, t.registerStyles = n;
} }), Sz = po({ "../../../node_modules/@emotion/utils/dist/emotion-utils.cjs.js"(t, e) {
  e.exports = qPt();
} }), KPt = po({ "../../../node_modules/@emotion/hash/dist/emotion-hash.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  function e(r) {
    for (var n = 0, a, i = 0, o = r.length; o >= 4; ++i, o -= 4) a = r.charCodeAt(i) & 255 | (r.charCodeAt(++i) & 255) << 8 | (r.charCodeAt(++i) & 255) << 16 | (r.charCodeAt(++i) & 255) << 24, a = (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16), a ^= a >>> 24, n = (a & 65535) * 1540483477 + ((a >>> 16) * 59797 << 16) ^ (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
    switch (o) {
      case 3:
        n ^= (r.charCodeAt(i + 2) & 255) << 16;
      case 2:
        n ^= (r.charCodeAt(i + 1) & 255) << 8;
      case 1:
        n ^= r.charCodeAt(i) & 255, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16);
    }
    return n ^= n >>> 13, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), ((n ^ n >>> 15) >>> 0).toString(36);
  }
  t.default = e;
} }), ZPt = po({ "../../../node_modules/@emotion/hash/dist/emotion-hash.cjs.js"(t, e) {
  e.exports = KPt();
} }), JPt = po({ "../../../node_modules/@emotion/unitless/dist/emotion-unitless.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = { animationIterationCount: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 };
  t.default = e;
} }), YPt = po({ "../../../node_modules/@emotion/unitless/dist/emotion-unitless.cjs.js"(t, e) {
  e.exports = JPt();
} }), XPt = po({ "../../../node_modules/@emotion/serialize/dist/emotion-serialize.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = ZPt(), r = YPt(), n = w2e();
  function a(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var i = a(e), o = a(r), s = a(n), l = /[A-Z]|^ms/g, c = /_EMO_([^_]+?)_([^]*?)_EMO_/g, u = function(C) {
    return C.charCodeAt(1) === 45;
  }, f = function(C) {
    return C != null && typeof C != "boolean";
  }, h = s.default(function(C) {
    return u(C) ? C : C.replace(l, "-$&").toLowerCase();
  }), p = function(C, x) {
    switch (C) {
      case "animation":
      case "animationName":
        if (typeof x == "string") return x.replace(c, function(S, A, I) {
          return w = { name: A, styles: I, next: w }, A;
        });
    }
    return o.default[C] !== 1 && !u(C) && typeof x == "number" && x !== 0 ? x + "px" : x;
  };
  function g(C, x, S) {
    if (S == null) return "";
    if (S.__emotion_styles !== void 0) return S;
    switch (typeof S) {
      case "boolean":
        return "";
      case "object": {
        if (S.anim === 1) return w = { name: S.name, styles: S.styles, next: w }, S.name;
        if (S.styles !== void 0) {
          var A = S.next;
          if (A !== void 0) for (; A !== void 0; ) w = { name: A.name, styles: A.styles, next: w }, A = A.next;
          var I = S.styles + ";";
          return I;
        }
        return y(C, x, S);
      }
      case "function": {
        if (C !== void 0) {
          var M = w, B = S(C);
          return w = M, g(C, x, B);
        }
        break;
      }
    }
    if (x == null) return S;
    var L = x[S];
    return L !== void 0 ? L : S;
  }
  function y(C, x, S) {
    var A = "";
    if (Array.isArray(S)) for (var I = 0; I < S.length; I++) A += g(C, x, S[I]) + ";";
    else for (var M in S) {
      var B = S[M];
      if (typeof B != "object") x != null && x[B] !== void 0 ? A += M + "{" + x[B] + "}" : f(B) && (A += h(M) + ":" + p(M, B) + ";");
      else if (Array.isArray(B) && typeof B[0] == "string" && (x == null || x[B[0]] === void 0)) for (var L = 0; L < B.length; L++) f(B[L]) && (A += h(M) + ":" + p(M, B[L]) + ";");
      else {
        var N = g(C, x, B);
        switch (M) {
          case "animation":
          case "animationName": {
            A += h(M) + ":" + N + ";";
            break;
          }
          default:
            A += M + "{" + N + "}";
        }
      }
    }
    return A;
  }
  var b = /label:\s*([^\s;\n{]+)\s*(;|$)/g, w, _ = function(C, x, S) {
    if (C.length === 1 && typeof C[0] == "object" && C[0] !== null && C[0].styles !== void 0) return C[0];
    var A = !0, I = "";
    w = void 0;
    var M = C[0];
    M == null || M.raw === void 0 ? (A = !1, I += g(S, x, M)) : I += M[0];
    for (var B = 1; B < C.length; B++) I += g(S, x, C[B]), A && (I += M[B]);
    b.lastIndex = 0;
    for (var L = "", N; (N = b.exec(I)) !== null; ) L += "-" + N[1];
    var d = i.default(I) + L;
    return { name: d, styles: I, next: w };
  };
  t.serializeStyles = _;
} }), _z = po({ "../../../node_modules/@emotion/serialize/dist/emotion-serialize.cjs.js"(t, e) {
  e.exports = XPt();
} }), QPt = po({ "../../../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = (HI(), Cz(b8));
  function r(c) {
    if (c && c.__esModule) return c;
    var u = /* @__PURE__ */ Object.create(null);
    return c && Object.keys(c).forEach(function(f) {
      if (f !== "default") {
        var h = Object.getOwnPropertyDescriptor(c, f);
        Object.defineProperty(u, f, h.get ? h : { enumerable: !0, get: function() {
          return c[f];
        } });
      }
    }), u.default = c, Object.freeze(u);
  }
  var n = r(e), a = typeof document < "u", i = function(c) {
    return c();
  }, o = n.useInsertionEffect ? n.useInsertionEffect : !1, s = a && o || i, l = o || e.useLayoutEffect;
  t.useInsertionEffectAlwaysWithSyncFallback = s, t.useInsertionEffectWithLayoutFallback = l;
} }), kz = po({ "../../../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.cjs.js"(t, e) {
  e.exports = QPt();
} }), eRt = po({ "../../../node_modules/@emotion/react/dist/emotion-element-20108edd.cjs.prod.js"(t) {
  var e = (HI(), Cz(b8)), r = S2e(), n = wz(), a = C2e(), i = hKe(), o = Sz(), s = _z(), l = kz();
  function c(N) {
    return N && N.__esModule ? N : { default: N };
  }
  var u = c(r), f = c(a), h = typeof document < "u", p = {}.hasOwnProperty, g = e.createContext(typeof HTMLElement < "u" ? u.default({ key: "css" }) : null), y = g.Provider, b = function() {
    return e.useContext(g);
  };
  t.withEmotionCache = function(N) {
    return e.forwardRef(function(d, m) {
      var v = e.useContext(g);
      return N(d, v, m);
    });
  }, h || (t.withEmotionCache = function(N) {
    return function(d) {
      var m = e.useContext(g);
      return m === null ? (m = u.default({ key: "css" }), e.createElement(g.Provider, { value: m }, N(d, m))) : N(d, m);
    };
  });
  var w = e.createContext({}), _ = function() {
    return e.useContext(w);
  }, C = function(N, d) {
    if (typeof d == "function") {
      var m = d(N);
      return m;
    }
    return n({}, N, d);
  }, x = f.default(function(N) {
    return f.default(function(d) {
      return C(N, d);
    });
  }), S = function(N) {
    var d = e.useContext(w);
    return N.theme !== d && (d = x(d)(N.theme)), e.createElement(w.Provider, { value: d }, N.children);
  };
  function A(N) {
    var d = N.displayName || N.name || "Component", m = function(k, O) {
      var G = e.useContext(w);
      return e.createElement(N, n({ theme: G, ref: O }, k));
    }, v = e.forwardRef(m);
    return v.displayName = "WithTheme(" + d + ")", i.default(v, N);
  }
  var I = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", M = function(N, d) {
    var m = {};
    for (var v in d) p.call(d, v) && (m[v] = d[v]);
    return m[I] = N, m;
  }, B = function(N) {
    var d = N.cache, m = N.serialized, v = N.isStringTag;
    o.registerStyles(d, m, v);
    var k = l.useInsertionEffectAlwaysWithSyncFallback(function() {
      return o.insertStyles(d, m, v);
    });
    if (!h && k !== void 0) {
      for (var O, G = m.name, H = m.next; H !== void 0; ) G += " " + H.name, H = H.next;
      return e.createElement("style", (O = {}, O["data-emotion"] = d.key + " " + G, O.dangerouslySetInnerHTML = { __html: k }, O.nonce = d.sheet.nonce, O));
    }
    return null;
  }, L = t.withEmotionCache(function(N, d, m) {
    var v = N.css;
    typeof v == "string" && d.registered[v] !== void 0 && (v = d.registered[v]);
    var k = N[I], O = [v], G = "";
    typeof N.className == "string" ? G = o.getRegisteredStyles(d.registered, O, N.className) : N.className != null && (G = N.className + " ");
    var H = s.serializeStyles(O, void 0, e.useContext(w));
    G += d.key + "-" + H.name;
    var j = {};
    for (var F in N) p.call(N, F) && F !== "css" && F !== I && (j[F] = N[F]);
    return j.ref = m, j.className = G, e.createElement(e.Fragment, null, e.createElement(B, { cache: d, serialized: H, isStringTag: typeof k == "string" }), e.createElement(k, j));
  });
  t.CacheProvider = y, t.Emotion = L, t.ThemeContext = w, t.ThemeProvider = S, t.__unsafe_useEmotionCache = b, t.createEmotionProps = M, t.hasOwnProperty = p, t.isBrowser = h, t.useTheme = _, t.withTheme = A;
} }), tRt = po({ "../../../node_modules/@emotion/react/dist/emotion-react.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = (HI(), Cz(b8));
  S2e();
  var r = eRt();
  wz(), C2e(), fKe(), hKe();
  var n = Sz(), a = _z(), i = kz(), o = function(g, y) {
    var b = arguments;
    if (y == null || !r.hasOwnProperty.call(y, "css")) return e.createElement.apply(void 0, b);
    var w = b.length, _ = new Array(w);
    _[0] = r.Emotion, _[1] = r.createEmotionProps(g, y);
    for (var C = 2; C < w; C++) _[C] = b[C];
    return e.createElement.apply(null, _);
  }, s = r.withEmotionCache(function(g, y) {
    var b = g.styles, w = a.serializeStyles([b], void 0, e.useContext(r.ThemeContext));
    if (!r.isBrowser) {
      for (var _, C = w.name, x = w.styles, S = w.next; S !== void 0; ) C += " " + S.name, x += S.styles, S = S.next;
      var A = y.compat === !0, I = y.insert("", { name: C, styles: x }, y.sheet, A);
      return A ? null : e.createElement("style", (_ = {}, _["data-emotion"] = y.key + "-global " + C, _.dangerouslySetInnerHTML = { __html: I }, _.nonce = y.sheet.nonce, _));
    }
    var M = e.useRef();
    return i.useInsertionEffectWithLayoutFallback(function() {
      var B = y.key + "-global", L = new y.sheet.constructor({ key: B, nonce: y.sheet.nonce, container: y.sheet.container, speedy: y.sheet.isSpeedy }), N = !1, d = document.querySelector('style[data-emotion="' + B + " " + w.name + '"]');
      return y.sheet.tags.length && (L.before = y.sheet.tags[0]), d !== null && (N = !0, d.setAttribute("data-emotion", B), L.hydrate([d])), M.current = [L, N], function() {
        L.flush();
      };
    }, [y]), i.useInsertionEffectWithLayoutFallback(function() {
      var B = M.current, L = B[0], N = B[1];
      if (N) {
        B[1] = !1;
        return;
      }
      if (w.next !== void 0 && n.insertStyles(y, w.next, !0), L.tags.length) {
        var d = L.tags[L.tags.length - 1].nextElementSibling;
        L.before = d, L.flush();
      }
      y.insert("", w, L, !1);
    }, [y, w.name]), null;
  });
  function l() {
    for (var g = arguments.length, y = new Array(g), b = 0; b < g; b++) y[b] = arguments[b];
    return a.serializeStyles(y);
  }
  var c = function() {
    var g = l.apply(void 0, arguments), y = "animation-" + g.name;
    return { name: y, styles: "@keyframes " + y + "{" + g.styles + "}", anim: 1, toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    } };
  }, u = function g(y) {
    for (var b = y.length, w = 0, _ = ""; w < b; w++) {
      var C = y[w];
      if (C != null) {
        var x = void 0;
        switch (typeof C) {
          case "boolean":
            break;
          case "object": {
            if (Array.isArray(C)) x = g(C);
            else {
              x = "";
              for (var S in C) C[S] && S && (x && (x += " "), x += S);
            }
            break;
          }
          default:
            x = C;
        }
        x && (_ && (_ += " "), _ += x);
      }
    }
    return _;
  };
  function f(g, y, b) {
    var w = [], _ = n.getRegisteredStyles(g, w, b);
    return w.length < 2 ? b : _ + y(w);
  }
  var h = function(g) {
    var y = g.cache, b = g.serializedArr, w = i.useInsertionEffectAlwaysWithSyncFallback(function() {
      for (var C = "", x = 0; x < b.length; x++) {
        var S = n.insertStyles(y, b[x], !1);
        !r.isBrowser && S !== void 0 && (C += S);
      }
      if (!r.isBrowser) return C;
    });
    if (!r.isBrowser && w.length !== 0) {
      var _;
      return e.createElement("style", (_ = {}, _["data-emotion"] = y.key + " " + b.map(function(C) {
        return C.name;
      }).join(" "), _.dangerouslySetInnerHTML = { __html: w }, _.nonce = y.sheet.nonce, _));
    }
    return null;
  }, p = r.withEmotionCache(function(g, y) {
    var b = [], w = function() {
      for (var S = arguments.length, A = new Array(S), I = 0; I < S; I++) A[I] = arguments[I];
      var M = a.serializeStyles(A, y.registered);
      return b.push(M), n.registerStyles(y, M, !1), y.key + "-" + M.name;
    }, _ = function() {
      for (var S = arguments.length, A = new Array(S), I = 0; I < S; I++) A[I] = arguments[I];
      return f(y.registered, w, u(A));
    }, C = { css: w, cx: _, theme: e.useContext(r.ThemeContext) }, x = g.children(C);
    return e.createElement(e.Fragment, null, e.createElement(h, { cache: y, serializedArr: b }), x);
  });
  t.CacheProvider = r.CacheProvider, t.ThemeContext = r.ThemeContext, t.ThemeProvider = r.ThemeProvider, t.__unsafe_useEmotionCache = r.__unsafe_useEmotionCache, t.useTheme = r.useTheme, Object.defineProperty(t, "withEmotionCache", { enumerable: !0, get: function() {
    return r.withEmotionCache;
  } }), t.withTheme = r.withTheme, t.ClassNames = p, t.Global = s, t.createElement = o, t.css = l, t.jsx = o, t.keyframes = c;
} }), _2e = po({ "../../../node_modules/@emotion/react/dist/emotion-react.cjs.js"(t, e) {
  e.exports = tRt();
} }), rRt = po({ "../../../node_modules/@emotion/styled/base/dist/emotion-styled-base.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var e = wz(), r = (HI(), Cz(b8)), n = dKe(), a = _2e(), i = Sz(), o = _z(), s = kz();
  function l(w) {
    return w && w.__esModule ? w : { default: w };
  }
  var c = l(n), u = c.default, f = function(w) {
    return w !== "theme";
  }, h = function(w) {
    return typeof w == "string" && w.charCodeAt(0) > 96 ? u : f;
  }, p = function(w, _, C) {
    var x;
    if (_) {
      var S = _.shouldForwardProp;
      x = w.__emotion_forwardProp && S ? function(A) {
        return w.__emotion_forwardProp(A) && S(A);
      } : S;
    }
    return typeof x != "function" && C && (x = w.__emotion_forwardProp), x;
  }, g = typeof document < "u", y = function(w) {
    var _ = w.cache, C = w.serialized, x = w.isStringTag;
    i.registerStyles(_, C, x);
    var S = s.useInsertionEffectAlwaysWithSyncFallback(function() {
      return i.insertStyles(_, C, x);
    });
    if (!g && S !== void 0) {
      for (var A, I = C.name, M = C.next; M !== void 0; ) I += " " + M.name, M = M.next;
      return r.createElement("style", (A = {}, A["data-emotion"] = _.key + " " + I, A.dangerouslySetInnerHTML = { __html: S }, A.nonce = _.sheet.nonce, A));
    }
    return null;
  }, b = function w(_, C) {
    var x = _.__emotion_real === _, S = x && _.__emotion_base || _, A, I;
    C !== void 0 && (A = C.label, I = C.target);
    var M = p(_, C, x), B = M || h(S), L = !B("as");
    return function() {
      var N = arguments, d = x && _.__emotion_styles !== void 0 ? _.__emotion_styles.slice(0) : [];
      if (A !== void 0 && d.push("label:" + A + ";"), N[0] == null || N[0].raw === void 0) d.push.apply(d, N);
      else {
        d.push(N[0][0]);
        for (var m = N.length, v = 1; v < m; v++) d.push(N[v], N[0][v]);
      }
      var k = a.withEmotionCache(function(O, G, H) {
        var j = L && O.as || S, F = "", z = [], W = O;
        if (O.theme == null) {
          W = {};
          for (var U in O) W[U] = O[U];
          W.theme = r.useContext(a.ThemeContext);
        }
        typeof O.className == "string" ? F = i.getRegisteredStyles(G.registered, z, O.className) : O.className != null && (F = O.className + " ");
        var Z = o.serializeStyles(d.concat(z), G.registered, W);
        F += G.key + "-" + Z.name, I !== void 0 && (F += " " + I);
        var V = L && M === void 0 ? h(j) : B, Y = {};
        for (var ge in O) L && ge === "as" || V(ge) && (Y[ge] = O[ge]);
        return Y.className = F, Y.ref = H, r.createElement(r.Fragment, null, r.createElement(y, { cache: G, serialized: Z, isStringTag: typeof j == "string" }), r.createElement(j, Y));
      });
      return k.displayName = A !== void 0 ? A : "Styled(" + (typeof S == "string" ? S : S.displayName || S.name || "Component") + ")", k.defaultProps = _.defaultProps, k.__emotion_real = k, k.__emotion_base = S, k.__emotion_styles = d, k.__emotion_forwardProp = M, Object.defineProperty(k, "toString", { value: function() {
        return "." + I;
      } }), k.withComponent = function(O, G) {
        return w(O, e({}, C, G, { shouldForwardProp: p(k, G, !0) })).apply(void 0, d);
      }, k;
    };
  };
  t.default = b;
} }), nRt = po({ "../../../node_modules/@emotion/styled/dist/emotion-styled.cjs.prod.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), wz(), HI(), dKe();
  var e = rRt();
  _2e(), Sz(), _z(), kz();
  var r = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"], n = e.default.bind();
  r.forEach(function(a) {
    n[a] = n(a);
  }), t.default = n;
} }), aRt = po({ "../../../node_modules/@emotion/styled/dist/emotion-styled.cjs.js"(t, e) {
  e.exports = nRt();
} }), iRt = po({ "../../../node_modules/object-assign/index.js"(t, e) {
  var r = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function i(s) {
    if (s == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function o() {
    try {
      if (!Object.assign) return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5") return !1;
      for (var l = {}, c = 0; c < 10; c++) l["_" + String.fromCharCode(c)] = c;
      var u = Object.getOwnPropertyNames(l).map(function(h) {
        return l[h];
      });
      if (u.join("") !== "0123456789") return !1;
      var f = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        f[h] = h;
      }), Object.keys(Object.assign({}, f)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  e.exports = o() ? Object.assign : function(s, l) {
    for (var c, u = i(s), f, h = 1; h < arguments.length; h++) {
      c = Object(arguments[h]);
      for (var p in c) n.call(c, p) && (u[p] = c[p]);
      if (r) {
        f = r(c);
        for (var g = 0; g < f.length; g++) a.call(c, f[g]) && (u[f[g]] = c[f[g]]);
      }
    }
    return u;
  };
} }), oRt = xz(S2e()), sRt = xz(aRt()), V2 = (t, e, r) => {
  let n = e && typeof e == "string" ? e.split(".") : [e], a = t;
  return n.forEach((i) => {
    a = a ? a[i] : void 0;
  }), a === void 0 ? r : a;
}, lRt = [40, 52, 64].map((t) => `${t}em`), cRt = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512], fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72] }, uRt = { bg: "backgroundColor", m: "margin", mt: "marginTop", mr: "marginRight", mb: "marginBottom", ml: "marginLeft", mx: "marginX", my: "marginY", p: "padding", pt: "paddingTop", pr: "paddingRight", pb: "paddingBottom", pl: "paddingLeft", px: "paddingX", py: "paddingY" }, g4e = { marginX: ["marginLeft", "marginRight"], marginY: ["marginTop", "marginBottom"], paddingX: ["paddingLeft", "paddingRight"], paddingY: ["paddingTop", "paddingBottom"], size: ["width", "height"] }, dRt = { color: "textColors", backgroundColor: "backgroundColors", borderColor: "borderColors", margin: "space", marginTop: "space", marginRight: "space", marginBottom: "space", marginLeft: "space", marginX: "space", marginY: "space", padding: "space", paddingTop: "space", paddingRight: "space", paddingBottom: "space", paddingLeft: "space", paddingX: "space", paddingY: "space", top: "space", right: "space", bottom: "space", left: "space", gridGap: "space", gridColumnGap: "space", gridRowGap: "space", gap: "space", columnGap: "space", rowGap: "space", fontFamily: "fonts", fontSize: "fontSizes", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", border: "borders", borderTop: "borders", borderRight: "borders", borderBottom: "borders", borderLeft: "borders", borderWidth: "borderWidths", borderStyle: "borderStyles", borderRadius: "radii", borderTopRightRadius: "radii", borderTopLeftRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", borderTopWidth: "borderWidths", borderTopColor: "borderColors", borderTopStyle: "borderStyles", borderBottomWidth: "borderWidths", borderBottomColor: "borderColors", borderBottomStyle: "borderStyles", borderLeftWidth: "borderWidths", borderLeftColor: "borderColors", borderLeftStyle: "borderStyles", borderRightWidth: "borderWidths", borderRightColor: "borderColors", borderRightStyle: "borderStyles", outlineColor: "outlineColors", boxShadow: "shadows", textShadow: "shadows", zIndex: "zIndices", width: "sizes", minWidth: "sizes", maxWidth: "sizes", height: "sizes", minHeight: "sizes", maxHeight: "sizes", flexBasis: "sizes", size: "sizes", "-webkit-text-fill-color": "textColors", fill: "fillColors", stroke: "strokeColors", colorScheme: "colorSchemes" }, fRt = (t, e) => {
  if (typeof e != "number" || e >= 0) return V2(t, e, e);
  let r = Math.abs(e), n = V2(t, r, r);
  return typeof n == "string" ? `-${n}` : n * -1;
}, hRt = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce((t, e) => ({ ...t, [e]: fRt }), {}), pRt = (t) => (e) => {
  let r = {}, n = [null, ...V2(e, "breakpoints", lRt).map((a) => `@media screen and (min-width: ${a})`)];
  for (let a in t) {
    let i = typeof t[a] == "function" ? t[a](e) : t[a];
    if (i != null) {
      if (!Array.isArray(i)) {
        r[a] = i;
        continue;
      }
      for (let o = 0; o < i.slice(0, n.length).length; o++) {
        let s = n[o];
        if (!s) {
          r[a] = i[o];
          continue;
        }
        r[s] = r[s] || {}, i[o] != null && (r[s][a] = i[o]);
      }
    }
  }
  return r;
}, us = (t) => (e = {}) => {
  let r = { ...cRt, ...e.theme || e }, n = {}, a = typeof t == "function" ? t(r) : t, i = pRt(a)(r);
  for (let o in i) {
    let s = i[o], l = typeof s == "function" ? s(r) : s;
    if (o === "variant") {
      let p = us(V2(r, l))(r);
      n = { ...n, ...p };
      continue;
    }
    if (l && typeof l == "object") {
      n[o] = us(l)(r);
      continue;
    }
    let c = V2(uRt, o, o), u = V2(dRt, c), f = V2(r, u, V2(r, c, {})), h = V2(hRt, c, V2)(f, l, l);
    if (g4e[c]) {
      let p = g4e[c];
      for (let g of p) n[g] = h;
    } else n[c] = h;
  }
  return n;
}, M1 = xz(iRt()), v4e = function(t, e) {
  var r = (0, M1.default)({}, t, e);
  for (var n in t) {
    var a;
    !t[n] || typeof e[n] != "object" || (0, M1.default)(r, (a = {}, a[n] = (0, M1.default)(t[n], e[n]), a));
  }
  return r;
}, mRt = function(t) {
  var e = {};
  return Object.keys(t).sort(function(r, n) {
    return r.localeCompare(n, void 0, { numeric: !0, sensitivity: "base" });
  }).forEach(function(r) {
    e[r] = t[r];
  }), e;
}, gRt = { breakpoints: [40, 52, 64].map(function(t) {
  return t + "em";
}) }, pKe = function(t) {
  return "@media screen and (min-width: " + t + ")";
}, vRt = function(t, e) {
  return Dh(e, t, t);
}, Dh = function(t, e, r, n, a) {
  for (e = e && e.split ? e.split(".") : [e], n = 0; n < e.length; n++) t = t ? t[e[n]] : a;
  return t === a ? r : t;
}, UI = function t(e) {
  var r = {}, n = function(i) {
    var o = {}, s = !1, l = i.theme && i.theme.disableStyledSystemCache;
    for (var c in i) if (e[c]) {
      var u = e[c], f = i[c], h = Dh(i.theme, u.scale, u.defaults);
      if (typeof f == "object") {
        if (r.breakpoints = !l && r.breakpoints || Dh(i.theme, "breakpoints", gRt.breakpoints), Array.isArray(f)) {
          r.media = !l && r.media || [null].concat(r.breakpoints.map(pKe)), o = v4e(o, yRt(r.media, u, h, f, i));
          continue;
        }
        f !== null && (o = v4e(o, bRt(r.breakpoints, u, h, f, i)), s = !0);
        continue;
      }
      (0, M1.default)(o, u(f, h, i));
    }
    return s && (o = mRt(o)), o;
  };
  n.config = e, n.propNames = Object.keys(e), n.cache = r;
  var a = Object.keys(e).filter(function(i) {
    return i !== "config";
  });
  return a.length > 1 && a.forEach(function(i) {
    var o;
    n[i] = t((o = {}, o[i] = e[i], o));
  }), n;
}, yRt = function(t, e, r, n, a) {
  var i = {};
  return n.slice(0, t.length).forEach(function(o, s) {
    var l = t[s], c = e(o, r, a);
    if (!l) (0, M1.default)(i, c);
    else {
      var u;
      (0, M1.default)(i, (u = {}, u[l] = (0, M1.default)({}, i[l], c), u));
    }
  }), i;
}, bRt = function(t, e, r, n, a) {
  var i = {};
  for (var o in n) {
    var s = t[o], l = n[o], c = e(l, r, a);
    if (!s) (0, M1.default)(i, c);
    else {
      var u, f = pKe(s);
      (0, M1.default)(i, (u = {}, u[f] = (0, M1.default)({}, i[f], c), u));
    }
  }
  return i;
}, lL = function(t) {
  var e = t.properties, r = t.property, n = t.scale, a = t.transform, i = a === void 0 ? vRt : a, o = t.defaultScale;
  e = e || [r];
  var s = function(l, c, u) {
    var f = {}, h = i(l, c, u);
    if (h !== null) return e.forEach(function(p) {
      f[p] = h;
    }), f;
  };
  return s.scale = n, s.defaults = o, s;
}, zu = function(t) {
  t === void 0 && (t = {});
  var e = {};
  Object.keys(t).forEach(function(n) {
    var a = t[n];
    if (a === !0) {
      e[n] = lL({ property: n, scale: n });
      return;
    }
    if (typeof a == "function") {
      e[n] = a;
      return;
    }
    e[n] = lL(a);
  });
  var r = UI(e);
  return r;
}, x8 = function() {
  for (var t = {}, e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];
  r.forEach(function(i) {
    !i || !i.config || (0, M1.default)(t, i.config);
  });
  var a = UI(t);
  return a;
}, Yce = function(t, e) {
  return e === void 0 && (e = null), function(r) {
    return Dh(r.theme, t, e);
  };
};
function xRt(t) {
  var e = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var CRt = xRt;
function wRt(t) {
  var e = {};
  return function(r) {
    return e[r] === void 0 && (e[r] = t(r)), e[r];
  };
}
var SRt = wRt, _Rt = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, kRt = SRt(function(t) {
  return _Rt.test(t) || t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) < 91;
}), ARt = kRt, TRt = function(t) {
  return typeof t == "number" && !isNaN(t);
}, ERt = function(t, e) {
  return Dh(e, t, !TRt(t) || t > 1 ? t : t * 100 + "%");
}, IRt = { width: { property: "width", scale: "sizes", transform: ERt }, height: { property: "height", scale: "sizes" }, minWidth: { property: "minWidth", scale: "sizes" }, minHeight: { property: "minHeight", scale: "sizes" }, maxWidth: { property: "maxWidth", scale: "sizes" }, maxHeight: { property: "maxHeight", scale: "sizes" }, size: { properties: ["width", "height"], scale: "sizes" }, overflow: !0, overflowX: !0, overflowY: !0, display: !0, verticalAlign: !0 }, Az = zu(IRt), yf = Az, Xce = { color: { property: "color", scale: "colors" }, backgroundColor: { property: "backgroundColor", scale: "colors" }, opacity: !0 };
Xce.bg = Xce.backgroundColor;
var k2e = zu(Xce), MRt = k2e, PRt = { fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72] }, RRt = { fontFamily: { property: "fontFamily", scale: "fonts" }, fontSize: { property: "fontSize", scale: "fontSizes", defaultScale: PRt.fontSizes }, fontWeight: { property: "fontWeight", scale: "fontWeights" }, lineHeight: { property: "lineHeight", scale: "lineHeights" }, letterSpacing: { property: "letterSpacing", scale: "letterSpacings" }, textAlign: !0, fontStyle: !0 }, C8 = zu(RRt), q5 = C8, ORt = { alignItems: !0, alignContent: !0, justifyItems: !0, justifyContent: !0, flexWrap: !0, flexDirection: !0, flex: !0, flexGrow: !0, flexShrink: !0, flexBasis: !0, justifySelf: !0, alignSelf: !0, order: !0 }, Tz = zu(ORt), b0 = Tz, jK = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, BRt = { gridGap: { property: "gridGap", scale: "space", defaultScale: jK.space }, gridColumnGap: { property: "gridColumnGap", scale: "space", defaultScale: jK.space }, gridRowGap: { property: "gridRowGap", scale: "space", defaultScale: jK.space }, gridColumn: !0, gridRow: !0, gridAutoFlow: !0, gridAutoColumns: !0, gridAutoRows: !0, gridTemplateColumns: !0, gridTemplateRows: !0, gridTemplateAreas: !0, gridArea: !0 }, Ez = zu(BRt), bf = Ez, kc = { border: { property: "border", scale: "borders" }, borderWidth: { property: "borderWidth", scale: "borderWidths" }, borderStyle: { property: "borderStyle", scale: "borderStyles" }, borderColor: { property: "borderColor", scale: "colors" }, borderRadius: { property: "borderRadius", scale: "radii" }, borderTop: { property: "borderTop", scale: "borders" }, borderTopLeftRadius: { property: "borderTopLeftRadius", scale: "radii" }, borderTopRightRadius: { property: "borderTopRightRadius", scale: "radii" }, borderRight: { property: "borderRight", scale: "borders" }, borderBottom: { property: "borderBottom", scale: "borders" }, borderBottomLeftRadius: { property: "borderBottomLeftRadius", scale: "radii" }, borderBottomRightRadius: { property: "borderBottomRightRadius", scale: "radii" }, borderLeft: { property: "borderLeft", scale: "borders" }, borderX: { properties: ["borderLeft", "borderRight"], scale: "borders" }, borderY: { properties: ["borderTop", "borderBottom"], scale: "borders" } };
kc.borderTopWidth = { property: "borderTopWidth", scale: "borderWidths" };
kc.borderTopColor = { property: "borderTopColor", scale: "colors" };
kc.borderTopStyle = { property: "borderTopStyle", scale: "borderStyles" };
kc.borderTopLeftRadius = { property: "borderTopLeftRadius", scale: "radii" };
kc.borderTopRightRadius = { property: "borderTopRightRadius", scale: "radii" };
kc.borderBottomWidth = { property: "borderBottomWidth", scale: "borderWidths" };
kc.borderBottomColor = { property: "borderBottomColor", scale: "colors" };
kc.borderBottomStyle = { property: "borderBottomStyle", scale: "borderStyles" };
kc.borderBottomLeftRadius = { property: "borderBottomLeftRadius", scale: "radii" };
kc.borderBottomRightRadius = { property: "borderBottomRightRadius", scale: "radii" };
kc.borderLeftWidth = { property: "borderLeftWidth", scale: "borderWidths" };
kc.borderLeftColor = { property: "borderLeftColor", scale: "colors" };
kc.borderLeftStyle = { property: "borderLeftStyle", scale: "borderStyles" };
kc.borderRightWidth = { property: "borderRightWidth", scale: "borderWidths" };
kc.borderRightColor = { property: "borderRightColor", scale: "colors" };
kc.borderRightStyle = { property: "borderRightStyle", scale: "borderStyles" };
var Iz = zu(kc), sg = Iz, Hm = { background: !0, backgroundImage: !0, backgroundSize: !0, backgroundPosition: !0, backgroundRepeat: !0 };
Hm.bgImage = Hm.backgroundImage;
Hm.bgSize = Hm.backgroundSize;
Hm.bgPosition = Hm.backgroundPosition;
Hm.bgRepeat = Hm.backgroundRepeat;
var Mz = zu(Hm), Pz = Mz, rB = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, NRt = { position: !0, zIndex: { property: "zIndex", scale: "zIndices" }, top: { property: "top", scale: "space", defaultScale: rB.space }, right: { property: "right", scale: "space", defaultScale: rB.space }, bottom: { property: "bottom", scale: "space", defaultScale: rB.space }, left: { property: "left", scale: "space", defaultScale: rB.space } }, w8 = zu(NRt), VI = w8, dd = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512] }, y4e = function(t) {
  return typeof t == "number" && !isNaN(t);
}, z3 = function(t, e) {
  if (!y4e(t)) return Dh(e, t, t);
  var r = t < 0, n = Math.abs(t), a = Dh(e, n, n);
  return y4e(a) ? a * (r ? -1 : 1) : r ? "-" + a : a;
}, vo = {};
vo.margin = { margin: { property: "margin", scale: "space", transform: z3, defaultScale: dd.space }, marginTop: { property: "marginTop", scale: "space", transform: z3, defaultScale: dd.space }, marginRight: { property: "marginRight", scale: "space", transform: z3, defaultScale: dd.space }, marginBottom: { property: "marginBottom", scale: "space", transform: z3, defaultScale: dd.space }, marginLeft: { property: "marginLeft", scale: "space", transform: z3, defaultScale: dd.space }, marginX: { properties: ["marginLeft", "marginRight"], scale: "space", transform: z3, defaultScale: dd.space }, marginY: { properties: ["marginTop", "marginBottom"], scale: "space", transform: z3, defaultScale: dd.space } };
vo.margin.m = vo.margin.margin;
vo.margin.mt = vo.margin.marginTop;
vo.margin.mr = vo.margin.marginRight;
vo.margin.mb = vo.margin.marginBottom;
vo.margin.ml = vo.margin.marginLeft;
vo.margin.mx = vo.margin.marginX;
vo.margin.my = vo.margin.marginY;
vo.padding = { padding: { property: "padding", scale: "space", defaultScale: dd.space }, paddingTop: { property: "paddingTop", scale: "space", defaultScale: dd.space }, paddingRight: { property: "paddingRight", scale: "space", defaultScale: dd.space }, paddingBottom: { property: "paddingBottom", scale: "space", defaultScale: dd.space }, paddingLeft: { property: "paddingLeft", scale: "space", defaultScale: dd.space }, paddingX: { properties: ["paddingLeft", "paddingRight"], scale: "space", defaultScale: dd.space }, paddingY: { properties: ["paddingTop", "paddingBottom"], scale: "space", defaultScale: dd.space } };
vo.padding.p = vo.padding.padding;
vo.padding.pt = vo.padding.paddingTop;
vo.padding.pr = vo.padding.paddingRight;
vo.padding.pb = vo.padding.paddingBottom;
vo.padding.pl = vo.padding.paddingLeft;
vo.padding.px = vo.padding.paddingX;
vo.padding.py = vo.padding.paddingY;
var mKe = zu(vo.margin), gKe = zu(vo.padding), qI = x8(mKe, gKe), A2e = zu({ boxShadow: { property: "boxShadow", scale: "shadows" }, textShadow: { property: "textShadow", scale: "shadows" } }), wT = A2e;
function ST() {
  return ST = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ST.apply(this, arguments);
}
var q2 = function(t, e, r, n, a) {
  for (e = e && e.split ? e.split(".") : [e], n = 0; n < e.length; n++) t = t ? t[e[n]] : a;
  return t === a ? r : t;
}, $Rt = [40, 52, 64].map(function(t) {
  return t + "em";
}), DRt = { space: [0, 4, 8, 16, 32, 64, 128, 256, 512], fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72] }, LRt = { bg: "backgroundColor", m: "margin", mt: "marginTop", mr: "marginRight", mb: "marginBottom", ml: "marginLeft", mx: "marginX", my: "marginY", p: "padding", pt: "paddingTop", pr: "paddingRight", pb: "paddingBottom", pl: "paddingLeft", px: "paddingX", py: "paddingY" }, b4e = { marginX: ["marginLeft", "marginRight"], marginY: ["marginTop", "marginBottom"], paddingX: ["paddingLeft", "paddingRight"], paddingY: ["paddingTop", "paddingBottom"], size: ["width", "height"] }, jRt = { color: "colors", backgroundColor: "colors", borderColor: "colors", margin: "space", marginTop: "space", marginRight: "space", marginBottom: "space", marginLeft: "space", marginX: "space", marginY: "space", padding: "space", paddingTop: "space", paddingRight: "space", paddingBottom: "space", paddingLeft: "space", paddingX: "space", paddingY: "space", top: "space", right: "space", bottom: "space", left: "space", gridGap: "space", gridColumnGap: "space", gridRowGap: "space", gap: "space", columnGap: "space", rowGap: "space", fontFamily: "fonts", fontSize: "fontSizes", fontWeight: "fontWeights", lineHeight: "lineHeights", letterSpacing: "letterSpacings", border: "borders", borderTop: "borders", borderRight: "borders", borderBottom: "borders", borderLeft: "borders", borderWidth: "borderWidths", borderStyle: "borderStyles", borderRadius: "radii", borderTopRightRadius: "radii", borderTopLeftRadius: "radii", borderBottomRightRadius: "radii", borderBottomLeftRadius: "radii", borderTopWidth: "borderWidths", borderTopColor: "colors", borderTopStyle: "borderStyles", borderBottomWidth: "borderWidths", borderBottomColor: "colors", borderBottomStyle: "borderStyles", borderLeftWidth: "borderWidths", borderLeftColor: "colors", borderLeftStyle: "borderStyles", borderRightWidth: "borderWidths", borderRightColor: "colors", borderRightStyle: "borderStyles", outlineColor: "colors", boxShadow: "shadows", textShadow: "shadows", zIndex: "zIndices", width: "sizes", minWidth: "sizes", maxWidth: "sizes", height: "sizes", minHeight: "sizes", maxHeight: "sizes", flexBasis: "sizes", size: "sizes", fill: "colors", stroke: "colors" }, FRt = function(t, e) {
  if (typeof e != "number" || e >= 0) return q2(t, e, e);
  var r = Math.abs(e), n = q2(t, r, r);
  return typeof n == "string" ? "-" + n : n * -1;
}, zRt = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(t, e) {
  var r;
  return ST({}, t, (r = {}, r[e] = FRt, r));
}, {}), GRt = function(t) {
  return function(e) {
    var r = {}, n = q2(e, "breakpoints", $Rt), a = [null].concat(n.map(function(c) {
      return "@media screen and (min-width: " + c + ")";
    }));
    for (var i in t) {
      var o = typeof t[i] == "function" ? t[i](e) : t[i];
      if (o != null) {
        if (!Array.isArray(o)) {
          r[i] = o;
          continue;
        }
        for (var s = 0; s < o.slice(0, a.length).length; s++) {
          var l = a[s];
          if (!l) {
            r[i] = o[s];
            continue;
          }
          r[l] = r[l] || {}, o[s] != null && (r[l][i] = o[s]);
        }
      }
    }
    return r;
  };
}, WRt = function t(e) {
  return function(r) {
    r === void 0 && (r = {});
    var n = ST({}, DRt, {}, r.theme || r), a = {}, i = typeof e == "function" ? e(n) : e, o = GRt(i)(n);
    for (var s in o) {
      var l = o[s], c = typeof l == "function" ? l(n) : l;
      if (s === "variant") {
        var u = t(q2(n, c))(n);
        a = ST({}, a, {}, u);
        continue;
      }
      if (c && typeof c == "object") {
        a[s] = t(c)(n);
        continue;
      }
      var f = q2(LRt, s, s), h = q2(jRt, f), p = q2(n, h, q2(n, f, {})), g = q2(zRt, f, q2), y = g(p, c, c);
      if (b4e[f]) for (var b = b4e[f], w = 0; w < b.length; w++) a[b[w]] = y;
      else a[f] = y;
    }
    return a;
  };
}, HRt = WRt, Rz = function(t) {
  var e, r = t.scale, n = t.prop, a = n === void 0 ? "variant" : n, i = t.variants, o = i === void 0 ? {} : i, s = t.key, l;
  Object.keys(o).length ? l = function(f, h, p) {
    return HRt(Dh(h, f, null))(p.theme);
  } : l = function(f, h) {
    return Dh(h, f, null);
  }, l.scale = r || s, l.defaults = o;
  var c = (e = {}, e[a] = l, e), u = UI(c);
  return u;
}, vKe = Rz({ key: "buttons" }), yKe = Rz({ key: "textStyles", prop: "textStyle" }), bKe = Rz({ key: "colorStyles", prop: "colors" }), URt = yf.width, VRt = yf.height, qRt = yf.minWidth, KRt = yf.minHeight, ZRt = yf.maxWidth, JRt = yf.maxHeight, YRt = yf.size, T2e = yf.verticalAlign, E2e = yf.display, I2e = yf.overflow, XRt = yf.overflowX, QRt = yf.overflowY, eOt = MRt.opacity, tOt = q5.fontSize, rOt = q5.fontFamily, nOt = q5.fontWeight, aOt = q5.lineHeight, iOt = q5.textAlign, oOt = q5.fontStyle, sOt = q5.letterSpacing, lOt = b0.alignItems, cOt = b0.alignContent, uOt = b0.justifyItems, dOt = b0.justifyContent, fOt = b0.flexWrap, hOt = b0.flexDirection, pOt = b0.flex, mOt = b0.flexGrow, gOt = b0.flexShrink, vOt = b0.flexBasis, yOt = b0.justifySelf, bOt = b0.alignSelf, xOt = b0.order, COt = bf.gridGap, wOt = bf.gridColumnGap, SOt = bf.gridRowGap, _Ot = bf.gridColumn, kOt = bf.gridRow, AOt = bf.gridAutoFlow, TOt = bf.gridAutoColumns, EOt = bf.gridAutoRows, IOt = bf.gridTemplateColumns, MOt = bf.gridTemplateRows, POt = bf.gridTemplateAreas, ROt = bf.gridArea, OOt = sg.borderWidth, BOt = sg.borderStyle, NOt = sg.borderColor, $Ot = sg.borderTop, DOt = sg.borderRight, LOt = sg.borderBottom, jOt = sg.borderLeft, FOt = sg.borderRadius, zOt = Pz.backgroundImage, GOt = Pz.backgroundSize, WOt = Pz.backgroundPosition, HOt = Pz.backgroundRepeat, UOt = VI.zIndex, VOt = VI.top, qOt = VI.right, KOt = VI.bottom, ZOt = VI.left, JOt = function(t) {
  var e = t.prop, r = t.cssProperty, n = t.alias, a = t.key, i = t.transformValue, o = t.scale, s = t.properties, l = {};
  l[e] = lL({ properties: s, property: r || e, scale: a, defaultScale: o, transform: i }), n && (l[n] = l[e]);
  var c = UI(l);
  return c;
}, YOt = x8(qI, C8, k2e, Az, Tz, Iz, Mz, w8, Ez, A2e, vKe, yKe, bKe), KI = YOt.propNames, ZI = function(t) {
  var e = new RegExp("^(" + t.join("|") + ")$");
  return CRt(function(r) {
    return ARt(r) && !e.test(r);
  });
};
ZI(KI);
var K5 = xz(_2e()), xKe = K5.CacheProvider, M2e = K5.css, fb = K5.Global, P2e = K5.ThemeContext, cL = K5.ThemeProvider, CKe = oRt.default, Ey = K5.keyframes, ds = sRt.default, wKe = K5.withTheme;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const XOt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CacheProvider: xKe,
  EmotionCSS: M2e,
  StylingGlobals: fb,
  ThemeContext: P2e,
  ThemeProvider: cL,
  alignContent: cOt,
  alignItems: lOt,
  alignSelf: bOt,
  background: Mz,
  backgroundImage: zOt,
  backgroundPosition: WOt,
  backgroundRepeat: HOt,
  backgroundSize: GOt,
  border: Iz,
  borderBottom: LOt,
  borderColor: NOt,
  borderLeft: jOt,
  borderRadius: FOt,
  borderRight: DOt,
  borderStyle: BOt,
  borderTop: $Ot,
  borderWidth: OOt,
  borders: sg,
  bottom: KOt,
  boxShadow: wT,
  buttonStyle: vKe,
  color: k2e,
  colorStyle: bKe,
  compose: x8,
  createCache: CKe,
  createParser: UI,
  createShouldForwardProp: ZI,
  createStyleFunction: lL,
  css: us,
  display: E2e,
  flex: pOt,
  flexBasis: vOt,
  flexDirection: hOt,
  flexGrow: mOt,
  flexShrink: gOt,
  flexWrap: fOt,
  flexbox: Tz,
  fontFamily: rOt,
  fontSize: tOt,
  fontStyle: oOt,
  fontWeight: nOt,
  get: Dh,
  grid: Ez,
  gridArea: ROt,
  gridAutoColumns: TOt,
  gridAutoFlow: AOt,
  gridAutoRows: EOt,
  gridColumn: _Ot,
  gridColumnGap: wOt,
  gridGap: COt,
  gridRow: kOt,
  gridRowGap: SOt,
  gridTemplateAreas: POt,
  gridTemplateColumns: IOt,
  gridTemplateRows: MOt,
  height: VRt,
  justifyContent: dOt,
  justifyItems: uOt,
  justifySelf: yOt,
  keyframes: Ey,
  layout: Az,
  left: ZOt,
  letterSpacing: sOt,
  lineHeight: aOt,
  margin: mKe,
  maxHeight: JRt,
  maxWidth: ZRt,
  minHeight: KRt,
  minWidth: qRt,
  opacity: eOt,
  order: xOt,
  overflow: I2e,
  overflowX: XRt,
  overflowY: QRt,
  padding: gKe,
  position: w8,
  props: KI,
  right: qOt,
  shadow: A2e,
  size: YRt,
  space: qI,
  style: JOt,
  styled: ds,
  system: zu,
  textAlign: iOt,
  textShadow: wT,
  textStyle: yKe,
  themeGet: Yce,
  top: VOt,
  typography: C8,
  variant: Rz,
  verticalAlign: T2e,
  width: URt,
  withTheme: wKe,
  zIndex: UOt
}, Symbol.toStringTag, { value: "Module" }));
var QOt = ["background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "backgroundAttachment"], eBt = ["borderRadius", "borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"], tBt = ["borderWidth", "borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"], rBt = ["borderColor", "borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"], nBt = ["borderStyle", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle"], aBt = [...eBt, ...tBt, ...rBt, ...nBt, "border", "borderTop", "borderRight", "borderBottom", "borderLeft", "borderX", "borderY"], iBt = ["alignContent", "alignItems", "alignSelf", "flex", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "justifyContent", "justifyItems", "justifySelf", "order"], oBt = ["gridColumn", "gridRow", "gridAutoFlow", "gridAutoColumns", "gridAutoRows", "gridTemplateColumns", "gridTemplateRows", "gridTemplateAreas", "gridArea"], R2e = ["overflow", "overflowX", "overflowY"], sBt = [...R2e, "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "size", "display", "verticalAlign"], lBt = ["position", "left", "right", "top", "bottom", "zIndex"], O2e = ["boxShadow", "textShadow"], cBt = ["margin", "m", "marginTop", "mt", "marginRight", "mr", "marginBottom", "mb", "marginLeft", "ml", "marginX", "mx", "marginY", "my"], uBt = ["padding", "p", "paddingTop", "pt", "paddingRight", "pr", "paddingBottom", "pb", "paddingLeft", "pl", "paddingX", "px", "paddingY", "py"], dBt = ["columnGap", "rowGap"], B2e = [...cBt, ...uBt, ...dBt], N2e = ["fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "textAlign", "color", "textDecoration", "textOverflow", "textTransform", "whiteSpace", "wordBreak", "wordWrap", "overflowWrap"], fBt = Object.create, SKe = Object.defineProperty, hBt = Object.getOwnPropertyDescriptor, _Ke = Object.getOwnPropertyNames, pBt = Object.getPrototypeOf, mBt = Object.prototype.hasOwnProperty, gBt = (t, e) => function() {
  return e || (0, t[_Ke(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, vBt = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of _Ke(e)) !mBt.call(t, a) && a !== r && SKe(t, a, { get: () => e[a], enumerable: !(n = hBt(e, a)) || n.enumerable });
  return t;
}, yBt = (t, e, r) => (r = t != null ? fBt(pBt(t)) : {}, vBt(!t || !t.__esModule ? SKe(r, "default", { value: t, enumerable: !0 }) : r, t)), bBt = gBt({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), kKe = { color: { property: "color", scale: "textColors" }, backgroundColor: { property: "backgroundColor", scale: "backgroundColors" }, borderColor: { property: "borderColor", scale: "borderColors" }, borderBottomColor: { property: "borderBottomColor", scale: "borderColors" }, borderLeftColor: { property: "borderLeftColor", scale: "borderColors" }, borderRightColor: { property: "borderRightColor", scale: "borderColors" }, borderTopColor: { property: "borderTopColor", scale: "borderColors" }, content: !0, cursor: !0, appearance: !0, transition: !0, transitionDelay: !0, transform: !0, animation: !0, transformOrigin: !0, visibility: !0, userSelect: !0, pointerEvents: !0, boxSizing: !0, resize: !0, listStyleType: !0, listStylePosition: !0, listStyleImage: !0, objectFit: !0, objectPosition: !0, outline: !0, float: !0, willChange: !0, clip: !0, backgroundAttachment: !0, textAlign: !0, textTransform: !0, textDecoration: !0, textOverflow: !0, whiteSpace: !0, wordBreak: !0, wordWrap: !0, overflowWrap: !0, opacity: !0, borderCollapse: !0, borderSpacing: !0, tableLayout: !0, fontVariantNumeric: !0, inset: !0, columnGap: { property: "columnGap", scale: "space" }, rowGap: { property: "rowGap", scale: "space" }, "-moz-appearance": !0 }, uL = { _hover: "&:hover", _active: "&:active, &[data-active=true]", _focus: "&:focus", _focus_hover: "&:focus:hover", _focus_placeholder: "&:focus::placeholder", _visited: "&:visited", _even: "&:nth-of-type(even)", _odd: "&:nth-of-type(odd)", _disabled: "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover", _disabled_focus: "&:disabled:focus,&[aria-disabled=true]:focus", _checked: "&:checked, &[aria-checked=true]", _checked_hover: "&:checked:hover, &[aria-checked=true]:hover", _mixed: "&:indeterminate, &[aria-checked=mixed]", _selected: "&[aria-selected=true]", _selected_hover: "&[aria-selected=true]:hover", _selected_focus: "&[aria-selected=true]:focus", _selected_focusVisible: "&[aria-selected=true]:focus-visible", _invalid: "&:invalid, &[aria-invalid=true]", _pressed: "&[aria-pressed=true]", _pressed_focus: "&[aria-pressed=true]:focus", _pressed_hover: "&[aria-pressed=true]:hover", _pressed_active: "&[aria-pressed=true]:active, &[aria-pressed=true][data-active=true]", _pressed_disabled: "&[aria-pressed=true]:disabled, &[aria-pressed=true][aria-disabled=true]", _readOnly: "&[aria-readonly=true], &[readonly]", _first: "&:first-of-type", _last: "&:last-of-type", _expanded: "&[aria-expanded=true]", _grabbed: "&[aria-grabbed=true]", _notFirst: "&:not(:first-of-type)", _notLast: "&:not(:last-of-type)", _groupHover: "[role=group]:hover &", _before: "&:before", _after: "&:after", _selected_after: "&[aria-selected=true]:after", _focus_selected_after: "&[aria-selected=true]:focus:after", _selected_hover_after: "&[aria-selected=true]:hover:after", _focus_selected_hover_after: "&[aria-selected=true]:focus:hover:after", _disabled_focus_after: "&:disabled:focus:after, &[aria-disabled=true]:focus:after", _focusWithin: "&:focus-within", _focusVisible: "&:focus-visible", _placeholder: "&::placeholder", __moz_focus_inner: "&::-moz-focus-inner", __webkit_datetime_edit: "&::-webkit-datetime-edit", __webkit_calendar_picker_indicator_hover: "&::-webkit-calendar-picker-indicator:hover", __webkit_inner_spin_button: "&::-webkit-inner-spin-button", __webkit_outer_spin_button: "&::-webkit-outer-spin-button" }, xBt = yBt(bBt()), CBt = zu(kKe), wBt = (t) => {
  let e = Object.keys(t).filter((n) => n.startsWith("_"));
  if (e.length === 0) return {};
  let r = {};
  return e.forEach((n) => {
    uL[n] != null && (r[uL[n]] = t[n]);
  }), us(r);
}, Oz = (t) => {
  if (t != null && t.theme != null && t.theme.elements != null) {
    let e = t.theme.elements, r = t["data-paste-element"];
    if (e[r] != null) {
      let n = e[r], a = us(n)(t), { variants: i, ...o } = a, s = {};
      return t.variant != null && i != null && i[t.variant] != null && (s = i[t.variant]), () => (0, xBt.default)(o, s);
    }
  }
  return {};
}, SBt = "21.0.0", _Bt = KI.filter((t) => t !== "size"), kBt = ZI([..._Bt, ...Object.keys({ ...kKe, ...uL })]), ABt = ds("div", { shouldForwardProp: kBt })({ boxSizing: "border-box" }, x8(qI, Az, Tz, Ez, Mz, Iz, wT, w8, C8, CBt), wBt, Oz), ht = P.forwardRef(({ children: t, element: e = "BOX", ...r }, n) => P.createElement(ABt, { "data-paste-element": e, "data-paste-core-version": SBt, ref: n, ...r }, t));
ht.displayName = "Box";
var AKe = [...sBt, ...B2e, ...QOt, ...aBt, ...O2e, ...lBt, ...iBt, ...oBt, ...N2e, ...Object.keys(uL), "className", "style"], Xt = (t) => Object.keys(t).reduce((e, r) => (AKe.includes(r) || (e[r] = t[r]), e), {});
const TBt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BOX_PROPS_TO_BLOCK: AKe,
  Box: ht,
  getCustomElementStyles: Oz,
  safelySpreadBoxProps: Xt
}, Symbol.toStringTag, { value: "Module" })), TKe = /* @__PURE__ */ aa(TBt);
var x4e;
function EBt() {
  return x4e || (x4e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = TKe;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(LK)), LK;
}
var ar = /* @__PURE__ */ EBt(), YS = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var IBt = YS.exports, C4e;
function MBt() {
  return C4e || (C4e = 1, function(t, e) {
    (function() {
      var r, n = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, u = "__lodash_placeholder__", f = 1, h = 2, p = 4, g = 1, y = 2, b = 1, w = 2, _ = 4, C = 8, x = 16, S = 32, A = 64, I = 128, M = 256, B = 512, L = 30, N = "...", d = 800, m = 16, v = 1, k = 2, O = 3, G = 1 / 0, H = 9007199254740991, j = 17976931348623157e292, F = NaN, z = 4294967295, W = z - 1, U = z >>> 1, Z = [
        ["ary", I],
        ["bind", b],
        ["bindKey", w],
        ["curry", C],
        ["curryRight", x],
        ["flip", B],
        ["partial", S],
        ["partialRight", A],
        ["rearg", M]
      ], V = "[object Arguments]", Y = "[object Array]", ge = "[object AsyncFunction]", ce = "[object Boolean]", ee = "[object Date]", Se = "[object DOMException]", Ce = "[object Error]", we = "[object Function]", We = "[object GeneratorFunction]", Fe = "[object Map]", it = "[object Number]", gt = "[object Null]", Ze = "[object Object]", Ne = "[object Promise]", ze = "[object Proxy]", ct = "[object RegExp]", rt = "[object Set]", qe = "[object String]", nt = "[object Symbol]", Rt = "[object Undefined]", Ot = "[object WeakMap]", lt = "[object WeakSet]", mt = "[object ArrayBuffer]", jt = "[object DataView]", Jt = "[object Float32Array]", ne = "[object Float64Array]", re = "[object Int8Array]", ie = "[object Int16Array]", Ie = "[object Int32Array]", Ke = "[object Uint8Array]", Le = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", ft = "[object Uint32Array]", ot = /\b__p \+= '';/g, Ye = /\b(__p \+=) '' \+/g, Je = /(__e\(.*?\)|\b__t\)) \+\n'';/g, tt = /&(?:amp|lt|gt|quot|#39);/g, kt = /[&<>"']/g, Ft = RegExp(tt.source), bt = RegExp(kt.source), At = /<%-([\s\S]+?)%>/g, vt = /<%([\s\S]+?)%>/g, _t = /<%=([\s\S]+?)%>/g, yt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, xr = /^\w*$/, dr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Er = /[\\^$.*+?()[\]{}|]/g, gr = RegExp(Er.source), pr = /^\s+/, Xr = /\s/, Yr = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, at = /\{\n\/\* \[wrapped with (.+)\] \*/, Vt = /,? & /, er = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, fr = /[()=,{}\[\]\/\s]/, tn = /\\(\\)?/g, Kn = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Pr = /\w*$/, Pt = /^[-+]0x[0-9a-f]+$/i, or = /^0b[01]+$/i, Ht = /^\[object .+?Constructor\]$/, Mt = /^0o[0-7]+$/i, Qt = /^(?:0|[1-9]\d*)$/, pn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Kr = /($^)/, Da = /['\n\r\u2028\u2029\\]/g, La = "\\ud800-\\udfff", ji = "\\u0300-\\u036f", Zo = "\\ufe20-\\ufe2f", kr = "\\u20d0-\\u20ff", qi = ji + Zo + kr, vi = "\\u2700-\\u27bf", Ho = "a-z\\xdf-\\xf6\\xf8-\\xff", Ec = "\\xac\\xb1\\xd7\\xf7", Uu = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ic = "\\u2000-\\u206f", js = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Mc = "A-Z\\xc0-\\xd6\\xd8-\\xde", Vu = "\\ufe0e\\ufe0f", So = Ec + Uu + Ic + js, Kl = "['’]", Vi = "[" + La + "]", iu = "[" + So + "]", cc = "[" + qi + "]", Pc = "\\d+", Jo = "[" + vi + "]", Ka = "[" + Ho + "]", y2 = "[^" + La + So + Pc + vi + Ho + Mc + "]", qu = "\\ud83c[\\udffb-\\udfff]", dp = "(?:" + cc + "|" + qu + ")", Nd = "[^" + La + "]", Rc = "(?:\\ud83c[\\udde6-\\uddff]){2}", Oc = "[\\ud800-\\udbff][\\udc00-\\udfff]", Lo = "[" + Mc + "]", Rl = "\\u200d", hs = "(?:" + Ka + "|" + y2 + ")", Bc = "(?:" + Lo + "|" + y2 + ")", Nc = "(?:" + Kl + "(?:d|ll|m|re|s|t|ve))?", b2 = "(?:" + Kl + "(?:D|LL|M|RE|S|T|VE))?", st = dp + "?", dt = "[" + Vu + "]?", De = "(?:" + Rl + "(?:" + [Nd, Rc, Oc].join("|") + ")" + dt + st + ")*", Be = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Me = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ut = dt + st + De, Ve = "(?:" + [Jo, Rc, Oc].join("|") + ")" + ut, Kt = "(?:" + [Nd + cc + "?", cc, Rc, Oc, Vi].join("|") + ")", qt = RegExp(Kl, "g"), vr = RegExp(cc, "g"), _e = RegExp(qu + "(?=" + qu + ")|" + Kt + ut, "g"), Pe = RegExp([
        Lo + "?" + Ka + "+" + Nc + "(?=" + [iu, Lo, "$"].join("|") + ")",
        Bc + "+" + b2 + "(?=" + [iu, Lo + hs, "$"].join("|") + ")",
        Lo + "?" + hs + "+" + Nc,
        Lo + "+" + b2,
        Me,
        Be,
        Pc,
        Ve
      ].join("|"), "g"), Q = RegExp("[" + Rl + La + qi + Vu + "]"), te = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, J = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], fe = -1, le = {};
      le[Jt] = le[ne] = le[re] = le[ie] = le[Ie] = le[Ke] = le[Le] = le[Ge] = le[ft] = !0, le[V] = le[Y] = le[mt] = le[ce] = le[jt] = le[ee] = le[Ce] = le[we] = le[Fe] = le[it] = le[Ze] = le[ct] = le[rt] = le[qe] = le[Ot] = !1;
      var ke = {};
      ke[V] = ke[Y] = ke[mt] = ke[jt] = ke[ce] = ke[ee] = ke[Jt] = ke[ne] = ke[re] = ke[ie] = ke[Ie] = ke[Fe] = ke[it] = ke[Ze] = ke[ct] = ke[rt] = ke[qe] = ke[nt] = ke[Ke] = ke[Le] = ke[Ge] = ke[ft] = !0, ke[Ce] = ke[we] = ke[Ot] = !1;
      var X = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, he = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, $e = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Ct = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Bt = parseFloat, St = parseInt, ir = typeof wl == "object" && wl && wl.Object === Object && wl, Ir = typeof self == "object" && self && self.Object === Object && self, Sr = ir || Ir || Function("return this")(), Vr = e && !e.nodeType && e, ri = Vr && !0 && t && !t.nodeType && t, ni = ri && ri.exports === Vr, Yn = ni && ir.process, ja = function() {
        try {
          var $t = ri && ri.require && ri.require("util").types;
          return $t || Yn && Yn.binding && Yn.binding("util");
        } catch {
        }
      }(), Rr = ja && ja.isArrayBuffer, _o = ja && ja.isDate, Ee = ja && ja.isMap, je = ja && ja.isRegExp, be = ja && ja.isSet, oe = ja && ja.isTypedArray;
      function ae($t, lr, tr) {
        switch (tr.length) {
          case 0:
            return $t.call(lr);
          case 1:
            return $t.call(lr, tr[0]);
          case 2:
            return $t.call(lr, tr[0], tr[1]);
          case 3:
            return $t.call(lr, tr[0], tr[1], tr[2]);
        }
        return $t.apply(lr, tr);
      }
      function xe($t, lr, tr, vn) {
        for (var Fa = -1, co = $t == null ? 0 : $t.length; ++Fa < co; ) {
          var Qs = $t[Fa];
          lr(vn, Qs, tr(Qs), $t);
        }
        return vn;
      }
      function ue($t, lr) {
        for (var tr = -1, vn = $t == null ? 0 : $t.length; ++tr < vn && lr($t[tr], tr, $t) !== !1; )
          ;
        return $t;
      }
      function pe($t, lr) {
        for (var tr = $t == null ? 0 : $t.length; tr-- && lr($t[tr], tr, $t) !== !1; )
          ;
        return $t;
      }
      function ve($t, lr) {
        for (var tr = -1, vn = $t == null ? 0 : $t.length; ++tr < vn; )
          if (!lr($t[tr], tr, $t))
            return !1;
        return !0;
      }
      function ye($t, lr) {
        for (var tr = -1, vn = $t == null ? 0 : $t.length, Fa = 0, co = []; ++tr < vn; ) {
          var Qs = $t[tr];
          lr(Qs, tr, $t) && (co[Fa++] = Qs);
        }
        return co;
      }
      function Ae($t, lr) {
        var tr = $t == null ? 0 : $t.length;
        return !!tr && Xs($t, lr, 0) > -1;
      }
      function Qe($t, lr, tr) {
        for (var vn = -1, Fa = $t == null ? 0 : $t.length; ++vn < Fa; )
          if (tr(lr, $t[vn]))
            return !0;
        return !1;
      }
      function pt($t, lr) {
        for (var tr = -1, vn = $t == null ? 0 : $t.length, Fa = Array(vn); ++tr < vn; )
          Fa[tr] = lr($t[tr], tr, $t);
        return Fa;
      }
      function Tt($t, lr) {
        for (var tr = -1, vn = lr.length, Fa = $t.length; ++tr < vn; )
          $t[Fa + tr] = lr[tr];
        return $t;
      }
      function zt($t, lr, tr, vn) {
        var Fa = -1, co = $t == null ? 0 : $t.length;
        for (vn && co && (tr = $t[++Fa]); ++Fa < co; )
          tr = lr(tr, $t[Fa], Fa, $t);
        return tr;
      }
      function mn($t, lr, tr, vn) {
        var Fa = $t == null ? 0 : $t.length;
        for (vn && Fa && (tr = $t[--Fa]); Fa--; )
          tr = lr(tr, $t[Fa], Fa, $t);
        return tr;
      }
      function Tn($t, lr) {
        for (var tr = -1, vn = $t == null ? 0 : $t.length; ++tr < vn; )
          if (lr($t[tr], tr, $t))
            return !0;
        return !1;
      }
      var Zn = jo("length");
      function ia($t) {
        return $t.split("");
      }
      function Fs($t) {
        return $t.match(er) || [];
      }
      function Ki($t, lr, tr) {
        var vn;
        return tr($t, function(Fa, co, Qs) {
          if (lr(Fa, co, Qs))
            return vn = co, !1;
        }), vn;
      }
      function Wn($t, lr, tr, vn) {
        for (var Fa = $t.length, co = tr + (vn ? 1 : -1); vn ? co-- : ++co < Fa; )
          if (lr($t[co], co, $t))
            return co;
        return -1;
      }
      function Xs($t, lr, tr) {
        return lr === lr ? lU($t, lr, tr) : Wn($t, Mn, tr);
      }
      function Ef($t, lr, tr, vn) {
        for (var Fa = tr - 1, co = $t.length; ++Fa < co; )
          if (vn($t[Fa], lr))
            return Fa;
        return -1;
      }
      function Mn($t) {
        return $t !== $t;
      }
      function Ku($t, lr) {
        var tr = $t == null ? 0 : $t.length;
        return tr ? k6($t, lr) / tr : F;
      }
      function jo($t) {
        return function(lr) {
          return lr == null ? r : lr[$t];
        };
      }
      function fp($t) {
        return function(lr) {
          return $t == null ? r : $t[lr];
        };
      }
      function IP($t, lr, tr, vn, Fa) {
        return Fa($t, function(co, Qs, Ro) {
          tr = vn ? (vn = !1, co) : lr(tr, co, Qs, Ro);
        }), tr;
      }
      function If($t, lr) {
        var tr = $t.length;
        for ($t.sort(lr); tr--; )
          $t[tr] = $t[tr].value;
        return $t;
      }
      function k6($t, lr) {
        for (var tr, vn = -1, Fa = $t.length; ++vn < Fa; ) {
          var co = lr($t[vn]);
          co !== r && (tr = tr === r ? co : tr + co);
        }
        return tr;
      }
      function hC($t, lr) {
        for (var tr = -1, vn = Array($t); ++tr < $t; )
          vn[tr] = lr(tr);
        return vn;
      }
      function s3($t, lr) {
        return pt(lr, function(tr) {
          return [tr, $t[tr]];
        });
      }
      function Zu($t) {
        return $t && $t.slice(0, RP($t) + 1).replace(pr, "");
      }
      function Ol($t) {
        return function(lr) {
          return $t(lr);
        };
      }
      function _g($t, lr) {
        return pt(lr, function(tr) {
          return $t[tr];
        });
      }
      function l3($t, lr) {
        return $t.has(lr);
      }
      function kg($t, lr) {
        for (var tr = -1, vn = $t.length; ++tr < vn && Xs(lr, $t[tr], 0) > -1; )
          ;
        return tr;
      }
      function MP($t, lr) {
        for (var tr = $t.length; tr-- && Xs(lr, $t[tr], 0) > -1; )
          ;
        return tr;
      }
      function c3($t, lr) {
        for (var tr = $t.length, vn = 0; tr--; )
          $t[tr] === lr && ++vn;
        return vn;
      }
      var Ag = fp(X), pC = fp(he);
      function mC($t) {
        return "\\" + Ct[$t];
      }
      function gC($t, lr) {
        return $t == null ? r : $t[lr];
      }
      function x2($t) {
        return Q.test($t);
      }
      function vC($t) {
        return te.test($t);
      }
      function yC($t) {
        for (var lr, tr = []; !(lr = $t.next()).done; )
          tr.push(lr.value);
        return tr;
      }
      function u3($t) {
        var lr = -1, tr = Array($t.size);
        return $t.forEach(function(vn, Fa) {
          tr[++lr] = [Fa, vn];
        }), tr;
      }
      function A6($t, lr) {
        return function(tr) {
          return $t(lr(tr));
        };
      }
      function T0($t, lr) {
        for (var tr = -1, vn = $t.length, Fa = 0, co = []; ++tr < vn; ) {
          var Qs = $t[tr];
          (Qs === lr || Qs === u) && ($t[tr] = u, co[Fa++] = tr);
        }
        return co;
      }
      function T6($t) {
        var lr = -1, tr = Array($t.size);
        return $t.forEach(function(vn) {
          tr[++lr] = vn;
        }), tr;
      }
      function sU($t) {
        var lr = -1, tr = Array($t.size);
        return $t.forEach(function(vn) {
          tr[++lr] = [vn, vn];
        }), tr;
      }
      function lU($t, lr, tr) {
        for (var vn = tr - 1, Fa = $t.length; ++vn < Fa; )
          if ($t[vn] === lr)
            return vn;
        return -1;
      }
      function PP($t, lr, tr) {
        for (var vn = tr + 1; vn--; )
          if ($t[vn] === lr)
            return vn;
        return vn;
      }
      function hp($t) {
        return x2($t) ? uU($t) : Zn($t);
      }
      function $d($t) {
        return x2($t) ? OP($t) : ia($t);
      }
      function RP($t) {
        for (var lr = $t.length; lr-- && Xr.test($t.charAt(lr)); )
          ;
        return lr;
      }
      var cU = fp($e);
      function uU($t) {
        for (var lr = _e.lastIndex = 0; _e.test($t); )
          ++lr;
        return lr;
      }
      function OP($t) {
        return $t.match(_e) || [];
      }
      function dU($t) {
        return $t.match(Pe) || [];
      }
      var fU = function $t(lr) {
        lr = lr == null ? Sr : Tg.defaults(Sr.Object(), lr, Tg.pick(Sr, J));
        var tr = lr.Array, vn = lr.Date, Fa = lr.Error, co = lr.Function, Qs = lr.Math, Ro = lr.Object, bC = lr.RegExp, hU = lr.String, Ju = lr.TypeError, d3 = tr.prototype, pU = co.prototype, Eg = Ro.prototype, E6 = lr["__core-js_shared__"], I6 = pU.toString, bo = Eg.hasOwnProperty, mU = 0, f3 = function() {
          var T = /[^.]+$/.exec(E6 && E6.keys && E6.keys.IE_PROTO || "");
          return T ? "Symbol(src)_1." + T : "";
        }(), M6 = Eg.toString, P6 = I6.call(Ro), gU = Sr._, vU = bC(
          "^" + I6.call(bo).replace(Er, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), R6 = ni ? lr.Buffer : r, Mf = lr.Symbol, h3 = lr.Uint8Array, xC = R6 ? R6.allocUnsafe : r, O6 = A6(Ro.getPrototypeOf, Ro), BP = Ro.create, NP = Eg.propertyIsEnumerable, B6 = d3.splice, CC = Mf ? Mf.isConcatSpreadable : r, Ig = Mf ? Mf.iterator : r, C2 = Mf ? Mf.toStringTag : r, Mg = function() {
          try {
            var T = P2(Ro, "defineProperty");
            return T({}, "", {}), T;
          } catch {
          }
        }(), yU = lr.clearTimeout !== Sr.clearTimeout && lr.clearTimeout, $P = vn && vn.now !== Sr.Date.now && vn.now, N6 = lr.setTimeout !== Sr.setTimeout && lr.setTimeout, p3 = Qs.ceil, $6 = Qs.floor, D6 = Ro.getOwnPropertySymbols, DP = R6 ? R6.isBuffer : r, L6 = lr.isFinite, bU = d3.join, LP = A6(Ro.keys, Ro), Ms = Qs.max, hl = Qs.min, Pg = vn.now, jP = lr.parseInt, wC = Qs.random, xU = d3.reverse, j6 = P2(lr, "DataView"), Rg = P2(lr, "Map"), F6 = P2(lr, "Promise"), pp = P2(lr, "Set"), m3 = P2(lr, "WeakMap"), g3 = P2(Ro, "create"), z6 = m3 && new m3(), mp = {}, CU = Ld(j6), wU = Ld(Rg), SU = Ld(F6), _U = Ld(pp), SC = Ld(m3), G6 = Mf ? Mf.prototype : r, v3 = G6 ? G6.valueOf : r, FP = G6 ? G6.toString : r;
        function He(T) {
          if (Cs(T) && !za(T) && !(T instanceof $i)) {
            if (T instanceof Oi)
              return T;
            if (bo.call(T, "__wrapped__"))
              return AR(T);
          }
          return new Oi(T);
        }
        var Og = /* @__PURE__ */ function() {
          function T() {
          }
          return function($) {
            if (!ms($))
              return {};
            if (BP)
              return BP($);
            T.prototype = $;
            var q = new T();
            return T.prototype = r, q;
          };
        }();
        function ko() {
        }
        function Oi(T, $) {
          this.__wrapped__ = T, this.__actions__ = [], this.__chain__ = !!$, this.__index__ = 0, this.__values__ = r;
        }
        He.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: At,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: vt,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: _t,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: He
          }
        }, He.prototype = ko.prototype, He.prototype.constructor = He, Oi.prototype = Og(ko.prototype), Oi.prototype.constructor = Oi;
        function $i(T) {
          this.__wrapped__ = T, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = z, this.__views__ = [];
        }
        function kU() {
          var T = new $i(this.__wrapped__);
          return T.__actions__ = Dc(this.__actions__), T.__dir__ = this.__dir__, T.__filtered__ = this.__filtered__, T.__iteratees__ = Dc(this.__iteratees__), T.__takeCount__ = this.__takeCount__, T.__views__ = Dc(this.__views__), T;
        }
        function AU() {
          if (this.__filtered__) {
            var T = new $i(this);
            T.__dir__ = -1, T.__filtered__ = !0;
          } else
            T = this.clone(), T.__dir__ *= -1;
          return T;
        }
        function TU() {
          var T = this.__wrapped__.value(), $ = this.__dir__, q = za(T), de = $ < 0, Oe = q ? T.length : 0, Xe = E3(0, Oe, this.__views__), xt = Xe.start, Et = Xe.end, Wt = Et - xt, yr = de ? Et : xt - 1, mr = this.__iteratees__, br = mr.length, Zr = 0, Pn = hl(Wt, this.__takeCount__);
          if (!q || !de && Oe == Wt && Pn == Wt)
            return t4(T, this.__actions__);
          var ta = [];
          e:
            for (; Wt-- && Zr < Pn; ) {
              yr += $;
              for (var ii = -1, ra = T[yr]; ++ii < br; ) {
                var Bi = mr[ii], Li = Bi.iteratee, Os = Bi.type, Vn = Li(ra);
                if (Os == k)
                  ra = Vn;
                else if (!Vn) {
                  if (Os == v)
                    continue e;
                  break e;
                }
              }
              ta[Zr++] = ra;
            }
          return ta;
        }
        $i.prototype = Og(ko.prototype), $i.prototype.constructor = $i;
        function gp(T) {
          var $ = -1, q = T == null ? 0 : T.length;
          for (this.clear(); ++$ < q; ) {
            var de = T[$];
            this.set(de[0], de[1]);
          }
        }
        function EU() {
          this.__data__ = g3 ? g3(null) : {}, this.size = 0;
        }
        function zP(T) {
          var $ = this.has(T) && delete this.__data__[T];
          return this.size -= $ ? 1 : 0, $;
        }
        function IU(T) {
          var $ = this.__data__;
          if (g3) {
            var q = $[T];
            return q === l ? r : q;
          }
          return bo.call($, T) ? $[T] : r;
        }
        function Bl(T) {
          var $ = this.__data__;
          return g3 ? $[T] !== r : bo.call($, T);
        }
        function _C(T, $) {
          var q = this.__data__;
          return this.size += this.has(T) ? 0 : 1, q[T] = g3 && $ === r ? l : $, this;
        }
        gp.prototype.clear = EU, gp.prototype.delete = zP, gp.prototype.get = IU, gp.prototype.has = Bl, gp.prototype.set = _C;
        function uc(T) {
          var $ = -1, q = T == null ? 0 : T.length;
          for (this.clear(); ++$ < q; ) {
            var de = T[$];
            this.set(de[0], de[1]);
          }
        }
        function GP() {
          this.__data__ = [], this.size = 0;
        }
        function kC(T) {
          var $ = this.__data__, q = vp($, T);
          if (q < 0)
            return !1;
          var de = $.length - 1;
          return q == de ? $.pop() : B6.call($, q, 1), --this.size, !0;
        }
        function Yu(T) {
          var $ = this.__data__, q = vp($, T);
          return q < 0 ? r : $[q][1];
        }
        function WP(T) {
          return vp(this.__data__, T) > -1;
        }
        function HP(T, $) {
          var q = this.__data__, de = vp(q, T);
          return de < 0 ? (++this.size, q.push([T, $])) : q[de][1] = $, this;
        }
        uc.prototype.clear = GP, uc.prototype.delete = kC, uc.prototype.get = Yu, uc.prototype.has = WP, uc.prototype.set = HP;
        function E0(T) {
          var $ = -1, q = T == null ? 0 : T.length;
          for (this.clear(); ++$ < q; ) {
            var de = T[$];
            this.set(de[0], de[1]);
          }
        }
        function UP() {
          this.size = 0, this.__data__ = {
            hash: new gp(),
            map: new (Rg || uc)(),
            string: new gp()
          };
        }
        function VP(T) {
          var $ = s4(this, T).delete(T);
          return this.size -= $ ? 1 : 0, $;
        }
        function qP(T) {
          return s4(this, T).get(T);
        }
        function ou(T) {
          return s4(this, T).has(T);
        }
        function MU(T, $) {
          var q = s4(this, T), de = q.size;
          return q.set(T, $), this.size += q.size == de ? 0 : 1, this;
        }
        E0.prototype.clear = UP, E0.prototype.delete = VP, E0.prototype.get = qP, E0.prototype.has = ou, E0.prototype.set = MU;
        function pl(T) {
          var $ = -1, q = T == null ? 0 : T.length;
          for (this.__data__ = new E0(); ++$ < q; )
            this.add(T[$]);
        }
        function PU(T) {
          return this.__data__.set(T, l), this;
        }
        function KP(T) {
          return this.__data__.has(T);
        }
        pl.prototype.add = pl.prototype.push = PU, pl.prototype.has = KP;
        function ml(T) {
          var $ = this.__data__ = new uc(T);
          this.size = $.size;
        }
        function W6() {
          this.__data__ = new uc(), this.size = 0;
        }
        function AC(T) {
          var $ = this.__data__, q = $.delete(T);
          return this.size = $.size, q;
        }
        function Yo(T) {
          return this.__data__.get(T);
        }
        function w2(T) {
          return this.__data__.has(T);
        }
        function TC(T, $) {
          var q = this.__data__;
          if (q instanceof uc) {
            var de = q.__data__;
            if (!Rg || de.length < a - 1)
              return de.push([T, $]), this.size = ++q.size, this;
            q = this.__data__ = new E0(de);
          }
          return q.set(T, $), this.size = q.size, this;
        }
        ml.prototype.clear = W6, ml.prototype.delete = AC, ml.prototype.get = Yo, ml.prototype.has = w2, ml.prototype.set = TC;
        function ZP(T, $) {
          var q = za(T), de = !q && Ip(T), Oe = !q && !de && td(T), Xe = !q && !de && !Oe && Pp(T), xt = q || de || Oe || Xe, Et = xt ? hC(T.length, hU) : [], Wt = Et.length;
          for (var yr in T)
            ($ || bo.call(T, yr)) && !(xt && // Safari 9 has enumerable `arguments.length` in strict mode.
            (yr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            Oe && (yr == "offset" || yr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            Xe && (yr == "buffer" || yr == "byteLength" || yr == "byteOffset") || // Skip index properties.
            zs(yr, Wt))) && Et.push(yr);
          return Et;
        }
        function H6(T) {
          var $ = T.length;
          return $ ? T[$g(0, $ - 1)] : r;
        }
        function RU(T, $) {
          return f4(Dc(T), Pf($, 0, T.length));
        }
        function OU(T) {
          return f4(Dc(T));
        }
        function EC(T, $, q) {
          (q !== r && !jd(T[$], q) || q === r && !($ in T)) && I0(T, $, q);
        }
        function Bg(T, $, q) {
          var de = T[$];
          (!(bo.call(T, $) && jd(de, q)) || q === r && !($ in T)) && I0(T, $, q);
        }
        function vp(T, $) {
          for (var q = T.length; q--; )
            if (jd(T[q][0], $))
              return q;
          return -1;
        }
        function Ng(T, $, q, de) {
          return Rf(T, function(Oe, Xe, xt) {
            $(de, Oe, q(Oe), xt);
          }), de;
        }
        function JP(T, $) {
          return T && R0($, vl($), T);
        }
        function YP(T, $) {
          return T && R0($, Xl($), T);
        }
        function I0(T, $, q) {
          $ == "__proto__" && Mg ? Mg(T, $, {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          }) : T[$] = q;
        }
        function y3(T, $) {
          for (var q = -1, de = $.length, Oe = tr(de), Xe = T == null; ++q < de; )
            Oe[q] = Xe ? r : Tw(T, $[q]);
          return Oe;
        }
        function Pf(T, $, q) {
          return T === T && (q !== r && (T = T <= q ? T : q), $ !== r && (T = T >= $ ? T : $)), T;
        }
        function su(T, $, q, de, Oe, Xe) {
          var xt, Et = $ & f, Wt = $ & h, yr = $ & p;
          if (q && (xt = Oe ? q(T, de, Oe, Xe) : q(T)), xt !== r)
            return xt;
          if (!ms(T))
            return T;
          var mr = za(T);
          if (mr) {
            if (xt = gR(T), !Et)
              return Dc(T, xt);
          } else {
            var br = gl(T), Zr = br == we || br == We;
            if (td(T))
              return HC(T, Et);
            if (br == Ze || br == V || Zr && !Oe) {
              if (xt = Wt || Zr ? {} : vR(T), !Et)
                return Wt ? GU(T, YP(xt, T)) : zU(T, JP(xt, T));
            } else {
              if (!ke[br])
                return Oe ? T : {};
              xt = Df(T, br, Et);
            }
          }
          Xe || (Xe = new ml());
          var Pn = Xe.get(T);
          if (Pn)
            return Pn;
          Xe.set(T, xt), vO(T) ? T.forEach(function(ra) {
            xt.add(su(ra, $, q, ra, T, Xe));
          }) : pO(T) && T.forEach(function(ra, Bi) {
            xt.set(Bi, su(ra, $, q, Bi, T, Xe));
          });
          var ta = yr ? Wt ? XC : YC : Wt ? Xl : vl, ii = mr ? r : ta(T);
          return ue(ii || T, function(ra, Bi) {
            ii && (Bi = ra, ra = T[Bi]), Bg(xt, Bi, su(ra, $, q, Bi, T, Xe));
          }), xt;
        }
        function BU(T) {
          var $ = vl(T);
          return function(q) {
            return U6(q, T, $);
          };
        }
        function U6(T, $, q) {
          var de = q.length;
          if (T == null)
            return !de;
          for (T = Ro(T); de--; ) {
            var Oe = q[de], Xe = $[Oe], xt = T[Oe];
            if (xt === r && !(Oe in T) || !Xe(xt))
              return !1;
          }
          return !0;
        }
        function V6(T, $, q) {
          if (typeof T != "function")
            throw new Ju(o);
          return el(function() {
            T.apply(r, q);
          }, $);
        }
        function b3(T, $, q, de) {
          var Oe = -1, Xe = Ae, xt = !0, Et = T.length, Wt = [], yr = $.length;
          if (!Et)
            return Wt;
          q && ($ = pt($, Ol(q))), de ? (Xe = Qe, xt = !1) : $.length >= a && (Xe = l3, xt = !1, $ = new pl($));
          e:
            for (; ++Oe < Et; ) {
              var mr = T[Oe], br = q == null ? mr : q(mr);
              if (mr = de || mr !== 0 ? mr : 0, xt && br === br) {
                for (var Zr = yr; Zr--; )
                  if ($[Zr] === br)
                    continue e;
                Wt.push(mr);
              } else Xe($, br, de) || Wt.push(mr);
            }
          return Wt;
        }
        var Rf = Lg(M0), $c = Lg(RC, !0);
        function IC(T, $) {
          var q = !0;
          return Rf(T, function(de, Oe, Xe) {
            return q = !!$(de, Oe, Xe), q;
          }), q;
        }
        function S2(T, $, q) {
          for (var de = -1, Oe = T.length; ++de < Oe; ) {
            var Xe = T[de], xt = $(Xe);
            if (xt != null && (Et === r ? xt === xt && !pu(xt) : q(xt, Et)))
              var Et = xt, Wt = Xe;
          }
          return Wt;
        }
        function XP(T, $, q, de) {
          var Oe = T.length;
          for (q = Xa(q), q < 0 && (q = -q > Oe ? 0 : Oe + q), de = de === r || de > Oe ? Oe : Xa(de), de < 0 && (de += Oe), de = q > de ? 0 : bO(de); q < de; )
            T[q++] = $;
          return T;
        }
        function MC(T, $) {
          var q = [];
          return Rf(T, function(de, Oe, Xe) {
            $(de, Oe, Xe) && q.push(de);
          }), q;
        }
        function Nl(T, $, q, de, Oe) {
          var Xe = -1, xt = T.length;
          for (q || (q = Ap), Oe || (Oe = []); ++Xe < xt; ) {
            var Et = T[Xe];
            $ > 0 && q(Et) ? $ > 1 ? Nl(Et, $ - 1, q, de, Oe) : Tt(Oe, Et) : de || (Oe[Oe.length] = Et);
          }
          return Oe;
        }
        var PC = KC(), QP = KC(!0);
        function M0(T, $) {
          return T && PC(T, $, vl);
        }
        function RC(T, $) {
          return T && QP(T, $, vl);
        }
        function Of(T, $) {
          return ye($, function(q) {
            return Gf(T[q]);
          });
        }
        function yp(T, $) {
          $ = Fo($, T);
          for (var q = 0, de = $.length; T != null && q < de; )
            T = T[B0($[q++])];
          return q && q == de ? T : r;
        }
        function eR(T, $, q) {
          var de = $(T);
          return za(T) ? de : Tt(de, q(T));
        }
        function $l(T) {
          return T == null ? T === r ? Rt : gt : C2 && C2 in Ro(T) ? hR(T) : wR(T);
        }
        function q6(T, $) {
          return T > $;
        }
        function _2(T, $) {
          return T != null && bo.call(T, $);
        }
        function K6(T, $) {
          return T != null && $ in Ro(T);
        }
        function NU(T, $, q) {
          return T >= hl($, q) && T < Ms($, q);
        }
        function OC(T, $, q) {
          for (var de = q ? Qe : Ae, Oe = T[0].length, Xe = T.length, xt = Xe, Et = tr(Xe), Wt = 1 / 0, yr = []; xt--; ) {
            var mr = T[xt];
            xt && $ && (mr = pt(mr, Ol($))), Wt = hl(mr.length, Wt), Et[xt] = !q && ($ || Oe >= 120 && mr.length >= 120) ? new pl(xt && mr) : r;
          }
          mr = T[0];
          var br = -1, Zr = Et[0];
          e:
            for (; ++br < Oe && yr.length < Wt; ) {
              var Pn = mr[br], ta = $ ? $(Pn) : Pn;
              if (Pn = q || Pn !== 0 ? Pn : 0, !(Zr ? l3(Zr, ta) : de(yr, ta, q))) {
                for (xt = Xe; --xt; ) {
                  var ii = Et[xt];
                  if (!(ii ? l3(ii, ta) : de(T[xt], ta, q)))
                    continue e;
                }
                Zr && Zr.push(ta), yr.push(Pn);
              }
            }
          return yr;
        }
        function $U(T, $, q, de) {
          return M0(T, function(Oe, Xe, xt) {
            $(de, q(Oe), Xe, xt);
          }), de;
        }
        function P0(T, $, q) {
          $ = Fo($, T), T = u4(T, $);
          var de = T == null ? T : T[B0(du($))];
          return de == null ? r : ae(de, T, q);
        }
        function Xu(T) {
          return Cs(T) && $l(T) == V;
        }
        function tR(T) {
          return Cs(T) && $l(T) == mt;
        }
        function DU(T) {
          return Cs(T) && $l(T) == ee;
        }
        function x3(T, $, q, de, Oe) {
          return T === $ ? !0 : T == null || $ == null || !Cs(T) && !Cs($) ? T !== T && $ !== $ : LU(T, $, q, de, x3, Oe);
        }
        function LU(T, $, q, de, Oe, Xe) {
          var xt = za(T), Et = za($), Wt = xt ? Y : gl(T), yr = Et ? Y : gl($);
          Wt = Wt == V ? Ze : Wt, yr = yr == V ? Ze : yr;
          var mr = Wt == Ze, br = yr == Ze, Zr = Wt == yr;
          if (Zr && td(T)) {
            if (!td($))
              return !1;
            xt = !0, mr = !1;
          }
          if (Zr && !mr)
            return Xe || (Xe = new ml()), xt || Pp(T) ? fR(T, $, q, de, Oe, Xe) : VU(T, $, Wt, q, de, Oe, Xe);
          if (!(q & g)) {
            var Pn = mr && bo.call(T, "__wrapped__"), ta = br && bo.call($, "__wrapped__");
            if (Pn || ta) {
              var ii = Pn ? T.value() : T, ra = ta ? $.value() : $;
              return Xe || (Xe = new ml()), Oe(ii, ra, q, de, Xe);
            }
          }
          return Zr ? (Xe || (Xe = new ml()), qU(T, $, q, de, Oe, Xe)) : !1;
        }
        function jU(T) {
          return Cs(T) && gl(T) == Fe;
        }
        function BC(T, $, q, de) {
          var Oe = q.length, Xe = Oe, xt = !de;
          if (T == null)
            return !Xe;
          for (T = Ro(T); Oe--; ) {
            var Et = q[Oe];
            if (xt && Et[2] ? Et[1] !== T[Et[0]] : !(Et[0] in T))
              return !1;
          }
          for (; ++Oe < Xe; ) {
            Et = q[Oe];
            var Wt = Et[0], yr = T[Wt], mr = Et[1];
            if (xt && Et[2]) {
              if (yr === r && !(Wt in T))
                return !1;
            } else {
              var br = new ml();
              if (de)
                var Zr = de(yr, mr, Wt, T, $, br);
              if (!(Zr === r ? x3(mr, yr, g | y, de, br) : Zr))
                return !1;
            }
          }
          return !0;
        }
        function bp(T) {
          if (!ms(T) || R2(T))
            return !1;
          var $ = Gf(T) ? vU : Ht;
          return $.test(Ld(T));
        }
        function Dt(T) {
          return Cs(T) && $l(T) == ct;
        }
        function cr(T) {
          return Cs(T) && gl(T) == rt;
        }
        function rr(T) {
          return Cs(T) && I4(T.length) && !!le[$l(T)];
        }
        function gn(T) {
          return typeof T == "function" ? T : T == null ? Fc : typeof T == "object" ? za(T) ? rR(T[0], T[1]) : Z6(T) : NO(T);
        }
        function Sa(T) {
          if (!I3(T))
            return LP(T);
          var $ = [];
          for (var q in Ro(T))
            bo.call(T, q) && q != "constructor" && $.push(q);
          return $;
        }
        function uo(T) {
          if (!ms(T))
            return rw(T);
          var $ = I3(T), q = [];
          for (var de in T)
            de == "constructor" && ($ || !bo.call(T, de)) || q.push(de);
          return q;
        }
        function Ps(T, $) {
          return T < $;
        }
        function Ao(T, $) {
          var q = -1, de = jc(T) ? tr(T.length) : [];
          return Rf(T, function(Oe, Xe, xt) {
            de[++q] = $(Oe, Xe, xt);
          }), de;
        }
        function Z6(T) {
          var $ = QC(T);
          return $.length == 1 && $[0][2] ? xR($[0][0], $[0][1]) : function(q) {
            return q === T || BC(q, T, $);
          };
        }
        function rR(T, $) {
          return c4(T) && M3($) ? xR(B0(T), $) : function(q) {
            var de = Tw(q, T);
            return de === r && de === $ ? Ew(q, T) : x3($, de, g | y);
          };
        }
        function dc(T, $, q, de, Oe) {
          T !== $ && PC($, function(Xe, xt) {
            if (Oe || (Oe = new ml()), ms(Xe))
              J6(T, $, xt, q, dc, de, Oe);
            else {
              var Et = de ? de(Lf(T, xt), Xe, xt + "", T, $, Oe) : r;
              Et === r && (Et = Xe), EC(T, xt, Et);
            }
          }, Xl);
        }
        function J6(T, $, q, de, Oe, Xe, xt) {
          var Et = Lf(T, q), Wt = Lf($, q), yr = xt.get(Wt);
          if (yr) {
            EC(T, q, yr);
            return;
          }
          var mr = Xe ? Xe(Et, Wt, q + "", T, $, xt) : r, br = mr === r;
          if (br) {
            var Zr = za(Wt), Pn = !Zr && td(Wt), ta = !Zr && !Pn && Pp(Wt);
            mr = Wt, Zr || Pn || ta ? za(Et) ? mr = Et : ps(Et) ? mr = Dc(Et) : Pn ? (br = !1, mr = HC(Wt, !0)) : ta ? (br = !1, mr = Sp(Wt, !0)) : mr = [] : Hg(Wt) || Ip(Wt) ? (mr = Et, Ip(Et) ? mr = Aw(Et) : (!ms(Et) || Gf(Et)) && (mr = vR(Wt))) : br = !1;
          }
          br && (xt.set(Wt, mr), Oe(mr, Wt, de, Xe, xt), xt.delete(Wt)), EC(T, q, mr);
        }
        function nR(T, $) {
          var q = T.length;
          if (q)
            return $ += $ < 0 ? q : 0, zs($, q) ? T[$] : r;
        }
        function xp(T, $, q) {
          $.length ? $ = pt($, function(Xe) {
            return za(Xe) ? function(xt) {
              return yp(xt, Xe.length === 1 ? Xe[0] : Xe);
            } : Xe;
          }) : $ = [Fc];
          var de = -1;
          $ = pt($, Ol(Xn()));
          var Oe = Ao(T, function(Xe, xt, Et) {
            var Wt = pt($, function(yr) {
              return yr(Xe);
            });
            return { criteria: Wt, index: ++de, value: Xe };
          });
          return If(Oe, function(Xe, xt) {
            return A3(Xe, xt, q);
          });
        }
        function Y6(T, $) {
          return C3(T, $, function(q, de) {
            return Ew(T, de);
          });
        }
        function C3(T, $, q) {
          for (var de = -1, Oe = $.length, Xe = {}; ++de < Oe; ) {
            var xt = $[de], Et = yp(T, xt);
            q(Et, xt) && A2(Xe, Fo(xt, T), Et);
          }
          return Xe;
        }
        function xo(T) {
          return function($) {
            return yp($, T);
          };
        }
        function NC(T, $, q, de) {
          var Oe = de ? Ef : Xs, Xe = -1, xt = $.length, Et = T;
          for (T === $ && ($ = Dc($)), q && (Et = pt(T, Ol(q))); ++Xe < xt; )
            for (var Wt = 0, yr = $[Xe], mr = q ? q(yr) : yr; (Wt = Oe(Et, mr, Wt, de)) > -1; )
              Et !== T && B6.call(Et, Wt, 1), B6.call(T, Wt, 1);
          return T;
        }
        function $C(T, $) {
          for (var q = T ? $.length : 0, de = q - 1; q--; ) {
            var Oe = $[q];
            if (q == de || Oe !== Xe) {
              var Xe = Oe;
              zs(Oe) ? B6.call(T, Oe, 1) : jC(T, Oe);
            }
          }
          return T;
        }
        function $g(T, $) {
          return T + $6(wC() * ($ - T + 1));
        }
        function FU(T, $, q, de) {
          for (var Oe = -1, Xe = Ms(p3(($ - T) / (q || 1)), 0), xt = tr(Xe); Xe--; )
            xt[de ? Xe : ++Oe] = T, T += q;
          return xt;
        }
        function DC(T, $) {
          var q = "";
          if (!T || $ < 1 || $ > H)
            return q;
          do
            $ % 2 && (q += T), $ = $6($ / 2), $ && (T += T);
          while ($);
          return q;
        }
        function yi(T, $) {
          return P3(Dd(T, $, Fc), T + "");
        }
        function X6(T) {
          return H6(Vg(T));
        }
        function k2(T, $) {
          var q = Vg(T);
          return f4(q, Pf($, 0, q.length));
        }
        function A2(T, $, q, de) {
          if (!ms(T))
            return T;
          $ = Fo($, T);
          for (var Oe = -1, Xe = $.length, xt = Xe - 1, Et = T; Et != null && ++Oe < Xe; ) {
            var Wt = B0($[Oe]), yr = q;
            if (Wt === "__proto__" || Wt === "constructor" || Wt === "prototype")
              return T;
            if (Oe != xt) {
              var mr = Et[Wt];
              yr = de ? de(mr, Wt, Et) : r, yr === r && (yr = ms(mr) ? mr : zs($[Oe + 1]) ? [] : {});
            }
            Bg(Et, Wt, yr), Et = Et[Wt];
          }
          return T;
        }
        var LC = z6 ? function(T, $) {
          return z6.set(T, $), T;
        } : Fc, Q6 = Mg ? function(T, $) {
          return Mg(T, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Pw($),
            writable: !0
          });
        } : Fc;
        function aR(T) {
          return f4(Vg(T));
        }
        function lu(T, $, q) {
          var de = -1, Oe = T.length;
          $ < 0 && ($ = -$ > Oe ? 0 : Oe + $), q = q > Oe ? Oe : q, q < 0 && (q += Oe), Oe = $ > q ? 0 : q - $ >>> 0, $ >>>= 0;
          for (var Xe = tr(Oe); ++de < Oe; )
            Xe[de] = T[de + $];
          return Xe;
        }
        function e4(T, $) {
          var q;
          return Rf(T, function(de, Oe, Xe) {
            return q = $(de, Oe, Xe), !q;
          }), !!q;
        }
        function w3(T, $, q) {
          var de = 0, Oe = T == null ? de : T.length;
          if (typeof $ == "number" && $ === $ && Oe <= U) {
            for (; de < Oe; ) {
              var Xe = de + Oe >>> 1, xt = T[Xe];
              xt !== null && !pu(xt) && (q ? xt <= $ : xt < $) ? de = Xe + 1 : Oe = Xe;
            }
            return Oe;
          }
          return Cp(T, $, Fc, q);
        }
        function Cp(T, $, q, de) {
          var Oe = 0, Xe = T == null ? 0 : T.length;
          if (Xe === 0)
            return 0;
          $ = q($);
          for (var xt = $ !== $, Et = $ === null, Wt = pu($), yr = $ === r; Oe < Xe; ) {
            var mr = $6((Oe + Xe) / 2), br = q(T[mr]), Zr = br !== r, Pn = br === null, ta = br === br, ii = pu(br);
            if (xt)
              var ra = de || ta;
            else yr ? ra = ta && (de || Zr) : Et ? ra = ta && Zr && (de || !Pn) : Wt ? ra = ta && Zr && !Pn && (de || !ii) : Pn || ii ? ra = !1 : ra = de ? br <= $ : br < $;
            ra ? Oe = mr + 1 : Xe = mr;
          }
          return hl(Xe, W);
        }
        function T2(T, $) {
          for (var q = -1, de = T.length, Oe = 0, Xe = []; ++q < de; ) {
            var xt = T[q], Et = $ ? $(xt) : xt;
            if (!q || !jd(Et, Wt)) {
              var Wt = Et;
              Xe[Oe++] = xt === 0 ? 0 : xt;
            }
          }
          return Xe;
        }
        function S3(T) {
          return typeof T == "number" ? T : pu(T) ? F : +T;
        }
        function cu(T) {
          if (typeof T == "string")
            return T;
          if (za(T))
            return pt(T, cu) + "";
          if (pu(T))
            return FP ? FP.call(T) : "";
          var $ = T + "";
          return $ == "0" && 1 / T == -1 / 0 ? "-0" : $;
        }
        function E2(T, $, q) {
          var de = -1, Oe = Ae, Xe = T.length, xt = !0, Et = [], Wt = Et;
          if (q)
            xt = !1, Oe = Qe;
          else if (Xe >= a) {
            var yr = $ ? null : HU(T);
            if (yr)
              return T6(yr);
            xt = !1, Oe = l3, Wt = new pl();
          } else
            Wt = $ ? [] : Et;
          e:
            for (; ++de < Xe; ) {
              var mr = T[de], br = $ ? $(mr) : mr;
              if (mr = q || mr !== 0 ? mr : 0, xt && br === br) {
                for (var Zr = Wt.length; Zr--; )
                  if (Wt[Zr] === br)
                    continue e;
                $ && Wt.push(br), Et.push(mr);
              } else Oe(Wt, br, q) || (Wt !== Et && Wt.push(br), Et.push(mr));
            }
          return Et;
        }
        function jC(T, $) {
          return $ = Fo($, T), T = u4(T, $), T == null || delete T[B0(du($))];
        }
        function _3(T, $, q, de) {
          return A2(T, $, q(yp(T, $)), de);
        }
        function wp(T, $, q, de) {
          for (var Oe = T.length, Xe = de ? Oe : -1; (de ? Xe-- : ++Xe < Oe) && $(T[Xe], Xe, T); )
            ;
          return q ? lu(T, de ? 0 : Xe, de ? Xe + 1 : Oe) : lu(T, de ? Xe + 1 : 0, de ? Oe : Xe);
        }
        function t4(T, $) {
          var q = T;
          return q instanceof $i && (q = q.value()), zt($, function(de, Oe) {
            return Oe.func.apply(Oe.thisArg, Tt([de], Oe.args));
          }, q);
        }
        function FC(T, $, q) {
          var de = T.length;
          if (de < 2)
            return de ? E2(T[0]) : [];
          for (var Oe = -1, Xe = tr(de); ++Oe < de; )
            for (var xt = T[Oe], Et = -1; ++Et < de; )
              Et != Oe && (Xe[Oe] = b3(Xe[Oe] || xt, T[Et], $, q));
          return E2(Nl(Xe, 1), $, q);
        }
        function zC(T, $, q) {
          for (var de = -1, Oe = T.length, Xe = $.length, xt = {}; ++de < Oe; ) {
            var Et = de < Xe ? $[de] : r;
            q(xt, T[de], Et);
          }
          return xt;
        }
        function GC(T) {
          return ps(T) ? T : [];
        }
        function WC(T) {
          return typeof T == "function" ? T : Fc;
        }
        function Fo(T, $) {
          return za(T) ? T : c4(T, $) ? [T] : h4(mo(T));
        }
        var Zl = yi;
        function I2(T, $, q) {
          var de = T.length;
          return q = q === r ? de : q, !$ && q >= de ? T : lu(T, $, q);
        }
        var iR = yU || function(T) {
          return Sr.clearTimeout(T);
        };
        function HC(T, $) {
          if ($)
            return T.slice();
          var q = T.length, de = xC ? xC(q) : new T.constructor(q);
          return T.copy(de), de;
        }
        function UC(T) {
          var $ = new T.constructor(T.byteLength);
          return new h3($).set(new h3(T)), $;
        }
        function VC(T, $) {
          var q = $ ? UC(T.buffer) : T.buffer;
          return new T.constructor(q, T.byteOffset, T.byteLength);
        }
        function k3(T) {
          var $ = new T.constructor(T.source, Pr.exec(T));
          return $.lastIndex = T.lastIndex, $;
        }
        function qC(T) {
          return v3 ? Ro(v3.call(T)) : {};
        }
        function Sp(T, $) {
          var q = $ ? UC(T.buffer) : T.buffer;
          return new T.constructor(q, T.byteOffset, T.length);
        }
        function Dg(T, $) {
          if (T !== $) {
            var q = T !== r, de = T === null, Oe = T === T, Xe = pu(T), xt = $ !== r, Et = $ === null, Wt = $ === $, yr = pu($);
            if (!Et && !yr && !Xe && T > $ || Xe && xt && Wt && !Et && !yr || de && xt && Wt || !q && Wt || !Oe)
              return 1;
            if (!de && !Xe && !yr && T < $ || yr && q && Oe && !de && !Xe || Et && q && Oe || !xt && Oe || !Wt)
              return -1;
          }
          return 0;
        }
        function A3(T, $, q) {
          for (var de = -1, Oe = T.criteria, Xe = $.criteria, xt = Oe.length, Et = q.length; ++de < xt; ) {
            var Wt = Dg(Oe[de], Xe[de]);
            if (Wt) {
              if (de >= Et)
                return Wt;
              var yr = q[de];
              return Wt * (yr == "desc" ? -1 : 1);
            }
          }
          return T.index - $.index;
        }
        function T3(T, $, q, de) {
          for (var Oe = -1, Xe = T.length, xt = q.length, Et = -1, Wt = $.length, yr = Ms(Xe - xt, 0), mr = tr(Wt + yr), br = !de; ++Et < Wt; )
            mr[Et] = $[Et];
          for (; ++Oe < xt; )
            (br || Oe < Xe) && (mr[q[Oe]] = T[Oe]);
          for (; yr--; )
            mr[Et++] = T[Oe++];
          return mr;
        }
        function _p(T, $, q, de) {
          for (var Oe = -1, Xe = T.length, xt = -1, Et = q.length, Wt = -1, yr = $.length, mr = Ms(Xe - Et, 0), br = tr(mr + yr), Zr = !de; ++Oe < mr; )
            br[Oe] = T[Oe];
          for (var Pn = Oe; ++Wt < yr; )
            br[Pn + Wt] = $[Wt];
          for (; ++xt < Et; )
            (Zr || Oe < Xe) && (br[Pn + q[xt]] = T[Oe++]);
          return br;
        }
        function Dc(T, $) {
          var q = -1, de = T.length;
          for ($ || ($ = tr(de)); ++q < de; )
            $[q] = T[q];
          return $;
        }
        function R0(T, $, q, de) {
          var Oe = !q;
          q || (q = {});
          for (var Xe = -1, xt = $.length; ++Xe < xt; ) {
            var Et = $[Xe], Wt = de ? de(q[Et], T[Et], Et, q, T) : r;
            Wt === r && (Wt = T[Et]), Oe ? I0(q, Et, Wt) : Bg(q, Et, Wt);
          }
          return q;
        }
        function zU(T, $) {
          return R0(T, ew(T), $);
        }
        function GU(T, $) {
          return R0(T, pR(T), $);
        }
        function r4(T, $) {
          return function(q, de) {
            var Oe = za(q) ? xe : Ng, Xe = $ ? $() : {};
            return Oe(q, T, Xn(de, 2), Xe);
          };
        }
        function Bf(T) {
          return yi(function($, q) {
            var de = -1, Oe = q.length, Xe = Oe > 1 ? q[Oe - 1] : r, xt = Oe > 2 ? q[2] : r;
            for (Xe = T.length > 3 && typeof Xe == "function" ? (Oe--, Xe) : r, xt && hc(q[0], q[1], xt) && (Xe = Oe < 3 ? r : Xe, Oe = 1), $ = Ro($); ++de < Oe; ) {
              var Et = q[de];
              Et && T($, Et, de, Xe);
            }
            return $;
          });
        }
        function Lg(T, $) {
          return function(q, de) {
            if (q == null)
              return q;
            if (!jc(q))
              return T(q, de);
            for (var Oe = q.length, Xe = $ ? Oe : -1, xt = Ro(q); ($ ? Xe-- : ++Xe < Oe) && de(xt[Xe], Xe, xt) !== !1; )
              ;
            return q;
          };
        }
        function KC(T) {
          return function($, q, de) {
            for (var Oe = -1, Xe = Ro($), xt = de($), Et = xt.length; Et--; ) {
              var Wt = xt[T ? Et : ++Oe];
              if (q(Xe[Wt], Wt, Xe) === !1)
                break;
            }
            return $;
          };
        }
        function Ue(T, $, q) {
          var de = $ & b, Oe = Jl(T);
          function Xe() {
            var xt = this && this !== Sr && this instanceof Xe ? Oe : T;
            return xt.apply(de ? q : this, arguments);
          }
          return Xe;
        }
        function kp(T) {
          return function($) {
            $ = mo($);
            var q = x2($) ? $d($) : r, de = q ? q[0] : $.charAt(0), Oe = q ? I2(q, 1).join("") : $.slice(1);
            return de[T]() + Oe;
          };
        }
        function Nf(T) {
          return function($) {
            return zt(Iw(TO($).replace(qt, "")), T, "");
          };
        }
        function Jl(T) {
          return function() {
            var $ = arguments;
            switch ($.length) {
              case 0:
                return new T();
              case 1:
                return new T($[0]);
              case 2:
                return new T($[0], $[1]);
              case 3:
                return new T($[0], $[1], $[2]);
              case 4:
                return new T($[0], $[1], $[2], $[3]);
              case 5:
                return new T($[0], $[1], $[2], $[3], $[4]);
              case 6:
                return new T($[0], $[1], $[2], $[3], $[4], $[5]);
              case 7:
                return new T($[0], $[1], $[2], $[3], $[4], $[5], $[6]);
            }
            var q = Og(T.prototype), de = T.apply(q, $);
            return ms(de) ? de : q;
          };
        }
        function Di(T, $, q) {
          var de = Jl(T);
          function Oe() {
            for (var Xe = arguments.length, xt = tr(Xe), Et = Xe, Wt = jg(Oe); Et--; )
              xt[Et] = arguments[Et];
            var yr = Xe < 3 && xt[0] !== Wt && xt[Xe - 1] !== Wt ? [] : T0(xt, Wt);
            if (Xe -= yr.length, Xe < q)
              return cR(
                T,
                $,
                n4,
                Oe.placeholder,
                r,
                xt,
                yr,
                r,
                r,
                q - Xe
              );
            var mr = this && this !== Sr && this instanceof Oe ? de : T;
            return ae(mr, this, xt);
          }
          return Oe;
        }
        function oR(T) {
          return function($, q, de) {
            var Oe = Ro($);
            if (!jc($)) {
              var Xe = Xn(q, 3);
              $ = vl($), q = function(Et) {
                return Xe(Oe[Et], Et, Oe);
              };
            }
            var xt = T($, q, de);
            return xt > -1 ? Oe[Xe ? $[xt] : xt] : r;
          };
        }
        function sR(T) {
          return fc(function($) {
            var q = $.length, de = q, Oe = Oi.prototype.thru;
            for (T && $.reverse(); de--; ) {
              var Xe = $[de];
              if (typeof Xe != "function")
                throw new Ju(o);
              if (Oe && !xt && o4(Xe) == "wrapper")
                var xt = new Oi([], !0);
            }
            for (de = xt ? de : q; ++de < q; ) {
              Xe = $[de];
              var Et = o4(Xe), Wt = Et == "wrapper" ? uu(Xe) : r;
              Wt && Tp(Wt[0]) && Wt[1] == (I | C | S | M) && !Wt[4].length && Wt[9] == 1 ? xt = xt[o4(Wt[0])].apply(xt, Wt[3]) : xt = Xe.length == 1 && Tp(Xe) ? xt[Et]() : xt.thru(Xe);
            }
            return function() {
              var yr = arguments, mr = yr[0];
              if (xt && yr.length == 1 && za(mr))
                return xt.plant(mr).value();
              for (var br = 0, Zr = q ? $[br].apply(this, yr) : mr; ++br < q; )
                Zr = $[br].call(this, Zr);
              return Zr;
            };
          });
        }
        function n4(T, $, q, de, Oe, Xe, xt, Et, Wt, yr) {
          var mr = $ & I, br = $ & b, Zr = $ & w, Pn = $ & (C | x), ta = $ & B, ii = Zr ? r : Jl(T);
          function ra() {
            for (var Bi = arguments.length, Li = tr(Bi), Os = Bi; Os--; )
              Li[Os] = arguments[Os];
            if (Pn)
              var Vn = jg(ra), Gc = c3(Li, Vn);
            if (de && (Li = T3(Li, de, Oe, Pn)), Xe && (Li = _p(Li, Xe, xt, Pn)), Bi -= Gc, Pn && Bi < yr) {
              var Zi = T0(Li, Vn);
              return cR(
                T,
                $,
                n4,
                ra.placeholder,
                q,
                Li,
                Zi,
                Et,
                Wt,
                yr - Bi
              );
            }
            var ad = br ? q : this, Hf = Zr ? ad[T] : T;
            return Bi = Li.length, Et ? Li = d4(Li, Et) : ta && Bi > 1 && Li.reverse(), mr && Wt < Bi && (Li.length = Wt), this && this !== Sr && this instanceof ra && (Hf = ii || Jl(Hf)), Hf.apply(ad, Li);
          }
          return ra;
        }
        function M2(T, $) {
          return function(q, de) {
            return $U(q, T, $(de), {});
          };
        }
        function a4(T, $) {
          return function(q, de) {
            var Oe;
            if (q === r && de === r)
              return $;
            if (q !== r && (Oe = q), de !== r) {
              if (Oe === r)
                return de;
              typeof q == "string" || typeof de == "string" ? (q = cu(q), de = cu(de)) : (q = S3(q), de = S3(de)), Oe = T(q, de);
            }
            return Oe;
          };
        }
        function ZC(T) {
          return fc(function($) {
            return $ = pt($, Ol(Xn())), yi(function(q) {
              var de = this;
              return T($, function(Oe) {
                return ae(Oe, de, q);
              });
            });
          });
        }
        function i4(T, $) {
          $ = $ === r ? " " : cu($);
          var q = $.length;
          if (q < 2)
            return q ? DC($, T) : $;
          var de = DC($, p3(T / hp($)));
          return x2($) ? I2($d(de), 0, T).join("") : de.slice(0, T);
        }
        function WU(T, $, q, de) {
          var Oe = $ & b, Xe = Jl(T);
          function xt() {
            for (var Et = -1, Wt = arguments.length, yr = -1, mr = de.length, br = tr(mr + Wt), Zr = this && this !== Sr && this instanceof xt ? Xe : T; ++yr < mr; )
              br[yr] = de[yr];
            for (; Wt--; )
              br[yr++] = arguments[++Et];
            return ae(Zr, Oe ? q : this, br);
          }
          return xt;
        }
        function lR(T) {
          return function($, q, de) {
            return de && typeof de != "number" && hc($, q, de) && (q = de = r), $ = Gs($), q === r ? (q = $, $ = 0) : q = Gs(q), de = de === r ? $ < q ? 1 : -1 : Gs(de), FU($, q, de, T);
          };
        }
        function Qu(T) {
          return function($, q) {
            return typeof $ == "string" && typeof q == "string" || ($ = nd($), q = nd(q)), T($, q);
          };
        }
        function cR(T, $, q, de, Oe, Xe, xt, Et, Wt, yr) {
          var mr = $ & C, br = mr ? xt : r, Zr = mr ? r : xt, Pn = mr ? Xe : r, ta = mr ? r : Xe;
          $ |= mr ? S : A, $ &= ~(mr ? A : S), $ & _ || ($ &= -4);
          var ii = [
            T,
            $,
            Oe,
            Pn,
            br,
            ta,
            Zr,
            Et,
            Wt,
            yr
          ], ra = q.apply(r, ii);
          return Tp(T) && nw(ra, ii), ra.placeholder = de, SR(ra, T, $);
        }
        function JC(T) {
          var $ = Qs[T];
          return function(q, de) {
            if (q = nd(q), de = de == null ? 0 : hl(Xa(de), 292), de && L6(q)) {
              var Oe = (mo(q) + "e").split("e"), Xe = $(Oe[0] + "e" + (+Oe[1] + de));
              return Oe = (mo(Xe) + "e").split("e"), +(Oe[0] + "e" + (+Oe[1] - de));
            }
            return $(q);
          };
        }
        var HU = pp && 1 / T6(new pp([, -0]))[1] == G ? function(T) {
          return new pp(T);
        } : Nw;
        function uR(T) {
          return function($) {
            var q = gl($);
            return q == Fe ? u3($) : q == rt ? sU($) : s3($, T($));
          };
        }
        function $f(T, $, q, de, Oe, Xe, xt, Et) {
          var Wt = $ & w;
          if (!Wt && typeof T != "function")
            throw new Ju(o);
          var yr = de ? de.length : 0;
          if (yr || ($ &= -97, de = Oe = r), xt = xt === r ? xt : Ms(Xa(xt), 0), Et = Et === r ? Et : Xa(Et), yr -= Oe ? Oe.length : 0, $ & A) {
            var mr = de, br = Oe;
            de = Oe = r;
          }
          var Zr = Wt ? r : uu(T), Pn = [
            T,
            $,
            q,
            de,
            Oe,
            mr,
            br,
            Xe,
            xt,
            Et
          ];
          if (Zr && Dl(Pn, Zr), T = Pn[0], $ = Pn[1], q = Pn[2], de = Pn[3], Oe = Pn[4], Et = Pn[9] = Pn[9] === r ? Wt ? 0 : T.length : Ms(Pn[9] - yr, 0), !Et && $ & (C | x) && ($ &= -25), !$ || $ == b)
            var ta = Ue(T, $, q);
          else $ == C || $ == x ? ta = Di(T, $, Et) : ($ == S || $ == (b | S)) && !Oe.length ? ta = WU(T, $, q, de) : ta = n4.apply(r, Pn);
          var ii = Zr ? LC : nw;
          return SR(ii(ta, Pn), T, $);
        }
        function O0(T, $, q, de) {
          return T === r || jd(T, Eg[q]) && !bo.call(de, q) ? $ : T;
        }
        function dR(T, $, q, de, Oe, Xe) {
          return ms(T) && ms($) && (Xe.set($, T), dc(T, $, r, dR, Xe), Xe.delete($)), T;
        }
        function UU(T) {
          return Hg(T) ? r : T;
        }
        function fR(T, $, q, de, Oe, Xe) {
          var xt = q & g, Et = T.length, Wt = $.length;
          if (Et != Wt && !(xt && Wt > Et))
            return !1;
          var yr = Xe.get(T), mr = Xe.get($);
          if (yr && mr)
            return yr == $ && mr == T;
          var br = -1, Zr = !0, Pn = q & y ? new pl() : r;
          for (Xe.set(T, $), Xe.set($, T); ++br < Et; ) {
            var ta = T[br], ii = $[br];
            if (de)
              var ra = xt ? de(ii, ta, br, $, T, Xe) : de(ta, ii, br, T, $, Xe);
            if (ra !== r) {
              if (ra)
                continue;
              Zr = !1;
              break;
            }
            if (Pn) {
              if (!Tn($, function(Bi, Li) {
                if (!l3(Pn, Li) && (ta === Bi || Oe(ta, Bi, q, de, Xe)))
                  return Pn.push(Li);
              })) {
                Zr = !1;
                break;
              }
            } else if (!(ta === ii || Oe(ta, ii, q, de, Xe))) {
              Zr = !1;
              break;
            }
          }
          return Xe.delete(T), Xe.delete($), Zr;
        }
        function VU(T, $, q, de, Oe, Xe, xt) {
          switch (q) {
            case jt:
              if (T.byteLength != $.byteLength || T.byteOffset != $.byteOffset)
                return !1;
              T = T.buffer, $ = $.buffer;
            case mt:
              return !(T.byteLength != $.byteLength || !Xe(new h3(T), new h3($)));
            case ce:
            case ee:
            case it:
              return jd(+T, +$);
            case Ce:
              return T.name == $.name && T.message == $.message;
            case ct:
            case qe:
              return T == $ + "";
            case Fe:
              var Et = u3;
            case rt:
              var Wt = de & g;
              if (Et || (Et = T6), T.size != $.size && !Wt)
                return !1;
              var yr = xt.get(T);
              if (yr)
                return yr == $;
              de |= y, xt.set(T, $);
              var mr = fR(Et(T), Et($), de, Oe, Xe, xt);
              return xt.delete(T), mr;
            case nt:
              if (v3)
                return v3.call(T) == v3.call($);
          }
          return !1;
        }
        function qU(T, $, q, de, Oe, Xe) {
          var xt = q & g, Et = YC(T), Wt = Et.length, yr = YC($), mr = yr.length;
          if (Wt != mr && !xt)
            return !1;
          for (var br = Wt; br--; ) {
            var Zr = Et[br];
            if (!(xt ? Zr in $ : bo.call($, Zr)))
              return !1;
          }
          var Pn = Xe.get(T), ta = Xe.get($);
          if (Pn && ta)
            return Pn == $ && ta == T;
          var ii = !0;
          Xe.set(T, $), Xe.set($, T);
          for (var ra = xt; ++br < Wt; ) {
            Zr = Et[br];
            var Bi = T[Zr], Li = $[Zr];
            if (de)
              var Os = xt ? de(Li, Bi, Zr, $, T, Xe) : de(Bi, Li, Zr, T, $, Xe);
            if (!(Os === r ? Bi === Li || Oe(Bi, Li, q, de, Xe) : Os)) {
              ii = !1;
              break;
            }
            ra || (ra = Zr == "constructor");
          }
          if (ii && !ra) {
            var Vn = T.constructor, Gc = $.constructor;
            Vn != Gc && "constructor" in T && "constructor" in $ && !(typeof Vn == "function" && Vn instanceof Vn && typeof Gc == "function" && Gc instanceof Gc) && (ii = !1);
          }
          return Xe.delete(T), Xe.delete($), ii;
        }
        function fc(T) {
          return P3(Dd(T, r, ow), T + "");
        }
        function YC(T) {
          return eR(T, vl, ew);
        }
        function XC(T) {
          return eR(T, Xl, pR);
        }
        var uu = z6 ? function(T) {
          return z6.get(T);
        } : Nw;
        function o4(T) {
          for (var $ = T.name + "", q = mp[$], de = bo.call(mp, $) ? q.length : 0; de--; ) {
            var Oe = q[de], Xe = Oe.func;
            if (Xe == null || Xe == T)
              return Oe.name;
          }
          return $;
        }
        function jg(T) {
          var $ = bo.call(He, "placeholder") ? He : T;
          return $.placeholder;
        }
        function Xn() {
          var T = He.iteratee || Rw;
          return T = T === Rw ? gn : T, arguments.length ? T(arguments[0], arguments[1]) : T;
        }
        function s4(T, $) {
          var q = T.__data__;
          return yR($) ? q[typeof $ == "string" ? "string" : "hash"] : q.map;
        }
        function QC(T) {
          for (var $ = vl(T), q = $.length; q--; ) {
            var de = $[q], Oe = T[de];
            $[q] = [de, Oe, M3(Oe)];
          }
          return $;
        }
        function P2(T, $) {
          var q = gC(T, $);
          return bp(q) ? q : r;
        }
        function hR(T) {
          var $ = bo.call(T, C2), q = T[C2];
          try {
            T[C2] = r;
            var de = !0;
          } catch {
          }
          var Oe = M6.call(T);
          return de && ($ ? T[C2] = q : delete T[C2]), Oe;
        }
        var ew = D6 ? function(T) {
          return T == null ? [] : (T = Ro(T), ye(D6(T), function($) {
            return NP.call(T, $);
          }));
        } : $w, pR = D6 ? function(T) {
          for (var $ = []; T; )
            Tt($, ew(T)), T = O6(T);
          return $;
        } : $w, gl = $l;
        (j6 && gl(new j6(new ArrayBuffer(1))) != jt || Rg && gl(new Rg()) != Fe || F6 && gl(F6.resolve()) != Ne || pp && gl(new pp()) != rt || m3 && gl(new m3()) != Ot) && (gl = function(T) {
          var $ = $l(T), q = $ == Ze ? T.constructor : r, de = q ? Ld(q) : "";
          if (de)
            switch (de) {
              case CU:
                return jt;
              case wU:
                return Fe;
              case SU:
                return Ne;
              case _U:
                return rt;
              case SC:
                return Ot;
            }
          return $;
        });
        function E3(T, $, q) {
          for (var de = -1, Oe = q.length; ++de < Oe; ) {
            var Xe = q[de], xt = Xe.size;
            switch (Xe.type) {
              case "drop":
                T += xt;
                break;
              case "dropRight":
                $ -= xt;
                break;
              case "take":
                $ = hl($, T + xt);
                break;
              case "takeRight":
                T = Ms(T, $ - xt);
                break;
            }
          }
          return { start: T, end: $ };
        }
        function l4(T) {
          var $ = T.match(at);
          return $ ? $[1].split(Vt) : [];
        }
        function mR(T, $, q) {
          $ = Fo($, T);
          for (var de = -1, Oe = $.length, Xe = !1; ++de < Oe; ) {
            var xt = B0($[de]);
            if (!(Xe = T != null && q(T, xt)))
              break;
            T = T[xt];
          }
          return Xe || ++de != Oe ? Xe : (Oe = T == null ? 0 : T.length, !!Oe && I4(Oe) && zs(xt, Oe) && (za(T) || Ip(T)));
        }
        function gR(T) {
          var $ = T.length, q = new T.constructor($);
          return $ && typeof T[0] == "string" && bo.call(T, "index") && (q.index = T.index, q.input = T.input), q;
        }
        function vR(T) {
          return typeof T.constructor == "function" && !I3(T) ? Og(O6(T)) : {};
        }
        function Df(T, $, q) {
          var de = T.constructor;
          switch ($) {
            case mt:
              return UC(T);
            case ce:
            case ee:
              return new de(+T);
            case jt:
              return VC(T, q);
            case Jt:
            case ne:
            case re:
            case ie:
            case Ie:
            case Ke:
            case Le:
            case Ge:
            case ft:
              return Sp(T, q);
            case Fe:
              return new de();
            case it:
            case qe:
              return new de(T);
            case ct:
              return k3(T);
            case rt:
              return new de();
            case nt:
              return qC(T);
          }
        }
        function tw(T, $) {
          var q = $.length;
          if (!q)
            return T;
          var de = q - 1;
          return $[de] = (q > 1 ? "& " : "") + $[de], $ = $.join(q > 2 ? ", " : " "), T.replace(Yr, `{
/* [wrapped with ` + $ + `] */
`);
        }
        function Ap(T) {
          return za(T) || Ip(T) || !!(CC && T && T[CC]);
        }
        function zs(T, $) {
          var q = typeof T;
          return $ = $ ?? H, !!$ && (q == "number" || q != "symbol" && Qt.test(T)) && T > -1 && T % 1 == 0 && T < $;
        }
        function hc(T, $, q) {
          if (!ms(q))
            return !1;
          var de = typeof $;
          return (de == "number" ? jc(q) && zs($, q.length) : de == "string" && $ in q) ? jd(q[$], T) : !1;
        }
        function c4(T, $) {
          if (za(T))
            return !1;
          var q = typeof T;
          return q == "number" || q == "symbol" || q == "boolean" || T == null || pu(T) ? !0 : xr.test(T) || !yt.test(T) || $ != null && T in Ro($);
        }
        function yR(T) {
          var $ = typeof T;
          return $ == "string" || $ == "number" || $ == "symbol" || $ == "boolean" ? T !== "__proto__" : T === null;
        }
        function Tp(T) {
          var $ = o4(T), q = He[$];
          if (typeof q != "function" || !($ in $i.prototype))
            return !1;
          if (T === q)
            return !0;
          var de = uu(q);
          return !!de && T === de[0];
        }
        function R2(T) {
          return !!f3 && f3 in T;
        }
        var bR = E6 ? Gf : Dw;
        function I3(T) {
          var $ = T && T.constructor, q = typeof $ == "function" && $.prototype || Eg;
          return T === q;
        }
        function M3(T) {
          return T === T && !ms(T);
        }
        function xR(T, $) {
          return function(q) {
            return q == null ? !1 : q[T] === $ && ($ !== r || T in Ro(q));
          };
        }
        function CR(T) {
          var $ = k4(T, function(de) {
            return q.size === c && q.clear(), de;
          }), q = $.cache;
          return $;
        }
        function Dl(T, $) {
          var q = T[1], de = $[1], Oe = q | de, Xe = Oe < (b | w | I), xt = de == I && q == C || de == I && q == M && T[7].length <= $[8] || de == (I | M) && $[7].length <= $[8] && q == C;
          if (!(Xe || xt))
            return T;
          de & b && (T[2] = $[2], Oe |= q & b ? 0 : _);
          var Et = $[3];
          if (Et) {
            var Wt = T[3];
            T[3] = Wt ? T3(Wt, Et, $[4]) : Et, T[4] = Wt ? T0(T[3], u) : $[4];
          }
          return Et = $[5], Et && (Wt = T[5], T[5] = Wt ? _p(Wt, Et, $[6]) : Et, T[6] = Wt ? T0(T[5], u) : $[6]), Et = $[7], Et && (T[7] = Et), de & I && (T[8] = T[8] == null ? $[8] : hl(T[8], $[8])), T[9] == null && (T[9] = $[9]), T[0] = $[0], T[1] = Oe, T;
        }
        function rw(T) {
          var $ = [];
          if (T != null)
            for (var q in Ro(T))
              $.push(q);
          return $;
        }
        function wR(T) {
          return M6.call(T);
        }
        function Dd(T, $, q) {
          return $ = Ms($ === r ? T.length - 1 : $, 0), function() {
            for (var de = arguments, Oe = -1, Xe = Ms(de.length - $, 0), xt = tr(Xe); ++Oe < Xe; )
              xt[Oe] = de[$ + Oe];
            Oe = -1;
            for (var Et = tr($ + 1); ++Oe < $; )
              Et[Oe] = de[Oe];
            return Et[$] = q(xt), ae(T, this, Et);
          };
        }
        function u4(T, $) {
          return $.length < 2 ? T : yp(T, lu($, 0, -1));
        }
        function d4(T, $) {
          for (var q = T.length, de = hl($.length, q), Oe = Dc(T); de--; ) {
            var Xe = $[de];
            T[de] = zs(Xe, q) ? Oe[Xe] : r;
          }
          return T;
        }
        function Lf(T, $) {
          if (!($ === "constructor" && typeof T[$] == "function") && $ != "__proto__")
            return T[$];
        }
        var nw = _R(LC), el = N6 || function(T, $) {
          return Sr.setTimeout(T, $);
        }, P3 = _R(Q6);
        function SR(T, $, q) {
          var de = $ + "";
          return P3(T, tw(de, kR(l4(de), q)));
        }
        function _R(T) {
          var $ = 0, q = 0;
          return function() {
            var de = Pg(), Oe = m - (de - q);
            if (q = de, Oe > 0) {
              if (++$ >= d)
                return arguments[0];
            } else
              $ = 0;
            return T.apply(r, arguments);
          };
        }
        function f4(T, $) {
          var q = -1, de = T.length, Oe = de - 1;
          for ($ = $ === r ? de : $; ++q < $; ) {
            var Xe = $g(q, Oe), xt = T[Xe];
            T[Xe] = T[q], T[q] = xt;
          }
          return T.length = $, T;
        }
        var h4 = CR(function(T) {
          var $ = [];
          return T.charCodeAt(0) === 46 && $.push(""), T.replace(dr, function(q, de, Oe, Xe) {
            $.push(Oe ? Xe.replace(tn, "$1") : de || q);
          }), $;
        });
        function B0(T) {
          if (typeof T == "string" || pu(T))
            return T;
          var $ = T + "";
          return $ == "0" && 1 / T == -1 / 0 ? "-0" : $;
        }
        function Ld(T) {
          if (T != null) {
            try {
              return I6.call(T);
            } catch {
            }
            try {
              return T + "";
            } catch {
            }
          }
          return "";
        }
        function kR(T, $) {
          return ue(Z, function(q) {
            var de = "_." + q[0];
            $ & q[1] && !Ae(T, de) && T.push(de);
          }), T.sort();
        }
        function AR(T) {
          if (T instanceof $i)
            return T.clone();
          var $ = new Oi(T.__wrapped__, T.__chain__);
          return $.__actions__ = Dc(T.__actions__), $.__index__ = T.__index__, $.__values__ = T.__values__, $;
        }
        function KU(T, $, q) {
          (q ? hc(T, $, q) : $ === r) ? $ = 1 : $ = Ms(Xa($), 0);
          var de = T == null ? 0 : T.length;
          if (!de || $ < 1)
            return [];
          for (var Oe = 0, Xe = 0, xt = tr(p3(de / $)); Oe < de; )
            xt[Xe++] = lu(T, Oe, Oe += $);
          return xt;
        }
        function R3(T) {
          for (var $ = -1, q = T == null ? 0 : T.length, de = 0, Oe = []; ++$ < q; ) {
            var Xe = T[$];
            Xe && (Oe[de++] = Xe);
          }
          return Oe;
        }
        function ZU() {
          var T = arguments.length;
          if (!T)
            return [];
          for (var $ = tr(T - 1), q = arguments[0], de = T; de--; )
            $[de - 1] = arguments[de];
          return Tt(za(q) ? Dc(q) : [q], Nl($, 1));
        }
        var JU = yi(function(T, $) {
          return ps(T) ? b3(T, Nl($, 1, ps, !0)) : [];
        }), aw = yi(function(T, $) {
          var q = du($);
          return ps(q) && (q = r), ps(T) ? b3(T, Nl($, 1, ps, !0), Xn(q, 2)) : [];
        }), TR = yi(function(T, $) {
          var q = du($);
          return ps(q) && (q = r), ps(T) ? b3(T, Nl($, 1, ps, !0), r, q) : [];
        });
        function YU(T, $, q) {
          var de = T == null ? 0 : T.length;
          return de ? ($ = q || $ === r ? 1 : Xa($), lu(T, $ < 0 ? 0 : $, de)) : [];
        }
        function XU(T, $, q) {
          var de = T == null ? 0 : T.length;
          return de ? ($ = q || $ === r ? 1 : Xa($), $ = de - $, lu(T, 0, $ < 0 ? 0 : $)) : [];
        }
        function QU(T, $) {
          return T && T.length ? wp(T, Xn($, 3), !0, !0) : [];
        }
        function ER(T, $) {
          return T && T.length ? wp(T, Xn($, 3), !0) : [];
        }
        function iw(T, $, q, de) {
          var Oe = T == null ? 0 : T.length;
          return Oe ? (q && typeof q != "number" && hc(T, $, q) && (q = 0, de = Oe), XP(T, $, q, de)) : [];
        }
        function IR(T, $, q) {
          var de = T == null ? 0 : T.length;
          if (!de)
            return -1;
          var Oe = q == null ? 0 : Xa(q);
          return Oe < 0 && (Oe = Ms(de + Oe, 0)), Wn(T, Xn($, 3), Oe);
        }
        function p4(T, $, q) {
          var de = T == null ? 0 : T.length;
          if (!de)
            return -1;
          var Oe = de - 1;
          return q !== r && (Oe = Xa(q), Oe = q < 0 ? Ms(de + Oe, 0) : hl(Oe, de - 1)), Wn(T, Xn($, 3), Oe, !0);
        }
        function ow(T) {
          var $ = T == null ? 0 : T.length;
          return $ ? Nl(T, 1) : [];
        }
        function MR(T) {
          var $ = T == null ? 0 : T.length;
          return $ ? Nl(T, G) : [];
        }
        function PR(T, $) {
          var q = T == null ? 0 : T.length;
          return q ? ($ = $ === r ? 1 : Xa($), Nl(T, $)) : [];
        }
        function m4(T) {
          for (var $ = -1, q = T == null ? 0 : T.length, de = {}; ++$ < q; ) {
            var Oe = T[$];
            de[Oe[0]] = Oe[1];
          }
          return de;
        }
        function RR(T) {
          return T && T.length ? T[0] : r;
        }
        function OR(T, $, q) {
          var de = T == null ? 0 : T.length;
          if (!de)
            return -1;
          var Oe = q == null ? 0 : Xa(q);
          return Oe < 0 && (Oe = Ms(de + Oe, 0)), Xs(T, $, Oe);
        }
        function BR(T) {
          var $ = T == null ? 0 : T.length;
          return $ ? lu(T, 0, -1) : [];
        }
        var eV = yi(function(T) {
          var $ = pt(T, GC);
          return $.length && $[0] === T[0] ? OC($) : [];
        }), NR = yi(function(T) {
          var $ = du(T), q = pt(T, GC);
          return $ === du(q) ? $ = r : q.pop(), q.length && q[0] === T[0] ? OC(q, Xn($, 2)) : [];
        }), tV = yi(function(T) {
          var $ = du(T), q = pt(T, GC);
          return $ = typeof $ == "function" ? $ : r, $ && q.pop(), q.length && q[0] === T[0] ? OC(q, r, $) : [];
        });
        function sw(T, $) {
          return T == null ? "" : bU.call(T, $);
        }
        function du(T) {
          var $ = T == null ? 0 : T.length;
          return $ ? T[$ - 1] : r;
        }
        function lw(T, $, q) {
          var de = T == null ? 0 : T.length;
          if (!de)
            return -1;
          var Oe = de;
          return q !== r && (Oe = Xa(q), Oe = Oe < 0 ? Ms(de + Oe, 0) : hl(Oe, de - 1)), $ === $ ? PP(T, $, Oe) : Wn(T, Mn, Oe, !0);
        }
        function rV(T, $) {
          return T && T.length ? nR(T, Xa($)) : r;
        }
        var cw = yi(ai);
        function ai(T, $) {
          return T && T.length && $ && $.length ? NC(T, $) : T;
        }
        function nV(T, $, q) {
          return T && T.length && $ && $.length ? NC(T, $, Xn(q, 2)) : T;
        }
        function aV(T, $, q) {
          return T && T.length && $ && $.length ? NC(T, $, r, q) : T;
        }
        var O3 = fc(function(T, $) {
          var q = T == null ? 0 : T.length, de = y3(T, $);
          return $C(T, pt($, function(Oe) {
            return zs(Oe, q) ? +Oe : Oe;
          }).sort(Dg)), de;
        });
        function $R(T, $) {
          var q = [];
          if (!(T && T.length))
            return q;
          var de = -1, Oe = [], Xe = T.length;
          for ($ = Xn($, 3); ++de < Xe; ) {
            var xt = T[de];
            $(xt, de, T) && (q.push(xt), Oe.push(de));
          }
          return $C(T, Oe), q;
        }
        function uw(T) {
          return T == null ? T : xU.call(T);
        }
        function iV(T, $, q) {
          var de = T == null ? 0 : T.length;
          return de ? (q && typeof q != "number" && hc(T, $, q) ? ($ = 0, q = de) : ($ = $ == null ? 0 : Xa($), q = q === r ? de : Xa(q)), lu(T, $, q)) : [];
        }
        function ed(T, $) {
          return w3(T, $);
        }
        function oV(T, $, q) {
          return Cp(T, $, Xn(q, 2));
        }
        function g4(T, $) {
          var q = T == null ? 0 : T.length;
          if (q) {
            var de = w3(T, $);
            if (de < q && jd(T[de], $))
              return de;
          }
          return -1;
        }
        function dw(T, $) {
          return w3(T, $, !0);
        }
        function DR(T, $, q) {
          return Cp(T, $, Xn(q, 2), !0);
        }
        function LR(T, $) {
          var q = T == null ? 0 : T.length;
          if (q) {
            var de = w3(T, $, !0) - 1;
            if (jd(T[de], $))
              return de;
          }
          return -1;
        }
        function fu(T) {
          return T && T.length ? T2(T) : [];
        }
        function O2(T, $) {
          return T && T.length ? T2(T, Xn($, 2)) : [];
        }
        function fw(T) {
          var $ = T == null ? 0 : T.length;
          return $ ? lu(T, 1, $) : [];
        }
        function jR(T, $, q) {
          return T && T.length ? ($ = q || $ === r ? 1 : Xa($), lu(T, 0, $ < 0 ? 0 : $)) : [];
        }
        function v4(T, $, q) {
          var de = T == null ? 0 : T.length;
          return de ? ($ = q || $ === r ? 1 : Xa($), $ = de - $, lu(T, $ < 0 ? 0 : $, de)) : [];
        }
        function FR(T, $) {
          return T && T.length ? wp(T, Xn($, 3), !1, !0) : [];
        }
        function hw(T, $) {
          return T && T.length ? wp(T, Xn($, 3)) : [];
        }
        var zR = yi(function(T) {
          return E2(Nl(T, 1, ps, !0));
        }), pw = yi(function(T) {
          var $ = du(T);
          return ps($) && ($ = r), E2(Nl(T, 1, ps, !0), Xn($, 2));
        }), mw = yi(function(T) {
          var $ = du(T);
          return $ = typeof $ == "function" ? $ : r, E2(Nl(T, 1, ps, !0), r, $);
        });
        function B2(T) {
          return T && T.length ? E2(T) : [];
        }
        function sV(T, $) {
          return T && T.length ? E2(T, Xn($, 2)) : [];
        }
        function N2(T, $) {
          return $ = typeof $ == "function" ? $ : r, T && T.length ? E2(T, r, $) : [];
        }
        function y4(T) {
          if (!(T && T.length))
            return [];
          var $ = 0;
          return T = ye(T, function(q) {
            if (ps(q))
              return $ = Ms(q.length, $), !0;
          }), hC($, function(q) {
            return pt(T, jo(q));
          });
        }
        function gw(T, $) {
          if (!(T && T.length))
            return [];
          var q = y4(T);
          return $ == null ? q : pt(q, function(de) {
            return ae($, r, de);
          });
        }
        var vw = yi(function(T, $) {
          return ps(T) ? b3(T, $) : [];
        }), lV = yi(function(T) {
          return FC(ye(T, ps));
        }), cV = yi(function(T) {
          var $ = du(T);
          return ps($) && ($ = r), FC(ye(T, ps), Xn($, 2));
        }), uV = yi(function(T) {
          var $ = du(T);
          return $ = typeof $ == "function" ? $ : r, FC(ye(T, ps), r, $);
        }), GR = yi(y4);
        function WR(T, $) {
          return zC(T || [], $ || [], Bg);
        }
        function dV(T, $) {
          return zC(T || [], $ || [], A2);
        }
        var HR = yi(function(T) {
          var $ = T.length, q = $ > 1 ? T[$ - 1] : r;
          return q = typeof q == "function" ? (T.pop(), q) : r, gw(T, q);
        });
        function yw(T) {
          var $ = He(T);
          return $.__chain__ = !0, $;
        }
        function Lc(T, $) {
          return $(T), T;
        }
        function hu(T, $) {
          return $(T);
        }
        var fV = fc(function(T) {
          var $ = T.length, q = $ ? T[0] : 0, de = this.__wrapped__, Oe = function(Xe) {
            return y3(Xe, T);
          };
          return $ > 1 || this.__actions__.length || !(de instanceof $i) || !zs(q) ? this.thru(Oe) : (de = de.slice(q, +q + ($ ? 1 : 0)), de.__actions__.push({
            func: hu,
            args: [Oe],
            thisArg: r
          }), new Oi(de, this.__chain__).thru(function(Xe) {
            return $ && !Xe.length && Xe.push(r), Xe;
          }));
        });
        function hV() {
          return yw(this);
        }
        function b4() {
          return new Oi(this.value(), this.__chain__);
        }
        function Fg() {
          this.__values__ === r && (this.__values__ = yO(this.value()));
          var T = this.__index__ >= this.__values__.length, $ = T ? r : this.__values__[this.__index__++];
          return { done: T, value: $ };
        }
        function UR() {
          return this;
        }
        function VR(T) {
          for (var $, q = this; q instanceof ko; ) {
            var de = AR(q);
            de.__index__ = 0, de.__values__ = r, $ ? Oe.__wrapped__ = de : $ = de;
            var Oe = de;
            q = q.__wrapped__;
          }
          return Oe.__wrapped__ = T, $;
        }
        function pV() {
          var T = this.__wrapped__;
          if (T instanceof $i) {
            var $ = T;
            return this.__actions__.length && ($ = new $i(this)), $ = $.reverse(), $.__actions__.push({
              func: hu,
              args: [uw],
              thisArg: r
            }), new Oi($, this.__chain__);
          }
          return this.thru(uw);
        }
        function qR() {
          return t4(this.__wrapped__, this.__actions__);
        }
        var zg = r4(function(T, $, q) {
          bo.call(T, q) ? ++T[q] : I0(T, q, 1);
        });
        function B3(T, $, q) {
          var de = za(T) ? ve : IC;
          return q && hc(T, $, q) && ($ = r), de(T, Xn($, 3));
        }
        function mV(T, $) {
          var q = za(T) ? ye : MC;
          return q(T, Xn($, 3));
        }
        var KR = oR(IR), ZR = oR(p4);
        function x4(T, $) {
          return Nl(Gg(T, $), 1);
        }
        function JR(T, $) {
          return Nl(Gg(T, $), G);
        }
        function C4(T, $, q) {
          return q = q === r ? 1 : Xa(q), Nl(Gg(T, $), q);
        }
        function w4(T, $) {
          var q = za(T) ? ue : Rf;
          return q(T, Xn($, 3));
        }
        function N3(T, $) {
          var q = za(T) ? pe : $c;
          return q(T, Xn($, 3));
        }
        var gV = r4(function(T, $, q) {
          bo.call(T, q) ? T[q].push($) : I0(T, q, [$]);
        });
        function YR(T, $, q, de) {
          T = jc(T) ? T : Vg(T), q = q && !de ? Xa(q) : 0;
          var Oe = T.length;
          return q < 0 && (q = Ms(Oe + q, 0)), P4(T) ? q <= Oe && T.indexOf($, q) > -1 : !!Oe && Xs(T, $, q) > -1;
        }
        var S4 = yi(function(T, $, q) {
          var de = -1, Oe = typeof $ == "function", Xe = jc(T) ? tr(T.length) : [];
          return Rf(T, function(xt) {
            Xe[++de] = Oe ? ae($, xt, q) : P0(xt, $, q);
          }), Xe;
        }), XR = r4(function(T, $, q) {
          I0(T, q, $);
        });
        function Gg(T, $) {
          var q = za(T) ? pt : Ao;
          return q(T, Xn($, 3));
        }
        function vV(T, $, q, de) {
          return T == null ? [] : (za($) || ($ = $ == null ? [] : [$]), q = de ? r : q, za(q) || (q = q == null ? [] : [q]), xp(T, $, q));
        }
        var QR = r4(function(T, $, q) {
          T[q ? 0 : 1].push($);
        }, function() {
          return [[], []];
        });
        function jf(T, $, q) {
          var de = za(T) ? zt : IP, Oe = arguments.length < 3;
          return de(T, Xn($, 4), q, Oe, Rf);
        }
        function eO(T, $, q) {
          var de = za(T) ? mn : IP, Oe = arguments.length < 3;
          return de(T, Xn($, 4), q, Oe, $c);
        }
        function tO(T, $) {
          var q = za(T) ? ye : MC;
          return q(T, A4(Xn($, 3)));
        }
        function yV(T) {
          var $ = za(T) ? H6 : X6;
          return $(T);
        }
        function rO(T, $, q) {
          (q ? hc(T, $, q) : $ === r) ? $ = 1 : $ = Xa($);
          var de = za(T) ? RU : k2;
          return de(T, $);
        }
        function bV(T) {
          var $ = za(T) ? OU : aR;
          return $(T);
        }
        function xV(T) {
          if (T == null)
            return 0;
          if (jc(T))
            return P4(T) ? hp(T) : T.length;
          var $ = gl(T);
          return $ == Fe || $ == rt ? T.size : Sa(T).length;
        }
        function Ff(T, $, q) {
          var de = za(T) ? Tn : e4;
          return q && hc(T, $, q) && ($ = r), de(T, Xn($, 3));
        }
        var bw = yi(function(T, $) {
          if (T == null)
            return [];
          var q = $.length;
          return q > 1 && hc(T, $[0], $[1]) ? $ = [] : q > 2 && hc($[0], $[1], $[2]) && ($ = [$[0]]), xp(T, Nl($, 1), []);
        }), Wg = $P || function() {
          return Sr.Date.now();
        };
        function xw(T, $) {
          if (typeof $ != "function")
            throw new Ju(o);
          return T = Xa(T), function() {
            if (--T < 1)
              return $.apply(this, arguments);
          };
        }
        function $3(T, $, q) {
          return $ = q ? r : $, $ = T && $ == null ? T.length : $, $f(T, I, r, r, r, r, $);
        }
        function Ep(T, $) {
          var q;
          if (typeof $ != "function")
            throw new Ju(o);
          return T = Xa(T), function() {
            return --T > 0 && (q = $.apply(this, arguments)), T <= 1 && ($ = r), q;
          };
        }
        var Jn = yi(function(T, $, q) {
          var de = b;
          if (q.length) {
            var Oe = T0(q, jg(Jn));
            de |= S;
          }
          return $f(T, de, $, q, Oe);
        }), D3 = yi(function(T, $, q) {
          var de = b | w;
          if (q.length) {
            var Oe = T0(q, jg(D3));
            de |= S;
          }
          return $f($, de, T, q, Oe);
        });
        function _4(T, $, q) {
          $ = q ? r : $;
          var de = $f(T, C, r, r, r, r, r, $);
          return de.placeholder = _4.placeholder, de;
        }
        function $2(T, $, q) {
          $ = q ? r : $;
          var de = $f(T, x, r, r, r, r, r, $);
          return de.placeholder = $2.placeholder, de;
        }
        function nO(T, $, q) {
          var de, Oe, Xe, xt, Et, Wt, yr = 0, mr = !1, br = !1, Zr = !0;
          if (typeof T != "function")
            throw new Ju(o);
          $ = nd($) || 0, ms(q) && (mr = !!q.leading, br = "maxWait" in q, Xe = br ? Ms(nd(q.maxWait) || 0, $) : Xe, Zr = "trailing" in q ? !!q.trailing : Zr);
          function Pn(Zi) {
            var ad = de, Hf = Oe;
            return de = Oe = r, yr = Zi, xt = T.apply(Hf, ad), xt;
          }
          function ta(Zi) {
            return yr = Zi, Et = el(Bi, $), mr ? Pn(Zi) : xt;
          }
          function ii(Zi) {
            var ad = Zi - Wt, Hf = Zi - yr, fo = $ - ad;
            return br ? hl(fo, Xe - Hf) : fo;
          }
          function ra(Zi) {
            var ad = Zi - Wt, Hf = Zi - yr;
            return Wt === r || ad >= $ || ad < 0 || br && Hf >= Xe;
          }
          function Bi() {
            var Zi = Wg();
            if (ra(Zi))
              return Li(Zi);
            Et = el(Bi, ii(Zi));
          }
          function Li(Zi) {
            return Et = r, Zr && de ? Pn(Zi) : (de = Oe = r, xt);
          }
          function Os() {
            Et !== r && iR(Et), yr = 0, de = Wt = Oe = Et = r;
          }
          function Vn() {
            return Et === r ? xt : Li(Wg());
          }
          function Gc() {
            var Zi = Wg(), ad = ra(Zi);
            if (de = arguments, Oe = this, Wt = Zi, ad) {
              if (Et === r)
                return ta(Wt);
              if (br)
                return iR(Et), Et = el(Bi, $), Pn(Wt);
            }
            return Et === r && (Et = el(Bi, $)), xt;
          }
          return Gc.cancel = Os, Gc.flush = Vn, Gc;
        }
        var Cw = yi(function(T, $) {
          return V6(T, 1, $);
        }), aO = yi(function(T, $, q) {
          return V6(T, nd($) || 0, q);
        });
        function Yl(T) {
          return $f(T, B);
        }
        function k4(T, $) {
          if (typeof T != "function" || $ != null && typeof $ != "function")
            throw new Ju(o);
          var q = function() {
            var de = arguments, Oe = $ ? $.apply(this, de) : de[0], Xe = q.cache;
            if (Xe.has(Oe))
              return Xe.get(Oe);
            var xt = T.apply(this, de);
            return q.cache = Xe.set(Oe, xt) || Xe, xt;
          };
          return q.cache = new (k4.Cache || E0)(), q;
        }
        k4.Cache = E0;
        function A4(T) {
          if (typeof T != "function")
            throw new Ju(o);
          return function() {
            var $ = arguments;
            switch ($.length) {
              case 0:
                return !T.call(this);
              case 1:
                return !T.call(this, $[0]);
              case 2:
                return !T.call(this, $[0], $[1]);
              case 3:
                return !T.call(this, $[0], $[1], $[2]);
            }
            return !T.apply(this, $);
          };
        }
        function iO(T) {
          return Ep(2, T);
        }
        var CV = Zl(function(T, $) {
          $ = $.length == 1 && za($[0]) ? pt($[0], Ol(Xn())) : pt(Nl($, 1), Ol(Xn()));
          var q = $.length;
          return yi(function(de) {
            for (var Oe = -1, Xe = hl(de.length, q); ++Oe < Xe; )
              de[Oe] = $[Oe].call(this, de[Oe]);
            return ae(T, this, de);
          });
        }), T4 = yi(function(T, $) {
          var q = T0($, jg(T4));
          return $f(T, S, r, $, q);
        }), oO = yi(function(T, $) {
          var q = T0($, jg(oO));
          return $f(T, A, r, $, q);
        }), wV = fc(function(T, $) {
          return $f(T, M, r, r, r, $);
        });
        function SV(T, $) {
          if (typeof T != "function")
            throw new Ju(o);
          return $ = $ === r ? $ : Xa($), yi(T, $);
        }
        function zf(T, $) {
          if (typeof T != "function")
            throw new Ju(o);
          return $ = $ == null ? 0 : Ms(Xa($), 0), yi(function(q) {
            var de = q[$], Oe = I2(q, 0, $);
            return de && Tt(Oe, de), ae(T, this, Oe);
          });
        }
        function pc(T, $, q) {
          var de = !0, Oe = !0;
          if (typeof T != "function")
            throw new Ju(o);
          return ms(q) && (de = "leading" in q ? !!q.leading : de, Oe = "trailing" in q ? !!q.trailing : Oe), nO(T, $, {
            leading: de,
            maxWait: $,
            trailing: Oe
          });
        }
        function ww(T) {
          return $3(T, 1);
        }
        function _V(T, $) {
          return T4(WC($), T);
        }
        function Sw() {
          if (!arguments.length)
            return [];
          var T = arguments[0];
          return za(T) ? T : [T];
        }
        function kV(T) {
          return su(T, p);
        }
        function AV(T, $) {
          return $ = typeof $ == "function" ? $ : r, su(T, p, $);
        }
        function L3(T) {
          return su(T, f | p);
        }
        function sO(T, $) {
          return $ = typeof $ == "function" ? $ : r, su(T, f | p, $);
        }
        function lO(T, $) {
          return $ == null || U6(T, $, vl($));
        }
        function jd(T, $) {
          return T === $ || T !== T && $ !== $;
        }
        var TV = Qu(q6), EV = Qu(function(T, $) {
          return T >= $;
        }), Ip = Xu(/* @__PURE__ */ function() {
          return arguments;
        }()) ? Xu : function(T) {
          return Cs(T) && bo.call(T, "callee") && !NP.call(T, "callee");
        }, za = tr.isArray, cO = Rr ? Ol(Rr) : tR;
        function jc(T) {
          return T != null && I4(T.length) && !Gf(T);
        }
        function ps(T) {
          return Cs(T) && jc(T);
        }
        function uO(T) {
          return T === !0 || T === !1 || Cs(T) && $l(T) == ce;
        }
        var td = DP || Dw, _w = _o ? Ol(_o) : DU;
        function dO(T) {
          return Cs(T) && T.nodeType === 1 && !Hg(T);
        }
        function fO(T) {
          if (T == null)
            return !0;
          if (jc(T) && (za(T) || typeof T == "string" || typeof T.splice == "function" || td(T) || Pp(T) || Ip(T)))
            return !T.length;
          var $ = gl(T);
          if ($ == Fe || $ == rt)
            return !T.size;
          if (I3(T))
            return !Sa(T).length;
          for (var q in T)
            if (bo.call(T, q))
              return !1;
          return !0;
        }
        function E4(T, $) {
          return x3(T, $);
        }
        function hO(T, $, q) {
          q = typeof q == "function" ? q : r;
          var de = q ? q(T, $) : r;
          return de === r ? x3(T, $, r, q) : !!de;
        }
        function rd(T) {
          if (!Cs(T))
            return !1;
          var $ = $l(T);
          return $ == Ce || $ == Se || typeof T.message == "string" && typeof T.name == "string" && !Hg(T);
        }
        function Mp(T) {
          return typeof T == "number" && L6(T);
        }
        function Gf(T) {
          if (!ms(T))
            return !1;
          var $ = $l(T);
          return $ == we || $ == We || $ == ge || $ == ze;
        }
        function kw(T) {
          return typeof T == "number" && T == Xa(T);
        }
        function I4(T) {
          return typeof T == "number" && T > -1 && T % 1 == 0 && T <= H;
        }
        function ms(T) {
          var $ = typeof T;
          return T != null && ($ == "object" || $ == "function");
        }
        function Cs(T) {
          return T != null && typeof T == "object";
        }
        var pO = Ee ? Ol(Ee) : jU;
        function IV(T, $) {
          return T === $ || BC(T, $, QC($));
        }
        function MV(T, $, q) {
          return q = typeof q == "function" ? q : r, BC(T, $, QC($), q);
        }
        function PV(T) {
          return mO(T) && T != +T;
        }
        function RV(T) {
          if (bR(T))
            throw new Fa(i);
          return bp(T);
        }
        function OV(T) {
          return T === null;
        }
        function BV(T) {
          return T == null;
        }
        function mO(T) {
          return typeof T == "number" || Cs(T) && $l(T) == it;
        }
        function Hg(T) {
          if (!Cs(T) || $l(T) != Ze)
            return !1;
          var $ = O6(T);
          if ($ === null)
            return !0;
          var q = bo.call($, "constructor") && $.constructor;
          return typeof q == "function" && q instanceof q && I6.call(q) == P6;
        }
        var M4 = je ? Ol(je) : Dt;
        function gO(T) {
          return kw(T) && T >= -9007199254740991 && T <= H;
        }
        var vO = be ? Ol(be) : cr;
        function P4(T) {
          return typeof T == "string" || !za(T) && Cs(T) && $l(T) == qe;
        }
        function pu(T) {
          return typeof T == "symbol" || Cs(T) && $l(T) == nt;
        }
        var Pp = oe ? Ol(oe) : rr;
        function NV(T) {
          return T === r;
        }
        function $V(T) {
          return Cs(T) && gl(T) == Ot;
        }
        function DV(T) {
          return Cs(T) && $l(T) == lt;
        }
        var LV = Qu(Ps), jV = Qu(function(T, $) {
          return T <= $;
        });
        function yO(T) {
          if (!T)
            return [];
          if (jc(T))
            return P4(T) ? $d(T) : Dc(T);
          if (Ig && T[Ig])
            return yC(T[Ig]());
          var $ = gl(T), q = $ == Fe ? u3 : $ == rt ? T6 : Vg;
          return q(T);
        }
        function Gs(T) {
          if (!T)
            return T === 0 ? T : 0;
          if (T = nd(T), T === G || T === -1 / 0) {
            var $ = T < 0 ? -1 : 1;
            return $ * j;
          }
          return T === T ? T : 0;
        }
        function Xa(T) {
          var $ = Gs(T), q = $ % 1;
          return $ === $ ? q ? $ - q : $ : 0;
        }
        function bO(T) {
          return T ? Pf(Xa(T), 0, z) : 0;
        }
        function nd(T) {
          if (typeof T == "number")
            return T;
          if (pu(T))
            return F;
          if (ms(T)) {
            var $ = typeof T.valueOf == "function" ? T.valueOf() : T;
            T = ms($) ? $ + "" : $;
          }
          if (typeof T != "string")
            return T === 0 ? T : +T;
          T = Zu(T);
          var q = or.test(T);
          return q || Mt.test(T) ? St(T.slice(2), q ? 2 : 8) : Pt.test(T) ? F : +T;
        }
        function Aw(T) {
          return R0(T, Xl(T));
        }
        function FV(T) {
          return T ? Pf(Xa(T), -9007199254740991, H) : T === 0 ? T : 0;
        }
        function mo(T) {
          return T == null ? "" : cu(T);
        }
        var zV = Bf(function(T, $) {
          if (I3($) || jc($)) {
            R0($, vl($), T);
            return;
          }
          for (var q in $)
            bo.call($, q) && Bg(T, q, $[q]);
        }), xO = Bf(function(T, $) {
          R0($, Xl($), T);
        }), Ug = Bf(function(T, $, q, de) {
          R0($, Xl($), T, de);
        }), GV = Bf(function(T, $, q, de) {
          R0($, vl($), T, de);
        }), WV = fc(y3);
        function HV(T, $) {
          var q = Og(T);
          return $ == null ? q : JP(q, $);
        }
        var UV = yi(function(T, $) {
          T = Ro(T);
          var q = -1, de = $.length, Oe = de > 2 ? $[2] : r;
          for (Oe && hc($[0], $[1], Oe) && (de = 1); ++q < de; )
            for (var Xe = $[q], xt = Xl(Xe), Et = -1, Wt = xt.length; ++Et < Wt; ) {
              var yr = xt[Et], mr = T[yr];
              (mr === r || jd(mr, Eg[yr]) && !bo.call(T, yr)) && (T[yr] = Xe[yr]);
            }
          return T;
        }), VV = yi(function(T) {
          return T.push(r, dR), ae(wO, r, T);
        });
        function qV(T, $) {
          return Ki(T, Xn($, 3), M0);
        }
        function KV(T, $) {
          return Ki(T, Xn($, 3), RC);
        }
        function ZV(T, $) {
          return T == null ? T : PC(T, Xn($, 3), Xl);
        }
        function JV(T, $) {
          return T == null ? T : QP(T, Xn($, 3), Xl);
        }
        function YV(T, $) {
          return T && M0(T, Xn($, 3));
        }
        function XV(T, $) {
          return T && RC(T, Xn($, 3));
        }
        function QV(T) {
          return T == null ? [] : Of(T, vl(T));
        }
        function eq(T) {
          return T == null ? [] : Of(T, Xl(T));
        }
        function Tw(T, $, q) {
          var de = T == null ? r : yp(T, $);
          return de === r ? q : de;
        }
        function tq(T, $) {
          return T != null && mR(T, $, _2);
        }
        function Ew(T, $) {
          return T != null && mR(T, $, K6);
        }
        var rq = M2(function(T, $, q) {
          $ != null && typeof $.toString != "function" && ($ = M6.call($)), T[$] = q;
        }, Pw(Fc)), nq = M2(function(T, $, q) {
          $ != null && typeof $.toString != "function" && ($ = M6.call($)), bo.call(T, $) ? T[$].push(q) : T[$] = [q];
        }, Xn), aq = yi(P0);
        function vl(T) {
          return jc(T) ? ZP(T) : Sa(T);
        }
        function Xl(T) {
          return jc(T) ? ZP(T, !0) : uo(T);
        }
        function CO(T, $) {
          var q = {};
          return $ = Xn($, 3), M0(T, function(de, Oe, Xe) {
            I0(q, $(de, Oe, Xe), de);
          }), q;
        }
        function iq(T, $) {
          var q = {};
          return $ = Xn($, 3), M0(T, function(de, Oe, Xe) {
            I0(q, Oe, $(de, Oe, Xe));
          }), q;
        }
        var oq = Bf(function(T, $, q) {
          dc(T, $, q);
        }), wO = Bf(function(T, $, q, de) {
          dc(T, $, q, de);
        }), sq = fc(function(T, $) {
          var q = {};
          if (T == null)
            return q;
          var de = !1;
          $ = pt($, function(Xe) {
            return Xe = Fo(Xe, T), de || (de = Xe.length > 1), Xe;
          }), R0(T, XC(T), q), de && (q = su(q, f | h | p, UU));
          for (var Oe = $.length; Oe--; )
            jC(q, $[Oe]);
          return q;
        });
        function lq(T, $) {
          return SO(T, A4(Xn($)));
        }
        var cq = fc(function(T, $) {
          return T == null ? {} : Y6(T, $);
        });
        function SO(T, $) {
          if (T == null)
            return {};
          var q = pt(XC(T), function(de) {
            return [de];
          });
          return $ = Xn($), C3(T, q, function(de, Oe) {
            return $(de, Oe[0]);
          });
        }
        function uq(T, $, q) {
          $ = Fo($, T);
          var de = -1, Oe = $.length;
          for (Oe || (Oe = 1, T = r); ++de < Oe; ) {
            var Xe = T == null ? r : T[B0($[de])];
            Xe === r && (de = Oe, Xe = q), T = Gf(Xe) ? Xe.call(T) : Xe;
          }
          return T;
        }
        function _O(T, $, q) {
          return T == null ? T : A2(T, $, q);
        }
        function dq(T, $, q, de) {
          return de = typeof de == "function" ? de : r, T == null ? T : A2(T, $, q, de);
        }
        var j3 = uR(vl), kO = uR(Xl);
        function fq(T, $, q) {
          var de = za(T), Oe = de || td(T) || Pp(T);
          if ($ = Xn($, 4), q == null) {
            var Xe = T && T.constructor;
            Oe ? q = de ? new Xe() : [] : ms(T) ? q = Gf(Xe) ? Og(O6(T)) : {} : q = {};
          }
          return (Oe ? ue : M0)(T, function(xt, Et, Wt) {
            return $(q, xt, Et, Wt);
          }), q;
        }
        function hq(T, $) {
          return T == null ? !0 : jC(T, $);
        }
        function pq(T, $, q) {
          return T == null ? T : _3(T, $, WC(q));
        }
        function mq(T, $, q, de) {
          return de = typeof de == "function" ? de : r, T == null ? T : _3(T, $, WC(q), de);
        }
        function Vg(T) {
          return T == null ? [] : _g(T, vl(T));
        }
        function gq(T) {
          return T == null ? [] : _g(T, Xl(T));
        }
        function vq(T, $, q) {
          return q === r && (q = $, $ = r), q !== r && (q = nd(q), q = q === q ? q : 0), $ !== r && ($ = nd($), $ = $ === $ ? $ : 0), Pf(nd(T), $, q);
        }
        function yq(T, $, q) {
          return $ = Gs($), q === r ? (q = $, $ = 0) : q = Gs(q), T = nd(T), NU(T, $, q);
        }
        function bq(T, $, q) {
          if (q && typeof q != "boolean" && hc(T, $, q) && ($ = q = r), q === r && (typeof $ == "boolean" ? (q = $, $ = r) : typeof T == "boolean" && (q = T, T = r)), T === r && $ === r ? (T = 0, $ = 1) : (T = Gs(T), $ === r ? ($ = T, T = 0) : $ = Gs($)), T > $) {
            var de = T;
            T = $, $ = de;
          }
          if (q || T % 1 || $ % 1) {
            var Oe = wC();
            return hl(T + Oe * ($ - T + Bt("1e-" + ((Oe + "").length - 1))), $);
          }
          return $g(T, $);
        }
        var xq = Nf(function(T, $, q) {
          return $ = $.toLowerCase(), T + (q ? AO($) : $);
        });
        function AO(T) {
          return F3(mo(T).toLowerCase());
        }
        function TO(T) {
          return T = mo(T), T && T.replace(pn, Ag).replace(vr, "");
        }
        function Cq(T, $, q) {
          T = mo(T), $ = cu($);
          var de = T.length;
          q = q === r ? de : Pf(Xa(q), 0, de);
          var Oe = q;
          return q -= $.length, q >= 0 && T.slice(q, Oe) == $;
        }
        function wq(T) {
          return T = mo(T), T && bt.test(T) ? T.replace(kt, pC) : T;
        }
        function Sq(T) {
          return T = mo(T), T && gr.test(T) ? T.replace(Er, "\\$&") : T;
        }
        var EO = Nf(function(T, $, q) {
          return T + (q ? "-" : "") + $.toLowerCase();
        }), IO = Nf(function(T, $, q) {
          return T + (q ? " " : "") + $.toLowerCase();
        }), _q = kp("toLowerCase");
        function kq(T, $, q) {
          T = mo(T), $ = Xa($);
          var de = $ ? hp(T) : 0;
          if (!$ || de >= $)
            return T;
          var Oe = ($ - de) / 2;
          return i4($6(Oe), q) + T + i4(p3(Oe), q);
        }
        function Aq(T, $, q) {
          T = mo(T), $ = Xa($);
          var de = $ ? hp(T) : 0;
          return $ && de < $ ? T + i4($ - de, q) : T;
        }
        function Tq(T, $, q) {
          T = mo(T), $ = Xa($);
          var de = $ ? hp(T) : 0;
          return $ && de < $ ? i4($ - de, q) + T : T;
        }
        function R4(T, $, q) {
          return q || $ == null ? $ = 0 : $ && ($ = +$), jP(mo(T).replace(pr, ""), $ || 0);
        }
        function Eq(T, $, q) {
          return (q ? hc(T, $, q) : $ === r) ? $ = 1 : $ = Xa($), DC(mo(T), $);
        }
        function Iq() {
          var T = arguments, $ = mo(T[0]);
          return T.length < 3 ? $ : $.replace(T[1], T[2]);
        }
        var Mq = Nf(function(T, $, q) {
          return T + (q ? "_" : "") + $.toLowerCase();
        });
        function Pq(T, $, q) {
          return q && typeof q != "number" && hc(T, $, q) && ($ = q = r), q = q === r ? z : q >>> 0, q ? (T = mo(T), T && (typeof $ == "string" || $ != null && !M4($)) && ($ = cu($), !$ && x2(T)) ? I2($d(T), 0, q) : T.split($, q)) : [];
        }
        var Rq = Nf(function(T, $, q) {
          return T + (q ? " " : "") + F3($);
        });
        function Oq(T, $, q) {
          return T = mo(T), q = q == null ? 0 : Pf(Xa(q), 0, T.length), $ = cu($), T.slice(q, q + $.length) == $;
        }
        function Bq(T, $, q) {
          var de = He.templateSettings;
          q && hc(T, $, q) && ($ = r), T = mo(T), $ = Ug({}, $, de, O0);
          var Oe = Ug({}, $.imports, de.imports, O0), Xe = vl(Oe), xt = _g(Oe, Xe), Et, Wt, yr = 0, mr = $.interpolate || Kr, br = "__p += '", Zr = bC(
            ($.escape || Kr).source + "|" + mr.source + "|" + (mr === _t ? Kn : Kr).source + "|" + ($.evaluate || Kr).source + "|$",
            "g"
          ), Pn = "//# sourceURL=" + (bo.call($, "sourceURL") ? ($.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++fe + "]") + `
`;
          T.replace(Zr, function(ra, Bi, Li, Os, Vn, Gc) {
            return Li || (Li = Os), br += T.slice(yr, Gc).replace(Da, mC), Bi && (Et = !0, br += `' +
__e(` + Bi + `) +
'`), Vn && (Wt = !0, br += `';
` + Vn + `;
__p += '`), Li && (br += `' +
((__t = (` + Li + `)) == null ? '' : __t) +
'`), yr = Gc + ra.length, ra;
          }), br += `';
`;
          var ta = bo.call($, "variable") && $.variable;
          if (!ta)
            br = `with (obj) {
` + br + `
}
`;
          else if (fr.test(ta))
            throw new Fa(s);
          br = (Wt ? br.replace(ot, "") : br).replace(Ye, "$1").replace(Je, "$1;"), br = "function(" + (ta || "obj") + `) {
` + (ta ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Et ? ", __e = _.escape" : "") + (Wt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + br + `return __p
}`;
          var ii = Mw(function() {
            return co(Xe, Pn + "return " + br).apply(r, xt);
          });
          if (ii.source = br, rd(ii))
            throw ii;
          return ii;
        }
        function Nq(T) {
          return mo(T).toLowerCase();
        }
        function $q(T) {
          return mo(T).toUpperCase();
        }
        function Dq(T, $, q) {
          if (T = mo(T), T && (q || $ === r))
            return Zu(T);
          if (!T || !($ = cu($)))
            return T;
          var de = $d(T), Oe = $d($), Xe = kg(de, Oe), xt = MP(de, Oe) + 1;
          return I2(de, Xe, xt).join("");
        }
        function Lq(T, $, q) {
          if (T = mo(T), T && (q || $ === r))
            return T.slice(0, RP(T) + 1);
          if (!T || !($ = cu($)))
            return T;
          var de = $d(T), Oe = MP(de, $d($)) + 1;
          return I2(de, 0, Oe).join("");
        }
        function O4(T, $, q) {
          if (T = mo(T), T && (q || $ === r))
            return T.replace(pr, "");
          if (!T || !($ = cu($)))
            return T;
          var de = $d(T), Oe = kg(de, $d($));
          return I2(de, Oe).join("");
        }
        function jq(T, $) {
          var q = L, de = N;
          if (ms($)) {
            var Oe = "separator" in $ ? $.separator : Oe;
            q = "length" in $ ? Xa($.length) : q, de = "omission" in $ ? cu($.omission) : de;
          }
          T = mo(T);
          var Xe = T.length;
          if (x2(T)) {
            var xt = $d(T);
            Xe = xt.length;
          }
          if (q >= Xe)
            return T;
          var Et = q - hp(de);
          if (Et < 1)
            return de;
          var Wt = xt ? I2(xt, 0, Et).join("") : T.slice(0, Et);
          if (Oe === r)
            return Wt + de;
          if (xt && (Et += Wt.length - Et), M4(Oe)) {
            if (T.slice(Et).search(Oe)) {
              var yr, mr = Wt;
              for (Oe.global || (Oe = bC(Oe.source, mo(Pr.exec(Oe)) + "g")), Oe.lastIndex = 0; yr = Oe.exec(mr); )
                var br = yr.index;
              Wt = Wt.slice(0, br === r ? Et : br);
            }
          } else if (T.indexOf(cu(Oe), Et) != Et) {
            var Zr = Wt.lastIndexOf(Oe);
            Zr > -1 && (Wt = Wt.slice(0, Zr));
          }
          return Wt + de;
        }
        function MO(T) {
          return T = mo(T), T && Ft.test(T) ? T.replace(tt, cU) : T;
        }
        var PO = Nf(function(T, $, q) {
          return T + (q ? " " : "") + $.toUpperCase();
        }), F3 = kp("toUpperCase");
        function Iw(T, $, q) {
          return T = mo(T), $ = q ? r : $, $ === r ? vC(T) ? dU(T) : Fs(T) : T.match($) || [];
        }
        var Mw = yi(function(T, $) {
          try {
            return ae(T, r, $);
          } catch (q) {
            return rd(q) ? q : new Fa(q);
          }
        }), RO = fc(function(T, $) {
          return ue($, function(q) {
            q = B0(q), I0(T, q, Jn(T[q], T));
          }), T;
        });
        function OO(T) {
          var $ = T == null ? 0 : T.length, q = Xn();
          return T = $ ? pt(T, function(de) {
            if (typeof de[1] != "function")
              throw new Ju(o);
            return [q(de[0]), de[1]];
          }) : [], yi(function(de) {
            for (var Oe = -1; ++Oe < $; ) {
              var Xe = T[Oe];
              if (ae(Xe[0], this, de))
                return ae(Xe[1], this, de);
            }
          });
        }
        function Fq(T) {
          return BU(su(T, f));
        }
        function Pw(T) {
          return function() {
            return T;
          };
        }
        function zq(T, $) {
          return T == null || T !== T ? $ : T;
        }
        var B4 = sR(), N4 = sR(!0);
        function Fc(T) {
          return T;
        }
        function Rw(T) {
          return gn(typeof T == "function" ? T : su(T, f));
        }
        function Ow(T) {
          return Z6(su(T, f));
        }
        function BO(T, $) {
          return rR(T, su($, f));
        }
        var Gq = yi(function(T, $) {
          return function(q) {
            return P0(q, T, $);
          };
        }), Wq = yi(function(T, $) {
          return function(q) {
            return P0(T, q, $);
          };
        });
        function Bw(T, $, q) {
          var de = vl($), Oe = Of($, de);
          q == null && !(ms($) && (Oe.length || !de.length)) && (q = $, $ = T, T = this, Oe = Of($, vl($)));
          var Xe = !(ms(q) && "chain" in q) || !!q.chain, xt = Gf(T);
          return ue(Oe, function(Et) {
            var Wt = $[Et];
            T[Et] = Wt, xt && (T.prototype[Et] = function() {
              var yr = this.__chain__;
              if (Xe || yr) {
                var mr = T(this.__wrapped__), br = mr.__actions__ = Dc(this.__actions__);
                return br.push({ func: Wt, args: arguments, thisArg: T }), mr.__chain__ = yr, mr;
              }
              return Wt.apply(T, Tt([this.value()], arguments));
            });
          }), T;
        }
        function Hq() {
          return Sr._ === this && (Sr._ = gU), this;
        }
        function Nw() {
        }
        function Uq(T) {
          return T = Xa(T), yi(function($) {
            return nR($, T);
          });
        }
        var Vq = ZC(pt), qq = ZC(ve), Kq = ZC(Tn);
        function NO(T) {
          return c4(T) ? jo(B0(T)) : xo(T);
        }
        function Zq(T) {
          return function($) {
            return T == null ? r : yp(T, $);
          };
        }
        var Jq = lR(), Fd = lR(!0);
        function $w() {
          return [];
        }
        function Dw() {
          return !1;
        }
        function Rp() {
          return {};
        }
        function Ha() {
          return "";
        }
        function Yq() {
          return !0;
        }
        function zc(T, $) {
          if (T = Xa(T), T < 1 || T > H)
            return [];
          var q = z, de = hl(T, z);
          $ = Xn($), T -= z;
          for (var Oe = hC(de, $); ++q < T; )
            $(q);
          return Oe;
        }
        function Rs(T) {
          return za(T) ? pt(T, B0) : pu(T) ? [T] : Dc(h4(mo(T)));
        }
        function Xq(T) {
          var $ = ++mU;
          return mo(T) + $;
        }
        var D2 = a4(function(T, $) {
          return T + $;
        }, 0), Qq = JC("ceil"), eK = a4(function(T, $) {
          return T / $;
        }, 1), tK = JC("floor");
        function rK(T) {
          return T && T.length ? S2(T, Fc, q6) : r;
        }
        function nK(T, $) {
          return T && T.length ? S2(T, Xn($, 2), q6) : r;
        }
        function Lw(T) {
          return Ku(T, Fc);
        }
        function aK(T, $) {
          return Ku(T, Xn($, 2));
        }
        function Wf(T) {
          return T && T.length ? S2(T, Fc, Ps) : r;
        }
        function $O(T, $) {
          return T && T.length ? S2(T, Xn($, 2), Ps) : r;
        }
        var $4 = a4(function(T, $) {
          return T * $;
        }, 1), gs = JC("round"), ws = a4(function(T, $) {
          return T - $;
        }, 0);
        function DO(T) {
          return T && T.length ? k6(T, Fc) : 0;
        }
        function iK(T, $) {
          return T && T.length ? k6(T, Xn($, 2)) : 0;
        }
        return He.after = xw, He.ary = $3, He.assign = zV, He.assignIn = xO, He.assignInWith = Ug, He.assignWith = GV, He.at = WV, He.before = Ep, He.bind = Jn, He.bindAll = RO, He.bindKey = D3, He.castArray = Sw, He.chain = yw, He.chunk = KU, He.compact = R3, He.concat = ZU, He.cond = OO, He.conforms = Fq, He.constant = Pw, He.countBy = zg, He.create = HV, He.curry = _4, He.curryRight = $2, He.debounce = nO, He.defaults = UV, He.defaultsDeep = VV, He.defer = Cw, He.delay = aO, He.difference = JU, He.differenceBy = aw, He.differenceWith = TR, He.drop = YU, He.dropRight = XU, He.dropRightWhile = QU, He.dropWhile = ER, He.fill = iw, He.filter = mV, He.flatMap = x4, He.flatMapDeep = JR, He.flatMapDepth = C4, He.flatten = ow, He.flattenDeep = MR, He.flattenDepth = PR, He.flip = Yl, He.flow = B4, He.flowRight = N4, He.fromPairs = m4, He.functions = QV, He.functionsIn = eq, He.groupBy = gV, He.initial = BR, He.intersection = eV, He.intersectionBy = NR, He.intersectionWith = tV, He.invert = rq, He.invertBy = nq, He.invokeMap = S4, He.iteratee = Rw, He.keyBy = XR, He.keys = vl, He.keysIn = Xl, He.map = Gg, He.mapKeys = CO, He.mapValues = iq, He.matches = Ow, He.matchesProperty = BO, He.memoize = k4, He.merge = oq, He.mergeWith = wO, He.method = Gq, He.methodOf = Wq, He.mixin = Bw, He.negate = A4, He.nthArg = Uq, He.omit = sq, He.omitBy = lq, He.once = iO, He.orderBy = vV, He.over = Vq, He.overArgs = CV, He.overEvery = qq, He.overSome = Kq, He.partial = T4, He.partialRight = oO, He.partition = QR, He.pick = cq, He.pickBy = SO, He.property = NO, He.propertyOf = Zq, He.pull = cw, He.pullAll = ai, He.pullAllBy = nV, He.pullAllWith = aV, He.pullAt = O3, He.range = Jq, He.rangeRight = Fd, He.rearg = wV, He.reject = tO, He.remove = $R, He.rest = SV, He.reverse = uw, He.sampleSize = rO, He.set = _O, He.setWith = dq, He.shuffle = bV, He.slice = iV, He.sortBy = bw, He.sortedUniq = fu, He.sortedUniqBy = O2, He.split = Pq, He.spread = zf, He.tail = fw, He.take = jR, He.takeRight = v4, He.takeRightWhile = FR, He.takeWhile = hw, He.tap = Lc, He.throttle = pc, He.thru = hu, He.toArray = yO, He.toPairs = j3, He.toPairsIn = kO, He.toPath = Rs, He.toPlainObject = Aw, He.transform = fq, He.unary = ww, He.union = zR, He.unionBy = pw, He.unionWith = mw, He.uniq = B2, He.uniqBy = sV, He.uniqWith = N2, He.unset = hq, He.unzip = y4, He.unzipWith = gw, He.update = pq, He.updateWith = mq, He.values = Vg, He.valuesIn = gq, He.without = vw, He.words = Iw, He.wrap = _V, He.xor = lV, He.xorBy = cV, He.xorWith = uV, He.zip = GR, He.zipObject = WR, He.zipObjectDeep = dV, He.zipWith = HR, He.entries = j3, He.entriesIn = kO, He.extend = xO, He.extendWith = Ug, Bw(He, He), He.add = D2, He.attempt = Mw, He.camelCase = xq, He.capitalize = AO, He.ceil = Qq, He.clamp = vq, He.clone = kV, He.cloneDeep = L3, He.cloneDeepWith = sO, He.cloneWith = AV, He.conformsTo = lO, He.deburr = TO, He.defaultTo = zq, He.divide = eK, He.endsWith = Cq, He.eq = jd, He.escape = wq, He.escapeRegExp = Sq, He.every = B3, He.find = KR, He.findIndex = IR, He.findKey = qV, He.findLast = ZR, He.findLastIndex = p4, He.findLastKey = KV, He.floor = tK, He.forEach = w4, He.forEachRight = N3, He.forIn = ZV, He.forInRight = JV, He.forOwn = YV, He.forOwnRight = XV, He.get = Tw, He.gt = TV, He.gte = EV, He.has = tq, He.hasIn = Ew, He.head = RR, He.identity = Fc, He.includes = YR, He.indexOf = OR, He.inRange = yq, He.invoke = aq, He.isArguments = Ip, He.isArray = za, He.isArrayBuffer = cO, He.isArrayLike = jc, He.isArrayLikeObject = ps, He.isBoolean = uO, He.isBuffer = td, He.isDate = _w, He.isElement = dO, He.isEmpty = fO, He.isEqual = E4, He.isEqualWith = hO, He.isError = rd, He.isFinite = Mp, He.isFunction = Gf, He.isInteger = kw, He.isLength = I4, He.isMap = pO, He.isMatch = IV, He.isMatchWith = MV, He.isNaN = PV, He.isNative = RV, He.isNil = BV, He.isNull = OV, He.isNumber = mO, He.isObject = ms, He.isObjectLike = Cs, He.isPlainObject = Hg, He.isRegExp = M4, He.isSafeInteger = gO, He.isSet = vO, He.isString = P4, He.isSymbol = pu, He.isTypedArray = Pp, He.isUndefined = NV, He.isWeakMap = $V, He.isWeakSet = DV, He.join = sw, He.kebabCase = EO, He.last = du, He.lastIndexOf = lw, He.lowerCase = IO, He.lowerFirst = _q, He.lt = LV, He.lte = jV, He.max = rK, He.maxBy = nK, He.mean = Lw, He.meanBy = aK, He.min = Wf, He.minBy = $O, He.stubArray = $w, He.stubFalse = Dw, He.stubObject = Rp, He.stubString = Ha, He.stubTrue = Yq, He.multiply = $4, He.nth = rV, He.noConflict = Hq, He.noop = Nw, He.now = Wg, He.pad = kq, He.padEnd = Aq, He.padStart = Tq, He.parseInt = R4, He.random = bq, He.reduce = jf, He.reduceRight = eO, He.repeat = Eq, He.replace = Iq, He.result = uq, He.round = gs, He.runInContext = $t, He.sample = yV, He.size = xV, He.snakeCase = Mq, He.some = Ff, He.sortedIndex = ed, He.sortedIndexBy = oV, He.sortedIndexOf = g4, He.sortedLastIndex = dw, He.sortedLastIndexBy = DR, He.sortedLastIndexOf = LR, He.startCase = Rq, He.startsWith = Oq, He.subtract = ws, He.sum = DO, He.sumBy = iK, He.template = Bq, He.times = zc, He.toFinite = Gs, He.toInteger = Xa, He.toLength = bO, He.toLower = Nq, He.toNumber = nd, He.toSafeInteger = FV, He.toString = mo, He.toUpper = $q, He.trim = Dq, He.trimEnd = Lq, He.trimStart = O4, He.truncate = jq, He.unescape = MO, He.uniqueId = Xq, He.upperCase = PO, He.upperFirst = F3, He.each = w4, He.eachRight = N3, He.first = RR, Bw(He, function() {
          var T = {};
          return M0(He, function($, q) {
            bo.call(He.prototype, q) || (T[q] = $);
          }), T;
        }(), { chain: !1 }), He.VERSION = n, ue(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(T) {
          He[T].placeholder = He;
        }), ue(["drop", "take"], function(T, $) {
          $i.prototype[T] = function(q) {
            q = q === r ? 1 : Ms(Xa(q), 0);
            var de = this.__filtered__ && !$ ? new $i(this) : this.clone();
            return de.__filtered__ ? de.__takeCount__ = hl(q, de.__takeCount__) : de.__views__.push({
              size: hl(q, z),
              type: T + (de.__dir__ < 0 ? "Right" : "")
            }), de;
          }, $i.prototype[T + "Right"] = function(q) {
            return this.reverse()[T](q).reverse();
          };
        }), ue(["filter", "map", "takeWhile"], function(T, $) {
          var q = $ + 1, de = q == v || q == O;
          $i.prototype[T] = function(Oe) {
            var Xe = this.clone();
            return Xe.__iteratees__.push({
              iteratee: Xn(Oe, 3),
              type: q
            }), Xe.__filtered__ = Xe.__filtered__ || de, Xe;
          };
        }), ue(["head", "last"], function(T, $) {
          var q = "take" + ($ ? "Right" : "");
          $i.prototype[T] = function() {
            return this[q](1).value()[0];
          };
        }), ue(["initial", "tail"], function(T, $) {
          var q = "drop" + ($ ? "" : "Right");
          $i.prototype[T] = function() {
            return this.__filtered__ ? new $i(this) : this[q](1);
          };
        }), $i.prototype.compact = function() {
          return this.filter(Fc);
        }, $i.prototype.find = function(T) {
          return this.filter(T).head();
        }, $i.prototype.findLast = function(T) {
          return this.reverse().find(T);
        }, $i.prototype.invokeMap = yi(function(T, $) {
          return typeof T == "function" ? new $i(this) : this.map(function(q) {
            return P0(q, T, $);
          });
        }), $i.prototype.reject = function(T) {
          return this.filter(A4(Xn(T)));
        }, $i.prototype.slice = function(T, $) {
          T = Xa(T);
          var q = this;
          return q.__filtered__ && (T > 0 || $ < 0) ? new $i(q) : (T < 0 ? q = q.takeRight(-T) : T && (q = q.drop(T)), $ !== r && ($ = Xa($), q = $ < 0 ? q.dropRight(-$) : q.take($ - T)), q);
        }, $i.prototype.takeRightWhile = function(T) {
          return this.reverse().takeWhile(T).reverse();
        }, $i.prototype.toArray = function() {
          return this.take(z);
        }, M0($i.prototype, function(T, $) {
          var q = /^(?:filter|find|map|reject)|While$/.test($), de = /^(?:head|last)$/.test($), Oe = He[de ? "take" + ($ == "last" ? "Right" : "") : $], Xe = de || /^find/.test($);
          Oe && (He.prototype[$] = function() {
            var xt = this.__wrapped__, Et = de ? [1] : arguments, Wt = xt instanceof $i, yr = Et[0], mr = Wt || za(xt), br = function(Bi) {
              var Li = Oe.apply(He, Tt([Bi], Et));
              return de && Zr ? Li[0] : Li;
            };
            mr && q && typeof yr == "function" && yr.length != 1 && (Wt = mr = !1);
            var Zr = this.__chain__, Pn = !!this.__actions__.length, ta = Xe && !Zr, ii = Wt && !Pn;
            if (!Xe && mr) {
              xt = ii ? xt : new $i(this);
              var ra = T.apply(xt, Et);
              return ra.__actions__.push({ func: hu, args: [br], thisArg: r }), new Oi(ra, Zr);
            }
            return ta && ii ? T.apply(this, Et) : (ra = this.thru(br), ta ? de ? ra.value()[0] : ra.value() : ra);
          });
        }), ue(["pop", "push", "shift", "sort", "splice", "unshift"], function(T) {
          var $ = d3[T], q = /^(?:push|sort|unshift)$/.test(T) ? "tap" : "thru", de = /^(?:pop|shift)$/.test(T);
          He.prototype[T] = function() {
            var Oe = arguments;
            if (de && !this.__chain__) {
              var Xe = this.value();
              return $.apply(za(Xe) ? Xe : [], Oe);
            }
            return this[q](function(xt) {
              return $.apply(za(xt) ? xt : [], Oe);
            });
          };
        }), M0($i.prototype, function(T, $) {
          var q = He[$];
          if (q) {
            var de = q.name + "";
            bo.call(mp, de) || (mp[de] = []), mp[de].push({ name: $, func: q });
          }
        }), mp[n4(r, w).name] = [{
          name: "wrapper",
          func: r
        }], $i.prototype.clone = kU, $i.prototype.reverse = AU, $i.prototype.value = TU, He.prototype.at = fV, He.prototype.chain = hV, He.prototype.commit = b4, He.prototype.next = Fg, He.prototype.plant = VR, He.prototype.reverse = pV, He.prototype.toJSON = He.prototype.valueOf = He.prototype.value = qR, He.prototype.first = He.prototype.head, Ig && (He.prototype[Ig] = UR), He;
      }, Tg = fU();
      ri ? ((ri.exports = Tg)._ = Tg, Vr._ = Tg) : Sr._ = Tg;
    }).call(IBt);
  }(YS, YS.exports)), YS.exports;
}
var $2e = MBt(), EKe = function() {
  var t = 1, e = /* @__PURE__ */ new WeakMap(), r = function(n, a) {
    return typeof n == "number" || typeof n == "string" ? a ? "idx-".concat(a) : "val-".concat(n) : e.has(n) ? "uid" + e.get(n) : (e.set(n, t++), r(n));
  };
  return r;
}, D2e = EKe(), L2e = function(t) {
  return t === void 0 && (t = ""), { value: 1, prefix: t, uid: EKe() };
}, PBt = L2e(), IKe = P.createContext(L2e()), RBt = function(t) {
  return t.value++;
}, OBt = function(t) {
  return t ? t.prefix : "";
}, BBt = function(t) {
  var e = t || PBt, r = OBt(e), n = RBt(e), a = r + n, i = function(o) {
    return a + e.uid(o);
  };
  return { uid: a, gen: i };
}, MKe = function() {
  var t = Qn(IKe), e = Yt(function() {
    return BBt(t);
  })[0];
  return e;
}, PKe = function() {
  var t = MKe().uid;
  return t;
}, NBt = function() {
  var t = MKe().gen;
  return t;
}, $Bt = function(t) {
  var e = t.children, r = t.prefix, n = r === void 0 ? "" : r, a = PKe(), i = Yt(function() {
    return L2e(a + "-" + n);
  })[0];
  return P.createElement(IKe.Provider, { value: i }, e);
}, DBt = "useId", dL = Te[DBt], Jr = dL !== void 0 ? dL : PKe, JI = dL !== void 0 ? () => {
  let t = dL();
  return (e) => `${t}-${e}`;
} : NBt;
const LBt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  UIDFork: $Bt,
  uid: D2e,
  useUID: Jr,
  useUIDSeed: JI
}, Symbol.toStringTag, { value: "Module" }));
var jBt = Object.defineProperty, FBt = Object.defineProperties, zBt = Object.getOwnPropertyDescriptors, fL = Object.getOwnPropertySymbols, RKe = Object.prototype.hasOwnProperty, OKe = Object.prototype.propertyIsEnumerable, w4e = (t, e, r) => e in t ? jBt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, GBt = (t, e) => {
  for (var r in e || (e = {})) RKe.call(e, r) && w4e(t, r, e[r]);
  if (fL) for (var r of fL(e)) OKe.call(e, r) && w4e(t, r, e[r]);
  return t;
}, WBt = (t, e) => FBt(t, zBt(e)), HBt = (t, e) => {
  var r = {};
  for (var n in t) RKe.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && fL) for (var n of fL(t)) e.indexOf(n) < 0 && OKe.call(t, n) && (r[n] = t[n]);
  return r;
};
const gi = P.forwardRef((t, e) => {
  var r = t, { as: n = "span", color: a = "currentColor", display: i = "block", element: o = "ICON", size: s = "sizeIcon30" } = r, l = HBt(r, ["as", "color", "display", "element", "size"]);
  return P.createElement(ht, WBt(GBt({}, Xt(l)), { as: n, element: o, lineHeight: "lineHeight0", display: i, color: a, size: s, ref: e, flexShrink: 0 }));
});
gi.displayName = "IconWrapper";
const BKe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowDownIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowDownIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.91 14.991l.05.007h.08l.07-.01.029-.01a.489.489 0 00.272-.205l3.444-3.832a.596.596 0 000-.78.459.459 0 00-.632-.063l-.069.063-2.659 2.957V5.513A.504.504 0 0010 5a.5.5 0 00-.488.42l-.008.093v7.604l-2.658-2.956a.459.459 0 00-.632-.063l-.069.063a.598.598 0 00-.057.704l.057.076 3.444 3.832c.064.098.16.172.272.206l.049.012z" })));
});
BKe.displayName = "ArrowDownIcon";
const j2e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SendIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SendIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", d: "M16.999 10.032a.337.337 0 00-.044-.175.274.274 0 00-.123-.114L4.365 4.02a.244.244 0 00-.148-.014.266.266 0 00-.132.075.322.322 0 00-.076.147.355.355 0 00.004.172l1.19 4.46c.004.03.016.056.034.077a.124.124 0 00.067.041l7.054.857a.13.13 0 01.082.052.17.17 0 01.033.101.17.17 0 01-.033.101.13.13 0 01-.082.052l-7.042.87a.124.124 0 00-.067.041.157.157 0 00-.036.077l-1.189 4.46a.355.355 0 00-.008.17.324.324 0 00.072.15.26.26 0 00.13.083c.048.013.1.01.147-.01l12.482-5.644a.28.28 0 00.118-.125.342.342 0 00.034-.181z" })));
});
j2e.displayName = "SendIcon";
const is = Ml(
  ({ children: t, ...e }, r) => /* @__PURE__ */ R.jsx(
    _r,
    {
      ref: r,
      borderWidth: "borderWidth10",
      borderColor: "colorBorderWeaker",
      borderRadius: "borderRadius20",
      ...e,
      children: t
    }
  )
), Kh = () => /* @__PURE__ */ R.jsx(R.Fragment, {});
function UBt(t, e) {
  const r = {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const VBt = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, qBt = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, KBt = {};
function S4e(t, e) {
  return (KBt.jsx ? qBt : VBt).test(t);
}
const ZBt = /[ \t\n\f\r]/g;
function JBt(t) {
  return typeof t == "object" ? t.type === "text" ? _4e(t.value) : !1 : _4e(t);
}
function _4e(t) {
  return t.replace(ZBt, "") === "";
}
let YI = class {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(e, r, n) {
    this.property = e, this.normal = r, n && (this.space = n);
  }
};
YI.prototype.property = {};
YI.prototype.normal = {};
YI.prototype.space = null;
function NKe(t, e) {
  const r = {}, n = {};
  let a = -1;
  for (; ++a < t.length; )
    Object.assign(r, t[a].property), Object.assign(n, t[a].normal);
  return new YI(r, n, e);
}
function Qce(t) {
  return t.toLowerCase();
}
class xf {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(e, r) {
    this.property = e, this.attribute = r;
  }
}
xf.prototype.space = null;
xf.prototype.boolean = !1;
xf.prototype.booleanish = !1;
xf.prototype.overloadedBoolean = !1;
xf.prototype.number = !1;
xf.prototype.commaSeparated = !1;
xf.prototype.spaceSeparated = !1;
xf.prototype.commaOrSpaceSeparated = !1;
xf.prototype.mustUseProperty = !1;
xf.prototype.defined = !1;
let YBt = 0;
const oi = Z5(), yl = Z5(), $Ke = Z5(), Wr = Z5(), Xo = Z5(), u7 = Z5(), Wd = Z5();
function Z5() {
  return 2 ** ++YBt;
}
const eue = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: oi,
  booleanish: yl,
  commaOrSpaceSeparated: Wd,
  commaSeparated: u7,
  number: Wr,
  overloadedBoolean: $Ke,
  spaceSeparated: Xo
}, Symbol.toStringTag, { value: "Module" })), FK = Object.keys(eue);
class F2e extends xf {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(e, r, n, a) {
    let i = -1;
    if (super(e, r), k4e(this, "space", a), typeof n == "number")
      for (; ++i < FK.length; ) {
        const o = FK[i];
        k4e(this, FK[i], (n & eue[o]) === eue[o]);
      }
  }
}
F2e.prototype.defined = !0;
function k4e(t, e, r) {
  r && (t[e] = r);
}
const XBt = {}.hasOwnProperty;
function S8(t) {
  const e = {}, r = {};
  let n;
  for (n in t.properties)
    if (XBt.call(t.properties, n)) {
      const a = t.properties[n], i = new F2e(
        n,
        t.transform(t.attributes || {}, n),
        a,
        t.space
      );
      t.mustUseProperty && t.mustUseProperty.includes(n) && (i.mustUseProperty = !0), e[n] = i, r[Qce(n)] = n, r[Qce(i.attribute)] = n;
    }
  return new YI(e, r, t.space);
}
const DKe = S8({
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), LKe = S8({
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function jKe(t, e) {
  return e in t ? t[e] : e;
}
function FKe(t, e) {
  return jKe(t, e.toLowerCase());
}
const zKe = S8({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: FKe,
  properties: { xmlns: null, xmlnsXLink: null }
}), GKe = S8({
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: yl,
    ariaAutoComplete: null,
    ariaBusy: yl,
    ariaChecked: yl,
    ariaColCount: Wr,
    ariaColIndex: Wr,
    ariaColSpan: Wr,
    ariaControls: Xo,
    ariaCurrent: null,
    ariaDescribedBy: Xo,
    ariaDetails: null,
    ariaDisabled: yl,
    ariaDropEffect: Xo,
    ariaErrorMessage: null,
    ariaExpanded: yl,
    ariaFlowTo: Xo,
    ariaGrabbed: yl,
    ariaHasPopup: null,
    ariaHidden: yl,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Xo,
    ariaLevel: Wr,
    ariaLive: null,
    ariaModal: yl,
    ariaMultiLine: yl,
    ariaMultiSelectable: yl,
    ariaOrientation: null,
    ariaOwns: Xo,
    ariaPlaceholder: null,
    ariaPosInSet: Wr,
    ariaPressed: yl,
    ariaReadOnly: yl,
    ariaRelevant: null,
    ariaRequired: yl,
    ariaRoleDescription: Xo,
    ariaRowCount: Wr,
    ariaRowIndex: Wr,
    ariaRowSpan: Wr,
    ariaSelected: yl,
    ariaSetSize: Wr,
    ariaSort: null,
    ariaValueMax: Wr,
    ariaValueMin: Wr,
    ariaValueNow: Wr,
    ariaValueText: null,
    role: null
  }
}), QBt = S8({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: FKe,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: u7,
    acceptCharset: Xo,
    accessKey: Xo,
    action: null,
    allow: null,
    allowFullScreen: oi,
    allowPaymentRequest: oi,
    allowUserMedia: oi,
    alt: null,
    as: null,
    async: oi,
    autoCapitalize: null,
    autoComplete: Xo,
    autoFocus: oi,
    autoPlay: oi,
    blocking: Xo,
    capture: null,
    charSet: null,
    checked: oi,
    cite: null,
    className: Xo,
    cols: Wr,
    colSpan: null,
    content: null,
    contentEditable: yl,
    controls: oi,
    controlsList: Xo,
    coords: Wr | u7,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: oi,
    defer: oi,
    dir: null,
    dirName: null,
    disabled: oi,
    download: $Ke,
    draggable: yl,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: oi,
    formTarget: null,
    headers: Xo,
    height: Wr,
    hidden: oi,
    high: Wr,
    href: null,
    hrefLang: null,
    htmlFor: Xo,
    httpEquiv: Xo,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: oi,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: oi,
    itemId: null,
    itemProp: Xo,
    itemRef: Xo,
    itemScope: oi,
    itemType: Xo,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: oi,
    low: Wr,
    manifest: null,
    max: null,
    maxLength: Wr,
    media: null,
    method: null,
    min: null,
    minLength: Wr,
    multiple: oi,
    muted: oi,
    name: null,
    nonce: null,
    noModule: oi,
    noValidate: oi,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: oi,
    optimum: Wr,
    pattern: null,
    ping: Xo,
    placeholder: null,
    playsInline: oi,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: oi,
    referrerPolicy: null,
    rel: Xo,
    required: oi,
    reversed: oi,
    rows: Wr,
    rowSpan: Wr,
    sandbox: Xo,
    scope: null,
    scoped: oi,
    seamless: oi,
    selected: oi,
    shadowRootClonable: oi,
    shadowRootDelegatesFocus: oi,
    shadowRootMode: null,
    shape: null,
    size: Wr,
    sizes: null,
    slot: null,
    span: Wr,
    spellCheck: yl,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Wr,
    step: null,
    style: null,
    tabIndex: Wr,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: oi,
    useMap: null,
    value: yl,
    width: Wr,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Xo,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Wr,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Wr,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: oi,
    // Lists. Use CSS to reduce space between items instead
    declare: oi,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Wr,
    // `<img>` and `<object>`
    leftMargin: Wr,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Wr,
    // `<body>`
    marginWidth: Wr,
    // `<body>`
    noResize: oi,
    // `<frame>`
    noHref: oi,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: oi,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: oi,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Wr,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: yl,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Wr,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Wr,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: oi,
    disableRemotePlayback: oi,
    prefix: null,
    property: null,
    results: Wr,
    security: null,
    unselectable: null
  }
}), eNt = S8({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: jKe,
  properties: {
    about: Wd,
    accentHeight: Wr,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Wr,
    amplitude: Wr,
    arabicForm: null,
    ascent: Wr,
    attributeName: null,
    attributeType: null,
    azimuth: Wr,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Wr,
    by: null,
    calcMode: null,
    capHeight: Wr,
    className: Xo,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Wr,
    diffuseConstant: Wr,
    direction: null,
    display: null,
    dur: null,
    divisor: Wr,
    dominantBaseline: null,
    download: oi,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Wr,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Wr,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Wr,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: u7,
    g2: u7,
    glyphName: u7,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Wr,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Wr,
    horizOriginX: Wr,
    horizOriginY: Wr,
    id: null,
    ideographic: Wr,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Wr,
    k: Wr,
    k1: Wr,
    k2: Wr,
    k3: Wr,
    k4: Wr,
    kernelMatrix: Wd,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Wr,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Wr,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Wr,
    overlineThickness: Wr,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Wr,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Xo,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Wr,
    pointsAtY: Wr,
    pointsAtZ: Wr,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Wd,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Wd,
    rev: Wd,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Wd,
    requiredFeatures: Wd,
    requiredFonts: Wd,
    requiredFormats: Wd,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Wr,
    specularExponent: Wr,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Wr,
    strikethroughThickness: Wr,
    string: null,
    stroke: null,
    strokeDashArray: Wd,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Wr,
    strokeOpacity: Wr,
    strokeWidth: null,
    style: null,
    surfaceScale: Wr,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Wd,
    tabIndex: Wr,
    tableValues: null,
    target: null,
    targetX: Wr,
    targetY: Wr,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Wd,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Wr,
    underlineThickness: Wr,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Wr,
    values: null,
    vAlphabetic: Wr,
    vMathematical: Wr,
    vectorEffect: null,
    vHanging: Wr,
    vIdeographic: Wr,
    version: null,
    vertAdvY: Wr,
    vertOriginX: Wr,
    vertOriginY: Wr,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Wr,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), tNt = /^data[-\w.:]+$/i, A4e = /-[a-z]/g, rNt = /[A-Z]/g;
function nNt(t, e) {
  const r = Qce(e);
  let n = e, a = xf;
  if (r in t.normal)
    return t.property[t.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && tNt.test(e)) {
    if (e.charAt(4) === "-") {
      const i = e.slice(5).replace(A4e, iNt);
      n = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = e.slice(4);
      if (!A4e.test(i)) {
        let o = i.replace(rNt, aNt);
        o.charAt(0) !== "-" && (o = "-" + o), e = "data" + o;
      }
    }
    a = F2e;
  }
  return new a(n, e);
}
function aNt(t) {
  return "-" + t.toLowerCase();
}
function iNt(t) {
  return t.charAt(1).toUpperCase();
}
const oNt = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, sNt = NKe([LKe, DKe, zKe, GKe, QBt], "html"), z2e = NKe([LKe, DKe, zKe, GKe, eNt], "svg");
function lNt(t) {
  return t.join(" ").trim();
}
var F4 = {}, zK, T4e;
function cNt() {
  if (T4e) return zK;
  T4e = 1;
  var t = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, e = /\n/g, r = /^\s*/, n = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, i = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, o = /^[;\s]*/, s = /^\s+|\s+$/g, l = `
`, c = "/", u = "*", f = "", h = "comment", p = "declaration";
  zK = function(y, b) {
    if (typeof y != "string")
      throw new TypeError("First argument must be a string");
    if (!y) return [];
    b = b || {};
    var w = 1, _ = 1;
    function C(m) {
      var v = m.match(e);
      v && (w += v.length);
      var k = m.lastIndexOf(l);
      _ = ~k ? m.length - k : _ + m.length;
    }
    function x() {
      var m = { line: w, column: _ };
      return function(v) {
        return v.position = new S(m), M(), v;
      };
    }
    function S(m) {
      this.start = m, this.end = { line: w, column: _ }, this.source = b.source;
    }
    S.prototype.content = y;
    function A(m) {
      var v = new Error(
        b.source + ":" + w + ":" + _ + ": " + m
      );
      if (v.reason = m, v.filename = b.source, v.line = w, v.column = _, v.source = y, !b.silent) throw v;
    }
    function I(m) {
      var v = m.exec(y);
      if (v) {
        var k = v[0];
        return C(k), y = y.slice(k.length), v;
      }
    }
    function M() {
      I(r);
    }
    function B(m) {
      var v;
      for (m = m || []; v = L(); )
        v !== !1 && m.push(v);
      return m;
    }
    function L() {
      var m = x();
      if (!(c != y.charAt(0) || u != y.charAt(1))) {
        for (var v = 2; f != y.charAt(v) && (u != y.charAt(v) || c != y.charAt(v + 1)); )
          ++v;
        if (v += 2, f === y.charAt(v - 1))
          return A("End of comment missing");
        var k = y.slice(2, v - 2);
        return _ += 2, C(k), y = y.slice(v), _ += 2, m({
          type: h,
          comment: k
        });
      }
    }
    function N() {
      var m = x(), v = I(n);
      if (v) {
        if (L(), !I(a)) return A("property missing ':'");
        var k = I(i), O = m({
          type: p,
          property: g(v[0].replace(t, f)),
          value: k ? g(k[0].replace(t, f)) : f
        });
        return I(o), O;
      }
    }
    function d() {
      var m = [];
      B(m);
      for (var v; v = N(); )
        v !== !1 && (m.push(v), B(m));
      return m;
    }
    return M(), d();
  };
  function g(y) {
    return y ? y.replace(s, f) : f;
  }
  return zK;
}
var E4e;
function uNt() {
  if (E4e) return F4;
  E4e = 1;
  var t = F4 && F4.__importDefault || function(n) {
    return n && n.__esModule ? n : { default: n };
  };
  Object.defineProperty(F4, "__esModule", { value: !0 }), F4.default = r;
  var e = t(cNt());
  function r(n, a) {
    var i = null;
    if (!n || typeof n != "string")
      return i;
    var o = (0, e.default)(n), s = typeof a == "function";
    return o.forEach(function(l) {
      if (l.type === "declaration") {
        var c = l.property, u = l.value;
        s ? a(c, u, l) : u && (i = i || {}, i[c] = u);
      }
    }), i;
  }
  return F4;
}
var dNt = uNt();
const I4e = /* @__PURE__ */ Gi(dNt), fNt = I4e.default || I4e, WKe = HKe("end"), G2e = HKe("start");
function HKe(t) {
  return e;
  function e(r) {
    const n = r && r.position && r.position[t] || {};
    if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0)
      return {
        line: n.line,
        column: n.column,
        offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
      };
  }
}
function hNt(t) {
  const e = G2e(t), r = WKe(t);
  if (e && r)
    return { start: e, end: r };
}
function A_(t) {
  return !t || typeof t != "object" ? "" : "position" in t || "type" in t ? M4e(t.position) : "start" in t || "end" in t ? M4e(t) : "line" in t || "column" in t ? tue(t) : "";
}
function tue(t) {
  return P4e(t && t.line) + ":" + P4e(t && t.column);
}
function M4e(t) {
  return tue(t && t.start) + "-" + tue(t && t.end);
}
function P4e(t) {
  return t && typeof t == "number" ? t : 1;
}
class tu extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(e, r, n) {
    super(), typeof r == "string" && (n = r, r = void 0);
    let a = "", i = {}, o = !1;
    if (r && ("line" in r && "column" in r ? i = { place: r } : "start" in r && "end" in r ? i = { place: r } : "type" in r ? i = {
      ancestors: [r],
      place: r.position
    } : i = { ...r }), typeof e == "string" ? a = e : !i.cause && e && (o = !0, a = e.message, i.cause = e), !i.ruleId && !i.source && typeof n == "string") {
      const l = n.indexOf(":");
      l === -1 ? i.ruleId = n : (i.source = n.slice(0, l), i.ruleId = n.slice(l + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const l = i.ancestors[i.ancestors.length - 1];
      l && (i.place = l.position);
    }
    const s = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = s ? s.line : void 0, this.name = A_(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = o && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
tu.prototype.file = "";
tu.prototype.name = "";
tu.prototype.reason = "";
tu.prototype.message = "";
tu.prototype.stack = "";
tu.prototype.column = void 0;
tu.prototype.line = void 0;
tu.prototype.ancestors = void 0;
tu.prototype.cause = void 0;
tu.prototype.fatal = void 0;
tu.prototype.place = void 0;
tu.prototype.ruleId = void 0;
tu.prototype.source = void 0;
const W2e = {}.hasOwnProperty, pNt = /* @__PURE__ */ new Map(), mNt = /[A-Z]/g, gNt = /-([a-z])/g, vNt = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), yNt = /* @__PURE__ */ new Set(["td", "th"]), UKe = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function VKe(t, e) {
  if (!e || e.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = e.filePath || void 0;
  let n;
  if (e.development) {
    if (typeof e.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    n = ANt(r, e.jsxDEV);
  } else {
    if (typeof e.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof e.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    n = kNt(r, e.jsx, e.jsxs);
  }
  const a = {
    Fragment: e.Fragment,
    ancestors: [],
    components: e.components || {},
    create: n,
    elementAttributeNameCase: e.elementAttributeNameCase || "react",
    evaluater: e.createEvaluater ? e.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: e.ignoreInvalidStyle || !1,
    passKeys: e.passKeys !== !1,
    passNode: e.passNode || !1,
    schema: e.space === "svg" ? z2e : sNt,
    stylePropertyNameCase: e.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: e.tableCellAlignToStyle !== !1
  }, i = qKe(a, t, void 0);
  return i && typeof i != "string" ? i : a.create(
    t,
    a.Fragment,
    { children: i || void 0 },
    void 0
  );
}
function qKe(t, e, r) {
  if (e.type === "element")
    return bNt(t, e, r);
  if (e.type === "mdxFlowExpression" || e.type === "mdxTextExpression")
    return xNt(t, e);
  if (e.type === "mdxJsxFlowElement" || e.type === "mdxJsxTextElement")
    return wNt(t, e, r);
  if (e.type === "mdxjsEsm")
    return CNt(t, e);
  if (e.type === "root")
    return SNt(t, e, r);
  if (e.type === "text")
    return _Nt(t, e);
}
function bNt(t, e, r) {
  const n = t.schema;
  let a = n;
  e.tagName.toLowerCase() === "svg" && n.space === "html" && (a = z2e, t.schema = a), t.ancestors.push(e);
  const i = ZKe(t, e.tagName, !1), o = TNt(t, e);
  let s = U2e(t, e);
  return vNt.has(e.tagName) && (s = s.filter(function(l) {
    return typeof l == "string" ? !JBt(l) : !0;
  })), KKe(t, o, i, e), H2e(o, s), t.ancestors.pop(), t.schema = n, t.create(e, i, o, r);
}
function xNt(t, e) {
  if (e.data && e.data.estree && t.evaluater) {
    const n = e.data.estree.body[0];
    return n.type, /** @type {Child | undefined} */
    t.evaluater.evaluateExpression(n.expression);
  }
  _T(t, e.position);
}
function CNt(t, e) {
  if (e.data && e.data.estree && t.evaluater)
    return (
      /** @type {Child | undefined} */
      t.evaluater.evaluateProgram(e.data.estree)
    );
  _T(t, e.position);
}
function wNt(t, e, r) {
  const n = t.schema;
  let a = n;
  e.name === "svg" && n.space === "html" && (a = z2e, t.schema = a), t.ancestors.push(e);
  const i = e.name === null ? t.Fragment : ZKe(t, e.name, !0), o = ENt(t, e), s = U2e(t, e);
  return KKe(t, o, i, e), H2e(o, s), t.ancestors.pop(), t.schema = n, t.create(e, i, o, r);
}
function SNt(t, e, r) {
  const n = {};
  return H2e(n, U2e(t, e)), t.create(e, t.Fragment, n, r);
}
function _Nt(t, e) {
  return e.value;
}
function KKe(t, e, r, n) {
  typeof r != "string" && r !== t.Fragment && t.passNode && (e.node = n);
}
function H2e(t, e) {
  if (e.length > 0) {
    const r = e.length > 1 ? e : e[0];
    r && (t.children = r);
  }
}
function kNt(t, e, r) {
  return n;
  function n(a, i, o, s) {
    const c = Array.isArray(o.children) ? r : e;
    return s ? c(i, o, s) : c(i, o);
  }
}
function ANt(t, e) {
  return r;
  function r(n, a, i, o) {
    const s = Array.isArray(i.children), l = G2e(n);
    return e(
      a,
      i,
      o,
      s,
      {
        columnNumber: l ? l.column - 1 : void 0,
        fileName: t,
        lineNumber: l ? l.line : void 0
      },
      void 0
    );
  }
}
function TNt(t, e) {
  const r = {};
  let n, a;
  for (a in e.properties)
    if (a !== "children" && W2e.call(e.properties, a)) {
      const i = INt(t, a, e.properties[a]);
      if (i) {
        const [o, s] = i;
        t.tableCellAlignToStyle && o === "align" && typeof s == "string" && yNt.has(e.tagName) ? n = s : r[o] = s;
      }
    }
  if (n) {
    const i = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    i[t.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = n;
  }
  return r;
}
function ENt(t, e) {
  const r = {};
  for (const n of e.attributes)
    if (n.type === "mdxJsxExpressionAttribute")
      if (n.data && n.data.estree && t.evaluater) {
        const i = n.data.estree.body[0];
        i.type;
        const o = i.expression;
        o.type;
        const s = o.properties[0];
        s.type, Object.assign(
          r,
          t.evaluater.evaluateExpression(s.argument)
        );
      } else
        _T(t, e.position);
    else {
      const a = n.name;
      let i;
      if (n.value && typeof n.value == "object")
        if (n.value.data && n.value.data.estree && t.evaluater) {
          const s = n.value.data.estree.body[0];
          s.type, i = t.evaluater.evaluateExpression(s.expression);
        } else
          _T(t, e.position);
      else
        i = n.value === null ? !0 : n.value;
      r[a] = /** @type {Props[keyof Props]} */
      i;
    }
  return r;
}
function U2e(t, e) {
  const r = [];
  let n = -1;
  const a = t.passKeys ? /* @__PURE__ */ new Map() : pNt;
  for (; ++n < e.children.length; ) {
    const i = e.children[n];
    let o;
    if (t.passKeys) {
      const l = i.type === "element" ? i.tagName : i.type === "mdxJsxFlowElement" || i.type === "mdxJsxTextElement" ? i.name : void 0;
      if (l) {
        const c = a.get(l) || 0;
        o = l + "-" + c, a.set(l, c + 1);
      }
    }
    const s = qKe(t, i, o);
    s !== void 0 && r.push(s);
  }
  return r;
}
function INt(t, e, r) {
  const n = nNt(t.schema, e);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = n.commaSeparated ? UBt(r) : lNt(r)), n.property === "style") {
      let a = typeof r == "object" ? r : MNt(t, String(r));
      return t.stylePropertyNameCase === "css" && (a = PNt(a)), ["style", a];
    }
    return [
      t.elementAttributeNameCase === "react" && n.space ? oNt[n.property] || n.property : n.attribute,
      r
    ];
  }
}
function MNt(t, e) {
  const r = {};
  try {
    fNt(e, n);
  } catch (a) {
    if (!t.ignoreInvalidStyle) {
      const i = (
        /** @type {Error} */
        a
      ), o = new tu("Cannot parse `style` attribute", {
        ancestors: t.ancestors,
        cause: i,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw o.file = t.filePath || void 0, o.url = UKe + "#cannot-parse-style-attribute", o;
    }
  }
  return r;
  function n(a, i) {
    let o = a;
    o.slice(0, 2) !== "--" && (o.slice(0, 4) === "-ms-" && (o = "ms-" + o.slice(4)), o = o.replace(gNt, ONt)), r[o] = i;
  }
}
function ZKe(t, e, r) {
  let n;
  if (!r)
    n = { type: "Literal", value: e };
  else if (e.includes(".")) {
    const a = e.split(".");
    let i = -1, o;
    for (; ++i < a.length; ) {
      const s = S4e(a[i]) ? { type: "Identifier", name: a[i] } : { type: "Literal", value: a[i] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: s,
        computed: !!(i && s.type === "Literal"),
        optional: !1
      } : s;
    }
    n = o;
  } else
    n = S4e(e) && !/^[a-z]/.test(e) ? { type: "Identifier", name: e } : { type: "Literal", value: e };
  if (n.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      n.value
    );
    return W2e.call(t.components, a) ? t.components[a] : a;
  }
  if (t.evaluater)
    return t.evaluater.evaluateExpression(n);
  _T(t);
}
function _T(t, e) {
  const r = new tu(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: t.ancestors,
      place: e,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = t.filePath || void 0, r.url = UKe + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function PNt(t) {
  const e = {};
  let r;
  for (r in t)
    W2e.call(t, r) && (e[RNt(r)] = t[r]);
  return e;
}
function RNt(t) {
  let e = t.replace(mNt, BNt);
  return e.slice(0, 3) === "ms-" && (e = "-" + e), e;
}
function ONt(t, e) {
  return e.toUpperCase();
}
function BNt(t) {
  return "-" + t.toLowerCase();
}
const d7 = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, NNt = {};
function $Nt(t, e) {
  const r = NNt, n = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return JKe(t, n, a);
}
function JKe(t, e, r) {
  if (DNt(t)) {
    if ("value" in t)
      return t.type === "html" && !r ? "" : t.value;
    if (e && "alt" in t && t.alt)
      return t.alt;
    if ("children" in t)
      return R4e(t.children, e, r);
  }
  return Array.isArray(t) ? R4e(t, e, r) : "";
}
function R4e(t, e, r) {
  const n = [];
  let a = -1;
  for (; ++a < t.length; )
    n[a] = JKe(t[a], e, r);
  return n.join("");
}
function DNt(t) {
  return !!(t && typeof t == "object");
}
const O4e = document.createElement("i");
function V2e(t) {
  const e = "&" + t + ";";
  O4e.innerHTML = e;
  const r = O4e.textContent;
  return r.charCodeAt(r.length - 1) === 59 && t !== "semi" || r === e ? !1 : r;
}
function Lh(t, e, r, n) {
  const a = t.length;
  let i = 0, o;
  if (e < 0 ? e = -e > a ? 0 : a + e : e = e > a ? a : e, r = r > 0 ? r : 0, n.length < 1e4)
    o = Array.from(n), o.unshift(e, r), t.splice(...o);
  else
    for (r && t.splice(e, r); i < n.length; )
      o = n.slice(i, i + 1e4), o.unshift(e, 0), t.splice(...o), i += 1e4, e += 1e4;
}
function U0(t, e) {
  return t.length > 0 ? (Lh(t, t.length, 0, e), t) : e;
}
const B4e = {}.hasOwnProperty;
function LNt(t) {
  const e = {};
  let r = -1;
  for (; ++r < t.length; )
    jNt(e, t[r]);
  return e;
}
function jNt(t, e) {
  let r;
  for (r in e) {
    const a = (B4e.call(t, r) ? t[r] : void 0) || (t[r] = {}), i = e[r];
    let o;
    if (i)
      for (o in i) {
        B4e.call(a, o) || (a[o] = []);
        const s = i[o];
        FNt(
          // @ts-expect-error Looks like a list.
          a[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function FNt(t, e) {
  let r = -1;
  const n = [];
  for (; ++r < e.length; )
    (e[r].add === "after" ? t : n).push(e[r]);
  Lh(t, 0, 0, n);
}
function YKe(t, e) {
  const r = Number.parseInt(t, e);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function f7(t) {
  return t.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const X2 = Iy(/[A-Za-z]/), o0 = Iy(/[\dA-Za-z]/), zNt = Iy(/[#-'*+\--9=?A-Z^-~]/);
function rue(t) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    t !== null && (t < 32 || t === 127)
  );
}
const nue = Iy(/\d/), GNt = Iy(/[\dA-Fa-f]/), WNt = Iy(/[!-/:-@[-`{-~]/);
function Na(t) {
  return t !== null && t < -2;
}
function md(t) {
  return t !== null && (t < 0 || t === 32);
}
function Co(t) {
  return t === -2 || t === -1 || t === 32;
}
const HNt = Iy(new RegExp("\\p{P}|\\p{S}", "u")), UNt = Iy(/\s/);
function Iy(t) {
  return e;
  function e(r) {
    return r !== null && r > -1 && t.test(String.fromCharCode(r));
  }
}
function _8(t) {
  const e = [];
  let r = -1, n = 0, a = 0;
  for (; ++r < t.length; ) {
    const i = t.charCodeAt(r);
    let o = "";
    if (i === 37 && o0(t.charCodeAt(r + 1)) && o0(t.charCodeAt(r + 2)))
      a = 2;
    else if (i < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(i)) || (o = String.fromCharCode(i));
    else if (i > 55295 && i < 57344) {
      const s = t.charCodeAt(r + 1);
      i < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(i, s), a = 1) : o = "�";
    } else
      o = String.fromCharCode(i);
    o && (e.push(t.slice(n, r), encodeURIComponent(o)), n = r + a + 1, o = ""), a && (r += a, a = 0);
  }
  return e.join("") + t.slice(n);
}
function ns(t, e, r, n) {
  const a = n ? n - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return o;
  function o(l) {
    return Co(l) ? (t.enter(r), s(l)) : e(l);
  }
  function s(l) {
    return Co(l) && i++ < a ? (t.consume(l), s) : (t.exit(r), e(l));
  }
}
const VNt = {
  tokenize: qNt
};
function qNt(t) {
  const e = t.attempt(this.parser.constructs.contentInitial, n, a);
  let r;
  return e;
  function n(s) {
    if (s === null) {
      t.consume(s);
      return;
    }
    return t.enter("lineEnding"), t.consume(s), t.exit("lineEnding"), ns(t, e, "linePrefix");
  }
  function a(s) {
    return t.enter("paragraph"), i(s);
  }
  function i(s) {
    const l = t.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = l), r = l, o(s);
  }
  function o(s) {
    if (s === null) {
      t.exit("chunkText"), t.exit("paragraph"), t.consume(s);
      return;
    }
    return Na(s) ? (t.consume(s), t.exit("chunkText"), i) : (t.consume(s), o);
  }
}
const KNt = {
  tokenize: ZNt
}, N4e = {
  tokenize: JNt
};
function ZNt(t) {
  const e = this, r = [];
  let n = 0, a, i, o;
  return s;
  function s(C) {
    if (n < r.length) {
      const x = r[n];
      return e.containerState = x[1], t.attempt(x[0].continuation, l, c)(C);
    }
    return c(C);
  }
  function l(C) {
    if (n++, e.containerState._closeFlow) {
      e.containerState._closeFlow = void 0, a && _();
      const x = e.events.length;
      let S = x, A;
      for (; S--; )
        if (e.events[S][0] === "exit" && e.events[S][1].type === "chunkFlow") {
          A = e.events[S][1].end;
          break;
        }
      w(n);
      let I = x;
      for (; I < e.events.length; )
        e.events[I][1].end = {
          ...A
        }, I++;
      return Lh(e.events, S + 1, 0, e.events.slice(x)), e.events.length = I, c(C);
    }
    return s(C);
  }
  function c(C) {
    if (n === r.length) {
      if (!a)
        return h(C);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return g(C);
      e.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return e.containerState = {}, t.check(N4e, u, f)(C);
  }
  function u(C) {
    return a && _(), w(n), h(C);
  }
  function f(C) {
    return e.parser.lazy[e.now().line] = n !== r.length, o = e.now().offset, g(C);
  }
  function h(C) {
    return e.containerState = {}, t.attempt(N4e, p, g)(C);
  }
  function p(C) {
    return n++, r.push([e.currentConstruct, e.containerState]), h(C);
  }
  function g(C) {
    if (C === null) {
      a && _(), w(0), t.consume(C);
      return;
    }
    return a = a || e.parser.flow(e.now()), t.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: i
    }), y(C);
  }
  function y(C) {
    if (C === null) {
      b(t.exit("chunkFlow"), !0), w(0), t.consume(C);
      return;
    }
    return Na(C) ? (t.consume(C), b(t.exit("chunkFlow")), n = 0, e.interrupt = void 0, s) : (t.consume(C), y);
  }
  function b(C, x) {
    const S = e.sliceStream(C);
    if (x && S.push(null), C.previous = i, i && (i.next = C), i = C, a.defineSkip(C.start), a.write(S), e.parser.lazy[C.start.line]) {
      let A = a.events.length;
      for (; A--; )
        if (
          // The token starts before the line ending…
          a.events[A][1].start.offset < o && // …and either is not ended yet…
          (!a.events[A][1].end || // …or ends after it.
          a.events[A][1].end.offset > o)
        )
          return;
      const I = e.events.length;
      let M = I, B, L;
      for (; M--; )
        if (e.events[M][0] === "exit" && e.events[M][1].type === "chunkFlow") {
          if (B) {
            L = e.events[M][1].end;
            break;
          }
          B = !0;
        }
      for (w(n), A = I; A < e.events.length; )
        e.events[A][1].end = {
          ...L
        }, A++;
      Lh(e.events, M + 1, 0, e.events.slice(I)), e.events.length = A;
    }
  }
  function w(C) {
    let x = r.length;
    for (; x-- > C; ) {
      const S = r[x];
      e.containerState = S[1], S[0].exit.call(e, t);
    }
    r.length = C;
  }
  function _() {
    a.write([null]), i = void 0, a = void 0, e.containerState._closeFlow = void 0;
  }
}
function JNt(t, e, r) {
  return ns(t, t.attempt(this.parser.constructs.document, e, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function $4e(t) {
  if (t === null || md(t) || UNt(t))
    return 1;
  if (HNt(t))
    return 2;
}
function q2e(t, e, r) {
  const n = [];
  let a = -1;
  for (; ++a < t.length; ) {
    const i = t[a].resolveAll;
    i && !n.includes(i) && (e = i(e, r), n.push(i));
  }
  return e;
}
const aue = {
  name: "attention",
  resolveAll: YNt,
  tokenize: XNt
};
function YNt(t, e) {
  let r = -1, n, a, i, o, s, l, c, u;
  for (; ++r < t.length; )
    if (t[r][0] === "enter" && t[r][1].type === "attentionSequence" && t[r][1]._close) {
      for (n = r; n--; )
        if (t[n][0] === "exit" && t[n][1].type === "attentionSequence" && t[n][1]._open && // If the markers are the same:
        e.sliceSerialize(t[n][1]).charCodeAt(0) === e.sliceSerialize(t[r][1]).charCodeAt(0)) {
          if ((t[n][1]._close || t[r][1]._open) && (t[r][1].end.offset - t[r][1].start.offset) % 3 && !((t[n][1].end.offset - t[n][1].start.offset + t[r][1].end.offset - t[r][1].start.offset) % 3))
            continue;
          l = t[n][1].end.offset - t[n][1].start.offset > 1 && t[r][1].end.offset - t[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...t[n][1].end
          }, h = {
            ...t[r][1].start
          };
          D4e(f, -l), D4e(h, l), o = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...t[n][1].end
            }
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...t[r][1].start
            },
            end: h
          }, i = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: {
              ...t[n][1].end
            },
            end: {
              ...t[r][1].start
            }
          }, a = {
            type: l > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...s.end
            }
          }, t[n][1].end = {
            ...o.start
          }, t[r][1].start = {
            ...s.end
          }, c = [], t[n][1].end.offset - t[n][1].start.offset && (c = U0(c, [["enter", t[n][1], e], ["exit", t[n][1], e]])), c = U0(c, [["enter", a, e], ["enter", o, e], ["exit", o, e], ["enter", i, e]]), c = U0(c, q2e(e.parser.constructs.insideSpan.null, t.slice(n + 1, r), e)), c = U0(c, [["exit", i, e], ["enter", s, e], ["exit", s, e], ["exit", a, e]]), t[r][1].end.offset - t[r][1].start.offset ? (u = 2, c = U0(c, [["enter", t[r][1], e], ["exit", t[r][1], e]])) : u = 0, Lh(t, n - 1, r - n + 3, c), r = n + c.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < t.length; )
    t[r][1].type === "attentionSequence" && (t[r][1].type = "data");
  return t;
}
function XNt(t, e) {
  const r = this.parser.constructs.attentionMarkers.null, n = this.previous, a = $4e(n);
  let i;
  return o;
  function o(l) {
    return i = l, t.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === i)
      return t.consume(l), s;
    const c = t.exit("attentionSequence"), u = $4e(l), f = !u || u === 2 && a || r.includes(l), h = !a || a === 2 && u || r.includes(n);
    return c._open = !!(i === 42 ? f : f && (a || !h)), c._close = !!(i === 42 ? h : h && (u || !f)), e(l);
  }
}
function D4e(t, e) {
  t.column += e, t.offset += e, t._bufferIndex += e;
}
const QNt = {
  name: "autolink",
  tokenize: e$t
};
function e$t(t, e, r) {
  let n = 0;
  return a;
  function a(p) {
    return t.enter("autolink"), t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.enter("autolinkProtocol"), i;
  }
  function i(p) {
    return X2(p) ? (t.consume(p), o) : p === 64 ? r(p) : c(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || o0(p) ? (n = 1, s(p)) : c(p);
  }
  function s(p) {
    return p === 58 ? (t.consume(p), n = 0, l) : (p === 43 || p === 45 || p === 46 || o0(p)) && n++ < 32 ? (t.consume(p), s) : (n = 0, c(p));
  }
  function l(p) {
    return p === 62 ? (t.exit("autolinkProtocol"), t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.exit("autolink"), e) : p === null || p === 32 || p === 60 || rue(p) ? r(p) : (t.consume(p), l);
  }
  function c(p) {
    return p === 64 ? (t.consume(p), u) : zNt(p) ? (t.consume(p), c) : r(p);
  }
  function u(p) {
    return o0(p) ? f(p) : r(p);
  }
  function f(p) {
    return p === 46 ? (t.consume(p), n = 0, u) : p === 62 ? (t.exit("autolinkProtocol").type = "autolinkEmail", t.enter("autolinkMarker"), t.consume(p), t.exit("autolinkMarker"), t.exit("autolink"), e) : h(p);
  }
  function h(p) {
    if ((p === 45 || o0(p)) && n++ < 63) {
      const g = p === 45 ? h : f;
      return t.consume(p), g;
    }
    return r(p);
  }
}
const Bz = {
  partial: !0,
  tokenize: t$t
};
function t$t(t, e, r) {
  return n;
  function n(i) {
    return Co(i) ? ns(t, a, "linePrefix")(i) : a(i);
  }
  function a(i) {
    return i === null || Na(i) ? e(i) : r(i);
  }
}
const XKe = {
  continuation: {
    tokenize: n$t
  },
  exit: a$t,
  name: "blockQuote",
  tokenize: r$t
};
function r$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    if (o === 62) {
      const s = n.containerState;
      return s.open || (t.enter("blockQuote", {
        _container: !0
      }), s.open = !0), t.enter("blockQuotePrefix"), t.enter("blockQuoteMarker"), t.consume(o), t.exit("blockQuoteMarker"), i;
    }
    return r(o);
  }
  function i(o) {
    return Co(o) ? (t.enter("blockQuotePrefixWhitespace"), t.consume(o), t.exit("blockQuotePrefixWhitespace"), t.exit("blockQuotePrefix"), e) : (t.exit("blockQuotePrefix"), e(o));
  }
}
function n$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return Co(o) ? ns(t, i, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : i(o);
  }
  function i(o) {
    return t.attempt(XKe, e, r)(o);
  }
}
function a$t(t) {
  t.exit("blockQuote");
}
const QKe = {
  name: "characterEscape",
  tokenize: i$t
};
function i$t(t, e, r) {
  return n;
  function n(i) {
    return t.enter("characterEscape"), t.enter("escapeMarker"), t.consume(i), t.exit("escapeMarker"), a;
  }
  function a(i) {
    return WNt(i) ? (t.enter("characterEscapeValue"), t.consume(i), t.exit("characterEscapeValue"), t.exit("characterEscape"), e) : r(i);
  }
}
const eZe = {
  name: "characterReference",
  tokenize: o$t
};
function o$t(t, e, r) {
  const n = this;
  let a = 0, i, o;
  return s;
  function s(f) {
    return t.enter("characterReference"), t.enter("characterReferenceMarker"), t.consume(f), t.exit("characterReferenceMarker"), l;
  }
  function l(f) {
    return f === 35 ? (t.enter("characterReferenceMarkerNumeric"), t.consume(f), t.exit("characterReferenceMarkerNumeric"), c) : (t.enter("characterReferenceValue"), i = 31, o = o0, u(f));
  }
  function c(f) {
    return f === 88 || f === 120 ? (t.enter("characterReferenceMarkerHexadecimal"), t.consume(f), t.exit("characterReferenceMarkerHexadecimal"), t.enter("characterReferenceValue"), i = 6, o = GNt, u) : (t.enter("characterReferenceValue"), i = 7, o = nue, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = t.exit("characterReferenceValue");
      return o === o0 && !V2e(n.sliceSerialize(h)) ? r(f) : (t.enter("characterReferenceMarker"), t.consume(f), t.exit("characterReferenceMarker"), t.exit("characterReference"), e);
    }
    return o(f) && a++ < i ? (t.consume(f), u) : r(f);
  }
}
const L4e = {
  partial: !0,
  tokenize: l$t
}, j4e = {
  concrete: !0,
  name: "codeFenced",
  tokenize: s$t
};
function s$t(t, e, r) {
  const n = this, a = {
    partial: !0,
    tokenize: S
  };
  let i = 0, o = 0, s;
  return l;
  function l(A) {
    return c(A);
  }
  function c(A) {
    const I = n.events[n.events.length - 1];
    return i = I && I[1].type === "linePrefix" ? I[2].sliceSerialize(I[1], !0).length : 0, s = A, t.enter("codeFenced"), t.enter("codeFencedFence"), t.enter("codeFencedFenceSequence"), u(A);
  }
  function u(A) {
    return A === s ? (o++, t.consume(A), u) : o < 3 ? r(A) : (t.exit("codeFencedFenceSequence"), Co(A) ? ns(t, f, "whitespace")(A) : f(A));
  }
  function f(A) {
    return A === null || Na(A) ? (t.exit("codeFencedFence"), n.interrupt ? e(A) : t.check(L4e, y, x)(A)) : (t.enter("codeFencedFenceInfo"), t.enter("chunkString", {
      contentType: "string"
    }), h(A));
  }
  function h(A) {
    return A === null || Na(A) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), f(A)) : Co(A) ? (t.exit("chunkString"), t.exit("codeFencedFenceInfo"), ns(t, p, "whitespace")(A)) : A === 96 && A === s ? r(A) : (t.consume(A), h);
  }
  function p(A) {
    return A === null || Na(A) ? f(A) : (t.enter("codeFencedFenceMeta"), t.enter("chunkString", {
      contentType: "string"
    }), g(A));
  }
  function g(A) {
    return A === null || Na(A) ? (t.exit("chunkString"), t.exit("codeFencedFenceMeta"), f(A)) : A === 96 && A === s ? r(A) : (t.consume(A), g);
  }
  function y(A) {
    return t.attempt(a, x, b)(A);
  }
  function b(A) {
    return t.enter("lineEnding"), t.consume(A), t.exit("lineEnding"), w;
  }
  function w(A) {
    return i > 0 && Co(A) ? ns(t, _, "linePrefix", i + 1)(A) : _(A);
  }
  function _(A) {
    return A === null || Na(A) ? t.check(L4e, y, x)(A) : (t.enter("codeFlowValue"), C(A));
  }
  function C(A) {
    return A === null || Na(A) ? (t.exit("codeFlowValue"), _(A)) : (t.consume(A), C);
  }
  function x(A) {
    return t.exit("codeFenced"), e(A);
  }
  function S(A, I, M) {
    let B = 0;
    return L;
    function L(k) {
      return A.enter("lineEnding"), A.consume(k), A.exit("lineEnding"), N;
    }
    function N(k) {
      return A.enter("codeFencedFence"), Co(k) ? ns(A, d, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(k) : d(k);
    }
    function d(k) {
      return k === s ? (A.enter("codeFencedFenceSequence"), m(k)) : M(k);
    }
    function m(k) {
      return k === s ? (B++, A.consume(k), m) : B >= o ? (A.exit("codeFencedFenceSequence"), Co(k) ? ns(A, v, "whitespace")(k) : v(k)) : M(k);
    }
    function v(k) {
      return k === null || Na(k) ? (A.exit("codeFencedFence"), I(k)) : M(k);
    }
  }
}
function l$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return o === null ? r(o) : (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), i);
  }
  function i(o) {
    return n.parser.lazy[n.now().line] ? r(o) : e(o);
  }
}
const GK = {
  name: "codeIndented",
  tokenize: u$t
}, c$t = {
  partial: !0,
  tokenize: d$t
};
function u$t(t, e, r) {
  const n = this;
  return a;
  function a(c) {
    return t.enter("codeIndented"), ns(t, i, "linePrefix", 5)(c);
  }
  function i(c) {
    const u = n.events[n.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(c) : r(c);
  }
  function o(c) {
    return c === null ? l(c) : Na(c) ? t.attempt(c$t, o, l)(c) : (t.enter("codeFlowValue"), s(c));
  }
  function s(c) {
    return c === null || Na(c) ? (t.exit("codeFlowValue"), o(c)) : (t.consume(c), s);
  }
  function l(c) {
    return t.exit("codeIndented"), e(c);
  }
}
function d$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return n.parser.lazy[n.now().line] ? r(o) : Na(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), a) : ns(t, i, "linePrefix", 5)(o);
  }
  function i(o) {
    const s = n.events[n.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(o) : Na(o) ? a(o) : r(o);
  }
}
const f$t = {
  name: "codeText",
  previous: p$t,
  resolve: h$t,
  tokenize: m$t
};
function h$t(t) {
  let e = t.length - 4, r = 3, n, a;
  if ((t[r][1].type === "lineEnding" || t[r][1].type === "space") && (t[e][1].type === "lineEnding" || t[e][1].type === "space")) {
    for (n = r; ++n < e; )
      if (t[n][1].type === "codeTextData") {
        t[r][1].type = "codeTextPadding", t[e][1].type = "codeTextPadding", r += 2, e -= 2;
        break;
      }
  }
  for (n = r - 1, e++; ++n <= e; )
    a === void 0 ? n !== e && t[n][1].type !== "lineEnding" && (a = n) : (n === e || t[n][1].type === "lineEnding") && (t[a][1].type = "codeTextData", n !== a + 2 && (t[a][1].end = t[n - 1][1].end, t.splice(a + 2, n - a - 2), e -= n - a - 2, n = a + 2), a = void 0);
  return t;
}
function p$t(t) {
  return t !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function m$t(t, e, r) {
  let n = 0, a, i;
  return o;
  function o(f) {
    return t.enter("codeText"), t.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (t.consume(f), n++, s) : (t.exit("codeTextSequence"), l(f));
  }
  function l(f) {
    return f === null ? r(f) : f === 32 ? (t.enter("space"), t.consume(f), t.exit("space"), l) : f === 96 ? (i = t.enter("codeTextSequence"), a = 0, u(f)) : Na(f) ? (t.enter("lineEnding"), t.consume(f), t.exit("lineEnding"), l) : (t.enter("codeTextData"), c(f));
  }
  function c(f) {
    return f === null || f === 32 || f === 96 || Na(f) ? (t.exit("codeTextData"), l(f)) : (t.consume(f), c);
  }
  function u(f) {
    return f === 96 ? (t.consume(f), a++, u) : a === n ? (t.exit("codeTextSequence"), t.exit("codeText"), e(f)) : (i.type = "codeTextData", c(f));
  }
}
class g$t {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(e) {
    this.left = e ? [...e] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(e) {
    if (e < 0 || e >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + e + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return e < this.left.length ? this.left[e] : this.right[this.right.length - e + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(e, r) {
    const n = r ?? Number.POSITIVE_INFINITY;
    return n < this.left.length ? this.left.slice(e, n) : e > this.left.length ? this.right.slice(this.right.length - n + this.left.length, this.right.length - e + this.left.length).reverse() : this.left.slice(e).concat(this.right.slice(this.right.length - n + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(e, r, n) {
    const a = r || 0;
    this.setCursor(Math.trunc(e));
    const i = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return n && Hw(this.left, n), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(e) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(e);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(e) {
    this.setCursor(Number.POSITIVE_INFINITY), Hw(this.left, e);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(e) {
    this.setCursor(0), this.right.push(e);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(e) {
    this.setCursor(0), Hw(this.right, e.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(e) {
    if (!(e === this.left.length || e > this.left.length && this.right.length === 0 || e < 0 && this.left.length === 0))
      if (e < this.left.length) {
        const r = this.left.splice(e, Number.POSITIVE_INFINITY);
        Hw(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - e, Number.POSITIVE_INFINITY);
        Hw(this.left, r.reverse());
      }
  }
}
function Hw(t, e) {
  let r = 0;
  if (e.length < 1e4)
    t.push(...e);
  else
    for (; r < e.length; )
      t.push(...e.slice(r, r + 1e4)), r += 1e4;
}
function tZe(t) {
  const e = {};
  let r = -1, n, a, i, o, s, l, c;
  const u = new g$t(t);
  for (; ++r < u.length; ) {
    for (; r in e; )
      r = e[r];
    if (n = u.get(r), r && n[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (l = n[1]._tokenizer.events, i = 0, i < l.length && l[i][1].type === "lineEndingBlank" && (i += 2), i < l.length && l[i][1].type === "content"))
      for (; ++i < l.length && l[i][1].type !== "content"; )
        l[i][1].type === "chunkText" && (l[i][1]._isInFirstContentOfListItem = !0, i++);
    if (n[0] === "enter")
      n[1].contentType && (Object.assign(e, v$t(u, r)), r = e[r], c = !0);
    else if (n[1]._container) {
      for (i = r, a = void 0; i-- && (o = u.get(i), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", a = i);
      a && (n[1].end = {
        ...u.get(a)[1].start
      }, s = u.slice(a, r), s.unshift(n), u.splice(a, r - a + 1, s));
    }
  }
  return Lh(t, 0, Number.POSITIVE_INFINITY, u.slice(0)), !c;
}
function v$t(t, e) {
  const r = t.get(e)[1], n = t.get(e)[2];
  let a = e - 1;
  const i = [], o = r._tokenizer || n.parser[r.contentType](r.start), s = o.events, l = [], c = {};
  let u, f, h = -1, p = r, g = 0, y = 0;
  const b = [y];
  for (; p; ) {
    for (; t.get(++a)[1] !== p; )
      ;
    i.push(a), p._tokenizer || (u = n.sliceStream(p), p.next || u.push(null), f && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = r; ++h < s.length; )
    // Find a void token that includes a break.
    s[h][0] === "exit" && s[h - 1][0] === "enter" && s[h][1].type === s[h - 1][1].type && s[h][1].start.line !== s[h][1].end.line && (y = h + 1, b.push(y), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : b.pop(), h = b.length; h--; ) {
    const w = s.slice(b[h], b[h + 1]), _ = i.pop();
    l.push([_, _ + w.length - 1]), t.splice(_, 2, w);
  }
  for (l.reverse(), h = -1; ++h < l.length; )
    c[g + l[h][0]] = g + l[h][1], g += l[h][1] - l[h][0] - 1;
  return c;
}
const y$t = {
  resolve: x$t,
  tokenize: C$t
}, b$t = {
  partial: !0,
  tokenize: w$t
};
function x$t(t) {
  return tZe(t), t;
}
function C$t(t, e) {
  let r;
  return n;
  function n(s) {
    return t.enter("content"), r = t.enter("chunkContent", {
      contentType: "content"
    }), a(s);
  }
  function a(s) {
    return s === null ? i(s) : Na(s) ? t.check(b$t, o, i)(s) : (t.consume(s), a);
  }
  function i(s) {
    return t.exit("chunkContent"), t.exit("content"), e(s);
  }
  function o(s) {
    return t.consume(s), t.exit("chunkContent"), r.next = t.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function w$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return t.exit("chunkContent"), t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), ns(t, i, "linePrefix");
  }
  function i(o) {
    if (o === null || Na(o))
      return r(o);
    const s = n.events[n.events.length - 1];
    return !n.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? e(o) : t.interrupt(n.parser.constructs.flow, r, e)(o);
  }
}
function rZe(t, e, r, n, a, i, o, s, l) {
  const c = l || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(w) {
    return w === 60 ? (t.enter(n), t.enter(a), t.enter(i), t.consume(w), t.exit(i), h) : w === null || w === 32 || w === 41 || rue(w) ? r(w) : (t.enter(n), t.enter(o), t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), y(w));
  }
  function h(w) {
    return w === 62 ? (t.enter(i), t.consume(w), t.exit(i), t.exit(a), t.exit(n), e) : (t.enter(s), t.enter("chunkString", {
      contentType: "string"
    }), p(w));
  }
  function p(w) {
    return w === 62 ? (t.exit("chunkString"), t.exit(s), h(w)) : w === null || w === 60 || Na(w) ? r(w) : (t.consume(w), w === 92 ? g : p);
  }
  function g(w) {
    return w === 60 || w === 62 || w === 92 ? (t.consume(w), p) : p(w);
  }
  function y(w) {
    return !u && (w === null || w === 41 || md(w)) ? (t.exit("chunkString"), t.exit(s), t.exit(o), t.exit(n), e(w)) : u < c && w === 40 ? (t.consume(w), u++, y) : w === 41 ? (t.consume(w), u--, y) : w === null || w === 32 || w === 40 || rue(w) ? r(w) : (t.consume(w), w === 92 ? b : y);
  }
  function b(w) {
    return w === 40 || w === 41 || w === 92 ? (t.consume(w), y) : y(w);
  }
}
function nZe(t, e, r, n, a, i) {
  const o = this;
  let s = 0, l;
  return c;
  function c(p) {
    return t.enter(n), t.enter(a), t.consume(p), t.exit(a), t.enter(i), u;
  }
  function u(p) {
    return s > 999 || p === null || p === 91 || p === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? r(p) : p === 93 ? (t.exit(i), t.enter(a), t.consume(p), t.exit(a), t.exit(n), e) : Na(p) ? (t.enter("lineEnding"), t.consume(p), t.exit("lineEnding"), u) : (t.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || Na(p) || s++ > 999 ? (t.exit("chunkString"), u(p)) : (t.consume(p), l || (l = !Co(p)), p === 92 ? h : f);
  }
  function h(p) {
    return p === 91 || p === 92 || p === 93 ? (t.consume(p), s++, f) : f(p);
  }
}
function aZe(t, e, r, n, a, i) {
  let o;
  return s;
  function s(h) {
    return h === 34 || h === 39 || h === 40 ? (t.enter(n), t.enter(a), t.consume(h), t.exit(a), o = h === 40 ? 41 : h, l) : r(h);
  }
  function l(h) {
    return h === o ? (t.enter(a), t.consume(h), t.exit(a), t.exit(n), e) : (t.enter(i), c(h));
  }
  function c(h) {
    return h === o ? (t.exit(i), l(o)) : h === null ? r(h) : Na(h) ? (t.enter("lineEnding"), t.consume(h), t.exit("lineEnding"), ns(t, c, "linePrefix")) : (t.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === o || h === null || Na(h) ? (t.exit("chunkString"), c(h)) : (t.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === o || h === 92 ? (t.consume(h), u) : u(h);
  }
}
function T_(t, e) {
  let r;
  return n;
  function n(a) {
    return Na(a) ? (t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), r = !0, n) : Co(a) ? ns(t, n, r ? "linePrefix" : "lineSuffix")(a) : e(a);
  }
}
const S$t = {
  name: "definition",
  tokenize: k$t
}, _$t = {
  partial: !0,
  tokenize: A$t
};
function k$t(t, e, r) {
  const n = this;
  let a;
  return i;
  function i(p) {
    return t.enter("definition"), o(p);
  }
  function o(p) {
    return nZe.call(
      n,
      t,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function s(p) {
    return a = f7(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), p === 58 ? (t.enter("definitionMarker"), t.consume(p), t.exit("definitionMarker"), l) : r(p);
  }
  function l(p) {
    return md(p) ? T_(t, c)(p) : c(p);
  }
  function c(p) {
    return rZe(
      t,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function u(p) {
    return t.attempt(_$t, f, f)(p);
  }
  function f(p) {
    return Co(p) ? ns(t, h, "whitespace")(p) : h(p);
  }
  function h(p) {
    return p === null || Na(p) ? (t.exit("definition"), n.parser.defined.push(a), e(p)) : r(p);
  }
}
function A$t(t, e, r) {
  return n;
  function n(s) {
    return md(s) ? T_(t, a)(s) : r(s);
  }
  function a(s) {
    return aZe(t, i, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function i(s) {
    return Co(s) ? ns(t, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || Na(s) ? e(s) : r(s);
  }
}
const T$t = {
  name: "hardBreakEscape",
  tokenize: E$t
};
function E$t(t, e, r) {
  return n;
  function n(i) {
    return t.enter("hardBreakEscape"), t.consume(i), a;
  }
  function a(i) {
    return Na(i) ? (t.exit("hardBreakEscape"), e(i)) : r(i);
  }
}
const I$t = {
  name: "headingAtx",
  resolve: M$t,
  tokenize: P$t
};
function M$t(t, e) {
  let r = t.length - 2, n = 3, a, i;
  return t[n][1].type === "whitespace" && (n += 2), r - 2 > n && t[r][1].type === "whitespace" && (r -= 2), t[r][1].type === "atxHeadingSequence" && (n === r - 1 || r - 4 > n && t[r - 2][1].type === "whitespace") && (r -= n + 1 === r ? 2 : 4), r > n && (a = {
    type: "atxHeadingText",
    start: t[n][1].start,
    end: t[r][1].end
  }, i = {
    type: "chunkText",
    start: t[n][1].start,
    end: t[r][1].end,
    contentType: "text"
  }, Lh(t, n, r - n + 1, [["enter", a, e], ["enter", i, e], ["exit", i, e], ["exit", a, e]])), t;
}
function P$t(t, e, r) {
  let n = 0;
  return a;
  function a(u) {
    return t.enter("atxHeading"), i(u);
  }
  function i(u) {
    return t.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && n++ < 6 ? (t.consume(u), o) : u === null || md(u) ? (t.exit("atxHeadingSequence"), s(u)) : r(u);
  }
  function s(u) {
    return u === 35 ? (t.enter("atxHeadingSequence"), l(u)) : u === null || Na(u) ? (t.exit("atxHeading"), e(u)) : Co(u) ? ns(t, s, "whitespace")(u) : (t.enter("atxHeadingText"), c(u));
  }
  function l(u) {
    return u === 35 ? (t.consume(u), l) : (t.exit("atxHeadingSequence"), s(u));
  }
  function c(u) {
    return u === null || u === 35 || md(u) ? (t.exit("atxHeadingText"), s(u)) : (t.consume(u), c);
  }
}
const R$t = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], F4e = ["pre", "script", "style", "textarea"], O$t = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: $$t,
  tokenize: D$t
}, B$t = {
  partial: !0,
  tokenize: j$t
}, N$t = {
  partial: !0,
  tokenize: L$t
};
function $$t(t) {
  let e = t.length;
  for (; e-- && !(t[e][0] === "enter" && t[e][1].type === "htmlFlow"); )
    ;
  return e > 1 && t[e - 2][1].type === "linePrefix" && (t[e][1].start = t[e - 2][1].start, t[e + 1][1].start = t[e - 2][1].start, t.splice(e - 2, 2)), t;
}
function D$t(t, e, r) {
  const n = this;
  let a, i, o, s, l;
  return c;
  function c(U) {
    return u(U);
  }
  function u(U) {
    return t.enter("htmlFlow"), t.enter("htmlFlowData"), t.consume(U), f;
  }
  function f(U) {
    return U === 33 ? (t.consume(U), h) : U === 47 ? (t.consume(U), i = !0, y) : U === 63 ? (t.consume(U), a = 3, n.interrupt ? e : F) : X2(U) ? (t.consume(U), o = String.fromCharCode(U), b) : r(U);
  }
  function h(U) {
    return U === 45 ? (t.consume(U), a = 2, p) : U === 91 ? (t.consume(U), a = 5, s = 0, g) : X2(U) ? (t.consume(U), a = 4, n.interrupt ? e : F) : r(U);
  }
  function p(U) {
    return U === 45 ? (t.consume(U), n.interrupt ? e : F) : r(U);
  }
  function g(U) {
    const Z = "CDATA[";
    return U === Z.charCodeAt(s++) ? (t.consume(U), s === Z.length ? n.interrupt ? e : d : g) : r(U);
  }
  function y(U) {
    return X2(U) ? (t.consume(U), o = String.fromCharCode(U), b) : r(U);
  }
  function b(U) {
    if (U === null || U === 47 || U === 62 || md(U)) {
      const Z = U === 47, V = o.toLowerCase();
      return !Z && !i && F4e.includes(V) ? (a = 1, n.interrupt ? e(U) : d(U)) : R$t.includes(o.toLowerCase()) ? (a = 6, Z ? (t.consume(U), w) : n.interrupt ? e(U) : d(U)) : (a = 7, n.interrupt && !n.parser.lazy[n.now().line] ? r(U) : i ? _(U) : C(U));
    }
    return U === 45 || o0(U) ? (t.consume(U), o += String.fromCharCode(U), b) : r(U);
  }
  function w(U) {
    return U === 62 ? (t.consume(U), n.interrupt ? e : d) : r(U);
  }
  function _(U) {
    return Co(U) ? (t.consume(U), _) : L(U);
  }
  function C(U) {
    return U === 47 ? (t.consume(U), L) : U === 58 || U === 95 || X2(U) ? (t.consume(U), x) : Co(U) ? (t.consume(U), C) : L(U);
  }
  function x(U) {
    return U === 45 || U === 46 || U === 58 || U === 95 || o0(U) ? (t.consume(U), x) : S(U);
  }
  function S(U) {
    return U === 61 ? (t.consume(U), A) : Co(U) ? (t.consume(U), S) : C(U);
  }
  function A(U) {
    return U === null || U === 60 || U === 61 || U === 62 || U === 96 ? r(U) : U === 34 || U === 39 ? (t.consume(U), l = U, I) : Co(U) ? (t.consume(U), A) : M(U);
  }
  function I(U) {
    return U === l ? (t.consume(U), l = null, B) : U === null || Na(U) ? r(U) : (t.consume(U), I);
  }
  function M(U) {
    return U === null || U === 34 || U === 39 || U === 47 || U === 60 || U === 61 || U === 62 || U === 96 || md(U) ? S(U) : (t.consume(U), M);
  }
  function B(U) {
    return U === 47 || U === 62 || Co(U) ? C(U) : r(U);
  }
  function L(U) {
    return U === 62 ? (t.consume(U), N) : r(U);
  }
  function N(U) {
    return U === null || Na(U) ? d(U) : Co(U) ? (t.consume(U), N) : r(U);
  }
  function d(U) {
    return U === 45 && a === 2 ? (t.consume(U), O) : U === 60 && a === 1 ? (t.consume(U), G) : U === 62 && a === 4 ? (t.consume(U), z) : U === 63 && a === 3 ? (t.consume(U), F) : U === 93 && a === 5 ? (t.consume(U), j) : Na(U) && (a === 6 || a === 7) ? (t.exit("htmlFlowData"), t.check(B$t, W, m)(U)) : U === null || Na(U) ? (t.exit("htmlFlowData"), m(U)) : (t.consume(U), d);
  }
  function m(U) {
    return t.check(N$t, v, W)(U);
  }
  function v(U) {
    return t.enter("lineEnding"), t.consume(U), t.exit("lineEnding"), k;
  }
  function k(U) {
    return U === null || Na(U) ? m(U) : (t.enter("htmlFlowData"), d(U));
  }
  function O(U) {
    return U === 45 ? (t.consume(U), F) : d(U);
  }
  function G(U) {
    return U === 47 ? (t.consume(U), o = "", H) : d(U);
  }
  function H(U) {
    if (U === 62) {
      const Z = o.toLowerCase();
      return F4e.includes(Z) ? (t.consume(U), z) : d(U);
    }
    return X2(U) && o.length < 8 ? (t.consume(U), o += String.fromCharCode(U), H) : d(U);
  }
  function j(U) {
    return U === 93 ? (t.consume(U), F) : d(U);
  }
  function F(U) {
    return U === 62 ? (t.consume(U), z) : U === 45 && a === 2 ? (t.consume(U), F) : d(U);
  }
  function z(U) {
    return U === null || Na(U) ? (t.exit("htmlFlowData"), W(U)) : (t.consume(U), z);
  }
  function W(U) {
    return t.exit("htmlFlow"), e(U);
  }
}
function L$t(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return Na(o) ? (t.enter("lineEnding"), t.consume(o), t.exit("lineEnding"), i) : r(o);
  }
  function i(o) {
    return n.parser.lazy[n.now().line] ? r(o) : e(o);
  }
}
function j$t(t, e, r) {
  return n;
  function n(a) {
    return t.enter("lineEnding"), t.consume(a), t.exit("lineEnding"), t.attempt(Bz, e, r);
  }
}
const F$t = {
  name: "htmlText",
  tokenize: z$t
};
function z$t(t, e, r) {
  const n = this;
  let a, i, o;
  return s;
  function s(F) {
    return t.enter("htmlText"), t.enter("htmlTextData"), t.consume(F), l;
  }
  function l(F) {
    return F === 33 ? (t.consume(F), c) : F === 47 ? (t.consume(F), S) : F === 63 ? (t.consume(F), C) : X2(F) ? (t.consume(F), M) : r(F);
  }
  function c(F) {
    return F === 45 ? (t.consume(F), u) : F === 91 ? (t.consume(F), i = 0, g) : X2(F) ? (t.consume(F), _) : r(F);
  }
  function u(F) {
    return F === 45 ? (t.consume(F), p) : r(F);
  }
  function f(F) {
    return F === null ? r(F) : F === 45 ? (t.consume(F), h) : Na(F) ? (o = f, G(F)) : (t.consume(F), f);
  }
  function h(F) {
    return F === 45 ? (t.consume(F), p) : f(F);
  }
  function p(F) {
    return F === 62 ? O(F) : F === 45 ? h(F) : f(F);
  }
  function g(F) {
    const z = "CDATA[";
    return F === z.charCodeAt(i++) ? (t.consume(F), i === z.length ? y : g) : r(F);
  }
  function y(F) {
    return F === null ? r(F) : F === 93 ? (t.consume(F), b) : Na(F) ? (o = y, G(F)) : (t.consume(F), y);
  }
  function b(F) {
    return F === 93 ? (t.consume(F), w) : y(F);
  }
  function w(F) {
    return F === 62 ? O(F) : F === 93 ? (t.consume(F), w) : y(F);
  }
  function _(F) {
    return F === null || F === 62 ? O(F) : Na(F) ? (o = _, G(F)) : (t.consume(F), _);
  }
  function C(F) {
    return F === null ? r(F) : F === 63 ? (t.consume(F), x) : Na(F) ? (o = C, G(F)) : (t.consume(F), C);
  }
  function x(F) {
    return F === 62 ? O(F) : C(F);
  }
  function S(F) {
    return X2(F) ? (t.consume(F), A) : r(F);
  }
  function A(F) {
    return F === 45 || o0(F) ? (t.consume(F), A) : I(F);
  }
  function I(F) {
    return Na(F) ? (o = I, G(F)) : Co(F) ? (t.consume(F), I) : O(F);
  }
  function M(F) {
    return F === 45 || o0(F) ? (t.consume(F), M) : F === 47 || F === 62 || md(F) ? B(F) : r(F);
  }
  function B(F) {
    return F === 47 ? (t.consume(F), O) : F === 58 || F === 95 || X2(F) ? (t.consume(F), L) : Na(F) ? (o = B, G(F)) : Co(F) ? (t.consume(F), B) : O(F);
  }
  function L(F) {
    return F === 45 || F === 46 || F === 58 || F === 95 || o0(F) ? (t.consume(F), L) : N(F);
  }
  function N(F) {
    return F === 61 ? (t.consume(F), d) : Na(F) ? (o = N, G(F)) : Co(F) ? (t.consume(F), N) : B(F);
  }
  function d(F) {
    return F === null || F === 60 || F === 61 || F === 62 || F === 96 ? r(F) : F === 34 || F === 39 ? (t.consume(F), a = F, m) : Na(F) ? (o = d, G(F)) : Co(F) ? (t.consume(F), d) : (t.consume(F), v);
  }
  function m(F) {
    return F === a ? (t.consume(F), a = void 0, k) : F === null ? r(F) : Na(F) ? (o = m, G(F)) : (t.consume(F), m);
  }
  function v(F) {
    return F === null || F === 34 || F === 39 || F === 60 || F === 61 || F === 96 ? r(F) : F === 47 || F === 62 || md(F) ? B(F) : (t.consume(F), v);
  }
  function k(F) {
    return F === 47 || F === 62 || md(F) ? B(F) : r(F);
  }
  function O(F) {
    return F === 62 ? (t.consume(F), t.exit("htmlTextData"), t.exit("htmlText"), e) : r(F);
  }
  function G(F) {
    return t.exit("htmlTextData"), t.enter("lineEnding"), t.consume(F), t.exit("lineEnding"), H;
  }
  function H(F) {
    return Co(F) ? ns(t, j, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(F) : j(F);
  }
  function j(F) {
    return t.enter("htmlTextData"), o(F);
  }
}
const K2e = {
  name: "labelEnd",
  resolveAll: U$t,
  resolveTo: V$t,
  tokenize: q$t
}, G$t = {
  tokenize: K$t
}, W$t = {
  tokenize: Z$t
}, H$t = {
  tokenize: J$t
};
function U$t(t) {
  let e = -1;
  const r = [];
  for (; ++e < t.length; ) {
    const n = t[e][1];
    if (r.push(t[e]), n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") {
      const a = n.type === "labelImage" ? 4 : 2;
      n.type = "data", e += a;
    }
  }
  return t.length !== r.length && Lh(t, 0, t.length, r), t;
}
function V$t(t, e) {
  let r = t.length, n = 0, a, i, o, s;
  for (; r--; )
    if (a = t[r][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      t[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (o) {
      if (t[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = r, a.type !== "labelLink")) {
        n = 2;
        break;
      }
    } else a.type === "labelEnd" && (o = r);
  const l = {
    type: t[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...t[i][1].start
    },
    end: {
      ...t[t.length - 1][1].end
    }
  }, c = {
    type: "label",
    start: {
      ...t[i][1].start
    },
    end: {
      ...t[o][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...t[i + n + 2][1].end
    },
    end: {
      ...t[o - 2][1].start
    }
  };
  return s = [["enter", l, e], ["enter", c, e]], s = U0(s, t.slice(i + 1, i + n + 3)), s = U0(s, [["enter", u, e]]), s = U0(s, q2e(e.parser.constructs.insideSpan.null, t.slice(i + n + 4, o - 3), e)), s = U0(s, [["exit", u, e], t[o - 2], t[o - 1], ["exit", c, e]]), s = U0(s, t.slice(o + 1)), s = U0(s, [["exit", l, e]]), Lh(t, i, t.length, s), t;
}
function q$t(t, e, r) {
  const n = this;
  let a = n.events.length, i, o;
  for (; a--; )
    if ((n.events[a][1].type === "labelImage" || n.events[a][1].type === "labelLink") && !n.events[a][1]._balanced) {
      i = n.events[a][1];
      break;
    }
  return s;
  function s(h) {
    return i ? i._inactive ? f(h) : (o = n.parser.defined.includes(f7(n.sliceSerialize({
      start: i.end,
      end: n.now()
    }))), t.enter("labelEnd"), t.enter("labelMarker"), t.consume(h), t.exit("labelMarker"), t.exit("labelEnd"), l) : r(h);
  }
  function l(h) {
    return h === 40 ? t.attempt(G$t, u, o ? u : f)(h) : h === 91 ? t.attempt(W$t, u, o ? c : f)(h) : o ? u(h) : f(h);
  }
  function c(h) {
    return t.attempt(H$t, u, f)(h);
  }
  function u(h) {
    return e(h);
  }
  function f(h) {
    return i._balanced = !0, r(h);
  }
}
function K$t(t, e, r) {
  return n;
  function n(f) {
    return t.enter("resource"), t.enter("resourceMarker"), t.consume(f), t.exit("resourceMarker"), a;
  }
  function a(f) {
    return md(f) ? T_(t, i)(f) : i(f);
  }
  function i(f) {
    return f === 41 ? u(f) : rZe(t, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return md(f) ? T_(t, l)(f) : u(f);
  }
  function s(f) {
    return r(f);
  }
  function l(f) {
    return f === 34 || f === 39 || f === 40 ? aZe(t, c, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function c(f) {
    return md(f) ? T_(t, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (t.enter("resourceMarker"), t.consume(f), t.exit("resourceMarker"), t.exit("resource"), e) : r(f);
  }
}
function Z$t(t, e, r) {
  const n = this;
  return a;
  function a(s) {
    return nZe.call(n, t, i, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function i(s) {
    return n.parser.defined.includes(f7(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? e(s) : r(s);
  }
  function o(s) {
    return r(s);
  }
}
function J$t(t, e, r) {
  return n;
  function n(i) {
    return t.enter("reference"), t.enter("referenceMarker"), t.consume(i), t.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (t.enter("referenceMarker"), t.consume(i), t.exit("referenceMarker"), t.exit("reference"), e) : r(i);
  }
}
const Y$t = {
  name: "labelStartImage",
  resolveAll: K2e.resolveAll,
  tokenize: X$t
};
function X$t(t, e, r) {
  const n = this;
  return a;
  function a(s) {
    return t.enter("labelImage"), t.enter("labelImageMarker"), t.consume(s), t.exit("labelImageMarker"), i;
  }
  function i(s) {
    return s === 91 ? (t.enter("labelMarker"), t.consume(s), t.exit("labelMarker"), t.exit("labelImage"), o) : r(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(s) : e(s);
  }
}
const Q$t = {
  name: "labelStartLink",
  resolveAll: K2e.resolveAll,
  tokenize: eDt
};
function eDt(t, e, r) {
  const n = this;
  return a;
  function a(o) {
    return t.enter("labelLink"), t.enter("labelMarker"), t.consume(o), t.exit("labelMarker"), t.exit("labelLink"), i;
  }
  function i(o) {
    return o === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? r(o) : e(o);
  }
}
const WK = {
  name: "lineEnding",
  tokenize: tDt
};
function tDt(t, e) {
  return r;
  function r(n) {
    return t.enter("lineEnding"), t.consume(n), t.exit("lineEnding"), ns(t, e, "linePrefix");
  }
}
const t$ = {
  name: "thematicBreak",
  tokenize: rDt
};
function rDt(t, e, r) {
  let n = 0, a;
  return i;
  function i(c) {
    return t.enter("thematicBreak"), o(c);
  }
  function o(c) {
    return a = c, s(c);
  }
  function s(c) {
    return c === a ? (t.enter("thematicBreakSequence"), l(c)) : n >= 3 && (c === null || Na(c)) ? (t.exit("thematicBreak"), e(c)) : r(c);
  }
  function l(c) {
    return c === a ? (t.consume(c), n++, l) : (t.exit("thematicBreakSequence"), Co(c) ? ns(t, s, "whitespace")(c) : s(c));
  }
}
const sd = {
  continuation: {
    tokenize: oDt
  },
  exit: lDt,
  name: "list",
  tokenize: iDt
}, nDt = {
  partial: !0,
  tokenize: cDt
}, aDt = {
  partial: !0,
  tokenize: sDt
};
function iDt(t, e, r) {
  const n = this, a = n.events[n.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, o = 0;
  return s;
  function s(p) {
    const g = n.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !n.containerState.marker || p === n.containerState.marker : nue(p)) {
      if (n.containerState.type || (n.containerState.type = g, t.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return t.enter("listItemPrefix"), p === 42 || p === 45 ? t.check(t$, r, c)(p) : c(p);
      if (!n.interrupt || p === 49)
        return t.enter("listItemPrefix"), t.enter("listItemValue"), l(p);
    }
    return r(p);
  }
  function l(p) {
    return nue(p) && ++o < 10 ? (t.consume(p), l) : (!n.interrupt || o < 2) && (n.containerState.marker ? p === n.containerState.marker : p === 41 || p === 46) ? (t.exit("listItemValue"), c(p)) : r(p);
  }
  function c(p) {
    return t.enter("listItemMarker"), t.consume(p), t.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || p, t.check(
      Bz,
      // Can’t be empty when interrupting.
      n.interrupt ? r : u,
      t.attempt(nDt, h, f)
    );
  }
  function u(p) {
    return n.containerState.initialBlankLine = !0, i++, h(p);
  }
  function f(p) {
    return Co(p) ? (t.enter("listItemPrefixWhitespace"), t.consume(p), t.exit("listItemPrefixWhitespace"), h) : r(p);
  }
  function h(p) {
    return n.containerState.size = i + n.sliceSerialize(t.exit("listItemPrefix"), !0).length, e(p);
  }
}
function oDt(t, e, r) {
  const n = this;
  return n.containerState._closeFlow = void 0, t.check(Bz, a, i);
  function a(s) {
    return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, ns(t, e, "listItemIndent", n.containerState.size + 1)(s);
  }
  function i(s) {
    return n.containerState.furtherBlankLines || !Co(s) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, o(s)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, t.attempt(aDt, e, o)(s));
  }
  function o(s) {
    return n.containerState._closeFlow = !0, n.interrupt = void 0, ns(t, t.attempt(sd, e, r), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function sDt(t, e, r) {
  const n = this;
  return ns(t, a, "listItemIndent", n.containerState.size + 1);
  function a(i) {
    const o = n.events[n.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === n.containerState.size ? e(i) : r(i);
  }
}
function lDt(t) {
  t.exit(this.containerState.type);
}
function cDt(t, e, r) {
  const n = this;
  return ns(t, a, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(i) {
    const o = n.events[n.events.length - 1];
    return !Co(i) && o && o[1].type === "listItemPrefixWhitespace" ? e(i) : r(i);
  }
}
const z4e = {
  name: "setextUnderline",
  resolveTo: uDt,
  tokenize: dDt
};
function uDt(t, e) {
  let r = t.length, n, a, i;
  for (; r--; )
    if (t[r][0] === "enter") {
      if (t[r][1].type === "content") {
        n = r;
        break;
      }
      t[r][1].type === "paragraph" && (a = r);
    } else
      t[r][1].type === "content" && t.splice(r, 1), !i && t[r][1].type === "definition" && (i = r);
  const o = {
    type: "setextHeading",
    start: {
      ...t[a][1].start
    },
    end: {
      ...t[t.length - 1][1].end
    }
  };
  return t[a][1].type = "setextHeadingText", i ? (t.splice(a, 0, ["enter", o, e]), t.splice(i + 1, 0, ["exit", t[n][1], e]), t[n][1].end = {
    ...t[i][1].end
  }) : t[n][1] = o, t.push(["exit", o, e]), t;
}
function dDt(t, e, r) {
  const n = this;
  let a;
  return i;
  function i(c) {
    let u = n.events.length, f;
    for (; u--; )
      if (n.events[u][1].type !== "lineEnding" && n.events[u][1].type !== "linePrefix" && n.events[u][1].type !== "content") {
        f = n.events[u][1].type === "paragraph";
        break;
      }
    return !n.parser.lazy[n.now().line] && (n.interrupt || f) ? (t.enter("setextHeadingLine"), a = c, o(c)) : r(c);
  }
  function o(c) {
    return t.enter("setextHeadingLineSequence"), s(c);
  }
  function s(c) {
    return c === a ? (t.consume(c), s) : (t.exit("setextHeadingLineSequence"), Co(c) ? ns(t, l, "lineSuffix")(c) : l(c));
  }
  function l(c) {
    return c === null || Na(c) ? (t.exit("setextHeadingLine"), e(c)) : r(c);
  }
}
const fDt = {
  tokenize: hDt
};
function hDt(t) {
  const e = this, r = t.attempt(
    // Try to parse a blank line.
    Bz,
    n,
    // Try to parse initial flow (essentially, only code).
    t.attempt(this.parser.constructs.flowInitial, a, ns(t, t.attempt(this.parser.constructs.flow, a, t.attempt(y$t, a)), "linePrefix"))
  );
  return r;
  function n(i) {
    if (i === null) {
      t.consume(i);
      return;
    }
    return t.enter("lineEndingBlank"), t.consume(i), t.exit("lineEndingBlank"), e.currentConstruct = void 0, r;
  }
  function a(i) {
    if (i === null) {
      t.consume(i);
      return;
    }
    return t.enter("lineEnding"), t.consume(i), t.exit("lineEnding"), e.currentConstruct = void 0, r;
  }
}
const pDt = {
  resolveAll: oZe()
}, mDt = iZe("string"), gDt = iZe("text");
function iZe(t) {
  return {
    resolveAll: oZe(t === "text" ? vDt : void 0),
    tokenize: e
  };
  function e(r) {
    const n = this, a = this.parser.constructs[t], i = r.attempt(a, o, s);
    return o;
    function o(u) {
      return c(u) ? i(u) : s(u);
    }
    function s(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), l;
    }
    function l(u) {
      return c(u) ? (r.exit("data"), i(u)) : (r.consume(u), l);
    }
    function c(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const p = f[h];
          if (!p.previous || p.previous.call(n, n.previous))
            return !0;
        }
      return !1;
    }
  }
}
function oZe(t) {
  return e;
  function e(r, n) {
    let a = -1, i;
    for (; ++a <= r.length; )
      i === void 0 ? r[a] && r[a][1].type === "data" && (i = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== i + 2 && (r[i][1].end = r[a - 1][1].end, r.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    return t ? t(r, n) : r;
  }
}
function vDt(t, e) {
  let r = 0;
  for (; ++r <= t.length; )
    if ((r === t.length || t[r][1].type === "lineEnding") && t[r - 1][1].type === "data") {
      const n = t[r - 1][1], a = e.sliceStream(n);
      let i = a.length, o = -1, s = 0, l;
      for (; i--; ) {
        const c = a[i];
        if (typeof c == "string") {
          for (o = c.length; c.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (c === -2)
          l = !0, s++;
        else if (c !== -1) {
          i++;
          break;
        }
      }
      if (s) {
        const c = {
          type: r === t.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? o : n.start._bufferIndex + o,
            _index: n.start._index + i,
            line: n.end.line,
            column: n.end.column - s,
            offset: n.end.offset - s
          },
          end: {
            ...n.end
          }
        };
        n.end = {
          ...c.start
        }, n.start.offset === n.end.offset ? Object.assign(n, c) : (t.splice(r, 0, ["enter", c, e], ["exit", c, e]), r += 2);
      }
      r++;
    }
  return t;
}
const yDt = {
  42: sd,
  43: sd,
  45: sd,
  48: sd,
  49: sd,
  50: sd,
  51: sd,
  52: sd,
  53: sd,
  54: sd,
  55: sd,
  56: sd,
  57: sd,
  62: XKe
}, bDt = {
  91: S$t
}, xDt = {
  [-2]: GK,
  [-1]: GK,
  32: GK
}, CDt = {
  35: I$t,
  42: t$,
  45: [z4e, t$],
  60: O$t,
  61: z4e,
  95: t$,
  96: j4e,
  126: j4e
}, wDt = {
  38: eZe,
  92: QKe
}, SDt = {
  [-5]: WK,
  [-4]: WK,
  [-3]: WK,
  33: Y$t,
  38: eZe,
  42: aue,
  60: [QNt, F$t],
  91: Q$t,
  92: [T$t, QKe],
  93: K2e,
  95: aue,
  96: f$t
}, _Dt = {
  null: [aue, pDt]
}, kDt = {
  null: [42, 95]
}, ADt = {
  null: []
}, TDt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: kDt,
  contentInitial: bDt,
  disable: ADt,
  document: yDt,
  flow: CDt,
  flowInitial: xDt,
  insideSpan: _Dt,
  string: wDt,
  text: SDt
}, Symbol.toStringTag, { value: "Module" }));
function EDt(t, e, r) {
  let n = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, i = [];
  let o = [], s = [];
  const l = {
    attempt: I(S),
    check: I(A),
    consume: _,
    enter: C,
    exit: x,
    interrupt: I(A, {
      interrupt: !0
    })
  }, c = {
    code: null,
    containerState: {},
    defineSkip: y,
    events: [],
    now: g,
    parser: t,
    previous: null,
    sliceSerialize: h,
    sliceStream: p,
    write: f
  };
  let u = e.tokenize.call(c, l);
  return e.resolveAll && i.push(e), c;
  function f(N) {
    return o = U0(o, N), b(), o[o.length - 1] !== null ? [] : (M(e, 0), c.events = q2e(i, c.events, c), c.events);
  }
  function h(N, d) {
    return MDt(p(N), d);
  }
  function p(N) {
    return IDt(o, N);
  }
  function g() {
    const {
      _bufferIndex: N,
      _index: d,
      line: m,
      column: v,
      offset: k
    } = n;
    return {
      _bufferIndex: N,
      _index: d,
      line: m,
      column: v,
      offset: k
    };
  }
  function y(N) {
    a[N.line] = N.column, L();
  }
  function b() {
    let N;
    for (; n._index < o.length; ) {
      const d = o[n._index];
      if (typeof d == "string")
        for (N = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === N && n._bufferIndex < d.length; )
          w(d.charCodeAt(n._bufferIndex));
      else
        w(d);
    }
  }
  function w(N) {
    u = u(N);
  }
  function _(N) {
    Na(N) ? (n.line++, n.column = 1, n.offset += N === -3 ? 2 : 1, L()) : N !== -1 && (n.column++, n.offset++), n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[n._index].length && (n._bufferIndex = -1, n._index++)), c.previous = N;
  }
  function C(N, d) {
    const m = d || {};
    return m.type = N, m.start = g(), c.events.push(["enter", m, c]), s.push(m), m;
  }
  function x(N) {
    const d = s.pop();
    return d.end = g(), c.events.push(["exit", d, c]), d;
  }
  function S(N, d) {
    M(N, d.from);
  }
  function A(N, d) {
    d.restore();
  }
  function I(N, d) {
    return m;
    function m(v, k, O) {
      let G, H, j, F;
      return Array.isArray(v) ? (
        /* c8 ignore next 1 */
        W(v)
      ) : "tokenize" in v ? (
        // Looks like a construct.
        W([
          /** @type {Construct} */
          v
        ])
      ) : z(v);
      function z(Y) {
        return ge;
        function ge(ce) {
          const ee = ce !== null && Y[ce], Se = ce !== null && Y.null, Ce = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ee) ? ee : ee ? [ee] : [],
            ...Array.isArray(Se) ? Se : Se ? [Se] : []
          ];
          return W(Ce)(ce);
        }
      }
      function W(Y) {
        return G = Y, H = 0, Y.length === 0 ? O : U(Y[H]);
      }
      function U(Y) {
        return ge;
        function ge(ce) {
          return F = B(), j = Y, Y.partial || (c.currentConstruct = Y), Y.name && c.parser.constructs.disable.null.includes(Y.name) ? V() : Y.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            d ? Object.assign(Object.create(c), d) : c,
            l,
            Z,
            V
          )(ce);
        }
      }
      function Z(Y) {
        return N(j, F), k;
      }
      function V(Y) {
        return F.restore(), ++H < G.length ? U(G[H]) : O;
      }
    }
  }
  function M(N, d) {
    N.resolveAll && !i.includes(N) && i.push(N), N.resolve && Lh(c.events, d, c.events.length - d, N.resolve(c.events.slice(d), c)), N.resolveTo && (c.events = N.resolveTo(c.events, c));
  }
  function B() {
    const N = g(), d = c.previous, m = c.currentConstruct, v = c.events.length, k = Array.from(s);
    return {
      from: v,
      restore: O
    };
    function O() {
      n = N, c.previous = d, c.currentConstruct = m, c.events.length = v, s = k, L();
    }
  }
  function L() {
    n.line in a && n.column < 2 && (n.column = a[n.line], n.offset += a[n.line] - 1);
  }
}
function IDt(t, e) {
  const r = e.start._index, n = e.start._bufferIndex, a = e.end._index, i = e.end._bufferIndex;
  let o;
  if (r === a)
    o = [t[r].slice(n, i)];
  else {
    if (o = t.slice(r, a), n > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(n) : o.shift();
    }
    i > 0 && o.push(t[a].slice(0, i));
  }
  return o;
}
function MDt(t, e) {
  let r = -1;
  const n = [];
  let a;
  for (; ++r < t.length; ) {
    const i = t[r];
    let o;
    if (typeof i == "string")
      o = i;
    else switch (i) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = e ? " " : "	";
        break;
      }
      case -1: {
        if (!e && a) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(i);
    }
    a = i === -2, n.push(o);
  }
  return n.join("");
}
function PDt(t) {
  const n = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      LNt([TDt, ...(t || {}).extensions || []])
    ),
    content: a(VNt),
    defined: [],
    document: a(KNt),
    flow: a(fDt),
    lazy: {},
    string: a(mDt),
    text: a(gDt)
  };
  return n;
  function a(i) {
    return o;
    function o(s) {
      return EDt(n, i, s);
    }
  }
}
function RDt(t) {
  for (; !tZe(t); )
    ;
  return t;
}
const G4e = /[\0\t\n\r]/g;
function ODt() {
  let t = 1, e = "", r = !0, n;
  return a;
  function a(i, o, s) {
    const l = [];
    let c, u, f, h, p;
    for (i = e + (typeof i == "string" ? i.toString() : new TextDecoder(o || void 0).decode(i)), f = 0, e = "", r && (i.charCodeAt(0) === 65279 && f++, r = void 0); f < i.length; ) {
      if (G4e.lastIndex = f, c = G4e.exec(i), h = c && c.index !== void 0 ? c.index : i.length, p = i.charCodeAt(h), !c) {
        e = i.slice(f);
        break;
      }
      if (p === 10 && f === h && n)
        l.push(-3), n = void 0;
      else
        switch (n && (l.push(-5), n = void 0), f < h && (l.push(i.slice(f, h)), t += h - f), p) {
          case 0: {
            l.push(65533), t++;
            break;
          }
          case 9: {
            for (u = Math.ceil(t / 4) * 4, l.push(-2); t++ < u; ) l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), t = 1;
            break;
          }
          default:
            n = !0, t = 1;
        }
      f = h + 1;
    }
    return s && (n && l.push(-5), e && l.push(e), l.push(null)), l;
  }
}
const BDt = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function NDt(t) {
  return t.replace(BDt, $Dt);
}
function $Dt(t, e, r) {
  if (e)
    return e;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), i = a === 120 || a === 88;
    return YKe(r.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return V2e(r) || t;
}
const sZe = {}.hasOwnProperty;
function DDt(t, e, r) {
  return typeof e != "string" && (r = e, e = void 0), LDt(r)(RDt(PDt(r).document().write(ODt()(t, e, !0))));
}
function LDt(t) {
  const e = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(ze),
      autolinkProtocol: B,
      autolinkEmail: B,
      atxHeading: i(it),
      blockQuote: i(Se),
      characterEscape: B,
      characterReference: B,
      codeFenced: i(Ce),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: i(Ce, o),
      codeText: i(we, o),
      codeTextData: B,
      data: B,
      codeFlowValue: B,
      definition: i(We),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: i(Fe),
      hardBreakEscape: i(gt),
      hardBreakTrailing: i(gt),
      htmlFlow: i(Ze, o),
      htmlFlowData: B,
      htmlText: i(Ze, o),
      htmlTextData: B,
      image: i(Ne),
      label: o,
      link: i(ze),
      listItem: i(rt),
      listItemValue: h,
      listOrdered: i(ct, f),
      listUnordered: i(ct),
      paragraph: i(qe),
      reference: U,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: i(it),
      strong: i(nt),
      thematicBreak: i(Ot)
    },
    exit: {
      atxHeading: l(),
      atxHeadingSequence: S,
      autolink: l(),
      autolinkEmail: ee,
      autolinkProtocol: ce,
      blockQuote: l(),
      characterEscapeValue: L,
      characterReferenceMarkerHexadecimal: V,
      characterReferenceMarkerNumeric: V,
      characterReferenceValue: Y,
      characterReference: ge,
      codeFenced: l(b),
      codeFencedFence: y,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: g,
      codeFlowValue: L,
      codeIndented: l(w),
      codeText: l(k),
      codeTextData: L,
      data: L,
      definition: l(),
      definitionDestinationString: x,
      definitionLabelString: _,
      definitionTitleString: C,
      emphasis: l(),
      hardBreakEscape: l(d),
      hardBreakTrailing: l(d),
      htmlFlow: l(m),
      htmlFlowData: L,
      htmlText: l(v),
      htmlTextData: L,
      image: l(G),
      label: j,
      labelText: H,
      lineEnding: N,
      link: l(O),
      listItem: l(),
      listOrdered: l(),
      listUnordered: l(),
      paragraph: l(),
      referenceString: Z,
      resourceDestinationString: F,
      resourceTitleString: z,
      resource: W,
      setextHeading: l(M),
      setextHeadingLineSequence: I,
      setextHeadingText: A,
      strong: l(),
      thematicBreak: l()
    }
  };
  lZe(e, (t || {}).mdastExtensions || []);
  const r = {};
  return n;
  function n(lt) {
    let mt = {
      type: "root",
      children: []
    };
    const jt = {
      stack: [mt],
      tokenStack: [],
      config: e,
      enter: s,
      exit: c,
      buffer: o,
      resume: u,
      data: r
    }, Jt = [];
    let ne = -1;
    for (; ++ne < lt.length; )
      if (lt[ne][1].type === "listOrdered" || lt[ne][1].type === "listUnordered")
        if (lt[ne][0] === "enter")
          Jt.push(ne);
        else {
          const re = Jt.pop();
          ne = a(lt, re, ne);
        }
    for (ne = -1; ++ne < lt.length; ) {
      const re = e[lt[ne][0]];
      sZe.call(re, lt[ne][1].type) && re[lt[ne][1].type].call(Object.assign({
        sliceSerialize: lt[ne][2].sliceSerialize
      }, jt), lt[ne][1]);
    }
    if (jt.tokenStack.length > 0) {
      const re = jt.tokenStack[jt.tokenStack.length - 1];
      (re[1] || W4e).call(jt, void 0, re[0]);
    }
    for (mt.position = {
      start: qg(lt.length > 0 ? lt[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: qg(lt.length > 0 ? lt[lt.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, ne = -1; ++ne < e.transforms.length; )
      mt = e.transforms[ne](mt) || mt;
    return mt;
  }
  function a(lt, mt, jt) {
    let Jt = mt - 1, ne = -1, re = !1, ie, Ie, Ke, Le;
    for (; ++Jt <= jt; ) {
      const Ge = lt[Jt];
      switch (Ge[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          Ge[0] === "enter" ? ne++ : ne--, Le = void 0;
          break;
        }
        case "lineEndingBlank": {
          Ge[0] === "enter" && (ie && !Le && !ne && !Ke && (Ke = Jt), Le = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Le = void 0;
      }
      if (!ne && Ge[0] === "enter" && Ge[1].type === "listItemPrefix" || ne === -1 && Ge[0] === "exit" && (Ge[1].type === "listUnordered" || Ge[1].type === "listOrdered")) {
        if (ie) {
          let ft = Jt;
          for (Ie = void 0; ft--; ) {
            const ot = lt[ft];
            if (ot[1].type === "lineEnding" || ot[1].type === "lineEndingBlank") {
              if (ot[0] === "exit") continue;
              Ie && (lt[Ie][1].type = "lineEndingBlank", re = !0), ot[1].type = "lineEnding", Ie = ft;
            } else if (!(ot[1].type === "linePrefix" || ot[1].type === "blockQuotePrefix" || ot[1].type === "blockQuotePrefixWhitespace" || ot[1].type === "blockQuoteMarker" || ot[1].type === "listItemIndent")) break;
          }
          Ke && (!Ie || Ke < Ie) && (ie._spread = !0), ie.end = Object.assign({}, Ie ? lt[Ie][1].start : Ge[1].end), lt.splice(Ie || Jt, 0, ["exit", ie, Ge[2]]), Jt++, jt++;
        }
        if (Ge[1].type === "listItemPrefix") {
          const ft = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, Ge[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          ie = ft, lt.splice(Jt, 0, ["enter", ft, Ge[2]]), Jt++, jt++, Ke = void 0, Le = !0;
        }
      }
    }
    return lt[mt][1]._spread = re, jt;
  }
  function i(lt, mt) {
    return jt;
    function jt(Jt) {
      s.call(this, lt(Jt), Jt), mt && mt.call(this, Jt);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(lt, mt, jt) {
    this.stack[this.stack.length - 1].children.push(lt), this.stack.push(lt), this.tokenStack.push([mt, jt || void 0]), lt.position = {
      start: qg(mt.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function l(lt) {
    return mt;
    function mt(jt) {
      lt && lt.call(this, jt), c.call(this, jt);
    }
  }
  function c(lt, mt) {
    const jt = this.stack.pop(), Jt = this.tokenStack.pop();
    if (Jt)
      Jt[0].type !== lt.type && (mt ? mt.call(this, lt, Jt[0]) : (Jt[1] || W4e).call(this, lt, Jt[0]));
    else throw new Error("Cannot close `" + lt.type + "` (" + A_({
      start: lt.start,
      end: lt.end
    }) + "): it’s not open");
    jt.position.end = qg(lt.end);
  }
  function u() {
    return $Nt(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(lt) {
    if (this.data.expectingFirstListItemValue) {
      const mt = this.stack[this.stack.length - 2];
      mt.start = Number.parseInt(this.sliceSerialize(lt), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.lang = lt;
  }
  function g() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.meta = lt;
  }
  function y() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function b() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.value = lt.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.value = lt.replace(/(\r?\n|\r)$/g, "");
  }
  function _(lt) {
    const mt = this.resume(), jt = this.stack[this.stack.length - 1];
    jt.label = mt, jt.identifier = f7(this.sliceSerialize(lt)).toLowerCase();
  }
  function C() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.title = lt;
  }
  function x() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.url = lt;
  }
  function S(lt) {
    const mt = this.stack[this.stack.length - 1];
    if (!mt.depth) {
      const jt = this.sliceSerialize(lt).length;
      mt.depth = jt;
    }
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function I(lt) {
    const mt = this.stack[this.stack.length - 1];
    mt.depth = this.sliceSerialize(lt).codePointAt(0) === 61 ? 1 : 2;
  }
  function M() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function B(lt) {
    const jt = this.stack[this.stack.length - 1].children;
    let Jt = jt[jt.length - 1];
    (!Jt || Jt.type !== "text") && (Jt = Rt(), Jt.position = {
      start: qg(lt.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, jt.push(Jt)), this.stack.push(Jt);
  }
  function L(lt) {
    const mt = this.stack.pop();
    mt.value += this.sliceSerialize(lt), mt.position.end = qg(lt.end);
  }
  function N(lt) {
    const mt = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const jt = mt.children[mt.children.length - 1];
      jt.position.end = qg(lt.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && e.canContainEols.includes(mt.type) && (B.call(this, lt), L.call(this, lt));
  }
  function d() {
    this.data.atHardBreak = !0;
  }
  function m() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.value = lt;
  }
  function v() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.value = lt;
  }
  function k() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.value = lt;
  }
  function O() {
    const lt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const mt = this.data.referenceType || "shortcut";
      lt.type += "Reference", lt.referenceType = mt, delete lt.url, delete lt.title;
    } else
      delete lt.identifier, delete lt.label;
    this.data.referenceType = void 0;
  }
  function G() {
    const lt = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const mt = this.data.referenceType || "shortcut";
      lt.type += "Reference", lt.referenceType = mt, delete lt.url, delete lt.title;
    } else
      delete lt.identifier, delete lt.label;
    this.data.referenceType = void 0;
  }
  function H(lt) {
    const mt = this.sliceSerialize(lt), jt = this.stack[this.stack.length - 2];
    jt.label = NDt(mt), jt.identifier = f7(mt).toLowerCase();
  }
  function j() {
    const lt = this.stack[this.stack.length - 1], mt = this.resume(), jt = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, jt.type === "link") {
      const Jt = lt.children;
      jt.children = Jt;
    } else
      jt.alt = mt;
  }
  function F() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.url = lt;
  }
  function z() {
    const lt = this.resume(), mt = this.stack[this.stack.length - 1];
    mt.title = lt;
  }
  function W() {
    this.data.inReference = void 0;
  }
  function U() {
    this.data.referenceType = "collapsed";
  }
  function Z(lt) {
    const mt = this.resume(), jt = this.stack[this.stack.length - 1];
    jt.label = mt, jt.identifier = f7(this.sliceSerialize(lt)).toLowerCase(), this.data.referenceType = "full";
  }
  function V(lt) {
    this.data.characterReferenceType = lt.type;
  }
  function Y(lt) {
    const mt = this.sliceSerialize(lt), jt = this.data.characterReferenceType;
    let Jt;
    jt ? (Jt = YKe(mt, jt === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Jt = V2e(mt);
    const ne = this.stack[this.stack.length - 1];
    ne.value += Jt;
  }
  function ge(lt) {
    const mt = this.stack.pop();
    mt.position.end = qg(lt.end);
  }
  function ce(lt) {
    L.call(this, lt);
    const mt = this.stack[this.stack.length - 1];
    mt.url = this.sliceSerialize(lt);
  }
  function ee(lt) {
    L.call(this, lt);
    const mt = this.stack[this.stack.length - 1];
    mt.url = "mailto:" + this.sliceSerialize(lt);
  }
  function Se() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Ce() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function we() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Fe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function it() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function gt() {
    return {
      type: "break"
    };
  }
  function Ze() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ne() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function ze() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ct(lt) {
    return {
      type: "list",
      ordered: lt.type === "listOrdered",
      start: null,
      spread: lt._spread,
      children: []
    };
  }
  function rt(lt) {
    return {
      type: "listItem",
      spread: lt._spread,
      checked: null,
      children: []
    };
  }
  function qe() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function nt() {
    return {
      type: "strong",
      children: []
    };
  }
  function Rt() {
    return {
      type: "text",
      value: ""
    };
  }
  function Ot() {
    return {
      type: "thematicBreak"
    };
  }
}
function qg(t) {
  return {
    line: t.line,
    column: t.column,
    offset: t.offset
  };
}
function lZe(t, e) {
  let r = -1;
  for (; ++r < e.length; ) {
    const n = e[r];
    Array.isArray(n) ? lZe(t, n) : jDt(t, n);
  }
}
function jDt(t, e) {
  let r;
  for (r in e)
    if (sZe.call(e, r))
      switch (r) {
        case "canContainEols": {
          const n = e[r];
          n && t[r].push(...n);
          break;
        }
        case "transforms": {
          const n = e[r];
          n && t[r].push(...n);
          break;
        }
        case "enter":
        case "exit": {
          const n = e[r];
          n && Object.assign(t[r], n);
          break;
        }
      }
}
function W4e(t, e) {
  throw t ? new Error("Cannot close `" + t.type + "` (" + A_({
    start: t.start,
    end: t.end
  }) + "): a different token (`" + e.type + "`, " + A_({
    start: e.start,
    end: e.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + e.type + "`, " + A_({
    start: e.start,
    end: e.end
  }) + ") is still open");
}
function cZe(t) {
  const e = this;
  e.parser = r;
  function r(n) {
    return DDt(n, {
      ...e.data("settings"),
      ...t,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: e.data("micromarkExtensions") || [],
      mdastExtensions: e.data("fromMarkdownExtensions") || []
    });
  }
}
function FDt(t, e) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: t.wrap(t.all(e), !0)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function zDt(t, e) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return t.patch(e, r), [t.applyData(e, r), { type: "text", value: `
` }];
}
function GDt(t, e) {
  const r = e.value ? e.value + `
` : "", n = {};
  e.lang && (n.className = ["language-" + e.lang]);
  let a = {
    type: "element",
    tagName: "code",
    properties: n,
    children: [{ type: "text", value: r }]
  };
  return e.meta && (a.data = { meta: e.meta }), t.patch(e, a), a = t.applyData(e, a), a = { type: "element", tagName: "pre", properties: {}, children: [a] }, t.patch(e, a), a;
}
function WDt(t, e) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function HDt(t, e) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function UDt(t, e) {
  const r = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", n = String(e.identifier).toUpperCase(), a = _8(n.toLowerCase()), i = t.footnoteOrder.indexOf(n);
  let o, s = t.footnoteCounts.get(n);
  s === void 0 ? (s = 0, t.footnoteOrder.push(n), o = t.footnoteOrder.length) : o = i + 1, s += 1, t.footnoteCounts.set(n, s);
  const l = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  t.patch(e, l);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [l]
  };
  return t.patch(e, c), t.applyData(e, c);
}
function VDt(t, e) {
  const r = {
    type: "element",
    tagName: "h" + e.depth,
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function qDt(t, e) {
  if (t.options.allowDangerousHtml) {
    const r = { type: "raw", value: e.value };
    return t.patch(e, r), t.applyData(e, r);
  }
}
function uZe(t, e) {
  const r = e.referenceType;
  let n = "]";
  if (r === "collapsed" ? n += "[]" : r === "full" && (n += "[" + (e.label || e.identifier) + "]"), e.type === "imageReference")
    return [{ type: "text", value: "![" + e.alt + n }];
  const a = t.all(e), i = a[0];
  i && i.type === "text" ? i.value = "[" + i.value : a.unshift({ type: "text", value: "[" });
  const o = a[a.length - 1];
  return o && o.type === "text" ? o.value += n : a.push({ type: "text", value: n }), a;
}
function KDt(t, e) {
  const r = String(e.identifier).toUpperCase(), n = t.definitionById.get(r);
  if (!n)
    return uZe(t, e);
  const a = { src: _8(n.url || ""), alt: e.alt };
  n.title !== null && n.title !== void 0 && (a.title = n.title);
  const i = { type: "element", tagName: "img", properties: a, children: [] };
  return t.patch(e, i), t.applyData(e, i);
}
function ZDt(t, e) {
  const r = { src: _8(e.url) };
  e.alt !== null && e.alt !== void 0 && (r.alt = e.alt), e.title !== null && e.title !== void 0 && (r.title = e.title);
  const n = { type: "element", tagName: "img", properties: r, children: [] };
  return t.patch(e, n), t.applyData(e, n);
}
function JDt(t, e) {
  const r = { type: "text", value: e.value.replace(/\r?\n|\r/g, " ") };
  t.patch(e, r);
  const n = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return t.patch(e, n), t.applyData(e, n);
}
function YDt(t, e) {
  const r = String(e.identifier).toUpperCase(), n = t.definitionById.get(r);
  if (!n)
    return uZe(t, e);
  const a = { href: _8(n.url || "") };
  n.title !== null && n.title !== void 0 && (a.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: a,
    children: t.all(e)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function XDt(t, e) {
  const r = { href: _8(e.url) };
  e.title !== null && e.title !== void 0 && (r.title = e.title);
  const n = {
    type: "element",
    tagName: "a",
    properties: r,
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function QDt(t, e, r) {
  const n = t.all(e), a = r ? eLt(r) : dZe(e), i = {}, o = [];
  if (typeof e.checked == "boolean") {
    const u = n[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, n.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: e.checked, disabled: !0 },
      children: []
    }), i.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < n.length; ) {
    const u = n[s];
    (a || s !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? o.push(...u.children) : o.push(u);
  }
  const l = n[n.length - 1];
  l && (a || l.type !== "element" || l.tagName !== "p") && o.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: i, children: o };
  return t.patch(e, c), t.applyData(e, c);
}
function eLt(t) {
  let e = !1;
  if (t.type === "list") {
    e = t.spread || !1;
    const r = t.children;
    let n = -1;
    for (; !e && ++n < r.length; )
      e = dZe(r[n]);
  }
  return e;
}
function dZe(t) {
  const e = t.spread;
  return e ?? t.children.length > 1;
}
function tLt(t, e) {
  const r = {}, n = t.all(e);
  let a = -1;
  for (typeof e.start == "number" && e.start !== 1 && (r.start = e.start); ++a < n.length; ) {
    const o = n[a];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const i = {
    type: "element",
    tagName: e.ordered ? "ol" : "ul",
    properties: r,
    children: t.wrap(n, !0)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function rLt(t, e) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function nLt(t, e) {
  const r = { type: "root", children: t.wrap(t.all(e)) };
  return t.patch(e, r), t.applyData(e, r);
}
function aLt(t, e) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
function iLt(t, e) {
  const r = t.all(e), n = r.shift(), a = [];
  if (n) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: t.wrap([n], !0)
    };
    t.patch(e.children[0], o), a.push(o);
  }
  if (r.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: t.wrap(r, !0)
    }, s = G2e(e.children[1]), l = WKe(e.children[e.children.length - 1]);
    s && l && (o.position = { start: s, end: l }), a.push(o);
  }
  const i = {
    type: "element",
    tagName: "table",
    properties: {},
    children: t.wrap(a, !0)
  };
  return t.patch(e, i), t.applyData(e, i);
}
function oLt(t, e, r) {
  const n = r ? r.children : void 0, i = (n ? n.indexOf(e) : 1) === 0 ? "th" : "td", o = r && r.type === "table" ? r.align : void 0, s = o ? o.length : e.children.length;
  let l = -1;
  const c = [];
  for (; ++l < s; ) {
    const f = e.children[l], h = {}, p = o ? o[l] : void 0;
    p && (h.align = p);
    let g = { type: "element", tagName: i, properties: h, children: [] };
    f && (g.children = t.all(f), t.patch(f, g), g = t.applyData(f, g)), c.push(g);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: t.wrap(c, !0)
  };
  return t.patch(e, u), t.applyData(e, u);
}
function sLt(t, e) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, r), t.applyData(e, r);
}
const H4e = 9, U4e = 32;
function lLt(t) {
  const e = String(t), r = /\r?\n|\r/g;
  let n = r.exec(e), a = 0;
  const i = [];
  for (; n; )
    i.push(
      V4e(e.slice(a, n.index), a > 0, !0),
      n[0]
    ), a = n.index + n[0].length, n = r.exec(e);
  return i.push(V4e(e.slice(a), a > 0, !1)), i.join("");
}
function V4e(t, e, r) {
  let n = 0, a = t.length;
  if (e) {
    let i = t.codePointAt(n);
    for (; i === H4e || i === U4e; )
      n++, i = t.codePointAt(n);
  }
  if (r) {
    let i = t.codePointAt(a - 1);
    for (; i === H4e || i === U4e; )
      a--, i = t.codePointAt(a - 1);
  }
  return a > n ? t.slice(n, a) : "";
}
function cLt(t, e) {
  const r = { type: "text", value: lLt(String(e.value)) };
  return t.patch(e, r), t.applyData(e, r);
}
function uLt(t, e) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return t.patch(e, r), t.applyData(e, r);
}
const dLt = {
  blockquote: FDt,
  break: zDt,
  code: GDt,
  delete: WDt,
  emphasis: HDt,
  footnoteReference: UDt,
  heading: VDt,
  html: qDt,
  imageReference: KDt,
  image: ZDt,
  inlineCode: JDt,
  linkReference: YDt,
  link: XDt,
  listItem: QDt,
  list: tLt,
  paragraph: rLt,
  // @ts-expect-error: root is different, but hard to type.
  root: nLt,
  strong: aLt,
  table: iLt,
  tableCell: sLt,
  tableRow: oLt,
  text: cLt,
  thematicBreak: uLt,
  toml: nB,
  yaml: nB,
  definition: nB,
  footnoteDefinition: nB
};
function nB() {
}
const fZe = -1, Nz = 0, hL = 1, pL = 2, Z2e = 3, J2e = 4, Y2e = 5, X2e = 6, hZe = 7, pZe = 8, q4e = typeof self == "object" ? self : globalThis, fLt = (t, e) => {
  const r = (a, i) => (t.set(i, a), a), n = (a) => {
    if (t.has(a))
      return t.get(a);
    const [i, o] = e[a];
    switch (i) {
      case Nz:
      case fZe:
        return r(o, a);
      case hL: {
        const s = r([], a);
        for (const l of o)
          s.push(n(l));
        return s;
      }
      case pL: {
        const s = r({}, a);
        for (const [l, c] of o)
          s[n(l)] = n(c);
        return s;
      }
      case Z2e:
        return r(new Date(o), a);
      case J2e: {
        const { source: s, flags: l } = o;
        return r(new RegExp(s, l), a);
      }
      case Y2e: {
        const s = r(/* @__PURE__ */ new Map(), a);
        for (const [l, c] of o)
          s.set(n(l), n(c));
        return s;
      }
      case X2e: {
        const s = r(/* @__PURE__ */ new Set(), a);
        for (const l of o)
          s.add(n(l));
        return s;
      }
      case hZe: {
        const { name: s, message: l } = o;
        return r(new q4e[s](l), a);
      }
      case pZe:
        return r(BigInt(o), a);
      case "BigInt":
        return r(Object(BigInt(o)), a);
    }
    return r(new q4e[i](o), a);
  };
  return n;
}, K4e = (t) => fLt(/* @__PURE__ */ new Map(), t)(0), z4 = "", { toString: hLt } = {}, { keys: pLt } = Object, Uw = (t) => {
  const e = typeof t;
  if (e !== "object" || !t)
    return [Nz, e];
  const r = hLt.call(t).slice(8, -1);
  switch (r) {
    case "Array":
      return [hL, z4];
    case "Object":
      return [pL, z4];
    case "Date":
      return [Z2e, z4];
    case "RegExp":
      return [J2e, z4];
    case "Map":
      return [Y2e, z4];
    case "Set":
      return [X2e, z4];
  }
  return r.includes("Array") ? [hL, r] : r.includes("Error") ? [hZe, r] : [pL, r];
}, aB = ([t, e]) => t === Nz && (e === "function" || e === "symbol"), mLt = (t, e, r, n) => {
  const a = (o, s) => {
    const l = n.push(o) - 1;
    return r.set(s, l), l;
  }, i = (o) => {
    if (r.has(o))
      return r.get(o);
    let [s, l] = Uw(o);
    switch (s) {
      case Nz: {
        let u = o;
        switch (l) {
          case "bigint":
            s = pZe, u = o.toString();
            break;
          case "function":
          case "symbol":
            if (t)
              throw new TypeError("unable to serialize " + l);
            u = null;
            break;
          case "undefined":
            return a([fZe], o);
        }
        return a([s, u], o);
      }
      case hL: {
        if (l)
          return a([l, [...o]], o);
        const u = [], f = a([s, u], o);
        for (const h of o)
          u.push(i(h));
        return f;
      }
      case pL: {
        if (l)
          switch (l) {
            case "BigInt":
              return a([l, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return a([l, o.valueOf()], o);
          }
        if (e && "toJSON" in o)
          return i(o.toJSON());
        const u = [], f = a([s, u], o);
        for (const h of pLt(o))
          (t || !aB(Uw(o[h]))) && u.push([i(h), i(o[h])]);
        return f;
      }
      case Z2e:
        return a([s, o.toISOString()], o);
      case J2e: {
        const { source: u, flags: f } = o;
        return a([s, { source: u, flags: f }], o);
      }
      case Y2e: {
        const u = [], f = a([s, u], o);
        for (const [h, p] of o)
          (t || !(aB(Uw(h)) || aB(Uw(p)))) && u.push([i(h), i(p)]);
        return f;
      }
      case X2e: {
        const u = [], f = a([s, u], o);
        for (const h of o)
          (t || !aB(Uw(h))) && u.push(i(h));
        return f;
      }
    }
    const { message: c } = o;
    return a([s, { name: l, message: c }], o);
  };
  return i;
}, Z4e = (t, { json: e, lossy: r } = {}) => {
  const n = [];
  return mLt(!(e || r), !!e, /* @__PURE__ */ new Map(), n)(t), n;
}, mL = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (t, e) => e && ("json" in e || "lossy" in e) ? K4e(Z4e(t, e)) : structuredClone(t)
) : (t, e) => K4e(Z4e(t, e));
function gLt(t, e) {
  const r = [{ type: "text", value: "↩" }];
  return e > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(e) }]
  }), r;
}
function vLt(t, e) {
  return "Back to reference " + (t + 1) + (e > 1 ? "-" + e : "");
}
function yLt(t) {
  const e = typeof t.options.clobberPrefix == "string" ? t.options.clobberPrefix : "user-content-", r = t.options.footnoteBackContent || gLt, n = t.options.footnoteBackLabel || vLt, a = t.options.footnoteLabel || "Footnotes", i = t.options.footnoteLabelTagName || "h2", o = t.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let l = -1;
  for (; ++l < t.footnoteOrder.length; ) {
    const c = t.footnoteById.get(
      t.footnoteOrder[l]
    );
    if (!c)
      continue;
    const u = t.all(c), f = String(c.identifier).toUpperCase(), h = _8(f.toLowerCase());
    let p = 0;
    const g = [], y = t.footnoteCounts.get(f);
    for (; y !== void 0 && ++p <= y; ) {
      g.length > 0 && g.push({ type: "text", value: " " });
      let _ = typeof r == "string" ? r : r(l, p);
      typeof _ == "string" && (_ = { type: "text", value: _ }), g.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e + "fnref-" + h + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof n == "string" ? n : n(l, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(_) ? _ : [_]
      });
    }
    const b = u[u.length - 1];
    if (b && b.type === "element" && b.tagName === "p") {
      const _ = b.children[b.children.length - 1];
      _ && _.type === "text" ? _.value += " " : b.children.push({ type: "text", value: " " }), b.children.push(...g);
    } else
      u.push(...g);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: e + "fn-" + h },
      children: t.wrap(u, !0)
    };
    t.patch(c, w), s.push(w);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: i,
          properties: {
            ...mL(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: t.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const mZe = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(t) {
    if (t == null)
      return wLt;
    if (typeof t == "function")
      return $z(t);
    if (typeof t == "object")
      return Array.isArray(t) ? bLt(t) : xLt(t);
    if (typeof t == "string")
      return CLt(t);
    throw new Error("Expected function, string, or object as test");
  }
);
function bLt(t) {
  const e = [];
  let r = -1;
  for (; ++r < t.length; )
    e[r] = mZe(t[r]);
  return $z(n);
  function n(...a) {
    let i = -1;
    for (; ++i < e.length; )
      if (e[i].apply(this, a)) return !0;
    return !1;
  }
}
function xLt(t) {
  const e = (
    /** @type {Record<string, unknown>} */
    t
  );
  return $z(r);
  function r(n) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      n
    );
    let i;
    for (i in t)
      if (a[i] !== e[i]) return !1;
    return !0;
  }
}
function CLt(t) {
  return $z(e);
  function e(r) {
    return r && r.type === t;
  }
}
function $z(t) {
  return e;
  function e(r, n, a) {
    return !!(SLt(r) && t.call(
      this,
      r,
      typeof n == "number" ? n : void 0,
      a || void 0
    ));
  }
}
function wLt() {
  return !0;
}
function SLt(t) {
  return t !== null && typeof t == "object" && "type" in t;
}
const gZe = [], _Lt = !0, J4e = !1, kLt = "skip";
function ALt(t, e, r, n) {
  let a;
  typeof e == "function" && typeof r != "function" ? (n = r, r = e) : a = e;
  const i = mZe(a), o = n ? -1 : 1;
  s(t, void 0, [])();
  function s(l, c, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      l && typeof l == "object" ? l : {}
    );
    if (typeof f.type == "string") {
      const p = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (l.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let p = gZe, g, y, b;
      if ((!e || i(l, c, u[u.length - 1] || void 0)) && (p = TLt(r(l, u)), p[0] === J4e))
        return p;
      if ("children" in l && l.children) {
        const w = (
          /** @type {UnistParent} */
          l
        );
        if (w.children && p[0] !== kLt)
          for (y = (n ? w.children.length : -1) + o, b = u.concat(w); y > -1 && y < w.children.length; ) {
            const _ = w.children[y];
            if (g = s(_, y, b)(), g[0] === J4e)
              return g;
            y = typeof g[1] == "number" ? g[1] : y + o;
          }
      }
      return p;
    }
  }
}
function TLt(t) {
  return Array.isArray(t) ? t : typeof t == "number" ? [_Lt, t] : t == null ? gZe : [t];
}
function Q2e(t, e, r, n) {
  let a, i, o;
  typeof e == "function" ? (i = void 0, o = e, a = r) : (i = e, o = r, a = n), ALt(t, i, s, a);
  function s(l, c) {
    const u = c[c.length - 1], f = u ? u.children.indexOf(l) : void 0;
    return o(l, f, u);
  }
}
const iue = {}.hasOwnProperty, ELt = {};
function ILt(t, e) {
  const r = e || ELt, n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = { ...dLt, ...r.handlers }, s = {
    all: c,
    applyData: PLt,
    definitionById: n,
    footnoteById: a,
    footnoteCounts: i,
    footnoteOrder: [],
    handlers: o,
    one: l,
    options: r,
    patch: MLt,
    wrap: OLt
  };
  return Q2e(t, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? n : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), s;
  function l(u, f) {
    const h = u.type, p = s.handlers[h];
    if (iue.call(s.handlers, h) && p)
      return p(s, u, f);
    if (s.options.passThrough && s.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: y, ...b } = u, w = mL(b);
        return w.children = s.all(u), w;
      }
      return mL(u);
    }
    return (s.options.unknownHandler || RLt)(s, u, f);
  }
  function c(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let p = -1;
      for (; ++p < h.length; ) {
        const g = s.one(h[p], u);
        if (g) {
          if (p && h[p - 1].type === "break" && (!Array.isArray(g) && g.type === "text" && (g.value = Y4e(g.value)), !Array.isArray(g) && g.type === "element")) {
            const y = g.children[0];
            y && y.type === "text" && (y.value = Y4e(y.value));
          }
          Array.isArray(g) ? f.push(...g) : f.push(g);
        }
      }
    }
    return f;
  }
}
function MLt(t, e) {
  t.position && (e.position = hNt(t));
}
function PLt(t, e) {
  let r = e;
  if (t && t.data) {
    const n = t.data.hName, a = t.data.hChildren, i = t.data.hProperties;
    if (typeof n == "string")
      if (r.type === "element")
        r.tagName = n;
      else {
        const o = "children" in r ? r.children : [r];
        r = { type: "element", tagName: n, properties: {}, children: o };
      }
    r.type === "element" && i && Object.assign(r.properties, mL(i)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function RLt(t, e) {
  const r = e.data || {}, n = "value" in e && !(iue.call(r, "hProperties") || iue.call(r, "hChildren")) ? { type: "text", value: e.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: t.all(e)
  };
  return t.patch(e, n), t.applyData(e, n);
}
function OLt(t, e) {
  const r = [];
  let n = -1;
  for (e && r.push({ type: "text", value: `
` }); ++n < t.length; )
    n && r.push({ type: "text", value: `
` }), r.push(t[n]);
  return e && t.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Y4e(t) {
  let e = 0, r = t.charCodeAt(e);
  for (; r === 9 || r === 32; )
    e++, r = t.charCodeAt(e);
  return t.slice(e);
}
function X4e(t, e) {
  const r = ILt(t, e), n = r.one(t, void 0), a = yLt(r), i = Array.isArray(n) ? { type: "root", children: n } : n || { type: "root", children: [] };
  return a && i.children.push({ type: "text", value: `
` }, a), i;
}
function vZe(t, e) {
  return t && "run" in t ? async function(r, n) {
    const a = (
      /** @type {HastRoot} */
      X4e(r, { file: n, ...e })
    );
    await t.run(a, n);
  } : function(r, n) {
    return (
      /** @type {HastRoot} */
      X4e(r, { file: n, ...t || e })
    );
  };
}
function Q4e(t) {
  if (t)
    throw t;
}
var HK, e9e;
function BLt() {
  if (e9e) return HK;
  e9e = 1;
  var t = Object.prototype.hasOwnProperty, e = Object.prototype.toString, r = Object.defineProperty, n = Object.getOwnPropertyDescriptor, a = function(c) {
    return typeof Array.isArray == "function" ? Array.isArray(c) : e.call(c) === "[object Array]";
  }, i = function(c) {
    if (!c || e.call(c) !== "[object Object]")
      return !1;
    var u = t.call(c, "constructor"), f = c.constructor && c.constructor.prototype && t.call(c.constructor.prototype, "isPrototypeOf");
    if (c.constructor && !u && !f)
      return !1;
    var h;
    for (h in c)
      ;
    return typeof h > "u" || t.call(c, h);
  }, o = function(c, u) {
    r && u.name === "__proto__" ? r(c, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : c[u.name] = u.newValue;
  }, s = function(c, u) {
    if (u === "__proto__")
      if (t.call(c, u)) {
        if (n)
          return n(c, u).value;
      } else return;
    return c[u];
  };
  return HK = function l() {
    var c, u, f, h, p, g, y = arguments[0], b = 1, w = arguments.length, _ = !1;
    for (typeof y == "boolean" && (_ = y, y = arguments[1] || {}, b = 2), (y == null || typeof y != "object" && typeof y != "function") && (y = {}); b < w; ++b)
      if (c = arguments[b], c != null)
        for (u in c)
          f = s(y, u), h = s(c, u), y !== h && (_ && h && (i(h) || (p = a(h))) ? (p ? (p = !1, g = f && a(f) ? f : []) : g = f && i(f) ? f : {}, o(y, { name: u, newValue: l(_, g, h) })) : typeof h < "u" && o(y, { name: u, newValue: h }));
    return y;
  }, HK;
}
var NLt = BLt();
const UK = /* @__PURE__ */ Gi(NLt);
function oue(t) {
  if (typeof t != "object" || t === null)
    return !1;
  const e = Object.getPrototypeOf(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}
function $Lt() {
  const t = [], e = { run: r, use: n };
  return e;
  function r(...a) {
    let i = -1;
    const o = a.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...a);
    function s(l, ...c) {
      const u = t[++i];
      let f = -1;
      if (l) {
        o(l);
        return;
      }
      for (; ++f < a.length; )
        (c[f] === null || c[f] === void 0) && (c[f] = a[f]);
      a = c, u ? DLt(u, s)(...c) : o(null, ...c);
    }
  }
  function n(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return t.push(a), e;
  }
}
function DLt(t, e) {
  let r;
  return n;
  function n(...o) {
    const s = t.length > o.length;
    let l;
    s && o.push(a);
    try {
      l = t.apply(this, o);
    } catch (c) {
      const u = (
        /** @type {Error} */
        c
      );
      if (s && r)
        throw u;
      return a(u);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(i, a) : l instanceof Error ? a(l) : i(l));
  }
  function a(o, ...s) {
    r || (r = !0, e(o, ...s));
  }
  function i(o) {
    a(null, o);
  }
}
const F2 = { basename: LLt, dirname: jLt, extname: FLt, join: zLt, sep: "/" };
function LLt(t, e) {
  if (e !== void 0 && typeof e != "string")
    throw new TypeError('"ext" argument must be a string');
  XI(t);
  let r = 0, n = -1, a = t.length, i;
  if (e === void 0 || e.length === 0 || e.length > t.length) {
    for (; a--; )
      if (t.codePointAt(a) === 47) {
        if (i) {
          r = a + 1;
          break;
        }
      } else n < 0 && (i = !0, n = a + 1);
    return n < 0 ? "" : t.slice(r, n);
  }
  if (e === t)
    return "";
  let o = -1, s = e.length - 1;
  for (; a--; )
    if (t.codePointAt(a) === 47) {
      if (i) {
        r = a + 1;
        break;
      }
    } else
      o < 0 && (i = !0, o = a + 1), s > -1 && (t.codePointAt(a) === e.codePointAt(s--) ? s < 0 && (n = a) : (s = -1, n = o));
  return r === n ? n = o : n < 0 && (n = t.length), t.slice(r, n);
}
function jLt(t) {
  if (XI(t), t.length === 0)
    return ".";
  let e = -1, r = t.length, n;
  for (; --r; )
    if (t.codePointAt(r) === 47) {
      if (n) {
        e = r;
        break;
      }
    } else n || (n = !0);
  return e < 0 ? t.codePointAt(0) === 47 ? "/" : "." : e === 1 && t.codePointAt(0) === 47 ? "//" : t.slice(0, e);
}
function FLt(t) {
  XI(t);
  let e = t.length, r = -1, n = 0, a = -1, i = 0, o;
  for (; e--; ) {
    const s = t.codePointAt(e);
    if (s === 47) {
      if (o) {
        n = e + 1;
        break;
      }
      continue;
    }
    r < 0 && (o = !0, r = e + 1), s === 46 ? a < 0 ? a = e : i !== 1 && (i = 1) : a > -1 && (i = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && a === r - 1 && a === n + 1 ? "" : t.slice(a, r);
}
function zLt(...t) {
  let e = -1, r;
  for (; ++e < t.length; )
    XI(t[e]), t[e] && (r = r === void 0 ? t[e] : r + "/" + t[e]);
  return r === void 0 ? "." : GLt(r);
}
function GLt(t) {
  XI(t);
  const e = t.codePointAt(0) === 47;
  let r = WLt(t, !e);
  return r.length === 0 && !e && (r = "."), r.length > 0 && t.codePointAt(t.length - 1) === 47 && (r += "/"), e ? "/" + r : r;
}
function WLt(t, e) {
  let r = "", n = 0, a = -1, i = 0, o = -1, s, l;
  for (; ++o <= t.length; ) {
    if (o < t.length)
      s = t.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(a === o - 1 || i === 1)) if (a !== o - 1 && i === 2) {
        if (r.length < 2 || n !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (l = r.lastIndexOf("/"), l !== r.length - 1) {
              l < 0 ? (r = "", n = 0) : (r = r.slice(0, l), n = r.length - 1 - r.lastIndexOf("/")), a = o, i = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", n = 0, a = o, i = 0;
            continue;
          }
        }
        e && (r = r.length > 0 ? r + "/.." : "..", n = 2);
      } else
        r.length > 0 ? r += "/" + t.slice(a + 1, o) : r = t.slice(a + 1, o), n = o - a - 1;
      a = o, i = 0;
    } else s === 46 && i > -1 ? i++ : i = -1;
  }
  return r;
}
function XI(t) {
  if (typeof t != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(t)
    );
}
const HLt = { cwd: ULt };
function ULt() {
  return "/";
}
function sue(t) {
  return !!(t !== null && typeof t == "object" && "href" in t && t.href && "protocol" in t && t.protocol && // @ts-expect-error: indexing is fine.
  t.auth === void 0);
}
function VLt(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!sue(t)) {
    const e = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + t + "`"
    );
    throw e.code = "ERR_INVALID_ARG_TYPE", e;
  }
  if (t.protocol !== "file:") {
    const e = new TypeError("The URL must be of scheme file");
    throw e.code = "ERR_INVALID_URL_SCHEME", e;
  }
  return qLt(t);
}
function qLt(t) {
  if (t.hostname !== "") {
    const n = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw n.code = "ERR_INVALID_FILE_URL_HOST", n;
  }
  const e = t.pathname;
  let r = -1;
  for (; ++r < e.length; )
    if (e.codePointAt(r) === 37 && e.codePointAt(r + 1) === 50) {
      const n = e.codePointAt(r + 2);
      if (n === 70 || n === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(e);
}
const VK = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class ehe {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(e) {
    let r;
    e ? sue(e) ? r = { path: e } : typeof e == "string" || KLt(e) ? r = { value: e } : r = e : r = {}, this.cwd = "cwd" in r ? "" : HLt.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let n = -1;
    for (; ++n < VK.length; ) {
      const i = VK[n];
      i in r && r[i] !== void 0 && r[i] !== null && (this[i] = i === "history" ? [...r[i]] : r[i]);
    }
    let a;
    for (a in r)
      VK.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? F2.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(e) {
    KK(e, "basename"), qK(e, "basename"), this.path = F2.join(this.dirname || "", e);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? F2.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(e) {
    t9e(this.basename, "dirname"), this.path = F2.join(e || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? F2.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(e) {
    if (qK(e, "extname"), t9e(this.dirname, "extname"), e) {
      if (e.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (e.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = F2.join(this.dirname, this.stem + (e || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(e) {
    sue(e) && (e = VLt(e)), KK(e, "path"), this.path !== e && this.history.push(e);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? F2.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(e) {
    KK(e, "stem"), qK(e, "stem"), this.path = F2.join(this.dirname || "", e + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(e, r, n) {
    const a = this.message(e, r, n);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(e, r, n) {
    const a = this.message(e, r, n);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(e, r, n) {
    const a = new tu(
      // @ts-expect-error: the overloads are fine.
      e,
      r,
      n
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(e) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(e || void 0).decode(this.value);
  }
}
function qK(t, e) {
  if (t && t.includes(F2.sep))
    throw new Error(
      "`" + e + "` cannot be a path: did not expect `" + F2.sep + "`"
    );
}
function KK(t, e) {
  if (!t)
    throw new Error("`" + e + "` cannot be empty");
}
function t9e(t, e) {
  if (!t)
    throw new Error("Setting `" + e + "` requires `path` to be set too");
}
function KLt(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const ZLt = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(t) {
    const n = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = n[t], i = function() {
      return a.apply(i, arguments);
    };
    return Object.setPrototypeOf(i, n), i;
  }
), JLt = {}.hasOwnProperty;
class the extends ZLt {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = $Lt();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const e = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new the()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const n = this.attachers[r];
      e.use(...n);
    }
    return e.data(UK(!0, {}, this.namespace)), e;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(e, r) {
    return typeof e == "string" ? arguments.length === 2 ? (YK("data", this.frozen), this.namespace[e] = r, this) : JLt.call(this.namespace, e) && this.namespace[e] || void 0 : e ? (YK("data", this.frozen), this.namespace = e, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const e = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...n] = this.attachers[this.freezeIndex];
      if (n[0] === !1)
        continue;
      n[0] === !0 && (n[0] = void 0);
      const a = r.call(e, ...n);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(e) {
    this.freeze();
    const r = iB(e), n = this.parser || this.Parser;
    return ZK("parse", n), n(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(e, r) {
    const n = this;
    return this.freeze(), ZK("process", this.parser || this.Parser), JK("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(i, o) {
      const s = iB(e), l = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        n.parse(s)
      );
      n.run(l, s, function(u, f, h) {
        if (u || !f || !h)
          return c(u);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), g = n.stringify(p, h);
        XLt(g) ? h.value = g : h.result = g, c(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function c(u, f) {
        u || !f ? o(u) : i ? i(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(e) {
    let r = !1, n;
    return this.freeze(), ZK("processSync", this.parser || this.Parser), JK("processSync", this.compiler || this.Compiler), this.process(e, a), n9e("processSync", "process", r), n;
    function a(i, o) {
      r = !0, Q4e(i), n = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(e, r, n) {
    r9e(e), this.freeze();
    const a = this.transformers;
    return !n && typeof r == "function" && (n = r, r = void 0), n ? i(void 0, n) : new Promise(i);
    function i(o, s) {
      const l = iB(r);
      a.run(e, l, c);
      function c(u, f, h) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || e
        );
        u ? s(u) : o ? o(p) : n(void 0, p, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(e, r) {
    let n = !1, a;
    return this.run(e, r, i), n9e("runSync", "run", n), a;
    function i(o, s) {
      Q4e(o), a = s, n = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(e, r) {
    this.freeze();
    const n = iB(r), a = this.compiler || this.Compiler;
    return JK("stringify", a), r9e(e), a(e, n);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(e, ...r) {
    const n = this.attachers, a = this.namespace;
    if (YK("use", this.frozen), e != null) if (typeof e == "function")
      l(e, r);
    else if (typeof e == "object")
      Array.isArray(e) ? s(e) : o(e);
    else
      throw new TypeError("Expected usable value, not `" + e + "`");
    return this;
    function i(c) {
      if (typeof c == "function")
        l(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          l(u, f);
        } else
          o(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function o(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(c.plugins), c.settings && (a.settings = UK(!0, a.settings, c.settings));
    }
    function s(c) {
      let u = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++u < c.length; ) {
          const f = c[u];
          i(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function l(c, u) {
      let f = -1, h = -1;
      for (; ++f < n.length; )
        if (n[f][0] === c) {
          h = f;
          break;
        }
      if (h === -1)
        n.push([c, ...u]);
      else if (u.length > 0) {
        let [p, ...g] = u;
        const y = n[h][1];
        oue(y) && oue(p) && (p = UK(!0, y, p)), n[h] = [c, p, ...g];
      }
    }
  }
}
const yZe = new the().freeze();
function ZK(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `parser`");
}
function JK(t, e) {
  if (typeof e != "function")
    throw new TypeError("Cannot `" + t + "` without `compiler`");
}
function YK(t, e) {
  if (e)
    throw new Error(
      "Cannot call `" + t + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function r9e(t) {
  if (!oue(t) || typeof t.type != "string")
    throw new TypeError("Expected node, got `" + t + "`");
}
function n9e(t, e, r) {
  if (!r)
    throw new Error(
      "`" + t + "` finished async. Use `" + e + "` instead"
    );
}
function iB(t) {
  return YLt(t) ? t : new ehe(t);
}
function YLt(t) {
  return !!(t && typeof t == "object" && "message" in t && "messages" in t);
}
function XLt(t) {
  return typeof t == "string" || QLt(t);
}
function QLt(t) {
  return !!(t && typeof t == "object" && "byteLength" in t && "byteOffset" in t);
}
const ejt = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", a9e = [], i9e = { allowDangerousHtml: !0 }, tjt = /^(https?|ircs?|mailto|xmpp)$/i, rjt = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function njt(t) {
  const e = t.allowedElements, r = t.allowElement, n = t.children || "", a = t.className, i = t.components, o = t.disallowedElements, s = t.rehypePlugins || a9e, l = t.remarkPlugins || a9e, c = t.remarkRehypeOptions ? { ...t.remarkRehypeOptions, ...i9e } : i9e, u = t.skipHtml, f = t.unwrapDisallowed, h = t.urlTransform || ajt, p = yZe().use(cZe).use(l).use(vZe, c).use(s), g = new ehe();
  typeof n == "string" && (g.value = n);
  for (const _ of rjt)
    Object.hasOwn(t, _.from) && ("" + _.from + (_.to ? "use `" + _.to + "` instead" : "remove it") + ejt + _.id, void 0);
  const y = p.parse(g);
  let b = p.runSync(y, g);
  return a && (b = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      b.type === "root" ? b.children : [b]
    )
  }), Q2e(b, w), VKe(b, {
    Fragment: R.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: R.jsx,
    jsxs: R.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(_, C, x) {
    if (_.type === "raw" && x && typeof C == "number")
      return u ? x.children.splice(C, 1) : x.children[C] = { type: "text", value: _.value }, C;
    if (_.type === "element") {
      let S;
      for (S in d7)
        if (Object.hasOwn(d7, S) && Object.hasOwn(_.properties, S)) {
          const A = _.properties[S], I = d7[S];
          (I === null || I.includes(_.tagName)) && (_.properties[S] = h(String(A || ""), S, _));
        }
    }
    if (_.type === "element") {
      let S = e ? !e.includes(_.tagName) : o ? o.includes(_.tagName) : !1;
      if (!S && r && typeof C == "number" && (S = !r(_, C, x)), S && x && typeof C == "number")
        return f && _.children ? x.children.splice(C, 1, ..._.children) : x.children.splice(C, 1), C;
    }
  }
}
function ajt(t) {
  const e = t.indexOf(":"), r = t.indexOf("?"), n = t.indexOf("#"), a = t.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    e < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && e > a || r > -1 && e > r || n > -1 && e > n || // It is a protocol, it should be allowed.
    tjt.test(t.slice(0, e)) ? t : ""
  );
}
var XK = {};
const ss = globalThis || void 0 || self;
var ijt = Object.create, bZe = Object.defineProperty, ojt = Object.getOwnPropertyDescriptor, xZe = Object.getOwnPropertyNames, sjt = Object.getPrototypeOf, ljt = Object.prototype.hasOwnProperty, da = (t, e) => function() {
  return e || (0, t[xZe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, cjt = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of xZe(e)) !ljt.call(t, a) && a !== r && bZe(t, a, { get: () => e[a], enumerable: !(n = ojt(e, a)) || n.enumerable });
  return t;
}, Ed = (t, e, r) => (r = t != null ? ijt(sjt(t)) : {}, cjt(!t || !t.__esModule ? bZe(r, "default", { value: t, enumerable: !0 }) : r, t)), ujt = da({ "../../../node_modules/xtend/immutable.js"(t, e) {
  e.exports = n;
  var r = Object.prototype.hasOwnProperty;
  function n() {
    for (var a = {}, i = 0; i < arguments.length; i++) {
      var o = arguments[i];
      for (var s in o) r.call(o, s) && (a[s] = o[s]);
    }
    return a;
  }
} }), CZe = da({ "../../../node_modules/property-information/lib/util/schema.js"(t, e) {
  e.exports = n;
  var r = n.prototype;
  r.space = null, r.normal = {}, r.property = {};
  function n(a, i, o) {
    this.property = a, this.normal = i, o && (this.space = o);
  }
} }), djt = da({ "../../../node_modules/property-information/lib/util/merge.js"(t, e) {
  var r = ujt(), n = CZe();
  e.exports = a;
  function a(i) {
    for (var o = i.length, s = [], l = [], c = -1, u, f; ++c < o; ) u = i[c], s.push(u.property), l.push(u.normal), f = u.space;
    return new n(r.apply(null, s), r.apply(null, l), f);
  }
} }), rhe = da({ "../../../node_modules/property-information/normalize.js"(t, e) {
  e.exports = r;
  function r(n) {
    return n.toLowerCase();
  }
} }), wZe = da({ "../../../node_modules/property-information/lib/util/info.js"(t, e) {
  e.exports = n;
  var r = n.prototype;
  r.space = null, r.attribute = null, r.property = null, r.boolean = !1, r.booleanish = !1, r.overloadedBoolean = !1, r.number = !1, r.commaSeparated = !1, r.spaceSeparated = !1, r.commaOrSpaceSeparated = !1, r.mustUseProperty = !1, r.defined = !1;
  function n(a, i) {
    this.property = a, this.attribute = i;
  }
} }), nhe = da({ "../../../node_modules/property-information/lib/util/types.js"(t) {
  var e = 0;
  t.boolean = r(), t.booleanish = r(), t.overloadedBoolean = r(), t.number = r(), t.spaceSeparated = r(), t.commaSeparated = r(), t.commaOrSpaceSeparated = r();
  function r() {
    return Math.pow(2, ++e);
  }
} }), SZe = da({ "../../../node_modules/property-information/lib/util/defined-info.js"(t, e) {
  var r = wZe(), n = nhe();
  e.exports = o, o.prototype = new r(), o.prototype.defined = !0;
  var a = ["boolean", "booleanish", "overloadedBoolean", "number", "commaSeparated", "spaceSeparated", "commaOrSpaceSeparated"], i = a.length;
  function o(l, c, u, f) {
    var h = -1, p;
    for (s(this, "space", f), r.call(this, l, c); ++h < i; ) p = a[h], s(this, p, (u & n[p]) === n[p]);
  }
  function s(l, c, u) {
    u && (l[c] = u);
  }
} }), QI = da({ "../../../node_modules/property-information/lib/util/create.js"(t, e) {
  var r = rhe(), n = CZe(), a = SZe();
  e.exports = i;
  function i(o) {
    var s = o.space, l = o.mustUseProperty || [], c = o.attributes || {}, u = o.properties, f = o.transform, h = {}, p = {}, g, y;
    for (g in u) y = new a(g, f(c, g), u[g], s), l.indexOf(g) !== -1 && (y.mustUseProperty = !0), h[g] = y, p[r(g)] = g, p[r(y.attribute)] = g;
    return new n(h, p, s);
  }
} }), fjt = da({ "../../../node_modules/property-information/lib/xlink.js"(t, e) {
  var r = QI();
  e.exports = r({ space: "xlink", transform: n, properties: { xLinkActuate: null, xLinkArcRole: null, xLinkHref: null, xLinkRole: null, xLinkShow: null, xLinkTitle: null, xLinkType: null } });
  function n(a, i) {
    return "xlink:" + i.slice(5).toLowerCase();
  }
} }), hjt = da({ "../../../node_modules/property-information/lib/xml.js"(t, e) {
  var r = QI();
  e.exports = r({ space: "xml", transform: n, properties: { xmlLang: null, xmlBase: null, xmlSpace: null } });
  function n(a, i) {
    return "xml:" + i.slice(3).toLowerCase();
  }
} }), pjt = da({ "../../../node_modules/property-information/lib/util/case-sensitive-transform.js"(t, e) {
  e.exports = r;
  function r(n, a) {
    return a in n ? n[a] : a;
  }
} }), _Ze = da({ "../../../node_modules/property-information/lib/util/case-insensitive-transform.js"(t, e) {
  var r = pjt();
  e.exports = n;
  function n(a, i) {
    return r(a, i.toLowerCase());
  }
} }), mjt = da({ "../../../node_modules/property-information/lib/xmlns.js"(t, e) {
  var r = QI(), n = _Ze();
  e.exports = r({ space: "xmlns", attributes: { xmlnsxlink: "xmlns:xlink" }, transform: n, properties: { xmlns: null, xmlnsXLink: null } });
} }), gjt = da({ "../../../node_modules/property-information/lib/aria.js"(t, e) {
  var r = nhe(), n = QI(), a = r.booleanish, i = r.number, o = r.spaceSeparated;
  e.exports = n({ transform: s, properties: { ariaActiveDescendant: null, ariaAtomic: a, ariaAutoComplete: null, ariaBusy: a, ariaChecked: a, ariaColCount: i, ariaColIndex: i, ariaColSpan: i, ariaControls: o, ariaCurrent: null, ariaDescribedBy: o, ariaDetails: null, ariaDisabled: a, ariaDropEffect: o, ariaErrorMessage: null, ariaExpanded: a, ariaFlowTo: o, ariaGrabbed: a, ariaHasPopup: null, ariaHidden: a, ariaInvalid: null, ariaKeyShortcuts: null, ariaLabel: null, ariaLabelledBy: o, ariaLevel: i, ariaLive: null, ariaModal: a, ariaMultiLine: a, ariaMultiSelectable: a, ariaOrientation: null, ariaOwns: o, ariaPlaceholder: null, ariaPosInSet: i, ariaPressed: a, ariaReadOnly: a, ariaRelevant: null, ariaRequired: a, ariaRoleDescription: o, ariaRowCount: i, ariaRowIndex: i, ariaRowSpan: i, ariaSelected: a, ariaSetSize: i, ariaSort: null, ariaValueMax: i, ariaValueMin: i, ariaValueNow: i, ariaValueText: null, role: null } });
  function s(l, c) {
    return c === "role" ? c : "aria-" + c.slice(4).toLowerCase();
  }
} }), vjt = da({ "../../../node_modules/property-information/lib/html.js"(t, e) {
  var r = nhe(), n = QI(), a = _Ze(), i = r.boolean, o = r.overloadedBoolean, s = r.booleanish, l = r.number, c = r.spaceSeparated, u = r.commaSeparated;
  e.exports = n({ space: "html", attributes: { acceptcharset: "accept-charset", classname: "class", htmlfor: "for", httpequiv: "http-equiv" }, transform: a, mustUseProperty: ["checked", "multiple", "muted", "selected"], properties: { abbr: null, accept: u, acceptCharset: c, accessKey: c, action: null, allow: null, allowFullScreen: i, allowPaymentRequest: i, allowUserMedia: i, alt: null, as: null, async: i, autoCapitalize: null, autoComplete: c, autoFocus: i, autoPlay: i, capture: i, charSet: null, checked: i, cite: null, className: c, cols: l, colSpan: null, content: null, contentEditable: s, controls: i, controlsList: c, coords: l | u, crossOrigin: null, data: null, dateTime: null, decoding: null, default: i, defer: i, dir: null, dirName: null, disabled: i, download: o, draggable: s, encType: null, enterKeyHint: null, form: null, formAction: null, formEncType: null, formMethod: null, formNoValidate: i, formTarget: null, headers: c, height: l, hidden: i, high: l, href: null, hrefLang: null, htmlFor: c, httpEquiv: c, id: null, imageSizes: null, imageSrcSet: u, inputMode: null, integrity: null, is: null, isMap: i, itemId: null, itemProp: c, itemRef: c, itemScope: i, itemType: c, kind: null, label: null, lang: null, language: null, list: null, loop: i, low: l, manifest: null, max: null, maxLength: l, media: null, method: null, min: null, minLength: l, multiple: i, muted: i, name: null, nonce: null, noModule: i, noValidate: i, onAbort: null, onAfterPrint: null, onAuxClick: null, onBeforePrint: null, onBeforeUnload: null, onBlur: null, onCancel: null, onCanPlay: null, onCanPlayThrough: null, onChange: null, onClick: null, onClose: null, onContextMenu: null, onCopy: null, onCueChange: null, onCut: null, onDblClick: null, onDrag: null, onDragEnd: null, onDragEnter: null, onDragExit: null, onDragLeave: null, onDragOver: null, onDragStart: null, onDrop: null, onDurationChange: null, onEmptied: null, onEnded: null, onError: null, onFocus: null, onFormData: null, onHashChange: null, onInput: null, onInvalid: null, onKeyDown: null, onKeyPress: null, onKeyUp: null, onLanguageChange: null, onLoad: null, onLoadedData: null, onLoadedMetadata: null, onLoadEnd: null, onLoadStart: null, onMessage: null, onMessageError: null, onMouseDown: null, onMouseEnter: null, onMouseLeave: null, onMouseMove: null, onMouseOut: null, onMouseOver: null, onMouseUp: null, onOffline: null, onOnline: null, onPageHide: null, onPageShow: null, onPaste: null, onPause: null, onPlay: null, onPlaying: null, onPopState: null, onProgress: null, onRateChange: null, onRejectionHandled: null, onReset: null, onResize: null, onScroll: null, onSecurityPolicyViolation: null, onSeeked: null, onSeeking: null, onSelect: null, onSlotChange: null, onStalled: null, onStorage: null, onSubmit: null, onSuspend: null, onTimeUpdate: null, onToggle: null, onUnhandledRejection: null, onUnload: null, onVolumeChange: null, onWaiting: null, onWheel: null, open: i, optimum: l, pattern: null, ping: c, placeholder: null, playsInline: i, poster: null, preload: null, readOnly: i, referrerPolicy: null, rel: c, required: i, reversed: i, rows: l, rowSpan: l, sandbox: c, scope: null, scoped: i, seamless: i, selected: i, shape: null, size: l, sizes: null, slot: null, span: l, spellCheck: s, src: null, srcDoc: null, srcLang: null, srcSet: u, start: l, step: null, style: null, tabIndex: l, target: null, title: null, translate: null, type: null, typeMustMatch: i, useMap: null, value: s, width: l, wrap: null, align: null, aLink: null, archive: c, axis: null, background: null, bgColor: null, border: l, borderColor: null, bottomMargin: l, cellPadding: null, cellSpacing: null, char: null, charOff: null, classId: null, clear: null, code: null, codeBase: null, codeType: null, color: null, compact: i, declare: i, event: null, face: null, frame: null, frameBorder: null, hSpace: l, leftMargin: l, link: null, longDesc: null, lowSrc: null, marginHeight: l, marginWidth: l, noResize: i, noHref: i, noShade: i, noWrap: i, object: null, profile: null, prompt: null, rev: null, rightMargin: l, rules: null, scheme: null, scrolling: s, standby: null, summary: null, text: null, topMargin: l, valueType: null, version: null, vAlign: null, vLink: null, vSpace: l, allowTransparency: null, autoCorrect: null, autoSave: null, disablePictureInPicture: i, disableRemotePlayback: i, prefix: null, property: null, results: l, security: null, unselectable: null } });
} }), yjt = da({ "../../../node_modules/property-information/html.js"(t, e) {
  var r = djt(), n = fjt(), a = hjt(), i = mjt(), o = gjt(), s = vjt();
  e.exports = r([a, n, i, o, s]);
} }), bjt = da({ "../../../node_modules/property-information/find.js"(t, e) {
  var r = rhe(), n = SZe(), a = wZe(), i = "data";
  e.exports = c;
  var o = /^data[-\w.:]+$/i, s = /-[a-z]/g, l = /[A-Z]/g;
  function c(g, y) {
    var b = r(y), w = y, _ = a;
    return b in g.normal ? g.property[g.normal[b]] : (b.length > 4 && b.slice(0, 4) === i && o.test(y) && (y.charAt(4) === "-" ? w = u(y) : y = f(y), _ = n), new _(w, y));
  }
  function u(g) {
    var y = g.slice(5).replace(s, p);
    return i + y.charAt(0).toUpperCase() + y.slice(1);
  }
  function f(g) {
    var y = g.slice(4);
    return s.test(y) ? g : (y = y.replace(l, h), y.charAt(0) !== "-" && (y = "-" + y), i + y);
  }
  function h(g) {
    return "-" + g.toLowerCase();
  }
  function p(g) {
    return g.charAt(1).toUpperCase();
  }
} }), xjt = da({ "../../../node_modules/hast-util-parse-selector/index.js"(t, e) {
  e.exports = a;
  var r = 35, n = 46;
  function a(i, o) {
    for (var s = i || "", l = o || "div", c = {}, u = -1, f = s.length, h, p, g, y, b; ++u <= f; ) g = s.charCodeAt(u), (!g || g === n || g === r) && (y = s.slice(b, u), y && (p === n ? h ? h.push(y) : (h = [y], c.className = h) : p === r ? c.id = y : l = y), b = u + 1, p = g);
    return { type: "element", tagName: l, properties: c, children: [] };
  }
} }), Cjt = da({ "../../../node_modules/space-separated-tokens/index.js"(t) {
  t.parse = a, t.stringify = i;
  var e = "", r = " ", n = /[ \t\n\r\f]+/g;
  function a(o) {
    var s = String(o || e).trim();
    return s === e ? [] : s.split(n);
  }
  function i(o) {
    return o.join(r).trim();
  }
} }), wjt = da({ "../../../node_modules/comma-separated-tokens/index.js"(t) {
  t.parse = a, t.stringify = i;
  var e = ",", r = " ", n = "";
  function a(o) {
    for (var s = [], l = String(o || n), c = l.indexOf(e), u = 0, f = !1, h; !f; ) c === -1 && (c = l.length, f = !0), h = l.slice(u, c).trim(), (h || !f) && s.push(h), u = c + 1, c = l.indexOf(e, u);
    return s;
  }
  function i(o, s) {
    var l = s || {}, c = l.padLeft === !1 ? n : r, u = l.padRight ? r : n;
    return o[o.length - 1] === n && (o = o.concat(n)), o.join(u + e + c).trim();
  }
} }), Sjt = da({ "../../../node_modules/hastscript/factory.js"(t, e) {
  var r = bjt(), n = rhe(), a = xjt(), i = Cjt().parse, o = wjt().parse;
  e.exports = l;
  var s = {}.hasOwnProperty;
  function l(b, w, _) {
    var C = _ ? y(_) : null;
    return x;
    function x(A, I) {
      var M = a(A, w), B = Array.prototype.slice.call(arguments, 2), L = M.tagName.toLowerCase(), N;
      if (M.tagName = C && s.call(C, L) ? C[L] : L, I && c(I, M) && (B.unshift(I), I = null), I) for (N in I) S(M.properties, N, I[N]);
      return f(M.children, B), M.tagName === "template" && (M.content = { type: "root", children: M.children }, M.children = []), M;
    }
    function S(A, I, M) {
      var B, L, N;
      M == null || M !== M || (B = r(b, I), L = B.property, N = M, typeof N == "string" && (B.spaceSeparated ? N = i(N) : B.commaSeparated ? N = o(N) : B.commaOrSpaceSeparated && (N = i(o(N).join(" ")))), L === "style" && typeof M != "string" && (N = g(N)), L === "className" && A.className && (N = A.className.concat(N)), A[L] = h(B, L, N));
    }
  }
  function c(b, w) {
    return typeof b == "string" || "length" in b || u(w.tagName, b);
  }
  function u(b, w) {
    var _ = w.type;
    return b === "input" || !_ || typeof _ != "string" ? !1 : typeof w.children == "object" && "length" in w.children ? !0 : (_ = _.toLowerCase(), b === "button" ? _ !== "menu" && _ !== "submit" && _ !== "reset" && _ !== "button" : "value" in w);
  }
  function f(b, w) {
    var _, C;
    if (typeof w == "string" || typeof w == "number") {
      b.push({ type: "text", value: String(w) });
      return;
    }
    if (typeof w == "object" && "length" in w) {
      for (_ = -1, C = w.length; ++_ < C; ) f(b, w[_]);
      return;
    }
    if (typeof w != "object" || !("type" in w)) throw new Error("Expected node, nodes, or string, got `" + w + "`");
    b.push(w);
  }
  function h(b, w, _) {
    var C, x, S;
    if (typeof _ != "object" || !("length" in _)) return p(b, w, _);
    for (x = _.length, C = -1, S = []; ++C < x; ) S[C] = p(b, w, _[C]);
    return S;
  }
  function p(b, w, _) {
    var C = _;
    return b.number || b.positiveNumber ? !isNaN(C) && C !== "" && (C = Number(C)) : (b.boolean || b.overloadedBoolean) && typeof C == "string" && (C === "" || n(_) === n(w)) && (C = !0), C;
  }
  function g(b) {
    var w = [], _;
    for (_ in b) w.push([_, b[_]].join(": "));
    return w.join("; ");
  }
  function y(b) {
    for (var w = b.length, _ = -1, C = {}, x; ++_ < w; ) x = b[_], C[x.toLowerCase()] = x;
    return C;
  }
} }), _jt = da({ "../../../node_modules/hastscript/html.js"(t, e) {
  var r = yjt(), n = Sjt(), a = n(r, "div");
  a.displayName = "html", e.exports = a;
} }), kjt = da({ "../../../node_modules/hastscript/index.js"(t, e) {
  e.exports = _jt();
} }), Ajt = da({ "../../../node_modules/parse-entities/node_modules/character-entities-legacy/index.json"(t, e) {
  e.exports = { AElig: "Æ", AMP: "&", Aacute: "Á", Acirc: "Â", Agrave: "À", Aring: "Å", Atilde: "Ã", Auml: "Ä", COPY: "©", Ccedil: "Ç", ETH: "Ð", Eacute: "É", Ecirc: "Ê", Egrave: "È", Euml: "Ë", GT: ">", Iacute: "Í", Icirc: "Î", Igrave: "Ì", Iuml: "Ï", LT: "<", Ntilde: "Ñ", Oacute: "Ó", Ocirc: "Ô", Ograve: "Ò", Oslash: "Ø", Otilde: "Õ", Ouml: "Ö", QUOT: '"', REG: "®", THORN: "Þ", Uacute: "Ú", Ucirc: "Û", Ugrave: "Ù", Uuml: "Ü", Yacute: "Ý", aacute: "á", acirc: "â", acute: "´", aelig: "æ", agrave: "à", amp: "&", aring: "å", atilde: "ã", auml: "ä", brvbar: "¦", ccedil: "ç", cedil: "¸", cent: "¢", copy: "©", curren: "¤", deg: "°", divide: "÷", eacute: "é", ecirc: "ê", egrave: "è", eth: "ð", euml: "ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", iacute: "í", icirc: "î", iexcl: "¡", igrave: "ì", iquest: "¿", iuml: "ï", laquo: "«", lt: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", ntilde: "ñ", oacute: "ó", ocirc: "ô", ograve: "ò", ordf: "ª", ordm: "º", oslash: "ø", otilde: "õ", ouml: "ö", para: "¶", plusmn: "±", pound: "£", quot: '"', raquo: "»", reg: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", thorn: "þ", times: "×", uacute: "ú", ucirc: "û", ugrave: "ù", uml: "¨", uuml: "ü", yacute: "ý", yen: "¥", yuml: "ÿ" };
} }), Tjt = da({ "../../../node_modules/character-reference-invalid/index.json"(t, e) {
  e.exports = { 0: "�", 128: "€", 130: "‚", 131: "ƒ", 132: "„", 133: "…", 134: "†", 135: "‡", 136: "ˆ", 137: "‰", 138: "Š", 139: "‹", 140: "Œ", 142: "Ž", 145: "‘", 146: "’", 147: "“", 148: "”", 149: "•", 150: "–", 151: "—", 152: "˜", 153: "™", 154: "š", 155: "›", 156: "œ", 158: "ž", 159: "Ÿ" };
} }), kZe = da({ "../../../node_modules/is-decimal/index.js"(t, e) {
  e.exports = r;
  function r(n) {
    var a = typeof n == "string" ? n.charCodeAt(0) : n;
    return a >= 48 && a <= 57;
  }
} }), Ejt = da({ "../../../node_modules/is-hexadecimal/index.js"(t, e) {
  e.exports = r;
  function r(n) {
    var a = typeof n == "string" ? n.charCodeAt(0) : n;
    return a >= 97 && a <= 102 || a >= 65 && a <= 70 || a >= 48 && a <= 57;
  }
} }), Ijt = da({ "../../../node_modules/is-alphabetical/index.js"(t, e) {
  e.exports = r;
  function r(n) {
    var a = typeof n == "string" ? n.charCodeAt(0) : n;
    return a >= 97 && a <= 122 || a >= 65 && a <= 90;
  }
} }), Mjt = da({ "../../../node_modules/is-alphanumerical/index.js"(t, e) {
  var r = Ijt(), n = kZe();
  e.exports = a;
  function a(i) {
    return r(i) || n(i);
  }
} }), Pjt = da({ "../../../node_modules/parse-entities/decode-entity.browser.js"(t, e) {
  var r, n = 59;
  e.exports = a;
  function a(i) {
    var o = "&" + i + ";", s;
    return r = r || document.createElement("i"), r.innerHTML = o, s = r.textContent, s.charCodeAt(s.length - 1) === n && i !== "semi" || s === o ? !1 : s;
  }
} }), Rjt = da({ "../../../node_modules/parse-entities/index.js"(t, e) {
  var r = Ajt(), n = Tjt(), a = kZe(), i = Ejt(), o = Mjt(), s = Pjt();
  e.exports = z;
  var l = {}.hasOwnProperty, c = String.fromCharCode, u = Function.prototype, f = { warning: null, reference: null, text: null, warningContext: null, referenceContext: null, textContext: null, position: {}, additional: null, attribute: !1, nonTerminated: !0 }, h = 9, p = 10, g = 12, y = 32, b = 38, w = 59, _ = 60, C = 61, x = 35, S = 88, A = 120, I = 65533, M = "named", B = "hexadecimal", L = "decimal", N = {};
  N[B] = 16, N[L] = 10;
  var d = {};
  d[M] = o, d[L] = a, d[B] = i;
  var m = 1, v = 2, k = 3, O = 4, G = 5, H = 6, j = 7, F = {};
  F[m] = "Named character references must be terminated by a semicolon", F[v] = "Numeric character references must be terminated by a semicolon", F[k] = "Named character references cannot be empty", F[O] = "Numeric character references cannot be empty", F[G] = "Named character references must be known", F[H] = "Numeric character references cannot be disallowed", F[j] = "Numeric character references cannot be outside the permissible Unicode range";
  function z(V, Y) {
    var ge = {}, ce, ee;
    Y || (Y = {});
    for (ee in f) ce = Y[ee], ge[ee] = ce ?? f[ee];
    return (ge.position.indent || ge.position.start) && (ge.indent = ge.position.indent || [], ge.position = ge.position.start), W(V, ge);
  }
  function W(V, Y) {
    var ge = Y.additional, ce = Y.nonTerminated, ee = Y.text, Se = Y.reference, Ce = Y.warning, we = Y.textContext, We = Y.referenceContext, Fe = Y.warningContext, it = Y.position, gt = Y.indent || [], Ze = V.length, Ne = 0, ze = -1, ct = it.column || 1, rt = it.line || 1, qe = "", nt = [], Rt, Ot, lt, mt, jt, Jt, ne, re, ie, Ie, Ke, Le, Ge, ft, ot, Ye, Je, tt, kt;
    for (typeof ge == "string" && (ge = ge.charCodeAt(0)), Ye = Ft(), re = Ce ? bt : u, Ne--, Ze++; ++Ne < Ze; ) if (jt === p && (ct = gt[ze] || 1), jt = V.charCodeAt(Ne), jt === b) {
      if (ne = V.charCodeAt(Ne + 1), ne === h || ne === p || ne === g || ne === y || ne === b || ne === _ || ne !== ne || ge && ne === ge) {
        qe += c(jt), ct++;
        continue;
      }
      for (Ge = Ne + 1, Le = Ge, kt = Ge, ne === x ? (kt = ++Le, ne = V.charCodeAt(kt), ne === S || ne === A ? (ft = B, kt = ++Le) : ft = L) : ft = M, Rt = "", Ke = "", mt = "", ot = d[ft], kt--; ++kt < Ze && (ne = V.charCodeAt(kt), !!ot(ne)); ) mt += c(ne), ft === M && l.call(r, mt) && (Rt = mt, Ke = r[mt]);
      lt = V.charCodeAt(kt) === w, lt && (kt++, Ot = ft === M ? s(mt) : !1, Ot && (Rt = mt, Ke = Ot)), tt = 1 + kt - Ge, !lt && !ce || (mt ? ft === M ? (lt && !Ke ? re(G, 1) : (Rt !== mt && (kt = Le + Rt.length, tt = 1 + kt - Le, lt = !1), lt || (ie = Rt ? m : k, Y.attribute ? (ne = V.charCodeAt(kt), ne === C ? (re(ie, tt), Ke = null) : o(ne) ? Ke = null : re(ie, tt)) : re(ie, tt))), Jt = Ke) : (lt || re(v, tt), Jt = parseInt(mt, N[ft]), U(Jt) ? (re(j, tt), Jt = c(I)) : Jt in n ? (re(H, tt), Jt = n[Jt]) : (Ie = "", Z(Jt) && re(H, tt), Jt > 65535 && (Jt -= 65536, Ie += c(Jt >>> 10 | 55296), Jt = 56320 | Jt & 1023), Jt = Ie + c(Jt))) : ft !== M && re(O, tt)), Jt ? (At(), Ye = Ft(), Ne = kt - 1, ct += kt - Ge + 1, nt.push(Jt), Je = Ft(), Je.offset++, Se && Se.call(We, Jt, { start: Ye, end: Je }, V.slice(Ge - 1, kt)), Ye = Je) : (mt = V.slice(Ge - 1, kt), qe += mt, ct += mt.length, Ne = kt - 1);
    } else jt === 10 && (rt++, ze++, ct = 0), jt === jt ? (qe += c(jt), ct++) : At();
    return nt.join("");
    function Ft() {
      return { line: rt, column: ct, offset: Ne + (it.offset || 0) };
    }
    function bt(vt, _t) {
      var yt = Ft();
      yt.column += _t, yt.offset += _t, Ce.call(Fe, F[vt], yt, vt);
    }
    function At() {
      qe && (nt.push(qe), ee && ee.call(we, qe, { start: Ye, end: Ft() }), qe = "");
    }
  }
  function U(V) {
    return V >= 55296 && V <= 57343 || V > 1114111;
  }
  function Z(V) {
    return V >= 1 && V <= 8 || V === 11 || V >= 13 && V <= 31 || V >= 127 && V <= 159 || V >= 64976 && V <= 65007 || (V & 65535) === 65535 || (V & 65535) === 65534;
  }
} }), Ojt = da({ "../../../node_modules/refractor/node_modules/prismjs/components/prism-core.js"(t, e) {
  var r = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {}, n = function(a) {
    var i = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, o = 0, s = {}, l = { manual: a.Prism && a.Prism.manual, disableWorkerMessageHandler: a.Prism && a.Prism.disableWorkerMessageHandler, util: { encode: function C(x) {
      return x instanceof c ? new c(x.type, C(x.content), x.alias) : Array.isArray(x) ? x.map(C) : x.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
    }, type: function(C) {
      return Object.prototype.toString.call(C).slice(8, -1);
    }, objId: function(C) {
      return C.__id || Object.defineProperty(C, "__id", { value: ++o }), C.__id;
    }, clone: function C(x, S) {
      S = S || {};
      var A, I;
      switch (l.util.type(x)) {
        case "Object":
          if (I = l.util.objId(x), S[I]) return S[I];
          A = {}, S[I] = A;
          for (var M in x) x.hasOwnProperty(M) && (A[M] = C(x[M], S));
          return A;
        case "Array":
          return I = l.util.objId(x), S[I] ? S[I] : (A = [], S[I] = A, x.forEach(function(B, L) {
            A[L] = C(B, S);
          }), A);
        default:
          return x;
      }
    }, getLanguage: function(C) {
      for (; C; ) {
        var x = i.exec(C.className);
        if (x) return x[1].toLowerCase();
        C = C.parentElement;
      }
      return "none";
    }, setLanguage: function(C, x) {
      C.className = C.className.replace(RegExp(i, "gi"), ""), C.classList.add("language-" + x);
    }, currentScript: function() {
      if (typeof document > "u") return null;
      if ("currentScript" in document) return document.currentScript;
      try {
        throw new Error();
      } catch (A) {
        var C = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(A.stack) || [])[1];
        if (C) {
          var x = document.getElementsByTagName("script");
          for (var S in x) if (x[S].src == C) return x[S];
        }
        return null;
      }
    }, isActive: function(C, x, S) {
      for (var A = "no-" + x; C; ) {
        var I = C.classList;
        if (I.contains(x)) return !0;
        if (I.contains(A)) return !1;
        C = C.parentElement;
      }
      return !!S;
    } }, languages: { plain: s, plaintext: s, text: s, txt: s, extend: function(C, x) {
      var S = l.util.clone(l.languages[C]);
      for (var A in x) S[A] = x[A];
      return S;
    }, insertBefore: function(C, x, S, A) {
      A = A || l.languages;
      var I = A[C], M = {};
      for (var B in I) if (I.hasOwnProperty(B)) {
        if (B == x) for (var L in S) S.hasOwnProperty(L) && (M[L] = S[L]);
        S.hasOwnProperty(B) || (M[B] = I[B]);
      }
      var N = A[C];
      return A[C] = M, l.languages.DFS(l.languages, function(d, m) {
        m === N && d != C && (this[d] = M);
      }), M;
    }, DFS: function C(x, S, A, I) {
      I = I || {};
      var M = l.util.objId;
      for (var B in x) if (x.hasOwnProperty(B)) {
        S.call(x, B, x[B], A || B);
        var L = x[B], N = l.util.type(L);
        N === "Object" && !I[M(L)] ? (I[M(L)] = !0, C(L, S, null, I)) : N === "Array" && !I[M(L)] && (I[M(L)] = !0, C(L, S, B, I));
      }
    } }, plugins: {}, highlightAll: function(C, x) {
      l.highlightAllUnder(document, C, x);
    }, highlightAllUnder: function(C, x, S) {
      var A = { callback: S, container: C, selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code' };
      l.hooks.run("before-highlightall", A), A.elements = Array.prototype.slice.apply(A.container.querySelectorAll(A.selector)), l.hooks.run("before-all-elements-highlight", A);
      for (var I = 0, M; M = A.elements[I++]; ) l.highlightElement(M, x === !0, A.callback);
    }, highlightElement: function(C, x, S) {
      var A = l.util.getLanguage(C), I = l.languages[A];
      l.util.setLanguage(C, A);
      var M = C.parentElement;
      M && M.nodeName.toLowerCase() === "pre" && l.util.setLanguage(M, A);
      var B = C.textContent, L = { element: C, language: A, grammar: I, code: B };
      function N(m) {
        L.highlightedCode = m, l.hooks.run("before-insert", L), L.element.innerHTML = L.highlightedCode, l.hooks.run("after-highlight", L), l.hooks.run("complete", L), S && S.call(L.element);
      }
      if (l.hooks.run("before-sanity-check", L), M = L.element.parentElement, M && M.nodeName.toLowerCase() === "pre" && !M.hasAttribute("tabindex") && M.setAttribute("tabindex", "0"), !L.code) {
        l.hooks.run("complete", L), S && S.call(L.element);
        return;
      }
      if (l.hooks.run("before-highlight", L), !L.grammar) {
        N(l.util.encode(L.code));
        return;
      }
      if (x && a.Worker) {
        var d = new Worker(l.filename);
        d.onmessage = function(m) {
          N(m.data);
        }, d.postMessage(JSON.stringify({ language: L.language, code: L.code, immediateClose: !0 }));
      } else N(l.highlight(L.code, L.grammar, L.language));
    }, highlight: function(C, x, S) {
      var A = { code: C, grammar: x, language: S };
      if (l.hooks.run("before-tokenize", A), !A.grammar) throw new Error('The language "' + A.language + '" has no grammar.');
      return A.tokens = l.tokenize(A.code, A.grammar), l.hooks.run("after-tokenize", A), c.stringify(l.util.encode(A.tokens), A.language);
    }, tokenize: function(C, x) {
      var S = x.rest;
      if (S) {
        for (var A in S) x[A] = S[A];
        delete x.rest;
      }
      var I = new h();
      return p(I, I.head, C), f(C, I, x, I.head, 0), y(I);
    }, hooks: { all: {}, add: function(C, x) {
      var S = l.hooks.all;
      S[C] = S[C] || [], S[C].push(x);
    }, run: function(C, x) {
      var S = l.hooks.all[C];
      if (!(!S || !S.length)) for (var A = 0, I; I = S[A++]; ) I(x);
    } }, Token: c };
    a.Prism = l;
    function c(C, x, S, A) {
      this.type = C, this.content = x, this.alias = S, this.length = (A || "").length | 0;
    }
    c.stringify = function C(x, S) {
      if (typeof x == "string") return x;
      if (Array.isArray(x)) {
        var A = "";
        return x.forEach(function(N) {
          A += C(N, S);
        }), A;
      }
      var I = { type: x.type, content: C(x.content, S), tag: "span", classes: ["token", x.type], attributes: {}, language: S }, M = x.alias;
      M && (Array.isArray(M) ? Array.prototype.push.apply(I.classes, M) : I.classes.push(M)), l.hooks.run("wrap", I);
      var B = "";
      for (var L in I.attributes) B += " " + L + '="' + (I.attributes[L] || "").replace(/"/g, "&quot;") + '"';
      return "<" + I.tag + ' class="' + I.classes.join(" ") + '"' + B + ">" + I.content + "</" + I.tag + ">";
    };
    function u(C, x, S, A) {
      C.lastIndex = x;
      var I = C.exec(S);
      if (I && A && I[1]) {
        var M = I[1].length;
        I.index += M, I[0] = I[0].slice(M);
      }
      return I;
    }
    function f(C, x, S, A, I, M) {
      for (var B in S) if (!(!S.hasOwnProperty(B) || !S[B])) {
        var L = S[B];
        L = Array.isArray(L) ? L : [L];
        for (var N = 0; N < L.length; ++N) {
          if (M && M.cause == B + "," + N) return;
          var d = L[N], m = d.inside, v = !!d.lookbehind, k = !!d.greedy, O = d.alias;
          if (k && !d.pattern.global) {
            var G = d.pattern.toString().match(/[imsuy]*$/)[0];
            d.pattern = RegExp(d.pattern.source, G + "g");
          }
          for (var H = d.pattern || d, j = A.next, F = I; j !== x.tail && !(M && F >= M.reach); F += j.value.length, j = j.next) {
            var z = j.value;
            if (x.length > C.length) return;
            if (!(z instanceof c)) {
              var W = 1, U;
              if (k) {
                if (U = u(H, F, C, v), !U || U.index >= C.length) break;
                var ge = U.index, Z = U.index + U[0].length, V = F;
                for (V += j.value.length; ge >= V; ) j = j.next, V += j.value.length;
                if (V -= j.value.length, F = V, j.value instanceof c) continue;
                for (var Y = j; Y !== x.tail && (V < Z || typeof Y.value == "string"); Y = Y.next) W++, V += Y.value.length;
                W--, z = C.slice(F, V), U.index -= F;
              } else if (U = u(H, 0, z, v), !U) continue;
              var ge = U.index, ce = U[0], ee = z.slice(0, ge), Se = z.slice(ge + ce.length), Ce = F + z.length;
              M && Ce > M.reach && (M.reach = Ce);
              var we = j.prev;
              ee && (we = p(x, we, ee), F += ee.length), g(x, we, W);
              var We = new c(B, m ? l.tokenize(ce, m) : ce, O, ce);
              if (j = p(x, we, We), Se && p(x, j, Se), W > 1) {
                var Fe = { cause: B + "," + N, reach: Ce };
                f(C, x, S, j.prev, F, Fe), M && Fe.reach > M.reach && (M.reach = Fe.reach);
              }
            }
          }
        }
      }
    }
    function h() {
      var C = { value: null, prev: null, next: null }, x = { value: null, prev: C, next: null };
      C.next = x, this.head = C, this.tail = x, this.length = 0;
    }
    function p(C, x, S) {
      var A = x.next, I = { value: S, prev: x, next: A };
      return x.next = I, A.prev = I, C.length++, I;
    }
    function g(C, x, S) {
      for (var A = x.next, I = 0; I < S && A !== C.tail; I++) A = A.next;
      x.next = A, A.prev = x, C.length -= I;
    }
    function y(C) {
      for (var x = [], S = C.head.next; S !== C.tail; ) x.push(S.value), S = S.next;
      return x;
    }
    if (!a.document) return a.addEventListener && (l.disableWorkerMessageHandler || a.addEventListener("message", function(C) {
      var x = JSON.parse(C.data), S = x.language, A = x.code, I = x.immediateClose;
      a.postMessage(l.highlight(A, l.languages[S], S)), I && a.close();
    }, !1)), l;
    var b = l.util.currentScript();
    b && (l.filename = b.src, b.hasAttribute("data-manual") && (l.manual = !0));
    function w() {
      l.manual || l.highlightAll();
    }
    if (!l.manual) {
      var _ = document.readyState;
      _ === "loading" || _ === "interactive" && b && b.defer ? document.addEventListener("DOMContentLoaded", w) : window.requestAnimationFrame ? window.requestAnimationFrame(w) : window.setTimeout(w, 16);
    }
    return l;
  }(r);
  typeof e < "u" && e.exports && (e.exports = n), typeof ss < "u" && (ss.Prism = n);
} }), Bjt = da({ "../../../node_modules/refractor/lang/markup.js"(t, e) {
  e.exports = r, r.displayName = "markup", r.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function r(n) {
    n.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: !0 }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: !0 }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: !0, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: !0, greedy: !0, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: !0 }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: !0 }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: !0, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, n.languages.markup.tag.inside["attr-value"].inside.entity = n.languages.markup.entity, n.languages.markup.doctype.inside["internal-subset"].inside = n.languages.markup, n.hooks.add("wrap", function(a) {
      a.type === "entity" && (a.attributes.title = a.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(n.languages.markup.tag, "addInlined", { value: function(a, i) {
      var o = {};
      o["language-" + i] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: !0, inside: n.languages[i] }, o.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var s = { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: o } };
      s["language-" + i] = { pattern: /[\s\S]+/, inside: n.languages[i] };
      var l = {};
      l[a] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
        return a;
      }), "i"), lookbehind: !0, greedy: !0, inside: s }, n.languages.insertBefore("markup", "cdata", l);
    } }), Object.defineProperty(n.languages.markup.tag, "addAttribute", { value: function(a, i) {
      n.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + a + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: !0, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: !0, alias: [i, "language-" + i], inside: n.languages[i] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
    } }), n.languages.html = n.languages.markup, n.languages.mathml = n.languages.markup, n.languages.svg = n.languages.markup, n.languages.xml = n.languages.extend("markup", {}), n.languages.ssml = n.languages.xml, n.languages.atom = n.languages.xml, n.languages.rss = n.languages.xml;
  }
} }), Njt = da({ "../../../node_modules/refractor/lang/css.js"(t, e) {
  e.exports = r, r.displayName = "css", r.aliases = [];
  function r(n) {
    (function(a) {
      var i = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      a.languages.css = { comment: /\/\*[\s\S]*?\*\//, atrule: { pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/, inside: { rule: /^@[\w-]+/, "selector-function-argument": { pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind: !0, alias: "selector" }, keyword: { pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/, lookbehind: !0 } } }, url: { pattern: RegExp("\\burl\\((?:" + i.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy: !0, inside: { function: /^url/i, punctuation: /^\(|\)$/, string: { pattern: RegExp("^" + i.source + "$"), alias: "url" } } }, selector: { pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + i.source + ")*(?=\\s*\\{)"), lookbehind: !0 }, string: { pattern: i, greedy: !0 }, property: { pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, lookbehind: !0 }, important: /!important\b/i, function: { pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind: !0 }, punctuation: /[(){};:,]/ }, a.languages.css.atrule.inside.rest = a.languages.css;
      var o = a.languages.markup;
      o && (o.tag.addInlined("style", "css"), o.tag.addAttribute("style", "css"));
    })(n);
  }
} }), $jt = da({ "../../../node_modules/refractor/lang/clike.js"(t, e) {
  e.exports = r, r.displayName = "clike", r.aliases = [];
  function r(n) {
    n.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind: !0, greedy: !0 }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: !0, greedy: !0 }], string: { pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: !0 }, "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind: !0, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, boolean: /\b(?:false|true)\b/, function: /\b\w+(?=\()/, number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation: /[{}[\];(),.:]/ };
  }
} }), AZe = da({ "../../../node_modules/refractor/lang/javascript.js"(t, e) {
  e.exports = r, r.displayName = "javascript", r.aliases = ["js"];
  function r(n) {
    n.languages.javascript = n.languages.extend("clike", { "class-name": [n.languages.clike["class-name"], { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind: !0 }], keyword: [{ pattern: /((?:^|\})\s*)catch\b/, lookbehind: !0 }, { pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind: !0 }], function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, number: { pattern: RegExp(/(^|[^\w$])/.source + "(?:" + (/NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source), lookbehind: !0 }, operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/ }), n.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, n.languages.insertBefore("javascript", "keyword", { regex: { pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/, lookbehind: !0, greedy: !0, inside: { "regex-source": { pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind: !0, alias: "language-regex", inside: n.languages.regex }, "regex-delimiter": /^\/|\/$/, "regex-flags": /^[a-z]+$/ } }, "function-variable": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias: "function" }, parameter: [{ pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, lookbehind: !0, inside: n.languages.javascript }, { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind: !0, inside: n.languages.javascript }, { pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind: !0, inside: n.languages.javascript }, { pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, lookbehind: !0, inside: n.languages.javascript }], constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/ }), n.languages.insertBefore("javascript", "string", { hashbang: { pattern: /^#!.*/, greedy: !0, alias: "comment" }, "template-string": { pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy: !0, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind: !0, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: n.languages.javascript } }, string: /[\s\S]+/ } }, "string-property": { pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind: !0, greedy: !0, alias: "property" } }), n.languages.insertBefore("javascript", "operator", { "literal-property": { pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind: !0, alias: "property" } }), n.languages.markup && (n.languages.markup.tag.addInlined("script", "javascript"), n.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), n.languages.js = n.languages.javascript;
  }
} }), Djt = da({ "../../../node_modules/refractor/core.js"(t, e) {
  var r = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof ss == "object" ? ss : {}, n = I();
  r.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
  var a = kjt(), i = Rjt(), o = Ojt(), s = Bjt(), l = Njt(), c = $jt(), u = AZe();
  n();
  var f = {}.hasOwnProperty;
  function h() {
  }
  h.prototype = o;
  var p = new h();
  e.exports = p, p.highlight = b, p.register = g, p.alias = y, p.registered = w, p.listLanguages = _, g(s), g(l), g(c), g(u), p.util.encode = S, p.Token.stringify = C;
  function g(M) {
    if (typeof M != "function" || !M.displayName) throw new Error("Expected `function` for `grammar`, got `" + M + "`");
    p.languages[M.displayName] === void 0 && M(p);
  }
  function y(M, B) {
    var L = p.languages, N = M, d, m, v, k;
    B && (N = {}, N[M] = B);
    for (d in N) for (m = N[d], m = typeof m == "string" ? [m] : m, v = m.length, k = -1; ++k < v; ) L[m[k]] = L[d];
  }
  function b(M, B) {
    var L = o.highlight, N;
    if (typeof M != "string") throw new Error("Expected `string` for `value`, got `" + M + "`");
    if (p.util.type(B) === "Object") N = B, B = null;
    else {
      if (typeof B != "string") throw new Error("Expected `string` for `name`, got `" + B + "`");
      if (f.call(p.languages, B)) N = p.languages[B];
      else throw new Error("Unknown language: `" + B + "` is not registered");
    }
    return L.call(this, M, N, B);
  }
  function w(M) {
    if (typeof M != "string") throw new Error("Expected `string` for `language`, got `" + M + "`");
    return f.call(p.languages, M);
  }
  function _() {
    var M = p.languages, B = [], L;
    for (L in M) f.call(M, L) && typeof M[L] == "object" && B.push(L);
    return B;
  }
  function C(M, B, L) {
    var N;
    return typeof M == "string" ? { type: "text", value: M } : p.util.type(M) === "Array" ? x(M, B) : (N = { type: M.type, content: p.Token.stringify(M.content, B, L), tag: "span", classes: ["token", M.type], attributes: {}, language: B, parent: L }, M.alias && (N.classes = N.classes.concat(M.alias)), p.hooks.run("wrap", N), a(N.tag + "." + N.classes.join("."), A(N.attributes), N.content));
  }
  function x(M, B) {
    for (var L = [], N = M.length, d = -1, m; ++d < N; ) m = M[d], m !== "" && m !== null && m !== void 0 && L.push(m);
    for (d = -1, N = L.length; ++d < N; ) m = L[d], L[d] = p.Token.stringify(m, B, L);
    return L;
  }
  function S(M) {
    return M;
  }
  function A(M) {
    var B;
    for (B in M) M[B] = i(M[B]);
    return M;
  }
  function I() {
    var M = "Prism" in r, B = M ? r.Prism : void 0;
    return L;
    function L() {
      M ? r.Prism = B : delete r.Prism, M = void 0, B = void 0;
    }
  }
} }), TZe = da({ "../../../node_modules/refractor/lang/bash.js"(t, e) {
  e.exports = r, r.displayName = "bash", r.aliases = ["shell"];
  function r(n) {
    (function(a) {
      var i = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", o = { pattern: /(^(["']?)\w+\2)[ \t]+\S.*/, lookbehind: !0, alias: "punctuation", inside: null }, s = { bash: o, environment: { pattern: RegExp("\\$" + i), alias: "constant" }, variable: [{ pattern: /\$?\(\([\s\S]+?\)\)/, greedy: !0, inside: { variable: [{ pattern: /(^\$\(\([\s\S]+)\)\)/, lookbehind: !0 }, /^\$\(\(/], number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/, operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/, punctuation: /\(\(?|\)\)?|,|;/ } }, { pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/, greedy: !0, inside: { variable: /^\$\(|^`|\)$|`$/ } }, { pattern: /\$\{[^}]+\}/, greedy: !0, inside: { operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/, punctuation: /[\[\]]/, environment: { pattern: RegExp("(\\{)" + i), lookbehind: !0, alias: "constant" } } }, /\$(?:\w+|[#?*!@$])/], entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/ };
      a.languages.bash = { shebang: { pattern: /^#!\s*\/.*/, alias: "important" }, comment: { pattern: /(^|[^"{\\$])#.*/, lookbehind: !0 }, "function-name": [{ pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/, lookbehind: !0, alias: "function" }, { pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/, alias: "function" }], "for-or-select": { pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/, alias: "variable", lookbehind: !0 }, "assign-left": { pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/, inside: { environment: { pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + i), lookbehind: !0, alias: "constant" } }, alias: "variable", lookbehind: !0 }, string: [{ pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/, lookbehind: !0, greedy: !0, inside: s }, { pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/, lookbehind: !0, greedy: !0, inside: { bash: o } }, { pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/, lookbehind: !0, greedy: !0, inside: s }, { pattern: /(^|[^$\\])'[^']*'/, lookbehind: !0, greedy: !0 }, { pattern: /\$'(?:[^'\\]|\\[\s\S])*'/, greedy: !0, inside: { entity: s.entity } }], environment: { pattern: RegExp("\\$?" + i), alias: "constant" }, variable: s.variable, function: { pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/, lookbehind: !0 }, keyword: { pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/, lookbehind: !0 }, builtin: { pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/, lookbehind: !0, alias: "class-name" }, boolean: { pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/, lookbehind: !0 }, "file-descriptor": { pattern: /\B&\d\b/, alias: "important" }, operator: { pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/, inside: { "file-descriptor": { pattern: /^\d/, alias: "important" } } }, punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/, number: { pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/, lookbehind: !0 } }, o.inside = a.languages.bash;
      for (var l = ["comment", "function-name", "for-or-select", "assign-left", "string", "environment", "function", "keyword", "builtin", "boolean", "file-descriptor", "operator", "punctuation", "number"], c = s.variable[1].inside, u = 0; u < l.length; u++) c[l[u]] = a.languages.bash[l[u]];
      a.languages.shell = a.languages.bash;
    })(n);
  }
} }), Ljt = da({ "../../../node_modules/refractor/lang/c.js"(t, e) {
  e.exports = r, r.displayName = "c", r.aliases = [];
  function r(n) {
    n.languages.c = n.languages.extend("clike", { comment: { pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: !0 }, string: { pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/, greedy: !0 }, "class-name": { pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/, lookbehind: !0 }, keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/, function: /\b[a-z_]\w*(?=\s*\()/i, number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i, operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/ }), n.languages.insertBefore("c", "string", { char: { pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/, greedy: !0 } }), n.languages.insertBefore("c", "string", { macro: { pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im, lookbehind: !0, greedy: !0, alias: "property", inside: { string: [{ pattern: /^(#\s*include\s*)<[^>]+>/, lookbehind: !0 }, n.languages.c.string], char: n.languages.c.char, comment: n.languages.c.comment, "macro-name": [{ pattern: /(^#\s*define\s+)\w+\b(?!\()/i, lookbehind: !0 }, { pattern: /(^#\s*define\s+)\w+\b(?=\()/i, lookbehind: !0, alias: "function" }], directive: { pattern: /^(#\s*)[a-z]+/, lookbehind: !0, alias: "keyword" }, "directive-hash": /^#/, punctuation: /##|\\(?=[\r\n])/, expression: { pattern: /\S[\s\S]*/, inside: n.languages.c } } } }), n.languages.insertBefore("c", "function", { constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/ }), delete n.languages.c.boolean;
  }
} }), jjt = da({ "../../../node_modules/refractor/lang/csharp.js"(t, e) {
  e.exports = r, r.displayName = "csharp", r.aliases = ["dotnet", "cs"];
  function r(n) {
    (function(a) {
      function i(U, Z) {
        return U.replace(/<<(\d+)>>/g, function(V, Y) {
          return "(?:" + Z[+Y] + ")";
        });
      }
      function o(U, Z, V) {
        return RegExp(i(U, Z), "");
      }
      function s(U, Z) {
        for (var V = 0; V < Z; V++) U = U.replace(/<<self>>/g, function() {
          return "(?:" + U + ")";
        });
        return U.replace(/<<self>>/g, "[^\\s\\S]");
      }
      var l = { type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void", typeDeclaration: "class enum interface record struct", contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)", other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield" };
      function c(U) {
        return "\\b(?:" + U.trim().replace(/ /g, "|") + ")\\b";
      }
      var u = c(l.typeDeclaration), f = RegExp(c(l.type + " " + l.typeDeclaration + " " + l.contextual + " " + l.other)), h = c(l.typeDeclaration + " " + l.contextual + " " + l.other), p = c(l.type + " " + l.typeDeclaration + " " + l.other), g = s(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), y = s(/\((?:[^()]|<<self>>)*\)/.source, 2), b = /@?\b[A-Za-z_]\w*\b/.source, w = i(/<<0>>(?:\s*<<1>>)?/.source, [b, g]), _ = i(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [h, w]), C = /\[\s*(?:,\s*)*\]/.source, x = i(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [_, C]), S = i(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [g, y, C]), A = i(/\(<<0>>+(?:,<<0>>+)+\)/.source, [S]), I = i(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [A, _, C]), M = { keyword: f, punctuation: /[<>()?,.:[\]]/ }, B = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, L = /"(?:\\.|[^\\"\r\n])*"/.source, N = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
      a.languages.csharp = a.languages.extend("clike", { string: [{ pattern: o(/(^|[^$\\])<<0>>/.source, [N]), lookbehind: !0, greedy: !0 }, { pattern: o(/(^|[^@$\\])<<0>>/.source, [L]), lookbehind: !0, greedy: !0 }], "class-name": [{ pattern: o(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [_]), lookbehind: !0, inside: M }, { pattern: o(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [b, I]), lookbehind: !0, inside: M }, { pattern: o(/(\busing\s+)<<0>>(?=\s*=)/.source, [b]), lookbehind: !0 }, { pattern: o(/(\b<<0>>\s+)<<1>>/.source, [u, w]), lookbehind: !0, inside: M }, { pattern: o(/(\bcatch\s*\(\s*)<<0>>/.source, [_]), lookbehind: !0, inside: M }, { pattern: o(/(\bwhere\s+)<<0>>/.source, [b]), lookbehind: !0 }, { pattern: o(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [x]), lookbehind: !0, inside: M }, { pattern: o(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [I, p, b]), inside: M }], keyword: f, number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i, operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/, punctuation: /\?\.?|::|[{}[\];(),.:]/ }), a.languages.insertBefore("csharp", "number", { range: { pattern: /\.\./, alias: "operator" } }), a.languages.insertBefore("csharp", "punctuation", { "named-parameter": { pattern: o(/([(,]\s*)<<0>>(?=\s*:)/.source, [b]), lookbehind: !0, alias: "punctuation" } }), a.languages.insertBefore("csharp", "class-name", { namespace: { pattern: o(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [b]), lookbehind: !0, inside: { punctuation: /\./ } }, "type-expression": { pattern: o(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [y]), lookbehind: !0, alias: "class-name", inside: M }, "return-type": { pattern: o(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [I, _]), inside: M, alias: "class-name" }, "constructor-invocation": { pattern: o(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [I]), lookbehind: !0, inside: M, alias: "class-name" }, "generic-method": { pattern: o(/<<0>>\s*<<1>>(?=\s*\()/.source, [b, g]), inside: { function: o(/^<<0>>/.source, [b]), generic: { pattern: RegExp(g), alias: "class-name", inside: M } } }, "type-list": { pattern: o(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [u, w, b, I, f.source, y, /\bnew\s*\(\s*\)/.source]), lookbehind: !0, inside: { "record-arguments": { pattern: o(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [w, y]), lookbehind: !0, greedy: !0, inside: a.languages.csharp }, keyword: f, "class-name": { pattern: RegExp(I), greedy: !0, inside: M }, punctuation: /[,()]/ } }, preprocessor: { pattern: /(^[\t ]*)#.*/m, lookbehind: !0, alias: "property", inside: { directive: { pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/, lookbehind: !0, alias: "keyword" } } } });
      var d = L + "|" + B, m = i(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [d]), v = s(i(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [m]), 2), k = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, O = i(/<<0>>(?:\s*\(<<1>>*\))?/.source, [_, v]);
      a.languages.insertBefore("csharp", "class-name", { attribute: { pattern: o(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [k, O]), lookbehind: !0, greedy: !0, inside: { target: { pattern: o(/^<<0>>(?=\s*:)/.source, [k]), alias: "keyword" }, "attribute-arguments": { pattern: o(/\(<<0>>*\)/.source, [v]), inside: a.languages.csharp }, "class-name": { pattern: RegExp(_), inside: { punctuation: /\./ } }, punctuation: /[:,]/ } } });
      var G = /:[^}\r\n]+/.source, H = s(i(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [m]), 2), j = i(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [H, G]), F = s(i(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [d]), 2), z = i(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [F, G]);
      function W(U, Z) {
        return { interpolation: { pattern: o(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [U]), lookbehind: !0, inside: { "format-string": { pattern: o(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [Z, G]), lookbehind: !0, inside: { punctuation: /^:/ } }, punctuation: /^\{|\}$/, expression: { pattern: /[\s\S]+/, alias: "language-csharp", inside: a.languages.csharp } } }, string: /[\s\S]+/ };
      }
      a.languages.insertBefore("csharp", "string", { "interpolation-string": [{ pattern: o(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [j]), lookbehind: !0, greedy: !0, inside: W(j, H) }, { pattern: o(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [z]), lookbehind: !0, greedy: !0, inside: W(z, F) }], char: { pattern: RegExp(B), greedy: !0 } }), a.languages.dotnet = a.languages.cs = a.languages.csharp;
    })(n);
  }
} }), Fjt = da({ "../../../node_modules/refractor/lang/go.js"(t, e) {
  e.exports = r, r.displayName = "go", r.aliases = [];
  function r(n) {
    n.languages.go = n.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/, lookbehind: !0, greedy: !0 }, keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/, boolean: /\b(?:_|false|iota|nil|true)\b/, number: [/\b0(?:b[01_]+|o[0-7_]+)i?\b/i, /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i, /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i], operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./, builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/ }), n.languages.insertBefore("go", "string", { char: { pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/, greedy: !0 } }), delete n.languages.go["class-name"];
  }
} }), zjt = da({ "../../../node_modules/refractor/lang/groovy.js"(t, e) {
  e.exports = r, r.displayName = "groovy", r.aliases = [];
  function r(n) {
    n.languages.groovy = n.languages.extend("clike", { string: [{ pattern: /("""|''')(?:[^\\]|\\[\s\S])*?\1|\$\/(?:[^/$]|\$(?:[/$]|(?![/$]))|\/(?!\$))*\/\$/, greedy: !0 }, { pattern: /(["'/])(?:\\.|(?!\1)[^\\\r\n])*\1/, greedy: !0 }], keyword: /\b(?:abstract|as|assert|boolean|break|byte|case|catch|char|class|const|continue|def|default|do|double|else|enum|extends|final|finally|float|for|goto|if|implements|import|in|instanceof|int|interface|long|native|new|package|private|protected|public|return|short|static|strictfp|super|switch|synchronized|this|throw|throws|trait|transient|try|void|volatile|while)\b/, number: /\b(?:0b[01_]+|0x[\da-f_]+(?:\.[\da-f_p\-]+)?|[\d_]+(?:\.[\d_]+)?(?:e[+-]?\d+)?)[glidf]?\b/i, operator: { pattern: /(^|[^.])(?:~|==?~?|\?[.:]?|\*(?:[.=]|\*=?)?|\.[@&]|\.\.<|\.\.(?!\.)|-[-=>]?|\+[+=]?|!=?|<(?:<=?|=>?)?|>(?:>>?=?|=)?|&[&=]?|\|[|=]?|\/=?|\^=?|%=?)/, lookbehind: !0 }, punctuation: /\.+|[{}[\];(),:$]/ }), n.languages.insertBefore("groovy", "string", { shebang: { pattern: /#!.+/, alias: "comment" } }), n.languages.insertBefore("groovy", "punctuation", { "spock-block": /\b(?:and|cleanup|expect|given|setup|then|when|where):/ }), n.languages.insertBefore("groovy", "function", { annotation: { pattern: /(^|[^.])@\w+/, lookbehind: !0, alias: "punctuation" } }), n.hooks.add("wrap", function(a) {
      if (a.language === "groovy" && a.type === "string") {
        var i = a.content.value[0];
        if (i != "'") {
          var o = /([^\\])(?:\$(?:\{.*?\}|[\w.]+))/;
          i === "$" && (o = /([^\$])(?:\$(?:\{.*?\}|[\w.]+))/), a.content.value = a.content.value.replace(/&lt;/g, "<").replace(/&amp;/g, "&"), a.content = n.highlight(a.content.value, { expression: { pattern: o, lookbehind: !0, inside: n.languages.groovy } }), a.classes.push(i === "/" ? "regex" : "gstring");
        }
      }
    });
  }
} }), Gjt = da({ "../../../node_modules/refractor/lang/java.js"(t, e) {
  e.exports = r, r.displayName = "java", r.aliases = [];
  function r(n) {
    (function(a) {
      var i = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, o = /(^|[^\w.])(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, s = { pattern: RegExp(o + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source), lookbehind: !0, inside: { namespace: { pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/, inside: { punctuation: /\./ } }, punctuation: /\./ } };
      a.languages.java = a.languages.extend("clike", { string: { pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/, lookbehind: !0, greedy: !0 }, "class-name": [s, { pattern: RegExp(o + /[A-Z]\w*(?=\s+\w+\s*[;,=()])/.source), lookbehind: !0, inside: s.inside }], keyword: i, function: [a.languages.clike.function, { pattern: /(::\s*)[a-z_]\w*/, lookbehind: !0 }], number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i, operator: { pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m, lookbehind: !0 } }), a.languages.insertBefore("java", "string", { "triple-quoted-string": { pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/, greedy: !0, alias: "string" }, char: { pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/, greedy: !0 } }), a.languages.insertBefore("java", "class-name", { annotation: { pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/, lookbehind: !0, alias: "punctuation" }, generics: { pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/, inside: { "class-name": s, keyword: i, punctuation: /[<>(),.:]/, operator: /[?&|]/ } }, namespace: { pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
        return i.source;
      })), lookbehind: !0, inside: { punctuation: /\./ } } });
    })(n);
  }
} }), Wjt = da({ "../../../node_modules/refractor/lang/json.js"(t, e) {
  e.exports = r, r.displayName = "json", r.aliases = ["webmanifest"];
  function r(n) {
    n.languages.json = { property: { pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/, lookbehind: !0, greedy: !0 }, string: { pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/, lookbehind: !0, greedy: !0 }, comment: { pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: !0 }, number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, punctuation: /[{}[\],]/, operator: /:/, boolean: /\b(?:false|true)\b/, null: { pattern: /\bnull\b/, alias: "keyword" } }, n.languages.webmanifest = n.languages.json;
  }
} }), Hjt = da({ "../../../node_modules/refractor/lang/jsx.js"(t, e) {
  e.exports = r, r.displayName = "jsx", r.aliases = [];
  function r(n) {
    (function(a) {
      var i = a.util.clone(a.languages.javascript), o = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, s = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, l = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function c(h, p) {
        return h = h.replace(/<S>/g, function() {
          return o;
        }).replace(/<BRACES>/g, function() {
          return s;
        }).replace(/<SPREAD>/g, function() {
          return l;
        }), RegExp(h, p);
      }
      l = c(l).source, a.languages.jsx = a.languages.extend("markup", i), a.languages.jsx.tag.pattern = c(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), a.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, a.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, a.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, a.languages.jsx.tag.inside.comment = i.comment, a.languages.insertBefore("inside", "attr-name", { spread: { pattern: c(/<SPREAD>/.source), inside: a.languages.jsx } }, a.languages.jsx.tag), a.languages.insertBefore("inside", "special-attr", { script: { pattern: c(/=<BRACES>/.source), alias: "language-javascript", inside: { "script-punctuation": { pattern: /^=(?=\{)/, alias: "punctuation" }, rest: a.languages.jsx } } }, a.languages.jsx.tag);
      var u = function(h) {
        return h ? typeof h == "string" ? h : typeof h.content == "string" ? h.content : h.content.map(u).join("") : "";
      }, f = function(h) {
        for (var p = [], g = 0; g < h.length; g++) {
          var y = h[g], b = !1;
          if (typeof y != "string" && (y.type === "tag" && y.content[0] && y.content[0].type === "tag" ? y.content[0].content[0].content === "</" ? p.length > 0 && p[p.length - 1].tagName === u(y.content[0].content[1]) && p.pop() : y.content[y.content.length - 1].content === "/>" || p.push({ tagName: u(y.content[0].content[1]), openedBraces: 0 }) : p.length > 0 && y.type === "punctuation" && y.content === "{" ? p[p.length - 1].openedBraces++ : p.length > 0 && p[p.length - 1].openedBraces > 0 && y.type === "punctuation" && y.content === "}" ? p[p.length - 1].openedBraces-- : b = !0), (b || typeof y == "string") && p.length > 0 && p[p.length - 1].openedBraces === 0) {
            var w = u(y);
            g < h.length - 1 && (typeof h[g + 1] == "string" || h[g + 1].type === "plain-text") && (w += u(h[g + 1]), h.splice(g + 1, 1)), g > 0 && (typeof h[g - 1] == "string" || h[g - 1].type === "plain-text") && (w = u(h[g - 1]) + w, h.splice(g - 1, 1), g--), h[g] = new a.Token("plain-text", w, null, w);
          }
          y.content && typeof y.content != "string" && f(y.content);
        }
      };
      a.hooks.add("after-tokenize", function(h) {
        h.language !== "jsx" && h.language !== "tsx" || f(h.tokens);
      });
    })(n);
  }
} }), Ujt = da({ "../../../node_modules/refractor/lang/markup-templating.js"(t, e) {
  e.exports = r, r.displayName = "markupTemplating", r.aliases = [];
  function r(n) {
    (function(a) {
      function i(o, s) {
        return "___" + o.toUpperCase() + s + "___";
      }
      Object.defineProperties(a.languages["markup-templating"] = {}, { buildPlaceholders: { value: function(o, s, l, c) {
        if (o.language === s) {
          var u = o.tokenStack = [];
          o.code = o.code.replace(l, function(f) {
            if (typeof c == "function" && !c(f)) return f;
            for (var h = u.length, p; o.code.indexOf(p = i(s, h)) !== -1; ) ++h;
            return u[h] = f, p;
          }), o.grammar = a.languages.markup;
        }
      } }, tokenizePlaceholders: { value: function(o, s) {
        if (o.language !== s || !o.tokenStack) return;
        o.grammar = a.languages[s];
        var l = 0, c = Object.keys(o.tokenStack);
        function u(f) {
          for (var h = 0; h < f.length && !(l >= c.length); h++) {
            var p = f[h];
            if (typeof p == "string" || p.content && typeof p.content == "string") {
              var g = c[l], y = o.tokenStack[g], b = typeof p == "string" ? p : p.content, w = i(s, g), _ = b.indexOf(w);
              if (_ > -1) {
                ++l;
                var C = b.substring(0, _), x = new a.Token(s, a.tokenize(y, o.grammar), "language-" + s, y), S = b.substring(_ + w.length), A = [];
                C && A.push.apply(A, u([C])), A.push(x), S && A.push.apply(A, u([S])), typeof p == "string" ? f.splice.apply(f, [h, 1].concat(A)) : p.content = A;
              }
            } else p.content && u(p.content);
          }
          return f;
        }
        u(o.tokens);
      } } });
    })(n);
  }
} }), Vjt = da({ "../../../node_modules/refractor/lang/php.js"(t, e) {
  var r = Ujt();
  e.exports = n, n.displayName = "php", n.aliases = [];
  function n(a) {
    a.register(r), function(i) {
      var o = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, s = [{ pattern: /\b(?:false|true)\b/i, alias: "boolean" }, { pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i, greedy: !0, lookbehind: !0 }, { pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i, greedy: !0, lookbehind: !0 }, /\b(?:null)\b/i, /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/], l = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, c = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, u = /[{}\[\](),:;]/;
      i.languages.php = { delimiter: { pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i, alias: "important" }, comment: o, variable: /\$+(?:\w+\b|(?=\{))/, package: { pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, lookbehind: !0, inside: { punctuation: /\\/ } }, "class-name-definition": { pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i, lookbehind: !0, alias: "class-name" }, "function-definition": { pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i, lookbehind: !0, alias: "function" }, keyword: [{ pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i, alias: "type-casting", greedy: !0, lookbehind: !0 }, { pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i, alias: "type-hint", greedy: !0, lookbehind: !0 }, { pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string|void)\b/i, alias: "return-type", greedy: !0, lookbehind: !0 }, { pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i, alias: "type-declaration", greedy: !0 }, { pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i, alias: "type-declaration", greedy: !0, lookbehind: !0 }, { pattern: /\b(?:parent|self|static)(?=\s*::)/i, alias: "static-context", greedy: !0 }, { pattern: /(\byield\s+)from\b/i, lookbehind: !0 }, /\bclass\b/i, { pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|new|or|parent|print|private|protected|public|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i, lookbehind: !0 }], "argument-name": { pattern: /([(,]\s+)\b[a-z_]\w*(?=\s*:(?!:))/i, lookbehind: !0 }, "class-name": [{ pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i, greedy: !0, lookbehind: !0 }, { pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i, greedy: !0, lookbehind: !0 }, { pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i, greedy: !0 }, { pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i, alias: "class-name-fully-qualified", greedy: !0, lookbehind: !0, inside: { punctuation: /\\/ } }, { pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i, alias: "class-name-fully-qualified", greedy: !0, inside: { punctuation: /\\/ } }, { pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, alias: "class-name-fully-qualified", greedy: !0, lookbehind: !0, inside: { punctuation: /\\/ } }, { pattern: /\b[a-z_]\w*(?=\s*\$)/i, alias: "type-declaration", greedy: !0 }, { pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i, alias: ["class-name-fully-qualified", "type-declaration"], greedy: !0, inside: { punctuation: /\\/ } }, { pattern: /\b[a-z_]\w*(?=\s*::)/i, alias: "static-context", greedy: !0 }, { pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i, alias: ["class-name-fully-qualified", "static-context"], greedy: !0, inside: { punctuation: /\\/ } }, { pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i, alias: "type-hint", greedy: !0, lookbehind: !0 }, { pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i, alias: ["class-name-fully-qualified", "type-hint"], greedy: !0, lookbehind: !0, inside: { punctuation: /\\/ } }, { pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i, alias: "return-type", greedy: !0, lookbehind: !0 }, { pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i, alias: ["class-name-fully-qualified", "return-type"], greedy: !0, lookbehind: !0, inside: { punctuation: /\\/ } }], constant: s, function: { pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i, lookbehind: !0, inside: { punctuation: /\\/ } }, property: { pattern: /(->\s*)\w+/, lookbehind: !0 }, number: l, operator: c, punctuation: u };
      var f = { pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/, lookbehind: !0, inside: i.languages.php }, h = [{ pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/, alias: "nowdoc-string", greedy: !0, inside: { delimiter: { pattern: /^<<<'[^']+'|[a-z_]\w*;$/i, alias: "symbol", inside: { punctuation: /^<<<'?|[';]$/ } } } }, { pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i, alias: "heredoc-string", greedy: !0, inside: { delimiter: { pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i, alias: "symbol", inside: { punctuation: /^<<<"?|[";]$/ } }, interpolation: f } }, { pattern: /`(?:\\[\s\S]|[^\\`])*`/, alias: "backtick-quoted-string", greedy: !0 }, { pattern: /'(?:\\[\s\S]|[^\\'])*'/, alias: "single-quoted-string", greedy: !0 }, { pattern: /"(?:\\[\s\S]|[^\\"])*"/, alias: "double-quoted-string", greedy: !0, inside: { interpolation: f } }];
      i.languages.insertBefore("php", "variable", { string: h, attribute: { pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im, greedy: !0, inside: { "attribute-content": { pattern: /^(#\[)[\s\S]+(?=\]$)/, lookbehind: !0, inside: { comment: o, string: h, "attribute-class-name": [{ pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i, alias: "class-name", greedy: !0, lookbehind: !0 }, { pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i, alias: ["class-name", "class-name-fully-qualified"], greedy: !0, lookbehind: !0, inside: { punctuation: /\\/ } }], constant: s, number: l, operator: c, punctuation: u } }, delimiter: { pattern: /^#\[|\]$/, alias: "punctuation" } } } }), i.hooks.add("before-tokenize", function(p) {
        if (/<\?/.test(p.code)) {
          var g = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
          i.languages["markup-templating"].buildPlaceholders(p, "php", g);
        }
      }), i.hooks.add("after-tokenize", function(p) {
        i.languages["markup-templating"].tokenizePlaceholders(p, "php");
      });
    }(a);
  }
} }), qjt = da({ "../../../node_modules/refractor/lang/python.js"(t, e) {
  e.exports = r, r.displayName = "python", r.aliases = ["py"];
  function r(n) {
    n.languages.python = { comment: { pattern: /(^|[^\\])#.*/, lookbehind: !0, greedy: !0 }, "string-interpolation": { pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i, greedy: !0, inside: { interpolation: { pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/, lookbehind: !0, inside: { "format-spec": { pattern: /(:)[^:(){}]+(?=\}$)/, lookbehind: !0 }, "conversion-option": { pattern: /![sra](?=[:}]$)/, alias: "punctuation" }, rest: null } }, string: /[\s\S]+/ } }, "triple-quoted-string": { pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i, greedy: !0, alias: "string" }, string: { pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i, greedy: !0 }, function: { pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g, lookbehind: !0 }, "class-name": { pattern: /(\bclass\s+)\w+/i, lookbehind: !0 }, decorator: { pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m, lookbehind: !0, alias: ["annotation", "punctuation"], inside: { punctuation: /\./ } }, keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/, builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/, boolean: /\b(?:False|None|True)\b/, number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i, operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/, punctuation: /[{}[\];(),.:]/ }, n.languages.python["string-interpolation"].inside.interpolation.inside.rest = n.languages.python, n.languages.py = n.languages.python;
  }
} }), Kjt = da({ "../../../node_modules/refractor/lang/ruby.js"(t, e) {
  e.exports = r, r.displayName = "ruby", r.aliases = ["rb"];
  function r(n) {
    (function(a) {
      a.languages.ruby = a.languages.extend("clike", { comment: { pattern: /#.*|^=begin\s[\s\S]*?^=end/m, greedy: !0 }, "class-name": { pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/, lookbehind: !0, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/, operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/, punctuation: /[(){}[\].,;]/ }), a.languages.insertBefore("ruby", "operator", { "double-colon": { pattern: /::/, alias: "punctuation" } });
      var i = { pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/, lookbehind: !0, inside: { content: { pattern: /^(#\{)[\s\S]+(?=\}$)/, lookbehind: !0, inside: a.languages.ruby }, delimiter: { pattern: /^#\{|\}$/, alias: "punctuation" } } };
      delete a.languages.ruby.function;
      var o = "(?:" + [/([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source, /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source, /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source, /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source, /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source].join("|") + ")", s = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
      a.languages.insertBefore("ruby", "keyword", { "regex-literal": [{ pattern: RegExp(/%r/.source + o + /[egimnosux]{0,6}/.source), greedy: !0, inside: { interpolation: i, regex: /[\s\S]+/ } }, { pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/, lookbehind: !0, greedy: !0, inside: { interpolation: i, regex: /[\s\S]+/ } }], variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/, symbol: [{ pattern: RegExp(/(^|[^:]):/.source + s), lookbehind: !0, greedy: !0 }, { pattern: RegExp(/([\r\n{(,][ \t]*)/.source + s + /(?=:(?!:))/.source), lookbehind: !0, greedy: !0 }], "method-definition": { pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/, lookbehind: !0, inside: { function: /\b\w+$/, keyword: /^self\b/, "class-name": /^\w+/, punctuation: /\./ } } }), a.languages.insertBefore("ruby", "string", { "string-literal": [{ pattern: RegExp(/%[qQiIwWs]?/.source + o), greedy: !0, inside: { interpolation: i, string: /[\s\S]+/ } }, { pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/, greedy: !0, inside: { interpolation: i, string: /[\s\S]+/ } }, { pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i, alias: "heredoc-string", greedy: !0, inside: { delimiter: { pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i, inside: { symbol: /\b\w+/, punctuation: /^<<[-~]?/ } }, interpolation: i, string: /[\s\S]+/ } }, { pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i, alias: "heredoc-string", greedy: !0, inside: { delimiter: { pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i, inside: { symbol: /\b\w+/, punctuation: /^<<[-~]?'|'$/ } }, string: /[\s\S]+/ } }], "command-literal": [{ pattern: RegExp(/%x/.source + o), greedy: !0, inside: { interpolation: i, command: { pattern: /[\s\S]+/, alias: "string" } } }, { pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/, greedy: !0, inside: { interpolation: i, command: { pattern: /[\s\S]+/, alias: "string" } } }] }), delete a.languages.ruby.string, a.languages.insertBefore("ruby", "number", { builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/, constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/ }), a.languages.rb = a.languages.ruby;
    })(n);
  }
} }), Zjt = da({ "../../../node_modules/refractor/lang/shell-session.js"(t, e) {
  var r = TZe();
  e.exports = n, n.displayName = "shellSession", n.aliases = [];
  function n(a) {
    a.register(r), function(i) {
      var o = [/"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/.source, /'[^']*'/.source, /\$'(?:[^'\\]|\\[\s\S])*'/.source, /<<-?\s*(["']?)(\w+)\1\s[\s\S]*?[\r\n]\2/.source].join("|");
      i.languages["shell-session"] = { command: { pattern: RegExp(/^/.source + "(?:" + (/[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+(?::[^\0-\x1F$#%*?"<>:;|]+)?/.source + "|" + /[/~.][^\0-\x1F$#%*?"<>@:;|]*/.source) + ")?" + /[$#%](?=\s)/.source + /(?:[^\\\r\n \t'"<$]|[ \t](?:(?!#)|#.*$)|\\(?:[^\r]|\r\n?)|\$(?!')|<(?!<)|<<str>>)+/.source.replace(/<<str>>/g, function() {
        return o;
      }), "m"), greedy: !0, inside: { info: { pattern: /^[^#$%]+/, alias: "punctuation", inside: { user: /^[^\s@:$#%*!/\\]+@[^\r\n@:$#%*!/\\]+/, punctuation: /:/, path: /[\s\S]+/ } }, bash: { pattern: /(^[$#%]\s*)\S[\s\S]*/, lookbehind: !0, alias: "language-bash", inside: i.languages.bash }, "shell-symbol": { pattern: /^[$#%]/, alias: "important" } } }, output: /.(?:.*(?:[\r\n]|.$))*/ }, i.languages["sh-session"] = i.languages.shellsession = i.languages["shell-session"];
    }(a);
  }
} });
function Jjt(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Yjt(t, e) {
  if (t == null) return {};
  var r = Jjt(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++) n = i[a], !(e.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(t, n) || (r[n] = t[n]));
  }
  return r;
}
function lue(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Xjt(t) {
  if (Array.isArray(t)) return lue(t);
}
function Qjt(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function eFt(t, e) {
  if (t) {
    if (typeof t == "string") return lue(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return lue(t, e);
  }
}
function tFt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rFt(t) {
  return Xjt(t) || Qjt(t) || eFt(t) || tFt();
}
function kT(t) {
  return kT = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, kT(t);
}
function nFt(t, e) {
  if (kT(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (kT(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function aFt(t) {
  var e = nFt(t, "string");
  return kT(e) === "symbol" ? e : String(e);
}
function EZe(t, e, r) {
  return e = aFt(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cue() {
  return cue = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, cue.apply(this, arguments);
}
function o9e(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $9(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? o9e(Object(r), !0).forEach(function(n) {
      EZe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : o9e(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function iFt(t) {
  var e = t.length;
  if (e === 0 || e === 1) return t;
  if (e === 2) return [t[0], t[1], "".concat(t[0], ".").concat(t[1]), "".concat(t[1], ".").concat(t[0])];
  if (e === 3) return [t[0], t[1], t[2], "".concat(t[0], ".").concat(t[1]), "".concat(t[0], ".").concat(t[2]), "".concat(t[1], ".").concat(t[0]), "".concat(t[1], ".").concat(t[2]), "".concat(t[2], ".").concat(t[0]), "".concat(t[2], ".").concat(t[1]), "".concat(t[0], ".").concat(t[1], ".").concat(t[2]), "".concat(t[0], ".").concat(t[2], ".").concat(t[1]), "".concat(t[1], ".").concat(t[0], ".").concat(t[2]), "".concat(t[1], ".").concat(t[2], ".").concat(t[0]), "".concat(t[2], ".").concat(t[0], ".").concat(t[1]), "".concat(t[2], ".").concat(t[1], ".").concat(t[0])];
  if (e >= 4) return [t[0], t[1], t[2], t[3], "".concat(t[0], ".").concat(t[1]), "".concat(t[0], ".").concat(t[2]), "".concat(t[0], ".").concat(t[3]), "".concat(t[1], ".").concat(t[0]), "".concat(t[1], ".").concat(t[2]), "".concat(t[1], ".").concat(t[3]), "".concat(t[2], ".").concat(t[0]), "".concat(t[2], ".").concat(t[1]), "".concat(t[2], ".").concat(t[3]), "".concat(t[3], ".").concat(t[0]), "".concat(t[3], ".").concat(t[1]), "".concat(t[3], ".").concat(t[2]), "".concat(t[0], ".").concat(t[1], ".").concat(t[2]), "".concat(t[0], ".").concat(t[1], ".").concat(t[3]), "".concat(t[0], ".").concat(t[2], ".").concat(t[1]), "".concat(t[0], ".").concat(t[2], ".").concat(t[3]), "".concat(t[0], ".").concat(t[3], ".").concat(t[1]), "".concat(t[0], ".").concat(t[3], ".").concat(t[2]), "".concat(t[1], ".").concat(t[0], ".").concat(t[2]), "".concat(t[1], ".").concat(t[0], ".").concat(t[3]), "".concat(t[1], ".").concat(t[2], ".").concat(t[0]), "".concat(t[1], ".").concat(t[2], ".").concat(t[3]), "".concat(t[1], ".").concat(t[3], ".").concat(t[0]), "".concat(t[1], ".").concat(t[3], ".").concat(t[2]), "".concat(t[2], ".").concat(t[0], ".").concat(t[1]), "".concat(t[2], ".").concat(t[0], ".").concat(t[3]), "".concat(t[2], ".").concat(t[1], ".").concat(t[0]), "".concat(t[2], ".").concat(t[1], ".").concat(t[3]), "".concat(t[2], ".").concat(t[3], ".").concat(t[0]), "".concat(t[2], ".").concat(t[3], ".").concat(t[1]), "".concat(t[3], ".").concat(t[0], ".").concat(t[1]), "".concat(t[3], ".").concat(t[0], ".").concat(t[2]), "".concat(t[3], ".").concat(t[1], ".").concat(t[0]), "".concat(t[3], ".").concat(t[1], ".").concat(t[2]), "".concat(t[3], ".").concat(t[2], ".").concat(t[0]), "".concat(t[3], ".").concat(t[2], ".").concat(t[1]), "".concat(t[0], ".").concat(t[1], ".").concat(t[2], ".").concat(t[3]), "".concat(t[0], ".").concat(t[1], ".").concat(t[3], ".").concat(t[2]), "".concat(t[0], ".").concat(t[2], ".").concat(t[1], ".").concat(t[3]), "".concat(t[0], ".").concat(t[2], ".").concat(t[3], ".").concat(t[1]), "".concat(t[0], ".").concat(t[3], ".").concat(t[1], ".").concat(t[2]), "".concat(t[0], ".").concat(t[3], ".").concat(t[2], ".").concat(t[1]), "".concat(t[1], ".").concat(t[0], ".").concat(t[2], ".").concat(t[3]), "".concat(t[1], ".").concat(t[0], ".").concat(t[3], ".").concat(t[2]), "".concat(t[1], ".").concat(t[2], ".").concat(t[0], ".").concat(t[3]), "".concat(t[1], ".").concat(t[2], ".").concat(t[3], ".").concat(t[0]), "".concat(t[1], ".").concat(t[3], ".").concat(t[0], ".").concat(t[2]), "".concat(t[1], ".").concat(t[3], ".").concat(t[2], ".").concat(t[0]), "".concat(t[2], ".").concat(t[0], ".").concat(t[1], ".").concat(t[3]), "".concat(t[2], ".").concat(t[0], ".").concat(t[3], ".").concat(t[1]), "".concat(t[2], ".").concat(t[1], ".").concat(t[0], ".").concat(t[3]), "".concat(t[2], ".").concat(t[1], ".").concat(t[3], ".").concat(t[0]), "".concat(t[2], ".").concat(t[3], ".").concat(t[0], ".").concat(t[1]), "".concat(t[2], ".").concat(t[3], ".").concat(t[1], ".").concat(t[0]), "".concat(t[3], ".").concat(t[0], ".").concat(t[1], ".").concat(t[2]), "".concat(t[3], ".").concat(t[0], ".").concat(t[2], ".").concat(t[1]), "".concat(t[3], ".").concat(t[1], ".").concat(t[0], ".").concat(t[2]), "".concat(t[3], ".").concat(t[1], ".").concat(t[2], ".").concat(t[0]), "".concat(t[3], ".").concat(t[2], ".").concat(t[0], ".").concat(t[1]), "".concat(t[3], ".").concat(t[2], ".").concat(t[1], ".").concat(t[0])];
}
var QK = {};
function oFt(t) {
  if (t.length === 0 || t.length === 1) return t;
  var e = t.join(".");
  return QK[e] || (QK[e] = iFt(t)), QK[e];
}
function sFt(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0, n = t.filter(function(i) {
    return i !== "token";
  }), a = oFt(n);
  return a.reduce(function(i, o) {
    return $9($9({}, i), r[o]);
  }, e);
}
function s9e(t) {
  return t.join(" ");
}
function lFt(t, e) {
  var r = 0;
  return function(n) {
    return r += 1, n.map(function(a, i) {
      return IZe({ node: a, stylesheet: t, useInlineStyles: e, key: "code-segment-".concat(r, "-").concat(i) });
    });
  };
}
function IZe(t) {
  var e = t.node, r = t.stylesheet, n = t.style, a = n === void 0 ? {} : n, i = t.useInlineStyles, o = t.key, s = e.properties, l = e.type, c = e.tagName, u = e.value;
  if (l === "text") return u;
  if (c) {
    var f = lFt(r, i), h;
    if (!i) h = $9($9({}, s), {}, { className: s9e(s.className) });
    else {
      var p = Object.keys(r).reduce(function(w, _) {
        return _.split(".").forEach(function(C) {
          w.includes(C) || w.push(C);
        }), w;
      }, []), g = s.className && s.className.includes("token") ? ["token"] : [], y = s.className && g.concat(s.className.filter(function(w) {
        return !p.includes(w);
      }));
      h = $9($9({}, s), {}, { className: s9e(y) || void 0, style: sFt(s.className, Object.assign({}, s.style, a), r) });
    }
    var b = f(e.children);
    return Te.createElement(c, cue({ key: o }, h), b);
  }
}
var cFt = function(t, e) {
  var r = t.listLanguages();
  return r.indexOf(e) !== -1;
}, uFt = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function l9e(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function J2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? l9e(Object(r), !0).forEach(function(n) {
      EZe(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : l9e(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
var dFt = /\n/g;
function fFt(t) {
  return t.match(dFt);
}
function hFt(t) {
  var e = t.lines, r = t.startingLineNumber, n = t.style;
  return e.map(function(a, i) {
    var o = i + r;
    return Te.createElement("span", { key: "line-".concat(i), className: "react-syntax-highlighter-line-number", style: typeof n == "function" ? n(o) : n }, "".concat(o, `
`));
  });
}
function pFt(t) {
  var e = t.codeString, r = t.codeStyle, n = t.containerStyle, a = n === void 0 ? { float: "left", paddingRight: "10px" } : n, i = t.numberStyle, o = i === void 0 ? {} : i, s = t.startingLineNumber;
  return Te.createElement("code", { style: Object.assign({}, r, a) }, hFt({ lines: e.replace(/\n$/, "").split(`
`), style: o, startingLineNumber: s }));
}
function mFt(t) {
  return "".concat(t.toString().length, ".25em");
}
function MZe(t, e) {
  return { type: "element", tagName: "span", properties: { key: "line-number--".concat(t), className: ["comment", "linenumber", "react-syntax-highlighter-line-number"], style: e }, children: [{ type: "text", value: t }] };
}
function PZe(t, e, r) {
  var n = { display: "inline-block", minWidth: mFt(r), paddingRight: "1em", textAlign: "right", userSelect: "none" }, a = typeof t == "function" ? t(e) : t, i = J2(J2({}, n), a);
  return i;
}
function r$(t) {
  var e = t.children, r = t.lineNumber, n = t.lineNumberStyle, a = t.largestLineNumber, i = t.showInlineLineNumbers, o = t.lineProps, s = o === void 0 ? {} : o, l = t.className, c = l === void 0 ? [] : l, u = t.showLineNumbers, f = t.wrapLongLines, h = typeof s == "function" ? s(r) : s;
  if (h.className = c, r && i) {
    var p = PZe(n, r, a);
    e.unshift(MZe(r, p));
  }
  return f & u && (h.style = J2(J2({}, h.style), {}, { display: "flex" })), { type: "element", tagName: "span", properties: h, children: e };
}
function RZe(t) {
  for (var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], n = 0; n < t.length; n++) {
    var a = t[n];
    if (a.type === "text") r.push(r$({ children: [a], className: rFt(new Set(e)) }));
    else if (a.children) {
      var i = e.concat(a.properties.className);
      RZe(a.children, i).forEach(function(o) {
        return r.push(o);
      });
    }
  }
  return r;
}
function gFt(t, e, r, n, a, i, o, s, l) {
  var c, u = RZe(t.value), f = [], h = -1, p = 0;
  function g(S, A) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return r$({ children: S, lineNumber: A, lineNumberStyle: s, largestLineNumber: o, showInlineLineNumbers: a, lineProps: r, className: I, showLineNumbers: n, wrapLongLines: l });
  }
  function y(S, A) {
    if (n && A && a) {
      var I = PZe(s, A, o);
      S.unshift(MZe(A, I));
    }
    return S;
  }
  function b(S, A) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return e || I.length > 0 ? g(S, A, I) : y(S, A);
  }
  for (var w = function() {
    var S = u[p], A = S.children[0].value, I = fFt(A);
    if (I) {
      var M = A.split(`
`);
      M.forEach(function(B, L) {
        var N = n && f.length + i, d = { type: "text", value: "".concat(B, `
`) };
        if (L === 0) {
          var m = u.slice(h + 1, p).concat(r$({ children: [d], className: S.properties.className })), v = b(m, N);
          f.push(v);
        } else if (L === M.length - 1) {
          var k = u[p + 1] && u[p + 1].children && u[p + 1].children[0], O = { type: "text", value: "".concat(B) };
          if (k) {
            var G = r$({ children: [O], className: S.properties.className });
            u.splice(p + 1, 0, G);
          } else {
            var H = [O], j = b(H, N, S.properties.className);
            f.push(j);
          }
        } else {
          var F = [d], z = b(F, N, S.properties.className);
          f.push(z);
        }
      }), h = p;
    }
    p++;
  }; p < u.length; ) w();
  if (h !== u.length - 1) {
    var _ = u.slice(h + 1, u.length);
    if (_ && _.length) {
      var C = n && f.length + i, x = b(_, C);
      f.push(x);
    }
  }
  return e ? f : (c = []).concat.apply(c, f);
}
function vFt(t) {
  var e = t.rows, r = t.stylesheet, n = t.useInlineStyles;
  return e.map(function(a, i) {
    return IZe({ node: a, stylesheet: r, useInlineStyles: n, key: "code-segement".concat(i) });
  });
}
function OZe(t) {
  return t && typeof t.highlightAuto < "u";
}
function yFt(t) {
  var e = t.astGenerator, r = t.language, n = t.code, a = t.defaultCodeValue;
  if (OZe(e)) {
    var i = cFt(e, r);
    return r === "text" ? { value: a, language: "text" } : i ? e.highlight(r, n) : e.highlightAuto(n);
  }
  try {
    return r && r !== "text" ? { value: e.highlight(n, r) } : { value: a };
  } catch {
    return { value: a };
  }
}
function bFt(t, e) {
  return function(r) {
    var n = r.language, a = r.children, i = r.style, o = i === void 0 ? e : i, s = r.customStyle, l = s === void 0 ? {} : s, c = r.codeTagProps, u = c === void 0 ? { className: n ? "language-".concat(n) : void 0, style: J2(J2({}, o['code[class*="language-"]']), o['code[class*="language-'.concat(n, '"]')]) } : c, f = r.useInlineStyles, h = f === void 0 ? !0 : f, p = r.showLineNumbers, g = p === void 0 ? !1 : p, y = r.showInlineLineNumbers, b = y === void 0 ? !0 : y, w = r.startingLineNumber, _ = w === void 0 ? 1 : w, C = r.lineNumberContainerStyle, x = r.lineNumberStyle, S = x === void 0 ? {} : x, A = r.wrapLines, I = r.wrapLongLines, M = I === void 0 ? !1 : I, B = r.lineProps, L = B === void 0 ? {} : B, N = r.renderer, d = r.PreTag, m = d === void 0 ? "pre" : d, v = r.CodeTag, k = v === void 0 ? "code" : v, O = r.code, G = O === void 0 ? (Array.isArray(a) ? a[0] : a) || "" : O, H = r.astGenerator, j = Yjt(r, uFt);
    H = H || t;
    var F = g ? Te.createElement(pFt, { containerStyle: C, codeStyle: u.style || {}, numberStyle: S, startingLineNumber: _, codeString: G }) : null, z = o.hljs || o['pre[class*="language-"]'] || { backgroundColor: "#fff" }, W = OZe(H) ? "hljs" : "prismjs", U = h ? Object.assign({}, j, { style: Object.assign({}, z, l) }) : Object.assign({}, j, { className: j.className ? "".concat(W, " ").concat(j.className) : W, style: Object.assign({}, l) });
    if (M ? u.style = J2(J2({}, u.style), {}, { whiteSpace: "pre-wrap" }) : u.style = J2(J2({}, u.style), {}, { whiteSpace: "pre" }), !H) return Te.createElement(m, U, F, Te.createElement(k, u, G));
    (A === void 0 && N || M) && (A = !0), N = N || vFt;
    var Z = [{ type: "text", value: G }], V = yFt({ astGenerator: H, language: n, code: G, defaultCodeValue: Z });
    V.language === null && (V.value = Z);
    var Y = V.value.length + _, ge = gFt(V, A, L, g, b, _, Y, S, M);
    return Te.createElement(m, U, Te.createElement(k, u, !b && F, N({ rows: ge, stylesheet: o, useInlineStyles: h })));
  };
}
var ahe = Ed(Djt()), ihe = bFt(ahe.default, {});
ihe.registerLanguage = function(t, e) {
  return ahe.default.register(e);
};
ihe.alias = function(t, e) {
  return ahe.default.alias(t, e);
};
var Id = ihe, xFt = Ed(TZe()), CFt = xFt.default, wFt = Ed(Ljt()), SFt = wFt.default, _Ft = Ed(jjt()), kFt = _Ft.default, AFt = Ed(Fjt()), TFt = AFt.default, EFt = Ed(zjt()), IFt = EFt.default, MFt = Ed(Gjt()), PFt = MFt.default, RFt = Ed(AZe()), OFt = RFt.default, BFt = Ed(Wjt()), NFt = BFt.default, $Ft = Ed(Hjt()), DFt = $Ft.default, LFt = Ed(Vjt()), jFt = LFt.default, FFt = Ed(qjt()), zFt = FFt.default, GFt = Ed(Kjt()), WFt = GFt.default, HFt = Ed(Zjt()), UFt = HFt.default, x0 = { JAVASCRIPT: "javascript", JSX: "jsx", CSHARP: "csharp", PHP: "php", RUBY: "ruby", PYTHON: "python", JAVA: "java", JSON: "json", C: "c", BASH: "bash", SHELL: "shell", GO: "go", GROOVY: "groovy" };
Id.registerLanguage(x0.JAVASCRIPT, OFt);
Id.registerLanguage(x0.JSX, DFt);
Id.registerLanguage(x0.CSHARP, kFt);
Id.registerLanguage(x0.PHP, jFt);
Id.registerLanguage(x0.RUBY, WFt);
Id.registerLanguage(x0.PYTHON, zFt);
Id.registerLanguage(x0.JAVA, PFt);
Id.registerLanguage(x0.JSON, NFt);
Id.registerLanguage(x0.C, SFt);
Id.registerLanguage(x0.BASH, CFt);
Id.registerLanguage(x0.SHELL, UFt);
Id.registerLanguage(x0.GO, TFt);
Id.registerLanguage(x0.GROOVY, IFt);
/**
* Prism: Lightweight, robust, elegant syntax highlighting
*
* @license MIT <https://opensource.org/licenses/MIT>
* @author Lea Verou <https://lea.verou.me>
* @namespace
* @public
*/
var ohe = tM(), ei = (t) => eM(t, ohe), she = tM();
ei.write = (t) => eM(t, she);
var Dz = tM();
ei.onStart = (t) => eM(t, Dz);
var lhe = tM();
ei.onFrame = (t) => eM(t, lhe);
var che = tM();
ei.onFinish = (t) => eM(t, che);
var h7 = [];
ei.setTimeout = (t, e) => {
  let r = ei.now() + e, n = () => {
    let i = h7.findIndex((o) => o.cancel == n);
    ~i && h7.splice(i, 1), wv -= ~i ? 1 : 0;
  }, a = { time: r, handler: t, cancel: n };
  return h7.splice(BZe(r), 0, a), wv += 1, NZe(), a;
};
var BZe = (t) => ~(~h7.findIndex((e) => e.time > t) || ~h7.length);
ei.cancel = (t) => {
  Dz.delete(t), lhe.delete(t), che.delete(t), ohe.delete(t), she.delete(t);
};
ei.sync = (t) => {
  uue = !0, ei.batchedUpdates(t), uue = !1;
};
ei.throttle = (t) => {
  let e;
  function r() {
    try {
      t(...e);
    } finally {
      e = null;
    }
  }
  function n(...a) {
    e = a, ei.onStart(r);
  }
  return n.handler = t, n.cancel = () => {
    Dz.delete(r), e = null;
  }, n;
};
var uhe = typeof window < "u" ? window.requestAnimationFrame : () => {
};
ei.use = (t) => uhe = t;
ei.now = typeof performance < "u" ? () => performance.now() : Date.now;
ei.batchedUpdates = (t) => t();
ei.catch = console.error;
ei.frameLoop = "always";
ei.advance = () => {
  ei.frameLoop !== "demand" ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : DZe();
};
var Cv = -1, wv = 0, uue = !1;
function eM(t, e) {
  uue ? (e.delete(t), t(0)) : (e.add(t), NZe());
}
function NZe() {
  Cv < 0 && (Cv = 0, ei.frameLoop !== "demand" && uhe($Ze));
}
function VFt() {
  Cv = -1;
}
function $Ze() {
  ~Cv && (uhe($Ze), ei.batchedUpdates(DZe));
}
function DZe() {
  let t = Cv;
  Cv = ei.now();
  let e = BZe(Cv);
  if (e && (LZe(h7.splice(0, e), (r) => r.handler()), wv -= e), !wv) {
    VFt();
    return;
  }
  Dz.flush(), ohe.flush(t ? Math.min(64, Cv - t) : 16.667), lhe.flush(), she.flush(), che.flush();
}
function tM() {
  let t = /* @__PURE__ */ new Set(), e = t;
  return { add(r) {
    wv += e == t && !t.has(r) ? 1 : 0, t.add(r);
  }, delete(r) {
    return wv -= e == t && t.has(r) ? 1 : 0, t.delete(r);
  }, flush(r) {
    e.size && (t = /* @__PURE__ */ new Set(), wv -= e.size, LZe(e, (n) => n(r) && t.add(n)), wv += t.size, e = t);
  } };
}
function LZe(t, e) {
  t.forEach((r) => {
    try {
      e(r);
    } catch (n) {
      ei.catch(n);
    }
  });
}
var qFt = Object.defineProperty, KFt = (t, e) => {
  for (var r in e) qFt(t, r, { get: e[r], enumerable: !0 });
}, Td = {};
KFt(Td, { assign: () => JFt, colors: () => Bv, createStringInterpolator: () => fhe, skipAnimation: () => FZe, to: () => jZe, willAdvance: () => hhe });
function due() {
}
var ZFt = (t, e, r) => Object.defineProperty(t, e, { value: r, writable: !0, configurable: !0 }), Or = { arr: Array.isArray, obj: (t) => !!t && t.constructor.name === "Object", fun: (t) => typeof t == "function", str: (t) => typeof t == "string", num: (t) => typeof t == "number", und: (t) => t === void 0 };
function Yp(t, e) {
  if (Or.arr(t)) {
    if (!Or.arr(e) || t.length !== e.length) return !1;
    for (let r = 0; r < t.length; r++) if (t[r] !== e[r]) return !1;
    return !0;
  }
  return t === e;
}
var na = (t, e) => t.forEach(e);
function jh(t, e, r) {
  if (Or.arr(t)) {
    for (let n = 0; n < t.length; n++) e.call(r, t[n], `${n}`);
    return;
  }
  for (let n in t) t.hasOwnProperty(n) && e.call(r, t[n], n);
}
var Cu = (t) => Or.und(t) ? [] : Or.arr(t) ? t : [t];
function E_(t, e) {
  if (t.size) {
    let r = Array.from(t);
    t.clear(), na(r, e);
  }
}
var XS = (t, ...e) => E_(t, (r) => r(...e)), dhe = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), fhe, jZe, Bv = null, FZe = !1, hhe = due, JFt = (t) => {
  t.to && (jZe = t.to), t.now && (ei.now = t.now), t.colors !== void 0 && (Bv = t.colors), t.skipAnimation != null && (FZe = t.skipAnimation), t.createStringInterpolator && (fhe = t.createStringInterpolator), t.requestAnimationFrame && ei.use(t.requestAnimationFrame), t.batchedUpdates && (ei.batchedUpdates = t.batchedUpdates), t.willAdvance && (hhe = t.willAdvance), t.frameLoop && (ei.frameLoop = t.frameLoop);
}, I_ = /* @__PURE__ */ new Set(), q0 = [], eZ = [], gL = 0, Lz = { get idle() {
  return !I_.size && !q0.length;
}, start(t) {
  gL > t.priority ? (I_.add(t), ei.onStart(YFt)) : (zZe(t), ei(fue));
}, advance: fue, sort(t) {
  if (gL) ei.onFrame(() => Lz.sort(t));
  else {
    let e = q0.indexOf(t);
    ~e && (q0.splice(e, 1), GZe(t));
  }
}, clear() {
  q0 = [], I_.clear();
} };
function YFt() {
  I_.forEach(zZe), I_.clear(), ei(fue);
}
function zZe(t) {
  q0.includes(t) || GZe(t);
}
function GZe(t) {
  q0.splice(XFt(q0, (e) => e.priority > t.priority), 0, t);
}
function fue(t) {
  let e = eZ;
  for (let r = 0; r < q0.length; r++) {
    let n = q0[r];
    gL = n.priority, n.idle || (hhe(n), n.advance(t), n.idle || e.push(n));
  }
  return gL = 0, eZ = q0, eZ.length = 0, q0 = e, q0.length > 0;
}
function XFt(t, e) {
  let r = t.findIndex(e);
  return r < 0 ? t.length : r;
}
var QFt = { transparent: 0, aliceblue: 4042850303, antiquewhite: 4209760255, aqua: 16777215, aquamarine: 2147472639, azure: 4043309055, beige: 4126530815, bisque: 4293182719, black: 255, blanchedalmond: 4293643775, blue: 65535, blueviolet: 2318131967, brown: 2771004159, burlywood: 3736635391, burntsienna: 3934150143, cadetblue: 1604231423, chartreuse: 2147418367, chocolate: 3530104575, coral: 4286533887, cornflowerblue: 1687547391, cornsilk: 4294499583, crimson: 3692313855, cyan: 16777215, darkblue: 35839, darkcyan: 9145343, darkgoldenrod: 3095792639, darkgray: 2846468607, darkgreen: 6553855, darkgrey: 2846468607, darkkhaki: 3182914559, darkmagenta: 2332068863, darkolivegreen: 1433087999, darkorange: 4287365375, darkorchid: 2570243327, darkred: 2332033279, darksalmon: 3918953215, darkseagreen: 2411499519, darkslateblue: 1211993087, darkslategray: 793726975, darkslategrey: 793726975, darkturquoise: 13554175, darkviolet: 2483082239, deeppink: 4279538687, deepskyblue: 12582911, dimgray: 1768516095, dimgrey: 1768516095, dodgerblue: 512819199, firebrick: 2988581631, floralwhite: 4294635775, forestgreen: 579543807, fuchsia: 4278255615, gainsboro: 3705462015, ghostwhite: 4177068031, gold: 4292280575, goldenrod: 3668254975, gray: 2155905279, green: 8388863, greenyellow: 2919182335, grey: 2155905279, honeydew: 4043305215, hotpink: 4285117695, indianred: 3445382399, indigo: 1258324735, ivory: 4294963455, khaki: 4041641215, lavender: 3873897215, lavenderblush: 4293981695, lawngreen: 2096890111, lemonchiffon: 4294626815, lightblue: 2916673279, lightcoral: 4034953471, lightcyan: 3774873599, lightgoldenrodyellow: 4210742015, lightgray: 3553874943, lightgreen: 2431553791, lightgrey: 3553874943, lightpink: 4290167295, lightsalmon: 4288707327, lightseagreen: 548580095, lightskyblue: 2278488831, lightslategray: 2005441023, lightslategrey: 2005441023, lightsteelblue: 2965692159, lightyellow: 4294959359, lime: 16711935, limegreen: 852308735, linen: 4210091775, magenta: 4278255615, maroon: 2147483903, mediumaquamarine: 1724754687, mediumblue: 52735, mediumorchid: 3126187007, mediumpurple: 2473647103, mediumseagreen: 1018393087, mediumslateblue: 2070474495, mediumspringgreen: 16423679, mediumturquoise: 1221709055, mediumvioletred: 3340076543, midnightblue: 421097727, mintcream: 4127193855, mistyrose: 4293190143, moccasin: 4293178879, navajowhite: 4292783615, navy: 33023, oldlace: 4260751103, olive: 2155872511, olivedrab: 1804477439, orange: 4289003775, orangered: 4282712319, orchid: 3664828159, palegoldenrod: 4008225535, palegreen: 2566625535, paleturquoise: 2951671551, palevioletred: 3681588223, papayawhip: 4293907967, peachpuff: 4292524543, peru: 3448061951, pink: 4290825215, plum: 3718307327, powderblue: 2967529215, purple: 2147516671, rebeccapurple: 1714657791, red: 4278190335, rosybrown: 3163525119, royalblue: 1097458175, saddlebrown: 2336560127, salmon: 4202722047, sandybrown: 4104413439, seagreen: 780883967, seashell: 4294307583, sienna: 2689740287, silver: 3233857791, skyblue: 2278484991, slateblue: 1784335871, slategray: 1887473919, slategrey: 1887473919, snow: 4294638335, springgreen: 16744447, steelblue: 1182971135, tan: 3535047935, teal: 8421631, thistle: 3636451583, tomato: 4284696575, turquoise: 1088475391, violet: 4001558271, wheat: 4125012991, white: 4294967295, whitesmoke: 4126537215, yellow: 4294902015, yellowgreen: 2597139199 }, y1 = "[-+]?\\d*\\.?\\d+", vL = y1 + "%";
function jz(...t) {
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var ezt = new RegExp("rgb" + jz(y1, y1, y1)), tzt = new RegExp("rgba" + jz(y1, y1, y1, y1)), rzt = new RegExp("hsl" + jz(y1, vL, vL)), nzt = new RegExp("hsla" + jz(y1, vL, vL, y1)), azt = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, izt = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, ozt = /^#([0-9a-fA-F]{6})$/, szt = /^#([0-9a-fA-F]{8})$/;
function lzt(t) {
  let e;
  return typeof t == "number" ? t >>> 0 === t && t >= 0 && t <= 4294967295 ? t : null : (e = ozt.exec(t)) ? parseInt(e[1] + "ff", 16) >>> 0 : Bv && Bv[t] !== void 0 ? Bv[t] : (e = ezt.exec(t)) ? (G4(e[1]) << 24 | G4(e[2]) << 16 | G4(e[3]) << 8 | 255) >>> 0 : (e = tzt.exec(t)) ? (G4(e[1]) << 24 | G4(e[2]) << 16 | G4(e[3]) << 8 | d9e(e[4])) >>> 0 : (e = azt.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + "ff", 16) >>> 0 : (e = szt.exec(t)) ? parseInt(e[1], 16) >>> 0 : (e = izt.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + e[4] + e[4], 16) >>> 0 : (e = rzt.exec(t)) ? (c9e(u9e(e[1]), oB(e[2]), oB(e[3])) | 255) >>> 0 : (e = nzt.exec(t)) ? (c9e(u9e(e[1]), oB(e[2]), oB(e[3])) | d9e(e[4])) >>> 0 : null;
}
function tZ(t, e, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + (e - t) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}
function c9e(t, e, r) {
  let n = r < 0.5 ? r * (1 + e) : r + e - r * e, a = 2 * r - n, i = tZ(a, n, t + 1 / 3), o = tZ(a, n, t), s = tZ(a, n, t - 1 / 3);
  return Math.round(i * 255) << 24 | Math.round(o * 255) << 16 | Math.round(s * 255) << 8;
}
function G4(t) {
  let e = parseInt(t, 10);
  return e < 0 ? 0 : e > 255 ? 255 : e;
}
function u9e(t) {
  return (parseFloat(t) % 360 + 360) % 360 / 360;
}
function d9e(t) {
  let e = parseFloat(t);
  return e < 0 ? 0 : e > 1 ? 255 : Math.round(e * 255);
}
function oB(t) {
  let e = parseFloat(t);
  return e < 0 ? 0 : e > 100 ? 1 : e / 100;
}
function f9e(t) {
  let e = lzt(t);
  if (e === null) return t;
  e = e || 0;
  let r = (e & 4278190080) >>> 24, n = (e & 16711680) >>> 16, a = (e & 65280) >>> 8, i = (e & 255) / 255;
  return `rgba(${r}, ${n}, ${a}, ${i})`;
}
var AT = (t, e, r) => {
  if (Or.fun(t)) return t;
  if (Or.arr(t)) return AT({ range: t, output: e, extrapolate: r });
  if (Or.str(t.output[0])) return fhe(t);
  let n = t, a = n.output, i = n.range || [0, 1], o = n.extrapolateLeft || n.extrapolate || "extend", s = n.extrapolateRight || n.extrapolate || "extend", l = n.easing || ((c) => c);
  return (c) => {
    let u = uzt(c, i);
    return czt(c, i[u], i[u + 1], a[u], a[u + 1], l, o, s, n.map);
  };
};
function czt(t, e, r, n, a, i, o, s, l) {
  let c = l ? l(t) : t;
  if (c < e) {
    if (o === "identity") return c;
    o === "clamp" && (c = e);
  }
  if (c > r) {
    if (s === "identity") return c;
    s === "clamp" && (c = r);
  }
  return n === a ? n : e === r ? t <= e ? n : a : (e === -1 / 0 ? c = -c : r === 1 / 0 ? c = c - e : c = (c - e) / (r - e), c = i(c), n === -1 / 0 ? c = -c : a === 1 / 0 ? c = c + n : c = c * (a - n) + n, c);
}
function uzt(t, e) {
  for (var r = 1; r < e.length - 1 && !(e[r] >= t); ++r) ;
  return r - 1;
}
var dzt = { linear: (t) => t }, TT = Symbol.for("FluidValue.get"), gx = Symbol.for("FluidValue.observers"), V0 = (t) => !!(t && t[TT]), fd = (t) => t && t[TT] ? t[TT]() : t, h9e = (t) => t[gx] || null;
function fzt(t, e) {
  t.eventObserved ? t.eventObserved(e) : t(e);
}
function ET(t, e) {
  let r = t[gx];
  r && r.forEach((n) => {
    fzt(n, e);
  });
}
var WZe = class {
  constructor(t) {
    if (!t && !(t = this.get)) throw Error("Unknown getter");
    hzt(this, t);
  }
}, hzt = (t, e) => HZe(t, TT, e);
function k8(t, e) {
  if (t[TT]) {
    let r = t[gx];
    r || HZe(t, gx, r = /* @__PURE__ */ new Set()), r.has(e) || (r.add(e), t.observerAdded && t.observerAdded(r.size, e));
  }
  return e;
}
function IT(t, e) {
  let r = t[gx];
  if (r && r.has(e)) {
    let n = r.size - 1;
    n ? r.delete(e) : t[gx] = null, t.observerRemoved && t.observerRemoved(n, e);
  }
}
var HZe = (t, e, r) => Object.defineProperty(t, e, { value: r, writable: !0, configurable: !0 }), n$ = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, pzt = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, p9e = new RegExp(`(${n$.source})(%|[a-z]+)`, "i"), mzt = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, Fz = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, UZe = (t) => {
  let [e, r] = gzt(t);
  if (!e || dhe()) return t;
  let n = window.getComputedStyle(document.documentElement).getPropertyValue(e);
  return n ? n.trim() : r && r.startsWith("--") ? window.getComputedStyle(document.documentElement).getPropertyValue(r) || t : r && Fz.test(r) ? UZe(r) : r || t;
}, gzt = (t) => {
  let e = Fz.exec(t);
  if (!e) return [,];
  let [, r, n] = e;
  return [r, n];
}, rZ, vzt = (t, e, r, n, a) => `rgba(${Math.round(e)}, ${Math.round(r)}, ${Math.round(n)}, ${a})`, VZe = (t) => {
  rZ || (rZ = Bv ? new RegExp(`(${Object.keys(Bv).join("|")})(?!\\w)`, "g") : /^\b$/);
  let e = t.output.map((a) => fd(a).replace(Fz, UZe).replace(pzt, f9e).replace(rZ, f9e)), r = e.map((a) => a.match(n$).map(Number)), n = r[0].map((a, i) => r.map((o) => {
    if (!(i in o)) throw Error('The arity of each "output" value must be equal');
    return o[i];
  })).map((a) => AT({ ...t, output: a }));
  return (a) => {
    var s;
    let i = !p9e.test(e[0]) && ((s = e.find((l) => p9e.test(l))) == null ? void 0 : s.replace(n$, "")), o = 0;
    return e[0].replace(n$, () => `${n[o++](a)}${i || ""}`).replace(mzt, vzt);
  };
}, phe = "react-spring: ", qZe = (t) => {
  let e = t, r = !1;
  if (typeof e != "function") throw new TypeError(`${phe}once requires a function parameter`);
  return (...n) => {
    r || (e(...n), r = !0);
  };
}, yzt = qZe(console.warn);
function KZe() {
  yzt(`${phe}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var bzt = qZe(console.warn);
function xzt() {
  bzt(`${phe}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
function zz(t) {
  return Or.str(t) && (t[0] == "#" || /\d/.test(t) || !dhe() && Fz.test(t) || t in (Bv || {}));
}
var xm = dhe() ? Ut : qh, Czt = () => {
  let t = Zt(!1);
  return xm(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
};
function mhe() {
  let t = Yt()[1], e = Czt();
  return () => {
    e.current && t(Math.random());
  };
}
function wzt(t, e) {
  let [r] = Yt(() => ({ inputs: e, result: t() })), n = Zt(), a = n.current, i = a;
  return i ? e && i.inputs && Szt(e, i.inputs) || (i = { inputs: e, result: t() }) : i = r, Ut(() => {
    n.current = i, a == r && (r.inputs = r.result = void 0);
  }, [i]), i.result;
}
function Szt(t, e) {
  if (t.length !== e.length) return !1;
  for (let r = 0; r < t.length; r++) if (t[r] !== e[r]) return !1;
  return !0;
}
var ghe = (t) => Ut(t, _zt), _zt = [];
function hue(t) {
  let e = Zt();
  return Ut(() => {
    e.current = t;
  }), e.current;
}
var MT = Symbol.for("Animated:node"), kzt = (t) => !!t && t[MT] === t, K2 = (t) => t && t[MT], vhe = (t, e) => ZFt(t, MT, e), Gz = (t) => t && t[MT] && t[MT].getPayload(), ZZe = class {
  constructor() {
    vhe(this, this);
  }
  getPayload() {
    return this.payload || [];
  }
}, rM = class extends ZZe {
  constructor(t) {
    super(), this._value = t, this.done = !0, this.durationProgress = 0, Or.num(this._value) && (this.lastPosition = this._value);
  }
  static create(t) {
    return new rM(t);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(t, e) {
    return Or.num(t) && (this.lastPosition = t, e && (t = Math.round(t / e) * e, this.done && (this.lastPosition = t))), this._value === t ? !1 : (this._value = t, !0);
  }
  reset() {
    let { done: t } = this;
    this.done = !1, Or.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, t && (this.lastVelocity = null), this.v0 = null);
  }
}, PT = class extends rM {
  constructor(t) {
    super(0), this._string = null, this._toString = AT({ output: [t, t] });
  }
  static create(t) {
    return new PT(t);
  }
  getValue() {
    return this._string ?? (this._string = this._toString(this._value));
  }
  setValue(t) {
    if (Or.str(t)) {
      if (t == this._string) return !1;
      this._string = t, this._value = 1;
    } else if (super.setValue(t)) this._string = null;
    else return !1;
    return !0;
  }
  reset(t) {
    t && (this._toString = AT({ output: [this.getValue(), t] })), this._value = 0, super.reset();
  }
}, yL = { dependencies: null }, Wz = class extends ZZe {
  constructor(t) {
    super(), this.source = t, this.setValue(t);
  }
  getValue(t) {
    let e = {};
    return jh(this.source, (r, n) => {
      kzt(r) ? e[n] = r.getValue(t) : V0(r) ? e[n] = fd(r) : t || (e[n] = r);
    }), e;
  }
  setValue(t) {
    this.source = t, this.payload = this._makePayload(t);
  }
  reset() {
    this.payload && na(this.payload, (t) => t.reset());
  }
  _makePayload(t) {
    if (t) {
      let e = /* @__PURE__ */ new Set();
      return jh(t, this._addToPayload, e), Array.from(e);
    }
  }
  _addToPayload(t) {
    yL.dependencies && V0(t) && yL.dependencies.add(t);
    let e = Gz(t);
    e && na(e, (r) => this.add(r));
  }
}, JZe = class extends Wz {
  constructor(t) {
    super(t);
  }
  static create(t) {
    return new JZe(t);
  }
  getValue() {
    return this.source.map((t) => t.getValue());
  }
  setValue(t) {
    let e = this.getPayload();
    return t.length == e.length ? e.map((r, n) => r.setValue(t[n])).some(Boolean) : (super.setValue(t.map(Azt)), !0);
  }
};
function Azt(t) {
  return (zz(t) ? PT : rM).create(t);
}
function pue(t) {
  let e = K2(t);
  return e ? e.constructor : Or.arr(t) ? JZe : zz(t) ? PT : rM;
}
var m9e = (t, e) => {
  let r = !Or.fun(t) || t.prototype && t.prototype.isReactComponent;
  return Ml((n, a) => {
    let i = Zt(null), o = r && sr((g) => {
      i.current = Izt(a, g);
    }, [a]), [s, l] = Ezt(n, e), c = mhe(), u = () => {
      let g = i.current;
      r && !g || (g ? e.applyAnimatedValues(g, s.getValue(!0)) : !1) === !1 && c();
    }, f = new Tzt(u, l), h = Zt();
    xm(() => (h.current = f, na(l, (g) => k8(g, f)), () => {
      h.current && (na(h.current.deps, (g) => IT(g, h.current)), ei.cancel(h.current.update));
    })), Ut(u, []), ghe(() => () => {
      let g = h.current;
      na(g.deps, (y) => IT(y, g));
    });
    let p = e.getComponentProps(s.getValue());
    return P.createElement(t, { ...p, ref: o });
  });
}, Tzt = class {
  constructor(t, e) {
    this.update = t, this.deps = e;
  }
  eventObserved(t) {
    t.type == "change" && ei.write(this.update);
  }
};
function Ezt(t, e) {
  let r = /* @__PURE__ */ new Set();
  return yL.dependencies = r, t.style && (t = { ...t, style: e.createAnimatedStyle(t.style) }), t = new Wz(t), yL.dependencies = null, [t, r];
}
function Izt(t, e) {
  return t && (Or.fun(t) ? t(e) : t.current = e), e;
}
var g9e = Symbol.for("AnimatedComponent"), Mzt = (t, { applyAnimatedValues: e = () => !1, createAnimatedStyle: r = (a) => new Wz(a), getComponentProps: n = (a) => a } = {}) => {
  let a = { applyAnimatedValues: e, createAnimatedStyle: r, getComponentProps: n }, i = (o) => {
    let s = v9e(o) || "Anonymous";
    return Or.str(o) ? o = i[o] || (i[o] = m9e(o, a)) : o = o[g9e] || (o[g9e] = m9e(o, a)), o.displayName = `Animated(${s})`, o;
  };
  return jh(t, (o, s) => {
    Or.arr(t) && (s = v9e(o)), i[s] = i(o);
  }), { animated: i };
}, v9e = (t) => Or.str(t) ? t : t && Or.str(t.displayName) ? t.displayName : Or.fun(t) && t.name || null;
function bu(t, ...e) {
  return Or.fun(t) ? t(...e) : t;
}
var M_ = (t, e) => t === !0 || !!(e && t && (Or.fun(t) ? t(e) : Cu(t).includes(e))), YZe = (t, e) => Or.obj(t) ? e && t[e] : t, XZe = (t, e) => t.default === !0 ? t[e] : t.default ? t.default[e] : void 0, Pzt = (t) => t, Hz = (t, e = Pzt) => {
  let r = Rzt;
  t.default && t.default !== !0 && (t = t.default, r = Object.keys(t));
  let n = {};
  for (let a of r) {
    let i = e(t[a], a);
    Or.und(i) || (n[a] = i);
  }
  return n;
}, Rzt = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"], Ozt = { config: 1, from: 1, to: 1, ref: 1, loop: 1, reset: 1, pause: 1, cancel: 1, reverse: 1, immediate: 1, default: 1, delay: 1, onProps: 1, onStart: 1, onChange: 1, onPause: 1, onResume: 1, onRest: 1, onResolve: 1, items: 1, trail: 1, sort: 1, expires: 1, initial: 1, enter: 1, update: 1, leave: 1, children: 1, onDestroyed: 1, keys: 1, callId: 1, parentId: 1 };
function Bzt(t) {
  let e = {}, r = 0;
  if (jh(t, (n, a) => {
    Ozt[a] || (e[a] = n, r++);
  }), r) return e;
}
function yhe(t) {
  let e = Bzt(t);
  if (e) {
    let r = { to: e };
    return jh(t, (n, a) => a in e || (r[a] = n)), r;
  }
  return { ...t };
}
function RT(t) {
  return t = fd(t), Or.arr(t) ? t.map(RT) : zz(t) ? Td.createStringInterpolator({ range: [0, 1], output: [t, t] })(1) : t;
}
function QZe(t) {
  for (let e in t) return !0;
  return !1;
}
function mue(t) {
  return Or.fun(t) || Or.arr(t) && Or.obj(t[0]);
}
function gue(t, e) {
  var r;
  (r = t.ref) == null || r.delete(t), e == null || e.delete(t);
}
function bhe(t, e) {
  var r;
  e && t.ref !== e && ((r = t.ref) == null || r.delete(t), e.add(t), t.ref = e);
}
function Nzt(t, e, r = 1e3) {
  xm(() => {
    if (e) {
      let n = 0;
      na(t, (a, i) => {
        let o = a.current;
        if (o.length) {
          let s = r * e[i];
          isNaN(s) ? s = n : n = s, na(o, (l) => {
            na(l.queue, (c) => {
              let u = c.delay;
              c.delay = (f) => s + bu(u || 0, f);
            });
          }), a.start();
        }
      });
    } else {
      let n = Promise.resolve();
      na(t, (a) => {
        let i = a.current;
        if (i.length) {
          let o = i.map((s) => {
            let l = s.queue;
            return s.queue = [], l;
          });
          n = n.then(() => (na(i, (s, l) => na(o[l] || [], (c) => s.queue.push(c))), Promise.all(a.start())));
        }
      });
    }
  });
}
var $zt = { default: { tension: 170, friction: 26 } }, vue = { ...$zt.default, mass: 1, damping: 1, easing: dzt.linear, clamp: !1 }, Dzt = class {
  constructor() {
    this.velocity = 0, Object.assign(this, vue);
  }
};
function Lzt(t, e, r) {
  r && (r = { ...r }, y9e(r, e), e = { ...r, ...e }), y9e(t, e), Object.assign(t, e);
  for (let o in vue) t[o] == null && (t[o] = vue[o]);
  let { frequency: n, damping: a } = t, { mass: i } = t;
  return Or.und(n) || (n < 0.01 && (n = 0.01), a < 0 && (a = 0), t.tension = Math.pow(2 * Math.PI / n, 2) * i, t.friction = 4 * Math.PI * a * i / n), t;
}
function y9e(t, e) {
  if (!Or.und(e.decay)) t.duration = void 0;
  else {
    let r = !Or.und(e.tension) || !Or.und(e.friction);
    (r || !Or.und(e.frequency) || !Or.und(e.damping) || !Or.und(e.mass)) && (t.duration = void 0, t.decay = void 0), r && (t.frequency = void 0);
  }
}
var b9e = [], jzt = class {
  constructor() {
    this.changed = !1, this.values = b9e, this.toValues = null, this.fromValues = b9e, this.config = new Dzt(), this.immediate = !1;
  }
};
function eJe(t, { key: e, props: r, defaultProps: n, state: a, actions: i }) {
  return new Promise((o, s) => {
    let l, c, u = M_(r.cancel ?? (n == null ? void 0 : n.cancel), e);
    if (u) p();
    else {
      Or.und(r.pause) || (a.paused = M_(r.pause, e));
      let g = n == null ? void 0 : n.pause;
      g !== !0 && (g = a.paused || M_(g, e)), l = bu(r.delay || 0, e), g ? (a.resumeQueue.add(h), i.pause()) : (i.resume(), h());
    }
    function f() {
      a.resumeQueue.add(h), a.timeouts.delete(c), c.cancel(), l = c.time - ei.now();
    }
    function h() {
      l > 0 && !Td.skipAnimation ? (a.delayed = !0, c = ei.setTimeout(p, l), a.pauseQueue.add(f), a.timeouts.add(c)) : p();
    }
    function p() {
      a.delayed && (a.delayed = !1), a.pauseQueue.delete(f), a.timeouts.delete(c), t <= (a.cancelId || 0) && (u = !0);
      try {
        i.start({ ...r, callId: t, cancel: u }, o);
      } catch (g) {
        s(g);
      }
    }
  });
}
var xhe = (t, e) => e.length == 1 ? e[0] : e.some((r) => r.cancelled) ? p7(t.get()) : e.every((r) => r.noop) ? tJe(t.get()) : d1(t.get(), e.every((r) => r.finished)), tJe = (t) => ({ value: t, noop: !0, finished: !0, cancelled: !1 }), d1 = (t, e, r = !1) => ({ value: t, finished: e, cancelled: r }), p7 = (t) => ({ value: t, cancelled: !0, finished: !1 });
function rJe(t, e, r, n) {
  let { callId: a, parentId: i, onRest: o } = e, { asyncTo: s, promise: l } = r;
  return !i && t === s && !e.reset ? l : r.promise = (async () => {
    r.asyncId = a, r.asyncTo = t;
    let c = Hz(e, (b, w) => w === "onRest" ? void 0 : b), u, f, h = new Promise((b, w) => (u = b, f = w)), p = (b) => {
      let w = a <= (r.cancelId || 0) && p7(n) || a !== r.asyncId && d1(n, !1);
      if (w) throw b.result = w, f(b), b;
    }, g = (b, w) => {
      let _ = new x9e(), C = new C9e();
      return (async () => {
        if (Td.skipAnimation) throw OT(r), C.result = d1(n, !1), f(C), C;
        p(_);
        let x = Or.obj(b) ? { ...b } : { ...w, to: b };
        x.parentId = a, jh(c, (A, I) => {
          Or.und(x[I]) && (x[I] = A);
        });
        let S = await n.start(x);
        return p(_), r.paused && await new Promise((A) => {
          r.resumeQueue.add(A);
        }), S;
      })();
    }, y;
    if (Td.skipAnimation) return OT(r), d1(n, !1);
    try {
      let b;
      Or.arr(t) ? b = (async (w) => {
        for (let _ of w) await g(_);
      })(t) : b = Promise.resolve(t(g, n.stop.bind(n))), await Promise.all([b.then(u), h]), y = d1(n.get(), !0, !1);
    } catch (b) {
      if (b instanceof x9e) y = b.result;
      else if (b instanceof C9e) y = b.result;
      else throw b;
    } finally {
      a == r.asyncId && (r.asyncId = i, r.asyncTo = i ? s : void 0, r.promise = i ? l : void 0);
    }
    return Or.fun(o) && ei.batchedUpdates(() => {
      o(y, n, n.item);
    }), y;
  })();
}
function OT(t, e) {
  E_(t.timeouts, (r) => r.cancel()), t.pauseQueue.clear(), t.resumeQueue.clear(), t.asyncId = t.asyncTo = t.promise = void 0, e && (t.cancelId = e);
}
var x9e = class extends Error {
  constructor() {
    super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
  }
}, C9e = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, yue = (t) => t instanceof Che, Fzt = 1, Che = class extends WZe {
  constructor() {
    super(...arguments), this.id = Fzt++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(t) {
    this._priority != t && (this._priority = t, this._onPriorityChange(t));
  }
  get() {
    let t = K2(this);
    return t && t.getValue();
  }
  to(...t) {
    return Td.to(this, t);
  }
  interpolate(...t) {
    return KZe(), Td.to(this, t);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(t) {
    t == 1 && this._attach();
  }
  observerRemoved(t) {
    t == 0 && this._detach();
  }
  _attach() {
  }
  _detach() {
  }
  _onChange(t, e = !1) {
    ET(this, { type: "change", parent: this, value: t, idle: e });
  }
  _onPriorityChange(t) {
    this.idle || Lz.sort(this), ET(this, { type: "priority", parent: this, priority: t });
  }
}, b5 = Symbol.for("SpringPhase"), nJe = 1, aJe = 2, iJe = 4, nZ = (t) => (t[b5] & nJe) > 0, Kg = (t) => (t[b5] & aJe) > 0, Vw = (t) => (t[b5] & iJe) > 0, w9e = (t, e) => e ? t[b5] |= aJe | nJe : t[b5] &= -3, S9e = (t, e) => e ? t[b5] |= iJe : t[b5] &= -5, zzt = class extends Che {
  constructor(t, e) {
    if (super(), this.animation = new jzt(), this.defaultProps = {}, this._state = { paused: !1, delayed: !1, pauseQueue: /* @__PURE__ */ new Set(), resumeQueue: /* @__PURE__ */ new Set(), timeouts: /* @__PURE__ */ new Set() }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !Or.und(t) || !Or.und(e)) {
      let r = Or.obj(t) ? { ...t } : { ...e, from: t };
      Or.und(r.default) && (r.default = !0), this.start(r);
    }
  }
  get idle() {
    return !(Kg(this) || this._state.asyncTo) || Vw(this);
  }
  get goal() {
    return fd(this.animation.to);
  }
  get velocity() {
    let t = K2(this);
    return t instanceof rM ? t.lastVelocity || 0 : t.getPayload().map((e) => e.lastVelocity || 0);
  }
  get hasAnimated() {
    return nZ(this);
  }
  get isAnimating() {
    return Kg(this);
  }
  get isPaused() {
    return Vw(this);
  }
  get isDelayed() {
    return this._state.delayed;
  }
  advance(t) {
    let e = !0, r = !1, n = this.animation, { toValues: a } = n, { config: i } = n, o = Gz(n.to);
    !o && V0(n.to) && (a = Cu(fd(n.to))), n.values.forEach((c, u) => {
      if (c.done) return;
      let f = c.constructor == PT ? 1 : o ? o[u].lastPosition : a[u], h = n.immediate, p = f;
      if (!h) {
        if (p = c.lastPosition, i.tension <= 0) {
          c.done = !0;
          return;
        }
        let g = c.elapsedTime += t, y = n.fromValues[u], b = c.v0 != null ? c.v0 : c.v0 = Or.arr(i.velocity) ? i.velocity[u] : i.velocity, w, _ = i.precision || (y == f ? 5e-3 : Math.min(1, Math.abs(f - y) * 1e-3));
        if (Or.und(i.duration)) if (i.decay) {
          let C = i.decay === !0 ? 0.998 : i.decay, x = Math.exp(-(1 - C) * g);
          p = y + b / (1 - C) * (1 - x), h = Math.abs(c.lastPosition - p) <= _, w = b * x;
        } else {
          w = c.lastVelocity == null ? b : c.lastVelocity;
          let C = i.restVelocity || _ / 10, x = i.clamp ? 0 : i.bounce, S = !Or.und(x), A = y == f ? c.v0 > 0 : y < f, I, M = !1, B = 1, L = Math.ceil(t / B);
          for (let N = 0; N < L && (I = Math.abs(w) > C, !(!I && (h = Math.abs(f - p) <= _, h))); ++N) {
            S && (M = p == f || p > f == A, M && (w = -w * x, p = f));
            let d = -i.tension * 1e-6 * (p - f), m = -i.friction * 1e-3 * w, v = (d + m) / i.mass;
            w = w + v * B, p = p + w * B;
          }
        }
        else {
          let C = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, c.durationProgress > 0 && (c.elapsedTime = i.duration * c.durationProgress, g = c.elapsedTime += t)), C = (i.progress || 0) + g / this._memoizedDuration, C = C > 1 ? 1 : C < 0 ? 0 : C, c.durationProgress = C), p = y + i.easing(C) * (f - y), w = (p - c.lastPosition) / t, h = C == 1;
        }
        c.lastVelocity = w, Number.isNaN(p) && (console.warn("Got NaN while animating:", this), h = !0);
      }
      o && !o[u].done && (h = !1), h ? c.done = !0 : e = !1, c.setValue(p, i.round) && (r = !0);
    });
    let s = K2(this), l = s.getValue();
    if (e) {
      let c = fd(n.to);
      (l !== c || r) && !i.decay ? (s.setValue(c), this._onChange(c)) : r && i.decay && this._onChange(l), this._stop();
    } else r && this._onChange(l);
  }
  set(t) {
    return ei.batchedUpdates(() => {
      this._stop(), this._focus(t), this._set(t);
    }), this;
  }
  pause() {
    this._update({ pause: !0 });
  }
  resume() {
    this._update({ pause: !1 });
  }
  finish() {
    if (Kg(this)) {
      let { to: t, config: e } = this.animation;
      ei.batchedUpdates(() => {
        this._onStart(), e.decay || this._set(t, !1), this._stop();
      });
    }
    return this;
  }
  update(t) {
    return (this.queue || (this.queue = [])).push(t), this;
  }
  start(t, e) {
    let r;
    return Or.und(t) ? (r = this.queue || [], this.queue = []) : r = [Or.obj(t) ? t : { ...e, to: t }], Promise.all(r.map((n) => this._update(n))).then((n) => xhe(this, n));
  }
  stop(t) {
    let { to: e } = this.animation;
    return this._focus(this.get()), OT(this._state, t && this._lastCallId), ei.batchedUpdates(() => this._stop(e, t)), this;
  }
  reset() {
    this._update({ reset: !0 });
  }
  eventObserved(t) {
    t.type == "change" ? this._start() : t.type == "priority" && (this.priority = t.priority + 1);
  }
  _prepareNode(t) {
    let e = this.key || "", { to: r, from: n } = t;
    r = Or.obj(r) ? r[e] : r, (r == null || mue(r)) && (r = void 0), n = Or.obj(n) ? n[e] : n, n == null && (n = void 0);
    let a = { to: r, from: n };
    return nZ(this) || (t.reverse && ([r, n] = [n, r]), n = fd(n), Or.und(n) ? K2(this) || this._set(r) : this._set(n)), a;
  }
  _update({ ...t }, e) {
    let { key: r, defaultProps: n } = this;
    t.default && Object.assign(n, Hz(t, (o, s) => /^on/.test(s) ? YZe(o, r) : o)), k9e(this, t, "onProps"), Kw(this, "onProps", t, this);
    let a = this._prepareNode(t);
    if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
    let i = this._state;
    return eJe(++this._lastCallId, { key: r, props: t, defaultProps: n, state: i, actions: { pause: () => {
      Vw(this) || (S9e(this, !0), XS(i.pauseQueue), Kw(this, "onPause", d1(this, qw(this, this.animation.to)), this));
    }, resume: () => {
      Vw(this) && (S9e(this, !1), Kg(this) && this._resume(), XS(i.resumeQueue), Kw(this, "onResume", d1(this, qw(this, this.animation.to)), this));
    }, start: this._merge.bind(this, a) } }).then((o) => {
      if (t.loop && o.finished && !(e && o.noop)) {
        let s = oJe(t);
        if (s) return this._update(s, !0);
      }
      return o;
    });
  }
  _merge(t, e, r) {
    if (e.cancel) return this.stop(!0), r(p7(this));
    let n = !Or.und(t.to), a = !Or.und(t.from);
    if (n || a) if (e.callId > this._lastToId) this._lastToId = e.callId;
    else return r(p7(this));
    let { key: i, defaultProps: o, animation: s } = this, { to: l, from: c } = s, { to: u = l, from: f = c } = t;
    a && !n && (!e.default || Or.und(u)) && (u = f), e.reverse && ([u, f] = [f, u]);
    let h = !Yp(f, c);
    h && (s.from = f), f = fd(f);
    let p = !Yp(u, l);
    p && this._focus(u);
    let g = mue(e.to), { config: y } = s, { decay: b, velocity: w } = y;
    (n || a) && (y.velocity = 0), e.config && !g && Lzt(y, bu(e.config, i), e.config !== o.config ? bu(o.config, i) : void 0);
    let _ = K2(this);
    if (!_ || Or.und(u)) return r(d1(this, !0));
    let C = Or.und(e.reset) ? a && !e.default : !Or.und(f) && M_(e.reset, i), x = C ? f : this.get(), S = RT(u), A = Or.num(S) || Or.arr(S) || zz(S), I = !g && (!A || M_(o.immediate || e.immediate, i));
    if (p) {
      let N = pue(u);
      if (N !== _.constructor) if (I) _ = this._set(S);
      else throw Error(`Cannot animate between ${_.constructor.name} and ${N.name}, as the "to" prop suggests`);
    }
    let M = _.constructor, B = V0(u), L = !1;
    if (!B) {
      let N = C || !nZ(this) && h;
      (p || N) && (L = Yp(RT(x), S), B = !L), (!Yp(s.immediate, I) && !I || !Yp(y.decay, b) || !Yp(y.velocity, w)) && (B = !0);
    }
    if (L && Kg(this) && (s.changed && !C ? B = !0 : B || this._stop(l)), !g && ((B || V0(l)) && (s.values = _.getPayload(), s.toValues = V0(u) ? null : M == PT ? [1] : Cu(S)), s.immediate != I && (s.immediate = I, !I && !C && this._set(l)), B)) {
      let { onRest: N } = s;
      na(Wzt, (m) => k9e(this, e, m));
      let d = d1(this, qw(this, l));
      XS(this._pendingCalls, d), this._pendingCalls.add(r), s.changed && ei.batchedUpdates(() => {
        var m;
        s.changed = !C, N == null || N(d, this), C ? bu(o.onRest, d) : (m = s.onStart) == null || m.call(s, d, this);
      });
    }
    C && this._set(x), g ? r(rJe(e.to, e, this._state, this)) : B ? this._start() : Kg(this) && !p ? this._pendingCalls.add(r) : r(tJe(x));
  }
  _focus(t) {
    let e = this.animation;
    t !== e.to && (h9e(this) && this._detach(), e.to = t, h9e(this) && this._attach());
  }
  _attach() {
    let t = 0, { to: e } = this.animation;
    V0(e) && (k8(e, this), yue(e) && (t = e.priority + 1)), this.priority = t;
  }
  _detach() {
    let { to: t } = this.animation;
    V0(t) && IT(t, this);
  }
  _set(t, e = !0) {
    let r = fd(t);
    if (!Or.und(r)) {
      let n = K2(this);
      if (!n || !Yp(r, n.getValue())) {
        let a = pue(r);
        !n || n.constructor != a ? vhe(this, a.create(r)) : n.setValue(r), n && ei.batchedUpdates(() => {
          this._onChange(r, e);
        });
      }
    }
    return K2(this);
  }
  _onStart() {
    let t = this.animation;
    t.changed || (t.changed = !0, Kw(this, "onStart", d1(this, qw(this, t.to)), this));
  }
  _onChange(t, e) {
    e || (this._onStart(), bu(this.animation.onChange, t, this)), bu(this.defaultProps.onChange, t, this), super._onChange(t, e);
  }
  _start() {
    let t = this.animation;
    K2(this).reset(fd(t.to)), t.immediate || (t.fromValues = t.values.map((e) => e.lastPosition)), Kg(this) || (w9e(this, !0), Vw(this) || this._resume());
  }
  _resume() {
    Td.skipAnimation ? this.finish() : Lz.start(this);
  }
  _stop(t, e) {
    if (Kg(this)) {
      w9e(this, !1);
      let r = this.animation;
      na(r.values, (a) => {
        a.done = !0;
      }), r.toValues && (r.onChange = r.onPause = r.onResume = void 0), ET(this, { type: "idle", parent: this });
      let n = e ? p7(this.get()) : d1(this.get(), qw(this, t ?? r.to));
      XS(this._pendingCalls, n), r.changed && (r.changed = !1, Kw(this, "onRest", n, this));
    }
  }
};
function qw(t, e) {
  let r = RT(e), n = RT(t.get());
  return Yp(n, r);
}
function oJe(t, e = t.loop, r = t.to) {
  let n = bu(e);
  if (n) {
    let a = n !== !0 && yhe(n), i = (a || t).reverse, o = !a || a.reset;
    return BT({ ...t, loop: e, default: !1, pause: void 0, to: !i || mue(r) ? r : void 0, from: o ? t.from : void 0, reset: o, ...a });
  }
}
function BT(t) {
  let { to: e, from: r } = t = yhe(t), n = /* @__PURE__ */ new Set();
  return Or.obj(e) && _9e(e, n), Or.obj(r) && _9e(r, n), t.keys = n.size ? Array.from(n) : null, t;
}
function Gzt(t) {
  let e = BT(t);
  return Or.und(e.default) && (e.default = Hz(e)), e;
}
function _9e(t, e) {
  jh(t, (r, n) => r != null && e.add(n));
}
var Wzt = ["onStart", "onRest", "onChange", "onPause", "onResume"];
function k9e(t, e, r) {
  t.animation[r] = e[r] !== XZe(e, r) ? YZe(e[r], t.key) : void 0;
}
function Kw(t, e, ...r) {
  var n, a, i, o;
  (a = (n = t.animation)[e]) == null || a.call(n, ...r), (o = (i = t.defaultProps)[e]) == null || o.call(i, ...r);
}
var Hzt = ["onStart", "onChange", "onRest"], Uzt = 1, sJe = class {
  constructor(e, r) {
    this.id = Uzt++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = { paused: !1, pauseQueue: /* @__PURE__ */ new Set(), resumeQueue: /* @__PURE__ */ new Set(), timeouts: /* @__PURE__ */ new Set() }, this._events = { onStart: /* @__PURE__ */ new Map(), onChange: /* @__PURE__ */ new Map(), onRest: /* @__PURE__ */ new Map() }, this._onFrame = this._onFrame.bind(this), r && (this._flush = r), e && this.start({ default: !0, ...e });
  }
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  get() {
    let e = {};
    return this.each((r, n) => e[n] = r.get()), e;
  }
  set(e) {
    for (let r in e) {
      let n = e[r];
      Or.und(n) || this.springs[r].set(n);
    }
  }
  update(e) {
    return e && this.queue.push(BT(e)), this;
  }
  start(e) {
    let { queue: r } = this;
    return e ? r = Cu(e).map(BT) : this.queue = [], this._flush ? this._flush(this, r) : (fJe(this, r), bue(this, r));
  }
  stop(e, r) {
    if (e !== !!e && (r = e), r) {
      let n = this.springs;
      na(Cu(r), (a) => n[a].stop(!!e));
    } else OT(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  pause(e) {
    if (Or.und(e)) this.start({ pause: !0 });
    else {
      let r = this.springs;
      na(Cu(e), (n) => r[n].pause());
    }
    return this;
  }
  resume(e) {
    if (Or.und(e)) this.start({ pause: !1 });
    else {
      let r = this.springs;
      na(Cu(e), (n) => r[n].resume());
    }
    return this;
  }
  each(e) {
    jh(this.springs, e);
  }
  _onFrame() {
    let { onStart: e, onChange: r, onRest: n } = this._events, a = this._active.size > 0, i = this._changed.size > 0;
    (a && !this._started || i && !this._started) && (this._started = !0, E_(e, ([l, c]) => {
      c.value = this.get(), l(c, this, this._item);
    }));
    let o = !a && this._started, s = i || o && n.size ? this.get() : null;
    i && r.size && E_(r, ([l, c]) => {
      c.value = s, l(c, this, this._item);
    }), o && (this._started = !1, E_(n, ([l, c]) => {
      c.value = s, l(c, this, this._item);
    }));
  }
  eventObserved(e) {
    if (e.type == "change") this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle") this._active.delete(e.parent);
    else return;
    ei.onFrame(this._onFrame);
  }
};
function bue(t, e) {
  return Promise.all(e.map((r) => lJe(t, r))).then((r) => xhe(t, r));
}
async function lJe(t, e, r) {
  let { keys: n, to: a, from: i, loop: o, onRest: s, onResolve: l } = e, c = Or.obj(e.default) && e.default;
  o && (e.loop = !1), a === !1 && (e.to = null), i === !1 && (e.from = null);
  let u = Or.arr(a) || Or.fun(a) ? a : void 0;
  u ? (e.to = void 0, e.onRest = void 0, c && (c.onRest = void 0)) : na(Hzt, (y) => {
    let b = e[y];
    if (Or.fun(b)) {
      let w = t._events[y];
      e[y] = ({ finished: _, cancelled: C }) => {
        let x = w.get(b);
        x ? (_ || (x.finished = !1), C && (x.cancelled = !0)) : w.set(b, { value: null, finished: _ || !1, cancelled: C || !1 });
      }, c && (c[y] = e[y]);
    }
  });
  let f = t._state;
  e.pause === !f.paused ? (f.paused = e.pause, XS(e.pause ? f.pauseQueue : f.resumeQueue)) : f.paused && (e.pause = !0);
  let h = (n || Object.keys(t.springs)).map((y) => t.springs[y].start(e)), p = e.cancel === !0 || XZe(e, "cancel") === !0;
  (u || p && f.asyncId) && h.push(eJe(++t._lastAsyncId, { props: e, state: f, actions: { pause: due, resume: due, start(y, b) {
    p ? (OT(f, t._lastAsyncId), b(p7(t))) : (y.onRest = s, b(rJe(u, y, f, t)));
  } } })), f.paused && await new Promise((y) => {
    f.resumeQueue.add(y);
  });
  let g = xhe(t, await Promise.all(h));
  if (o && g.finished && !(r && g.noop)) {
    let y = oJe(e, o, a);
    if (y) return fJe(t, [y]), lJe(t, y, !0);
  }
  return l && ei.batchedUpdates(() => l(g, t, t.item)), g;
}
function xue(t, e) {
  let r = { ...t.springs };
  return e && na(Cu(e), (n) => {
    Or.und(n.keys) && (n = BT(n)), Or.obj(n.to) || (n = { ...n, to: void 0 }), dJe(r, n, (a) => uJe(a));
  }), cJe(t, r), r;
}
function cJe(t, e) {
  jh(e, (r, n) => {
    t.springs[n] || (t.springs[n] = r, k8(r, t));
  });
}
function uJe(t, e) {
  let r = new zzt();
  return r.key = t, e && k8(r, e), r;
}
function dJe(t, e, r) {
  e.keys && na(e.keys, (n) => {
    (t[n] || (t[n] = r(n)))._prepareNode(e);
  });
}
function fJe(t, e) {
  na(e, (r) => {
    dJe(t.springs, r, (n) => uJe(n, t));
  });
}
var nM = ({ children: t, ...e }) => {
  let r = Qn(bL), n = e.pause || !!r.pause, a = e.immediate || !!r.immediate;
  e = wzt(() => ({ pause: n, immediate: a }), [n, a]);
  let { Provider: i } = bL;
  return P.createElement(i, { value: e }, t);
}, bL = Vzt(nM, {});
nM.Provider = bL.Provider;
nM.Consumer = bL.Consumer;
function Vzt(t, e) {
  return Object.assign(t, P.createContext(e)), t.Provider._context = t, t.Consumer._context = t, t;
}
var hJe = () => {
  let t = [], e = function(n) {
    xzt();
    let a = [];
    return na(t, (i, o) => {
      if (Or.und(n)) a.push(i.start());
      else {
        let s = r(n, i, o);
        s && a.push(i.start(s));
      }
    }), a;
  };
  e.current = t, e.add = function(n) {
    t.includes(n) || t.push(n);
  }, e.delete = function(n) {
    let a = t.indexOf(n);
    ~a && t.splice(a, 1);
  }, e.pause = function() {
    return na(t, (n) => n.pause(...arguments)), this;
  }, e.resume = function() {
    return na(t, (n) => n.resume(...arguments)), this;
  }, e.set = function(n) {
    na(t, (a, i) => {
      let o = Or.fun(n) ? n(i, a) : n;
      o && a.set(o);
    });
  }, e.start = function(n) {
    let a = [];
    return na(t, (i, o) => {
      if (Or.und(n)) a.push(i.start());
      else {
        let s = this._getProps(n, i, o);
        s && a.push(i.start(s));
      }
    }), a;
  }, e.stop = function() {
    return na(t, (n) => n.stop(...arguments)), this;
  }, e.update = function(n) {
    return na(t, (a, i) => a.update(this._getProps(n, a, i))), this;
  };
  let r = function(n, a, i) {
    return Or.fun(n) ? n(i, a) : n;
  };
  return e._getProps = r, e;
};
function whe(t, e, r) {
  let n = Or.fun(e) && e;
  n && !r && (r = []);
  let a = fa(() => n || arguments.length == 3 ? hJe() : void 0, []), i = Zt(0), o = mhe(), s = fa(() => ({ ctrls: [], queue: [], flush(w, _) {
    let C = xue(w, _);
    return i.current > 0 && !s.queue.length && !Object.keys(C).some((x) => !w.springs[x]) ? bue(w, _) : new Promise((x) => {
      cJe(w, C), s.queue.push(() => {
        x(bue(w, _));
      }), o();
    });
  } }), []), l = Zt([...s.ctrls]), c = [], u = hue(t) || 0;
  fa(() => {
    na(l.current.slice(t, u), (w) => {
      gue(w, a), w.stop(!0);
    }), l.current.length = t, f(u, t);
  }, [t]), fa(() => {
    f(0, Math.min(u, t));
  }, r);
  function f(w, _) {
    for (let C = w; C < _; C++) {
      let x = l.current[C] || (l.current[C] = new sJe(null, s.flush)), S = n ? n(C, x) : e[C];
      S && (c[C] = Gzt(S));
    }
  }
  let h = l.current.map((w, _) => xue(w, c[_])), p = Qn(nM), g = hue(p), y = p !== g && QZe(p);
  xm(() => {
    i.current++, s.ctrls = l.current;
    let { queue: w } = s;
    w.length && (s.queue = [], na(w, (_) => _())), na(l.current, (_, C) => {
      a == null || a.add(_), y && _.start({ default: p });
      let x = c[C];
      x && (bhe(_, x.ref), _.ref ? _.queue.push(x) : _.start(x));
    });
  }), ghe(() => () => {
    na(s.ctrls, (w) => w.stop(!0));
  });
  let b = h.map((w) => ({ ...w }));
  return a ? [b, a] : b;
}
function aM(t, e) {
  let r = Or.fun(t), [[n], a] = whe(1, r ? t : [t], r ? e || [] : e);
  return r || arguments.length == 2 ? [n, a] : n;
}
function qzt(t, e, r) {
  let n = Or.fun(e) && e;
  n && !r && (r = []);
  let a = !0, i, o = whe(t, (s, l) => {
    let c = n ? n(s, l) : e;
    return i = c.ref, a = a && c.reverse, c;
  }, r || [{}]);
  if (xm(() => {
    na(o[1].current, (s, l) => {
      let c = o[1].current[l + (a ? 1 : -1)];
      if (bhe(s, i), s.ref) {
        c && s.update({ to: c.springs });
        return;
      }
      c ? s.start({ to: c.springs }) : s.start();
    });
  }, r), n || arguments.length == 3) {
    let s = i ?? o[1];
    return s._getProps = (l, c, u) => {
      let f = Or.fun(l) ? l(u, c) : l;
      if (f) {
        let h = s.current[u + (f.reverse ? 1 : -1)];
        return h && (f.to = h.springs), f;
      }
    }, o;
  }
  return o[0];
}
function A8(t, e, r) {
  let n = Or.fun(e) && e, { reset: a, sort: i, trail: o = 0, expires: s = !0, exitBeforeEnter: l = !1, onDestroyed: c, ref: u, config: f } = n ? n() : e, h = fa(() => n || arguments.length == 3 ? hJe() : void 0, []), p = Cu(t), g = [], y = Zt(null), b = a ? null : y.current;
  xm(() => {
    y.current = g;
  }), ghe(() => (na(g, (v) => {
    h == null || h.add(v.ctrl), v.ctrl.ref = h;
  }), () => {
    na(y.current, (v) => {
      v.expired && clearTimeout(v.expirationId), gue(v.ctrl, h), v.ctrl.stop(!0);
    });
  }));
  let w = Zzt(p, n ? n() : e, b), _ = a && y.current || [];
  xm(() => na(_, ({ ctrl: v, item: k, key: O }) => {
    gue(v, h), bu(c, k, O);
  }));
  let C = [];
  if (b && na(b, (v, k) => {
    v.expired ? (clearTimeout(v.expirationId), _.push(v)) : (k = C[k] = w.indexOf(v.key), ~k && (g[k] = v));
  }), na(p, (v, k) => {
    g[k] || (g[k] = { key: w[k], item: v, phase: "mount", ctrl: new sJe() }, g[k].ctrl.item = v);
  }), C.length) {
    let v = -1, { leave: k } = n ? n() : e;
    na(C, (O, G) => {
      let H = b[G];
      ~O ? (v = g.indexOf(H), g[v] = { ...H, item: p[O] }) : k && g.splice(++v, 0, H);
    });
  }
  Or.fun(i) && g.sort((v, k) => i(v.item, k.item));
  let x = -o, S = mhe(), A = Hz(e), I = /* @__PURE__ */ new Map(), M = Zt(/* @__PURE__ */ new Map()), B = Zt(!1);
  na(g, (v, k) => {
    let O = v.key, G = v.phase, H = n ? n() : e, j, F, z = bu(H.delay || 0, O);
    if (G == "mount") j = H.enter, F = "enter";
    else {
      let V = w.indexOf(O) < 0;
      if (G != "leave") if (V) j = H.leave, F = "leave";
      else if (j = H.update) F = "update";
      else return;
      else if (!V) j = H.enter, F = "enter";
      else return;
    }
    if (j = bu(j, v.item, k), j = Or.obj(j) ? yhe(j) : { to: j }, !j.config) {
      let V = f || A.config;
      j.config = bu(V, v.item, k, F);
    }
    x += o;
    let W = { ...A, delay: z + x, ref: u, immediate: H.immediate, reset: !1, ...j };
    if (F == "enter" && Or.und(W.from)) {
      let V = n ? n() : e, Y = Or.und(V.initial) || b ? V.from : V.initial;
      W.from = bu(Y, v.item, k);
    }
    let { onResolve: U } = W;
    W.onResolve = (V) => {
      bu(U, V);
      let Y = y.current, ge = Y.find((ce) => ce.key === O);
      if (ge && !(V.cancelled && ge.phase != "update") && ge.ctrl.idle) {
        let ce = Y.every((ee) => ee.ctrl.idle);
        if (ge.phase == "leave") {
          let ee = bu(s, ge.item);
          if (ee !== !1) {
            let Se = ee === !0 ? 0 : ee;
            if (ge.expired = !0, !ce && Se > 0) {
              Se <= 2147483647 && (ge.expirationId = setTimeout(S, Se));
              return;
            }
          }
        }
        ce && Y.some((ee) => ee.expired) && (M.current.delete(ge), l && (B.current = !0), S());
      }
    };
    let Z = xue(v.ctrl, W);
    F === "leave" && l ? M.current.set(v, { phase: F, springs: Z, payload: W }) : I.set(v, { phase: F, springs: Z, payload: W });
  });
  let L = Qn(nM), N = hue(L), d = L !== N && QZe(L);
  xm(() => {
    d && na(g, (v) => {
      v.ctrl.start({ default: L });
    });
  }, [L]), na(I, (v, k) => {
    if (M.current.size) {
      let O = g.findIndex((G) => G.key === k.key);
      g.splice(O, 1);
    }
  }), xm(() => {
    na(M.current.size ? M.current : I, ({ phase: v, payload: k }, O) => {
      let { ctrl: G } = O;
      O.phase = v, h == null || h.add(G), d && v == "enter" && G.start({ default: L }), k && (bhe(G, k.ref), (G.ref || h) && !B.current ? G.update(k) : (G.start(k), B.current && (B.current = !1)));
    });
  }, a ? void 0 : r);
  let m = (v) => P.createElement(P.Fragment, null, g.map((k, O) => {
    let { springs: G } = I.get(k) || k.ctrl, H = v({ ...G }, k.item, k, O);
    return H && H.type ? P.createElement(H.type, { ...H.props, key: Or.str(k.key) || Or.num(k.key) ? k.key : k.ctrl.id, ref: H.ref }) : H;
  }));
  return h ? [m, h] : m;
}
var Kzt = 1;
function Zzt(t, { key: e, keys: r = e }, n) {
  if (r === null) {
    let a = /* @__PURE__ */ new Set();
    return t.map((i) => {
      let o = n && n.find((s) => s.item === i && s.phase !== "leave" && !a.has(s));
      return o ? (a.add(o), o.key) : Kzt++;
    });
  }
  return Or.und(r) ? t : Or.fun(r) ? t.map(r) : Cu(r);
}
var pJe = class extends Che {
  constructor(t, e) {
    super(), this.source = t, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = AT(...e);
    let r = this._get(), n = pue(r);
    vhe(this, n.create(r));
  }
  advance(t) {
    let e = this._get(), r = this.get();
    Yp(e, r) || (K2(this).setValue(e), this._onChange(e, this.idle)), !this.idle && A9e(this._active) && aZ(this);
  }
  _get() {
    let t = Or.arr(this.source) ? this.source.map(fd) : Cu(fd(this.source));
    return this.calc(...t);
  }
  _start() {
    this.idle && !A9e(this._active) && (this.idle = !1, na(Gz(this), (t) => {
      t.done = !1;
    }), Td.skipAnimation ? (ei.batchedUpdates(() => this.advance()), aZ(this)) : Lz.start(this));
  }
  _attach() {
    let t = 1;
    na(Cu(this.source), (e) => {
      V0(e) && k8(e, this), yue(e) && (e.idle || this._active.add(e), t = Math.max(t, e.priority + 1));
    }), this.priority = t, this._start();
  }
  _detach() {
    na(Cu(this.source), (t) => {
      V0(t) && IT(t, this);
    }), this._active.clear(), aZ(this);
  }
  eventObserved(t) {
    t.type == "change" ? t.idle ? this.advance() : (this._active.add(t.parent), this._start()) : t.type == "idle" ? this._active.delete(t.parent) : t.type == "priority" && (this.priority = Cu(this.source).reduce((e, r) => Math.max(e, (yue(r) ? r.priority : 0) + 1), 0));
  }
};
function Jzt(t) {
  return t.idle !== !1;
}
function A9e(t) {
  return !t.size || Array.from(t).every(Jzt);
}
function aZ(t) {
  t.idle || (t.idle = !0, na(Gz(t), (e) => {
    e.done = !0;
  }), ET(t, { type: "idle", parent: t }));
}
var Yzt = (t, ...e) => (KZe(), new pJe(t, e));
Td.assign({ createStringInterpolator: VZe, to: (t, e) => new pJe(t, e) });
var mJe = /^--/;
function Xzt(t, e) {
  return e == null || typeof e == "boolean" || e === "" ? "" : typeof e == "number" && e !== 0 && !mJe.test(t) && !(P_.hasOwnProperty(t) && P_[t]) ? e + "px" : ("" + e).trim();
}
var T9e = {};
function Qzt(t, e) {
  if (!t.nodeType || !t.setAttribute) return !1;
  let r = t.nodeName === "filter" || t.parentNode && t.parentNode.nodeName === "filter", { className: n, style: a, children: i, scrollTop: o, scrollLeft: s, viewBox: l, ...c } = e, u = Object.values(c), f = Object.keys(c).map((h) => r || t.hasAttribute(h) ? h : T9e[h] || (T9e[h] = h.replace(/([A-Z])/g, (p) => "-" + p.toLowerCase())));
  i !== void 0 && (t.textContent = i);
  for (let h in a) if (a.hasOwnProperty(h)) {
    let p = Xzt(h, a[h]);
    mJe.test(h) ? t.style.setProperty(h, p) : t.style[h] = p;
  }
  f.forEach((h, p) => {
    t.setAttribute(h, u[p]);
  }), n !== void 0 && (t.className = n), o !== void 0 && (t.scrollTop = o), s !== void 0 && (t.scrollLeft = s), l !== void 0 && t.setAttribute("viewBox", l);
}
var P_ = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 }, eGt = (t, e) => t + e.charAt(0).toUpperCase() + e.substring(1), tGt = ["Webkit", "Ms", "Moz", "O"];
P_ = Object.keys(P_).reduce((t, e) => (tGt.forEach((r) => t[eGt(r, e)] = t[e]), t), P_);
var rGt = /^(matrix|translate|scale|rotate|skew)/, nGt = /^(translate)/, aGt = /^(rotate|skew)/, iZ = (t, e) => Or.num(t) && t !== 0 ? t + e : t, a$ = (t, e) => Or.arr(t) ? t.every((r) => a$(r, e)) : Or.num(t) ? t === e : parseFloat(t) === e, iGt = class extends Wz {
  constructor({ x: t, y: e, z: r, ...n }) {
    let a = [], i = [];
    (t || e || r) && (a.push([t || 0, e || 0, r || 0]), i.push((o) => [`translate3d(${o.map((s) => iZ(s, "px")).join(",")})`, a$(o, 0)])), jh(n, (o, s) => {
      if (s === "transform") a.push([o || ""]), i.push((l) => [l, l === ""]);
      else if (rGt.test(s)) {
        if (delete n[s], Or.und(o)) return;
        let l = nGt.test(s) ? "px" : aGt.test(s) ? "deg" : "";
        a.push(Cu(o)), i.push(s === "rotate3d" ? ([c, u, f, h]) => [`rotate3d(${c},${u},${f},${iZ(h, l)})`, a$(h, 0)] : (c) => [`${s}(${c.map((u) => iZ(u, l)).join(",")})`, a$(c, s.startsWith("scale") ? 1 : 0)]);
      }
    }), a.length && (n.transform = new oGt(a, i)), super(n);
  }
}, oGt = class extends WZe {
  constructor(t, e) {
    super(), this.inputs = t, this.transforms = e, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let t = "", e = !0;
    return na(this.inputs, (r, n) => {
      let a = fd(r[0]), [i, o] = this.transforms[n](Or.arr(a) ? a : r.map(fd));
      t += " " + i, e = e && o;
    }), e ? "none" : t;
  }
  observerAdded(t) {
    t == 1 && na(this.inputs, (e) => na(e, (r) => V0(r) && k8(r, this)));
  }
  observerRemoved(t) {
    t == 0 && na(this.inputs, (e) => na(e, (r) => V0(r) && IT(r, this)));
  }
  eventObserved(t) {
    t.type == "change" && (this._value = null), ET(this, t);
  }
}, sGt = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"];
Td.assign({ batchedUpdates: _5t, createStringInterpolator: VZe, colors: QFt });
var lGt = Mzt(sGt, { applyAnimatedValues: Qzt, createAnimatedStyle: (t) => new iGt(t), getComponentProps: ({ scrollTop: t, scrollLeft: e, ...r }) => r }), Zh = lGt.animated, cGt = "(prefers-reduced-motion: reduce)", gJe = typeof window > "u" || !window.location || !window.location.href || !window.matchMedia, E9e = () => gJe ? { matches: !0, addListener: () => {
}, removeListener: () => {
} } : window.matchMedia(cGt);
function iM() {
  let [t, e] = P.useState(E9e().matches);
  return P.useEffect(() => {
    let r = E9e(), n = () => {
      e(r.matches);
    };
    return r.addListener(n), () => {
      r.removeListener(n);
    };
  }, []), t;
}
const uGt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Globals: Td,
  animated: Zh,
  interpolate: Yzt,
  isRenderingOnServer: gJe,
  useChain: Nzt,
  useReducedMotion: iM,
  useSpring: aM,
  useSprings: whe,
  useTrail: qzt,
  useTransition: A8
}, Symbol.toStringTag, { value: "Module" })), dGt = "rgb(18, 28, 45)", fGt = "rgba(18, 28, 45, 0.9)", hGt = "rgb(96, 107, 133)", pGt = "rgb(214, 31, 31)", mGt = "rgb(136, 145, 170)", gGt = "rgb(109, 46, 209)", vGt = "rgb(136, 145, 170)", yGt = "rgb(88, 23, 189)", bGt = "rgb(244, 124, 34)", xGt = "rgb(57, 71, 98)", CGt = "rgb(244, 244, 246)", wGt = "rgb(18, 28, 45)", SGt = "rgb(235, 86, 86)", _Gt = "rgb(136, 145, 170)", kGt = "rgb(255, 179, 122)", AGt = "rgb(200, 175, 240)", TGt = "rgb(255, 255, 255)", EGt = "rgb(200, 175, 240)", IGt = "rgb(0, 140, 255)", MGt = "rgb(153, 205, 255)", PGt = "rgb(204, 228, 255)", RGt = "rgb(231, 220, 250)", OGt = "rgb(0, 140, 255)", BGt = "rgb(255, 233, 128)", NGt = "rgb(162, 246, 195)", $Gt = "rgb(255, 255, 255)", DGt = "rgb(255, 179, 122)", LGt = "rgb(136, 145, 170)", jGt = "rgb(57, 71, 98)", FGt = "rgb(13, 19, 28)", zGt = "'TwilioSansMono', Courier, monospace", GGt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", WGt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", HGt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", UGt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", VGt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", qGt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", KGt = "0 4px 16px 0 rgba(0, 0, 0, 0.5)", ZGt = "0 0 0 1px #606b85", JGt = "0 0 0 1px #d61f1f", YGt = "0 0 0 1px #8891aa", XGt = "0 0 0 1px #5817bd", QGt = "0 0 0 1px #394762", eWt = "0 0 0 1px #1f304c", tWt = "0 2px 4px 0 rgba(0, 0, 0, 0.4)", rWt = "0 0 0 1px #1f304c", nWt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.4)", aWt = "0 6px 8px 0 rgba(0, 0, 0, 0.3), 16px 16px 32px 0 rgba(0, 0, 0, 0.2)", iWt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", oWt = "0 0 0 1px #19273E, -4px 0 8px 0 rgba(0, 0, 0, 0.3), -16px 0 32px 0 rgba(0, 0, 0, 0.2)", sWt = "0 0 0 1px #19273E, 0 6px 8px 0 rgba(0, 0, 0, 0.3), 16px 16px 32px 0 rgba(0, 0, 0, 0.2)", lWt = "0 0 0 4px #606b85", cWt = "inset 0 0 0 2px #606b85", uWt = "0 0 0 4px #8891aa", dWt = "inset 0 0 0 2px rgba(255, 255, 255, 0.4)", fWt = "0 0 0 4px #606b85, 0 0 0 1px #606b85", hWt = "0 16px 24px 4px rgba(0, 0, 0, 0.5)", pWt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", mWt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", gWt = "0 2px 4px 0 rgba(0, 0, 0, 0.4)", vWt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", yWt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", bWt = "5.5rem", xWt = "70.5rem", CWt = "12rem", wWt = "18.5rem", SWt = "25rem", _Wt = "31.5rem", kWt = "38rem", AWt = "44.5rem", TWt = "51rem", EWt = "57.5rem", IWt = "0.125rem", MWt = "2.25rem", PWt = "2.75rem", RWt = "3.25rem", OWt = "3.75rem", BWt = "4.25rem", NWt = "0.25rem", $Wt = "4.75rem", DWt = "5.25rem", LWt = "5.75rem", jWt = "6.25rem", FWt = "6.75rem", zWt = "0.5rem", GWt = "7.25rem", WWt = "0.75rem", HWt = "1.25rem", UWt = "1.5rem", VWt = "1.75rem", qWt = { colorBackground: dGt, colorBackgroundAvailable: "rgb(20, 176, 83)", colorBackgroundBody: "rgb(13, 19, 28)", colorBackgroundBodyElevation: "rgb(25, 39, 62)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(18, 28, 45)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(242, 47, 70)", colorBackgroundBrandHighlightWeakest: "rgba(242, 47, 70, 0.1)", colorBackgroundBrandStrong: "rgb(31, 48, 76)", colorBackgroundBrandStronger: "rgb(18, 28, 45)", colorBackgroundBusy: "rgb(244, 124, 34)", colorBackgroundDecorative10Weakest: "rgb(18, 28, 45)", colorBackgroundDecorative20Weakest: "rgb(3, 11, 93)", colorBackgroundDecorative30Weakest: "rgb(5, 41, 18)", colorBackgroundDecorative40Weakest: "rgb(56, 14, 120)", colorBackgroundDestructive: "rgb(214, 31, 31)", colorBackgroundDestructiveStrong: "rgb(246, 177, 177)", colorBackgroundDestructiveStronger: "rgb(252, 207, 207)", colorBackgroundDestructiveStrongest: "rgb(254, 236, 236)", colorBackgroundDestructiveWeak: "rgb(57, 71, 98)", colorBackgroundDestructiveWeaker: "rgb(31, 48, 76)", colorBackgroundDestructiveWeakest: "rgb(18, 28, 45)", colorBackgroundElevation: "rgb(25, 39, 62)", colorBackgroundError: "rgb(214, 31, 31)", colorBackgroundErrorStrong: "rgb(245, 138, 138)", colorBackgroundErrorStronger: "rgb(252, 207, 207)", colorBackgroundErrorStrongest: "rgb(254, 236, 236)", colorBackgroundErrorWeakest: "rgb(49, 12, 12)", colorBackgroundInverse: "rgb(31, 48, 76)", colorBackgroundInverseElevation: "rgb(37, 57, 91)", colorBackgroundInverseStrong: "rgb(57, 71, 98)", colorBackgroundInverseStrongElevation: "rgb(37, 57, 91)", colorBackgroundInverseStronger: "rgb(57, 71, 98)", colorBackgroundInverseStrongerElevation: "rgb(64, 79, 110)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(37, 57, 91)", colorBackgroundNeutralWeakest: "rgb(3, 11, 93)", colorBackgroundNew: "rgb(56, 14, 120)", colorBackgroundNewWeakest: "rgb(18, 28, 45)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(174, 178, 193)", colorBackgroundOverlay: fGt, colorBackgroundPrimary: "rgb(2, 99, 224)", colorBackgroundPrimaryStrong: "rgb(153, 205, 255)", colorBackgroundPrimaryStronger: "rgb(204, 228, 255)", colorBackgroundPrimaryStrongest: "rgb(235, 244, 255)", colorBackgroundPrimaryWeak: "rgb(57, 71, 98)", colorBackgroundPrimaryWeaker: "rgb(31, 48, 76)", colorBackgroundPrimaryWeakest: "rgb(18, 28, 45)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(18, 28, 45)", colorBackgroundStrong: "rgb(31, 48, 76)", colorBackgroundStrongElevation: "rgb(31, 48, 76)", colorBackgroundStronger: "rgb(96, 107, 133)", colorBackgroundStrongest: "rgb(225, 227, 234)", colorBackgroundSubaccount: "rgb(18, 28, 45)", colorBackgroundSuccess: "rgb(20, 176, 83)", colorBackgroundSuccessWeakest: "rgb(5, 41, 18)", colorBackgroundTrial: "rgb(5, 41, 18)", colorBackgroundUnavailable: "rgb(214, 31, 31)", colorBackgroundUser: "rgb(34, 9, 74)", colorBackgroundWarning: "rgb(244, 124, 34)", colorBackgroundWarningWeakest: "rgb(64, 19, 15)", colorBackgroundWeak: "rgb(18, 28, 45)", colorBackgroundWeakElevation: "rgb(18, 28, 45)", colorBackgroundWeaker: "rgb(18, 28, 45)", colorBackgroundWeakest: "rgb(13, 19, 28)" }, KWt = { colorBorder: hGt, colorBorderDecorative10Weaker: "rgb(31, 48, 76)", colorBorderDecorative20Weaker: "rgb(0, 20, 137)", colorBorderDecorative30Weaker: "rgb(13, 58, 31)", colorBorderDecorative40Weaker: "rgb(88, 23, 189)", colorBorderDestructive: "rgb(214, 31, 31)", colorBorderDestructiveStrong: "rgb(246, 177, 177)", colorBorderDestructiveStronger: "rgb(252, 207, 207)", colorBorderDestructiveStrongest: "rgb(254, 236, 236)", colorBorderDestructiveWeak: "rgb(57, 71, 98)", colorBorderDestructiveWeaker: "rgb(31, 48, 76)", colorBorderDestructiveWeakest: "rgb(18, 28, 45)", colorBorderError: pGt, colorBorderErrorStrong: "rgb(246, 177, 177)", colorBorderErrorStronger: "rgb(252, 207, 207)", colorBorderErrorStrongest: "rgb(254, 236, 236)", colorBorderErrorWeak: "rgb(173, 17, 17)", colorBorderErrorWeaker: "rgb(117, 12, 12)", colorBorderErrorWeakest: "rgb(49, 12, 12)", colorBorderInverse: mGt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(31, 48, 76)", colorBorderNeutral: "rgb(2, 99, 224)", colorBorderNeutralWeak: "rgb(4, 60, 181)", colorBorderNeutralWeaker: "rgb(0, 20, 137)", colorBorderNewWeak: gGt, colorBorderNewWeaker: "rgb(88, 23, 189)", colorBorderPrimary: "rgb(2, 99, 224)", colorBorderPrimaryStrong: "rgb(153, 205, 255)", colorBorderPrimaryStronger: "rgb(204, 228, 255)", colorBorderPrimaryStrongest: "rgb(235, 244, 255)", colorBorderPrimaryWeak: "rgb(57, 71, 98)", colorBorderPrimaryWeaker: "rgb(31, 48, 76)", colorBorderPrimaryWeakest: "rgb(18, 28, 45)", colorBorderStrong: vGt, colorBorderSuccess: "rgb(20, 176, 83)", colorBorderSuccessWeak: "rgb(14, 124, 58)", colorBorderSuccessWeaker: "rgb(13, 58, 31)", colorBorderSuccessWeakest: "rgb(5, 41, 18)", colorBorderUser: yGt, colorBorderWarning: bGt, colorBorderWarningWeak: "rgb(195, 83, 35)", colorBorderWarningWeaker: "rgb(84, 25, 20)", colorBorderWarningWeakest: "rgb(64, 19, 15)", colorBorderWeak: xGt, colorBorderWeaker: "rgb(31, 48, 76)", colorBorderWeakest: "rgb(13, 19, 28)" }, ZWt = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, JWt = { shadow: KGt, shadowBorder: ZGt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #1f304c", shadowBorderBottomDecorative20Weaker: "0 1px 0 #001489", shadowBorderBottomDecorative30Weaker: "0 1px 0 #0d3a1f", shadowBorderBottomDecorative40Weaker: "0 1px 0 #5817bd", shadowBorderBottomErrorWeaker: "0 1px 0 #750c0c", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #001489", shadowBorderBottomNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #c28e00", shadowBorderBottomSuccessWeaker: "0 1px 0 #0d3a1f", shadowBorderBottomWarningWeaker: "0 1px 0 #541914", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #394762", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #1f304c", shadowBorderDecorative20Weaker: "0 0 0 1px #043cb5", shadowBorderDecorative30Weaker: "0 0 0 1px #0e7c3a", shadowBorderDecorative40Weaker: "0 0 0 1px #5817bd", shadowBorderDestructive: "0 0 0 1px #d61f1f", shadowBorderDestructiveStrong: "0 0 0 1px #f6b1b1", shadowBorderDestructiveStronger: "0 0 0 1px #fccfcf", shadowBorderDestructiveStrongest: "0 0 0 1px #feecec", shadowBorderDestructiveWeak: "0 0 0 1px #394762", shadowBorderDestructiveWeaker: "0 0 0 1px #1f304c", shadowBorderError: JGt, shadowBorderErrorStrong: "0 0 0 1px #f6b1b1", shadowBorderErrorStronger: "0 0 0 1px #fccfcf", shadowBorderErrorStrongest: "0 0 0 1px #feecec", shadowBorderErrorWeak: "0 0 0 1px #ad1111", shadowBorderErrorWeaker: "0 0 0 1px #ad1111", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #1f304c", shadowBorderNeutralWeaker: "0 0 0 1px #043cb5", shadowBorderNewWeaker: "0 0 0 1px #5817bd", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #0263e0", shadowBorderPrimaryStrong: "0 0 0 1px #99cdff", shadowBorderPrimaryStronger: "0 0 0 1px #cce4ff", shadowBorderPrimaryStrongest: "0 0 0 1px #ebf4ff", shadowBorderPrimaryWeak: "0 0 0 1px #394762", shadowBorderPrimaryWeaker: "0 0 0 1px #1f304c", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: YGt, shadowBorderSubaccount: "0 0 0 1px #c28e00", shadowBorderSuccessWeaker: "0 0 0 1px #0e7c3a", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #006dfa", shadowBorderTopPrimaryStrongest: "0 -1px 0 #ebf4ff", shadowBorderUser: XGt, shadowBorderWarningWeaker: "0 0 0 1px #c35323", shadowBorderWeak: QGt, shadowBorderWeaker: eWt, shadowCard: tWt, shadowElevation05: rWt, shadowElevation10: nWt, shadowElevation20: aWt, shadowElevationBottom05: "0 1px 0 0 #1f304c", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: iWt, shadowElevationLeft20: oWt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #1f304c", shadowElevationTop20: sWt, shadowFocus: lWt, shadowFocusInset: cWt, shadowFocusInverse: uWt, shadowFocusInverseInset: dWt, shadowFocusShadowBorder: fWt, shadowHigh: hWt, shadowLeft: pWt, shadowLeftInverse: mWt, shadowLow: gWt, shadowRight: vWt, shadowRightInverse: yWt }, YWt = { colorScheme: "dark" }, XWt = { colorDataVisualization1: "rgb(2, 99, 224)", colorDataVisualization2: "rgb(200, 175, 240)", colorDataVisualization3: "rgb(96, 107, 133)", colorDataVisualization4: "rgb(102, 179, 255)", colorDataVisualization5: "rgb(14, 124, 58)", colorDataVisualization6: "rgb(250, 153, 80)", colorDataVisualization7: "rgb(195, 83, 35)", colorDataVisualization8: "rgb(246, 177, 177)", colorDataVisualization9: "rgb(140, 91, 216)", colorDataVisualization10: "rgb(232, 180, 7)" }, QWt = { fontFamilyCode: zGt, fontFamilyDisplay: GGt, fontFamilyText: WGt, fontFamilyTextChineseSimplified: HGt, fontFamilyTextChineseTraditional: UGt, fontFamilyTextJapanese: VGt, fontFamilyTextKorean: qGt }, eHt = { fontSize10: "0.625rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "1rem", fontSize50: "1.125rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "1.75rem", fontSize90: "2rem", fontSize100: "2.5rem", fontSize110: "3rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, tHt = { fontWeightLight: "400", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "700", fontWeightExtrabold: "800" }, rHt = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, nHt = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, aHt = { size0: "0", size10: bWt, size20: CWt, size30: wWt, size40: SWt, size50: _Wt, size60: kWt, size70: AWt, size80: TWt, size90: EWt, size100: "64rem", size110: xWt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, iHt = { space0: "0", space10: IWt, space20: NWt, space30: zWt, space40: WWt, space50: "1rem", space60: HWt, space70: UWt, space80: VWt, space90: "2rem", space100: MWt, space110: "2.5rem", space120: PWt, space130: "3rem", space140: RWt, space150: "3.5rem", space160: OWt, space170: "4rem", space180: BWt, space190: "4.5rem", space200: $Wt, space210: "5rem", space220: DWt, space230: "5.5rem", space240: LWt, space250: "6rem", space260: jWt, space270: "6.5rem", space280: FWt, space290: "7rem", space300: GWt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, oHt = { colorText: CGt, colorTextBrand: wGt, colorTextBrandHighlight: "rgb(242, 47, 70)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(225, 227, 234)", colorTextDecorative20: "rgb(204, 228, 255)", colorTextDecorative30: "rgb(162, 246, 195)", colorTextDecorative40: "rgb(231, 220, 250)", colorTextDestructive: "rgb(235, 86, 86)", colorTextDestructiveStrong: "rgb(246, 177, 177)", colorTextDestructiveStronger: "rgb(254, 236, 236)", colorTextDestructiveStrongest: "rgb(255, 255, 255)", colorTextDestructiveWeak: "rgb(57, 71, 98)", colorTextError: SGt, colorTextErrorStrong: "rgb(246, 177, 177)", colorTextErrorStronger: "rgb(254, 236, 236)", colorTextErrorStrongest: "rgb(254, 236, 236)", colorTextErrorWeak: "rgb(235, 86, 86)", colorTextIcon: _Gt, colorTextIconAvailable: "rgb(54, 213, 118)", colorTextIconBrandHighlight: "rgb(242, 47, 70)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: kGt, colorTextIconError: "rgb(235, 86, 86)", colorTextIconInverse: "rgb(225, 227, 234)", colorTextIconNeutral: "rgb(102, 179, 255)", colorTextIconNew: AGt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(244, 244, 246)", colorTextIconSuccess: "rgb(54, 213, 118)", colorTextIconUnavailable: "rgb(235, 86, 86)", colorTextIconWarning: "rgb(255, 179, 122)", colorTextInverse: TGt, colorTextInverseNew: EGt, colorTextInverseWeak: "rgb(202, 205, 216)", colorTextInverseWeaker: "rgb(136, 145, 170)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: IGt, colorTextLinkDestructive: "rgb(235, 86, 86)", colorTextLinkDestructiveStrong: "rgb(246, 177, 177)", colorTextLinkDestructiveStronger: "rgb(254, 236, 236)", colorTextLinkDestructiveStrongest: "rgb(255, 255, 255)", colorTextLinkDestructiveWeak: "rgb(57, 71, 98)", colorTextLinkStrong: MGt, colorTextLinkStronger: "rgb(235, 244, 255)", colorTextLinkStrongest: "rgb(255, 255, 255)", colorTextLinkWeak: "rgb(57, 71, 98)", colorTextNeutral: PGt, colorTextNew: RGt, colorTextPrimary: OGt, colorTextPrimaryStrong: "rgb(153, 205, 255)", colorTextPrimaryStronger: "rgb(153, 205, 255)", colorTextPrimaryStrongest: "rgb(255, 255, 255)", colorTextPrimaryWeak: "rgb(57, 71, 98)", colorTextSubaccount: BGt, colorTextSuccess: NGt, colorTextUser: $Gt, colorTextWarning: DGt, colorTextWarningStrong: "rgb(250, 194, 160)", colorTextWeak: LGt, colorTextWeaker: jGt, colorTextWeakest: FGt }, sHt = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, lHt = "rgb(244, 244, 246)", cHt = "rgb(255, 255, 255)", uHt = "rgb(245, 240, 252)", dHt = "rgba(96, 107, 133, 0.5)", fHt = "rgb(250, 247, 253)", hHt = "rgb(249, 249, 250)", pHt = "rgb(136, 145, 170)", mHt = "rgb(199, 35, 35)", gHt = "rgb(136, 145, 170)", vHt = "rgb(166, 127, 227)", yHt = "rgb(96, 107, 133)", bHt = "rgb(231, 220, 250)", xHt = "rgb(244, 124, 34)", CHt = "rgb(202, 205, 216)", wHt = "rgb(225, 227, 234)", SHt = "rgb(255, 255, 255)", _Ht = "rgb(18, 28, 45)", kHt = "rgb(18, 28, 45)", AHt = "rgb(199, 35, 35)", THt = "rgb(96, 107, 133)", EHt = "rgb(227, 106, 25)", IHt = "rgb(109, 46, 209)", MHt = "rgb(255, 255, 255)", PHt = "rgb(200, 175, 240)", RHt = "rgb(2, 99, 224)", OHt = "rgb(153, 205, 255)", BHt = "rgb(109, 46, 209)", NHt = "rgb(2, 99, 224)", $Ht = "rgb(11, 96, 45)", DHt = "rgb(109, 46, 209)", LHt = "rgb(141, 49, 24)", jHt = "rgb(96, 107, 133)", FHt = "rgb(142, 150, 174)", zHt = "rgb(255, 255, 255)", GHt = "'TwilioSansMono', Courier, monospace", WHt = "'TwilioSansDisplay', 'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", HHt = "'TwilioSansText', 'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", UHt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", VHt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", qHt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", KHt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", ZHt = "0 4px 16px 0 rgba(18, 28, 45, 0.2)", JHt = "0 0 0 1px #8891aa", YHt = "0 0 0 1px #c72323", XHt = "0 0 0 1px #606b85", QHt = "0 0 0 1px #e7dcfa", eUt = "0 0 0 1px #cacdd8", tUt = "0 0 0 1px #e1e3ea", rUt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", nUt = "0 0 0 1px #edeef2", aUt = "0 -1px 0 0 #f4f4f6, 0 3px 4px 0 rgba(15, 22, 33, 0.1)", iUt = "0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", oUt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", sUt = "0 0 0 1px #f9f9fa, -4px 0 8px 0 rgba(15, 22, 33, 0.1), -16px 0 32px 0 rgba(15, 22, 33, 0.05)", lUt = "0 0 0 1px #f9f9fa, 0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", cUt = "0 0 0 2px #ffffff, 0 0 0 3px #006dfa, 0 0 0 5px #cce4ff", uUt = "inset 0 0 0 1px #006dfa, inset 0 0 0 3px #cce4ff", dUt = "0 0 0 1px #394762, 0 0 0 3px #121c2d, 0 0 0 4px #ffffff, 0 0 0 6px rgba(255, 255, 255, 0.2)", fUt = "0 0 0 1px #ffffff, inset 0 0 0 3px rgba(255, 255, 255, 0.2)", hUt = "0 0 0 1px #cacdd8, 0 0 0 3px #ffffff, 0 0 0 4px #006dfa, 0 0 0 6px #cce4ff", pUt = "0 16px 24px 0 rgba(18, 28, 45, 0.2)", mUt = "4px 0 8px -4px rgba(18, 28, 45, 0.2)", gUt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", vUt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", yUt = "-4px 0 8px -4px rgba(18, 28, 45, 0.2)", bUt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", xUt = "5.5rem", CUt = "70.5rem", wUt = "12rem", SUt = "18.5rem", _Ut = "25rem", kUt = "31.5rem", AUt = "38rem", TUt = "44.5rem", EUt = "51rem", IUt = "57.5rem", MUt = "0.125rem", PUt = "2.25rem", RUt = "2.75rem", OUt = "3.25rem", BUt = "3.75rem", NUt = "4.25rem", $Ut = "0.25rem", DUt = "4.75rem", LUt = "5.25rem", jUt = "5.75rem", FUt = "6.25rem", zUt = "6.75rem", GUt = "0.5rem", WUt = "7.25rem", HUt = "0.75rem", UUt = "1.25rem", VUt = "1.5rem", qUt = "1.75rem", KUt = { colorBackground: lHt, colorBackgroundAvailable: "rgb(20, 176, 83)", colorBackgroundBody: cHt, colorBackgroundBodyElevation: "rgb(249, 249, 250)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(18, 28, 45)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(242, 47, 70)", colorBackgroundBrandHighlightWeakest: "rgba(242, 47, 70, 0.1)", colorBackgroundBrandStrong: "rgb(18, 28, 45)", colorBackgroundBrandStronger: "rgb(18, 28, 45)", colorBackgroundBusy: "rgb(244, 124, 34)", colorBackgroundDecorative10Weakest: "rgb(244, 244, 246)", colorBackgroundDecorative20Weakest: "rgb(244, 249, 255)", colorBackgroundDecorative30Weakest: "rgb(237, 253, 243)", colorBackgroundDecorative40Weakest: "rgb(250, 247, 253)", colorBackgroundDestructive: "rgb(199, 35, 35)", colorBackgroundDestructiveStrong: "rgb(117, 12, 12)", colorBackgroundDestructiveStronger: "rgb(74, 11, 11)", colorBackgroundDestructiveStrongest: "rgb(49, 12, 12)", colorBackgroundDestructiveWeak: "rgb(246, 177, 177)", colorBackgroundDestructiveWeaker: "rgb(252, 207, 207)", colorBackgroundDestructiveWeakest: "rgb(254, 245, 245)", colorBackgroundElevation: "rgb(237, 238, 242)", colorBackgroundError: "rgb(199, 35, 35)", colorBackgroundErrorStrong: "rgb(117, 12, 12)", colorBackgroundErrorStronger: "rgb(74, 11, 11)", colorBackgroundErrorStrongest: "rgb(49, 12, 12)", colorBackgroundErrorWeakest: "rgb(254, 245, 245)", colorBackgroundInverse: "rgb(18, 28, 45)", colorBackgroundInverseElevation: "rgb(25, 39, 62)", colorBackgroundInverseStrong: "rgb(31, 48, 76)", colorBackgroundInverseStrongElevation: "rgb(37, 57, 91)", colorBackgroundInverseStronger: "rgb(57, 71, 98)", colorBackgroundInverseStrongerElevation: "rgb(64, 79, 110)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(18, 28, 45)", colorBackgroundNeutralWeakest: "rgb(244, 249, 255)", colorBackgroundNew: uHt, colorBackgroundNewWeakest: "rgb(250, 247, 253)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(142, 150, 174)", colorBackgroundOverlay: dHt, colorBackgroundPrimary: "rgb(0, 109, 250)", colorBackgroundPrimaryStrong: "rgb(0, 20, 137)", colorBackgroundPrimaryStronger: "rgb(3, 11, 93)", colorBackgroundPrimaryStrongest: "rgb(6, 3, 58)", colorBackgroundPrimaryWeak: "rgb(153, 205, 255)", colorBackgroundPrimaryWeaker: "rgb(204, 228, 255)", colorBackgroundPrimaryWeakest: "rgb(244, 249, 255)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(249, 249, 250)", colorBackgroundStrong: "rgb(225, 227, 234)", colorBackgroundStrongElevation: "rgb(225, 227, 234)", colorBackgroundStronger: "rgb(136, 145, 170)", colorBackgroundStrongest: "rgb(75, 86, 113)", colorBackgroundSubaccount: "rgb(255, 251, 234)", colorBackgroundSuccess: "rgb(20, 176, 83)", colorBackgroundSuccessWeakest: "rgb(237, 253, 243)", colorBackgroundTrial: "rgb(209, 250, 224)", colorBackgroundUnavailable: "rgb(214, 31, 31)", colorBackgroundUser: fHt, colorBackgroundWarning: "rgb(244, 124, 34)", colorBackgroundWarningWeakest: "rgb(253, 247, 244)", colorBackgroundWeak: hHt, colorBackgroundWeakElevation: "rgb(249, 249, 250)", colorBackgroundWeaker: "rgb(255, 255, 255)", colorBackgroundWeakest: "rgb(255, 255, 255)" }, ZUt = { colorBorder: pHt, colorBorderDecorative10Weaker: "rgb(225, 227, 234)", colorBorderDecorative20Weaker: "rgb(204, 228, 255)", colorBorderDecorative30Weaker: "rgb(209, 250, 224)", colorBorderDecorative40Weaker: "rgb(231, 220, 250)", colorBorderDestructive: "rgb(199, 35, 35)", colorBorderDestructiveStrong: "rgb(117, 12, 12)", colorBorderDestructiveStronger: "rgb(74, 11, 11)", colorBorderDestructiveStrongest: "rgb(49, 12, 12)", colorBorderDestructiveWeak: "rgb(246, 177, 177)", colorBorderDestructiveWeaker: "rgb(252, 207, 207)", colorBorderDestructiveWeakest: "rgb(254, 236, 236)", colorBorderError: mHt, colorBorderErrorStrong: "rgb(117, 12, 12)", colorBorderErrorStronger: "rgb(74, 11, 11)", colorBorderErrorStrongest: "rgb(49, 12, 12)", colorBorderErrorWeak: "rgb(245, 138, 138)", colorBorderErrorWeaker: "rgb(252, 207, 207)", colorBorderErrorWeakest: "rgb(254, 236, 236)", colorBorderInverse: gHt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(18, 28, 45)", colorBorderNeutral: "rgb(2, 99, 224)", colorBorderNeutralWeak: "rgb(102, 179, 255)", colorBorderNeutralWeaker: "rgb(204, 228, 255)", colorBorderNewWeak: vHt, colorBorderNewWeaker: "rgb(231, 220, 250)", colorBorderPrimary: "rgb(0, 109, 250)", colorBorderPrimaryStrong: "rgb(0, 20, 137)", colorBorderPrimaryStronger: "rgb(3, 11, 93)", colorBorderPrimaryStrongest: "rgb(6, 3, 58)", colorBorderPrimaryWeak: "rgb(153, 205, 255)", colorBorderPrimaryWeaker: "rgb(204, 228, 255)", colorBorderPrimaryWeakest: "rgb(235, 244, 255)", colorBorderStrong: yHt, colorBorderSuccess: "rgb(20, 176, 83)", colorBorderSuccessWeak: "rgb(123, 234, 165)", colorBorderSuccessWeaker: "rgb(209, 250, 224)", colorBorderSuccessWeakest: "rgb(237, 253, 243)", colorBorderUser: bHt, colorBorderWarning: xHt, colorBorderWarningWeak: "rgb(255, 179, 122)", colorBorderWarningWeaker: "rgb(253, 220, 196)", colorBorderWarningWeakest: "rgb(254, 245, 238)", colorBorderWeak: CHt, colorBorderWeaker: wHt, colorBorderWeakest: SHt }, JUt = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, YUt = { shadow: ZHt, shadowBorder: JHt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #8e96ae", shadowBorderBottomDecorative20Weaker: "0 1px 0 #66b3ff", shadowBorderBottomDecorative30Weaker: "0 1px 0 #7beaa5", shadowBorderBottomDecorative40Weaker: "0 1px 0 #c8aff0", shadowBorderBottomErrorWeaker: "0 1px 0 #f58a8a", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #66b3ff", shadowBorderBottomNewWeaker: "0 1px 0 #c8aff0", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #ffdd35", shadowBorderBottomSuccessWeaker: "0 1px 0 #7beaa5", shadowBorderBottomWarningWeaker: "0 1px 0 #ffb37a", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #cacdd8", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #e1e3ea", shadowBorderDecorative20Weaker: "0 0 0 1px #cce4ff", shadowBorderDecorative30Weaker: "0 0 0 1px #d1fae0", shadowBorderDecorative40Weaker: "0 0 0 1px #e7dcfa", shadowBorderDestructive: "0 0 0 1px #c72323", shadowBorderDestructiveStrong: "0 0 0 1px #750c0c", shadowBorderDestructiveStronger: "0 0 0 1px #4a0b0b", shadowBorderDestructiveStrongest: "0 0 0 1px #310c0c", shadowBorderDestructiveWeak: "0 0 0 1px #f6b1b1", shadowBorderDestructiveWeaker: "0 0 0 1px #fccfcf", shadowBorderError: YHt, shadowBorderErrorStrong: "0 0 0 1px #750c0c", shadowBorderErrorStronger: "0 0 0 1px #4a0b0b", shadowBorderErrorStrongest: "0 0 0 1px #310c0c", shadowBorderErrorWeak: "0 0 0 1px #eb5656", shadowBorderErrorWeaker: "0 0 0 1px #fccfcf", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #121c2d", shadowBorderNeutralWeaker: "0 0 0 1px #cce4ff", shadowBorderNewWeaker: "0 0 0 1px #e7dcfa", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #006dfa", shadowBorderPrimaryStrong: "0 0 0 1px #001489", shadowBorderPrimaryStronger: "0 0 0 1px #030b5d", shadowBorderPrimaryStrongest: "0 0 0 1px #06033a", shadowBorderPrimaryWeak: "0 0 0 1px #99cdff", shadowBorderPrimaryWeaker: "0 0 0 1px #cce4ff", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: XHt, shadowBorderSubaccount: "0 0 0 1px #fff1b3", shadowBorderSuccessWeaker: "0 0 0 1px #d1fae0", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #006dfa", shadowBorderTopPrimaryStrongest: "0 -1px 0 #030b5d", shadowBorderUser: QHt, shadowBorderWarningWeaker: "0 0 0 1px #fddcc4", shadowBorderWeak: eUt, shadowBorderWeaker: tUt, shadowCard: rUt, shadowElevation05: nUt, shadowElevation10: aUt, shadowElevation20: iUt, shadowElevationBottom05: "0 1px 0 0 #edeef2", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: oUt, shadowElevationLeft20: sUt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #edeef2", shadowElevationTop20: lUt, shadowFocus: cUt, shadowFocusInset: uUt, shadowFocusInverse: dUt, shadowFocusInverseInset: fUt, shadowFocusShadowBorder: hUt, shadowHigh: pUt, shadowLeft: mUt, shadowLeftInverse: gUt, shadowLow: vUt, shadowRight: yUt, shadowRightInverse: bUt }, XUt = { colorScheme: "light" }, QUt = { colorDataVisualization1: "rgb(0, 20, 137)", colorDataVisualization2: "rgb(14, 124, 58)", colorDataVisualization3: "rgb(13, 58, 31)", colorDataVisualization4: "rgb(0, 140, 255)", colorDataVisualization5: "rgb(57, 71, 98)", colorDataVisualization6: "rgb(166, 127, 227)", colorDataVisualization7: "rgb(109, 46, 209)", colorDataVisualization8: "rgb(136, 145, 170)", colorDataVisualization9: "rgb(117, 12, 12)", colorDataVisualization10: "rgb(235, 86, 86)" }, eVt = { fontFamilyCode: GHt, fontFamilyDisplay: WHt, fontFamilyText: HHt, fontFamilyTextChineseSimplified: UHt, fontFamilyTextChineseTraditional: VHt, fontFamilyTextJapanese: qHt, fontFamilyTextKorean: KHt }, tVt = { fontSize10: "0.625rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "1rem", fontSize50: "1.125rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "1.75rem", fontSize90: "2rem", fontSize100: "2.5rem", fontSize110: "3rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, rVt = { fontWeightLight: "400", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "600", fontWeightExtrabold: "800" }, nVt = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, aVt = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, vJe = { size0: "0", size10: xUt, size20: wUt, size30: SUt, size40: _Ut, size50: kUt, size60: AUt, size70: TUt, size80: EUt, size90: IUt, size100: "64rem", size110: CUt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, iVt = { space0: "0", space10: MUt, space20: $Ut, space30: GUt, space40: HUt, space50: "1rem", space60: UUt, space70: VUt, space80: qUt, space90: "2rem", space100: PUt, space110: "2.5rem", space120: RUt, space130: "3rem", space140: OUt, space150: "3.5rem", space160: BUt, space170: "4rem", space180: NUt, space190: "4.5rem", space200: DUt, space210: "5rem", space220: LUt, space230: "5.5rem", space240: jUt, space250: "6rem", space260: FUt, space270: "6.5rem", space280: zUt, space290: "7rem", space300: WUt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, oVt = { colorText: _Ht, colorTextBrand: kHt, colorTextBrandHighlight: "rgb(242, 47, 70)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(96, 107, 133)", colorTextDecorative20: "rgb(0, 20, 137)", colorTextDecorative30: "rgb(11, 96, 45)", colorTextDecorative40: "rgb(109, 46, 209)", colorTextDestructive: "rgb(199, 35, 35)", colorTextDestructiveStrong: "rgb(173, 17, 17)", colorTextDestructiveStronger: "rgb(74, 11, 11)", colorTextDestructiveStrongest: "rgb(49, 12, 12)", colorTextDestructiveWeak: "rgb(246, 177, 177)", colorTextError: AHt, colorTextErrorStrong: "rgb(117, 12, 12)", colorTextErrorStronger: "rgb(74, 11, 11)", colorTextErrorStrongest: "rgb(49, 12, 12)", colorTextErrorWeak: "rgb(235, 86, 86)", colorTextIcon: THt, colorTextIconAvailable: "rgb(14, 124, 58)", colorTextIconBrandHighlight: "rgb(242, 47, 70)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: EHt, colorTextIconError: "rgb(199, 35, 35)", colorTextIconInverse: "rgb(136, 145, 170)", colorTextIconNeutral: "rgb(3, 11, 93)", colorTextIconNew: IHt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(96, 107, 133)", colorTextIconSuccess: "rgb(11, 96, 45)", colorTextIconUnavailable: "rgb(214, 31, 31)", colorTextIconWarning: "rgb(195, 83, 35)", colorTextInverse: MHt, colorTextInverseNew: PHt, colorTextInverseWeak: "rgb(202, 205, 216)", colorTextInverseWeaker: "rgb(136, 145, 170)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: RHt, colorTextLinkDestructive: "rgb(199, 35, 35)", colorTextLinkDestructiveStrong: "rgb(173, 17, 17)", colorTextLinkDestructiveStronger: "rgb(74, 11, 11)", colorTextLinkDestructiveStrongest: "rgb(49, 12, 12)", colorTextLinkDestructiveWeak: "rgb(246, 177, 177)", colorTextLinkStrong: "rgb(0, 20, 137)", colorTextLinkStronger: "rgb(3, 11, 93)", colorTextLinkStrongest: "rgb(6, 3, 58)", colorTextLinkWeak: OHt, colorTextNeutral: "rgb(3, 11, 93)", colorTextNew: BHt, colorTextPrimary: NHt, colorTextPrimaryStrong: "rgb(0, 20, 137)", colorTextPrimaryStronger: "rgb(3, 11, 93)", colorTextPrimaryStrongest: "rgb(6, 3, 58)", colorTextPrimaryWeak: "rgb(153, 205, 255)", colorTextSubaccount: "rgb(84, 51, 8)", colorTextSuccess: $Ht, colorTextUser: DHt, colorTextWarning: LHt, colorTextWarningStrong: "rgb(141, 49, 24)", colorTextWeak: jHt, colorTextWeaker: FHt, colorTextWeakest: zHt }, sVt = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, lVt = "rgb(244, 244, 246)", cVt = "rgb(255, 255, 255)", uVt = "rgb(245, 240, 252)", dVt = "rgb(200, 175, 240)", fVt = "rgb(249, 249, 250)", hVt = "rgb(136, 145, 170)", pVt = "rgb(214, 31, 31)", mVt = "rgb(136, 145, 170)", gVt = "rgb(166, 127, 227)", vVt = "rgb(96, 107, 133)", yVt = "rgb(231, 220, 250)", bVt = "rgb(244, 124, 34)", xVt = "rgb(202, 205, 216)", CVt = "rgb(225, 227, 234)", wVt = "rgb(255, 255, 255)", SVt = "rgb(0, 20, 137)", _Vt = "rgb(255, 255, 255)", kVt = "rgb(244, 244, 246)", AVt = "rgb(18, 28, 45)", TVt = "rgb(225, 227, 234)", EVt = "rgb(202, 205, 216)", IVt = "rgb(142, 150, 174)", MVt = "rgb(136, 145, 170)", PVt = "rgb(96, 107, 133)", RVt = "rgb(75, 86, 113)", OVt = "rgb(57, 71, 98)", BVt = "rgb(31, 48, 76)", NVt = "rgb(18, 28, 45)", $Vt = "rgb(18, 28, 45)", DVt = "rgb(214, 31, 31)", LVt = "rgb(96, 107, 133)", jVt = "rgb(227, 106, 25)", FVt = "rgb(109, 46, 209)", zVt = "rgb(255, 255, 255)", GVt = "rgb(200, 175, 240)", WVt = "rgb(2, 99, 224)", HVt = "rgb(153, 205, 255)", UVt = "rgb(0, 20, 137)", VVt = "rgb(109, 46, 209)", qVt = "rgb(2, 99, 224)", KVt = "rgb(14, 124, 58)", ZVt = "rgb(18, 28, 45)", JVt = "rgb(141, 49, 24)", YVt = "rgb(96, 107, 133)", XVt = "rgb(142, 150, 174)", QVt = "rgb(255, 255, 255)", eqt = "'TwilioSansMono', Courier, monospace", tqt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", rqt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", nqt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", aqt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", iqt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", oqt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", sqt = "0 4px 16px 0 rgba(18, 28, 45, 0.2)", lqt = "0 0 0 1px #8891aa", cqt = "0 0 0 1px #d61f1f", uqt = "0 0 0 1px #606b85", dqt = "0 0 0 1px #8c5bd8", fqt = "0 0 0 1px #cacdd8", hqt = "0 0 0 1px #e1e3ea", pqt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", mqt = "0 0 0 1px #edeef2", gqt = "0 -1px 0 0 #f4f4f6, 0 3px 4px 0 rgba(15, 22, 33, 0.1)", vqt = "0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", yqt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", bqt = "0 0 0 1px #f9f9fa, -4px 0 8px 0 rgba(15, 22, 33, 0.1), -16px 0 32px 0 rgba(15, 22, 33, 0.05)", xqt = "0 0 0 1px #f9f9fa, 0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", Cqt = "0 0 0 4px rgba(2, 99, 224, 0.7)", wqt = "inset 0 0 0 2px rgba(2, 99, 224, 0.7)", Sqt = "0 0 0 4px rgba(255, 255, 255, 0.4)", _qt = "inset 0 0 0 2px rgba(255, 255, 255, 0.4)", kqt = "0 0 0 4px rgba(2, 99, 224, 0.7), 0 0 0 1px #8891aa", Aqt = "0 16px 24px 0 rgba(18, 28, 45, 0.2)", Tqt = "4px 0 8px -4px rgba(18, 28, 45, 0.2)", Eqt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", Iqt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", Mqt = "-4px 0 8px -4px rgba(18, 28, 45, 0.2)", Pqt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", Rqt = "5.5rem", Oqt = "70.5rem", Bqt = "12rem", Nqt = "18.5rem", $qt = "25rem", Dqt = "31.5rem", Lqt = "38rem", jqt = "44.5rem", Fqt = "51rem", zqt = "57.5rem", Gqt = "0.125rem", Wqt = "2.25rem", Hqt = "2.75rem", Uqt = "3.25rem", Vqt = "3.75rem", qqt = "4.25rem", Kqt = "0.25rem", Zqt = "4.75rem", Jqt = "5.25rem", Yqt = "5.75rem", Xqt = "6.25rem", Qqt = "6.75rem", eKt = "0.5rem", tKt = "7.25rem", rKt = "0.75rem", nKt = "1.25rem", aKt = "1.5rem", iKt = "1.75rem", yJe = { colorBackground: lVt, colorBackgroundAvailable: "rgb(20, 176, 83)", colorBackgroundBody: cVt, colorBackgroundBodyElevation: "rgb(249, 249, 250)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(0, 20, 137)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(242, 47, 70)", colorBackgroundBrandHighlightWeakest: "rgba(242, 47, 70, 0.1)", colorBackgroundBrandStrong: "rgb(3, 11, 93)", colorBackgroundBrandStronger: "rgb(6, 3, 58)", colorBackgroundBusy: "rgb(244, 124, 34)", colorBackgroundDecorative10Weakest: "rgb(244, 244, 246)", colorBackgroundDecorative20Weakest: "rgb(235, 244, 255)", colorBackgroundDecorative30Weakest: "rgb(237, 253, 243)", colorBackgroundDecorative40Weakest: "rgb(245, 240, 252)", colorBackgroundDestructive: "rgb(214, 31, 31)", colorBackgroundDestructiveStrong: "rgb(117, 12, 12)", colorBackgroundDestructiveStronger: "rgb(74, 11, 11)", colorBackgroundDestructiveStrongest: "rgb(49, 12, 12)", colorBackgroundDestructiveWeak: "rgb(246, 177, 177)", colorBackgroundDestructiveWeaker: "rgb(252, 207, 207)", colorBackgroundDestructiveWeakest: "rgb(254, 236, 236)", colorBackgroundElevation: "rgb(237, 238, 242)", colorBackgroundError: "rgb(214, 31, 31)", colorBackgroundErrorStrong: "rgb(117, 12, 12)", colorBackgroundErrorStronger: "rgb(74, 11, 11)", colorBackgroundErrorStrongest: "rgb(49, 12, 12)", colorBackgroundErrorWeakest: "rgb(254, 236, 236)", colorBackgroundInverse: "rgb(31, 48, 76)", colorBackgroundInverseElevation: "rgb(37, 57, 91)", colorBackgroundInverseStrong: "rgb(57, 71, 98)", colorBackgroundInverseStrongElevation: "rgb(37, 57, 91)", colorBackgroundInverseStronger: "rgb(57, 71, 98)", colorBackgroundInverseStrongerElevation: "rgb(64, 79, 110)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(37, 57, 91)", colorBackgroundNeutralWeakest: "rgb(235, 244, 255)", colorBackgroundNew: uVt, colorBackgroundNewWeakest: "rgb(250, 247, 253)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(142, 150, 174)", colorBackgroundOverlay: "rgba(6, 3, 58, 0.4)", colorBackgroundPrimary: "rgb(2, 99, 224)", colorBackgroundPrimaryStrong: "rgb(0, 20, 137)", colorBackgroundPrimaryStronger: "rgb(3, 11, 93)", colorBackgroundPrimaryStrongest: "rgb(6, 3, 58)", colorBackgroundPrimaryWeak: "rgb(153, 205, 255)", colorBackgroundPrimaryWeaker: "rgb(204, 228, 255)", colorBackgroundPrimaryWeakest: "rgb(235, 244, 255)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(244, 244, 246)", colorBackgroundStrong: "rgb(225, 227, 234)", colorBackgroundStrongElevation: "rgb(225, 227, 234)", colorBackgroundStronger: "rgb(136, 145, 170)", colorBackgroundStrongest: "rgb(75, 86, 113)", colorBackgroundSubaccount: "rgb(255, 251, 234)", colorBackgroundSuccess: "rgb(20, 176, 83)", colorBackgroundSuccessWeakest: "rgb(237, 253, 243)", colorBackgroundTrial: "rgb(209, 250, 224)", colorBackgroundUnavailable: "rgb(214, 31, 31)", colorBackgroundUser: dVt, colorBackgroundWarning: "rgb(244, 124, 34)", colorBackgroundWarningWeakest: "rgb(254, 245, 238)", colorBackgroundWeak: fVt, colorBackgroundWeakElevation: "rgb(249, 249, 250)", colorBackgroundWeaker: "rgb(255, 255, 255)", colorBackgroundWeakest: "rgb(255, 255, 255)" }, bJe = { colorBorder: hVt, colorBorderDecorative10Weaker: "rgb(225, 227, 234)", colorBorderDecorative20Weaker: "rgb(204, 228, 255)", colorBorderDecorative30Weaker: "rgb(209, 250, 224)", colorBorderDecorative40Weaker: "rgb(231, 220, 250)", colorBorderDestructive: "rgb(214, 31, 31)", colorBorderDestructiveStrong: "rgb(117, 12, 12)", colorBorderDestructiveStronger: "rgb(74, 11, 11)", colorBorderDestructiveStrongest: "rgb(49, 12, 12)", colorBorderDestructiveWeak: "rgb(246, 177, 177)", colorBorderDestructiveWeaker: "rgb(252, 207, 207)", colorBorderDestructiveWeakest: "rgb(254, 236, 236)", colorBorderError: pVt, colorBorderErrorStrong: "rgb(117, 12, 12)", colorBorderErrorStronger: "rgb(74, 11, 11)", colorBorderErrorStrongest: "rgb(49, 12, 12)", colorBorderErrorWeak: "rgb(245, 138, 138)", colorBorderErrorWeaker: "rgb(252, 207, 207)", colorBorderErrorWeakest: "rgb(254, 236, 236)", colorBorderInverse: mVt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(31, 48, 76)", colorBorderNeutral: "rgb(2, 99, 224)", colorBorderNeutralWeak: "rgb(102, 179, 255)", colorBorderNeutralWeaker: "rgb(204, 228, 255)", colorBorderNewWeak: gVt, colorBorderNewWeaker: "rgb(231, 220, 250)", colorBorderPrimary: "rgb(2, 99, 224)", colorBorderPrimaryStrong: "rgb(0, 20, 137)", colorBorderPrimaryStronger: "rgb(3, 11, 93)", colorBorderPrimaryStrongest: "rgb(6, 3, 58)", colorBorderPrimaryWeak: "rgb(153, 205, 255)", colorBorderPrimaryWeaker: "rgb(204, 228, 255)", colorBorderPrimaryWeakest: "rgb(235, 244, 255)", colorBorderStrong: vVt, colorBorderSuccess: "rgb(20, 176, 83)", colorBorderSuccessWeak: "rgb(54, 213, 118)", colorBorderSuccessWeaker: "rgb(209, 250, 224)", colorBorderSuccessWeakest: "rgb(237, 253, 243)", colorBorderUser: yVt, colorBorderWarning: bVt, colorBorderWarningWeak: "rgb(255, 179, 122)", colorBorderWarningWeaker: "rgb(253, 220, 196)", colorBorderWarningWeakest: "rgb(254, 245, 238)", colorBorderWeak: xVt, colorBorderWeaker: CVt, colorBorderWeakest: wVt }, xJe = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, CJe = { shadow: sqt, shadowBorder: lqt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #e1e3ea", shadowBorderBottomDecorative20Weaker: "0 1px 0 #cce4ff", shadowBorderBottomDecorative30Weaker: "0 1px 0 #d1fae0", shadowBorderBottomDecorative40Weaker: "0 1px 0 #e7dcfa", shadowBorderBottomErrorWeaker: "0 1px 0 #fccfcf", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #cce4ff", shadowBorderBottomNewWeaker: "0 1px 0 #e7dcfa", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #ffdd35", shadowBorderBottomSuccessWeaker: "0 1px 0 #d1fae0", shadowBorderBottomWarningWeaker: "0 1px 0 #fddcc4", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #cacdd8", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #e1e3ea", shadowBorderDecorative20Weaker: "0 0 0 1px #cce4ff", shadowBorderDecorative30Weaker: "0 0 0 1px #d1fae0", shadowBorderDecorative40Weaker: "0 0 0 1px #e7dcfa", shadowBorderDestructive: "0 0 0 1px #d61f1f", shadowBorderDestructiveStrong: "0 0 0 1px #750c0c", shadowBorderDestructiveStronger: "0 0 0 1px #4a0b0b", shadowBorderDestructiveStrongest: "0 0 0 1px #310c0c", shadowBorderDestructiveWeak: "0 0 0 1px #f6b1b1", shadowBorderDestructiveWeaker: "0 0 0 1px #fccfcf", shadowBorderError: cqt, shadowBorderErrorStrong: "0 0 0 1px #750c0c", shadowBorderErrorStronger: "0 0 0 1px #4a0b0b", shadowBorderErrorStrongest: "0 0 0 1px #310c0c", shadowBorderErrorWeak: "0 0 0 1px #eb5656", shadowBorderErrorWeaker: "0 0 0 1px #fccfcf", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #1f304c", shadowBorderNeutralWeaker: "0 0 0 1px #cce4ff", shadowBorderNewWeaker: "0 0 0 1px #e7dcfa", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #0263e0", shadowBorderPrimaryStrong: "0 0 0 1px #001489", shadowBorderPrimaryStronger: "0 0 0 1px #030b5d", shadowBorderPrimaryStrongest: "0 0 0 1px #06033a", shadowBorderPrimaryWeak: "0 0 0 1px #99cdff", shadowBorderPrimaryWeaker: "0 0 0 1px #cce4ff", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: uqt, shadowBorderSubaccount: "0 0 0 1px #fff1b3", shadowBorderSuccessWeaker: "0 0 0 1px #d1fae0", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #006dfa", shadowBorderTopPrimaryStrongest: "0 -1px 0 #030b5d", shadowBorderUser: dqt, shadowBorderWarningWeaker: "0 0 0 1px #fddcc4", shadowBorderWeak: fqt, shadowBorderWeaker: hqt, shadowCard: pqt, shadowElevation05: mqt, shadowElevation10: gqt, shadowElevation20: vqt, shadowElevationBottom05: "0 1px 0 0 #edeef2", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: yqt, shadowElevationLeft20: bqt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #edeef2", shadowElevationTop20: xqt, shadowFocus: Cqt, shadowFocusInset: wqt, shadowFocusInverse: Sqt, shadowFocusInverseInset: _qt, shadowFocusShadowBorder: kqt, shadowHigh: Aqt, shadowLeft: Tqt, shadowLeftInverse: Eqt, shadowLow: Iqt, shadowRight: Mqt, shadowRightInverse: Pqt }, oKt = { colorBrand: SVt, colorBrandHighlight: "rgb(242, 47, 70)", colorGray0: _Vt, colorGray10: kVt, colorGray20: TVt, colorGray30: EVt, colorGray40: IVt, colorGray50: MVt, colorGray60: PVt, colorGray70: RVt, colorGray80: OVt, colorGray90: BVt, colorGray100: AVt }, wJe = { colorScheme: "light" }, SJe = { colorDataVisualization1: "rgb(0, 20, 137)", colorDataVisualization2: "rgb(14, 124, 58)", colorDataVisualization3: "rgb(13, 58, 31)", colorDataVisualization4: "rgb(0, 140, 255)", colorDataVisualization5: "rgb(57, 71, 98)", colorDataVisualization6: "rgb(166, 127, 227)", colorDataVisualization7: "rgb(109, 46, 209)", colorDataVisualization8: "rgb(136, 145, 170)", colorDataVisualization9: "rgb(117, 12, 12)", colorDataVisualization10: "rgb(235, 86, 86)" }, _Je = { fontFamilyCode: eqt, fontFamilyDisplay: tqt, fontFamilyText: rqt, fontFamilyTextChineseSimplified: nqt, fontFamilyTextChineseTraditional: aqt, fontFamilyTextJapanese: iqt, fontFamilyTextKorean: oqt }, kJe = { fontSize10: "0.625rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "1rem", fontSize50: "1.125rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "1.75rem", fontSize90: "2rem", fontSize100: "2.5rem", fontSize110: "3rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, AJe = { fontWeightLight: "400", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "700", fontWeightExtrabold: "800" }, TJe = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, EJe = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, IJe = { size0: "0", size10: Rqt, size20: Bqt, size30: Nqt, size40: $qt, size50: Dqt, size60: Lqt, size70: jqt, size80: Fqt, size90: zqt, size100: "64rem", size110: Oqt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, MJe = { space0: "0", space10: Gqt, space20: Kqt, space30: eKt, space40: rKt, space50: "1rem", space60: nKt, space70: aKt, space80: iKt, space90: "2rem", space100: Wqt, space110: "2.5rem", space120: Hqt, space130: "3rem", space140: Uqt, space150: "3.5rem", space160: Vqt, space170: "4rem", space180: qqt, space190: "4.5rem", space200: Zqt, space210: "5rem", space220: Jqt, space230: "5.5rem", space240: Yqt, space250: "6rem", space260: Xqt, space270: "6.5rem", space280: Qqt, space290: "7rem", space300: tKt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, PJe = { colorText: NVt, colorTextBrand: $Vt, colorTextBrandHighlight: "rgb(242, 47, 70)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(96, 107, 133)", colorTextDecorative20: "rgb(0, 20, 137)", colorTextDecorative30: "rgb(14, 124, 58)", colorTextDecorative40: "rgb(109, 46, 209)", colorTextDestructive: "rgb(214, 31, 31)", colorTextDestructiveStrong: "rgb(173, 17, 17)", colorTextDestructiveStronger: "rgb(74, 11, 11)", colorTextDestructiveStrongest: "rgb(49, 12, 12)", colorTextDestructiveWeak: "rgb(246, 177, 177)", colorTextError: DVt, colorTextErrorStrong: "rgb(173, 17, 17)", colorTextErrorStronger: "rgb(74, 11, 11)", colorTextErrorStrongest: "rgb(49, 12, 12)", colorTextErrorWeak: "rgb(235, 86, 86)", colorTextIcon: LVt, colorTextIconAvailable: "rgb(14, 124, 58)", colorTextIconBrandHighlight: "rgb(242, 47, 70)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: jVt, colorTextIconError: "rgb(214, 31, 31)", colorTextIconInverse: "rgb(136, 145, 170)", colorTextIconNeutral: "rgb(0, 20, 137)", colorTextIconNew: FVt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(96, 107, 133)", colorTextIconSuccess: "rgb(14, 124, 58)", colorTextIconUnavailable: "rgb(214, 31, 31)", colorTextIconWarning: "rgb(227, 106, 25)", colorTextInverse: zVt, colorTextInverseNew: GVt, colorTextInverseWeak: "rgb(202, 205, 216)", colorTextInverseWeaker: "rgb(136, 145, 170)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: WVt, colorTextLinkDestructive: "rgb(214, 31, 31)", colorTextLinkDestructiveStrong: "rgb(173, 17, 17)", colorTextLinkDestructiveStronger: "rgb(74, 11, 11)", colorTextLinkDestructiveStrongest: "rgb(49, 12, 12)", colorTextLinkDestructiveWeak: "rgb(246, 177, 177)", colorTextLinkStrong: "rgb(0, 20, 137)", colorTextLinkStronger: "rgb(3, 11, 93)", colorTextLinkStrongest: "rgb(6, 3, 58)", colorTextLinkWeak: HVt, colorTextNeutral: UVt, colorTextNew: VVt, colorTextPrimary: qVt, colorTextPrimaryStrong: "rgb(0, 20, 137)", colorTextPrimaryStronger: "rgb(3, 11, 93)", colorTextPrimaryStrongest: "rgb(6, 3, 58)", colorTextPrimaryWeak: "rgb(153, 205, 255)", colorTextSubaccount: "rgb(84, 51, 8)", colorTextSuccess: KVt, colorTextUser: ZVt, colorTextWarning: JVt, colorTextWarningStrong: "rgb(141, 49, 24)", colorTextWeak: YVt, colorTextWeaker: XVt, colorTextWeakest: QVt }, RJe = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, sKt = "rgb(244, 246, 250)", lKt = "rgb(255, 255, 255)", cKt = "rgb(231, 228, 249)", uKt = "rgba(71, 77, 102, 0.64)", dKt = "rgb(231, 228, 249)", fKt = "rgb(249, 249, 250)", hKt = "rgb(216, 218, 229)", pKt = "rgb(209, 67, 67)", mKt = "rgb(136, 145, 170)", gKt = "rgb(51, 102, 255)", vKt = "rgb(166, 127, 227)", yKt = "rgb(51, 102, 255)", bKt = "rgb(143, 149, 178)", xKt = "rgb(82, 189, 148)", CKt = "rgb(231, 220, 250)", wKt = "rgb(222, 117, 72)", SKt = "rgb(230, 232, 240)", _Kt = "rgb(237, 239, 245)", kKt = "rgb(255, 255, 255)", AKt = "rgb(71, 77, 102)", TKt = "rgb(18, 28, 45)", EKt = "rgb(167, 54, 54)", IKt = "rgb(143, 149, 178)", MKt = "rgb(222, 117, 72)", PKt = "rgb(109, 46, 209)", RKt = "rgb(255, 255, 255)", OKt = "rgb(200, 175, 240)", BKt = "rgb(51, 102, 255)", NKt = "rgb(157, 181, 255)", $Kt = "rgb(0, 20, 137)", DKt = "rgb(82, 73, 136)", LKt = "rgb(51, 102, 255)", jKt = "rgb(36, 99, 75)", FKt = "rgb(109, 46, 209)", zKt = "rgb(178, 94, 58)", GKt = "rgb(105, 111, 140)", WKt = "rgb(143, 149, 178)", HKt = "rgb(255, 255, 255)", UKt = "'SF Mono', Monaco, Inconsolata, 'Fira Mono', 'Droid Sans Mono', 'Source Code Pro', monospace", VKt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", qKt = "'SF UI Text', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'", KKt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", ZKt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", JKt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", YKt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", XKt = "0 4px 16px 0 rgba(18, 28, 45, 0.2)", QKt = "0 0 0 1px #D8DAE5", eZt = "0 0 0 1px #D14343", tZt = "0 0 0 1px #8F95B2", rZt = "0 0 0 1px #8c5bd8", nZt = "0 0 0 1px #E6E8F0", aZt = "0 0 0 1px #EDEFF5", iZt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", oZt = "0 0 0 1px #edeef2", sZt = "0 -1px 0 0 #f4f4f6, 0 3px 4px 0 rgba(15, 22, 33, 0.1)", lZt = "0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", cZt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", uZt = "0 0 0 1px #f9f9fa, -4px 0 8px 0 rgba(15, 22, 33, 0.1), -16px 0 32px 0 rgba(15, 22, 33, 0.05)", dZt = "0 0 0 1px #f9f9fa, 0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", fZt = "0 0 0 4px rgba(2, 99, 224, 0.7)", hZt = "inset 0 0 0 2px rgba(2, 99, 224, 0.7)", pZt = "0 0 0 4px rgba(255, 255, 255, 0.4)", mZt = "inset 0 0 0 2px rgba(255, 255, 255, 0.4)", gZt = "0 0 0 4px rgba(2, 99, 224, 0.7), 0 0 0 1px #8891aa", vZt = "0 16px 24px 0 rgba(18, 28, 45, 0.2)", yZt = "4px 0 8px -4px rgba(18, 28, 45, 0.2)", bZt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", xZt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", CZt = "-4px 0 8px -4px rgba(18, 28, 45, 0.2)", wZt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", SZt = "5.5rem", _Zt = "70.5rem", kZt = "12rem", AZt = "18.5rem", TZt = "25rem", EZt = "31.5rem", IZt = "38rem", MZt = "44.5rem", PZt = "51rem", RZt = "57.5rem", OZt = "0.125rem", BZt = "2.25rem", NZt = "2.75rem", $Zt = "3.25rem", DZt = "3.75rem", LZt = "4.25rem", jZt = "0.25rem", FZt = "4.75rem", zZt = "5.25rem", GZt = "5.75rem", WZt = "6.25rem", HZt = "6.75rem", UZt = "0.5rem", VZt = "7.25rem", qZt = "0.75rem", KZt = "1.25rem", ZZt = "1.5rem", JZt = "1.75rem", YZt = { colorBackground: sKt, colorBackgroundAvailable: "rgb(82, 189, 148)", colorBackgroundBody: lKt, colorBackgroundBodyElevation: "rgb(249, 249, 250)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(71, 77, 102)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(82, 189, 148)", colorBackgroundBrandHighlightWeakest: "rgb(220, 242, 234)", colorBackgroundBrandStrong: "rgb(3, 11, 93)", colorBackgroundBrandStronger: "rgb(6, 3, 58)", colorBackgroundBusy: "rgb(222, 117, 72)", colorBackgroundDecorative10Weakest: "rgb(244, 246, 250)", colorBackgroundDecorative20Weakest: "rgb(243, 246, 255)", colorBackgroundDecorative30Weakest: "rgb(238, 248, 244)", colorBackgroundDecorative40Weakest: "rgb(248, 247, 253)", colorBackgroundDestructive: "rgb(209, 67, 67)", colorBackgroundDestructiveStrong: "rgb(167, 54, 54)", colorBackgroundDestructiveStronger: "rgb(125, 40, 40)", colorBackgroundDestructiveStrongest: "rgb(79, 21, 21)", colorBackgroundDestructiveWeak: "rgb(244, 182, 182)", colorBackgroundDestructiveWeaker: "rgb(249, 218, 218)", colorBackgroundDestructiveWeakest: "rgb(253, 244, 244)", colorBackgroundElevation: "rgb(237, 238, 242)", colorBackgroundError: "rgb(209, 67, 67)", colorBackgroundErrorStrong: "rgb(167, 54, 54)", colorBackgroundErrorStronger: "rgb(125, 40, 40)", colorBackgroundErrorStrongest: "rgb(49, 12, 12)", colorBackgroundErrorWeakest: "rgb(253, 244, 244)", colorBackgroundInverse: "rgb(18, 28, 45)", colorBackgroundInverseElevation: "rgb(25, 39, 62)", colorBackgroundInverseStrong: "rgb(64, 79, 110)", colorBackgroundInverseStrongElevation: "rgb(75, 86, 113)", colorBackgroundInverseStronger: "rgb(96, 107, 133)", colorBackgroundInverseStrongerElevation: "rgb(103, 114, 142)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(25, 39, 62)", colorBackgroundNeutralWeakest: "rgb(244, 246, 250)", colorBackgroundNew: cKt, colorBackgroundNewWeakest: "rgb(250, 247, 253)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(193, 196, 214)", colorBackgroundOverlay: uKt, colorBackgroundPrimary: "rgb(51, 102, 255)", colorBackgroundPrimaryStrong: "rgb(41, 82, 204)", colorBackgroundPrimaryStronger: "rgb(31, 61, 153)", colorBackgroundPrimaryStrongest: "rgb(12, 30, 86)", colorBackgroundPrimaryWeak: "rgb(214, 224, 255)", colorBackgroundPrimaryWeaker: "rgb(235, 240, 255)", colorBackgroundPrimaryWeakest: "rgb(243, 246, 255)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(250, 251, 255)", colorBackgroundStrong: "rgb(230, 232, 240)", colorBackgroundStrongElevation: "rgb(225, 227, 234)", colorBackgroundStronger: "rgb(202, 205, 216)", colorBackgroundStrongest: "rgb(105, 111, 140)", colorBackgroundSubaccount: "rgb(255, 239, 210)", colorBackgroundSuccess: "rgb(82, 189, 148)", colorBackgroundSuccessWeakest: "rgb(238, 248, 244)", colorBackgroundTrial: "rgb(220, 242, 234)", colorBackgroundUnavailable: "rgb(209, 67, 67)", colorBackgroundUser: dKt, colorBackgroundWarning: "rgb(222, 117, 72)", colorBackgroundWarningWeakest: "rgb(253, 247, 244)", colorBackgroundWeak: fKt, colorBackgroundWeakElevation: "rgb(249, 249, 250)", colorBackgroundWeaker: "rgb(255, 255, 255)", colorBackgroundWeakest: "rgb(255, 255, 255)" }, XZt = { colorBorder: hKt, colorBorderDecorative10Weaker: "rgb(216, 218, 229)", colorBorderDecorative20Weaker: "rgb(214, 224, 255)", colorBorderDecorative30Weaker: "rgb(238, 248, 244)", colorBorderDecorative40Weaker: "rgb(231, 228, 249)", colorBorderDestructive: "rgb(209, 67, 67)", colorBorderDestructiveStrong: "rgb(167, 54, 54)", colorBorderDestructiveStronger: "rgb(125, 40, 40)", colorBorderDestructiveStrongest: "rgb(49, 12, 12)", colorBorderDestructiveWeak: "rgb(244, 182, 182)", colorBorderDestructiveWeaker: "rgb(249, 218, 218)", colorBorderDestructiveWeakest: "rgb(253, 244, 244)", colorBorderError: pKt, colorBorderErrorStrong: "rgb(167, 54, 54)", colorBorderErrorStronger: "rgb(125, 40, 40)", colorBorderErrorStrongest: "rgb(49, 12, 12)", colorBorderErrorWeak: "rgb(238, 145, 145)", colorBorderErrorWeaker: "rgb(244, 182, 182)", colorBorderErrorWeakest: "rgb(249, 218, 218)", colorBorderInverse: mKt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(31, 48, 76)", colorBorderNeutral: gKt, colorBorderNeutralWeak: "rgb(157, 181, 255)", colorBorderNeutralWeaker: "rgb(214, 224, 255)", colorBorderNewWeak: vKt, colorBorderNewWeaker: "rgb(231, 228, 249)", colorBorderPrimary: yKt, colorBorderPrimaryStrong: "rgb(41, 82, 204)", colorBorderPrimaryStronger: "rgb(31, 61, 153)", colorBorderPrimaryStrongest: "rgb(12, 30, 86)", colorBorderPrimaryWeak: "rgb(157, 181, 255)", colorBorderPrimaryWeaker: "rgb(214, 224, 255)", colorBorderPrimaryWeakest: "rgb(235, 240, 255)", colorBorderStrong: bKt, colorBorderSuccess: xKt, colorBorderSuccessWeak: "rgb(163, 230, 205)", colorBorderSuccessWeaker: "rgb(220, 242, 234)", colorBorderSuccessWeakest: "rgb(238, 248, 244)", colorBorderUser: CKt, colorBorderWarning: wKt, colorBorderWarningWeak: "rgb(235, 172, 145)", colorBorderWarningWeaker: "rgb(242, 200, 182)", colorBorderWarningWeakest: "rgb(248, 227, 218)", colorBorderWeak: SKt, colorBorderWeaker: _Kt, colorBorderWeakest: kKt }, QZt = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, eJt = { shadow: XKt, shadowBorder: QKt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #D8DAE5", shadowBorderBottomDecorative20Weaker: "0 1px 0 #D6E0FF", shadowBorderBottomDecorative30Weaker: "0 1px 0 #DCF2EA", shadowBorderBottomDecorative40Weaker: "0 1px 0 #D0CAF4", shadowBorderBottomErrorWeaker: "0 1px 0 #F4B6B6", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #9DB5FF", shadowBorderBottomNewWeaker: "0 1px 0 #D0CAF4", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #ffdd35", shadowBorderBottomSuccessWeaker: "0 1px 0 #DCF2EA", shadowBorderBottomWarningWeaker: "0 1px 0 #F2C8B6", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #cacdd8", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #e1e3ea", shadowBorderDecorative20Weaker: "0 0 0 1px #cce4ff", shadowBorderDecorative30Weaker: "0 0 0 1px #d1fae0", shadowBorderDecorative40Weaker: "0 0 0 1px #e7dcfa", shadowBorderDestructive: "0 0 0 1px #D14343", shadowBorderDestructiveStrong: "0 0 0 1px #A73636", shadowBorderDestructiveStronger: "0 0 0 1px #7D2828", shadowBorderDestructiveStrongest: "0 0 0 1px #310C0C", shadowBorderDestructiveWeak: "0 0 0 1px #F4B6B6", shadowBorderDestructiveWeaker: "0 0 0 1px #F9DADA", shadowBorderError: eZt, shadowBorderErrorStrong: "0 0 0 1px #A73636", shadowBorderErrorStronger: "0 0 0 1px #7D2828", shadowBorderErrorStrongest: "0 0 0 1px #310c0c", shadowBorderErrorWeak: "0 0 0 1px #F4B6B6", shadowBorderErrorWeaker: "0 0 0 1px #fccfcf", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #1f304c", shadowBorderNeutralWeaker: "0 0 0 1px #cce4ff", shadowBorderNewWeaker: "0 0 0 1px #e7dcfa", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #3366FF", shadowBorderPrimaryStrong: "0 0 0 1px #2952CC", shadowBorderPrimaryStronger: "0 0 0 1px #1F3D99", shadowBorderPrimaryStrongest: "0 0 0 1px #0C1E56", shadowBorderPrimaryWeak: "0 0 0 1px #9DB5FF", shadowBorderPrimaryWeaker: "0 0 0 1px #D6E0FF", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: tZt, shadowBorderSubaccount: "0 0 0 1px #fff1b3", shadowBorderSuccessWeaker: "0 0 0 1px #d1fae0", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #3366FF", shadowBorderTopPrimaryStrongest: "0 -1px 0 #030b5d", shadowBorderUser: rZt, shadowBorderWarningWeaker: "0 0 0 1px #fddcc4", shadowBorderWeak: nZt, shadowBorderWeaker: aZt, shadowCard: iZt, shadowElevation05: oZt, shadowElevation10: sZt, shadowElevation20: lZt, shadowElevationBottom05: "0 1px 0 0 #edeef2", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: cZt, shadowElevationLeft20: uZt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #edeef2", shadowElevationTop20: dZt, shadowFocus: fZt, shadowFocusInset: hZt, shadowFocusInverse: pZt, shadowFocusInverseInset: mZt, shadowFocusShadowBorder: gZt, shadowHigh: vZt, shadowLeft: yZt, shadowLeftInverse: bZt, shadowLow: xZt, shadowRight: CZt, shadowRightInverse: wZt }, tJt = { colorScheme: "light" }, rJt = { colorDataVisualization1: "rgb(4, 162, 174)", colorDataVisualization2: "rgb(209, 129, 0)", colorDataVisualization3: "rgb(24, 65, 191)", colorDataVisualization4: "rgb(122, 103, 233)", colorDataVisualization5: "rgb(17, 167, 110)", colorDataVisualization6: "rgb(10, 29, 123)", colorDataVisualization7: "rgb(221, 54, 173)", colorDataVisualization8: "rgb(206, 32, 28)", colorDataVisualization9: "rgb(105, 140, 247)", colorDataVisualization10: "rgb(243, 103, 43)" }, nJt = { fontFamilyCode: UKt, fontFamilyDisplay: VKt, fontFamilyText: qKt, fontFamilyTextChineseSimplified: KKt, fontFamilyTextChineseTraditional: ZKt, fontFamilyTextJapanese: JKt, fontFamilyTextKorean: YKt }, aJt = { fontSize10: "0.75rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "0.875rem", fontSize50: "1rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "2rem", fontSize90: "2rem", fontSize100: "3rem", fontSize110: "4rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, iJt = { fontWeightLight: "300", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "700", fontWeightExtrabold: "800" }, oJt = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, sJt = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, lJt = { size0: "0", size10: SZt, size20: kZt, size30: AZt, size40: TZt, size50: EZt, size60: IZt, size70: MZt, size80: PZt, size90: RZt, size100: "64rem", size110: _Zt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, cJt = { space0: "0", space10: OZt, space20: jZt, space30: UZt, space40: qZt, space50: "1rem", space60: KZt, space70: ZZt, space80: JZt, space90: "2rem", space100: BZt, space110: "2.5rem", space120: NZt, space130: "3rem", space140: $Zt, space150: "3.5rem", space160: DZt, space170: "4rem", space180: LZt, space190: "4.5rem", space200: FZt, space210: "5rem", space220: zZt, space230: "5.5rem", space240: GZt, space250: "6rem", space260: WZt, space270: "6.5rem", space280: HZt, space290: "7rem", space300: VZt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, uJt = { colorText: AKt, colorTextBrand: TKt, colorTextBrandHighlight: "rgb(82, 189, 148)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(105, 111, 140)", colorTextDecorative20: "rgb(41, 82, 204)", colorTextDecorative30: "rgb(49, 113, 89)", colorTextDecorative40: "rgb(110, 98, 182)", colorTextDestructive: "rgb(199, 35, 35)", colorTextDestructiveStrong: "rgb(173, 17, 17)", colorTextDestructiveStronger: "rgb(74, 11, 11)", colorTextDestructiveStrongest: "rgb(49, 12, 12)", colorTextDestructiveWeak: "rgb(246, 177, 177)", colorTextError: EKt, colorTextErrorStrong: "rgb(125, 40, 40)", colorTextErrorStronger: "rgb(49, 12, 12)", colorTextErrorStrongest: "rgb(49, 12, 12)", colorTextErrorWeak: "rgb(209, 67, 67)", colorTextIcon: IKt, colorTextIconAvailable: "rgb(82, 189, 148)", colorTextIconBrandHighlight: "rgb(82, 189, 148)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: MKt, colorTextIconError: "rgb(209, 67, 67)", colorTextIconInverse: "rgb(143, 149, 178)", colorTextIconNeutral: "rgb(0, 20, 137)", colorTextIconNew: PKt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(143, 149, 178)", colorTextIconSuccess: "rgb(82, 189, 148)", colorTextIconUnavailable: "rgb(209, 67, 67)", colorTextIconWarning: "rgb(222, 117, 72)", colorTextInverse: RKt, colorTextInverseNew: OKt, colorTextInverseWeak: "rgb(136, 145, 170)", colorTextInverseWeaker: "rgb(96, 107, 133)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: BKt, colorTextLinkDestructive: "rgb(209, 67, 67)", colorTextLinkDestructiveStrong: "rgb(125, 40, 40)", colorTextLinkDestructiveStronger: "rgb(49, 12, 12)", colorTextLinkDestructiveStrongest: "rgb(49, 12, 12)", colorTextLinkDestructiveWeak: "rgb(209, 67, 67)", colorTextLinkStrong: "rgb(31, 61, 153)", colorTextLinkStronger: "rgb(12, 30, 86)", colorTextLinkStrongest: "rgb(7, 19, 55)", colorTextLinkWeak: NKt, colorTextNeutral: $Kt, colorTextNew: DKt, colorTextPrimary: LKt, colorTextPrimaryStrong: "rgb(0, 20, 137)", colorTextPrimaryStronger: "rgb(3, 11, 93)", colorTextPrimaryStrongest: "rgb(6, 3, 58)", colorTextPrimaryWeak: "rgb(153, 205, 255)", colorTextSubaccount: "rgb(84, 51, 8)", colorTextSuccess: jKt, colorTextUser: FKt, colorTextWarning: zKt, colorTextWarningStrong: "rgb(133, 70, 43)", colorTextWeak: GKt, colorTextWeaker: WKt, colorTextWeakest: HKt }, dJt = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, fJt = "rgb(244, 244, 246)", hJt = "rgb(255, 255, 255)", pJt = "rgb(245, 240, 252)", mJt = "rgb(200, 175, 240)", gJt = "rgb(249, 249, 250)", vJt = "rgb(136, 145, 170)", yJt = "rgb(214, 31, 31)", bJt = "rgb(136, 145, 170)", xJt = "rgb(166, 127, 227)", CJt = "rgb(96, 107, 133)", wJt = "rgb(231, 220, 250)", SJt = "rgb(244, 124, 34)", _Jt = "rgb(202, 205, 216)", kJt = "rgb(225, 227, 234)", AJt = "rgb(255, 255, 255)", TJt = "rgb(18, 28, 45)", EJt = "rgb(18, 28, 45)", IJt = "rgb(214, 31, 31)", MJt = "rgb(96, 107, 133)", PJt = "rgb(227, 106, 25)", RJt = "rgb(109, 46, 209)", OJt = "rgb(255, 255, 255)", BJt = "rgb(200, 175, 240)", NJt = "rgb(2, 99, 224)", $Jt = "rgb(153, 205, 255)", DJt = "rgb(0, 20, 137)", LJt = "rgb(109, 46, 209)", jJt = "rgb(2, 99, 224)", FJt = "rgb(14, 124, 58)", zJt = "rgb(18, 28, 45)", GJt = "rgb(141, 49, 24)", WJt = "rgb(96, 107, 133)", HJt = "rgb(142, 150, 174)", UJt = "rgb(255, 255, 255)", VJt = "'TwilioSansMono', Courier, monospace", qJt = "'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", KJt = "'Colfax', Helvetica, Arial, sans-serif", ZJt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", JJt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", YJt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", XJt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", QJt = "0 4px 16px 0 rgba(18, 28, 45, 0.2)", eYt = "0 0 0 1px #8891aa", tYt = "0 0 0 1px #d61f1f", rYt = "0 0 0 1px #606b85", nYt = "0 0 0 1px #8c5bd8", aYt = "0 0 0 1px #cacdd8", iYt = "0 0 0 1px #e1e3ea", oYt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", sYt = "0 0 0 1px #edeef2", lYt = "0 -1px 0 0 #f4f4f6, 0 3px 4px 0 rgba(15, 22, 33, 0.1)", cYt = "0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", uYt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", dYt = "0 0 0 1px #f9f9fa, -4px 0 8px 0 rgba(15, 22, 33, 0.1), -16px 0 32px 0 rgba(15, 22, 33, 0.05)", fYt = "0 0 0 1px #f9f9fa, 0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)", hYt = "0 0 0 4px rgba(2, 99, 224, 0.7)", pYt = "inset 0 0 0 2px rgba(2, 99, 224, 0.7)", mYt = "0 0 0 4px rgba(255, 255, 255, 0.4)", gYt = "inset 0 0 0 2px rgba(255, 255, 255, 0.4)", vYt = "0 0 0 4px rgba(2, 99, 224, 0.7), 0 0 0 1px #8891aa", yYt = "0 16px 24px 0 rgba(18, 28, 45, 0.2)", bYt = "4px 0 8px -4px rgba(18, 28, 45, 0.2)", xYt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", CYt = "0 2px 8px 0 rgba(18, 28, 45, 0.1)", wYt = "-4px 0 8px -4px rgba(18, 28, 45, 0.2)", SYt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", _Yt = "5.5rem", kYt = "70.5rem", AYt = "12rem", TYt = "18.5rem", EYt = "25rem", IYt = "31.5rem", MYt = "38rem", PYt = "44.5rem", RYt = "51rem", OYt = "57.5rem", BYt = "0.125rem", NYt = "2.25rem", $Yt = "2.75rem", DYt = "3.25rem", LYt = "3.75rem", jYt = "4.25rem", FYt = "0.25rem", zYt = "4.75rem", GYt = "5.25rem", WYt = "5.75rem", HYt = "6.25rem", UYt = "6.75rem", VYt = "0.5rem", qYt = "7.25rem", KYt = "0.75rem", ZYt = "1.25rem", JYt = "1.5rem", YYt = "1.75rem", XYt = { colorBackground: fJt, colorBackgroundAvailable: "rgb(20, 176, 83)", colorBackgroundBody: hJt, colorBackgroundBodyElevation: "rgb(249, 249, 250)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(0, 20, 137)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(242, 47, 70)", colorBackgroundBrandHighlightWeakest: "rgba(242, 47, 70, 0.1)", colorBackgroundBrandStrong: "rgb(3, 11, 93)", colorBackgroundBrandStronger: "rgb(6, 3, 58)", colorBackgroundBusy: "rgb(244, 124, 34)", colorBackgroundDecorative10Weakest: "rgb(244, 244, 246)", colorBackgroundDecorative20Weakest: "rgb(235, 244, 255)", colorBackgroundDecorative30Weakest: "rgb(237, 253, 243)", colorBackgroundDecorative40Weakest: "rgb(245, 240, 252)", colorBackgroundDestructive: "rgb(214, 31, 31)", colorBackgroundDestructiveStrong: "rgb(117, 12, 12)", colorBackgroundDestructiveStronger: "rgb(74, 11, 11)", colorBackgroundDestructiveStrongest: "rgb(49, 12, 12)", colorBackgroundDestructiveWeak: "rgb(246, 177, 177)", colorBackgroundDestructiveWeaker: "rgb(252, 207, 207)", colorBackgroundDestructiveWeakest: "rgb(254, 236, 236)", colorBackgroundElevation: "rgb(237, 238, 242)", colorBackgroundError: "rgb(214, 31, 31)", colorBackgroundErrorStrong: "rgb(117, 12, 12)", colorBackgroundErrorStronger: "rgb(74, 11, 11)", colorBackgroundErrorStrongest: "rgb(49, 12, 12)", colorBackgroundErrorWeakest: "rgb(254, 236, 236)", colorBackgroundInverse: "rgb(31, 48, 76)", colorBackgroundInverseElevation: "rgb(37, 57, 91)", colorBackgroundInverseStrong: "rgb(57, 71, 98)", colorBackgroundInverseStrongElevation: "rgb(37, 57, 91)", colorBackgroundInverseStronger: "rgb(57, 71, 98)", colorBackgroundInverseStrongerElevation: "rgb(64, 79, 110)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(37, 57, 91)", colorBackgroundNeutralWeakest: "rgb(235, 244, 255)", colorBackgroundNew: pJt, colorBackgroundNewWeakest: "rgb(250, 247, 253)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(142, 150, 174)", colorBackgroundOverlay: "rgba(6, 3, 58, 0.4)", colorBackgroundPrimary: "rgb(2, 99, 224)", colorBackgroundPrimaryStrong: "rgb(0, 20, 137)", colorBackgroundPrimaryStronger: "rgb(3, 11, 93)", colorBackgroundPrimaryStrongest: "rgb(6, 3, 58)", colorBackgroundPrimaryWeak: "rgb(153, 205, 255)", colorBackgroundPrimaryWeaker: "rgb(204, 228, 255)", colorBackgroundPrimaryWeakest: "rgb(235, 244, 255)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(244, 244, 246)", colorBackgroundStrong: "rgb(225, 227, 234)", colorBackgroundStrongElevation: "rgb(225, 227, 234)", colorBackgroundStronger: "rgb(136, 145, 170)", colorBackgroundStrongest: "rgb(75, 86, 113)", colorBackgroundSubaccount: "rgb(255, 251, 234)", colorBackgroundSuccess: "rgb(20, 176, 83)", colorBackgroundSuccessWeakest: "rgb(237, 253, 243)", colorBackgroundTrial: "rgb(209, 250, 224)", colorBackgroundUnavailable: "rgb(214, 31, 31)", colorBackgroundUser: mJt, colorBackgroundWarning: "rgb(244, 124, 34)", colorBackgroundWarningWeakest: "rgb(254, 245, 238)", colorBackgroundWeak: gJt, colorBackgroundWeakElevation: "rgb(249, 249, 250)", colorBackgroundWeaker: "rgb(255, 255, 255)", colorBackgroundWeakest: "rgb(255, 255, 255)" }, QYt = { colorBorder: vJt, colorBorderDecorative10Weaker: "rgb(225, 227, 234)", colorBorderDecorative20Weaker: "rgb(204, 228, 255)", colorBorderDecorative30Weaker: "rgb(209, 250, 224)", colorBorderDecorative40Weaker: "rgb(231, 220, 250)", colorBorderDestructive: "rgb(214, 31, 31)", colorBorderDestructiveStrong: "rgb(117, 12, 12)", colorBorderDestructiveStronger: "rgb(74, 11, 11)", colorBorderDestructiveStrongest: "rgb(49, 12, 12)", colorBorderDestructiveWeak: "rgb(246, 177, 177)", colorBorderDestructiveWeaker: "rgb(252, 207, 207)", colorBorderDestructiveWeakest: "rgb(254, 236, 236)", colorBorderError: yJt, colorBorderErrorStrong: "rgb(117, 12, 12)", colorBorderErrorStronger: "rgb(74, 11, 11)", colorBorderErrorStrongest: "rgb(49, 12, 12)", colorBorderErrorWeak: "rgb(245, 138, 138)", colorBorderErrorWeaker: "rgb(252, 207, 207)", colorBorderErrorWeakest: "rgb(254, 236, 236)", colorBorderInverse: bJt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(31, 48, 76)", colorBorderNeutral: "rgb(2, 99, 224)", colorBorderNeutralWeak: "rgb(102, 179, 255)", colorBorderNeutralWeaker: "rgb(204, 228, 255)", colorBorderNewWeak: xJt, colorBorderNewWeaker: "rgb(231, 220, 250)", colorBorderPrimary: "rgb(2, 99, 224)", colorBorderPrimaryStrong: "rgb(0, 20, 137)", colorBorderPrimaryStronger: "rgb(3, 11, 93)", colorBorderPrimaryStrongest: "rgb(6, 3, 58)", colorBorderPrimaryWeak: "rgb(153, 205, 255)", colorBorderPrimaryWeaker: "rgb(204, 228, 255)", colorBorderPrimaryWeakest: "rgb(235, 244, 255)", colorBorderStrong: CJt, colorBorderSuccess: "rgb(20, 176, 83)", colorBorderSuccessWeak: "rgb(54, 213, 118)", colorBorderSuccessWeaker: "rgb(209, 250, 224)", colorBorderSuccessWeakest: "rgb(237, 253, 243)", colorBorderUser: wJt, colorBorderWarning: SJt, colorBorderWarningWeak: "rgb(255, 179, 122)", colorBorderWarningWeaker: "rgb(253, 220, 196)", colorBorderWarningWeakest: "rgb(254, 245, 238)", colorBorderWeak: _Jt, colorBorderWeaker: kJt, colorBorderWeakest: AJt }, eXt = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, tXt = { shadow: QJt, shadowBorder: eYt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #e1e3ea", shadowBorderBottomDecorative20Weaker: "0 1px 0 #cce4ff", shadowBorderBottomDecorative30Weaker: "0 1px 0 #d1fae0", shadowBorderBottomDecorative40Weaker: "0 1px 0 #e7dcfa", shadowBorderBottomErrorWeaker: "0 1px 0 #fccfcf", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #cce4ff", shadowBorderBottomNewWeaker: "0 1px 0 #e7dcfa", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #ffdd35", shadowBorderBottomSuccessWeaker: "0 1px 0 #d1fae0", shadowBorderBottomWarningWeaker: "0 1px 0 #fddcc4", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #cacdd8", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #e1e3ea", shadowBorderDecorative20Weaker: "0 0 0 1px #cce4ff", shadowBorderDecorative30Weaker: "0 0 0 1px #d1fae0", shadowBorderDecorative40Weaker: "0 0 0 1px #e7dcfa", shadowBorderDestructive: "0 0 0 1px #d61f1f", shadowBorderDestructiveStrong: "0 0 0 1px #750c0c", shadowBorderDestructiveStronger: "0 0 0 1px #4a0b0b", shadowBorderDestructiveStrongest: "0 0 0 1px #310c0c", shadowBorderDestructiveWeak: "0 0 0 1px #f6b1b1", shadowBorderDestructiveWeaker: "0 0 0 1px #fccfcf", shadowBorderError: tYt, shadowBorderErrorStrong: "0 0 0 1px #750c0c", shadowBorderErrorStronger: "0 0 0 1px #4a0b0b", shadowBorderErrorStrongest: "0 0 0 1px #310c0c", shadowBorderErrorWeak: "0 0 0 1px #eb5656", shadowBorderErrorWeaker: "0 0 0 1px #fccfcf", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #1f304c", shadowBorderNeutralWeaker: "0 0 0 1px #cce4ff", shadowBorderNewWeaker: "0 0 0 1px #e7dcfa", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #0263e0", shadowBorderPrimaryStrong: "0 0 0 1px #001489", shadowBorderPrimaryStronger: "0 0 0 1px #030b5d", shadowBorderPrimaryStrongest: "0 0 0 1px #06033a", shadowBorderPrimaryWeak: "0 0 0 1px #99cdff", shadowBorderPrimaryWeaker: "0 0 0 1px #cce4ff", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: rYt, shadowBorderSubaccount: "0 0 0 1px #fff1b3", shadowBorderSuccessWeaker: "0 0 0 1px #d1fae0", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #006dfa", shadowBorderTopPrimaryStrongest: "0 -1px 0 #030b5d", shadowBorderUser: nYt, shadowBorderWarningWeaker: "0 0 0 1px #fddcc4", shadowBorderWeak: aYt, shadowBorderWeaker: iYt, shadowCard: oYt, shadowElevation05: sYt, shadowElevation10: lYt, shadowElevation20: cYt, shadowElevationBottom05: "0 1px 0 0 #edeef2", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: uYt, shadowElevationLeft20: dYt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #edeef2", shadowElevationTop20: fYt, shadowFocus: hYt, shadowFocusInset: pYt, shadowFocusInverse: mYt, shadowFocusInverseInset: gYt, shadowFocusShadowBorder: vYt, shadowHigh: yYt, shadowLeft: bYt, shadowLeftInverse: xYt, shadowLow: CYt, shadowRight: wYt, shadowRightInverse: SYt }, rXt = { colorScheme: "light" }, nXt = { colorDataVisualization1: "rgb(0, 20, 137)", colorDataVisualization2: "rgb(14, 124, 58)", colorDataVisualization3: "rgb(13, 58, 31)", colorDataVisualization4: "rgb(0, 140, 255)", colorDataVisualization5: "rgb(57, 71, 98)", colorDataVisualization6: "rgb(166, 127, 227)", colorDataVisualization7: "rgb(109, 46, 209)", colorDataVisualization8: "rgb(136, 145, 170)", colorDataVisualization9: "rgb(117, 12, 12)", colorDataVisualization10: "rgb(235, 86, 86)" }, aXt = { fontFamilyCode: VJt, fontFamilyDisplay: qJt, fontFamilyText: KJt, fontFamilyTextChineseSimplified: ZJt, fontFamilyTextChineseTraditional: JJt, fontFamilyTextJapanese: YJt, fontFamilyTextKorean: XJt }, iXt = { fontSize10: "0.625rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "1rem", fontSize50: "1.125rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "1.75rem", fontSize90: "2rem", fontSize100: "2.5rem", fontSize110: "3rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, oXt = { fontWeightLight: "400", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "700", fontWeightExtrabold: "800" }, sXt = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, lXt = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, cXt = { size0: "0", size10: _Yt, size20: AYt, size30: TYt, size40: EYt, size50: IYt, size60: MYt, size70: PYt, size80: RYt, size90: OYt, size100: "64rem", size110: kYt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, uXt = { space0: "0", space10: BYt, space20: FYt, space30: VYt, space40: KYt, space50: "1rem", space60: ZYt, space70: JYt, space80: YYt, space90: "2rem", space100: NYt, space110: "2.5rem", space120: $Yt, space130: "3rem", space140: DYt, space150: "3.5rem", space160: LYt, space170: "4rem", space180: jYt, space190: "4.5rem", space200: zYt, space210: "5rem", space220: GYt, space230: "5.5rem", space240: WYt, space250: "6rem", space260: HYt, space270: "6.5rem", space280: UYt, space290: "7rem", space300: qYt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, dXt = { colorText: TJt, colorTextBrand: EJt, colorTextBrandHighlight: "rgb(242, 47, 70)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(96, 107, 133)", colorTextDecorative20: "rgb(0, 20, 137)", colorTextDecorative30: "rgb(14, 124, 58)", colorTextDecorative40: "rgb(109, 46, 209)", colorTextDestructive: "rgb(214, 31, 31)", colorTextDestructiveStrong: "rgb(173, 17, 17)", colorTextDestructiveStronger: "rgb(74, 11, 11)", colorTextDestructiveStrongest: "rgb(49, 12, 12)", colorTextDestructiveWeak: "rgb(246, 177, 177)", colorTextError: IJt, colorTextErrorStrong: "rgb(173, 17, 17)", colorTextErrorStronger: "rgb(74, 11, 11)", colorTextErrorStrongest: "rgb(49, 12, 12)", colorTextErrorWeak: "rgb(235, 86, 86)", colorTextIcon: MJt, colorTextIconAvailable: "rgb(14, 124, 58)", colorTextIconBrandHighlight: "rgb(242, 47, 70)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: PJt, colorTextIconError: "rgb(214, 31, 31)", colorTextIconInverse: "rgb(136, 145, 170)", colorTextIconNeutral: "rgb(0, 20, 137)", colorTextIconNew: RJt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(96, 107, 133)", colorTextIconSuccess: "rgb(14, 124, 58)", colorTextIconUnavailable: "rgb(214, 31, 31)", colorTextIconWarning: "rgb(227, 106, 25)", colorTextInverse: OJt, colorTextInverseNew: BJt, colorTextInverseWeak: "rgb(202, 205, 216)", colorTextInverseWeaker: "rgb(136, 145, 170)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: NJt, colorTextLinkDestructive: "rgb(214, 31, 31)", colorTextLinkDestructiveStrong: "rgb(173, 17, 17)", colorTextLinkDestructiveStronger: "rgb(74, 11, 11)", colorTextLinkDestructiveStrongest: "rgb(49, 12, 12)", colorTextLinkDestructiveWeak: "rgb(246, 177, 177)", colorTextLinkStrong: "rgb(0, 20, 137)", colorTextLinkStronger: "rgb(3, 11, 93)", colorTextLinkStrongest: "rgb(6, 3, 58)", colorTextLinkWeak: $Jt, colorTextNeutral: DJt, colorTextNew: LJt, colorTextPrimary: jJt, colorTextPrimaryStrong: "rgb(0, 20, 137)", colorTextPrimaryStronger: "rgb(3, 11, 93)", colorTextPrimaryStrongest: "rgb(6, 3, 58)", colorTextPrimaryWeak: "rgb(153, 205, 255)", colorTextSubaccount: "rgb(84, 51, 8)", colorTextSuccess: FJt, colorTextUser: zJt, colorTextWarning: GJt, colorTextWarningStrong: "rgb(141, 49, 24)", colorTextWeak: WJt, colorTextWeaker: HJt, colorTextWeakest: UJt }, fXt = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, hXt = "rgb(18, 28, 45)", pXt = "rgba(18, 28, 45, 0.9)", mXt = "rgb(96, 107, 133)", gXt = "rgb(214, 31, 31)", vXt = "rgb(136, 145, 170)", yXt = "rgb(109, 46, 209)", bXt = "rgb(136, 145, 170)", xXt = "rgb(88, 23, 189)", CXt = "rgb(244, 124, 34)", wXt = "rgb(57, 71, 98)", SXt = "rgb(244, 244, 246)", _Xt = "rgb(18, 28, 45)", kXt = "rgb(235, 86, 86)", AXt = "rgb(136, 145, 170)", TXt = "rgb(255, 179, 122)", EXt = "rgb(200, 175, 240)", IXt = "rgb(255, 255, 255)", MXt = "rgb(200, 175, 240)", PXt = "rgb(0, 140, 255)", RXt = "rgb(153, 205, 255)", OXt = "rgb(102, 179, 255)", BXt = "rgb(231, 220, 250)", NXt = "rgb(0, 140, 255)", $Xt = "rgb(255, 233, 128)", DXt = "rgb(162, 246, 195)", LXt = "rgb(200, 175, 240)", jXt = "rgb(255, 179, 122)", FXt = "rgb(136, 145, 170)", zXt = "rgb(57, 71, 98)", GXt = "rgb(13, 19, 28)", WXt = "'TwilioSansMono', Courier, monospace", HXt = "'TwilioSansDisplay', 'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", UXt = "'TwilioSansText', 'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif", VXt = "'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif", qXt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", KXt = "'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif", ZXt = "'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif", JXt = "0 4px 16px 0 rgba(0, 0, 0, 0.5)", YXt = "0 0 0 1px #606b85", XXt = "0 0 0 1px #d61f1f", QXt = "0 0 0 1px #8891aa", eQt = "0 0 0 1px #5817bd", tQt = "0 0 0 1px #394762", rQt = "0 0 0 1px #1f304c", nQt = "0 2px 4px 0 rgba(0, 0, 0, 0.4)", aQt = "0 0 0 1px #1f304c", iQt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.4)", oQt = "0 6px 8px 0 rgba(0, 0, 0, 0.3), 16px 16px 32px 0 rgba(0, 0, 0, 0.2)", sQt = "0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)", lQt = "0 0 0 1px #19273E, -4px 0 8px 0 rgba(0, 0, 0, 0.3), -16px 0 32px 0 rgba(0, 0, 0, 0.2)", cQt = "0 0 0 1px #19273E, 0 6px 8px 0 rgba(0, 0, 0, 0.3), 16px 16px 32px 0 rgba(0, 0, 0, 0.2)", uQt = "0 0 0 2px #121c2d, 0 0 0 3px #ffffff, 0 0 0 5px rgba(255, 255, 255, 0.2)", dQt = "inset 0 0 0 1px #ffffff, inset 0 0 0 3px rgba(255, 255, 255, 0.2)", fQt = "0 0 0 1px #394762, 0 0 0 3px #121c2d, 0 0 0 4px #ffffff, 0 0 0 6px rgba(255, 255, 255, 0.2)", hQt = "0 0 0 1px #ffffff, inset 0 0 0 3px rgba(255, 255, 255, 0.2)", pQt = "0 0 0 1px #394762, 0 0 0 3px #121c2d, 0 0 0 4px #ffffff, 0 0 0 6px rgba(255, 255, 255, 0.2)", mQt = "0 16px 24px 4px rgba(0, 0, 0, 0.5)", gQt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", vQt = "4px 0 8px -4px rgba(0, 0, 0, 0.4)", yQt = "0 2px 4px 0 rgba(0, 0, 0, 0.4)", bQt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", xQt = "-4px 0 8px -4px rgba(0, 0, 0, 0.4)", CQt = "5.5rem", wQt = "70.5rem", SQt = "12rem", _Qt = "18.5rem", kQt = "25rem", AQt = "31.5rem", TQt = "38rem", EQt = "44.5rem", IQt = "51rem", MQt = "57.5rem", PQt = "0.125rem", RQt = "2.25rem", OQt = "2.75rem", BQt = "3.25rem", NQt = "3.75rem", $Qt = "4.25rem", DQt = "0.25rem", LQt = "4.75rem", jQt = "5.25rem", FQt = "5.75rem", zQt = "6.25rem", GQt = "6.75rem", WQt = "0.5rem", HQt = "7.25rem", UQt = "0.75rem", VQt = "1.25rem", qQt = "1.5rem", KQt = "1.75rem", ZQt = { colorBackground: hXt, colorBackgroundAvailable: "rgb(20, 176, 83)", colorBackgroundBody: "rgb(13, 19, 28)", colorBackgroundBodyElevation: "rgb(25, 39, 62)", colorBackgroundBodyInverse: "rgb(18, 28, 45)", colorBackgroundBrand: "rgb(18, 28, 45)", colorBackgroundBrand10: "rgb(242, 190, 90)", colorBackgroundBrand20: "rgb(81, 169, 227)", colorBackgroundBrand30: "rgb(106, 221, 178)", colorBackgroundBrandHighlight: "rgb(242, 47, 70)", colorBackgroundBrandHighlightWeakest: "rgba(242, 47, 70, 0.1)", colorBackgroundBrandStrong: "rgb(18, 28, 45)", colorBackgroundBrandStronger: "rgb(18, 28, 45)", colorBackgroundBusy: "rgb(244, 124, 34)", colorBackgroundDecorative10Weakest: "rgb(18, 28, 45)", colorBackgroundDecorative20Weakest: "rgb(3, 11, 93)", colorBackgroundDecorative30Weakest: "rgb(5, 41, 18)", colorBackgroundDecorative40Weakest: "rgb(34, 9, 74)", colorBackgroundDestructive: "rgb(214, 31, 31)", colorBackgroundDestructiveStrong: "rgb(246, 177, 177)", colorBackgroundDestructiveStronger: "rgb(252, 207, 207)", colorBackgroundDestructiveStrongest: "rgb(254, 236, 236)", colorBackgroundDestructiveWeak: "rgb(57, 71, 98)", colorBackgroundDestructiveWeaker: "rgb(31, 48, 76)", colorBackgroundDestructiveWeakest: "rgb(18, 28, 45)", colorBackgroundElevation: "rgb(25, 39, 62)", colorBackgroundError: "rgb(214, 31, 31)", colorBackgroundErrorStrong: "rgb(245, 138, 138)", colorBackgroundErrorStronger: "rgb(252, 207, 207)", colorBackgroundErrorStrongest: "rgb(254, 236, 236)", colorBackgroundErrorWeakest: "rgb(18, 28, 45)", colorBackgroundInverse: "rgb(18, 28, 45)", colorBackgroundInverseElevation: "rgb(25, 39, 62)", colorBackgroundInverseStrong: "rgb(31, 48, 76)", colorBackgroundInverseStrongElevation: "rgb(37, 57, 91)", colorBackgroundInverseStronger: "rgb(57, 71, 98)", colorBackgroundInverseStrongerElevation: "rgb(64, 79, 110)", colorBackgroundInverseStrongest: "rgb(255, 255, 255)", colorBackgroundInverseWeakElevation: "rgb(18, 28, 45)", colorBackgroundNeutralWeakest: "rgb(18, 28, 45)", colorBackgroundNew: "rgb(56, 14, 120)", colorBackgroundNewWeakest: "rgb(18, 28, 45)", colorBackgroundNotification: "rgb(214, 31, 31)", colorBackgroundOffline: "rgb(174, 178, 193)", colorBackgroundOverlay: pXt, colorBackgroundPrimary: "rgb(0, 109, 250)", colorBackgroundPrimaryStrong: "rgb(153, 205, 255)", colorBackgroundPrimaryStronger: "rgb(204, 228, 255)", colorBackgroundPrimaryStrongest: "rgb(235, 244, 255)", colorBackgroundPrimaryWeak: "rgb(57, 71, 98)", colorBackgroundPrimaryWeaker: "rgb(31, 48, 76)", colorBackgroundPrimaryWeakest: "rgb(18, 28, 45)", colorBackgroundRequired: "rgb(235, 86, 86)", colorBackgroundRowStriped: "rgb(18, 28, 45)", colorBackgroundStrong: "rgb(31, 48, 76)", colorBackgroundStrongElevation: "rgb(31, 48, 76)", colorBackgroundStronger: "rgb(96, 107, 133)", colorBackgroundStrongest: "rgb(225, 227, 234)", colorBackgroundSubaccount: "rgb(18, 28, 45)", colorBackgroundSuccess: "rgb(20, 176, 83)", colorBackgroundSuccessWeakest: "rgb(18, 28, 45)", colorBackgroundTrial: "rgb(5, 41, 18)", colorBackgroundUnavailable: "rgb(214, 31, 31)", colorBackgroundUser: "rgb(34, 9, 74)", colorBackgroundWarning: "rgb(244, 124, 34)", colorBackgroundWarningWeakest: "rgb(18, 28, 45)", colorBackgroundWeak: "rgb(18, 28, 45)", colorBackgroundWeakElevation: "rgb(18, 28, 45)", colorBackgroundWeaker: "rgb(18, 28, 45)", colorBackgroundWeakest: "rgb(13, 19, 28)" }, JQt = { colorBorder: mXt, colorBorderDecorative10Weaker: "rgb(31, 48, 76)", colorBorderDecorative20Weaker: "rgb(4, 60, 181)", colorBorderDecorative30Weaker: "rgb(14, 124, 58)", colorBorderDecorative40Weaker: "rgb(88, 23, 189)", colorBorderDestructive: "rgb(214, 31, 31)", colorBorderDestructiveStrong: "rgb(246, 177, 177)", colorBorderDestructiveStronger: "rgb(252, 207, 207)", colorBorderDestructiveStrongest: "rgb(254, 236, 236)", colorBorderDestructiveWeak: "rgb(117, 12, 12)", colorBorderDestructiveWeaker: "rgb(74, 11, 11)", colorBorderDestructiveWeakest: "rgb(49, 12, 12)", colorBorderError: gXt, colorBorderErrorStrong: "rgb(245, 138, 138)", colorBorderErrorStronger: "rgb(252, 207, 207)", colorBorderErrorStrongest: "rgb(254, 236, 236)", colorBorderErrorWeak: "rgb(173, 17, 17)", colorBorderErrorWeaker: "rgb(173, 17, 17)", colorBorderErrorWeakest: "rgb(49, 12, 12)", colorBorderInverse: vXt, colorBorderInverseStrong: "rgb(225, 227, 234)", colorBorderInverseStronger: "rgb(244, 244, 246)", colorBorderInverseStrongest: "rgb(255, 255, 255)", colorBorderInverseWeaker: "rgb(57, 71, 98)", colorBorderInverseWeakest: "rgb(18, 28, 45)", colorBorderNeutral: "rgb(0, 109, 250)", colorBorderNeutralWeak: "rgb(4, 60, 181)", colorBorderNeutralWeaker: "rgb(4, 60, 181)", colorBorderNewWeak: yXt, colorBorderNewWeaker: "rgb(88, 23, 189)", colorBorderPrimary: "rgb(0, 109, 250)", colorBorderPrimaryStrong: "rgb(153, 205, 255)", colorBorderPrimaryStronger: "rgb(204, 228, 255)", colorBorderPrimaryStrongest: "rgb(235, 244, 255)", colorBorderPrimaryWeak: "rgb(4, 60, 181)", colorBorderPrimaryWeaker: "rgb(4, 60, 181)", colorBorderPrimaryWeakest: "rgb(3, 11, 93)", colorBorderStrong: bXt, colorBorderSuccess: "rgb(20, 176, 83)", colorBorderSuccessWeak: "rgb(14, 124, 58)", colorBorderSuccessWeaker: "rgb(14, 124, 58)", colorBorderSuccessWeakest: "rgb(5, 41, 18)", colorBorderUser: xXt, colorBorderWarning: CXt, colorBorderWarningWeak: "rgb(195, 83, 35)", colorBorderWarningWeaker: "rgb(195, 83, 35)", colorBorderWarningWeakest: "rgb(64, 19, 15)", colorBorderWeak: wXt, colorBorderWeaker: "rgb(31, 48, 76)", colorBorderWeakest: "rgb(13, 19, 28)" }, YQt = { borderWidth0: "0", borderWidth10: "1px", borderWidth20: "2px", borderWidth30: "4px", borderWidth40: "8px" }, XQt = { shadow: JXt, shadowBorder: YXt, shadowBorderBottomBrand10Strong: "0 1px 0 #855c15", shadowBorderBottomBrand20Strong: "0 1px 0 #043cb5", shadowBorderBottomBrand30Strong: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative10Weaker: "0 1px 0 #8891aa", shadowBorderBottomDecorative20Weaker: "0 1px 0 #043cb5", shadowBorderBottomDecorative30Weaker: "0 1px 0 #0e7c3a", shadowBorderBottomDecorative40Weaker: "0 1px 0 #5817bd", shadowBorderBottomErrorWeaker: "0 1px 0 #ad1111", shadowBorderBottomInverseNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomInverseWeaker: "0 1px 0 #394762", shadowBorderBottomInverseWeakerInset: "inset 0 -1px 0 0 #394762", shadowBorderBottomNeutralWeaker: "0 1px 0 #043cb5", shadowBorderBottomNewWeaker: "0 1px 0 #5817bd", shadowBorderBottomNotificationStronger: "0 1px 0 #4a0b0b", shadowBorderBottomPrimary: "0 1px 0 #006dfa", shadowBorderBottomSubaccount: "0 1px 0 #c28e00", shadowBorderBottomSuccessWeaker: "0 1px 0 #0e7c3a", shadowBorderBottomWarningWeaker: "0 1px 0 #c35323", shadowBorderBottomWeak: "0 1px 0 #cacdd8", shadowBorderBottomWeakInset: "inset 0 -1px 0 0 #394762", shadowBorderBrand10: "saffron", shadowBorderBrand20: "sky", shadowBorderBrand30: "mint", shadowBorderDecorative10Weaker: "0 0 0 1px #1f304c", shadowBorderDecorative20Weaker: "0 0 0 1px #043cb5", shadowBorderDecorative30Weaker: "0 0 0 1px #0e7c3a", shadowBorderDecorative40Weaker: "0 0 0 1px #5817bd", shadowBorderDestructive: "0 0 0 1px #d61f1f", shadowBorderDestructiveStrong: "0 0 0 1px #f6b1b1", shadowBorderDestructiveStronger: "0 0 0 1px #fccfcf", shadowBorderDestructiveStrongest: "0 0 0 1px #feecec", shadowBorderDestructiveWeak: "0 0 0 1px #394762", shadowBorderDestructiveWeaker: "0 0 0 1px #1f304c", shadowBorderError: XXt, shadowBorderErrorStrong: "0 0 0 1px #f58a8a", shadowBorderErrorStronger: "0 0 0 1px #fccfcf", shadowBorderErrorStrongest: "0 0 0 1px #feecec", shadowBorderErrorWeak: "0 0 0 1px #ad1111", shadowBorderErrorWeaker: "0 0 0 1px #ad1111", shadowBorderInverse: "0 0 0 1px #8891aa", shadowBorderInverseNewWeaker: "0 0 0 1px #5817bd", shadowBorderInverseStrong: "0 0 0 1px #e1e3ea", shadowBorderInverseStronger: "0 0 0 1px #f4f4f6", shadowBorderInverseStrongest: "0 0 0 1px #ffffff", shadowBorderInverseWeaker: "0 0 0 1px #394762", shadowBorderInverseWeakest: "0 0 0 1px #121c2d", shadowBorderNeutralWeaker: "0 0 0 1px #043cb5", shadowBorderNewWeaker: "0 0 0 1px #5817bd", shadowBorderNotification: "0 1px 0 #d61f1f", shadowBorderPrimary: "0 0 0 1px #006dfa", shadowBorderPrimaryStrong: "0 0 0 1px #99cdff", shadowBorderPrimaryStronger: "0 0 0 1px #cce4ff", shadowBorderPrimaryStrongest: "0 0 0 1px #ebf4ff", shadowBorderPrimaryWeak: "0 0 0 1px #043cb5", shadowBorderPrimaryWeaker: "0 0 0 1px #043cb5", shadowBorderRightInverseStrong: "1px 0 #e1e3ea", shadowBorderStrong: QXt, shadowBorderSubaccount: "0 0 0 1px #c28e00", shadowBorderSuccessWeaker: "0 0 0 1px #0e7c3a", shadowBorderTopInverseStrongest: "0 -1px 0 #cce4ff", shadowBorderTopPrimary: "0 -1px 0 #006dfa", shadowBorderTopPrimaryStrongest: "0 -1px 0 #ebf4ff", shadowBorderUser: eQt, shadowBorderWarningWeaker: "0 0 0 1px #c35323", shadowBorderWeak: tQt, shadowBorderWeaker: rQt, shadowCard: nQt, shadowElevation05: aQt, shadowElevation10: iQt, shadowElevation20: oQt, shadowElevationBottom05: "0 1px 0 0 #1f304c", shadowElevationBottomInverse05: "0 1px 0 0 #1f304c", shadowElevationInverse05: "0 0 0 1px #1f304c", shadowElevationInverse10: sQt, shadowElevationLeft20: lQt, shadowElevationRightInverse05: "1px 0 0 0 #1f304c", shadowElevationTop05: "0 -1px 0 0 #1f304c", shadowElevationTop20: cQt, shadowFocus: uQt, shadowFocusInset: dQt, shadowFocusInverse: fQt, shadowFocusInverseInset: hQt, shadowFocusShadowBorder: pQt, shadowHigh: mQt, shadowLeft: gQt, shadowLeftInverse: vQt, shadowLow: yQt, shadowRight: bQt, shadowRightInverse: xQt }, QQt = { colorScheme: "dark" }, eer = { colorDataVisualization1: "rgb(2, 99, 224)", colorDataVisualization2: "rgb(200, 175, 240)", colorDataVisualization3: "rgb(96, 107, 133)", colorDataVisualization4: "rgb(102, 179, 255)", colorDataVisualization5: "rgb(14, 124, 58)", colorDataVisualization6: "rgb(250, 153, 80)", colorDataVisualization7: "rgb(195, 83, 35)", colorDataVisualization8: "rgb(246, 177, 177)", colorDataVisualization9: "rgb(140, 91, 216)", colorDataVisualization10: "rgb(232, 180, 7)" }, ter = { fontFamilyCode: WXt, fontFamilyDisplay: HXt, fontFamilyText: UXt, fontFamilyTextChineseSimplified: VXt, fontFamilyTextChineseTraditional: qXt, fontFamilyTextJapanese: KXt, fontFamilyTextKorean: ZXt }, rer = { fontSize10: "0.625rem", fontSize20: "0.75rem", fontSize30: "0.875rem", fontSize40: "1rem", fontSize50: "1.125rem", fontSize60: "1.25rem", fontSize70: "1.5rem", fontSize80: "1.75rem", fontSize90: "2rem", fontSize100: "2.5rem", fontSize110: "3rem", fontSizeBase: "100%", fontSizeDisplay10: "2rem", fontSizeDisplay20: "3rem", fontSizeDisplay30: "4rem" }, ner = { fontWeightLight: "400", fontWeightNormal: "400", fontWeightMedium: "500", fontWeightSemibold: "600", fontWeightBold: "600", fontWeightExtrabold: "800" }, aer = { lineHeight0: "0", lineHeight05: "0.75rem", lineHeight10: "1rem", lineHeight20: "1.25rem", lineHeight30: "1.25rem", lineHeight40: "1.5rem", lineHeight50: "1.75rem", lineHeight60: "1.75rem", lineHeight70: "2rem", lineHeight80: "2.5rem", lineHeight90: "2.5rem", lineHeight100: "3.25rem", lineHeight110: "4rem", lineHeightDisplay10: "2.5rem", lineHeightDisplay20: "3.75rem", lineHeightDisplay30: "5rem" }, ier = { borderRadius0: "0", borderRadius10: "2px", borderRadius20: "4px", borderRadius30: "8px", borderRadius40: "12px", borderRadius50: "16px", borderRadius60: "20px", borderRadius70: "24px", borderRadius80: "28px", borderRadius90: "32px", borderRadiusCircle: "50%", borderRadiusPill: "100px" }, oer = { size0: "0", size10: CQt, size20: SQt, size30: _Qt, size40: kQt, size50: AQt, size60: TQt, size70: EQt, size80: IQt, size90: MQt, size100: "64rem", size110: wQt, size120: "77rem", sizeBase0: "0", sizeBase10: "0.25rem", sizeBase20: "0.5rem", sizeBase30: "0.75rem", sizeBase40: "1rem", sizeBase50: "1.25rem", sizeBase60: "1.5rem", sizeBase70: "1.75rem", sizeBase80: "2rem", sizeBase90: "2.25rem", sizeIcon05: "0.75rem", sizeIcon10: "1rem", sizeIcon20: "1.25rem", sizeIcon30: "1.25rem", sizeIcon40: "1.5rem", sizeIcon50: "1.75rem", sizeIcon60: "1.75rem", sizeIcon70: "2rem", sizeIcon80: "2.5rem", sizeIcon90: "2.5rem", sizeIcon100: "3.25rem", sizeIcon110: "4rem", sizeSidebar: "15rem", sizeSidebarCompact: "4.75rem", sizeSquare0: "0", sizeSquare10: "0.125rem", sizeSquare20: "0.25rem", sizeSquare25: "0.375rem", sizeSquare30: "0.5rem", sizeSquare40: "0.75rem", sizeSquare50: "1rem", sizeSquare60: "1.25rem", sizeSquare70: "1.5rem", sizeSquare80: "1.75rem", sizeSquare90: "2rem", sizeSquare100: "2.25rem", sizeSquare110: "2.5rem", sizeSquare120: "2.75rem", sizeSquare130: "3rem", sizeSquare140: "3.25rem", sizeSquare150: "3.5rem", sizeSquare160: "3.75rem", sizeSquare170: "4rem", sizeSquare180: "4.25rem", sizeSquare190: "4.5rem", sizeSquare200: "4.75rem", sizeTopbar: "4.75rem" }, ser = { space0: "0", space10: PQt, space20: DQt, space30: WQt, space40: UQt, space50: "1rem", space60: VQt, space70: qQt, space80: KQt, space90: "2rem", space100: RQt, space110: "2.5rem", space120: OQt, space130: "3rem", space140: BQt, space150: "3.5rem", space160: NQt, space170: "4rem", space180: $Qt, space190: "4.5rem", space200: LQt, space210: "5rem", space220: jQt, space230: "5.5rem", space240: FQt, space250: "6rem", space260: zQt, space270: "6.5rem", space280: GQt, space290: "7rem", space300: HQt, space310: "7.5rem", spaceNegative10: "-0.125rem", spaceNegative20: "-0.25rem", spaceNegative30: "-0.5rem", spaceNegative40: "-0.75rem", spaceNegative50: "-1rem", spaceNegative60: "-1.25rem", spaceNegative70: "-1.5rem", spaceNegative80: "-1.75rem", spaceNegative90: "-2rem", spaceNegative100: "-2.25rem", spaceNegative110: "-2.5rem", spaceNegative120: "-2.75rem", spaceNegative130: "-3rem", spaceNegative140: "-3.25rem", spaceNegative150: "-3.5rem", spaceNegative160: "-3.75rem", spaceNegative170: "-4rem", spaceNegative180: "-4.25rem", spaceNegative190: "-4.5rem", spaceNegative200: "-4.75rem" }, ler = { colorText: SXt, colorTextBrand: _Xt, colorTextBrandHighlight: "rgb(242, 47, 70)", colorTextBrandInverse: "rgb(255, 255, 255)", colorTextDecorative10: "rgb(225, 227, 234)", colorTextDecorative20: "rgb(204, 228, 255)", colorTextDecorative30: "rgb(162, 246, 195)", colorTextDecorative40: "rgb(200, 175, 240)", colorTextDestructive: "rgb(235, 86, 86)", colorTextDestructiveStrong: "rgb(246, 177, 177)", colorTextDestructiveStronger: "rgb(246, 177, 177)", colorTextDestructiveStrongest: "rgb(255, 255, 255)", colorTextDestructiveWeak: "rgb(57, 71, 98)", colorTextError: kXt, colorTextErrorStrong: "rgb(246, 177, 177)", colorTextErrorStronger: "rgb(254, 236, 236)", colorTextErrorStrongest: "rgb(254, 236, 236)", colorTextErrorWeak: "rgb(235, 86, 86)", colorTextIcon: AXt, colorTextIconAvailable: "rgb(54, 213, 118)", colorTextIconBrandHighlight: "rgb(242, 47, 70)", colorTextIconBrandInverse: "rgb(255, 255, 255)", colorTextIconBusy: TXt, colorTextIconError: "rgb(235, 86, 86)", colorTextIconInverse: "rgb(136, 145, 170)", colorTextIconNeutral: "rgb(102, 179, 255)", colorTextIconNew: EXt, colorTextIconNotification: "rgb(235, 86, 86)", colorTextIconOffline: "rgb(244, 244, 246)", colorTextIconSuccess: "rgb(54, 213, 118)", colorTextIconUnavailable: "rgb(235, 86, 86)", colorTextIconWarning: "rgb(255, 179, 122)", colorTextInverse: IXt, colorTextInverseNew: MXt, colorTextInverseWeak: "rgb(202, 205, 216)", colorTextInverseWeaker: "rgb(136, 145, 170)", colorTextInverseWeakest: "rgb(75, 86, 113)", colorTextLink: PXt, colorTextLinkDestructive: "rgb(235, 86, 86)", colorTextLinkDestructiveStrong: "rgb(246, 177, 177)", colorTextLinkDestructiveStronger: "rgb(246, 177, 177)", colorTextLinkDestructiveStrongest: "rgb(255, 255, 255)", colorTextLinkDestructiveWeak: "rgb(57, 71, 98)", colorTextLinkStrong: RXt, colorTextLinkStronger: "rgb(235, 244, 255)", colorTextLinkStrongest: "rgb(255, 255, 255)", colorTextLinkWeak: "rgb(57, 71, 98)", colorTextNeutral: OXt, colorTextNew: BXt, colorTextPrimary: NXt, colorTextPrimaryStrong: "rgb(153, 205, 255)", colorTextPrimaryStronger: "rgb(153, 205, 255)", colorTextPrimaryStrongest: "rgb(255, 255, 255)", colorTextPrimaryWeak: "rgb(57, 71, 98)", colorTextSubaccount: $Xt, colorTextSuccess: DXt, colorTextUser: LXt, colorTextWarning: jXt, colorTextWarningStrong: "rgb(250, 194, 160)", colorTextWeak: FXt, colorTextWeaker: zXt, colorTextWeakest: GXt }, cer = { zIndex0: "0", zIndex10: "10", zIndex20: "20", zIndex30: "30", zIndex40: "40", zIndex50: "50", zIndex60: "60", zIndex70: "70", zIndex80: "80", zIndex90: "90" }, uer = /* @__PURE__ */ JSON.parse(`{"color-background-user":{"type":"color","category":"background-color","value":"#c8aff0","comment":"Background color used for user avatars.","originalValue":"{!palette-purple-30}","name":"color-background-user"},"color-background-notification":{"type":"color","category":"background-color","value":"#d61f1f","comment":"Background color used for notifications.","originalValue":"{!palette-red-60}","name":"color-background-notification"},"color-background-trial":{"type":"color","category":"background-color","value":"#d1fae0","comment":"Background color used for trial accounts.","originalValue":"{!palette-green-20}","name":"color-background-trial"},"color-background-subaccount":{"type":"color","category":"background-color","value":"#fffbea","comment":"Background color used for subaccounts.","originalValue":"{!palette-yellow-10}","name":"color-background-subaccount"},"color-background-primary-stronger":{"type":"color","category":"background-color","value":"#030b5d","comment":"Stronger background color used for primary actions or highlights.","originalValue":"{!palette-blue-90}","name":"color-background-primary-stronger"},"color-background-destructive-stronger":{"type":"color","category":"background-color","value":"#4a0b0b","comment":"Stronger background color used for destructive actions or highlights.","originalValue":"{!palette-red-90}","name":"color-background-destructive-stronger"},"color-background-primary-weaker":{"type":"color","category":"background-color","value":"#cce4ff","comment":"Weaker background color used for primary actions or highlights.","originalValue":"{!palette-blue-20}","name":"color-background-primary-weaker"},"color-background-destructive-weaker":{"type":"color","category":"background-color","value":"#fccfcf","comment":"Weaker background color used for destructive actions or highlights.","originalValue":"{!palette-red-20}","name":"color-background-destructive-weaker"},"color-background-inverse-stronger-elevation":{"type":"color","category":"background-color","value":"#404f6e","comment":"Elevation token for color-background-inverse-stronger elements.","originalValue":"{!palette-gray-75}","name":"color-background-inverse-stronger-elevation"},"color-background-body-elevation":{"type":"color","category":"background-color","value":"#f9f9fa","comment":"Elevation token for color-background-body elements.","originalValue":"{!palette-gray-05}","name":"color-background-body-elevation"},"color-background-warning":{"type":"color","category":"background-color","value":"#f47c22","comment":"Background color used for warning alerts and toasts.","originalValue":"{!palette-orange-60}","name":"color-background-warning"},"color-background-elevation":{"type":"color","category":"background-color","value":"#edeef2","comment":"Elevation token for color-background elements.","originalValue":"{!palette-gray-15}","name":"color-background-elevation"},"color-background-warning-weakest":{"type":"color","category":"background-color","value":"#fef5ee","comment":"Weakest background color used for warning alerts and toasts.","originalValue":"{!palette-orange-10}","name":"color-background-warning-weakest"},"color-background-inverse-strong":{"type":"color","category":"background-color","value":"#394762","comment":"Strong inverse background color used for containers.","originalValue":"{!palette-gray-80}","name":"color-background-inverse-strong"},"color-background-new":{"type":"color","category":"background-color","value":"#f5f0fc","comment":"Background color used to represent a new status.","originalValue":"{!palette-purple-10}","name":"color-background-new"},"color-background-inverse-elevation":{"type":"color","category":"background-color","value":"#25395b","comment":"Elevation token for color-background-inverse elements.","originalValue":"{!palette-gray-85}","name":"color-background-inverse-elevation"},"color-background-strong":{"type":"color","category":"background-color","value":"#e1e3ea","comment":"Strong background color used for containers.","originalValue":"{!palette-gray-20}","name":"color-background-strong"},"color-background-new-weakest":{"type":"color","category":"background-color","value":"#faf7fd","comment":"Weakest background color for indicating a new status.","originalValue":"{!palette-purple-05}","name":"color-background-new-weakest"},"color-background-destructive":{"type":"color","category":"background-color","value":"#d61f1f","comment":"Background color used for destructive actions or highlights.","originalValue":"{!palette-red-60}","name":"color-background-destructive"},"color-background-weak":{"type":"color","category":"background-color","value":"#f9f9fa","comment":"Weak background color used for containers.","originalValue":"{!palette-gray-05}","name":"color-background-weak"},"color-background-primary":{"type":"color","category":"background-color","value":"#0263e0","comment":"Background color used for primary actions or highlights.","originalValue":"{!palette-blue-60}","name":"color-background-primary"},"color-background-primary-weakest":{"type":"color","category":"background-color","value":"#ebf4ff","comment":"Weakest background color used for primary actions or highlights.","originalValue":"{!palette-blue-10}","name":"color-background-primary-weakest"},"color-background-busy":{"type":"color","category":"background-color","value":"#f47c22","comment":"Background color used to represent an entity or person as \\"busy\\".","originalValue":"{!palette-orange-60}","name":"color-background-busy"},"color-background-success":{"type":"color","category":"background-color","value":"#14b053","comment":"Background color used for success alerts and toasts.","originalValue":"{!palette-green-60}","name":"color-background-success"},"color-background-destructive-weakest":{"type":"color","category":"background-color","value":"#feecec","comment":"Weakest background color used for destructive actions or highlights.","originalValue":"{!palette-red-10}","name":"color-background-destructive-weakest"},"color-background-offline":{"type":"color","category":"background-color","value":"#8e96ae","comment":"Background color used to represent an entity or person as \\"offline\\".","originalValue":"{!palette-gray-40}","name":"color-background-offline"},"color-background-row-striped":{"type":"color","category":"background-color","value":"#f4f4f6","comment":"Background color used for alternative striped rows.","originalValue":"{!palette-gray-10}","name":"color-background-row-striped"},"color-background-primary-strongest":{"type":"color","category":"background-color","value":"#06033a","comment":"Strongest background color used for primary actions or highlights.","originalValue":"{!palette-blue-100}","name":"color-background-primary-strongest"},"color-background-success-weakest":{"type":"color","category":"background-color","value":"#edfdf3","comment":"Weakest background color used for success alerts and toasts.","originalValue":"{!palette-green-10}","name":"color-background-success-weakest"},"color-background-destructive-strongest":{"type":"color","category":"background-color","value":"#310c0c","comment":"Strongest background color used for destructive actions or highlights.","originalValue":"{!palette-red-100}","name":"color-background-destructive-strongest"},"color-background-error-strong":{"type":"color","category":"background-color","value":"#750c0c","comment":"Strongest background color used for error alerts and toasts.","originalValue":"{!palette-red-80}","name":"color-background-error-strong"},"color-background-brand-strong":{"type":"color","category":"background-color","value":"#030b5d","comment":"Strong primary brand background, accessible with inverse text.","originalValue":"{!palette-blue-90}","name":"color-background-brand-strong"},"color-background-brand":{"type":"color","category":"background-color","value":"#001489","comment":"Primary brand background, accessible with inverse text.","originalValue":"{!palette-blue-80}","name":"color-background-brand"},"color-background-error":{"type":"color","category":"background-color","value":"#d61f1f","comment":"Background color used for error alerts and toasts.","originalValue":"{!palette-red-60}","name":"color-background-error"},"color-background-neutral-weakest":{"type":"color","category":"background-color","value":"#ebf4ff","comment":"Weakest background color used for neutral or default variants.","originalValue":"{!palette-blue-10}","name":"color-background-neutral-weakest"},"color-background-available":{"type":"color","category":"background-color","value":"#14b053","comment":"Background color used to represent an entity or person as \\"available\\".","originalValue":"{!palette-green-60}","name":"color-background-available"},"color-background-error-weakest":{"type":"color","category":"background-color","value":"#feecec","comment":"Weakest background color used for error alerts and toasts.","originalValue":"{!palette-red-10}","name":"color-background-error-weakest"},"color-background-required":{"type":"color","category":"background-color","value":"#eb5656","comment":"Background color used to represent required form fields.","originalValue":"{!palette-red-50}","name":"color-background-required"},"color-background-error-strongest":{"type":"color","category":"background-color","value":"#310c0c","comment":"Strongest error background color","originalValue":"{!palette-red-100}","name":"color-background-error-strongest"},"color-background-decorative-40-weakest":{"type":"color","category":"background-color","value":"#f5f0fc","comment":"Weakest background color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative border and/or text tokens.","originalValue":"{!palette-purple-10}","name":"color-background-decorative-40-weakest"},"color-background-inverse-stronger":{"type":"color","category":"background-color","value":"#394762","comment":"Stronger inverse background color for any container. Must be used on color-background-body-inverse.","originalValue":"{!palette-gray-80}","name":"color-background-inverse-stronger"},"color-background-decorative-30-weakest":{"type":"color","category":"background-color","value":"#edfdf3","comment":"Weakest background color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative border and/or text tokens.","originalValue":"{!palette-green-10}","name":"color-background-decorative-30-weakest"},"color-background-body":{"type":"color","category":"background-color","value":"#ffffff","comment":"Background color used for the main page body.","originalValue":"{!palette-gray-0}","name":"color-background-body"},"color-background-primary-strong":{"type":"color","category":"background-color","value":"#001489","comment":"Strong background color used for primary actions or highlights.","originalValue":"{!palette-blue-80}","name":"color-background-primary-strong"},"color-background-decorative-20-weakest":{"type":"color","category":"background-color","value":"#ebf4ff","comment":"Weakest background color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative border and/or text tokens.","originalValue":"{!palette-blue-10}","name":"color-background-decorative-20-weakest"},"color-background-destructive-strong":{"type":"color","category":"background-color","value":"#750c0c","comment":"Strong background color used for destructive actions or highlights.","originalValue":"{!palette-red-80}","name":"color-background-destructive-strong"},"color-background-destructive-weak":{"type":"color","category":"background-color","value":"#f6b1b1","comment":"Weak background color used for destructive actions or highlights.","originalValue":"{!palette-red-30}","name":"color-background-destructive-weak"},"color-background-decorative-10-weakest":{"type":"color","category":"background-color","value":"#f4f4f6","comment":"Weakest background color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative border and/or text tokens.","originalValue":"{!palette-gray-10}","name":"color-background-decorative-10-weakest"},"color-background":{"type":"color","category":"background-color","value":"#f4f4f6","comment":"Default background color for any container.","originalValue":"{!palette-gray-10}","name":"color-background"},"color-background-primary-weak":{"type":"color","category":"background-color","value":"#99cdff","comment":"Weak background color used for primary actions or highlights.","originalValue":"{!palette-blue-30}","name":"color-background-primary-weak"},"color-background-brand-30":{"type":"color","category":"background-color","value":"#6ADDB2","comment":"Brand accent background color representing Segment.","originalValue":"{!mint}","name":"color-background-brand-30"},"color-background-weakest":{"type":"color","category":"background-color","value":"#ffffff","comment":"The weakest background color used for containers.","originalValue":"{!palette-gray-0}","name":"color-background-weakest"},"color-background-stronger":{"type":"color","category":"background-color","value":"#8891aa","comment":"Stronger background color used for containers.","originalValue":"{!palette-gray-50}","name":"color-background-stronger"},"color-background-inverse-strong-elevation":{"type":"color","category":"background-color","value":"#25395b","comment":"Elevation token for color-background-inverse-strong elements.","originalValue":"{!palette-gray-85}","name":"color-background-inverse-strong-elevation"},"color-background-brand-20":{"type":"color","category":"background-color","value":"#51A9E3","comment":"Brand accent background color representing Sendgrid.","originalValue":"{!sky}","name":"color-background-brand-20"},"color-background-brand-highlight":{"type":"color","category":"background-color","value":"#F22F46","comment":"Highlight brand background, accessible with black text.","originalValue":"{!amaranth}","name":"color-background-brand-highlight"},"color-background-brand-highlight-weakest":{"type":"color","category":"background-color","value":"rgba(242, 47, 70, 0.1)","comment":"Weakest background color used for brand highlights.","originalValue":"{!amaranth-transparent-10}","name":"color-background-brand-highlight-weakest"},"color-background-strongest":{"type":"color","category":"background-color","value":"#4b5671","comment":"Strongest background color used for containers.","originalValue":"{!palette-gray-70}","name":"color-background-strongest"},"color-background-inverse-weak-elevation":{"type":"color","category":"background-color","value":"#25395b","comment":"Elevation token for color-background-inverse-weak elements.","originalValue":"{!palette-gray-85}","name":"color-background-inverse-weak-elevation"},"color-background-brand-10":{"type":"color","category":"background-color","value":"#F2BE5A","comment":"Brand accent background color representing Twilio.","originalValue":"{!saffron}","name":"color-background-brand-10"},"color-background-weaker":{"type":"color","category":"background-color","value":"#ffffff","comment":"Background color for elevated elements. Matches color-background-body in light mode but appears slightly lighter in dark mode to maintain focus.","originalValue":"{!palette-gray-0}","name":"color-background-weaker"},"color-background-body-inverse":{"type":"color","category":"background-color","value":"#121c2d","comment":"Inverse background color used for the main page body.","originalValue":"{!palette-gray-100}","name":"color-background-body-inverse"},"color-background-inverse":{"type":"color","category":"background-color","value":"#1f304c","comment":"Inverse background color used for containers.","originalValue":"{!palette-gray-90}","name":"color-background-inverse"},"color-background-overlay":{"type":"color","category":"background-color","value":"rgba(6, 3, 58, 0.4)","comment":"Background color used for overlays.","originalValue":"{!palette-blue-100-transparent-40}","name":"color-background-overlay"},"color-background-unavailable":{"type":"color","category":"background-color","value":"#d61f1f","comment":"Background color used to represent an entity or person as \\"unavailable\\".","originalValue":"{!palette-red-60}","name":"color-background-unavailable"},"color-background-strong-elevation":{"type":"color","category":"background-color","value":"#e1e3ea","comment":"Elevation token for color-background-strong elements.","originalValue":"{!palette-gray-20}","name":"color-background-strong-elevation"},"color-background-inverse-strongest":{"type":"color","category":"background-color","value":"#ffffff","comment":"Strongest inverse background color used for containers.","originalValue":"{!palette-gray-0}","name":"color-background-inverse-strongest"},"color-background-weak-elevation":{"type":"color","category":"background-color","value":"#f9f9fa","comment":"Elevation token for color-background-weak elements.","originalValue":"{!palette-gray-05}","name":"color-background-weak-elevation"},"color-background-error-stronger":{"type":"color","category":"background-color","value":"#4a0b0b","comment":"Stronger error background color","originalValue":"{!palette-red-90}","name":"color-background-error-stronger"},"color-background-brand-stronger":{"type":"color","category":"background-color","value":"#06033a","comment":"Stronger primary brand background, accessible with inverse text.","originalValue":"{!palette-blue-100}","name":"color-background-brand-stronger"},"color-border-error-stronger":{"type":"color","category":"border-color","value":"#4a0b0b","comment":"Stronger error border color","originalValue":"{!palette-red-90}","name":"color-border-error-stronger"},"color-border-warning-weak":{"type":"color","category":"border-color","value":"#ffb37a","comment":"Weak warning border color","originalValue":"{!palette-orange-40}","name":"color-border-warning-weak"},"color-border-decorative-40-weaker":{"type":"color","category":"border-color","value":"#e7dcfa","comment":"Weaker border color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or text tokens.","originalValue":"{!palette-purple-20}","name":"color-border-decorative-40-weaker"},"color-border-error-weaker":{"type":"color","category":"border-color","value":"#fccfcf","comment":"Weaker error border color","originalValue":"{!palette-red-20}","name":"color-border-error-weaker"},"color-border-user":{"type":"color","category":"border-color","value":"#e7dcfa","comment":"User avatar border color.","originalValue":"{!palette-purple-20}","name":"color-border-user"},"color-border-neutral-weaker":{"type":"color","category":"border-color","value":"#cce4ff","comment":"Weaker neutral border color","originalValue":"{!palette-blue-20}","name":"color-border-neutral-weaker"},"color-border-warning":{"type":"color","category":"border-color","value":"#f47c22","comment":"Warning border color","originalValue":"{!palette-orange-60}","name":"color-border-warning"},"color-border-success-weaker":{"type":"color","category":"border-color","value":"#d1fae0","comment":"Weaker success border color","originalValue":"{!palette-green-20}","name":"color-border-success-weaker"},"color-border-primary-stronger":{"type":"color","category":"border-color","value":"#030b5d","comment":"Stronger primary border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weak","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weak","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-blue-90}","name":"color-border-primary-stronger"},"color-border-destructive-stronger":{"type":"color","category":"border-color","value":"#4a0b0b","comment":"Stronger destructive hover border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weak","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weak","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-red-90}","name":"color-border-destructive-stronger"},"color-border-warning-weakest":{"type":"color","category":"border-color","value":"#fef5ee","comment":"Weakest warning border color","originalValue":"{!palette-orange-10}","name":"color-border-warning-weakest"},"color-border-primary-weaker":{"type":"color","category":"border-color","value":"#cce4ff","comment":"Weaker primary border color","originalValue":"{!palette-blue-20}","name":"color-border-primary-weaker"},"color-border-destructive-weaker":{"type":"color","category":"border-color","value":"#fccfcf","comment":"Destructive focus border color","originalValue":"{!palette-red-20}","name":"color-border-destructive-weaker"},"color-border-new-weaker":{"type":"color","category":"border-color","value":"#e7dcfa","comment":"Weaker border color for something designated as new","originalValue":"{!palette-purple-20}","name":"color-border-new-weaker"},"color-border-destructive":{"type":"color","category":"border-color","value":"#d61f1f","comment":"Destructive border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-60}","name":"color-border-destructive"},"color-border-inverse-strong":{"type":"color","category":"border-color","value":"#e1e3ea","comment":"Strong border on inverse backgrounds. Must be used on color-background-body-inverse.","uicontrol_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-20}","name":"color-border-inverse-strong"},"color-border-primary":{"type":"color","category":"border-color","value":"#0263e0","comment":"Primary border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-blue-60}","name":"color-border-primary"},"color-border-primary-weakest":{"type":"color","category":"border-color","value":"#ebf4ff","comment":"Weakest primary border color","originalValue":"{!palette-blue-10}","name":"color-border-primary-weakest"},"color-border-success":{"type":"color","category":"border-color","value":"#14b053","comment":"Success border color","originalValue":"{!palette-green-60}","name":"color-border-success"},"color-border-destructive-weakest":{"type":"color","category":"border-color","value":"#feecec","comment":"Destructive focus border color","originalValue":"{!palette-red-10}","name":"color-border-destructive-weakest"},"color-border-destructive-strongest":{"type":"color","category":"border-color","value":"#310c0c","comment":"Strongest destructive hover border color","originalValue":"{!palette-red-100}","name":"color-border-destructive-strongest"},"color-border-primary-strongest":{"type":"color","category":"border-color","value":"#06033a","comment":"Strongest primary border color","originalValue":"{!palette-blue-100}","name":"color-border-primary-strongest"},"color-border-success-weakest":{"type":"color","category":"border-color","value":"#edfdf3","comment":"Weakest success border color","originalValue":"{!palette-green-10}","name":"color-border-success-weakest"},"color-border-warning-weaker":{"type":"color","category":"border-color","value":"#fddcc4","comment":"Weaker warning border color","originalValue":"{!palette-orange-20}","name":"color-border-warning-weaker"},"color-border-strong":{"type":"color","category":"border-color","value":"#606b85","comment":"Strong border color","uicontrol_contrast_pairing":["color-background","color-background-strong","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-gray-60}","name":"color-border-strong"},"color-border-weak":{"type":"color","category":"border-color","value":"#cacdd8","comment":"Weak border color","originalValue":"{!palette-gray-30}","name":"color-border-weak"},"color-border-neutral":{"type":"color","category":"border-color","value":"#0263e0","comment":"Neutral border color","originalValue":"{!palette-blue-60}","name":"color-border-neutral"},"color-border-error":{"type":"color","category":"border-color","value":"#d61f1f","comment":"Error border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-60}","name":"color-border-error"},"color-border-error-weakest":{"type":"color","category":"border-color","value":"#feecec","comment":"Weakest error border color","originalValue":"{!palette-red-10}","name":"color-border-error-weakest"},"color-border-error-strongest":{"type":"color","category":"border-color","value":"#310c0c","comment":"Strongest error border color","originalValue":"{!palette-red-100}","name":"color-border-error-strongest"},"color-border-error-strong":{"type":"color","category":"border-color","value":"#750c0c","comment":"Strong error border color","originalValue":"{!palette-red-80}","name":"color-border-error-strong"},"color-border-error-weak":{"type":"color","category":"border-color","value":"#f58a8a","comment":"Weak error border color","originalValue":"{!palette-red-40}","name":"color-border-error-weak"},"color-border-neutral-weak":{"type":"color","category":"border-color","value":"#66b3ff","comment":"Weak neutral border color","originalValue":"{!palette-blue-40}","name":"color-border-neutral-weak"},"color-border":{"type":"color","category":"border-color","value":"#8891aa","comment":"Default border color","uicontrol_contrast_pairing":["color-background-body"],"originalValue":"{!palette-gray-50}","name":"color-border"},"color-border-weakest":{"type":"color","category":"border-color","value":"#ffffff","comment":"Weakest border color","originalValue":"{!palette-gray-0}","name":"color-border-weakest"},"color-border-inverse-stronger":{"type":"color","category":"border-color","value":"#f4f4f6","comment":"Stronger border on inverse backgrounds. Must be used on color-background-body-inverse.","uicontrol_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-10}","name":"color-border-inverse-stronger"},"color-border-inverse-weaker":{"type":"color","category":"border-color","value":"#394762","comment":"Weaker border on inverse backgrounds. Must be used on color-background-body-inverse.","originalValue":"{!palette-gray-80}","name":"color-border-inverse-weaker"},"color-border-success-weak":{"type":"color","category":"border-color","value":"#36d576","comment":"Weak success border color","originalValue":"{!palette-green-50}","name":"color-border-success-weak"},"color-border-primary-strong":{"type":"color","category":"border-color","value":"#001489","comment":"Strong primary border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weak","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weak","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-blue-80}","name":"color-border-primary-strong"},"color-border-inverse":{"type":"color","category":"border-color","value":"#8891aa","comment":"Border on inverse backgrounds. Must be used on color-background-body-inverse.","uicontrol_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-50}","name":"color-border-inverse"},"color-border-destructive-strong":{"type":"color","category":"border-color","value":"#750c0c","comment":"Destructive focus border color","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weak","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weak","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-red-80}","name":"color-border-destructive-strong"},"color-border-primary-weak":{"type":"color","category":"border-color","value":"#99cdff","comment":"Weak primary border color","originalValue":"{!palette-blue-30}","name":"color-border-primary-weak"},"color-border-inverse-weakest":{"type":"color","category":"border-color","value":"#1f304c","comment":"Weakest border on inverse backgrounds. Must be used on color-background-body-inverse.","originalValue":"{!palette-gray-90}","name":"color-border-inverse-weakest"},"color-border-destructive-weak":{"type":"color","category":"border-color","value":"#f6b1b1","comment":"Destructive focus border color","originalValue":"{!palette-red-30}","name":"color-border-destructive-weak"},"color-border-inverse-strongest":{"type":"color","category":"border-color","value":"#ffffff","comment":"Strongest border on inverse backgrounds. Must be used on color-background-body-inverse.","uicontrol_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-0}","name":"color-border-inverse-strongest"},"color-border-new-weak":{"type":"color","category":"border-color","value":"#a67fe3","comment":"Weak border color for something designated as new","originalValue":"{!palette-purple-40}","name":"color-border-new-weak"},"color-border-weaker":{"type":"color","category":"border-color","value":"#e1e3ea","comment":"Weaker border color","originalValue":"{!palette-gray-20}","name":"color-border-weaker"},"color-border-decorative-10-weaker":{"type":"color","category":"border-color","value":"#e1e3ea","comment":"Weaker border color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or text tokens.","originalValue":"{!palette-gray-20}","name":"color-border-decorative-10-weaker"},"color-border-decorative-20-weaker":{"type":"color","category":"border-color","value":"#cce4ff","comment":"Weaker border color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or text tokens.","originalValue":"{!palette-blue-20}","name":"color-border-decorative-20-weaker"},"color-border-decorative-30-weaker":{"type":"color","category":"border-color","value":"#d1fae0","comment":"Weaker border color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or text tokens.","originalValue":"{!palette-green-20}","name":"color-border-decorative-30-weaker"},"border-radius-circle":{"type":"size","category":"radius","value":"50%","comment":"Circular border radius","originalValue":"{!border-radius-circle}","name":"border-radius-circle"},"border-radius-90":{"type":"size","category":"radius","value":"32px","comment":"Largest border radius","originalValue":"{!border-radius-90}","name":"border-radius-90"},"border-radius-80":{"type":"size","category":"radius","value":"28px","comment":"Extra-large border radius","originalValue":"{!border-radius-80}","name":"border-radius-80"},"border-radius-pill":{"type":"size","category":"radius","value":"100px","comment":"Pill border radius","originalValue":"{!border-radius-pill}","name":"border-radius-pill"},"border-radius-70":{"type":"size","category":"radius","value":"24px","comment":"Larger border radius","originalValue":"{!border-radius-70}","name":"border-radius-70"},"border-radius-60":{"type":"size","category":"radius","value":"20px","comment":"Large border radiusr","originalValue":"{!border-radius-60}","name":"border-radius-60"},"border-radius-50":{"type":"size","category":"radius","value":"16px","comment":"Medium-large border radius","originalValue":"{!border-radius-50}","name":"border-radius-50"},"border-radius-40":{"type":"size","category":"radius","value":"12px","comment":"Medium border radius","originalValue":"{!border-radius-40}","name":"border-radius-40"},"border-radius-0":{"type":"size","category":"radius","value":"0","comment":"Border radius reset","originalValue":"{!border-radius-0}","name":"border-radius-0"},"border-radius-30":{"type":"size","category":"radius","value":"8px","comment":"Small-medium border radius","originalValue":"{!border-radius-30}","name":"border-radius-30"},"border-radius-20":{"type":"size","category":"radius","value":"4px","comment":"Small border radius","originalValue":"{!border-radius-20}","name":"border-radius-20"},"border-radius-10":{"type":"size","category":"radius","value":"2px","comment":"Smallest border radius","originalValue":"{!border-radius-10}","name":"border-radius-10"},"border-width-0":{"type":"size","category":"border-width","value":"0","comment":"Border width reset","originalValue":"{!border-width-0}","name":"border-width-0"},"border-width-10":{"type":"size","category":"border-width","value":"1px","comment":"Constant border width token for border width 10","originalValue":"{!border-width-10}","name":"border-width-10"},"border-width-20":{"type":"size","category":"border-width","value":"2px","comment":"Constant border width token for border width 20","originalValue":"{!border-width-20}","name":"border-width-20"},"border-width-30":{"type":"size","category":"border-width","value":"4px","comment":"Constant border width token for border width 30","originalValue":"{!border-width-30}","name":"border-width-30"},"border-width-40":{"type":"size","category":"border-width","value":"8px","comment":"Constant border width token for border width 40","originalValue":"{!border-width-40}","name":"border-width-40"},"shadow-border-bottom-new-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #e7dcfa","comment":"Weaker bottom shadow border for new status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-purple-20}","name":"shadow-border-bottom-new-weaker"},"shadow":{"type":"shadow","category":"box-shadow","value":"0 4px 16px 0 rgba(18, 28, 45, 0.2)","comment":"Default shadow.","originalValue":"{!deprecated-shadow-elevation-20}","name":"shadow"},"shadow-border-bottom-inverse-weaker-inset":{"type":"shadow","category":"box-shadow","value":"inset 0 -1px 0 0 #394762","comment":"Weaker bottom shadow border for tab container on inverse backgrounds","originalValue":"inset {!offset-0} {!offset-negative-05} {!offset-0} {!offset-0} {!palette-gray-80}","name":"shadow-border-bottom-inverse-weaker-inset"},"shadow-border-subaccount":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #fff1b3","comment":"Shadow border for subaccount badge.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-yellow-20}","name":"shadow-border-subaccount"},"shadow-elevation-05":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #edeef2","comment":"Accent shadows that subtly define the edges of a container. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-15}","name":"shadow-elevation-05"},"shadow-border-destructive-stronger":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #4a0b0b","comment":"Strong shadow border for destructive interactions","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-90}","name":"shadow-border-destructive-stronger"},"shadow-border-success-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #d1fae0","comment":"Weaker shadow border for success inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-green-20}","name":"shadow-border-success-weaker"},"shadow-border-inverse-new-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #5817bd","comment":"Shadow border for the sidebar beta badge.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-purple-70}","name":"shadow-border-inverse-new-weaker"},"shadow-border-primary-stronger":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #030b5d","comment":"Stronger shadow border for inputs active.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-90}","name":"shadow-border-primary-stronger"},"shadow-border-bottom-warning-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #fddcc4","comment":"Weaker bottom shadow border for warning status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-orange-20}","name":"shadow-border-bottom-warning-weaker"},"shadow-border-destructive-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #fccfcf","comment":"Weaker shadow border for destructive interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-20}","name":"shadow-border-destructive-weaker"},"shadow-border-primary-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #cce4ff","comment":"Weaker shadow border for primary interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-20}","name":"shadow-border-primary-weaker"},"shadow-border-top-inverse-strongest":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 #cce4ff","comment":"Top shadow border for for selected status of horizontal tabs on inverse backgrounds","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!palette-blue-20}","name":"shadow-border-top-inverse-strongest"},"shadow-border-bottom-weak":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #cacdd8","comment":"Bottom shadow border for border weak color","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-gray-30}","name":"shadow-border-bottom-weak"},"shadow-border-new-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #e7dcfa","comment":"Weaker shadow border for new status inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-purple-20}","name":"shadow-border-new-weaker"},"shadow-elevation-bottom-inverse-05":{"type":"shadow","category":"box-shadow","value":"0 1px 0 0 #1f304c","comment":"Accent shadows that subtly define the bottom edge of an inverse element. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!offset-0} {!palette-gray-90}","name":"shadow-elevation-bottom-inverse-05"},"shadow-low":{"type":"shadow","category":"box-shadow","value":"0 2px 8px 0 rgba(18, 28, 45, 0.1)","comment":"Low elevation default shadow.","originalValue":"{!deprecated-shadow-elevation-10}","name":"shadow-low"},"shadow-elevation-left-20":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #f9f9fa, -4px 0 8px 0 rgba(15, 22, 33, 0.1), -16px 0 32px 0 rgba(15, 22, 33, 0.05)","comment":"Use for elements that dynamically open from the right side of the screen, appearing above the UI to indicate a greater separation from the underlying surface.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-05}, {!offset-negative-20} {!offset-0} {!offset-40} {!offset-0} {!palette-gray-110-transparent-10}, {!offset-negative-60} {!offset-0} {!offset-90} {!offset-0} {!palette-gray-110-transparent-05}","name":"shadow-elevation-left-20"},"shadow-border-inverse-strong":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #e1e3ea","comment":"Strong shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-20}","name":"shadow-border-inverse-strong"},"shadow-border-warning-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #fddcc4","comment":"Weaker shadow border for warning inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-orange-20}","name":"shadow-border-warning-weaker"},"shadow-elevation-bottom-05":{"type":"shadow","category":"box-shadow","value":"0 1px 0 0 #edeef2","comment":"Accent shadows that subtly define the bottom edge of an element. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!offset-0} {!palette-gray-15}","name":"shadow-elevation-bottom-05"},"shadow-border-strong":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #606b85","comment":"Strong shadow border for inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-60}","name":"shadow-border-strong"},"shadow-focus":{"type":"shadow","category":"box-shadow","value":"0 0 0 4px rgba(2, 99, 224, 0.7)","comment":"Shadow for focus ring on interactive elements.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-20} {!palette-blue-60-transparent-70}","name":"shadow-focus"},"shadow-border-weak":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #cacdd8","comment":"Weak shadow border for disabled inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-30}","name":"shadow-border-weak"},"shadow-focus-inverse":{"type":"shadow","category":"box-shadow","value":"0 0 0 4px rgba(255, 255, 255, 0.4)","comment":"Shadow for focus ring on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-20} {!palette-gray-0-transparent-40}","name":"shadow-focus-inverse"},"shadow-border-primary":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #0263e0","comment":"Default shadow border for primary interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-60}","name":"shadow-border-primary"},"shadow-border-destructive":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #d61f1f","comment":"Shadow border for destructive interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-60}","name":"shadow-border-destructive"},"shadow-high":{"type":"shadow","category":"box-shadow","value":"0 16px 24px 0 rgba(18, 28, 45, 0.2)","comment":"High elevation default shadow.","originalValue":"{!deprecated-shadow-elevation-30}","name":"shadow-high"},"shadow-right":{"type":"shadow","category":"box-shadow","value":"-4px 0 8px -4px rgba(18, 28, 45, 0.2)","comment":"Right shadow border for elements.","originalValue":"{!offset-negative-20} {!offset-0} {!offset-40} {!offset-negative-20} {!palette-gray-100-transparent-20}","name":"shadow-right"},"shadow-elevation-right-inverse-05":{"type":"shadow","category":"box-shadow","value":"1px 0 0 0 #1f304c","comment":"Accent shadows that subtly define the right edge of an inverse element. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-05} {!offset-0} {!offset-0} {!offset-0} {!palette-gray-90}","name":"shadow-elevation-right-inverse-05"},"shadow-border-error-strong":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #750c0c","comment":"Shadow border for error inputs hover.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-80}","name":"shadow-border-error-strong"},"shadow-border-bottom-inverse-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #394762","comment":"Bottom shadow border for inverse border weaker color","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-gray-80}","name":"shadow-border-bottom-inverse-weaker"},"shadow-border-primary-strongest":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #06033a","comment":"Strongest shadow border for inputs active.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-100}","name":"shadow-border-primary-strongest"},"shadow-border-destructive-strongest":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #310c0c","comment":"Strongest shadow border for destructive interactions","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-100}","name":"shadow-border-destructive-strongest"},"shadow-border-error-weak":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #eb5656","comment":"Shadow border for inverse error inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-50}","name":"shadow-border-error-weak"},"shadow-border-bottom-brand-10-strong":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #855c15","comment":"Strong bottom shadow border for brand 10","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-yellow-80}","name":"shadow-border-bottom-brand-10-strong"},"shadow-border-bottom-brand-20-strong":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #043cb5","comment":"Strong bottom shadow border for brand 20","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-blue-70}","name":"shadow-border-bottom-brand-20-strong"},"shadow-right-inverse":{"type":"shadow","category":"box-shadow","value":"-4px 0 8px -4px rgba(0, 0, 0, 0.4)","comment":"Right shadow border for inverse elements.","originalValue":"{!offset-negative-20} {!offset-0} {!offset-40} {!offset-negative-20} {!palette-black-transparent-40}","name":"shadow-right-inverse"},"shadow-elevation-top-20":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #f9f9fa, 0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)","comment":"Use on elements that sit above the UI to indicate a greater distance distance from the surface behind them.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-05}, {!offset-0} {!offset-30} {!offset-40} {!offset-0} {!palette-gray-110-transparent-10}, {!offset-60} {!offset-60} {!offset-90} {!offset-0} {!palette-gray-110-transparent-05}","name":"shadow-elevation-top-20"},"shadow-border-bottom-brand-30-strong":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #0e7c3a","comment":"Strong bottom shadow border for brand 30","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-green-70}","name":"shadow-border-bottom-brand-30-strong"},"shadow-left":{"type":"shadow","category":"box-shadow","value":"4px 0 8px -4px rgba(18, 28, 45, 0.2)","comment":"Left shadow border for elements.","originalValue":"{!offset-20} {!offset-0} {!offset-40} {!offset-negative-20} {!palette-gray-100-transparent-20}","name":"shadow-left"},"shadow-border-error":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #d61f1f","comment":"Shadow border for error inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-60}","name":"shadow-border-error"},"shadow-border-bottom-decorative-10-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #e1e3ea","comment":"Weaker bottom shadow border for decorative 10","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-gray-20}","name":"shadow-border-bottom-decorative-10-weaker"},"shadow-border-bottom-primary":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #006dfa","comment":"Bottom shadow border for primary status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-blue-55}","name":"shadow-border-bottom-primary"},"shadow-border-bottom-decorative-20-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #cce4ff","comment":"Weaker bottom shadow border for decorative 20","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-blue-20}","name":"shadow-border-bottom-decorative-20-weaker"},"shadow-border-inverse-stronger":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #f4f4f6","comment":"Stronger shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-10}","name":"shadow-border-inverse-stronger"},"shadow-border-bottom-weak-inset":{"type":"shadow","category":"box-shadow","value":"inset 0 -1px 0 0 #cacdd8","comment":"Weak bottom shadow border for tab container","originalValue":"inset {!offset-0} {!offset-negative-05} {!offset-0} {!offset-0} {!palette-gray-30}","name":"shadow-border-bottom-weak-inset"},"shadow-border-error-strongest":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #310c0c","comment":"Strongest shadow border for error inputs hover.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-100}","name":"shadow-border-error-strongest"},"shadow-border-destructive-strong":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #750c0c","comment":"Strong shadow border for destructive interactions","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-80}","name":"shadow-border-destructive-strong"},"shadow-border-inverse-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #394762","comment":"Weaker shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-80}","name":"shadow-border-inverse-weaker"},"shadow-border-top-primary":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 #006dfa","comment":"Top shadow border for selected status of horizontal tabs","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!palette-blue-55}","name":"shadow-border-top-primary"},"shadow-border-bottom-decorative-30-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #d1fae0","comment":"Weaker bottom shadow border for decorative 30","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-green-20}","name":"shadow-border-bottom-decorative-30-weaker"},"shadow-border-primary-strong":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #001489","comment":"Strong shadow border for inputs hover.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-80}","name":"shadow-border-primary-strong"},"shadow-border-brand-30":{"type":"shadow","category":"box-shadow","value":"mint","comment":"Shadow border for brand 30","originalValue":"mint","name":"shadow-border-brand-30"},"shadow-border-primary-weak":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #99cdff","comment":"Weaker shadow border for primary interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-30}","name":"shadow-border-primary-weak"},"shadow-focus-shadow-border":{"type":"shadow","category":"box-shadow","value":"0 0 0 4px rgba(2, 99, 224, 0.7), 0 0 0 1px #8891aa","comment":"Shadow for simultaneous focus and border.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-20} {!palette-blue-60-transparent-70}, {!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-50}","name":"shadow-focus-shadow-border"},"shadow-border-bottom-decorative-40-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #e7dcfa","comment":"Weaker bottom shadow border for decorative 40","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-purple-20}","name":"shadow-border-bottom-decorative-40-weaker"},"shadow-border-destructive-weak":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #f6b1b1","comment":"Weak shadow border for destructive interactions.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-30}","name":"shadow-border-destructive-weak"},"shadow-left-inverse":{"type":"shadow","category":"box-shadow","value":"4px 0 8px -4px rgba(0, 0, 0, 0.4)","comment":"Left shadow border for inverse elements.","originalValue":"{!offset-20} {!offset-0} {!offset-40} {!offset-negative-20} {!palette-black-transparent-40}","name":"shadow-left-inverse"},"shadow-border-brand-20":{"type":"shadow","category":"box-shadow","value":"sky","comment":"Shadow border for brand 20","originalValue":"sky","name":"shadow-border-brand-20"},"shadow-border-top-primary-strongest":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 #030b5d","comment":"Top shadow border for selected hover status of horizontal tabs","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!palette-blue-90}","name":"shadow-border-top-primary-strongest"},"shadow-border-bottom-notification-stronger":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #4a0b0b","comment":"Stronger bottom shadow border for notification.","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-red-90}","name":"shadow-border-bottom-notification-stronger"},"shadow-border-bottom-error-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #fccfcf","comment":"Weaker bottom shadow border for error status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-red-20}","name":"shadow-border-bottom-error-weaker"},"shadow-border-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #e1e3ea","comment":"Weaker shadow border for disabled inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-20}","name":"shadow-border-weaker"},"shadow-border":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #8891aa","comment":"Shadow border for inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-50}","name":"shadow-border"},"shadow-elevation-inverse-10":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 0 #1f304c, 0 3px 4px 0 rgba(0, 0, 0, 0.1)","comment":"Use on inverse elements that overlay other UI components but remain visually connected to the elements behind them.","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!offset-0} {!palette-gray-90}, {!offset-0} {!offset-15} {!offset-20} {!offset-0} {!palette-black-transparent-10}","name":"shadow-elevation-inverse-10"},"shadow-border-right-inverse-strong":{"type":"shadow","category":"box-shadow","value":"1px 0 #e1e3ea","comment":"Right shadow border for hover status of vertical tabs on inverse backgrounds","originalValue":"{!offset-05} {!offset-0} {!palette-gray-20}","name":"shadow-border-right-inverse-strong"},"shadow-border-bottom-neutral-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #cce4ff","comment":"Weaker bottom shadow border for neutral status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-blue-20}","name":"shadow-border-bottom-neutral-weaker"},"shadow-border-brand-10":{"type":"shadow","category":"box-shadow","value":"saffron","comment":"Shadow border for brand 10","originalValue":"saffron","name":"shadow-border-brand-10"},"shadow-border-decorative-10-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #e1e3ea","comment":"Weaker shadow border for decorative 10","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-20}","name":"shadow-border-decorative-10-weaker"},"shadow-elevation-top-05":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 0 #edeef2","comment":"Accent shadows that subtly define the top edges of an element. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!offset-0} {!palette-gray-15}","name":"shadow-elevation-top-05"},"shadow-border-decorative-20-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #cce4ff","comment":"Weaker shadow border for decorative 20","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-20}","name":"shadow-border-decorative-20-weaker"},"shadow-border-bottom-subaccount":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #ffdd35","comment":"Bottom shadow border for subaccount badge","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-yellow-40}","name":"shadow-border-bottom-subaccount"},"shadow-focus-inset":{"type":"shadow","category":"box-shadow","value":"inset 0 0 0 2px rgba(2, 99, 224, 0.7)","comment":"Shadow for inset focus on elements, such as DataGrid cells.","originalValue":"inset {!offset-0} {!offset-0} {!offset-0} {!offset-10} {!palette-blue-60-transparent-70}","name":"shadow-focus-inset"},"shadow-elevation-20":{"type":"shadow","category":"box-shadow","value":"0 6px 8px 0 rgba(15, 22, 33, 0.1), 16px 16px 32px 0 rgba(15, 22, 33, 0.05)","comment":"Use on elements with decorative or semantic use of color that sit above the UI to indicate a greater distance distance from the surface behind them.","originalValue":"{!offset-0} {!offset-30} {!offset-40} {!offset-0} {!palette-gray-110-transparent-10}, {!offset-60} {!offset-60} {!offset-90} {!offset-0} {!palette-gray-110-transparent-05}","name":"shadow-elevation-20"},"shadow-border-inverse":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #8891aa","comment":"Shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-50}","name":"shadow-border-inverse"},"shadow-elevation-10":{"type":"shadow","category":"box-shadow","value":"0 -1px 0 0 #f4f4f6, 0 3px 4px 0 rgba(15, 22, 33, 0.1)","comment":"Use on elements that overlay other UI components but remain visually connected to the elements behind them.","originalValue":"{!offset-0} {!offset-negative-05} {!offset-0} {!offset-0} {!palette-gray-10}, {!offset-0} {!offset-15} {!offset-20} {!offset-0} {!palette-gray-110-transparent-10}","name":"shadow-elevation-10"},"shadow-border-decorative-30-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #d1fae0","comment":"Weaker shadow border for decorative 30","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-green-20}","name":"shadow-border-decorative-30-weaker"},"shadow-border-inverse-weakest":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #1f304c","comment":"Weakest shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-90}","name":"shadow-border-inverse-weakest"},"shadow-border-bottom-inverse-new-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #5817bd","comment":"Bottom shadow border for the sidebar beta badge","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-purple-70}","name":"shadow-border-bottom-inverse-new-weaker"},"shadow-border-bottom-success-weaker":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #d1fae0","comment":"Weaker bottom shadow border for success status","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-green-20}","name":"shadow-border-bottom-success-weaker"},"shadow-border-decorative-40-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #e7dcfa","comment":"Weaker shadow border for decorative 40","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-purple-20}","name":"shadow-border-decorative-40-weaker"},"shadow-border-error-stronger":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #4a0b0b","comment":"Shadow border for error inputs hover.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-90}","name":"shadow-border-error-stronger"},"shadow-card":{"type":"shadow","category":"box-shadow","value":"0 2px 8px 0 rgba(18, 28, 45, 0.1)","comment":"Shadow for cards.","originalValue":"{!deprecated-shadow-elevation-10}","name":"shadow-card"},"shadow-border-error-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #fccfcf","comment":"Weaker shadow border for error inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-red-20}","name":"shadow-border-error-weaker"},"shadow-border-inverse-strongest":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #ffffff","comment":"Strongest shadow border on interactive elements on inverse backgrounds.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-0}","name":"shadow-border-inverse-strongest"},"shadow-focus-inverse-inset":{"type":"shadow","category":"box-shadow","value":"inset 0 0 0 2px rgba(255, 255, 255, 0.4)","comment":"Shadow for inset focus ring on interactive elements on inverse backgrounds.","originalValue":"inset {!offset-0} {!offset-0} {!offset-0} {!offset-10} {!palette-gray-0-transparent-40}","name":"shadow-focus-inverse-inset"},"shadow-border-notification":{"type":"shadow","category":"box-shadow","value":"0 1px 0 #d61f1f","comment":"Shadow border for notification.","originalValue":"{!offset-0} {!offset-05} {!offset-0} {!palette-red-60}","name":"shadow-border-notification"},"shadow-elevation-inverse-05":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #1f304c","comment":"Accent shadows that subtly define the the edges of a container on inverse backgrounds. They serve as a lightweight alternative to risen shadows at lower elevations.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-gray-90}","name":"shadow-elevation-inverse-05"},"shadow-border-user":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #8c5bd8","comment":"Shadow border for user.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-purple-50}","name":"shadow-border-user"},"shadow-border-neutral-weaker":{"type":"shadow","category":"box-shadow","value":"0 0 0 1px #cce4ff","comment":"Weaker shadow border for neutral inputs.","originalValue":"{!offset-0} {!offset-0} {!offset-0} {!offset-05} {!palette-blue-20}","name":"shadow-border-neutral-weaker"},"color-data-visualization-10":{"type":"color","category":"data-visualization","value":"#eb5656","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-9","color-data-visualization-1"],"originalValue":"{!palette-red-50}","name":"color-data-visualization-10"},"color-data-visualization-1":{"type":"color","category":"data-visualization","value":"#001489","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-10","color-data-visualization-2"],"originalValue":"{!palette-blue-80}","name":"color-data-visualization-1"},"color-data-visualization-2":{"type":"color","category":"data-visualization","value":"#0e7c3a","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-1","color-data-visualization-3"],"originalValue":"{!palette-green-70}","name":"color-data-visualization-2"},"color-data-visualization-3":{"type":"color","category":"data-visualization","value":"#0d3a1f","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-2","color-data-visualization-4"],"originalValue":"{!palette-green-90}","name":"color-data-visualization-3"},"color-data-visualization-4":{"type":"color","category":"data-visualization","value":"#008cff","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-3","color-data-visualization-5"],"originalValue":"{!palette-blue-50}","name":"color-data-visualization-4"},"color-data-visualization-5":{"type":"color","category":"data-visualization","value":"#394762","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-4","color-data-visualization-6"],"originalValue":"{!palette-gray-80}","name":"color-data-visualization-5"},"color-data-visualization-6":{"type":"color","category":"data-visualization","value":"#a67fe3","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-5","color-data-visualization-7"],"originalValue":"{!palette-purple-40}","name":"color-data-visualization-6"},"color-data-visualization-7":{"type":"color","category":"data-visualization","value":"#6d2ed1","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-6","color-data-visualization-8"],"originalValue":"{!palette-purple-60}","name":"color-data-visualization-7"},"color-data-visualization-8":{"type":"color","category":"data-visualization","value":"#8891aa","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-7","color-data-visualization-9"],"originalValue":"{!palette-gray-50}","name":"color-data-visualization-8"},"color-data-visualization-9":{"type":"color","category":"data-visualization","value":"#750c0c","comment":"Color used for data visualizations. Must be used in a sequence.","uicontrol_contrast_pairing":["color-background-body"],"data_visualization_contrast_pairing":["color-data-visualization-8","color-data-visualization-10"],"originalValue":"{!palette-red-80}","name":"color-data-visualization-9"},"font-family-text":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif","originalValue":"{!font-family-10}","name":"font-family-text"},"font-family-code":{"category":"font","type":"font","value":"'TwilioSansMono', Courier, monospace","originalValue":"{!font-family-20}","name":"font-family-code"},"font-family-text-japanese":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', Hiragino Sans, 'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', 'メイリオ', Meiryo, Osaka, 'MS PGothic', sans-serif","originalValue":"{!font-family-30}","name":"font-family-text-japanese"},"font-family-text-korean":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif","originalValue":"{!font-family-40}","name":"font-family-text-korean"},"font-family-text-chinese-traditional":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', 'Microsoft JhengHei', 微軟正黑體, 'Microsoft JhengHei UI', 'Microsoft YaHei', 微軟雅黑, 宋体, SimSun, sans-serif","originalValue":"{!font-family-50}","name":"font-family-text-chinese-traditional"},"font-family-text-chinese-simplified":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', 'Microsoft YaHei New', 微软雅黑, 'Microsoft Yahei', 'Microsoft JhengHei', 宋体, SimSun, sans-serif","originalValue":"{!font-family-60}","name":"font-family-text-chinese-simplified"},"font-family-display":{"category":"font","type":"font","value":"'Inter var experimental', 'Inter var', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif","originalValue":"{!font-family-10}","name":"font-family-display"},"font-size-110":{"category":"font-size","type":"font-size","value":"3rem","comment":"Constant typography token for font size 110","originalValue":"{!font-size-110}","name":"font-size-110"},"font-size-100":{"category":"font-size","type":"font-size","value":"2.5rem","comment":"Constant typography token for font size 100","originalValue":"{!font-size-100}","name":"font-size-100"},"font-size-90":{"category":"font-size","type":"font-size","value":"2rem","comment":"Constant typography token for font size 90","originalValue":"{!font-size-90}","name":"font-size-90"},"font-size-80":{"category":"font-size","type":"font-size","value":"1.75rem","comment":"Constant typography token for font size 80","originalValue":"{!font-size-80}","name":"font-size-80"},"font-size-70":{"category":"font-size","type":"font-size","value":"1.5rem","comment":"Constant typography token for font size 70","originalValue":"{!font-size-70}","name":"font-size-70"},"font-size-60":{"category":"font-size","type":"font-size","value":"1.25rem","comment":"Constant typography token for font size 60","originalValue":"{!font-size-60}","name":"font-size-60"},"font-size-50":{"category":"font-size","type":"font-size","value":"1.125rem","comment":"Constant typography token for font size 50","originalValue":"{!font-size-50}","name":"font-size-50"},"font-size-40":{"category":"font-size","type":"font-size","value":"1rem","comment":"Constant typography token for font size 40","originalValue":"{!font-size-40}","name":"font-size-40"},"font-size-30":{"category":"font-size","type":"font-size","value":"0.875rem","comment":"Constant typography token for font size 30","originalValue":"{!font-size-30}","name":"font-size-30"},"font-size-20":{"category":"font-size","type":"font-size","value":"0.75rem","comment":"Constant typography token for font size 20","originalValue":"{!font-size-20}","name":"font-size-20"},"font-size-10":{"category":"font-size","type":"font-size","value":"0.625rem","comment":"Constant typography token for font size 10","originalValue":"{!font-size-10}","name":"font-size-10"},"font-size-display-30":{"category":"font-size","type":"font-size","value":"4rem","comment":"Constant typography token for font size display 30","originalValue":"{!font-size-display-30}","name":"font-size-display-30"},"font-size-display-20":{"category":"font-size","type":"font-size","value":"3rem","comment":"Constant typography token for font size display 20","originalValue":"{!font-size-display-20}","name":"font-size-display-20"},"font-size-display-10":{"category":"font-size","type":"font-size","value":"2rem","comment":"Constant typography token for font size display 10","originalValue":"{!font-size-display-10}","name":"font-size-display-10"},"font-size-base":{"category":"font-size","type":"font-size","value":"100%","comment":"Base font size applied to the html element, used for rem calculations","originalValue":"100%","name":"font-size-base"},"font-weight-light":{"category":"font-weight","type":"font-weight","value":"400","comment":"Font weight for light weight","originalValue":"{!font-weight-normal}","name":"font-weight-light"},"font-weight-normal":{"category":"font-weight","type":"font-weight","value":"400","comment":"Font weight for normal weight","originalValue":"{!font-weight-normal}","name":"font-weight-normal"},"font-weight-medium":{"category":"font-weight","type":"font-weight","value":"500","comment":"Font weight for medium weight","originalValue":"{!font-weight-medium}","name":"font-weight-medium"},"font-weight-semibold":{"category":"font-weight","type":"font-weight","value":"600","comment":"Font weight for semibold weight","originalValue":"{!font-weight-semibold}","name":"font-weight-semibold"},"font-weight-bold":{"category":"font-weight","type":"font-weight","value":"700","comment":"Font weight for bold weight","originalValue":"{!font-weight-bold}","name":"font-weight-bold"},"font-weight-extrabold":{"category":"font-weight","type":"font-weight","value":"800","comment":"Font weight for extrabold weight","originalValue":"{!font-weight-extrabold}","name":"font-weight-extrabold"},"line-height-0":{"category":"line-height","type":"number","value":"0","comment":"Constant line-height token for line-height 0","originalValue":"{!line-height-0}","name":"line-height-0"},"line-height-110":{"category":"line-height","type":"number","value":"4rem","comment":"Constant line-height token for line-height 110","originalValue":"{!line-height-110}","name":"line-height-110"},"line-height-90":{"category":"line-height","type":"number","value":"2.5rem","comment":"Constant line-height token for line-height 90","originalValue":"{!line-height-90}","name":"line-height-90"},"line-height-100":{"category":"line-height","type":"number","value":"3.25rem","comment":"Constant line-height token for line-height 100","originalValue":"{!line-height-100}","name":"line-height-100"},"line-height-80":{"category":"line-height","type":"number","value":"2.5rem","comment":"Constant line-height token for line-height 80","originalValue":"{!line-height-80}","name":"line-height-80"},"line-height-70":{"category":"line-height","type":"number","value":"2rem","comment":"Constant line-height token for line-height 70","originalValue":"{!line-height-70}","name":"line-height-70"},"line-height-60":{"category":"line-height","type":"number","value":"1.75rem","comment":"Constant line-height token for line-height 60","originalValue":"{!line-height-60}","name":"line-height-60"},"line-height-50":{"category":"line-height","type":"number","value":"1.75rem","comment":"Constant line-height token for line-height 50","originalValue":"{!line-height-50}","name":"line-height-50"},"line-height-40":{"category":"line-height","type":"number","value":"1.5rem","comment":"Constant line-height token for line-height 40","originalValue":"{!line-height-40}","name":"line-height-40"},"line-height-30":{"category":"line-height","type":"number","value":"1.25rem","comment":"Constant line-height token for line-height 30","originalValue":"{!line-height-30}","name":"line-height-30"},"line-height-20":{"category":"line-height","type":"number","value":"1.25rem","comment":"Constant line-height token for line-height 20","originalValue":"{!line-height-20}","name":"line-height-20"},"line-height-10":{"category":"line-height","type":"number","value":"1rem","comment":"Constant line-height token for line-height 10","originalValue":"{!line-height-10}","name":"line-height-10"},"line-height-05":{"category":"line-height","type":"number","value":"0.75rem","comment":"Constant line-height token for line-height 05","originalValue":"{!line-height-05}","name":"line-height-05"},"line-height-display-30":{"category":"line-height","type":"number","value":"5rem","comment":"Constant line-height token for line-height-display 30","originalValue":"{!line-height-display-30}","name":"line-height-display-30"},"line-height-display-20":{"category":"line-height","type":"number","value":"3.75rem","comment":"Constant line-height token for line-height-display 20","originalValue":"{!line-height-display-20}","name":"line-height-display-20"},"line-height-display-10":{"category":"line-height","type":"number","value":"2.5rem","comment":"Constant line-height token for line-height-display 10","originalValue":"{!line-height-display-10}","name":"line-height-display-10"},"color-brand-highlight":{"type":"color","category":"color","value":"#F22F46","comment":"Twilio brand red","originalValue":"{!amaranth}","name":"color-brand-highlight"},"color-gray-0":{"type":"color","category":"color","value":"#ffffff","comment":"Gray Color 0","originalValue":"{!palette-gray-0}","name":"color-gray-0"},"color-gray-100":{"type":"color","category":"color","value":"#121c2d","comment":"Gray Color 10","originalValue":"{!palette-gray-100}","name":"color-gray-100"},"color-gray-90":{"type":"color","category":"color","value":"#1f304c","comment":"Gray Color 9","originalValue":"{!palette-gray-90}","name":"color-gray-90"},"color-gray-80":{"type":"color","category":"color","value":"#394762","comment":"Gray Color 8","originalValue":"{!palette-gray-80}","name":"color-gray-80"},"color-gray-70":{"type":"color","category":"color","value":"#4b5671","comment":"Gray Color 7","originalValue":"{!palette-gray-70}","name":"color-gray-70"},"color-gray-60":{"type":"color","category":"color","value":"#606b85","comment":"Gray Color 6","originalValue":"{!palette-gray-60}","name":"color-gray-60"},"color-gray-50":{"type":"color","category":"color","value":"#8891aa","comment":"Gray Color 5","originalValue":"{!palette-gray-50}","name":"color-gray-50"},"color-gray-40":{"type":"color","category":"color","value":"#8e96ae","comment":"Gray Color 4","originalValue":"{!palette-gray-40}","name":"color-gray-40"},"color-brand":{"type":"color","category":"color","value":"#001489","comment":"Default branding color","originalValue":"{!palette-blue-80}","name":"color-brand"},"color-gray-30":{"type":"color","category":"color","value":"#cacdd8","comment":"Gray Color 3","originalValue":"{!palette-gray-30}","name":"color-gray-30"},"color-gray-20":{"type":"color","category":"color","value":"#e1e3ea","comment":"Gray Color 2","originalValue":"{!palette-gray-20}","name":"color-gray-20"},"color-gray-10":{"type":"color","category":"color","value":"#f4f4f6","comment":"Gray Color 1","originalValue":"{!palette-gray-10}","name":"color-gray-10"},"size-square-40":{"type":"size","category":"sizing","value":"0.75rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-40}","name":"size-square-40"},"size-icon-80":{"type":"size","category":"sizing","value":"2.5rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-80}","name":"size-icon-80"},"size-base-0":{"type":"size","category":"sizing","value":"0","comment":"Generic sizing token for UI components","originalValue":"{!size-base-0}","name":"size-base-0"},"size-square-30":{"type":"size","category":"sizing","value":"0.5rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-30}","name":"size-square-30"},"size-icon-70":{"type":"size","category":"sizing","value":"2rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-70}","name":"size-icon-70"},"size-square-20":{"type":"size","category":"sizing","value":"0.25rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-20}","name":"size-square-20"},"size-icon-60":{"type":"size","category":"sizing","value":"1.75rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-60}","name":"size-icon-60"},"size-90":{"type":"size","category":"sizing","value":"57.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-90}","name":"size-90"},"size-square-10":{"type":"size","category":"sizing","value":"0.125rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-10}","name":"size-square-10"},"size-120":{"type":"size","category":"sizing","value":"77rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-120}","name":"size-120"},"size-icon-50":{"type":"size","category":"sizing","value":"1.75rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-50}","name":"size-icon-50"},"size-80":{"type":"size","category":"sizing","value":"51rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-80}","name":"size-80"},"size-0":{"type":"size","category":"sizing","value":"0","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-0}","name":"size-0"},"size-110":{"type":"size","category":"sizing","value":"70.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-110}","name":"size-110"},"size-icon-40":{"type":"size","category":"sizing","value":"1.5rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-40}","name":"size-icon-40"},"size-square-190":{"type":"size","category":"sizing","value":"4.5rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-190}","name":"size-square-190"},"size-70":{"type":"size","category":"sizing","value":"44.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-70}","name":"size-70"},"size-100":{"type":"size","category":"sizing","value":"64rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-100}","name":"size-100"},"size-icon-30":{"type":"size","category":"sizing","value":"1.25rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-30}","name":"size-icon-30"},"size-square-180":{"type":"size","category":"sizing","value":"4.25rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-180}","name":"size-square-180"},"size-60":{"type":"size","category":"sizing","value":"38rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-60}","name":"size-60"},"size-icon-20":{"type":"size","category":"sizing","value":"1.25rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-20}","name":"size-icon-20"},"size-square-170":{"type":"size","category":"sizing","value":"4rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-170}","name":"size-square-170"},"size-sidebar-compact":{"type":"size","category":"sizing","value":"4.75rem","comment":"Sizing token for the compact sidebar width.","originalValue":"{!size-sidebar-compact}","name":"size-sidebar-compact"},"size-base-90":{"type":"size","category":"sizing","value":"2.25rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-90}","name":"size-base-90"},"size-icon-10":{"type":"size","category":"sizing","value":"1rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-10}","name":"size-icon-10"},"size-square-25":{"type":"size","category":"sizing","value":"0.375rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-25}","name":"size-square-25"},"size-square-160":{"type":"size","category":"sizing","value":"3.75rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-160}","name":"size-square-160"},"size-50":{"type":"size","category":"sizing","value":"31.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-50}","name":"size-50"},"size-base-80":{"type":"size","category":"sizing","value":"2rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-80}","name":"size-base-80"},"size-icon-110":{"type":"size","category":"sizing","value":"4rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-110}","name":"size-icon-110"},"size-square-150":{"type":"size","category":"sizing","value":"3.5rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-150}","name":"size-square-150"},"size-40":{"type":"size","category":"sizing","value":"25rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-40}","name":"size-40"},"size-base-70":{"type":"size","category":"sizing","value":"1.75rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-70}","name":"size-base-70"},"size-icon-100":{"type":"size","category":"sizing","value":"3.25rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-100}","name":"size-icon-100"},"size-square-140":{"type":"size","category":"sizing","value":"3.25rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-140}","name":"size-square-140"},"size-30":{"type":"size","category":"sizing","value":"18.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-30}","name":"size-30"},"size-base-60":{"type":"size","category":"sizing","value":"1.5rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-60}","name":"size-base-60"},"size-topbar":{"type":"size","category":"sizing","value":"4.75rem","comment":"Sizing token for the minimum topbar height.","originalValue":"{!size-topbar}","name":"size-topbar"},"size-square-130":{"type":"size","category":"sizing","value":"3rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-130}","name":"size-square-130"},"size-20":{"type":"size","category":"sizing","value":"12rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-20}","name":"size-20"},"size-base-50":{"type":"size","category":"sizing","value":"1.25rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-50}","name":"size-base-50"},"size-square-120":{"type":"size","category":"sizing","value":"2.75rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-120}","name":"size-square-120"},"size-10":{"type":"size","category":"sizing","value":"5.5rem","comment":"Generic sizing token for layouts and containers.","originalValue":"{!size-10}","name":"size-10"},"size-base-40":{"type":"size","category":"sizing","value":"1rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-40}","name":"size-base-40"},"size-square-110":{"type":"size","category":"sizing","value":"2.5rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-110}","name":"size-square-110"},"size-square-0":{"type":"size","category":"sizing","value":"0","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-0}","name":"size-square-0"},"size-base-30":{"type":"size","category":"sizing","value":"0.75rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-30}","name":"size-base-30"},"size-icon-05":{"type":"size","category":"sizing","value":"0.75rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-05}","name":"size-icon-05"},"size-square-100":{"type":"size","category":"sizing","value":"2.25rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-100}","name":"size-square-100"},"size-base-20":{"type":"size","category":"sizing","value":"0.5rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-20}","name":"size-base-20"},"size-square-200":{"type":"size","category":"sizing","value":"4.75rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-200}","name":"size-square-200"},"size-base-10":{"type":"size","category":"sizing","value":"0.25rem","comment":"Generic sizing token for UI components","originalValue":"{!size-base-10}","name":"size-base-10"},"size-sidebar":{"type":"size","category":"sizing","value":"15rem","comment":"Sizing token for sidebar width.","originalValue":"{!size-sidebar}","name":"size-sidebar"},"size-square-90":{"type":"size","category":"sizing","value":"2rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-90}","name":"size-square-90"},"size-square-80":{"type":"size","category":"sizing","value":"1.75rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-80}","name":"size-square-80"},"size-square-70":{"type":"size","category":"sizing","value":"1.5rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-70}","name":"size-square-70"},"size-square-60":{"type":"size","category":"sizing","value":"1.25rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-60}","name":"size-square-60"},"size-square-50":{"type":"size","category":"sizing","value":"1rem","comment":"Generic square sizing token scale for UI components.","originalValue":"{!size-square-50}","name":"size-square-50"},"size-icon-90":{"type":"size","category":"sizing","value":"2.5rem","comment":"Maps to line-height tokens 1:1","originalValue":"{!line-height-90}","name":"size-icon-90"},"space-70":{"category":"spacing","type":"size","value":"1.5rem","originalValue":"{!space-70}","name":"space-70"},"space-negative-100":{"category":"spacing","type":"size","value":"-2.25rem","originalValue":"-{!space-100}","name":"space-negative-100"},"space-60":{"category":"spacing","type":"size","value":"1.25rem","originalValue":"{!space-60}","name":"space-60"},"space-negative-200":{"category":"spacing","type":"size","value":"-4.75rem","originalValue":"-{!space-200}","name":"space-negative-200"},"space-190":{"category":"spacing","type":"size","value":"4.5rem","originalValue":"{!space-190}","name":"space-190"},"space-50":{"category":"spacing","type":"size","value":"1rem","originalValue":"{!space-50}","name":"space-50"},"space-290":{"category":"spacing","type":"size","value":"7rem","originalValue":"{!space-290}","name":"space-290"},"space-180":{"category":"spacing","type":"size","value":"4.25rem","originalValue":"{!space-180}","name":"space-180"},"space-40":{"category":"spacing","type":"size","value":"0.75rem","originalValue":"{!space-40}","name":"space-40"},"space-280":{"category":"spacing","type":"size","value":"6.75rem","originalValue":"{!space-280}","name":"space-280"},"space-170":{"category":"spacing","type":"size","value":"4rem","originalValue":"{!space-170}","name":"space-170"},"space-30":{"category":"spacing","type":"size","value":"0.5rem","originalValue":"{!space-30}","name":"space-30"},"space-270":{"category":"spacing","type":"size","value":"6.5rem","originalValue":"{!space-270}","name":"space-270"},"space-160":{"category":"spacing","type":"size","value":"3.75rem","originalValue":"{!space-160}","name":"space-160"},"space-20":{"category":"spacing","type":"size","value":"0.25rem","originalValue":"{!space-20}","name":"space-20"},"space-260":{"category":"spacing","type":"size","value":"6.25rem","originalValue":"{!space-260}","name":"space-260"},"space-150":{"category":"spacing","type":"size","value":"3.5rem","originalValue":"{!space-150}","name":"space-150"},"space-10":{"category":"spacing","type":"size","value":"0.125rem","originalValue":"{!space-10}","name":"space-10"},"space-250":{"category":"spacing","type":"size","value":"6rem","originalValue":"{!space-250}","name":"space-250"},"space-140":{"category":"spacing","type":"size","value":"3.25rem","originalValue":"{!space-140}","name":"space-140"},"space-240":{"category":"spacing","type":"size","value":"5.75rem","originalValue":"{!space-240}","name":"space-240"},"space-130":{"category":"spacing","type":"size","value":"3rem","originalValue":"{!space-130}","name":"space-130"},"space-230":{"category":"spacing","type":"size","value":"5.5rem","originalValue":"{!space-230}","name":"space-230"},"space-120":{"category":"spacing","type":"size","value":"2.75rem","originalValue":"{!space-120}","name":"space-120"},"space-negative-90":{"category":"spacing","type":"size","value":"-2rem","originalValue":"-{!space-90}","name":"space-negative-90"},"space-220":{"category":"spacing","type":"size","value":"5.25rem","originalValue":"{!space-220}","name":"space-220"},"space-110":{"category":"spacing","type":"size","value":"2.5rem","originalValue":"{!space-110}","name":"space-110"},"space-0":{"category":"spacing","type":"size","value":"0","originalValue":"{!space-0}","name":"space-0"},"space-negative-80":{"category":"spacing","type":"size","value":"-1.75rem","originalValue":"-{!space-80}","name":"space-negative-80"},"space-210":{"category":"spacing","type":"size","value":"5rem","originalValue":"{!space-210}","name":"space-210"},"space-100":{"category":"spacing","type":"size","value":"2.25rem","originalValue":"{!space-100}","name":"space-100"},"space-negative-70":{"category":"spacing","type":"size","value":"-1.5rem","originalValue":"-{!space-70}","name":"space-negative-70"},"space-310":{"category":"spacing","type":"size","value":"7.5rem","originalValue":"{!space-310}","name":"space-310"},"space-200":{"category":"spacing","type":"size","value":"4.75rem","originalValue":"{!space-200}","name":"space-200"},"space-negative-60":{"category":"spacing","type":"size","value":"-1.25rem","originalValue":"-{!space-60}","name":"space-negative-60"},"space-300":{"category":"spacing","type":"size","value":"7.25rem","originalValue":"{!space-300}","name":"space-300"},"space-negative-50":{"category":"spacing","type":"size","value":"-1rem","originalValue":"-{!space-50}","name":"space-negative-50"},"space-negative-40":{"category":"spacing","type":"size","value":"-0.75rem","originalValue":"-{!space-40}","name":"space-negative-40"},"space-negative-30":{"category":"spacing","type":"size","value":"-0.5rem","originalValue":"-{!space-30}","name":"space-negative-30"},"space-negative-20":{"category":"spacing","type":"size","value":"-0.25rem","originalValue":"-{!space-20}","name":"space-negative-20"},"space-negative-10":{"category":"spacing","type":"size","value":"-0.125rem","originalValue":"-{!space-10}","name":"space-negative-10"},"space-negative-190":{"category":"spacing","type":"size","value":"-4.5rem","originalValue":"-{!space-190}","name":"space-negative-190"},"space-negative-180":{"category":"spacing","type":"size","value":"-4.25rem","originalValue":"-{!space-180}","name":"space-negative-180"},"space-negative-170":{"category":"spacing","type":"size","value":"-4rem","originalValue":"-{!space-170}","name":"space-negative-170"},"space-negative-160":{"category":"spacing","type":"size","value":"-3.75rem","originalValue":"-{!space-160}","name":"space-negative-160"},"space-negative-150":{"category":"spacing","type":"size","value":"-3.5rem","originalValue":"-{!space-150}","name":"space-negative-150"},"space-negative-140":{"category":"spacing","type":"size","value":"-3.25rem","originalValue":"-{!space-140}","name":"space-negative-140"},"space-negative-130":{"category":"spacing","type":"size","value":"-3rem","originalValue":"-{!space-130}","name":"space-negative-130"},"space-90":{"category":"spacing","type":"size","value":"2rem","originalValue":"{!space-90}","name":"space-90"},"space-negative-120":{"category":"spacing","type":"size","value":"-2.75rem","originalValue":"-{!space-120}","name":"space-negative-120"},"space-80":{"category":"spacing","type":"size","value":"1.75rem","originalValue":"{!space-80}","name":"space-80"},"space-negative-110":{"category":"spacing","type":"size","value":"-2.5rem","originalValue":"-{!space-110}","name":"space-negative-110"},"color-text-link-destructive-weak":{"type":"color","category":"text-color","value":"#f6b1b1","comment":"Weak shade of destructive link text to be used in interactions","originalValue":"{!palette-red-30}","name":"color-text-link-destructive-weak"},"color-text-link-stronger":{"type":"color","category":"text-color","value":"#030b5d","comment":"Stronger shade of link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-blue-90}","name":"color-text-link-stronger"},"color-text-user":{"type":"color","category":"text-color","value":"#121c2d","comment":"Text color for user avatar.","originalValue":"{!palette-gray-100}","name":"color-text-user"},"color-text-icon-new":{"type":"color","category":"text-color","value":"#6d2ed1","comment":"Icon color for indicating a new status.","originalValue":"{!palette-purple-60}","name":"color-text-icon-new"},"color-text-subaccount":{"type":"color","category":"text-color","value":"#543308","comment":"Text color for the subaccount badge","originalValue":"{!palette-yellow-90}","name":"color-text-subaccount"},"color-text-destructive-stronger":{"type":"color","category":"text-color","value":"#4a0b0b","comment":"Stronger shade of destructive text.","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-90}","name":"color-text-destructive-stronger"},"color-text-icon-offline":{"type":"color","category":"text-color","value":"#606b85","comment":"Icon color for indicating a offline status","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-gray-60}","name":"color-text-icon-offline"},"color-text-link-destructive":{"type":"color","category":"text-color","value":"#d61f1f","comment":"Destructive link text","text_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-warning-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-60}","name":"color-text-link-destructive"},"color-text-primary-stronger":{"type":"color","category":"text-color","value":"#030b5d","comment":"Stronger primary text.","originalValue":"{!palette-blue-90}","name":"color-text-primary-stronger"},"color-text-icon-success":{"type":"color","category":"text-color","value":"#0e7c3a","comment":"Icon color for indicating success.","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-success-weakest","color-background-row-striped"],"originalValue":"{!palette-green-70}","name":"color-text-icon-success"},"color-text-warning":{"type":"color","category":"text-color","value":"#8d3118","comment":"Color for warning text.","text_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-orange-80}","name":"color-text-warning"},"color-text-link-destructive-strongest":{"type":"color","category":"text-color","value":"#310c0c","comment":"Strongest shade of destructive link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-100}","name":"color-text-link-destructive-strongest"},"color-text-icon-neutral":{"type":"color","category":"text-color","value":"#001489","comment":"Icon color for being neutral.","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-row-striped"],"originalValue":"{!palette-blue-80}","name":"color-text-icon-neutral"},"color-text-icon-notification":{"type":"color","category":"text-color","value":"#eb5656","comment":"Icon color for notification elements.","originalValue":"{!palette-red-50}","name":"color-text-icon-notification"},"color-text-new":{"type":"color","category":"text-color","value":"#6d2ed1","comment":"Color for text indicating a new status.","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-purple-60}","name":"color-text-new"},"color-text-icon-error":{"type":"color","category":"text-color","value":"#d61f1f","comment":"Icon color for indicating an error.","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-error-weakest","color-background-row-striped"],"originalValue":"{!palette-red-60}","name":"color-text-icon-error"},"color-text-inverse-weak":{"type":"color","category":"text-color","value":"#cacdd8","comment":"Weak inverse text color for dark backgrounds. Must pass AA color contrast with color-background-body-inverse.","text_contrast_pairing":["color-background-body-inverse","color-background-brand"],"originalValue":"{!palette-gray-30}","name":"color-text-inverse-weak"},"color-text-icon-available":{"type":"color","category":"text-color","value":"#0e7c3a","comment":"Icon color for indicating a available status","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-green-70}","name":"color-text-icon-available"},"color-text-link-destructive-stronger":{"type":"color","category":"text-color","value":"#4a0b0b","comment":"Stronger shade of destructive link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-90}","name":"color-text-link-destructive-stronger"},"color-text-icon-brand-inverse":{"type":"color","category":"text-color","value":"#ffffff","comment":"Twilio brand icon color used for the Twilio logo on inverse backgrounds.","text_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-0}","name":"color-text-icon-brand-inverse"},"color-text-destructive":{"type":"color","category":"text-color","value":"#d61f1f","comment":"Destructive text.","text_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-warning-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-60}","name":"color-text-destructive"},"color-text-primary":{"type":"color","category":"text-color","value":"#0263e0","comment":"Primary text.","originalValue":"{!palette-blue-60}","name":"color-text-primary"},"color-text-success":{"type":"color","category":"text-color","value":"#0e7c3a","comment":"Text color for success text.","text_contrast_pairing":["color-background","color-background-body","color-background-success-weakest","color-background-row-striped"],"uicontrol_contrast_pairing":["color-background","color-background-body","color-background-success-weakest","color-background-row-striped"],"originalValue":"{!palette-green-70}","name":"color-text-success"},"color-text-inverse-new":{"type":"color","category":"text-color","value":"#c8aff0","comment":"Inverse color for indicating a new status.","text_contrast_pairing":["color-background-inverse-strong"],"originalValue":"{!palette-purple-30}","name":"color-text-inverse-new"},"color-text-destructive-strongest":{"type":"color","category":"text-color","value":"#310c0c","comment":"Strongest shade of destructive text.","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-100}","name":"color-text-destructive-strongest"},"color-text-weak":{"type":"color","category":"text-color","value":"#606b85","comment":"Weak body text for visual hierarchy.","text_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-gray-60}","name":"color-text-weak"},"color-text-primary-strongest":{"type":"color","category":"text-color","value":"#06033a","comment":"Strongest primary text.","originalValue":"{!palette-blue-100}","name":"color-text-primary-strongest"},"color-text-icon":{"type":"color","category":"text-color","value":"#606b85","comment":"Default icon color.","text_contrast_pairing":["color-background","color-background-body","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"uicontrol_contrast_pairing":["color-background","color-background-strong","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-gray-60}","name":"color-text-icon"},"color-text-link":{"type":"color","category":"text-color","value":"#0263e0","comment":"Link text","text_contrast_pairing":["color-background","color-background-body","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"uicontrol_contrast_pairing":["color-background","color-background-strong","color-background-body","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-blue-60}","name":"color-text-link"},"color-text-icon-brand-highlight":{"type":"color","category":"text-color","value":"#F22F46","comment":"Twilio brand red icon color used for the Twilio logo.","uicontrol_contrast_pairing":["color-background","color-background-body"],"originalValue":"{!amaranth}","name":"color-text-icon-brand-highlight"},"color-text-neutral":{"type":"color","category":"text-color","value":"#001489","comment":"Color for text indicating a neutral status.","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-blue-80}","name":"color-text-neutral"},"color-text-brand":{"type":"color","category":"text-color","value":"#121c2d","comment":"Text color to be used on top of brand accent background colors such as color-background-brand-10 only.","text_contrast_pairing":["color-background-brand-10","color-background-brand-20","color-background-brand-30"],"originalValue":"{!palette-gray-100}","name":"color-text-brand"},"color-text-link-strongest":{"type":"color","category":"text-color","value":"#06033a","comment":"Strongest shade of link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-blue-100}","name":"color-text-link-strongest"},"color-text-error":{"type":"color","category":"text-color","value":"#d61f1f","comment":"Error text for inputs and error misc","text_contrast_pairing":["color-background","color-background-body","color-background-neutral-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-60}","name":"color-text-error"},"color-text-icon-inverse":{"type":"color","category":"text-color","value":"#8891aa","comment":"Default icon color for inverse backgrounds.","text_contrast_pairing":["color-background-body-inverse"],"originalValue":"{!palette-gray-50}","name":"color-text-icon-inverse"},"color-text-error-strong":{"type":"color","category":"text-color","value":"#ad1111","comment":"Strong error text for inputs and error misc","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-70}","name":"color-text-error-strong"},"color-text-icon-unavailable":{"type":"color","category":"text-color","value":"#d61f1f","comment":"Icon color for indicating a unavailable status","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-red-60}","name":"color-text-icon-unavailable"},"color-text-error-weak":{"type":"color","category":"text-color","value":"#eb5656","comment":"Weak error text for inputs and error misc","originalValue":"{!palette-red-50}","name":"color-text-error-weak"},"color-text-decorative-40":{"type":"color","category":"text-color","value":"#6d2ed1","comment":"Text color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or border tokens.","text_contrast_pairing":["color-background","color-background-body","color-background-decorative-40-weakest"],"originalValue":"{!palette-purple-60}","name":"color-text-decorative-40"},"color-text-link-strong":{"type":"color","category":"text-color","value":"#001489","comment":"Strong shade of link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-blue-80}","name":"color-text-link-strong"},"color-text-brand-inverse":{"type":"color","category":"text-color","value":"#FFFFFF","comment":"Text color used on any brand color","text_contrast_pairing":["color-background-body-inverse","color-background-brand"],"originalValue":"{!white}","name":"color-text-brand-inverse"},"color-text-error-strongest":{"type":"color","category":"text-color","value":"#310c0c","comment":"Strongest error text for inputs and error misc.","originalValue":"{!palette-red-100}","name":"color-text-error-strongest"},"color-text-decorative-30":{"type":"color","category":"text-color","value":"#0e7c3a","comment":"Text color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or border tokens.","text_contrast_pairing":["color-background","color-background-body","color-background-decorative-30-weakest"],"originalValue":"{!palette-green-70}","name":"color-text-decorative-30"},"color-text-link-weak":{"type":"color","category":"text-color","value":"#99cdff","comment":"Weak shade of link text to be used in interactions","originalValue":"{!palette-blue-30}","name":"color-text-link-weak"},"color-text-decorative-20":{"type":"color","category":"text-color","value":"#001489","comment":"Text color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or border tokens.","text_contrast_pairing":["color-background","color-background-body","color-background-decorative-20-weakest"],"originalValue":"{!palette-blue-80}","name":"color-text-decorative-20"},"color-text-decorative-10":{"type":"color","category":"text-color","value":"#606b85","comment":"Text color with no semantic meaning, used for decorative purposes only. Should generally be used with matching decorative background and/or border tokens.","text_contrast_pairing":["color-background","color-background-body","color-background-decorative-10-weakest"],"originalValue":"{!palette-gray-60}","name":"color-text-decorative-10"},"color-text":{"type":"color","category":"text-color","value":"#121c2d","comment":"Body text color","text_contrast_pairing":["color-background","color-background-strong","color-background-stronger","color-background-body","color-background-user","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-new","color-background-row-striped","color-background-primary-weak","color-background-primary-weaker","color-background-primary-weakest","color-background-destructive-weak","color-background-destructive-weaker","color-background-destructive-weakest"],"originalValue":"{!palette-gray-100}","name":"color-text"},"color-text-icon-busy":{"type":"color","category":"text-color","value":"#e36a19","comment":"Icon color for indicating a busy status","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-orange-65}","name":"color-text-icon-busy"},"color-text-weakest":{"type":"color","category":"text-color","value":"#ffffff","comment":"Weakest body text for visual hierarchy. Inaccessible unless used on disabled controls.","text_contrast_pairing":["color-background-primary-strong","color-background-primary-stronger","color-background-primary-strongest","color-background-destructive-strong","color-background-destructive-stronger","color-background-destructive-strongest"],"originalValue":"{!palette-gray-0}","name":"color-text-weakest"},"color-text-brand-highlight":{"type":"color","category":"text-color","value":"#F22F46","comment":"Twilio brand red, accessible on large text only.","uicontrol_contrast_pairing":["color-background-body"],"originalValue":"{!amaranth}","name":"color-text-brand-highlight"},"color-text-destructive-strong":{"type":"color","category":"text-color","value":"#ad1111","comment":"Strong shade of destructive text.","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-70}","name":"color-text-destructive-strong"},"color-text-inverse-weaker":{"type":"color","category":"text-color","value":"#8891aa","comment":"Weaker inverse text color for dark backgrounds. Must pass AA color contrast with color-background-body-inverse.","originalValue":"{!palette-gray-50}","name":"color-text-inverse-weaker"},"color-text-primary-strong":{"type":"color","category":"text-color","value":"#001489","comment":"Strong primary text.","originalValue":"{!palette-blue-80}","name":"color-text-primary-strong"},"color-text-primary-weak":{"type":"color","category":"text-color","value":"#99cdff","comment":"Weak primary text.","originalValue":"{!palette-blue-30}","name":"color-text-primary-weak"},"color-text-destructive-weak":{"type":"color","category":"text-color","value":"#f6b1b1","comment":"Weak shade of destructive text.","originalValue":"{!palette-red-30}","name":"color-text-destructive-weak"},"color-text-inverse":{"type":"color","category":"text-color","value":"#ffffff","comment":"Inverse text color for dark backgrounds. Must pass AA color contrast with color-background-body-inverse.","text_contrast_pairing":["color-background-body-inverse","color-background-brand","color-background-error","color-background-primary","color-background-destructive"],"originalValue":"{!palette-gray-0}","name":"color-text-inverse"},"color-text-inverse-weakest":{"type":"color","category":"text-color","value":"#4b5671","comment":"Weakest inverse text color for dark backgrounds. Must pass AA color contrast with color-background-body-inverse.","originalValue":"{!palette-gray-70}","name":"color-text-inverse-weakest"},"color-text-weaker":{"type":"color","category":"text-color","value":"#8e96ae","comment":"Weaker body text for visual hierarchy. Inaccessible unless used on disabled controls.","originalValue":"{!palette-gray-40}","name":"color-text-weaker"},"color-text-warning-strong":{"type":"color","category":"text-color","value":"#8d3118","comment":"Color for dark warning text.","text_contrast_pairing":["color-background","color-background-body","color-background-row-striped","color-background-warning-weakest"],"uicontrol_contrast_pairing":["color-background","color-background-body","color-background-row-striped","color-background-warning-weakest"],"originalValue":"{!palette-orange-80}","name":"color-text-warning-strong"},"color-text-icon-warning":{"type":"color","category":"text-color","value":"#e36a19","comment":"Icon color for indicating a warning.","uicontrol_contrast_pairing":["color-background","color-background-body","color-background-warning-weakest","color-background-row-striped"],"originalValue":"{!palette-orange-65}","name":"color-text-icon-warning"},"color-text-error-stronger":{"type":"color","category":"text-color","value":"#4a0b0b","comment":"Stronger error text for inputs and error misc","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-90}","name":"color-text-error-stronger"},"color-text-link-destructive-strong":{"type":"color","category":"text-color","value":"#ad1111","comment":"Strong shade of destructive link text to be used in interactions","text_contrast_pairing":["color-background","color-background-body","color-background-subaccount","color-background-trial","color-background-neutral-weakest","color-background-success-weakest","color-background-warning-weakest","color-background-error-weakest","color-background-row-striped","color-background-primary-weakest","color-background-destructive-weakest"],"originalValue":"{!palette-red-70}","name":"color-text-link-destructive-strong"},"z-index-0":{"type":"z-index","category":"z-index","value":"0","originalValue":"{!z-index-0}","name":"z-index-0"},"z-index-90":{"type":"z-index","category":"z-index","value":"90","originalValue":"{!z-index-90}","name":"z-index-90"},"z-index-80":{"type":"z-index","category":"z-index","value":"80","originalValue":"{!z-index-80}","name":"z-index-80"},"z-index-70":{"type":"z-index","category":"z-index","value":"70","originalValue":"{!z-index-70}","name":"z-index-70"},"z-index-60":{"type":"z-index","category":"z-index","value":"60","originalValue":"{!z-index-60}","name":"z-index-60"},"z-index-50":{"type":"z-index","category":"z-index","value":"50","originalValue":"{!z-index-50}","name":"z-index-50"},"z-index-40":{"type":"z-index","category":"z-index","value":"40","originalValue":"{!z-index-40}","name":"z-index-40"},"z-index-30":{"type":"z-index","category":"z-index","value":"30","originalValue":"{!z-index-30}","name":"z-index-30"},"z-index-20":{"type":"z-index","category":"z-index","value":"20","originalValue":"{!z-index-20}","name":"z-index-20"},"z-index-10":{"type":"z-index","category":"z-index","value":"10","originalValue":"{!z-index-10}","name":"z-index-10"},"color-scheme":{"type":"string","category":"color-scheme","value":"light","originalValue":"light","name":"color-scheme"}}`), OJe = {
  props: uer
};
var der = Object.create, BJe = Object.defineProperty, fer = Object.getOwnPropertyDescriptor, NJe = Object.getOwnPropertyNames, her = Object.getPrototypeOf, per = Object.prototype.hasOwnProperty, wo = (t, e) => function() {
  return e || (0, t[NJe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, mer = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of NJe(e)) !per.call(t, a) && a !== r && BJe(t, a, { get: () => e[a], enumerable: !(n = fer(e, a)) || n.enumerable });
  return t;
}, ger = (t, e, r) => (r = t != null ? der(her(t)) : {}, mer(!t || !t.__esModule ? BJe(r, "default", { value: t, enumerable: !0 }) : r, t)), ver = wo({ "../../node_modules/lodash/_freeGlobal.js"(t, e) {
  var r = typeof ss == "object" && ss && ss.Object === Object && ss;
  e.exports = r;
} }), yer = wo({ "../../node_modules/lodash/_root.js"(t, e) {
  var r = ver(), n = typeof self == "object" && self && self.Object === Object && self, a = r || n || Function("return this")();
  e.exports = a;
} }), She = wo({ "../../node_modules/lodash/_Symbol.js"(t, e) {
  var r = yer(), n = r.Symbol;
  e.exports = n;
} }), ber = wo({ "../../node_modules/lodash/_arrayMap.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = Array(o); ++i < o; ) s[i] = a(n[i], i, n);
    return s;
  }
  e.exports = r;
} }), xer = wo({ "../../node_modules/lodash/isArray.js"(t, e) {
  var r = Array.isArray;
  e.exports = r;
} }), Cer = wo({ "../../node_modules/lodash/_getRawTag.js"(t, e) {
  var r = She(), n = Object.prototype, a = n.hasOwnProperty, i = n.toString, o = r ? r.toStringTag : void 0;
  function s(l) {
    var c = a.call(l, o), u = l[o];
    try {
      l[o] = void 0;
      var f = !0;
    } catch {
    }
    var h = i.call(l);
    return f && (c ? l[o] = u : delete l[o]), h;
  }
  e.exports = s;
} }), wer = wo({ "../../node_modules/lodash/_objectToString.js"(t, e) {
  var r = Object.prototype, n = r.toString;
  function a(i) {
    return n.call(i);
  }
  e.exports = a;
} }), Ser = wo({ "../../node_modules/lodash/_baseGetTag.js"(t, e) {
  var r = She(), n = Cer(), a = wer(), i = "[object Null]", o = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : i : s && s in Object(c) ? n(c) : a(c);
  }
  e.exports = l;
} }), _er = wo({ "../../node_modules/lodash/isObjectLike.js"(t, e) {
  function r(n) {
    return n != null && typeof n == "object";
  }
  e.exports = r;
} }), ker = wo({ "../../node_modules/lodash/isSymbol.js"(t, e) {
  var r = Ser(), n = _er(), a = "[object Symbol]";
  function i(o) {
    return typeof o == "symbol" || n(o) && r(o) == a;
  }
  e.exports = i;
} }), Aer = wo({ "../../node_modules/lodash/_baseToString.js"(t, e) {
  var r = She(), n = ber(), a = xer(), i = ker(), o = r ? r.prototype : void 0, s = o ? o.toString : void 0;
  function l(c) {
    if (typeof c == "string") return c;
    if (a(c)) return n(c, l) + "";
    if (i(c)) return s ? s.call(c) : "";
    var u = c + "";
    return u == "0" && 1 / c == -1 / 0 ? "-0" : u;
  }
  e.exports = l;
} }), Uz = wo({ "../../node_modules/lodash/toString.js"(t, e) {
  var r = Aer();
  function n(a) {
    return a == null ? "" : r(a);
  }
  e.exports = n;
} }), Ter = wo({ "../../node_modules/lodash/_baseSlice.js"(t, e) {
  function r(n, a, i) {
    var o = -1, s = n.length;
    a < 0 && (a = -a > s ? 0 : s + a), i = i > s ? s : i, i < 0 && (i += s), s = a > i ? 0 : i - a >>> 0, a >>>= 0;
    for (var l = Array(s); ++o < s; ) l[o] = n[o + a];
    return l;
  }
  e.exports = r;
} }), Eer = wo({ "../../node_modules/lodash/_castSlice.js"(t, e) {
  var r = Ter();
  function n(a, i, o) {
    var s = a.length;
    return o = o === void 0 ? s : o, !i && o >= s ? a : r(a, i, o);
  }
  e.exports = n;
} }), $Je = wo({ "../../node_modules/lodash/_hasUnicode.js"(t, e) {
  var r = "\\ud800-\\udfff", n = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", o = n + a + i, s = "\\ufe0e\\ufe0f", l = "\\u200d", c = RegExp("[" + l + r + o + s + "]");
  function u(f) {
    return c.test(f);
  }
  e.exports = u;
} }), Ier = wo({ "../../node_modules/lodash/_asciiToArray.js"(t, e) {
  function r(n) {
    return n.split("");
  }
  e.exports = r;
} }), Mer = wo({ "../../node_modules/lodash/_unicodeToArray.js"(t, e) {
  var r = "\\ud800-\\udfff", n = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", o = n + a + i, s = "\\ufe0e\\ufe0f", l = "[" + r + "]", c = "[" + o + "]", u = "\\ud83c[\\udffb-\\udfff]", f = "(?:" + c + "|" + u + ")", h = "[^" + r + "]", p = "(?:\\ud83c[\\udde6-\\uddff]){2}", g = "[\\ud800-\\udbff][\\udc00-\\udfff]", y = "\\u200d", b = f + "?", w = "[" + s + "]?", _ = "(?:" + y + "(?:" + [h, p, g].join("|") + ")" + w + b + ")*", C = w + b + _, x = "(?:" + [h + c + "?", c, p, g, l].join("|") + ")", S = RegExp(u + "(?=" + u + ")|" + x + C, "g");
  function A(I) {
    return I.match(S) || [];
  }
  e.exports = A;
} }), Per = wo({ "../../node_modules/lodash/_stringToArray.js"(t, e) {
  var r = Ier(), n = $Je(), a = Mer();
  function i(o) {
    return n(o) ? a(o) : r(o);
  }
  e.exports = i;
} }), Rer = wo({ "../../node_modules/lodash/_createCaseFirst.js"(t, e) {
  var r = Eer(), n = $Je(), a = Per(), i = Uz();
  function o(s) {
    return function(l) {
      l = i(l);
      var c = n(l) ? a(l) : void 0, u = c ? c[0] : l.charAt(0), f = c ? r(c, 1).join("") : l.slice(1);
      return u[s]() + f;
    };
  }
  e.exports = o;
} }), Oer = wo({ "../../node_modules/lodash/upperFirst.js"(t, e) {
  var r = Rer(), n = r("toUpperCase");
  e.exports = n;
} }), Ber = wo({ "../../node_modules/lodash/capitalize.js"(t, e) {
  var r = Uz(), n = Oer();
  function a(i) {
    return n(r(i).toLowerCase());
  }
  e.exports = a;
} }), Ner = wo({ "../../node_modules/lodash/_arrayReduce.js"(t, e) {
  function r(n, a, i, o) {
    var s = -1, l = n == null ? 0 : n.length;
    for (o && l && (i = n[++s]); ++s < l; ) i = a(i, n[s], s, n);
    return i;
  }
  e.exports = r;
} }), $er = wo({ "../../node_modules/lodash/_basePropertyOf.js"(t, e) {
  function r(n) {
    return function(a) {
      return n == null ? void 0 : n[a];
    };
  }
  e.exports = r;
} }), Der = wo({ "../../node_modules/lodash/_deburrLetter.js"(t, e) {
  var r = $er(), n = { À: "A", Á: "A", Â: "A", Ã: "A", Ä: "A", Å: "A", à: "a", á: "a", â: "a", ã: "a", ä: "a", å: "a", Ç: "C", ç: "c", Ð: "D", ð: "d", È: "E", É: "E", Ê: "E", Ë: "E", è: "e", é: "e", ê: "e", ë: "e", Ì: "I", Í: "I", Î: "I", Ï: "I", ì: "i", í: "i", î: "i", ï: "i", Ñ: "N", ñ: "n", Ò: "O", Ó: "O", Ô: "O", Õ: "O", Ö: "O", Ø: "O", ò: "o", ó: "o", ô: "o", õ: "o", ö: "o", ø: "o", Ù: "U", Ú: "U", Û: "U", Ü: "U", ù: "u", ú: "u", û: "u", ü: "u", Ý: "Y", ý: "y", ÿ: "y", Æ: "Ae", æ: "ae", Þ: "Th", þ: "th", ß: "ss", Ā: "A", Ă: "A", Ą: "A", ā: "a", ă: "a", ą: "a", Ć: "C", Ĉ: "C", Ċ: "C", Č: "C", ć: "c", ĉ: "c", ċ: "c", č: "c", Ď: "D", Đ: "D", ď: "d", đ: "d", Ē: "E", Ĕ: "E", Ė: "E", Ę: "E", Ě: "E", ē: "e", ĕ: "e", ė: "e", ę: "e", ě: "e", Ĝ: "G", Ğ: "G", Ġ: "G", Ģ: "G", ĝ: "g", ğ: "g", ġ: "g", ģ: "g", Ĥ: "H", Ħ: "H", ĥ: "h", ħ: "h", Ĩ: "I", Ī: "I", Ĭ: "I", Į: "I", İ: "I", ĩ: "i", ī: "i", ĭ: "i", į: "i", ı: "i", Ĵ: "J", ĵ: "j", Ķ: "K", ķ: "k", ĸ: "k", Ĺ: "L", Ļ: "L", Ľ: "L", Ŀ: "L", Ł: "L", ĺ: "l", ļ: "l", ľ: "l", ŀ: "l", ł: "l", Ń: "N", Ņ: "N", Ň: "N", Ŋ: "N", ń: "n", ņ: "n", ň: "n", ŋ: "n", Ō: "O", Ŏ: "O", Ő: "O", ō: "o", ŏ: "o", ő: "o", Ŕ: "R", Ŗ: "R", Ř: "R", ŕ: "r", ŗ: "r", ř: "r", Ś: "S", Ŝ: "S", Ş: "S", Š: "S", ś: "s", ŝ: "s", ş: "s", š: "s", Ţ: "T", Ť: "T", Ŧ: "T", ţ: "t", ť: "t", ŧ: "t", Ũ: "U", Ū: "U", Ŭ: "U", Ů: "U", Ű: "U", Ų: "U", ũ: "u", ū: "u", ŭ: "u", ů: "u", ű: "u", ų: "u", Ŵ: "W", ŵ: "w", Ŷ: "Y", ŷ: "y", Ÿ: "Y", Ź: "Z", Ż: "Z", Ž: "Z", ź: "z", ż: "z", ž: "z", Ĳ: "IJ", ĳ: "ij", Œ: "Oe", œ: "oe", ŉ: "'n", ſ: "s" }, a = r(n);
  e.exports = a;
} }), Ler = wo({ "../../node_modules/lodash/deburr.js"(t, e) {
  var r = Der(), n = Uz(), a = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, i = "\\u0300-\\u036f", o = "\\ufe20-\\ufe2f", s = "\\u20d0-\\u20ff", l = i + o + s, c = "[" + l + "]", u = RegExp(c, "g");
  function f(h) {
    return h = n(h), h && h.replace(a, r).replace(u, "");
  }
  e.exports = f;
} }), jer = wo({ "../../node_modules/lodash/_asciiWords.js"(t, e) {
  var r = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function n(a) {
    return a.match(r) || [];
  }
  e.exports = n;
} }), Fer = wo({ "../../node_modules/lodash/_hasUnicodeWord.js"(t, e) {
  var r = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function n(a) {
    return r.test(a);
  }
  e.exports = n;
} }), zer = wo({ "../../node_modules/lodash/_unicodeWords.js"(t, e) {
  var r = "\\ud800-\\udfff", n = "\\u0300-\\u036f", a = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", o = n + a + i, s = "\\u2700-\\u27bf", l = "a-z\\xdf-\\xf6\\xf8-\\xff", c = "\\xac\\xb1\\xd7\\xf7", u = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", f = "\\u2000-\\u206f", h = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", p = "A-Z\\xc0-\\xd6\\xd8-\\xde", g = "\\ufe0e\\ufe0f", y = c + u + f + h, b = "['’]", w = "[" + y + "]", _ = "[" + o + "]", C = "\\d+", x = "[" + s + "]", S = "[" + l + "]", A = "[^" + r + y + C + s + l + p + "]", I = "\\ud83c[\\udffb-\\udfff]", M = "(?:" + _ + "|" + I + ")", B = "[^" + r + "]", L = "(?:\\ud83c[\\udde6-\\uddff]){2}", N = "[\\ud800-\\udbff][\\udc00-\\udfff]", d = "[" + p + "]", m = "\\u200d", v = "(?:" + S + "|" + A + ")", k = "(?:" + d + "|" + A + ")", O = "(?:" + b + "(?:d|ll|m|re|s|t|ve))?", G = "(?:" + b + "(?:D|LL|M|RE|S|T|VE))?", H = M + "?", j = "[" + g + "]?", F = "(?:" + m + "(?:" + [B, L, N].join("|") + ")" + j + H + ")*", z = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", W = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", U = j + H + F, Z = "(?:" + [x, L, N].join("|") + ")" + U, V = RegExp([d + "?" + S + "+" + O + "(?=" + [w, d, "$"].join("|") + ")", k + "+" + G + "(?=" + [w, d + v, "$"].join("|") + ")", d + "?" + v + "+" + O, d + "+" + G, W, z, C, Z].join("|"), "g");
  function Y(ge) {
    return ge.match(V) || [];
  }
  e.exports = Y;
} }), Ger = wo({ "../../node_modules/lodash/words.js"(t, e) {
  var r = jer(), n = Fer(), a = Uz(), i = zer();
  function o(s, l, c) {
    return s = a(s), l = c ? void 0 : l, l === void 0 ? n(s) ? i(s) : r(s) : s.match(l) || [];
  }
  e.exports = o;
} }), Wer = wo({ "../../node_modules/lodash/_createCompounder.js"(t, e) {
  var r = Ner(), n = Ler(), a = Ger(), i = "['’]", o = RegExp(i, "g");
  function s(l) {
    return function(c) {
      return r(a(n(c).replace(o, "")), l, "");
    };
  }
  e.exports = s;
} }), Her = wo({ "../../node_modules/lodash/camelCase.js"(t, e) {
  var r = Ber(), n = Wer(), a = n(function(i, o, s) {
    return o = o.toLowerCase(), i + (s ? r(o) : o);
  });
  e.exports = a;
} }), sB = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof ss < "u" ? ss : typeof self < "u" ? self : {};
function _he(t, e) {
  return t(e = { exports: {} }, e.exports), e.exports;
}
var Uer = "[object GeneratorFunction]", Ver = /^\[object .+?Constructor\]$/, qer = typeof sB == "object" && sB && sB.Object === Object && sB, Ker = typeof self == "object" && self && self.Object === Object && self, khe = qer || Ker || Function("return this")();
function Zer(t, e) {
  return !!(t && t.length) && function(r, n, a) {
    if (n != n) return function(s, l, c, u) {
      for (var f = s.length, h = c + -1; ++h < f; ) if (l(s[h], h, s)) return h;
      return -1;
    }(r, Jer, a);
    for (var i = a - 1, o = r.length; ++i < o; ) if (r[i] === n) return i;
    return -1;
  }(t, e, 0) > -1;
}
function Jer(t) {
  return t != t;
}
function Yer(t, e) {
  return t.has(e);
}
function DJe(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var I9e, Xer = Array.prototype, Qer = Function.prototype, LJe = Object.prototype, oZ = khe["__core-js_shared__"], M9e = (I9e = /[^.]+$/.exec(oZ && oZ.keys && oZ.keys.IE_PROTO || "")) ? "Symbol(src)_1." + I9e : "", jJe = Qer.toString, Cue = LJe.hasOwnProperty, etr = LJe.toString, ttr = RegExp("^" + jJe.call(Cue).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), rtr = Xer.splice, ntr = Ahe(khe, "Map"), sZ = Ahe(khe, "Set"), Zw = Ahe(Object, "create");
function G3(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function W4(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function b9(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
function i$(t) {
  var e = -1, r = t ? t.length : 0;
  for (this.__data__ = new b9(); ++e < r; ) this.add(t[e]);
}
function lB(t, e) {
  for (var r, n, a = t.length; a--; ) if ((r = t[a][0]) === (n = e) || r != r && n != n) return a;
  return -1;
}
function atr(t) {
  return !(!P9e(t) || (e = t, M9e && M9e in e)) && (function(r) {
    var n = P9e(r) ? etr.call(r) : "";
    return n == "[object Function]" || n == Uer;
  }(t) || function(r) {
    var n = !1;
    if (r != null && typeof r.toString != "function") try {
      n = !!(r + "");
    } catch {
    }
    return n;
  }(t) ? ttr : Ver).test(function(r) {
    if (r != null) {
      try {
        return jJe.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }(t));
  var e;
}
G3.prototype.clear = function() {
  this.__data__ = Zw ? Zw(null) : {};
}, G3.prototype.delete = function(t) {
  return this.has(t) && delete this.__data__[t];
}, G3.prototype.get = function(t) {
  var e = this.__data__;
  if (Zw) {
    var r = e[t];
    return r === "__lodash_hash_undefined__" ? void 0 : r;
  }
  return Cue.call(e, t) ? e[t] : void 0;
}, G3.prototype.has = function(t) {
  var e = this.__data__;
  return Zw ? e[t] !== void 0 : Cue.call(e, t);
}, G3.prototype.set = function(t, e) {
  return this.__data__[t] = Zw && e === void 0 ? "__lodash_hash_undefined__" : e, this;
}, W4.prototype.clear = function() {
  this.__data__ = [];
}, W4.prototype.delete = function(t) {
  var e = this.__data__, r = lB(e, t);
  return !(r < 0) && (r == e.length - 1 ? e.pop() : rtr.call(e, r, 1), !0);
}, W4.prototype.get = function(t) {
  var e = this.__data__, r = lB(e, t);
  return r < 0 ? void 0 : e[r][1];
}, W4.prototype.has = function(t) {
  return lB(this.__data__, t) > -1;
}, W4.prototype.set = function(t, e) {
  var r = this.__data__, n = lB(r, t);
  return n < 0 ? r.push([t, e]) : r[n][1] = e, this;
}, b9.prototype.clear = function() {
  this.__data__ = { hash: new G3(), map: new (ntr || W4)(), string: new G3() };
}, b9.prototype.delete = function(t) {
  return cB(this, t).delete(t);
}, b9.prototype.get = function(t) {
  return cB(this, t).get(t);
}, b9.prototype.has = function(t) {
  return cB(this, t).has(t);
}, b9.prototype.set = function(t, e) {
  return cB(this, t).set(t, e), this;
}, i$.prototype.add = i$.prototype.push = function(t) {
  return this.__data__.set(t, "__lodash_hash_undefined__"), this;
}, i$.prototype.has = function(t) {
  return this.__data__.has(t);
};
var itr = sZ && 1 / DJe(new sZ([, -0]))[1] == 1 / 0 ? function(t) {
  return new sZ(t);
} : function() {
};
function cB(t, e) {
  var r, n, a = t.__data__;
  return ((n = typeof (r = e)) == "string" || n == "number" || n == "symbol" || n == "boolean" ? r !== "__proto__" : r === null) ? a[typeof e == "string" ? "string" : "hash"] : a.map;
}
function Ahe(t, e) {
  var r = function(n, a) {
    return n == null ? void 0 : n[a];
  }(t, e);
  return atr(r) ? r : void 0;
}
function P9e(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
var R9e = function(t) {
  return t && t.length ? function(e, r, n) {
    var a = -1, i = Zer, o = e.length, s = !0, l = [], c = l;
    if (o >= 200) {
      var u = itr(e);
      if (u) return DJe(u);
      s = !1, i = Yer, c = new i$();
    } else c = l;
    e: for (; ++a < o; ) {
      var f = e[a], h = f;
      if (f = f !== 0 ? f : 0, s && h == h) {
        for (var p = c.length; p--; ) if (c[p] === h) continue e;
        l.push(f);
      } else i(c, h, n) || (c !== l && c.push(h), l.push(f));
    }
    return l;
  }(t) : [];
}, uB = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] }, Jw = _he(function(t) {
  var e = Array.prototype.concat, r = Array.prototype.slice, n = t.exports = function(a) {
    for (var i, o = [], s = 0, l = a.length; s < l; s++) {
      var c = a[s];
      (i = c) && typeof i != "string" && (i instanceof Array || Array.isArray(i) || i.length >= 0 && (i.splice instanceof Function || Object.getOwnPropertyDescriptor(i, i.length - 1) && i.constructor.name !== "String")) ? o = e.call(o, r.call(c)) : o.push(c);
    }
    return o;
  };
  n.wrap = function(a) {
    return function() {
      return a(n(arguments));
    };
  };
}), hb = _he(function(t) {
  var e = {};
  for (var r in uB) uB.hasOwnProperty(r) && (e[uB[r]] = r);
  var n = t.exports = { to: {}, get: {} };
  function a(o, s, l) {
    return Math.min(Math.max(s, o), l);
  }
  function i(o) {
    var s = o.toString(16).toUpperCase();
    return s.length < 2 ? "0" + s : s;
  }
  n.get = function(o) {
    var s, l;
    switch (o.substring(0, 3).toLowerCase()) {
      case "hsl":
        s = n.get.hsl(o), l = "hsl";
        break;
      case "hwb":
        s = n.get.hwb(o), l = "hwb";
        break;
      default:
        s = n.get.rgb(o), l = "rgb";
    }
    return s ? { model: l, value: s } : null;
  }, n.get.rgb = function(o) {
    if (!o) return null;
    var s, l, c, u = [0, 0, 0, 1];
    if (s = o.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
      for (c = s[2], s = s[1], l = 0; l < 3; l++) {
        var f = 2 * l;
        u[l] = parseInt(s.slice(f, f + 2), 16);
      }
      c && (u[3] = parseInt(c, 16) / 255);
    } else if (s = o.match(/^#([a-f0-9]{3,4})$/i)) {
      for (c = (s = s[1])[3], l = 0; l < 3; l++) u[l] = parseInt(s[l] + s[l], 16);
      c && (u[3] = parseInt(c + c, 16) / 255);
    } else if (s = o.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/)) {
      for (l = 0; l < 3; l++) u[l] = parseInt(s[l + 1], 0);
      s[4] && (u[3] = parseFloat(s[4]));
    } else {
      if (!(s = o.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/))) return (s = o.match(/(\D+)/)) ? s[1] === "transparent" ? [0, 0, 0, 0] : (u = uB[s[1]]) ? (u[3] = 1, u) : null : null;
      for (l = 0; l < 3; l++) u[l] = Math.round(2.55 * parseFloat(s[l + 1]));
      s[4] && (u[3] = parseFloat(s[4]));
    }
    for (l = 0; l < 3; l++) u[l] = a(u[l], 0, 255);
    return u[3] = a(u[3], 0, 1), u;
  }, n.get.hsl = function(o) {
    if (!o) return null;
    var s = o.match(/^hsla?\(\s*([+-]?(?:\d*\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
    if (s) {
      var l = parseFloat(s[4]);
      return [(parseFloat(s[1]) + 360) % 360, a(parseFloat(s[2]), 0, 100), a(parseFloat(s[3]), 0, 100), a(isNaN(l) ? 1 : l, 0, 1)];
    }
    return null;
  }, n.get.hwb = function(o) {
    if (!o) return null;
    var s = o.match(/^hwb\(\s*([+-]?\d*[\.]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
    if (s) {
      var l = parseFloat(s[4]);
      return [(parseFloat(s[1]) % 360 + 360) % 360, a(parseFloat(s[2]), 0, 100), a(parseFloat(s[3]), 0, 100), a(isNaN(l) ? 1 : l, 0, 1)];
    }
    return null;
  }, n.to.hex = function() {
    var o = Jw(arguments);
    return "#" + i(o[0]) + i(o[1]) + i(o[2]) + (o[3] < 1 ? i(Math.round(255 * o[3])) : "");
  }, n.to.rgb = function() {
    var o = Jw(arguments);
    return o.length < 4 || o[3] === 1 ? "rgb(" + Math.round(o[0]) + ", " + Math.round(o[1]) + ", " + Math.round(o[2]) + ")" : "rgba(" + Math.round(o[0]) + ", " + Math.round(o[1]) + ", " + Math.round(o[2]) + ", " + o[3] + ")";
  }, n.to.rgb.percent = function() {
    var o = Jw(arguments), s = Math.round(o[0] / 255 * 100), l = Math.round(o[1] / 255 * 100), c = Math.round(o[2] / 255 * 100);
    return o.length < 4 || o[3] === 1 ? "rgb(" + s + "%, " + l + "%, " + c + "%)" : "rgba(" + s + "%, " + l + "%, " + c + "%, " + o[3] + ")";
  }, n.to.hsl = function() {
    var o = Jw(arguments);
    return o.length < 4 || o[3] === 1 ? "hsl(" + o[0] + ", " + o[1] + "%, " + o[2] + "%)" : "hsla(" + o[0] + ", " + o[1] + "%, " + o[2] + "%, " + o[3] + ")";
  }, n.to.hwb = function() {
    var o = Jw(arguments), s = "";
    return o.length >= 4 && o[3] !== 1 && (s = ", " + o[3]), "hwb(" + o[0] + ", " + o[1] + "%, " + o[2] + "%" + s + ")";
  }, n.to.keyword = function(o) {
    return e[o.slice(0, 3)];
  };
});
hb.to, hb.get;
var W3 = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] }, Hs = _he(function(t) {
  var e = {};
  for (var r in W3) W3.hasOwnProperty(r) && (e[W3[r]] = r);
  var n = t.exports = { rgb: { channels: 3, labels: "rgb" }, hsl: { channels: 3, labels: "hsl" }, hsv: { channels: 3, labels: "hsv" }, hwb: { channels: 3, labels: "hwb" }, cmyk: { channels: 4, labels: "cmyk" }, xyz: { channels: 3, labels: "xyz" }, lab: { channels: 3, labels: "lab" }, lch: { channels: 3, labels: "lch" }, hex: { channels: 1, labels: ["hex"] }, keyword: { channels: 1, labels: ["keyword"] }, ansi16: { channels: 1, labels: ["ansi16"] }, ansi256: { channels: 1, labels: ["ansi256"] }, hcg: { channels: 3, labels: ["h", "c", "g"] }, apple: { channels: 3, labels: ["r16", "g16", "b16"] }, gray: { channels: 1, labels: ["gray"] } };
  for (var a in n) if (n.hasOwnProperty(a)) {
    if (!("channels" in n[a])) throw new Error("missing channels property: " + a);
    if (!("labels" in n[a])) throw new Error("missing channel labels property: " + a);
    if (n[a].labels.length !== n[a].channels) throw new Error("channel and label counts mismatch: " + a);
    var i = n[a].channels, o = n[a].labels;
    delete n[a].channels, delete n[a].labels, Object.defineProperty(n[a], "channels", { value: i }), Object.defineProperty(n[a], "labels", { value: o });
  }
  n.rgb.hsl = function(s) {
    var l, c, u = s[0] / 255, f = s[1] / 255, h = s[2] / 255, p = Math.min(u, f, h), g = Math.max(u, f, h), y = g - p;
    return g === p ? l = 0 : u === g ? l = (f - h) / y : f === g ? l = 2 + (h - u) / y : h === g && (l = 4 + (u - f) / y), (l = Math.min(60 * l, 360)) < 0 && (l += 360), c = (p + g) / 2, [l, 100 * (g === p ? 0 : c <= 0.5 ? y / (g + p) : y / (2 - g - p)), 100 * c];
  }, n.rgb.hsv = function(s) {
    var l, c, u, f, h, p = s[0] / 255, g = s[1] / 255, y = s[2] / 255, b = Math.max(p, g, y), w = b - Math.min(p, g, y), _ = function(C) {
      return (b - C) / 6 / w + 0.5;
    };
    return w === 0 ? f = h = 0 : (h = w / b, l = _(p), c = _(g), u = _(y), p === b ? f = u - c : g === b ? f = 1 / 3 + l - u : y === b && (f = 2 / 3 + c - l), f < 0 ? f += 1 : f > 1 && (f -= 1)), [360 * f, 100 * h, 100 * b];
  }, n.rgb.hwb = function(s) {
    var l = s[0], c = s[1], u = s[2];
    return [n.rgb.hsl(s)[0], 100 * (1 / 255 * Math.min(l, Math.min(c, u))), 100 * (u = 1 - 1 / 255 * Math.max(l, Math.max(c, u)))];
  }, n.rgb.cmyk = function(s) {
    var l, c = s[0] / 255, u = s[1] / 255, f = s[2] / 255;
    return [100 * ((1 - c - (l = Math.min(1 - c, 1 - u, 1 - f))) / (1 - l) || 0), 100 * ((1 - u - l) / (1 - l) || 0), 100 * ((1 - f - l) / (1 - l) || 0), 100 * l];
  }, n.rgb.keyword = function(s) {
    var l = e[s];
    if (l) return l;
    var c, u, f, h = 1 / 0;
    for (var p in W3) if (W3.hasOwnProperty(p)) {
      var g = W3[p], y = (u = s, f = g, Math.pow(u[0] - f[0], 2) + Math.pow(u[1] - f[1], 2) + Math.pow(u[2] - f[2], 2));
      y < h && (h = y, c = p);
    }
    return c;
  }, n.keyword.rgb = function(s) {
    return W3[s];
  }, n.rgb.xyz = function(s) {
    var l = s[0] / 255, c = s[1] / 255, u = s[2] / 255;
    return [100 * (0.4124 * (l = l > 0.04045 ? Math.pow((l + 0.055) / 1.055, 2.4) : l / 12.92) + 0.3576 * (c = c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92) + 0.1805 * (u = u > 0.04045 ? Math.pow((u + 0.055) / 1.055, 2.4) : u / 12.92)), 100 * (0.2126 * l + 0.7152 * c + 0.0722 * u), 100 * (0.0193 * l + 0.1192 * c + 0.9505 * u)];
  }, n.rgb.lab = function(s) {
    var l = n.rgb.xyz(s), c = l[0], u = l[1], f = l[2];
    return u /= 100, f /= 108.883, c = (c /= 95.047) > 8856e-6 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116, [116 * (u = u > 8856e-6 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116) - 16, 500 * (c - u), 200 * (u - (f = f > 8856e-6 ? Math.pow(f, 1 / 3) : 7.787 * f + 16 / 116))];
  }, n.hsl.rgb = function(s) {
    var l, c, u, f, h, p = s[0] / 360, g = s[1] / 100, y = s[2] / 100;
    if (g === 0) return [h = 255 * y, h, h];
    l = 2 * y - (c = y < 0.5 ? y * (1 + g) : y + g - y * g), f = [0, 0, 0];
    for (var b = 0; b < 3; b++) (u = p + 1 / 3 * -(b - 1)) < 0 && u++, u > 1 && u--, h = 6 * u < 1 ? l + 6 * (c - l) * u : 2 * u < 1 ? c : 3 * u < 2 ? l + (c - l) * (2 / 3 - u) * 6 : l, f[b] = 255 * h;
    return f;
  }, n.hsl.hsv = function(s) {
    var l = s[0], c = s[1] / 100, u = s[2] / 100, f = c, h = Math.max(u, 0.01);
    return c *= (u *= 2) <= 1 ? u : 2 - u, f *= h <= 1 ? h : 2 - h, [l, 100 * (u === 0 ? 2 * f / (h + f) : 2 * c / (u + c)), 100 * ((u + c) / 2)];
  }, n.hsv.rgb = function(s) {
    var l = s[0] / 60, c = s[1] / 100, u = s[2] / 100, f = Math.floor(l) % 6, h = l - Math.floor(l), p = 255 * u * (1 - c), g = 255 * u * (1 - c * h), y = 255 * u * (1 - c * (1 - h));
    switch (u *= 255, f) {
      case 0:
        return [u, y, p];
      case 1:
        return [g, u, p];
      case 2:
        return [p, u, y];
      case 3:
        return [p, g, u];
      case 4:
        return [y, p, u];
      case 5:
        return [u, p, g];
    }
  }, n.hsv.hsl = function(s) {
    var l, c, u, f = s[0], h = s[1] / 100, p = s[2] / 100, g = Math.max(p, 0.01);
    return u = (2 - h) * p, c = h * g, [f, 100 * (c = (c /= (l = (2 - h) * g) <= 1 ? l : 2 - l) || 0), 100 * (u /= 2)];
  }, n.hwb.rgb = function(s) {
    var l, c, u, f, h, p, g, y = s[0] / 360, b = s[1] / 100, w = s[2] / 100, _ = b + w;
    switch (_ > 1 && (b /= _, w /= _), u = 6 * y - (l = Math.floor(6 * y)), 1 & l && (u = 1 - u), f = b + u * ((c = 1 - w) - b), l) {
      default:
      case 6:
      case 0:
        h = c, p = f, g = b;
        break;
      case 1:
        h = f, p = c, g = b;
        break;
      case 2:
        h = b, p = c, g = f;
        break;
      case 3:
        h = b, p = f, g = c;
        break;
      case 4:
        h = f, p = b, g = c;
        break;
      case 5:
        h = c, p = b, g = f;
    }
    return [255 * h, 255 * p, 255 * g];
  }, n.cmyk.rgb = function(s) {
    var l = s[0] / 100, c = s[1] / 100, u = s[2] / 100, f = s[3] / 100;
    return [255 * (1 - Math.min(1, l * (1 - f) + f)), 255 * (1 - Math.min(1, c * (1 - f) + f)), 255 * (1 - Math.min(1, u * (1 - f) + f))];
  }, n.xyz.rgb = function(s) {
    var l, c, u, f = s[0] / 100, h = s[1] / 100, p = s[2] / 100;
    return c = -0.9689 * f + 1.8758 * h + 0.0415 * p, u = 0.0557 * f + -0.204 * h + 1.057 * p, l = (l = 3.2406 * f + -1.5372 * h + -0.4986 * p) > 31308e-7 ? 1.055 * Math.pow(l, 1 / 2.4) - 0.055 : 12.92 * l, c = c > 31308e-7 ? 1.055 * Math.pow(c, 1 / 2.4) - 0.055 : 12.92 * c, u = u > 31308e-7 ? 1.055 * Math.pow(u, 1 / 2.4) - 0.055 : 12.92 * u, [255 * (l = Math.min(Math.max(0, l), 1)), 255 * (c = Math.min(Math.max(0, c), 1)), 255 * (u = Math.min(Math.max(0, u), 1))];
  }, n.xyz.lab = function(s) {
    var l = s[0], c = s[1], u = s[2];
    return c /= 100, u /= 108.883, l = (l /= 95.047) > 8856e-6 ? Math.pow(l, 1 / 3) : 7.787 * l + 16 / 116, [116 * (c = c > 8856e-6 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116) - 16, 500 * (l - c), 200 * (c - (u = u > 8856e-6 ? Math.pow(u, 1 / 3) : 7.787 * u + 16 / 116))];
  }, n.lab.xyz = function(s) {
    var l, c, u, f = s[0];
    l = s[1] / 500 + (c = (f + 16) / 116), u = c - s[2] / 200;
    var h = Math.pow(c, 3), p = Math.pow(l, 3), g = Math.pow(u, 3);
    return c = h > 8856e-6 ? h : (c - 16 / 116) / 7.787, l = p > 8856e-6 ? p : (l - 16 / 116) / 7.787, u = g > 8856e-6 ? g : (u - 16 / 116) / 7.787, [l *= 95.047, c *= 100, u *= 108.883];
  }, n.lab.lch = function(s) {
    var l, c = s[0], u = s[1], f = s[2];
    return (l = 360 * Math.atan2(f, u) / 2 / Math.PI) < 0 && (l += 360), [c, Math.sqrt(u * u + f * f), l];
  }, n.lch.lab = function(s) {
    var l, c = s[0], u = s[1];
    return l = s[2] / 360 * 2 * Math.PI, [c, u * Math.cos(l), u * Math.sin(l)];
  }, n.rgb.ansi16 = function(s) {
    var l = s[0], c = s[1], u = s[2], f = 1 in arguments ? arguments[1] : n.rgb.hsv(s)[2];
    if ((f = Math.round(f / 50)) === 0) return 30;
    var h = 30 + (Math.round(u / 255) << 2 | Math.round(c / 255) << 1 | Math.round(l / 255));
    return f === 2 && (h += 60), h;
  }, n.hsv.ansi16 = function(s) {
    return n.rgb.ansi16(n.hsv.rgb(s), s[2]);
  }, n.rgb.ansi256 = function(s) {
    var l = s[0], c = s[1], u = s[2];
    return l === c && c === u ? l < 8 ? 16 : l > 248 ? 231 : Math.round((l - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(l / 255 * 5) + 6 * Math.round(c / 255 * 5) + Math.round(u / 255 * 5);
  }, n.ansi16.rgb = function(s) {
    var l = s % 10;
    if (l === 0 || l === 7) return s > 50 && (l += 3.5), [l = l / 10.5 * 255, l, l];
    var c = 0.5 * (1 + ~~(s > 50));
    return [(1 & l) * c * 255, (l >> 1 & 1) * c * 255, (l >> 2 & 1) * c * 255];
  }, n.ansi256.rgb = function(s) {
    if (s >= 232) {
      var l = 10 * (s - 232) + 8;
      return [l, l, l];
    }
    var c;
    return s -= 16, [Math.floor(s / 36) / 5 * 255, Math.floor((c = s % 36) / 6) / 5 * 255, c % 6 / 5 * 255];
  }, n.rgb.hex = function(s) {
    var l = (((255 & Math.round(s[0])) << 16) + ((255 & Math.round(s[1])) << 8) + (255 & Math.round(s[2]))).toString(16).toUpperCase();
    return "000000".substring(l.length) + l;
  }, n.hex.rgb = function(s) {
    var l = s.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!l) return [0, 0, 0];
    var c = l[0];
    l[0].length === 3 && (c = c.split("").map(function(f) {
      return f + f;
    }).join(""));
    var u = parseInt(c, 16);
    return [u >> 16 & 255, u >> 8 & 255, 255 & u];
  }, n.rgb.hcg = function(s) {
    var l, c = s[0] / 255, u = s[1] / 255, f = s[2] / 255, h = Math.max(Math.max(c, u), f), p = Math.min(Math.min(c, u), f), g = h - p;
    return l = g <= 0 ? 0 : h === c ? (u - f) / g % 6 : h === u ? 2 + (f - c) / g : 4 + (c - u) / g + 4, l /= 6, [360 * (l %= 1), 100 * g, 100 * (g < 1 ? p / (1 - g) : 0)];
  }, n.hsl.hcg = function(s) {
    var l = s[1] / 100, c = s[2] / 100, u = 1, f = 0;
    return (u = c < 0.5 ? 2 * l * c : 2 * l * (1 - c)) < 1 && (f = (c - 0.5 * u) / (1 - u)), [s[0], 100 * u, 100 * f];
  }, n.hsv.hcg = function(s) {
    var l = s[1] / 100, c = s[2] / 100, u = l * c, f = 0;
    return u < 1 && (f = (c - u) / (1 - u)), [s[0], 100 * u, 100 * f];
  }, n.hcg.rgb = function(s) {
    var l = s[0] / 360, c = s[1] / 100, u = s[2] / 100;
    if (c === 0) return [255 * u, 255 * u, 255 * u];
    var f, h = [0, 0, 0], p = l % 1 * 6, g = p % 1, y = 1 - g;
    switch (Math.floor(p)) {
      case 0:
        h[0] = 1, h[1] = g, h[2] = 0;
        break;
      case 1:
        h[0] = y, h[1] = 1, h[2] = 0;
        break;
      case 2:
        h[0] = 0, h[1] = 1, h[2] = g;
        break;
      case 3:
        h[0] = 0, h[1] = y, h[2] = 1;
        break;
      case 4:
        h[0] = g, h[1] = 0, h[2] = 1;
        break;
      default:
        h[0] = 1, h[1] = 0, h[2] = y;
    }
    return f = (1 - c) * u, [255 * (c * h[0] + f), 255 * (c * h[1] + f), 255 * (c * h[2] + f)];
  }, n.hcg.hsv = function(s) {
    var l = s[1] / 100, c = l + s[2] / 100 * (1 - l), u = 0;
    return c > 0 && (u = l / c), [s[0], 100 * u, 100 * c];
  }, n.hcg.hsl = function(s) {
    var l = s[1] / 100, c = s[2] / 100 * (1 - l) + 0.5 * l, u = 0;
    return c > 0 && c < 0.5 ? u = l / (2 * c) : c >= 0.5 && c < 1 && (u = l / (2 * (1 - c))), [s[0], 100 * u, 100 * c];
  }, n.hcg.hwb = function(s) {
    var l = s[1] / 100, c = l + s[2] / 100 * (1 - l);
    return [s[0], 100 * (c - l), 100 * (1 - c)];
  }, n.hwb.hcg = function(s) {
    var l = s[1] / 100, c = 1 - s[2] / 100, u = c - l, f = 0;
    return u < 1 && (f = (c - u) / (1 - u)), [s[0], 100 * u, 100 * f];
  }, n.apple.rgb = function(s) {
    return [s[0] / 65535 * 255, s[1] / 65535 * 255, s[2] / 65535 * 255];
  }, n.rgb.apple = function(s) {
    return [s[0] / 255 * 65535, s[1] / 255 * 65535, s[2] / 255 * 65535];
  }, n.gray.rgb = function(s) {
    return [s[0] / 100 * 255, s[0] / 100 * 255, s[0] / 100 * 255];
  }, n.gray.hsl = n.gray.hsv = function(s) {
    return [0, 0, s[0]];
  }, n.gray.hwb = function(s) {
    return [0, 100, s[0]];
  }, n.gray.cmyk = function(s) {
    return [0, 0, 0, s[0]];
  }, n.gray.lab = function(s) {
    return [s[0], 0, 0];
  }, n.gray.hex = function(s) {
    var l = 255 & Math.round(s[0] / 100 * 255), c = ((l << 16) + (l << 8) + l).toString(16).toUpperCase();
    return "000000".substring(c.length) + c;
  }, n.rgb.gray = function(s) {
    return [(s[0] + s[1] + s[2]) / 3 / 255 * 100];
  };
});
function otr(t) {
  var e = function() {
    for (var c = {}, u = Object.keys(Hs), f = u.length, h = 0; h < f; h++) c[u[h]] = { distance: -1, parent: null };
    return c;
  }(), r = [t];
  for (e[t].distance = 0; r.length; ) for (var n = r.pop(), a = Object.keys(Hs[n]), i = a.length, o = 0; o < i; o++) {
    var s = a[o], l = e[s];
    l.distance === -1 && (l.distance = e[n].distance + 1, l.parent = n, r.unshift(s));
  }
  return e;
}
function str(t, e) {
  return function(r) {
    return e(t(r));
  };
}
function ltr(t, e) {
  for (var r = [e[t].parent, t], n = Hs[e[t].parent][t], a = e[t].parent; e[a].parent; ) r.unshift(e[a].parent), n = str(Hs[e[a].parent][a], n), a = e[a].parent;
  return n.conversion = r, n;
}
Hs.rgb, Hs.hsl, Hs.hsv, Hs.hwb, Hs.cmyk, Hs.xyz, Hs.lab, Hs.lch, Hs.hex, Hs.keyword, Hs.ansi16, Hs.ansi256, Hs.hcg, Hs.apple, Hs.gray;
var x9 = {};
Object.keys(Hs).forEach(function(t) {
  x9[t] = {}, Object.defineProperty(x9[t], "channels", { value: Hs[t].channels }), Object.defineProperty(x9[t], "labels", { value: Hs[t].labels });
  var e = function(r) {
    for (var n = otr(r), a = {}, i = Object.keys(n), o = i.length, s = 0; s < o; s++) {
      var l = i[s];
      n[l].parent !== null && (a[l] = ltr(l, n));
    }
    return a;
  }(t);
  Object.keys(e).forEach(function(r) {
    var n = e[r];
    x9[t][r] = function(a) {
      var i = function(o) {
        if (o == null) return o;
        arguments.length > 1 && (o = Array.prototype.slice.call(arguments));
        var s = a(o);
        if (typeof s == "object") for (var l = s.length, c = 0; c < l; c++) s[c] = Math.round(s[c]);
        return s;
      };
      return "conversion" in a && (i.conversion = a.conversion), i;
    }(n), x9[t][r].raw = function(a) {
      var i = function(o) {
        return o == null ? o : (arguments.length > 1 && (o = Array.prototype.slice.call(arguments)), a(o));
      };
      return "conversion" in a && (i.conversion = a.conversion), i;
    }(n);
  });
});
var Xd = x9, The = [].slice, FJe = ["keyword", "gray", "hex"], wue = {};
Object.keys(Xd).forEach(function(t) {
  wue[The.call(Xd[t].labels).sort().join("")] = t;
});
var xL = {};
function yc(t, e) {
  if (!(this instanceof yc)) return new yc(t, e);
  if (e && e in FJe && (e = null), e && !(e in Xd)) throw new Error("Unknown model: " + e);
  var r, n;
  if (t == null) this.model = "rgb", this.color = [0, 0, 0], this.valpha = 1;
  else if (t instanceof yc) this.model = t.model, this.color = t.color.slice(), this.valpha = t.valpha;
  else if (typeof t == "string") {
    var a = hb.get(t);
    if (a === null) throw new Error("Unable to parse color from string: " + t);
    this.model = a.model, n = Xd[this.model].channels, this.color = a.value.slice(0, n), this.valpha = typeof a.value[n] == "number" ? a.value[n] : 1;
  } else if (t.length) {
    this.model = e || "rgb", n = Xd[this.model].channels;
    var i = The.call(t, 0, n);
    this.color = Sue(i, n), this.valpha = typeof t[n] == "number" ? t[n] : 1;
  } else if (typeof t == "number") t &= 16777215, this.model = "rgb", this.color = [t >> 16 & 255, t >> 8 & 255, 255 & t], this.valpha = 1;
  else {
    this.valpha = 1;
    var o = Object.keys(t);
    "alpha" in t && (o.splice(o.indexOf("alpha"), 1), this.valpha = typeof t.alpha == "number" ? t.alpha : 0);
    var s = o.sort().join("");
    if (!(s in wue)) throw new Error("Unable to parse color from object: " + JSON.stringify(t));
    this.model = wue[s];
    var l = Xd[this.model].labels, c = [];
    for (r = 0; r < l.length; r++) c.push(t[l[r]]);
    this.color = Sue(c);
  }
  if (xL[this.model]) for (n = Xd[this.model].channels, r = 0; r < n; r++) {
    var u = xL[this.model][r];
    u && (this.color[r] = u(this.color[r]));
  }
  this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}
function Ws(t, e, r) {
  return (t = Array.isArray(t) ? t : [t]).forEach(function(n) {
    (xL[n] || (xL[n] = []))[e] = r;
  }), t = t[0], function(n) {
    var a;
    return arguments.length ? (r && (n = r(n)), (a = this[t]()).color[e] = n, a) : (a = this[t]().color[e], r && (a = r(a)), a);
  };
}
function Ll(t) {
  return function(e) {
    return Math.max(0, Math.min(t, e));
  };
}
function ctr(t) {
  return Array.isArray(t) ? t : [t];
}
function Sue(t, e) {
  for (var r = 0; r < e; r++) typeof t[r] != "number" && (t[r] = 0);
  return t;
}
yc.prototype = { toString: function() {
  return this.string();
}, toJSON: function() {
  return this[this.model]();
}, string: function(t) {
  var e = this.model in hb.to ? this : this.rgb(), r = (e = e.round(typeof t == "number" ? t : 1)).valpha === 1 ? e.color : e.color.concat(this.valpha);
  return hb.to[e.model](r);
}, percentString: function(t) {
  var e = this.rgb().round(typeof t == "number" ? t : 1), r = e.valpha === 1 ? e.color : e.color.concat(this.valpha);
  return hb.to.rgb.percent(r);
}, array: function() {
  return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
}, object: function() {
  for (var t = {}, e = Xd[this.model].channels, r = Xd[this.model].labels, n = 0; n < e; n++) t[r[n]] = this.color[n];
  return this.valpha !== 1 && (t.alpha = this.valpha), t;
}, unitArray: function() {
  var t = this.rgb().color;
  return t[0] /= 255, t[1] /= 255, t[2] /= 255, this.valpha !== 1 && t.push(this.valpha), t;
}, unitObject: function() {
  var t = this.rgb().object();
  return t.r /= 255, t.g /= 255, t.b /= 255, this.valpha !== 1 && (t.alpha = this.valpha), t;
}, round: function(t) {
  return t = Math.max(t || 0, 0), new yc(this.color.map(/* @__PURE__ */ function(e) {
    return function(r) {
      return function(n, a) {
        return Number(n.toFixed(a));
      }(r, e);
    };
  }(t)).concat(this.valpha), this.model);
}, alpha: function(t) {
  return arguments.length ? new yc(this.color.concat(Math.max(0, Math.min(1, t))), this.model) : this.valpha;
}, red: Ws("rgb", 0, Ll(255)), green: Ws("rgb", 1, Ll(255)), blue: Ws("rgb", 2, Ll(255)), hue: Ws(["hsl", "hsv", "hsl", "hwb", "hcg"], 0, function(t) {
  return (t % 360 + 360) % 360;
}), saturationl: Ws("hsl", 1, Ll(100)), lightness: Ws("hsl", 2, Ll(100)), saturationv: Ws("hsv", 1, Ll(100)), value: Ws("hsv", 2, Ll(100)), chroma: Ws("hcg", 1, Ll(100)), gray: Ws("hcg", 2, Ll(100)), white: Ws("hwb", 1, Ll(100)), wblack: Ws("hwb", 2, Ll(100)), cyan: Ws("cmyk", 0, Ll(100)), magenta: Ws("cmyk", 1, Ll(100)), yellow: Ws("cmyk", 2, Ll(100)), black: Ws("cmyk", 3, Ll(100)), x: Ws("xyz", 0, Ll(100)), y: Ws("xyz", 1, Ll(100)), z: Ws("xyz", 2, Ll(100)), l: Ws("lab", 0, Ll(100)), a: Ws("lab", 1), b: Ws("lab", 2), keyword: function(t) {
  return arguments.length ? new yc(t) : Xd[this.model].keyword(this.color);
}, hex: function(t) {
  return arguments.length ? new yc(t) : hb.to.hex(this.rgb().round().color);
}, rgbNumber: function() {
  var t = this.rgb().color;
  return (255 & t[0]) << 16 | (255 & t[1]) << 8 | 255 & t[2];
}, luminosity: function() {
  for (var t = this.rgb().color, e = [], r = 0; r < t.length; r++) {
    var n = t[r] / 255;
    e[r] = n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }
  return 0.2126 * e[0] + 0.7152 * e[1] + 0.0722 * e[2];
}, contrast: function(t) {
  var e = this.luminosity(), r = t.luminosity();
  return e > r ? (e + 0.05) / (r + 0.05) : (r + 0.05) / (e + 0.05);
}, level: function(t) {
  var e = this.contrast(t);
  return e >= 7.1 ? "AAA" : e >= 4.5 ? "AA" : "";
}, isDark: function() {
  var t = this.rgb().color;
  return (299 * t[0] + 587 * t[1] + 114 * t[2]) / 1e3 < 128;
}, isLight: function() {
  return !this.isDark();
}, negate: function() {
  for (var t = this.rgb(), e = 0; e < 3; e++) t.color[e] = 255 - t.color[e];
  return t;
}, lighten: function(t) {
  var e = this.hsl();
  return e.color[2] += e.color[2] * t, e;
}, darken: function(t) {
  var e = this.hsl();
  return e.color[2] -= e.color[2] * t, e;
}, saturate: function(t) {
  var e = this.hsl();
  return e.color[1] += e.color[1] * t, e;
}, desaturate: function(t) {
  var e = this.hsl();
  return e.color[1] -= e.color[1] * t, e;
}, whiten: function(t) {
  var e = this.hwb();
  return e.color[1] += e.color[1] * t, e;
}, blacken: function(t) {
  var e = this.hwb();
  return e.color[2] += e.color[2] * t, e;
}, grayscale: function() {
  var t = this.rgb().color, e = 0.3 * t[0] + 0.59 * t[1] + 0.11 * t[2];
  return yc.rgb(e, e, e);
}, fade: function(t) {
  return this.alpha(this.valpha - this.valpha * t);
}, opaquer: function(t) {
  return this.alpha(this.valpha + this.valpha * t);
}, rotate: function(t) {
  var e = this.hsl(), r = e.color[0];
  return r = (r = (r + t) % 360) < 0 ? 360 + r : r, e.color[0] = r, e;
}, mix: function(t, e) {
  if (!t || !t.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof t);
  var r = t.rgb(), n = this.rgb(), a = e === void 0 ? 0.5 : e, i = 2 * a - 1, o = r.alpha() - n.alpha(), s = ((i * o == -1 ? i : (i + o) / (1 + i * o)) + 1) / 2, l = 1 - s;
  return yc.rgb(s * r.red() + l * n.red(), s * r.green() + l * n.green(), s * r.blue() + l * n.blue(), r.alpha() * a + n.alpha() * (1 - a));
} }, Object.keys(Xd).forEach(function(t) {
  if (FJe.indexOf(t) === -1) {
    var e = Xd[t].channels;
    yc.prototype[t] = function() {
      if (this.model === t) return new yc(this);
      if (arguments.length) return new yc(arguments, t);
      var r = typeof arguments[e] == "number" ? e : this.valpha;
      return new yc(ctr(Xd[this.model][t].raw(this.color)).concat(r), t);
    }, yc[t] = function(r) {
      return typeof r == "number" && (r = Sue(The.call(arguments), e)), new yc(r, t);
    };
  }
});
var O9e = yc;
function utr(t, e) {
  e === void 0 && (e = {});
  var r = [], n = 4.5, a = 3, i = 7, o = 4.5, s = Object.assign({ threshold: 0, compact: !1, uniq: !0 }, e);
  if (Array.isArray(t)) {
    var l = t;
    s.uniq && (l = R9e(t)), l !== void 0 && (r = l.map(function(c) {
      return O9e(c);
    }));
  } else {
    if (typeof t != "object") return console.error("Must provide an array or object"), !1;
    r = Object.keys(t).map(function(c) {
      return O9e(t[c]);
    }), s.uniq && (r = R9e(r));
  }
  return r.map(function(c) {
    var u = s.compact ? { hex: "", combinations: [] } : { color: c.color, model: c.model, valpha: c.valpha, hex: "", combinations: [] };
    return u.hex = c.hex(), u.combinations = r.filter(function(f) {
      return c !== f;
    }).filter(function(f) {
      return s.threshold === void 0 || c.contrast(f) > s.threshold;
    }).map(function(f) {
      var h = s.compact ? { accessibility: { aa: !1, aaLarge: !1, aaa: !1, aaaLarge: !1 }, hex: "", contrast: 0 } : { accessibility: { aa: !1, aaLarge: !1, aaa: !1, aaaLarge: !1 }, hex: "", contrast: 0, color: f.color, model: f.model, valpha: f.valpha };
      return (h = Object.assign(h, { hex: f.hex(), contrast: c.contrast(f) })).accessibility = { aa: h.contrast >= n, aaLarge: h.contrast >= a, aaa: h.contrast >= i, aaaLarge: h.contrast >= o }, h;
    }), u;
  });
}
var B9e = ger(Her()), dtr = (t) => t.filter((e) => !e.aa).length, ftr = (t) => t.filter((e) => !e.aaLarge).length, zJe = (t) => {
  let e = {};
  return Object.values(t).forEach((r) => {
    e = { ...e, ...r };
  }), e;
}, GJe = (t) => Object.keys(t).reduce((e, r) => [t[r], ...e], []), htr = (t) => GJe(t).filter((e) => e.type === "color" && e.text_contrast_pairing != null), ptr = (t) => GJe(t).filter((e) => e.type === "color" && e.uicontrol_contrast_pairing != null), WJe = (t, e, r) => t.reduce((n, a) => {
  let i = a[r];
  if (i !== void 0) {
    let o = i.map((s) => {
      let l = (0, B9e.default)(a.name), c = e[l], u = (0, B9e.default)(s), f = e[u], h = { aa: !1, aaLarge: !1, aaa: !1, aaaLarge: !1 }, p = 0, g = !1;
      return c != null && f != null && (g = utr([c, f])), g !== !1 && g[0].combinations[0] !== void 0 && (h = g[0].combinations[0].accessibility, p = g[0].combinations[0].contrast), { foreground: a.name, foregroundValue: c, background: s, backgroundValue: f, contrast: p, ...h };
    }).filter((s) => !(s.foregroundValue === void 0 || s.backgroundValue === void 0));
    return [...n, ...o];
  }
  return n;
}, []), mtr = (t) => {
  let e = OJe.props, r = htr(e), n = zJe(t);
  return WJe(r, n, "text_contrast_pairing");
}, gtr = (t) => {
  let e = OJe.props, r = ptr(e), n = zJe(t);
  return WJe(r, n, "uicontrol_contrast_pairing");
}, HJe = ({ children: t, ...e }) => {
  if (t == null || typeof t != "function") throw new Error("[ThemeConsumer]: You must pass a function as children");
  return P.createElement(P2e.Consumer, null, (r) => t({ ...e, theme: r }));
};
HJe.displayName = "PasteThemeConsumer";
var fv = { DEFAULT: "default", SENDGRID: "sendgrid", DARK: "dark", TWILIO: "twilio", TWILIO_DARK: "twilio-dark", EVERGREEN: "evergreen" }, Ehe = us({ color: "colorText", colorScheme: "colorScheme", fontSize: "fontSize30", fontFamily: "fontFamilyText", lineHeight: "lineHeight30", fontWeight: "fontWeightNormal", fontVariantNumeric: "tabular-nums" }), _ue = M2e`
/* -------------------------------------------------------
Variable font.
*/
@font-face {
  font-family: 'Inter var';
  font-weight: 100 900;
  font-display: swap;
  font-style: normal;
  font-named-instance: 'Regular';
  src: url("https://assets.twilio.com/public_assets/paste-fonts/1.5.2/Inter-roman.var.woff2?v=3.19") format("woff2");
}
@font-face {
  font-family: 'Inter var';
  font-weight: 100 900;
  font-display: swap;
  font-style: italic;
  font-named-instance: 'Italic';
  src: url("https://assets.twilio.com/public_assets/paste-fonts/1.5.2/Inter-italic.var.woff2?v=3.19") format("woff2");
}
/* --------------------------------------------------------------------------
[EXPERIMENTAL] Multi-axis, single variable font.

Slant axis is not yet widely supported (as of February 2019) and thus this
multi-axis single variable font is opt-in rather than the default.

When using this, you will probably need to set font-variation-settings
explicitly, e.g.

  * { font-variation-settings: "slnt" 0deg }
  .italic { font-variation-settings: "slnt" 10deg }

*/
@font-face {
  font-family: 'Inter var experimental';
  font-weight: 100 900;
  font-display: swap;
  font-style: oblique 0deg 8deg;
  src: url("https://assets.twilio.com/public_assets/paste-fonts/1.5.2/Inter.var.woff2?v=3.19") format("woff2");
}

/*
Twilio Sans Mono
*/
@font-face {
  font-family: 'TwilioSansMono';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Regular.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Regular.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansMono';
  font-style: italic;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-RegularItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-RegularItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansMono';
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Bold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Bold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansMono';
  font-style: italic;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-BoldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-BoldItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansMono';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Medium.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-Medium.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansMono';
  font-style: italic;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-MediumItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansMono-MediumItl.woff') format('woff');
}

/*
Twilio Sans Text
*/
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 300;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Light.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Light.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 300;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-LightItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-LightItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Regular.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Regular.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-RegularItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-RegularItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Medium.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Medium.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-MediumItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-MediumItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 600;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Semibold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Semibold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 600;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-SemiboldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-SemiboldItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Bold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Bold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-BoldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-BoldItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: normal;
  font-display: swap;
  font-weight: 800;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Extrabold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-Extrabold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansText';
  font-style: italic;
  font-display: swap;
  font-weight: 800;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-ExtraboldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansText-ExtraboldItl.woff') format('woff');
}

/*
Twilio Sans Display
*/
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 300;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Light.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Light.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 300;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-LightItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-LightItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Regular.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Regular.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 400;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-RegularItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-RegularItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Medium.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Medium.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 500;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-MediumItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-MediumItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 600;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Semibold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Semibold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 600;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-SemiboldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-SemiboldItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Bold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Bold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 700;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-BoldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-BoldItl.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: normal;
  font-display: swap;
  font-weight: 800;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Extrabold.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-Extrabold.woff') format('woff');
}
@font-face {
  font-family: 'TwilioSansDisplay';
  font-style: italic;
  font-display: swap;
  font-weight: 800;
  src: local(''),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-ExtraboldItl.woff2') format('woff2'),
       url('https://assets.twilio.com/public_assets/paste-fonts/1.5.2/TwilioSansDisplay-ExtraboldItl.woff') format('woff');
}
`, CL = us({ html: { fontSize: "fontSizeBase", fontFamily: "fontFamilyText" }, "html:lang(ja), html:lang(ja-JP)": { ".paste-theme-provider": { fontFamily: "fontFamilyTextJapanese" } }, "html:lang(zh-CN)": { ".paste-theme-provider": { fontFamily: "fontFamilyTextChineseSimplified" } }, "html:lang(zh-TW), html:lang(zh-HK)": { ".paste-theme-provider": { fontFamily: "fontFamilyTextChineseTraditional" } }, "html:lang(ko)": { ".paste-theme-provider": { fontFamily: "fontFamilyTextKorean" } }, body: { backgroundColor: "colorBackgroundBody", margin: 0 }, "*, *::after, *::before": { boxSizing: "border-box" }, "@media (prefers-reduced-motion: reduce)": { "*": { animationDuration: "0 !important", animationIterationCount: "1 !important", transitionDuration: "0 !important", scrollBehavior: "auto !important" } }, ":root": { "--reach-dialog": "1" } }), o$ = (t, e = "number") => {
  let r;
  typeof t == "string" && t.includes("%") ? r = Number.parseFloat(t.replace("%", "")) / 100 : r = typeof t == "string" ? Number.parseFloat(t.replace("rem", "")) : t;
  let n = Math.round(r * 16);
  return e === "number" ? n : `${n}px`;
}, My = ({ backgroundColors: t, borderColors: e, borderWidths: r, dataVisualization: n, colorSchemes: a, radii: i, fonts: o, fontSizes: s, fontWeights: l, lineHeights: c, boxShadows: u, sizings: f, spacings: h, textColors: p, zIndices: g }) => {
  let y = f.size0.includes("var") ? vJe : f, b = [o$(y.size40, "string"), o$(y.size100, "string"), o$(y.size120, "string")];
  return { shadows: u, borderWidths: r, radii: i, breakpoints: b, textColors: p, colorSchemes: a, borderColors: e, backgroundColors: t, fonts: o, fontSizes: s, fontWeights: l, lineHeights: c, widths: f, maxWidths: f, minWidths: f, heights: f, maxHeights: f, minHeights: f, sizes: f, iconSizes: { sizeIcon05: f.sizeIcon05, sizeIcon10: f.sizeIcon10, sizeIcon20: f.sizeIcon20, sizeIcon30: f.sizeIcon30, sizeIcon40: f.sizeIcon40, sizeIcon50: f.sizeIcon50, sizeIcon60: f.sizeIcon60, sizeIcon70: f.sizeIcon70, sizeIcon80: f.sizeIcon80, sizeIcon90: f.sizeIcon90, sizeIcon100: f.sizeIcon100, sizeIcon110: f.sizeIcon110 }, space: h, zIndices: g, dataVisualization: n };
}, wL = My({ backgroundColors: qWt, borderColors: KWt, borderWidths: ZWt, radii: nHt, fonts: QWt, fontSizes: eHt, fontWeights: tHt, lineHeights: rHt, boxShadows: JWt, sizings: aHt, spacings: iHt, textColors: oHt, zIndices: sHt, dataVisualization: XWt, colorSchemes: YWt }), NT = My({ backgroundColors: yJe, borderColors: bJe, borderWidths: xJe, radii: EJe, fonts: _Je, fontSizes: kJe, fontWeights: AJe, lineHeights: TJe, boxShadows: CJe, sizings: IJe, spacings: MJe, textColors: PJe, zIndices: RJe, dataVisualization: SJe, colorSchemes: wJe }), kue = My({ backgroundColors: YZt, borderColors: XZt, borderWidths: QZt, radii: sJt, fonts: nJt, fontSizes: aJt, fontWeights: iJt, lineHeights: oJt, boxShadows: eJt, sizings: lJt, spacings: cJt, textColors: uJt, zIndices: dJt, dataVisualization: rJt, colorSchemes: tJt }), Aue = My({ backgroundColors: XYt, borderColors: QYt, borderWidths: eXt, radii: lXt, fonts: aXt, fontSizes: iXt, fontWeights: oXt, lineHeights: sXt, boxShadows: tXt, sizings: cXt, spacings: uXt, textColors: dXt, zIndices: fXt, dataVisualization: nXt, colorSchemes: rXt }), Tue = My({ backgroundColors: KUt, borderColors: ZUt, borderWidths: JUt, radii: aVt, fonts: eVt, fontSizes: tVt, fontWeights: rVt, lineHeights: nVt, boxShadows: YUt, sizings: vJe, spacings: iVt, textColors: oVt, zIndices: sVt, dataVisualization: QUt, colorSchemes: XUt }), Eue = My({ backgroundColors: ZQt, borderColors: JQt, borderWidths: YQt, radii: ier, fonts: ter, fontSizes: rer, fontWeights: ner, lineHeights: aer, boxShadows: XQt, sizings: oer, spacings: ser, textColors: ler, zIndices: cer, dataVisualization: eer, colorSchemes: QQt }), vtr = NT, UJe = (t) => {
  let e = {};
  for (let [r, n] of Object.entries(t)) if (typeof n == "object") e[r] = UJe(n);
  else {
    let a = `--${r.replace(/([A-Z])/g, "-$1").replace(/(\d+)/g, "-$1").toLowerCase()}`;
    e[r] = `var(${a})`;
  }
  return e;
}, N9e = My(UJe({ backgroundColors: yJe, borderColors: bJe, borderWidths: xJe, radii: EJe, fonts: _Je, fontSizes: kJe, fontWeights: AJe, lineHeights: TJe, boxShadows: CJe, sizings: IJe, spacings: MJe, textColors: PJe, zIndices: RJe, dataVisualization: SJe, colors: oKt, colorSchemes: wJe })), $9e = () => {
  try {
    if (window.location.hash.includes("paste-theme-override")) return window.location.hash.split("=")[1];
  } catch {
  }
}, uy = ds.div(Ehe), VJe = "CSSVariables", ytr = () => {
  let [t, e] = P.useState($9e()), r = () => {
    e($9e());
  };
  return P.useEffect(() => (window.addEventListener("popstate", r), () => {
    window.removeEventListener("popstate", r);
  })), t;
};
function btr(t, e) {
  switch (t) {
    case fv.TWILIO:
      return { ...Tue, breakpoints: e || Tue.breakpoints };
    case fv.TWILIO_DARK:
      return { ...Eue, breakpoints: e || Eue.breakpoints };
    case fv.DARK:
      return { ...wL, breakpoints: e || wL.breakpoints };
    case fv.SENDGRID:
      return { ...Aue, breakpoints: e || Aue.breakpoints };
    case fv.EVERGREEN:
      return { ...kue, breakpoints: e || kue.breakpoints };
    case VJe:
      return { ...N9e, breakpoints: e || N9e.breakpoints };
    case fv.DEFAULT:
    default:
      return { ...NT, breakpoints: e || NT.breakpoints };
  }
}
var qJe = ({ customBreakpoints: t, theme: e = fv.DEFAULT, disableAnimations: r = !1, cacheProviderProps: n, useCSSVariables: a, ...i }) => {
  let [o] = P.useState(n ? CKe(n) : null), s = iM();
  P.useMemo(() => {
    Td.assign({ skipAnimation: r || s });
  }, [r, s]);
  let l = ytr(), c = btr(l || (a ? VJe : e), t);
  return o ? P.createElement(xKe, { value: o }, P.createElement(cL, { theme: c }, P.createElement(fb, { styles: CL({ theme: c }) }), P.createElement(fb, { styles: _ue }), P.createElement(uy, { className: "paste-theme-provider", ...i }))) : P.createElement(cL, { theme: c }, P.createElement(fb, { styles: CL({ theme: c }) }), P.createElement(fb, { styles: _ue }), P.createElement(uy, { className: "paste-theme-provider", ...i }));
};
qJe.displayName = "PasteThemeProvider";
var Md = () => {
  let t = P.useContext(P2e);
  if (!t) throw new Error("[useHook]: must be used within the @twilio-paste/theme provider");
  return t;
}, KJe = ({ backgroundColors: t, borderColors: e, borderWidths: r, colorSchemes: n, radii: a, fonts: i, fontSizes: o, fontWeights: s, lineHeights: l, shadows: c, sizes: u, space: f, textColors: h, zIndices: p, dataVisualization: g }) => ({ boxShadows: c, borderWidths: r, radii: a, textColors: h, borderColors: e, backgroundColors: t, fonts: i, fontSizes: o, fontWeights: s, lineHeights: l, sizings: u, spacings: f, zIndices: p, colorSchemes: n, colors: {}, dataVisualization: g }), xtr = () => {
  let t = Md(), e = KJe(t), r = mtr(e), n = gtr(e), a = dtr(r), i = ftr(n), o = a + i;
  return { textContrastRating: r, uiControlContrastRating: n, numberOfTextFailures: a, numberOfUIControlFailures: i, totalFailures: o };
}, ZJe = { Provider: qJe, Consumer: HJe };
const Ctr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ConsoleTheme: vtr,
  DarkTheme: wL,
  DefaultTheme: NT,
  EvergreenTheme: kue,
  SendGridTheme: Aue,
  StyledBase: uy,
  Theme: ZJe,
  ThemeVariants: fv,
  TwilioDarkTheme: Eue,
  TwilioTheme: Tue,
  generateThemeFromTokens: My,
  generateTokensFromTheme: KJe,
  pasteBaseStyles: Ehe,
  pasteFonts: _ue,
  pasteGlobalStyles: CL,
  remToPx: o$,
  useTheme: Md,
  useThemeContrastCheck: xtr,
  withTheme: wKe
}, Symbol.toStringTag, { value: "Module" }));
var wtr = Object.defineProperty, Str = Object.defineProperties, _tr = Object.getOwnPropertyDescriptors, SL = Object.getOwnPropertySymbols, JJe = Object.prototype.hasOwnProperty, YJe = Object.prototype.propertyIsEnumerable, D9e = (t, e, r) => e in t ? wtr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ktr = (t, e) => {
  for (var r in e || (e = {})) JJe.call(e, r) && D9e(t, r, e[r]);
  if (SL) for (var r of SL(e)) YJe.call(e, r) && D9e(t, r, e[r]);
  return t;
}, Atr = (t, e) => Str(t, _tr(e)), Ttr = (t, e) => {
  var r = {};
  for (var n in t) JJe.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && SL) for (var n of SL(t)) e.indexOf(n) < 0 && YJe.call(t, n) && (r[n] = t[n]);
  return r;
};
const As = P.forwardRef((t, e) => {
  var r = t, { as: n = "span", color: a = "currentColor", display: i = "block", element: o = "ICON", size: s = "sizeIcon30" } = r, l = Ttr(r, ["as", "color", "display", "element", "size"]);
  return P.createElement(ht, Atr(ktr({}, Xt(l)), { as: n, element: o, lineHeight: "lineHeight0", display: i, color: a, size: s, ref: e, flexShrink: 0 }));
});
As.displayName = "IconWrapper";
const Vz = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `LinkExternalIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[LinkExternalIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.4 4.5a.5.5 0 01.5.5v.1a.5.5 0 01-.5.5H5.6v8.8h8.8v-2.8a.5.5 0 01.41-.492l.09-.008h.1a.5.5 0 01.492.41l.008.09V15a.5.5 0 01-.41.492L15 15.5H5a.5.5 0 01-.492-.41L4.5 15V5a.5.5 0 01.41-.492L5 4.5h3.4zm6.6 0a.5.5 0 01.5.5v.1l-.001.01.001 3.29a.5.5 0 01-.5.5h-.1a.5.5 0 01-.5-.5l-.001-1.935-3.967 3.967a.611.611 0 01-.78.07l-.084-.07a.611.611 0 01-.07-.78l.07-.084L13.534 5.6H11.6a.5.5 0 01-.5-.5V5a.5.5 0 01.5-.5H15z" })));
});
Vz.displayName = "LinkExternalIcon";
var XJe = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "a", color: "colorTextLink", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", outline: "none", ref: e, textDecoration: "underline", _active: { color: "colorTextLinkStrongest", textDecoration: "none" }, _focus: { boxShadow: "shadowFocus", color: "colorTextLink", textDecoration: "underline", borderRadius: "borderRadius20" }, _hover: { color: "colorTextLinkStronger", textDecoration: "none" } }, t.children));
XJe.displayName = "DefaultAnchor";
var QJe = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "a", color: "colorTextInverse", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", outline: "none", ref: e, textDecoration: "underline", _active: { color: "colorTextInverse", textDecoration: "none" }, _focus: { boxShadow: "shadowFocusInverse", color: "colorTextInverse", textDecoration: "underline", borderRadius: "borderRadius20" }, _hover: { color: "colorTextInverse", textDecoration: "none" } }, t.children));
QJe.displayName = "InverseAnchor";
var Etr = { inverse: QJe, default: XJe }, Itr = /^(https?:)\S*$/, Mtr = "_blank", Ptr = "noreferrer noopener", eYe = (t) => Itr.test(t), T8 = (t) => {
  if (eYe(t)) return { rel: Ptr, target: Mtr };
}, m7 = P.forwardRef(({ element: t = "ANCHOR", variant: e = "default", showExternal: r, display: n, height: a, minHeight: i, maxHeight: o, width: s, minWidth: l, maxWidth: c, size: u, margin: f, marginBottom: h, marginLeft: p, marginRight: g, marginTop: y, marginX: b = null, marginY: w = null, padding: _, paddingBottom: C, paddingLeft: x, paddingRight: S, paddingTop: A, paddingX: I = null, paddingY: M = null, verticalAlign: B, i18nExternalLinkLabel: L = "(link takes you to an external page)", ...N }, d) => {
  let m = Etr[e];
  return P.createElement(m, { href: N.href, ref: d, variant: e, ...T8(N.href), ...Xt(N), element: t, display: n, height: a, minHeight: i, maxHeight: o, width: s, minWidth: l, maxWidth: c, size: u, margin: f, marginBottom: h, marginLeft: p, marginRight: g, marginTop: y, marginX: b, marginY: w, padding: _, paddingBottom: C, paddingLeft: x, paddingRight: S, paddingTop: A, paddingX: I, paddingY: M, verticalAlign: B }, r ? P.createElement(ht, { as: "span" }, N.children, P.createElement(ht, { as: "span", display: "inline-block", flexShrink: 0, verticalAlign: "middle" }, P.createElement(Vz, { decorative: !1, title: L }))) : N.children);
});
m7.displayName = "Anchor";
const Rtr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Anchor: m7,
  isExternalUrl: eYe,
  secureExternalLink: T8
}, Symbol.toStringTag, { value: "Module" })), Ihe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowForwardIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowForwardIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.991 9.91l.007.05v.08l-.01.07-.01.029a.489.489 0 01-.205.272l-3.832 3.444a.596.596 0 01-.78 0 .459.459 0 01-.063-.632l.063-.069 2.957-2.659H5.513A.504.504 0 015 10a.5.5 0 01.42-.488l.093-.008h7.604l-2.956-2.658a.459.459 0 01-.063-.632l.063-.069a.598.598 0 01.704-.057l.076.057 3.832 3.444c.098.064.172.16.206.272l.012.049z" })));
});
Ihe.displayName = "ArrowForwardIcon";
var L9e = { cx: 50, cy: 50, r: 45 }, s$ = Math.PI * 2 * 45, Otr = Ey`
  0%,
  15% {
    stroke-dashoffset: ${s$ * 0.9999};
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: ${s$ * 0.2};
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: ${s$ * 0.9999};
    transform: rotate(360deg);
  }
`, Btr = Ey`
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
`, Ntr = Ey`
  0%,
  75% {
    stroke-dashoffset: 90%;
  }

  100% {
    stroke-dashoffset: 90%;
    transform: rotate(360deg);
  }
`, $tr = ds.circle({ transformOrigin: "center", opacity: 0.25 }), Dtr = ds.circle(({ show: t, isSafari: e }) => ({ transformOrigin: "center", animation: e ? "none" : `1.5s ease-in-out infinite both ${Btr}`, strokeDasharray: s$, opacity: t ? 1 : 0 })), Ltr = ds.svg(({ isSafari: t }) => ({ height: "100%", width: "100%", display: "block", animation: t ? `1s infinite linear ${Ntr}` : `4.25s linear infinite both ${Otr}` })), Mhe = P.forwardRef(({ size: t, color: e = "currentColor", title: r, as: n, display: a, decorative: i, delay: o = 250, element: s = "SPINNER" }, l) => {
  let c = `spinner-${Jr()}`, { borderWidths: { borderWidth40: u } } = Md(), [f, h] = P.useState(o === 0);
  if (!i && r == null) throw new Error("[Spinner]: Missing a title for non-decorative icon.");
  P.useEffect(() => {
    if (o === 0) return;
    let y = setTimeout(() => h(!0), o);
    return () => clearTimeout(y);
  }, [o]);
  let [p, g] = P.useState(null);
  return P.useEffect(() => {
    g(navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome"));
  }, []), p == null ? null : P.createElement(As, { as: n, element: s, display: a, size: t, color: e, "aria-hidden": i, ref: l }, P.createElement(Ltr, { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": c, isSafari: p }, r ? P.createElement("title", { id: c }, r) : null, P.createElement("g", { strokeWidth: u, stroke: "currentColor", strokeLinecap: "round", fill: "transparent" }, P.createElement($tr, { ...L9e }), P.createElement(Dtr, { show: f, ...L9e, isSafari: p }))));
});
Mhe.displayName = "Spinner";
const jtr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Spinner: Mhe
}, Symbol.toStringTag, { value: "Module" }));
var Ftr = Object.create, tYe = Object.defineProperty, ztr = Object.getOwnPropertyDescriptor, rYe = Object.getOwnPropertyNames, Gtr = Object.getPrototypeOf, Wtr = Object.prototype.hasOwnProperty, Htr = (t, e) => function() {
  return e || (0, t[rYe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Utr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of rYe(e)) !Wtr.call(t, a) && a !== r && tYe(t, a, { get: () => e[a], enumerable: !(n = ztr(e, a)) || n.enumerable });
  return t;
}, C0 = (t, e, r) => (r = t != null ? Ftr(Gtr(t)) : {}, Utr(!t || !t.__esModule ? tYe(r, "default", { value: t, enumerable: !0 }) : r, t)), w0 = Htr({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), Phe = C0(w0()), lZ = C0(w0()), cZ = { appearance: "none", background: "none", display: "inline-block", border: "none", outline: "none", transition: "background-color 100ms ease-in, box-shadow 100ms ease-in, color 100ms ease-in", fontFamily: "inherit", fontWeight: "fontWeightSemibold", textDecoration: "none", position: "relative", margin: "space0", borderRadius: "borderRadius20", _hover: { textDecoration: "none" }, _focus: { textDecoration: "none", boxShadow: "shadowFocus" }, _active: { textDecoration: "none" } }, Hi = { default: (0, lZ.default)(cZ, { cursor: "pointer", _active: { boxShadow: "none" } }), disabled: (0, lZ.default)(cZ, { cursor: "not-allowed" }), loading: (0, lZ.default)(cZ, { cursor: "wait" }) }, Cf = { default: { paddingTop: "space30", paddingBottom: "space30", paddingLeft: "space40", paddingRight: "space40", borderRadius: "borderRadius20", fontSize: "fontSize30", lineHeight: "lineHeight20" }, small: { paddingTop: "space20", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", borderRadius: "borderRadius10", fontSize: "fontSize30", lineHeight: "lineHeight20" }, icon: { padding: "space30", borderRadius: "borderRadius20" }, icon_small: { padding: "space20", borderRadius: "borderRadius20" }, reset: { paddingTop: "space0", paddingRight: "space0", paddingBottom: "space0", paddingLeft: "space0", borderWidth: "borderWidth0", fontSize: "inherit" }, rounded_small: { borderRadius: "borderRadiusPill", paddingTop: "space20", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", fontSize: "fontSize30", lineHeight: "lineHeight20" }, circle: { padding: "space30", borderRadius: "borderRadiusCircle" }, circle_small: { padding: "space20", borderRadius: "borderRadiusCircle" } }, nYe = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorText", backgroundColor: "colorBackgroundBody", _disabled: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker", color: "colorTextWeaker" }, _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _pressed: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _pressed_hover: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStronger", color: "colorTextPrimaryStronger" }, _pressed_active: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _pressed_focus: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextPrimary" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, aYe = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorTextError", backgroundColor: "colorBackgroundBody", _disabled: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker", color: "colorTextWeaker" }, _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderError", color: "colorTextError" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderErrorStrongest", color: "colorTextErrorStrongest" }, _pressed: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderError", color: "colorTextError" }, _pressed_hover: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderErrorStronger", color: "colorTextErrorStronger" }, _pressed_active: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderError", color: "colorTextError" }, _pressed_focus: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextError" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, Vtr = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorTextIcon", backgroundColor: "colorBackgroundBody", _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimary", color: "colorTextPrimaryStronger" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _disabled: { backgroundColor: "colorBackgroundBody", color: "colorTextWeaker" }, _pressed: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _pressed_hover: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStronger", color: "colorTextPrimaryStronger" }, _pressed_focus: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextPrimary" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, qtr = (0, Phe.default)(Hi.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundDestructive", boxShadow: "shadowBorderDestructive", _hover: { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderDestructive" }, _focus: { boxShadow: "shadowFocus" }, _active: { color: "colorTextDestructive", backgroundColor: "colorBackgroundDestructiveWeakest", boxShadow: "shadowBorderDestructive" } }), Ktr = (0, Phe.default)(Hi.loading, { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }), Ztr = (0, Phe.default)(Hi.disabled, { color: "colorTextWeakest", backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker" }), Jtr = { default: qtr, loading: Ktr, disabled: Ztr }, iYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...Jtr[e], ...Cf[t] }));
iYe.displayName = "DestructiveButton";
var Rhe = C0(w0()), Ytr = (0, Rhe.default)(Hi.default, { color: "colorTextDestructive", _hover: { color: "colorTextDestructiveStrongest" }, _active: { color: "colorTextDestructiveStrongest" } }), Xtr = (0, Rhe.default)(Hi.loading, { color: "colorTextDestructive" }), Qtr = (0, Rhe.default)(Hi.disabled, { color: "colorTextWeaker" }), err = { default: Ytr, loading: Xtr, disabled: Qtr }, oYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...err[e], ...Cf[t] }));
oYe.displayName = "DestructiveIconButton";
var Ohe = C0(w0()), trr = (0, Ohe.default)(Hi.default, { color: "colorTextLinkDestructive", textAlign: "left", transition: "none", _hover: { color: "colorTextLinkDestructiveStrongest", textDecoration: "underline" }, _active: { color: "colorTextLinkDestructiveStrongest", textDecoration: "underline" } }), rrr = (0, Ohe.default)(Hi.loading, { color: "colorTextLinkDestructive", textAlign: "left", _hover: { color: "colorTextLinkDestructiveStronger" }, _active: { color: "colorTextLinkDestructiveStronger" }, _focus: { color: "colorTextLinkDestructiveStronger" } }), nrr = (0, Ohe.default)(Hi.disabled, { color: "colorTextWeaker", textAlign: "left", _hover: { color: "colorTextLinkDestructiveWeak" }, _active: { color: "colorTextLinkDestructiveWeak" }, _focus: { color: "colorTextLinkDestructiveWeak" } }), arr = { default: trr, loading: rrr, disabled: nrr }, sYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...arr[e], ...Cf[t] }));
sYe.displayName = "DestructiveLinkButton";
var Bhe = C0(w0()), irr = (0, Bhe.default)(Hi.default, { color: "colorTextDestructive", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderWeak", _hover: { color: "colorTextDestructive", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderDestructive" }, _focus: { boxShadow: "shadowFocusShadowBorder" }, _active: { color: "colorTextDestructive", backgroundColor: "colorBackgroundDestructiveWeakest", boxShadow: "shadowBorderDestructive" } }), dB = { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }, orr = (0, Bhe.default)(Hi.loading, { ...dB, _hover: dB, _active: dB, _focus: dB }), fB = { color: "colorTextWeaker", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker" }, srr = (0, Bhe.default)(Hi.disabled, { ...fB, _hover: fB, _active: fB, _focus: fB }), lrr = { default: irr, loading: orr, disabled: srr }, lYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : aYe;
  return P.createElement(ht, { ref: o, width: r ? "100%" : "auto", "aria-pressed": n, ...Xt({ as: a, ...i }), ...lrr[e], ...s, ...Cf[t] });
});
lYe.displayName = "DestructiveSecondaryButton";
var Nhe = C0(w0()), crr = (0, Nhe.default)(Hi.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundInverse", boxShadow: "shadowBorderInverseWeaker", _hover: { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseStronger" }, _focus: { boxShadow: "shadowFocusInverse" }, _active: { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseStrongest" } }), urr = (0, Nhe.default)(Hi.loading, { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseWeaker" }), drr = (0, Nhe.default)(Hi.disabled, { color: "colorTextInverseWeakest", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseWeakest" }), frr = { default: crr, loading: urr, disabled: drr }, cYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...frr[e], ...Cf[t] }));
cYe.displayName = "InverseButton";
var $he = C0(w0()), hrr = (0, $he.default)(Hi.default, { color: "colorTextInverse", textAlign: "left", transition: "none", _hover: { color: "colorTextInverseWeaker", textDecoration: "underline" }, _focus: { boxShadow: "shadowFocusInverse" }, _active: { color: "colorTextInverseWeaker", textDecoration: "underline" } }), prr = (0, $he.default)(Hi.loading, { color: "colorTextInverse", textAlign: "left" }), mrr = (0, $he.default)(Hi.disabled, { color: "colorTextInverseWeakest", textAlign: "left" }), grr = { default: hrr, loading: prr, disabled: mrr }, uYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...grr[e], ...Cf[t] }));
uYe.displayName = "InverseLinkButton";
var Dhe = C0(w0()), vrr = (0, Dhe.default)(Hi.default, { color: "colorTextPrimary", textAlign: "left", transition: "none", _hover: { color: "colorTextPrimaryStrongest", textDecoration: "underline" }, _active: { color: "colorTextPrimaryStrongest", textDecoration: "underline" } }), yrr = (0, Dhe.default)(Hi.loading, { color: "colorTextPrimary", textAlign: "left" }), brr = (0, Dhe.default)(Hi.disabled, { color: "colorTextWeaker", textAlign: "left" }), xrr = { default: vrr, loading: yrr, disabled: brr }, dYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...xrr[e], ...Cf[t] }));
dYe.displayName = "LinkButton";
var Lhe = C0(w0()), Crr = (0, Lhe.default)(Hi.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundPrimary", boxShadow: "shadowBorderPrimary", _hover: { color: "colorTextPrimary", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderPrimary" }, _focus: { boxShadow: "shadowFocus" }, _active: { color: "colorTextPrimaryStrong", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrong" } }), wrr = (0, Lhe.default)(Hi.loading, { color: "colorTextPrimary", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }), Srr = (0, Lhe.default)(Hi.disabled, { color: "colorTextWeakest", backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker" }), _rr = { default: Crr, loading: wrr, disabled: Srr }, fYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ..._rr[e], ...Cf[t] }));
fYe.displayName = "PrimaryButton";
var jhe = C0(w0()), krr = (0, jhe.default)(Hi.default, { color: "colorTextPrimary", _hover: { color: "colorTextPrimaryStrongest" }, _active: { color: "colorTextPrimaryStrongest" } }), Arr = (0, jhe.default)(Hi.loading, { color: "colorTextPrimary" }), Trr = (0, jhe.default)(Hi.disabled, { color: "colorTextWeaker" }), Err = { default: krr, loading: Arr, disabled: Trr }, hYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...Err[e], ...Cf[t] }));
hYe.displayName = "PrimaryIconButton";
var Fhe = C0(w0()), Irr = (0, Fhe.default)(Hi.default, { fontWeight: "inherit", color: "inherit" }), Mrr = (0, Fhe.default)(Hi.loading, { fontSize: "inherit", fontWeight: "inherit" }), Prr = (0, Fhe.default)(Hi.disabled, { fontSize: "inherit", fontWeight: "inherit" }), Rrr = { default: Irr, loading: Mrr, disabled: Prr }, pYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Rrr[e], ...Cf[t], as: n, ...a }));
pYe.displayName = "ResetButton";
var zhe = C0(w0()), Orr = (0, zhe.default)(Hi.default, { color: "colorText", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderWeak", _hover: { color: "colorTextPrimary", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderPrimary" }, _focus: { boxShadow: "shadowFocusShadowBorder" }, _active: { color: "colorTextPrimaryStrong", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrong" } }), hB = { color: "colorTextPrimary", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }, Brr = (0, zhe.default)(Hi.loading, { ...hB, _hover: hB, _active: hB, _focus: hB }), pB = { color: "colorTextWeaker", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker" }, Nrr = (0, zhe.default)(Hi.disabled, { ...pB, _hover: pB, _active: pB, _focus: pB, _pressed: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak", boxShadow: "none" }, _pressed_hover: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak", boxShadow: "none" } }), $rr = { default: Orr, loading: Brr, disabled: Nrr }, mYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : nYe;
  return P.createElement(ht, { ref: o, width: r ? "100%" : "auto", "aria-pressed": n, ...Xt({ as: a, ...i }), ...$rr[e], ...s, ...Cf[t] });
});
mYe.displayName = "SecondaryButton";
var Ghe = C0(w0()), Drr = (0, Ghe.default)(Hi.default, { color: "colorTextIcon", _hover: { color: "colorTextPrimaryStrongest" }, _active: { color: "colorTextPrimaryStrongest" } }), Lrr = (0, Ghe.default)(Hi.loading, { color: "colorTextPrimary" }), jrr = (0, Ghe.default)(Hi.disabled, { color: "colorTextWeaker", _pressed: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak" }, _pressed_hover: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak" } }), Frr = { default: Drr, loading: Lrr, disabled: jrr }, gYe = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : Vtr;
  return P.createElement(ht, { ref: o, "aria-pressed": n, width: r ? "100%" : "auto", ...Xt({ as: a, ...i }), ...s, ...Frr[e], ...Cf[t] });
});
gYe.displayName = "SecondaryIconButton";
var zrr = Zh(ht), Grr = (t, e, r) => {
  let n = "default";
  return r != null ? n = r : t === "link" || t === "destructive_link" || t === "reset" ? n = "reset" : P.Children.count(e) === 1 && P.Children.forEach(e, (a) => {
    P.isValidElement(a) && typeof a.type.displayName == "string" && a.type.displayName.includes("Icon") && (n = "icon");
  }), n;
}, Wrr = (t, e) => t ? "disabled" : e ? "loading" : "default", Hrr = ({ as: t, href: e, tabIndex: r, variant: n, size: a, fullWidth: i, children: o, disabled: s, loading: l, pressed: c }) => {
  let u = e != null && e !== "", f = r != null;
  if (t !== "a" && u) throw new Error(`[Paste: Button] You cannot pass href into a button without the 'a' tag.  Use 'as="a"'.`);
  if (t === "a") {
    if (!u) throw new Error("[Paste: Button] Missing href prop for link button.");
    if (n === "link" || n === "inverse_link") throw new Error("[Paste: Button] Using Button component as an Anchor. Use the Paste Anchor component instead.");
    if (n !== "primary" && n !== "secondary" && n !== "reset" && n !== "inverse") throw new Error('[Paste: Button] <Button as="a"> only works with the following variants: primary and secondary.');
    if (s || l) throw new Error('[Paste: Button] <Button as="a"> cannot be disabled or loading.');
  }
  if (n === "reset" && a !== "reset") throw new Error('[Paste: Button] The "RESET" variant can only be used with the "RESET" size.');
  if ((a === "icon" || a === "icon_small" || a === "circle" || a === "circle_small") && i) throw new Error("[Paste: Button] Icon buttons should not be fullWidth.");
  if (o == null) throw new Error("[Paste: Button] Must have non-null children.");
  if (f && !(r === 0 || r === -1)) throw console.error("tabIndex", r), new Error("[Paste: Button] tabIndex must be 0 or -1.");
  if (c && !(n === "secondary" || n === "secondary_icon" || n === "destructive_secondary")) throw console.error("variant", n, "pressed", c), new Error('[Paste: Button] pressed can only be used with "secondary" and "secondary_icon" and "destructive_secondary" variants.');
}, Urr = /* @__PURE__ */ new Set(["link", "destructive_link", "inverse_link", "reset"]), vYe = ({ buttonState: t, children: e, showLoading: r, variant: n }) => {
  let a = n && Urr.has(n);
  return P.createElement(P.Fragment, null, P.createElement(ht, { as: "span", display: "flex", textDecoration: "inherit", opacity: t === "loading" ? "0" : "1", justifyContent: a ? null : "center", columnGap: "space20", alignItems: "center", width: "100%" }, e), r ? P.createElement(ht, { as: "span", position: "absolute", top: 0, right: 0, bottom: 0, left: 0, display: "flex", justifyContent: "center", alignItems: "center", lineHeight: "lineHeight30" }, P.createElement(Mhe, { decorative: !0, delay: 0 })) : null);
};
vYe.displayName = "ButtonContents";
var Vrr = (t) => {
  switch (t) {
    case "primary_icon":
      return hYe;
    case "secondary":
      return mYe;
    case "secondary_icon":
      return gYe;
    case "destructive":
      return iYe;
    case "destructive_icon":
      return oYe;
    case "destructive_secondary":
      return lYe;
    case "link":
      return dYe;
    case "destructive_link":
      return sYe;
    case "reset":
      return pYe;
    case "inverse":
      return cYe;
    case "inverse_link":
      return uYe;
    case "primary":
    default:
      return fYe;
  }
}, Zs = P.forwardRef(({ element: t = "BUTTON", i18nExternalLinkLabel: e = "(link takes you to an external page)", as: r = "button", fullWidth: n = !1, disabled: a = !1, loading: i = !1, variant: o = "primary", type: s = "button", ...l }, c) => {
  let { size: u, children: f, ...h } = l, [p, g] = P.useState(!1), y = aM({ translateX: p ? "4px" : "0px", config: { mass: 0.1, tension: 275, friction: 16 } }), b = P.useMemo(() => Grr(o, f, u), [u, o, f]);
  Hrr({ ...l, as: r, children: f, fullWidth: n, disabled: a, loading: i, variant: o, size: b });
  let w = Wrr(a, i), _ = w === "loading", C = w !== "default", x = Vrr(o), S = l.href != null ? T8(l.href) : null, A = f;
  return r === "a" && l.href != null && typeof f == "string" && o !== "reset" && (A = P.createElement(P.Fragment, null, f, S != null ? P.createElement(Vz, { decorative: !1, title: e }) : P.createElement(zrr, { style: y }, P.createElement(Ihe, { decorative: !0 })))), P.createElement(x, { ...S, ...h, onMouseEnter: (I) => {
    typeof h.onMouseEnter == "function" && h.onMouseEnter(I), g(!0);
  }, onMouseLeave: (I) => {
    typeof h.onMouseLeave == "function" && h.onMouseLeave(I), g(!1);
  }, buttonState: w, disabled: C, element: t, variant: o, size: b, "aria-busy": w === "loading" ? "true" : "false", as: r, type: s, fullWidth: n, ref: c }, P.createElement(vYe, { buttonState: w, showLoading: _, variant: o }, A));
});
Zs.displayName = "Button";
const qrr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Zs,
  ButtonToggleStyles: nYe,
  DestructiveSecondaryButtonToggleStyles: aYe
}, Symbol.toStringTag, { value: "Module" }));
var Krr = Object.create, qz = Object.defineProperty, Zrr = Object.getOwnPropertyDescriptor, Whe = Object.getOwnPropertyNames, Jrr = Object.getPrototypeOf, Yrr = Object.prototype.hasOwnProperty, Xrr = (t, e) => function() {
  return t && (e = (0, t[Whe(t)[0]])(t = 0)), e;
}, Hhe = (t, e) => function() {
  return e || (0, t[Whe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Qrr = (t, e) => {
  for (var r in e) qz(t, r, { get: e[r], enumerable: !0 });
}, Uhe = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Whe(e)) !Yrr.call(t, a) && a !== r && qz(t, a, { get: () => e[a], enumerable: !(n = Zrr(e, a)) || n.enumerable });
  return t;
}, enr = (t, e, r) => (Uhe(t, e, "default"), r), tnr = (t, e, r) => (r = t != null ? Krr(Jrr(t)) : {}, Uhe(!t || !t.__esModule ? qz(r, "default", { value: t, enumerable: !0 }) : r, t)), yYe = (t) => Uhe(qz({}, "__esModule", { value: !0 }), t), rnr = Hhe({ "../../../node_modules/clipboard-copy/index.js"(t, e) {
  e.exports = r;
  function r(n) {
    if (navigator.clipboard) return navigator.clipboard.writeText(n).catch(function(l) {
      throw l !== void 0 ? l : new DOMException("The request is not allowed", "NotAllowedError");
    });
    var a = document.createElement("span");
    a.textContent = n, a.style.whiteSpace = "pre", document.body.appendChild(a);
    var i = window.getSelection(), o = window.document.createRange();
    i.removeAllRanges(), o.selectNode(a), i.addRange(o);
    var s = !1;
    try {
      s = window.document.execCommand("copy");
    } catch (l) {
      console.log("error", l);
    }
    return i.removeAllRanges(), window.document.body.removeChild(a), s ? Promise.resolve() : Promise.reject(new DOMException("The request is not allowed", "NotAllowedError"));
  }
} }), Kz = {};
Qrr(Kz, { default: () => P });
var bYe = Xrr({ "esm-externals:react"() {
  enr(Kz, P);
} }), nnr = Hhe({ "../../../node_modules/use-clipboard-copy/dist/useTimedToggle.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.useTimedToggle = void 0;
  var e = (bYe(), yYe(Kz));
  function r(n) {
    var a = e.useState(!1), i = a[0], o = a[1], s = e.useRef(), l = e.useRef(n), c = function(u) {
      clearTimeout(s.current), o(!l.current), s.current = window.setTimeout(function() {
        return o(l.current);
      }, u);
    };
    return e.useEffect(function() {
      return function() {
        return clearTimeout(s.current);
      };
    }, []), [i, c];
  }
  t.useTimedToggle = r;
} }), anr = Hhe({ "../../../node_modules/use-clipboard-copy/dist/index.js"(t) {
  var e = t && t.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.useClipboard = void 0;
  var r = e(rnr()), n = (bYe(), yYe(Kz)), a = nnr();
  function i(s) {
    return s && (s.nodeName === "TEXTAREA" || s.nodeName === "INPUT");
  }
  function o(s) {
    s === void 0 && (s = {});
    var l = a.useTimedToggle(!1), c = l[0], u = l[1], f = n.useRef(null), h = n.useRef(s);
    h.current = s;
    function p() {
      return !!navigator.clipboard || typeof document.execCommand == "function" && typeof document.queryCommandSupported == "function" && document.queryCommandSupported("copy");
    }
    var g = n.useCallback(function(y) {
      var b = h.current, w = f.current;
      function _() {
        b.onSuccess && b.onSuccess(), b.copiedTimeout && u(b.copiedTimeout), b.selectOnCopy && i(w) && w.select();
      }
      function C() {
        b.onError && b.onError(), b.selectOnError !== !1 && i(w) && w.select();
      }
      function x(S) {
        r.default(S).then(_).catch(C);
      }
      typeof y == "string" ? x(y) : w && x(w.value);
    }, []);
    return { copied: c, copy: g, isSupported: p, target: f };
  }
  t.useClipboard = o;
} }), inr = tnr(anr()), onr = inr.useClipboard;
const xYe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CopyIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CopyIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.469 2.5c.63 0 1.15.48 1.212 1.094l.007.125-.001 1.593h1.407c.73 0 1.331.558 1.4 1.271l.006.136v9.375c0 .776-.63 1.406-1.406 1.406H6.719c-.777 0-1.407-.63-1.407-1.406v-1.407H3.719c-.631 0-1.15-.48-1.213-1.094L2.5 13.47v-9.75c0-.631.48-1.15 1.094-1.213L3.72 2.5h9.75zm2.625 3.75H6.719a.469.469 0 00-.469.469v9.375c0 .259.21.468.469.468h9.375c.259 0 .468-.21.468-.468V6.719a.469.469 0 00-.468-.469zm-2.625-2.813h-9.75a.281.281 0 00-.274.217l-.007.065v9.75c0 .133.092.244.216.274l.065.007 1.593-.001v-7.03c0-.731.558-1.332 1.271-1.4l.136-.006 7.031-.001V3.719a.281.281 0 00-.217-.274l-.064-.007z" })));
});
xYe.displayName = "CopyIcon";
var Ul = P.forwardRef(({ as: t = "span", children: e, ...r }, n) => P.createElement(ht, { ...r, as: t, border: "none", clip: "rect(0 0 0 0)", height: "1px", margin: "spaceNegative10", overflow: "hidden", padding: "space0", position: "absolute", ref: n, textTransform: "none", whiteSpace: "nowrap", width: "1px" }, e));
Ul.displayName = "ScreenReaderOnly";
var CYe = P.createContext({}), snr = { default: { borderColor: "colorBorderWeak", backgroundColor: "colorBackgroundWeak", boxShadow: "shadowBorderBottomWeak" }, inverse: { borderColor: "colorBorderInverseWeaker", backgroundColor: "colorBackgroundInverse", color: "colorTextInverse", boxShadow: "shadowBorderBottomInverseWeaker" } }, lnr = { default: { color: "colorTextWeak", borderColor: "colorBorderWeakest", boxShadow: void 0 }, inverse: { color: "colorTextInverseWeaker", borderColor: "colorBorderInverseWeakest", boxShadow: void 0 } }, cnr = { default: { backgroundColor: "colorBackgroundStrong", boxShadow: void 0 }, inverse: { backgroundColor: "colorBackgroundInverseStronger", boxShadow: void 0 } }, wYe = P.forwardRef(({ element: t = "KEYBOARD_KEY", keyEvent: e, ...r }, n) => {
  let { disabled: a, activeKeys: i, enablePressStyles: o, variant: s = "default" } = P.useContext(CYe), l = !a && i && e && i.map((c) => c.toLowerCase()).includes(e.toLowerCase());
  return P.createElement(ht, { ...Xt(r), element: t, ref: n, borderWidth: "borderWidth10", borderRadius: "borderRadius20", borderStyle: "solid", width: "fit-content", minWidth: "sizeBase60", display: "inline-flex", justifyContent: "center", paddingX: "space20", as: "kbd", fontFamily: "fontFamilyText", ...snr[s], ...a ? lnr[s] : {}, ...l && o ? cnr[s] : {} }, r.children);
});
wYe.displayName = "KeyboardKey";
var SYe = P.forwardRef(({ element: t = "KEYBOARD_KEY_GROUP", activeKeys: e, disabled: r = !1, enablePressStyles: n = !1, variant: a = "default", ...i }, o) => P.createElement(CYe.Provider, { value: { activeKeys: e, disabled: r, enablePressStyles: n, variant: a } }, P.createElement(ht, { ...Xt(i), element: t, ref: o, display: "inline-flex", columnGap: "space20" }, i.children)));
SYe.displayName = "KeyboardKeyGroup";
var unr = (t) => Array.isArray(t) ? t.map((e) => e === "horizontal" ? "flex" : "block") : t === "horizontal" ? "flex" : "block", dnr = (t) => ({ display: unr(t), alignItems: "center", flexWrap: "wrap" }), fnr = (t, e) => {
  let r = {};
  if (Array.isArray(t)) {
    let n = [], a = [];
    t.forEach((i, o) => {
      n[o] = i === "horizontal" ? e : "space0", a[o] = i === "horizontal" ? "space0" : e;
    }), r = { marginRight: n, marginBottom: a };
  }
  return t === "horizontal" && (r = { marginRight: e }), t === "vertical" && (r = { marginBottom: e }), r;
}, J5 = P.forwardRef(({ children: t, orientation: e, spacing: r, element: n = "STACK", ...a }, i) => {
  let [o, s] = P.useMemo(() => {
    let f = P.Children.toArray(t).filter((h) => P.isValidElement(h) || typeof h == "string");
    return [f.length, f];
  }, [t]), l = P.useMemo(() => dnr(e), [e]), c = P.useMemo(() => fnr(e, r), [e, r]), u = JI();
  return P.createElement(ht, { element: n, ...Xt(a), ...l, ref: i }, s.map((f, h) => P.createElement(ht, { element: `${n}_CHILD`, ...o !== h + 1 ? c : null, key: u(`stack-${h}`) }, f)));
});
J5.displayName = "Stack";
const hnr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Stack: J5
}, Symbol.toStringTag, { value: "Module" }));
var pnr = Object.create, _Ye = Object.defineProperty, mnr = Object.getOwnPropertyDescriptor, kYe = Object.getOwnPropertyNames, gnr = Object.getPrototypeOf, vnr = Object.prototype.hasOwnProperty, ynr = (t, e) => function() {
  return e || (0, t[kYe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, bnr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of kYe(e)) !vnr.call(t, a) && a !== r && _Ye(t, a, { get: () => e[a], enumerable: !(n = mnr(e, a)) || n.enumerable });
  return t;
}, xnr = (t, e, r) => (r = t != null ? pnr(gnr(t)) : {}, bnr(!t || !t.__esModule ? _Ye(r, "default", { value: t, enumerable: !0 }) : r, t)), Cnr = ynr({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), AYe = { color: { property: "color", scale: "textColors" }, cursor: !0, outline: !0, transition: !0, transitionDelay: !0, textDecoration: !0, textTransform: !0, whiteSpace: !0, wordBreak: !0, wordWrap: !0, fontVariantNumeric: !0, textOverflow: !0, overflowWrap: !0, listStyleType: !0, listStylePosition: !0, listStyleImage: !0 }, _L = { _hover: "&:hover", _active: "&:active, &[data-active=true]", _focus: "&:focus", _visited: "&:visited", _even: "&:nth-of-type(even)", _odd: "&:nth-of-type(odd)", _disabled: "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover", _checked: "&:checked, &[aria-checked=true]", _mixed: "&:indeterminate, &[aria-checked=mixed]", _selected: "&[aria-selected=true]", _selected_hover: "&[aria-selected=true]:hover", _selected_focus: "&[aria-selected=true]:focus", _selected_focusVisible: "&[aria-selected=true]:focus-visible", _invalid: "&:invalid, &[aria-invalid=true]", _pressed: "&[aria-pressed=true]", _readOnly: "&[aria-readonly=true], &[readonly]", _first: "&:first-of-type", _last: "&:last-of-type", _expanded: "&[aria-expanded=true]", _grabbed: "&[aria-grabbed=true]", _notFirst: "&:not(:first-of-type)", _notLast: "&:not(:last-of-type)", _before: "&:before", _after: "&:after", _focusWithin: "&:focus-within" }, wnr = xnr(Cnr()), Snr = zu(AYe), _nr = (t) => {
  let e = Object.keys(t).filter((n) => n.startsWith("_"));
  if (e.length === 0) return {};
  let r = {};
  return e.forEach((n) => {
    _L[n] != null && (r[_L[n]] = t[n]);
  }), us(r);
}, knr = (t) => {
  if (t != null && t.theme != null && t.theme.elements != null) {
    let e = t.theme.elements, r = t["data-paste-element"];
    if (e[r] != null) {
      let n = e[r], a = us(n)(t), { variants: i, ...o } = a, s = {};
      return t.variant != null && i != null && i[t.variant] != null && (s = i[t.variant]), () => (0, wnr.default)(o, s);
    }
  }
  return {};
}, TYe = [...O2e, ...B2e, ...N2e, ...R2e, ...Object.keys(_L), "display", "verticalAlign", "className", "style"], lg = (t) => Object.keys(t).reduce((e, r) => (TYe.includes(r) || (e[r] = t[r]), e), {}), Anr = "21.0.0", Tnr = ZI([...KI, ...Object.keys({ ...AYe, ..._L })]), Enr = ds("div", { shouldForwardProp: Tnr })({ margin: 0, padding: 0 }, x8(wT, E2e, I2e, w8, qI, C8, T2e, Snr), _nr, knr), cl = P.forwardRef(({ children: t, color: e = "colorText", fontSize: r = "fontSize30", lineHeight: n = "lineHeight30", element: a = "TEXT", ...i }, o) => P.createElement(Enr, { "data-paste-element": a, "data-paste-core-version": Anr, ref: o, color: e, fontSize: r, lineHeight: n, ...i }, t));
cl.displayName = "Text";
const Inr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TEXT_PROPS_TO_BLOCK: TYe,
  Text: cl,
  safelySpreadTextProps: lg
}, Symbol.toStringTag, { value: "Module" }));
function Mnr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function j9e(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Lt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? j9e(Object(r), !0).forEach(function(n) {
      Mnr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : j9e(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function qn(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Pnr(t, e) {
  if (t) {
    if (typeof t == "string") return F9e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return F9e(t, e);
  }
}
function F9e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Y5(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = Pnr(t)) || e) {
      r && (t = r);
      var n = 0;
      return function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
var EYe = Bo({});
function Rnr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function z9e(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D9(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? z9e(Object(r), !0).forEach(function(n) {
      Rnr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : z9e(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Iue(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Onr(t, e) {
  if (t) {
    if (typeof t == "string") return G9e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return G9e(t, e);
  }
}
function G9e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function W9e(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = Onr(t)) || e) {
      r && (t = r);
      var n = 0;
      return function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function Bnr(t) {
  return typeof t == "function";
}
var X5 = function(t, e, r) {
  r === void 0 && (r = e.children);
  var n = Qn(EYe);
  if (n.useCreateElement) return n.useCreateElement(t, e, r);
  if (typeof t == "string" && Bnr(r)) {
    e.children;
    var a = Iue(e, ["children"]);
    return r(a);
  }
  return Ds(t, e, r);
};
function Nnr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function H9e(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sv(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? H9e(Object(r), !0).forEach(function(n) {
      Nnr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : H9e(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function $nr(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function IYe(t) {
  return typeof t == "object" && t != null;
}
function Mue(t) {
  var e;
  if (!IYe(t)) return !1;
  var r = Object.getPrototypeOf(t);
  return r == null ? !0 : ((e = r.constructor) === null || e === void 0 ? void 0 : e.toString()) === Object.toString();
}
function U9e(t, e) {
  for (var r = Object.keys(t), n = {}, a = {}, i = 0, o = r; i < o.length; i++) {
    var s = o[i];
    e.indexOf(s) >= 0 ? n[s] = t[s] : a[s] = t[s];
  }
  return [n, a];
}
function V9e(t, e) {
  if (e === void 0 && (e = []), !Mue(t.state)) return U9e(t, e);
  var r = U9e(t, [].concat(e, ["state"])), n = r[0], a = r[1], i = n.state, o = $nr(n, ["state"]);
  return [Sv(Sv({}, i), o), a];
}
function x5(t, e) {
  if (t === e) return !0;
  if (!t || !e || typeof t != "object" || typeof e != "object") return !1;
  var r = Object.keys(t), n = Object.keys(e), a = r.length;
  if (n.length !== a) return !1;
  for (var i = 0, o = r; i < o.length; i++) {
    var s = o[i];
    if (t[s] !== e[s]) return !1;
  }
  return !0;
}
function q9e(t) {
  return t.name === "normalizePropsAreEqualInner" ? t : function(e, r) {
    return !Mue(e.state) || !Mue(r.state) ? t(e, r) : t(Sv(Sv({}, e.state), e), Sv(Sv({}, r.state), r));
  };
}
function Dnr(t) {
  return Ml(t);
}
function Lnr(t, e) {
  return Ls(t, e);
}
function so(t) {
  var e = t.as, r = t.useHook, n = t.memo, a = t.propsAreEqual, i = a === void 0 ? r == null ? void 0 : r.unstable_propsAreEqual : a, o = t.keys, s = o === void 0 ? (r == null ? void 0 : r.__keys) || [] : o, l = t.useCreateElement, c = l === void 0 ? X5 : l, u = function(f, h) {
    var p = f.as, g = p === void 0 ? e : p, y = Iue(f, ["as"]);
    if (r) {
      var b, w = V9e(y, s), _ = w[0], C = w[1], x = r(_, D9({ ref: h }, C)), S = x.wrapElement, A = Iue(x, ["wrapElement"]), I = ((b = g.render) === null || b === void 0 ? void 0 : b.__keys) || g.__keys, M = I && V9e(y, I)[0], B = M ? D9(D9({}, A), M) : A, L = c(g, B);
      return S ? S(L) : L;
    }
    return c(g, D9({ ref: h }, y));
  };
  return u = Dnr(u), n && (u = Lnr(u, i && q9e(i))), u.__keys = s, u.unstable_propsAreEqual = q9e(i || x5), u;
}
function MYe(t, e) {
  Mv(t);
  var r = Qn(EYe);
  return r[t] != null ? r[t] : e;
}
function jnr(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var n = "use" + t + "Props";
  Mv(n);
  var a = MYe(n);
  return a ? a(e, r) : r;
}
function Fnr(t, e, r) {
  e === void 0 && (e = {}), r === void 0 && (r = {});
  var n = "use" + t + "Options";
  Mv(n);
  var a = MYe(n);
  return a ? D9(D9({}, e), a(e, r)) : e;
}
function znr(t) {
  return Array.isArray(t) ? t : typeof t < "u" ? [t] : [];
}
function lo(t) {
  var e, r, n = znr(t.compose), a = function(s, l) {
    if (t.useOptions && (s = t.useOptions(s, l)), t.name && (s = Fnr(t.name, s, l)), t.compose) for (var c = W9e(n), u; !(u = c()).done; ) {
      var f = u.value;
      s = f.__useOptions(s, l);
    }
    return s;
  }, i = function(s, l, c) {
    if (s === void 0 && (s = {}), l === void 0 && (l = {}), c === void 0 && (c = !1), c || (s = a(s, l)), t.useProps && (l = t.useProps(s, l)), t.name && (l = jnr(t.name, s, l)), t.compose) if (t.useComposeOptions && (s = t.useComposeOptions(s, l)), t.useComposeProps) l = t.useComposeProps(s, l);
    else for (var u = W9e(n), f; !(f = u()).done; ) {
      var h = f.value;
      l = h(s, l, !0);
    }
    var p = {}, g = l || {};
    for (var y in g) g[y] !== void 0 && (p[y] = g[y]);
    return p;
  };
  i.__useOptions = a;
  var o = n.reduce(function(s, l) {
    return s.push.apply(s, l.__keys || []), s;
  }, []);
  return i.__keys = [].concat(o, ((e = t.useState) === null || e === void 0 ? void 0 : e.__keys) || [], t.keys || []), i.unstable_propsAreEqual = t.propsAreEqual || ((r = n[0]) === null || r === void 0 ? void 0 : r.unstable_propsAreEqual) || x5, i;
}
var Gnr = ["unstable_system"], PYe = lo({ name: "Box", keys: Gnr, propsAreEqual: function(t, e) {
  var r = t.unstable_system, n = qn(t, ["unstable_system"]), a = e.unstable_system, i = qn(e, ["unstable_system"]);
  return r !== a && !x5(r, a) ? !1 : x5(n, i);
} });
so({ as: "div", useHook: PYe });
function K9e(t, e) {
  e === void 0 && (e = null), t && (typeof t == "function" ? t(e) : t.current = e);
}
function Ac(t, e) {
  return fa(function() {
    return t == null && e == null ? null : function(r) {
      K9e(t, r), K9e(e, r);
    };
  }, [t, e]);
}
var Wnr = ["button", "color", "file", "image", "reset", "submit"];
function Zz(t) {
  if (t.tagName === "BUTTON") return !0;
  if (t.tagName === "INPUT") {
    var e = t;
    return Wnr.indexOf(e.type) !== -1;
  }
  return !1;
}
function sc(t) {
  return t ? t.ownerDocument || t : document;
}
var RYe;
try {
  RYe = window;
} catch {
}
function OYe(t) {
  return t && sc(t).defaultView || RYe;
}
function Hnr() {
  var t = OYe();
  return !!(typeof t < "u" && t.document && t.document.createElement);
}
var oM = Hnr(), Py = oM ? qh : Ut;
function Ua(t) {
  var e = Zt(t);
  return Py(function() {
    e.current = t;
  }), e;
}
function h1(t) {
  return t.target === t.currentTarget;
}
function E8(t) {
  var e = sc(t), r = e.activeElement;
  return r != null && r.nodeName ? r : null;
}
function W1(t, e) {
  return t === e || t.contains(e);
}
function sM(t) {
  var e = E8(t);
  if (!e) return !1;
  if (W1(t, e)) return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id ? !0 : !!t.querySelector("#" + r) : !1;
}
function Vhe(t) {
  return !W1(t.currentTarget, t.target);
}
function pb(t) {
  return oM ? window.navigator.userAgent.indexOf(t) !== -1 : !1;
}
function BYe(t, e) {
  return "matches" in t ? t.matches(e) : "msMatchesSelector" in t ? t.msMatchesSelector(e) : t.webkitMatchesSelector(e);
}
function NYe(t, e) {
  if ("closest" in t) return t.closest(e);
  do {
    if (BYe(t, e)) return t;
    t = t.parentElement || t.parentNode;
  } while (t !== null && t.nodeType === 1);
  return null;
}
var $Ye = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function Unr(t) {
  var e = t;
  return e.offsetWidth > 0 || e.offsetHeight > 0 || t.getClientRects().length > 0;
}
function Vnr(t) {
  var e = parseInt(t.getAttribute("tabindex") || "0", 10);
  return e < 0;
}
function DYe(t) {
  return BYe(t, $Ye) && Unr(t);
}
function Pue(t) {
  return DYe(t) && !Vnr(t);
}
function LYe(t, e) {
  var r = Array.from(t.querySelectorAll($Ye)), n = r.filter(Pue);
  return Pue(t) && n.unshift(t), !n.length && e ? r : n;
}
function jYe(t, e) {
  var r = LYe(t, e), n = r[0];
  return n || null;
}
function qnr(t, e) {
  var r = LYe(t, e);
  return r[r.length - 1] || null;
}
var Knr = ["unstable_system"], Ry = lo({ name: "Role", keys: Knr, propsAreEqual: function(t, e) {
  var r = t.unstable_system, n = qn(t, ["unstable_system"]), a = e.unstable_system, i = qn(e, ["unstable_system"]);
  return r !== a && !x5(r, a) ? !1 : x5(n, i);
} });
so({ as: "div", useHook: Ry });
var Znr = ["disabled", "focusable"], Jnr = pb("Mac") && !pb("Chrome") && (pb("Safari") || pb("Firefox"));
function Z9e(t) {
  !sM(t) && DYe(t) && t.focus();
}
function Ynr(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(t.tagName);
}
function Xnr(t) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(t.tagName);
}
function Qnr(t, e, r, n) {
  return t ? e && !r ? -1 : void 0 : e ? n : n || 0;
}
function uZ(t, e) {
  return sr(function(r) {
    var n;
    (n = t.current) === null || n === void 0 || n.call(t, r), !r.defaultPrevented && e && (r.stopPropagation(), r.preventDefault());
  }, [t, e]);
}
var kL = lo({ name: "Tabbable", compose: Ry, keys: Znr, useOptions: function(t, e) {
  var r = e.disabled;
  return Lt({ disabled: r }, t);
}, useProps: function(t, e) {
  var r = e.ref, n = e.tabIndex, a = e.onClickCapture, i = e.onMouseDownCapture, o = e.onMouseDown, s = e.onKeyPressCapture, l = e.style, c = qn(e, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]), u = Zt(null), f = Ua(a), h = Ua(i), p = Ua(o), g = Ua(s), y = !!t.disabled && !t.focusable, b = Yt(!0), w = b[0], _ = b[1], C = Yt(!0), x = C[0], S = C[1], A = t.disabled ? Lt({ pointerEvents: "none" }, l) : l;
  Py(function() {
    var N = u.current;
    !N || (Ynr(N) || _(!1), Xnr(N) || S(!1));
  }, []);
  var I = uZ(f, t.disabled), M = uZ(h, t.disabled), B = uZ(g, t.disabled), L = sr(function(N) {
    var d;
    (d = p.current) === null || d === void 0 || d.call(p, N);
    var m = N.currentTarget;
    if (!N.defaultPrevented && Jnr && !Vhe(N) && Zz(m)) {
      var v = requestAnimationFrame(function() {
        m.removeEventListener("mouseup", k, !0), Z9e(m);
      }), k = function() {
        cancelAnimationFrame(v), Z9e(m);
      };
      m.addEventListener("mouseup", k, { once: !0, capture: !0 });
    }
  }, []);
  return Lt({ ref: Ac(u, r), style: A, tabIndex: Qnr(y, w, x, n), disabled: y && x ? !0 : void 0, "aria-disabled": t.disabled ? !0 : void 0, onClickCapture: I, onMouseDownCapture: M, onMouseDown: L, onKeyPressCapture: B }, c);
} });
so({ as: "div", useHook: kL });
var ear = ["unstable_clickOnEnter", "unstable_clickOnSpace"];
function tar(t) {
  var e = t.currentTarget;
  return t.isTrusted ? Zz(e) || e.tagName === "INPUT" || e.tagName === "TEXTAREA" || e.tagName === "A" || e.tagName === "SELECT" : !1;
}
var g7 = lo({ name: "Clickable", compose: kL, keys: ear, useOptions: function(t) {
  var e = t.unstable_clickOnEnter, r = e === void 0 ? !0 : e, n = t.unstable_clickOnSpace, a = n === void 0 ? !0 : n, i = qn(t, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);
  return Lt({ unstable_clickOnEnter: r, unstable_clickOnSpace: a }, i);
}, useProps: function(t, e) {
  var r = e.onKeyDown, n = e.onKeyUp, a = qn(e, ["onKeyDown", "onKeyUp"]), i = Yt(!1), o = i[0], s = i[1], l = Ua(r), c = Ua(n), u = sr(function(h) {
    var p;
    if ((p = l.current) === null || p === void 0 || p.call(l, h), !h.defaultPrevented && !t.disabled && !h.metaKey && !!h1(h)) {
      var g = t.unstable_clickOnEnter && h.key === "Enter", y = t.unstable_clickOnSpace && h.key === " ";
      if (g || y) {
        if (tar(h)) return;
        h.preventDefault(), g ? h.currentTarget.click() : y && s(!0);
      }
    }
  }, [t.disabled, t.unstable_clickOnEnter, t.unstable_clickOnSpace]), f = sr(function(h) {
    var p;
    if ((p = c.current) === null || p === void 0 || p.call(c, h), !h.defaultPrevented && !t.disabled && !h.metaKey) {
      var g = t.unstable_clickOnSpace && h.key === " ";
      o && g && (s(!1), h.currentTarget.click());
    }
  }, [t.disabled, t.unstable_clickOnSpace, o]);
  return Lt({ "data-active": o || void 0, onKeyDown: u, onKeyUp: f }, a);
} });
so({ as: "button", memo: !0, useHook: g7 });
var rar = [], FYe = lo({ name: "Button", compose: g7, keys: rar, useProps: function(t, e) {
  var r = e.ref, n = qn(e, ["ref"]), a = Zt(null), i = Yt(void 0), o = i[0], s = i[1], l = Yt("button"), c = l[0], u = l[1];
  return Ut(function() {
    var f = a.current;
    !f || Zz(f) || (f.tagName !== "A" && s("button"), u(void 0));
  }, []), Lt({ ref: Ac(a, r), role: o, type: c }, n);
} });
so({ as: "button", memo: !0, useHook: FYe });
function zYe(t, e) {
  return e === -1 ? t : [].concat(t.slice(0, e), t.slice(e + 1));
}
function Jz(t, e, r) {
  if (typeof Event == "function") return new Event(e, r);
  var n = sc(t).createEvent("Event");
  return n.initEvent(e, r == null ? void 0 : r.bubbles, r == null ? void 0 : r.cancelable), n;
}
var nar = ["state", "setState"], aar = [].concat(nar, ["value", "checked"]);
function iar(t) {
  if (typeof t.checked < "u") return t.checked;
  if (typeof t.value > "u") return !!t.state;
  var e = Array.isArray(t.state) ? t.state : [];
  return e.indexOf(t.value) !== -1;
}
function oar(t, e) {
  var r = Jz(t, "change");
  Object.defineProperties(r, { type: { value: "change" }, target: { value: t }, currentTarget: { value: t } }), e == null || e(r);
}
function sar(t, e) {
  Ut(function() {
    var r = t.current;
    !r || (e.state === "indeterminate" ? r.indeterminate = !0 : r.indeterminate && (r.indeterminate = !1));
  }, [e.state, t]);
}
var GYe = lo({ name: "Checkbox", compose: g7, keys: aar, useOptions: function(t, e) {
  var r = e.value, n = e.checked, a = t.unstable_clickOnEnter, i = a === void 0 ? !1 : a, o = qn(t, ["unstable_clickOnEnter"]);
  return Lt({ unstable_clickOnEnter: i, value: r, checked: iar(Lt({ checked: n }, o)) }, o);
}, useProps: function(t, e) {
  var r = e.ref, n = e.onChange, a = e.onClick, i = qn(e, ["ref", "onChange", "onClick"]), o = Zt(null), s = Yt(!0), l = s[0], c = s[1], u = Ua(n), f = Ua(a);
  Ut(function() {
    var g = o.current;
    !g || (g.tagName !== "INPUT" || g.type !== "checkbox") && c(!1);
  }, []), sar(o, t);
  var h = sr(function(g) {
    var y = g.currentTarget;
    if (t.disabled) {
      g.stopPropagation(), g.preventDefault();
      return;
    }
    if (u.current && (l || (y.checked = !y.checked), u.current(g)), !!t.setState) if (typeof t.value > "u") t.setState(!t.checked);
    else {
      var b = Array.isArray(t.state) ? t.state : [], w = b.indexOf(t.value);
      w === -1 ? t.setState([].concat(b, [t.value])) : t.setState(zYe(b, w));
    }
  }, [t.disabled, l, t.setState, t.value, t.checked, t.state]), p = sr(function(g) {
    var y;
    (y = f.current) === null || y === void 0 || y.call(f, g), !g.defaultPrevented && (l || oar(g.currentTarget, h));
  }, [l, h]);
  return Lt({ ref: Ac(o, r), role: l ? void 0 : "checkbox", type: l ? "checkbox" : void 0, value: l ? t.value : void 0, checked: t.checked, "aria-checked": t.state === "indeterminate" ? "mixed" : t.checked, onChange: h, onClick: p }, i);
} });
so({ as: "input", memo: !0, useHook: GYe });
function cg(t) {
  var e = Yt(t), r = e[0];
  return r;
}
function WYe(t, e) {
  var r = Zt(!1);
  Ut(function() {
    if (r.current) return t();
    r.current = !0;
  }, e);
}
function J9e(t, e, r) {
  return r === void 0 && (r = {}), typeof FocusEvent == "function" ? new FocusEvent(e, r) : Jz(t, e, r);
}
function dZ(t, e) {
  var r = J9e(t, "blur", e), n = t.dispatchEvent(r), a = Sv(Sv({}, e), {}, { bubbles: !0 });
  return t.dispatchEvent(J9e(t, "focusout", a)), n;
}
function lar(t, e, r) {
  if (r === void 0 && (r = {}), typeof KeyboardEvent == "function") return new KeyboardEvent(e, r);
  var n = sc(t).createEvent("KeyboardEvent");
  return n.initKeyboardEvent(e, r.bubbles, r.cancelable, OYe(t), r.key, r.location, r.ctrlKey, r.altKey, r.shiftKey, r.metaKey), n;
}
function car(t, e, r) {
  return t.dispatchEvent(lar(t, e, r));
}
var uar = oM && "msCrypto" in window;
function HYe(t) {
  if (uar) {
    var e = E8(t.currentTarget);
    return e;
  }
  return t.relatedTarget;
}
function AL(t) {
  for (var e = [[]], r = function() {
    var i = a.value, o = e.find(function(s) {
      return !s[0] || s[0].groupId === i.groupId;
    });
    o ? o.push(i) : e.push([i]);
  }, n = Y5(t), a; !(a = n()).done; ) r();
  return e;
}
function Rue(t) {
  for (var e = [], r = Y5(t), n; !(n = r()).done; ) {
    var a = n.value;
    e.push.apply(e, a);
  }
  return e;
}
function C9(t) {
  return t.slice().reverse();
}
function um(t, e) {
  return e ? t.find(function(r) {
    return !r.disabled && r.id !== e;
  }) : t.find(function(r) {
    return !r.disabled;
  });
}
function nb(t, e) {
  var r;
  return e || e === null ? e : t.currentId || t.currentId === null ? t.currentId : (r = um(t.items || [])) === null || r === void 0 ? void 0 : r.id;
}
function TL(t, e) {
  if (e) return t == null ? void 0 : t.find(function(r) {
    return r.id === e && !r.disabled;
  });
}
var dar = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"], UYe = dar, VYe = UYe, far = VYe;
function qYe(t) {
  t.userFocus = !0, t.focus(), t.userFocus = !1;
}
function har(t) {
  return !!t.userFocus;
}
function Y9e(t, e) {
  t.userFocus = e;
}
var par = oM && "msCrypto" in window;
function mar(t) {
  return !(!h1(t) || t.metaKey || t.key === "Tab");
}
function X9e(t, e, r) {
  var n = Ua(r);
  return sr(function(a) {
    var i;
    if ((i = n.current) === null || i === void 0 || i.call(n, a), !a.defaultPrevented && t && mar(a)) {
      var o = e == null ? void 0 : e.ref.current;
      o && (car(o, a.type, a) || a.preventDefault(), a.currentTarget.contains(o) && a.stopPropagation());
    }
  }, [t, e]);
}
function gar(t) {
  var e = Zt(null);
  return Ut(function() {
    var r = sc(t.current), n = function(a) {
      var i = a.target;
      e.current = i;
    };
    return r.addEventListener("focus", n, !0), function() {
      r.removeEventListener("focus", n, !0);
    };
  }, []), e;
}
function yar(t) {
  return um(Rue(C9(AL(t))));
}
function fZ(t, e) {
  return t == null ? void 0 : t.some(function(r) {
    return !!e && r.ref.current === e;
  });
}
function bar(t) {
  var e = Ua(t), r = AI(function(i) {
    return i + 1;
  }, 0), n = r[0], a = r[1];
  return Ut(function() {
    var i, o = (i = e.current) === null || i === void 0 ? void 0 : i.ref.current;
    n && o && qYe(o);
  }, [n]), a;
}
var qhe = lo({ name: "Composite", compose: [kL], keys: UYe, useOptions: function(t) {
  return Lt(Lt({}, t), {}, { currentId: nb(t) });
}, useProps: function(t, e) {
  var r = e.ref, n = e.onFocusCapture, a = e.onFocus, i = e.onBlurCapture, o = e.onKeyDown, s = e.onKeyDownCapture, l = e.onKeyUpCapture, c = qn(e, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]), u = Zt(null), f = TL(t.items, t.currentId), h = Zt(null), p = Ua(n), g = Ua(a), y = Ua(i), b = Ua(o), w = bar(f), _ = par ? gar(u) : void 0;
  Ut(function() {
    var B = u.current;
    t.unstable_moves && !f && (B == null || B.focus());
  }, [t.unstable_moves, f]);
  var C = X9e(t.unstable_virtual, f, s), x = X9e(t.unstable_virtual, f, l), S = sr(function(B) {
    var L;
    if ((L = p.current) === null || L === void 0 || L.call(p, B), !B.defaultPrevented && !!t.unstable_virtual) {
      var N = (_ == null ? void 0 : _.current) || B.relatedTarget, d = fZ(t.items, N);
      h1(B) && d && (B.stopPropagation(), h.current = N);
    }
  }, [t.unstable_virtual, t.items]), A = sr(function(B) {
    var L;
    if ((L = g.current) === null || L === void 0 || L.call(g, B), !B.defaultPrevented) {
      if (t.unstable_virtual) h1(B) && w();
      else if (h1(B)) {
        var N;
        (N = t.setCurrentId) === null || N === void 0 || N.call(t, null);
      }
    }
  }, [t.unstable_virtual, t.setCurrentId]), I = sr(function(B) {
    var L;
    if ((L = y.current) === null || L === void 0 || L.call(y, B), !B.defaultPrevented && !!t.unstable_virtual) {
      var N = (f == null ? void 0 : f.ref.current) || null, d = HYe(B), m = fZ(t.items, d);
      if (h1(B) && m) d === N ? h.current && h.current !== d && dZ(h.current, B) : N && dZ(N, B), B.stopPropagation();
      else {
        var v = fZ(t.items, B.target);
        !v && N && dZ(N, B);
      }
    }
  }, [t.unstable_virtual, t.items, f]), M = sr(function(B) {
    var L, N;
    if ((L = b.current) === null || L === void 0 || L.call(b, B), !B.defaultPrevented && t.currentId === null && !!h1(B)) {
      var d = t.orientation !== "horizontal", m = t.orientation !== "vertical", v = !!((N = t.groups) !== null && N !== void 0 && N.length), k = function() {
        if (v) {
          var H = yar(t.items);
          if (H != null && H.id) {
            var j;
            (j = t.move) === null || j === void 0 || j.call(t, H.id);
          }
        } else {
          var F;
          (F = t.last) === null || F === void 0 || F.call(t);
        }
      }, O = { ArrowUp: (v || d) && k, ArrowRight: (v || m) && t.first, ArrowDown: (v || d) && t.first, ArrowLeft: (v || m) && t.last, Home: t.first, End: t.last, PageUp: t.first, PageDown: t.last }, G = O[B.key];
      G && (B.preventDefault(), G());
    }
  }, [t.currentId, t.orientation, t.groups, t.items, t.move, t.last, t.first]);
  return Lt({ ref: Ac(u, r), id: t.baseId, onFocus: A, onFocusCapture: S, onBlurCapture: I, onKeyDownCapture: C, onKeyDown: M, onKeyUpCapture: x, "aria-activedescendant": t.unstable_virtual && (f == null ? void 0 : f.id) || void 0 }, c);
}, useComposeProps: function(t, e) {
  e = Ry(t, e, !0);
  var r = kL(t, e, !0);
  return t.unstable_virtual || t.currentId === null ? Lt({ tabIndex: 0 }, r) : Lt(Lt({}, e), {}, { ref: r.ref });
} }), KYe = so({ as: "div", useHook: qhe, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} });
function Q9e(t) {
  try {
    var e = t instanceof HTMLInputElement && t.selectionStart !== null, r = t.tagName === "TEXTAREA", n = t.contentEditable === "true";
    return e || r || n || !1;
  } catch {
    return !1;
  }
}
function xar(t) {
  var e = E8(t);
  if (!e) return !1;
  if (e === t) return !0;
  var r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function $T(t, e) {
  var r = e === void 0 ? {} : e, n = r.preventScroll, a = r.isActive, i = a === void 0 ? xar : a;
  return i(t) || (t.focus({ preventScroll: n }), i(t)) ? -1 : requestAnimationFrame(function() {
    t.focus({ preventScroll: n });
  });
}
var Car = "id";
function war(t) {
  return t === void 0 && (t = Car), (t ? t + "-" : "") + Math.random().toString(32).substr(2, 6);
}
var ZYe = Bo(war), Sar = ["baseId", "unstable_idCountRef", "setBaseId"], _ar = [].concat(Sar, ["id"]), Yz = lo({ keys: _ar, useOptions: function(t, e) {
  var r = Qn(ZYe), n = Yt(function() {
    return t.unstable_idCountRef ? (t.unstable_idCountRef.current += 1, "-" + t.unstable_idCountRef.current) : t.baseId ? "-" + r("") : "";
  }), a = n[0], i = fa(function() {
    return t.baseId || r();
  }, [t.baseId, r]), o = e.id || t.id || "" + i + a;
  return Lt(Lt({}, t), {}, { id: o });
}, useProps: function(t, e) {
  return Lt({ id: t.id }, e);
} });
so({ as: "div", useHook: Yz });
function kar(t, e, r) {
  return t.dispatchEvent(Jz(t, e, r));
}
function e7e(t, e) {
  if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement) {
    var r, n = Object.getPrototypeOf(t), a = (r = Object.getOwnPropertyDescriptor(n, "value")) === null || r === void 0 ? void 0 : r.set;
    a && (a.call(t, e), kar(t, "input", { bubbles: !0 }));
  }
}
function hZ(t) {
  return t.querySelector("[data-composite-item-widget]");
}
function Aar(t) {
  return fa(function() {
    var e;
    return (e = t.items) === null || e === void 0 ? void 0 : e.find(function(r) {
      return t.id && r.id === t.id;
    });
  }, [t.items, t.id]);
}
function Tar(t, e) {
  if (h1(t)) return !1;
  for (var r = Y5(e), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.ref.current === t.target) return !0;
  }
  return !1;
}
var DT = lo({ name: "CompositeItem", compose: [g7, Yz], keys: far, propsAreEqual: function(t, e) {
  if (!e.id || t.id !== e.id) return g7.unstable_propsAreEqual(t, e);
  var r = t.currentId, n = t.unstable_moves, a = qn(t, ["currentId", "unstable_moves"]), i = e.currentId, o = e.unstable_moves, s = qn(e, ["currentId", "unstable_moves"]);
  if (i !== r) {
    if (e.id === i || e.id === r) return !1;
  } else if (n !== o) return !1;
  return g7.unstable_propsAreEqual(a, s);
}, useOptions: function(t) {
  return Lt(Lt({}, t), {}, { id: t.id, currentId: nb(t), unstable_clickOnSpace: t.unstable_hasActiveWidget ? !1 : t.unstable_clickOnSpace });
}, useProps: function(t, e) {
  var r, n = e.ref, a = e.tabIndex, i = a === void 0 ? 0 : a, o = e.onMouseDown, s = e.onFocus, l = e.onBlurCapture, c = e.onKeyDown, u = e.onClick, f = qn(e, ["ref", "tabIndex", "onMouseDown", "onFocus", "onBlurCapture", "onKeyDown", "onClick"]), h = Zt(null), p = t.id, g = t.disabled && !t.focusable, y = t.currentId === p, b = Ua(y), w = Zt(!1), _ = Aar(t), C = Ua(o), x = Ua(s), S = Ua(l), A = Ua(c), I = Ua(u), M = !t.unstable_virtual && !t.unstable_hasActiveWidget && y || !((r = t.items) !== null && r !== void 0 && r.length);
  Ut(function() {
    var v;
    if (p) return (v = t.registerItem) === null || v === void 0 || v.call(t, { id: p, ref: h, disabled: !!g }), function() {
      var k;
      (k = t.unregisterItem) === null || k === void 0 || k.call(t, p);
    };
  }, [p, g, t.registerItem, t.unregisterItem]), Ut(function() {
    var v = h.current;
    !v || t.unstable_moves && b.current && qYe(v);
  }, [t.unstable_moves]);
  var B = sr(function(v) {
    var k;
    (k = C.current) === null || k === void 0 || k.call(C, v), Y9e(v.currentTarget, !0);
  }, []), L = sr(function(v) {
    var k, O, G = har(v.currentTarget);
    if (Y9e(v.currentTarget, !1), (k = x.current) === null || k === void 0 || k.call(x, v), !v.defaultPrevented && !Vhe(v) && !!p && !Tar(v, t.items) && ((O = t.setCurrentId) === null || O === void 0 || O.call(t, p), G && t.unstable_virtual && t.baseId && h1(v))) {
      var H = v.target, j = sc(H).getElementById(t.baseId);
      j && (w.current = !0, $T(j));
    }
  }, [p, t.items, t.setCurrentId, t.unstable_virtual, t.baseId]), N = sr(function(v) {
    var k;
    (k = S.current) === null || k === void 0 || k.call(S, v), !v.defaultPrevented && t.unstable_virtual && w.current && (w.current = !1, v.preventDefault(), v.stopPropagation());
  }, [t.unstable_virtual]), d = sr(function(v) {
    var k;
    if (h1(v)) {
      var O = t.orientation !== "horizontal", G = t.orientation !== "vertical", H = !!(_ != null && _.groupId), j = { ArrowUp: (H || O) && t.up, ArrowRight: (H || G) && t.next, ArrowDown: (H || O) && t.down, ArrowLeft: (H || G) && t.previous, Home: function() {
        if (!H || v.ctrlKey) {
          var U;
          (U = t.first) === null || U === void 0 || U.call(t);
        } else {
          var Z;
          (Z = t.previous) === null || Z === void 0 || Z.call(t, !0);
        }
      }, End: function() {
        if (!H || v.ctrlKey) {
          var U;
          (U = t.last) === null || U === void 0 || U.call(t);
        } else {
          var Z;
          (Z = t.next) === null || Z === void 0 || Z.call(t, !0);
        }
      }, PageUp: function() {
        if (H) {
          var U;
          (U = t.up) === null || U === void 0 || U.call(t, !0);
        } else {
          var Z;
          (Z = t.first) === null || Z === void 0 || Z.call(t);
        }
      }, PageDown: function() {
        if (H) {
          var U;
          (U = t.down) === null || U === void 0 || U.call(t, !0);
        } else {
          var Z;
          (Z = t.last) === null || Z === void 0 || Z.call(t);
        }
      } }, F = j[v.key];
      if (F) {
        v.preventDefault(), F();
        return;
      }
      if ((k = A.current) === null || k === void 0 || k.call(A, v), !v.defaultPrevented) {
        if (v.key.length === 1 && v.key !== " ") {
          var z = hZ(v.currentTarget);
          z && Q9e(z) && (z.focus(), e7e(z, ""));
        } else if (v.key === "Delete" || v.key === "Backspace") {
          var W = hZ(v.currentTarget);
          W && Q9e(W) && (v.preventDefault(), e7e(W, ""));
        }
      }
    }
  }, [t.orientation, _, t.up, t.next, t.down, t.previous, t.first, t.last]), m = sr(function(v) {
    var k;
    if ((k = I.current) === null || k === void 0 || k.call(I, v), !v.defaultPrevented) {
      var O = v.currentTarget, G = hZ(O);
      G && !sM(G) && G.focus();
    }
  }, []);
  return Lt({ ref: Ac(h, n), id: p, tabIndex: M ? i : -1, "aria-selected": t.unstable_virtual && y ? !0 : void 0, onMouseDown: B, onFocus: L, onBlurCapture: N, onKeyDown: d, onClick: m }, f);
} }), JYe = so({ as: "button", memo: !0, useHook: DT }), Ear = [], l$ = lo({ name: "Group", compose: Ry, keys: Ear, useProps: function(t, e) {
  return Lt({ role: "group" }, e);
} });
so({ as: "div", useHook: l$ });
var Iar = lo({ name: "CompositeGroup", compose: [l$, Yz], keys: VYe, propsAreEqual: function(t, e) {
  if (!e.id || t.id !== e.id) return l$.unstable_propsAreEqual(t, e);
  var r = t.currentId;
  t.unstable_moves;
  var n = qn(t, ["currentId", "unstable_moves"]), a = e.currentId;
  e.unstable_moves;
  var i = qn(e, ["currentId", "unstable_moves"]);
  if (t.items && e.items) {
    var o = TL(t.items, r), s = TL(e.items, a), l = o == null ? void 0 : o.groupId, c = s == null ? void 0 : s.groupId;
    if (e.id === c || e.id === l) return !1;
  }
  return l$.unstable_propsAreEqual(n, i);
}, useProps: function(t, e) {
  var r = e.ref, n = qn(e, ["ref"]), a = Zt(null), i = t.id;
  return Py(function() {
    var o;
    if (i) return (o = t.registerGroup) === null || o === void 0 || o.call(t, { id: i, ref: a }), function() {
      var s;
      (s = t.unregisterGroup) === null || s === void 0 || s.call(t, i);
    };
  }, [i, t.registerGroup, t.unregisterGroup]), Lt({ ref: Ac(a, r) }, n);
} }), Mar = so({ as: "div", useHook: Iar });
function Par(t) {
  return typeof t == "function";
}
function Zg(t, e) {
  return Par(t) ? t(e) : t;
}
function YYe(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.baseId, n = Qn(ZYe), a = Zt(0), i = Yt(function() {
    return r || n();
  }), o = i[0], s = i[1];
  return { baseId: o, setBaseId: s, unstable_idCountRef: a };
}
function XYe(t, e) {
  return !!(e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
function t7e(t, e) {
  return t.findIndex(function(r) {
    return !r.ref.current || !e.ref.current ? !1 : XYe(e.ref.current, r.ref.current);
  });
}
function QYe(t) {
  for (var e = 0, r = Y5(t), n; !(n = r()).done; ) {
    var a = n.value.length;
    a > e && (e = a);
  }
  return e;
}
function r7e(t) {
  for (var e = AL(t), r = QYe(e), n = [], a = 0; a < r; a += 1) for (var i = Y5(e), o; !(o = i()).done; ) {
    var s = o.value;
    s[a] && n.push(Lt(Lt({}, s[a]), {}, { groupId: s[a].groupId ? "" + a : void 0 }));
  }
  return n;
}
function Rar(t) {
  return { id: "__EMPTY_ITEM__", disabled: !0, ref: { current: null }, groupId: t };
}
function n7e(t, e, r) {
  for (var n = QYe(t), a = Y5(t), i; !(i = a()).done; ) for (var o = i.value, s = 0; s < n; s += 1) {
    var l = o[s];
    if (!l || r && l.disabled) {
      var c = s === 0, u = c && r ? um(o) : o[s - 1];
      o[s] = u && e !== (u == null ? void 0 : u.id) && r ? u : Rar(u == null ? void 0 : u.groupId);
    }
  }
  return t;
}
var Oar = { id: null, ref: { current: null } };
function Bar(t, e, r) {
  var n = t.findIndex(function(a) {
    return a.id === e;
  });
  return [].concat(t.slice(n + 1), r ? [Oar] : [], t.slice(0, n));
}
function pZ(t, e) {
  return t.filter(function(r) {
    return r.groupId === e;
  });
}
var Nar = { horizontal: "vertical", vertical: "horizontal" };
function $ar(t) {
  return t && Nar[t];
}
function a7e(t, e, r) {
  return r in t ? [].concat(t.slice(0, r), [e], t.slice(r)) : [].concat(t, [e]);
}
function Oue(t) {
  var e = t.map(function(n, a) {
    return [a, n];
  }), r = !1;
  return e.sort(function(n, a) {
    var i = n[0], o = n[1], s = a[0], l = a[1], c = o.ref.current, u = l.ref.current;
    return !c || !u ? 0 : XYe(c, u) ? (i > s && (r = !0), -1) : (i < s && (r = !0), 1);
  }), r ? e.map(function(n) {
    n[0];
    var a = n[1];
    return a;
  }) : t;
}
function eXe(t, e) {
  var r = Oue(t);
  t !== r && e(r);
}
function Dar(t) {
  for (var e, r = t[0], n = t.slice(1), a = r == null || (e = r.ref.current) === null || e === void 0 ? void 0 : e.parentElement, i = function() {
    var s = a;
    if (n.every(function(l) {
      return s.contains(l.ref.current);
    })) return { v: a };
    a = a.parentElement;
  }; a; ) {
    var o = i();
    if (typeof o == "object") return o.v;
  }
  return sc(a).body;
}
function Lar(t, e) {
  var r = Zt([]);
  Ut(function() {
    for (var n = function() {
      var c = !!r.current.length;
      c && eXe(t, e), r.current = t;
    }, a = Dar(t), i = new IntersectionObserver(n, { root: a }), o = Y5(t), s; !(s = o()).done; ) {
      var l = s.value;
      l.ref.current && i.observe(l.ref.current);
    }
    return function() {
      i.disconnect();
    };
  }, [t]);
}
function jar(t, e) {
  Ut(function() {
    var r = function() {
      return eXe(t, e);
    }, n = setTimeout(r, 250);
    return function() {
      return clearTimeout(n);
    };
  });
}
function Far(t, e) {
  typeof IntersectionObserver == "function" ? Lar(t, e) : jar(t, e);
}
function Hd(t, e) {
  var r = t.unstable_virtual, n = t.rtl, a = t.orientation, i = t.items, o = t.groups, s = t.currentId, l = t.loop, c = t.wrap, u = t.pastIds, f = t.shift, h = t.unstable_moves, p = t.unstable_includesBaseElement, g = t.initialVirtual, y = t.initialRTL, b = t.initialOrientation, w = t.initialCurrentId, _ = t.initialLoop, C = t.initialWrap, x = t.initialShift, S = t.hasSetCurrentId;
  switch (e.type) {
    case "registerGroup": {
      var A = e.group;
      if (o.length === 0) return Lt(Lt({}, t), {}, { groups: [A] });
      var I = t7e(o, A);
      return Lt(Lt({}, t), {}, { groups: a7e(o, A, I) });
    }
    case "unregisterGroup": {
      var M = e.id, B = o.filter(function(Je) {
        return Je.id !== M;
      });
      return B.length === o.length ? t : Lt(Lt({}, t), {}, { groups: B });
    }
    case "registerItem": {
      var L = e.item, N = o.find(function(Je) {
        var tt;
        return (tt = Je.ref.current) === null || tt === void 0 ? void 0 : tt.contains(L.ref.current);
      }), d = Lt({ groupId: N == null ? void 0 : N.id }, L), m = t7e(i, d), v = Lt(Lt({}, t), {}, { items: a7e(i, d, m) });
      if (!S && !h && w === void 0) {
        var k;
        return Lt(Lt({}, v), {}, { currentId: (k = um(v.items)) === null || k === void 0 ? void 0 : k.id });
      }
      return v;
    }
    case "unregisterItem": {
      var O = e.id, G = i.filter(function(Je) {
        return Je.id !== O;
      });
      if (G.length === i.length) return t;
      var H = u.filter(function(Je) {
        return Je !== O;
      }), j = Lt(Lt({}, t), {}, { pastIds: H, items: G });
      if (s && s === O) {
        var F = p ? null : nb(Lt(Lt({}, j), {}, { currentId: H[0] }));
        return Lt(Lt({}, j), {}, { currentId: F });
      }
      return j;
    }
    case "move": {
      var z = e.id;
      if (z === void 0) return t;
      var W = u.filter(function(Je) {
        return Je !== s && Je !== z;
      }), U = s ? [s].concat(W) : W, Z = Lt(Lt({}, t), {}, { pastIds: U });
      if (z === null) return Lt(Lt({}, Z), {}, { unstable_moves: h + 1, currentId: nb(Z, z) });
      var V = TL(i, z);
      return Lt(Lt({}, Z), {}, { unstable_moves: V ? h + 1 : h, currentId: nb(Z, V == null ? void 0 : V.id) });
    }
    case "next": {
      if (s == null) return Hd(t, Lt(Lt({}, e), {}, { type: "first" }));
      var Y = a !== "vertical", ge = n && Y, ce = ge ? C9(i) : i, ee = ce.find(function(Je) {
        return Je.id === s;
      });
      if (!ee) return Hd(t, Lt(Lt({}, e), {}, { type: "first" }));
      var Se = !!ee.groupId, Ce = ce.indexOf(ee), we = ce.slice(Ce + 1), We = pZ(we, ee.groupId);
      if (e.allTheWay) {
        var Fe = um(ge ? pZ(ce, ee.groupId) : C9(We));
        return Hd(t, Lt(Lt({}, e), {}, { type: "move", id: Fe == null ? void 0 : Fe.id }));
      }
      var it = $ar(Se ? a || "horizontal" : a), gt = l && l !== it, Ze = Se && c && c !== it, Ne = e.hasNullItem || !Se && gt && p;
      if (gt) {
        var ze = Ze && !Ne ? ce : pZ(ce, ee.groupId), ct = Bar(ze, s, Ne), rt = um(ct, s);
        return Hd(t, Lt(Lt({}, e), {}, { type: "move", id: rt == null ? void 0 : rt.id }));
      }
      if (Ze) {
        var qe = um(Ne ? We : we, s), nt = Ne ? (qe == null ? void 0 : qe.id) || null : qe == null ? void 0 : qe.id;
        return Hd(t, Lt(Lt({}, e), {}, { type: "move", id: nt }));
      }
      var Rt = um(We, s);
      return !Rt && Ne ? Hd(t, Lt(Lt({}, e), {}, { type: "move", id: null })) : Hd(t, Lt(Lt({}, e), {}, { type: "move", id: Rt == null ? void 0 : Rt.id }));
    }
    case "previous": {
      var Ot = !!o.length, lt = !Ot && p, mt = Hd(Lt(Lt({}, t), {}, { items: C9(i) }), Lt(Lt({}, e), {}, { type: "next", hasNullItem: lt }));
      return Lt(Lt({}, mt), {}, { items: i });
    }
    case "down": {
      var jt = f && !e.allTheWay, Jt = r7e(Rue(n7e(AL(i), s, jt))), ne = l && l !== "horizontal", re = ne && p, ie = Hd(Lt(Lt({}, t), {}, { orientation: "vertical", items: Jt }), Lt(Lt({}, e), {}, { type: "next", hasNullItem: re }));
      return Lt(Lt({}, ie), {}, { orientation: a, items: i });
    }
    case "up": {
      var Ie = f && !e.allTheWay, Ke = r7e(C9(Rue(n7e(AL(i), s, Ie)))), Le = p, Ge = Hd(Lt(Lt({}, t), {}, { orientation: "vertical", items: Ke }), Lt(Lt({}, e), {}, { type: "next", hasNullItem: Le }));
      return Lt(Lt({}, Ge), {}, { orientation: a, items: i });
    }
    case "first": {
      var ft = um(i);
      return Hd(t, Lt(Lt({}, e), {}, { type: "move", id: ft == null ? void 0 : ft.id }));
    }
    case "last": {
      var ot = Hd(Lt(Lt({}, t), {}, { items: C9(i) }), Lt(Lt({}, e), {}, { type: "first" }));
      return Lt(Lt({}, ot), {}, { items: i });
    }
    case "sort":
      return Lt(Lt({}, t), {}, { items: Oue(i), groups: Oue(o) });
    case "setVirtual":
      return Lt(Lt({}, t), {}, { unstable_virtual: Zg(e.virtual, r) });
    case "setRTL":
      return Lt(Lt({}, t), {}, { rtl: Zg(e.rtl, n) });
    case "setOrientation":
      return Lt(Lt({}, t), {}, { orientation: Zg(e.orientation, a) });
    case "setCurrentId": {
      var Ye = nb(Lt(Lt({}, t), {}, { currentId: Zg(e.currentId, s) }));
      return Lt(Lt({}, t), {}, { currentId: Ye, hasSetCurrentId: !0 });
    }
    case "setLoop":
      return Lt(Lt({}, t), {}, { loop: Zg(e.loop, l) });
    case "setWrap":
      return Lt(Lt({}, t), {}, { wrap: Zg(e.wrap, c) });
    case "setShift":
      return Lt(Lt({}, t), {}, { shift: Zg(e.shift, f) });
    case "setIncludesBaseElement":
      return Lt(Lt({}, t), {}, { unstable_includesBaseElement: Zg(e.includesBaseElement, p) });
    case "reset":
      return Lt(Lt({}, t), {}, { unstable_virtual: g, rtl: y, orientation: b, currentId: nb(Lt(Lt({}, t), {}, { currentId: w })), loop: _, wrap: C, shift: x, unstable_moves: 0, pastIds: [] });
    case "setItems":
      return Lt(Lt({}, t), {}, { items: e.items });
    default:
      throw new Error();
  }
}
function rl(t) {
  return sr(t, []);
}
function zar() {
  var t = Zt(!1);
  return Py(function() {
    return function() {
      t.current = !0;
    };
  }, []), t;
}
function LT(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.unstable_virtual, n = r === void 0 ? !1 : r, a = e.rtl, i = a === void 0 ? !1 : a, o = e.orientation, s = e.currentId, l = e.loop, c = l === void 0 ? !1 : l, u = e.wrap, f = u === void 0 ? !1 : u, h = e.shift, p = h === void 0 ? !1 : h, g = e.unstable_includesBaseElement, y = qn(e, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]), b = YYe(y), w = AI(Hd, { unstable_virtual: n, rtl: i, orientation: o, items: [], groups: [], currentId: s, loop: c, wrap: f, shift: p, unstable_moves: 0, pastIds: [], unstable_includesBaseElement: g ?? s === null, initialVirtual: n, initialRTL: i, initialOrientation: o, initialCurrentId: s, initialLoop: c, initialWrap: f, initialShift: p }), _ = w[0];
  _.pastIds, _.initialVirtual, _.initialRTL, _.initialOrientation, _.initialCurrentId, _.initialLoop, _.initialWrap, _.initialShift, _.hasSetCurrentId;
  var C = qn(_, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]), x = w[1], S = Yt(!1), A = S[0], I = S[1], M = zar(), B = sr(function(L) {
    return x({ type: "setItems", items: L });
  }, []);
  return Far(C.items, B), Lt(Lt(Lt({}, b), C), {}, { unstable_hasActiveWidget: A, unstable_setHasActiveWidget: I, registerItem: rl(function(L) {
    M.current || x({ type: "registerItem", item: L });
  }), unregisterItem: rl(function(L) {
    M.current || x({ type: "unregisterItem", id: L });
  }), registerGroup: rl(function(L) {
    M.current || x({ type: "registerGroup", group: L });
  }), unregisterGroup: rl(function(L) {
    M.current || x({ type: "unregisterGroup", id: L });
  }), move: rl(function(L) {
    return x({ type: "move", id: L });
  }), next: rl(function(L) {
    return x({ type: "next", allTheWay: L });
  }), previous: rl(function(L) {
    return x({ type: "previous", allTheWay: L });
  }), up: rl(function(L) {
    return x({ type: "up", allTheWay: L });
  }), down: rl(function(L) {
    return x({ type: "down", allTheWay: L });
  }), first: rl(function() {
    return x({ type: "first" });
  }), last: rl(function() {
    return x({ type: "last" });
  }), sort: rl(function() {
    return x({ type: "sort" });
  }), unstable_setVirtual: rl(function(L) {
    return x({ type: "setVirtual", virtual: L });
  }), setRTL: rl(function(L) {
    return x({ type: "setRTL", rtl: L });
  }), setOrientation: rl(function(L) {
    return x({ type: "setOrientation", orientation: L });
  }), setCurrentId: rl(function(L) {
    return x({ type: "setCurrentId", currentId: L });
  }), setLoop: rl(function(L) {
    return x({ type: "setLoop", loop: L });
  }), setWrap: rl(function(L) {
    return x({ type: "setWrap", wrap: L });
  }), setShift: rl(function(L) {
    return x({ type: "setShift", shift: L });
  }), unstable_setIncludesBaseElement: rl(function(L) {
    return x({ type: "setIncludesBaseElement", includesBaseElement: L });
  }), reset: rl(function() {
    return x({ type: "reset" });
  }) });
}
var ff = "top", H1 = "bottom", U1 = "right", hf = "left", Khe = "auto", lM = [ff, H1, U1, hf], vx = "start", Zhe = "end", Gar = "clippingParents", tXe = "viewport", Yw = "popper", War = "reference", i7e = lM.reduce(function(t, e) {
  return t.concat([e + "-" + vx, e + "-" + Zhe]);
}, []), rXe = [].concat(lM, [Khe]).reduce(function(t, e) {
  return t.concat([e, e + "-" + vx, e + "-" + Zhe]);
}, []), Har = "beforeRead", Uar = "read", Var = "afterRead", qar = "beforeMain", Kar = "main", Zar = "afterMain", Jar = "beforeWrite", Yar = "write", Xar = "afterWrite", Qar = [Har, Uar, Var, qar, Kar, Zar, Jar, Yar, Xar];
function Fh(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function l2(t) {
  if (t == null) return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function jT(t) {
  var e = l2(t).Element;
  return t instanceof e || t instanceof Element;
}
function V1(t) {
  var e = l2(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function nXe(t) {
  if (typeof ShadowRoot > "u") return !1;
  var e = l2(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function eir(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(r) {
    var n = e.styles[r] || {}, a = e.attributes[r] || {}, i = e.elements[r];
    !V1(i) || !Fh(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function tir(t) {
  var e = t.state, r = { popper: { position: e.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
  return Object.assign(e.elements.popper.style, r.popper), e.styles = r, e.elements.arrow && Object.assign(e.elements.arrow.style, r.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var a = e.elements[n], i = e.attributes[n] || {}, o = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : r[n]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !V1(a) || !Fh(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
var rir = { name: "applyStyles", enabled: !0, phase: "write", fn: eir, effect: tir, requires: ["computeStyles"] };
function gh(t) {
  return t.split("-")[0];
}
function yx(t) {
  var e = t.getBoundingClientRect();
  return { width: e.width, height: e.height, top: e.top, right: e.right, bottom: e.bottom, left: e.left, x: e.left, y: e.top };
}
function Jhe(t) {
  var e = yx(t), r = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - r) <= 1 && (r = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), { x: t.offsetLeft, y: t.offsetTop, width: r, height: n };
}
function aXe(t, e) {
  var r = e.getRootNode && e.getRootNode();
  if (t.contains(e)) return !0;
  if (r && nXe(r)) {
    var n = e;
    do {
      if (n && t.isSameNode(n)) return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Um(t) {
  return l2(t).getComputedStyle(t);
}
function nir(t) {
  return ["table", "td", "th"].indexOf(Fh(t)) >= 0;
}
function Oy(t) {
  return ((jT(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function Xz(t) {
  return Fh(t) === "html" ? t : t.assignedSlot || t.parentNode || (nXe(t) ? t.host : null) || Oy(t);
}
function o7e(t) {
  return !V1(t) || Um(t).position === "fixed" ? null : t.offsetParent;
}
function air(t) {
  var e = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, r = navigator.userAgent.indexOf("Trident") !== -1;
  if (r && V1(t)) {
    var n = Um(t);
    if (n.position === "fixed") return null;
  }
  for (var a = Xz(t); V1(a) && ["html", "body"].indexOf(Fh(a)) < 0; ) {
    var i = Um(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none") return a;
    a = a.parentNode;
  }
  return null;
}
function cM(t) {
  for (var e = l2(t), r = o7e(t); r && nir(r) && Um(r).position === "static"; ) r = o7e(r);
  return r && (Fh(r) === "html" || Fh(r) === "body" && Um(r).position === "static") ? e : r || air(t) || e;
}
function Yhe(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
var Nv = Math.max, FT = Math.min, mB = Math.round;
function c$(t, e, r) {
  return Nv(t, FT(e, r));
}
function iXe() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
function oXe(t) {
  return Object.assign({}, iXe(), t);
}
function sXe(t, e) {
  return e.reduce(function(r, n) {
    return r[n] = t, r;
  }, {});
}
var iir = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, { placement: e.placement })) : t, oXe(typeof t != "number" ? t : sXe(t, lM));
};
function oir(t) {
  var e, r = t.state, n = t.name, a = t.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = gh(r.placement), l = Yhe(s), c = [hf, U1].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!i || !o)) {
    var f = iir(a.padding, r), h = Jhe(i), p = l === "y" ? ff : hf, g = l === "y" ? H1 : U1, y = r.rects.reference[u] + r.rects.reference[l] - o[l] - r.rects.popper[u], b = o[l] - r.rects.reference[l], w = cM(i), _ = w ? l === "y" ? w.clientHeight || 0 : w.clientWidth || 0 : 0, C = y / 2 - b / 2, x = f[p], S = _ - h[u] - f[g], A = _ / 2 - h[u] / 2 + C, I = c$(x, A, S), M = l;
    r.modifiersData[n] = (e = {}, e[M] = I, e.centerOffset = I - A, e);
  }
}
function sir(t) {
  var e = t.state, r = t.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = e.elements.popper.querySelector(a), !a) || !aXe(e.elements.popper, a) || (e.elements.arrow = a));
}
var lir = { name: "arrow", enabled: !0, phase: "main", fn: oir, effect: sir, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] }, cir = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function uir(t) {
  var e = t.x, r = t.y, n = window, a = n.devicePixelRatio || 1;
  return { x: mB(mB(e * a) / a) || 0, y: mB(mB(r * a) / a) || 0 };
}
function s7e(t) {
  var e, r = t.popper, n = t.popperRect, a = t.placement, i = t.offsets, o = t.position, s = t.gpuAcceleration, l = t.adaptive, c = t.roundOffsets, u = c === !0 ? uir(i) : typeof c == "function" ? c(i) : i, f = u.x, h = f === void 0 ? 0 : f, p = u.y, g = p === void 0 ? 0 : p, y = i.hasOwnProperty("x"), b = i.hasOwnProperty("y"), w = hf, _ = ff, C = window;
  if (l) {
    var x = cM(r), S = "clientHeight", A = "clientWidth";
    x === l2(r) && (x = Oy(r), Um(x).position !== "static" && (S = "scrollHeight", A = "scrollWidth")), x = x, a === ff && (_ = H1, g -= x[S] - n.height, g *= s ? 1 : -1), a === hf && (w = U1, h -= x[A] - n.width, h *= s ? 1 : -1);
  }
  var I = Object.assign({ position: o }, l && cir);
  if (s) {
    var M;
    return Object.assign({}, I, (M = {}, M[_] = b ? "0" : "", M[w] = y ? "0" : "", M.transform = (C.devicePixelRatio || 1) < 2 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", M));
  }
  return Object.assign({}, I, (e = {}, e[_] = b ? g + "px" : "", e[w] = y ? h + "px" : "", e.transform = "", e));
}
function dir(t) {
  var e = t.state, r = t.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s, c = { placement: gh(e.placement), popper: e.elements.popper, popperRect: e.rects.popper, gpuAcceleration: a };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, s7e(Object.assign({}, c, { offsets: e.modifiersData.popperOffsets, position: e.options.strategy, adaptive: o, roundOffsets: l })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, s7e(Object.assign({}, c, { offsets: e.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: l })))), e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-placement": e.placement });
}
var fir = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: dir, data: {} }, gB = { passive: !0 };
function hir(t) {
  var e = t.state, r = t.instance, n = t.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, s = o === void 0 ? !0 : o, l = l2(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", r.update, gB);
  }), s && l.addEventListener("resize", r.update, gB), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", r.update, gB);
    }), s && l.removeEventListener("resize", r.update, gB);
  };
}
var pir = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
}, effect: hir, data: {} }, mir = { left: "right", right: "left", bottom: "top", top: "bottom" };
function u$(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return mir[e];
  });
}
var gir = { start: "end", end: "start" };
function l7e(t) {
  return t.replace(/start|end/g, function(e) {
    return gir[e];
  });
}
function Xhe(t) {
  var e = l2(t), r = e.pageXOffset, n = e.pageYOffset;
  return { scrollLeft: r, scrollTop: n };
}
function Qhe(t) {
  return yx(Oy(t)).left + Xhe(t).scrollLeft;
}
function vir(t) {
  var e = l2(t), r = Oy(t), n = e.visualViewport, a = r.clientWidth, i = r.clientHeight, o = 0, s = 0;
  return n && (a = n.width, i = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (o = n.offsetLeft, s = n.offsetTop)), { width: a, height: i, x: o + Qhe(t), y: s };
}
function yir(t) {
  var e, r = Oy(t), n = Xhe(t), a = (e = t.ownerDocument) == null ? void 0 : e.body, i = Nv(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Nv(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + Qhe(t), l = -n.scrollTop;
  return Um(a || r).direction === "rtl" && (s += Nv(r.clientWidth, a ? a.clientWidth : 0) - i), { width: i, height: o, x: s, y: l };
}
function epe(t) {
  var e = Um(t), r = e.overflow, n = e.overflowX, a = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function lXe(t) {
  return ["html", "body", "#document"].indexOf(Fh(t)) >= 0 ? t.ownerDocument.body : V1(t) && epe(t) ? t : lXe(Xz(t));
}
function R_(t, e) {
  var r;
  e === void 0 && (e = []);
  var n = lXe(t), a = n === ((r = t.ownerDocument) == null ? void 0 : r.body), i = l2(n), o = a ? [i].concat(i.visualViewport || [], epe(n) ? n : []) : n, s = e.concat(o);
  return a ? s : s.concat(R_(Xz(o)));
}
function Bue(t) {
  return Object.assign({}, t, { left: t.x, top: t.y, right: t.x + t.width, bottom: t.y + t.height });
}
function bir(t) {
  var e = yx(t);
  return e.top = e.top + t.clientTop, e.left = e.left + t.clientLeft, e.bottom = e.top + t.clientHeight, e.right = e.left + t.clientWidth, e.width = t.clientWidth, e.height = t.clientHeight, e.x = e.left, e.y = e.top, e;
}
function c7e(t, e) {
  return e === tXe ? Bue(vir(t)) : V1(e) ? bir(e) : Bue(yir(Oy(t)));
}
function xir(t) {
  var e = R_(Xz(t)), r = ["absolute", "fixed"].indexOf(Um(t).position) >= 0, n = r && V1(t) ? cM(t) : t;
  return jT(n) ? e.filter(function(a) {
    return jT(a) && aXe(a, n) && Fh(a) !== "body";
  }) : [];
}
function Cir(t, e, r) {
  var n = e === "clippingParents" ? xir(t) : [].concat(e), a = [].concat(n, [r]), i = a[0], o = a.reduce(function(s, l) {
    var c = c7e(t, l);
    return s.top = Nv(c.top, s.top), s.right = FT(c.right, s.right), s.bottom = FT(c.bottom, s.bottom), s.left = Nv(c.left, s.left), s;
  }, c7e(t, i));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function zT(t) {
  return t.split("-")[1];
}
function cXe(t) {
  var e = t.reference, r = t.element, n = t.placement, a = n ? gh(n) : null, i = n ? zT(n) : null, o = e.x + e.width / 2 - r.width / 2, s = e.y + e.height / 2 - r.height / 2, l;
  switch (a) {
    case ff:
      l = { x: o, y: e.y - r.height };
      break;
    case H1:
      l = { x: o, y: e.y + e.height };
      break;
    case U1:
      l = { x: e.x + e.width, y: s };
      break;
    case hf:
      l = { x: e.x - r.width, y: s };
      break;
    default:
      l = { x: e.x, y: e.y };
  }
  var c = a ? Yhe(a) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case vx:
        l[c] = l[c] - (e[u] / 2 - r[u] / 2);
        break;
      case Zhe:
        l[c] = l[c] + (e[u] / 2 - r[u] / 2);
        break;
    }
  }
  return l;
}
function GT(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, a = n === void 0 ? t.placement : n, i = r.boundary, o = i === void 0 ? Gar : i, s = r.rootBoundary, l = s === void 0 ? tXe : s, c = r.elementContext, u = c === void 0 ? Yw : c, f = r.altBoundary, h = f === void 0 ? !1 : f, p = r.padding, g = p === void 0 ? 0 : p, y = oXe(typeof g != "number" ? g : sXe(g, lM)), b = u === Yw ? War : Yw, w = t.elements.reference, _ = t.rects.popper, C = t.elements[h ? b : u], x = Cir(jT(C) ? C : C.contextElement || Oy(t.elements.popper), o, l), S = yx(w), A = cXe({ reference: S, element: _, placement: a }), I = Bue(Object.assign({}, _, A)), M = u === Yw ? I : S, B = { top: x.top - M.top + y.top, bottom: M.bottom - x.bottom + y.bottom, left: x.left - M.left + y.left, right: M.right - x.right + y.right }, L = t.modifiersData.offset;
  if (u === Yw && L) {
    var N = L[a];
    Object.keys(B).forEach(function(d) {
      var m = [U1, H1].indexOf(d) >= 0 ? 1 : -1, v = [ff, H1].indexOf(d) >= 0 ? "y" : "x";
      B[d] += N[v] * m;
    });
  }
  return B;
}
function wir(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, c = l === void 0 ? rXe : l, u = zT(n), f = u ? s ? i7e : i7e.filter(function(g) {
    return zT(g) === u;
  }) : lM, h = f.filter(function(g) {
    return c.indexOf(g) >= 0;
  });
  h.length === 0 && (h = f);
  var p = h.reduce(function(g, y) {
    return g[y] = GT(t, { placement: y, boundary: a, rootBoundary: i, padding: o })[gh(y)], g;
  }, {});
  return Object.keys(p).sort(function(g, y) {
    return p[g] - p[y];
  });
}
function Sir(t) {
  if (gh(t) === Khe) return [];
  var e = u$(t);
  return [l7e(t), e, l7e(e)];
}
function _ir(t) {
  var e = t.state, r = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !0 : o, l = r.fallbackPlacements, c = r.padding, u = r.boundary, f = r.rootBoundary, h = r.altBoundary, p = r.flipVariations, g = p === void 0 ? !0 : p, y = r.allowedAutoPlacements, b = e.options.placement, w = gh(b), _ = w === b, C = l || (_ || !g ? [u$(b)] : Sir(b)), x = [b].concat(C).reduce(function(Z, V) {
      return Z.concat(gh(V) === Khe ? wir(e, { placement: V, boundary: u, rootBoundary: f, padding: c, flipVariations: g, allowedAutoPlacements: y }) : V);
    }, []), S = e.rects.reference, A = e.rects.popper, I = /* @__PURE__ */ new Map(), M = !0, B = x[0], L = 0; L < x.length; L++) {
      var N = x[L], d = gh(N), m = zT(N) === vx, v = [ff, H1].indexOf(d) >= 0, k = v ? "width" : "height", O = GT(e, { placement: N, boundary: u, rootBoundary: f, altBoundary: h, padding: c }), G = v ? m ? U1 : hf : m ? H1 : ff;
      S[k] > A[k] && (G = u$(G));
      var H = u$(G), j = [];
      if (i && j.push(O[d] <= 0), s && j.push(O[G] <= 0, O[H] <= 0), j.every(function(Z) {
        return Z;
      })) {
        B = N, M = !1;
        break;
      }
      I.set(N, j);
    }
    if (M) for (var F = g ? 3 : 1, z = function(Z) {
      var V = x.find(function(Y) {
        var ge = I.get(Y);
        if (ge) return ge.slice(0, Z).every(function(ce) {
          return ce;
        });
      });
      if (V) return B = V, "break";
    }, W = F; W > 0; W--) {
      var U = z(W);
      if (U === "break") break;
    }
    e.placement !== B && (e.modifiersData[n]._skip = !0, e.placement = B, e.reset = !0);
  }
}
var kir = { name: "flip", enabled: !0, phase: "main", fn: _ir, requiresIfExists: ["offset"], data: { _skip: !1 } };
function u7e(t, e, r) {
  return r === void 0 && (r = { x: 0, y: 0 }), { top: t.top - e.height - r.y, right: t.right - e.width + r.x, bottom: t.bottom - e.height + r.y, left: t.left - e.width - r.x };
}
function d7e(t) {
  return [ff, U1, H1, hf].some(function(e) {
    return t[e] >= 0;
  });
}
function Air(t) {
  var e = t.state, r = t.name, n = e.rects.reference, a = e.rects.popper, i = e.modifiersData.preventOverflow, o = GT(e, { elementContext: "reference" }), s = GT(e, { altBoundary: !0 }), l = u7e(o, n), c = u7e(s, a, i), u = d7e(l), f = d7e(c);
  e.modifiersData[r] = { referenceClippingOffsets: l, popperEscapeOffsets: c, isReferenceHidden: u, hasPopperEscaped: f }, e.attributes.popper = Object.assign({}, e.attributes.popper, { "data-popper-reference-hidden": u, "data-popper-escaped": f });
}
var Tir = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: Air };
function Eir(t, e, r) {
  var n = gh(t), a = [hf, ff].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, e, { placement: t })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [hf, U1].indexOf(n) >= 0 ? { x: s, y: o } : { x: o, y: s };
}
function Iir(t) {
  var e = t.state, r = t.options, n = t.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = rXe.reduce(function(u, f) {
    return u[f] = Eir(f, e.rects, i), u;
  }, {}), s = o[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = o;
}
var Mir = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: Iir };
function Pir(t) {
  var e = t.state, r = t.name;
  e.modifiersData[r] = cXe({ reference: e.rects.reference, element: e.rects.popper, placement: e.placement });
}
var Rir = { name: "popperOffsets", enabled: !0, phase: "read", fn: Pir, data: {} };
function Oir(t) {
  return t === "x" ? "y" : "x";
}
function Bir(t) {
  var e = t.state, r = t.options, n = t.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !1 : o, l = r.boundary, c = r.rootBoundary, u = r.altBoundary, f = r.padding, h = r.tether, p = h === void 0 ? !0 : h, g = r.tetherOffset, y = g === void 0 ? 0 : g, b = GT(e, { boundary: l, rootBoundary: c, padding: f, altBoundary: u }), w = gh(e.placement), _ = zT(e.placement), C = !_, x = Yhe(w), S = Oir(x), A = e.modifiersData.popperOffsets, I = e.rects.reference, M = e.rects.popper, B = typeof y == "function" ? y(Object.assign({}, e.rects, { placement: e.placement })) : y, L = { x: 0, y: 0 };
  if (A) {
    if (i || s) {
      var N = x === "y" ? ff : hf, d = x === "y" ? H1 : U1, m = x === "y" ? "height" : "width", v = A[x], k = A[x] + b[N], O = A[x] - b[d], G = p ? -M[m] / 2 : 0, H = _ === vx ? I[m] : M[m], j = _ === vx ? -M[m] : -I[m], F = e.elements.arrow, z = p && F ? Jhe(F) : { width: 0, height: 0 }, W = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : iXe(), U = W[N], Z = W[d], V = c$(0, I[m], z[m]), Y = C ? I[m] / 2 - G - V - U - B : H - V - U - B, ge = C ? -I[m] / 2 + G + V + Z + B : j + V + Z + B, ce = e.elements.arrow && cM(e.elements.arrow), ee = ce ? x === "y" ? ce.clientTop || 0 : ce.clientLeft || 0 : 0, Se = e.modifiersData.offset ? e.modifiersData.offset[e.placement][x] : 0, Ce = A[x] + Y - Se - ee, we = A[x] + ge - Se;
      if (i) {
        var We = c$(p ? FT(k, Ce) : k, v, p ? Nv(O, we) : O);
        A[x] = We, L[x] = We - v;
      }
      if (s) {
        var Fe = x === "x" ? ff : hf, it = x === "x" ? H1 : U1, gt = A[S], Ze = gt + b[Fe], Ne = gt - b[it], ze = c$(p ? FT(Ze, Ce) : Ze, gt, p ? Nv(Ne, we) : Ne);
        A[S] = ze, L[S] = ze - gt;
      }
    }
    e.modifiersData[n] = L;
  }
}
var Nir = { name: "preventOverflow", enabled: !0, phase: "main", fn: Bir, requiresIfExists: ["offset"] };
function $ir(t) {
  return { scrollLeft: t.scrollLeft, scrollTop: t.scrollTop };
}
function Dir(t) {
  return t === l2(t) || !V1(t) ? Xhe(t) : $ir(t);
}
function Lir(t, e, r) {
  r === void 0 && (r = !1);
  var n = Oy(e), a = yx(t), i = V1(e), o = { scrollLeft: 0, scrollTop: 0 }, s = { x: 0, y: 0 };
  return (i || !i && !r) && ((Fh(e) !== "body" || epe(n)) && (o = Dir(e)), V1(e) ? (s = yx(e), s.x += e.clientLeft, s.y += e.clientTop) : n && (s.x = Qhe(n))), { x: a.left + o.scrollLeft - s.x, y: a.top + o.scrollTop - s.y, width: a.width, height: a.height };
}
function jir(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var l = e.get(s);
        l && a(l);
      }
    }), n.push(i);
  }
  return t.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function Fir(t) {
  var e = jir(t);
  return Qar.reduce(function(r, n) {
    return r.concat(e.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function zir(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(r) {
      Promise.resolve().then(function() {
        e = void 0, r(t());
      });
    })), e;
  };
}
function Gir(t) {
  var e = t.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, { options: Object.assign({}, a.options, n.options), data: Object.assign({}, a.data, n.data) }) : n, r;
  }, {});
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}
var f7e = { placement: "bottom", modifiers: [], strategy: "absolute" };
function h7e() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Wir(t) {
  t === void 0 && (t = {});
  var e = t, r = e.defaultModifiers, n = r === void 0 ? [] : r, a = e.defaultOptions, i = a === void 0 ? f7e : a;
  return function(o, s, l) {
    l === void 0 && (l = i);
    var c = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, f7e, i), modifiersData: {}, elements: { reference: o, popper: s }, attributes: {}, styles: {} }, u = [], f = !1, h = { state: c, setOptions: function(y) {
      g(), c.options = Object.assign({}, i, c.options, y), c.scrollParents = { reference: jT(o) ? R_(o) : o.contextElement ? R_(o.contextElement) : [], popper: R_(s) };
      var b = Fir(Gir([].concat(n, c.options.modifiers)));
      return c.orderedModifiers = b.filter(function(w) {
        return w.enabled;
      }), p(), h.update();
    }, forceUpdate: function() {
      if (!f) {
        var y = c.elements, b = y.reference, w = y.popper;
        if (h7e(b, w)) {
          c.rects = { reference: Lir(b, cM(w), c.options.strategy === "fixed"), popper: Jhe(w) }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(B) {
            return c.modifiersData[B.name] = Object.assign({}, B.data);
          });
          for (var _ = 0, C = 0; C < c.orderedModifiers.length; C++) {
            if (c.reset === !0) {
              c.reset = !1, C = -1;
              continue;
            }
            var x = c.orderedModifiers[C], S = x.fn, A = x.options, I = A === void 0 ? {} : A, M = x.name;
            typeof S == "function" && (c = S({ state: c, options: I, name: M, instance: h }) || c);
          }
        }
      }
    }, update: zir(function() {
      return new Promise(function(y) {
        h.forceUpdate(), y(c);
      });
    }), destroy: function() {
      g(), f = !0;
    } };
    if (!h7e(o, s)) return h;
    h.setOptions(l).then(function(y) {
      !f && l.onFirstUpdate && l.onFirstUpdate(y);
    });
    function p() {
      c.orderedModifiers.forEach(function(y) {
        var b = y.name, w = y.options, _ = w === void 0 ? {} : w, C = y.effect;
        if (typeof C == "function") {
          var x = C({ state: c, name: b, instance: h, options: _ }), S = function() {
          };
          u.push(x || S);
        }
      });
    }
    function g() {
      u.forEach(function(y) {
        return y();
      }), u = [];
    }
    return h;
  };
}
var Hir = [pir, Rir, fir, rir, Mir, kir, Nir, lir, Tir], Uir = Wir({ defaultModifiers: Hir });
function Vir(t) {
  var e = Zt(null);
  return Py(function() {
    e.current = t;
  }, [t]), e;
}
function tpe(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.visible, n = r === void 0 ? !1 : r, a = e.animated, i = a === void 0 ? !1 : a, o = qn(e, ["visible", "animated"]), s = YYe(o), l = Yt(n), c = l[0], u = l[1], f = Yt(i), h = f[0], p = f[1], g = Yt(!1), y = g[0], b = g[1], w = Vir(c), _ = w.current != null && w.current !== c;
  h && !y && _ && b(!0), Ut(function() {
    if (typeof h == "number" && y) {
      var I = setTimeout(function() {
        return b(!1);
      }, h);
      return function() {
        clearTimeout(I);
      };
    }
    return function() {
    };
  }, [h, y]);
  var C = sr(function() {
    return u(!0);
  }, []), x = sr(function() {
    return u(!1);
  }, []), S = sr(function() {
    return u(function(I) {
      return !I;
    });
  }, []), A = sr(function() {
    return b(!1);
  }, []);
  return Lt(Lt({}, s), {}, { visible: c, animated: h, animating: y, show: C, hide: x, toggle: S, setVisible: u, setAnimated: p, stopAnimation: A });
}
function qir(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.modal, n = r === void 0 ? !0 : r, a = qn(e, ["modal"]), i = tpe(a), o = Yt(n), s = o[0], l = o[1], c = Zt(null);
  return Lt(Lt({}, i), {}, { modal: s, setModal: l, unstable_disclosureRef: c });
}
var Kir = pb("Mac") && !pb("Chrome") && pb("Safari");
function p7e(t) {
  return function(e) {
    return t && !x5(e, t) ? t : e;
  };
}
function rpe(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.gutter, n = r === void 0 ? 12 : r, a = e.placement, i = a === void 0 ? "bottom" : a, o = e.unstable_flip, s = o === void 0 ? !0 : o, l = e.unstable_offset, c = e.unstable_preventOverflow, u = c === void 0 ? !0 : c, f = e.unstable_fixed, h = f === void 0 ? !1 : f, p = e.modal, g = p === void 0 ? !1 : p, y = qn(e, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]), b = Zt(null), w = Zt(null), _ = Zt(null), C = Zt(null), x = Yt(i), S = x[0], A = x[1], I = Yt(i), M = I[0], B = I[1], L = Yt(l || [0, n]), N = L[0], d = Yt({ position: "fixed", left: "100%", top: "100%" }), m = d[0], v = d[1], k = Yt({}), O = k[0], G = k[1], H = Yt(!1), j = H[0], F = H[1], z = qir(Lt({ modal: g }, y)), W = sr(function() {
    return b.current ? (b.current.forceUpdate(), !0) : !1;
  }, []), U = sr(function(Z) {
    d5e(function() {
      Z.placement && B(Z.placement);
    }), d5e(function() {
      Z.styles && (v(p7e(Z.styles.popper)), C.current && G(p7e(Z.styles.arrow)));
    });
  }, []);
  return Ut(function() {
    F(!0);
  }, []), Py(function() {
    return w.current && _.current && (b.current = Uir(w.current, _.current, { placement: S, strategy: h ? "fixed" : "absolute", onFirstUpdate: Kir ? U : void 0, modifiers: [{ name: "eventListeners", enabled: z.visible }, { name: "applyStyles", enabled: !1 }, { name: "flip", enabled: s, options: { padding: 8 } }, { name: "offset", options: { offset: N } }, { name: "preventOverflow", enabled: u, options: { tetherOffset: function() {
      var Z;
      return ((Z = C.current) === null || Z === void 0 ? void 0 : Z.clientWidth) || 0;
    } } }, { name: "arrow", enabled: !!C.current, options: { element: C.current } }, { name: "updateState", phase: "write", requires: ["computeStyles"], enabled: z.visible && !0, fn: function(Z) {
      var V = Z.state;
      return U(V);
    } }] })), function() {
      b.current && (b.current.destroy(), b.current = null);
    };
  }, [S, h, z.visible, s, N, u, j]), Ut(function() {
    if (z.visible) {
      var Z = window.requestAnimationFrame(function() {
        var V;
        (V = b.current) === null || V === void 0 || V.forceUpdate();
      });
      return function() {
        window.cancelAnimationFrame(Z);
      };
    }
  }, [z.visible, j]), Lt(Lt({}, z), {}, { unstable_referenceRef: w, unstable_popoverRef: _, unstable_arrowRef: C, unstable_popoverStyles: m, unstable_arrowStyles: O, unstable_update: W, unstable_originalPlacement: S, placement: M, place: A });
}
var Zir = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"], uXe = Zir, Jir = uXe, Qz = lo({ name: "DisclosureContent", compose: Ry, keys: Jir, useProps: function(t, e) {
  var r = e.onTransitionEnd, n = e.onAnimationEnd, a = e.style, i = qn(e, ["onTransitionEnd", "onAnimationEnd", "style"]), o = t.animated && t.animating, s = Yt(null), l = s[0], c = s[1], u = !t.visible && !o, f = u ? Lt({ display: "none" }, a) : a, h = Ua(r), p = Ua(n), g = Zt(0);
  Ut(function() {
    if (t.animated) return g.current = window.requestAnimationFrame(function() {
      g.current = window.requestAnimationFrame(function() {
        t.visible ? c("enter") : c(o ? "leave" : null);
      });
    }), function() {
      return window.cancelAnimationFrame(g.current);
    };
  }, [t.animated, t.visible, o]);
  var y = sr(function(_) {
    if (h1(_) && o && t.animated === !0) {
      var C;
      (C = t.stopAnimation) === null || C === void 0 || C.call(t);
    }
  }, [t.animated, o, t.stopAnimation]), b = sr(function(_) {
    var C;
    (C = h.current) === null || C === void 0 || C.call(h, _), y(_);
  }, [y]), w = sr(function(_) {
    var C;
    (C = p.current) === null || C === void 0 || C.call(p, _), y(_);
  }, [y]);
  return Lt({ id: t.baseId, "data-enter": l === "enter" ? "" : void 0, "data-leave": l === "leave" ? "" : void 0, onTransitionEnd: b, onAnimationEnd: w, hidden: u, style: f }, i);
} }), Yir = so({ as: "div", useHook: Qz });
function dXe() {
  return oM ? document.body : null;
}
var m7e = Bo(dXe());
function Vm(t) {
  var e = t.children, r = Qn(m7e) || dXe(), n = Yt(null), a = n[0], i = n[1];
  return Ut(function() {
    if (r) {
      var o = document.createElement("div");
      return o.className = Vm.__className, i(o), r.appendChild(o), function() {
        r.removeChild(o);
      };
    }
  }, [r]), a ? aWe(Ds(m7e.Provider, { value: a }, e), a) : null;
}
Vm.__className = "__reakit-portal";
Vm.__selector = "." + Vm.__className;
function Nue(t, e) {
  var r = t.indexOf(e);
  return zYe(t, r);
}
var dy = Bo(null);
function Xir(t, e, r) {
  var n = "unstable_orphan" in r && r.unstable_orphan, a = Qn(dy), i = Yt([]), o = i[0], s = i[1], l = a || {}, c = l.addChild, u = l.removeChild, f = sr(function(y) {
    return s(function(b) {
      return [].concat(b, [y]);
    });
  }, []), h = sr(function(y) {
    return s(function(b) {
      return Nue(b, y);
    });
  }, []);
  Ut(function() {
    if (!(!c || n)) return c(t), function() {
      u == null || u(t);
    };
  }, [t, c, u, n]);
  var p = fa(function() {
    return { orientation: r.orientation, next: r.next, previous: r.previous, ref: t, role: e, parent: a, children: o, addChild: f, removeChild: h };
  }, [r.orientation, r.next, r.previous, t, e, a, o, f, h]), g = sr(function(y) {
    return Ds(dy.Provider, { value: p }, y);
  }, [p]);
  return g;
}
function Qir(t) {
  if (Array.isArray(t)) {
    for (var e = 0, r = Array(t.length); e < t.length; e++) r[e] = t[e];
    return r;
  } else return Array.from(t);
}
var npe = !1;
typeof window < "u" && (mZ = { get passive() {
  npe = !0;
} }, window.addEventListener("testPassive", null, mZ), window.removeEventListener("testPassive", null, mZ));
var mZ, fXe = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), _v = [], EL = !1, hXe = -1, O_ = void 0, B_ = void 0, pXe = function(t) {
  return _v.some(function(e) {
    return !!(e.options.allowTouchMove && e.options.allowTouchMove(t));
  });
}, ape = function(t) {
  var e = t || window.event;
  return pXe(e.target) || e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}, eor = function(t) {
  if (B_ === void 0) {
    var e = !!t && t.reserveScrollBarGap === !0, r = window.innerWidth - document.documentElement.clientWidth;
    e && r > 0 && (B_ = document.body.style.paddingRight, document.body.style.paddingRight = r + "px");
  }
  O_ === void 0 && (O_ = document.body.style.overflow, document.body.style.overflow = "hidden");
}, tor = function() {
  B_ !== void 0 && (document.body.style.paddingRight = B_, B_ = void 0), O_ !== void 0 && (document.body.style.overflow = O_, O_ = void 0);
}, ror = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, nor = function(t, e) {
  var r = t.targetTouches[0].clientY - hXe;
  return pXe(t.target) ? !1 : e && e.scrollTop === 0 && r > 0 || ror(e) && r < 0 ? ape(t) : (t.stopPropagation(), !0);
}, aor = function(t, e) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!_v.some(function(n) {
    return n.targetElement === t;
  })) {
    var r = { targetElement: t, options: e || {} };
    _v = [].concat(Qir(_v), [r]), fXe ? (t.ontouchstart = function(n) {
      n.targetTouches.length === 1 && (hXe = n.targetTouches[0].clientY);
    }, t.ontouchmove = function(n) {
      n.targetTouches.length === 1 && nor(n, t);
    }, EL || (document.addEventListener("touchmove", ape, npe ? { passive: !1 } : void 0), EL = !0)) : eor(e);
  }
}, ior = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  _v = _v.filter(function(e) {
    return e.targetElement !== t;
  }), fXe ? (t.ontouchstart = null, t.ontouchmove = null, EL && _v.length === 0 && (document.removeEventListener("touchmove", ape, npe ? { passive: !1 } : void 0), EL = !1)) : _v.length || tor();
}, oor = Bo(void 0);
function sor(t) {
  return Array.isArray(t) ? !t.length : IYe(t) ? !Object.keys(t).length : t == null || t === "";
}
var mXe = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"], lor = [].concat(mXe, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]), cor = mXe, uor = cor;
function dor(t, e) {
  var r = Zt(null), n = !!(e.animated && e.animating);
  return Ut(function() {
    if (!(e.visible || n)) {
      var a = function(o) {
        var s = o.target;
        "focus" in s && (r.current = s, e.unstable_disclosureRef && (e.unstable_disclosureRef.current = s));
      }, i = sc(t.current);
      return i.addEventListener("focusin", a), function() {
        return i.removeEventListener("focusin", a);
      };
    }
  }, [e.visible, n, e.unstable_disclosureRef, t]), Ut(function() {
    var a;
    if (!(!e.visible || n)) {
      var i = function(s) {
        var l = s.currentTarget;
        !Zz(l) || (s.preventDefault(), l.focus());
      }, o = ((a = e.unstable_disclosureRef) === null || a === void 0 ? void 0 : a.current) || r.current;
      return o == null || o.addEventListener("mousedown", i), function() {
        return o == null ? void 0 : o.removeEventListener("mousedown", i);
      };
    }
  }, [e.visible, n, e.unstable_disclosureRef]), e.unstable_disclosureRef || r;
}
function hor(t, e) {
  var r = !!(e.preventBodyScroll && e.visible);
  Ut(function() {
    var n = t.current;
    if (!(!n || !r)) return aor(n, { reserveScrollBarGap: !0 }), function() {
      return ior(n);
    };
  }, [t, r]);
}
function por(t, e, r) {
  var n = r.unstable_initialFocusRef, a = r.visible && r.unstable_autoFocusOnShow, i = !!(r.animated && r.animating);
  WYe(function() {
    var o = t.current;
    if (a && o && !i && !e.some(function(c) {
      return c.current && !c.current.hidden;
    })) if (n != null && n.current) n.current.focus({ preventScroll: !0 });
    else {
      var s = jYe(o, !0), l = function() {
        return sM(o);
      };
      s ? $T(s, { preventScroll: !0, isActive: l }) : $T(o, { preventScroll: !0, isActive: l });
    }
  }, [t, a, i, e, n]);
}
function mor(t, e) {
  var r = Zt(null);
  return Ut(function() {
    var n = t.current;
    !n || !e.visible || (r.current = NYe(n, Vm.__selector));
  }, [t, e.visible]), r;
}
function g7e(t) {
  t.parentNode != null && t.parentNode.removeChild(t);
}
var gXe = "__reakit-focus-trap";
function gor(t) {
  var e;
  return (e = t.classList) === null || e === void 0 ? void 0 : e.contains(gXe);
}
function vor(t, e, r) {
  var n = mor(t, r), a = r.visible && r.modal, i = Zt(null), o = Zt(null);
  Ut(function() {
    if (a) {
      var s = n.current;
      if (s) {
        if (!i.current) {
          var l = sc(s);
          i.current = l.createElement("div"), i.current.className = gXe, i.current.tabIndex = 0, i.current.style.position = "fixed", i.current.setAttribute("aria-hidden", "true");
        }
        return o.current || (o.current = i.current.cloneNode()), s.insertAdjacentElement("beforebegin", i.current), s.insertAdjacentElement("afterend", o.current), function() {
          i.current && g7e(i.current), o.current && g7e(o.current);
        };
      }
    }
  }, [t, n, a]), Ut(function() {
    var s = i.current, l = o.current;
    if (!(!a || !s || !l)) {
      var c = function(u) {
        var f = t.current;
        if (!(!f || e.length)) {
          u.preventDefault();
          var h = u.target === l, p = h ? jYe(f) : qnr(f);
          p ? p.focus() : f.focus();
        }
      };
      return s.addEventListener("focus", c), l.addEventListener("focus", c), function() {
        s.removeEventListener("focus", c), l.removeEventListener("focus", c);
      };
    }
  }, [t, e, a]);
}
function yor(t) {
  var e = t.current;
  if (!e) return !1;
  var r = E8(e);
  return !r || W1(e, r) ? !1 : !!(Pue(r) || r.getAttribute("data-dialog") === "true");
}
function bor(t, e, r) {
  var n = r.unstable_autoFocusOnHide && !r.visible, a = !!(r.animated && r.animating);
  WYe(function() {
    var i;
    if (n && !a && !yor(t)) {
      var o = ((i = r.unstable_finalFocusRef) === null || i === void 0 ? void 0 : i.current) || e.current;
      if (o) {
        if (o.id) {
          var s = sc(o), l = s.querySelector("[aria-activedescendant='" + o.id + "']");
          if (l) {
            $T(l);
            return;
          }
        }
        $T(o);
        return;
      }
    }
  }, [n, a, t, e]);
}
var v7e = Bo({});
function xor(t, e) {
  var r = Qn(v7e), n = Yt([]), a = n[0], i = n[1], o = Yt(a), s = o[0], l = o[1], c = sr(function(y) {
    var b;
    (b = r.addDialog) === null || b === void 0 || b.call(r, y), i(function(w) {
      return [].concat(w, [y]);
    });
  }, [r.addDialog]), u = sr(function(y) {
    var b;
    (b = r.removeDialog) === null || b === void 0 || b.call(r, y), i(function(w) {
      return Nue(w, y);
    });
  }, [r.removeDialog]), f = sr(function(y) {
    var b;
    (b = r.showDialog) === null || b === void 0 || b.call(r, y), l(function(w) {
      return [].concat(w, [y]);
    });
  }, [r.showDialog]), h = sr(function(y) {
    var b;
    (b = r.hideDialog) === null || b === void 0 || b.call(r, y), l(function(w) {
      return Nue(w, y);
    });
  }, [r.hideDialog]);
  Ut(function() {
    var y;
    if (!e.unstable_orphan) return (y = r.addDialog) === null || y === void 0 || y.call(r, t), function() {
      var b;
      (b = r.removeDialog) === null || b === void 0 || b.call(r, t);
    };
  }, [e.unstable_orphan, r.addDialog, t, r.removeDialog]), Ut(function() {
    var y;
    if (!e.unstable_orphan && e.modal && e.visible) return (y = r.showDialog) === null || y === void 0 || y.call(r, t), function() {
      var b;
      (b = r.hideDialog) === null || b === void 0 || b.call(r, t);
    };
  }, [e.unstable_orphan, e.modal, e.visible, r.showDialog, t, r.hideDialog]), Ut(function() {
    if (r.visible === !1 && e.visible && !e.unstable_orphan) {
      var y;
      (y = e.hide) === null || y === void 0 || y.call(e);
    }
  }, [r.visible, e.visible, e.hide, e.unstable_orphan]);
  var p = fa(function() {
    return { visible: e.visible, addDialog: c, removeDialog: u, showDialog: f, hideDialog: h };
  }, [e.visible, c, u, f, h]), g = sr(function(y) {
    return Ds(v7e.Provider, { value: p }, y);
  }, [p]);
  return { dialogs: a, visibleModals: s, wrap: g };
}
function Cor(t) {
  return function(e) {
    var r = e.current;
    if (!r) return !1;
    if (W1(r, t)) return !0;
    var n = sc(r), a = n.querySelector('[data-dialog-ref="' + r.id + '"]');
    return a ? W1(a, t) : !1;
  };
}
function wor(t, e) {
  return W1(e, t);
}
function Sor(t) {
  var e = sc(t);
  return t.tagName === "HTML" ? !0 : W1(e.body, t);
}
function $ue(t, e, r, n, a, i, o) {
  var s = Ua(a);
  Ut(function() {
    if (i) {
      var l = function(u) {
        if (s.current) {
          var f = t.current, h = e.current, p = u.target;
          !f || !Sor(p) || W1(f, p) || h && wor(p, h) || gor(p) || r.some(Cor(p)) || s.current(u);
        }
      }, c = sc(t.current);
      return c.addEventListener(n, l, o), function() {
        return c.removeEventListener(n, l, o);
      };
    }
  }, [t, e, r, n, i, s]);
}
function _or(t, e) {
  var r = Zt();
  return Ut(function() {
    if (e.visible && e.hideOnClickOutside) {
      var n = sc(t.current), a = function(i) {
        r.current = i.target;
      };
      return n.addEventListener("mousedown", a), function() {
        return n.removeEventListener("mousedown", a);
      };
    }
  }, [e.visible, e.hideOnClickOutside, t]), r;
}
function kor(t, e, r, n) {
  var a = _or(t, n);
  $ue(t, e, r, "click", function(i) {
    if (a.current === i.target) {
      var o;
      (o = n.hide) === null || o === void 0 || o.call(n);
    }
  }, n.visible && n.hideOnClickOutside), $ue(t, e, r, "focusin", function(i) {
    var o = sc(t.current);
    if (i.target !== o && i.target !== o.body) {
      var s;
      (s = n.hide) === null || s === void 0 || s.call(n);
    }
  }, n.visible && n.hideOnClickOutside);
}
function Aor(t, e, r) {
  var n = function(a) {
    return $ue(t, { current: null }, e, a, function(i) {
      i.stopPropagation(), i.preventDefault();
    }, r.visible && r.modal, !0);
  };
  n("mouseover"), n("mousemove"), n("mouseout");
}
function Tor(t, e) {
  Ut(function() {
    var r = t.current;
    if (!(!e.visible || !r)) {
      var n = new MutationObserver(function(a) {
        var i = a[0].target;
        if (i === r) {
          var o = sc(r), s = E8(r);
          (s === o.body || sor(s)) && r.focus();
        }
      });
      return n.observe(r, { childList: !0, subtree: !0 }), function() {
        n.disconnect();
      };
    }
  }, [e.visible, t]);
}
function y7e(t) {
  return t && t.tagName && t.tagName !== "HTML" && t !== sc(t).body;
}
function Eor(t, e) {
  var r = AI(function(o) {
    return o + 1;
  }, 0), n = r[0], a = r[1];
  Py(function() {
    var o = t.current;
    !e.visible || !n || y7e(E8(o)) || (o == null || o.focus());
  }, [n, t]);
  var i = sr(function(o) {
    if (e.visible) {
      var s = HYe(o);
      y7e(s) || a();
    }
  }, [e.visible]);
  return i;
}
var vXe = lo({ name: "Dialog", compose: Qz, keys: lor, useOptions: function(t) {
  var e = t.modal, r = e === void 0 ? !0 : e, n = t.hideOnEsc, a = n === void 0 ? !0 : n, i = t.hideOnClickOutside, o = i === void 0 ? !0 : i, s = t.preventBodyScroll, l = s === void 0 ? r : s, c = t.unstable_autoFocusOnShow, u = c === void 0 ? !0 : c, f = t.unstable_autoFocusOnHide, h = f === void 0 ? !0 : f, p = t.unstable_orphan, g = qn(t, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);
  return Lt({ modal: r, hideOnEsc: a, hideOnClickOutside: o, preventBodyScroll: r && l, unstable_autoFocusOnShow: u, unstable_autoFocusOnHide: h, unstable_orphan: r && p }, g);
}, useProps: function(t, e) {
  var r = e.ref, n = e.onKeyDown, a = e.onBlur, i = e.wrapElement, o = e.tabIndex, s = qn(e, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]), l = Zt(null), c = Qn(oor), u = c && c === t.baseId, f = dor(l, t), h = Ua(n), p = Ua(a), g = Eor(l, t), y = xor(l, t), b = y.dialogs, w = y.visibleModals, _ = y.wrap, C = t.modal && !w.length ? !0 : void 0;
  hor(l, t), vor(l, w, t), Tor(l, t), por(l, b, t), bor(l, f, t), kor(l, f, b, t), Aor(l, b, t);
  var x = sr(function(I) {
    var M;
    (M = h.current) === null || M === void 0 || M.call(h, I), !I.defaultPrevented && I.key === "Escape" && (!t.hideOnEsc || !t.hide || (I.stopPropagation(), t.hide()));
  }, [t.hideOnEsc, t.hide]), S = sr(function(I) {
    var M;
    (M = p.current) === null || M === void 0 || M.call(p, I), g(I);
  }, [g]), A = sr(function(I) {
    return I = _(I), t.modal && !u && (I = Ds(Vm, null, I)), i && (I = i(I)), Ds(dy.Provider, { value: null }, I);
  }, [_, t.modal, u, i]);
  return Lt({ ref: Ac(l, r), role: "dialog", tabIndex: o ?? -1, "aria-modal": C, "data-dialog": !0, onKeyDown: x, onBlur: S, wrapElement: A }, s);
} });
so({ as: "div", useHook: vXe, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} });
var Ior = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], yXe = Ior, Mor = yXe, Por = Mor, bXe = lo({ name: "Popover", compose: vXe, keys: yXe, useOptions: function(t) {
  var e = t.modal, r = e === void 0 ? !1 : e, n = qn(t, ["modal"]);
  return Lt({ modal: r }, n);
}, useProps: function(t, e) {
  var r = e.ref, n = e.style, a = qn(e, ["ref", "style"]);
  return Lt({ ref: Ac(t.unstable_popoverRef, r), style: Lt(Lt({}, t.unstable_popoverStyles), n) }, a);
} }), xXe = so({ as: "div", useHook: bXe, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} }), CXe = lo({ name: "Disclosure", compose: FYe, keys: uXe, useProps: function(t, e) {
  var r = e.onClick, n = e["aria-controls"], a = qn(e, ["onClick", "aria-controls"]), i = Ua(r), o = n ? n + " " + t.baseId : t.baseId, s = sr(function(l) {
    var c, u;
    (c = i.current) === null || c === void 0 || c.call(i, l), !l.defaultPrevented && ((u = t.toggle) === null || u === void 0 || u.call(t));
  }, [t.toggle]);
  return Lt({ "aria-expanded": !!t.visible, "aria-controls": o, onClick: s }, a);
} }), Ror = so({ as: "button", memo: !0, useHook: CXe }), wXe = lo({ name: "DialogDisclosure", compose: CXe, keys: uor, useProps: function(t, e) {
  var r = e.ref, n = e.onClick, a = qn(e, ["ref", "onClick"]), i = Zt(null), o = Ua(n), s = Yt(!1), l = s[0], c = s[1], u = t.unstable_disclosureRef;
  Py(function() {
    var h = i.current;
    u && !u.current && (u.current = h);
    var p = !(u != null && u.current) || u.current === h;
    c(!!t.visible && p);
  }, [t.visible, u]);
  var f = sr(function(h) {
    var p;
    (p = o.current) === null || p === void 0 || p.call(o, h), !h.defaultPrevented && u && (u.current = h.currentTarget);
  }, [u]);
  return Lt({ ref: Ac(i, r), "aria-haspopup": "dialog", "aria-expanded": l, onClick: f }, a);
} });
so({ as: "button", memo: !0, useHook: wXe });
var Oor = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "state", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "setState"], Bor = [].concat(Oor, ["value", "checked", "unstable_checkOnFocus"]);
function SXe(t) {
  return typeof t.checked < "u" ? t.checked : typeof t.value < "u" && t.state === t.value;
}
function Nor(t) {
  var e = Yt(function() {
    return SXe(t);
  }), r = e[0], n = Yt(t.currentId), a = n[0], i = t.id, o = t.setCurrentId;
  Ut(function() {
    r && i && a !== i && (o == null || o(i));
  }, [r, i, o, a]);
}
function b7e(t, e) {
  var r = Jz(t, "change");
  Object.defineProperties(r, { type: { value: "change" }, target: { value: t }, currentTarget: { value: t } }), e == null || e(r);
}
var _Xe = lo({ name: "Radio", compose: DT, keys: Bor, useOptions: function(t, e) {
  var r, n = e.value, a = e.checked, i = t.unstable_clickOnEnter, o = i === void 0 ? !1 : i, s = t.unstable_checkOnFocus, l = s === void 0 ? !0 : s, c = qn(t, ["unstable_clickOnEnter", "unstable_checkOnFocus"]);
  return Lt(Lt({ checked: a, unstable_clickOnEnter: o, unstable_checkOnFocus: l }, c), {}, { value: (r = c.value) != null ? r : n });
}, useProps: function(t, e) {
  var r = e.ref, n = e.onChange, a = e.onClick, i = qn(e, ["ref", "onChange", "onClick"]), o = Zt(null), s = Yt(!0), l = s[0], c = s[1], u = SXe(t), f = Ua(t.currentId === t.id), h = Ua(n), p = Ua(a);
  Nor(t), Ut(function() {
    var b = o.current;
    !b || (b.tagName !== "INPUT" || b.type !== "radio") && c(!1);
  }, []);
  var g = sr(function(b) {
    var w, _;
    (w = h.current) === null || w === void 0 || w.call(h, b), !b.defaultPrevented && (t.disabled || (_ = t.setState) === null || _ === void 0 || _.call(t, t.value));
  }, [t.disabled, t.setState, t.value]), y = sr(function(b) {
    var w;
    (w = p.current) === null || w === void 0 || w.call(p, b), !b.defaultPrevented && (l || b7e(b.currentTarget, g));
  }, [g, l]);
  return Ut(function() {
    var b = o.current;
    !b || t.unstable_moves && f.current && t.unstable_checkOnFocus && b7e(b, g);
  }, [t.unstable_moves, t.unstable_checkOnFocus, g]), Lt({ ref: Ac(o, r), role: l ? void 0 : "radio", type: l ? "radio" : void 0, value: l ? t.value : void 0, name: l ? t.baseId : void 0, "aria-checked": u, checked: u, onChange: g, onClick: y }, i);
} });
so({ as: "input", memo: !0, useHook: _Xe });
var $or = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"], Dor = [].concat($or, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]), kXe = Dor, Lor = kXe, AXe = Lor, TXe = AXe, jor = TXe, EXe = jor, ipe = EXe, IXe = [].concat(ipe, ["name"]), For = IXe, zor = ipe;
function Gor(t, e, r) {
  var n = e.items, a = n === void 0 ? [] : n, i = e.move;
  r === void 0 && (r = 500);
  var o = Yt(""), s = o[0], l = o[1];
  Ut(function() {
    if (s) {
      var c = setTimeout(function() {
        return l("");
      }, r), u = a.find(function(f) {
        return !!(f.ref.current && f.ref.current.textContent && f.ref.current.textContent.toLowerCase().startsWith(s));
      });
      return u && i(u.id), function() {
        return clearTimeout(c);
      };
    }
  }, [s, a, i, r]), Ut(function() {
    var c = t.current;
    if (c) {
      var u = function(f) {
        var h;
        if (!(f.key.length > 1) && !f.shiftKey && !f.metaKey && !f.ctrlKey && !f.altKey) {
          var p = f.target, g = (h = p.getAttribute) === null || h === void 0 ? void 0 : h.call(p, "role"), y = p === c, b = g && g.indexOf("menuitem") !== -1 && NYe(p, "[role=menu],[role=menubar]") === c;
          !y && !b || /^[a-z0-9_-]$/i.test(f.key) && (f.stopPropagation(), f.preventDefault(), l(function(w) {
            return "" + w + f.key;
          }));
        }
      };
      return c.addEventListener("keydown", u), function() {
        return c.removeEventListener("keydown", u);
      };
    }
  }, [t, l]);
}
var MXe = lo({ name: "MenuBar", compose: qhe, keys: AXe, useProps: function(t, e) {
  var r = e.ref, n = e.wrapElement, a = e.role, i = a === void 0 ? "menubar" : a, o = qn(e, ["ref", "wrapElement", "role"]), s = Zt(null), l = Xir(s, i, t);
  Gor(s, t);
  var c = sr(function(u) {
    return u = l(u), n ? n(u) : u;
  }, [l, n]);
  return Lt({ ref: Ac(s, r), role: i, "aria-orientation": t.orientation, wrapElement: c }, o);
} });
so({ as: "div", useHook: MXe, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} });
function Wor(t) {
  return fa(function() {
    var e;
    return t == null || (e = t.split("-")) === null || e === void 0 ? void 0 : e[0];
  }, [t]);
}
var Hor = lo({ name: "Menu", compose: [MXe, bXe], keys: kXe, useOptions: function(t) {
  var e = Qn(dy), r = (e == null ? void 0 : e.role) === "menubar";
  return Lt(Lt({ unstable_autoFocusOnHide: !r, modal: !1 }, t), {}, { unstable_autoFocusOnShow: !1, hideOnEsc: !1 });
}, useProps: function(t, e) {
  for (var r = e.onKeyDown, n = qn(e, ["onKeyDown"]), a = Ua(r), i = Qn(dy), o = !!i, s = i; s && s.role !== "menubar"; ) s = s.parent;
  var l = s || {}, c = l.next, u = l.previous, f = l.orientation, h = f === "horizontal", p = Wor(t.placement), g = sr(function(y) {
    var b;
    if ((b = a.current) === null || b === void 0 || b.call(a, y), !y.defaultPrevented) {
      if (y.key === "Escape") {
        var w;
        o || y.stopPropagation(), (w = t.hide) === null || w === void 0 || w.call(t);
      } else if (o && !Vhe(y)) {
        var _ = h && p !== "left" ? c : p === "left" && t.hide, C = h && p !== "right" ? u : p === "right" && t.hide, x = { ArrowRight: _, ArrowLeft: C }, S = x[y.key];
        S && (y.preventDefault(), o && y.stopPropagation(), S());
      }
    }
  }, [o, h, c, u, p, t.hide]);
  return Lt({ role: "menu", onKeyDown: g }, n);
} }), Uor = so({ as: "div", useHook: Hor, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} });
function Vor(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.orientation, n = r === void 0 ? "horizontal" : r, a = e.unstable_values, i = a === void 0 ? {} : a, o = qn(e, ["orientation", "unstable_values"]), s = Yt(i), l = s[0], c = s[1], u = LT(Lt(Lt({}, o), {}, { orientation: n }));
  return Lt(Lt({}, u), {}, { unstable_values: l, unstable_setValue: sr(function(f, h) {
    c(function(p) {
      var g;
      return Lt(Lt({}, p), {}, (g = {}, g[f] = typeof h == "function" ? h(p) : h, g));
    });
  }, []) });
}
var Due = lo({ name: "PopoverDisclosure", compose: wXe, keys: Por, useProps: function(t, e) {
  var r = e.ref, n = qn(e, ["ref"]);
  return Lt({ ref: Ac(t.unstable_referenceRef, r) }, n);
} }), eG = so({ as: "button", memo: !0, useHook: Due });
function ope(t) {
  var e = t == null ? void 0 : t.find(function(r) {
    return r.current && !r.current.hidden;
  });
  return e == null ? void 0 : e.current;
}
var qor = function() {
}, Kor = lo({ name: "MenuButton", compose: Due, keys: TXe, propsAreEqual: function(t, e) {
  t.unstable_popoverStyles, t.unstable_arrowStyles, t.currentId, t.unstable_moves;
  var r = qn(t, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
  e.unstable_popoverStyles, e.unstable_arrowStyles, e.currentId, e.unstable_moves;
  var n = qn(e, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);
  return Due.unstable_propsAreEqual(r, n);
}, useProps: function(t, e) {
  var r = e.ref, n = e.onClick, a = e.onKeyDown, i = e.onFocus, o = e.onMouseEnter, s = e.onMouseDown, l = qn(e, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]), c = Qn(dy), u = Zt(null), f = Zt(!1), h = t.placement.split("-"), p = h[0], g = !!c, y = (c == null ? void 0 : c.role) === "menubar", b = t.disabled || l["aria-disabled"], w = Ua(n), _ = Ua(a), C = Ua(i), x = Ua(o), S = Ua(s), A = sr(function(N) {
    var d;
    if (N.key === "Escape") {
      var m;
      (m = t.hide) === null || m === void 0 || m.call(t);
    } else if (!b) {
      var v = t.first && function() {
        return setTimeout(t.first);
      }, k = t.last && function() {
        return setTimeout(t.last);
      }, O = { Enter: v, " ": v, ArrowUp: (p === "top" || p === "bottom") && k, ArrowRight: p === "right" && v, ArrowDown: (p === "bottom" || p === "top") && v, ArrowLeft: p === "left" && v }, G = O[N.key];
      if (G) {
        var H;
        N.preventDefault(), N.stopPropagation(), (H = t.show) === null || H === void 0 || H.call(t), G();
        return;
      }
    }
    (d = _.current) === null || d === void 0 || d.call(_, N);
  }, [b, t.hide, t.first, t.last, p, t.show]), I = sr(function(N) {
    var d;
    if ((d = x.current) === null || d === void 0 || d.call(x, N), !N.defaultPrevented && !!c) {
      var m = N.currentTarget;
      y ? ope(c.children) && m.focus() : setTimeout(function() {
        if (sM(m)) {
          var v;
          (v = t.show) === null || v === void 0 || v.call(t);
        }
      }, 200);
    }
  }, [c, y, t.show]), M = sr(function(N) {
    var d;
    f.current = !0, (d = S.current) === null || d === void 0 || d.call(S, N);
  }, []), B = sr(function(N) {
    var d;
    if ((d = C.current) === null || d === void 0 || d.call(C, N), !N.defaultPrevented && !b && y && !f.current) {
      var m;
      (m = t.show) === null || m === void 0 || m.call(t);
    }
  }, [y, b, t.show]), L = sr(function(N) {
    var d;
    if ((d = w.current) === null || d === void 0 || d.call(w, N), !N.defaultPrevented) {
      if (g && !y) {
        var m;
        (m = t.show) === null || m === void 0 || m.call(t);
      } else {
        var v;
        if ((v = t.toggle) === null || v === void 0 || v.call(t), f.current && !y && !t.visible) {
          var k;
          (k = t.move) === null || k === void 0 || k.call(t, null);
        }
      }
      f.current = !1;
    }
  }, [g, y, t.show, t.toggle, t.visible, t.move]);
  return Lt({ ref: Ac(u, r), "aria-haspopup": "menu", onKeyDown: A, onMouseEnter: I, onMouseDown: M, onFocus: B, onClick: L }, l);
}, useComposeOptions: function(t) {
  return Lt(Lt({}, t), {}, { toggle: qor });
} }), spe = so({ as: "button", memo: !0, useHook: Kor }), Zor = lo({ name: "MenuGroup", compose: Ry, keys: EXe, useProps: function(t, e) {
  return Lt({ role: "group" }, e);
} });
so({ as: "div", useHook: Zor });
function vB(t, e, r) {
  return Math.abs((t.x * (e.y - r.y) + e.x * (r.y - t.y) + r.x * (t.y - e.y)) / 2);
}
function Jor(t, e, r, n) {
  var a = vB(e, r, n), i = vB(t, r, n), o = vB(e, t, n), s = vB(e, r, t);
  return a === i + o + s;
}
function Yor(t, e) {
  var r = e.getBoundingClientRect(), n = r.top, a = r.right, i = r.bottom, o = r.left, s = o > t.clientX ? o : a;
  return [{ x: s, y: n }, { x: s, y: i }];
}
function Xor(t, e) {
  var r = Ua(e), n = Zt(null), a = Zt(null), i = Zt(null), o = Zt(0), s = Zt(0), l = sr(function(f) {
    if (t != null && t.children.length) {
      a.current = null, i.current = null;
      var h = ope(t.children);
      if (h) {
        var p = Yor(f, h);
        a.current = p[0], i.current = p[1];
      }
    }
  }, [t == null ? void 0 : t.children]), c = sr(function(f) {
    var h = o.current !== f.clientX || s.current !== f.clientY;
    if (f.isTrusted && !h) return !0;
    var p = Math.abs(o.current - f.clientX);
    o.current = f.clientX, s.current = f.clientY;
    var g = function() {
      return a.current && i.current;
    };
    return f.type === "mouseleave" && !g() && l(f), g() ? p && n.current && Jor({ x: f.clientX, y: f.clientY }, n.current, a.current, i.current) : !1;
  }, [l]), u = sr(function(f) {
    var h;
    (h = r.current) === null || h === void 0 || h.call(r, f), !f.defaultPrevented && (t == null ? void 0 : t.role) !== "menubar" && (n.current = { x: f.clientX, y: f.clientY }, l(f));
  }, [t == null ? void 0 : t.role, l]);
  return { onMouseEnter: u, isMouseInTransitToSubmenu: c };
}
function lpe(t) {
  var e = t.relatedTarget;
  return (e == null ? void 0 : e.nodeType) === Node.ELEMENT_NODE ? t.relatedTarget : t.toElement || null;
}
function Qor(t) {
  var e = lpe(t);
  return e ? W1(t.currentTarget, e) : !1;
}
function esr(t, e) {
  if (!(e != null && e.length)) return !1;
  var r = lpe(t);
  if (!r) return !1;
  var n = ope(e);
  return n && W1(n, r);
}
function tsr(t, e) {
  var r = lpe(t);
  return r ? e == null ? void 0 : e.some(function(n) {
    return n.ref.current && W1(n.ref.current, r);
  }) : !1;
}
var Nb = lo({ name: "MenuItem", compose: DT, keys: ipe, propsAreEqual: function(t, e) {
  t.unstable_popoverStyles, t.unstable_arrowStyles, t.visible;
  var r = qn(t, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
  e.unstable_popoverStyles, e.unstable_arrowStyles, e.visible;
  var n = qn(e, ["unstable_popoverStyles", "unstable_arrowStyles", "visible"]);
  return DT.unstable_propsAreEqual(r, n);
}, useProps: function(t, e) {
  var r = e.onMouseEnter, n = e.onMouseMove, a = e.onMouseLeave, i = qn(e, ["onMouseEnter", "onMouseMove", "onMouseLeave"]), o = Qn(dy), s = Ua(n), l = Ua(a), c = Xor(o, r), u = c.onMouseEnter, f = c.isMouseInTransitToSubmenu, h = sr(function(g) {
    var y, b;
    (y = s.current) === null || y === void 0 || y.call(s, g), !g.defaultPrevented && (o == null ? void 0 : o.role) !== "menubar" && (f(g) || sM(g.currentTarget) || (b = t.move) === null || b === void 0 || b.call(t, g.currentTarget.id));
  }, [t.move]), p = sr(function(g) {
    var y;
    if ((y = l.current) === null || y === void 0 || y.call(l, g), !g.defaultPrevented && (o == null ? void 0 : o.role) !== "menubar" && !Qor(g) && !esr(g, o == null ? void 0 : o.children) && !tsr(g, t.items)) {
      var b;
      if (f(g)) return;
      (b = t.move) === null || b === void 0 || b.call(t, null);
    }
  }, [o == null ? void 0 : o.role, o == null ? void 0 : o.children, t.items, t.move]);
  return Lt({ role: "menuitem", onMouseEnter: u, onMouseMove: h, onMouseLeave: p }, i);
} }), rsr = so({ as: "button", memo: !0, useHook: Nb }), nsr = lo({ name: "MenuItemCheckbox", compose: [Nb, GYe], keys: IXe, propsAreEqual: function(t, e) {
  if (t.name !== e.name) return Nb.unstable_propsAreEqual(t, e);
  var r = t.unstable_values, n = qn(t, ["unstable_values"]), a = e.unstable_values, i = qn(e, ["unstable_values"]);
  return r[e.name] !== a[e.name] ? !1 : Nb.unstable_propsAreEqual(n, i);
}, useOptions: function(t) {
  var e = sr(function(r) {
    return t.unstable_setValue(t.name, r);
  }, [t.unstable_setValue, t.name]);
  return Lt(Lt({}, t), {}, { state: t.unstable_values[t.name], setState: e });
}, useProps: function(t, e) {
  return Lt({ role: "menuitemcheckbox", name: t.name }, e);
} }), asr = so({ as: "button", memo: !0, useHook: nsr }), isr = lo({ name: "MenuItemRadio", compose: [Nb, _Xe], keys: For, propsAreEqual: function(t, e) {
  if (t.name !== e.name) return Nb.unstable_propsAreEqual(t, e);
  var r = t.unstable_values, n = qn(t, ["unstable_values"]), a = e.unstable_values, i = qn(e, ["unstable_values"]);
  return r[e.name] !== a[e.name] ? !1 : Nb.unstable_propsAreEqual(n, i);
}, useOptions: function(t) {
  var e = sr(function(r) {
    return t.unstable_setValue(t.name, r);
  }, [t.unstable_setValue, t.name]);
  return Lt(Lt({}, t), {}, { unstable_checkOnFocus: !1, state: t.unstable_values[t.name], setState: e });
}, useProps: function(t, e) {
  return Lt({ role: "menuitemradio" }, e);
} }), osr = so({ as: "button", memo: !0, useHook: isr }), ssr = ["orientation"], PXe = lo({ name: "Separator", compose: Ry, keys: ssr, useOptions: function(t) {
  var e = t.orientation, r = e === void 0 ? "horizontal" : e, n = qn(t, ["orientation"]);
  return Lt({ orientation: r }, n);
}, useProps: function(t, e) {
  return Lt({ role: "separator", "aria-orientation": t.orientation }, e);
} });
so({ as: "hr", memo: !0, useHook: PXe });
var lsr = lo({ name: "MenuSeparator", compose: PXe, keys: zor, useOptions: function(t) {
  var e = t.orientation, r = e === void 0 ? "vertical" : e, n = qn(t, ["orientation"]);
  return Lt({ orientation: r === "vertical" ? "horizontal" : "vertical" }, n);
} }), csr = so({ as: "hr", memo: !0, useHook: lsr });
function usr(t) {
  t === void 0 && (t = {});
  var e = Qn(dy), r = cg(t), n = r.orientation, a = n === void 0 ? "vertical" : n, i = r.gutter, o = i === void 0 ? 0 : i, s = qn(r, ["orientation", "gutter"]), l = s.placement || (e && e.orientation === "vertical" ? "right-start" : "bottom-start"), c = Vor(Lt(Lt({}, s), {}, { orientation: a })), u = rpe(Lt(Lt({}, s), {}, { placement: l, gutter: o }));
  return Ut(function() {
    u.visible || c.reset();
  }, [u.visible, c.reset]), Lt(Lt({}, c), u);
}
var dsr = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "selectedId", "panels", "manual", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "select", "setSelectedId", "registerPanel", "unregisterPanel"], RXe = dsr, OXe = RXe, fsr = [].concat(OXe, ["tabId"]);
function hsr(t) {
  return fa(function() {
    var e, r;
    return ((e = t.panels) === null || e === void 0 || (r = e.find(function(n) {
      return n.groupId === t.id;
    })) === null || r === void 0 ? void 0 : r.id) || void 0;
  }, [t.panels, t.id]);
}
var psr = lo({ name: "Tab", compose: DT, keys: RXe, useOptions: function(t) {
  var e = t.focusable, r = e === void 0 ? !0 : e, n = qn(t, ["focusable"]);
  return Lt({ focusable: r }, n);
}, useProps: function(t, e) {
  var r = e.onClick, n = e.onFocus, a = qn(e, ["onClick", "onFocus"]), i = t.selectedId === t.id, o = hsr(t), s = Ua(r), l = Ua(n), c = sr(function(f) {
    var h, p;
    (h = s.current) === null || h === void 0 || h.call(s, f), !f.defaultPrevented && (t.disabled || !t.id || i || (p = t.select) === null || p === void 0 || p.call(t, t.id));
  }, [t.disabled, i, t.select, t.id]), u = sr(function(f) {
    var h, p;
    (h = l.current) === null || h === void 0 || h.call(l, f), !f.defaultPrevented && (t.disabled || t.manual || !t.id || i || (p = t.select) === null || p === void 0 || p.call(t, t.id));
  }, [t.id, t.disabled, t.manual, i, t.select]);
  return Lt({ role: "tab", "aria-selected": i, "aria-controls": o, onClick: c, onFocus: u }, a);
} }), msr = so({ as: "button", memo: !0, useHook: psr }), gsr = lo({ name: "TabList", compose: qhe, keys: OXe, useProps: function(t, e) {
  return Lt({ role: "tablist", "aria-orientation": t.orientation }, e);
} }), BXe = so({ as: "div", useHook: gsr, useCreateElement: function(t, e, r) {
  return X5(t, e, r);
} });
function vsr(t, e) {
  var r = e.map(function(n) {
    return n.groupId;
  }).filter(Boolean);
  return t.filter(function(n) {
    return r.indexOf(n.id || void 0) === -1;
  });
}
function ysr(t, e) {
  var r = t.filter(function(n) {
    return !n.groupId;
  });
  return r.indexOf(e);
}
function x7e(t) {
  var e, r, n = (e = t.panels) === null || e === void 0 ? void 0 : e.find(function(s) {
    return s.id === t.id;
  }), a = t.tabId || (n == null ? void 0 : n.groupId);
  if (a || !n || !t.panels || !t.items) return a;
  var i = ysr(t.panels, n), o = vsr(t.items, t.panels);
  return ((r = o[i]) === null || r === void 0 ? void 0 : r.id) || void 0;
}
var bsr = lo({ name: "TabPanel", compose: [Yz, Qz], keys: fsr, useProps: function(t, e) {
  var r = e.ref, n = qn(e, ["ref"]), a = Zt(null), i = x7e(t), o = t.id, s = t.registerPanel, l = t.unregisterPanel;
  return Ut(function() {
    if (o) return s == null || s({ id: o, ref: a, groupId: i }), function() {
      l == null || l(o);
    };
  }, [i, o, s, l]), Lt({ ref: Ac(a, r), role: "tabpanel", tabIndex: 0, "aria-labelledby": i }, n);
}, useComposeOptions: function(t) {
  var e = x7e(t);
  return Lt({ visible: e ? t.selectedId === e : !1 }, t);
} }), xsr = so({ as: "div", useHook: bsr });
function Csr(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.selectedId, n = e.loop, a = n === void 0 ? !0 : n, i = e.manual, o = i === void 0 ? !1 : i, s = qn(e, ["selectedId", "loop", "manual"]), l = LT(Lt({ loop: a, currentId: r }, s)), c = LT(), u = Yt(r), f = u[0], h = u[1], p = sr(function(g) {
    l.move(g), h(g);
  }, [l.move]);
  return Ut(function() {
    if (f !== null) {
      var g = l.items.find(function(y) {
        return y.id === f;
      });
      g || l.currentId && h(l.currentId);
    }
  }, [f, l.items, l.currentId]), Lt(Lt({}, l), {}, { selectedId: f, panels: c.items, manual: o, select: p, setSelectedId: h, registerPanel: sr(function(g) {
    return c.registerItem(g);
  }, [c.registerItem]), unregisterPanel: sr(function(g) {
    return c.unregisterItem(g);
  }, [c.unregisterItem]) });
}
var NXe = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "unstable_disclosureRef", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place", "unstable_timeout", "unstable_setTimeout"], wsr = [].concat(NXe, ["unstable_portal"]), Ssr = NXe, _sr = Ssr, ov = { currentTooltipId: null, listeners: /* @__PURE__ */ new Set(), subscribe: function(t) {
  var e = this;
  return this.listeners.add(t), function() {
    e.listeners.delete(t);
  };
}, show: function(t) {
  this.currentTooltipId = t, this.listeners.forEach(function(e) {
    return e(t);
  });
}, hide: function(t) {
  this.currentTooltipId === t && (this.currentTooltipId = null, this.listeners.forEach(function(e) {
    return e(null);
  }));
} };
function ksr(t) {
  t.defaultPrevented || t.key === "Escape" && ov.show(null);
}
var Asr = lo({ name: "Tooltip", compose: Qz, keys: wsr, useOptions: function(t) {
  var e = t.unstable_portal, r = e === void 0 ? !0 : e, n = qn(t, ["unstable_portal"]);
  return Lt({ unstable_portal: r }, n);
}, useProps: function(t, e) {
  var r = e.ref, n = e.style, a = e.wrapElement, i = qn(e, ["ref", "style", "wrapElement"]);
  Ut(function() {
    var s, l = sc((s = t.unstable_popoverRef) === null || s === void 0 ? void 0 : s.current);
    l.addEventListener("keydown", ksr);
  }, []);
  var o = sr(function(s) {
    return t.unstable_portal && (s = Ds(Vm, null, s)), a ? a(s) : s;
  }, [t.unstable_portal, a]);
  return Lt({ ref: Ac(t.unstable_popoverRef, r), role: "tooltip", style: Lt(Lt({}, t.unstable_popoverStyles), {}, { pointerEvents: "none" }, n), wrapElement: o }, i);
} }), Tsr = so({ as: "div", memo: !0, useHook: Asr }), Esr = lo({ name: "TooltipReference", compose: Ry, keys: _sr, useProps: function(t, e) {
  var r = e.ref, n = e.onFocus, a = e.onBlur, i = e.onMouseEnter, o = e.onMouseLeave, s = qn(e, ["ref", "onFocus", "onBlur", "onMouseEnter", "onMouseLeave"]), l = Ua(n), c = Ua(a), u = Ua(i), f = Ua(o), h = sr(function(b) {
    var w, _;
    (w = l.current) === null || w === void 0 || w.call(l, b), !b.defaultPrevented && ((_ = t.show) === null || _ === void 0 || _.call(t));
  }, [t.show]), p = sr(function(b) {
    var w, _;
    (w = c.current) === null || w === void 0 || w.call(c, b), !b.defaultPrevented && ((_ = t.hide) === null || _ === void 0 || _.call(t));
  }, [t.hide]), g = sr(function(b) {
    var w, _;
    (w = u.current) === null || w === void 0 || w.call(u, b), !b.defaultPrevented && ((_ = t.show) === null || _ === void 0 || _.call(t));
  }, [t.show]), y = sr(function(b) {
    var w, _;
    (w = f.current) === null || w === void 0 || w.call(f, b), !b.defaultPrevented && ((_ = t.hide) === null || _ === void 0 || _.call(t));
  }, [t.hide]);
  return Lt({ ref: Ac(t.unstable_referenceRef, r), tabIndex: 0, onFocus: h, onBlur: p, onMouseEnter: g, onMouseLeave: y, "aria-describedby": t.baseId }, s);
} }), Isr = so({ as: "div", useHook: Esr });
function tG(t) {
  t === void 0 && (t = {});
  var e = cg(t), r = e.placement, n = r === void 0 ? "top" : r, a = e.unstable_timeout, i = a === void 0 ? 0 : a, o = qn(e, ["placement", "unstable_timeout"]), s = Yt(i), l = s[0], c = s[1], u = Zt(null), f = Zt(null), h = rpe(Lt(Lt({}, o), {}, { placement: n }));
  h.modal, h.setModal;
  var p = qn(h, ["modal", "setModal"]), g = sr(function() {
    u.current !== null && window.clearTimeout(u.current), f.current !== null && window.clearTimeout(f.current);
  }, []), y = sr(function() {
    g(), p.hide(), f.current = window.setTimeout(function() {
      ov.hide(p.baseId);
    }, l);
  }, [g, p.hide, l, p.baseId]), b = sr(function() {
    g(), !l || ov.currentTooltipId ? (ov.show(p.baseId), p.show()) : (ov.show(null), u.current = window.setTimeout(function() {
      ov.show(p.baseId), p.show();
    }, l));
  }, [g, l, p.show, p.baseId]);
  return Ut(function() {
    return ov.subscribe(function(w) {
      w !== p.baseId && (g(), p.visible && p.hide());
    });
  }, [p.baseId, g, p.visible, p.hide]), Ut(function() {
    return function() {
      g(), ov.hide(p.baseId);
    };
  }, [g, p.baseId]), Lt(Lt({}, p), {}, { hide: y, show: b, unstable_timeout: l, unstable_setTimeout: c });
}
var Msr = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"], Psr = Msr, Rsr = [...Psr, "size"], Osr = [...Rsr, "fill", "stroke"], $Xe = lo({ name: "PopoverArrow", compose: PYe, keys: Osr, useOptions({ size: t = 30, fill: e, stroke: r, ...n }) {
  return { size: t, fill: e, stroke: r, ...n };
}, useProps(t, { ref: e, style: r, ...n }) {
  let [a] = t.placement.split("-"), i = { top: "rotateZ(180deg)", right: "rotateZ(-90deg)", bottom: "rotateZ(360deg)", left: "rotateZ(90deg)" }, { unstable_arrowStyles: o, fill: s, stroke: l } = t, c = i[a], u = P.useMemo(() => P.createElement("svg", { viewBox: "0 0 30 30", style: { transform: c } }, P.createElement("path", { fill: s, stroke: l, d: `M23.7,27.1L17,19.9C16.5,19.3,15.8,19,15,19s-1.6,0.3-2.1,0.9l-6.6,7.2C5.3,28.1,3.4,29,2,29h26
        C26.7,29,24.6,28.1,23.7,27.1z` }), P.createElement("path", { fill: s, d: "M23,27.8c1.1,1.2,3.4,2.2,5,2.2h2H0h2c1.7,0,3.9-1,5-2.2l6.6-7.2c0.7-0.8,2-0.8,2.7,0L23,27.8L23,27.8z" })), [c, s, l]), f = Zt(e);
  return { ref: Ac(t.unstable_arrowRef, f), style: { ...o, fontSize: t.size, width: "1em", height: "1em", pointerEvents: "none", [a]: "100%", ...r }, children: u, ...n };
} }), Bsr = so({ as: "div", memo: !0, useHook: $Xe }), DXe = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "unstable_disclosureRef", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place", "unstable_timeout", "unstable_setTimeout"];
[...DXe];
var Nsr = DXe, $sr = lo({ name: "TooltipArrow", compose: $Xe, keys: Nsr, useOptions({ size: t = 16, ...e }) {
  return { size: t, ...e };
} }), Dsr = so({ as: "div", memo: !0, useHook: $sr }), LXe = (t) => {
  let e = Md();
  return P.createElement(Dsr, { ...t, size: e.fontSizes.fontSize50, fill: e.backgroundColors.colorBackgroundInverseElevation });
};
LXe.displayName = "TooltipArrow";
var jXe = P.forwardRef(({ style: t, element: e, ...r }, n) => P.createElement(ht, { ...Xt(r), backgroundColor: "colorBackgroundInverseElevation", boxShadow: "shadowElevationInverse10", borderRadius: "borderRadius30", element: e, maxWidth: "size30", paddingX: "space50", paddingY: "space40", zIndex: "zIndex90", _focus: { outline: "none" }, style: t, ref: n }));
jXe.displayName = "StyledTooltip";
var rG = P.forwardRef(({ baseId: t, children: e, element: r = "TOOLTIP", state: n, text: a, actionHeader: i, keyCombinationsActions: o, ...s }, l) => {
  let c = n || tG({ baseId: `paste-tooltip-${Jr()}`, ...s });
  return P.createElement(P.Fragment, null, P.Children.only(P.createElement(Isr, { ...c, ref: l, ...e.props }, (u) => P.cloneElement(e, u))), P.createElement(Tsr, { element: r, ...c, ...s, as: jXe }, P.createElement(uy, null, P.createElement(LXe, { ...c }), a && !o && P.createElement(cl, { element: `${r}_TEXT`, as: "span", color: "colorTextInverse", fontSize: "fontSize20", lineHeight: "lineHeight10" }, a), o && !a && P.createElement(ht, { color: "colorTextInverse", fontSize: "fontSize20", lineHeight: "lineHeight10" }, P.createElement(J5, { orientation: "vertical", spacing: "space40" }, i && P.createElement(cl, { element: `${r}_HEADER`, fontWeight: "fontWeightSemibold", as: "p", color: "inherit", fontSize: "inherit", lineHeight: "inherit" }, i), o.map((u, f) => P.createElement(ht, { display: "flex", key: `action-${f}`, justifyContent: "space-between" }, u.name && P.createElement(cl, { element: `${r}_ACTION_TEXT`, as: "span", color: "inherit", fontSize: "inherit", lineHeight: "inherit", marginRight: "space70" }, u.name), P.createElement(SYe, { variant: "inverse", element: `${r}_ACTION_KEY_GROUP`, disabled: u.disabled }, u.eventKeyCombination.map((h, p) => P.createElement(wYe, { key: `key-${f}-${p}`, element: `${r}_ACTION_KEY` }, h))))))))));
});
rG.displayName = "Tooltip";
const Lsr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Tooltip: rG,
  useTooltipState: tG
}, Symbol.toStringTag, { value: "Module" }));
var jsr = ({ grow: t }) => Array.isArray(t) ? t.map((e) => Number(e)) : typeof t == "number" ? t : t ? 1 : 0, Fsr = ({ shrink: t, basis: e }) => Array.isArray(t) ? t.map((r) => Number(r)) : typeof t == "number" ? t : typeof t == "boolean" ? t ? 1 : 0 : e && e !== "auto" ? 0 : 1, C7e = (t) => {
  let e = typeof t == "number" || String(Number.parseInt(t, 10)) === t ? "px" : "";
  return t + e;
}, zsr = ({ basis: t }) => Array.isArray(t) ? t.map((e) => C7e(e)) : t ? C7e(t) : "auto", Gsr = ({ vertical: t }) => Array.isArray(t) ? t.map((e) => typeof e == "boolean" ? e === !0 ? "column" : "row" : e) : t ? "column" : "row", Wsr = ({ wrap: t }) => Array.isArray(t) ? t.map((e) => typeof e == "boolean" ? e === !0 ? "wrap" : "nowrap" : e) : t ? "wrap" : "nowrap", w7e = { top: "flex-start", center: "center", bottom: "flex-end", stretch: "stretch" }, S7e = ({ vAlignContent: t }) => Array.isArray(t) ? t.map((e) => w7e[e]) : t ? w7e[t] : "flex-start", _7e = { left: "flex-start", center: "center", right: "flex-end", around: "space-around", between: "space-between" }, k7e = ({ hAlignContent: t }) => Array.isArray(t) ? t.map((e) => _7e[e]) : t ? _7e[t] : "flex-start", Hsr = (t) => {
  let e = { justifyContent: t.vertical ? S7e(t) : k7e(t), alignItems: t.vertical ? k7e(t) : S7e(t) };
  return (t.grow || t.shrink || t.basis) && (e.flexGrow = jsr(t), e.flexShrink = Fsr(t), e.flexBasis = zsr(t)), t.vertical && (e.flexDirection = Gsr(t)), t.wrap && (e.flexWrap = Wsr(t)), e;
}, WT = P.forwardRef(({ as: t, basis: e, children: r, display: n = "flex", element: a = "FLEX", hAlignContent: i, grow: o, marginTop: s, marginRight: l, marginBottom: c, marginLeft: u, margin: f, marginX: h, marginY: p, paddingTop: g, paddingRight: y, paddingBottom: b, paddingLeft: w, padding: _, paddingX: C, paddingY: x, maxWidth: S, minWidth: A = "size0", width: I, height: M, minHeight: B, maxHeight: L, size: N, shrink: d, vertical: m, vAlignContent: v, wrap: k, ...O }, G) => {
  let H = P.useMemo(() => Hsr({ basis: e, hAlignContent: i, grow: o, shrink: d, vertical: m, vAlignContent: v, wrap: k }), [e, i, o, d, m, v, k]);
  N && (I || M) && console.error("[Paste Flex]: you cannot set a height or width when using the size attribute"), (h && (f || c || u || l || s) || p && (f || c || u || l || s)) && console.error("[Paste Flex]: you cannot set a top, right, bottom or left margin when using the marginX or marginY attributes."), (C && (_ || b || w || y || g) || x && (_ || b || w || y || g)) && console.error("[Paste Flex]: you cannot set a top, right, bottom or left padding when using the paddingX or paddingY attributes.");
  let j = h || p ? { marginX: h, marginY: p } : { margin: f, marginBottom: c, marginLeft: u, marginRight: l, marginTop: s }, F = C || x ? { paddingX: C, paddingY: x } : { padding: _, paddingBottom: b, paddingLeft: w, paddingRight: y, paddingTop: g }, z = N ? { size: N } : { height: M, width: I };
  return P.createElement(ht, { ...H, ...Xt(O), ref: G, as: t, display: n, element: a, ...j, ...F, minHeight: B, maxHeight: L, maxWidth: S, minWidth: A, ...z }, r);
});
WT.displayName = "Flex";
const Usr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Flex: WT
}, Symbol.toStringTag, { value: "Module" })), cpe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronLeftIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronLeftIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10.293 6.293a1 1 0 011.497 1.32l-.083.094L9.415 10l2.292 2.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-3-3a1 1 0 01-.083-1.32l.083-.094 3-3z" })));
});
cpe.displayName = "ChevronLeftIcon";
const nG = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronRightIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronRightIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.707 6.293a1 1 0 00-1.497 1.32l.083.094L10.585 10l-2.292 2.293a1 1 0 00-.083 1.32l.083.094a1 1 0 001.32.083l.094-.083 3-3a1 1 0 00.083-1.32l-.083-.094-3-3z" })));
});
nG.displayName = "ChevronRightIcon";
var By = P.createContext({}), uM = (t, e, r) => r ?? `${t.toUpperCase()}_${e}`, Vsr = () => {
  let [t, e] = Te.useState(null), [r, n] = Te.useState(null);
  return { elementOutOBoundsLeft: t, elementOutOBoundsRight: r, determineElementsOutOfBounds: (a, i) => {
    if (a && i) {
      let o = a == null ? void 0 : a.getBoundingClientRect().right, s = a == null ? void 0 : a.getBoundingClientRect().x, l = null, c = null;
      i.childNodes.forEach((u) => {
        let { x: f, right: h } = u.getBoundingClientRect();
        f < s && h > o || (Math.round(f) < Math.round(s - 28) && (l = u), Math.round(h) > Math.round(o + 28) && !c && (c = u)), e(l), n(c);
      });
    }
  } };
}, qsr = () => {
  let [t, e] = Te.useState(!1), r;
  return { showShadow: t, handleShadow: () => {
    r && window.clearTimeout(r), e(!0), r = window.setTimeout(() => {
      e(!1);
    }, 500);
  } };
}, A7e = (t, e, r, n) => {
  let a = t === "left" ? e : r;
  if (n && a) {
    let i = a.getBoundingClientRect(), o = n.getBoundingClientRect(), s = n.scrollLeft + (i.left - o.left) - o.width / 2 + i.width / 2;
    n.scrollTo({ left: s, behavior: "smooth" });
  }
}, FXe = P.forwardRef(({ children: t, element: e, orientation: r = "horizontal", state: n, variant: a, ...i }, o) => {
  let { orientation: s = r, ...l } = n || Csr({ orientation: r, ...i }), c = uM(s, "TABS", e), u = P.useMemo(() => ({ ...l, orientation: s, variant: a }), [l, s, a]), f = P.createElement(By.Provider, { value: u }, t);
  return s === "vertical" ? P.createElement(WT, { element: c, ref: o, wrap: !1, vAlignContent: "stretch" }, f) : P.createElement(ht, { element: c }, f);
});
FXe.displayName = "Tabs";
var Ksr = { color: "colorTextIcon", _hover: { color: "colorTextPrimaryStrongest", cursor: "pointer" } }, Zsr = { color: "colorTextIconInverse", _hover: { color: "colorTextInverse", cursor: "pointer" } }, Lue = ({ onClick: t, position: e, visible: r, element: n = "TAB_LIST", showShadow: a }) => {
  let i = Md(), { variant: o } = Te.useContext(By), s = o == null ? void 0 : o.includes("inverse"), l = e === "left" ? cpe : nG;
  return r ? Te.createElement(ht, { onClick: t, "aria-hidden": !0, display: "flex", alignItems: "center", justifyContent: "center", width: "sizeBase70", padding: "space20", boxShadow: (() => {
    if (a) return e === "left" ? s ? i.shadows.shadowLeftInverse : i.shadows.shadowLeft : s ? i.shadows.shadowRightInverse : i.shadows.shadowRight;
  })(), element: `${n}_OVERFLOW_BUTTON_${e.toUpperCase()}`, zIndex: "zIndex10", ...s ? Zsr : Ksr }, Te.createElement(l, { decorative: !0 })) : null;
};
Lue.displayName = "OverflowButton";
var Jsr = ds.div(() => us({ overflowX: "auto", overflowY: "hidden", overflowScrolling: "touch", "@supports (-moz-appearance:none)": { paddingBottom: "0px", scrollbarWidth: "none" }, "::-webkit-scrollbar": { height: 0 }, "::-webkit-scrollbar-track": { background: "transparent" } })), zXe = ({ children: t, variant: e, element: r }) => {
  let n = P.useRef(null), { selectedId: a } = P.useContext(By), i = P.useRef(null), o = e === "inverse" || e === "inverse_fitted", { determineElementsOutOfBounds: s, elementOutOBoundsLeft: l, elementOutOBoundsRight: c } = Vsr(), { handleShadow: u, showShadow: f } = qsr(), h = () => {
    u(), s(i.current, n.current);
  };
  return P.useEffect(() => {
    var p;
    n.current && i.current && ((p = i.current) == null || p.addEventListener("scroll", h), window.addEventListener("resize", h), s(i.current, n.current));
  }, [n.current, i.current]), P.useEffect(() => {
    if (i.current && a) {
      let p = document.getElementById(a), g = i.current.getBoundingClientRect().width;
      if (p && ((p == null ? void 0 : p.getBoundingClientRect().x) < 0 || (p == null ? void 0 : p.getBoundingClientRect().right) > g)) {
        let y = p.getBoundingClientRect().x - i.current.getBoundingClientRect().x;
        i.current.scrollLeft += y;
      }
    }
  }, [i.current, a]), P.useEffect(() => () => {
    i.current && (i.current.removeEventListener("scroll", h), window.removeEventListener("resize", h));
  }, []), P.createElement(ht, { display: "flex", overflow: "hidden" }, P.createElement(Lue, { position: "left", onClick: () => A7e("left", l, c, i.current), visible: !!l, element: r, showShadow: f }), P.createElement(ht, { as: Jsr, ref: i, flexGrow: 1, element: `${r}_SCROLL_WRAPPER` }, P.createElement(ht, { ref: n, position: "relative", whiteSpace: "nowrap", element: r, display: "flex", columnGap: "space20", paddingTop: "1px", boxShadow: o ? "shadowBorderBottomInverseWeakerInset" : "shadowBorderBottomWeakInset", width: c || l ? "max-content" : "auto" }, t, P.createElement(ht, { position: "absolute", width: "100%", height: "1px", backgroundColor: o ? "colorBackgroundInverse" : "colorBackgroundBody", bottom: "-1px" }))), P.createElement(Lue, { position: "right", onClick: () => A7e("right", l, c, i.current), visible: !!c, element: r, showShadow: f }));
};
zXe.displayName = "HorizontalTabList";
var GXe = ({ children: t, element: e, variant: r }) => P.createElement(ht, { element: e, marginRight: "space110", minWidth: "size20", maxWidth: "size40", borderRightStyle: "solid", borderRightWidth: "borderWidth10", borderRightColor: r === "inverse" || r === "inverse_fitted" ? "colorBorderInverseWeaker" : "colorBorderWeak" }, t);
GXe.displayName = "VerticalTabList";
var Ysr = P.forwardRef(({ children: t, element: e, variant: r, ...n }, a) => {
  let i = P.useContext(By), { orientation: o } = i, s = uM(o, "TAB_LIST", e), l = o === "vertical" ? GXe : zXe;
  return P.createElement(BXe, { ...i, as: ht, ...n, element: s, ref: a }, P.createElement(l, { variant: r || i.variant, element: `${s}_CHILD` }, t));
});
Ysr.displayName = "TabList";
var Xsr = (t, e) => {
  let r = e === "inverse" || e === "inverse_fitted" || e === "inverse_full_width", n = e === "fitted" || e === "inverse_fitted" || e === "full_width" || e === "inverse_full_width";
  switch (t) {
    case "vertical":
      return { color: r ? "colorTextInverseWeak" : "colorTextWeak", display: "block", marginBottom: "space30", paddingBottom: "space30", paddingLeft: "space50", paddingRight: "space50", paddingTop: "space30", _last: { marginBottom: "space0" }, _selected: { color: r ? "colorTextInverse" : "colorTextLink" }, _hover: { color: r ? "colorTextInverse" : "colorTextLinkStronger", boxShadow: r ? "shadowBorderRightInverseStrong" : "none" }, _disabled: { borderLeftColor: "transparent", color: r ? "colorTextInverseWeakest" : "colorTextWeaker", boxShadow: "none" }, _disabled_focus: { boxShadow: "none" }, _focus: { boxShadow: r ? "shadowFocusInverseInset" : "shadowFocusInset", outline: "none", borderTopLeftRadius: "borderRadius30", borderBottomLeftRadius: "borderRadius30" }, _selected_after: { content: '" "', position: "absolute", height: "80%", width: "4px", backgroundColor: r ? "colorBackgroundInverseStrongest" : "colorBackgroundPrimary", borderTopLeftRadius: "borderRadius30", borderBottomLeftRadius: "borderRadius30", right: -1, top: "10%" }, _selected_hover: { boxShadow: "none" }, _selected_hover_after: { content: '" "', position: "absolute", height: "80%", width: "4px", backgroundColor: r ? "colorBackgroundPrimary" : "colorBackgroundPrimaryStrongest", borderTopLeftRadius: "borderRadius30", borderBottomLeftRadius: "borderRadius30", right: -1, top: "10%" }, _focus_selected_after: { display: "none" }, _focus_selected_hover_after: { display: "none" }, _disabled_focus_after: { content: '" "', position: "absolute", height: "80%", width: "4px", backgroundColor: r ? "colorBackgroundInverseStronger" : "colorBackgroundStrong", borderTopLeftRadius: "borderRadius30", borderBottomLeftRadius: "borderRadius30", right: -1, top: "10%" } };
    case "horizontal":
    default:
      return { color: r ? "colorTextInverseWeak" : "colorTextWeak", borderColor: "transparent", borderStyle: "solid", borderWidth: "borderWidth10", borderBottomWidth: "borderWidth20", borderTopLeftRadius: "borderRadius30", borderTopRightRadius: "borderRadius30", display: "inline-block", flexBasis: n ? "50%" : void 0, flexGrow: n ? 1 : void 0, flexShrink: n ? 1 : void 0, minWidth: "sizeSquare130", paddingY: "space30", paddingX: "space50", textAlign: "center", bottom: "-1px", _selected: { borderColor: r ? "colorBorderInverse" : "colorBorderWeak", borderBottomColor: r ? "colorBorderInverseWeakest" : "colorBorderWeakest", color: r ? "colorTextInverse" : "colorTextPrimary", boxShadow: r ? "shadowBorderTopInverseStrongest" : "shadowBorderTopPrimary", backgroundColor: r ? "colorBackgroundInverse" : "colorBackgroundBody" }, _disabled: { borderBottomColor: "transparent", color: r ? "colorTextInverseWeakest" : "colorTextWeaker" }, _hover: { color: r ? "colorTextInverse" : "colorTextPrimaryStrongest", borderBottomColor: r ? "colorBorderInverseStrong" : "transparent" }, _selected_hover: { color: r ? "colorTextInverse" : "colorTextPrimaryStronger", borderBottomColor: "transparent", boxShadow: r ? "shadowBorderTopPrimary" : "shadowBorderTopPrimaryStrongest" }, _focus: { outline: "none", borderColor: "colorBorderPrimary", boxShadow: "shadowFocusInset", borderBottomColor: "colorBorderPrimary" }, _selected_focus: { borderStyle: "solid", boxShadow: "shadowFocusInset", color: r ? "colorTextInverse" : "colorTextPrimary", borderColor: "colorBorderPrimary" }, _disabled_focus: { borderColor: r ? "colorBorderInverseWeaker" : "colorBorderWeak", boxShadow: "none", borderBottom: "none", overflow: "clip" } };
  }
}, WXe = P.forwardRef(({ children: t, element: e, ...r }, n) => {
  let a = P.useContext(By), i = P.useMemo(() => Xsr(a.orientation, a.variant), [a.orientation, a.variant]), { orientation: o, variant: s } = a, l = uM(o, "TAB", e);
  return P.createElement(msr, { ...a, ...r, orientation: o === "vertical" ? void 0 : "horizontal", ref: n }, (c) => P.createElement(ht, { ...Xt(c), ...i, as: "span", cursor: c["aria-disabled"] ? "not-allowed" : "pointer", element: l, fontSize: "fontSize30", lineHeight: "lineHeight30", fontWeight: "fontWeightMedium", overflow: o !== "vertical" ? "hidden" : void 0, position: "relative", textOverflow: o !== "vertical" ? "ellipsis" : void 0, transition: "border-color 100ms ease, color 100ms ease", whiteSpace: o !== "vertical" ? "nowrap" : void 0, minWidth: s === "fitted" || s === "inverse_fitted" ? "auto" : "fit-content" }, t));
});
WXe.displayName = "Tab";
var Qsr = P.forwardRef(({ children: t, element: e, ...r }, n) => {
  let { orientation: a } = P.useContext(By), i = uM(a, "TAB_PANELS", e);
  return P.createElement(ht, { ...Xt(r), element: i, width: "100%", ref: n }, t);
});
Qsr.displayName = "TabPanels";
var HXe = P.forwardRef(({ children: t, element: e, paddingTop: r = "space60", ...n }, a) => {
  let i = P.useContext(By), o = uM(i.orientation, "TAB_PANEL", e);
  return P.createElement(xsr, { ...i, paddingTop: r, borderRadius: "borderRadius20", _focusVisible: { boxShadow: "shadowFocusInset", outline: "none" }, ...n, element: o, as: ht, ref: a }, t);
});
HXe.displayName = "TabPanel";
var elr = (t) => {
  let e = Md();
  return us({ 'code[class*="language-"]': { color: "#d6deeb", fontFamily: "fontFamilyCode", textAlign: "left", whiteSpace: "pre", wordSpacing: "normal", wordBreak: "normal", wordWrap: "normal", lineHeight: "1.5", fontSize: "1em", MozTabSize: "4", OTabSize: "4", tabSize: "4", WebkitHyphens: "none", MozHyphens: "none", msHyphens: "none", hyphens: "none" }, 'pre[class*="language-"]': { color: "white", fontFamily: "fontFamilyCode", textAlign: "left", whiteSpace: "pre", wordSpacing: "normal", wordBreak: "normal", wordWrap: "normal", lineHeight: "1.5", fontSize: "1em", MozTabSize: "4", OTabSize: "4", tabSize: "4", WebkitHyphens: "none", MozHyphens: "none", msHyphens: "none", hyphens: "none", margin: "0", overflow: "auto", background: "inherit", display: "-webkit-box", WebkitLineClamp: `${t}`, WebkitBoxOrient: "vertical", width: "100%" }, 'pre[class*="language-"]::-moz-selection': { textShadow: "none", background: "inherit" }, 'pre[class*="language-"] ::-moz-selection': { textShadow: "none", background: "inherit" }, 'code[class*="language-"]::-moz-selection': { textShadow: "none", background: "inherit" }, 'code[class*="language-"] ::-moz-selection': { textShadow: "none", background: "inherit" }, 'pre[class*="language-"]::selection': { textShadow: "none", background: "inherit" }, 'pre[class*="language-"] ::selection': { textShadow: "none", background: "inherit" }, 'code[class*="language-"]::selection': { textShadow: "none", background: "inherit" }, 'code[class*="language-"] ::selection': { textShadow: "none", background: "inherit" }, ':not(pre) > code[class*="language-"]': { color: "white", background: "#011627", padding: "0.1em", borderRadius: "0.3em", whiteSpace: "normal" }, comment: { color: "rgb(136, 145, 170)", fontStyle: "italic" }, linenumber: { color: "colorTextInverseWeak", fontStyle: "none" }, prolog: { color: "rgb(99, 119, 119)", fontStyle: "italic" }, cdata: { color: "rgb(99, 119, 119)", fontStyle: "italic" }, punctuation: { color: "rgb(199, 146, 234)" }, ".namespace": { color: "rgb(178, 204, 214)" }, deleted: { color: "rgba(239, 83, 80, 0.56)", fontStyle: "italic" }, symbol: { color: "rgb(128, 203, 196)" }, property: { color: "rgb(128, 203, 196)" }, tag: { color: "rgb(127, 219, 202)" }, operator: { color: "rgb(127, 219, 202)" }, keyword: { color: "rgb(127, 219, 202)" }, boolean: { color: "rgb(255, 88, 116)" }, number: { color: "rgb(247, 140, 108)" }, constant: { color: "rgb(130, 170, 255)" }, function: { color: "rgb(130, 170, 255)" }, builtin: { color: "rgb(130, 170, 255)" }, char: { color: "rgb(130, 170, 255)" }, selector: { color: "rgb(199, 146, 234)", fontStyle: "italic" }, doctype: { color: "rgb(199, 146, 234)", fontStyle: "italic" }, "attr-name": { color: "rgb(173, 219, 103)", fontStyle: "italic" }, inserted: { color: "rgb(173, 219, 103)", fontStyle: "italic" }, string: { color: "rgb(173, 219, 103)" }, url: { color: "rgb(173, 219, 103)" }, entity: { color: "rgb(173, 219, 103)" }, ".language-css .token.string": { color: "rgb(173, 219, 103)" }, ".style .token.string": { color: "rgb(173, 219, 103)" }, "class-name": { color: "rgb(255, 203, 139)" }, atrule: { color: "rgb(255, 203, 139)" }, "attr-value": { color: "rgb(255, 203, 139)" }, regex: { color: "rgb(214, 222, 235)" }, important: { color: "rgb(214, 222, 235)", fontWeight: "bold" }, variable: { color: "rgb(214, 222, 235)" }, bold: { fontWeight: "bold" }, italic: { fontStyle: "italic" } })(e);
}, tlr = (t, e) => (r) => r ? e : t, UXe = ({ text: t, i18nCopyLabelBefore: e = "Copy code block", i18nCopyLabelAfter: r = "Copied!", element: n = "COPY_BUTTON", copyTextFormatter: a, ...i }) => {
  let o = tG(), [s, l] = P.useState(e), c = P.useRef(!0), u = P.useMemo(() => tlr(e, r), [e, r]), f = onr({ copiedTimeout: 1500 }), h = P.useCallback(() => {
    let p = a ? a(t) : t;
    f.copy(p);
  }, [t, a, f]);
  return P.useEffect(() => {
    l(u(f.copied));
  }, [f.copied, u]), P.useEffect(() => {
    if (c.current) {
      c.current = !1;
      return;
    }
    setTimeout(() => {
      o.unstable_update();
    }, 0);
  }, [o]), P.createElement(rG, { text: s, state: o, element: `${n}_TOOLTIP` }, P.createElement(Zs, { variant: "inverse", size: "icon_small", onClick: h, element: n, ...i }, P.createElement(ht, { as: "span" }, P.createElement(xYe, { decorative: !0 }), P.createElement(ht, { as: "span", "aria-live": "polite" }, P.createElement(Ul, null, s)))));
};
UXe.displayName = "CopyButton";
var VXe = ({ i18nLinkLabel: t = "Open code block in new page", href: e, element: r = "EXTERNAL_LINK", ...n }) => {
  let a = tG(), i = t, o = P.useRef(!0);
  return P.useEffect(() => {
    if (o.current) {
      o.current = !1;
      return;
    }
    a.hide(), setTimeout(() => a.show(), 0);
  }, [i]), P.createElement(rG, { text: i, element: `${r}_TOOLTIP` }, P.createElement(Zs, { as: "a", variant: "inverse", size: "icon_small", href: e, element: r, target: "_blank", ...n }, P.createElement(Vz, { decorative: !0 }), P.createElement(Ul, null, t)));
};
VXe.displayName = "ExternalLinkButton";
var rlr = { "single-line": { gridTemplateColumns: "1fr auto", gridTemplateAreas: '"code-block button-group"', columnGap: "space40", borderRadius: "borderRadius20", paddingY: "space60" }, "multi-line": { gridTemplateRows: "auto 1fr", gridTemplateAreas: '"button-group" "code-block"', rowGap: "space20", paddingTop: "space50", paddingBottom: "space90" } }, qXe = P.forwardRef(({ element: t = "CODE_BLOCK", language: e, code: r, variant: n = "multi-line", showLineNumbers: a, wrapLines: i, maxLines: o, externalLink: s, i18nCopyLabelAfter: l, i18nCopyLabelBefore: c, i18nLinkLabel: u, copyTextFormatter: f, ...h }, p) => P.createElement(ht, { ref: p, element: t, variant: n, ...Xt(h), backgroundColor: "colorBackgroundBodyInverse", paddingX: "space70", display: "grid", ...rlr[n] }, P.createElement(ht, { display: "flex", flexDirection: "row", alignItems: "center", columnGap: "space40", justifyContent: n === "multi-line" ? "flex-end" : void 0, gridArea: "button-group" }, P.createElement(ht, null, P.createElement(UXe, { element: `${t}_COPY_BUTTON`, text: r, i18nCopyLabelAfter: l, i18nCopyLabelBefore: c, copyTextFormatter: f })), s && P.createElement(ht, null, P.createElement(VXe, { href: s, element: `${t}_EXTERNAL_LINK`, i18nLinkLabel: u }))), P.createElement(ht, { element: `${t}_CONTENT`, display: "flex", alignItems: "center", overflowX: "auto", gridArea: "code-block" }, P.createElement(Id, { language: e, style: elr(o), showLineNumbers: a, wrapLongLines: i, wrapLines: !0 }, r))));
qXe.displayName = "CodeBlock";
var KXe = P.forwardRef(({ children: t, element: e = "CODE_BLOCK_HEADER", as: r = "h3", ...n }, a) => P.createElement(ht, { ...Xt(n), ref: a, element: e, as: r, backgroundColor: "colorBackgroundInverseStrong", color: "colorTextInverse", paddingY: "space50", paddingX: "space70", margin: "space0", borderTopLeftRadius: "borderRadius20", borderTopRightRadius: "borderRadius20", fontWeight: "fontWeightSemibold", fontSize: "fontSize30" }, t));
KXe.displayName = "CodeBlockHeader";
var ZXe = P.forwardRef(({ children: t, element: e = "CODE_BLOCK_TAB", ...r }, n) => P.createElement(WXe, { element: e, ref: n, ...r }, t));
ZXe.displayName = "CodeBlockTab";
var nlr = { color: "colorTextIconInverse", _hover: { color: "colorTextInverse", cursor: "pointer" } }, jue = ({ onClick: t, position: e, visible: r, element: n = "CODE_BLOCK_TAB_LIST", showShadow: a }) => {
  let i = Md(), o = e === "left" ? cpe : nG;
  return !r && e === "right" ? null : Te.createElement(ht, { onClick: t, "aria-hidden": !0, display: "flex", alignItems: "center", justifyContent: "center", width: "sizeBase60", padding: "space10", position: "relative", boxShadow: (() => {
    if (r && a) return e === "left" ? i.shadows.shadowLeftInverse : i.shadows.shadowRightInverse;
  })(), element: `${n}_OVERFLOW_BUTTON_${e.toUpperCase()}`, cursor: r ? "pointer" : "none", zIndex: "zIndex10", ...nlr }, r && Te.createElement(o, { decorative: !0 }));
};
jue.displayName = "OverflowButton";
var alr = () => {
  let [t, e] = Te.useState(null), [r, n] = Te.useState(null);
  return { elementOutOBoundsLeft: t, elementOutOBoundsRight: r, determineElementsOutOfBounds: (a, i) => {
    if (a && i) {
      let o = a == null ? void 0 : a.getBoundingClientRect().right, s = a == null ? void 0 : a.getBoundingClientRect().x, l = null, c = null;
      i.childNodes.forEach((u) => {
        let { x: f, right: h } = u.getBoundingClientRect();
        f < s && h > o || (Math.round(f) < Math.round(s - 28) && (l = u), Math.round(h) > Math.round(o + 28) && !c && (c = u)), e(l), n(c);
      });
    }
  } };
}, ilr = () => {
  let [t, e] = Te.useState(!1), r;
  return { showShadow: t, handleShadow: () => {
    r && window.clearTimeout(r), e(!0), r = window.setTimeout(() => {
      e(!1);
    }, 500);
  } };
}, T7e = (t, e, r, n) => {
  let a = t === "left" ? e : r;
  if (n && a) {
    let i = a.getBoundingClientRect(), o = n.getBoundingClientRect(), s = n.scrollLeft + (i.left - o.left) - o.width / 2 + i.width / 2;
    n.scrollTo({ left: s, behavior: "smooth" });
  }
}, olr = ds.div(() => us({ overflowX: "auto", overflowY: "hidden", overflowScrolling: "touch", "@supports (-moz-appearance:none)": { paddingBottom: "0px", scrollbarWidth: "none" }, "::-webkit-scrollbar": { height: 0 }, "::-webkit-scrollbar-track": { background: "transparent" } })), JXe = P.forwardRef(({ children: t, element: e = "CODE_BLOCK_TAB_LIST", ...r }, n) => {
  let a = P.useContext(By), i = P.useRef(null), o = P.useRef(null), { determineElementsOutOfBounds: s, elementOutOBoundsLeft: l, elementOutOBoundsRight: c } = alr(), { handleShadow: u, showShadow: f } = ilr(), h = () => {
    u(), s(i.current, o.current);
  };
  return P.useEffect(() => {
    i.current && o.current && (i.current.addEventListener("scroll", h), window.addEventListener("resize", h), s(i.current, o.current));
  }, [i.current, o.current]), P.useEffect(() => () => {
    i.current && (i.current.removeEventListener("scroll", h), window.removeEventListener("resize", h));
  }, []), P.createElement(BXe, { ...a, as: ht, ...r, element: e, ref: n }, P.createElement(ht, { element: `${e}_CHILD_WRAPPER`, display: "flex" }, P.createElement(jue, { position: "left", onClick: () => T7e("left", l, c, i.current), visible: !!l, element: e, showShadow: f }), P.createElement(ht, { ...Xt(r), as: olr, ref: i, display: "flex", flexWrap: "nowrap", element: `${e}_CHILD_SCROLL_WRAPPER`, overflowX: "auto", overflowY: "hidden", flexGrow: 1, width: "calc(100% - 60px)" }, P.createElement(ht, { whiteSpace: "nowrap", element: `${e}_CHILD`, display: "flex", borderBottomStyle: "solid", borderBottomWidth: "borderWidth10", borderBottomColor: "colorBorderInverseWeaker", ref: o, flexGrow: 1, columnGap: "space20" }, t)), P.createElement(jue, { position: "right", onClick: () => T7e("right", l, c, i.current), visible: !!c, element: e, showShadow: f })));
});
JXe.displayName = "CodeBlockTabList";
var YXe = P.forwardRef(({ children: t, element: e = "CODE_BLOCK_TAB_PANEL", ...r }, n) => P.createElement(HXe, { ...r, paddingTop: "space0", element: e, ref: n }, t));
YXe.displayName = "CodeBlockTabPanel";
var XXe = P.forwardRef(({ children: t, state: e, element: r = "CODE_BLOCK_WRAPPER" }, n) => P.createElement(FXe, { variant: "inverse", state: e }, P.createElement(ht, { backgroundColor: "colorBackgroundInverseStrong", borderRadius: "borderRadius20", overflow: "hidden", element: r, ref: n }, t)));
XXe.displayName = "CodeBlockWrapper";
const slr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CodeBlock: qXe,
  CodeBlockHeader: KXe,
  CodeBlockTab: ZXe,
  CodeBlockTabList: JXe,
  CodeBlockTabPanel: YXe,
  CodeBlockWrapper: XXe
}, Symbol.toStringTag, { value: "Module" })), QXe = /* @__PURE__ */ aa(slr);
var E7e;
function llr() {
  return E7e || (E7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = QXe;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(XK)), XK;
}
var clr = /* @__PURE__ */ llr();
const ulr = "_markdownContainer_lrcxp_1", dlr = {
  markdownContainer: ulr
}, flr = ({ children: t, className: e, ...r }) => {
  const n = (e == null ? void 0 : e.replace("language-", "")) ?? void 0, a = String(t);
  return a.includes(`
`) ? /* @__PURE__ */ R.jsx(
    clr.CodeBlock,
    {
      ...r,
      variant: "multi-line",
      language: n,
      code: a,
      maxLines: 15,
      wrapLines: !0
    }
  ) : /* @__PURE__ */ R.jsx(o5t, { children: a });
}, hlr = ({ href: t, children: e }) => /* @__PURE__ */ R.jsx(ZGe, { href: t, showExternal: !0, children: e }), plr = ({ children: t }) => /* @__PURE__ */ R.jsx(i5t, { marginBottom: "space0", children: t }), mlr = ({ children: t }) => /* @__PURE__ */ R.jsx(a5t, { marginBottom: "space0", children: t }), glr = ({ children: t }) => /* @__PURE__ */ R.jsx(n5t, { children: t }), vlr = ({ children: t }) => /* @__PURE__ */ R.jsxs(JGe, { marginBottom: "space0", children: [
  " ",
  t
] }), H4 = (t) => ({ children: e }) => /* @__PURE__ */ R.jsx(
  Am,
  {
    as: `h${t}`,
    variant: `heading${t}0`,
    marginBottom: "space0",
    children: e
  }
), bx = ({ markdown: t }) => /* @__PURE__ */ R.jsx(
  njt,
  {
    className: dlr.markdownContainer,
    components: {
      p: vlr,
      code: flr,
      a: hlr,
      ol: plr,
      ul: mlr,
      li: glr,
      h1: H4(1),
      h2: H4(2),
      h3: H4(3),
      h4: H4(4),
      h5: H4(5),
      h6: H4(6)
    },
    children: t
  }
), Ts = () => /* @__PURE__ */ R.jsx(
  _r,
  {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ R.jsx(YGe, { decorative: !1, title: "Loading", size: "sizeIcon60" })
  }
);
var ylr = Object.defineProperty, blr = Object.defineProperties, xlr = Object.getOwnPropertyDescriptors, IL = Object.getOwnPropertySymbols, eQe = Object.prototype.hasOwnProperty, tQe = Object.prototype.propertyIsEnumerable, I7e = (t, e, r) => e in t ? ylr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, Clr = (t, e) => {
  for (var r in e || (e = {})) eQe.call(e, r) && I7e(t, r, e[r]);
  if (IL) for (var r of IL(e)) tQe.call(e, r) && I7e(t, r, e[r]);
  return t;
}, wlr = (t, e) => blr(t, xlr(e)), Slr = (t, e) => {
  var r = {};
  for (var n in t) eQe.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && IL) for (var n of IL(t)) e.indexOf(n) < 0 && tQe.call(t, n) && (r[n] = t[n]);
  return r;
};
const dM = P.forwardRef((t, e) => {
  var r = t, { as: n = "span", color: a = "currentColor", display: i = "block", element: o = "ICON", size: s = "sizeIcon30" } = r, l = Slr(r, ["as", "color", "display", "element", "size"]);
  return P.createElement(ht, wlr(Clr({}, Xt(l)), { as: n, element: o, lineHeight: "lineHeight0", display: i, color: a, size: s, ref: e, flexShrink: 0 }));
});
dM.displayName = "IconWrapper";
const rQe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DocumentationIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DocumentationIcon]: Missing a title for non-decorative icon.");
  return P.createElement(dM, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M9.374 5.458c.05.034.091.065.126.092v9.992a7.543 7.543 0 00-.822-.389c-1.145-.464-2.951-.92-5.678-.972V4.003c2.614.05 4.5.535 5.304.897.43.194.861.414 1.07.558zm.262 11.385zm.003.003l-.002-.002-.003-.003a2.543 2.543 0 00-.26-.203 5.623 5.623 0 00-1.072-.558c-1.034-.42-2.763-.866-5.475-.901h-.008a.85.85 0 01-.576-.248.824.824 0 01-.243-.587V3.834a.829.829 0 01.53-.775A.85.85 0 012.852 3c2.811.036 4.663.5 5.828.974a6.595 6.595 0 011.32.702 6.598 6.598 0 011.32-.702c1.165-.474 3.017-.938 5.828-.974a.85.85 0 01.599.238.83.83 0 01.253.596v10.51a.824.824 0 01-.242.587.85.85 0 01-.577.248h-.008c-2.712.035-4.44.481-5.475.9a5.63 5.63 0 00-1.072.558 2.53 2.53 0 00-.26.204l-.003.003-.002.002a.499.499 0 01-.361.15.499.499 0 01-.361-.15zm.725-.003zm.958-1.69a7.539 7.539 0 00-.822.39V5.55c.035-.027.077-.058.126-.092.209-.144.64-.364 1.07-.558.804-.362 2.69-.848 5.304-.897V14.18c-2.727.052-4.533.508-5.678.972zm-7.46-6.055a.5.5 0 01.534-.463c1.156.082 2.298.311 3.397.68a.5.5 0 01-.32.949 12.725 12.725 0 00-3.148-.632.5.5 0 01-.463-.534zm0 2.61a.5.5 0 01.534-.463c1.156.083 2.298.312 3.397.681a.5.5 0 11-.32.948 12.726 12.726 0 00-3.148-.632.5.5 0 01-.463-.534zm11.817-2.076a.5.5 0 00-.072-.997 13.726 13.726 0 00-3.396.68.5.5 0 00.318.949 12.724 12.724 0 013.15-.632zm.463 2.076a.5.5 0 01-.463.534c-1.073.077-2.13.29-3.15.632a.5.5 0 01-.318-.948c1.098-.37 2.24-.598 3.396-.681a.5.5 0 01.535.463z" })));
});
rQe.displayName = "DocumentationIcon";
const nQe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SupportRequestIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SupportRequestIcon]: Missing a title for non-decorative icon.");
  return P.createElement(dM, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, height: "100%", width: "100%", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", d: "M10.076 5.185a.97.97 0 00-1.036.967.5.5 0 11-1 0 1.97 1.97 0 013.776-.783 1.968 1.968 0 01-1.15 2.639.234.234 0 00-.157.222v.125a.5.5 0 11-1 0V8.23a1.235 1.235 0 01.823-1.165.969.969 0 00-.256-1.88zm-.066 4.139a.684.684 0 110 1.367.684.684 0 010-1.367z" }), P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M5.804 2a1.435 1.435 0 00-1.435 1.435v5.85l-.328-.21a1 1 0 00-1.541.84V15.5A1.5 1.5 0 004 17h12a1.5 1.5 0 001.5-1.5V9.916a1 1 0 00-1.54-.841l-.31.199v-5.84A1.434 1.434 0 0014.214 2h-8.41zm8.845 7.917V3.435A.435.435 0 0014.216 3H5.804a.435.435 0 00-.435.435v6.494l4.36 2.803a.5.5 0 00.541 0l4.38-2.815zm-3.838 3.656L16.5 9.916V15.5a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V9.916l5.689 3.657a1.5 1.5 0 001.622 0z" })));
});
nQe.displayName = "SupportRequestIcon";
const aQe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SMSCapableIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SMSCapableIcon]: Missing a title for non-decorative icon.");
  return P.createElement(dM, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.5 3A1.502 1.502 0 0118 4.5v10a1.502 1.502 0 01-1.5 1.5H9.667L5.8 18.9a.5.5 0 01-.8-.4V16H3.5A1.502 1.502 0 012 14.5v-10A1.502 1.502 0 013.5 3zm0 1h-13a.5.5 0 00-.5.5v10a.5.5 0 00.5.5h2a.5.5 0 01.5.5v2l3.2-2.4a.5.5 0 01.3-.1h7a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5zm-5 7a.5.5 0 110 1h-6a.5.5 0 110-1h6zm3-3a.5.5 0 110 1h-9a.5.5 0 010-1h9z" })));
});
aQe.displayName = "SMSCapableIcon";
const M7e = {
  documentation: rQe,
  "support-request": nQe,
  "sms-capable": aQe
}, _lr = ({ decorative: t = !0, name: e }) => {
  if (!M7e[e])
    return null;
  const r = M7e[e];
  return /* @__PURE__ */ R.jsx(r, { decorative: t });
}, $a = ({ error: t }) => /* @__PURE__ */ R.jsx(
  _r,
  {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    children: /* @__PURE__ */ R.jsxs(XGe, { variant: "error", children: [
      "An error occurred: ",
      JSON.stringify(t)
    ] })
  }
), klr = ({
  item: t,
  height: e = "200px",
  onClick: r
}) => /* @__PURE__ */ R.jsxs(
  _r,
  {
    height: e,
    borderWidth: "borderWidth10",
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    overflow: "hidden",
    cursor: r ? "pointer" : "default",
    _hover: {
      boxShadow: r ? "shadowCard" : "none"
    },
    onClick: r,
    children: [
      /* @__PURE__ */ R.jsx(
        _r,
        {
          padding: "space40",
          backgroundColor: "colorBackgroundWeak",
          borderTopLeftRadius: "borderRadius20",
          borderTopRightRadius: "borderRadius20",
          children: /* @__PURE__ */ R.jsx(Am, { as: "h3", variant: "heading30", marginBottom: "space0", children: /* @__PURE__ */ R.jsx(QGe, { title: t.name, children: t.name }) })
        }
      ),
      /* @__PURE__ */ R.jsx(eWe, { orientation: "horizontal", verticalSpacing: "space0" }),
      /* @__PURE__ */ R.jsx(_r, { padding: "space40", children: /* @__PURE__ */ R.jsx(JGe, { children: t.description }) })
    ]
  }
), Alr = ({ children: t }) => /* @__PURE__ */ R.jsx("div", { className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4", children: t }), Wl = ({
  label: t,
  variant: e,
  children: r
}) => /* @__PURE__ */ R.jsxs(
  _r,
  {
    display: "flex",
    flexDirection: e === "multiline" ? "column" : "row",
    columnGap: "space20",
    rowGap: "space20",
    alignItems: e === "multiline" ? "start" : "center",
    children: [
      /* @__PURE__ */ R.jsxs(_r, { as: "b", children: [
        t,
        ":"
      ] }),
      e === "multiline" ? /* @__PURE__ */ R.jsx(_r, { width: "100%", children: r }) : r
    ]
  }
), Ny = ({ children: t }) => /* @__PURE__ */ R.jsx(_r, { display: "flex", flexDirection: "column", rowGap: "space40", children: t }), iQe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CopyIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CopyIcon]: Missing a title for non-decorative icon.");
  return P.createElement(dM, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.469 2.5c.63 0 1.15.48 1.212 1.094l.007.125-.001 1.593h1.407c.73 0 1.331.558 1.4 1.271l.006.136v9.375c0 .776-.63 1.406-1.406 1.406H6.719c-.777 0-1.407-.63-1.407-1.406v-1.407H3.719c-.631 0-1.15-.48-1.213-1.094L2.5 13.47v-9.75c0-.631.48-1.15 1.094-1.213L3.72 2.5h9.75zm2.625 3.75H6.719a.469.469 0 00-.469.469v9.375c0 .259.21.468.469.468h9.375c.259 0 .468-.21.468-.468V6.719a.469.469 0 00-.468-.469zm-2.625-2.813h-9.75a.281.281 0 00-.274.217l-.007.065v9.75c0 .133.092.244.216.274l.065.007 1.593-.001v-7.03c0-.731.558-1.332 1.271-1.4l.136-.006 7.031-.001V3.719a.281.281 0 00-.217-.274l-.064-.007z" })));
});
iQe.displayName = "CopyIcon";
var Tlr = Object.create, aG = Object.defineProperty, Elr = Object.getOwnPropertyDescriptor, upe = Object.getOwnPropertyNames, Ilr = Object.getPrototypeOf, Mlr = Object.prototype.hasOwnProperty, Plr = (t, e) => function() {
  return t && (e = (0, t[upe(t)[0]])(t = 0)), e;
}, dpe = (t, e) => function() {
  return e || (0, t[upe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Rlr = (t, e) => {
  for (var r in e) aG(t, r, { get: e[r], enumerable: !0 });
}, fpe = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of upe(e)) !Mlr.call(t, a) && a !== r && aG(t, a, { get: () => e[a], enumerable: !(n = Elr(e, a)) || n.enumerable });
  return t;
}, Olr = (t, e, r) => (fpe(t, e, "default"), r), Blr = (t, e, r) => (r = t != null ? Tlr(Ilr(t)) : {}, fpe(!t || !t.__esModule ? aG(r, "default", { value: t, enumerable: !0 }) : r, t)), oQe = (t) => fpe(aG({}, "__esModule", { value: !0 }), t), Nlr = dpe({ "../../../node_modules/clipboard-copy/index.js"(t, e) {
  e.exports = r;
  function r(n) {
    if (navigator.clipboard) return navigator.clipboard.writeText(n).catch(function(l) {
      throw l !== void 0 ? l : new DOMException("The request is not allowed", "NotAllowedError");
    });
    var a = document.createElement("span");
    a.textContent = n, a.style.whiteSpace = "pre", document.body.appendChild(a);
    var i = window.getSelection(), o = window.document.createRange();
    i.removeAllRanges(), o.selectNode(a), i.addRange(o);
    var s = !1;
    try {
      s = window.document.execCommand("copy");
    } catch (l) {
      console.log("error", l);
    }
    return i.removeAllRanges(), window.document.body.removeChild(a), s ? Promise.resolve() : Promise.reject(new DOMException("The request is not allowed", "NotAllowedError"));
  }
} }), iG = {};
Rlr(iG, { default: () => P });
var sQe = Plr({ "esm-externals:react"() {
  Olr(iG, P);
} }), $lr = dpe({ "../../../node_modules/use-clipboard-copy/dist/useTimedToggle.js"(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.useTimedToggle = void 0;
  var e = (sQe(), oQe(iG));
  function r(n) {
    var a = e.useState(!1), i = a[0], o = a[1], s = e.useRef(), l = e.useRef(n), c = function(u) {
      clearTimeout(s.current), o(!l.current), s.current = window.setTimeout(function() {
        return o(l.current);
      }, u);
    };
    return e.useEffect(function() {
      return function() {
        return clearTimeout(s.current);
      };
    }, []), [i, c];
  }
  t.useTimedToggle = r;
} }), Dlr = dpe({ "../../../node_modules/use-clipboard-copy/dist/index.js"(t) {
  var e = t && t.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.useClipboard = void 0;
  var r = e(Nlr()), n = (sQe(), oQe(iG)), a = $lr();
  function i(s) {
    return s && (s.nodeName === "TEXTAREA" || s.nodeName === "INPUT");
  }
  function o(s) {
    s === void 0 && (s = {});
    var l = a.useTimedToggle(!1), c = l[0], u = l[1], f = n.useRef(null), h = n.useRef(s);
    h.current = s;
    function p() {
      return !!navigator.clipboard || typeof document.execCommand == "function" && typeof document.queryCommandSupported == "function" && document.queryCommandSupported("copy");
    }
    var g = n.useCallback(function(y) {
      var b = h.current, w = f.current;
      function _() {
        b.onSuccess && b.onSuccess(), b.copiedTimeout && u(b.copiedTimeout), b.selectOnCopy && i(w) && w.select();
      }
      function C() {
        b.onError && b.onError(), b.selectOnError !== !1 && i(w) && w.select();
      }
      function x(S) {
        r.default(S).then(_).catch(C);
      }
      typeof y == "string" ? x(y) : w && x(w.value);
    }, []);
    return { copied: c, copy: g, isSupported: p, target: f };
  }
  t.useClipboard = o;
} }), Llr = Blr(Dlr()), jlr = Llr.useClipboard;
const P7e = (t) => {
  const { text: e, onSuccess: r } = t, n = jlr({
    onSuccess: r,
    copiedTimeout: 1e3
  });
  return /* @__PURE__ */ R.jsx(
    as,
    {
      onClick: () => n.copied ? null : n.copy(e),
      variant: "reset",
      size: "reset",
      children: /* @__PURE__ */ R.jsx(
        iQe,
        {
          decorative: !1,
          size: "sizeIcon10",
          title: "Copy to clipboard"
        }
      )
    }
  );
}, ML = Ml(({ children: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  as,
  {
    ref: r,
    ...e,
    variant: "secondary",
    "data-paste-override": "ghost-button",
    children: t
  }
)), PL = ({ children: t, isActive: e, ...r }) => e ? /* @__PURE__ */ R.jsx(al, { ...r, children: t }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: t }), lQe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ColumnIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ColumnIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.143 2.5a.643.643 0 00-.643.643v13.714c0 .355.288.643.643.643h13.714a.643.643 0 00.643-.643V3.143a.643.643 0 00-.643-.643H3.143zM1.5 3.143c0-.907.736-1.643 1.643-1.643h13.714c.908 0 1.643.736 1.643 1.643v13.714c0 .908-.735 1.643-1.643 1.643H3.143A1.643 1.643 0 011.5 16.857V3.143z", clipRule: "evenodd" }), P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 1.5a.5.5 0 01.5.5v16a.5.5 0 01-1 0V2a.5.5 0 01.5-.5z", clipRule: "evenodd" })));
});
lQe.displayName = "ColumnIcon";
const Flr = "data:image/svg+xml,%3csvg%20width='14'%20height='14'%20viewBox='0%200%2014%2014'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_190_21552)'%3e%3cpath%20d='M3.02002%2010.9844L4.52002%209.48437L3.02002%207.98438'%20stroke='black'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M6.02002%2010.9844H7.52002'%20stroke='black'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M0.5%205.5H6.5'%20stroke='black'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5.5%202.5H1.5C1.23478%202.5%200.98043%202.60536%200.792893%202.79289C0.605357%202.98043%200.5%203.23478%200.5%203.5V12.5C0.5%2012.7652%200.605357%2013.0196%200.792893%2013.2071C0.98043%2013.3946%201.23478%2013.5%201.5%2013.5H11.5C12.0523%2013.5%2012.5%2013.0523%2012.5%2012.5V7'%20stroke='black'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M7.50916%203.93834C7.16361%203.87721%207.16361%203.37279%207.50916%203.31166C8.76104%203.0902%209.75674%202.12059%2010.0285%200.858379L10.0493%200.761626C10.1241%200.41435%2010.6103%200.412188%2010.6881%200.758787L10.7134%200.871541C10.9951%202.1278%2011.9911%203.08921%2013.2395%203.31006C13.5868%203.3715%2013.5868%203.8785%2013.2395%203.93994C11.9911%204.16079%2010.9951%205.1222%2010.7134%206.37846L10.6881%206.49121C10.6103%206.83781%2010.1241%206.83565%2010.0493%206.48837L10.0285%206.39162C9.75674%205.12941%208.76104%204.1598%207.50916%203.93834Z'%20stroke='black'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_190_21552'%3e%3crect%20width='14'%20height='14'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
var gZ = {};
const zlr = /* @__PURE__ */ aa(Ctr);
var R7e;
function Glr() {
  return R7e || (R7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = zlr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(gZ)), gZ;
}
var HT = /* @__PURE__ */ Glr(), vZ = {}, Wlr = Object.create, cQe = Object.defineProperty, Hlr = Object.getOwnPropertyDescriptor, uQe = Object.getOwnPropertyNames, Ulr = Object.getPrototypeOf, Vlr = Object.prototype.hasOwnProperty, qlr = (t, e) => function() {
  return e || (0, t[uQe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Klr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of uQe(e)) !Vlr.call(t, a) && a !== r && cQe(t, a, { get: () => e[a], enumerable: !(n = Hlr(e, a)) || n.enumerable });
  return t;
}, Zlr = (t, e, r) => (r = t != null ? Wlr(Ulr(t)) : {}, Klr(!t || !t.__esModule ? cQe(r, "default", { value: t, enumerable: !0 }) : r, t)), Jlr = qlr({ "../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), Ylr = Zlr(Jlr()), Xlr = ({ baseTheme: t, overrides: e, customBreakpoints: r, elements: n }) => {
  let a = r || t.breakpoints, i = (0, Ylr.default)(t, e);
  if (n != null && [...new Set(Object.keys(n).map((o) => o.toLowerCase()))].length !== Object.keys(n).length) throw new Error("[CustomizationProvider]: duplicate element names, even when using a different casing, is not supported with Paste.");
  return { ...i, breakpoints: a, elements: n };
}, dQe = ({ baseTheme: t = "default", customBreakpoints: e, elements: r, theme: n, disableAnimations: a = !1, ...i }) => {
  let o = iM();
  P.useMemo(() => {
    Td.assign({ skipAnimation: a || o });
  }, [a, o]);
  let s = P.useMemo(() => Xlr({ baseTheme: t === "dark" ? wL : NT, overrides: n || {}, elements: r || {}, customBreakpoints: e }), [t, e, r, n]);
  return P.createElement(cL, { theme: s }, P.createElement(fb, { styles: CL({ theme: s }) }), P.createElement(uy, { ...i }));
};
dQe.displayName = "PasteCustomizationProvider";
var fQe = (t) => P.createElement(ZJe.Consumer, { ...t });
fQe.displayName = "PasteCustomizationConsumer";
const Qlr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CustomizationConsumer: fQe,
  CustomizationProvider: dQe
}, Symbol.toStringTag, { value: "Module" })), ecr = /* @__PURE__ */ aa(Qlr);
var O7e;
function tcr() {
  return O7e || (O7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = ecr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(vZ)), vZ;
}
var hpe = /* @__PURE__ */ tcr(), yZ = {}, rcr = Object.create, hQe = Object.defineProperty, ncr = Object.getOwnPropertyDescriptor, pQe = Object.getOwnPropertyNames, acr = Object.getPrototypeOf, icr = Object.prototype.hasOwnProperty, fM = (t, e) => function() {
  return e || (0, t[pQe(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, ocr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of pQe(e)) !icr.call(t, a) && a !== r && hQe(t, a, { get: () => e[a], enumerable: !(n = ncr(e, a)) || n.enumerable });
  return t;
}, mQe = (t, e, r) => (r = t != null ? rcr(acr(t)) : {}, ocr(!t || !t.__esModule ? hQe(r, "default", { value: t, enumerable: !0 }) : r, t)), scr = fM({ "../../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(t, e) {
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  e.exports = r;
} }), lcr = fM({ "../../../node_modules/prop-types/factoryWithThrowingShims.js"(t, e) {
  var r = scr();
  function n() {
  }
  function a() {
  }
  a.resetWarningCache = n, e.exports = function() {
    function i(l, c, u, f, h, p) {
      if (p !== r) {
        var g = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw g.name = "Invariant Violation", g;
      }
    }
    i.isRequired = i;
    function o() {
      return i;
    }
    var s = { array: i, bigint: i, bool: i, func: i, number: i, object: i, string: i, symbol: i, any: i, arrayOf: o, element: i, elementType: i, instanceOf: o, node: i, objectOf: o, oneOf: o, oneOfType: o, shape: o, exact: o, checkPropTypes: a, resetWarningCache: n };
    return s.PropTypes = s, s;
  };
} }), ccr = fM({ "../../../node_modules/prop-types/index.js"(t, e) {
  e.exports = lcr()();
} }), ucr = fM({ "../../../node_modules/downshift/node_modules/react-is/cjs/react-is.production.min.js"(t) {
  var e = 60103, r = 60106, n = 60107, a = 60108, i = 60114, o = 60109, s = 60110, l = 60112, c = 60113, u = 60120, f = 60115, h = 60116, p = 60121, g = 60122, y = 60117, b = 60129, w = 60131;
  typeof Symbol == "function" && Symbol.for && (_ = Symbol.for, e = _("react.element"), r = _("react.portal"), n = _("react.fragment"), a = _("react.strict_mode"), i = _("react.profiler"), o = _("react.provider"), s = _("react.context"), l = _("react.forward_ref"), c = _("react.suspense"), u = _("react.suspense_list"), f = _("react.memo"), h = _("react.lazy"), p = _("react.block"), g = _("react.server.block"), y = _("react.fundamental"), b = _("react.debug_trace_mode"), w = _("react.legacy_hidden"));
  var _;
  function C(v) {
    if (typeof v == "object" && v !== null) {
      var k = v.$$typeof;
      switch (k) {
        case e:
          switch (v = v.type, v) {
            case n:
            case i:
            case a:
            case c:
            case u:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case l:
                case h:
                case f:
                case o:
                  return v;
                default:
                  return k;
              }
          }
        case r:
          return k;
      }
    }
  }
  var x = o, S = e, A = l, I = n, M = h, B = f, L = r, N = i, d = a, m = c;
  t.ContextConsumer = s, t.ContextProvider = x, t.Element = S, t.ForwardRef = A, t.Fragment = I, t.Lazy = M, t.Memo = B, t.Portal = L, t.Profiler = N, t.StrictMode = d, t.Suspense = m, t.isAsyncMode = function() {
    return !1;
  }, t.isConcurrentMode = function() {
    return !1;
  }, t.isContextConsumer = function(v) {
    return C(v) === s;
  }, t.isContextProvider = function(v) {
    return C(v) === o;
  }, t.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, t.isForwardRef = function(v) {
    return C(v) === l;
  }, t.isFragment = function(v) {
    return C(v) === n;
  }, t.isLazy = function(v) {
    return C(v) === h;
  }, t.isMemo = function(v) {
    return C(v) === f;
  }, t.isPortal = function(v) {
    return C(v) === r;
  }, t.isProfiler = function(v) {
    return C(v) === i;
  }, t.isStrictMode = function(v) {
    return C(v) === a;
  }, t.isSuspense = function(v) {
    return C(v) === c;
  }, t.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === n || v === i || v === b || v === a || v === c || v === u || v === w || typeof v == "object" && v !== null && (v.$$typeof === h || v.$$typeof === f || v.$$typeof === o || v.$$typeof === s || v.$$typeof === l || v.$$typeof === y || v.$$typeof === p || v[0] === g);
  }, t.typeOf = C;
} }), dcr = fM({ "../../../node_modules/downshift/node_modules/react-is/index.js"(t, e) {
  e.exports = ucr();
} });
function t0(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function Ga() {
  return Ga = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ga.apply(this, arguments);
}
function B7e(t) {
  if (t === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Fue(t, e) {
  return Fue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Fue(t, e);
}
function fcr(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Fue(t, e);
}
var qr = mQe(ccr());
mQe(dcr());
function N7e(t) {
  return typeof t == "object" && t != null && t.nodeType === 1;
}
function $7e(t, e) {
  return (!e || t !== "hidden") && t !== "visible" && t !== "clip";
}
function bZ(t, e) {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    var r = getComputedStyle(t, null);
    return $7e(r.overflowY, e) || $7e(r.overflowX, e) || function(n) {
      var a = function(i) {
        if (!i.ownerDocument || !i.ownerDocument.defaultView) return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(n);
      return !!a && (a.clientHeight < n.scrollHeight || a.clientWidth < n.scrollWidth);
    }(t);
  }
  return !1;
}
function yB(t, e, r, n, a, i, o, s) {
  return i < t && o > e || i > t && o < e ? 0 : i <= t && s <= r || o >= e && s >= r ? i - t - n : o > e && s < r || i < t && s > r ? o - e + a : 0;
}
var hcr = function(t, e) {
  var r = window, n = e.inline, a = e.boundary, i = e.skipOverflowHiddenElements, o = typeof a == "function" ? a : function(we) {
    return we !== a;
  };
  if (!N7e(t)) throw new TypeError("Invalid target");
  for (var s, l, c = document.scrollingElement || document.documentElement, u = [], f = t; N7e(f) && o(f); ) {
    if ((f = (l = (s = f).parentElement) == null ? s.getRootNode().host || null : l) === c) {
      u.push(f);
      break;
    }
    f != null && f === document.body && bZ(f) && !bZ(document.documentElement) || f != null && bZ(f, i) && u.push(f);
  }
  for (var h = r.visualViewport ? r.visualViewport.width : innerWidth, p = r.visualViewport ? r.visualViewport.height : innerHeight, g = window.scrollX || pageXOffset, y = window.scrollY || pageYOffset, b = t.getBoundingClientRect(), w = b.height, _ = b.width, C = b.top, x = b.right, S = b.bottom, A = b.left, I = C, M = n === "center" ? A + _ / 2 : n === "end" ? x : A, B = [], L = 0; L < u.length; L++) {
    var N = u[L], d = N.getBoundingClientRect(), m = d.height, v = d.width, k = d.top, O = d.right, G = d.bottom, H = d.left;
    if (C >= 0 && A >= 0 && S <= p && x <= h && C >= k && S <= G && A >= H && x <= O) return B;
    var j = getComputedStyle(N), F = parseInt(j.borderLeftWidth, 10), z = parseInt(j.borderTopWidth, 10), W = parseInt(j.borderRightWidth, 10), U = parseInt(j.borderBottomWidth, 10), Z = 0, V = 0, Y = "offsetWidth" in N ? N.offsetWidth - N.clientWidth - F - W : 0, ge = "offsetHeight" in N ? N.offsetHeight - N.clientHeight - z - U : 0, ce = "offsetWidth" in N ? N.offsetWidth === 0 ? 0 : v / N.offsetWidth : 0, ee = "offsetHeight" in N ? N.offsetHeight === 0 ? 0 : m / N.offsetHeight : 0;
    if (c === N) Z = yB(y, y + p, p, z, U, y + I, y + I + w, w), V = n === "start" ? M : n === "center" ? M - h / 2 : n === "end" ? M - h : yB(g, g + h, h, F, W, g + M, g + M + _, _), Z = Math.max(0, Z + y), V = Math.max(0, V + g);
    else {
      Z = yB(k, G, m, z, U + ge, I, I + w, w), V = n === "start" ? M - H - F : n === "center" ? M - (H + v / 2) + Y / 2 : n === "end" ? M - O + W + Y : yB(H, O, v, F, W + Y, M, M + _, _);
      var Se = N.scrollLeft, Ce = N.scrollTop;
      I += Ce - (Z = Math.max(0, Math.min(Ce + Z / ee, N.scrollHeight - m / ee + ge))), M += Se - (V = Math.max(0, Math.min(Se + V / ce, N.scrollWidth - v / ce + Y)));
    }
    B.push({ el: N, top: Z, left: V });
  }
  return B;
}, RL = function() {
  return RL = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, RL.apply(this, arguments);
}, pcr = 0;
function D7e(t) {
  return typeof t == "function" ? t : Z2;
}
function Z2() {
}
function gQe(t, e) {
  if (t) {
    var r = hcr(t, { boundary: e });
    r.forEach(function(n) {
      var a = n.el, i = n.top, o = n.left;
      a.scrollTop = i, a.scrollLeft = o;
    });
  }
}
function L7e(t, e, r) {
  var n = t === e || e instanceof r.Node && t.contains && t.contains(e);
  return n;
}
function ppe(t, e) {
  var r;
  function n() {
    r && clearTimeout(r);
  }
  function a() {
    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) o[s] = arguments[s];
    n(), r = setTimeout(function() {
      r = null, t.apply(void 0, o);
    }, e);
  }
  return a.cancel = n, a;
}
function il() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return function(n) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), o = 1; o < a; o++) i[o - 1] = arguments[o];
    return e.some(function(s) {
      return s && s.apply(void 0, [n].concat(i)), n.preventDownshiftDefault || n.hasOwnProperty("nativeEvent") && n.nativeEvent.preventDownshiftDefault;
    });
  };
}
function pm() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return function(n) {
    e.forEach(function(a) {
      typeof a == "function" ? a(n) : a && (a.current = n);
    });
  };
}
function vQe() {
  return String(pcr++);
}
function yQe(t) {
  var e = t.isOpen, r = t.resultCount, n = t.previousResultCount;
  return e ? r ? r !== n ? r + " result" + (r === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function j7e(t, e) {
  return t = Array.isArray(t) ? t[0] : t, !t && e ? e : t;
}
function mcr(t) {
  return typeof t.type == "string";
}
function gcr(t) {
  return t.props;
}
var vcr = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function bB(t) {
  t === void 0 && (t = {});
  var e = {};
  return vcr.forEach(function(r) {
    t.hasOwnProperty(r) && (e[r] = t[r]);
  }), e;
}
function UT(t, e) {
  return Object.keys(t).reduce(function(r, n) {
    return r[n] = OL(e, n) ? e[n] : t[n], r;
  }, {});
}
function OL(t, e) {
  return t[e] !== void 0;
}
function VT(t) {
  var e = t.key, r = t.keyCode;
  return r >= 37 && r <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function v7(t, e, r, n, a) {
  if (a === void 0 && (a = !0), r === 0) return -1;
  var i = r - 1;
  (typeof e != "number" || e < 0 || e >= r) && (e = t > 0 ? -1 : i + 1);
  var o = e + t;
  o < 0 ? o = a ? i : 0 : o > i && (o = a ? 0 : i);
  var s = C5(t, o, r, n, a);
  return s === -1 ? e >= r ? -1 : e : s;
}
function C5(t, e, r, n, a) {
  var i = n(e);
  if (!i || !i.hasAttribute("disabled")) return e;
  if (t > 0) {
    for (var o = e + 1; o < r; o++) if (!n(o).hasAttribute("disabled")) return o;
  } else for (var s = e - 1; s >= 0; s--) if (!n(s).hasAttribute("disabled")) return s;
  return a ? t > 0 ? C5(1, 0, r, n, !1) : C5(-1, r - 1, r, n, !1) : -1;
}
function BL(t, e, r, n) {
  return n === void 0 && (n = !0), e.some(function(a) {
    return a && (L7e(a, t, r) || n && L7e(a, r.document.activeElement, r));
  });
}
var ycr = ppe(function(t) {
  bQe(t).textContent = "";
}, 500);
function mpe(t, e) {
  var r = bQe(e);
  !t || (r.textContent = t, ycr(e));
}
function bQe(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, { border: "0", clip: "rect(0 0 0 0)", height: "1px", margin: "-1px", overflow: "hidden", padding: "0", position: "absolute", width: "1px" }), t.body.appendChild(e), e);
}
var xQe = 0, CQe = 1, wQe = 2, d$ = 3, f$ = 4, SQe = 5, _Qe = 6, kQe = 7, AQe = 8, TQe = 9, EQe = 10, IQe = 11, MQe = 12, PQe = 13, RQe = 14, OQe = 15, BQe = 16, bcr = Object.freeze({ __proto__: null, unknown: xQe, mouseUp: CQe, itemMouseEnter: wQe, keyDownArrowUp: d$, keyDownArrowDown: f$, keyDownEscape: SQe, keyDownEnter: _Qe, keyDownHome: kQe, keyDownEnd: AQe, clickItem: TQe, blurInput: EQe, changeInput: IQe, keyDownSpaceButton: MQe, clickButton: PQe, blurButton: RQe, controlledPropUpdatedSelectedItem: OQe, touchEnd: BQe }), xcr = ["refKey", "ref"], Ccr = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], wcr = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], Scr = ["refKey", "ref"], _cr = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"];
(function() {
  var t = function(e) {
    fcr(r, e);
    function r(a) {
      var i;
      i = e.call(this, a) || this, i.id = i.props.id || "downshift-" + vQe(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(_) {
        return i.id + "-item-" + _;
      }, i.input = null, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(_, C) {
        var x = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(S) {
            return S !== x;
          }), _();
        }, C);
        i.timeoutIds.push(x);
      }, i.setItemCount = function(_) {
        i.itemCount = _;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.setHighlightedIndex = function(_, C) {
        _ === void 0 && (_ = i.props.defaultHighlightedIndex), C === void 0 && (C = {}), C = bB(C), i.internalSetState(Ga({ highlightedIndex: _ }, C));
      }, i.clearSelection = function(_) {
        i.internalSetState({ selectedItem: null, inputValue: "", highlightedIndex: i.props.defaultHighlightedIndex, isOpen: i.props.defaultIsOpen }, _);
      }, i.selectItem = function(_, C, x) {
        C = bB(C), i.internalSetState(Ga({ isOpen: i.props.defaultIsOpen, highlightedIndex: i.props.defaultHighlightedIndex, selectedItem: _, inputValue: i.props.itemToString(_) }, C), x);
      }, i.selectItemAtIndex = function(_, C, x) {
        var S = i.items[_];
        S != null && i.selectItem(S, C, x);
      }, i.selectHighlightedItem = function(_, C) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, _, C);
      }, i.internalSetState = function(_, C) {
        var x, S, A = {}, I = typeof _ == "function";
        return !I && _.hasOwnProperty("inputValue") && i.props.onInputValueChange(_.inputValue, Ga({}, i.getStateAndHelpers(), _)), i.setState(function(M) {
          M = i.getState(M);
          var B = I ? _(M) : _;
          B = i.props.stateReducer(M, B), x = B.hasOwnProperty("selectedItem");
          var L = {};
          return x && B.selectedItem !== M.selectedItem && (S = B.selectedItem), B.type = B.type || xQe, Object.keys(B).forEach(function(N) {
            M[N] !== B[N] && (A[N] = B[N]), N !== "type" && (B[N], OL(i.props, N) || (L[N] = B[N]));
          }), I && B.hasOwnProperty("inputValue") && i.props.onInputValueChange(B.inputValue, Ga({}, i.getStateAndHelpers(), B)), L;
        }, function() {
          D7e(C)();
          var M = Object.keys(A).length > 1;
          M && i.props.onStateChange(A, i.getStateAndHelpers()), x && i.props.onSelect(_.selectedItem, i.getStateAndHelpers()), S !== void 0 && i.props.onChange(S, i.getStateAndHelpers()), i.props.onUserAction(A, i.getStateAndHelpers());
        });
      }, i.rootRef = function(_) {
        return i._rootNode = _;
      }, i.getRootProps = function(_, C) {
        var x, S = _ === void 0 ? {} : _, A = S.refKey, I = A === void 0 ? "ref" : A, M = S.ref, B = t0(S, xcr), L = C === void 0 ? {} : C, N = L.suppressRefError, d = N === void 0 ? !1 : N;
        i.getRootProps.called = !0, i.getRootProps.refKey = I, i.getRootProps.suppressRefError = d;
        var m = i.getState(), v = m.isOpen;
        return Ga((x = {}, x[I] = pm(M, i.rootRef), x.role = "combobox", x["aria-expanded"] = v, x["aria-haspopup"] = "listbox", x["aria-owns"] = v ? i.menuId : null, x["aria-labelledby"] = i.labelId, x), B);
      }, i.keyDownHandlers = { ArrowDown: function(_) {
        var C = this;
        if (_.preventDefault(), this.getState().isOpen) {
          var x = _.shiftKey ? 5 : 1;
          this.moveHighlightedIndex(x, { type: f$ });
        } else this.internalSetState({ isOpen: !0, type: f$ }, function() {
          var S = C.getItemCount();
          if (S > 0) {
            var A = C.getState(), I = A.highlightedIndex, M = v7(1, I, S, function(B) {
              return C.getItemNodeFromIndex(B);
            });
            C.setHighlightedIndex(M, { type: f$ });
          }
        });
      }, ArrowUp: function(_) {
        var C = this;
        if (_.preventDefault(), this.getState().isOpen) {
          var x = _.shiftKey ? -5 : -1;
          this.moveHighlightedIndex(x, { type: d$ });
        } else this.internalSetState({ isOpen: !0, type: d$ }, function() {
          var S = C.getItemCount();
          if (S > 0) {
            var A = C.getState(), I = A.highlightedIndex, M = v7(-1, I, S, function(B) {
              return C.getItemNodeFromIndex(B);
            });
            C.setHighlightedIndex(M, { type: d$ });
          }
        });
      }, Enter: function(_) {
        if (_.which !== 229) {
          var C = this.getState(), x = C.isOpen, S = C.highlightedIndex;
          if (x && S != null) {
            _.preventDefault();
            var A = this.items[S], I = this.getItemNodeFromIndex(S);
            if (A == null || I && I.hasAttribute("disabled")) return;
            this.selectHighlightedItem({ type: _Qe });
          }
        }
      }, Escape: function(_) {
        _.preventDefault(), this.reset(Ga({ type: SQe }, !this.state.isOpen && { selectedItem: null, inputValue: "" }));
      } }, i.buttonKeyDownHandlers = Ga({}, i.keyDownHandlers, { " ": function(_) {
        _.preventDefault(), this.toggleMenu({ type: MQe });
      } }), i.inputKeyDownHandlers = Ga({}, i.keyDownHandlers, { Home: function(_) {
        var C = this, x = this.getState(), S = x.isOpen;
        if (S) {
          _.preventDefault();
          var A = this.getItemCount();
          if (!(A <= 0 || !S)) {
            var I = C5(1, 0, A, function(M) {
              return C.getItemNodeFromIndex(M);
            }, !1);
            this.setHighlightedIndex(I, { type: kQe });
          }
        }
      }, End: function(_) {
        var C = this, x = this.getState(), S = x.isOpen;
        if (S) {
          _.preventDefault();
          var A = this.getItemCount();
          if (!(A <= 0 || !S)) {
            var I = C5(-1, A - 1, A, function(M) {
              return C.getItemNodeFromIndex(M);
            }, !1);
            this.setHighlightedIndex(I, { type: AQe });
          }
        }
      } }), i.getToggleButtonProps = function(_) {
        var C = _ === void 0 ? {} : _, x = C.onClick;
        C.onPress;
        var S = C.onKeyDown, A = C.onKeyUp, I = C.onBlur, M = t0(C, Ccr), B = i.getState(), L = B.isOpen, N = { onClick: il(x, i.buttonHandleClick), onKeyDown: il(S, i.buttonHandleKeyDown), onKeyUp: il(A, i.buttonHandleKeyUp), onBlur: il(I, i.buttonHandleBlur) }, d = M.disabled ? {} : N;
        return Ga({ type: "button", role: "button", "aria-label": L ? "close menu" : "open menu", "aria-haspopup": !0, "data-toggle": !0 }, d, M);
      }, i.buttonHandleKeyUp = function(_) {
        _.preventDefault();
      }, i.buttonHandleKeyDown = function(_) {
        var C = VT(_);
        i.buttonKeyDownHandlers[C] && i.buttonKeyDownHandlers[C].call(B7e(i), _);
      }, i.buttonHandleClick = function(_) {
        _.preventDefault(), i.props.environment.document.activeElement === i.props.environment.document.body && _.target.focus(), i.internalSetTimeout(function() {
          return i.toggleMenu({ type: PQe });
        });
      }, i.buttonHandleBlur = function(_) {
        var C = _.target;
        i.internalSetTimeout(function() {
          !i.isMouseDown && (i.props.environment.document.activeElement == null || i.props.environment.document.activeElement.id !== i.inputId) && i.props.environment.document.activeElement !== C && i.reset({ type: RQe });
        });
      }, i.getLabelProps = function(_) {
        return Ga({ htmlFor: i.inputId, id: i.labelId }, _);
      }, i.getInputProps = function(_) {
        var C = _ === void 0 ? {} : _, x = C.onKeyDown, S = C.onBlur, A = C.onChange, I = C.onInput;
        C.onChangeText;
        var M = t0(C, wcr), B, L = {};
        B = "onChange";
        var N = i.getState(), d = N.inputValue, m = N.isOpen, v = N.highlightedIndex;
        if (!M.disabled) {
          var k;
          L = (k = {}, k[B] = il(A, I, i.inputHandleChange), k.onKeyDown = il(x, i.inputHandleKeyDown), k.onBlur = il(S, i.inputHandleBlur), k);
        }
        return Ga({ "aria-autocomplete": "list", "aria-activedescendant": m && typeof v == "number" && v >= 0 ? i.getItemId(v) : null, "aria-controls": m ? i.menuId : null, "aria-labelledby": i.labelId, autoComplete: "off", value: d, id: i.inputId }, L, M);
      }, i.inputHandleKeyDown = function(_) {
        var C = VT(_);
        C && i.inputKeyDownHandlers[C] && i.inputKeyDownHandlers[C].call(B7e(i), _);
      }, i.inputHandleChange = function(_) {
        i.internalSetState({ type: IQe, isOpen: !0, inputValue: _.target.value, highlightedIndex: i.props.defaultHighlightedIndex });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var _ = i.props.environment.document && !!i.props.environment.document.activeElement && !!i.props.environment.document.activeElement.dataset && i.props.environment.document.activeElement.dataset.toggle && i._rootNode && i._rootNode.contains(i.props.environment.document.activeElement);
          !i.isMouseDown && !_ && i.reset({ type: EQe });
        });
      }, i.menuRef = function(_) {
        i._menuNode = _;
      }, i.getMenuProps = function(_, C) {
        var x, S = _ === void 0 ? {} : _, A = S.refKey, I = A === void 0 ? "ref" : A, M = S.ref, B = t0(S, Scr), L = C === void 0 ? {} : C, N = L.suppressRefError, d = N === void 0 ? !1 : N;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = I, i.getMenuProps.suppressRefError = d, Ga((x = {}, x[I] = pm(M, i.menuRef), x.role = "listbox", x["aria-labelledby"] = B && B["aria-label"] ? null : i.labelId, x.id = i.menuId, x), B);
      }, i.getItemProps = function(_) {
        var C, x = _ === void 0 ? {} : _, S = x.onMouseMove, A = x.onMouseDown, I = x.onClick;
        x.onPress;
        var M = x.index, B = x.item, L = B === void 0 ? void 0 : B, N = t0(x, _cr);
        M === void 0 ? (i.items.push(L), M = i.items.indexOf(L)) : i.items[M] = L;
        var d = "onClick", m = I, v = (C = { onMouseMove: il(S, function() {
          M !== i.getState().highlightedIndex && (i.setHighlightedIndex(M, { type: wQe }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
            return i.avoidScrolling = !1;
          }, 250));
        }), onMouseDown: il(A, function(O) {
          O.preventDefault();
        }) }, C[d] = il(m, function() {
          i.selectItemAtIndex(M, { type: TQe });
        }), C), k = N.disabled ? { onMouseDown: v.onMouseDown } : v;
        return Ga({ id: i.getItemId(M), role: "option", "aria-selected": i.getState().highlightedIndex === M }, k, N);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(_, C) {
        _ === void 0 && (_ = {}), _ = bB(_), i.internalSetState(function(x) {
          var S = x.selectedItem;
          return Ga({ isOpen: i.props.defaultIsOpen, highlightedIndex: i.props.defaultHighlightedIndex, inputValue: i.props.itemToString(S) }, _);
        }, C);
      }, i.toggleMenu = function(_, C) {
        _ === void 0 && (_ = {}), _ = bB(_), i.internalSetState(function(x) {
          var S = x.isOpen;
          return Ga({ isOpen: !S }, S && { highlightedIndex: i.props.defaultHighlightedIndex }, _);
        }, function() {
          var x = i.getState(), S = x.isOpen, A = x.highlightedIndex;
          S && i.getItemCount() > 0 && typeof A == "number" && i.setHighlightedIndex(A, _), D7e(C)();
        });
      }, i.openMenu = function(_) {
        i.internalSetState({ isOpen: !0 }, _);
      }, i.closeMenu = function(_) {
        i.internalSetState({ isOpen: !1 }, _);
      }, i.updateStatus = ppe(function() {
        var _ = i.getState(), C = i.items[_.highlightedIndex], x = i.getItemCount(), S = i.props.getA11yStatusMessage(Ga({ itemToString: i.props.itemToString, previousResultCount: i.previousResultCount, resultCount: x, highlightedItem: C }, _));
        i.previousResultCount = x, mpe(S, i.props.environment.document);
      }, 200);
      var o = i.props, s = o.defaultHighlightedIndex, l = o.initialHighlightedIndex, c = l === void 0 ? s : l, u = o.defaultIsOpen, f = o.initialIsOpen, h = f === void 0 ? u : f, p = o.initialInputValue, g = p === void 0 ? "" : p, y = o.initialSelectedItem, b = y === void 0 ? null : y, w = i.getState({ highlightedIndex: c, isOpen: h, inputValue: g, selectedItem: b });
      return w.selectedItem != null && i.props.initialInputValue === void 0 && (w.inputValue = i.props.itemToString(w.selectedItem)), i.state = w, i;
    }
    var n = r.prototype;
    return n.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(a) {
        clearTimeout(a);
      }), this.timeoutIds = [];
    }, n.getState = function(a) {
      return a === void 0 && (a = this.state), UT(a, this.props);
    }, n.getItemCount = function() {
      var a = this.items.length;
      return this.itemCount != null ? a = this.itemCount : this.props.itemCount !== void 0 && (a = this.props.itemCount), a;
    }, n.getItemNodeFromIndex = function(a) {
      return this.props.environment.document.getElementById(this.getItemId(a));
    }, n.scrollHighlightedItemIntoView = function() {
      {
        var a = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(a, this._menuNode);
      }
    }, n.moveHighlightedIndex = function(a, i) {
      var o = this, s = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (s > 0) {
        var u = v7(a, c, s, function(f) {
          return o.getItemNodeFromIndex(f);
        });
        this.setHighlightedIndex(u, i);
      }
    }, n.getStateAndHelpers = function() {
      var a = this.getState(), i = a.highlightedIndex, o = a.inputValue, s = a.selectedItem, l = a.isOpen, c = this.props.itemToString, u = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, y = this.getInputProps, b = this.getItemProps, w = this.openMenu, _ = this.closeMenu, C = this.toggleMenu, x = this.selectItem, S = this.selectItemAtIndex, A = this.selectHighlightedItem, I = this.setHighlightedIndex, M = this.clearSelection, B = this.clearItems, L = this.reset, N = this.setItemCount, d = this.unsetItemCount, m = this.internalSetState;
      return { getRootProps: f, getToggleButtonProps: h, getLabelProps: p, getMenuProps: g, getInputProps: y, getItemProps: b, reset: L, openMenu: w, closeMenu: _, toggleMenu: C, selectItem: x, selectItemAtIndex: S, selectHighlightedItem: A, setHighlightedIndex: I, clearSelection: M, clearItems: B, setItemCount: N, unsetItemCount: d, setState: m, itemToString: c, id: u, highlightedIndex: i, inputValue: o, isOpen: l, selectedItem: s };
    }, n.componentDidMount = function() {
      var a = this;
      {
        var i = function() {
          a.isMouseDown = !0;
        }, o = function(f) {
          a.isMouseDown = !1;
          var h = BL(f.target, [a._rootNode, a._menuNode], a.props.environment);
          !h && a.getState().isOpen && a.reset({ type: CQe }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, s = function() {
          a.isTouchMove = !1;
        }, l = function() {
          a.isTouchMove = !0;
        }, c = function(f) {
          var h = BL(f.target, [a._rootNode, a._menuNode], a.props.environment, !1);
          !a.isTouchMove && !h && a.getState().isOpen && a.reset({ type: BQe }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", i), u.addEventListener("mouseup", o), u.addEventListener("touchstart", s), u.addEventListener("touchmove", l), u.addEventListener("touchend", c), this.cleanup = function() {
          a.internalClearTimeouts(), a.updateStatus.cancel(), u.removeEventListener("mousedown", i), u.removeEventListener("mouseup", o), u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", l), u.removeEventListener("touchend", c);
        };
      }
    }, n.shouldScroll = function(a, i) {
      var o = this.props.highlightedIndex === void 0 ? this.getState() : this.props, s = o.highlightedIndex, l = i.highlightedIndex === void 0 ? a : i, c = l.highlightedIndex, u = s && this.getState().isOpen && !a.isOpen, f = s !== c;
      return u || f;
    }, n.componentDidUpdate = function(a, i) {
      OL(this.props, "selectedItem") && this.props.selectedItemChanged(a.selectedItem, this.props.selectedItem) && this.internalSetState({ type: OQe, inputValue: this.props.itemToString(this.props.selectedItem) }), !this.avoidScrolling && this.shouldScroll(i, a) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, n.componentWillUnmount = function() {
      this.cleanup();
    }, n.render = function() {
      var a = j7e(this.props.children, Z2);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = j7e(a(this.getStateAndHelpers()));
      if (!i) return null;
      if (this.getRootProps.called || this.props.suppressRefError) return i;
      if (mcr(i)) return xl(i, this.getRootProps(gcr(i)));
    }, r;
  }(QF);
  return t.defaultProps = { defaultHighlightedIndex: null, defaultIsOpen: !1, getA11yStatusMessage: yQe, itemToString: function(e) {
    return e == null ? "" : String(e);
  }, onStateChange: Z2, onInputValueChange: Z2, onUserAction: Z2, onChange: Z2, onSelect: Z2, onOuterClick: Z2, selectedItemChanged: function(e, r) {
    return e !== r;
  }, environment: typeof window > "u" ? {} : window, stateReducer: function(e, r) {
    return r;
  }, suppressRefError: !1, scrollIntoView: gQe }, t.stateChangeTypes = bcr, t;
})();
var kcr = ["isInitialMount", "highlightedIndex", "items", "environment"], NQe = { highlightedIndex: -1, isOpen: !1, selectedItem: null, inputValue: "" };
function Acr(t, e, r) {
  var n = t.props, a = t.type, i = {};
  Object.keys(e).forEach(function(o) {
    Tcr(o, t, e, r), r[o] !== e[o] && (i[o] = r[o]);
  }), n.onStateChange && Object.keys(i).length && n.onStateChange(Ga({ type: a }, i));
}
function Tcr(t, e, r, n) {
  var a = e.props, i = e.type, o = "on" + gpe(t) + "Change";
  a[o] && n[t] !== void 0 && n[t] !== r[t] && a[o](Ga({ type: i }, n));
}
function Ecr(t, e) {
  return e.changes;
}
function Icr(t) {
  var e = t.selectedItem, r = t.itemToString;
  return e ? r(e) + " has been selected." : "";
}
var Mcr = ppe(function(t, e) {
  mpe(t(), e);
}, 200), Pcr = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qh : Ut;
function Rcr(t) {
  var e = t.id, r = e === void 0 ? "downshift-" + vQe() : e, n = t.labelId, a = t.menuId, i = t.getItemId, o = t.toggleButtonId, s = t.inputId, l = Zt({ labelId: n || r + "-label", menuId: a || r + "-menu", getItemId: i || function(c) {
    return r + "-item-" + c;
  }, toggleButtonId: o || r + "-toggle-button", inputId: s || r + "-input" });
  return l.current;
}
function $Qe(t, e, r) {
  return t !== void 0 ? t : r.length === 0 ? -1 : r.indexOf(e);
}
function Ocr(t) {
  return t ? String(t) : "";
}
function gpe(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function vpe(t) {
  var e = Zt(t);
  return e.current = t, e;
}
function DQe(t, e, r) {
  var n = Zt(), a = Zt(), i = sr(function(h, p) {
    a.current = p, h = UT(h, p.props);
    var g = t(h, p), y = p.props.stateReducer(h, Ga({}, p, { changes: g }));
    return y;
  }, [t]), o = AI(i, e), s = o[0], l = o[1], c = vpe(r), u = sr(function(h) {
    return l(Ga({ props: c.current }, h));
  }, [c]), f = a.current;
  return Ut(function() {
    f && n.current && n.current !== s && Acr(f, UT(n.current, f.props), s), n.current = s;
  }, [s, r, f]), [s, u];
}
function Bcr(t, e, r) {
  var n = DQe(t, e, r), a = n[0], i = n[1];
  return [UT(a, r), i];
}
var N_ = { itemToString: Ocr, stateReducer: Ecr, getA11ySelectionMessage: Icr, scrollIntoView: gQe, circularNavigation: !1, environment: typeof window > "u" ? {} : window };
function p1(t, e, r) {
  r === void 0 && (r = NQe);
  var n = "default" + gpe(e);
  return n in t ? t[n] : r[e];
}
function QS(t, e, r) {
  if (r === void 0 && (r = NQe), e in t) return t[e];
  var n = "initial" + gpe(e);
  return n in t ? t[n] : p1(t, e, r);
}
function Ncr(t) {
  var e = QS(t, "selectedItem"), r = QS(t, "isOpen"), n = QS(t, "highlightedIndex"), a = QS(t, "inputValue");
  return { highlightedIndex: n < 0 && e && r ? t.items.indexOf(e) : n, isOpen: r, selectedItem: e, inputValue: a };
}
function NL(t, e, r, n) {
  var a = t.items, i = t.initialHighlightedIndex, o = t.defaultHighlightedIndex, s = e.selectedItem, l = e.highlightedIndex;
  return a.length === 0 ? -1 : i !== void 0 && l === i ? i : o !== void 0 ? o : s ? r === 0 ? a.indexOf(s) : v7(r, a.indexOf(s), a.length, n, !1) : r === 0 ? -1 : r < 0 ? a.length - 1 : 0;
}
function $cr(t, e, r, n) {
  var a = Zt({ isMouseDown: !1, isTouchMove: !1 });
  return Ut(function() {
    var i = function() {
      a.current.isMouseDown = !0;
    }, o = function(u) {
      a.current.isMouseDown = !1, t && !BL(u.target, e.map(function(f) {
        return f.current;
      }), r) && n();
    }, s = function() {
      a.current.isTouchMove = !1;
    }, l = function() {
      a.current.isTouchMove = !0;
    }, c = function(u) {
      t && !a.current.isTouchMove && !BL(u.target, e.map(function(f) {
        return f.current;
      }), r, !1) && n();
    };
    return r.addEventListener("mousedown", i), r.addEventListener("mouseup", o), r.addEventListener("touchstart", s), r.addEventListener("touchmove", l), r.addEventListener("touchend", c), function() {
      r.removeEventListener("mousedown", i), r.removeEventListener("mouseup", o), r.removeEventListener("touchstart", s), r.removeEventListener("touchmove", l), r.removeEventListener("touchend", c);
    };
  }, [t, r]), a;
}
var LQe = function() {
  return Z2;
};
function F7e(t, e, r) {
  var n = r.isInitialMount, a = r.highlightedIndex, i = r.items, o = r.environment, s = t0(r, kcr);
  Ut(function() {
    n || Mcr(function() {
      return t(Ga({ highlightedIndex: a, highlightedItem: i[a], resultCount: i.length }, s));
    }, o.document);
  }, e);
}
function Dcr(t) {
  var e = t.highlightedIndex, r = t.isOpen, n = t.itemRefs, a = t.getItemNodeFromIndex, i = t.menuElement, o = t.scrollIntoView, s = Zt(!0);
  return Pcr(function() {
    e < 0 || !r || !Object.keys(n.current).length || (s.current === !1 ? s.current = !0 : o(a(e), i));
  }, [e]), s;
}
var jQe = Z2;
function Lcr(t, e, r) {
  var n = e.type, a = e.props, i;
  switch (n) {
    case r.ItemMouseMove:
      i = { highlightedIndex: e.index };
      break;
    case r.MenuMouseLeave:
      i = { highlightedIndex: -1 };
      break;
    case r.ToggleButtonClick:
    case r.FunctionToggleMenu:
      i = { isOpen: !t.isOpen, highlightedIndex: t.isOpen ? -1 : NL(a, t, 0) };
      break;
    case r.FunctionOpenMenu:
      i = { isOpen: !0, highlightedIndex: NL(a, t, 0) };
      break;
    case r.FunctionCloseMenu:
      i = { isOpen: !1 };
      break;
    case r.FunctionSetHighlightedIndex:
      i = { highlightedIndex: e.highlightedIndex };
      break;
    case r.FunctionSetInputValue:
      i = { inputValue: e.inputValue };
      break;
    case r.FunctionReset:
      i = { highlightedIndex: p1(a, "highlightedIndex"), isOpen: p1(a, "isOpen"), selectedItem: p1(a, "selectedItem"), inputValue: p1(a, "inputValue") };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Ga({}, t, i);
}
qr.default.array.isRequired, qr.default.func, qr.default.func, qr.default.func, qr.default.bool, qr.default.number, qr.default.number, qr.default.number, qr.default.bool, qr.default.bool, qr.default.bool, qr.default.any, qr.default.any, qr.default.any, qr.default.string, qr.default.string, qr.default.string, qr.default.func, qr.default.string, qr.default.func, qr.default.func, qr.default.func, qr.default.func, qr.default.func, qr.default.shape({ addEventListener: qr.default.func, removeEventListener: qr.default.func, document: qr.default.shape({ getElementById: qr.default.func, activeElement: qr.default.any, body: qr.default.any }) });
function jcr(t) {
  var e = t.isOpen, r = t.resultCount, n = t.previousResultCount;
  return e ? r ? r !== n ? r + " result" + (r === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select." : "" : "No results are available." : "";
}
RL(RL({}, N_), { getA11yStatusMessage: jcr });
var ype = 0, bpe = 1, xpe = 2, Cpe = 3, wpe = 4, Spe = 5, _pe = 6, $L = 7, FQe = 8, zQe = 9, kpe = 10, GQe = 11, WQe = 12, HQe = 13, UQe = 14, VQe = 15, Ape = 16, qQe = 17, KQe = 18, Tpe = 19, ZQe = Object.freeze({ __proto__: null, InputKeyDownArrowDown: ype, InputKeyDownArrowUp: bpe, InputKeyDownEscape: xpe, InputKeyDownHome: Cpe, InputKeyDownEnd: wpe, InputKeyDownEnter: Spe, InputChange: _pe, InputBlur: $L, MenuMouseLeave: FQe, ItemMouseMove: zQe, ItemClick: kpe, ToggleButtonClick: GQe, FunctionToggleMenu: WQe, FunctionOpenMenu: HQe, FunctionCloseMenu: UQe, FunctionSetHighlightedIndex: VQe, FunctionSelectItem: Ape, FunctionSetInputValue: qQe, FunctionReset: KQe, ControlledPropUpdatedSelectedItem: Tpe });
function Fcr(t) {
  var e = Ncr(t), r = e.selectedItem, n = e.inputValue;
  return n === "" && r && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (n = t.itemToString(r)), Ga({}, e, { inputValue: n });
}
qr.default.array.isRequired, qr.default.func, qr.default.func, qr.default.func, qr.default.bool, qr.default.number, qr.default.number, qr.default.number, qr.default.bool, qr.default.bool, qr.default.bool, qr.default.any, qr.default.any, qr.default.any, qr.default.string, qr.default.string, qr.default.string, qr.default.string, qr.default.string, qr.default.string, qr.default.func, qr.default.string, qr.default.string, qr.default.func, qr.default.func, qr.default.func, qr.default.func, qr.default.func, qr.default.func, qr.default.shape({ addEventListener: qr.default.func, removeEventListener: qr.default.func, document: qr.default.shape({ getElementById: qr.default.func, activeElement: qr.default.any, body: qr.default.any }) });
function zcr(t, e, r) {
  var n = Zt(), a = DQe(t, e, r), i = a[0], o = a[1];
  return Ut(function() {
    OL(r, "selectedItem") && (n.current !== r.selectedItem && o({ type: Tpe, inputValue: r.itemToString(r.selectedItem) }), n.current = i.selectedItem === n.current ? r.selectedItem : i.selectedItem);
  }), [UT(i, r), o];
}
var Gcr = Ga({}, N_, { getA11yStatusMessage: yQe, circularNavigation: !0 });
function Wcr(t, e) {
  var r = e.type, n = e.props, a = e.shiftKey, i;
  switch (r) {
    case kpe:
      i = { isOpen: p1(n, "isOpen"), highlightedIndex: p1(n, "highlightedIndex"), selectedItem: n.items[e.index], inputValue: n.itemToString(n.items[e.index]) };
      break;
    case ype:
      t.isOpen ? i = { highlightedIndex: v7(a ? 5 : 1, t.highlightedIndex, n.items.length, e.getItemNodeFromIndex, n.circularNavigation) } : i = { highlightedIndex: NL(n, t, 1, e.getItemNodeFromIndex), isOpen: n.items.length >= 0 };
      break;
    case bpe:
      t.isOpen ? i = { highlightedIndex: v7(a ? -5 : -1, t.highlightedIndex, n.items.length, e.getItemNodeFromIndex, n.circularNavigation) } : i = { highlightedIndex: NL(n, t, -1, e.getItemNodeFromIndex), isOpen: n.items.length >= 0 };
      break;
    case Spe:
      i = Ga({}, t.isOpen && t.highlightedIndex >= 0 && { selectedItem: n.items[t.highlightedIndex], isOpen: p1(n, "isOpen"), highlightedIndex: p1(n, "highlightedIndex"), inputValue: n.itemToString(n.items[t.highlightedIndex]) });
      break;
    case xpe:
      i = Ga({ isOpen: !1, highlightedIndex: -1 }, !t.isOpen && { selectedItem: null, inputValue: "" });
      break;
    case Cpe:
      i = { highlightedIndex: C5(1, 0, n.items.length, e.getItemNodeFromIndex, !1) };
      break;
    case wpe:
      i = { highlightedIndex: C5(-1, n.items.length - 1, n.items.length, e.getItemNodeFromIndex, !1) };
      break;
    case $L:
      i = Ga({ isOpen: !1, highlightedIndex: -1 }, t.highlightedIndex >= 0 && e.selectItem && { selectedItem: n.items[t.highlightedIndex], inputValue: n.itemToString(n.items[t.highlightedIndex]) });
      break;
    case _pe:
      i = { isOpen: !0, highlightedIndex: p1(n, "highlightedIndex"), inputValue: e.inputValue };
      break;
    case Ape:
      i = { selectedItem: e.selectedItem, inputValue: n.itemToString(e.selectedItem) };
      break;
    case Tpe:
      i = { inputValue: e.inputValue };
      break;
    default:
      return Lcr(t, e, ZQe);
  }
  return Ga({}, t, i);
}
var Hcr = ["onMouseLeave", "refKey", "ref"], Ucr = ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"], Vcr = ["onClick", "onPress", "refKey", "ref"], qcr = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"], Kcr = ["refKey", "ref"];
a1.stateChangeTypes = ZQe;
function a1(t) {
  t === void 0 && (t = {});
  var e = Ga({}, Gcr, t), r = e.initialIsOpen, n = e.defaultIsOpen, a = e.items, i = e.scrollIntoView, o = e.environment, s = e.getA11yStatusMessage, l = e.getA11ySelectionMessage, c = e.itemToString, u = Fcr(e), f = zcr(Wcr, u, e), h = f[0], p = f[1], g = h.isOpen, y = h.highlightedIndex, b = h.selectedItem, w = h.inputValue, _ = Zt(null), C = Zt({}), x = Zt(null), S = Zt(null), A = Zt(null), I = Zt(!0), M = Rcr(e), B = Zt(), L = vpe({ state: h, props: e }), N = sr(function(ee) {
    return C.current[M.getItemId(ee)];
  }, [M]);
  F7e(s, [g, y, w, a], Ga({ isInitialMount: I.current, previousResultCount: B.current, items: a, environment: o, itemToString: c }, h)), F7e(l, [b], Ga({ isInitialMount: I.current, previousResultCount: B.current, items: a, environment: o, itemToString: c }, h));
  var d = Dcr({ menuElement: _.current, highlightedIndex: y, isOpen: g, itemRefs: C, scrollIntoView: i, getItemNodeFromIndex: N });
  jQe({ isInitialMount: I.current }), Ut(function() {
    var ee = r || n || g;
    ee && x.current && x.current.focus();
  }, []), Ut(function() {
    I.current || (B.current = a.length);
  });
  var m = $cr(g, [A, _, S], o, function() {
    p({ type: $L, selectItem: !1 });
  }), v = LQe();
  Ut(function() {
    I.current = !1;
  }, []), Ut(function() {
    g || (C.current = {});
  }, [g]);
  var k = fa(function() {
    return { ArrowDown: function(ee) {
      ee.preventDefault(), p({ type: ype, shiftKey: ee.shiftKey, getItemNodeFromIndex: N });
    }, ArrowUp: function(ee) {
      ee.preventDefault(), p({ type: bpe, shiftKey: ee.shiftKey, getItemNodeFromIndex: N });
    }, Home: function(ee) {
      !L.current.state.isOpen || (ee.preventDefault(), p({ type: Cpe, getItemNodeFromIndex: N }));
    }, End: function(ee) {
      !L.current.state.isOpen || (ee.preventDefault(), p({ type: wpe, getItemNodeFromIndex: N }));
    }, Escape: function() {
      var ee = L.current.state;
      (ee.isOpen || ee.inputValue || ee.selectedItem || ee.highlightedIndex > -1) && p({ type: xpe });
    }, Enter: function(ee) {
      var Se = L.current.state;
      !Se.isOpen || Se.highlightedIndex < 0 || ee.which === 229 || (ee.preventDefault(), p({ type: Spe, getItemNodeFromIndex: N }));
    } };
  }, [p, L, N]), O = sr(function(ee) {
    return Ga({ id: M.labelId, htmlFor: M.inputId }, ee);
  }, [M]), G = sr(function(ee, Se) {
    var Ce, we = ee === void 0 ? {} : ee, We = we.onMouseLeave, Fe = we.refKey, it = Fe === void 0 ? "ref" : Fe, gt = we.ref, Ze = t0(we, Hcr), Ne = Se === void 0 ? {} : Se;
    return Ne.suppressRefError, Ga((Ce = {}, Ce[it] = pm(gt, function(ze) {
      _.current = ze;
    }), Ce.id = M.menuId, Ce.role = "listbox", Ce["aria-labelledby"] = M.labelId, Ce.onMouseLeave = il(We, function() {
      p({ type: FQe });
    }), Ce), Ze);
  }, [p, v, M]), H = sr(function(ee) {
    var Se, Ce, we = ee === void 0 ? {} : ee, We = we.item, Fe = we.index, it = we.refKey, gt = it === void 0 ? "ref" : it, Ze = we.ref, Ne = we.onMouseMove, ze = we.onClick;
    we.onPress;
    var ct = t0(we, Ucr), rt = L.current, qe = rt.props, nt = rt.state, Rt = $Qe(Fe, We, qe.items);
    if (Rt < 0) throw new Error("Pass either item or item index in getItemProps!");
    var Ot = "onClick", lt = ze, mt = function() {
      Fe !== nt.highlightedIndex && (d.current = !1, p({ type: zQe, index: Fe }));
    }, jt = function() {
      p({ type: kpe, index: Fe }), x.current && x.current.focus();
    };
    return Ga((Se = {}, Se[gt] = pm(Ze, function(Jt) {
      Jt && (C.current[M.getItemId(Rt)] = Jt);
    }), Se.role = "option", Se["aria-selected"] = "" + (Rt === nt.highlightedIndex), Se.id = M.getItemId(Rt), Se), !ct.disabled && (Ce = { onMouseMove: il(Ne, mt) }, Ce[Ot] = il(lt, jt), Ce), ct);
  }, [p, L, d, M]), j = sr(function(ee) {
    var Se, Ce = ee === void 0 ? {} : ee, we = Ce.onClick;
    Ce.onPress;
    var We = Ce.refKey, Fe = We === void 0 ? "ref" : We, it = Ce.ref, gt = t0(Ce, Vcr), Ze = function() {
      p({ type: GQe }), !L.current.state.isOpen && x.current && x.current.focus();
    };
    return Ga((Se = {}, Se[Fe] = pm(it, function(Ne) {
      S.current = Ne;
    }), Se.id = M.toggleButtonId, Se.tabIndex = -1, Se), !gt.disabled && Ga({}, { onClick: il(we, Ze) }), gt);
  }, [p, L, M]), F = sr(function(ee, Se) {
    var Ce, we = ee === void 0 ? {} : ee, We = we.onKeyDown, Fe = we.onChange, it = we.onInput, gt = we.onBlur;
    we.onChangeText;
    var Ze = we.refKey, Ne = Ze === void 0 ? "ref" : Ze, ze = we.ref, ct = t0(we, qcr), rt = Se === void 0 ? {} : Se;
    rt.suppressRefError;
    var qe = L.current.state, nt = function(Jt) {
      var ne = VT(Jt);
      ne && k[ne] && k[ne](Jt);
    }, Rt = function(Jt) {
      p({ type: _pe, inputValue: Jt.target.value });
    }, Ot = function() {
      qe.isOpen && !m.current.isMouseDown && p({ type: $L, selectItem: !0 });
    }, lt = "onChange", mt = {};
    if (!ct.disabled) {
      var jt;
      mt = (jt = {}, jt[lt] = il(Fe, it, Rt), jt.onKeyDown = il(We, nt), jt.onBlur = il(gt, Ot), jt);
    }
    return Ga((Ce = {}, Ce[Ne] = pm(ze, function(Jt) {
      x.current = Jt;
    }), Ce.id = M.inputId, Ce["aria-autocomplete"] = "list", Ce["aria-controls"] = M.menuId, Ce), qe.isOpen && qe.highlightedIndex > -1 && { "aria-activedescendant": M.getItemId(qe.highlightedIndex) }, { "aria-labelledby": M.labelId, autoComplete: "off", value: qe.inputValue }, mt, ct);
  }, [p, k, L, m, v, M]), z = sr(function(ee, Se) {
    var Ce, we = ee === void 0 ? {} : ee, We = we.refKey, Fe = We === void 0 ? "ref" : We, it = we.ref, gt = t0(we, Kcr), Ze = Se === void 0 ? {} : Se;
    return Ze.suppressRefError, Ga((Ce = {}, Ce[Fe] = pm(it, function(Ne) {
      A.current = Ne;
    }), Ce.role = "combobox", Ce["aria-haspopup"] = "listbox", Ce["aria-owns"] = M.menuId, Ce["aria-expanded"] = L.current.state.isOpen, Ce), gt);
  }, [L, v, M]), W = sr(function() {
    p({ type: WQe });
  }, [p]), U = sr(function() {
    p({ type: UQe });
  }, [p]), Z = sr(function() {
    p({ type: HQe });
  }, [p]), V = sr(function(ee) {
    p({ type: VQe, highlightedIndex: ee });
  }, [p]), Y = sr(function(ee) {
    p({ type: Ape, selectedItem: ee });
  }, [p]), ge = sr(function(ee) {
    p({ type: qQe, inputValue: ee });
  }, [p]), ce = sr(function() {
    p({ type: KQe });
  }, [p]);
  return { getItemProps: H, getLabelProps: O, getMenuProps: G, getInputProps: F, getComboboxProps: z, getToggleButtonProps: j, toggleMenu: W, openMenu: Z, closeMenu: U, setHighlightedIndex: V, setInputValue: ge, selectItem: Y, reset: ce, highlightedIndex: y, isOpen: g, selectedItem: b, inputValue: w };
}
var JQe = { activeIndex: -1, selectedItems: [] };
function z7e(t, e) {
  return QS(t, e, JQe);
}
function G7e(t, e) {
  return p1(t, e, JQe);
}
function Zcr(t) {
  var e = z7e(t, "activeIndex"), r = z7e(t, "selectedItems");
  return { activeIndex: e, selectedItems: r };
}
function W7e(t) {
  if (t.shiftKey || t.metaKey || t.ctrlKey || t.altKey) return !1;
  var e = t.target;
  return !(e instanceof HTMLInputElement && e.value !== "" && (e.selectionStart !== 0 || e.selectionEnd !== 0));
}
function Jcr(t) {
  var e = t.removedSelectedItem, r = t.itemToString;
  return r(e) + " has been removed.";
}
qr.default.array, qr.default.array, qr.default.array, qr.default.func, qr.default.func, qr.default.func, qr.default.number, qr.default.number, qr.default.number, qr.default.func, qr.default.func, qr.default.string, qr.default.string, qr.default.shape({ addEventListener: qr.default.func, removeEventListener: qr.default.func, document: qr.default.shape({ getElementById: qr.default.func, activeElement: qr.default.any, body: qr.default.any }) });
var Ycr = { itemToString: N_.itemToString, stateReducer: N_.stateReducer, environment: N_.environment, getA11yRemovalMessage: Jcr, keyNavigationNext: "ArrowRight", keyNavigationPrevious: "ArrowLeft" }, Epe = 0, Ipe = 1, Mpe = 2, Ppe = 3, Rpe = 4, Ope = 5, Bpe = 6, Npe = 7, $pe = 8, Dpe = 9, Lpe = 10, jpe = 11, Fpe = 12, Xcr = Object.freeze({ __proto__: null, SelectedItemClick: Epe, SelectedItemKeyDownDelete: Ipe, SelectedItemKeyDownBackspace: Mpe, SelectedItemKeyDownNavigationNext: Ppe, SelectedItemKeyDownNavigationPrevious: Rpe, DropdownKeyDownNavigationPrevious: Ope, DropdownKeyDownBackspace: Bpe, DropdownClick: Npe, FunctionAddSelectedItem: $pe, FunctionRemoveSelectedItem: Dpe, FunctionSetSelectedItems: Lpe, FunctionSetActiveIndex: jpe, FunctionReset: Fpe });
function Qcr(t, e) {
  var r = e.type, n = e.index, a = e.props, i = e.selectedItem, o = t.activeIndex, s = t.selectedItems, l;
  switch (r) {
    case Epe:
      l = { activeIndex: n };
      break;
    case Rpe:
      l = { activeIndex: o - 1 < 0 ? 0 : o - 1 };
      break;
    case Ppe:
      l = { activeIndex: o + 1 >= s.length ? -1 : o + 1 };
      break;
    case Mpe:
    case Ipe: {
      var c = o;
      s.length === 1 ? c = -1 : o === s.length - 1 && (c = s.length - 2), l = Ga({ selectedItems: [].concat(s.slice(0, o), s.slice(o + 1)) }, { activeIndex: c });
      break;
    }
    case Ope:
      l = { activeIndex: s.length - 1 };
      break;
    case Bpe:
      l = { selectedItems: s.slice(0, s.length - 1) };
      break;
    case $pe:
      l = { selectedItems: [].concat(s, [i]) };
      break;
    case Npe:
      l = { activeIndex: -1 };
      break;
    case Dpe: {
      var u = o, f = s.indexOf(i);
      s.length === 1 ? u = -1 : f === s.length - 1 && (u = s.length - 2), l = Ga({ selectedItems: [].concat(s.slice(0, f), s.slice(f + 1)) }, { activeIndex: u });
      break;
    }
    case Lpe: {
      var h = e.selectedItems;
      l = { selectedItems: h };
      break;
    }
    case jpe: {
      var p = e.activeIndex;
      l = { activeIndex: p };
      break;
    }
    case Fpe:
      l = { activeIndex: G7e(a, "activeIndex"), selectedItems: G7e(a, "selectedItems") };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return Ga({}, t, l);
}
var eur = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"], tur = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
zpe.stateChangeTypes = Xcr;
function zpe(t) {
  t === void 0 && (t = {});
  var e = Ga({}, Ycr, t), r = e.getA11yRemovalMessage, n = e.itemToString, a = e.environment, i = e.keyNavigationNext, o = e.keyNavigationPrevious, s = Bcr(Qcr, Zcr(e), e), l = s[0], c = s[1], u = l.activeIndex, f = l.selectedItems, h = Zt(!0), p = Zt(null), g = Zt(f), y = Zt();
  y.current = [];
  var b = vpe({ state: l, props: e });
  Ut(function() {
    if (!h.current) {
      if (f.length < g.current.length) {
        var N = g.current.find(function(d) {
          return f.indexOf(d) < 0;
        });
        mpe(r({ itemToString: n, resultCount: f.length, removedSelectedItem: N, activeIndex: u, activeSelectedItem: f[u] }), a.document);
      }
      g.current = f;
    }
  }, [f.length]), Ut(function() {
    h.current || (u === -1 && p.current ? p.current.focus() : y.current[u] && y.current[u].focus());
  }, [u]), jQe({ isInitialMount: h.current });
  var w = LQe();
  Ut(function() {
    h.current = !1;
  }, []);
  var _ = fa(function() {
    var N;
    return N = {}, N[o] = function() {
      c({ type: Rpe });
    }, N[i] = function() {
      c({ type: Ppe });
    }, N.Delete = function() {
      c({ type: Ipe });
    }, N.Backspace = function() {
      c({ type: Mpe });
    }, N;
  }, [c, i, o]), C = fa(function() {
    var N;
    return N = {}, N[o] = function(d) {
      W7e(d) && c({ type: Ope });
    }, N.Backspace = function(d) {
      W7e(d) && c({ type: Bpe });
    }, N;
  }, [c, o]), x = sr(function(N) {
    var d, m = N === void 0 ? {} : N, v = m.refKey, k = v === void 0 ? "ref" : v, O = m.ref, G = m.onClick, H = m.onKeyDown, j = m.selectedItem, F = m.index, z = t0(m, eur), W = b.current.state, U = $Qe(F, j, W.selectedItems);
    if (U < 0) throw new Error("Pass either selectedItem or index in getSelectedItemProps!");
    var Z = function() {
      c({ type: Epe, index: F });
    }, V = function(Y) {
      var ge = VT(Y);
      ge && _[ge] && _[ge](Y);
    };
    return Ga((d = {}, d[k] = pm(O, function(Y) {
      Y && y.current.push(Y);
    }), d.tabIndex = F === W.activeIndex ? 0 : -1, d.onClick = il(G, Z), d.onKeyDown = il(H, V), d), z);
  }, [c, b, _]), S = sr(function(N, d) {
    var m, v = N === void 0 ? {} : N, k = v.refKey, O = k === void 0 ? "ref" : k, G = v.ref, H = v.onKeyDown, j = v.onClick, F = v.preventKeyAction, z = F === void 0 ? !1 : F, W = t0(v, tur), U = d === void 0 ? {} : d;
    U.suppressRefError;
    var Z = function(Y) {
      var ge = VT(Y);
      ge && C[ge] && C[ge](Y);
    }, V = function() {
      c({ type: Npe });
    };
    return Ga((m = {}, m[O] = pm(G, function(Y) {
      Y && (p.current = Y);
    }), m), !z && { onKeyDown: il(H, Z), onClick: il(j, V) }, W);
  }, [c, C, w]), A = sr(function(N) {
    c({ type: $pe, selectedItem: N });
  }, [c]), I = sr(function(N) {
    c({ type: Dpe, selectedItem: N });
  }, [c]), M = sr(function(N) {
    c({ type: Lpe, selectedItems: N });
  }, [c]), B = sr(function(N) {
    c({ type: jpe, activeIndex: N });
  }, [c]), L = sr(function() {
    c({ type: Fpe });
  }, [c]);
  return { getSelectedItemProps: x, getDropdownProps: S, addSelectedItem: A, removeSelectedItem: I, setSelectedItems: M, setActiveIndex: B, reset: L, selectedItems: f, activeIndex: u };
}
/** @license React v17.0.2
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
const fy = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ErrorIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ErrorIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.247 2.517l6.236 6.236a1.764 1.764 0 010 2.494l-6.236 6.236a1.764 1.764 0 01-2.494 0l-6.236-6.236a1.764 1.764 0 010-2.494l6.236-6.236a1.764 1.764 0 012.494 0zM10 12a1 1 0 100 2 1 1 0 000-2zm.01-5h-.02c-.604 0-1.073.592-.978 1.244l.428 2.238c.04.296.278.518.557.518h.006c.279 0 .516-.222.557-.518l.428-2.238c.095-.652-.367-1.237-.978-1.244z" })));
});
fy.displayName = "ErrorIcon";
const oG = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SuccessIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SuccessIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 2a8 8 0 110 16 8 8 0 010-16zm2.997 5c-.266 0-.521.106-.71.294l-3.286 3.294L7.712 9.29a1.003 1.003 0 00-1.418 1.418l1.998 1.997a1 1 0 001.418 0l3.996-3.994A1.002 1.002 0 0012.996 7z" })));
});
oG.displayName = "SuccessIcon";
const hM = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `WarningIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[WarningIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M17.798 14.791L11.316 3.744c-.582-.992-2.05-.992-2.632 0L2.202 14.79C1.625 15.776 2.354 17 3.518 17h12.964c1.164 0 1.893-1.224 1.316-2.209zM9.99 8h.02c.611.007 1.073.592.978 1.244l-.428 2.238c-.04.296-.278.518-.557.518h-.006c-.279 0-.516-.222-.557-.518l-.428-2.238C8.917 8.592 9.386 8 9.99 8zm.01 7a1 1 0 100-2 1 1 0 000 2z" })));
});
hM.displayName = "WarningIcon";
var U4 = { DEFAULT: "default", ERROR: "error", ERROR_INVERSE: "error_inverse", INVERSE: "inverse", SUCCESS: "success", WARNING: "warning" }, rur = { [U4.DEFAULT]: { textColor: "colorTextWeak", icon: null }, [U4.INVERSE]: { textColor: "colorTextInverseWeaker", icon: null }, [U4.ERROR]: { textColor: "colorTextError", icon: P.createElement(ht, { flexShrink: 0 }, P.createElement(fy, { color: "colorTextError", decorative: !0, size: "sizeIcon20" })) }, [U4.ERROR_INVERSE]: { textColor: "colorTextErrorWeak", icon: P.createElement(ht, { flexShrink: 0 }, P.createElement(fy, { color: "colorTextErrorWeak", decorative: !0, size: "sizeIcon20" })) }, [U4.SUCCESS]: { textColor: "colorTextSuccess", icon: P.createElement(ht, { flexShrink: 0 }, P.createElement(oG, { color: "colorTextIconSuccess", decorative: !0, size: "sizeIcon20" })) }, [U4.WARNING]: { textColor: "colorTextWarning", icon: P.createElement(ht, { flexShrink: 0 }, P.createElement(hM, { color: "colorTextWarning", decorative: !0, size: "sizeIcon20" })) } }, w5 = P.forwardRef(({ marginTop: t, children: e, variant: r = "default", element: n = "HELP_TEXT", ...a }, i) => {
  let { textColor: o, icon: s } = rur[r];
  return P.createElement(ht, { ...Xt(a), display: "flex", columnGap: "space20", marginTop: t || "space30", ref: i, element: n, variant: r, as: "div", color: o, fontSize: "fontSize30", lineHeight: "lineHeight30" }, s, P.createElement("span", null, e));
});
w5.displayName = "HelpText";
const nur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HelpText: w5
}, Symbol.toStringTag, { value: "Module" })), I8 = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronDownIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronDownIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.293 8.293a1 1 0 011.32-.083l.094.083L10 10.585l2.293-2.292a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-3 3a1 1 0 01-1.32.083l-.094-.083-3-3a1 1 0 010-1.414z" })));
});
I8.displayName = "ChevronDownIcon";
var YQe = P.forwardRef(({ disabled: t, element: e, hasError: r, readOnly: n, children: a, type: i, variant: o }, s) => {
  let l = "colorBackgroundWeakest", c = "shadowBorder", u = "shadowBorderPrimary", f = "shadowBorderPrimaryStronger";
  return t && i !== "hidden" ? (c = "shadowBorderWeak", u = "shadowBorderWeak", l = "colorBackground", f = "shadowBorderWeak") : n && i !== "hidden" ? (u = "shadowBorder", l = "colorBackground") : r && i !== "hidden" ? (c = "shadowBorderError", u = "shadowBorderErrorStronger") : i === "hidden" && (c = null, u = null, l = null, f = null), P.createElement(ht, { element: e, ref: s, display: "flex", width: "100%", backgroundColor: l, boxShadow: c, borderRadius: "borderRadius20", transition: "box-shadow 100ms ease-in", cursor: t ? "not-allowed" : "text", variant: o, _hover: { boxShadow: u }, _focusWithin: { boxShadow: t ? c : "shadowFocusShadowBorder" }, _active: { boxShadow: f } }, a);
});
YQe.displayName = "DefaultFauxInput";
var XQe = P.forwardRef(({ disabled: t, element: e, hasError: r, readOnly: n, children: a, type: i, variant: o }, s) => {
  let l = "colorBackgroundInverse", c = "shadowBorderInverse", u = "shadowBorderInverseStrongest";
  return t && i !== "hidden" ? (l = "colorBackgroundInverse", c = "shadowBorderInverseWeaker", u = "shadowBorderInverseWeaker") : n && i !== "hidden" ? (l = "colorBackgroundInverseStrong", u = "shadowBorderInverse") : r && i !== "hidden" ? c = "shadowBorderErrorWeak" : i === "hidden" && (l = null, c = null, u = null), P.createElement(ht, { element: e, ref: s, display: "flex", width: "100%", backgroundColor: l, boxShadow: c, borderRadius: "borderRadius20", color: "colorTextInverse", transition: "box-shadow 100ms ease-in", cursor: t ? "not-allowed" : "text", variant: o, _hover: { boxShadow: u }, _focusWithin: { backgroundColor: "colorBackgroundInverse", boxShadow: t ? c : "shadowFocusInverse" }, _active: { boxShadow: u } }, a);
});
XQe.displayName = "InverseFauxInput";
var aur = { default: YQe, inverse: XQe }, QQe = P.forwardRef(({ children: t, disabled: e, element: r, hasError: n, readOnly: a, type: i, variant: o = "default" }, s) => {
  let l = aur[o];
  return P.createElement(l, { disabled: e, element: r, hasError: n, readOnly: a, type: i, variant: o, ref: s }, t);
});
QQe.displayName = "FieldWrapper";
var eet = P.createContext(null), iur = () => {
  let t = P.useContext(eet);
  if (!t) throw new Error("useInputBoxContext must be used within a <InputBox> component.");
  return t;
}, tet = P.forwardRef(({ children: t, disabled: e, element: r = "PREFIX", variant: n }, a) => {
  let i = "colorBackgroundBodyElevation";
  return e && n === "inverse" ? i = "none" : n === "inverse" ? i = "colorBackgroundInverseElevation" : e && (i = "none"), t == null ? null : P.createElement(ht, { alignItems: "flex-start", backgroundColor: i, borderBottomLeftRadius: "borderRadius20", borderTopLeftRadius: "borderRadius20", display: "flex", element: `${r}_PREFIX`, lineHeight: "lineHeight20", padding: "space30", variant: n, ref: a }, t);
});
tet.displayName = "Prefix";
var ret = P.forwardRef(({ children: t, disabled: e, element: r = "SUFFIX", variant: n }, a) => {
  let i = "colorBackgroundBodyElevation";
  return e && n === "inverse" ? i = "none" : n === "inverse" ? i = "colorBackgroundInverseElevation" : e && (i = "none"), t == null ? null : P.createElement(ht, { alignItems: "flex-start", backgroundColor: i, borderBottomRightRadius: "borderRadius20", borderTopRightRadius: "borderRadius20", display: "flex", element: `${r}_SUFFIX`, lineHeight: "lineHeight20", padding: "space30", variant: n, ref: a }, t);
});
ret.displayName = "Suffix";
var M8 = P.forwardRef(({ children: t, disabled: e = !1, readOnly: r = !1, element: n = "INPUT_BOX", hasError: a, insertAfter: i, insertBefore: o, type: s, variant: l = "default", ...c }, u) => P.createElement(eet.Provider, { value: { disabled: e, readOnly: r, variant: l } }, P.createElement(QQe, { disabled: e, element: n, hasError: a, readOnly: r, type: s, variant: l, ref: u, ...c }, o && P.createElement(tet, { disabled: e, element: n, variant: l }, o), t, i && P.createElement(ret, { disabled: e, element: n, variant: l }, i))));
M8.displayName = "InputBox";
var net = (t, e) => t ? "disabled" : e ? "readOnly" : "default", our = { default: { default: "colorTextIcon", disabled: "colorTextWeaker", readOnly: "colorTextWeaker" }, inverse: { default: "colorTextIconInverse", disabled: "colorTextInverseWeakest", readOnly: "colorTextInverseWeakest" } }, Gpe = (t = "default", e = !1, r = !1) => our[t][net(e, r)], sur = { default: { default: "colorBackgroundBodyElevation", disabled: "colorBackground", readOnly: "colorBackgroundBodyElevation" }, inverse: { default: "colorBackgroundInverseElevation", disabled: "colorBackgroundInverse", readOnly: "colorBackgroundInverseElevation" } }, sG = P.forwardRef(({ children: t, element: e = "CHEVRON_WRAPPER" }, r) => {
  let { disabled: n, readOnly: a, variant: i } = iur();
  return P.createElement(ht, { backgroundColor: sur[i][net(n, a)], borderRadius: "borderRadius20", cursor: "pointer", alignItems: "center", display: "inline-flex", position: "absolute", pointerEvents: "none", right: "space30", top: "50%", transform: "translateY(-50%)", zIndex: "zIndex10", element: e, ref: r }, t);
});
sG.displayName = "InputChevronWrapper";
var Q5 = P.forwardRef(({ as: t = "span", children: e, element: r = "MEDIA_OBJECT", marginBottom: n, marginTop: a, verticalAlign: i = "top", ...o }, s) => P.createElement(ht, { ...Xt(o), alignItems: i === "top" ? "flex-start" : "center", as: t, display: "flex", element: r, marginBottom: n, marginTop: a, ref: s }, e));
Q5.displayName = "MediaObject";
var qm = P.forwardRef(({ align: t = "start", as: e = "span", children: r, element: n = "MEDIA_FIGURE", spacing: a = "space0", ...i }, o) => P.createElement(ht, { ...Xt(i), as: e, display: "flex", element: n, flexShrink: 0, marginLeft: t === "end" ? a : void 0, marginRight: t === "start" ? a : void 0, ref: o }, r));
qm.displayName = "MediaFigure";
var e6 = P.forwardRef(({ as: t = "span", children: e, element: r = "MEDIA_BODY", ...n }, a) => P.createElement(ht, { ...Xt(n), as: t, element: r, flex: 1, minWidth: "size0", ref: a }, e));
e6.displayName = "MediaBody";
const lur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MediaBody: e6,
  MediaFigure: qm,
  MediaObject: Q5
}, Symbol.toStringTag, { value: "Module" }));
var Wpe = ({ element: t = "REQUIRED_DOT", i18nLabel: e = "Required", ...r }) => P.createElement(ht, { ...Xt(r), alignItems: "center", justifyContent: "center", as: "span", cursor: "pointer", display: "flex", height: "sizeIcon30", title: e, element: `${t}_WRAPPER` }, P.createElement(ht, { as: "span", backgroundColor: "colorBackgroundRequired", borderRadius: "borderRadiusCircle", display: "block", height: "4px", width: "4px", element: t }, P.createElement(Ul, null, e)));
Wpe.displayName = "RequiredDot";
var P8 = P.forwardRef(({ as: t = "label", marginBottom: e, required: r, disabled: n, children: a, variant: i, element: o = "LABEL", i18nRequiredLabel: s = "", ...l }, c) => {
  let u = "colorText";
  n && i === "inverse" ? u = "colorTextInverseWeaker" : n ? u = "colorTextWeak" : i === "inverse" && (u = "colorTextInverse");
  let f = "pointer";
  return n ? f = "not-allowed" : (t === "legend" || t === "div") && (f = "default"), P.createElement(ht, { ...Xt(l), as: t, borderBottomWidth: "borderWidth0", display: "block", marginBottom: e || "space20", paddingLeft: "space0", paddingRight: "space0", textTransform: "none", element: o, fontSize: "fontSize30", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight30", color: u, cursor: f, ref: c }, P.createElement(Q5, { verticalAlign: "top" }, r && P.createElement(qm, { spacing: "space20" }, P.createElement(Wpe, { element: `${o}_REQUIRED_DOT`, i18nLabel: s })), P.createElement(e6, null, a)));
});
P8.displayName = "Label";
const cur = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Label: P8,
  RequiredDot: Wpe
}, Symbol.toStringTag, { value: "Module" }));
var uur = Object.create, aet = Object.defineProperty, dur = Object.getOwnPropertyDescriptor, iet = Object.getOwnPropertyNames, fur = Object.getPrototypeOf, hur = Object.prototype.hasOwnProperty, hr = (t, e) => function() {
  return e || (0, t[iet(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, pur = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of iet(e)) !hur.call(t, a) && a !== r && aet(t, a, { get: () => e[a], enumerable: !(n = dur(e, a)) || n.enumerable });
  return t;
}, Hpe = (t, e, r) => (r = t != null ? uur(fur(t)) : {}, pur(!t || !t.__esModule ? aet(r, "default", { value: t, enumerable: !0 }) : r, t)), pM = hr({ "../../node_modules/lodash/isObject.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return n != null && (a == "object" || a == "function");
  }
  e.exports = r;
} }), oet = hr({ "../../node_modules/lodash/_freeGlobal.js"(t, e) {
  var r = typeof ss == "object" && ss && ss.Object === Object && ss;
  e.exports = r;
} }), Jh = hr({ "../../node_modules/lodash/_root.js"(t, e) {
  var r = oet(), n = typeof self == "object" && self && self.Object === Object && self, a = r || n || Function("return this")();
  e.exports = a;
} }), mur = hr({ "../../node_modules/lodash/now.js"(t, e) {
  var r = Jh(), n = function() {
    return r.Date.now();
  };
  e.exports = n;
} }), gur = hr({ "../../node_modules/lodash/_trimmedEndIndex.js"(t, e) {
  var r = /\s/;
  function n(a) {
    for (var i = a.length; i-- && r.test(a.charAt(i)); ) ;
    return i;
  }
  e.exports = n;
} }), vur = hr({ "../../node_modules/lodash/_baseTrim.js"(t, e) {
  var r = gur(), n = /^\s+/;
  function a(i) {
    return i && i.slice(0, r(i) + 1).replace(n, "");
  }
  e.exports = a;
} }), lG = hr({ "../../node_modules/lodash/_Symbol.js"(t, e) {
  var r = Jh(), n = r.Symbol;
  e.exports = n;
} }), yur = hr({ "../../node_modules/lodash/_getRawTag.js"(t, e) {
  var r = lG(), n = Object.prototype, a = n.hasOwnProperty, i = n.toString, o = r ? r.toStringTag : void 0;
  function s(l) {
    var c = a.call(l, o), u = l[o];
    try {
      l[o] = void 0;
      var f = !0;
    } catch {
    }
    var h = i.call(l);
    return f && (c ? l[o] = u : delete l[o]), h;
  }
  e.exports = s;
} }), bur = hr({ "../../node_modules/lodash/_objectToString.js"(t, e) {
  var r = Object.prototype, n = r.toString;
  function a(i) {
    return n.call(i);
  }
  e.exports = a;
} }), mM = hr({ "../../node_modules/lodash/_baseGetTag.js"(t, e) {
  var r = lG(), n = yur(), a = bur(), i = "[object Null]", o = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : i : s && s in Object(c) ? n(c) : a(c);
  }
  e.exports = l;
} }), gM = hr({ "../../node_modules/lodash/isObjectLike.js"(t, e) {
  function r(n) {
    return n != null && typeof n == "object";
  }
  e.exports = r;
} }), cG = hr({ "../../node_modules/lodash/isSymbol.js"(t, e) {
  var r = mM(), n = gM(), a = "[object Symbol]";
  function i(o) {
    return typeof o == "symbol" || n(o) && r(o) == a;
  }
  e.exports = i;
} }), set = hr({ "../../node_modules/lodash/toNumber.js"(t, e) {
  var r = vur(), n = pM(), a = cG(), i = NaN, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, c = parseInt;
  function u(f) {
    if (typeof f == "number") return f;
    if (a(f)) return i;
    if (n(f)) {
      var h = typeof f.valueOf == "function" ? f.valueOf() : f;
      f = n(h) ? h + "" : h;
    }
    if (typeof f != "string") return f === 0 ? f : +f;
    f = r(f);
    var p = s.test(f);
    return p || l.test(f) ? c(f.slice(2), p ? 2 : 8) : o.test(f) ? i : +f;
  }
  e.exports = u;
} }), cet = hr({ "../../node_modules/lodash/debounce.js"(t, e) {
  var r = pM(), n = mur(), a = set(), i = "Expected a function", o = Math.max, s = Math.min;
  function l(c, u, f) {
    var h, p, g, y, b, w, _ = 0, C = !1, x = !1, S = !0;
    if (typeof c != "function") throw new TypeError(i);
    u = a(u) || 0, r(f) && (C = !!f.leading, x = "maxWait" in f, g = x ? o(a(f.maxWait) || 0, u) : g, S = "trailing" in f ? !!f.trailing : S);
    function A(k) {
      var O = h, G = p;
      return h = p = void 0, _ = k, y = c.apply(G, O), y;
    }
    function I(k) {
      return _ = k, b = setTimeout(L, u), C ? A(k) : y;
    }
    function M(k) {
      var O = k - w, G = k - _, H = u - O;
      return x ? s(H, g - G) : H;
    }
    function B(k) {
      var O = k - w, G = k - _;
      return w === void 0 || O >= u || O < 0 || x && G >= g;
    }
    function L() {
      var k = n();
      if (B(k)) return N(k);
      b = setTimeout(L, M(k));
    }
    function N(k) {
      return b = void 0, S && h ? A(k) : (h = p = void 0, y);
    }
    function d() {
      b !== void 0 && clearTimeout(b), _ = 0, h = w = p = b = void 0;
    }
    function m() {
      return b === void 0 ? y : N(n());
    }
    function v() {
      var k = n(), O = B(k);
      if (h = arguments, p = this, w = k, O) {
        if (b === void 0) return I(w);
        if (x) return clearTimeout(b), b = setTimeout(L, u), A(w);
      }
      return b === void 0 && (b = setTimeout(L, u)), y;
    }
    return v.cancel = d, v.flush = m, v;
  }
  e.exports = l;
} }), xur = hr({ "../../node_modules/lodash/_baseFindIndex.js"(t, e) {
  function r(n, a, i, o) {
    for (var s = n.length, l = i + (o ? 1 : -1); o ? l-- : ++l < s; ) if (a(n[l], l, n)) return l;
    return -1;
  }
  e.exports = r;
} }), Cur = hr({ "../../node_modules/lodash/_listCacheClear.js"(t, e) {
  function r() {
    this.__data__ = [], this.size = 0;
  }
  e.exports = r;
} }), uet = hr({ "../../node_modules/lodash/eq.js"(t, e) {
  function r(n, a) {
    return n === a || n !== n && a !== a;
  }
  e.exports = r;
} }), uG = hr({ "../../node_modules/lodash/_assocIndexOf.js"(t, e) {
  var r = uet();
  function n(a, i) {
    for (var o = a.length; o--; ) if (r(a[o][0], i)) return o;
    return -1;
  }
  e.exports = n;
} }), wur = hr({ "../../node_modules/lodash/_listCacheDelete.js"(t, e) {
  var r = uG(), n = Array.prototype, a = n.splice;
  function i(o) {
    var s = this.__data__, l = r(s, o);
    if (l < 0) return !1;
    var c = s.length - 1;
    return l == c ? s.pop() : a.call(s, l, 1), --this.size, !0;
  }
  e.exports = i;
} }), Sur = hr({ "../../node_modules/lodash/_listCacheGet.js"(t, e) {
  var r = uG();
  function n(a) {
    var i = this.__data__, o = r(i, a);
    return o < 0 ? void 0 : i[o][1];
  }
  e.exports = n;
} }), _ur = hr({ "../../node_modules/lodash/_listCacheHas.js"(t, e) {
  var r = uG();
  function n(a) {
    return r(this.__data__, a) > -1;
  }
  e.exports = n;
} }), kur = hr({ "../../node_modules/lodash/_listCacheSet.js"(t, e) {
  var r = uG();
  function n(a, i) {
    var o = this.__data__, s = r(o, a);
    return s < 0 ? (++this.size, o.push([a, i])) : o[s][1] = i, this;
  }
  e.exports = n;
} }), dG = hr({ "../../node_modules/lodash/_ListCache.js"(t, e) {
  var r = Cur(), n = wur(), a = Sur(), i = _ur(), o = kur();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Aur = hr({ "../../node_modules/lodash/_stackClear.js"(t, e) {
  var r = dG();
  function n() {
    this.__data__ = new r(), this.size = 0;
  }
  e.exports = n;
} }), Tur = hr({ "../../node_modules/lodash/_stackDelete.js"(t, e) {
  function r(n) {
    var a = this.__data__, i = a.delete(n);
    return this.size = a.size, i;
  }
  e.exports = r;
} }), Eur = hr({ "../../node_modules/lodash/_stackGet.js"(t, e) {
  function r(n) {
    return this.__data__.get(n);
  }
  e.exports = r;
} }), Iur = hr({ "../../node_modules/lodash/_stackHas.js"(t, e) {
  function r(n) {
    return this.__data__.has(n);
  }
  e.exports = r;
} }), det = hr({ "../../node_modules/lodash/isFunction.js"(t, e) {
  var r = mM(), n = pM(), a = "[object AsyncFunction]", i = "[object Function]", o = "[object GeneratorFunction]", s = "[object Proxy]";
  function l(c) {
    if (!n(c)) return !1;
    var u = r(c);
    return u == i || u == o || u == a || u == s;
  }
  e.exports = l;
} }), Mur = hr({ "../../node_modules/lodash/_coreJsData.js"(t, e) {
  var r = Jh(), n = r["__core-js_shared__"];
  e.exports = n;
} }), Pur = hr({ "../../node_modules/lodash/_isMasked.js"(t, e) {
  var r = Mur(), n = function() {
    var i = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function a(i) {
    return !!n && n in i;
  }
  e.exports = a;
} }), fet = hr({ "../../node_modules/lodash/_toSource.js"(t, e) {
  var r = Function.prototype, n = r.toString;
  function a(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  e.exports = a;
} }), Rur = hr({ "../../node_modules/lodash/_baseIsNative.js"(t, e) {
  var r = det(), n = Pur(), a = pM(), i = fet(), o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, l = Function.prototype, c = Object.prototype, u = l.toString, f = c.hasOwnProperty, h = RegExp("^" + u.call(f).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  function p(g) {
    if (!a(g) || n(g)) return !1;
    var y = r(g) ? h : s;
    return y.test(i(g));
  }
  e.exports = p;
} }), Our = hr({ "../../node_modules/lodash/_getValue.js"(t, e) {
  function r(n, a) {
    return n == null ? void 0 : n[a];
  }
  e.exports = r;
} }), R8 = hr({ "../../node_modules/lodash/_getNative.js"(t, e) {
  var r = Rur(), n = Our();
  function a(i, o) {
    var s = n(i, o);
    return r(s) ? s : void 0;
  }
  e.exports = a;
} }), Upe = hr({ "../../node_modules/lodash/_Map.js"(t, e) {
  var r = R8(), n = Jh(), a = r(n, "Map");
  e.exports = a;
} }), fG = hr({ "../../node_modules/lodash/_nativeCreate.js"(t, e) {
  var r = R8(), n = r(Object, "create");
  e.exports = n;
} }), Bur = hr({ "../../node_modules/lodash/_hashClear.js"(t, e) {
  var r = fG();
  function n() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  e.exports = n;
} }), Nur = hr({ "../../node_modules/lodash/_hashDelete.js"(t, e) {
  function r(n) {
    var a = this.has(n) && delete this.__data__[n];
    return this.size -= a ? 1 : 0, a;
  }
  e.exports = r;
} }), $ur = hr({ "../../node_modules/lodash/_hashGet.js"(t, e) {
  var r = fG(), n = "__lodash_hash_undefined__", a = Object.prototype, i = a.hasOwnProperty;
  function o(s) {
    var l = this.__data__;
    if (r) {
      var c = l[s];
      return c === n ? void 0 : c;
    }
    return i.call(l, s) ? l[s] : void 0;
  }
  e.exports = o;
} }), Dur = hr({ "../../node_modules/lodash/_hashHas.js"(t, e) {
  var r = fG(), n = Object.prototype, a = n.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    return r ? s[o] !== void 0 : a.call(s, o);
  }
  e.exports = i;
} }), Lur = hr({ "../../node_modules/lodash/_hashSet.js"(t, e) {
  var r = fG(), n = "__lodash_hash_undefined__";
  function a(i, o) {
    var s = this.__data__;
    return this.size += this.has(i) ? 0 : 1, s[i] = r && o === void 0 ? n : o, this;
  }
  e.exports = a;
} }), jur = hr({ "../../node_modules/lodash/_Hash.js"(t, e) {
  var r = Bur(), n = Nur(), a = $ur(), i = Dur(), o = Lur();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Fur = hr({ "../../node_modules/lodash/_mapCacheClear.js"(t, e) {
  var r = jur(), n = dG(), a = Upe();
  function i() {
    this.size = 0, this.__data__ = { hash: new r(), map: new (a || n)(), string: new r() };
  }
  e.exports = i;
} }), zur = hr({ "../../node_modules/lodash/_isKeyable.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? n !== "__proto__" : n === null;
  }
  e.exports = r;
} }), hG = hr({ "../../node_modules/lodash/_getMapData.js"(t, e) {
  var r = zur();
  function n(a, i) {
    var o = a.__data__;
    return r(i) ? o[typeof i == "string" ? "string" : "hash"] : o.map;
  }
  e.exports = n;
} }), Gur = hr({ "../../node_modules/lodash/_mapCacheDelete.js"(t, e) {
  var r = hG();
  function n(a) {
    var i = r(this, a).delete(a);
    return this.size -= i ? 1 : 0, i;
  }
  e.exports = n;
} }), Wur = hr({ "../../node_modules/lodash/_mapCacheGet.js"(t, e) {
  var r = hG();
  function n(a) {
    return r(this, a).get(a);
  }
  e.exports = n;
} }), Hur = hr({ "../../node_modules/lodash/_mapCacheHas.js"(t, e) {
  var r = hG();
  function n(a) {
    return r(this, a).has(a);
  }
  e.exports = n;
} }), Uur = hr({ "../../node_modules/lodash/_mapCacheSet.js"(t, e) {
  var r = hG();
  function n(a, i) {
    var o = r(this, a), s = o.size;
    return o.set(a, i), this.size += o.size == s ? 0 : 1, this;
  }
  e.exports = n;
} }), Vpe = hr({ "../../node_modules/lodash/_MapCache.js"(t, e) {
  var r = Fur(), n = Gur(), a = Wur(), i = Hur(), o = Uur();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Vur = hr({ "../../node_modules/lodash/_stackSet.js"(t, e) {
  var r = dG(), n = Upe(), a = Vpe(), i = 200;
  function o(s, l) {
    var c = this.__data__;
    if (c instanceof r) {
      var u = c.__data__;
      if (!n || u.length < i - 1) return u.push([s, l]), this.size = ++c.size, this;
      c = this.__data__ = new a(u);
    }
    return c.set(s, l), this.size = c.size, this;
  }
  e.exports = o;
} }), het = hr({ "../../node_modules/lodash/_Stack.js"(t, e) {
  var r = dG(), n = Aur(), a = Tur(), i = Eur(), o = Iur(), s = Vur();
  function l(c) {
    var u = this.__data__ = new r(c);
    this.size = u.size;
  }
  l.prototype.clear = n, l.prototype.delete = a, l.prototype.get = i, l.prototype.has = o, l.prototype.set = s, e.exports = l;
} }), qur = hr({ "../../node_modules/lodash/_setCacheAdd.js"(t, e) {
  var r = "__lodash_hash_undefined__";
  function n(a) {
    return this.__data__.set(a, r), this;
  }
  e.exports = n;
} }), Kur = hr({ "../../node_modules/lodash/_setCacheHas.js"(t, e) {
  function r(n) {
    return this.__data__.has(n);
  }
  e.exports = r;
} }), Zur = hr({ "../../node_modules/lodash/_SetCache.js"(t, e) {
  var r = Vpe(), n = qur(), a = Kur();
  function i(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.__data__ = new r(); ++s < l; ) this.add(o[s]);
  }
  i.prototype.add = i.prototype.push = n, i.prototype.has = a, e.exports = i;
} }), Jur = hr({ "../../node_modules/lodash/_arraySome.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length; ++i < o; ) if (a(n[i], i, n)) return !0;
    return !1;
  }
  e.exports = r;
} }), Yur = hr({ "../../node_modules/lodash/_cacheHas.js"(t, e) {
  function r(n, a) {
    return n.has(a);
  }
  e.exports = r;
} }), pet = hr({ "../../node_modules/lodash/_equalArrays.js"(t, e) {
  var r = Zur(), n = Jur(), a = Yur(), i = 1, o = 2;
  function s(l, c, u, f, h, p) {
    var g = u & i, y = l.length, b = c.length;
    if (y != b && !(g && b > y)) return !1;
    var w = p.get(l), _ = p.get(c);
    if (w && _) return w == c && _ == l;
    var C = -1, x = !0, S = u & o ? new r() : void 0;
    for (p.set(l, c), p.set(c, l); ++C < y; ) {
      var A = l[C], I = c[C];
      if (f) var M = g ? f(I, A, C, c, l, p) : f(A, I, C, l, c, p);
      if (M !== void 0) {
        if (M) continue;
        x = !1;
        break;
      }
      if (S) {
        if (!n(c, function(B, L) {
          if (!a(S, L) && (A === B || h(A, B, u, f, p))) return S.push(L);
        })) {
          x = !1;
          break;
        }
      } else if (!(A === I || h(A, I, u, f, p))) {
        x = !1;
        break;
      }
    }
    return p.delete(l), p.delete(c), x;
  }
  e.exports = s;
} }), Xur = hr({ "../../node_modules/lodash/_Uint8Array.js"(t, e) {
  var r = Jh(), n = r.Uint8Array;
  e.exports = n;
} }), Qur = hr({ "../../node_modules/lodash/_mapToArray.js"(t, e) {
  function r(n) {
    var a = -1, i = Array(n.size);
    return n.forEach(function(o, s) {
      i[++a] = [s, o];
    }), i;
  }
  e.exports = r;
} }), edr = hr({ "../../node_modules/lodash/_setToArray.js"(t, e) {
  function r(n) {
    var a = -1, i = Array(n.size);
    return n.forEach(function(o) {
      i[++a] = o;
    }), i;
  }
  e.exports = r;
} }), tdr = hr({ "../../node_modules/lodash/_equalByTag.js"(t, e) {
  var r = lG(), n = Xur(), a = uet(), i = pet(), o = Qur(), s = edr(), l = 1, c = 2, u = "[object Boolean]", f = "[object Date]", h = "[object Error]", p = "[object Map]", g = "[object Number]", y = "[object RegExp]", b = "[object Set]", w = "[object String]", _ = "[object Symbol]", C = "[object ArrayBuffer]", x = "[object DataView]", S = r ? r.prototype : void 0, A = S ? S.valueOf : void 0;
  function I(M, B, L, N, d, m, v) {
    switch (L) {
      case x:
        if (M.byteLength != B.byteLength || M.byteOffset != B.byteOffset) return !1;
        M = M.buffer, B = B.buffer;
      case C:
        return !(M.byteLength != B.byteLength || !m(new n(M), new n(B)));
      case u:
      case f:
      case g:
        return a(+M, +B);
      case h:
        return M.name == B.name && M.message == B.message;
      case y:
      case w:
        return M == B + "";
      case p:
        var k = o;
      case b:
        var O = N & l;
        if (k || (k = s), M.size != B.size && !O) return !1;
        var G = v.get(M);
        if (G) return G == B;
        N |= c, v.set(M, B);
        var H = i(k(M), k(B), N, d, m, v);
        return v.delete(M), H;
      case _:
        if (A) return A.call(M) == A.call(B);
    }
    return !1;
  }
  e.exports = I;
} }), rdr = hr({ "../../node_modules/lodash/_arrayPush.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = a.length, s = n.length; ++i < o; ) n[s + i] = a[i];
    return n;
  }
  e.exports = r;
} }), $y = hr({ "../../node_modules/lodash/isArray.js"(t, e) {
  var r = Array.isArray;
  e.exports = r;
} }), ndr = hr({ "../../node_modules/lodash/_baseGetAllKeys.js"(t, e) {
  var r = rdr(), n = $y();
  function a(i, o, s) {
    var l = o(i);
    return n(i) ? l : r(l, s(i));
  }
  e.exports = a;
} }), adr = hr({ "../../node_modules/lodash/_arrayFilter.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = 0, l = []; ++i < o; ) {
      var c = n[i];
      a(c, i, n) && (l[s++] = c);
    }
    return l;
  }
  e.exports = r;
} }), idr = hr({ "../../node_modules/lodash/stubArray.js"(t, e) {
  function r() {
    return [];
  }
  e.exports = r;
} }), odr = hr({ "../../node_modules/lodash/_getSymbols.js"(t, e) {
  var r = adr(), n = idr(), a = Object.prototype, i = a.propertyIsEnumerable, o = Object.getOwnPropertySymbols, s = o ? function(l) {
    return l == null ? [] : (l = Object(l), r(o(l), function(c) {
      return i.call(l, c);
    }));
  } : n;
  e.exports = s;
} }), sdr = hr({ "../../node_modules/lodash/_baseTimes.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = Array(n); ++i < n; ) o[i] = a(i);
    return o;
  }
  e.exports = r;
} }), ldr = hr({ "../../node_modules/lodash/_baseIsArguments.js"(t, e) {
  var r = mM(), n = gM(), a = "[object Arguments]";
  function i(o) {
    return n(o) && r(o) == a;
  }
  e.exports = i;
} }), met = hr({ "../../node_modules/lodash/isArguments.js"(t, e) {
  var r = ldr(), n = gM(), a = Object.prototype, i = a.hasOwnProperty, o = a.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(l) {
    return n(l) && i.call(l, "callee") && !o.call(l, "callee");
  };
  e.exports = s;
} }), cdr = hr({ "../../node_modules/lodash/stubFalse.js"(t, e) {
  function r() {
    return !1;
  }
  e.exports = r;
} }), get = hr({ "../../node_modules/lodash/isBuffer.js"(t, e) {
  var r = Jh(), n = cdr(), a = typeof t == "object" && t && !t.nodeType && t, i = a && typeof e == "object" && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
  e.exports = c;
} }), vet = hr({ "../../node_modules/lodash/_isIndex.js"(t, e) {
  var r = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function a(i, o) {
    var s = typeof i;
    return o = o ?? r, !!o && (s == "number" || s != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < o;
  }
  e.exports = a;
} }), qpe = hr({ "../../node_modules/lodash/isLength.js"(t, e) {
  var r = 9007199254740991;
  function n(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= r;
  }
  e.exports = n;
} }), udr = hr({ "../../node_modules/lodash/_baseIsTypedArray.js"(t, e) {
  var r = mM(), n = qpe(), a = gM(), i = "[object Arguments]", o = "[object Array]", s = "[object Boolean]", l = "[object Date]", c = "[object Error]", u = "[object Function]", f = "[object Map]", h = "[object Number]", p = "[object Object]", g = "[object RegExp]", y = "[object Set]", b = "[object String]", w = "[object WeakMap]", _ = "[object ArrayBuffer]", C = "[object DataView]", x = "[object Float32Array]", S = "[object Float64Array]", A = "[object Int8Array]", I = "[object Int16Array]", M = "[object Int32Array]", B = "[object Uint8Array]", L = "[object Uint8ClampedArray]", N = "[object Uint16Array]", d = "[object Uint32Array]", m = {};
  m[x] = m[S] = m[A] = m[I] = m[M] = m[B] = m[L] = m[N] = m[d] = !0, m[i] = m[o] = m[_] = m[s] = m[C] = m[l] = m[c] = m[u] = m[f] = m[h] = m[p] = m[g] = m[y] = m[b] = m[w] = !1;
  function v(k) {
    return a(k) && n(k.length) && !!m[r(k)];
  }
  e.exports = v;
} }), ddr = hr({ "../../node_modules/lodash/_baseUnary.js"(t, e) {
  function r(n) {
    return function(a) {
      return n(a);
    };
  }
  e.exports = r;
} }), fdr = hr({ "../../node_modules/lodash/_nodeUtil.js"(t, e) {
  var r = oet(), n = typeof t == "object" && t && !t.nodeType && t, a = n && typeof e == "object" && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
} }), yet = hr({ "../../node_modules/lodash/isTypedArray.js"(t, e) {
  var r = udr(), n = ddr(), a = fdr(), i = a && a.isTypedArray, o = i ? n(i) : r;
  e.exports = o;
} }), hdr = hr({ "../../node_modules/lodash/_arrayLikeKeys.js"(t, e) {
  var r = sdr(), n = met(), a = $y(), i = get(), o = vet(), s = yet(), l = Object.prototype, c = l.hasOwnProperty;
  function u(f, h) {
    var p = a(f), g = !p && n(f), y = !p && !g && i(f), b = !p && !g && !y && s(f), w = p || g || y || b, _ = w ? r(f.length, String) : [], C = _.length;
    for (var x in f) (h || c.call(f, x)) && !(w && (x == "length" || y && (x == "offset" || x == "parent") || b && (x == "buffer" || x == "byteLength" || x == "byteOffset") || o(x, C))) && _.push(x);
    return _;
  }
  e.exports = u;
} }), pdr = hr({ "../../node_modules/lodash/_isPrototype.js"(t, e) {
  var r = Object.prototype;
  function n(a) {
    var i = a && a.constructor, o = typeof i == "function" && i.prototype || r;
    return a === o;
  }
  e.exports = n;
} }), mdr = hr({ "../../node_modules/lodash/_overArg.js"(t, e) {
  function r(n, a) {
    return function(i) {
      return n(a(i));
    };
  }
  e.exports = r;
} }), gdr = hr({ "../../node_modules/lodash/_nativeKeys.js"(t, e) {
  var r = mdr(), n = r(Object.keys, Object);
  e.exports = n;
} }), vdr = hr({ "../../node_modules/lodash/_baseKeys.js"(t, e) {
  var r = pdr(), n = gdr(), a = Object.prototype, i = a.hasOwnProperty;
  function o(s) {
    if (!r(s)) return n(s);
    var l = [];
    for (var c in Object(s)) i.call(s, c) && c != "constructor" && l.push(c);
    return l;
  }
  e.exports = o;
} }), ydr = hr({ "../../node_modules/lodash/isArrayLike.js"(t, e) {
  var r = det(), n = qpe();
  function a(i) {
    return i != null && n(i.length) && !r(i);
  }
  e.exports = a;
} }), bet = hr({ "../../node_modules/lodash/keys.js"(t, e) {
  var r = hdr(), n = vdr(), a = ydr();
  function i(o) {
    return a(o) ? r(o) : n(o);
  }
  e.exports = i;
} }), bdr = hr({ "../../node_modules/lodash/_getAllKeys.js"(t, e) {
  var r = ndr(), n = odr(), a = bet();
  function i(o) {
    return r(o, a, n);
  }
  e.exports = i;
} }), xdr = hr({ "../../node_modules/lodash/_equalObjects.js"(t, e) {
  var r = bdr(), n = 1, a = Object.prototype, i = a.hasOwnProperty;
  function o(s, l, c, u, f, h) {
    var p = c & n, g = r(s), y = g.length, b = r(l), w = b.length;
    if (y != w && !p) return !1;
    for (var _ = y; _--; ) {
      var C = g[_];
      if (!(p ? C in l : i.call(l, C))) return !1;
    }
    var x = h.get(s), S = h.get(l);
    if (x && S) return x == l && S == s;
    var A = !0;
    h.set(s, l), h.set(l, s);
    for (var I = p; ++_ < y; ) {
      C = g[_];
      var M = s[C], B = l[C];
      if (u) var L = p ? u(B, M, C, l, s, h) : u(M, B, C, s, l, h);
      if (!(L === void 0 ? M === B || f(M, B, c, u, h) : L)) {
        A = !1;
        break;
      }
      I || (I = C == "constructor");
    }
    if (A && !I) {
      var N = s.constructor, d = l.constructor;
      N != d && "constructor" in s && "constructor" in l && !(typeof N == "function" && N instanceof N && typeof d == "function" && d instanceof d) && (A = !1);
    }
    return h.delete(s), h.delete(l), A;
  }
  e.exports = o;
} }), Cdr = hr({ "../../node_modules/lodash/_DataView.js"(t, e) {
  var r = R8(), n = Jh(), a = r(n, "DataView");
  e.exports = a;
} }), wdr = hr({ "../../node_modules/lodash/_Promise.js"(t, e) {
  var r = R8(), n = Jh(), a = r(n, "Promise");
  e.exports = a;
} }), Sdr = hr({ "../../node_modules/lodash/_Set.js"(t, e) {
  var r = R8(), n = Jh(), a = r(n, "Set");
  e.exports = a;
} }), _dr = hr({ "../../node_modules/lodash/_WeakMap.js"(t, e) {
  var r = R8(), n = Jh(), a = r(n, "WeakMap");
  e.exports = a;
} }), kdr = hr({ "../../node_modules/lodash/_getTag.js"(t, e) {
  var r = Cdr(), n = Upe(), a = wdr(), i = Sdr(), o = _dr(), s = mM(), l = fet(), c = "[object Map]", u = "[object Object]", f = "[object Promise]", h = "[object Set]", p = "[object WeakMap]", g = "[object DataView]", y = l(r), b = l(n), w = l(a), _ = l(i), C = l(o), x = s;
  (r && x(new r(new ArrayBuffer(1))) != g || n && x(new n()) != c || a && x(a.resolve()) != f || i && x(new i()) != h || o && x(new o()) != p) && (x = function(S) {
    var A = s(S), I = A == u ? S.constructor : void 0, M = I ? l(I) : "";
    if (M) switch (M) {
      case y:
        return g;
      case b:
        return c;
      case w:
        return f;
      case _:
        return h;
      case C:
        return p;
    }
    return A;
  }), e.exports = x;
} }), Adr = hr({ "../../node_modules/lodash/_baseIsEqualDeep.js"(t, e) {
  var r = het(), n = pet(), a = tdr(), i = xdr(), o = kdr(), s = $y(), l = get(), c = yet(), u = 1, f = "[object Arguments]", h = "[object Array]", p = "[object Object]", g = Object.prototype, y = g.hasOwnProperty;
  function b(w, _, C, x, S, A) {
    var I = s(w), M = s(_), B = I ? h : o(w), L = M ? h : o(_);
    B = B == f ? p : B, L = L == f ? p : L;
    var N = B == p, d = L == p, m = B == L;
    if (m && l(w)) {
      if (!l(_)) return !1;
      I = !0, N = !1;
    }
    if (m && !N) return A || (A = new r()), I || c(w) ? n(w, _, C, x, S, A) : a(w, _, B, C, x, S, A);
    if (!(C & u)) {
      var v = N && y.call(w, "__wrapped__"), k = d && y.call(_, "__wrapped__");
      if (v || k) {
        var O = v ? w.value() : w, G = k ? _.value() : _;
        return A || (A = new r()), S(O, G, C, x, A);
      }
    }
    return m ? (A || (A = new r()), i(w, _, C, x, S, A)) : !1;
  }
  e.exports = b;
} }), xet = hr({ "../../node_modules/lodash/_baseIsEqual.js"(t, e) {
  var r = Adr(), n = gM();
  function a(i, o, s, l, c) {
    return i === o ? !0 : i == null || o == null || !n(i) && !n(o) ? i !== i && o !== o : r(i, o, s, l, a, c);
  }
  e.exports = a;
} }), Tdr = hr({ "../../node_modules/lodash/_baseIsMatch.js"(t, e) {
  var r = het(), n = xet(), a = 1, i = 2;
  function o(s, l, c, u) {
    var f = c.length, h = f, p = !u;
    if (s == null) return !h;
    for (s = Object(s); f--; ) {
      var g = c[f];
      if (p && g[2] ? g[1] !== s[g[0]] : !(g[0] in s)) return !1;
    }
    for (; ++f < h; ) {
      g = c[f];
      var y = g[0], b = s[y], w = g[1];
      if (p && g[2]) {
        if (b === void 0 && !(y in s)) return !1;
      } else {
        var _ = new r();
        if (u) var C = u(b, w, y, s, l, _);
        if (!(C === void 0 ? n(w, b, a | i, u, _) : C)) return !1;
      }
    }
    return !0;
  }
  e.exports = o;
} }), Cet = hr({ "../../node_modules/lodash/_isStrictComparable.js"(t, e) {
  var r = pM();
  function n(a) {
    return a === a && !r(a);
  }
  e.exports = n;
} }), Edr = hr({ "../../node_modules/lodash/_getMatchData.js"(t, e) {
  var r = Cet(), n = bet();
  function a(i) {
    for (var o = n(i), s = o.length; s--; ) {
      var l = o[s], c = i[l];
      o[s] = [l, c, r(c)];
    }
    return o;
  }
  e.exports = a;
} }), wet = hr({ "../../node_modules/lodash/_matchesStrictComparable.js"(t, e) {
  function r(n, a) {
    return function(i) {
      return i == null ? !1 : i[n] === a && (a !== void 0 || n in Object(i));
    };
  }
  e.exports = r;
} }), Idr = hr({ "../../node_modules/lodash/_baseMatches.js"(t, e) {
  var r = Tdr(), n = Edr(), a = wet();
  function i(o) {
    var s = n(o);
    return s.length == 1 && s[0][2] ? a(s[0][0], s[0][1]) : function(l) {
      return l === o || r(l, o, s);
    };
  }
  e.exports = i;
} }), Kpe = hr({ "../../node_modules/lodash/_isKey.js"(t, e) {
  var r = $y(), n = cG(), a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function o(s, l) {
    if (r(s)) return !1;
    var c = typeof s;
    return c == "number" || c == "symbol" || c == "boolean" || s == null || n(s) ? !0 : i.test(s) || !a.test(s) || l != null && s in Object(l);
  }
  e.exports = o;
} }), Mdr = hr({ "../../node_modules/lodash/memoize.js"(t, e) {
  var r = Vpe(), n = "Expected a function";
  function a(i, o) {
    if (typeof i != "function" || o != null && typeof o != "function") throw new TypeError(n);
    var s = function() {
      var l = arguments, c = o ? o.apply(this, l) : l[0], u = s.cache;
      if (u.has(c)) return u.get(c);
      var f = i.apply(this, l);
      return s.cache = u.set(c, f) || u, f;
    };
    return s.cache = new (a.Cache || r)(), s;
  }
  a.Cache = r, e.exports = a;
} }), Pdr = hr({ "../../node_modules/lodash/_memoizeCapped.js"(t, e) {
  var r = Mdr(), n = 500;
  function a(i) {
    var o = r(i, function(l) {
      return s.size === n && s.clear(), l;
    }), s = o.cache;
    return o;
  }
  e.exports = a;
} }), Rdr = hr({ "../../node_modules/lodash/_stringToPath.js"(t, e) {
  var r = Pdr(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a = /\\(\\)?/g, i = r(function(o) {
    var s = [];
    return o.charCodeAt(0) === 46 && s.push(""), o.replace(n, function(l, c, u, f) {
      s.push(u ? f.replace(a, "$1") : c || l);
    }), s;
  });
  e.exports = i;
} }), Odr = hr({ "../../node_modules/lodash/_arrayMap.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = Array(o); ++i < o; ) s[i] = a(n[i], i, n);
    return s;
  }
  e.exports = r;
} }), Bdr = hr({ "../../node_modules/lodash/_baseToString.js"(t, e) {
  var r = lG(), n = Odr(), a = $y(), i = cG(), o = r ? r.prototype : void 0, s = o ? o.toString : void 0;
  function l(c) {
    if (typeof c == "string") return c;
    if (a(c)) return n(c, l) + "";
    if (i(c)) return s ? s.call(c) : "";
    var u = c + "";
    return u == "0" && 1 / c == -1 / 0 ? "-0" : u;
  }
  e.exports = l;
} }), Ndr = hr({ "../../node_modules/lodash/toString.js"(t, e) {
  var r = Bdr();
  function n(a) {
    return a == null ? "" : r(a);
  }
  e.exports = n;
} }), _et = hr({ "../../node_modules/lodash/_castPath.js"(t, e) {
  var r = $y(), n = Kpe(), a = Rdr(), i = Ndr();
  function o(s, l) {
    return r(s) ? s : n(s, l) ? [s] : a(i(s));
  }
  e.exports = o;
} }), pG = hr({ "../../node_modules/lodash/_toKey.js"(t, e) {
  var r = cG();
  function n(a) {
    if (typeof a == "string" || r(a)) return a;
    var i = a + "";
    return i == "0" && 1 / a == -1 / 0 ? "-0" : i;
  }
  e.exports = n;
} }), ket = hr({ "../../node_modules/lodash/_baseGet.js"(t, e) {
  var r = _et(), n = pG();
  function a(i, o) {
    o = r(o, i);
    for (var s = 0, l = o.length; i != null && s < l; ) i = i[n(o[s++])];
    return s && s == l ? i : void 0;
  }
  e.exports = a;
} }), $dr = hr({ "../../node_modules/lodash/get.js"(t, e) {
  var r = ket();
  function n(a, i, o) {
    var s = a == null ? void 0 : r(a, i);
    return s === void 0 ? o : s;
  }
  e.exports = n;
} }), Ddr = hr({ "../../node_modules/lodash/_baseHasIn.js"(t, e) {
  function r(n, a) {
    return n != null && a in Object(n);
  }
  e.exports = r;
} }), Ldr = hr({ "../../node_modules/lodash/_hasPath.js"(t, e) {
  var r = _et(), n = met(), a = $y(), i = vet(), o = qpe(), s = pG();
  function l(c, u, f) {
    u = r(u, c);
    for (var h = -1, p = u.length, g = !1; ++h < p; ) {
      var y = s(u[h]);
      if (!(g = c != null && f(c, y))) break;
      c = c[y];
    }
    return g || ++h != p ? g : (p = c == null ? 0 : c.length, !!p && o(p) && i(y, p) && (a(c) || n(c)));
  }
  e.exports = l;
} }), jdr = hr({ "../../node_modules/lodash/hasIn.js"(t, e) {
  var r = Ddr(), n = Ldr();
  function a(i, o) {
    return i != null && n(i, o, r);
  }
  e.exports = a;
} }), Fdr = hr({ "../../node_modules/lodash/_baseMatchesProperty.js"(t, e) {
  var r = xet(), n = $dr(), a = jdr(), i = Kpe(), o = Cet(), s = wet(), l = pG(), c = 1, u = 2;
  function f(h, p) {
    return i(h) && o(p) ? s(l(h), p) : function(g) {
      var y = n(g, h);
      return y === void 0 && y === p ? a(g, h) : r(p, y, c | u);
    };
  }
  e.exports = f;
} }), zdr = hr({ "../../node_modules/lodash/identity.js"(t, e) {
  function r(n) {
    return n;
  }
  e.exports = r;
} }), Gdr = hr({ "../../node_modules/lodash/_baseProperty.js"(t, e) {
  function r(n) {
    return function(a) {
      return a == null ? void 0 : a[n];
    };
  }
  e.exports = r;
} }), Wdr = hr({ "../../node_modules/lodash/_basePropertyDeep.js"(t, e) {
  var r = ket();
  function n(a) {
    return function(i) {
      return r(i, a);
    };
  }
  e.exports = n;
} }), Hdr = hr({ "../../node_modules/lodash/property.js"(t, e) {
  var r = Gdr(), n = Wdr(), a = Kpe(), i = pG();
  function o(s) {
    return a(s) ? r(i(s)) : n(s);
  }
  e.exports = o;
} }), Udr = hr({ "../../node_modules/lodash/_baseIteratee.js"(t, e) {
  var r = Idr(), n = Fdr(), a = zdr(), i = $y(), o = Hdr();
  function s(l) {
    return typeof l == "function" ? l : l == null ? a : typeof l == "object" ? i(l) ? n(l[0], l[1]) : r(l) : o(l);
  }
  e.exports = s;
} }), Vdr = hr({ "../../node_modules/lodash/toFinite.js"(t, e) {
  var r = set(), n = 1 / 0, a = 17976931348623157e292;
  function i(o) {
    if (!o) return o === 0 ? o : 0;
    if (o = r(o), o === n || o === -1 / 0) {
      var s = o < 0 ? -1 : 1;
      return s * a;
    }
    return o === o ? o : 0;
  }
  e.exports = i;
} }), qdr = hr({ "../../node_modules/lodash/toInteger.js"(t, e) {
  var r = Vdr();
  function n(a) {
    var i = r(a), o = i % 1;
    return i === i ? o ? i - o : i : 0;
  }
  e.exports = n;
} }), Kdr = hr({ "../../node_modules/lodash/findIndex.js"(t, e) {
  var r = xur(), n = Udr(), a = qdr(), i = Math.max;
  function o(s, l, c) {
    var u = s == null ? 0 : s.length;
    if (!u) return -1;
    var f = c == null ? 0 : a(c);
    return f < 0 && (f = i(u + f, 0)), r(s, n(l, 3), f);
  }
  e.exports = o;
} }), Zdr = Hpe(cet()), Jdr = { config: { attributes: !0, childList: !0, subtree: !0 }, debounceTime: 0 };
function Ydr(t, e, r = Jdr) {
  let [n, a] = Yt(null);
  Ut(() => {
    if (!e || typeof e != "function") {
      console.warn(`You must provide a valid callback function, instead you've provided ${e}`);
      return;
    }
    let i = r.debounceTime && typeof r.debounceTime == "number" && r.debounceTime > 0, o = new MutationObserver(i ? (0, Zdr.default)(e, r.debounceTime) : e);
    a(o);
  }, [e, r]), Ut(() => {
    if (!n) return;
    t || console.warn(`You must provide a valid DOM element to observe, instead you've provided ${t}`);
    let { config: i } = r;
    try {
      n.observe(t, i);
    } catch (o) {
      console.error(o);
    }
    return () => {
      n && n.disconnect();
    };
  }, [n, t, r]);
}
var Xdr = Hpe(cet()), Qdr = Hpe(Kdr());
function O8() {
  let [t, e] = Yt({ width: void 0, height: void 0, breakpointIndex: void 0 }), { breakpoints: r } = Md(), n = r.map((a) => Number.parseInt(a.replace(/\D+/g, ""), 10));
  return Ut(() => {
    let a = (o) => {
      let s = (0, Qdr.default)(n, (l) => o < l);
      return s === -1 ? n.length - 1 : s;
    }, i = (0, Xdr.default)(() => {
      e({ width: window.innerWidth, height: window.innerHeight, breakpointIndex: a(window.innerWidth) });
    }, 50, { leading: !1, trailing: !0, maxWait: 150 });
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), t;
}
function e0r(t, e) {
  if (t != null) {
    if (typeof t == "function") {
      t(e);
      return;
    }
    try {
      t.current = e;
    } catch {
      throw new Error(`Cannot assign value '${e}' to ref '${t}'`);
    }
  }
}
function Aet(...t) {
  return P.useMemo(() => t.every((e) => e == null) ? null : (e) => {
    t.forEach((r) => {
      r && e0r(r, e);
    });
  }, t);
}
const Zpe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SelectedIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SelectedIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.659 6.597a1.155 1.155 0 00-1.65 0l-4.2 4.281L6.99 9.026a1.15 1.15 0 00-1.65 0 1.207 1.207 0 000 1.682l2.643 2.694a1.151 1.151 0 001.65 0l5.024-5.123a1.206 1.206 0 000-1.682z", clipRule: "evenodd" })));
});
Zpe.displayName = "SelectedIcon";
const Tet = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronUpIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronUpIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.293 7.293a1 1 0 011.32-.083l.094.083 3 3a1 1 0 01-1.32 1.497l-.094-.083L10 9.415l-2.293 2.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 3-3z" })));
});
Tet.displayName = "ChevronUpIcon";
var Eet = P.forwardRef(({ i18nStepDownLabel: t = "step value down", element: e, variant: r, ...n }, a) => P.createElement(Zs, { ...n, ref: a, element: `${e}_DECREMENT_BUTTON`, variant: "reset", size: "reset", type: "button", borderRadius: "borderRadius20", backgroundColor: r === "inverse" ? "colorBackgroundInverseElevation" : "colorBackgroundBodyElevation", marginRight: "space30", _focus: { boxShadow: r === "inverse" ? "shadowBorderInverseStrong" : "shadowBorderPrimary" } }, P.createElement(I8, { decorative: !1, title: t, size: "sizeIcon05", element: `${e}_DECREMENT_ICON` })));
Eet.displayName = "Decrement";
var Iet = P.forwardRef(({ i18nStepUpLabel: t = "step value up", element: e, variant: r, ...n }, a) => P.createElement(Zs, { ...n, ref: a, element: `${e}_INCREMENT_BUTTON`, variant: "reset", size: "reset", type: "button", borderRadius: "borderRadius20", backgroundColor: r === "inverse" ? "colorBackgroundInverseElevation" : "colorBackgroundBodyElevation", marginRight: "space30", _focus: { boxShadow: r === "inverse" ? "shadowBorderInverseStrong" : "shadowBorderPrimary" } }, P.createElement(Tet, { decorative: !1, title: t, size: "sizeIcon05", element: `${e}_INCREMENT_ICON` })));
Iet.displayName = "Increment";
var t0r = ["className", "style", "size", "height", "width"], r0r = (t) => Object.keys(t).reduce((e, r) => (t0r.includes(r) || (e[r] = t[r]), e), {}), vM = P.forwardRef(({ element: t, ...e }, r) => P.createElement(ht, { appearance: "none", as: "input", backgroundColor: "transparent", border: "none", borderRadius: "borderRadius20", boxShadow: "none", color: "inherit", cursor: (e.type === "date" || e.type === "time") && !e.readOnly && !e.disabled ? "text" : "auto", display: "block", element: t, fontFamily: "inherit", fontSize: "fontSize30", fontWeight: "fontWeightMedium", lineHeight: "lineHeight20", margin: "space0", outline: "none", paddingBottom: "space30", paddingLeft: "space40", paddingRight: "space40", paddingTop: "space30", resize: "none", width: "100%", variant: e.variant, ref: r, _placeholder: { color: e.variant === "inverse" ? "colorTextInverseWeaker" : "colorTextWeak", fontStyle: "italic" }, _focus_placeholder: { color: e.variant === "inverse" ? "colorTextInverseWeaker" : "colorTextWeak" }, _disabled: { color: e.variant === "inverse" ? "colorTextInverseWeakest" : "colorTextWeaker", cursor: "not-allowed", "-webkit-text-fill-color": e.variant === "inverse" ? "colorTextInverseWeakest" : "colorTextWeaker", "-webkit-opacity": "1" }, __webkit_datetime_edit: { display: "flex" }, __webkit_calendar_picker_indicator_hover: { cursor: e.readOnly || e.disabled ? "default" : "pointer" }, __webkit_inner_spin_button: { display: "none", margin: "space0" }, __webkit_outer_spin_button: { display: "none", margin: "space0" }, "-moz-appearance": "textfield", ...e }));
vM.displayName = "InputElement";
var Met = P.forwardRef(({ disabled: t, element: e = "INPUT", hasError: r, id: n, insertAfter: a, insertBefore: i, max: o, min: s, name: l, placeholder: c, readOnly: u, required: f, step: h, type: p, value: g, variant: y, i18nStepUpLabel: b, i18nStepDownLabel: w, ..._ }, C) => {
  let x = { type: p }, S = P.useRef(void 0), A = Aet(S, C), [I, M] = P.useState(!0), [B, L] = P.useState(!0), [N, d] = P.useState(g ?? _.defaultValue ?? "0");
  return P.useEffect(() => {
    if (p !== "number") return;
    if (t) {
      L(!1), M(!1);
      return;
    }
    let m = Number(N), v = h && !isNaN(Number(h)) ? Number(h) : 1, k = Number(o);
    if (isNaN(k)) return;
    let O = Number(s);
    isNaN(O) || ((k - O) % v !== 0 && console.error("[Paste Input]: when using min/max, and step values with a Number Input, please make sure that the min and max are multiples of the step value."), m < k && m + v <= k ? M(!0) : M(!1), m > O && m - v >= O ? L(!0) : L(!1));
  }, [o, s, h, t, p, N]), P.createElement(M8, { disabled: t, element: e, hasError: r, insertAfter: a, insertBefore: i, readOnly: u, type: p, variant: y }, P.createElement(vM, { "aria-invalid": r, "aria-readonly": u, ...r0r(_), ...x, disabled: t, element: `${e}_ELEMENT`, id: n, name: l, max: o, min: s, placeholder: c, readOnly: u, ref: A, required: f, step: h, value: g, variant: y, onChange: (m) => {
    _.onChange != null && typeof _.onChange == "function" && _.onChange(m), d(m.target.value);
  } }), p === "number" ? P.createElement(ht, { display: "flex", flexDirection: "column", rowGap: "space10", justifyContent: "center", element: `${e}_STEP_WRAPPER` }, I ? P.createElement(Iet, { element: e, onClick: () => {
    var v, k, O;
    (v = S.current) == null || v.stepUp();
    let m = new Event("change", { bubbles: !0 });
    (k = S.current) == null || k.dispatchEvent(m), (O = S.current) == null || O.focus();
  }, i18nStepUpLabel: b, variant: y }) : P.createElement(ht, { height: "12px", width: "12px", element: `${e}_INCREMENT_PLACEHOLDER` }), B ? P.createElement(Eet, { element: e, onClick: () => {
    var v, k, O;
    (v = S.current) == null || v.stepDown();
    let m = new Event("change", { bubbles: !0 });
    (k = S.current) == null || k.dispatchEvent(m), (O = S.current) == null || O.focus();
  }, i18nStepDownLabel: w, variant: y }) : P.createElement(ht, { height: "12px", width: "12px", element: `${e}_DECREMENT_PLACEHOLDER` })) : P.createElement(P.Fragment, null));
});
Met.displayName = "Input";
const n0r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Input: Met,
  InputElement: vM
}, Symbol.toStringTag, { value: "Module" }));
var mG = P.forwardRef(({ children: t, ...e }, r) => P.createElement(ht, { ...e, as: "span", display: "inline-block", verticalAlign: "bottom", textDecoration: "inherit", maxWidth: "100%", overflow: "hidden", ref: r, textOverflow: "ellipsis", whiteSpace: "nowrap" }, t));
mG.displayName = "Truncate";
const a0r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Truncate: mG
}, Symbol.toStringTag, { value: "Module" })), Dy = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CloseIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CloseIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.16 13.514L11.645 10l3.515-3.514a1.165 1.165 0 00-1.646-1.646L10 8.355 6.486 4.84A1.165 1.165 0 004.84 6.486L8.355 10 4.84 13.514a1.165 1.165 0 001.646 1.646L10 11.645l3.514 3.515a1.165 1.165 0 001.646-1.646z" })));
});
Dy.displayName = "CloseIcon";
var i0r = Object.create, Pet = Object.defineProperty, o0r = Object.getOwnPropertyDescriptor, Ret = Object.getOwnPropertyNames, s0r = Object.getPrototypeOf, l0r = Object.prototype.hasOwnProperty, c0r = (t, e) => function() {
  return e || (0, t[Ret(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, u0r = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Ret(e)) !l0r.call(t, a) && a !== r && Pet(t, a, { get: () => e[a], enumerable: !(n = o0r(e, a)) || n.enumerable });
  return t;
}, d0r = (t, e, r) => (r = t != null ? i0r(s0r(t)) : {}, u0r(!t || !t.__esModule ? Pet(r, "default", { value: t, enumerable: !0 }) : r, t)), f0r = c0r({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), h0r = { default: { color: "colorTextIcon", _hover: { color: "colorTextLinkStronger" } }, error: { color: "colorTextIcon", _hover: { color: "colorTextErrorStronger" } } }, p0r = { default: { color: "colorTextWeakest", _hover: { color: "colorTextInverse" } }, error: { color: "colorTextInverse", _hover: { color: "colorTextWeakest" } } }, H7e = { default: { color: "colorText", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryWeaker", _focus: { boxShadow: "shadowFocus", color: "colorText" }, _selected: { backgroundColor: "colorBackgroundPrimaryStronger", boxShadow: "shadowBorderPrimaryStronger", color: "colorTextWeakest" }, _selected_focus: { boxShadow: "shadowFocus", color: "colorTextWeakest" }, _disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", cursor: "not-allowed", color: "colorText" } }, error: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderErrorWeaker", color: "colorTextError", _focus: { boxShadow: "shadowFocus", color: "colorTextErrorStrong" }, _selected: { backgroundColor: "colorBackgroundError", boxShadow: "shadowBorderError", color: "colorTextInverse" }, _selected_focus: { boxShadow: "shadowFocus", color: "colorTextInverse" }, _disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", cursor: "not-allowed", color: "colorText" } } }, m0r = { default: { cursor: "pointer", color: "colorText", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryWeaker", _hover: { boxShadow: "shadowBorderPrimaryStronger", color: "colorTextPrimaryStronger" }, _selected_hover: { backgroundColor: "colorBackgroundPrimary", boxShadow: "shadowBorderPrimary", color: "colorTextInverse" }, _focus_hover: { boxShadow: "shadowFocus" } }, error: { cursor: "pointer", backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderErrorWeaker", color: "colorTextError", _hover: { boxShadow: "shadowBorderErrorStronger", color: "colorTextErrorStronger" }, _selected_hover: { backgroundColor: "colorBackgroundErrorStrongest", boxShadow: "shadowBorderErrorStrongest", color: "colorTextWeakest" }, _focus_hover: { boxShadow: "shadowFocus" } } }, g0r = { default: { _hover: { cursor: "pointer", boxShadow: "shadowBorderPrimaryStronger" } }, error: { _hover: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderErrorStronger", cursor: "pointer" } } }, v0r = { default: { _hover: { cursor: "pointer", backgroundColor: "colorBackgroundPrimary", boxShadow: "shadowBorderPrimary" } }, error: { _hover: { cursor: "pointer", backgroundColor: "colorBackgroundErrorStrongest", boxShadow: "shadowBorderErrorStrongest" } } }, y0r = { color: "inherit", _hover: { color: "inherit" } }, b0r = { default: { color: "colorTextIcon", _hover: { color: "colorTextPrimaryStronger" } }, error: { color: "colorTextIcon", _hover: { color: "colorTextErrorStronger" } } }, x0r = { default: { color: "colorTextWeakest", _hover: { color: "colorTextInverse" } }, error: { color: "colorTextInverse", _hover: { color: "colorTextWeakest" } } }, Oet = (t = {}) => ({ ...LT({ ...t, orientation: "horizontal", loop: !0 }) }), Jpe = Bo({ size: "default", variant: "listbox" }), C0r = { default: { fontSize: "fontSize20", height: "sizeIcon40" }, large: { fontSize: "fontSize30", height: "sizeIcon50" } }, Bet = P.forwardRef(({ element: t = "FORM_PILL", selected: e = !1, variant: r = "default", isHoverable: n = !1, isDisabled: a = !1, isDismissable: i = !1, i18nErrorLabel: o = "(error)", ...s }, l) => {
  let c = P.useMemo(() => n && !a ? { ...H7e[r], ...m0r[r] } : H7e[r], [n, a, r]), { size: u, variant: f } = P.useContext(Jpe), { height: h, fontSize: p } = C0r[u], g = (y) => {
    if (typeof y == "string") return P.createElement(mG, { title: y }, y);
    if (P.isValidElement(y)) {
      let b = y.props;
      return b.children && typeof b.children == "string" ? P.createElement(ht, { minWidth: "0", element: `${t}_TEXT_TRUNCATE_WRAPPER` }, P.createElement(y.type, { ...b }, g(b.children))) : P.createElement(y.type, { ...b }, g(b.children));
    }
    return Array.isArray(y) ? y.map((b) => g(b)) : y;
  };
  return P.createElement(ht, { ...Xt(s), element: t, ref: l, "aria-selected": e, "aria-disabled": a, role: f === "tree" ? "treeitem" : "option", type: f === "tree" ? void 0 : "button", as: f === "tree" ? "div" : "button", margin: "space0", position: "relative", borderRadius: "borderRadiusPill", borderStyle: "none", cursor: "default", height: h, fontFamily: "inherit", fontSize: p, fontWeight: "fontWeightMedium", outline: "none", paddingLeft: "space30", paddingRight: i ? u === "large" ? "space90" : "space80" : "space30", transition: "background-color 150ms ease-in, border-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", maxWidth: "100%", ...c }, P.createElement(ht, { display: "flex", height: "100%", alignItems: "center", columnGap: "space20", opacity: a ? 0.3 : 1 }, r === "error" ? P.createElement(P.Fragment, null, P.createElement(fy, { decorative: !0, size: u === "large" ? "sizeIcon20" : "sizeIcon10" }), P.createElement(Ul, null, o)) : null, g(s.children)));
});
Bet.displayName = "FormPillButton";
var w0r = d0r(f0r()), Net = ({ element: t = "FORM_PILL_CLOSE", onClick: e = () => {
}, selected: r = !1, variant: n = "default", pillIsHoverable: a = !1 }) => {
  let { size: i } = P.useContext(Jpe), o = r ? v0r[n] : g0r[n], s = r ? x0r[n] : b0r[n];
  a && (s = y0r);
  let l = (0, w0r.default)(o, s);
  return P.createElement(ht, { element: t, onClick: e, ...l, position: "absolute", right: 0, top: 0, display: "flex", alignItems: "center", justifyContent: "center", height: i === "large" ? "sizeIcon50" : "sizeIcon40", width: i === "large" ? "sizeIcon50" : "sizeIcon40", borderRadius: "borderRadiusCircle", borderWidth: "borderWidth10", borderStyle: "solid", borderColor: "transparent", transition: "color 150ms ease-in, border-color 150ms ease-in, background-color 150ms ease-in" }, P.createElement(Dy, { decorative: !0, size: i === "large" ? "sizeIcon20" : "sizeIcon10", color: "inherit" }));
};
Net.displayName = "PillCloseIcon";
var gG = P.forwardRef(({ element: t = "FORM_PILL", onDismiss: e, onSelect: r, next: n, selected: a, variant: i = "default", disabled: o = !1, i18nErrorLabel: s, ...l }, c) => {
  if (a && o) throw new Error("[Paste FormPill] FormPills cannot be selected and disabled at the same time.");
  let u = r != null, f = e != null, h = {};
  u && (h = a ? p0r[i] : h0r[i]);
  let p = P.useCallback((g) => {
    (g.key === "Backspace" || g.key === "Delete") && typeof e == "function" && (e(g), typeof n == "function" && n());
  }, [e, n]);
  return P.createElement(ht, { element: `${t}_WRAPPER`, position: "relative", display: "inline-block", borderRadius: "borderRadiusPill", maxWidth: "100%", ...h }, P.createElement(JYe, { ...Xt(l), element: t, ref: c, as: Bet, focusable: o, onKeyDown: o ? void 0 : p, onClick: o ? void 0 : r, next: n, isDisabled: o, isDismissable: f, isHoverable: u, selected: a, variant: i, i18nErrorLabel: s }, l.children), f && !o ? P.createElement(Net, { element: `${t}_CLOSE`, onClick: e, selected: a, variant: i, pillIsHoverable: u }) : null);
});
gG.displayName = "FormPill";
var S0r = { default: { columnGap: "space20", rowGap: "space20" }, large: { columnGap: "space30", rowGap: "space30" } }, $et = P.forwardRef(({ element: t = "FORM_PILL_GROUP", display: e = "flex", size: r = "default", variant: n = "listbox", ...a }, i) => P.createElement(Jpe.Provider, { value: { size: r, variant: n } }, P.createElement(ht, { ...Xt(a), element: t, ref: i, role: n === "tree" ? "tree" : "listbox", lineHeight: "lineHeight30", margin: "space0", padding: "space0", display: e, flexWrap: "wrap", maxWidth: "100%", ...S0r[r] }, a.children)));
$et.displayName = "StyledFormPillGroup";
var Ype = P.forwardRef(({ i18nKeyboardControls: t = "Press Delete or Backspace to remove. Press Enter to toggle selection.", ...e }, r) => {
  let n = Jr();
  return P.createElement(P.Fragment, null, P.createElement(Ul, { id: n }, t), P.createElement(KYe, { as: $et, ref: r, "aria-describedby": n, ...e }, e.children));
});
Ype.displayName = "FormPillGroup";
const _0r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FormPill: gG,
  FormPillGroup: Ype,
  useFormPillState: Oet
}, Symbol.toStringTag, { value: "Module" }));
var k0r = Object.create, Det = Object.defineProperty, A0r = Object.getOwnPropertyDescriptor, Let = Object.getOwnPropertyNames, T0r = Object.getPrototypeOf, E0r = Object.prototype.hasOwnProperty, nr = (t, e) => function() {
  return e || (0, t[Let(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, I0r = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Let(e)) !E0r.call(t, a) && a !== r && Det(t, a, { get: () => e[a], enumerable: !(n = A0r(e, a)) || n.enumerable });
  return t;
}, yM = (t, e, r) => (r = t != null ? k0r(T0r(t)) : {}, I0r(!t || !t.__esModule ? Det(r, "default", { value: t, enumerable: !0 }) : r, t)), M0r = nr({ "../../../../node_modules/lodash/_listCacheClear.js"(t, e) {
  function r() {
    this.__data__ = [], this.size = 0;
  }
  e.exports = r;
} }), jet = nr({ "../../../../node_modules/lodash/eq.js"(t, e) {
  function r(n, a) {
    return n === a || n !== n && a !== a;
  }
  e.exports = r;
} }), vG = nr({ "../../../../node_modules/lodash/_assocIndexOf.js"(t, e) {
  var r = jet();
  function n(a, i) {
    for (var o = a.length; o--; ) if (r(a[o][0], i)) return o;
    return -1;
  }
  e.exports = n;
} }), P0r = nr({ "../../../../node_modules/lodash/_listCacheDelete.js"(t, e) {
  var r = vG(), n = Array.prototype, a = n.splice;
  function i(o) {
    var s = this.__data__, l = r(s, o);
    if (l < 0) return !1;
    var c = s.length - 1;
    return l == c ? s.pop() : a.call(s, l, 1), --this.size, !0;
  }
  e.exports = i;
} }), R0r = nr({ "../../../../node_modules/lodash/_listCacheGet.js"(t, e) {
  var r = vG();
  function n(a) {
    var i = this.__data__, o = r(i, a);
    return o < 0 ? void 0 : i[o][1];
  }
  e.exports = n;
} }), O0r = nr({ "../../../../node_modules/lodash/_listCacheHas.js"(t, e) {
  var r = vG();
  function n(a) {
    return r(this.__data__, a) > -1;
  }
  e.exports = n;
} }), B0r = nr({ "../../../../node_modules/lodash/_listCacheSet.js"(t, e) {
  var r = vG();
  function n(a, i) {
    var o = this.__data__, s = r(o, a);
    return s < 0 ? (++this.size, o.push([a, i])) : o[s][1] = i, this;
  }
  e.exports = n;
} }), yG = nr({ "../../../../node_modules/lodash/_ListCache.js"(t, e) {
  var r = M0r(), n = P0r(), a = R0r(), i = O0r(), o = B0r();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), N0r = nr({ "../../../../node_modules/lodash/_stackClear.js"(t, e) {
  var r = yG();
  function n() {
    this.__data__ = new r(), this.size = 0;
  }
  e.exports = n;
} }), $0r = nr({ "../../../../node_modules/lodash/_stackDelete.js"(t, e) {
  function r(n) {
    var a = this.__data__, i = a.delete(n);
    return this.size = a.size, i;
  }
  e.exports = r;
} }), D0r = nr({ "../../../../node_modules/lodash/_stackGet.js"(t, e) {
  function r(n) {
    return this.__data__.get(n);
  }
  e.exports = r;
} }), L0r = nr({ "../../../../node_modules/lodash/_stackHas.js"(t, e) {
  function r(n) {
    return this.__data__.has(n);
  }
  e.exports = r;
} }), Fet = nr({ "../../../../node_modules/lodash/_freeGlobal.js"(t, e) {
  var r = typeof ss == "object" && ss && ss.Object === Object && ss;
  e.exports = r;
} }), ug = nr({ "../../../../node_modules/lodash/_root.js"(t, e) {
  var r = Fet(), n = typeof self == "object" && self && self.Object === Object && self, a = r || n || Function("return this")();
  e.exports = a;
} }), bG = nr({ "../../../../node_modules/lodash/_Symbol.js"(t, e) {
  var r = ug(), n = r.Symbol;
  e.exports = n;
} }), j0r = nr({ "../../../../node_modules/lodash/_getRawTag.js"(t, e) {
  var r = bG(), n = Object.prototype, a = n.hasOwnProperty, i = n.toString, o = r ? r.toStringTag : void 0;
  function s(l) {
    var c = a.call(l, o), u = l[o];
    try {
      l[o] = void 0;
      var f = !0;
    } catch {
    }
    var h = i.call(l);
    return f && (c ? l[o] = u : delete l[o]), h;
  }
  e.exports = s;
} }), F0r = nr({ "../../../../node_modules/lodash/_objectToString.js"(t, e) {
  var r = Object.prototype, n = r.toString;
  function a(i) {
    return n.call(i);
  }
  e.exports = a;
} }), B8 = nr({ "../../../../node_modules/lodash/_baseGetTag.js"(t, e) {
  var r = bG(), n = j0r(), a = F0r(), i = "[object Null]", o = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : i : s && s in Object(c) ? n(c) : a(c);
  }
  e.exports = l;
} }), xG = nr({ "../../../../node_modules/lodash/isObject.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return n != null && (a == "object" || a == "function");
  }
  e.exports = r;
} }), zet = nr({ "../../../../node_modules/lodash/isFunction.js"(t, e) {
  var r = B8(), n = xG(), a = "[object AsyncFunction]", i = "[object Function]", o = "[object GeneratorFunction]", s = "[object Proxy]";
  function l(c) {
    if (!n(c)) return !1;
    var u = r(c);
    return u == i || u == o || u == a || u == s;
  }
  e.exports = l;
} }), z0r = nr({ "../../../../node_modules/lodash/_coreJsData.js"(t, e) {
  var r = ug(), n = r["__core-js_shared__"];
  e.exports = n;
} }), G0r = nr({ "../../../../node_modules/lodash/_isMasked.js"(t, e) {
  var r = z0r(), n = function() {
    var i = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function a(i) {
    return !!n && n in i;
  }
  e.exports = a;
} }), Get = nr({ "../../../../node_modules/lodash/_toSource.js"(t, e) {
  var r = Function.prototype, n = r.toString;
  function a(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  e.exports = a;
} }), W0r = nr({ "../../../../node_modules/lodash/_baseIsNative.js"(t, e) {
  var r = zet(), n = G0r(), a = xG(), i = Get(), o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, l = Function.prototype, c = Object.prototype, u = l.toString, f = c.hasOwnProperty, h = RegExp("^" + u.call(f).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  function p(g) {
    if (!a(g) || n(g)) return !1;
    var y = r(g) ? h : s;
    return y.test(i(g));
  }
  e.exports = p;
} }), H0r = nr({ "../../../../node_modules/lodash/_getValue.js"(t, e) {
  function r(n, a) {
    return n == null ? void 0 : n[a];
  }
  e.exports = r;
} }), t6 = nr({ "../../../../node_modules/lodash/_getNative.js"(t, e) {
  var r = W0r(), n = H0r();
  function a(i, o) {
    var s = n(i, o);
    return r(s) ? s : void 0;
  }
  e.exports = a;
} }), Xpe = nr({ "../../../../node_modules/lodash/_Map.js"(t, e) {
  var r = t6(), n = ug(), a = r(n, "Map");
  e.exports = a;
} }), CG = nr({ "../../../../node_modules/lodash/_nativeCreate.js"(t, e) {
  var r = t6(), n = r(Object, "create");
  e.exports = n;
} }), U0r = nr({ "../../../../node_modules/lodash/_hashClear.js"(t, e) {
  var r = CG();
  function n() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  e.exports = n;
} }), V0r = nr({ "../../../../node_modules/lodash/_hashDelete.js"(t, e) {
  function r(n) {
    var a = this.has(n) && delete this.__data__[n];
    return this.size -= a ? 1 : 0, a;
  }
  e.exports = r;
} }), q0r = nr({ "../../../../node_modules/lodash/_hashGet.js"(t, e) {
  var r = CG(), n = "__lodash_hash_undefined__", a = Object.prototype, i = a.hasOwnProperty;
  function o(s) {
    var l = this.__data__;
    if (r) {
      var c = l[s];
      return c === n ? void 0 : c;
    }
    return i.call(l, s) ? l[s] : void 0;
  }
  e.exports = o;
} }), K0r = nr({ "../../../../node_modules/lodash/_hashHas.js"(t, e) {
  var r = CG(), n = Object.prototype, a = n.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    return r ? s[o] !== void 0 : a.call(s, o);
  }
  e.exports = i;
} }), Z0r = nr({ "../../../../node_modules/lodash/_hashSet.js"(t, e) {
  var r = CG(), n = "__lodash_hash_undefined__";
  function a(i, o) {
    var s = this.__data__;
    return this.size += this.has(i) ? 0 : 1, s[i] = r && o === void 0 ? n : o, this;
  }
  e.exports = a;
} }), J0r = nr({ "../../../../node_modules/lodash/_Hash.js"(t, e) {
  var r = U0r(), n = V0r(), a = q0r(), i = K0r(), o = Z0r();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Y0r = nr({ "../../../../node_modules/lodash/_mapCacheClear.js"(t, e) {
  var r = J0r(), n = yG(), a = Xpe();
  function i() {
    this.size = 0, this.__data__ = { hash: new r(), map: new (a || n)(), string: new r() };
  }
  e.exports = i;
} }), X0r = nr({ "../../../../node_modules/lodash/_isKeyable.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? n !== "__proto__" : n === null;
  }
  e.exports = r;
} }), wG = nr({ "../../../../node_modules/lodash/_getMapData.js"(t, e) {
  var r = X0r();
  function n(a, i) {
    var o = a.__data__;
    return r(i) ? o[typeof i == "string" ? "string" : "hash"] : o.map;
  }
  e.exports = n;
} }), Q0r = nr({ "../../../../node_modules/lodash/_mapCacheDelete.js"(t, e) {
  var r = wG();
  function n(a) {
    var i = r(this, a).delete(a);
    return this.size -= i ? 1 : 0, i;
  }
  e.exports = n;
} }), efr = nr({ "../../../../node_modules/lodash/_mapCacheGet.js"(t, e) {
  var r = wG();
  function n(a) {
    return r(this, a).get(a);
  }
  e.exports = n;
} }), tfr = nr({ "../../../../node_modules/lodash/_mapCacheHas.js"(t, e) {
  var r = wG();
  function n(a) {
    return r(this, a).has(a);
  }
  e.exports = n;
} }), rfr = nr({ "../../../../node_modules/lodash/_mapCacheSet.js"(t, e) {
  var r = wG();
  function n(a, i) {
    var o = r(this, a), s = o.size;
    return o.set(a, i), this.size += o.size == s ? 0 : 1, this;
  }
  e.exports = n;
} }), Qpe = nr({ "../../../../node_modules/lodash/_MapCache.js"(t, e) {
  var r = Y0r(), n = Q0r(), a = efr(), i = tfr(), o = rfr();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), nfr = nr({ "../../../../node_modules/lodash/_stackSet.js"(t, e) {
  var r = yG(), n = Xpe(), a = Qpe(), i = 200;
  function o(s, l) {
    var c = this.__data__;
    if (c instanceof r) {
      var u = c.__data__;
      if (!n || u.length < i - 1) return u.push([s, l]), this.size = ++c.size, this;
      c = this.__data__ = new a(u);
    }
    return c.set(s, l), this.size = c.size, this;
  }
  e.exports = o;
} }), Wet = nr({ "../../../../node_modules/lodash/_Stack.js"(t, e) {
  var r = yG(), n = N0r(), a = $0r(), i = D0r(), o = L0r(), s = nfr();
  function l(c) {
    var u = this.__data__ = new r(c);
    this.size = u.size;
  }
  l.prototype.clear = n, l.prototype.delete = a, l.prototype.get = i, l.prototype.has = o, l.prototype.set = s, e.exports = l;
} }), afr = nr({ "../../../../node_modules/lodash/_setCacheAdd.js"(t, e) {
  var r = "__lodash_hash_undefined__";
  function n(a) {
    return this.__data__.set(a, r), this;
  }
  e.exports = n;
} }), ifr = nr({ "../../../../node_modules/lodash/_setCacheHas.js"(t, e) {
  function r(n) {
    return this.__data__.has(n);
  }
  e.exports = r;
} }), ofr = nr({ "../../../../node_modules/lodash/_SetCache.js"(t, e) {
  var r = Qpe(), n = afr(), a = ifr();
  function i(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.__data__ = new r(); ++s < l; ) this.add(o[s]);
  }
  i.prototype.add = i.prototype.push = n, i.prototype.has = a, e.exports = i;
} }), sfr = nr({ "../../../../node_modules/lodash/_arraySome.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length; ++i < o; ) if (a(n[i], i, n)) return !0;
    return !1;
  }
  e.exports = r;
} }), lfr = nr({ "../../../../node_modules/lodash/_cacheHas.js"(t, e) {
  function r(n, a) {
    return n.has(a);
  }
  e.exports = r;
} }), Het = nr({ "../../../../node_modules/lodash/_equalArrays.js"(t, e) {
  var r = ofr(), n = sfr(), a = lfr(), i = 1, o = 2;
  function s(l, c, u, f, h, p) {
    var g = u & i, y = l.length, b = c.length;
    if (y != b && !(g && b > y)) return !1;
    var w = p.get(l), _ = p.get(c);
    if (w && _) return w == c && _ == l;
    var C = -1, x = !0, S = u & o ? new r() : void 0;
    for (p.set(l, c), p.set(c, l); ++C < y; ) {
      var A = l[C], I = c[C];
      if (f) var M = g ? f(I, A, C, c, l, p) : f(A, I, C, l, c, p);
      if (M !== void 0) {
        if (M) continue;
        x = !1;
        break;
      }
      if (S) {
        if (!n(c, function(B, L) {
          if (!a(S, L) && (A === B || h(A, B, u, f, p))) return S.push(L);
        })) {
          x = !1;
          break;
        }
      } else if (!(A === I || h(A, I, u, f, p))) {
        x = !1;
        break;
      }
    }
    return p.delete(l), p.delete(c), x;
  }
  e.exports = s;
} }), cfr = nr({ "../../../../node_modules/lodash/_Uint8Array.js"(t, e) {
  var r = ug(), n = r.Uint8Array;
  e.exports = n;
} }), ufr = nr({ "../../../../node_modules/lodash/_mapToArray.js"(t, e) {
  function r(n) {
    var a = -1, i = Array(n.size);
    return n.forEach(function(o, s) {
      i[++a] = [s, o];
    }), i;
  }
  e.exports = r;
} }), dfr = nr({ "../../../../node_modules/lodash/_setToArray.js"(t, e) {
  function r(n) {
    var a = -1, i = Array(n.size);
    return n.forEach(function(o) {
      i[++a] = o;
    }), i;
  }
  e.exports = r;
} }), ffr = nr({ "../../../../node_modules/lodash/_equalByTag.js"(t, e) {
  var r = bG(), n = cfr(), a = jet(), i = Het(), o = ufr(), s = dfr(), l = 1, c = 2, u = "[object Boolean]", f = "[object Date]", h = "[object Error]", p = "[object Map]", g = "[object Number]", y = "[object RegExp]", b = "[object Set]", w = "[object String]", _ = "[object Symbol]", C = "[object ArrayBuffer]", x = "[object DataView]", S = r ? r.prototype : void 0, A = S ? S.valueOf : void 0;
  function I(M, B, L, N, d, m, v) {
    switch (L) {
      case x:
        if (M.byteLength != B.byteLength || M.byteOffset != B.byteOffset) return !1;
        M = M.buffer, B = B.buffer;
      case C:
        return !(M.byteLength != B.byteLength || !m(new n(M), new n(B)));
      case u:
      case f:
      case g:
        return a(+M, +B);
      case h:
        return M.name == B.name && M.message == B.message;
      case y:
      case w:
        return M == B + "";
      case p:
        var k = o;
      case b:
        var O = N & l;
        if (k || (k = s), M.size != B.size && !O) return !1;
        var G = v.get(M);
        if (G) return G == B;
        N |= c, v.set(M, B);
        var H = i(k(M), k(B), N, d, m, v);
        return v.delete(M), H;
      case _:
        if (A) return A.call(M) == A.call(B);
    }
    return !1;
  }
  e.exports = I;
} }), hfr = nr({ "../../../../node_modules/lodash/_arrayPush.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = a.length, s = n.length; ++i < o; ) n[s + i] = a[i];
    return n;
  }
  e.exports = r;
} }), c2 = nr({ "../../../../node_modules/lodash/isArray.js"(t, e) {
  var r = Array.isArray;
  e.exports = r;
} }), pfr = nr({ "../../../../node_modules/lodash/_baseGetAllKeys.js"(t, e) {
  var r = hfr(), n = c2();
  function a(i, o, s) {
    var l = o(i);
    return n(i) ? l : r(l, s(i));
  }
  e.exports = a;
} }), mfr = nr({ "../../../../node_modules/lodash/_arrayFilter.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = 0, l = []; ++i < o; ) {
      var c = n[i];
      a(c, i, n) && (l[s++] = c);
    }
    return l;
  }
  e.exports = r;
} }), gfr = nr({ "../../../../node_modules/lodash/stubArray.js"(t, e) {
  function r() {
    return [];
  }
  e.exports = r;
} }), vfr = nr({ "../../../../node_modules/lodash/_getSymbols.js"(t, e) {
  var r = mfr(), n = gfr(), a = Object.prototype, i = a.propertyIsEnumerable, o = Object.getOwnPropertySymbols, s = o ? function(l) {
    return l == null ? [] : (l = Object(l), r(o(l), function(c) {
      return i.call(l, c);
    }));
  } : n;
  e.exports = s;
} }), yfr = nr({ "../../../../node_modules/lodash/_baseTimes.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = Array(n); ++i < n; ) o[i] = a(i);
    return o;
  }
  e.exports = r;
} }), N8 = nr({ "../../../../node_modules/lodash/isObjectLike.js"(t, e) {
  function r(n) {
    return n != null && typeof n == "object";
  }
  e.exports = r;
} }), bfr = nr({ "../../../../node_modules/lodash/_baseIsArguments.js"(t, e) {
  var r = B8(), n = N8(), a = "[object Arguments]";
  function i(o) {
    return n(o) && r(o) == a;
  }
  e.exports = i;
} }), eme = nr({ "../../../../node_modules/lodash/isArguments.js"(t, e) {
  var r = bfr(), n = N8(), a = Object.prototype, i = a.hasOwnProperty, o = a.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(l) {
    return n(l) && i.call(l, "callee") && !o.call(l, "callee");
  };
  e.exports = s;
} }), xfr = nr({ "../../../../node_modules/lodash/stubFalse.js"(t, e) {
  function r() {
    return !1;
  }
  e.exports = r;
} }), tme = nr({ "../../../../node_modules/lodash/isBuffer.js"(t, e) {
  var r = ug(), n = xfr(), a = typeof t == "object" && t && !t.nodeType && t, i = a && typeof e == "object" && e && !e.nodeType && e, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
  e.exports = c;
} }), Uet = nr({ "../../../../node_modules/lodash/_isIndex.js"(t, e) {
  var r = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function a(i, o) {
    var s = typeof i;
    return o = o ?? r, !!o && (s == "number" || s != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < o;
  }
  e.exports = a;
} }), rme = nr({ "../../../../node_modules/lodash/isLength.js"(t, e) {
  var r = 9007199254740991;
  function n(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= r;
  }
  e.exports = n;
} }), Cfr = nr({ "../../../../node_modules/lodash/_baseIsTypedArray.js"(t, e) {
  var r = B8(), n = rme(), a = N8(), i = "[object Arguments]", o = "[object Array]", s = "[object Boolean]", l = "[object Date]", c = "[object Error]", u = "[object Function]", f = "[object Map]", h = "[object Number]", p = "[object Object]", g = "[object RegExp]", y = "[object Set]", b = "[object String]", w = "[object WeakMap]", _ = "[object ArrayBuffer]", C = "[object DataView]", x = "[object Float32Array]", S = "[object Float64Array]", A = "[object Int8Array]", I = "[object Int16Array]", M = "[object Int32Array]", B = "[object Uint8Array]", L = "[object Uint8ClampedArray]", N = "[object Uint16Array]", d = "[object Uint32Array]", m = {};
  m[x] = m[S] = m[A] = m[I] = m[M] = m[B] = m[L] = m[N] = m[d] = !0, m[i] = m[o] = m[_] = m[s] = m[C] = m[l] = m[c] = m[u] = m[f] = m[h] = m[p] = m[g] = m[y] = m[b] = m[w] = !1;
  function v(k) {
    return a(k) && n(k.length) && !!m[r(k)];
  }
  e.exports = v;
} }), wfr = nr({ "../../../../node_modules/lodash/_baseUnary.js"(t, e) {
  function r(n) {
    return function(a) {
      return n(a);
    };
  }
  e.exports = r;
} }), Sfr = nr({ "../../../../node_modules/lodash/_nodeUtil.js"(t, e) {
  var r = Fet(), n = typeof t == "object" && t && !t.nodeType && t, a = n && typeof e == "object" && e && !e.nodeType && e, i = a && a.exports === n, o = i && r.process, s = function() {
    try {
      var l = a && a.require && a.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = s;
} }), nme = nr({ "../../../../node_modules/lodash/isTypedArray.js"(t, e) {
  var r = Cfr(), n = wfr(), a = Sfr(), i = a && a.isTypedArray, o = i ? n(i) : r;
  e.exports = o;
} }), _fr = nr({ "../../../../node_modules/lodash/_arrayLikeKeys.js"(t, e) {
  var r = yfr(), n = eme(), a = c2(), i = tme(), o = Uet(), s = nme(), l = Object.prototype, c = l.hasOwnProperty;
  function u(f, h) {
    var p = a(f), g = !p && n(f), y = !p && !g && i(f), b = !p && !g && !y && s(f), w = p || g || y || b, _ = w ? r(f.length, String) : [], C = _.length;
    for (var x in f) (h || c.call(f, x)) && !(w && (x == "length" || y && (x == "offset" || x == "parent") || b && (x == "buffer" || x == "byteLength" || x == "byteOffset") || o(x, C))) && _.push(x);
    return _;
  }
  e.exports = u;
} }), Vet = nr({ "../../../../node_modules/lodash/_isPrototype.js"(t, e) {
  var r = Object.prototype;
  function n(a) {
    var i = a && a.constructor, o = typeof i == "function" && i.prototype || r;
    return a === o;
  }
  e.exports = n;
} }), kfr = nr({ "../../../../node_modules/lodash/_overArg.js"(t, e) {
  function r(n, a) {
    return function(i) {
      return n(a(i));
    };
  }
  e.exports = r;
} }), Afr = nr({ "../../../../node_modules/lodash/_nativeKeys.js"(t, e) {
  var r = kfr(), n = r(Object.keys, Object);
  e.exports = n;
} }), qet = nr({ "../../../../node_modules/lodash/_baseKeys.js"(t, e) {
  var r = Vet(), n = Afr(), a = Object.prototype, i = a.hasOwnProperty;
  function o(s) {
    if (!r(s)) return n(s);
    var l = [];
    for (var c in Object(s)) i.call(s, c) && c != "constructor" && l.push(c);
    return l;
  }
  e.exports = o;
} }), bM = nr({ "../../../../node_modules/lodash/isArrayLike.js"(t, e) {
  var r = zet(), n = rme();
  function a(i) {
    return i != null && n(i.length) && !r(i);
  }
  e.exports = a;
} }), xM = nr({ "../../../../node_modules/lodash/keys.js"(t, e) {
  var r = _fr(), n = qet(), a = bM();
  function i(o) {
    return a(o) ? r(o) : n(o);
  }
  e.exports = i;
} }), Tfr = nr({ "../../../../node_modules/lodash/_getAllKeys.js"(t, e) {
  var r = pfr(), n = vfr(), a = xM();
  function i(o) {
    return r(o, a, n);
  }
  e.exports = i;
} }), Efr = nr({ "../../../../node_modules/lodash/_equalObjects.js"(t, e) {
  var r = Tfr(), n = 1, a = Object.prototype, i = a.hasOwnProperty;
  function o(s, l, c, u, f, h) {
    var p = c & n, g = r(s), y = g.length, b = r(l), w = b.length;
    if (y != w && !p) return !1;
    for (var _ = y; _--; ) {
      var C = g[_];
      if (!(p ? C in l : i.call(l, C))) return !1;
    }
    var x = h.get(s), S = h.get(l);
    if (x && S) return x == l && S == s;
    var A = !0;
    h.set(s, l), h.set(l, s);
    for (var I = p; ++_ < y; ) {
      C = g[_];
      var M = s[C], B = l[C];
      if (u) var L = p ? u(B, M, C, l, s, h) : u(M, B, C, s, l, h);
      if (!(L === void 0 ? M === B || f(M, B, c, u, h) : L)) {
        A = !1;
        break;
      }
      I || (I = C == "constructor");
    }
    if (A && !I) {
      var N = s.constructor, d = l.constructor;
      N != d && "constructor" in s && "constructor" in l && !(typeof N == "function" && N instanceof N && typeof d == "function" && d instanceof d) && (A = !1);
    }
    return h.delete(s), h.delete(l), A;
  }
  e.exports = o;
} }), Ifr = nr({ "../../../../node_modules/lodash/_DataView.js"(t, e) {
  var r = t6(), n = ug(), a = r(n, "DataView");
  e.exports = a;
} }), Mfr = nr({ "../../../../node_modules/lodash/_Promise.js"(t, e) {
  var r = t6(), n = ug(), a = r(n, "Promise");
  e.exports = a;
} }), Pfr = nr({ "../../../../node_modules/lodash/_Set.js"(t, e) {
  var r = t6(), n = ug(), a = r(n, "Set");
  e.exports = a;
} }), Rfr = nr({ "../../../../node_modules/lodash/_WeakMap.js"(t, e) {
  var r = t6(), n = ug(), a = r(n, "WeakMap");
  e.exports = a;
} }), Ket = nr({ "../../../../node_modules/lodash/_getTag.js"(t, e) {
  var r = Ifr(), n = Xpe(), a = Mfr(), i = Pfr(), o = Rfr(), s = B8(), l = Get(), c = "[object Map]", u = "[object Object]", f = "[object Promise]", h = "[object Set]", p = "[object WeakMap]", g = "[object DataView]", y = l(r), b = l(n), w = l(a), _ = l(i), C = l(o), x = s;
  (r && x(new r(new ArrayBuffer(1))) != g || n && x(new n()) != c || a && x(a.resolve()) != f || i && x(new i()) != h || o && x(new o()) != p) && (x = function(S) {
    var A = s(S), I = A == u ? S.constructor : void 0, M = I ? l(I) : "";
    if (M) switch (M) {
      case y:
        return g;
      case b:
        return c;
      case w:
        return f;
      case _:
        return h;
      case C:
        return p;
    }
    return A;
  }), e.exports = x;
} }), Ofr = nr({ "../../../../node_modules/lodash/_baseIsEqualDeep.js"(t, e) {
  var r = Wet(), n = Het(), a = ffr(), i = Efr(), o = Ket(), s = c2(), l = tme(), c = nme(), u = 1, f = "[object Arguments]", h = "[object Array]", p = "[object Object]", g = Object.prototype, y = g.hasOwnProperty;
  function b(w, _, C, x, S, A) {
    var I = s(w), M = s(_), B = I ? h : o(w), L = M ? h : o(_);
    B = B == f ? p : B, L = L == f ? p : L;
    var N = B == p, d = L == p, m = B == L;
    if (m && l(w)) {
      if (!l(_)) return !1;
      I = !0, N = !1;
    }
    if (m && !N) return A || (A = new r()), I || c(w) ? n(w, _, C, x, S, A) : a(w, _, B, C, x, S, A);
    if (!(C & u)) {
      var v = N && y.call(w, "__wrapped__"), k = d && y.call(_, "__wrapped__");
      if (v || k) {
        var O = v ? w.value() : w, G = k ? _.value() : _;
        return A || (A = new r()), S(O, G, C, x, A);
      }
    }
    return m ? (A || (A = new r()), i(w, _, C, x, S, A)) : !1;
  }
  e.exports = b;
} }), Zet = nr({ "../../../../node_modules/lodash/_baseIsEqual.js"(t, e) {
  var r = Ofr(), n = N8();
  function a(i, o, s, l, c) {
    return i === o ? !0 : i == null || o == null || !n(i) && !n(o) ? i !== i && o !== o : r(i, o, s, l, a, c);
  }
  e.exports = a;
} }), Bfr = nr({ "../../../../node_modules/lodash/_baseIsMatch.js"(t, e) {
  var r = Wet(), n = Zet(), a = 1, i = 2;
  function o(s, l, c, u) {
    var f = c.length, h = f, p = !u;
    if (s == null) return !h;
    for (s = Object(s); f--; ) {
      var g = c[f];
      if (p && g[2] ? g[1] !== s[g[0]] : !(g[0] in s)) return !1;
    }
    for (; ++f < h; ) {
      g = c[f];
      var y = g[0], b = s[y], w = g[1];
      if (p && g[2]) {
        if (b === void 0 && !(y in s)) return !1;
      } else {
        var _ = new r();
        if (u) var C = u(b, w, y, s, l, _);
        if (!(C === void 0 ? n(w, b, a | i, u, _) : C)) return !1;
      }
    }
    return !0;
  }
  e.exports = o;
} }), Jet = nr({ "../../../../node_modules/lodash/_isStrictComparable.js"(t, e) {
  var r = xG();
  function n(a) {
    return a === a && !r(a);
  }
  e.exports = n;
} }), Nfr = nr({ "../../../../node_modules/lodash/_getMatchData.js"(t, e) {
  var r = Jet(), n = xM();
  function a(i) {
    for (var o = n(i), s = o.length; s--; ) {
      var l = o[s], c = i[l];
      o[s] = [l, c, r(c)];
    }
    return o;
  }
  e.exports = a;
} }), Yet = nr({ "../../../../node_modules/lodash/_matchesStrictComparable.js"(t, e) {
  function r(n, a) {
    return function(i) {
      return i == null ? !1 : i[n] === a && (a !== void 0 || n in Object(i));
    };
  }
  e.exports = r;
} }), $fr = nr({ "../../../../node_modules/lodash/_baseMatches.js"(t, e) {
  var r = Bfr(), n = Nfr(), a = Yet();
  function i(o) {
    var s = n(o);
    return s.length == 1 && s[0][2] ? a(s[0][0], s[0][1]) : function(l) {
      return l === o || r(l, o, s);
    };
  }
  e.exports = i;
} }), SG = nr({ "../../../../node_modules/lodash/isSymbol.js"(t, e) {
  var r = B8(), n = N8(), a = "[object Symbol]";
  function i(o) {
    return typeof o == "symbol" || n(o) && r(o) == a;
  }
  e.exports = i;
} }), ame = nr({ "../../../../node_modules/lodash/_isKey.js"(t, e) {
  var r = c2(), n = SG(), a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function o(s, l) {
    if (r(s)) return !1;
    var c = typeof s;
    return c == "number" || c == "symbol" || c == "boolean" || s == null || n(s) ? !0 : i.test(s) || !a.test(s) || l != null && s in Object(l);
  }
  e.exports = o;
} }), Dfr = nr({ "../../../../node_modules/lodash/memoize.js"(t, e) {
  var r = Qpe(), n = "Expected a function";
  function a(i, o) {
    if (typeof i != "function" || o != null && typeof o != "function") throw new TypeError(n);
    var s = function() {
      var l = arguments, c = o ? o.apply(this, l) : l[0], u = s.cache;
      if (u.has(c)) return u.get(c);
      var f = i.apply(this, l);
      return s.cache = u.set(c, f) || u, f;
    };
    return s.cache = new (a.Cache || r)(), s;
  }
  a.Cache = r, e.exports = a;
} }), Lfr = nr({ "../../../../node_modules/lodash/_memoizeCapped.js"(t, e) {
  var r = Dfr(), n = 500;
  function a(i) {
    var o = r(i, function(l) {
      return s.size === n && s.clear(), l;
    }), s = o.cache;
    return o;
  }
  e.exports = a;
} }), jfr = nr({ "../../../../node_modules/lodash/_stringToPath.js"(t, e) {
  var r = Lfr(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a = /\\(\\)?/g, i = r(function(o) {
    var s = [];
    return o.charCodeAt(0) === 46 && s.push(""), o.replace(n, function(l, c, u, f) {
      s.push(u ? f.replace(a, "$1") : c || l);
    }), s;
  });
  e.exports = i;
} }), Xet = nr({ "../../../../node_modules/lodash/_arrayMap.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = Array(o); ++i < o; ) s[i] = a(n[i], i, n);
    return s;
  }
  e.exports = r;
} }), Ffr = nr({ "../../../../node_modules/lodash/_baseToString.js"(t, e) {
  var r = bG(), n = Xet(), a = c2(), i = SG(), o = r ? r.prototype : void 0, s = o ? o.toString : void 0;
  function l(c) {
    if (typeof c == "string") return c;
    if (a(c)) return n(c, l) + "";
    if (i(c)) return s ? s.call(c) : "";
    var u = c + "";
    return u == "0" && 1 / c == -1 / 0 ? "-0" : u;
  }
  e.exports = l;
} }), zfr = nr({ "../../../../node_modules/lodash/toString.js"(t, e) {
  var r = Ffr();
  function n(a) {
    return a == null ? "" : r(a);
  }
  e.exports = n;
} }), Qet = nr({ "../../../../node_modules/lodash/_castPath.js"(t, e) {
  var r = c2(), n = ame(), a = jfr(), i = zfr();
  function o(s, l) {
    return r(s) ? s : n(s, l) ? [s] : a(i(s));
  }
  e.exports = o;
} }), _G = nr({ "../../../../node_modules/lodash/_toKey.js"(t, e) {
  var r = SG();
  function n(a) {
    if (typeof a == "string" || r(a)) return a;
    var i = a + "";
    return i == "0" && 1 / a == -1 / 0 ? "-0" : i;
  }
  e.exports = n;
} }), ett = nr({ "../../../../node_modules/lodash/_baseGet.js"(t, e) {
  var r = Qet(), n = _G();
  function a(i, o) {
    o = r(o, i);
    for (var s = 0, l = o.length; i != null && s < l; ) i = i[n(o[s++])];
    return s && s == l ? i : void 0;
  }
  e.exports = a;
} }), Gfr = nr({ "../../../../node_modules/lodash/get.js"(t, e) {
  var r = ett();
  function n(a, i, o) {
    var s = a == null ? void 0 : r(a, i);
    return s === void 0 ? o : s;
  }
  e.exports = n;
} }), Wfr = nr({ "../../../../node_modules/lodash/_baseHasIn.js"(t, e) {
  function r(n, a) {
    return n != null && a in Object(n);
  }
  e.exports = r;
} }), Hfr = nr({ "../../../../node_modules/lodash/_hasPath.js"(t, e) {
  var r = Qet(), n = eme(), a = c2(), i = Uet(), o = rme(), s = _G();
  function l(c, u, f) {
    u = r(u, c);
    for (var h = -1, p = u.length, g = !1; ++h < p; ) {
      var y = s(u[h]);
      if (!(g = c != null && f(c, y))) break;
      c = c[y];
    }
    return g || ++h != p ? g : (p = c == null ? 0 : c.length, !!p && o(p) && i(y, p) && (a(c) || n(c)));
  }
  e.exports = l;
} }), Ufr = nr({ "../../../../node_modules/lodash/hasIn.js"(t, e) {
  var r = Wfr(), n = Hfr();
  function a(i, o) {
    return i != null && n(i, o, r);
  }
  e.exports = a;
} }), Vfr = nr({ "../../../../node_modules/lodash/_baseMatchesProperty.js"(t, e) {
  var r = Zet(), n = Gfr(), a = Ufr(), i = ame(), o = Jet(), s = Yet(), l = _G(), c = 1, u = 2;
  function f(h, p) {
    return i(h) && o(p) ? s(l(h), p) : function(g) {
      var y = n(g, h);
      return y === void 0 && y === p ? a(g, h) : r(p, y, c | u);
    };
  }
  e.exports = f;
} }), qfr = nr({ "../../../../node_modules/lodash/identity.js"(t, e) {
  function r(n) {
    return n;
  }
  e.exports = r;
} }), Kfr = nr({ "../../../../node_modules/lodash/_baseProperty.js"(t, e) {
  function r(n) {
    return function(a) {
      return a == null ? void 0 : a[n];
    };
  }
  e.exports = r;
} }), Zfr = nr({ "../../../../node_modules/lodash/_basePropertyDeep.js"(t, e) {
  var r = ett();
  function n(a) {
    return function(i) {
      return r(i, a);
    };
  }
  e.exports = n;
} }), Jfr = nr({ "../../../../node_modules/lodash/property.js"(t, e) {
  var r = Kfr(), n = Zfr(), a = ame(), i = _G();
  function o(s) {
    return a(s) ? r(i(s)) : n(s);
  }
  e.exports = o;
} }), ime = nr({ "../../../../node_modules/lodash/_baseIteratee.js"(t, e) {
  var r = $fr(), n = Vfr(), a = qfr(), i = c2(), o = Jfr();
  function s(l) {
    return typeof l == "function" ? l : l == null ? a : typeof l == "object" ? i(l) ? n(l[0], l[1]) : r(l) : o(l);
  }
  e.exports = s;
} }), Yfr = nr({ "../../../../node_modules/lodash/_createFind.js"(t, e) {
  var r = ime(), n = bM(), a = xM();
  function i(o) {
    return function(s, l, c) {
      var u = Object(s);
      if (!n(s)) {
        var f = r(l, 3);
        s = a(s), l = function(p) {
          return f(u[p], p, u);
        };
      }
      var h = o(s, l, c);
      return h > -1 ? u[f ? s[h] : h] : void 0;
    };
  }
  e.exports = i;
} }), ttt = nr({ "../../../../node_modules/lodash/_baseFindIndex.js"(t, e) {
  function r(n, a, i, o) {
    for (var s = n.length, l = i + (o ? 1 : -1); o ? l-- : ++l < s; ) if (a(n[l], l, n)) return l;
    return -1;
  }
  e.exports = r;
} }), Xfr = nr({ "../../../../node_modules/lodash/_trimmedEndIndex.js"(t, e) {
  var r = /\s/;
  function n(a) {
    for (var i = a.length; i-- && r.test(a.charAt(i)); ) ;
    return i;
  }
  e.exports = n;
} }), Qfr = nr({ "../../../../node_modules/lodash/_baseTrim.js"(t, e) {
  var r = Xfr(), n = /^\s+/;
  function a(i) {
    return i && i.slice(0, r(i) + 1).replace(n, "");
  }
  e.exports = a;
} }), e1r = nr({ "../../../../node_modules/lodash/toNumber.js"(t, e) {
  var r = Qfr(), n = xG(), a = SG(), i = NaN, o = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, c = parseInt;
  function u(f) {
    if (typeof f == "number") return f;
    if (a(f)) return i;
    if (n(f)) {
      var h = typeof f.valueOf == "function" ? f.valueOf() : f;
      f = n(h) ? h + "" : h;
    }
    if (typeof f != "string") return f === 0 ? f : +f;
    f = r(f);
    var p = s.test(f);
    return p || l.test(f) ? c(f.slice(2), p ? 2 : 8) : o.test(f) ? i : +f;
  }
  e.exports = u;
} }), t1r = nr({ "../../../../node_modules/lodash/toFinite.js"(t, e) {
  var r = e1r(), n = 1 / 0, a = 17976931348623157e292;
  function i(o) {
    if (!o) return o === 0 ? o : 0;
    if (o = r(o), o === n || o === -1 / 0) {
      var s = o < 0 ? -1 : 1;
      return s * a;
    }
    return o === o ? o : 0;
  }
  e.exports = i;
} }), rtt = nr({ "../../../../node_modules/lodash/toInteger.js"(t, e) {
  var r = t1r();
  function n(a) {
    var i = r(a), o = i % 1;
    return i === i ? o ? i - o : i : 0;
  }
  e.exports = n;
} }), r1r = nr({ "../../../../node_modules/lodash/findIndex.js"(t, e) {
  var r = ttt(), n = ime(), a = rtt(), i = Math.max;
  function o(s, l, c) {
    var u = s == null ? 0 : s.length;
    if (!u) return -1;
    var f = c == null ? 0 : a(c);
    return f < 0 && (f = i(u + f, 0)), r(s, n(l, 3), f);
  }
  e.exports = o;
} }), n1r = nr({ "../../../../node_modules/lodash/find.js"(t, e) {
  var r = Yfr(), n = r1r(), a = r(n);
  e.exports = a;
} }), a1r = nr({ "../../../../node_modules/lodash/_defineProperty.js"(t, e) {
  var r = t6(), n = function() {
    try {
      var a = r(Object, "defineProperty");
      return a({}, "", {}), a;
    } catch {
    }
  }();
  e.exports = n;
} }), i1r = nr({ "../../../../node_modules/lodash/_baseAssignValue.js"(t, e) {
  var r = a1r();
  function n(a, i, o) {
    i == "__proto__" && r ? r(a, i, { configurable: !0, enumerable: !0, value: o, writable: !0 }) : a[i] = o;
  }
  e.exports = n;
} }), o1r = nr({ "../../../../node_modules/lodash/_arrayAggregator.js"(t, e) {
  function r(n, a, i, o) {
    for (var s = -1, l = n == null ? 0 : n.length; ++s < l; ) {
      var c = n[s];
      a(o, c, i(c), n);
    }
    return o;
  }
  e.exports = r;
} }), s1r = nr({ "../../../../node_modules/lodash/_createBaseFor.js"(t, e) {
  function r(n) {
    return function(a, i, o) {
      for (var s = -1, l = Object(a), c = o(a), u = c.length; u--; ) {
        var f = c[n ? u : ++s];
        if (i(l[f], f, l) === !1) break;
      }
      return a;
    };
  }
  e.exports = r;
} }), l1r = nr({ "../../../../node_modules/lodash/_baseFor.js"(t, e) {
  var r = s1r(), n = r();
  e.exports = n;
} }), c1r = nr({ "../../../../node_modules/lodash/_baseForOwn.js"(t, e) {
  var r = l1r(), n = xM();
  function a(i, o) {
    return i && r(i, o, n);
  }
  e.exports = a;
} }), u1r = nr({ "../../../../node_modules/lodash/_createBaseEach.js"(t, e) {
  var r = bM();
  function n(a, i) {
    return function(o, s) {
      if (o == null) return o;
      if (!r(o)) return a(o, s);
      for (var l = o.length, c = i ? l : -1, u = Object(o); (i ? c-- : ++c < l) && s(u[c], c, u) !== !1; ) ;
      return o;
    };
  }
  e.exports = n;
} }), d1r = nr({ "../../../../node_modules/lodash/_baseEach.js"(t, e) {
  var r = c1r(), n = u1r(), a = n(r);
  e.exports = a;
} }), f1r = nr({ "../../../../node_modules/lodash/_baseAggregator.js"(t, e) {
  var r = d1r();
  function n(a, i, o, s) {
    return r(a, function(l, c, u) {
      i(s, l, o(l), u);
    }), s;
  }
  e.exports = n;
} }), h1r = nr({ "../../../../node_modules/lodash/_createAggregator.js"(t, e) {
  var r = o1r(), n = f1r(), a = ime(), i = c2();
  function o(s, l) {
    return function(c, u) {
      var f = i(c) ? r : n, h = l ? l() : {};
      return f(c, s, a(u, 2), h);
    };
  }
  e.exports = o;
} }), p1r = nr({ "../../../../node_modules/lodash/groupBy.js"(t, e) {
  var r = i1r(), n = h1r(), a = Object.prototype, i = a.hasOwnProperty, o = n(function(s, l, c) {
    i.call(s, c) ? s[c].push(l) : r(s, c, [l]);
  });
  e.exports = o;
} }), ntt = nr({ "../../../../node_modules/lodash/isEmpty.js"(t, e) {
  var r = qet(), n = Ket(), a = eme(), i = c2(), o = bM(), s = tme(), l = Vet(), c = nme(), u = "[object Map]", f = "[object Set]", h = Object.prototype, p = h.hasOwnProperty;
  function g(y) {
    if (y == null) return !0;
    if (o(y) && (i(y) || typeof y == "string" || typeof y.splice == "function" || s(y) || c(y) || a(y))) return !y.length;
    var b = n(y);
    if (b == u || b == f) return !y.size;
    if (l(y)) return !r(y).length;
    for (var w in y) if (p.call(y, w)) return !1;
    return !0;
  }
  e.exports = g;
} }), m1r = nr({ "../../../../node_modules/lodash/_baseIsNaN.js"(t, e) {
  function r(n) {
    return n !== n;
  }
  e.exports = r;
} }), g1r = nr({ "../../../../node_modules/lodash/_strictIndexOf.js"(t, e) {
  function r(n, a, i) {
    for (var o = i - 1, s = n.length; ++o < s; ) if (n[o] === a) return o;
    return -1;
  }
  e.exports = r;
} }), v1r = nr({ "../../../../node_modules/lodash/_baseIndexOf.js"(t, e) {
  var r = ttt(), n = m1r(), a = g1r();
  function i(o, s, l) {
    return s === s ? a(o, s, l) : r(o, n, l);
  }
  e.exports = i;
} }), y1r = nr({ "../../../../node_modules/lodash/isString.js"(t, e) {
  var r = B8(), n = c2(), a = N8(), i = "[object String]";
  function o(s) {
    return typeof s == "string" || !n(s) && a(s) && r(s) == i;
  }
  e.exports = o;
} }), b1r = nr({ "../../../../node_modules/lodash/_baseValues.js"(t, e) {
  var r = Xet();
  function n(a, i) {
    return r(i, function(o) {
      return a[o];
    });
  }
  e.exports = n;
} }), x1r = nr({ "../../../../node_modules/lodash/values.js"(t, e) {
  var r = b1r(), n = xM();
  function a(i) {
    return i == null ? [] : r(i, n(i));
  }
  e.exports = a;
} }), C1r = nr({ "../../../../node_modules/lodash/includes.js"(t, e) {
  var r = v1r(), n = bM(), a = y1r(), i = rtt(), o = x1r(), s = Math.max;
  function l(c, u, f, h) {
    c = n(c) ? c : o(c), f = f && !h ? i(f) : 0;
    var p = c.length;
    return f < 0 && (f = s(p + f, 0)), a(c) ? f <= p && c.indexOf(u, f) > -1 : !!p && r(c, u, f) > -1;
  }
  e.exports = l;
} });
function ab() {
  return ab = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ab.apply(this, arguments);
}
function w1r(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
var S1r = ["bottom", "height", "left", "right", "top", "width"], _1r = function(t, e) {
  return t === void 0 && (t = {}), e === void 0 && (e = {}), S1r.some(function(r) {
    return t[r] !== e[r];
  });
}, sv = /* @__PURE__ */ new Map(), att, k1r = function t() {
  var e = [];
  sv.forEach(function(r, n) {
    var a = n.getBoundingClientRect();
    _1r(a, r.rect) && (r.rect = a, e.push(r));
  }), e.forEach(function(r) {
    r.callbacks.forEach(function(n) {
      return n(r.rect);
    });
  }), att = window.requestAnimationFrame(t);
};
function A1r(t, e) {
  return { observe: function() {
    var r = sv.size === 0;
    sv.has(t) ? sv.get(t).callbacks.push(e) : sv.set(t, { rect: void 0, hasRectChanged: !1, callbacks: [e] }), r && k1r();
  }, unobserve: function() {
    var r = sv.get(t);
    if (r) {
      var n = r.callbacks.indexOf(e);
      n >= 0 && r.callbacks.splice(n, 1), r.callbacks.length || sv.delete(t), sv.size || cancelAnimationFrame(att);
    }
  } };
}
var DL = typeof window < "u" ? Te.useLayoutEffect : Te.useEffect;
function T1r(t, e) {
  e === void 0 && (e = { width: 0, height: 0 });
  var r = Te.useState(t.current), n = r[0], a = r[1], i = Te.useReducer(E1r, e), o = i[0], s = i[1], l = Te.useRef(!1);
  return DL(function() {
    t.current !== n && a(t.current);
  }), DL(function() {
    if (n && !l.current) {
      l.current = !0;
      var c = n.getBoundingClientRect();
      s({ rect: c });
    }
  }, [n]), Te.useEffect(function() {
    if (n) {
      var c = A1r(n, function(u) {
        s({ rect: u });
      });
      return c.observe(), function() {
        c.unobserve();
      };
    }
  }, [n]), o;
}
function E1r(t, e) {
  var r = e.rect;
  return t.height !== r.height || t.width !== r.width ? r : t;
}
var I1r = function() {
  return 50;
}, M1r = function(t) {
  return t;
}, P1r = function(t, e) {
  var r = e ? "offsetWidth" : "offsetHeight";
  return t[r];
}, R1r = function(t) {
  for (var e = Math.max(t.start - t.overscan, 0), r = Math.min(t.end + t.overscan, t.size - 1), n = [], a = e; a <= r; a++) n.push(a);
  return n;
};
function itt(t) {
  var e, r = t.size, n = r === void 0 ? 0 : r, a = t.estimateSize, i = a === void 0 ? I1r : a, o = t.overscan, s = o === void 0 ? 1 : o, l = t.paddingStart, c = l === void 0 ? 0 : l, u = t.paddingEnd, f = u === void 0 ? 0 : u, h = t.parentRef, p = t.horizontal, g = t.scrollToFn, y = t.useObserver, b = t.initialRect, w = t.onScrollElement, _ = t.scrollOffsetFn, C = t.keyExtractor, x = C === void 0 ? M1r : C, S = t.measureSize, A = S === void 0 ? P1r : S, I = t.rangeExtractor, M = I === void 0 ? R1r : I, B = p ? "width" : "height", L = p ? "scrollLeft" : "scrollTop", N = Te.useRef({ scrollOffset: 0, measurements: [] }), d = Te.useState(0), m = d[0], v = d[1];
  N.current.scrollOffset = m;
  var k = y || T1r, O = k(h, b), G = O[B];
  N.current.outerSize = G;
  var H = Te.useCallback(function(ze) {
    h.current && (h.current[L] = ze);
  }, [h, L]), j = g || H;
  g = Te.useCallback(function(ze) {
    j(ze, H);
  }, [H, j]);
  var F = Te.useState({}), z = F[0], W = F[1], U = Te.useCallback(function() {
    return W({});
  }, []), Z = Te.useRef([]), V = Te.useMemo(function() {
    var ze = Z.current.length > 0 ? Math.min.apply(Math, Z.current) : 0;
    Z.current = [];
    for (var ct = N.current.measurements.slice(0, ze), rt = ze; rt < n; rt++) {
      var qe = x(rt), nt = z[qe], Rt = ct[rt - 1] ? ct[rt - 1].end : c, Ot = typeof nt == "number" ? nt : i(rt), lt = Rt + Ot;
      ct[rt] = { index: rt, start: Rt, size: Ot, end: lt, key: qe };
    }
    return ct;
  }, [i, z, c, n, x]), Y = (((e = V[n - 1]) == null ? void 0 : e.end) || c) + f;
  N.current.measurements = V, N.current.totalSize = Y;
  var ge = w ? w.current : h.current, ce = Te.useRef(_);
  ce.current = _, DL(function() {
    if (!ge) {
      v(0);
      return;
    }
    var ze = function(ct) {
      var rt = ce.current ? ce.current(ct) : ge[L];
      v(rt);
    };
    return ze(), ge.addEventListener("scroll", ze, { capture: !1, passive: !0 }), function() {
      ge.removeEventListener("scroll", ze);
    };
  }, [ge, L]);
  var ee = B1r(N.current), Se = ee.start, Ce = ee.end, we = Te.useMemo(function() {
    return M({ start: Se, end: Ce, overscan: s, size: V.length });
  }, [Se, Ce, s, V.length, M]), We = Te.useRef(A);
  We.current = A;
  var Fe = Te.useMemo(function() {
    for (var ze = [], ct = function(nt, Rt) {
      var Ot = we[nt], lt = V[Ot], mt = ab(ab({}, lt), {}, { measureRef: function(jt) {
        if (jt) {
          var Jt = We.current(jt, p);
          if (Jt !== mt.size) {
            var ne = N.current.scrollOffset;
            mt.start < ne && H(ne + (Jt - mt.size)), Z.current.push(Ot), W(function(re) {
              var ie;
              return ab(ab({}, re), {}, (ie = {}, ie[mt.key] = Jt, ie));
            });
          }
        }
      } });
      ze.push(mt);
    }, rt = 0, qe = we.length; rt < qe; rt++) ct(rt);
    return ze;
  }, [we, H, p, V]), it = Te.useRef(!1);
  DL(function() {
    it.current && W({}), it.current = !0;
  }, [i]);
  var gt = Te.useCallback(function(ze, ct) {
    var rt = ct === void 0 ? {} : ct, qe = rt.align, nt = qe === void 0 ? "start" : qe, Rt = N.current, Ot = Rt.scrollOffset, lt = Rt.outerSize;
    nt === "auto" && (ze <= Ot ? nt = "start" : ze >= Ot + lt ? nt = "end" : nt = "start"), nt === "start" ? g(ze) : nt === "end" ? g(ze - lt) : nt === "center" && g(ze - lt / 2);
  }, [g]), Ze = Te.useCallback(function(ze, ct) {
    var rt = ct === void 0 ? {} : ct, qe = rt.align, nt = qe === void 0 ? "auto" : qe, Rt = w1r(rt, ["align"]), Ot = N.current, lt = Ot.measurements, mt = Ot.scrollOffset, jt = Ot.outerSize, Jt = lt[Math.max(0, Math.min(ze, n - 1))];
    if (Jt) {
      if (nt === "auto") if (Jt.end >= mt + jt) nt = "end";
      else if (Jt.start <= mt) nt = "start";
      else return;
      var ne = nt === "center" ? Jt.start + Jt.size / 2 : nt === "end" ? Jt.end : Jt.start;
      gt(ne, ab({ align: nt }, Rt));
    }
  }, [gt, n]), Ne = Te.useCallback(function() {
    for (var ze = arguments.length, ct = new Array(ze), rt = 0; rt < ze; rt++) ct[rt] = arguments[rt];
    Ze.apply(void 0, ct), requestAnimationFrame(function() {
      Ze.apply(void 0, ct);
    });
  }, [Ze]);
  return { virtualItems: Fe, totalSize: Y, scrollToOffset: gt, scrollToIndex: Ne, measure: U };
}
var O1r = function(t, e, r, n) {
  for (; t <= e; ) {
    var a = (t + e) / 2 | 0, i = r(a);
    if (i < n) t = a + 1;
    else if (i > n) e = a - 1;
    else return a;
  }
  return t > 0 ? t - 1 : 0;
};
function B1r(t) {
  for (var e = t.measurements, r = t.outerSize, n = t.scrollOffset, a = e.length - 1, i = function(l) {
    return e[l].start;
  }, o = O1r(0, a, i, n), s = o; s < a && e[s].end < n + r; ) s++;
  return { start: o, end: s };
}
var U7e = yM(n1r()), N1r = yM(p1r()), $1r = (t) => t.map((e, r) => typeof e == "string" ? { label: e, index: r } : { ...e, index: r }), D1r = (t, e) => (0, N1r.default)(t, (r) => typeof r == "string" ? "Uncategorized" : r[e]), L1r = (t, e) => e && t === "inverse" ? "error_inverse" : e ? "error" : t === "inverse" ? "inverse" : "default", j1r = { clip: "rect(0 0 0 0)", height: "1px", margin: "spaceNegative10", overflow: "hidden", padding: "space0", position: "absolute", whiteSpace: "nowrap", width: "1px" }, L9 = P.forwardRef(({ children: t, element: e = "COMBOBOX", groupName: r, groupLabelTemplate: n }, a) => P.createElement(ht, { as: "ul", ref: a, element: `${e}_LIST`, role: r ? "group" : "presentation", "aria-label": r, margin: "space0", padding: "space0", listStyleType: "none", borderBottomStyle: "solid", borderBottomWidth: "borderWidth10", borderBottomColor: "colorBorderWeaker", _last: { borderWidth: "borderWidth0" } }, r ? P.createElement(ht, { as: "li", backgroundColor: "colorBackgroundWeak", borderBottomStyle: "solid", borderBottomWidth: "borderWidth10", borderBottomColor: "colorBorderWeaker", role: "presentation", paddingY: "space30", paddingLeft: "space50", paddingRight: "space50", element: `${e}_GROUPNAME` }, P.createElement(cl, { as: "span", fontSize: "fontSize20", lineHeight: "lineHeight20", fontWeight: "fontWeightSemibold", color: "colorText", element: `${e}_GROUPNAME_TEXT` }, n ? n(r) : r)) : null, t));
L9.displayName = "ComboboxListboxGroup";
var F1r = { groupOption: { paddingLeft: "space90", paddingRight: "space50" }, default: { paddingLeft: "space50", paddingRight: "space50" } }, z1r = (t) => ({ position: "absolute", top: 0, left: 0, width: "100%", transform: `translateY(${t}px)` }), LL = P.forwardRef(({ children: t, element: e = "COMBOBOX", highlighted: r, selected: n, disabled: a = !1, variant: i = "default", startHeight: o, ...s }, l) => {
  let c = o != null ? z1r(o) : {};
  return P.createElement(ht, { role: "option", ...Xt(s), "aria-selected": n, "aria-disabled": a, as: "li", position: "relative", element: `${e}_LIST_ITEM`, backgroundColor: r ? "colorBackgroundPrimaryWeakest" : "colorBackgroundWeaker", color: r || n ? "colorTextPrimary" : "colorText", display: "flex", justifyContent: "space-between", alignItems: "center", paddingY: "space40", cursor: a ? "not-allowed" : "pointer", ref: l, transition: "background-color 150ms ease, color 150ms ease", borderBottomWidth: "borderWidth10", borderBottomColor: "colorBorderWeaker", borderBottomStyle: "solid", opacity: a ? 0.3 : 1, _before: { content: '""', position: "absolute", top: 0, bottom: 0, left: 0, borderLeftWidth: "borderWidth20", borderLeftColor: r ? "colorBorderPrimary" : "transparent", borderLeftStyle: "solid" }, _last: { borderBottomColor: "transparent" }, ...c, ...F1r[i] }, P.createElement(ht, { as: "span" }, P.createElement(cl, { as: "span", color: "inherit", element: `${e}_LIST_ITEM_TEXT` }, t)), P.createElement(ht, { as: "span", hidden: !n }, P.createElement(Zpe, { decorative: !0, color: "inherit" })));
});
LL.displayName = "ComboboxListboxOption";
var ome = P.memo(P.forwardRef(({ items: t, element: e = "COMBOBOX", getItemProps: r, highlightedIndex: n, selectedItems: a, disabledItems: i, optionTemplate: o, groupLabelTemplate: s, groupItemsBy: l, totalSize: c, virtualItems: u, emptyState: f }, h) => {
  let p = P.useMemo(() => o != null && typeof o == "function" ? t.map((b) => o(b)) : t, [JSON.stringify(t), o]);
  if (l == null) return u.length === 0 && f != null ? P.createElement(L9, { element: e, ref: h }, P.createElement(ht, { as: "li", role: "option", position: "relative", element: `${e}_EMPTY_STATE`, backgroundColor: "colorBackgroundBody", color: "colorText" }, P.createElement(f, null))) : P.createElement(L9, { element: e, ref: h }, P.createElement("li", { role: "presentation", key: "total-size", style: { margin: 0, height: c } }), u.map(({ measureRef: b, index: w, start: _ }) => {
    let C = p[w], x = i != null && i.includes(t[w]);
    return P.createElement(LL, { ...r({ item: C, index: w, ref: b, disabled: x }), key: w, element: e, highlighted: n === w, selected: a == null ? void 0 : a.includes(t[w]), disabled: x, variant: "default", startHeight: _, "aria-setsize": t.length, "aria-posinset": w + 1 }, C);
  }));
  let g = P.useMemo(() => {
    let b = $1r(t);
    return D1r(b, l);
  }, [t, l]), y = Object.keys(g);
  return y.length === 0 && f != null ? P.createElement(L9, { element: e, ref: h }, P.createElement(ht, { as: "li", role: "option", position: "relative", element: `${e}_EMPTY_STATE`, backgroundColor: "colorBackgroundBody", color: "colorText" }, P.createElement(f, null))) : P.createElement(P.Fragment, null, y.map((b) => {
    let w = b === "undefined", _ = w ? "$$$Uncategorized$$$" : b;
    return P.createElement(L9, { element: e, key: _, groupName: w ? void 0 : _, groupLabelTemplate: s }, g[b].map(({ index: C, ...x }) => {
      let S = i != null && (0, U7e.default)(i, x);
      return P.createElement(LL, { ...r({ item: x, index: C, disabled: S }), element: e, highlighted: n === C, selected: (0, U7e.default)(a, x) != null, disabled: S, key: C, variant: w ? "default" : "groupOption" }, o ? o(x) : x);
    }));
  }));
}));
ome.displayName = "ComboboxItems";
function G1r(t, e) {
  let r = Y3.get(t);
  return r === void 0 ? (Y3.set(t, { rect: {}, callbacks: [e] }), Y3.size === 1 && (zue = requestAnimationFrame(ott))) : (r.callbacks.push(e), e(t.getBoundingClientRect())), () => {
    let n = Y3.get(t);
    if (n === void 0) return;
    let a = n.callbacks.indexOf(e);
    a > -1 && n.callbacks.splice(a, 1), n.callbacks.length === 0 && (Y3.delete(t), Y3.size === 0 && cancelAnimationFrame(zue));
  };
}
var zue, Y3 = /* @__PURE__ */ new Map();
function ott() {
  let t = [];
  Y3.forEach((e, r) => {
    let n = r.getBoundingClientRect();
    W1r(e.rect, n) || (e.rect = n, t.push(e));
  }), t.forEach((e) => {
    e.callbacks.forEach((r) => r(e.rect));
  }), zue = requestAnimationFrame(ott);
}
function W1r(t, e) {
  return t.width === e.width && t.height === e.height && t.top === e.top && t.right === e.right && t.bottom === e.bottom && t.left === e.left;
}
function V7e(t) {
  let [e, r] = Yt();
  return Ut(() => {
    if (t) {
      let n = G1r(t, r);
      return () => {
        r(void 0), n();
      };
    }
  }, [t]), e;
}
var stt = ({ inputBoxRef: t, dropdownBoxRef: e, ...r }) => {
  var s;
  let { height: n } = O8(), a = V7e(t.current), i = (s = V7e(e.current)) == null ? void 0 : s.height, o = P.useMemo(() => {
    if (i == null || a == null || i === 0) return {};
    if (n) {
      if (i >= n) return { position: "fixed", top: 0, left: a == null ? void 0 : a.left, right: a == null ? void 0 : a.right, width: a == null ? void 0 : a.width };
      if (i + (a == null ? void 0 : a.bottom) >= n && (a == null ? void 0 : a.top) - i > 0) return { position: "fixed", top: (a == null ? void 0 : a.top) - i - 6, left: a == null ? void 0 : a.left, right: a == null ? void 0 : a.right, width: a == null ? void 0 : a.width };
    }
    return { position: "fixed", top: a == null ? void 0 : a.bottom, left: a == null ? void 0 : a.left, right: a == null ? void 0 : a.right, width: a == null ? void 0 : a.width };
  }, [a, i, n]);
  return P.createElement(ht, { ...r, ...o, zIndex: "zIndex90" });
};
stt.displayName = "ListBoxPositioner";
var sme = ({ inputBoxRef: t, parentRef: e, usePortal: r, children: n }) => r ? P.createElement(Vm, null, P.createElement(stt, { inputBoxRef: t, dropdownBoxRef: e }, n)) : P.createElement(ht, { position: "absolute", top: "100%", width: "100%" }, n);
sme.displayName = "ListboxWrapper";
var ltt = P.forwardRef(({ ...t }, e) => P.createElement(vM, { paddingRight: t.autocomplete ? void 0 : "space100", cursor: t.autocomplete ? void 0 : "pointer", readOnly: !t.autocomplete, type: "text", ref: e, ...t }));
ltt.displayName = "ComboboxInputSelect";
var ctt = P.forwardRef(({ children: t, ...e }, r) => P.createElement(ht, { ...Xt(e), ref: r, display: "flex", position: "relative", width: "100%" }, t));
ctt.displayName = "ComboboxInputWrapper";
var kG = P.forwardRef(({ children: t, element: e = "COMBOBOX_LISTBOX", hidden: r, ...n }, a) => r ? P.createElement(ht, { ...Xt(n), appearance: "none", ref: a }) : P.createElement(ht, { ...Xt(n), as: "div", backgroundColor: "colorBackgroundWeaker", borderRadius: "borderRadius20", boxShadow: "shadowElevation10", element: e, listStyleType: "none", margin: "space0", overflowY: "auto", padding: "space0", position: "absolute", width: "100%", maxHeight: "size30", zIndex: "zIndex20", marginTop: "space20", ref: a }, t));
kG.displayName = "ComboboxListbox";
var H1r = yM(ntt()), U1r = ({ onInputValueChange: t, onIsOpenChange: e, onSelectedItemChange: r, onHighlightedIndexChange: n, itemToString: a, initialIsOpen: i, inputValue: o, selectedItem: s, initialSelectedItem: l, items: c, getA11yStatusMessage: u, getA11ySelectionMessage: f, disabledItems: h }) => a1({ initialSelectedItem: l, items: c, stateReducer: (p, g) => h != null && h.includes(g.changes.selectedItem) ? p : g.changes, onHighlightedIndexChange: P.useCallback((p) => {
  n && n(p);
}, [n]), onInputValueChange: t, onIsOpenChange: e, onSelectedItemChange: r, ...a != null && { itemToString: a }, ...i != null && { initialIsOpen: i }, ...o != null && { defaultInputValue: o }, ...s != null && { selectedItem: s }, ...u != null && { getA11yStatusMessage: u }, ...f != null && { getA11ySelectionMessage: f } }), V1r = ({ state: t, ...e }) => t != null && !(0, H1r.default)(t) ? t : U1r(e), q1r = (t, e) => e && t === "inverse" ? "error_inverse" : e ? "error" : t === "inverse" ? "inverse" : "default", utt = P.forwardRef(({ usePortal: t = !0, autocomplete: e, disabled: r, element: n = "COMBOBOX", hasError: a, hideVisibleLabel: i, helpText: o, initialSelectedItem: s, disabledItems: l, initialIsOpen: c, inputValue: u, insertAfter: f, insertBefore: h, items: p, itemToString: g, labelText: y, onInputValueChange: b, onSelectedItemChange: w, optionTemplate: _, onHighlightedIndexChange: C, onIsOpenChange: x, required: S, selectedItem: A, groupItemsBy: I, groupLabelTemplate: M, variant: B = "default", emptyState: L, getA11yStatusMessage: N, getA11ySelectionMessage: d, state: m, ...v }, k) => {
  let O = P.useRef(null), G = Jr(), { width: H } = O8(), j = P.useRef(null), { getComboboxProps: F, getInputProps: z, getItemProps: W, getLabelProps: U, getMenuProps: Z, getToggleButtonProps: V, highlightedIndex: Y, selectedItem: ge, isOpen: ce } = V1r({ onInputValueChange: b, onIsOpenChange: x, onSelectedItemChange: w, onHighlightedIndexChange: C, itemToString: g, initialIsOpen: c, inputValue: u, selectedItem: A, initialSelectedItem: s, items: p, state: m, getA11yStatusMessage: N, getA11ySelectionMessage: d, disabledItems: l });
  if (F === void 0 || z === void 0 || W === void 0 || U === void 0 || Z === void 0 || V === void 0 || Y === void 0 || ce === void 0) throw new Error("[Combobox]: One of getComboboxProps, getInputProps, getItemProps, getLabelProps, getMenuProps, getToggleButtonProps, highlightedIndex or isOpen is missing from the state object. Please make sure this is provided.");
  let ee = itt({ size: p.length, parentRef: O, overscan: 8 });
  P.useEffect(() => {
    ee.measure();
  }, [H]);
  let Se = P.useCallback((Ce) => {
    Ce && ee.scrollToIndex(p.indexOf(ge));
  }, [p, ge]);
  return P.createElement(ht, { position: "relative", element: `${n}_WRAPPER` }, P.createElement(ht, { ...i && { ...j1r } }, P.createElement(P8, { disabled: r, required: S, variant: B, ...U() }, y)), P.createElement(M8, { disabled: r, element: n, hasError: a, insertBefore: h, insertAfter: f, variant: B, ref: j }, P.createElement(ctt, { ...F({ role: "combobox" }) }, P.createElement(ltt, { ...V({ tabIndex: 0 }), ...z({ disabled: r, required: S, ref: k, ...v }), ...e ? void 0 : { onChange: (Ce) => Ce.preventDefault() }, autocomplete: e, "aria-describedby": o != null ? G : null, element: `${n}_ELEMENT`, textOverflow: "ellipsis" }), !e && P.createElement(sG, { element: `${n}_CHEVRON_WRAPPER` }, P.createElement(I8, { decorative: !0, color: Gpe(B, r, !1), size: "sizeIcon30" })))), P.createElement(sme, { inputBoxRef: j, parentRef: O, usePortal: t }, P.createElement(kG, { hidden: !ce, element: `${n}_LISTBOX`, ...Z({ ref: O }) }, P.createElement(ome, { ref: Se, items: p, element: n, getItemProps: W, highlightedIndex: Y, disabledItems: l, optionTemplate: _, groupItemsBy: I, groupLabelTemplate: M, totalSize: ee.totalSize, virtualItems: ee.virtualItems, emptyState: L }))), o && P.createElement(w5, { id: G, variant: q1r(B, a) }, o));
});
utt.displayName = "Combobox";
var q7e = yM(C1r()), dtt = P.forwardRef(({ element: t = "GROWING_INPUT", onChange: e, initialValue: r = "", value: n, placeholder: a = "", ...i }, o) => {
  let [s, l] = P.useState(n || r);
  return P.useEffect(() => {
    l(n || "");
  }, [n]), P.createElement(ht, { element: `${t}_CONTAINER`, display: "inline-grid", gridTemplateColumns: "min-content", maxWidth: "100%", overflow: "hidden", height: "28px", alignContent: "center", _after: { content: `"${s || a || ""}"`, fontFamily: "inherit", fontSize: "fontSize30", fontWeight: "fontWeightMedium", paddingX: "space40", visibility: "hidden", height: "size0", whiteSpace: "nowrap" } }, P.createElement(vM, { ...i, ref: o, element: t, type: "text", value: n != null ? n.replace(/  +/g, " ") : s, placeholder: a, padding: "space0", onChange: (c) => {
    c.preventDefault(), l(c.currentTarget.value.replace(/  +/g, " ")), e == null || e(c);
  } }));
});
dtt.displayName = "GrowingInput";
var K1r = yM(ntt()), Z1r = ({ state: t, initialSelectedItems: e, onSelectedItemsChange: r }) => t != null && !(0, K1r.default)(t) ? t : zpe({ initialSelectedItems: e, onSelectedItemsChange: r }), ftt = P.forwardRef(({ usePortal: t = !0, element: e = "MULTISELECT_COMBOBOX", disabled: r, hasError: n, helpText: a, state: i, initialSelectedItems: o = [], disabledItems: s, inputValue: l, placeholder: c, insertAfter: u, insertBefore: f, items: h, itemToString: p = (k) => k ? k.toString() : "", labelText: g, optionTemplate: y, required: b, variant: w = "default", initialIsOpen: _, onHighlightedIndexChange: C, onInputValueChange: x, onSelectedItemsChange: S, onIsOpenChange: A, groupItemsBy: I, groupLabelTemplate: M, emptyState: B, maxHeight: L = "100%", selectedItemsLabelText: N, i18nKeyboardControls: d = "Press Delete or Backspace to remove. Press Enter to toggle selection.", ...m }, v) => {
  let k = Jr(), O = Jr(), G = Oet(), H = P.useRef(null), { width: j } = O8(), F = P.useRef(null), z = P.useCallback((rt) => {
    S && S(rt.selectedItems);
  }, [S]), { getDropdownProps: W, removeSelectedItem: U, addSelectedItem: Z, selectedItems: V } = Z1r({ state: i, initialSelectedItems: o, onSelectedItemsChange: z }), { isOpen: Y, getToggleButtonProps: ge, getLabelProps: ce, getMenuProps: ee, getInputProps: Se, getComboboxProps: Ce, getItemProps: we, highlightedIndex: We } = a1({ items: h, itemToString: p, selectedItem: null, defaultInputValue: l, onInputValueChange: x, onHighlightedIndexChange: C, onIsOpenChange: A, initialIsOpen: _, stateReducer(rt, qe) {
    let { changes: nt, type: Rt } = qe;
    switch (Rt) {
      case a1.stateChangeTypes.InputKeyDownEnter:
      case a1.stateChangeTypes.ItemClick:
      case a1.stateChangeTypes.InputBlur:
        return { ...nt, ...nt.selectedItem != null ? { isOpen: !0, highlightedIndex: h.indexOf(nt.selectedItem), inputValue: "" } : {} };
      case a1.stateChangeTypes.MenuMouseLeave:
        return { ...nt, highlightedIndex: -2 };
      case a1.stateChangeTypes.ControlledPropUpdatedSelectedItem:
        return { ...nt, inputValue: l };
    }
    return nt;
  }, onStateChange({ type: rt, selectedItem: qe }) {
    switch (rt) {
      case a1.stateChangeTypes.InputKeyDownEnter:
      case a1.stateChangeTypes.ItemClick:
        if (qe) {
          if (s != null && (0, q7e.default)(s, qe)) return;
          (0, q7e.default)(V, qe) ? U(qe) : Z(qe);
        }
        break;
    }
  } }), Fe = P.useMemo(() => h.length, [h]), it = itt({ size: Fe, parentRef: H, overscan: 8 });
  P.useEffect(() => {
    it.measure();
  }, [j]);
  let gt = P.useCallback((rt) => {
    if (rt != null) {
      if (We === -1) {
        let qe = V[V.length - 1];
        it.scrollToIndex(h.indexOf(qe));
      }
      We === 0 && it.scrollToIndex(0), We === Fe - 1 && it.scrollToIndex(Fe - 1);
    }
  }, [h, V, We]), { onKeyDown: Ze } = m, Ne = P.useCallback((rt) => {
    rt.code === "Enter" && b && V.length === 0 && rt.preventDefault(), Ze == null || Ze(rt);
  }, [b, V, Ze]), ze = Ce({ disabled: r, role: "combobox" }), ct = ze["aria-expanded"] || "false";
  return P.createElement(ht, { position: "relative", element: `${e}_WRAPPER` }, P.createElement(P8, { disabled: r, required: b, variant: w, ...ce() }, g), P.createElement(M8, { disabled: r, hasError: n, element: e, insertBefore: f, insertAfter: u, variant: w, ref: F }, P.createElement(ht, { ...ge({ disabled: r }), ...ze, "aria-expanded": ct, position: "relative", width: "100%", lineHeight: "lineHeight50", paddingY: "space20", paddingLeft: "space40", paddingRight: "space100", maxHeight: L, overflowY: "auto", display: "flex", alignItems: "center", flexDirection: "row", flexWrap: "wrap", columnGap: "space20" }, P.createElement(Ype, { ...G, element: `${e}_PILL_GROUP`, display: "flex", "aria-label": N, "aria-describedby": k, i18nKeyboardControls: "" }, V.map(function(rt) {
    let qe = I != null && typeof rt != "string" ? `${rt[I]}-${p(rt)}` : p(rt);
    return P.createElement(gG, { variant: n ? "error" : "default", element: `${e}_PILL`, key: qe, disabled: r, onDismiss: r ? void 0 : (nt) => {
      U(rt), nt.stopPropagation();
    }, onSelect: (nt) => nt.stopPropagation(), ...G }, p(rt));
  })), P.createElement(dtt, { ...Se({ ...W({ ref: v, preventKeyAction: Y }), ...m, disabled: r, onKeyDown: Ne }), placeholder: V.length === 0 ? c : "", "aria-describedby": O, element: `${e}_ELEMENT` }), P.createElement(sG, { element: `${e}_CHEVRON_WRAPPER` }, P.createElement(I8, { decorative: !0, color: Gpe("default", !1, !1), size: "sizeIcon30" })))), P.createElement(sme, { inputBoxRef: F, parentRef: H, usePortal: t }, P.createElement(kG, { ...ee({ ref: H }), element: `${e}_LISTBOX`, hidden: !Y, "aria-multiselectable": "true" }, P.createElement(ome, { ref: gt, items: h, element: e, getItemProps: we, highlightedIndex: We, selectedItems: V, disabledItems: s, totalSize: it.totalSize, virtualItems: it.virtualItems, optionTemplate: y, groupItemsBy: I, groupLabelTemplate: M, emptyState: B }))), a && P.createElement(w5, { id: O, variant: L1r(w, n), element: `${e}_HELP_TEXT` }, a), P.createElement(Ul, { id: k }, d));
});
ftt.displayName = "MultiselectCombobox";
const J1r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Combobox: utt,
  ComboboxListbox: kG,
  ComboboxListboxGroup: L9,
  ComboboxListboxOption: LL,
  MultiselectCombobox: ftt,
  useCombobox: a1,
  useMultiselectCombobox: zpe
}, Symbol.toStringTag, { value: "Module" })), Y1r = /* @__PURE__ */ aa(J1r);
var K7e;
function X1r() {
  return K7e || (K7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Y1r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(yZ)), yZ;
}
var htt = /* @__PURE__ */ X1r();
const Q1r = () => /* @__PURE__ */ R.jsx(tWe, { children: /* @__PURE__ */ R.jsxs(s5t, { orientation: "vertical", spacing: "space60", children: [
  /* @__PURE__ */ R.jsx(i7, {}),
  /* @__PURE__ */ R.jsx(i7, {}),
  /* @__PURE__ */ R.jsx(i7, {})
] }) });
var xZ = {}, ptt = P.forwardRef(({ children: t, element: e = "PARAGRAPH", marginBottom: r, ...n }, a) => P.createElement(cl, { ...lg(n), as: "p", color: "colorText", element: e, fontSize: "fontSize30", fontWeight: "fontWeightNormal", lineHeight: "lineHeight40", marginBottom: r || "space70", ref: a }, t));
ptt.displayName = "Paragraph";
const e2r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Paragraph: ptt
}, Symbol.toStringTag, { value: "Module" })), t2r = /* @__PURE__ */ aa(e2r);
var Z7e;
function r2r() {
  return Z7e || (Z7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = t2r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(xZ)), xZ;
}
var Ly = /* @__PURE__ */ r2r(), CZ = {};
const n2r = /* @__PURE__ */ aa(qrr);
var J7e;
function a2r() {
  return J7e || (J7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = n2r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(CZ)), CZ;
}
var zi = /* @__PURE__ */ a2r();
const i2r = {
  PROMPT_LIBRARY_TRIGGER: "PROMPT_LIBRARY_TRIGGER"
}, wZ = {
  heading: "No saved prompts yet",
  text: {
    getStarted: "To get started",
    link: "create a saved prompt."
  }
};
var SZ = {}, mtt = P.forwardRef(({ children: t, element: e = "CARD", padding: r = "space100", paddingBottom: n, paddingLeft: a, paddingRight: i, paddingTop: o, ...s }, l) => P.createElement(ht, { ...Xt(s), ref: l, as: "article", borderWidth: "borderWidth10", borderColor: "colorBorderWeaker", borderStyle: "solid", borderRadius: "borderRadius30", element: e, padding: r, paddingBottom: n, paddingLeft: a, paddingRight: i, paddingTop: o, backgroundColor: "colorBackgroundWeakest" }, t));
mtt.displayName = "Card";
const o2r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Card: mtt
}, Symbol.toStringTag, { value: "Module" })), s2r = /* @__PURE__ */ aa(o2r);
var Y7e;
function l2r() {
  return Y7e || (Y7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = s2r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(SZ)), SZ;
}
var vh = /* @__PURE__ */ l2r(), _Z = {};
function c2r(t, e) {
  switch (t) {
    case "heading10":
      return { marginBottom: e || "space70", fontSize: "fontSize90", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight90", letterSpacing: "-.02em" };
    case "heading30":
      return { marginBottom: e || "space50", fontSize: "fontSize60", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight60", letterSpacing: "-.02em" };
    case "heading40":
      return { marginBottom: e || "space30", fontSize: "fontSize40", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight40", letterSpacing: "-.02em" };
    case "heading50":
      return { marginBottom: e || "space30", fontSize: "fontSize30", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight30", letterSpacing: "-.02em" };
    case "heading60":
      return { marginBottom: e || "space30", fontSize: "fontSize20", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight20", letterSpacing: "-.02em" };
    case "heading20":
    default:
      return { marginBottom: e || "space60", fontSize: "fontSize70", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight70", letterSpacing: "-.02em" };
  }
}
var $8 = P.forwardRef(({ as: t, children: e, display: r = "block", element: n = "HEADING", id: a, marginBottom: i, variant: o, ...s }, l) => P.createElement(cl, { ...lg(s), ...c2r(o, i), as: t, display: r, element: n, id: a, color: "colorText", variant: o, ref: l }, e));
$8.displayName = "Heading";
const u2r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Heading: $8
}, Symbol.toStringTag, { value: "Module" })), d2r = /* @__PURE__ */ aa(u2r);
var X7e;
function f2r() {
  return X7e || (X7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = d2r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(_Z)), _Z;
}
var hy = /* @__PURE__ */ f2r(), kZ = {};
const h2r = /* @__PURE__ */ aa(Inr);
var Q7e;
function p2r() {
  return Q7e || (Q7e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = h2r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(kZ)), kZ;
}
var pf = /* @__PURE__ */ p2r(), AG = /* @__PURE__ */ ((t) => (t.celebration = "celebration", t.create = "create", t.dependency = "dependency", t.noData = "noData", t.noResults = "noResults", t.oops = "oops", t.unauthorized = "unauthorized", t))(AG || {}), jL = /* @__PURE__ */ ((t) => (t.horizontal = "horizontal", t.vertical = "vertical", t))(jL || {});
const m2r = "_emptyStateContainerHorizontal_5t59e_1", g2r = "_emptyStateContainerVertical_5t59e_8", v2r = "_emptyStateImageContainer_5t59e_16", y2r = "_emptyStateImage_5t59e_16", b2r = "_emptyStateRenderContainer_5t59e_26", Xw = {
  emptyStateContainerHorizontal: m2r,
  emptyStateContainerVertical: g2r,
  emptyStateImageContainer: v2r,
  emptyStateImage: y2r,
  emptyStateRenderContainer: b2r
}, lme = ({
  borderless: t,
  children: e,
  description: r,
  heading: n,
  imageWidth: a = "15rem",
  maxWidth: i = "40rem",
  orientation: o = jL.horizontal,
  variant: s
}) => {
  const l = o === jL.horizontal, c = () => /* @__PURE__ */ R.jsxs(
    ar.Box,
    {
      as: "article",
      className: l ? Xw.emptyStateContainerHorizontal : Xw.emptyStateContainerVertical,
      maxWidth: i,
      children: [
        /* @__PURE__ */ R.jsx(
          ar.Box,
          {
            as: "div",
            className: Xw.emptyStateImageContainer,
            width: a,
            children: /* @__PURE__ */ R.jsx(
              ar.Box,
              {
                as: "img",
                className: Xw.emptyStateImage,
                alt: `${s} image`,
                width: a
              }
            )
          }
        ),
        /* @__PURE__ */ R.jsxs(ar.Box, { flex: "1", children: [
          n && /* @__PURE__ */ R.jsx(hy.Heading, { as: "h3", variant: "heading30", children: n }),
          /* @__PURE__ */ R.jsx(pf.Text, { as: "p", dangerouslySetInnerHTML: { __html: r } }),
          e && /* @__PURE__ */ R.jsx(ar.Box, { className: Xw.emptyStateRenderContainer, children: e })
        ] })
      ]
    }
  );
  return t ? c() : /* @__PURE__ */ R.jsx(vh.Card, { children: c() });
}, x2r = ({
  handleChatButtonToolClick: t
}) => {
  const e = () => {
    t && t(i2r.PROMPT_LIBRARY_TRIGGER);
  };
  return /* @__PURE__ */ R.jsx(
    lme,
    {
      variant: AG.create,
      heading: wZ.heading,
      description: "",
      children: /* @__PURE__ */ R.jsxs(Ly.Paragraph, { children: [
        wZ.text.getStarted,
        " ",
        /* @__PURE__ */ R.jsx(zi.Button, { variant: "link", onClick: e, children: wZ.text.link })
      ] })
    }
  );
};
var io;
(function(t) {
  t.assertEqual = (a) => a;
  function e(a) {
  }
  t.assertIs = e;
  function r(a) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (a) => {
    const i = {};
    for (const o of a)
      i[o] = o;
    return i;
  }, t.getValidEnumValues = (a) => {
    const i = t.objectKeys(a).filter((s) => typeof a[a[s]] != "number"), o = {};
    for (const s of i)
      o[s] = a[s];
    return t.objectValues(o);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(i) {
    return a[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const i = [];
    for (const o in a)
      Object.prototype.hasOwnProperty.call(a, o) && i.push(o);
    return i;
  }, t.find = (a, i) => {
    for (const o of a)
      if (i(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && isFinite(a) && Math.floor(a) === a;
  function n(a, i = " | ") {
    return a.map((o) => typeof o == "string" ? `'${o}'` : o).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (a, i) => typeof i == "bigint" ? i.toString() : i;
})(io || (io = {}));
var Gue;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Gue || (Gue = {}));
const An = io.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), dm = (t) => {
  switch (typeof t) {
    case "undefined":
      return An.undefined;
    case "string":
      return An.string;
    case "number":
      return isNaN(t) ? An.nan : An.number;
    case "boolean":
      return An.boolean;
    case "function":
      return An.function;
    case "bigint":
      return An.bigint;
    case "symbol":
      return An.symbol;
    case "object":
      return Array.isArray(t) ? An.array : t === null ? An.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? An.promise : typeof Map < "u" && t instanceof Map ? An.map : typeof Set < "u" && t instanceof Set ? An.set : typeof Date < "u" && t instanceof Date ? An.date : An.object;
    default:
      return An.unknown;
  }
}, Gr = io.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), C2r = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class s0 extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, a = (i) => {
      for (const o of i.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(a);
        else if (o.code === "invalid_return_type")
          a(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          a(o.argumentsError);
        else if (o.path.length === 0)
          n._errors.push(r(o));
        else {
          let s = n, l = 0;
          for (; l < o.path.length; ) {
            const c = o.path[l];
            l === o.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(r(o))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
          }
        }
    };
    return a(this), n;
  }
  static assert(e) {
    if (!(e instanceof s0))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, io.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const a of this.issues)
      a.path.length > 0 ? (r[a.path[0]] = r[a.path[0]] || [], r[a.path[0]].push(e(a))) : n.push(e(a));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
s0.create = (t) => new s0(t);
const xx = (t, e) => {
  let r;
  switch (t.code) {
    case Gr.invalid_type:
      t.received === An.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Gr.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, io.jsonStringifyReplacer)}`;
      break;
    case Gr.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${io.joinValues(t.keys, ", ")}`;
      break;
    case Gr.invalid_union:
      r = "Invalid input";
      break;
    case Gr.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${io.joinValues(t.options)}`;
      break;
    case Gr.invalid_enum_value:
      r = `Invalid enum value. Expected ${io.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Gr.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Gr.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Gr.invalid_date:
      r = "Invalid date";
      break;
    case Gr.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : io.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Gr.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Gr.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Gr.custom:
      r = "Invalid input";
      break;
    case Gr.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Gr.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Gr.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, io.assertNever(t);
  }
  return { message: r };
};
let gtt = xx;
function w2r(t) {
  gtt = t;
}
function FL() {
  return gtt;
}
const zL = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: a } = t, i = [...r, ...a.path || []], o = {
    ...a,
    path: i
  };
  if (a.message !== void 0)
    return {
      ...a,
      path: i,
      message: a.message
    };
  let s = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    s = c(o, { data: e, defaultError: s }).message;
  return {
    ...a,
    path: i,
    message: s
  };
}, S2r = [];
function fn(t, e) {
  const r = FL(), n = zL({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === xx ? void 0 : xx
      // then global default map
    ].filter((a) => !!a)
  });
  t.common.issues.push(n);
}
class Qc {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const a of r) {
      if (a.status === "aborted")
        return Ra;
      a.status === "dirty" && e.dirty(), n.push(a.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const a of r) {
      const i = await a.key, o = await a.value;
      n.push({
        key: i,
        value: o
      });
    }
    return Qc.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const a of r) {
      const { key: i, value: o } = a;
      if (i.status === "aborted" || o.status === "aborted")
        return Ra;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof o.value < "u" || a.alwaysSet) && (n[i.value] = o.value);
    }
    return { status: e.value, value: n };
  }
}
const Ra = Object.freeze({
  status: "aborted"
}), j9 = (t) => ({ status: "dirty", value: t }), Nu = (t) => ({ status: "valid", value: t }), Wue = (t) => t.status === "aborted", Hue = (t) => t.status === "dirty", S5 = (t) => t.status === "valid", qT = (t) => typeof Promise < "u" && t instanceof Promise;
function GL(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function vtt(t, e, r, n, a) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var zn;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(zn || (zn = {}));
var e_, t_;
class zh {
  constructor(e, r, n, a) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = a;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const exe = (t, e) => {
  if (S5(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new s0(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function mi(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: a } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: a } : { errorMap: (o, s) => {
    var l, c;
    const { message: u } = t;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError };
  }, description: a };
}
class Ri {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return dm(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: dm(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new Qc(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: dm(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (qT(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const a = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dm(e)
    }, i = this._parseSync({ data: e, path: a.path, parent: a });
    return exe(a, i);
  }
  "~validate"(e) {
    var r, n;
    const a = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dm(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: a });
        return S5(i) ? {
          value: i.value
        } : {
          issues: a.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), a.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: a }).then((i) => S5(i) ? {
      value: i.value
    } : {
      issues: a.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: dm(e)
    }, a = this._parse({ data: e, path: n.path, parent: n }), i = await (qT(a) ? a : Promise.resolve(a));
    return exe(n, i);
  }
  refine(e, r) {
    const n = (a) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(a) : r;
    return this._refinement((a, i) => {
      const o = e(a), s = () => i.addIssue({
        code: Gr.custom,
        ...n(a)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((l) => l ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, a) => e(n) ? !0 : (a.addIssue(typeof r == "function" ? r(n, a) : r), !1));
  }
  _refinement(e) {
    return new q1({
      schema: this,
      typeName: wa.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return yh.create(this, this._def);
  }
  nullable() {
    return vy.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return P1.create(this);
  }
  promise() {
    return wx.create(this, this._def);
  }
  or(e) {
    return YT.create([this, e], this._def);
  }
  and(e) {
    return XT.create(this, e, this._def);
  }
  transform(e) {
    return new q1({
      ...mi(this._def),
      schema: this,
      typeName: wa.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new nE({
      ...mi(this._def),
      innerType: this,
      defaultValue: r,
      typeName: wa.ZodDefault
    });
  }
  brand() {
    return new cme({
      typeName: wa.ZodBranded,
      type: this,
      ...mi(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new aE({
      ...mi(this._def),
      innerType: this,
      catchValue: r,
      typeName: wa.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return CM.create(this, e);
  }
  readonly() {
    return iE.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const _2r = /^c[^\s-]{8,}$/i, k2r = /^[0-9a-z]+$/, A2r = /^[0-9A-HJKMNP-TV-Z]{26}$/i, T2r = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, E2r = /^[a-z0-9_-]{21}$/i, I2r = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, M2r = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, P2r = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, R2r = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let AZ;
const O2r = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, B2r = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, N2r = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, $2r = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, D2r = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, L2r = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, ytt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", j2r = new RegExp(`^${ytt}$`);
function btt(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function F2r(t) {
  return new RegExp(`^${btt(t)}$`);
}
function xtt(t) {
  let e = `${ytt}T${btt(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function z2r(t, e) {
  return !!((e === "v4" || !e) && O2r.test(t) || (e === "v6" || !e) && N2r.test(t));
}
function G2r(t, e) {
  if (!I2r.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), a = JSON.parse(atob(n));
    return !(typeof a != "object" || a === null || !a.typ || !a.alg || e && a.alg !== e);
  } catch {
    return !1;
  }
}
function W2r(t, e) {
  return !!((e === "v4" || !e) && B2r.test(t) || (e === "v6" || !e) && $2r.test(t));
}
class b1 extends Ri {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== An.string) {
      const i = this._getOrReturnCtx(e);
      return fn(i, {
        code: Gr.invalid_type,
        expected: An.string,
        received: i.parsedType
      }), Ra;
    }
    const n = new Qc();
    let a;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (a = this._getOrReturnCtx(e, a), fn(a, {
          code: Gr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (a = this._getOrReturnCtx(e, a), fn(a, {
          code: Gr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const o = e.data.length > i.value, s = e.data.length < i.value;
        (o || s) && (a = this._getOrReturnCtx(e, a), o ? fn(a, {
          code: Gr.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : s && fn(a, {
          code: Gr.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        P2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "email",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        AZ || (AZ = new RegExp(R2r, "u")), AZ.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "emoji",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        T2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "uuid",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        E2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "nanoid",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        _2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "cuid",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        k2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "cuid2",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        A2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
          validation: "ulid",
          code: Gr.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          a = this._getOrReturnCtx(e, a), fn(a, {
            validation: "url",
            code: Gr.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "regex",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? xtt(i).test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? j2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? F2r(i).test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? M2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "duration",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? z2r(e.data, i.version) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "ip",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? G2r(e.data, i.alg) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "jwt",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? W2r(e.data, i.version) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "cidr",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? D2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "base64",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? L2r.test(e.data) || (a = this._getOrReturnCtx(e, a), fn(a, {
        validation: "base64url",
        code: Gr.invalid_string,
        message: i.message
      }), n.dirty()) : io.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((a) => e.test(a), {
      validation: r,
      code: Gr.invalid_string,
      ...zn.errToObj(n)
    });
  }
  _addCheck(e) {
    return new b1({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...zn.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...zn.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...zn.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...zn.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...zn.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...zn.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...zn.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...zn.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...zn.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...zn.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...zn.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...zn.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...zn.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...zn.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...zn.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...zn.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...zn.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...zn.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...zn.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...zn.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...zn.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...zn.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...zn.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, zn.errToObj(e));
  }
  trim() {
    return new b1({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new b1({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new b1({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
b1.create = (t) => {
  var e;
  return new b1({
    checks: [],
    typeName: wa.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...mi(t)
  });
};
function H2r(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, a = r > n ? r : n, i = parseInt(t.toFixed(a).replace(".", "")), o = parseInt(e.toFixed(a).replace(".", ""));
  return i % o / Math.pow(10, a);
}
class py extends Ri {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== An.number) {
      const i = this._getOrReturnCtx(e);
      return fn(i, {
        code: Gr.invalid_type,
        expected: An.number,
        received: i.parsedType
      }), Ra;
    }
    let n;
    const a = new Qc();
    for (const i of this._def.checks)
      i.kind === "int" ? io.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), a.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? H2r(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.not_finite,
        message: i.message
      }), a.dirty()) : io.assertNever(i);
    return { status: a.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, zn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, zn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, zn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, zn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new py({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: zn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new py({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: zn.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: zn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: zn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: zn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: zn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: zn.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: zn.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: zn.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: zn.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && io.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
py.create = (t) => new py({
  checks: [],
  typeName: wa.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...mi(t)
});
class my extends Ri {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== An.bigint)
      return this._getInvalidInput(e);
    let n;
    const a = new Qc();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), a.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), fn(n, {
        code: Gr.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), a.dirty()) : io.assertNever(i);
    return { status: a.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return fn(r, {
      code: Gr.invalid_type,
      expected: An.bigint,
      received: r.parsedType
    }), Ra;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, zn.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, zn.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, zn.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, zn.toString(r));
  }
  setLimit(e, r, n, a) {
    return new my({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: zn.toString(a)
        }
      ]
    });
  }
  _addCheck(e) {
    return new my({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: zn.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: zn.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: zn.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: zn.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: zn.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
my.create = (t) => {
  var e;
  return new my({
    checks: [],
    typeName: wa.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...mi(t)
  });
};
class KT extends Ri {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== An.boolean) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.boolean,
        received: n.parsedType
      }), Ra;
    }
    return Nu(e.data);
  }
}
KT.create = (t) => new KT({
  typeName: wa.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...mi(t)
});
class _5 extends Ri {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== An.date) {
      const i = this._getOrReturnCtx(e);
      return fn(i, {
        code: Gr.invalid_type,
        expected: An.date,
        received: i.parsedType
      }), Ra;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return fn(i, {
        code: Gr.invalid_date
      }), Ra;
    }
    const n = new Qc();
    let a;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (a = this._getOrReturnCtx(e, a), fn(a, {
        code: Gr.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : io.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new _5({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: zn.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: zn.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
_5.create = (t) => new _5({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: wa.ZodDate,
  ...mi(t)
});
class WL extends Ri {
  _parse(e) {
    if (this._getType(e) !== An.symbol) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.symbol,
        received: n.parsedType
      }), Ra;
    }
    return Nu(e.data);
  }
}
WL.create = (t) => new WL({
  typeName: wa.ZodSymbol,
  ...mi(t)
});
class ZT extends Ri {
  _parse(e) {
    if (this._getType(e) !== An.undefined) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.undefined,
        received: n.parsedType
      }), Ra;
    }
    return Nu(e.data);
  }
}
ZT.create = (t) => new ZT({
  typeName: wa.ZodUndefined,
  ...mi(t)
});
class JT extends Ri {
  _parse(e) {
    if (this._getType(e) !== An.null) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.null,
        received: n.parsedType
      }), Ra;
    }
    return Nu(e.data);
  }
}
JT.create = (t) => new JT({
  typeName: wa.ZodNull,
  ...mi(t)
});
class Cx extends Ri {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return Nu(e.data);
  }
}
Cx.create = (t) => new Cx({
  typeName: wa.ZodAny,
  ...mi(t)
});
class $b extends Ri {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return Nu(e.data);
  }
}
$b.create = (t) => new $b({
  typeName: wa.ZodUnknown,
  ...mi(t)
});
class Km extends Ri {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return fn(r, {
      code: Gr.invalid_type,
      expected: An.never,
      received: r.parsedType
    }), Ra;
  }
}
Km.create = (t) => new Km({
  typeName: wa.ZodNever,
  ...mi(t)
});
class HL extends Ri {
  _parse(e) {
    if (this._getType(e) !== An.undefined) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.void,
        received: n.parsedType
      }), Ra;
    }
    return Nu(e.data);
  }
}
HL.create = (t) => new HL({
  typeName: wa.ZodVoid,
  ...mi(t)
});
class P1 extends Ri {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), a = this._def;
    if (r.parsedType !== An.array)
      return fn(r, {
        code: Gr.invalid_type,
        expected: An.array,
        received: r.parsedType
      }), Ra;
    if (a.exactLength !== null) {
      const o = r.data.length > a.exactLength.value, s = r.data.length < a.exactLength.value;
      (o || s) && (fn(r, {
        code: o ? Gr.too_big : Gr.too_small,
        minimum: s ? a.exactLength.value : void 0,
        maximum: o ? a.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: a.exactLength.message
      }), n.dirty());
    }
    if (a.minLength !== null && r.data.length < a.minLength.value && (fn(r, {
      code: Gr.too_small,
      minimum: a.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.minLength.message
    }), n.dirty()), a.maxLength !== null && r.data.length > a.maxLength.value && (fn(r, {
      code: Gr.too_big,
      maximum: a.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: a.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, s) => a.type._parseAsync(new zh(r, o, r.path, s)))).then((o) => Qc.mergeArray(n, o));
    const i = [...r.data].map((o, s) => a.type._parseSync(new zh(r, o, r.path, s)));
    return Qc.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new P1({
      ...this._def,
      minLength: { value: e, message: zn.toString(r) }
    });
  }
  max(e, r) {
    return new P1({
      ...this._def,
      maxLength: { value: e, message: zn.toString(r) }
    });
  }
  length(e, r) {
    return new P1({
      ...this._def,
      exactLength: { value: e, message: zn.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
P1.create = (t, e) => new P1({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: wa.ZodArray,
  ...mi(e)
});
function w9(t) {
  if (t instanceof Ns) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = yh.create(w9(n));
    }
    return new Ns({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof P1 ? new P1({
    ...t._def,
    type: w9(t.element)
  }) : t instanceof yh ? yh.create(w9(t.unwrap())) : t instanceof vy ? vy.create(w9(t.unwrap())) : t instanceof Gh ? Gh.create(t.items.map((e) => w9(e))) : t;
}
class Ns extends Ri {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = io.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== An.object) {
      const c = this._getOrReturnCtx(e);
      return fn(c, {
        code: Gr.invalid_type,
        expected: An.object,
        received: c.parsedType
      }), Ra;
    }
    const { status: n, ctx: a } = this._processInputParams(e), { shape: i, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Km && this._def.unknownKeys === "strip"))
      for (const c in a.data)
        o.includes(c) || s.push(c);
    const l = [];
    for (const c of o) {
      const u = i[c], f = a.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new zh(a, f, a.path, c)),
        alwaysSet: c in a.data
      });
    }
    if (this._def.catchall instanceof Km) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of s)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: a.data[u] }
          });
      else if (c === "strict")
        s.length > 0 && (fn(a, {
          code: Gr.unrecognized_keys,
          keys: s
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of s) {
        const f = a.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new zh(a, f, a.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in a.data
        });
      }
    }
    return a.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const f = await u.key, h = await u.value;
        c.push({
          key: f,
          value: h,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => Qc.mergeObjectSync(n, c)) : Qc.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return zn.errToObj, new Ns({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var a, i, o, s;
          const l = (o = (i = (a = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(a, r, n).message) !== null && o !== void 0 ? o : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (s = zn.errToObj(e).message) !== null && s !== void 0 ? s : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new Ns({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Ns({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new Ns({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new Ns({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: wa.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new Ns({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return io.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new Ns({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return io.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new Ns({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return w9(this);
  }
  partial(e) {
    const r = {};
    return io.objectKeys(this.shape).forEach((n) => {
      const a = this.shape[n];
      e && !e[n] ? r[n] = a : r[n] = a.optional();
    }), new Ns({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return io.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof yh; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new Ns({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ctt(io.objectKeys(this.shape));
  }
}
Ns.create = (t, e) => new Ns({
  shape: () => t,
  unknownKeys: "strip",
  catchall: Km.create(),
  typeName: wa.ZodObject,
  ...mi(e)
});
Ns.strictCreate = (t, e) => new Ns({
  shape: () => t,
  unknownKeys: "strict",
  catchall: Km.create(),
  typeName: wa.ZodObject,
  ...mi(e)
});
Ns.lazycreate = (t, e) => new Ns({
  shape: t,
  unknownKeys: "strip",
  catchall: Km.create(),
  typeName: wa.ZodObject,
  ...mi(e)
});
class YT extends Ri {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function a(i) {
      for (const s of i)
        if (s.result.status === "valid")
          return s.result;
      for (const s of i)
        if (s.result.status === "dirty")
          return r.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((s) => new s0(s.ctx.common.issues));
      return fn(r, {
        code: Gr.invalid_union,
        unionErrors: o
      }), Ra;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(a);
    {
      let i;
      const o = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && o.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const s = o.map((l) => new s0(l));
      return fn(r, {
        code: Gr.invalid_union,
        unionErrors: s
      }), Ra;
    }
  }
  get options() {
    return this._def.options;
  }
}
YT.create = (t, e) => new YT({
  options: t,
  typeName: wa.ZodUnion,
  ...mi(e)
});
const Jp = (t) => t instanceof eE ? Jp(t.schema) : t instanceof q1 ? Jp(t.innerType()) : t instanceof tE ? [t.value] : t instanceof gy ? t.options : t instanceof rE ? io.objectValues(t.enum) : t instanceof nE ? Jp(t._def.innerType) : t instanceof ZT ? [void 0] : t instanceof JT ? [null] : t instanceof yh ? [void 0, ...Jp(t.unwrap())] : t instanceof vy ? [null, ...Jp(t.unwrap())] : t instanceof cme || t instanceof iE ? Jp(t.unwrap()) : t instanceof aE ? Jp(t._def.innerType) : [];
class TG extends Ri {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== An.object)
      return fn(r, {
        code: Gr.invalid_type,
        expected: An.object,
        received: r.parsedType
      }), Ra;
    const n = this.discriminator, a = r.data[n], i = this.optionsMap.get(a);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (fn(r, {
      code: Gr.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), Ra);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const a = /* @__PURE__ */ new Map();
    for (const i of r) {
      const o = Jp(i.shape[e]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (a.has(s))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(s)}`);
        a.set(s, i);
      }
    }
    return new TG({
      typeName: wa.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: a,
      ...mi(n)
    });
  }
}
function Uue(t, e) {
  const r = dm(t), n = dm(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === An.object && n === An.object) {
    const a = io.objectKeys(e), i = io.objectKeys(t).filter((s) => a.indexOf(s) !== -1), o = { ...t, ...e };
    for (const s of i) {
      const l = Uue(t[s], e[s]);
      if (!l.valid)
        return { valid: !1 };
      o[s] = l.data;
    }
    return { valid: !0, data: o };
  } else if (r === An.array && n === An.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const a = [];
    for (let i = 0; i < t.length; i++) {
      const o = t[i], s = e[i], l = Uue(o, s);
      if (!l.valid)
        return { valid: !1 };
      a.push(l.data);
    }
    return { valid: !0, data: a };
  } else return r === An.date && n === An.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class XT extends Ri {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = (i, o) => {
      if (Wue(i) || Wue(o))
        return Ra;
      const s = Uue(i.value, o.value);
      return s.valid ? ((Hue(i) || Hue(o)) && r.dirty(), { status: r.value, value: s.data }) : (fn(n, {
        code: Gr.invalid_intersection_types
      }), Ra);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, o]) => a(i, o)) : a(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
XT.create = (t, e, r) => new XT({
  left: t,
  right: e,
  typeName: wa.ZodIntersection,
  ...mi(r)
});
class Gh extends Ri {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== An.array)
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.array,
        received: n.parsedType
      }), Ra;
    if (n.data.length < this._def.items.length)
      return fn(n, {
        code: Gr.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ra;
    !this._def.rest && n.data.length > this._def.items.length && (fn(n, {
      code: Gr.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((o, s) => {
      const l = this._def.items[s] || this._def.rest;
      return l ? l._parse(new zh(n, o, n.path, s)) : null;
    }).filter((o) => !!o);
    return n.common.async ? Promise.all(i).then((o) => Qc.mergeArray(r, o)) : Qc.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Gh({
      ...this._def,
      rest: e
    });
  }
}
Gh.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Gh({
    items: t,
    typeName: wa.ZodTuple,
    rest: null,
    ...mi(e)
  });
};
class QT extends Ri {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== An.object)
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.object,
        received: n.parsedType
      }), Ra;
    const a = [], i = this._def.keyType, o = this._def.valueType;
    for (const s in n.data)
      a.push({
        key: i._parse(new zh(n, s, n.path, s)),
        value: o._parse(new zh(n, n.data[s], n.path, s)),
        alwaysSet: s in n.data
      });
    return n.common.async ? Qc.mergeObjectAsync(r, a) : Qc.mergeObjectSync(r, a);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Ri ? new QT({
      keyType: e,
      valueType: r,
      typeName: wa.ZodRecord,
      ...mi(n)
    }) : new QT({
      keyType: b1.create(),
      valueType: e,
      typeName: wa.ZodRecord,
      ...mi(r)
    });
  }
}
class UL extends Ri {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== An.map)
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.map,
        received: n.parsedType
      }), Ra;
    const a = this._def.keyType, i = this._def.valueType, o = [...n.data.entries()].map(([s, l], c) => ({
      key: a._parse(new zh(n, s, n.path, [c, "key"])),
      value: i._parse(new zh(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of o) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return Ra;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
        }
        return { status: r.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const l of o) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return Ra;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), s.set(c.value, u.value);
      }
      return { status: r.value, value: s };
    }
  }
}
UL.create = (t, e, r) => new UL({
  valueType: e,
  keyType: t,
  typeName: wa.ZodMap,
  ...mi(r)
});
class k5 extends Ri {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== An.set)
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.set,
        received: n.parsedType
      }), Ra;
    const a = this._def;
    a.minSize !== null && n.data.size < a.minSize.value && (fn(n, {
      code: Gr.too_small,
      minimum: a.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.minSize.message
    }), r.dirty()), a.maxSize !== null && n.data.size > a.maxSize.value && (fn(n, {
      code: Gr.too_big,
      maximum: a.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: a.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function o(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return Ra;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const s = [...n.data.values()].map((l, c) => i._parse(new zh(n, l, n.path, c)));
    return n.common.async ? Promise.all(s).then((l) => o(l)) : o(s);
  }
  min(e, r) {
    return new k5({
      ...this._def,
      minSize: { value: e, message: zn.toString(r) }
    });
  }
  max(e, r) {
    return new k5({
      ...this._def,
      maxSize: { value: e, message: zn.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
k5.create = (t, e) => new k5({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: wa.ZodSet,
  ...mi(e)
});
class y7 extends Ri {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== An.function)
      return fn(r, {
        code: Gr.invalid_type,
        expected: An.function,
        received: r.parsedType
      }), Ra;
    function n(s, l) {
      return zL({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          FL(),
          xx
        ].filter((c) => !!c),
        issueData: {
          code: Gr.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function a(s, l) {
      return zL({
        data: s,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          FL(),
          xx
        ].filter((c) => !!c),
        issueData: {
          code: Gr.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, o = r.data;
    if (this._def.returns instanceof wx) {
      const s = this;
      return Nu(async function(...l) {
        const c = new s0([]), u = await s._def.args.parseAsync(l, i).catch((p) => {
          throw c.addIssue(n(l, p)), c;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, i).catch((p) => {
          throw c.addIssue(a(f, p)), c;
        });
      });
    } else {
      const s = this;
      return Nu(function(...l) {
        const c = s._def.args.safeParse(l, i);
        if (!c.success)
          throw new s0([n(l, c.error)]);
        const u = Reflect.apply(o, this, c.data), f = s._def.returns.safeParse(u, i);
        if (!f.success)
          throw new s0([a(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new y7({
      ...this._def,
      args: Gh.create(e).rest($b.create())
    });
  }
  returns(e) {
    return new y7({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new y7({
      args: e || Gh.create([]).rest($b.create()),
      returns: r || $b.create(),
      typeName: wa.ZodFunction,
      ...mi(n)
    });
  }
}
class eE extends Ri {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
eE.create = (t, e) => new eE({
  getter: t,
  typeName: wa.ZodLazy,
  ...mi(e)
});
class tE extends Ri {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return fn(r, {
        received: r.data,
        code: Gr.invalid_literal,
        expected: this._def.value
      }), Ra;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
tE.create = (t, e) => new tE({
  value: t,
  typeName: wa.ZodLiteral,
  ...mi(e)
});
function Ctt(t, e) {
  return new gy({
    values: t,
    typeName: wa.ZodEnum,
    ...mi(e)
  });
}
class gy extends Ri {
  constructor() {
    super(...arguments), e_.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return fn(r, {
        expected: io.joinValues(n),
        received: r.parsedType,
        code: Gr.invalid_type
      }), Ra;
    }
    if (GL(this, e_) || vtt(this, e_, new Set(this._def.values)), !GL(this, e_).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return fn(r, {
        received: r.data,
        code: Gr.invalid_enum_value,
        options: n
      }), Ra;
    }
    return Nu(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return gy.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return gy.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
e_ = /* @__PURE__ */ new WeakMap();
gy.create = Ctt;
class rE extends Ri {
  constructor() {
    super(...arguments), t_.set(this, void 0);
  }
  _parse(e) {
    const r = io.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== An.string && n.parsedType !== An.number) {
      const a = io.objectValues(r);
      return fn(n, {
        expected: io.joinValues(a),
        received: n.parsedType,
        code: Gr.invalid_type
      }), Ra;
    }
    if (GL(this, t_) || vtt(this, t_, new Set(io.getValidEnumValues(this._def.values))), !GL(this, t_).has(e.data)) {
      const a = io.objectValues(r);
      return fn(n, {
        received: n.data,
        code: Gr.invalid_enum_value,
        options: a
      }), Ra;
    }
    return Nu(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
t_ = /* @__PURE__ */ new WeakMap();
rE.create = (t, e) => new rE({
  values: t,
  typeName: wa.ZodNativeEnum,
  ...mi(e)
});
class wx extends Ri {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== An.promise && r.common.async === !1)
      return fn(r, {
        code: Gr.invalid_type,
        expected: An.promise,
        received: r.parsedType
      }), Ra;
    const n = r.parsedType === An.promise ? r.data : Promise.resolve(r.data);
    return Nu(n.then((a) => this._def.type.parseAsync(a, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
wx.create = (t, e) => new wx({
  type: t,
  typeName: wa.ZodPromise,
  ...mi(e)
});
class q1 extends Ri {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === wa.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), a = this._def.effect || null, i = {
      addIssue: (o) => {
        fn(n, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), a.type === "preprocess") {
      const o = a.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (r.value === "aborted")
            return Ra;
          const l = await this._def.schema._parseAsync({
            data: s,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? Ra : l.status === "dirty" || r.value === "dirty" ? j9(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return Ra;
        const s = this._def.schema._parseSync({
          data: o,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ra : s.status === "dirty" || r.value === "dirty" ? j9(s.value) : s;
      }
    }
    if (a.type === "refinement") {
      const o = (s) => {
        const l = a.refinement(s, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (n.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return s.status === "aborted" ? Ra : (s.status === "dirty" && r.dirty(), o(s.value), { status: r.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((s) => s.status === "aborted" ? Ra : (s.status === "dirty" && r.dirty(), o(s.value).then(() => ({ status: r.value, value: s.value }))));
    }
    if (a.type === "transform")
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!S5(o))
          return o;
        const s = a.transform(o.value, i);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => S5(o) ? Promise.resolve(a.transform(o.value, i)).then((s) => ({ status: r.value, value: s })) : o);
    io.assertNever(a);
  }
}
q1.create = (t, e, r) => new q1({
  schema: t,
  typeName: wa.ZodEffects,
  effect: e,
  ...mi(r)
});
q1.createWithPreprocess = (t, e, r) => new q1({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: wa.ZodEffects,
  ...mi(r)
});
class yh extends Ri {
  _parse(e) {
    return this._getType(e) === An.undefined ? Nu(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
yh.create = (t, e) => new yh({
  innerType: t,
  typeName: wa.ZodOptional,
  ...mi(e)
});
class vy extends Ri {
  _parse(e) {
    return this._getType(e) === An.null ? Nu(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
vy.create = (t, e) => new vy({
  innerType: t,
  typeName: wa.ZodNullable,
  ...mi(e)
});
class nE extends Ri {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === An.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
nE.create = (t, e) => new nE({
  innerType: t,
  typeName: wa.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...mi(e)
});
class aE extends Ri {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, a = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return qT(a) ? a.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new s0(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new s0(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
aE.create = (t, e) => new aE({
  innerType: t,
  typeName: wa.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...mi(e)
});
class VL extends Ri {
  _parse(e) {
    if (this._getType(e) !== An.nan) {
      const n = this._getOrReturnCtx(e);
      return fn(n, {
        code: Gr.invalid_type,
        expected: An.nan,
        received: n.parsedType
      }), Ra;
    }
    return { status: "valid", value: e.data };
  }
}
VL.create = (t) => new VL({
  typeName: wa.ZodNaN,
  ...mi(t)
});
const U2r = Symbol("zod_brand");
class cme extends Ri {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class CM extends Ri {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? Ra : i.status === "dirty" ? (r.dirty(), j9(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const a = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return a.status === "aborted" ? Ra : a.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: a.value
      }) : this._def.out._parseSync({
        data: a.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new CM({
      in: e,
      out: r,
      typeName: wa.ZodPipeline
    });
  }
}
class iE extends Ri {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (a) => (S5(a) && (a.value = Object.freeze(a.value)), a);
    return qT(r) ? r.then((a) => n(a)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
iE.create = (t, e) => new iE({
  innerType: t,
  typeName: wa.ZodReadonly,
  ...mi(e)
});
function wtt(t, e = {}, r) {
  return t ? Cx.create().superRefine((n, a) => {
    var i, o;
    if (!t(n)) {
      const s = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (o = (i = s.fatal) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : !0, c = typeof s == "string" ? { message: s } : s;
      a.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : Cx.create();
}
const V2r = {
  object: Ns.lazycreate
};
var wa;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(wa || (wa = {}));
const q2r = (t, e = {
  message: `Input not instance of ${t.name}`
}) => wtt((r) => r instanceof t, e), Stt = b1.create, _tt = py.create, K2r = VL.create, Z2r = my.create, ktt = KT.create, J2r = _5.create, Y2r = WL.create, X2r = ZT.create, Q2r = JT.create, ehr = Cx.create, thr = $b.create, rhr = Km.create, nhr = HL.create, ahr = P1.create, ihr = Ns.create, ohr = Ns.strictCreate, shr = YT.create, lhr = TG.create, chr = XT.create, uhr = Gh.create, dhr = QT.create, fhr = UL.create, hhr = k5.create, phr = y7.create, mhr = eE.create, ghr = tE.create, vhr = gy.create, yhr = rE.create, bhr = wx.create, txe = q1.create, xhr = yh.create, Chr = vy.create, whr = q1.createWithPreprocess, Shr = CM.create, _hr = () => Stt().optional(), khr = () => _tt().optional(), Ahr = () => ktt().optional(), Thr = {
  string: (t) => b1.create({ ...t, coerce: !0 }),
  number: (t) => py.create({ ...t, coerce: !0 }),
  boolean: (t) => KT.create({
    ...t,
    coerce: !0
  }),
  bigint: (t) => my.create({ ...t, coerce: !0 }),
  date: (t) => _5.create({ ...t, coerce: !0 })
}, Ehr = Ra;
var ha = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: xx,
  setErrorMap: w2r,
  getErrorMap: FL,
  makeIssue: zL,
  EMPTY_PATH: S2r,
  addIssueToContext: fn,
  ParseStatus: Qc,
  INVALID: Ra,
  DIRTY: j9,
  OK: Nu,
  isAborted: Wue,
  isDirty: Hue,
  isValid: S5,
  isAsync: qT,
  get util() {
    return io;
  },
  get objectUtil() {
    return Gue;
  },
  ZodParsedType: An,
  getParsedType: dm,
  ZodType: Ri,
  datetimeRegex: xtt,
  ZodString: b1,
  ZodNumber: py,
  ZodBigInt: my,
  ZodBoolean: KT,
  ZodDate: _5,
  ZodSymbol: WL,
  ZodUndefined: ZT,
  ZodNull: JT,
  ZodAny: Cx,
  ZodUnknown: $b,
  ZodNever: Km,
  ZodVoid: HL,
  ZodArray: P1,
  ZodObject: Ns,
  ZodUnion: YT,
  ZodDiscriminatedUnion: TG,
  ZodIntersection: XT,
  ZodTuple: Gh,
  ZodRecord: QT,
  ZodMap: UL,
  ZodSet: k5,
  ZodFunction: y7,
  ZodLazy: eE,
  ZodLiteral: tE,
  ZodEnum: gy,
  ZodNativeEnum: rE,
  ZodPromise: wx,
  ZodEffects: q1,
  ZodTransformer: q1,
  ZodOptional: yh,
  ZodNullable: vy,
  ZodDefault: nE,
  ZodCatch: aE,
  ZodNaN: VL,
  BRAND: U2r,
  ZodBranded: cme,
  ZodPipeline: CM,
  ZodReadonly: iE,
  custom: wtt,
  Schema: Ri,
  ZodSchema: Ri,
  late: V2r,
  get ZodFirstPartyTypeKind() {
    return wa;
  },
  coerce: Thr,
  any: ehr,
  array: ahr,
  bigint: Z2r,
  boolean: ktt,
  date: J2r,
  discriminatedUnion: lhr,
  effect: txe,
  enum: vhr,
  function: phr,
  instanceof: q2r,
  intersection: chr,
  lazy: mhr,
  literal: ghr,
  map: fhr,
  nan: K2r,
  nativeEnum: yhr,
  never: rhr,
  null: Q2r,
  nullable: Chr,
  number: _tt,
  object: ihr,
  oboolean: Ahr,
  onumber: khr,
  optional: xhr,
  ostring: _hr,
  pipeline: Shr,
  preprocess: whr,
  promise: bhr,
  record: dhr,
  set: hhr,
  strictObject: ohr,
  string: Stt,
  symbol: Y2r,
  transformer: txe,
  tuple: uhr,
  undefined: X2r,
  union: shr,
  unknown: thr,
  void: nhr,
  NEVER: Ehr,
  ZodIssueCode: Gr,
  quotelessJson: C2r,
  ZodError: s0
});
const Ihr = 1, A5 = ha.string().min(Ihr), l0 = {
  CREATE_CONVERSATION: "createConversation",
  SEND_MESSAGE: "sendMessage",
  OPEN_URL: "openUrl",
  DIRECT_LIVE_CHAT_TRANSFER: "directLiveChatTransfer",
  MESSAGE_DONE: "messageDone"
}, Mhr = ha.object({
  type: ha.literal(l0.CREATE_CONVERSATION),
  data: ha.object({
    conversationId: n2
  })
}), Phr = ha.object({
  type: ha.literal(l0.SEND_MESSAGE),
  data: ha.object({
    conversationId: A5,
    message: A5
  })
}), Rhr = ha.object({
  type: ha.literal(l0.MESSAGE_DONE),
  data: ha.object({
    conversationId: A5,
    message: g8
  })
}), L3n = ha.union([
  Mhr,
  Phr,
  Rhr
]), Att = Bo({
  requestTransformer: (t) => t,
  setRequestTransformer: () => {
  }
}), Ohr = ({
  children: t,
  props: e
}) => {
  const [r, n] = Yt(() => e.requestTransformer);
  return /* @__PURE__ */ R.jsx(
    Att.Provider,
    {
      value: { requestTransformer: r, setRequestTransformer: n },
      children: t
    }
  );
}, Ja = () => Qn(Att);
var gu = {}, rxe = {}, Qw, nxe;
function wi() {
  if (nxe) return Qw;
  nxe = 1;
  var t = function(e) {
    return e && e.Math === Math && e;
  };
  return Qw = // eslint-disable-next-line es/no-global-this -- safe
  t(typeof globalThis == "object" && globalThis) || t(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  t(typeof self == "object" && self) || t(typeof wl == "object" && wl) || t(typeof Qw == "object" && Qw) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")(), Qw;
}
var TZ = {}, EZ, axe;
function Ba() {
  return axe || (axe = 1, EZ = function(t) {
    try {
      return !!t();
    } catch {
      return !0;
    }
  }), EZ;
}
var IZ, ixe;
function Go() {
  if (ixe) return IZ;
  ixe = 1;
  var t = Ba();
  return IZ = !t(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), IZ;
}
var MZ, oxe;
function wM() {
  if (oxe) return MZ;
  oxe = 1;
  var t = Ba();
  return MZ = !t(function() {
    var e = (function() {
    }).bind();
    return typeof e != "function" || e.hasOwnProperty("prototype");
  }), MZ;
}
var PZ, sxe;
function No() {
  if (sxe) return PZ;
  sxe = 1;
  var t = wM(), e = Function.prototype.call;
  return PZ = t ? e.bind(e) : function() {
    return e.apply(e, arguments);
  }, PZ;
}
var RZ = {}, lxe;
function EG() {
  if (lxe) return RZ;
  lxe = 1;
  var t = {}.propertyIsEnumerable, e = Object.getOwnPropertyDescriptor, r = e && !t.call({ 1: 2 }, 1);
  return RZ.f = r ? function(a) {
    var i = e(this, a);
    return !!i && i.enumerable;
  } : t, RZ;
}
var OZ, cxe;
function r6() {
  return cxe || (cxe = 1, OZ = function(t, e) {
    return {
      enumerable: !(t & 1),
      configurable: !(t & 2),
      writable: !(t & 4),
      value: e
    };
  }), OZ;
}
var BZ, uxe;
function Wa() {
  if (uxe) return BZ;
  uxe = 1;
  var t = wM(), e = Function.prototype, r = e.call, n = t && e.bind.bind(r, r);
  return BZ = t ? n : function(a) {
    return function() {
      return r.apply(a, arguments);
    };
  }, BZ;
}
var NZ, dxe;
function Yh() {
  if (dxe) return NZ;
  dxe = 1;
  var t = Wa(), e = t({}.toString), r = t("".slice);
  return NZ = function(n) {
    return r(e(n), 8, -1);
  }, NZ;
}
var $Z, fxe;
function SM() {
  if (fxe) return $Z;
  fxe = 1;
  var t = Wa(), e = Ba(), r = Yh(), n = Object, a = t("".split);
  return $Z = e(function() {
    return !n("z").propertyIsEnumerable(0);
  }) ? function(i) {
    return r(i) === "String" ? a(i, "") : n(i);
  } : n, $Z;
}
var DZ, hxe;
function u2() {
  return hxe || (hxe = 1, DZ = function(t) {
    return t == null;
  }), DZ;
}
var LZ, pxe;
function d2() {
  if (pxe) return LZ;
  pxe = 1;
  var t = u2(), e = TypeError;
  return LZ = function(r) {
    if (t(r)) throw new e("Can't call method on " + r);
    return r;
  }, LZ;
}
var jZ, mxe;
function S0() {
  if (mxe) return jZ;
  mxe = 1;
  var t = SM(), e = d2();
  return jZ = function(r) {
    return t(e(r));
  }, jZ;
}
var FZ, gxe;
function $o() {
  if (gxe) return FZ;
  gxe = 1;
  var t = typeof document == "object" && document.all;
  return FZ = typeof t > "u" && t !== void 0 ? function(e) {
    return typeof e == "function" || e === t;
  } : function(e) {
    return typeof e == "function";
  }, FZ;
}
var zZ, vxe;
function fs() {
  if (vxe) return zZ;
  vxe = 1;
  var t = $o();
  return zZ = function(e) {
    return typeof e == "object" ? e !== null : t(e);
  }, zZ;
}
var GZ, yxe;
function wf() {
  if (yxe) return GZ;
  yxe = 1;
  var t = wi(), e = $o(), r = function(n) {
    return e(n) ? n : void 0;
  };
  return GZ = function(n, a) {
    return arguments.length < 2 ? r(t[n]) : t[n] && t[n][a];
  }, GZ;
}
var WZ, bxe;
function dg() {
  if (bxe) return WZ;
  bxe = 1;
  var t = Wa();
  return WZ = t({}.isPrototypeOf), WZ;
}
var HZ, xxe;
function jy() {
  if (xxe) return HZ;
  xxe = 1;
  var t = wi(), e = t.navigator, r = e && e.userAgent;
  return HZ = r ? String(r) : "", HZ;
}
var UZ, Cxe;
function D8() {
  if (Cxe) return UZ;
  Cxe = 1;
  var t = wi(), e = jy(), r = t.process, n = t.Deno, a = r && r.versions || n && n.version, i = a && a.v8, o, s;
  return i && (o = i.split("."), s = o[0] > 0 && o[0] < 4 ? 1 : +(o[0] + o[1])), !s && e && (o = e.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = e.match(/Chrome\/(\d+)/), o && (s = +o[1]))), UZ = s, UZ;
}
var VZ, wxe;
function L8() {
  if (wxe) return VZ;
  wxe = 1;
  var t = D8(), e = Ba(), r = wi(), n = r.String;
  return VZ = !!Object.getOwnPropertySymbols && !e(function() {
    var a = Symbol("symbol detection");
    return !n(a) || !(Object(a) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && t && t < 41;
  }), VZ;
}
var qZ, Sxe;
function Ttt() {
  if (Sxe) return qZ;
  Sxe = 1;
  var t = L8();
  return qZ = t && !Symbol.sham && typeof Symbol.iterator == "symbol", qZ;
}
var KZ, _xe;
function j8() {
  if (_xe) return KZ;
  _xe = 1;
  var t = wf(), e = $o(), r = dg(), n = Ttt(), a = Object;
  return KZ = n ? function(i) {
    return typeof i == "symbol";
  } : function(i) {
    var o = t("Symbol");
    return e(o) && r(o.prototype, a(i));
  }, KZ;
}
var ZZ, kxe;
function n6() {
  if (kxe) return ZZ;
  kxe = 1;
  var t = String;
  return ZZ = function(e) {
    try {
      return t(e);
    } catch {
      return "Object";
    }
  }, ZZ;
}
var JZ, Axe;
function Sf() {
  if (Axe) return JZ;
  Axe = 1;
  var t = $o(), e = n6(), r = TypeError;
  return JZ = function(n) {
    if (t(n)) return n;
    throw new r(e(n) + " is not a function");
  }, JZ;
}
var YZ, Txe;
function a6() {
  if (Txe) return YZ;
  Txe = 1;
  var t = Sf(), e = u2();
  return YZ = function(r, n) {
    var a = r[n];
    return e(a) ? void 0 : t(a);
  }, YZ;
}
var XZ, Exe;
function Bhr() {
  if (Exe) return XZ;
  Exe = 1;
  var t = No(), e = $o(), r = fs(), n = TypeError;
  return XZ = function(a, i) {
    var o, s;
    if (i === "string" && e(o = a.toString) && !r(s = t(o, a)) || e(o = a.valueOf) && !r(s = t(o, a)) || i !== "string" && e(o = a.toString) && !r(s = t(o, a))) return s;
    throw new n("Can't convert object to primitive value");
  }, XZ;
}
var QZ = { exports: {} }, eJ, Ixe;
function _f() {
  return Ixe || (Ixe = 1, eJ = !1), eJ;
}
var tJ, Mxe;
function ume() {
  if (Mxe) return tJ;
  Mxe = 1;
  var t = wi(), e = Object.defineProperty;
  return tJ = function(r, n) {
    try {
      e(t, r, { value: n, configurable: !0, writable: !0 });
    } catch {
      t[r] = n;
    }
    return n;
  }, tJ;
}
var Pxe;
function dme() {
  if (Pxe) return QZ.exports;
  Pxe = 1;
  var t = _f(), e = wi(), r = ume(), n = "__core-js_shared__", a = QZ.exports = e[n] || r(n, {});
  return (a.versions || (a.versions = [])).push({
    version: "3.39.0",
    mode: t ? "pure" : "global",
    copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), QZ.exports;
}
var rJ, Rxe;
function F8() {
  if (Rxe) return rJ;
  Rxe = 1;
  var t = dme();
  return rJ = function(e, r) {
    return t[e] || (t[e] = r || {});
  }, rJ;
}
var nJ, Oxe;
function ru() {
  if (Oxe) return nJ;
  Oxe = 1;
  var t = d2(), e = Object;
  return nJ = function(r) {
    return e(t(r));
  }, nJ;
}
var aJ, Bxe;
function Es() {
  if (Bxe) return aJ;
  Bxe = 1;
  var t = Wa(), e = ru(), r = t({}.hasOwnProperty);
  return aJ = Object.hasOwn || function(a, i) {
    return r(e(a), i);
  }, aJ;
}
var iJ, Nxe;
function _M() {
  if (Nxe) return iJ;
  Nxe = 1;
  var t = Wa(), e = 0, r = Math.random(), n = t(1 .toString);
  return iJ = function(a) {
    return "Symbol(" + (a === void 0 ? "" : a) + ")_" + n(++e + r, 36);
  }, iJ;
}
var oJ, $xe;
function Do() {
  if ($xe) return oJ;
  $xe = 1;
  var t = wi(), e = F8(), r = Es(), n = _M(), a = L8(), i = Ttt(), o = t.Symbol, s = e("wks"), l = i ? o.for || o : o && o.withoutSetter || n;
  return oJ = function(c) {
    return r(s, c) || (s[c] = a && r(o, c) ? o[c] : l("Symbol." + c)), s[c];
  }, oJ;
}
var sJ, Dxe;
function fme() {
  if (Dxe) return sJ;
  Dxe = 1;
  var t = No(), e = fs(), r = j8(), n = a6(), a = Bhr(), i = Do(), o = TypeError, s = i("toPrimitive");
  return sJ = function(l, c) {
    if (!e(l) || r(l)) return l;
    var u = n(l, s), f;
    if (u) {
      if (c === void 0 && (c = "default"), f = t(u, l, c), !e(f) || r(f)) return f;
      throw new o("Can't convert object to primitive value");
    }
    return c === void 0 && (c = "number"), a(l, c);
  }, sJ;
}
var lJ, Lxe;
function IG() {
  if (Lxe) return lJ;
  Lxe = 1;
  var t = fme(), e = j8();
  return lJ = function(r) {
    var n = t(r, "string");
    return e(n) ? n : n + "";
  }, lJ;
}
var cJ, jxe;
function MG() {
  if (jxe) return cJ;
  jxe = 1;
  var t = wi(), e = fs(), r = t.document, n = e(r) && e(r.createElement);
  return cJ = function(a) {
    return n ? r.createElement(a) : {};
  }, cJ;
}
var uJ, Fxe;
function Ett() {
  if (Fxe) return uJ;
  Fxe = 1;
  var t = Go(), e = Ba(), r = MG();
  return uJ = !t && !e(function() {
    return Object.defineProperty(r("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), uJ;
}
var zxe;
function Fy() {
  if (zxe) return TZ;
  zxe = 1;
  var t = Go(), e = No(), r = EG(), n = r6(), a = S0(), i = IG(), o = Es(), s = Ett(), l = Object.getOwnPropertyDescriptor;
  return TZ.f = t ? l : function(u, f) {
    if (u = a(u), f = i(f), s) try {
      return l(u, f);
    } catch {
    }
    if (o(u, f)) return n(!e(r.f, u, f), u[f]);
  }, TZ;
}
var dJ = {}, fJ, Gxe;
function Itt() {
  if (Gxe) return fJ;
  Gxe = 1;
  var t = Go(), e = Ba();
  return fJ = t && e(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), fJ;
}
var hJ, Wxe;
function Ys() {
  if (Wxe) return hJ;
  Wxe = 1;
  var t = fs(), e = String, r = TypeError;
  return hJ = function(n) {
    if (t(n)) return n;
    throw new r(e(n) + " is not an object");
  }, hJ;
}
var Hxe;
function Pd() {
  if (Hxe) return dJ;
  Hxe = 1;
  var t = Go(), e = Ett(), r = Itt(), n = Ys(), a = IG(), i = TypeError, o = Object.defineProperty, s = Object.getOwnPropertyDescriptor, l = "enumerable", c = "configurable", u = "writable";
  return dJ.f = t ? r ? function(h, p, g) {
    if (n(h), p = a(p), n(g), typeof h == "function" && p === "prototype" && "value" in g && u in g && !g[u]) {
      var y = s(h, p);
      y && y[u] && (h[p] = g.value, g = {
        configurable: c in g ? g[c] : y[c],
        enumerable: l in g ? g[l] : y[l],
        writable: !1
      });
    }
    return o(h, p, g);
  } : o : function(h, p, g) {
    if (n(h), p = a(p), n(g), e) try {
      return o(h, p, g);
    } catch {
    }
    if ("get" in g || "set" in g) throw new i("Accessors not supported");
    return "value" in g && (h[p] = g.value), h;
  }, dJ;
}
var pJ, Uxe;
function fg() {
  if (Uxe) return pJ;
  Uxe = 1;
  var t = Go(), e = Pd(), r = r6();
  return pJ = t ? function(n, a, i) {
    return e.f(n, a, r(1, i));
  } : function(n, a, i) {
    return n[a] = i, n;
  }, pJ;
}
var mJ = { exports: {} }, gJ, Vxe;
function kM() {
  if (Vxe) return gJ;
  Vxe = 1;
  var t = Go(), e = Es(), r = Function.prototype, n = t && Object.getOwnPropertyDescriptor, a = e(r, "name"), i = a && (function() {
  }).name === "something", o = a && (!t || t && n(r, "name").configurable);
  return gJ = {
    EXISTS: a,
    PROPER: i,
    CONFIGURABLE: o
  }, gJ;
}
var vJ, qxe;
function hme() {
  if (qxe) return vJ;
  qxe = 1;
  var t = Wa(), e = $o(), r = dme(), n = t(Function.toString);
  return e(r.inspectSource) || (r.inspectSource = function(a) {
    return n(a);
  }), vJ = r.inspectSource, vJ;
}
var yJ, Kxe;
function Nhr() {
  if (Kxe) return yJ;
  Kxe = 1;
  var t = wi(), e = $o(), r = t.WeakMap;
  return yJ = e(r) && /native code/.test(String(r)), yJ;
}
var bJ, Zxe;
function PG() {
  if (Zxe) return bJ;
  Zxe = 1;
  var t = F8(), e = _M(), r = t("keys");
  return bJ = function(n) {
    return r[n] || (r[n] = e(n));
  }, bJ;
}
var xJ, Jxe;
function AM() {
  return Jxe || (Jxe = 1, xJ = {}), xJ;
}
var CJ, Yxe;
function _0() {
  if (Yxe) return CJ;
  Yxe = 1;
  var t = Nhr(), e = wi(), r = fs(), n = fg(), a = Es(), i = dme(), o = PG(), s = AM(), l = "Object already initialized", c = e.TypeError, u = e.WeakMap, f, h, p, g = function(_) {
    return p(_) ? h(_) : f(_, {});
  }, y = function(_) {
    return function(C) {
      var x;
      if (!r(C) || (x = h(C)).type !== _)
        throw new c("Incompatible receiver, " + _ + " required");
      return x;
    };
  };
  if (t || i.state) {
    var b = i.state || (i.state = new u());
    b.get = b.get, b.has = b.has, b.set = b.set, f = function(_, C) {
      if (b.has(_)) throw new c(l);
      return C.facade = _, b.set(_, C), C;
    }, h = function(_) {
      return b.get(_) || {};
    }, p = function(_) {
      return b.has(_);
    };
  } else {
    var w = o("state");
    s[w] = !0, f = function(_, C) {
      if (a(_, w)) throw new c(l);
      return C.facade = _, n(_, w, C), C;
    }, h = function(_) {
      return a(_, w) ? _[w] : {};
    }, p = function(_) {
      return a(_, w);
    };
  }
  return CJ = {
    set: f,
    get: h,
    has: p,
    enforce: g,
    getterFor: y
  }, CJ;
}
var Xxe;
function Mtt() {
  if (Xxe) return mJ.exports;
  Xxe = 1;
  var t = Wa(), e = Ba(), r = $o(), n = Es(), a = Go(), i = kM().CONFIGURABLE, o = hme(), s = _0(), l = s.enforce, c = s.get, u = String, f = Object.defineProperty, h = t("".slice), p = t("".replace), g = t([].join), y = a && !e(function() {
    return f(function() {
    }, "length", { value: 8 }).length !== 8;
  }), b = String(String).split("String"), w = mJ.exports = function(_, C, x) {
    h(u(C), 0, 7) === "Symbol(" && (C = "[" + p(u(C), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), x && x.getter && (C = "get " + C), x && x.setter && (C = "set " + C), (!n(_, "name") || i && _.name !== C) && (a ? f(_, "name", { value: C, configurable: !0 }) : _.name = C), y && x && n(x, "arity") && _.length !== x.arity && f(_, "length", { value: x.arity });
    try {
      x && n(x, "constructor") && x.constructor ? a && f(_, "prototype", { writable: !1 }) : _.prototype && (_.prototype = void 0);
    } catch {
    }
    var S = l(_);
    return n(S, "source") || (S.source = g(b, typeof C == "string" ? C : "")), _;
  };
  return Function.prototype.toString = w(function() {
    return r(this) && c(this).source || o(this);
  }, "toString"), mJ.exports;
}
var wJ, Qxe;
function Gu() {
  if (Qxe) return wJ;
  Qxe = 1;
  var t = $o(), e = Pd(), r = Mtt(), n = ume();
  return wJ = function(a, i, o, s) {
    s || (s = {});
    var l = s.enumerable, c = s.name !== void 0 ? s.name : i;
    if (t(o) && r(o, c, s), s.global)
      l ? a[i] = o : n(i, o);
    else {
      try {
        s.unsafe ? a[i] && (l = !0) : delete a[i];
      } catch {
      }
      l ? a[i] = o : e.f(a, i, {
        value: o,
        enumerable: !1,
        configurable: !s.nonConfigurable,
        writable: !s.nonWritable
      });
    }
    return a;
  }, wJ;
}
var SJ = {}, _J, e8e;
function $hr() {
  if (e8e) return _J;
  e8e = 1;
  var t = Math.ceil, e = Math.floor;
  return _J = Math.trunc || function(n) {
    var a = +n;
    return (a > 0 ? e : t)(a);
  }, _J;
}
var kJ, t8e;
function Xh() {
  if (t8e) return kJ;
  t8e = 1;
  var t = $hr();
  return kJ = function(e) {
    var r = +e;
    return r !== r || r === 0 ? 0 : t(r);
  }, kJ;
}
var AJ, r8e;
function i6() {
  if (r8e) return AJ;
  r8e = 1;
  var t = Xh(), e = Math.max, r = Math.min;
  return AJ = function(n, a) {
    var i = t(n);
    return i < 0 ? e(i + a, 0) : r(i, a);
  }, AJ;
}
var TJ, n8e;
function hg() {
  if (n8e) return TJ;
  n8e = 1;
  var t = Xh(), e = Math.min;
  return TJ = function(r) {
    var n = t(r);
    return n > 0 ? e(n, 9007199254740991) : 0;
  }, TJ;
}
var EJ, a8e;
function nu() {
  if (a8e) return EJ;
  a8e = 1;
  var t = hg();
  return EJ = function(e) {
    return t(e.length);
  }, EJ;
}
var IJ, i8e;
function RG() {
  if (i8e) return IJ;
  i8e = 1;
  var t = S0(), e = i6(), r = nu(), n = function(a) {
    return function(i, o, s) {
      var l = t(i), c = r(l);
      if (c === 0) return !a && -1;
      var u = e(s, c), f;
      if (a && o !== o) {
        for (; c > u; )
          if (f = l[u++], f !== f) return !0;
      } else for (; c > u; u++)
        if ((a || u in l) && l[u] === o) return a || u || 0;
      return !a && -1;
    };
  };
  return IJ = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: n(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: n(!1)
  }, IJ;
}
var MJ, o8e;
function Ptt() {
  if (o8e) return MJ;
  o8e = 1;
  var t = Wa(), e = Es(), r = S0(), n = RG().indexOf, a = AM(), i = t([].push);
  return MJ = function(o, s) {
    var l = r(o), c = 0, u = [], f;
    for (f in l) !e(a, f) && e(l, f) && i(u, f);
    for (; s.length > c; ) e(l, f = s[c++]) && (~n(u, f) || i(u, f));
    return u;
  }, MJ;
}
var PJ, s8e;
function pme() {
  return s8e || (s8e = 1, PJ = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), PJ;
}
var l8e;
function z8() {
  if (l8e) return SJ;
  l8e = 1;
  var t = Ptt(), e = pme(), r = e.concat("length", "prototype");
  return SJ.f = Object.getOwnPropertyNames || function(a) {
    return t(a, r);
  }, SJ;
}
var RJ = {}, c8e;
function OG() {
  return c8e || (c8e = 1, RJ.f = Object.getOwnPropertySymbols), RJ;
}
var OJ, u8e;
function Rtt() {
  if (u8e) return OJ;
  u8e = 1;
  var t = wf(), e = Wa(), r = z8(), n = OG(), a = Ys(), i = e([].concat);
  return OJ = t("Reflect", "ownKeys") || function(s) {
    var l = r.f(a(s)), c = n.f;
    return c ? i(l, c(s)) : l;
  }, OJ;
}
var BJ, d8e;
function mme() {
  if (d8e) return BJ;
  d8e = 1;
  var t = Es(), e = Rtt(), r = Fy(), n = Pd();
  return BJ = function(a, i, o) {
    for (var s = e(i), l = n.f, c = r.f, u = 0; u < s.length; u++) {
      var f = s[u];
      !t(a, f) && !(o && t(o, f)) && l(a, f, c(i, f));
    }
  }, BJ;
}
var NJ, f8e;
function BG() {
  if (f8e) return NJ;
  f8e = 1;
  var t = Ba(), e = $o(), r = /#|\.prototype\./, n = function(l, c) {
    var u = i[a(l)];
    return u === s ? !0 : u === o ? !1 : e(c) ? t(c) : !!c;
  }, a = n.normalize = function(l) {
    return String(l).replace(r, ".").toLowerCase();
  }, i = n.data = {}, o = n.NATIVE = "N", s = n.POLYFILL = "P";
  return NJ = n, NJ;
}
var $J, h8e;
function Ya() {
  if (h8e) return $J;
  h8e = 1;
  var t = wi(), e = Fy().f, r = fg(), n = Gu(), a = ume(), i = mme(), o = BG();
  return $J = function(s, l) {
    var c = s.target, u = s.global, f = s.stat, h, p, g, y, b, w;
    if (u ? p = t : f ? p = t[c] || a(c, {}) : p = t[c] && t[c].prototype, p) for (g in l) {
      if (b = l[g], s.dontCallGetSet ? (w = e(p, g), y = w && w.value) : y = p[g], h = o(u ? g : c + (f ? "." : "#") + g, s.forced), !h && y !== void 0) {
        if (typeof b == typeof y) continue;
        i(b, y);
      }
      (s.sham || y && y.sham) && r(b, "sham", !0), n(p, g, b, s);
    }
  }, $J;
}
var DJ, p8e;
function TM() {
  if (p8e) return DJ;
  p8e = 1;
  var t = Ptt(), e = pme();
  return DJ = Object.keys || function(n) {
    return t(n, e);
  }, DJ;
}
var m8e;
function gme() {
  if (m8e) return rxe;
  m8e = 1;
  var t = Ya(), e = ru(), r = TM(), n = Ba(), a = n(function() {
    r(1);
  });
  return t({ target: "Object", stat: !0, forced: a }, {
    keys: function(o) {
      return r(e(o));
    }
  }), rxe;
}
var g8e = {}, v8e = {}, LJ, y8e;
function vme() {
  if (y8e) return LJ;
  y8e = 1;
  var t = Do(), e = t("toStringTag"), r = {};
  return r[e] = "z", LJ = String(r) === "[object z]", LJ;
}
var jJ, b8e;
function pg() {
  if (b8e) return jJ;
  b8e = 1;
  var t = vme(), e = $o(), r = Yh(), n = Do(), a = n("toStringTag"), i = Object, o = r(/* @__PURE__ */ function() {
    return arguments;
  }()) === "Arguments", s = function(l, c) {
    try {
      return l[c];
    } catch {
    }
  };
  return jJ = t ? r : function(l) {
    var c, u, f;
    return l === void 0 ? "Undefined" : l === null ? "Null" : typeof (u = s(c = i(l), a)) == "string" ? u : o ? r(c) : (f = r(c)) === "Object" && e(c.callee) ? "Arguments" : f;
  }, jJ;
}
var FJ, x8e;
function Vl() {
  if (x8e) return FJ;
  x8e = 1;
  var t = pg(), e = String;
  return FJ = function(r) {
    if (t(r) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return e(r);
  }, FJ;
}
var zJ = {}, C8e;
function Ott() {
  if (C8e) return zJ;
  C8e = 1;
  var t = Go(), e = Itt(), r = Pd(), n = Ys(), a = S0(), i = TM();
  return zJ.f = t && !e ? Object.defineProperties : function(s, l) {
    n(s);
    for (var c = a(l), u = i(l), f = u.length, h = 0, p; f > h; ) r.f(s, p = u[h++], c[p]);
    return s;
  }, zJ;
}
var GJ, w8e;
function Btt() {
  if (w8e) return GJ;
  w8e = 1;
  var t = wf();
  return GJ = t("document", "documentElement"), GJ;
}
var WJ, S8e;
function mg() {
  if (S8e) return WJ;
  S8e = 1;
  var t = Ys(), e = Ott(), r = pme(), n = AM(), a = Btt(), i = MG(), o = PG(), s = ">", l = "<", c = "prototype", u = "script", f = o("IE_PROTO"), h = function() {
  }, p = function(_) {
    return l + u + s + _ + l + "/" + u + s;
  }, g = function(_) {
    _.write(p("")), _.close();
    var C = _.parentWindow.Object;
    return _ = null, C;
  }, y = function() {
    var _ = i("iframe"), C = "java" + u + ":", x;
    return _.style.display = "none", a.appendChild(_), _.src = String(C), x = _.contentWindow.document, x.open(), x.write(p("document.F=Object")), x.close(), x.F;
  }, b, w = function() {
    try {
      b = new ActiveXObject("htmlfile");
    } catch {
    }
    w = typeof document < "u" ? document.domain && b ? g(b) : y() : g(b);
    for (var _ = r.length; _--; ) delete w[c][r[_]];
    return w();
  };
  return n[f] = !0, WJ = Object.create || function(C, x) {
    var S;
    return C !== null ? (h[c] = t(C), S = new h(), h[c] = null, S[f] = C) : S = w(), x === void 0 ? S : e.f(S, x);
  }, WJ;
}
var HJ = {}, UJ, _8e;
function Qh() {
  if (_8e) return UJ;
  _8e = 1;
  var t = Wa();
  return UJ = t([].slice), UJ;
}
var k8e;
function Ntt() {
  if (k8e) return HJ;
  k8e = 1;
  var t = Yh(), e = S0(), r = z8().f, n = Qh(), a = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], i = function(o) {
    try {
      return r(o);
    } catch {
      return n(a);
    }
  };
  return HJ.f = function(s) {
    return a && t(s) === "Window" ? i(s) : r(e(s));
  }, HJ;
}
var VJ, A8e;
function ep() {
  if (A8e) return VJ;
  A8e = 1;
  var t = Mtt(), e = Pd();
  return VJ = function(r, n, a) {
    return a.get && t(a.get, n, { getter: !0 }), a.set && t(a.set, n, { setter: !0 }), e.f(r, n, a);
  }, VJ;
}
var qJ = {}, T8e;
function $tt() {
  if (T8e) return qJ;
  T8e = 1;
  var t = Do();
  return qJ.f = t, qJ;
}
var KJ, E8e;
function Dtt() {
  if (E8e) return KJ;
  E8e = 1;
  var t = wi();
  return KJ = t, KJ;
}
var ZJ, I8e;
function Ltt() {
  if (I8e) return ZJ;
  I8e = 1;
  var t = Dtt(), e = Es(), r = $tt(), n = Pd().f;
  return ZJ = function(a) {
    var i = t.Symbol || (t.Symbol = {});
    e(i, a) || n(i, a, {
      value: r.f(a)
    });
  }, ZJ;
}
var JJ, M8e;
function Dhr() {
  if (M8e) return JJ;
  M8e = 1;
  var t = No(), e = wf(), r = Do(), n = Gu();
  return JJ = function() {
    var a = e("Symbol"), i = a && a.prototype, o = i && i.valueOf, s = r("toPrimitive");
    i && !i[s] && n(i, s, function(l) {
      return t(o, this);
    }, { arity: 1 });
  }, JJ;
}
var YJ, P8e;
function tp() {
  if (P8e) return YJ;
  P8e = 1;
  var t = Pd().f, e = Es(), r = Do(), n = r("toStringTag");
  return YJ = function(a, i, o) {
    a && !o && (a = a.prototype), a && !e(a, n) && t(a, n, { configurable: !0, value: i });
  }, YJ;
}
var XJ, R8e;
function yme() {
  if (R8e) return XJ;
  R8e = 1;
  var t = Yh(), e = Wa();
  return XJ = function(r) {
    if (t(r) === "Function") return e(r);
  }, XJ;
}
var QJ, O8e;
function gg() {
  if (O8e) return QJ;
  O8e = 1;
  var t = yme(), e = Sf(), r = wM(), n = t(t.bind);
  return QJ = function(a, i) {
    return e(a), i === void 0 ? a : r ? n(a, i) : function() {
      return a.apply(i, arguments);
    };
  }, QJ;
}
var eY, B8e;
function EM() {
  if (B8e) return eY;
  B8e = 1;
  var t = Yh();
  return eY = Array.isArray || function(r) {
    return t(r) === "Array";
  }, eY;
}
var tY, N8e;
function NG() {
  if (N8e) return tY;
  N8e = 1;
  var t = Wa(), e = Ba(), r = $o(), n = pg(), a = wf(), i = hme(), o = function() {
  }, s = a("Reflect", "construct"), l = /^\s*(?:class|function)\b/, c = t(l.exec), u = !l.test(o), f = function(g) {
    if (!r(g)) return !1;
    try {
      return s(o, [], g), !0;
    } catch {
      return !1;
    }
  }, h = function(g) {
    if (!r(g)) return !1;
    switch (n(g)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return u || !!c(l, i(g));
    } catch {
      return !0;
    }
  };
  return h.sham = !0, tY = !s || e(function() {
    var p;
    return f(f.call) || !f(Object) || !f(function() {
      p = !0;
    }) || p;
  }) ? h : f, tY;
}
var rY, $8e;
function Lhr() {
  if ($8e) return rY;
  $8e = 1;
  var t = EM(), e = NG(), r = fs(), n = Do(), a = n("species"), i = Array;
  return rY = function(o) {
    var s;
    return t(o) && (s = o.constructor, e(s) && (s === i || t(s.prototype)) ? s = void 0 : r(s) && (s = s[a], s === null && (s = void 0))), s === void 0 ? i : s;
  }, rY;
}
var nY, D8e;
function bme() {
  if (D8e) return nY;
  D8e = 1;
  var t = Lhr();
  return nY = function(e, r) {
    return new (t(e))(r === 0 ? 0 : r);
  }, nY;
}
var aY, L8e;
function Rd() {
  if (L8e) return aY;
  L8e = 1;
  var t = gg(), e = Wa(), r = SM(), n = ru(), a = nu(), i = bme(), o = e([].push), s = function(l) {
    var c = l === 1, u = l === 2, f = l === 3, h = l === 4, p = l === 6, g = l === 7, y = l === 5 || p;
    return function(b, w, _, C) {
      for (var x = n(b), S = r(x), A = a(S), I = t(w, _), M = 0, B = C || i, L = c ? B(b, A) : u || g ? B(b, 0) : void 0, N, d; A > M; M++) if ((y || M in S) && (N = S[M], d = I(N, M, x), l))
        if (c) L[M] = d;
        else if (d) switch (l) {
          case 3:
            return !0;
          // some
          case 5:
            return N;
          // find
          case 6:
            return M;
          // findIndex
          case 2:
            o(L, N);
        }
        else switch (l) {
          case 4:
            return !1;
          // every
          case 7:
            o(L, N);
        }
      return p ? -1 : f || h ? h : L;
    };
  };
  return aY = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: s(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: s(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: s(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: s(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: s(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: s(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: s(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: s(7)
  }, aY;
}
var j8e;
function jhr() {
  if (j8e) return v8e;
  j8e = 1;
  var t = Ya(), e = wi(), r = No(), n = Wa(), a = _f(), i = Go(), o = L8(), s = Ba(), l = Es(), c = dg(), u = Ys(), f = S0(), h = IG(), p = Vl(), g = r6(), y = mg(), b = TM(), w = z8(), _ = Ntt(), C = OG(), x = Fy(), S = Pd(), A = Ott(), I = EG(), M = Gu(), B = ep(), L = F8(), N = PG(), d = AM(), m = _M(), v = Do(), k = $tt(), O = Ltt(), G = Dhr(), H = tp(), j = _0(), F = Rd().forEach, z = N("hidden"), W = "Symbol", U = "prototype", Z = j.set, V = j.getterFor(W), Y = Object[U], ge = e.Symbol, ce = ge && ge[U], ee = e.RangeError, Se = e.TypeError, Ce = e.QObject, we = x.f, We = S.f, Fe = _.f, it = I.f, gt = n([].push), Ze = L("symbols"), Ne = L("op-symbols"), ze = L("wks"), ct = !Ce || !Ce[U] || !Ce[U].findChild, rt = function(re, ie, Ie) {
    var Ke = we(Y, ie);
    Ke && delete Y[ie], We(re, ie, Ie), Ke && re !== Y && We(Y, ie, Ke);
  }, qe = i && s(function() {
    return y(We({}, "a", {
      get: function() {
        return We(this, "a", { value: 7 }).a;
      }
    })).a !== 7;
  }) ? rt : We, nt = function(re, ie) {
    var Ie = Ze[re] = y(ce);
    return Z(Ie, {
      type: W,
      tag: re,
      description: ie
    }), i || (Ie.description = ie), Ie;
  }, Rt = function(ie, Ie, Ke) {
    ie === Y && Rt(Ne, Ie, Ke), u(ie);
    var Le = h(Ie);
    return u(Ke), l(Ze, Le) ? (Ke.enumerable ? (l(ie, z) && ie[z][Le] && (ie[z][Le] = !1), Ke = y(Ke, { enumerable: g(0, !1) })) : (l(ie, z) || We(ie, z, g(1, y(null))), ie[z][Le] = !0), qe(ie, Le, Ke)) : We(ie, Le, Ke);
  }, Ot = function(ie, Ie) {
    u(ie);
    var Ke = f(Ie), Le = b(Ke).concat(ne(Ke));
    return F(Le, function(Ge) {
      (!i || r(mt, Ke, Ge)) && Rt(ie, Ge, Ke[Ge]);
    }), ie;
  }, lt = function(ie, Ie) {
    return Ie === void 0 ? y(ie) : Ot(y(ie), Ie);
  }, mt = function(ie) {
    var Ie = h(ie), Ke = r(it, this, Ie);
    return this === Y && l(Ze, Ie) && !l(Ne, Ie) ? !1 : Ke || !l(this, Ie) || !l(Ze, Ie) || l(this, z) && this[z][Ie] ? Ke : !0;
  }, jt = function(ie, Ie) {
    var Ke = f(ie), Le = h(Ie);
    if (!(Ke === Y && l(Ze, Le) && !l(Ne, Le))) {
      var Ge = we(Ke, Le);
      return Ge && l(Ze, Le) && !(l(Ke, z) && Ke[z][Le]) && (Ge.enumerable = !0), Ge;
    }
  }, Jt = function(ie) {
    var Ie = Fe(f(ie)), Ke = [];
    return F(Ie, function(Le) {
      !l(Ze, Le) && !l(d, Le) && gt(Ke, Le);
    }), Ke;
  }, ne = function(re) {
    var ie = re === Y, Ie = Fe(ie ? Ne : f(re)), Ke = [];
    return F(Ie, function(Le) {
      l(Ze, Le) && (!ie || l(Y, Le)) && gt(Ke, Ze[Le]);
    }), Ke;
  };
  return o || (ge = function() {
    if (c(ce, this)) throw new Se("Symbol is not a constructor");
    var ie = !arguments.length || arguments[0] === void 0 ? void 0 : p(arguments[0]), Ie = m(ie), Ke = function(Le) {
      var Ge = this === void 0 ? e : this;
      Ge === Y && r(Ke, Ne, Le), l(Ge, z) && l(Ge[z], Ie) && (Ge[z][Ie] = !1);
      var ft = g(1, Le);
      try {
        qe(Ge, Ie, ft);
      } catch (ot) {
        if (!(ot instanceof ee)) throw ot;
        rt(Ge, Ie, ft);
      }
    };
    return i && ct && qe(Y, Ie, { configurable: !0, set: Ke }), nt(Ie, ie);
  }, ce = ge[U], M(ce, "toString", function() {
    return V(this).tag;
  }), M(ge, "withoutSetter", function(re) {
    return nt(m(re), re);
  }), I.f = mt, S.f = Rt, A.f = Ot, x.f = jt, w.f = _.f = Jt, C.f = ne, k.f = function(re) {
    return nt(v(re), re);
  }, i && (B(ce, "description", {
    configurable: !0,
    get: function() {
      return V(this).description;
    }
  }), a || M(Y, "propertyIsEnumerable", mt, { unsafe: !0 }))), t({ global: !0, constructor: !0, wrap: !0, forced: !o, sham: !o }, {
    Symbol: ge
  }), F(b(ze), function(re) {
    O(re);
  }), t({ target: W, stat: !0, forced: !o }, {
    useSetter: function() {
      ct = !0;
    },
    useSimple: function() {
      ct = !1;
    }
  }), t({ target: "Object", stat: !0, forced: !o, sham: !i }, {
    // `Object.create` method
    // https://tc39.es/ecma262/#sec-object.create
    create: lt,
    // `Object.defineProperty` method
    // https://tc39.es/ecma262/#sec-object.defineproperty
    defineProperty: Rt,
    // `Object.defineProperties` method
    // https://tc39.es/ecma262/#sec-object.defineproperties
    defineProperties: Ot,
    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
    getOwnPropertyDescriptor: jt
  }), t({ target: "Object", stat: !0, forced: !o }, {
    // `Object.getOwnPropertyNames` method
    // https://tc39.es/ecma262/#sec-object.getownpropertynames
    getOwnPropertyNames: Jt
  }), G(), H(ge, W), d[z] = !0, v8e;
}
var F8e = {}, iY, z8e;
function jtt() {
  if (z8e) return iY;
  z8e = 1;
  var t = L8();
  return iY = t && !!Symbol.for && !!Symbol.keyFor, iY;
}
var G8e;
function Fhr() {
  if (G8e) return F8e;
  G8e = 1;
  var t = Ya(), e = wf(), r = Es(), n = Vl(), a = F8(), i = jtt(), o = a("string-to-symbol-registry"), s = a("symbol-to-string-registry");
  return t({ target: "Symbol", stat: !0, forced: !i }, {
    for: function(l) {
      var c = n(l);
      if (r(o, c)) return o[c];
      var u = e("Symbol")(c);
      return o[c] = u, s[u] = c, u;
    }
  }), F8e;
}
var W8e = {}, H8e;
function zhr() {
  if (H8e) return W8e;
  H8e = 1;
  var t = Ya(), e = Es(), r = j8(), n = n6(), a = F8(), i = jtt(), o = a("symbol-to-string-registry");
  return t({ target: "Symbol", stat: !0, forced: !i }, {
    keyFor: function(l) {
      if (!r(l)) throw new TypeError(n(l) + " is not a symbol");
      if (e(o, l)) return o[l];
    }
  }), W8e;
}
var U8e = {}, oY, V8e;
function o6() {
  if (V8e) return oY;
  V8e = 1;
  var t = wM(), e = Function.prototype, r = e.apply, n = e.call;
  return oY = typeof Reflect == "object" && Reflect.apply || (t ? n.bind(r) : function() {
    return n.apply(r, arguments);
  }), oY;
}
var sY, q8e;
function Ghr() {
  if (q8e) return sY;
  q8e = 1;
  var t = Wa(), e = EM(), r = $o(), n = Yh(), a = Vl(), i = t([].push);
  return sY = function(o) {
    if (r(o)) return o;
    if (e(o)) {
      for (var s = o.length, l = [], c = 0; c < s; c++) {
        var u = o[c];
        typeof u == "string" ? i(l, u) : (typeof u == "number" || n(u) === "Number" || n(u) === "String") && i(l, a(u));
      }
      var f = l.length, h = !0;
      return function(p, g) {
        if (h)
          return h = !1, g;
        if (e(this)) return g;
        for (var y = 0; y < f; y++) if (l[y] === p) return g;
      };
    }
  }, sY;
}
var K8e;
function $G() {
  if (K8e) return U8e;
  K8e = 1;
  var t = Ya(), e = wf(), r = o6(), n = No(), a = Wa(), i = Ba(), o = $o(), s = j8(), l = Qh(), c = Ghr(), u = L8(), f = String, h = e("JSON", "stringify"), p = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), b = a("".replace), w = a(1 .toString), _ = /[\uD800-\uDFFF]/g, C = /^[\uD800-\uDBFF]$/, x = /^[\uDC00-\uDFFF]$/, S = !u || i(function() {
    var B = e("Symbol")("stringify detection");
    return h([B]) !== "[null]" || h({ a: B }) !== "{}" || h(Object(B)) !== "{}";
  }), A = i(function() {
    return h("\uDF06\uD834") !== '"\\udf06\\ud834"' || h("\uDEAD") !== '"\\udead"';
  }), I = function(B, L) {
    var N = l(arguments), d = c(L);
    if (!(!o(d) && (B === void 0 || s(B))))
      return N[1] = function(m, v) {
        if (o(d) && (v = n(d, this, f(m), v)), !s(v)) return v;
      }, r(h, null, N);
  }, M = function(B, L, N) {
    var d = g(N, L - 1), m = g(N, L + 1);
    return p(C, B) && !p(x, m) || p(x, B) && !p(C, d) ? "\\u" + w(y(B, 0), 16) : B;
  };
  return h && t({ target: "JSON", stat: !0, arity: 3, forced: S || A }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function(L, N, d) {
      var m = l(arguments), v = r(S ? I : h, null, m);
      return A && typeof v == "string" ? b(v, _, M) : v;
    }
  }), U8e;
}
var Z8e = {}, J8e;
function Whr() {
  if (J8e) return Z8e;
  J8e = 1;
  var t = Ya(), e = L8(), r = Ba(), n = OG(), a = ru(), i = !e || r(function() {
    n.f(1);
  });
  return t({ target: "Object", stat: !0, forced: i }, {
    getOwnPropertySymbols: function(s) {
      var l = n.f;
      return l ? l(a(s)) : [];
    }
  }), Z8e;
}
var Y8e;
function DG() {
  return Y8e || (Y8e = 1, jhr(), Fhr(), zhr(), $G(), Whr()), g8e;
}
var X8e = {}, lY, Q8e;
function IM() {
  if (Q8e) return lY;
  Q8e = 1;
  var t = Ba(), e = Do(), r = D8(), n = e("species");
  return lY = function(a) {
    return r >= 51 || !t(function() {
      var i = [], o = i.constructor = {};
      return o[n] = function() {
        return { foo: 1 };
      }, i[a](Boolean).foo !== 1;
    });
  }, lY;
}
var eCe;
function MM() {
  if (eCe) return X8e;
  eCe = 1;
  var t = Ya(), e = Rd().filter, r = IM(), n = r("filter");
  return t({ target: "Array", proto: !0, forced: !n }, {
    filter: function(i) {
      return e(this, i, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), X8e;
}
var tCe = {}, rCe;
function xme() {
  if (rCe) return tCe;
  rCe = 1;
  var t = Ya(), e = Ba(), r = S0(), n = Fy().f, a = Go(), i = !a || e(function() {
    n(1);
  });
  return t({ target: "Object", stat: !0, forced: i, sham: !a }, {
    getOwnPropertyDescriptor: function(s, l) {
      return n(r(s), l);
    }
  }), tCe;
}
var nCe = {}, cY, aCe;
function Ftt() {
  return aCe || (aCe = 1, cY = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), cY;
}
var uY, iCe;
function ztt() {
  if (iCe) return uY;
  iCe = 1;
  var t = MG(), e = t("span").classList, r = e && e.constructor && e.constructor.prototype;
  return uY = r === Object.prototype ? void 0 : r, uY;
}
var dY, oCe;
function LG() {
  if (oCe) return dY;
  oCe = 1;
  var t = Ba();
  return dY = function(e, r) {
    var n = [][e];
    return !!n && t(function() {
      n.call(null, r || function() {
        return 1;
      }, 1);
    });
  }, dY;
}
var fY, sCe;
function Hhr() {
  if (sCe) return fY;
  sCe = 1;
  var t = Rd().forEach, e = LG(), r = e("forEach");
  return fY = r ? [].forEach : function(a) {
    return t(this, a, arguments.length > 1 ? arguments[1] : void 0);
  }, fY;
}
var lCe;
function PM() {
  if (lCe) return nCe;
  lCe = 1;
  var t = wi(), e = Ftt(), r = ztt(), n = Hhr(), a = fg(), i = function(s) {
    if (s && s.forEach !== n) try {
      a(s, "forEach", n);
    } catch {
      s.forEach = n;
    }
  };
  for (var o in e)
    e[o] && i(t[o] && t[o].prototype);
  return i(r), nCe;
}
var cCe = {}, hY, uCe;
function RM() {
  if (uCe) return hY;
  uCe = 1;
  var t = Go(), e = Pd(), r = r6();
  return hY = function(n, a, i) {
    t ? e.f(n, a, r(0, i)) : n[a] = i;
  }, hY;
}
var dCe;
function Cme() {
  if (dCe) return cCe;
  dCe = 1;
  var t = Ya(), e = Go(), r = Rtt(), n = S0(), a = Fy(), i = RM();
  return t({ target: "Object", stat: !0, sham: !e }, {
    getOwnPropertyDescriptors: function(s) {
      for (var l = n(s), c = a.f, u = r(l), f = {}, h = 0, p, g; u.length > h; )
        g = c(l, p = u[h++]), g !== void 0 && i(f, p, g);
      return f;
    }
  }), cCe;
}
var fCe = {}, hCe;
function G8() {
  if (hCe) return fCe;
  hCe = 1;
  var t = Ya(), e = wi(), r = tp();
  return t({ global: !0 }, { Reflect: {} }), r(e.Reflect, "Reflect", !0), fCe;
}
var pCe = {}, pY, mCe;
function Uhr() {
  if (mCe) return pY;
  mCe = 1;
  var t = Wa(), e = Sf(), r = fs(), n = Es(), a = Qh(), i = wM(), o = Function, s = t([].concat), l = t([].join), c = {}, u = function(f, h, p) {
    if (!n(c, h)) {
      for (var g = [], y = 0; y < h; y++) g[y] = "a[" + y + "]";
      c[h] = o("C,a", "return new C(" + l(g, ",") + ")");
    }
    return c[h](f, p);
  };
  return pY = i ? o.bind : function(h) {
    var p = e(this), g = p.prototype, y = a(arguments, 1), b = function() {
      var _ = s(y, a(arguments));
      return this instanceof b ? u(p, _.length, _) : p.apply(h, _);
    };
    return r(g) && (b.prototype = g), b;
  }, pY;
}
var mY, gCe;
function wme() {
  if (gCe) return mY;
  gCe = 1;
  var t = NG(), e = n6(), r = TypeError;
  return mY = function(n) {
    if (t(n)) return n;
    throw new r(e(n) + " is not a constructor");
  }, mY;
}
var vCe;
function s6() {
  if (vCe) return pCe;
  vCe = 1;
  var t = Ya(), e = wf(), r = o6(), n = Uhr(), a = wme(), i = Ys(), o = fs(), s = mg(), l = Ba(), c = e("Reflect", "construct"), u = Object.prototype, f = [].push, h = l(function() {
    function y() {
    }
    return !(c(function() {
    }, [], y) instanceof y);
  }), p = !l(function() {
    c(function() {
    });
  }), g = h || p;
  return t({ target: "Reflect", stat: !0, forced: g, sham: g }, {
    construct: function(b, w) {
      a(b), i(w);
      var _ = arguments.length < 3 ? b : a(arguments[2]);
      if (p && !h) return c(b, w, _);
      if (b === _) {
        switch (w.length) {
          case 0:
            return new b();
          case 1:
            return new b(w[0]);
          case 2:
            return new b(w[0], w[1]);
          case 3:
            return new b(w[0], w[1], w[2]);
          case 4:
            return new b(w[0], w[1], w[2], w[3]);
        }
        var C = [null];
        return r(f, C, w), new (r(n, b, C))();
      }
      var x = _.prototype, S = s(o(x) ? x : u), A = r(b, S, w);
      return o(A) ? A : S;
    }
  }), pCe;
}
var gY = { exports: {} }, yCe;
function OM() {
  return yCe || (yCe = 1, function(t) {
    function e(n, a, i, o, s, l, c) {
      try {
        var u = n[l](c), f = u.value;
      } catch (h) {
        return void i(h);
      }
      u.done ? a(f) : Promise.resolve(f).then(o, s);
    }
    function r(n) {
      return function() {
        var a = this, i = arguments;
        return new Promise(function(o, s) {
          var l = n.apply(a, i);
          function c(f) {
            e(l, o, s, c, u, "next", f);
          }
          function u(f) {
            e(l, o, s, c, u, "throw", f);
          }
          c(void 0);
        });
      };
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(gY)), gY.exports;
}
var vY = { exports: {} }, bCe;
function zy() {
  return bCe || (bCe = 1, function(t) {
    function e(r, n) {
      if (!(r instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(vY)), vY.exports;
}
var yY = { exports: {} }, bY = { exports: {} }, xY = { exports: {} }, xCe;
function rp() {
  return xCe || (xCe = 1, function(t) {
    function e(r) {
      "@babel/helpers - typeof";
      return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(xY)), xY.exports;
}
var CY = { exports: {} }, CCe;
function Vhr() {
  return CCe || (CCe = 1, function(t) {
    var e = rp().default;
    function r(n, a) {
      if (e(n) != "object" || !n) return n;
      var i = n[Symbol.toPrimitive];
      if (i !== void 0) {
        var o = i.call(n, a || "default");
        if (e(o) != "object") return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(n);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(CY)), CY.exports;
}
var wCe;
function Gtt() {
  return wCe || (wCe = 1, function(t) {
    var e = rp().default, r = Vhr();
    function n(a) {
      var i = r(a, "string");
      return e(i) == "symbol" ? i : i + "";
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(bY)), bY.exports;
}
var SCe;
function Gy() {
  return SCe || (SCe = 1, function(t) {
    var e = Gtt();
    function r(a, i) {
      for (var o = 0; o < i.length; o++) {
        var s = i[o];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(a, e(s.key), s);
      }
    }
    function n(a, i, o) {
      return i && r(a.prototype, i), o && r(a, o), Object.defineProperty(a, "prototype", {
        writable: !1
      }), a;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(yY)), yY.exports;
}
var wY = { exports: {} }, _Ce;
function l6() {
  return _Ce || (_Ce = 1, function(t) {
    function e(r) {
      if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(wY)), wY.exports;
}
var SY = { exports: {} }, _Y = { exports: {} }, kCe;
function Sme() {
  return kCe || (kCe = 1, function(t) {
    function e(r, n) {
      return t.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, i) {
        return a.__proto__ = i, a;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r, n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(_Y)), _Y.exports;
}
var ACe;
function Wy() {
  return ACe || (ACe = 1, function(t) {
    var e = Sme();
    function r(n, a) {
      if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(a && a.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(n, "prototype", {
        writable: !1
      }), a && e(n, a);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(SY)), SY.exports;
}
var kY = { exports: {} }, TCe;
function Hy() {
  return TCe || (TCe = 1, function(t) {
    var e = rp().default, r = l6();
    function n(a, i) {
      if (i && (e(i) == "object" || typeof i == "function")) return i;
      if (i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return r(a);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(kY)), kY.exports;
}
var AY = { exports: {} }, ECe;
function np() {
  return ECe || (ECe = 1, function(t) {
    function e(r) {
      return t.exports = e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
        return n.__proto__ || Object.getPrototypeOf(n);
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(AY)), AY.exports;
}
var TY = { exports: {} }, ICe;
function c6() {
  return ICe || (ICe = 1, function(t) {
    var e = Gtt();
    function r(n, a, i) {
      return (a = e(a)) in n ? Object.defineProperty(n, a, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[a] = i, n;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(TY)), TY.exports;
}
var MCe = {}, PCe;
function jG() {
  if (PCe) return MCe;
  PCe = 1;
  var t = Ya(), e = Rd().map, r = IM(), n = r("map");
  return t({ target: "Array", proto: !0, forced: !n }, {
    map: function(i) {
      return e(this, i, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), MCe;
}
var RCe = {}, EY, OCe;
function qhr() {
  if (OCe) return EY;
  OCe = 1;
  var t = vme(), e = pg();
  return EY = t ? {}.toString : function() {
    return "[object " + e(this) + "]";
  }, EY;
}
var BCe;
function u6() {
  if (BCe) return RCe;
  BCe = 1;
  var t = vme(), e = Gu(), r = qhr();
  return t || e(Object.prototype, "toString", r, { unsafe: !0 }), RCe;
}
var NCe = {}, $Ce = {}, IY, DCe;
function Wtt() {
  if (DCe) return IY;
  DCe = 1;
  var t = wi(), e = jy(), r = Yh(), n = function(a) {
    return e.slice(0, a.length) === a;
  };
  return IY = function() {
    return n("Bun/") ? "BUN" : n("Cloudflare-Workers") ? "CLOUDFLARE" : n("Deno/") ? "DENO" : n("Node.js/") ? "NODE" : t.Bun && typeof Bun.version == "string" ? "BUN" : t.Deno && typeof Deno.version == "object" ? "DENO" : r(t.process) === "process" ? "NODE" : t.window && t.document ? "BROWSER" : "REST";
  }(), IY;
}
var MY, LCe;
function _me() {
  if (LCe) return MY;
  LCe = 1;
  var t = Wtt();
  return MY = t === "NODE", MY;
}
var PY, jCe;
function Khr() {
  if (jCe) return PY;
  jCe = 1;
  var t = Wa(), e = Sf();
  return PY = function(r, n, a) {
    try {
      return t(e(Object.getOwnPropertyDescriptor(r, n)[a]));
    } catch {
    }
  }, PY;
}
var RY, FCe;
function Zhr() {
  if (FCe) return RY;
  FCe = 1;
  var t = fs();
  return RY = function(e) {
    return t(e) || e === null;
  }, RY;
}
var OY, zCe;
function Jhr() {
  if (zCe) return OY;
  zCe = 1;
  var t = Zhr(), e = String, r = TypeError;
  return OY = function(n) {
    if (t(n)) return n;
    throw new r("Can't set " + e(n) + " as a prototype");
  }, OY;
}
var BY, GCe;
function W8() {
  if (GCe) return BY;
  GCe = 1;
  var t = Khr(), e = fs(), r = d2(), n = Jhr();
  return BY = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var a = !1, i = {}, o;
    try {
      o = t(Object.prototype, "__proto__", "set"), o(i, []), a = i instanceof Array;
    } catch {
    }
    return function(l, c) {
      return r(l), n(c), e(l) && (a ? o(l, c) : l.__proto__ = c), l;
    };
  }() : void 0), BY;
}
var NY, WCe;
function FG() {
  if (WCe) return NY;
  WCe = 1;
  var t = wf(), e = ep(), r = Do(), n = Go(), a = r("species");
  return NY = function(i) {
    var o = t(i);
    n && o && !o[a] && e(o, a, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, NY;
}
var $Y, HCe;
function Uy() {
  if (HCe) return $Y;
  HCe = 1;
  var t = dg(), e = TypeError;
  return $Y = function(r, n) {
    if (t(n, r)) return r;
    throw new e("Incorrect invocation");
  }, $Y;
}
var DY, UCe;
function Htt() {
  if (UCe) return DY;
  UCe = 1;
  var t = Ys(), e = wme(), r = u2(), n = Do(), a = n("species");
  return DY = function(i, o) {
    var s = t(i).constructor, l;
    return s === void 0 || r(l = t(s)[a]) ? o : e(l);
  }, DY;
}
var LY, VCe;
function kme() {
  if (VCe) return LY;
  VCe = 1;
  var t = TypeError;
  return LY = function(e, r) {
    if (e < r) throw new t("Not enough arguments");
    return e;
  }, LY;
}
var jY, qCe;
function Utt() {
  if (qCe) return jY;
  qCe = 1;
  var t = jy();
  return jY = /(?:ipad|iphone|ipod).*applewebkit/i.test(t), jY;
}
var FY, KCe;
function Vtt() {
  if (KCe) return FY;
  KCe = 1;
  var t = wi(), e = o6(), r = gg(), n = $o(), a = Es(), i = Ba(), o = Btt(), s = Qh(), l = MG(), c = kme(), u = Utt(), f = _me(), h = t.setImmediate, p = t.clearImmediate, g = t.process, y = t.Dispatch, b = t.Function, w = t.MessageChannel, _ = t.String, C = 0, x = {}, S = "onreadystatechange", A, I, M, B;
  i(function() {
    A = t.location;
  });
  var L = function(v) {
    if (a(x, v)) {
      var k = x[v];
      delete x[v], k();
    }
  }, N = function(v) {
    return function() {
      L(v);
    };
  }, d = function(v) {
    L(v.data);
  }, m = function(v) {
    t.postMessage(_(v), A.protocol + "//" + A.host);
  };
  return (!h || !p) && (h = function(k) {
    c(arguments.length, 1);
    var O = n(k) ? k : b(k), G = s(arguments, 1);
    return x[++C] = function() {
      e(O, void 0, G);
    }, I(C), C;
  }, p = function(k) {
    delete x[k];
  }, f ? I = function(v) {
    g.nextTick(N(v));
  } : y && y.now ? I = function(v) {
    y.now(N(v));
  } : w && !u ? (M = new w(), B = M.port2, M.port1.onmessage = d, I = r(B.postMessage, B)) : t.addEventListener && n(t.postMessage) && !t.importScripts && A && A.protocol !== "file:" && !i(m) ? (I = m, t.addEventListener("message", d, !1)) : S in l("script") ? I = function(v) {
    o.appendChild(l("script"))[S] = function() {
      o.removeChild(this), L(v);
    };
  } : I = function(v) {
    setTimeout(N(v), 0);
  }), FY = {
    set: h,
    clear: p
  }, FY;
}
var zY, ZCe;
function qtt() {
  if (ZCe) return zY;
  ZCe = 1;
  var t = wi(), e = Go(), r = Object.getOwnPropertyDescriptor;
  return zY = function(n) {
    if (!e) return t[n];
    var a = r(t, n);
    return a && a.value;
  }, zY;
}
var GY, JCe;
function Ktt() {
  if (JCe) return GY;
  JCe = 1;
  var t = function() {
    this.head = null, this.tail = null;
  };
  return t.prototype = {
    add: function(e) {
      var r = { item: e, next: null }, n = this.tail;
      n ? n.next = r : this.head = r, this.tail = r;
    },
    get: function() {
      var e = this.head;
      if (e) {
        var r = this.head = e.next;
        return r === null && (this.tail = null), e.item;
      }
    }
  }, GY = t, GY;
}
var WY, YCe;
function Yhr() {
  if (YCe) return WY;
  YCe = 1;
  var t = jy();
  return WY = /ipad|iphone|ipod/i.test(t) && typeof Pebble < "u", WY;
}
var HY, XCe;
function Xhr() {
  if (XCe) return HY;
  XCe = 1;
  var t = jy();
  return HY = /web0s(?!.*chrome)/i.test(t), HY;
}
var UY, QCe;
function Qhr() {
  if (QCe) return UY;
  QCe = 1;
  var t = wi(), e = qtt(), r = gg(), n = Vtt().set, a = Ktt(), i = Utt(), o = Yhr(), s = Xhr(), l = _me(), c = t.MutationObserver || t.WebKitMutationObserver, u = t.document, f = t.process, h = t.Promise, p = e("queueMicrotask"), g, y, b, w, _;
  if (!p) {
    var C = new a(), x = function() {
      var S, A;
      for (l && (S = f.domain) && S.exit(); A = C.get(); ) try {
        A();
      } catch (I) {
        throw C.head && g(), I;
      }
      S && S.enter();
    };
    !i && !l && !s && c && u ? (y = !0, b = u.createTextNode(""), new c(x).observe(b, { characterData: !0 }), g = function() {
      b.data = y = !y;
    }) : !o && h && h.resolve ? (w = h.resolve(void 0), w.constructor = h, _ = r(w.then, w), g = function() {
      _(x);
    }) : l ? g = function() {
      f.nextTick(x);
    } : (n = r(n, t), g = function() {
      n(x);
    }), p = function(S) {
      C.head || g(), C.add(S);
    };
  }
  return UY = p, UY;
}
var VY, ewe;
function epr() {
  return ewe || (ewe = 1, VY = function(t, e) {
    try {
      arguments.length === 1 ? console.error(t) : console.error(t, e);
    } catch {
    }
  }), VY;
}
var qY, twe;
function Ame() {
  return twe || (twe = 1, qY = function(t) {
    try {
      return { error: !1, value: t() };
    } catch (e) {
      return { error: !0, value: e };
    }
  }), qY;
}
var KY, rwe;
function BM() {
  if (rwe) return KY;
  rwe = 1;
  var t = wi();
  return KY = t.Promise, KY;
}
var ZY, nwe;
function NM() {
  if (nwe) return ZY;
  nwe = 1;
  var t = wi(), e = BM(), r = $o(), n = BG(), a = hme(), i = Do(), o = Wtt(), s = _f(), l = D8(), c = e && e.prototype, u = i("species"), f = !1, h = r(t.PromiseRejectionEvent), p = n("Promise", function() {
    var g = a(e), y = g !== String(e);
    if (!y && l === 66 || s && !(c.catch && c.finally)) return !0;
    if (!l || l < 51 || !/native code/.test(g)) {
      var b = new e(function(C) {
        C(1);
      }), w = function(C) {
        C(function() {
        }, function() {
        });
      }, _ = b.constructor = {};
      if (_[u] = w, f = b.then(function() {
      }) instanceof w, !f) return !0;
    }
    return !y && (o === "BROWSER" || o === "DENO") && !h;
  });
  return ZY = {
    CONSTRUCTOR: p,
    REJECTION_EVENT: h,
    SUBCLASSING: f
  }, ZY;
}
var JY = {}, awe;
function $M() {
  if (awe) return JY;
  awe = 1;
  var t = Sf(), e = TypeError, r = function(n) {
    var a, i;
    this.promise = new n(function(o, s) {
      if (a !== void 0 || i !== void 0) throw new e("Bad Promise constructor");
      a = o, i = s;
    }), this.resolve = t(a), this.reject = t(i);
  };
  return JY.f = function(n) {
    return new r(n);
  }, JY;
}
var iwe;
function tpr() {
  if (iwe) return $Ce;
  iwe = 1;
  var t = Ya(), e = _f(), r = _me(), n = wi(), a = No(), i = Gu(), o = W8(), s = tp(), l = FG(), c = Sf(), u = $o(), f = fs(), h = Uy(), p = Htt(), g = Vtt().set, y = Qhr(), b = epr(), w = Ame(), _ = Ktt(), C = _0(), x = BM(), S = NM(), A = $M(), I = "Promise", M = S.CONSTRUCTOR, B = S.REJECTION_EVENT, L = S.SUBCLASSING, N = C.getterFor(I), d = C.set, m = x && x.prototype, v = x, k = m, O = n.TypeError, G = n.document, H = n.process, j = A.f, F = j, z = !!(G && G.createEvent && n.dispatchEvent), W = "unhandledrejection", U = "rejectionhandled", Z = 0, V = 1, Y = 2, ge = 1, ce = 2, ee, Se, Ce, we, We = function(nt) {
    var Rt;
    return f(nt) && u(Rt = nt.then) ? Rt : !1;
  }, Fe = function(nt, Rt) {
    var Ot = Rt.value, lt = Rt.state === V, mt = lt ? nt.ok : nt.fail, jt = nt.resolve, Jt = nt.reject, ne = nt.domain, re, ie, Ie;
    try {
      mt ? (lt || (Rt.rejection === ce && ze(Rt), Rt.rejection = ge), mt === !0 ? re = Ot : (ne && ne.enter(), re = mt(Ot), ne && (ne.exit(), Ie = !0)), re === nt.promise ? Jt(new O("Promise-chain cycle")) : (ie = We(re)) ? a(ie, re, jt, Jt) : jt(re)) : Jt(Ot);
    } catch (Ke) {
      ne && !Ie && ne.exit(), Jt(Ke);
    }
  }, it = function(nt, Rt) {
    nt.notified || (nt.notified = !0, y(function() {
      for (var Ot = nt.reactions, lt; lt = Ot.get(); )
        Fe(lt, nt);
      nt.notified = !1, Rt && !nt.rejection && Ze(nt);
    }));
  }, gt = function(nt, Rt, Ot) {
    var lt, mt;
    z ? (lt = G.createEvent("Event"), lt.promise = Rt, lt.reason = Ot, lt.initEvent(nt, !1, !0), n.dispatchEvent(lt)) : lt = { promise: Rt, reason: Ot }, !B && (mt = n["on" + nt]) ? mt(lt) : nt === W && b("Unhandled promise rejection", Ot);
  }, Ze = function(nt) {
    a(g, n, function() {
      var Rt = nt.facade, Ot = nt.value, lt = Ne(nt), mt;
      if (lt && (mt = w(function() {
        r ? H.emit("unhandledRejection", Ot, Rt) : gt(W, Rt, Ot);
      }), nt.rejection = r || Ne(nt) ? ce : ge, mt.error))
        throw mt.value;
    });
  }, Ne = function(nt) {
    return nt.rejection !== ge && !nt.parent;
  }, ze = function(nt) {
    a(g, n, function() {
      var Rt = nt.facade;
      r ? H.emit("rejectionHandled", Rt) : gt(U, Rt, nt.value);
    });
  }, ct = function(nt, Rt, Ot) {
    return function(lt) {
      nt(Rt, lt, Ot);
    };
  }, rt = function(nt, Rt, Ot) {
    nt.done || (nt.done = !0, Ot && (nt = Ot), nt.value = Rt, nt.state = Y, it(nt, !0));
  }, qe = function(nt, Rt, Ot) {
    if (!nt.done) {
      nt.done = !0, Ot && (nt = Ot);
      try {
        if (nt.facade === Rt) throw new O("Promise can't be resolved itself");
        var lt = We(Rt);
        lt ? y(function() {
          var mt = { done: !1 };
          try {
            a(
              lt,
              Rt,
              ct(qe, mt, nt),
              ct(rt, mt, nt)
            );
          } catch (jt) {
            rt(mt, jt, nt);
          }
        }) : (nt.value = Rt, nt.state = V, it(nt, !1));
      } catch (mt) {
        rt({ done: !1 }, mt, nt);
      }
    }
  };
  if (M && (v = function(Rt) {
    h(this, k), c(Rt), a(ee, this);
    var Ot = N(this);
    try {
      Rt(ct(qe, Ot), ct(rt, Ot));
    } catch (lt) {
      rt(Ot, lt);
    }
  }, k = v.prototype, ee = function(Rt) {
    d(this, {
      type: I,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: new _(),
      rejection: !1,
      state: Z,
      value: null
    });
  }, ee.prototype = i(k, "then", function(Rt, Ot) {
    var lt = N(this), mt = j(p(this, v));
    return lt.parent = !0, mt.ok = u(Rt) ? Rt : !0, mt.fail = u(Ot) && Ot, mt.domain = r ? H.domain : void 0, lt.state === Z ? lt.reactions.add(mt) : y(function() {
      Fe(mt, lt);
    }), mt.promise;
  }), Se = function() {
    var nt = new ee(), Rt = N(nt);
    this.promise = nt, this.resolve = ct(qe, Rt), this.reject = ct(rt, Rt);
  }, A.f = j = function(nt) {
    return nt === v || nt === Ce ? new Se(nt) : F(nt);
  }, !e && u(x) && m !== Object.prototype)) {
    we = m.then, L || i(m, "then", function(Rt, Ot) {
      var lt = this;
      return new v(function(mt, jt) {
        a(we, lt, mt, jt);
      }).then(Rt, Ot);
    }, { unsafe: !0 });
    try {
      delete m.constructor;
    } catch {
    }
    o && o(m, k);
  }
  return t({ global: !0, constructor: !0, wrap: !0, forced: M }, {
    Promise: v
  }), s(v, I, !1, !0), l(I), $Ce;
}
var owe = {}, YY, swe;
function DM() {
  return swe || (swe = 1, YY = {}), YY;
}
var XY, lwe;
function Tme() {
  if (lwe) return XY;
  lwe = 1;
  var t = Do(), e = DM(), r = t("iterator"), n = Array.prototype;
  return XY = function(a) {
    return a !== void 0 && (e.Array === a || n[r] === a);
  }, XY;
}
var QY, cwe;
function LM() {
  if (cwe) return QY;
  cwe = 1;
  var t = pg(), e = a6(), r = u2(), n = DM(), a = Do(), i = a("iterator");
  return QY = function(o) {
    if (!r(o)) return e(o, i) || e(o, "@@iterator") || n[t(o)];
  }, QY;
}
var eX, uwe;
function zG() {
  if (uwe) return eX;
  uwe = 1;
  var t = No(), e = Sf(), r = Ys(), n = n6(), a = LM(), i = TypeError;
  return eX = function(o, s) {
    var l = arguments.length < 2 ? a(o) : s;
    if (e(l)) return r(t(l, o));
    throw new i(n(o) + " is not iterable");
  }, eX;
}
var tX, dwe;
function Ztt() {
  if (dwe) return tX;
  dwe = 1;
  var t = No(), e = Ys(), r = a6();
  return tX = function(n, a, i) {
    var o, s;
    e(n);
    try {
      if (o = r(n, "return"), !o) {
        if (a === "throw") throw i;
        return i;
      }
      o = t(o, n);
    } catch (l) {
      s = !0, o = l;
    }
    if (a === "throw") throw i;
    if (s) throw o;
    return e(o), i;
  }, tX;
}
var rX, fwe;
function jM() {
  if (fwe) return rX;
  fwe = 1;
  var t = gg(), e = No(), r = Ys(), n = n6(), a = Tme(), i = nu(), o = dg(), s = zG(), l = LM(), c = Ztt(), u = TypeError, f = function(p, g) {
    this.stopped = p, this.result = g;
  }, h = f.prototype;
  return rX = function(p, g, y) {
    var b = y && y.that, w = !!(y && y.AS_ENTRIES), _ = !!(y && y.IS_RECORD), C = !!(y && y.IS_ITERATOR), x = !!(y && y.INTERRUPTED), S = t(g, b), A, I, M, B, L, N, d, m = function(k) {
      return A && c(A, "normal", k), new f(!0, k);
    }, v = function(k) {
      return w ? (r(k), x ? S(k[0], k[1], m) : S(k[0], k[1])) : x ? S(k, m) : S(k);
    };
    if (_)
      A = p.iterator;
    else if (C)
      A = p;
    else {
      if (I = l(p), !I) throw new u(n(p) + " is not iterable");
      if (a(I)) {
        for (M = 0, B = i(p); B > M; M++)
          if (L = v(p[M]), L && o(h, L)) return L;
        return new f(!1);
      }
      A = s(p, I);
    }
    for (N = _ ? p.next : A.next; !(d = e(N, A)).done; ) {
      try {
        L = v(d.value);
      } catch (k) {
        c(A, "throw", k);
      }
      if (typeof L == "object" && L && o(h, L)) return L;
    }
    return new f(!1);
  }, rX;
}
var nX, hwe;
function GG() {
  if (hwe) return nX;
  hwe = 1;
  var t = Do(), e = t("iterator"), r = !1;
  try {
    var n = 0, a = {
      next: function() {
        return { done: !!n++ };
      },
      return: function() {
        r = !0;
      }
    };
    a[e] = function() {
      return this;
    }, Array.from(a, function() {
      throw 2;
    });
  } catch {
  }
  return nX = function(i, o) {
    try {
      if (!o && !r) return !1;
    } catch {
      return !1;
    }
    var s = !1;
    try {
      var l = {};
      l[e] = function() {
        return {
          next: function() {
            return { done: s = !0 };
          }
        };
      }, i(l);
    } catch {
    }
    return s;
  }, nX;
}
var aX, pwe;
function Jtt() {
  if (pwe) return aX;
  pwe = 1;
  var t = BM(), e = GG(), r = NM().CONSTRUCTOR;
  return aX = r || !e(function(n) {
    t.all(n).then(void 0, function() {
    });
  }), aX;
}
var mwe;
function rpr() {
  if (mwe) return owe;
  mwe = 1;
  var t = Ya(), e = No(), r = Sf(), n = $M(), a = Ame(), i = jM(), o = Jtt();
  return t({ target: "Promise", stat: !0, forced: o }, {
    all: function(l) {
      var c = this, u = n.f(c), f = u.resolve, h = u.reject, p = a(function() {
        var g = r(c.resolve), y = [], b = 0, w = 1;
        i(l, function(_) {
          var C = b++, x = !1;
          w++, e(g, c, _).then(function(S) {
            x || (x = !0, y[C] = S, --w || f(y));
          }, h);
        }), --w || f(y);
      });
      return p.error && h(p.value), u.promise;
    }
  }), owe;
}
var gwe = {}, vwe;
function npr() {
  if (vwe) return gwe;
  vwe = 1;
  var t = Ya(), e = _f(), r = NM().CONSTRUCTOR, n = BM(), a = wf(), i = $o(), o = Gu(), s = n && n.prototype;
  if (t({ target: "Promise", proto: !0, forced: r, real: !0 }, {
    catch: function(c) {
      return this.then(void 0, c);
    }
  }), !e && i(n)) {
    var l = a("Promise").prototype.catch;
    s.catch !== l && o(s, "catch", l, { unsafe: !0 });
  }
  return gwe;
}
var ywe = {}, bwe;
function apr() {
  if (bwe) return ywe;
  bwe = 1;
  var t = Ya(), e = No(), r = Sf(), n = $M(), a = Ame(), i = jM(), o = Jtt();
  return t({ target: "Promise", stat: !0, forced: o }, {
    race: function(l) {
      var c = this, u = n.f(c), f = u.reject, h = a(function() {
        var p = r(c.resolve);
        i(l, function(g) {
          e(p, c, g).then(u.resolve, f);
        });
      });
      return h.error && f(h.value), u.promise;
    }
  }), ywe;
}
var xwe = {}, Cwe;
function ipr() {
  if (Cwe) return xwe;
  Cwe = 1;
  var t = Ya(), e = $M(), r = NM().CONSTRUCTOR;
  return t({ target: "Promise", stat: !0, forced: r }, {
    reject: function(a) {
      var i = e.f(this), o = i.reject;
      return o(a), i.promise;
    }
  }), xwe;
}
var wwe = {}, iX, Swe;
function opr() {
  if (Swe) return iX;
  Swe = 1;
  var t = Ys(), e = fs(), r = $M();
  return iX = function(n, a) {
    if (t(n), e(a) && a.constructor === n) return a;
    var i = r.f(n), o = i.resolve;
    return o(a), i.promise;
  }, iX;
}
var _we;
function spr() {
  if (_we) return wwe;
  _we = 1;
  var t = Ya(), e = wf(), r = _f(), n = BM(), a = NM().CONSTRUCTOR, i = opr(), o = e("Promise"), s = r && !a;
  return t({ target: "Promise", stat: !0, forced: r || a }, {
    resolve: function(c) {
      return i(s && this === o ? n : this, c);
    }
  }), wwe;
}
var kwe;
function d6() {
  return kwe || (kwe = 1, tpr(), rpr(), npr(), apr(), ipr(), spr()), NCe;
}
var oX = { exports: {} }, Awe;
function lpr() {
  return Awe || (Awe = 1, function(t) {
    var e = rp().default;
    function r() {
      t.exports = r = function() {
        return a;
      }, t.exports.__esModule = !0, t.exports.default = t.exports;
      var n, a = {}, i = Object.prototype, o = i.hasOwnProperty, s = Object.defineProperty || function(j, F, z) {
        j[F] = z.value;
      }, l = typeof Symbol == "function" ? Symbol : {}, c = l.iterator || "@@iterator", u = l.asyncIterator || "@@asyncIterator", f = l.toStringTag || "@@toStringTag";
      function h(j, F, z) {
        return Object.defineProperty(j, F, {
          value: z,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), j[F];
      }
      try {
        h({}, "");
      } catch {
        h = function(z, W, U) {
          return z[W] = U;
        };
      }
      function p(j, F, z, W) {
        var U = F && F.prototype instanceof x ? F : x, Z = Object.create(U.prototype), V = new G(W || []);
        return s(Z, "_invoke", {
          value: m(j, z, V)
        }), Z;
      }
      function g(j, F, z) {
        try {
          return {
            type: "normal",
            arg: j.call(F, z)
          };
        } catch (W) {
          return {
            type: "throw",
            arg: W
          };
        }
      }
      a.wrap = p;
      var y = "suspendedStart", b = "suspendedYield", w = "executing", _ = "completed", C = {};
      function x() {
      }
      function S() {
      }
      function A() {
      }
      var I = {};
      h(I, c, function() {
        return this;
      });
      var M = Object.getPrototypeOf, B = M && M(M(H([])));
      B && B !== i && o.call(B, c) && (I = B);
      var L = A.prototype = x.prototype = Object.create(I);
      function N(j) {
        ["next", "throw", "return"].forEach(function(F) {
          h(j, F, function(z) {
            return this._invoke(F, z);
          });
        });
      }
      function d(j, F) {
        function z(U, Z, V, Y) {
          var ge = g(j[U], j, Z);
          if (ge.type !== "throw") {
            var ce = ge.arg, ee = ce.value;
            return ee && e(ee) == "object" && o.call(ee, "__await") ? F.resolve(ee.__await).then(function(Se) {
              z("next", Se, V, Y);
            }, function(Se) {
              z("throw", Se, V, Y);
            }) : F.resolve(ee).then(function(Se) {
              ce.value = Se, V(ce);
            }, function(Se) {
              return z("throw", Se, V, Y);
            });
          }
          Y(ge.arg);
        }
        var W;
        s(this, "_invoke", {
          value: function(Z, V) {
            function Y() {
              return new F(function(ge, ce) {
                z(Z, V, ge, ce);
              });
            }
            return W = W ? W.then(Y, Y) : Y();
          }
        });
      }
      function m(j, F, z) {
        var W = y;
        return function(U, Z) {
          if (W === w) throw Error("Generator is already running");
          if (W === _) {
            if (U === "throw") throw Z;
            return {
              value: n,
              done: !0
            };
          }
          for (z.method = U, z.arg = Z; ; ) {
            var V = z.delegate;
            if (V) {
              var Y = v(V, z);
              if (Y) {
                if (Y === C) continue;
                return Y;
              }
            }
            if (z.method === "next") z.sent = z._sent = z.arg;
            else if (z.method === "throw") {
              if (W === y) throw W = _, z.arg;
              z.dispatchException(z.arg);
            } else z.method === "return" && z.abrupt("return", z.arg);
            W = w;
            var ge = g(j, F, z);
            if (ge.type === "normal") {
              if (W = z.done ? _ : b, ge.arg === C) continue;
              return {
                value: ge.arg,
                done: z.done
              };
            }
            ge.type === "throw" && (W = _, z.method = "throw", z.arg = ge.arg);
          }
        };
      }
      function v(j, F) {
        var z = F.method, W = j.iterator[z];
        if (W === n) return F.delegate = null, z === "throw" && j.iterator.return && (F.method = "return", F.arg = n, v(j, F), F.method === "throw") || z !== "return" && (F.method = "throw", F.arg = new TypeError("The iterator does not provide a '" + z + "' method")), C;
        var U = g(W, j.iterator, F.arg);
        if (U.type === "throw") return F.method = "throw", F.arg = U.arg, F.delegate = null, C;
        var Z = U.arg;
        return Z ? Z.done ? (F[j.resultName] = Z.value, F.next = j.nextLoc, F.method !== "return" && (F.method = "next", F.arg = n), F.delegate = null, C) : Z : (F.method = "throw", F.arg = new TypeError("iterator result is not an object"), F.delegate = null, C);
      }
      function k(j) {
        var F = {
          tryLoc: j[0]
        };
        1 in j && (F.catchLoc = j[1]), 2 in j && (F.finallyLoc = j[2], F.afterLoc = j[3]), this.tryEntries.push(F);
      }
      function O(j) {
        var F = j.completion || {};
        F.type = "normal", delete F.arg, j.completion = F;
      }
      function G(j) {
        this.tryEntries = [{
          tryLoc: "root"
        }], j.forEach(k, this), this.reset(!0);
      }
      function H(j) {
        if (j || j === "") {
          var F = j[c];
          if (F) return F.call(j);
          if (typeof j.next == "function") return j;
          if (!isNaN(j.length)) {
            var z = -1, W = function U() {
              for (; ++z < j.length; ) if (o.call(j, z)) return U.value = j[z], U.done = !1, U;
              return U.value = n, U.done = !0, U;
            };
            return W.next = W;
          }
        }
        throw new TypeError(e(j) + " is not iterable");
      }
      return S.prototype = A, s(L, "constructor", {
        value: A,
        configurable: !0
      }), s(A, "constructor", {
        value: S,
        configurable: !0
      }), S.displayName = h(A, f, "GeneratorFunction"), a.isGeneratorFunction = function(j) {
        var F = typeof j == "function" && j.constructor;
        return !!F && (F === S || (F.displayName || F.name) === "GeneratorFunction");
      }, a.mark = function(j) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(j, A) : (j.__proto__ = A, h(j, f, "GeneratorFunction")), j.prototype = Object.create(L), j;
      }, a.awrap = function(j) {
        return {
          __await: j
        };
      }, N(d.prototype), h(d.prototype, u, function() {
        return this;
      }), a.AsyncIterator = d, a.async = function(j, F, z, W, U) {
        U === void 0 && (U = Promise);
        var Z = new d(p(j, F, z, W), U);
        return a.isGeneratorFunction(F) ? Z : Z.next().then(function(V) {
          return V.done ? V.value : Z.next();
        });
      }, N(L), h(L, f, "Generator"), h(L, c, function() {
        return this;
      }), h(L, "toString", function() {
        return "[object Generator]";
      }), a.keys = function(j) {
        var F = Object(j), z = [];
        for (var W in F) z.push(W);
        return z.reverse(), function U() {
          for (; z.length; ) {
            var Z = z.pop();
            if (Z in F) return U.value = Z, U.done = !1, U;
          }
          return U.done = !0, U;
        };
      }, a.values = H, G.prototype = {
        constructor: G,
        reset: function(F) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(O), !F) for (var z in this) z.charAt(0) === "t" && o.call(this, z) && !isNaN(+z.slice(1)) && (this[z] = n);
        },
        stop: function() {
          this.done = !0;
          var F = this.tryEntries[0].completion;
          if (F.type === "throw") throw F.arg;
          return this.rval;
        },
        dispatchException: function(F) {
          if (this.done) throw F;
          var z = this;
          function W(ce, ee) {
            return V.type = "throw", V.arg = F, z.next = ce, ee && (z.method = "next", z.arg = n), !!ee;
          }
          for (var U = this.tryEntries.length - 1; U >= 0; --U) {
            var Z = this.tryEntries[U], V = Z.completion;
            if (Z.tryLoc === "root") return W("end");
            if (Z.tryLoc <= this.prev) {
              var Y = o.call(Z, "catchLoc"), ge = o.call(Z, "finallyLoc");
              if (Y && ge) {
                if (this.prev < Z.catchLoc) return W(Z.catchLoc, !0);
                if (this.prev < Z.finallyLoc) return W(Z.finallyLoc);
              } else if (Y) {
                if (this.prev < Z.catchLoc) return W(Z.catchLoc, !0);
              } else {
                if (!ge) throw Error("try statement without catch or finally");
                if (this.prev < Z.finallyLoc) return W(Z.finallyLoc);
              }
            }
          }
        },
        abrupt: function(F, z) {
          for (var W = this.tryEntries.length - 1; W >= 0; --W) {
            var U = this.tryEntries[W];
            if (U.tryLoc <= this.prev && o.call(U, "finallyLoc") && this.prev < U.finallyLoc) {
              var Z = U;
              break;
            }
          }
          Z && (F === "break" || F === "continue") && Z.tryLoc <= z && z <= Z.finallyLoc && (Z = null);
          var V = Z ? Z.completion : {};
          return V.type = F, V.arg = z, Z ? (this.method = "next", this.next = Z.finallyLoc, C) : this.complete(V);
        },
        complete: function(F, z) {
          if (F.type === "throw") throw F.arg;
          return F.type === "break" || F.type === "continue" ? this.next = F.arg : F.type === "return" ? (this.rval = this.arg = F.arg, this.method = "return", this.next = "end") : F.type === "normal" && z && (this.next = z), C;
        },
        finish: function(F) {
          for (var z = this.tryEntries.length - 1; z >= 0; --z) {
            var W = this.tryEntries[z];
            if (W.finallyLoc === F) return this.complete(W.completion, W.afterLoc), O(W), C;
          }
        },
        catch: function(F) {
          for (var z = this.tryEntries.length - 1; z >= 0; --z) {
            var W = this.tryEntries[z];
            if (W.tryLoc === F) {
              var U = W.completion;
              if (U.type === "throw") {
                var Z = U.arg;
                O(W);
              }
              return Z;
            }
          }
          throw Error("illegal catch attempt");
        },
        delegateYield: function(F, z, W) {
          return this.delegate = {
            iterator: H(F),
            resultName: z,
            nextLoc: W
          }, this.method === "next" && (this.arg = n), C;
        }
      }, a;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(oX)), oX.exports;
}
var sX, Twe;
function FM() {
  if (Twe) return sX;
  Twe = 1;
  var t = lpr()();
  sX = t;
  try {
    regeneratorRuntime = t;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
  return sX;
}
var mc = {}, Ewe = {}, Iwe;
function Eme() {
  if (Iwe) return Ewe;
  Iwe = 1;
  var t = Go(), e = kM().EXISTS, r = Wa(), n = ep(), a = Function.prototype, i = r(a.toString), o = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/, s = r(o.exec), l = "name";
  return t && !e && n(a, l, {
    configurable: !0,
    get: function() {
      try {
        return s(o, i(this))[1];
      } catch {
        return "";
      }
    }
  }), Ewe;
}
var lX = { exports: {} }, cX = { exports: {} }, Mwe;
function cpr() {
  return Mwe || (Mwe = 1, function(t) {
    function e(r) {
      if (Array.isArray(r)) return r;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(cX)), cX.exports;
}
var uX = { exports: {} }, Pwe;
function upr() {
  return Pwe || (Pwe = 1, function(t) {
    function e(r, n) {
      var a = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
      if (a != null) {
        var i, o, s, l, c = [], u = !0, f = !1;
        try {
          if (s = (a = a.call(r)).next, n === 0) {
            if (Object(a) !== a) return;
            u = !1;
          } else for (; !(u = (i = s.call(a)).done) && (c.push(i.value), c.length !== n); u = !0) ;
        } catch (h) {
          f = !0, o = h;
        } finally {
          try {
            if (!u && a.return != null && (l = a.return(), Object(l) !== l)) return;
          } finally {
            if (f) throw o;
          }
        }
        return c;
      }
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(uX)), uX.exports;
}
var dX = { exports: {} }, fX = { exports: {} }, Rwe;
function Ytt() {
  return Rwe || (Rwe = 1, function(t) {
    function e(r, n) {
      (n == null || n > r.length) && (n = r.length);
      for (var a = 0, i = Array(n); a < n; a++) i[a] = r[a];
      return i;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(fX)), fX.exports;
}
var Owe;
function Xtt() {
  return Owe || (Owe = 1, function(t) {
    var e = Ytt();
    function r(n, a) {
      if (n) {
        if (typeof n == "string") return e(n, a);
        var i = {}.toString.call(n).slice(8, -1);
        return i === "Object" && n.constructor && (i = n.constructor.name), i === "Map" || i === "Set" ? Array.from(n) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? e(n, a) : void 0;
      }
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(dX)), dX.exports;
}
var hX = { exports: {} }, Bwe;
function dpr() {
  return Bwe || (Bwe = 1, function(t) {
    function e() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(hX)), hX.exports;
}
var Nwe;
function WG() {
  return Nwe || (Nwe = 1, function(t) {
    var e = cpr(), r = upr(), n = Xtt(), a = dpr();
    function i(o, s) {
      return e(o) || r(o, s) || n(o, s) || a();
    }
    t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(lX)), lX.exports;
}
var pX, $we;
function Ime() {
  if ($we) return pX;
  $we = 1;
  var t = Do(), e = mg(), r = Pd().f, n = t("unscopables"), a = Array.prototype;
  return a[n] === void 0 && r(a, n, {
    configurable: !0,
    value: e(null)
  }), pX = function(i) {
    a[n][i] = !0;
  }, pX;
}
var mX, Dwe;
function fpr() {
  if (Dwe) return mX;
  Dwe = 1;
  var t = Ba();
  return mX = !t(function() {
    function e() {
    }
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }), mX;
}
var gX, Lwe;
function zM() {
  if (Lwe) return gX;
  Lwe = 1;
  var t = Es(), e = $o(), r = ru(), n = PG(), a = fpr(), i = n("IE_PROTO"), o = Object, s = o.prototype;
  return gX = a ? o.getPrototypeOf : function(l) {
    var c = r(l);
    if (t(c, i)) return c[i];
    var u = c.constructor;
    return e(u) && c instanceof u ? u.prototype : c instanceof o ? s : null;
  }, gX;
}
var vX, jwe;
function Qtt() {
  if (jwe) return vX;
  jwe = 1;
  var t = Ba(), e = $o(), r = fs(), n = mg(), a = zM(), i = Gu(), o = Do(), s = _f(), l = o("iterator"), c = !1, u, f, h;
  [].keys && (h = [].keys(), "next" in h ? (f = a(a(h)), f !== Object.prototype && (u = f)) : c = !0);
  var p = !r(u) || t(function() {
    var g = {};
    return u[l].call(g) !== g;
  });
  return p ? u = {} : s && (u = n(u)), e(u[l]) || i(u, l, function() {
    return this;
  }), vX = {
    IteratorPrototype: u,
    BUGGY_SAFARI_ITERATORS: c
  }, vX;
}
var yX, Fwe;
function ert() {
  if (Fwe) return yX;
  Fwe = 1;
  var t = Qtt().IteratorPrototype, e = mg(), r = r6(), n = tp(), a = DM(), i = function() {
    return this;
  };
  return yX = function(o, s, l, c) {
    var u = s + " Iterator";
    return o.prototype = e(t, { next: r(+!c, l) }), n(o, u, !1, !0), a[u] = i, o;
  }, yX;
}
var bX, zwe;
function Mme() {
  if (zwe) return bX;
  zwe = 1;
  var t = Ya(), e = No(), r = _f(), n = kM(), a = $o(), i = ert(), o = zM(), s = W8(), l = tp(), c = fg(), u = Gu(), f = Do(), h = DM(), p = Qtt(), g = n.PROPER, y = n.CONFIGURABLE, b = p.IteratorPrototype, w = p.BUGGY_SAFARI_ITERATORS, _ = f("iterator"), C = "keys", x = "values", S = "entries", A = function() {
    return this;
  };
  return bX = function(I, M, B, L, N, d, m) {
    i(B, M, L);
    var v = function(Z) {
      if (Z === N && j) return j;
      if (!w && Z && Z in G) return G[Z];
      switch (Z) {
        case C:
          return function() {
            return new B(this, Z);
          };
        case x:
          return function() {
            return new B(this, Z);
          };
        case S:
          return function() {
            return new B(this, Z);
          };
      }
      return function() {
        return new B(this);
      };
    }, k = M + " Iterator", O = !1, G = I.prototype, H = G[_] || G["@@iterator"] || N && G[N], j = !w && H || v(N), F = M === "Array" && G.entries || H, z, W, U;
    if (F && (z = o(F.call(new I())), z !== Object.prototype && z.next && (!r && o(z) !== b && (s ? s(z, b) : a(z[_]) || u(z, _, A)), l(z, k, !0, !0), r && (h[k] = A))), g && N === x && H && H.name !== x && (!r && y ? c(G, "name", x) : (O = !0, j = function() {
      return e(H, this);
    })), N)
      if (W = {
        values: v(x),
        keys: d ? j : v(C),
        entries: v(S)
      }, m) for (U in W)
        (w || O || !(U in G)) && u(G, U, W[U]);
      else t({ target: M, proto: !0, forced: w || O }, W);
    return (!r || m) && G[_] !== j && u(G, _, j, { name: N }), h[M] = j, W;
  }, bX;
}
var xX, Gwe;
function HG() {
  return Gwe || (Gwe = 1, xX = function(t, e) {
    return { value: t, done: e };
  }), xX;
}
var CX, Wwe;
function vg() {
  if (Wwe) return CX;
  Wwe = 1;
  var t = S0(), e = Ime(), r = DM(), n = _0(), a = Pd().f, i = Mme(), o = HG(), s = _f(), l = Go(), c = "Array Iterator", u = n.set, f = n.getterFor(c);
  CX = i(Array, "Array", function(p, g) {
    u(this, {
      type: c,
      target: t(p),
      // target
      index: 0,
      // next index
      kind: g
      // kind
    });
  }, function() {
    var p = f(this), g = p.target, y = p.index++;
    if (!g || y >= g.length)
      return p.target = null, o(void 0, !0);
    switch (p.kind) {
      case "keys":
        return o(y, !1);
      case "values":
        return o(g[y], !1);
    }
    return o([y, g[y]], !1);
  }, "values");
  var h = r.Arguments = r.Array;
  if (e("keys"), e("values"), e("entries"), !s && l && h.name !== "values") try {
    a(h, "name", { value: "values" });
  } catch {
  }
  return CX;
}
var Hwe = {}, Uwe;
function H8() {
  if (Uwe) return Hwe;
  Uwe = 1;
  var t = wi(), e = Ftt(), r = ztt(), n = vg(), a = fg(), i = tp(), o = Do(), s = o("iterator"), l = n.values, c = function(f, h) {
    if (f) {
      if (f[s] !== l) try {
        a(f, s, l);
      } catch {
        f[s] = l;
      }
      if (i(f, h, !0), e[h]) {
        for (var p in n)
          if (f[p] !== n[p]) try {
            a(f, p, n[p]);
          } catch {
            f[p] = n[p];
          }
      }
    }
  };
  for (var u in e)
    c(t[u] && t[u].prototype, u);
  return c(r, "DOMTokenList"), Hwe;
}
var Vwe = {}, wX, qwe;
function trt() {
  if (qwe) return wX;
  qwe = 1;
  var t = TypeError, e = 9007199254740991;
  return wX = function(r) {
    if (r > e) throw t("Maximum allowed index exceeded");
    return r;
  }, wX;
}
var Kwe;
function f6() {
  if (Kwe) return Vwe;
  Kwe = 1;
  var t = Ya(), e = Ba(), r = EM(), n = fs(), a = ru(), i = nu(), o = trt(), s = RM(), l = bme(), c = IM(), u = Do(), f = D8(), h = u("isConcatSpreadable"), p = f >= 51 || !e(function() {
    var b = [];
    return b[h] = !1, b.concat()[0] !== b;
  }), g = function(b) {
    if (!n(b)) return !1;
    var w = b[h];
    return w !== void 0 ? !!w : r(b);
  }, y = !p || !c("concat");
  return t({ target: "Array", proto: !0, arity: 1, forced: y }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    concat: function(w) {
      var _ = a(this), C = l(_, 0), x = 0, S, A, I, M, B;
      for (S = -1, I = arguments.length; S < I; S++)
        if (B = S === -1 ? _ : arguments[S], g(B))
          for (M = i(B), o(x + M), A = 0; A < M; A++, x++) A in B && s(C, x, B[A]);
        else
          o(x + 1), s(C, x++, B);
      return C.length = x, C;
    }
  }), Vwe;
}
var Zwe = {}, Jwe;
function UG() {
  if (Jwe) return Zwe;
  Jwe = 1;
  var t = Ya(), e = EM(), r = NG(), n = fs(), a = i6(), i = nu(), o = S0(), s = RM(), l = Do(), c = IM(), u = Qh(), f = c("slice"), h = l("species"), p = Array, g = Math.max;
  return t({ target: "Array", proto: !0, forced: !f }, {
    slice: function(b, w) {
      var _ = o(this), C = i(_), x = a(b, C), S = a(w === void 0 ? C : w, C), A, I, M;
      if (e(_) && (A = _.constructor, r(A) && (A === p || e(A.prototype)) ? A = void 0 : n(A) && (A = A[h], A === null && (A = void 0)), A === p || A === void 0))
        return u(_, x, S);
      for (I = new (A === void 0 ? p : A)(g(S - x, 0)), M = 0; x < S; x++, M++) x in _ && s(I, M, _[x]);
      return I.length = M, I;
    }
  }), Zwe;
}
var Ywe = {}, SX, Xwe;
function hpr() {
  if (Xwe) return SX;
  Xwe = 1;
  var t = Ys(), e = Ztt();
  return SX = function(r, n, a, i) {
    try {
      return i ? n(t(a)[0], a[1]) : n(a);
    } catch (o) {
      e(r, "throw", o);
    }
  }, SX;
}
var _X, Qwe;
function rrt() {
  if (Qwe) return _X;
  Qwe = 1;
  var t = gg(), e = No(), r = ru(), n = hpr(), a = Tme(), i = NG(), o = nu(), s = RM(), l = zG(), c = LM(), u = Array;
  return _X = function(h) {
    var p = r(h), g = i(this), y = arguments.length, b = y > 1 ? arguments[1] : void 0, w = b !== void 0;
    w && (b = t(b, y > 2 ? arguments[2] : void 0));
    var _ = c(p), C = 0, x, S, A, I, M, B;
    if (_ && !(this === u && a(_)))
      for (S = g ? new this() : [], I = l(p, _), M = I.next; !(A = e(M, I)).done; C++)
        B = w ? n(I, b, [A.value, C], !0) : A.value, s(S, C, B);
    else
      for (x = o(p), S = g ? new this(x) : u(x); x > C; C++)
        B = w ? b(p[C], C) : p[C], s(S, C, B);
    return S.length = C, S;
  }, _X;
}
var eSe;
function U8() {
  if (eSe) return Ywe;
  eSe = 1;
  var t = Ya(), e = rrt(), r = GG(), n = !r(function(a) {
    Array.from(a);
  });
  return t({ target: "Array", stat: !0, forced: n }, {
    from: e
  }), Ywe;
}
var tSe = {}, kX, rSe;
function Pme() {
  if (rSe) return kX;
  rSe = 1;
  var t = Wa(), e = Xh(), r = Vl(), n = d2(), a = t("".charAt), i = t("".charCodeAt), o = t("".slice), s = function(l) {
    return function(c, u) {
      var f = r(n(c)), h = e(u), p = f.length, g, y;
      return h < 0 || h >= p ? l ? "" : void 0 : (g = i(f, h), g < 55296 || g > 56319 || h + 1 === p || (y = i(f, h + 1)) < 56320 || y > 57343 ? l ? a(f, h) : g : l ? o(f, h, h + 2) : (g - 55296 << 10) + (y - 56320) + 65536);
    };
  };
  return kX = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: s(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: s(!0)
  }, kX;
}
var nSe;
function h6() {
  if (nSe) return tSe;
  nSe = 1;
  var t = Pme().charAt, e = Vl(), r = _0(), n = Mme(), a = HG(), i = "String Iterator", o = r.set, s = r.getterFor(i);
  return n(String, "String", function(l) {
    o(this, {
      type: i,
      string: e(l),
      index: 0
    });
  }, function() {
    var c = s(this), u = c.string, f = c.index, h;
    return f >= u.length ? a(void 0, !0) : (h = t(u, f), c.index += h.length, a(h, !1));
  }), tSe;
}
var aSe = {}, AX, iSe;
function nrt() {
  if (iSe) return AX;
  iSe = 1;
  var t = Ys();
  return AX = function() {
    var e = t(this), r = "";
    return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
  }, AX;
}
var TX, oSe;
function art() {
  if (oSe) return TX;
  oSe = 1;
  var t = Ba(), e = wi(), r = e.RegExp, n = t(function() {
    var o = r("a", "y");
    return o.lastIndex = 2, o.exec("abcd") !== null;
  }), a = n || t(function() {
    return !r("a", "y").sticky;
  }), i = n || t(function() {
    var o = r("^r", "gy");
    return o.lastIndex = 2, o.exec("str") !== null;
  });
  return TX = {
    BROKEN_CARET: i,
    MISSED_STICKY: a,
    UNSUPPORTED_Y: n
  }, TX;
}
var EX, sSe;
function ppr() {
  if (sSe) return EX;
  sSe = 1;
  var t = Ba(), e = wi(), r = e.RegExp;
  return EX = t(function() {
    var n = r(".", "s");
    return !(n.dotAll && n.test(`
`) && n.flags === "s");
  }), EX;
}
var IX, lSe;
function mpr() {
  if (lSe) return IX;
  lSe = 1;
  var t = Ba(), e = wi(), r = e.RegExp;
  return IX = t(function() {
    var n = r("(?<a>b)", "g");
    return n.exec("b").groups.a !== "b" || "b".replace(n, "$<a>c") !== "bc";
  }), IX;
}
var MX, cSe;
function Rme() {
  if (cSe) return MX;
  cSe = 1;
  var t = No(), e = Wa(), r = Vl(), n = nrt(), a = art(), i = F8(), o = mg(), s = _0().get, l = ppr(), c = mpr(), u = i("native-string-replace", String.prototype.replace), f = RegExp.prototype.exec, h = f, p = e("".charAt), g = e("".indexOf), y = e("".replace), b = e("".slice), w = function() {
    var S = /a/, A = /b*/g;
    return t(f, S, "a"), t(f, A, "a"), S.lastIndex !== 0 || A.lastIndex !== 0;
  }(), _ = a.BROKEN_CARET, C = /()??/.exec("")[1] !== void 0, x = w || C || _ || l || c;
  return x && (h = function(A) {
    var I = this, M = s(I), B = r(A), L = M.raw, N, d, m, v, k, O, G;
    if (L)
      return L.lastIndex = I.lastIndex, N = t(h, L, B), I.lastIndex = L.lastIndex, N;
    var H = M.groups, j = _ && I.sticky, F = t(n, I), z = I.source, W = 0, U = B;
    if (j && (F = y(F, "y", ""), g(F, "g") === -1 && (F += "g"), U = b(B, I.lastIndex), I.lastIndex > 0 && (!I.multiline || I.multiline && p(B, I.lastIndex - 1) !== `
`) && (z = "(?: " + z + ")", U = " " + U, W++), d = new RegExp("^(?:" + z + ")", F)), C && (d = new RegExp("^" + z + "$(?!\\s)", F)), w && (m = I.lastIndex), v = t(f, j ? d : I, U), j ? v ? (v.input = b(v.input, W), v[0] = b(v[0], W), v.index = I.lastIndex, I.lastIndex += v[0].length) : I.lastIndex = 0 : w && v && (I.lastIndex = I.global ? v.index + v[0].length : m), C && v && v.length > 1 && t(u, v[0], d, function() {
      for (k = 1; k < arguments.length - 2; k++)
        arguments[k] === void 0 && (v[k] = void 0);
    }), v && H)
      for (v.groups = O = o(null), k = 0; k < H.length; k++)
        G = H[k], O[G[0]] = v[G[1]];
    return v;
  }), MX = h, MX;
}
var uSe;
function p6() {
  if (uSe) return aSe;
  uSe = 1;
  var t = Ya(), e = Rme();
  return t({ target: "RegExp", proto: !0, forced: /./.exec !== e }, {
    exec: e
  }), aSe;
}
var dSe = {}, fSe;
function Ome() {
  if (fSe) return dSe;
  fSe = 1, p6();
  var t = Ya(), e = No(), r = $o(), n = Ys(), a = Vl(), i = function() {
    var s = !1, l = /[ac]/;
    return l.exec = function() {
      return s = !0, /./.exec.apply(this, arguments);
    }, l.test("abc") === !0 && s;
  }(), o = /./.test;
  return t({ target: "RegExp", proto: !0, forced: !i }, {
    test: function(s) {
      var l = n(this), c = a(s), u = l.exec;
      if (!r(u)) return e(o, l, c);
      var f = e(u, l, c);
      return f === null ? !1 : (n(f), !0);
    }
  }), dSe;
}
var hSe = {}, pSe;
function VG() {
  if (pSe) return hSe;
  pSe = 1;
  var t = Ya(), e = Go(), r = wi(), n = Wa(), a = Es(), i = $o(), o = dg(), s = Vl(), l = ep(), c = mme(), u = r.Symbol, f = u && u.prototype;
  if (e && i(u) && (!("description" in f) || // Safari 12 bug
  u().description !== void 0)) {
    var h = {}, p = function() {
      var S = arguments.length < 1 || arguments[0] === void 0 ? void 0 : s(arguments[0]), A = o(f, this) ? new u(S) : S === void 0 ? u() : u(S);
      return S === "" && (h[A] = !0), A;
    };
    c(p, u), p.prototype = f, f.constructor = p;
    var g = String(u("description detection")) === "Symbol(description detection)", y = n(f.valueOf), b = n(f.toString), w = /^Symbol\((.*)\)[^)]+$/, _ = n("".replace), C = n("".slice);
    l(f, "description", {
      configurable: !0,
      get: function() {
        var S = y(this);
        if (a(h, S)) return "";
        var A = b(S), I = g ? C(A, 7, -1) : _(A, w, "$1");
        return I === "" ? void 0 : I;
      }
    }), t({ global: !0, constructor: !0, forced: !0 }, {
      Symbol: p
    });
  }
  return hSe;
}
var mSe = {}, gSe;
function Bme() {
  if (gSe) return mSe;
  gSe = 1;
  var t = Ltt();
  return t("iterator"), mSe;
}
var PX = { exports: {} }, RX = { exports: {} }, vSe;
function gpr() {
  return vSe || (vSe = 1, function(t) {
    var e = Ytt();
    function r(n) {
      if (Array.isArray(n)) return e(n);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(RX)), RX.exports;
}
var OX = { exports: {} }, ySe;
function vpr() {
  return ySe || (ySe = 1, function(t) {
    function e(r) {
      if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(OX)), OX.exports;
}
var BX = { exports: {} }, bSe;
function ypr() {
  return bSe || (bSe = 1, function(t) {
    function e() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(BX)), BX.exports;
}
var xSe;
function GM() {
  return xSe || (xSe = 1, function(t) {
    var e = gpr(), r = vpr(), n = Xtt(), a = ypr();
    function i(o) {
      return e(o) || r(o) || n(o) || a();
    }
    t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(PX)), PX.exports;
}
var CSe = {}, wSe;
function Nme() {
  if (wSe) return CSe;
  wSe = 1;
  var t = Ya(), e = RG().includes, r = Ba(), n = Ime(), a = r(function() {
    return !Array(1).includes();
  });
  return t({ target: "Array", proto: !0, forced: a }, {
    includes: function(o) {
      return e(this, o, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), n("includes"), CSe;
}
var SSe = {}, _Se;
function WM() {
  if (_Se) return SSe;
  _Se = 1;
  var t = Ya(), e = Wa(), r = SM(), n = S0(), a = LG(), i = e([].join), o = r !== Object, s = o || !a("join", ",");
  return t({ target: "Array", proto: !0, forced: s }, {
    join: function(c) {
      return i(n(this), c === void 0 ? "," : c);
    }
  }), SSe;
}
var kSe = {}, NX, ASe;
function irt() {
  if (ASe) return NX;
  ASe = 1;
  var t = fs(), e = Math.floor;
  return NX = Number.isInteger || function(n) {
    return !t(n) && isFinite(n) && e(n) === n;
  }, NX;
}
var TSe;
function ort() {
  if (TSe) return kSe;
  TSe = 1;
  var t = Ya(), e = irt();
  return t({ target: "Number", stat: !0 }, {
    isInteger: e
  }), kSe;
}
var ESe = {}, $X, ISe;
function qG() {
  if (ISe) return $X;
  ISe = 1;
  var t = $o(), e = fs(), r = W8();
  return $X = function(n, a, i) {
    var o, s;
    return (
      // it can work only with native `setPrototypeOf`
      r && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
      t(o = a.constructor) && o !== i && e(s = o.prototype) && s !== i.prototype && r(n, s), n
    );
  }, $X;
}
var DX, MSe;
function bpr() {
  if (MSe) return DX;
  MSe = 1;
  var t = Wa();
  return DX = t(1 .valueOf), DX;
}
var LX, PSe;
function xpr() {
  return PSe || (PSe = 1, LX = `	
\v\f\r                　\u2028\u2029\uFEFF`), LX;
}
var jX, RSe;
function Cpr() {
  if (RSe) return jX;
  RSe = 1;
  var t = Wa(), e = d2(), r = Vl(), n = xpr(), a = t("".replace), i = RegExp("^[" + n + "]+"), o = RegExp("(^|[^" + n + "])[" + n + "]+$"), s = function(l) {
    return function(c) {
      var u = r(e(c));
      return l & 1 && (u = a(u, i, "")), l & 2 && (u = a(u, o, "$1")), u;
    };
  };
  return jX = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: s(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: s(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: s(3)
  }, jX;
}
var OSe;
function KG() {
  if (OSe) return ESe;
  OSe = 1;
  var t = Ya(), e = _f(), r = Go(), n = wi(), a = Dtt(), i = Wa(), o = BG(), s = Es(), l = qG(), c = dg(), u = j8(), f = fme(), h = Ba(), p = z8().f, g = Fy().f, y = Pd().f, b = bpr(), w = Cpr().trim, _ = "Number", C = n[_], x = a[_], S = C.prototype, A = n.TypeError, I = i("".slice), M = i("".charCodeAt), B = function(k) {
    var O = f(k, "number");
    return typeof O == "bigint" ? O : L(O);
  }, L = function(k) {
    var O = f(k, "number"), G, H, j, F, z, W, U, Z;
    if (u(O)) throw new A("Cannot convert a Symbol value to a number");
    if (typeof O == "string" && O.length > 2) {
      if (O = w(O), G = M(O, 0), G === 43 || G === 45) {
        if (H = M(O, 2), H === 88 || H === 120) return NaN;
      } else if (G === 48) {
        switch (M(O, 1)) {
          // fast equal of /^0b[01]+$/i
          case 66:
          case 98:
            j = 2, F = 49;
            break;
          // fast equal of /^0o[0-7]+$/i
          case 79:
          case 111:
            j = 8, F = 55;
            break;
          default:
            return +O;
        }
        for (z = I(O, 2), W = z.length, U = 0; U < W; U++)
          if (Z = M(z, U), Z < 48 || Z > F) return NaN;
        return parseInt(z, j);
      }
    }
    return +O;
  }, N = o(_, !C(" 0o1") || !C("0b1") || C("+0x1")), d = function(k) {
    return c(S, k) && h(function() {
      b(k);
    });
  }, m = function(O) {
    var G = arguments.length < 1 ? 0 : C(B(O));
    return d(this) ? l(Object(G), this, m) : G;
  };
  m.prototype = S, N && !e && (S.constructor = m), t({ global: !0, constructor: !0, wrap: !0, forced: N }, {
    Number: m
  });
  var v = function(k, O) {
    for (var G = r ? p(O) : (
      // ES3:
      "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
    ), H = 0, j; G.length > H; H++)
      s(O, j = G[H]) && !s(k, j) && y(k, j, g(O, j));
  };
  return e && x && v(a[_], x), (N || e) && v(a[_], C), ESe;
}
var BSe = {}, FX, NSe;
function wpr() {
  if (NSe) return FX;
  NSe = 1;
  var t = Go(), e = Ba(), r = Wa(), n = zM(), a = TM(), i = S0(), o = EG().f, s = r(o), l = r([].push), c = t && e(function() {
    var f = /* @__PURE__ */ Object.create(null);
    return f[2] = 2, !s(f, 2);
  }), u = function(f) {
    return function(h) {
      for (var p = i(h), g = a(p), y = c && n(p) === null, b = g.length, w = 0, _ = [], C; b > w; )
        C = g[w++], (!t || (y ? C in p : s(p, C))) && l(_, f ? [C, p[C]] : p[C]);
      return _;
    };
  };
  return FX = {
    // `Object.entries` method
    // https://tc39.es/ecma262/#sec-object.entries
    entries: u(!0),
    // `Object.values` method
    // https://tc39.es/ecma262/#sec-object.values
    values: u(!1)
  }, FX;
}
var $Se;
function srt() {
  if ($Se) return BSe;
  $Se = 1;
  var t = Ya(), e = wpr().entries;
  return t({ target: "Object", stat: !0 }, {
    entries: function(n) {
      return e(n);
    }
  }), BSe;
}
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
var DSe;
function HM() {
  if (DSe) return mc;
  DSe = 1, Object.defineProperty(mc, "__esModule", { value: !0 });
  var t = rp();
  Eme();
  var e = WG();
  vg(), u6(), H8(), f6(), UG(), U8(), h6(), p6(), Ome(), DG(), VG(), Bme(), G8(), s6();
  var r = GM(), n = Gy(), a = zy(), i = Wy(), o = Hy(), s = np();
  Nme(), d6(), WM(), ort(), KG(), srt();
  function l(ee) {
    return ee && typeof ee == "object" && "default" in ee ? ee : { default: ee };
  }
  var c = /* @__PURE__ */ l(t), u = /* @__PURE__ */ l(e), f = /* @__PURE__ */ l(r), h = /* @__PURE__ */ l(n), p = /* @__PURE__ */ l(a), g = /* @__PURE__ */ l(i), y = /* @__PURE__ */ l(o), b = /* @__PURE__ */ l(s), w = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    return {
      checks: Ce
    };
  }, _ = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    return w(function(We) {
      for (var Fe = !1, it = [], gt = 0, Ze = Ce; gt < Ze.length; gt++) {
        var Ne = Ze[gt];
        if (typeof Ne == "string") {
          Fe = Fe || c.default(We) === Ne, it.push("of type ".concat(Ne));
          continue;
        }
        Fe = Fe || We instanceof Ne, it.push("an instance of ".concat(Ne.name));
      }
      return [Fe, it];
    });
  }, C = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    return w(function(We) {
      for (var Fe = !1, it = [], gt = 0, Ze = Ce; gt < Ze.length; gt++) {
        var Ne = Ze[gt];
        Fe = Fe || We === Ne, it.push(typeof Ne == "string" ? '"'.concat(Ne, '"') : "".concat(Ne));
      }
      return [Fe, it];
    });
  };
  function x(ee) {
    var Se = S();
    return function() {
      var we = b.default(ee), We;
      if (Se) {
        var Fe = b.default(this).constructor;
        We = Reflect.construct(we, arguments, Fe);
      } else
        We = we.apply(this, arguments);
      return y.default(this, We);
    };
  }
  function S() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function A(ee, Se) {
    var Ce = typeof Symbol < "u" && ee[Symbol.iterator] || ee["@@iterator"];
    if (!Ce) {
      if (Array.isArray(ee) || (Ce = I(ee)) || Se) {
        Ce && (ee = Ce);
        var we = 0, We = function() {
        };
        return { s: We, n: function() {
          return we >= ee.length ? { done: !0 } : { done: !1, value: ee[we++] };
        }, e: function(Ne) {
          throw Ne;
        }, f: We };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var Fe = !0, it = !1, gt;
    return { s: function() {
      Ce = Ce.call(ee);
    }, n: function() {
      var Ne = Ce.next();
      return Fe = Ne.done, Ne;
    }, e: function(Ne) {
      it = !0, gt = Ne;
    }, f: function() {
      try {
        !Fe && Ce.return != null && Ce.return();
      } finally {
        if (it) throw gt;
      }
    } };
  }
  function I(ee, Se) {
    if (ee) {
      if (typeof ee == "string") return M(ee, Se);
      var Ce = Object.prototype.toString.call(ee).slice(8, -1);
      if (Ce === "Object" && ee.constructor && (Ce = ee.constructor.name), Ce === "Map" || Ce === "Set") return Array.from(ee);
      if (Ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ce)) return M(ee, Se);
    }
  }
  function M(ee, Se) {
    (Se == null || Se > ee.length) && (Se = ee.length);
    for (var Ce = 0, we = new Array(Se); Ce < Se; Ce++)
      we[Ce] = ee[Ce];
    return we;
  }
  var B = function(Se, Ce) {
    if (Ce.length > Se.length)
      throw new Error("Expected at most ".concat(Se.length, " argument(s), but got ").concat(Ce.length));
    for (; Ce.length < Se.length; )
      Ce.push(void 0);
    var we = A(Ce.entries()), We;
    try {
      for (we.s(); !(We = we.n()).done; ) {
        var Fe = u.default(We.value, 2), it = Fe[0], gt = Fe[1], Ze = O(Se[it], gt), Ne = u.default(Ze, 4), ze = Ne[0], ct = Ne[1], rt = Ne[2], qe = Ne[3];
        if (!ze) {
          var nt = it + 1;
          throw new Error("Argument ".concat(nt, " is expected to be ").concat(rt).concat(qe, " but got ").concat(ct));
        }
      }
    } catch (Rt) {
      we.e(Rt);
    } finally {
      we.f();
    }
  }, L = function(Se) {
    var Ce, we, We = ["undefined", "boolean", "number", "bigint", "string"];
    if (We.includes(c.default(Se)) && (we = typeof Se == "string" ? '"'.concat(Se, '"') : "".concat(Se)), c.default(Se) === "object" && (Se == null || (Ce = Se.constructor) === null || Ce === void 0 ? void 0 : Ce.name) !== "Object") {
      var Fe;
      we = Se === null ? "null" : "instance of ".concat(Se == null || (Fe = Se.constructor) === null || Fe === void 0 ? void 0 : Fe.name);
    }
    return we || (we = c.default(Se)), we;
  }, N = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    var We = v(Ce);
    return function(Fe) {
      return /* @__PURE__ */ function(it) {
        g.default(Ze, it);
        var gt = x(Ze);
        function Ze() {
          p.default(this, Ze);
          for (var Ne = arguments.length, ze = new Array(Ne), ct = 0; ct < Ne; ct++)
            ze[ct] = arguments[ct];
          return B(We, ze), gt.call.apply(gt, [this].concat(ze));
        }
        return h.default(Ze);
      }(Fe);
    };
  }, d = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    var We = v(Ce);
    return function(Fe, it, gt) {
      if (typeof gt.value != "function")
        throw new Error("The validateTypes decorator can only be applied to methods");
      var Ze = gt.value;
      gt.value = function() {
        for (var Ne = arguments.length, ze = new Array(Ne), ct = 0; ct < Ne; ct++)
          ze[ct] = arguments[ct];
        return B(We, ze), Ze.apply(this, ze);
      };
    };
  }, m = function() {
    for (var Se = arguments.length, Ce = new Array(Se), we = 0; we < Se; we++)
      Ce[we] = arguments[we];
    var We = v(Ce);
    return function(Fe, it, gt) {
      if (typeof gt.value != "function")
        throw new Error("The validateTypesAsync decorator can only be applied to methods");
      var Ze = gt.value;
      gt.value = function() {
        for (var Ne = arguments.length, ze = new Array(Ne), ct = 0; ct < Ne; ct++)
          ze[ct] = arguments[ct];
        try {
          B(We, ze);
        } catch (rt) {
          return Promise.reject(rt);
        }
        return Ze.apply(this, ze);
      };
    };
  }, v = function(Se) {
    var Ce = [], we = A(Se), We;
    try {
      for (we.s(); !(We = we.n()).done; ) {
        var Fe = We.value;
        Ce.push(k(Fe));
      }
    } catch (it) {
      we.e(it);
    } finally {
      we.f();
    }
    return Ce;
  }, k = function(Se) {
    var Ce = [], we = Array.isArray(Se) ? Se : [Se], We = A(we), Fe;
    try {
      for (We.s(); !(Fe = We.n()).done; ) {
        var it = Fe.value;
        if (typeof it == "string" || typeof it == "function") {
          Ce.push(_(it));
          continue;
        }
        Ce.push(it);
      }
    } catch (gt) {
      We.e(gt);
    } finally {
      We.f();
    }
    return Ce;
  }, O = function(Se, Ce) {
    var we = [], We, Fe = !1, it = A(Se), gt;
    try {
      for (it.s(); !(gt = it.n()).done; ) {
        var Ze = gt.value, Ne = A(Ze.checks), ze;
        try {
          for (Ne.s(); !(ze = Ne.n()).done; ) {
            var ct = ze.value, rt = ct(Ce), qe = u.default(rt, 3), nt = qe[0], Rt = qe[1], Ot = qe[2];
            Fe = Fe || nt, !We && Ot && (We = Ot), Rt && (we = typeof Rt == "string" ? [].concat(f.default(we), [Rt]) : [].concat(f.default(we), f.default(Rt)));
          }
        } catch (Jt) {
          Ne.e(Jt);
        } finally {
          Ne.f();
        }
      }
    } catch (Jt) {
      it.e(Jt);
    } finally {
      it.f();
    }
    if (Fe)
      return [!0];
    var lt = We || L(Ce), mt = we.length - 1, jt = mt > 0 ? "".concat(we.slice(0, mt).join(", "), " or ").concat(we[mt]) : we.join(", ");
    return [!1, lt, jt, mt > 1 ? ";" : ","];
  };
  function G(ee, Se) {
    var Ce = typeof Symbol < "u" && ee[Symbol.iterator] || ee["@@iterator"];
    if (!Ce) {
      if (Array.isArray(ee) || (Ce = H(ee)) || Se) {
        Ce && (ee = Ce);
        var we = 0, We = function() {
        };
        return { s: We, n: function() {
          return we >= ee.length ? { done: !0 } : { done: !1, value: ee[we++] };
        }, e: function(Ne) {
          throw Ne;
        }, f: We };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var Fe = !0, it = !1, gt;
    return { s: function() {
      Ce = Ce.call(ee);
    }, n: function() {
      var Ne = Ce.next();
      return Fe = Ne.done, Ne;
    }, e: function(Ne) {
      it = !0, gt = Ne;
    }, f: function() {
      try {
        !Fe && Ce.return != null && Ce.return();
      } finally {
        if (it) throw gt;
      }
    } };
  }
  function H(ee, Se) {
    if (ee) {
      if (typeof ee == "string") return j(ee, Se);
      var Ce = Object.prototype.toString.call(ee).slice(8, -1);
      if (Ce === "Object" && ee.constructor && (Ce = ee.constructor.name), Ce === "Map" || Ce === "Set") return Array.from(ee);
      if (Ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ce)) return j(ee, Se);
    }
  }
  function j(ee, Se) {
    (Se == null || Se > ee.length) && (Se = ee.length);
    for (var Ce = 0, we = new Array(Se); Ce < Se; Ce++)
      we[Ce] = ee[Ce];
    return we;
  }
  var F = function(Se, Ce) {
    return w(function(we) {
      if (!Array.isArray(we) || we.length < 1)
        return [!1, "a non-empty array of ".concat(Se)];
      var We = G(we.entries()), Fe;
      try {
        for (We.s(); !(Fe = We.n()).done; ) {
          var it = u.default(Fe.value, 2), gt = it[0], Ze = it[1], Ne = O(k(Ce), Ze), ze = u.default(Ne, 3), ct = ze[0], rt = ze[1], qe = ze[2];
          if (!ct)
            return [!1, "a valid non-empty array of ".concat(Se, " (index ").concat(gt, " should be ").concat(qe, ")"), "malformed array of ".concat(Se, " (index ").concat(gt, " is ").concat(rt, ")")];
        }
      } catch (nt) {
        We.e(nt);
      } finally {
        We.f();
      }
      return [!0];
    });
  }, z = w(function(ee) {
    return [typeof ee == "string" && ee.length > 0, "a non-empty string"];
  }), W = w(function(ee) {
    return [typeof ee == "number" && Number.isInteger(ee) && ee >= 0, "a non-negative integer"];
  }), U = w(function(ee) {
    return [c.default(ee) === "object" && ee !== null && !Array.isArray(ee), "a pure object (non-null and non-array)"];
  }), Z = function(Se, Ce) {
    return w(function(we) {
      if (c.default(we) !== "object" || we === null || Array.isArray(we))
        return [!1, "valid ".concat(Se, " (should be a pure object)")];
      for (var We = 0, Fe = Object.entries(Ce); We < Fe.length; We++) {
        var it = u.default(Fe[We], 2), gt = it[0], Ze = it[1], Ne = O(k(Ze), we[gt]), ze = u.default(Ne, 3), ct = ze[0], rt = ze[1], qe = ze[2];
        if (!ct)
          return [!1, "valid ".concat(Se, ' (key "').concat(gt, '" should be ').concat(qe, ")"), "malformed ".concat(Se, ' (key "').concat(gt, '" is ').concat(rt, ")")];
      }
      return [!0];
    });
  };
  function V(ee, Se) {
    var Ce = typeof Symbol < "u" && ee[Symbol.iterator] || ee["@@iterator"];
    if (!Ce) {
      if (Array.isArray(ee) || (Ce = Y(ee)) || Se) {
        Ce && (ee = Ce);
        var we = 0, We = function() {
        };
        return { s: We, n: function() {
          return we >= ee.length ? { done: !0 } : { done: !1, value: ee[we++] };
        }, e: function(Ne) {
          throw Ne;
        }, f: We };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var Fe = !0, it = !1, gt;
    return { s: function() {
      Ce = Ce.call(ee);
    }, n: function() {
      var Ne = Ce.next();
      return Fe = Ne.done, Ne;
    }, e: function(Ne) {
      it = !0, gt = Ne;
    }, f: function() {
      try {
        !Fe && Ce.return != null && Ce.return();
      } finally {
        if (it) throw gt;
      }
    } };
  }
  function Y(ee, Se) {
    if (ee) {
      if (typeof ee == "string") return ge(ee, Se);
      var Ce = Object.prototype.toString.call(ee).slice(8, -1);
      if (Ce === "Object" && ee.constructor && (Ce = ee.constructor.name), Ce === "Map" || Ce === "Set") return Array.from(ee);
      if (Ce === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ce)) return ge(ee, Se);
    }
  }
  function ge(ee, Se) {
    (Se == null || Se > ee.length) && (Se = ee.length);
    for (var Ce = 0, we = new Array(Se); Ce < Se; Ce++)
      we[Ce] = ee[Ce];
    return we;
  }
  var ce = function(Se, Ce) {
    return w(function(we) {
      if (!Array.isArray(we))
        return [!1, "an array of ".concat(Se)];
      var We = V(we.entries()), Fe;
      try {
        for (We.s(); !(Fe = We.n()).done; ) {
          var it = u.default(Fe.value, 2), gt = it[0], Ze = it[1], Ne = O(k(Ce), Ze), ze = u.default(Ne, 3), ct = ze[0], rt = ze[1], qe = ze[2];
          if (!ct)
            return [!1, "a valid array of ".concat(Se, " (index ").concat(gt, " should be ").concat(qe, ")"), "malformed array of ".concat(Se, " (index ").concat(gt, " is ").concat(rt, ")")];
        }
      } catch (nt) {
        We.e(nt);
      } finally {
        We.f();
      }
      return [!0];
    });
  };
  return mc.array = ce, mc.custom = w, mc.literal = C, mc.nonEmptyArray = F, mc.nonEmptyString = z, mc.nonNegativeInteger = W, mc.objectSchema = Z, mc.pureObject = U, mc.runtimeTypeValidation = B, mc.stringifyReceivedType = L, mc.type = _, mc.validateConstructorTypes = N, mc.validateTypes = d, mc.validateTypesAsync = m, mc;
}
var zX = {}, GX = { exports: {} }, WX = { exports: {} }, LSe;
function Spr() {
  return LSe || (LSe = 1, function(t) {
    var e = np();
    function r(n, a) {
      for (; !{}.hasOwnProperty.call(n, a) && (n = e(n)) !== null; ) ;
      return n;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(WX)), WX.exports;
}
var jSe;
function $me() {
  return jSe || (jSe = 1, function(t) {
    var e = Spr();
    function r() {
      return t.exports = r = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(n, a, i) {
        var o = e(n, a);
        if (o) {
          var s = Object.getOwnPropertyDescriptor(o, a);
          return s.get ? s.get.call(arguments.length < 3 ? n : i) : s.value;
        }
      }, t.exports.__esModule = !0, t.exports.default = t.exports, r.apply(null, arguments);
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(GX)), GX.exports;
}
var FSe = {}, HX, zSe;
function _pr() {
  if (zSe) return HX;
  zSe = 1;
  var t = No(), e = Es(), r = dg(), n = nrt(), a = RegExp.prototype;
  return HX = function(i) {
    var o = i.flags;
    return o === void 0 && !("flags" in a) && !e(i, "flags") && r(a, i) ? t(n, i) : o;
  }, HX;
}
var GSe;
function lrt() {
  if (GSe) return FSe;
  GSe = 1;
  var t = kM().PROPER, e = Gu(), r = Ys(), n = Vl(), a = Ba(), i = _pr(), o = "toString", s = RegExp.prototype, l = s[o], c = a(function() {
    return l.call({ source: "a", flags: "b" }) !== "/a/b";
  }), u = t && l.name !== o;
  return (c || u) && e(s, o, function() {
    var h = r(this), p = n(h.source), g = n(i(h));
    return "/" + p + "/" + g;
  }, { unsafe: !0 }), FSe;
}
var h$ = { exports: {} }, kpr = h$.exports, WSe;
function V8() {
  return WSe || (WSe = 1, function(t) {
    (function(e, r) {
      t.exports ? t.exports = r() : e.log = r();
    })(kpr, function() {
      var e = function() {
      }, r = "undefined", n = typeof window !== r && typeof window.navigator !== r && /Trident\/|MSIE /.test(window.navigator.userAgent), a = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], i = {}, o = null;
      function s(y, b) {
        var w = y[b];
        if (typeof w.bind == "function")
          return w.bind(y);
        try {
          return Function.prototype.bind.call(w, y);
        } catch {
          return function() {
            return Function.prototype.apply.apply(w, [y, arguments]);
          };
        }
      }
      function l() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function c(y) {
        return y === "debug" && (y = "log"), typeof console === r ? !1 : y === "trace" && n ? l : console[y] !== void 0 ? s(console, y) : console.log !== void 0 ? s(console, "log") : e;
      }
      function u() {
        for (var y = this.getLevel(), b = 0; b < a.length; b++) {
          var w = a[b];
          this[w] = b < y ? e : this.methodFactory(w, y, this.name);
        }
        if (this.log = this.debug, typeof console === r && y < this.levels.SILENT)
          return "No console available for logging";
      }
      function f(y) {
        return function() {
          typeof console !== r && (u.call(this), this[y].apply(this, arguments));
        };
      }
      function h(y, b, w) {
        return c(y) || f.apply(this, arguments);
      }
      function p(y, b) {
        var w = this, _, C, x, S = "loglevel";
        typeof y == "string" ? S += ":" + y : typeof y == "symbol" && (S = void 0);
        function A(N) {
          var d = (a[N] || "silent").toUpperCase();
          if (!(typeof window === r || !S)) {
            try {
              window.localStorage[S] = d;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=" + d + ";";
            } catch {
            }
          }
        }
        function I() {
          var N;
          if (!(typeof window === r || !S)) {
            try {
              N = window.localStorage[S];
            } catch {
            }
            if (typeof N === r)
              try {
                var d = window.document.cookie, m = encodeURIComponent(S), v = d.indexOf(m + "=");
                v !== -1 && (N = /^([^;]+)/.exec(
                  d.slice(v + m.length + 1)
                )[1]);
              } catch {
              }
            return w.levels[N] === void 0 && (N = void 0), N;
          }
        }
        function M() {
          if (!(typeof window === r || !S)) {
            try {
              window.localStorage.removeItem(S);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(S) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function B(N) {
          var d = N;
          if (typeof d == "string" && w.levels[d.toUpperCase()] !== void 0 && (d = w.levels[d.toUpperCase()]), typeof d == "number" && d >= 0 && d <= w.levels.SILENT)
            return d;
          throw new TypeError("log.setLevel() called with invalid level: " + N);
        }
        w.name = y, w.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, w.methodFactory = b || h, w.getLevel = function() {
          return x ?? C ?? _;
        }, w.setLevel = function(N, d) {
          return x = B(N), d !== !1 && A(x), u.call(w);
        }, w.setDefaultLevel = function(N) {
          C = B(N), I() || w.setLevel(N, !1);
        }, w.resetLevel = function() {
          x = null, M(), u.call(w);
        }, w.enableAll = function(N) {
          w.setLevel(w.levels.TRACE, N);
        }, w.disableAll = function(N) {
          w.setLevel(w.levels.SILENT, N);
        }, w.rebuild = function() {
          if (o !== w && (_ = B(o.getLevel())), u.call(w), o === w)
            for (var N in i)
              i[N].rebuild();
        }, _ = B(
          o ? o.getLevel() : "WARN"
        );
        var L = I();
        L != null && (x = B(L)), u.call(w);
      }
      o = new p(), o.getLogger = function(b) {
        if (typeof b != "symbol" && typeof b != "string" || b === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var w = i[b];
        return w || (w = i[b] = new p(
          b,
          o.methodFactory
        )), w;
      };
      var g = typeof window !== r ? window.log : void 0;
      return o.noConflict = function() {
        return typeof window !== r && window.log === o && (window.log = g), o;
      }, o.getLoggers = function() {
        return i;
      }, o.default = o, o;
    });
  }(h$)), h$.exports;
}
var HSe = {}, USe = {}, UX = { exports: {} }, VX, VSe;
function Apr() {
  if (VSe) return VX;
  VSe = 1;
  var t = Ba();
  return VX = t(function() {
    if (typeof ArrayBuffer == "function") {
      var e = new ArrayBuffer(8);
      Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
    }
  }), VX;
}
var qX, qSe;
function Tpr() {
  if (qSe) return qX;
  qSe = 1;
  var t = Ba(), e = fs(), r = Yh(), n = Apr(), a = Object.isExtensible, i = t(function() {
  });
  return qX = i || n ? function(s) {
    return !e(s) || n && r(s) === "ArrayBuffer" ? !1 : a ? a(s) : !0;
  } : a, qX;
}
var KX, KSe;
function crt() {
  if (KSe) return KX;
  KSe = 1;
  var t = Ba();
  return KX = !t(function() {
    return Object.isExtensible(Object.preventExtensions({}));
  }), KX;
}
var ZSe;
function ZG() {
  if (ZSe) return UX.exports;
  ZSe = 1;
  var t = Ya(), e = Wa(), r = AM(), n = fs(), a = Es(), i = Pd().f, o = z8(), s = Ntt(), l = Tpr(), c = _M(), u = crt(), f = !1, h = c("meta"), p = 0, g = function(x) {
    i(x, h, { value: {
      objectID: "O" + p++,
      // object ID
      weakData: {}
      // weak collections IDs
    } });
  }, y = function(x, S) {
    if (!n(x)) return typeof x == "symbol" ? x : (typeof x == "string" ? "S" : "P") + x;
    if (!a(x, h)) {
      if (!l(x)) return "F";
      if (!S) return "E";
      g(x);
    }
    return x[h].objectID;
  }, b = function(x, S) {
    if (!a(x, h)) {
      if (!l(x)) return !0;
      if (!S) return !1;
      g(x);
    }
    return x[h].weakData;
  }, w = function(x) {
    return u && f && l(x) && !a(x, h) && g(x), x;
  }, _ = function() {
    C.enable = function() {
    }, f = !0;
    var x = o.f, S = e([].splice), A = {};
    A[h] = 1, x(A).length && (o.f = function(I) {
      for (var M = x(I), B = 0, L = M.length; B < L; B++)
        if (M[B] === h) {
          S(M, B, 1);
          break;
        }
      return M;
    }, t({ target: "Object", stat: !0, forced: !0 }, {
      getOwnPropertyNames: s.f
    }));
  }, C = UX.exports = {
    enable: _,
    fastKey: y,
    getWeakData: b,
    onFreeze: w
  };
  return r[h] = !0, UX.exports;
}
var ZX, JSe;
function Dme() {
  if (JSe) return ZX;
  JSe = 1;
  var t = Ya(), e = wi(), r = Wa(), n = BG(), a = Gu(), i = ZG(), o = jM(), s = Uy(), l = $o(), c = u2(), u = fs(), f = Ba(), h = GG(), p = tp(), g = qG();
  return ZX = function(y, b, w) {
    var _ = y.indexOf("Map") !== -1, C = y.indexOf("Weak") !== -1, x = _ ? "set" : "add", S = e[y], A = S && S.prototype, I = S, M = {}, B = function(O) {
      var G = r(A[O]);
      a(
        A,
        O,
        O === "add" ? function(j) {
          return G(this, j === 0 ? 0 : j), this;
        } : O === "delete" ? function(H) {
          return C && !u(H) ? !1 : G(this, H === 0 ? 0 : H);
        } : O === "get" ? function(j) {
          return C && !u(j) ? void 0 : G(this, j === 0 ? 0 : j);
        } : O === "has" ? function(j) {
          return C && !u(j) ? !1 : G(this, j === 0 ? 0 : j);
        } : function(j, F) {
          return G(this, j === 0 ? 0 : j, F), this;
        }
      );
    }, L = n(
      y,
      !l(S) || !(C || A.forEach && !f(function() {
        new S().entries().next();
      }))
    );
    if (L)
      I = w.getConstructor(b, y, _, x), i.enable();
    else if (n(y, !0)) {
      var N = new I(), d = N[x](C ? {} : -0, 1) !== N, m = f(function() {
        N.has(1);
      }), v = h(function(O) {
        new S(O);
      }), k = !C && f(function() {
        for (var O = new S(), G = 5; G--; ) O[x](G, G);
        return !O.has(-0);
      });
      v || (I = b(function(O, G) {
        s(O, A);
        var H = g(new S(), O, I);
        return c(G) || o(G, H[x], { that: H, AS_ENTRIES: _ }), H;
      }), I.prototype = A, A.constructor = I), (m || k) && (B("delete"), B("has"), _ && B("get")), (k || d) && B(x), C && A.clear && delete A.clear;
    }
    return M[y] = I, t({ global: !0, constructor: !0, forced: I !== S }, M), p(I, y), C || w.setStrong(I, y, _), I;
  }, ZX;
}
var JX, YSe;
function JG() {
  if (YSe) return JX;
  YSe = 1;
  var t = Gu();
  return JX = function(e, r, n) {
    for (var a in r) t(e, a, r[a], n);
    return e;
  }, JX;
}
var YX, XSe;
function urt() {
  if (XSe) return YX;
  XSe = 1;
  var t = mg(), e = ep(), r = JG(), n = gg(), a = Uy(), i = u2(), o = jM(), s = Mme(), l = HG(), c = FG(), u = Go(), f = ZG().fastKey, h = _0(), p = h.set, g = h.getterFor;
  return YX = {
    getConstructor: function(y, b, w, _) {
      var C = y(function(M, B) {
        a(M, x), p(M, {
          type: b,
          index: t(null),
          first: null,
          last: null,
          size: 0
        }), u || (M.size = 0), i(B) || o(B, M[_], { that: M, AS_ENTRIES: w });
      }), x = C.prototype, S = g(b), A = function(M, B, L) {
        var N = S(M), d = I(M, B), m, v;
        return d ? d.value = L : (N.last = d = {
          index: v = f(B, !0),
          key: B,
          value: L,
          previous: m = N.last,
          next: null,
          removed: !1
        }, N.first || (N.first = d), m && (m.next = d), u ? N.size++ : M.size++, v !== "F" && (N.index[v] = d)), M;
      }, I = function(M, B) {
        var L = S(M), N = f(B), d;
        if (N !== "F") return L.index[N];
        for (d = L.first; d; d = d.next)
          if (d.key === B) return d;
      };
      return r(x, {
        // `{ Map, Set }.prototype.clear()` methods
        // https://tc39.es/ecma262/#sec-map.prototype.clear
        // https://tc39.es/ecma262/#sec-set.prototype.clear
        clear: function() {
          for (var B = this, L = S(B), N = L.first; N; )
            N.removed = !0, N.previous && (N.previous = N.previous.next = null), N = N.next;
          L.first = L.last = null, L.index = t(null), u ? L.size = 0 : B.size = 0;
        },
        // `{ Map, Set }.prototype.delete(key)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.delete
        // https://tc39.es/ecma262/#sec-set.prototype.delete
        delete: function(M) {
          var B = this, L = S(B), N = I(B, M);
          if (N) {
            var d = N.next, m = N.previous;
            delete L.index[N.index], N.removed = !0, m && (m.next = d), d && (d.previous = m), L.first === N && (L.first = d), L.last === N && (L.last = m), u ? L.size-- : B.size--;
          }
          return !!N;
        },
        // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.foreach
        // https://tc39.es/ecma262/#sec-set.prototype.foreach
        forEach: function(B) {
          for (var L = S(this), N = n(B, arguments.length > 1 ? arguments[1] : void 0), d; d = d ? d.next : L.first; )
            for (N(d.value, d.key, this); d && d.removed; ) d = d.previous;
        },
        // `{ Map, Set}.prototype.has(key)` methods
        // https://tc39.es/ecma262/#sec-map.prototype.has
        // https://tc39.es/ecma262/#sec-set.prototype.has
        has: function(B) {
          return !!I(this, B);
        }
      }), r(x, w ? {
        // `Map.prototype.get(key)` method
        // https://tc39.es/ecma262/#sec-map.prototype.get
        get: function(B) {
          var L = I(this, B);
          return L && L.value;
        },
        // `Map.prototype.set(key, value)` method
        // https://tc39.es/ecma262/#sec-map.prototype.set
        set: function(B, L) {
          return A(this, B === 0 ? 0 : B, L);
        }
      } : {
        // `Set.prototype.add(value)` method
        // https://tc39.es/ecma262/#sec-set.prototype.add
        add: function(B) {
          return A(this, B = B === 0 ? 0 : B, B);
        }
      }), u && e(x, "size", {
        configurable: !0,
        get: function() {
          return S(this).size;
        }
      }), C;
    },
    setStrong: function(y, b, w) {
      var _ = b + " Iterator", C = g(b), x = g(_);
      s(y, b, function(S, A) {
        p(this, {
          type: _,
          target: S,
          state: C(S),
          kind: A,
          last: null
        });
      }, function() {
        for (var S = x(this), A = S.kind, I = S.last; I && I.removed; ) I = I.previous;
        return !S.target || !(S.last = I = I ? I.next : S.state.first) ? (S.target = null, l(void 0, !0)) : l(A === "keys" ? I.key : A === "values" ? I.value : [I.key, I.value], !1);
      }, w ? "entries" : "values", !w, !0), c(b);
    }
  }, YX;
}
var QSe;
function Epr() {
  if (QSe) return USe;
  QSe = 1;
  var t = Dme(), e = urt();
  return t("Set", function(r) {
    return function() {
      return r(this, arguments.length ? arguments[0] : void 0);
    };
  }, e), USe;
}
var e_e;
function Lme() {
  return e_e || (e_e = 1, Epr()), HSe;
}
var p$ = { exports: {} }, Ipr = p$.exports, t_e;
function Mpr() {
  return t_e || (t_e = 1, function(t, e) {
    (function(n, a) {
      t.exports = a();
    })(Ipr, function() {
      return (
        /******/
        function(r) {
          var n = {};
          function a(i) {
            if (n[i])
              return n[i].exports;
            var o = n[i] = {
              /******/
              i,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return r[i].call(o.exports, o, o.exports, a), o.l = !0, o.exports;
          }
          return a.m = r, a.c = n, a.i = function(i) {
            return i;
          }, a.d = function(i, o, s) {
            a.o(i, o) || Object.defineProperty(i, o, {
              /******/
              configurable: !1,
              /******/
              enumerable: !0,
              /******/
              get: s
              /******/
            });
          }, a.n = function(i) {
            var o = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return a.d(o, "a", o), o;
          }, a.o = function(i, o) {
            return Object.prototype.hasOwnProperty.call(i, o);
          }, a.p = "", a(a.s = 5);
        }([
          /* 0 */
          /***/
          function(r, n, a) {
            r.exports = function(i, o) {
              var s, l, c;
              for (s = 1; s < arguments.length; s++) {
                l = arguments[s];
                for (c in l)
                  l.hasOwnProperty(c) && (i[c] = l[c]);
              }
              return i;
            };
          },
          /* 1 */
          /***/
          function(r, n, a) {
            var i = a(0);
            r.exports = {
              build: function(o, s) {
                var l, c, u, f = s.plugins;
                for (l = 0, c = f.length; l < c; l++)
                  u = f[l], u.methods && i(o, u.methods), u.properties && Object.defineProperties(o, u.properties);
              },
              hook: function(o, s, l) {
                var c, u, f, h, p = o.config.plugins, g = [o.context];
                for (l && (g = g.concat(l)), c = 0, u = p.length; c < u; c++)
                  h = p[c], f = p[c][s], f && f.apply(h, g);
              }
            };
          },
          /* 2 */
          /***/
          function(r, n, a) {
            function i(o) {
              if (o.length === 0)
                return o;
              var s, l, c = o.split(/[_-]/);
              if (c.length === 1 && c[0][0].toLowerCase() === c[0][0])
                return o;
              for (l = c[0].toLowerCase(), s = 1; s < c.length; s++)
                l = l + c[s].charAt(0).toUpperCase() + c[s].substring(1).toLowerCase();
              return l;
            }
            i.prepended = function(o, s) {
              return s = i(s), o + s[0].toUpperCase() + s.substring(1);
            }, r.exports = i;
          },
          /* 3 */
          /***/
          function(r, n, a) {
            var i = a(0), o = a(2);
            function s(l, c) {
              l = l || {}, this.options = l, this.defaults = c.defaults, this.states = [], this.transitions = [], this.map = {}, this.lifecycle = this.configureLifecycle(), this.init = this.configureInitTransition(l.init), this.data = this.configureData(l.data), this.methods = this.configureMethods(l.methods), this.map[this.defaults.wildcard] = {}, this.configureTransitions(l.transitions || []), this.plugins = this.configurePlugins(l.plugins, c.plugin);
            }
            i(s.prototype, {
              addState: function(l) {
                this.map[l] || (this.states.push(l), this.addStateLifecycleNames(l), this.map[l] = {});
              },
              addStateLifecycleNames: function(l) {
                this.lifecycle.onEnter[l] = o.prepended("onEnter", l), this.lifecycle.onLeave[l] = o.prepended("onLeave", l), this.lifecycle.on[l] = o.prepended("on", l);
              },
              addTransition: function(l) {
                this.transitions.indexOf(l) < 0 && (this.transitions.push(l), this.addTransitionLifecycleNames(l));
              },
              addTransitionLifecycleNames: function(l) {
                this.lifecycle.onBefore[l] = o.prepended("onBefore", l), this.lifecycle.onAfter[l] = o.prepended("onAfter", l), this.lifecycle.on[l] = o.prepended("on", l);
              },
              mapTransition: function(l) {
                var c = l.name, u = l.from, f = l.to;
                return this.addState(u), typeof f != "function" && this.addState(f), this.addTransition(c), this.map[u][c] = l, l;
              },
              configureLifecycle: function() {
                return {
                  onBefore: { transition: "onBeforeTransition" },
                  onAfter: { transition: "onAfterTransition" },
                  onEnter: { state: "onEnterState" },
                  onLeave: { state: "onLeaveState" },
                  on: { transition: "onTransition" }
                };
              },
              configureInitTransition: function(l) {
                return typeof l == "string" ? this.mapTransition(i({}, this.defaults.init, { to: l, active: !0 })) : typeof l == "object" ? this.mapTransition(i({}, this.defaults.init, l, { active: !0 })) : (this.addState(this.defaults.init.from), this.defaults.init);
              },
              configureData: function(l) {
                return typeof l == "function" ? l : typeof l == "object" ? function() {
                  return l;
                } : function() {
                  return {};
                };
              },
              configureMethods: function(l) {
                return l || {};
              },
              configurePlugins: function(l, c) {
                l = l || [];
                var u, f, h;
                for (u = 0, f = l.length; u < f; u++)
                  h = l[u], typeof h == "function" && (l[u] = h = h()), h.configure && h.configure(this);
                return l;
              },
              configureTransitions: function(l) {
                var c, u, f, h, p, g = this.defaults.wildcard;
                for (u = 0; u < l.length; u++)
                  for (f = l[u], h = Array.isArray(f.from) ? f.from : [f.from || g], p = f.to || g, c = 0; c < h.length; c++)
                    this.mapTransition({ name: f.name, from: h[c], to: p });
              },
              transitionFor: function(l, c) {
                var u = this.defaults.wildcard;
                return this.map[l][c] || this.map[u][c];
              },
              transitionsFor: function(l) {
                var c = this.defaults.wildcard;
                return Object.keys(this.map[l]).concat(Object.keys(this.map[c]));
              },
              allStates: function() {
                return this.states;
              },
              allTransitions: function() {
                return this.transitions;
              }
            }), r.exports = s;
          },
          /* 4 */
          /***/
          function(r, n, a) {
            var i = a(0), o = a(6), s = a(1), l = [null, []];
            function c(u, f) {
              this.context = u, this.config = f, this.state = f.init.from, this.observers = [u];
            }
            i(c.prototype, {
              init: function(u) {
                if (i(this.context, this.config.data.apply(this.context, u)), s.hook(this, "init"), this.config.init.active)
                  return this.fire(this.config.init.name, []);
              },
              is: function(u) {
                return Array.isArray(u) ? u.indexOf(this.state) >= 0 : this.state === u;
              },
              isPending: function() {
                return this.pending;
              },
              can: function(u) {
                return !this.isPending() && !!this.seek(u);
              },
              cannot: function(u) {
                return !this.can(u);
              },
              allStates: function() {
                return this.config.allStates();
              },
              allTransitions: function() {
                return this.config.allTransitions();
              },
              transitions: function() {
                return this.config.transitionsFor(this.state);
              },
              seek: function(u, f) {
                var h = this.config.defaults.wildcard, p = this.config.transitionFor(this.state, u), g = p && p.to;
                return typeof g == "function" ? g.apply(this.context, f) : g === h ? this.state : g;
              },
              fire: function(u, f) {
                return this.transit(u, this.state, this.seek(u, f), f);
              },
              transit: function(u, f, h, p) {
                var g = this.config.lifecycle, y = this.config.options.observeUnchangedState || f !== h;
                return h ? this.isPending() ? this.context.onPendingTransition(u, f, h) : (this.config.addState(h), this.beginTransit(), p.unshift({
                  // this context will be passed to each lifecycle event observer
                  transition: u,
                  from: f,
                  to: h,
                  fsm: this.context
                }), this.observeEvents([
                  this.observersForEvent(g.onBefore.transition),
                  this.observersForEvent(g.onBefore[u]),
                  y ? this.observersForEvent(g.onLeave.state) : l,
                  y ? this.observersForEvent(g.onLeave[f]) : l,
                  this.observersForEvent(g.on.transition),
                  y ? ["doTransit", [this]] : l,
                  y ? this.observersForEvent(g.onEnter.state) : l,
                  y ? this.observersForEvent(g.onEnter[h]) : l,
                  y ? this.observersForEvent(g.on[h]) : l,
                  this.observersForEvent(g.onAfter.transition),
                  this.observersForEvent(g.onAfter[u]),
                  this.observersForEvent(g.on[u])
                ], p)) : this.context.onInvalidTransition(u, f, h);
              },
              beginTransit: function() {
                this.pending = !0;
              },
              endTransit: function(u) {
                return this.pending = !1, u;
              },
              failTransit: function(u) {
                throw this.pending = !1, u;
              },
              doTransit: function(u) {
                this.state = u.to;
              },
              observe: function(u) {
                if (u.length === 2) {
                  var f = {};
                  f[u[0]] = u[1], this.observers.push(f);
                } else
                  this.observers.push(u[0]);
              },
              observersForEvent: function(u) {
                for (var f = 0, h = this.observers.length, p, g = []; f < h; f++)
                  p = this.observers[f], p[u] && g.push(p);
                return [u, g, !0];
              },
              observeEvents: function(u, f, h, p) {
                if (u.length === 0)
                  return this.endTransit(p === void 0 ? !0 : p);
                var g = u[0][0], y = u[0][1], b = u[0][2];
                if (f[0].event = g, g && b && g !== h && s.hook(this, "lifecycle", f), y.length === 0)
                  return u.shift(), this.observeEvents(u, f, g, p);
                var w = y.shift(), _ = w[g].apply(w, f);
                return _ && typeof _.then == "function" ? _.then(this.observeEvents.bind(this, u, f, g)).catch(this.failTransit.bind(this)) : _ === !1 ? this.endTransit(!1) : this.observeEvents(u, f, g, _);
              },
              onInvalidTransition: function(u, f, h) {
                throw new o("transition is invalid in current state", u, f, h, this.state);
              },
              onPendingTransition: function(u, f, h) {
                throw new o("transition is invalid while previous transition is still in progress", u, f, h, this.state);
              }
            }), r.exports = c;
          },
          /* 5 */
          /***/
          function(r, n, a) {
            var i = a(0), o = a(2), s = a(1), l = a(3), c = a(4), u = {
              is: function(b) {
                return this._fsm.is(b);
              },
              can: function(b) {
                return this._fsm.can(b);
              },
              cannot: function(b) {
                return this._fsm.cannot(b);
              },
              observe: function() {
                return this._fsm.observe(arguments);
              },
              transitions: function() {
                return this._fsm.transitions();
              },
              allTransitions: function() {
                return this._fsm.allTransitions();
              },
              allStates: function() {
                return this._fsm.allStates();
              },
              onInvalidTransition: function(b, w, _) {
                return this._fsm.onInvalidTransition(b, w, _);
              },
              onPendingTransition: function(b, w, _) {
                return this._fsm.onPendingTransition(b, w, _);
              }
            }, f = {
              state: {
                configurable: !1,
                enumerable: !0,
                get: function() {
                  return this._fsm.state;
                },
                set: function(b) {
                  throw Error("use transitions to change state");
                }
              }
            };
            function h(b) {
              return g(this || {}, b);
            }
            function p() {
              var b, w;
              typeof arguments[0] == "function" ? (b = arguments[0], w = arguments[1] || {}) : (b = function() {
                this._fsm.apply(this, arguments);
              }, w = arguments[0] || {});
              var _ = new l(w, h);
              return y(b.prototype, _), b.prototype._fsm.config = _, b;
            }
            function g(b, w) {
              var _ = new l(w, h);
              return y(b, _), b._fsm(), b;
            }
            function y(b, w) {
              if (typeof b != "object" || Array.isArray(b))
                throw Error("StateMachine can only be applied to objects");
              s.build(b, w), Object.defineProperties(b, f), i(b, u), i(b, w.methods), w.allTransitions().forEach(function(_) {
                b[o(_)] = function() {
                  return this._fsm.fire(_, [].slice.call(arguments));
                };
              }), b._fsm = function() {
                this._fsm = new c(this, w), this._fsm.init(arguments);
              };
            }
            h.version = "3.0.1", h.factory = p, h.apply = g, h.defaults = {
              wildcard: "*",
              init: {
                name: "init",
                from: "none"
              }
            }, r.exports = h;
          },
          /* 6 */
          /***/
          function(r, n, a) {
            r.exports = function(i, o, s, l, c) {
              this.message = i, this.transition = o, this.from = s, this.to = l, this.current = c;
            };
          }
          /******/
        ])
      );
    });
  }(p$)), p$.exports;
}
var XX = {}, xB = {}, r_e;
function Ppr() {
  return r_e || (r_e = 1, Object.defineProperty(xB, "__esModule", { value: !0 }), xB.default = "ffffffff-ffff-ffff-ffff-ffffffffffff"), xB;
}
var CB = {}, n_e;
function Rpr() {
  return n_e || (n_e = 1, Object.defineProperty(CB, "__esModule", { value: !0 }), CB.default = "00000000-0000-0000-0000-000000000000"), CB;
}
var wB = {}, SB = {}, _B = {}, a_e;
function Opr() {
  return a_e || (a_e = 1, Object.defineProperty(_B, "__esModule", { value: !0 }), _B.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i), _B;
}
var i_e;
function YG() {
  if (i_e) return SB;
  i_e = 1, Object.defineProperty(SB, "__esModule", { value: !0 });
  const t = Opr();
  function e(r) {
    return typeof r == "string" && t.default.test(r);
  }
  return SB.default = e, SB;
}
var o_e;
function XG() {
  if (o_e) return wB;
  o_e = 1, Object.defineProperty(wB, "__esModule", { value: !0 });
  const t = YG();
  function e(r) {
    if (!(0, t.default)(r))
      throw TypeError("Invalid UUID");
    let n;
    return Uint8Array.of((n = parseInt(r.slice(0, 8), 16)) >>> 24, n >>> 16 & 255, n >>> 8 & 255, n & 255, (n = parseInt(r.slice(9, 13), 16)) >>> 8, n & 255, (n = parseInt(r.slice(14, 18), 16)) >>> 8, n & 255, (n = parseInt(r.slice(19, 23), 16)) >>> 8, n & 255, (n = parseInt(r.slice(24, 36), 16)) / 1099511627776 & 255, n / 4294967296 & 255, n >>> 24 & 255, n >>> 16 & 255, n >>> 8 & 255, n & 255);
  }
  return wB.default = e, wB;
}
var V4 = {}, s_e;
function Vy() {
  if (s_e) return V4;
  s_e = 1, Object.defineProperty(V4, "__esModule", { value: !0 }), V4.unsafeStringify = void 0;
  const t = YG(), e = [];
  for (let a = 0; a < 256; ++a)
    e.push((a + 256).toString(16).slice(1));
  function r(a, i = 0) {
    return (e[a[i + 0]] + e[a[i + 1]] + e[a[i + 2]] + e[a[i + 3]] + "-" + e[a[i + 4]] + e[a[i + 5]] + "-" + e[a[i + 6]] + e[a[i + 7]] + "-" + e[a[i + 8]] + e[a[i + 9]] + "-" + e[a[i + 10]] + e[a[i + 11]] + e[a[i + 12]] + e[a[i + 13]] + e[a[i + 14]] + e[a[i + 15]]).toLowerCase();
  }
  V4.unsafeStringify = r;
  function n(a, i = 0) {
    const o = r(a, i);
    if (!(0, t.default)(o))
      throw TypeError("Stringified UUID is invalid");
    return o;
  }
  return V4.default = n, V4;
}
var q4 = {}, kB = {}, l_e;
function jme() {
  if (l_e) return kB;
  l_e = 1, Object.defineProperty(kB, "__esModule", { value: !0 });
  let t;
  const e = new Uint8Array(16);
  function r() {
    if (!t) {
      if (typeof crypto > "u" || !crypto.getRandomValues)
        throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
      t = crypto.getRandomValues.bind(crypto);
    }
    return t(e);
  }
  return kB.default = r, kB;
}
var c_e;
function drt() {
  if (c_e) return q4;
  c_e = 1, Object.defineProperty(q4, "__esModule", { value: !0 }), q4.updateV1State = void 0;
  const t = jme(), e = Vy(), r = {};
  function n(o, s, l) {
    var f;
    let c;
    const u = (o == null ? void 0 : o._v6) ?? !1;
    if (o) {
      const h = Object.keys(o);
      h.length === 1 && h[0] === "_v6" && (o = void 0);
    }
    if (o)
      c = i(o.random ?? ((f = o.rng) == null ? void 0 : f.call(o)) ?? (0, t.default)(), o.msecs, o.nsecs, o.clockseq, o.node, s, l);
    else {
      const h = Date.now(), p = (0, t.default)();
      a(r, h, p), c = i(p, r.msecs, r.nsecs, u ? void 0 : r.clockseq, u ? void 0 : r.node, s, l);
    }
    return s ?? (0, e.unsafeStringify)(c);
  }
  function a(o, s, l) {
    return o.msecs ?? (o.msecs = -1 / 0), o.nsecs ?? (o.nsecs = 0), s === o.msecs ? (o.nsecs++, o.nsecs >= 1e4 && (o.node = void 0, o.nsecs = 0)) : s > o.msecs ? o.nsecs = 0 : s < o.msecs && (o.node = void 0), o.node || (o.node = l.slice(10, 16), o.node[0] |= 1, o.clockseq = (l[8] << 8 | l[9]) & 16383), o.msecs = s, o;
  }
  q4.updateV1State = a;
  function i(o, s, l, c, u, f, h = 0) {
    if (o.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!f)
      f = new Uint8Array(16), h = 0;
    else if (h < 0 || h + 16 > f.length)
      throw new RangeError(`UUID byte range ${h}:${h + 15} is out of buffer bounds`);
    s ?? (s = Date.now()), l ?? (l = 0), c ?? (c = (o[8] << 8 | o[9]) & 16383), u ?? (u = o.slice(10, 16)), s += 122192928e5;
    const p = ((s & 268435455) * 1e4 + l) % 4294967296;
    f[h++] = p >>> 24 & 255, f[h++] = p >>> 16 & 255, f[h++] = p >>> 8 & 255, f[h++] = p & 255;
    const g = s / 4294967296 * 1e4 & 268435455;
    f[h++] = g >>> 8 & 255, f[h++] = g & 255, f[h++] = g >>> 24 & 15 | 16, f[h++] = g >>> 16 & 255, f[h++] = c >>> 8 | 128, f[h++] = c & 255;
    for (let y = 0; y < 6; ++y)
      f[h++] = u[y];
    return f;
  }
  return q4.default = n, q4;
}
var AB = {}, u_e;
function frt() {
  if (u_e) return AB;
  u_e = 1, Object.defineProperty(AB, "__esModule", { value: !0 });
  const t = XG(), e = Vy();
  function r(a) {
    const i = typeof a == "string" ? (0, t.default)(a) : a, o = n(i);
    return typeof a == "string" ? (0, e.unsafeStringify)(o) : o;
  }
  AB.default = r;
  function n(a) {
    return Uint8Array.of((a[6] & 15) << 4 | a[7] >> 4 & 15, (a[7] & 15) << 4 | (a[4] & 240) >> 4, (a[4] & 15) << 4 | (a[5] & 240) >> 4, (a[5] & 15) << 4 | (a[0] & 240) >> 4, (a[0] & 15) << 4 | (a[1] & 240) >> 4, (a[1] & 15) << 4 | (a[2] & 240) >> 4, 96 | a[2] & 15, a[3], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  }
  return AB;
}
var QX = {}, TB = {}, d_e;
function Bpr() {
  if (d_e) return TB;
  d_e = 1, Object.defineProperty(TB, "__esModule", { value: !0 });
  function t(h) {
    const p = a(h), g = n(p, h.length * 8);
    return e(g);
  }
  function e(h) {
    const p = new Uint8Array(h.length * 4);
    for (let g = 0; g < h.length * 4; g++)
      p[g] = h[g >> 2] >>> g % 4 * 8 & 255;
    return p;
  }
  function r(h) {
    return (h + 64 >>> 9 << 4) + 14 + 1;
  }
  function n(h, p) {
    const g = new Uint32Array(r(p)).fill(0);
    g.set(h), g[p >> 5] |= 128 << p % 32, g[g.length - 1] = p, h = g;
    let y = 1732584193, b = -271733879, w = -1732584194, _ = 271733878;
    for (let C = 0; C < h.length; C += 16) {
      const x = y, S = b, A = w, I = _;
      y = l(y, b, w, _, h[C], 7, -680876936), _ = l(_, y, b, w, h[C + 1], 12, -389564586), w = l(w, _, y, b, h[C + 2], 17, 606105819), b = l(b, w, _, y, h[C + 3], 22, -1044525330), y = l(y, b, w, _, h[C + 4], 7, -176418897), _ = l(_, y, b, w, h[C + 5], 12, 1200080426), w = l(w, _, y, b, h[C + 6], 17, -1473231341), b = l(b, w, _, y, h[C + 7], 22, -45705983), y = l(y, b, w, _, h[C + 8], 7, 1770035416), _ = l(_, y, b, w, h[C + 9], 12, -1958414417), w = l(w, _, y, b, h[C + 10], 17, -42063), b = l(b, w, _, y, h[C + 11], 22, -1990404162), y = l(y, b, w, _, h[C + 12], 7, 1804603682), _ = l(_, y, b, w, h[C + 13], 12, -40341101), w = l(w, _, y, b, h[C + 14], 17, -1502002290), b = l(b, w, _, y, h[C + 15], 22, 1236535329), y = c(y, b, w, _, h[C + 1], 5, -165796510), _ = c(_, y, b, w, h[C + 6], 9, -1069501632), w = c(w, _, y, b, h[C + 11], 14, 643717713), b = c(b, w, _, y, h[C], 20, -373897302), y = c(y, b, w, _, h[C + 5], 5, -701558691), _ = c(_, y, b, w, h[C + 10], 9, 38016083), w = c(w, _, y, b, h[C + 15], 14, -660478335), b = c(b, w, _, y, h[C + 4], 20, -405537848), y = c(y, b, w, _, h[C + 9], 5, 568446438), _ = c(_, y, b, w, h[C + 14], 9, -1019803690), w = c(w, _, y, b, h[C + 3], 14, -187363961), b = c(b, w, _, y, h[C + 8], 20, 1163531501), y = c(y, b, w, _, h[C + 13], 5, -1444681467), _ = c(_, y, b, w, h[C + 2], 9, -51403784), w = c(w, _, y, b, h[C + 7], 14, 1735328473), b = c(b, w, _, y, h[C + 12], 20, -1926607734), y = u(y, b, w, _, h[C + 5], 4, -378558), _ = u(_, y, b, w, h[C + 8], 11, -2022574463), w = u(w, _, y, b, h[C + 11], 16, 1839030562), b = u(b, w, _, y, h[C + 14], 23, -35309556), y = u(y, b, w, _, h[C + 1], 4, -1530992060), _ = u(_, y, b, w, h[C + 4], 11, 1272893353), w = u(w, _, y, b, h[C + 7], 16, -155497632), b = u(b, w, _, y, h[C + 10], 23, -1094730640), y = u(y, b, w, _, h[C + 13], 4, 681279174), _ = u(_, y, b, w, h[C], 11, -358537222), w = u(w, _, y, b, h[C + 3], 16, -722521979), b = u(b, w, _, y, h[C + 6], 23, 76029189), y = u(y, b, w, _, h[C + 9], 4, -640364487), _ = u(_, y, b, w, h[C + 12], 11, -421815835), w = u(w, _, y, b, h[C + 15], 16, 530742520), b = u(b, w, _, y, h[C + 2], 23, -995338651), y = f(y, b, w, _, h[C], 6, -198630844), _ = f(_, y, b, w, h[C + 7], 10, 1126891415), w = f(w, _, y, b, h[C + 14], 15, -1416354905), b = f(b, w, _, y, h[C + 5], 21, -57434055), y = f(y, b, w, _, h[C + 12], 6, 1700485571), _ = f(_, y, b, w, h[C + 3], 10, -1894986606), w = f(w, _, y, b, h[C + 10], 15, -1051523), b = f(b, w, _, y, h[C + 1], 21, -2054922799), y = f(y, b, w, _, h[C + 8], 6, 1873313359), _ = f(_, y, b, w, h[C + 15], 10, -30611744), w = f(w, _, y, b, h[C + 6], 15, -1560198380), b = f(b, w, _, y, h[C + 13], 21, 1309151649), y = f(y, b, w, _, h[C + 4], 6, -145523070), _ = f(_, y, b, w, h[C + 11], 10, -1120210379), w = f(w, _, y, b, h[C + 2], 15, 718787259), b = f(b, w, _, y, h[C + 9], 21, -343485551), y = i(y, x), b = i(b, S), w = i(w, A), _ = i(_, I);
    }
    return Uint32Array.of(y, b, w, _);
  }
  function a(h) {
    if (h.length === 0)
      return new Uint32Array();
    const p = new Uint32Array(r(h.length * 8)).fill(0);
    for (let g = 0; g < h.length; g++)
      p[g >> 2] |= (h[g] & 255) << g % 4 * 8;
    return p;
  }
  function i(h, p) {
    const g = (h & 65535) + (p & 65535);
    return (h >> 16) + (p >> 16) + (g >> 16) << 16 | g & 65535;
  }
  function o(h, p) {
    return h << p | h >>> 32 - p;
  }
  function s(h, p, g, y, b, w) {
    return i(o(i(i(p, h), i(y, w)), b), g);
  }
  function l(h, p, g, y, b, w, _) {
    return s(p & g | ~p & y, h, p, b, w, _);
  }
  function c(h, p, g, y, b, w, _) {
    return s(p & y | g & ~y, h, p, b, w, _);
  }
  function u(h, p, g, y, b, w, _) {
    return s(p ^ g ^ y, h, p, b, w, _);
  }
  function f(h, p, g, y, b, w, _) {
    return s(g ^ (p | ~y), h, p, b, w, _);
  }
  return TB.default = t, TB;
}
var L2 = {}, f_e;
function qL() {
  if (f_e) return L2;
  f_e = 1, Object.defineProperty(L2, "__esModule", { value: !0 }), L2.URL = L2.DNS = L2.stringToBytes = void 0;
  const t = XG(), e = Vy();
  function r(a) {
    a = unescape(encodeURIComponent(a));
    const i = new Uint8Array(a.length);
    for (let o = 0; o < a.length; ++o)
      i[o] = a.charCodeAt(o);
    return i;
  }
  L2.stringToBytes = r, L2.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", L2.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  function n(a, i, o, s, l, c) {
    const u = typeof o == "string" ? r(o) : o, f = typeof s == "string" ? (0, t.default)(s) : s;
    if (typeof s == "string" && (s = (0, t.default)(s)), (s == null ? void 0 : s.length) !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    let h = new Uint8Array(16 + u.length);
    if (h.set(f), h.set(u, f.length), h = i(h), h[6] = h[6] & 15 | a, h[8] = h[8] & 63 | 128, l) {
      c = c || 0;
      for (let p = 0; p < 16; ++p)
        l[c + p] = h[p];
      return l;
    }
    return (0, e.unsafeStringify)(h);
  }
  return L2.default = n, L2;
}
var h_e;
function Npr() {
  return h_e || (h_e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.URL = t.DNS = void 0;
    const e = Bpr(), r = qL();
    var n = qL();
    Object.defineProperty(t, "DNS", { enumerable: !0, get: function() {
      return n.DNS;
    } }), Object.defineProperty(t, "URL", { enumerable: !0, get: function() {
      return n.URL;
    } });
    function a(i, o, s, l) {
      return (0, r.default)(48, e.default, i, o, s, l);
    }
    a.DNS = r.DNS, a.URL = r.URL, t.default = a;
  }(QX)), QX;
}
var EB = {}, IB = {}, p_e;
function $pr() {
  if (p_e) return IB;
  p_e = 1, Object.defineProperty(IB, "__esModule", { value: !0 });
  const t = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
  return IB.default = { randomUUID: t }, IB;
}
var m_e;
function Dpr() {
  if (m_e) return EB;
  m_e = 1, Object.defineProperty(EB, "__esModule", { value: !0 });
  const t = $pr(), e = jme(), r = Vy();
  function n(a, i, o) {
    var l;
    if (t.default.randomUUID && !i && !a)
      return t.default.randomUUID();
    a = a || {};
    const s = a.random ?? ((l = a.rng) == null ? void 0 : l.call(a)) ?? (0, e.default)();
    if (s.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, i) {
      if (o = o || 0, o < 0 || o + 16 > i.length)
        throw new RangeError(`UUID byte range ${o}:${o + 15} is out of buffer bounds`);
      for (let c = 0; c < 16; ++c)
        i[o + c] = s[c];
      return i;
    }
    return (0, r.unsafeStringify)(s);
  }
  return EB.default = n, EB;
}
var eQ = {}, MB = {}, g_e;
function Lpr() {
  if (g_e) return MB;
  g_e = 1, Object.defineProperty(MB, "__esModule", { value: !0 });
  function t(n, a, i, o) {
    switch (n) {
      case 0:
        return a & i ^ ~a & o;
      case 1:
        return a ^ i ^ o;
      case 2:
        return a & i ^ a & o ^ i & o;
      case 3:
        return a ^ i ^ o;
    }
  }
  function e(n, a) {
    return n << a | n >>> 32 - a;
  }
  function r(n) {
    const a = [1518500249, 1859775393, 2400959708, 3395469782], i = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], o = new Uint8Array(n.length + 1);
    o.set(n), o[n.length] = 128, n = o;
    const s = n.length / 4 + 2, l = Math.ceil(s / 16), c = new Array(l);
    for (let u = 0; u < l; ++u) {
      const f = new Uint32Array(16);
      for (let h = 0; h < 16; ++h)
        f[h] = n[u * 64 + h * 4] << 24 | n[u * 64 + h * 4 + 1] << 16 | n[u * 64 + h * 4 + 2] << 8 | n[u * 64 + h * 4 + 3];
      c[u] = f;
    }
    c[l - 1][14] = (n.length - 1) * 8 / Math.pow(2, 32), c[l - 1][14] = Math.floor(c[l - 1][14]), c[l - 1][15] = (n.length - 1) * 8 & 4294967295;
    for (let u = 0; u < l; ++u) {
      const f = new Uint32Array(80);
      for (let w = 0; w < 16; ++w)
        f[w] = c[u][w];
      for (let w = 16; w < 80; ++w)
        f[w] = e(f[w - 3] ^ f[w - 8] ^ f[w - 14] ^ f[w - 16], 1);
      let h = i[0], p = i[1], g = i[2], y = i[3], b = i[4];
      for (let w = 0; w < 80; ++w) {
        const _ = Math.floor(w / 20), C = e(h, 5) + t(_, p, g, y) + b + a[_] + f[w] >>> 0;
        b = y, y = g, g = e(p, 30) >>> 0, p = h, h = C;
      }
      i[0] = i[0] + h >>> 0, i[1] = i[1] + p >>> 0, i[2] = i[2] + g >>> 0, i[3] = i[3] + y >>> 0, i[4] = i[4] + b >>> 0;
    }
    return Uint8Array.of(i[0] >> 24, i[0] >> 16, i[0] >> 8, i[0], i[1] >> 24, i[1] >> 16, i[1] >> 8, i[1], i[2] >> 24, i[2] >> 16, i[2] >> 8, i[2], i[3] >> 24, i[3] >> 16, i[3] >> 8, i[3], i[4] >> 24, i[4] >> 16, i[4] >> 8, i[4]);
  }
  return MB.default = r, MB;
}
var v_e;
function jpr() {
  return v_e || (v_e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.URL = t.DNS = void 0;
    const e = Lpr(), r = qL();
    var n = qL();
    Object.defineProperty(t, "DNS", { enumerable: !0, get: function() {
      return n.DNS;
    } }), Object.defineProperty(t, "URL", { enumerable: !0, get: function() {
      return n.URL;
    } });
    function a(i, o, s, l) {
      return (0, r.default)(80, e.default, i, o, s, l);
    }
    a.DNS = r.DNS, a.URL = r.URL, t.default = a;
  }(eQ)), eQ;
}
var PB = {}, y_e;
function Fpr() {
  if (y_e) return PB;
  y_e = 1, Object.defineProperty(PB, "__esModule", { value: !0 });
  const t = Vy(), e = drt(), r = frt();
  function n(a, i, o) {
    a ?? (a = {}), o ?? (o = 0);
    let s = (0, e.default)({ ...a, _v6: !0 }, new Uint8Array(16));
    if (s = (0, r.default)(s), i) {
      for (let l = 0; l < 16; l++)
        i[o + l] = s[l];
      return i;
    }
    return (0, t.unsafeStringify)(s);
  }
  return PB.default = n, PB;
}
var RB = {}, b_e;
function zpr() {
  if (b_e) return RB;
  b_e = 1, Object.defineProperty(RB, "__esModule", { value: !0 });
  const t = XG(), e = Vy();
  function r(a) {
    const i = typeof a == "string" ? (0, t.default)(a) : a, o = n(i);
    return typeof a == "string" ? (0, e.unsafeStringify)(o) : o;
  }
  RB.default = r;
  function n(a) {
    return Uint8Array.of((a[3] & 15) << 4 | a[4] >> 4 & 15, (a[4] & 15) << 4 | (a[5] & 240) >> 4, (a[5] & 15) << 4 | a[6] & 15, a[7], (a[1] & 15) << 4 | (a[2] & 240) >> 4, (a[2] & 15) << 4 | (a[3] & 240) >> 4, 16 | (a[0] & 240) >> 4, (a[0] & 15) << 4 | (a[1] & 240) >> 4, a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  }
  return RB;
}
var K4 = {}, x_e;
function Gpr() {
  if (x_e) return K4;
  x_e = 1, Object.defineProperty(K4, "__esModule", { value: !0 }), K4.updateV7State = void 0;
  const t = jme(), e = Vy(), r = {};
  function n(o, s, l) {
    var u;
    let c;
    if (o)
      c = i(o.random ?? ((u = o.rng) == null ? void 0 : u.call(o)) ?? (0, t.default)(), o.msecs, o.seq, s, l);
    else {
      const f = Date.now(), h = (0, t.default)();
      a(r, f, h), c = i(h, r.msecs, r.seq, s, l);
    }
    return s ?? (0, e.unsafeStringify)(c);
  }
  function a(o, s, l) {
    return o.msecs ?? (o.msecs = -1 / 0), o.seq ?? (o.seq = 0), s > o.msecs ? (o.seq = l[6] << 23 | l[7] << 16 | l[8] << 8 | l[9], o.msecs = s) : (o.seq = o.seq + 1 | 0, o.seq === 0 && o.msecs++), o;
  }
  K4.updateV7State = a;
  function i(o, s, l, c, u = 0) {
    if (o.length < 16)
      throw new Error("Random bytes length must be >= 16");
    if (!c)
      c = new Uint8Array(16), u = 0;
    else if (u < 0 || u + 16 > c.length)
      throw new RangeError(`UUID byte range ${u}:${u + 15} is out of buffer bounds`);
    return s ?? (s = Date.now()), l ?? (l = o[6] * 127 << 24 | o[7] << 16 | o[8] << 8 | o[9]), c[u++] = s / 1099511627776 & 255, c[u++] = s / 4294967296 & 255, c[u++] = s / 16777216 & 255, c[u++] = s / 65536 & 255, c[u++] = s / 256 & 255, c[u++] = s & 255, c[u++] = 112 | l >>> 28 & 15, c[u++] = l >>> 20 & 255, c[u++] = 128 | l >>> 14 & 63, c[u++] = l >>> 6 & 255, c[u++] = l << 2 & 255 | o[10] & 3, c[u++] = o[11], c[u++] = o[12], c[u++] = o[13], c[u++] = o[14], c[u++] = o[15], c;
  }
  return K4.default = n, K4;
}
var OB = {}, C_e;
function Wpr() {
  if (C_e) return OB;
  C_e = 1, Object.defineProperty(OB, "__esModule", { value: !0 });
  const t = YG();
  function e(r) {
    if (!(0, t.default)(r))
      throw TypeError("Invalid UUID");
    return parseInt(r.slice(14, 15), 16);
  }
  return OB.default = e, OB;
}
var w_e;
function QG() {
  return w_e || (w_e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.version = t.validate = t.v7 = t.v6ToV1 = t.v6 = t.v5 = t.v4 = t.v3 = t.v1ToV6 = t.v1 = t.stringify = t.parse = t.NIL = t.MAX = void 0;
    var e = Ppr();
    Object.defineProperty(t, "MAX", { enumerable: !0, get: function() {
      return e.default;
    } });
    var r = Rpr();
    Object.defineProperty(t, "NIL", { enumerable: !0, get: function() {
      return r.default;
    } });
    var n = XG();
    Object.defineProperty(t, "parse", { enumerable: !0, get: function() {
      return n.default;
    } });
    var a = Vy();
    Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
      return a.default;
    } });
    var i = drt();
    Object.defineProperty(t, "v1", { enumerable: !0, get: function() {
      return i.default;
    } });
    var o = frt();
    Object.defineProperty(t, "v1ToV6", { enumerable: !0, get: function() {
      return o.default;
    } });
    var s = Npr();
    Object.defineProperty(t, "v3", { enumerable: !0, get: function() {
      return s.default;
    } });
    var l = Dpr();
    Object.defineProperty(t, "v4", { enumerable: !0, get: function() {
      return l.default;
    } });
    var c = jpr();
    Object.defineProperty(t, "v5", { enumerable: !0, get: function() {
      return c.default;
    } });
    var u = Fpr();
    Object.defineProperty(t, "v6", { enumerable: !0, get: function() {
      return u.default;
    } });
    var f = zpr();
    Object.defineProperty(t, "v6ToV1", { enumerable: !0, get: function() {
      return f.default;
    } });
    var h = Gpr();
    Object.defineProperty(t, "v7", { enumerable: !0, get: function() {
      return h.default;
    } });
    var p = YG();
    Object.defineProperty(t, "validate", { enumerable: !0, get: function() {
      return p.default;
    } });
    var g = Wpr();
    Object.defineProperty(t, "version", { enumerable: !0, get: function() {
      return g.default;
    } });
  }(XX)), XX;
}
var S_e = {}, tQ, __e;
function eW() {
  if (__e) return tQ;
  __e = 1, p6();
  var t = No(), e = Gu(), r = Rme(), n = Ba(), a = Do(), i = fg(), o = a("species"), s = RegExp.prototype;
  return tQ = function(l, c, u, f) {
    var h = a(l), p = !n(function() {
      var w = {};
      return w[h] = function() {
        return 7;
      }, ""[l](w) !== 7;
    }), g = p && !n(function() {
      var w = !1, _ = /a/;
      return l === "split" && (_ = {}, _.constructor = {}, _.constructor[o] = function() {
        return _;
      }, _.flags = "", _[h] = /./[h]), _.exec = function() {
        return w = !0, null;
      }, _[h](""), !w;
    });
    if (!p || !g || u) {
      var y = /./[h], b = c(h, ""[l], function(w, _, C, x, S) {
        var A = _.exec;
        return A === r || A === s.exec ? p && !S ? { done: !0, value: t(y, _, C, x) } : { done: !0, value: t(w, C, _, x) } : { done: !1 };
      });
      e(String.prototype, l, b[0]), e(s, h, b[1]);
    }
    f && i(s[h], "sham", !0);
  }, tQ;
}
var rQ, k_e;
function Fme() {
  if (k_e) return rQ;
  k_e = 1;
  var t = Pme().charAt;
  return rQ = function(e, r, n) {
    return r + (n ? t(e, r).length : 1);
  }, rQ;
}
var nQ, A_e;
function Hpr() {
  if (A_e) return nQ;
  A_e = 1;
  var t = Wa(), e = ru(), r = Math.floor, n = t("".charAt), a = t("".replace), i = t("".slice), o = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, s = /\$([$&'`]|\d{1,2})/g;
  return nQ = function(l, c, u, f, h, p) {
    var g = u + l.length, y = f.length, b = s;
    return h !== void 0 && (h = e(h), b = o), a(p, b, function(w, _) {
      var C;
      switch (n(_, 0)) {
        case "$":
          return "$";
        case "&":
          return l;
        case "`":
          return i(c, 0, u);
        case "'":
          return i(c, g);
        case "<":
          C = h[i(_, 1, -1)];
          break;
        default:
          var x = +_;
          if (x === 0) return w;
          if (x > y) {
            var S = r(x / 10);
            return S === 0 ? w : S <= y ? f[S - 1] === void 0 ? n(_, 1) : f[S - 1] + n(_, 1) : w;
          }
          C = f[x - 1];
      }
      return C === void 0 ? "" : C;
    });
  }, nQ;
}
var aQ, T_e;
function tW() {
  if (T_e) return aQ;
  T_e = 1;
  var t = No(), e = Ys(), r = $o(), n = Yh(), a = Rme(), i = TypeError;
  return aQ = function(o, s) {
    var l = o.exec;
    if (r(l)) {
      var c = t(l, o, s);
      return c !== null && e(c), c;
    }
    if (n(o) === "RegExp") return t(a, o, s);
    throw new i("RegExp#exec called on incompatible receiver");
  }, aQ;
}
var E_e;
function rW() {
  if (E_e) return S_e;
  E_e = 1;
  var t = o6(), e = No(), r = Wa(), n = eW(), a = Ba(), i = Ys(), o = $o(), s = u2(), l = Xh(), c = hg(), u = Vl(), f = d2(), h = Fme(), p = a6(), g = Hpr(), y = tW(), b = Do(), w = b("replace"), _ = Math.max, C = Math.min, x = r([].concat), S = r([].push), A = r("".indexOf), I = r("".slice), M = function(d) {
    return d === void 0 ? d : String(d);
  }, B = function() {
    return "a".replace(/./, "$0") === "$0";
  }(), L = function() {
    return /./[w] ? /./[w]("a", "$0") === "" : !1;
  }(), N = !a(function() {
    var d = /./;
    return d.exec = function() {
      var m = [];
      return m.groups = { a: "7" }, m;
    }, "".replace(d, "$<a>") !== "7";
  });
  return n("replace", function(d, m, v) {
    var k = L ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(G, H) {
        var j = f(this), F = s(G) ? void 0 : p(G, w);
        return F ? e(F, G, j, H) : e(m, u(j), G, H);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(O, G) {
        var H = i(this), j = u(O);
        if (typeof G == "string" && A(G, k) === -1 && A(G, "$<") === -1) {
          var F = v(m, H, j, G);
          if (F.done) return F.value;
        }
        var z = o(G);
        z || (G = u(G));
        var W = H.global, U;
        W && (U = H.unicode, H.lastIndex = 0);
        for (var Z = [], V; V = y(H, j), !(V === null || (S(Z, V), !W)); ) {
          var Y = u(V[0]);
          Y === "" && (H.lastIndex = h(j, c(H.lastIndex), U));
        }
        for (var ge = "", ce = 0, ee = 0; ee < Z.length; ee++) {
          V = Z[ee];
          for (var Se = u(V[0]), Ce = _(C(l(V.index), j.length), 0), we = [], We, Fe = 1; Fe < V.length; Fe++) S(we, M(V[Fe]));
          var it = V.groups;
          if (z) {
            var gt = x([Se], we, Ce, j);
            it !== void 0 && S(gt, it), We = u(t(G, void 0, gt));
          } else
            We = g(Se, j, Ce, we, it, G);
          Ce >= ce && (ge += I(j, ce, Ce) + We, ce = Ce + Se.length);
        }
        return ge + I(j, ce);
      }
    ];
  }, !N || !B || L), S_e;
}
var I_e = {}, BB = { exports: {} }, iQ, M_e;
function hrt() {
  return M_e || (M_e = 1, iQ = typeof ArrayBuffer < "u" && typeof DataView < "u"), iQ;
}
var oQ, P_e;
function Wo() {
  if (P_e) return oQ;
  P_e = 1;
  var t = hrt(), e = Go(), r = wi(), n = $o(), a = fs(), i = Es(), o = pg(), s = n6(), l = fg(), c = Gu(), u = ep(), f = dg(), h = zM(), p = W8(), g = Do(), y = _M(), b = _0(), w = b.enforce, _ = b.get, C = r.Int8Array, x = C && C.prototype, S = r.Uint8ClampedArray, A = S && S.prototype, I = C && h(C), M = x && h(x), B = Object.prototype, L = r.TypeError, N = g("toStringTag"), d = y("TYPED_ARRAY_TAG"), m = "TypedArrayConstructor", v = t && !!p && o(r.opera) !== "Opera", k = !1, O, G, H, j = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  }, F = {
    BigInt64Array: 8,
    BigUint64Array: 8
  }, z = function(ee) {
    if (!a(ee)) return !1;
    var Se = o(ee);
    return Se === "DataView" || i(j, Se) || i(F, Se);
  }, W = function(ce) {
    var ee = h(ce);
    if (a(ee)) {
      var Se = _(ee);
      return Se && i(Se, m) ? Se[m] : W(ee);
    }
  }, U = function(ce) {
    if (!a(ce)) return !1;
    var ee = o(ce);
    return i(j, ee) || i(F, ee);
  }, Z = function(ce) {
    if (U(ce)) return ce;
    throw new L("Target is not a typed array");
  }, V = function(ce) {
    if (n(ce) && (!p || f(I, ce))) return ce;
    throw new L(s(ce) + " is not a typed array constructor");
  }, Y = function(ce, ee, Se, Ce) {
    if (e) {
      if (Se) for (var we in j) {
        var We = r[we];
        if (We && i(We.prototype, ce)) try {
          delete We.prototype[ce];
        } catch {
          try {
            We.prototype[ce] = ee;
          } catch {
          }
        }
      }
      (!M[ce] || Se) && c(M, ce, Se ? ee : v && x[ce] || ee, Ce);
    }
  }, ge = function(ce, ee, Se) {
    var Ce, we;
    if (e) {
      if (p) {
        if (Se) {
          for (Ce in j)
            if (we = r[Ce], we && i(we, ce)) try {
              delete we[ce];
            } catch {
            }
        }
        if (!I[ce] || Se)
          try {
            return c(I, ce, Se ? ee : v && I[ce] || ee);
          } catch {
          }
        else return;
      }
      for (Ce in j)
        we = r[Ce], we && (!we[ce] || Se) && c(we, ce, ee);
    }
  };
  for (O in j)
    G = r[O], H = G && G.prototype, H ? w(H)[m] = G : v = !1;
  for (O in F)
    G = r[O], H = G && G.prototype, H && (w(H)[m] = G);
  if ((!v || !n(I) || I === Function.prototype) && (I = function() {
    throw new L("Incorrect invocation");
  }, v))
    for (O in j)
      r[O] && p(r[O], I);
  if ((!v || !M || M === B) && (M = I.prototype, v))
    for (O in j)
      r[O] && p(r[O].prototype, M);
  if (v && h(A) !== M && p(A, M), e && !i(M, N)) {
    k = !0, u(M, N, {
      configurable: !0,
      get: function() {
        return a(this) ? this[d] : void 0;
      }
    });
    for (O in j) r[O] && l(r[O], d, O);
  }
  return oQ = {
    NATIVE_ARRAY_BUFFER_VIEWS: v,
    TYPED_ARRAY_TAG: k && d,
    aTypedArray: Z,
    aTypedArrayConstructor: V,
    exportTypedArrayMethod: Y,
    exportTypedArrayStaticMethod: ge,
    getTypedArrayConstructor: W,
    isView: z,
    isTypedArray: U,
    TypedArray: I,
    TypedArrayPrototype: M
  }, oQ;
}
var sQ, R_e;
function Upr() {
  if (R_e) return sQ;
  R_e = 1;
  var t = wi(), e = Ba(), r = GG(), n = Wo().NATIVE_ARRAY_BUFFER_VIEWS, a = t.ArrayBuffer, i = t.Int8Array;
  return sQ = !n || !e(function() {
    i(1);
  }) || !e(function() {
    new i(-1);
  }) || !r(function(o) {
    new i(), new i(null), new i(1.5), new i(o);
  }, !0) || e(function() {
    return new i(new a(2), 1, void 0).length !== 1;
  }), sQ;
}
var lQ, O_e;
function prt() {
  if (O_e) return lQ;
  O_e = 1;
  var t = Xh(), e = hg(), r = RangeError;
  return lQ = function(n) {
    if (n === void 0) return 0;
    var a = t(n), i = e(a);
    if (a !== i) throw new r("Wrong length or index");
    return i;
  }, lQ;
}
var cQ, B_e;
function Vpr() {
  return B_e || (B_e = 1, cQ = Math.sign || function(e) {
    var r = +e;
    return r === 0 || r !== r ? r : r < 0 ? -1 : 1;
  }), cQ;
}
var uQ, N_e;
function qpr() {
  if (N_e) return uQ;
  N_e = 1;
  var t = Vpr(), e = Math.abs, r = 2220446049250313e-31, n = 1 / r, a = function(i) {
    return i + n - n;
  };
  return uQ = function(i, o, s, l) {
    var c = +i, u = e(c), f = t(c);
    if (u < l) return f * a(u / l / o) * l * o;
    var h = (1 + o / r) * u, p = h - (h - u);
    return p > s || p !== p ? f * (1 / 0) : f * p;
  }, uQ;
}
var dQ, $_e;
function Kpr() {
  if ($_e) return dQ;
  $_e = 1;
  var t = qpr(), e = 11920928955078125e-23, r = 34028234663852886e22, n = 11754943508222875e-54;
  return dQ = Math.fround || function(i) {
    return t(i, e, r, n);
  }, dQ;
}
var fQ, D_e;
function Zpr() {
  if (D_e) return fQ;
  D_e = 1;
  var t = Array, e = Math.abs, r = Math.pow, n = Math.floor, a = Math.log, i = Math.LN2, o = function(l, c, u) {
    var f = t(u), h = u * 8 - c - 1, p = (1 << h) - 1, g = p >> 1, y = c === 23 ? r(2, -24) - r(2, -77) : 0, b = l < 0 || l === 0 && 1 / l < 0 ? 1 : 0, w = 0, _, C, x;
    for (l = e(l), l !== l || l === 1 / 0 ? (C = l !== l ? 1 : 0, _ = p) : (_ = n(a(l) / i), x = r(2, -_), l * x < 1 && (_--, x *= 2), _ + g >= 1 ? l += y / x : l += y * r(2, 1 - g), l * x >= 2 && (_++, x /= 2), _ + g >= p ? (C = 0, _ = p) : _ + g >= 1 ? (C = (l * x - 1) * r(2, c), _ += g) : (C = l * r(2, g - 1) * r(2, c), _ = 0)); c >= 8; )
      f[w++] = C & 255, C /= 256, c -= 8;
    for (_ = _ << c | C, h += c; h > 0; )
      f[w++] = _ & 255, _ /= 256, h -= 8;
    return f[w - 1] |= b * 128, f;
  }, s = function(l, c) {
    var u = l.length, f = u * 8 - c - 1, h = (1 << f) - 1, p = h >> 1, g = f - 7, y = u - 1, b = l[y--], w = b & 127, _;
    for (b >>= 7; g > 0; )
      w = w * 256 + l[y--], g -= 8;
    for (_ = w & (1 << -g) - 1, w >>= -g, g += c; g > 0; )
      _ = _ * 256 + l[y--], g -= 8;
    if (w === 0)
      w = 1 - p;
    else {
      if (w === h)
        return _ ? NaN : b ? -1 / 0 : 1 / 0;
      _ += r(2, c), w -= p;
    }
    return (b ? -1 : 1) * _ * r(2, w - c);
  };
  return fQ = {
    pack: o,
    unpack: s
  }, fQ;
}
var hQ, L_e;
function mrt() {
  if (L_e) return hQ;
  L_e = 1;
  var t = ru(), e = i6(), r = nu();
  return hQ = function(a) {
    for (var i = t(this), o = r(i), s = arguments.length, l = e(s > 1 ? arguments[1] : void 0, o), c = s > 2 ? arguments[2] : void 0, u = c === void 0 ? o : e(c, o); u > l; ) i[l++] = a;
    return i;
  }, hQ;
}
var pQ, j_e;
function grt() {
  if (j_e) return pQ;
  j_e = 1;
  var t = wi(), e = Wa(), r = Go(), n = hrt(), a = kM(), i = fg(), o = ep(), s = JG(), l = Ba(), c = Uy(), u = Xh(), f = hg(), h = prt(), p = Kpr(), g = Zpr(), y = zM(), b = W8(), w = mrt(), _ = Qh(), C = qG(), x = mme(), S = tp(), A = _0(), I = a.PROPER, M = a.CONFIGURABLE, B = "ArrayBuffer", L = "DataView", N = "prototype", d = "Wrong length", m = "Wrong index", v = A.getterFor(B), k = A.getterFor(L), O = A.set, G = t[B], H = G, j = H && H[N], F = t[L], z = F && F[N], W = Object.prototype, U = t.Array, Z = t.RangeError, V = e(w), Y = e([].reverse), ge = g.pack, ce = g.unpack, ee = function(rt) {
    return [rt & 255];
  }, Se = function(rt) {
    return [rt & 255, rt >> 8 & 255];
  }, Ce = function(rt) {
    return [rt & 255, rt >> 8 & 255, rt >> 16 & 255, rt >> 24 & 255];
  }, we = function(rt) {
    return rt[3] << 24 | rt[2] << 16 | rt[1] << 8 | rt[0];
  }, We = function(rt) {
    return ge(p(rt), 23, 4);
  }, Fe = function(rt) {
    return ge(rt, 52, 8);
  }, it = function(rt, qe, nt) {
    o(rt[N], qe, {
      configurable: !0,
      get: function() {
        return nt(this)[qe];
      }
    });
  }, gt = function(rt, qe, nt, Rt) {
    var Ot = k(rt), lt = h(nt), mt = !!Rt;
    if (lt + qe > Ot.byteLength) throw new Z(m);
    var jt = Ot.bytes, Jt = lt + Ot.byteOffset, ne = _(jt, Jt, Jt + qe);
    return mt ? ne : Y(ne);
  }, Ze = function(rt, qe, nt, Rt, Ot, lt) {
    var mt = k(rt), jt = h(nt), Jt = Rt(+Ot), ne = !!lt;
    if (jt + qe > mt.byteLength) throw new Z(m);
    for (var re = mt.bytes, ie = jt + mt.byteOffset, Ie = 0; Ie < qe; Ie++) re[ie + Ie] = Jt[ne ? Ie : qe - Ie - 1];
  };
  if (!n)
    H = function(qe) {
      c(this, j);
      var nt = h(qe);
      O(this, {
        type: B,
        bytes: V(U(nt), 0),
        byteLength: nt
      }), r || (this.byteLength = nt, this.detached = !1);
    }, j = H[N], F = function(qe, nt, Rt) {
      c(this, z), c(qe, j);
      var Ot = v(qe), lt = Ot.byteLength, mt = u(nt);
      if (mt < 0 || mt > lt) throw new Z("Wrong offset");
      if (Rt = Rt === void 0 ? lt - mt : f(Rt), mt + Rt > lt) throw new Z(d);
      O(this, {
        type: L,
        buffer: qe,
        byteLength: Rt,
        byteOffset: mt,
        bytes: Ot.bytes
      }), r || (this.buffer = qe, this.byteLength = Rt, this.byteOffset = mt);
    }, z = F[N], r && (it(H, "byteLength", v), it(F, "buffer", k), it(F, "byteLength", k), it(F, "byteOffset", k)), s(z, {
      getInt8: function(qe) {
        return gt(this, 1, qe)[0] << 24 >> 24;
      },
      getUint8: function(qe) {
        return gt(this, 1, qe)[0];
      },
      getInt16: function(qe) {
        var nt = gt(this, 2, qe, arguments.length > 1 ? arguments[1] : !1);
        return (nt[1] << 8 | nt[0]) << 16 >> 16;
      },
      getUint16: function(qe) {
        var nt = gt(this, 2, qe, arguments.length > 1 ? arguments[1] : !1);
        return nt[1] << 8 | nt[0];
      },
      getInt32: function(qe) {
        return we(gt(this, 4, qe, arguments.length > 1 ? arguments[1] : !1));
      },
      getUint32: function(qe) {
        return we(gt(this, 4, qe, arguments.length > 1 ? arguments[1] : !1)) >>> 0;
      },
      getFloat32: function(qe) {
        return ce(gt(this, 4, qe, arguments.length > 1 ? arguments[1] : !1), 23);
      },
      getFloat64: function(qe) {
        return ce(gt(this, 8, qe, arguments.length > 1 ? arguments[1] : !1), 52);
      },
      setInt8: function(qe, nt) {
        Ze(this, 1, qe, ee, nt);
      },
      setUint8: function(qe, nt) {
        Ze(this, 1, qe, ee, nt);
      },
      setInt16: function(qe, nt) {
        Ze(this, 2, qe, Se, nt, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint16: function(qe, nt) {
        Ze(this, 2, qe, Se, nt, arguments.length > 2 ? arguments[2] : !1);
      },
      setInt32: function(qe, nt) {
        Ze(this, 4, qe, Ce, nt, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint32: function(qe, nt) {
        Ze(this, 4, qe, Ce, nt, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat32: function(qe, nt) {
        Ze(this, 4, qe, We, nt, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat64: function(qe, nt) {
        Ze(this, 8, qe, Fe, nt, arguments.length > 2 ? arguments[2] : !1);
      }
    });
  else {
    var Ne = I && G.name !== B;
    !l(function() {
      G(1);
    }) || !l(function() {
      new G(-1);
    }) || l(function() {
      return new G(), new G(1.5), new G(NaN), G.length !== 1 || Ne && !M;
    }) ? (H = function(qe) {
      return c(this, j), C(new G(h(qe)), this, H);
    }, H[N] = j, j.constructor = H, x(H, G)) : Ne && M && i(G, "name", B), b && y(z) !== W && b(z, W);
    var ze = new F(new H(2)), ct = e(z.setInt8);
    ze.setInt8(0, 2147483648), ze.setInt8(1, 2147483649), (ze.getInt8(0) || !ze.getInt8(1)) && s(z, {
      setInt8: function(qe, nt) {
        ct(this, qe, nt << 24 >> 24);
      },
      setUint8: function(qe, nt) {
        ct(this, qe, nt << 24 >> 24);
      }
    }, { unsafe: !0 });
  }
  return S(H, B), S(F, L), pQ = {
    ArrayBuffer: H,
    DataView: F
  }, pQ;
}
var mQ, F_e;
function Jpr() {
  if (F_e) return mQ;
  F_e = 1;
  var t = Xh(), e = RangeError;
  return mQ = function(r) {
    var n = t(r);
    if (n < 0) throw new e("The argument can't be less than 0");
    return n;
  }, mQ;
}
var gQ, z_e;
function vrt() {
  if (z_e) return gQ;
  z_e = 1;
  var t = Jpr(), e = RangeError;
  return gQ = function(r, n) {
    var a = t(r);
    if (a % n) throw new e("Wrong offset");
    return a;
  }, gQ;
}
var vQ, G_e;
function Ypr() {
  if (G_e) return vQ;
  G_e = 1;
  var t = Math.round;
  return vQ = function(e) {
    var r = t(e);
    return r < 0 ? 0 : r > 255 ? 255 : r & 255;
  }, vQ;
}
var yQ, W_e;
function Xpr() {
  if (W_e) return yQ;
  W_e = 1;
  var t = pg();
  return yQ = function(e) {
    var r = t(e);
    return r === "BigInt64Array" || r === "BigUint64Array";
  }, yQ;
}
var bQ, H_e;
function yrt() {
  if (H_e) return bQ;
  H_e = 1;
  var t = fme(), e = TypeError;
  return bQ = function(r) {
    var n = t(r, "number");
    if (typeof n == "number") throw new e("Can't convert number to bigint");
    return BigInt(n);
  }, bQ;
}
var xQ, U_e;
function Qpr() {
  if (U_e) return xQ;
  U_e = 1;
  var t = gg(), e = No(), r = wme(), n = ru(), a = nu(), i = zG(), o = LM(), s = Tme(), l = Xpr(), c = Wo().aTypedArrayConstructor, u = yrt();
  return xQ = function(h) {
    var p = r(this), g = n(h), y = arguments.length, b = y > 1 ? arguments[1] : void 0, w = b !== void 0, _ = o(g), C, x, S, A, I, M, B, L;
    if (_ && !s(_))
      for (B = i(g, _), L = B.next, g = []; !(M = e(L, B)).done; )
        g.push(M.value);
    for (w && y > 2 && (b = t(b, arguments[2])), x = a(g), S = new (c(p))(x), A = l(S), C = 0; x > C; C++)
      I = w ? b(g[C], C) : g[C], S[C] = A ? u(I) : +I;
    return S;
  }, xQ;
}
var CQ, V_e;
function brt() {
  if (V_e) return CQ;
  V_e = 1;
  var t = nu();
  return CQ = function(e, r, n) {
    for (var a = 0, i = arguments.length > 2 ? n : t(r), o = new e(i); i > a; ) o[a] = r[a++];
    return o;
  }, CQ;
}
var q_e;
function emr() {
  if (q_e) return BB.exports;
  q_e = 1;
  var t = Ya(), e = wi(), r = No(), n = Go(), a = Upr(), i = Wo(), o = grt(), s = Uy(), l = r6(), c = fg(), u = irt(), f = hg(), h = prt(), p = vrt(), g = Ypr(), y = IG(), b = Es(), w = pg(), _ = fs(), C = j8(), x = mg(), S = dg(), A = W8(), I = z8().f, M = Qpr(), B = Rd().forEach, L = FG(), N = ep(), d = Pd(), m = Fy(), v = brt(), k = _0(), O = qG(), G = k.get, H = k.set, j = k.enforce, F = d.f, z = m.f, W = e.RangeError, U = o.ArrayBuffer, Z = U.prototype, V = o.DataView, Y = i.NATIVE_ARRAY_BUFFER_VIEWS, ge = i.TYPED_ARRAY_TAG, ce = i.TypedArray, ee = i.TypedArrayPrototype, Se = i.isTypedArray, Ce = "BYTES_PER_ELEMENT", we = "Wrong length", We = function(Ne, ze) {
    N(Ne, ze, {
      configurable: !0,
      get: function() {
        return G(this)[ze];
      }
    });
  }, Fe = function(Ne) {
    var ze;
    return S(Z, Ne) || (ze = w(Ne)) === "ArrayBuffer" || ze === "SharedArrayBuffer";
  }, it = function(Ne, ze) {
    return Se(Ne) && !C(ze) && ze in Ne && u(+ze) && ze >= 0;
  }, gt = function(ze, ct) {
    return ct = y(ct), it(ze, ct) ? l(2, ze[ct]) : z(ze, ct);
  }, Ze = function(ze, ct, rt) {
    return ct = y(ct), it(ze, ct) && _(rt) && b(rt, "value") && !b(rt, "get") && !b(rt, "set") && !rt.configurable && (!b(rt, "writable") || rt.writable) && (!b(rt, "enumerable") || rt.enumerable) ? (ze[ct] = rt.value, ze) : F(ze, ct, rt);
  };
  return n ? (Y || (m.f = gt, d.f = Ze, We(ee, "buffer"), We(ee, "byteOffset"), We(ee, "byteLength"), We(ee, "length")), t({ target: "Object", stat: !0, forced: !Y }, {
    getOwnPropertyDescriptor: gt,
    defineProperty: Ze
  }), BB.exports = function(Ne, ze, ct) {
    var rt = Ne.match(/\d+/)[0] / 8, qe = Ne + (ct ? "Clamped" : "") + "Array", nt = "get" + Ne, Rt = "set" + Ne, Ot = e[qe], lt = Ot, mt = lt && lt.prototype, jt = {}, Jt = function(Ie, Ke) {
      var Le = G(Ie);
      return Le.view[nt](Ke * rt + Le.byteOffset, !0);
    }, ne = function(Ie, Ke, Le) {
      var Ge = G(Ie);
      Ge.view[Rt](Ke * rt + Ge.byteOffset, ct ? g(Le) : Le, !0);
    }, re = function(Ie, Ke) {
      F(Ie, Ke, {
        get: function() {
          return Jt(this, Ke);
        },
        set: function(Le) {
          return ne(this, Ke, Le);
        },
        enumerable: !0
      });
    };
    Y ? a && (lt = ze(function(Ie, Ke, Le, Ge) {
      return s(Ie, mt), O(function() {
        return _(Ke) ? Fe(Ke) ? Ge !== void 0 ? new Ot(Ke, p(Le, rt), Ge) : Le !== void 0 ? new Ot(Ke, p(Le, rt)) : new Ot(Ke) : Se(Ke) ? v(lt, Ke) : r(M, lt, Ke) : new Ot(h(Ke));
      }(), Ie, lt);
    }), A && A(lt, ce), B(I(Ot), function(Ie) {
      Ie in lt || c(lt, Ie, Ot[Ie]);
    }), lt.prototype = mt) : (lt = ze(function(Ie, Ke, Le, Ge) {
      s(Ie, mt);
      var ft = 0, ot = 0, Ye, Je, tt;
      if (!_(Ke))
        tt = h(Ke), Je = tt * rt, Ye = new U(Je);
      else if (Fe(Ke)) {
        Ye = Ke, ot = p(Le, rt);
        var kt = Ke.byteLength;
        if (Ge === void 0) {
          if (kt % rt) throw new W(we);
          if (Je = kt - ot, Je < 0) throw new W(we);
        } else if (Je = f(Ge) * rt, Je + ot > kt) throw new W(we);
        tt = Je / rt;
      } else return Se(Ke) ? v(lt, Ke) : r(M, lt, Ke);
      for (H(Ie, {
        buffer: Ye,
        byteOffset: ot,
        byteLength: Je,
        length: tt,
        view: new V(Ye)
      }); ft < tt; ) re(Ie, ft++);
    }), A && A(lt, ce), mt = lt.prototype = x(ee)), mt.constructor !== lt && c(mt, "constructor", lt), j(mt).TypedArrayConstructor = lt, ge && c(mt, ge, qe);
    var ie = lt !== Ot;
    jt[qe] = lt, t({ global: !0, constructor: !0, forced: ie, sham: !Y }, jt), Ce in lt || c(lt, Ce, rt), Ce in mt || c(mt, Ce, rt), L(qe);
  }) : BB.exports = function() {
  }, BB.exports;
}
var K_e;
function xrt() {
  if (K_e) return I_e;
  K_e = 1;
  var t = emr();
  return t("Uint8", function(e) {
    return function(n, a, i) {
      return e(this, n, a, i);
    };
  }), I_e;
}
var Z_e = {}, wQ, J_e;
function zme() {
  if (J_e) return wQ;
  J_e = 1;
  var t = n6(), e = TypeError;
  return wQ = function(r, n) {
    if (!delete r[n]) throw new e("Cannot delete property " + t(n) + " of " + t(r));
  }, wQ;
}
var SQ, Y_e;
function tmr() {
  if (Y_e) return SQ;
  Y_e = 1;
  var t = ru(), e = i6(), r = nu(), n = zme(), a = Math.min;
  return SQ = [].copyWithin || function(o, s) {
    var l = t(this), c = r(l), u = e(o, c), f = e(s, c), h = arguments.length > 2 ? arguments[2] : void 0, p = a((h === void 0 ? c : e(h, c)) - f, c - u), g = 1;
    for (f < u && u < f + p && (g = -1, f += p - 1, u += p - 1); p-- > 0; )
      f in l ? l[u] = l[f] : n(l, u), u += g, f += g;
    return l;
  }, SQ;
}
var X_e;
function Crt() {
  if (X_e) return Z_e;
  X_e = 1;
  var t = Wa(), e = Wo(), r = tmr(), n = t(r), a = e.aTypedArray, i = e.exportTypedArrayMethod;
  return i("copyWithin", function(s, l) {
    return n(a(this), s, l, arguments.length > 2 ? arguments[2] : void 0);
  }), Z_e;
}
var Q_e = {}, eke;
function wrt() {
  if (eke) return Q_e;
  eke = 1;
  var t = Wo(), e = Rd().every, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("every", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), Q_e;
}
var tke = {}, rke;
function Srt() {
  if (rke) return tke;
  rke = 1;
  var t = Wo(), e = mrt(), r = yrt(), n = pg(), a = No(), i = Wa(), o = Ba(), s = t.aTypedArray, l = t.exportTypedArrayMethod, c = i("".slice), u = o(function() {
    var f = 0;
    return new Int8Array(2).fill({ valueOf: function() {
      return f++;
    } }), f !== 1;
  });
  return l("fill", function(h) {
    var p = arguments.length;
    s(this);
    var g = c(n(this), 0, 3) === "Big" ? r(h) : +h;
    return a(e, this, g, p > 1 ? arguments[1] : void 0, p > 2 ? arguments[2] : void 0);
  }, u), tke;
}
var nke = {}, _Q, ake;
function rmr() {
  if (ake) return _Q;
  ake = 1;
  var t = brt(), e = Wo().getTypedArrayConstructor;
  return _Q = function(r, n) {
    return t(e(r), n);
  }, _Q;
}
var ike;
function _rt() {
  if (ike) return nke;
  ike = 1;
  var t = Wo(), e = Rd().filter, r = rmr(), n = t.aTypedArray, a = t.exportTypedArrayMethod;
  return a("filter", function(o) {
    var s = e(n(this), o, arguments.length > 1 ? arguments[1] : void 0);
    return r(this, s);
  }), nke;
}
var oke = {}, ske;
function krt() {
  if (ske) return oke;
  ske = 1;
  var t = Wo(), e = Rd().find, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("find", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), oke;
}
var lke = {}, cke;
function Art() {
  if (cke) return lke;
  cke = 1;
  var t = Wo(), e = Rd().findIndex, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("findIndex", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), lke;
}
var uke = {}, dke;
function Trt() {
  if (dke) return uke;
  dke = 1;
  var t = Wo(), e = Rd().forEach, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("forEach", function(i) {
    e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), uke;
}
var fke = {}, hke;
function Ert() {
  if (hke) return fke;
  hke = 1;
  var t = Wo(), e = RG().includes, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("includes", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), fke;
}
var pke = {}, mke;
function Irt() {
  if (mke) return pke;
  mke = 1;
  var t = Wo(), e = RG().indexOf, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("indexOf", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), pke;
}
var gke = {}, vke;
function Mrt() {
  if (vke) return gke;
  vke = 1;
  var t = wi(), e = Ba(), r = Wa(), n = Wo(), a = vg(), i = Do(), o = i("iterator"), s = t.Uint8Array, l = r(a.values), c = r(a.keys), u = r(a.entries), f = n.aTypedArray, h = n.exportTypedArrayMethod, p = s && s.prototype, g = !e(function() {
    p[o].call([1]);
  }), y = !!p && p.values && p[o] === p.values && p.values.name === "values", b = function() {
    return l(f(this));
  };
  return h("entries", function() {
    return u(f(this));
  }, g), h("keys", function() {
    return c(f(this));
  }, g), h("values", b, g || !y, { name: "values" }), h(o, b, g || !y, { name: "values" }), gke;
}
var yke = {}, bke;
function Prt() {
  if (bke) return yke;
  bke = 1;
  var t = Wo(), e = Wa(), r = t.aTypedArray, n = t.exportTypedArrayMethod, a = e([].join);
  return n("join", function(o) {
    return a(r(this), o);
  }), yke;
}
var xke = {}, kQ, Cke;
function nmr() {
  if (Cke) return kQ;
  Cke = 1;
  var t = o6(), e = S0(), r = Xh(), n = nu(), a = LG(), i = Math.min, o = [].lastIndexOf, s = !!o && 1 / [1].lastIndexOf(1, -0) < 0, l = a("lastIndexOf"), c = s || !l;
  return kQ = c ? function(f) {
    if (s) return t(o, this, arguments) || 0;
    var h = e(this), p = n(h);
    if (p === 0) return -1;
    var g = p - 1;
    for (arguments.length > 1 && (g = i(g, r(arguments[1]))), g < 0 && (g = p + g); g >= 0; g--) if (g in h && h[g] === f) return g || 0;
    return -1;
  } : o, kQ;
}
var wke;
function Rrt() {
  if (wke) return xke;
  wke = 1;
  var t = Wo(), e = o6(), r = nmr(), n = t.aTypedArray, a = t.exportTypedArrayMethod;
  return a("lastIndexOf", function(o) {
    var s = arguments.length;
    return e(r, n(this), s > 1 ? [o, arguments[1]] : [o]);
  }), xke;
}
var Ske = {}, _ke;
function Ort() {
  if (_ke) return Ske;
  _ke = 1;
  var t = Wo(), e = Rd().map, r = t.aTypedArray, n = t.getTypedArrayConstructor, a = t.exportTypedArrayMethod;
  return a("map", function(o) {
    return e(r(this), o, arguments.length > 1 ? arguments[1] : void 0, function(s, l) {
      return new (n(s))(l);
    });
  }), Ske;
}
var kke = {}, AQ, Ake;
function Brt() {
  if (Ake) return AQ;
  Ake = 1;
  var t = Sf(), e = ru(), r = SM(), n = nu(), a = TypeError, i = "Reduce of empty array with no initial value", o = function(s) {
    return function(l, c, u, f) {
      var h = e(l), p = r(h), g = n(h);
      if (t(c), g === 0 && u < 2) throw new a(i);
      var y = s ? g - 1 : 0, b = s ? -1 : 1;
      if (u < 2) for (; ; ) {
        if (y in p) {
          f = p[y], y += b;
          break;
        }
        if (y += b, s ? y < 0 : g <= y)
          throw new a(i);
      }
      for (; s ? y >= 0 : g > y; y += b) y in p && (f = c(f, p[y], y, h));
      return f;
    };
  };
  return AQ = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: o(!1),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: o(!0)
  }, AQ;
}
var Tke;
function Nrt() {
  if (Tke) return kke;
  Tke = 1;
  var t = Wo(), e = Brt().left, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("reduce", function(i) {
    var o = arguments.length;
    return e(r(this), i, o, o > 1 ? arguments[1] : void 0);
  }), kke;
}
var Eke = {}, Ike;
function $rt() {
  if (Ike) return Eke;
  Ike = 1;
  var t = Wo(), e = Brt().right, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("reduceRight", function(i) {
    var o = arguments.length;
    return e(r(this), i, o, o > 1 ? arguments[1] : void 0);
  }), Eke;
}
var Mke = {}, Pke;
function Drt() {
  if (Pke) return Mke;
  Pke = 1;
  var t = Wo(), e = t.aTypedArray, r = t.exportTypedArrayMethod, n = Math.floor;
  return r("reverse", function() {
    for (var i = this, o = e(i).length, s = n(o / 2), l = 0, c; l < s; )
      c = i[l], i[l++] = i[--o], i[o] = c;
    return i;
  }), Mke;
}
var Rke = {}, Oke;
function Lrt() {
  if (Oke) return Rke;
  Oke = 1;
  var t = wi(), e = No(), r = Wo(), n = nu(), a = vrt(), i = ru(), o = Ba(), s = t.RangeError, l = t.Int8Array, c = l && l.prototype, u = c && c.set, f = r.aTypedArray, h = r.exportTypedArrayMethod, p = !o(function() {
    var y = new Uint8ClampedArray(2);
    return e(u, y, { length: 1, 0: 3 }, 1), y[1] !== 3;
  }), g = p && r.NATIVE_ARRAY_BUFFER_VIEWS && o(function() {
    var y = new l(2);
    return y.set(1), y.set("2", 1), y[0] !== 0 || y[1] !== 2;
  });
  return h("set", function(b) {
    f(this);
    var w = a(arguments.length > 1 ? arguments[1] : void 0, 1), _ = i(b);
    if (p) return e(u, this, _, w);
    var C = this.length, x = n(_), S = 0;
    if (x + w > C) throw new s("Wrong length");
    for (; S < x; ) this[w + S] = _[S++];
  }, !p || g), Rke;
}
var Bke = {}, Nke;
function jrt() {
  if (Nke) return Bke;
  Nke = 1;
  var t = Wo(), e = Ba(), r = Qh(), n = t.aTypedArray, a = t.getTypedArrayConstructor, i = t.exportTypedArrayMethod, o = e(function() {
    new Int8Array(1).slice();
  });
  return i("slice", function(l, c) {
    for (var u = r(n(this), l, c), f = a(this), h = 0, p = u.length, g = new f(p); p > h; ) g[h] = u[h++];
    return g;
  }, o), Bke;
}
var $ke = {}, Dke;
function Frt() {
  if (Dke) return $ke;
  Dke = 1;
  var t = Wo(), e = Rd().some, r = t.aTypedArray, n = t.exportTypedArrayMethod;
  return n("some", function(i) {
    return e(r(this), i, arguments.length > 1 ? arguments[1] : void 0);
  }), $ke;
}
var Lke = {}, TQ, jke;
function Gme() {
  if (jke) return TQ;
  jke = 1;
  var t = Qh(), e = Math.floor, r = function(n, a) {
    var i = n.length;
    if (i < 8)
      for (var o = 1, s, l; o < i; ) {
        for (l = o, s = n[o]; l && a(n[l - 1], s) > 0; )
          n[l] = n[--l];
        l !== o++ && (n[l] = s);
      }
    else
      for (var c = e(i / 2), u = r(t(n, 0, c), a), f = r(t(n, c), a), h = u.length, p = f.length, g = 0, y = 0; g < h || y < p; )
        n[g + y] = g < h && y < p ? a(u[g], f[y]) <= 0 ? u[g++] : f[y++] : g < h ? u[g++] : f[y++];
    return n;
  };
  return TQ = r, TQ;
}
var EQ, Fke;
function zrt() {
  if (Fke) return EQ;
  Fke = 1;
  var t = jy(), e = t.match(/firefox\/(\d+)/i);
  return EQ = !!e && +e[1], EQ;
}
var IQ, zke;
function Grt() {
  if (zke) return IQ;
  zke = 1;
  var t = jy();
  return IQ = /MSIE|Trident/.test(t), IQ;
}
var MQ, Gke;
function Wrt() {
  if (Gke) return MQ;
  Gke = 1;
  var t = jy(), e = t.match(/AppleWebKit\/(\d+)\./);
  return MQ = !!e && +e[1], MQ;
}
var Wke;
function Hrt() {
  if (Wke) return Lke;
  Wke = 1;
  var t = wi(), e = yme(), r = Ba(), n = Sf(), a = Gme(), i = Wo(), o = zrt(), s = Grt(), l = D8(), c = Wrt(), u = i.aTypedArray, f = i.exportTypedArrayMethod, h = t.Uint16Array, p = h && e(h.prototype.sort), g = !!p && !(r(function() {
    p(new h(2), null);
  }) && r(function() {
    p(new h(2), {});
  })), y = !!p && !r(function() {
    if (l) return l < 74;
    if (o) return o < 67;
    if (s) return !0;
    if (c) return c < 602;
    var w = new h(516), _ = Array(516), C, x;
    for (C = 0; C < 516; C++)
      x = C % 4, w[C] = 515 - C, _[C] = C - 2 * x + 3;
    for (p(w, function(S, A) {
      return (S / 4 | 0) - (A / 4 | 0);
    }), C = 0; C < 516; C++)
      if (w[C] !== _[C]) return !0;
  }), b = function(w) {
    return function(_, C) {
      return w !== void 0 ? +w(_, C) || 0 : C !== C ? -1 : _ !== _ ? 1 : _ === 0 && C === 0 ? 1 / _ > 0 && 1 / C < 0 ? 1 : -1 : _ > C;
    };
  };
  return f("sort", function(_) {
    return _ !== void 0 && n(_), y ? p(this, _) : a(u(this), b(_));
  }, !y || g), Lke;
}
var Hke = {}, Uke;
function Urt() {
  if (Uke) return Hke;
  Uke = 1;
  var t = Wo(), e = hg(), r = i6(), n = t.aTypedArray, a = t.getTypedArrayConstructor, i = t.exportTypedArrayMethod;
  return i("subarray", function(s, l) {
    var c = n(this), u = c.length, f = r(s, u), h = a(c);
    return new h(
      c.buffer,
      c.byteOffset + f * c.BYTES_PER_ELEMENT,
      e((l === void 0 ? u : r(l, u)) - f)
    );
  }), Hke;
}
var Vke = {}, qke;
function Vrt() {
  if (qke) return Vke;
  qke = 1;
  var t = wi(), e = o6(), r = Wo(), n = Ba(), a = Qh(), i = t.Int8Array, o = r.aTypedArray, s = r.exportTypedArrayMethod, l = [].toLocaleString, c = !!i && n(function() {
    l.call(new i(1));
  }), u = n(function() {
    return [1, 2].toLocaleString() !== new i([1, 2]).toLocaleString();
  }) || !n(function() {
    i.prototype.toLocaleString.call([1, 2]);
  });
  return s("toLocaleString", function() {
    return e(
      l,
      c ? a(o(this)) : o(this),
      a(arguments)
    );
  }, u), Vke;
}
var Kke = {}, Zke;
function qrt() {
  if (Zke) return Kke;
  Zke = 1;
  var t = Wo().exportTypedArrayMethod, e = Ba(), r = wi(), n = Wa(), a = r.Uint8Array, i = a && a.prototype || {}, o = [].toString, s = n([].join);
  e(function() {
    o.call({});
  }) && (o = function() {
    return s(this);
  });
  var l = i.toString !== o;
  return t("toString", o, l), Kke;
}
var Jke = {}, Yke;
function Krt() {
  if (Yke) return Jke;
  Yke = 1;
  var t = No(), e = Wa(), r = eW(), n = Ys(), a = u2(), i = d2(), o = Htt(), s = Fme(), l = hg(), c = Vl(), u = a6(), f = tW(), h = art(), p = Ba(), g = h.UNSUPPORTED_Y, y = 4294967295, b = Math.min, w = e([].push), _ = e("".slice), C = !p(function() {
    var S = /(?:)/, A = S.exec;
    S.exec = function() {
      return A.apply(this, arguments);
    };
    var I = "ab".split(S);
    return I.length !== 2 || I[0] !== "a" || I[1] !== "b";
  }), x = "abbc".split(/(b)*/)[1] === "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length;
  return r("split", function(S, A, I) {
    var M = "0".split(void 0, 0).length ? function(B, L) {
      return B === void 0 && L === 0 ? [] : t(A, this, B, L);
    } : A;
    return [
      // `String.prototype.split` method
      // https://tc39.es/ecma262/#sec-string.prototype.split
      function(L, N) {
        var d = i(this), m = a(L) ? void 0 : u(L, S);
        return m ? t(m, L, d, N) : t(M, c(d), L, N);
      },
      // `RegExp.prototype[@@split]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
      //
      // NOTE: This cannot be properly polyfilled in engines that don't support
      // the 'y' flag.
      function(B, L) {
        var N = n(this), d = c(B);
        if (!x) {
          var m = I(M, N, d, L, M !== A);
          if (m.done) return m.value;
        }
        var v = o(N, RegExp), k = N.unicode, O = (N.ignoreCase ? "i" : "") + (N.multiline ? "m" : "") + (N.unicode ? "u" : "") + (g ? "g" : "y"), G = new v(g ? "^(?:" + N.source + ")" : N, O), H = L === void 0 ? y : L >>> 0;
        if (H === 0) return [];
        if (d.length === 0) return f(G, d) === null ? [d] : [];
        for (var j = 0, F = 0, z = []; F < d.length; ) {
          G.lastIndex = g ? 0 : F;
          var W = f(G, g ? _(d, F) : d), U;
          if (W === null || (U = b(l(G.lastIndex + (g ? F : 0)), d.length)) === j)
            F = s(d, F, k);
          else {
            if (w(z, _(d, j, F)), z.length === H) return z;
            for (var Z = 1; Z <= W.length - 1; Z++)
              if (w(z, W[Z]), z.length === H) return z;
            F = j = U;
          }
        }
        return w(z, _(d, j)), z;
      }
    ];
  }, x || !C, g), Jke;
}
var PQ = { exports: {} }, RQ = { exports: {} }, Xke;
function amr() {
  return Xke || (Xke = 1, function(t) {
    function e(r) {
      try {
        return Function.toString.call(r).indexOf("[native code]") !== -1;
      } catch {
        return typeof r == "function";
      }
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(RQ)), RQ.exports;
}
var OQ = { exports: {} }, BQ = { exports: {} }, Qke;
function imr() {
  return Qke || (Qke = 1, function(t) {
    function e() {
      try {
        var r = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch {
      }
      return (t.exports = e = function() {
        return !!r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports)();
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(BQ)), BQ.exports;
}
var eAe;
function omr() {
  return eAe || (eAe = 1, function(t) {
    var e = imr(), r = Sme();
    function n(a, i, o) {
      if (e()) return Reflect.construct.apply(null, arguments);
      var s = [null];
      s.push.apply(s, i);
      var l = new (a.bind.apply(a, s))();
      return o && r(l, o.prototype), l;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(OQ)), OQ.exports;
}
var tAe;
function nW() {
  return tAe || (tAe = 1, function(t) {
    var e = np(), r = Sme(), n = amr(), a = omr();
    function i(o) {
      var s = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
      return t.exports = i = function(c) {
        if (c === null || !n(c)) return c;
        if (typeof c != "function") throw new TypeError("Super expression must either be null or a function");
        if (s !== void 0) {
          if (s.has(c)) return s.get(c);
          s.set(c, u);
        }
        function u() {
          return a(c, arguments, e(this).constructor);
        }
        return u.prototype = Object.create(c.prototype, {
          constructor: {
            value: u,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r(u, c);
      }, t.exports.__esModule = !0, t.exports.default = t.exports, i(o);
    }
    t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(PQ)), PQ.exports;
}
var Z4 = {};
/*
@license
Copyright (c) 2016, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
var rAe;
function UM() {
  if (rAe) return Z4;
  rAe = 1, Object.defineProperty(Z4, "__esModule", { value: !0 }), G8(), s6();
  var t = zy(), e = Gy(), r = l6(), n = Wy(), a = Hy(), i = np(), o = c6();
  u6(), d6();
  function s(U) {
    return U && typeof U == "object" && "default" in U ? U : { default: U };
  }
  var l = /* @__PURE__ */ s(t), c = /* @__PURE__ */ s(e), u = /* @__PURE__ */ s(r), f = /* @__PURE__ */ s(n), h = /* @__PURE__ */ s(a), p = /* @__PURE__ */ s(i), g = /* @__PURE__ */ s(o), y;
  function b() {
  }
  b.prototype = /* @__PURE__ */ Object.create(null);
  function w() {
    w.init.call(this);
  }
  w.EventEmitter = w, w.usingDomains = !1, w.prototype.domain = void 0, w.prototype._events = void 0, w.prototype._maxListeners = void 0, w.defaultMaxListeners = 10, w.init = function() {
    this.domain = null, w.usingDomains && y.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new b(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, w.prototype.setMaxListeners = function(Z) {
    if (typeof Z != "number" || Z < 0 || isNaN(Z))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = Z, this;
  };
  function _(U) {
    return U._maxListeners === void 0 ? w.defaultMaxListeners : U._maxListeners;
  }
  w.prototype.getMaxListeners = function() {
    return _(this);
  };
  function C(U, Z, V) {
    if (Z)
      U.call(V);
    else
      for (var Y = U.length, ge = m(U, Y), ce = 0; ce < Y; ++ce)
        ge[ce].call(V);
  }
  function x(U, Z, V, Y) {
    if (Z)
      U.call(V, Y);
    else
      for (var ge = U.length, ce = m(U, ge), ee = 0; ee < ge; ++ee)
        ce[ee].call(V, Y);
  }
  function S(U, Z, V, Y, ge) {
    if (Z)
      U.call(V, Y, ge);
    else
      for (var ce = U.length, ee = m(U, ce), Se = 0; Se < ce; ++Se)
        ee[Se].call(V, Y, ge);
  }
  function A(U, Z, V, Y, ge, ce) {
    if (Z)
      U.call(V, Y, ge, ce);
    else
      for (var ee = U.length, Se = m(U, ee), Ce = 0; Ce < ee; ++Ce)
        Se[Ce].call(V, Y, ge, ce);
  }
  function I(U, Z, V, Y) {
    if (Z)
      U.apply(V, Y);
    else
      for (var ge = U.length, ce = m(U, ge), ee = 0; ee < ge; ++ee)
        ce[ee].apply(V, Y);
  }
  w.prototype.emit = function(Z) {
    var V, Y, ge, ce, ee, Se, Ce, we = Z === "error";
    if (Se = this._events, Se)
      we = we && Se.error == null;
    else if (!we)
      return !1;
    if (Ce = this.domain, we) {
      if (V = arguments[1], Ce)
        V || (V = new Error('Uncaught, unspecified "error" event')), V.domainEmitter = this, V.domain = Ce, V.domainThrown = !1, Ce.emit("error", V);
      else {
        if (V instanceof Error)
          throw V;
        var We = new Error('Uncaught, unspecified "error" event. (' + V + ")");
        throw We.context = V, We;
      }
      return !1;
    }
    if (Y = Se[Z], !Y)
      return !1;
    var Fe = typeof Y == "function";
    switch (ge = arguments.length, ge) {
      // fast cases
      case 1:
        C(Y, Fe, this);
        break;
      case 2:
        x(Y, Fe, this, arguments[1]);
        break;
      case 3:
        S(Y, Fe, this, arguments[1], arguments[2]);
        break;
      case 4:
        A(Y, Fe, this, arguments[1], arguments[2], arguments[3]);
        break;
      // slower
      default:
        for (ce = new Array(ge - 1), ee = 1; ee < ge; ee++)
          ce[ee - 1] = arguments[ee];
        I(Y, Fe, this, ce);
    }
    return !0;
  };
  function M(U, Z, V, Y) {
    var ge, ce, ee;
    if (typeof V != "function")
      throw new TypeError('"listener" argument must be a function');
    if (ce = U._events, ce ? (ce.newListener && (U.emit(
      "newListener",
      Z,
      V.listener ? V.listener : V
    ), ce = U._events), ee = ce[Z]) : (ce = U._events = new b(), U._eventsCount = 0), !ee)
      ee = ce[Z] = V, ++U._eventsCount;
    else if (typeof ee == "function" ? ee = ce[Z] = Y ? [V, ee] : [ee, V] : Y ? ee.unshift(V) : ee.push(V), !ee.warned && (ge = _(U), ge && ge > 0 && ee.length > ge)) {
      ee.warned = !0;
      var Se = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + Z + " listeners added. Use emitter.setMaxListeners() to increase limit");
      Se.name = "MaxListenersExceededWarning", Se.emitter = U, Se.type = Z, Se.count = ee.length, B(Se);
    }
    return U;
  }
  function B(U) {
    typeof console.warn == "function" ? console.warn(U) : console.log(U);
  }
  w.prototype.addListener = function(Z, V) {
    return M(this, Z, V, !1);
  }, w.prototype.on = w.prototype.addListener, w.prototype.prependListener = function(Z, V) {
    return M(this, Z, V, !0);
  };
  function L(U, Z, V) {
    var Y = !1;
    function ge() {
      U.removeListener(Z, ge), Y || (Y = !0, V.apply(U, arguments));
    }
    return ge.listener = V, ge;
  }
  w.prototype.once = function(Z, V) {
    if (typeof V != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(Z, L(this, Z, V)), this;
  }, w.prototype.prependOnceListener = function(Z, V) {
    if (typeof V != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(Z, L(this, Z, V)), this;
  }, w.prototype.removeListener = function(Z, V) {
    var Y, ge, ce, ee, Se;
    if (typeof V != "function")
      throw new TypeError('"listener" argument must be a function');
    if (ge = this._events, !ge)
      return this;
    if (Y = ge[Z], !Y)
      return this;
    if (Y === V || Y.listener && Y.listener === V)
      --this._eventsCount === 0 ? this._events = new b() : (delete ge[Z], ge.removeListener && this.emit("removeListener", Z, Y.listener || V));
    else if (typeof Y != "function") {
      for (ce = -1, ee = Y.length; ee-- > 0; )
        if (Y[ee] === V || Y[ee].listener && Y[ee].listener === V) {
          Se = Y[ee].listener, ce = ee;
          break;
        }
      if (ce < 0)
        return this;
      if (Y.length === 1) {
        if (Y[0] = void 0, --this._eventsCount === 0)
          return this._events = new b(), this;
        delete ge[Z];
      } else
        d(Y, ce);
      ge.removeListener && this.emit("removeListener", Z, Se || V);
    }
    return this;
  }, w.prototype.off = function(U, Z) {
    return this.removeListener(U, Z);
  }, w.prototype.removeAllListeners = function(Z) {
    var V, Y;
    if (Y = this._events, !Y)
      return this;
    if (!Y.removeListener)
      return arguments.length === 0 ? (this._events = new b(), this._eventsCount = 0) : Y[Z] && (--this._eventsCount === 0 ? this._events = new b() : delete Y[Z]), this;
    if (arguments.length === 0) {
      for (var ge = Object.keys(Y), ce = 0, ee; ce < ge.length; ++ce)
        ee = ge[ce], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = new b(), this._eventsCount = 0, this;
    }
    if (V = Y[Z], typeof V == "function")
      this.removeListener(Z, V);
    else if (V)
      do
        this.removeListener(Z, V[V.length - 1]);
      while (V[0]);
    return this;
  }, w.prototype.listeners = function(Z) {
    var V, Y, ge = this._events;
    return ge ? (V = ge[Z], V ? typeof V == "function" ? Y = [V.listener || V] : Y = v(V) : Y = []) : Y = [], Y;
  }, w.listenerCount = function(U, Z) {
    return typeof U.listenerCount == "function" ? U.listenerCount(Z) : N.call(U, Z);
  }, w.prototype.listenerCount = N;
  function N(U) {
    var Z = this._events;
    if (Z) {
      var V = Z[U];
      if (typeof V == "function")
        return 1;
      if (V)
        return V.length;
    }
    return 0;
  }
  w.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function d(U, Z) {
    for (var V = Z, Y = V + 1, ge = U.length; Y < ge; V += 1, Y += 1)
      U[V] = U[Y];
    U.pop();
  }
  function m(U, Z) {
    for (var V = new Array(Z); Z--; )
      V[Z] = U[Z];
    return V;
  }
  function v(U) {
    for (var Z = new Array(U.length), V = 0; V < Z.length; ++V)
      Z[V] = U[V].listener || U[V];
    return Z;
  }
  function k(U) {
    var Z = O();
    return function() {
      var Y = p.default(U), ge;
      if (Z) {
        var ce = p.default(this).constructor;
        ge = Reflect.construct(Y, arguments, ce);
      } else
        ge = Y.apply(this, arguments);
      return h.default(this, ge);
    };
  }
  function O() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var G = /* @__PURE__ */ function(U) {
    f.default(V, U);
    var Z = k(V);
    function V(Y) {
      var ge;
      return l.default(this, V), ge = Z.call(this), g.default(u.default(ge), "timeout", null), g.default(u.default(ge), "startTimestamp", -1), ge.minDelay = Y.min, ge.maxDelay = Y.max, ge.initialDelay = Y.initial || 0, ge.maxAttemptsCount = Y.maxAttemptsCount || 0, ge.maxAttemptsTime = Y.maxAttemptsTime || 0, ge.randomness = Y.randomness || 0, ge.inProgress = !1, ge.attemptNum = 0, ge.prevDelay = 0, ge.currDelay = 0, ge;
    }
    return c.default(V, [{
      key: "attempt",
      value: function() {
        this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.attemptNum++, this.emit("attempt", this);
      }
    }, {
      key: "nextDelay",
      value: function(ge) {
        if (typeof ge == "number")
          return this.prevDelay = 0, this.currDelay = ge, ge;
        if (this.attemptNum == 0)
          return this.initialDelay;
        if (this.attemptNum == 1)
          return this.currDelay = this.minDelay, this.currDelay;
        this.prevDelay = this.currDelay;
        var ce = this.currDelay + this.prevDelay;
        return this.maxDelay && ce > this.maxDelay && (this.currDelay = this.maxDelay, ce = this.maxDelay), this.currDelay = ce, ce;
      }
    }, {
      key: "randomize",
      value: function(ge) {
        var ce = ge * this.randomness, ee = Math.round(Math.random() * ce * 2 - ce);
        return Math.max(0, ge + ee);
      }
    }, {
      key: "scheduleAttempt",
      value: function(ge) {
        var ce = this;
        if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
          this.cleanup(), this.emit("failed", new Error("Maximum attempt count limit reached"));
          return;
        }
        var ee = this.nextDelay(ge);
        if (ee = this.randomize(ee), this.maxAttemptsTime && this.startTimestamp + this.maxAttemptsTime < Date.now() + ee) {
          this.cleanup(), this.emit("failed", new Error("Maximum attempt time limit reached"));
          return;
        }
        this.timeout = setTimeout(function() {
          return ce.attempt();
        }, ee);
      }
    }, {
      key: "cleanup",
      value: function() {
        this.timeout && (clearTimeout(this.timeout), this.timeout = null), this.inProgress = !1, this.attemptNum = 0, this.prevDelay = 0, this.currDelay = 0;
      }
    }, {
      key: "start",
      value: function() {
        if (this.inProgress)
          throw new Error("Retrier is already in progress");
        this.inProgress = !0, this.startTimestamp = Date.now(), this.scheduleAttempt(this.initialDelay);
      }
    }, {
      key: "cancel",
      value: function() {
        this.timeout && (clearTimeout(this.timeout), this.timeout = null, this.inProgress = !1, this.emit("cancelled"));
      }
      // @todo Must be a T here, so the entire Retrier must be typed on this value type.
      // eslint-disable-next-line
    }, {
      key: "succeeded",
      value: function(ge) {
        this.emit("succeeded", ge);
      }
    }, {
      key: "failed",
      value: function(ge, ce) {
        if (this.timeout)
          throw new Error("Retrier attempt is already in progress");
        this.scheduleAttempt(ce);
      }
    }]), V;
  }(w), H = /* @__PURE__ */ function(U) {
    f.default(V, U);
    var Z = k(V);
    function V(Y) {
      var ge;
      return l.default(this, V), ge = Z.call(this), g.default(u.default(ge), "resolve", function() {
      }), g.default(u.default(ge), "reject", function() {
      }), ge.retrier = new G(Y), ge;
    }
    return c.default(V, [{
      key: "run",
      value: function(ge) {
        var ce = this;
        return this.retrier.on("attempt", function() {
          ge().then(function(ee) {
            return ce.retrier.succeeded(ee);
          }).catch(function(ee) {
            return ce.retrier.failed(ee);
          });
        }), this.retrier.on("succeeded", function(ee) {
          return ce.resolve(ee);
        }), this.retrier.on("cancelled", function() {
          return ce.reject(new Error("Cancelled"));
        }), this.retrier.on("failed", function(ee) {
          return ce.reject(ee);
        }), new Promise(function(ee, Se) {
          ce.resolve = ee, ce.reject = Se, ce.retrier.start();
        });
      }
    }, {
      key: "cancel",
      value: function() {
        this.retrier.cancel();
      }
    }]), V;
  }(w);
  function j(U) {
    var Z = F();
    return function() {
      var Y = p.default(U), ge;
      if (Z) {
        var ce = p.default(this).constructor;
        ge = Reflect.construct(Y, arguments, ce);
      } else
        ge = Y.apply(this, arguments);
      return h.default(this, ge);
    };
  }
  function F() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function z(U) {
    return U != null;
  }
  var W = /* @__PURE__ */ function(U) {
    f.default(V, U);
    var Z = j(V);
    function V(Y) {
      var ge;
      l.default(this, V), ge = Z.call(this), g.default(u.default(ge), "backoffDelay", 0), g.default(u.default(ge), "nextBackoffDelay", 0), g.default(u.default(ge), "backoffNumber", 0), g.default(u.default(ge), "timeoutID", null), g.default(u.default(ge), "maxNumberOfRetry", -1), Y = Y || {};
      var ce = Y, ee = ce.initialDelay, Se = ce.maxDelay, Ce = ce.randomisationFactor, we = ce.factor;
      if (z(ee) && ee < 1)
        throw new Error("The initial timeout must be equal to or greater than 1.");
      if (z(Se) && Se <= 1)
        throw new Error("The maximal timeout must be greater than 1.");
      if (z(Ce) && (Ce < 0 || Ce > 1))
        throw new Error("The randomisation factor must be between 0 and 1.");
      if (z(we) && we <= 1)
        throw new Error("Exponential factor should be greater than 1.");
      if (ge.initialDelay = ee || 100, ge.maxDelay = Se || 1e4, ge.maxDelay <= ge.initialDelay)
        throw new Error("The maximal backoff delay must be greater than the initial backoff delay.");
      return ge.randomisationFactor = Ce || 0, ge.factor = we || 2, ge.reset(), ge;
    }
    return c.default(V, [{
      key: "backoff",
      value: function(ge) {
        this.timeoutID == null && (this.backoffNumber === this.maxNumberOfRetry ? (this.emit("fail", ge), this.reset()) : (this.backoffDelay = this.next(), this.timeoutID = setTimeout(this.onBackoff.bind(this), this.backoffDelay), this.emit("backoff", this.backoffNumber, this.backoffDelay, ge)));
      }
    }, {
      key: "reset",
      value: function() {
        this.backoffDelay = 0, this.nextBackoffDelay = this.initialDelay, this.backoffNumber = 0, this.timeoutID && clearTimeout(this.timeoutID), this.timeoutID = null;
      }
    }, {
      key: "failAfter",
      value: function(ge) {
        if (ge <= 0)
          throw new Error("Expected a maximum number of retry greater than 0 but got ".concat(ge));
        this.maxNumberOfRetry = ge;
      }
    }, {
      key: "next",
      value: function() {
        this.backoffDelay = Math.min(this.nextBackoffDelay, this.maxDelay), this.nextBackoffDelay = this.backoffDelay * this.factor;
        var ge = 1 + Math.random() * this.randomisationFactor;
        return Math.min(this.maxDelay, Math.round(this.backoffDelay * ge));
      }
    }, {
      key: "onBackoff",
      value: function() {
        this.timeoutID = null, this.emit("ready", this.backoffNumber, this.backoffDelay), this.backoffNumber++;
      }
    }], [{
      key: "exponential",
      value: function(ge) {
        return new V(ge);
      }
    }]), V;
  }(w);
  return Z4.AsyncRetrier = H, Z4.Backoff = W, Z4.Retrier = G, Z4;
}
var nAe = {}, aAe = {}, iAe;
function smr() {
  if (iAe) return aAe;
  iAe = 1;
  var t = Dme(), e = urt();
  return t("Map", function(r) {
    return function() {
      return r(this, arguments.length ? arguments[0] : void 0);
    };
  }, e), aAe;
}
var oAe;
function VM() {
  return oAe || (oAe = 1, smr()), nAe;
}
var r_ = { exports: {} };
/*!
 * Platform.js v1.3.6
 * Copyright 2014-2020 Benjamin Tan
 * Copyright 2011-2013 John-David Dalton
 * Available under MIT license
 */
var lmr = r_.exports, sAe;
function Zrt() {
  return sAe || (sAe = 1, function(t, e) {
    (function() {
      var r = {
        function: !0,
        object: !0
      }, n = r[typeof window] && window || this, a = e, i = t && !t.nodeType && t, o = a && i && typeof wl == "object" && wl;
      o && (o.global === o || o.window === o || o.self === o) && (n = o);
      var s = Math.pow(2, 53) - 1, l = /\bOpera/, c = Object.prototype, u = c.hasOwnProperty, f = c.toString;
      function h(M) {
        return M = String(M), M.charAt(0).toUpperCase() + M.slice(1);
      }
      function p(M, B, L) {
        var N = {
          "10.0": "10",
          "6.4": "10 Technical Preview",
          "6.3": "8.1",
          "6.2": "8",
          "6.1": "Server 2008 R2 / 7",
          "6.0": "Server 2008 / Vista",
          "5.2": "Server 2003 / XP 64-bit",
          "5.1": "XP",
          "5.01": "2000 SP1",
          "5.0": "2000",
          "4.0": "NT",
          "4.90": "ME"
        };
        return B && L && /^Win/i.test(M) && !/^Windows Phone /i.test(M) && (N = N[/[\d.]+$/.exec(M)]) && (M = "Windows " + N), M = String(M), B && L && (M = M.replace(RegExp(B, "i"), L)), M = y(
          M.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0]
        ), M;
      }
      function g(M, B) {
        var L = -1, N = M ? M.length : 0;
        if (typeof N == "number" && N > -1 && N <= s)
          for (; ++L < N; )
            B(M[L], L, M);
        else
          b(M, B);
      }
      function y(M) {
        return M = S(M), /^(?:webOS|i(?:OS|P))/.test(M) ? M : h(M);
      }
      function b(M, B) {
        for (var L in M)
          u.call(M, L) && B(M[L], L, M);
      }
      function w(M) {
        return M == null ? h(M) : f.call(M).slice(8, -1);
      }
      function _(M, B) {
        var L = M != null ? typeof M[B] : "number";
        return !/^(?:boolean|number|string|undefined)$/.test(L) && (L == "object" ? !!M[B] : !0);
      }
      function C(M) {
        return String(M).replace(/([ -])(?!$)/g, "$1?");
      }
      function x(M, B) {
        var L = null;
        return g(M, function(N, d) {
          L = B(L, N, d, M);
        }), L;
      }
      function S(M) {
        return String(M).replace(/^ +| +$/g, "");
      }
      function A(M) {
        var B = n, L = M && typeof M == "object" && w(M) != "String";
        L && (B = M, M = null);
        var N = B.navigator || {}, d = N.userAgent || "";
        M || (M = d);
        var m = L ? !!N.likeChrome : /\bChrome\b/.test(M) && !/internal|\n/i.test(f.toString()), v = "Object", k = L ? v : "ScriptBridgingProxyObject", O = L ? v : "Environment", G = L && B.java ? "JavaPackage" : w(B.java), H = L ? v : "RuntimeObject", j = /\bJava/.test(G) && B.java, F = j && w(B.environment) == O, z = j ? "a" : "α", W = j ? "b" : "β", U = B.document || {}, Z = B.operamini || B.opera, V = l.test(V = L && Z ? Z["[[Class]]"] : w(Z)) ? V : Z = null, Y, ge = M, ce = [], ee = null, Se = M == d, Ce = Se && Z && typeof Z.version == "function" && Z.version(), we, We = Ne([
          { label: "EdgeHTML", pattern: "Edge" },
          "Trident",
          { label: "WebKit", pattern: "AppleWebKit" },
          "iCab",
          "Presto",
          "NetFront",
          "Tasman",
          "KHTML",
          "Gecko"
        ]), Fe = ct([
          "Adobe AIR",
          "Arora",
          "Avant Browser",
          "Breach",
          "Camino",
          "Electron",
          "Epiphany",
          "Fennec",
          "Flock",
          "Galeon",
          "GreenBrowser",
          "iCab",
          "Iceweasel",
          "K-Meleon",
          "Konqueror",
          "Lunascape",
          "Maxthon",
          { label: "Microsoft Edge", pattern: "(?:Edge|Edg|EdgA|EdgiOS)" },
          "Midori",
          "Nook Browser",
          "PaleMoon",
          "PhantomJS",
          "Raven",
          "Rekonq",
          "RockMelt",
          { label: "Samsung Internet", pattern: "SamsungBrowser" },
          "SeaMonkey",
          { label: "Silk", pattern: "(?:Cloud9|Silk-Accelerated)" },
          "Sleipnir",
          "SlimBrowser",
          { label: "SRWare Iron", pattern: "Iron" },
          "Sunrise",
          "Swiftfox",
          "Vivaldi",
          "Waterfox",
          "WebPositive",
          { label: "Yandex Browser", pattern: "YaBrowser" },
          { label: "UC Browser", pattern: "UCBrowser" },
          "Opera Mini",
          { label: "Opera Mini", pattern: "OPiOS" },
          "Opera",
          { label: "Opera", pattern: "OPR" },
          "Chromium",
          "Chrome",
          { label: "Chrome", pattern: "(?:HeadlessChrome)" },
          { label: "Chrome Mobile", pattern: "(?:CriOS|CrMo)" },
          { label: "Firefox", pattern: "(?:Firefox|Minefield)" },
          { label: "Firefox for iOS", pattern: "FxiOS" },
          { label: "IE", pattern: "IEMobile" },
          { label: "IE", pattern: "MSIE" },
          "Safari"
        ]), it = qe([
          { label: "BlackBerry", pattern: "BB10" },
          "BlackBerry",
          { label: "Galaxy S", pattern: "GT-I9000" },
          { label: "Galaxy S2", pattern: "GT-I9100" },
          { label: "Galaxy S3", pattern: "GT-I9300" },
          { label: "Galaxy S4", pattern: "GT-I9500" },
          { label: "Galaxy S5", pattern: "SM-G900" },
          { label: "Galaxy S6", pattern: "SM-G920" },
          { label: "Galaxy S6 Edge", pattern: "SM-G925" },
          { label: "Galaxy S7", pattern: "SM-G930" },
          { label: "Galaxy S7 Edge", pattern: "SM-G935" },
          "Google TV",
          "Lumia",
          "iPad",
          "iPod",
          "iPhone",
          "Kindle",
          { label: "Kindle Fire", pattern: "(?:Cloud9|Silk-Accelerated)" },
          "Nexus",
          "Nook",
          "PlayBook",
          "PlayStation Vita",
          "PlayStation",
          "TouchPad",
          "Transformer",
          { label: "Wii U", pattern: "WiiU" },
          "Wii",
          "Xbox One",
          { label: "Xbox 360", pattern: "Xbox" },
          "Xoom"
        ]), gt = ze({
          Apple: { iPad: 1, iPhone: 1, iPod: 1 },
          Alcatel: {},
          Archos: {},
          Amazon: { Kindle: 1, "Kindle Fire": 1 },
          Asus: { Transformer: 1 },
          "Barnes & Noble": { Nook: 1 },
          BlackBerry: { PlayBook: 1 },
          Google: { "Google TV": 1, Nexus: 1 },
          HP: { TouchPad: 1 },
          HTC: {},
          Huawei: {},
          Lenovo: {},
          LG: {},
          Microsoft: { Xbox: 1, "Xbox One": 1 },
          Motorola: { Xoom: 1 },
          Nintendo: { "Wii U": 1, Wii: 1 },
          Nokia: { Lumia: 1 },
          Oppo: {},
          Samsung: { "Galaxy S": 1, "Galaxy S2": 1, "Galaxy S3": 1, "Galaxy S4": 1 },
          Sony: { PlayStation: 1, "PlayStation Vita": 1 },
          Xiaomi: { Mi: 1, Redmi: 1 }
        }), Ze = rt([
          "Windows Phone",
          "KaiOS",
          "Android",
          "CentOS",
          { label: "Chrome OS", pattern: "CrOS" },
          "Debian",
          { label: "DragonFly BSD", pattern: "DragonFly" },
          "Fedora",
          "FreeBSD",
          "Gentoo",
          "Haiku",
          "Kubuntu",
          "Linux Mint",
          "OpenBSD",
          "Red Hat",
          "SuSE",
          "Ubuntu",
          "Xubuntu",
          "Cygwin",
          "Symbian OS",
          "hpwOS",
          "webOS ",
          "webOS",
          "Tablet OS",
          "Tizen",
          "Linux",
          "Mac OS X",
          "Macintosh",
          "Mac",
          "Windows 98;",
          "Windows "
        ]);
        function Ne(lt) {
          return x(lt, function(mt, jt) {
            return mt || RegExp("\\b" + (jt.pattern || C(jt)) + "\\b", "i").exec(M) && (jt.label || jt);
          });
        }
        function ze(lt) {
          return x(lt, function(mt, jt, Jt) {
            return mt || (jt[it] || jt[/^[a-z]+(?: +[a-z]+\b)*/i.exec(it)] || RegExp("\\b" + C(Jt) + "(?:\\b|\\w*\\d)", "i").exec(M)) && Jt;
          });
        }
        function ct(lt) {
          return x(lt, function(mt, jt) {
            return mt || RegExp("\\b" + (jt.pattern || C(jt)) + "\\b", "i").exec(M) && (jt.label || jt);
          });
        }
        function rt(lt) {
          return x(lt, function(mt, jt) {
            var Jt = jt.pattern || C(jt);
            return !mt && (mt = RegExp("\\b" + Jt + "(?:/[\\d.]+|[ \\w.]*)", "i").exec(M)) && (mt = p(mt, Jt, jt.label || jt)), mt;
          });
        }
        function qe(lt) {
          return x(lt, function(mt, jt) {
            var Jt = jt.pattern || C(jt);
            return !mt && (mt = RegExp("\\b" + Jt + " *\\d+[.\\w_]*", "i").exec(M) || RegExp("\\b" + Jt + " *\\w+-[\\w]*", "i").exec(M) || RegExp("\\b" + Jt + "(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)", "i").exec(M)) && ((mt = String(jt.label && !RegExp(Jt, "i").test(jt.label) ? jt.label : mt).split("/"))[1] && !/[\d.]+/.test(mt[0]) && (mt[0] += " " + mt[1]), jt = jt.label || jt, mt = y(mt[0].replace(RegExp(Jt, "i"), jt).replace(RegExp("; *(?:" + jt + "[_-])?", "i"), " ").replace(RegExp("(" + jt + ")[-_.]?(\\w)", "i"), "$1 $2"))), mt;
          });
        }
        function nt(lt) {
          return x(lt, function(mt, jt) {
            return mt || (RegExp(jt + "(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)", "i").exec(M) || 0)[1] || null;
          });
        }
        function Rt() {
          return this.description || "";
        }
        if (We && (We = [We]), /\bAndroid\b/.test(Ze) && !it && (Y = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(M)) && (it = S(Y[1]).replace(/^[a-z]{2}-[a-z]{2};\s*/i, "") || null), gt && !it ? it = qe([gt]) : gt && it && (it = it.replace(RegExp("^(" + C(gt) + ")[-_.\\s]", "i"), gt + " ").replace(RegExp("^(" + C(gt) + ")[-_.]?(\\w)", "i"), gt + " $2")), (Y = /\bGoogle TV\b/.exec(it)) && (it = Y[0]), /\bSimulator\b/i.test(M) && (it = (it ? it + " " : "") + "Simulator"), Fe == "Opera Mini" && /\bOPiOS\b/.test(M) && ce.push("running in Turbo/Uncompressed mode"), Fe == "IE" && /\blike iPhone OS\b/.test(M) ? (Y = A(M.replace(/like iPhone OS/, "")), gt = Y.manufacturer, it = Y.product) : /^iP/.test(it) ? (Fe || (Fe = "Safari"), Ze = "iOS" + ((Y = / OS ([\d_]+)/i.exec(M)) ? " " + Y[1].replace(/_/g, ".") : "")) : Fe == "Konqueror" && /^Linux\b/i.test(Ze) ? Ze = "Kubuntu" : gt && gt != "Google" && (/Chrome/.test(Fe) && !/\bMobile Safari\b/i.test(M) || /\bVita\b/.test(it)) || /\bAndroid\b/.test(Ze) && /^Chrome/.test(Fe) && /\bVersion\//i.test(M) ? (Fe = "Android Browser", Ze = /\bAndroid\b/.test(Ze) ? Ze : "Android") : Fe == "Silk" ? (/\bMobi/i.test(M) || (Ze = "Android", ce.unshift("desktop mode")), /Accelerated *= *true/i.test(M) && ce.unshift("accelerated")) : Fe == "UC Browser" && /\bUCWEB\b/.test(M) ? ce.push("speed mode") : Fe == "PaleMoon" && (Y = /\bFirefox\/([\d.]+)\b/.exec(M)) ? ce.push("identifying as Firefox " + Y[1]) : Fe == "Firefox" && (Y = /\b(Mobile|Tablet|TV)\b/i.exec(M)) ? (Ze || (Ze = "Firefox OS"), it || (it = Y[1])) : !Fe || (Y = !/\bMinefield\b/i.test(M) && /\b(?:Firefox|Safari)\b/.exec(Fe)) ? (Fe && !it && /[\/,]|^[^(]+?\)/.test(M.slice(M.indexOf(Y + "/") + 8)) && (Fe = null), (Y = it || gt || Ze) && (it || gt || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(Ze)) && (Fe = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(Ze) ? Ze : Y) + " Browser")) : Fe == "Electron" && (Y = (/\bChrome\/([\d.]+)\b/.exec(M) || 0)[1]) && ce.push("Chromium " + Y), Ce || (Ce = nt([
          "(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)",
          "Version",
          C(Fe),
          "(?:Firefox|Minefield|NetFront)"
        ])), (Y = We == "iCab" && parseFloat(Ce) > 3 && "WebKit" || /\bOpera\b/.test(Fe) && (/\bOPR\b/.test(M) ? "Blink" : "Presto") || /\b(?:Midori|Nook|Safari)\b/i.test(M) && !/^(?:Trident|EdgeHTML)$/.test(We) && "WebKit" || !We && /\bMSIE\b/i.test(M) && (Ze == "Mac OS" ? "Tasman" : "Trident") || We == "WebKit" && /\bPlayStation\b(?! Vita\b)/i.test(Fe) && "NetFront") && (We = [Y]), Fe == "IE" && (Y = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(M) || 0)[1]) ? (Fe += " Mobile", Ze = "Windows Phone " + (/\+$/.test(Y) ? Y : Y + ".x"), ce.unshift("desktop mode")) : /\bWPDesktop\b/i.test(M) ? (Fe = "IE Mobile", Ze = "Windows Phone 8.x", ce.unshift("desktop mode"), Ce || (Ce = (/\brv:([\d.]+)/.exec(M) || 0)[1])) : Fe != "IE" && We == "Trident" && (Y = /\brv:([\d.]+)/.exec(M)) && (Fe && ce.push("identifying as " + Fe + (Ce ? " " + Ce : "")), Fe = "IE", Ce = Y[1]), Se) {
          if (_(B, "global"))
            if (j && (Y = j.lang.System, ge = Y.getProperty("os.arch"), Ze = Ze || Y.getProperty("os.name") + " " + Y.getProperty("os.version")), F) {
              try {
                Ce = B.require("ringo/engine").version.join("."), Fe = "RingoJS";
              } catch {
                (Y = B.system) && Y.global.system == B.system && (Fe = "Narwhal", Ze || (Ze = Y[0].os || null));
              }
              Fe || (Fe = "Rhino");
            } else typeof B.process == "object" && !B.process.browser && (Y = B.process) && (typeof Y.versions == "object" && (typeof Y.versions.electron == "string" ? (ce.push("Node " + Y.versions.node), Fe = "Electron", Ce = Y.versions.electron) : typeof Y.versions.nw == "string" && (ce.push("Chromium " + Ce, "Node " + Y.versions.node), Fe = "NW.js", Ce = Y.versions.nw)), Fe || (Fe = "Node.js", ge = Y.arch, Ze = Y.platform, Ce = /[\d.]+/.exec(Y.version), Ce = Ce ? Ce[0] : null));
          else w(Y = B.runtime) == k ? (Fe = "Adobe AIR", Ze = Y.flash.system.Capabilities.os) : w(Y = B.phantom) == H ? (Fe = "PhantomJS", Ce = (Y = Y.version || null) && Y.major + "." + Y.minor + "." + Y.patch) : typeof U.documentMode == "number" && (Y = /\bTrident\/(\d+)/i.exec(M)) ? (Ce = [Ce, U.documentMode], (Y = +Y[1] + 4) != Ce[1] && (ce.push("IE " + Ce[1] + " mode"), We && (We[1] = ""), Ce[1] = Y), Ce = Fe == "IE" ? String(Ce[1].toFixed(1)) : Ce[0]) : typeof U.documentMode == "number" && /^(?:Chrome|Firefox)\b/.test(Fe) && (ce.push("masking as " + Fe + " " + Ce), Fe = "IE", Ce = "11.0", We = ["Trident"], Ze = "Windows");
          Ze = Ze && y(Ze);
        }
        if (Ce && (Y = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(Ce) || /(?:alpha|beta)(?: ?\d)?/i.exec(M + ";" + (Se && N.appMinorVersion)) || /\bMinefield\b/i.test(M) && "a") && (ee = /b/i.test(Y) ? "beta" : "alpha", Ce = Ce.replace(RegExp(Y + "\\+?$"), "") + (ee == "beta" ? W : z) + (/\d+\+?/.exec(Y) || "")), Fe == "Fennec" || Fe == "Firefox" && /\b(?:Android|Firefox OS|KaiOS)\b/.test(Ze))
          Fe = "Firefox Mobile";
        else if (Fe == "Maxthon" && Ce)
          Ce = Ce.replace(/\.[\d.]+/, ".x");
        else if (/\bXbox\b/i.test(it))
          it == "Xbox 360" && (Ze = null), it == "Xbox 360" && /\bIEMobile\b/.test(M) && ce.unshift("mobile mode");
        else if ((/^(?:Chrome|IE|Opera)$/.test(Fe) || Fe && !it && !/Browser|Mobi/.test(Fe)) && (Ze == "Windows CE" || /Mobi/i.test(M)))
          Fe += " Mobile";
        else if (Fe == "IE" && Se)
          try {
            B.external === null && ce.unshift("platform preview");
          } catch {
            ce.unshift("embedded");
          }
        else (/\bBlackBerry\b/.test(it) || /\bBB10\b/.test(M)) && (Y = (RegExp(it.replace(/ +/g, " *") + "/([.\\d]+)", "i").exec(M) || 0)[1] || Ce) ? (Y = [Y, /BB10/.test(M)], Ze = (Y[1] ? (it = null, gt = "BlackBerry") : "Device Software") + " " + Y[0], Ce = null) : this != b && it != "Wii" && (Se && Z || /Opera/.test(Fe) && /\b(?:MSIE|Firefox)\b/i.test(M) || Fe == "Firefox" && /\bOS X (?:\d+\.){2,}/.test(Ze) || Fe == "IE" && (Ze && !/^Win/.test(Ze) && Ce > 5.5 || /\bWindows XP\b/.test(Ze) && Ce > 8 || Ce == 8 && !/\bTrident\b/.test(M))) && !l.test(Y = A.call(b, M.replace(l, "") + ";")) && Y.name && (Y = "ing as " + Y.name + ((Y = Y.version) ? " " + Y : ""), l.test(Fe) ? (/\bIE\b/.test(Y) && Ze == "Mac OS" && (Ze = null), Y = "identify" + Y) : (Y = "mask" + Y, V ? Fe = y(V.replace(/([a-z])([A-Z])/g, "$1 $2")) : Fe = "Opera", /\bIE\b/.test(Y) && (Ze = null), Se || (Ce = null)), We = ["Presto"], ce.push(Y));
        (Y = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(M) || 0)[1]) && (Y = [parseFloat(Y.replace(/\.(\d)$/, ".0$1")), Y], Fe == "Safari" && Y[1].slice(-1) == "+" ? (Fe = "WebKit Nightly", ee = "alpha", Ce = Y[1].slice(0, -1)) : (Ce == Y[1] || Ce == (Y[2] = (/\bSafari\/([\d.]+\+?)/i.exec(M) || 0)[1])) && (Ce = null), Y[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(M) || 0)[1], Y[0] == 537.36 && Y[2] == 537.36 && parseFloat(Y[1]) >= 28 && We == "WebKit" && (We = ["Blink"]), !Se || !m && !Y[1] ? (We && (We[1] = "like Safari"), Y = (Y = Y[0], Y < 400 ? 1 : Y < 500 ? 2 : Y < 526 ? 3 : Y < 533 ? 4 : Y < 534 ? "4+" : Y < 535 ? 5 : Y < 537 ? 6 : Y < 538 ? 7 : Y < 601 ? 8 : Y < 602 ? 9 : Y < 604 ? 10 : Y < 606 ? 11 : Y < 608 ? 12 : "12")) : (We && (We[1] = "like Chrome"), Y = Y[1] || (Y = Y[0], Y < 530 ? 1 : Y < 532 ? 2 : Y < 532.05 ? 3 : Y < 533 ? 4 : Y < 534.03 ? 5 : Y < 534.07 ? 6 : Y < 534.1 ? 7 : Y < 534.13 ? 8 : Y < 534.16 ? 9 : Y < 534.24 ? 10 : Y < 534.3 ? 11 : Y < 535.01 ? 12 : Y < 535.02 ? "13+" : Y < 535.07 ? 15 : Y < 535.11 ? 16 : Y < 535.19 ? 17 : Y < 536.05 ? 18 : Y < 536.1 ? 19 : Y < 537.01 ? 20 : Y < 537.11 ? "21+" : Y < 537.13 ? 23 : Y < 537.18 ? 24 : Y < 537.24 ? 25 : Y < 537.36 ? 26 : We != "Blink" ? "27" : "28")), We && (We[1] += " " + (Y += typeof Y == "number" ? ".x" : /[.+]/.test(Y) ? "" : "+")), Fe == "Safari" && (!Ce || parseInt(Ce) > 45) ? Ce = Y : Fe == "Chrome" && /\bHeadlessChrome/i.test(M) && ce.unshift("headless")), Fe == "Opera" && (Y = /\bzbov|zvav$/.exec(Ze)) ? (Fe += " ", ce.unshift("desktop mode"), Y == "zvav" ? (Fe += "Mini", Ce = null) : Fe += "Mobile", Ze = Ze.replace(RegExp(" *" + Y + "$"), "")) : Fe == "Safari" && /\bChrome\b/.exec(We && We[1]) ? (ce.unshift("desktop mode"), Fe = "Chrome Mobile", Ce = null, /\bOS X\b/.test(Ze) ? (gt = "Apple", Ze = "iOS 4.3+") : Ze = null) : /\bSRWare Iron\b/.test(Fe) && !Ce && (Ce = nt("Chrome")), Ce && Ce.indexOf(Y = /[\d.]+$/.exec(Ze)) == 0 && M.indexOf("/" + Y + "-") > -1 && (Ze = S(Ze.replace(Y, ""))), Ze && Ze.indexOf(Fe) != -1 && !RegExp(Fe + " OS").test(Ze) && (Ze = Ze.replace(RegExp(" *" + C(Fe) + " *"), "")), We && !/\b(?:Avant|Nook)\b/.test(Fe) && (/Browser|Lunascape|Maxthon/.test(Fe) || Fe != "Safari" && /^iOS/.test(Ze) && /\bSafari\b/.test(We[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(Fe) && We[1]) && (Y = We[We.length - 1]) && ce.push(Y), ce.length && (ce = ["(" + ce.join("; ") + ")"]), gt && it && it.indexOf(gt) < 0 && ce.push("on " + gt), it && ce.push((/^on /.test(ce[ce.length - 1]) ? "" : "on ") + it), Ze && (Y = / ([\d.+]+)$/.exec(Ze), we = Y && Ze.charAt(Ze.length - Y[0].length - 1) == "/", Ze = {
          architecture: 32,
          family: Y && !we ? Ze.replace(Y[0], "") : Ze,
          version: Y ? Y[1] : null,
          toString: function() {
            var lt = this.version;
            return this.family + (lt && !we ? " " + lt : "") + (this.architecture == 64 ? " 64-bit" : "");
          }
        }), (Y = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(ge)) && !/\bi686\b/i.test(ge) ? (Ze && (Ze.architecture = 64, Ze.family = Ze.family.replace(RegExp(" *" + Y), "")), Fe && (/\bWOW64\b/i.test(M) || Se && /\w(?:86|32)$/.test(N.cpuClass || N.platform) && !/\bWin64; x64\b/i.test(M)) && ce.unshift("32-bit")) : Ze && /^OS X/.test(Ze.family) && Fe == "Chrome" && parseFloat(Ce) >= 39 && (Ze.architecture = 64), M || (M = null);
        var Ot = {};
        return Ot.description = M, Ot.layout = We && We[0], Ot.manufacturer = gt, Ot.name = Fe, Ot.prerelease = ee, Ot.product = it, Ot.ua = M, Ot.version = Fe && Ce, Ot.os = Ze || {
          /**
           * The CPU architecture the OS is built for.
           *
           * @memberOf platform.os
           * @type number|null
           */
          architecture: null,
          /**
           * The family of the OS.
           *
           * Common values include:
           * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
           * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
           * "SuSE", "Android", "iOS" and "Windows Phone"
           *
           * @memberOf platform.os
           * @type string|null
           */
          family: null,
          /**
           * The version of the OS.
           *
           * @memberOf platform.os
           * @type string|null
           */
          version: null,
          /**
           * Returns the OS string.
           *
           * @memberOf platform.os
           * @returns {string} The OS string.
           */
          toString: function() {
            return "null";
          }
        }, Ot.parse = A, Ot.toString = Rt, Ot.version && ce.unshift(Ce), Ot.name && ce.unshift(Fe), Ze && Fe && !(Ze == String(Ze).split(" ")[0] && (Ze == Fe.split(" ")[0] || it)) && ce.push(it ? "(" + Ze + ")" : "on " + Ze), ce.length && (Ot.description = ce.join(" ")), Ot;
      }
      var I = A();
      a && i ? b(I, function(M, B) {
        a[B] = M;
      }) : n.platform = I;
    }).call(lmr);
  }(r_, r_.exports)), r_.exports;
}
var lAe = {}, cAe;
function Jrt() {
  if (cAe) return lAe;
  cAe = 1;
  var t = No(), e = eW(), r = Ys(), n = u2(), a = hg(), i = Vl(), o = d2(), s = a6(), l = Fme(), c = tW();
  return e("match", function(u, f, h) {
    return [
      // `String.prototype.match` method
      // https://tc39.es/ecma262/#sec-string.prototype.match
      function(g) {
        var y = o(this), b = n(g) ? void 0 : s(g, u);
        return b ? t(b, g, y) : new RegExp(g)[u](i(y));
      },
      // `RegExp.prototype[@@match]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
      function(p) {
        var g = r(this), y = i(p), b = h(f, g, y);
        if (b.done) return b.value;
        if (!g.global) return c(g, y);
        var w = g.unicode;
        g.lastIndex = 0;
        for (var _ = [], C = 0, x; (x = c(g, y)) !== null; ) {
          var S = i(x[0]);
          _[C] = S, S === "" && (g.lastIndex = l(y, a(g.lastIndex), w)), C++;
        }
        return C === 0 ? null : _;
      }
    ];
  }), lAe;
}
var uAe = {}, NQ, dAe;
function cmr() {
  return dAe || (dAe = 1, NQ = Object.is || function(e, r) {
    return e === r ? e !== 0 || 1 / e === 1 / r : e !== e && r !== r;
  }), NQ;
}
var fAe;
function umr() {
  if (fAe) return uAe;
  fAe = 1;
  var t = No(), e = eW(), r = Ys(), n = u2(), a = d2(), i = cmr(), o = Vl(), s = a6(), l = tW();
  return e("search", function(c, u, f) {
    return [
      // `String.prototype.search` method
      // https://tc39.es/ecma262/#sec-string.prototype.search
      function(p) {
        var g = a(this), y = n(p) ? void 0 : s(p, c);
        return y ? t(y, p, g) : new RegExp(p)[c](o(g));
      },
      // `RegExp.prototype[@@search]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
      function(h) {
        var p = r(this), g = o(h), y = f(u, p, g);
        if (y.done) return y.value;
        var b = p.lastIndex;
        i(b, 0) || (p.lastIndex = 0);
        var w = l(p, g);
        return i(p.lastIndex, b) || (p.lastIndex = b), w === null ? -1 : w.index;
      }
    ];
  }), uAe;
}
var hAe = {}, $Q, pAe;
function dmr() {
  if (pAe) return $Q;
  pAe = 1;
  var t = Go(), e = EM(), r = TypeError, n = Object.getOwnPropertyDescriptor, a = t && !function() {
    if (this !== void 0) return !0;
    try {
      Object.defineProperty([], "length", { writable: !1 }).length = 1;
    } catch (i) {
      return i instanceof TypeError;
    }
  }();
  return $Q = a ? function(i, o) {
    if (e(i) && !n(i, "length").writable)
      throw new r("Cannot set read only .length");
    return i.length = o;
  } : function(i, o) {
    return i.length = o;
  }, $Q;
}
var mAe;
function Yrt() {
  if (mAe) return hAe;
  mAe = 1;
  var t = Ya(), e = ru(), r = i6(), n = Xh(), a = nu(), i = dmr(), o = trt(), s = bme(), l = RM(), c = zme(), u = IM(), f = u("splice"), h = Math.max, p = Math.min;
  return t({ target: "Array", proto: !0, forced: !f }, {
    splice: function(y, b) {
      var w = e(this), _ = a(w), C = r(y, _), x = arguments.length, S, A, I, M, B, L;
      for (x === 0 ? S = A = 0 : x === 1 ? (S = 0, A = _ - C) : (S = x - 2, A = p(h(n(b), 0), _ - C)), o(_ + S - A), I = s(w, A), M = 0; M < A; M++)
        B = C + M, B in w && l(I, M, w[B]);
      if (I.length = A, S < A) {
        for (M = C; M < _ - A; M++)
          B = M + A, L = M + S, B in w ? w[L] = w[B] : c(w, L);
        for (M = _; M > _ - A + S; M--) c(w, M - 1);
      } else if (S > A)
        for (M = _ - A; M > C; M--)
          B = M + A - 1, L = M + S - 1, B in w ? w[L] = w[B] : c(w, L);
      for (M = 0; M < S; M++)
        w[M + C] = arguments[M + 2];
      return i(w, _ - A + S), I;
    }
  }), hAe;
}
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes javascript-state-machine under the following license.

    Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.


*/
var gAe;
function Wme() {
  return gAe || (gAe = 1, function(t) {
    var e = typeof e < "u" ? e : typeof self < "u" ? self : typeof window < "u" ? window : {};
    Object.defineProperty(t, "__esModule", { value: !0 }), s6();
    var r = OM(), n = Gy(), a = l6(), i = $me(), o = Wy(), s = Hy(), l = np(), c = zy(), u = c6(), f = FM();
    f6(), u6(), lrt(), WM(), jG();
    var h = rp(), p = HM();
    U8(), h6();
    var g = V8();
    vg(), Lme(), H8(), DG(), VG(), d6();
    var y = Mpr(), b = /* @__PURE__ */ QG();
    p6(), rW(), KG(), xrt(), Crt(), wrt(), Srt(), _rt(), krt(), Art(), Trt(), Ert(), Irt(), Mrt(), Prt(), Rrt(), Ort(), Nrt(), $rt(), Drt(), Lrt(), jrt(), Frt(), Hrt(), Urt(), Vrt(), qrt(), Krt();
    var w = nW();
    gme(), MM(), xme(), PM(), Cme();
    var _ = UM();
    VM();
    var C = Zrt();
    Jrt(), umr(), Yrt();
    function x(st) {
      return st && typeof st == "object" && "default" in st ? st : { default: st };
    }
    function S(st) {
      if (st && st.__esModule) return st;
      var dt = /* @__PURE__ */ Object.create(null);
      return st && Object.keys(st).forEach(function(De) {
        if (De !== "default") {
          var Be = Object.getOwnPropertyDescriptor(st, De);
          Object.defineProperty(dt, De, Be.get ? Be : {
            enumerable: !0,
            get: function() {
              return st[De];
            }
          });
        }
      }), dt.default = st, Object.freeze(dt);
    }
    var A = /* @__PURE__ */ x(r), I = /* @__PURE__ */ x(n), M = /* @__PURE__ */ x(a), B = /* @__PURE__ */ x(i), L = /* @__PURE__ */ x(o), N = /* @__PURE__ */ x(s), d = /* @__PURE__ */ x(l), m = /* @__PURE__ */ x(c), v = /* @__PURE__ */ x(u), k = /* @__PURE__ */ x(f), O = /* @__PURE__ */ x(h), G = /* @__PURE__ */ S(g), H = /* @__PURE__ */ S(y), j = /* @__PURE__ */ x(w), F = /* @__PURE__ */ S(C);
    function z(st, dt, De, Be) {
      var Me = arguments.length, ut = Me < 3 ? dt : Be === null ? Be = Object.getOwnPropertyDescriptor(dt, De) : Be, Ve;
      if ((typeof Reflect > "u" ? "undefined" : O.default(Reflect)) === "object" && typeof Reflect.decorate == "function") ut = Reflect.decorate(st, dt, De, Be);
      else for (var Kt = st.length - 1; Kt >= 0; Kt--)
        (Ve = st[Kt]) && (ut = (Me < 3 ? Ve(ut) : Me > 3 ? Ve(dt, De, ut) : Ve(dt, De)) || ut);
      return Me > 3 && ut && Object.defineProperty(dt, De, ut), ut;
    }
    function W(st, dt) {
      if ((typeof Reflect > "u" ? "undefined" : O.default(Reflect)) === "object" && typeof Reflect.metadata == "function") return Reflect.metadata(st, dt);
    }
    var U;
    function Z() {
    }
    Z.prototype = /* @__PURE__ */ Object.create(null);
    function V() {
      V.init.call(this);
    }
    V.EventEmitter = V, V.usingDomains = !1, V.prototype.domain = void 0, V.prototype._events = void 0, V.prototype._maxListeners = void 0, V.defaultMaxListeners = 10, V.init = function() {
      this.domain = null, V.usingDomains && U.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new Z(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, V.prototype.setMaxListeners = function(dt) {
      if (typeof dt != "number" || dt < 0 || isNaN(dt))
        throw new TypeError('"n" argument must be a positive number');
      return this._maxListeners = dt, this;
    };
    function Y(st) {
      return st._maxListeners === void 0 ? V.defaultMaxListeners : st._maxListeners;
    }
    V.prototype.getMaxListeners = function() {
      return Y(this);
    };
    function ge(st, dt, De) {
      if (dt)
        st.call(De);
      else
        for (var Be = st.length, Me = Ze(st, Be), ut = 0; ut < Be; ++ut)
          Me[ut].call(De);
    }
    function ce(st, dt, De, Be) {
      if (dt)
        st.call(De, Be);
      else
        for (var Me = st.length, ut = Ze(st, Me), Ve = 0; Ve < Me; ++Ve)
          ut[Ve].call(De, Be);
    }
    function ee(st, dt, De, Be, Me) {
      if (dt)
        st.call(De, Be, Me);
      else
        for (var ut = st.length, Ve = Ze(st, ut), Kt = 0; Kt < ut; ++Kt)
          Ve[Kt].call(De, Be, Me);
    }
    function Se(st, dt, De, Be, Me, ut) {
      if (dt)
        st.call(De, Be, Me, ut);
      else
        for (var Ve = st.length, Kt = Ze(st, Ve), qt = 0; qt < Ve; ++qt)
          Kt[qt].call(De, Be, Me, ut);
    }
    function Ce(st, dt, De, Be) {
      if (dt)
        st.apply(De, Be);
      else
        for (var Me = st.length, ut = Ze(st, Me), Ve = 0; Ve < Me; ++Ve)
          ut[Ve].apply(De, Be);
    }
    V.prototype.emit = function(dt) {
      var De, Be, Me, ut, Ve, Kt, qt, vr = dt === "error";
      if (Kt = this._events, Kt)
        vr = vr && Kt.error == null;
      else if (!vr)
        return !1;
      if (qt = this.domain, vr) {
        if (De = arguments[1], qt)
          De || (De = new Error('Uncaught, unspecified "error" event')), De.domainEmitter = this, De.domain = qt, De.domainThrown = !1, qt.emit("error", De);
        else {
          if (De instanceof Error)
            throw De;
          var _e = new Error('Uncaught, unspecified "error" event. (' + De + ")");
          throw _e.context = De, _e;
        }
        return !1;
      }
      if (Be = Kt[dt], !Be)
        return !1;
      var Pe = typeof Be == "function";
      switch (Me = arguments.length, Me) {
        // fast cases
        case 1:
          ge(Be, Pe, this);
          break;
        case 2:
          ce(Be, Pe, this, arguments[1]);
          break;
        case 3:
          ee(Be, Pe, this, arguments[1], arguments[2]);
          break;
        case 4:
          Se(Be, Pe, this, arguments[1], arguments[2], arguments[3]);
          break;
        // slower
        default:
          for (ut = new Array(Me - 1), Ve = 1; Ve < Me; Ve++)
            ut[Ve - 1] = arguments[Ve];
          Ce(Be, Pe, this, ut);
      }
      return !0;
    };
    function we(st, dt, De, Be) {
      var Me, ut, Ve;
      if (typeof De != "function")
        throw new TypeError('"listener" argument must be a function');
      if (ut = st._events, ut ? (ut.newListener && (st.emit(
        "newListener",
        dt,
        De.listener ? De.listener : De
      ), ut = st._events), Ve = ut[dt]) : (ut = st._events = new Z(), st._eventsCount = 0), !Ve)
        Ve = ut[dt] = De, ++st._eventsCount;
      else if (typeof Ve == "function" ? Ve = ut[dt] = Be ? [De, Ve] : [Ve, De] : Be ? Ve.unshift(De) : Ve.push(De), !Ve.warned && (Me = Y(st), Me && Me > 0 && Ve.length > Me)) {
        Ve.warned = !0;
        var Kt = new Error("Possible EventEmitter memory leak detected. " + Ve.length + " " + dt + " listeners added. Use emitter.setMaxListeners() to increase limit");
        Kt.name = "MaxListenersExceededWarning", Kt.emitter = st, Kt.type = dt, Kt.count = Ve.length, We(Kt);
      }
      return st;
    }
    function We(st) {
      typeof console.warn == "function" ? console.warn(st) : console.log(st);
    }
    V.prototype.addListener = function(dt, De) {
      return we(this, dt, De, !1);
    }, V.prototype.on = V.prototype.addListener, V.prototype.prependListener = function(dt, De) {
      return we(this, dt, De, !0);
    };
    function Fe(st, dt, De) {
      var Be = !1;
      function Me() {
        st.removeListener(dt, Me), Be || (Be = !0, De.apply(st, arguments));
      }
      return Me.listener = De, Me;
    }
    V.prototype.once = function(dt, De) {
      if (typeof De != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.on(dt, Fe(this, dt, De)), this;
    }, V.prototype.prependOnceListener = function(dt, De) {
      if (typeof De != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.prependListener(dt, Fe(this, dt, De)), this;
    }, V.prototype.removeListener = function(dt, De) {
      var Be, Me, ut, Ve, Kt;
      if (typeof De != "function")
        throw new TypeError('"listener" argument must be a function');
      if (Me = this._events, !Me)
        return this;
      if (Be = Me[dt], !Be)
        return this;
      if (Be === De || Be.listener && Be.listener === De)
        --this._eventsCount === 0 ? this._events = new Z() : (delete Me[dt], Me.removeListener && this.emit("removeListener", dt, Be.listener || De));
      else if (typeof Be != "function") {
        for (ut = -1, Ve = Be.length; Ve-- > 0; )
          if (Be[Ve] === De || Be[Ve].listener && Be[Ve].listener === De) {
            Kt = Be[Ve].listener, ut = Ve;
            break;
          }
        if (ut < 0)
          return this;
        if (Be.length === 1) {
          if (Be[0] = void 0, --this._eventsCount === 0)
            return this._events = new Z(), this;
          delete Me[dt];
        } else
          gt(Be, ut);
        Me.removeListener && this.emit("removeListener", dt, Kt || De);
      }
      return this;
    }, V.prototype.off = function(st, dt) {
      return this.removeListener(st, dt);
    }, V.prototype.removeAllListeners = function(dt) {
      var De, Be;
      if (Be = this._events, !Be)
        return this;
      if (!Be.removeListener)
        return arguments.length === 0 ? (this._events = new Z(), this._eventsCount = 0) : Be[dt] && (--this._eventsCount === 0 ? this._events = new Z() : delete Be[dt]), this;
      if (arguments.length === 0) {
        for (var Me = Object.keys(Be), ut = 0, Ve; ut < Me.length; ++ut)
          Ve = Me[ut], Ve !== "removeListener" && this.removeAllListeners(Ve);
        return this.removeAllListeners("removeListener"), this._events = new Z(), this._eventsCount = 0, this;
      }
      if (De = Be[dt], typeof De == "function")
        this.removeListener(dt, De);
      else if (De)
        do
          this.removeListener(dt, De[De.length - 1]);
        while (De[0]);
      return this;
    }, V.prototype.listeners = function(dt) {
      var De, Be, Me = this._events;
      return Me ? (De = Me[dt], De ? typeof De == "function" ? Be = [De.listener || De] : Be = Ne(De) : Be = []) : Be = [], Be;
    }, V.listenerCount = function(st, dt) {
      return typeof st.listenerCount == "function" ? st.listenerCount(dt) : it.call(st, dt);
    }, V.prototype.listenerCount = it;
    function it(st) {
      var dt = this._events;
      if (dt) {
        var De = dt[st];
        if (typeof De == "function")
          return 1;
        if (De)
          return De.length;
      }
      return 0;
    }
    V.prototype.eventNames = function() {
      return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };
    function gt(st, dt) {
      for (var De = dt, Be = De + 1, Me = st.length; Be < Me; De += 1, Be += 1)
        st[De] = st[Be];
      st.pop();
    }
    function Ze(st, dt) {
      for (var De = new Array(dt); dt--; )
        De[dt] = st[dt];
      return De;
    }
    function Ne(st) {
      for (var dt = new Array(st.length), De = 0; De < dt.length; ++De)
        dt[De] = st[De].listener || st[De];
      return dt;
    }
    var ze = G.getLogger("twilsock");
    function ct(st, dt) {
      return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilsock ").concat(st, ":")].concat(Array.from(dt));
    }
    var rt = /* @__PURE__ */ function() {
      function st(dt) {
        m.default(this, st), v.default(this, "prefix", ""), this.prefix = dt != null && dt.length > 0 ? " " + dt + ":" : "";
      }
      return I.default(st, [{
        key: "setLevel",
        value: function(De) {
          ze.setLevel(De);
        }
      }, {
        key: "trace",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.trace.apply(null, ct("T", Be));
        }
      }, {
        key: "debug",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.debug.apply(null, ct("D", Be));
        }
      }, {
        key: "info",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.info.apply(null, ct("I", Be));
        }
      }, {
        key: "warn",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.warn.apply(null, ct("W", Be));
        }
      }, {
        key: "error",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.error.apply(null, ct("E", Be));
        }
      }], [{
        key: "setLevel",
        value: function(De) {
          ze.setLevel(De);
        }
      }, {
        key: "trace",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.trace.apply(null, ct("T", Be));
        }
      }, {
        key: "debug",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.debug.apply(null, ct("D", Be));
        }
      }, {
        key: "info",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.info.apply(null, ct("I", Be));
        }
      }, {
        key: "warn",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.warn.apply(null, ct("W", Be));
        }
      }, {
        key: "error",
        value: function() {
          for (var De = arguments.length, Be = new Array(De), Me = 0; Me < De; Me++)
            Be[Me] = arguments[Me];
          ze.error.apply(null, ct("E", Be));
        }
      }]), st;
    }(), qe = new rt(""), nt = "0.12.2", Rt = /* @__PURE__ */ function() {
      function st(dt, De, Be) {
        m.default(this, st), v.default(this, "confirmedCapabilities", /* @__PURE__ */ new Set()), this.activeGrant = De, this._token = dt;
        var Me = Be.region || "us1", ut = "wss://tsock.".concat(Me, ".twilio.com/v3/wsconnect"), Ve = Be.twilsock || Be.Twilsock || {};
        this.url = Ve.uri || ut, this._continuationToken = Be.continuationToken ? Be.continuationToken : null, this.logLevel = Be.logLevel ? Be.logLevel : "error", this.retryPolicy = Be.retryPolicy ? Be.retryPolicy : {
          min: 1 * 1e3,
          max: 2 * 60 * 1e3,
          randomness: 0.2
        }, this.clientMetadata = Be.clientMetadata ? Be.clientMetadata : {}, this.clientMetadata.ver = nt, this.initRegistrations = Be.initRegistrations ? Be.initRegistrations : null, this.tweaks = Be.tweaks ? Be.tweaks : null;
      }
      return I.default(st, [{
        key: "token",
        get: function() {
          return this._token;
        }
      }, {
        key: "continuationToken",
        get: function() {
          return this._continuationToken;
        }
      }, {
        key: "updateToken",
        value: function(De) {
          this._token = De;
        }
      }, {
        key: "updateContinuationToken",
        value: function(De) {
          this._continuationToken = De;
        }
      }]), st;
    }(), Ot = function st(dt) {
      m.default(this, st), this.id = dt || "TM".concat(b.v4());
    };
    function lt(st) {
      var dt = mt();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function mt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var jt = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = lt(De);
      function De(Be, Me, ut, Ve, Kt) {
        var qt;
        return m.default(this, De), qt = dt.call(this), v.default(M.default(qt), "method", "init"), qt.token = Be, qt.continuation_token = Me, qt.metadata = ut, qt.registrations = Ve, qt.tweaks = Kt, qt.capabilities = ["client_update", "offline_storage", "telemetry.v1"], qt;
      }
      return De;
    }(Ot);
    function Jt(st) {
      var dt = ne();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function ne() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var re = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Jt(De);
      function De(Be, Me, ut, Ve, Kt, qt, vr) {
        var _e;
        return m.default(this, De), _e = dt.call(this, Be), _e.continuationToken = Me, _e.continuationTokenStatus = Ve, _e.offlineStorage = Kt, _e.initRegistrations = qt, _e.debugInfo = vr, _e.confirmedCapabilities = ut, _e;
      }
      return De;
    }(Ot);
    function ie(st) {
      var dt = Ie();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Ie() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ke = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = ie(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this), v.default(M.default(Me), "method", "update"), Me.token = Be, Me;
      }
      return De;
    }(Ot);
    function Le(st) {
      var dt = Ge();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Ge() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var ft = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Le(De);
      function De(Be, Me, ut) {
        var Ve;
        return m.default(this, De), Ve = dt.call(this), v.default(M.default(Ve), "method", "message"), Ve.active_grant = Be, Ve.payload_type = Me, Ve.http_request = ut, Ve;
      }
      return De;
    }(Ot);
    function ot(st) {
      var dt = Ye();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Ye() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Je = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = ot(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this, Be), v.default(M.default(Me), "method", "reply"), v.default(M.default(Me), "payload_type", "application/json"), v.default(M.default(Me), "status", {
          code: 200,
          status: "OK"
        }), Me;
      }
      return De;
    }(Ot);
    function tt(st) {
      var dt = kt();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function kt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ft = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = tt(De);
      function De() {
        var Be;
        return m.default(this, De), Be = dt.call(this), v.default(M.default(Be), "method", "close"), Be;
      }
      return De;
    }(Ot);
    function bt(st) {
      var dt = At();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function At() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var vt = function st(dt, De, Be, Me, ut, Ve) {
      m.default(this, st), this.start = dt, this.end = De, this.title = Be, this.details = Me, this.id = ut, this.type = Ve;
    }, _t = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = bt(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this), v.default(M.default(Me), "method", "telemetry.v1"), Me.events = Be, Me;
      }
      return De;
    }(Ot);
    function yt(st) {
      var dt = encodeURIComponent(st), De = dt.replace(/%([0-9A-F]{2})/g, function(Be, Me) {
        return String.fromCharCode(+("0x" + Me));
      });
      return De.length;
    }
    function xr(st) {
      var dt = encodeURIComponent(st), De = dt.replace(/%([0-9A-F]{2})/g, function(Me, ut) {
        return String.fromCharCode(+("0x" + ut));
      }), Be = new Uint8Array(De.length);
      return Array.prototype.forEach.call(De, function(Me, ut) {
        Be[ut] = Me.charCodeAt(0);
      }), Be;
    }
    function dr(st) {
      var dt = Array.prototype.map.call(st, function(Be) {
        return String.fromCharCode(Be);
      }).join(""), De = dt.replace(/(.)/g, function(Be, Me) {
        var ut = Me.charCodeAt(0).toString(16).toUpperCase();
        return ut.length < 2 && (ut = "0" + ut), "%" + ut;
      });
      return decodeURIComponent(De);
    }
    function Er(st) {
      return JSON.parse(dr(st));
    }
    function gr(st) {
      for (var dt = "", De = 0; De < st.length; ++De) {
        var Be = String.fromCharCode(st[De]);
        if (dt += Be, Be === "\r") {
          De += 2;
          break;
        }
      }
      var Me = dt.split(" ");
      return {
        size: De,
        protocol: Me[0],
        version: Me[1],
        headerSize: Number(Me[2])
      };
    }
    var pr = /* @__PURE__ */ function() {
      function st() {
        m.default(this, st);
      }
      return I.default(st, null, [{
        key: "parse",
        value: function(De) {
          var Be = 2, Me = new Uint8Array(De), ut = gr(Me);
          if (ut.protocol !== "TWILSOCK" || ut.version !== "V3.0")
            return qe.error("unsupported protocol: ".concat(ut.protocol, " ver ").concat(ut.version)), null;
          var Ve;
          try {
            Ve = Er(Me.subarray(ut.size, ut.size + ut.headerSize));
          } catch (_e) {
            return qe.error("failed to parse message header", _e, De), null;
          }
          qe.debug("message received: ", Ve.method), qe.trace("message received: ", Ve);
          var Kt;
          if (Ve.payload_size > 0) {
            var qt = Be + ut.size + ut.headerSize, vr = Ve.payload_size;
            if (!Ve.hasOwnProperty("payload_type") || Ve.payload_type.indexOf("application/json") === 0)
              try {
                Kt = Er(Me.subarray(qt, qt + vr));
              } catch (_e) {
                return qe.error("failed to parse message body", _e, De), null;
              }
            else Ve.payload_type.indexOf("text/plain") === 0 && (Kt = dr(Me.subarray(qt, qt + vr)));
          }
          return {
            method: Ve.method,
            header: Ve,
            payload: Kt
          };
        }
      }, {
        key: "createPacket",
        value: function(De) {
          var Be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
          De.payload_size = yt(Be);
          var Me = JSON.stringify(De), ut = "TWILSOCK V3.0 " + yt(Me);
          qe.debug("send request:", ut + Me + Be);
          var Ve = xr(ut + `\r
` + Me + `\r
` + Be);
          return Ve.buffer;
        }
      }]), st;
    }();
    function Xr(st) {
      var dt = Yr();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Yr() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var at = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Xr(De);
      function De(Be) {
        return m.default(this, De), dt.call(this, Be);
      }
      return De;
    }(/* @__PURE__ */ j.default(Error));
    function Vt(st) {
      var dt = er();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function er() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var fr = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Vt(De);
      function De(Be, Me) {
        var ut;
        return m.default(this, De), ut = dt.call(this, Be), ut.reply = Me, ut;
      }
      return De;
    }(at);
    function tn(st, dt) {
      var De = Object.keys(st);
      if (Object.getOwnPropertySymbols) {
        var Be = Object.getOwnPropertySymbols(st);
        dt && (Be = Be.filter(function(Me) {
          return Object.getOwnPropertyDescriptor(st, Me).enumerable;
        })), De.push.apply(De, Be);
      }
      return De;
    }
    function Kn(st) {
      for (var dt = 1; dt < arguments.length; dt++) {
        var De = arguments[dt] != null ? arguments[dt] : {};
        dt % 2 ? tn(Object(De), !0).forEach(function(Be) {
          v.default(st, Be, De[Be]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(st, Object.getOwnPropertyDescriptors(De)) : tn(Object(De)).forEach(function(Be) {
          Object.defineProperty(st, Be, Object.getOwnPropertyDescriptor(De, Be));
        });
      }
      return st;
    }
    function Pr(st) {
      var dt = Pt();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Pt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var or = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Pr(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this), v.default(M.default(Me), "newBackoff", null), v.default(M.default(Me), "usedBackoff", null), v.default(M.default(Me), "retrier", null), Me.options = Be ? Kn({}, Be) : {}, Me;
      }
      return I.default(De, [{
        key: "inProgress",
        get: function() {
          return !!this.retrier;
        }
      }, {
        key: "start",
        value: function() {
          if (this.inProgress)
            throw new Error("Already waiting for next attempt, call finishAttempt(success : boolean) to finish it");
          this.createRetrier();
        }
        /**
         * Should be called to stop retrier entirely.
         */
      }, {
        key: "stop",
        value: function() {
          this.cleanRetrier(), this.newBackoff = null, this.usedBackoff = null;
        }
        /**
         * Modifies backoff for next attempt.
         * Expected behavior:
         * - If there was no backoff passed previously reschedulling next attempt to given backoff
         * - If previous backoff was longer then ignoring this one.
         * - If previous backoff was shorter then reschedulling with this one.
         * With or without backoff retrier will keep growing normally.
         * @param delay delay of next attempts in ms.
         */
      }, {
        key: "modifyBackoff",
        value: function(Me) {
          this.newBackoff = Me;
        }
        /**
         * Mark last emmited attempt as failed, initiating either next of fail if limits were hit.
         */
      }, {
        key: "attemptFailed",
        value: function() {
          if (!this.inProgress)
            throw new Error("No attempt is in progress");
          if (this.newBackoff) {
            var Me = !this.usedBackoff || this.usedBackoff < this.newBackoff;
            if (Me)
              this.createRetrier();
            else {
              var ut;
              (ut = this.retrier) === null || ut === void 0 || ut.failed(new Error());
            }
          } else {
            var Ve;
            (Ve = this.retrier) === null || Ve === void 0 || Ve.failed(new Error());
          }
        }
      }, {
        key: "cancel",
        value: function() {
          var Me;
          (Me = this.retrier) === null || Me === void 0 || Me.cancel();
        }
      }, {
        key: "cleanRetrier",
        value: function() {
          var Me, ut;
          (Me = this.retrier) === null || Me === void 0 || Me.removeAllListeners(), (ut = this.retrier) === null || ut === void 0 || ut.cancel(), this.retrier = null;
        }
      }, {
        key: "getRetryPolicy",
        value: function() {
          var Me = Kn({}, this.options);
          return this.newBackoff && (Me.min = this.newBackoff, Me.max = this.options.max && this.options.max > this.newBackoff ? this.options.max : this.newBackoff), Me.maxAttemptsCount = this.options.maxAttemptsCount ? this.options.maxAttemptsCount + 1 : void 0, Me;
        }
      }, {
        key: "createRetrier",
        value: function() {
          var Me = this;
          this.cleanRetrier();
          var ut = this.getRetryPolicy();
          this.retrier = new _.Retrier(ut), this.retrier.once("attempt", function() {
            var Ve, Kt;
            (Ve = Me.retrier) === null || Ve === void 0 || Ve.on("attempt", function() {
              return Me.emit("attempt");
            }), (Kt = Me.retrier) === null || Kt === void 0 || Kt.failed(new Error("Skipping first attempt"));
          }), this.retrier.on("failed", function(Ve) {
            return Me.emit("failed", Ve);
          }), this.usedBackoff = this.newBackoff, this.newBackoff = null, this.retrier.start();
        }
      }]), De;
    }(V);
    function Ht(st) {
      var dt = Mt();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Mt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Qt = 3e3;
    function pn(st) {
      setTimeout(st, 0);
    }
    var Kr = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Ht(De);
      function De(Be, Me, ut) {
        var Ve;
        m.default(this, De), Ve = dt.call(this), v.default(M.default(Ve), "disconnectingTimer", null), v.default(M.default(Ve), "disconnectedPromiseResolve", null), v.default(M.default(Ve), "terminalStates", ["disconnected", "rejected"]), v.default(M.default(Ve), "tokenExpiredSasCode", 20104), v.default(M.default(Ve), "terminationReason", "Connection is not initialized"), Ve.websocket = Be, Ve.websocket.on("connected", function() {
          return Ve.fsm.socketConnected();
        }), Ve.websocket.on("disconnected", function() {
          return Ve.fsm.socketClosed();
        }), Ve.websocket.on("message", function(qt) {
          return Ve.onIncomingMessage(qt);
        }), Ve.websocket.on("socketError", function(qt) {
          return Ve.emit("connectionError", {
            terminal: !1,
            message: "Socket error: ".concat(qt.message),
            httpStatusCode: null,
            errorCode: null
          });
        }), Ve.transport = Me, Ve.config = ut, Ve.retrier = new or(ut.retryPolicy), Ve.retrier.on("attempt", function() {
          return Ve.retry();
        }), Ve.retrier.on("failed", function(qt) {
          qe.warn("Retrying failed: ".concat(qt.message)), Ve.disconnect();
        }), typeof window < "u" && typeof window.addEventListener < "u" && (window.addEventListener("online", function() {
          qe.debug("Browser reported connectivity state: online"), Ve.resetBackoff(), Ve.fsm.systemOnline();
        }), window.addEventListener("offline", function() {
          qe.debug("Browser reported connectivity state: offline"), Ve.websocket.close(), Ve.fsm.socketClosed();
        }));
        var Kt = H.factory({
          init: "disconnected",
          transitions: [{
            name: "userConnect",
            from: ["disconnected", "rejected"],
            to: "connecting"
          }, {
            name: "userConnect",
            from: ["connecting", "connected"]
          }, {
            name: "userDisconnect",
            from: ["connecting", "initialising", "connected", "updating", "retrying", "rejected", "waitSocketClosed", "waitOffloadSocketClosed"],
            to: "disconnecting"
          }, {
            name: "userRetry",
            from: ["retrying"],
            to: "connecting"
          }, {
            name: "socketConnected",
            from: ["connecting"],
            to: "initialising"
          }, {
            name: "socketClosed",
            from: ["connecting", "initialising", "connected", "updating", "error", "waitOffloadSocketClosed"],
            to: "retrying"
          }, {
            name: "socketClosed",
            from: ["disconnecting"],
            to: "disconnected"
          }, {
            name: "socketClosed",
            from: ["waitSocketClosed"],
            to: "disconnected"
          }, {
            name: "socketClosed",
            from: ["rejected"],
            to: "rejected"
          }, {
            name: "initSuccess",
            from: ["initialising"],
            to: "connected"
          }, {
            name: "initError",
            from: ["initialising"],
            to: "error"
          }, {
            name: "tokenRejected",
            from: ["initialising", "updating"],
            to: "rejected"
          }, {
            name: "protocolError",
            from: ["initialising", "connected", "updating"],
            to: "error"
          }, {
            name: "receiveClose",
            from: ["initialising", "connected", "updating"],
            to: "waitSocketClosed"
          }, {
            name: "receiveOffload",
            from: ["initialising", "connected", "updating"],
            to: "waitOffloadSocketClosed"
          }, {
            name: "unsupportedProtocol",
            from: ["initialising", "connected", "updating"],
            to: "unsupported"
          }, {
            name: "receiveFatalClose",
            from: ["initialising", "connected", "updating"],
            to: "unsupported"
          }, {
            name: "userUpdateToken",
            from: ["disconnected", "rejected", "connecting", "retrying"],
            to: "connecting"
          }, {
            name: "userUpdateToken",
            from: ["connected"],
            to: "updating"
          }, {
            name: "updateSuccess",
            from: ["updating"],
            to: "connected"
          }, {
            name: "updateError",
            from: ["updating"],
            to: "error"
          }, {
            name: "userSend",
            from: ["connected"],
            to: "connected"
          }, {
            name: "systemOnline",
            from: ["retrying"],
            to: "connecting"
          }],
          methods: {
            onConnecting: function() {
              Ve.setupSocket(), Ve.emit("connecting");
            },
            onEnterInitialising: function() {
              Ve.sendInit();
            },
            onLeaveInitialising: function() {
              Ve.cancelInit();
            },
            onEnterUpdating: function() {
              Ve.sendUpdate();
            },
            onLeaveUpdating: function() {
              Ve.cancelUpdate();
            },
            onEnterRetrying: function() {
              Ve.initRetry(), Ve.emit("connecting");
            },
            onEnterConnected: function() {
              Ve.resetBackoff(), Ve.onConnected();
            },
            onUserUpdateToken: function() {
              Ve.resetBackoff();
            },
            onTokenRejected: function() {
              Ve.resetBackoff(), Ve.closeSocket(!0), Ve.finalizeSocket();
            },
            onUserDisconnect: function() {
              Ve.closeSocket(!0);
            },
            onEnterDisconnecting: function() {
              Ve.startDisconnectTimer();
            },
            onLeaveDisconnecting: function() {
              Ve.cancelDisconnectTimer();
            },
            onEnterWaitSocketClosed: function() {
              Ve.startDisconnectTimer();
            },
            onLeaveWaitSocketClosed: function() {
              Ve.cancelDisconnectTimer();
            },
            onEnterWaitOffloadSocketClosed: function() {
              Ve.startDisconnectTimer();
            },
            onLeaveWaitOffloadSocketClosed: function() {
              Ve.cancelDisconnectTimer();
            },
            onDisconnected: function() {
              Ve.resetBackoff(), Ve.finalizeSocket();
            },
            onReceiveClose: function() {
              Ve.onCloseReceived();
            },
            onReceiveOffload: function(vr, _e) {
              qe.debug("onreceiveoffload: ", _e), Ve.modifyBackoff(_e.body), Ve.onCloseReceived();
            },
            onUnsupported: function() {
              Ve.closeSocket(!0), Ve.finalizeSocket();
            },
            onError: function(vr, _e) {
              Ve.closeSocket(_e), Ve.finalizeSocket();
            },
            onEnterState: function(vr) {
              vr.from !== "none" && Ve.changeState(vr);
            },
            onInvalidTransition: function(vr, _e, Pe) {
              qe.warn("FSM: unexpected transition", _e, Pe);
            }
          }
        });
        return Ve.fsm = new Kt(), Ve;
      }
      return I.default(De, [{
        key: "changeState",
        value: function(Me) {
          qe.debug("FSM: ".concat(Me.transition, ": ").concat(Me.from, " --> ").concat(Me.to)), this.lastEmittedState !== this.state && (this.lastEmittedState = this.state, this.emit("stateChanged", this.state));
        }
      }, {
        key: "resetBackoff",
        value: function() {
          qe.trace("resetBackoff"), this.retrier.stop();
        }
      }, {
        key: "modifyBackoff",
        value: function(Me) {
          qe.trace("modifyBackoff", Me);
          var ut = Me ? Me.backoff_policy : null;
          ut && typeof ut.reconnect_min_ms == "number" && this.retrier.modifyBackoff(ut.reconnect_min_ms);
        }
      }, {
        key: "startDisconnectTimer",
        value: function() {
          var Me = this;
          qe.trace("startDisconnectTimer"), this.disconnectingTimer && (clearTimeout(this.disconnectingTimer), this.disconnectingTimer = null), this.disconnectingTimer = setTimeout(function() {
            qe.debug("disconnecting is timed out"), Me.closeSocket(!0);
          }, Qt);
        }
      }, {
        key: "cancelDisconnectTimer",
        value: function() {
          qe.trace("cancelDisconnectTimer"), this.disconnectingTimer && (clearTimeout(this.disconnectingTimer), this.disconnectingTimer = null);
        }
      }, {
        key: "isConnected",
        get: function() {
          return this.state === "connected" && this.websocket.isConnected;
        }
      }, {
        key: "state",
        get: function() {
          switch (this.fsm.state) {
            case "connecting":
            case "initialising":
            case "retrying":
            case "error":
              return "connecting";
            case "updating":
            case "connected":
              return "connected";
            case "rejected":
              return "denied";
            case "disconnecting":
            case "waitSocketClosed":
            case "waitOffloadSocketClosed":
              return "disconnecting";
            case "disconnected":
            default:
              return "disconnected";
          }
        }
      }, {
        key: "initRetry",
        value: function() {
          qe.debug("initRetry"), this.retrier.inProgress ? this.retrier.attemptFailed() : this.retrier.start();
        }
      }, {
        key: "retry",
        value: function() {
          this.fsm.state != "connecting" ? (qe.trace("retry"), this.websocket.close(), this.fsm.userRetry()) : qe.trace("can	 retry as already connecting");
        }
      }, {
        key: "onConnected",
        value: function() {
          this.emit("connected");
        }
      }, {
        key: "finalizeSocket",
        value: function() {
          qe.trace("finalizeSocket"), this.websocket.close(), this.emit("disconnected"), this.disconnectedPromiseResolve && (this.disconnectedPromiseResolve(), this.disconnectedPromiseResolve = null);
        }
      }, {
        key: "setupSocket",
        value: function() {
          qe.trace("setupSocket:", this.config.token), this.emit("beforeConnect"), this.websocket.connect();
        }
      }, {
        key: "onIncomingMessage",
        value: function(Me) {
          var ut = pr.parse(Me);
          if (ut) {
            var Ve = ut.method, Kt = ut.header, qt = ut.payload;
            if (Ve !== "reply" && this.confirmReceiving(Kt), Ve === "notification")
              this.emit("message", Kt.message_type, qt);
            else if (Kt.method === "reply")
              this.transport.processReply({
                id: Kt.id,
                status: Kt.status,
                header: Kt,
                body: qt
              });
            else if (Kt.method === "client_update")
              Kt.client_update_type === "token_about_to_expire" && this.emit("tokenAboutToExpire");
            else if (Kt.method === "close")
              if (Kt.status.code === 308)
                qe.debug("Connection has been offloaded"), this.fsm.receiveOffload({
                  status: Kt.status.status,
                  body: qt
                });
              else if (Kt.status.code === 406) {
                var vr = "Server closed connection because can't parse protocol: ".concat(JSON.stringify(Kt.status));
                this.emitReplyConnectionError(vr, Kt, !0), qe.error(vr), this.fsm.receiveFatalClose();
              } else Kt.status.code === 417 ? (qe.error("Server closed connection because can't parse client reply: ".concat(JSON.stringify(Kt.status))), this.fsm.receiveFatalClose(Kt.status.status)) : Kt.status.code === 410 ? (qe.warn("Server closed connection: ".concat(JSON.stringify(Kt.status))), this.fsm.receiveClose(Kt.status.status), this.emit("tokenExpired")) : Kt.status.code === 401 ? (qe.error("Server closed connection: ".concat(JSON.stringify(Kt.status))), this.fsm.receiveClose(Kt.status.status)) : (qe.warn("unexpected message: ", Kt.status), this.fsm.receiveOffload({
                status: Kt.status.status,
                body: null
              }));
          }
        }
      }, {
        key: "sendInit",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut() {
            var Ve, Kt;
            return k.default.wrap(function(vr) {
              for (; ; )
                switch (vr.prev = vr.next) {
                  case 0:
                    return qe.trace("sendInit"), vr.prev = 1, this.emit("beforeSendInit"), vr.next = 5, this.transport.sendInit();
                  case 5:
                    Ve = vr.sent, this.config.updateContinuationToken(Ve.continuationToken), this.config.confirmedCapabilities = Ve.confirmedCapabilities, this.fsm.initSuccess(Ve), this.emit("initialized", Ve), this.emit("tokenUpdated"), vr.next = 17;
                    break;
                  case 13:
                    vr.prev = 13, vr.t0 = vr.catch(1), vr.t0 instanceof fr ? (Kt = !1, qe.warn("Init rejected by server: ".concat(JSON.stringify(vr.t0.reply.status))), this.emit("sendInitFailed"), vr.t0.reply.status.code === 401 || vr.t0.reply.status.code === 403 ? (Kt = !0, this.fsm.tokenRejected(vr.t0.reply.status), vr.t0.reply.status.errorCode === this.tokenExpiredSasCode && this.emit("tokenExpired")) : vr.t0.reply.status.code === 429 ? (this.modifyBackoff(vr.t0.reply.body), this.fsm.initError(!0)) : vr.t0.reply.status.code === 500 ? this.fsm.initError(!1) : this.fsm.initError(!0), this.emitReplyConnectionError(vr.t0.message, vr.t0.reply, Kt)) : (this.terminationReason = vr.t0.message, this.emit("connectionError", {
                      terminal: !0,
                      message: "Unknown error during connection initialisation: ".concat(vr.t0.message, `
`).concat(JSON.stringify(vr.t0, null, 2)),
                      httpStatusCode: null,
                      errorCode: null
                    }), this.fsm.initError(!0)), this.emit("tokenUpdated", vr.t0);
                  case 17:
                  case "end":
                    return vr.stop();
                }
            }, ut, this, [[1, 13]]);
          }));
          function Me() {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "sendUpdate",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut() {
            var Ve, Kt, qt;
            return k.default.wrap(function(_e) {
              for (; ; )
                switch (_e.prev = _e.next) {
                  case 0:
                    return qe.trace("sendUpdate"), Ve = new Ke(this.config.token), _e.prev = 2, _e.next = 5, this.transport.sendWithReply(Ve);
                  case 5:
                    Kt = _e.sent, this.fsm.updateSuccess(Kt.body), this.emit("tokenUpdated"), _e.next = 14;
                    break;
                  case 10:
                    _e.prev = 10, _e.t0 = _e.catch(2), _e.t0 instanceof fr ? (qt = !1, qe.warn("Token update rejected by server: ".concat(JSON.stringify(_e.t0.reply.status))), _e.t0.reply.status.code === 401 || _e.t0.reply.status.code === 403 ? (qt = !0, this.fsm.tokenRejected(_e.t0.reply.status), _e.t0.reply.status.errorCode === this.tokenExpiredSasCode && this.emit("tokenExpired")) : _e.t0.reply.status.code === 429 ? (this.modifyBackoff(_e.t0.reply.body), this.fsm.updateError(_e.t0.reply.status)) : this.fsm.updateError(_e.t0.reply.status), this.emitReplyConnectionError(_e.t0.message, _e.t0.reply, qt)) : (this.emit("error", !1, _e.t0.message, null, null), this.fsm.updateError(_e.t0)), this.emit("tokenUpdated", _e.t0);
                  case 14:
                  case "end":
                    return _e.stop();
                }
            }, ut, this, [[2, 10]]);
          }));
          function Me() {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "emitReplyConnectionError",
        value: function(Me, ut, Ve) {
          var Kt = ut.status && ut.status.description ? ut.status.description : Me, qt = ut.status.code, vr = ut.status && ut.status.errorCode ? ut.status.errorCode : null;
          Ve && (this.terminationReason = Kt), this.emit("connectionError", {
            terminal: Ve,
            message: "Connection error: ".concat(Kt),
            httpStatusCode: qt,
            errorCode: vr
          });
        }
      }, {
        key: "cancelInit",
        value: function() {
          qe.trace("cancelInit");
        }
      }, {
        key: "cancelUpdate",
        value: function() {
          qe.trace("cancelUpdate");
        }
        /**
         * Should be called for each message to confirm it received
         */
      }, {
        key: "confirmReceiving",
        value: function(Me) {
          qe.trace("confirmReceiving");
          try {
            this.transport.send(new Je(Me.id));
          } catch (ut) {
            qe.debug("failed to confirm packet receiving", ut);
          }
        }
        /**
         * Shutdown connection
         */
      }, {
        key: "closeSocket",
        value: function(Me) {
          var ut = this;
          qe.trace("closeSocket (graceful: ".concat(Me, ")")), Me && this.transport.isConnected && this.transport.sendClose(), this.websocket.close(), pn(function() {
            return ut.fsm.socketClosed();
          });
        }
        /**
         * Initiate the twilsock connection
         * If already connected, it does nothing
         */
      }, {
        key: "connect",
        value: function() {
          qe.trace("connect"), this.fsm.userConnect();
        }
        /**
         * Close twilsock connection
         * If already disconnected, it does nothing
         */
      }, {
        key: "disconnect",
        value: function() {
          var Me = this;
          return qe.trace("disconnect"), this.fsm.is("disconnected") ? Promise.resolve() : new Promise(function(ut) {
            Me.disconnectedPromiseResolve = ut, Me.fsm.userDisconnect();
          });
        }
        /**
         * Update fpa token for twilsock connection
         */
      }, {
        key: "updateToken",
        value: function(Me) {
          var ut = this;
          return qe.trace("updateToken:", Me), new Promise(function(Ve, Kt) {
            ut.once("tokenUpdated", function(qt) {
              qt ? Kt(qt) : Ve();
            }), ut.fsm.userUpdateToken();
          });
        }
      }, {
        key: "isTerminalState",
        get: function() {
          return this.terminalStates.indexOf(this.fsm.state) !== -1;
        }
      }, {
        key: "getTerminationReason",
        get: function() {
          return this.terminationReason;
        }
      }, {
        key: "onCloseReceived",
        value: function() {
          this.websocket.close();
        }
      }]), De;
    }(V), Da = /* @__PURE__ */ function() {
      function st() {
        m.default(this, st);
      }
      return I.default(st, null, [{
        key: "getMetadata",
        value: function(De) {
          var Be, Me, ut, Ve, Kt, qt, vr, _e, Pe = De && De.clientMetadata ? De.clientMetadata : {}, Q = ["ver", "env", "envv", "os", "osv", "osa", "type", "sdk", "sdkv", "dev", "devv", "devt", "app", "appv"], te = {
            env: (Be = F.name) !== null && Be !== void 0 ? Be : "unknown",
            envv: (Me = F.version) !== null && Me !== void 0 ? Me : "unknown",
            os: (ut = (Ve = F.os) === null || Ve === void 0 ? void 0 : Ve.family) !== null && ut !== void 0 ? ut : "unknown",
            osv: (Kt = (qt = F.os) === null || qt === void 0 ? void 0 : qt.version) !== null && Kt !== void 0 ? Kt : "unknown",
            osa: (vr = (_e = F.os) === null || _e === void 0 ? void 0 : _e.architecture) !== null && vr !== void 0 ? vr : "unknown",
            sdk: "js-default"
          }, J = {};
          return Q.filter(function(fe) {
            return fe in Pe || fe in te;
          }).forEach(function(fe) {
            return J[fe] = fe in Pe ? Pe[fe] : te[fe];
          }), J;
        }
      }]), st;
    }(), La = 3e4;
    function ji(st) {
      return st >= 200 && st < 300;
    }
    function Zo(st) {
      switch (O.default(st)) {
        case "undefined":
          return "";
        case "object":
          return JSON.stringify(st);
        default:
          return st;
      }
    }
    var kr = /* @__PURE__ */ function() {
      function st(dt, De) {
        var Be = this;
        m.default(this, st), this.config = De, this.activeRequests = /* @__PURE__ */ new Map(), this.channel = dt, this.channel.on("reply", function(Me) {
          return Be.processReply(Me);
        }), this.channel.on("disconnected", function() {
          Be.activeRequests.forEach(function(Me) {
            clearTimeout(Me.timeout), Me.reject(new at("disconnected"));
          }), Be.activeRequests.clear();
        });
      }
      return I.default(st, [{
        key: "isConnected",
        get: function() {
          return this.channel.isConnected;
        }
      }, {
        key: "processReply",
        value: function(De) {
          var Be = this.activeRequests.get(De.id);
          Be && (clearTimeout(Be.timeout), this.activeRequests.delete(De.id), ji(De.status.code) ? Be.resolve(De) : (Be.reject(new fr("Transport failure: " + De.status.status, De)), qe.trace("message rejected")));
        }
      }, {
        key: "storeRequest",
        value: function(De, Be, Me) {
          var ut = {
            resolve: Be,
            reject: Me,
            timeout: setTimeout(function() {
              qe.trace("request", De, "is timed out"), Me(new at("Twilsock: request timeout: " + De));
            }, La)
          };
          this.activeRequests.set(De, ut);
        }
      }, {
        key: "shutdown",
        value: function() {
          this.activeRequests.forEach(function(De) {
            clearTimeout(De.timeout), De.reject(new at("Twilsock: request cancelled by user"));
          }), this.activeRequests.clear();
        }
      }, {
        key: "sendInit",
        value: function() {
          var dt = A.default(/* @__PURE__ */ k.default.mark(function Be() {
            var Me, ut, Ve;
            return k.default.wrap(function(qt) {
              for (; ; )
                switch (qt.prev = qt.next) {
                  case 0:
                    return qe.trace("sendInit"), Me = Da.getMetadata(this.config), ut = new jt(this.config.token, this.config.continuationToken, Me, this.config.initRegistrations, this.config.tweaks), qt.next = 5, this.sendWithReply(ut);
                  case 5:
                    return Ve = qt.sent, qt.abrupt("return", new re(Ve.id, Ve.header.continuation_token, new Set(Ve.header.capabilities), Ve.header.continuation_token_status, Ve.header.offline_storage, Ve.header.init_registrations, Ve.header.debug_info));
                  case 7:
                  case "end":
                    return qt.stop();
                }
            }, Be, this);
          }));
          function De() {
            return dt.apply(this, arguments);
          }
          return De;
        }()
      }, {
        key: "sendClose",
        value: function() {
          var De = new Ft();
          this.send(De);
        }
      }, {
        key: "sendWithReply",
        value: function(De, Be) {
          var Me = this;
          return new Promise(function(ut, Ve) {
            var Kt = Me.send(De, Be);
            Me.storeRequest(Kt, ut, Ve);
          });
        }
      }, {
        key: "send",
        value: function(De, Be) {
          De.id = De.id || "TM".concat(b.v4());
          var Me = pr.createPacket(De, Zo(Be));
          try {
            return this.channel.send(Me), De.id;
          } catch (ut) {
            throw qe.debug("failed to send ", De, ut), qe.trace(ut.stack), ut;
          }
        }
      }]), st;
    }();
    function qi(st) {
      var dt = vi();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function vi() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ho = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = qi(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this), v.default(M.default(Me), "socket", null), Me.url = Be, Me.url = Be, Me.WebSocket = e.WebSocket || e.MozWebSocket || {}, Me;
      }
      return I.default(De, [{
        key: "isConnected",
        get: function() {
          return !!this.socket && this.socket.readyState === 1;
        }
      }, {
        key: "connect",
        value: function() {
          var Me = this;
          qe.trace("connecting to socket");
          var ut;
          try {
            ut = new this.WebSocket(this.url);
          } catch (Ve) {
            qe.debug("Socket error: ".concat(this.url)), this.emit("socketError", Ve);
            return;
          }
          ut.binaryType = "arraybuffer", ut.onopen = function() {
            qe.debug("socket opened ".concat(Me.url)), Me.emit("connected");
          }, ut.onclose = function(Ve) {
            qe.debug("socket closed", Ve), Me.emit("disconnected", Ve);
          }, ut.onerror = function(Ve) {
            qe.debug("Socket error:", Ve), Me.emit("socketError", Ve);
          }, ut.onmessage = function(Ve) {
            Me.emit("message", Ve.data);
          }, this.socket = ut;
        }
      }, {
        key: "send",
        value: function(Me) {
          return this.socket && this.socket.send(Me);
        }
      }, {
        key: "close",
        value: function() {
          if (qe.trace("closing socket"), this.socket) {
            this.socket.onopen = null, this.socket.onclose = null, this.socket.onerror = null, this.socket.onmessage = null;
            try {
              this.socket.close();
            } finally {
            }
          }
        }
      }]), De;
    }(V);
    function Ec(st) {
      var dt = Uu();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Uu() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ic = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = Ec(De);
      function De(Be) {
        var Me;
        return m.default(this, De), Me = dt.call(this), Me.transport = Be, Me.registrations = /* @__PURE__ */ new Map(), Me.registrationsInProgress = /* @__PURE__ */ new Map(), Me;
      }
      return I.default(De, [{
        key: "putNotificationContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt) {
            var qt;
            return k.default.wrap(function(_e) {
              for (; ; )
                switch (_e.prev = _e.next) {
                  case 0:
                    return qt = {
                      method: "put_notification_ctx",
                      notification_ctx_id: Ve
                    }, _e.next = 3, this.transport.sendWithReply(qt, Kt);
                  case 3:
                  case "end":
                    return _e.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "deleteNotificationContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve) {
            var Kt;
            return k.default.wrap(function(vr) {
              for (; ; )
                switch (vr.prev = vr.next) {
                  case 0:
                    return Kt = {
                      method: "delete_notification_ctx",
                      notification_ctx_id: Ve
                    }, vr.next = 3, this.transport.sendWithReply(Kt);
                  case 3:
                  case "end":
                    return vr.stop();
                }
            }, ut, this);
          }));
          function Me(ut) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "updateRegistration",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt) {
            var qt, vr;
            return k.default.wrap(function(Pe) {
              for (; ; )
                switch (Pe.prev = Pe.next) {
                  case 0:
                    return qe.debug("update registration for context", Ve), qt = this.registrationsInProgress.get(Ve), qt || (qt = /* @__PURE__ */ new Set(), this.registrationsInProgress.set(Ve, qt)), vr = b.v4(), qt.add(vr), Pe.prev = 5, Pe.next = 8, this.putNotificationContext(Ve, Kt);
                  case 8:
                    qe.debug("registration attempt succeeded for context", Kt), qt.delete(vr), qt.size === 0 && (this.registrationsInProgress.delete(Ve), this.emit("registered", Ve)), Pe.next = 19;
                    break;
                  case 13:
                    Pe.prev = 13, Pe.t0 = Pe.catch(5), qe.warn("registration attempt failed for context", Kt), qe.debug(Pe.t0), qt.delete(vr), qt.size === 0 && (this.registrationsInProgress.delete(Ve), this.emit("registrationFailed", Ve, Pe.t0));
                  case 19:
                  case "end":
                    return Pe.stop();
                }
            }, ut, this, [[5, 13]]);
          }));
          function Me(ut, Ve) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "updateRegistrations",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut() {
            var Ve = this, Kt;
            return k.default.wrap(function(vr) {
              for (; ; )
                switch (vr.prev = vr.next) {
                  case 0:
                    return qe.trace("refreshing ".concat(this.registrations.size, " registrations")), Kt = [], this.registrations.forEach(function(_e, Pe) {
                      Kt.push(Ve.updateRegistration(Pe, _e));
                    }), vr.next = 5, Promise.all(Kt);
                  case 5:
                  case "end":
                    return vr.stop();
                }
            }, ut, this);
          }));
          function Me() {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "setNotificationsContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt) {
            return k.default.wrap(function(vr) {
              for (; ; )
                switch (vr.prev = vr.next) {
                  case 0:
                    if (!(!Ve || !Kt)) {
                      vr.next = 2;
                      break;
                    }
                    throw new at("Invalid arguments provided");
                  case 2:
                    return this.registrations.set(Ve, Kt), vr.next = 5, this.updateRegistration(Ve, Kt);
                  case 5:
                    return vr.abrupt("return", vr.sent);
                  case 6:
                  case "end":
                    return vr.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }, {
        key: "removeNotificationsContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve) {
            return k.default.wrap(function(qt) {
              for (; ; )
                switch (qt.prev = qt.next) {
                  case 0:
                    if (this.registrations.has(Ve)) {
                      qt.next = 2;
                      break;
                    }
                    return qt.abrupt("return");
                  case 2:
                    return qt.next = 4, this.deleteNotificationContext(Ve);
                  case 4:
                    this.transport.isConnected && this.registrations.delete(Ve);
                  case 5:
                  case "end":
                    return qt.stop();
                }
            }, ut, this);
          }));
          function Me(ut) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
      }]), De;
    }(V);
    function js(st) {
      var dt = Mc();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Mc() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Vu = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = js(De);
      function De(Be, Me, ut) {
        var Ve;
        return m.default(this, De), Ve = dt.call(this, Me), Ve.status = Be, Ve.description = Me, Ve.body = ut, Ve;
      }
      return De;
    }(at);
    function So(st) {
      var dt = Kl();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Kl() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Vi = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = So(De);
      function De(Be) {
        return m.default(this, De), dt.call(this, Be);
      }
      return De;
    }(at), iu = 2e4;
    function cc(st) {
      return st >= 200 && st < 300;
    }
    function Pc(st) {
      return st && st.header && st.header.http_status;
    }
    function Jo(st) {
      var dt = st.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
      if (dt) {
        var De = {
          protocol: dt[1],
          host: dt[2],
          hostname: dt[3],
          port: dt[4],
          pathname: dt[5],
          search: dt[6],
          hash: dt[7],
          params: {}
        };
        if (De.search.length > 0) {
          var Be = De.search.substring(1);
          De.params = Be.split("&").map(function(Me) {
            return Me.split("=");
          }).reduce(function(Me, ut) {
            return Me.hasOwnProperty(ut[0]) ? Array.isArray(Me[ut[0]]) ? Me[ut[0]].push(ut[1]) : Me[ut[0]] = [Me[ut[0]], ut[1]] : Me[ut[0]] = ut[1], Me;
          }, {});
        }
        return De;
      }
      throw new at("Incorrect URI: " + st);
    }
    function Ka(st, dt) {
      var De = Jo(dt), Be = {
        method: st,
        host: De.host,
        path: De.pathname
      };
      return De.params && (Be.params = De.params), Be;
    }
    function y2(st, dt, De, Be, Me) {
      return {
        to: Ka(st, dt),
        headers: De,
        body: Be,
        grant: Me
      };
    }
    var qu = /* @__PURE__ */ function() {
      function st(dt, De, Be) {
        m.default(this, st), this.config = Be, this.transport = dt, this.pendingMessages = [], this.twilsock = De;
      }
      return I.default(st, [{
        key: "saveMessage",
        value: function(De) {
          var Be = this;
          return new Promise(function(Me, ut) {
            var Ve = {
              message: De,
              resolve: Me,
              reject: ut,
              alreadyRejected: !1,
              timeout: setTimeout(function() {
                qe.debug("request is timed out"), ut(new at("request '".concat(De.to.method, "' to '").concat(De.to.host, "' timed out"))), Ve.alreadyRejected = !0;
              }, iu)
            };
            Be.pendingMessages.push(Ve);
          });
        }
      }, {
        key: "sendPendingMessages",
        value: function() {
          for (var De = this, Be = function() {
            var Ve = De.pendingMessages[0];
            if (!Ve.alreadyRejected)
              try {
                var Kt = Ve.message;
                De.actualSend(Kt).then(function(qt) {
                  return Ve.resolve(qt);
                }).catch(function(qt) {
                  return Ve.reject(qt);
                }), clearTimeout(Ve.timeout);
              } catch (qt) {
                return qe.debug("Failed to send pending message", qt), "break";
              }
            De.pendingMessages.splice(0, 1);
          }; this.pendingMessages.length > 0; ) {
            var Me = Be();
            if (Me === "break") break;
          }
        }
      }, {
        key: "rejectPendingMessages",
        value: function() {
          var De = this;
          this.pendingMessages.forEach(function(Be) {
            Be.reject(new Vi(
              // @todo Error Unhandled promise rejection!
              "Unable to connect: " + De.twilsock.getTerminationReason
            )), Be.alreadyRejected = !0, clearTimeout(Be.timeout);
          }), this.pendingMessages.splice(0, this.pendingMessages.length);
        }
      }, {
        key: "actualSend",
        value: function() {
          var dt = A.default(/* @__PURE__ */ k.default.mark(function Be(Me) {
            var ut, Ve, Kt, qt, vr, _e, Pe, Q;
            return k.default.wrap(function(J) {
              for (; ; )
                switch (J.prev = J.next) {
                  case 0:
                    return Ve = Me.to, Kt = Me.headers, qt = Me.body, vr = (ut = Me.grant) !== null && ut !== void 0 ? ut : this.config.activeGrant, _e = {
                      host: Ve.host,
                      path: Ve.path,
                      method: Ve.method,
                      params: Ve.params,
                      headers: Kt
                    }, Pe = new ft(vr, Kt["Content-Type"] || "application/json", _e), qe.trace("Sending upstream message", Pe), J.next = 9, this.transport.sendWithReply(Pe, qt);
                  case 9:
                    if (Q = J.sent, qe.trace("Received upstream message response", Q), !(Pc(Q) && !cc(Q.header.http_status.code))) {
                      J.next = 13;
                      break;
                    }
                    throw new Vu(Q.header.http_status.code, Q.header.http_status.status, Q.body);
                  case 13:
                    return J.abrupt("return", {
                      status: Q.header.http_status,
                      headers: Q.header.http_headers,
                      body: Q.body
                    });
                  case 14:
                  case "end":
                    return J.stop();
                }
            }, Be, this);
          }));
          function De(Be) {
            return dt.apply(this, arguments);
          }
          return De;
        }()
        /**
         * Send an upstream message
         * @param {string} method The upstream method
         * @param {string} url URL to send the message to
         * @param {object} [headers] The message headers
         * @param {any} [body] The message body
         * @param {string} [grant] The product grant
         * @returns {Promise<Result>} Result from remote side
         */
      }, {
        key: "send",
        value: function(De, Be) {
          var Me = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, ut = arguments.length > 3 ? arguments[3] : void 0, Ve = arguments.length > 4 ? arguments[4] : void 0;
          if (this.twilsock.isTerminalState)
            return Promise.reject(new Vi("Unable to connect: " + this.twilsock.getTerminationReason));
          var Kt = y2(De, Be, Me, ut, Ve);
          return this.twilsock.isConnected ? this.actualSend(Kt) : this.saveMessage(Kt);
        }
      }]), st;
    }(), dp = /* @__PURE__ */ function() {
      function st() {
        var dt = this;
        m.default(this, st), this._promise = new Promise(function(De, Be) {
          dt._resolve = De, dt._reject = Be;
        });
      }
      return I.default(st, [{
        key: "promise",
        get: function() {
          return this._promise;
        }
      }, {
        key: "update",
        value: function(De) {
          this._resolve(De);
        }
      }, {
        key: "set",
        value: function(De) {
          this._resolve(De);
        }
      }, {
        key: "fail",
        value: function(De) {
          this._reject(De);
        }
      }]), st;
    }(), Nd = /* @__PURE__ */ function() {
      function st(dt) {
        m.default(this, st), this.id = dt;
      }
      return I.default(st, null, [{
        key: "create",
        value: function(De) {
          if (De instanceof Object && "storage_id" in De)
            return new st(De.storage_id);
          throw new at('Field "storage_id" is missing');
        }
      }]), st;
    }(), Rc = /* @__PURE__ */ function() {
      function st() {
        return m.default(this, st), v.default(this, "initializedFlag", "twilio_twilsock_token_storage"), v.default(this, "tokenStoragePrefix", "twilio_continuation_token_"), st._instance || (this.initialize(), st._instance = this), st._instance;
      }
      return I.default(st, [{
        key: "sessionStorage",
        value: function() {
          try {
            return e.sessionStorage;
          } catch {
            return null;
          }
        }
      }, {
        key: "window",
        value: function() {
          try {
            return e.window;
          } catch {
            return null;
          }
        }
      }, {
        key: "storeToken",
        value: function(De, Be) {
          this.canStore() && this.sessionStorage.setItem(this.getKeyName(Be), De);
        }
      }, {
        key: "getStoredToken",
        value: function(De) {
          return this.canStore() ? this.sessionStorage.getItem(this.getKeyName(De)) : null;
        }
      }, {
        key: "initialize",
        value: function() {
          var De = this;
          if (this.canStore()) {
            var Be = this.sessionStorage.getItem(this.initializedFlag);
            Be && this.clear(), this.sessionStorage.setItem(this.initializedFlag, "true");
            var Me = this.sessionStorage.removeItem;
            this.window.addEventListener("unload", function() {
              Me(De.initializedFlag);
            });
          }
        }
      }, {
        key: "clear",
        value: function() {
          if (this.canStore()) {
            for (var De = [], Be = 0; Be < this.sessionStorage.length; Be++) {
              var Me = this.sessionStorage.key(Be);
              Me && Me.indexOf(this.tokenStoragePrefix) === 0 && De.push(Me);
            }
            var ut = this.sessionStorage.removeItem;
            De.forEach(function(Ve) {
              return ut(Ve);
            }), ut(this.initializedFlag);
          }
        }
      }, {
        key: "getKeyName",
        value: function(De) {
          return "".concat(this.tokenStoragePrefix).concat(De);
        }
      }, {
        key: "canStore",
        value: function() {
          return !!(this.sessionStorage && this.sessionStorage.length && this.window);
        }
      }]), st;
    }();
    v.default(Rc, "_instance", null);
    var Oc = new Rc(), Lo = /* @__PURE__ */ function() {
      function st(dt, De, Be, Me, ut, Ve) {
        m.default(this, st), this.title = dt, this.details = De, this.start = Be, this.type = ut, this.id = Ve, this.end = Me;
      }
      return I.default(st, [{
        key: "toTelemetryEvent",
        value: function() {
          var De = /* @__PURE__ */ new Date(), Be = this.start, Me = this.end ? this.end : De;
          if (Me < Be) {
            var ut = Me;
            Me = Be, Be = ut;
          }
          var Ve = Be.getTime() - De.getTime(), Kt = Me.getTime() - De.getTime(), qt = new vt(Ve, Kt, this.title, this.details, this.id, this.type);
          return qt;
        }
      }]), st;
    }();
    t.TelemetryPoint = void 0, function(st) {
      st[st.Start = 0] = "Start", st[st.End = 1] = "End";
    }(t.TelemetryPoint || (t.TelemetryPoint = {})), t.EventSendingLimitation = void 0, function(st) {
      st[st.MinEventsPortion = 0] = "MinEventsPortion", st[st.AnyEvents = 1] = "AnyEvents", st[st.AnyEventsIncludingUnfinished = 2] = "AnyEventsIncludingUnfinished";
    }(t.EventSendingLimitation || (t.EventSendingLimitation = {}));
    var Rl = /* @__PURE__ */ function() {
      function st(dt, De) {
        m.default(this, st), v.default(this, "minEventsPortionToSend", 50), v.default(this, "maxEventsPortionToSend", 100), v.default(this, "pendingEvents", /* @__PURE__ */ new Map()), v.default(this, "readyEvents", []), v.default(this, "hasInitializationFinished", !1), v.default(this, "_canSendTelemetry", !1), this.config = dt, this.packetInterface = De;
      }
      return I.default(st, [{
        key: "isTelemetryEnabled",
        get: function() {
          return this.config.confirmedCapabilities.has("telemetry.v1");
        }
      }, {
        key: "canSendTelemetry",
        get: function() {
          return this._canSendTelemetry && this.isTelemetryEnabled;
        },
        set: function(De) {
          qe.debug("TelemetryTracker.canSendTelemetry: ".concat(De, " TelemetryTracker.isTelemetryEnabled: ").concat(this.isTelemetryEnabled)), this._canSendTelemetry && !De && (this.pendingEvents.clear(), this.readyEvents = []), this._canSendTelemetry = De, De && this.sendTelemetry(t.EventSendingLimitation.AnyEvents), De && !this.hasInitializationFinished && (this.hasInitializationFinished = !0);
        }
        // Add complete event
      }, {
        key: "addTelemetryEvent",
        value: function(De) {
          !this.canSendTelemetry && this.hasInitializationFinished || this.readyEvents.push(De);
        }
        // Add incomplete event (with either starting or ending time point)
      }, {
        key: "addPartialEvent",
        value: function(De, Be, Me) {
          qe.debug("Adding ".concat(Me === t.TelemetryPoint.Start ? "starting" : "ending", " timepoint for '").concat(Be, "' event"));
          var ut = this.pendingEvents.has(Be);
          if (Me === t.TelemetryPoint.Start)
            ut && qe.debug("Overwriting starting point for '".concat(Be, "' event")), this.pendingEvents.set(Be, De);
          else {
            if (!ut) {
              qe.info("Could not find started event for '".concat(Be, "' event"));
              return;
            }
            this.addTelemetryEvent(this.merge(this.pendingEvents.get(Be), De)), this.pendingEvents.delete(Be);
          }
        }
      }, {
        key: "getTelemetryToSend",
        value: function(De) {
          return !this.canSendTelemetry || this.readyEvents.length == 0 ? [] : De == t.EventSendingLimitation.MinEventsPortion && this.readyEvents.length < this.minEventsPortionToSend ? [] : this.getTelemetryPortion(De == t.EventSendingLimitation.AnyEventsIncludingUnfinished);
        }
      }, {
        key: "getTelemetryPortion",
        value: function(De) {
          var Be = this, Me = Math.min(this.readyEvents.length, this.maxEventsPortionToSend), ut = this.readyEvents.splice(0, Me);
          return De && ut.length < this.maxEventsPortionToSend && this.pendingEvents.forEach(function(Ve, Kt) {
            if (!(ut.length >= Be.maxEventsPortionToSend)) {
              var qt = Be.pendingEvents.get(Kt);
              Be.pendingEvents.delete(Kt), ut.push(new Lo(
                "[UNFINISHED] ".concat(qt.title),
                // add prefix title to mark unfinished events for CleanSock
                qt.details,
                qt.start,
                null,
                // Not ended, on sending will be replaced with now
                qt.type,
                qt.id
              ));
            }
          }), ut;
        }
        // Merging 2 partial events:
        //   use start.startTime & end.endTime.
        // For other fields,
        //   if there are values in end, use them,
        //   else use values from start.
      }, {
        key: "merge",
        value: function(De, Be) {
          return new Lo(Be.title ? Be.title : De.title, Be.details ? Be.details : De.details, De.start, Be.end, Be.type ? Be.type : De.type, Be.id ? Be.id : De.id);
        }
      }, {
        key: "sendTelemetryIfMinimalPortionCollected",
        value: function() {
          this.sendTelemetry(t.EventSendingLimitation.MinEventsPortion);
        }
        // NB: getTelemetryToSend will return non-empty array only if we have already received initReply
        // and telemetry.v1 capability is enabled there.
      }, {
        key: "sendTelemetry",
        value: function(De) {
          var Be = this.getTelemetryToSend(De);
          if (Be.length !== 0)
            try {
              this.packetInterface.send(new _t(Be.map(function(Me) {
                return Me.toTelemetryEvent();
              })));
            } catch (Me) {
              qe.debug("Error while sending ".concat(Be.length, " telemetry events due to ").concat(Me, "; they will be resubmitted")), this.readyEvents = this.readyEvents.concat(Be);
            }
        }
      }]), st;
    }();
    function hs(st) {
      var dt = Bc();
      return function() {
        var Be = d.default(st), Me;
        if (dt) {
          var ut = d.default(this).constructor;
          Me = Reflect.construct(Be, arguments, ut);
        } else
          Me = Be.apply(this, arguments);
        return N.default(this, Me);
      };
    }
    function Bc() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Nc = function st() {
      m.default(this, st);
    };
    v.default(Nc, "TWILSOCK_CONNECT", "twilsock.sdk.connect"), v.default(Nc, "TWILSOCK_INIT", "twilsock.sdk.init"), t.TwilsockClient = /* @__PURE__ */ function(st) {
      L.default(De, st);
      var dt = hs(De);
      function De(Be, Me, ut) {
        var Ve;
        m.default(this, De), Ve = dt.call(this), v.default(M.default(Ve), "version", nt), v.default(M.default(Ve), "offlineStorageDeferred", new dp()), ut.continuationToken = ut.continuationToken ? ut.continuationToken : Oc.getStoredToken(Me);
        var Kt = Ve.config = new Rt(Be, Me, ut);
        qe.setLevel(Kt.logLevel);
        var qt = new Ho(Kt.url), vr = new kr(qt, Kt);
        return Ve.channel = new Kr(qt, vr, Kt), Ve.registrations = new Ic(vr), Ve.upstream = new qu(vr, Ve.channel, Kt), Ve.telemetryTracker = new Rl(Kt, vr), Ve.channel.on("initialized", function() {
          return Ve.telemetryTracker.canSendTelemetry = !0;
        }), qt.on("disconnected", function() {
          return Ve.telemetryTracker.canSendTelemetry = !1;
        }), Ve.registrations.on("registered", function(_e) {
          return Ve.emit("registered", _e);
        }), Ve.channel.on("message", function(_e, Pe) {
          return setTimeout(function() {
            return Ve.emit("message", _e, Pe);
          }, 0);
        }), Ve.channel.on("stateChanged", function(_e) {
          return setTimeout(function() {
            return Ve.emit("stateChanged", _e);
          }, 0);
        }), Ve.channel.on("connectionError", function(_e) {
          return setTimeout(function() {
            return Ve.emit("connectionError", _e);
          }, 0);
        }), Ve.channel.on("tokenAboutToExpire", function() {
          return setTimeout(function() {
            return Ve.emit("tokenAboutToExpire");
          }, 0);
        }), Ve.channel.on("tokenExpired", function() {
          return setTimeout(function() {
            return Ve.emit("tokenExpired");
          }, 0);
        }), Ve.channel.on("connected", function() {
          return Ve.registrations.updateRegistrations();
        }), Ve.channel.on("connected", function() {
          return Ve.upstream.sendPendingMessages();
        }), Ve.channel.on("connected", function() {
          return setTimeout(function() {
            return Ve.emit("connected");
          }, 0);
        }), Ve.channel.on("beforeConnect", function() {
          return Ve.telemetryTracker.addPartialEvent(new Lo("Establish WebSocket connection", "", /* @__PURE__ */ new Date()), Nc.TWILSOCK_CONNECT, t.TelemetryPoint.Start);
        }), Ve.channel.on("connected", function() {
          return Ve.telemetryTracker.addPartialEvent(new Lo("Establish WebSocket connection", "", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), Nc.TWILSOCK_CONNECT, t.TelemetryPoint.End);
        }), Ve.channel.on("beforeSendInit", function() {
          return Ve.telemetryTracker.addPartialEvent(new Lo("Send Twilsock init", "", /* @__PURE__ */ new Date()), Nc.TWILSOCK_INIT, t.TelemetryPoint.Start);
        }), Ve.channel.on("initialized", function() {
          return Ve.telemetryTracker.addPartialEvent(new Lo("Send Twilsock init", "Succeeded", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), Nc.TWILSOCK_INIT, t.TelemetryPoint.End);
        }), Ve.channel.on("sendInitFailed", function() {
          return Ve.telemetryTracker.addPartialEvent(new Lo("Send Twilsock init", "Failed", /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()), Nc.TWILSOCK_INIT, t.TelemetryPoint.End);
        }), Ve.channel.on("initialized", function(_e) {
          Ve.handleStorageId(Me, _e), Oc.storeToken(_e.continuationToken, Me), setTimeout(function() {
            return Ve.emit("initialized", _e);
          }, 0);
        }), Ve.channel.on("disconnected", function() {
          return setTimeout(function() {
            return Ve.emit("disconnected");
          }, 0);
        }), Ve.channel.on("disconnected", function() {
          return Ve.upstream.rejectPendingMessages();
        }), Ve.channel.on("disconnected", function() {
          return Ve.offlineStorageDeferred.fail(new at("Client disconnected"));
        }), Ve.offlineStorageDeferred.promise.catch(function() {
        }), Ve;
      }
      return I.default(De, [{
        key: "emit",
        value: function(Me) {
          for (var ut, Ve = arguments.length, Kt = new Array(Ve > 1 ? Ve - 1 : 0), qt = 1; qt < Ve; qt++)
            Kt[qt - 1] = arguments[qt];
          return qe.debug("Emitting ".concat(Me.toString(), "(").concat(Kt.map(function(vr) {
            return JSON.stringify(vr);
          }).join(", "), ")")), (ut = B.default(d.default(De.prototype), "emit", this)).call.apply(ut, [this, Me].concat(Kt));
        }
      }, {
        key: "handleStorageId",
        value: function(Me, ut) {
          if (!ut.offlineStorage)
            this.offlineStorageDeferred.fail(new at("No offline storage id"));
          else if (ut.offlineStorage.hasOwnProperty(Me))
            try {
              this.offlineStorageDeferred.set(Nd.create(ut.offlineStorage[Me])), qe.debug("Offline storage for '".concat(Me, "' product: ").concat(JSON.stringify(ut.offlineStorage[Me]), "."));
            } catch (Ve) {
              this.offlineStorageDeferred.fail(new at("Failed to parse offline storage for ".concat(Me, " ").concat(JSON.stringify(ut.offlineStorage[Me]), ". ").concat(Ve, ".")));
            }
          else
            this.offlineStorageDeferred.fail(new at("No offline storage id for '".concat(Me, "' product: ").concat(JSON.stringify(ut.offlineStorage))));
        }
        /**
         * Get offline storage ID
         * @returns {Promise}
         */
      }, {
        key: "storageId",
        value: function() {
          return this.offlineStorageDeferred.promise;
        }
        /**
         * Indicates if twilsock is connected now
         * @returns {Boolean}
         */
      }, {
        key: "isConnected",
        get: function() {
          return this.channel.isConnected;
        }
        /**
         * Current state
         * @returns {ConnectionState}
         */
      }, {
        key: "state",
        get: function() {
          return this.channel.state;
        }
        /**
         * Update token
         * @param {String} token
         * @returns {Promise}
         */
      }, {
        key: "updateToken",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve) {
            return k.default.wrap(function(qt) {
              for (; ; )
                switch (qt.prev = qt.next) {
                  case 0:
                    if (qe.trace("updating token '".concat(Ve, "'")), this.config.token !== Ve) {
                      qt.next = 3;
                      break;
                    }
                    return qt.abrupt("return");
                  case 3:
                    return this.config.updateToken(Ve), qt.next = 6, this.channel.updateToken(Ve);
                  case 6:
                    return qt.abrupt("return", qt.sent);
                  case 7:
                  case "end":
                    return qt.stop();
                }
            }, ut, this);
          }));
          function Me(ut) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Updates notification context.
         * This method shouldn't be used anyone except twilio notifications library
         * @param contextId id of notification context
         * @param context value of notification context
         * @private
         */
      }, {
        key: "setNotificationsContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt) {
            return k.default.wrap(function(vr) {
              for (; ; )
                switch (vr.prev = vr.next) {
                  case 0:
                    return vr.next = 2, this.registrations.setNotificationsContext(Ve, Kt);
                  case 2:
                  case "end":
                    return vr.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Remove notification context.
         * This method shouldn't be used anyone except twilio notifications library
         * @param contextId id of notification context
         * @private
         */
      }, {
        key: "removeNotificationsContext",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve) {
            return k.default.wrap(function(qt) {
              for (; ; )
                switch (qt.prev = qt.next) {
                  case 0:
                    return qt.next = 2, this.registrations.removeNotificationsContext(Ve);
                  case 2:
                  case "end":
                    return qt.stop();
                }
            }, ut, this);
          }));
          function Me(ut) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Connect to the server
         * @fires Twilsock#connected
         * @public
         * @returns {void}
         */
      }, {
        key: "connect",
        value: function() {
          return this.channel.connect();
        }
        /**
         * Disconnect from the server
         * @fires Twilsock#disconnected
         * @public
         * @returns {Promise}
         */
      }, {
        key: "disconnect",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut() {
            return k.default.wrap(function(Kt) {
              for (; ; )
                switch (Kt.prev = Kt.next) {
                  case 0:
                    return this.telemetryTracker.sendTelemetry(t.EventSendingLimitation.AnyEventsIncludingUnfinished), Kt.next = 3, this.channel.disconnect();
                  case 3:
                    return Kt.abrupt("return", Kt.sent);
                  case 4:
                  case "end":
                    return Kt.stop();
                }
            }, ut, this);
          }));
          function Me() {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Get HTTP request to upstream service
         * @param {string} url Upstream service url
         * @param {headers} headers Set of custom headers
         * @param {string} [grant] The product grant
         * @returns {Promise}
         */
      }, {
        key: "get",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt, qt) {
            return k.default.wrap(function(_e) {
              for (; ; )
                switch (_e.prev = _e.next) {
                  case 0:
                    return this.telemetryTracker.sendTelemetry(t.EventSendingLimitation.AnyEvents), _e.next = 3, this.upstream.send("GET", Ve, Kt, void 0, qt);
                  case 3:
                    return _e.abrupt("return", _e.sent);
                  case 4:
                  case "end":
                    return _e.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve, Kt) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Post HTTP request to upstream service
         * @param {string} url Upstream service url
         * @param {headers} headers Set of custom headers
         * @param {body} body Body to send
         * @param {string} [grant] The product grant
         * @returns {Promise}
         */
      }, {
        key: "post",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt, qt, vr) {
            return k.default.wrap(function(Pe) {
              for (; ; )
                switch (Pe.prev = Pe.next) {
                  case 0:
                    return this.telemetryTracker.sendTelemetry(t.EventSendingLimitation.AnyEvents), Pe.next = 3, this.upstream.send("POST", Ve, Kt, qt, vr);
                  case 3:
                    return Pe.abrupt("return", Pe.sent);
                  case 4:
                  case "end":
                    return Pe.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve, Kt, qt) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Put HTTP request to upstream service
         * @param {string} url Upstream service url
         * @param {headers} headers Set of custom headers
         * @param {body} body Body to send
         * @param {string} [grant] The product grant
         * @returns {Promise}
         */
      }, {
        key: "put",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt, qt, vr) {
            return k.default.wrap(function(Pe) {
              for (; ; )
                switch (Pe.prev = Pe.next) {
                  case 0:
                    return this.telemetryTracker.sendTelemetry(t.EventSendingLimitation.AnyEvents), Pe.next = 3, this.upstream.send("PUT", Ve, Kt, qt, vr);
                  case 3:
                    return Pe.abrupt("return", Pe.sent);
                  case 4:
                  case "end":
                    return Pe.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve, Kt, qt) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Delete HTTP request to upstream service
         * @param {string} url Upstream service url
         * @param {headers} headers Set of custom headers
         * @param {body} body Body to send
         * @param {string} [grant] The product grant
         * @returns {Promise}
         */
      }, {
        key: "delete",
        value: function() {
          var Be = A.default(/* @__PURE__ */ k.default.mark(function ut(Ve, Kt, qt, vr) {
            return k.default.wrap(function(Pe) {
              for (; ; )
                switch (Pe.prev = Pe.next) {
                  case 0:
                    return this.telemetryTracker.sendTelemetry(t.EventSendingLimitation.AnyEvents), Pe.next = 3, this.upstream.send("DELETE", Ve, Kt, qt, vr);
                  case 3:
                    return Pe.abrupt("return", Pe.sent);
                  case 4:
                  case "end":
                    return Pe.stop();
                }
            }, ut, this);
          }));
          function Me(ut, Ve, Kt, qt) {
            return Be.apply(this, arguments);
          }
          return Me;
        }()
        /**
         * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
         * @param {TelemetryEventDescription} event Event details.
         * @returns {void}
         */
      }, {
        key: "addTelemetryEvent",
        value: function(Me) {
          this.telemetryTracker.addTelemetryEvent(Me), this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
        }
        /**
         * Submits internal telemetry event. Not to be used for any customer and/or sensitive data.
         * @param {TelemetryEventDescription} event Event details.
         * @param {string} eventKey Unique event key.
         * @param {TelemetryPoint} point Is this partial event for start or end of measurement.
         * @returns {void}
         */
      }, {
        key: "addPartialTelemetryEvent",
        value: function(Me, ut, Ve) {
          this.telemetryTracker.addPartialEvent(Me, ut, Ve), Ve === t.TelemetryPoint.End && this.telemetryTracker.sendTelemetryIfMinimalPortionCollected();
        }
      }]), De;
    }(V), t.TwilsockClient = z([p.validateConstructorTypes(p.nonEmptyString, p.nonEmptyString, [p.pureObject, "undefined", p.literal(null)]), W("design:paramtypes", [String, String, Object])], t.TwilsockClient);
    var b2 = /* @__PURE__ */ function() {
      function st(dt) {
        m.default(this, st), this.product = dt, this.type = "ers", this.notification_protocol_version = 0, this.message_types = [];
      }
      return I.default(st, [{
        key: "populateInitRegistrations",
        value: function(De) {
          var Be = new Set(this.message_types);
          for (var Me in De)
            Be.add(De[Me]);
          this.message_types = Array.from(Be);
        }
      }]), st;
    }();
    t.InitRegistration = b2, t.TelemetryEventDescription = Lo, t.TelemetryTracker = Rl, t.TransportUnavailableError = Vi, t.Twilsock = t.TwilsockClient, t.TwilsockError = at;
  }(zX)), zX;
}
var vAe = {}, DQ, yAe;
function Xrt() {
  if (yAe) return DQ;
  yAe = 1;
  var t = Go(), e = Wa(), r = No(), n = Ba(), a = TM(), i = OG(), o = EG(), s = ru(), l = SM(), c = Object.assign, u = Object.defineProperty, f = e([].concat);
  return DQ = !c || n(function() {
    if (t && c({ b: 1 }, c(u({}, "a", {
      enumerable: !0,
      get: function() {
        u(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), { b: 2 })).b !== 1) return !0;
    var h = {}, p = {}, g = Symbol("assign detection"), y = "abcdefghijklmnopqrst";
    return h[g] = 7, y.split("").forEach(function(b) {
      p[b] = b;
    }), c({}, h)[g] !== 7 || a(c({}, p)).join("") !== y;
  }) ? function(p, g) {
    for (var y = s(p), b = arguments.length, w = 1, _ = i.f, C = o.f; b > w; )
      for (var x = l(arguments[w++]), S = _ ? f(a(x), _(x)) : a(x), A = S.length, I = 0, M; A > I; )
        M = S[I++], (!t || r(C, x, M)) && (y[M] = x[M]);
    return y;
  } : c, DQ;
}
var bAe;
function Hme() {
  if (bAe) return vAe;
  bAe = 1;
  var t = Ya(), e = Xrt();
  return t({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== e }, {
    assign: e
  }), vAe;
}
var NB = {};
/*
@license
Copyright (c) 2021 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/
var xAe;
function Qrt() {
  if (xAe) return NB;
  xAe = 1, Object.defineProperty(NB, "__esModule", { value: !0 });
  var t = GM(), e = zy(), r = Gy(), n = l6(), a = $me(), i = Wy(), o = Hy(), s = np(), l = c6();
  function c(W) {
    return W && typeof W == "object" && "default" in W ? W : { default: W };
  }
  var u = /* @__PURE__ */ c(t), f = /* @__PURE__ */ c(e), h = /* @__PURE__ */ c(r), p = /* @__PURE__ */ c(n), g = /* @__PURE__ */ c(a), y = /* @__PURE__ */ c(i), b = /* @__PURE__ */ c(o), w = /* @__PURE__ */ c(s), _ = /* @__PURE__ */ c(l), C;
  function x() {
  }
  x.prototype = /* @__PURE__ */ Object.create(null);
  function S() {
    S.init.call(this);
  }
  S.EventEmitter = S, S.usingDomains = !1, S.prototype.domain = void 0, S.prototype._events = void 0, S.prototype._maxListeners = void 0, S.defaultMaxListeners = 10, S.init = function() {
    this.domain = null, S.usingDomains && C.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new x(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, S.prototype.setMaxListeners = function(U) {
    if (typeof U != "number" || U < 0 || isNaN(U))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = U, this;
  };
  function A(W) {
    return W._maxListeners === void 0 ? S.defaultMaxListeners : W._maxListeners;
  }
  S.prototype.getMaxListeners = function() {
    return A(this);
  };
  function I(W, U, Z) {
    if (U)
      W.call(Z);
    else
      for (var V = W.length, Y = G(W, V), ge = 0; ge < V; ++ge)
        Y[ge].call(Z);
  }
  function M(W, U, Z, V) {
    if (U)
      W.call(Z, V);
    else
      for (var Y = W.length, ge = G(W, Y), ce = 0; ce < Y; ++ce)
        ge[ce].call(Z, V);
  }
  function B(W, U, Z, V, Y) {
    if (U)
      W.call(Z, V, Y);
    else
      for (var ge = W.length, ce = G(W, ge), ee = 0; ee < ge; ++ee)
        ce[ee].call(Z, V, Y);
  }
  function L(W, U, Z, V, Y, ge) {
    if (U)
      W.call(Z, V, Y, ge);
    else
      for (var ce = W.length, ee = G(W, ce), Se = 0; Se < ce; ++Se)
        ee[Se].call(Z, V, Y, ge);
  }
  function N(W, U, Z, V) {
    if (U)
      W.apply(Z, V);
    else
      for (var Y = W.length, ge = G(W, Y), ce = 0; ce < Y; ++ce)
        ge[ce].apply(Z, V);
  }
  S.prototype.emit = function(U) {
    var Z, V, Y, ge, ce, ee, Se, Ce = U === "error";
    if (ee = this._events, ee)
      Ce = Ce && ee.error == null;
    else if (!Ce)
      return !1;
    if (Se = this.domain, Ce) {
      if (Z = arguments[1], Se)
        Z || (Z = new Error('Uncaught, unspecified "error" event')), Z.domainEmitter = this, Z.domain = Se, Z.domainThrown = !1, Se.emit("error", Z);
      else {
        if (Z instanceof Error)
          throw Z;
        var we = new Error('Uncaught, unspecified "error" event. (' + Z + ")");
        throw we.context = Z, we;
      }
      return !1;
    }
    if (V = ee[U], !V)
      return !1;
    var We = typeof V == "function";
    switch (Y = arguments.length, Y) {
      // fast cases
      case 1:
        I(V, We, this);
        break;
      case 2:
        M(V, We, this, arguments[1]);
        break;
      case 3:
        B(V, We, this, arguments[1], arguments[2]);
        break;
      case 4:
        L(V, We, this, arguments[1], arguments[2], arguments[3]);
        break;
      // slower
      default:
        for (ge = new Array(Y - 1), ce = 1; ce < Y; ce++)
          ge[ce - 1] = arguments[ce];
        N(V, We, this, ge);
    }
    return !0;
  };
  function d(W, U, Z, V) {
    var Y, ge, ce;
    if (typeof Z != "function")
      throw new TypeError('"listener" argument must be a function');
    if (ge = W._events, ge ? (ge.newListener && (W.emit(
      "newListener",
      U,
      Z.listener ? Z.listener : Z
    ), ge = W._events), ce = ge[U]) : (ge = W._events = new x(), W._eventsCount = 0), !ce)
      ce = ge[U] = Z, ++W._eventsCount;
    else if (typeof ce == "function" ? ce = ge[U] = V ? [Z, ce] : [ce, Z] : V ? ce.unshift(Z) : ce.push(Z), !ce.warned && (Y = A(W), Y && Y > 0 && ce.length > Y)) {
      ce.warned = !0;
      var ee = new Error("Possible EventEmitter memory leak detected. " + ce.length + " " + U + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ee.name = "MaxListenersExceededWarning", ee.emitter = W, ee.type = U, ee.count = ce.length, m(ee);
    }
    return W;
  }
  function m(W) {
    typeof console.warn == "function" ? console.warn(W) : console.log(W);
  }
  S.prototype.addListener = function(U, Z) {
    return d(this, U, Z, !1);
  }, S.prototype.on = S.prototype.addListener, S.prototype.prependListener = function(U, Z) {
    return d(this, U, Z, !0);
  };
  function v(W, U, Z) {
    var V = !1;
    function Y() {
      W.removeListener(U, Y), V || (V = !0, Z.apply(W, arguments));
    }
    return Y.listener = Z, Y;
  }
  S.prototype.once = function(U, Z) {
    if (typeof Z != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(U, v(this, U, Z)), this;
  }, S.prototype.prependOnceListener = function(U, Z) {
    if (typeof Z != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(U, v(this, U, Z)), this;
  }, S.prototype.removeListener = function(U, Z) {
    var V, Y, ge, ce, ee;
    if (typeof Z != "function")
      throw new TypeError('"listener" argument must be a function');
    if (Y = this._events, !Y)
      return this;
    if (V = Y[U], !V)
      return this;
    if (V === Z || V.listener && V.listener === Z)
      --this._eventsCount === 0 ? this._events = new x() : (delete Y[U], Y.removeListener && this.emit("removeListener", U, V.listener || Z));
    else if (typeof V != "function") {
      for (ge = -1, ce = V.length; ce-- > 0; )
        if (V[ce] === Z || V[ce].listener && V[ce].listener === Z) {
          ee = V[ce].listener, ge = ce;
          break;
        }
      if (ge < 0)
        return this;
      if (V.length === 1) {
        if (V[0] = void 0, --this._eventsCount === 0)
          return this._events = new x(), this;
        delete Y[U];
      } else
        O(V, ge);
      Y.removeListener && this.emit("removeListener", U, ee || Z);
    }
    return this;
  }, S.prototype.off = function(W, U) {
    return this.removeListener(W, U);
  }, S.prototype.removeAllListeners = function(U) {
    var Z, V;
    if (V = this._events, !V)
      return this;
    if (!V.removeListener)
      return arguments.length === 0 ? (this._events = new x(), this._eventsCount = 0) : V[U] && (--this._eventsCount === 0 ? this._events = new x() : delete V[U]), this;
    if (arguments.length === 0) {
      for (var Y = Object.keys(V), ge = 0, ce; ge < Y.length; ++ge)
        ce = Y[ge], ce !== "removeListener" && this.removeAllListeners(ce);
      return this.removeAllListeners("removeListener"), this._events = new x(), this._eventsCount = 0, this;
    }
    if (Z = V[U], typeof Z == "function")
      this.removeListener(U, Z);
    else if (Z)
      do
        this.removeListener(U, Z[Z.length - 1]);
      while (Z[0]);
    return this;
  }, S.prototype.listeners = function(U) {
    var Z, V, Y = this._events;
    return Y ? (Z = Y[U], Z ? typeof Z == "function" ? V = [Z.listener || Z] : V = H(Z) : V = []) : V = [], V;
  }, S.listenerCount = function(W, U) {
    return typeof W.listenerCount == "function" ? W.listenerCount(U) : k.call(W, U);
  }, S.prototype.listenerCount = k;
  function k(W) {
    var U = this._events;
    if (U) {
      var Z = U[W];
      if (typeof Z == "function")
        return 1;
      if (Z)
        return Z.length;
    }
    return 0;
  }
  S.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  function O(W, U) {
    for (var Z = U, V = Z + 1, Y = W.length; V < Y; Z += 1, V += 1)
      W[Z] = W[V];
    W.pop();
  }
  function G(W, U) {
    for (var Z = new Array(U); U--; )
      Z[U] = W[U];
    return Z;
  }
  function H(W) {
    for (var U = new Array(W.length), Z = 0; Z < U.length; ++Z)
      U[Z] = W[Z].listener || W[Z];
    return U;
  }
  function j(W) {
    var U = F();
    return function() {
      var V = w.default(W), Y;
      if (U) {
        var ge = w.default(this).constructor;
        Y = Reflect.construct(V, arguments, ge);
      } else
        Y = V.apply(this, arguments);
      return b.default(this, Y);
    };
  }
  function F() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var z = /* @__PURE__ */ function(W) {
    y.default(Z, W);
    var U = j(Z);
    function Z() {
      var V;
      return f.default(this, Z), V = U.call(this), _.default(p.default(V), "eventHistory", /* @__PURE__ */ new Map()), V;
    }
    return h.default(Z, [{
      key: "on",
      value: function(Y, ge) {
        return g.default(w.default(Z.prototype), "on", this).call(this, Y, ge);
      }
    }, {
      key: "once",
      value: function(Y, ge) {
        return g.default(w.default(Z.prototype), "once", this).call(this, Y, ge);
      }
    }, {
      key: "off",
      value: function(Y, ge) {
        return g.default(w.default(Z.prototype), "off", this).call(this, Y, ge);
      }
    }, {
      key: "emit",
      value: function(Y) {
        for (var ge, ce = arguments.length, ee = new Array(ce > 1 ? ce - 1 : 0), Se = 1; Se < ce; Se++)
          ee[Se - 1] = arguments[Se];
        return this.eventHistory.set(Y, ee), (ge = g.default(w.default(Z.prototype), "emit", this)).call.apply(ge, [this, Y].concat(ee));
      }
    }, {
      key: "addListener",
      value: function(Y, ge) {
        return g.default(w.default(Z.prototype), "addListener", this).call(this, Y, ge);
      }
    }, {
      key: "removeListener",
      value: function(Y, ge) {
        return g.default(w.default(Z.prototype), "removeListener", this).call(this, Y, ge);
      }
    }, {
      key: "addListenerWithReplay",
      value: function(Y, ge) {
        var ce = this.eventHistory.get(Y);
        return ce !== void 0 && ge.apply(void 0, u.default(ce)), this.addListener(Y, ge);
      }
    }, {
      key: "onWithReplay",
      value: function(Y, ge) {
        return this.addListenerWithReplay(Y, ge);
      }
    }, {
      key: "onceWithReplay",
      value: function(Y, ge) {
        var ce = this.eventHistory.get(Y);
        return ce !== void 0 ? (ge.apply(void 0, u.default(ce)), this) : g.default(w.default(Z.prototype), "once", this).call(this, Y, ge);
      }
    }]), Z;
  }(S);
  return NB.ReplayEventEmitter = z, NB;
}
var CAe = {}, wAe;
function ent() {
  if (wAe) return CAe;
  wAe = 1;
  var t = Ya(), e = Wa(), r = Sf(), n = ru(), a = nu(), i = zme(), o = Vl(), s = Ba(), l = Gme(), c = LG(), u = zrt(), f = Grt(), h = D8(), p = Wrt(), g = [], y = e(g.sort), b = e(g.push), w = s(function() {
    g.sort(void 0);
  }), _ = s(function() {
    g.sort(null);
  }), C = c("sort"), x = !s(function() {
    if (h) return h < 70;
    if (!(u && u > 3)) {
      if (f) return !0;
      if (p) return p < 603;
      var I = "", M, B, L, N;
      for (M = 65; M < 76; M++) {
        switch (B = String.fromCharCode(M), M) {
          case 66:
          case 69:
          case 70:
          case 72:
            L = 3;
            break;
          case 68:
          case 71:
            L = 4;
            break;
          default:
            L = 2;
        }
        for (N = 0; N < 47; N++)
          g.push({ k: B + N, v: L });
      }
      for (g.sort(function(d, m) {
        return m.v - d.v;
      }), N = 0; N < g.length; N++)
        B = g[N].k.charAt(0), I.charAt(I.length - 1) !== B && (I += B);
      return I !== "DGBEFHACIJK";
    }
  }), S = w || !_ || !C || !x, A = function(I) {
    return function(M, B) {
      return B === void 0 ? -1 : M === void 0 ? 1 : I !== void 0 ? +I(M, B) || 0 : o(M) > o(B) ? 1 : -1;
    };
  };
  return t({ target: "Array", proto: !0, forced: S }, {
    sort: function(M) {
      M !== void 0 && r(M);
      var B = n(this);
      if (x) return M === void 0 ? y(B) : y(B, M);
      var L = [], N = a(B), d, m;
      for (m = 0; m < N; m++)
        m in B && b(L, B[m]);
      for (l(L, A(M)), d = a(L), m = 0; m < d; ) B[m] = L[m++];
      for (; m < N; ) i(B, m++);
      return B;
    }
  }), CAe;
}
/*
@license
The following license applies to all parts of this software except as
documented below.

    Copyright (c) 2016, Twilio, inc.
    All rights reserved.

    Redistribution and use in source and binary forms, with or without
    modification, are permitted provided that the following conditions are
    met:

      1. Redistributions of source code must retain the above copyright
         notice, this list of conditions and the following disclaimer.

      2. Redistributions in binary form must reproduce the above copyright
         notice, this list of conditions and the following disclaimer in
         the documentation and/or other materials provided with the
         distribution.

      3. Neither the name of Twilio nor the names of its contributors may
         be used to endorse or promote products derived from this software
         without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
    "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
    LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
    A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
    HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
    LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
    DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
    THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
    (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
    OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

This software includes loglevel under the following license.

    Copyright (c) 2013 Tim Perry

    Permission is hereby granted, free of charge, to any person
    obtaining a copy of this software and associated documentation
    files (the "Software"), to deal in the Software without
    restriction, including without limitation the rights to use,
    copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the
    Software is furnished to do so, subject to the following
    conditions:

    The above copyright notice and this permission notice shall be
    included in all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
    OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
    HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
    WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
    OTHER DEALINGS IN THE SOFTWARE.

This software includes Backoff library under the following license

    Copyright (C) 2012 Mathieu Turcotte

    Permission is hereby granted, free of charge, to any person obtaining a copy of
    this software and associated documentation files (the "Software"), to deal in
    the Software without restriction, including without limitation the rights to
    use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
    of the Software, and to permit persons to whom the Software is furnished to do
    so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.

This software includes Event-to-Promise library under the following license

    Copyright (c) 2014, Julien Fontanet <julien.fontanet@isonoe.net>.

    Permission to use, copy, modify, and/or distribute this software for any purpose
    with or without fee is hereby granted, provided that the above copyright notice
    and this permission notice appear in all copies.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
    FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
    OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
    TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
    THIS SOFTWARE.

*/
var SAe;
function tnt() {
  if (SAe) return gu;
  SAe = 1, Object.defineProperty(gu, "__esModule", { value: !0 }), gme(), DG(), MM(), xme(), PM(), Cme(), G8(), s6();
  var t = OM(), e = zy(), r = Gy(), n = l6(), a = Wy(), i = Hy(), o = np(), s = c6();
  jG(), u6(), d6();
  var l = FM(), c = rp(), u = HM(), f = Wme();
  WM();
  var h = nW();
  Eme(), f6(), $G(), Nme(), U8(), h6();
  var p = V8();
  UG(), Ome(), VG(), Bme();
  var g = WG();
  vg(), VM(), H8(), Hme(), p6(), Jrt();
  var y = UM();
  rW();
  var b = /* @__PURE__ */ QG(), w = $me();
  KG();
  var _ = Qrt(), C = GM();
  ent();
  var x = Zrt();
  function S(_e) {
    return _e && typeof _e == "object" && "default" in _e ? _e : { default: _e };
  }
  function A(_e) {
    if (_e && _e.__esModule) return _e;
    var Pe = /* @__PURE__ */ Object.create(null);
    return _e && Object.keys(_e).forEach(function(Q) {
      if (Q !== "default") {
        var te = Object.getOwnPropertyDescriptor(_e, Q);
        Object.defineProperty(Pe, Q, te.get ? te : {
          enumerable: !0,
          get: function() {
            return _e[Q];
          }
        });
      }
    }), Pe.default = _e, Object.freeze(Pe);
  }
  var I = /* @__PURE__ */ S(t), M = /* @__PURE__ */ S(e), B = /* @__PURE__ */ S(r), L = /* @__PURE__ */ S(n), N = /* @__PURE__ */ S(a), d = /* @__PURE__ */ S(i), m = /* @__PURE__ */ S(o), v = /* @__PURE__ */ S(s), k = /* @__PURE__ */ S(l), O = /* @__PURE__ */ S(c), G = /* @__PURE__ */ S(h), H = /* @__PURE__ */ A(p), j = /* @__PURE__ */ S(g), F = /* @__PURE__ */ A(b), z = /* @__PURE__ */ S(w), W = /* @__PURE__ */ S(C), U = /* @__PURE__ */ A(x);
  function Z(_e, Pe, Q, te) {
    var J = arguments.length, fe = J < 3 ? Pe : te === null ? te = Object.getOwnPropertyDescriptor(Pe, Q) : te, le;
    if ((typeof Reflect > "u" ? "undefined" : O.default(Reflect)) === "object" && typeof Reflect.decorate == "function") fe = Reflect.decorate(_e, Pe, Q, te);
    else for (var ke = _e.length - 1; ke >= 0; ke--)
      (le = _e[ke]) && (fe = (J < 3 ? le(fe) : J > 3 ? le(Pe, Q, fe) : le(Pe, Q)) || fe);
    return J > 3 && fe && Object.defineProperty(Pe, Q, fe), fe;
  }
  function V(_e, Pe) {
    if ((typeof Reflect > "u" ? "undefined" : O.default(Reflect)) === "object" && typeof Reflect.metadata == "function") return Reflect.metadata(_e, Pe);
  }
  var Y = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), this.base = Pe, this.args = new Array(), this.paths = new Array();
    }
    return B.default(_e, [{
      key: "pathSegment",
      value: function(Q) {
        return this.paths.push(encodeURIComponent(Q)), this;
      }
    }, {
      key: "queryParam",
      value: function(Q, te) {
        return typeof te < "u" && this.args.push(encodeURIComponent(Q) + "=" + encodeURIComponent(te)), this;
      }
    }, {
      key: "build",
      value: function() {
        var Q = this.base;
        return this.paths.length && (Q += "/" + this.paths.join("/")), this.args.length && (Q += "?" + this.args.join("&")), Q;
      }
    }]), _e;
  }();
  function ge(_e) {
    var Pe = ce();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function ce() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var ee = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = ge(Q);
    function Q(te) {
      var J, fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, le = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
      return M.default(this, Q), J = Pe.call(this), J.name = J.constructor.name, J.message = "".concat(te, " (status: ").concat(fe, ", code: ").concat(le, ")"), J.status = fe, J.code = le, J;
    }
    return B.default(Q);
  }(/* @__PURE__ */ G.default(Error)), Se = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = ge(Q);
    function Q(te) {
      var J, fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, le = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ke = arguments.length > 3 ? arguments[3] : void 0;
      return M.default(this, Q), J = Pe.call(this, te, fe, le), J.body = ke, J;
    }
    return B.default(Q);
  }(ee);
  function Ce(_e) {
    return JSON.parse(JSON.stringify(_e));
  }
  function we(_e) {
    var Pe = _e === void 0 || Fe(_e);
    if (!Pe)
      throw new ee("Invalid pageSize parameter. Expected a positive integer, was '".concat(_e, "'."), 400, 20007);
  }
  function We(_e) {
    return !isNaN(parseInt(_e)) && isFinite(_e);
  }
  function Fe(_e) {
    return We(_e) && _e > 0;
  }
  var it = H.getLogger("twilio-sync");
  function gt(_e, Pe) {
    return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Sync ").concat(_e, ":")].concat(Array.from(Pe));
  }
  var Ze = {
    setLevel: function(Pe) {
      it.setLevel(Pe);
    },
    trace: function() {
      if (it.getLevel() == it.levels.TRACE) {
        for (var Pe = arguments.length, Q = new Array(Pe), te = 0; te < Pe; te++)
          Q[te] = arguments[te];
        it.debug.apply(null, gt("T", Q));
      }
    },
    debug: function() {
      for (var Pe = arguments.length, Q = new Array(Pe), te = 0; te < Pe; te++)
        Q[te] = arguments[te];
      it.debug.apply(null, gt("D", Q));
    },
    info: function() {
      for (var Pe = arguments.length, Q = new Array(Pe), te = 0; te < Pe; te++)
        Q[te] = arguments[te];
      it.info.apply(null, gt("I", Q));
    },
    warn: function() {
      for (var Pe = arguments.length, Q = new Array(Pe), te = 0; te < Pe; te++)
        Q[te] = arguments[te];
      it.warn.apply(null, gt("W", Q));
    },
    error: function() {
      for (var Pe = arguments.length, Q = new Array(Pe), te = 0; te < Pe; te++)
        Q[te] = arguments[te];
      it.error.apply(null, gt("E", Q));
    }
  }, Ne = "/v4/Subscriptions", ze = "/v3/Maps", ct = "/v3/Lists", rt = "/v3/Documents", qe = "/v3/Streams", nt = "/v3/Insights";
  function Rt(_e, Pe, Q) {
    return _e && typeof _e[Pe] < "u" ? _e[Pe] : Q;
  }
  var Ot = /* @__PURE__ */ function() {
    function _e() {
      var Pe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      M.default(this, _e);
      var Q = Pe.region || "us1", te = "https://cds.".concat(Q, ".twilio.com"), J = Pe.cdsUri || te;
      this.settings = {
        subscriptionsUri: J + Ne,
        documentsUri: J + rt,
        listsUri: J + ct,
        mapsUri: J + ze,
        streamsUri: J + qe,
        insightsUri: J + nt,
        sessionStorageEnabled: Rt(Pe.Sync, "enableSessionStorage", !0),
        productId: Pe.productId
      };
    }
    return B.default(_e, [{
      key: "subscriptionsUri",
      get: function() {
        return this.settings.subscriptionsUri;
      }
    }, {
      key: "documentsUri",
      get: function() {
        return this.settings.documentsUri;
      }
    }, {
      key: "listsUri",
      get: function() {
        return this.settings.listsUri;
      }
    }, {
      key: "mapsUri",
      get: function() {
        return this.settings.mapsUri;
      }
    }, {
      key: "streamsUri",
      get: function() {
        return this.settings.streamsUri;
      }
    }, {
      key: "insightsUri",
      get: function() {
        return this.settings.insightsUri;
      }
    }, {
      key: "backoffConfig",
      get: function() {
        return this.settings.backoffConfig || {};
      }
    }, {
      key: "sessionStorageEnabled",
      get: function() {
        return this.settings.sessionStorageEnabled;
      }
    }, {
      key: "productId",
      get: function() {
        return this.settings.productId;
      }
    }]), _e;
  }();
  function lt(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = mt(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function mt(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return jt(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return jt(_e, Pe);
    }
  }
  function jt(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  var Jt = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), this.localObject = Pe, this.pendingCorrelationId = null, this.pendingAction = null, this.established = !1, this.retryCount = 0;
    }
    return B.default(_e, [{
      key: "sid",
      get: function() {
        return this.localObject.sid;
      }
    }, {
      key: "type",
      get: function() {
        return this.localObject.type;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.localObject.lastEventId;
      }
      // below properties are specific to Insights only
    }, {
      key: "indexName",
      get: function() {
        return this.localObject.indexName;
      }
    }, {
      key: "queryString",
      get: function() {
        return this.localObject.queryString;
      }
    }, {
      key: "isEstablished",
      get: function() {
        return this.established;
      }
    }, {
      key: "update",
      value: function(Q, te) {
        this.localObject._update(Q, te);
      }
    }, {
      key: "updatePending",
      value: function(Q, te) {
        this.pendingAction = Q, this.pendingCorrelationId = te;
      }
    }, {
      key: "reset",
      value: function() {
        this.updatePending(null, null), this.retryCount = 0, this.established = !1, this.setSubscriptionState("none");
      }
    }, {
      key: "markAsFailed",
      value: function(Q) {
        this.rejectedWithError = Q.error, this.updatePending(null, null), this.localObject.reportFailure(new ee("Failed to subscribe on service events: ".concat(Q.error.message), Q.error.status, Q.error.code));
      }
    }, {
      key: "complete",
      value: function(Q) {
        this.updatePending(null, null), this.established = !0, this.localObject._advanceLastEventId(Q);
      }
    }, {
      key: "setSubscriptionState",
      value: function(Q) {
        this.localObject._setSubscriptionState(Q);
      }
    }]), _e;
  }(), ne = /* @__PURE__ */ function() {
    function _e(Pe) {
      var Q = this;
      M.default(this, _e), v.default(this, "isConnected", !1), v.default(this, "maxBatchSize", 100), v.default(this, "subscriptionTtlTimer", null), v.default(this, "pendingPokeReason", null), this.services = Pe, this.subscriptions = /* @__PURE__ */ new Map(), this.persisted = /* @__PURE__ */ new Map(), this.latestPokeResponseArrivalTimestampByCorrelationId = /* @__PURE__ */ new Map();
      var te = {
        randomisationFactor: 0.2,
        initialDelay: 100,
        maxDelay: 2 * 60 * 1e3
      };
      this.backoff = y.Backoff.exponential(Object.assign(te, this.services.config.backoffConfig)), this.backoff.on("ready", function() {
        var J = Q.getSubscriptionUpdateBatch(), fe = J.action, le = J.subscriptions;
        fe ? Q.applyNewSubscriptionUpdateBatch(fe, le) : (Q.backoff.reset(), Ze.debug("All subscriptions resolved."));
      });
    }
    return B.default(_e, [{
      key: "getSubscriptionUpdateBatch",
      value: function() {
        function Q(fe, le, ke, X) {
          var he = [], $e = lt(fe), Ct;
          try {
            for ($e.s(); !(Ct = $e.n()).done; ) {
              var Bt = j.default(Ct.value, 2), St = Bt[0], ir = Bt[1], Ir = le.get(St);
              if (!Ir && ke !== ir.pendingAction && !ir.rejectedWithError && (he.push(ir), X && he.length >= X))
                break;
            }
          } catch (Sr) {
            $e.e(Sr);
          } finally {
            $e.f();
          }
          return he;
        }
        var te = Q(this.subscriptions, this.persisted, "establish", this.maxBatchSize);
        if (te.length > 0)
          return {
            action: "establish",
            subscriptions: te
          };
        var J = Q(this.persisted, this.subscriptions, "cancel", this.maxBatchSize);
        return J.length > 0 ? {
          action: "cancel",
          subscriptions: J
        } : {
          action: null,
          subscriptions: null
        };
      }
    }, {
      key: "persist",
      value: function() {
        this.backoff.backoff();
      }
    }, {
      key: "applyNewSubscriptionUpdateBatch",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te(J, fe) {
          var le = this, ke, X, he, $e, Ct, Bt, St, ir, Ir, Sr, Vr, ri, ni, Yn, ja, Rr;
          return k.default.wrap(function(Ee) {
            for (; ; )
              switch (Ee.prev = Ee.next) {
                case 0:
                  if (this.isConnected) {
                    Ee.next = 4;
                    break;
                  }
                  return Ze.debug("Twilsock connection (required for subscription) not ready; waiting…"), this.backoff.reset(), Ee.abrupt("return");
                case 4:
                  fe = this.processLocalActions(J, fe), ke = (/* @__PURE__ */ new Date()).getTime(), X = lt(fe);
                  try {
                    for (X.s(); !(he = X.n()).done; )
                      $e = he.value, this.recordActionAttemptOn($e, J, ke);
                  } catch (je) {
                    X.e(je);
                  } finally {
                    X.f();
                  }
                  return Ct = this.pendingPokeReason, this.pendingPokeReason = null, Ee.prev = 10, Ee.next = 13, this.request(J, ke, Ct, fe);
                case 13:
                  Bt = Ee.sent, St = Bt.body.max_batch_size, !isNaN(parseInt(St)) && isFinite(St) && St > 0 && (this.maxBatchSize = St), this.subscriptionTtlTimer || (ir = Bt.body.ttl_in_s, Ir = !isNaN(parseFloat(ir)) && isFinite(ir), Sr = Ir && ir > 0, Sr && (this.subscriptionTtlTimer = setTimeout(function() {
                    return le.onSubscriptionTtlElapsed();
                  }, ir * 1e3))), J === "establish" && (Vr = Bt.body.estimated_delivery_in_ms, ri = !isNaN(parseFloat(Vr)) && isFinite(Vr), ni = ri && Vr > 0, ni ? setTimeout(function() {
                    return le.verifyPokeDelivery(ke, Vr, fe);
                  }, Vr) : Ze.error("Invalid timeout: ".concat(Vr)), fe.filter(function(je) {
                    return je.pendingCorrelationId === ke;
                  }).forEach(function(je) {
                    return je.setSubscriptionState("response_in_flight");
                  })), this.backoff.reset(), Ee.next = 26;
                  break;
                case 21:
                  Ee.prev = 21, Ee.t0 = Ee.catch(10), Yn = lt(fe);
                  try {
                    for (Yn.s(); !(ja = Yn.n()).done; )
                      Rr = ja.value, this.recordActionFailureOn(Rr, J);
                  } catch (je) {
                    Yn.e(je);
                  } finally {
                    Yn.f();
                  }
                  Ee.t0 instanceof f.TransportUnavailableError ? (Ze.debug("Twilsock connection (required for subscription) not ready (c:".concat(ke, "); waiting…")), this.backoff.reset()) : (Ze.debug("Failed an attempt to ".concat(J, " subscriptions (c:").concat(ke, "); retrying"), Ee.t0), this.persist());
                case 26:
                case "end":
                  return Ee.stop();
              }
          }, te, this, [[10, 21]]);
        }));
        function Q(te, J) {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
    }, {
      key: "verifyPokeDelivery",
      value: function(Q, te, J) {
        var fe = this, le = this.latestPokeResponseArrivalTimestampByCorrelationId.get(Q), ke = le ? (/* @__PURE__ */ new Date()).getTime() - le : te;
        if (ke >= te)
          J.filter(function(he) {
            return he.pendingCorrelationId === Q;
          }).forEach(function(he) {
            he.updatePending(null, null), he.retryCount++, fe.persisted.delete(he.sid);
          }), this.persist(), this.latestPokeResponseArrivalTimestampByCorrelationId.delete(Q);
        else {
          var X = te - ke;
          setTimeout(function() {
            return fe.verifyPokeDelivery(Q, te, J);
          }, X);
        }
      }
    }, {
      key: "processLocalActions",
      value: function(Q, te) {
        return Q === "cancel" ? te.filter(function(J) {
          return !J.rejectedWithError;
        }) : te;
      }
    }, {
      key: "recordActionAttemptOn",
      value: function(Q, te, J) {
        if (Q.setSubscriptionState("request_in_flight"), te === "establish")
          this.persisted.set(Q.sid, Q), Q.updatePending(te, J);
        else {
          var fe = this.persisted.get(Q.sid);
          fe && fe.updatePending(te, J);
        }
      }
    }, {
      key: "recordActionFailureOn",
      value: function(Q, te) {
        Q.setSubscriptionState("none"), Q.updatePending(null, null), te === "establish" && this.persisted.delete(Q.sid);
      }
    }, {
      key: "request",
      value: function(Q, te, J, fe) {
        var le = fe.map(function(he) {
          return {
            object_sid: he.sid,
            object_type: he.type,
            last_event_id: Q === "establish" ? he.lastEventId : void 0,
            index_name: Q === "establish" ? he.indexName : void 0,
            query_string: Q === "establish" ? he.queryString : void 0
          };
        }), ke = fe.filter(function(he) {
          return he.retryCount > 0;
        }).length;
        Ze.debug("Attempting '".concat(Q, "' request (c:").concat(te, "):"), le);
        var X = {
          event_protocol_version: 4,
          action: Q,
          correlation_id: te,
          retried_requests: ke,
          ttl_in_s: -1,
          requests: le
        };
        return J === "ttl" && (X.reason = J), this.services.network.post(this.services.config.subscriptionsUri, X);
      }
      /**
       * Establishes intent to be subscribed to this entity. That subscription will be effected
       * asynchronously.
       * If subscription to the given sid already exists, it will be overwritten.
       *
       * @param {String} sid should be a well-formed SID, uniquely identifying a single instance of a Sync entity.
       * @param {Object} entity should represent the (singular) local representation of this entity.
       *      Incoming events and modifications to the entity will be directed at the _update() function
       *      of this provided reference.
       *
       * @return undefined
       */
    }, {
      key: "add",
      value: function(Q, te) {
        Ze.debug("Establishing intent to subscribe to ".concat(Q));
        var J = this.subscriptions.get(Q);
        J && te && J.lastEventId === te.lastEventId || (this.persisted.delete(Q), this.subscriptions.set(Q, new Jt(te)), this.persist());
      }
      /**
       * Establishes the caller's intent to no longer be subscribed to this entity. Following this
       * call, no further events shall be routed to the local representation of the entity, even
       * though a server-side subscription may take more time to actually terminate.
       *
       * @param {string} sid should be any well-formed SID, uniquely identifying a Sync entity.
       *      This call only has meaningful effect if that entity is subscribed at the
       *      time of call. Otherwise does nothing.
       *
       * @return undefined
       */
    }, {
      key: "remove",
      value: function(Q) {
        Ze.debug("Establishing intent to unsubscribe from ".concat(Q));
        var te = this.subscriptions.delete(Q);
        te && this.persist();
      }
      /**
       * The point of ingestion for remote incoming messages (e.g. new data was written to a map
       * to which we are subscribed).
       *
       * @param {object} message is the full, unaltered body of the incoming notification.
       *
       * @return undefined
       */
    }, {
      key: "acceptMessage",
      value: function(Q, te) {
        Ze.trace("Subscriptions received", Q);
        var J = Q.event_type, fe = typeof Q.events < "u" ? Q.events : [Q.event], le = Q.correlation_id;
        le && this.latestPokeResponseArrivalTimestampByCorrelationId.set(le, (/* @__PURE__ */ new Date()).getTime());
        var ke = lt(fe), X;
        try {
          for (ke.s(); !(X = ke.n()).done; ) {
            var he = X.value, $e = void 0;
            switch (Q.event_type) {
              case "subscription_established":
                this.applySubscriptionEstablishedMessage(he, le);
                break;
              case "subscription_canceled":
                this.applySubscriptionCancelledMessage(he, le);
                break;
              case "subscription_failed":
                this.applySubscriptionFailedMessage(he, le);
                break;
              case ($e = J.match(/^(?:map|list|document|stream|live_query)_/) || {}).input: {
                var Ct = void 0;
                switch ($e[0]) {
                  case "map_":
                    Ct = he.map_sid;
                    break;
                  case "list_":
                    Ct = he.list_sid;
                    break;
                  case "document_":
                    Ct = he.document_sid;
                    break;
                  case "stream_":
                    Ct = he.stream_sid;
                    break;
                  case "live_query_":
                    Ct = he.query_id, te = !1, Q.strictly_ordered === !0 && (te = !0);
                    break;
                  default:
                    Ct = void 0;
                }
                this.applyEventToSubscribedEntity(Ct, he, J, te);
                break;
              }
              default:
                Ze.debug("Dropping unknown message type ".concat(J));
                break;
            }
          }
        } catch (Bt) {
          ke.e(Bt);
        } finally {
          ke.f();
        }
      }
    }, {
      key: "applySubscriptionEstablishedMessage",
      value: function(Q, te) {
        var J = Q.object_sid, fe = this.persisted.get(Q.object_sid);
        fe && fe.pendingCorrelationId === te ? Q.replay_status === "interrupted" ? (Ze.debug("Event Replay for subscription to ".concat(J, " (c:").concat(te, ") interrupted; continuing eagerly.")), fe.updatePending(null, null), this.persisted.delete(fe.sid), this.backoff.reset()) : Q.replay_status === "completed" && (Ze.debug("Event Replay for subscription to ".concat(J, " (c:").concat(te, ") completed. Subscription is ready.")), fe.complete(Q.last_event_id), this.persisted.set(Q.object_sid, fe), fe.setSubscriptionState("established"), this.backoff.reset()) : Ze.debug("Late message for ".concat(Q.object_sid, " (c:").concat(te, ") dropped.")), this.persist();
      }
    }, {
      key: "applySubscriptionCancelledMessage",
      value: function(Q, te) {
        var J = this.persisted.get(Q.object_sid);
        J && J.pendingCorrelationId === te ? (J.updatePending(null, null), J.setSubscriptionState("none"), this.persisted.delete(Q.object_sid)) : Ze.debug("Late message for ".concat(Q.object_sid, " (c:").concat(te, ") dropped.")), this.persist();
      }
    }, {
      key: "applySubscriptionFailedMessage",
      value: function(Q, te) {
        var J = Q.object_sid, fe = this.subscriptions.get(J), le = this.persisted.get(J);
        fe && le ? le.pendingCorrelationId === te && (Ze.error("Failed to subscribe on ".concat(le.sid), Q.error), le.markAsFailed(Q), le.setSubscriptionState("none")) : !fe && le && (this.persisted.delete(J), le.setSubscriptionState("none")), this.persist();
      }
    }, {
      key: "applyEventToSubscribedEntity",
      value: function(Q, te, J, fe) {
        var le = this;
        if (Q) {
          fe = fe || function() {
            var X = le.persisted.get(Q);
            return X && X.isEstablished;
          }();
          var ke = this.subscriptions.get(Q);
          ke ? (te.type = J, ke.update(te, fe)) : Ze.debug("Message dropped for SID '".concat(Q, "', for which there is no subscription."));
        }
      }
    }, {
      key: "onConnectionStateChanged",
      value: function(Q) {
        this.isConnected = Q, Q && this.poke("reconnect");
      }
    }, {
      key: "onSubscriptionTtlElapsed",
      value: function() {
        this.isConnected && this.poke("ttl");
      }
      /**
       * Prompts a playback of any missed changes made to any subscribed object. This method
       * should be invoked whenever the connectivity layer has experienced cross-cutting
       * delivery failures that would affect the entire local sync set. Any tangible result
       * of this operation will result in calls to the _update() function of subscribed
       * Sync entities.
       */
    }, {
      key: "poke",
      value: function(Q) {
        Ze.debug("Triggering event replay for all subscriptions, reason=".concat(Q)), this.pendingPokeReason = Q, this.subscriptionTtlTimer && (clearTimeout(this.subscriptionTtlTimer), this.subscriptionTtlTimer = null);
        var te = [], J = lt(this.persisted.values()), fe;
        try {
          for (J.s(); !(fe = J.n()).done; ) {
            var le = fe.value;
            le.reset(), le.rejectedWithError && te.push(le);
          }
        } catch ($e) {
          J.e($e);
        } finally {
          J.f();
        }
        this.persisted.clear();
        for (var ke = 0, X = te; ke < X.length; ke++) {
          var he = X[ke];
          this.persisted.set(he.sid, he);
        }
        this.persist();
      }
      /**
       * Stops all communication, clears any subscription intent, and returns.
       */
    }, {
      key: "shutdown",
      value: function() {
        this.backoff.reset(), this.subscriptions.clear();
      }
    }]), _e;
  }(), re = 4e3, ie = 6e4, Ie = 9e4, Ke = 0.2;
  function Le(_e) {
    if (_e.body && _e.body.message)
      return _e.body.message;
    switch (_e.status) {
      case 429:
        return "Throttled by server";
      case 404:
        return "Not found from server";
      default:
        return "Error from server";
    }
  }
  function Ge(_e) {
    return _e.body ? _e.body.code : 0;
  }
  function ft(_e) {
    return _e.status === 409 ? new Se(Le(_e), _e.status, Ge(_e), _e.body) : _e.status ? new ee(Le(_e), _e.status, Ge(_e)) : _e instanceof f.TransportUnavailableError ? _e : new ee(_e.message, 0, 0);
  }
  var ot = /* @__PURE__ */ function() {
    function _e(Pe, Q, te) {
      M.default(this, _e), this.clientInfo = Pe, this.config = Q, this.transport = te;
    }
    return B.default(_e, [{
      key: "createHeaders",
      value: function() {
        return {
          "Content-Type": "application/json",
          "Twilio-Sync-Client-Info": JSON.stringify(this.clientInfo),
          "Twilio-Request-Id": "RQ" + F.v4().replace(/-/g, "")
        };
      }
    }, {
      key: "backoffConfig",
      value: function() {
        return Object.assign({
          min: re,
          max: ie,
          maxAttemptsTime: Ie,
          randomness: Ke
        }, this.config.backoffConfig);
      }
    }, {
      key: "executeWithRetry",
      value: function(Q) {
        var te = this, J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        return new Promise(function(fe, le) {
          var ke = [502, 503, 504];
          J && ke.push(429);
          var X = new y.Retrier(te.backoffConfig());
          X.on("attempt", function() {
            Q().then(function(he) {
              return X.succeeded(he);
            }).catch(function(he) {
              if (ke.includes(he.status)) {
                var $e = parseInt(he.headers ? he.headers["Retry-After"] : null);
                X.failed(ft(he), isNaN($e) ? null : $e * 1e3);
              } else he.message === "Twilsock disconnected" ? X.failed(ft(he)) : (X.removeAllListeners(), X.cancel(), le(ft(he)));
            });
          }), X.on("succeeded", function(he) {
            fe(he);
          }), X.on("cancelled", function(he) {
            return le(ft(he));
          }), X.on("failed", function(he) {
            return le(ft(he));
          }), X.start();
        });
      }
      /**
       * Make a GET request by given URI
       * @Returns Promise<Response> Result of successful get request
       */
    }, {
      key: "get",
      value: function(Q) {
        var te = this, J = this.createHeaders();
        return Ze.debug("GET", Q, "ID:", J["Twilio-Request-Id"]), this.executeWithRetry(function() {
          return te.transport.get(Q, J, te.config.productId);
        }, !0);
      }
    }, {
      key: "post",
      value: function(Q, te, J) {
        var fe = this, le = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1, ke = this.createHeaders();
        return typeof J < "u" && J !== null && (ke["If-Match"] = J), Ze.debug("POST", Q, "ID:", ke["Twilio-Request-Id"]), this.executeWithRetry(function() {
          return fe.transport.post(Q, ke, te, fe.config.productId);
        }, le);
      }
    }, {
      key: "put",
      value: function(Q, te, J) {
        var fe = this, le = this.createHeaders();
        return typeof J < "u" && J !== null && (le["If-Match"] = J), Ze.debug("PUT", Q, "ID:", le["Twilio-Request-Id"]), this.executeWithRetry(function() {
          return fe.transport.put(Q, le, te, fe.config.productId);
        }, !1);
      }
    }, {
      key: "delete",
      value: function(Q) {
        var te = this, J = this.createHeaders();
        return Ze.debug("DELETE", Q, "ID:", J["Twilio-Request-Id"]), this.executeWithRetry(function() {
          return te.transport.delete(Q, J, te.config.productId);
        }, !1);
      }
    }]), _e;
  }(), Ye = /* @__PURE__ */ function() {
    function _e(Pe, Q) {
      M.default(this, _e), this.config = Pe, this.storageId = null;
      try {
        this.storage = Q || sessionStorage;
      } catch {
      }
    }
    return B.default(_e, [{
      key: "storageKey",
      value: function(Q, te) {
        return "".concat(this.storageId, "::").concat(Q, "::").concat(te);
      }
    }, {
      key: "isReady",
      get: function() {
        return this.config.sessionStorageEnabled && !!this.storageId;
      }
    }, {
      key: "updateStorageId",
      value: function(Q) {
        this.storageId = Q;
      }
    }, {
      key: "store",
      value: function(Q, te, J) {
        return this.isReady ? this._store(this.storageKey(Q, te), J) : null;
      }
    }, {
      key: "read",
      value: function(Q, te) {
        return this.isReady ? this._read(this.storageKey(Q, te)) : null;
      }
    }, {
      key: "remove",
      value: function(Q, te, J) {
        if (!this.isReady)
          return null;
        try {
          this.storage.removeItem(this.storageKey(Q, te)), J && this.storage.removeItem(this.storageKey(Q, J));
        } catch {
        }
      }
    }, {
      key: "update",
      value: function(Q, te, J, fe) {
        if (!this.isReady)
          return null;
        this._apply(this.storageKey(Q, te), fe), J && this._apply(this.storageKey(Q, J), fe);
      }
    }, {
      key: "_store",
      value: function(Q, te) {
        try {
          this.storage.setItem(Q, JSON.stringify(te));
        } catch {
        }
      }
    }, {
      key: "_read",
      value: function(Q) {
        try {
          var te = this.storage.getItem(Q);
          if (te)
            return JSON.parse(te);
        } catch {
        }
        return null;
      }
    }, {
      key: "_apply",
      value: function(Q, te) {
        var J = this._read(Q);
        if (!J)
          return !1;
        this._store(Q, Object.assign(J, te));
      }
    }]), _e;
  }();
  function Je(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = tt(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function tt(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return kt(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return kt(_e, Pe);
    }
  }
  function kt(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  var Ft = /* @__PURE__ */ function() {
    function _e(Pe, Q) {
      M.default(this, _e), this.services = Pe, this.removalHandler = Q, this.subscriptionState = "none", this._attachedListeners = /* @__PURE__ */ new Map();
    }
    return B.default(_e, [{
      key: "_advanceLastEventId",
      value: function(Q, te) {
      }
    }, {
      key: "reportFailure",
      value: function(Q) {
        Q.status === 404 ? this.onRemoved(!1) : this.broadcastEventToListeners("failure", Q);
      }
      /**
       * Subscribe to changes of data entity
       * @private
       */
    }, {
      key: "_subscribe",
      value: function() {
        this.services.router._subscribe(this.sid, this);
      }
      /**
       * Unsubscribe from changes of current data entity
       * @private
       */
    }, {
      key: "_unsubscribe",
      value: function() {
        this.services.router._unsubscribe(this.sid);
      }
    }, {
      key: "_setSubscriptionState",
      value: function(Q) {
        this.subscriptionState = Q, this.broadcastEventToListeners("_subscriptionStateChanged", Q);
      }
      /**
       * @public
       */
    }, {
      key: "close",
      value: function() {
        this._unsubscribe(), this.removalHandler != null && this.removalHandler(this.type, this.sid, this.uniqueName);
      }
    }, {
      key: "attach",
      value: function(Q) {
        var te = Q.listenerUuid, J = this._attachedListeners.get(te);
        J || (this._attachedListeners.size || this._subscribe(), this._attachedListeners.set(te, Q));
      }
    }, {
      key: "detach",
      value: function(Q) {
        this._attachedListeners.delete(Q), this._attachedListeners.size || this.close();
      }
    }, {
      key: "broadcastEventToListeners",
      value: function(Q) {
        for (var te = arguments.length, J = new Array(te > 1 ? te - 1 : 0), fe = 1; fe < te; fe++)
          J[fe - 1] = arguments[fe];
        var le = Je(this._attachedListeners.values()), ke;
        try {
          for (le.s(); !(ke = le.n()).done; ) {
            var X = ke.value;
            X.emit.apply(X, [Q].concat(J));
          }
        } catch (he) {
          le.e(he);
        } finally {
          le.f();
        }
      }
    }]), _e;
  }(), bt = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), v.default(this, "queuedRequests", []), v.default(this, "isRequestInFlight", !1), this.inputMergingFunction = Pe;
    }
    return B.default(_e, [{
      key: "add",
      value: function(Q, te) {
        var J = this, fe = new Promise(function(le, ke) {
          return J.queuedRequests.push({
            input: Q,
            requestFunction: te,
            resolve: le,
            reject: ke
          });
        });
        return this.wakeupQueue(), fe;
      }
    }, {
      key: "squashAndAdd",
      value: function(Q, te) {
        var J = this.queuedRequests;
        this.queuedRequests = [];
        var fe;
        J.length > 0 ? (fe = J.map(function(ke) {
          return ke.input;
        }).reduce(this.inputMergingFunction), fe = this.inputMergingFunction(fe, Q)) : fe = Q;
        var le = this.add(fe, te);
        return J.forEach(function(ke) {
          return le.then(ke.resolve, ke.reject);
        }), le;
      }
    }, {
      key: "isEmpty",
      value: function() {
        return this.queuedRequests.length === 0 && !this.isRequestInFlight;
      }
    }, {
      key: "wakeupQueue",
      value: function() {
        var Q = this;
        if (!(this.queuedRequests.length === 0 || this.isRequestInFlight)) {
          var te = this.queuedRequests.shift();
          this.isRequestInFlight = !0, te.requestFunction(te.input).then(te.resolve, te.reject).then(function(J) {
            Q.isRequestInFlight = !1, Q.wakeupQueue();
          });
        }
      }
    }]), _e;
  }(), At = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), v.default(this, "queueByNamespaceKey", /* @__PURE__ */ new Map()), this.inputReducer = Pe;
    }
    return B.default(_e, [{
      key: "add",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te(J, fe, le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.invokeQueueMethod(J, function(he) {
                    return he.add(fe, le);
                  }));
                case 1:
                case "end":
                  return X.stop();
              }
          }, te, this);
        }));
        function Q(te, J, fe) {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
    }, {
      key: "squashAndAdd",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te(J, fe, le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.invokeQueueMethod(J, function(he) {
                    return he.squashAndAdd(fe, le);
                  }));
                case 1:
                case "end":
                  return X.stop();
              }
          }, te, this);
        }));
        function Q(te, J, fe) {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
    }, {
      key: "invokeQueueMethod",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te(J, fe) {
          var le, ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return this.queueByNamespaceKey.has(J) || this.queueByNamespaceKey.set(J, new bt(this.inputReducer)), le = this.queueByNamespaceKey.get(J), ke = fe(le), this.queueByNamespaceKey.get(J).isEmpty() && this.queueByNamespaceKey.delete(J), he.abrupt("return", ke);
                case 5:
                case "end":
                  return he.stop();
              }
          }, te, this);
        }));
        function Q(te, J) {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
    }]), _e;
  }();
  function vt(_e) {
    var Pe = _t();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function _t() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var yt = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = vt(Q);
    function Q() {
      var te;
      return M.default(this, Q), te = Pe.call(this), te.closed = !1, te.uuid = b.v4(), te;
    }
    return B.default(Q, [{
      key: "listenerUuid",
      get: function() {
        return this.uuid;
      }
    }, {
      key: "close",
      value: function() {
        this.removeAllListeners(), this.closed = !0;
      }
    }, {
      key: "ensureNotClosed",
      value: function() {
        if (this.closed)
          throw new Error("Invalid operation on closed object");
      }
    }]), Q;
  }(_.ReplayEventEmitter);
  function xr(_e) {
    var Pe = dr();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function dr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Er = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = xr(Q);
    function Q(te, J, fe) {
      var le;
      M.default(this, Q), le = Pe.call(this, te, fe), v.default(L.default(le), "isDeleted", !1);
      var ke = function(he, $e) {
        return typeof $e.ttl == "number" ? {
          ttl: $e.ttl
        } : he;
      };
      return le.updateMergingQueue = new bt(ke), le.descriptor = J, le.descriptor.data = le.descriptor.data || {}, le.descriptor.date_updated = new Date(le.descriptor.date_updated), le;
    }
    return B.default(Q, [{
      key: "uri",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "revision",
      get: function() {
        return this.descriptor.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.last_event_id;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.date_expires;
      }
    }, {
      key: "type",
      get: function() {
        return "document";
      }
      // below properties are specific to Insights only
    }, {
      key: "indexName",
      get: function() {
      }
    }, {
      key: "queryString",
      get: function() {
      }
      // public props, documented along with class description
    }, {
      key: "sid",
      get: function() {
        return this.descriptor.sid;
      }
    }, {
      key: "data",
      get: function() {
        return this.descriptor.data;
      }
    }, {
      key: "dateUpdated",
      get: function() {
        return this.descriptor.date_updated;
      }
    }, {
      key: "uniqueName",
      get: function() {
        return this.descriptor.unique_name || null;
      }
      /**
       * Update data entity with new data
       * @private
       */
    }, {
      key: "_update",
      value: function(J) {
        switch (J.date_created = new Date(J.date_created), J.type) {
          case "document_updated":
            if (J.id <= this.lastEventId) {
              Ze.trace("Document update skipped, current:", this.lastEventId, ", remote:", J.id);
              break;
            }
            var fe = this.descriptor.data !== void 0 ? Ce(this.descriptor.data) : null;
            this.descriptor.last_event_id = J.id, this.descriptor.revision = J.document_revision, this.descriptor.date_updated = J.date_created, this.descriptor.data = J.document_data, this.broadcastEventToListeners("updated", {
              data: J.document_data,
              isLocal: !1,
              previousData: fe
            }), this.services.storage.update(this.type, this.sid, this.uniqueName, {
              last_event_id: J.id,
              revision: J.document_revision,
              date_updated: J.date_created,
              data: J.document_data
            });
            break;
          case "document_removed":
            this.onRemoved(!1);
            break;
        }
      }
    }, {
      key: "set",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X = this, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  return he = ke || {}, Ct.abrupt("return", this.updateMergingQueue.squashAndAdd(he, function(Bt) {
                    return X._setUnconditionally(le, Bt.ttl);
                  }));
                case 2:
                case "end":
                  return Ct.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X = this, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  return he = ke || {}, Ct.abrupt("return", this.updateMergingQueue.add(he, function(Bt) {
                    return X._setWithIfMatch(le, Bt.ttl);
                  }));
                case 2:
                case "end":
                  return Ct.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.abrupt("return", this.mutate(function($e) {
                    return Object.assign($e, le);
                  }, ke));
                case 1:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.next = 2, this._postUpdateToServer({
                    ttl: le
                  });
                case 2:
                  ke = he.sent, this.descriptor.date_expires = ke.date_expires;
                case 4:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @private
       */
    }, {
      key: "_setUnconditionally",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.next = 2, this._postUpdateToServer({
                    data: le,
                    revision: void 0,
                    ttl: ke
                  });
                case 2:
                  return X = $e.sent, this._handleSuccessfulUpdateResult(X), $e.abrupt("return", this.descriptor.data);
                case 5:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @private
       */
    }, {
      key: "_setWithIfMatch",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  if (X = le(Ce(this.descriptor.data)), !X) {
                    Bt.next = 22;
                    break;
                  }
                  return he = this.revision, Bt.prev = 3, Bt.next = 6, this._postUpdateToServer({
                    data: X,
                    revision: he,
                    ttl: ke
                  });
                case 6:
                  return $e = Bt.sent, this._handleSuccessfulUpdateResult($e), Bt.abrupt("return", this.descriptor.data);
                case 11:
                  if (Bt.prev = 11, Bt.t0 = Bt.catch(3), Bt.t0.status !== 412) {
                    Bt.next = 19;
                    break;
                  }
                  return Bt.next = 16, this._softSync();
                case 16:
                  return Bt.abrupt("return", this._setWithIfMatch(le));
                case 19:
                  throw Bt.t0;
                case 20:
                  Bt.next = 23;
                  break;
                case 22:
                  return Bt.abrupt("return", this.descriptor.data);
                case 23:
                case "end":
                  return Bt.stop();
              }
          }, fe, this, [[3, 11]]);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @private
       */
    }, {
      key: "_handleSuccessfulUpdateResult",
      value: function(J) {
        if (!(J.last_event_id <= this.descriptor.last_event_id)) {
          var fe = this.descriptor.data !== void 0 ? Ce(this.descriptor.data) : null;
          this.descriptor.revision = J.revision, this.descriptor.data = J.data, this.descriptor.last_event_id = J.last_event_id, this.descriptor.date_expires = J.date_expires, this.descriptor.date_updated = new Date(J.date_updated), this.services.storage.update(this.type, this.sid, this.uniqueName, {
            last_event_id: J.last_event_id,
            revision: J.revision,
            date_updated: J.date_updated,
            data: J.data
          }), this.broadcastEventToListeners("updated", {
            data: this.descriptor.data,
            isLocal: !0,
            previousData: fe
          });
        }
      }
      /**
       * @private
       */
    }, {
      key: "_postUpdateToServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  if (this.isDeleted) {
                    Ct.next = 17;
                    break;
                  }
                  return ke = {
                    data: le.data
                  }, le.ttl !== void 0 && (ke.ttl = le.ttl), X = le.revision, Ct.prev = 4, Ct.next = 7, this.services.network.post(this.uri, ke, X);
                case 7:
                  return he = Ct.sent, Ct.abrupt("return", {
                    revision: he.body.revision,
                    data: le.data,
                    last_event_id: he.body.last_event_id,
                    date_updated: he.body.date_updated,
                    date_expires: he.body.date_expires
                  });
                case 11:
                  throw Ct.prev = 11, Ct.t0 = Ct.catch(4), Ct.t0.status === 404 && this.onRemoved(!1), Ct.t0;
                case 15:
                  Ct.next = 18;
                  break;
                case 17:
                  return Ct.abrupt("return", Promise.reject(new ee("The Document has been removed", 404, 54100)));
                case 18:
                case "end":
                  return Ct.stop();
              }
          }, fe, this, [[4, 11]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Get new data from server
       * @private
       */
    }, {
      key: "_softSync",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          var le = this;
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.services.network.get(this.uri).then(function(he) {
                    var $e = {
                      type: "document_updated",
                      id: he.body.last_event_id,
                      document_revision: he.body.revision,
                      document_data: he.body.data,
                      date_created: he.body.date_updated
                    };
                    return le._update($e), le;
                  }).catch(function(he) {
                    he.status === 404 ? le.onRemoved(!1) : Ze.error("Can't get updates for ".concat(le.sid, ":"), he);
                  }));
                case 1:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "onRemoved",
      value: function(J) {
        if (!this.isDeleted) {
          var fe = this.descriptor.data !== void 0 ? Ce(this.descriptor.data) : null;
          this.isDeleted = !0, this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
            isLocal: J,
            previousData: fe
          });
        }
      }
    }, {
      key: "removeDocument",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  if (this.isDeleted) {
                    ke.next = 6;
                    break;
                  }
                  return ke.next = 3, this.services.network.delete(this.uri);
                case 3:
                  this.onRemoved(!0), ke.next = 7;
                  break;
                case 6:
                  return ke.abrupt("return", Promise.reject(new ee("The Document has been removed", 404, 54100)));
                case 7:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }], [{
      key: "type",
      get: function() {
        return "document";
      }
    }]), Q;
  }(Ft), gr = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = xr(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), J.syncDocumentImpl = te, J.syncDocumentImpl.attach(L.default(J)), J;
    }
    return B.default(Q, [{
      key: "uri",
      get: (
        // private props
        function() {
          return this.syncDocumentImpl.uri;
        }
      )
    }, {
      key: "revision",
      get: function() {
        return this.syncDocumentImpl.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.syncDocumentImpl.lastEventId;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.syncDocumentImpl.dateExpires;
      }
    }, {
      key: "type",
      get: function() {
        return Er.type;
      }
      /**
       * The immutable identifier of this document, assigned by the system.
       */
    }, {
      key: "sid",
      get: function() {
        return this.syncDocumentImpl.sid;
      }
      /**
       * The contents of this document.
       */
    }, {
      key: "data",
      get: function() {
        return this.syncDocumentImpl.data;
      }
      /**
       * Date when the document was last updated.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.syncDocumentImpl.dateUpdated;
      }
      /**
       * An optional immutable identifier that may be assigned by the programmer
       * to this document during creation. Globally unique among other documents.
       */
    }, {
      key: "uniqueName",
      get: function() {
        return this.syncDocumentImpl.uniqueName;
      }
    }, {
      key: "set",
      value: (
        /**
         * Assign new contents to this document. The current data will be overwritten.
         * @param data The new contents to assign.
         * @param metadataUpdates New document metadata.
         * @return A promise resolving to the new data of the document.
         * @example
         * ```typescript
         * // Say, the Document data is `{ name: 'John Smith', age: 34 }`
         * document.set({ name: 'Barbara Oaks' }, { ttl: 86400 })
         *   .then((newValue) => {
         *     // Now the Document data is `{ name: 'Barbara Oaks' }`
         *     console.log('Document set() successful, new data:', newValue);
         *   })
         *   .catch((error) => {
         *     console.error('Document set() failed', error);
         *   });
         * ```
         */
        function() {
          var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
            return k.default.wrap(function(he) {
              for (; ; )
                switch (he.prev = he.next) {
                  case 0:
                    return this.ensureNotClosed(), he.abrupt("return", this.syncDocumentImpl.set(le, ke));
                  case 2:
                  case "end":
                    return he.stop();
                }
            }, fe, this);
          }));
          function J(fe, le) {
            return te.apply(this, arguments);
          }
          return J;
        }()
      )
      /**
       * Schedules a modification to this document that will apply a mutation function.
       * @param mutator A function that outputs new data based on the existing data.
       * May be called multiple times, particularly if this document is modified concurrently by remote code.
       * If the mutation ultimately succeeds, the document will have made the particular transition described
       * by this function.
       * @param metadataUpdates New document metadata.
       * @return Resolves with the most recent Document state, whether the output of a
       * successful mutation or a state that prompted graceful cancellation (mutator returned `null`).
       * @example
       * ```typescript
       * const mutatorFunction = (currentValue) => {
       *     currentValue.viewCount = (currentValue.viewCount ?? 0) + 1;
       *     return currentValue;
       * };
       * document.mutate(mutatorFunction, { ttl: 86400 }))
       *   .then((newValue) => {
       *     console.log('Document mutate() successful, new data:', newValue);
       *   })
       *   .catch((error) => {
       *     console.error('Document mutate() failed', error);
       *   });
       * ```
       */
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return this.ensureNotClosed(), he.abrupt("return", this.syncDocumentImpl.mutate(le, ke));
                case 2:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Modify a document by appending new fields (or by overwriting existing ones) with the values from the provided Object.
       * This is equivalent to:
       * ```typescript
       * document.mutate((currentValue) => Object.assign(currentValue, obj));
       * ```
       * @param obj Specifies the particular (top-level) attributes that will receive new values.
       * @param metadataUpdates New document metadata.
       * @return A promise resolving to the new data of the document.
       * @example
       * ```typescript
       * // Say, the Document data is `{ name: 'John Smith' }`
       * document.update({ age: 34 }, { ttl: 86400 })
       *   .then((newValue) => {
       *     // Now the Document data is `{ name: 'John Smith', age: 34 }`
       *     console.log('Document update() successful, new data:', newValue);
       *   })
       *   .catch((error) => {
       *     console.error('Document update() failed', error);
       *   });
       * ```
       */
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return this.ensureNotClosed(), he.abrupt("return", this.syncDocumentImpl.update(le, ke));
                case 2:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Update the time-to-live of the document.
       * @param ttl Specifies the time-to-live in seconds after which the document is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * document.setTtl(3600)
       *   .then(() => {
       *     console.log('Document setTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Document setTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncDocumentImpl.setTtl(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Delete a document.
       * @return A promise which resolves if (and only if) the document is ultimately deleted.
       * @example
       * ```typescript
       * document.removeDocument()
       *   .then(() => {
       *     console.log('Document removeDocument() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Document removeDocument() failed', error);
       *   });
       * ```
       */
    }, {
      key: "removeDocument",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return this.ensureNotClosed(), ke.abrupt("return", this.syncDocumentImpl.removeDocument());
                case 2:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Conclude work with the document instance and remove all event listeners attached to it.
       * Any subsequent operation on this object will be rejected with error.
       * Other local copies of this document will continue operating and receiving events normally.
       * @example
       * ```typescript
       * document.close();
       * ```
       */
    }, {
      key: "close",
      value: function() {
        z.default(m.default(Q.prototype), "close", this).call(this), this.syncDocumentImpl.detach(this.listenerUuid);
      }
    }], [{
      key: "type",
      get: function() {
        return Er.type;
      }
    }]), Q;
  }(yt);
  v.default(gr, "removed", "removed"), v.default(gr, "updated", "updated"), Z([u.validateTypesAsync(u.pureObject, ["undefined", u.objectSchema("document metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object, Object]), V("design:returntype", Promise)], gr.prototype, "set", null), Z([u.validateTypesAsync("function", ["undefined", u.objectSchema("document metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Function, Object]), V("design:returntype", Promise)], gr.prototype, "mutate", null), Z([u.validateTypesAsync(u.pureObject, ["undefined", u.objectSchema("document metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object, Object]), V("design:returntype", Promise)], gr.prototype, "update", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], gr.prototype, "setTtl", null);
  var pr = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), this.descriptor = Pe;
    }
    return B.default(_e, [{
      key: "url",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "revision",
      get: function() {
        return this.descriptor.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.lastEventId;
      }
      /**
       * Date when the list item was last updated.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.descriptor.dateUpdated;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.dateExpires;
      }
      /**
       * The index, within the containing list, of this item. This index is stable;
       * even if lower-indexed items are removed, this index will remain as is.
       */
    }, {
      key: "index",
      get: function() {
        return this.descriptor.index;
      }
      /**
       * The contents of the item.
       */
    }, {
      key: "data",
      get: function() {
        return this.descriptor.data;
      }
      /**
       * CachedValue interface.
       */
    }, {
      key: "cacheKey",
      get: function() {
        return this.index;
      }
      /**
       * @internal
       */
    }, {
      key: "update",
      value: function(Q, te, J, fe) {
        return this.descriptor.lastEventId = Q, this.descriptor.revision = te, this.descriptor.data = J, this.descriptor.dateUpdated = fe, this;
      }
      /**
       * @internal
       */
    }, {
      key: "updateDateExpires",
      value: function(Q) {
        this.descriptor.dateExpires = Q;
      }
    }]), _e;
  }(), Xr = /* @__PURE__ */ function() {
    function _e(Pe, Q) {
      var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      M.default(this, _e), this.items = Pe, this.source = Q, this.prevPageItemId = te, this.nextPageItemId = J;
    }
    return B.default(_e, [{
      key: "nextPage",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te() {
          return k.default.wrap(function(fe) {
            for (; ; )
              switch (fe.prev = fe.next) {
                case 0:
                  if (this.hasNextPage) {
                    fe.next = 2;
                    break;
                  }
                  throw new Error("No next page");
                case 2:
                  return fe.abrupt("return", this.source({
                    nextPageItemId: this.nextPageItemId
                  }));
                case 3:
                case "end":
                  return fe.stop();
              }
          }, te, this);
        }));
        function Q() {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
      /**
       * Request previous page.
       * Does not modify existing object.
       */
    }, {
      key: "prevPage",
      value: function() {
        var Pe = I.default(/* @__PURE__ */ k.default.mark(function te() {
          return k.default.wrap(function(fe) {
            for (; ; )
              switch (fe.prev = fe.next) {
                case 0:
                  if (this.hasPrevPage) {
                    fe.next = 2;
                    break;
                  }
                  throw new Error("No previous page");
                case 2:
                  return fe.abrupt("return", this.source({
                    prevPageItemId: this.prevPageItemId
                  }));
                case 3:
                case "end":
                  return fe.stop();
              }
          }, te, this);
        }));
        function Q() {
          return Pe.apply(this, arguments);
        }
        return Q;
      }()
      /**
       * Indicates the existence of the next page.
       */
    }, {
      key: "hasNextPage",
      get: function() {
        return this.nextPageItemId !== null;
      }
      /**
       * Indicates the existence of the previous page.
       */
    }, {
      key: "hasPrevPage",
      get: function() {
        return this.prevPageItemId !== null;
      }
    }]), _e;
  }();
  function Yr(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = at(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function at(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return Vt(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return Vt(_e, Pe);
    }
  }
  function Vt(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  var er = /* @__PURE__ */ function() {
    function _e(Pe, Q) {
      M.default(this, _e), this.balanceFactor = 0, this.key = Pe, this.value = Q, this.parent = null, this.left = null, this.right = null;
    }
    return B.default(_e, [{
      key: "isRoot",
      get: function() {
        return this.parent === null;
      }
    }, {
      key: "isLeaf",
      get: function() {
        return this.left === null && this.right === null;
      }
    }, {
      key: "isLeftChild",
      get: function() {
        return this.parent.left === this;
      }
    }, {
      key: "update",
      value: function(Q) {
        this.value = Q;
      }
    }, {
      key: "replace",
      value: function(Q, te) {
        Q && (this.left === te ? this.left = te : this.right === te && (this.right = te));
      }
    }]), _e;
  }(), fr = /* @__PURE__ */ function(_e) {
    function Pe(Q, te) {
      M.default(this, Pe), this.isLessThan = Q || function(J, fe) {
        return J < fe;
      }, this.isEqual = te || function(J, fe) {
        return J === fe;
      }, this.root = null, this.count = null;
    }
    return B.default(Pe, [{
      key: "size",
      get: function() {
        return this.count;
      }
    }, {
      key: "clear",
      value: function() {
        this.root = null, this.count = 0;
      }
    }, {
      key: "set",
      value: function(te, J) {
        var fe = this.getNode(te);
        fe ? fe.update(J) : this.insert(te, J);
      }
    }, {
      key: "insert",
      value: function(te, J) {
        var fe = new er(te, J);
        if (this.count++, !this.root) {
          this.root = fe;
          return;
        }
        for (var le = this.root; ; )
          if (this.isLessThan(te, le.key))
            if (le.left)
              le = le.left;
            else {
              le.left = fe;
              break;
            }
          else if (le.right)
            le = le.right;
          else {
            le.right = fe;
            break;
          }
        for (fe.parent = le, le = fe; le.parent; ) {
          var ke = le.parent, X = ke.balanceFactor;
          if (le.isLeftChild ? ke.balanceFactor++ : ke.balanceFactor--, Math.abs(ke.balanceFactor) < Math.abs(X))
            break;
          if (ke.balanceFactor < -1 || ke.balanceFactor > 1) {
            this.rebalance(ke);
            break;
          }
          le = ke;
        }
      }
    }, {
      key: "get",
      value: function(te) {
        for (var J = this.root; J; ) {
          if (this.isEqual(te, J.key))
            return J.value;
          this.isLessThan(te, J.key) ? J = J.left : J = J.right;
        }
        return null;
      }
    }, {
      key: "delete",
      value: function(te) {
        var J = this.getNode(te);
        if (!J || J.key !== te)
          return null;
        var fe = J.parent, le = J.left, ke = J.right;
        if (!!le != !!ke) {
          var X = le || ke;
          !fe && !X ? this.root = null : fe && !X ? this.root = X : (fe.replace(J, null), this.rebalance(fe));
        } else {
          for (var he = J.left; he.right; )
            he = he.right;
          if (J.left === he)
            J.isRoot ? (this.root = he, he.parent = null) : (J.isLeftChild ? J.parent.left = he : J.parent.right = he, he.parent = J.parent), he.right = J.right, he.right.parent = he, he.balanceFactor = J.balanceFactor, J = {
              parent: he,
              isLeftChild: !0
            };
          else {
            var $e = he.parent, Ct = he.left;
            $e.right = Ct, Ct && (Ct.parent = $e), J.isRoot ? (this.root = he, he.parent = null) : (J.isLeftChild ? J.parent.left = he : J.parent.right = he, he.parent = J.parent), he.right = J.right, he.right.parent = he, he.left = J.left, he.left.parent = he, he.balanceFactor = J.balanceFactor, J = {
              parent: $e,
              isLeftChild: !1
            };
          }
        }
        for (this.count--; J.parent; ) {
          var Bt = J.parent, St = Bt.balanceFactor;
          if (J.isLeftChild ? Bt.balanceFactor -= 1 : Bt.balanceFactor += 1, Math.abs(Bt.balanceFactor) > Math.abs(St))
            if (Bt.balanceFactor < -1 || Bt.balanceFactor > 1)
              if (this.rebalance(Bt), Bt.parent.balanceFactor === 0)
                J = Bt.parent;
              else
                break;
            else
              break;
          else
            J = Bt;
        }
        return null;
      }
    }, {
      key: "getNode",
      value: function(te) {
        for (var J = this.root; J; ) {
          if (this.isEqual(te, J.key))
            return J;
          this.isLessThan(te, J.key) ? J = J.left : J = J.right;
        }
        return null;
      }
    }, {
      key: "rebalance",
      value: function(te) {
        te.balanceFactor < 0 ? te.right.balanceFactor > 0 ? (this.rotateRight(te.right), this.rotateLeft(te)) : this.rotateLeft(te) : te.balanceFactor > 0 && (te.left.balanceFactor < 0 ? (this.rotateLeft(te.left), this.rotateRight(te)) : this.rotateRight(te));
      }
    }, {
      key: "rotateLeft",
      value: function(te) {
        var J = te.right;
        te.right = J.left, J.left !== null && (J.left.parent = te), J.parent = te.parent, J.parent === null ? this.root = J : te.isLeftChild ? J.parent.left = J : J.parent.right = J, J.left = te, te.parent = J, te.balanceFactor = te.balanceFactor + 1 - Math.min(J.balanceFactor, 0), J.balanceFactor = J.balanceFactor + 1 - Math.max(te.balanceFactor, 0);
      }
    }, {
      key: "rotateRight",
      value: function(te) {
        var J = te.left;
        te.left = J.right, J.right !== null && (J.right.parent = te), J.parent = te.parent, J.parent === null ? this.root = J : te.isLeftChild ? J.parent.left = J : J.parent.right = J, J.right = te, te.parent = J, te.balanceFactor = te.balanceFactor - 1 - Math.min(J.balanceFactor, 0), J.balanceFactor = J.balanceFactor - 1 - Math.max(te.balanceFactor, 0);
      }
    }, {
      key: _e,
      value: /* @__PURE__ */ k.default.mark(function Q() {
        var te, J, fe;
        return k.default.wrap(function(ke) {
          for (; ; )
            switch (ke.prev = ke.next) {
              case 0:
                te = Yr(this.getIterator()), ke.prev = 1, te.s();
              case 3:
                if ((J = te.n()).done) {
                  ke.next = 9;
                  break;
                }
                return fe = J.value, ke.next = 7, fe;
              case 7:
                ke.next = 3;
                break;
              case 9:
                ke.next = 14;
                break;
              case 11:
                ke.prev = 11, ke.t0 = ke.catch(1), te.e(ke.t0);
              case 14:
                return ke.prev = 14, te.f(), ke.finish(14);
              case 17:
              case "end":
                return ke.stop();
            }
        }, Q, this, [[1, 11, 14, 17]]);
      })
    }, {
      key: "getIterator",
      value: /* @__PURE__ */ k.default.mark(function Q() {
        var te, J, fe, le = arguments;
        return k.default.wrap(function(X) {
          for (; ; )
            switch (X.prev = X.next) {
              case 0:
                te = le.length > 0 && le[0] !== void 0 ? le[0] : null, J = this.root;
              case 2:
                if (!J) {
                  X.next = 8;
                  break;
                }
                if (!(this.isEqual(te, J.key) || te === null && !J.left)) {
                  X.next = 5;
                  break;
                }
                return X.abrupt("break", 8);
              case 5:
                this.isLessThan(te, J.key) || te === null ? J = J.left : J = J.right, X.next = 2;
                break;
              case 8:
                if (J) {
                  X.next = 10;
                  break;
                }
                return X.abrupt("return", null);
              case 10:
                fe = !0;
              case 11:
                if (!fe) {
                  X.next = 29;
                  break;
                }
                return X.next = 14, [J.key, J.value];
              case 14:
                if (fe = !1, !J.right) {
                  X.next = 21;
                  break;
                }
                for (J = J.right; J.left; )
                  J = J.left;
                fe = !0, X.next = 27;
                break;
              case 21:
                if (!J.parent) {
                  X.next = 26;
                  break;
                }
                fe = J.parent.left === J, J = J.parent, X.next = 27;
                break;
              case 26:
                return X.abrupt("break", 37);
              case 27:
                X.next = 35;
                break;
              case 29:
                if (!J.parent) {
                  X.next = 34;
                  break;
                }
                fe = J.parent.left === J, J = J.parent, X.next = 35;
                break;
              case 34:
                return X.abrupt("break", 37);
              case 35:
                X.next = 11;
                break;
              case 37:
                return X.abrupt("return", null);
              case 38:
              case "end":
                return X.stop();
            }
        }, Q, this);
      })
    }, {
      key: "getReverseIterator",
      value: /* @__PURE__ */ k.default.mark(function Q() {
        var te, J, fe, le = arguments;
        return k.default.wrap(function(X) {
          for (; ; )
            switch (X.prev = X.next) {
              case 0:
                te = le.length > 0 && le[0] !== void 0 ? le[0] : null, J = this.root;
              case 2:
                if (!J) {
                  X.next = 8;
                  break;
                }
                if (!(this.isEqual(te, J.key) || te === null && !J.right)) {
                  X.next = 5;
                  break;
                }
                return X.abrupt("break", 8);
              case 5:
                !this.isLessThan(te, J.key) || te === null ? J = J.right : J = J.left, X.next = 2;
                break;
              case 8:
                if (J) {
                  X.next = 10;
                  break;
                }
                return X.abrupt("return", null);
              case 10:
                fe = !0;
              case 11:
                if (!fe) {
                  X.next = 29;
                  break;
                }
                return X.next = 14, [J.key, J.value];
              case 14:
                if (fe = !1, !J.left) {
                  X.next = 21;
                  break;
                }
                for (J = J.left; J.right; )
                  J = J.right;
                fe = !0, X.next = 27;
                break;
              case 21:
                if (!J.parent) {
                  X.next = 26;
                  break;
                }
                fe = J.parent.right === J, J = J.parent, X.next = 27;
                break;
              case 26:
                return X.abrupt("break", 37);
              case 27:
                X.next = 35;
                break;
              case 29:
                if (!J.parent) {
                  X.next = 34;
                  break;
                }
                fe = J.parent.right === J, J = J.parent, X.next = 35;
                break;
              case 34:
                return X.abrupt("break", 37);
              case 35:
                X.next = 11;
                break;
              case 37:
                return X.abrupt("return", null);
              case 38:
              case "end":
                return X.stop();
            }
        }, Q, this);
      })
    }]), Pe;
  }(Symbol.iterator);
  function tn(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = Kn(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function Kn(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return Pr(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return Pr(_e, Pe);
    }
  }
  function Pr(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  var Pt = /* @__PURE__ */ function() {
    function _e(Pe, Q) {
      var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, J = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      M.default(this, _e), this._data = Pe, this.lastEventId = Q || 0, this.isLeftBound = te, this.isRightBound = J;
    }
    return B.default(_e, [{
      key: "isValid",
      get: function() {
        return !0;
      }
    }, {
      key: "value",
      get: function() {
        return this._data;
      }
    }]), _e;
  }(), or = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), this.lastEventId = Pe, this.isLeftBound = !1, this.isRightBound = !1;
    }
    return B.default(_e, [{
      key: "isValid",
      get: function() {
        return !1;
      }
    }, {
      key: "value",
      get: function() {
        return null;
      }
    }]), _e;
  }(), Ht = /* @__PURE__ */ function() {
    function _e() {
      M.default(this, _e), v.default(this, "items", new fr()), v.default(this, "beginKey", null), v.default(this, "endKey", null), this.items.clear();
    }
    return B.default(_e, [{
      key: "size",
      get: function() {
        return this.items.size;
      }
    }, {
      key: "collectionBegin",
      get: function() {
        return this.beginKey;
      }
    }, {
      key: "collectionEnd",
      get: function() {
        return this.endKey;
      }
    }, {
      key: "has",
      value: function(Q) {
        var te, J = this.items.get(Q);
        return (te = J == null ? void 0 : J.isValid) !== null && te !== void 0 ? te : !1;
      }
      // Whether an entry exists in the cache either as a value or a tombstone.
    }, {
      key: "exists",
      value: function(Q) {
        var te = this.items.get(Q);
        return !!te;
      }
      // Return only cached value or null if it is missing or marked with a tombstone.
    }, {
      key: "getValue",
      value: function(Q) {
        var te, J = this.items.get(Q);
        return (te = J == null ? void 0 : J.value) !== null && te !== void 0 ? te : null;
      }
      // Return a cache entry, can either be missing (null), valid or a tombstone.
    }, {
      key: "get",
      value: function(Q) {
        return this.items.get(Q);
      }
      // Get an item next to the given key in specified search order.
    }, {
      key: "getNextItem",
      value: function(Q, te, J) {
        return Q === null ? this.getFirstItem(te) : J ? this.getValue(Q) : this.getAdjacentItem(Q, te);
      }
      // Find the first item in the cache based on query order.
      // @internal
    }, {
      key: "getFirstItem",
      value: function(Q) {
        var te = Q === "asc" ? this.beginKey : this.endKey;
        if (this.exists(te)) {
          var J = this.items.get(te);
          return J.isValid ? J.value : this.getAdjacentItem(te, Q);
        }
        return null;
      }
      // Find the first valid item next to the given one.
      // @internal
    }, {
      key: "getAdjacentItem",
      value: function(Q, te) {
        var J = te === "asc" ? this.items.getIterator(Q) : this.items.getReverseIterator(Q), fe = tn(J), le;
        try {
          for (fe.s(); !(le = fe.n()).done; ) {
            var ke = j.default(le.value, 2), X = ke[0], he = ke[1];
            if (te === "asc" ? he.isRightBound : he.isLeftBound)
              break;
            if (he.isValid)
              return he.value;
          }
        } catch ($e) {
          fe.e($e);
        } finally {
          fe.f();
        }
        return null;
      }
    }, {
      key: "store",
      value: function(Q, te, J) {
        var fe = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, le = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, ke = this.items.get(Q);
        return ke && ke.lastEventId > J ? ke.value : (this.items.set(Q, new Pt(te, J, ke ? ke.isLeftBound && fe : fe, ke ? ke.isRightBound && le : le)), this.beginKey && Q < this.beginKey && (this.beginKey = Q), this.endKey && this.endKey < Q && (this.endKey = Q), te);
      }
      // Populate a contiguous range of items from a paginator page.
    }, {
      key: "populate",
      value: function(Q, te, J) {
        var fe = this;
        if (Q.length) {
          var le = W.default(Q);
          if (le.sort(function(he, $e) {
            return he.cacheKey === $e.cacheKey ? 0 : he.cacheKey > $e.cacheKey ? 1 : -1;
          }), le.forEach(function(he, $e) {
            fe.store(he.cacheKey, he, he.lastEventId, $e === 0, $e === le.length - 1);
          }), te) {
            var ke = le[0].cacheKey;
            (!this.beginKey || ke < this.beginKey) && (this.beginKey = ke);
          }
          if (J) {
            var X = le[le.length - 1].cacheKey;
            (!this.endKey || this.endKey < X) && (this.endKey = X);
          }
        }
      }
    }, {
      key: "delete",
      value: function(Q, te) {
        var J = this.items.get(Q);
        (J === null || te === null || J.lastEventId < te) && this.items.set(Q, new or(te));
      }
      // Shall we ignore the item with this key in an update?
    }, {
      key: "isKnown",
      value: function(Q, te) {
        var J = this.items.get(Q);
        return J && J.lastEventId >= te;
      }
    }, {
      key: "getIterator",
      value: /* @__PURE__ */ k.default.mark(function Pe(Q) {
        var te, J, fe, le;
        return k.default.wrap(function(X) {
          for (; ; )
            switch (X.prev = X.next) {
              case 0:
                if (Q === null && this.beginKey !== null && (Q = this.beginKey), Q !== null) {
                  X.next = 3;
                  break;
                }
                return X.abrupt("return");
              case 3:
                te = tn(this.items.getIterator(Q)), X.prev = 4, te.s();
              case 6:
                if ((J = te.n()).done) {
                  X.next = 16;
                  break;
                }
                if (fe = j.default(J.value, 2), le = fe[1], le.isValid) {
                  X.next = 10;
                  break;
                }
                return X.abrupt("continue", 14);
              case 10:
                return X.next = 12, le;
              case 12:
                if (!le.isRightBound) {
                  X.next = 14;
                  break;
                }
                return X.abrupt("break", 16);
              case 14:
                X.next = 6;
                break;
              case 16:
                X.next = 21;
                break;
              case 18:
                X.prev = 18, X.t0 = X.catch(4), te.e(X.t0);
              case 21:
                return X.prev = 21, te.f(), X.finish(21);
              case 24:
              case "end":
                return X.stop();
            }
        }, Pe, this, [[4, 18, 21, 24]]);
      })
    }, {
      key: "getReverseIterator",
      value: /* @__PURE__ */ k.default.mark(function Pe(Q) {
        var te, J, fe, le;
        return k.default.wrap(function(X) {
          for (; ; )
            switch (X.prev = X.next) {
              case 0:
                if (Q === null && this.endKey !== null && (Q = this.endKey), Q !== null) {
                  X.next = 3;
                  break;
                }
                return X.abrupt("return");
              case 3:
                te = tn(this.items.getReverseIterator(Q)), X.prev = 4, te.s();
              case 6:
                if ((J = te.n()).done) {
                  X.next = 16;
                  break;
                }
                if (fe = j.default(J.value, 2), le = fe[1], le.isValid) {
                  X.next = 10;
                  break;
                }
                return X.abrupt("continue", 14);
              case 10:
                return X.next = 12, le;
              case 12:
                if (!le.isLeftBound) {
                  X.next = 14;
                  break;
                }
                return X.abrupt("break", 16);
              case 14:
                X.next = 6;
                break;
              case 16:
                X.next = 21;
                break;
              case 18:
                X.prev = 18, X.t0 = X.catch(4), te.e(X.t0);
              case 21:
                return X.prev = 21, te.f(), X.finish(21);
              case 24:
              case "end":
                return X.stop();
            }
        }, Pe, this, [[4, 18, 21, 24]]);
      })
    }, {
      key: "forEach",
      value: function(Q) {
        if (this.items) {
          var te = tn(this.items), J;
          try {
            for (te.s(); !(J = te.n()).done; ) {
              var fe = j.default(J.value, 2), le = fe[0], ke = fe[1];
              ke.isValid && Q(le, ke.value);
            }
          } catch (X) {
            te.e(X);
          } finally {
            te.f();
          }
        }
      }
    }]), _e;
  }(), Mt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof wl < "u" ? wl : typeof self < "u" ? self : {}, Qt = { exports: {} };
  (function(_e, Pe) {
    (function() {
      var Q, te = "4.17.21", J = 200, fe = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", le = "Expected a function", ke = "Invalid `variable` option passed into `_.template`", X = "__lodash_hash_undefined__", he = 500, $e = "__lodash_placeholder__", Ct = 1, Bt = 2, St = 4, ir = 1, Ir = 2, Sr = 1, Vr = 2, ri = 4, ni = 8, Yn = 16, ja = 32, Rr = 64, _o = 128, Ee = 256, je = 512, be = 30, oe = "...", ae = 800, xe = 16, ue = 1, pe = 2, ve = 3, ye = 1 / 0, Ae = 9007199254740991, Qe = 17976931348623157e292, pt = NaN, Tt = 4294967295, zt = Tt - 1, mn = Tt >>> 1, Tn = [["ary", _o], ["bind", Sr], ["bindKey", Vr], ["curry", ni], ["curryRight", Yn], ["flip", je], ["partial", ja], ["partialRight", Rr], ["rearg", Ee]], Zn = "[object Arguments]", ia = "[object Array]", Fs = "[object AsyncFunction]", Ki = "[object Boolean]", Wn = "[object Date]", Xs = "[object DOMException]", Ef = "[object Error]", Mn = "[object Function]", Ku = "[object GeneratorFunction]", jo = "[object Map]", fp = "[object Number]", IP = "[object Null]", If = "[object Object]", k6 = "[object Promise]", hC = "[object Proxy]", s3 = "[object RegExp]", Zu = "[object Set]", Ol = "[object String]", _g = "[object Symbol]", l3 = "[object Undefined]", kg = "[object WeakMap]", MP = "[object WeakSet]", c3 = "[object ArrayBuffer]", Ag = "[object DataView]", pC = "[object Float32Array]", mC = "[object Float64Array]", gC = "[object Int8Array]", x2 = "[object Int16Array]", vC = "[object Int32Array]", yC = "[object Uint8Array]", u3 = "[object Uint8ClampedArray]", A6 = "[object Uint16Array]", T0 = "[object Uint32Array]", T6 = /\b__p \+= '';/g, sU = /\b(__p \+=) '' \+/g, lU = /(__e\(.*?\)|\b__t\)) \+\n'';/g, PP = /&(?:amp|lt|gt|quot|#39);/g, hp = /[&<>"']/g, $d = RegExp(PP.source), RP = RegExp(hp.source), cU = /<%-([\s\S]+?)%>/g, uU = /<%([\s\S]+?)%>/g, OP = /<%=([\s\S]+?)%>/g, dU = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, fU = /^\w*$/, Tg = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $t = /[\\^$.*+?()[\]{}|]/g, lr = RegExp($t.source), tr = /^\s+/, vn = /\s/, Fa = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, co = /\{\n\/\* \[wrapped with (.+)\] \*/, Qs = /,? & /, Ro = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, bC = /[()=,{}\[\]\/\s]/, hU = /\\(\\)?/g, Ju = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, d3 = /\w*$/, pU = /^[-+]0x[0-9a-f]+$/i, Eg = /^0b[01]+$/i, E6 = /^\[object .+?Constructor\]$/, I6 = /^0o[0-7]+$/i, bo = /^(?:0|[1-9]\d*)$/, mU = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, f3 = /($^)/, M6 = /['\n\r\u2028\u2029\\]/g, P6 = "\\ud800-\\udfff", gU = "\\u0300-\\u036f", vU = "\\ufe20-\\ufe2f", R6 = "\\u20d0-\\u20ff", Mf = gU + vU + R6, h3 = "\\u2700-\\u27bf", xC = "a-z\\xdf-\\xf6\\xf8-\\xff", O6 = "\\xac\\xb1\\xd7\\xf7", BP = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", NP = "\\u2000-\\u206f", B6 = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", CC = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ig = "\\ufe0e\\ufe0f", C2 = O6 + BP + NP + B6, Mg = "['’]", yU = "[" + P6 + "]", $P = "[" + C2 + "]", N6 = "[" + Mf + "]", p3 = "\\d+", $6 = "[" + h3 + "]", D6 = "[" + xC + "]", DP = "[^" + P6 + C2 + p3 + h3 + xC + CC + "]", L6 = "\\ud83c[\\udffb-\\udfff]", bU = "(?:" + N6 + "|" + L6 + ")", LP = "[^" + P6 + "]", Ms = "(?:\\ud83c[\\udde6-\\uddff]){2}", hl = "[\\ud800-\\udbff][\\udc00-\\udfff]", Pg = "[" + CC + "]", jP = "\\u200d", wC = "(?:" + D6 + "|" + DP + ")", xU = "(?:" + Pg + "|" + DP + ")", j6 = "(?:" + Mg + "(?:d|ll|m|re|s|t|ve))?", Rg = "(?:" + Mg + "(?:D|LL|M|RE|S|T|VE))?", F6 = bU + "?", pp = "[" + Ig + "]?", m3 = "(?:" + jP + "(?:" + [LP, Ms, hl].join("|") + ")" + pp + F6 + ")*", g3 = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", z6 = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", mp = pp + F6 + m3, CU = "(?:" + [$6, Ms, hl].join("|") + ")" + mp, wU = "(?:" + [LP + N6 + "?", N6, Ms, hl, yU].join("|") + ")", SU = RegExp(Mg, "g"), _U = RegExp(N6, "g"), SC = RegExp(L6 + "(?=" + L6 + ")|" + wU + mp, "g"), G6 = RegExp([Pg + "?" + D6 + "+" + j6 + "(?=" + [$P, Pg, "$"].join("|") + ")", xU + "+" + Rg + "(?=" + [$P, Pg + wC, "$"].join("|") + ")", Pg + "?" + wC + "+" + j6, Pg + "+" + Rg, z6, g3, p3, CU].join("|"), "g"), v3 = RegExp("[" + jP + P6 + Mf + Ig + "]"), FP = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, He = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"], Og = -1, ko = {};
      ko[pC] = ko[mC] = ko[gC] = ko[x2] = ko[vC] = ko[yC] = ko[u3] = ko[A6] = ko[T0] = !0, ko[Zn] = ko[ia] = ko[c3] = ko[Ki] = ko[Ag] = ko[Wn] = ko[Ef] = ko[Mn] = ko[jo] = ko[fp] = ko[If] = ko[s3] = ko[Zu] = ko[Ol] = ko[kg] = !1;
      var Oi = {};
      Oi[Zn] = Oi[ia] = Oi[c3] = Oi[Ag] = Oi[Ki] = Oi[Wn] = Oi[pC] = Oi[mC] = Oi[gC] = Oi[x2] = Oi[vC] = Oi[jo] = Oi[fp] = Oi[If] = Oi[s3] = Oi[Zu] = Oi[Ol] = Oi[_g] = Oi[yC] = Oi[u3] = Oi[A6] = Oi[T0] = !0, Oi[Ef] = Oi[Mn] = Oi[kg] = !1;
      var $i = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, kU = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, AU = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'" }, TU = { "\\": "\\", "'": "'", "\n": "n", "\r": "r", "\u2028": "u2028", "\u2029": "u2029" }, gp = parseFloat, EU = parseInt, zP = O.default(Mt) == "object" && Mt && Mt.Object === Object && Mt, IU = (typeof self > "u" ? "undefined" : O.default(self)) == "object" && self && self.Object === Object && self, Bl = zP || IU || Function("return this")(), _C = Pe && !Pe.nodeType && Pe, uc = _C && !0 && _e && !_e.nodeType && _e, GP = uc && uc.exports === _C, kC = GP && zP.process, Yu = function() {
        try {
          var Dt = uc && uc.require && uc.require("util").types;
          return Dt || kC && kC.binding && kC.binding("util");
        } catch {
        }
      }(), WP = Yu && Yu.isArrayBuffer, HP = Yu && Yu.isDate, E0 = Yu && Yu.isMap, UP = Yu && Yu.isRegExp, VP = Yu && Yu.isSet, qP = Yu && Yu.isTypedArray;
      function ou(Dt, cr, rr) {
        switch (rr.length) {
          case 0:
            return Dt.call(cr);
          case 1:
            return Dt.call(cr, rr[0]);
          case 2:
            return Dt.call(cr, rr[0], rr[1]);
          case 3:
            return Dt.call(cr, rr[0], rr[1], rr[2]);
        }
        return Dt.apply(cr, rr);
      }
      function MU(Dt, cr, rr, gn) {
        for (var Sa = -1, uo = Dt == null ? 0 : Dt.length; ++Sa < uo; ) {
          var Ps = Dt[Sa];
          cr(gn, Ps, rr(Ps), Dt);
        }
        return gn;
      }
      function pl(Dt, cr) {
        for (var rr = -1, gn = Dt == null ? 0 : Dt.length; ++rr < gn && cr(Dt[rr], rr, Dt) !== !1; )
          ;
        return Dt;
      }
      function PU(Dt, cr) {
        for (var rr = Dt == null ? 0 : Dt.length; rr-- && cr(Dt[rr], rr, Dt) !== !1; )
          ;
        return Dt;
      }
      function KP(Dt, cr) {
        for (var rr = -1, gn = Dt == null ? 0 : Dt.length; ++rr < gn; )
          if (!cr(Dt[rr], rr, Dt))
            return !1;
        return !0;
      }
      function ml(Dt, cr) {
        for (var rr = -1, gn = Dt == null ? 0 : Dt.length, Sa = 0, uo = []; ++rr < gn; ) {
          var Ps = Dt[rr];
          cr(Ps, rr, Dt) && (uo[Sa++] = Ps);
        }
        return uo;
      }
      function W6(Dt, cr) {
        var rr = Dt == null ? 0 : Dt.length;
        return !!rr && Ng(Dt, cr, 0) > -1;
      }
      function AC(Dt, cr, rr) {
        for (var gn = -1, Sa = Dt == null ? 0 : Dt.length; ++gn < Sa; )
          if (rr(cr, Dt[gn]))
            return !0;
        return !1;
      }
      function Yo(Dt, cr) {
        for (var rr = -1, gn = Dt == null ? 0 : Dt.length, Sa = Array(gn); ++rr < gn; )
          Sa[rr] = cr(Dt[rr], rr, Dt);
        return Sa;
      }
      function w2(Dt, cr) {
        for (var rr = -1, gn = cr.length, Sa = Dt.length; ++rr < gn; )
          Dt[Sa + rr] = cr[rr];
        return Dt;
      }
      function TC(Dt, cr, rr, gn) {
        var Sa = -1, uo = Dt == null ? 0 : Dt.length;
        for (gn && uo && (rr = Dt[++Sa]); ++Sa < uo; )
          rr = cr(rr, Dt[Sa], Sa, Dt);
        return rr;
      }
      function ZP(Dt, cr, rr, gn) {
        var Sa = Dt == null ? 0 : Dt.length;
        for (gn && Sa && (rr = Dt[--Sa]); Sa--; )
          rr = cr(rr, Dt[Sa], Sa, Dt);
        return rr;
      }
      function H6(Dt, cr) {
        for (var rr = -1, gn = Dt == null ? 0 : Dt.length; ++rr < gn; )
          if (cr(Dt[rr], rr, Dt))
            return !0;
        return !1;
      }
      var RU = y3("length");
      function OU(Dt) {
        return Dt.split("");
      }
      function EC(Dt) {
        return Dt.match(Ro) || [];
      }
      function Bg(Dt, cr, rr) {
        var gn;
        return rr(Dt, function(Sa, uo, Ps) {
          if (cr(Sa, uo, Ps))
            return gn = uo, !1;
        }), gn;
      }
      function vp(Dt, cr, rr, gn) {
        for (var Sa = Dt.length, uo = rr + (gn ? 1 : -1); gn ? uo-- : ++uo < Sa; )
          if (cr(Dt[uo], uo, Dt))
            return uo;
        return -1;
      }
      function Ng(Dt, cr, rr) {
        return cr === cr ? OC(Dt, cr, rr) : vp(Dt, YP, rr);
      }
      function JP(Dt, cr, rr, gn) {
        for (var Sa = rr - 1, uo = Dt.length; ++Sa < uo; )
          if (gn(Dt[Sa], cr))
            return Sa;
        return -1;
      }
      function YP(Dt) {
        return Dt !== Dt;
      }
      function I0(Dt, cr) {
        var rr = Dt == null ? 0 : Dt.length;
        return rr ? U6(Dt, cr) / rr : pt;
      }
      function y3(Dt) {
        return function(cr) {
          return cr == null ? Q : cr[Dt];
        };
      }
      function Pf(Dt) {
        return function(cr) {
          return Dt == null ? Q : Dt[cr];
        };
      }
      function su(Dt, cr, rr, gn, Sa) {
        return Sa(Dt, function(uo, Ps, Ao) {
          rr = gn ? (gn = !1, uo) : cr(rr, uo, Ps, Ao);
        }), rr;
      }
      function BU(Dt, cr) {
        var rr = Dt.length;
        for (Dt.sort(cr); rr--; )
          Dt[rr] = Dt[rr].value;
        return Dt;
      }
      function U6(Dt, cr) {
        for (var rr, gn = -1, Sa = Dt.length; ++gn < Sa; ) {
          var uo = cr(Dt[gn]);
          uo !== Q && (rr = rr === Q ? uo : rr + uo);
        }
        return rr;
      }
      function V6(Dt, cr) {
        for (var rr = -1, gn = Array(Dt); ++rr < Dt; )
          gn[rr] = cr(rr);
        return gn;
      }
      function b3(Dt, cr) {
        return Yo(cr, function(rr) {
          return [rr, Dt[rr]];
        });
      }
      function Rf(Dt) {
        return Dt && Dt.slice(0, tR(Dt) + 1).replace(tr, "");
      }
      function $c(Dt) {
        return function(cr) {
          return Dt(cr);
        };
      }
      function IC(Dt, cr) {
        return Yo(cr, function(rr) {
          return Dt[rr];
        });
      }
      function S2(Dt, cr) {
        return Dt.has(cr);
      }
      function XP(Dt, cr) {
        for (var rr = -1, gn = Dt.length; ++rr < gn && Ng(cr, Dt[rr], 0) > -1; )
          ;
        return rr;
      }
      function MC(Dt, cr) {
        for (var rr = Dt.length; rr-- && Ng(cr, Dt[rr], 0) > -1; )
          ;
        return rr;
      }
      function Nl(Dt, cr) {
        for (var rr = Dt.length, gn = 0; rr--; )
          Dt[rr] === cr && ++gn;
        return gn;
      }
      var PC = Pf($i), QP = Pf(kU);
      function M0(Dt) {
        return "\\" + TU[Dt];
      }
      function RC(Dt, cr) {
        return Dt == null ? Q : Dt[cr];
      }
      function Of(Dt) {
        return v3.test(Dt);
      }
      function yp(Dt) {
        return FP.test(Dt);
      }
      function eR(Dt) {
        for (var cr, rr = []; !(cr = Dt.next()).done; )
          rr.push(cr.value);
        return rr;
      }
      function $l(Dt) {
        var cr = -1, rr = Array(Dt.size);
        return Dt.forEach(function(gn, Sa) {
          rr[++cr] = [Sa, gn];
        }), rr;
      }
      function q6(Dt, cr) {
        return function(rr) {
          return Dt(cr(rr));
        };
      }
      function _2(Dt, cr) {
        for (var rr = -1, gn = Dt.length, Sa = 0, uo = []; ++rr < gn; ) {
          var Ps = Dt[rr];
          (Ps === cr || Ps === $e) && (Dt[rr] = $e, uo[Sa++] = rr);
        }
        return uo;
      }
      function K6(Dt) {
        var cr = -1, rr = Array(Dt.size);
        return Dt.forEach(function(gn) {
          rr[++cr] = gn;
        }), rr;
      }
      function NU(Dt) {
        var cr = -1, rr = Array(Dt.size);
        return Dt.forEach(function(gn) {
          rr[++cr] = [gn, gn];
        }), rr;
      }
      function OC(Dt, cr, rr) {
        for (var gn = rr - 1, Sa = Dt.length; ++gn < Sa; )
          if (Dt[gn] === cr)
            return gn;
        return -1;
      }
      function $U(Dt, cr, rr) {
        for (var gn = rr + 1; gn--; )
          if (Dt[gn] === cr)
            return gn;
        return gn;
      }
      function P0(Dt) {
        return Of(Dt) ? x3(Dt) : RU(Dt);
      }
      function Xu(Dt) {
        return Of(Dt) ? LU(Dt) : OU(Dt);
      }
      function tR(Dt) {
        for (var cr = Dt.length; cr-- && vn.test(Dt.charAt(cr)); )
          ;
        return cr;
      }
      var DU = Pf(AU);
      function x3(Dt) {
        for (var cr = SC.lastIndex = 0; SC.test(Dt); )
          ++cr;
        return cr;
      }
      function LU(Dt) {
        return Dt.match(SC) || [];
      }
      function jU(Dt) {
        return Dt.match(G6) || [];
      }
      var BC = function Dt(cr) {
        cr = cr == null ? Bl : bp.defaults(Bl.Object(), cr, bp.pick(Bl, He));
        var rr = cr.Array, gn = cr.Date, Sa = cr.Error, uo = cr.Function, Ps = cr.Math, Ao = cr.Object, Z6 = cr.RegExp, rR = cr.String, dc = cr.TypeError, J6 = rr.prototype, nR = uo.prototype, xp = Ao.prototype, Y6 = cr["__core-js_shared__"], C3 = nR.toString, xo = xp.hasOwnProperty, NC = 0, $C = function() {
          var E = /[^.]+$/.exec(Y6 && Y6.keys && Y6.keys.IE_PROTO || "");
          return E ? "Symbol(src)_1." + E : "";
        }(), $g = xp.toString, FU = C3.call(Ao), DC = Bl._, yi = Z6("^" + C3.call(xo).replace($t, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), X6 = GP ? cr.Buffer : Q, k2 = cr.Symbol, A2 = cr.Uint8Array, LC = X6 ? X6.allocUnsafe : Q, Q6 = q6(Ao.getPrototypeOf, Ao), aR = Ao.create, lu = xp.propertyIsEnumerable, e4 = J6.splice, w3 = k2 ? k2.isConcatSpreadable : Q, Cp = k2 ? k2.iterator : Q, T2 = k2 ? k2.toStringTag : Q, S3 = function() {
          try {
            var E = $2(Ao, "defineProperty");
            return E({}, "", {}), E;
          } catch {
          }
        }(), cu = cr.clearTimeout !== Bl.clearTimeout && cr.clearTimeout, E2 = gn && gn.now !== Bl.Date.now && gn.now, jC = cr.setTimeout !== Bl.setTimeout && cr.setTimeout, _3 = Ps.ceil, wp = Ps.floor, t4 = Ao.getOwnPropertySymbols, FC = X6 ? X6.isBuffer : Q, zC = cr.isFinite, GC = J6.join, WC = q6(Ao.keys, Ao), Fo = Ps.max, Zl = Ps.min, I2 = gn.now, iR = cr.parseInt, HC = Ps.random, UC = J6.reverse, VC = $2(cr, "DataView"), k3 = $2(cr, "Map"), qC = $2(cr, "Promise"), Sp = $2(cr, "Set"), Dg = $2(cr, "WeakMap"), A3 = $2(Ao, "create"), T3 = Dg && new Dg(), _p = {}, Dc = Mp(VC), R0 = Mp(k3), zU = Mp(qC), GU = Mp(Sp), r4 = Mp(Dg), Bf = k2 ? k2.prototype : Q, Lg = Bf ? Bf.valueOf : Q, KC = Bf ? Bf.toString : Q;
        function Ue(E) {
          if (ws(E) && !Ha(E) && !(E instanceof Di)) {
            if (E instanceof Jl)
              return E;
            if (xo.call(E, "__wrapped__"))
              return kw(E);
          }
          return new Jl(E);
        }
        var kp = /* @__PURE__ */ function() {
          function E() {
          }
          return function(D) {
            if (!gs(D))
              return {};
            if (aR)
              return aR(D);
            E.prototype = D;
            var K = new E();
            return E.prototype = Q, K;
          };
        }();
        function Nf() {
        }
        function Jl(E, D) {
          this.__wrapped__ = E, this.__actions__ = [], this.__chain__ = !!D, this.__index__ = 0, this.__values__ = Q;
        }
        Ue.templateSettings = {
          /**
          * Used to detect `data` property values to be HTML-escaped.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          escape: cU,
          /**
          * Used to detect code to be evaluated.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          evaluate: uU,
          /**
          * Used to detect `data` property values to inject.
          *
          * @memberOf _.templateSettings
          * @type {RegExp}
          */
          interpolate: OP,
          /**
          * Used to reference the data object in the template text.
          *
          * @memberOf _.templateSettings
          * @type {string}
          */
          variable: "",
          /**
          * Used to import variables into the compiled template.
          *
          * @memberOf _.templateSettings
          * @type {Object}
          */
          imports: {
            /**
            * A reference to the `lodash` function.
            *
            * @memberOf _.templateSettings.imports
            * @type {Function}
            */
            _: Ue
          }
        }, Ue.prototype = Nf.prototype, Ue.prototype.constructor = Ue, Jl.prototype = kp(Nf.prototype), Jl.prototype.constructor = Jl;
        function Di(E) {
          this.__wrapped__ = E, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Tt, this.__views__ = [];
        }
        function oR() {
          var E = new Di(this.__wrapped__);
          return E.__actions__ = Lc(this.__actions__), E.__dir__ = this.__dir__, E.__filtered__ = this.__filtered__, E.__iteratees__ = Lc(this.__iteratees__), E.__takeCount__ = this.__takeCount__, E.__views__ = Lc(this.__views__), E;
        }
        function sR() {
          if (this.__filtered__) {
            var E = new Di(this);
            E.__dir__ = -1, E.__filtered__ = !0;
          } else
            E = this.clone(), E.__dir__ *= -1;
          return E;
        }
        function n4() {
          var E = this.__wrapped__.value(), D = this.__dir__, K = Ha(E), me = D < 0, Re = K ? E.length : 0, et = k4(0, Re, this.__views__), wt = et.start, It = et.end, Gt = It - wt, Cr = me ? It : wt - 1, wr = this.__iteratees__, Tr = wr.length, rn = 0, Rn = Zl(Gt, this.__takeCount__);
          if (!K || !me && Re == Gt && Rn == Gt)
            return FR(E, this.__actions__);
          var oa = [];
          e: for (; Gt-- && rn < Rn; ) {
            Cr += D;
            for (var Si = -1, sa = E[Cr]; ++Si < Tr; ) {
              var Wi = wr[Si], Ji = Wi.iteratee, Wc = Wi.type, mu = Ji(sa);
              if (Wc == pe)
                sa = mu;
              else if (!mu) {
                if (Wc == ue)
                  continue e;
                break e;
              }
            }
            oa[rn++] = sa;
          }
          return oa;
        }
        Di.prototype = kp(Nf.prototype), Di.prototype.constructor = Di;
        function M2(E) {
          var D = -1, K = E == null ? 0 : E.length;
          for (this.clear(); ++D < K; ) {
            var me = E[D];
            this.set(me[0], me[1]);
          }
        }
        function a4() {
          this.__data__ = A3 ? A3(null) : {}, this.size = 0;
        }
        function ZC(E) {
          var D = this.has(E) && delete this.__data__[E];
          return this.size -= D ? 1 : 0, D;
        }
        function i4(E) {
          var D = this.__data__;
          if (A3) {
            var K = D[E];
            return K === X ? Q : K;
          }
          return xo.call(D, E) ? D[E] : Q;
        }
        function WU(E) {
          var D = this.__data__;
          return A3 ? D[E] !== Q : xo.call(D, E);
        }
        function lR(E, D) {
          var K = this.__data__;
          return this.size += this.has(E) ? 0 : 1, K[E] = A3 && D === Q ? X : D, this;
        }
        M2.prototype.clear = a4, M2.prototype.delete = ZC, M2.prototype.get = i4, M2.prototype.has = WU, M2.prototype.set = lR;
        function Qu(E) {
          var D = -1, K = E == null ? 0 : E.length;
          for (this.clear(); ++D < K; ) {
            var me = E[D];
            this.set(me[0], me[1]);
          }
        }
        function cR() {
          this.__data__ = [], this.size = 0;
        }
        function JC(E) {
          var D = this.__data__, K = l4(D, E);
          if (K < 0)
            return !1;
          var me = D.length - 1;
          return K == me ? D.pop() : e4.call(D, K, 1), --this.size, !0;
        }
        function HU(E) {
          var D = this.__data__, K = l4(D, E);
          return K < 0 ? Q : D[K][1];
        }
        function uR(E) {
          return l4(this.__data__, E) > -1;
        }
        function $f(E, D) {
          var K = this.__data__, me = l4(K, E);
          return me < 0 ? (++this.size, K.push([E, D])) : K[me][1] = D, this;
        }
        Qu.prototype.clear = cR, Qu.prototype.delete = JC, Qu.prototype.get = HU, Qu.prototype.has = uR, Qu.prototype.set = $f;
        function O0(E) {
          var D = -1, K = E == null ? 0 : E.length;
          for (this.clear(); ++D < K; ) {
            var me = E[D];
            this.set(me[0], me[1]);
          }
        }
        function dR() {
          this.size = 0, this.__data__ = { hash: new M2(), map: new (k3 || Qu)(), string: new M2() };
        }
        function UU(E) {
          var D = D3(this, E).delete(E);
          return this.size -= D ? 1 : 0, D;
        }
        function fR(E) {
          return D3(this, E).get(E);
        }
        function VU(E) {
          return D3(this, E).has(E);
        }
        function qU(E, D) {
          var K = D3(this, E), me = K.size;
          return K.set(E, D), this.size += K.size == me ? 0 : 1, this;
        }
        O0.prototype.clear = dR, O0.prototype.delete = UU, O0.prototype.get = fR, O0.prototype.has = VU, O0.prototype.set = qU;
        function fc(E) {
          var D = -1, K = E == null ? 0 : E.length;
          for (this.__data__ = new O0(); ++D < K; )
            this.add(E[D]);
        }
        function YC(E) {
          return this.__data__.set(E, X), this;
        }
        function XC(E) {
          return this.__data__.has(E);
        }
        fc.prototype.add = fc.prototype.push = YC, fc.prototype.has = XC;
        function uu(E) {
          var D = this.__data__ = new Qu(E);
          this.size = D.size;
        }
        function o4() {
          this.__data__ = new Qu(), this.size = 0;
        }
        function jg(E) {
          var D = this.__data__, K = D.delete(E);
          return this.size = D.size, K;
        }
        function Xn(E) {
          return this.__data__.get(E);
        }
        function s4(E) {
          return this.__data__.has(E);
        }
        function QC(E, D) {
          var K = this.__data__;
          if (K instanceof Qu) {
            var me = K.__data__;
            if (!k3 || me.length < J - 1)
              return me.push([E, D]), this.size = ++K.size, this;
            K = this.__data__ = new O0(me);
          }
          return K.set(E, D), this.size = K.size, this;
        }
        uu.prototype.clear = o4, uu.prototype.delete = jg, uu.prototype.get = Xn, uu.prototype.has = s4, uu.prototype.set = QC;
        function P2(E, D) {
          var K = Ha(E), me = !K && Rp(E), Re = !K && !me && D2(E), et = !K && !me && !Re && Zr(E), wt = K || me || Re || et, It = wt ? V6(E.length, rR) : [], Gt = It.length;
          for (var Cr in E)
            (D || xo.call(E, Cr)) && !(wt && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Cr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            Re && (Cr == "offset" || Cr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            et && (Cr == "buffer" || Cr == "byteLength" || Cr == "byteOffset") || // Skip index properties.
            zf(Cr, Gt))) && It.push(Cr);
          return It;
        }
        function hR(E) {
          var D = E.length;
          return D ? E[lw(0, D - 1)] : Q;
        }
        function ew(E, D) {
          return E4(Lc(E), Ap(D, 0, E.length));
        }
        function pR(E) {
          return E4(Lc(E));
        }
        function gl(E, D, K) {
          (K !== Q && !Fd(E[D], K) || K === Q && !(D in E)) && Df(E, D, K);
        }
        function E3(E, D, K) {
          var me = E[D];
          (!(xo.call(E, D) && Fd(me, K)) || K === Q && !(D in E)) && Df(E, D, K);
        }
        function l4(E, D) {
          for (var K = E.length; K--; )
            if (Fd(E[K][0], D))
              return K;
          return -1;
        }
        function mR(E, D, K, me) {
          return R2(E, function(Re, et, wt) {
            D(me, Re, K(Re), wt);
          }), me;
        }
        function gR(E, D) {
          return E && hu(D, Ql(D), E);
        }
        function vR(E, D) {
          return E && hu(D, id(D), E);
        }
        function Df(E, D, K) {
          D == "__proto__" && S3 ? S3(E, D, { configurable: !0, enumerable: !0, value: K, writable: !0 }) : E[D] = K;
        }
        function tw(E, D) {
          for (var K = -1, me = D.length, Re = rr(me), et = E == null; ++K < me; )
            Re[K] = et ? Q : oK(E, D[K]);
          return Re;
        }
        function Ap(E, D, K) {
          return E === E && (K !== Q && (E = E <= K ? E : K), D !== Q && (E = E >= D ? E : D)), E;
        }
        function zs(E, D, K, me, Re, et) {
          var wt, It = D & Ct, Gt = D & Bt, Cr = D & St;
          if (K && (wt = Re ? K(E, me, Re, et) : K(E)), wt !== Q)
            return wt;
          if (!gs(E))
            return E;
          var wr = Ha(E);
          if (wr) {
            if (wt = CV(E), !It)
              return Lc(E, wt);
          } else {
            var Tr = Yl(E), rn = Tr == Mn || Tr == Ku;
            if (D2(E))
              return gw(E, It);
            if (Tr == If || Tr == Zn || rn && !Re) {
              if (wt = Gt || rn ? {} : T4(E), !It)
                return Gt ? hV(E, vR(wt, E)) : fV(E, gR(wt, E));
            } else {
              if (!Oi[Tr])
                return Re ? E : {};
              wt = oO(E, Tr, It);
            }
          }
          et || (et = new uu());
          var Rn = et.get(E);
          if (Rn)
            return Rn;
          et.set(E, wt), yr(E) ? E.forEach(function(sa) {
            wt.add(zs(sa, D, K, sa, E, et));
          }) : DO(E) && E.forEach(function(sa, Wi) {
            wt.set(Wi, zs(sa, D, K, Wi, E, et));
          });
          var oa = Cr ? Gt ? Wg : bw : Gt ? id : Ql, Si = wr ? Q : oa(E);
          return pl(Si || E, function(sa, Wi) {
            Si && (Wi = sa, sa = E[Wi]), E3(wt, Wi, zs(sa, D, K, Wi, E, et));
          }), wt;
        }
        function hc(E) {
          var D = Ql(E);
          return function(K) {
            return c4(K, E, D);
          };
        }
        function c4(E, D, K) {
          var me = K.length;
          if (E == null)
            return !me;
          for (E = Ao(E); me--; ) {
            var Re = K[me], et = D[Re], wt = E[Re];
            if (wt === Q && !(Re in E) || !et(wt))
              return !1;
          }
          return !0;
        }
        function yR(E, D, K) {
          if (typeof E != "function")
            throw new dc(le);
          return td(function() {
            E.apply(Q, K);
          }, D);
        }
        function Tp(E, D, K, me) {
          var Re = -1, et = W6, wt = !0, It = E.length, Gt = [], Cr = D.length;
          if (!It)
            return Gt;
          K && (D = Yo(D, $c(K))), me ? (et = AC, wt = !1) : D.length >= J && (et = S2, wt = !1, D = new fc(D));
          e: for (; ++Re < It; ) {
            var wr = E[Re], Tr = K == null ? wr : K(wr);
            if (wr = me || wr !== 0 ? wr : 0, wt && Tr === Tr) {
              for (var rn = Cr; rn--; )
                if (D[rn] === Tr)
                  continue e;
              Gt.push(wr);
            } else et(D, Tr, me) || Gt.push(wr);
          }
          return Gt;
        }
        var R2 = UR(Dd), bR = UR(u4, !0);
        function I3(E, D) {
          var K = !0;
          return R2(E, function(me, Re, et) {
            return K = !!D(me, Re, et), K;
          }), K;
        }
        function M3(E, D, K) {
          for (var me = -1, Re = E.length; ++me < Re; ) {
            var et = E[me], wt = D(et);
            if (wt != null && (It === Q ? wt === wt && !br(wt) : K(wt, It)))
              var It = wt, Gt = et;
          }
          return Gt;
        }
        function xR(E, D, K, me) {
          var Re = E.length;
          for (K = Vn(K), K < 0 && (K = -K > Re ? 0 : Re + K), me = me === Q || me > Re ? Re : Vn(me), me < 0 && (me += Re), me = K > me ? 0 : Gc(me); K < me; )
            E[K++] = D;
          return E;
        }
        function CR(E, D) {
          var K = [];
          return R2(E, function(me, Re, et) {
            D(me, Re, et) && K.push(me);
          }), K;
        }
        function Dl(E, D, K, me, Re) {
          var et = -1, wt = E.length;
          for (K || (K = SV), Re || (Re = []); ++et < wt; ) {
            var It = E[et];
            D > 0 && K(It) ? D > 1 ? Dl(It, D - 1, K, me, Re) : w2(Re, It) : me || (Re[Re.length] = It);
          }
          return Re;
        }
        var rw = VR(), wR = VR(!0);
        function Dd(E, D) {
          return E && rw(E, D, Ql);
        }
        function u4(E, D) {
          return E && wR(E, D, Ql);
        }
        function d4(E, D) {
          return ml(D, function(K) {
            return Wf(E[K]);
          });
        }
        function Lf(E, D) {
          D = B2(D, E);
          for (var K = 0, me = D.length; E != null && K < me; )
            E = E[rd(D[K++])];
          return K && K == me ? E : Q;
        }
        function nw(E, D, K) {
          var me = D(E);
          return Ha(E) ? me : w2(me, K(E));
        }
        function el(E) {
          return E == null ? E === Q ? l3 : IP : T2 && T2 in Ao(E) ? nO(E) : Ip(E);
        }
        function P3(E, D) {
          return E > D;
        }
        function SR(E, D) {
          return E != null && xo.call(E, D);
        }
        function _R(E, D) {
          return E != null && D in Ao(E);
        }
        function f4(E, D, K) {
          return E >= Zl(D, K) && E < Fo(D, K);
        }
        function h4(E, D, K) {
          for (var me = K ? AC : W6, Re = E[0].length, et = E.length, wt = et, It = rr(et), Gt = 1 / 0, Cr = []; wt--; ) {
            var wr = E[wt];
            wt && D && (wr = Yo(wr, $c(D))), Gt = Zl(wr.length, Gt), It[wt] = !K && (D || Re >= 120 && wr.length >= 120) ? new fc(wt && wr) : Q;
          }
          wr = E[0];
          var Tr = -1, rn = It[0];
          e: for (; ++Tr < Re && Cr.length < Gt; ) {
            var Rn = wr[Tr], oa = D ? D(Rn) : Rn;
            if (Rn = K || Rn !== 0 ? Rn : 0, !(rn ? S2(rn, oa) : me(Cr, oa, K))) {
              for (wt = et; --wt; ) {
                var Si = It[wt];
                if (!(Si ? S2(Si, oa) : me(E[wt], oa, K)))
                  continue e;
              }
              rn && rn.push(oa), Cr.push(Rn);
            }
          }
          return Cr;
        }
        function B0(E, D, K, me) {
          return Dd(E, function(Re, et, wt) {
            D(me, K(Re), et, wt);
          }), me;
        }
        function Ld(E, D, K) {
          D = B2(D, E), E = cO(E, D);
          var me = E == null ? E : E[rd(Gs(D))];
          return me == null ? Q : ou(me, E, K);
        }
        function kR(E) {
          return ws(E) && el(E) == Zn;
        }
        function AR(E) {
          return ws(E) && el(E) == c3;
        }
        function KU(E) {
          return ws(E) && el(E) == Wn;
        }
        function R3(E, D, K, me, Re) {
          return E === D ? !0 : E == null || D == null || !ws(E) && !ws(D) ? E !== E && D !== D : ZU(E, D, K, me, R3, Re);
        }
        function ZU(E, D, K, me, Re, et) {
          var wt = Ha(E), It = Ha(D), Gt = wt ? ia : Yl(E), Cr = It ? ia : Yl(D);
          Gt = Gt == Zn ? If : Gt, Cr = Cr == Zn ? If : Cr;
          var wr = Gt == If, Tr = Cr == If, rn = Gt == Cr;
          if (rn && D2(E)) {
            if (!D2(D))
              return !1;
            wt = !0, wr = !1;
          }
          if (rn && !wr)
            return et || (et = new uu()), wt || Zr(E) ? rO(E, D, K, me, Re, et) : bV(E, D, Gt, K, me, Re, et);
          if (!(K & ir)) {
            var Rn = wr && xo.call(E, "__wrapped__"), oa = Tr && xo.call(D, "__wrapped__");
            if (Rn || oa) {
              var Si = Rn ? E.value() : E, sa = oa ? D.value() : D;
              return et || (et = new uu()), Re(Si, sa, K, me, et);
            }
          }
          return rn ? (et || (et = new uu()), xV(E, D, K, me, Re, et)) : !1;
        }
        function JU(E) {
          return ws(E) && Yl(E) == jo;
        }
        function aw(E, D, K, me) {
          var Re = K.length, et = Re, wt = !me;
          if (E == null)
            return !et;
          for (E = Ao(E); Re--; ) {
            var It = K[Re];
            if (wt && It[2] ? It[1] !== E[It[0]] : !(It[0] in E))
              return !1;
          }
          for (; ++Re < et; ) {
            It = K[Re];
            var Gt = It[0], Cr = E[Gt], wr = It[1];
            if (wt && It[2]) {
              if (Cr === Q && !(Gt in E))
                return !1;
            } else {
              var Tr = new uu();
              if (me)
                var rn = me(Cr, wr, Gt, E, D, Tr);
              if (!(rn === Q ? R3(wr, Cr, ir | Ir, me, Tr) : rn))
                return !1;
            }
          }
          return !0;
        }
        function TR(E) {
          if (!gs(E) || kV(E))
            return !1;
          var D = Wf(E) ? yi : E6;
          return D.test(Mp(E));
        }
        function YU(E) {
          return ws(E) && el(E) == s3;
        }
        function XU(E) {
          return ws(E) && Yl(E) == Zu;
        }
        function QU(E) {
          return ws(E) && $4(E.length) && !!ko[el(E)];
        }
        function ER(E) {
          return typeof E == "function" ? E : E == null ? od : O.default(E) == "object" ? Ha(E) ? PR(E[0], E[1]) : MR(E) : s5e(E);
        }
        function iw(E) {
          if (!L3(E))
            return WC(E);
          var D = [];
          for (var K in Ao(E))
            xo.call(E, K) && K != "constructor" && D.push(K);
          return D;
        }
        function IR(E) {
          if (!gs(E))
            return EV(E);
          var D = L3(E), K = [];
          for (var me in E)
            me == "constructor" && (D || !xo.call(E, me)) || K.push(me);
          return K;
        }
        function p4(E, D) {
          return E < D;
        }
        function ow(E, D) {
          var K = -1, me = zc(E) ? rr(E.length) : [];
          return R2(E, function(Re, et, wt) {
            me[++K] = D(Re, et, wt);
          }), me;
        }
        function MR(E) {
          var D = _4(E);
          return D.length == 1 && D[0][2] ? lO(D[0][0], D[0][1]) : function(K) {
            return K === E || aw(K, E, D);
          };
        }
        function PR(E, D) {
          return ww(E) && sO(D) ? lO(rd(E), D) : function(K) {
            var me = oK(K, E);
            return me === Q && me === D ? sK(K, E) : R3(D, me, ir | Ir);
          };
        }
        function m4(E, D, K, me, Re) {
          E !== D && rw(D, function(et, wt) {
            if (Re || (Re = new uu()), gs(et))
              RR(E, D, wt, K, m4, me, Re);
            else {
              var It = me ? me(ps(E, wt), et, wt + "", E, D, Re) : Q;
              It === Q && (It = et), gl(E, wt, It);
            }
          }, id);
        }
        function RR(E, D, K, me, Re, et, wt) {
          var It = ps(E, K), Gt = ps(D, K), Cr = wt.get(Gt);
          if (Cr) {
            gl(E, K, Cr);
            return;
          }
          var wr = et ? et(It, Gt, K + "", E, D, wt) : Q, Tr = wr === Q;
          if (Tr) {
            var rn = Ha(Gt), Rn = !rn && D2(Gt), oa = !rn && !Rn && Zr(Gt);
            wr = Gt, rn || Rn || oa ? Ha(It) ? wr = It : Rs(It) ? wr = Lc(It) : Rn ? (Tr = !1, wr = gw(Gt, !0)) : oa ? (Tr = !1, wr = GR(Gt, !0)) : wr = [] : xt(Gt) || Rp(Gt) ? (wr = It, Rp(It) ? wr = ad(It) : (!gs(It) || Wf(It)) && (wr = T4(Gt))) : Tr = !1;
          }
          Tr && (wt.set(Gt, wr), Re(wr, Gt, me, et, wt), wt.delete(Gt)), gl(E, K, wr);
        }
        function OR(E, D) {
          var K = E.length;
          if (K)
            return D += D < 0 ? K : 0, zf(D, K) ? E[D] : Q;
        }
        function BR(E, D, K) {
          D.length ? D = Yo(D, function(et) {
            return Ha(et) ? function(wt) {
              return Lf(wt, et.length === 1 ? et[0] : et);
            } : et;
          }) : D = [od];
          var me = -1;
          D = Yo(D, $c(Jn()));
          var Re = ow(E, function(et, wt, It) {
            var Gt = Yo(D, function(Cr) {
              return Cr(et);
            });
            return { criteria: Gt, index: ++me, value: et };
          });
          return BU(Re, function(et, wt) {
            return dV(et, wt, K);
          });
        }
        function eV(E, D) {
          return NR(E, D, function(K, me) {
            return sK(E, me);
          });
        }
        function NR(E, D, K) {
          for (var me = -1, Re = D.length, et = {}; ++me < Re; ) {
            var wt = D[me], It = Lf(E, wt);
            K(It, wt) && O3(et, B2(wt, E), It);
          }
          return et;
        }
        function tV(E) {
          return function(D) {
            return Lf(D, E);
          };
        }
        function sw(E, D, K, me) {
          var Re = me ? JP : Ng, et = -1, wt = D.length, It = E;
          for (E === D && (D = Lc(D)), K && (It = Yo(E, $c(K))); ++et < wt; )
            for (var Gt = 0, Cr = D[et], wr = K ? K(Cr) : Cr; (Gt = Re(It, wr, Gt, me)) > -1; )
              It !== E && e4.call(It, Gt, 1), e4.call(E, Gt, 1);
          return E;
        }
        function du(E, D) {
          for (var K = E ? D.length : 0, me = K - 1; K--; ) {
            var Re = D[K];
            if (K == me || Re !== et) {
              var et = Re;
              zf(Re) ? e4.call(E, Re, 1) : fw(E, Re);
            }
          }
          return E;
        }
        function lw(E, D) {
          return E + wp(HC() * (D - E + 1));
        }
        function rV(E, D, K, me) {
          for (var Re = -1, et = Fo(_3((D - E) / (K || 1)), 0), wt = rr(et); et--; )
            wt[me ? et : ++Re] = E, E += K;
          return wt;
        }
        function cw(E, D) {
          var K = "";
          if (!E || D < 1 || D > Ae)
            return K;
          do
            D % 2 && (K += E), D = wp(D / 2), D && (E += E);
          while (D);
          return K;
        }
        function ai(E, D) {
          return _w(za(E, D, od), E + "");
        }
        function nV(E) {
          return hR(D4(E));
        }
        function aV(E, D) {
          var K = D4(E);
          return E4(K, Ap(D, 0, K.length));
        }
        function O3(E, D, K, me) {
          if (!gs(E))
            return E;
          D = B2(D, E);
          for (var Re = -1, et = D.length, wt = et - 1, It = E; It != null && ++Re < et; ) {
            var Gt = rd(D[Re]), Cr = K;
            if (Gt === "__proto__" || Gt === "constructor" || Gt === "prototype")
              return E;
            if (Re != wt) {
              var wr = It[Gt];
              Cr = me ? me(wr, Gt, It) : Q, Cr === Q && (Cr = gs(wr) ? wr : zf(D[Re + 1]) ? [] : {});
            }
            E3(It, Gt, Cr), It = It[Gt];
          }
          return E;
        }
        var $R = T3 ? function(E, D) {
          return T3.set(E, D), E;
        } : od, uw = S3 ? function(E, D) {
          return S3(E, "toString", { configurable: !0, enumerable: !1, value: cK(D), writable: !0 });
        } : od;
        function iV(E) {
          return E4(D4(E));
        }
        function ed(E, D, K) {
          var me = -1, Re = E.length;
          D < 0 && (D = -D > Re ? 0 : Re + D), K = K > Re ? Re : K, K < 0 && (K += Re), Re = D > K ? 0 : K - D >>> 0, D >>>= 0;
          for (var et = rr(Re); ++me < Re; )
            et[me] = E[me + D];
          return et;
        }
        function oV(E, D) {
          var K;
          return R2(E, function(me, Re, et) {
            return K = D(me, Re, et), !K;
          }), !!K;
        }
        function g4(E, D, K) {
          var me = 0, Re = E == null ? me : E.length;
          if (typeof D == "number" && D === D && Re <= mn) {
            for (; me < Re; ) {
              var et = me + Re >>> 1, wt = E[et];
              wt !== null && !br(wt) && (K ? wt <= D : wt < D) ? me = et + 1 : Re = et;
            }
            return Re;
          }
          return dw(E, D, od, K);
        }
        function dw(E, D, K, me) {
          var Re = 0, et = E == null ? 0 : E.length;
          if (et === 0)
            return 0;
          D = K(D);
          for (var wt = D !== D, It = D === null, Gt = br(D), Cr = D === Q; Re < et; ) {
            var wr = wp((Re + et) / 2), Tr = K(E[wr]), rn = Tr !== Q, Rn = Tr === null, oa = Tr === Tr, Si = br(Tr);
            if (wt)
              var sa = me || oa;
            else Cr ? sa = oa && (me || rn) : It ? sa = oa && rn && (me || !Rn) : Gt ? sa = oa && rn && !Rn && (me || !Si) : Rn || Si ? sa = !1 : sa = me ? Tr <= D : Tr < D;
            sa ? Re = wr + 1 : et = wr;
          }
          return Zl(et, zt);
        }
        function DR(E, D) {
          for (var K = -1, me = E.length, Re = 0, et = []; ++K < me; ) {
            var wt = E[K], It = D ? D(wt) : wt;
            if (!K || !Fd(It, Gt)) {
              var Gt = It;
              et[Re++] = wt === 0 ? 0 : wt;
            }
          }
          return et;
        }
        function LR(E) {
          return typeof E == "number" ? E : br(E) ? pt : +E;
        }
        function fu(E) {
          if (typeof E == "string")
            return E;
          if (Ha(E))
            return Yo(E, fu) + "";
          if (br(E))
            return KC ? KC.call(E) : "";
          var D = E + "";
          return D == "0" && 1 / E == -1 / 0 ? "-0" : D;
        }
        function O2(E, D, K) {
          var me = -1, Re = W6, et = E.length, wt = !0, It = [], Gt = It;
          if (K)
            wt = !1, Re = AC;
          else if (et >= J) {
            var Cr = D ? null : vV(E);
            if (Cr)
              return K6(Cr);
            wt = !1, Re = S2, Gt = new fc();
          } else
            Gt = D ? [] : It;
          e: for (; ++me < et; ) {
            var wr = E[me], Tr = D ? D(wr) : wr;
            if (wr = K || wr !== 0 ? wr : 0, wt && Tr === Tr) {
              for (var rn = Gt.length; rn--; )
                if (Gt[rn] === Tr)
                  continue e;
              D && Gt.push(Tr), It.push(wr);
            } else Re(Gt, Tr, K) || (Gt !== It && Gt.push(Tr), It.push(wr));
          }
          return It;
        }
        function fw(E, D) {
          return D = B2(D, E), E = cO(E, D), E == null || delete E[rd(Gs(D))];
        }
        function jR(E, D, K, me) {
          return O3(E, D, K(Lf(E, D)), me);
        }
        function v4(E, D, K, me) {
          for (var Re = E.length, et = me ? Re : -1; (me ? et-- : ++et < Re) && D(E[et], et, E); )
            ;
          return K ? ed(E, me ? 0 : et, me ? et + 1 : Re) : ed(E, me ? et + 1 : 0, me ? Re : et);
        }
        function FR(E, D) {
          var K = E;
          return K instanceof Di && (K = K.value()), TC(D, function(me, Re) {
            return Re.func.apply(Re.thisArg, w2([me], Re.args));
          }, K);
        }
        function hw(E, D, K) {
          var me = E.length;
          if (me < 2)
            return me ? O2(E[0]) : [];
          for (var Re = -1, et = rr(me); ++Re < me; )
            for (var wt = E[Re], It = -1; ++It < me; )
              It != Re && (et[Re] = Tp(et[Re] || wt, E[It], D, K));
          return O2(Dl(et, 1), D, K);
        }
        function zR(E, D, K) {
          for (var me = -1, Re = E.length, et = D.length, wt = {}; ++me < Re; ) {
            var It = me < et ? D[me] : Q;
            K(wt, E[me], It);
          }
          return wt;
        }
        function pw(E) {
          return Rs(E) ? E : [];
        }
        function mw(E) {
          return typeof E == "function" ? E : od;
        }
        function B2(E, D) {
          return Ha(E) ? E : ww(E, D) ? [E] : hO(fo(E));
        }
        var sV = ai;
        function N2(E, D, K) {
          var me = E.length;
          return K = K === Q ? me : K, !D && K >= me ? E : ed(E, D, K);
        }
        var y4 = cu || function(E) {
          return Bl.clearTimeout(E);
        };
        function gw(E, D) {
          if (D)
            return E.slice();
          var K = E.length, me = LC ? LC(K) : new E.constructor(K);
          return E.copy(me), me;
        }
        function vw(E) {
          var D = new E.constructor(E.byteLength);
          return new A2(D).set(new A2(E)), D;
        }
        function lV(E, D) {
          var K = D ? vw(E.buffer) : E.buffer;
          return new E.constructor(K, E.byteOffset, E.byteLength);
        }
        function cV(E) {
          var D = new E.constructor(E.source, d3.exec(E));
          return D.lastIndex = E.lastIndex, D;
        }
        function uV(E) {
          return Lg ? Ao(Lg.call(E)) : {};
        }
        function GR(E, D) {
          var K = D ? vw(E.buffer) : E.buffer;
          return new E.constructor(K, E.byteOffset, E.length);
        }
        function WR(E, D) {
          if (E !== D) {
            var K = E !== Q, me = E === null, Re = E === E, et = br(E), wt = D !== Q, It = D === null, Gt = D === D, Cr = br(D);
            if (!It && !Cr && !et && E > D || et && wt && Gt && !It && !Cr || me && wt && Gt || !K && Gt || !Re)
              return 1;
            if (!me && !et && !Cr && E < D || Cr && K && Re && !me && !et || It && K && Re || !wt && Re || !Gt)
              return -1;
          }
          return 0;
        }
        function dV(E, D, K) {
          for (var me = -1, Re = E.criteria, et = D.criteria, wt = Re.length, It = K.length; ++me < wt; ) {
            var Gt = WR(Re[me], et[me]);
            if (Gt) {
              if (me >= It)
                return Gt;
              var Cr = K[me];
              return Gt * (Cr == "desc" ? -1 : 1);
            }
          }
          return E.index - D.index;
        }
        function HR(E, D, K, me) {
          for (var Re = -1, et = E.length, wt = K.length, It = -1, Gt = D.length, Cr = Fo(et - wt, 0), wr = rr(Gt + Cr), Tr = !me; ++It < Gt; )
            wr[It] = D[It];
          for (; ++Re < wt; )
            (Tr || Re < et) && (wr[K[Re]] = E[Re]);
          for (; Cr--; )
            wr[It++] = E[Re++];
          return wr;
        }
        function yw(E, D, K, me) {
          for (var Re = -1, et = E.length, wt = -1, It = K.length, Gt = -1, Cr = D.length, wr = Fo(et - It, 0), Tr = rr(wr + Cr), rn = !me; ++Re < wr; )
            Tr[Re] = E[Re];
          for (var Rn = Re; ++Gt < Cr; )
            Tr[Rn + Gt] = D[Gt];
          for (; ++wt < It; )
            (rn || Re < et) && (Tr[Rn + K[wt]] = E[Re++]);
          return Tr;
        }
        function Lc(E, D) {
          var K = -1, me = E.length;
          for (D || (D = rr(me)); ++K < me; )
            D[K] = E[K];
          return D;
        }
        function hu(E, D, K, me) {
          var Re = !K;
          K || (K = {});
          for (var et = -1, wt = D.length; ++et < wt; ) {
            var It = D[et], Gt = me ? me(K[It], E[It], It, K, E) : Q;
            Gt === Q && (Gt = E[It]), Re ? Df(K, It, Gt) : E3(K, It, Gt);
          }
          return K;
        }
        function fV(E, D) {
          return hu(E, Cw(E), D);
        }
        function hV(E, D) {
          return hu(E, aO(E), D);
        }
        function b4(E, D) {
          return function(K, me) {
            var Re = Ha(K) ? MU : mR, et = D ? D() : {};
            return Re(K, E, Jn(me, 2), et);
          };
        }
        function Fg(E) {
          return ai(function(D, K) {
            var me = -1, Re = K.length, et = Re > 1 ? K[Re - 1] : Q, wt = Re > 2 ? K[2] : Q;
            for (et = E.length > 3 && typeof et == "function" ? (Re--, et) : Q, wt && pc(K[0], K[1], wt) && (et = Re < 3 ? Q : et, Re = 1), D = Ao(D); ++me < Re; ) {
              var It = K[me];
              It && E(D, It, me, et);
            }
            return D;
          });
        }
        function UR(E, D) {
          return function(K, me) {
            if (K == null)
              return K;
            if (!zc(K))
              return E(K, me);
            for (var Re = K.length, et = D ? Re : -1, wt = Ao(K); (D ? et-- : ++et < Re) && me(wt[et], et, wt) !== !1; )
              ;
            return K;
          };
        }
        function VR(E) {
          return function(D, K, me) {
            for (var Re = -1, et = Ao(D), wt = me(D), It = wt.length; It--; ) {
              var Gt = wt[E ? It : ++Re];
              if (K(et[Gt], Gt, et) === !1)
                break;
            }
            return D;
          };
        }
        function pV(E, D, K) {
          var me = D & Sr, Re = B3(E);
          function et() {
            var wt = this && this !== Bl && this instanceof et ? Re : E;
            return wt.apply(me ? K : this, arguments);
          }
          return et;
        }
        function qR(E) {
          return function(D) {
            D = fo(D);
            var K = Of(D) ? Xu(D) : Q, me = K ? K[0] : D.charAt(0), Re = K ? N2(K, 1).join("") : D.slice(1);
            return me[E]() + Re;
          };
        }
        function zg(E) {
          return function(D) {
            return TC(i5e(a5e(D).replace(SU, "")), E, "");
          };
        }
        function B3(E) {
          return function() {
            var D = arguments;
            switch (D.length) {
              case 0:
                return new E();
              case 1:
                return new E(D[0]);
              case 2:
                return new E(D[0], D[1]);
              case 3:
                return new E(D[0], D[1], D[2]);
              case 4:
                return new E(D[0], D[1], D[2], D[3]);
              case 5:
                return new E(D[0], D[1], D[2], D[3], D[4]);
              case 6:
                return new E(D[0], D[1], D[2], D[3], D[4], D[5]);
              case 7:
                return new E(D[0], D[1], D[2], D[3], D[4], D[5], D[6]);
            }
            var K = kp(E.prototype), me = E.apply(K, D);
            return gs(me) ? me : K;
          };
        }
        function mV(E, D, K) {
          var me = B3(E);
          function Re() {
            for (var et = arguments.length, wt = rr(et), It = et, Gt = Ep(Re); It--; )
              wt[It] = arguments[It];
            var Cr = et < 3 && wt[0] !== Gt && wt[et - 1] !== Gt ? [] : _2(wt, Gt);
            if (et -= Cr.length, et < K)
              return XR(E, D, x4, Re.placeholder, Q, wt, Cr, Q, Q, K - et);
            var wr = this && this !== Bl && this instanceof Re ? me : E;
            return ou(wr, this, wt);
          }
          return Re;
        }
        function KR(E) {
          return function(D, K, me) {
            var Re = Ao(D);
            if (!zc(D)) {
              var et = Jn(K, 3);
              D = Ql(D), K = function(Gt) {
                return et(Re[Gt], Gt, Re);
              };
            }
            var wt = E(D, K, me);
            return wt > -1 ? Re[et ? D[wt] : wt] : Q;
          };
        }
        function ZR(E) {
          return Ff(function(D) {
            var K = D.length, me = K, Re = Jl.prototype.thru;
            for (E && D.reverse(); me--; ) {
              var et = D[me];
              if (typeof et != "function")
                throw new dc(le);
              if (Re && !wt && $3(et) == "wrapper")
                var wt = new Jl([], !0);
            }
            for (me = wt ? me : K; ++me < K; ) {
              et = D[me];
              var It = $3(et), Gt = It == "wrapper" ? xw(et) : Q;
              Gt && Sw(Gt[0]) && Gt[1] == (_o | ni | ja | Ee) && !Gt[4].length && Gt[9] == 1 ? wt = wt[$3(Gt[0])].apply(wt, Gt[3]) : wt = et.length == 1 && Sw(et) ? wt[It]() : wt.thru(et);
            }
            return function() {
              var Cr = arguments, wr = Cr[0];
              if (wt && Cr.length == 1 && Ha(wr))
                return wt.plant(wr).value();
              for (var Tr = 0, rn = K ? D[Tr].apply(this, Cr) : wr; ++Tr < K; )
                rn = D[Tr].call(this, rn);
              return rn;
            };
          });
        }
        function x4(E, D, K, me, Re, et, wt, It, Gt, Cr) {
          var wr = D & _o, Tr = D & Sr, rn = D & Vr, Rn = D & (ni | Yn), oa = D & je, Si = rn ? Q : B3(E);
          function sa() {
            for (var Wi = arguments.length, Ji = rr(Wi), Wc = Wi; Wc--; )
              Ji[Wc] = arguments[Wc];
            if (Rn)
              var mu = Ep(sa), zd = Nl(Ji, mu);
            if (me && (Ji = HR(Ji, me, Re, Rn)), et && (Ji = yw(Ji, et, wt, Rn)), Wi -= zd, Rn && Wi < Cr) {
              var tl = _2(Ji, mu);
              return XR(E, D, x4, sa.placeholder, K, Ji, tl, It, Gt, Cr - Wi);
            }
            var Uf = Tr ? K : this, Op = rn ? Uf[E] : E;
            return Wi = Ji.length, It ? Ji = jc(Ji, It) : oa && Wi > 1 && Ji.reverse(), wr && Gt < Wi && (Ji.length = Gt), this && this !== Bl && this instanceof sa && (Op = Si || B3(Op)), Op.apply(Uf, Ji);
          }
          return sa;
        }
        function JR(E, D) {
          return function(K, me) {
            return B0(K, E, D(me), {});
          };
        }
        function C4(E, D) {
          return function(K, me) {
            var Re;
            if (K === Q && me === Q)
              return D;
            if (K !== Q && (Re = K), me !== Q) {
              if (Re === Q)
                return me;
              typeof K == "string" || typeof me == "string" ? (K = fu(K), me = fu(me)) : (K = LR(K), me = LR(me)), Re = E(K, me);
            }
            return Re;
          };
        }
        function w4(E) {
          return Ff(function(D) {
            return D = Yo(D, $c(Jn())), ai(function(K) {
              var me = this;
              return E(D, function(Re) {
                return ou(Re, me, K);
              });
            });
          });
        }
        function N3(E, D) {
          D = D === Q ? " " : fu(D);
          var K = D.length;
          if (K < 2)
            return K ? cw(D, E) : D;
          var me = cw(D, _3(E / P0(D)));
          return Of(D) ? N2(Xu(me), 0, E).join("") : me.slice(0, E);
        }
        function gV(E, D, K, me) {
          var Re = D & Sr, et = B3(E);
          function wt() {
            for (var It = -1, Gt = arguments.length, Cr = -1, wr = me.length, Tr = rr(wr + Gt), rn = this && this !== Bl && this instanceof wt ? et : E; ++Cr < wr; )
              Tr[Cr] = me[Cr];
            for (; Gt--; )
              Tr[Cr++] = arguments[++It];
            return ou(rn, Re ? K : this, Tr);
          }
          return wt;
        }
        function YR(E) {
          return function(D, K, me) {
            return me && typeof me != "number" && pc(D, K, me) && (K = me = Q), D = Os(D), K === Q ? (K = D, D = 0) : K = Os(K), me = me === Q ? D < K ? 1 : -1 : Os(me), rV(D, K, me, E);
          };
        }
        function S4(E) {
          return function(D, K) {
            return typeof D == "string" && typeof K == "string" || (D = Zi(D), K = Zi(K)), E(D, K);
          };
        }
        function XR(E, D, K, me, Re, et, wt, It, Gt, Cr) {
          var wr = D & ni, Tr = wr ? wt : Q, rn = wr ? Q : wt, Rn = wr ? et : Q, oa = wr ? Q : et;
          D |= wr ? ja : Rr, D &= ~(wr ? Rr : ja), D & ri || (D &= -4);
          var Si = [E, D, Re, Rn, Tr, oa, rn, It, Gt, Cr], sa = K.apply(Q, Si);
          return Sw(E) && uO(sa, Si), sa.placeholder = me, dO(sa, E, D);
        }
        function Gg(E) {
          var D = Ps[E];
          return function(K, me) {
            if (K = Zi(K), me = me == null ? 0 : Zl(Vn(me), 292), me && zC(K)) {
              var Re = (fo(K) + "e").split("e"), et = D(Re[0] + "e" + (+Re[1] + me));
              return Re = (fo(et) + "e").split("e"), +(Re[0] + "e" + (+Re[1] - me));
            }
            return D(K);
          };
        }
        var vV = Sp && 1 / K6(new Sp([, -0]))[1] == ye ? function(E) {
          return new Sp(E);
        } : fK;
        function QR(E) {
          return function(D) {
            var K = Yl(D);
            return K == jo ? $l(D) : K == Zu ? NU(D) : b3(D, E(D));
          };
        }
        function jf(E, D, K, me, Re, et, wt, It) {
          var Gt = D & Vr;
          if (!Gt && typeof E != "function")
            throw new dc(le);
          var Cr = me ? me.length : 0;
          if (Cr || (D &= -97, me = Re = Q), wt = wt === Q ? wt : Fo(Vn(wt), 0), It = It === Q ? It : Vn(It), Cr -= Re ? Re.length : 0, D & Rr) {
            var wr = me, Tr = Re;
            me = Re = Q;
          }
          var rn = Gt ? Q : xw(E), Rn = [E, D, K, me, Re, wr, Tr, et, wt, It];
          if (rn && TV(Rn, rn), E = Rn[0], D = Rn[1], K = Rn[2], me = Rn[3], Re = Rn[4], It = Rn[9] = Rn[9] === Q ? Gt ? 0 : E.length : Fo(Rn[9] - Cr, 0), !It && D & (ni | Yn) && (D &= -25), !D || D == Sr)
            var oa = pV(E, D, K);
          else D == ni || D == Yn ? oa = mV(E, D, It) : (D == ja || D == (Sr | ja)) && !Re.length ? oa = gV(E, D, K, me) : oa = x4.apply(Q, Rn);
          var Si = rn ? $R : uO;
          return dO(Si(oa, Rn), E, D);
        }
        function eO(E, D, K, me) {
          return E === Q || Fd(E, xp[K]) && !xo.call(me, K) ? D : E;
        }
        function tO(E, D, K, me, Re, et) {
          return gs(E) && gs(D) && (et.set(D, E), m4(E, D, Q, tO, et), et.delete(D)), E;
        }
        function yV(E) {
          return xt(E) ? Q : E;
        }
        function rO(E, D, K, me, Re, et) {
          var wt = K & ir, It = E.length, Gt = D.length;
          if (It != Gt && !(wt && Gt > It))
            return !1;
          var Cr = et.get(E), wr = et.get(D);
          if (Cr && wr)
            return Cr == D && wr == E;
          var Tr = -1, rn = !0, Rn = K & Ir ? new fc() : Q;
          for (et.set(E, D), et.set(D, E); ++Tr < It; ) {
            var oa = E[Tr], Si = D[Tr];
            if (me)
              var sa = wt ? me(Si, oa, Tr, D, E, et) : me(oa, Si, Tr, E, D, et);
            if (sa !== Q) {
              if (sa)
                continue;
              rn = !1;
              break;
            }
            if (Rn) {
              if (!H6(D, function(Wi, Ji) {
                if (!S2(Rn, Ji) && (oa === Wi || Re(oa, Wi, K, me, et)))
                  return Rn.push(Ji);
              })) {
                rn = !1;
                break;
              }
            } else if (!(oa === Si || Re(oa, Si, K, me, et))) {
              rn = !1;
              break;
            }
          }
          return et.delete(E), et.delete(D), rn;
        }
        function bV(E, D, K, me, Re, et, wt) {
          switch (K) {
            case Ag:
              if (E.byteLength != D.byteLength || E.byteOffset != D.byteOffset)
                return !1;
              E = E.buffer, D = D.buffer;
            case c3:
              return !(E.byteLength != D.byteLength || !et(new A2(E), new A2(D)));
            case Ki:
            case Wn:
            case fp:
              return Fd(+E, +D);
            case Ef:
              return E.name == D.name && E.message == D.message;
            case s3:
            case Ol:
              return E == D + "";
            case jo:
              var It = $l;
            case Zu:
              var Gt = me & ir;
              if (It || (It = K6), E.size != D.size && !Gt)
                return !1;
              var Cr = wt.get(E);
              if (Cr)
                return Cr == D;
              me |= Ir, wt.set(E, D);
              var wr = rO(It(E), It(D), me, Re, et, wt);
              return wt.delete(E), wr;
            case _g:
              if (Lg)
                return Lg.call(E) == Lg.call(D);
          }
          return !1;
        }
        function xV(E, D, K, me, Re, et) {
          var wt = K & ir, It = bw(E), Gt = It.length, Cr = bw(D), wr = Cr.length;
          if (Gt != wr && !wt)
            return !1;
          for (var Tr = Gt; Tr--; ) {
            var rn = It[Tr];
            if (!(wt ? rn in D : xo.call(D, rn)))
              return !1;
          }
          var Rn = et.get(E), oa = et.get(D);
          if (Rn && oa)
            return Rn == D && oa == E;
          var Si = !0;
          et.set(E, D), et.set(D, E);
          for (var sa = wt; ++Tr < Gt; ) {
            rn = It[Tr];
            var Wi = E[rn], Ji = D[rn];
            if (me)
              var Wc = wt ? me(Ji, Wi, rn, D, E, et) : me(Wi, Ji, rn, E, D, et);
            if (!(Wc === Q ? Wi === Ji || Re(Wi, Ji, K, me, et) : Wc)) {
              Si = !1;
              break;
            }
            sa || (sa = rn == "constructor");
          }
          if (Si && !sa) {
            var mu = E.constructor, zd = D.constructor;
            mu != zd && "constructor" in E && "constructor" in D && !(typeof mu == "function" && mu instanceof mu && typeof zd == "function" && zd instanceof zd) && (Si = !1);
          }
          return et.delete(E), et.delete(D), Si;
        }
        function Ff(E) {
          return _w(za(E, Q, gO), E + "");
        }
        function bw(E) {
          return nw(E, Ql, Cw);
        }
        function Wg(E) {
          return nw(E, id, aO);
        }
        var xw = T3 ? function(E) {
          return T3.get(E);
        } : fK;
        function $3(E) {
          for (var D = E.name + "", K = _p[D], me = xo.call(_p, D) ? K.length : 0; me--; ) {
            var Re = K[me], et = Re.func;
            if (et == null || et == E)
              return Re.name;
          }
          return D;
        }
        function Ep(E) {
          var D = xo.call(Ue, "placeholder") ? Ue : E;
          return D.placeholder;
        }
        function Jn() {
          var E = Ue.iteratee || uK;
          return E = E === uK ? ER : E, arguments.length ? E(arguments[0], arguments[1]) : E;
        }
        function D3(E, D) {
          var K = E.__data__;
          return _V(D) ? K[typeof D == "string" ? "string" : "hash"] : K.map;
        }
        function _4(E) {
          for (var D = Ql(E), K = D.length; K--; ) {
            var me = D[K], Re = E[me];
            D[K] = [me, Re, sO(Re)];
          }
          return D;
        }
        function $2(E, D) {
          var K = RC(E, D);
          return TR(K) ? K : Q;
        }
        function nO(E) {
          var D = xo.call(E, T2), K = E[T2];
          try {
            E[T2] = Q;
            var me = !0;
          } catch {
          }
          var Re = $g.call(E);
          return me && (D ? E[T2] = K : delete E[T2]), Re;
        }
        var Cw = t4 ? function(E) {
          return E == null ? [] : (E = Ao(E), ml(t4(E), function(D) {
            return lu.call(E, D);
          }));
        } : hK, aO = t4 ? function(E) {
          for (var D = []; E; )
            w2(D, Cw(E)), E = Q6(E);
          return D;
        } : hK, Yl = el;
        (VC && Yl(new VC(new ArrayBuffer(1))) != Ag || k3 && Yl(new k3()) != jo || qC && Yl(qC.resolve()) != k6 || Sp && Yl(new Sp()) != Zu || Dg && Yl(new Dg()) != kg) && (Yl = function(D) {
          var K = el(D), me = K == If ? D.constructor : Q, Re = me ? Mp(me) : "";
          if (Re)
            switch (Re) {
              case Dc:
                return Ag;
              case R0:
                return jo;
              case zU:
                return k6;
              case GU:
                return Zu;
              case r4:
                return kg;
            }
          return K;
        });
        function k4(E, D, K) {
          for (var me = -1, Re = K.length; ++me < Re; ) {
            var et = K[me], wt = et.size;
            switch (et.type) {
              case "drop":
                E += wt;
                break;
              case "dropRight":
                D -= wt;
                break;
              case "take":
                D = Zl(D, E + wt);
                break;
              case "takeRight":
                E = Fo(E, D - wt);
                break;
            }
          }
          return { start: E, end: D };
        }
        function A4(E) {
          var D = E.match(co);
          return D ? D[1].split(Qs) : [];
        }
        function iO(E, D, K) {
          D = B2(D, E);
          for (var me = -1, Re = D.length, et = !1; ++me < Re; ) {
            var wt = rd(D[me]);
            if (!(et = E != null && K(E, wt)))
              break;
            E = E[wt];
          }
          return et || ++me != Re ? et : (Re = E == null ? 0 : E.length, !!Re && $4(Re) && zf(wt, Re) && (Ha(E) || Rp(E)));
        }
        function CV(E) {
          var D = E.length, K = new E.constructor(D);
          return D && typeof E[0] == "string" && xo.call(E, "index") && (K.index = E.index, K.input = E.input), K;
        }
        function T4(E) {
          return typeof E.constructor == "function" && !L3(E) ? kp(Q6(E)) : {};
        }
        function oO(E, D, K) {
          var me = E.constructor;
          switch (D) {
            case c3:
              return vw(E);
            case Ki:
            case Wn:
              return new me(+E);
            case Ag:
              return lV(E, K);
            case pC:
            case mC:
            case gC:
            case x2:
            case vC:
            case yC:
            case u3:
            case A6:
            case T0:
              return GR(E, K);
            case jo:
              return new me();
            case fp:
            case Ol:
              return new me(E);
            case s3:
              return cV(E);
            case Zu:
              return new me();
            case _g:
              return uV(E);
          }
        }
        function wV(E, D) {
          var K = D.length;
          if (!K)
            return E;
          var me = K - 1;
          return D[me] = (K > 1 ? "& " : "") + D[me], D = D.join(K > 2 ? ", " : " "), E.replace(Fa, `{
/* [wrapped with ` + D + `] */
`);
        }
        function SV(E) {
          return Ha(E) || Rp(E) || !!(w3 && E && E[w3]);
        }
        function zf(E, D) {
          var K = O.default(E);
          return D = D ?? Ae, !!D && (K == "number" || K != "symbol" && bo.test(E)) && E > -1 && E % 1 == 0 && E < D;
        }
        function pc(E, D, K) {
          if (!gs(K))
            return !1;
          var me = O.default(D);
          return (me == "number" ? zc(K) && zf(D, K.length) : me == "string" && D in K) ? Fd(K[D], E) : !1;
        }
        function ww(E, D) {
          if (Ha(E))
            return !1;
          var K = O.default(E);
          return K == "number" || K == "symbol" || K == "boolean" || E == null || br(E) ? !0 : fU.test(E) || !dU.test(E) || D != null && E in Ao(D);
        }
        function _V(E) {
          var D = O.default(E);
          return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? E !== "__proto__" : E === null;
        }
        function Sw(E) {
          var D = $3(E), K = Ue[D];
          if (typeof K != "function" || !(D in Di.prototype))
            return !1;
          if (E === K)
            return !0;
          var me = xw(K);
          return !!me && E === me[0];
        }
        function kV(E) {
          return !!$C && $C in E;
        }
        var AV = Y6 ? Wf : pK;
        function L3(E) {
          var D = E && E.constructor, K = typeof D == "function" && D.prototype || xp;
          return E === K;
        }
        function sO(E) {
          return E === E && !gs(E);
        }
        function lO(E, D) {
          return function(K) {
            return K == null ? !1 : K[E] === D && (D !== Q || E in Ao(K));
          };
        }
        function jd(E) {
          var D = B4(E, function(me) {
            return K.size === he && K.clear(), me;
          }), K = D.cache;
          return D;
        }
        function TV(E, D) {
          var K = E[1], me = D[1], Re = K | me, et = Re < (Sr | Vr | _o), wt = me == _o && K == ni || me == _o && K == Ee && E[7].length <= D[8] || me == (_o | Ee) && D[7].length <= D[8] && K == ni;
          if (!(et || wt))
            return E;
          me & Sr && (E[2] = D[2], Re |= K & Sr ? 0 : ri);
          var It = D[3];
          if (It) {
            var Gt = E[3];
            E[3] = Gt ? HR(Gt, It, D[4]) : It, E[4] = Gt ? _2(E[3], $e) : D[4];
          }
          return It = D[5], It && (Gt = E[5], E[5] = Gt ? yw(Gt, It, D[6]) : It, E[6] = Gt ? _2(E[5], $e) : D[6]), It = D[7], It && (E[7] = It), me & _o && (E[8] = E[8] == null ? D[8] : Zl(E[8], D[8])), E[9] == null && (E[9] = D[9]), E[0] = D[0], E[1] = Re, E;
        }
        function EV(E) {
          var D = [];
          if (E != null)
            for (var K in Ao(E))
              D.push(K);
          return D;
        }
        function Ip(E) {
          return $g.call(E);
        }
        function za(E, D, K) {
          return D = Fo(D === Q ? E.length - 1 : D, 0), function() {
            for (var me = arguments, Re = -1, et = Fo(me.length - D, 0), wt = rr(et); ++Re < et; )
              wt[Re] = me[D + Re];
            Re = -1;
            for (var It = rr(D + 1); ++Re < D; )
              It[Re] = me[Re];
            return It[D] = K(wt), ou(E, this, It);
          };
        }
        function cO(E, D) {
          return D.length < 2 ? E : Lf(E, ed(D, 0, -1));
        }
        function jc(E, D) {
          for (var K = E.length, me = Zl(D.length, K), Re = Lc(E); me--; ) {
            var et = D[me];
            E[me] = zf(et, K) ? Re[et] : Q;
          }
          return E;
        }
        function ps(E, D) {
          if (!(D === "constructor" && typeof E[D] == "function") && D != "__proto__")
            return E[D];
        }
        var uO = fO($R), td = jC || function(E, D) {
          return Bl.setTimeout(E, D);
        }, _w = fO(uw);
        function dO(E, D, K) {
          var me = D + "";
          return _w(E, wV(me, Gf(A4(me), K)));
        }
        function fO(E) {
          var D = 0, K = 0;
          return function() {
            var me = I2(), Re = xe - (me - K);
            if (K = me, Re > 0) {
              if (++D >= ae)
                return arguments[0];
            } else
              D = 0;
            return E.apply(Q, arguments);
          };
        }
        function E4(E, D) {
          var K = -1, me = E.length, Re = me - 1;
          for (D = D === Q ? me : D; ++K < D; ) {
            var et = lw(K, Re), wt = E[et];
            E[et] = E[K], E[K] = wt;
          }
          return E.length = D, E;
        }
        var hO = jd(function(E) {
          var D = [];
          return E.charCodeAt(0) === 46 && D.push(""), E.replace(Tg, function(K, me, Re, et) {
            D.push(Re ? et.replace(hU, "$1") : me || K);
          }), D;
        });
        function rd(E) {
          if (typeof E == "string" || br(E))
            return E;
          var D = E + "";
          return D == "0" && 1 / E == -1 / 0 ? "-0" : D;
        }
        function Mp(E) {
          if (E != null) {
            try {
              return C3.call(E);
            } catch {
            }
            try {
              return E + "";
            } catch {
            }
          }
          return "";
        }
        function Gf(E, D) {
          return pl(Tn, function(K) {
            var me = "_." + K[0];
            D & K[1] && !W6(E, me) && E.push(me);
          }), E.sort();
        }
        function kw(E) {
          if (E instanceof Di)
            return E.clone();
          var D = new Jl(E.__wrapped__, E.__chain__);
          return D.__actions__ = Lc(E.__actions__), D.__index__ = E.__index__, D.__values__ = E.__values__, D;
        }
        function I4(E, D, K) {
          (K ? pc(E, D, K) : D === Q) ? D = 1 : D = Fo(Vn(D), 0);
          var me = E == null ? 0 : E.length;
          if (!me || D < 1)
            return [];
          for (var Re = 0, et = 0, wt = rr(_3(me / D)); Re < me; )
            wt[et++] = ed(E, Re, Re += D);
          return wt;
        }
        function ms(E) {
          for (var D = -1, K = E == null ? 0 : E.length, me = 0, Re = []; ++D < K; ) {
            var et = E[D];
            et && (Re[me++] = et);
          }
          return Re;
        }
        function Cs() {
          var E = arguments.length;
          if (!E)
            return [];
          for (var D = rr(E - 1), K = arguments[0], me = E; me--; )
            D[me - 1] = arguments[me];
          return w2(Ha(K) ? Lc(K) : [K], Dl(D, 1));
        }
        var pO = ai(function(E, D) {
          return Rs(E) ? Tp(E, Dl(D, 1, Rs, !0)) : [];
        }), IV = ai(function(E, D) {
          var K = Gs(D);
          return Rs(K) && (K = Q), Rs(E) ? Tp(E, Dl(D, 1, Rs, !0), Jn(K, 2)) : [];
        }), MV = ai(function(E, D) {
          var K = Gs(D);
          return Rs(K) && (K = Q), Rs(E) ? Tp(E, Dl(D, 1, Rs, !0), Q, K) : [];
        });
        function PV(E, D, K) {
          var me = E == null ? 0 : E.length;
          return me ? (D = K || D === Q ? 1 : Vn(D), ed(E, D < 0 ? 0 : D, me)) : [];
        }
        function RV(E, D, K) {
          var me = E == null ? 0 : E.length;
          return me ? (D = K || D === Q ? 1 : Vn(D), D = me - D, ed(E, 0, D < 0 ? 0 : D)) : [];
        }
        function OV(E, D) {
          return E && E.length ? v4(E, Jn(D, 3), !0, !0) : [];
        }
        function BV(E, D) {
          return E && E.length ? v4(E, Jn(D, 3), !0) : [];
        }
        function mO(E, D, K, me) {
          var Re = E == null ? 0 : E.length;
          return Re ? (K && typeof K != "number" && pc(E, D, K) && (K = 0, me = Re), xR(E, D, K, me)) : [];
        }
        function Hg(E, D, K) {
          var me = E == null ? 0 : E.length;
          if (!me)
            return -1;
          var Re = K == null ? 0 : Vn(K);
          return Re < 0 && (Re = Fo(me + Re, 0)), vp(E, Jn(D, 3), Re);
        }
        function M4(E, D, K) {
          var me = E == null ? 0 : E.length;
          if (!me)
            return -1;
          var Re = me - 1;
          return K !== Q && (Re = Vn(K), Re = K < 0 ? Fo(me + Re, 0) : Zl(Re, me - 1)), vp(E, Jn(D, 3), Re, !0);
        }
        function gO(E) {
          var D = E == null ? 0 : E.length;
          return D ? Dl(E, 1) : [];
        }
        function vO(E) {
          var D = E == null ? 0 : E.length;
          return D ? Dl(E, ye) : [];
        }
        function P4(E, D) {
          var K = E == null ? 0 : E.length;
          return K ? (D = D === Q ? 1 : Vn(D), Dl(E, D)) : [];
        }
        function pu(E) {
          for (var D = -1, K = E == null ? 0 : E.length, me = {}; ++D < K; ) {
            var Re = E[D];
            me[Re[0]] = Re[1];
          }
          return me;
        }
        function Pp(E) {
          return E && E.length ? E[0] : Q;
        }
        function NV(E, D, K) {
          var me = E == null ? 0 : E.length;
          if (!me)
            return -1;
          var Re = K == null ? 0 : Vn(K);
          return Re < 0 && (Re = Fo(me + Re, 0)), Ng(E, D, Re);
        }
        function $V(E) {
          var D = E == null ? 0 : E.length;
          return D ? ed(E, 0, -1) : [];
        }
        var DV = ai(function(E) {
          var D = Yo(E, pw);
          return D.length && D[0] === E[0] ? h4(D) : [];
        }), LV = ai(function(E) {
          var D = Gs(E), K = Yo(E, pw);
          return D === Gs(K) ? D = Q : K.pop(), K.length && K[0] === E[0] ? h4(K, Jn(D, 2)) : [];
        }), jV = ai(function(E) {
          var D = Gs(E), K = Yo(E, pw);
          return D = typeof D == "function" ? D : Q, D && K.pop(), K.length && K[0] === E[0] ? h4(K, Q, D) : [];
        });
        function yO(E, D) {
          return E == null ? "" : GC.call(E, D);
        }
        function Gs(E) {
          var D = E == null ? 0 : E.length;
          return D ? E[D - 1] : Q;
        }
        function Xa(E, D, K) {
          var me = E == null ? 0 : E.length;
          if (!me)
            return -1;
          var Re = me;
          return K !== Q && (Re = Vn(K), Re = Re < 0 ? Fo(me + Re, 0) : Zl(Re, me - 1)), D === D ? $U(E, D, Re) : vp(E, YP, Re, !0);
        }
        function bO(E, D) {
          return E && E.length ? OR(E, Vn(D)) : Q;
        }
        var nd = ai(Aw);
        function Aw(E, D) {
          return E && E.length && D && D.length ? sw(E, D) : E;
        }
        function FV(E, D, K) {
          return E && E.length && D && D.length ? sw(E, D, Jn(K, 2)) : E;
        }
        function mo(E, D, K) {
          return E && E.length && D && D.length ? sw(E, D, Q, K) : E;
        }
        var zV = Ff(function(E, D) {
          var K = E == null ? 0 : E.length, me = tw(E, D);
          return du(E, Yo(D, function(Re) {
            return zf(Re, K) ? +Re : Re;
          }).sort(WR)), me;
        });
        function xO(E, D) {
          var K = [];
          if (!(E && E.length))
            return K;
          var me = -1, Re = [], et = E.length;
          for (D = Jn(D, 3); ++me < et; ) {
            var wt = E[me];
            D(wt, me, E) && (K.push(wt), Re.push(me));
          }
          return du(E, Re), K;
        }
        function Ug(E) {
          return E == null ? E : UC.call(E);
        }
        function GV(E, D, K) {
          var me = E == null ? 0 : E.length;
          return me ? (K && typeof K != "number" && pc(E, D, K) ? (D = 0, K = me) : (D = D == null ? 0 : Vn(D), K = K === Q ? me : Vn(K)), ed(E, D, K)) : [];
        }
        function WV(E, D) {
          return g4(E, D);
        }
        function HV(E, D, K) {
          return dw(E, D, Jn(K, 2));
        }
        function UV(E, D) {
          var K = E == null ? 0 : E.length;
          if (K) {
            var me = g4(E, D);
            if (me < K && Fd(E[me], D))
              return me;
          }
          return -1;
        }
        function VV(E, D) {
          return g4(E, D, !0);
        }
        function qV(E, D, K) {
          return dw(E, D, Jn(K, 2), !0);
        }
        function KV(E, D) {
          var K = E == null ? 0 : E.length;
          if (K) {
            var me = g4(E, D, !0) - 1;
            if (Fd(E[me], D))
              return me;
          }
          return -1;
        }
        function ZV(E) {
          return E && E.length ? DR(E) : [];
        }
        function JV(E, D) {
          return E && E.length ? DR(E, Jn(D, 2)) : [];
        }
        function YV(E) {
          var D = E == null ? 0 : E.length;
          return D ? ed(E, 1, D) : [];
        }
        function XV(E, D, K) {
          return E && E.length ? (D = K || D === Q ? 1 : Vn(D), ed(E, 0, D < 0 ? 0 : D)) : [];
        }
        function QV(E, D, K) {
          var me = E == null ? 0 : E.length;
          return me ? (D = K || D === Q ? 1 : Vn(D), D = me - D, ed(E, D < 0 ? 0 : D, me)) : [];
        }
        function eq(E, D) {
          return E && E.length ? v4(E, Jn(D, 3), !1, !0) : [];
        }
        function Tw(E, D) {
          return E && E.length ? v4(E, Jn(D, 3)) : [];
        }
        var tq = ai(function(E) {
          return O2(Dl(E, 1, Rs, !0));
        }), Ew = ai(function(E) {
          var D = Gs(E);
          return Rs(D) && (D = Q), O2(Dl(E, 1, Rs, !0), Jn(D, 2));
        }), rq = ai(function(E) {
          var D = Gs(E);
          return D = typeof D == "function" ? D : Q, O2(Dl(E, 1, Rs, !0), Q, D);
        });
        function nq(E) {
          return E && E.length ? O2(E) : [];
        }
        function aq(E, D) {
          return E && E.length ? O2(E, Jn(D, 2)) : [];
        }
        function vl(E, D) {
          return D = typeof D == "function" ? D : Q, E && E.length ? O2(E, Q, D) : [];
        }
        function Xl(E) {
          if (!(E && E.length))
            return [];
          var D = 0;
          return E = ml(E, function(K) {
            if (Rs(K))
              return D = Fo(K.length, D), !0;
          }), V6(D, function(K) {
            return Yo(E, y3(K));
          });
        }
        function CO(E, D) {
          if (!(E && E.length))
            return [];
          var K = Xl(E);
          return D == null ? K : Yo(K, function(me) {
            return ou(D, Q, me);
          });
        }
        var iq = ai(function(E, D) {
          return Rs(E) ? Tp(E, D) : [];
        }), oq = ai(function(E) {
          return hw(ml(E, Rs));
        }), wO = ai(function(E) {
          var D = Gs(E);
          return Rs(D) && (D = Q), hw(ml(E, Rs), Jn(D, 2));
        }), sq = ai(function(E) {
          var D = Gs(E);
          return D = typeof D == "function" ? D : Q, hw(ml(E, Rs), Q, D);
        }), lq = ai(Xl);
        function cq(E, D) {
          return zR(E || [], D || [], E3);
        }
        function SO(E, D) {
          return zR(E || [], D || [], O3);
        }
        var uq = ai(function(E) {
          var D = E.length, K = D > 1 ? E[D - 1] : Q;
          return K = typeof K == "function" ? (E.pop(), K) : Q, CO(E, K);
        });
        function _O(E) {
          var D = Ue(E);
          return D.__chain__ = !0, D;
        }
        function dq(E, D) {
          return D(E), E;
        }
        function j3(E, D) {
          return D(E);
        }
        var kO = Ff(function(E) {
          var D = E.length, K = D ? E[0] : 0, me = this.__wrapped__, Re = function(wt) {
            return tw(wt, E);
          };
          return D > 1 || this.__actions__.length || !(me instanceof Di) || !zf(K) ? this.thru(Re) : (me = me.slice(K, +K + (D ? 1 : 0)), me.__actions__.push({ func: j3, args: [Re], thisArg: Q }), new Jl(me, this.__chain__).thru(function(et) {
            return D && !et.length && et.push(Q), et;
          }));
        });
        function fq() {
          return _O(this);
        }
        function hq() {
          return new Jl(this.value(), this.__chain__);
        }
        function pq() {
          this.__values__ === Q && (this.__values__ = Li(this.value()));
          var E = this.__index__ >= this.__values__.length, D = E ? Q : this.__values__[this.__index__++];
          return { done: E, value: D };
        }
        function mq() {
          return this;
        }
        function Vg(E) {
          for (var D, K = this; K instanceof Nf; ) {
            var me = kw(K);
            me.__index__ = 0, me.__values__ = Q, D ? Re.__wrapped__ = me : D = me;
            var Re = me;
            K = K.__wrapped__;
          }
          return Re.__wrapped__ = E, D;
        }
        function gq() {
          var E = this.__wrapped__;
          if (E instanceof Di) {
            var D = E;
            return this.__actions__.length && (D = new Di(this)), D = D.reverse(), D.__actions__.push({ func: j3, args: [Ug], thisArg: Q }), new Jl(D, this.__chain__);
          }
          return this.thru(Ug);
        }
        function vq() {
          return FR(this.__wrapped__, this.__actions__);
        }
        var yq = b4(function(E, D, K) {
          xo.call(E, K) ? ++E[K] : Df(E, K, 1);
        });
        function bq(E, D, K) {
          var me = Ha(E) ? KP : I3;
          return K && pc(E, D, K) && (D = Q), me(E, Jn(D, 3));
        }
        function xq(E, D) {
          var K = Ha(E) ? ml : CR;
          return K(E, Jn(D, 3));
        }
        var AO = KR(Hg), TO = KR(M4);
        function Cq(E, D) {
          return Dl(R4(E, D), 1);
        }
        function wq(E, D) {
          return Dl(R4(E, D), ye);
        }
        function Sq(E, D, K) {
          return K = K === Q ? 1 : Vn(K), Dl(R4(E, D), K);
        }
        function EO(E, D) {
          var K = Ha(E) ? pl : R2;
          return K(E, Jn(D, 3));
        }
        function IO(E, D) {
          var K = Ha(E) ? PU : bR;
          return K(E, Jn(D, 3));
        }
        var _q = b4(function(E, D, K) {
          xo.call(E, K) ? E[K].push(D) : Df(E, K, [D]);
        });
        function kq(E, D, K, me) {
          E = zc(E) ? E : D4(E), K = K && !me ? Vn(K) : 0;
          var Re = E.length;
          return K < 0 && (K = Fo(Re + K, 0)), mr(E) ? K <= Re && E.indexOf(D, K) > -1 : !!Re && Ng(E, D, K) > -1;
        }
        var Aq = ai(function(E, D, K) {
          var me = -1, Re = typeof D == "function", et = zc(E) ? rr(E.length) : [];
          return R2(E, function(wt) {
            et[++me] = Re ? ou(D, wt, K) : Ld(wt, D, K);
          }), et;
        }), Tq = b4(function(E, D, K) {
          Df(E, K, D);
        });
        function R4(E, D) {
          var K = Ha(E) ? Yo : ow;
          return K(E, Jn(D, 3));
        }
        function Eq(E, D, K, me) {
          return E == null ? [] : (Ha(D) || (D = D == null ? [] : [D]), K = me ? Q : K, Ha(K) || (K = K == null ? [] : [K]), BR(E, D, K));
        }
        var Iq = b4(function(E, D, K) {
          E[K ? 0 : 1].push(D);
        }, function() {
          return [[], []];
        });
        function Mq(E, D, K) {
          var me = Ha(E) ? TC : su, Re = arguments.length < 3;
          return me(E, Jn(D, 4), K, Re, R2);
        }
        function Pq(E, D, K) {
          var me = Ha(E) ? ZP : su, Re = arguments.length < 3;
          return me(E, Jn(D, 4), K, Re, bR);
        }
        function Rq(E, D) {
          var K = Ha(E) ? ml : CR;
          return K(E, N4(Jn(D, 3)));
        }
        function Oq(E) {
          var D = Ha(E) ? hR : nV;
          return D(E);
        }
        function Bq(E, D, K) {
          (K ? pc(E, D, K) : D === Q) ? D = 1 : D = Vn(D);
          var me = Ha(E) ? ew : aV;
          return me(E, D);
        }
        function Nq(E) {
          var D = Ha(E) ? pR : iV;
          return D(E);
        }
        function $q(E) {
          if (E == null)
            return 0;
          if (zc(E))
            return mr(E) ? P0(E) : E.length;
          var D = Yl(E);
          return D == jo || D == Zu ? E.size : iw(E).length;
        }
        function Dq(E, D, K) {
          var me = Ha(E) ? H6 : oV;
          return K && pc(E, D, K) && (D = Q), me(E, Jn(D, 3));
        }
        var Lq = ai(function(E, D) {
          if (E == null)
            return [];
          var K = D.length;
          return K > 1 && pc(E, D[0], D[1]) ? D = [] : K > 2 && pc(D[0], D[1], D[2]) && (D = [D[0]]), BR(E, Dl(D, 1), []);
        }), O4 = E2 || function() {
          return Bl.Date.now();
        };
        function jq(E, D) {
          if (typeof D != "function")
            throw new dc(le);
          return E = Vn(E), function() {
            if (--E < 1)
              return D.apply(this, arguments);
          };
        }
        function MO(E, D, K) {
          return D = K ? Q : D, D = E && D == null ? E.length : D, jf(E, _o, Q, Q, Q, Q, D);
        }
        function PO(E, D) {
          var K;
          if (typeof D != "function")
            throw new dc(le);
          return E = Vn(E), function() {
            return --E > 0 && (K = D.apply(this, arguments)), E <= 1 && (D = Q), K;
          };
        }
        var F3 = ai(function(E, D, K) {
          var me = Sr;
          if (K.length) {
            var Re = _2(K, Ep(F3));
            me |= ja;
          }
          return jf(E, me, D, K, Re);
        }), Iw = ai(function(E, D, K) {
          var me = Sr | Vr;
          if (K.length) {
            var Re = _2(K, Ep(Iw));
            me |= ja;
          }
          return jf(D, me, E, K, Re);
        });
        function Mw(E, D, K) {
          D = K ? Q : D;
          var me = jf(E, ni, Q, Q, Q, Q, Q, D);
          return me.placeholder = Mw.placeholder, me;
        }
        function RO(E, D, K) {
          D = K ? Q : D;
          var me = jf(E, Yn, Q, Q, Q, Q, Q, D);
          return me.placeholder = RO.placeholder, me;
        }
        function OO(E, D, K) {
          var me, Re, et, wt, It, Gt, Cr = 0, wr = !1, Tr = !1, rn = !0;
          if (typeof E != "function")
            throw new dc(le);
          D = Zi(D) || 0, gs(K) && (wr = !!K.leading, Tr = "maxWait" in K, et = Tr ? Fo(Zi(K.maxWait) || 0, D) : et, rn = "trailing" in K ? !!K.trailing : rn);
          function Rn(tl) {
            var Uf = me, Op = Re;
            return me = Re = Q, Cr = tl, wt = E.apply(Op, Uf), wt;
          }
          function oa(tl) {
            return Cr = tl, It = td(Wi, D), wr ? Rn(tl) : wt;
          }
          function Si(tl) {
            var Uf = tl - Gt, Op = tl - Cr, l5e = D - Uf;
            return Tr ? Zl(l5e, et - Op) : l5e;
          }
          function sa(tl) {
            var Uf = tl - Gt, Op = tl - Cr;
            return Gt === Q || Uf >= D || Uf < 0 || Tr && Op >= et;
          }
          function Wi() {
            var tl = O4();
            if (sa(tl))
              return Ji(tl);
            It = td(Wi, Si(tl));
          }
          function Ji(tl) {
            return It = Q, rn && me ? Rn(tl) : (me = Re = Q, wt);
          }
          function Wc() {
            It !== Q && y4(It), Cr = 0, me = Gt = Re = It = Q;
          }
          function mu() {
            return It === Q ? wt : Ji(O4());
          }
          function zd() {
            var tl = O4(), Uf = sa(tl);
            if (me = arguments, Re = this, Gt = tl, Uf) {
              if (It === Q)
                return oa(Gt);
              if (Tr)
                return y4(It), It = td(Wi, D), Rn(Gt);
            }
            return It === Q && (It = td(Wi, D)), wt;
          }
          return zd.cancel = Wc, zd.flush = mu, zd;
        }
        var Fq = ai(function(E, D) {
          return yR(E, 1, D);
        }), Pw = ai(function(E, D, K) {
          return yR(E, Zi(D) || 0, K);
        });
        function zq(E) {
          return jf(E, je);
        }
        function B4(E, D) {
          if (typeof E != "function" || D != null && typeof D != "function")
            throw new dc(le);
          var K = function me() {
            var Re = arguments, et = D ? D.apply(this, Re) : Re[0], wt = me.cache;
            if (wt.has(et))
              return wt.get(et);
            var It = E.apply(this, Re);
            return me.cache = wt.set(et, It) || wt, It;
          };
          return K.cache = new (B4.Cache || O0)(), K;
        }
        B4.Cache = O0;
        function N4(E) {
          if (typeof E != "function")
            throw new dc(le);
          return function() {
            var D = arguments;
            switch (D.length) {
              case 0:
                return !E.call(this);
              case 1:
                return !E.call(this, D[0]);
              case 2:
                return !E.call(this, D[0], D[1]);
              case 3:
                return !E.call(this, D[0], D[1], D[2]);
            }
            return !E.apply(this, D);
          };
        }
        function Fc(E) {
          return PO(2, E);
        }
        var Rw = sV(function(E, D) {
          D = D.length == 1 && Ha(D[0]) ? Yo(D[0], $c(Jn())) : Yo(Dl(D, 1), $c(Jn()));
          var K = D.length;
          return ai(function(me) {
            for (var Re = -1, et = Zl(me.length, K); ++Re < et; )
              me[Re] = D[Re].call(this, me[Re]);
            return ou(E, this, me);
          });
        }), Ow = ai(function(E, D) {
          var K = _2(D, Ep(Ow));
          return jf(E, ja, Q, D, K);
        }), BO = ai(function(E, D) {
          var K = _2(D, Ep(BO));
          return jf(E, Rr, Q, D, K);
        }), Gq = Ff(function(E, D) {
          return jf(E, Ee, Q, Q, Q, D);
        });
        function Wq(E, D) {
          if (typeof E != "function")
            throw new dc(le);
          return D = D === Q ? D : Vn(D), ai(E, D);
        }
        function Bw(E, D) {
          if (typeof E != "function")
            throw new dc(le);
          return D = D == null ? 0 : Fo(Vn(D), 0), ai(function(K) {
            var me = K[D], Re = N2(K, 0, D);
            return me && w2(Re, me), ou(E, this, Re);
          });
        }
        function Hq(E, D, K) {
          var me = !0, Re = !0;
          if (typeof E != "function")
            throw new dc(le);
          return gs(K) && (me = "leading" in K ? !!K.leading : me, Re = "trailing" in K ? !!K.trailing : Re), OO(E, D, { leading: me, maxWait: D, trailing: Re });
        }
        function Nw(E) {
          return MO(E, 1);
        }
        function Uq(E, D) {
          return Ow(mw(D), E);
        }
        function Vq() {
          if (!arguments.length)
            return [];
          var E = arguments[0];
          return Ha(E) ? E : [E];
        }
        function qq(E) {
          return zs(E, St);
        }
        function Kq(E, D) {
          return D = typeof D == "function" ? D : Q, zs(E, St, D);
        }
        function NO(E) {
          return zs(E, Ct | St);
        }
        function Zq(E, D) {
          return D = typeof D == "function" ? D : Q, zs(E, Ct | St, D);
        }
        function Jq(E, D) {
          return D == null || c4(E, D, Ql(D));
        }
        function Fd(E, D) {
          return E === D || E !== E && D !== D;
        }
        var $w = S4(P3), Dw = S4(function(E, D) {
          return E >= D;
        }), Rp = kR(/* @__PURE__ */ function() {
          return arguments;
        }()) ? kR : function(E) {
          return ws(E) && xo.call(E, "callee") && !lu.call(E, "callee");
        }, Ha = rr.isArray, Yq = WP ? $c(WP) : AR;
        function zc(E) {
          return E != null && $4(E.length) && !Wf(E);
        }
        function Rs(E) {
          return ws(E) && zc(E);
        }
        function Xq(E) {
          return E === !0 || E === !1 || ws(E) && el(E) == Ki;
        }
        var D2 = FC || pK, Qq = HP ? $c(HP) : KU;
        function eK(E) {
          return ws(E) && E.nodeType === 1 && !xt(E);
        }
        function tK(E) {
          if (E == null)
            return !0;
          if (zc(E) && (Ha(E) || typeof E == "string" || typeof E.splice == "function" || D2(E) || Zr(E) || Rp(E)))
            return !E.length;
          var D = Yl(E);
          if (D == jo || D == Zu)
            return !E.size;
          if (L3(E))
            return !iw(E).length;
          for (var K in E)
            if (xo.call(E, K))
              return !1;
          return !0;
        }
        function rK(E, D) {
          return R3(E, D);
        }
        function nK(E, D, K) {
          K = typeof K == "function" ? K : Q;
          var me = K ? K(E, D) : Q;
          return me === Q ? R3(E, D, Q, K) : !!me;
        }
        function Lw(E) {
          if (!ws(E))
            return !1;
          var D = el(E);
          return D == Ef || D == Xs || typeof E.message == "string" && typeof E.name == "string" && !xt(E);
        }
        function aK(E) {
          return typeof E == "number" && zC(E);
        }
        function Wf(E) {
          if (!gs(E))
            return !1;
          var D = el(E);
          return D == Mn || D == Ku || D == Fs || D == hC;
        }
        function $O(E) {
          return typeof E == "number" && E == Vn(E);
        }
        function $4(E) {
          return typeof E == "number" && E > -1 && E % 1 == 0 && E <= Ae;
        }
        function gs(E) {
          var D = O.default(E);
          return E != null && (D == "object" || D == "function");
        }
        function ws(E) {
          return E != null && O.default(E) == "object";
        }
        var DO = E0 ? $c(E0) : JU;
        function iK(E, D) {
          return E === D || aw(E, D, _4(D));
        }
        function T(E, D, K) {
          return K = typeof K == "function" ? K : Q, aw(E, D, _4(D), K);
        }
        function $(E) {
          return Xe(E) && E != +E;
        }
        function q(E) {
          if (AV(E))
            throw new Sa(fe);
          return TR(E);
        }
        function de(E) {
          return E === null;
        }
        function Oe(E) {
          return E == null;
        }
        function Xe(E) {
          return typeof E == "number" || ws(E) && el(E) == fp;
        }
        function xt(E) {
          if (!ws(E) || el(E) != If)
            return !1;
          var D = Q6(E);
          if (D === null)
            return !0;
          var K = xo.call(D, "constructor") && D.constructor;
          return typeof K == "function" && K instanceof K && C3.call(K) == FU;
        }
        var Et = UP ? $c(UP) : YU;
        function Wt(E) {
          return $O(E) && E >= -9007199254740991 && E <= Ae;
        }
        var yr = VP ? $c(VP) : XU;
        function mr(E) {
          return typeof E == "string" || !Ha(E) && ws(E) && el(E) == Ol;
        }
        function br(E) {
          return O.default(E) == "symbol" || ws(E) && el(E) == _g;
        }
        var Zr = qP ? $c(qP) : QU;
        function Pn(E) {
          return E === Q;
        }
        function ta(E) {
          return ws(E) && Yl(E) == kg;
        }
        function ii(E) {
          return ws(E) && el(E) == MP;
        }
        var ra = S4(p4), Bi = S4(function(E, D) {
          return E <= D;
        });
        function Li(E) {
          if (!E)
            return [];
          if (zc(E))
            return mr(E) ? Xu(E) : Lc(E);
          if (Cp && E[Cp])
            return eR(E[Cp]());
          var D = Yl(E), K = D == jo ? $l : D == Zu ? K6 : D4;
          return K(E);
        }
        function Os(E) {
          if (!E)
            return E === 0 ? E : 0;
          if (E = Zi(E), E === ye || E === -1 / 0) {
            var D = E < 0 ? -1 : 1;
            return D * Qe;
          }
          return E === E ? E : 0;
        }
        function Vn(E) {
          var D = Os(E), K = D % 1;
          return D === D ? K ? D - K : D : 0;
        }
        function Gc(E) {
          return E ? Ap(Vn(E), 0, Tt) : 0;
        }
        function Zi(E) {
          if (typeof E == "number")
            return E;
          if (br(E))
            return pt;
          if (gs(E)) {
            var D = typeof E.valueOf == "function" ? E.valueOf() : E;
            E = gs(D) ? D + "" : D;
          }
          if (typeof E != "string")
            return E === 0 ? E : +E;
          E = Rf(E);
          var K = Eg.test(E);
          return K || I6.test(E) ? EU(E.slice(2), K ? 2 : 8) : pU.test(E) ? pt : +E;
        }
        function ad(E) {
          return hu(E, id(E));
        }
        function Hf(E) {
          return E ? Ap(Vn(E), -9007199254740991, Ae) : E === 0 ? E : 0;
        }
        function fo(E) {
          return E == null ? "" : fu(E);
        }
        var l3t = Fg(function(E, D) {
          if (L3(D) || zc(D)) {
            hu(D, Ql(D), E);
            return;
          }
          for (var K in D)
            xo.call(D, K) && E3(E, K, D[K]);
        }), Xbe = Fg(function(E, D) {
          hu(D, id(D), E);
        }), LO = Fg(function(E, D, K, me) {
          hu(D, id(D), E, me);
        }), c3t = Fg(function(E, D, K, me) {
          hu(D, Ql(D), E, me);
        }), u3t = Ff(tw);
        function d3t(E, D) {
          var K = kp(E);
          return D == null ? K : gR(K, D);
        }
        var f3t = ai(function(E, D) {
          E = Ao(E);
          var K = -1, me = D.length, Re = me > 2 ? D[2] : Q;
          for (Re && pc(D[0], D[1], Re) && (me = 1); ++K < me; )
            for (var et = D[K], wt = id(et), It = -1, Gt = wt.length; ++It < Gt; ) {
              var Cr = wt[It], wr = E[Cr];
              (wr === Q || Fd(wr, xp[Cr]) && !xo.call(E, Cr)) && (E[Cr] = et[Cr]);
            }
          return E;
        }), h3t = ai(function(E) {
          return E.push(Q, tO), ou(Qbe, Q, E);
        });
        function p3t(E, D) {
          return Bg(E, Jn(D, 3), Dd);
        }
        function m3t(E, D) {
          return Bg(E, Jn(D, 3), u4);
        }
        function g3t(E, D) {
          return E == null ? E : rw(E, Jn(D, 3), id);
        }
        function v3t(E, D) {
          return E == null ? E : wR(E, Jn(D, 3), id);
        }
        function y3t(E, D) {
          return E && Dd(E, Jn(D, 3));
        }
        function b3t(E, D) {
          return E && u4(E, Jn(D, 3));
        }
        function x3t(E) {
          return E == null ? [] : d4(E, Ql(E));
        }
        function C3t(E) {
          return E == null ? [] : d4(E, id(E));
        }
        function oK(E, D, K) {
          var me = E == null ? Q : Lf(E, D);
          return me === Q ? K : me;
        }
        function w3t(E, D) {
          return E != null && iO(E, D, SR);
        }
        function sK(E, D) {
          return E != null && iO(E, D, _R);
        }
        var S3t = JR(function(E, D, K) {
          D != null && typeof D.toString != "function" && (D = $g.call(D)), E[D] = K;
        }, cK(od)), _3t = JR(function(E, D, K) {
          D != null && typeof D.toString != "function" && (D = $g.call(D)), xo.call(E, D) ? E[D].push(K) : E[D] = [K];
        }, Jn), k3t = ai(Ld);
        function Ql(E) {
          return zc(E) ? P2(E) : iw(E);
        }
        function id(E) {
          return zc(E) ? P2(E, !0) : IR(E);
        }
        function A3t(E, D) {
          var K = {};
          return D = Jn(D, 3), Dd(E, function(me, Re, et) {
            Df(K, D(me, Re, et), me);
          }), K;
        }
        function T3t(E, D) {
          var K = {};
          return D = Jn(D, 3), Dd(E, function(me, Re, et) {
            Df(K, Re, D(me, Re, et));
          }), K;
        }
        var E3t = Fg(function(E, D, K) {
          m4(E, D, K);
        }), Qbe = Fg(function(E, D, K, me) {
          m4(E, D, K, me);
        }), I3t = Ff(function(E, D) {
          var K = {};
          if (E == null)
            return K;
          var me = !1;
          D = Yo(D, function(et) {
            return et = B2(et, E), me || (me = et.length > 1), et;
          }), hu(E, Wg(E), K), me && (K = zs(K, Ct | Bt | St, yV));
          for (var Re = D.length; Re--; )
            fw(K, D[Re]);
          return K;
        });
        function M3t(E, D) {
          return e5e(E, N4(Jn(D)));
        }
        var P3t = Ff(function(E, D) {
          return E == null ? {} : eV(E, D);
        });
        function e5e(E, D) {
          if (E == null)
            return {};
          var K = Yo(Wg(E), function(me) {
            return [me];
          });
          return D = Jn(D), NR(E, K, function(me, Re) {
            return D(me, Re[0]);
          });
        }
        function R3t(E, D, K) {
          D = B2(D, E);
          var me = -1, Re = D.length;
          for (Re || (Re = 1, E = Q); ++me < Re; ) {
            var et = E == null ? Q : E[rd(D[me])];
            et === Q && (me = Re, et = K), E = Wf(et) ? et.call(E) : et;
          }
          return E;
        }
        function O3t(E, D, K) {
          return E == null ? E : O3(E, D, K);
        }
        function B3t(E, D, K, me) {
          return me = typeof me == "function" ? me : Q, E == null ? E : O3(E, D, K, me);
        }
        var t5e = QR(Ql), r5e = QR(id);
        function N3t(E, D, K) {
          var me = Ha(E), Re = me || D2(E) || Zr(E);
          if (D = Jn(D, 4), K == null) {
            var et = E && E.constructor;
            Re ? K = me ? new et() : [] : gs(E) ? K = Wf(et) ? kp(Q6(E)) : {} : K = {};
          }
          return (Re ? pl : Dd)(E, function(wt, It, Gt) {
            return D(K, wt, It, Gt);
          }), K;
        }
        function $3t(E, D) {
          return E == null ? !0 : fw(E, D);
        }
        function D3t(E, D, K) {
          return E == null ? E : jR(E, D, mw(K));
        }
        function L3t(E, D, K, me) {
          return me = typeof me == "function" ? me : Q, E == null ? E : jR(E, D, mw(K), me);
        }
        function D4(E) {
          return E == null ? [] : IC(E, Ql(E));
        }
        function j3t(E) {
          return E == null ? [] : IC(E, id(E));
        }
        function F3t(E, D, K) {
          return K === Q && (K = D, D = Q), K !== Q && (K = Zi(K), K = K === K ? K : 0), D !== Q && (D = Zi(D), D = D === D ? D : 0), Ap(Zi(E), D, K);
        }
        function z3t(E, D, K) {
          return D = Os(D), K === Q ? (K = D, D = 0) : K = Os(K), E = Zi(E), f4(E, D, K);
        }
        function G3t(E, D, K) {
          if (K && typeof K != "boolean" && pc(E, D, K) && (D = K = Q), K === Q && (typeof D == "boolean" ? (K = D, D = Q) : typeof E == "boolean" && (K = E, E = Q)), E === Q && D === Q ? (E = 0, D = 1) : (E = Os(E), D === Q ? (D = E, E = 0) : D = Os(D)), E > D) {
            var me = E;
            E = D, D = me;
          }
          if (K || E % 1 || D % 1) {
            var Re = HC();
            return Zl(E + Re * (D - E + gp("1e-" + ((Re + "").length - 1))), D);
          }
          return lw(E, D);
        }
        var W3t = zg(function(E, D, K) {
          return D = D.toLowerCase(), E + (K ? n5e(D) : D);
        });
        function n5e(E) {
          return lK(fo(E).toLowerCase());
        }
        function a5e(E) {
          return E = fo(E), E && E.replace(mU, PC).replace(_U, "");
        }
        function H3t(E, D, K) {
          E = fo(E), D = fu(D);
          var me = E.length;
          K = K === Q ? me : Ap(Vn(K), 0, me);
          var Re = K;
          return K -= D.length, K >= 0 && E.slice(K, Re) == D;
        }
        function U3t(E) {
          return E = fo(E), E && RP.test(E) ? E.replace(hp, QP) : E;
        }
        function V3t(E) {
          return E = fo(E), E && lr.test(E) ? E.replace($t, "\\$&") : E;
        }
        var q3t = zg(function(E, D, K) {
          return E + (K ? "-" : "") + D.toLowerCase();
        }), K3t = zg(function(E, D, K) {
          return E + (K ? " " : "") + D.toLowerCase();
        }), Z3t = qR("toLowerCase");
        function J3t(E, D, K) {
          E = fo(E), D = Vn(D);
          var me = D ? P0(E) : 0;
          if (!D || me >= D)
            return E;
          var Re = (D - me) / 2;
          return N3(wp(Re), K) + E + N3(_3(Re), K);
        }
        function Y3t(E, D, K) {
          E = fo(E), D = Vn(D);
          var me = D ? P0(E) : 0;
          return D && me < D ? E + N3(D - me, K) : E;
        }
        function X3t(E, D, K) {
          E = fo(E), D = Vn(D);
          var me = D ? P0(E) : 0;
          return D && me < D ? N3(D - me, K) + E : E;
        }
        function Q3t(E, D, K) {
          return K || D == null ? D = 0 : D && (D = +D), iR(fo(E).replace(tr, ""), D || 0);
        }
        function ebt(E, D, K) {
          return (K ? pc(E, D, K) : D === Q) ? D = 1 : D = Vn(D), cw(fo(E), D);
        }
        function tbt() {
          var E = arguments, D = fo(E[0]);
          return E.length < 3 ? D : D.replace(E[1], E[2]);
        }
        var rbt = zg(function(E, D, K) {
          return E + (K ? "_" : "") + D.toLowerCase();
        });
        function nbt(E, D, K) {
          return K && typeof K != "number" && pc(E, D, K) && (D = K = Q), K = K === Q ? Tt : K >>> 0, K ? (E = fo(E), E && (typeof D == "string" || D != null && !Et(D)) && (D = fu(D), !D && Of(E)) ? N2(Xu(E), 0, K) : E.split(D, K)) : [];
        }
        var abt = zg(function(E, D, K) {
          return E + (K ? " " : "") + lK(D);
        });
        function ibt(E, D, K) {
          return E = fo(E), K = K == null ? 0 : Ap(Vn(K), 0, E.length), D = fu(D), E.slice(K, K + D.length) == D;
        }
        function obt(E, D, K) {
          var me = Ue.templateSettings;
          K && pc(E, D, K) && (D = Q), E = fo(E), D = LO({}, D, me, eO);
          var Re = LO({}, D.imports, me.imports, eO), et = Ql(Re), wt = IC(Re, et), It, Gt, Cr = 0, wr = D.interpolate || f3, Tr = "__p += '", rn = Z6((D.escape || f3).source + "|" + wr.source + "|" + (wr === OP ? Ju : f3).source + "|" + (D.evaluate || f3).source + "|$", "g"), Rn = "//# sourceURL=" + (xo.call(D, "sourceURL") ? (D.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Og + "]") + `
`;
          E.replace(rn, function(sa, Wi, Ji, Wc, mu, zd) {
            return Ji || (Ji = Wc), Tr += E.slice(Cr, zd).replace(M6, M0), Wi && (It = !0, Tr += `' +
__e(` + Wi + `) +
'`), mu && (Gt = !0, Tr += `';
` + mu + `;
__p += '`), Ji && (Tr += `' +
((__t = (` + Ji + `)) == null ? '' : __t) +
'`), Cr = zd + sa.length, sa;
          }), Tr += `';
`;
          var oa = xo.call(D, "variable") && D.variable;
          if (!oa)
            Tr = `with (obj) {
` + Tr + `
}
`;
          else if (bC.test(oa))
            throw new Sa(ke);
          Tr = (Gt ? Tr.replace(T6, "") : Tr).replace(sU, "$1").replace(lU, "$1;"), Tr = "function(" + (oa || "obj") + `) {
` + (oa ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (It ? ", __e = _.escape" : "") + (Gt ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Tr + `return __p
}`;
          var Si = o5e(function() {
            return uo(et, Rn + "return " + Tr).apply(Q, wt);
          });
          if (Si.source = Tr, Lw(Si))
            throw Si;
          return Si;
        }
        function sbt(E) {
          return fo(E).toLowerCase();
        }
        function lbt(E) {
          return fo(E).toUpperCase();
        }
        function cbt(E, D, K) {
          if (E = fo(E), E && (K || D === Q))
            return Rf(E);
          if (!E || !(D = fu(D)))
            return E;
          var me = Xu(E), Re = Xu(D), et = XP(me, Re), wt = MC(me, Re) + 1;
          return N2(me, et, wt).join("");
        }
        function ubt(E, D, K) {
          if (E = fo(E), E && (K || D === Q))
            return E.slice(0, tR(E) + 1);
          if (!E || !(D = fu(D)))
            return E;
          var me = Xu(E), Re = MC(me, Xu(D)) + 1;
          return N2(me, 0, Re).join("");
        }
        function dbt(E, D, K) {
          if (E = fo(E), E && (K || D === Q))
            return E.replace(tr, "");
          if (!E || !(D = fu(D)))
            return E;
          var me = Xu(E), Re = XP(me, Xu(D));
          return N2(me, Re).join("");
        }
        function fbt(E, D) {
          var K = be, me = oe;
          if (gs(D)) {
            var Re = "separator" in D ? D.separator : Re;
            K = "length" in D ? Vn(D.length) : K, me = "omission" in D ? fu(D.omission) : me;
          }
          E = fo(E);
          var et = E.length;
          if (Of(E)) {
            var wt = Xu(E);
            et = wt.length;
          }
          if (K >= et)
            return E;
          var It = K - P0(me);
          if (It < 1)
            return me;
          var Gt = wt ? N2(wt, 0, It).join("") : E.slice(0, It);
          if (Re === Q)
            return Gt + me;
          if (wt && (It += Gt.length - It), Et(Re)) {
            if (E.slice(It).search(Re)) {
              var Cr, wr = Gt;
              for (Re.global || (Re = Z6(Re.source, fo(d3.exec(Re)) + "g")), Re.lastIndex = 0; Cr = Re.exec(wr); )
                var Tr = Cr.index;
              Gt = Gt.slice(0, Tr === Q ? It : Tr);
            }
          } else if (E.indexOf(fu(Re), It) != It) {
            var rn = Gt.lastIndexOf(Re);
            rn > -1 && (Gt = Gt.slice(0, rn));
          }
          return Gt + me;
        }
        function hbt(E) {
          return E = fo(E), E && $d.test(E) ? E.replace(PP, DU) : E;
        }
        var pbt = zg(function(E, D, K) {
          return E + (K ? " " : "") + D.toUpperCase();
        }), lK = qR("toUpperCase");
        function i5e(E, D, K) {
          return E = fo(E), D = K ? Q : D, D === Q ? yp(E) ? jU(E) : EC(E) : E.match(D) || [];
        }
        var o5e = ai(function(E, D) {
          try {
            return ou(E, Q, D);
          } catch (K) {
            return Lw(K) ? K : new Sa(K);
          }
        }), mbt = Ff(function(E, D) {
          return pl(D, function(K) {
            K = rd(K), Df(E, K, F3(E[K], E));
          }), E;
        });
        function gbt(E) {
          var D = E == null ? 0 : E.length, K = Jn();
          return E = D ? Yo(E, function(me) {
            if (typeof me[1] != "function")
              throw new dc(le);
            return [K(me[0]), me[1]];
          }) : [], ai(function(me) {
            for (var Re = -1; ++Re < D; ) {
              var et = E[Re];
              if (ou(et[0], this, me))
                return ou(et[1], this, me);
            }
          });
        }
        function vbt(E) {
          return hc(zs(E, Ct));
        }
        function cK(E) {
          return function() {
            return E;
          };
        }
        function ybt(E, D) {
          return E == null || E !== E ? D : E;
        }
        var bbt = ZR(), xbt = ZR(!0);
        function od(E) {
          return E;
        }
        function uK(E) {
          return ER(typeof E == "function" ? E : zs(E, Ct));
        }
        function Cbt(E) {
          return MR(zs(E, Ct));
        }
        function wbt(E, D) {
          return PR(E, zs(D, Ct));
        }
        var Sbt = ai(function(E, D) {
          return function(K) {
            return Ld(K, E, D);
          };
        }), _bt = ai(function(E, D) {
          return function(K) {
            return Ld(E, K, D);
          };
        });
        function dK(E, D, K) {
          var me = Ql(D), Re = d4(D, me);
          K == null && !(gs(D) && (Re.length || !me.length)) && (K = D, D = E, E = this, Re = d4(D, Ql(D)));
          var et = !(gs(K) && "chain" in K) || !!K.chain, wt = Wf(E);
          return pl(Re, function(It) {
            var Gt = D[It];
            E[It] = Gt, wt && (E.prototype[It] = function() {
              var Cr = this.__chain__;
              if (et || Cr) {
                var wr = E(this.__wrapped__), Tr = wr.__actions__ = Lc(this.__actions__);
                return Tr.push({ func: Gt, args: arguments, thisArg: E }), wr.__chain__ = Cr, wr;
              }
              return Gt.apply(E, w2([this.value()], arguments));
            });
          }), E;
        }
        function kbt() {
          return Bl._ === this && (Bl._ = DC), this;
        }
        function fK() {
        }
        function Abt(E) {
          return E = Vn(E), ai(function(D) {
            return OR(D, E);
          });
        }
        var Tbt = w4(Yo), Ebt = w4(KP), Ibt = w4(H6);
        function s5e(E) {
          return ww(E) ? y3(rd(E)) : tV(E);
        }
        function Mbt(E) {
          return function(D) {
            return E == null ? Q : Lf(E, D);
          };
        }
        var Pbt = YR(), Rbt = YR(!0);
        function hK() {
          return [];
        }
        function pK() {
          return !1;
        }
        function Obt() {
          return {};
        }
        function Bbt() {
          return "";
        }
        function Nbt() {
          return !0;
        }
        function $bt(E, D) {
          if (E = Vn(E), E < 1 || E > Ae)
            return [];
          var K = Tt, me = Zl(E, Tt);
          D = Jn(D), E -= Tt;
          for (var Re = V6(me, D); ++K < E; )
            D(K);
          return Re;
        }
        function Dbt(E) {
          return Ha(E) ? Yo(E, rd) : br(E) ? [E] : Lc(hO(fo(E)));
        }
        function Lbt(E) {
          var D = ++NC;
          return fo(E) + D;
        }
        var jbt = C4(function(E, D) {
          return E + D;
        }, 0), Fbt = Gg("ceil"), zbt = C4(function(E, D) {
          return E / D;
        }, 1), Gbt = Gg("floor");
        function Wbt(E) {
          return E && E.length ? M3(E, od, P3) : Q;
        }
        function Hbt(E, D) {
          return E && E.length ? M3(E, Jn(D, 2), P3) : Q;
        }
        function Ubt(E) {
          return I0(E, od);
        }
        function Vbt(E, D) {
          return I0(E, Jn(D, 2));
        }
        function qbt(E) {
          return E && E.length ? M3(E, od, p4) : Q;
        }
        function Kbt(E, D) {
          return E && E.length ? M3(E, Jn(D, 2), p4) : Q;
        }
        var Zbt = C4(function(E, D) {
          return E * D;
        }, 1), Jbt = Gg("round"), Ybt = C4(function(E, D) {
          return E - D;
        }, 0);
        function Xbt(E) {
          return E && E.length ? U6(E, od) : 0;
        }
        function Qbt(E, D) {
          return E && E.length ? U6(E, Jn(D, 2)) : 0;
        }
        return Ue.after = jq, Ue.ary = MO, Ue.assign = l3t, Ue.assignIn = Xbe, Ue.assignInWith = LO, Ue.assignWith = c3t, Ue.at = u3t, Ue.before = PO, Ue.bind = F3, Ue.bindAll = mbt, Ue.bindKey = Iw, Ue.castArray = Vq, Ue.chain = _O, Ue.chunk = I4, Ue.compact = ms, Ue.concat = Cs, Ue.cond = gbt, Ue.conforms = vbt, Ue.constant = cK, Ue.countBy = yq, Ue.create = d3t, Ue.curry = Mw, Ue.curryRight = RO, Ue.debounce = OO, Ue.defaults = f3t, Ue.defaultsDeep = h3t, Ue.defer = Fq, Ue.delay = Pw, Ue.difference = pO, Ue.differenceBy = IV, Ue.differenceWith = MV, Ue.drop = PV, Ue.dropRight = RV, Ue.dropRightWhile = OV, Ue.dropWhile = BV, Ue.fill = mO, Ue.filter = xq, Ue.flatMap = Cq, Ue.flatMapDeep = wq, Ue.flatMapDepth = Sq, Ue.flatten = gO, Ue.flattenDeep = vO, Ue.flattenDepth = P4, Ue.flip = zq, Ue.flow = bbt, Ue.flowRight = xbt, Ue.fromPairs = pu, Ue.functions = x3t, Ue.functionsIn = C3t, Ue.groupBy = _q, Ue.initial = $V, Ue.intersection = DV, Ue.intersectionBy = LV, Ue.intersectionWith = jV, Ue.invert = S3t, Ue.invertBy = _3t, Ue.invokeMap = Aq, Ue.iteratee = uK, Ue.keyBy = Tq, Ue.keys = Ql, Ue.keysIn = id, Ue.map = R4, Ue.mapKeys = A3t, Ue.mapValues = T3t, Ue.matches = Cbt, Ue.matchesProperty = wbt, Ue.memoize = B4, Ue.merge = E3t, Ue.mergeWith = Qbe, Ue.method = Sbt, Ue.methodOf = _bt, Ue.mixin = dK, Ue.negate = N4, Ue.nthArg = Abt, Ue.omit = I3t, Ue.omitBy = M3t, Ue.once = Fc, Ue.orderBy = Eq, Ue.over = Tbt, Ue.overArgs = Rw, Ue.overEvery = Ebt, Ue.overSome = Ibt, Ue.partial = Ow, Ue.partialRight = BO, Ue.partition = Iq, Ue.pick = P3t, Ue.pickBy = e5e, Ue.property = s5e, Ue.propertyOf = Mbt, Ue.pull = nd, Ue.pullAll = Aw, Ue.pullAllBy = FV, Ue.pullAllWith = mo, Ue.pullAt = zV, Ue.range = Pbt, Ue.rangeRight = Rbt, Ue.rearg = Gq, Ue.reject = Rq, Ue.remove = xO, Ue.rest = Wq, Ue.reverse = Ug, Ue.sampleSize = Bq, Ue.set = O3t, Ue.setWith = B3t, Ue.shuffle = Nq, Ue.slice = GV, Ue.sortBy = Lq, Ue.sortedUniq = ZV, Ue.sortedUniqBy = JV, Ue.split = nbt, Ue.spread = Bw, Ue.tail = YV, Ue.take = XV, Ue.takeRight = QV, Ue.takeRightWhile = eq, Ue.takeWhile = Tw, Ue.tap = dq, Ue.throttle = Hq, Ue.thru = j3, Ue.toArray = Li, Ue.toPairs = t5e, Ue.toPairsIn = r5e, Ue.toPath = Dbt, Ue.toPlainObject = ad, Ue.transform = N3t, Ue.unary = Nw, Ue.union = tq, Ue.unionBy = Ew, Ue.unionWith = rq, Ue.uniq = nq, Ue.uniqBy = aq, Ue.uniqWith = vl, Ue.unset = $3t, Ue.unzip = Xl, Ue.unzipWith = CO, Ue.update = D3t, Ue.updateWith = L3t, Ue.values = D4, Ue.valuesIn = j3t, Ue.without = iq, Ue.words = i5e, Ue.wrap = Uq, Ue.xor = oq, Ue.xorBy = wO, Ue.xorWith = sq, Ue.zip = lq, Ue.zipObject = cq, Ue.zipObjectDeep = SO, Ue.zipWith = uq, Ue.entries = t5e, Ue.entriesIn = r5e, Ue.extend = Xbe, Ue.extendWith = LO, dK(Ue, Ue), Ue.add = jbt, Ue.attempt = o5e, Ue.camelCase = W3t, Ue.capitalize = n5e, Ue.ceil = Fbt, Ue.clamp = F3t, Ue.clone = qq, Ue.cloneDeep = NO, Ue.cloneDeepWith = Zq, Ue.cloneWith = Kq, Ue.conformsTo = Jq, Ue.deburr = a5e, Ue.defaultTo = ybt, Ue.divide = zbt, Ue.endsWith = H3t, Ue.eq = Fd, Ue.escape = U3t, Ue.escapeRegExp = V3t, Ue.every = bq, Ue.find = AO, Ue.findIndex = Hg, Ue.findKey = p3t, Ue.findLast = TO, Ue.findLastIndex = M4, Ue.findLastKey = m3t, Ue.floor = Gbt, Ue.forEach = EO, Ue.forEachRight = IO, Ue.forIn = g3t, Ue.forInRight = v3t, Ue.forOwn = y3t, Ue.forOwnRight = b3t, Ue.get = oK, Ue.gt = $w, Ue.gte = Dw, Ue.has = w3t, Ue.hasIn = sK, Ue.head = Pp, Ue.identity = od, Ue.includes = kq, Ue.indexOf = NV, Ue.inRange = z3t, Ue.invoke = k3t, Ue.isArguments = Rp, Ue.isArray = Ha, Ue.isArrayBuffer = Yq, Ue.isArrayLike = zc, Ue.isArrayLikeObject = Rs, Ue.isBoolean = Xq, Ue.isBuffer = D2, Ue.isDate = Qq, Ue.isElement = eK, Ue.isEmpty = tK, Ue.isEqual = rK, Ue.isEqualWith = nK, Ue.isError = Lw, Ue.isFinite = aK, Ue.isFunction = Wf, Ue.isInteger = $O, Ue.isLength = $4, Ue.isMap = DO, Ue.isMatch = iK, Ue.isMatchWith = T, Ue.isNaN = $, Ue.isNative = q, Ue.isNil = Oe, Ue.isNull = de, Ue.isNumber = Xe, Ue.isObject = gs, Ue.isObjectLike = ws, Ue.isPlainObject = xt, Ue.isRegExp = Et, Ue.isSafeInteger = Wt, Ue.isSet = yr, Ue.isString = mr, Ue.isSymbol = br, Ue.isTypedArray = Zr, Ue.isUndefined = Pn, Ue.isWeakMap = ta, Ue.isWeakSet = ii, Ue.join = yO, Ue.kebabCase = q3t, Ue.last = Gs, Ue.lastIndexOf = Xa, Ue.lowerCase = K3t, Ue.lowerFirst = Z3t, Ue.lt = ra, Ue.lte = Bi, Ue.max = Wbt, Ue.maxBy = Hbt, Ue.mean = Ubt, Ue.meanBy = Vbt, Ue.min = qbt, Ue.minBy = Kbt, Ue.stubArray = hK, Ue.stubFalse = pK, Ue.stubObject = Obt, Ue.stubString = Bbt, Ue.stubTrue = Nbt, Ue.multiply = Zbt, Ue.nth = bO, Ue.noConflict = kbt, Ue.noop = fK, Ue.now = O4, Ue.pad = J3t, Ue.padEnd = Y3t, Ue.padStart = X3t, Ue.parseInt = Q3t, Ue.random = G3t, Ue.reduce = Mq, Ue.reduceRight = Pq, Ue.repeat = ebt, Ue.replace = tbt, Ue.result = R3t, Ue.round = Jbt, Ue.runInContext = Dt, Ue.sample = Oq, Ue.size = $q, Ue.snakeCase = rbt, Ue.some = Dq, Ue.sortedIndex = WV, Ue.sortedIndexBy = HV, Ue.sortedIndexOf = UV, Ue.sortedLastIndex = VV, Ue.sortedLastIndexBy = qV, Ue.sortedLastIndexOf = KV, Ue.startCase = abt, Ue.startsWith = ibt, Ue.subtract = Ybt, Ue.sum = Xbt, Ue.sumBy = Qbt, Ue.template = obt, Ue.times = $bt, Ue.toFinite = Os, Ue.toInteger = Vn, Ue.toLength = Gc, Ue.toLower = sbt, Ue.toNumber = Zi, Ue.toSafeInteger = Hf, Ue.toString = fo, Ue.toUpper = lbt, Ue.trim = cbt, Ue.trimEnd = ubt, Ue.trimStart = dbt, Ue.truncate = fbt, Ue.unescape = hbt, Ue.uniqueId = Lbt, Ue.upperCase = pbt, Ue.upperFirst = lK, Ue.each = EO, Ue.eachRight = IO, Ue.first = Pp, dK(Ue, function() {
          var E = {};
          return Dd(Ue, function(D, K) {
            xo.call(Ue.prototype, K) || (E[K] = D);
          }), E;
        }(), { chain: !1 }), Ue.VERSION = te, pl(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(E) {
          Ue[E].placeholder = Ue;
        }), pl(["drop", "take"], function(E, D) {
          Di.prototype[E] = function(K) {
            K = K === Q ? 1 : Fo(Vn(K), 0);
            var me = this.__filtered__ && !D ? new Di(this) : this.clone();
            return me.__filtered__ ? me.__takeCount__ = Zl(K, me.__takeCount__) : me.__views__.push({ size: Zl(K, Tt), type: E + (me.__dir__ < 0 ? "Right" : "") }), me;
          }, Di.prototype[E + "Right"] = function(K) {
            return this.reverse()[E](K).reverse();
          };
        }), pl(["filter", "map", "takeWhile"], function(E, D) {
          var K = D + 1, me = K == ue || K == ve;
          Di.prototype[E] = function(Re) {
            var et = this.clone();
            return et.__iteratees__.push({ iteratee: Jn(Re, 3), type: K }), et.__filtered__ = et.__filtered__ || me, et;
          };
        }), pl(["head", "last"], function(E, D) {
          var K = "take" + (D ? "Right" : "");
          Di.prototype[E] = function() {
            return this[K](1).value()[0];
          };
        }), pl(["initial", "tail"], function(E, D) {
          var K = "drop" + (D ? "" : "Right");
          Di.prototype[E] = function() {
            return this.__filtered__ ? new Di(this) : this[K](1);
          };
        }), Di.prototype.compact = function() {
          return this.filter(od);
        }, Di.prototype.find = function(E) {
          return this.filter(E).head();
        }, Di.prototype.findLast = function(E) {
          return this.reverse().find(E);
        }, Di.prototype.invokeMap = ai(function(E, D) {
          return typeof E == "function" ? new Di(this) : this.map(function(K) {
            return Ld(K, E, D);
          });
        }), Di.prototype.reject = function(E) {
          return this.filter(N4(Jn(E)));
        }, Di.prototype.slice = function(E, D) {
          E = Vn(E);
          var K = this;
          return K.__filtered__ && (E > 0 || D < 0) ? new Di(K) : (E < 0 ? K = K.takeRight(-E) : E && (K = K.drop(E)), D !== Q && (D = Vn(D), K = D < 0 ? K.dropRight(-D) : K.take(D - E)), K);
        }, Di.prototype.takeRightWhile = function(E) {
          return this.reverse().takeWhile(E).reverse();
        }, Di.prototype.toArray = function() {
          return this.take(Tt);
        }, Dd(Di.prototype, function(E, D) {
          var K = /^(?:filter|find|map|reject)|While$/.test(D), me = /^(?:head|last)$/.test(D), Re = Ue[me ? "take" + (D == "last" ? "Right" : "") : D], et = me || /^find/.test(D);
          Re && (Ue.prototype[D] = function() {
            var wt = this.__wrapped__, It = me ? [1] : arguments, Gt = wt instanceof Di, Cr = It[0], wr = Gt || Ha(wt), Tr = function(Ji) {
              var Wc = Re.apply(Ue, w2([Ji], It));
              return me && rn ? Wc[0] : Wc;
            };
            wr && K && typeof Cr == "function" && Cr.length != 1 && (Gt = wr = !1);
            var rn = this.__chain__, Rn = !!this.__actions__.length, oa = et && !rn, Si = Gt && !Rn;
            if (!et && wr) {
              wt = Si ? wt : new Di(this);
              var sa = E.apply(wt, It);
              return sa.__actions__.push({ func: j3, args: [Tr], thisArg: Q }), new Jl(sa, rn);
            }
            return oa && Si ? E.apply(this, It) : (sa = this.thru(Tr), oa ? me ? sa.value()[0] : sa.value() : sa);
          });
        }), pl(["pop", "push", "shift", "sort", "splice", "unshift"], function(E) {
          var D = J6[E], K = /^(?:push|sort|unshift)$/.test(E) ? "tap" : "thru", me = /^(?:pop|shift)$/.test(E);
          Ue.prototype[E] = function() {
            var Re = arguments;
            if (me && !this.__chain__) {
              var et = this.value();
              return D.apply(Ha(et) ? et : [], Re);
            }
            return this[K](function(wt) {
              return D.apply(Ha(wt) ? wt : [], Re);
            });
          };
        }), Dd(Di.prototype, function(E, D) {
          var K = Ue[D];
          if (K) {
            var me = K.name + "";
            xo.call(_p, me) || (_p[me] = []), _p[me].push({ name: D, func: K });
          }
        }), _p[x4(Q, Vr).name] = [{ name: "wrapper", func: Q }], Di.prototype.clone = oR, Di.prototype.reverse = sR, Di.prototype.value = n4, Ue.prototype.at = kO, Ue.prototype.chain = fq, Ue.prototype.commit = hq, Ue.prototype.next = pq, Ue.prototype.plant = Vg, Ue.prototype.reverse = gq, Ue.prototype.toJSON = Ue.prototype.valueOf = Ue.prototype.value = vq, Ue.prototype.first = Ue.prototype.head, Cp && (Ue.prototype[Cp] = mq), Ue;
      }, bp = BC();
      uc ? ((uc.exports = bp)._ = bp, _C._ = bp) : Bl._ = bp;
    }).call(Mt);
  })(Qt, Qt.exports);
  function pn(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = Kr(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function Kr(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return Da(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return Da(_e, Pe);
    }
  }
  function Da(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  function La(_e, Pe) {
    var Q = Object.keys(_e);
    if (Object.getOwnPropertySymbols) {
      var te = Object.getOwnPropertySymbols(_e);
      Pe && (te = te.filter(function(J) {
        return Object.getOwnPropertyDescriptor(_e, J).enumerable;
      })), Q.push.apply(Q, te);
    }
    return Q;
  }
  function ji(_e) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var Q = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? La(Object(Q), !0).forEach(function(te) {
        v.default(_e, te, Q[te]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_e, Object.getOwnPropertyDescriptors(Q)) : La(Object(Q)).forEach(function(te) {
        Object.defineProperty(_e, te, Object.getOwnPropertyDescriptor(Q, te));
      });
    }
    return _e;
  }
  function Zo(_e) {
    var Pe = kr();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function kr() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var qi = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = Zo(Q);
    function Q(te, J, fe) {
      var le;
      M.default(this, Q), le = Pe.call(this, te, fe);
      var ke = function(he, $e) {
        return typeof $e.ttl == "number" ? {
          ttl: $e.ttl
        } : he;
      };
      return le.updateMergingQueue = new At(ke), le.cache = new Ht(), le.descriptor = J, le.descriptor.date_updated = new Date(le.descriptor.date_updated), le;
    }
    return B.default(Q, [{
      key: "uri",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "revision",
      get: function() {
        return this.descriptor.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.last_event_id;
      }
    }, {
      key: "links",
      get: function() {
        return this.descriptor.links;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.date_expires;
      }
    }, {
      key: "type",
      get: function() {
        return "list";
      }
      // below properties are specific to Insights only
    }, {
      key: "indexName",
      get: function() {
      }
    }, {
      key: "queryString",
      get: function() {
      }
      // public props, documented along with class description
    }, {
      key: "sid",
      get: function() {
        return this.descriptor.sid;
      }
    }, {
      key: "uniqueName",
      get: function() {
        return this.descriptor.unique_name || null;
      }
    }, {
      key: "dateUpdated",
      get: function() {
        return this.descriptor.date_updated;
      }
    }, {
      key: "_addOrUpdateItemOnServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X, he) {
          var $e, Ct;
          return k.default.wrap(function(St) {
            for (; ; )
              switch (St.prev = St.next) {
                case 0:
                  return $e = {
                    data: ke
                  }, he !== void 0 && ($e.ttl = he), St.next = 4, this.services.network.post(le, $e, X);
                case 4:
                  return Ct = St.sent, Ct.body.data = ke, Ct.body.date_updated = new Date(Ct.body.date_updated), St.abrupt("return", Ct.body);
                case 8:
                case "end":
                  return St.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke, X) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "push",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return X = (ke || {}).ttl, Bt.next = 3, this._addOrUpdateItemOnServer(this.links.items, le, void 0, X);
                case 3:
                  return he = Bt.sent, $e = Number(he.index), this._handleItemMutated($e, he.url, he.last_event_id, he.revision, le, he.date_updated, he.date_expires, !0, !1), Bt.abrupt("return", this.cache.getValue($e));
                case 7:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "set",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he = this, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return $e = X || {}, Bt.abrupt("return", this.updateMergingQueue.squashAndAdd(le, $e, function(St) {
                    return he._updateItemUnconditionally(le, ke, St.ttl);
                  }));
                case 2:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_updateItemUnconditionally",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return Bt.next = 2, this.get(le);
                case 2:
                  return he = Bt.sent, Bt.next = 5, this._addOrUpdateItemOnServer(he.url, ke, void 0, X);
                case 5:
                  return $e = Bt.sent, this._handleItemMutated(le, $e.url, $e.last_event_id, $e.revision, $e.data, $e.date_updated, $e.date_expires, !1, !1), Bt.abrupt("return", this.cache.getValue(le));
                case 8:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_updateItemWithIfMatch",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he, $e, Ct, Bt;
          return k.default.wrap(function(ir) {
            for (; ; )
              switch (ir.prev = ir.next) {
                case 0:
                  return ir.next = 2, this.get(le);
                case 2:
                  if (he = ir.sent, $e = ke(Ce(he.data)), !$e) {
                    ir.next = 25;
                    break;
                  }
                  return Ct = he.revision, ir.prev = 6, ir.next = 9, this._addOrUpdateItemOnServer(he.url, $e, Ct, X);
                case 9:
                  return Bt = ir.sent, this._handleItemMutated(le, Bt.url, Bt.last_event_id, Bt.revision, Bt.data, Bt.date_updated, Bt.date_expires, !1, !1), ir.abrupt("return", this.cache.getValue(le));
                case 14:
                  if (ir.prev = 14, ir.t0 = ir.catch(6), ir.t0.status !== 412) {
                    ir.next = 22;
                    break;
                  }
                  return ir.next = 19, this._getItemFromServer(le);
                case 19:
                  return ir.abrupt("return", this._updateItemWithIfMatch(le, ke, X));
                case 22:
                  throw ir.t0;
                case 23:
                  ir.next = 26;
                  break;
                case 25:
                  return ir.abrupt("return", he);
                case 26:
                case "end":
                  return ir.stop();
              }
          }, fe, this, [[6, 14]]);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he = this, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return $e = X || {}, Bt.abrupt("return", this.updateMergingQueue.add(le, $e, function(St) {
                    return he._updateItemWithIfMatch(le, ke, St.ttl);
                  }));
                case 2:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.abrupt("return", this.mutate(le, function(Ct) {
                    return Object.assign(Ct, ke);
                  }, X));
                case 1:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "remove",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  return Ct.next = 2, this.get(le);
                case 2:
                  return ke = Ct.sent, X = Ce(ke.data), Ct.next = 6, this.services.network.delete(ke.url);
                case 6:
                  he = Ct.sent, this._handleItemRemoved(le, he.body.last_event_id, X, new Date(he.body.date_updated), !1);
                case 8:
                case "end":
                  return Ct.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "get",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  if (ke = this.cache.get(le), !ke) {
                    he.next = 3;
                    break;
                  }
                  return he.abrupt("return", ke.value);
                case 3:
                  return he.abrupt("return", this._getItemFromServer(le));
                case 4:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_getItemFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.next = 2, this._queryItemsFromServer({
                    index: le
                  });
                case 2:
                  if (ke = he.sent, !(ke.items.length < 1)) {
                    he.next = 7;
                    break;
                  }
                  throw new ee("No item with index ".concat(le, " found"), 404, 54151);
                case 7:
                  return he.abrupt("return", ke.items[0]);
                case 8:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Query items from the List
       * @param args Argument pack for the query.
       *             May include the following parameters:
       *
       *             - index -- Returns the Item with the specified index or an empty items array, if one doesn't exist.
       *             - from -- Item index offset specifying the starting point of the query (inclusive). If not specified,
       *                       the query starts from either the first or the last item in the List (by index),
       *                       depending on the Order query parameter.
       *             - order -- String(Optional) -- Determines the order of the query. Items are ordered numerically by index.
       *                                            One of {asc, desc}, defaults to asc.
       *             - pageSize -- Maximum number of Items in the response (i.e. in this page). Defaults to 50.
       *                           The max page size is 1000. Note: PageSize between 100 and 1000 returns at most 100 items.
       *             - pageToken - Direct paging token, for starting from a specific page.
       *             - Metadata - May have the value list. If specified, returns the state of the List in the list attribute of the response.
       *             - HideExpired - Determines whether expired List items are filtered out from the result list. By default, is false.
       *
       *             Stuff not accepted by the service, internal to SDK:
       *
       *             - limit
       *
       *   Valid query parameter combinations
       *   These are the valid query parameter combinations. [x] should be read as “if x is not provided, the default value is assumed”.
       *   The combinations are in order of precedence - e.g., if both Index and PageToken are provided, PageToken is ignored.
       *   +-----------------------------------------+------------------------------------------------------------------------------+
       *   | Index, [Metadata]                       | Returns 0-1 Items with the given Index                                       |
       *   | PageToken, [Metadata]                   | Returns a page based on the PageToken returned from a previous query,        |
       *   |                                         | with this and all following pages modified by any provided query parameters. |
       *   | [From], [Order], [Pagesize], [Metadata] | Performs an initial query from a specified offset.                           |
       *   |                                         | Returned PageTokens in the meta block should be used for pagination.         |
       *   +-----------------------------------------+------------------------------------------------------------------------------+
       * @private
       */
    }, {
      key: "queryItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he, $e, Ct, Bt, St, ir, Ir, Sr, Vr, ri, ni, Yn, ja, Rr, _o, Ee, je, be, oe, ae, xe, ue, pe, ve, ye;
          return k.default.wrap(function(Qe) {
            for (; ; )
              switch (Qe.prev = Qe.next) {
                case 0:
                  if (!le.index) {
                    Qe.next = 5;
                    break;
                  }
                  if (Ir = this.cache.get(le.index), !Ir) {
                    Qe.next = 4;
                    break;
                  }
                  return Qe.abrupt("return", this.makePaginator(Ir.isValid ? [Ir.value] : [], le, !1, !1));
                case 4:
                  return Qe.abrupt("return", this._querySingleItemFromServer(le.index));
                case 5:
                  Sr = !!le.nextPageItemId || !!le.prevPageItemId, Vr = ji({}, le), Sr && (le.from = (ri = (ni = le.nextPageItemId) !== null && ni !== void 0 ? ni : le.prevPageItemId) !== null && ri !== void 0 ? ri : le.from), Yn = !!le.prevPageItemId, ja = le.order === "desc" ? Yn ? this.cache.getIterator((ke = (X = le.prevPageItemId) !== null && X !== void 0 ? X : le.from) !== null && ke !== void 0 ? ke : null) : this.cache.getReverseIterator((he = ($e = le.nextPageItemId) !== null && $e !== void 0 ? $e : le.from) !== null && he !== void 0 ? he : null) : Yn ? this.cache.getReverseIterator((Ct = (Bt = le.prevPageItemId) !== null && Bt !== void 0 ? Bt : le.from) !== null && Ct !== void 0 ? Ct : null) : this.cache.getIterator((St = (ir = le.nextPageItemId) !== null && ir !== void 0 ? ir : le.from) !== null && St !== void 0 ? St : null), Rr = [], _o = Sr ? le.limit + 1 : le.limit, Ee = pn(ja), Qe.prev = 13, Ee.s();
                case 15:
                  if ((je = Ee.n()).done) {
                    Qe.next = 25;
                    break;
                  }
                  if (be = je.value, !(Sr && be.value.index == le.from)) {
                    Qe.next = 19;
                    break;
                  }
                  return Qe.abrupt("continue", 23);
                case 19:
                  if (Rr.push(be.value), !(Rr.length >= le.limit)) {
                    Qe.next = 23;
                    break;
                  }
                  return Yn && Qt.exports.reverse(Rr), Qe.abrupt("return", this.makePaginator(Rr, le, this._prevPageAllowed(Rr, le.order), this._nextPageAllowed(Rr, le.order)));
                case 23:
                  Qe.next = 15;
                  break;
                case 25:
                  Qe.next = 30;
                  break;
                case 27:
                  Qe.prev = 27, Qe.t0 = Qe.catch(13), Ee.e(Qe.t0);
                case 30:
                  return Qe.prev = 30, Ee.f(), Qe.finish(30);
                case 33:
                  if (Rr.length > 0 && (le.from = Qt.exports.last(Rr).index), oe = Math.max(_o - Rr.length, 10), Yn && (le.order = le.order === "desc" ? "asc" : "desc"), ae = le.from !== (Vr.order === "desc" ? Yn ? this.cache.collectionEnd : this.cache.collectionBegin : Yn ? this.cache.collectionBegin : this.cache.collectionEnd), !ae) {
                    Qe.next = 65;
                    break;
                  }
                  return Qe.next = 40, this._queryItemsFromServer(ji(ji({}, le), {}, {
                    limit: oe
                  }));
                case 40:
                  xe = Qe.sent, ue = xe.items, this.cache.populate(ue, !xe.hasPrevPage, !xe.hasNextPage), pe = pn(ue), Qe.prev = 44, pe.s();
                case 46:
                  if ((ve = pe.n()).done) {
                    Qe.next = 55;
                    break;
                  }
                  if (ye = ve.value, !((Rr.length > 0 || Sr) && ye.index == le.from)) {
                    Qe.next = 50;
                    break;
                  }
                  return Qe.abrupt("continue", 53);
                case 50:
                  if (Yn ? Rr.unshift(ye) : Rr.push(ye), !(Rr.length >= le.limit)) {
                    Qe.next = 53;
                    break;
                  }
                  return Qe.abrupt("break", 55);
                case 53:
                  Qe.next = 46;
                  break;
                case 55:
                  Qe.next = 60;
                  break;
                case 57:
                  Qe.prev = 57, Qe.t1 = Qe.catch(44), pe.e(Qe.t1);
                case 60:
                  return Qe.prev = 60, pe.f(), Qe.finish(60);
                case 63:
                  Qe.next = 66;
                  break;
                case 65:
                  Yn && Qt.exports.reverse(Rr);
                case 66:
                  return Qe.abrupt("return", this.makePaginator(Rr, Vr, this._prevPageAllowed(Rr, Vr.order), this._nextPageAllowed(Rr, Vr.order)));
                case 67:
                case "end":
                  return Qe.stop();
              }
          }, fe, this, [[13, 27, 30, 33], [44, 57, 60, 63]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_prevPageAllowed",
      value: function(J, fe) {
        return J.length > 0 && Qt.exports.head(J).index !== (fe === "desc" ? this.cache.collectionEnd : this.cache.collectionBegin);
      }
    }, {
      key: "_nextPageAllowed",
      value: function(J, fe) {
        return J.length > 0 && Qt.exports.last(J).index !== (fe === "desc" ? this.cache.collectionBegin : this.cache.collectionEnd);
      }
      // Paginator depends on:
      // - items listed
      // - was there a previous token (prevPage)
      // - was there a next token (nextPage)
      // - order of items asc/desc
    }, {
      key: "makePaginator",
      value: function(J, fe, le, ke) {
        var X = this;
        fe.nextPageItemId = fe.prevPageItemId = null;
        var he = le && this._prevPageAllowed(J, fe.order), $e = ke && this._nextPageAllowed(J, fe.order);
        return new Xr(J, function(Ct) {
          return X.queryItems(ji(ji({}, fe), Ct));
        }, he ? Qt.exports.head(J).index : null, $e ? Qt.exports.last(J).index : null);
      }
    }, {
      key: "_querySingleItemFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.next = 2, this._queryItemsFromServer({
                    index: le
                  });
                case 2:
                  return ke = he.sent, ke.items.length === 0 && this.cache.delete(le, null), he.abrupt("return", ke);
                case 5:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_queryItemsFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he = this, $e, Ct, Bt, St;
          return k.default.wrap(function(Ir) {
            for (; ; )
              switch (Ir.prev = Ir.next) {
                case 0:
                  return $e = new Y(this.links.items).queryParam("HideExpired", !0).queryParam("Index", le.index).queryParam("PageToken", le.pageToken).queryParam("From", le.from).queryParam("PageSize", le.limit).queryParam("Order", le.order).build(), Ir.next = 3, this.services.network.get($e);
                case 3:
                  return Ct = Ir.sent, Bt = ((ke = (X = Ct.body) === null || X === void 0 ? void 0 : X.items) !== null && ke !== void 0 ? ke : []).map(function(Sr) {
                    return Sr.date_updated = new Date(Sr.date_updated), he._handleItemMutated(Sr.index, Sr.url, Sr.last_event_id, Sr.revision, Sr.data, Sr.date_updated, Sr.date_expires, !1, !0), he.cache.getValue(Sr.index);
                  }), St = Ct.body.meta, Ir.abrupt("return", this.makePaginator(Bt, le, !!St.previous_token, !!St.next_token));
                case 7:
                case "end":
                  return Ir.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "getItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return le = le || {}, we(le.pageSize), le.limit = le.pageSize || le.limit || 50, le.order = le.order || "asc", X.abrupt("return", this.queryItems(le));
                case 5:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @return {Promise<Object>} Context of List
       * @private
       */
    }, {
      key: "getContext",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          var le;
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  if (this.context) {
                    X.next = 5;
                    break;
                  }
                  return X.next = 3, this.services.network.get(this.links.context);
                case 3:
                  le = X.sent, this._updateContextIfRequired(le.body.data, le.body.last_event_id);
                case 5:
                  return X.abrupt("return", this.context);
                case 6:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.prev = 0, ke = {
                    ttl: le
                  }, $e.next = 4, this.services.network.post(this.uri, ke);
                case 4:
                  X = $e.sent, this.descriptor.date_expires = X.body.date_expires, $e.next = 12;
                  break;
                case 8:
                  throw $e.prev = 8, $e.t0 = $e.catch(0), $e.t0.status === 404 && this.onRemoved(!1), $e.t0;
                case 12:
                case "end":
                  return $e.stop();
              }
          }, fe, this, [[0, 8]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "setItemTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return Bt.next = 2, this.get(le);
                case 2:
                  return X = Bt.sent, he = {
                    ttl: ke
                  }, Bt.next = 6, this.services.network.post(X.url, he);
                case 6:
                  $e = Bt.sent, X.updateDateExpires($e.body.date_expires);
                case 8:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "removeList",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return ke.next = 2, this.services.network.delete(this.uri);
                case 2:
                  this.onRemoved(!0);
                case 3:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "onRemoved",
      value: function(J) {
        this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
          isLocal: J
        });
      }
    }, {
      key: "shouldIgnoreEvent",
      value: function(J, fe) {
        return this.cache.isKnown(J, fe);
      }
      /**
       * Handle update, which came from the server.
       * @private
       */
    }, {
      key: "_update",
      value: function(J, fe) {
        var le = Number(J.item_index);
        switch (J.date_created = new Date(J.date_created), J.type) {
          case "list_item_added":
          case "list_item_updated":
            this._handleItemMutated(
              le,
              J.item_url,
              J.id,
              J.item_revision,
              J.item_data,
              J.date_created,
              J.date_expires,
              // orchestration events include date_expires since June 2020, SP-386
              J.type === "list_item_added",
              !0
            );
            break;
          case "list_item_removed":
            this._handleItemRemoved(le, J.id, J.item_data, J.date_created, !0);
            break;
          case "list_context_updated":
            this._handleContextUpdate(J.context_data, J.id, J.date_created);
            break;
          case "list_removed":
            this.onRemoved(!1);
            break;
        }
        fe && this._advanceLastEventId(J.id, J.list_revision);
      }
    }, {
      key: "_advanceLastEventId",
      value: function(J, fe) {
        this.lastEventId < J && (this.descriptor.last_event_id = J, fe && (this.descriptor.revision = fe));
      }
    }, {
      key: "_updateRootDateUpdated",
      value: function(J) {
        (!this.descriptor.date_updated || J.getTime() > this.descriptor.date_updated.getTime()) && (this.descriptor.date_updated = J, this.services.storage.update(this.type, this.sid, this.uniqueName, {
          date_updated: J
        }));
      }
    }, {
      key: "_handleItemMutated",
      value: function(J, fe, le, ke, X, he, $e, Ct, Bt) {
        if (this.shouldIgnoreEvent(J, le)) {
          Ze.trace("Item ".concat(J, " update skipped, current: ").concat(this.lastEventId, ", remote: ").concat(le));
          return;
        }
        this._updateRootDateUpdated(he);
        var St = this.cache.getValue(J);
        if (!St) {
          var ir = new pr({
            index: J,
            url: fe,
            lastEventId: le,
            revision: ke,
            data: X,
            dateUpdated: he,
            dateExpires: $e
          });
          this.cache.store(J, ir, le), this.emitItemMutationEvent(ir, Bt, Ct);
          return;
        }
        var Ir = Ce(St.data);
        St.update(le, ke, X, he), this.cache.store(J, St, le), $e !== void 0 && St.updateDateExpires($e), this.emitItemMutationEvent(St, Bt, !1, Ir);
      }
      /**
       * @private
       */
    }, {
      key: "emitItemMutationEvent",
      value: function(J, fe, le) {
        var ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, X = le ? "itemAdded" : "itemUpdated", he = {
          item: J,
          isLocal: !fe
        };
        le || (he.previousItemData = ke), this.broadcastEventToListeners(X, he);
      }
      /**
       * @private
       */
    }, {
      key: "_handleItemRemoved",
      value: function(J, fe, le, ke, X) {
        this._updateRootDateUpdated(ke), this.cache.delete(J, fe), this.broadcastEventToListeners("itemRemoved", {
          index: J,
          isLocal: !X,
          previousItemData: le
        });
      }
      /**
       * @private
       */
    }, {
      key: "_handleContextUpdate",
      value: function(J, fe, le) {
        this._updateRootDateUpdated(le), this._updateContextIfRequired(J, fe) && this.broadcastEventToListeners("contextUpdated", {
          context: J,
          isLocal: !1
        });
      }
      /**
       * @private
       */
    }, {
      key: "_updateContextIfRequired",
      value: function(J, fe) {
        return !this.contextEventId || fe > this.contextEventId ? (this.context = J, this.contextEventId = fe, !0) : (Ze.trace("Context update skipped, current:", this.lastEventId, ", remote:", fe), !1);
      }
    }], [{
      key: "type",
      get: function() {
        return "list";
      }
    }]), Q;
  }(Ft), vi = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = Zo(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), J.syncListImpl = te, J.syncListImpl.attach(L.default(J)), J;
    }
    return B.default(Q, [{
      key: "uri",
      get: (
        // private props
        function() {
          return this.syncListImpl.uri;
        }
      )
    }, {
      key: "revision",
      get: function() {
        return this.syncListImpl.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.syncListImpl.lastEventId;
      }
    }, {
      key: "links",
      get: function() {
        return this.syncListImpl.links;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.syncListImpl.dateExpires;
      }
    }, {
      key: "type",
      get: function() {
        return qi.type;
      }
      /**
       * Unique ID of the list, immutable identifier assigned by the system.
       */
    }, {
      key: "sid",
      get: function() {
        return this.syncListImpl.sid;
      }
      /**
       * Unique name of the list, immutable identifier that can be assigned to the list during creation.
       */
    }, {
      key: "uniqueName",
      get: function() {
        return this.syncListImpl.uniqueName;
      }
      /**
       * Date when the list was last updated, given in UTC ISO 8601 format (e.g., '2018-04-26T15:23:19.732Z').
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.syncListImpl.dateUpdated;
      }
    }, {
      key: "push",
      value: (
        /**
         * Add a new item to the list.
         * @param data Data to be added.
         * @param itemMetadata Item metadata.
         * @return The newly added item.
         * @example
         * ```typescript
         * list.push({ name: 'John Smith' }, { ttl: 86400 })
         *   .then((item) => {
         *     console.log(`List Item push() successful, item index: ${item.index}, data:`, item.data)
         *   })
         *   .catch((error) => {
         *     console.error('List Item push() failed', error);
         *   });
         * ```
         */
        function() {
          var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
            return k.default.wrap(function(he) {
              for (; ; )
                switch (he.prev = he.next) {
                  case 0:
                    return this.ensureNotClosed(), he.abrupt("return", this.syncListImpl.push(le, ke));
                  case 2:
                  case "end":
                    return he.stop();
                }
            }, fe, this);
          }));
          function J(fe, le) {
            return te.apply(this, arguments);
          }
          return J;
        }()
      )
      /**
       * Assign new data to an existing item, given its index.
       * @param index Index of the item to be updated.
       * @param value New data to be assigned to an item.
       * @param itemMetadataUpdates New item metadata.
       * @return A promise with the updated item containing latest known data.
       * The promise will be rejected if the item does not exist.
       * @example
       * ```typescript
       * list.set(42, { name: 'John Smith' }, { ttl: 86400 })
       *   .then((item) => {
       *     console.log('List Item set() successful, item data:', item.data)
       *   })
       *   .catch((error) => {
       *     console.error('List Item set() failed', error);
       *   });
       * ```
       */
    }, {
      key: "set",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return this.ensureNotClosed(), $e.abrupt("return", this.syncListImpl.set(le, ke, X));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Modify an existing item by applying a mutation function to it.
       * @param index Index of the item to be changed.
       * @param mutator A function that outputs a new data based on the existing data.
       * @param itemMetadataUpdates New item metadata.
       * @return Resolves with the most recent item state, the output of a successful
       * mutation or a state that prompted graceful cancellation (mutator returned `null`). This promise
       * will be rejected if the indicated item does not already exist.
       * @example
       * ```typescript
       * const mutatorFunction = (currentValue) => {
       *     currentValue.viewCount = (currentValue.viewCount || 0) + 1;
       *     return currentValue;
       * };
       * list.mutate(42, mutatorFunction, { ttl: 86400 })
       *   .then((item) => {
       *     console.log('List Item mutate() successful, new data:', item.data)
       *   })
       *   .catch((error) => {
       *     console.error('List Item mutate() failed', error);
       *   });
       * ```
       */
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return this.ensureNotClosed(), $e.abrupt("return", this.syncListImpl.mutate(le, ke, X));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Modify an existing item by appending new fields (or overwriting existing ones) with the values from the object.
       * This is equivalent to
       * ```typescript
       * list.mutate(42, (currentValue) => Object.assign(currentValue, obj));
       * ```
       * @param index Index of an item to be changed.
       * @param obj Set of fields to update.
       * @param itemMetadataUpdates New item metadata.
       * @return A promise with a modified item containing latest known data.
       * The promise will be rejected if the item was not found.
       * @example
       * ```typescript
       * // Say, the List Item (index: 42) data is `{ name: 'John Smith' }`
       * list.update(42, { age: 34 }, { ttl: 86400 })
       *   .then((item) => {
       *     // Now the List Item data is `{ name: 'John Smith', age: 34 }`
       *     console.log('List Item update() successful, new data:', item.data);
       *   })
       *   .catch((error) => {
       *     console.error('List Item update() failed', error);
       *   });
       * ```
       */
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return this.ensureNotClosed(), $e.abrupt("return", this.syncListImpl.update(le, ke, X));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Delete an item given its index.
       * @param index Index of the item to be removed.
       * @return A promise to remove the item.
       * The promise will be rejected if the item was not found.
       * @example
       * ```typescript
       * list.remove(42)
       *   .then(() => {
       *     console.log('List Item remove() successful');
       *   })
       *   .catch((error) => {
       *     console.error('List Item remove() failed', error);
       *   });
       * ```
       */
    }, {
      key: "remove",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncListImpl.remove(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Retrieve an item by List index.
       * @param index Item index in the list.
       * @return A promise with the item containing latest known data.
       * The promise will be rejected if the item was not found.
       * @example
       * ```typescript
       * list.get(42)
       *   .then((item) => {
       *     console.log('List Item get() successful, item data:', item.data)
       *   })
       *   .catch((error) => {
       *     console.error('List Item get() failed', error);
       *   });
       * ```
       */
    }, {
      key: "get",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncListImpl.get(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Retrieve a list context
       * @return A promise with the list's context
       * @internal
       */
    }, {
      key: "getContext",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return this.ensureNotClosed(), ke.abrupt("return", this.syncListImpl.getContext());
                case 2:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Query a list of items from collection.
       * Information about the query limits can be found {@link https://www.twilio.com/docs/sync/limits|here}.
       * @param queryOptions Query options.
       * @example
       * ```typescript
       * const pageHandler = (paginator) => {
       *   paginator.items.forEach((item) => {
       *     console.log(`Item ${item.index}:`, item.data);
       *   });
       *   return paginator.hasNextPage
       *     ? paginator.nextPage().then(pageHandler)
       *     : null;
       * };
       * list.getItems({ from: 0, order: 'asc' })
       *   .then(pageHandler)
       *   .catch((error) => {
       *     console.error('List getItems() failed', error);
       *   });
       * ```
       */
    }, {
      key: "getItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncListImpl.getItems(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Update the time-to-live of the list.
       * @param ttl Specifies the TTL in seconds after which the list is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * list.setTtl(3600)
       *   .then(() => {
       *     console.log('List setTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('List setTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncListImpl.setTtl(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Update the time-to-live of a list item.
       * @param index Item index.
       * @param ttl Specifies the TTL in seconds after which the list item is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * list.setItemTtl(42, 86400)
       *   .then(() => {
       *     console.log('List setItemTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('List setItemTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setItemTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return this.ensureNotClosed(), he.abrupt("return", this.syncListImpl.setItemTtl(le, ke));
                case 2:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Delete this list. It will be impossible to restore it.
       * @return A promise that resolves when the list has been deleted.
       * @example
       * list.removeList()
       *   .then(() => {
       *     console.log('List removeList() successful');
       *   })
       *   .catch((error) => {
       *     console.error('List removeList() failed', error);
       *   });
       */
    }, {
      key: "removeList",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return this.ensureNotClosed(), ke.abrupt("return", this.syncListImpl.removeList());
                case 2:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Conclude work with the list instance and remove all event listeners attached to it.
       * Any subsequent operation on this object will be rejected with error.
       * Other local copies of this list will continue operating and receiving events normally.
       * @example
       * ```typescript
       * list.close();
       * ```
       */
    }, {
      key: "close",
      value: function() {
        z.default(m.default(Q.prototype), "close", this).call(this), this.syncListImpl.detach(this.listenerUuid);
      }
    }], [{
      key: "type",
      get: function() {
        return qi.type;
      }
    }]), Q;
  }(yt);
  v.default(vi, "itemAdded", "itemAdded"), v.default(vi, "itemUpdated", "itemUpdated"), v.default(vi, "itemRemoved", "itemRemoved"), v.default(vi, "removed", "removed"), Z([u.validateTypesAsync(u.pureObject, ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object, Object]), V("design:returntype", Promise)], vi.prototype, "push", null), Z([u.validateTypesAsync(u.nonNegativeInteger, u.pureObject, ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Number, Object, Object]), V("design:returntype", Promise)], vi.prototype, "set", null), Z([u.validateTypesAsync(u.nonNegativeInteger, "function", ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Number, Function, Object]), V("design:returntype", Promise)], vi.prototype, "mutate", null), Z([u.validateTypesAsync(u.nonNegativeInteger, u.pureObject, ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Number, Object, Object]), V("design:returntype", Promise)], vi.prototype, "update", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], vi.prototype, "remove", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], vi.prototype, "get", null), Z([u.validateTypesAsync(["undefined", u.objectSchema("query options", {
    from: [u.nonNegativeInteger, "undefined"],
    pageSize: [u.custom(function(_e) {
      return [Fe(_e), "a positive integer"];
    }), "undefined"],
    order: [u.custom(function(_e) {
      return [_e === "asc" || _e === "desc", "either 'asc' or 'desc'"];
    }), "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], vi.prototype, "getItems", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], vi.prototype, "setTtl", null), Z([u.validateTypesAsync(u.nonNegativeInteger, u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number, Number]), V("design:returntype", Promise)], vi.prototype, "setItemTtl", null);
  var Ho = /* @__PURE__ */ function() {
    function _e(Pe) {
      M.default(this, _e), this.descriptor = Pe;
    }
    return B.default(_e, [{
      key: "uri",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "revision",
      get: function() {
        return this.descriptor.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.last_event_id;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.date_expires;
      }
      /**
       * The identifier that maps to this item within the containing Map.
       */
    }, {
      key: "key",
      get: function() {
        return this.descriptor.key;
      }
      /**
       * The contents of the item.
       */
    }, {
      key: "data",
      get: function() {
        return this.descriptor.data;
      }
      /**
       * Date when the map item was last updated.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.descriptor.date_updated;
      }
      /**
       * CachedValue interface.
       */
    }, {
      key: "cacheKey",
      get: function() {
        return this.key;
      }
      /**
       * @internal
       */
    }, {
      key: "update",
      value: function(Q, te, J, fe) {
        return this.descriptor.last_event_id = Q, this.descriptor.revision = te, this.descriptor.data = J, this.descriptor.date_updated = fe, this;
      }
      /**
       * @internal
       */
    }, {
      key: "updateDateExpires",
      value: function(Q) {
        this.descriptor.date_expires = Q;
      }
    }]), _e;
  }();
  function Ec(_e, Pe) {
    var Q = typeof Symbol < "u" && _e[Symbol.iterator] || _e["@@iterator"];
    if (!Q) {
      if (Array.isArray(_e) || (Q = Uu(_e)) || Pe) {
        Q && (_e = Q);
        var te = 0, J = function() {
        };
        return { s: J, n: function() {
          return te >= _e.length ? { done: !0 } : { done: !1, value: _e[te++] };
        }, e: function(he) {
          throw he;
        }, f: J };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var fe = !0, le = !1, ke;
    return { s: function() {
      Q = Q.call(_e);
    }, n: function() {
      var he = Q.next();
      return fe = he.done, he;
    }, e: function(he) {
      le = !0, ke = he;
    }, f: function() {
      try {
        !fe && Q.return != null && Q.return();
      } finally {
        if (le) throw ke;
      }
    } };
  }
  function Uu(_e, Pe) {
    if (_e) {
      if (typeof _e == "string") return Ic(_e, Pe);
      var Q = Object.prototype.toString.call(_e).slice(8, -1);
      if (Q === "Object" && _e.constructor && (Q = _e.constructor.name), Q === "Map" || Q === "Set") return Array.from(_e);
      if (Q === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Q)) return Ic(_e, Pe);
    }
  }
  function Ic(_e, Pe) {
    (Pe == null || Pe > _e.length) && (Pe = _e.length);
    for (var Q = 0, te = new Array(Pe); Q < Pe; Q++)
      te[Q] = _e[Q];
    return te;
  }
  function js(_e, Pe) {
    var Q = Object.keys(_e);
    if (Object.getOwnPropertySymbols) {
      var te = Object.getOwnPropertySymbols(_e);
      Pe && (te = te.filter(function(J) {
        return Object.getOwnPropertyDescriptor(_e, J).enumerable;
      })), Q.push.apply(Q, te);
    }
    return Q;
  }
  function Mc(_e) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var Q = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? js(Object(Q), !0).forEach(function(te) {
        v.default(_e, te, Q[te]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_e, Object.getOwnPropertyDescriptors(Q)) : js(Object(Q)).forEach(function(te) {
        Object.defineProperty(_e, te, Object.getOwnPropertyDescriptor(Q, te));
      });
    }
    return _e;
  }
  function Vu(_e) {
    var Pe = So();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function So() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Kl = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = Vu(Q);
    function Q(te, J, fe) {
      var le;
      M.default(this, Q), le = Pe.call(this, te, fe);
      var ke = function(he, $e) {
        return typeof $e.ttl == "number" ? {
          ttl: $e.ttl
        } : he;
      };
      return le.updateMergingQueue = new At(ke), le.cache = new Ht(), le.descriptor = J, le.descriptor.date_updated = new Date(le.descriptor.date_updated), J.items && J.items.forEach(function(X) {
        X.date_updated = new Date(X.date_updated), le.cache.store(X.key, new Ho(X), X.last_event_id);
      }), le;
    }
    return B.default(Q, [{
      key: "uri",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "links",
      get: function() {
        return this.descriptor.links;
      }
    }, {
      key: "revision",
      get: function() {
        return this.descriptor.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.last_event_id;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.date_expires;
      }
    }, {
      key: "type",
      get: function() {
        return "map";
      }
      // below properties are specific to Insights only
    }, {
      key: "indexName",
      get: function() {
      }
    }, {
      key: "queryString",
      get: function() {
      }
      // public props, documented along with class description
    }, {
      key: "sid",
      get: function() {
        return this.descriptor.sid;
      }
    }, {
      key: "uniqueName",
      get: function() {
        return this.descriptor.unique_name || null;
      }
    }, {
      key: "dateUpdated",
      get: function() {
        return this.descriptor.date_updated;
      }
    }, {
      key: "set",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he = this, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return $e = X || {}, Bt.abrupt("return", this.updateMergingQueue.squashAndAdd(le, $e, function(St) {
                    return he._putItemUnconditionally(le, ke, St.ttl);
                  }));
                case 2:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "get",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  if (le != null) {
                    X.next = 2;
                    break;
                  }
                  throw new ee("SyncMapItem key may not be empty", 400, 54209);
                case 2:
                  if (!this.cache.has(le)) {
                    X.next = 6;
                    break;
                  }
                  return X.abrupt("return", this.cache.getValue(le));
                case 6:
                  return X.abrupt("return", this._getItemFromServer(le));
                case 7:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_getItemFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.next = 2, this._queryItemsFromServer({
                    key: le
                  });
                case 2:
                  if (ke = he.sent, !(ke.items.length < 1)) {
                    he.next = 7;
                    break;
                  }
                  throw new ee("The specified Map Item does not exist", 404, 54201);
                case 7:
                  return he.abrupt("return", ke.items[0]);
                case 8:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he = this, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return $e = X || {}, Bt.abrupt("return", this.updateMergingQueue.add(le, $e, function(St) {
                    return he._putItemWithIfMatch(le, ke, St.ttl);
                  }));
                case 2:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.abrupt("return", this.mutate(le, function(Ct) {
                    return Object.assign(Ct, ke);
                  }, X));
                case 1:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_putItemUnconditionally",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return Bt.next = 2, this._putItemToServer(le, ke, void 0, X);
                case 2:
                  return he = Bt.sent, $e = he.item, this._handleItemMutated($e.key, $e.url, $e.last_event_id, $e.revision, $e.data, $e.date_updated, $e.date_expires, he.added, !1), Bt.abrupt("return", this.cache.getValue($e.key));
                case 6:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_putItemWithIfMatch",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          var he, $e, Ct, Bt, St;
          return k.default.wrap(function(Ir) {
            for (; ; )
              switch (Ir.prev = Ir.next) {
                case 0:
                  return Ir.next = 2, this.get(le).catch(function(Sr) {
                    if (Sr.status === 404)
                      return new Ho({
                        key: le,
                        data: {},
                        last_event_id: -1,
                        revision: "-1",
                        url: null,
                        date_updated: null,
                        date_expires: null
                      });
                    throw Sr;
                  });
                case 2:
                  if (he = Ir.sent, $e = ke(Ce(he.data)), !$e) {
                    Ir.next = 26;
                    break;
                  }
                  return Ct = he.revision, Ir.prev = 6, Ir.next = 9, this._putItemToServer(le, $e, Ct, X);
                case 9:
                  return Bt = Ir.sent, St = Bt.item, this._handleItemMutated(St.key, St.url, St.last_event_id, St.revision, St.data, St.date_updated, St.date_expires, Bt.added, !1), Ir.abrupt("return", this.cache.getValue(St.key));
                case 15:
                  if (Ir.prev = 15, Ir.t0 = Ir.catch(6), Ir.t0.status !== 412) {
                    Ir.next = 23;
                    break;
                  }
                  return Ir.next = 20, this._getItemFromServer(le);
                case 20:
                  return Ir.abrupt("return", this._putItemWithIfMatch(le, ke, X));
                case 23:
                  throw Ir.t0;
                case 24:
                  Ir.next = 27;
                  break;
                case 26:
                  return Ir.abrupt("return", he);
                case 27:
                case "end":
                  return Ir.stop();
              }
          }, fe, this, [[6, 15]]);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_putItemToServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X, he) {
          var $e, Ct, Bt, St, ir;
          return k.default.wrap(function(Sr) {
            for (; ; )
              switch (Sr.prev = Sr.next) {
                case 0:
                  return $e = new Y(this.links.items).pathSegment(le).build(), Ct = {
                    data: ke
                  }, he !== void 0 && (Ct.ttl = he), Sr.prev = 3, Sr.next = 6, this.services.network.put($e, Ct, X);
                case 6:
                  return Bt = Sr.sent, St = Bt.body, St.data = ke, St.date_updated = new Date(St.date_updated), ir = Bt.status.code === 201, Sr.abrupt("return", {
                    added: ir,
                    item: St
                  });
                case 14:
                  throw Sr.prev = 14, Sr.t0 = Sr.catch(3), Sr.t0.status === 404 && this.onRemoved(!1), Sr.t0;
                case 18:
                case "end":
                  return Sr.stop();
              }
          }, fe, this, [[3, 14]]);
        }));
        function J(fe, le, ke, X) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "remove",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  return Ct.next = 2, this.get(le);
                case 2:
                  return ke = Ct.sent, X = Ce(ke.data), Ct.next = 6, this.services.network.delete(ke.uri);
                case 6:
                  he = Ct.sent, this._handleItemRemoved(le, he.body.last_event_id, X, new Date(he.body.date_updated), !1);
                case 8:
                case "end":
                  return Ct.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @param args Argument pack for the query.
       *             May include the following parameters:
       *
       *             - key -- Returns the Item with the specified key or an empty items array, if one doesn't exist.
       *             - from -- Item index offset specifying the starting point of the query (inclusive). If not specified,
       *                       the query starts from either the first or the last item in the List (by index),
       *                       depending on the Order query parameter.
       *             - order -- String(Optional) -- Determines the order of the query. Items are ordered numerically by index.
       *                                            One of {asc, desc}, defaults to asc.
       *             - pageSize -- Maximum number of Items in the response (i.e. in this page). Defaults to 50.
       *                           The max page size is 1000. Note: PageSize between 100 and 1000 returns at most 100 items.
       *             - pageToken - Direct paging token, for starting from a specific page.
       *             - Metadata - May have the value list. If specified, returns the state of the List in the list attribute of the response.
       *             - HideExpired - Determines whether expired List items are filtered out from the result list. By default, is false.
       *
       *             Stuff not accepted by the service, internal to SDK:
       *
       *             - limit
       *             - isNextPage
       *
       *   Valid query parameter combinations
       *   These are the valid query parameter combinations. [x] should be read as “if x is not provided, the default value is assumed”.
       *   The combinations are in order of precedence - e.g., if both Key and PageToken are provided, PageToken is ignored.
       *   +-----------------------------------------+------------------------------------------------------------------------------+
       *   | Key, [Metadata]                         | Returns 0-1 Items with the given Key                                         |
       *   | PageToken, [Metadata]                   | Returns a page based on the PageToken returned from a previous query,        |
       *   |                                         | with this and all following pages modified by any provided query parameters. |
       *   | [From], [Order], [Pagesize], [Metadata] | Performs an initial query from a specified offset.                           |
       *   |                                         | Returned PageTokens in the meta block should be used for pagination.         |
       *   +-----------------------------------------+------------------------------------------------------------------------------+
       * @private
       */
    }, {
      key: "queryItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he, $e, Ct, Bt, St, ir, Ir, Sr, Vr, ri, ni, Yn, ja, Rr, _o, Ee, je, be, oe, ae, xe, ue, pe, ve, ye;
          return k.default.wrap(function(Qe) {
            for (; ; )
              switch (Qe.prev = Qe.next) {
                case 0:
                  if (!le.key) {
                    Qe.next = 5;
                    break;
                  }
                  if (Ir = this.cache.get(le.key), !Ir) {
                    Qe.next = 4;
                    break;
                  }
                  return Qe.abrupt("return", this.makePaginator(Ir.isValid ? [Ir.value] : [], le, !1, !1));
                case 4:
                  return Qe.abrupt("return", this._querySingleItemFromServer(le.key));
                case 5:
                  Sr = !!le.nextPageItemId || !!le.prevPageItemId, Vr = Mc({}, le), Sr && (le.from = (ri = (ni = le.nextPageItemId) !== null && ni !== void 0 ? ni : le.prevPageItemId) !== null && ri !== void 0 ? ri : le.from), Yn = !!le.prevPageItemId, ja = le.order === "desc" ? Yn ? this.cache.getIterator((ke = (X = le.prevPageItemId) !== null && X !== void 0 ? X : le.from) !== null && ke !== void 0 ? ke : null) : this.cache.getReverseIterator((he = ($e = le.nextPageItemId) !== null && $e !== void 0 ? $e : le.from) !== null && he !== void 0 ? he : null) : Yn ? this.cache.getReverseIterator((Ct = (Bt = le.prevPageItemId) !== null && Bt !== void 0 ? Bt : le.from) !== null && Ct !== void 0 ? Ct : null) : this.cache.getIterator((St = (ir = le.nextPageItemId) !== null && ir !== void 0 ? ir : le.from) !== null && St !== void 0 ? St : null), Rr = [], _o = Sr ? le.limit + 1 : le.limit, Ee = Ec(ja), Qe.prev = 13, Ee.s();
                case 15:
                  if ((je = Ee.n()).done) {
                    Qe.next = 25;
                    break;
                  }
                  if (be = je.value, !(Sr && be.value.key == le.from)) {
                    Qe.next = 19;
                    break;
                  }
                  return Qe.abrupt("continue", 23);
                case 19:
                  if (Rr.push(be.value), !(Rr.length >= le.limit)) {
                    Qe.next = 23;
                    break;
                  }
                  return Yn && Qt.exports.reverse(Rr), Qe.abrupt("return", this.makePaginator(Rr, le, this._prevPageAllowed(Rr, le.order), this._nextPageAllowed(Rr, le.order)));
                case 23:
                  Qe.next = 15;
                  break;
                case 25:
                  Qe.next = 30;
                  break;
                case 27:
                  Qe.prev = 27, Qe.t0 = Qe.catch(13), Ee.e(Qe.t0);
                case 30:
                  return Qe.prev = 30, Ee.f(), Qe.finish(30);
                case 33:
                  if (Rr.length > 0 && (le.from = Qt.exports.last(Rr).key), oe = Math.max(_o - Rr.length, 10), Yn && (le.order = le.order === "desc" ? "asc" : "desc"), ae = le.from !== (Vr.order === "desc" ? Yn ? this.cache.collectionEnd : this.cache.collectionBegin : Yn ? this.cache.collectionBegin : this.cache.collectionEnd), !ae) {
                    Qe.next = 65;
                    break;
                  }
                  return Qe.next = 40, this._queryItemsFromServer(Mc(Mc({}, le), {}, {
                    limit: oe
                  }));
                case 40:
                  xe = Qe.sent, ue = xe.items, this.cache.populate(ue, !xe.hasPrevPage, !xe.hasNextPage), pe = Ec(ue), Qe.prev = 44, pe.s();
                case 46:
                  if ((ve = pe.n()).done) {
                    Qe.next = 55;
                    break;
                  }
                  if (ye = ve.value, !((Rr.length > 0 || Sr) && ye.key == le.from)) {
                    Qe.next = 50;
                    break;
                  }
                  return Qe.abrupt("continue", 53);
                case 50:
                  if (Yn ? Rr.unshift(ye) : Rr.push(ye), !(Rr.length >= le.limit)) {
                    Qe.next = 53;
                    break;
                  }
                  return Qe.abrupt("break", 55);
                case 53:
                  Qe.next = 46;
                  break;
                case 55:
                  Qe.next = 60;
                  break;
                case 57:
                  Qe.prev = 57, Qe.t1 = Qe.catch(44), pe.e(Qe.t1);
                case 60:
                  return Qe.prev = 60, pe.f(), Qe.finish(60);
                case 63:
                  Qe.next = 66;
                  break;
                case 65:
                  Yn && Qt.exports.reverse(Rr);
                case 66:
                  return Qe.abrupt("return", this.makePaginator(Rr, Vr, this._prevPageAllowed(Rr, Vr.order), this._nextPageAllowed(Rr, Vr.order)));
                case 67:
                case "end":
                  return Qe.stop();
              }
          }, fe, this, [[13, 27, 30, 33], [44, 57, 60, 63]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_prevPageAllowed",
      value: function(J, fe) {
        return J.length > 0 && Qt.exports.head(J).key !== (fe === "desc" ? this.cache.collectionEnd : this.cache.collectionBegin);
      }
    }, {
      key: "_nextPageAllowed",
      value: function(J, fe) {
        return J.length > 0 && Qt.exports.last(J).key !== (fe === "desc" ? this.cache.collectionBegin : this.cache.collectionEnd);
      }
      // Paginator depends on:
      // - items listed
      // - was there a previous token (prevPage)
      // - was there a next token (nextPage)
      // - order of items asc/desc
    }, {
      key: "makePaginator",
      value: function(J, fe, le, ke) {
        var X = this;
        fe.nextPageItemId = fe.prevPageItemId = null;
        var he = le && this._prevPageAllowed(J, fe.order), $e = ke && this._nextPageAllowed(J, fe.order);
        return new Xr(J, function(Ct) {
          return X.queryItems(Mc(Mc({}, fe), Ct));
        }, he ? Qt.exports.head(J).key : null, $e ? Qt.exports.last(J).key : null);
      }
    }, {
      key: "_querySingleItemFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke;
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return he.next = 2, this._queryItemsFromServer({
                    key: le
                  });
                case 2:
                  return ke = he.sent, ke.items.length === 0 && this.cache.delete(le, null), he.abrupt("return", ke);
                case 5:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_queryItemsFromServer",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he = this, $e, Ct, Bt, St;
          return k.default.wrap(function(Ir) {
            for (; ; )
              switch (Ir.prev = Ir.next) {
                case 0:
                  return $e = new Y(this.links.items).queryParam("HideExpired", !0).queryParam("Key", le.key).queryParam("PageToken", le.pageToken).queryParam("From", le.from).queryParam("PageSize", le.limit).queryParam("Order", le.order).build(), Ir.next = 3, this.services.network.get($e);
                case 3:
                  return Ct = Ir.sent, Bt = ((ke = (X = Ct.body) === null || X === void 0 ? void 0 : X.items) !== null && ke !== void 0 ? ke : []).map(function(Sr) {
                    return Sr.date_updated = new Date(Sr.date_updated), he._handleItemMutated(Sr.key, Sr.url, Sr.last_event_id, Sr.revision, Sr.data, Sr.date_updated, Sr.date_expires, !1, !0), he.cache.getValue(Sr.key);
                  }), St = Ct.body.meta, Ir.abrupt("return", this.makePaginator(Bt, le, !!St.previous_token, !!St.next_token));
                case 7:
                case "end":
                  return Ir.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "getItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return le = le || {}, we(le.pageSize), le.limit = le.pageSize || le.limit || 50, le.order = le.order || "asc", X.abrupt("return", this.queryItems(le));
                case 5:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "shouldIgnoreEvent",
      value: function(J, fe) {
        return this.cache.isKnown(J, fe);
      }
      /**
       * Handle update from the server
       * @private
       */
    }, {
      key: "_update",
      value: function(J, fe) {
        switch (J.date_created = new Date(J.date_created), J.type) {
          case "map_item_added":
          case "map_item_updated":
            this._handleItemMutated(
              J.item_key,
              J.item_url,
              J.id,
              J.item_revision,
              J.item_data,
              J.date_created,
              J.date_expires,
              // orchestration events include date_expires since June 2020, SP-386
              J.type === "map_item_added",
              !0
            );
            break;
          case "map_item_removed":
            this._handleItemRemoved(J.item_key, J.id, J.item_data, J.date_created, !0);
            break;
          case "map_removed":
            this.onRemoved(!1);
            break;
        }
        fe && this._advanceLastEventId(J.id, J.map_revision);
      }
    }, {
      key: "_advanceLastEventId",
      value: function(J, fe) {
        this.lastEventId < J && (this.descriptor.last_event_id = J, fe && (this.descriptor.revision = fe));
      }
    }, {
      key: "_updateRootDateUpdated",
      value: function(J) {
        (!this.descriptor.date_updated || J.getTime() > this.descriptor.date_updated.getTime()) && (this.descriptor.date_updated = J, this.services.storage.update(this.type, this.sid, this.uniqueName, {
          date_updated: J
        }));
      }
    }, {
      key: "_handleItemMutated",
      value: function(J, fe, le, ke, X, he, $e, Ct, Bt) {
        if (this.shouldIgnoreEvent(J, le)) {
          Ze.trace("SyncMapItem ", J, " update skipped, current:", this.lastEventId, ", remote:", le);
          return;
        }
        this._updateRootDateUpdated(he);
        var St = this.cache.getValue(J);
        if (!St) {
          var ir = new Ho({
            key: J,
            url: fe,
            last_event_id: le,
            revision: ke,
            data: X,
            date_updated: he,
            date_expires: $e
          });
          this.cache.store(J, ir, le), this.emitItemMutationEvent(ir, Bt, Ct);
          return;
        }
        var Ir = Ce(St.data);
        St.update(le, ke, X, he), this.cache.store(J, St, le), $e !== void 0 && St.updateDateExpires($e), this.emitItemMutationEvent(St, Bt, !1, Ir);
      }
    }, {
      key: "emitItemMutationEvent",
      value: function(J, fe, le) {
        var ke = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, X = le ? "itemAdded" : "itemUpdated", he = {
          item: J,
          isLocal: !fe
        };
        le || (he.previousItemData = ke), this.broadcastEventToListeners(X, he);
      }
      /**
       * @private
       */
    }, {
      key: "_handleItemRemoved",
      value: function(J, fe, le, ke, X) {
        this._updateRootDateUpdated(ke), this.cache.delete(J, fe), this.broadcastEventToListeners("itemRemoved", {
          key: J,
          isLocal: !X,
          previousItemData: le
        });
      }
    }, {
      key: "onRemoved",
      value: function(J) {
        this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
          isLocal: J
        });
      }
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.prev = 0, ke = {
                    ttl: le
                  }, $e.next = 4, this.services.network.post(this.uri, ke);
                case 4:
                  X = $e.sent, this.descriptor.date_expires = X.body.date_expires, $e.next = 12;
                  break;
                case 8:
                  throw $e.prev = 8, $e.t0 = $e.catch(0), $e.t0.status === 404 && this.onRemoved(!1), $e.t0;
                case 12:
                case "end":
                  return $e.stop();
              }
          }, fe, this, [[0, 8]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "setItemTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return Bt.next = 2, this.get(le);
                case 2:
                  return X = Bt.sent, he = {
                    ttl: ke
                  }, Bt.next = 6, this.services.network.post(X.uri, he);
                case 6:
                  $e = Bt.sent, X.updateDateExpires($e.body.date_expires);
                case 8:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "removeMap",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return ke.next = 2, this.services.network.delete(this.uri);
                case 2:
                  this.onRemoved(!0);
                case 3:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }], [{
      key: "type",
      get: function() {
        return "map";
      }
    }]), Q;
  }(Ft), Vi = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = Vu(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), J.syncMapImpl = te, J.syncMapImpl.attach(L.default(J)), J;
    }
    return B.default(Q, [{
      key: "uri",
      get: (
        // private props
        function() {
          return this.syncMapImpl.uri;
        }
      )
    }, {
      key: "links",
      get: function() {
        return this.syncMapImpl.links;
      }
    }, {
      key: "revision",
      get: function() {
        return this.syncMapImpl.revision;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.syncMapImpl.lastEventId;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.syncMapImpl.dateExpires;
      }
    }, {
      key: "type",
      get: function() {
        return Kl.type;
      }
      /**
       * An immutable identifier (a SID) assigned by the system on creation.
       */
    }, {
      key: "sid",
      get: function() {
        return this.syncMapImpl.sid;
      }
      /**
       * An optional immutable identifier that may be assigned by the
       * programmer to this map on creation. Unique among other Maps.
       */
    }, {
      key: "uniqueName",
      get: function() {
        return this.syncMapImpl.uniqueName;
      }
      /**
       * Date when the map was last updated.
       */
    }, {
      key: "dateUpdated",
      get: function() {
        return this.syncMapImpl.dateUpdated;
      }
    }, {
      key: "set",
      value: (
        /**
         * Add a new item to the map with the given key-value pair. Overwrites any data that might already exist with that key.
         * @param key Unique item identifier.
         * @param data Data to be set.
         * @param itemMetadataUpdates New item metadata.
         * @return Newly added item, or modified one if already exists, with the latest known data.
         * @example
         * ```typescript
         * map.set('myKey', { name: 'John Smith' }, { ttl: 86400 })
         *   .then((item) => {
         *     console.log('Map SyncMapItem set() successful, item data:', item.data);
         *   })
         *   .catch((error) => {
         *     console.error('Map SyncMapItem set() failed', error);
         *   });
         * ```
         */
        function() {
          var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
            return k.default.wrap(function($e) {
              for (; ; )
                switch ($e.prev = $e.next) {
                  case 0:
                    return this.ensureNotClosed(), $e.abrupt("return", this.syncMapImpl.set(le, ke, X));
                  case 2:
                  case "end":
                    return $e.stop();
                }
            }, fe, this);
          }));
          function J(fe, le, ke) {
            return te.apply(this, arguments);
          }
          return J;
        }()
      )
      /**
       * Retrieve an item by key.
       * @param key Identifies the desired item.
       * @return A promise that resolves when the item has been fetched.
       * This promise will be rejected if item was not found.
       * @example
       * ```typescript
       * map.get('myKey')
       *   .then((item) => {
       *     console.log('Map SyncMapItem get() successful, item data:', item.data)
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem get() failed', error);
       *   });
       * ```
       */
    }, {
      key: "get",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncMapImpl.get(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Schedules a modification to this Map SyncMapItem that will apply a mutation function.
       * If no SyncMapItem with the given key exists, it will first be created, having the default data (`{}`).
       * @param key Selects the map item to be mutated.
       * @param mutator A function that outputs a new data based on the existing data.
       * May be called multiple times, particularly if this Map SyncMapItem is modified concurrently by remote code.
       * If the mutation ultimately succeeds, the Map SyncMapItem will have made the particular transition described
       * by this function.
       * @param itemMetadataUpdates New item metadata.
       * @return Resolves with the most recent item state, the output of a successful
       * mutation or a state that prompted graceful cancellation (mutator returned `null`).
       * @example
       * ```typescript
       * const mutatorFunction = (currentData) => {
       *     currentData.viewCount = (currentData.viewCount || 0) + 1;
       *     return currentData;
       * };
       * map.mutate('myKey', mutatorFunction, { ttl: 86400 })
       *   .then((item) => {
       *     console.log('Map SyncMapItem mutate() successful, new data:', item.data)
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem mutate() failed', error);
       *   });
       * ```
       */
    }, {
      key: "mutate",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return this.ensureNotClosed(), $e.abrupt("return", this.syncMapImpl.mutate(le, ke, X));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Modify a map item by appending new fields (or by overwriting existing ones) with the values from
       * the provided Object. Creates a new item if no item by this key exists, copying all given fields and values
       * into it.
       * This is equivalent to
       * ```typescript
       * map.mutate('myKey', (currentData) => Object.assign(currentData, obj));
       * ```
       * @param key Selects the map item to update.
       * @param obj Specifies the particular (top-level) attributes that will receive new values.
       * @param itemMetadataUpdates New item metadata.
       * @return A promise resolving to the modified item in its new state.
       * @example
       * ```typescript
       * // Say, the Map SyncMapItem (key: `'myKey'`) data is `{ name: 'John Smith' }`
       * map.update('myKey', { age: 34 }, { ttl: 86400 })
       *   .then((item) => {
       *     // Now the Map SyncMapItem data is `{ name: 'John Smith', age: 34 }`
       *     console.log('Map SyncMapItem update() successful, new data:', item.data);
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem update() failed', error);
       *   });
       * ```
       */
    }, {
      key: "update",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke, X) {
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return this.ensureNotClosed(), $e.abrupt("return", this.syncMapImpl.update(le, ke, X));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe, le, ke) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Delete an item, given its key.
       * @param key Selects the item to delete.
       * @return A promise to remove an item.
       * The promise will be rejected if 'key' is undefined or an item was not found.
       * @example
       * ```typescript
       * map.remove('myKey')
       *   .then(() => {
       *     console.log('Map SyncMapItem remove() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Map SyncMapItem remove() failed', error);
       *   });
       * ```
       */
    }, {
      key: "remove",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncMapImpl.remove(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Get a complete list of items from the map.
       * Information about the query limits can be found [here](https://www.twilio.com/docs/sync/limits).
       * @param queryOptions Query options.
       * @example
       * ```typescript
       * const pageHandler = (paginator) => {
       *   paginator.items.forEach((item) => {
       *     console.log(`SyncMapItem ${item.key}: `, item.data);
       *   });
       *   return paginator.hasNextPage
       *     ? paginator.nextPage().then(pageHandler)
       *     : null;
       * };
       * map.getItems({ from: 'myKey', order: 'asc' })
       *   .then(pageHandler)
       *   .catch((error) => {
       *     console.error('Map getItems() failed', error);
       *   });
       * ```
       */
    }, {
      key: "getItems",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncMapImpl.getItems(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Update the time-to-live of the map.
       * @param ttl Specifies the TTL in seconds after which the map is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * map.setTtl(3600)
       *   .then(() => {
       *     console.log('Map setTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Map setTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncMapImpl.setTtl(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Update the time-to-live of a map item.
       * @param key SyncMapItem key.
       * @param ttl Specifies the TTL in seconds after which the map item is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * map.setItemTtl('myKey', 86400)
       *   .then(() => {
       *     console.log('Map setItemTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Map setItemTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setItemTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          return k.default.wrap(function(he) {
            for (; ; )
              switch (he.prev = he.next) {
                case 0:
                  return this.ensureNotClosed(), he.abrupt("return", this.syncMapImpl.setItemTtl(le, ke));
                case 2:
                case "end":
                  return he.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Delete this map. It will be impossible to restore it.
       * @return A promise that resolves when the map has been deleted.
       * @example
       * ```typescript
       * map.removeMap()
       *   .then(() => {
       *     console.log('Map removeMap() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Map removeMap() failed', error);
       *   });
       * ```
       */
    }, {
      key: "removeMap",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return this.ensureNotClosed(), ke.next = 3, this.syncMapImpl.removeMap();
                case 3:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Conclude work with the map instance and remove all event listeners attached to it.
       * Any subsequent operation on this object will be rejected with error.
       * Other local copies of this map will continue operating and receiving events normally.
       * @example
       * ```typescript
       * map.close();
       * ````
       */
    }, {
      key: "close",
      value: function() {
        z.default(m.default(Q.prototype), "close", this).call(this), this.syncMapImpl.detach(this.listenerUuid);
      }
    }], [{
      key: "type",
      get: function() {
        return Kl.type;
      }
    }]), Q;
  }(yt);
  v.default(Vi, "itemAdded", "itemAdded"), v.default(Vi, "itemUpdated", "itemUpdated"), v.default(Vi, "itemRemoved", "itemRemoved"), v.default(Vi, "removed", "removed"), Z([u.validateTypesAsync("string", u.pureObject, ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [String, Object, Object]), V("design:returntype", Promise)], Vi.prototype, "set", null), Z([u.validateTypesAsync("string"), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", Promise)], Vi.prototype, "get", null), Z([u.validateTypesAsync("string", "function", ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [String, Function, Object]), V("design:returntype", Promise)], Vi.prototype, "mutate", null), Z([u.validateTypesAsync("string", u.pureObject, ["undefined", u.objectSchema("item metadata", {
    ttl: [u.nonNegativeInteger, "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [String, Object, Object]), V("design:returntype", Promise)], Vi.prototype, "update", null), Z([u.validateTypesAsync("string"), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", Promise)], Vi.prototype, "remove", null), Z([u.validateTypesAsync(["undefined", u.objectSchema("query options", {
    from: ["string", "undefined"],
    pageSize: [u.custom(function(_e) {
      return [Fe(_e), "a positive integer"];
    }), "undefined"],
    order: [u.custom(function(_e) {
      return [_e === "asc" || _e === "desc", "either 'asc' or 'desc'"];
    }), "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], Vi.prototype, "getItems", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], Vi.prototype, "setTtl", null), Z([u.validateTypesAsync("string", u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [String, Number]), V("design:returntype", Promise)], Vi.prototype, "setItemTtl", null);
  function iu(_e) {
    var Pe = cc();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function cc() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Pc = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = iu(Q);
    function Q(te, J, fe) {
      var le;
      return M.default(this, Q), le = Pe.call(this, te, fe), le.descriptor = J, le;
    }
    return B.default(Q, [{
      key: "uri",
      get: function() {
        return this.descriptor.url;
      }
    }, {
      key: "links",
      get: function() {
        return this.descriptor.links;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.descriptor.date_expires;
      }
    }, {
      key: "type",
      get: function() {
        return "stream";
      }
    }, {
      key: "lastEventId",
      get: function() {
        return null;
      }
      // below properties are specific to Insights only
    }, {
      key: "indexName",
      get: function() {
      }
    }, {
      key: "queryString",
      get: function() {
      }
      // public props, documented along with class description
    }, {
      key: "sid",
      get: function() {
        return this.descriptor.sid;
      }
    }, {
      key: "uniqueName",
      get: function() {
        return this.descriptor.unique_name || null;
      }
    }, {
      key: "publishMessage",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X, he, $e;
          return k.default.wrap(function(Bt) {
            for (; ; )
              switch (Bt.prev = Bt.next) {
                case 0:
                  return ke = {
                    data: le
                  }, Bt.next = 3, this.services.network.post(this.links.messages, ke);
                case 3:
                  return X = Bt.sent, he = X.body, $e = this._handleMessagePublished(he.sid, le, !1), Bt.abrupt("return", $e);
                case 7:
                case "end":
                  return Bt.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.prev = 0, ke = {
                    ttl: le
                  }, $e.next = 4, this.services.network.post(this.uri, ke);
                case 4:
                  X = $e.sent, this.descriptor.date_expires = X.body.date_expires, $e.next = 12;
                  break;
                case 8:
                  throw $e.prev = 8, $e.t0 = $e.catch(0), $e.t0.status === 404 && this.onRemoved(!1), $e.t0;
                case 12:
                case "end":
                  return $e.stop();
              }
          }, fe, this, [[0, 8]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "removeStream",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return ke.next = 2, this.services.network.delete(this.uri);
                case 2:
                  this.onRemoved(!0);
                case 3:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Handle event from the server
       * @private
       */
    }, {
      key: "_update",
      value: function(J) {
        switch (J.type) {
          case "stream_message_published": {
            this._handleMessagePublished(J.message_sid, J.message_data, !0);
            break;
          }
          case "stream_removed": {
            this.onRemoved(!1);
            break;
          }
        }
      }
    }, {
      key: "_handleMessagePublished",
      value: function(J, fe, le) {
        var ke = {
          sid: J,
          data: fe
        };
        return this.broadcastEventToListeners("messagePublished", {
          message: ke,
          isLocal: !le
        }), ke;
      }
    }, {
      key: "onRemoved",
      value: function(J) {
        this._unsubscribe(), this.removalHandler(this.type, this.sid, this.uniqueName), this.broadcastEventToListeners("removed", {
          isLocal: J
        });
      }
    }], [{
      key: "type",
      get: function() {
        return "stream";
      }
    }]), Q;
  }(Ft);
  Z([u.validateTypesAsync(u.pureObject), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], Pc.prototype, "publishMessage", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], Pc.prototype, "setTtl", null);
  var Jo = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = iu(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), J.syncStreamImpl = te, J.syncStreamImpl.attach(L.default(J)), J;
    }
    return B.default(Q, [{
      key: "uri",
      get: (
        // private props
        function() {
          return this.syncStreamImpl.uri;
        }
      )
    }, {
      key: "links",
      get: function() {
        return this.syncStreamImpl.links;
      }
    }, {
      key: "dateExpires",
      get: function() {
        return this.syncStreamImpl.dateExpires;
      }
    }, {
      key: "type",
      get: function() {
        return Pc.type;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return null;
      }
      /**
       * The immutable system-assigned identifier of this stream. Never null.
       */
    }, {
      key: "sid",
      get: function() {
        return this.syncStreamImpl.sid;
      }
      /**
       * A unique identifier optionally assigned to the stream on creation.
       */
    }, {
      key: "uniqueName",
      get: function() {
        return this.syncStreamImpl.uniqueName;
      }
    }, {
      key: "publishMessage",
      value: (
        /**
         * Publish a message to the stream. The system will attempt delivery to all online subscribers.
         * @param data The body of the dispatched message. Maximum size in serialized JSON: 4KB.
         * A rate limit applies to this operation, refer to the [Sync API documentation](https://www.twilio.com/docs/api/sync) for details.
         * @return A promise which resolves after the message is successfully published
         * to the Sync service. Resolves irrespective of ultimate delivery to any subscribers.
         * @example
         * ```typescript
         * stream.publishMessage({ x: 42, y: 123 })
         *   .then((message) => {
         *     console.log('Stream publishMessage() successful, message SID:', message.sid);
         *   })
         *   .catch((error) => {
         *     console.error('Stream publishMessage() failed', error);
         *   });
         * ```
         */
        function() {
          var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
            return k.default.wrap(function(X) {
              for (; ; )
                switch (X.prev = X.next) {
                  case 0:
                    return this.ensureNotClosed(), X.abrupt("return", this.syncStreamImpl.publishMessage(le));
                  case 2:
                  case "end":
                    return X.stop();
                }
            }, fe, this);
          }));
          function J(fe) {
            return te.apply(this, arguments);
          }
          return J;
        }()
      )
      /**
       * Update the time-to-live of the stream.
       * @param ttl Specifies the TTL in seconds after which the stream is subject to automatic deletion. The value 0 means infinity.
       * @return A promise that resolves after the TTL update was successful.
       * @example
       * ```typescript
       * stream.setTtl(3600)
       *   .then(() => {
       *     console.log('Stream setTtl() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Stream setTtl() failed', error);
       *   });
       * ```
       */
    }, {
      key: "setTtl",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return this.ensureNotClosed(), X.abrupt("return", this.syncStreamImpl.setTtl(le));
                case 2:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Permanently delete this Stream.
       * @return A promise which resolves after the Stream is successfully deleted.
       * @example
       * ```typescript
       * stream.removeStream()
       *   .then(() => {
       *     console.log('Stream removeStream() successful');
       *   })
       *   .catch((error) => {
       *     console.error('Stream removeStream() failed', error);
       *   });
       * ```
       */
    }, {
      key: "removeStream",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return this.ensureNotClosed(), ke.abrupt("return", this.syncStreamImpl.removeStream());
                case 2:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Conclude work with the stream instance and remove all event listeners attached to it.
       * Any subsequent operation on this object will be rejected with error.
       * Other local copies of this stream will continue operating and receiving events normally.
       * @example
       * ```typescript
       * stream.close();
       * ```
       */
    }, {
      key: "close",
      value: function() {
        z.default(m.default(Q.prototype), "close", this).call(this), this.syncStreamImpl.detach(this.listenerUuid);
      }
    }], [{
      key: "type",
      get: function() {
        return Pc.type;
      }
    }]), Q;
  }(yt);
  v.default(Jo, "messagePublished", "messagePublished"), v.default(Jo, "removed", "removed"), Z([u.validateTypesAsync(u.pureObject), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], Jo.prototype, "publishMessage", null), Z([u.validateTypesAsync(u.nonNegativeInteger), V("design:type", Function), V("design:paramtypes", [Number]), V("design:returntype", Promise)], Jo.prototype, "setTtl", null);
  var Ka = /* @__PURE__ */ B.default(function _e(Pe) {
    M.default(this, _e), this.sdk = "js", this.sdkVer = Pe, this.os = U.os.family, this.osVer = U.os.version, this.pl = U.name, this.plVer = U.version;
  }), y2 = /* @__PURE__ */ function() {
    function _e() {
      M.default(this, _e), this.names = /* @__PURE__ */ new Map(), this.entities = /* @__PURE__ */ new Map();
    }
    return B.default(_e, [{
      key: "store",
      value: function(Q) {
        var te = this.entities.get(Q.sid);
        return te || (this.entities.set(Q.sid, Q), Q.uniqueName && this.names.set(Q.type + "::" + Q.uniqueName, Q.sid), Q);
      }
    }, {
      key: "getResolved",
      value: function(Q, te) {
        var J = this.names.get(te + "::" + Q);
        return J ? this.entities.get(J) : null;
      }
    }, {
      key: "get",
      value: function(Q, te) {
        return this.entities.get(Q) || this.getResolved(Q, te) || null;
      }
    }, {
      key: "remove",
      value: function(Q) {
        var te = this.entities.get(Q);
        te && (this.entities.delete(Q), te.uniqueName && this.names.delete(te.type + "::" + te.uniqueName));
      }
    }]), _e;
  }();
  function qu(_e) {
    var Pe = dp();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function dp() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  var Nd = /* @__PURE__ */ function() {
    function _e(Pe, Q, te) {
      M.default(this, _e), this.key = Pe, this.value = Q, this.lastEventId = te;
    }
    return B.default(_e, [{
      key: "cacheKey",
      get: (
        /**
         * CachedValue interface.
         */
        function() {
          return this.key;
        }
      )
    }]), _e;
  }(), Rc = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = qu(Q);
    function Q(te, J, fe, le) {
      var ke;
      return M.default(this, Q), ke = Pe.call(this, J, fe), ke.descriptor = te, ke.cache = new Ht(), le && le.forEach(function(X) {
        var he = new Nd(X.key, X.data, X.revision);
        ke.cache.store(X.key, he, X.revision);
      }), ke;
    }
    return B.default(Q, [{
      key: "sid",
      get: function() {
        return this.descriptor.sid;
      }
      // private extension of SyncEntity
    }, {
      key: "uniqueName",
      get: function() {
        return null;
      }
    }, {
      key: "type",
      get: function() {
        return Q.type;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.descriptor.last_event_id;
      }
    }, {
      key: "indexName",
      get: function() {
        return this.descriptor.indexName;
      }
    }, {
      key: "queryString",
      get: function() {
        return this.descriptor.queryExpression;
      }
      // custom private props
    }, {
      key: "queryUri",
      get: function() {
        return this.descriptor.queryUri;
      }
    }, {
      key: "liveQueryDescriptor",
      get: function() {
        return this.descriptor;
      }
      // dummy stub from iface
    }, {
      key: "onRemoved",
      value: function() {
      }
    }, {
      key: "getItems",
      value: function() {
        var J = {};
        return this.cache.forEach(function(fe, le) {
          J[fe] = le.value;
        }), J;
      }
      /**
       * @internal
       */
    }, {
      key: "_update",
      value: function(J, fe) {
        switch (J.type) {
          case "live_query_item_updated":
            this.handleItemMutated(J.item_key, J.item_data, J.item_revision);
            break;
          case "live_query_item_removed":
            this.handleItemRemoved(J.item_key, J.item_revision);
            break;
          case "live_query_updated":
            this.handleBatchUpdate(J.items);
            break;
        }
        fe && this._advanceLastEventId(J.last_event_id);
      }
    }, {
      key: "handleItemMutated",
      value: function(J, fe, le) {
        if (this.shouldIgnoreEvent(J, le)) {
          Ze.trace("Item ".concat(J, " update skipped, revision: ").concat(le));
          return;
        }
        var ke = new Nd(J, fe, le);
        this.cache.store(J, ke, le), this.broadcastEventToListeners("itemUpdated", ke);
      }
    }, {
      key: "handleItemRemoved",
      value: function(J, fe) {
        if (this.shouldIgnoreEvent(J, fe)) {
          Ze.trace("Item ".concat(J, " delete skipped, revision: ").concat(fe));
          return;
        }
        this.cache.delete(J, fe), this.broadcastEventToListeners("itemRemoved", {
          key: J
        });
      }
    }, {
      key: "handleBatchUpdate",
      value: function(J) {
        var fe = this, le = {};
        J != null && J.forEach(function(X) {
          le[X.key] = {
            data: X.data,
            revision: X.revision
          };
        }), this.cache.forEach(function(X, he) {
          var $e = le[X];
          $e != null ? fe.handleItemMutated(X, $e.data, $e.revision) : fe.handleItemRemoved(X, null), delete le[X];
        });
        for (var ke in le)
          this.handleItemMutated(ke, le[ke].data, le[ke].revision);
      }
    }, {
      key: "shouldIgnoreEvent",
      value: function(J, fe) {
        return J != null && fe != null && this.cache.isKnown(J, fe);
      }
      /**
       * @internal
       */
    }, {
      key: "_advanceLastEventId",
      value: function(J, fe) {
        this.lastEventId < J && (this.descriptor.last_event_id = J);
      }
    }], [{
      key: "type",
      get: function() {
        return "live_query";
      }
    }]), Q;
  }(Ft);
  function Oc(_e) {
    return Lo.apply(this, arguments);
  }
  function Lo() {
    return Lo = I.default(/* @__PURE__ */ k.default.mark(function _e(Pe) {
      var Q, te, J, fe, le, ke;
      return k.default.wrap(function(he) {
        for (; ; )
          switch (he.prev = he.next) {
            case 0:
              if (Q = Pe.network, te = Pe.queryString, J = Pe.uri, fe = Pe.type, te != null) {
                he.next = 3;
                break;
              }
              throw new ee("Invalid query", 400, 54507);
            case 3:
              return le = {
                query_string: te
                // raw query string (like `key == "value" AND key2 != "value2"`)
              }, fe === Rl.type && (le.type = fe), he.next = 7, Q.post(J, le, void 0, !0);
            case 7:
              return ke = he.sent, he.abrupt("return", ke.body);
            case 9:
            case "end":
              return he.stop();
          }
      }, _e);
    })), Lo.apply(this, arguments);
  }
  var Rl = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = qu(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), J.liveQueryImpl = te, J.liveQueryImpl.attach(L.default(J)), J;
    }
    return B.default(Q, [{
      key: "type",
      get: function() {
        return Rc.type;
      }
    }, {
      key: "lastEventId",
      get: function() {
        return this.liveQueryImpl.lastEventId;
      }
      /**
       * The immutable identifier of this query object, assigned by the system.
       */
    }, {
      key: "sid",
      get: function() {
        return this.liveQueryImpl.sid;
      }
    }, {
      key: "close",
      value: (
        /**
         * Closes this query instance and unsubscribes from further service events.
         * This will eventually stop the physical inflow of updates over the network,
         * when all other instances of this query are closed as well.
         */
        function() {
          z.default(m.default(Q.prototype), "close", this).call(this), this.liveQueryImpl.detach(this.listenerUuid);
        }
      )
      /**
       * @return A snapshot of items matching the current query expression.
       */
    }, {
      key: "getItems",
      value: function() {
        return this.ensureNotClosed(), this.liveQueryImpl.getItems();
      }
    }], [{
      key: "type",
      get: (
        // private props
        function() {
          return Rc.type;
        }
      )
    }]), Q;
  }(yt);
  v.default(Rl, "itemUpdated", "itemUpdated"), v.default(Rl, "itemRemoved", "itemRemoved");
  var hs = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = qu(Q);
    function Q(te) {
      var J;
      return M.default(this, Q), J = Pe.call(this), v.default(L.default(J), "queryExpression", null), v.default(L.default(J), "items", {}), Object.assign(L.default(J), te), J.updateIndexName(te.indexName), J;
    }
    return B.default(Q, [{
      key: "type",
      get: function() {
        return Q.type;
      }
    }, {
      key: "search",
      value: (
        /**
         * Spawns a new search request. The result will be provided asynchronously via the {@link InstantQuery.searchResult}
         * event.
         * @param queryExpression A query expression to be executed against the given data index. For more information
         * on the syntax read {@link SyncClient.liveQuery}.
         * @return A promise that resolves when query result has been received.
         */
        function() {
          var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
            var ke = this, X;
            return k.default.wrap(function($e) {
              for (; ; )
                switch ($e.prev = $e.next) {
                  case 0:
                    return this.items = {}, $e.prev = 1, $e.next = 4, Oc({
                      network: this.network,
                      uri: this.queryUri,
                      queryString: le
                    });
                  case 4:
                    X = $e.sent, this.queryExpression = le, X.items && X.items.forEach(function(Ct) {
                      ke.items[Ct.key] = Ct.data;
                    }), this.emit("searchResult", this.getItems()), $e.next = 15;
                    break;
                  case 10:
                    throw $e.prev = 10, $e.t0 = $e.catch(1), Ze.error("Error '".concat($e.t0.message, "' while executing query '").concat(le, "'")), this.queryExpression = null, $e.t0;
                  case 15:
                  case "end":
                    return $e.stop();
                }
            }, fe, this, [[1, 10]]);
          }));
          function J(fe) {
            return te.apply(this, arguments);
          }
          return J;
        }()
      )
      /**
       * Instantiates a LiveQuery object based on the last known query expression that was passed to the
       * {@link InstantQuery.search} method. This LiveQuery will start receiving updates with new results,
       * while current object can be still used to execute repetitive searches.
       * @return A promise which resolves when the LiveQuery object is ready.
       */
    }, {
      key: "subscribe",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  if (this.queryExpression != null) {
                    ke.next = 2;
                    break;
                  }
                  return ke.abrupt("return", Promise.reject(new ee("Invalid query", 400, 54507)));
                case 2:
                  return ke.abrupt("return", this.liveQueryCreator(this.indexName, this.queryExpression));
                case 3:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * @return A snapshot of items matching current query expression.
       */
    }, {
      key: "getItems",
      value: function() {
        return this.items;
      }
      /**
       * Set new index name
       * @param indexName New index name to set
       */
    }, {
      key: "updateIndexName",
      value: function(J) {
        this.indexName = J, this.queryUri = this.generateQueryUri(this.indexName);
      }
    }, {
      key: "generateQueryUri",
      value: function(J) {
        return new Y(this.insightsUri).pathSegment(J).pathSegment("Items").build();
      }
    }], [{
      key: "type",
      get: (
        // private props
        function() {
          return "instant_query";
        }
      )
    }]), Q;
  }(_.ReplayEventEmitter);
  v.default(hs, "searchResult", "searchResult"), Z([u.validateTypesAsync("string"), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", Promise)], hs.prototype, "search", null), Z([u.validateTypes(u.nonEmptyString), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", void 0)], hs.prototype, "updateIndexName", null);
  var Bc = "3.3.7";
  function Nc(_e) {
    var Pe = b2();
    return function() {
      var te = m.default(_e), J;
      if (Pe) {
        var fe = m.default(this).constructor;
        J = Reflect.construct(te, arguments, fe);
      } else
        J = te.apply(this, arguments);
      return d.default(this, J);
    };
  }
  function b2() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function st(_e, Pe) {
    var Q = Object.keys(_e);
    if (Object.getOwnPropertySymbols) {
      var te = Object.getOwnPropertySymbols(_e);
      Pe && (te = te.filter(function(J) {
        return Object.getOwnPropertyDescriptor(_e, J).enumerable;
      })), Q.push.apply(Q, te);
    }
    return Q;
  }
  function dt(_e) {
    for (var Pe = 1; Pe < arguments.length; Pe++) {
      var Q = arguments[Pe] != null ? arguments[Pe] : {};
      Pe % 2 ? st(Object(Q), !0).forEach(function(te) {
        v.default(_e, te, Q[te]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(_e, Object.getOwnPropertyDescriptors(Q)) : st(Object(Q)).forEach(function(te) {
        Object.defineProperty(_e, te, Object.getOwnPropertyDescriptor(Q, te));
      });
    }
    return _e;
  }
  var De = "data_sync", Be = Bc;
  function Me(_e) {
    if (_e) {
      if (typeof _e == "string")
        return {
          id: _e,
          mode: "open_or_create"
        };
      var Pe = _e.mode || (_e.id ? "open_or_create" : "create_new");
      return dt(dt({}, _e), {}, {
        mode: Pe
      });
    } else return {
      mode: "create_new"
    };
  }
  var ut = "com.twilio.rtd.cds.document", Ve = "com.twilio.rtd.cds.list", Kt = "com.twilio.rtd.cds.map", qt = "twilio.sync.event", vr = /* @__PURE__ */ function(_e) {
    N.default(Q, _e);
    var Pe = Nc(Q);
    function Q(te) {
      var J, fe, le = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (M.default(this, Q), fe = Pe.call(this), !te)
        throw new Error("Sync library needs a valid Twilio token to be passed");
      le.hasOwnProperty("logLevel") ? Ze.setLevel(le.logLevel) : Ze.setLevel("silent");
      var ke = le.productId = le.productId || De;
      le.clientMetadata = le.clientMetadata || {}, le.clientMetadata.hasOwnProperty("type") || (le.clientMetadata.type = "sync"), le.clientMetadata.hasOwnProperty("sdk") || (le.clientMetadata.sdk = "JS", le.clientMetadata.sdkv = Be);
      var X = !le.twilsockClient;
      if (!le.initRegistrations) {
        var he = new f.InitRegistration(ke);
        Q.populateInitRegistrations(he), le.initRegistrations = [he];
      }
      var $e = le.twilsockClient = (J = le.twilsockClient) !== null && J !== void 0 ? J : new f.Twilsock(te, ke, le);
      $e.on("tokenAboutToExpire", function() {
        return fe.emit("tokenAboutToExpire");
      }), $e.on("tokenExpired", function() {
        return fe.emit("tokenExpired");
      }), $e.on("connectionError", function(ir) {
        return fe.emit("connectionError", ir);
      }), $e.on("stateChanged", function(ir) {
        fe.emit("connectionStateChanged", ir), fe.services.subscriptions.onConnectionStateChanged(ir === "connected");
      }), $e.on("message", function(ir, Ir) {
        return fe._routeMessage(ir, Ir);
      });
      var Ct = new Ot(le), Bt = new ot(new Ka(Be), Ct, $e), St = new Ye(Ct);
      return fe.services = {
        config: Ct,
        twilsock: $e,
        network: Bt,
        storage: St,
        router: L.default(fe),
        subscriptions: null
      }, fe.services.subscriptions = new ne(fe.services), fe.entities = new y2(), X && $e.connect(), fe;
    }
    return B.default(Q, [{
      key: "_routeMessage",
      value: (
        /**
         * Entry point for all the incoming messages (Router).
         *
         * @param type Type of the incoming message
         * @param message Message to route
         * @internal
         */
        function(J, fe) {
          switch (Ze.trace("Notification type:", J, "content:", fe), J) {
            case ut:
            case Ve:
            case Kt:
              this.services.subscriptions.acceptMessage(fe, !1);
              break;
            case qt:
              this.services.subscriptions.acceptMessage(fe, !0);
              break;
          }
        }
      )
      /**
       * Subscribe for events (Router)
       *
       * @internal
       */
    }, {
      key: "_subscribe",
      value: function(J, fe) {
        this.services.subscriptions.add(J, fe);
      }
      /**
       * Unsubscribe from events (Router)
       *
       * @internal
       */
    }, {
      key: "_unsubscribe",
      value: function(J) {
        this.services.subscriptions.remove(J);
      }
      /**
       * Current version of the Sync client.
       */
    }, {
      key: "connectionState",
      get: (
        /**
         * Current service connection state.
         */
        function() {
          return this.services.twilsock.state;
        }
      )
      /**
       * Returns a promise which resolves when library is correctly initialized
       * Or throws if initialization is impossible
       *
       * @internal
       */
    }, {
      key: "ensureReady",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          var le;
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  if (this.services.config.sessionStorageEnabled) {
                    X.next = 2;
                    break;
                  }
                  return X.abrupt("return");
                case 2:
                  return X.prev = 2, X.next = 5, this.services.twilsock.storageId();
                case 5:
                  le = X.sent, this.services.storage.updateStorageId(le.id), X.next = 12;
                  break;
                case 9:
                  X.prev = 9, X.t0 = X.catch(2), Ze.warn("Failed to initialize storage", X.t0);
                case 12:
                case "end":
                  return X.stop();
              }
          }, fe, this, [[2, 9]]);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "storeRootInSessionCache",
      value: function(J, fe, le) {
        if (!(!this.services.config.sessionStorageEnabled || !fe)) {
          var ke = Ce(le);
          (J === vi.type || J === Vi.type) && (ke.last_event_id = null, delete ke.items), this.services.storage.store(J, fe, ke);
        }
      }
    }, {
      key: "readRootFromSessionCache",
      value: function(J, fe) {
        return !this.services.config.sessionStorageEnabled || !fe ? null : this.services.storage.read(J, fe);
      }
    }, {
      key: "_get",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he, $e, Ct = arguments;
          return k.default.wrap(function(St) {
            for (; ; )
              switch (St.prev = St.next) {
                case 0:
                  if (X = Ct.length > 2 && Ct[2] !== void 0 ? Ct[2] : !1, ke) {
                    St.next = 3;
                    break;
                  }
                  throw new ee("Cannot get entity without id", 404);
                case 3:
                  return he = new Y(le).pathSegment(ke).queryParam("Include", X ? "items" : void 0).build(), St.next = 6, this.services.network.get(he);
                case 6:
                  return $e = St.sent, St.abrupt("return", $e.body);
                case 8:
                case "end":
                  return St.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_createDocument",
      value: function(J, fe, le) {
        var ke = {
          unique_name: J,
          data: fe || {}
        };
        return le !== void 0 && (ke.ttl = le), this.services.network.post(this.services.config.documentsUri, ke).then(function(X) {
          return X.body.data = ke.data, X.body;
        });
      }
    }, {
      key: "_getDocument",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.readRootFromSessionCache(gr.type, le) || this._get(this.services.config.documentsUri, le));
                case 1:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_createList",
      value: function(J, fe, le, ke) {
        var X = {
          unique_name: J,
          purpose: fe,
          context: le
        };
        return ke !== void 0 && (X.ttl = ke), this.services.network.post(this.services.config.listsUri, X).then(function(he) {
          return he.body;
        });
      }
    }, {
      key: "_getList",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.readRootFromSessionCache(vi.type, le) || this._get(this.services.config.listsUri, le));
                case 1:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_createMap",
      value: function(J, fe) {
        var le = {
          unique_name: J
        };
        return fe !== void 0 && (le.ttl = fe), this.services.network.post(this.services.config.mapsUri, le).then(function(ke) {
          return ke.body;
        });
      }
    }, {
      key: "_getMap",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke, X = arguments;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return ke = X.length > 1 && X[1] !== void 0 ? X[1] : !1, $e.abrupt("return", this.readRootFromSessionCache(Vi.type, le) || this._get(this.services.config.mapsUri, le, ke));
                case 2:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_getStream",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.readRootFromSessionCache(Jo.type, le) || this._get(this.services.config.streamsUri, le, !1));
                case 1:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_createStream",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X, he;
          return k.default.wrap(function(Ct) {
            for (; ; )
              switch (Ct.prev = Ct.next) {
                case 0:
                  return X = {
                    unique_name: le
                  }, ke !== void 0 && (X.ttl = ke), Ct.next = 4, this.services.network.post(this.services.config.streamsUri, X);
                case 4:
                  return he = Ct.sent, Ct.abrupt("return", he.body);
                case 6:
                case "end":
                  return Ct.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }, {
      key: "_getLiveQuery",
      value: function(J) {
        return this.readRootFromSessionCache(Rl.type, J);
      }
    }, {
      key: "getCached",
      value: function(J, fe) {
        return J && this.entities.get(J, fe) || null;
      }
    }, {
      key: "removeFromCacheAndSession",
      value: function(J, fe, le) {
        this.entities.remove(fe), this.services.config.sessionStorageEnabled && this.services.storage.remove(J, fe, le);
      }
      /**
       * Read or create a Sync document.
       * @param arg Could be any of the following:
       * * Unique name or SID identifying the Sync document - opens the document with the given identifier or creates one if it does not exist.
       * * none - creates a new document with a randomly assigned SID and no unique name.
       * * {@link OpenDocumentOptions} object for more granular control.
       * @return A promise which resolves after the document is successfully read (or created).
       * This promise may reject if the document could not be created or if this endpoint lacks the necessary permissions to access it.
       * @example
       * ```typescript
       * syncClient.document('MyDocument')
       *   .then((document) => {
       *     console.log('Successfully opened a document. SID:', document.sid);
       *     document.on('updated', (event) => {
       *       console.log('Received an "updated" event: ', event);
       *     });
       *   })
       *   .catch((error) => {
       *     console.error('Unexpected error', error);
       *   });
       * ```
       */
    }, {
      key: "document",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke = this, X, he, $e, Ct;
          return k.default.wrap(function(St) {
            for (; ; )
              switch (St.prev = St.next) {
                case 0:
                  return St.next = 2, this.ensureReady();
                case 2:
                  if (X = Me(le), X.mode !== "create_new") {
                    St.next = 9;
                    break;
                  }
                  return St.next = 6, this._createDocument(X.id, X.data, X.ttl);
                case 6:
                  he = St.sent, St.next = 39;
                  break;
                case 9:
                  if ($e = this.getCached(X.id, gr.type), !$e) {
                    St.next = 14;
                    break;
                  }
                  return St.abrupt("return", new gr($e));
                case 14:
                  return St.prev = 14, St.next = 17, this._getDocument(X.id);
                case 17:
                  he = St.sent, St.next = 39;
                  break;
                case 20:
                  if (St.prev = 20, St.t0 = St.catch(14), !(St.t0.status !== 404 || X.mode === "open_existing")) {
                    St.next = 26;
                    break;
                  }
                  throw St.t0;
                case 26:
                  return St.prev = 26, St.next = 29, this._createDocument(X.id, X.data, X.ttl);
                case 29:
                  he = St.sent, St.next = 39;
                  break;
                case 32:
                  if (St.prev = 32, St.t1 = St.catch(26), St.t1.status !== 409) {
                    St.next = 38;
                    break;
                  }
                  return St.abrupt("return", this.document(le));
                case 38:
                  throw St.t1;
                case 39:
                  return this.storeRootInSessionCache(gr.type, X.id, he), Ct = new Er(this.services, he, function(ir, Ir, Sr) {
                    return ke.removeFromCacheAndSession(ir, Ir, Sr);
                  }), Ct = this.entities.store(Ct), St.abrupt("return", new gr(Ct));
                case 43:
                case "end":
                  return St.stop();
              }
          }, fe, this, [[14, 20], [26, 32]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Read or create a Sync map.
       * @param arg Could be any of the following:
       * * Unique name or SID identifying the Sync map - opens the map with the given identifier or creates one if it does not exist.
       * * none - creates a new map with a randomly assigned SID and no unique name.
       * * {@link OpenMapOptions} object for more granular control.
       * @return A promise which resolves after the map is successfully read (or created).
       * This promise may reject if the map could not be created or if this endpoint lacks the necessary permissions to access it.
       * @example
       * ```typescript
       * syncClient.map('MyMap')
       *   .then((map) => {
       *     console.log('Successfully opened a map. SID:', map.sid);
       *     map.on('itemUpdated', (event) => {
       *       console.log('Received an "itemUpdated" event:', event);
       *     });
       *   })
       *   .catch((error) => {
       *     console.error('Unexpected error', error);
       *   });
       * ```
       */
    }, {
      key: "map",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke = this, X, he, $e, Ct;
          return k.default.wrap(function(St) {
            for (; ; )
              switch (St.prev = St.next) {
                case 0:
                  return St.next = 2, this.ensureReady();
                case 2:
                  if (X = Me(le), X.mode !== "create_new") {
                    St.next = 9;
                    break;
                  }
                  return St.next = 6, this._createMap(X.id, X.ttl);
                case 6:
                  he = St.sent, St.next = 39;
                  break;
                case 9:
                  if ($e = this.getCached(X.id, Vi.type), !$e) {
                    St.next = 14;
                    break;
                  }
                  return St.abrupt("return", new Vi($e));
                case 14:
                  return St.prev = 14, St.next = 17, this._getMap(X.id, X.includeItems);
                case 17:
                  he = St.sent, St.next = 39;
                  break;
                case 20:
                  if (St.prev = 20, St.t0 = St.catch(14), !(St.t0.status !== 404 || X.mode === "open_existing")) {
                    St.next = 26;
                    break;
                  }
                  throw St.t0;
                case 26:
                  return St.prev = 26, St.next = 29, this._createMap(X.id, X.ttl);
                case 29:
                  he = St.sent, St.next = 39;
                  break;
                case 32:
                  if (St.prev = 32, St.t1 = St.catch(26), St.t1.status !== 409) {
                    St.next = 38;
                    break;
                  }
                  return St.abrupt("return", this.map(le));
                case 38:
                  throw St.t1;
                case 39:
                  return this.storeRootInSessionCache(Vi.type, X.id, he), Ct = new Kl(this.services, he, function(ir, Ir, Sr) {
                    return ke.removeFromCacheAndSession(ir, Ir, Sr);
                  }), Ct = this.entities.store(Ct), St.abrupt("return", new Vi(Ct));
                case 43:
                case "end":
                  return St.stop();
              }
          }, fe, this, [[14, 20], [26, 32]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Read or create a Sync list.
       * @param arg Could be any of the following:
       * * Unique name or SID identifying a Sync list - opens the list with the given identifier or creates one if it does not exist.
       * * none - creates a new list with a randomly assigned SID and no unique name.
       * * {@link OpenListOptions} object for more granular control.
       * @return A promise which resolves after the list is successfully read (or created).
       * This promise may reject if the list could not be created or if this endpoint lacks the necessary permissions to access it.
       * @example
       * ```typescript
       * syncClient.list('MyList')
       *   .then((list) => {
       *     console.log('Successfully opened a List. SID:', list.sid);
       *     list.on('itemAdded', (event) => {
       *       console.log('Received an "itemAdded" event:', event);
       *     });
       *   })
       *   .catch((error) => {
       *     console.error('Unexpected error', error);
       *   });
       * ```
       */
    }, {
      key: "list",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke = this, X, he, $e, Ct;
          return k.default.wrap(function(St) {
            for (; ; )
              switch (St.prev = St.next) {
                case 0:
                  return St.next = 2, this.ensureReady();
                case 2:
                  if (X = Me(le), X.mode !== "create_new") {
                    St.next = 9;
                    break;
                  }
                  return St.next = 6, this._createList(X.id, X.purpose, X.context, X.ttl);
                case 6:
                  he = St.sent, St.next = 39;
                  break;
                case 9:
                  if ($e = this.getCached(X.id, vi.type), !$e) {
                    St.next = 14;
                    break;
                  }
                  return St.abrupt("return", new vi($e));
                case 14:
                  return St.prev = 14, St.next = 17, this._getList(X.id);
                case 17:
                  he = St.sent, St.next = 39;
                  break;
                case 20:
                  if (St.prev = 20, St.t0 = St.catch(14), !(St.t0.status !== 404 || X.mode === "open_existing")) {
                    St.next = 26;
                    break;
                  }
                  throw St.t0;
                case 26:
                  return St.prev = 26, St.next = 29, this._createList(X.id, X.purpose, X.context, X.ttl);
                case 29:
                  he = St.sent, St.next = 39;
                  break;
                case 32:
                  if (St.prev = 32, St.t1 = St.catch(26), St.t1.status !== 409) {
                    St.next = 38;
                    break;
                  }
                  return St.abrupt("return", this.list(le));
                case 38:
                  throw St.t1;
                case 39:
                  return this.storeRootInSessionCache(vi.type, X.id, he), Ct = new qi(this.services, he, function(ir, Ir, Sr) {
                    return ke.removeFromCacheAndSession(ir, Ir, Sr);
                  }), Ct = this.entities.store(Ct), St.abrupt("return", new vi(Ct));
                case 43:
                case "end":
                  return St.stop();
              }
          }, fe, this, [[14, 20], [26, 32]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Read or create a Sync message stream.
       * @param arg Could be any of the following:
       * * Unique name or SID identifying a stream - opens the stream with the given identifier or creates one if it does not exist.
       * * none - creates a new stream with a randomly assigned SID and no unique name.
       * * {@link OpenStreamOptions} object for more granular control.
       * @return A promise which resolves after the stream is successfully read (or created).
       * The flow of messages will begin imminently (but not necessarily immediately) upon resolution.
       * This promise may reject if the stream could not be created or if this endpoint lacks the necessary permissions to access it.
       * @example
       * ```typescript
       * syncClient.stream('MyStream')
       *   .then((stream) => {
       *     console.log('Successfully opened a message stream. SID:', stream.sid);
       *     stream.on('messagePublished', (event) => {
       *       console.log('Received a "messagePublished" event:', event);
       *     });
       *   })
       *   .catch((error) => {
       *     console.error('Unexpected error', error);
       *   });
       * ```
       */
    }, {
      key: "stream",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke = this, X, he, $e, Ct, Bt;
          return k.default.wrap(function(ir) {
            for (; ; )
              switch (ir.prev = ir.next) {
                case 0:
                  return ir.next = 2, this.ensureReady();
                case 2:
                  if (X = Me(le), X.mode !== "create_new") {
                    ir.next = 9;
                    break;
                  }
                  return ir.next = 6, this._createStream(X.id, X.ttl);
                case 6:
                  he = ir.sent, ir.next = 39;
                  break;
                case 9:
                  if ($e = this.getCached(X.id, Jo.type), !$e) {
                    ir.next = 14;
                    break;
                  }
                  return ir.abrupt("return", new Jo($e));
                case 14:
                  return ir.prev = 14, ir.next = 17, this._getStream(X.id);
                case 17:
                  he = ir.sent, ir.next = 39;
                  break;
                case 20:
                  if (ir.prev = 20, ir.t0 = ir.catch(14), !(ir.t0.status !== 404 || X.mode === "open_existing")) {
                    ir.next = 26;
                    break;
                  }
                  throw ir.t0;
                case 26:
                  return ir.prev = 26, ir.next = 29, this._createStream(X.id, X.ttl);
                case 29:
                  he = ir.sent, ir.next = 39;
                  break;
                case 32:
                  if (ir.prev = 32, ir.t1 = ir.catch(26), ir.t1.status !== 409) {
                    ir.next = 38;
                    break;
                  }
                  return ir.abrupt("return", this.stream(le));
                case 38:
                  throw ir.t1;
                case 39:
                  return this.storeRootInSessionCache(Jo.type, X.id, he), Ct = function(Sr, Vr, ri) {
                    return ke.removeFromCacheAndSession(Sr, Vr, ri);
                  }, Bt = new Pc(this.services, he, Ct), Bt = this.entities.store(Bt), ir.abrupt("return", new Jo(Bt));
                case 44:
                case "end":
                  return ir.stop();
              }
          }, fe, this, [[14, 20], [26, 32]]);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Gracefully shuts the Sync client down.
       */
    }, {
      key: "shutdown",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe() {
          return k.default.wrap(function(ke) {
            for (; ; )
              switch (ke.prev = ke.next) {
                case 0:
                  return ke.next = 2, this.services.subscriptions.shutdown();
                case 2:
                  return ke.next = 4, this.services.twilsock.disconnect();
                case 4:
                case "end":
                  return ke.stop();
              }
          }, fe, this);
        }));
        function J() {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * Set the authentication token.
       * @param token New token to set.
       */
    }, {
      key: "updateToken",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          return k.default.wrap(function(X) {
            for (; ; )
              switch (X.prev = X.next) {
                case 0:
                  return X.abrupt("return", this.services.twilsock.updateToken(le).catch(function(he) {
                    var $e, Ct = he == null || ($e = he.reply) === null || $e === void 0 ? void 0 : $e.status;
                    throw (Ct == null ? void 0 : Ct.code) === 401 && (Ct == null ? void 0 : Ct.status) === "UNAUTHORIZED" ? new ee("Updated token was rejected by server", 400, 51130) : he;
                  }));
                case 1:
                case "end":
                  return X.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * For Flex customers only. Establishes a long-running query against Flex data wherein the returned
       * result set is updated whenever new (or updated) records match the given expression. Updated results
       * are presented row-by-row according to the lifetime of the returned LiveQuery object.
       *
       * @param indexName Must specify one of the Flex data classes for which Live Queries are available.
       * @param queryExpression A query expression to be executed against the given data index.
       * Please review the [Live Query Language](https://www.twilio.com/docs/sync/live-query)
       * page for Sync client limits and a full list of operators currently supported in query expressions.
       *
       * @return A promise that resolves when the query has been successfully executed.
       * @example
       * ```typescript
       * syncClient.liveQuery('tr-worker', 'data.attributes.worker_name == "Bob"')
       *   .then((args) => {
       *      console.log('Subscribed to live data updates for worker Bob');
       *      const items = args.getItems();
       *      Object.entries(items).forEach(([key, value]) => {
       *        console.log('Search result item key:', key);
       *        console.log('Search result item value:', value);
       *      });
       *   })
       *   .catch((err) => {
       *      console.error('Error when subscribing to live updates for worker Bob', err);
       *   });
       * ```
       */
    }, {
      key: "liveQuery",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le, ke) {
          var X = this, he, $e, Ct, Bt, St;
          return k.default.wrap(function(Ir) {
            for (; ; )
              switch (Ir.prev = Ir.next) {
                case 0:
                  return Ir.next = 2, this.ensureReady();
                case 2:
                  return he = new Y(this.services.config.insightsUri).pathSegment(le).pathSegment("Items").build(), Ir.next = 5, Oc({
                    network: this.services.network,
                    uri: he,
                    queryString: ke,
                    type: Rl.type
                  });
                case 5:
                  return $e = Ir.sent, Ct = this.getCached($e.query_id, Rl.type), Ct || (Bt = this._getLiveQuery($e.query_id), Bt || (Bt = {
                    indexName: le,
                    queryExpression: ke,
                    sid: $e.query_id,
                    queryUri: he,
                    last_event_id: $e.last_event_id
                  }), St = function(Vr, ri, ni) {
                    return X.removeFromCacheAndSession(Vr, ri, ni);
                  }, Ct = new Rc(Bt, this.services, St, $e.items)), this.storeRootInSessionCache(Rl.type, $e.query_id, Ct.liveQueryDescriptor), Ct = this.entities.store(Ct), Ir.abrupt("return", new Rl(Ct));
                case 11:
                case "end":
                  return Ir.stop();
              }
          }, fe, this);
        }));
        function J(fe, le) {
          return te.apply(this, arguments);
        }
        return J;
      }()
      /**
       * For Flex customers only. Creates a query object that can be used to issue one-time queries repeatedly
       * against the target index.
       *
       * @param indexName Must specify one of the Flex data classes for which live queries are available.
       * @return A promise which resolves after the instance of InstantQuery is successfully created.
       * @example
       * ```typescript
       * syncClient.instantQuery('tr-worker')
       *   .then((q) => {
       *     q.on('searchResult', (items) => {
       *       Object.entries(items).forEach(([key, value]) => {
       *         console.log('Search result item key:', key);
       *         console.log('Search result item value:', value);
       *       });
       *     });
       *   });
       * ```
       */
    }, {
      key: "instantQuery",
      value: function() {
        var te = I.default(/* @__PURE__ */ k.default.mark(function fe(le) {
          var ke = this, X;
          return k.default.wrap(function($e) {
            for (; ; )
              switch ($e.prev = $e.next) {
                case 0:
                  return $e.next = 2, this.ensureReady();
                case 2:
                  return X = function(Bt, St) {
                    return ke.liveQuery(Bt, St);
                  }, $e.abrupt("return", new hs({
                    indexName: le,
                    network: this.services.network,
                    insightsUri: this.services.config.insightsUri,
                    liveQueryCreator: X
                  }));
                case 4:
                case "end":
                  return $e.stop();
              }
          }, fe, this);
        }));
        function J(fe) {
          return te.apply(this, arguments);
        }
        return J;
      }()
    }], [{
      key: "populateInitRegistrations",
      value: function(J) {
        J.populateInitRegistrations([qt, ut, Ve, Kt]);
      }
    }, {
      key: "version",
      get: function() {
        return Be;
      }
    }]), Q;
  }(_.ReplayEventEmitter);
  return v.default(vr, "connectionStateChanged", "connectionStateChanged"), v.default(vr, "connectionError", "connectionError"), v.default(vr, "tokenAboutToExpire", "tokenAboutToExpire"), v.default(vr, "tokenExpired", "tokenExpired"), Z([u.validateTypesAsync(["undefined", "string", u.objectSchema("open document options", {
    id: ["string", "undefined"],
    mode: [u.literal("open_or_create", "open_existing", "create_new"), "undefined"],
    ttl: [u.nonNegativeInteger, "undefined"],
    data: [u.pureObject, "undefined", u.literal(null)]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], vr.prototype, "document", null), Z([u.validateTypesAsync(["undefined", "string", u.objectSchema("open map options", {
    id: ["string", "undefined"],
    mode: [u.literal("open_or_create", "open_existing", "create_new"), "undefined"],
    ttl: [u.nonNegativeInteger, "undefined"],
    data: [u.pureObject, "undefined", u.literal(null)],
    includeItems: ["boolean", "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], vr.prototype, "map", null), Z([u.validateTypesAsync(["undefined", "string", u.objectSchema("open list options", {
    id: ["string", "undefined"],
    mode: [u.literal("open_or_create", "open_existing", "create_new"), "undefined"],
    ttl: [u.nonNegativeInteger, "undefined"],
    data: [u.pureObject, "undefined", u.literal(null)],
    purpose: ["string", "undefined"],
    context: [u.pureObject, "undefined"],
    includeItems: ["boolean", "undefined"]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], vr.prototype, "list", null), Z([u.validateTypesAsync(["undefined", "string", u.objectSchema("open stream options", {
    id: ["string", "undefined"],
    mode: [u.literal("open_or_create", "open_existing", "create_new"), "undefined"],
    ttl: [u.nonNegativeInteger, "undefined"],
    data: [u.pureObject, "undefined", u.literal(null)]
  })]), V("design:type", Function), V("design:paramtypes", [Object]), V("design:returntype", Promise)], vr.prototype, "stream", null), Z([u.validateTypesAsync(u.nonEmptyString), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", Promise)], vr.prototype, "updateToken", null), Z([u.validateTypesAsync(u.nonEmptyString, "string"), V("design:type", Function), V("design:paramtypes", [String, String]), V("design:returntype", Promise)], vr.prototype, "liveQuery", null), Z([u.validateTypesAsync(u.nonEmptyString), V("design:type", Function), V("design:paramtypes", [String]), V("design:returntype", Promise)], vr.prototype, "instantQuery", null), gu.Client = vr, gu.InsightsItem = Nd, gu.InstantQuery = hs, gu.LiveQuery = Rl, gu.Paginator = Xr, gu.SyncClient = vr, gu.SyncDocument = gr, gu.SyncList = vi, gu.SyncListItem = pr, gu.SyncMap = Vi, gu.SyncMapItem = Ho, gu.SyncStream = Jo, gu;
}
var rnt = tnt();
const _Ae = {
  /** Total duration of the animation in milliseconds */
  durationMs: 500,
  /** Buffer factor to make animation smoother (1.25 = 25% buffer) */
  bufferFactor: 1.25
}, fmr = async (t) => {
  const e = atob(t), r = new Uint8Array([...e].map((o) => o.charCodeAt(0))), a = new ReadableStream({
    start(o) {
      o.enqueue(r), o.close();
    }
  }).pipeThrough(
    new DecompressionStream("gzip")
  );
  return await new Response(a).text();
}, kAe = (t) => {
  const e = t.parts.find((r) => r.type === "MARKDOWN");
  return {
    content: (e == null ? void 0 : e.content) || "",
    otherParts: t.parts.filter((r) => r !== e)
  };
}, hmr = (t, e) => ({
  role: "ASSISTANT",
  complete: !1,
  parts: [
    {
      type: "MARKDOWN",
      content: t
    },
    ...e
  ]
}), pmr = (t) => {
  const e = {
    message: {
      role: "ASSISTANT",
      complete: !1,
      parts: []
    },
    canvasContent: null,
    canvasId: null,
    loadingMessages: []
  };
  for (const [r, n] of t)
    switch (r) {
      case N9.LOADING_MESSAGE:
        e.loadingMessages.push(n);
        break;
      case N9.CONTENT:
        e.message = n;
        break;
      case N9.CANVAS_CONTENT:
        e.canvasContent = n;
        break;
      case N9.CANVAS_DONE:
        e.canvasId = n;
        break;
    }
  return e;
}, mmr = (t, e, r, n) => {
  let a = n;
  return e && (t(oz(!0)), a = !0), e && t(g1e(e)), r && t(DWe(r)), a;
}, gmr = async (t, e, r, n, a) => {
  const i = r.slice(e.length).split(/(\s+)/), o = _Ae.durationMs * _Ae.bufferFactor / i.length;
  let s = e;
  for (const l of i) {
    if (a.signal.aborted)
      break;
    s += l, t(
      q$(
        hmr(s, n)
      )
    ), await new Promise((c) => setTimeout(c, o));
  }
}, vmr = (t, e, r, n) => {
  e.current && e.current.abort(), e.current = null;
  const [a, i] = r[1];
  t(
    Jce({
      type: l0.MESSAGE_DONE,
      data: {
        conversationId: n,
        message: i
      }
    })
  ), t(d6e(a)), t(d6e(i)), t(q$(null)), t($We(null)), t(AS([])), t(kle(N7.Idle)), t(W4t(0));
}, qM = () => {
  const t = s2(), { requestTransformer: e } = Ja(), r = Gn((c) => c.config.applicationId), n = Gn(
    (c) => c.conversation.conversationId
  ), a = Te.useRef(null), [i] = fPt(), [o] = HMt(), s = async (c, u) => {
    const f = await fmr(c), h = JSON.parse(f);
    if (h.find(
      ([M]) => M === N9.ERROR
    )) {
      t(kle(N7.Error)), t(AS([])), t(H4t());
      return;
    }
    const g = h.find(
      ([M]) => M === N9.DONE
    );
    if (g) {
      vmr(
        t,
        a,
        g,
        u
      );
      return;
    }
    const { message: y, canvasContent: b, canvasId: w, loadingMessages: _ } = pmr(h), C = y.parts.some(
      (M) => M.type === "MARKDOWN" && M.content.length > 0
    );
    mmr(t, b, w, !1), t(AS(C ? [] : _));
    const x = uKe.getState().conversation.partialAssistantMessage, { content: S } = kAe(
      x || y
    ), { content: A, otherParts: I } = kAe(y);
    A !== S ? (a.current && a.current.abort(), a.current = new AbortController(), await gmr(
      t,
      S,
      A,
      I,
      a.current
    )) : t(q$(y));
  };
  return { sendMessage: async ({ message: c }) => {
    a.current && a.current.abort(), a.current = new AbortController(), t(bPt()), t(kle(N7.Loading));
    let u = n;
    if (!u) {
      const { conversation: b } = await o({
        applicationId: r,
        requestTransformer: e
      }).unwrap();
      t(_le(b.id)), t(LWe(b.chatId)), t(
        Jce({
          type: "createConversation",
          data: {
            conversationId: b.id
          }
        })
      ), u = b.id;
    }
    t(
      Jce({
        type: l0.SEND_MESSAGE,
        data: {
          conversationId: u,
          message: c
        }
      })
    ), t(
      $We({ role: Mu.USER, content: c })
    ), t(
      q$({
        role: "ASSISTANT",
        complete: !1,
        parts: []
      })
    ), t(AS(["Thinking"]));
    const { syncDocumentSid: f, accessToken: h } = await i({
      requestTransformer: e,
      conversationId: u,
      body: {
        input: c,
        applicationId: r,
        streamMode: "sync",
        systemContext: {}
      }
    }).unwrap(), g = await new rnt.SyncClient(h).document(f), { data: y } = g.data;
    await s(y, u), g.on(
      "updated",
      ({ data: { data: b } }) => {
        s(b, u);
      }
    );
  } };
}, ymr = ha.object({
  url: ha.string()
}), bmr = (t) => {
  try {
    const { url: e } = ymr.parse(t);
    window.open(e, "_blank");
  } catch (e) {
    console.error("Invalid open URL action arguments", e);
  }
}, Ume = () => {
  const { sendMessage: t } = qM();
  return {
    [l0.SEND_MESSAGE]: t,
    [l0.OPEN_URL]: bmr,
    // DIRECT_LIVE_CHAT_TRANSFER is handled
    [l0.DIRECT_LIVE_CHAT_TRANSFER]: () => {
    }
  };
};
var LQ = {}, aW = (t) => rpe({ modal: !0, ...t }), iW = P.createContext({}), xmr = Zh(ht), Cmr = () => ({ from: { opacity: 0, transform: "translateX(100%)" }, enter: { opacity: 1, transform: "translateX(0%)" }, leave: { opacity: 0, transform: "translateX(100%)" }, config: { mass: 0.5, tension: 220, friction: 20 } }), nnt = P.forwardRef(({ children: t, element: e = "SIDE_MODAL", hideOnEsc: r = !0, ...n }, a) => {
  let i = P.useContext(iW), o = A8(i.visible, Cmr());
  return P.createElement(xXe, { ...i, ...Xt(n), preventBodyScroll: !1, hideOnClickOutside: !1, hideOnEsc: r, element: `${e}_CONTAINER`, ref: a, as: ht, zIndex: "zIndex80", position: "fixed", top: "0 !important", right: "0 !important", bottom: "0 !important", left: "auto !important", transform: "none !important", _focus: { outline: "none" } }, P.createElement(uy, null, o((s, l) => l && P.createElement(xmr, { style: s, element: e, display: "grid", gridTemplateRows: "auto 1fr auto", height: "100vh", backgroundColor: "colorBackgroundWeaker", boxShadow: "shadowElevationLeft20", width: "size80" }, t))));
});
nnt.displayName = "SideModal";
var ant = P.forwardRef(({ children: t, element: e = "SIDE_MODAL_BUTTON", ...r }, n) => {
  let a = P.useContext(iW);
  return P.createElement(eG, { element: e, ...a, ...r, as: Zs, ref: n }, t);
});
ant.displayName = "SideModalButton";
var int = P.forwardRef(({ children: t, element: e = "SIDE_MODAL_HEADER", i18nDismissLabel: r = "close", ...n }, a) => {
  let { hide: i } = P.useContext(iW);
  return P.createElement(ht, { ...Xt(n), ref: a, paddingRight: "space90", paddingLeft: "space90", paddingTop: "space90", element: e, display: "flex", flexDirection: "row", alignItems: "flex-start" }, P.createElement(ht, { display: "flex", flexGrow: 1, marginRight: "space70" }, t), P.createElement(Zs, { element: `${e}_CLOSE_BUTTON`, variant: "secondary_icon", size: "reset", onClick: i }, P.createElement(Dy, { element: `${e}_CLOSE_ICON`, decorative: !0, size: "sizeIcon50" }), P.createElement(Ul, null, r)));
});
int.displayName = "SideModalHeader";
var ont = P.forwardRef(({ children: t, as: e = "h2", element: r = "SIDE_MODAL_HEADING", ...n }, a) => P.createElement($8, { ...n, as: e, element: r, marginBottom: "space0", variant: "heading30", ref: a }, t));
ont.displayName = "SideModalHeading";
var snt = ({ gutter: t, placement: e, modal: r, children: n, state: a, ...i }) => {
  let o = a || aW({ modal: !0, unstable_fixed: !0, ...i });
  return P.createElement(iW.Provider, { value: { ...o } }, n);
};
snt.displayName = "BaseSideModalContainer";
var lnt = P.memo(snt);
lnt.displayName = "SideModalContainer";
var cnt = P.forwardRef(({ children: t, element: e = "SIDE_MODAL_BODY", ...r }, n) => P.createElement(ht, { ...Xt(r), element: e, ref: n, overflowY: "auto", padding: "space90" }, t));
cnt.displayName = "SideModalBody";
var unt = P.forwardRef(({ children: t, element: e = "SIDE_MODAL_FOOTER", ...r }, n) => P.createElement(ht, { ...Xt(r), as: "div", element: e, ref: n, paddingRight: "space90", paddingLeft: "space90", paddingBottom: "space90", display: "flex" }, t));
unt.displayName = "SideModalFooter";
var dnt = P.forwardRef(({ children: t, element: e = "SIDE_MODAL_FOOTER_ACTIONS", justifyContent: r = "flex-start", ...n }, a) => P.createElement(ht, { ...Xt(n), display: "flex", justifyContent: r, flexWrap: "wrap", flexGrow: 1, element: e, columnGap: "space50", alignItems: "center", ref: a }, t));
dnt.displayName = "SideModalFooterActions";
var wmr = (t) => aW({ modal: !0, unstable_fixed: !0, ...t });
const Smr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SideModal: nnt,
  SideModalBody: cnt,
  SideModalButton: ant,
  SideModalContainer: lnt,
  SideModalFooter: unt,
  SideModalFooterActions: dnt,
  SideModalHeader: int,
  SideModalHeading: ont,
  useSideModalState: wmr
}, Symbol.toStringTag, { value: "Module" })), _mr = /* @__PURE__ */ aa(Smr);
var AAe;
function kmr() {
  return AAe || (AAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = _mr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(LQ)), LQ;
}
var F9 = /* @__PURE__ */ kmr(), KM = (t) => t.type === "checkbox", mb = (t) => t instanceof Date, yu = (t) => t == null;
const fnt = (t) => typeof t == "object";
var ul = (t) => !yu(t) && !Array.isArray(t) && fnt(t) && !mb(t), hnt = (t) => ul(t) && t.target ? KM(t.target) ? t.target.checked : t.target.value : t, Amr = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, pnt = (t, e) => t.has(Amr(e)), Tmr = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return ul(e) && e.hasOwnProperty("isPrototypeOf");
}, Vme = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function cd(t) {
  let e;
  const r = Array.isArray(t), n = typeof FileList < "u" ? t instanceof FileList : !1;
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(Vme && (t instanceof Blob || n)) && (r || ul(t)))
    if (e = r ? [] : {}, !r && !Tmr(t))
      e = t;
    else
      for (const a in t)
        t.hasOwnProperty(a) && (e[a] = cd(t[a]));
  else
    return t;
  return e;
}
var oW = (t) => Array.isArray(t) ? t.filter(Boolean) : [], sl = (t) => t === void 0, en = (t, e, r) => {
  if (!e || !ul(t))
    return r;
  const n = oW(e.split(/[,[\].]+?/)).reduce((a, i) => yu(a) ? a : a[i], t);
  return sl(n) || n === t ? sl(t[e]) ? r : t[e] : n;
}, W0 = (t) => typeof t == "boolean", qme = (t) => /^\w*$/.test(t), mnt = (t) => oW(t.replace(/["|']|\]/g, "").split(/\.|\[/)), Uo = (t, e, r) => {
  let n = -1;
  const a = qme(e) ? [e] : mnt(e), i = a.length, o = i - 1;
  for (; ++n < i; ) {
    const s = a[n];
    let l = r;
    if (n !== o) {
      const c = t[s];
      l = ul(c) || Array.isArray(c) ? c : isNaN(+a[n + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    t[s] = l, t = t[s];
  }
  return t;
};
const KL = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, m1 = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, $p = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Emr = Te.createContext(null), Kme = () => Te.useContext(Emr);
var gnt = (t, e, r, n = !0) => {
  const a = {
    defaultValues: e._defaultValues
  };
  for (const i in t)
    Object.defineProperty(a, i, {
      get: () => {
        const o = i;
        return e._proxyFormState[o] !== m1.all && (e._proxyFormState[o] = !n || m1.all), r && (r[o] = !0), t[o];
      }
    });
  return a;
}, ud = (t) => ul(t) && !Object.keys(t).length, vnt = (t, e, r, n) => {
  r(t);
  const { name: a, ...i } = t;
  return ud(i) || Object.keys(i).length >= Object.keys(e).length || Object.keys(i).find((o) => e[o] === (!n || m1.all));
}, $_ = (t) => Array.isArray(t) ? t : [t], ynt = (t, e, r) => !t || !e || t === e || $_(t).some((n) => n && (r ? n === e : n.startsWith(e) || e.startsWith(n)));
function Zme(t) {
  const e = Te.useRef(t);
  e.current = t, Te.useEffect(() => {
    const r = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [t.disabled]);
}
function Imr(t) {
  const e = Kme(), { control: r = e.control, disabled: n, name: a, exact: i } = t || {}, [o, s] = Te.useState(r._formState), l = Te.useRef(!0), c = Te.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = Te.useRef(a);
  return u.current = a, Zme({
    disabled: n,
    next: (f) => l.current && ynt(u.current, f.name, i) && vnt(f, c.current, r._updateFormState) && s({
      ...r._formState,
      ...f
    }),
    subject: r._subjects.state
  }), Te.useEffect(() => (l.current = !0, c.current.isValid && r._updateValid(!0), () => {
    l.current = !1;
  }), [r]), Te.useMemo(() => gnt(o, r, c.current, !1), [o, r]);
}
var nh = (t) => typeof t == "string", bnt = (t, e, r, n, a) => nh(t) ? (n && e.watch.add(t), en(r, t, a)) : Array.isArray(t) ? t.map((i) => (n && e.watch.add(i), en(r, i))) : (n && (e.watchAll = !0), r);
function Mmr(t) {
  const e = Kme(), { control: r = e.control, name: n, defaultValue: a, disabled: i, exact: o } = t || {}, s = Te.useRef(n);
  s.current = n, Zme({
    disabled: i,
    subject: r._subjects.values,
    next: (u) => {
      ynt(s.current, u.name, o) && c(cd(bnt(s.current, r._names, u.values || r._formValues, !1, a)));
    }
  });
  const [l, c] = Te.useState(r._getWatch(n, a));
  return Te.useEffect(() => r._removeUnmounted()), l;
}
function Pmr(t) {
  const e = Kme(), { name: r, disabled: n, control: a = e.control, shouldUnregister: i } = t, o = pnt(a._names.array, r), s = Mmr({
    control: a,
    name: r,
    defaultValue: en(a._formValues, r, en(a._defaultValues, r, t.defaultValue)),
    exact: !0
  }), l = Imr({
    control: a,
    name: r,
    exact: !0
  }), c = Te.useRef(a.register(r, {
    ...t.rules,
    value: s,
    ...W0(t.disabled) ? { disabled: t.disabled } : {}
  })), u = Te.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!en(l.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!en(l.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!en(l.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!en(l.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => en(l.errors, r)
    }
  }), [l, r]), f = Te.useMemo(() => ({
    name: r,
    value: s,
    ...W0(n) || l.disabled ? { disabled: l.disabled || n } : {},
    onChange: (h) => c.current.onChange({
      target: {
        value: hnt(h),
        name: r
      },
      type: KL.CHANGE
    }),
    onBlur: () => c.current.onBlur({
      target: {
        value: en(a._formValues, r),
        name: r
      },
      type: KL.BLUR
    }),
    ref: (h) => {
      const p = en(a._fields, r);
      p && h && (p._f.ref = {
        focus: () => h.focus(),
        select: () => h.select(),
        setCustomValidity: (g) => h.setCustomValidity(g),
        reportValidity: () => h.reportValidity()
      });
    }
  }), [
    r,
    a._formValues,
    n,
    l.disabled,
    s,
    a._fields
  ]);
  return Te.useEffect(() => {
    const h = a._options.shouldUnregister || i, p = (g, y) => {
      const b = en(a._fields, g);
      b && b._f && (b._f.mount = y);
    };
    if (p(r, !0), h) {
      const g = cd(en(a._options.defaultValues, r));
      Uo(a._defaultValues, r, g), sl(en(a._formValues, r)) && Uo(a._formValues, r, g);
    }
    return !o && a.register(r), () => {
      (o ? h && !a._state.action : h) ? a.unregister(r) : p(r, !1);
    };
  }, [r, a, o, i]), Te.useEffect(() => {
    a._updateDisabledField({
      disabled: n,
      fields: a._fields,
      name: r
    });
  }, [n, r, a]), Te.useMemo(() => ({
    field: f,
    formState: l,
    fieldState: u
  }), [f, l, u]);
}
const Vue = (t) => t.render(Pmr(t));
var Rmr = (t, e, r, n, a) => e ? {
  ...r[t],
  types: {
    ...r[t] && r[t].types ? r[t].types : {},
    [n]: a || !0
  }
} : {}, TAe = (t) => ({
  isOnSubmit: !t || t === m1.onSubmit,
  isOnBlur: t === m1.onBlur,
  isOnChange: t === m1.onChange,
  isOnAll: t === m1.all,
  isOnTouch: t === m1.onTouched
}), EAe = (t, e, r) => !r && (e.watchAll || e.watch.has(t) || [...e.watch].some((n) => t.startsWith(n) && /^\.\w+/.test(t.slice(n.length))));
const D_ = (t, e, r, n) => {
  for (const a of r || Object.keys(t)) {
    const i = en(t, a);
    if (i) {
      const { _f: o, ...s } = i;
      if (o) {
        if (o.refs && o.refs[0] && e(o.refs[0], a) && !n)
          return !0;
        if (o.ref && e(o.ref, o.name) && !n)
          return !0;
        if (D_(s, e))
          break;
      } else if (ul(s) && D_(s, e))
        break;
    }
  }
};
var Omr = (t, e, r) => {
  const n = $_(en(t, r));
  return Uo(n, "root", e[r]), Uo(t, r, n), t;
}, Jme = (t) => t.type === "file", Q2 = (t) => typeof t == "function", ZL = (t) => {
  if (!Vme)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, m$ = (t) => nh(t), Yme = (t) => t.type === "radio", JL = (t) => t instanceof RegExp;
const IAe = {
  value: !1,
  isValid: !1
}, MAe = { value: !0, isValid: !0 };
var xnt = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !sl(t[0].attributes.value) ? sl(t[0].value) || t[0].value === "" ? MAe : { value: t[0].value, isValid: !0 } : MAe
    ) : IAe;
  }
  return IAe;
};
const PAe = {
  isValid: !1,
  value: null
};
var Cnt = (t) => Array.isArray(t) ? t.reduce((e, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : e, PAe) : PAe;
function RAe(t, e, r = "validate") {
  if (m$(t) || Array.isArray(t) && t.every(m$) || W0(t) && !t)
    return {
      type: r,
      message: m$(t) ? t : "",
      ref: e
    };
}
var J4 = (t) => ul(t) && !JL(t) ? t : {
  value: t,
  message: ""
}, OAe = async (t, e, r, n, a, i) => {
  const { ref: o, refs: s, required: l, maxLength: c, minLength: u, min: f, max: h, pattern: p, validate: g, name: y, valueAsNumber: b, mount: w } = t._f, _ = en(r, y);
  if (!w || e.has(y))
    return {};
  const C = s ? s[0] : o, x = (d) => {
    a && C.reportValidity && (C.setCustomValidity(W0(d) ? "" : d || ""), C.reportValidity());
  }, S = {}, A = Yme(o), I = KM(o), M = A || I, B = (b || Jme(o)) && sl(o.value) && sl(_) || ZL(o) && o.value === "" || _ === "" || Array.isArray(_) && !_.length, L = Rmr.bind(null, y, n, S), N = (d, m, v, k = $p.maxLength, O = $p.minLength) => {
    const G = d ? m : v;
    S[y] = {
      type: d ? k : O,
      message: G,
      ref: o,
      ...L(d ? k : O, G)
    };
  };
  if (i ? !Array.isArray(_) || !_.length : l && (!M && (B || yu(_)) || W0(_) && !_ || I && !xnt(s).isValid || A && !Cnt(s).isValid)) {
    const { value: d, message: m } = m$(l) ? { value: !!l, message: l } : J4(l);
    if (d && (S[y] = {
      type: $p.required,
      message: m,
      ref: C,
      ...L($p.required, m)
    }, !n))
      return x(m), S;
  }
  if (!B && (!yu(f) || !yu(h))) {
    let d, m;
    const v = J4(h), k = J4(f);
    if (!yu(_) && !isNaN(_)) {
      const O = o.valueAsNumber || _ && +_;
      yu(v.value) || (d = O > v.value), yu(k.value) || (m = O < k.value);
    } else {
      const O = o.valueAsDate || new Date(_), G = (F) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + F), H = o.type == "time", j = o.type == "week";
      nh(v.value) && _ && (d = H ? G(_) > G(v.value) : j ? _ > v.value : O > new Date(v.value)), nh(k.value) && _ && (m = H ? G(_) < G(k.value) : j ? _ < k.value : O < new Date(k.value));
    }
    if ((d || m) && (N(!!d, v.message, k.message, $p.max, $p.min), !n))
      return x(S[y].message), S;
  }
  if ((c || u) && !B && (nh(_) || i && Array.isArray(_))) {
    const d = J4(c), m = J4(u), v = !yu(d.value) && _.length > +d.value, k = !yu(m.value) && _.length < +m.value;
    if ((v || k) && (N(v, d.message, m.message), !n))
      return x(S[y].message), S;
  }
  if (p && !B && nh(_)) {
    const { value: d, message: m } = J4(p);
    if (JL(d) && !_.match(d) && (S[y] = {
      type: $p.pattern,
      message: m,
      ref: o,
      ...L($p.pattern, m)
    }, !n))
      return x(m), S;
  }
  if (g) {
    if (Q2(g)) {
      const d = await g(_, r), m = RAe(d, C);
      if (m && (S[y] = {
        ...m,
        ...L($p.validate, m.message)
      }, !n))
        return x(m.message), S;
    } else if (ul(g)) {
      let d = {};
      for (const m in g) {
        if (!ud(d) && !n)
          break;
        const v = RAe(await g[m](_, r), C, m);
        v && (d = {
          ...v,
          ...L(m, v.message)
        }, x(v.message), n && (S[y] = d));
      }
      if (!ud(d) && (S[y] = {
        ref: C,
        ...d
      }, !n))
        return S;
    }
  }
  return x(!0), S;
};
function Bmr(t, e) {
  const r = e.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    t = sl(t) ? n++ : t[e[n++]];
  return t;
}
function Nmr(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !sl(t[e]))
      return !1;
  return !0;
}
function Fl(t, e) {
  const r = Array.isArray(e) ? e : qme(e) ? [e] : mnt(e), n = r.length === 1 ? t : Bmr(t, r), a = r.length - 1, i = r[a];
  return n && delete n[i], a !== 0 && (ul(n) && ud(n) || Array.isArray(n) && Nmr(n)) && Fl(t, r.slice(0, -1)), t;
}
var jQ = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (a) => {
      for (const i of t)
        i.next && i.next(a);
    },
    subscribe: (a) => (t.push(a), {
      unsubscribe: () => {
        t = t.filter((i) => i !== a);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, que = (t) => yu(t) || !fnt(t);
function gv(t, e) {
  if (que(t) || que(e))
    return t === e;
  if (mb(t) && mb(e))
    return t.getTime() === e.getTime();
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (const a of r) {
    const i = t[a];
    if (!n.includes(a))
      return !1;
    if (a !== "ref") {
      const o = e[a];
      if (mb(i) && mb(o) || ul(i) && ul(o) || Array.isArray(i) && Array.isArray(o) ? !gv(i, o) : i !== o)
        return !1;
    }
  }
  return !0;
}
var wnt = (t) => t.type === "select-multiple", $mr = (t) => Yme(t) || KM(t), FQ = (t) => ZL(t) && t.isConnected, Snt = (t) => {
  for (const e in t)
    if (Q2(t[e]))
      return !0;
  return !1;
};
function YL(t, e = {}) {
  const r = Array.isArray(t);
  if (ul(t) || r)
    for (const n in t)
      Array.isArray(t[n]) || ul(t[n]) && !Snt(t[n]) ? (e[n] = Array.isArray(t[n]) ? [] : {}, YL(t[n], e[n])) : yu(t[n]) || (e[n] = !0);
  return e;
}
function _nt(t, e, r) {
  const n = Array.isArray(t);
  if (ul(t) || n)
    for (const a in t)
      Array.isArray(t[a]) || ul(t[a]) && !Snt(t[a]) ? sl(e) || que(r[a]) ? r[a] = Array.isArray(t[a]) ? YL(t[a], []) : { ...YL(t[a]) } : _nt(t[a], yu(e) ? {} : e[a], r[a]) : r[a] = !gv(t[a], e[a]);
  return r;
}
var eS = (t, e) => _nt(t, e, YL(e)), knt = (t, { valueAsNumber: e, valueAsDate: r, setValueAs: n }) => sl(t) ? t : e ? t === "" ? NaN : t && +t : r && nh(t) ? new Date(t) : n ? n(t) : t;
function zQ(t) {
  const e = t.ref;
  return Jme(e) ? e.files : Yme(e) ? Cnt(t.refs).value : wnt(e) ? [...e.selectedOptions].map(({ value: r }) => r) : KM(e) ? xnt(t.refs).value : knt(sl(e.value) ? t.ref.value : e.value, t);
}
var Dmr = (t, e, r, n) => {
  const a = {};
  for (const i of t) {
    const o = en(e, i);
    o && Uo(a, i, o._f);
  }
  return {
    criteriaMode: r,
    names: [...t],
    fields: a,
    shouldUseNativeValidation: n
  };
}, tS = (t) => sl(t) ? t : JL(t) ? t.source : ul(t) ? JL(t.value) ? t.value.source : t.value : t;
const BAe = "AsyncFunction";
var Lmr = (t) => !!t && !!t.validate && !!(Q2(t.validate) && t.validate.constructor.name === BAe || ul(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === BAe)), jmr = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function NAe(t, e, r) {
  const n = en(t, r);
  if (n || qme(r))
    return {
      error: n,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const i = a.join("."), o = en(e, i), s = en(t, i);
    if (o && !Array.isArray(o) && r !== i)
      return { name: r };
    if (s && s.type)
      return {
        name: i,
        error: s
      };
    a.pop();
  }
  return {
    name: r
  };
}
var Fmr = (t, e, r, n, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(e || t) : (r ? n.isOnBlur : a.isOnBlur) ? !t : (r ? n.isOnChange : a.isOnChange) ? t : !0, zmr = (t, e) => !oW(en(t, e)).length && Fl(t, e);
const Gmr = {
  mode: m1.onSubmit,
  reValidateMode: m1.onChange,
  shouldFocusError: !0
};
function Wmr(t = {}) {
  let e = {
    ...Gmr,
    ...t
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Q2(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, n = {}, a = ul(e.defaultValues) || ul(e.values) ? cd(e.defaultValues || e.values) || {} : {}, i = e.shouldUnregister ? {} : cd(a), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: jQ(),
    array: jQ(),
    state: jQ()
  }, h = TAe(e.mode), p = TAe(e.reValidateMode), g = e.criteriaMode === m1.all, y = (Ne) => (ze) => {
    clearTimeout(c), c = setTimeout(Ne, ze);
  }, b = async (Ne) => {
    if (!e.disabled && (u.isValid || Ne)) {
      const ze = e.resolver ? ud((await M()).errors) : await L(n, !0);
      ze !== r.isValid && f.state.next({
        isValid: ze
      });
    }
  }, w = (Ne, ze) => {
    !e.disabled && (u.isValidating || u.validatingFields) && ((Ne || Array.from(s.mount)).forEach((ct) => {
      ct && (ze ? Uo(r.validatingFields, ct, ze) : Fl(r.validatingFields, ct));
    }), f.state.next({
      validatingFields: r.validatingFields,
      isValidating: !ud(r.validatingFields)
    }));
  }, _ = (Ne, ze = [], ct, rt, qe = !0, nt = !0) => {
    if (rt && ct && !e.disabled) {
      if (o.action = !0, nt && Array.isArray(en(n, Ne))) {
        const Rt = ct(en(n, Ne), rt.argA, rt.argB);
        qe && Uo(n, Ne, Rt);
      }
      if (nt && Array.isArray(en(r.errors, Ne))) {
        const Rt = ct(en(r.errors, Ne), rt.argA, rt.argB);
        qe && Uo(r.errors, Ne, Rt), zmr(r.errors, Ne);
      }
      if (u.touchedFields && nt && Array.isArray(en(r.touchedFields, Ne))) {
        const Rt = ct(en(r.touchedFields, Ne), rt.argA, rt.argB);
        qe && Uo(r.touchedFields, Ne, Rt);
      }
      u.dirtyFields && (r.dirtyFields = eS(a, i)), f.state.next({
        name: Ne,
        isDirty: d(Ne, ze),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Uo(i, Ne, ze);
  }, C = (Ne, ze) => {
    Uo(r.errors, Ne, ze), f.state.next({
      errors: r.errors
    });
  }, x = (Ne) => {
    r.errors = Ne, f.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, S = (Ne, ze, ct, rt) => {
    const qe = en(n, Ne);
    if (qe) {
      const nt = en(i, Ne, sl(ct) ? en(a, Ne) : ct);
      sl(nt) || rt && rt.defaultChecked || ze ? Uo(i, Ne, ze ? nt : zQ(qe._f)) : k(Ne, nt), o.mount && b();
    }
  }, A = (Ne, ze, ct, rt, qe) => {
    let nt = !1, Rt = !1;
    const Ot = {
      name: Ne
    };
    if (!e.disabled) {
      const lt = !!(en(n, Ne) && en(n, Ne)._f && en(n, Ne)._f.disabled);
      if (!ct || rt) {
        u.isDirty && (Rt = r.isDirty, r.isDirty = Ot.isDirty = d(), nt = Rt !== Ot.isDirty);
        const mt = lt || gv(en(a, Ne), ze);
        Rt = !!(!lt && en(r.dirtyFields, Ne)), mt || lt ? Fl(r.dirtyFields, Ne) : Uo(r.dirtyFields, Ne, !0), Ot.dirtyFields = r.dirtyFields, nt = nt || u.dirtyFields && Rt !== !mt;
      }
      if (ct) {
        const mt = en(r.touchedFields, Ne);
        mt || (Uo(r.touchedFields, Ne, ct), Ot.touchedFields = r.touchedFields, nt = nt || u.touchedFields && mt !== ct);
      }
      nt && qe && f.state.next(Ot);
    }
    return nt ? Ot : {};
  }, I = (Ne, ze, ct, rt) => {
    const qe = en(r.errors, Ne), nt = u.isValid && W0(ze) && r.isValid !== ze;
    if (e.delayError && ct ? (l = y(() => C(Ne, ct)), l(e.delayError)) : (clearTimeout(c), l = null, ct ? Uo(r.errors, Ne, ct) : Fl(r.errors, Ne)), (ct ? !gv(qe, ct) : qe) || !ud(rt) || nt) {
      const Rt = {
        ...rt,
        ...nt && W0(ze) ? { isValid: ze } : {},
        errors: r.errors,
        name: Ne
      };
      r = {
        ...r,
        ...Rt
      }, f.state.next(Rt);
    }
  }, M = async (Ne) => {
    w(Ne, !0);
    const ze = await e.resolver(i, e.context, Dmr(Ne || s.mount, n, e.criteriaMode, e.shouldUseNativeValidation));
    return w(Ne), ze;
  }, B = async (Ne) => {
    const { errors: ze } = await M(Ne);
    if (Ne)
      for (const ct of Ne) {
        const rt = en(ze, ct);
        rt ? Uo(r.errors, ct, rt) : Fl(r.errors, ct);
      }
    else
      r.errors = ze;
    return ze;
  }, L = async (Ne, ze, ct = {
    valid: !0
  }) => {
    for (const rt in Ne) {
      const qe = Ne[rt];
      if (qe) {
        const { _f: nt, ...Rt } = qe;
        if (nt) {
          const Ot = s.array.has(nt.name), lt = qe._f && Lmr(qe._f);
          lt && u.validatingFields && w([rt], !0);
          const mt = await OAe(qe, s.disabled, i, g, e.shouldUseNativeValidation && !ze, Ot);
          if (lt && u.validatingFields && w([rt]), mt[nt.name] && (ct.valid = !1, ze))
            break;
          !ze && (en(mt, nt.name) ? Ot ? Omr(r.errors, mt, nt.name) : Uo(r.errors, nt.name, mt[nt.name]) : Fl(r.errors, nt.name));
        }
        !ud(Rt) && await L(Rt, ze, ct);
      }
    }
    return ct.valid;
  }, N = () => {
    for (const Ne of s.unMount) {
      const ze = en(n, Ne);
      ze && (ze._f.refs ? ze._f.refs.every((ct) => !FQ(ct)) : !FQ(ze._f.ref)) && Y(Ne);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, d = (Ne, ze) => !e.disabled && (Ne && ze && Uo(i, Ne, ze), !gv(z(), a)), m = (Ne, ze, ct) => bnt(Ne, s, {
    ...o.mount ? i : sl(ze) ? a : nh(Ne) ? { [Ne]: ze } : ze
  }, ct, ze), v = (Ne) => oW(en(o.mount ? i : a, Ne, e.shouldUnregister ? en(a, Ne, []) : [])), k = (Ne, ze, ct = {}) => {
    const rt = en(n, Ne);
    let qe = ze;
    if (rt) {
      const nt = rt._f;
      nt && (!nt.disabled && Uo(i, Ne, knt(ze, nt)), qe = ZL(nt.ref) && yu(ze) ? "" : ze, wnt(nt.ref) ? [...nt.ref.options].forEach((Rt) => Rt.selected = qe.includes(Rt.value)) : nt.refs ? KM(nt.ref) ? nt.refs.length > 1 ? nt.refs.forEach((Rt) => (!Rt.defaultChecked || !Rt.disabled) && (Rt.checked = Array.isArray(qe) ? !!qe.find((Ot) => Ot === Rt.value) : qe === Rt.value)) : nt.refs[0] && (nt.refs[0].checked = !!qe) : nt.refs.forEach((Rt) => Rt.checked = Rt.value === qe) : Jme(nt.ref) ? nt.ref.value = "" : (nt.ref.value = qe, nt.ref.type || f.values.next({
        name: Ne,
        values: { ...i }
      })));
    }
    (ct.shouldDirty || ct.shouldTouch) && A(Ne, qe, ct.shouldTouch, ct.shouldDirty, !0), ct.shouldValidate && F(Ne);
  }, O = (Ne, ze, ct) => {
    for (const rt in ze) {
      const qe = ze[rt], nt = `${Ne}.${rt}`, Rt = en(n, nt);
      (s.array.has(Ne) || ul(qe) || Rt && !Rt._f) && !mb(qe) ? O(nt, qe, ct) : k(nt, qe, ct);
    }
  }, G = (Ne, ze, ct = {}) => {
    const rt = en(n, Ne), qe = s.array.has(Ne), nt = cd(ze);
    Uo(i, Ne, nt), qe ? (f.array.next({
      name: Ne,
      values: { ...i }
    }), (u.isDirty || u.dirtyFields) && ct.shouldDirty && f.state.next({
      name: Ne,
      dirtyFields: eS(a, i),
      isDirty: d(Ne, nt)
    })) : rt && !rt._f && !yu(nt) ? O(Ne, nt, ct) : k(Ne, nt, ct), EAe(Ne, s) && f.state.next({ ...r }), f.values.next({
      name: o.mount ? Ne : void 0,
      values: { ...i }
    });
  }, H = async (Ne) => {
    o.mount = !0;
    const ze = Ne.target;
    let ct = ze.name, rt = !0;
    const qe = en(n, ct), nt = () => ze.type ? zQ(qe._f) : hnt(Ne), Rt = (Ot) => {
      rt = Number.isNaN(Ot) || mb(Ot) && isNaN(Ot.getTime()) || gv(Ot, en(i, ct, Ot));
    };
    if (qe) {
      let Ot, lt;
      const mt = nt(), jt = Ne.type === KL.BLUR || Ne.type === KL.FOCUS_OUT, Jt = !jmr(qe._f) && !e.resolver && !en(r.errors, ct) && !qe._f.deps || Fmr(jt, en(r.touchedFields, ct), r.isSubmitted, p, h), ne = EAe(ct, s, jt);
      Uo(i, ct, mt), jt ? (qe._f.onBlur && qe._f.onBlur(Ne), l && l(0)) : qe._f.onChange && qe._f.onChange(Ne);
      const re = A(ct, mt, jt, !1), ie = !ud(re) || ne;
      if (!jt && f.values.next({
        name: ct,
        type: Ne.type,
        values: { ...i }
      }), Jt)
        return u.isValid && (e.mode === "onBlur" && jt ? b() : jt || b()), ie && f.state.next({ name: ct, ...ne ? {} : re });
      if (!jt && ne && f.state.next({ ...r }), e.resolver) {
        const { errors: Ie } = await M([ct]);
        if (Rt(mt), rt) {
          const Ke = NAe(r.errors, n, ct), Le = NAe(Ie, n, Ke.name || ct);
          Ot = Le.error, ct = Le.name, lt = ud(Ie);
        }
      } else
        w([ct], !0), Ot = (await OAe(qe, s.disabled, i, g, e.shouldUseNativeValidation))[ct], w([ct]), Rt(mt), rt && (Ot ? lt = !1 : u.isValid && (lt = await L(n, !0)));
      rt && (qe._f.deps && F(qe._f.deps), I(ct, lt, Ot, re));
    }
  }, j = (Ne, ze) => {
    if (en(r.errors, ze) && Ne.focus)
      return Ne.focus(), 1;
  }, F = async (Ne, ze = {}) => {
    let ct, rt;
    const qe = $_(Ne);
    if (e.resolver) {
      const nt = await B(sl(Ne) ? Ne : qe);
      ct = ud(nt), rt = Ne ? !qe.some((Rt) => en(nt, Rt)) : ct;
    } else Ne ? (rt = (await Promise.all(qe.map(async (nt) => {
      const Rt = en(n, nt);
      return await L(Rt && Rt._f ? { [nt]: Rt } : Rt);
    }))).every(Boolean), !(!rt && !r.isValid) && b()) : rt = ct = await L(n);
    return f.state.next({
      ...!nh(Ne) || u.isValid && ct !== r.isValid ? {} : { name: Ne },
      ...e.resolver || !Ne ? { isValid: ct } : {},
      errors: r.errors
    }), ze.shouldFocus && !rt && D_(n, j, Ne ? qe : s.mount), rt;
  }, z = (Ne) => {
    const ze = {
      ...o.mount ? i : a
    };
    return sl(Ne) ? ze : nh(Ne) ? en(ze, Ne) : Ne.map((ct) => en(ze, ct));
  }, W = (Ne, ze) => ({
    invalid: !!en((ze || r).errors, Ne),
    isDirty: !!en((ze || r).dirtyFields, Ne),
    error: en((ze || r).errors, Ne),
    isValidating: !!en(r.validatingFields, Ne),
    isTouched: !!en((ze || r).touchedFields, Ne)
  }), U = (Ne) => {
    Ne && $_(Ne).forEach((ze) => Fl(r.errors, ze)), f.state.next({
      errors: Ne ? r.errors : {}
    });
  }, Z = (Ne, ze, ct) => {
    const rt = (en(n, Ne, { _f: {} })._f || {}).ref, qe = en(r.errors, Ne) || {}, { ref: nt, message: Rt, type: Ot, ...lt } = qe;
    Uo(r.errors, Ne, {
      ...lt,
      ...ze,
      ref: rt
    }), f.state.next({
      name: Ne,
      errors: r.errors,
      isValid: !1
    }), ct && ct.shouldFocus && rt && rt.focus && rt.focus();
  }, V = (Ne, ze) => Q2(Ne) ? f.values.subscribe({
    next: (ct) => Ne(m(void 0, ze), ct)
  }) : m(Ne, ze, !0), Y = (Ne, ze = {}) => {
    for (const ct of Ne ? $_(Ne) : s.mount)
      s.mount.delete(ct), s.array.delete(ct), ze.keepValue || (Fl(n, ct), Fl(i, ct)), !ze.keepError && Fl(r.errors, ct), !ze.keepDirty && Fl(r.dirtyFields, ct), !ze.keepTouched && Fl(r.touchedFields, ct), !ze.keepIsValidating && Fl(r.validatingFields, ct), !e.shouldUnregister && !ze.keepDefaultValue && Fl(a, ct);
    f.values.next({
      values: { ...i }
    }), f.state.next({
      ...r,
      ...ze.keepDirty ? { isDirty: d() } : {}
    }), !ze.keepIsValid && b();
  }, ge = ({ disabled: Ne, name: ze, field: ct, fields: rt }) => {
    (W0(Ne) && o.mount || Ne || s.disabled.has(ze)) && (Ne ? s.disabled.add(ze) : s.disabled.delete(ze), A(ze, zQ(ct ? ct._f : en(rt, ze)._f), !1, !1, !0));
  }, ce = (Ne, ze = {}) => {
    let ct = en(n, Ne);
    const rt = W0(ze.disabled) || W0(e.disabled);
    return Uo(n, Ne, {
      ...ct || {},
      _f: {
        ...ct && ct._f ? ct._f : { ref: { name: Ne } },
        name: Ne,
        mount: !0,
        ...ze
      }
    }), s.mount.add(Ne), ct ? ge({
      field: ct,
      disabled: W0(ze.disabled) ? ze.disabled : e.disabled,
      name: Ne
    }) : S(Ne, !0, ze.value), {
      ...rt ? { disabled: ze.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!ze.required,
        min: tS(ze.min),
        max: tS(ze.max),
        minLength: tS(ze.minLength),
        maxLength: tS(ze.maxLength),
        pattern: tS(ze.pattern)
      } : {},
      name: Ne,
      onChange: H,
      onBlur: H,
      ref: (qe) => {
        if (qe) {
          ce(Ne, ze), ct = en(n, Ne);
          const nt = sl(qe.value) && qe.querySelectorAll && qe.querySelectorAll("input,select,textarea")[0] || qe, Rt = $mr(nt), Ot = ct._f.refs || [];
          if (Rt ? Ot.find((lt) => lt === nt) : nt === ct._f.ref)
            return;
          Uo(n, Ne, {
            _f: {
              ...ct._f,
              ...Rt ? {
                refs: [
                  ...Ot.filter(FQ),
                  nt,
                  ...Array.isArray(en(a, Ne)) ? [{}] : []
                ],
                ref: { type: nt.type, name: Ne }
              } : { ref: nt }
            }
          }), S(Ne, !1, void 0, nt);
        } else
          ct = en(n, Ne, {}), ct._f && (ct._f.mount = !1), (e.shouldUnregister || ze.shouldUnregister) && !(pnt(s.array, Ne) && o.action) && s.unMount.add(Ne);
      }
    };
  }, ee = () => e.shouldFocusError && D_(n, j, s.mount), Se = (Ne) => {
    W0(Ne) && (f.state.next({ disabled: Ne }), D_(n, (ze, ct) => {
      const rt = en(n, ct);
      rt && (ze.disabled = rt._f.disabled || Ne, Array.isArray(rt._f.refs) && rt._f.refs.forEach((qe) => {
        qe.disabled = rt._f.disabled || Ne;
      }));
    }, 0, !1));
  }, Ce = (Ne, ze) => async (ct) => {
    let rt;
    ct && (ct.preventDefault && ct.preventDefault(), ct.persist && ct.persist());
    let qe = cd(i);
    if (s.disabled.size)
      for (const nt of s.disabled)
        Uo(qe, nt, void 0);
    if (f.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: nt, values: Rt } = await M();
      r.errors = nt, qe = Rt;
    } else
      await L(n);
    if (Fl(r.errors, "root"), ud(r.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await Ne(qe, ct);
      } catch (nt) {
        rt = nt;
      }
    } else
      ze && await ze({ ...r.errors }, ct), ee(), setTimeout(ee);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ud(r.errors) && !rt,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), rt)
      throw rt;
  }, we = (Ne, ze = {}) => {
    en(n, Ne) && (sl(ze.defaultValue) ? G(Ne, cd(en(a, Ne))) : (G(Ne, ze.defaultValue), Uo(a, Ne, cd(ze.defaultValue))), ze.keepTouched || Fl(r.touchedFields, Ne), ze.keepDirty || (Fl(r.dirtyFields, Ne), r.isDirty = ze.defaultValue ? d(Ne, cd(en(a, Ne))) : d()), ze.keepError || (Fl(r.errors, Ne), u.isValid && b()), f.state.next({ ...r }));
  }, We = (Ne, ze = {}) => {
    const ct = Ne ? cd(Ne) : a, rt = cd(ct), qe = ud(Ne), nt = qe ? a : rt;
    if (ze.keepDefaultValues || (a = ct), !ze.keepValues) {
      if (ze.keepDirtyValues) {
        const Rt = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(eS(a, i))
        ]);
        for (const Ot of Array.from(Rt))
          en(r.dirtyFields, Ot) ? Uo(nt, Ot, en(i, Ot)) : G(Ot, en(nt, Ot));
      } else {
        if (Vme && sl(Ne))
          for (const Rt of s.mount) {
            const Ot = en(n, Rt);
            if (Ot && Ot._f) {
              const lt = Array.isArray(Ot._f.refs) ? Ot._f.refs[0] : Ot._f.ref;
              if (ZL(lt)) {
                const mt = lt.closest("form");
                if (mt) {
                  mt.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      i = e.shouldUnregister ? ze.keepDefaultValues ? cd(a) : {} : cd(nt), f.array.next({
        values: { ...nt }
      }), f.values.next({
        values: { ...nt }
      });
    }
    s = {
      mount: ze.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !u.isValid || !!ze.keepIsValid || !!ze.keepDirtyValues, o.watch = !!e.shouldUnregister, f.state.next({
      submitCount: ze.keepSubmitCount ? r.submitCount : 0,
      isDirty: qe ? !1 : ze.keepDirty ? r.isDirty : !!(ze.keepDefaultValues && !gv(Ne, a)),
      isSubmitted: ze.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: qe ? {} : ze.keepDirtyValues ? ze.keepDefaultValues && i ? eS(a, i) : r.dirtyFields : ze.keepDefaultValues && Ne ? eS(a, Ne) : ze.keepDirty ? r.dirtyFields : {},
      touchedFields: ze.keepTouched ? r.touchedFields : {},
      errors: ze.keepErrors ? r.errors : {},
      isSubmitSuccessful: ze.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Fe = (Ne, ze) => We(Q2(Ne) ? Ne(i) : Ne, ze);
  return {
    control: {
      register: ce,
      unregister: Y,
      getFieldState: W,
      handleSubmit: Ce,
      setError: Z,
      _executeSchema: M,
      _getWatch: m,
      _getDirty: d,
      _updateValid: b,
      _removeUnmounted: N,
      _updateFieldArray: _,
      _updateDisabledField: ge,
      _getFieldArray: v,
      _reset: We,
      _resetDefaultValues: () => Q2(e.defaultValues) && e.defaultValues().then((Ne) => {
        Fe(Ne, e.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (Ne) => {
        r = {
          ...r,
          ...Ne
        };
      },
      _disableForm: Se,
      _subjects: f,
      _proxyFormState: u,
      _setErrors: x,
      get _fields() {
        return n;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return o;
      },
      set _state(Ne) {
        o = Ne;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return s;
      },
      set _names(Ne) {
        s = Ne;
      },
      get _formState() {
        return r;
      },
      set _formState(Ne) {
        r = Ne;
      },
      get _options() {
        return e;
      },
      set _options(Ne) {
        e = {
          ...e,
          ...Ne
        };
      }
    },
    trigger: F,
    register: ce,
    handleSubmit: Ce,
    watch: V,
    setValue: G,
    getValues: z,
    reset: Fe,
    resetField: we,
    clearErrors: U,
    unregister: Y,
    setError: Z,
    setFocus: (Ne, ze = {}) => {
      const ct = en(n, Ne), rt = ct && ct._f;
      if (rt) {
        const qe = rt.refs ? rt.refs[0] : rt.ref;
        qe.focus && (qe.focus(), ze.shouldSelect && Q2(qe.select) && qe.select());
      }
    },
    getFieldState: W
  };
}
function Xme(t = {}) {
  const e = Te.useRef(void 0), r = Te.useRef(void 0), [n, a] = Te.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Q2(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    defaultValues: Q2(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...Wmr(t),
    formState: n
  });
  const i = e.current.control;
  return i._options = t, Zme({
    subject: i._subjects.state,
    next: (o) => {
      vnt(o, i._proxyFormState, i._updateFormState, !0) && a({ ...i._formState });
    }
  }), Te.useEffect(() => i._disableForm(t.disabled), [i, t.disabled]), Te.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const o = i._getDirty();
      o !== n.isDirty && i._subjects.state.next({
        isDirty: o
      });
    }
  }, [i, n.isDirty]), Te.useEffect(() => {
    t.values && !gv(t.values, r.current) ? (i._reset(t.values, i._options.resetOptions), r.current = t.values, a((o) => ({ ...o }))) : i._resetDefaultValues();
  }, [t.values, i]), Te.useEffect(() => {
    t.errors && i._setErrors(t.errors);
  }, [t.errors, i]), Te.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), Te.useEffect(() => {
    t.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [t.shouldUnregister, i]), e.current.formState = gnt(n, i), e.current;
}
var GQ = {}, Ant = P.forwardRef(({ element: t = "FORM", maxWidth: e, children: r, ...n }, a) => P.createElement(ht, { as: "form", ref: a, element: t, maxWidth: e, display: "flex", flexDirection: "column", rowGap: "space80", ...Xt(n) }, r));
Ant.displayName = "Form";
var Tnt = P.forwardRef(({ children: t, element: e = "FORM_ACTIONS", ...r }, n) => P.createElement(ht, { ref: n, element: e, ...Xt(r), display: "flex", flexDirection: "row", columnGap: "space40", marginTop: "space60" }, t));
Tnt.displayName = "FormActions";
var Ent = P.forwardRef(({ children: t, element: e = "FORM_CONTROL", ...r }, n) => P.createElement(ht, { ref: n, flexGrow: 1, element: e, ...Xt(r) }, t));
Ent.displayName = "FormControl";
var Int = P.forwardRef(({ children: t, element: e = "FORM_CONTROL_TWO_COLUMN", ...r }, n) => P.createElement(ht, { display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "space50", ref: n, element: e, ...Xt(r) }, t));
Int.displayName = "FormControlTwoColumn";
var Mnt = P.createContext({}), Pnt = P.forwardRef(({ children: t, element: e = "FORM_SECTION", id: r, ...n }, a) => {
  let i = r || Jr();
  return P.createElement(Mnt.Provider, { value: { id: i } }, P.createElement(ht, { as: "fieldset", border: "none", margin: "space0", padding: "space0", marginY: "space20", ref: a, element: e, display: "flex", flexDirection: "column", rowGap: "space80", _first: { marginTop: "space0" }, _last: { marginBottom: "space0" }, ...Xt(n), "aria-describedby": `${i}-section-description`, id: i }, t));
});
Pnt.displayName = "FormSection";
var Rnt = P.forwardRef(({ children: t, element: e = "FORM_SECTION_DESCRIPTION", ...r }, n) => {
  let { id: a } = P.useContext(Mnt);
  return P.createElement(ht, { ref: n, ...Xt(r), element: e, color: "colorText", fontSize: "fontSize30", lineHeight: "lineHeight20", id: `${a}-section-description` }, t);
});
Rnt.displayName = "FormSectionDescription";
var Ont = P.forwardRef(({ children: t, element: e = "FORM_SECTION_HEADING", variant: r = "heading40", ...n }, a) => P.createElement(ht, { as: "legend", ref: a, ...Xt(n), element: e, padding: "space0" }, P.createElement($8, { as: "span", variant: r }, t)));
Ont.displayName = "FormSectionHeading";
const Hmr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Form: Ant,
  FormActions: Tnt,
  FormControl: Ent,
  FormControlTwoColumn: Int,
  FormSection: Pnt,
  FormSectionDescription: Rnt,
  FormSectionHeading: Ont
}, Symbol.toStringTag, { value: "Module" })), Umr = /* @__PURE__ */ aa(Hmr);
var $Ae;
function Vmr() {
  return $Ae || ($Ae = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Umr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(GQ)), GQ;
}
var Y4 = /* @__PURE__ */ Vmr(), WQ = {};
const qmr = /* @__PURE__ */ aa(cur);
var DAe;
function Kmr() {
  return DAe || (DAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = qmr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(WQ)), WQ;
}
var Db = /* @__PURE__ */ Kmr(), HQ = {}, Zmr = Object.create, Bnt = Object.defineProperty, Jmr = Object.getOwnPropertyDescriptor, Nnt = Object.getOwnPropertyNames, Ymr = Object.getPrototypeOf, Xmr = Object.prototype.hasOwnProperty, Qr = (t, e) => function() {
  return e || (0, t[Nnt(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, Qmr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Nnt(e)) !Xmr.call(t, a) && a !== r && Bnt(t, a, { get: () => e[a], enumerable: !(n = Jmr(e, a)) || n.enumerable });
  return t;
}, egr = (t, e, r) => (r = t != null ? Zmr(Ymr(t)) : {}, Qmr(!t || !t.__esModule ? Bnt(r, "default", { value: t, enumerable: !0 }) : r, t)), ZM = Qr({ "../../../node_modules/lodash/isArray.js"(t, e) {
  var r = Array.isArray;
  e.exports = r;
} }), tgr = Qr({ "../../../node_modules/lodash/_freeGlobal.js"(t, e) {
  var r = typeof ss == "object" && ss && ss.Object === Object && ss;
  e.exports = r;
} }), Qme = Qr({ "../../../node_modules/lodash/_root.js"(t, e) {
  var r = tgr(), n = typeof self == "object" && self && self.Object === Object && self, a = r || n || Function("return this")();
  e.exports = a;
} }), sW = Qr({ "../../../node_modules/lodash/_Symbol.js"(t, e) {
  var r = Qme(), n = r.Symbol;
  e.exports = n;
} }), rgr = Qr({ "../../../node_modules/lodash/_getRawTag.js"(t, e) {
  var r = sW(), n = Object.prototype, a = n.hasOwnProperty, i = n.toString, o = r ? r.toStringTag : void 0;
  function s(l) {
    var c = a.call(l, o), u = l[o];
    try {
      l[o] = void 0;
      var f = !0;
    } catch {
    }
    var h = i.call(l);
    return f && (c ? l[o] = u : delete l[o]), h;
  }
  e.exports = s;
} }), ngr = Qr({ "../../../node_modules/lodash/_objectToString.js"(t, e) {
  var r = Object.prototype, n = r.toString;
  function a(i) {
    return n.call(i);
  }
  e.exports = a;
} }), ege = Qr({ "../../../node_modules/lodash/_baseGetTag.js"(t, e) {
  var r = sW(), n = rgr(), a = ngr(), i = "[object Null]", o = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : i : s && s in Object(c) ? n(c) : a(c);
  }
  e.exports = l;
} }), tge = Qr({ "../../../node_modules/lodash/isObjectLike.js"(t, e) {
  function r(n) {
    return n != null && typeof n == "object";
  }
  e.exports = r;
} }), rge = Qr({ "../../../node_modules/lodash/isSymbol.js"(t, e) {
  var r = ege(), n = tge(), a = "[object Symbol]";
  function i(o) {
    return typeof o == "symbol" || n(o) && r(o) == a;
  }
  e.exports = i;
} }), agr = Qr({ "../../../node_modules/lodash/_isKey.js"(t, e) {
  var r = ZM(), n = rge(), a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function o(s, l) {
    if (r(s)) return !1;
    var c = typeof s;
    return c == "number" || c == "symbol" || c == "boolean" || s == null || n(s) ? !0 : i.test(s) || !a.test(s) || l != null && s in Object(l);
  }
  e.exports = o;
} }), nge = Qr({ "../../../node_modules/lodash/isObject.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return n != null && (a == "object" || a == "function");
  }
  e.exports = r;
} }), igr = Qr({ "../../../node_modules/lodash/isFunction.js"(t, e) {
  var r = ege(), n = nge(), a = "[object AsyncFunction]", i = "[object Function]", o = "[object GeneratorFunction]", s = "[object Proxy]";
  function l(c) {
    if (!n(c)) return !1;
    var u = r(c);
    return u == i || u == o || u == a || u == s;
  }
  e.exports = l;
} }), ogr = Qr({ "../../../node_modules/lodash/_coreJsData.js"(t, e) {
  var r = Qme(), n = r["__core-js_shared__"];
  e.exports = n;
} }), sgr = Qr({ "../../../node_modules/lodash/_isMasked.js"(t, e) {
  var r = ogr(), n = function() {
    var i = /[^.]+$/.exec(r && r.keys && r.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function a(i) {
    return !!n && n in i;
  }
  e.exports = a;
} }), lgr = Qr({ "../../../node_modules/lodash/_toSource.js"(t, e) {
  var r = Function.prototype, n = r.toString;
  function a(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  e.exports = a;
} }), cgr = Qr({ "../../../node_modules/lodash/_baseIsNative.js"(t, e) {
  var r = igr(), n = sgr(), a = nge(), i = lgr(), o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, l = Function.prototype, c = Object.prototype, u = l.toString, f = c.hasOwnProperty, h = RegExp("^" + u.call(f).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  function p(g) {
    if (!a(g) || n(g)) return !1;
    var y = r(g) ? h : s;
    return y.test(i(g));
  }
  e.exports = p;
} }), ugr = Qr({ "../../../node_modules/lodash/_getValue.js"(t, e) {
  function r(n, a) {
    return n == null ? void 0 : n[a];
  }
  e.exports = r;
} }), age = Qr({ "../../../node_modules/lodash/_getNative.js"(t, e) {
  var r = cgr(), n = ugr();
  function a(i, o) {
    var s = n(i, o);
    return r(s) ? s : void 0;
  }
  e.exports = a;
} }), lW = Qr({ "../../../node_modules/lodash/_nativeCreate.js"(t, e) {
  var r = age(), n = r(Object, "create");
  e.exports = n;
} }), dgr = Qr({ "../../../node_modules/lodash/_hashClear.js"(t, e) {
  var r = lW();
  function n() {
    this.__data__ = r ? r(null) : {}, this.size = 0;
  }
  e.exports = n;
} }), fgr = Qr({ "../../../node_modules/lodash/_hashDelete.js"(t, e) {
  function r(n) {
    var a = this.has(n) && delete this.__data__[n];
    return this.size -= a ? 1 : 0, a;
  }
  e.exports = r;
} }), hgr = Qr({ "../../../node_modules/lodash/_hashGet.js"(t, e) {
  var r = lW(), n = "__lodash_hash_undefined__", a = Object.prototype, i = a.hasOwnProperty;
  function o(s) {
    var l = this.__data__;
    if (r) {
      var c = l[s];
      return c === n ? void 0 : c;
    }
    return i.call(l, s) ? l[s] : void 0;
  }
  e.exports = o;
} }), pgr = Qr({ "../../../node_modules/lodash/_hashHas.js"(t, e) {
  var r = lW(), n = Object.prototype, a = n.hasOwnProperty;
  function i(o) {
    var s = this.__data__;
    return r ? s[o] !== void 0 : a.call(s, o);
  }
  e.exports = i;
} }), mgr = Qr({ "../../../node_modules/lodash/_hashSet.js"(t, e) {
  var r = lW(), n = "__lodash_hash_undefined__";
  function a(i, o) {
    var s = this.__data__;
    return this.size += this.has(i) ? 0 : 1, s[i] = r && o === void 0 ? n : o, this;
  }
  e.exports = a;
} }), ggr = Qr({ "../../../node_modules/lodash/_Hash.js"(t, e) {
  var r = dgr(), n = fgr(), a = hgr(), i = pgr(), o = mgr();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), vgr = Qr({ "../../../node_modules/lodash/_listCacheClear.js"(t, e) {
  function r() {
    this.__data__ = [], this.size = 0;
  }
  e.exports = r;
} }), $nt = Qr({ "../../../node_modules/lodash/eq.js"(t, e) {
  function r(n, a) {
    return n === a || n !== n && a !== a;
  }
  e.exports = r;
} }), cW = Qr({ "../../../node_modules/lodash/_assocIndexOf.js"(t, e) {
  var r = $nt();
  function n(a, i) {
    for (var o = a.length; o--; ) if (r(a[o][0], i)) return o;
    return -1;
  }
  e.exports = n;
} }), ygr = Qr({ "../../../node_modules/lodash/_listCacheDelete.js"(t, e) {
  var r = cW(), n = Array.prototype, a = n.splice;
  function i(o) {
    var s = this.__data__, l = r(s, o);
    if (l < 0) return !1;
    var c = s.length - 1;
    return l == c ? s.pop() : a.call(s, l, 1), --this.size, !0;
  }
  e.exports = i;
} }), bgr = Qr({ "../../../node_modules/lodash/_listCacheGet.js"(t, e) {
  var r = cW();
  function n(a) {
    var i = this.__data__, o = r(i, a);
    return o < 0 ? void 0 : i[o][1];
  }
  e.exports = n;
} }), xgr = Qr({ "../../../node_modules/lodash/_listCacheHas.js"(t, e) {
  var r = cW();
  function n(a) {
    return r(this.__data__, a) > -1;
  }
  e.exports = n;
} }), Cgr = Qr({ "../../../node_modules/lodash/_listCacheSet.js"(t, e) {
  var r = cW();
  function n(a, i) {
    var o = this.__data__, s = r(o, a);
    return s < 0 ? (++this.size, o.push([a, i])) : o[s][1] = i, this;
  }
  e.exports = n;
} }), wgr = Qr({ "../../../node_modules/lodash/_ListCache.js"(t, e) {
  var r = vgr(), n = ygr(), a = bgr(), i = xgr(), o = Cgr();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Sgr = Qr({ "../../../node_modules/lodash/_Map.js"(t, e) {
  var r = age(), n = Qme(), a = r(n, "Map");
  e.exports = a;
} }), _gr = Qr({ "../../../node_modules/lodash/_mapCacheClear.js"(t, e) {
  var r = ggr(), n = wgr(), a = Sgr();
  function i() {
    this.size = 0, this.__data__ = { hash: new r(), map: new (a || n)(), string: new r() };
  }
  e.exports = i;
} }), kgr = Qr({ "../../../node_modules/lodash/_isKeyable.js"(t, e) {
  function r(n) {
    var a = typeof n;
    return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? n !== "__proto__" : n === null;
  }
  e.exports = r;
} }), uW = Qr({ "../../../node_modules/lodash/_getMapData.js"(t, e) {
  var r = kgr();
  function n(a, i) {
    var o = a.__data__;
    return r(i) ? o[typeof i == "string" ? "string" : "hash"] : o.map;
  }
  e.exports = n;
} }), Agr = Qr({ "../../../node_modules/lodash/_mapCacheDelete.js"(t, e) {
  var r = uW();
  function n(a) {
    var i = r(this, a).delete(a);
    return this.size -= i ? 1 : 0, i;
  }
  e.exports = n;
} }), Tgr = Qr({ "../../../node_modules/lodash/_mapCacheGet.js"(t, e) {
  var r = uW();
  function n(a) {
    return r(this, a).get(a);
  }
  e.exports = n;
} }), Egr = Qr({ "../../../node_modules/lodash/_mapCacheHas.js"(t, e) {
  var r = uW();
  function n(a) {
    return r(this, a).has(a);
  }
  e.exports = n;
} }), Igr = Qr({ "../../../node_modules/lodash/_mapCacheSet.js"(t, e) {
  var r = uW();
  function n(a, i) {
    var o = r(this, a), s = o.size;
    return o.set(a, i), this.size += o.size == s ? 0 : 1, this;
  }
  e.exports = n;
} }), Mgr = Qr({ "../../../node_modules/lodash/_MapCache.js"(t, e) {
  var r = _gr(), n = Agr(), a = Tgr(), i = Egr(), o = Igr();
  function s(l) {
    var c = -1, u = l == null ? 0 : l.length;
    for (this.clear(); ++c < u; ) {
      var f = l[c];
      this.set(f[0], f[1]);
    }
  }
  s.prototype.clear = r, s.prototype.delete = n, s.prototype.get = a, s.prototype.has = i, s.prototype.set = o, e.exports = s;
} }), Pgr = Qr({ "../../../node_modules/lodash/memoize.js"(t, e) {
  var r = Mgr(), n = "Expected a function";
  function a(i, o) {
    if (typeof i != "function" || o != null && typeof o != "function") throw new TypeError(n);
    var s = function() {
      var l = arguments, c = o ? o.apply(this, l) : l[0], u = s.cache;
      if (u.has(c)) return u.get(c);
      var f = i.apply(this, l);
      return s.cache = u.set(c, f) || u, f;
    };
    return s.cache = new (a.Cache || r)(), s;
  }
  a.Cache = r, e.exports = a;
} }), Rgr = Qr({ "../../../node_modules/lodash/_memoizeCapped.js"(t, e) {
  var r = Pgr(), n = 500;
  function a(i) {
    var o = r(i, function(l) {
      return s.size === n && s.clear(), l;
    }), s = o.cache;
    return o;
  }
  e.exports = a;
} }), Ogr = Qr({ "../../../node_modules/lodash/_stringToPath.js"(t, e) {
  var r = Rgr(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a = /\\(\\)?/g, i = r(function(o) {
    var s = [];
    return o.charCodeAt(0) === 46 && s.push(""), o.replace(n, function(l, c, u, f) {
      s.push(u ? f.replace(a, "$1") : c || l);
    }), s;
  });
  e.exports = i;
} }), Bgr = Qr({ "../../../node_modules/lodash/_arrayMap.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = n == null ? 0 : n.length, s = Array(o); ++i < o; ) s[i] = a(n[i], i, n);
    return s;
  }
  e.exports = r;
} }), Ngr = Qr({ "../../../node_modules/lodash/_baseToString.js"(t, e) {
  var r = sW(), n = Bgr(), a = ZM(), i = rge(), o = r ? r.prototype : void 0, s = o ? o.toString : void 0;
  function l(c) {
    if (typeof c == "string") return c;
    if (a(c)) return n(c, l) + "";
    if (i(c)) return s ? s.call(c) : "";
    var u = c + "";
    return u == "0" && 1 / c == -1 / 0 ? "-0" : u;
  }
  e.exports = l;
} }), $gr = Qr({ "../../../node_modules/lodash/toString.js"(t, e) {
  var r = Ngr();
  function n(a) {
    return a == null ? "" : r(a);
  }
  e.exports = n;
} }), dW = Qr({ "../../../node_modules/lodash/_castPath.js"(t, e) {
  var r = ZM(), n = agr(), a = Ogr(), i = $gr();
  function o(s, l) {
    return r(s) ? s : n(s, l) ? [s] : a(i(s));
  }
  e.exports = o;
} }), ige = Qr({ "../../../node_modules/lodash/_toKey.js"(t, e) {
  var r = rge();
  function n(a) {
    if (typeof a == "string" || r(a)) return a;
    var i = a + "";
    return i == "0" && 1 / a == -1 / 0 ? "-0" : i;
  }
  e.exports = n;
} }), Dgr = Qr({ "../../../node_modules/lodash/_baseGet.js"(t, e) {
  var r = dW(), n = ige();
  function a(i, o) {
    o = r(o, i);
    for (var s = 0, l = o.length; i != null && s < l; ) i = i[n(o[s++])];
    return s && s == l ? i : void 0;
  }
  e.exports = a;
} }), Dnt = Qr({ "../../../node_modules/lodash/_defineProperty.js"(t, e) {
  var r = age(), n = function() {
    try {
      var a = r(Object, "defineProperty");
      return a({}, "", {}), a;
    } catch {
    }
  }();
  e.exports = n;
} }), Lgr = Qr({ "../../../node_modules/lodash/_baseAssignValue.js"(t, e) {
  var r = Dnt();
  function n(a, i, o) {
    i == "__proto__" && r ? r(a, i, { configurable: !0, enumerable: !0, value: o, writable: !0 }) : a[i] = o;
  }
  e.exports = n;
} }), jgr = Qr({ "../../../node_modules/lodash/_assignValue.js"(t, e) {
  var r = Lgr(), n = $nt(), a = Object.prototype, i = a.hasOwnProperty;
  function o(s, l, c) {
    var u = s[l];
    (!(i.call(s, l) && n(u, c)) || c === void 0 && !(l in s)) && r(s, l, c);
  }
  e.exports = o;
} }), Lnt = Qr({ "../../../node_modules/lodash/_isIndex.js"(t, e) {
  var r = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function a(i, o) {
    var s = typeof i;
    return o = o ?? r, !!o && (s == "number" || s != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < o;
  }
  e.exports = a;
} }), Fgr = Qr({ "../../../node_modules/lodash/_baseSet.js"(t, e) {
  var r = jgr(), n = dW(), a = Lnt(), i = nge(), o = ige();
  function s(l, c, u, f) {
    if (!i(l)) return l;
    c = n(c, l);
    for (var h = -1, p = c.length, g = p - 1, y = l; y != null && ++h < p; ) {
      var b = o(c[h]), w = u;
      if (b === "__proto__" || b === "constructor" || b === "prototype") return l;
      if (h != g) {
        var _ = y[b];
        w = f ? f(_, b, y) : void 0, w === void 0 && (w = i(_) ? _ : a(c[h + 1]) ? [] : {});
      }
      r(y, b, w), y = y[b];
    }
    return l;
  }
  e.exports = s;
} }), zgr = Qr({ "../../../node_modules/lodash/_basePickBy.js"(t, e) {
  var r = Dgr(), n = Fgr(), a = dW();
  function i(o, s, l) {
    for (var c = -1, u = s.length, f = {}; ++c < u; ) {
      var h = s[c], p = r(o, h);
      l(p, h) && n(f, a(h, o), p);
    }
    return f;
  }
  e.exports = i;
} }), Ggr = Qr({ "../../../node_modules/lodash/_baseHasIn.js"(t, e) {
  function r(n, a) {
    return n != null && a in Object(n);
  }
  e.exports = r;
} }), Wgr = Qr({ "../../../node_modules/lodash/_baseIsArguments.js"(t, e) {
  var r = ege(), n = tge(), a = "[object Arguments]";
  function i(o) {
    return n(o) && r(o) == a;
  }
  e.exports = i;
} }), jnt = Qr({ "../../../node_modules/lodash/isArguments.js"(t, e) {
  var r = Wgr(), n = tge(), a = Object.prototype, i = a.hasOwnProperty, o = a.propertyIsEnumerable, s = r(/* @__PURE__ */ function() {
    return arguments;
  }()) ? r : function(l) {
    return n(l) && i.call(l, "callee") && !o.call(l, "callee");
  };
  e.exports = s;
} }), Hgr = Qr({ "../../../node_modules/lodash/isLength.js"(t, e) {
  var r = 9007199254740991;
  function n(a) {
    return typeof a == "number" && a > -1 && a % 1 == 0 && a <= r;
  }
  e.exports = n;
} }), Ugr = Qr({ "../../../node_modules/lodash/_hasPath.js"(t, e) {
  var r = dW(), n = jnt(), a = ZM(), i = Lnt(), o = Hgr(), s = ige();
  function l(c, u, f) {
    u = r(u, c);
    for (var h = -1, p = u.length, g = !1; ++h < p; ) {
      var y = s(u[h]);
      if (!(g = c != null && f(c, y))) break;
      c = c[y];
    }
    return g || ++h != p ? g : (p = c == null ? 0 : c.length, !!p && o(p) && i(y, p) && (a(c) || n(c)));
  }
  e.exports = l;
} }), Vgr = Qr({ "../../../node_modules/lodash/hasIn.js"(t, e) {
  var r = Ggr(), n = Ugr();
  function a(i, o) {
    return i != null && n(i, o, r);
  }
  e.exports = a;
} }), qgr = Qr({ "../../../node_modules/lodash/_basePick.js"(t, e) {
  var r = zgr(), n = Vgr();
  function a(i, o) {
    return r(i, o, function(s, l) {
      return n(i, l);
    });
  }
  e.exports = a;
} }), Kgr = Qr({ "../../../node_modules/lodash/_arrayPush.js"(t, e) {
  function r(n, a) {
    for (var i = -1, o = a.length, s = n.length; ++i < o; ) n[s + i] = a[i];
    return n;
  }
  e.exports = r;
} }), Zgr = Qr({ "../../../node_modules/lodash/_isFlattenable.js"(t, e) {
  var r = sW(), n = jnt(), a = ZM(), i = r ? r.isConcatSpreadable : void 0;
  function o(s) {
    return a(s) || n(s) || !!(i && s && s[i]);
  }
  e.exports = o;
} }), Jgr = Qr({ "../../../node_modules/lodash/_baseFlatten.js"(t, e) {
  var r = Kgr(), n = Zgr();
  function a(i, o, s, l, c) {
    var u = -1, f = i.length;
    for (s || (s = n), c || (c = []); ++u < f; ) {
      var h = i[u];
      o > 0 && s(h) ? o > 1 ? a(h, o - 1, s, l, c) : r(c, h) : l || (c[c.length] = h);
    }
    return c;
  }
  e.exports = a;
} }), Ygr = Qr({ "../../../node_modules/lodash/flatten.js"(t, e) {
  var r = Jgr();
  function n(a) {
    var i = a == null ? 0 : a.length;
    return i ? r(a, 1) : [];
  }
  e.exports = n;
} }), Xgr = Qr({ "../../../node_modules/lodash/_apply.js"(t, e) {
  function r(n, a, i) {
    switch (i.length) {
      case 0:
        return n.call(a);
      case 1:
        return n.call(a, i[0]);
      case 2:
        return n.call(a, i[0], i[1]);
      case 3:
        return n.call(a, i[0], i[1], i[2]);
    }
    return n.apply(a, i);
  }
  e.exports = r;
} }), Qgr = Qr({ "../../../node_modules/lodash/_overRest.js"(t, e) {
  var r = Xgr(), n = Math.max;
  function a(i, o, s) {
    return o = n(o === void 0 ? i.length - 1 : o, 0), function() {
      for (var l = arguments, c = -1, u = n(l.length - o, 0), f = Array(u); ++c < u; ) f[c] = l[o + c];
      c = -1;
      for (var h = Array(o + 1); ++c < o; ) h[c] = l[c];
      return h[o] = s(f), r(i, this, h);
    };
  }
  e.exports = a;
} }), evr = Qr({ "../../../node_modules/lodash/constant.js"(t, e) {
  function r(n) {
    return function() {
      return n;
    };
  }
  e.exports = r;
} }), tvr = Qr({ "../../../node_modules/lodash/identity.js"(t, e) {
  function r(n) {
    return n;
  }
  e.exports = r;
} }), rvr = Qr({ "../../../node_modules/lodash/_baseSetToString.js"(t, e) {
  var r = evr(), n = Dnt(), a = tvr(), i = n ? function(o, s) {
    return n(o, "toString", { configurable: !0, enumerable: !1, value: r(s), writable: !0 });
  } : a;
  e.exports = i;
} }), nvr = Qr({ "../../../node_modules/lodash/_shortOut.js"(t, e) {
  var r = 800, n = 16, a = Date.now;
  function i(o) {
    var s = 0, l = 0;
    return function() {
      var c = a(), u = n - (c - l);
      if (l = c, u > 0) {
        if (++s >= r) return arguments[0];
      } else s = 0;
      return o.apply(void 0, arguments);
    };
  }
  e.exports = i;
} }), avr = Qr({ "../../../node_modules/lodash/_setToString.js"(t, e) {
  var r = rvr(), n = nvr(), a = n(r);
  e.exports = a;
} }), ivr = Qr({ "../../../node_modules/lodash/_flatRest.js"(t, e) {
  var r = Ygr(), n = Qgr(), a = avr();
  function i(o) {
    return a(n(o, void 0, r), o + "");
  }
  e.exports = i;
} }), ovr = Qr({ "../../../node_modules/lodash/pick.js"(t, e) {
  var r = qgr(), n = ivr(), a = n(function(i, o) {
    return i == null ? {} : r(i, o);
  });
  e.exports = a;
} }), LAe = { "min-height": "0", "max-height": "none", height: "0", visibility: "hidden", overflow: "hidden", position: "absolute", "z-index": "-1000", top: "0", right: "0" }, Fnt = (t) => {
  Object.keys(LAe).forEach((e) => {
    t.style.setProperty(e, LAe[e], "important");
  });
}, svr = (t, e) => {
  let r = t.scrollHeight;
  return e.sizingStyle.boxSizing === "border-box" ? r + e.borderSize : r - e.paddingSize;
};
function lvr(t, e, r, n = 1, a = 999) {
  let { paddingSize: i, borderSize: o, sizingStyle: s } = e, { boxSizing: l } = s;
  if (t == null) return [0, 0];
  Object.keys(s).forEach((p) => {
    let g = p;
    t.style[g] = s[g];
  }), Fnt(t), t.value = r;
  let c = svr(t, e);
  t.value = "x";
  let u = Math.max(t.scrollHeight - i, 0), f = u * n;
  l === "border-box" && (f = f + i + o), c = Math.max(f, c);
  let h = u * a;
  return l === "border-box" && (h = h + i + o), c = Math.max(Math.min(h, c), 0), [c, u];
}
var cvr = egr(ovr()), uvr = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width", "wordBreak"], dvr = typeof document < "u" ? !!document.documentElement.currentStyle : !1, fvr = (t) => {
  let e = window.getComputedStyle(t);
  if (e === null) return null;
  let r = (0, cvr.default)(e, uvr), { borderBottomWidth: n, borderLeftWidth: a, borderRightWidth: i, borderTopWidth: o, boxSizing: s, paddingBottom: l, paddingLeft: c, paddingRight: u, paddingTop: f, width: h } = r;
  if (s === "") return null;
  if (dvr && s === "border-box") {
    let y = Number.parseFloat(h) + Number.parseFloat(i) + Number.parseFloat(a) + Number.parseFloat(u) + Number.parseFloat(c);
    r.width = `${y}px`;
  }
  let p = Number.parseFloat(l) + Number.parseFloat(f), g = Number.parseFloat(n) + Number.parseFloat(o);
  return { sizingStyle: r, paddingSize: p, borderSize: g };
}, hvr = () => {
  let [t, e] = Te.useState(null);
  return Te.useEffect(() => {
    let r = document.createElement("textarea");
    return r.setAttribute("tabindex", "-1"), r.setAttribute("aria-hidden", "true"), Fnt(r), document.body.append(r), e(r), () => {
      r.remove(), e(null);
    };
  }, []), t;
}, pvr = qh, mvr = pvr, gvr = function(t) {
  var e = P.useRef(t);
  return mvr(function() {
    e.current = t;
  }), e;
}, vvr = (t) => {
  let e = gvr(t);
  P.useLayoutEffect(() => {
    let r = (n) => {
      e.current(n);
    };
    return window.addEventListener("resize", r), () => {
      window.removeEventListener("resize", r);
    };
  }, []);
}, znt = ({ cacheMeasurements: t, maxRows: e, minRows: r, onChange: n = () => {
}, onHeightChange: a = () => {
}, ...i }, o) => {
  let s = i.value !== void 0 && n !== void 0, l = P.useRef(null), c = Aet(l, o), u = P.useRef(0), f = P.useRef(void 0), h = hvr(), p = () => {
    let y = l.current, b = t && f.current ? f.current : fvr(y);
    if (!b) return;
    f.current = b;
    let [w, _] = lvr(h, b, y.value || y.placeholder || "x", r, e);
    u.current !== w && (u.current = w, y.style.setProperty("height", `${w}px`, "important"), a(w, { rowHeight: _ }));
  }, g = (y) => {
    var w;
    let b = ((w = l.current) == null ? void 0 : w.style.getPropertyPriority("height")) !== "important";
    !s && !b && p(), n(y);
  };
  return typeof document < "u" && (P.useLayoutEffect(p), vvr(p)), P.createElement("textarea", { ...i, onChange: g, ref: c });
};
znt.displayName = "TexareaAutosize";
var yvr = P.forwardRef(znt), bvr = ds(yvr)((t) => us({ appearance: "none", background: "transparent", border: "none", borderRadius: "borderRadius20", boxShadow: "none", color: "inherit", display: "block", fontFamily: "inherit", fontSize: "fontSize30", fontWeight: "fontWeightMedium", lineHeight: "lineHeight20", outline: "none", paddingBottom: "space30", paddingLeft: "space40", paddingRight: "space40", paddingTop: "space30", resize: t.resize, width: "100%", "&::placeholder": { color: t.variant === "inverse" ? "colorTextInverseWeaker" : "colorTextWeak", fontStyle: "italic" }, "&:focus::placeholder": { color: t.variant === "inverse" ? "colorTextInverseWeaker" : "colorTextWeak" }, "&:disabled": { color: t.variant === "inverse" ? "colorTextInverseWeakest" : "colorTextWeaker", cursor: "not-allowed", "-webkit-text-fill-color": t.variant === "inverse" ? "colorTextInverseWeakest" : "colorTextWeaker", "-webkit-opacity": "1" } }), Oz), Gnt = P.forwardRef(({ children: t, disabled: e, element: r = "TEXTAREA", hasError: n, insertBefore: a, insertAfter: i, readOnly: o, variant: s, resize: l = "none", maxRows: c = 10, size: u, height: f, width: h, ...p }, g) => P.createElement(M8, { disabled: e, element: r, hasError: n, insertAfter: i, insertBefore: a, readOnly: o, variant: s }, P.createElement(bvr, { ...Xt(p), "aria-invalid": n, "aria-readonly": o, disabled: e, "data-paste-element": `${r}_ELEMENT`, readOnly: o, ref: g, rows: 3, minRows: 3, maxRows: c, spellCheck: !0, resize: l, variant: s }, t)));
Gnt.displayName = "TextArea";
const xvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextArea: Gnt
}, Symbol.toStringTag, { value: "Module" })), Cvr = /* @__PURE__ */ aa(xvr);
var jAe;
function wvr() {
  return jAe || (jAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Cvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(HQ)), HQ;
}
var oge = /* @__PURE__ */ wvr(), UQ = {};
const Svr = /* @__PURE__ */ aa(n0r);
var FAe;
function _vr() {
  return FAe || (FAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Svr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(UQ)), UQ;
}
var Kue = /* @__PURE__ */ _vr(), VQ = {};
const sge = /* @__PURE__ */ aa(LBt);
var zAe;
function kvr() {
  return zAe || (zAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = sge;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(VQ)), VQ;
}
var Avr = /* @__PURE__ */ kvr(), qQ = {};
const Tvr = /* @__PURE__ */ aa(nur);
var GAe;
function Evr() {
  return GAe || (GAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Tvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(qQ)), qQ;
}
var g$ = /* @__PURE__ */ Evr();
const Lb = 4e3, KQ = 10, Gd = {
  LIST: "LIST",
  CREATE: "CREATE",
  EDIT: "EDIT",
  RUN: "RUN"
}, n_ = {
  USER: "USER",
  GLOBAL: "GLOBAL"
}, D0 = {
  nameField: {
    label: "name",
    capLabel: "Name",
    helpText: "Enter a shortcut name",
    validation: {
      required: "Enter a shortcut name",
      minLength: {
        value: 3,
        message: "Name is too short. Name must be at least 3 characters"
      },
      maxLength: {
        value: 50,
        message: "Name is too long. Name must be at most 50 characters"
      }
    }
  },
  descriptionField: {
    label: "description",
    capLabel: "Description",
    helpText: "Enter a detailed description of the prompt",
    validation: {
      required: "Enter a detailed description of the prompt",
      minLength: {
        value: 3,
        message: "Description is too short. Description must be at least 3 characters"
      },
      maxLength: {
        value: 200,
        message: "Description is too long. Description must be at most 200 characters"
      }
    }
  },
  promptField: {
    label: "template",
    capLabel: "Prompt",
    helpText: "Enter full prompt",
    validation: {
      required: "Enter full prompt",
      minLength: {
        value: 10,
        message: "Prompt is too short. Prompt must be at least 10 characters"
      },
      maxLength: {
        value: 2e3,
        message: "Prompt is too long. Prompt must be at most 2000 characters"
      }
    }
  }
}, WAe = ({
  prompt: t,
  onPromptSaved: e,
  onCancelClicked: r
}) => {
  const n = Avr.useUIDSeed(), a = yW(), [i, { isLoading: o }] = ePt(), [s, { isLoading: l }] = tPt(), { requestTransformer: c } = Ja(), {
    register: u,
    handleSubmit: f,
    formState: { errors: h, isSubmitting: p }
  } = Xme({
    defaultValues: t ? {
      name: t.name,
      description: t.description,
      template: t.template
    } : void 0
  }), g = async (y) => {
    if (t) {
      const b = { ...t, ...y };
      try {
        const w = await s({
          body: b,
          id: t.id,
          requestTransformer: c
        }).unwrap();
        e(w.prompt, !1);
      } catch {
        a.push({
          message: jb("", `Failed to update prompt ${t.name}`),
          variant: "error",
          dismissAfter: Lb
        });
      }
    } else {
      const b = {
        ...y,
        type: n_.USER,
        variables: [],
        applicationIds: []
      };
      try {
        const w = await i({
          body: b,
          requestTransformer: c
        }).unwrap();
        e(w.prompt, !0);
      } catch {
        a.push({
          message: jb(
            "",
            `Failed to save new prompt ${b.name}`
          ),
          variant: "error",
          dismissAfter: Lb
        });
      }
    }
  };
  return /* @__PURE__ */ R.jsx(
    Y4.Form,
    {
      onSubmit: f(g),
      "aria-labelledby": n("create-prompt"),
      children: /* @__PURE__ */ R.jsxs(Y4.FormSection, { children: [
        /* @__PURE__ */ R.jsxs(Y4.FormControl, { children: [
          /* @__PURE__ */ R.jsx(Db.Label, { htmlFor: n("name"), children: D0.nameField.capLabel }),
          /* @__PURE__ */ R.jsx(
            Kue.Input,
            {
              ...u("name", D0.nameField.validation),
              id: n("name"),
              name: D0.nameField.label,
              type: "text"
            }
          ),
          /* @__PURE__ */ R.jsx(g$.HelpText, { variant: h.name ? "error" : "default", children: h.name ? h.name.message : D0.nameField.helpText })
        ] }),
        /* @__PURE__ */ R.jsxs(Y4.FormControl, { children: [
          /* @__PURE__ */ R.jsx(Db.Label, { htmlFor: n("description"), children: D0.descriptionField.capLabel }),
          /* @__PURE__ */ R.jsx(
            Kue.Input,
            {
              ...u(
                "description",
                D0.descriptionField.validation
              ),
              id: n("description"),
              name: D0.descriptionField.label,
              type: "text"
            }
          ),
          /* @__PURE__ */ R.jsx(g$.HelpText, { variant: h.description ? "error" : "default", children: h.description ? h.description.message : D0.descriptionField.helpText })
        ] }),
        /* @__PURE__ */ R.jsxs(Y4.FormControl, { children: [
          /* @__PURE__ */ R.jsx(Db.Label, { htmlFor: n("template"), children: D0.promptField.capLabel }),
          /* @__PURE__ */ R.jsx(
            oge.TextArea,
            {
              ...u("template", D0.promptField.validation),
              id: n("template"),
              name: D0.promptField.label,
              resize: "vertical"
            }
          ),
          /* @__PURE__ */ R.jsx(g$.HelpText, { variant: h.template ? "error" : "default", children: h.template ? h.template.message : D0.promptField.helpText })
        ] }),
        /* @__PURE__ */ R.jsx(Y4.FormActions, { children: /* @__PURE__ */ R.jsxs(ar.Box, { width: "100%", display: "flex", justifyContent: "space-between", children: [
          /* @__PURE__ */ R.jsx(
            zi.Button,
            {
              disabled: p,
              onClick: r,
              variant: "secondary",
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ R.jsx(zi.Button, { disabled: p, type: "submit", variant: "primary", children: p ? "Submitting..." : "Submit" })
        ] }) })
      ] })
    }
  );
};
var ZQ = {}, Ivr = Ey`
  0% {
    transform: translateX(-100%) skew(155deg);
  }
  50%,
  100% {
    transform: translateX(100%) skew(155deg);
  }
`, Mvr = ds.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(
    90deg,
    transparent,
    ${Yce("backgroundColors.colorBackground")} 40%,
    ${Yce("backgroundColors.colorBackground")} 60%,
    transparent
  );
  transform: translateX(-100%) skew(155deg);
  animation-timing-function: cubic-bezier(0.06, 0.42, 0.57, 0.89);
  animation-name: ${Ivr};
  animation-duration: 4.5s;
  animation-iteration-count: infinite;
`, Wnt = P.forwardRef(({ borderBottomLeftRadius: t, borderBottomRightRadius: e, borderRadius: r = "borderRadius20", borderTopLeftRadius: n, borderTopRightRadius: a, element: i = "SKELETON_LOADER", display: o, height: s = "sizeIcon20", maxHeight: l, maxWidth: c, minHeight: u, minWidth: f, size: h = null, width: p = null, ...g }, y) => P.createElement(ht, { ...Xt(g), "aria-busy": "true", backgroundColor: "colorBackgroundStrong", borderBottomLeftRadius: t, borderBottomRightRadius: e, borderRadius: r, borderTopLeftRadius: n, borderTopRightRadius: a, display: o, element: i, height: s, maxHeight: l, maxWidth: c, minHeight: u, minWidth: f, overflow: "hidden", pointerEvents: "none", position: "relative", userSelect: "none", size: h, width: p, ref: y }, P.createElement(Mvr, null)));
Wnt.displayName = "SkeletonLoader";
const Pvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SkeletonLoader: Wnt
}, Symbol.toStringTag, { value: "Module" })), Rvr = /* @__PURE__ */ aa(Pvr);
var HAe;
function Ovr() {
  return HAe || (HAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Rvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(ZQ)), ZQ;
}
var Qo = /* @__PURE__ */ Ovr(), JQ = {};
const Bvr = /* @__PURE__ */ aa(hnr);
var UAe;
function Nvr() {
  return UAe || (UAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Bvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(JQ)), JQ;
}
var R1 = /* @__PURE__ */ Nvr();
const $vr = () => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ R.jsx(ar.Box, { marginBottom: "space30", marginTop: "space150", children: /* @__PURE__ */ R.jsx(vh.Card, { children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space20", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "80px" })
  ] }) }) }),
  /* @__PURE__ */ R.jsx(ar.Box, { marginBottom: "space30", children: /* @__PURE__ */ R.jsx(vh.Card, { children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space20", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "80px" })
  ] }) }) }),
  /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsx(vh.Card, { children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space20", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, {}),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "80px" })
  ] }) }) })
] }), fW = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `PlusIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[PlusIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.043 9.043h-4.086V4.957a.958.958 0 00-1.914 0v4.086H4.957a.958.958 0 000 1.914h4.086v4.086a.958.958 0 001.914 0v-4.086h4.086a.958.958 0 000-1.914z" })));
});
fW.displayName = "PlusIcon";
const Dvr = "data:image/svg+xml,%3csvg%20width='192'%20height='224'%20viewBox='0%200%20192%20224'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1239_9574)'%3e%3cpath%20d='M55.8086%2016.8368C55.8086%2016.8006%2055.8086%2016.7644%2055.8086%2016.7281C55.7193%2016.6252%2055.639%2016.515%2055.5684%2016.3986C54.8509%2015.2207%2054.9736%2013.696%2055.4823%2012.4152C55.605%2012.086%2055.7721%2011.7748%2055.979%2011.4902C56.3146%2011.0562%2056.7775%2010.7363%2057.3038%2010.5744C56.9597%2010.0221%2056.6736%209.43614%2056.4501%208.82576C56.0058%207.72035%2055.5537%206.53324%2055.8028%205.36887C55.9261%204.8476%2056.175%204.36388%2056.5282%203.95935C56.8814%203.55483%2057.3283%203.24162%2057.8304%203.04668C58.3354%202.86003%2058.8742%202.78073%2059.4121%202.81393C59.9499%202.84713%2060.4747%202.99207%2060.9526%203.2394C61.129%203.36086%2061.3408%203.42102%2061.5552%203.41053C61.68%203.37676%2061.7948%203.31386%2061.8901%203.22706C62.7919%202.51133%2063.5087%201.54969%2064.5319%201.01973C65.1425%200.731525%2065.7953%200.541704%2066.466%200.457395C67.1439%200.347164%2067.9176%200.295902%2068.4376%200.741454C68.6356%200.935737%2068.7825%201.1754%2068.8654%201.43934C68.9482%201.70327%2068.9644%201.98339%2068.9126%202.25502C68.8033%202.79662%2068.6043%203.31644%2068.3235%203.79325L72.18%203.02549C72.8916%202.84544%2073.6271%202.7769%2074.36%202.82237C74.8197%202.85604%2075.2557%203.03794%2075.6017%203.34038C75.7709%203.49401%2075.8916%203.69297%2075.9495%203.91325C76.0073%204.13353%2075.9998%204.36573%2075.9277%204.58183C75.6078%205.14427%2075.1417%205.61108%2074.5781%205.93352C74.8714%206.03193%2075.163%206.13793%2075.4527%206.2515C76.5786%206.25341%2077.6932%206.47376%2078.7341%206.90017C79.5144%207.18269%2080.3933%207.62939%2080.5222%208.44457C80.5317%208.51675%2080.5347%208.58963%2080.5311%208.66233C80.6648%208.80546%2080.7406%208.99249%2080.7441%209.18767C80.7414%209.63669%2080.3363%209.97201%2079.9467%2010.1998C79.5279%2010.3743%2079.175%2010.6751%2078.9378%2011.0597C78.9066%2011.1169%2078.8988%2011.1838%2078.916%2011.2466C78.9332%2011.2789%2078.9571%2011.3073%2078.986%2011.3298C79.015%2011.3523%2079.0484%2011.3685%2079.0841%2011.3773C79.3802%2011.4562%2079.6875%2011.4855%2079.9933%2011.464C80.8853%2011.476%2081.761%2011.704%2082.5443%2012.1281C82.8593%2012.2865%2083.1404%2012.5039%2083.3724%2012.7683C83.605%2013.036%2083.7245%2013.3826%2083.7061%2013.7357C83.6585%2014.0634%2083.5136%2014.3696%2083.2901%2014.6152C82.9835%2014.9994%2082.5731%2015.289%2082.107%2015.4501C81.93%2015.5144%2081.7442%2015.5513%2081.5559%2015.5595C81.195%2015.71%2080.8237%2015.8348%2080.445%2015.933C80.0588%2016.0501%2079.6546%2016.0967%2079.2517%2016.0706C79.1896%2016.0613%2079.128%2016.0485%2079.0674%2016.0321C79.0069%2016.1081%2078.9653%2016.1972%2078.9459%2016.2922C78.9313%2016.5077%2078.9823%2016.7226%2079.0922%2016.9089C80.722%2020.5126%2080.1904%2024.6714%2079.6254%2028.5823C79.4964%2029.8247%2079.2184%2031.0473%2078.7973%2032.2242C78.2106%2033.704%2077.1489%2034.9503%2075.7768%2035.7701C75.2498%2036.0761%2074.639%2036.3509%2074.3841%2036.9017C73.9242%2037.8949%2075.748%2038.586%2076.2855%2039.1869C77.0709%2040.0981%2077.5784%2041.2129%2077.7484%2042.4006C77.9591%2044.0797%2077.7123%2045.7842%2077.0336%2047.3363C76.6039%2048.4721%2075.9316%2049.5021%2075.0631%2050.3554C74.2714%2051.0518%2073.332%2051.5624%2072.3146%2051.8493C71.2972%2052.1362%2070.2279%2052.192%2069.1858%2052.0127C67.0929%2051.6298%2065.1928%2050.5526%2063.7966%2048.9574C62.5757%2047.6043%2061.7044%2045.9767%2061.2576%2044.2148C60.4466%2040.9995%2061.1098%2037.6151%2061.8684%2034.3864C61.9977%2033.9634%2062.0432%2033.5196%2062.0023%2033.0794C61.894%2032.621%2061.6907%2032.1901%2061.4054%2031.8141C60.5094%2030.4474%2059.5855%2029.0506%2058.2669%2028.0781C57.4745%2027.4935%2056.5355%2027.0572%2055.9573%2026.2624C54.6348%2024.4451%2055.83%2021.9545%2055.9398%2019.7148C55.9868%2018.7559%2055.8211%2017.7988%2055.8102%2016.8388'%20fill='white'/%3e%3cpath%20d='M81.2753%20177.654C80.5462%20177.898%2080.0045%20178.543%2079.2517%20178.791C78.2387%20179.116%2077.1742%20179.253%2076.1112%20179.196C74.1429%20179.044%2072.2273%20178.491%2070.4845%20177.569C70.0162%20177.299%2069.5052%20177.109%2068.9731%20177.007C68.7085%20176.958%2068.4352%20176.983%2068.1845%20177.08C67.9338%20177.178%2067.7157%20177.343%2067.5552%20177.558C67.4316%20177.82%2067.3769%20178.108%2067.3961%20178.396C67.3749%20179.669%2067.354%20180.941%2067.3336%20182.214C67.3111%20183.577%2067.2948%20184.975%2067.7993%20186.258C68.3289%20187.603%2069.3902%20188.71%2070.4298%20189.777C71.4775%20190.85%2072.5804%20191.952%2074.034%20192.499C75.3534%20192.996%2076.8279%20192.984%2078.2528%20192.912C81.2923%20192.756%2084.3141%20192.355%2087.2881%20191.713C88.391%20191.475%2089.5198%20191.188%2090.4061%20190.541C93.2807%20188.443%2090.8442%20184.991%2089.0689%20183.043C87.5618%20181.394%2085.873%20179.919%2084.0344%20178.645C83.4643%20178.253%2082.7022%20177.574%2081.8865%20177.558C81.6785%20177.554%2081.4714%20177.586%2081.2746%20177.653'%20fill='%23F22F46'/%3e%3cpath%20d='M125.589%20168.566C124.787%20168.759%20124.511%20169.648%20124.037%20170.179C123.453%20170.812%20122.744%20171.319%20121.953%20171.667C120.803%20172.206%20119.559%20172.522%20118.289%20172.597C117.052%20172.597%20115.835%20172.289%20114.748%20171.702C114.556%20171.606%20113.901%20171.086%20113.718%20171.25C113.582%20171.41%20113.485%20171.6%20113.436%20171.804C113.387%20172.008%20113.386%20172.221%20113.434%20172.425C113.65%20174.639%20114.289%20176.792%20115.317%20178.768C115.505%20179.214%20115.82%20179.596%20116.224%20179.867C116.701%20180.079%20117.224%20180.168%20117.745%20180.124L138.022%20180.115C139.053%20180.115%20140.173%20180.087%20140.971%20179.492C141.763%20178.903%20142.027%20177.912%20142.174%20176.987C142.37%20175.76%20142.388%20174.358%20141.455%20173.46C140.831%20172.859%20139.911%20172.617%20139.042%20172.384C135.75%20171.502%20132.522%20170.397%20129.382%20169.077C128.591%20168.688%20127.741%20168.428%20126.867%20168.306C126.185%20168.251%20126.22%20168.414%20125.586%20168.565'%20fill='%23F22F46'/%3e%3cpath%20d='M76.1159%2040.2314C77.2203%2042.5755%2076.7244%2045.1953%2075.1222%2047.2003C74.2368%2048.2412%2073.0678%2049.0062%2071.7555%2049.4034C69.2002%2049.9931%2066.357%2049.0611%2064.305%2047.5425C61.7993%2045.6882%2061.1319%2042.7571%2060.9476%2039.7955C60.9424%2039.719%2060.9182%2039.645%2060.8771%2039.5801C60.836%2039.5152%2060.7793%2039.4615%2060.7121%2039.4238C60.6449%2039.386%2060.5694%2039.3655%2060.4922%2039.364C60.415%2039.3625%2060.3387%2039.38%2060.2701%2039.4151C56.5859%2041.3233%2052.0997%2043.6023%2048.6442%2046.6364C43.7936%2050.895%2041.1339%2057.0309%2038.6225%2062.9565C37.6108%2065.3426%2036.5821%2067.8128%2036.5965%2070.4002C36.6019%2071.4277%2036.5821%2072.732%2036.0191%2073.4485C35.8361%2073.685%2035.7237%2073.9677%2035.6944%2074.2645C35.6652%2074.5613%2035.7204%2074.8602%2035.8538%2075.1274C36.4448%2076.3195%2036.7793%2077.6238%2036.0951%2078.6934C35.8623%2079.0603%2035.5216%2079.3579%2035.3249%2079.746C34.5127%2081.347%2036.4983%2083.2306%2035.9678%2084.9446C35.7932%2085.5089%2035.3656%2085.9583%2035.1017%2086.4863C34.5065%2087.6777%2034.8208%2089.1646%2035.5794%2090.2604C36.338%2091.3561%2037.4754%2092.1309%2038.6217%2092.8188C42.0873%2094.897%2045.8634%2096.4148%2049.8087%2097.3156C49.9021%2097.336%2049.9995%2097.3289%2050.0889%2097.2953C50.1783%2097.2616%2050.256%2097.2028%2050.3123%2097.126C50.3687%2097.0492%2050.4013%2096.9578%2050.4062%2096.863C50.4111%2096.7681%2050.3881%2096.6739%2050.3399%2096.5918C49.3116%2094.739%2049.5565%2092.2457%2050.3752%2090.2103C50.9317%2088.8262%2050.8289%2088.2199%2052.1052%2087.4352C54.2227%2086.1344%2054.8708%2087.9999%2060.2084%2086.6108C63.6045%2085.727%2067.3453%2085.848%2070.8125%2085.3004L87.991%2082.5812C88.4399%2077.9279%2087.2149%2071.9577%2086.6161%2067.0647C86.6067%2066.9899%2086.6227%2066.914%2086.6615%2066.8492C86.7003%2066.7844%2086.7597%2066.7342%2086.8304%2066.7067C86.9011%2066.6791%2086.979%2066.6757%2087.0518%2066.697C87.1247%2066.7182%2087.1883%2066.763%2087.2327%2066.8242C89.5059%2070.0017%2093.5986%2073.6524%2095.8807%2076.138C96.2882%2073.482%2096.4457%2070.1393%2097.4057%2067.6274C97.6297%2067.0412%2098.0526%2066.2133%2098.6005%2065.9027C99.2569%2065.5985%2099.9556%2065.3942%20100.673%2065.2964C102.26%2065.2355%20104.922%2064.7371%20106.509%2064.6762C108.372%2064.6416%20110.23%2064.4832%20112.072%2064.2022C113.295%2063.9798%20112.921%2060.849%20113.404%2059.7466C113.645%2059.1962%20114.649%2058.1013%20114.772%2057.4958C115.094%2055.9132%20115.088%2055.8608%20114.754%2054.6933C114.743%2054.6559%20114.722%2054.6225%20114.692%2054.5974C114.662%2054.5722%20114.626%2054.5564%20114.587%2054.5521C114.548%2054.5477%20114.509%2054.555%20114.474%2054.573C114.439%2054.5909%20114.411%2054.6187%20114.392%2054.6529C113.801%2055.8176%20112.183%2056.3757%20110.843%2056.0735C109.149%2055.6916%20107.282%2055.2796%20105.845%2054.2277C105.074%2053.6627%20104.315%2053.1975%20103.994%2052.3249C103.709%2051.5513%20103.593%2050.1249%20102.561%2050.5458C102.441%2050.5978%20102.334%2050.6769%20102.249%2050.7768C102.165%2050.8767%20102.105%2050.9947%20102.074%2051.1216C101.314%2054.0663%20100.992%2057.1056%20101.12%2060.1429C100.103%2058.6416%2098.3118%2056.6821%2097.3766%2055.13C92.5408%2047.0981%2090.2874%2042.5725%2082.1039%2040.389C81.1384%2040.1316%2080.2335%2039.5272%2079.3701%2039.0466C78.3513%2038.4273%2077.2834%2037.8916%2076.1769%2037.4448C75.8404%2037.3241%2075.0725%2037.1168%2074.7601%2037.3719C74.5048%2037.5804%2074.7298%2037.8811%2074.8563%2038.1019C75.0729%2038.4804%2075.2899%2038.8589%2075.5075%2039.2374C75.6414%2039.4709%2075.8253%2039.6741%2075.9541%2039.9115C76.0103%2040.0143%2076.0641%2040.1208%2076.1156%2040.231'%20fill='%23F2BE5A'/%3e%3cpath%20d='M60.7476%2029.3392C60.7328%2029.2699%2060.7001%2029.2055%2060.6525%2029.1527C60.6434%2029.1386%2060.6326%2029.1256%2060.6203%2029.1142C60.564%2029.0725%2060.5795%2029.019%2060.4992%2028.9812C60.4436%2028.9461%2060.3925%2028.9044%2060.3471%2028.8571L60.3261%2028.8405C60.1827%2028.71%2060.0268%2028.5938%2059.8605%2028.4936L59.8387%2028.4786C59.675%2028.3522%2059.4817%2028.255%2059.3157%2028.1352C59.2938%2028.1208%2059.271%2028.1079%2059.2474%2028.0966C59.133%2028.0354%2059.0224%2027.9673%2058.9164%2027.8927C58.8927%2027.875%2058.8675%2027.8594%2058.8411%2027.8461C58.737%2027.7963%2058.6371%2027.7383%2058.5423%2027.6727C58.526%2027.6605%2058.5083%2027.6504%2058.4895%2027.6426C58.3928%2027.6127%2058.2993%2027.5734%2058.2105%2027.525C58.0433%2027.416%2057.9303%2027.3096%2057.7619%2027.2098C57.7371%2027.1951%2057.713%2027.1778%2057.689%2027.1616C57.6766%2027.1512%2057.6636%2027.1414%2057.6502%2027.1323C57.4806%2027.034%2057.3292%2026.9049%2057.1701%2026.7951C57.0876%2026.7377%2057.0097%2026.6739%2056.9373%2026.6043L56.6991%2026.3923L56.4814%2026.1657C56.4158%2026.0924%2056.3595%2026.0115%2056.299%2025.9367C56.2565%2025.892%2056.2229%2025.8397%2056.2%2025.7825C56.1205%2025.5974%2056.0298%2025.4172%2055.9284%2025.2429C55.8534%2025.0479%2055.7992%2024.8456%2055.7666%2024.6394C55.7392%2024.5324%2055.7236%2024.4228%2055.72%2024.3125C55.7305%2024.153%2055.6944%2024.0427%2055.6967%2023.9101C55.6972%2023.6823%2055.7137%2023.4547%2055.746%2023.2291C55.7636%2023.1173%2055.7873%2023.0065%2055.817%2022.8972C55.8252%2022.8714%2055.8325%2022.8448%2055.8384%2022.8202C55.8561%2022.6759%2055.8888%2022.5338%2055.9358%2022.3962C56.0092%2022.2472%2056.0973%2022.1058%2056.1989%2021.9742C56.2718%2021.8917%2056.3064%2021.761%2056.396%2021.6997C56.6041%2021.5364%2056.8516%2021.4301%2057.1139%2021.3914C57.2673%2021.3654%2057.4249%2021.3779%2057.5722%2021.428C57.7575%2021.4719%2057.9359%2021.5409%2058.1022%2021.6331C58.1762%2021.6692%2058.2473%2021.7108%2058.3149%2021.7575C58.3358%2021.7718%2058.415%2021.8069%2058.4363%2021.8196C58.4883%2021.8447%2058.4817%2021.8524%2058.5271%2021.8878C58.6436%2021.9807%2058.767%2022.0674%2058.8764%2022.1699C59.0261%2022.2971%2059.1622%2022.4391%2059.2827%2022.5939C59.2869%2022.6006%2059.2914%2022.607%2059.2963%2022.6132C59.4252%2022.7427%2059.544%2022.8817%2059.6517%2023.0291C59.7456%2023.1559%2059.8256%2023.3725%2059.9233%2023.5012C59.9672%2023.5594%2060.0075%2023.6245%2060.0495%2023.6874C60.1098%2023.7886%2060.1974%2023.8711%2060.3025%2023.9256C60.3948%2023.966%2060.4837%2023.9934%2060.5741%2024.0273C60.6214%2024.0454%2060.6478%2024.02%2060.6839%2024.0138C60.7798%2023.9972%2060.8178%2023.8959%2060.8512%2023.788C60.8537%2023.7742%2060.8546%2023.7603%2060.8539%2023.7463C60.8475%2023.6191%2060.8244%2023.4933%2060.7852%2023.3721C60.7598%2023.2992%2060.7275%2023.2288%2060.6886%2023.162C60.5665%2022.9225%2060.4272%2022.6921%2060.2718%2022.4725C60.1726%2022.3516%2060.0672%2022.2358%2059.9559%2022.1256C59.9439%2022.1121%2059.9303%2022.0994%2059.9195%2022.0852C59.797%2021.9178%2059.6651%2021.7574%2059.5244%2021.6049C59.5108%2021.5918%2059.4988%2021.5772%2059.4856%2021.5664C59.3118%2021.4261%2059.143%2021.2842%2058.959%2021.1551C58.7571%2021.0253%2058.5385%2020.9231%2058.3091%2020.8514C58.2641%2020.8341%2058.2194%2020.8179%2058.1744%2020.7978C58.0108%2020.71%2057.8347%2020.6475%2057.6521%2020.6124C57.4434%2020.5854%2057.2326%2020.5768%2057.0223%2020.587C56.9207%2020.5902%2056.8199%2020.6069%2056.7227%2020.6367C56.6231%2020.6605%2056.5262%2020.6944%2056.4336%2020.7381C56.3686%2020.7662%2056.3062%2020.7999%2056.247%2020.8387C56.1915%2020.8811%2056.1372%2020.9243%2056.0793%2020.9651C55.9953%2021.0231%2055.9159%2021.0876%2055.8419%2021.1578C55.7647%2021.2219%2055.6964%2021.2959%2055.6389%2021.3779C55.5747%2021.4689%2055.5204%2021.5664%2055.4771%2021.6689C55.4208%2021.7722%2055.3657%2021.8292%2055.3114%2021.9302C55.2556%2022.0471%2055.2066%2022.167%2055.1647%2022.2894C55.114%2022.398%2055.0727%2022.5107%2055.0413%2022.6263C55.0103%2022.7805%2055.0293%2022.7739%2054.9967%2022.9258C54.9653%2023.1102%2054.9448%2023.2963%2054.9354%2023.4831C54.9265%2023.739%2054.9269%2023.882%2054.9327%2024.082C54.9329%2024.1798%2054.9418%2024.2773%2054.9595%2024.3734L54.9757%2024.4833C55.0534%2024.7893%2055.058%2024.9519%2055.1267%2025.184C55.1418%2025.2433%2055.1655%2025.2996%2055.1865%2025.3593C55.2159%2025.4491%2055.2606%2025.5332%2055.2947%2025.6237C55.3287%2025.713%2055.3704%2025.7991%2055.4193%2025.8812C55.6278%2026.2176%2055.8705%2026.5319%2056.1438%2026.8189C56.2645%2026.9341%2056.3942%2027.0396%2056.5318%2027.1342C56.8186%2027.3335%2057.0689%2027.5802%2057.3657%2027.7605C57.6114%2027.9116%2057.8562%2028.0585%2058.1053%2028.1918C58.162%2028.2219%2058.2155%2028.2604%2058.2722%2028.2924C58.4946%2028.4181%2058.6971%2028.4632%2058.9012%2028.6054C59.0906%2028.7341%2059.2916%2028.8559%2059.4643%2028.9627C59.5784%2029.0344%2059.609%2029.0197%2059.6676%2029.0845C59.793%2029.1788%2059.9248%2029.2641%2060.0623%2029.34C60.1122%2029.376%2060.164%2029.4093%2060.2175%2029.4398C60.2782%2029.4823%2060.3468%2029.5126%2060.4193%2029.5289C60.4949%2029.5532%2060.5764%2029.5532%2060.6521%2029.5289C60.6856%2029.5096%2060.7129%2029.4812%2060.7307%2029.4471C60.7485%2029.413%2060.7561%2029.3745%2060.7526%2029.3362'%20fill='%23121C2D'/%3e%3cpath%20d='M59.2505%2028.7422C59.2515%2028.9001%2059.2748%2029.0571%2059.3196%2029.2086C59.3285%2029.2471%2059.3378%2029.288%2059.3502%2029.3242C59.3825%2029.4626%2059.424%2029.5987%2059.4744%2029.7316C59.5435%2029.8692%2059.5877%2030.0261%2059.6513%2030.1729L59.6773%2030.2327C59.855%2030.678%2060.0927%2031.0973%2060.384%2031.4791L60.4228%2031.5319C60.7357%2031.9503%2061.0933%2032.3338%2061.4891%2032.6759C61.5334%2032.7171%2061.5877%2032.7603%2061.6381%2032.8008C61.8939%2033.0023%2062.1476%2033.2058%2062.4053%2033.3974C62.4631%2033.4437%2062.5238%2033.4865%2062.5869%2033.5254L63.3262%2033.9856C63.3696%2034.015%2063.415%2034.0415%2063.462%2034.065C63.6529%2034.1555%2063.9622%2034.2885%2064.1484%2034.3856C64.5939%2034.6192%2064.9315%2034.8096%2065.3937%2035.0023L65.5982%2035.0906C65.637%2035.1075%2065.6758%2035.1291%2065.7126%2035.1426C66.1845%2035.3211%2066.6408%2035.5307%2067.1174%2035.6984C67.3591%2035.7816%2067.6082%2035.8911%2067.8585%2035.979C68.389%2036.1717%2068.928%2036.3525%2069.4759%2036.5086C69.7336%2036.5856%2069.9963%2036.6492%2070.2578%2036.7148C70.4216%2036.7583%2070.602%2036.7841%2070.7561%2036.8304C71.071%2036.9222%2071.3942%2036.9829%2071.7211%2037.0115C71.9676%2037.0366%2072.1763%2037.0389%2072.4662%2037.0501C73.0639%2037.0777%2073.6629%2037.0368%2074.2512%2036.9283C74.5576%2036.8578%2074.8599%2036.7709%2075.1569%2036.6681C75.3514%2036.6143%2075.5386%2036.5374%2075.7145%2036.4392C75.8799%2036.3598%2076.0293%2036.2692%2076.1934%2036.1694C76.7467%2035.8286%2077.2401%2035.4002%2077.654%2034.9009C77.8612%2034.6555%2078.0536%2034.3981%2078.2303%2034.1301L78.3505%2033.932C78.5434%2033.5719%2078.714%2033.2004%2078.8612%2032.8196C79.0539%2032.3833%2079.2141%2031.9334%2079.3405%2031.4737C79.4281%2031.1361%2079.4639%2030.77%2079.5232%2030.4331C79.5822%2030.1032%2079.6427%2029.7914%2079.6699%2029.4626C79.7275%2028.9095%2079.7499%2028.3534%2079.737%2027.7976C79.711%2027.2888%2079.7343%2026.8405%2079.7316%2026.3715C79.7273%2025.8377%2079.7355%2025.3015%2079.7658%2024.7681C79.7793%2024.5457%2079.7933%2024.316%2079.8077%2024.0921C79.81%2024.0227%2079.817%2023.7868%2079.8193%2023.7197C79.821%2023.6166%2079.8293%2023.5136%2079.8441%2023.4114C79.8732%2023.0059%2079.9027%2022.5966%2079.9318%2022.1904C79.9706%2021.655%2079.9912%2021.1166%2080.018%2020.5735C80.018%2020.5523%2080.0203%2020.53%2080.0211%2020.5103C80.0211%2020.2405%2080.0149%2020.0093%2080.0028%2019.7757C79.9978%2019.5444%2079.9792%2019.3132%2079.9536%2019.0353C79.9439%2018.8252%2079.9086%2018.5658%2079.8814%2018.3072C79.8471%2018.0607%2079.7923%2017.8175%2079.7176%2017.5799C79.6354%2017.3941%2079.5725%2017.1945%2079.4747%2017.0087C79.3874%2016.8512%2079.2876%2016.7008%2079.1763%2016.5589C79.0872%2016.4669%2078.9905%2016.3825%2078.8872%2016.3065C78.841%2016.2741%2078.7984%2016.2437%2078.7541%2016.2174L78.6125%2016.1546L78.3408%2016.0417C78.2465%2016.0031%2078.2434%2016.0467%2078.2%2016.054C78.0867%2016.0756%2078.1666%2016.256%2078.2434%2016.4321C78.2565%2016.456%2078.2713%2016.4789%2078.2877%2016.5007C78.359%2016.6011%2078.4229%2016.7065%2078.479%2016.816L78.5857%2016.9918C78.6125%2017.0577%2078.64%2017.1247%2078.6672%2017.1922C78.6944%2017.2596%2078.7308%2017.3321%2078.7693%2017.4053C78.7972%2017.4851%2078.8263%2017.5672%2078.8534%2017.6451C79.0321%2018.2054%2079.1312%2018.7877%2079.148%2019.3752C79.1627%2019.6562%2079.2089%2020.123%2079.2023%2020.4124V20.535C79.1825%2021.0514%2079.1367%2021.3829%2079.094%2021.9044C79.0902%2021.9453%2079.0867%2021.9869%2079.0832%2022.0262C79.0638%2022.5172%2079.0226%2023.0067%2078.9858%2023.5008C78.938%2024.0998%2078.9644%2024.4806%2078.9594%2025.0838C78.9594%2025.1905%2078.9555%2025.2931%2078.9501%2025.4002C78.9303%2025.7155%2078.8992%2026.2636%2078.9113%2026.5815C78.9342%2026.9966%2078.9353%2027.4191%2078.9229%2027.8288C78.9109%2028.2142%2078.9089%2028.5931%2078.8841%2028.9716C78.8678%2029.2367%2078.8655%2029.4911%2078.8379%2029.7547C78.796%2030.1375%2078.7173%2030.5256%2078.6439%2030.8971C78.6074%2031.0852%2078.564%2031.3735%2078.5186%2031.5524C78.4614%2031.7567%2078.3902%2031.957%2078.3055%2032.1517C78.2539%2032.3136%2078.0727%2032.7445%2078.0005%2032.8975C77.8938%2033.1122%2077.7479%2033.3407%2077.6292%2033.5458C77.5321%2033.7338%2077.4208%2033.9142%2077.2962%2034.0854C77.0652%2034.404%2076.8036%2034.6996%2076.5151%2034.968C76.2083%2035.2548%2075.8624%2035.4973%2075.4875%2035.6884C75.3013%2035.7735%2075.1204%2035.8734%2074.9276%2035.9427L74.7091%2036.0279C74.4539%2036.1244%2074.1891%2036.1934%2073.919%2036.2337C73.6901%2036.2785%2073.4743%2036.2831%2073.2206%2036.3081C73.091%2036.3185%2072.9594%2036.3158%2072.829%2036.3216C72.6274%2036.3284%2072.4256%2036.3223%2072.2248%2036.3035C72.0234%2036.2862%2071.8182%2036.2607%2071.6191%2036.2495C70.7581%2036.1424%2069.9108%2035.946%2069.091%2035.6637L68.0072%2035.3241C67.2427%2035.0705%2066.4969%2034.7225%2065.7445%2034.4115C65.1174%2034.1501%2064.5027%2033.8634%2063.9117%2033.5473C63.7755%2033.4772%2063.6447%2033.3908%2063.5116%2033.3161C62.5383%2032.8111%2061.6798%2032.113%2060.9893%2031.2648C60.8621%2031.1249%2060.7489%2030.973%2060.6513%2030.8112C60.5019%2030.5171%2060.2583%2030.1698%2060.1061%2029.8091L59.9253%2029.3928C59.8569%2029.2288%2059.7777%2029.0694%2059.6882%2028.9157C59.5831%2028.7472%2059.4829%2028.5753%2059.4131%2028.5534C59.3285%2028.5268%2059.2699%2028.5792%2059.2524%2028.7461'%20fill='%23121C2D'/%3e%3cpath%20d='M73.9041%2039.7137C73.9319%2039.7009%2073.9554%2039.6804%2073.972%2039.6548C73.9743%2039.6509%2073.979%2039.6463%2073.977%2039.6432C73.97%2039.6305%2074.0158%2039.6151%2073.9933%2039.602C73.9708%2039.5889%2073.9906%2039.5754%2073.991%2039.5634C73.991%2039.5634%2073.991%2039.5596%2073.991%2039.558C73.9999%2039.5182%2073.9958%2039.4767%2073.9794%2039.4393C73.9794%2039.4393%2073.9794%2039.4358%2073.9794%2039.4339C73.9902%2039.3877%2073.9565%2039.3507%2073.9669%2039.3048C73.9669%2039.2994%2073.9634%2039.2944%2073.9611%2039.2898C73.9492%2039.2645%2073.9461%2039.236%2073.9522%2039.2088C73.9535%2039.2059%2073.9542%2039.2028%2073.9542%2039.1996C73.9542%2039.1964%2073.9535%2039.1932%2073.9522%2039.1903C73.9384%2039.1694%2073.9329%2039.1441%2073.9367%2039.1194C73.9367%2039.1144%2073.939%2039.1098%2073.9343%2039.1063C73.9161%2039.0928%2073.8816%2039.0712%2073.8816%2039.0535C73.8816%2039.0103%2073.9064%2038.971%2073.8905%2038.9317C73.8888%2038.9256%2073.888%2038.9192%2073.8882%2038.9128C73.8882%2038.909%2073.8913%2038.9047%2073.8882%2038.9016C73.8625%2038.8631%2073.8827%2038.8157%2073.8587%2038.7768C73.8466%2038.7571%2073.8521%2038.7324%2073.8474%2038.7105L73.8164%2038.5702L73.802%2038.5043C73.7997%2038.4904%2073.7919%2038.4765%2073.802%2038.4611C73.8517%2038.3755%2073.7904%2038.3667%2073.783%2038.3197C73.774%2038.2718%2073.7679%2038.2234%2073.7648%2038.1747C73.7648%2038.1493%2073.7372%2038.1269%2073.7512%2038.1C73.7729%2038.0591%2073.7357%2038.0402%2073.7345%2038.0094C73.7293%2037.9576%2073.7212%2037.9061%2073.7104%2037.8552C73.7065%2037.8297%2073.7047%2037.8039%2073.705%2037.7781C73.7053%2037.7718%2073.7041%2037.7655%2073.7015%2037.7596C73.6887%2037.728%2073.6487%2037.6999%2073.6449%2037.6667C73.6402%2037.6282%2073.6705%2037.5831%2073.6689%2037.5434C73.6689%2037.5141%2073.632%2037.4891%2073.6355%2037.4594C73.639%2037.4297%2073.6619%2037.4%2073.6561%2037.373C73.6464%2037.3272%2073.6709%2037.2732%2073.6336%2037.2339C73.5963%2037.1946%2073.6266%2037.153%2073.6239%2037.1121C73.6184%2037.0654%2073.6177%2037.0183%2073.6216%2036.9714C73.6209%2036.9516%2073.6217%2036.9318%2073.6239%2036.9121C73.6239%2036.9055%2073.6146%2036.8866%2073.6103%2036.8812C73.6002%2036.8689%2073.6103%2036.8678%2073.613%2036.8539C73.6153%2036.8187%2073.6134%2036.7834%2073.6076%2036.7487C73.5983%2036.7035%2073.5934%2036.6575%2073.5929%2036.6114C73.5929%2036.6114%2073.5929%2036.6076%2073.5929%2036.606C73.5706%2036.5694%2073.552%2036.5307%2073.5374%2036.4904C73.5257%2036.4565%2073.5653%2036.4018%2073.5428%2036.3698C73.5344%2036.355%2073.5272%2036.3395%2073.5215%2036.3235C73.5071%2036.2931%2073.4671%2036.2742%2073.4109%2036.2649L73.2192%2036.2387C73.1848%2036.2366%2073.1502%2036.2374%2073.1159%2036.2411C73.0297%2036.2463%2072.9446%2036.2638%2072.8633%2036.2931C72.8559%2036.2961%2072.8486%2036.2996%2072.8416%2036.3035C72.7982%2036.3263%2072.7595%2036.357%2072.7275%2036.3941C72.7165%2036.4088%2072.7111%2036.427%2072.7124%2036.4453C72.7058%2036.5012%2072.7082%2036.5578%2072.7194%2036.613C72.724%2036.6388%2072.7679%2036.6762%2072.7768%2036.7012C72.7768%2036.7047%2072.7811%2036.7082%2072.7811%2036.7117C72.7811%2036.7583%2072.7597%2036.7911%2072.7562%2036.8385C72.7562%2036.8423%2072.7531%2036.8462%2072.7562%2036.8496C72.771%2036.8913%2072.7757%2036.9357%2072.7702%2036.9795C72.7663%2037.0335%2072.816%2037.0605%2072.8342%2037.111C72.8365%2037.1201%2072.8365%2037.1296%2072.8342%2037.1387C72.8303%2037.1672%2072.7954%2037.2204%2072.8098%2037.2466C72.8269%2037.2808%2072.8327%2037.3195%2072.8265%2037.3572C72.8278%2037.3917%2072.8318%2037.426%2072.8385%2037.4598C72.8385%2037.484%2072.8637%2037.5037%2072.8672%2037.5276C72.8723%2037.5623%2072.8571%2037.6012%2072.8633%2037.6355C72.8664%2037.6533%2072.894%2037.6741%2072.9021%2037.6914C72.9103%2037.7088%2072.887%2037.73%2072.887%2037.7535C72.887%2037.7697%2072.8979%2037.812%2072.8994%2037.8282C72.8994%2037.8502%2072.88%2037.8795%2072.8909%2037.9003C72.9056%2037.9288%2072.9165%2037.925%2072.9231%2037.9554C72.9312%2037.992%2072.9437%2038.0271%2072.9541%2038.0633C72.9663%2038.101%2072.975%2038.1397%2072.9801%2038.179C72.9805%2038.1989%2072.9862%2038.2185%2072.9964%2038.2356C73.0007%2038.2422%2073.0003%2038.2503%2073.0054%2038.2568C73.0488%2038.3127%2073.0267%2038.3497%2073.0387%2038.396L73.0492%2038.431C73.0576%2038.4479%2073.0617%2038.4666%2073.0612%2038.4854C73.0601%2038.5047%2073.0664%2038.5236%2073.0787%2038.5386C73.1334%2038.6157%2073.1175%2038.69%2073.1412%2038.7656C73.1541%2038.7988%2073.1718%2038.83%2073.1939%2038.8581C73.237%2038.9221%2073.1967%2039.0042%2073.2199%2039.0739C73.239%2039.1317%2073.2502%2039.1915%2073.2735%2039.2481C73.2789%2039.2612%2073.2735%2039.2763%2073.2793%2039.2898C73.2948%2039.343%2073.3627%2039.3707%2073.3569%2039.4274C73.3557%2039.4768%2073.3634%2039.526%2073.3798%2039.5727C73.388%2039.6016%2073.4186%2039.5977%2073.4039%2039.6212C73.3767%2039.6598%2073.4404%2039.6841%2073.4501%2039.7176C73.4546%2039.7316%2073.4628%2039.7442%2073.4737%2039.7542C73.494%2039.7724%2073.5201%2039.7829%2073.5475%2039.7839C73.5989%2039.7921%2073.6513%2039.7921%2073.7027%2039.7839C73.7724%2039.7707%2073.8402%2039.7488%2073.9045%2039.7187'%20fill='%23121C2D'/%3e%3cpath%20d='M61.6005%2032.3695C61.5811%2032.4828%2061.5823%2032.726%2061.5737%2033.0012C61.5737%2033.0521%2061.5683%2033.1103%2061.5699%2033.1596C61.5761%2033.3847%2061.5311%2033.4525%2061.5388%2033.7316C61.5364%2033.9438%2061.5209%2034.1557%2061.4923%2034.366C61.4895%2034.3949%2061.4864%2034.4261%2061.4837%2034.4527C61.4403%2034.761%2061.396%2035.0732%2061.3514%2035.3881C61.2909%2035.7011%2061.2303%2036.0164%2061.1698%2036.3301L61.1531%2036.4157C61.0755%2036.751%2061.0181%2037.0886%2060.9412%2037.4371C60.8734%2037.774%2060.7871%2038.1069%2060.6828%2038.4345L60.6052%2038.6658C60.5808%2038.7423%2060.5511%2038.817%2060.5163%2038.8893C60.4942%2038.9167%2060.4954%2038.9159%2060.3856%2038.9568L60.0674%2039.0585C59.9366%2039.1056%2059.8532%2039.1456%2059.7437%2039.1884C59.6479%2039.227%2059.5609%2039.2632%2059.4597%2039.3102C59.0922%2039.4794%2058.7193%2039.6613%2058.3565%2039.8606C58.2878%2039.8991%2058.2241%2039.9338%2058.1624%2039.9762C57.8619%2040.1865%2057.5746%2040.4149%2057.3021%2040.66C56.7655%2041.1048%2056.3487%2041.6753%2056.0895%2042.32C56.0484%2042.4241%2056.0142%2042.5343%2055.9801%2042.6426L55.9304%2042.8299C55.7652%2043.6058%2055.9077%2044.4151%2056.3281%2045.0893C56.5238%2045.4173%2056.7382%2045.7338%2056.9704%2046.0374C57.4493%2046.6759%2057.9619%2047.2888%2058.5059%2047.8736C58.7647%2048.1476%2059.0239%2048.4209%2059.2948%2048.683L59.8054%2049.179C60.3632%2049.7449%2060.971%2050.2598%2061.6215%2050.7177C62.2621%2051.216%2062.9339%2051.6727%2063.6149%2052.1125C63.9676%2052.3411%2064.3692%2052.5523%2064.7014%2052.7623C65.1423%2053.0257%2065.5965%2053.2664%2066.0623%2053.4835C66.8428%2053.8941%2067.6577%2054.237%2068.4977%2054.5083C68.9413%2054.6427%2069.4008%2054.7185%2069.8644%2054.7338C69.9769%2054.7407%2070.0922%2054.7338%2070.2039%2054.7284C70.7926%2054.6724%2071.3698%2054.5309%2071.9171%2054.3087C72.5503%2054.0766%2073.1583%2053.7818%2073.732%2053.4287C74.1472%2053.1721%2074.5531%2052.856%2074.94%2052.5716C75.3215%2052.2956%2075.6812%2052.032%2076.0335%2051.7306C76.6333%2051.2252%2077.2014%2050.684%2077.7347%2050.1098C78.214%2049.5702%2078.6633%2049.1297%2079.1131%2048.629L80.635%2046.8946C80.8469%2046.6537%2081.0619%2046.3936%2081.2691%2046.1311C81.335%2046.054%2081.5314%2045.7541%2081.5826%2045.6647C81.699%2045.4566%2081.7072%2045.4678%2081.8255%2045.255C82.147%2044.6764%2082.2887%2044.0161%2082.2326%2043.3576C82.1244%2042.5357%2081.8162%2041.7524%2081.3347%2041.0755L81.2838%2040.9984C80.8646%2040.4345%2080.3973%2039.9076%2079.8869%2039.4235C79.4097%2038.9431%2078.8902%2038.5059%2078.3347%2038.1173C78.1108%2037.9716%2077.8744%2037.8209%2077.6362%2037.6841C77.2934%2037.4771%2076.924%2037.3171%2076.538%2037.2085C76.2543%2037.1399%2076.0145%2037.1025%2075.7507%2037.0643C75.6137%2037.0431%2075.6311%2037.0882%2075.5795%2037.1029C75.4433%2037.1453%2075.6397%2037.3106%2075.8543%2037.4883C75.8756%2037.5064%2075.9183%2037.5334%2075.9548%2037.5577C76.2264%2037.7315%2076.6121%2037.9605%2076.9823%2038.2091C77.1713%2038.3339%2077.4092%2038.4789%2077.6175%2038.6218C78.3308%2039.106%2078.9916%2039.6623%2079.5892%2040.2819C79.9335%2040.6226%2080.2554%2040.985%2080.5527%2041.3669C80.5869%2041.4116%2080.6199%2041.4574%2080.6505%2041.5029C80.8221%2041.7574%2080.9698%2042.0271%2081.0917%2042.3084C81.21%2042.5781%2081.2963%2042.8604%2081.349%2043.1498C81.3564%2043.2003%2081.3669%2043.2516%2081.3715%2043.2998C81.4605%2043.9048%2081.3247%2044.5214%2080.9893%2045.0342C80.6106%2045.6395%2080.1859%2046.2152%2079.7188%2046.7563C79.623%2046.8719%2079.5295%2046.979%2079.4297%2047.0904C79.136%2047.4219%2078.6078%2047.9642%2078.3203%2048.3007C77.9408%2048.7485%2077.5295%2049.1817%2077.1174%2049.5926C76.7316%2049.978%2076.3498%2050.3584%2075.9532%2050.7238C75.6715%2050.9755%2075.4127%2051.2287%2075.1212%2051.4696C74.6944%2051.8146%2074.2357%2052.1453%2073.7825%2052.4486C73.5559%2052.6028%2073.2163%2052.8487%2072.9936%2052.9855C72.3997%2053.3143%2071.7735%2053.5819%2071.1247%2053.7841C70.7931%2053.8664%2070.4539%2053.9146%2070.1123%2053.9279C69.8255%2053.954%2069.5365%2053.9421%2069.2528%2053.8924C68.6983%2053.7846%2068.158%2053.6143%2067.6424%2053.3848C66.9051%2053.0645%2066.4954%2052.8641%2065.935%2052.5754L65.1201%2052.1399L64.8147%2051.9684C64.1566%2051.6089%2063.5228%2051.2069%2062.9176%2050.7651L62.4492%2050.4363C62.2164%2050.2605%2061.9777%2050.0948%2061.7507%2049.9048C61.5237%2049.7148%2061.2878%2049.539%2061.0689%2049.3552C60.1158%2048.5751%2059.2358%2047.7108%2058.4399%2046.7728C58.2645%2046.5673%2058.0912%2046.3645%2057.9199%2046.1646L57.4217%2045.5479C57.0719%2045.1368%2056.8014%2044.6651%2056.6238%2044.1566C56.4861%2043.6645%2056.506%2043.1421%2056.6809%2042.6619C56.8269%2042.2447%2057.0507%2041.8586%2057.3405%2041.5237C57.6377%2041.1827%2057.9812%2040.8843%2058.3611%2040.6372C58.535%2040.5216%2058.7251%2040.416%2058.9137%2040.3139C59.2854%2040.1107%2059.63%2039.9442%2059.9789%2039.7781L60.2373%2039.6556C60.3103%2039.6232%2060.398%2039.5947%2060.4977%2039.5604C60.6245%2039.5223%2060.7458%2039.4677%2060.8582%2039.3981C60.9831%2039.2979%2061.0763%2039.1641%2061.1267%2039.0127C61.2817%2038.63%2061.4013%2038.234%2061.4841%2037.8298C61.5772%2037.4517%2061.6448%2037.0655%2061.7138%2036.7121C61.8046%2036.2395%2061.7856%2036.1725%2061.864%2035.8765C61.985%2035.323%2062.0517%2034.7592%2062.0631%2034.1929C62.0782%2033.9698%2062.0837%2033.7385%2062.0786%2033.5242C62.0778%2033.2644%2062.051%2033.0052%2061.9987%2032.7507C61.9692%2032.5383%2061.8944%2032.3348%2061.779%2032.1536C61.6956%2032.0954%2061.6382%2032.1567%2061.6013%2032.3714'%20fill='%23121C2D'/%3e%3cpath%20d='M66.9156%2068.554C66.9403%2068.4964%2066.9481%2068.4331%2066.9381%2068.3713C66.9381%2068.3572%2066.9361%2068.3432%2066.9323%2068.3297C66.9098%2068.2753%2066.9482%2068.2433%2066.9082%2068.1801C66.8852%2068.1295%2066.8697%2068.0759%2066.8621%2068.0209L66.8555%2067.9994C66.8195%2067.8395%2066.7732%2067.682%2066.7169%2067.528L66.7099%2067.5064C66.6777%2067.3318%2066.6001%2067.1641%2066.5675%2066.9899C66.5619%2066.9682%2066.5546%2066.9469%2066.5454%2066.9263C66.5052%2066.8213%2066.476%2066.7124%2066.4581%2066.6014C66.4545%2066.5759%2066.4482%2066.5509%2066.4395%2066.5266C66.4036%2066.4323%2066.3762%2066.3349%2066.3576%2066.2356C66.3555%2066.2174%2066.3506%2066.1997%2066.3432%2066.1828C66.2981%2066.1056%2066.2611%2066.024%2066.2327%2065.9393C66.1939%2065.767%2066.1938%2065.6271%2066.1434%2065.4586C66.136%2065.434%2066.1314%2065.4078%2066.1256%2065.3815C66.124%2065.3669%2066.1215%2065.3524%2066.1182%2065.338C66.0592%2065.1696%2066.0382%2064.9911%2065.9859%2064.82C65.9583%2064.734%2065.947%2064.6381%2065.9261%2064.5471L65.7926%2063.9651L65.7363%2063.6891C65.7214%2063.6317%2065.7119%2063.573%2065.708%2063.5138C65.7008%2063.3152%2065.6659%2063.1186%2065.6044%2062.9295L65.5097%2062.3309C65.4846%2062.2287%2065.4685%2062.1245%2065.4616%2062.0195C65.4551%2061.8916%2065.4364%2061.7646%2065.4057%2061.6402L65.3231%2060.9958L65.2924%2060.672C65.2924%2060.6462%2065.287%2060.6196%2065.2827%2060.595C65.2476%2060.4593%2065.2197%2060.3219%2065.1989%2060.1833C65.1853%2060.0187%2065.2078%2059.8545%2065.1989%2059.6904C65.19%2059.5705%2065.1492%2059.4468%2065.1504%2059.3273C65.1516%2059.2078%2065.171%2059.0987%2065.162%2058.9843C65.1611%2058.7893%2065.1497%2058.5945%2065.1279%2058.4007C65.1076%2058.2329%2065.1038%2058.0636%2065.1166%2057.895C65.1108%2057.7023%2065.1112%2057.5073%2065.1217%2057.3146C65.1263%2057.234%2065.1217%2057.1516%2065.1298%2057.0706C65.1295%2057.0258%2065.1259%2056.9812%2065.1193%2056.9369C65.1149%2056.9%2065.1167%2056.8626%2065.1248%2056.8263C65.1368%2056.681%2065.1341%2056.5345%2065.1395%2056.3892C65.1477%2056.1984%2065.1341%2056.0072%2065.1531%2055.8176C65.1546%2055.8104%2065.1555%2055.803%2065.1558%2055.7956C65.1457%2055.6052%2065.138%2055.473%2065.1372%2055.283C65.1372%2055.1377%2065.19%2054.9342%2065.1838%2054.7901C65.1799%2054.7245%2065.1838%2054.6563%2065.1838%2054.5896C65.1883%2054.4839%2065.1596%2054.3793%2065.1015%2054.2905C65.0456%2054.2158%2064.9851%2054.1526%2064.9284%2054.0824C64.8985%2054.0458%2064.8625%2054.0508%2064.8291%2054.0377C64.7394%2054.0015%2064.6525%2054.0562%2064.5656%2054.1194C64.5561%2054.1283%2064.5476%2054.1383%2064.5404%2054.1491C64.4774%2054.2454%2064.4283%2054.3499%2064.3945%2054.4597C64.3759%2054.5252%2064.3642%2054.5923%2064.3595%2054.6602C64.3298%2054.8889%2064.3129%2055.1191%2064.3091%2055.3497C64.306%2055.4572%2064.3374%2055.6338%2064.3386%2055.7405C64.3386%2055.7555%2064.3386%2055.771%2064.3386%2055.786C64.3262%2055.9787%2064.2998%2056.1005%2064.2874%2056.2917C64.2874%2056.3067%2064.2831%2056.3221%2064.2835%2056.3364C64.2924%2056.5164%2064.2835%2056.6956%2064.2742%2056.876C64.2804%2057.0678%2064.2976%2057.2592%2064.3258%2057.4491C64.3284%2057.4876%2064.3284%2057.5262%2064.3258%2057.5647C64.3047%2057.7061%2064.2954%2057.8489%2064.2982%2057.9918C64.316%2058.1445%2064.322%2058.2984%2064.3161%2058.452C64.3118%2058.5954%2064.3285%2058.736%2064.3359%2058.8759C64.3401%2058.9754%2064.3665%2059.0687%2064.3747%2059.1681C64.3836%2059.3122%2064.372%2059.4626%2064.3836%2059.6063C64.3906%2059.6792%2064.4224%2059.7871%2064.4356%2059.8557C64.44%2059.9371%2064.4392%2060.0187%2064.4333%2060.1001C64.4391%2060.1652%2064.4558%2060.3436%2064.462%2060.4084C64.4596%2060.5049%2064.4635%2060.6015%2064.4736%2060.6975C64.4952%2060.7769%2064.5124%2060.8575%2064.5252%2060.9387L64.592%2061.3943C64.6261%2061.6028%2064.6471%2061.7192%2064.6696%2061.883C64.6775%2061.9632%2064.6905%2062.0427%2064.7084%2062.1212C64.7142%2062.1505%2064.7204%2062.1817%2064.7266%2062.211C64.773%2062.4015%2064.8077%2062.5946%2064.8306%2062.7892L64.8605%2062.936C64.8784%2063.0105%2064.892%2063.0859%2064.9013%2063.1619C64.9087%2063.2382%2064.9253%2063.3134%2064.9505%2063.3858C65.0619%2063.7304%2065.0844%2064.016%2065.1616%2064.3286C65.1962%2064.4658%2065.2427%2064.5961%2065.287%2064.7275C65.3778%2065.0085%2065.3964%2065.3091%2065.481%2065.5974C65.5481%2065.8371%2065.6079%2066.0799%2065.6886%2066.3158C65.7065%2066.3698%2065.7154%2066.4276%2065.7321%2066.4823C65.7988%2066.6985%2065.8997%2066.8527%2065.9501%2067.0697C65.9952%2067.2701%2066.0623%2067.4729%2066.119%2067.6478C66.1578%2067.7635%2066.1923%2067.7704%2066.1966%2067.851C66.2331%2067.9908%2066.2868%2068.1257%2066.3564%2068.2526C66.3753%2068.3055%2066.3979%2068.357%2066.424%2068.4067C66.4533%2068.4694%2066.4956%2068.5252%2066.5481%2068.5706C66.6149%2068.6222%2066.6805%2068.6738%2066.7422%2068.6685C66.78%2068.6655%2066.8165%2068.6535%2066.8486%2068.6333C66.8806%2068.6132%2066.9072%2068.5855%2066.9261%2068.5528'%20fill='%23121C2D'/%3e%3cpath%20d='M75.9048%2067.1518C75.9534%2067.1183%2075.9906%2067.0708%2076.0115%2067.0158C76.0183%2067.0045%2076.0234%2066.9923%2076.0266%2066.9795C76.0328%2066.9252%2076.0817%2066.9175%2076.0771%2066.8473C76.0811%2066.7958%2076.0931%2066.7452%2076.1128%2066.6974L76.1174%2066.6766C76.1649%2066.531%2076.198%2066.3811%2076.2164%2066.2291C76.2173%2066.2221%2076.2186%2066.2152%2076.2202%2066.2083C76.2684%2066.0499%2076.2734%2065.8772%2076.3215%2065.7184C76.3262%2065.698%2076.329%2065.6773%2076.3301%2065.6564C76.3419%2065.5523%2076.3615%2065.4492%2076.3887%2065.348C76.3958%2065.3251%2076.4003%2065.3014%2076.4022%2065.2775C76.4074%2065.1833%2076.4218%2065.0898%2076.4453%2064.9985C76.4508%2064.9822%2076.4535%2064.9651%2076.4535%2064.948C76.4437%2064.8652%2076.4429%2064.7816%2076.4511%2064.6986C76.4913%2064.5517%2076.5233%2064.4027%2076.547%2064.2523C76.5493%2064.228%2076.5544%2064.2037%2076.5586%2064.1798C76.5625%2064.1665%2076.5655%2064.153%2076.5675%2064.1393C76.573%2063.9728%2076.625%2063.8117%2076.6281%2063.6433C76.6304%2063.5589%2076.651%2063.471%2076.6607%2063.3843C76.6812%2063.1997%2076.7045%2063.0147%2076.7204%2062.8293L76.7457%2062.5676C76.7476%2062.5121%2076.7553%2062.4569%2076.7685%2062.403C76.822%2062.2241%2076.8416%2062.037%2076.8264%2061.8511L76.8815%2061.2864C76.8809%2061.1879%2076.8873%2061.0895%2076.9009%2060.992C76.9206%2060.8737%2076.9283%2060.7537%2076.9238%2060.6339C76.9455%2060.4319%2076.9474%2060.2288%2076.9587%2060.0261C76.9645%2059.9247%2076.9711%2059.8233%2076.9808%2059.7224C76.9832%2059.6979%2076.9843%2059.6733%2076.9839%2059.6487C76.9839%2059.5192%2076.9509%2059.3855%2076.9564%2059.256C76.9622%2059.1018%2077.0045%2058.9515%2077.0126%2058.7977C77.0196%2058.6852%2076.9897%2058.5665%2076.9983%2058.4547C77.0068%2058.3429%2077.0371%2058.2431%2077.0371%2058.1348C77.0536%2057.9525%2077.0536%2057.769%2077.0371%2057.5867C77.0223%2057.4287%2077.0241%2057.2695%2077.0425%2057.1119C77.0464%2056.9303%2077.0394%2056.7484%2077.0491%2056.5669C77.053%2056.4898%2077.0491%2056.4127%2077.0542%2056.3379C77.0535%2056.2959%2077.0494%2056.2541%2077.0421%2056.2127C77.0373%2056.1779%2077.0386%2056.1426%2077.046%2056.1082C77.053%2055.9718%2077.0406%2055.8342%2077.0379%2055.6974C77.0344%2055.5181%2077.015%2055.3397%2077.0177%2055.1605C77.0183%2055.1535%2077.0183%2055.1466%2077.0177%2055.1397C76.989%2054.9624%2076.9684%2054.8398%2076.9486%2054.6625C76.953%2054.5075%2076.9495%2054.3523%2076.9381%2054.1977C76.9253%2054.1372%2076.9183%2054.0736%2076.9083%2054.0115C76.8976%2053.9121%2076.8541%2053.819%2076.7845%2053.7467C76.7189%2053.6862%2076.6506%2053.6373%2076.5835%2053.5821C76.5485%2053.5536%2076.5136%2053.564%2076.4787%2053.5571C76.3856%2053.539%2076.3072%2053.6022%2076.2299%2053.6727C76.2217%2053.682%2076.2148%2053.6924%2076.2094%2053.7036C76.1607%2053.7975%2076.1266%2053.8982%2076.1081%2054.0023C76.0988%2054.0628%2076.0965%2054.1242%2076.1011%2054.1853C76.1046%2054.3923%2076.1131%2054.6004%2076.1291%2054.8078C76.136%2054.9042%2076.1842%2055.0599%2076.1958%2055.1547C76.1958%2055.1682%2076.2008%2055.182%2076.2016%2055.1955C76.2059%2055.3686%2076.183%2055.4811%2076.1807%2055.6538C76.1799%2055.6673%2076.1799%2055.6808%2076.1807%2055.6943C76.197%2055.8557%2076.2024%2056.0181%2076.197%2056.1803C76.2048%2056.3534%2076.2239%2056.5257%2076.254%2056.6964C76.2565%2056.7306%2076.2565%2056.765%2076.254%2056.7993C76.2349%2056.927%2076.2235%2057.0557%2076.2199%2057.1847C76.2324%2057.3228%2076.2334%2057.4616%2076.2226%2057.5998C76.2148%2057.7286%2076.2226%2057.8554%2076.2191%2057.9852C76.216%2058.0747%2076.2354%2058.1606%2076.2334%2058.2504C76.2334%2058.3807%2076.2098%2058.5148%2076.209%2058.6447C76.209%2058.7102%2076.2284%2058.8104%2076.2319%2058.8733C76.2268%2058.9467%2076.2164%2059.0198%2076.2008%2059.0918C76.2008%2059.1504%2076.1946%2059.3119%2076.1931%2059.3708C76.1896%2059.4537%2076.1601%2059.547%2076.1636%2059.6299C76.1719%2059.7036%2076.1761%2059.7777%2076.176%2059.8519L76.1686%2060.2673C76.1651%2060.4581%2076.1585%2060.5641%2076.1465%2060.7129C76.139%2060.7852%2076.1363%2060.858%2076.1384%2060.9307V61.0135C76.1445%2061.1906%2076.1336%2061.3678%2076.1058%2061.5427L76.0988%2061.6776C76.0984%2061.7469%2076.0934%2061.816%2076.0837%2061.8846C76.0736%2061.9531%2076.0703%2062.0224%2076.0736%2062.0916C76.0671%2062.3828%2076.0437%2062.6734%2076.0033%2062.9619C75.9917%2063.089%2075.9932%2063.2143%2075.9925%2063.34C75.9671%2063.6077%2075.9272%2063.8739%2075.8729%2064.1374L75.7953%2064.8096C75.7899%2064.8609%2075.7751%2064.9117%2075.7682%2064.9638C75.7659%2065.1533%2075.7519%2065.3425%2075.7263%2065.5303C75.6789%2065.7107%2075.6487%2065.9019%2075.6238%2066.0668C75.606%2066.1767%2075.6355%2066.1967%2075.6025%2066.2626C75.5684%2066.3895%2075.5516%2066.5203%2075.5524%2066.6515C75.5435%2066.7025%2075.5386%2066.754%2075.5377%2066.8057C75.5337%2066.8693%2075.5442%2066.9329%2075.5683%2066.9919C75.6021%2067.0636%2075.6347%2067.136%2075.6906%2067.1603C75.7245%2067.1761%2075.7617%2067.1839%2075.7992%2067.1831C75.8367%2067.1823%2075.8735%2067.1729%2075.9067%2067.1557'%20fill='%23121C2D'/%3e%3cpath%20d='M86.8666%2066.734C86.9044%2066.6905%2086.9283%2066.6368%2086.9353%2066.5798C86.939%2066.5673%2086.9407%2066.5543%2086.9403%2066.5413C86.9322%2066.4885%2086.9791%2066.4692%2086.9555%2066.4048C86.9461%2066.3554%2086.9448%2066.3048%2086.9516%2066.2549C86.9516%2066.2484%2086.9516%2066.241%2086.9516%2066.2345C86.9591%2066.0859%2086.9535%2065.9369%2086.9349%2065.7893C86.9344%2065.7825%2086.9344%2065.7757%2086.9349%2065.7689C86.9438%2065.6078%2086.9074%2065.4444%2086.9155%2065.2833C86.9149%2065.2629%2086.9126%2065.2427%2086.9085%2065.2227C86.8946%2065.1216%2086.8898%2065.0195%2086.8942%2064.9175C86.8959%2064.8942%2086.895%2064.8708%2086.8914%2064.8477C86.8754%2064.7574%2086.8685%2064.6657%2086.8709%2064.5741C86.8724%2064.5575%2086.8712%2064.5409%2086.8674%2064.5247C86.8394%2064.4485%2086.82%2064.3694%2086.8096%2064.2889C86.8177%2064.141%2086.8177%2063.9927%2086.8096%2063.8448C86.8068%2063.8213%2086.8069%2063.7974%2086.8057%2063.7735C86.8066%2063.7607%2086.8066%2063.7478%2086.8057%2063.735C86.7762%2063.5754%2086.7925%2063.4124%2086.7638%2063.2513C86.749%2063.1703%2086.7521%2063.0821%2086.7455%2062.9973L86.697%2062.4577L86.6734%2062.2022C86.6651%2062.1486%2086.6625%2062.0944%2086.6656%2062.0403C86.6839%2061.8593%2086.669%2061.6764%2086.6218%2061.5007L86.5721%2060.948C86.5538%2060.8532%2086.5429%2060.7572%2086.5395%2060.6608C86.5374%2060.5432%2086.5226%2060.4261%2086.4952%2060.3116C86.4786%2060.1128%2086.4433%2059.917%2086.4176%2059.7196L86.3819%2059.4232C86.3793%2059.3993%2086.3753%2059.3754%2086.3699%2059.3519C86.3424%2059.2282%2086.2873%2059.1056%2086.2686%2058.98C86.2461%2058.8305%2086.2566%2058.6794%2086.2353%2058.5298C86.2193%2058.4211%2086.1697%2058.3121%2086.1576%2058.2041C86.1456%2058.0962%2086.1553%2057.9945%2086.1351%2057.8916C86.117%2057.7143%2086.0841%2057.5389%2086.037%2057.367C85.9946%2057.2186%2085.9686%2057.0661%2085.9594%2056.9122C85.9306%2056.738%2085.8969%2056.5653%2085.8775%2056.3896C85.8693%2056.3163%2085.8523%2056.2427%2085.8468%2056.1691C85.8391%2056.1291%2085.8285%2056.0896%2085.815%2056.0512C85.8045%2056.0187%2085.8003%2055.9846%2085.8026%2055.9506C85.789%2055.8187%2085.758%2055.6885%2085.7366%2055.5578C85.7083%2055.3863%2085.6625%2055.2182%2085.6423%2055.0456C85.6422%2055.0388%2085.6414%2055.0321%2085.64%2055.0255C85.5899%2054.859%2085.5542%2054.7434%2085.5131%2054.5754C85.4817%2054.447%2085.4918%2054.2543%2085.4491%2054.1294C85.4297%2054.0728%2085.4161%2054.0138%2085.399%2053.9537C85.3776%2053.8584%2085.3244%2053.7731%2085.2481%2053.7116C85.1767%2053.6604%2085.1037%2053.6199%2085.0315%2053.5736C84.9927%2053.5494%2084.9601%2053.5636%2084.9248%2053.5601C84.8297%2053.5517%2084.7583%2053.6214%2084.6893%2053.6977C84.6821%2053.7076%2084.6763%2053.7184%2084.6718%2053.7297C84.6337%2053.8268%2084.6105%2053.9291%2084.6031%2054.0331C84.6008%2054.0934%2084.6054%2054.1538%2084.6167%2054.2131C84.6412%2054.4158%2084.6761%2054.6181%2084.7176%2054.8193C84.737%2054.913%2084.8045%2055.0591%2084.8278%2055.1512C84.8309%2055.1647%2084.8363%2055.177%2084.8383%2055.1897C84.8647%2055.3582%2084.8604%2055.4711%2084.8825%2055.6403C84.8831%2055.6532%2084.8844%2055.6661%2084.8864%2055.6788C84.9255%2055.8341%2084.9545%2055.9917%2084.9733%2056.1506C85.0089%2056.3176%2085.0554%2056.4822%2085.1126%2056.6432C85.1205%2056.6762%2085.1262%2056.7096%2085.1297%2056.7434C85.1307%2056.8704%2085.141%2056.9971%2085.1608%2057.1226C85.1973%2057.2541%2085.2225%2057.3885%2085.236%2057.5242C85.2512%2057.6507%2085.2826%2057.7721%2085.3016%2057.8962C85.3152%2057.9829%2085.3501%2058.0623%2085.3656%2058.149C85.3882%2058.2751%2085.392%2058.4084%2085.4142%2058.5344C85.4254%2058.5977%2085.4654%2058.6886%2085.4809%2058.7495C85.4902%2058.8211%2085.4942%2058.8932%2085.4929%2058.9654C85.5022%2059.022%2085.5282%2059.1777%2085.5375%2059.2352C85.5399%2059.3201%2085.5467%2059.4049%2085.5581%2059.4891C85.5818%2059.5577%2085.6004%2059.6279%2085.6136%2059.6992L85.6838%2060.0977C85.7153%2060.2808%2085.7292%2060.3837%2085.7459%2060.5279C85.7521%2060.5985%2085.7629%2060.6687%2085.7781%2060.7379C85.7843%2060.7638%2085.7855%2060.7923%2085.7921%2060.8173C85.8289%2060.9864%2085.8508%2061.1583%2085.8573%2061.3311L85.8744%2061.4625C85.886%2061.5293%2085.8931%2061.5968%2085.8957%2061.6645C85.8976%2061.7322%2085.9068%2061.7995%2085.9233%2061.8653C85.9713%2062.147%2086.0026%2062.4313%2086.0172%2062.7167C86.0308%2062.8416%2086.056%2062.9618%2086.0808%2063.0832C86.1316%2063.3419%2086.0975%2063.6097%2086.1258%2063.8749C86.1495%2064.0958%2086.1646%2064.3174%2086.193%2064.5375C86.1992%2064.5876%2086.1964%2064.6396%2086.2011%2064.6916C86.2408%2064.8738%2086.2702%2065.0581%2086.2892%2065.2435C86.2869%2065.4266%2086.3051%2065.6159%2086.3195%2065.7797C86.3288%2065.8888%2086.3622%2065.9007%2086.3459%2065.9724C86.3452%2066.1014%2086.3625%2066.23%2086.3971%2066.3543C86.4015%2066.4048%2086.4101%2066.4548%2086.4227%2066.5039C86.4354%2066.5654%2086.4619%2066.6232%2086.5003%2066.6731C86.5515%2066.7325%2086.602%2066.7918%2086.6621%2066.8007C86.6991%2066.8067%2086.7369%2066.8044%2086.7728%2066.7939C86.8088%2066.7835%2086.8419%2066.7651%2086.8697%2066.7402'%20fill='%23121C2D'/%3e%3cpath%20d='M103.004%2050.6564C103.013%2050.7372%20103.036%2050.8156%20103.074%2050.8876C103.081%2050.9059%20103.089%2050.9236%20103.099%2050.9404C103.146%2051.0071%20103.12%2051.0514%20103.186%2051.1312C103.23%2051.196%20103.266%2051.2659%20103.293%2051.3394L103.307%2051.3687C103.401%2051.5928%20103.507%2051.8115%20103.625%2052.0239C103.63%2052.0343%20103.636%2052.0447%20103.641%2052.0547C103.766%2052.3098%20103.915%2052.5529%20104.085%2052.7809C104.106%2052.8109%20104.13%2052.8391%20104.156%2052.8649L104.523%2053.258C104.55%2053.2877%20104.58%2053.3155%20104.611%2053.3413C104.733%2053.4407%20104.855%2053.5421%20104.971%2053.6457C104.992%2053.6654%20105.014%2053.683%20105.038%2053.6986C105.137%2053.7575%20105.3%2053.84%20105.39%2053.9082C105.583%2054.0659%20105.785%2054.2113%20105.995%2054.3438L106.096%2054.4073C106.115%2054.4197%20106.135%2054.4351%20106.152%2054.4459C106.392%2054.5696%20106.607%2054.7269%20106.856%2054.846C106.98%2054.9049%20107.105%2054.9828%20107.232%2055.0472C107.502%2055.1846%20107.777%2055.3131%20108.056%2055.4326L108.452%2055.5983C108.537%2055.6292%20108.621%2055.6646%20108.702%2055.7043C108.971%2055.8442%20109.258%2055.9472%20109.556%2056.0103C109.849%2056.1055%20110.147%2056.1899%20110.445%2056.2713C110.601%2056.314%20110.774%2056.3318%20110.92%2056.38C111.115%2056.4326%20111.315%2056.4649%20111.517%2056.4763C111.869%2056.5237%20112.225%2056.5253%20112.577%2056.4809C112.759%2056.458%20112.939%2056.4209%20113.115%2056.3699C113.157%2056.3568%20113.2%2056.3414%20113.241%2056.3256C113.464%2056.2299%20113.674%2056.107%20113.866%2055.9598C114.115%2055.7958%20114.327%2055.5808%20114.487%2055.3293C114.611%2055.0287%20114.692%2054.7125%20114.728%2054.3896C114.741%2054.2894%20114.741%2054.188%20114.728%2054.0878C114.701%2053.7515%20114.603%2053.4246%20114.44%2053.1285C114.279%2052.8753%20114.15%2052.6309%20114%2052.4293C113.825%2052.1881%20113.633%2051.958%20113.448%2051.7244C113.37%2051.6269%20113.28%2051.5363%20113.203%2051.438C113.156%2051.387%20113.106%2051.3391%20113.053%2051.2947C113.009%2051.2568%20112.97%2051.2143%20112.936%2051.1678C112.786%2051.0017%20112.619%2050.8487%20112.454%2050.6965C112.239%2050.4945%20112.006%2050.3172%20111.789%2050.123C111.78%2050.1156%20111.772%2050.1068%20111.763%2050.1006L111.122%2049.6554C110.943%2049.529%20110.717%2049.3086%20110.53%2049.1987L110.276%2049.0372C110.151%2048.9504%20110.009%2048.8931%20109.858%2048.8696C109.737%2048.8591%20109.629%2048.8615%20109.515%2048.8572C109.454%2048.8549%20109.444%2048.8908%20109.411%2048.9096C109.324%2048.9601%20109.351%2049.08%20109.388%2049.2056C109.394%2049.2214%20109.403%2049.2364%20109.413%2049.2504C109.503%2049.3831%20109.607%2049.5065%20109.723%2049.6188C109.794%2049.6856%20109.87%2049.7477%20109.95%2049.8046L110.745%2050.4024C110.868%2050.4934%20111.09%2050.6171%20111.213%2050.7084L111.266%2050.747C111.474%2050.9239%20111.592%2051.0553%20111.789%2051.243C111.804%2051.258%20111.818%2051.275%20111.833%2051.2881C112.028%2051.4506%20112.211%2051.6266%20112.38%2051.815C112.587%2052.0416%20112.75%2052.1526%20112.958%2052.38C112.994%2052.4193%20113.029%2052.4606%20113.061%2052.5037C113.157%2052.6344%20113.294%2052.8757%20113.398%2053.0002C113.528%2053.1506%20113.634%2053.3195%20113.714%2053.5012C113.785%2053.6586%20113.841%2053.8225%20113.88%2053.9907C113.91%2054.1014%20113.93%2054.2149%20113.938%2054.3295C113.933%2054.4914%20113.9%2054.6512%20113.84%2054.8016C113.822%2054.8435%20113.807%2054.8866%20113.796%2054.9308C113.78%2054.9729%20113.761%2055.014%20113.74%2055.0541C113.687%2055.1262%20113.623%2055.1887%20113.549%2055.2387C113.519%2055.2595%20113.474%2055.3089%20113.417%2055.3482L113.269%2055.4457C113.168%2055.4904%20113.052%2055.5266%20112.944%2055.5644C112.855%2055.6122%20112.759%2055.6478%20112.66%2055.67C112.469%2055.7117%20112.274%2055.7352%20112.078%2055.7402C111.857%2055.7443%20111.636%2055.7283%20111.418%2055.6924C111.31%2055.6746%20111.2%2055.6538%20111.09%2055.6399L110.964%2055.6187C110.689%2055.5755%20110.418%2055.5092%20110.154%2055.4206L109.948%2055.3647C109.843%2055.3377%20109.74%2055.3053%20109.638%2055.2676C109.536%2055.2295%20109.433%2055.1967%20109.328%2055.1693C108.888%2055.0368%20108.459%2054.8686%20108.047%2054.6664L107.497%2054.4351C107.117%2054.2423%20106.748%2054.027%20106.394%2053.7903C106.085%2053.6103%20105.791%2053.4145%20105.506%2053.2121C105.442%2053.1659%20105.381%2053.1108%20105.319%2053.0611C105.079%2052.9017%20104.858%2052.7147%20104.661%2052.5041C104.495%2052.29%20104.346%2052.063%20104.216%2051.8254C104.133%2051.6747%20104.094%2051.6674%20104.063%2051.5587C103.978%2051.3636%20103.874%2051.1773%20103.752%2051.0021C103.711%2050.9267%20103.664%2050.8542%20103.612%2050.7851C103.553%2050.7003%20103.478%2050.6268%20103.393%2050.5681C103.293%2050.5041%20103.187%2050.4506%20103.129%2050.4698C103.091%2050.4839%20103.059%2050.5097%20103.037%2050.5434C103.015%2050.577%20103.005%2050.6168%20103.007%2050.6568'%20fill='%23121C2D'/%3e%3cpath%20d='M110.021%2053.2117C110.044%2053.0252%20110.049%2052.8368%20110.035%2052.6494C110.035%2052.6047%20110.032%2052.5527%20110.026%2052.5095C110.002%2052.3121%20110.04%2052.2482%20109.998%2052.0053C109.967%2051.8269%20109.964%2051.635%20109.951%2051.4492C109.949%2051.4241%20109.947%2051.3964%20109.945%2051.3721C109.921%2050.8298%20109.867%2050.2713%20109.832%2049.7148C109.832%2049.6893%20109.828%2049.6627%20109.827%2049.6377C109.81%2049.0422%20109.757%2048.4259%20109.758%2047.8285C109.758%2047.7583%20109.752%2047.6774%20109.749%2047.6015C109.733%2047.2218%20109.725%2046.8333%20109.737%2046.4702C109.74%2046.3885%20109.744%2046.3161%20109.747%2046.2267C109.739%2045.9423%20109.819%2045.6624%20109.975%2045.4242L110.065%2045.3105C110.238%2045.0999%20110.446%2044.9192%20110.678%2044.7755C111.178%2044.4556%20111.588%2044.244%20112.096%2043.9237L112.325%2043.785L112.456%2043.7079C112.965%2043.3745%20113.501%2043.0716%20114.003%2042.7004C114.256%2042.5139%20114.531%2042.3208%20114.786%2042.1146C115.34%2041.6767%20115.839%2041.1747%20116.273%2040.6191C116.479%2040.354%20116.666%2040.0745%20116.832%2039.7827C116.939%2039.6%20117.035%2039.3973%20117.13%2039.225C117.323%2038.873%20117.476%2038.501%20117.588%2038.1158C117.671%2037.8263%20117.722%2037.5808%20117.799%2037.242C117.948%2036.5526%20118.049%2035.8541%20118.102%2035.1511C118.132%2034.7915%20118.132%2034.3953%20118.153%2034.0684C118.174%2033.816%20118.175%2033.592%20118.179%2033.3951C118.186%2033.2071%20118.213%2033.0203%20118.258%2032.8378C118.274%2032.7744%20118.284%2032.71%20118.289%2032.645C118.296%2032.5614%20118.291%2032.4772%20118.274%2032.3949C118.258%2032.312%20118.226%2032.2328%20118.18%2032.1613L118.012%2031.9709C117.898%2031.8802%20117.767%2031.8141%20117.625%2031.7768C117.484%2031.7395%20117.337%2031.7319%20117.193%2031.7543C116.952%2031.7914%20116.723%2031.8822%20116.524%2032.0199C116.33%2032.1475%20116.162%2032.3091%20116.028%2032.4966C115.821%2032.83%20115.64%2033.1778%20115.484%2033.5373L115.368%2033.7686C115.271%2033.9767%20115.172%2034.1875%20115.073%2034.3983C114.962%2034.6084%20114.849%2034.8185%20114.73%2035.022C114.448%2035.5049%20114.136%2035.9662%20113.856%2036.4411C113.689%2036.7733%20113.46%2037.0705%20113.181%2037.3164C112.88%2037.5119%20112.559%2037.6741%20112.222%2037.8001C111.609%2038.0699%20110.949%2038.3397%20110.39%2038.6407C109.844%2038.9356%20109.343%2039.1483%20108.824%2039.4116C108.227%2039.7176%20107.643%2040.0309%20107.049%2040.3532C106.791%2040.4966%20106.541%2040.6543%20106.3%2040.8253C106.164%2040.9267%20106.036%2041.0376%20105.917%2041.1572C105.768%2041.3144%20105.765%2041.3036%20105.617%2041.4655C105.269%2041.8966%20105.009%2042.3907%20104.85%2042.9205C104.634%2043.5826%20104.522%2044.2159%20104.351%2044.8434C104.345%2044.8677%20104.338%2044.8935%20104.331%2044.9166L103.962%2046.6233C103.853%2047.1066%20103.645%2047.7795%20103.548%2048.2598C103.501%2048.4768%20103.452%2048.7042%20103.404%2048.9266C103.325%2049.2515%20103.281%2049.5837%20103.272%2049.9179C103.275%2050.1646%20103.291%2050.3715%20103.3%2050.5997C103.305%2050.7188%20103.346%2050.7003%20103.371%2050.7431C103.438%2050.8587%20103.567%2050.6745%20103.702%2050.4656C103.72%2050.4341%20103.735%2050.4017%20103.749%2050.3684C103.868%2050.1083%20103.994%2049.7333%20104.12%2049.3567C104.184%2049.164%20104.241%2048.9246%20104.298%2048.7073C104.49%2047.9684%20104.673%2047.2207%20104.85%2046.4718C104.931%2046.1249%20105.031%2045.5468%20105.108%2045.1999C105.12%2045.1506%20105.13%2045.1004%20105.141%2045.0515C105.298%2044.4348%20105.411%2044.0259%20105.584%2043.4404L105.627%2043.3051C105.755%2042.7809%20106.011%2042.296%20106.372%2041.8929C106.798%2041.475%20107.281%2041.1194%20107.808%2040.8369C107.92%2040.7733%20108.028%2040.7139%20108.142%2040.6553C108.48%2040.4796%20109.077%2040.2117%20109.413%2040.0286C109.858%2039.7839%20110.324%2039.5592%20110.784%2039.3491C111.215%2039.1518%20111.637%2038.9471%20112.068%2038.7571C112.37%2038.6226%20112.65%2038.4873%20112.972%2038.3305C113.219%2038.214%20113.455%2038.0735%20113.675%2037.9111C113.898%2037.7377%20114.094%2037.5323%20114.257%2037.3018C114.419%2037.0547%20114.567%2036.7982%20114.699%2036.5336C114.848%2036.2638%20114.974%2036.1008%20115.129%2035.8421L115.65%2034.9456C115.812%2034.6886%20115.985%2034.3644%20116.125%2034.0834C116.312%2033.698%20116.292%2033.6949%20116.457%2033.3303C116.537%2033.1386%20116.648%2032.9614%20116.787%2032.8058C116.913%2032.6745%20117.072%2032.5785%20117.247%2032.5275C117.318%2032.504%20117.395%2032.5055%20117.465%2032.5317C117.478%2032.536%20117.49%2032.5424%20117.501%2032.5506C117.505%2032.5506%20117.503%2032.5506%20117.507%2032.5537C117.512%2032.5574%20117.515%2032.5625%20117.517%2032.5683C117.519%2032.5767%20117.519%2032.5854%20117.517%2032.5938C117.511%2032.6385%20117.503%2032.6828%20117.491%2032.7264C117.461%2032.8578%20117.435%2032.9962%20117.413%2033.1503C117.404%2033.2248%20117.397%2033.2996%20117.392%2033.3746L117.387%2033.5789V33.9832C117.387%2034.0831%20117.387%2034.191%20117.387%2034.2916C117.385%2034.9317%20117.333%2035.5707%20117.232%2036.2029C117.209%2036.3635%20117.184%2036.5231%20117.157%2036.6816C117.118%2036.925%20117.066%2037.1662%20117.002%2037.4043L116.8%2038.1111C116.501%2039.0956%20115.971%2039.9956%20115.254%2040.7367C114.95%2041.0669%20114.625%2041.3777%20114.281%2041.6671C113.503%2042.267%20112.682%2042.8104%20111.826%2043.2932L110.758%2043.9627C110.381%2044.1882%20110.025%2044.4462%20109.693%2044.7335C109.521%2044.8918%20109.381%2045.0804%20109.279%2045.2897C109.128%2045.6576%20109.065%2046.0553%20109.096%2046.4514C109.108%2046.7982%20109.128%2047.1251%20109.128%2047.5013C109.128%2048.1889%20109.167%2048.9046%20109.205%2049.5217C109.232%2049.9321%20109.268%2049.9842%20109.265%2050.2459C109.261%2050.6698%20109.361%2051.2029%20109.409%2051.6874C109.428%2051.877%20109.454%2052.0728%20109.481%2052.2512C109.511%2052.4691%20109.557%2052.6845%20109.618%2052.8957C109.657%2053.0754%20109.729%2053.2463%20109.832%2053.399C109.91%2053.4503%20109.978%2053.399%20110.022%2053.2094'%20fill='%23121C2D'/%3e%3cpath%20d='M105.471%2042.7983C105.521%2042.775%20105.562%2042.7369%20105.59%2042.6892C105.597%2042.68%20105.603%2042.6696%20105.608%2042.6584C105.619%2042.6102%20105.668%2042.6098%20105.67%2042.5466C105.679%2042.5007%20105.696%2042.4567%20105.72%2042.4167C105.722%2042.4107%20105.724%2042.4047%20105.727%2042.399C105.787%2042.2757%20105.836%2042.1475%20105.874%2042.0159C105.875%2042.01%20105.877%2042.0042%20105.88%2041.9985C105.948%2041.8671%20105.978%2041.7172%20106.05%2041.5892C106.058%2041.5726%20106.064%2041.5551%20106.068%2041.5372C106.096%2041.4496%20106.134%2041.3654%20106.181%2041.2863C106.192%2041.2685%20106.202%2041.2497%20106.209%2041.23C106.234%2041.1519%20106.268%2041.0773%20106.312%2041.008C106.321%2040.9964%20106.328%2040.9834%20106.332%2040.9695C106.342%2040.8977%20106.362%2040.8278%20106.393%2040.7621C106.468%2040.6403%20106.548%2040.5628%20106.619%2040.4414C106.629%2040.4233%20106.642%2040.4067%20106.654%2040.3898C106.661%2040.381%20106.669%2040.3718%20106.675%2040.362C106.739%2040.2352%20106.845%2040.1393%20106.92%2040.0202C106.965%2039.9624%20107.013%2039.9069%20107.064%2039.854L107.394%2039.4632L107.549%2039.2786C107.579%2039.2379%20107.614%2039.2007%20107.653%2039.1676C107.874%2039.0073%20107.877%2038.9136%20107.988%2038.7849C108.099%2038.6561%20108.215%2038.5224%20108.333%2038.3948C108.385%2038.3213%20108.444%2038.2523%20108.508%2038.1886C108.588%2038.1132%20108.659%2038.0292%20108.721%2037.9381C108.85%2037.7962%20108.968%2037.6443%20109.073%2037.4837C109.127%2037.4066%20109.18%2037.3337%20109.236%2037.2632C109.25%2037.2463%20109.263%2037.2285%20109.275%2037.21C109.326%2037.108%20109.382%2037.009%20109.444%2036.9136C109.531%2036.8225%20109.624%2036.7375%20109.723%2036.6592C109.785%2036.6034%20109.83%2036.5182%20109.894%2036.487C109.944%2036.4652%20109.997%2036.4514%20110.051%2036.4461C110.144%2036.4318%20110.238%2036.4296%20110.332%2036.4396C110.421%2036.4338%20110.472%2036.5066%20110.526%2036.5648C110.597%2036.6374%20110.647%2036.7285%20110.669%2036.8277C110.681%2036.8706%20110.687%2036.9147%20110.689%2036.9591C110.689%2036.9726%20110.702%2037.0177%20110.706%2037.0308C110.715%2037.0616%20110.708%2037.0616%20110.7%2037.0921C110.689%2037.1843%20110.673%2037.2759%20110.652%2037.3665C110.622%2037.5009%20110.576%2037.6313%20110.515%2037.755C110.512%2037.7596%20110.509%2037.7645%20110.507%2037.7697C110.47%2037.8977%20110.423%2038.0225%20110.366%2038.1431C110.316%2038.2484%20110.193%2038.3698%20110.146%2038.48C110.125%2038.5297%20110.096%2038.5798%20110.072%2038.6295C110.026%2038.7092%20110.011%2038.8023%20110.027%2038.8924C110.047%2038.9749%20110.075%2039.0512%20110.098%2039.1306C110.11%2039.1722%20110.144%2039.1849%20110.168%2039.2108C110.205%2039.2399%20110.247%2039.2607%20110.293%2039.2717C110.338%2039.2826%20110.386%2039.2834%20110.432%2039.274C110.443%2039.2721%20110.454%2039.2687%20110.465%2039.2639C110.556%2039.2238%20110.639%2039.1694%20110.713%2039.1028C110.755%2039.0628%20110.791%2039.0177%20110.822%2038.9687C110.939%2038.8057%20111.044%2038.6341%20111.135%2038.4553C111.18%2038.3709%20111.213%2038.2106%20111.249%2038.1204C111.253%2038.1073%20111.258%2038.0945%20111.263%2038.0818C111.338%2037.941%20111.404%2037.7957%20111.461%2037.6467C111.467%2037.6331%20111.472%2037.6192%20111.476%2037.6051C111.515%2037.4235%20111.541%2037.2393%20111.553%2037.0539C111.548%2036.8392%20111.486%2036.6296%20111.375%2036.4453L111.319%2036.3297C111.259%2036.1741%20111.164%2036.0347%20111.039%2035.9231C110.888%2035.8092%20110.72%2035.7192%20110.541%2035.6564C110.372%2035.6094%20110.194%2035.5978%20110.021%2035.6224C109.902%2035.6441%20109.787%2035.6815%20109.679%2035.7335C109.526%2035.7976%20109.383%2035.8842%20109.257%2035.9905C109.2%2036.0507%20109.148%2036.1151%20109.101%2036.1832C109.045%2036.2515%20108.99%2036.2757%20108.933%2036.3374C108.894%2036.3817%20108.796%2036.5109%20108.761%2036.5563C108.702%2036.6169%20108.647%2036.6813%20108.597%2036.749C108.567%2036.8123%20108.533%2036.8738%20108.496%2036.9333L108.292%2037.2416C108.215%2037.3489%20108.131%2037.4519%20108.042%2037.55C107.997%2037.5981%20107.955%2037.6497%20107.917%2037.7041C107.904%2037.7249%20107.885%2037.7427%20107.872%2037.7646C107.781%2037.8981%20107.678%2038.0231%20107.564%2038.1381L107.487%2038.2349C107.45%2038.2862%20107.409%2038.3348%20107.365%2038.3802C107.321%2038.4252%20107.282%2038.4751%20107.249%2038.5289C107.093%2038.7442%20106.925%2038.9501%20106.744%2039.1456C106.671%2039.237%20106.61%2039.3326%20106.544%2039.4305C106.392%2039.6459%20106.191%2039.8263%20106.053%2040.0556C105.937%2040.2422%20105.834%2040.4361%20105.743%2040.6361C105.723%2040.6815%20105.695%2040.7243%20105.674%2040.7694C105.594%2040.9494%20105.589%2041.1121%20105.502%2041.282C105.426%2041.4362%20105.363%2041.5957%20105.311%2041.7592C105.277%2041.8575%20105.303%2041.881%20105.262%2041.9361C105.194%2042.0263%20105.204%2042.1716%20105.168%2042.288C105.154%2042.3335%20105.144%2042.38%20105.138%2042.4271C105.128%2042.4856%20105.132%2042.5456%20105.15%2042.6021C105.165%2042.6685%20105.202%2042.728%20105.255%2042.7713C105.287%2042.79%20105.323%2042.8017%20105.36%2042.8057C105.397%2042.8097%20105.434%2042.8059%20105.47%2042.7944'%20fill='%23121C2D'/%3e%3cpath%20d='M53.7251%2084.5619C53.6804%2084.471%2053.6191%2084.3892%2053.5442%2084.3206C53.5287%2084.3016%2053.512%2084.2836%2053.4942%2084.2666C53.4142%2084.2007%2053.4216%2084.1456%2053.3145%2084.0739C53.2387%2084.0133%2053.1706%2083.9438%2053.1116%2083.8669L53.0844%2083.8384C52.9039%2083.6218%2052.7099%2083.4067%2052.5345%2083.1782C52.5264%2083.1682%2052.5178%2083.157%2052.5101%2083.1473C52.3284%2082.8935%2052.1637%2082.628%2052.0173%2082.3526C51.9999%2082.3175%2051.9807%2082.2833%2051.9598%2082.2501C51.8623%2082.0801%2051.7794%2081.9023%2051.7119%2081.7186C51.6989%2081.6758%2051.6834%2081.6338%2051.6653%2081.5929C51.5895%2081.4343%2051.5298%2081.2685%2051.4872%2081.098C51.4801%2081.0671%2051.4703%2081.0368%2051.4581%2081.0075C51.395%2080.8668%2051.3431%2080.7214%2051.3029%2080.5727C51.247%2080.269%2051.2392%2080.0331%2051.2028%2079.7298L51.1942%2079.5941C51.1942%2079.5683%2051.1942%2079.5409%2051.1919%2079.517C51.1707%2079.2083%2051.1729%2078.8985%2051.1985%2078.5901C51.2084%2078.4269%2051.2272%2078.2644%2051.2548%2078.1033C51.3021%2077.7564%2051.3712%2077.4095%2051.455%2077.0653C51.4933%2076.9024%2051.5352%2076.7397%2051.5807%2076.577C51.6057%2076.4734%2051.6371%2076.3715%2051.6746%2076.2717C51.8086%2075.9377%2051.9164%2075.5939%2051.9971%2075.2434L52.3304%2074.177C52.3847%2073.9885%2052.4177%2073.7792%2052.4833%2073.6065C52.5483%2073.3782%2052.6009%2073.1467%2052.6409%2072.9128C52.7317%2072.5216%2052.8019%2072.1273%2052.8737%2071.7349C52.9125%2071.538%2052.9482%2071.3425%2052.985%2071.1464L53.0099%2071.0038C53.044%2070.7517%2053.0487%2070.4892%2053.091%2070.2379C53.1422%2069.9384%2053.2198%2069.6509%2053.2679%2069.3514C53.3025%2069.1337%2053.3067%2068.8993%2053.3428%2068.6839C53.3789%2068.4684%2053.4336%2068.2765%2053.4592%2068.0672C53.5058%2067.7122%2053.5819%2067.3414%2053.5947%2067.0026C53.6071%2066.6716%2053.6746%2066.3887%2053.715%2066.0819C53.7615%2065.7292%2053.8015%2065.3758%2053.8547%2065.0258C53.8768%2064.8801%2053.8911%2064.7283%2053.916%2064.5818C53.9241%2064.5371%2053.9323%2064.3814%2053.9338%2064.337C53.9369%2064.2691%2053.9464%2064.2016%2053.9622%2064.1355C54.001%2063.8718%2054.0258%2063.6036%2054.0568%2063.3384C54.0956%2062.9915%2054.1209%2062.6408%2054.1686%2062.2947C54.1686%2062.2812%2054.174%2062.2673%2054.1744%2062.2561C54.1911%2061.9073%2054.2031%2061.6657%2054.2284%2061.3184C54.2478%2061.0528%2054.3304%2060.6813%2054.3374%2060.418C54.344%2060.2986%2054.351%2060.1737%2054.3572%2060.0519C54.3749%2059.8697%2054.3576%2059.6858%2054.3063%2059.51C54.2582%2059.3762%2054.2047%2059.2641%2054.1542%2059.1407C54.1278%2059.0764%2054.091%2059.0875%2054.0584%2059.0637C53.9719%2059.0031%2053.8783%2059.1068%2053.7844%2059.224C53.7733%2059.2412%2053.7638%2059.2594%2053.7561%2059.2783C53.6806%2059.4597%2053.6206%2059.647%2053.5768%2059.8384C53.5514%2059.9564%2053.5327%2060.0759%2053.5209%2060.196C53.4678%2060.6027%2053.4235%2061.0131%2053.3859%2061.4236C53.3681%2061.6144%2053.3754%2061.9304%2053.3618%2062.1212L53.3564%2062.2022C53.3176%2062.5425%2053.2672%2062.7599%2053.2218%2063.0987C53.2183%2063.1253%2053.2121%2063.1522%2053.2101%2063.1781C53.188%2063.4991%2053.1476%2063.8171%2053.1042%2064.1355C53.051%2064.5209%2053.0673%2064.7699%2053.0347%2065.1584C53.0289%2065.227%2053.0204%2065.2929%2053.0099%2065.3611C52.9792%2065.5635%2052.8935%2065.9061%2052.8811%2066.1119C52.8632%2066.3844%2052.8256%2066.6596%2052.7817%2066.9275C52.7429%2067.1792%2052.7185%2067.4285%2052.6835%2067.6802C52.6579%2067.8556%2052.6552%2068.0271%2052.6312%2068.2017C52.5892%2068.4557%2052.5462%2068.7182%2052.5043%2068.9726C52.486%2069.1009%2052.481%2069.299%2052.4682%2069.4224C52.4511%2069.5862%2052.408%2069.6891%2052.3809%2069.8463C52.3626%2069.9619%2052.3126%2070.2757%2052.2943%2070.3901C52.2668%2070.5516%2052.2136%2070.7313%2052.1927%2070.8931C52.1639%2071.1151%2052.1775%2071.1047%2052.1399%2071.3263C52.0953%2071.5961%2052.0537%2071.8636%2052.0029%2072.1307C51.9373%2072.4996%2051.8985%2072.7046%2051.8294%2072.9871C51.7968%2073.1247%2051.7635%2073.2635%2051.7414%2073.403L51.7049%2073.5572C51.6373%2073.8953%2051.5454%2074.2281%2051.4298%2074.5531L51.3545%2074.8091C51.3157%2074.9401%2051.2807%2075.0711%2051.233%2075.2022C51.1869%2075.332%2051.148%2075.4643%2051.1166%2075.5984C50.9653%2076.2301%2050.7945%2076.7223%2050.6785%2077.3055C50.6307%2077.5586%2050.5972%2077.8141%2050.578%2078.0709C50.5055%2078.6227%2050.4838%2079.1799%2050.5132%2079.7356C50.5566%2080.2024%2050.6477%2080.6637%2050.7848%2081.1123L50.8791%2081.4206C51.0259%2081.7821%2051.1929%2082.1352%2051.3793%2082.4783C51.5413%2082.8175%2051.7362%2083.1402%2051.9614%2083.4418C52.1007%2083.6249%2052.1476%2083.6268%2052.2198%2083.7548C52.3834%2083.9691%2052.5723%2084.1632%2052.7825%2084.3329C52.8574%2084.4076%2052.9382%2084.4762%2053.0242%2084.538C53.1197%2084.617%2053.2276%2084.6799%2053.3436%2084.7241C53.4767%2084.7692%2053.6063%2084.8128%2053.663%2084.7816C53.732%2084.743%2053.7557%2084.6721%2053.72%2084.5592'%20fill='%23121C2D'/%3e%3cpath%20d='M52.4676%2098.325C52.4492%2098.262%2052.4144%2098.2048%2052.3667%2098.1593C52.3573%2098.1476%2052.3465%2098.1371%2052.3345%2098.1281C52.2809%2098.0961%2052.2926%2098.0479%2052.2181%2098.0186C52.1681%2097.988%2052.1234%2097.9496%2052.0857%2097.9049L52.0675%2097.8895C51.9511%2097.7662%2051.8106%2097.6621%2051.6872%2097.5403L51.6697%2097.5241C51.5444%2097.3881%2051.4047%2097.2566%2051.2926%2097.1094C51.2801%2097.0917%2051.2592%2097.0763%2051.2444%2097.0582C51.1672%2096.9699%2051.0968%2096.876%2051.0337%2096.7772C51.0198%2096.7541%2051.0042%2096.7352%2050.9872%2096.712C50.9214%2096.63%2050.8628%2096.5425%2050.8118%2096.4507C50.8038%2096.4335%2050.7933%2096.4176%2050.7807%2096.4033C50.7146%2096.3378%2050.6568%2096.2645%2050.6084%2096.1852C50.5203%2096.0225%2050.4951%2095.8768%2050.4105%2095.7161C50.3981%2095.6918%2050.388%2095.6664%2050.3775%2095.6413C50.3709%2095.6274%2050.369%2095.6109%2050.3628%2095.5978C50.2913%2095.4272%2050.2287%2095.253%2050.1754%2095.0759C50.1446%2094.9842%2050.1187%2094.8909%2050.0978%2094.7965C50.05%2094.5955%2050.0125%2094.3923%2049.9856%2094.1875C49.9694%2094.0913%2049.9588%2093.9943%2049.9538%2093.8969C49.9482%2093.8356%2049.9482%2093.7739%2049.9538%2093.7126C49.9802%2093.5081%2049.9847%2093.3014%2049.9674%2093.096C49.985%2092.8869%2050.0159%2092.6791%2050.0601%2092.4739C50.0708%2092.3649%2050.0925%2092.2572%2050.1249%2092.1525C50.168%2092.0244%2050.2031%2091.8939%2050.2301%2091.7616C50.3015%2091.5423%2050.3706%2091.3207%2050.4509%2091.1022C50.4928%2090.9931%2050.5339%2090.8844%2050.5828%2090.7788C50.5945%2090.753%2050.6046%2090.7264%2050.6139%2090.7017C50.662%2090.5614%2050.6891%2090.4076%2050.7508%2090.2716C50.8242%2090.1089%2050.9321%2089.9675%2051.0128%2089.8091C51.0741%2089.6957%2051.1051%2089.5589%2051.1738%2089.4506C51.2425%2089.3423%2051.3193%2089.2533%2051.3799%2089.1461C51.4804%2088.9631%2051.622%2088.7935%2051.7035%2088.6139C51.7887%2088.4562%2051.8941%2088.3102%2052.017%2088.1795C52.1376%2088.0168%2052.2702%2087.8633%2052.4136%2087.7201C52.4701%2087.6578%2052.53%2087.5989%2052.5933%2087.5435C52.6255%2087.5108%2052.6555%2087.4759%2052.6829%2087.4391C52.719%2087.3944%2052.7256%2087.4029%2052.7706%2087.3678C52.887%2087.2741%2052.9965%2087.1781%2053.1129%2087.093C53.2591%2086.9796%2053.4181%2086.8836%2053.5867%2086.807C53.5935%2086.8049%2053.6001%2086.8022%2053.6065%2086.7989C53.7418%2086.7132%2053.8883%2086.6464%2054.0419%2086.6004C54.116%2086.5839%2054.1917%2086.5754%2054.2677%2086.575C54.3419%2086.581%2054.4166%2086.579%2054.4905%2086.5692L54.6724%2086.5665C54.7718%2086.5761%2054.872%2086.5584%2054.9619%2086.5152C55.0426%2086.4767%2055.1171%2086.4339%2055.2045%2086.3954C55.2495%2086.3757%2055.2537%2086.3399%2055.2766%2086.3113C55.3391%2086.2342%2055.303%2086.1379%2055.2471%2086.035C55.2387%2086.0228%2055.2288%2086.0117%2055.2176%2086.0018C55.1134%2085.9087%2054.9912%2085.8377%2054.8583%2085.7933C54.7757%2085.7668%2054.6898%2085.7516%2054.603%2085.7482C54.3068%2085.7188%2054.0077%2085.7487%2053.7233%2085.8361C53.5697%2085.8916%2053.4222%2085.9626%2053.2832%2086.0481L53.2343%2086.0754C53.1261%2086.1225%2053.0403%2086.1618%2052.9538%2086.2057C52.8604%2086.2477%2052.7706%2086.2972%2052.6853%2086.3537C52.6701%2086.3637%2052.6531%2086.3718%2052.6395%2086.3826C52.4707%2086.5171%2052.3069%2086.6524%2052.1463%2086.7889C51.9877%2086.9444%2051.8455%2087.1155%2051.7217%2087.2996C51.693%2087.3335%2051.667%2087.3662%2051.6368%2087.3982C51.5166%2087.5077%2051.4063%2087.6275%2051.3073%2087.7563C51.2177%2087.9055%2051.111%2088.0454%2051.012%2088.1849C50.915%2088.3148%2050.8413%2088.4547%2050.7563%2088.59C50.6977%2088.6852%2050.6639%2088.7881%2050.608%2088.8844C50.5304%2089.0263%2050.4319%2089.1623%2050.3616%2089.3084C50.3252%2089.3812%2050.2902%2089.5011%2050.2627%2089.5736C50.2239%2089.6695%2050.1696%2089.7181%2050.1253%2089.8083L49.9864%2090.1236C49.9338%2090.2174%2049.8865%2090.314%2049.8447%2090.413C49.8028%2090.5475%2049.8141%2090.5433%2049.7671%2090.6763C49.7078%2090.8366%2049.6569%2090.9996%2049.6061%2091.1635C49.539%2091.3909%2049.5009%2091.518%2049.4486%2091.6957C49.4204%2091.7826%2049.399%2091.8715%2049.3845%2091.9617L49.3647%2092.0642C49.3461%2092.3629%2049.2751%2092.5051%2049.2596%2092.7306L49.2448%2092.9017C49.2386%2092.9892%2049.2324%2093.0755%2049.2262%2093.165C49.2189%2093.2526%2049.2189%2093.3406%2049.2262%2093.4282C49.2367%2093.6348%2049.2619%2093.8179%2049.265%2093.9971C49.2801%2094.1752%2049.2999%2094.3486%2049.3275%2094.5309C49.364%2094.6889%2049.4109%2094.8393%2049.4583%2094.9911C49.5147%2095.1506%2049.5626%2095.313%2049.6018%2095.4775C49.6477%2095.642%2049.7047%2095.8032%2049.7722%2095.9601C49.8362%2096.088%2049.8952%2096.2183%2049.9619%2096.3455L50.1812%2096.7128L50.2867%2096.8789C50.4299%2097.0967%2050.6042%2097.2166%2050.7485%2097.4247C50.8862%2097.6075%2051.0405%2097.7773%2051.2095%2097.9319C51.3131%2098.0267%2051.3481%2098.0155%2051.3985%2098.0915C51.4761%2098.2191%2051.6639%2098.2842%2051.7908%2098.3863C51.8404%2098.4273%2051.8949%2098.462%2051.953%2098.4896C52.0208%2098.5271%2052.0953%2098.5513%2052.1723%2098.5609C52.2638%2098.5675%2052.3535%2098.5736%2052.3985%2098.5328C52.427%2098.5071%2052.4484%2098.4746%2052.4606%2098.4383C52.4728%2098.4021%2052.4755%2098.3634%2052.4683%2098.3258'%20fill='%23121C2D'/%3e%3cpath%20d='M94.8058%2095.3129C94.876%2095.0838%2094.9271%2094.8493%2094.9587%2094.6118C94.968%2094.5548%2094.9801%2094.49%2094.9851%2094.4338C95.008%2094.1802%2095.0627%2094.1089%2095.0755%2093.7932C95.086%2093.5619%2095.1267%2093.3191%2095.1531%2093.0813C95.1566%2093.0493%2095.1601%2093.0142%2095.1632%2092.9846C95.256%2092.2939%2095.3146%2091.5762%2095.3763%2090.8647C95.379%2090.832%2095.3821%2090.7981%2095.3848%2090.7672C95.4721%2090.0068%2095.5105%2089.2132%2095.5881%2088.4512C95.5971%2088.361%2095.6013%2088.2585%2095.6071%2088.1602C95.6372%2087.6694%2095.6749%2087.1846%2095.7205%2086.7056C95.7313%2086.5942%2095.7406%2086.4932%2095.7468%2086.373C95.7693%2085.9382%2095.8008%2085.5004%2095.8431%2085.0675C95.8512%2084.9858%2095.8594%2084.9095%2095.8617%2084.8313C95.8702%2084.5137%2095.8819%2084.0053%2095.911%2083.6881C95.9816%2082.9284%2096.0619%2082.3476%2096.1213%2081.5875C96.1314%2081.4758%2096.1423%2081.3617%2096.1524%2081.2495C96.1593%2081.1852%2096.1659%2081.1181%2096.1721%2081.0568C96.221%2080.286%2096.3274%2079.5301%2096.3693%2078.7442C96.3906%2078.3519%2096.4282%2077.9376%2096.4562%2077.5336L96.6397%2074.9536L96.7375%2073.7383C96.7604%2073.4832%2096.7763%2073.2122%2096.8113%2072.974C96.9983%2071.6497%2096.9859%2071.2739%2097.0872%2070.426C97.1836%2069.5702%2097.3308%2068.7208%2097.528%2067.8822C97.5555%2067.7785%2097.5839%2067.6733%2097.6122%2067.5669C97.6444%2067.4682%2097.6832%2067.3823%2097.7166%2067.289C97.7952%2067.1119%2097.9042%2066.9497%2098.0386%2066.8096C98.2134%2066.6257%2098.4102%2066.4637%2098.6246%2066.3274C98.7227%2066.2619%2098.8253%2066.2034%2098.9315%2066.152C99.0403%2066.0951%2099.1533%2066.0464%2099.2695%2066.0063C100.144%2065.7363%20101.049%2065.5745%20101.964%2065.5245L103.381%2065.3846L103.723%2065.3461C104.322%2065.2748%20104.933%2065.1769%20105.536%2065.1148C106.254%2065.0416%20106.959%2065.0073%20107.676%2064.9395C108.198%2064.889%20108.746%2064.8034%20109.265%2064.7599C109.772%2064.7175%20110.254%2064.6963%20110.755%2064.6465C111.602%2064.5614%20112.501%2064.5059%20113.299%2064.4003C114.079%2064.2954%20114.769%2064.2669%20115.504%2064.2014C116.348%2064.127%20117.193%2064.0495%20118.035%2063.9867L119.099%2063.9023C119.208%2063.895%20119.577%2063.8541%20119.681%2063.8414C119.924%2063.8117%20119.919%2063.8221%20120.165%2063.8052L122.073%2063.6468C122.907%2063.5785%20123.738%2063.4926%20124.569%2063.4348L124.666%2063.4282L126.895%2063.197C127.528%2063.1368%20128.431%2063.1056%20129.056%2063.0355L129.927%2062.9464C130.353%2062.9115%20130.776%2062.8418%20131.191%2062.7379C131.491%2062.6524%20131.739%2062.5676%20132.015%2062.4824C132.159%2062.4381%20132.121%2062.4053%20132.164%2062.3668C132.28%2062.2654%20132.006%2062.2056%20131.698%2062.1494C131.667%2062.1436%20131.611%2062.1409%20131.561%2062.1378C131.197%2062.1135%20130.691%2062.1208%20130.182%2062.1293C129.924%2062.134%20129.607%2062.1613%20129.32%2062.181C128.342%2062.2492%20127.358%2062.3294%20126.375%2062.4157C125.918%2062.4542%20125.172%2062.5579%20124.719%2062.6022L124.525%2062.6219L122.361%2062.7672L122.17%2062.7807C121.404%2062.8578%20120.639%2062.9202%20119.872%2062.9792C118.941%2063.0497%20118.359%2063.148%20117.432%2063.2421L116.945%2063.2848C116.456%2063.3214%20115.616%2063.3554%20115.126%2063.4128C114.477%2063.4876%20113.814%2063.5442%20113.166%2063.5974C112.557%2063.6467%20111.957%2063.713%20111.353%2063.7685L110.104%2063.9077L108.238%2064.0726C107.928%2064.1046%20107.462%2064.1756%20107.166%2064.2102C106.773%2064.2573%20106.512%2064.255%20106.128%2064.2912L104.811%2064.428C104.419%2064.4665%20103.972%2064.4885%20103.582%2064.5371C103.046%2064.6038%20103.077%2064.6119%20102.539%2064.6701C101.891%2064.7437%20101.241%2064.7976%20100.568%2064.899C99.8197%2064.9921%2099.0929%2065.2096%2098.4178%2065.5423C98.0735%2065.7249%2097.7641%2065.9659%2097.5035%2066.2545C97.4041%2066.3663%2097.3133%2066.4853%2097.2319%2066.6107C97.0826%2066.8509%2096.9671%2067.1102%2096.8885%2067.3815C96.8326%2067.6062%2096.7639%2067.8132%2096.7282%2068.0048C96.6925%2068.1963%2096.6483%2068.3813%2096.6083%2068.5694C96.5769%2068.7571%2096.5447%2068.9487%2096.5094%2069.1568C96.474%2069.3649%2096.4504%2069.5808%2096.4213%2069.7943C96.3825%2070.1192%2096.3409%2070.441%2096.2998%2070.7702C96.2587%2071.0993%2096.2257%2071.4254%2096.2009%2071.7445C96.0844%2073.2743%2095.9626%2074.4811%2095.8679%2075.8489C95.8291%2076.4502%2095.8031%2077.0337%2095.7763%2077.6219C95.7468%2078.2486%2095.701%2078.8757%2095.6351%2079.4978C95.5695%2080.1268%2095.4993%2080.7577%2095.4488%2081.3937C95.3619%2082.4513%2095.2742%2083.5135%2095.2028%2084.57C95.183%2084.8109%2095.164%2085.0575%2095.1434%2085.3023C95.0755%2086.2658%2095.0837%2087.0174%2094.9971%2087.9617C94.9253%2088.8301%2094.8505%2089.7347%2094.7856%2090.5155C94.7434%2091.0351%2094.7674%2091.1075%2094.717%2091.4332C94.6351%2091.9647%2094.6246%2092.6481%2094.5656%2093.264C94.5423%2093.5045%2094.5229%2093.7523%2094.5082%2093.9828C94.4864%2094.2604%2094.4794%2094.5389%2094.4872%2094.8173C94.4795%2095.0468%2094.507%2095.2762%2094.5687%2095.4975C94.6328%2095.5823%2094.7096%2095.5361%2094.8016%2095.3102'%20fill='%23121C2D'/%3e%3cpath%20d='M95.8127%2096.3316C96.0443%2096.3499%2096.2771%2096.3486%2096.5085%2096.3277C96.5644%2096.3247%2096.628%2096.3212%2096.6819%2096.3135C96.9256%2096.278%2097.0048%2096.3135%2097.3052%2096.258C97.5256%2096.2164%2097.7634%2096.2025%2097.9932%2096.1755L98.0867%2096.1635C98.7568%2096.098%2099.4448%2095.9982%20100.128%2095.9018L100.222%2095.8887C100.956%2095.807%20101.713%2095.6787%20102.447%2095.5923C102.534%2095.5823%20102.633%2095.5646%20102.725%2095.5499C103.195%2095.4763%20103.661%2095.4131%20104.122%2095.3572C104.23%2095.3441%20104.327%2095.3322%20104.442%2095.3125C104.857%2095.2424%20105.278%2095.1799%20105.696%2095.1279C105.773%2095.1179%20105.848%2095.1098%20105.923%2095.0948C106.224%2095.0362%20106.706%2094.9348%20107.011%2094.8916C107.743%2094.7899%20108.309%2094.7375%20109.037%2094.6188L109.363%2094.5698L109.547%2094.5444C110.28%2094.4126%20111.021%2094.327%20111.759%2094.1944C112.131%2094.1262%20112.53%2094.0722%20112.917%2094.0098L115.389%2093.6001L116.553%2093.4027C116.798%2093.3642%20117.057%2093.3102%20117.288%2093.2817C118.576%2093.1175%20118.925%2093.005%20119.742%2092.8504C120.577%2092.6939%20121.414%2092.5456%20122.247%2092.3783C122.679%2092.2931%20123.14%2092.1813%20123.548%2092.1123C124.176%2092.0002%20124.602%2091.8703%20125.126%2091.757L126.464%2091.4078L127.137%2091.1765L127.473%2091.0582C127.581%2091.0119%20127.69%2090.9638%20127.799%2090.9102C128.032%2090.8011%20128.252%2090.6654%20128.453%2090.5059C128.67%2090.3315%20128.848%2090.1149%20128.978%2089.8695C129.037%2089.7559%20129.087%2089.6374%20129.126%2089.5153C129.213%2089.2203%20129.277%2088.919%20129.317%2088.6142C129.363%2088.3259%20129.411%2088.0361%20129.467%2087.7536C129.601%2087.0779%20129.767%2086.4246%20129.903%2085.7493C130.002%2085.2583%20130.073%2084.7337%20130.174%2084.2462C130.275%2083.7706%20130.39%2083.325%20130.48%2082.8536C130.636%2082.0543%20130.83%2081.2183%20130.946%2080.4582C131.061%2079.7155%20131.221%2079.0765%20131.359%2078.3854C131.519%2077.5927%20131.679%2076.8008%20131.839%2076.0096C131.907%2075.6809%20131.977%2075.3421%20132.045%2075.0114C132.068%2074.91%20132.128%2074.5608%20132.143%2074.461C132.18%2074.2297%20132.189%2074.2375%20132.238%2074.0081C132.366%2073.415%20132.477%2072.8133%20132.597%2072.2163C132.752%2071.4339%20132.893%2070.6484%20133.057%2069.8706L133.077%2069.78C133.211%2068.9961%20133.304%2068.4484%20133.42%2067.6532C133.543%2066.9599%20133.623%2066.2594%20133.659%2065.5561C133.662%2065.2763%20133.662%2064.9818%20133.652%2064.6939C133.642%2064.2706%20133.572%2063.8508%20133.443%2063.4471C133.345%2063.1832%20133.231%2062.9258%20133.101%2062.6762C133.036%2062.5456%20133.009%2062.588%20132.966%2062.5537C132.849%2062.4631%20132.829%2062.7325%20132.813%2063.0196C132.81%2063.0489%20132.813%2063.1017%20132.813%2063.1472C132.829%2063.4837%20132.849%2063.9497%20132.842%2064.4164C132.842%2064.6546%20132.838%2064.9472%20132.835%2065.212C132.794%2066.1295%20132.693%2067.0436%20132.534%2067.9485C132.466%2068.3744%20132.371%2069.0805%20132.293%2069.5094C132.282%2069.5707%20132.271%2069.632%20132.26%2069.6925L131.824%2071.7141L131.785%2071.8925C131.655%2072.616%20131.511%2073.3333%20131.361%2074.0509C131.179%2074.9235%20131.117%2075.4808%20130.957%2076.3565C130.926%2076.5107%20130.897%2076.6591%20130.866%2076.814C130.769%2077.2708%20130.574%2078.0474%20130.494%2078.5126C130.389%2079.1266%20130.261%2079.749%20130.135%2080.3557C130.022%2080.9277%20129.911%2081.4919%20129.799%2082.0597C129.727%2082.4586%20129.659%2082.8405%20129.587%2083.2395C129.467%2083.8176%20129.344%2084.4119%20129.224%2084.9885C129.168%2085.2799%20129.105%2085.7262%20129.056%2086.006C128.99%2086.3772%20128.915%2086.6154%20128.841%2086.975C128.79%2087.2352%20128.65%2087.9536%20128.599%2088.2149C128.53%2088.5784%20128.441%2088.9378%20128.331%2089.2914C128.292%2089.4149%20128.238%2089.5331%20128.17%2089.6433C128.102%2089.7503%20128.015%2089.8443%20127.914%2089.9208C127.688%2090.0856%20127.443%2090.2222%20127.184%2090.3274L126.339%2090.6292C125.52%2090.8566%20125.061%2090.9919%20124.399%2091.1303C124.079%2091.2008%20123.756%2091.2717%20123.44%2091.3519C123.323%2091.3827%20123.193%2091.4078%20123.075%2091.4348C122.043%2091.673%20121.506%2091.7654%20120.716%2091.9111L120.114%2092.0268C119.806%2092.0873%20119.502%2092.1493%20119.189%2092.2017C118.876%2092.2542%20118.565%2092.3116%20118.264%2092.374C116.82%2092.6724%20115.661%2092.8365%20114.359%2093.062L112.673%2093.3704C111.482%2093.5947%20110.267%2093.7257%20109.052%2093.9235L106.014%2094.3991L105.316%2094.4989C104.396%2094.6384%20103.686%2094.8034%20102.777%2094.9151C101.941%2095.02%20101.072%2095.1464%20100.321%2095.2524C99.8212%2095.3233%2099.7584%2095.3649%2099.4402%2095.3869C98.921%2095.4216%2098.276%2095.5665%2097.6827%2095.6463C97.4499%2095.6771%2097.2136%2095.713%2096.9939%2095.75C96.7282%2095.7917%2096.4648%2095.8466%2096.2047%2095.9146C95.9871%2095.9575%2095.7776%2096.034%2095.5838%2096.1412C95.5174%2096.2221%2095.5752%2096.2869%2095.8096%2096.3258'%20fill='%23121C2D'/%3e%3cpath%20d='M95.2198%2086.7202C95.1016%2086.6946%2094.9801%2086.6875%2094.8597%2086.699C94.8298%2086.6985%2094.7998%2086.7002%2094.7701%2086.704C94.6622%2086.7029%2094.5545%2086.7096%2094.4476%2086.7241C94.3306%2086.7471%2094.2121%2086.761%2094.0929%2086.7657L94.0444%2086.7711C93.6952%2086.7911%2093.3409%2086.8482%2092.9862%2086.891L92.9381%2086.8968C92.5563%2086.9241%2092.1647%2086.9958%2091.7817%2087.022C91.7363%2087.0251%2091.6851%2087.0347%2091.637%2087.0417C91.3935%2087.0776%2091.1511%2087.1041%2090.9098%2087.1211C90.8539%2087.1249%2090.8031%2087.1288%2090.7437%2087.1388C90.5276%2087.1735%2090.3091%2087.2001%2090.091%2087.2159C90.052%2087.218%2090.0131%2087.2225%2089.9746%2087.2294C89.8194%2087.2633%2089.5687%2087.3219%2089.4096%2087.3373C89.0281%2087.3758%2088.7321%2087.3758%2088.3526%2087.4302L88.1834%2087.4491C88.1512%2087.4525%2088.1166%2087.4525%2088.0871%2087.4575C87.7057%2087.5208%2087.3184%2087.5393%2086.9335%2087.6017C86.7394%2087.6337%2086.5307%2087.6495%2086.3293%2087.6745L85.0398%2087.8414L84.431%2087.922C84.3029%2087.9386%2084.1683%2087.9605%2084.0464%2087.9667C83.6145%2087.9907%2083.1852%2088.0483%2082.7623%2088.139C82.3242%2088.2045%2081.8861%2088.2712%2081.443%2088.3467C81.3301%2088.3625%2081.2051%2088.4003%2081.0868%2088.4277L80.9094%2088.4693L80.7042%2088.5325C80.5288%2088.5993%2080.3693%2088.7018%2080.2361%2088.8333C80.1028%2088.9649%2079.9987%2089.1226%2079.9304%2089.2964C79.8023%2089.5867%2079.7737%2089.9108%2079.8491%2090.2188C79.9244%2090.5268%2080.0996%2090.8016%2080.3475%2091.0011C80.5641%2091.1474%2080.7921%2091.2763%2081.0293%2091.3866L81.1846%2091.4637C81.4562%2091.5916%2081.7507%2091.6949%2082.0224%2091.8287C82.3444%2091.9886%2082.6471%2092.1717%2082.97%2092.3297C83.2051%2092.4453%2083.4698%2092.5332%2083.7014%2092.6512C83.9331%2092.7691%2084.1349%2092.8913%2084.3642%2092.9946C84.7523%2093.1711%2085.1488%2093.3831%2085.5284%2093.5199C85.8993%2093.6529%2086.2008%2093.8221%2086.5373%2093.9736L87.6971%2094.4881L88.1845%2094.7055C88.2334%2094.7294%2088.4084%2094.7918%2088.4585%2094.8088C88.5348%2094.8358%2088.6089%2094.8687%2088.6801%2094.9071C88.9692%2095.0396%2089.2683%2095.1545%2089.5629%2095.2759C89.9482%2095.4374%2090.3425%2095.5761%2090.727%2095.7407L90.7716%2095.7604L91.831%2096.1246C92.131%2096.2294%2092.5357%2096.433%2092.8372%2096.5228L93.2532%2096.6588C93.4566%2096.7337%2093.6712%2096.7746%2093.8881%2096.7798C94.053%2096.7744%2094.1942%2096.7575%2094.3475%2096.7467C94.4274%2096.7413%2094.4228%2096.702%2094.4561%2096.6773C94.545%2096.6122%2094.4476%2096.4896%2094.3347%2096.362C94.3174%2096.3458%2094.2989%2096.331%2094.2792%2096.3177C94.088%2096.1881%2093.8878%2096.0722%2093.6801%2095.9708C93.566%2095.9103%2093.4177%2095.8552%2093.285%2095.8036C92.8329%2095.6243%2092.3762%2095.447%2091.9175%2095.2771C91.7049%2095.1965%2091.3432%2095.0986%2091.1294%2095.0227L91.0386%2094.9899C90.6626%2094.8357%2090.4267%2094.7174%2090.0541%2094.5559C90.025%2094.5432%2089.9959%2094.5282%2089.9672%2094.5174C89.6087%2094.3852%2089.2579%2094.2379%2088.9086%2094.0826C88.4841%2093.8965%2088.2001%2093.8232%2087.7685%2093.654C87.6909%2093.6244%2087.6203%2093.592%2087.5462%2093.5573C87.3262%2093.4532%2086.9602%2093.2516%2086.7313%2093.1626C86.429%2093.0451%2086.1283%2092.909%2085.8388%2092.7687C85.5672%2092.6361%2085.2889%2092.5232%2085.0169%2092.3952C84.8264%2092.3058%2084.6347%2092.2411%2084.443%2092.152C84.1647%2092.0241%2083.8881%2091.8699%2083.6102%2091.7412C83.4701%2091.6768%2083.2493%2091.5962%2083.1135%2091.5377C82.9339%2091.4606%2082.8295%2091.3789%2082.6591%2091.2933L82.0685%2091.0062C81.8935%2090.9198%2081.7065%2090.7992%2081.5284%2090.7186C81.2847%2090.6092%2081.2932%2090.6257%2081.0518%2090.5074C80.9665%2090.4689%2080.9316%2090.4419%2080.885%2090.4168C80.843%2090.3892%2080.8039%2090.3573%2080.7686%2090.3216C80.6982%2090.2507%2080.6464%2090.1638%2080.6176%2090.0684C80.5835%2089.9618%2080.5763%2089.8485%2080.5966%2089.7385C80.6169%2089.6285%2080.6641%2089.5251%2080.734%2089.4375C80.8057%2089.3574%2080.8903%2089.2897%2080.9843%2089.2371L81.1062%2089.1889C81.4964%2089.0825%2081.8941%2089.0052%2082.2959%2088.9576L82.6064%2088.9048C82.7655%2088.8775%2082.923%2088.8474%2083.0871%2088.8312C83.2513%2088.815%2083.4116%2088.7861%2083.5676%2088.7541C84.3188%2088.61%2084.9257%2088.5614%2085.6029%2088.4662C85.9013%2088.4246%2086.1896%2088.3726%2086.4806%2088.3224C87.1015%2088.2157%2087.7363%2088.1941%2088.3696%2088.1093L89.9521%2087.9027L90.3169%2087.8642C90.7961%2087.8029%2091.1632%2087.6984%2091.6362%2087.6587C92.0728%2087.6202%2092.5252%2087.5635%2092.9168%2087.5119C93.0677%2087.4786%2093.2206%2087.4553%2093.3747%2087.4421C93.682%2087.4132%2093.9873%2087.366%2094.2889%2087.3007C94.4096%2087.2841%2094.5334%2087.2621%2094.6475%2087.2359C94.7876%2087.2101%2094.9242%2087.168%2095.0545%2087.1107C95.1993%2087.0397%2095.3417%2086.97%2095.3622%2086.9072C95.3871%2086.8301%2095.3471%2086.7646%2095.2202%2086.7175'%20fill='%23121C2D'/%3e%3cpath%20d='M0.0815667%2096.8836C0.00424121%2097.1948%20-0.0183391%2097.517%200.0148227%2097.8359C0.0616394%2098.3202%200.225079%2098.7862%200.491344%2099.1946C0.603269%2099.3651%200.731955%2099.5241%200.875511%2099.6694C1.11434%2099.9087%201.37785%20100.122%201.66169%20100.307C1.98496%20100.513%202.33288%20100.679%202.69739%20100.799C3.41644%20101.047%204.18671%20101.223%204.91469%20101.399L5.21077%20101.472C7.33533%20102.048%209.54331%20102.611%2011.73%20103.176L12.0291%20103.253L19.1417%20105.113L20.0342%20105.342C21.5416%20105.726%2023.0317%20106.114%2024.5045%20106.508L25.5266%20106.775C26.8649%20107.112%2028.2122%20107.461%2029.544%20107.816L30.2712%20108.005C31.2487%20108.243%2032.8145%20108.618%2033.7912%20108.875C36.13%20109.492%2037.92%20109.986%2040.2615%20110.585L41.3038%20110.855L41.8921%20111.009C44.2592%20111.603%2046.6103%20112.246%2048.9995%20112.841C50.2052%20113.138%2051.4935%20113.458%2052.7729%20113.681C54.1401%20113.931%2055.5286%20114.049%2056.9188%20114.032C58.3%20113.997%2059.6779%20113.879%2061.0449%20113.68C62.3297%20113.505%2063.6029%20113.308%2064.8803%20113.122C65.6848%20113.003%2066.5358%20112.872%2067.294%20112.772C71.5051%20112.218%2072.6715%20111.971%2075.3619%20111.566L83.6021%20110.3L87.8845%20109.623C89.9412%20109.323%2091.3645%20109.061%2093.0914%20108.789L101.919%20107.343L106.331%20106.607L107.398%20106.427L113.064%20105.416C115.302%20105.031%20117.497%20104.693%20119.73%20104.299L124.684%20103.403L129.318%20102.6C131.96%20102.124%20134.751%20101.641%20137.236%20101.148C139.666%20100.671%20141.806%20100.305%20144.09%2099.8733L151.947%2098.3886L155.249%2097.7608C155.587%2097.6995%20156.733%2097.4667%20157.057%2097.3981C157.813%2097.2405%20157.797%2097.2543%20158.557%2097.1086L164.472%2095.9462L172.203%2094.3875L172.502%2094.3274L179.401%2092.8659C181.357%2092.4481%20184.147%2091.9081%20186.077%2091.4841C186.949%2091.2864%20187.879%2091.1187%20188.794%2090.827C189.606%2090.5927%20190.356%2090.1821%20190.989%2089.6248C191.242%2089.3974%20191.456%2089.1299%20191.622%2088.8332C191.754%2088.5942%20191.852%2088.3381%20191.914%2088.0723C192.027%2087.5951%20192.029%2087.0985%20191.919%2086.6204C191.814%2086.1653%20191.57%2085.7536%20191.221%2085.4418C191.125%2085.3525%20191.01%2085.2866%20190.884%2085.2491C190.837%2085.2469%20190.789%2085.2409%20190.743%2085.231C190.549%2085.1797%20190.642%2085.2753%20190.844%2085.438C191.113%2085.6837%20191.3%2086.0052%20191.381%2086.3595C191.414%2086.4814%20191.438%2086.6054%20191.453%2086.7307C191.509%2087.3232%20191.377%2087.9183%20191.077%2088.4331L190.94%2088.6347L190.783%2088.8208C190.661%2088.9465%20190.531%2089.0641%20190.394%2089.1731C190.105%2089.3948%20189.789%2089.5805%20189.453%2089.7262C188.644%2090.058%20187.801%2090.3035%20186.94%2090.4585L177.843%2092.3513L172.721%2093.4533L172.121%2093.5797L165.43%2094.8901L164.838%2095.0058C162.465%2095.4956%20160.096%2095.9516%20157.72%2096.4137L150.153%2097.9296L148.642%2098.2198C147.128%2098.502%20144.524%2098.9487%20143.003%2099.2485C140.988%2099.6478%20138.928%20100.024%20136.916%20100.386L131.284%20101.42L127.397%20102.141L121.596%20103.156L118.253%20103.777C117.031%20104.001%20116.22%20104.111%20115.026%20104.313L110.921%20105.022L107.093%20105.654L103.838%20106.225L97.7312%20107.251C94.9264%20107.719%2093.3579%20107.979%2091.162%20108.325L87.9559%20108.845L86.7398%20109.045C83.3079%20109.62%2081.5303%20109.865%2078.9261%20110.276L76.9346%20110.584L73.8784%20111.051C72.8578%20111.199%2071.8217%20111.362%2070.8279%20111.522C68.4383%20111.899%2066.2928%20112.216%2064.2098%20112.524C62.1241%20112.822%2060.1085%20113.163%2057.9731%20113.297C56.129%20113.416%2054.2771%20113.3%2052.4629%20112.95C50.5284%20112.596%2048.6049%20112.064%2046.6685%20111.557L40.837%20110.03L31.0753%20107.519L28.8308%20106.934C25.8766%20106.173%2023.5592%20105.635%2020.657%20104.866L12.7917%20102.819C11.1898%20102.405%2010.9678%20102.38%209.96124%20102.098C9.14168%20101.867%208.20533%20101.631%207.23637%20101.39C6.26742%20101.149%205.26432%20100.892%204.30623%20100.68C3.57988%20100.534%202.87295%20100.305%202.19953%2099.9978C1.79137%2099.7981%201.42237%2099.5277%201.10989%2099.1992C0.858356%2098.9324%200.662271%2098.619%200.532865%2098.2769C0.384136%2097.8801%200.323382%2097.4561%200.354752%2097.0339C0.379523%2096.7846%200.419566%2096.5371%200.474658%2096.2927C0.489792%2096.1678%200.466121%2096.1312%200.391616%2096.2156C0.239413%2096.4121%200.133349%2096.6399%200.0811787%2096.8824'%20fill='%23121C2D'/%3e%3cpath%20d='M133.369%2074.2167C133.721%2074.3304%20134.518%2074.5323%20135.417%2074.749L135.936%2074.8707C136.673%2075.0295%20136.885%2075.1232%20137.801%2075.307C138.475%2075.4419%20139.182%2075.6154%20139.873%2075.7696L140.156%2075.8324C142.166%2076.2999%20144.251%2076.7489%20146.318%2077.1983L146.601%2077.2604C148.81%2077.7637%20151.115%2078.2382%20153.33%2078.7331L154.176%2078.9123L158.411%2079.8142L159.381%2080.0189L163.193%2080.7943L163.883%2080.9335L167.228%2081.5428C169.454%2081.9768%20171.162%2082.3164%20173.396%2082.6991L174.391%2082.8726L174.953%2082.9724C177.209%2083.3462%20179.471%2083.7047%20181.725%2084.1183C182.291%2084.2269%20182.877%2084.3403%20183.456%2084.4894L185.187%2084.9573L185.417%2085.0182C185.482%2085.0332%20185.546%2085.055%20185.607%2085.0834C185.742%2085.1412%20185.882%2085.2098%20186.018%2085.2795L186.222%2085.3875L186.377%2085.4742C186.407%2085.4915%20186.436%2085.5104%20186.464%2085.5308C186.486%2085.5513%20186.531%2085.5755%20186.516%2085.6079C186.484%2085.6217%20186.45%2085.6293%20186.416%2085.6303L185.779%2085.7112C185.141%2085.7925%20184.498%2085.882%20183.856%2086.0107L181.972%2086.3961C180.789%2086.6328%20179.613%2086.8929%20178.423%2087.1084C177.675%2087.2495%20176.884%2087.4048%20176.178%2087.5262C172.259%2088.1988%20171.172%2088.4608%20168.668%2088.9253L160.99%2090.3329C159.665%2090.5718%20158.24%2090.8555%20156.996%2091.0613C155.075%2091.3812%20153.749%2091.6553%20152.137%2091.9397L143.89%2093.4093L139.764%2094.1297L138.765%2094.3054C137.015%2094.6219%20135.223%2094.9668%20133.463%2095.2732L127.218%2096.3089C125.692%2096.5687%20124.088%2096.8747%20122.575%2097.1241L118.229%2097.8286C115.751%2098.2526%20113.131%2098.6611%20110.795%2099.0797C108.512%2099.491%20106.5%2099.7823%20104.353%20100.126C101.886%20100.519%2099.4168%20100.911%2096.9554%20101.282L93.8429%20101.753L92.1375%20102.023C91.4242%20102.139%2091.439%20102.128%2090.723%20102.233L85.1348%20103.067L77.8286%20104.143L77.545%20104.182L71.0149%20105.171C69.1616%20105.446%2066.5221%20105.779%2064.6897%20106.06L62.1372%20106.441C60.4546%20106.692%2059.2268%20106.903%2058.4251%20107.075L55.9909%20107.61C55.83%20107.626%2055.6762%20107.683%2055.5446%20107.776C55.1973%20107.918%2055.9905%20107.888%2056.8803%20107.844C56.9703%20107.839%2057.1349%20107.823%2057.2784%20107.81C58.3386%20107.714%2059.819%20107.537%2061.304%20107.359C62.0584%20107.269%2062.9862%20107.135%2063.8263%20107.019L72.4483%20105.793L77.302%20105.041L77.8701%20104.956L84.2003%20104.066L84.7595%20103.985L91.4848%20102.975C94.2092%20102.57%2095.9085%20102.262%2098.6248%20101.827L100.049%20101.604C101.477%20101.389%20103.927%20101.037%20105.361%20100.796L111.088%2099.8556L116.38%2098.9691L120.028%2098.3327L125.471%2097.4251L128.607%2096.857C129.753%2096.6535%20130.513%2096.5486%20131.632%2096.359L135.477%2095.6903C136.621%2095.4925%20137.922%2095.2917%20139.062%2095.0832L142.107%2094.5244L147.818%2093.4983L153.957%2092.3914L156.95%2091.8433L158.086%2091.6325C161.287%2091.0158%20162.946%2090.7399%20165.375%2090.2881L167.231%2089.9413L170.079%2089.4101C171.03%2089.2402%20171.994%2089.0532%20172.92%2088.8706L179.079%2087.6881L181.964%2087.108L183.414%2086.8128C183.905%2086.7114%20184.37%2086.6123%20184.87%2086.5387C185.305%2086.4713%20185.741%2086.4146%20186.178%2086.3576L186.58%2086.3048C186.769%2086.2847%20186.956%2086.2541%20187.141%2086.213C187.184%2086.206%20187.226%2086.1959%20187.267%2086.183L187.344%2086.1363C187.396%2086.1101%20187.444%2086.078%20187.488%2086.0408C187.532%2086.0018%20187.564%2085.9521%20187.582%2085.8966C187.601%2085.8339%20187.602%2085.7673%20187.586%2085.7039C187.475%2085.4141%20187.256%2085.1775%20186.975%2085.0425C186.81%2084.9369%20186.65%2084.8471%20186.57%2084.8039L186.269%2084.6498C186.06%2084.5391%20185.841%2084.4487%20185.614%2084.38L184.974%2084.2138C183.159%2083.7238%20181.319%2083.3333%20179.461%2083.0441L173.895%2082.0979C170.795%2081.5702%20167.697%2080.9948%20164.614%2080.3977L162.485%2079.9691C159.685%2079.4053%20157.492%2079.0087%20154.745%2078.4063L147.308%2076.7902C145.795%2076.461%20145.584%2076.4483%20144.633%2076.219C143.083%2075.8436%20141.092%2075.4651%20139.298%2075.0715L137.203%2074.6256C136.249%2074.4283%20135.411%2074.2633%20134.774%2074.1569C134.123%2074.0286%20133.465%2073.9353%20132.804%2073.8775C132.563%2073.8983%20132.699%2074.0012%20133.367%2074.2167'%20fill='%23121C2D'/%3e%3cpath%20d='M55.0415%20113.411C55.0753%20113.399%2055.1038%20113.375%2055.1218%20113.344C55.1253%20113.339%2055.1307%20113.333%2055.13%20113.328C55.1261%20113.304%2055.1727%20113.297%2055.156%20113.268C55.1436%20113.247%2055.1599%20113.224%2055.1641%20113.202C55.1636%20113.199%2055.1636%20113.196%2055.1641%20113.193C55.1832%20113.129%2055.1894%20113.062%2055.1824%20112.995C55.1819%20112.993%2055.1819%20112.99%2055.1824%20112.987C55.2037%20112.916%2055.18%20112.843%2055.2014%20112.772C55.2031%20112.763%2055.2031%20112.754%2055.2014%20112.745C55.1954%20112.7%2055.1987%20112.654%2055.2111%20112.61C55.2146%20112.6%2055.2156%20112.59%2055.2138%20112.579C55.2048%20112.539%2055.2048%20112.498%2055.2138%20112.458C55.2166%20112.451%2055.2166%20112.444%2055.2138%20112.437C55.193%20112.405%2055.1798%20112.368%2055.175%20112.331C55.1947%20112.267%2055.2067%20112.201%2055.2107%20112.135C55.2104%20112.124%2055.2112%20112.114%2055.213%20112.104C55.213%20112.097%2055.2177%20112.091%2055.2165%20112.086C55.1998%20112.015%2055.2293%20111.944%2055.2142%20111.872C55.2115%20111.835%2055.2125%20111.797%2055.2173%20111.76C55.2173%20111.68%2055.2173%20111.6%2055.2173%20111.52C55.2173%20111.481%2055.2173%20111.445%2055.2173%20111.407C55.214%20111.383%2055.2165%20111.359%2055.2247%20111.336C55.2899%20111.212%2055.2316%20111.177%2055.2332%20111.098C55.2347%20111.019%2055.2355%20110.935%2055.2429%20110.854C55.2468%20110.812%2055.2247%20110.767%2055.2429%20110.728C55.272%20110.667%2055.2386%20110.625%2055.2429%20110.574C55.2507%20110.487%2055.2429%20110.4%2055.246%20110.314C55.246%20110.27%2055.2491%20110.227%2055.2541%20110.183C55.2557%20110.172%2055.2557%20110.162%2055.2541%20110.151C55.2369%20110.096%2055.2239%20110.04%2055.2153%20109.983C55.2153%20109.917%2055.2541%20109.852%2055.2588%20109.786C55.2619%20109.738%2055.2309%20109.687%2055.2386%20109.639C55.2543%20109.595%2055.2657%20109.549%2055.2728%20109.502C55.2704%20109.425%2055.3019%20109.341%2055.2728%20109.267C55.2437%20109.193%2055.2774%20109.132%2055.2809%20109.064C55.2817%20108.986%2055.2872%20108.908%2055.2976%20108.83C55.303%20108.798%2055.2999%20108.765%2055.3085%20108.732C55.3085%20108.714%2055.3053%20108.695%2055.2992%20108.678C55.291%20108.655%2055.3015%20108.656%2055.3058%20108.634C55.3126%20108.575%2055.3155%20108.516%2055.3143%20108.457C55.3108%20108.38%2055.3116%20108.303%2055.3166%20108.226C55.3166%20108.223%2055.319%20108.22%2055.3166%20108.218C55.2986%20108.15%2055.2848%20108.081%2055.2755%20108.012C55.2685%20107.954%2055.3143%20107.871%2055.2953%20107.813C55.2884%20107.786%2055.283%20107.759%2055.279%20107.732C55.2723%20107.706%2055.2595%20107.682%2055.2414%20107.662C55.2234%20107.642%2055.2007%20107.626%2055.1754%20107.616C55.1144%20107.588%2055.0504%20107.565%2054.9876%20107.539C54.9542%20107.53%2054.9198%20107.525%2054.8851%20107.525C54.7974%20107.519%2054.7095%20107.533%2054.6282%20107.566C54.6203%20107.569%2054.6126%20107.573%2054.6053%20107.578C54.556%20107.611%2054.514%20107.654%2054.4819%20107.704C54.4685%20107.729%2054.4615%20107.756%2054.4614%20107.784C54.4485%20107.873%2054.4442%20107.963%2054.4486%20108.054C54.4486%20108.095%2054.4874%20108.165%2054.4951%20108.208C54.4968%20108.214%2054.4978%20108.22%2054.4982%20108.226C54.4928%20108.303%2054.4672%20108.35%2054.4575%20108.425C54.4557%20108.43%2054.4547%20108.436%2054.4544%20108.442C54.4636%20108.513%2054.4628%20108.584%2054.4521%20108.654C54.4408%20108.74%2054.4862%20108.794%2054.4971%20108.88C54.4996%20108.895%2054.4996%20108.91%2054.4971%20108.925C54.4885%20108.97%2054.4466%20109.047%2054.4583%20109.092C54.4699%20109.151%2054.4699%20109.213%2054.4583%20109.272C54.4497%20109.329%2054.4583%20109.384%2054.4552%20109.44C54.4528%20109.478%2054.4734%20109.517%2054.473%20109.555C54.473%20109.612%2054.4521%20109.671%2054.4524%20109.727C54.4597%20109.761%2054.4694%20109.794%2054.4815%20109.826C54.4885%20109.862%2054.4602%20109.887%2054.4567%20109.922C54.4544%20109.948%2054.4567%20110.018%2054.4567%20110.043C54.4567%20110.08%2054.4292%20110.121%2054.4369%20110.157C54.447%20110.207%2054.4583%20110.203%2054.4594%20110.253C54.4594%20110.314%2054.4668%20110.373%2054.4715%20110.434C54.4771%20110.498%2054.4788%20110.563%2054.4765%20110.627C54.4731%20110.659%2054.475%20110.691%2054.4819%20110.722C54.485%20110.734%2054.4819%20110.746%2054.4866%20110.758C54.5037%20110.834%2054.5061%20110.912%2054.4936%20110.989C54.4936%20111.009%2054.4959%20111.028%2054.4975%20111.048C54.502%20111.078%2054.502%20111.108%2054.4975%20111.138C54.4926%20111.168%2054.495%20111.199%2054.5044%20111.228C54.5256%20111.354%2054.531%20111.481%2054.5204%20111.608C54.5261%20111.663%2054.5369%20111.718%2054.5526%20111.772C54.5813%20111.888%2054.525%20112.003%2054.532%20112.123C54.5378%20112.221%2054.5359%20112.319%2054.5456%20112.417C54.5479%20112.439%2054.5409%20112.462%2054.5417%20112.485C54.5444%20112.574%2054.6042%20112.643%2054.5859%20112.731C54.5727%20112.809%2054.5684%20112.889%2054.5731%20112.968C54.5731%20113.017%2054.6061%20113.023%2054.5848%20113.054C54.5491%20113.103%2054.6046%20113.166%2054.6053%20113.224C54.6061%20113.246%2054.6107%20113.269%2054.6189%20113.29C54.6307%20113.323%2054.6533%20113.35%2054.6829%20113.367C54.7276%20113.399%2054.7794%20113.421%2054.8339%20113.429C54.905%20113.437%2054.977%20113.431%2055.0454%20113.41'%20fill='%23121C2D'/%3e%3cpath%20d='M35.1409%2090.7272C34.8318%2090.7256%2034.523%2090.7437%2034.2162%2090.7815C34.1421%2090.7888%2034.0571%2090.7961%2033.9834%2090.8073C33.6578%2090.8586%2033.5538%2090.8274%2033.153%2090.9014C32.8581%2090.9553%2032.5414%2090.9842%2032.2352%2091.0239L32.1099%2091.0409C31.2147%2091.1415%2030.2946%2091.2775%2029.3796%2091.4043L29.2546%2091.4213C28.2725%2091.5369%2027.2589%2091.698%2026.2752%2091.8117L25.9019%2091.8649C25.2722%2091.9574%2024.6479%2092.04%2024.0288%2092.1128C23.8852%2092.1297%2023.7545%2092.1455%2023.602%2092.1694C23.0443%2092.2558%2022.4801%2092.3336%2021.9213%2092.4007C21.8158%2092.4138%2021.7168%2092.4253%2021.6167%2092.4431C21.2108%2092.5151%2020.5632%2092.6358%2020.1542%2092.6894C19.1736%2092.8227%2018.4165%2092.8963%2017.4378%2093.0509L17.0017%2093.1145L16.7553%2093.148C15.7708%2093.3149%2014.7789%2093.4363%2013.7875%2093.6132L12.2353%2093.8641C11.1314%2094.0484%2010.029%2094.2411%208.92797%2094.4423L7.37036%2094.7356C7.04285%2094.7957%206.69787%2094.8682%206.3886%2094.9194C5.95903%2094.9888%205.60823%2095.0505%205.30555%2095.1075L5.08748%2095.1491L4.98425%2095.1692C4.93497%2095.1811%204.8756%2095.1989%204.8236%2095.2162C4.61529%2095.2994%204.44727%2095.4591%204.35446%2095.6621C4.27052%2095.8427%204.25071%2096.0463%204.29829%2096.2395C4.34586%2096.4327%204.458%2096.6042%204.61638%2096.7259C4.69583%2096.784%204.78413%2096.829%204.87793%2096.8593C4.95554%2096.8851%204.99939%2096.8936%205.06381%2096.9125L5.44253%2097.0196C6.53877%2097.336%207.64121%2097.6267%208.74442%2097.9061C9.31563%2098.0518%209.93923%2098.1759%2010.4716%2098.3204C11.2943%2098.542%2011.8795%2098.6384%2012.5768%2098.7991L16.1468%2099.5835L17.9276%2099.9851L18.3587%20100.082C19.115%20100.244%2019.9%20100.39%2020.6598%20100.564L23.3427%20101.219C24.0005%20101.373%2024.7009%20101.501%2025.3524%20101.657C25.9896%20101.812%2026.5868%20101.975%2027.2186%20102.118C28.2884%20102.359%2029.4091%20102.647%2030.4254%20102.848C31.4188%20103.044%2032.276%20103.275%2033.2007%20103.489L36.3827%20104.232L37.7195%20104.549C37.8553%20104.582%2038.3229%20104.68%2038.4568%20104.707C38.7672%20104.769%2038.7564%20104.777%2039.0641%20104.852L41.4638%20105.408C42.5115%20105.651%2043.5623%20105.877%2044.6042%20106.128L44.7261%20106.157L47.5445%20106.758C48.3431%20106.933%2049.4641%20107.235%2050.2557%20107.397L51.357%20107.632C51.8922%20107.755%2052.4348%20107.843%2052.9814%20107.897C53.3799%20107.926%2053.7129%20107.936%2054.0803%20107.957C54.2724%20107.967%2054.2356%20107.923%2054.3015%20107.902C54.4765%20107.849%2054.1595%20107.692%2053.8006%20107.526C53.7645%20107.51%2053.6958%20107.488%2053.6364%20107.465C53.196%20107.311%2052.5704%20107.131%2051.9422%20106.953C51.6228%20106.863%2051.2235%20106.773%2050.8638%20106.686C49.6384%20106.393%2048.4001%20106.108%2047.163%20105.829C46.5875%20105.699%2045.638%20105.521%2045.0641%20105.397L44.8188%20105.344L42.1106%20104.685L41.8712%20104.627C40.9011%20104.417%2039.9422%20104.194%2038.9799%20103.965C37.8111%20103.687%2037.0664%20103.563%2035.8945%20103.307L35.2818%20103.166C34.6694%20103.018%2033.6268%20102.737%2033.0063%20102.606C32.1836%20102.433%2031.3509%20102.238%2030.5387%20102.043L28.2574%20101.52L26.678%20101.178L24.3358%20100.623C23.9477%20100.534%2023.3486%20100.422%2022.9745%20100.341C22.4778%20100.235%2022.1596%20100.133%2021.6761%20100.02L20.0168%2099.6413C19.5228%2099.5256%2018.9691%2099.3738%2018.4735%2099.2697C17.7937%2099.1263%2017.8298%2099.1475%2017.148%2098.9972L14.6718%2098.468C13.5356%2098.2264%2012.9012%2098.088%2012.016%2097.8872L10.7239%2097.597L10.2338%2097.4875C8.8461%2097.1915%208.14411%2096.9865%207.10648%2096.712L6.31448%2096.5004C5.91324%2096.3941%205.49958%2096.2777%205.11463%2096.1582C5.08934%2096.1508%205.06731%2096.1351%205.05215%2096.1137C5.037%2096.0923%205.02961%2096.0664%205.0312%2096.0402C5.02872%2096.0131%205.03489%2095.9859%205.04881%2095.9625C5.06274%2095.939%205.08373%2095.9205%205.10882%2095.9096C5.12356%2095.9069%205.11697%2095.9038%205.14763%2095.8965L5.23687%2095.8768L5.41382%2095.8383L5.76307%2095.7635L6.43943%2095.6213C6.8818%2095.5276%207.30943%2095.4463%207.7324%2095.3684L10.2683%2094.9059L12.5228%2094.4854C14.1193%2094.1937%2015.7436%2093.9917%2017.3707%2093.7431L21.4452%2093.138L22.3843%2093.01C23.6186%2092.835%2024.5736%2092.6427%2025.7925%2092.4943C26.9139%2092.3575%2028.0796%2092.1949%2029.0862%2092.0546C29.7564%2091.9613%2029.8421%2091.917%2030.2678%2091.8792C30.9624%2091.8179%2031.8309%2091.6421%2032.6245%2091.5269C32.9349%2091.4822%2033.2527%2091.4321%2033.548%2091.3816C33.9671%2091.3091%2034.333%2091.2359%2034.6066%2091.1627C34.8949%2091.1052%2035.1752%2091.0133%2035.4413%2090.889C35.5301%2090.8035%2035.4529%2090.7426%2035.1413%2090.7202'%20fill='%23121C2D'/%3e%3cpath%20d='M95.3809%2081.3759C95.2271%2081.3503%2095.0706%2081.3442%2094.9153%2081.3578C94.8765%2081.3578%2094.8353%2081.3601%2094.7989%2081.3655C94.6602%2081.3679%2094.5217%2081.3778%2094.384%2081.3952C94.2328%2081.4215%2094.0802%2081.4396%2093.9269%2081.4495L93.8644%2081.4565C93.4174%2081.49%2092.9603%2081.5605%2092.5063%2081.623L92.4442%2081.6315C91.9545%2081.6766%2091.4523%2081.769%2090.9622%2081.8149C90.9044%2081.8203%2090.8385%2081.8326%2090.7768%2081.8423C90.4648%2081.8916%2090.1543%2081.9316%2089.8454%2081.9621C89.7733%2081.9691%2089.7085%2081.9756%2089.6324%2081.9887C89.3561%2082.0358%2089.076%2082.0743%2088.7973%2082.1044C88.7467%2082.1084%2088.6963%2082.1151%2088.6464%2082.1244C88.4462%2082.1672%2088.1264%2082.24%2087.9227%2082.2659C87.4349%2082.3248%2087.0569%2082.3453%2086.5719%2082.42L86.355%2082.4486C86.3138%2082.454%2086.2704%2082.4559%2086.2323%2082.4628C85.7442%2082.5488%2085.2498%2082.59%2084.7578%2082.6756C84.5098%2082.7184%2084.2428%2082.7457%2083.9852%2082.7835L82.3371%2083.0232L81.561%2083.1369C81.3977%2083.16%2081.2258%2083.1905%2081.0702%2083.2013C80.5196%2083.2467%2079.9722%2083.3239%2079.4307%2083.4325L77.7551%2083.6684C77.466%2083.707%2077.1575%2083.7744%2076.8847%2083.796C76.4629%2083.8295%2076.1777%2083.9051%2075.8257%2083.9502L74.0294%2084.2119L73.1303%2084.336L72.9126%2084.3684C72.5327%2084.432%2072.1466%2084.5225%2071.7632%2084.5784C71.3069%2084.6439%2070.8556%2084.6728%2070.3996%2084.7357C70.0675%2084.7811%2069.7217%2084.8632%2069.3907%2084.9041C69.0679%2084.9426%2068.7598%2084.9615%2068.4416%2085.0097C67.903%2085.0914%2067.3302%2085.1431%2066.8257%2085.2483C66.3325%2085.3508%2065.8917%2085.3801%2065.4249%2085.4456C64.8886%2085.5204%2064.3523%2085.5998%2063.8168%2085.6642L63.1401%2085.752C63.071%2085.7594%2062.837%2085.8018%2062.771%2085.8152C62.6693%2085.8343%2062.5666%2085.8472%2062.4633%2085.8538C62.0601%2085.9012%2061.655%2085.9663%2061.2514%2086.0218C60.7221%2086.0947%2060.1959%2086.1849%2059.6674%2086.2492L59.6061%2086.2562C59.0826%2086.3506%2058.7194%2086.4173%2058.1956%2086.5025C57.7951%2086.5676%2057.2177%2086.6054%2056.8234%2086.6809L56.2724%2086.7769C56%2086.816%2055.7338%2086.8893%2055.48%2086.995C55.2945%2087.0829%2055.1436%2087.1692%2054.9756%2087.2567C54.8871%2087.3022%2054.9146%2087.3338%2054.8906%2087.3724C54.8258%2087.4741%2055.007%2087.5312%2055.2088%2087.5843C55.2381%2087.5899%2055.2678%2087.5934%2055.2976%2087.5948C55.5928%2087.6102%2055.8886%2087.6089%2056.1835%2087.5909C56.3492%2087.584%2056.5499%2087.5543%2056.7326%2087.5319C57.3535%2087.4548%2057.979%2087.3681%2058.6019%2087.2749C58.8913%2087.2309%2059.3601%2087.1238%2059.6496%2087.076L59.7722%2087.0548C60.291%2086.985%2060.6294%2086.9611%2061.1478%2086.896L61.2693%2086.8813C61.7547%2086.8%2062.2394%2086.7337%2062.728%2086.6717C63.3201%2086.5946%2063.6837%2086.4978%2064.272%2086.4019C64.3756%2086.3845%2064.4765%2086.371%2064.5824%2086.3587C64.8929%2086.3202%2065.4299%2086.2855%2065.74%2086.2288C66.1509%2086.1544%2066.5719%2086.0978%2066.9837%2086.0465C67.3717%2085.9979%2067.7508%2085.934%2068.1346%2085.8804C68.4031%2085.8418%2068.6573%2085.7852%2068.9258%2085.7459L70.1117%2085.5917C70.3084%2085.5624%2070.6034%2085.4953%2070.7904%2085.463C71.0391%2085.4194%2071.2076%2085.4244%2071.4501%2085.3901L72.2867%2085.2672C72.5358%2085.2317%2072.8214%2085.2159%2073.069%2085.172C73.4082%2085.1118%2073.3868%2085.1034%2073.7287%2085.0517L74.9704%2084.8567L76.3065%2084.6547C76.5242%2084.6243%2076.743%2084.5942%2076.958%2084.5537C77.0383%2084.5399%2077.1249%2084.526%2077.2048%2084.5125C77.899%2084.3768%2078.2634%2084.3522%2078.7927%2084.2724L79.197%2084.2088C79.4035%2084.1764%2079.6072%2084.1406%2079.8179%2084.1171C80.0286%2084.0935%2080.2355%2084.0565%2080.4388%2084.0192C81.405%2083.8392%2082.1796%2083.7555%2083.0496%2083.6237C83.4318%2083.5655%2083.8008%2083.4961%2084.1749%2083.4291C84.9692%2083.2868%2085.781%2083.2271%2086.5909%2083.1046C87.2653%2083.0047%2087.9413%2082.9053%2088.615%2082.8051C88.7702%2082.7854%2088.9254%2082.7665%2089.0806%2082.7446C89.6937%2082.6567%2090.1633%2082.5314%2090.7694%2082.4655C91.3274%2082.4054%2091.906%2082.3237%2092.4058%2082.2539C92.5993%2082.2133%2092.7949%2082.1828%2092.9917%2082.1626C93.339%2082.1499%2093.7678%2082.0377%2094.1605%2081.9837C94.3157%2081.9625%2094.471%2081.9359%2094.6184%2081.9066C94.796%2081.8765%2094.9707%2081.8315%2095.1407%2081.7721C95.3274%2081.7004%2095.514%2081.6299%2095.5466%2081.5655C95.5854%2081.4885%2095.5435%2081.4214%2095.3844%2081.3755'%20fill='%23121C2D'/%3e%3cpath%20d='M1.80718%20112.828C2.18436%20112.953%203.03613%20113.18%203.99771%20113.424L4.55106%20113.568C5.3388%20113.757%205.56386%20113.86%206.54135%20114.083C7.26079%20114.243%208.01244%20114.458%208.74895%20114.647L9.05008%20114.724L15.5984%20116.461L15.8983%20116.541C18.2406%20117.194%2020.6829%20117.838%2023.026%20118.507L23.9212%20118.751C25.4312%20119.163%2026.9238%20119.577%2028.3989%20119.996L29.4233%20120.28L33.4512%20121.382L34.1804%20121.58C35.1614%20121.833%2036.7353%20122.22%2037.7155%20122.487C40.0663%20123.118%2041.8676%20123.617%2044.2304%20124.204L45.2828%20124.464L45.8773%20124.614L49.4652%20125.468C50.6619%20125.752%2051.8641%20126.036%2053.0949%20126.26C54.3779%20126.507%2055.6786%20126.652%2056.9847%20126.694C58.3788%20126.736%2059.7741%20126.669%2061.1574%20126.492C61.8532%20126.405%2062.5307%20126.278%2063.2082%20126.169L65.2435%20125.829L69.0852%20125.189L71.5058%20124.788C75.7282%20124.133%2076.8997%20123.885%2079.597%20123.417L87.8624%20121.991C89.2881%20121.744%2090.8209%20121.451%2092.1581%20121.237C94.2233%20120.903%2095.6505%20120.612%2097.3808%20120.309L106.238%20118.723L110.668%20117.93L111.739%20117.734L117.427%20116.655L124.123%20115.471L129.099%20114.534L133.755%20113.708C136.41%20113.214%20139.215%20112.728%20141.717%20112.234C144.162%20111.751%20146.315%20111.386%20148.613%20110.965L156.525%20109.52L159.853%20108.917L161.677%20108.57C162.439%20108.422%20162.422%20108.435%20163.19%20108.3L169.155%20107.214L176.959%20105.794L177.262%20105.74L184.233%20104.438L185.847%20104.149C186.454%20104.058%20187.056%20103.936%20187.651%20103.783C188.298%20103.624%20188.898%20103.311%20189.397%20102.871C189.637%20102.645%20189.836%20102.379%20189.984%20102.085C190.115%20101.821%20190.211%20101.541%20190.27%20101.253C190.359%20100.78%20190.406%20100.3%20190.41%2099.8182C190.424%2099.3518%20190.434%2098.8831%20190.431%2098.4195C190.436%2097.0671%20190.338%2095.7162%20190.136%2094.3787C189.978%2093.4151%20189.808%2092.6292%20189.602%2091.7605C189.581%2091.5898%20189.517%2091.4272%20189.416%2091.2872C189.256%2090.9214%20189.332%2091.764%20189.384%2092.7059L189.418%2093.128C189.514%2094.2515%20189.625%2095.8259%20189.623%2097.4062C189.626%2098.2075%20189.62%2099.2027%20189.573%20100.091C189.592%20100.784%20189.397%20101.465%20189.015%20102.044C188.547%20102.552%20187.927%20102.896%20187.246%20103.026C186.535%20103.211%20185.748%20103.317%20184.982%20103.464L182.677%20103.882L177.495%20104.865L176.888%20104.979L170.131%20106.17L169.533%20106.276C167.137%20106.727%20164.748%20107.162%20162.351%20107.591C159.44%20108.116%20157.625%20108.497%20154.722%20109.043L153.199%20109.322C151.674%20109.596%20149.053%20110.039%20147.52%20110.333C145.49%20110.723%20143.418%20111.104%20141.393%20111.467L135.727%20112.514L131.819%20113.254L125.988%20114.309L122.629%20114.956C121.401%20115.187%20120.586%20115.309%20119.387%20115.525L115.265%20116.28C114.038%20116.502%20112.643%20116.73%20111.42%20116.96L108.153%20117.576L102.021%20118.694L95.4293%20119.876L92.2128%20120.454L90.9924%20120.674C87.55%20121.31%2085.7681%20121.599%2083.1538%20122.052L81.1565%20122.401L78.091%20122.932L75.0312%20123.46C70.2396%20124.319%2066.4267%20124.919%2062.126%20125.642C60.2909%20125.96%2058.427%20126.084%2056.5656%20126.012C54.5801%20125.894%2052.6115%20125.579%2050.6891%20125.071C48.7312%20124.609%2046.7684%20124.133%2044.8004%20123.645C41.5234%20122.836%2038.2494%20121.974%2034.9898%20121.108L32.7392%20120.491C29.778%20119.688%2027.4567%20119.107%2024.5491%20118.287C21.8743%20117.53%2019.0776%20116.768%2016.6639%20116.116C15.0559%20115.686%2014.8308%20115.66%2013.8219%20115.368C12.1742%20114.896%2010.0547%20114.397%208.14011%20113.917C7.39389%20113.724%206.62168%20113.541%205.90496%20113.374C4.88556%20113.136%203.98995%20112.934%203.30737%20112.812C2.61034%20112.663%201.90617%20112.549%201.19756%20112.47C0.939899%20112.484%201.0858%20112.591%201.80097%20112.828'%20fill='%23121C2D'/%3e%3cpath%20d='M177.077%20105.6C177.058%20105.9%20177.07%20106.566%20177.095%20107.316C177.101%20107.454%20177.107%20107.613%20177.112%20107.748C177.151%20108.358%20177.115%20108.544%20177.176%20109.299C177.221%20109.854%20177.238%20110.444%20177.268%20111.018C177.272%20111.095%20177.277%20111.18%20177.28%20111.253C177.351%20112.924%20177.459%20114.65%20177.558%20116.362C177.563%20116.439%20177.567%20116.522%20177.571%20116.596C177.671%20118.43%20177.775%20120.335%20177.875%20122.171C177.888%20122.388%20177.903%20122.637%20177.917%20122.87C177.991%20124.049%20178.056%20125.217%20178.111%20126.373C178.126%20126.643%20178.139%20126.885%20178.155%20127.174C178.224%20128.22%20178.285%20129.275%20178.336%20130.321C178.346%20130.518%20178.354%20130.702%20178.368%20130.89C178.427%20131.652%20178.526%20132.871%20178.566%20133.637C178.663%20135.471%20178.712%20136.881%20178.824%20138.713C178.84%20138.982%20178.855%20139.258%20178.87%20139.529C178.878%20139.683%20178.886%20139.847%20178.893%20139.991C179.001%20141.841%20179.108%20143.692%20179.217%20145.556C179.27%20146.495%20179.327%20147.495%20179.382%20148.468L179.744%20154.686C179.801%20155.664%20179.857%20156.642%20179.914%20157.62C179.949%20158.237%20179.992%20158.889%20180.014%20159.47C180.135%20162.692%20180.247%20163.591%20180.363%20165.653C180.482%20167.76%20180.601%20169.866%20180.719%20171.971C180.779%20173.062%20180.869%20174.236%20180.909%20175.257C180.945%20176.046%20180.966%20176.708%20181.045%20177.37C181.107%20178.056%20181.31%20178.722%20181.64%20179.327C181.722%20179.465%20181.814%20179.597%20181.914%20179.722C181.969%20179.786%20182.031%20179.848%20182.088%20179.91C182.144%20179.972%20182.215%20180.021%20182.28%20180.076C182.544%20180.279%20182.846%20180.429%20183.168%20180.518C183.494%20180.611%20183.837%20180.634%20184.172%20180.585C184.533%20180.534%20184.869%20180.372%20185.133%20180.122C185.387%20179.869%20185.56%20179.546%20185.627%20179.194C185.684%20178.889%20185.707%20178.579%20185.698%20178.269L185.683%20176.571C185.676%20175.434%20185.668%20174.304%20185.661%20173.175C185.659%20172.905%20185.656%20172.624%20185.654%20172.353C185.633%20170.911%20185.586%20169.433%20185.576%20167.985C185.576%20166.26%20185.576%20164.575%20185.576%20162.853C185.559%20161.599%20185.54%20160.275%20185.522%20159.032C185.519%20157.815%20185.537%20156.665%20185.524%20155.462C185.504%20153.425%20185.516%20151.276%20185.469%20149.351C185.422%20147.471%20185.443%20145.823%20185.43%20144.059C185.417%20142.034%20185.405%20140.007%20185.391%20137.989C185.387%20137.149%20185.383%20136.282%20185.379%20135.437C185.375%20135.177%20185.361%20134.29%20185.357%20134.037C185.344%20133.452%20185.354%20133.466%20185.353%20132.878C185.343%20131.359%20185.332%20129.825%20185.321%20128.302C185.304%20126.304%20185.287%20124.308%20185.271%20122.315C185.271%20122.238%20185.271%20122.156%20185.271%20122.084C185.238%20120.095%20185.215%20118.716%20185.182%20116.731C185.162%20115.213%20185.188%20113.056%20185.156%20111.556C185.145%20110.875%20185.133%20110.161%20185.121%20109.464C185.098%20108.085%20185.052%20107.076%20184.99%20106.414C184.916%20105.681%20184.854%20105.075%20184.785%20104.401C184.79%20104.268%20184.753%20104.136%20184.68%20104.024C184.585%20103.73%20184.508%20104.371%20184.432%20105.09C184.424%20105.162%20184.418%20105.296%20184.412%20105.413C184.365%20106.275%20184.341%20107.483%20184.318%20108.695C184.306%20109.312%20184.313%20110.07%20184.315%20110.759C184.332%20113.1%20184.348%20115.461%20184.365%20117.816C184.387%20118.911%20184.424%20120.704%20184.447%20121.796C184.449%20121.95%20184.452%20122.108%20184.454%20122.261C184.454%20124.22%20184.457%20125.485%20184.459%20127.439C184.459%20127.593%20184.459%20127.75%20184.459%20127.898C184.486%20129.738%20184.498%20131.57%20184.505%20133.409C184.514%20135.641%20184.572%20137.04%20184.602%20139.268C184.606%20139.662%20184.608%20140.04%20184.611%20140.436C184.613%20141.606%20184.588%20143.612%20184.611%20144.789C184.639%20146.349%20184.65%20147.939%20184.653%20149.491C184.665%20150.951%20184.677%20152.392%20184.689%20153.84C184.704%20154.854%20184.718%20155.825%20184.733%20156.841C184.739%20158.317%20184.746%20159.838%20184.752%20161.312C184.767%20162.055%20184.791%20163.183%20184.804%20163.894C184.819%20164.838%20184.796%20165.459%20184.801%20166.378C184.807%20167.043%20184.823%20168.874%20184.829%20169.542C184.836%20170.482%20184.819%20171.549%20184.835%20172.488C184.856%20173.776%20184.867%20173.702%20184.88%20174.997C184.889%20175.782%20184.897%20176.566%20184.906%20177.348C184.891%20178.119%20185.016%20178.98%20184.708%20179.425C184.604%20179.568%20184.463%20179.681%20184.301%20179.752C184.139%20179.824%20183.961%20179.851%20183.784%20179.832C183.443%20179.82%20183.112%20179.711%20182.831%20179.518C182.702%20179.432%20182.588%20179.326%20182.492%20179.205C182.389%20179.075%20182.3%20178.936%20182.224%20178.789C182.065%20178.463%20181.954%20178.116%20181.893%20177.759C181.756%20177.005%20181.748%20176.169%20181.683%20175.354C181.664%20175.051%20181.644%20174.722%20181.624%20174.42C181.439%20171.784%20181.388%20170.422%20181.27%20168.423L181.178%20166.895C181.132%20166.115%20181.087%20165.342%20181.041%20164.552C181.002%20163.769%20180.951%20162.976%20180.899%20162.212C180.647%20158.547%20180.508%20155.636%20180.311%20152.35C180.217%20150.906%20180.125%20149.505%20180.033%20148.093C179.83%20145.083%20179.71%20142.045%20179.526%20138.986C179.374%20136.44%20179.222%20133.887%20179.07%20131.345C179.038%20130.767%20179.005%20130.172%20178.973%20129.586C178.836%20127.274%20178.672%20125.474%20178.559%20123.196C178.442%20121.101%20178.32%20118.918%20178.214%20117.033C178.141%20115.779%20178.098%20115.612%20178.075%20114.82C178.036%20113.527%20177.885%20111.89%20177.798%20110.405C177.76%20109.827%20177.721%20109.228%20177.685%20108.673C177.627%20107.886%20177.568%20107.196%20177.505%20106.676C177.459%20106.139%20177.378%20105.606%20177.261%20105.08C177.178%20104.897%20177.114%20105.026%20177.079%20105.596'%20fill='%23121C2D'/%3e%3cpath%20d='M53.5307%20126.526C53.5125%20126.912%2053.5238%20127.766%2053.5482%20128.728C53.5536%20128.905%2053.5599%20129.109%2053.5649%20129.282C53.6037%20130.066%2053.5672%20130.304%2053.6278%20131.274C53.6716%20131.987%2053.6891%20132.745%2053.7178%20133.481C53.722%20133.581%2053.7263%20133.69%2053.7306%20133.782C53.7993%20135.928%2053.9068%20138.145%2054.0042%20140.344C54.0084%20140.444%2054.0131%20140.55%2054.0174%20140.645C54.1159%20143%2054.218%20145.445%2054.3169%20147.804C54.3297%20148.083%2054.3449%20148.403%2054.3588%20148.702C54.432%20150.217%2054.4956%20151.716%2054.5494%20153.201C54.5637%20153.548%2054.5769%20153.859%2054.5924%20154.23C54.6611%20155.574%2054.7213%20156.928%2054.7713%20158.271C54.7822%20158.523%2054.7927%20158.76%2054.8031%20159.003C54.861%20159.982%2054.9584%20161.547%2054.9991%20162.532C55.0946%20164.887%2055.1423%20166.698%2055.2533%20169.05C55.268%20169.397%2055.2832%20169.75%2055.2983%20170.099C55.3057%20170.298%2055.3138%20170.507%2055.3212%20170.691C55.4275%20173.066%2055.5342%20175.441%2055.6413%20177.838C55.6941%20179.045%2055.75%20180.328%2055.8047%20181.576L56.1617%20189.562C56.2178%20190.819%2056.274%20192.075%2056.3301%20193.331C56.3646%20194.122%2056.4077%20194.96%2056.4287%20195.705C56.5474%20199.841%2056.6576%20200.997%2056.7736%20203.644C56.8908%20206.35%2057.0079%20209.055%2057.1248%20211.759C57.1834%20213.159%2057.2731%20214.668%2057.3126%20215.979C57.3433%20216.992%2057.3821%20217.849%2057.4229%20218.667C57.448%20219.503%2057.5388%20220.336%2057.6945%20221.159C57.7725%20221.538%2057.8877%20221.91%2058.0387%20222.267C58.116%20222.45%2058.2068%20222.628%2058.3103%20222.798C58.4206%20222.979%2058.5507%20223.147%2058.6984%20223.299C59.0048%20223.607%2059.3885%20223.828%2059.8097%20223.939C60.261%20224.059%2060.7418%20224%2061.1497%20223.774C61.5389%20223.532%2061.828%20223.159%2061.9646%20222.724C62.0827%20222.342%2062.1444%20221.944%2062.1477%20221.544C62.1594%20220.789%2062.1427%20220.084%2062.1419%20219.351C62.1354%20217.893%2062.1288%20216.441%2062.1221%20214.993C62.1198%20214.646%2062.1171%20214.287%2062.1151%20213.939C62.0895%20212.089%2062.0635%20210.191%2062.0375%20208.332C62.0375%20206.119%2062.0375%20203.955%2062.0375%20201.746C62.0204%20200.136%2062.0026%20198.437%2061.9855%20196.841C61.9855%20195.279%2061.9882%20193.803%2061.9894%20192.259C61.9696%20189.644%2061.984%20186.887%2061.9366%20184.417C61.8912%20182.004%2061.9122%20179.888%2061.9009%20177.624C61.8893%20175.025%2061.878%20172.423%2061.8668%20169.833C61.8633%20168.754%2061.8598%20167.643%2061.8563%20166.557C61.8524%20166.223%2061.8392%20165.085%2061.8353%20164.761C61.8218%20164.008%2061.8326%20164.027%2061.8318%20163.273C61.8218%20161.324%2061.8121%20159.354%2061.802%20157.399C61.7864%20154.835%2061.7707%20152.274%2061.7546%20149.716C61.7546%20149.616%2061.7546%20149.511%2061.7546%20149.418C61.7228%20146.865%2061.7007%20145.095%2061.6689%20142.548C61.6491%20140.599%2061.6759%20137.831%2061.6452%20135.905C61.6343%20135.031%2061.6227%20134.115%2061.6114%20133.22C61.5889%20131.45%2061.5427%20130.155%2061.4822%20129.305C61.4077%20128.365%2061.3464%20127.586%2061.2777%20126.722C61.2837%20126.555%2061.2474%20126.389%2061.1722%20126.239C61.0779%20125.861%2061.0003%20126.683%2060.9242%20127.605C60.9164%20127.699%2060.9102%20127.871%2060.904%20128.02C60.8563%20129.126%2060.8318%20130.677%2060.8082%20132.232C60.7961%20133.023%2060.8031%20133.998%2060.8047%20134.881C60.8198%20137.885%2060.8357%20140.915%2060.8512%20143.939C60.873%20145.344%2060.9091%20147.646%2060.9312%20149.047C60.9335%20149.247%2060.9358%20149.448%2060.9382%20149.644C60.9382%20152.159%2060.9382%20153.781%2060.9405%20156.29C60.9405%20156.488%2060.9405%20156.689%2060.9405%20156.878C60.9669%20159.24%2060.9793%20161.591%2060.984%20163.951C60.9913%20166.815%2061.0488%20168.611%2061.0779%20171.472C61.0806%20171.978%2061.0833%20172.464%2061.086%20172.972C61.086%20174.475%2061.062%20177.047%2061.0829%20178.56C61.1105%20180.564%2061.1186%20182.603%2061.1217%20184.595C61.133%20186.469%2061.1442%20188.318%2061.1555%20190.177C61.1698%20191.478%2061.1838%20192.725%2061.1982%20194.029C61.2036%20195.924%2061.2094%20197.876%2061.2148%20199.769C61.2296%20200.723%2061.2517%20202.17%2061.2653%20203.084C61.2804%20204.294%2061.2571%20205.091%2061.2614%20206.272C61.2668%20207.124%2061.2824%20209.476%2061.2878%20210.332C61.294%20211.539%2061.2773%20212.908%2061.2921%20214.114C61.3146%20215.766%2061.3134%20215.672%2061.3359%20217.334C61.3439%20218.341%2061.3521%20219.347%2061.3604%20220.351C61.3604%20220.852%2061.3833%20221.364%2061.3464%20221.821C61.3433%20222.235%2061.2008%20222.637%2060.9417%20222.961C60.7801%20223.125%2060.5621%20223.221%2060.3317%20223.231C60.1016%20223.233%2059.8746%20223.178%2059.672%20223.07C59.4725%20222.967%2059.296%20222.826%2059.1532%20222.654C59.0128%20222.481%2058.8944%20222.291%2058.8008%20222.089C58.4408%20221.2%2058.2492%20220.253%2058.2358%20219.295C58.1858%20218.244%2058.1349%20217.185%2058.0845%20216.14C58.0655%20215.751%2058.0457%20215.328%2058.0263%20214.94C57.8427%20211.553%2057.7934%20209.806%2057.677%20207.239C57.6465%20206.584%2057.6161%20205.93%2057.5858%20205.276C57.5408%20204.274%2057.4962%20203.281%2057.4504%20202.266C57.4116%20201.262%2057.3612%20200.242%2057.3095%20199.26C57.0608%20194.55%2056.9242%20190.814%2056.7298%20186.593C56.6363%20184.738%2056.5455%20182.939%2056.4539%20181.124C56.2537%20177.257%2056.1357%20173.358%2055.9541%20169.429C55.8043%20166.158%2055.6537%20162.88%2055.5036%20159.615C55.4717%20158.87%2055.4395%20158.108%2055.4069%20157.356C55.2719%20154.386%2055.1093%20152.072%2054.9976%20149.146C54.8811%20146.455%2054.762%20143.652%2054.658%20141.231C54.5855%20139.62%2054.5435%20139.406%2054.5199%20138.388C54.4811%20136.731%2054.3328%20134.626%2054.2482%20132.717C54.2094%20131.972%2054.1706%20131.205%2054.1353%20130.493C54.0787%20129.481%2054.0189%20128.594%2053.9572%20127.926C53.9121%20127.237%2053.831%20126.551%2053.7143%20125.871C53.6312%20125.634%2053.5668%20125.798%2053.5315%20126.526'%20fill='%23121C2D'/%3e%3cpath%20d='M132.035%20113.377C131.997%20113.585%20131.978%20113.796%20131.979%20114.007C131.979%20114.058%20131.974%20114.116%20131.979%20114.165C131.992%20114.388%20131.948%20114.458%20131.976%20114.733C131.996%20114.937%20131.988%20115.153%20131.993%20115.363C131.993%20115.391%20131.993%20115.423%20131.995%20115.449C131.992%20116.062%20132.028%20116.693%20132.047%20117.32C132.047%20117.349%20132.047%20117.379%20132.049%20117.406C132.049%20118.078%20132.096%20118.775%20132.097%20119.449C132.097%20119.528%20132.104%20119.619%20132.108%20119.705C132.129%20120.137%20132.136%20120.564%20132.135%20120.988C132.135%20121.086%20132.135%20121.176%20132.141%20121.281C132.16%20121.664%20132.17%20122.052%20132.171%20122.434C132.171%20122.506%20132.171%20122.573%20132.176%20122.642C132.198%20122.921%20132.239%20123.368%20132.242%20123.648C132.248%20124.32%20132.227%20124.837%20132.248%20125.508C132.248%20125.607%20132.251%20125.708%20132.253%20125.807C132.253%20125.864%20132.253%20125.923%20132.253%20125.976C132.284%20126.653%20132.271%20127.331%20132.297%20128.015C132.31%20128.359%20132.306%20128.726%20132.313%20129.082L132.352%20131.361L132.368%20132.436C132.371%20132.662%20132.38%20132.901%20132.371%20133.114C132.324%20134.294%20132.385%20134.624%20132.393%20135.379L132.411%20137.695C132.411%20138.094%20132.439%20138.525%20132.423%20138.899C132.401%20139.477%20132.439%20139.879%20132.439%20140.364C132.446%20141.193%20132.453%20142.021%20132.46%20142.849C132.46%20143.265%20132.462%20143.678%20132.463%20144.092C132.463%20144.191%20132.466%20144.294%20132.467%20144.393C132.479%20144.92%20132.519%20145.461%20132.523%20145.991C132.527%20146.623%20132.496%20147.24%20132.497%20147.87C132.497%20148.329%20132.536%20148.813%20132.531%20149.269C132.528%20149.715%20132.505%20150.136%20132.511%20150.576C132.521%20151.322%20132.498%20152.108%20132.537%20152.812C132.576%20153.499%20132.548%20154.103%20132.552%20154.749C132.557%20155.491%20132.562%20156.232%20132.566%20156.972C132.566%20157.28%20132.566%20157.597%20132.569%20157.906C132.569%20158.002%20132.581%20158.327%20132.586%20158.419C132.597%20158.633%20132.586%20158.628%20132.586%20158.843C132.586%20159.399%20132.6%20159.96%20132.607%20160.518C132.62%20161.25%20132.633%20161.981%20132.646%20162.71V162.795C132.677%20163.523%20132.699%20164.029%20132.729%20164.754C132.748%20165.31%20132.72%20166.101%20132.754%20166.65C132.766%20166.9%20132.779%20167.161%20132.791%20167.415C132.8%20167.79%20132.845%20168.163%20132.924%20168.53C132.992%20168.796%20133.063%20169.016%20133.131%20169.262C133.167%20169.39%20133.202%20169.357%20133.238%20169.397C133.332%20169.502%20133.409%20169.266%20133.484%20169.001C133.493%20168.961%20133.499%20168.922%20133.504%20168.882C133.55%20168.565%20133.573%20168.123%20133.595%20167.679C133.606%20167.453%20133.598%20167.175%20133.595%20166.923C133.579%20166.067%20133.563%20165.203%20133.547%20164.341C133.537%20163.94%20133.483%20163.285%20133.469%20162.886C133.467%20162.829%20133.465%20162.77%20133.462%20162.715C133.452%20161.999%20133.472%20161.536%20133.468%20160.82V160.653C133.445%20159.98%20133.437%20159.309%20133.435%20158.637C133.435%20157.82%20133.382%20157.309%20133.358%20156.493C133.358%20156.349%20133.355%20156.21%20133.354%20156.066C133.354%20155.637%20133.388%20154.903%20133.372%20154.472C133.35%20153.901%20133.349%20153.319%20133.351%20152.751C133.346%20152.217%20133.341%20151.69%20133.336%20151.16C133.336%20150.789%20133.31%20150.433%20133.306%20150.061C133.306%20149.522%20133.309%20148.965%20133.31%20148.425C133.307%20148.153%20133.279%20147.74%20133.271%20147.48C133.261%20147.133%20133.287%20146.907%20133.288%20146.57C133.285%20146.327%20133.279%20145.657%20133.276%20145.414C133.276%20145.069%20133.297%20144.679%20133.286%20144.335C133.272%20143.864%20133.261%20143.891%20133.255%20143.417C133.246%20142.842%20133.236%20142.27%20133.227%20141.695C133.217%20140.905%20133.211%20140.462%20133.203%20139.845C133.203%20139.545%20133.2%20139.242%20133.188%20138.943C133.185%20138.831%20133.182%20138.711%20133.179%20138.6C133.137%20137.633%20133.158%20137.135%20133.147%20136.403L133.136%20135.843C133.13%20135.556%20133.121%20135.273%20133.124%20134.983C133.127%20134.693%20133.118%20134.405%20133.106%20134.125C133.047%20132.781%20133.062%20131.714%20133.036%20130.509C133.024%20129.979%20132.997%20129.465%20132.976%20128.947C132.929%20127.844%20132.963%20126.73%20132.929%20125.608C132.902%20124.674%20132.887%20123.738%20132.849%20122.806C132.845%20122.593%20132.84%20122.376%20132.836%20122.161C132.809%20121.313%20132.734%20120.654%20132.725%20119.818C132.717%20119.05%20132.687%20118.25%20132.664%20117.559C132.647%20117.099%20132.614%20117.038%20132.625%20116.747C132.643%20116.273%20132.563%20115.674%20132.541%20115.128C132.532%20114.916%20132.518%20114.697%20132.502%20114.494C132.486%20114.248%20132.455%20114.004%20132.409%20113.762C132.384%20113.559%20132.325%20113.363%20132.235%20113.18C132.16%20113.115%20132.09%20113.163%20132.03%20113.372'%20fill='%23121C2D'/%3e%3cpath%20d='M137.349%20170.398C137.404%20170.187%20137.439%20169.971%20137.455%20169.754C137.461%20169.701%20137.469%20169.641%20137.47%20169.591C137.475%20169.359%20137.525%20169.291%20137.519%20169.005C137.515%20168.794%20137.541%20168.572%20137.553%20168.355C137.553%20168.325%20137.556%20168.293%20137.557%20168.266C137.609%20167.635%20137.628%20166.98%20137.65%20166.332C137.65%20166.303%20137.652%20166.272%20137.653%20166.244C137.699%20165.55%20137.701%20164.828%20137.746%20164.134C137.752%20164.052%20137.752%20163.957%20137.754%20163.869C137.764%20163.422%20137.781%20162.979%20137.807%20162.543C137.813%20162.441%20137.818%20162.35%20137.819%20162.239C137.823%20161.843%20137.836%20161.443%20137.858%20161.048C137.862%20160.973%20137.867%20160.904%20137.865%20160.832C137.86%20160.543%20137.846%20160.079%20137.859%20159.792C137.888%20159.098%20137.936%20158.565%20137.949%20157.871C137.952%20157.768%20137.955%20157.664%20137.959%20157.562C137.962%20157.503%20137.965%20157.442%20137.968%20157.388C137.971%20156.687%20138.02%20155.987%20138.022%20155.28C138.022%20154.924%20138.044%20154.545%20138.053%20154.177L138.11%20151.822L138.136%20150.711C138.141%20150.479%20138.142%20150.23%20138.159%20150.011C138.253%20148.793%20138.202%20148.45%20138.221%20147.669L138.283%20145.277C138.296%20144.864%20138.283%20144.418%20138.31%20144.032C138.352%20143.436%20138.327%20143.02%20138.343%20142.519C138.362%20141.663%20138.381%20140.807%20138.401%20139.951C138.413%20139.522%20138.425%20139.095%20138.437%20138.668C138.437%20138.565%20138.441%20138.459%20138.443%20138.357C138.447%20137.812%20138.425%20137.252%20138.439%20136.704C138.455%20136.052%20138.507%20135.416%20138.525%20134.765C138.538%20134.291%20138.52%20133.79%20138.538%20133.32C138.557%20132.86%20138.595%20132.426%20138.604%20131.971C138.619%20131.2%20138.67%20130.391%20138.659%20129.661C138.647%20128.95%20138.697%20128.328%20138.718%20127.661C138.741%20126.896%20138.763%20126.13%20138.796%20125.368C138.808%20125.05%20138.821%20124.723%20138.834%20124.404C138.84%20124.306%20138.841%20123.97%20138.84%20123.875C138.84%20123.653%20138.848%20123.659%20138.859%20123.437C138.888%20122.864%20138.9%20122.283%20138.921%20121.708C138.95%20120.953%20138.957%20120.198%20138.997%20119.446C138.997%20119.417%20139%20119.386%20139.001%20119.358C139.013%20118.606%20139.021%20118.087%20139.032%20117.335C139.045%20116.761%20139.119%20115.947%20139.125%20115.381C139.13%20115.123%20139.135%20114.854%20139.14%20114.59C139.156%20114.204%20139.137%20113.817%20139.083%20113.434C139.033%20113.154%20138.978%20112.922%20138.928%20112.665C138.9%20112.531%20138.864%20112.561%20138.831%20112.518C138.744%20112.403%20138.651%20112.641%20138.559%20112.91C138.55%20112.937%20138.541%20112.987%20138.532%20113.031C138.464%20113.354%20138.411%20113.809%20138.359%20114.266C138.332%20114.497%20138.32%20114.786%20138.307%20115.046C138.256%20115.93%20138.222%20116.822%20138.195%20117.713C138.182%20118.128%20138.195%20118.807%20138.188%20119.22C138.188%20119.279%20138.186%20119.338%20138.184%20119.396C138.146%20120.136%20138.12%20120.614%20138.081%20121.353C138.078%20121.411%20138.075%20121.469%20138.072%20121.526C138.062%20122.222%20138.033%20122.914%20138.005%20123.61C137.97%20124.454%20138.001%20124.984%20137.988%20125.827C137.983%20125.977%20137.978%20126.12%20137.974%20126.269C137.952%20126.712%20137.89%20127.469%20137.89%20127.914C137.89%20128.505%20137.869%20129.106%20137.845%20129.692C137.822%20130.244%20137.818%20130.789%20137.802%20131.337C137.799%20131.722%20137.796%20132.088%20137.793%20132.472L137.733%20134.163C137.727%20134.444%20137.741%20134.871%20137.74%20135.14C137.74%20135.497%20137.705%20135.731%20137.694%20136.079C137.689%20136.33%20137.673%20137.023%20137.668%20137.274C137.658%20137.63%20137.623%20138.032%20137.623%20138.388C137.623%20138.874%20137.635%20138.847%20137.625%20139.337C137.616%20139.93%20137.607%20140.521%20137.599%20141.115C137.584%20141.932%20137.575%20142.387%20137.563%20143.026C137.555%20143.337%20137.546%20143.65%20137.548%20143.959C137.548%20144.075%20137.548%20144.198%20137.546%20144.313C137.557%20145.313%20137.517%20145.827%20137.503%20146.584L137.494%20147.162C137.491%20147.458%20137.489%20147.751%20137.476%20148.049C137.463%20148.347%20137.462%20148.645%20137.463%20148.935C137.47%20150.325%20137.415%20151.425%20137.392%20152.67C137.381%20153.217%20137.383%20153.749%20137.383%20154.284C137.383%20155.425%20137.297%20156.572%20137.271%20157.73C137.247%20158.694%20137.224%20159.66%20137.2%20160.624C137.192%20160.843%20137.184%20161.068%20137.176%20161.289C137.151%20162.165%20137.191%20162.849%20137.143%20163.71C137.098%20164.503%20137.072%20165.329%20137.048%20166.042C137.032%20166.516%20137.062%20166.581%20137.03%20166.88C136.976%20167.367%20137.006%20167.989%20136.985%20168.552C136.976%20168.772%20136.973%20168.998%20136.973%20169.207C136.969%20169.461%20136.98%20169.714%20137.007%20169.967C137.015%20170.177%20137.058%20170.384%20137.134%20170.581C137.203%20170.655%20137.277%20170.61%20137.353%20170.399'%20fill='%23121C2D'/%3e%3cpath%20d='M5.55767%20114.834C5.52663%20115.168%205.51034%20115.911%205.50296%20116.747C5.50296%20116.901%205.50296%20117.078%205.50296%20117.229C5.51616%20117.91%205.4719%20118.115%205.50062%20118.961C5.52196%20119.581%205.5142%20120.24%205.51886%20120.88C5.51886%20120.966%205.51886%20121.062%205.52158%20121.142C5.52158%20123.007%205.55573%20124.936%205.58096%20126.846C5.58096%20126.934%205.58327%20127.026%205.58444%20127.108C5.60578%20129.156%205.62868%20131.282%205.65002%20133.334C5.6539%20133.576%205.65856%20133.855%205.66283%20134.115C5.68663%20135.432%205.70112%20136.736%205.70629%20138.027C5.7094%20138.327%205.71211%20138.599%205.7156%20138.922C5.74005%20140.09%205.75442%20141.269%205.76257%20142.436C5.76528%20142.656%205.76799%20142.86%205.77031%20143.072C5.79631%20143.924%205.84405%20145.286%205.85181%20146.142C5.87005%20148.189%205.85879%20149.763%205.89333%20151.807C5.89682%20152.108%205.90031%20152.416%205.9038%20152.719C5.9038%20152.893%205.90614%20153.074%205.9073%20153.234C5.93641%20155.3%205.96512%20157.365%205.99423%20159.449C6.00742%20160.498%206.02179%20161.615%206.03537%20162.701L6.13198%20169.646C6.14724%20170.739%206.16237%20171.831%206.17738%20172.922C6.18592%20173.61%206.20106%20174.339%206.19834%20174.987C6.18204%20178.582%206.25422%20179.589%206.2841%20181.891C6.31308%20184.244%206.34191%20186.596%206.37062%20188.948C6.38381%20190.165%206.42339%20191.478%206.42029%20192.617C6.41679%20194.381%206.4622%20195.594%206.48471%20197.088C6.46347%20197.785%206.61596%20198.475%206.92863%20199.099C7.13322%20199.455%207.46265%20199.724%207.85412%20199.855C8.24574%20199.966%208.66401%20199.938%209.03768%20199.778C9.38266%20199.631%209.69034%20199.41%209.93834%20199.13C10.1739%20198.86%2010.3621%20198.553%2010.4948%20198.222C10.7404%20197.599%2010.8931%20196.945%2010.948%20196.279C11.0155%20195.627%2011.028%20194.985%2011.0423%20194.355C11.0567%20193.726%2011.073%20193.095%2011.0881%20192.467C11.0943%20192.164%2011.1009%20191.853%2011.1071%20191.551C11.1335%20189.943%2011.1339%20188.293%2011.1696%20186.678C11.2251%20184.756%2011.2794%20182.878%2011.3345%20180.958C11.3574%20179.56%2011.3819%20178.083%2011.4051%20176.697C11.4416%20175.34%2011.4963%20174.059%2011.5215%20172.718C11.5673%20170.446%2011.65%20168.051%2011.6647%20165.905C11.6791%20163.808%2011.7532%20161.971%2011.7982%20160.005C11.8514%20157.747%2011.905%20155.487%2011.9585%20153.237C11.9818%20152.3%2012.0058%20151.335%2012.0295%20150.392C12.0338%20150.102%2012.0493%20149.113%2012.0532%20148.832C12.0586%20148.176%2012.0687%20148.194%2012.0873%20147.539C12.1261%20145.846%2012.165%20144.135%2012.2038%20142.437C12.2516%20140.209%2012.2997%20137.985%2012.3481%20135.763C12.3504%20135.676%2012.3528%20135.584%2012.3551%20135.504C12.3869%20133.286%2012.409%20131.748%2012.4408%20129.535C12.4696%20127.841%2012.5658%20125.438%2012.5829%20123.764C12.5934%20123.006%2012.605%20122.209%2012.6158%20121.432C12.6376%20119.894%2012.624%20118.768%2012.5848%20118.028C12.534%20117.209%2012.4917%20116.531%2012.4447%20115.778C12.4544%20115.631%2012.422%20115.484%2012.3512%20115.354C12.2662%20115.023%2012.1684%20115.735%2012.0687%20116.534C12.0586%20116.615%2012.0485%20116.765%2012.0381%20116.894C11.9632%20117.854%2011.8995%20119.199%2011.8371%20120.55C11.8052%20121.236%2011.7881%20122.083%2011.768%20122.85C11.7086%20125.46%2011.6485%20128.092%2011.5883%20130.719C11.5751%20131.94%2011.5542%20133.94%2011.541%20135.157C11.5383%20135.331%2011.5355%20135.504%2011.5328%20135.677C11.4711%20137.86%2011.4311%20139.269%2011.3698%20141.449C11.3652%20141.62%2011.3605%20141.796%2011.3559%20141.959C11.3237%20144.011%2011.2759%20146.053%2011.2231%20148.103C11.1591%20150.591%2011.1716%20152.152%2011.1296%20154.638C11.1196%20155.077%2011.1102%20155.5%2011.1001%20155.94C11.0644%20157.245%2010.9744%20159.479%2010.9577%20160.793C10.9352%20162.533%2010.8925%20164.305%2010.8468%20166.035C10.8114%20167.662%2010.7765%20169.269%2010.7408%20170.883C10.723%20172.014%2010.7059%20173.097%2010.6876%20174.23C10.6457%20175.876%2010.603%20177.571%2010.5615%20179.216C10.5522%20180.044%2010.5383%20181.302%2010.5293%20182.095C10.5138%20183.148%2010.4711%20183.839%2010.4455%20184.864C10.43%20185.605%2010.3865%20187.647%2010.3706%20188.391C10.347%20189.44%2010.2957%20190.626%2010.281%20191.676C10.2624%20193.112%2010.2631%20193.03%2010.2441%20194.474C10.2511%20195.323%2010.184%20196.172%2010.0435%20197.01C9.96877%20197.404%209.8418%20197.786%209.66592%20198.147C9.50958%20198.477%209.26177%20198.756%208.95152%20198.952C8.79662%20199.07%208.60889%20199.139%208.41355%20199.148C8.21821%20199.158%208.02462%20199.108%207.85879%20199.005C7.58401%20198.758%207.40541%20198.424%207.35433%20198.059C7.24561%20197.218%207.20344%20196.369%207.22821%20195.521C7.21386%20194.605%207.19949%20193.682%207.18513%20192.772C7.17892%20192.433%207.17232%20192.066%207.16611%20191.728C7.09316%20188.782%207.10054%20187.263%207.06756%20185.03C7.05851%20184.461%207.04945%20183.892%207.04039%20183.324C7.02798%20182.452%207.01596%20181.589%207.0016%20180.706C6.99617%20179.832%206.97869%20178.946%206.9589%20178.093C6.86382%20173.997%206.8491%20170.748%206.79244%20167.077C6.75946%20165.464%206.72724%20163.899%206.69503%20162.32C6.62052%20158.957%206.63023%20155.567%206.57668%20152.15C6.53321%20149.306%206.49016%20146.455%206.4467%20143.615C6.43932%20142.968%206.43155%20142.305%206.42379%20141.65C6.38499%20139.067%206.29807%20137.054%206.28216%20134.511C6.25461%20132.171%206.22588%20129.731%206.20066%20127.628C6.18087%20126.227%206.14596%20126.039%206.15566%20125.155C6.17118%20123.713%206.09122%20121.883%206.06755%20120.222C6.05397%20119.574%206.04001%20118.906%206.02876%20118.287C6.00509%20117.407%205.9756%20116.635%205.93447%20116.053C5.91183%20115.453%205.85325%20114.855%205.75906%20114.262C5.68378%20114.055%205.61393%20114.196%205.55495%20114.829'%20fill='%23121C2D'/%3e%3cpath%20d='M125.481%20168.054C125.452%20167.86%20125.405%20167.67%20125.34%20167.485C125.326%20167.441%20125.312%20167.389%20125.294%20167.346C125.217%20167.154%20125.235%20167.08%20125.129%20166.845C125.052%20166.673%20124.996%20166.48%20124.93%20166.297L124.903%20166.223C124.729%20165.683%20124.52%20165.135%20124.325%20164.588C124.316%20164.563%20124.307%20164.537%20124.298%20164.513C124.107%20163.921%20123.875%20163.319%20123.692%20162.722C123.671%20162.651%20123.64%20162.572%20123.614%20162.497C123.48%20162.12%20123.358%20161.743%20123.246%20161.367C123.22%20161.28%20123.196%20161.2%20123.163%20161.108C123.045%20160.773%20122.935%20160.432%20122.835%20160.092C122.816%20160.028%20122.799%20159.967%20122.776%20159.907C122.685%20159.664%20122.534%20159.278%20122.46%20159.028C122.282%20158.432%20122.171%20157.966%20121.984%20157.371C121.958%20157.284%20121.932%20157.194%20121.907%20157.105L121.865%20156.954C121.669%20156.357%20121.516%20155.747%20121.326%20155.143C121.229%20154.839%20121.146%20154.51%20121.055%20154.192L120.477%20152.161L120.21%20151.2C120.155%20150.998%20120.091%20150.786%20120.05%20150.593C119.817%20149.523%20119.688%20149.241%20119.506%20148.564L118.959%20146.487C118.866%20146.129%20118.744%20145.747%20118.671%20145.408C118.56%20144.883%20118.434%20144.531%20118.322%20144.095C118.125%20143.351%20117.929%20142.608%20117.732%20141.866L117.442%20140.748C117.418%20140.659%20117.393%20140.568%20117.369%20140.478C117.236%20140.007%20117.073%20139.531%20116.946%20139.055C116.805%20138.487%20116.667%20137.93%20116.526%20137.363C116.415%20136.951%20116.269%20136.525%20116.161%20136.116C116.056%20135.716%20115.977%20135.332%20115.864%20134.94C115.673%20134.274%20115.499%20133.564%20115.289%20132.943C115.082%20132.337%20114.956%20131.79%20114.785%20131.215L114.195%20129.236C114.112%20128.962%20114.027%20128.68%20113.943%20128.404C113.919%20128.319%20113.82%20128.034%20113.791%20127.953C113.723%20127.765%20113.733%20127.767%20113.674%20127.575C113.525%20127.08%20113.358%20126.586%20113.194%20126.093L112.534%20124.164C112.526%20124.138%20112.517%20124.112%20112.509%20124.089C112.266%20123.456%20112.097%20123.017%20111.854%20122.386C111.672%20121.902%20111.447%20121.202%20111.25%20120.729L110.976%20120.07C110.85%20119.745%20110.691%20119.433%20110.5%20119.14C110.353%20118.93%20110.219%20118.761%20110.078%20118.571C110.005%20118.472%20109.985%20118.511%20109.941%20118.489C109.825%20118.428%20109.834%20118.659%20109.855%20118.913C109.86%20118.949%20109.867%20118.986%20109.876%20119.022C109.938%20119.312%20110.066%20119.701%20110.184%20120.095C110.246%20120.295%20110.34%20120.534%20110.422%20120.751L111.253%20122.99L111.75%20124.244C111.768%20124.294%20111.789%20124.343%20111.805%20124.392C112.018%20125.02%20112.138%20125.432%20112.34%20126.062C112.355%20126.112%20112.371%20126.163%20112.386%20126.21C112.596%20126.797%20112.783%20127.389%20112.968%20127.983C113.188%20128.707%20113.374%20129.145%20113.606%20129.864L113.723%20130.243C113.834%20130.624%20113.99%20131.286%20114.116%20131.665C114.279%20132.168%20114.428%20132.686%20114.567%20133.194C114.703%20133.669%20114.838%20134.139%20114.972%20134.611L115.266%20135.586C115.395%20136.069%20115.527%20136.568%20115.654%20137.05C115.721%20137.293%20115.845%20137.656%20115.913%20137.887C116.003%20138.196%20116.034%20138.405%20116.113%20138.706L116.393%20139.742C116.475%20140.05%20116.546%20140.406%20116.635%20140.712C116.757%20141.132%20116.761%20141.105%20116.876%20141.529C117.016%20142.043%20117.157%20142.555%20117.297%20143.069C117.488%20143.777%20117.594%20144.173%20117.743%20144.726C117.813%20144.996%20117.884%20145.268%20117.963%20145.535L118.049%20145.841C118.31%20146.701%20118.404%20147.154%20118.582%20147.811L118.721%20148.312C118.792%20148.568%20118.865%20148.82%20118.929%20149.082C118.994%20149.345%20119.069%20149.601%20119.144%20149.849C119.508%20151.044%20119.745%20152.006%20120.055%20153.081C120.19%20153.553%20120.336%20154.008%20120.482%20154.468C120.79%20155.447%20121.033%20156.451%20121.339%20157.448C121.596%20158.276%20121.851%20159.108%20122.124%20159.93C122.183%20160.118%20122.243%20160.312%20122.303%20160.502C122.547%20161.252%20122.793%20161.818%20123.025%20162.558C123.238%20163.24%20123.485%20163.941%20123.702%20164.547C123.846%20164.949%20123.894%20164.993%20123.967%20165.253C124.085%20165.677%20124.326%20166.185%20124.506%20166.659C124.576%20166.844%20124.652%20167.034%20124.727%20167.207C124.814%20167.419%20124.914%20167.625%20125.028%20167.824C125.111%20167.994%20125.223%20168.149%20125.359%20168.282C125.445%20168.317%20125.493%20168.253%20125.482%20168.051'%20fill='%23121C2D'/%3e%3cpath%20d='M82.375%20178.115C82.4238%20177.911%2082.4547%20177.704%2082.4674%20177.495C82.4724%20177.445%2082.479%20177.388%2082.4798%20177.339C82.4833%20177.117%2082.5287%20177.052%2082.5213%20176.776C82.5162%20176.575%2082.5391%20176.361%2082.55%20176.153C82.55%20176.125%2082.5523%20176.094%2082.5535%20176.068C82.6001%20175.463%2082.616%20174.835%2082.6435%20174.215C82.6435%20174.186%2082.6462%20174.156%2082.6474%20174.13C82.6963%20173.465%2082.7079%20172.774%2082.7638%20172.109C82.7673%20172.032%2082.7716%20171.94%2082.7755%20171.855C82.7928%20171.427%2082.8197%20171.004%2082.8562%20170.585C82.8647%20170.488%2082.8717%20170.4%2082.876%20170.295C82.8911%20169.916%2082.9148%20169.533%2082.9489%20169.155C82.9555%20169.084%2082.9621%20169.017%2082.9633%20168.948C82.9679%20168.671%2082.9718%20168.227%2082.9947%20167.95C83.051%20167.287%2083.1189%20166.779%2083.1655%20166.115C83.174%20166.018%2083.1821%20165.918%2083.1907%20165.82C83.1961%20165.764%2083.2019%20165.704%2083.2074%20165.653C83.2493%20164.982%2083.3296%20164.316%2083.3785%20163.64C83.4029%20163.299%2083.4429%20162.939%2083.4782%20162.587L83.7006%20160.34L83.8139%20159.281C83.8391%20159.058%2083.8589%20158.822%2083.8938%20158.614C84.0878%20157.46%2084.0715%20157.129%2084.1654%20156.386C84.2594%20155.626%2084.3575%20154.868%2084.4642%20154.112C84.5205%20153.72%2084.5543%20153.293%2084.6233%20152.929C84.7301%20152.366%2084.7514%20151.965%2084.8251%20151.492C84.9467%20150.68%2085.0683%20149.868%2085.1899%20149.057C85.2559%20148.651%2085.322%20148.245%2085.3882%20147.842L85.4344%20147.548C85.512%20147.031%2085.564%20146.496%2085.6524%20145.978C85.758%20145.362%2085.893%20144.765%2086.0056%20144.151C86.0859%20143.703%2086.1402%20143.226%2086.2264%20142.782C86.311%20142.348%2086.4076%20141.94%2086.4805%20141.51C86.6055%20140.78%2086.7619%20140.012%2086.8418%20139.315C86.9194%20138.634%2087.0393%20138.043%2087.1274%20137.406C87.2252%20136.674%2087.3214%20135.939%2087.3963%20135.205C87.4281%20134.9%2087.4627%20134.585%2087.4891%20134.276C87.4976%20134.181%2087.512%20133.856%2087.5147%20133.764C87.5213%20133.549%2087.5306%20133.555%2087.5492%20133.34C87.588%20132.784%2087.6039%20132.222%2087.6148%20131.662L87.6125%20130.562L87.5737%20129.462C87.5737%20129.434%2087.5737%20129.403%2087.5737%20129.377C87.5442%20129.012%2087.5034%20128.704%2087.4732%20128.396C87.4429%20128.088%2087.4033%20127.779%2087.3474%20127.419C87.3024%20127.143%2087.2815%20126.802%2087.2229%20126.471C87.1643%20126.139%2087.1119%20125.804%2087.0525%20125.534C87.0013%20125.288%2086.9241%20125.035%2086.8612%20124.785C86.7983%20124.536%2086.7316%20124.328%2086.6707%20124.151C86.615%20124.005%2086.5494%20123.864%2086.4743%20123.727C86.3393%20123.485%2086.2163%20123.291%2086.0863%20123.074C86.0192%20122.961%2085.997%20123.002%2085.9543%20122.973C85.841%20122.899%2085.8379%20123.146%2085.8399%20123.415C85.8399%20123.443%2085.848%20123.493%2085.8535%20123.531C85.8923%20123.843%2086.0063%20124.26%2086.068%20124.691C86.1068%20124.909%2086.1705%20125.172%2086.226%20125.411C86.3117%20125.82%2086.3742%20126.236%2086.4538%20126.648C86.5228%20127.063%2086.5678%20127.483%2086.6288%20127.9C86.678%20128.288%2086.7584%20128.925%2086.7999%20129.315C86.803%20129.371%2086.8061%20129.427%2086.8096%20129.482C86.8337%20130.185%2086.8333%20130.638%2086.8158%20131.34C86.8158%20131.395%2086.8135%20131.452%2086.8127%20131.504C86.8232%20131.834%2086.8077%20132.164%2086.796%20132.494C86.7844%20132.824%2086.7723%20133.153%2086.7413%20133.483C86.6835%20134.283%2086.6777%20134.789%2086.6098%20135.59C86.5997%20135.732%2086.5791%20135.867%2086.5609%20136.009C86.5046%20136.428%2086.3812%20137.141%2086.328%20137.564C86.2683%20138.124%2086.1755%20138.692%2086.0812%20139.245C85.9955%20139.767%2085.9109%20140.281%2085.8255%20140.799C85.7685%20141.162%2085.7137%20141.51%2085.6567%20141.873C85.5578%20142.4%2085.4561%20142.943%2085.3568%20143.469C85.3106%20143.735%2085.2621%20144.142%2085.2225%20144.398C85.1693%20144.738%2085.1061%20144.956%2085.0479%20145.285C85.0091%20145.523%2084.8981%20146.181%2084.8585%20146.42C84.8022%20146.757%2084.7161%20147.136%2084.6676%20147.474C84.6043%20147.937%2084.6191%20147.914%2084.5469%20148.379L84.2993%20150.071C84.1887%20150.849%2084.1266%20151.283%2084.0401%20151.891C83.9974%20152.187%2083.954%20152.485%2083.9214%20152.78C83.9078%20152.89%2083.8926%20153.008%2083.8791%20153.118C83.7821%20154.074%2083.6901%20154.561%2083.602%20155.284L83.5349%20155.836C83.5031%20156.119%2083.4739%20156.399%2083.4332%20156.684C83.3925%20156.97%2083.3626%20157.254%2083.3389%20157.532C83.2202%20158.863%2083.0793%20159.913%2082.9644%20161.104C82.9128%20161.628%2082.8814%20162.138%2082.8434%20162.651C82.7658%20163.745%2082.6195%20164.841%2082.5372%20165.953C82.4693%20166.878%2082.3991%20167.803%2082.3467%20168.728C82.3315%20168.938%2082.316%20169.154%2082.3013%20169.366C82.2504%20170.207%2082.2667%20170.866%2082.205%20171.692C82.148%20172.453%2082.1115%20173.246%2082.0828%20173.932C82.063%20174.388%2082.0913%20174.451%2082.0591%20174.738C82.0064%20175.206%2082.0351%20175.804%2082.0184%20176.345C82.0114%20176.556%2082.0087%20176.774%2082.0106%20176.976C82.0089%20177.22%2082.0219%20177.463%2082.0494%20177.705C82.0591%20177.907%2082.1016%20178.105%2082.1752%20178.293C82.2411%20178.363%2082.3098%20178.319%2082.3785%20178.115'%20fill='%23121C2D'/%3e%3cpath%20d='M62.2429%20127.109C62.3655%20127.157%2062.641%20127.236%2062.9492%20127.323L63.1253%20127.378C63.3779%20127.443%2063.4424%20127.501%2063.7501%20127.592C63.9815%20127.665%2064.2072%20127.755%2064.4253%20127.861L64.5141%20127.905C65.1546%20128.213%2065.7388%20128.625%2066.2429%20129.124L66.3108%20129.191C66.8175%20129.751%2067.136%20130.453%2067.2219%20131.201C67.2246%20131.288%2067.234%20131.388%2067.2413%20131.481C67.2565%20131.982%2067.2456%20132.482%2067.2087%20132.982C67.2002%20133.097%2067.1932%20133.203%2067.1889%20133.329C67.1738%20133.78%2067.142%20134.236%2067.0962%20134.686C67.0877%20134.771%2067.0795%20134.851%2067.0753%20134.932C67.0609%20135.263%2067.0364%20135.792%2067%20136.123C66.9088%20136.914%2066.8087%20137.518%2066.7225%20138.311C66.7082%20138.427%2066.6938%20138.546%2066.6794%20138.664L66.6527%20138.863C66.5751%20139.665%2066.4532%20140.463%2066.3837%20141.276C66.3496%20141.685%2066.2906%20142.129%2066.2751%20142.551C66.2285%20143.457%2066.1719%20144.352%2066.1082%20145.252L66.0155%20146.524C65.9953%20146.791%2065.9786%20147.075%2065.9484%20147.326C65.7807%20148.718%2065.804%20149.115%2065.7388%20150.011L65.5557%20152.763C65.5285%20153.239%2065.5266%20153.753%2065.4912%20154.198C65.4431%20154.886%2065.4583%20155.366%2065.4501%20155.947C65.4261%20156.936%2065.454%20157.926%2065.485%20158.917C65.5145%20159.414%2065.5289%20159.906%2065.5654%20160.403C65.5751%20160.522%2065.5852%20160.645%2065.5949%20160.764C65.6383%20161.401%2065.7776%20162.029%2065.8308%20162.653C65.9084%20163.393%2065.9247%20164.124%2065.9751%20164.868C66.0089%20165.412%2066.0764%20165.983%2066.104%20166.526C66.1327%20167.055%2066.1393%20167.556%2066.1816%20168.08C66.251%20168.967%2066.3069%20169.907%2066.4455%20170.742C66.5727%20171.557%2066.6639%20172.277%2066.8083%20173.042C66.9045%20173.478%2066.9918%20173.917%2067.1113%20174.349C67.1692%20174.566%2067.218%20174.784%2067.2871%20174.998L67.4982%20175.702L67.5176%20175.767C67.5186%20175.778%2067.5224%20175.788%2067.5285%20175.798C67.5347%20175.807%2067.5431%20175.815%2067.5529%20175.82L67.6581%20175.904L67.799%20176.017C67.8738%20176.076%2067.9472%20176.137%2068.0244%20176.193L68.4831%20176.536C68.575%20176.607%2068.9099%20176.822%2069.0058%20176.881C69.2301%20177.016%2069.2204%20177.019%2069.4404%20177.163C70.7828%20177.998%2072.2423%20178.633%2073.7714%20179.045L73.8719%20179.073C74.6613%20179.257%2075.4674%20179.36%2076.2778%20179.382C77.0703%20179.418%2077.864%20179.34%2078.634%20179.15C78.9441%20179.062%2079.2488%20178.955%2079.5467%20178.832C79.9825%20178.653%2080.3842%20178.402%2080.7345%20178.088C80.9553%20177.874%2081.158%20177.642%2081.3406%20177.394C81.4376%20177.269%2081.3864%20177.27%2081.4012%20177.214C81.44%20177.068%2081.1753%20177.195%2080.8967%20177.335C80.8676%20177.347%2080.8191%20177.375%2080.7745%20177.4C80.384%20177.636%2079.9756%20177.843%2079.5529%20178.016C79.3177%20178.112%2079.0263%20178.228%2078.7539%20178.307C77.8111%20178.578%2076.8258%20178.672%2075.8482%20178.586C75.2878%20178.552%2074.7308%20178.476%2074.1819%20178.359C74.1167%20178.346%2074.0519%20178.332%2073.9879%20178.314C73.2781%20178.119%2072.5853%20177.866%2071.9161%20177.56L71.7392%20177.478C71.0186%20177.166%2070.3258%20176.794%2069.6682%20176.367C69.2673%20176.109%2068.9449%20175.895%2068.6286%20175.673L68.3907%20175.505L68.2716%20175.416L68.2115%20175.371C68.2053%20175.365%2068.1984%20175.361%2068.1909%20175.357C68.1835%20175.354%2068.182%20175.353%2068.1773%20175.341L68.1342%20175.213C68.1001%20175.109%2068.0652%20175.001%2068.0279%20174.888C67.9759%20174.728%2067.9274%20174.573%2067.8898%20174.408C67.7625%20173.923%2067.6049%20173.079%2067.5064%20172.584C67.3689%20171.925%2067.2653%20171.259%2067.1959%20170.589C67.1234%20169.965%2067.0555%20169.347%2067.0042%20168.723C66.9654%20168.287%2066.9193%20167.868%2066.8878%20167.429C66.8513%20166.789%2066.8137%20166.129%2066.7776%20165.489C66.7563%20165.166%2066.7%20164.68%2066.6725%20164.368C66.6371%20163.959%2066.6391%20163.685%2066.6084%20163.285C66.5871%20162.996%2066.5048%20162.194%2066.468%20161.908C66.4474%20161.704%2066.4257%20161.486%2066.4035%20161.269C66.3919%20161.054%2066.3787%20160.84%2066.3589%20160.64C66.3038%20160.092%2066.2941%20160.124%2066.2642%20159.566C66.22%20158.891%2066.1986%20158.217%2066.1796%20157.539C66.1629%20156.607%2066.1688%20156.085%2066.182%20155.355C66.1924%20155%2066.206%20154.642%2066.208%20154.288C66.2115%20154.157%2066.2153%20154.014%2066.2188%20153.883C66.2367%20152.739%2066.2988%20152.149%2066.3515%20151.284L66.3904%20150.621C66.4117%20150.282%2066.4315%20149.947%2066.4621%20149.604C66.4928%20149.262%2066.5145%20148.921%2066.5316%20148.588C66.6162%20146.993%2066.7435%20145.732%2066.8316%20144.3C66.8704%20143.67%2066.8913%20143.06%2066.9092%20142.447C66.9747%20141.154%2067.1998%20139.843%2067.343%20138.521C67.4672%20137.418%2067.5956%20136.311%2067.6849%20135.201C67.707%20134.949%2067.7299%20134.69%2067.752%20134.434C67.8242%20133.423%2067.8071%20132.631%2067.8296%20131.63C67.8355%20131.138%2067.7523%20130.648%2067.584%20130.185C67.4211%20129.745%2067.1827%20129.337%2066.8793%20128.979C66.755%20128.825%2066.6165%20128.683%2066.4656%20128.555C66.3675%20128.458%2066.2774%20128.396%2066.1439%20128.271C65.6236%20127.847%2065.035%20127.513%2064.4028%20127.284C64.1622%20127.185%2063.916%20127.1%2063.6655%20127.03C63.377%20126.947%2063.0813%20126.891%2062.7823%20126.864C62.5416%20126.828%2062.2965%20126.832%2062.0574%20126.878C61.9666%20126.932%2062.014%20127.007%2062.2452%20127.109'%20fill='%23121C2D'/%3e%3cpath%20d='M61.4544%20139.371C61.4539%20139.405%2061.4653%20139.439%2061.4866%20139.465C61.4901%20139.47%2061.4936%20139.477%2061.4986%20139.477C61.5199%20139.48%2061.5122%20139.526%2061.5421%20139.518C61.5642%20139.512%2061.5789%20139.534%2061.5968%20139.544C61.5991%20139.544%2061.6022%20139.544%2061.6042%20139.547C61.6528%20139.582%2061.709%20139.606%2061.7683%20139.617C61.7709%20139.617%2061.7733%20139.618%2061.7757%20139.62C61.8304%20139.658%2061.9002%20139.656%2061.9553%20139.697C61.9628%20139.7%2061.9711%20139.702%2061.9794%20139.702C62.02%20139.709%2062.0587%20139.724%2062.0927%20139.747C62.1003%20139.753%2062.1092%20139.757%2062.1187%20139.758C62.1556%20139.76%2062.1913%20139.771%2062.2227%20139.791C62.2289%20139.795%2062.2343%20139.799%2062.2417%20139.797C62.2712%20139.791%2062.3193%20139.776%2062.3445%20139.788C62.4024%20139.815%2062.44%20139.861%2062.5029%20139.873C62.5122%20139.875%2062.5212%20139.879%2062.5296%20139.883C62.5347%20139.885%2062.5386%20139.891%2062.544%20139.891C62.61%20139.894%2062.6635%20139.94%2062.7303%20139.944C62.7633%20139.951%2062.7955%20139.962%2062.8261%20139.976L63.0341%20140.036L63.1323%20140.064C63.154%20140.067%2063.1746%20140.075%2063.192%20140.089C63.2809%20140.182%2063.3275%20140.135%2063.3961%20140.157C63.4648%20140.178%2063.5362%20140.2%2063.6041%20140.227C63.6398%20140.24%2063.6852%20140.23%2063.7143%20140.258C63.7594%20140.301%2063.8051%20140.279%2063.8482%20140.297C63.9219%20140.326%2063.9996%20140.34%2064.0745%20140.364C64.1122%20140.375%2064.1494%20140.388%2064.1858%20140.402C64.1946%20140.406%2064.2039%20140.408%2064.2134%20140.41C64.2658%20140.405%2064.3185%20140.405%2064.3709%20140.41C64.428%20140.427%2064.4745%20140.479%2064.5308%20140.499C64.5719%20140.513%2064.6247%20140.496%2064.6643%20140.514C64.7039%20140.533%2064.7345%20140.57%2064.7753%20140.58C64.844%20140.596%2064.9076%20140.646%2064.9805%20140.634C65.0535%20140.622%2065.097%20140.67%2065.1555%20140.689C65.2236%20140.708%2065.2904%20140.732%2065.3554%20140.759C65.3822%20140.772%2065.412%20140.777%2065.4384%20140.792C65.4546%20140.796%2065.4715%20140.798%2065.4881%20140.796C65.5098%20140.793%2065.5067%20140.803%2065.5269%20140.812C65.5761%20140.832%2065.6269%20140.848%2065.6786%20140.86C65.7465%20140.875%2065.8135%20140.893%2065.8793%20140.915C65.8816%20140.915%2065.8839%20140.919%2065.8866%20140.919C65.9502%20140.916%2066.0139%20140.919%2066.0772%20140.925C66.1299%20140.932%2066.1912%20140.994%2066.2463%20140.989C66.2712%20140.988%2066.2961%20140.989%2066.3209%20140.991C66.3467%20140.99%2066.3719%20140.983%2066.3943%20140.97C66.4166%20140.957%2066.4354%20140.939%2066.4489%20140.917C66.4877%20140.865%2066.5265%20140.808%2066.5626%20140.754C66.5794%20140.724%2066.5924%20140.692%2066.6014%20140.658C66.6281%20140.575%2066.6373%20140.488%2066.6286%20140.402C66.6277%20140.393%2066.6259%20140.385%2066.6231%20140.377C66.6076%20140.323%2066.5812%20140.273%2066.5455%20140.23C66.5282%20140.212%2066.506%20140.198%2066.4815%20140.192C66.4066%20140.16%2066.3286%20140.135%2066.2487%20140.119C66.2118%20140.111%2066.1424%20140.134%2066.1043%20140.13C66.0988%20140.13%2066.0932%20140.13%2066.0876%20140.13C66.0236%20140.108%2065.9883%20140.072%2065.9254%20140.046C65.9204%20140.044%2065.9161%20140.039%2065.9107%20140.039C65.8474%20140.032%2065.7857%20140.015%2065.7279%20139.988C65.6565%20139.958%2065.5983%20139.988%2065.5215%20139.98C65.5079%20139.979%2065.4948%20139.975%2065.4827%20139.968C65.4458%20139.95%2065.3899%20139.891%2065.348%20139.891C65.2939%20139.889%2065.2409%20139.875%2065.1928%20139.85C65.1457%20139.833%2065.0978%20139.819%2065.0492%20139.808C65.0162%20139.797%2064.9786%20139.808%2064.9448%20139.798C64.8959%20139.784%2064.8505%20139.751%2064.8017%20139.737C64.7704%20139.737%2064.7392%20139.738%2064.7081%20139.742C64.6751%20139.739%2064.662%20139.707%2064.6305%20139.695C64.6092%20139.687%2064.5475%20139.673%2064.5254%20139.666C64.4947%20139.656%2064.466%20139.621%2064.433%20139.62C64.3876%20139.618%2064.3868%20139.629%2064.3438%20139.62C64.2914%20139.606%2064.2382%20139.598%2064.1847%20139.588C64.1274%20139.577%2064.071%20139.563%2064.0159%20139.545C63.9894%20139.534%2063.9613%20139.528%2063.9328%20139.527C63.9216%20139.527%2063.9115%20139.522%2063.9006%20139.523C63.804%20139.529%2063.7667%20139.489%2063.7%20139.472L63.6484%20139.462C63.6215%20139.459%2063.5953%20139.452%2063.5708%20139.44C63.546%20139.428%2063.5184%20139.423%2063.4908%20139.425C63.3773%20139.413%2063.2659%20139.387%2063.1598%20139.345C63.1103%20139.336%2063.06%20139.332%2063.0096%20139.334C62.9018%20139.331%2062.8176%20139.248%2062.7143%20139.224C62.629%20139.204%2062.5448%20139.177%2062.4582%20139.161C62.4384%20139.157%2062.4194%20139.144%2062.4016%20139.139C62.324%20139.119%2062.2464%20139.157%2062.1773%20139.117C62.1142%20139.084%2062.0472%20139.059%2061.9778%20139.042C61.9359%20139.03%2061.9212%20139.059%2061.9002%20139.03C61.868%20138.984%2061.7978%20139.018%2061.7485%20139.004C61.7287%20138.998%2061.708%20138.997%2061.6876%20138.999C61.6555%20139.002%2061.6252%20139.015%2061.6022%20139.038C61.5605%20139.072%2061.5267%20139.115%2061.5033%20139.164C61.4747%20139.229%2061.4586%20139.299%2061.4559%20139.369'%20fill='%23121C2D'/%3e%3cpath%20d='M40.4799%20123.585C40.45%20123.664%2040.4368%20123.748%2040.4411%20123.833C40.4393%20123.853%2040.4393%20123.873%2040.4411%20123.894C40.4567%20123.978%2040.4182%20124.009%2040.4493%20124.113C40.4676%20124.192%2040.4791%20124.272%2040.4838%20124.352C40.4838%20124.363%2040.4873%20124.375%2040.4889%20124.385C40.511%20124.624%2040.5512%20124.861%2040.6092%20125.094C40.6115%20125.105%2040.6138%20125.116%2040.6161%20125.126C40.6464%20125.384%2040.7357%20125.639%2040.7768%20125.895C40.7834%20125.927%2040.7917%20125.959%2040.8016%20125.991C40.8506%20126.148%2040.8915%20126.307%2040.9243%20126.469C40.9309%20126.506%2040.9401%20126.543%2040.9518%20126.579C41.0023%20126.718%2041.0454%20126.859%2041.081%20127.003C41.0863%20127.029%2041.094%20127.055%2041.1039%20127.08C41.1466%20127.179%2041.2289%20127.333%2041.2591%20127.436C41.3169%20127.668%2041.3874%20127.896%2041.4702%20128.12L41.5091%20128.229C41.516%20128.249%2041.5211%20128.272%2041.5288%20128.291C41.6371%20128.529%2041.7139%20128.779%2041.8288%20129.016C41.8893%20129.135%2041.9382%20129.267%2041.9941%20129.392C42.1136%20129.66%2042.246%20129.921%2042.3767%20130.183L42.5707%20130.55C42.6096%20130.627%2042.6581%20130.706%2042.6895%20130.781C42.8008%20131.051%2042.9458%20131.306%2043.121%20131.54C43.2704%20131.798%2043.4373%20132.046%2043.5921%20132.3C43.6767%20132.429%2043.7884%20132.554%2043.8563%20132.682C43.9538%20132.844%2044.0644%20132.998%2044.187%20133.142C44.3736%20133.404%2044.5793%20133.653%2044.7904%20133.899L45.1128%20134.266L45.1947%20134.352C45.3461%20134.495%2045.5203%20134.621%2045.6767%20134.761C45.8618%20134.928%2046.0302%20135.108%2046.2324%20135.262C46.3806%20135.371%2046.5571%20135.458%2046.7085%20135.557C46.8485%20135.659%2046.9943%20135.754%2047.145%20135.84C47.4001%20135.988%2047.6672%20136.113%2047.9436%20136.215C48.2025%20136.295%2048.4093%20136.408%2048.6421%20136.5L49.4403%20136.804C49.549%20136.848%2049.6642%20136.885%2049.7725%20136.932C49.8063%20136.946%2049.9254%20136.98%2049.9595%20136.989C50.0118%20137.003%2050.0623%20137.023%2050.1101%20137.048C50.3065%20137.128%2050.5102%20137.194%2050.7096%20137.268C50.9712%20137.364%2051.2382%20137.445%2051.4962%20137.548C51.5063%20137.552%2051.5164%20137.557%2051.5261%20137.56C51.7935%20137.637%2051.9789%20137.689%2052.2428%20137.773C52.4446%20137.837%2052.7147%20137.976%2052.918%20138.03L53.1978%20138.114C53.3368%20138.162%2053.4846%20138.18%2053.6312%20138.166C53.7477%20138.148%2053.8458%20138.121%2053.9537%20138.099C54.01%20138.087%2054.01%20138.053%2054.0348%20138.028C54.1019%20137.963%2054.0433%20137.862%2053.9739%20137.759C53.9631%20137.746%2053.9511%20137.734%2053.9382%20137.724C53.8157%20137.625%2053.6839%20137.539%2053.5447%20137.465C53.4589%20137.422%2053.3704%20137.384%2053.2797%20137.352C52.9758%20137.232%2052.6662%20137.121%2052.3553%20137.014C52.2106%20136.964%2051.9626%20136.914%2051.8175%20136.868L51.755%20136.849C51.4993%20136.754%2051.3406%20136.673%2051.0864%20136.574C51.0666%20136.567%2051.0476%20136.556%2051.0271%20136.55C50.7818%20136.473%2050.542%20136.385%2050.303%20136.292C50.0131%20136.179%2049.8144%20136.153%2049.5187%20136.061C49.4663%20136.044%2049.4171%20136.025%2049.3662%20136.005C49.216%20135.943%2048.9692%20135.812%2048.8156%20135.765C48.6121%20135.699%2048.4135%20135.62%2048.2211%20135.527C48.043%20135.442%2047.8633%20135.368%2047.6902%20135.281C47.57%20135.219%2047.4469%20135.175%2047.3286%20135.11C47.1578%20135.013%2046.9968%20134.893%2046.8362%20134.786C46.7562%20134.731%2046.6227%20134.663%2046.5455%20134.609C46.4598%20134.54%2046.379%20134.466%2046.3038%20134.386C46.2378%20134.328%2046.0535%20134.171%2045.991%20134.108C45.901%20134.022%2045.8171%20133.905%2045.7252%20133.82C45.6396%20133.747%2045.5581%20133.67%2045.4811%20133.589C45.3398%20133.435%2045.199%20133.277%2045.0632%20133.114C44.8769%20132.889%2044.7772%20132.758%2044.6429%20132.572C44.5777%20132.481%2044.5133%20132.389%2044.4442%20132.303L44.3666%20132.2C44.1971%20131.985%2044.0436%20131.757%2043.9072%20131.52L43.7927%20131.345C43.7357%20131.255%2043.6763%20131.168%2043.6258%20131.072C43.5754%20130.976%2043.5141%20130.887%2043.4574%20130.799C43.2159%20130.419%2043.0001%20130.023%2042.8113%20129.614C42.7178%20129.44%2042.627%20129.271%2042.5354%20129.099C42.3594%20128.723%2042.2048%20128.337%2042.0725%20127.943C41.9409%20127.62%2041.8311%20127.288%2041.7124%20126.961C41.6899%20126.884%2041.6674%20126.806%2041.6449%20126.729C41.5362%20126.458%2041.4423%20126.18%2041.3635%20125.899C41.3104%20125.616%2041.2312%20125.327%2041.1792%20125.074C41.1458%20124.979%2041.1213%20124.88%2041.1063%20124.78C41.0762%20124.58%2041.033%20124.382%2040.977%20124.187C40.9619%20124.11%2040.9437%20124.029%2040.9262%20123.956C40.9062%20123.864%2040.8731%20123.775%2040.828%20123.693C40.7714%20123.599%2040.7155%20123.506%2040.6584%20123.492C40.6216%20123.483%2040.5826%20123.487%2040.5489%20123.505C40.5152%20123.522%2040.4892%20123.551%2040.4757%20123.587'%20fill='%23121C2D'/%3e%3cpath%20d='M75.9708%20185.72C76.0278%20185.733%2076.0874%20185.73%2076.1428%20185.712C76.1562%20185.71%2076.1693%20185.706%2076.1815%20185.7C76.2277%20185.671%2076.263%20185.7%2076.3147%20185.655C76.3568%20185.626%2076.4031%20185.603%2076.452%20185.588L76.4707%20185.578C76.6127%20185.529%2076.7423%20185.446%2076.8812%20185.383L76.9002%20185.375C77.0554%20185.323%2077.1994%20185.23%2077.355%20185.177C77.3741%20185.169%2077.3926%20185.159%2077.4101%20185.148C77.5016%20185.099%2077.5986%20185.06%2077.6992%20185.033C77.7223%20185.027%2077.7447%20185.019%2077.7659%20185.008C77.8488%20184.965%2077.9354%20184.929%2078.0248%20184.902C78.0412%20184.898%2078.0569%20184.892%2078.0713%20184.883C78.1374%20184.833%2078.2087%20184.791%2078.284%20184.756C78.4415%20184.709%2078.57%20184.696%2078.7213%20184.636C78.7438%20184.627%2078.7675%20184.621%2078.7904%20184.613C78.8035%20184.611%2078.8165%20184.607%2078.8292%20184.603C78.979%20184.531%2079.1427%20184.503%2079.2987%20184.446C79.3763%20184.415%2079.4644%20184.399%2079.5475%20184.374C79.7244%20184.323%2079.8994%20184.264%2080.0795%20184.223L80.3329%20184.16C80.3855%20184.144%2080.4396%20184.133%2080.4943%20184.127C80.6778%20184.113%2080.8588%20184.077%2081.0333%20184.019C81.2176%20183.985%2081.4019%20183.949%2081.5867%20183.921C81.6819%20183.9%2081.7785%20183.887%2081.8758%20183.88C81.9944%20183.875%2082.1123%20183.858%2082.2277%20183.83C82.4272%20183.804%2082.627%20183.785%2082.8272%20183.767L83.128%20183.746C83.1523%20183.746%2083.1765%20183.743%2083.2005%20183.74C83.3277%20183.713%2083.4562%20183.693%2083.5855%20183.681C83.7407%20183.675%2083.8901%20183.704%2084.0422%20183.701C84.1536%20183.696%2084.2708%20183.673%2084.3814%20183.679C84.492%20183.685%2084.5913%20183.713%2084.698%20183.712C84.8789%20183.708%2085.0678%20183.741%2085.2413%20183.726C85.398%20183.721%2085.5548%20183.732%2085.7093%20183.758C85.8883%20183.77%2086.0665%20183.792%2086.2432%20183.822C86.3166%20183.836%2086.393%20183.841%2086.4664%20183.856C86.5076%20183.86%2086.5491%20183.862%2086.5905%20183.86C86.625%20183.86%2086.6593%20183.865%2086.6918%20183.877C86.823%20183.908%2086.9576%20183.923%2087.0903%20183.947C87.2638%20183.98%2087.4396%20183.989%2087.6119%20184.034C87.6183%20184.037%2087.625%20184.039%2087.6317%20184.04C87.8067%20184.059%2087.9285%20184.072%2088.1027%20184.1C88.2358%20184.12%2088.4132%20184.2%2088.5439%20184.22C88.6041%20184.228%2088.6654%20184.242%2088.7267%20184.253C88.8224%20184.276%2088.9228%20184.267%2089.0135%20184.229C89.0911%20184.191%2089.1613%20184.148%2089.2362%20184.108C89.275%20184.087%2089.2778%20184.053%2089.2964%20184.025C89.3464%20183.95%2089.3127%20183.861%2089.2704%20183.771C89.2639%20183.761%2089.2562%20183.751%2089.2475%20183.743C89.1696%20183.668%2089.0814%20183.605%2088.9855%20183.555C88.9281%20183.526%2088.8679%20183.503%2088.8059%20183.487C88.5987%20183.418%2088.3866%20183.365%2088.1714%20183.328C88.0717%20183.308%2087.9017%20183.31%2087.802%20183.295C87.7876%20183.292%2087.7729%20183.292%2087.7593%20183.289C87.5828%20183.247%2087.4702%20183.212%2087.2937%20183.173C87.2797%20183.171%2087.2657%20183.165%2087.2521%20183.164C87.0818%20183.149%2086.9153%20183.115%2086.7477%20183.087C86.567%20183.072%2086.3856%20183.067%2086.2044%20183.072C86.1685%20183.07%2086.1327%20183.066%2086.0973%20183.06C85.9673%20183.023%2085.8337%20183%2085.6988%20182.992C85.5535%20182.995%2085.4082%20182.987%2085.2642%20182.968C85.1306%20182.956%2084.9964%20182.95%2084.8622%20182.952C84.7679%20182.949%2084.6778%20182.968%2084.5843%20182.967C84.4477%20182.967%2084.3069%20182.946%2084.1703%20182.946C84.0903%20182.954%2084.0108%20182.965%2083.932%20182.981C83.855%20182.982%2083.778%20182.977%2083.7015%20182.968L83.4093%20182.981C83.3183%20182.974%2083.2268%20182.974%2083.1357%20182.981C83.06%20182.999%2082.9833%20183.013%2082.906%20183.023L82.4737%20183.075C82.2751%20183.096%2082.166%20183.123%2082.0108%20183.139C81.935%20183.148%2081.8599%20183.161%2081.7857%20183.178L81.7007%20183.195C81.4637%20183.257%2081.3364%20183.258%2081.1552%20183.295L81.017%20183.326C80.947%20183.344%2080.876%20183.358%2080.8044%20183.368C80.7325%20183.377%2080.6617%20183.393%2080.5929%20183.416C80.272%20183.531%2080.0046%20183.57%2079.7112%20183.647C79.5839%20183.688%2079.464%20183.74%2079.343%20183.789C79.0841%20183.891%2078.7997%20183.924%2078.5374%20184.03C78.3189%20184.117%2078.0919%20184.184%2077.8808%20184.287C77.8323%20184.31%2077.7791%20184.326%2077.7295%20184.346C77.5354%20184.432%2077.4008%20184.542%2077.2029%20184.613C77.0221%20184.682%2076.8416%20184.772%2076.6856%20184.848C76.582%20184.899%2076.5816%20184.932%2076.5063%20184.946C76.3853%20184.97%2076.2774%20185.09%2076.1571%20185.156C76.1104%20185.182%2076.0657%20185.212%2076.0232%20185.244C75.9699%20185.281%2075.9251%20185.329%2075.8917%20185.384C75.8505%20185.44%2075.8302%20185.508%2075.8343%20185.577C75.8439%20185.611%2075.8616%20185.642%2075.886%20185.668C75.9104%20185.694%2075.9407%20185.714%2075.9743%20185.725'%20fill='%23121C2D'/%3e%3cpath%20d='M75.0226%20183.72C75.074%20183.729%2075.1271%20183.724%2075.1751%20183.703C75.1863%20183.7%2075.1969%20183.696%2075.2066%20183.689C75.2426%20183.66%2075.2799%20183.686%2075.3172%20183.64C75.35%20183.611%2075.3877%20183.587%2075.4285%20183.57C75.4333%20183.566%2075.4384%20183.563%2075.4437%20183.56C75.5601%20183.506%2075.6625%20183.421%2075.7754%20183.355C75.7802%20183.352%2075.7853%20183.349%2075.7906%20183.346C75.9202%20183.289%2076.0316%20183.192%2076.1604%20183.136C76.1761%20183.127%2076.1909%20183.117%2076.2046%20183.106C76.2777%20183.054%2076.3573%20183.013%2076.4413%20182.982C76.4607%20182.975%2076.4792%20182.966%2076.4964%20182.955C76.5624%20182.909%2076.6332%20182.87%2076.7075%20182.839C76.7215%20182.835%2076.7347%20182.828%2076.7463%20182.819C76.7962%20182.768%2076.8527%20182.724%2076.9144%20182.687C77.0386%20182.649%2077.1605%20182.604%2077.2795%20182.552C77.2977%20182.542%2077.3183%20182.535%2077.3369%20182.527C77.3482%20182.523%2077.3592%20182.519%2077.3699%20182.515C77.4962%20182.451%2077.6257%20182.393%2077.758%20182.342C77.822%20182.309%2077.8965%20182.29%2077.9652%20182.261C78.1119%20182.203%2078.2574%20182.139%2078.4083%20182.091L78.6206%20182.018C78.6643%20182%2078.7099%20181.987%2078.7564%20181.979C78.9134%20181.958%2079.0664%20181.914%2079.2104%20181.849C79.3657%20181.807%2079.5209%20181.763%2079.6761%20181.728C79.7562%20181.704%2079.8382%20181.685%2079.9213%20181.674C80.0229%20181.663%2080.1228%20181.641%2080.2193%20181.608C80.3885%20181.573%2080.5589%20181.545%2080.7293%20181.517C80.815%20181.503%2080.9%20181.491%2080.9857%20181.481C81.0065%20181.479%2081.0271%20181.476%2081.0474%20181.471C81.1547%20181.439%2081.2636%20181.413%2081.3738%20181.394C81.505%20181.38%2081.6365%20181.4%2081.7673%20181.39C81.8629%20181.372%2081.9594%20181.359%2082.0564%20181.351C82.1499%20181.351%2082.2388%20181.373%2082.3299%20181.367C82.4852%20181.352%2082.6489%20181.376%2082.7956%20181.35C82.9296%20181.336%2083.0648%20181.338%2083.1984%20181.356C83.3524%20181.357%2083.5063%20181.368%2083.659%20181.389C83.7223%20181.397%2083.7882%20181.397%2083.853%20181.408C83.8886%20181.41%2083.9243%20181.409%2083.9597%20181.405C84.0047%20181.4%2084.0028%20181.409%2084.047%20181.415C84.1607%20181.439%2084.2772%20181.445%2084.3912%20181.46C84.541%20181.482%2084.6943%20181.479%2084.8418%20181.515C84.8472%20181.517%2084.8528%20181.518%2084.8585%20181.519C85.0098%20181.527%2085.1149%20181.531%2085.2655%20181.548C85.3819%20181.559%2085.534%20181.627%2085.6477%20181.638C85.6997%20181.642%2085.7529%20181.652%2085.8057%20181.659C85.8911%20181.674%2085.9791%20181.659%2086.0544%20181.616C86.1227%20181.574%2086.1829%20181.526%2086.2484%20181.481C86.2826%20181.458%2086.2845%20181.424%2086.3012%20181.395C86.3175%20181.355%2086.324%20181.311%2086.3202%20181.267C86.3163%20181.224%2086.3023%20181.182%2086.2791%20181.145C86.2735%20181.135%2086.2669%20181.127%2086.2593%20181.119C86.1922%20181.05%2086.1147%20180.993%2086.0296%20180.949C85.9793%20180.924%2085.9263%20180.906%2085.8716%20180.894C85.6899%20180.839%2085.5037%20180.799%2085.3152%20180.776C85.2275%20180.763%2085.0796%20180.776%2084.9923%20180.766C84.9799%20180.766%2084.9671%20180.766%2084.9535%20180.763C84.7983%20180.733%2084.7001%20180.704%2084.5449%20180.677C84.5329%20180.677%2084.5201%20180.67%2084.5084%20180.67C84.3606%20180.662%2084.2134%20180.646%2084.0672%20180.622C83.9093%20180.618%2083.7513%20180.624%2083.5942%20180.64C83.5629%20180.641%2083.5317%20180.638%2083.5007%20180.634C83.3865%20180.605%2083.2692%20180.59%2083.1514%20180.59C83.0256%20180.6%2082.899%20180.6%2082.7731%20180.59C82.6567%20180.585%2082.5401%20180.586%2082.4238%20180.595C82.3424%20180.598%2082.2651%20180.621%2082.184%20180.625C82.0657%20180.632%2081.9423%20180.62%2081.8239%20180.628C81.7549%20180.639%2081.6868%20180.655%2081.6198%20180.675C81.5529%20180.68%2081.4857%20180.68%2081.4188%20180.675L81.1662%20180.704C81.0867%20180.701%2081.0071%20180.705%2080.9283%20180.715C80.8647%20180.737%2080.8%20180.755%2080.7343%20180.77L80.3629%20180.843C80.1922%20180.874%2080.0995%20180.904%2079.9664%20180.929C79.9006%20180.94%2079.8358%20180.956%2079.7723%20180.977L79.7001%20180.998C79.4999%20181.071%2079.3897%20181.075%2079.2345%20181.123L79.1181%20181.161C79.0589%20181.182%2078.9984%20181.2%2078.9369%20181.213C78.8753%20181.226%2078.8153%20181.245%2078.758%20181.271C78.5145%20181.373%2078.2658%20181.463%2078.0129%20181.54C77.9062%20181.586%2077.808%20181.642%2077.7075%20181.695C77.4937%20181.808%2077.2477%20181.851%2077.0304%20181.966C76.8496%20182.061%2076.6579%20182.137%2076.4871%20182.248C76.4483%20182.272%2076.4025%20182.289%2076.3614%20182.312C76.2%20182.404%2076.0995%20182.518%2075.9345%20182.595C75.789%20182.672%2075.6474%20182.756%2075.5104%20182.847C75.4258%20182.901%2075.4328%20182.933%2075.3661%20182.949C75.2609%20182.979%2075.1848%20183.1%2075.0886%20183.169C75.0512%20183.196%2075.016%20183.227%2074.9834%20183.26C74.9413%20183.299%2074.9091%20183.347%2074.8895%20183.4C74.8621%20183.458%2074.856%20183.524%2074.8721%20183.586C74.8865%20183.618%2074.9076%20183.646%2074.9339%20183.669C74.9602%20183.692%2074.9911%20183.709%2075.0246%20183.72'%20fill='%23121C2D'/%3e%3cpath%20d='M129.031%20175.969C129.069%20175.961%20129.102%20175.939%20129.125%20175.908C129.13%20175.903%20129.137%20175.896%20129.137%20175.89C129.142%20175.861%20129.186%20175.863%20129.18%20175.824C129.175%20175.795%20129.198%20175.771%20129.208%20175.747C129.209%20175.743%20129.21%20175.739%20129.211%20175.736C129.249%20175.662%20129.275%20175.583%20129.289%20175.502C129.29%20175.499%20129.291%20175.495%20129.292%20175.491C129.335%20175.412%20129.338%20175.318%20129.38%20175.238C129.384%20175.227%20129.386%20175.216%20129.387%20175.205C129.396%20175.149%20129.414%20175.096%20129.44%20175.046C129.447%20175.034%20129.452%20175.022%20129.454%20175.009C129.46%20174.959%20129.474%20174.911%20129.497%20174.866C129.502%20174.858%20129.504%20174.849%20129.505%20174.84C129.497%20174.795%20129.497%20174.748%20129.505%20174.703C129.545%20174.632%20129.579%20174.558%20129.608%20174.482C129.611%20174.469%20129.616%20174.457%20129.621%20174.445C129.625%20174.439%20129.628%20174.433%20129.631%20174.426C129.643%20174.337%20129.695%20174.262%20129.709%20174.173C129.721%20174.129%20129.737%20174.086%20129.757%20174.045L129.853%20173.767L129.903%20173.639C129.911%20173.612%20129.924%20173.586%20129.942%20173.562C130.055%20173.447%20130.017%20173.384%20130.058%20173.299C130.099%20173.213%20130.142%20173.122%20130.189%20173.035C130.203%20172.987%20130.226%20172.941%20130.257%20172.9C130.315%20172.849%20130.311%20172.79%20130.343%20172.738C130.397%20172.647%20130.445%20172.557%20130.503%20172.47C130.53%20172.427%20130.559%20172.384%20130.59%20172.343C130.598%20172.333%20130.604%20172.322%20130.61%20172.311C130.632%20172.247%20130.66%20172.185%20130.693%20172.127C130.741%20172.063%20130.814%20172.022%20130.862%20171.961C130.901%20171.919%20130.918%20171.856%20130.96%20171.817C131.005%20171.786%20131.048%20171.751%20131.088%20171.714C131.143%20171.639%20131.239%20171.598%20131.277%20171.513C131.315%20171.428%20131.392%20171.401%20131.453%20171.351C131.525%20171.294%20131.594%20171.235%20131.672%20171.184C131.704%20171.163%20131.731%20171.136%20131.766%20171.117C131.782%20171.104%20131.798%20171.089%20131.811%20171.072C131.828%20171.051%20131.834%20171.059%20131.858%20171.046C131.917%20171.011%20131.975%20170.972%20132.03%20170.931C132.1%20170.873%20132.176%20170.823%20132.257%20170.782C132.261%20170.781%20132.264%20170.78%20132.267%20170.778C132.335%20170.716%20132.384%20170.672%20132.456%20170.617C132.51%20170.572%20132.62%20170.565%20132.673%20170.518C132.697%20170.496%20132.725%20170.479%20132.751%20170.46C132.775%20170.442%20132.795%20170.419%20132.809%20170.393C132.823%20170.367%20132.831%20170.338%20132.832%20170.308C132.835%20170.242%20132.837%20170.175%20132.839%20170.108C132.836%20170.075%20132.828%20170.043%20132.813%20170.014C132.784%20169.936%20132.731%20169.869%20132.661%20169.823C132.654%20169.818%20132.646%20169.814%20132.637%20169.811C132.573%20169.789%20132.506%20169.78%20132.438%20169.785C132.402%20169.79%20132.368%20169.8%20132.336%20169.817C132.223%20169.86%20132.115%20169.915%20132.016%20169.983C131.968%20170.014%20131.909%20170.093%20131.865%20170.127C131.859%20170.132%20131.853%20170.137%20131.846%20170.142C131.758%20170.19%20131.691%20170.203%20131.603%20170.257C131.596%20170.261%20131.589%20170.264%20131.582%20170.269C131.511%20170.332%20131.433%20170.387%20131.35%20170.435C131.248%20170.492%20131.223%20170.577%20131.142%20170.657C131.127%20170.672%20131.112%20170.685%20131.095%20170.696C131.026%20170.728%20130.961%20170.768%20130.901%20170.815C130.852%20170.88%20130.794%20170.938%20130.729%20170.988C130.67%20171.036%20130.623%20171.095%20130.568%20171.147C130.532%20171.185%20130.514%20171.236%20130.48%20171.276C130.43%20171.334%20130.364%20171.382%20130.316%20171.441C130.291%20171.479%20130.27%20171.519%20130.254%20171.562C130.231%20171.605%20130.191%20171.615%20130.16%20171.652L130.064%20171.784C130.036%20171.823%20129.98%20171.853%20129.962%20171.9C129.949%20171.942%20129.933%20171.982%20129.912%20172.021L129.796%20172.233C129.743%20172.33%20129.721%20172.387%20129.676%20172.461C129.654%20172.497%20129.636%20172.535%20129.622%20172.575C129.618%20172.59%20129.608%20172.603%20129.604%20172.619C129.573%20172.715%20129.531%20172.808%20129.48%20172.896L129.451%20172.968C129.439%20173.005%20129.423%20173.041%20129.403%20173.076C129.383%20173.11%20129.369%20173.147%20129.364%20173.187C129.32%20173.345%20129.265%20173.5%20129.2%20173.651C129.181%20173.72%20129.167%20173.79%20129.158%20173.861C129.132%20174.009%20129.042%20174.136%20129%20174.282C128.966%20174.403%20128.929%20174.523%20128.904%20174.645C128.898%20174.674%20128.884%20174.7%20128.876%20174.728C128.847%20174.837%20128.876%20174.937%20128.831%20175.039C128.793%20175.132%20128.763%20175.228%20128.741%20175.326C128.726%20175.385%20128.753%20175.401%20128.723%20175.433C128.676%20175.486%20128.705%20175.576%20128.688%20175.646C128.681%20175.673%20128.678%20175.702%20128.679%20175.73C128.679%20175.769%20128.69%20175.807%20128.713%20175.839C128.741%20175.886%20128.781%20175.924%20128.829%20175.949C128.892%20175.976%20128.96%20175.985%20129.028%20175.975'%20fill='%23121C2D'/%3e%3cpath%20d='M131.059%20177.15C131.097%20177.142%20131.131%20177.121%20131.155%20177.09C131.16%20177.084%20131.167%20177.078%20131.168%20177.072C131.173%20177.043%20131.218%20177.046%20131.212%20177.007C131.208%20176.978%20131.231%20176.955%20131.242%20176.93C131.243%20176.926%20131.244%20176.923%20131.246%20176.919C131.285%20176.846%20131.314%20176.769%20131.334%20176.688C131.335%20176.685%20131.336%20176.681%20131.338%20176.678C131.384%20176.601%20131.391%20176.506%20131.438%20176.429C131.442%20176.418%20131.445%20176.407%20131.446%20176.396C131.459%20176.341%20131.481%20176.289%20131.511%20176.242C131.518%20176.231%20131.524%20176.219%20131.527%20176.206C131.536%20176.157%20131.554%20176.109%20131.58%20176.066C131.585%20176.058%20131.589%20176.049%20131.59%20176.04C131.585%20175.994%20131.589%20175.948%20131.601%20175.904C131.649%20175.836%20131.69%20175.765%20131.724%20175.69C131.729%20175.678%20131.734%20175.666%20131.741%20175.655C131.745%20175.649%20131.749%20175.642%20131.752%20175.635C131.771%20175.547%20131.83%20175.475%20131.855%20175.389C131.872%20175.345%20131.892%20175.303%20131.915%20175.263C131.956%20175.172%20131.992%20175.08%20132.039%20174.993L132.1%20174.866C132.111%20174.838%20132.126%20174.812%20132.145%20174.789C132.267%20174.677%20132.241%20174.616%20132.288%20174.529C132.336%20174.442%20132.385%20174.351%20132.44%20174.266C132.469%20174.223%20132.478%20174.163%20132.517%20174.13C132.579%20174.078%20132.578%20174.016%20132.613%20173.964L132.785%20173.687C132.814%20173.642%20132.845%20173.597%20132.878%20173.554C132.886%20173.543%20132.892%20173.532%20132.898%20173.52C132.922%20173.453%20132.95%20173.388%20132.982%20173.325C133.03%20173.257%20133.104%20173.209%20133.153%20173.143C133.189%20173.095%20133.204%20173.027%20133.244%20172.984C133.289%20172.946%20133.331%20172.906%20133.37%20172.863C133.436%20172.791%20133.494%20172.712%20133.544%20172.628C133.576%20172.54%20133.651%20172.497%20133.705%20172.432C133.765%20172.357%20133.83%20172.285%20133.899%20172.217C133.928%20172.19%20133.953%20172.156%20133.984%20172.13C133.999%20172.112%20134.011%20172.093%20134.02%20172.072C134.032%20172.047%20134.038%20172.052%20134.059%20172.034C134.112%20171.984%20134.162%20171.931%20134.21%20171.875C134.271%20171.801%20134.335%20171.73%20134.404%20171.663C134.407%20171.662%20134.41%20171.659%20134.412%20171.656C134.458%20171.583%20134.508%20171.513%20134.561%20171.445C134.606%20171.386%20134.707%20171.341%20134.747%20171.28C134.764%20171.251%20134.785%20171.226%20134.807%20171.199C134.826%20171.175%20134.838%20171.147%20134.845%20171.117C134.851%20171.087%20134.85%20171.057%20134.843%20171.027C134.828%20170.962%20134.807%20170.898%20134.79%20170.834C134.777%20170.804%20134.759%20170.777%20134.736%20170.753C134.684%20170.688%20134.612%20170.641%20134.532%20170.618C134.523%20170.616%20134.514%20170.614%20134.505%20170.614C134.437%20170.613%20134.37%20170.624%20134.307%20170.648C134.274%20170.663%20134.244%20170.683%20134.219%20170.708C134.126%20170.783%20134.04%20170.865%20133.962%20170.955C133.923%20170.997%20133.889%20171.087%20133.856%20171.131C133.851%20171.137%20133.847%20171.144%20133.842%20171.15C133.769%20171.218%20133.712%20171.251%20133.639%20171.319C133.633%20171.323%20133.627%20171.329%20133.621%20171.334C133.566%20171.409%20133.504%20171.478%20133.435%20171.541C133.375%20171.621%20133.323%20171.706%20133.28%20171.796C133.269%20171.812%20133.256%20171.827%20133.241%20171.84C133.197%20171.879%20133.102%20171.934%20133.074%20171.988C133.035%20172.057%20132.987%20172.121%20132.93%20172.176C132.882%20172.232%20132.837%20172.29%20132.795%20172.35C132.763%20172.39%20132.75%20172.441%20132.72%20172.482C132.676%20172.543%20132.615%20172.593%20132.572%20172.655C132.552%20172.694%20132.534%20172.735%20132.52%20172.777C132.499%20172.82%20132.46%20172.831%20132.431%20172.868L132.342%20173.001C132.315%20173.039%20132.265%20173.071%20132.244%20173.115C132.232%20173.156%20132.215%20173.196%20132.195%20173.234L132.079%20173.441C132.025%20173.535%20131.998%20173.59%20131.953%20173.662C131.929%20173.696%20131.91%20173.733%20131.895%20173.772C131.89%20173.787%20131.88%20173.801%20131.875%20173.816C131.838%20173.91%20131.791%20173.999%20131.734%20174.083L131.701%20174.153C131.687%20174.19%20131.669%20174.225%20131.646%20174.258C131.624%20174.29%20131.607%20174.327%20131.597%20174.365C131.542%20174.522%20131.473%20174.673%20131.391%20174.817C131.367%20174.885%20131.347%20174.955%20131.332%20175.026C131.293%20175.174%20131.183%20175.293%20131.133%20175.439C131.091%20175.56%20131.036%20175.677%20131.003%20175.801C130.995%20175.829%20130.979%20175.855%20130.969%20175.882C130.954%20175.989%20130.931%20176.095%20130.899%20176.198C130.856%20176.292%20130.82%20176.389%20130.792%20176.488C130.773%20176.549%20130.799%20176.565%20130.768%20176.597C130.717%20176.649%20130.745%20176.744%20130.724%20176.815C130.717%20176.843%20130.713%20176.872%20130.712%20176.902C130.71%20176.941%20130.721%20176.981%20130.743%20177.014C130.769%20177.062%20130.809%20177.101%20130.858%20177.127C130.92%20177.154%20130.989%20177.164%20131.056%20177.155'%20fill='%23121C2D'/%3e%3cpath%20d='M74.8284%20191.014C74.8773%20191.061%2074.9377%20191.096%2075.0038%20191.114C75.0185%20191.121%2075.034%20191.125%2075.05%20191.128C75.1171%20191.134%2075.131%20191.18%2075.216%20191.176C75.2795%20191.18%2075.3423%20191.191%2075.4031%20191.21L75.4287%20191.214C75.612%20191.259%2075.7988%20191.287%2075.9871%20191.299L76.0131%20191.302C76.2125%20191.344%2076.424%20191.349%2076.6246%20191.385C76.6504%20191.388%2076.6763%20191.389%2076.7023%20191.389C76.8316%20191.394%2076.9604%20191.408%2077.088%20191.43C77.117%20191.435%2077.1465%20191.438%2077.1761%20191.439C77.2922%20191.442%2077.4081%20191.45%2077.5234%20191.465C77.5441%20191.469%2077.5652%20191.47%2077.5862%20191.469C77.6875%20191.453%2077.7899%20191.446%2077.8924%20191.448C78.0776%20191.478%2078.2645%20191.497%2078.452%20191.505L78.5424%20191.509C78.5595%20191.509%2078.5773%20191.514%2078.5932%20191.513C78.7981%20191.502%2079.0026%20191.534%2079.2094%20191.524C79.3134%20191.517%2079.424%20191.524%2079.5319%20191.524C79.7612%20191.521%2079.991%20191.524%2080.2203%20191.514L80.5447%20191.501C80.6129%20191.496%2080.6814%20191.496%2080.7496%20191.501C80.9778%20191.525%2081.2083%20191.515%2081.4333%20191.47L82.1318%20191.426C82.2519%20191.407%2082.3729%20191.396%2082.4942%20191.391C82.6422%20191.39%2082.7897%20191.374%2082.9347%20191.345C83.1842%20191.321%2083.4318%20191.283%2083.6801%20191.253L84.0526%20191.203C84.0825%20191.2%2084.1132%20191.195%2084.1423%20191.189C84.2975%20191.157%2084.4554%20191.102%2084.6134%20191.075C84.8012%20191.042%2084.9905%20191.042%2085.1788%20191.011C85.3157%20190.988%2085.4543%20190.934%2085.5897%20190.911C85.7251%20190.888%2085.8524%20190.887%2085.9824%20190.858C86.2063%20190.825%2086.4269%20190.774%2086.6421%20190.704C86.8285%20190.644%2087.0192%20190.599%2087.2125%20190.569C87.4294%20190.512%2087.6456%20190.45%2087.864%20190.402L88.1384%20190.332C88.1878%20190.316%2088.2364%20190.298%2088.2839%20190.277C88.3235%20190.26%2088.3653%20190.249%2088.4081%20190.244C88.5718%20190.204%2088.7321%20190.147%2088.8943%20190.099C89.1089%20190.032%2089.3192%20189.945%2089.5373%20189.868C89.546%20189.865%2089.5545%20189.862%2089.5629%20189.859C89.7697%20189.753%2089.9121%20189.672%2090.1147%20189.551C90.3069%20189.458%2090.4865%20189.341%2090.6494%20189.204C90.7104%20189.143%2090.7752%20189.077%2090.8341%20189.008C90.9289%20188.908%2090.9875%20188.779%2091.0006%20188.641C91.0016%20188.541%2090.9899%20188.44%2090.9657%20188.343C90.9556%20188.293%2090.9207%20188.29%2090.8966%20188.266C90.8314%20188.204%2090.729%20188.236%2090.632%20188.26C90.6207%20188.265%2090.6099%20188.27%2090.5998%20188.277C90.5144%20188.32%2090.4314%20188.392%2090.3359%20188.45C90.2893%20188.481%2090.2432%20188.53%2090.1943%20188.569C90.0208%20188.708%2089.8343%20188.831%2089.6374%20188.935C89.5451%20188.989%2089.3945%20189.097%2089.2928%20189.146C89.2787%20189.154%2089.2642%20189.161%2089.2494%20189.167C89.06%20189.24%2088.9269%20189.262%2088.7286%20189.321C88.7131%20189.326%2088.696%20189.328%2088.682%20189.334C88.4963%20189.403%2088.3072%20189.462%2088.1155%20189.511C87.8827%20189.575%2087.7511%20189.658%2087.5218%20189.731C87.4818%20189.744%2087.4411%20189.755%2087.3999%20189.764C87.2758%20189.79%2087.0577%20189.813%2086.9374%20189.854C86.7762%20189.905%2086.6118%20189.946%2086.4453%20189.977C86.2901%20190.007%2086.1423%20190.054%2085.9886%20190.083C85.8815%20190.104%2085.7833%20190.145%2085.6758%20190.168C85.5206%20190.2%2085.3561%20190.221%2085.1997%20190.249C85.1221%20190.264%2085.0057%20190.308%2084.9312%20190.327C84.8424%20190.34%2084.7528%20190.349%2084.663%20190.353C84.5924%20190.364%2084.3988%20190.404%2084.327%20190.412C84.2265%20190.426%2084.1089%20190.421%2084.01%20190.443C83.8741%20190.474%2083.8835%20190.481%2083.7457%20190.505L83.2443%20190.585C83.0138%20190.619%2082.8842%20190.638%2082.7034%20190.658C82.6147%20190.663%2082.5264%20190.674%2082.4388%20190.688L82.3386%20190.703C82.1255%20190.741%2081.9096%20190.763%2081.6929%20190.767L81.528%20190.782C81.4438%20190.79%2081.3608%20190.8%2081.275%20190.8C81.1903%20190.801%2081.1058%20190.809%2081.0224%20190.824C80.668%20190.86%2080.3119%20190.878%2079.9556%20190.877C79.8004%20190.88%2079.6475%20190.897%2079.4939%20190.91C79.1671%20190.944%2078.8388%20190.877%2078.5075%20190.878C78.2312%20190.878%2077.9553%20190.856%2077.6794%20190.854C77.6165%20190.854%2077.5525%20190.843%2077.4892%20190.841C77.2389%20190.825%2077.0399%20190.863%2076.795%20190.827C76.5695%20190.796%2076.3344%20190.768%2076.1307%20190.75C75.9952%20190.735%2075.9754%20190.763%2075.8909%20190.734C75.733%20190.707%2075.5733%20190.692%2075.4132%20190.691C75.3508%20190.683%2075.2879%20190.678%2075.225%20190.677C75.1492%20190.673%2075.0734%20190.683%2075.0011%20190.706C74.9165%20190.737%2074.8311%20190.768%2074.807%20190.821C74.7908%20190.854%2074.7844%20190.89%2074.7886%20190.926C74.7929%20190.962%2074.8077%20190.996%2074.8311%20191.024'%20fill='%23121C2D'/%3e%3cpath%20d='M119.688%20178.288C119.762%20178.335%20119.846%20178.367%20119.933%20178.382C119.953%20178.388%20119.974%20178.392%20119.995%20178.394C120.085%20178.398%20120.108%20178.443%20120.22%20178.436C120.304%20178.437%20120.389%20178.447%20120.471%20178.463L120.506%20178.467C120.753%20178.503%20121.003%20178.526%20121.253%20178.536L121.287%20178.538C121.554%20178.576%20121.835%20178.573%20122.102%20178.607C122.133%20178.611%20122.17%20178.61%20122.204%20178.611C122.378%20178.615%20122.549%20178.628%20122.718%20178.649C122.756%20178.655%20122.795%20178.658%20122.834%20178.658C122.988%20178.657%20123.142%20178.665%20123.295%20178.68C123.323%20178.684%20123.351%20178.686%20123.379%20178.685C123.513%20178.671%20123.649%20178.665%20123.784%20178.667C124.053%20178.688%20124.258%20178.724%20124.527%20178.727L124.647%20178.733C124.67%20178.733%20124.694%20178.739%20124.715%20178.738C124.986%20178.734%20125.258%20178.766%20125.532%20178.759C125.67%20178.755%20125.817%20178.768%20125.959%20178.772L126.873%20178.783L127.304%20178.787C127.395%20178.784%20127.485%20178.786%20127.576%20178.794C127.877%20178.828%20128.182%20178.83%20128.484%20178.801H129.412C129.572%20178.801%20129.745%20178.776%20129.895%20178.791C130.091%20178.798%20130.287%20178.794%20130.482%20178.779C130.815%20178.776%20131.146%20178.759%20131.478%20178.751L131.976%20178.739L132.097%20178.733C132.308%20178.717%20132.524%20178.677%20132.735%20178.667C132.988%20178.655%20133.237%20178.677%20133.489%20178.667C133.674%20178.661%20133.865%20178.62%20134.048%20178.615C134.231%20178.611%20134.397%20178.626%20134.573%20178.615C134.872%20178.608%20135.17%20178.586%20135.467%20178.549C135.725%20178.518%20135.984%20178.5%20136.243%20178.495L137.134%20178.432L137.511%20178.403C137.58%20178.396%20137.649%20178.386%20137.717%20178.371C137.774%20178.36%20137.832%20178.355%20137.89%20178.356C138.116%20178.338%20138.344%20178.298%20138.571%20178.261C138.87%20178.212%20139.164%20178.138%20139.464%20178.068C139.476%20178.066%20139.488%20178.064%20139.499%20178.061C139.789%20177.964%20139.987%20177.882%20140.272%20177.764C140.528%20177.671%20140.775%20177.555%20141.009%20177.417C141.098%20177.353%20141.195%20177.294%20141.281%20177.224C141.418%20177.128%20141.528%20176.999%20141.6%20176.849C141.641%20176.737%20141.673%20176.623%20141.698%20176.507C141.713%20176.449%20141.678%20176.436%20141.666%20176.403C141.632%20176.316%20141.508%20176.331%20141.385%20176.346C141.37%20176.35%20141.354%20176.355%20141.34%20176.362C141.223%20176.41%20141.078%20176.487%20140.933%20176.559C140.855%20176.591%20140.78%20176.656%20140.697%20176.698C140.424%20176.856%20140.137%20176.992%20139.841%20177.103C139.704%20177.159%20139.479%20177.268%20139.332%20177.313L139.27%20177.333C139.005%20177.4%20138.825%20177.413%20138.553%20177.457L138.489%20177.466C138.233%20177.52%20137.974%20177.559%20137.713%20177.581C137.395%20177.611%20137.199%20177.671%20136.878%20177.712C136.821%20177.719%20136.766%20177.722%20136.708%20177.725C136.538%20177.732%20136.242%20177.718%20136.073%20177.743C135.847%20177.773%20135.619%20177.791%20135.39%20177.797C135.177%20177.805%20134.969%20177.829%20134.759%20177.842C134.611%20177.849%20134.471%20177.877%20134.324%20177.886C134.109%20177.9%20133.887%20177.895%20133.672%20177.909C133.564%20177.915%20133.401%20177.945%20133.298%20177.955C133.161%20177.969%20133.069%20177.948%20132.936%20177.952L132.476%20177.975C132.339%20177.979%20132.182%20177.961%20132.046%20177.975C131.859%20177.992%20131.87%20178.002%20131.682%20178.011L130.998%20178.045C130.683%20178.06%20130.508%20178.07%20130.26%20178.071C130.141%20178.071%20130.02%20178.071%20129.901%20178.083L129.765%20178.09C129.474%20178.113%20129.182%20178.12%20128.89%20178.11L128.667%20178.115C128.553%20178.119%20128.441%20178.125%20128.325%20178.12C128.211%20178.116%20128.097%20178.118%20127.984%20178.126C127.448%20178.165%20127.024%20178.134%20126.544%20178.132C126.333%20178.132%20126.129%20178.146%20125.923%20178.152C125.483%20178.167%20125.042%20178.108%20124.595%20178.097L123.48%20178.066L123.223%20178.051C122.886%20178.04%20122.62%20178.079%20122.289%20178.043C121.984%20178.011%20121.668%20177.996%20121.391%20177.977C121.283%20177.983%20121.175%20177.979%20121.068%20177.966C120.854%20177.942%20120.638%20177.933%20120.423%20177.938C120.339%20177.932%20120.251%20177.93%20120.17%20177.931C120.07%20177.93%20119.97%20177.942%20119.874%20177.968C119.764%20178.003%20119.655%20178.036%20119.628%20178.09C119.611%20178.124%20119.607%20178.164%20119.617%20178.202C119.628%20178.239%20119.652%20178.271%20119.685%20178.292'%20fill='%23121C2D'/%3e%3cpath%20d='M104.244%2056.4443C104.237%2056.4888%20104.246%2056.5345%20104.269%2056.573C104.272%2056.5819%20104.277%2056.5899%20104.284%2056.5966C104.315%2056.6189%20104.292%2056.6609%20104.339%2056.6794C104.373%2056.6929%20104.39%2056.7295%20104.414%2056.7565C104.417%2056.7604%20104.422%2056.7631%20104.424%2056.7669C104.49%2056.8521%20104.568%2056.9264%20104.657%2056.987C104.661%2056.9897%20104.665%2056.9927%20104.669%2056.9959C104.746%2057.0837%20104.853%2057.1392%20104.93%2057.2271C104.941%2057.2371%20104.953%2057.2458%20104.966%2057.2529C105.027%2057.2938%20105.084%2057.3399%20105.136%2057.3909C105.147%2057.4033%20105.16%2057.4138%20105.175%2057.4221C105.233%2057.4531%20105.287%2057.492%20105.335%2057.5378C105.343%2057.5468%20105.352%2057.5541%20105.363%2057.559C105.421%2057.5729%20105.475%2057.5955%20105.526%2057.626C105.603%2057.6992%20105.686%2057.7662%20105.773%2057.8265C105.788%2057.8352%20105.802%2057.8449%20105.815%2057.8554C105.822%2057.8622%20105.83%2057.8684%20105.838%2057.8739C105.944%2057.9224%20106.025%2058.0099%20106.136%2058.0535C106.19%2058.0812%20106.241%2058.1121%20106.291%2058.146C106.405%2058.2088%20106.516%2058.277%20106.633%2058.3321L106.797%2058.4146C106.833%2058.4293%20106.867%2058.449%20106.898%2058.4732C107.048%2058.6239%20107.127%2058.5931%20107.244%2058.6466C107.361%2058.7002%20107.484%2058.7565%20107.602%2058.8162C107.669%2058.8354%20107.733%2058.8612%20107.794%2058.8933C107.867%2058.9347%20107.945%2058.9652%20108.027%2058.9839C108.158%2059.0392%20108.291%2059.0873%20108.427%2059.128C108.495%2059.1512%20108.561%2059.1754%20108.627%2059.2028C108.642%2059.2095%20108.659%2059.2148%20108.675%2059.2186C108.763%2059.2421%20108.863%2059.2298%20108.95%2059.2572C109.053%2059.288%20109.144%2059.352%20109.248%2059.3851C109.323%2059.4109%20109.412%2059.3971%20109.486%2059.4237C109.555%2059.4552%20109.625%2059.4826%20109.697%2059.5058C109.818%2059.5498%20109.945%2059.5758%20110.074%2059.5828C110.185%2059.5882%20110.295%2059.6101%20110.4%2059.648C110.524%2059.6765%20110.652%2059.6865%20110.776%2059.7162C110.828%2059.7281%20110.883%2059.7316%20110.935%2059.7463C110.964%2059.7493%20110.994%2059.7493%20111.023%2059.7463C111.062%2059.7424%20111.059%2059.7524%20111.095%2059.7613C111.19%2059.7802%20111.287%2059.7806%20111.382%2059.7906C111.508%2059.8025%20111.634%2059.8018%20111.76%2059.8176C111.764%2059.8189%20111.769%2059.8197%20111.774%2059.8199C111.9%2059.8045%20111.988%2059.7925%20112.113%2059.786C112.221%2059.802%20112.33%2059.8086%20112.439%2059.8056C112.482%2059.796%20112.527%2059.7921%20112.571%2059.7856C112.608%2059.7815%20112.644%2059.7697%20112.676%2059.751C112.708%2059.7322%20112.736%2059.707%20112.758%2059.6769C112.802%2059.6148%20112.836%2059.5501%20112.874%2059.4869C112.887%2059.4544%20112.893%2059.4196%20112.892%2059.3847C112.895%2059.2942%20112.868%2059.2051%20112.814%2059.1319C112.808%2059.1236%20112.802%2059.1161%20112.794%2059.1095C112.735%2059.0594%20112.668%2059.0202%20112.595%2058.9939C112.556%2058.9815%20112.515%2058.9759%20112.474%2058.9773C112.337%2058.9712%20112.199%2058.9642%20112.061%2058.9642C111.997%2058.9642%20111.891%2059.0028%20111.826%2059.0055C111.817%2059.0069%20111.808%2059.0076%20111.798%2059.0078C111.682%2058.9997%20111.611%2058.965%20111.497%2058.9484C111.489%2058.9459%20111.48%2058.9442%20111.471%2058.9434C111.363%2058.9456%20111.255%2058.9364%20111.15%2058.9161C111.034%2058.906%20110.918%2058.9068%20110.803%2058.9184C110.78%2058.9174%20110.757%2058.914%20110.735%2058.9083C110.654%2058.8768%20110.572%2058.851%20110.488%2058.8313C110.396%2058.8271%20110.304%2058.8113%20110.216%2058.7842C110.133%2058.7615%20110.049%2058.7557%20109.967%2058.7326C109.909%2058.7176%20109.85%2058.7245%20109.791%2058.711C109.707%2058.6913%20109.625%2058.652%20109.54%2058.6339C109.498%2058.6239%20109.429%2058.6278%20109.385%2058.622C109.33%2058.6135%20109.302%2058.5769%20109.251%2058.5591L109.073%2058.5098C109.02%2058.4936%20108.968%2058.4524%20108.913%2058.4408C108.864%2058.4369%20108.815%2058.4286%20108.767%2058.4162L108.501%2058.3391C108.406%2058.3121%20108.313%2058.2791%20108.222%2058.24C108.178%2058.2195%20108.132%2058.2036%20108.085%2058.1926C108.067%2058.1891%20108.05%2058.1803%20108.032%2058.1776C107.916%2058.1517%20107.806%2058.1075%20107.704%2058.0465L107.62%2058.0138C107.576%2057.9997%20107.534%2057.9813%20107.493%2057.959C107.453%2057.9361%20107.41%2057.9191%20107.365%2057.9085C107.183%2057.8411%20107.007%2057.7576%20106.839%2057.6592C106.764%2057.6224%20106.686%2057.5902%20106.606%2057.5628C106.447%2057.4802%20106.296%2057.3817%20106.156%2057.2687C106.027%2057.1917%20105.898%2057.1146%20105.772%2057.0321C105.742%2057.014%20105.718%2056.9882%20105.689%2056.9685C105.578%2056.8914%20105.452%2056.8806%20105.357%2056.7827C105.27%2056.6975%20105.177%2056.6186%20105.079%2056.5468C105.02%2056.5017%20104.992%2056.5199%20104.968%2056.4744C104.933%2056.3973%20104.825%2056.3753%20104.758%2056.3179C104.732%2056.2955%20104.703%2056.2762%20104.672%2056.2605C104.632%2056.2376%20104.586%2056.2266%20104.54%2056.2289C104.478%2056.2274%20104.417%2056.2436%20104.365%2056.2755C104.306%2056.3187%20104.263%2056.38%20104.244%2056.4497'%20fill='%23121C2D'/%3e%3cpath%20d='M75.3874%2027.4503C75.3897%2027.493%2075.4078%2027.5333%2075.4382%2027.5636C75.4433%2027.569%2075.4487%2027.5767%2075.4545%2027.5763C75.4794%2027.574%2075.4825%2027.6364%2075.5155%2027.6172C75.5395%2027.6029%2075.5628%2027.6268%2075.5873%2027.6341C75.5904%2027.6341%2075.595%2027.6341%2075.5985%2027.6341C75.6837%2027.6572%2075.7736%2027.6572%2075.8589%2027.6341C75.8626%2027.6326%2075.8665%2027.6317%2075.8705%2027.6314C75.9658%2027.6189%2076.0584%2027.5908%2076.1445%2027.5482C76.1557%2027.5434%2076.1657%2027.5363%2076.174%2027.5274C76.2252%2027.4935%2076.2714%2027.4588%2076.3234%2027.4252C76.3363%2027.4191%2076.3473%2027.4098%2076.3556%2027.3983C76.3863%2027.3529%2076.4206%2027.31%2076.458%2027.2699C76.4664%2027.2641%2076.4723%2027.2554%2076.4747%2027.2456C76.4755%2027.1946%2076.4817%2027.1438%2076.4933%2027.0942C76.5514%2027.0279%2076.5921%2026.9485%2076.6121%2026.8629C76.6142%2026.8488%2076.6177%2026.835%2076.6226%2026.8217C76.6249%2026.8139%2076.6315%2026.8066%2076.6311%2026.7989C76.6191%2026.7137%2076.6621%2026.6447%2076.6431%2026.5677C76.6384%2026.5307%2076.6384%2026.4933%2076.6431%2026.4563C76.6404%2026.3769%2076.628%2026.3021%2076.6183%2026.2281L76.6%2026.1252C76.5969%2026.1036%2076.5865%2026.082%2076.5977%2026.0589C76.6571%2025.9302%2076.5752%2025.9144%2076.5589%2025.8458C76.5426%2025.7772%2076.5201%2025.7035%2076.5058%2025.6303C76.4988%2025.5918%2076.4545%2025.5632%2076.467%2025.5201C76.4805%2025.448%2076.4305%2025.443%2076.4231%2025.4068C76.4095%2025.347%2076.3812%2025.2931%2076.3637%2025.2352C76.3545%2025.2062%2076.3486%2025.1762%2076.3463%2025.1458C76.3457%2025.1384%2076.3433%2025.1313%2076.3393%2025.125C76.3179%2025.0915%2076.2617%2025.066%2076.2539%2025.0279C76.2434%2024.9824%2076.2799%2024.9261%2076.2753%2024.8803C76.2718%2024.8467%2076.2221%2024.8217%2076.226%2024.7866C76.2299%2024.7515%2076.2597%2024.7153%2076.2508%2024.6845C76.238%2024.6317%2076.2698%2024.5688%2076.2217%2024.5249C76.1736%2024.481%2076.2147%2024.4309%2076.2139%2024.3842C76.209%2024.3303%2076.2113%2024.276%2076.2209%2024.2227C76.2225%2024.1998%2076.2257%2024.177%2076.2306%2024.1545C76.2333%2024.1476%2076.2209%2024.1252%2076.2163%2024.1187C76.2046%2024.1036%2076.2186%2024.1036%2076.224%2024.0878C76.2313%2024.0482%2076.2339%2024.0078%2076.2318%2023.9676C76.2268%2023.9154%2076.2286%2023.8628%2076.2372%2023.8111C76.2372%2023.8111%2076.2403%2023.8072%2076.2396%2023.8053C76.2169%2023.7601%2076.2009%2023.712%2076.1918%2023.6623C76.1845%2023.6211%2076.2496%2023.5698%2076.2306%2023.5286C76.2234%2023.51%2076.2181%2023.4908%2076.2147%2023.4712C76.2042%2023.4326%2076.1588%2023.401%2076.0886%2023.3729L75.8488%2023.2811C75.805%2023.2674%2075.7603%2023.257%2075.7149%2023.2499C75.6021%2023.2271%2075.4865%2023.2211%2075.3719%2023.2322C75.361%2023.2334%2075.3502%2023.2354%2075.3397%2023.2384C75.2751%2023.2544%2075.2146%2023.2835%2075.162%2023.3239C75.136%2023.3416%2075.1352%2023.3671%2075.1274%2023.3894C75.1012%2023.4653%2075.0881%2023.5451%2075.0886%2023.6253C75.0886%2023.6639%2075.1379%2023.7251%2075.1449%2023.7614C75.1449%2023.7664%2075.1491%2023.7718%2075.1484%2023.7768C75.1383%2023.8419%2075.1049%2023.8836%2075.0921%2023.9495C75.0921%2023.9545%2075.0867%2023.9599%2075.0882%2023.9645C75.1005%2024.0258%2075.1005%2024.089%2075.0882%2024.1503C75.0758%2024.2274%2075.1414%2024.2698%2075.1604%2024.343C75.1633%2024.3557%2075.1633%2024.3688%2075.1604%2024.3815C75.1534%2024.4201%2075.1041%2024.4941%2075.1216%2024.5318C75.1442%2024.5807%2075.1518%2024.6352%2075.1433%2024.6883C75.1461%2024.7371%2075.153%2024.7856%2075.1639%2024.8332C75.1662%2024.8675%2075.1996%2024.8945%2075.2062%2024.9281C75.2159%2024.9762%2075.1977%2025.0325%2075.2108%2025.0822C75.2171%2025.1065%2075.2566%2025.1362%2075.2691%2025.1593C75.2854%2025.1878%2075.2539%2025.2171%2075.2574%2025.2483C75.2601%2025.2707%2075.2819%2025.3289%2075.2865%2025.3509C75.292%2025.3821%2075.271%2025.428%2075.2896%2025.4538C75.3156%2025.4923%2075.3284%2025.4846%2075.3439%2025.5255C75.3626%2025.5752%2075.3886%2025.6218%2075.4111%2025.6696C75.4375%2025.72%2075.4601%2025.7723%2075.4786%2025.8261C75.4883%2025.8554%2075.4926%2025.8743%2075.51%2025.8874C75.5166%2025.8924%2075.5166%2025.9009%2075.524%2025.9055C75.588%2025.9487%2075.5628%2025.9965%2075.581%2026.0412L75.5962%2026.0762C75.6075%2026.0927%2075.6135%2026.1122%2075.6136%2026.1321C75.613%2026.1423%2075.6147%2026.1525%2075.6187%2026.1619C75.6227%2026.1714%2075.6288%2026.1798%2075.6365%2026.1865C75.7087%2026.2636%2075.6831%2026.3441%2075.6994%2026.4177C75.712%2026.4513%2075.7292%2026.4829%2075.7506%2026.5118C75.7933%2026.5758%2075.7118%2026.654%2075.718%2026.681C75.7242%2026.708%2075.7145%2026.7195%2075.718%2026.7434C75.718%2026.7488%2075.7079%2026.7473%2075.7068%2026.7515C75.7033%2026.765%2075.7456%2026.8409%2075.7091%2026.8348C75.6875%2026.8299%2075.6649%2026.8325%2075.6451%2026.8421C75.635%2026.8471%2075.6416%2026.8876%2075.6272%2026.8602C75.6059%2026.8136%2075.6063%2026.8899%2075.5764%2026.8887C75.5636%2026.889%2075.5514%2026.8941%2075.5422%2026.903C75.5193%2026.925%2075.502%2026.9523%2075.4918%2026.9824C75.4623%2027.0445%2075.4379%2027.109%2075.4188%2027.1751C75.3937%2027.2655%2075.3823%2027.3592%2075.3851%2027.453'%20fill='%23121C2D'/%3e%3cpath%20d='M67.6773%2024.7554C67.7084%2024.7805%2067.7451%2024.7978%2067.7844%2024.8059C67.7898%2024.8059%2067.798%2024.8097%2067.8003%2024.8059C67.81%2024.7916%2067.8538%2024.8359%2067.8546%2024.8059C67.8546%2024.7839%2067.8814%2024.7908%2067.8965%2024.7855C67.8965%2024.7855%2067.8992%2024.7824%2067.902%2024.7824C67.9578%2024.7824%2067.9834%2024.7438%2068.023%2024.7203C68.023%2024.7203%2068.0258%2024.7172%2068.0277%2024.7168C68.084%2024.7138%2068.1076%2024.6602%2068.1623%2024.6563C68.1689%2024.6563%2068.1717%2024.6486%2068.1763%2024.644C68.1868%2024.632%2068.1999%2024.6226%2068.2147%2024.6165C68.2294%2024.6103%2068.2453%2024.6076%2068.2613%2024.6085C68.2649%2024.609%2068.2686%2024.6087%2068.272%2024.6075C68.2755%2024.6063%2068.2786%2024.6042%2068.2811%2024.6016C68.2895%2024.5903%2068.3003%2024.5809%2068.3128%2024.5743C68.3253%2024.5676%2068.3391%2024.5638%2068.3533%2024.5631C68.3591%2024.5631%2068.3649%2024.5631%2068.3668%2024.5565C68.3746%2024.5303%2068.3851%2024.4794%2068.4057%2024.4756C68.4557%2024.4663%2068.5077%2024.491%2068.5477%2024.4636C68.554%2024.4603%2068.5608%2024.458%2068.5679%2024.4571C68.5721%2024.4571%2068.5783%2024.4594%2068.581%2024.4571C68.616%2024.4185%2068.6742%2024.432%2068.7141%2024.3993C68.7335%2024.3815%2068.7634%2024.3858%2068.7871%2024.3777C68.8387%2024.3611%2068.8876%2024.3368%2068.9423%2024.3241C68.9668%2024.3172%2068.9912%2024.3091%2069.0164%2024.3037C69.0323%2024.3002%2069.0471%2024.289%2069.0661%2024.3002C69.167%2024.3607%2069.172%2024.2829%2069.226%2024.2752C69.2803%2024.266%2069.3351%2024.2601%2069.3901%2024.2574C69.4196%2024.2574%2069.4464%2024.2266%2069.4759%2024.2486C69.5209%2024.2825%2069.5442%2024.2351%2069.5795%2024.2378C69.6392%2024.2378%2069.6959%2024.2304%2069.7564%2024.2316C69.7861%2024.2318%2069.8157%2024.2346%2069.8449%2024.2401C69.8518%2024.242%2069.859%2024.242%2069.8659%2024.2401C69.9047%2024.227%2069.9435%2024.1865%2069.9823%2024.1892C70.0281%2024.1938%2070.0696%2024.2455%2070.1131%2024.2528C70.1453%2024.257%2070.1829%2024.222%2070.214%2024.2362C70.245%2024.2505%2070.2698%2024.2906%2070.3001%2024.2921C70.3533%2024.2944%2070.4006%2024.3434%2070.4553%2024.3148C70.51%2024.2863%2070.5426%2024.3399%2070.5849%2024.3534C70.6358%2024.3653%2070.6841%2024.386%2070.7277%2024.4147C70.746%2024.4278%2070.7665%2024.4297%2070.7848%2024.4463C70.7902%2024.4517%2070.8143%2024.4463%2070.8236%2024.4463C70.841%2024.4401%2070.8368%2024.4528%2070.8488%2024.4625C70.8801%2024.4846%2070.9145%2024.502%2070.9508%2024.5141C70.9943%2024.5384%2071.049%2024.5361%2071.0867%2024.5723C71.0867%2024.5723%2071.0867%2024.5769%2071.0905%2024.5769C71.1384%2024.5748%2071.1863%2024.5781%2071.2333%2024.587C71.2721%2024.5954%2071.2923%2024.671%2071.3338%2024.6706C71.3524%2024.6717%2071.3709%2024.6745%2071.3889%2024.6791C71.4254%2024.6845%2071.4735%2024.6556%2071.5287%2024.602L71.7134%2024.4232C71.7448%2024.3898%2071.7736%2024.3541%2071.7995%2024.3164C71.8688%2024.2253%2071.9235%2024.1242%2071.9617%2024.0165C71.9651%2024.0065%2071.9676%2023.9962%2071.9691%2023.9857C71.9812%2023.9205%2071.9789%2023.8534%2071.9621%2023.7891C71.9559%2023.7583%2071.9326%2023.7456%2071.9144%2023.7282C71.8537%2023.6708%2071.7822%2023.6257%2071.704%2023.5956C71.668%2023.5802%2071.5876%2023.5995%2071.5523%2023.5899C71.5467%2023.5896%2071.5412%2023.5884%2071.536%2023.5864C71.4778%2023.5509%2071.4491%2023.507%2071.3909%2023.4708C71.3858%2023.4677%2071.3824%2023.4619%2071.3773%2023.4607C71.3135%2023.4485%2071.2525%2023.4245%2071.1976%2023.3898C71.1274%2023.3532%2071.0622%2023.3968%2070.9854%2023.3898C70.9715%2023.3885%2070.9582%2023.3839%2070.9466%2023.3763C70.9109%2023.3532%2070.8569%2023.2831%2070.8127%2023.2896C70.7573%2023.294%2070.7018%2023.2824%2070.6528%2023.2565C70.6049%2023.2404%2070.5551%2023.2307%2070.5046%2023.2276C70.4701%2023.2202%2070.4332%2023.2426%2070.3987%2023.238C70.3486%2023.231%2070.2989%2023.1975%2070.2481%2023.1917C70.2225%2023.1894%2070.1806%2023.2195%2070.1565%2023.2249C70.1235%2023.2322%2070.1045%2023.194%2070.0731%2023.1863C70.0502%2023.1821%2069.9865%2023.184%2069.9633%2023.1813C69.9311%2023.1775%2069.8946%2023.1428%2069.8616%2023.1536C69.8166%2023.1678%2069.8197%2023.1829%2069.7751%2023.1859C69.7211%2023.1898%2069.6676%2023.1994%2069.6136%2023.2068C69.5568%2023.2172%2069.4994%2023.2245%2069.4417%2023.2287C69.4131%2023.2274%2069.3847%2023.233%2069.3587%2023.2449C69.3486%2023.2503%2069.3374%2023.2488%2069.3277%2023.2549C69.2434%2023.3062%2069.1934%2023.2808%2069.1263%2023.2954L69.0754%2023.3104C69.0511%2023.3216%2069.0246%2023.3272%2068.9978%2023.327C68.9697%2023.3249%2068.9418%2023.3337%2068.9202%2023.3517C68.8119%2023.4342%2068.7068%2023.4199%2068.602%2023.4607C68.5571%2023.4845%2068.5158%2023.5145%2068.4794%2023.5498C68.3971%2023.6165%2068.2745%2023.5849%2068.1829%2023.6388C68.104%2023.6755%2068.0285%2023.7188%2067.9571%2023.7683C67.9419%2023.7803%2067.9183%2023.7818%2067.9024%2023.7926C67.8352%2023.8354%2067.822%2023.9298%2067.7471%2023.9506C67.6812%2023.9738%2067.6198%2024.0084%2067.5659%2024.0528C67.5314%2024.0774%2067.5523%2024.1148%2067.5128%2024.1071C67.4503%2024.0963%2067.4518%2024.1896%2067.4146%2024.2227C67.3994%2024.2365%2067.388%2024.2538%2067.3816%2024.2732C67.3701%2024.3079%2067.3717%2024.3456%2067.3862%2024.3792C67.4069%2024.4448%2067.4389%2024.5062%2067.4809%2024.5607C67.5399%2024.6343%2067.607%2024.7011%2067.6808%2024.76'%20fill='%23121C2D'/%3e%3cpath%20d='M77.2657%2024.106C77.2864%2024.1362%2077.3109%2024.1637%2077.3387%2024.1877C77.3426%2024.1908%2077.348%2024.1961%2077.3488%2024.1942C77.353%2024.1865%2077.3856%2024.2389%2077.3829%2024.215C77.3829%2024.1973%2077.3981%2024.2127%2077.4066%2024.215C77.4066%2024.215%2077.4066%2024.215%2077.4097%2024.215C77.4446%2024.2362%2077.457%2024.215%2077.4768%2024.2077H77.4795C77.5125%2024.2239%2077.5183%2024.1857%2077.5517%2024.2012C77.5556%2024.2012%2077.5564%2024.1977%2077.5583%2024.1954C77.568%2024.1819%2077.5831%2024.1803%2077.6025%2024.19C77.6072%2024.1923%2077.6111%2024.1938%2077.613%2024.19C77.6141%2024.1865%2077.616%2024.1833%2077.6186%2024.1807C77.6211%2024.1781%2077.6242%2024.176%2077.6276%2024.1747C77.631%2024.1734%2077.6347%2024.1729%2077.6384%2024.1732C77.642%2024.1735%2077.6456%2024.1746%2077.6487%2024.1765C77.6522%2024.1765%2077.6553%2024.1803%2077.6557%2024.1765C77.6557%2024.1553%2077.6557%2024.1141%2077.6677%2024.1152C77.6937%2024.1191%2077.7252%2024.1537%2077.743%2024.1387C77.7453%2024.1364%2077.7496%2024.1387%2077.7531%2024.1387C77.7566%2024.1387%2077.7589%2024.1433%2077.7601%2024.141C77.7745%2024.1133%2077.8074%2024.141%2077.8233%2024.1171C77.8311%2024.1044%2077.847%2024.1144%2077.8583%2024.111L77.9301%2024.0882C77.9414%2024.0845%2077.9529%2024.0816%2077.9646%2024.0794C77.972%2024.0794%2077.9782%2024.0697%2077.9887%2024.0832C78.0457%2024.158%2078.0387%2024.0809%2078.0639%2024.0782C78.0897%2024.0746%2078.1158%2024.0746%2078.1415%2024.0782C78.1551%2024.0809%2078.1644%2024.0505%2078.1804%2024.0732C78.2048%2024.1087%2078.2114%2024.0628%2078.2281%2024.067C78.2553%2024.0681%2078.2826%2024.0666%2078.3096%2024.0624C78.3236%2024.0623%2078.3376%2024.0648%2078.3507%2024.0697C78.3521%2024.0707%2078.3538%2024.0711%2078.3556%2024.0711C78.3573%2024.0711%2078.359%2024.0707%2078.3604%2024.0697C78.3771%2024.0578%2078.3922%2024.0123%2078.4101%2024.0135C78.4279%2024.0146%2078.4535%2024.0639%2078.4741%2024.069C78.4888%2024.072%2078.5044%2024.0304%2078.5191%2024.0424C78.5339%2024.0543%2078.5471%2024.0894%2078.561%2024.0878C78.5855%2024.0844%2078.6084%2024.1264%2078.6328%2024.0878C78.6573%2024.0493%2078.6743%2024.0971%2078.6941%2024.1029C78.7191%2024.1061%2078.7426%2024.1162%2078.762%2024.1322C78.7706%2024.1406%2078.7811%2024.1376%2078.7896%2024.1495C78.7919%2024.1534%2078.8036%2024.1437%2078.807%2024.1391C78.8156%2024.1287%2078.8133%2024.1426%2078.8191%2024.1491C78.8342%2024.1672%2078.8524%2024.1618%2078.8691%2024.1688C78.8858%2024.1757%2078.9165%2024.163%2078.9355%2024.1838L78.9378%2024.1865C78.9592%2024.1697%2078.9834%2024.1566%2079.0092%2024.148C79.029%2024.1426%2079.0387%2024.2062%2079.0608%2024.1865C79.0697%2024.1804%2079.0796%2024.1757%2079.0899%2024.1726C79.124%2024.1385%2079.1491%2024.0967%2079.1633%2024.0508L79.2615%2023.8196C79.2789%2023.781%2079.2921%2023.7344%2079.3072%2023.6912C79.3443%2023.5838%2079.3728%2023.4736%2079.3926%2023.3617C79.3926%2023.3509%2079.3953%2023.3409%2079.3965%2023.3309C79.4025%2023.2734%2079.4%2023.2154%2079.3891%2023.1586C79.3848%2023.1339%2079.3717%2023.1312%2079.3616%2023.1227C79.3284%2023.096%2079.2878%2023.0799%2079.2451%2023.0765C79.2254%2023.0742%2079.1835%2023.1177%2079.1637%2023.1212C79.1609%2023.1212%2079.1574%2023.1243%2079.1547%2023.1235C79.1229%2023.1092%2079.1074%2023.0734%2079.0771%2023.0545C79.0748%2023.0545%2079.0729%2023.0484%2079.0701%2023.0491C79.0537%2023.0525%2079.0368%2023.0525%2079.0203%2023.0493C79.0038%2023.046%2078.9882%2023.0396%2078.9743%2023.0302C78.9355%2023.0106%2078.9048%2023.0688%2078.8652%2023.0776C78.8618%2023.0783%2078.8583%2023.0782%2078.8549%2023.0774C78.8515%2023.0766%2078.8482%2023.0751%2078.8455%2023.073C78.8268%2023.0595%2078.7966%2023.0006%2078.7745%2023.014C78.7616%2023.021%2078.747%2023.0243%2078.7324%2023.0234C78.7178%2023.0225%2078.7037%2023.0175%2078.6918%2023.009C78.667%2022.9959%2078.641%2023.0063%2078.6142%2023.0021C78.5963%2022.999%2078.5785%2023.0256%2078.561%2023.0248C78.5354%2023.0248%2078.509%2022.9959%2078.4834%2022.9967C78.4702%2022.9967%2078.4512%2023.0291%2078.4388%2023.0352C78.4264%2023.0414%2078.4109%2023.0079%2078.3946%2023.0036C78.3783%2022.9994%2078.3511%2023.0071%2078.3391%2023.006C78.327%2023.0048%2078.3003%2022.9709%2078.2855%2022.9824C78.2708%2022.994%2078.2661%2023.0125%2078.2436%2023.0164C78.2164%2023.0223%2078.1896%2023.0299%2078.1633%2023.0391C78.1355%2023.0495%2078.1063%2023.0555%2078.0767%2023.0568C78.0693%2023.0558%2078.0617%2023.0565%2078.0545%2023.0587C78.0473%2023.061%2078.0407%2023.0648%2078.0352%2023.0699C78.031%2023.0749%2078.0247%2023.0726%2078.0201%2023.0784C77.9813%2023.127%2077.953%2023.0954%2077.9192%2023.105C77.9107%2023.1078%2077.9024%2023.1111%2077.8944%2023.115C77.8816%2023.1208%2077.8699%2023.1301%2077.8556%2023.1243C77.8412%2023.1185%2077.8284%2023.1281%2077.8167%2023.1416C77.7671%2023.2068%2077.71%2023.1802%2077.6573%2023.2029C77.6337%2023.219%2077.6139%2023.24%2077.5994%2023.2646C77.5606%2023.3143%2077.4904%2023.2596%2077.4442%2023.2865C77.4034%2023.3035%2077.3644%2023.3244%2077.3278%2023.349C77.3197%2023.3555%2077.3069%2023.349%2077.2979%2023.3555C77.2626%2023.3748%2077.2665%2023.4581%2077.2203%2023.4515C77.1844%2023.4498%2077.149%2023.4602%2077.1198%2023.4812C77.1012%2023.4916%2077.1198%2023.5305%2077.093%2023.5105C77.0519%2023.4789%2077.062%2023.5571%2077.041%2023.5698C77.0365%2023.5734%2077.0327%2023.5779%2077.0299%2023.583C77.0271%2023.5881%2077.0253%2023.5937%2077.0248%2023.5995C77.0214%2023.63%2077.026%2023.6608%2077.0383%2023.6889C77.0586%2023.7528%2077.0846%2023.8147%2077.1159%2023.8739C77.161%2023.9561%2077.2107%2024.0357%2077.2646%2024.1125'%20fill='%23121C2D'/%3e%3cpath%20d='M67.6541%2020.5361C67.6803%2020.5665%2067.7138%2020.5898%2067.7515%2020.604C67.7569%2020.6063%2067.7647%2020.6101%2067.7674%2020.6074C67.7798%2020.5947%2067.8155%2020.646%2067.8221%2020.6159C67.8272%2020.5943%2067.8524%2020.6055%2067.8683%2020.6024C67.8706%2020.6024%2067.8722%2020.5997%2067.8745%2020.6001C67.9315%2020.6094%2067.9653%2020.5743%2068.0084%2020.5566C68.0084%2020.5566%2068.0119%2020.5539%2068.0142%2020.5542C68.072%2020.5592%2068.105%2020.5088%2068.1613%2020.513C68.1683%2020.513%2068.1725%2020.5068%2068.1776%2020.5026C68.1902%2020.4922%2068.205%2020.4846%2068.2209%2020.4804C68.2367%2020.4762%2068.2534%2020.4755%2068.2695%2020.4783C68.2732%2020.4793%2068.277%2020.4794%2068.2807%2020.4787C68.2844%2020.4779%2068.2879%2020.4764%2068.2909%2020.4741C68.3014%2020.4639%2068.314%2020.4561%2068.3277%2020.4512C68.3415%2020.4462%2068.3562%2020.4441%2068.3708%2020.4452C68.3762%2020.4452%2068.3821%2020.4452%2068.3852%2020.4405C68.3976%2020.4151%2068.4158%2020.3673%2068.4368%2020.3635C68.4888%2020.36%2068.5388%2020.3908%2068.5831%2020.3685C68.59%2020.3659%2068.5974%2020.3646%2068.6048%2020.3646C68.6087%2020.3646%2068.6149%2020.3685%2068.618%2020.3646C68.6599%2020.3291%2068.717%2020.3511%2068.7612%2020.3226C68.7837%2020.3076%2068.8132%2020.3149%2068.8388%2020.3091C68.8935%2020.2979%2068.9463%2020.2802%2069.0018%2020.2729C69.0278%2020.2686%2069.0538%2020.2629%2069.0794%2020.2602C69.0961%2020.2602%2069.112%2020.249%2069.1298%2020.2602C69.2261%2020.3311%2069.24%2020.2548%2069.2959%2020.2517C69.3524%2020.2483%2069.409%2020.2483%2069.4655%2020.2517C69.4946%2020.2563%2069.5253%2020.2266%2069.5536%2020.2517C69.5963%2020.2902%2069.6246%2020.2447%2069.6603%2020.2517C69.7204%2020.259%2069.781%2020.2563%2069.8411%2020.2617C69.8714%2020.2644%2069.9014%2020.2696%2069.9308%2020.2775C69.9379%2020.2793%2069.9454%2020.2793%2069.9525%2020.2775C69.9913%2020.2698%2070.0355%2020.2313%2070.0743%2020.239C70.1205%2020.2471%2070.1586%2020.3018%2070.2028%2020.313C70.2354%2020.3203%2070.2765%2020.2887%2070.3076%2020.3049C70.3386%2020.3211%2070.3607%2020.3631%2070.3922%2020.3669C70.4465%2020.3723%2070.4911%2020.4267%2070.5497%2020.4012C70.6083%2020.3758%2070.6386%2020.4321%2070.682%2020.4475C70.7337%2020.4638%2070.7826%2020.4877%2070.8272%2020.5184C70.8454%2020.5323%2070.8683%2020.5357%2070.8854%2020.5535C70.8908%2020.5589%2070.916%2020.5558%2070.9242%2020.5535C70.9424%2020.5481%2070.9378%2020.5604%2070.9494%2020.5716C70.9816%2020.5955%2071.0172%2020.6147%2071.0549%2020.6286C71.0999%2020.6548%2071.1574%2020.6548%2071.1962%2020.6945C71.1962%2020.6945%2071.1985%2020.6992%2071.2005%2020.6992C71.2508%2020.6984%2071.3011%2020.7035%2071.3502%2020.7142C71.391%2020.7234%2071.4115%2020.8017%2071.4566%2020.8021C71.4761%2020.8036%2071.4955%2020.807%2071.5144%2020.8121C71.5532%2020.8183%2071.6025%2020.7897%2071.6568%2020.7373L71.8407%2020.5573C71.8714%2020.5234%2071.8996%2020.4874%2071.9249%2020.4494C71.9927%2020.3571%2072.0459%2020.255%2072.0829%2020.1468C72.0863%2020.1368%2072.0888%2020.1265%2072.0902%2020.116C72.102%2020.051%2072.0996%2019.9842%2072.0833%2019.9202C72.0774%2019.8898%2072.0542%2019.8774%2072.0367%2019.8609C71.9779%2019.8044%2071.9088%2019.7598%2071.833%2019.7294C71.798%2019.7144%2071.72%2019.7329%2071.684%2019.7229C71.6785%2019.7226%2071.6731%2019.7214%2071.6681%2019.7194C71.6126%2019.6809%2071.5854%2019.6381%2071.5295%2019.5988C71.5249%2019.5957%2071.5218%2019.5899%2071.5163%2019.5887C71.4539%2019.5753%2071.3949%2019.549%2071.3433%2019.5117C71.2757%2019.4731%2071.2094%2019.5117%2071.1333%2019.5028C71.12%2019.5007%2071.1074%2019.4956%2071.0965%2019.4878C71.0627%2019.4639%2071.0142%2019.3891%2070.9703%2019.3937C70.9157%2019.395%2070.8618%2019.3805%2070.8151%2019.3521C70.7686%2019.334%2070.7202%2019.3211%2070.6708%2019.3136C70.637%2019.3039%2070.5986%2019.324%2070.5652%2019.317C70.5156%2019.3066%2070.4694%2019.27%2070.4193%2019.2611C70.3945%2019.2557%2070.3506%2019.2823%2070.3258%2019.2862C70.2928%2019.2912%2070.2769%2019.2515%2070.2459%2019.243C70.2237%2019.2369%2070.1605%2019.2345%2070.138%2019.2299C70.1062%2019.2245%2070.0732%2019.1841%2070.0394%2019.1914C69.994%2019.2022%2069.9956%2019.2172%2069.9509%2019.2164C69.897%2019.2164%2069.8431%2019.2207%2069.7891%2019.2234C69.7317%2019.2282%2069.6741%2019.23%2069.6164%2019.2288C69.5881%2019.2249%2069.5592%2019.2278%2069.5322%2019.2372C69.5222%2019.2415%2069.5105%2019.2372%2069.5%2019.2442C69.4119%2019.2873%2069.3646%2019.2557%2069.2963%2019.2646L69.2451%2019.2742C69.2201%2019.2826%2069.1937%2019.2855%2069.1675%2019.2827C69.1404%2019.2785%2069.1128%2019.2844%2069.0899%2019.2993C68.9735%2019.3694%2068.8714%2019.344%2068.7631%2019.3725C68.7162%2019.3908%2068.672%2019.4156%2068.632%2019.4461C68.5423%2019.5032%2068.4251%2019.4565%2068.3289%2019.4978C68.2468%2019.5238%2068.167%2019.5564%2068.0903%2019.5953C68.0732%2019.6049%2068.0515%2019.6034%2068.0328%2019.6115C67.961%2019.6439%2067.9347%2019.7356%2067.8563%2019.7448C67.7879%2019.7572%2067.7222%2019.7815%2067.6622%2019.8165C67.6234%2019.8354%2067.6394%2019.8755%2067.6021%2019.8612C67.5427%2019.84%2067.5291%2019.9318%2067.4857%2019.9568C67.4685%2019.9676%2067.4545%2019.9826%2067.4449%2020.0004C67.428%2020.0328%2067.4232%2020.07%2067.4314%2020.1056C67.4401%2020.1738%2067.4606%2020.24%2067.4919%2020.3014C67.5362%2020.3844%2067.5901%2020.462%2067.6525%2020.5327'%20fill='%23121C2D'/%3e%3cpath%20d='M79.6638%2019.9607C79.6889%2019.932%2079.7065%2019.8976%2079.715%2019.8605C79.715%2019.8551%2079.7185%2019.847%2079.715%2019.8462C79.7018%2019.8401%2079.7421%2019.793%2079.715%2019.7965C79.6948%2019.7996%2079.6994%2019.7753%2079.6932%2019.7626C79.6932%2019.7626%2079.6901%2019.7603%2079.6897%2019.7583C79.6843%2019.7067%2079.6463%2019.6878%2079.6152%2019.6643C79.6152%2019.6643%2079.6118%2019.6643%2079.6114%2019.6608C79.5951%2019.6111%2079.5411%2019.6111%2079.5213%2019.5649C79.519%2019.5595%2079.5116%2019.5595%2079.5062%2019.5579C79.4928%2019.5535%2079.4804%2019.5465%2079.4698%2019.5373C79.4591%2019.5281%2079.4504%2019.5169%2079.4441%2019.5043C79.441%2019.4978%2079.4375%2019.4924%2079.4301%2019.4916C79.4175%2019.4904%2079.4052%2019.4862%2079.3944%2019.4796C79.3836%2019.4729%2079.3744%2019.4638%2079.3677%2019.4531C79.365%2019.4492%2079.3626%2019.4442%2079.3564%2019.4461C79.3316%2019.455%2079.2904%2019.4762%2079.2788%2019.4643C79.2474%2019.4361%2079.2361%2019.3829%2079.1942%2019.3745C79.1883%2019.3725%2079.1829%2019.3694%2079.1783%2019.3652C79.1752%2019.3652%2079.174%2019.3567%2079.1702%2019.3571C79.1236%2019.3617%2079.098%2019.3109%2079.0518%2019.3166C79.0289%2019.3193%2079.013%2019.2985%2078.9913%2019.2928C78.947%2019.28%2078.9024%2019.2681%2078.8574%2019.2592C78.8364%2019.2546%2078.8151%2019.2515%2078.7945%2019.245C78.7813%2019.2419%2078.7662%2019.245%2078.7557%2019.2284C78.7014%2019.1297%2078.6672%2019.2037%2078.6234%2019.1952C78.5776%2019.1881%2078.5321%2019.1787%2078.4872%2019.1671C78.4635%2019.1605%2078.436%2019.1883%2078.4154%2019.1625C78.3828%2019.1216%2078.3564%2019.1656%2078.3281%2019.159C78.2796%2019.1528%2078.2306%2019.1516%2078.1818%2019.1555C78.1576%2019.1552%2078.1334%2019.1527%2078.1096%2019.1478C78.104%2019.146%2078.0978%2019.146%2078.0922%2019.1478C78.0619%2019.159%2078.0355%2019.2083%2078.0056%2019.2083C77.9699%2019.2083%2077.9303%2019.1636%2077.8939%2019.1621C77.8671%2019.1621%2077.8457%2019.2056%2077.8194%2019.2006C77.793%2019.1956%2077.7639%2019.1621%2077.7418%2019.1671C77.7029%2019.1775%2077.6498%2019.144%2077.6195%2019.1914C77.5893%2019.2388%2077.5489%2019.1995%2077.5128%2019.2033C77.4722%2019.2113%2077.4306%2019.2135%2077.3894%2019.2099C77.3712%2019.2068%2077.356%2019.2153%2077.337%2019.2099C77.3312%2019.2099%2077.3168%2019.223%2077.3133%2019.2288C77.3048%2019.2423%2077.3017%2019.2288%2077.2889%2019.2265C77.2586%2019.2254%2077.2283%2019.23%2077.1997%2019.2399C77.1608%2019.2453%2077.129%2019.2742%2077.0879%2019.2696C77.0879%2019.2696%2077.084%2019.2696%2077.0829%2019.2696C77.0594%2019.3002%2077.0323%2019.3279%2077.0021%2019.3521C76.9777%2019.3698%2076.9203%2019.3251%2076.9016%2019.3575C76.8929%2019.3695%2076.8828%2019.3804%2076.8714%2019.3899C76.8516%2019.4115%2076.8504%2019.4646%2076.8628%2019.5379L76.9098%2019.7842C76.9183%2019.8269%2076.935%2019.8713%2076.9486%2019.9148C76.9834%2020.0233%2077.0267%2020.1288%2077.0782%2020.2305C77.0836%2020.2405%2077.0887%2020.2486%2077.0933%2020.2575C77.123%2020.3073%2077.1587%2020.3532%2077.1997%2020.3943C77.2167%2020.4124%2077.2288%2020.4074%2077.2412%2020.4093C77.2811%2020.4134%2077.3214%2020.4065%2077.3576%2020.3893C77.3743%2020.382%2077.3859%2020.3241%2077.401%2020.3122C77.4034%2020.3122%2077.4049%2020.3064%2077.4073%2020.306C77.4399%2020.3029%2077.4693%2020.3303%2077.5031%2020.3338C77.5058%2020.3338%2077.5093%2020.3376%2077.5116%2020.3338C77.5232%2020.3241%2077.5369%2020.3173%2077.5516%2020.3139C77.5663%2020.3105%2077.5816%2020.3106%2077.5962%2020.3141C77.635%2020.3199%2077.6397%2020.2552%2077.67%2020.2336C77.6725%2020.2317%2077.6756%2020.2304%2077.6788%2020.23C77.682%2020.2296%2077.6852%2020.23%2077.6882%2020.2313C77.7088%2020.237%2077.7514%2020.2852%2077.7658%2020.2671C77.7741%2020.2574%2077.7853%2020.2507%2077.7978%2020.2481C77.8103%2020.2454%2077.8234%2020.247%2077.8349%2020.2525C77.8586%2020.2594%2077.8772%2020.2436%2077.8989%2020.244C77.914%2020.244%2077.9234%2020.2158%2077.9377%2020.2135C77.9591%2020.2112%2077.9851%2020.2351%2078.006%2020.2316C78.0165%2020.2316%2078.0285%2020.1973%2078.0382%2020.1892C78.0479%2020.1812%2078.0638%2020.2147%2078.077%2020.2182C78.0917%2020.2177%2078.1064%2020.2163%2078.1209%2020.2139C78.1345%2020.2139%2078.1515%2020.2482%2078.1636%2020.2382C78.1756%2020.2282%2078.1787%2020.2093%2078.1962%2020.2066C78.2178%2020.202%2078.2392%2020.1962%2078.2602%2020.1892C78.2818%2020.1817%2078.3051%2020.1797%2078.3277%2020.1835C78.3332%2020.1855%2078.3391%2020.186%2078.3448%2020.185C78.3505%2020.184%2078.3559%2020.1815%2078.3603%2020.1777C78.3642%2020.1738%2078.3688%2020.1777%2078.3731%2020.1723C78.4119%2020.1307%2078.4266%2020.17%2078.453%2020.1696C78.4601%2020.1691%2078.4671%2020.1682%2078.474%2020.1669C78.4845%2020.1669%2078.4957%2020.1596%2078.505%2020.1696C78.5143%2020.1796%2078.5252%2020.1734%2078.5372%2020.1646C78.5947%2020.1222%2078.6257%2020.1688%2078.6692%2020.1707C78.693%2020.1674%2078.7157%2020.1585%2078.7355%2020.1449C78.7864%2020.1218%2078.8%2020.2047%2078.8384%2020.2108C78.871%2020.2166%2078.8997%2020.232%2078.9338%2020.2351C78.9416%2020.2351%2078.9439%2020.2471%2078.9509%2020.2501C78.9769%2020.2606%2079.0386%2020.2043%2079.0506%2020.2409C79.0627%2020.2775%2079.0848%2020.286%2079.1042%2020.2999C79.117%2020.3083%2079.1457%2020.2764%2079.1352%2020.3049C79.117%2020.3507%2079.1791%2020.3087%2079.1954%2020.3203C79.2043%2020.3247%2079.2146%2020.3255%2079.2241%2020.3226C79.2522%2020.3137%2079.2785%2020.2999%2079.3017%2020.2818C79.3584%2020.2447%2079.413%2020.2044%2079.4651%2020.1611C79.5369%2020.1004%2079.6034%2020.0339%2079.6641%2019.9622'%20fill='%23121C2D'/%3e%3cpath%20d='M68.719%2092.4411C68.7101%2092.4762%2068.7118%2092.513%2068.724%2092.5471C68.724%2092.5525%2068.7275%2092.5602%2068.7314%2092.5614C68.7496%2092.566%2068.7314%2092.6157%2068.7593%2092.6091C68.7807%2092.6038%2068.788%2092.6288%2068.8012%2092.6404C68.8012%2092.6404%2068.8059%2092.6404%2068.807%2092.6442C68.8373%2092.6939%2068.8881%2092.7082%2068.932%2092.7348C68.9342%2092.7354%2068.9362%2092.7366%2068.9378%2092.7383C68.9735%2092.7868%2069.0368%2092.7911%2069.0725%2092.8385C69.0763%2092.8439%2069.0849%2092.8443%2069.0919%2092.847C69.1256%2092.8591%2069.1548%2092.8813%2069.1753%2092.9105C69.1795%2092.9176%2069.1861%2092.9229%2069.1939%2092.9256C69.2246%2092.9331%2069.2519%2092.9506%2069.2715%2092.9753C69.2754%2092.9799%2069.2785%2092.9853%2069.2855%2092.9849C69.3138%2092.9826%2069.3631%2092.9734%2069.3794%2092.9903C69.4182%2093.0289%2069.4337%2093.0844%2069.4834%2093.1083C69.4905%2093.1123%2069.4969%2093.1174%2069.5024%2093.1233C69.5059%2093.1264%2069.5071%2093.1333%2069.5117%2093.1345C69.5688%2093.1487%2069.594%2093.2089%2069.6491%2093.227C69.677%2093.2362%2069.6941%2093.2636%2069.7178%2093.2802L69.8683%2093.3892L69.9382%2093.442C69.9522%2093.454%2069.9716%2093.4609%2069.977%2093.4806C70.0057%2093.5962%2070.067%2093.5642%2070.114%2093.6043C70.1627%2093.6443%2070.2085%2093.6877%2070.251%2093.7342C70.2723%2093.7585%2070.3158%2093.7631%2070.3243%2093.7993C70.3371%2093.8552%2070.3872%2093.8483%2070.4132%2093.8787C70.4566%2093.9308%2070.5106%2093.972%2070.5579%2094.0198C70.5819%2094.0439%2070.6042%2094.0697%2070.6247%2094.0969C70.6294%2094.1036%2070.6353%2094.1093%2070.6421%2094.1138C70.6782%2094.1381%2070.7376%2094.1416%2070.7667%2094.174C70.8016%2094.2125%2070.8055%2094.2769%2070.8377%2094.3181C70.8606%2094.3478%2070.9153%2094.3524%2070.932%2094.386C70.9487%2094.4195%2070.9498%2094.4654%2070.9755%2094.4904C71.0197%2094.532%2071.0325%2094.606%2071.0969%2094.6253C71.1613%2094.6446%2071.1609%2094.7086%2071.1928%2094.7502C71.2303%2094.7977%2071.2634%2094.8486%2071.2917%2094.902C71.306%2094.9233%2071.3189%2094.9455%2071.3305%2094.9683C71.3328%2094.9764%2071.3569%2094.9911%2071.3651%2094.9942C71.3833%2095.0023%2071.3736%2095.0092%2071.3802%2095.0265C71.4008%2095.0669%2071.4256%2095.105%2071.4543%2095.1402C71.4935%2095.1847%2071.5281%2095.233%2071.5575%2095.2844C71.5575%2095.2867%2071.5575%2095.2898%2071.5598%2095.2909C71.6065%2095.3212%2071.6503%2095.3557%2071.6906%2095.3939C71.724%2095.4258%2071.7174%2095.5075%2071.7589%2095.533C71.7767%2095.5455%2071.7934%2095.5594%2071.809%2095.5746C71.8314%2095.5881%2071.8567%2095.5962%2071.8829%2095.5981C71.9091%2095.6001%2071.9353%2095.5958%2071.9595%2095.5858L72.1757%2095.521C72.2127%2095.5066%2072.2483%2095.4888%2072.282%2095.4678C72.3697%2095.4193%2072.4485%2095.3562%2072.5148%2095.2813C72.5211%2095.2743%2072.5267%2095.2667%2072.5315%2095.2586C72.5632%2095.208%2072.584%2095.1514%2072.5924%2095.0924C72.5943%2095.0682%2072.5881%2095.044%2072.575%2095.0235C72.5457%2094.9517%2072.5059%2094.8846%2072.4566%2094.8246C72.4341%2094.796%2072.3635%2094.7741%2072.3375%2094.7475C72.3336%2094.744%2072.3282%2094.7417%2072.3255%2094.7371C72.2944%2094.6812%2072.2921%2094.6315%2072.263%2094.5733C72.2607%2094.569%2072.2607%2094.5625%2072.2568%2094.5594C72.2121%2094.5181%2072.1759%2094.4686%2072.1501%2094.4137C72.1151%2094.3482%2072.0441%2094.3451%2071.989%2094.2981C71.9794%2094.2895%2071.9717%2094.279%2071.9665%2094.2673C71.9494%2094.2322%2071.9467%2094.1489%2071.9114%2094.1281C71.868%2094.0991%2071.8331%2094.0592%2071.8101%2094.0125C71.7823%2093.9738%2071.7518%2093.9371%2071.7189%2093.9026C71.698%2093.8764%2071.6592%2093.8687%2071.6367%2093.8437C71.6045%2093.8074%2071.5882%2093.755%2071.5544%2093.7196C71.5377%2093.7018%2071.4931%2093.693%2071.4722%2093.681C71.445%2093.6644%2071.4539%2093.6274%2071.4357%2093.6039C71.4225%2093.5862%2071.3767%2093.5465%2071.3623%2093.5299C71.3418%2093.5068%2071.3383%2093.4606%2071.3107%2093.4444C71.2719%2093.4224%2071.2645%2093.434%2071.2331%2093.4058C71.1943%2093.3715%2071.152%2093.3411%2071.1113%2093.3091C71.0671%2093.2754%2071.025%2093.2391%2070.9852%2093.2004C70.9672%2093.1797%2070.9449%2093.163%2070.92%2093.1514C70.9099%2093.1476%2070.9037%2093.1383%2070.8936%2093.1349C70.8031%2093.1056%2070.7923%2093.0508%2070.7383%2093.0115L70.6964%2092.983C70.6734%2092.9711%2070.6529%2092.9547%2070.6363%2092.9348C70.6199%2092.914%2070.5971%2092.8991%2070.5715%2092.8921C70.4731%2092.8448%2070.3827%2092.7825%2070.3037%2092.7074C70.2612%2092.6839%2070.2157%2092.6662%2070.1683%2092.655C70.069%2092.6246%2070.0263%2092.5132%2069.9355%2092.465C69.8618%2092.4265%2069.7938%2092.3748%2069.7162%2092.3413C69.6984%2092.3336%2069.686%2092.3166%2069.6693%2092.3074C69.6021%2092.2688%2069.5164%2092.2985%2069.4636%2092.2422C69.4135%2092.1968%2069.3565%2092.1593%2069.2948%2092.1312C69.2583%2092.1116%2069.2358%2092.1412%2069.2254%2092.1069C69.2075%2092.0507%2069.1295%2092.0827%2069.0857%2092.0615C69.0675%2092.0533%2069.0478%2092.0492%2069.0278%2092.0495C68.994%2092.0503%2068.9616%2092.0631%2068.9366%2092.0857C68.8878%2092.1216%2068.8462%2092.1663%2068.814%2092.2176C68.7721%2092.2876%2068.7405%2092.3633%2068.7201%2092.4423'%20fill='%23121C2D'/%3e%3cpath%20d='M63.9109%2095.4794C63.9019%2095.5146%2063.9037%2095.5516%2063.916%2095.5858C63.916%2095.5912%2063.9194%2095.5989%2063.9233%2095.6001C63.9416%2095.6047%2063.9233%2095.6544%2063.9509%2095.6479C63.9722%2095.6425%2063.9796%2095.6675%2063.9928%2095.6791C63.9928%2095.6791%2063.9974%2095.6791%2063.9986%2095.6829C64.0289%2095.7323%2064.0793%2095.7469%2064.1236%2095.7735C64.1236%2095.7735%2064.1282%2095.7735%2064.1294%2095.777C64.1651%2095.8256%2064.2283%2095.8298%2064.264%2095.8772C64.2679%2095.8826%2064.2765%2095.883%2064.2834%2095.8857C64.3172%2095.8978%2064.3464%2095.92%2064.3669%2095.9493C64.3711%2095.9563%2064.3777%2095.9617%2064.3855%2095.9643C64.4162%2095.9719%2064.4435%2095.9893%2064.4631%2096.014C64.467%2096.0186%2064.4701%2096.024%2064.4771%2096.0237C64.5054%2096.0213%2064.5547%2096.0121%2064.571%2096.0291C64.6098%2096.0676%2064.6253%2096.1231%2064.675%2096.147C64.682%2096.1511%2064.6884%2096.1562%2064.694%2096.162C64.6975%2096.1651%2064.6986%2096.172%2064.7029%2096.1732C64.7603%2096.1875%2064.7856%2096.2476%2064.8407%2096.2657C64.8682%2096.275%2064.8857%2096.3023%2064.9094%2096.3189L65.0595%2096.428L65.1298%2096.4808C65.1437%2096.4927%2065.1631%2096.4997%2065.1686%2096.5193C65.1973%2096.6349%2065.2586%2096.603%2065.3056%2096.643C65.3543%2096.683%2065.4001%2096.7264%2065.4425%2096.7729C65.4639%2096.7972%2065.5069%2096.8018%2065.5159%2096.8381C65.5287%2096.8939%2065.5787%2096.887%2065.6047%2096.9175C65.6482%2096.9695%2065.7021%2097.0107%2065.7499%2097.0585C65.7739%2097.0827%2065.7962%2097.1084%2065.8166%2097.1356C65.8213%2097.1423%2065.8272%2097.1481%2065.8341%2097.1526C65.8702%2097.1769%2065.9295%2097.1803%2065.9586%2097.2127C65.9932%2097.2512%2065.9974%2097.3156%2066.0296%2097.3568C66.0525%2097.3865%2066.1073%2097.3911%2066.1236%2097.4247C66.1399%2097.4582%2066.1414%2097.5041%2066.167%2097.5291C66.2109%2097.5708%2066.2237%2097.6448%2066.2885%2097.664C66.3533%2097.6833%2066.3525%2097.7473%2066.3843%2097.7889C66.4219%2097.8364%2066.455%2097.8873%2066.4833%2097.9408C66.4975%2097.9621%2066.5105%2097.9842%2066.5221%2098.0071C66.5244%2098.0151%2066.5485%2098.0298%2066.5566%2098.0329C66.5749%2098.041%2066.5652%2098.0479%2066.5717%2098.0649C66.5924%2098.1053%2066.6172%2098.1434%2066.6459%2098.1786C66.6851%2098.223%2066.7197%2098.2713%2066.7491%2098.3227C66.7491%2098.325%2066.7491%2098.3281%2066.7514%2098.3293C66.7979%2098.3596%2066.8416%2098.394%2066.8818%2098.4322C66.9152%2098.4642%2066.9086%2098.5459%2066.9501%2098.5713C66.9678%2098.5839%2066.9845%2098.5979%2067.0002%2098.613C67.0226%2098.6265%2067.0479%2098.6345%2067.0741%2098.6365C67.1002%2098.6384%2067.1265%2098.6342%2067.1507%2098.6241L67.3668%2098.5594C67.4039%2098.545%2067.4395%2098.5272%2067.4732%2098.5062C67.5609%2098.4577%2067.6396%2098.3948%2067.706%2098.32C67.7123%2098.313%2067.7179%2098.3054%2067.7227%2098.2973C67.7544%2098.2468%2067.7751%2098.1904%2067.7836%2098.1316C67.7854%2098.1073%2067.7793%2098.0831%2067.7662%2098.0626C67.737%2097.9907%2067.6969%2097.9236%2067.6474%2097.8637C67.6253%2097.8352%2067.5547%2097.8132%2067.5287%2097.7866C67.5248%2097.7831%2067.5194%2097.7808%2067.5166%2097.7766C67.4856%2097.7207%2067.4833%2097.671%2067.4538%2097.6128C67.4514%2097.6085%2067.4514%2097.602%2067.448%2097.5989C67.4031%2097.5576%2067.3668%2097.5082%2067.3409%2097.4532C67.3059%2097.3877%2067.2349%2097.3846%2067.1798%2097.3376C67.1701%2097.329%2067.1625%2097.3185%2067.1573%2097.3067C67.1402%2097.2713%2067.1375%2097.1884%2067.1018%2097.1676C67.0586%2097.1384%2067.0237%2097.0986%2067.0005%2097.052C66.9729%2097.0133%2066.9426%2096.9765%2066.9097%2096.9421C66.8888%2096.9159%2066.85%2096.9082%2066.8275%2096.8832C66.7949%2096.8469%2066.779%2096.7941%2066.7452%2096.7591C66.7285%2096.7413%2066.6839%2096.7325%2066.6629%2096.7205C66.6354%2096.7039%2066.6447%2096.6669%2066.6265%2096.6434C66.6129%2096.6257%2066.5675%2096.586%2066.5531%2096.5694C66.5326%2096.5463%2066.5291%2096.5%2066.5015%2096.4839C66.4627%2096.4619%2066.4553%2096.4735%2066.4239%2096.4453C66.3851%2096.411%2066.3428%2096.3806%2066.3021%2096.3486C66.2579%2096.3149%2066.2158%2096.2786%2066.1759%2096.2399C66.1579%2096.2192%2066.1357%2096.2025%2066.1107%2096.1909C66.1007%2096.1871%2066.0944%2096.1778%2066.0844%2096.1744C65.9939%2096.1451%2065.9827%2096.0903%2065.9291%2096.051L65.8872%2096.0225C65.864%2096.0106%2065.8435%2095.9942%2065.8267%2095.9743C65.8105%2095.9535%2065.7879%2095.9385%2065.7623%2095.9315C65.6638%2095.8844%2065.5734%2095.8221%2065.4945%2095.7469C65.452%2095.7233%2065.4065%2095.7057%2065.3591%2095.6945C65.2598%2095.6641%2065.2171%2095.5527%2065.1263%2095.5045C65.0525%2095.466%2064.9846%2095.4143%2064.907%2095.3808C64.8892%2095.3731%2064.8768%2095.3561%2064.8601%2095.3469C64.7929%2095.3083%2064.7072%2095.338%2064.6544%2095.2817C64.6043%2095.2363%2064.5473%2095.1988%2064.4856%2095.1707C64.4491%2095.1511%2064.4266%2095.1807%2064.4161%2095.1464C64.3983%2095.0902%2064.3199%2095.1222%2064.2764%2095.101C64.2583%2095.0928%2064.2386%2095.0887%2064.2186%2095.089C64.1848%2095.0898%2064.1524%2095.1026%2064.1274%2095.1252C64.0785%2095.161%2064.0369%2095.2058%2064.0048%2095.2571C63.9629%2095.3271%2063.9313%2095.4028%2063.9109%2095.4818'%20fill='%23121C2D'/%3e%3cpath%20d='M66.3335%2093.7408C66.3309%2093.7779%2066.3411%2093.8149%2066.3623%2093.8456C66.3661%2093.851%2066.3692%2093.8587%2066.3743%2093.8602C66.3983%2093.8672%2066.3848%2093.9142%2066.4197%2093.9107C66.4453%2093.908%2066.4585%2093.9335%2066.4787%2093.9466C66.481%2093.9466%2066.4845%2093.9489%2066.4868%2093.9512C66.539%2093.9956%2066.5984%2094.0308%2066.6626%2094.0553C66.6657%2094.0561%2066.6686%2094.0576%2066.6711%2094.0595C66.7262%2094.1123%2066.805%2094.1242%2066.8605%2094.1751C66.8683%2094.1805%2066.8772%2094.1841%2066.8865%2094.1859C66.9304%2094.2019%2066.9701%2094.2273%2067.0029%2094.2603C67.01%2094.2684%2067.0191%2094.2745%2067.0293%2094.278C67.07%2094.2897%2067.1074%2094.3106%2067.1387%2094.3389C67.1445%2094.3443%2067.1496%2094.3501%2067.1581%2094.3505C67.1978%2094.3469%2067.2377%2094.3529%2067.2745%2094.3678C67.3327%2094.4137%2067.3638%2094.4711%2067.4298%2094.5023C67.4394%2094.5075%2067.4485%2094.5136%2067.4569%2094.5205C67.462%2094.5243%2067.4651%2094.5309%2067.4705%2094.5328C67.5431%2094.5552%2067.59%2094.6191%2067.6599%2094.6484C67.6939%2094.6667%2067.7261%2094.6884%2067.7557%2094.7132L67.9633%2094.8473L68.06%2094.9128C68.0797%2094.9275%2068.1042%2094.9375%2068.1158%2094.9606C68.1826%2095.087%2068.2447%2095.0616%2068.3099%2095.1109C68.375%2095.1603%2068.4433%2095.2119%2068.5039%2095.2686C68.5353%2095.2983%2068.5861%2095.309%2068.6059%2095.3495C68.6362%2095.4116%2068.6921%2095.4116%2068.7301%2095.4478L68.9346%2095.622C68.9684%2095.6521%2069.001%2095.6825%2069.0316%2095.7157C69.0392%2095.7236%2069.0476%2095.7306%2069.0568%2095.7365C69.1108%2095.7603%2069.1628%2095.7885%2069.2121%2095.8209C69.2617%2095.8683%2069.2846%2095.9415%2069.332%2095.9901C69.3661%2096.0263%2069.4255%2096.0398%2069.4554%2096.0799C69.4773%2096.1234%2069.5033%2096.1647%2069.533%2096.2032C69.5935%2096.2564%2069.6288%2096.3401%2069.7045%2096.3728C69.7802%2096.4056%2069.7976%2096.4769%2069.8438%2096.527C69.8981%2096.5859%2069.9479%2096.6488%2069.9928%2096.7151C70.0107%2096.7436%2070.0363%2096.7667%2070.0522%2096.7972C70.0648%2096.811%2070.0796%2096.8226%2070.096%2096.8315C70.1181%2096.843%2070.11%2096.8496%2070.1216%2096.87C70.1548%2096.9202%2070.1915%2096.968%2070.2315%2097.013C70.2854%2097.0702%2070.3352%2097.1311%2070.3805%2097.1953C70.3805%2097.198%2070.3805%2097.2019%2070.3847%2097.2038C70.4424%2097.2468%2070.4974%2097.2932%2070.5493%2097.3429C70.5927%2097.3853%2070.6079%2097.4805%2070.6575%2097.5168C70.6794%2097.5344%2070.7002%2097.5532%2070.72%2097.573C70.7418%2097.591%2070.7677%2097.6034%2070.7954%2097.6093C70.8231%2097.6152%2070.8518%2097.6144%2070.8791%2097.607L71.0856%2097.5592C71.1196%2097.5472%2071.1518%2097.5307%2071.1814%2097.5102C71.2597%2097.4633%2071.3255%2097.3982%2071.3731%2097.3206C71.3779%2097.313%2071.3818%2097.3048%2071.3847%2097.2963C71.4051%2097.2365%2071.4125%2097.173%2071.4065%2097.1101C71.4015%2097.0803%2071.3895%2097.0521%2071.3715%2097.0277C71.3239%2096.94%2071.2664%2096.858%2071.2%2096.7833C71.1698%2096.7478%2071.091%2096.7132%2071.0576%2096.6812C71.0523%2096.6772%2071.0473%2096.6726%2071.0429%2096.6677C70.9963%2096.5991%2070.9804%2096.5428%2070.9354%2096.4726C70.9315%2096.4672%2070.93%2096.4599%2070.9253%2096.4561C70.8677%2096.4031%2070.8176%2096.3427%2070.7763%2096.2765C70.7216%2096.1994%2070.6459%2096.1859%2070.5745%2096.1223C70.5619%2096.1112%2070.5512%2096.0982%2070.5427%2096.0837C70.5163%2096.0414%2070.4911%2095.9489%2070.4472%2095.9211C70.3927%2095.8822%2070.3458%2095.8337%2070.3087%2095.7781C70.2692%2095.731%2070.2267%2095.6865%2070.1814%2095.6448C70.1519%2095.6132%2070.1077%2095.5997%2070.077%2095.5677C70.0324%2095.5241%2069.9994%2095.4636%2069.9556%2095.4204C69.9238%2095.3998%2069.8901%2095.3822%2069.8551%2095.3676C69.8209%2095.3461%2069.8209%2095.3071%2069.7945%2095.2778C69.7755%2095.257%2069.7169%2095.2077%2069.6952%2095.188C69.6665%2095.1603%2069.6513%2095.1109%2069.6176%2095.089C69.5691%2095.0616%2069.5636%2095.0724%2069.5206%2095.0377C69.4689%2094.9961%2069.4138%2094.9579%2069.3603%2094.9182C69.2873%2094.8627%2069.2439%2094.8342%2069.1907%2094.7868C69.1653%2094.7625%2069.1364%2094.7421%2069.105%2094.7263C69.0929%2094.7209%2069.0836%2094.7105%2069.0708%2094.7055C68.9622%2094.6623%2068.9342%2094.6049%2068.8644%2094.5567L68.8097%2094.5212C68.78%2094.506%2068.7528%2094.4866%2068.7289%2094.4634C68.7052%2094.4396%2068.6762%2094.4216%2068.6443%2094.4106C68.5183%2094.3499%2068.3997%2094.2751%2068.2908%2094.1875C68.2362%2094.1594%2068.1792%2094.1362%2068.1205%2094.1181C67.9979%2094.0745%2067.9206%2093.9566%2067.8042%2093.8976C67.708%2093.8491%2067.618%2093.7889%2067.5171%2093.7477C67.4942%2093.7381%2067.4759%2093.7199%2067.4538%2093.7091C67.3657%2093.6648%2067.2707%2093.6822%2067.1942%2093.6209C67.1235%2093.5703%2067.0475%2093.5274%2066.9676%2093.4929C66.9199%2093.4702%2066.8989%2093.4968%2066.8787%2093.4617C66.8458%2093.405%2066.7577%2093.4282%2066.7006%2093.4031C66.6777%2093.3935%2066.6533%2093.3876%2066.6284%2093.3858C66.592%2093.3821%2066.5554%2093.391%2066.5248%2093.4112C66.4745%2093.439%2066.4318%2093.4787%2066.4007%2093.5268C66.3631%2093.5909%2066.3393%2093.6621%2066.3308%2093.7357'%20fill='%23121C2D'/%3e%3cpath%20d='M72.4175%2092.9121C72.4279%2092.8291%2072.419%2092.7449%2072.3915%2092.6658C72.3874%2092.6461%2072.3812%2092.6269%2072.3733%2092.6084C72.3314%2092.5352%2072.3581%2092.4928%2072.2918%2092.4084C72.2484%2092.3414%2072.2105%2092.271%2072.1785%2092.1979L72.1606%2092.1706C72.1057%2092.0664%2072.0447%2091.9655%2071.9779%2091.8684L71.7563%2091.589L71.7361%2091.5631C71.5732%2091.3646%2071.3998%2091.1748%2071.2165%2090.9946C71.1947%2090.971%2071.1706%2090.9494%2071.1447%2090.9303C71.0163%2090.8304%2070.9014%2090.7171%2070.7819%2090.6123C70.7551%2090.5872%2070.7266%2090.564%2070.6965%2090.5429C70.5801%2090.46%2070.4637%2090.3749%2070.3473%2090.2878C70.3278%2090.2705%2070.3065%2090.2556%2070.2836%2090.2431C70.1905%2090.1929%2070.033%2090.1301%2069.9468%2090.0723C69.7622%2089.9341%2069.5676%2089.8094%2069.3647%2089.6992L69.2662%2089.6472C69.2479%2089.6372%2069.2297%2089.6237%2069.2115%2089.616C68.981%2089.5146%2068.7625%2089.3874%2068.5231%2089.3022C68.4016%2089.2637%2068.2813%2089.1974%2068.1568%2089.1527C67.8933%2089.0529%2067.6259%2088.965%2067.3574%2088.8829L66.9763%2088.7738C66.895%2088.7562%2066.815%2088.7332%2066.7369%2088.7048C66.4778%2088.6031%2066.2055%2088.5382%2065.9282%2088.5121C65.6515%2088.452%2065.3733%2088.4011%2065.0966%2088.3483C64.9534%2088.3205%2064.7947%2088.3175%2064.6624%2088.2801C64.4885%2088.2417%2064.3117%2088.217%2064.1339%2088.2065C63.8358%2088.1591%2063.5363%2088.1317%2063.2383%2088.097L62.7916%2088.0419C62.7563%2088.0369%2062.7194%2088.0334%2062.6833%2088.0311C62.4928%2088.0203%2062.2953%2088.0349%2062.1048%2088.0161C61.8785%2087.9929%2061.6608%2087.9351%2061.4358%2087.9097C61.2716%2087.8912%2061.0955%2087.9058%2060.9337%2087.8819C60.7718%2087.858%2060.6279%2087.8168%2060.4715%2087.8025C60.2057%2087.7783%2059.9309%2087.7158%2059.6775%2087.7174C59.448%2087.7038%2059.22%2087.6716%2058.9957%2087.621C58.7354%2087.5825%2058.475%2087.5439%2058.2196%2087.4857C58.1133%2087.4618%2058.0019%2087.4472%2057.8964%2087.4187C57.8372%2087.4074%2057.7775%2087.3992%2057.7175%2087.394C57.6676%2087.389%2057.6186%2087.3776%2057.5716%2087.3601C57.383%2087.3073%2057.1874%2087.2768%2056.9989%2087.2263C56.7497%2087.165%2056.4994%2087.1134%2056.2581%2087.0317C56.2488%2087.0286%2056.2394%2087.024%2056.2301%2087.0217C55.9806%2086.9696%2055.8099%2086.9265%2055.567%2086.8556C55.3826%2086.7958%2055.1401%2086.6609%2054.9604%2086.6027C54.8774%2086.578%2054.7924%2086.5461%2054.7109%2086.5133C54.5864%2086.4602%2054.4513%2086.4358%2054.3159%2086.442C54.2057%2086.4539%2054.1063%2086.4755%2053.9992%2086.4902C53.943%2086.4983%2053.936%2086.5341%2053.9069%2086.5576C53.8293%2086.6204%2053.8642%2086.7311%2053.9127%2086.8478C53.9208%2086.8616%2053.9303%2086.8746%2053.941%2086.8864C54.0427%2087.0035%2054.1602%2087.106%2054.2903%2087.1909C54.3691%2087.2427%2054.4527%2087.2872%2054.5398%2087.3238C54.8301%2087.4604%2055.1292%2087.5778%2055.435%2087.6753C55.5767%2087.7224%2055.8204%2087.7582%2055.9639%2087.791L56.0249%2087.806C56.2775%2087.8831%2056.4358%2087.9525%2056.6903%2088.0234C56.7101%2088.0288%2056.7292%2088.0369%2056.7497%2088.0404C56.9938%2088.0889%2057.2336%2088.1421%2057.4742%2088.2003C57.7325%2088.2468%2057.9933%2088.2782%2058.2554%2088.2943C58.3077%2088.3013%2058.3574%2088.309%2058.4106%2088.3198C58.5976%2088.372%2058.7878%2088.4128%2058.9798%2088.442C59.1882%2088.457%2059.3974%2088.4859%2059.6007%2088.519C59.7924%2088.5487%2059.9837%2088.5634%2060.1746%2088.5853C60.3085%2088.6015%2060.4385%2088.5954%2060.572%2088.6085C60.766%2088.6281%2060.9647%2088.6678%2061.1583%2088.6855C61.2561%2088.6948%2061.4063%2088.6855%2061.5002%2088.689C61.6244%2088.6936%2061.7035%2088.7276%2061.8234%2088.7441L62.2371%2088.7827C62.3597%2088.7962%2062.4963%2088.8351%2062.6197%2088.8401C62.7881%2088.8474%2062.78%2088.8355%2062.9484%2088.8517L63.5599%2088.9076C63.8405%2088.9349%2063.9965%2088.953%2064.2134%2088.9846C64.3194%2088.9997%2064.4249%2089.0182%2064.5312%2089.0232L64.6523%2089.0363C64.911%2089.0579%2065.1677%2089.0989%2065.4202%2089.1588L65.6143%2089.1916C65.7136%2089.2097%2065.8126%2089.2248%2065.9111%2089.2514C66.0085%2089.2771%2066.1074%2089.2969%2066.2072%2089.3107C66.6243%2089.3835%2067.0343%2089.4913%2067.433%2089.6329L67.9581%2089.7836C68.3218%2089.9191%2068.6736%2090.0841%2069.0101%2090.277C69.3007%2090.4196%2069.5789%2090.5853%2069.8529%2090.7549C69.9142%2090.7934%2069.972%2090.8432%2070.0333%2090.8844C70.2676%2091.0184%2070.4885%2091.1741%2070.693%2091.3496C70.8789%2091.5377%2071.071%2091.7304%2071.2266%2091.9065C71.3294%2092.0222%2071.3636%2092.0222%2071.409%2092.1131C71.4843%2092.2569%2071.6371%2092.396%2071.7392%2092.551C71.7745%2092.6131%2071.8134%2092.6732%2071.8556%2092.731C71.9048%2092.8013%2071.9618%2092.866%2072.0256%2092.9237C72.1055%2092.9869%2072.187%2093.0536%2072.2503%2093.049C72.2901%2093.0471%2072.3281%2093.032%2072.3584%2093.0061C72.3886%2092.9803%2072.4093%2092.9452%2072.4171%2092.9063'%20fill='%23121C2D'/%3e%3cpath%20d='M64.5614%2097.3614C64.5506%2097.2991%2064.5224%2097.2409%2064.4799%2097.1938C64.4718%2097.1814%2064.462%2097.1703%2064.4508%2097.1606C64.4011%2097.1256%2064.4155%2097.0782%2064.3468%2097.045C64.2979%2097.0147%2064.2534%2096.978%2064.2145%2096.9359L64.1962%2096.9213C64.0732%2096.8036%2063.9382%2096.699%2063.7934%2096.6091L63.7748%2096.5956C63.6378%2096.4715%2063.4644%2096.3906%2063.3223%2096.2726C63.3036%2096.2589%2063.2837%2096.2468%2063.263%2096.2364C63.1605%2096.1806%2063.0626%2096.1171%2062.97%2096.0464C62.9493%2096.0297%2062.9269%2096.0151%2062.9032%2096.0028C62.8086%2095.9577%2062.7178%2095.9051%2062.6316%2095.8456C62.6167%2095.8336%2062.6001%2095.8238%2062.5823%2095.8167C62.4937%2095.7906%2062.4073%2095.7578%2062.3239%2095.7184C62.1868%2095.6209%2062.0436%2095.5322%2061.8951%2095.4528C61.8706%2095.4416%2061.847%2095.4278%2061.8233%2095.4143C61.8109%2095.4054%2061.798%2095.3975%2061.7845%2095.3904C61.6141%2095.3202%2061.4593%2095.2192%2061.2862%2095.1518C61.1989%2095.1179%2061.1128%2095.0697%2061.0243%2095.0296C60.8377%2094.9437%2060.6479%2094.8654%2060.4582%2094.7864L60.1885%2094.677C60.1307%2094.657%2060.0747%2094.6321%2060.0212%2094.6026C59.8454%2094.4967%2059.6532%2094.4204%2059.4523%2094.3767L58.866%2094.1601C58.7612%2094.1322%2058.6584%2094.0975%2058.5583%2094.056C58.437%2094.0044%2058.3111%2093.964%2058.1823%2093.9354C57.9712%2093.8622%2057.7554%2093.8024%2057.5428%2093.7384L57.2234%2093.6375C57.198%2093.6289%2057.1721%2093.6218%2057.1458%2093.6163C57.0073%2093.5858%2056.8571%2093.58%2056.7189%2093.5392C56.5552%2093.4949%2056.4046%2093.4158%2056.2416%2093.37C56.1233%2093.3368%2055.989%2093.3349%2055.8722%2093.2979C55.7554%2093.2609%2055.6545%2093.2093%2055.5401%2093.1823C55.3488%2093.1224%2055.1531%2093.0771%2054.9549%2093.047C54.7833%2093.0222%2054.6144%2092.9816%2054.4504%2092.9256C54.2564%2092.8797%2054.0624%2092.8385%2053.8718%2092.7849C53.7942%2092.7625%2053.7085%2092.7483%2053.6289%2092.7232C53.5841%2092.7139%2053.5388%2092.7076%2053.4931%2092.7043C53.455%2092.7006%2053.4178%2092.6907%2053.3829%2092.6751C53.2393%2092.6346%2053.0911%2092.6107%2052.9452%2092.5783C52.7543%2092.5367%2052.5595%2092.5116%2052.3713%2092.4627C52.364%2092.4602%2052.3566%2092.4583%2052.3491%2092.4569C52.1551%2092.4372%2052.0197%2092.4249%2051.8276%2092.3975C51.6809%2092.3763%2051.4822%2092.2931%2051.3348%2092.2838C51.2677%2092.2796%2051.199%2092.2688%2051.1314%2092.2615C51.0257%2092.2443%2050.9172%2092.2603%2050.821%2092.3074C50.7395%2092.3536%2050.6693%2092.4053%2050.5928%2092.4538C50.554%2092.4793%2050.554%2092.5159%2050.537%2092.5471C50.492%2092.6315%2050.537%2092.724%2050.5917%2092.8169C50.5991%2092.8273%2050.6079%2092.8368%2050.6177%2092.845C50.706%2092.9181%2050.8041%2092.9786%2050.9091%2093.025C50.9716%2093.0506%2051.0367%2093.0699%2051.1031%2093.0824C51.3247%2093.1383%2051.5498%2093.1838%2051.7756%2093.2235C51.8808%2093.2416%2052.0593%2093.2374%2052.1637%2093.2516C52.1788%2093.254%2052.1939%2093.254%2052.2087%2093.2574C52.3949%2093.2987%2052.5102%2093.3476%2052.6945%2093.3943C52.7096%2093.3981%2052.7232%2093.4039%2052.7376%2093.4062C52.9143%2093.432%2053.0894%2093.4682%2053.2618%2093.5145C53.4489%2093.549%2053.6378%2093.5731%2053.8276%2093.5866C53.8651%2093.5929%2053.9022%2093.6015%2053.9386%2093.6124C54.0703%2093.6633%2054.2051%2093.7061%2054.3422%2093.7404C54.4927%2093.7613%2054.6413%2093.7944%2054.7865%2093.8394C54.9219%2093.878%2055.0604%2093.9019%2055.1959%2093.9373C55.2902%2093.9624%2055.3868%2093.9647%2055.4818%2093.9882C55.6208%2094.0213%2055.7581%2094.0776%2055.8967%2094.1115C55.9657%2094.1289%2056.0779%2094.132%2056.1458%2094.1451C56.2228%2094.1685%2056.2983%2094.1968%2056.3716%2094.2299L56.6658%2094.3069C56.7531%2094.3328%2056.8454%2094.384%2056.9343%2094.4018C57.0147%2094.4119%2057.0944%2094.4268%2057.1729%2094.4465L57.6107%2094.5621C57.8113%2094.6168%2057.9211%2094.6484%2058.0763%2094.7012C58.1507%2094.7285%2058.2268%2094.7509%2058.3041%2094.7683L58.3914%2094.7922C58.5791%2094.8366%2058.7626%2094.8972%2058.9397%2094.9733L59.0794%2095.0192C59.1521%2095.0399%2059.2231%2095.0657%2059.2921%2095.0963C59.3604%2095.1276%2059.4316%2095.1521%2059.5047%2095.1695C59.8075%2095.2617%2060.1032%2095.3755%2060.3895%2095.5099C60.5195%2095.56%2060.6475%2095.602%2060.7775%2095.6451C61.0452%2095.7607%2061.3055%2095.8926%2061.5567%2096.0402C61.7775%2096.1431%2061.9909%2096.2626%2062.2086%2096.3713C62.2583%2096.3967%2062.3037%2096.431%2062.3526%2096.458C62.5415%2096.5371%2062.7246%2096.6292%2062.9005%2096.7336C63.0592%2096.8569%2063.2385%2096.9648%2063.3852%2097.0674C63.4841%2097.1348%2063.516%2097.1178%2063.5652%2097.1784C63.6738%2097.2679%2063.7918%2097.3455%2063.9172%2097.4096C63.9622%2097.442%2064.0115%2097.4724%2064.0569%2097.4994C64.1143%2097.5358%2064.1789%2097.5596%2064.2463%2097.5692C64.3188%2097.5866%2064.3951%2097.5799%2064.4636%2097.5503C64.4947%2097.5288%2064.5198%2097.4999%2064.5366%2097.4662C64.5534%2097.4325%2064.5614%2097.3952%2064.5598%2097.3576'%20fill='%23121C2D'/%3e%3cpath%20d='M165.566%2072.1716L163.41%2085.2903C163.339%2085.7241%20163.114%2086.1186%20162.777%2086.4033C162.44%2086.688%20162.012%2086.8443%20161.569%2086.8443H153.676C153.213%2086.8444%20152.767%2086.6739%20152.424%2086.3658C152.081%2086.0577%20151.866%2085.634%20151.819%2085.177L150.493%2072.0583C150.467%2071.8007%20150.495%2071.5405%20150.577%2071.2945C150.658%2071.0486%20150.79%2070.8223%20150.965%2070.6303C151.14%2070.4383%20151.354%2070.2848%20151.592%2070.1798C151.83%2070.0748%20152.088%2070.0205%20152.348%2070.0205H163.726C163.996%2070.0205%20164.263%2070.0788%20164.509%2070.1915C164.754%2070.3042%20164.972%2070.4685%20165.147%2070.6732C165.322%2070.8778%20165.45%2071.1178%20165.523%2071.3765C165.595%2071.6352%20165.61%2071.9065%20165.566%2072.1716Z'%20fill='%23F22F46'/%3e%3cpath%20d='M157.825%2047.5641C157.779%2047.6412%20157.75%2047.7274%20157.742%2047.8165C157.736%2047.8374%20157.734%2047.8587%20157.733%2047.8801C157.737%2047.9699%20157.688%2047.9957%20157.706%2048.1087C157.712%2048.193%20157.709%2048.2777%20157.698%2048.3615C157.698%2048.3731%20157.698%2048.3858%20157.698%2048.3962C157.678%2048.6465%20157.671%2048.8976%20157.679%2049.1485C157.679%2049.1605%20157.679%2049.1724%20157.679%2049.1832C157.656%2049.453%20157.681%2049.7336%20157.659%2050.0042C157.657%2050.0385%20157.657%2050.0728%20157.659%2050.1071C157.665%2050.2792%20157.662%2050.4515%20157.649%2050.6232C157.645%2050.6624%20157.645%2050.7018%20157.646%2050.7411C157.656%2050.8952%20157.656%2051.0496%20157.646%2051.2036C157.643%2051.2316%20157.643%2051.2597%20157.646%2051.2877C157.668%2051.4216%20157.681%2051.557%20157.685%2051.6927C157.675%2051.9625%20157.641%2052.1703%20157.646%2052.4405C157.646%2052.479%20157.646%2052.5206%20157.646%2052.5607C157.646%2052.5835%20157.641%2052.6077%20157.642%2052.6289C157.659%2052.9014%20157.629%2053.1739%20157.645%2053.4487C157.652%2053.5871%20157.641%2053.7343%20157.641%2053.8777C157.641%2054.183%20157.641%2054.4886%20157.641%2054.7939C157.641%2054.9376%20157.641%2055.0822%20157.641%2055.2259C157.645%2055.3168%20157.643%2055.4079%20157.634%2055.4984C157.599%2055.8008%20157.596%2056.1062%20157.626%2056.4092C157.626%2056.7198%20157.622%2057.0297%20157.615%2057.34C157.612%2057.5007%20157.635%2057.6738%20157.615%2057.8241C157.603%2058.0202%20157.603%2058.2169%20157.615%2058.413C157.607%2058.746%20157.615%2059.079%20157.612%2059.4117C157.612%2059.5789%20157.609%2059.7451%20157.604%2059.9127C157.604%2059.9513%20157.604%2059.9936%20157.604%2060.0333C157.611%2060.2453%20157.647%2060.4631%20157.646%2060.6759C157.646%2060.9295%20157.605%2061.1769%20157.601%2061.4305C157.597%2061.6151%20157.63%2061.8098%20157.621%2061.9929C157.613%2062.1759%20157.585%2062.3397%20157.586%2062.5178C157.589%2062.8173%20157.556%2063.1345%20157.586%2063.4166C157.601%2063.676%20157.598%2063.9361%20157.578%2064.1952C157.574%2064.4931%20157.574%2064.7914%20157.561%2065.0878C157.555%2065.2115%20157.558%2065.3387%20157.55%2065.4636C157.547%2065.5022%20157.555%2065.632%20157.559%2065.669C157.563%2065.726%20157.561%2065.7833%20157.552%2065.8398C157.54%2066.0629%20157.547%2066.2888%20157.544%2066.5127C157.539%2066.8068%20157.554%2067.1005%20157.541%2067.3934C157.54%2067.4047%20157.54%2067.4161%20157.541%2067.4274C157.56%2067.7199%20157.574%2067.9226%20157.584%2068.2148C157.591%2068.4379%20157.545%2068.7544%20157.563%2068.976C157.572%2069.0758%20157.574%2069.1814%20157.58%2069.2843C157.581%2069.4401%20157.617%2069.5937%20157.687%2069.7334C157.75%2069.8409%20157.816%2069.9303%20157.881%2070.0297C157.915%2070.0814%20157.952%2070.0683%20157.987%2070.0852C158.082%2070.1284%20158.168%2070.0344%20158.253%2069.9288C158.263%2069.9137%20158.271%2069.8977%20158.277%2069.881C158.336%2069.7249%20158.379%2069.5632%20158.405%2069.3984C158.419%2069.298%20158.426%2069.1966%20158.426%2069.0951C158.44%2068.7509%20158.443%2068.4036%20158.44%2068.0568C158.44%2067.8956%20158.398%2067.6328%20158.392%2067.4713C158.392%2067.4486%20158.388%2067.4254%20158.388%2067.4031C158.394%2067.1148%20158.42%2066.929%20158.43%2066.6411C158.43%2066.6183%20158.434%2066.5956%20158.433%2066.574C158.422%2066.3042%20158.426%2066.0344%20158.436%2065.7646C158.448%2065.4366%20158.4%2065.2308%20158.39%2064.9028C158.387%2064.845%20158.39%2064.7891%20158.39%2064.7309C158.398%2064.5586%20158.442%2064.2638%20158.43%2064.0903C158.418%2063.86%20158.418%2063.6292%20158.43%2063.3989C158.439%2063.1842%20158.43%2062.9722%20158.433%2062.7595C158.436%2062.6103%20158.415%2062.4673%20158.415%2062.3178C158.415%2062.1008%20158.437%2061.8768%20158.437%2061.6602C158.437%2061.5508%20158.412%2061.385%20158.407%2061.2802C158.4%2061.1414%20158.429%2061.0489%20158.433%2060.9148C158.435%2060.8173%20158.433%2060.5475%20158.433%2060.4496C158.433%2060.3112%20158.461%2060.1548%20158.454%2060.0164C158.443%2059.8268%20158.432%2059.8379%20158.43%2059.6475C158.43%2059.4163%20158.422%2059.185%20158.418%2058.9538C158.413%2058.6362%20158.41%2058.4589%20158.413%2058.2107C158.413%2058.0897%20158.416%2057.9679%20158.407%2057.848C158.404%2057.8033%20158.407%2057.7547%20158.402%2057.7104C158.385%2057.4162%20158.382%2057.1214%20158.395%2056.827C158.395%2056.7499%20158.393%2056.6767%20158.391%2056.6019C158.389%2056.4863%20158.383%2056.373%20158.391%2056.255C158.396%2056.1401%20158.394%2056.025%20158.384%2055.9105C158.345%2055.3709%20158.374%2054.9415%20158.368%2054.4574C158.364%2054.2443%20158.348%2054.0381%20158.334%2053.8295C158.305%2053.3859%20158.362%2052.9388%20158.355%2052.4883C158.35%2052.1132%20158.352%2051.7371%20158.342%2051.3624C158.339%2051.2769%20158.347%2051.1894%20158.345%2051.1034C158.343%2050.7627%20158.281%2050.4972%20158.3%2050.1614C158.317%2049.8531%20158.314%2049.5317%20158.313%2049.2534C158.298%2049.1453%20158.294%2049.0361%20158.301%2048.9273C158.312%2048.7102%20158.305%2048.4926%20158.28%2048.2767C158.28%2048.1912%20158.274%2048.1029%20158.265%2048.0212C158.258%2047.9201%20158.236%2047.8207%20158.199%2047.7263C158.151%2047.6192%20158.104%2047.5124%20158.044%2047.4897C158.004%2047.4756%20157.961%2047.4753%20157.921%2047.4888C157.881%2047.5023%20157.847%2047.5288%20157.825%2047.5641Z'%20fill='%23121C2D'/%3e%3cpath%20d='M151.075%2054.7404C151.069%2054.783%20151.078%2054.8265%20151.101%2054.8629C151.105%2054.8699%20151.109%2054.8795%20151.115%2054.8837C151.145%2054.9007%20151.124%2054.945%20151.168%2054.9558C151.2%2054.9639%20151.216%2054.9967%20151.239%2055.019C151.243%2055.0215%20151.246%2055.0243%20151.249%2055.0275C151.311%2055.0986%20151.384%2055.1602%20151.464%2055.2102C151.468%2055.2125%20151.471%2055.2151%20151.474%2055.2179C151.542%2055.295%20151.641%2055.3385%20151.71%2055.416C151.719%2055.4247%20151.73%2055.4319%20151.742%2055.4372C151.798%2055.4706%20151.848%2055.5117%20151.892%2055.5594C151.902%2055.5708%20151.913%2055.5805%20151.926%2055.5879C151.978%2055.6145%20152.025%2055.6494%20152.066%2055.6912C152.072%2055.6998%20152.081%2055.7065%20152.091%2055.7105C152.142%2055.7208%20152.192%2055.7401%20152.237%2055.7675C152.299%2055.8376%20152.368%2055.9021%20152.441%2055.9602C152.454%2055.9686%20152.466%2055.9781%20152.477%2055.9884C152.483%2055.9938%20152.488%2056.0026%20152.495%2056.0061C152.588%2056.0527%20152.651%2056.1368%20152.745%2056.1846C152.79%2056.2136%20152.833%2056.2458%20152.874%2056.2809L153.154%2056.4798L153.286%2056.5734C153.315%2056.5908%20153.341%2056.6128%20153.363%2056.6386C153.469%2056.7966%20153.545%2056.7762%20153.635%2056.8436C153.726%2056.9111%20153.823%2056.9801%20153.914%2057.0533C153.96%2057.0918%20154.027%2057.1096%20154.062%2057.1578C154.116%2057.2321%20154.185%2057.2387%20154.242%2057.2846C154.339%2057.3616%20154.446%2057.4283%20154.547%2057.5019C154.598%2057.5386%20154.648%2057.5759%20154.696%2057.6176C154.708%2057.6274%20154.721%2057.6361%20154.734%2057.6434C154.81%2057.6737%20154.884%2057.708%20154.956%2057.7463C155.034%2057.8018%20155.088%2057.8862%20155.163%2057.944C155.218%2057.986%20155.297%2058.0011%20155.348%2058.0465C155.392%2058.0963%20155.44%2058.1431%20155.49%2058.1865C155.574%2058.2615%20155.668%2058.325%20155.769%2058.3753C155.873%2058.4085%20155.927%2058.4909%20156.006%2058.5464C156.095%2058.6127%20156.188%2058.6744%20156.273%2058.7484C156.308%2058.7789%20156.35%2058.8031%20156.383%2058.8363C156.404%2058.8509%20156.428%2058.8628%20156.452%2058.8717C156.484%2058.8829%20156.477%2058.8914%20156.501%2058.9134C156.564%2058.9696%20156.638%2059.0117%20156.706%2059.061C156.795%2059.1257%20156.895%2059.1766%20156.978%2059.2468C156.981%2059.2495%20156.984%2059.2537%20156.987%2059.2552C157.09%2059.3003%20157.161%2059.3323%20157.257%2059.3836C157.331%2059.4241%20157.403%2059.5289%20157.483%2059.5582C157.519%2059.5717%20157.554%2059.5917%20157.589%2059.6079C157.62%2059.6232%20157.654%2059.6315%20157.688%2059.6321C157.723%2059.6328%20157.757%2059.6258%20157.788%2059.6118C157.857%2059.5821%20157.921%2059.5451%20157.988%2059.5119C158.023%2059.4946%20158.04%2059.4614%20158.066%2059.4348C158.124%2059.3628%20158.158%2059.2746%20158.164%2059.1824C158.165%2059.1727%20158.165%2059.1628%20158.164%2059.1531C158.152%2059.0805%20158.125%2059.0109%20158.086%2058.9481C158.064%2058.9167%20158.036%2058.8896%20158.004%2058.8683C157.904%2058.7866%20157.799%2058.7115%20157.689%2058.6436C157.638%2058.6116%20157.533%2058.5908%20157.48%2058.5626C157.472%2058.5593%20157.465%2058.5555%20157.457%2058.5511C157.371%2058.4871%20157.328%2058.4262%20157.245%2058.3584C157.239%2058.3521%20157.233%2058.3465%20157.226%2058.3418C157.137%2058.2938%20157.053%2058.2365%20156.977%2058.171C156.884%2058.114%20156.786%2058.0666%20156.684%2058.0296C156.666%2058.0189%20156.648%2058.006%20156.632%2057.991C156.584%2057.9483%20156.516%2057.8504%20156.458%2057.8234C156.381%2057.7854%20156.309%2057.7366%20156.245%2057.6785C156.184%2057.6264%20156.114%2057.5894%20156.051%2057.5416C156.006%2057.5085%20155.951%2057.4954%20155.905%2057.4645C155.838%2057.4183%20155.782%2057.3535%20155.715%2057.3104C155.672%2057.2893%20155.627%2057.2707%20155.582%2057.2545C155.535%2057.231%20155.524%2057.1878%20155.484%2057.1562C155.456%2057.1335%20155.371%2057.0791%20155.342%2057.0575C155.3%2057.0267%20155.268%2056.972%20155.221%2056.9485C155.177%2056.9327%20155.135%2056.9127%20155.095%2056.8887L154.876%2056.7511C154.776%2056.6883%20154.721%2056.6517%20154.647%2056.597C154.612%2056.5682%20154.574%2056.5437%20154.533%2056.5237C154.518%2056.5168%20154.504%2056.5045%20154.488%2056.4979C154.389%2056.4498%20154.298%2056.3879%20154.216%2056.3141L154.146%2056.269C154.108%2056.2485%20154.073%2056.2239%20154.04%2056.1957C154.008%2056.167%20153.971%2056.1439%20153.931%2056.1275C153.772%2056.0412%20153.621%2055.9404%20153.481%2055.8265C153.413%2055.7853%20153.343%2055.7487%20153.271%2055.717C153.133%2055.6234%20153.002%2055.5204%20152.878%2055.4087C152.762%2055.3316%20152.649%2055.2476%20152.529%2055.1736C152.502%2055.1566%20152.48%2055.1316%20152.452%2055.1131C152.348%2055.0402%20152.231%2055.0317%20152.141%2054.9423C152.059%2054.8649%20151.97%2054.7943%20151.877%2054.7311C151.82%2054.6926%20151.793%2054.7122%20151.772%2054.6687C151.736%2054.597%20151.63%2054.5893%20151.564%2054.5411C151.538%2054.5225%20151.509%2054.5072%20151.479%2054.4956C151.439%2054.4784%20151.394%2054.474%20151.351%2054.4829C151.29%2054.4907%20151.233%2054.5156%20151.187%2054.5546C151.133%2054.6066%20151.095%2054.6728%20151.077%2054.7454'%20fill='%23121C2D'/%3e%3cpath%20d='M166.287%2060.2962C166.254%2060.2683%20166.212%2060.2528%20166.169%2060.2523C166.16%2060.2504%20166.152%2060.2504%20166.143%2060.2523C166.113%2060.2677%20166.086%2060.2265%20166.053%2060.2577C166.029%2060.2804%20165.992%2060.2762%20165.961%2060.2835C165.957%2060.2853%20165.953%2060.2866%20165.949%2060.2874C165.855%2060.302%20165.763%2060.3297%20165.677%2060.3695C165.673%2060.3713%20165.669%2060.3727%20165.665%2060.3737C165.561%2060.3884%20165.471%2060.4477%20165.368%2060.4627C165.356%2060.4662%20165.344%2060.4714%20165.332%2060.4782C165.274%2060.5063%20165.211%2060.5256%20165.147%2060.5356C165.132%2060.537%20165.117%2060.5412%20165.104%2060.5479C165.053%2060.5763%20164.997%2060.5962%20164.94%2060.6069C164.929%2060.6077%20164.919%2060.6113%20164.91%2060.6173C164.872%2060.6547%20164.829%2060.6853%20164.781%2060.7075C164.686%2060.7198%20164.593%2060.7402%20164.503%2060.7684C164.489%2060.774%20164.474%2060.7785%20164.46%2060.7819C164.451%2060.7828%20164.442%2060.7846%20164.434%2060.7873C164.343%2060.8378%20164.237%2060.8443%20164.144%2060.8933C164.094%2060.914%20164.042%2060.9311%20163.989%2060.9445L163.665%2061.0601L163.509%2061.1145C163.478%2061.1291%20163.445%2061.1383%20163.41%2061.1415C163.22%2061.1372%20163.192%2061.2097%20163.083%2061.2455C162.974%2061.2814%20162.861%2061.3188%20162.748%2061.35C162.694%2061.3769%20162.636%2061.3964%20162.576%2061.4082C162.483%2061.4082%20162.437%2061.4602%20162.366%2061.4791C162.244%2061.5119%20162.128%2061.5562%20162.008%2061.5947C161.948%2061.6132%20161.888%2061.6314%20161.827%2061.646C161.812%2061.6498%20161.798%2061.6548%20161.784%2061.661C161.714%2061.7037%20161.642%2061.7423%20161.567%2061.7767C161.476%2061.8048%20161.373%2061.7971%20161.283%2061.8225C161.216%2061.8414%20161.156%2061.8942%20161.089%2061.9073C161.022%2061.9118%20160.956%2061.9209%20160.89%2061.9347C160.779%2061.9559%20160.671%2061.991%20160.568%2062.0391C160.48%2062.0822%20160.384%2062.1095%20160.286%2062.1197C160.178%2062.1501%20160.071%2062.1833%20159.961%2062.2037C159.915%2062.2122%20159.869%2062.2295%20159.822%2062.2349C159.797%2062.2427%20159.773%2062.2535%20159.751%2062.2669C159.723%2062.2846%20159.72%2062.2742%20159.688%2062.2796C159.604%2062.2931%20159.525%2062.3243%20159.443%2062.3455C159.336%2062.3737%20159.235%2062.4203%20159.126%2062.4396C159.122%2062.4396%20159.117%2062.4404%20159.113%2062.4419C159.013%2062.4916%20158.944%2062.5267%20158.842%2062.5675C158.747%2062.5829%20158.653%2062.6037%20158.561%2062.63C158.527%2062.6489%20158.49%2062.662%20158.455%2062.6786C158.423%2062.6923%20158.395%2062.7129%20158.372%2062.7389C158.349%2062.7649%20158.332%2062.7957%20158.323%2062.8289C158.302%2062.9006%20158.289%2062.973%20158.271%2063.0451C158.267%2063.0811%20158.271%2063.1174%20158.281%2063.1522C158.299%2063.243%20158.345%2063.3258%20158.413%2063.3889C158.42%2063.3958%20158.428%2063.4018%20158.437%2063.4066C158.502%2063.4434%20158.574%2063.4672%20158.649%2063.4768C158.688%2063.4796%20158.727%2063.4754%20158.765%2063.4644C158.894%2063.44%20159.022%2063.4066%20159.146%2063.3646C159.204%2063.3453%20159.288%2063.2783%20159.345%2063.2551C159.353%2063.2511%20159.361%2063.2476%20159.369%2063.2447C159.475%2063.2185%20159.55%2063.2224%20159.658%2063.2004C159.666%2063.1997%20159.675%2063.1983%20159.683%2063.1962C159.778%2063.157%20159.877%2063.1277%20159.978%2063.1087C160.082%2063.0719%20160.182%2063.0245%20160.277%2062.9672C160.297%2062.959%20160.318%2062.953%20160.339%2062.9495C160.421%2062.9482%20160.503%2062.9368%20160.583%2062.9156C160.662%2062.8776%20160.746%2062.8509%20160.833%2062.8362C160.913%2062.82%20160.988%2062.7869%20161.066%2062.7653C161.121%2062.7499%20161.166%2062.7132%20161.221%2062.6963C161.299%2062.672%20161.387%2062.6658%20161.465%2062.6404C161.509%2062.6184%20161.552%2062.5939%20161.593%2062.5672C161.641%2062.544%20161.682%2062.5606%20161.733%2062.5483C161.769%2062.5394%20161.865%2062.5036%20161.9%2062.4935C161.955%2062.4875%20162.01%2062.4768%20162.063%2062.4616C162.103%2062.4354%20162.145%2062.4132%20162.188%2062.3953L162.433%2062.3008C162.546%2062.2577%20162.609%2062.2334%20162.699%2062.206C162.743%2062.1943%20162.786%2062.1777%20162.827%2062.1563C162.842%2062.1478%20162.861%2062.144%20162.875%2062.1351C162.975%2062.0827%20163.08%2062.0438%20163.19%2062.0195L163.268%2061.9879C163.307%2061.9689%20163.348%2061.9543%20163.391%2061.9443C163.434%2061.9348%20163.475%2061.9179%20163.512%2061.8946C163.677%2061.8139%20163.85%2061.7478%20164.027%2061.6973C164.1%2061.6652%20164.171%2061.6281%20164.24%2061.5863C164.398%2061.5261%20164.561%2061.4757%20164.726%2061.4352C164.857%2061.3816%20164.992%2061.3357%20165.122%2061.2771C165.152%2061.2637%20165.185%2061.259%20165.216%2061.2471C165.336%2061.2001%20165.41%2061.1079%20165.535%2061.0817C165.647%2061.0545%20165.756%2061.0186%20165.862%2060.9742C165.927%2060.9488%20165.925%2060.9148%20165.974%2060.9202C166.054%2060.9291%20166.12%2060.8432%20166.197%2060.8135C166.227%2060.8013%20166.256%2060.7853%20166.282%2060.7661C166.319%2060.7416%20166.347%2060.7063%20166.363%2060.6651C166.389%2060.61%20166.399%2060.5486%20166.391%2060.4882C166.375%2060.4154%20166.339%2060.3485%20166.287%2060.2955'%20fill='%23121C2D'/%3e%3cpath%20d='M152.156%2043.7183C152.209%2043.5909%20152.244%2043.4566%20152.259%2043.3194C152.263%2043.287%20152.273%2043.2512%20152.278%2043.22C152.313%2043.1039%20152.34%2042.9856%20152.359%2042.8658C152.372%2042.7324%20152.403%2042.6013%20152.452%2042.4765C152.457%2042.4591%20152.462%2042.4402%20152.467%2042.4241C152.496%2042.3316%20152.526%2042.2383%20152.557%2042.145L152.664%2041.8687C152.731%2041.6813%20152.81%2041.4988%20152.903%2041.3225L152.926%2041.2736C153.025%2041.0851%20153.154%2040.9093%20153.261%2040.7212C153.384%2040.544%20153.517%2040.3742%20153.661%2040.2129C153.697%2040.1774%20153.733%2040.1327%20153.769%2040.0922C153.945%2039.8866%20154.142%2039.6996%20154.357%2039.5341C154.404%2039.4925%20154.455%2039.4659%20154.506%2039.4227L154.795%2039.2004C154.895%2039.1314%20155.004%2039.0751%20155.109%2039.0154C155.148%2038.9951%20155.186%2038.9725%20155.223%2038.9475C155.399%2038.8274%20155.585%2038.7206%20155.778%2038.628C155.981%2038.5613%20156.161%2038.502%20156.342%2038.4526C156.528%2038.4176%20156.71%2038.3686%20156.918%2038.3251L157.106%2038.2985C157.141%2038.2938%20157.179%2038.2923%20157.212%2038.2865C157.639%2038.2253%20158.071%2038.2124%20158.5%2038.248C158.724%2038.2692%20158.947%2038.3022%20159.168%2038.3466C159.402%2038.3986%20159.633%2038.4638%20159.86%2038.5421L160.199%2038.6642L160.525%2038.8184C160.729%2038.917%20160.926%2039.0285%20161.116%2039.1522C161.236%2039.229%20161.35%2039.3145%20161.458%2039.4081C161.814%2039.7221%20162.15%2040.0585%20162.463%2040.4152C162.762%2040.798%20163.009%2041.218%20163.198%2041.6644C163.3%2041.8942%20163.381%2042.1328%20163.44%2042.3774C163.514%2042.7312%20163.57%2042.9748%20163.615%2043.2762L163.631%2043.6651L163.641%2043.8578L163.631%2044.0506L163.611%2044.4391L163.552%2044.8245C163.534%2044.9531%20163.506%2045.0801%20163.467%2045.2041C163.431%2045.3279%20163.406%2045.455%20163.359%2045.5761L163.294%2045.7526C163.247%2045.9125%20163.191%2046.0696%20163.126%2046.2232C163.068%2046.3809%20162.995%2046.5328%20162.908%2046.6768C162.809%2046.8473%20162.694%2047.0085%20162.565%2047.1582C162.443%2047.3118%20162.312%2047.4589%20162.174%2047.5988C161.985%2047.8218%20161.777%2048.0289%20161.553%2048.2178C161.33%2048.3749%20161.097%2048.5196%20160.857%2048.6514C160.654%2048.7716%20160.442%2048.8769%20160.223%2048.9667C160.001%2049.0476%20159.785%2049.1339%20159.577%2049.2079C159.192%2049.334%20158.79%2049.4011%20158.384%2049.4068L158.035%2049.4222C157.919%2049.4222%20157.802%2049.4103%20157.686%2049.4057C157.455%2049.3943%20157.225%2049.3641%20156.999%2049.3155C156.808%2049.2791%20156.62%2049.2316%20156.435%2049.1732C156.376%2049.1628%20156.184%2049.0985%20156.13%2049.0827C156.045%2049.0567%20155.963%2049.0245%20155.884%2048.9863C155.725%2048.9177%20155.573%2048.8321%20155.415%2048.7605C155.257%2048.6888%20155.115%2048.5851%20154.966%2048.4976C154.776%2048.3746%20154.596%2048.2347%20154.416%2048.0975C154.241%2047.9531%20154.078%2047.7955%20153.928%2047.6261L153.894%2047.5876C153.817%2047.5067%20153.739%2047.4358%20153.672%2047.361L153.487%2047.1347C153.359%2046.9774%20153.242%2046.8107%20153.138%2046.636C153.038%2046.4663%20152.952%2046.2885%20152.881%2046.1045C152.8%2045.9118%20152.747%2045.711%20152.675%2045.556C152.619%2045.4123%20152.583%2045.2535%20152.536%2045.102C152.486%2044.8699%20152.411%2044.644%20152.311%2044.4283C152.241%2044.2645%20152.167%2044.1253%20152.094%2043.9658C152.055%2043.8817%20152.02%2043.9022%20151.983%2043.8756C151.884%2043.8031%20151.806%2043.9596%20151.73%2044.1454C151.722%2044.1728%20151.715%2044.2007%20151.711%2044.229C151.665%2044.5125%20151.657%2044.8006%20151.686%2045.0862C151.711%2045.2648%20151.747%2045.4416%20151.795%2045.6154C151.951%2046.2142%20152.205%2046.7839%20152.544%2047.3024C152.639%2047.4494%20152.746%2047.588%20152.864%2047.7167L153.044%2047.9279L153.215%2048.101L153.3%2048.1889C153.598%2048.5285%20153.932%2048.8367%20154.294%2049.1085C154.327%2049.1328%20154.358%2049.1613%20154.39%2049.1829C154.8%2049.4398%20155.231%2049.6617%20155.679%2049.8462C155.817%2049.8994%20155.943%2049.9445%20156.063%2049.9842C156.186%2050.0158%20156.304%2050.0389%20156.421%2050.0636C156.673%2050.115%20156.927%2050.1524%20157.183%2050.1757C157.284%2050.1924%20157.385%2050.2035%20157.487%2050.2089C157.64%2050.2189%20157.847%2050.2497%20158.056%2050.2594C158.265%2050.2594%20158.476%2050.2594%20158.63%2050.2436L159.244%2050.1441C159.447%2050.1056%20159.647%2050.0497%20159.847%2050.005C160.214%2049.8977%20160.571%2049.7565%20160.912%2049.5833C161.145%2049.4603%20161.371%2049.3238%20161.588%2049.1748L162.068%2048.8345C162.223%2048.7142%20162.369%2048.5808%20162.515%2048.4517C162.66%2048.3226%20162.832%2048.0752%20162.955%2047.9364C163.101%2047.7372%20163.222%2047.6242%20163.368%2047.4311C163.52%2047.1995%20163.658%2046.9592%20163.782%2046.7115C163.837%2046.6009%20163.901%2046.4853%20163.963%2046.3685C164.016%2046.2479%20164.066%2046.1249%20164.105%2046.0077C164.173%2045.7983%20164.228%2045.5854%20164.272%2045.3699C164.324%2045.171%20164.361%2044.9686%20164.383%2044.7644C164.415%2044.5617%20164.432%2044.357%20164.433%2044.1519C164.446%2043.9166%20164.442%2043.6806%20164.421%2043.4458C164.413%2043.2413%20164.39%2043.0375%20164.353%2042.8361C164.327%2042.6225%20164.28%2042.4119%20164.213%2042.2075C164.192%2042.1304%20164.168%2042.0483%20164.146%2041.972C164.009%2041.6544%20163.934%2041.4035%20163.822%2041.1903C163.729%2040.9687%20163.617%2040.7551%20163.488%2040.5517C163.421%2040.4367%20163.348%2040.3252%20163.269%2040.2179C163.142%2040.0583%20163.024%2039.893%20162.893%2039.7342C162.762%2039.5778%20162.62%2039.4306%20162.468%2039.2936C161.835%2038.7125%20161.099%2038.2512%20160.298%2037.9327C159.95%2037.8055%20159.589%2037.7127%20159.222%2037.6556C158.444%2037.5078%20157.645%2037.4959%20156.863%2037.6205C156.208%2037.7422%20155.576%2037.9643%20154.99%2038.2788L154.595%2038.5101C154.471%2038.5831%20154.354%2038.6671%20154.246%2038.761C154.14%2038.8489%20154.035%2038.9306%20153.935%2039.02C153.751%2039.2127%20153.547%2039.3804%20153.353%2039.5981C152.981%2039.9781%20152.665%2040.4079%20152.413%2040.875C152.342%2041.0521%20152.263%2041.2254%20152.174%2041.3942C152.095%2041.5595%20152.03%2041.7314%20151.98%2041.908C151.924%2042.0949%20151.9%2042.2961%20151.849%2042.4796C151.814%2042.6238%20151.793%2042.7706%20151.784%2042.9186C151.758%2043.0886%20151.761%2043.2617%20151.793%2043.4308C151.832%2043.6181%20151.87%2043.7996%20151.929%2043.8374C152.002%2043.8837%20152.078%2043.8509%20152.155%2043.7183'%20fill='%23121C2D'/%3e%3cpath%20d='M146.11%2053.9757C146.16%2053.8908%20146.193%2053.7971%20146.207%2053.6997C146.211%2053.6773%20146.22%2053.6527%20146.223%2053.6311C146.234%2053.5328%20146.287%2053.5104%20146.288%2053.3875C146.294%2053.2945%20146.317%2053.2033%20146.354%2053.1177L146.364%2053.0815C146.406%2052.9535%20146.455%2052.8275%20146.506%2052.7003C146.552%2052.5713%20146.607%2052.4456%20146.67%2052.3241C146.676%2052.3129%20146.681%2052.301%20146.687%2052.2902C146.757%2052.1618%20146.847%2052.0408%20146.919%2051.9109C147.003%2051.7888%20147.096%2051.6728%20147.197%2051.564C147.223%2051.5374%20147.247%2051.5095%20147.271%2051.4804C147.391%2051.3378%20147.527%2051.2097%20147.678%2051.0988C147.71%2051.0711%20147.746%2051.053%20147.78%2051.0218C147.906%2050.9105%20148.045%2050.8163%20148.196%2050.7415C148.223%2050.7285%20148.249%2050.713%20148.273%2050.6953C148.391%2050.6067%20148.517%2050.5292%20148.649%2050.464C148.79%2050.4197%20148.915%2050.3819%20149.041%2050.3503C149.17%2050.3291%20149.295%2050.2975%20149.438%2050.2663L149.567%2050.249C149.591%2050.2459%20149.618%2050.2463%20149.64%2050.2417C150.087%2050.1749%20150.543%2050.189%20150.985%2050.2833C151.308%2050.3526%20151.62%2050.4615%20151.916%2050.6074C152.057%2050.6749%20152.192%2050.7513%20152.323%2050.8364C152.406%2050.8885%20152.484%2050.9481%20152.556%2051.0144C152.908%2051.3852%20153.036%2051.4534%20153.244%2051.7082C153.448%2051.9712%20153.617%2052.2601%20153.745%2052.5673C153.818%2052.7241%20153.873%2052.888%20153.911%2053.0564C153.953%2053.3012%20154.002%2053.4654%20154.031%2053.6731C154.06%2054.0279%20154.045%2054.3849%20153.986%2054.7361C153.955%2054.9107%20153.91%2055.0826%20153.852%2055.2503C153.835%2055.2888%20153.821%2055.3308%20153.808%2055.3709C153.749%2055.5934%20153.664%2055.8083%20153.555%2056.0111C153.486%2056.1281%20153.405%2056.2377%20153.313%2056.3383C153.225%2056.4408%20153.137%2056.5407%20153.039%2056.6355C152.912%2056.7905%20152.771%2056.9342%20152.618%2057.0648C152.458%2057.1743%20152.299%2057.2606%20152.134%2057.3531C151.995%2057.435%20151.849%2057.5061%20151.699%2057.5659C151.547%2057.6199%20151.399%2057.6792%20151.259%2057.7343C150.996%2057.825%20150.72%2057.8701%20150.442%2057.8677C150.283%2057.8798%20150.124%2057.879%20149.966%2057.8654C149.808%2057.8575%20149.651%2057.8357%20149.497%2057.8002C149.367%2057.7748%20149.239%2057.7414%20149.113%2057.7C149.074%2057.6923%20148.942%2057.6507%20148.903%2057.6411C148.845%2057.6246%20148.789%2057.6019%20148.736%2057.5736C148.521%2057.4758%20148.312%2057.3637%20148.111%2057.2379C147.849%2057.0729%20147.611%2056.8726%20147.404%2056.6428C147.397%2056.6333%20147.39%2056.6242%20147.381%2056.6154C147.279%2056.5217%20147.184%2056.4199%20147.098%2056.311C147.008%2056.2049%20146.926%2056.0919%20146.854%2055.9729C146.731%2055.7345%20146.628%2055.487%20146.544%2055.2325C146.502%2055.135%20146.478%2055.0267%20146.443%2054.9242C146.407%2054.7624%20146.344%2054.6078%20146.256%2054.4671L146.046%2054.1483C146.009%2054.0897%20145.973%2054.104%20145.936%2054.0855C145.839%2054.0342%20145.758%2054.1445%20145.68%2054.2805C145.671%2054.3%20145.664%2054.3202%20145.659%2054.341C145.61%2054.5448%20145.592%2054.7548%20145.606%2054.9639C145.619%2055.0942%20145.644%2055.2231%20145.679%2055.3493C145.789%2055.7851%20145.972%2056.1995%20146.22%2056.5754C146.289%2056.6816%20146.368%2056.7811%20146.456%2056.8725C146.538%2056.9681%20146.625%2057.0594%20146.717%2057.1462L146.778%2057.209C146.993%2057.4574%20147.232%2057.6837%20147.492%2057.8843C147.515%2057.9024%20147.537%2057.9228%20147.56%2057.9386C147.859%2058.1232%20148.172%2058.2845%20148.496%2058.4212C148.595%2058.4597%20148.687%2058.4928%20148.774%2058.521C148.863%2058.5433%20148.95%2058.5595%20149.035%2058.5749C149.205%2058.6135%20149.378%2058.6227%20149.588%2058.6474C149.662%2058.6582%20149.733%2058.6678%20149.809%2058.6721C149.919%2058.6805%20150.069%2058.7064%20150.221%2058.716C150.36%2058.7215%20150.499%2058.7188%20150.637%2058.7079L151.082%2058.6335C151.229%2058.605%20151.374%2058.5665%20151.52%2058.5352C151.787%2058.4584%20152.046%2058.3561%20152.293%2058.23C152.462%2058.1393%20152.624%2058.0388%20152.781%2057.929L153.13%2057.6846C153.244%2057.5987%20153.351%2057.5031%20153.456%2057.409C153.561%2057.315%20153.681%2057.1315%20153.77%2057.0298C153.873%2056.8845%20153.967%2056.8074%20154.074%2056.6675C154.185%2056.4996%20154.285%2056.3253%20154.375%2056.1456C154.414%2056.0654%20154.463%2055.9822%20154.51%2055.8982C154.55%2055.8132%20154.585%2055.7259%20154.615%2055.6368C154.693%2055.4029%20154.667%2055.4098%20154.731%2055.1716C154.768%2055.0273%20154.794%2054.8804%20154.809%2054.7322C154.831%2054.5851%20154.843%2054.4366%20154.844%2054.2879C154.852%2054.1172%20154.848%2053.9462%20154.833%2053.776C154.826%2053.6277%20154.81%2053.4801%20154.784%2053.3339C154.766%2053.179%20154.731%2053.0264%20154.681%2052.8787L154.631%2052.7084C154.5%2052.3534%20154.34%2052.0097%20154.153%2051.6808C154.104%2051.5976%20154.051%2051.5171%20153.993%2051.4396L153.721%2051.0896C153.627%2050.9753%20153.523%2050.8692%20153.411%2050.7724C152.949%2050.3567%20152.417%2050.0248%20151.839%2049.7919C151.587%2049.701%20151.326%2049.6364%20151.06%2049.5992C150.498%2049.4936%20149.922%2049.483%20149.357%2049.5679C148.884%2049.6563%20148.428%2049.818%20148.006%2050.047L147.72%2050.2116C147.396%2050.4429%20147.098%2050.7092%20146.833%2051.0056C146.563%2051.2767%20146.333%2051.5857%20146.153%2051.9229C146.106%2052.0519%20146.05%2052.1773%20145.984%2052.2979C145.923%2052.4153%20145.875%2052.5395%20145.843%2052.6679C145.804%2052.8036%20145.791%2052.9489%20145.755%2053.0811C145.73%2053.1848%20145.716%2053.2906%20145.712%2053.3971C145.695%2053.5207%20145.704%2053.6462%20145.737%2053.7664C145.778%2053.9013%20145.819%2054.0308%20145.879%2054.0574C145.953%2054.0901%20146.028%2054.0666%20146.103%2053.9745'%20fill='%23121C2D'/%3e%3cpath%20d='M162.512%2059.4506C162.562%2059.3657%20162.595%2059.272%20162.609%2059.1746C162.613%2059.1523%20162.622%2059.1276%20162.625%2059.106C162.637%2059.0077%20162.689%2058.9854%20162.69%2058.8624C162.697%2058.7695%20162.719%2058.6783%20162.756%2058.5926L162.767%2058.5564C162.809%2058.4284%20162.857%2058.3024%20162.909%2058.1752C162.955%2058.0462%20163.009%2057.9205%20163.073%2057.799C163.078%2057.7879%20163.084%2057.7759%20163.089%2057.7651C163.16%2057.6368%20163.249%2057.5158%20163.322%2057.3859C163.406%2057.2639%20163.499%2057.1479%20163.599%2057.039C163.625%2057.0124%20163.65%2056.9844%20163.673%2056.9554C163.793%2056.8127%20163.93%2056.6846%20164.08%2056.5738C164.113%2056.546%20164.148%2056.5279%20164.183%2056.4967C164.308%2056.3855%20164.448%2056.2914%20164.598%2056.2169C164.625%2056.2037%20164.651%2056.1883%20164.676%2056.1706C164.794%2056.082%20164.919%2056.0046%20165.052%2055.9394C165.193%2055.895%20165.318%2055.8573%20165.444%2055.8257C165.573%2055.8045%20165.698%2055.7729%20165.84%2055.7416L165.97%2055.7243C165.994%2055.7212%20166.02%2055.7216%20166.043%2055.717C166.336%2055.6748%20166.633%2055.6658%20166.929%2055.69C167.413%2055.7333%20167.885%2055.8666%20168.32%2056.0828C168.461%2056.1502%20168.597%2056.2267%20168.727%2056.3117C168.81%2056.3638%20168.888%2056.4234%20168.96%2056.4898C169.312%2056.8605%20169.441%2056.9288%20169.648%2057.1835C169.853%2057.4466%20170.021%2057.7355%20170.149%2058.0426C170.222%2058.1994%20170.277%2058.3633%20170.315%2058.5317C170.357%2058.7761%20170.406%2058.9407%20170.435%2059.1484C170.464%2059.5032%20170.449%2059.8603%20170.391%2060.2114C170.359%2060.386%20170.314%2060.558%20170.256%2060.7256C170.24%2060.7641%20170.225%2060.8061%20170.212%2060.8462C170.153%2061.0688%20170.068%2061.2837%20169.959%2061.4864C169.89%2061.6034%20169.809%2061.713%20169.717%2061.8136C169.63%2061.9162%20169.541%2062.016%20169.443%2062.1108C169.316%2062.2659%20169.175%2062.4095%20169.022%2062.5402C168.862%2062.6496%20168.703%2062.736%20168.538%2062.8285C168.399%2062.9103%20168.253%2062.9814%20168.103%2063.0412C167.951%2063.0952%20167.803%2063.1545%20167.663%2063.2097C167.4%2063.3004%20167.124%2063.3455%20166.846%2063.343C166.687%2063.3552%20166.528%2063.3545%20166.37%2063.3407C166.212%2063.3329%20166.055%2063.3111%20165.901%2063.2756C165.771%2063.2502%20165.643%2063.2167%20165.517%2063.1753C165.479%2063.1676%20165.346%2063.126%20165.308%2063.1164C165.25%2063.0999%20165.194%2063.0772%20165.141%2063.0489C164.925%2062.9512%20164.717%2062.8391%20164.516%2062.7132C164.254%2062.5482%20164.016%2062.3479%20163.809%2062.1181C163.802%2062.1086%20163.794%2062.0995%20163.786%2062.0908C163.683%2061.9971%20163.589%2061.8953%20163.503%2061.7863C163.412%2061.6803%20163.331%2061.5673%20163.259%2061.4483C163.136%2061.2099%20163.032%2060.9623%20162.948%2060.7079C162.907%2060.6103%20162.882%2060.502%20162.848%2060.3995C162.812%2060.2377%20162.749%2060.0832%20162.661%2059.9424L162.45%2059.6237C162.414%2059.5651%20162.377%2059.5793%20162.341%2059.5608C162.244%2059.5096%20162.163%2059.6198%20162.084%2059.7559C162.076%2059.7753%20162.068%2059.7956%20162.063%2059.8164C162.014%2060.0201%20161.996%2060.2301%20162.01%2060.4392C162.024%2060.5695%20162.049%2060.6984%20162.084%2060.8246C162.194%2061.2604%20162.376%2061.6748%20162.624%2062.0507C162.694%2062.1569%20162.773%2062.2564%20162.861%2062.3478C162.943%2062.4434%20163.03%2062.5348%20163.121%2062.6215L163.183%2062.6843C163.397%2062.9327%20163.636%2063.159%20163.896%2063.3596C163.919%2063.3777%20163.941%2063.3981%20163.965%2063.4139C164.264%2063.598%20164.578%2063.7588%20164.902%2063.8949C165.001%2063.9335%20165.093%2063.9666%20165.181%2063.9948C165.27%2064.0171%20165.356%2064.0333%20165.441%2064.0487C165.611%2064.0873%20165.784%2064.0965%20165.994%2064.1216C166.069%2064.132%20166.14%2064.1416%20166.215%2064.1459C166.325%2064.1543%20166.475%2064.1802%20166.627%2064.1898C166.766%2064.1952%20166.905%2064.1925%20167.043%2064.1817L167.488%2064.1073C167.635%2064.0788%20167.78%2064.0402%20167.926%2064.009C168.193%2063.9321%20168.452%2063.8299%20168.699%2063.7038C168.868%2063.6131%20169.031%2063.5126%20169.187%2063.4027L169.536%2063.1584C169.65%2063.0724%20169.757%2062.9769%20169.862%2062.8828C169.967%2062.7888%20170.088%2062.6053%20170.176%2062.5036C170.279%2062.3579%20170.374%2062.2812%20170.48%2062.1413C170.591%2061.9733%20170.691%2061.7991%20170.781%2061.6194C170.82%2061.5392%20170.869%2061.456%20170.916%2061.3716C170.956%2061.2866%20170.991%2061.1993%20171.021%2061.1102C171.099%2060.8763%20171.073%2060.8832%20171.138%2060.645C171.174%2060.5007%20171.2%2060.3538%20171.215%2060.2056C171.237%2060.0585%20171.249%2059.91%20171.25%2059.7612C171.258%2059.5906%20171.254%2059.4196%20171.239%2059.2494C171.232%2059.1011%20171.216%2058.9535%20171.19%2058.8073C171.172%2058.6523%20171.138%2058.4997%20171.087%2058.3521L171.037%2058.1818C170.907%2057.8267%20170.747%2057.483%20170.559%2057.1542C170.51%2057.071%20170.457%2056.9905%20170.399%2056.913L170.127%2056.563C170.033%2056.4487%20169.929%2056.3426%20169.817%2056.2458C169.355%2055.8301%20168.823%2055.4982%20168.245%2055.2653C167.993%2055.1744%20167.732%2055.1098%20167.466%2055.0726C166.904%2054.9669%20166.329%2054.9564%20165.763%2055.0413C165.29%2055.1297%20164.835%2055.2914%20164.412%2055.5204L164.126%2055.685C163.802%2055.9163%20163.505%2056.1826%20163.239%2056.479C162.969%2056.75%20162.739%2057.0591%20162.559%2057.3963C162.512%2057.5253%20162.456%2057.6507%20162.39%2057.7713C162.328%2057.8887%20162.281%2058.0129%20162.249%2058.1413C162.21%2058.277%20162.197%2058.4227%20162.161%2058.5545C162.136%2058.6582%20162.122%2058.764%20162.117%2058.8705C162.101%2058.9941%20162.11%2059.1196%20162.143%2059.2398C162.184%2059.3747%20162.225%2059.5042%20162.285%2059.5308C162.358%2059.5635%20162.434%2059.54%20162.509%2059.4479'%20fill='%23121C2D'/%3e%3cpath%20d='M59.3845%2040.083C59.0906%2039.9646%2058.7896%2039.8645%2058.4831%2039.7835C58.4094%2039.7623%2058.3255%2039.7365%2058.2526%2039.7199C57.9792%2039.6319%2057.7008%2039.5605%2057.4187%2039.506C57.1121%2039.4675%2056.7924%2039.3989%2056.4788%2039.3434L56.3504%2039.3214C55.4201%2039.1504%2054.4804%2039.0345%2053.5363%2038.9745L53.4067%2038.9622C52.8995%2038.9213%2052.3803%2038.9167%2051.8618%2038.8986L51.0857%2038.8774L50.3162%2038.8909L49.9282%2038.9044L48.9519%2038.9352L47.9887%2039.0034C47.8397%2039.0127%2047.7051%2039.0215%2047.5456%2039.0373C47.2573%2039.0682%2046.9662%2039.0863%2046.6775%2039.121L45.8126%2039.2273C45.7043%2039.2397%2045.6026%2039.2509%2045.4998%2039.2678L44.7493%2039.3935L44.0012%2039.5322L42.6143%2039.7519C42.1723%2039.8255%2041.7346%2039.9227%2041.2398%2040.0294L40.7978%2040.1227L40.5479%2040.1728L39.0578%2040.5382C38.5604%2040.6592%2038.0606%2040.7764%2037.5685%2040.9286C37.0765%2041.0809%2036.5371%2041.215%2036.0202%2041.3599C34.9267%2041.6952%2033.8305%2042.0217%2032.7482%2042.3871C32.236%2042.5563%2031.7226%2042.7212%2031.2146%2042.8993C30.8937%2043.0095%2030.555%2043.1305%2030.2496%2043.2246C28.5546%2043.7476%2028.1083%2043.9742%2027.0408%2044.3585L25.4067%2044.9528C24.8472%2045.1514%2024.3001%2045.3831%2023.7684%2045.6466C23.1961%2045.9375%2022.6697%2046.31%2022.2061%2046.7524C21.8949%2047.0485%2021.6491%2047.4056%2021.4844%2047.8011C21.3336%2048.1628%2021.2475%2048.5478%2021.2298%2048.9389C21.2161%2049.5978%2021.3125%2050.2543%2021.515%2050.8818L22.0583%2052.6614C22.2376%2053.2552%2022.4159%2053.8461%2022.5934%2054.4343L22.7249%2054.8629C22.9628%2055.6129%2023.2325%2056.3749%2023.4622%2057.1311L24.2407%2059.8214C24.4382%2060.4766%2024.6799%2061.1588%2024.8708%2061.8098C25.0583%2062.4473%2025.2154%2063.0555%2025.4095%2063.6822C25.7377%2064.7448%2026.0509%2065.8753%2026.3877%2066.8708C26.7172%2067.8433%2026.9473%2068.7132%2027.2259%2069.6347C27.5449%2070.6931%2027.8632%2071.7506%2028.1809%2072.8072C28.3117%2073.2465%2028.4467%2073.6998%2028.5786%2074.1419C28.6174%2074.2787%2028.7676%2074.7393%2028.8115%2074.8696C28.9131%2075.1729%2028.9011%2075.1687%2028.9907%2075.4762C29.2309%2076.2698%2029.4739%2077.0715%2029.7145%2077.8659C30.0303%2078.9096%2030.3629%2079.9472%2030.6694%2080.9905C30.6815%2081.0314%2030.6939%2081.0745%2030.7051%2081.1123L31.6004%2083.8939C31.8499%2084.6844%2032.1514%2085.821%2032.4091%2086.6008L32.7583%2087.6877C32.9207%2088.2202%2033.1167%2088.7421%2033.345%2089.2502C33.5204%2089.6152%2033.6787%2089.9131%2033.8464%2090.2473C33.9341%2090.4211%2033.9546%2090.3668%2034.0051%2090.4146C34.1401%2090.5417%2034.1168%2090.1833%2034.0827%2089.7852C34.0788%2089.7466%2034.0645%2089.6726%2034.0532%2089.6098C33.9678%2089.1442%2033.808%2088.504%2033.6469%2087.8619C33.5647%2087.5354%2033.4424%2087.1392%2033.3365%2086.7792C32.9752%2085.5539%2032.5992%2084.3214%2032.2205%2083.0922C32.0439%2082.5214%2031.7195%2081.5972%2031.5394%2081.0287L31.4618%2080.7866L30.6725%2078.0728C30.6493%2077.9923%2030.6248%2077.9102%2030.6023%2077.8331C30.2977%2076.8761%2030.0086%2075.9187%2029.7238%2074.9567C29.3776%2073.7888%2029.1103%2073.0719%2028.7436%2071.9118C28.6811%2071.706%2028.6209%2071.5083%2028.5585%2071.3017C28.3792%2070.6889%2028.0986%2069.6301%2027.8988%2069.0188C27.6353%2068.2094%2027.3862%2067.3777%2027.1467%2066.5648L26.4541%2064.2947L25.9574%2062.7337C25.7277%2061.9628%2025.4917%2061.1654%2025.262%2060.3941C25.1429%2060.0064%2024.9399%2059.4244%2024.8212%2059.0548C24.6636%2058.5645%2024.5915%2058.2323%2024.4479%2057.7513C24.3415%2057.4044%2024.0486%2056.4489%2023.9434%2056.1009C23.7944%2055.6095%2023.6489%2055.046%2023.4913%2054.5592C23.276%2053.8901%2023.2768%2053.9317%2023.0684%2053.2561L22.3082%2050.8098C22.1641%2050.3664%2022.065%2049.9099%2022.0125%2049.4469C21.9692%2049.0729%2022.0057%2048.694%2022.1196%2048.3349C22.2445%2047.9635%2022.4463%2047.6221%2022.7121%2047.3328C22.8157%2047.2183%2022.9271%2047.1111%2023.0455%2047.0118C23.4735%2046.6512%2023.9521%2046.3542%2024.4661%2046.1303C24.9104%2045.9264%2025.333%2045.7703%2025.8452%2045.5815L26.6318%2045.2897C27.0334%2045.1405%2027.4304%2044.9895%2027.8406%2044.8472C28.2507%2044.705%2028.6555%2044.557%2029.0474%2044.4082C30.9298%2043.6937%2032.4521%2043.2134%2034.1642%2042.6561L36.3877%2041.9461C37.9667%2041.4667%2039.5856%2041.0855%2041.2193%2040.727C41.8999%2040.5806%2042.5774%2040.4187%2043.2666%2040.3081C43.9558%2040.1975%2044.6349%2040.0456%2045.3233%2039.9639L46.2759%2039.8421C46.9007%2039.7454%2047.4606%2039.703%2048.0167%2039.6394L48.8584%2039.5538C49.1443%2039.5276%2049.4404%2039.5295%2049.7509%2039.5218L50.6143%2039.506C50.9026%2039.4987%2051.1909%2039.489%2051.475%2039.506L53.1113%2039.5546C53.7931%2039.5993%2053.8874%2039.59%2054.3143%2039.6478C54.6635%2039.7014%2055.0609%2039.7249%2055.4711%2039.7669C55.8789%2039.8248%2056.3015%2039.8803%2056.7012%2039.9454C57.0116%2040.0013%2057.3379%2040.034%2057.6325%2040.0961C58.0527%2040.1851%2058.4233%2040.2549%2058.7082%2040.2888C59.0023%2040.3436%2059.3018%2040.364%2059.6007%2040.3497C59.7202%2040.3046%2059.6732%2040.2198%2059.3868%2040.0818'%20fill='%23121C2D'/%3e%3cpath%20d='M56.2426%2010.9097C56.0637%2010.5638%2055.8247%2010.252%2055.5367%209.98858C55.4666%209.9187%2055.3925%209.85293%2055.3147%209.79163C55.1405%209.6733%2055.0411%209.57579%2054.9135%209.49793C54.7575%209.38738%2054.589%209.29552%2054.4114%209.22428C54.0531%209.06768%2053.6828%208.94007%2053.3039%208.84271L53.1486%208.80417C52.597%208.67816%2052.0358%208.59797%2051.4707%208.56443C50.9054%208.52589%2050.3477%208.50546%2049.7738%208.50854L49.6186%208.51163C48.3927%208.55151%2047.1718%208.68526%2045.9667%208.9117L45.5169%208.99457C44.761%209.1391%2044.0148%209.28017%2043.2771%209.39194L42.7665%209.47211L41.7614%209.61125C41.4265%209.65981%2041.0893%209.6945%2040.7525%209.71724C40.6256%209.72726%2040.5072%209.73574%2040.3862%209.75077C39.898%209.81976%2039.1107%209.89184%2038.6155%209.91959C37.4289%209.97547%2036.5142%209.96738%2035.3245%2010.0005L34.7936%2010.0075H34.4937C33.2907%2010.0437%2032.0855%2010.0298%2030.8686%2010.0749L28.9671%2010.1416C27.6124%2010.2098%2026.2558%2010.3181%2024.9054%2010.5027C24.5857%2010.5355%2024.2698%2010.6045%2023.9516%2010.6538C23.635%2010.7124%2023.3152%2010.7521%2023.0009%2010.8246C22.6043%2010.9124%2022.186%2011.0115%2021.8096%2011.0836C21.0497%2011.2485%2020.3031%2011.4685%2019.5756%2011.7419L18.7867%2012.0429C18.524%2012.1539%2018.2524%2012.2799%2017.9415%2012.4422C17.276%2012.7682%2016.6909%2013.2359%2016.2279%2013.812C15.9922%2014.1223%2015.8207%2014.4761%2015.7235%2014.8526C15.6305%2015.226%2015.6084%2015.6133%2015.6583%2015.9947C15.7073%2016.3686%2015.7851%2016.7383%2015.8911%2017.1005C15.9858%2017.4504%2016.077%2017.7942%2016.1515%2018.1141C16.3843%2019.1074%2016.5958%2019.7846%2016.8112%2020.6144C17.1824%2022.0294%2017.5532%2023.4435%2017.9237%2024.8568C18.1096%2025.5659%2018.2927%2026.277%2018.5003%2026.9866L18.6618%2027.5008C18.9661%2028.4178%2019.3604%2029.3029%2019.8391%2030.1432C20.3921%2031.1667%2021.1693%2032.0538%2022.1134%2032.7391C22.8289%2033.2237%2023.6115%2033.6024%2024.4367%2033.8634C25.1931%2034.1257%2025.9766%2034.3034%2026.7727%2034.393C28.1239%2034.5324%2029.4877%2034.4956%2030.8294%2034.2835C32.054%2034.0908%2033.1188%2033.9077%2034.2442%2033.6849C35.534%2033.4248%2036.8196%2033.1789%2038.1111%2032.9746C38.6485%2032.8909%2039.2015%2032.7965%2039.7436%2032.7233L40.6384%2032.5811C41.0129%2032.5186%2041.0047%2032.529%2041.3823%2032.4828C42.3575%2032.3591%2043.3427%2032.2338%2044.3233%2032.1301C45.6097%2031.9948%2046.8957%2031.8653%2048.1824%2031.7863L48.3322%2031.7778C49.6155%2031.6765%2050.5053%2031.5998%2051.7909%2031.5647C52.7819%2031.5304%2054.1525%2031.5342%2055.1587%2031.4907C55.6406%2031.4676%2056.1189%2031.3971%2056.5867%2031.2803C57.0131%2031.172%2057.4122%2030.9768%2057.7586%2030.7071C58.0027%2030.5098%2058.2021%2030.2635%2058.3438%2029.9845C58.5587%2029.5566%2058.6462%2029.0767%2058.5961%2028.6012C58.5654%2028.363%2058.5235%2028.4235%2058.4874%2028.3533C58.3756%2028.1737%2058.364%2028.5962%2058.1859%2028.9823C58.1673%2029.0209%2058.1428%2029.0949%2058.1137%2029.1562C57.9996%2029.4179%2057.8388%2029.6569%2057.6391%2029.8619C57.406%2030.0932%2057.1224%2030.268%2056.8102%2030.373C56.4248%2030.5074%2056.0237%2030.5927%2055.6166%2030.627C55.2588%2030.6616%2054.8918%2030.6678%2054.5138%2030.6713L53.3629%2030.699L51.0567%2030.7642C50.3419%2030.7865%2049.1766%2030.896%2048.4661%2030.9503L48.163%2030.9746C46.8883%2031.0621%2046.0645%2031.1076%2044.7944%2031.2259L44.4971%2031.2548C43.3043%2031.392%2042.1169%2031.5335%2040.9271%2031.6903C39.4836%2031.8831%2038.5884%2032.0735%2037.1584%2032.3348L36.4083%2032.4693C35.6563%2032.5965%2034.3637%2032.8139%2033.6194%2032.9761C32.6311%2033.1897%2031.6233%2033.3731%2030.6377%2033.4926C29.7245%2033.6134%2028.8036%2033.6668%2027.8825%2033.6522C27.2538%2033.6422%2026.6267%2033.5835%2026.0071%2033.4768C25.0938%2033.3076%2024.211%2033.0041%2023.3878%2032.5764C22.9152%2032.3391%2022.4697%2032.0518%2022.0591%2031.7196C21.6755%2031.3877%2021.3343%2031.0102%2021.0432%2030.5957C20.8487%2030.3361%2020.6702%2030.0649%2020.5089%2029.7836C20.3121%2029.4514%2020.1453%2029.0991%2020.0576%2028.9107C19.8144%2028.3424%2019.601%2027.7621%2019.4181%2027.172C19.1654%2026.3942%2019.1717%2026.4397%2018.9493%2025.6411L18.1643%2022.7095L17.3284%2019.5533C17.1946%2019.0399%2017.0607%2018.5223%2016.9179%2018.0143L16.7557%2017.435C16.5321%2016.8096%2016.4043%2016.1544%2016.3766%2015.4913C16.3968%2014.9773%2016.5985%2014.4869%2016.9462%2014.1057C17.1437%2013.8801%2017.3673%2013.6785%2017.6125%2013.5052C18.0055%2013.2273%2018.429%2012.9945%2018.8748%2012.8114C19.3292%2012.628%2019.8174%2012.4646%2020.2694%2012.2869C20.8201%2012.0853%2021.3618%2011.9481%2021.876%2011.7897C22.4014%2011.6698%2022.9078%2011.5507%2023.4103%2011.4486C23.9175%2011.3669%2024.4146%2011.2747%2024.9198%2011.2042C25.4274%2011.1468%2025.9361%2011.0716%2026.4642%2011.0223L27.8426%2010.8951L29.212%2010.7972C31.1615%2010.6816%2033.1355%2010.729%2035.1301%2010.6847C36.7901%2010.6461%2038.4599%2010.5933%2040.1204%2010.4484L41.2694%2010.3455C42.0222%2010.2441%2042.6935%2010.1566%2043.3532%2010.0287C44.0129%209.9007%2044.6648%209.76966%2045.3939%209.64324C46.6928%209.39016%2048.0065%209.21933%2049.3272%209.13178C49.7986%209.09855%2050.2718%209.09674%2050.7435%209.12638C51.6783%209.14873%2052.6082%209.26705%2053.5185%209.47943C53.8614%209.57721%2054.1932%209.71026%2054.5084%209.87642C54.8717%2010.0683%2055.2092%2010.3049%2055.513%2010.5806C55.674%2010.7214%2055.827%2010.8709%2055.9713%2011.0285C56.0488%2011.1311%2056.1402%2011.2227%2056.2429%2011.3006C56.3702%2011.3649%2056.3912%2011.2655%2056.2426%2010.9097Z'%20fill='%23121C2D'/%3e%3cpath%20d='M48.525%2038.9128C48.5612%2038.8947%2048.5896%2038.8642%2048.6049%2038.8269C48.6093%2038.8206%2048.612%2038.8133%2048.6127%2038.8057C48.6088%2038.7749%2048.6554%2038.7671%2048.6383%2038.7286C48.6255%2038.7009%2048.6418%2038.6712%2048.6453%2038.6423C48.6453%2038.6384%2048.6453%2038.6342%2048.6453%2038.6303C48.6642%2038.546%2048.6693%2038.4592%2048.6604%2038.3732C48.6599%2038.3693%2048.6599%2038.3653%2048.6604%2038.3613C48.6802%2038.2688%2048.6542%2038.1736%2048.6732%2038.0807C48.6741%2038.0689%2048.6732%2038.0571%2048.6705%2038.0456C48.6636%2037.987%2048.6651%2037.9277%2048.6748%2037.8695C48.6774%2037.8561%2048.6774%2037.8424%2048.6748%2037.829C48.664%2037.777%2048.6625%2037.7235%2048.6701%2037.671C48.6726%2037.6616%2048.6726%2037.6518%2048.6701%2037.6425C48.647%2037.6001%2048.632%2037.5538%2048.6259%2037.506C48.6415%2037.4215%2048.6491%2037.3357%2048.6488%2037.2497C48.6477%2037.236%2048.6477%2037.2222%2048.6488%2037.2085C48.6506%2037.2009%2048.6514%2037.1931%2048.6511%2037.1854C48.6301%2037.0932%2048.655%2036.9988%2048.6332%2036.9063C48.6273%2036.8577%2048.6251%2036.8088%2048.6266%2036.7598L48.6034%2036.448L48.5909%2036.3008C48.5853%2036.27%2048.5853%2036.2384%2048.5909%2036.2075C48.6437%2036.0406%2048.5809%2036.0002%2048.5723%2035.8969C48.5638%2035.7936%2048.5552%2035.6853%2048.5521%2035.5793C48.5521%2035.5246%2048.5215%2035.4679%2048.5347%2035.4151C48.5549%2035.333%2048.5157%2035.2821%2048.5129%2035.2151C48.5091%2035.0994%2048.4877%2034.9892%2048.4761%2034.8763C48.4703%2034.8192%2048.4652%2034.7626%2048.4633%2034.7055C48.4627%2034.6918%2048.4609%2034.6781%2048.4578%2034.6647C48.4311%2034.5951%2048.408%2034.5242%2048.3884%2034.4523C48.3783%2034.3667%2048.4035%2034.2773%2048.3961%2034.191C48.3907%2034.1282%2048.3496%2034.0669%2048.348%2034.0041C48.355%2033.9439%2048.3577%2033.8834%2048.3562%2033.8229C48.3545%2033.7199%2048.3377%2033.6177%2048.3061%2033.5196C48.2775%2033.4347%2048.2653%2033.3453%2048.27%2033.2559C48.2576%2033.1546%2048.2374%2033.0548%2048.2312%2032.9522C48.2289%2032.9098%2048.218%2032.8674%2048.2184%2032.8239C48.2142%2032.8006%2048.2071%2032.7779%2048.1971%2032.7564C48.1835%2032.7291%2048.1936%2032.7275%2048.1928%2032.6975C48.1848%2032.6211%2048.1727%2032.5451%2048.1563%2032.4701C48.1408%2032.3706%2048.1082%2032.2743%2048.0997%2032.1741C48.1002%2032.1701%2048.1002%2032.1661%2048.0997%2032.1621C48.0609%2032.0677%2048.0329%2032.0025%2048.0031%2031.9066C47.9805%2031.8333%2048.0031%2031.7177%2047.9666%2031.648C47.9511%2031.6163%2047.9406%2031.5817%2047.9278%2031.5489C47.9163%2031.519%2047.8982%2031.4921%2047.8747%2031.4702C47.8513%2031.4483%2047.8231%2031.432%2047.7923%2031.4225C47.7252%2031.4001%2047.6554%2031.3839%2047.5871%2031.3666C47.5524%2031.362%2047.5172%2031.3637%2047.4831%2031.3716C47.3946%2031.3844%2047.3119%2031.4224%2047.2448%2031.4811C47.2377%2031.4872%2047.2313%2031.4942%2047.2258%2031.5019C47.1859%2031.5574%2047.1573%2031.6201%2047.1416%2031.6865C47.1354%2031.7207%2047.1362%2031.7559%2047.1439%2031.7898C47.1573%2031.9047%2047.1779%2032.0186%2047.2056%2032.1309C47.2184%2032.1829%2047.2747%2032.2612%2047.2918%2032.3124C47.2948%2032.3194%2047.2973%2032.3266%2047.2991%2032.334C47.3143%2032.4292%2047.2991%2032.4951%2047.3096%2032.5911C47.3089%2032.5987%2047.3089%2032.6063%2047.3096%2032.6138C47.3366%2032.7002%2047.3532%2032.7895%2047.3593%2032.8798C47.381%2032.9748%2047.4132%2033.0671%2047.4555%2033.155C47.4608%2033.1734%2047.4638%2033.1924%2047.4644%2033.2116C47.4551%2033.2837%2047.4543%2033.3567%2047.4621%2033.429C47.4865%2033.5024%2047.4995%2033.5791%2047.5009%2033.6564C47.5044%2033.7285%2047.5246%2033.7967%2047.532%2033.8676C47.5374%2033.9173%2047.5646%2033.9613%2047.5708%2034.0106C47.5813%2034.0823%2047.5708%2034.1594%2047.584%2034.2303C47.5971%2034.2717%2047.6125%2034.3124%2047.6301%2034.3521C47.6433%2034.3968%2047.6197%2034.4292%2047.6224%2034.4762C47.6224%2034.5086%2047.6402%2034.5972%2047.6437%2034.6304C47.6398%2034.6789%2047.6398%2034.7276%2047.6437%2034.7761C47.6607%2034.8144%2047.6737%2034.8543%2047.6825%2034.8952L47.7213%2035.1229C47.7368%2035.2044%2047.7476%2035.2866%2047.7539%2035.3692C47.7551%2035.4098%2047.7614%2035.4501%2047.7726%2035.4891C47.7772%2035.5037%2047.7768%2035.5195%2047.7823%2035.5342C47.8101%2035.6293%2047.8224%2035.7282%2047.8187%2035.8271L47.8296%2035.9015C47.8382%2035.9394%2047.8422%2035.9783%2047.8416%2036.0171C47.8403%2036.0564%2047.8463%2036.0957%2047.8595%2036.1328C47.8939%2036.2915%2047.9122%2036.4533%2047.9142%2036.6157C47.9243%2036.6858%2047.9396%2036.7552%2047.96%2036.8231C47.9745%2036.9723%2047.9763%2037.1225%2047.9654%2037.2721L47.9965%2037.6475C47.9999%2037.676%2047.9941%2037.7053%2047.9965%2037.7346C48.0034%2037.8483%2048.0675%2037.935%2048.0516%2038.0483C48.0407%2038.1493%2048.0387%2038.2511%2048.0457%2038.3524C48.0481%2038.4145%2048.0803%2038.4222%2048.0593%2038.4615C48.0248%2038.5259%2048.0803%2038.6057%2048.0822%2038.6793C48.083%2038.7083%2048.0877%2038.7371%2048.0962%2038.7648C48.107%2038.8035%2048.1296%2038.8379%2048.161%2038.8631C48.2034%2038.9027%2048.2558%2038.9302%2048.3127%2038.9425C48.3842%2038.9531%2048.4573%2038.9443%2048.5242%2038.9171'%20fill='%23121C2D'/%3e%3cpath%20d='M42.2945%2039.9604C42.3299%2039.9421%2042.3575%2039.9117%2042.3722%2039.8749C42.3766%2039.8686%2042.3792%2039.8613%2042.3799%2039.8537C42.3756%2039.8232%2042.4218%2039.8151%2042.4044%2039.7766C42.3916%2039.7492%2042.4075%2039.7199%2042.411%2039.691C42.4106%2039.6872%2042.4106%2039.6833%2042.411%2039.6795C42.4293%2039.5961%2042.4333%2039.5102%2042.423%2039.4255C42.4224%2039.4215%2042.4224%2039.4175%2042.423%2039.4135C42.4408%2039.3218%2042.4133%2039.2285%2042.4308%2039.136C42.4316%2039.1243%2042.4304%2039.1126%2042.4273%2039.1013C42.4193%2039.0435%2042.4193%2038.9849%2042.4273%2038.9271C42.4299%2038.9144%2042.4299%2038.9013%2042.4273%2038.8886C42.4154%2038.8373%2042.4125%2038.7843%2042.4187%2038.7321C42.4214%2038.7228%2042.4214%2038.7129%2042.4187%2038.7036C42.3946%2038.6625%2042.3784%2038.6172%2042.371%2038.5702C42.3839%2038.4862%2042.3889%2038.4011%2042.3857%2038.3162C42.3846%2038.3027%2042.3846%2038.2892%2042.3857%2038.2757C42.3866%2038.2681%2042.3866%2038.2603%2042.3857%2038.2526C42.3617%2038.1624%2042.3834%2038.068%2042.3578%2037.977C42.3498%2037.9294%2042.3457%2037.8812%2042.3454%2037.8329C42.3337%2037.7304%2042.3237%2037.6278%2042.3085%2037.5245L42.2891%2037.38C42.2818%2037.3498%2042.2803%2037.3186%2042.2845%2037.2879C42.3291%2037.1202%2042.2635%2037.0836%2042.2499%2036.9819C42.2363%2036.8801%2042.2208%2036.7741%2042.2111%2036.6697C42.2057%2036.6153%2042.1723%2036.5614%2042.1832%2036.5086C42.1983%2036.4261%2042.156%2036.3779%2042.149%2036.3124C42.1385%2036.1998%2042.1102%2036.0908%2042.0897%2035.9798C42.0796%2035.9243%2042.0706%2035.8688%2042.0652%2035.8125C42.0636%2035.7994%2042.0607%2035.7865%2042.0567%2035.7739C42.0361%2035.7049%2041.9849%2035.6406%2041.9713%2035.57C41.9546%2035.486%2041.9713%2035.3962%2041.9589%2035.3114C41.9492%2035.2494%2041.9026%2035.1927%2041.8956%2035.131C41.8972%2035.0708%2041.8943%2035.0105%2041.8867%2034.9507C41.8764%2034.849%2041.8502%2034.7495%2041.8091%2034.6558C41.7729%2034.5748%2041.7525%2034.4877%2041.7489%2034.3991C41.7276%2034.3005%2041.6969%2034.2041%2041.6818%2034.1035C41.6756%2034.0619%2041.6605%2034.021%2041.6566%2033.9786C41.6501%2033.956%2041.6406%2033.9343%2041.6283%2033.9143C41.6124%2033.8884%2041.6224%2033.8861%2041.6182%2033.8568C41.6021%2033.7823%2041.5819%2033.7087%2041.5576%2033.6364C41.5313%2033.54%2041.489%2033.4491%2041.4696%2033.3508C41.4693%2033.3468%2041.4685%2033.3429%2041.4672%2033.3392C41.418%2033.2506%2041.383%2033.19%2041.3427%2033.0995C41.3116%2033.0301%2041.3198%2032.9133%2041.2759%2032.8497C41.2561%2032.8208%2041.2418%2032.7877%2041.2251%2032.7572C41.2101%2032.7292%2041.1888%2032.7049%2041.1629%2032.6862C41.1371%2032.6676%2041.1072%2032.6551%2041.0757%2032.6497C41.0058%2032.6362%2040.9356%2032.6304%2040.8658%2032.6212C40.8308%2032.6213%2040.7962%2032.6274%2040.7633%2032.6393C40.6775%2032.6633%2040.6002%2032.711%2040.5406%2032.7769C40.5342%2032.7838%2040.5287%2032.7914%2040.5243%2032.7996C40.4912%2032.8585%2040.4703%2032.9234%2040.4626%2032.9904C40.4606%2033.0243%2040.4656%2033.0583%2040.4773%2033.0902C40.5041%2033.2%2040.5374%2033.3081%2040.5771%2033.414C40.5953%2033.4633%2040.6601%2033.5323%2040.6826%2033.5801C40.6865%2033.5865%2040.6899%2033.5932%2040.6927%2033.6001C40.7175%2033.6911%2040.7105%2033.757%2040.7315%2033.8495C40.7319%2033.8569%2040.733%2033.8643%2040.735%2033.8715C40.7711%2033.9523%2040.7972%2034.0372%2040.8126%2034.1243C40.832%2034.2303%2040.8941%2034.2816%2040.9348%2034.3814C40.9417%2034.3989%2040.9464%2034.4171%2040.9488%2034.4357C40.9465%2034.5067%2040.9525%2034.5777%2040.9666%2034.6473C40.9974%2034.7165%2041.0171%2034.7899%2041.0252%2034.8651C41.0353%2034.9353%2041.0613%2034.9996%2041.0745%2035.0678C41.0838%2035.1156%2041.1133%2035.1561%2041.1261%2035.2035C41.1424%2035.2725%2041.1397%2035.348%2041.1568%2035.4166C41.1731%2035.4561%2041.1915%2035.4947%2041.2119%2035.5323C41.2286%2035.5751%2041.2076%2035.6094%2041.2119%2035.6541C41.2162%2035.6861%2041.2391%2035.7697%2041.2445%2035.8025C41.2441%2035.85%2041.2472%2035.8976%2041.2538%2035.9447C41.2729%2035.9809%2041.2881%2036.019%2041.2992%2036.0584L41.3543%2036.2773C41.3753%2036.3556%2041.3913%2036.4352%2041.4024%2036.5155C41.4061%2036.555%2041.4148%2036.5938%2041.4284%2036.6311C41.4339%2036.645%2041.4346%2036.6608%2041.4408%2036.6747C41.4746%2036.7655%2041.4925%2036.8615%2041.4936%2036.9584L41.5088%2037.03C41.5194%2037.0663%2041.5255%2037.1037%2041.527%2037.1414C41.5278%2037.1793%2041.5358%2037.2167%2041.5507%2037.2517C41.5927%2037.4049%2041.6187%2037.5621%2041.6283%2037.7207C41.6413%2037.7888%2041.6594%2037.8558%2041.6826%2037.9211C41.703%2038.0664%2041.7101%2038.2132%2041.7039%2038.3598L41.7462%2038.7259C41.7501%2038.7537%2041.7462%2038.7826%2041.7462%2038.8107C41.7555%2038.9217%2041.8238%2039.0053%2041.8087%2039.1163C41.7997%2039.2155%2041.7997%2039.3152%2041.8087%2039.4143C41.8118%2039.4748%2041.8444%2039.4817%2041.8242%2039.5207C41.7905%2039.5839%2041.8467%2039.6613%2041.8491%2039.7334C41.8502%2039.7619%2041.8553%2039.79%2041.8642%2039.8171C41.8751%2039.8552%2041.8981%2039.8889%2041.9298%2039.913C41.9728%2039.9517%2042.0254%2039.9784%2042.0823%2039.9901C42.1537%2040.0001%2042.2266%2039.9911%2042.2934%2039.9639'%20fill='%23121C2D'/%3e%3cpath%20d='M75.361%2032.3201C75.3489%2032.2746%2075.3215%2032.2345%2075.2834%2032.2064C75.2768%2032.2014%2075.2698%2032.1933%2075.2632%2032.1941C75.2326%2032.1964%2075.2295%2032.1344%2075.1895%2032.1532C75.1604%2032.1663%2075.1344%2032.1405%2075.1065%2032.132C75.103%2032.132%2075.0983%2032.132%2075.0952%2032.1297C75.0181%2032.0948%2074.9353%2032.0737%2074.8508%2032.0673C74.8469%2032.0672%2074.8431%2032.0664%2074.8395%2032.065C74.7565%2032.0222%2074.6587%2032.0295%2074.5776%2031.984C74.5667%2031.9796%2074.5551%2031.9775%2074.5434%2031.9779C74.486%2031.9706%2074.4309%2031.9513%2074.3816%2031.9212C74.3711%2031.9132%2074.3586%2031.908%2074.3455%2031.9062C74.2937%2031.9023%2074.2436%2031.8863%2074.1992%2031.8595C74.1911%2031.8545%2074.1837%2031.848%2074.1736%2031.8495C74.1264%2031.8623%2074.0767%2031.8636%2074.0289%2031.8534C73.9478%2031.8118%2073.9016%2031.7424%2073.8151%2031.7181C73.8024%2031.7137%2073.7905%2031.7074%2073.7797%2031.6996C73.7731%2031.6957%2073.7681%2031.6876%2073.7611%2031.6861C73.6695%2031.6688%2073.6059%2031.5967%2073.5151%2031.5705C73.4708%2031.5531%2073.4292%2031.5298%2073.3913%2031.5011C73.3028%2031.4529%2073.2147%2031.4032%2073.1294%2031.35C73.0881%2031.3264%2073.0481%2031.3007%2073.0095%2031.2729C72.985%2031.2552%2072.9548%2031.2432%2072.9404%2031.2147C72.8663%2031.0532%2072.7852%2031.0922%2072.7076%2031.0266L72.6552%2030.9823L72.6447%2030.9704C72.6387%2030.9632%2072.6341%2030.955%2072.6311%2030.9461C72.6311%2030.9391%2072.5884%2030.9407%2072.6109%2030.9264C72.6498%2030.9087%2072.5881%2030.9122%2072.5869%2030.901C72.5857%2030.8898%2072.5644%2030.8721%2072.5589%2030.8563C72.5566%2030.8493%2072.559%2030.8424%2072.5667%2030.8401C72.5694%2030.8401%2072.5667%2030.8378%2072.5636%2030.8343C72.5399%2030.8193%2072.4379%2030.7572%2072.4375%2030.7407C72.4911%2030.7594%2072.543%2030.7824%2072.5927%2030.8096C72.6063%2030.815%2072.5539%2030.7688%2072.583%2030.7823C72.6121%2030.7958%2072.6606%2030.8366%2072.6629%2030.8351C72.6758%2030.8351%2072.7091%2030.8783%2072.6948%2030.8351C72.6897%2030.7946%2072.7204%2030.8439%2072.7235%2030.8486C72.7324%2030.8509%2072.7134%2030.8486%2072.7448%2030.854L72.8251%2030.8648C72.8788%2030.8721%2072.9319%2030.8825%2072.9842%2030.896C73.0281%2030.9075%2073.0751%2030.9079%2073.1181%2030.9233C73.1433%2030.9255%2073.1688%2030.9237%2073.1934%2030.9179C73.2256%2030.9102%2073.2241%2030.9233%2073.2543%2030.9326C73.3339%2030.9494%2073.4146%2030.9609%2073.4957%2030.9669C73.6019%2030.9727%2073.7077%2030.9841%2073.8127%2031.0008C73.8174%2031.0008%2073.8213%2031.0047%2073.8248%2031.0043C73.9206%2030.9895%2074.0173%2030.9805%2074.1142%2030.9773C74.1953%2030.9773%2074.304%2031.0467%2074.3859%2031.0301C74.4233%2031.0245%2074.461%2031.0209%2074.4988%2031.0193C74.5356%2031.0145%2074.5707%2031.0011%2074.6012%2030.9801C74.6317%2030.9591%2074.6568%2030.9312%2074.6742%2030.8987C74.7208%2030.8216%2074.7615%2030.7407%2074.805%2030.6616C74.8224%2030.6191%2074.8338%2030.5743%2074.8387%2030.5287C74.8585%2030.4137%2074.8504%2030.2957%2074.815%2030.1845C74.8117%2030.1733%2074.807%2030.1626%2074.8011%2030.1525C74.7613%2030.0825%2074.7074%2030.0213%2074.6428%2029.9729C74.6109%2029.9516%2074.5742%2029.9384%2074.536%2029.9343C74.4136%2029.9055%2074.2888%2029.8877%2074.1631%2029.8812C74.1049%2029.8777%2074.0048%2029.9197%2073.9462%2029.9224C73.9378%2029.9232%2073.9294%2029.9232%2073.921%2029.9224C73.8178%2029.9054%2073.7541%2029.8654%2073.6521%2029.8426C73.6444%2029.8393%2073.6363%2029.8371%2073.628%2029.8361C73.5297%2029.8389%2073.4316%2029.8283%2073.3362%2029.8045C73.2198%2029.7782%2073.1391%2029.831%2073.0196%2029.8337C72.9986%2029.8342%2072.9776%2029.8314%2072.9575%2029.8257C72.9194%2029.812%2072.8821%2029.7965%2072.8457%2029.779C72.7774%2029.7562%2072.7062%2029.7433%2072.6342%2029.7405C72.4713%2029.7407%2072.3087%2029.7252%2072.1488%2029.6942C71.9912%2029.6676%2071.8488%2029.6657%2071.6963%2029.6468C71.6498%2029.6408%2071.6027%2029.6408%2071.5562%2029.6468C71.531%2029.6618%2071.5035%2029.6727%2071.4747%2029.6792C71.382%2029.6958%2071.2567%2029.6881%2071.1643%2029.7085C71.1174%2029.7189%2071.0824%2029.7601%2071.0479%2029.7736C70.9835%2029.7803%2070.9186%2029.7819%2070.8539%2029.7786L70.8096%2029.7863C70.7937%2029.791%2070.7631%2029.7863%2070.7817%2029.8203C70.7964%2029.8688%2070.8104%2029.9178%2070.8182%2029.9436C70.8215%2030.0112%2070.8314%2030.0783%2070.8477%2030.144C70.8805%2030.2041%2070.9093%2030.2663%2070.9338%2030.3302C70.9685%2030.4418%2071.014%2030.5498%2071.0696%2030.6528C71.1354%2030.775%2071.2075%2030.8938%2071.2858%2031.0085C71.3256%2031.0727%2071.3737%2031.1314%2071.429%2031.1831C71.4519%2031.2032%2071.4678%2031.2274%2071.4926%2031.2471C71.6424%2031.3733%2071.7849%2031.5077%2071.9195%2031.6499C71.9583%2031.683%2071.9994%2031.7135%2072.0359%2031.7397C72.0752%2031.7632%2072.1114%2031.7917%2072.1434%2031.8245C72.1759%2031.8578%2072.2157%2031.8833%2072.2598%2031.8989C72.4285%2031.9894%2072.5916%2032.09%2072.7483%2032.1999C72.8237%2032.2358%2072.9024%2032.264%2072.9835%2032.2843C73.153%2032.3336%2073.2776%2032.4747%2073.4445%2032.5383C73.5812%2032.5928%2073.7209%2032.6399%2073.8628%2032.6793C73.8954%2032.6878%2073.9245%2032.7082%2073.9575%2032.7179C74.0867%2032.7564%2074.2074%2032.7079%2074.3273%2032.7634C74.4364%2032.809%2074.5511%2032.8404%2074.6684%2032.8566C74.7398%2032.8678%2074.7568%2032.8273%2074.796%2032.8636C74.8616%2032.9241%2074.9664%2032.8636%2075.0502%2032.8721C75.0838%2032.8761%2075.1179%2032.8738%2075.1507%2032.8655C75.1981%2032.855%2075.2405%2032.8286%2075.2706%2032.7907C75.3214%2032.7366%2075.3569%2032.6702%2075.3735%2032.598C75.3904%2032.5045%2075.3879%2032.4084%2075.3661%2032.3159'%20fill='%23121C2D'/%3e%3cpath%20d='M97.3315%20135.689C97.2777%20135.683%2097.2235%20135.694%2097.1763%20135.72C97.165%20135.724%2097.1545%20135.729%2097.1453%20135.737C97.1107%20135.771%2097.0677%20135.747%2097.0354%20135.799C97.0048%20135.833%2096.9683%20135.861%2096.9276%20135.883C96.9225%20135.886%2096.9183%20135.892%2096.9132%20135.894C96.8009%20135.97%2096.6938%20136.054%2096.5927%20136.144C96.5876%20136.148%2096.5826%20136.152%2096.5779%20136.155C96.4507%20136.23%2096.3478%20136.343%2096.2209%20136.417C96.2058%20136.428%2096.1918%20136.441%2096.179%20136.454C96.1104%20136.517%2096.034%20136.571%2095.9516%20136.614C95.9325%20136.624%2095.9146%20136.636%2095.8985%20136.65C95.8369%20136.706%2095.7694%20136.755%2095.6971%20136.796C95.6833%20136.803%2095.6708%20136.812%2095.6602%20136.823C95.6161%20136.882%2095.5648%20136.936%2095.5073%20136.983C95.3855%20137.042%2095.2671%20137.107%2095.1526%20137.179C95.1352%20137.191%2095.1162%20137.202%2095.0979%20137.213C95.0866%20137.218%2095.0757%20137.224%2095.0653%20137.23C94.9524%20137.325%2094.8154%20137.384%2094.6955%20137.472C94.6354%20137.517%2094.5624%20137.549%2094.4968%20137.587C94.3552%20137.671%2094.219%20137.763%2094.0735%20137.84L93.8698%20137.953C93.8286%20137.98%2093.7844%20138.002%2093.7382%20138.018C93.5814%20138.068%2093.4335%20138.143%2093.3001%20138.239C93.1499%20138.312%2092.9994%20138.385%2092.8473%20138.453C92.7717%20138.496%2092.6921%20138.532%2092.6098%20138.56C92.5085%20138.591%2092.4114%20138.635%2092.3203%20138.689C92.1546%20138.757%2091.9904%20138.828%2091.8224%20138.892C91.7386%20138.924%2091.6548%20138.955%2091.5698%20138.983C91.5493%20138.99%2091.5292%20138.998%2091.5096%20139.008C91.4095%20139.066%2091.3059%20139.117%2091.1992%20139.162C91.0696%20139.206%2090.9311%20139.214%2090.8011%20139.255C90.709%20139.297%2090.6148%20139.333%2090.519%20139.366C90.4239%20139.386%2090.3292%20139.386%2090.2384%20139.415C90.0809%20139.451%2089.9254%20139.495%2089.7728%20139.548C89.6414%20139.596%2089.5047%20139.628%2089.3657%20139.644C89.2102%20139.682%2089.0526%20139.711%2088.8938%20139.732C88.8279%20139.741%2088.7615%20139.758%2088.6948%20139.763C88.6585%20139.771%2088.623%20139.782%2088.5884%20139.795C88.5446%20139.813%2088.5434%20139.803%2088.4976%20139.808C88.3773%20139.817%2088.2586%20139.843%2088.1399%20139.859C87.9846%20139.88%2087.8294%20139.924%2087.6742%20139.931C87.6681%20139.931%2087.662%20139.931%2087.656%20139.931C87.5031%20139.968%2087.3964%20139.995%2087.2415%20140.023C87.1251%20140.045%2086.9497%20140.023%2086.8329%20140.045C86.7805%20140.058%2086.7243%20140.065%2086.6699%20140.074C86.5802%20140.086%2086.4976%20140.129%2086.4371%20140.196C86.3832%20140.26%2086.3385%20140.328%2086.2881%20140.395C86.2617%20140.429%2086.2706%20140.464%2086.2636%20140.499C86.2605%20140.545%2086.268%20140.591%2086.2855%20140.634C86.3031%20140.677%2086.3302%20140.716%2086.3649%20140.747C86.3732%20140.755%2086.3826%20140.762%2086.3929%20140.767C86.4794%20140.816%2086.5732%20140.85%2086.6707%20140.869C86.7275%20140.878%2086.7852%20140.88%2086.8426%20140.876C87.0376%20140.875%2087.2322%20140.859%2087.4247%20140.828C87.5147%20140.816%2087.6575%20140.759%2087.7452%20140.742C87.758%20140.742%2087.77%20140.735%2087.784%20140.735C87.9454%20140.72%2088.0518%20140.723%2088.2132%20140.707C88.2262%20140.707%2088.2392%20140.706%2088.252%20140.704C88.4005%20140.671%2088.5508%20140.646%2088.7021%20140.629C88.8605%20140.592%2089.016%20140.544%2089.1678%20140.486C89.1987%20140.477%2089.2302%20140.471%2089.2621%20140.467C89.3831%20140.466%2089.5036%20140.451%2089.6214%20140.423C89.7438%20140.379%2089.8699%20140.347%2089.9982%20140.326C90.1156%20140.302%2090.2316%20140.271%2090.3455%20140.234C90.4262%20140.211%2090.4976%20140.168%2090.5783%20140.144C90.6948%20140.11%2090.8213%20140.093%2090.9384%20140.057C91.0047%20140.028%2091.0695%20139.996%2091.1325%20139.96C91.1985%20139.941%2091.266%20139.926%2091.3343%20139.916L91.5811%20139.83C91.6613%20139.815%2091.7402%20139.793%2091.8166%20139.764C91.876%20139.728%2091.9377%20139.696%2092.0013%20139.667L92.3579%20139.513L92.7386%20139.342C92.8017%20139.317%2092.8629%20139.288%2092.9218%20139.254C92.9435%20139.241%2092.9695%20139.232%2092.9904%20139.218C93.1341%20139.137%2093.2825%20139.063%2093.4348%20138.999L93.5461%20138.939C93.6014%20138.906%2093.6592%20138.877%2093.7188%20138.852C93.7788%20138.828%2093.8356%20138.796%2093.8876%20138.758C94.1147%20138.61%2094.3494%20138.473%2094.5907%20138.349C94.6912%20138.284%2094.7817%20138.211%2094.874%20138.139C95.0723%20137.988%2095.3133%20137.902%2095.5174%20137.753C95.6878%20137.631%2095.8666%20137.522%2096.0281%20137.385C96.0669%20137.355%2096.1084%20137.332%2096.1472%20137.303C96.2982%20137.187%2096.3843%20137.056%2096.5422%20136.954C96.682%20136.858%2096.8164%20136.755%2096.945%20136.646C97.025%20136.58%2097.0149%20136.547%2097.0793%20136.523C97.1829%20136.481%2097.2477%20136.35%2097.3385%20136.269C97.3738%20136.237%2097.4064%20136.202%2097.4359%20136.165C97.4745%20136.121%2097.5019%20136.068%2097.5159%20136.011C97.5371%20135.947%2097.5357%20135.877%2097.512%20135.814C97.4933%20135.782%2097.4682%20135.754%2097.4382%20135.732C97.4083%20135.71%2097.3741%20135.695%2097.3377%20135.686'%20fill='%23121C2D'/%3e%3cpath%20d='M87.3412%20126.152C87.5685%20126.257%2087.8017%20126.35%2088.0397%20126.429C88.0959%20126.45%2088.1604%20126.476%2088.2162%20126.493C88.472%20126.568%2088.5321%20126.64%2088.8484%20126.731C89.0851%20126.809%2089.3174%20126.9%2089.5441%20127.004L89.6384%20127.042C90.3004%20127.34%2090.9807%20127.657%2091.6283%20128.022L91.7168%20128.072C92.414%20128.474%2093.0829%20128.922%2093.7188%20129.414C93.7894%20129.473%2093.8829%20129.53%2093.9493%20129.597C94.3191%20129.914%2094.64%20130.283%2094.9015%20130.693C94.9663%20130.785%2095.0179%20130.874%2095.0823%20130.976C95.3231%20131.349%2095.5241%20131.746%2095.6819%20132.161L95.7723%20132.386C95.9339%20132.746%2096.0727%20133.115%2096.1879%20133.492C96.3998%20134.257%2096.5049%20134.863%2096.6924%20135.645C96.7191%20135.761%2096.7467%20135.879%2096.7735%20135.995L96.8169%20136.194C97.0199%20136.984%2097.1906%20137.781%2097.4126%20138.574C97.5193%20138.974%2097.633%20139.4%2097.744%20139.815C97.9853%20140.696%2098.2449%20141.573%2098.515%20142.447L98.9073%20143.68C98.9896%20143.94%2099.0866%20144.211%2099.1576%20144.457C99.4143%20145.33%2099.7181%20146.19%20100.068%20147.031C100.392%20147.903%20100.742%20148.765%20101.096%20149.627C101.281%20150.071%20101.508%20150.54%20101.678%20150.958C101.938%20151.605%20102.173%20152.03%20102.421%20152.56C102.844%20153.465%20103.297%20154.354%20103.751%20155.241L104.435%20156.571L104.605%20156.89C104.909%20157.447%20105.248%20158.004%20105.551%20158.564L106.595%20160.564C106.857%20161.049%20107.164%20161.543%20107.42%20162.025C107.671%20162.498%20107.89%20162.954%20108.145%20163.416C108.578%20164.199%20109.005%20165.041%20109.439%20165.767C109.863%20166.477%20110.18%20167.128%20110.551%20167.81C110.657%20168.005%20110.76%20168.199%20110.884%20168.401C110.997%20168.604%20111.122%20168.801%20111.256%20168.991C111.384%20169.185%20111.523%20169.373%20111.672%20169.552L111.892%20169.825L112.131%20170.081C112.262%20170.228%20112.403%20170.366%20112.553%20170.495L112.772%20170.695L113.005%20170.88C113.052%20170.918%20113.158%20170.999%20113.266%20171.077L113.541%20171.25C113.773%20171.395%20113.761%20171.399%20113.998%20171.535C114.615%20171.889%20115.276%20172.158%20115.965%20172.336C116.865%20172.561%20117.793%20172.655%20118.72%20172.613L118.827%20172.607C119.65%20172.537%20120.46%20172.365%20121.239%20172.097C122.003%20171.858%20122.728%20171.515%20123.395%20171.076L123.783%20170.79L124.16%20170.479C124.52%20170.169%20124.824%20169.799%20125.058%20169.387C125.201%20169.11%20125.318%20168.821%20125.407%20168.523C125.457%20168.369%20125.407%20168.387%20125.4%20168.33C125.382%20168.176%20125.171%20168.384%20124.949%20168.6C124.925%20168.621%20124.887%20168.664%20124.853%20168.7C124.553%20169.046%20124.226%20169.369%20123.875%20169.663C123.681%20169.829%20123.436%20170.03%20123.204%20170.198C122.396%20170.765%20121.495%20171.189%20120.542%20171.452C120.006%20171.614%20119.456%20171.725%20118.898%20171.784L118.702%20171.803C117.974%20171.836%20117.245%20171.768%20116.537%20171.6L116.351%20171.553C115.6%20171.387%20114.882%20171.096%20114.228%20170.694C113.883%20170.478%20113.55%20170.243%20113.232%20169.989C112.913%20169.733%20112.619%20169.448%20112.353%20169.138C112.245%20169.015%20112.144%20168.886%20112.05%20168.752C111.713%20168.231%20111.404%20167.694%20111.123%20167.141C110.78%20166.548%20110.448%20165.933%20110.128%20165.33L109.211%20163.654L108.56%20162.507L107.633%20160.776C107.475%20160.49%20107.216%20160.067%20107.062%20159.795C106.857%20159.435%20106.751%20159.183%20106.56%20158.827L105.898%20157.608C105.704%20157.244%20105.506%20156.82%20105.307%20156.46C105.035%20155.967%20105.039%20156%20104.774%20155.496C104.458%20154.886%20104.144%20154.28%20103.828%20153.669C103.401%20152.826%20103.17%20152.352%20102.86%20151.683C102.709%20151.358%20102.556%20151.03%20102.405%20150.707L102.234%20150.335C101.741%20149.292%20101.539%20148.731%20101.213%20147.92L100.964%20147.299C100.842%20146.981%20100.713%20146.668%20100.601%20146.341C100.488%20146.014%20100.362%20145.694%20100.245%20145.381C99.6745%20143.88%2099.314%20142.658%2098.8972%20141.281C98.7133%20140.676%2098.5344%20140.089%2098.354%20139.497C97.9768%20138.231%2097.7055%20136.929%2097.3939%20135.625C97.159%20134.517%2096.8541%20133.424%2096.4813%20132.353C96.3901%20132.108%2096.2923%20131.857%2096.1856%20131.614C95.7745%20130.722%2095.1949%20129.918%2094.4782%20129.244C94.1241%20128.922%2093.7456%20128.629%2093.3458%20128.365C92.9621%20128.095%2092.5697%20127.861%2092.2073%20127.645C91.718%20127.367%2091.6338%20127.364%2091.3307%20127.179C90.7479%20126.867%2090.1409%20126.603%2089.5154%20126.387C89.2721%20126.296%2089.0191%20126.207%2088.7805%20126.136C88.4953%20126.045%2088.2033%20125.976%2087.9074%20125.93C87.668%20125.877%2087.4218%20125.864%2087.1782%20125.891C87.0808%20125.94%2087.1185%20126.024%2087.3416%20126.15'%20fill='%23121C2D'/%3e%3cpath%20d='M80.4069%2018.402C80.4304%2018.1138%2080.3834%2017.8242%2080.2699%2017.5579C80.2448%2017.4896%2080.2148%2017.4232%2080.1803%2017.3591C80.0696%2017.1193%2079.9166%2016.9012%2079.7286%2016.715L79.6723%2016.6653L79.6444%2016.6426L79.5904%2016.5971C79.5594%2016.567%2079.5097%2016.5512%2079.5163%2016.5011C79.5163%2016.4888%2079.5205%2016.4768%2079.5283%2016.4672C79.5726%2016.4287%2079.6385%2016.4487%2079.6863%2016.4383L79.7588%2016.4325L79.9529%2016.4075C80.1104%2016.3855%2080.2691%2016.3608%2080.4278%2016.3327C80.7453%2016.2768%2081.0638%2016.207%2081.3793%2016.1238L81.4872%2016.0945C81.9295%2015.9888%2082.356%2015.826%2082.7557%2015.6104C83.1908%2015.379%2083.5526%2015.032%2083.8007%2014.6083C83.8623%2014.4972%2083.9113%2014.3797%2083.947%2014.2579C84.0497%2013.9408%2084.0605%2013.6014%2083.9781%2013.2786C83.8862%2012.9656%2083.714%2012.6818%2083.4783%2012.4549C83.3818%2012.3565%2083.2772%2012.2662%2083.1655%2012.1851C82.7488%2011.8892%2082.303%2011.636%2081.8349%2011.4293C81.751%2011.39%2081.6648%2011.3558%2081.5768%2011.3268C81.1536%2011.1951%2080.721%2011.095%2080.2827%2011.0273C80.0664%2010.989%2079.8595%2010.9592%2079.6618%2010.9379L79.5303%2010.9228L79.4915%2010.9171L79.422%2010.907C79.3786%2010.9013%2079.3401%2010.8974%2079.3002%2010.8959C79.2614%2010.9101%2079.2063%2010.8573%2079.24%2010.8145C79.2594%2010.7957%2079.2959%2010.7926%2079.3238%2010.7818C79.3409%2010.7764%2079.3646%2010.7721%2079.3755%2010.7667L79.398%2010.7563L79.4589%2010.729C79.4907%2010.7136%2079.4628%2010.729%2079.5978%2010.6608C79.7996%2010.5574%2079.9906%2010.4344%2080.1679%2010.2934C80.5519%2010.0048%2080.8356%209.60417%2080.9792%209.14758C81.0556%208.88117%2081.0669%208.60054%2081.0122%208.32893C80.9556%208.06297%2080.8437%207.8117%2080.6836%207.59123C80.3658%207.16999%2079.9618%206.82044%2079.4981%206.56561C79.0458%206.31209%2078.5526%206.13851%2078.0406%206.05261C77.572%205.97576%2077.0969%205.94542%2076.6223%205.96204C76.3277%205.96897%2076.02%205.99557%2075.7476%206.00944L75.6335%206.01561L75.578%206.01869C75.573%206.0198%2075.5679%206.0198%2075.5629%206.01869L75.5287%206.01522L75.4798%206.01098C75.4539%206.01038%2075.428%206.01166%2075.4022%206.01484C75.3693%206.00674%2075.3762%205.9736%2075.3918%205.97013L75.4387%205.92889C75.4546%205.9154%2075.4775%205.89806%2075.5028%205.87955L75.7538%205.69108C75.8631%205.60904%2075.9668%205.51994%2076.0643%205.42437C76.3074%205.19324%2076.4512%204.87767%2076.4655%204.54367C76.4605%204.24171%2076.3815%203.9455%2076.2353%203.6807C76.0892%203.41589%2075.8802%203.19046%2075.6265%203.02394C75.146%202.71334%2074.5944%202.52778%2074.0227%202.48434C73.3786%202.43124%2072.7301%202.46782%2072.0961%202.59303C71.566%202.67075%2071.0412%202.78041%2070.5245%202.92141C70.2657%202.99002%2070.0103%203.06942%2069.7562%203.15267C69.6289%203.19481%2069.5025%203.23862%2069.377%203.2841L69.039%203.41052C68.9614%203.43634%2068.9521%203.45638%2068.9129%203.44906C68.8741%203.43018%2068.8994%203.38547%2068.9168%203.36157L68.9308%203.3369C68.9731%203.24787%2069.0356%203.10141%2069.079%202.98539C69.2076%202.65064%2069.3016%202.30377%2069.3596%201.95014C69.4405%201.53626%2069.3694%201.10725%2069.159%200.741061C69.0151%200.522466%2068.8138%200.347075%2068.5769%200.233841C68.3651%200.133155%2068.1387%200.0660479%2067.906%200.0349619C67.6906%200.00368156%2067.4726%20-0.0066454%2067.2552%200.00412789C67.0452%200.00853945%2066.8356%200.0257877%2066.6277%200.0557749C66.0136%200.153233%2065.4157%200.333341%2064.8505%200.591131C64.3141%200.811763%2063.809%201.10096%2063.348%201.4514C62.9493%201.76009%2062.5838%202.10882%2062.2572%202.49205L62.0243%202.7869L61.8125%203.09524L61.7915%203.1253L61.781%203.13687C61.7738%203.1434%2061.7657%203.14898%2061.757%203.15344C61.7435%203.16048%2061.7283%203.16381%2061.7131%203.16308C61.7011%203.15961%2061.7131%203.16847%2061.6805%203.1465L61.5397%203.03935C61.445%202.97075%2061.3487%202.90677%2061.2517%202.84664C61.0603%202.729%2060.8597%202.62679%2060.6518%202.541C60.2392%202.36793%2059.7983%202.27064%2059.3507%202.25386C58.8257%202.24478%2058.3044%202.34271%2057.8189%202.54158C57.3335%202.74045%2056.8943%203.03606%2056.5284%203.41013C56.2199%203.72698%2055.9702%204.09562%2055.7911%204.49896C55.6957%204.7177%2055.6229%204.9455%2055.5738%205.17885C55.5172%205.46946%2055.5102%205.46098%2055.4667%205.75313C55.3856%206.5088%2055.4649%207.27298%2055.6995%207.99631C55.8459%208.45713%2056.0348%208.90355%2056.2638%209.32988C56.3755%209.54148%2056.4931%209.7473%2056.615%209.95003L56.8004%2010.2511L56.8947%2010.3994C56.9172%2010.4345%2056.9072%2010.4222%2056.911%2010.4276V10.4322C56.911%2010.4322%2056.911%2010.4353%2056.911%2010.4368C56.9122%2010.4418%2056.9125%2010.4469%2056.9117%2010.4519C56.9109%2010.457%2056.9091%2010.4618%2056.9064%2010.4661C56.9023%2010.4731%2056.897%2010.4793%2056.8909%2010.4846L56.8835%2010.4908L56.8474%2010.5151L56.776%2010.5629C56.5937%2010.6857%2056.4218%2010.8233%2056.2622%2010.9741C55.9351%2011.2844%2055.6576%2011.6425%2055.4392%2012.036C55.2237%2012.4146%2055.0596%2012.8198%2054.951%2013.2412C54.8436%2013.6616%2054.8043%2014.0962%2054.8346%2014.5289C54.8598%2014.8745%2054.9179%2015.217%2055.0081%2015.5518C55.132%2016.0368%2055.3527%2016.4922%2055.6573%2016.8908C55.8641%2017.1424%2056.0938%2017.3746%2056.3433%2017.5845C56.4725%2017.6925%2056.4749%2017.6389%2056.5335%2017.6566C56.691%2017.7006%2056.5606%2017.4254%2056.4458%2017.1232C56.4349%2017.0916%2056.407%2017.0392%2056.3856%2016.9925C56.1715%2016.5705%2055.9999%2016.1284%2055.8734%2015.6728C55.7946%2015.3939%2055.7356%2015.1097%2055.6968%2014.8226C55.5699%2013.8498%2055.822%2012.8657%2056.4015%2012.0714C56.5611%2011.8515%2056.7431%2011.6485%2056.9448%2011.4659C57.0523%2011.3698%2057.1664%2011.2813%2057.2863%2011.2011C57.3331%2011.1708%2057.3782%2011.138%2057.4213%2011.1028C57.4707%2011.0615%2057.5153%2011.0148%2057.5544%2010.9637C57.6274%2010.8687%2057.6802%2010.76%2057.7096%2010.6442C57.7401%2010.5187%2057.7419%2010.3881%2057.7147%2010.2618C57.6946%2010.1645%2057.6572%2010.0716%2057.6041%209.98742L57.5183%209.85136L57.3662%209.60084C57.2696%209.43819%2057.1831%209.2817%2057.1012%209.12407C56.9264%208.79035%2056.7731%208.44599%2056.6421%208.09305L56.5781%207.90651C56.3022%207.17949%2056.2219%206.39357%2056.3453%205.62633C56.4109%205.23425%2056.5401%204.85534%2056.7279%204.50436C56.992%204.01249%2057.4028%203.61385%2057.904%203.36311C58.1701%203.23464%2058.4541%203.14643%2058.7465%203.10141C59.0355%203.0608%2059.3285%203.0573%2059.6184%203.091C59.9355%203.12536%2060.2442%203.21321%2060.5315%203.35078C60.6753%203.41911%2060.8133%203.49903%2060.944%203.58974C61.008%203.63599%2061.0717%203.68263%2061.1318%203.73351L61.1815%203.77397C61.2145%203.8011%2061.2493%203.82583%2061.2859%203.84798C61.3599%203.89329%2061.4403%203.92733%2061.5245%203.94896C61.6786%203.98639%2061.8399%203.98268%2061.9921%203.93821C62.1443%203.89373%2062.2819%203.81008%2062.391%203.69573C62.4178%203.66805%2062.4425%203.63856%2062.4651%203.60747L62.5152%203.53694L62.5816%203.44174L62.7139%203.25095C62.8995%203.0024%2063.1047%202.76899%2063.3278%202.55295C63.6328%202.24798%2063.968%201.97423%2064.3282%201.73584C64.8749%201.39572%2065.4714%201.14192%2066.0965%200.983494C66.4525%200.8805%2066.8174%200.811073%2067.1865%200.776135C67.5116%200.737494%2067.8413%200.773762%2068.15%200.882127C68.2961%200.92847%2068.4237%201.01937%2068.5148%201.1419C68.5944%201.27769%2068.6305%201.43428%2068.6184%201.59092C68.5652%201.98798%2068.4561%202.37565%2068.2944%202.74258C68.247%202.86591%2068.2218%202.92989%2068.178%203.03319C68.1112%203.18119%2068.0557%203.29335%2068.0053%203.3924C67.9464%203.51396%2067.9205%203.64867%2067.93%203.78323C67.9384%203.8726%2067.9649%203.95936%2068.0079%204.03831C68.051%204.11726%2068.1096%204.18676%2068.1803%204.24265C68.2774%204.32482%2068.3997%204.3716%2068.5272%204.37524C68.669%204.35737%2068.8097%204.33163%2068.9486%204.29815L69.3732%204.12356L69.618%204.0299C69.9463%203.90785%2070.2791%203.79851%2070.6165%203.7019C71.341%203.49193%2072.0831%203.34745%2072.8338%203.27022C73.1863%203.23301%2073.5413%203.22245%2073.8955%203.23862C74.0255%203.24611%2074.155%203.26052%2074.2835%203.28179C74.7061%203.32433%2075.1016%203.50805%2075.4053%203.80288C75.5163%203.90404%2075.6019%204.02956%2075.6553%204.16943C75.7088%204.30929%2075.7285%204.45962%2075.7131%204.60842C75.6751%204.75695%2075.5869%204.888%2075.4632%204.97959C75.353%205.07671%2075.2133%205.18309%2075.0751%205.28793C74.8038%205.48806%2074.522%205.67396%2074.2311%205.84487L74.1923%205.873C74.0967%205.93636%2074.0201%206.02409%2073.9704%206.127C73.9432%206.18079%2073.9217%206.23724%2073.9063%206.29543C73.8861%206.3768%2073.8933%206.46251%2073.9269%206.5394C73.9456%206.58819%2073.9728%206.63332%2074.0072%206.67276C74.0289%206.69823%2074.0566%206.71785%2074.0879%206.7298C74.1576%206.76595%2074.2297%206.79724%2074.3037%206.82346H74.762C74.9172%206.81999%2075.1197%206.78492%2075.292%206.76603L75.7406%206.71516C76.1044%206.67511%2076.4701%206.65388%2076.8361%206.65156C77.5246%206.6302%2078.2099%206.75476%2078.8462%207.01694C79.3908%207.24128%2079.8624%207.61075%2080.209%208.08457C80.3423%208.2852%2080.4052%208.52388%2080.3881%208.76365C80.371%209.00341%2080.2748%209.23088%2080.1143%209.41082C79.9493%209.61778%2079.7493%209.79464%2079.5233%209.93346C79.467%209.972%2079.4069%2010.0025%2079.3483%2010.0348L79.2579%2010.0811L79.1217%2010.1443C78.8772%2010.2541%2078.606%2010.3463%2078.3281%2010.4418C78.2135%2010.4848%2078.1098%2010.5522%2078.0243%2010.6392C77.9776%2010.6875%2077.9344%2010.739%2077.8951%2010.7933C77.8559%2010.857%2077.8337%2010.9295%2077.8303%2011.0041C77.827%2011.0786%2077.8427%2011.1527%2077.876%2011.2196C77.9001%2011.2794%2077.9425%2011.3302%2077.9971%2011.3649L78.1252%2011.442C78.1577%2011.4597%2078.1926%2011.4727%2078.2288%2011.4806L78.3549%2011.5191C78.3978%2011.5333%2078.4416%2011.5448%2078.486%2011.5534H78.6909C78.9672%2011.5511%2079.2295%2011.5673%2079.4864%2011.5796C80.0472%2011.6177%2080.6015%2011.7212%2081.138%2011.888C81.3811%2011.9669%2081.618%2012.0639%2081.8465%2012.1782C82.2651%2012.3705%2082.658%2012.6137%2083.0161%2012.9024C83.173%2013.0215%2083.292%2013.183%2083.3589%2013.3676C83.4258%2013.5521%2083.4378%2013.7519%2083.3933%2013.943C83.2891%2014.344%2083.0388%2014.6923%2082.6909%2014.9205C82.3325%2015.1567%2081.9391%2015.3357%2081.5248%2015.4508C81.213%2015.5605%2080.8923%2015.6439%2080.5664%2015.7002L80.013%2015.7854L79.7154%2015.8347L79.2109%2015.9068C79.1192%2015.9256%2079.0306%2015.9577%2078.9482%2016.002C78.8688%2016.033%2078.8016%2016.0888%2078.757%2016.1611C78.7123%2016.2333%2078.6925%2016.318%2078.7006%2016.4024C78.7067%2016.4768%2078.7364%2016.5473%2078.7856%2016.6036C78.8053%2016.6337%2078.8266%2016.6628%2078.8493%2016.6907L78.9595%2016.7936C79.0417%2016.8666%2079.1284%2016.9345%2079.2191%2016.9968C79.2779%2017.0452%2079.3341%2017.0967%2079.3875%2017.1509C79.4263%2017.1941%2079.4701%2017.2346%2079.5039%2017.2793C79.6848%2017.4922%2079.836%2017.7283%2079.9536%2017.9811C80.0949%2018.2587%2080.1453%2018.577%2080.1977%2018.6483C80.2653%2018.7343%2080.3506%2018.6899%2080.4034%2018.4055'%20fill='%23121C2D'/%3e%3cpath%20d='M56.8636%2018.6298C56.8729%2018.6697%2056.8936%2018.706%2056.9234%2018.7343C56.928%2018.7385%2056.9335%2018.7458%2056.9381%2018.7447C56.9579%2018.7393%2056.9657%2018.8006%2056.9897%2018.7771C57.0072%2018.7601%2057.0285%2018.7813%2057.046%2018.7859C57.0487%2018.7859%2057.0514%2018.7859%2057.0538%2018.7859C57.1061%2018.8089%2057.1643%2018.8158%2057.2206%2018.8056C57.223%2018.8051%2057.2255%2018.8051%2057.228%2018.8056C57.2885%2018.8329%2057.3494%2018.8002%2057.4096%2018.8272C57.4166%2018.8303%2057.4247%2018.8272%2057.4325%2018.8241C57.4708%2018.8155%2057.5108%2018.8196%2057.5466%2018.8356C57.5545%2018.8401%2057.5638%2018.8414%2057.5726%2018.8391C57.6055%2018.8269%2057.6417%2018.8269%2057.6746%2018.8391C57.6812%2018.8414%2057.687%2018.8445%2057.6932%2018.8391C57.7177%2018.8195%2057.7573%2018.7817%2057.7821%2018.7863C57.8419%2018.799%2057.8877%2018.8422%2057.9474%2018.8341C57.9563%2018.8337%2057.9652%2018.8344%2057.9738%2018.8364C57.9788%2018.8364%2057.9843%2018.843%2057.9889%2018.8414C58.0495%2018.8198%2058.1092%2018.8584%2058.1698%2018.8414C58.2014%2018.8383%2058.2334%2018.8401%2058.2645%2018.8468H58.4666H58.5621C58.5819%2018.8468%2058.6036%2018.8418%2058.6218%2018.858C58.7239%2018.947%2058.7553%2018.8711%2058.8221%2018.8753C58.8904%2018.8789%2058.9585%2018.8858%2059.0262%2018.8962C59.0615%2018.9023%2059.1011%2018.875%2059.1329%2018.9016C59.1822%2018.9424%2059.2198%2018.9016%2059.2625%2018.9081C59.3351%2018.9216%2059.4088%2018.9174%2059.4818%2018.9247C59.5185%2018.928%2059.555%2018.934%2059.5908%2018.9428C59.5995%2018.9446%2059.6085%2018.9446%2059.6172%2018.9428C59.6645%2018.9359%2059.7154%2018.8938%2059.7619%2018.8989C59.8178%2018.9054%2059.8686%2018.959%2059.9237%2018.9686C59.9626%2018.9756%2060.0099%2018.9382%2060.0491%2018.952C60.0883%2018.9659%2060.1216%2019.0048%2060.1608%2019.0064C60.2268%2019.0087%2060.292%2019.0561%2060.358%2019.0218C60.4239%2018.9875%2060.4713%2019.0395%2060.5272%2019.0492C60.5932%2019.0565%2060.6582%2019.0707%2060.7212%2019.0916C60.7484%2019.0974%2060.7753%2019.105%2060.8015%2019.1143C60.8174%2019.116%2060.8335%2019.1134%2060.8481%2019.107C60.8679%2019.0985%2060.8663%2019.1116%2060.8842%2019.1197C60.9315%2019.1344%2060.9803%2019.1439%2061.0297%2019.1482C61.0941%2019.1515%2061.1581%2019.1604%2061.221%2019.1748C61.2233%2019.1748%2061.2256%2019.1787%2061.228%2019.1779C61.2863%2019.1619%2061.3461%2019.1515%2061.4065%2019.1467C61.4565%2019.144%2061.5175%2019.2122%2061.5687%2019.1952C61.5917%2019.1893%2061.6152%2019.1853%2061.6389%2019.1833C61.6851%2019.1756%2061.7247%2019.1305%2061.7553%2019.0615L61.8574%2018.8252C61.872%2018.7821%2061.8828%2018.7377%2061.8896%2018.6927C61.9124%2018.5802%2061.9178%2018.4649%2061.9055%2018.3508C61.9043%2018.3401%2061.9022%2018.3295%2061.8993%2018.3192C61.8829%2018.2551%2061.854%2018.1949%2061.8143%2018.1419C61.7972%2018.1161%2061.7716%2018.1137%2061.7495%2018.1033C61.6748%2018.0754%2061.5963%2018.0589%2061.5167%2018.0544C61.4779%2018.0517%2061.4131%2018.0949%2061.3758%2018.0979C61.3704%2018.0987%2061.3649%2018.0987%2061.3595%2018.0979C61.2955%2018.0825%2061.2575%2018.0444%2061.1934%2018.0232C61.1884%2018.0232%2061.1837%2018.0166%2061.1783%2018.0174C61.1159%2018.0223%2061.0532%2018.0137%2060.9944%2017.9923C60.921%2017.9696%2060.8679%2018.0243%2060.7918%2018.0309C60.7785%2018.0319%2060.7652%2018.0297%2060.753%2018.0243C60.7142%2018.0093%2060.6537%2017.9472%2060.6129%2017.9576C60.5601%2017.9683%2060.5052%2017.963%2060.4554%2017.9426C60.4074%2017.933%2060.3587%2017.9273%2060.3099%2017.9257C60.2757%2017.9203%2060.2412%2017.9442%2060.207%2017.9407C60.1577%2017.9357%2060.1088%2017.9041%2060.0592%2017.9021C60.0343%2017.9021%2059.9936%2017.9287%2059.9695%2017.9338C59.9369%2017.9407%2059.9191%2017.9018%2059.8884%2017.8952C59.8663%2017.8898%2059.8046%2017.891%2059.7821%2017.8875C59.7507%2017.8829%2059.7173%2017.8463%2059.6847%2017.854C59.6405%2017.8648%2059.642%2017.8798%2059.5986%2017.8786C59.5454%2017.8786%2059.4926%2017.8825%2059.4395%2017.8844C59.3828%2017.8893%2059.3258%2017.8893%2059.2691%2017.8844C59.2416%2017.8787%2059.2131%2017.8797%2059.1861%2017.8875C59.1756%2017.8914%2059.1647%2017.8875%2059.1543%2017.8921C59.0634%2017.9307%2059.0192%2017.8921%2058.9521%2017.8921L58.9005%2017.8956C58.8749%2017.9014%2058.8484%2017.9014%2058.8229%2017.8956C58.797%2017.8884%2058.7695%2017.8907%2058.7452%2017.9021C58.6363%2017.9272%2058.5236%2017.9317%2058.4131%2017.9153C58.3635%2017.9224%2058.315%2017.9361%2058.2691%2017.9561C58.1678%2017.9919%2058.0665%2017.9176%2057.9637%2017.9264C57.878%2017.9338%2057.7918%2017.9303%2057.7068%2017.9445C57.687%2017.9441%2057.6672%2017.9425%2057.6475%2017.9399C57.5699%2017.9442%2057.5105%2018.0239%2057.4336%2018.0008C57.3658%2017.9849%2057.2957%2017.9807%2057.2264%2017.9885C57.1845%2017.9885%2057.1799%2018.0332%2057.1527%2018.0051C57.1081%2017.9596%2057.0553%2018.0343%2057.006%2018.0374C56.9854%2018.039%2056.9655%2018.0457%2056.9482%2018.0571C56.9174%2018.0778%2056.8949%2018.1087%2056.8846%2018.1442C56.858%2018.2083%2056.8425%2018.2765%2056.8388%2018.3458C56.8355%2018.4398%2056.8448%2018.5339%2056.8663%2018.6256'%20fill='%23121C2D'/%3e%3cpath%20d='M56.8187%2019.6419C56.819%2019.6828%2056.8306%2019.7227%2056.852%2019.7576C56.8552%2019.7626%2056.8586%2019.7707%2056.8625%2019.7699C56.8812%2019.7699%2056.8761%2019.83%2056.9013%2019.8115C56.92%2019.798%2056.9335%2019.8223%2056.9491%2019.8304C56.9514%2019.8304%2056.9537%2019.8304%2056.9557%2019.8327C56.9976%2019.8759%2057.0488%2019.8713%2057.0973%2019.8836C57.0996%2019.8836%2057.1019%2019.8836%2057.1039%2019.8836C57.1504%2019.9221%2057.2106%2019.9036%2057.2568%2019.9418C57.2622%2019.9464%2057.2704%2019.9418%2057.2773%2019.9418C57.3128%2019.9414%2057.347%2019.9543%2057.3732%2019.978C57.3759%2019.981%2057.3792%2019.9833%2057.3829%2019.9849C57.3865%2019.9864%2057.3905%2019.9871%2057.3945%2019.9869C57.4258%2019.983%2057.4573%2019.9916%2057.4822%2020.0108C57.4873%2020.0146%2057.4916%2020.0189%2057.4981%2020.0158C57.5241%2020.0023%2057.5684%2019.9745%2057.5889%2019.9853C57.6374%2020.0123%2057.6642%2020.0655%2057.7174%2020.0721C57.7252%2020.074%2057.7327%2020.0771%2057.7395%2020.0813C57.7434%2020.0836%2057.7465%2020.0898%2057.7508%2020.0894C57.8086%2020.084%2057.8486%2020.1353%2057.906%2020.1345C57.9351%2020.1345%2057.958%2020.1557%2057.9836%2020.165C58.0403%2020.185%2058.1%2020.2004%2058.1543%2020.2216C58.1811%2020.2312%2058.2083%2020.2397%2058.2343%2020.2509C58.2506%2020.2578%2058.2707%2020.2582%2058.2808%2020.2786C58.3363%2020.3912%2058.3879%2020.3299%2058.4426%2020.3557C58.4984%2020.38%2058.5527%2020.4076%2058.6052%2020.4382C58.6316%2020.4552%2058.6747%2020.4436%2058.691%2020.4768C58.7155%2020.5311%2058.7632%2020.5041%2058.795%2020.5261C58.8497%2020.5619%2058.9114%2020.5839%2058.9681%2020.6167C58.9968%2020.6324%2059.024%2020.6506%2059.0496%2020.671C59.0558%2020.676%2059.0631%2020.6796%2059.0709%2020.6814C59.1128%2020.6907%2059.1714%2020.6729%2059.2071%2020.6949C59.2494%2020.7215%2059.2665%2020.7886%2059.3068%2020.8175C59.3363%2020.8379%2059.3895%2020.8233%2059.4147%2020.851C59.4399%2020.8788%2059.4477%2020.9281%2059.4783%2020.9427C59.53%2020.9701%2059.5591%2021.0379%2059.6266%2021.0349C59.6941%2021.0318%2059.7069%2021.0965%2059.7461%2021.1277C59.7938%2021.1613%2059.8368%2021.201%2059.8742%2021.2457C59.8893%2021.2653%2059.913%2021.2765%2059.9242%2021.2996C59.9281%2021.3066%2059.9549%2021.3131%2059.963%2021.3131C59.9828%2021.3131%2059.9747%2021.3251%2059.9844%2021.339C60.0121%2021.3725%2060.0441%2021.4024%2060.0794%2021.428C60.1182%2021.4665%2060.1772%2021.487%2060.2098%2021.5359C60.2098%2021.5359%2060.2098%2021.5413%2060.2137%2021.5417C60.266%2021.5554%2060.3167%2021.5745%2060.365%2021.5987C60.4038%2021.6199%2060.4112%2021.704%2060.4578%2021.7144C60.4779%2021.7206%2060.4974%2021.7287%2060.516%2021.7386C60.5438%2021.7441%2060.5725%2021.7432%2060.6%2021.7361C60.6275%2021.729%2060.653%2021.7159%2060.6747%2021.6978L60.8908%2021.5583C60.9277%2021.5311%2060.9622%2021.5009%2060.9941%2021.4681C61.0781%2021.3891%2061.1499%2021.2982%2061.2071%2021.1983C61.2124%2021.1889%2061.217%2021.1791%2061.2207%2021.169C61.2452%2021.1077%2061.2569%2021.0422%2061.2552%2020.9763C61.2528%2020.9514%2061.2417%2020.9283%2061.2238%2020.9107C61.1795%2020.8465%2061.1243%2020.7903%2061.0608%2020.7446C61.0313%2020.723%2060.9533%2020.7242%2060.9211%2020.7061C60.9164%2020.7038%2060.9102%2020.703%2060.9067%2020.6992C60.8625%2020.6525%2060.8505%2020.6016%2060.8082%2020.5515C60.8047%2020.5477%2060.8035%2020.5411%2060.7989%2020.5388C60.744%2020.5107%2060.6959%2020.4713%2060.6576%2020.4232C60.6072%2020.3677%2060.5334%2020.3893%2060.4663%2020.358C60.4546%2020.3525%2060.4445%2020.3442%2060.4368%2020.3338C60.4128%2020.3018%2060.3906%2020.2181%2060.3499%2020.2097C60.2992%2020.1948%2060.2543%2020.1649%2060.2211%2020.1241C60.1852%2020.0932%2060.1462%2020.0661%2060.1046%2020.0432C60.0775%2020.0235%2060.036%2020.0297%2060.0076%2020.0115C59.9669%2019.9857%2059.9386%2019.9345%2059.8967%2019.9113C59.8753%2019.899%2059.8272%2019.9083%2059.8035%2019.9025C59.7721%2019.8955%2059.7729%2019.8528%2059.7488%2019.8339C59.7314%2019.82%2059.6766%2019.7953%2059.658%2019.7826C59.632%2019.7653%2059.6192%2019.7182%2059.5854%2019.7128C59.5416%2019.7051%2059.5366%2019.7194%2059.4977%2019.7013C59.4512%2019.6797%2059.4015%2019.6627%2059.353%2019.6446C59.3004%2019.6268%2059.2493%2019.6049%2059.2001%2019.5791C59.177%2019.5636%2059.1503%2019.5541%2059.1225%2019.5517C59.1116%2019.5517%2059.1031%2019.544%2059.0919%2019.5444C58.996%2019.5467%2058.9696%2019.497%2058.9079%2019.4743L58.8598%2019.4592C58.834%2019.4556%2058.8094%2019.4459%2058.788%2019.4311C58.767%2019.4149%2058.7403%2019.4075%2058.7139%2019.4107C58.5827%2019.4165%2058.5086%2019.3455%2058.4035%2019.317C58.3554%2019.3089%2058.3064%2019.3076%2058.2579%2019.3132C58.1539%2019.317%2058.0829%2019.2168%2057.9832%2019.1975C57.9027%2019.176%2057.8209%2019.1594%2057.7383%2019.1478C57.7193%2019.1478%2057.703%2019.1324%2057.6844%2019.1285C57.6099%2019.1139%2057.535%2019.1756%2057.4686%2019.1359C57.4086%2019.1057%2057.3438%2019.0862%2057.277%2019.0784C57.2382%2019.0715%2057.2234%2019.112%2057.2036%2019.0784C57.1714%2019.0249%2057.1054%2019.0881%2057.0581%2019.0811C57.0384%2019.079%2057.0185%2019.0819%2057.0003%2019.0896C56.9665%2019.1041%2056.939%2019.1301%2056.9227%2019.1628C56.8856%2019.2211%2056.8585%2019.285%2056.8423%2019.3521C56.8218%2019.4439%2056.8125%2019.5379%2056.8148%2019.6319'%20fill='%23121C2D'/%3e%3cpath%20d='M61.7115%2016.5273C61.7632%2016.5986%2061.8308%2016.657%2061.909%2016.6981C61.9263%2016.7105%2061.9449%2016.721%2061.9645%2016.7293C62.0491%2016.7582%2062.0561%2016.8121%2062.1663%2016.8353C62.2463%2016.86%2062.3242%2016.8912%2062.3991%2016.9285L62.4309%2016.9405C62.6607%2017.0399%2062.8988%2017.1188%2063.1426%2017.1764L63.176%2017.1856C63.4317%2017.2747%2063.7107%2017.3124%2063.9726%2017.3806C64.0064%2017.3876%2064.0404%2017.3927%2064.0747%2017.3961C64.2478%2017.4196%2064.4146%2017.4466%2064.5858%2017.4789C64.6267%2017.4872%2064.6682%2017.4922%2064.7099%2017.494C64.893%2017.5035%2065.0765%2017.4951%2065.2579%2017.4689C65.2948%2017.4641%2065.3311%2017.4548%2065.3657%2017.4412C65.536%2017.3654%2065.6884%2017.2551%2065.8132%2017.1174C66.0414%2016.893%2066.1755%2016.5909%2066.1884%2016.2722L66.1907%2016.1269C66.1923%2016.0998%2066.1923%2016.0726%2066.1907%2016.0455C66.1663%2015.8775%2066.136%2015.7441%2066.1019%2015.5996L66.0751%2015.4978C66.0704%2015.4832%2066.0636%2015.4693%2066.0549%2015.4566C66.0414%2015.4315%2066.0293%2015.4058%2066.0184%2015.3795L65.9924%2015.339C65.9839%2015.3275%2065.968%2015.3101%2065.9839%2015.2974C66.0138%2015.2874%2066.039%2015.3202%2066.0677%2015.3302L66.148%2015.3737C66.1675%2015.3806%2066.1846%2015.3926%2066.1977%2015.4084C66.1799%2015.4169%2066.3118%2015.4971%2066.3712%2015.5314C66.4433%2015.5718%2066.5054%2015.6023%2066.5652%2015.6285C66.6816%2015.6809%2066.7856%2015.7145%2066.9199%2015.7827C67.1954%2015.9156%2067.4752%2016.0413%2067.7565%2016.1658C67.9032%2016.2286%2068.07%2016.2722%2068.2039%2016.3408C68.3823%2016.421%2068.5675%2016.4855%2068.7573%2016.5335C69.0717%2016.6395%2069.3913%2016.7295%2069.715%2016.8033C69.8764%2016.8439%2070.0408%2016.8813%2070.2082%2016.9154C70.247%2016.9239%2070.2912%2016.9301%2070.332%2016.9351C70.5589%2016.953%2070.7867%2016.9566%2071.0141%2016.9459C71.2989%2016.959%2071.584%2016.9248%2071.8574%2016.8445C71.962%2016.8058%2072.0621%2016.7557%2072.1558%2016.6954C72.2555%2016.6306%2072.3501%2016.5583%2072.4387%2016.4791C72.6083%2016.3421%2072.7473%2016.1715%2072.8469%2015.9781C72.8873%2015.8934%2072.9219%2015.8061%2072.9505%2015.7168L72.9707%2015.6482C72.9742%2015.6321%2072.9791%2015.6164%2072.9854%2015.6011C72.9876%2015.5968%2072.9902%2015.5926%2072.9932%2015.5888C73.0101%2015.5707%2073.0291%2015.5546%2073.0498%2015.541C73.0638%2015.5316%2073.0806%2015.5272%2073.0974%2015.5284C73.1143%2015.5297%2073.1302%2015.5366%2073.1426%2015.5479C73.2493%2015.6123%2073.3521%2015.6794%2073.462%2015.7407C73.7153%2015.8837%2073.9707%2016.0228%2074.2183%2016.1739C74.3219%2016.2367%2074.4321%2016.2941%2074.5349%2016.3597C74.5663%2016.3797%2074.6816%2016.4337%2074.7153%2016.4479C74.7661%2016.4712%2074.8141%2016.4999%2074.8585%2016.5335C75.0498%2016.6512%2075.2482%2016.757%2075.4526%2016.8503C75.7671%2017.0041%2076.1112%2017.0889%2076.4616%2017.0989C76.4765%2017.0998%2076.4916%2017.0998%2076.5066%2017.0989C76.6868%2017.0845%2076.8628%2017.0372%2077.0258%2016.9594C77.1985%2016.8769%2077.3502%2016.7566%2077.4693%2016.6075C77.5924%2016.4572%2077.6777%2016.2801%2077.7184%2016.0906C77.7551%2015.9132%2077.745%2015.7293%2077.6893%2015.5568C77.6517%2015.4428%2077.6055%2015.3318%2077.5512%2015.2246C77.4896%2015.0856%2077.3934%2014.9644%2077.2718%2014.8723C77.1763%2014.8091%2077.0875%2014.7625%2077.0002%2014.6965C76.9555%2014.6615%2076.9226%2014.6815%2076.8869%2014.6761C76.7863%2014.6572%2076.7285%2014.7702%2076.6928%2014.9074C76.6899%2014.9261%2076.6889%2014.9451%2076.6897%2014.964C76.7013%2015.1294%2076.7313%2015.2931%2076.779%2015.452C76.7999%2015.5348%2076.8368%2015.6189%2076.8566%2015.6913C76.8892%2015.7788%2076.8984%2015.8733%2076.8834%2015.9654C76.8694%2016.0322%2076.8328%2016.0923%2076.7797%2016.1357C76.7031%2016.2129%2076.6043%2016.2644%2076.4969%2016.2833C76.4817%2016.2833%2076.4662%2016.2887%2076.4511%2016.2891C76.2602%2016.2735%2076.0749%2016.2172%2075.9078%2016.1242C75.8911%2016.1168%2075.8737%2016.1049%2075.8566%2016.0987C75.6241%2016.0019%2075.4005%2015.8852%2075.1884%2015.7499C74.9167%2015.5892%2074.7227%2015.5345%2074.4433%2015.3934C74.3937%2015.3683%2074.3475%2015.3421%2074.2997%2015.3128C74.1597%2015.2265%2073.933%2015.0542%2073.7825%2014.9845L73.6342%2014.9112L73.5609%2014.8727C73.5411%2014.8623%2073.4794%2014.8291%2073.4391%2014.8114C73.254%2014.7326%2073.0488%2014.7129%2072.8519%2014.7551C72.6639%2014.7957%2072.4943%2014.8962%2072.3692%2015.0415C72.3053%2015.1164%2072.2542%2015.2011%2072.2179%2015.2924C72.2008%2015.3369%2072.1868%2015.3825%2072.176%2015.4289L72.162%2015.4793C72.1396%2015.5766%2072.1029%2015.6699%2072.0529%2015.7565C71.9704%2015.873%2071.858%2015.9655%2071.7274%2016.0243C71.6476%2016.0741%2071.5638%2016.117%2071.4767%2016.1527C71.3838%2016.1746%2071.2884%2016.1838%2071.193%2016.18C71.0652%2016.1902%2070.9369%2016.1922%2070.8089%2016.1858C70.6925%2016.1789%2070.559%2016.1369%2070.4367%2016.1253C70.3254%2016.1201%2070.2145%2016.1073%2070.105%2016.0868C69.8977%2016.0428%2069.6855%2015.9966%2069.4771%2015.9434C69.1899%2015.869%2069.0301%2015.8201%2068.8112%2015.7437C68.7049%2015.7052%2068.5974%2015.6667%2068.4891%2015.6347L68.3665%2015.5938C68.1013%2015.5109%2067.8435%2015.406%2067.5958%2015.2805L67.4018%2015.1957C67.301%2015.1543%2067.2024%2015.1078%2067.1065%2015.0561C67.0106%2015.0044%2066.9119%2014.958%2066.8108%2014.917L66.6378%2014.8399L66.5559%2014.8014L66.4185%2014.7324C66.2276%2014.6341%2066.0448%2014.5304%2065.8636%2014.4298C65.7892%2014.3874%2065.7098%2014.3541%2065.6273%2014.3308L65.4049%2014.2537C65.3812%2014.2409%2065.3537%2014.2371%2065.3273%2014.2429L65.2691%2014.2494L65.1527%2014.2645C65.102%2014.2792%2065.0578%2014.3106%2065.0274%2014.3535C64.9831%2014.4109%2064.9924%2014.4306%2064.9948%2014.451L65.0107%2014.6499C65.0136%2014.8093%2065.0663%2014.9638%2065.1616%2015.092C65.2693%2015.2621%2065.3541%2015.4454%2065.4139%2015.6374C65.4338%2015.6956%2065.4492%2015.7553%2065.46%2015.8158L65.4864%2015.9573C65.5011%2016.0401%2065.5087%2016.1241%2065.5093%2016.2082C65.5188%2016.3235%2065.4954%2016.4392%2065.4418%2016.542C65.3882%2016.6448%2065.3066%2016.7305%2065.2063%2016.7894C65.1559%2016.8096%2065.1025%2016.8214%2065.0483%2016.8245C64.7764%2016.8614%2064.5002%2016.8529%2064.2311%2016.7994C63.9478%2016.7358%2063.6529%2016.6761%2063.3999%2016.6129C63.2319%2016.5697%2063.2008%2016.5948%2063.1015%2016.5431C62.9086%2016.4765%2062.7123%2016.4206%2062.5132%2016.3755C62.4379%2016.3481%2062.358%2016.3242%2062.2835%2016.3042C62.1918%2016.2764%2062.0968%2016.2613%2062.001%2016.2594C61.8888%2016.2629%2061.7771%2016.2618%2061.7328%2016.3072C61.7046%2016.3363%2061.6873%2016.374%2061.6838%2016.4142C61.6802%2016.4544%2061.6907%2016.4946%2061.7134%2016.5281'%20fill='%23121C2D'/%3e%3cpath%20d='M55.6085%20173.885C55.4131%20174.014%2055.2279%20174.158%2055.0547%20174.315C55.0124%20174.354%2054.9624%20174.392%2054.9236%20174.431C54.7474%20174.606%2054.664%20174.627%2054.4459%20174.843C54.286%20175.003%2054.0966%20175.152%2053.9224%20175.306L53.8514%20175.369L53.0598%20176.032C52.7947%20176.256%2052.5316%20176.486%2052.2565%20176.699L52.182%20176.759C51.593%20177.215%2050.9853%20177.695%2050.3749%20178.126L50.1444%20178.292C49.7536%20178.57%2049.3683%20178.849%2048.9702%20179.098C48.8774%20179.156%2048.7936%20179.209%2048.6966%20179.275C48.345%20179.515%2047.99%20179.756%2047.6205%20179.966C47.5515%20180.007%2047.4867%20180.043%2047.423%20180.087C47.1657%20180.261%2046.7587%20180.547%2046.4836%20180.694L45.5775%20181.19C45.2829%20181.339%2044.9892%20181.489%2044.6624%20181.668L44.3687%20181.822L44.1995%20181.904C43.8662%20182.078%2043.5278%20182.243%2043.1906%20182.408L42.1619%20182.886C41.8196%20183.057%2041.4389%20183.201%2041.0753%20183.357C40.6873%20183.525%2040.2965%20183.684%2039.9031%20183.833C39.51%20183.987%2039.118%20184.141%2038.7183%20184.277C38.3416%20184.406%2037.9706%20184.552%2037.5895%20184.667C37.3501%20184.744%2037.0986%20184.828%2036.8705%20184.89L35.4952%20185.255C35.1545%20185.35%2034.8087%20185.425%2034.4595%20185.481C33.6496%20185.627%2032.8186%20185.611%2032.0148%20185.435C31.61%20185.346%2031.2238%20185.189%2030.8736%20184.968C30.4653%20184.743%2030.1541%20184.377%2029.9985%20183.94C29.7832%20183.223%2030.2911%20182.446%2030.9388%20181.882C31.2704%20181.591%2031.629%20181.331%2032.0098%20181.107C32.101%20181.051%2032.1957%20180.996%2032.2888%20180.943C32.7933%20180.654%2033.3144%20180.331%2033.8324%20180.046C34.4475%20179.699%2035.0668%20179.391%2035.6799%20179.042C36.1254%20178.785%2036.5802%20178.489%2037.023%20178.237C37.4545%20177.987%2037.8724%20177.767%2038.2942%20177.513C39.0055%20177.076%2039.7746%20176.645%2040.4254%20176.199C41.0637%20175.767%2041.6512%20175.432%2042.2585%20175.043L44.3454%20173.69L45.2166%20173.112C45.3062%20173.054%2045.6046%20172.842%2045.6865%20172.783C45.8805%20172.643%2045.8805%20172.652%2046.0804%20172.519C46.5961%20172.172%2047.1133%20171.813%2047.6213%20171.45L49.6124%20170.019L49.69%20169.964L51.4273%20168.627C51.9162%20168.241%2052.6465%20167.744%2053.1191%20167.35L53.7843%20166.811C54.1144%20166.554%2054.4218%20166.269%2054.7032%20165.96C54.9022%20165.729%2055.0586%20165.529%2055.2375%20165.312C55.331%20165.199%2055.2833%20165.196%2055.2984%20165.143C55.3392%20165.003%2055.0869%20165.108%2054.811%20165.233C54.7831%20165.246%2054.7361%20165.275%2054.6946%20165.299C54.3881%20165.479%2053.9861%20165.765%2053.5786%20166.046C53.3714%20166.189%2053.1281%20166.38%2052.9049%20166.55L50.6155%20168.29C50.2581%20168.556%2049.6974%20169.027%2049.3392%20169.292L49.1879%20169.407C48.5402%20169.875%2048.1102%20170.16%2047.4548%20170.613L47.2996%20170.719C46.697%20171.165%2046.0769%20171.582%2045.4579%20172.005C44.6993%20172.506%2044.255%20172.866%2043.5014%20173.375L43.1033%20173.637C42.7028%20173.897%2041.9954%20174.309%2041.5965%20174.576C41.0711%20174.935%2040.5185%20175.274%2039.9783%20175.604L38.4688%20176.534C38.1165%20176.751%2037.7855%20176.969%2037.4293%20177.181C36.9132%20177.489%2036.3707%20177.792%2035.8499%20178.093L34.9524%20178.644C34.6206%20178.839%2034.3877%20178.942%2034.0598%20179.124L32.9345%20179.753C32.595%20179.94%2032.212%20180.121%2031.867%20180.324C31.5611%20180.509%2031.2649%20180.709%2030.9795%20180.924C30.411%20181.323%2029.93%20181.833%2029.5659%20182.423C29.3383%20182.798%2029.225%20183.231%2029.2395%20183.669C29.2482%20183.859%2029.2845%20184.047%2029.3474%20184.226C29.4048%20184.415%2029.4917%20184.593%2029.6047%20184.755C29.8267%20185.069%2030.113%20185.334%2030.4448%20185.531C30.5612%20185.601%2030.6908%20185.671%2030.8099%20185.734C31.2415%20185.939%2031.6992%20186.085%2032.1704%20186.167C32.5634%20186.241%2032.9631%20186.273%2033.3629%20186.263C33.5829%20186.263%2033.8002%20186.241%2034.0164%20186.224C34.347%20186.185%2034.6714%20186.138%2034.9993%20186.078C35.3218%20186.019%2035.641%20185.944%2035.9555%20185.853C37.4176%20185.408%2038.5515%20185.043%2039.8212%20184.557C40.3776%20184.341%2040.91%20184.116%2041.4397%20183.872C42.5744%20183.371%2043.7238%20182.87%2044.8413%20182.286C45.7672%20181.791%2046.6881%20181.28%2047.5747%20180.722L48.1956%20180.345C48.9962%20179.827%2049.5844%20179.372%2050.3563%20178.842C51.0664%20178.352%2051.7851%20177.812%2052.3861%20177.321C52.7874%20176.997%2052.8281%20176.936%2053.0873%20176.74C53.5115%20176.419%2054%20175.953%2054.4455%20175.536C54.6221%20175.375%2054.8017%20175.207%2054.9655%20175.049C55.1618%20174.857%2055.3466%20174.653%2055.5192%20174.439C55.6712%20174.274%2055.7983%20174.087%2055.8964%20173.885C55.9046%20173.785%2055.8188%20173.774%2055.6108%20173.89'%20fill='%23121C2D'/%3e%3cpath%20d='M39.088%20185.755C39.0156%20185.717%2038.9366%20185.693%2038.8552%20185.683C38.8359%20185.678%2038.8161%20185.675%2038.7962%20185.674C38.7124%20185.674%2038.6895%20185.63%2038.5847%20185.639C38.5045%20185.639%2038.4245%20185.63%2038.3461%20185.614L38.3135%20185.61C38.0697%20185.569%2037.8234%20185.544%2037.5762%20185.536H37.5412C37.2558%20185.514%2036.9687%20185.524%2036.6856%20185.567C36.6515%20185.569%2036.6134%20185.578%2036.5773%20185.584C36.4023%20185.642%2036.2196%20185.673%2036.05%20185.734C36.0103%20185.747%2035.9714%20185.763%2035.9336%20185.781L35.7112%20185.885C35.6406%20185.926%2035.5691%20185.964%2035.4966%20186.001C35.4696%20186.013%2035.4437%20186.028%2035.419%20186.045C35.3193%20186.111%2035.1932%20186.255%2035.095%20186.319C34.9755%20186.396%2034.8882%20186.483%2034.7892%20186.559C34.6868%20186.64%2034.5947%20186.732%2034.5149%20186.835L34.4318%20186.928C34.4159%20186.946%2034.3965%20186.962%2034.3833%20186.98C34.3057%20187.097%2034.2242%20187.214%2034.1404%20187.327C34.0628%20187.446%2033.9926%20187.57%2033.9305%20187.698C33.8692%20187.828%2033.809%20187.968%2033.7485%20188.105C33.6899%20188.252%2033.653%20188.408%2033.6053%20188.56C33.57%20188.714%2033.5455%20188.874%2033.5176%20189.031L33.4912%20189.484C33.4997%20189.58%2033.5033%20189.676%2033.5021%20189.772C33.4947%20190.099%2033.5673%20190.423%2033.7136%20190.715C33.7773%20190.869%2033.8494%20191.019%2033.9293%20191.164C34.0147%20191.307%2034.114%20191.44%2034.2072%20191.577L34.563%20191.95C34.7088%20192.099%2034.8751%20192.227%2035.057%20192.33C35.3487%20192.524%2035.6653%20192.68%2035.9984%20192.792C36.1645%20192.848%2036.3336%20192.892%2036.5028%20192.939L36.6286%20192.959C36.7399%20192.975%2036.8519%20192.984%2036.9642%20192.988C37.0775%20192.988%2037.1901%20192.986%2037.3014%20192.993C37.5663%20193.011%2037.8322%20193.004%2038.0958%20192.973C38.2908%20192.932%2038.483%20192.879%2038.6712%20192.814C38.8526%20192.763%2039.0294%20192.698%2039.1998%20192.618C39.4938%20192.476%2039.7589%20192.281%2039.9817%20192.044C40.1719%20191.837%2040.3479%20191.618%2040.5086%20191.388C40.6711%20191.114%2040.8024%20190.822%2040.9002%20190.518C40.9359%20190.392%2040.9747%20190.261%2041.0026%20190.133C41.0108%20190.094%2041.0228%20189.955%2041.0251%20189.916C41.0297%20189.855%2041.0397%20189.796%2041.055%20189.737C41.0777%20189.501%2041.0789%20189.263%2041.0589%20189.026C41.0509%20188.871%2041.0296%20188.716%2040.9953%20188.564C40.9674%20188.411%2040.9318%20188.26%2040.8885%20188.111C40.8858%20188.099%2040.8827%20188.087%2040.88%20188.076C40.8332%20187.944%2040.778%20187.815%2040.7147%20187.69C40.6576%20187.563%2040.5918%20187.44%2040.5176%20187.322C40.4881%20187.271%2040.4578%20187.213%2040.4268%20187.152L40.3131%20186.971C40.2469%20186.852%2040.1635%20186.743%2040.0655%20186.648C39.9852%20186.574%2039.9126%20186.487%2039.8265%20186.416C39.7041%20186.305%2039.5552%20186.227%2039.3938%20186.188C39.2778%20186.176%2039.1612%20186.17%2039.0446%20186.17C38.986%20186.17%2038.9809%20186.204%2038.9526%20186.222C38.8773%20186.274%2038.9184%20186.389%2038.958%20186.503C38.9648%20186.517%2038.973%20186.531%2038.9825%20186.544C39.0214%20186.598%2039.0642%20186.649%2039.1105%20186.698C39.154%20186.759%2039.2025%20186.82%2039.2502%20186.881C39.2979%20186.941%2039.3709%20187.002%2039.4229%20187.073L39.5661%20187.24L39.6906%20187.423C39.7753%20187.545%2039.8515%20187.672%2039.9188%20187.805C40.0052%20187.951%2040.0829%20188.103%2040.1516%20188.259L40.1707%20188.316C40.2261%20188.531%2040.2598%20188.752%2040.2712%20188.974C40.2712%20188.993%2040.2712%20189.012%2040.2712%20189.032C40.3021%20189.265%2040.3009%20189.501%2040.2677%20189.734C40.245%20189.982%2040.2051%20190.227%2040.1482%20190.469C40.1315%20190.516%2040.1132%20190.562%2040.0927%20190.607C40.0418%20190.749%2039.8777%20190.947%2039.8133%20191.077C39.7617%20191.158%2039.7062%20191.239%2039.6491%20191.318C39.5855%20191.391%2039.5121%20191.456%2039.4446%20191.524C39.3806%20191.586%2039.312%20191.644%2039.2393%20191.696C39.1728%20191.755%2039.0999%20191.807%2039.022%20191.85C38.9199%20191.922%2038.8123%20191.985%2038.7003%20192.04C38.6142%20192.074%2038.5273%20192.111%2038.4365%20192.137C38.3457%20192.163%2038.2518%20192.178%2038.1625%20192.204C38.0733%20192.23%2037.9324%20192.265%2037.8435%20192.287C37.7377%20192.301%2037.6306%20192.301%2037.5246%20192.289C37.3895%20192.295%2037.2542%20192.293%2037.1195%20192.281C36.998%20192.281%2036.8676%20192.224%2036.7477%20192.214C36.6399%20192.208%2036.5331%20192.19%2036.4295%20192.16C36.3309%20192.138%2036.2342%20192.109%2036.1404%20192.072C36.0445%20192.041%2035.9504%20192.004%2035.8587%20191.963C35.7361%20191.899%2035.6348%20191.858%2035.5482%20191.805L35.2983%20191.639C35.2157%20191.576%2035.1404%20191.503%2035.0546%20191.444C35.0226%20191.421%2034.9925%20191.395%2034.9646%20191.367C34.7747%20191.2%2034.6177%20191%2034.5017%20190.776L34.4113%20190.608C34.362%20190.524%2034.3251%20190.433%2034.3018%20190.338C34.2731%20190.245%2034.2363%20190.153%2034.2161%20190.058C34.106%20189.651%2034.1035%20189.222%2034.2087%20188.813C34.2188%20188.72%2034.251%20188.633%2034.2696%20188.543C34.287%20188.452%2034.311%20188.363%2034.3414%20188.276C34.4822%20187.903%2034.694%20187.56%2034.9654%20187.266C35.1769%20187.009%2035.4221%20186.782%2035.6945%20186.591L35.8936%20186.48C36.1228%20186.324%2036.3781%20186.21%2036.6476%20186.143C36.7815%20186.12%2036.9192%20186.115%2037.0531%20186.093C37.1893%20186.084%2037.3247%20186.083%2037.4532%20186.086C37.5545%20186.077%2037.6566%20186.079%2037.7574%20186.093C37.9653%20186.119%2038.1749%20186.131%2038.3845%20186.127C38.4688%20186.133%2038.5534%20186.135%2038.6379%20186.132C38.739%20186.131%2038.8394%20186.115%2038.9351%20186.083C39.043%20186.041%2039.1478%20185.995%2039.1679%20185.94C39.1794%20185.905%2039.1779%20185.866%2039.1638%20185.831C39.1496%20185.796%2039.1236%20185.768%2039.0903%20185.75'%20fill='%23121C2D'/%3e%3cpath%20d='M66.083%20167.292C66.053%20167.278%2066.0193%20167.275%2065.9875%20167.283C65.9821%20167.283%2065.9743%20167.283%2065.9716%20167.289C65.9588%20167.307%2065.9235%20167.282%2065.9161%20167.312C65.9107%20167.334%2065.8854%20167.338%2065.8688%20167.35C65.8664%20167.35%2065.8649%20167.354%2065.8625%20167.356C65.8094%20167.385%2065.7624%20167.424%2065.724%20167.471C65.7223%20167.473%2065.7202%20167.475%2065.7178%20167.477C65.658%20167.508%2065.6255%20167.57%2065.5665%20167.601C65.5595%20167.605%2065.5552%20167.613%2065.5502%20167.62C65.5245%20167.652%2065.4922%20167.678%2065.4555%20167.697C65.4467%20167.701%2065.4391%20167.707%2065.4334%20167.715C65.4127%20167.746%2065.3851%20167.773%2065.3527%20167.792C65.3464%20167.796%2065.3402%20167.798%2065.3375%20167.805C65.3274%20167.833%2065.3146%20167.882%2065.2925%20167.897C65.2393%20167.936%2065.1823%20167.946%2065.1373%20167.994C65.1303%20168.001%2065.1228%20168.007%2065.1148%20168.012C65.1105%20168.016%2065.1039%20168.017%2065.1008%20168.021C65.062%20168.075%2064.9976%20168.1%2064.9576%20168.153C64.9341%20168.178%2064.9081%20168.2%2064.88%20168.219L64.7178%20168.364L64.6402%20168.432C64.6256%20168.448%2064.6073%20168.462%2064.5867%20168.47C64.4625%20168.499%2064.4729%20168.559%2064.4163%20168.604C64.3596%20168.65%2064.2999%20168.696%2064.2405%20168.739C64.2087%20168.76%2064.1893%20168.802%2064.1509%20168.811C64.0911%20168.824%2064.0802%20168.873%2064.0418%20168.898C63.9759%20168.942%2063.9173%20168.996%2063.8532%20169.043C63.821%20169.066%2063.7888%20169.089%2063.7547%20169.109C63.7465%20169.114%2063.7389%20169.12%2063.7322%20169.127C63.6969%20169.166%2063.6744%20169.219%2063.6332%20169.249C63.5839%20169.284%2063.5168%20169.292%2063.4656%20169.326C63.4291%20169.35%2063.4082%20169.4%2063.3686%20169.42C63.3273%20169.432%2063.2873%20169.448%2063.249%20169.468C63.1928%20169.512%2063.1152%20169.532%2063.076%20169.593C63.0368%20169.654%2062.9724%20169.66%2062.9208%20169.693C62.8622%20169.733%2062.8008%20169.769%2062.7372%20169.8C62.7097%20169.812%2062.6864%20169.831%2062.6596%20169.842C62.6459%20169.851%2062.6338%20169.862%2062.6239%20169.876C62.6111%20169.894%2062.6064%20169.885%2062.587%20169.894C62.5391%20169.917%2062.4929%20169.944%2062.4489%20169.974C62.3923%20170.015%2062.3334%20170.052%2062.2723%20170.086C62.27%20170.086%2062.2665%20170.086%2062.2646%20170.089C62.2214%20170.136%2062.1753%20170.179%2062.1264%20170.22C62.0849%20170.254%2061.9991%20170.259%2061.9631%20170.3C61.9457%20170.317%2061.9275%20170.334%2061.9084%20170.35C61.8908%20170.368%2061.8778%20170.389%2061.8704%20170.413C61.8631%20170.436%2061.8616%20170.462%2061.866%20170.486C61.8754%20170.546%2061.8847%20170.608%2061.894%20170.669C61.9022%20170.7%2061.9146%20170.729%2061.9309%20170.756C61.9673%20170.828%2062.0206%20170.89%2062.0861%20170.938C62.0926%20170.942%2062.0996%20170.946%2062.107%20170.95C62.1574%20170.972%2062.212%20170.984%2062.2673%20170.985C62.2933%20170.983%2062.3186%20170.975%2062.341%20170.962C62.4199%20170.928%2062.4949%20170.886%2062.5649%20170.837C62.5979%20170.815%2062.6336%20170.75%2062.6643%20170.725C62.6681%20170.72%2062.6723%20170.717%2062.6771%20170.713C62.7395%20170.679%2062.7904%20170.675%2062.8548%20170.642C62.8602%20170.641%2062.8654%20170.639%2062.8703%20170.636C62.9213%20170.593%2062.978%20170.556%2063.0387%20170.528C63.1117%20170.49%2063.1303%20170.429%2063.1916%20170.374C63.2023%20170.365%2063.2143%20170.357%2063.2273%20170.351C63.2661%20170.334%2063.3488%20170.325%2063.3779%20170.292C63.4177%20170.251%2063.4652%20170.218%2063.5176%20170.194C63.5627%20170.167%2063.6061%20170.137%2063.6476%20170.105C63.6786%20170.085%2063.6961%20170.049%2063.7252%20170.028C63.7686%20169.997%2063.8245%20169.98%2063.8676%20169.948C63.8892%20169.924%2063.9089%20169.898%2063.9266%20169.871C63.9499%20169.846%2063.9836%20169.853%2064.0123%20169.835C64.0329%20169.823%2064.0841%20169.78%2064.1039%20169.767C64.1319%20169.747%2064.1776%20169.743%2064.2002%20169.717C64.2312%20169.681%2064.223%20169.674%2064.2591%20169.645L64.3872%20169.532C64.4317%20169.49%2064.4785%20169.451%2064.5273%20169.414C64.5524%20169.398%2064.5748%20169.378%2064.5936%20169.355C64.6006%20169.345%2064.6111%20169.34%2064.6173%20169.33C64.6732%20169.248%2064.7267%20169.235%2064.7811%20169.187L64.8199%20169.149C64.8385%20169.127%2064.8602%20169.109%2064.8843%20169.094C64.9091%20169.079%2064.93%20169.059%2064.9452%20169.034C65.0218%20168.943%2065.1092%20168.861%2065.2056%20168.79C65.2412%20168.752%2065.2732%20168.711%2065.301%20168.666C65.3651%20168.575%2065.4807%20168.54%2065.5579%20168.46C65.622%20168.393%2065.6918%20168.333%2065.752%20168.263C65.7655%20168.247%2065.7857%20168.237%2065.8005%20168.222C65.8594%20168.162%2065.8688%20168.078%2065.939%20168.033C65.9998%20167.99%2066.0556%20167.941%2066.1055%20167.885C66.1373%20167.853%2066.1206%20167.828%2066.1551%20167.822C66.2114%20167.812%2066.2164%20167.734%2066.2533%20167.696C66.2678%20167.68%2066.2796%20167.662%2066.2882%20167.643C66.3016%20167.614%2066.3045%20167.581%2066.2964%20167.551C66.2879%20167.501%2066.2675%20167.454%2066.237%20167.414C66.1951%20167.364%2066.1431%20167.323%2066.0845%20167.293'%20fill='%23121C2D'/%3e%3cpath%20d='M65.3079%20159.163C65.2819%20159.146%2065.251%20159.139%2065.2202%20159.141C65.2148%20159.141%2065.2082%20159.141%2065.2054%20159.144C65.1934%20159.159%2065.1616%20159.131%2065.1542%20159.157C65.1492%20159.176%2065.1259%20159.177%2065.1104%20159.185C65.1104%20159.185%2065.1069%20159.188%2065.1049%20159.189C65.0564%20159.208%2065.0127%20159.238%2064.9773%20159.276C64.9756%20159.277%2064.9738%20159.279%2064.9718%20159.28C64.9171%20159.301%2064.8869%20159.353%2064.8325%20159.374C64.8259%20159.376%2064.8224%20159.384%2064.8174%20159.389C64.7939%20159.416%2064.7642%20159.436%2064.7309%20159.449C64.723%20159.451%2064.7159%20159.456%2064.7107%20159.462C64.6918%20159.488%2064.6664%20159.508%2064.637%20159.521C64.6311%20159.523%2064.6257%20159.525%2064.6234%20159.531C64.6141%20159.556%2064.6024%20159.599%2064.5822%20159.611C64.5337%20159.639%2064.4817%20159.641%2064.4425%20159.68C64.4365%20159.686%2064.4297%20159.69%2064.4224%20159.694C64.4185%20159.696%2064.4123%20159.696%2064.4096%20159.7C64.3754%20159.746%2064.3156%20159.76%2064.2799%20159.805C64.2585%20159.824%2064.2348%20159.842%2064.2093%20159.856L64.0626%20159.972L63.9928%20160.025C63.9777%20160.036%2063.9649%20160.051%2063.9443%20160.053C63.8314%20160.064%2063.8422%20160.122%2063.7914%20160.157C63.7406%20160.192%2063.6882%20160.23%2063.6339%20160.262C63.6055%20160.279%2063.5888%20160.315%2063.5539%20160.32C63.5%20160.325%2063.4914%20160.369%2063.4565%20160.389C63.3972%20160.423%2063.3455%20160.466%2063.2889%20160.505C63.2607%20160.524%2063.2314%20160.541%2063.2012%20160.557C63.194%20160.56%2063.1873%20160.565%2063.1814%20160.571C63.1503%20160.602%2063.1313%20160.652%2063.0949%20160.675C63.0514%20160.703%2062.9901%20160.703%2062.9455%20160.729C62.9129%20160.747%2062.8958%20160.792%2062.8605%20160.806C62.8252%20160.819%2062.7829%20160.818%2062.7542%20160.838C62.7045%20160.874%2062.6354%20160.885%2062.602%20160.939C62.5687%20160.994%2062.5112%20160.993%2062.4651%20161.019C62.4136%20161.051%2062.3596%20161.079%2062.3036%20161.102C62.2796%20161.111%2062.2594%20161.127%2062.2338%20161.134C62.2217%20161.142%2062.2113%20161.152%2062.2031%20161.164C62.1923%20161.179%2062.1876%20161.171%2062.1709%20161.177C62.1288%20161.195%2062.0884%20161.216%2062.0499%20161.241C62.0003%20161.275%2061.9484%20161.305%2061.8946%20161.331C61.8923%20161.331%2061.8896%20161.331%2061.888%20161.334C61.8513%20161.374%2061.8118%20161.412%2061.7697%20161.447C61.734%20161.475%2061.6575%20161.473%2061.6269%20161.509C61.6123%20161.525%2061.5968%20161.539%2061.5803%20161.553C61.565%20161.57%2061.5542%20161.59%2061.5486%20161.612C61.5431%20161.634%2061.543%20161.658%2061.5485%20161.68C61.559%20161.738%2061.5702%20161.799%2061.5811%20161.859C61.5895%20161.889%2061.6018%20161.918%2061.6176%20161.946C61.6525%20162.017%2061.7018%20162.081%2061.7623%20162.133C61.7681%20162.138%2061.7745%20162.143%2061.7813%20162.146C61.8254%20162.172%2061.8745%20162.188%2061.9253%20162.194C61.9478%20162.195%2061.9701%20162.19%2061.9897%20162.179C62.0581%20162.153%2062.1232%20162.12%2062.1837%20162.079C62.2124%20162.061%2062.2415%20162.002%2062.2679%20161.98C62.2718%20161.977%2062.2745%20161.973%2062.2788%20161.971C62.3335%20161.944%2062.3781%20161.943%2062.434%20161.92C62.4387%20161.92%2062.4441%20161.92%2062.4476%20161.915C62.4914%20161.879%2062.5408%20161.849%2062.5939%20161.829C62.6579%20161.801%2062.6715%20161.743%2062.725%20161.698C62.7344%20161.69%2062.745%20161.684%2062.7565%20161.68C62.7914%20161.667%2062.8644%20161.667%2062.8896%20161.639C62.9239%20161.604%2062.9655%20161.578%2063.0114%20161.561C63.051%20161.54%2063.0891%20161.517%2063.1255%20161.491C63.1527%20161.475%2063.1674%20161.443%2063.1938%20161.426C63.2326%20161.401%2063.2819%20161.391%2063.3195%20161.365C63.3386%20161.353%2063.3552%20161.315%2063.3708%20161.299C63.3863%20161.282%2063.4216%20161.288%2063.4484%20161.274C63.4666%20161.265%2063.5116%20161.23%2063.5291%20161.22C63.5543%20161.205%2063.5947%20161.205%2063.6148%20161.183C63.6424%20161.153%2063.6346%20161.144%2063.6664%20161.122C63.7053%20161.093%2063.7417%20161.061%2063.779%20161.03C63.8184%20160.996%2063.8598%20160.965%2063.9032%20160.936C63.9257%20160.924%2063.9457%20160.907%2063.9621%20160.888C63.968%20160.88%2063.9773%20160.876%2063.9831%20160.868C64.0316%20160.796%2064.0805%20160.791%2064.129%20160.752L64.1647%20160.721C64.1813%20160.704%2064.2009%20160.689%2064.2225%20160.678C64.2449%20160.667%2064.2637%20160.65%2064.2768%20160.629C64.3448%20160.554%2064.4232%20160.488%2064.5097%20160.434C64.5418%20160.403%2064.5704%20160.368%2064.595%20160.331C64.6525%20160.254%2064.7573%20160.236%2064.8279%20160.172C64.8857%20160.12%2064.9489%20160.072%2065.0033%20160.015C65.0157%20160.002%2065.0339%20159.996%2065.0475%20159.984C65.1011%20159.937%2065.1092%20159.86%2065.1736%20159.83C65.2291%20159.799%2065.2804%20159.761%2065.3261%20159.717C65.3552%20159.691%2065.3401%20159.665%2065.3715%20159.665C65.4228%20159.665%2065.4278%20159.593%2065.4619%20159.562C65.4754%20159.55%2065.4863%20159.535%2065.4941%20159.518C65.5066%20159.492%2065.5094%20159.462%2065.5019%20159.434C65.4936%20159.385%2065.4751%20159.339%2065.4476%20159.299C65.4095%20159.245%2065.362%20159.2%2065.3075%20159.163'%20fill='%23121C2D'/%3e%3cpath%20d='M109.684%20165.478C109.606%20165.41%20109.517%20165.355%20109.42%20165.317C109.398%20165.305%20109.375%20165.295%20109.351%20165.287C109.248%20165.258%20109.23%20165.208%20109.099%20165.183C109.002%20165.157%20108.907%20165.125%20108.814%20165.085L108.776%20165.072C108.504%20164.96%20108.213%20164.876%20107.928%20164.786L107.889%20164.773C107.589%20164.658%20107.264%20164.578%20106.964%20164.462C106.928%20164.448%20106.886%20164.438%20106.847%20164.427C106.649%20164.369%20106.455%20164.305%20106.265%20164.234C106.222%20164.217%20106.177%20164.202%20106.132%20164.189C105.956%20164.141%20105.779%20164.086%20105.608%20164.022C105.577%20164.01%20105.545%20163.999%20105.512%20163.992C105.354%20163.963%20105.197%20163.926%20105.043%20163.881C104.739%20163.775%20104.513%20163.672%20104.206%20163.581L104.07%20163.536C104.044%20163.527%20104.018%20163.515%20103.992%20163.509C103.68%20163.425%20103.379%20163.302%20103.063%20163.216C102.904%20163.173%20102.741%20163.111%20102.578%20163.06L101.54%20162.732L101.05%20162.578C100.947%20162.545%20100.837%20162.515%20100.743%20162.475C100.41%20162.336%20100.065%20162.224%2099.7138%20162.14L98.6619%20161.798C98.481%20161.737%2098.2785%20161.694%2098.1135%20161.624C97.8586%20161.516%2097.6665%20161.487%2097.4465%20161.413L96.3161%20161.052L95.7527%20160.865L95.6157%20160.822C95.3735%20160.752%2095.1174%20160.704%2094.8765%20160.626C94.5897%20160.534%2094.3192%20160.412%2094.0336%20160.318C93.8252%20160.249%2093.5959%20160.206%2093.3914%20160.134C93.1869%20160.061%2093.0068%20159.98%2092.8062%20159.916C92.4659%20159.81%2092.1167%20159.67%2091.7872%20159.595C91.4655%20159.521%2091.2005%20159.404%2090.9075%20159.308C90.5711%20159.198%2090.2335%20159.091%2089.9009%20158.973L89.4791%20158.83C89.4364%20158.813%2089.2851%20158.774%2089.2432%20158.764C89.1776%20158.747%2089.1136%20158.724%2089.0519%20158.697C88.802%20158.607%2088.5443%20158.531%2088.2917%20158.448C87.9599%20158.339%2087.6231%20158.246%2087.2948%20158.13L87.256%20158.116C86.9196%20158.027%2086.6856%20157.966%2086.3526%20157.869C86.0973%20157.795%2085.7512%20157.642%2085.4958%20157.579L85.1423%20157.482C84.9686%20157.428%2084.7866%20157.404%2084.6045%20157.411C84.4648%20157.425%2084.3452%20157.45%2084.2164%20157.467C84.1485%20157.477%2084.1524%20157.512%2084.1241%20157.536C84.0488%20157.6%2084.1311%20157.705%2084.2277%20157.815C84.2422%20157.829%2084.2581%20157.842%2084.275%20157.853C84.4377%20157.96%2084.6088%20158.054%2084.7865%20158.133C84.8968%20158.182%2085.0096%20158.224%2085.1245%20158.26C85.5125%20158.396%2085.9036%20158.523%2086.2975%20158.646C86.4803%20158.702%2086.7907%20158.761%2086.9743%20158.816L87.0519%20158.838C87.3771%20158.946%2087.5804%20159.035%2087.9033%20159.146C87.9289%20159.155%2087.9541%20159.166%2087.9809%20159.173C88.2913%20159.26%2088.5948%20159.361%2088.8986%20159.466C89.2676%20159.594%2089.5136%20159.629%2089.8885%20159.736C89.9545%20159.755%2090.0177%20159.775%2090.0825%20159.8C90.2765%20159.868%2090.5979%20160.011%2090.7973%20160.064C91.0612%20160.134%2091.325%20160.222%2091.5812%20160.312C91.8221%20160.396%2092.0651%20160.466%2092.3056%20160.543C92.4741%20160.599%2092.6417%20160.632%2092.8101%20160.686L93.5501%20160.94C93.6743%20160.979%2093.8687%20161.017%2093.9886%20161.051C94.1477%20161.095%2094.2435%20161.152%2094.3961%20161.205L94.9234%20161.372C95.0786%20161.423%2095.2501%20161.502%2095.4089%20161.546C95.6266%20161.605%2095.6172%20161.591%2095.8334%20161.658L96.6207%20161.897C96.9824%20162.006%2097.1842%20162.067%2097.4651%20162.159C97.6017%20162.204%2097.7391%20162.249%2097.8776%20162.284L98.0352%20162.33C98.4845%20162.441%2098.7042%20162.537%2099.0383%20162.641L99.2944%20162.718C99.4255%20162.757%2099.5559%20162.795%2099.6863%20162.841C99.8167%20162.887%2099.949%20162.925%20100.079%20162.957C100.702%20163.117%20101.18%20163.297%20101.73%20163.465C101.972%20163.538%20102.211%20163.598%20102.45%20163.662C102.961%20163.797%20103.452%20164.006%20103.964%20164.163L105.244%20164.555L105.537%20164.652C105.925%20164.772%20106.241%20164.815%20106.616%20164.952C106.961%20165.077%20107.327%20165.19%20107.642%20165.288C107.768%20165.315%20107.893%20165.351%20108.015%20165.396C108.257%20165.483%20108.506%20165.555%20108.758%20165.611C108.855%20165.642%20108.956%20165.669%20109.051%20165.691C109.165%20165.721%20109.283%20165.738%20109.402%20165.741C109.536%20165.741%20109.669%20165.738%20109.713%20165.694C109.763%20165.641%20109.762%20165.572%20109.686%20165.483'%20fill='%23121C2D'/%3e%3cpath%20d='M85.0557%20165.507C85.1371%20165.585%2085.2304%20165.649%2085.332%20165.698C85.3558%20165.713%2085.3806%20165.726%2085.4061%20165.737C85.5163%20165.777%2085.5326%20165.83%2085.6731%20165.87C85.777%20165.906%2085.8782%20165.95%2085.9762%20166L86.0177%20166.017C86.306%20166.159%2086.6157%20166.278%2086.9226%20166.396L86.9645%20166.412C87.2854%20166.558%2087.6343%20166.671%2087.956%20166.816C87.9948%20166.833%2088.0398%20166.848%2088.0821%20166.863C88.2951%20166.94%2088.5039%20167.022%2088.708%20167.11C88.7554%20167.131%2088.7984%20167.149%2088.8512%20167.167C89.0421%20167.23%2089.2319%20167.301%2089.417%20167.379C89.4501%20167.395%2089.4842%20167.408%2089.519%20167.418C89.6607%20167.457%2089.8896%20167.515%2090.0258%20167.57C90.3541%20167.698%2090.5982%20167.817%2090.9315%20167.931L91.0786%20167.986C91.1065%20167.996%2091.1345%20168.01%2091.1609%20168.018C91.5%20168.125%2091.8252%20168.271%2092.1698%20168.374C92.3429%20168.427%2092.521%20168.498%2092.6979%20168.56C93.0743%20168.689%2093.4496%20168.822%2093.8287%20168.945L94.3642%20169.122C94.476%20169.161%2094.597%20169.195%2094.6991%20169.24C95.063%20169.396%2095.4394%20169.521%2095.8244%20169.615L96.9789%20169.991C97.1775%20170.057%2097.4003%20170.102%2097.5827%20170.176C97.8648%20170.29%2098.0751%20170.322%2098.3172%20170.4C98.7301%20170.536%2099.1492%20170.649%2099.5656%20170.772L100.189%20170.962L100.341%20171.006C100.607%20171.078%20100.891%20171.121%20101.158%20171.198C101.476%20171.288%20101.779%20171.408%20102.096%20171.5C102.328%20171.568%20102.58%20171.604%20102.809%20171.672C103.037%20171.74%20103.24%20171.819%20103.463%20171.877C103.841%20171.975%20104.233%20172.108%20104.599%20172.168C104.956%20172.23%20105.254%20172.338%20105.582%20172.423L106.711%20172.71L107.186%20172.833C107.234%20172.847%20107.401%20172.879%20107.449%20172.887C107.522%20172.901%20107.594%20172.92%20107.664%20172.944C107.947%20173.019%20108.235%20173.077%20108.518%20173.144L109.64%20173.396L109.683%20173.407C110.06%20173.47%20110.322%20173.512%20110.697%20173.582C110.983%20173.637%20111.38%20173.763%20111.667%20173.801L112.063%20173.864C112.259%20173.903%20112.459%20173.91%20112.656%20173.885C112.805%20173.858%20112.931%20173.823%20113.068%20173.793C113.14%20173.776%20113.131%20173.741%20113.157%20173.715C113.228%20173.644%20113.123%20173.546%20113.002%20173.446C112.984%20173.433%20112.965%20173.422%20112.945%20173.413C112.753%20173.322%20112.555%20173.245%20112.352%20173.182C112.24%20173.143%20112.098%20173.116%20111.969%20173.087L110.65%20172.804C110.445%20172.762%20110.103%20172.726%20109.897%20172.688L109.81%20172.672C109.444%20172.59%20109.215%20172.511%20108.852%20172.422L108.768%20172.4C108.423%20172.332%20108.081%20172.254%20107.742%20172.166C107.33%20172.057%20107.06%20172.036%20106.644%20171.947C106.57%20171.932%20106.5%20171.914%20106.427%20171.894C106.21%20171.837%20105.848%20171.708%20105.628%20171.663C105.335%20171.603%20105.042%20171.525%20104.757%20171.445L103.953%20171.236C103.767%20171.185%20103.582%20171.156%20103.395%20171.106L102.574%20170.87C102.437%20170.833%20102.225%20170.795%20102.092%20170.764C101.917%20170.722%20101.809%20170.666%20101.641%20170.615L101.059%20170.454C100.886%20170.405%20100.696%20170.328%20100.522%20170.283C100.284%20170.223%20100.295%20170.237%20100.057%20170.167L99.1915%20169.927C98.7941%20169.817%2098.5741%20169.748%2098.266%20169.652C98.1162%20169.606%2097.966%20169.558%2097.8139%20169.52L97.642%20169.472C97.1496%20169.356%2096.9106%20169.248%2096.5454%20169.135L96.266%20169.05C96.1228%20169.007%2095.9804%20168.967%2095.8392%20168.915C95.6979%20168.864%2095.552%20168.824%2095.4123%20168.785C94.7352%20168.597%2094.2152%20168.4%2093.6176%20168.203C93.3557%20168.116%2093.0972%20168.042%2092.8376%20167.965C92.2839%20167.803%2091.7534%20167.563%2091.2012%20167.368L89.8233%20166.879L89.5097%20166.758C89.0949%20166.604%2088.7507%20166.537%2088.3506%20166.365C87.9824%20166.205%2087.5928%20166.056%2087.2556%20165.927C87.1196%20165.888%2086.9865%20165.84%2086.857%20165.783C86.5992%20165.669%2086.3352%20165.57%2086.0662%20165.485C85.9634%20165.444%2085.8555%20165.406%2085.7558%20165.373C85.6334%20165.33%2085.5069%20165.3%2085.3782%20165.284C85.2331%20165.271%2085.0879%20165.257%2085.0402%20165.296C84.9816%20165.344%2084.9789%20165.412%2085.0557%20165.511'%20fill='%23121C2D'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1239_9574'%3e%3crect%20width='192'%20height='224'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Lvr = ({
  onCreatePromptClicked: t
}) => /* @__PURE__ */ R.jsx(vh.Card, { children: /* @__PURE__ */ R.jsxs(
  ar.Box,
  {
    display: "flex",
    flexBasis: "0",
    flexDirection: "row",
    justifyContent: "space-around",
    children: [
      /* @__PURE__ */ R.jsx("img", { src: Dvr, alt: "No Prompt" }),
      /* @__PURE__ */ R.jsxs("div", { style: { width: "200px" }, children: [
        /* @__PURE__ */ R.jsx("h2", { children: "No prompts yet" }),
        /* @__PURE__ */ R.jsx("p", { children: "You will see prompts here after you add one." }),
        /* @__PURE__ */ R.jsx(ar.Box, { marginTop: "space100", children: /* @__PURE__ */ R.jsxs(zi.Button, { variant: "primary", onClick: t, children: [
          /* @__PURE__ */ R.jsx(
            fW,
            {
              decorative: !1,
              title: "Create a Prompt Button Icon"
            }
          ),
          "Create prompt"
        ] }) })
      ] })
    ]
  }
) });
var YQ = {};
const jvr = /* @__PURE__ */ aa(Usr);
var VAe;
function Fvr() {
  return VAe || (VAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = jvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(YQ)), YQ;
}
var Hnt = /* @__PURE__ */ Fvr(), XQ = {};
const Unt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowBackIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowBackIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.009 9.91l-.007.05v.08l.01.07.01.029a.489.489 0 00.205.272l3.832 3.444a.596.596 0 00.78 0 .459.459 0 00.063-.632l-.063-.069-2.957-2.659h7.605A.504.504 0 0015 10a.5.5 0 00-.42-.488l-.093-.008H6.883l2.956-2.658a.459.459 0 00.063-.632l-.063-.069a.598.598 0 00-.704-.057l-.076.057L5.227 9.59a.498.498 0 00-.206.272l-.012.049z" })));
});
Unt.displayName = "ArrowBackIcon";
var Vnt = P.forwardRef(({ children: t, element: e = "PAGINATION", label: r, ...n }, a) => P.createElement(ht, { ...Xt(n), element: e, ref: a, "aria-label": r, as: "nav", role: "navigation" }, t));
Vnt.displayName = "Pagination";
var qnt = { display: "inline-flex", margin: "space0", padding: "space0" }, Knt = { listStyleType: "none", margin: "space0", padding: "space0" }, Znt = P.forwardRef(({ children: t, element: e = "PAGINATION_ITEMS", ...r }, n) => {
  let [a] = P.useMemo(() => [P.Children.toArray(t).filter((o) => P.isValidElement(o))], [t]), i = JI();
  return P.createElement(ht, { ...qnt, ...Xt(r), ref: n, element: e, as: "ul" }, a.map((o, s) => P.createElement(ht, { ...Knt, key: i(`pagination-items-${s}`), element: `${e}_ITEM`, as: "li", marginRight: "space90", _last: { marginRight: "space0" } }, o)));
});
Znt.displayName = "PaginationItems";
var Jnt = ({ as: t, href: e }) => {
  let r = e != null && e !== "";
  if (t !== "a" && r) throw new Error(`[Paste: Pagination] You cannot pass href into button pagination without the 'a' tag.  Use 'as="a"'.`);
  if (t === "a" && !r) throw new Error("[Paste: Pagination] Missing href prop for link pagination.");
}, lge = P.forwardRef(({ children: t, element: e = "PAGINATION_ARROW_BUTTON", disabled: r, visibleLabel: n, ...a }, i) => P.createElement(ht, { ...Xt(a), element: e, ref: i, "aria-hidden": r, alignItems: "center", appearance: "none", border: "none", background: "none", borderColor: "colorBorder", borderRadius: n ? "borderRadius10" : "borderRadiusCircle", color: "colorText", display: "flex", fontFamily: "inherit", fontVariantNumeric: "tabular-nums", fontWeight: "fontWeightNormal", lineHeight: "lineHeight30", margin: "space0", outline: "none", opacity: r ? "0" : "1", padding: "space0", position: "relative", textDecoration: "none", transition: "border-color 100ms ease-in, box-shadow 100ms ease-in, color 100ms ease-in, opacity 150ms ease-in, visibility 150ms ease-in", visibility: r ? "hidden" : "visible", _hover: { borderColor: "colorBorderPrimaryStronger", color: "colorTextLinkStronger", cursor: "pointer", textDecoration: "none" }, _focus: { borderColor: "colorBorderPrimaryStronger", boxShadow: "shadowFocus", color: "colorTextLinkStronger", textDecoration: "none" }, _active: { textDecoration: "none" } }, t));
lge.displayName = "PaginationArrowButton";
var cge = ({ children: t, element: e = "PAGINATION_ARROW_ICON_WRAPPER", isFocused: r, isHovered: n }) => P.createElement(ht, { element: e, alignItems: "center", backgroundColor: "colorBackgroundBody", boxShadow: n && !r ? "shadowBorderPrimary" : "shadowBorderWeak", borderRadius: "borderRadiusCircle", display: "flex", height: "sizeSquare80", justifyContent: "center", transition: "background-color 100ms ease-in", width: "sizeSquare80" }, t);
cge.displayName = "PaginationArrowIconWrapper";
var Ynt = P.forwardRef(({ as: t = "button", element: e = "PAGINATION_ARROW", disabled: r, isFocused: n, isHovered: a, label: i, visibleLabel: o, ...s }, l) => P.createElement(lge, { ...s, ref: l, as: t, disabled: r, visibleLabel: o, element: `${e}_BUTTON` }, P.createElement(cge, { isFocused: n, isHovered: a, element: `${e}_ICON_WRAPPER` }, P.createElement(Unt, { decorative: !1, color: a ? "colorTextPrimary" : "colorText", display: "block", title: i, element: `${e}_ICON` })), o ? P.createElement(cl, { "aria-hidden": "true", as: "span", color: a ? "colorTextLink" : "colorText", fontWeight: "fontWeightMedium", marginLeft: "space30", element: `${e}_TEXT` }, o) : null));
Ynt.displayName = "PaginationBackArrow";
var Xnt = P.forwardRef(({ as: t = "button", element: e = "PAGINATION_ARROW", disabled: r, isFocused: n, isHovered: a, label: i, visibleLabel: o, ...s }, l) => P.createElement(lge, { ...s, ref: l, element: `${e}_BUTTON`, as: t, disabled: r, visibleLabel: o }, o ? P.createElement(cl, { "aria-hidden": "true", as: "span", color: a ? "colorTextLink" : "inherit", fontWeight: "fontWeightMedium", marginRight: "space30", element: `${e}_TEXT` }, o) : null, P.createElement(cge, { isFocused: n, isHovered: a, element: `${e}_ICON_WRAPPER` }, P.createElement(Ihe, { decorative: !1, color: a ? "colorTextPrimary" : "colorText", display: "block", title: i, element: `${e}_ICON` }))));
Xnt.displayName = "PaginationForwardArrow";
var Qnt = P.forwardRef(({ as: t = "button", element: e = "PAGINATION_ARROW", disabled: r, href: n, isHovered: a = !1, isFocused: i = !1, label: o, variant: s = "back", visibleLabel: l, ...c }, u) => {
  let [f, h] = P.useState(a), [p, g] = P.useState(i);
  return Jnt({ as: t, href: n }), s === "back" ? P.createElement(Ynt, { ...c, element: e, ref: u, as: t, disabled: r, href: n, isFocused: p, isHovered: f, label: o, variant: s, visibleLabel: l, onMouseEnter: (y) => {
    typeof c.onMouseEnter == "function" && c.onMouseEnter(y), h(!0);
  }, onMouseLeave: (y) => {
    typeof c.onMouseLeave == "function" && c.onMouseLeave(y), h(!1);
  }, onFocus: (y) => {
    typeof c.onFocus == "function" && c.onFocus(y), g(!0);
  }, onBlur: (y) => {
    typeof c.onBlur == "function" && c.onBlur(y), g(!1);
  } }) : P.createElement(Xnt, { ...c, element: e, ref: u, as: t, disabled: r, href: n, isFocused: p, isHovered: f, label: o, variant: s, visibleLabel: l, onMouseEnter: (y) => {
    typeof c.onMouseEnter == "function" && c.onMouseEnter(y), h(!0);
  }, onMouseLeave: (y) => {
    typeof c.onMouseLeave == "function" && c.onMouseLeave(y), h(!1);
  }, onFocus: (y) => {
    typeof c.onFocus == "function" && c.onFocus(y), g(!0);
  }, onBlur: (y) => {
    typeof c.onBlur == "function" && c.onBlur(y), g(!1);
  } });
});
Qnt.displayName = "PaginationArrow";
var uge = P.forwardRef(({ children: t, element: e = "PAGINATION_LABEL", ...r }, n) => P.createElement(cl, { ...lg(r), ref: n, element: e, as: "div", color: "colorTextWeak", textAlign: "center", fontWeight: "fontWeightNormal", lineHeight: "lineHeight50" }, t));
uge.displayName = "PaginationLabel";
var eat = P.forwardRef(({ label: t, element: e = "PAGINATION_ELLIPSIS", ...r }, n) => P.createElement(cl, { ...lg(r), ref: n, element: e, "aria-label": t, as: "span", display: "inline-block", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", paddingTop: "space20", fontWeight: "fontWeightMedium" }, "…"));
eat.displayName = "PaginationEllipsis";
var tat = P.forwardRef(({ as: t = "button", element: e = "PAGINATION_NUMBER", children: r, href: n, isCurrent: a, label: i, ...o }, s) => (Jnt({ as: t, href: n }), P.createElement(ht, { ...Xt(o), ref: s, element: e, "aria-label": i, "aria-current": a, as: t, href: n, appearance: "none", background: "none", backgroundColor: a ? "colorBackgroundPrimaryWeakest" : "transparent", borderColor: a ? "colorBorderPrimary" : "transparent", borderRadius: "borderRadius20", borderStyle: "solid", borderWidth: "borderWidth10", color: a ? "colorTextLink" : "colorTextWeak", display: "inline-block", fontFamily: "inherit", fontSize: "fontSize30", fontVariantNumeric: "tabular-nums", fontWeight: "fontWeightNormal", lineHeight: "lineHeight30", margin: "space0", outline: "none", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", paddingTop: "space20", position: "relative", textDecoration: "none", transition: "background-color 100ms ease-in, border-color 100ms ease-in, box-shadow 100ms ease-in, color 100ms ease-in", _hover: { backgroundColor: "colorBackgroundPrimaryWeakest", borderColor: a ? "colorBorderPrimaryStronger" : "transparent", boxShadow: a ? "none" : "shadowBorderPrimaryStronger", color: "colorTextLinkStronger", cursor: "pointer", textDecoration: "none" }, _focus: { boxShadow: "shadowFocus", borderColor: "transparent", textDecoration: "none", color: "colorTextLink" }, _active: { textDecoration: "none" } }, r ? P.createElement(cl, { "aria-hidden": "true", as: "span", color: "inherit", fontWeight: "fontWeightMedium", element: `${e}_TEXT` }, r) : null)));
tat.displayName = "PaginationNumber";
var rat = P.forwardRef(({ children: t, element: e = "PAGINATION_NUMBERS", pageLabel: r, ...n }, a) => {
  let [i] = P.useMemo(() => [P.Children.toArray(t).filter((s) => P.isValidElement(s))], [t]), o = JI();
  return P.createElement(P.Fragment, null, P.createElement(ht, { ...qnt, ...Xt(n), element: e, ref: a, as: "ul", justifyContent: "center", paddingLeft: "space40", paddingRight: "space40", paddingBottom: "space20", width: "100%" }, i.map((s, l) => P.createElement(ht, { ...Knt, key: o(`pagination-numbers-${l}`), element: `${e}_ITEM`, as: "li", marginRight: "space30", _last: { marginRight: "space0" } }, s))), r ? P.createElement(uge, null, r) : null);
});
rat.displayName = "PaginationNumbers";
const zvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Pagination: Vnt,
  PaginationArrow: Qnt,
  PaginationEllipsis: eat,
  PaginationItems: Znt,
  PaginationLabel: uge,
  PaginationNumber: tat,
  PaginationNumbers: rat
}, Symbol.toStringTag, { value: "Module" })), Gvr = /* @__PURE__ */ aa(zvr);
var qAe;
function Wvr() {
  return qAe || (qAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Gvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(XQ)), XQ;
}
var H3 = /* @__PURE__ */ Wvr();
const Hvr = 7, KAe = 4, Uvr = ({
  itemCount: t,
  current: e,
  pageSize: r,
  goToPage: n
}) => {
  const a = Math.ceil(t / r), i = (l) => Array.from({ length: l }, (c, u) => u + 1);
  if (a < 2)
    return /* @__PURE__ */ R.jsx("span", { "data-testid": "no-pagination" });
  let o = [];
  a <= Hvr ? o = i(a) : e <= KAe ? o = [1, 2, 3, 4, 5, 0, a] : a - e < KAe ? o = [
    1,
    0,
    a - 4,
    a - 3,
    a - 2,
    a - 1,
    a
  ] : o = [1, 0, e - 1, e, e + 1, 0, a];
  const s = `${(e - 1) * r + 1}-${Math.min(
    e * r,
    t
  )} of ${t} items`;
  return /* @__PURE__ */ R.jsx(
    Hnt.Flex,
    {
      "data-testid": "adaptive-pagination",
      hAlignContent: "center",
      vertical: !0,
      padding: "space0",
      children: /* @__PURE__ */ R.jsx(H3.Pagination, { label: "truncated pagination navigation", children: /* @__PURE__ */ R.jsxs(H3.PaginationItems, { children: [
        /* @__PURE__ */ R.jsx(
          H3.PaginationArrow,
          {
            "data-testid": "back_arrow",
            label: "Go to previous page",
            variant: "back",
            disabled: e === 1,
            onClick: () => n(e - 1)
          }
        ),
        /* @__PURE__ */ R.jsx(H3.PaginationNumbers, { pageLabel: s, children: o.map((l, c) => l === 0 ? /* @__PURE__ */ R.jsx(
          H3.PaginationEllipsis,
          {
            "data-testid": `pe_${c + 1}`,
            label: "Collapsed pages"
          },
          c
        ) : /* @__PURE__ */ R.jsx(
          H3.PaginationNumber,
          {
            "data-testid": `pn_${c + 1}`,
            label: `Go to page ${l}`,
            isCurrent: e === l,
            onClick: () => n(l),
            children: l
          },
          l
        )) }),
        /* @__PURE__ */ R.jsx(
          H3.PaginationArrow,
          {
            "data-testid": "forward_arrow",
            label: "Go to next page",
            variant: "forward",
            disabled: e === a,
            onClick: () => n(e + 1)
          }
        )
      ] }) })
    }
  );
}, Vvr = ({
  onCreatePromptClickHandler: t,
  promptEditClickHandler: e,
  promptRunClickHandler: r,
  setCurrentPage: n,
  currentPage: a
}) => {
  const i = yW(), { requestTransformer: o } = Ja(), {
    data: { prompts: s, page: l } = {},
    isLoading: c,
    isError: u
  } = nKe({
    offset: (a - 1) * KQ,
    limit: KQ,
    requestTransformer: o
  }), [f] = rPt(), [h, p] = Yt();
  Ut(() => {
    if (l) {
      const { limit: b, total: w, offset: _ } = l;
      n(Math.ceil(_ / b) + 1), p(w);
    }
  }, [l]), Ut(() => {
    u && i.push({
      message: jb(
        "Failed to load prompts",
        "The prompts failed to load. Please refresh and try again."
      ),
      variant: "error",
      id: "Failed to load prompts",
      dismissAfter: Lb
    });
  }, [u]);
  const g = async (b) => {
    try {
      await f({
        promptId: b.id,
        requestTransformer: o
      }).unwrap(), i.push({
        message: jb("", `${b.name} has been deleted!`),
        variant: "success",
        dismissAfter: Lb
      });
    } catch {
      i.push({
        message: jb("", `Failed to delete prompt ${b.name}`),
        variant: "error",
        dismissAfter: Lb
      });
    }
  }, y = (b) => {
    n(b);
  };
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    s && s.length > 0 && /* @__PURE__ */ R.jsxs(
      ar.Box,
      {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        rowGap: "space70",
        children: [
          /* @__PURE__ */ R.jsx(ar.Box, { as: "div", display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ R.jsxs(zi.Button, { variant: "secondary", onClick: t, children: [
            /* @__PURE__ */ R.jsx(
              fW,
              {
                decorative: !1,
                title: "Create a Prompt Button Icon"
              }
            ),
            "Create prompt"
          ] }) }),
          /* @__PURE__ */ R.jsx(ar.Box, { overflowY: "auto", flexGrow: 1, children: s.map((b) => /* @__PURE__ */ R.jsx(
            Sbr,
            {
              prompt: b,
              onPromptDeleteConfirmed: () => g(b),
              onPromptEditClicked: e,
              onPromptRunClicked: () => r(b)
            },
            b.id
          )) }),
          /* @__PURE__ */ R.jsx(ar.Box, { as: "div", display: "flex", justifyContent: "center", children: h && a && /* @__PURE__ */ R.jsx(
            Uvr,
            {
              itemCount: h,
              current: a,
              pageSize: KQ,
              goToPage: (b) => y(b)
            }
          ) })
        ]
      }
    ),
    !c && s && s.length === 0 && /* @__PURE__ */ R.jsx(Lvr, { onCreatePromptClicked: t }),
    c && /* @__PURE__ */ R.jsx($vr, {})
  ] });
};
var QQ = {}, qvr = "sizeIcon10", dge = (t) => {
  let e = JI();
  return Array.isArray(t) ? P.Children.map(t, (r) => {
    var n, a;
    return typeof r == "object" && !Array.isArray(r) && typeof ((n = r == null ? void 0 : r.type) == null ? void 0 : n.displayName) == "string" && ((a = r == null ? void 0 : r.type) != null && a.displayName.includes("Icon")) ? P.cloneElement(r, { ...r.props, key: e(r), size: qvr }) : P.createElement(P.Fragment, { key: e(r) }, r);
  }) : t;
}, fge = { alignItems: "center", border: "unset", borderRadius: "borderRadius20", columnGap: "space20", display: "flex", fontSize: "fontSize20", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight10", maxWidth: "max-content", appearance: "none", background: "none", outline: "none", fontFamily: "inherit", position: "relative" }, nat = { success: { backgroundColor: "colorBackgroundSuccessWeakest", color: "colorTextSuccess", boxShadow: "shadowBorderSuccessWeaker" }, error: { backgroundColor: "colorBackgroundErrorWeakest", color: "colorTextError", boxShadow: "shadowBorderErrorWeaker" }, warning: { backgroundColor: "colorBackgroundWarningWeakest", color: "colorTextWarning", boxShadow: "shadowBorderWarningWeaker" }, new: { backgroundColor: "colorBackgroundNewWeakest", color: "colorTextNew", boxShadow: "shadowBorderNewWeaker" }, neutral: { backgroundColor: "colorBackgroundNeutralWeakest", color: "colorTextNeutral", boxShadow: "shadowBorderNeutralWeaker" }, subaccount: { backgroundColor: "colorBackgroundSubaccount", color: "colorTextSubaccount", boxShadow: "shadowBorderSubaccount" }, decorative10: { backgroundColor: "colorBackgroundDecorative10Weakest", color: "colorTextDecorative10", boxShadow: "shadowBorderDecorative10Weaker" }, decorative20: { backgroundColor: "colorBackgroundDecorative20Weakest", color: "colorTextDecorative20", boxShadow: "shadowBorderDecorative20Weaker" }, decorative30: { backgroundColor: "colorBackgroundDecorative30Weakest", color: "colorTextDecorative30", boxShadow: "shadowBorderDecorative30Weaker" }, decorative40: { backgroundColor: "colorBackgroundDecorative40Weakest", color: "colorTextDecorative40", boxShadow: "shadowBorderDecorative40Weaker" }, brand10: { backgroundColor: "colorBackgroundBrand10", color: "colorTextBrand", boxShadow: "shadowBorderBrand10" }, brand20: { backgroundColor: "colorBackgroundBrand20", color: "colorTextBrand", boxShadow: "shadowBorderBrand20" }, brand30: { backgroundColor: "colorBackgroundBrand30", color: "colorTextBrand", boxShadow: "shadowBorderBrand30" }, neutral_counter: { backgroundColor: "colorBackgroundNeutralWeakest", color: "colorTextNeutral", borderRadius: "borderRadiusPill", boxShadow: "shadowBorderNeutralWeaker" }, error_counter: { backgroundColor: "colorBackgroundErrorWeakest", color: "colorTextError", borderRadius: "borderRadiusPill", boxShadow: "shadowBorderErrorWeaker" }, default: { backgroundColor: "colorBackgroundBody", color: "colorText", boxShadow: "shadowBorderWeaker" }, notification_counter: { borderRadius: "borderRadiusPill", backgroundColor: "colorBackgroundNotification", color: "colorTextInverse", boxShadow: "shadowBorderNotification" }, info: { backgroundColor: "colorBackgroundNeutralWeakest", color: "colorTextNeutral", boxShadow: "shadowBorderNeutralWeaker" } }, aat = { success: { boxShadow: "shadowBorderBottomSuccessWeaker" }, error: { boxShadow: "shadowBorderBottomErrorWeaker" }, warning: { boxShadow: "shadowBorderBottomWarningWeaker" }, new: { boxShadow: "shadowBorderBottomNewWeaker" }, neutral: { boxShadow: "shadowBorderBottomNeutralWeaker" }, subaccount: { boxShadow: "shadowBorderBottomSubaccount" }, decorative10: { boxShadow: "shadowBorderBottomDecorative10Weaker" }, decorative20: { boxShadow: "shadowBorderBottomDecorative20Weaker" }, decorative30: { boxShadow: "shadowBorderBottomDecorative30Weaker" }, decorative40: { boxShadow: "shadowBorderBottomDecorative40Weaker" }, brand10: { boxShadow: "shadowBorderBottomBrand10Strong" }, brand20: { boxShadow: "shadowBorderBottomBrand20Strong" }, brand30: { boxShadow: "shadowBorderBottomBrand30Strong" }, neutral_counter: { boxShadow: "shadowBorderBottomNeutralWeaker" }, error_counter: { boxShadow: "shadowBorderBottomErrorWeaker" }, notification_counter: { boxShadow: "shadowBorderBottomNotificationStronger" }, default: { boxShadow: "shadowBorderBottomDecorative10Weaker" }, info: { boxShadow: "shadowBorderBottomNeutralWeaker" } }, Kvr = { textDecoration: "underline", cursor: "pointer", _hover: { textDecoration: "none" }, _focus: { textDecoration: "none", boxShadow: "shadowFocus" } }, iat = (t) => ({ ...aat[t], cursor: "pointer", _hover: { top: "1px", boxShadow: "none" }, _focus: { top: "1px", boxShadow: "shadowFocus" } }), Zvr = ["neutral", "warning", "error", "success", "new", "subaccount", "decorative10", "decorative20", "decorative30", "decorative40", "brand10", "brand20", "brand30", "neutral_counter", "error_counter", "default", "notification_counter", "info"], hW = P.forwardRef(({ as: t, href: e, variant: r, size: n = "default", children: a, element: i = "BADGE", ...o }, s) => {
  let l = dge(a), c = { ...fge, ...nat[r] };
  return t === "a" && (c = { ...c, ...Kvr }), t === "button" && (c = { ...c, ...iat(r) }), P.createElement(ht, { ...Xt(o), ...e ? T8(e) : {}, href: e, as: t, element: i, paddingX: n === "small" ? "space20" : "space30", paddingY: n === "small" ? "space10" : "space20", minWidth: n === "small" ? "sizeBase50" : "size0", justifyContent: "center", variant: r, ref: s, ...c }, r === "error_counter" ? P.createElement(fy, { element: `${i}_ICON`, decorative: !0, size: "sizeIcon10" }) : null, l);
});
hW.displayName = "Badge";
const Jvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Badge: hW,
  BadgeVariants: Zvr,
  badgeBaseStyles: fge,
  badgeButtonStyles: aat,
  badgeVariantStyles: nat,
  getBadgeButtonStyles: iat,
  useResizeChildIcons: dge
}, Symbol.toStringTag, { value: "Module" })), Yvr = /* @__PURE__ */ aa(Jvr);
var ZAe;
function Xvr() {
  return ZAe || (ZAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Yvr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(QQ)), QQ;
}
var JM = /* @__PURE__ */ Xvr();
const hge = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `UserIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[UserIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M10 3.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM6.5 6a3.5 3.5 0 117 0 3.5 3.5 0 01-7 0zm3.5 5.5A5.5 5.5 0 004.5 17a.5.5 0 01-1 0 6.5 6.5 0 1113 0 .5.5 0 01-1 0 5.5 5.5 0 00-5.5-5.5z" })));
});
hge.displayName = "UserIcon";
const oat = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `MoreIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[MoreIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 14.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zm0-6c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zm0-6c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5S8.5 4.827 8.5 4s.673-1.5 1.5-1.5z" })));
});
oat.displayName = "MoreIcon";
const pge = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ProductRegionalIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ProductRegionalIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.343 13.167c.03-.068.055-.138.083-.207a7.905 7.905 0 00.56-2.695c.003-.088.014-.175.014-.265 0-.11-.012-.217-.017-.326-.004-.108-.007-.216-.016-.323a7.97 7.97 0 00-.08-.638 7.915 7.915 0 00-.598-1.992c-.022-.048-.046-.096-.07-.144a7.976 7.976 0 00-.42-.77c-.026-.043-.05-.086-.077-.128a8.027 8.027 0 00-.267-.385c-.016-.021-.03-.044-.046-.066a.493.493 0 00-.033-.04 7.99 7.99 0 00-14.217 3.21V8.4a8.116 8.116 0 00-.11.713l-.014.152a8.002 8.002 0 00.003 1.529l.006.052c.054.518.16 1.029.313 1.526l.003.009a7.93 7.93 0 00.996 2.072l.019.027c.273.403.583.779.925 1.125.038.039.077.076.117.114.126.123.257.242.392.357l.157.134c.017.013.032.028.049.042.008.006.017.008.026.014a7.981 7.981 0 0012.02-2.516l.011-.015c.1-.187.188-.377.271-.57zm-.37-2.647c-.006.09-.01.18-.02.269-.02.173-.047.345-.08.514-.015.083-.034.166-.052.248-.03.13-.063.258-.1.385-.017.063-.033.126-.053.188a6.94 6.94 0 01-.193.526c-.024.06-.05.118-.077.177-.026.06-.056.117-.084.175h-.967a.498.498 0 01-.494-.418l-.527-3.166A.5.5 0 0013.833 9H12.78a.5.5 0 01-.485-.621l.5-2A.499.499 0 0113.28 6h2.454a6.899 6.899 0 01.29.455c.067.112.133.226.193.342.128.25.24.505.336.766.016.043.033.086.048.13a7 7 0 01.327 1.36 7.058 7.058 0 01.066.838c.002.1-.001.2-.004.3-.003.11-.008.22-.017.33zM5.508 12.402l-.5 2.499a7.054 7.054 0 01-.424-.47A6.965 6.965 0 013 10.014v-.027c0-.228.012-.454.034-.677l.008-.067c.009-.082.025-.162.037-.243h3.14c.229 0 .43.156.484.379l.501 2.002a.5.5 0 01-.486.619h-.719a.5.5 0 00-.49.402zM9.998 17a6.955 6.955 0 01-4.12-1.353L6.409 13h.31a1.502 1.502 0 001.455-1.864l-.5-2A1.498 1.498 0 006.218 8H3.293a6.99 6.99 0 0111.596-3h-1.61c-.688 0-1.288.468-1.454 1.136l-.5 2A1.501 1.501 0 0012.78 10h.63l.457 2.75c.119.723.746 1.254 1.48 1.252h.388A6.994 6.994 0 019.999 17z" })));
});
pge.displayName = "ProductRegionalIcon";
const mge = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `PlayIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[PlayIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M6.153 4.465a1.003 1.003 0 011.277-.368l.102.056 8.002 5.002a.99.99 0 01.096 1.616l-.095.067-8.002 5.01c-.16.099-.344.152-.533.152a.998.998 0 01-.993-.878L6 15.006V4.994a.99.99 0 01.153-.529z" })));
});
mge.displayName = "PlayIcon";
var eee = {}, gge = P.forwardRef(({ element: t = "SEPARATOR", orientation: e, horizontalSpacing: r, verticalSpacing: n, ...a }, i) => P.createElement(ht, { ...Xt(a), "aria-orientation": e, element: t, margin: "space0", marginBottom: n, marginLeft: r, marginRight: r, marginTop: n, as: "hr", borderWidth: "borderWidth0", borderColor: "colorBorderWeaker", borderStyle: "solid", borderBottomWidth: e === "horizontal" ? "borderWidth10" : null, borderLeftWidth: e === "vertical" ? "borderWidth10" : null, width: e === "horizontal" ? "auto" : null, height: e === "vertical" ? "auto" : null, ref: i }));
gge.displayName = "Separator";
const Qvr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Separator: gge
}, Symbol.toStringTag, { value: "Module" }));
var sat = P.forwardRef(({ style: t, ...e }, r) => P.createElement(ht, { ...Xt(e), backgroundColor: "colorBackgroundWeaker", borderRadius: "borderRadius30", boxShadow: "shadowElevation10", maxWidth: "size30", minWidth: "size20", zIndex: "zIndex20", paddingY: "space30", _focus: { outline: "none" }, style: t, ref: r }, P.createElement(ht, { maxHeight: "size50", overflowY: "auto" }, e.children)));
sat.displayName = "StyledMenu";
var lat = P.forwardRef(({ element: t = "MENU", ...e }, r) => P.createElement(Uor, { ...e, element: t, as: sat, ref: r }));
lat.displayName = "Menu";
var cat = P.forwardRef(({ element: t = "MENU_BUTTON", ...e }, r) => P.createElement(spe, { ...e, element: t, as: Zs, ref: r }, e.children));
cat.displayName = "MenuButton";
var vge = P.forwardRef(({ children: t, element: e, i18nButtonLabel: r, ...n }, a) => P.createElement(ht, { as: "span", display: "flex", flexDirection: "row", columnGap: "space20", alignItems: "center" }, t, P.createElement(spe, { ...n, variant: "secondary_icon", size: "reset", element: `${e}_BUTTON`, as: Zs, ref: a }, P.createElement(I8, { decorative: !0, size: "sizeIcon10" }), P.createElement(Ul, null, r))));
vge.displayName = "MenuBadgeContent";
var uat = P.forwardRef(({ children: t, element: e = "MENU_BADGE", variant: r = "default", i18nButtonLabel: n, ...a }, i) => P.createElement(hW, { element: e, as: "span", variant: r }, P.createElement(vge, { ...a, element: e, i18nButtonLabel: n, ref: i }, t)));
uat.displayName = "MenuBadge";
var Zc = { DEFAULT: "default", DESTRUCTIVE: "destructive", GROUP_ITEM: "group_item", DESTRUCTIVE_GROUP_ITEM: "destructive_group_item" }, YM = P.createContext(Zc.DEFAULT), dat = P.forwardRef(({ label: t, icon: e, children: r, element: n = "MENU_GROUP", ...a }, i) => P.createElement(YM.Provider, { value: Zc.GROUP_ITEM }, P.createElement(ht, { ...Xt(a), element: n, role: "presentation", "aria-label": t, textDecoration: "none", ref: i }, P.createElement(ht, { display: "flex", alignItems: "center", paddingX: "space70", paddingY: "space30", cursor: "default" }, P.isValidElement(e) ? P.createElement(ht, { flexShrink: 0, size: "sizeIcon30" }, P.cloneElement(e, { color: "colorTextIcon" })) : null, P.createElement(cl, { as: "span", color: "colorTextWeak", fontSize: "fontSize20", role: "presentation", fontWeight: "fontWeightBold", paddingLeft: e != null ? "space20" : void 0 }, t)), r)));
dat.displayName = "MenuGroup";
var Zue = { [Zc.DEFAULT]: { color: "colorText", _hover: { color: "colorTextPrimary", backgroundColor: "colorBackgroundPrimaryWeakest", borderColor: "colorBorderPrimary" }, _focus: { color: "colorTextPrimary", backgroundColor: "colorBackgroundPrimaryWeakest", borderColor: "colorBorderPrimary" } }, [Zc.DESTRUCTIVE]: { color: "colorTextDestructive", _hover: { backgroundColor: "colorBackgroundDestructiveWeakest", borderColor: "colorBorderDestructive" }, _focus: { backgroundColor: "colorBackgroundDestructiveWeakest", borderColor: "colorBorderDestructive" } } }, eyr = { [Zc.GROUP_ITEM]: { ...Zue[Zc.DEFAULT], paddingLeft: "space90" }, [Zc.DESTRUCTIVE_GROUP_ITEM]: { ...Zue[Zc.DESTRUCTIVE], paddingLeft: "space90" } }, tyr = { ...Zue, ...eyr }, ryr = ({ disabled: t, variant: e }) => t || e === Zc.DESTRUCTIVE || e === Zc.DESTRUCTIVE_GROUP_ITEM ? "inherit" : "colorTextPrimary", pW = (t, e) => e ? t === Zc.DESTRUCTIVE ? Zc.DESTRUCTIVE_GROUP_ITEM : Zc.GROUP_ITEM : t, q8 = P.forwardRef(({ element: t = "STYLED_MENU_ITEM", href: e, variant: r = "default", tabIndex: n, children: a, ...i }, o) => P.createElement(ht, { variant: r, ...e && T8(e), href: e, as: e ? "a" : "button", ...Xt(i), element: t, appearance: "none", background: "none", border: "none", display: "block", textAlign: "left", fontFamily: "inherit", fontSize: "fontSize30", fontWeight: "fontWeightNormal", lineHeight: "lineHeight30", margin: "space0", outline: "none", paddingY: "space30", borderLeftStyle: "solid", borderLeftWidth: "borderWidth20", borderColor: "transparent", cursor: "pointer", paddingX: "space70", width: "100%", ...tyr[r], _disabled: { color: "colorTextWeaker", cursor: "not-allowed", backgroundColor: "colorBackgroundWeaker", borderColor: "transparent" }, ref: o }, i["aria-checked"] != null ? P.createElement(ht, { as: "span", display: "flex", columnGap: "space50", justifyContent: "space-between", alignItems: "center" }, a, P.createElement(ht, { as: "span", visibility: i["aria-checked"] ? "visible" : "hidden" }, P.createElement(Zpe, { decorative: !0, color: ryr({ disabled: i.disabled, variant: r }) }))) : a));
q8.displayName = "StyledMenuItem";
var fat = P.forwardRef(({ as: t = q8, variant: e, element: r = "MENU_ITEM", ...n }, a) => {
  let i = P.useContext(YM) === Zc.GROUP_ITEM, o = e && pW(e, i);
  return P.createElement(rsr, { ...n, element: r, variant: o, as: t, ref: a });
});
fat.displayName = "MenuItem";
var hat = P.forwardRef(({ as: t = q8, variant: e, element: r = "MENU_ITEM_CHECKBOX", ...n }, a) => {
  let i = P.useContext(YM) === Zc.GROUP_ITEM, o = e && pW(e, i);
  return P.createElement(asr, { ...n, element: r, variant: o, as: t, ref: a });
});
hat.displayName = "MenuItemCheckbox";
var pat = P.forwardRef(({ as: t = q8, variant: e, element: r = "MENU_ITEM_RADIO", ...n }, a) => {
  let i = P.useContext(YM) === Zc.GROUP_ITEM, o = e && pW(e, i);
  return P.createElement(osr, { ...n, element: r, variant: o, as: t, ref: a });
});
pat.displayName = "MenuItemRadio";
var mat = P.forwardRef((t, e) => P.createElement(gge, { ...t, orientation: "horizontal", verticalSpacing: "space40", ref: e }));
mat.displayName = "StyledMenuSeparator";
var gat = P.forwardRef(({ element: t = "MENU_SEPARATOR", ...e }, r) => P.createElement(csr, { ...e, element: t, as: mat, ref: r }));
gat.displayName = "MenuSeparator";
var vat = P.forwardRef(({ element: t = "SUBMENU_BUTTON", ...e }, r) => P.createElement(spe, { ...e, as: q8, element: t, ref: r }, P.createElement(Q5, { as: "span", verticalAlign: "center", element: `${t}_MEDIA_OBJECT` }, e.children && P.createElement(e6, { as: "span", element: `${t}_MEDIA_BODY` }, e.children), P.createElement(qm, { as: "span", align: "end", spacing: "space20", element: `${t}_MEDIA_FIGURE` }, P.createElement(nG, { decorative: !0, size: "sizeIcon30", element: `${t}_ICON` })))));
vat.displayName = "SubMenuButton";
const nyr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Menu: lat,
  MenuBadge: uat,
  MenuBadgeContent: vge,
  MenuButton: cat,
  MenuGroup: dat,
  MenuGroupContext: YM,
  MenuItem: fat,
  MenuItemCheckbox: hat,
  MenuItemRadio: pat,
  MenuSeparator: gat,
  StyledMenuItem: q8,
  SubMenuButton: vat,
  getComputedVariant: pW,
  useMenuState: usr
}, Symbol.toStringTag, { value: "Module" })), ayr = /* @__PURE__ */ aa(nyr);
var JAe;
function iyr() {
  return JAe || (JAe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = ayr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(eee)), eee;
}
var i1 = /* @__PURE__ */ iyr();
const yat = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `EditIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[EditIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.345 3.646c.973-.972 2.434-.845 3.646.368 1.21 1.21 1.333 2.662.36 3.636L8.39 15.613a.525.525 0 01-.01.011l-.013.01-.28.28a.515.515 0 01-.157.108l-.091.03-4.081.937a.618.618 0 01-.742-.74l.926-4.089a.515.515 0 01.138-.25l6.84-6.84a.525.525 0 01.01-.01l.009-.008zM4.847 12.82l-.682 3.016 3.007-.69-2.325-2.326zm6.446-6.668l-5.829 5.828 2.549 2.549 5.828-5.829-2.548-2.548zm3.97-1.41c-.836-.836-1.65-.907-2.19-.369l-1.051 1.051 2.548 2.548 1.053-1.051c.48-.482.48-1.171-.11-1.903l-.119-.138z" })));
});
yat.displayName = "EditIcon";
const bat = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DeleteIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DeleteIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.25 2c.966 0 1.75.784 1.75 1.75L13.999 5H17.5a.5.5 0 01.09.992L17.5 6h-1.501L16 16.25a1.75 1.75 0 01-1.606 1.744L14.25 18H5.74C4.774 18 4 17.217 4 16.25L3.999 6H2.5a.5.5 0 01-.09-.992L2.5 5h3.499L6 3.75a1.75 1.75 0 011.606-1.744L7.75 2zm2.749 4h-10L5 16.25c0 .383.276.694.64.743l.1.007h8.51a.75.75 0 00.75-.75L14.999 6zM8.5 9a.5.5 0 01.492.41L9 9.5v4a.5.5 0 01-.992.09L8 13.5v-4a.5.5 0 01.5-.5zm3 0a.5.5 0 01.492.41L12 9.5v4a.5.5 0 01-.992.09L11 13.5v-4a.5.5 0 01.5-.5zm.75-6h-4.5a.75.75 0 00-.75.75L6.999 5h6L13 3.75a.75.75 0 00-.648-.743L12.25 3z" })));
});
bat.displayName = "DeleteIcon";
var tee = {}, oyr = Object.create, xat = Object.defineProperty, syr = Object.getOwnPropertyDescriptor, Cat = Object.getOwnPropertyNames, lyr = Object.getPrototypeOf, cyr = Object.prototype.hasOwnProperty, yge = (t, e) => function() {
  return e || (0, t[Cat(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, uyr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Cat(e)) !cyr.call(t, a) && a !== r && xat(t, a, { get: () => e[a], enumerable: !(n = syr(e, a)) || n.enumerable });
  return t;
}, dyr = (t, e, r) => (r = t != null ? oyr(lyr(t)) : {}, uyr(!t || !t.__esModule ? xat(r, "default", { value: t, enumerable: !0 }) : r, t)), fyr = yge({ "../../../../node_modules/prop-types/lib/ReactPropTypesSecret.js"(t, e) {
  var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  e.exports = r;
} }), hyr = yge({ "../../../../node_modules/prop-types/factoryWithThrowingShims.js"(t, e) {
  var r = fyr();
  function n() {
  }
  function a() {
  }
  a.resetWarningCache = n, e.exports = function() {
    function i(l, c, u, f, h, p) {
      if (p !== r) {
        var g = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw g.name = "Invariant Violation", g;
      }
    }
    i.isRequired = i;
    function o() {
      return i;
    }
    var s = { array: i, bigint: i, bool: i, func: i, number: i, object: i, string: i, symbol: i, any: i, arrayOf: o, element: i, elementType: i, instanceOf: o, node: i, objectOf: o, oneOf: o, oneOfType: o, shape: o, exact: o, checkPropTypes: a, resetWarningCache: n };
    return s.PropTypes = s, s;
  };
} }), pyr = yge({ "../../../../node_modules/prop-types/index.js"(t, e) {
  e.exports = hyr()();
} });
function wat() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var myr = wat() ? qh : Ut;
function gyr() {
  var t = Yt(/* @__PURE__ */ Object.create(null)), e = t[1];
  return sr(function() {
    e(/* @__PURE__ */ Object.create(null));
  }, []);
}
var vyr = function(t) {
  var e = t.children, r = t.type, n = r === void 0 ? "reach-portal" : r, a = t.containerRef, i = Zt(null), o = Zt(null), s = gyr();
  return myr(function() {
    if (i.current) {
      var l = i.current.ownerDocument, c = (a == null ? void 0 : a.current) || l.body;
      return o.current = l == null ? void 0 : l.createElement(n), c.appendChild(o.current), s(), function() {
        o.current && c && c.removeChild(o.current);
      };
    }
  }, [n, s, a]), o.current ? aWe(e, o.current) : Ds("span", { ref: i });
};
function yyr(t) {
  return wat() ? t ? t.ownerDocument : document : null;
}
function byr(t) {
  return !!(t && {}.toString.call(t) == "[object Function]");
}
function Sat() {
}
function YAe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function xyr(t, e) {
  if (t) {
    if (typeof t == "string") return YAe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return YAe(t, e);
  }
}
function Cyr(t, e) {
  var r;
  if (typeof Symbol > "u" || t[Symbol.iterator] == null) {
    if (Array.isArray(t) || (r = xyr(t)) || e) {
      r && (t = r);
      var n = 0;
      return function() {
        return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  return r = t[Symbol.iterator](), r.next.bind(r);
}
function wyr(t, e) {
  if (t != null) if (byr(t)) t(e);
  else try {
    t.current = e;
  } catch {
    throw new Error('Cannot assign value "' + e + '" to ref "' + t + '"');
  }
}
function Syr() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return sr(function(n) {
    for (var a = Cyr(e), i; !(i = a()).done; ) {
      var o = i.value;
      wyr(o, n);
    }
  }, e);
}
function v$(t, e) {
  return function(r) {
    if (t && t(r), !r.defaultPrevented) return e(r);
  };
}
function _yr(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function oE() {
  return oE = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, oE.apply(this, arguments);
}
var Jue = "data-focus-lock", _at = "data-focus-lock-disabled", kyr = "data-no-focus-lock", Ayr = "data-autofocus-inside", Tyr = "data-no-autofocus";
function Eyr(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function Iyr(t, e) {
  var r = Yt(function() {
    return { value: t, callback: e, facade: { get current() {
      return r.value;
    }, set current(n) {
      var a = r.value;
      a !== n && (r.value = n, r.callback(n, a));
    } } };
  })[0];
  return r.callback = e, r.facade;
}
function kat(t, e) {
  return Iyr(null, function(r) {
    return t.forEach(function(n) {
      return Eyr(n, r);
    });
  });
}
var ree = { width: "1px", height: "0px", padding: 0, overflow: "hidden", position: "fixed", top: "1px", left: "1px" }, eh = function() {
  return eh = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && (t[a] = e[a]);
    }
    return t;
  }, eh.apply(this, arguments);
};
function Aat(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function") for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++) e.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (r[n[a]] = t[n[a]]);
  return r;
}
function Myr(t, e, r) {
  for (var n = 0, a = e.length, i; n < a; n++) (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function Tat(t) {
  return t;
}
function Eat(t, e) {
  e === void 0 && (e = Tat);
  var r = [], n = !1, a = { read: function() {
    if (n) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
    return r.length ? r[r.length - 1] : t;
  }, useMedium: function(i) {
    var o = e(i, n);
    return r.push(o), function() {
      r = r.filter(function(s) {
        return s !== o;
      });
    };
  }, assignSyncMedium: function(i) {
    for (n = !0; r.length; ) {
      var o = r;
      r = [], o.forEach(i);
    }
    r = { push: function(s) {
      return i(s);
    }, filter: function() {
      return r;
    } };
  }, assignMedium: function(i) {
    n = !0;
    var o = [];
    if (r.length) {
      var s = r;
      r = [], s.forEach(i), o = r;
    }
    var l = function() {
      var u = o;
      o = [], u.forEach(i);
    }, c = function() {
      return Promise.resolve().then(l);
    };
    c(), r = { push: function(u) {
      o.push(u), c();
    }, filter: function(u) {
      return o = o.filter(u), r;
    } };
  } };
  return a;
}
function bge(t, e) {
  return e === void 0 && (e = Tat), Eat(t, e);
}
function Iat(t) {
  t === void 0 && (t = {});
  var e = Eat(null);
  return e.options = eh({ async: !0, ssr: !1 }, t), e;
}
var Mat = function(t) {
  var e = t.sideCar, r = Aat(t, ["sideCar"]);
  if (!e) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = e.read();
  if (!n) throw new Error("Sidecar medium not found");
  return P.createElement(n, eh({}, r));
};
Mat.isSideCarExport = !0;
function Pyr(t, e) {
  return t.useMedium(e), Mat;
}
var Pat = bge({}, function(t) {
  var e = t.target, r = t.currentTarget;
  return { target: e, currentTarget: r };
}), Rat = bge(), Ryr = bge(), Oyr = Iat({ async: !0 }), Byr = [], xge = P.forwardRef(function(t, e) {
  var r, n = P.useState(), a = n[0], i = n[1], o = P.useRef(), s = P.useRef(!1), l = P.useRef(null), c = t.children, u = t.disabled, f = t.noFocusGuards, h = t.persistentFocus, p = t.crossFrame, g = t.autoFocus;
  t.allowTextSelection;
  var y = t.group, b = t.className, w = t.whiteList, _ = t.hasPositiveIndices, C = t.shards, x = C === void 0 ? Byr : C, S = t.as, A = S === void 0 ? "div" : S, I = t.lockProps, M = I === void 0 ? {} : I, B = t.sideCar, L = t.returnFocus, N = t.focusOptions, d = t.onActivation, m = t.onDeactivation, v = P.useState({}), k = v[0], O = P.useCallback(function() {
    l.current = l.current || document && document.activeElement, o.current && d && d(o.current), s.current = !0;
  }, [d]), G = P.useCallback(function() {
    s.current = !1, m && m(o.current);
  }, [m]);
  Ut(function() {
    u || (l.current = null);
  }, []);
  var H = P.useCallback(function(Y) {
    var ge = l.current;
    if (ge && ge.focus) {
      var ce = typeof L == "function" ? L(ge) : L;
      if (ce) {
        var ee = typeof ce == "object" ? ce : void 0;
        l.current = null, Y ? Promise.resolve().then(function() {
          return ge.focus(ee);
        }) : ge.focus(ee);
      }
    }
  }, [L]), j = P.useCallback(function(Y) {
    s.current && Pat.useMedium(Y);
  }, []), F = Rat.useMedium, z = P.useCallback(function(Y) {
    o.current !== Y && (o.current = Y, i(Y));
  }, []), W = oE((r = {}, r[_at] = u && "disabled", r[Jue] = y, r), M), U = f !== !0, Z = U && f !== "tail", V = kat([e, z]);
  return P.createElement(P.Fragment, null, U && [P.createElement("div", { key: "guard-first", "data-focus-guard": !0, tabIndex: u ? -1 : 0, style: ree }), _ ? P.createElement("div", { key: "guard-nearest", "data-focus-guard": !0, tabIndex: u ? -1 : 1, style: ree }) : null], !u && P.createElement(B, { id: k, sideCar: Oyr, observed: a, disabled: u, persistentFocus: h, crossFrame: p, autoFocus: g, whiteList: w, shards: x, onActivation: O, onDeactivation: G, returnFocus: H, focusOptions: N }), P.createElement(A, oE({ ref: V }, W, { className: b, onBlur: F, onFocus: j }), c), Z && P.createElement("div", { "data-focus-guard": !0, tabIndex: u ? -1 : 0, style: ree }));
});
xge.propTypes = {};
xge.defaultProps = { children: void 0, disabled: !1, returnFocus: !1, focusOptions: void 0, noFocusGuards: !1, autoFocus: !0, persistentFocus: !1, crossFrame: !0, hasPositiveIndices: void 0, allowTextSelection: void 0, group: void 0, className: void 0, whiteList: void 0, shards: void 0, as: "div", lockProps: {}, onActivation: void 0, onDeactivation: void 0 };
var Oat = xge;
function Yue(t, e) {
  return Yue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, Yue(t, e);
}
function Nyr(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Yue(t, e);
}
function sE(t) {
  return sE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sE(t);
}
function $yr(t, e) {
  if (sE(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (sE(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Dyr(t) {
  var e = $yr(t, "string");
  return sE(e) === "symbol" ? e : String(e);
}
function Lyr(t, e, r) {
  return e = Dyr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function jyr(t, e) {
  function r(n) {
    return n.displayName || n.name || "Component";
  }
  return function(n) {
    var a = [], i;
    function o() {
      i = t(a.map(function(l) {
        return l.props;
      })), e(i);
    }
    var s = function(l) {
      Nyr(c, l);
      function c() {
        return l.apply(this, arguments) || this;
      }
      c.peek = function() {
        return i;
      };
      var u = c.prototype;
      return u.componentDidMount = function() {
        a.push(this), o();
      }, u.componentDidUpdate = function() {
        o();
      }, u.componentWillUnmount = function() {
        var f = a.indexOf(this);
        a.splice(f, 1), o();
      }, u.render = function() {
        return Te.createElement(n, this.props);
      }, c;
    }(g0);
    return Lyr(s, "displayName", "SideEffect(" + r(n) + ")"), s;
  };
}
var Fyr = jyr, ap = function(t) {
  for (var e = Array(t.length), r = 0; r < t.length; ++r) e[r] = t[r];
  return e;
}, XL = function(t) {
  return Array.isArray(t) ? t : [t];
}, Bat = function(t) {
  return Array.isArray(t) ? t[0] : t;
}, zyr = function(t) {
  if (t.nodeType !== Node.ELEMENT_NODE) return !1;
  var e = window.getComputedStyle(t, null);
  return !e || !e.getPropertyValue ? !1 : e.getPropertyValue("display") === "none" || e.getPropertyValue("visibility") === "hidden";
}, Nat = function(t) {
  return t.parentNode && t.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? t.parentNode.host : t.parentNode;
}, $at = function(t) {
  return t === document || t && t.nodeType === Node.DOCUMENT_NODE;
}, Gyr = function(t, e) {
  return !t || $at(t) || !zyr(t) && e(Nat(t));
}, Dat = function(t, e) {
  var r = t.get(e);
  if (r !== void 0) return r;
  var n = Gyr(e, Dat.bind(void 0, t));
  return t.set(e, n), n;
}, Wyr = function(t, e) {
  return t && !$at(t) ? Vyr(t) ? e(Nat(t)) : !1 : !0;
}, Lat = function(t, e) {
  var r = t.get(e);
  if (r !== void 0) return r;
  var n = Wyr(e, Lat.bind(void 0, t));
  return t.set(e, n), n;
}, jat = function(t) {
  return t.dataset;
}, Hyr = function(t) {
  return t.tagName === "BUTTON";
}, Fat = function(t) {
  return t.tagName === "INPUT";
}, zat = function(t) {
  return Fat(t) && t.type === "radio";
}, Uyr = function(t) {
  return !((Fat(t) || Hyr(t)) && (t.type === "hidden" || t.disabled));
}, Vyr = function(t) {
  var e = t.getAttribute(Tyr);
  return ![!0, "true", ""].includes(e);
}, Cge = function(t) {
  var e;
  return !!(t && (!((e = jat(t)) === null || e === void 0) && e.focusGuard));
}, QL = function(t) {
  return !Cge(t);
}, qyr = function(t) {
  return !!t;
}, Kyr = function(t, e) {
  var r = t.tabIndex - e.tabIndex, n = t.index - e.index;
  if (r) {
    if (!t.tabIndex) return 1;
    if (!e.tabIndex) return -1;
  }
  return r || n;
}, Gat = function(t, e, r) {
  return ap(t).map(function(n, a) {
    return { node: n, index: a, tabIndex: r && n.tabIndex === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : n.tabIndex };
  }).filter(function(n) {
    return !e || n.tabIndex >= 0;
  }).sort(Kyr);
}, Zyr = ["button:enabled", "select:enabled", "textarea:enabled", "input:enabled", "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", "[tabindex]", "[contenteditable]", "[autofocus]"], wge = Zyr.join(","), Jyr = "".concat(wge, ", [data-focus-guard]"), Wat = function(t, e) {
  return ap((t.shadowRoot || t).children).reduce(function(r, n) {
    return r.concat(n.matches(e ? Jyr : wge) ? [n] : [], Wat(n));
  }, []);
}, Yyr = function(t, e) {
  var r;
  return t instanceof HTMLIFrameElement && (!((r = t.contentDocument) === null || r === void 0) && r.body) ? mW([t.contentDocument.body], e) : [t];
}, mW = function(t, e) {
  return t.reduce(function(r, n) {
    var a, i = Wat(n, e), o = (a = []).concat.apply(a, i.map(function(s) {
      return Yyr(s, e);
    }));
    return r.concat(o, n.parentNode ? ap(n.parentNode.querySelectorAll(wge)).filter(function(s) {
      return s === n;
    }) : []);
  }, []);
}, Xyr = function(t) {
  var e = t.querySelectorAll("[".concat(Ayr, "]"));
  return ap(e).map(function(r) {
    return mW([r]);
  }).reduce(function(r, n) {
    return r.concat(n);
  }, []);
}, Sge = function(t, e) {
  return ap(t).filter(function(r) {
    return Dat(e, r);
  }).filter(function(r) {
    return Uyr(r);
  });
}, XAe = function(t, e) {
  return e === void 0 && (e = /* @__PURE__ */ new Map()), ap(t).filter(function(r) {
    return Lat(e, r);
  });
}, Xue = function(t, e, r) {
  return Gat(Sge(mW(t, r), e), !0, r);
}, QAe = function(t, e) {
  return Gat(Sge(mW(t), e), !1);
}, Qyr = function(t, e) {
  return Sge(Xyr(t), e);
}, b7 = function(t, e) {
  return t.shadowRoot ? b7(t.shadowRoot, e) : Object.getPrototypeOf(t).contains !== void 0 && Object.getPrototypeOf(t).contains.call(t, e) ? !0 : ap(t.children).some(function(r) {
    var n;
    if (r instanceof HTMLIFrameElement) {
      var a = (n = r.contentDocument) === null || n === void 0 ? void 0 : n.body;
      return a ? b7(a, e) : !1;
    }
    return b7(r, e);
  });
}, e3r = function(t) {
  for (var e = /* @__PURE__ */ new Set(), r = t.length, n = 0; n < r; n += 1) for (var a = n + 1; a < r; a += 1) {
    var i = t[n].compareDocumentPosition(t[a]);
    (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && e.add(a), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && e.add(n);
  }
  return t.filter(function(o, s) {
    return !e.has(s);
  });
}, Hat = function(t) {
  return t.parentNode ? Hat(t.parentNode) : t;
}, _ge = function(t) {
  var e = XL(t);
  return e.filter(Boolean).reduce(function(r, n) {
    var a = n.getAttribute(Jue);
    return r.push.apply(r, a ? e3r(ap(Hat(n).querySelectorAll("[".concat(Jue, '="').concat(a, '"]:not([').concat(_at, '="disabled"])')))) : [n]), r;
  }, []);
}, t3r = function(t) {
  try {
    return t();
  } catch {
    return;
  }
}, lE = function(t) {
  if (t === void 0 && (t = document), !(!t || !t.activeElement)) {
    var e = t.activeElement;
    return e.shadowRoot ? lE(e.shadowRoot) : e instanceof HTMLIFrameElement && t3r(function() {
      return e.contentWindow.document;
    }) ? lE(e.contentWindow.document) : e;
  }
}, r3r = function(t, e) {
  return t === e;
}, n3r = function(t, e) {
  return !!ap(t.querySelectorAll("iframe")).some(function(r) {
    return r3r(r, e);
  });
}, Uat = function(t, e) {
  return e === void 0 && (e = lE(Bat(t).ownerDocument)), !e || e.dataset && e.dataset.focusGuard ? !1 : _ge(t).some(function(r) {
    return b7(r, e) || n3r(r, e);
  });
}, a3r = function(t) {
  t === void 0 && (t = document);
  var e = lE(t);
  return e ? ap(t.querySelectorAll("[".concat(kyr, "]"))).some(function(r) {
    return b7(r, e);
  }) : !1;
}, i3r = function(t, e) {
  return e.filter(zat).filter(function(r) {
    return r.name === t.name;
  }).filter(function(r) {
    return r.checked;
  })[0] || t;
}, kge = function(t, e) {
  return zat(t) && t.name ? i3r(t, e) : t;
}, o3r = function(t) {
  var e = /* @__PURE__ */ new Set();
  return t.forEach(function(r) {
    return e.add(kge(r, t));
  }), t.filter(function(r) {
    return e.has(r);
  });
}, eTe = function(t) {
  return t[0] && t.length > 1 ? kge(t[0], t) : t[0];
}, tTe = function(t, e) {
  return t.length > 1 ? t.indexOf(kge(t[e], t)) : e;
}, Vat = "NEW_FOCUS", s3r = function(t, e, r, n) {
  var a = t.length, i = t[0], o = t[a - 1], s = Cge(r);
  if (!(r && t.indexOf(r) >= 0)) {
    var l = r !== void 0 ? e.indexOf(r) : -1, c = n ? e.indexOf(n) : l, u = n ? t.indexOf(n) : -1, f = l - c, h = e.indexOf(i), p = e.indexOf(o), g = o3r(e), y = r !== void 0 ? g.indexOf(r) : -1, b = y - (n ? g.indexOf(n) : l), w = tTe(t, 0), _ = tTe(t, a - 1);
    if (l === -1 || u === -1) return Vat;
    if (!f && u >= 0) return u;
    if (l <= h && s && Math.abs(f) > 1) return _;
    if (l >= p && s && Math.abs(f) > 1) return w;
    if (f && Math.abs(b) > 1) return u;
    if (l <= h) return _;
    if (l > p) return w;
    if (f) return Math.abs(f) > 1 ? u : (a + u + f) % a;
  }
}, l3r = function(t) {
  return function(e) {
    var r, n = (r = jat(e)) === null || r === void 0 ? void 0 : r.autofocus;
    return e.autofocus || n !== void 0 && n !== "false" || t.indexOf(e) >= 0;
  };
}, c3r = function(t, e, r) {
  var n = t.map(function(i) {
    var o = i.node;
    return o;
  }), a = XAe(n.filter(l3r(r)));
  return a && a.length ? eTe(a) : eTe(XAe(e));
}, Que = function(t, e) {
  return e === void 0 && (e = []), e.push(t), t.parentNode && Que(t.parentNode.host || t.parentNode, e), e;
}, nee = function(t, e) {
  for (var r = Que(t), n = Que(e), a = 0; a < r.length; a += 1) {
    var i = r[a];
    if (n.indexOf(i) >= 0) return i;
  }
  return !1;
}, qat = function(t, e, r) {
  var n = XL(t), a = XL(e), i = n[0], o = !1;
  return a.filter(Boolean).forEach(function(s) {
    o = nee(o || s, s) || o, r.filter(Boolean).forEach(function(l) {
      var c = nee(i, l);
      c && (!o || b7(c, o) ? o = c : o = nee(c, o));
    });
  }), o;
}, u3r = function(t, e) {
  return t.reduce(function(r, n) {
    return r.concat(Qyr(n, e));
  }, []);
}, d3r = function(t, e) {
  var r = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    return r.set(n.node, n);
  }), t.map(function(n) {
    return r.get(n);
  }).filter(qyr);
}, f3r = function(t, e) {
  var r = lE(XL(t).length > 0 ? document : Bat(t).ownerDocument), n = _ge(t).filter(QL), a = qat(r || t, t, n), i = /* @__PURE__ */ new Map(), o = QAe(n, i), s = Xue(n, i).filter(function(p) {
    var g = p.node;
    return QL(g);
  });
  if (!(!s[0] && (s = o, !s[0]))) {
    var l = QAe([a], i).map(function(p) {
      var g = p.node;
      return g;
    }), c = d3r(l, s), u = c.map(function(p) {
      var g = p.node;
      return g;
    }), f = s3r(u, l, r, e);
    if (f === Vat) {
      var h = c3r(o, u, u3r(n, i));
      if (h) return { node: h };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return f === void 0 ? f : c[f];
  }
}, h3r = function(t) {
  var e = _ge(t).filter(QL), r = qat(t, t, e), n = /* @__PURE__ */ new Map(), a = Xue([r], n, !0), i = Xue(e, n).filter(function(o) {
    var s = o.node;
    return QL(s);
  }).map(function(o) {
    var s = o.node;
    return s;
  });
  return a.map(function(o) {
    var s = o.node, l = o.index;
    return { node: s, index: l, lockItem: i.indexOf(s) >= 0, guard: Cge(s) };
  });
}, p3r = function(t, e) {
  "focus" in t && t.focus(e), "contentWindow" in t && t.contentWindow && t.contentWindow.focus();
}, aee = 0, iee = !1, m3r = function(t, e, r) {
  r === void 0 && (r = {});
  var n = f3r(t, e);
  if (!iee && n) {
    if (aee > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), iee = !0, setTimeout(function() {
        iee = !1;
      }, 1);
      return;
    }
    aee++, p3r(n.node, r.focusOptions), aee--;
  }
}, Kat = m3r;
function Age(t) {
  setTimeout(t, 1);
}
var g3r = function() {
  return document && document.activeElement === document.body;
}, v3r = function() {
  return g3r() || a3r();
}, x7 = null, z9 = null, C7 = null, cE = !1, y3r = function() {
  return !0;
}, b3r = function(t) {
  return (x7.whiteList || y3r)(t);
}, x3r = function(t, e) {
  C7 = { observerNode: t, portaledElement: e };
}, C3r = function(t) {
  return C7 && C7.portaledElement === t;
};
function rTe(t, e, r, n) {
  var a = null, i = t;
  do {
    var o = n[i];
    if (o.guard) o.node.dataset.focusAutoGuard && (a = o);
    else if (o.lockItem) {
      if (i !== t) return;
      a = null;
    } else break;
  } while ((i += r) !== e);
  a && (a.node.tabIndex = 0);
}
var w3r = function(t) {
  return t && "current" in t ? t.current : t;
}, S3r = function(t) {
  return t ? !!cE : cE === "meanwhile";
}, _3r = function t(e, r, n) {
  return r && (r.host === e && (!r.activeElement || n.contains(r.activeElement)) || r.parentNode && t(e, r.parentNode, n));
}, k3r = function(t, e) {
  return e.some(function(r) {
    return _3r(t, r, r);
  });
}, ej = function() {
  var t = !1;
  if (x7) {
    var e = x7, r = e.observed, n = e.persistentFocus, a = e.autoFocus, i = e.shards, o = e.crossFrame, s = e.focusOptions, l = r || C7 && C7.portaledElement, c = document && document.activeElement;
    if (l) {
      var u = [l].concat(i.map(w3r).filter(Boolean));
      if ((!c || b3r(c)) && (n || S3r(o) || !v3r() || !z9 && a) && (l && !(Uat(u) || c && k3r(c, u) || C3r(c)) && (document && !z9 && c && !a ? (c.blur && c.blur(), document.body.focus()) : (t = Kat(u, z9, { focusOptions: s }), C7 = {})), cE = !1, z9 = document && document.activeElement), document) {
        var f = document && document.activeElement, h = h3r(u), p = h.map(function(g) {
          var y = g.node;
          return y;
        }).indexOf(f);
        p > -1 && (h.filter(function(g) {
          var y = g.guard, b = g.node;
          return y && b.dataset.focusAutoGuard;
        }).forEach(function(g) {
          var y = g.node;
          return y.removeAttribute("tabIndex");
        }), rTe(p, h.length, 1, h), rTe(p, -1, -1, h));
      }
    }
  }
  return t;
}, Zat = function(t) {
  ej() && t && (t.stopPropagation(), t.preventDefault());
}, Tge = function() {
  return Age(ej);
}, A3r = function(t) {
  var e = t.target, r = t.currentTarget;
  r.contains(e) || x3r(r, e);
}, T3r = function() {
  return null;
}, Jat = function() {
  cE = "just", Age(function() {
    cE = "meanwhile";
  });
}, E3r = function() {
  document.addEventListener("focusin", Zat), document.addEventListener("focusout", Tge), window.addEventListener("blur", Jat);
}, I3r = function() {
  document.removeEventListener("focusin", Zat), document.removeEventListener("focusout", Tge), window.removeEventListener("blur", Jat);
};
function M3r(t) {
  return t.filter(function(e) {
    var r = e.disabled;
    return !r;
  });
}
function P3r(t) {
  var e = t.slice(-1)[0];
  e && !x7 && E3r();
  var r = x7, n = r && e && e.id === r.id;
  x7 = e, r && !n && (r.onDeactivation(), t.filter(function(a) {
    var i = a.id;
    return i === r.id;
  }).length || r.returnFocus(!e)), e ? (z9 = null, (!n || r.observed !== e.observed) && e.onActivation(), ej(), Age(ej)) : (I3r(), z9 = null);
}
Pat.assignSyncMedium(A3r);
Rat.assignMedium(Tge);
Ryr.assignMedium(function(t) {
  return t({ moveFocusInside: Kat, focusInside: Uat });
});
var R3r = Fyr(M3r, P3r)(T3r), Yat = P.forwardRef(function(t, e) {
  return P.createElement(Oat, oE({ sideCar: R3r, ref: e }, t));
}), Xat = Oat.propTypes || {};
Xat.sideCar;
_yr(Xat, ["sideCar"]);
Yat.propTypes = {};
var O3r = Yat, B3r = O3r, y$ = "right-scroll-bar-position", b$ = "width-before-scroll-bar", N3r = "with-scroll-bars-hidden", $3r = "--removed-body-scroll-bar-size", Qat = Iat(), oee = function() {
}, gW = P.forwardRef(function(t, e) {
  var r = P.useRef(null), n = P.useState({ onScrollCapture: oee, onWheelCapture: oee, onTouchMoveCapture: oee }), a = n[0], i = n[1], o = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, f = t.shards, h = t.sideCar, p = t.noIsolation, g = t.inert, y = t.allowPinchZoom, b = t.as, w = b === void 0 ? "div" : b, _ = t.gapMode, C = Aat(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = h, S = kat([r, e]), A = eh(eh({}, C), a);
  return P.createElement(P.Fragment, null, u && P.createElement(x, { sideCar: Qat, removeScrollBar: c, shards: f, noIsolation: p, inert: g, setCallbacks: i, allowPinchZoom: !!y, lockRef: r, gapMode: _ }), o ? P.cloneElement(P.Children.only(s), eh(eh({}, A), { ref: S })) : P.createElement(w, eh({}, A, { className: l, ref: S }), s));
});
gW.defaultProps = { enabled: !0, removeScrollBar: !0, inert: !1 };
gW.classNames = { fullWidth: b$, zeroRight: y$ };
var D3r = function() {
  if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
function L3r() {
  if (!document) return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = D3r();
  return e && t.setAttribute("nonce", e), t;
}
function j3r(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function F3r(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var z3r = function() {
  var t = 0, e = null;
  return { add: function(r) {
    t == 0 && (e = L3r()) && (j3r(e, r), F3r(e)), t++;
  }, remove: function() {
    t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
  } };
}, G3r = function() {
  var t = z3r();
  return function(e, r) {
    P.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && r]);
  };
}, eit = function() {
  var t = G3r(), e = function(r) {
    var n = r.styles, a = r.dynamic;
    return t(n, a), null;
  };
  return e;
}, W3r = { left: 0, top: 0, right: 0, gap: 0 }, see = function(t) {
  return parseInt(t || "", 10) || 0;
}, H3r = function(t) {
  var e = window.getComputedStyle(document.body), r = e[t === "padding" ? "paddingLeft" : "marginLeft"], n = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [see(r), see(n), see(a)];
}, U3r = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u") return W3r;
  var e = H3r(t), r = document.documentElement.clientWidth, n = window.innerWidth;
  return { left: e[0], top: e[1], right: e[2], gap: Math.max(0, n - r + e[2] - e[0]) };
}, V3r = eit(), q3r = function(t, e, r, n) {
  var a = t.left, i = t.top, o = t.right, s = t.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(N3r, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([e && "position: relative ".concat(n, ";"), r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `), r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(y$, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(b$, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(y$, " .").concat(y$, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(b$, " .").concat(b$, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat($3r, ": ").concat(s, `px;
  }
`);
}, K3r = function(t) {
  var e = t.noRelative, r = t.noImportant, n = t.gapMode, a = n === void 0 ? "margin" : n, i = P.useMemo(function() {
    return U3r(a);
  }, [a]);
  return P.createElement(V3r, { styles: q3r(i, !e, a, r ? "" : "!important") });
}, ede = !1;
if (typeof window < "u") try {
  rS = Object.defineProperty({}, "passive", { get: function() {
    return ede = !0, !0;
  } }), window.addEventListener("test", rS, rS), window.removeEventListener("test", rS, rS);
} catch {
  ede = !1;
}
var rS, X4 = ede ? { passive: !1 } : !1, Z3r = function(t) {
  return t.tagName === "TEXTAREA";
}, tit = function(t, e) {
  var r = window.getComputedStyle(t);
  return r[e] !== "hidden" && !(r.overflowY === r.overflowX && !Z3r(t) && r[e] === "visible");
}, J3r = function(t) {
  return tit(t, "overflowY");
}, Y3r = function(t) {
  return tit(t, "overflowX");
}, nTe = function(t, e) {
  var r = e.ownerDocument, n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = rit(t, n);
    if (a) {
      var i = nit(t, n), o = i[1], s = i[2];
      if (o > s) return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, X3r = function(t) {
  var e = t.scrollTop, r = t.scrollHeight, n = t.clientHeight;
  return [e, r, n];
}, Q3r = function(t) {
  var e = t.scrollLeft, r = t.scrollWidth, n = t.clientWidth;
  return [e, r, n];
}, rit = function(t, e) {
  return t === "v" ? J3r(e) : Y3r(e);
}, nit = function(t, e) {
  return t === "v" ? X3r(e) : Q3r(e);
}, ebr = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, tbr = function(t, e, r, n, a) {
  var i = ebr(t, window.getComputedStyle(e).direction), o = i * n, s = r.target, l = e.contains(s), c = !1, u = o > 0, f = 0, h = 0;
  do {
    var p = nit(t, s), g = p[0], y = p[1], b = p[2], w = y - b - i * g;
    (g || w) && rit(t, s) && (f += w, h += g), s = s.parentNode;
  } while (!l && s !== document.body || l && (e.contains(s) || e === s));
  return (u && f === 0 || !u && h === 0) && (c = !0), c;
}, $B = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, aTe = function(t) {
  return [t.deltaX, t.deltaY];
}, iTe = function(t) {
  return t && "current" in t ? t.current : t;
}, rbr = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, nbr = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, abr = 0, Q4 = [];
function ibr(t) {
  var e = P.useRef([]), r = P.useRef([0, 0]), n = P.useRef(), a = P.useState(abr++)[0], i = P.useState(eit)[0], o = P.useRef(t);
  P.useEffect(function() {
    o.current = t;
  }, [t]), P.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var y = Myr([t.lockRef.current], (t.shards || []).map(iTe)).filter(Boolean);
      return y.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), y.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = P.useCallback(function(y, b) {
    if ("touches" in y && y.touches.length === 2) return !o.current.allowPinchZoom;
    var w = $B(y), _ = r.current, C = "deltaX" in y ? y.deltaX : _[0] - w[0], x = "deltaY" in y ? y.deltaY : _[1] - w[1], S, A = y.target, I = Math.abs(C) > Math.abs(x) ? "h" : "v";
    if ("touches" in y && I === "h" && A.type === "range") return !1;
    var M = nTe(I, A);
    if (!M) return !0;
    if (M ? S = I : (S = I === "v" ? "h" : "v", M = nTe(I, A)), !M) return !1;
    if (!n.current && "changedTouches" in y && (C || x) && (n.current = S), !S) return !0;
    var B = n.current || S;
    return tbr(B, b, y, B === "h" ? C : x);
  }, []), l = P.useCallback(function(y) {
    var b = y;
    if (!(!Q4.length || Q4[Q4.length - 1] !== i)) {
      var w = "deltaY" in b ? aTe(b) : $B(b), _ = e.current.filter(function(S) {
        return S.name === b.type && S.target === b.target && rbr(S.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var C = (o.current.shards || []).map(iTe).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), x = C.length > 0 ? s(b, C[0]) : !o.current.noIsolation;
        x && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = P.useCallback(function(y, b, w, _) {
    var C = { name: y, delta: b, target: w, should: _ };
    e.current.push(C), setTimeout(function() {
      e.current = e.current.filter(function(x) {
        return x !== C;
      });
    }, 1);
  }, []), u = P.useCallback(function(y) {
    r.current = $B(y), n.current = void 0;
  }, []), f = P.useCallback(function(y) {
    c(y.type, aTe(y), y.target, s(y, t.lockRef.current));
  }, []), h = P.useCallback(function(y) {
    c(y.type, $B(y), y.target, s(y, t.lockRef.current));
  }, []);
  P.useEffect(function() {
    return Q4.push(i), t.setCallbacks({ onScrollCapture: f, onWheelCapture: f, onTouchMoveCapture: h }), document.addEventListener("wheel", l, X4), document.addEventListener("touchmove", l, X4), document.addEventListener("touchstart", u, X4), function() {
      Q4 = Q4.filter(function(y) {
        return y !== i;
      }), document.removeEventListener("wheel", l, X4), document.removeEventListener("touchmove", l, X4), document.removeEventListener("touchstart", u, X4);
    };
  }, []);
  var p = t.removeScrollBar, g = t.inert;
  return P.createElement(P.Fragment, null, g ? P.createElement(i, { styles: nbr(a) }) : null, p ? P.createElement(K3r, { gapMode: t.gapMode }) : null);
}
var obr = Pyr(Qat, ibr), ait = P.forwardRef(function(t, e) {
  return P.createElement(gW, eh({}, t, { ref: e, sideCar: obr }));
});
ait.classNames = gW.classNames;
var sbr = ait, DB = dyr(pyr());
function uE() {
  return uE = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, uE.apply(this, arguments);
}
function Ege(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
var lbr = ["as", "isOpen"], cbr = ["allowPinchZoom", "as", "dangerouslyBypassFocusLock", "dangerouslyBypassScrollLock", "initialFocusRef", "onClick", "onDismiss", "onKeyDown", "onMouseDown", "unstable_lockFocusAcrossFrames"], ubr = ["as", "onClick", "onKeyDown"];
DB.default.bool, DB.default.bool, DB.default.bool, DB.default.func;
var dbr = Ml(function(t, e) {
  var r = t.as, n = r === void 0 ? "div" : r, a = t.isOpen, i = a === void 0 ? !0 : a, o = Ege(t, lbr);
  return Ut(function() {
    i ? window.__REACH_DISABLE_TOOLTIPS = !0 : window.requestAnimationFrame(function() {
      window.__REACH_DISABLE_TOOLTIPS = !1;
    });
  }, [i]), i ? Ds(vyr, { "data-reach-dialog-wrapper": "" }, Ds(fbr, uE({ ref: e, as: n }, o))) : null;
}), fbr = Ml(function(t, e) {
  var r = t.allowPinchZoom, n = t.as, a = n === void 0 ? "div" : n, i = t.dangerouslyBypassFocusLock, o = i === void 0 ? !1 : i, s = t.dangerouslyBypassScrollLock, l = s === void 0 ? !1 : s, c = t.initialFocusRef, u = t.onClick, f = t.onDismiss, h = f === void 0 ? Sat : f, p = t.onKeyDown, g = t.onMouseDown, y = t.unstable_lockFocusAcrossFrames, b = Ege(t, cbr), w = Zt(null), _ = Zt(null), C = Syr(_, e), x = sr(function() {
    c && c.current && c.current.focus();
  }, [c]);
  function S(M) {
    w.current === M.target && (M.stopPropagation(), h(M));
  }
  function A(M) {
    M.key === "Escape" && (M.stopPropagation(), h(M));
  }
  function I(M) {
    w.current = M.target;
  }
  return Ut(function() {
    return _.current ? pbr(_.current) : void 0;
  }, []), Ds(B3r, { autoFocus: !0, returnFocus: !0, onActivation: x, disabled: o, crossFrame: y ?? !0 }, Ds(sbr, { allowPinchZoom: r, enabled: !l }, Ds(a, uE({}, b, { ref: C, "data-reach-dialog-overlay": "", onClick: v$(u, S), onKeyDown: v$(p, A), onMouseDown: v$(g, I) }))));
}), hbr = Ml(function(t, e) {
  var r = t.as, n = r === void 0 ? "div" : r, a = t.onClick;
  t.onKeyDown;
  var i = Ege(t, ubr);
  return Ds(n, uE({ "aria-modal": "true", role: "dialog", tabIndex: -1 }, i, { ref: e, "data-reach-dialog-content": "", onClick: v$(a, function(o) {
    o.stopPropagation();
  }) }));
});
function pbr(t) {
  var e = [], r = [], n = yyr(t);
  return t ? (Array.prototype.forEach.call(n.querySelectorAll("body > *"), function(a) {
    var i, o, s = (i = t.parentNode) == null || (o = i.parentNode) == null ? void 0 : o.parentNode;
    if (a !== s) {
      var l = a.getAttribute("aria-hidden"), c = l !== null && l !== "false";
      c || (e.push(l), r.push(a), a.setAttribute("aria-hidden", "true"));
    }
  }), function() {
    r.forEach(function(a, i) {
      var o = e[i];
      o === null ? a.removeAttribute("aria-hidden") : a.setAttribute("aria-hidden", o);
    });
  }) : Sat;
}
var Ige = P.createContext(null), mbr = () => {
  let t = P.useContext(Ige);
  if (!t) throw new Error("useModalContext must be used with ModalContextProvider");
  return t;
}, Mge = Zh(ds(dbr)(us({ position: "fixed", top: 0, right: 0, bottom: 0, left: 0, display: "flex", justifyContent: "center", alignItems: "center", width: "100%", backgroundColor: "colorBackgroundOverlay", zIndex: "zIndex80" }), Ehe, Oz)), Pge = Zh(ds(hbr)(({ size: t }) => us({ width: "100%", maxWidth: t === "wide" ? "size80" : "size60", maxHeight: "90%", minHeight: "170px", backgroundColor: "colorBackgroundBody", borderRadius: "borderRadius30", boxShadow: "shadowElevationTop20", display: "flex", flexDirection: "column" }))), gbr = () => ({ from: { opacity: 0, transform: "scale(0.675)" }, enter: { opacity: 1, transform: "scale(1)" }, leave: { opacity: 0, transform: "scale(0.675)" }, config: { mass: 0.5, tension: 370, friction: 26 } }), iit = P.forwardRef(({ children: t, element: e = "MODAL", isOpen: r, onDismiss: n, allowPinchZoom: a = !0, initialFocusRef: i, ariaLabelledby: o, size: s, ...l }, c) => {
  let u = A8(r, gbr());
  return P.createElement(Ige.Provider, { value: { onDismiss: n } }, u((f, h) => h && P.createElement(Mge, { onDismiss: n, allowPinchZoom: a, initialFocusRef: i, style: { opacity: f.opacity }, "data-paste-element": `${e}_OVERLAY`, variant: s }, P.createElement(ht, { as: Pge, "aria-labelledby": o, ...Xt(l), element: e, ref: c, style: f, size: s, variant: s }, t))));
});
iit.displayName = "Modal";
var oit = P.forwardRef(({ children: t, element: e = "MODAL_HEADER", i18nDismissLabel: r = "Close modal", ...n }, a) => {
  let { onDismiss: i } = mbr();
  return P.createElement(ht, { ...Xt(n), as: "div", element: e, ref: a, padding: "space90", flexShrink: 0 }, P.createElement(WT, { hAlignContent: "between" }, P.createElement(WT, { vAlignContent: "center", grow: 1, marginRight: "space70" }, t), P.createElement(Zs, { element: `${e}_CLOSE_BUTTON`, variant: "secondary_icon", size: "reset", onClick: () => i() }, P.createElement(Dy, { element: `${e}_CLOSE_ICON`, decorative: !0, size: "sizeIcon60" }), P.createElement(Ul, null, r))));
});
oit.displayName = "ModalHeader";
var sit = P.forwardRef(({ children: t, as: e = "h2", element: r = "MODAL_HEADING", ...n }, a) => P.createElement($8, { ...n, as: e, element: r, marginBottom: "space0", variant: "heading30", ref: a }, t));
sit.displayName = "ModalHeading";
var lit = P.forwardRef(({ children: t, element: e = "MODAL_BODY", ...r }, n) => P.createElement(ht, { ...Xt(r), overflowY: "auto", paddingX: "space90", paddingY: "space10", as: "div", element: e, ref: n }, t));
lit.displayName = "ModalBody";
var cit = P.forwardRef(({ children: t, element: e = "MODAL_FOOTER", ...r }, n) => P.createElement(ht, { ...Xt(r), flexShrink: 0, display: "flex", padding: "space90", as: "div", element: e, ref: n }, t));
cit.displayName = "ModalFooter";
var uit = P.forwardRef(({ children: t, element: e = "MODAL_FOOTER_ACTIONS", justify: r, ...n }, a) => {
  let i = P.Children.count(t);
  return P.createElement(ht, { ...Xt(n), display: "flex", justifyContent: r === "start" ? "flex-start" : "flex-end", flexShrink: r === "start" ? null : 0, flexWrap: "wrap", flexGrow: 1, element: e, alignItems: "center", ref: a }, P.Children.map(t, (o, s) => P.createElement(ht, { marginRight: i !== s + 1 ? "space50" : null, element: `${e}_ITEM` }, o)));
});
uit.displayName = "ModalFooterActions";
const vbr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Modal: iit,
  ModalBody: lit,
  ModalContext: Ige,
  ModalDialogContent: Pge,
  ModalDialogOverlay: Mge,
  ModalFooter: cit,
  ModalFooterActions: uit,
  ModalHeader: oit,
  ModalHeading: sit
}, Symbol.toStringTag, { value: "Module" }));
var dit = P.forwardRef(({ bodyID: t, children: e, element: r = "ALERT_DIALOG_BODY", ...n }, a) => P.createElement(ht, { ...Xt(n), as: "div", overflowY: "auto", padding: "space90", paddingTop: "space0", element: r, id: t, ref: a }, e));
dit.displayName = "AlertDialogBody";
var fit = ds(Pge)(() => us({ maxWidth: "size40" }));
fit.displayName = "AlertDialogContent";
var hit = P.forwardRef(({ destructive: t, element: e = "ALERT_DIALOG_FOOTER", onConfirm: r, onConfirmLabel: n, onDismiss: a, onDismissLabel: i, onConfirmDisabled: o, isConfirmDisabled: s = o || !1, ...l }, c) => {
  let u = t ? "destructive" : "primary";
  return P.createElement(ht, { ...Xt(l), as: "div", flexShrink: 0, display: "flex", padding: "space90", paddingTop: "space0", border: "none", element: e, justifyContent: "flex-end", ref: c }, P.createElement(J5, { orientation: "horizontal", spacing: "space50" }, P.createElement(Zs, { variant: "secondary", onClick: a }, i), P.createElement(Zs, { variant: u, onClick: r, disabled: t && (s || o) }, n)));
});
hit.displayName = "AlertDialogFooter";
var pit = P.forwardRef(({ children: t, element: e = "ALERT_DIALOG_HEADER", headingID: r, ...n }, a) => P.createElement(ht, { ...Xt(n), as: "div", padding: "space90", flexShrink: 0, border: "none", element: `${e}_WRAPPER`, ref: a }, P.createElement($8, { as: "h3", element: e, marginBottom: "space0", variant: "heading30", id: r }, t)));
pit.displayName = "AlertDialogHeader";
var ybr = () => ({ from: { opacity: 0, transform: "scale(0.675)" }, enter: { opacity: 1, transform: "scale(1)" }, leave: { opacity: 0, transform: "scale(0.675)" }, config: { mass: 0.5, tension: 370, friction: 26 } }), mit = P.forwardRef(({ children: t, destructive: e, element: r = "ALERT_DIALOG", heading: n, isOpen: a, onConfirm: i, onConfirmLabel: o, onDismiss: s, onDismissLabel: l, onConfirmDisabled: c, isConfirmDisabled: u, ...f }, h) => {
  let p = A8(a, ybr()), g = Jr(), y = Jr();
  return P.createElement(P.Fragment, null, p((b, w) => w && P.createElement(Mge, { isOpen: a, style: { opacity: b.opacity } }, P.createElement(ht, { as: fit, ...Xt(f), "aria-labelledby": g, "aria-describedby": y, element: r, ref: h, role: "alertdialog", style: b }, P.createElement(pit, { headingID: g, element: `${r}_HEADER` }, n), P.createElement(dit, { bodyID: y, element: `${r}_BODY` }, t), P.createElement(hit, { destructive: e, element: `${r}_FOOTER`, onDismiss: s, onDismissLabel: l, onConfirm: i, onConfirmLabel: o, isConfirmDisabled: u || c })))));
});
mit.displayName = "AlertDialog";
const bbr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AlertDialog: mit
}, Symbol.toStringTag, { value: "Module" })), xbr = /* @__PURE__ */ aa(bbr);
var oTe;
function Cbr() {
  return oTe || (oTe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = xbr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(tee)), tee;
}
var wbr = /* @__PURE__ */ Cbr();
const Sbr = ({
  prompt: t,
  onPromptEditClicked: e,
  onPromptDeleteConfirmed: r,
  onPromptRunClicked: n
}) => {
  const a = i1.useMenuState(), [i, o] = Yt(!1), s = async () => {
    o(!1), r();
  };
  return /* @__PURE__ */ R.jsxs(ar.Box, { position: "relative", marginBottom: "space40", children: [
    /* @__PURE__ */ R.jsxs(vh.Card, { children: [
      /* @__PURE__ */ R.jsxs(
        ar.Box,
        {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "space70",
          children: [
            /* @__PURE__ */ R.jsxs(ar.Box, { children: [
              /* @__PURE__ */ R.jsxs(
                JM.Badge,
                {
                  as: "span",
                  variant: t.type === n_.USER ? "success" : "new",
                  children: [
                    t.type === n_.USER ? /* @__PURE__ */ R.jsx(hge, { decorative: !1, title: "User Prompt" }) : /* @__PURE__ */ R.jsx(pge, { decorative: !1, title: "Global Prompt" }),
                    t.type === n_.USER ? "User" : "Global",
                    " prompt"
                  ]
                }
              ),
              t.type === n_.GLOBAL && /* @__PURE__ */ R.jsx("sub", { children: "Created by TODO" })
            ] }),
            /* @__PURE__ */ R.jsxs(ar.Box, { children: [
              /* @__PURE__ */ R.jsx(i1.MenuButton, { ...a, variant: "reset", children: /* @__PURE__ */ R.jsx(oat, { decorative: !1, title: "More Options" }) }),
              /* @__PURE__ */ R.jsxs(i1.Menu, { ...a, "aria-label": "Prompt Menu", children: [
                /* @__PURE__ */ R.jsx(i1.MenuItem, { onClick: n, ...a, children: /* @__PURE__ */ R.jsxs(
                  ar.Box,
                  {
                    as: "span",
                    display: "flex",
                    columnGap: "space30",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ R.jsx(mge, { decorative: !1, title: "Run Prompt" }),
                      " Run prompt"
                    ]
                  }
                ) }),
                /* @__PURE__ */ R.jsx(i1.MenuSeparator, { ...a }),
                /* @__PURE__ */ R.jsx(i1.MenuItem, { onClick: () => e(t), ...a, children: /* @__PURE__ */ R.jsxs(
                  ar.Box,
                  {
                    as: "span",
                    display: "flex",
                    columnGap: "space30",
                    alignItems: "center",
                    children: [
                      /* @__PURE__ */ R.jsx(yat, { decorative: !1, title: "Edit Prompt" }),
                      " Edit"
                    ]
                  }
                ) }),
                /* @__PURE__ */ R.jsx(
                  i1.MenuItem,
                  {
                    onClick: () => o(!0),
                    variant: "destructive",
                    ...a,
                    children: /* @__PURE__ */ R.jsxs(
                      ar.Box,
                      {
                        as: "span",
                        display: "flex",
                        columnGap: "space30",
                        alignItems: "center",
                        children: [
                          /* @__PURE__ */ R.jsx(bat, { decorative: !1, title: "Delete Prompt" }),
                          " Delete"
                        ]
                      }
                    )
                  }
                )
              ] })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ R.jsxs(ar.Box, { children: [
        /* @__PURE__ */ R.jsx(hy.Heading, { as: "h4", variant: "heading40", children: t.name }),
        /* @__PURE__ */ R.jsx(Ly.Paragraph, { marginBottom: "space0", children: t.description })
      ] })
    ] }),
    /* @__PURE__ */ R.jsxs(
      wbr.AlertDialog,
      {
        heading: "Delete prompt",
        isOpen: i,
        onConfirm: s,
        destructive: !0,
        onConfirmLabel: "Delete",
        onDismiss: () => o(!1),
        onDismissLabel: "Cancel",
        children: [
          "Are you sure you want to delete the",
          /* @__PURE__ */ R.jsxs(ar.Box, { as: "span", fontWeight: "fontWeightBold", children: [
            " ",
            t.name,
            " "
          ] }),
          "prompt? This action cannot be undone."
        ]
      }
    )
  ] });
}, _br = ({ prompt: t, onCancelClicked: e }) => {
  const r = Rge(), { sendMessage: n } = qM(), a = () => {
    n({ message: t.template }), r.hide();
  };
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsxs(vh.Card, { children: [
      /* @__PURE__ */ R.jsx(ar.Box, { marginBottom: "space70", children: /* @__PURE__ */ R.jsxs(
        JM.Badge,
        {
          as: "span",
          variant: t.type === __.USER ? "success" : "new",
          children: [
            t.type === __.USER ? /* @__PURE__ */ R.jsx(hge, { decorative: !1, title: "User Prompt" }) : /* @__PURE__ */ R.jsx(pge, { decorative: !1, title: "Global Prompt" }),
            t.type === __.USER ? "User" : "Global",
            " prompt"
          ]
        }
      ) }),
      /* @__PURE__ */ R.jsxs(ar.Box, { children: [
        /* @__PURE__ */ R.jsx(hy.Heading, { as: "h4", variant: "heading40", children: t.name }),
        /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: t.description })
      ] }),
      /* @__PURE__ */ R.jsxs(ar.Box, { children: [
        /* @__PURE__ */ R.jsx(hy.Heading, { as: "h4", variant: "heading40", children: "Prompt" }),
        /* @__PURE__ */ R.jsx(
          ar.Box,
          {
            as: "p",
            marginBottom: "space0",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            children: t.template
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", justifyContent: "space-between", marginTop: "space40", children: [
      /* @__PURE__ */ R.jsx(zi.Button, { onClick: e, variant: "secondary", children: "Cancel" }),
      /* @__PURE__ */ R.jsxs(zi.Button, { onClick: a, variant: "primary", children: [
        "Run prompt ",
        /* @__PURE__ */ R.jsx(mge, { decorative: !0 })
      ] })
    ] })
  ] });
}, kbr = () => {
  const [t, e] = Yt(""), [r, n] = Yt(
    Gd.LIST
  ), [a, i] = Yt(), [o, s] = Yt(1), l = Rge(), c = yW(), u = () => {
    i(void 0), n(Gd.LIST);
  }, f = (g) => {
    g ? (i(g), n(Gd.EDIT)) : n(Gd.CREATE);
  }, h = (g) => {
    i(g), n(Gd.RUN);
  }, p = (g, y) => {
    u(), c.push({
      message: jb(
        "",
        `${g.name} has been ${y ? "added" : "updated"}!`
      ),
      variant: "success",
      dismissAfter: Lb
    });
  };
  return Ut(() => {
    l.visible || u();
  }, [l.visible]), Ut(() => {
    switch (r) {
      case Gd.LIST: {
        e("Prompt library");
        break;
      }
      case Gd.CREATE: {
        e("Create prompt");
        break;
      }
      case Gd.EDIT: {
        e("Edit prompt");
        break;
      }
      case Gd.RUN: {
        e("Run prompt");
        break;
      }
      default: {
        e("Prompt library");
        break;
      }
    }
  }, [r]), /* @__PURE__ */ R.jsxs(F9.SideModal, { "aria-label": "Basic Side Modal", children: [
    /* @__PURE__ */ R.jsx(F9.SideModalHeader, { children: /* @__PURE__ */ R.jsx(F9.SideModalHeading, { children: t }) }),
    /* @__PURE__ */ R.jsxs(F9.SideModalBody, { children: [
      r === Gd.LIST && /* @__PURE__ */ R.jsx(
        Vvr,
        {
          onCreatePromptClickHandler: () => f(),
          promptEditClickHandler: (g) => f(g),
          promptRunClickHandler: (g) => h(g),
          currentPage: o,
          setCurrentPage: s
        }
      ),
      r === Gd.CREATE && /* @__PURE__ */ R.jsx(
        WAe,
        {
          onPromptSaved: p,
          onCancelClicked: u,
          prompt: a
        }
      ),
      r === Gd.EDIT && a && /* @__PURE__ */ R.jsx(
        WAe,
        {
          onPromptSaved: p,
          onCancelClicked: u,
          prompt: a
        }
      ),
      r === Gd.RUN && a && /* @__PURE__ */ R.jsx(_br, { prompt: a, onCancelClicked: u })
    ] })
  ] });
}, git = Bo(void 0), Abr = ({
  children: t
}) => {
  const e = F9.useSideModalState({});
  return /* @__PURE__ */ R.jsxs(git.Provider, { value: e, children: [
    /* @__PURE__ */ R.jsx(F9.SideModalContainer, { state: e, children: /* @__PURE__ */ R.jsx(kbr, {}) }),
    t
  ] });
}, Rge = () => {
  const t = Qn(git);
  if (!t)
    throw new Error(
      "useWiseOwlSideModal must be used within a WiseOwlSideModalProvider"
    );
  return t;
};
var lee = {};
const vW = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `NeutralIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[NeutralIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 7c-.26.01-.528.08-.707.24-.178.158-.292.355-.292.575v3.37c0 .21.11.428.292.577.173.14.457.247.707.237.26-.008.528-.078.707-.237.178-.16.292-.355.292-.577v-3.37a.766.766 0 00-.292-.575A1.14 1.14 0 0010 9zm0-3l-.266.036c-.17.047-.318.131-.441.253l-.156.198A.958.958 0 009 6.98v.04a.728.728 0 00.086.378c.04.121.108.227.206.315.09.094.197.163.321.202.12.06.248.09.386.084l.266-.035c.17-.047.318-.131.441-.253l.156-.198A.958.958 0 0011 7.02v-.04a.728.728 0 00-.086-.378.721.721 0 00-.206-.315.757.757 0 00-.321-.202.767.767 0 00-.386-.084z" })));
});
vW.displayName = "NeutralIcon";
var vit = P.forwardRef(({ element: t = "TOAST", variant: e, ...r }, n) => P.createElement(ht, { ...Xt(r), ref: n, color: "colorTextError", width: ["100%", "size40", "size40"], backgroundColor: "colorBackgroundErrorWeakest", borderColor: "colorBorderErrorWeak", borderRadius: "borderRadius30", borderStyle: "solid", borderWidth: "borderWidth10", boxShadow: "shadowElevation20", element: t, padding: "space60", variant: e }, r.children));
vit.displayName = "ErrorToast";
var yit = P.forwardRef(({ element: t = "TOAST", variant: e, ...r }, n) => P.createElement(ht, { ...Xt(r), ref: n, color: "colorTextNeutral", width: ["100%", "size40", "size40"], backgroundColor: "colorBackgroundNeutralWeakest", borderColor: "colorBorderNeutralWeak", borderRadius: "borderRadius30", borderStyle: "solid", borderWidth: "borderWidth10", boxShadow: "shadowElevation20", element: t, padding: "space60", variant: e }, r.children));
yit.displayName = "NeutralToast";
var bit = P.forwardRef(({ element: t = "TOAST", variant: e, ...r }, n) => P.createElement(ht, { ...Xt(r), ref: n, color: "colorTextSuccess", width: ["100%", "size40", "size40"], backgroundColor: "colorBackgroundSuccessWeakest", borderColor: "colorBorderSuccessWeak", borderRadius: "borderRadius30", borderStyle: "solid", borderWidth: "borderWidth10", boxShadow: "shadowElevation20", element: t, padding: "space60", variant: e }, r.children));
bit.displayName = "SuccessToast";
var xit = P.forwardRef(({ element: t = "TOAST", variant: e, ...r }, n) => P.createElement(ht, { ...Xt(r), ref: n, color: "colorTextWarningStrong", width: ["100%", "size40", "size40"], backgroundColor: "colorBackgroundWarningWeakest", borderColor: "colorBorderWarningWeak", borderRadius: "borderRadius30", borderStyle: "solid", borderWidth: "borderWidth10", boxShadow: "shadowElevation20", element: t, padding: "space60", variant: e }, r.children));
xit.displayName = "WarningToast";
var LB = { ERROR: "error", NEUTRAL: "neutral", SUCCESS: "success", WARNING: "warning" }, Tbr = { error: vit, neutral: yit, success: bit, warning: xit }, Ebr = (t, e, r) => {
  switch (t) {
    case LB.ERROR:
      return P.createElement(fy, { color: "colorTextIconError", decorative: !1, title: e, element: `${r}_ICON`, size: "sizeIcon20" });
    case LB.SUCCESS:
      return P.createElement(oG, { color: "colorTextIconSuccess", decorative: !1, title: e, element: `${r}_ICON`, size: "sizeIcon20" });
    case LB.WARNING:
      return P.createElement(hM, { color: "colorTextIconWarning", decorative: !1, title: e, element: `${r}_ICON`, size: "sizeIcon20" });
    case LB.NEUTRAL:
    default:
      return P.createElement(vW, { color: "colorTextIconNeutral", decorative: !1, title: e, element: `${r}_ICON`, size: "sizeIcon20" });
  }
}, Oge = P.forwardRef(({ children: t, onDismiss: e, variant: r = "neutral", element: n = "TOAST", setFocus: a, i18nDismissLabel: i = "Dismiss toast", i18nErrorLabel: o = "(error)", i18nNeutralLabel: s = "(information)", i18nSuccessLabel: l = "(success)", i18nWarningLabel: c = "(warning)", ...u }, f) => {
  let h = Tbr[r], p = P.useRef(null);
  P.useEffect(() => {
    a && p.current && p.current.focus({ preventScroll: !0 });
  }, [a]);
  let g = { error: o, neutral: s, success: l, warning: c };
  return P.createElement(h, { role: "status", variant: r, element: n, ref: f, ...u }, P.createElement(Q5, { as: "div" }, P.createElement(qm, { as: "div", spacing: "space60" }, Ebr(r, g[r], n)), P.createElement(e6, { as: "div" }, t), e && typeof e == "function" && P.createElement(qm, { align: "end", spacing: "space40" }, P.createElement(Zs, { onClick: e, variant: "secondary_icon", ref: p, size: "reset", element: `${n}_CLOSE_BUTTON` }, P.createElement(Dy, { decorative: !0, size: "sizeIcon20", element: `${n}_CLOSE_ICON` }), P.createElement(Ul, null, i)))));
});
Oge.displayName = "Toast";
var Bge = P.forwardRef(({ children: t, left: e, ...r }, n) => P.createElement(Vm, null, P.createElement(uy, null, P.createElement(ht, { ...Xt(r), position: "fixed", right: "space40", top: "space90", left: e, zIndex: "zIndex90", ref: n }, t))));
Bge.displayName = "ToastPortal";
var Cit = P.forwardRef(({ children: t, ...e }, r) => P.createElement(Bge, { ...e }, P.createElement(J5, { orientation: "vertical", spacing: "space40", ref: r }, t)));
Cit.displayName = "ToastContainer";
var Ibr = Zh(ht), wit = ({ toasts: t, pop: e, ...r }) => {
  let n = iM(), [a] = P.useState(() => /* @__PURE__ */ new WeakMap()), [i, o] = P.useState({ trigger: null }), s = Md(), l = A8(t, { from: { marginBottom: "0rem", opacity: 0, transform: "translateX(100%) scale(1)", height: n ? "auto" : 0 }, enter: n ? { marginBottom: s.space.space40, opacity: 1, transform: "translateX(0px) scale(1)" } : (u) => async (f) => {
    await f({ marginBottom: s.space.space40, opacity: 1, transform: "translateX(0px) scale(1)", height: a.get(u).offsetHeight });
  }, leave: { marginBottom: "0rem", opacity: 0, transform: "translateX(0px) scale(0.8)", height: n ? "auto" : 0 }, config: { mass: 1, tension: 150, friction: 20 } }), c = P.useCallback(() => {
    o({ trigger: null });
  }, [i]);
  return P.useEffect(() => {
    i.trigger != null && t.length === 0 && (i.trigger.focus(), c());
  }, [t]), P.createElement(Bge, { ...r }, l((u, f, h, p) => P.createElement(Ibr, { as: "div", key: h.key, style: u }, P.createElement(Oge, { key: f.id, ...f, onDismiss: () => {
    f.onDismiss != null && f.onDismiss(), e(f.id);
  }, ref: (g) => {
    g != null && a.set(f, g);
  }, setFocus: p === 0, onFocus: (g) => {
    g.relatedTarget && !i.trigger && o({ trigger: g.relatedTarget });
  } }, f.message))));
};
wit.displayName = "Toaster";
var Mbr = () => {
  let t = P.useRef(null), [e, r] = P.useState([]);
  P.useEffect(() => (t.current = !0, () => {
    t.current = !1, e.forEach((a) => {
      a.timeOutId && window.clearTimeout(a.timeOutId);
    });
  }), []);
  let n = (a) => {
    !t.current || r((i) => i.filter((o) => (o.id === a && (o.timeOutId && window.clearTimeout(o.timeOutId), o.onDismiss && o.onDismiss()), o.id !== a)));
  };
  return { toasts: e, push: (a) => {
    if (!t.current) return;
    let i = D2e(a), o;
    a.dismissAfter != null && Number.isInteger(a.dismissAfter) && (o = window.setTimeout(n, a.dismissAfter, a.id || i)), r((s) => {
      let l = s.map((c) => {
        let u = c;
        return u.setFocus = !1, u;
      });
      return [{ id: i, timeOutId: o, setFocus: !0, ...a }, ...l];
    });
  }, pop: n };
};
const Pbr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Toast: Oge,
  ToastContainer: Cit,
  Toaster: wit,
  useToaster: Mbr
}, Symbol.toStringTag, { value: "Module" })), Rbr = /* @__PURE__ */ aa(Pbr);
var sTe;
function Obr() {
  return sTe || (sTe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Rbr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(lee)), lee;
}
var Sx = /* @__PURE__ */ Obr();
const Sit = Bo(void 0), Bbr = ({
  children: t
}) => {
  const e = Sx.useToaster();
  return /* @__PURE__ */ R.jsxs(Sit.Provider, { value: e, children: [
    /* @__PURE__ */ R.jsx(Sx.Toaster, { left: ["space40", "unset", "unset"], ...e }),
    t
  ] });
}, yW = () => {
  const t = Qn(Sit);
  if (!t)
    throw new Error("useCustomToaster must be used within a ToasterProvider");
  return t;
}, jb = (t, e) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ R.jsx("strong", { children: t }),
  /* @__PURE__ */ R.jsxs("div", { children: [
    " ",
    e
  ] })
] }), Nbr = ({
  value: t,
  setValue: e,
  onComboboxOpenChange: r,
  setSelectedItem: n,
  hideCombobox: a,
  showPromptLibrary: i
}) => {
  const [o, s] = Yt(""), l = yW(), [c, u] = Yt(!1), { requestTransformer: f } = Ja(), {
    data: { prompts: h, page: p } = {},
    isLoading: g,
    isError: y
  } = nKe({
    offset: 0,
    limit: 10,
    search: o,
    requestTransformer: f
  }), b = (S) => S.trim().charAt(0) === "/", w = sr(
    $2e.debounce((S) => {
      s(S);
    }, 300),
    []
  ), _ = (S) => {
    if (h) {
      const A = h.find(
        (I) => I.name === S.selectedItem
      );
      A && n(A);
    }
  }, C = () => {
    i();
  }, x = (S) => {
    const A = S.inputValue ?? "", I = b(A) ? A.slice(1) : A;
    I !== "Enter" && (e(A), w(I)), b(A) || a();
  };
  return Ut(() => {
    p && p.total === 0 && o.length === 0 && u(!0);
  }, [p]), Ut(() => {
    y && l.push({
      message: jb("", "Failed to fetch prompts"),
      variant: "error",
      dismissAfter: Lb
    });
  }, [y]), /* @__PURE__ */ R.jsx(HT.Theme.Provider, { theme: "twilio", children: /* @__PURE__ */ R.jsx(
    hpe.CustomizationProvider,
    {
      theme: HT.TwilioTheme,
      elements: {
        COMBOBOX_ELEMENT: {
          ":focus": {
            boxShadow: "none",
            outline: "none"
          },
          fontWeight: "inherit"
        },
        COMBOBOX: {
          boxShadow: "none",
          ":active": {
            boxShadow: "none"
          },
          ":focus-within": {
            boxShadow: "none"
          },
          ":hover": {
            boxShadow: "none"
          }
        }
      },
      children: /* @__PURE__ */ R.jsxs(
        ar.Box,
        {
          position: "absolute",
          zIndex: "zIndex70",
          top: "space30",
          right: "space40",
          left: "space40",
          children: [
            g && /* @__PURE__ */ R.jsx(
              ar.Box,
              {
                position: "absolute",
                zIndex: "zIndex90",
                left: "space40",
                right: "space40",
                bottom: "space120",
                children: /* @__PURE__ */ R.jsx(Q1r, {})
              }
            ),
            c && /* @__PURE__ */ R.jsx(ar.Box, { position: "absolute", zIndex: "zIndex90", bottom: "space120", children: /* @__PURE__ */ R.jsx(
              x2r,
              {
                handleChatButtonToolClick: C
              }
            ) }),
            h && p && /* @__PURE__ */ R.jsx(
              htt.Combobox,
              {
                autocomplete: !0,
                items: h && h.map((S) => S.name),
                "aria-expanded": "true",
                onIsOpenChange: r,
                inputValue: t,
                initialIsOpen: !0,
                onInputValueChange: x,
                onSelectedItemChange: _,
                labelText: ""
              }
            )
          ]
        }
      )
    }
  ) });
}, bW = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `NotesIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[NotesIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", d: "M5 7.5a.5.5 0 01.5-.5h9a.498.498 0 01.45.717.5.5 0 01-.45.283h-9a.5.5 0 01-.5-.5zm.5 2.5a.498.498 0 00-.49.6.5.5 0 00.49.4h9a.5.5 0 100-1h-9zm-.195 3.04A.498.498 0 015.5 13h6a.498.498 0 01.481.636.5.5 0 01-.481.364h-6a.498.498 0 01-.458-.7.502.502 0 01.263-.26z" }), P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.5 1a.5.5 0 00-1 0v1h-2V1a.5.5 0 00-1 0v1h-2V1a.5.5 0 00-1 0v1h-3A1.5 1.5 0 002 3.5v13A1.5 1.5 0 003.5 18h13a1.5 1.5 0 001.5-1.5v-13A1.5 1.5 0 0016.5 2h-3V1zm-4 2h-2v1a.5.5 0 01-1 0V3h-3a.5.5 0 00-.5.5v13a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-13a.5.5 0 00-.5-.5h-3v1a.5.5 0 01-1 0V3h-2v1a.5.5 0 01-1 0V3z", clipRule: "evenodd" })));
});
bW.displayName = "NotesIcon";
const o1 = {
  automatedUserResponse: "Provide feedback on live chat",
  csatFeedbackButton: {
    defaultButtonText: "Feedback"
  },
  errors: {
    toast: "Something went wrong. Try again.",
    emptyState: {
      heading: (t) => `We could not load the ${t} survey`,
      description: 'Click "Retry" to try again.'
    }
  },
  formButton: {
    cancel: "Cancel",
    submit: "Submit feedback",
    retry: "Retry"
  },
  feedbackSubmitted: "Feedback submitted"
}, $br = ({
  onlyShowIcons: t = !1
}) => {
  const e = s2(), r = Gn(
    (s) => s.csatSurvey.isSurveySubmitted
  ), n = Gn(
    (s) => s.conversation.conversationId
  ), a = Gn((s) => s.config.surveyId), i = Gn((s) => s.conversation.chatId), o = () => {
    e(lKe());
  };
  return !n || !a || !i ? /* @__PURE__ */ R.jsx("div", {}) : /* @__PURE__ */ R.jsx(R.Fragment, { children: !r && /* @__PURE__ */ R.jsx(
    PL,
    {
      text: o1.csatFeedbackButton.defaultButtonText,
      isActive: t,
      placement: "right",
      children: /* @__PURE__ */ R.jsxs(ML, { size: "small", onClick: o, children: [
        /* @__PURE__ */ R.jsx(bW, { decorative: !0 }),
        t ? "" : o1.csatFeedbackButton.defaultButtonText
      ] })
    }
  ) });
};
function Oa(t, e, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(a) {
    if (t == null || t(a), r === !1 || !a.defaultPrevented)
      return e == null ? void 0 : e(a);
  };
}
function _it(t, e) {
  const r = P.createContext(e), n = (i) => {
    const { children: o, ...s } = i, l = P.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ R.jsx(r.Provider, { value: l, children: o });
  };
  n.displayName = t + "Provider";
  function a(i) {
    const o = P.useContext(r);
    if (o) return o;
    if (e !== void 0) return e;
    throw new Error(`\`${i}\` must be used within \`${t}\``);
  }
  return [n, a];
}
function qy(t, e = []) {
  let r = [];
  function n(i, o) {
    const s = P.createContext(o), l = r.length;
    r = [...r, o];
    const c = (f) => {
      var w;
      const { scope: h, children: p, ...g } = f, y = ((w = h == null ? void 0 : h[t]) == null ? void 0 : w[l]) || s, b = P.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ R.jsx(y.Provider, { value: b, children: p });
    };
    c.displayName = i + "Provider";
    function u(f, h) {
      var y;
      const p = ((y = h == null ? void 0 : h[t]) == null ? void 0 : y[l]) || s, g = P.useContext(p);
      if (g) return g;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const a = () => {
    const i = r.map((o) => P.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || i;
      return P.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return a.scopeName = t, [n, Dbr(a, ...e)];
}
function Dbr(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const r = () => {
    const n = t.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return function(i) {
      const o = n.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(i)[`__scope${c}`];
        return { ...s, ...f };
      }, {});
      return P.useMemo(() => ({ [`__scope${e.scopeName}`]: o }), [o]);
    };
  };
  return r.scopeName = e.scopeName, r;
}
function Lbr(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function K8(...t) {
  return (e) => t.forEach((r) => Lbr(r, e));
}
function El(...t) {
  return P.useCallback(K8(...t), t);
}
var dE = P.forwardRef((t, e) => {
  const { children: r, ...n } = t, a = P.Children.toArray(r), i = a.find(Fbr);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? P.Children.count(o) > 1 ? P.Children.only(null) : P.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ R.jsx(tde, { ...n, ref: e, children: P.isValidElement(o) ? P.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(tde, { ...n, ref: e, children: r });
});
dE.displayName = "Slot";
var tde = P.forwardRef((t, e) => {
  const { children: r, ...n } = t;
  if (P.isValidElement(r)) {
    const a = Gbr(r), i = zbr(n, r.props);
    return r.type !== P.Fragment && (i.ref = e ? K8(e, a) : a), P.cloneElement(r, i);
  }
  return P.Children.count(r) > 1 ? P.Children.only(null) : null;
});
tde.displayName = "SlotClone";
var jbr = ({ children: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
function Fbr(t) {
  return P.isValidElement(t) && t.type === jbr;
}
function zbr(t, e) {
  const r = { ...e };
  for (const n in e) {
    const a = t[n], i = e[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...t, ...r };
}
function Gbr(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
function kit(t) {
  const e = t + "CollectionProvider", [r, n] = qy(e), [a, i] = r(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (p) => {
    const { scope: g, children: y } = p, b = Te.useRef(null), w = Te.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ R.jsx(a, { scope: g, itemMap: w, collectionRef: b, children: y });
  };
  o.displayName = e;
  const s = t + "CollectionSlot", l = Te.forwardRef(
    (p, g) => {
      const { scope: y, children: b } = p, w = i(s, y), _ = El(g, w.collectionRef);
      return /* @__PURE__ */ R.jsx(dE, { ref: _, children: b });
    }
  );
  l.displayName = s;
  const c = t + "CollectionItemSlot", u = "data-radix-collection-item", f = Te.forwardRef(
    (p, g) => {
      const { scope: y, children: b, ...w } = p, _ = Te.useRef(null), C = El(g, _), x = i(c, y);
      return Te.useEffect(() => (x.itemMap.set(_, { ref: _, ...w }), () => void x.itemMap.delete(_))), /* @__PURE__ */ R.jsx(dE, { [u]: "", ref: C, children: b });
    }
  );
  f.displayName = c;
  function h(p) {
    const g = i(t + "CollectionConsumer", p);
    return Te.useCallback(() => {
      const b = g.collectionRef.current;
      if (!b) return [];
      const w = Array.from(b.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (x, S) => w.indexOf(x.ref.current) - w.indexOf(S.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: f },
    h,
    n
  ];
}
var T5 = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
}, Wbr = P.useId || (() => {
}), Hbr = 0;
function bh(t) {
  const [e, r] = P.useState(Wbr());
  return T5(() => {
    r((n) => n ?? String(Hbr++));
  }, [t]), e ? `radix-${e}` : "";
}
var Ubr = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Mo = Ubr.reduce((t, e) => {
  const r = P.forwardRef((n, a) => {
    const { asChild: i, ...o } = n, s = i ? dE : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(s, { ...o, ref: a });
  });
  return r.displayName = `Primitive.${e}`, { ...t, [e]: r };
}, {});
function Ait(t, e) {
  t && rWe.flushSync(() => t.dispatchEvent(e));
}
function K1(t) {
  const e = P.useRef(t);
  return P.useEffect(() => {
    e.current = t;
  }), P.useMemo(() => (...r) => {
    var n;
    return (n = e.current) == null ? void 0 : n.call(e, ...r);
  }, []);
}
function Z8({
  prop: t,
  defaultProp: e,
  onChange: r = () => {
  }
}) {
  const [n, a] = Vbr({ defaultProp: e, onChange: r }), i = t !== void 0, o = i ? t : n, s = K1(r), l = P.useCallback(
    (c) => {
      if (i) {
        const f = typeof c == "function" ? c(t) : c;
        f !== t && s(f);
      } else
        a(c);
    },
    [i, t, a, s]
  );
  return [o, l];
}
function Vbr({
  defaultProp: t,
  onChange: e
}) {
  const r = P.useState(t), [n] = r, a = P.useRef(n), i = K1(e);
  return P.useEffect(() => {
    a.current !== n && (i(n), a.current = n);
  }, [n, a, i]), r;
}
var qbr = P.createContext(void 0);
function Nge(t) {
  const e = P.useContext(qbr);
  return t || e || "ltr";
}
var cee = "rovingFocusGroup.onEntryFocus", Kbr = { bubbles: !1, cancelable: !0 }, xW = "RovingFocusGroup", [rde, Tit, Zbr] = kit(xW), [Jbr, CW] = qy(
  xW,
  [Zbr]
), [Ybr, Xbr] = Jbr(xW), Eit = P.forwardRef(
  (t, e) => /* @__PURE__ */ R.jsx(rde.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ R.jsx(rde.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ R.jsx(Qbr, { ...t, ref: e }) }) })
);
Eit.displayName = xW;
var Qbr = P.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: a = !1,
    dir: i,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = t, h = P.useRef(null), p = El(e, h), g = Nge(i), [y = null, b] = Z8({
    prop: o,
    defaultProp: s,
    onChange: l
  }), [w, _] = P.useState(!1), C = K1(c), x = Tit(r), S = P.useRef(!1), [A, I] = P.useState(0);
  return P.useEffect(() => {
    const M = h.current;
    if (M)
      return M.addEventListener(cee, C), () => M.removeEventListener(cee, C);
  }, [C]), /* @__PURE__ */ R.jsx(
    Ybr,
    {
      scope: r,
      orientation: n,
      dir: g,
      loop: a,
      currentTabStopId: y,
      onItemFocus: P.useCallback(
        (M) => b(M),
        [b]
      ),
      onItemShiftTab: P.useCallback(() => _(!0), []),
      onFocusableItemAdd: P.useCallback(
        () => I((M) => M + 1),
        []
      ),
      onFocusableItemRemove: P.useCallback(
        () => I((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ R.jsx(
        Mo.div,
        {
          tabIndex: w || A === 0 ? -1 : 0,
          "data-orientation": n,
          ...f,
          ref: p,
          style: { outline: "none", ...t.style },
          onMouseDown: Oa(t.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: Oa(t.onFocus, (M) => {
            const B = !S.current;
            if (M.target === M.currentTarget && B && !w) {
              const L = new CustomEvent(cee, Kbr);
              if (M.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const N = x().filter((O) => O.focusable), d = N.find((O) => O.active), m = N.find((O) => O.id === y), k = [d, m, ...N].filter(
                  Boolean
                ).map((O) => O.ref.current);
                Pit(k, u);
              }
            }
            S.current = !1;
          }),
          onBlur: Oa(t.onBlur, () => _(!1))
        }
      )
    }
  );
}), Iit = "RovingFocusGroupItem", Mit = P.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: a = !1,
      tabStopId: i,
      ...o
    } = t, s = bh(), l = i || s, c = Xbr(Iit, r), u = c.currentTabStopId === l, f = Tit(r), { onFocusableItemAdd: h, onFocusableItemRemove: p } = c;
    return P.useEffect(() => {
      if (n)
        return h(), () => p();
    }, [n, h, p]), /* @__PURE__ */ R.jsx(
      rde.ItemSlot,
      {
        scope: r,
        id: l,
        focusable: n,
        active: a,
        children: /* @__PURE__ */ R.jsx(
          Mo.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...o,
            ref: e,
            onMouseDown: Oa(t.onMouseDown, (g) => {
              n ? c.onItemFocus(l) : g.preventDefault();
            }),
            onFocus: Oa(t.onFocus, () => c.onItemFocus(l)),
            onKeyDown: Oa(t.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget) return;
              const y = r5r(g, c.orientation, c.dir);
              if (y !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey) return;
                g.preventDefault();
                let w = f().filter((_) => _.focusable).map((_) => _.ref.current);
                if (y === "last") w.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && w.reverse();
                  const _ = w.indexOf(g.currentTarget);
                  w = c.loop ? n5r(w, _ + 1) : w.slice(_ + 1);
                }
                setTimeout(() => Pit(w));
              }
            })
          }
        )
      }
    );
  }
);
Mit.displayName = Iit;
var e5r = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function t5r(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function r5r(t, e, r) {
  const n = t5r(t.key, r);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return e5r[n];
}
function Pit(t, e = !1) {
  const r = document.activeElement;
  for (const n of t)
    if (n === r || (n.focus({ preventScroll: e }), document.activeElement !== r)) return;
}
function n5r(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
var Rit = Eit, Oit = Mit;
function a5r(t, e) {
  return P.useReducer((r, n) => e[r][n] ?? r, t);
}
var kf = (t) => {
  const { present: e, children: r } = t, n = i5r(e), a = typeof r == "function" ? r({ present: n.isPresent }) : P.Children.only(r), i = El(n.ref, o5r(a));
  return typeof r == "function" || n.isPresent ? P.cloneElement(a, { ref: i }) : null;
};
kf.displayName = "Presence";
function i5r(t) {
  const [e, r] = P.useState(), n = P.useRef({}), a = P.useRef(t), i = P.useRef("none"), o = t ? "mounted" : "unmounted", [s, l] = a5r(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return P.useEffect(() => {
    const c = jB(n.current);
    i.current = s === "mounted" ? c : "none";
  }, [s]), T5(() => {
    const c = n.current, u = a.current;
    if (u !== t) {
      const h = i.current, p = jB(c);
      t ? l("MOUNT") : p === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && h !== p ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
    }
  }, [t, l]), T5(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, f = (p) => {
        const y = jB(n.current).includes(p.animationName);
        if (p.target === e && y && (l("ANIMATION_END"), !a.current)) {
          const b = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = b);
          });
        }
      }, h = (p) => {
        p.target === e && (i.current = jB(n.current));
      };
      return e.addEventListener("animationstart", h), e.addEventListener("animationcancel", f), e.addEventListener("animationend", f), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", h), e.removeEventListener("animationcancel", f), e.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: P.useCallback((c) => {
      c && (n.current = getComputedStyle(c)), r(c);
    }, [])
  };
}
function jB(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function o5r(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var $ge = "Tabs", [s5r, j3n] = qy($ge, [
  CW
]), Bit = CW(), [l5r, Dge] = s5r($ge), Nit = P.forwardRef(
  (t, e) => {
    const {
      __scopeTabs: r,
      value: n,
      onValueChange: a,
      defaultValue: i,
      orientation: o = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = t, u = Nge(s), [f, h] = Z8({
      prop: n,
      onChange: a,
      defaultProp: i
    });
    return /* @__PURE__ */ R.jsx(
      l5r,
      {
        scope: r,
        baseId: bh(),
        value: f,
        onValueChange: h,
        orientation: o,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ R.jsx(
          Mo.div,
          {
            dir: u,
            "data-orientation": o,
            ...c,
            ref: e
          }
        )
      }
    );
  }
);
Nit.displayName = $ge;
var $it = "TabsList", Dit = P.forwardRef(
  (t, e) => {
    const { __scopeTabs: r, loop: n = !0, ...a } = t, i = Dge($it, r), o = Bit(r);
    return /* @__PURE__ */ R.jsx(
      Rit,
      {
        asChild: !0,
        ...o,
        orientation: i.orientation,
        dir: i.dir,
        loop: n,
        children: /* @__PURE__ */ R.jsx(
          Mo.div,
          {
            role: "tablist",
            "aria-orientation": i.orientation,
            ...a,
            ref: e
          }
        )
      }
    );
  }
);
Dit.displayName = $it;
var Lit = "TabsTrigger", jit = P.forwardRef(
  (t, e) => {
    const { __scopeTabs: r, value: n, disabled: a = !1, ...i } = t, o = Dge(Lit, r), s = Bit(r), l = Git(o.baseId, n), c = Wit(o.baseId, n), u = n === o.value;
    return /* @__PURE__ */ R.jsx(
      Oit,
      {
        asChild: !0,
        ...s,
        focusable: !a,
        active: u,
        children: /* @__PURE__ */ R.jsx(
          Mo.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": a ? "" : void 0,
            disabled: a,
            id: l,
            ...i,
            ref: e,
            onMouseDown: Oa(t.onMouseDown, (f) => {
              !a && f.button === 0 && f.ctrlKey === !1 ? o.onValueChange(n) : f.preventDefault();
            }),
            onKeyDown: Oa(t.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && o.onValueChange(n);
            }),
            onFocus: Oa(t.onFocus, () => {
              const f = o.activationMode !== "manual";
              !u && !a && f && o.onValueChange(n);
            })
          }
        )
      }
    );
  }
);
jit.displayName = Lit;
var Fit = "TabsContent", zit = P.forwardRef(
  (t, e) => {
    const { __scopeTabs: r, value: n, forceMount: a, children: i, ...o } = t, s = Dge(Fit, r), l = Git(s.baseId, n), c = Wit(s.baseId, n), u = n === s.value, f = P.useRef(u);
    return P.useEffect(() => {
      const h = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ R.jsx(kf, { present: a || u, children: ({ present: h }) => /* @__PURE__ */ R.jsx(
      Mo.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...o,
        ref: e,
        style: {
          ...t.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: h && i
      }
    ) });
  }
);
zit.displayName = Fit;
function Git(t, e) {
  return `${t}-trigger-${e}`;
}
function Wit(t, e) {
  return `${t}-content-${e}`;
}
var c5r = Nit, Hit = Dit, Uit = jit, Vit = zit;
function qit(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var a = t.length;
    for (e = 0; e < a; e++) t[e] && (r = qit(t[e])) && (n && (n += " "), n += r);
  } else for (r in t) t[r] && (n && (n += " "), n += r);
  return n;
}
function Kit() {
  for (var t, e, r = 0, n = "", a = arguments.length; r < a; r++) (t = arguments[r]) && (e = qit(t)) && (n && (n += " "), n += e);
  return n;
}
const Lge = "-", u5r = (t) => {
  const e = f5r(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (o) => {
      const s = o.split(Lge);
      return s[0] === "" && s.length !== 1 && s.shift(), Zit(s, e) || d5r(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = r[o] || [];
      return s && n[o] ? [...l, ...n[o]] : l;
    }
  };
}, Zit = (t, e) => {
  var o;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], n = e.nextPart.get(r), a = n ? Zit(t.slice(1), n) : void 0;
  if (a)
    return a;
  if (e.validators.length === 0)
    return;
  const i = t.join(Lge);
  return (o = e.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, lTe = /^\[(.+)\]$/, d5r = (t) => {
  if (lTe.test(t)) {
    const e = lTe.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, f5r = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return p5r(Object.entries(t.classGroups), r).forEach(([i, o]) => {
    nde(o, n, i, e);
  }), n;
}, nde = (t, e, r, n) => {
  t.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? e : cTe(e, a);
      i.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (h5r(a)) {
        nde(a(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      nde(o, cTe(e, i), r, n);
    });
  });
}, cTe = (t, e) => {
  let r = t;
  return e.split(Lge).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, h5r = (t) => t.isThemeGetter, p5r = (t, e) => e ? t.map(([r, n]) => {
  const a = n.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [e + o, s])) : i);
  return [r, a];
}) : t, m5r = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    r.set(i, o), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = r.get(i);
      if (o !== void 0)
        return o;
      if ((o = n.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      r.has(i) ? r.set(i, o) : a(i, o);
    }
  };
}, Jit = "!", g5r = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, n = e.length === 1, a = e[0], i = e.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, f;
    for (let b = 0; b < s.length; b++) {
      let w = s[b];
      if (c === 0) {
        if (w === a && (n || s.slice(b, b + i) === e)) {
          l.push(s.slice(u, b)), u = b + i;
          continue;
        }
        if (w === "/") {
          f = b;
          continue;
        }
      }
      w === "[" ? c++ : w === "]" && c--;
    }
    const h = l.length === 0 ? s : s.substring(u), p = h.startsWith(Jit), g = p ? h.substring(1) : h, y = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: y
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: o
  }) : o;
}, v5r = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...r.sort(), n), r = []) : r.push(n);
  }), e.push(...r.sort()), e;
}, y5r = (t) => ({
  cache: m5r(t.cacheSize),
  parseClassName: g5r(t),
  ...u5r(t)
}), b5r = /\s+/, x5r = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = e, i = [], o = t.trim().split(b5r);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = r(c);
    let g = !!p, y = n(g ? h.substring(0, p) : h);
    if (!y) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (y = n(h), !y) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const b = v5r(u).join(":"), w = f ? b + Jit : b, _ = w + y;
    if (i.includes(_))
      continue;
    i.push(_);
    const C = a(y, g);
    for (let x = 0; x < C.length; ++x) {
      const S = C[x];
      i.push(w + S);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function C5r() {
  let t = 0, e, r, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = Yit(e)) && (n && (n += " "), n += r);
  return n;
}
const Yit = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = Yit(t[n])) && (r && (r += " "), r += e);
  return r;
};
function w5r(t, ...e) {
  let r, n, a, i = o;
  function o(l) {
    const c = e.reduce((u, f) => f(u), t());
    return r = y5r(c), n = r.cache.get, a = r.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = n(l);
    if (c)
      return c;
    const u = x5r(l, r);
    return a(l, u), u;
  }
  return function() {
    return i(C5r.apply(null, arguments));
  };
}
const vs = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, Xit = /^\[(?:([a-z-]+):)?(.+)\]$/i, S5r = /^\d+\/\d+$/, _5r = /* @__PURE__ */ new Set(["px", "full", "screen"]), k5r = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, A5r = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, T5r = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, E5r = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, I5r = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Dp = (t) => w7(t) || _5r.has(t) || S5r.test(t), Jg = (t) => J8(t, "length", D5r), w7 = (t) => !!t && !Number.isNaN(Number(t)), uee = (t) => J8(t, "number", w7), nS = (t) => !!t && Number.isInteger(Number(t)), M5r = (t) => t.endsWith("%") && w7(t.slice(0, -1)), bi = (t) => Xit.test(t), Yg = (t) => k5r.test(t), P5r = /* @__PURE__ */ new Set(["length", "size", "percentage"]), R5r = (t) => J8(t, P5r, Qit), O5r = (t) => J8(t, "position", Qit), B5r = /* @__PURE__ */ new Set(["image", "url"]), N5r = (t) => J8(t, B5r, j5r), $5r = (t) => J8(t, "", L5r), aS = () => !0, J8 = (t, e, r) => {
  const n = Xit.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : r(n[2]) : !1;
}, D5r = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  A5r.test(t) && !T5r.test(t)
), Qit = () => !1, L5r = (t) => E5r.test(t), j5r = (t) => I5r.test(t), F5r = () => {
  const t = vs("colors"), e = vs("spacing"), r = vs("blur"), n = vs("brightness"), a = vs("borderColor"), i = vs("borderRadius"), o = vs("borderSpacing"), s = vs("borderWidth"), l = vs("contrast"), c = vs("grayscale"), u = vs("hueRotate"), f = vs("invert"), h = vs("gap"), p = vs("gradientColorStops"), g = vs("gradientColorStopPositions"), y = vs("inset"), b = vs("margin"), w = vs("opacity"), _ = vs("padding"), C = vs("saturate"), x = vs("scale"), S = vs("sepia"), A = vs("skew"), I = vs("space"), M = vs("translate"), B = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], N = () => ["auto", bi, e], d = () => [bi, e], m = () => ["", Dp, Jg], v = () => ["auto", w7, bi], k = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], O = () => ["solid", "dashed", "dotted", "double", "none"], G = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", bi], F = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], z = () => [w7, bi];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [aS],
      spacing: [Dp, Jg],
      blur: ["none", "", Yg, bi],
      brightness: z(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Yg, bi],
      borderSpacing: d(),
      borderWidth: m(),
      contrast: z(),
      grayscale: j(),
      hueRotate: z(),
      invert: j(),
      gap: d(),
      gradientColorStops: [t],
      gradientColorStopPositions: [M5r, Jg],
      inset: N(),
      margin: N(),
      opacity: z(),
      padding: d(),
      saturate: z(),
      scale: z(),
      sepia: j(),
      skew: z(),
      space: d(),
      translate: d()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", bi]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Yg]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": F()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": F()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...k(), bi]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", nS, bi]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: N()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", bi]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", nS, bi]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [aS]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", nS, bi]
        }, bi]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": v()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": v()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [aS]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [nS, bi]
        }, bi]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": v()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": v()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", bi]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", bi]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [_]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [_]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [_]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [_]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [_]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [_]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [_]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [_]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [_]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", bi, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [bi, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [bi, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Yg]
        }, Yg]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [bi, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [bi, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [bi, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [bi, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Yg, Jg]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", uee]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [aS]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", bi]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", w7, uee]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Dp, bi]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", bi]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", bi]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...O(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Dp, Jg]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Dp, bi]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: d()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", bi]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", bi]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...k(), O5r]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", R5r]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, N5r]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...O(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: O()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...O()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Dp, bi]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Dp, Jg]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: m()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Dp, Jg]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Yg, $5r]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [aS]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...G(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": G()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Yg, bi]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", bi]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", bi]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", bi]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [nS, bi]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", bi]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", bi]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": d()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": d()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": d()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": d()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": d()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": d()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": d()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": d()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": d()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": d()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": d()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": d()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": d()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": d()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": d()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": d()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": d()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": d()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", bi]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Dp, Jg, uee]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, z5r = /* @__PURE__ */ w5r(F5r);
function Tc(...t) {
  return z5r(Kit(t));
}
const G5r = c5r, eot = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Hit,
  {
    ref: r,
    className: Tc(
      "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
      t
    ),
    ...e
  }
));
eot.displayName = Hit.displayName;
const ade = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Uit,
  {
    ref: r,
    className: Tc(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
      t
    ),
    ...e
  }
));
ade.displayName = Uit.displayName;
const ide = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Vit,
  {
    ref: r,
    className: Tc(
      "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      t
    ),
    ...e
  }
));
ide.displayName = Vit.displayName;
function W5r(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = K1(t);
  P.useEffect(() => {
    const n = (a) => {
      a.key === "Escape" && r(a);
    };
    return e.addEventListener("keydown", n, { capture: !0 }), () => e.removeEventListener("keydown", n, { capture: !0 });
  }, [r, e]);
}
var H5r = "DismissableLayer", ode = "dismissableLayer.update", U5r = "dismissableLayer.pointerDownOutside", V5r = "dismissableLayer.focusOutside", uTe, tot = P.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), wW = P.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = t, c = P.useContext(tot), [u, f] = P.useState(null), h = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = P.useState({}), g = El(e, (I) => f(I)), y = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = y.indexOf(b), _ = u ? y.indexOf(u) : -1, C = c.layersWithOutsidePointerEventsDisabled.size > 0, x = _ >= w, S = Z5r((I) => {
      const M = I.target, B = [...c.branches].some((L) => L.contains(M));
      !x || B || (a == null || a(I), o == null || o(I), I.defaultPrevented || s == null || s());
    }, h), A = J5r((I) => {
      const M = I.target;
      [...c.branches].some((L) => L.contains(M)) || (i == null || i(I), o == null || o(I), I.defaultPrevented || s == null || s());
    }, h);
    return W5r((I) => {
      _ === c.layers.size - 1 && (n == null || n(I), !I.defaultPrevented && s && (I.preventDefault(), s()));
    }, h), P.useEffect(() => {
      if (u)
        return r && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (uTe = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), dTe(), () => {
          r && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = uTe);
        };
    }, [u, h, r, c]), P.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), dTe());
    }, [u, c]), P.useEffect(() => {
      const I = () => p({});
      return document.addEventListener(ode, I), () => document.removeEventListener(ode, I);
    }, []), /* @__PURE__ */ R.jsx(
      Mo.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: C ? x ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Oa(t.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Oa(t.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Oa(
          t.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
wW.displayName = H5r;
var q5r = "DismissableLayerBranch", K5r = P.forwardRef((t, e) => {
  const r = P.useContext(tot), n = P.useRef(null), a = El(e, n);
  return P.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ R.jsx(Mo.div, { ...t, ref: a });
});
K5r.displayName = q5r;
function Z5r(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = K1(t), n = P.useRef(!1), a = P.useRef(() => {
  });
  return P.useEffect(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let l = function() {
          rot(
            U5r,
            r,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", a.current), a.current = l, e.addEventListener("click", a.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", a.current);
      n.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", i), e.removeEventListener("click", a.current);
    };
  }, [e, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function J5r(t, e = globalThis == null ? void 0 : globalThis.document) {
  const r = K1(t), n = P.useRef(!1);
  return P.useEffect(() => {
    const a = (i) => {
      i.target && !n.current && rot(V5r, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", a), () => e.removeEventListener("focusin", a);
  }, [e, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function dTe() {
  const t = new CustomEvent(ode);
  document.dispatchEvent(t);
}
function rot(t, e, r, { discrete: n }) {
  const a = r.originalEvent.target, i = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: r });
  e && a.addEventListener(t, e, { once: !0 }), n ? Ait(a, i) : a.dispatchEvent(i);
}
var dee = 0;
function jge() {
  P.useEffect(() => {
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", t[0] ?? fTe()), document.body.insertAdjacentElement("beforeend", t[1] ?? fTe()), dee++, () => {
      dee === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), dee--;
    };
  }, []);
}
function fTe() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.outline = "none", t.style.opacity = "0", t.style.position = "fixed", t.style.pointerEvents = "none", t;
}
var fee = "focusScope.autoFocusOnMount", hee = "focusScope.autoFocusOnUnmount", hTe = { bubbles: !1, cancelable: !0 }, Y5r = "FocusScope", SW = P.forwardRef((t, e) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...o
  } = t, [s, l] = P.useState(null), c = K1(a), u = K1(i), f = P.useRef(null), h = El(e, (y) => l(y)), p = P.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  P.useEffect(() => {
    if (n) {
      let y = function(C) {
        if (p.paused || !s) return;
        const x = C.target;
        s.contains(x) ? f.current = x : lv(f.current, { select: !0 });
      }, b = function(C) {
        if (p.paused || !s) return;
        const x = C.relatedTarget;
        x !== null && (s.contains(x) || lv(f.current, { select: !0 }));
      }, w = function(C) {
        if (document.activeElement === document.body)
          for (const S of C)
            S.removedNodes.length > 0 && lv(s);
      };
      document.addEventListener("focusin", y), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", y), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [n, s, p.paused]), P.useEffect(() => {
    if (s) {
      mTe.add(p);
      const y = document.activeElement;
      if (!s.contains(y)) {
        const w = new CustomEvent(fee, hTe);
        s.addEventListener(fee, c), s.dispatchEvent(w), w.defaultPrevented || (X5r(n6r(not(s)), { select: !0 }), document.activeElement === y && lv(s));
      }
      return () => {
        s.removeEventListener(fee, c), setTimeout(() => {
          const w = new CustomEvent(hee, hTe);
          s.addEventListener(hee, u), s.dispatchEvent(w), w.defaultPrevented || lv(y ?? document.body, { select: !0 }), s.removeEventListener(hee, u), mTe.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const g = P.useCallback(
    (y) => {
      if (!r && !n || p.paused) return;
      const b = y.key === "Tab" && !y.altKey && !y.ctrlKey && !y.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = y.currentTarget, [C, x] = Q5r(_);
        C && x ? !y.shiftKey && w === x ? (y.preventDefault(), r && lv(C, { select: !0 })) : y.shiftKey && w === C && (y.preventDefault(), r && lv(x, { select: !0 })) : w === _ && y.preventDefault();
      }
    },
    [r, n, p.paused]
  );
  return /* @__PURE__ */ R.jsx(Mo.div, { tabIndex: -1, ...o, ref: h, onKeyDown: g });
});
SW.displayName = Y5r;
function X5r(t, { select: e = !1 } = {}) {
  const r = document.activeElement;
  for (const n of t)
    if (lv(n, { select: e }), document.activeElement !== r) return;
}
function Q5r(t) {
  const e = not(t), r = pTe(e, t), n = pTe(e.reverse(), t);
  return [r, n];
}
function not(t) {
  const e = [], r = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) e.push(r.currentNode);
  return e;
}
function pTe(t, e) {
  for (const r of t)
    if (!e6r(r, { upTo: e })) return r;
}
function e6r(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden") return !0;
  for (; t; ) {
    if (e !== void 0 && t === e) return !1;
    if (getComputedStyle(t).display === "none") return !0;
    t = t.parentElement;
  }
  return !1;
}
function t6r(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function lv(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const r = document.activeElement;
    t.focus({ preventScroll: !0 }), t !== r && t6r(t) && e && t.select();
  }
}
var mTe = r6r();
function r6r() {
  let t = [];
  return {
    add(e) {
      const r = t[0];
      e !== r && (r == null || r.pause()), t = gTe(t, e), t.unshift(e);
    },
    remove(e) {
      var r;
      t = gTe(t, e), (r = t[0]) == null || r.resume();
    }
  };
}
function gTe(t, e) {
  const r = [...t], n = r.indexOf(e);
  return n !== -1 && r.splice(n, 1), r;
}
function n6r(t) {
  return t.filter((e) => e.tagName !== "A");
}
const a6r = ["top", "right", "bottom", "left"], yy = Math.min, Qd = Math.max, tj = Math.round, FB = Math.floor, xh = (t) => ({
  x: t,
  y: t
}), i6r = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, o6r = {
  start: "end",
  end: "start"
};
function sde(t, e, r) {
  return Qd(t, yy(e, r));
}
function Zm(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Jm(t) {
  return t.split("-")[0];
}
function Y8(t) {
  return t.split("-")[1];
}
function Fge(t) {
  return t === "x" ? "y" : "x";
}
function zge(t) {
  return t === "y" ? "height" : "width";
}
function by(t) {
  return ["top", "bottom"].includes(Jm(t)) ? "y" : "x";
}
function Gge(t) {
  return Fge(by(t));
}
function s6r(t, e, r) {
  r === void 0 && (r = !1);
  const n = Y8(t), a = Gge(t), i = zge(a);
  let o = a === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (o = rj(o)), [o, rj(o)];
}
function l6r(t) {
  const e = rj(t);
  return [lde(t), e, lde(e)];
}
function lde(t) {
  return t.replace(/start|end/g, (e) => o6r[e]);
}
function c6r(t, e, r) {
  const n = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return r ? e ? a : n : e ? n : a;
    case "left":
    case "right":
      return e ? i : o;
    default:
      return [];
  }
}
function u6r(t, e, r, n) {
  const a = Y8(t);
  let i = c6r(Jm(t), r === "start", n);
  return a && (i = i.map((o) => o + "-" + a), e && (i = i.concat(i.map(lde)))), i;
}
function rj(t) {
  return t.replace(/left|right|bottom|top/g, (e) => i6r[e]);
}
function d6r(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function aot(t) {
  return typeof t != "number" ? d6r(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function nj(t) {
  const {
    x: e,
    y: r,
    width: n,
    height: a
  } = t;
  return {
    width: n,
    height: a,
    top: r,
    left: e,
    right: e + n,
    bottom: r + a,
    x: e,
    y: r
  };
}
function vTe(t, e, r) {
  let {
    reference: n,
    floating: a
  } = t;
  const i = by(e), o = Gge(e), s = zge(o), l = Jm(e), c = i === "y", u = n.x + n.width / 2 - a.width / 2, f = n.y + n.height / 2 - a.height / 2, h = n[s] / 2 - a[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: n.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: n.x - a.width,
        y: f
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (Y8(e)) {
    case "start":
      p[o] -= h * (r && c ? -1 : 1);
      break;
    case "end":
      p[o] += h * (r && c ? -1 : 1);
      break;
  }
  return p;
}
const f6r = async (t, e, r) => {
  const {
    placement: n = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = r, s = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: t,
    floating: e,
    strategy: a
  }), {
    x: u,
    y: f
  } = vTe(c, n, l), h = n, p = {}, g = 0;
  for (let y = 0; y < s.length; y++) {
    const {
      name: b,
      fn: w
    } = s[y], {
      x: _,
      y: C,
      data: x,
      reset: S
    } = await w({
      x: u,
      y: f,
      initialPlacement: n,
      placement: h,
      strategy: a,
      middlewareData: p,
      rects: c,
      platform: o,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = _ ?? u, f = C ?? f, p = {
      ...p,
      [b]: {
        ...p[b],
        ...x
      }
    }, S && g <= 50 && (g++, typeof S == "object" && (S.placement && (h = S.placement), S.rects && (c = S.rects === !0 ? await o.getElementRects({
      reference: t,
      floating: e,
      strategy: a
    }) : S.rects), {
      x: u,
      y: f
    } = vTe(c, h, l)), y = -1);
  }
  return {
    x: u,
    y: f,
    placement: h,
    strategy: a,
    middlewareData: p
  };
};
async function fE(t, e) {
  var r;
  e === void 0 && (e = {});
  const {
    x: n,
    y: a,
    platform: i,
    rects: o,
    elements: s,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = Zm(e, t), g = aot(p), b = s[h ? f === "floating" ? "reference" : "floating" : f], w = nj(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(b))) == null || r ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), _ = f === "floating" ? {
    x: n,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), x = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = nj(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: C,
    strategy: l
  }) : _);
  return {
    top: (w.top - S.top + g.top) / x.y,
    bottom: (S.bottom - w.bottom + g.bottom) / x.y,
    left: (w.left - S.left + g.left) / x.x,
    right: (S.right - w.right + g.right) / x.x
  };
}
const h6r = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: r,
      y: n,
      placement: a,
      rects: i,
      platform: o,
      elements: s,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0
    } = Zm(t, e) || {};
    if (c == null)
      return {};
    const f = aot(u), h = {
      x: r,
      y: n
    }, p = Gge(a), g = zge(p), y = await o.getDimensions(c), b = p === "y", w = b ? "top" : "left", _ = b ? "bottom" : "right", C = b ? "clientHeight" : "clientWidth", x = i.reference[g] + i.reference[p] - h[p] - i.floating[g], S = h[p] - i.reference[p], A = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let I = A ? A[C] : 0;
    (!I || !await (o.isElement == null ? void 0 : o.isElement(A))) && (I = s.floating[C] || i.floating[g]);
    const M = x / 2 - S / 2, B = I / 2 - y[g] / 2 - 1, L = yy(f[w], B), N = yy(f[_], B), d = L, m = I - y[g] - N, v = I / 2 - y[g] / 2 + M, k = sde(d, v, m), O = !l.arrow && Y8(a) != null && v !== k && i.reference[g] / 2 - (v < d ? L : N) - y[g] / 2 < 0, G = O ? v < d ? v - d : v - m : 0;
    return {
      [p]: h[p] + G,
      data: {
        [p]: k,
        centerOffset: v - k - G,
        ...O && {
          alignmentOffset: G
        }
      },
      reset: O
    };
  }
}), p6r = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: y = !0,
        ...b
      } = Zm(t, e);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const w = Jm(a), _ = by(s), C = Jm(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = h || (C || !y ? [rj(s)] : l6r(s)), A = g !== "none";
      !h && A && S.push(...u6r(s, y, g, x));
      const I = [s, ...S], M = await fE(e, b), B = [];
      let L = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && B.push(M[w]), f) {
        const v = s6r(a, o, x);
        B.push(M[v[0]], M[v[1]]);
      }
      if (L = [...L, {
        placement: a,
        overflows: B
      }], !B.every((v) => v <= 0)) {
        var N, d;
        const v = (((N = i.flip) == null ? void 0 : N.index) || 0) + 1, k = I[v];
        if (k)
          return {
            data: {
              index: v,
              overflows: L
            },
            reset: {
              placement: k
            }
          };
        let O = (d = L.filter((G) => G.overflows[0] <= 0).sort((G, H) => G.overflows[1] - H.overflows[1])[0]) == null ? void 0 : d.placement;
        if (!O)
          switch (p) {
            case "bestFit": {
              var m;
              const G = (m = L.filter((H) => {
                if (A) {
                  const j = by(H.placement);
                  return j === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  j === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((j) => j > 0).reduce((j, F) => j + F, 0)]).sort((H, j) => H[1] - j[1])[0]) == null ? void 0 : m[0];
              G && (O = G);
              break;
            }
            case "initialPlacement":
              O = s;
              break;
          }
        if (a !== O)
          return {
            reset: {
              placement: O
            }
          };
      }
      return {};
    }
  };
};
function yTe(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function bTe(t) {
  return a6r.some((e) => t[e] >= 0);
}
const m6r = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: r
      } = e, {
        strategy: n = "referenceHidden",
        ...a
      } = Zm(t, e);
      switch (n) {
        case "referenceHidden": {
          const i = await fE(e, {
            ...a,
            elementContext: "reference"
          }), o = yTe(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: bTe(o)
            }
          };
        }
        case "escaped": {
          const i = await fE(e, {
            ...a,
            altBoundary: !0
          }), o = yTe(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: bTe(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function g6r(t, e) {
  const {
    placement: r,
    platform: n,
    elements: a
  } = t, i = await (n.isRTL == null ? void 0 : n.isRTL(a.floating)), o = Jm(r), s = Y8(r), l = by(r) === "y", c = ["left", "top"].includes(o) ? -1 : 1, u = i && l ? -1 : 1, f = Zm(e, t);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (p = s === "end" ? g * -1 : g), l ? {
    x: p * u,
    y: h * c
  } : {
    x: h * c,
    y: p * u
  };
}
const v6r = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var r, n;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: s
      } = e, l = await g6r(e, t);
      return o === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: a + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, y6r = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: r,
        y: n,
        placement: a
      } = e, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y: _
            } = b;
            return {
              x: w,
              y: _
            };
          }
        },
        ...l
      } = Zm(t, e), c = {
        x: r,
        y: n
      }, u = await fE(e, l), f = by(Jm(a)), h = Fge(f);
      let p = c[h], g = c[f];
      if (i) {
        const b = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", _ = p + u[b], C = p - u[w];
        p = sde(_, p, C);
      }
      if (o) {
        const b = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", _ = g + u[b], C = g - u[w];
        g = sde(_, g, C);
      }
      const y = s.fn({
        ...e,
        [h]: p,
        [f]: g
      });
      return {
        ...y,
        data: {
          x: y.x - r,
          y: y.y - n,
          enabled: {
            [h]: i,
            [f]: o
          }
        }
      };
    }
  };
}, b6r = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: r,
        y: n,
        placement: a,
        rects: i,
        middlewareData: o
      } = e, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = Zm(t, e), u = {
        x: r,
        y: n
      }, f = by(a), h = Fge(f);
      let p = u[h], g = u[f];
      const y = Zm(s, e), b = typeof y == "number" ? {
        mainAxis: y,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...y
      };
      if (l) {
        const C = h === "y" ? "height" : "width", x = i.reference[h] - i.floating[C] + b.mainAxis, S = i.reference[h] + i.reference[C] - b.mainAxis;
        p < x ? p = x : p > S && (p = S);
      }
      if (c) {
        var w, _;
        const C = h === "y" ? "width" : "height", x = ["top", "left"].includes(Jm(a)), S = i.reference[f] - i.floating[C] + (x && ((w = o.offset) == null ? void 0 : w[f]) || 0) + (x ? 0 : b.crossAxis), A = i.reference[f] + i.reference[C] + (x ? 0 : ((_ = o.offset) == null ? void 0 : _[f]) || 0) - (x ? b.crossAxis : 0);
        g < S ? g = S : g > A && (g = A);
      }
      return {
        [h]: p,
        [f]: g
      };
    }
  };
}, x6r = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var r, n;
      const {
        placement: a,
        rects: i,
        platform: o,
        elements: s
      } = e, {
        apply: l = () => {
        },
        ...c
      } = Zm(t, e), u = await fE(e, c), f = Jm(a), h = Y8(a), p = by(a) === "y", {
        width: g,
        height: y
      } = i.floating;
      let b, w;
      f === "top" || f === "bottom" ? (b = f, w = h === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = f, b = h === "end" ? "top" : "bottom");
      const _ = y - u.top - u.bottom, C = g - u.left - u.right, x = yy(y - u[b], _), S = yy(g - u[w], C), A = !e.middlewareData.shift;
      let I = x, M = S;
      if ((r = e.middlewareData.shift) != null && r.enabled.x && (M = C), (n = e.middlewareData.shift) != null && n.enabled.y && (I = _), A && !h) {
        const L = Qd(u.left, 0), N = Qd(u.right, 0), d = Qd(u.top, 0), m = Qd(u.bottom, 0);
        p ? M = g - 2 * (L !== 0 || N !== 0 ? L + N : Qd(u.left, u.right)) : I = y - 2 * (d !== 0 || m !== 0 ? d + m : Qd(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: M,
        availableHeight: I
      });
      const B = await o.getDimensions(s.floating);
      return g !== B.width || y !== B.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function _W() {
  return typeof window < "u";
}
function X8(t) {
  return iot(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function c0(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ip(t) {
  var e;
  return (e = (iot(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function iot(t) {
  return _W() ? t instanceof Node || t instanceof c0(t).Node : !1;
}
function Z1(t) {
  return _W() ? t instanceof Element || t instanceof c0(t).Element : !1;
}
function Wh(t) {
  return _W() ? t instanceof HTMLElement || t instanceof c0(t).HTMLElement : !1;
}
function xTe(t) {
  return !_W() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof c0(t).ShadowRoot;
}
function XM(t) {
  const {
    overflow: e,
    overflowX: r,
    overflowY: n,
    display: a
  } = J1(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + r) && !["inline", "contents"].includes(a);
}
function C6r(t) {
  return ["table", "td", "th"].includes(X8(t));
}
function kW(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Wge(t) {
  const e = Hge(), r = Z1(t) ? J1(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !e && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !e && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function w6r(t) {
  let e = xy(t);
  for (; Wh(e) && !_x(e); ) {
    if (Wge(e))
      return e;
    if (kW(e))
      return null;
    e = xy(e);
  }
  return null;
}
function Hge() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function _x(t) {
  return ["html", "body", "#document"].includes(X8(t));
}
function J1(t) {
  return c0(t).getComputedStyle(t);
}
function AW(t) {
  return Z1(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function xy(t) {
  if (X8(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    xTe(t) && t.host || // Fallback.
    ip(t)
  );
  return xTe(e) ? e.host : e;
}
function oot(t) {
  const e = xy(t);
  return _x(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Wh(e) && XM(e) ? e : oot(e);
}
function hE(t, e, r) {
  var n;
  e === void 0 && (e = []), r === void 0 && (r = !0);
  const a = oot(t), i = a === ((n = t.ownerDocument) == null ? void 0 : n.body), o = c0(a);
  if (i) {
    const s = cde(o);
    return e.concat(o, o.visualViewport || [], XM(a) ? a : [], s && r ? hE(s) : []);
  }
  return e.concat(a, hE(a, [], r));
}
function cde(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function sot(t) {
  const e = J1(t);
  let r = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const a = Wh(t), i = a ? t.offsetWidth : r, o = a ? t.offsetHeight : n, s = tj(r) !== i || tj(n) !== o;
  return s && (r = i, n = o), {
    width: r,
    height: n,
    $: s
  };
}
function Uge(t) {
  return Z1(t) ? t : t.contextElement;
}
function S7(t) {
  const e = Uge(t);
  if (!Wh(e))
    return xh(1);
  const r = e.getBoundingClientRect(), {
    width: n,
    height: a,
    $: i
  } = sot(e);
  let o = (i ? tj(r.width) : r.width) / n, s = (i ? tj(r.height) : r.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const S6r = /* @__PURE__ */ xh(0);
function lot(t) {
  const e = c0(t);
  return !Hge() || !e.visualViewport ? S6r : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function _6r(t, e, r) {
  return e === void 0 && (e = !1), !r || e && r !== c0(t) ? !1 : e;
}
function E5(t, e, r, n) {
  e === void 0 && (e = !1), r === void 0 && (r = !1);
  const a = t.getBoundingClientRect(), i = Uge(t);
  let o = xh(1);
  e && (n ? Z1(n) && (o = S7(n)) : o = S7(t));
  const s = _6r(i, r, n) ? lot(i) : xh(0);
  let l = (a.left + s.x) / o.x, c = (a.top + s.y) / o.y, u = a.width / o.x, f = a.height / o.y;
  if (i) {
    const h = c0(i), p = n && Z1(n) ? c0(n) : n;
    let g = h, y = cde(g);
    for (; y && n && p !== g; ) {
      const b = S7(y), w = y.getBoundingClientRect(), _ = J1(y), C = w.left + (y.clientLeft + parseFloat(_.paddingLeft)) * b.x, x = w.top + (y.clientTop + parseFloat(_.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, f *= b.y, l += C, c += x, g = c0(y), y = cde(g);
    }
  }
  return nj({
    width: u,
    height: f,
    x: l,
    y: c
  });
}
function Vge(t, e) {
  const r = AW(t).scrollLeft;
  return e ? e.left + r : E5(ip(t)).left + r;
}
function cot(t, e, r) {
  r === void 0 && (r = !1);
  const n = t.getBoundingClientRect(), a = n.left + e.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Vge(t, n)
  )), i = n.top + e.scrollTop;
  return {
    x: a,
    y: i
  };
}
function k6r(t) {
  let {
    elements: e,
    rect: r,
    offsetParent: n,
    strategy: a
  } = t;
  const i = a === "fixed", o = ip(n), s = e ? kW(e.floating) : !1;
  if (n === o || s && i)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = xh(1);
  const u = xh(0), f = Wh(n);
  if ((f || !f && !i) && ((X8(n) !== "body" || XM(o)) && (l = AW(n)), Wh(n))) {
    const p = E5(n);
    c = S7(n), u.x = p.x + n.clientLeft, u.y = p.y + n.clientTop;
  }
  const h = o && !f && !i ? cot(o, l, !0) : xh(0);
  return {
    width: r.width * c.x,
    height: r.height * c.y,
    x: r.x * c.x - l.scrollLeft * c.x + u.x + h.x,
    y: r.y * c.y - l.scrollTop * c.y + u.y + h.y
  };
}
function A6r(t) {
  return Array.from(t.getClientRects());
}
function T6r(t) {
  const e = ip(t), r = AW(t), n = t.ownerDocument.body, a = Qd(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), i = Qd(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -r.scrollLeft + Vge(t);
  const s = -r.scrollTop;
  return J1(n).direction === "rtl" && (o += Qd(e.clientWidth, n.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: s
  };
}
function E6r(t, e) {
  const r = c0(t), n = ip(t), a = r.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    const c = Hge();
    (!c || c && e === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function I6r(t, e) {
  const r = E5(t, !0, e === "fixed"), n = r.top + t.clientTop, a = r.left + t.clientLeft, i = Wh(t) ? S7(t) : xh(1), o = t.clientWidth * i.x, s = t.clientHeight * i.y, l = a * i.x, c = n * i.y;
  return {
    width: o,
    height: s,
    x: l,
    y: c
  };
}
function CTe(t, e, r) {
  let n;
  if (e === "viewport")
    n = E6r(t, r);
  else if (e === "document")
    n = T6r(ip(t));
  else if (Z1(e))
    n = I6r(e, r);
  else {
    const a = lot(t);
    n = {
      x: e.x - a.x,
      y: e.y - a.y,
      width: e.width,
      height: e.height
    };
  }
  return nj(n);
}
function uot(t, e) {
  const r = xy(t);
  return r === e || !Z1(r) || _x(r) ? !1 : J1(r).position === "fixed" || uot(r, e);
}
function M6r(t, e) {
  const r = e.get(t);
  if (r)
    return r;
  let n = hE(t, [], !1).filter((s) => Z1(s) && X8(s) !== "body"), a = null;
  const i = J1(t).position === "fixed";
  let o = i ? xy(t) : t;
  for (; Z1(o) && !_x(o); ) {
    const s = J1(o), l = Wge(o);
    !l && s.position === "fixed" && (a = null), (i ? !l && !a : !l && s.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || XM(o) && !l && uot(t, o)) ? n = n.filter((u) => u !== o) : a = s, o = xy(o);
  }
  return e.set(t, n), n;
}
function P6r(t) {
  let {
    element: e,
    boundary: r,
    rootBoundary: n,
    strategy: a
  } = t;
  const o = [...r === "clippingAncestors" ? kW(e) ? [] : M6r(e, this._c) : [].concat(r), n], s = o[0], l = o.reduce((c, u) => {
    const f = CTe(e, u, a);
    return c.top = Qd(f.top, c.top), c.right = yy(f.right, c.right), c.bottom = yy(f.bottom, c.bottom), c.left = Qd(f.left, c.left), c;
  }, CTe(e, s, a));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function R6r(t) {
  const {
    width: e,
    height: r
  } = sot(t);
  return {
    width: e,
    height: r
  };
}
function O6r(t, e, r) {
  const n = Wh(e), a = ip(e), i = r === "fixed", o = E5(t, !0, i, e);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = xh(0);
  if (n || !n && !i)
    if ((X8(e) !== "body" || XM(a)) && (s = AW(e)), n) {
      const h = E5(e, !0, i, e);
      l.x = h.x + e.clientLeft, l.y = h.y + e.clientTop;
    } else a && (l.x = Vge(a));
  const c = a && !n && !i ? cot(a, s) : xh(0), u = o.left + s.scrollLeft - l.x - c.x, f = o.top + s.scrollTop - l.y - c.y;
  return {
    x: u,
    y: f,
    width: o.width,
    height: o.height
  };
}
function pee(t) {
  return J1(t).position === "static";
}
function wTe(t, e) {
  if (!Wh(t) || J1(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let r = t.offsetParent;
  return ip(t) === r && (r = r.ownerDocument.body), r;
}
function dot(t, e) {
  const r = c0(t);
  if (kW(t))
    return r;
  if (!Wh(t)) {
    let a = xy(t);
    for (; a && !_x(a); ) {
      if (Z1(a) && !pee(a))
        return a;
      a = xy(a);
    }
    return r;
  }
  let n = wTe(t, e);
  for (; n && C6r(n) && pee(n); )
    n = wTe(n, e);
  return n && _x(n) && pee(n) && !Wge(n) ? r : n || w6r(t) || r;
}
const B6r = async function(t) {
  const e = this.getOffsetParent || dot, r = this.getDimensions, n = await r(t.floating);
  return {
    reference: O6r(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function N6r(t) {
  return J1(t).direction === "rtl";
}
const $6r = {
  convertOffsetParentRelativeRectToViewportRelativeRect: k6r,
  getDocumentElement: ip,
  getClippingRect: P6r,
  getOffsetParent: dot,
  getElementRects: B6r,
  getClientRects: A6r,
  getDimensions: R6r,
  getScale: S7,
  isElement: Z1,
  isRTL: N6r
};
function fot(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function D6r(t, e) {
  let r = null, n;
  const a = ip(t);
  function i() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: f,
      width: h,
      height: p
    } = c;
    if (s || e(), !h || !p)
      return;
    const g = FB(f), y = FB(a.clientWidth - (u + h)), b = FB(a.clientHeight - (f + p)), w = FB(u), C = {
      rootMargin: -g + "px " + -y + "px " + -b + "px " + -w + "px",
      threshold: Qd(0, yy(1, l)) || 1
    };
    let x = !0;
    function S(A) {
      const I = A[0].intersectionRatio;
      if (I !== l) {
        if (!x)
          return o();
        I ? o(!1, I) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      I === 1 && !fot(c, t.getBoundingClientRect()) && o(), x = !1;
    }
    try {
      r = new IntersectionObserver(S, {
        ...C,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(S, C);
    }
    r.observe(t);
  }
  return o(!0), i;
}
function L6r(t, e, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, c = Uge(t), u = a || i ? [...c ? hE(c) : [], ...hE(e)] : [];
  u.forEach((w) => {
    a && w.addEventListener("scroll", r, {
      passive: !0
    }), i && w.addEventListener("resize", r);
  });
  const f = c && s ? D6r(c, r) : null;
  let h = -1, p = null;
  o && (p = new ResizeObserver((w) => {
    let [_] = w;
    _ && _.target === c && p && (p.unobserve(e), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(e);
    })), r();
  }), c && !l && p.observe(c), p.observe(e));
  let g, y = l ? E5(t) : null;
  l && b();
  function b() {
    const w = E5(t);
    y && !fot(y, w) && r(), y = w, g = requestAnimationFrame(b);
  }
  return r(), () => {
    var w;
    u.forEach((_) => {
      a && _.removeEventListener("scroll", r), i && _.removeEventListener("resize", r);
    }), f == null || f(), (w = p) == null || w.disconnect(), p = null, l && cancelAnimationFrame(g);
  };
}
const j6r = v6r, F6r = y6r, z6r = p6r, G6r = x6r, W6r = m6r, STe = h6r, H6r = b6r, U6r = (t, e, r) => {
  const n = /* @__PURE__ */ new Map(), a = {
    platform: $6r,
    ...r
  }, i = {
    ...a.platform,
    _c: n
  };
  return f6r(t, e, {
    ...a,
    platform: i
  });
};
var x$ = typeof document < "u" ? qh : Ut;
function aj(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let r, n, a;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (r = t.length, r !== e.length) return !1;
      for (n = r; n-- !== 0; )
        if (!aj(t[n], e[n]))
          return !1;
      return !0;
    }
    if (a = Object.keys(t), r = a.length, r !== Object.keys(e).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(e, a[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = a[n];
      if (!(i === "_owner" && t.$$typeof) && !aj(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function hot(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function _Te(t, e) {
  const r = hot(t);
  return Math.round(e * r) / r;
}
function mee(t) {
  const e = P.useRef(t);
  return x$(() => {
    e.current = t;
  }), e;
}
function V6r(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, f] = P.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = P.useState(n);
  aj(h, n) || p(n);
  const [g, y] = P.useState(null), [b, w] = P.useState(null), _ = P.useCallback((H) => {
    H !== A.current && (A.current = H, y(H));
  }, []), C = P.useCallback((H) => {
    H !== I.current && (I.current = H, w(H));
  }, []), x = i || g, S = o || b, A = P.useRef(null), I = P.useRef(null), M = P.useRef(u), B = l != null, L = mee(l), N = mee(a), d = mee(c), m = P.useCallback(() => {
    if (!A.current || !I.current)
      return;
    const H = {
      placement: e,
      strategy: r,
      middleware: h
    };
    N.current && (H.platform = N.current), U6r(A.current, I.current, H).then((j) => {
      const F = {
        ...j,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: d.current !== !1
      };
      v.current && !aj(M.current, F) && (M.current = F, rWe.flushSync(() => {
        f(F);
      }));
    });
  }, [h, e, r, N, d]);
  x$(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, f((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [c]);
  const v = P.useRef(!1);
  x$(() => (v.current = !0, () => {
    v.current = !1;
  }), []), x$(() => {
    if (x && (A.current = x), S && (I.current = S), x && S) {
      if (L.current)
        return L.current(x, S, m);
      m();
    }
  }, [x, S, m, L, B]);
  const k = P.useMemo(() => ({
    reference: A,
    floating: I,
    setReference: _,
    setFloating: C
  }), [_, C]), O = P.useMemo(() => ({
    reference: x,
    floating: S
  }), [x, S]), G = P.useMemo(() => {
    const H = {
      position: r,
      left: 0,
      top: 0
    };
    if (!O.floating)
      return H;
    const j = _Te(O.floating, u.x), F = _Te(O.floating, u.y);
    return s ? {
      ...H,
      transform: "translate(" + j + "px, " + F + "px)",
      ...hot(O.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: j,
      top: F
    };
  }, [r, s, O.floating, u.x, u.y]);
  return P.useMemo(() => ({
    ...u,
    update: m,
    refs: k,
    elements: O,
    floatingStyles: G
  }), [u, m, k, O, G]);
}
const q6r = (t) => {
  function e(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(r) {
      const {
        element: n,
        padding: a
      } = typeof t == "function" ? t(r) : t;
      return n && e(n) ? n.current != null ? STe({
        element: n.current,
        padding: a
      }).fn(r) : {} : n ? STe({
        element: n,
        padding: a
      }).fn(r) : {};
    }
  };
}, K6r = (t, e) => ({
  ...j6r(t),
  options: [t, e]
}), Z6r = (t, e) => ({
  ...F6r(t),
  options: [t, e]
}), J6r = (t, e) => ({
  ...H6r(t),
  options: [t, e]
}), Y6r = (t, e) => ({
  ...z6r(t),
  options: [t, e]
}), X6r = (t, e) => ({
  ...G6r(t),
  options: [t, e]
}), Q6r = (t, e) => ({
  ...W6r(t),
  options: [t, e]
}), e4r = (t, e) => ({
  ...q6r(t),
  options: [t, e]
});
var t4r = "Arrow", pot = P.forwardRef((t, e) => {
  const { children: r, width: n = 10, height: a = 5, ...i } = t;
  return /* @__PURE__ */ R.jsx(
    Mo.svg,
    {
      ...i,
      ref: e,
      width: n,
      height: a,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? r : /* @__PURE__ */ R.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
pot.displayName = t4r;
var r4r = pot;
function n4r(t) {
  const [e, r] = P.useState(void 0);
  return T5(() => {
    if (t) {
      r({ width: t.offsetWidth, height: t.offsetHeight });
      const n = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let o, s;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = t.offsetWidth, s = t.offsetHeight;
        r({ width: o, height: s });
      });
      return n.observe(t, { box: "border-box" }), () => n.unobserve(t);
    } else
      r(void 0);
  }, [t]), e;
}
var qge = "Popper", [mot, got] = qy(qge), [a4r, vot] = mot(qge), yot = (t) => {
  const { __scopePopper: e, children: r } = t, [n, a] = P.useState(null);
  return /* @__PURE__ */ R.jsx(a4r, { scope: e, anchor: n, onAnchorChange: a, children: r });
};
yot.displayName = qge;
var bot = "PopperAnchor", xot = P.forwardRef(
  (t, e) => {
    const { __scopePopper: r, virtualRef: n, ...a } = t, i = vot(bot, r), o = P.useRef(null), s = El(e, o);
    return P.useEffect(() => {
      i.onAnchorChange((n == null ? void 0 : n.current) || o.current);
    }), n ? null : /* @__PURE__ */ R.jsx(Mo.div, { ...a, ref: s });
  }
);
xot.displayName = bot;
var Kge = "PopperContent", [i4r, o4r] = mot(Kge), Cot = P.forwardRef(
  (t, e) => {
    var ge, ce, ee, Se, Ce, we;
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: a = 0,
      align: i = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: g,
      ...y
    } = t, b = vot(Kge, r), [w, _] = P.useState(null), C = El(e, (We) => _(We)), [x, S] = P.useState(null), A = n4r(x), I = (A == null ? void 0 : A.width) ?? 0, M = (A == null ? void 0 : A.height) ?? 0, B = n + (i !== "center" ? "-" + i : ""), L = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, N = Array.isArray(c) ? c : [c], d = N.length > 0, m = {
      padding: L,
      boundary: N.filter(l4r),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: d
    }, { refs: v, floatingStyles: k, placement: O, isPositioned: G, middlewareData: H } = V6r({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: B,
      whileElementsMounted: (...We) => L6r(...We, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        K6r({ mainAxis: a + M, alignmentAxis: o }),
        l && Z6r({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? J6r() : void 0,
          ...m
        }),
        l && Y6r({ ...m }),
        X6r({
          ...m,
          apply: ({ elements: We, rects: Fe, availableWidth: it, availableHeight: gt }) => {
            const { width: Ze, height: Ne } = Fe.reference, ze = We.floating.style;
            ze.setProperty("--radix-popper-available-width", `${it}px`), ze.setProperty("--radix-popper-available-height", `${gt}px`), ze.setProperty("--radix-popper-anchor-width", `${Ze}px`), ze.setProperty("--radix-popper-anchor-height", `${Ne}px`);
          }
        }),
        x && e4r({ element: x, padding: s }),
        c4r({ arrowWidth: I, arrowHeight: M }),
        h && Q6r({ strategy: "referenceHidden", ...m })
      ]
    }), [j, F] = _ot(O), z = K1(g);
    T5(() => {
      G && (z == null || z());
    }, [G, z]);
    const W = (ge = H.arrow) == null ? void 0 : ge.x, U = (ce = H.arrow) == null ? void 0 : ce.y, Z = ((ee = H.arrow) == null ? void 0 : ee.centerOffset) !== 0, [V, Y] = P.useState();
    return T5(() => {
      w && Y(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: v.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...k,
          transform: G ? k.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: V,
          "--radix-popper-transform-origin": [
            (Se = H.transformOrigin) == null ? void 0 : Se.x,
            (Ce = H.transformOrigin) == null ? void 0 : Ce.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((we = H.hide) == null ? void 0 : we.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ R.jsx(
          i4r,
          {
            scope: r,
            placedSide: j,
            onArrowChange: S,
            arrowX: W,
            arrowY: U,
            shouldHideArrow: Z,
            children: /* @__PURE__ */ R.jsx(
              Mo.div,
              {
                "data-side": j,
                "data-align": F,
                ...y,
                ref: C,
                style: {
                  ...y.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: G ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Cot.displayName = Kge;
var wot = "PopperArrow", s4r = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Sot = P.forwardRef(function(e, r) {
  const { __scopePopper: n, ...a } = e, i = o4r(wot, n), o = s4r[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ R.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ R.jsx(
          r4r,
          {
            ...a,
            ref: r,
            style: {
              ...a.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Sot.displayName = wot;
function l4r(t) {
  return t !== null;
}
var c4r = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var b, w, _;
    const { placement: r, rects: n, middlewareData: a } = e, o = ((b = a.arrow) == null ? void 0 : b.centerOffset) !== 0, s = o ? 0 : t.arrowWidth, l = o ? 0 : t.arrowHeight, [c, u] = _ot(r), f = { start: "0%", center: "50%", end: "100%" }[u], h = (((w = a.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, p = (((_ = a.arrow) == null ? void 0 : _.y) ?? 0) + l / 2;
    let g = "", y = "";
    return c === "bottom" ? (g = o ? f : `${h}px`, y = `${-l}px`) : c === "top" ? (g = o ? f : `${h}px`, y = `${n.floating.height + l}px`) : c === "right" ? (g = `${-l}px`, y = o ? f : `${p}px`) : c === "left" && (g = `${n.floating.width + l}px`, y = o ? f : `${p}px`), { data: { x: g, y } };
  }
});
function _ot(t) {
  const [e, r = "center"] = t.split("-");
  return [e, r];
}
var u4r = yot, d4r = xot, f4r = Cot, h4r = Sot, p4r = "Portal", TW = P.forwardRef((t, e) => {
  var s;
  const { container: r, ...n } = t, [a, i] = P.useState(!1);
  T5(() => i(!0), []);
  const o = r || a && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return o ? nWe.createPortal(/* @__PURE__ */ R.jsx(Mo.div, { ...n, ref: e }), o) : null;
});
TW.displayName = p4r;
var m4r = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, e9 = /* @__PURE__ */ new WeakMap(), zB = /* @__PURE__ */ new WeakMap(), GB = {}, gee = 0, kot = function(t) {
  return t && (t.host || kot(t.parentNode));
}, g4r = function(t, e) {
  return e.map(function(r) {
    if (t.contains(r))
      return r;
    var n = kot(r);
    return n && t.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, v4r = function(t, e, r, n) {
  var a = g4r(e, Array.isArray(t) ? t : [t]);
  GB[r] || (GB[r] = /* @__PURE__ */ new WeakMap());
  var i = GB[r], o = [], s = /* @__PURE__ */ new Set(), l = new Set(a), c = function(f) {
    !f || s.has(f) || (s.add(f), c(f.parentNode));
  };
  a.forEach(c);
  var u = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(n), g = p !== null && p !== "false", y = (e9.get(h) || 0) + 1, b = (i.get(h) || 0) + 1;
          e9.set(h, y), i.set(h, b), o.push(h), y === 1 && g && zB.set(h, !0), b === 1 && h.setAttribute(r, "true"), g || h.setAttribute(n, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(e), s.clear(), gee++, function() {
    o.forEach(function(f) {
      var h = e9.get(f) - 1, p = i.get(f) - 1;
      e9.set(f, h), i.set(f, p), h || (zB.has(f) || f.removeAttribute(n), zB.delete(f)), p || f.removeAttribute(r);
    }), gee--, gee || (e9 = /* @__PURE__ */ new WeakMap(), e9 = /* @__PURE__ */ new WeakMap(), zB = /* @__PURE__ */ new WeakMap(), GB = {});
  };
}, Zge = function(t, e, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(t) ? t : [t]), a = m4r(t);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), v4r(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, th = function() {
  return th = Object.assign || function(e) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }, th.apply(this, arguments);
};
function Aot(t, e) {
  var r = {};
  for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(t); a < n.length; a++)
      e.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[a]) && (r[n[a]] = t[n[a]]);
  return r;
}
function y4r(t, e, r) {
  if (r || arguments.length === 2) for (var n = 0, a = e.length, i; n < a; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var C$ = "right-scroll-bar-position", w$ = "width-before-scroll-bar", b4r = "with-scroll-bars-hidden", x4r = "--removed-body-scroll-bar-size";
function vee(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function C4r(t, e) {
  var r = Yt(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = e, r.facade;
}
var w4r = typeof window < "u" ? P.useLayoutEffect : P.useEffect, kTe = /* @__PURE__ */ new WeakMap();
function S4r(t, e) {
  var r = C4r(null, function(n) {
    return t.forEach(function(a) {
      return vee(a, n);
    });
  });
  return w4r(function() {
    var n = kTe.get(r);
    if (n) {
      var a = new Set(n), i = new Set(t), o = r.current;
      a.forEach(function(s) {
        i.has(s) || vee(s, null);
      }), i.forEach(function(s) {
        a.has(s) || vee(s, o);
      });
    }
    kTe.set(r, t);
  }, [t]), r;
}
function _4r(t) {
  return t;
}
function k4r(t, e) {
  e === void 0 && (e = _4r);
  var r = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : t;
    },
    useMedium: function(i) {
      var o = e(i, n);
      return r.push(o), function() {
        r = r.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var o = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), o = r;
      }
      var l = function() {
        var u = o;
        o = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), r = {
        push: function(u) {
          o.push(u), c();
        },
        filter: function(u) {
          return o = o.filter(u), r;
        }
      };
    }
  };
  return a;
}
function A4r(t) {
  t === void 0 && (t = {});
  var e = k4r(null);
  return e.options = th({ async: !0, ssr: !1 }, t), e;
}
var Tot = function(t) {
  var e = t.sideCar, r = Aot(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = e.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return P.createElement(n, th({}, r));
};
Tot.isSideCarExport = !0;
function T4r(t, e) {
  return t.useMedium(e), Tot;
}
var Eot = A4r(), yee = function() {
}, EW = P.forwardRef(function(t, e) {
  var r = P.useRef(null), n = P.useState({
    onScrollCapture: yee,
    onWheelCapture: yee,
    onTouchMoveCapture: yee
  }), a = n[0], i = n[1], o = t.forwardProps, s = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, f = t.shards, h = t.sideCar, p = t.noIsolation, g = t.inert, y = t.allowPinchZoom, b = t.as, w = b === void 0 ? "div" : b, _ = t.gapMode, C = Aot(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = h, S = S4r([r, e]), A = th(th({}, C), a);
  return P.createElement(
    P.Fragment,
    null,
    u && P.createElement(x, { sideCar: Eot, removeScrollBar: c, shards: f, noIsolation: p, inert: g, setCallbacks: i, allowPinchZoom: !!y, lockRef: r, gapMode: _ }),
    o ? P.cloneElement(P.Children.only(s), th(th({}, A), { ref: S })) : P.createElement(w, th({}, A, { className: l, ref: S }), s)
  );
});
EW.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
EW.classNames = {
  fullWidth: w$,
  zeroRight: C$
};
var E4r = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function I4r() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = E4r();
  return e && t.setAttribute("nonce", e), t;
}
function M4r(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function P4r(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var R4r = function() {
  var t = 0, e = null;
  return {
    add: function(r) {
      t == 0 && (e = I4r()) && (M4r(e, r), P4r(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, O4r = function() {
  var t = R4r();
  return function(e, r) {
    P.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && r]);
  };
}, Iot = function() {
  var t = O4r(), e = function(r) {
    var n = r.styles, a = r.dynamic;
    return t(n, a), null;
  };
  return e;
}, B4r = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, bee = function(t) {
  return parseInt(t || "", 10) || 0;
}, N4r = function(t) {
  var e = window.getComputedStyle(document.body), r = e[t === "padding" ? "paddingLeft" : "marginLeft"], n = e[t === "padding" ? "paddingTop" : "marginTop"], a = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [bee(r), bee(n), bee(a)];
}, $4r = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return B4r;
  var e = N4r(t), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, n - r + e[2] - e[0])
  };
}, D4r = Iot(), _7 = "data-scroll-locked", L4r = function(t, e, r, n) {
  var a = t.left, i = t.top, o = t.right, s = t.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(b4r, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(_7, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(C$, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(w$, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(C$, " .").concat(C$, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(w$, " .").concat(w$, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(_7, `] {
    `).concat(x4r, ": ").concat(s, `px;
  }
`);
}, ATe = function() {
  var t = parseInt(document.body.getAttribute(_7) || "0", 10);
  return isFinite(t) ? t : 0;
}, j4r = function() {
  P.useEffect(function() {
    return document.body.setAttribute(_7, (ATe() + 1).toString()), function() {
      var t = ATe() - 1;
      t <= 0 ? document.body.removeAttribute(_7) : document.body.setAttribute(_7, t.toString());
    };
  }, []);
}, F4r = function(t) {
  var e = t.noRelative, r = t.noImportant, n = t.gapMode, a = n === void 0 ? "margin" : n;
  j4r();
  var i = P.useMemo(function() {
    return $4r(a);
  }, [a]);
  return P.createElement(D4r, { styles: L4r(i, !e, a, r ? "" : "!important") });
}, ude = !1;
if (typeof window < "u")
  try {
    var WB = Object.defineProperty({}, "passive", {
      get: function() {
        return ude = !0, !0;
      }
    });
    window.addEventListener("test", WB, WB), window.removeEventListener("test", WB, WB);
  } catch {
    ude = !1;
  }
var t9 = ude ? { passive: !1 } : !1, z4r = function(t) {
  return t.tagName === "TEXTAREA";
}, Mot = function(t, e) {
  if (!(t instanceof Element))
    return !1;
  var r = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    r[e] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !z4r(t) && r[e] === "visible")
  );
}, G4r = function(t) {
  return Mot(t, "overflowY");
}, W4r = function(t) {
  return Mot(t, "overflowX");
}, TTe = function(t, e) {
  var r = e.ownerDocument, n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = Pot(t, n);
    if (a) {
      var i = Rot(t, n), o = i[1], s = i[2];
      if (o > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, H4r = function(t) {
  var e = t.scrollTop, r = t.scrollHeight, n = t.clientHeight;
  return [
    e,
    r,
    n
  ];
}, U4r = function(t) {
  var e = t.scrollLeft, r = t.scrollWidth, n = t.clientWidth;
  return [
    e,
    r,
    n
  ];
}, Pot = function(t, e) {
  return t === "v" ? G4r(e) : W4r(e);
}, Rot = function(t, e) {
  return t === "v" ? H4r(e) : U4r(e);
}, V4r = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, q4r = function(t, e, r, n, a) {
  var i = V4r(t, window.getComputedStyle(e).direction), o = i * n, s = r.target, l = e.contains(s), c = !1, u = o > 0, f = 0, h = 0;
  do {
    var p = Rot(t, s), g = p[0], y = p[1], b = p[2], w = y - b - i * g;
    (g || w) && Pot(t, s) && (f += w, h += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (e.contains(s) || e === s)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, HB = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, ETe = function(t) {
  return [t.deltaX, t.deltaY];
}, ITe = function(t) {
  return t && "current" in t ? t.current : t;
}, K4r = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, Z4r = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, J4r = 0, r9 = [];
function Y4r(t) {
  var e = P.useRef([]), r = P.useRef([0, 0]), n = P.useRef(), a = P.useState(J4r++)[0], i = P.useState(Iot)[0], o = P.useRef(t);
  P.useEffect(function() {
    o.current = t;
  }, [t]), P.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var y = y4r([t.lockRef.current], (t.shards || []).map(ITe), !0).filter(Boolean);
      return y.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), y.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var s = P.useCallback(function(y, b) {
    if ("touches" in y && y.touches.length === 2 || y.type === "wheel" && y.ctrlKey)
      return !o.current.allowPinchZoom;
    var w = HB(y), _ = r.current, C = "deltaX" in y ? y.deltaX : _[0] - w[0], x = "deltaY" in y ? y.deltaY : _[1] - w[1], S, A = y.target, I = Math.abs(C) > Math.abs(x) ? "h" : "v";
    if ("touches" in y && I === "h" && A.type === "range")
      return !1;
    var M = TTe(I, A);
    if (!M)
      return !0;
    if (M ? S = I : (S = I === "v" ? "h" : "v", M = TTe(I, A)), !M)
      return !1;
    if (!n.current && "changedTouches" in y && (C || x) && (n.current = S), !S)
      return !0;
    var B = n.current || S;
    return q4r(B, b, y, B === "h" ? C : x);
  }, []), l = P.useCallback(function(y) {
    var b = y;
    if (!(!r9.length || r9[r9.length - 1] !== i)) {
      var w = "deltaY" in b ? ETe(b) : HB(b), _ = e.current.filter(function(S) {
        return S.name === b.type && (S.target === b.target || b.target === S.shadowParent) && K4r(S.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var C = (o.current.shards || []).map(ITe).filter(Boolean).filter(function(S) {
          return S.contains(b.target);
        }), x = C.length > 0 ? s(b, C[0]) : !o.current.noIsolation;
        x && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = P.useCallback(function(y, b, w, _) {
    var C = { name: y, delta: b, target: w, should: _, shadowParent: X4r(w) };
    e.current.push(C), setTimeout(function() {
      e.current = e.current.filter(function(x) {
        return x !== C;
      });
    }, 1);
  }, []), u = P.useCallback(function(y) {
    r.current = HB(y), n.current = void 0;
  }, []), f = P.useCallback(function(y) {
    c(y.type, ETe(y), y.target, s(y, t.lockRef.current));
  }, []), h = P.useCallback(function(y) {
    c(y.type, HB(y), y.target, s(y, t.lockRef.current));
  }, []);
  P.useEffect(function() {
    return r9.push(i), t.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, t9), document.addEventListener("touchmove", l, t9), document.addEventListener("touchstart", u, t9), function() {
      r9 = r9.filter(function(y) {
        return y !== i;
      }), document.removeEventListener("wheel", l, t9), document.removeEventListener("touchmove", l, t9), document.removeEventListener("touchstart", u, t9);
    };
  }, []);
  var p = t.removeScrollBar, g = t.inert;
  return P.createElement(
    P.Fragment,
    null,
    g ? P.createElement(i, { styles: Z4r(a) }) : null,
    p ? P.createElement(F4r, { gapMode: t.gapMode }) : null
  );
}
function X4r(t) {
  for (var e = null; t !== null; )
    t instanceof ShadowRoot && (e = t.host, t = t.host), t = t.parentNode;
  return e;
}
const Q4r = T4r(Eot, Y4r);
var IW = P.forwardRef(function(t, e) {
  return P.createElement(EW, th({}, t, { ref: e, sideCar: Q4r }));
});
IW.classNames = EW.classNames;
var dde = ["Enter", " "], e9r = ["ArrowDown", "PageUp", "Home"], Oot = ["ArrowUp", "PageDown", "End"], t9r = [...e9r, ...Oot], r9r = {
  ltr: [...dde, "ArrowRight"],
  rtl: [...dde, "ArrowLeft"]
}, n9r = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, QM = "Menu", [pE, a9r, i9r] = kit(QM), [m6, Bot] = qy(QM, [
  i9r,
  got,
  CW
]), MW = got(), Not = CW(), [o9r, g6] = m6(QM), [s9r, eP] = m6(QM), $ot = (t) => {
  const { __scopeMenu: e, open: r = !1, children: n, dir: a, onOpenChange: i, modal: o = !0 } = t, s = MW(e), [l, c] = P.useState(null), u = P.useRef(!1), f = K1(i), h = Nge(a);
  return P.useEffect(() => {
    const p = () => {
      u.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", p, { capture: !0 }), () => {
      document.removeEventListener("keydown", p, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ R.jsx(u4r, { ...s, children: /* @__PURE__ */ R.jsx(
    o9r,
    {
      scope: e,
      open: r,
      onOpenChange: f,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ R.jsx(
        s9r,
        {
          scope: e,
          onClose: P.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: h,
          modal: o,
          children: n
        }
      )
    }
  ) });
};
$ot.displayName = QM;
var l9r = "MenuAnchor", Jge = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t, a = MW(r);
    return /* @__PURE__ */ R.jsx(d4r, { ...a, ...n, ref: e });
  }
);
Jge.displayName = l9r;
var Yge = "MenuPortal", [c9r, Dot] = m6(Yge, {
  forceMount: void 0
}), Lot = (t) => {
  const { __scopeMenu: e, forceMount: r, children: n, container: a } = t, i = g6(Yge, e);
  return /* @__PURE__ */ R.jsx(c9r, { scope: e, forceMount: r, children: /* @__PURE__ */ R.jsx(kf, { present: r || i.open, children: /* @__PURE__ */ R.jsx(TW, { asChild: !0, container: a, children: n }) }) });
};
Lot.displayName = Yge;
var tf = "MenuContent", [u9r, Xge] = m6(tf), jot = P.forwardRef(
  (t, e) => {
    const r = Dot(tf, t.__scopeMenu), { forceMount: n = r.forceMount, ...a } = t, i = g6(tf, t.__scopeMenu), o = eP(tf, t.__scopeMenu);
    return /* @__PURE__ */ R.jsx(pE.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: /* @__PURE__ */ R.jsx(pE.Slot, { scope: t.__scopeMenu, children: o.modal ? /* @__PURE__ */ R.jsx(d9r, { ...a, ref: e }) : /* @__PURE__ */ R.jsx(f9r, { ...a, ref: e }) }) }) });
  }
), d9r = P.forwardRef(
  (t, e) => {
    const r = g6(tf, t.__scopeMenu), n = P.useRef(null), a = El(e, n);
    return P.useEffect(() => {
      const i = n.current;
      if (i) return Zge(i);
    }, []), /* @__PURE__ */ R.jsx(
      Qge,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: Oa(
          t.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), f9r = P.forwardRef((t, e) => {
  const r = g6(tf, t.__scopeMenu);
  return /* @__PURE__ */ R.jsx(
    Qge,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), Qge = P.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: a,
      onOpenAutoFocus: i,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: h,
      onDismiss: p,
      disableOutsideScroll: g,
      ...y
    } = t, b = g6(tf, r), w = eP(tf, r), _ = MW(r), C = Not(r), x = a9r(r), [S, A] = P.useState(null), I = P.useRef(null), M = El(e, I, b.onContentChange), B = P.useRef(0), L = P.useRef(""), N = P.useRef(0), d = P.useRef(null), m = P.useRef("right"), v = P.useRef(0), k = g ? IW : P.Fragment, O = g ? { as: dE, allowPinchZoom: !0 } : void 0, G = (j) => {
      var ge, ce;
      const F = L.current + j, z = x().filter((ee) => !ee.disabled), W = document.activeElement, U = (ge = z.find((ee) => ee.ref.current === W)) == null ? void 0 : ge.textValue, Z = z.map((ee) => ee.textValue), V = _9r(Z, F, U), Y = (ce = z.find((ee) => ee.textValue === V)) == null ? void 0 : ce.ref.current;
      (function ee(Se) {
        L.current = Se, window.clearTimeout(B.current), Se !== "" && (B.current = window.setTimeout(() => ee(""), 1e3));
      })(F), Y && setTimeout(() => Y.focus());
    };
    P.useEffect(() => () => window.clearTimeout(B.current), []), jge();
    const H = P.useCallback((j) => {
      var z, W;
      return m.current === ((z = d.current) == null ? void 0 : z.side) && A9r(j, (W = d.current) == null ? void 0 : W.area);
    }, []);
    return /* @__PURE__ */ R.jsx(
      u9r,
      {
        scope: r,
        searchRef: L,
        onItemEnter: P.useCallback(
          (j) => {
            H(j) && j.preventDefault();
          },
          [H]
        ),
        onItemLeave: P.useCallback(
          (j) => {
            var F;
            H(j) || ((F = I.current) == null || F.focus(), A(null));
          },
          [H]
        ),
        onTriggerLeave: P.useCallback(
          (j) => {
            H(j) && j.preventDefault();
          },
          [H]
        ),
        pointerGraceTimerRef: N,
        onPointerGraceIntentChange: P.useCallback((j) => {
          d.current = j;
        }, []),
        children: /* @__PURE__ */ R.jsx(k, { ...O, children: /* @__PURE__ */ R.jsx(
          SW,
          {
            asChild: !0,
            trapped: a,
            onMountAutoFocus: Oa(i, (j) => {
              var F;
              j.preventDefault(), (F = I.current) == null || F.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ R.jsx(
              wW,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: h,
                onDismiss: p,
                children: /* @__PURE__ */ R.jsx(
                  Rit,
                  {
                    asChild: !0,
                    ...C,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: Oa(l, (j) => {
                      w.isUsingKeyboardRef.current || j.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ R.jsx(
                      f4r,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": tst(b.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ..._,
                        ...y,
                        ref: M,
                        style: { outline: "none", ...y.style },
                        onKeyDown: Oa(y.onKeyDown, (j) => {
                          const z = j.target.closest("[data-radix-menu-content]") === j.currentTarget, W = j.ctrlKey || j.altKey || j.metaKey, U = j.key.length === 1;
                          z && (j.key === "Tab" && j.preventDefault(), !W && U && G(j.key));
                          const Z = I.current;
                          if (j.target !== Z || !t9r.includes(j.key)) return;
                          j.preventDefault();
                          const Y = x().filter((ge) => !ge.disabled).map((ge) => ge.ref.current);
                          Oot.includes(j.key) && Y.reverse(), w9r(Y);
                        }),
                        onBlur: Oa(t.onBlur, (j) => {
                          j.currentTarget.contains(j.target) || (window.clearTimeout(B.current), L.current = "");
                        }),
                        onPointerMove: Oa(
                          t.onPointerMove,
                          mE((j) => {
                            const F = j.target, z = v.current !== j.clientX;
                            if (j.currentTarget.contains(F) && z) {
                              const W = j.clientX > v.current ? "right" : "left";
                              m.current = W, v.current = j.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
jot.displayName = tf;
var h9r = "MenuGroup", eve = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ R.jsx(Mo.div, { role: "group", ...n, ref: e });
  }
);
eve.displayName = h9r;
var p9r = "MenuLabel", Fot = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ R.jsx(Mo.div, { ...n, ref: e });
  }
);
Fot.displayName = p9r;
var ij = "MenuItem", MTe = "menu.itemSelect", PW = P.forwardRef(
  (t, e) => {
    const { disabled: r = !1, onSelect: n, ...a } = t, i = P.useRef(null), o = eP(ij, t.__scopeMenu), s = Xge(ij, t.__scopeMenu), l = El(e, i), c = P.useRef(!1), u = () => {
      const f = i.current;
      if (!r && f) {
        const h = new CustomEvent(MTe, { bubbles: !0, cancelable: !0 });
        f.addEventListener(MTe, (p) => n == null ? void 0 : n(p), { once: !0 }), Ait(f, h), h.defaultPrevented ? c.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ R.jsx(
      zot,
      {
        ...a,
        ref: l,
        disabled: r,
        onClick: Oa(t.onClick, u),
        onPointerDown: (f) => {
          var h;
          (h = t.onPointerDown) == null || h.call(t, f), c.current = !0;
        },
        onPointerUp: Oa(t.onPointerUp, (f) => {
          var h;
          c.current || (h = f.currentTarget) == null || h.click();
        }),
        onKeyDown: Oa(t.onKeyDown, (f) => {
          const h = s.searchRef.current !== "";
          r || h && f.key === " " || dde.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
PW.displayName = ij;
var zot = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: a, ...i } = t, o = Xge(ij, r), s = Not(r), l = P.useRef(null), c = El(e, l), [u, f] = P.useState(!1), [h, p] = P.useState("");
    return P.useEffect(() => {
      const g = l.current;
      g && p((g.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ R.jsx(
      pE.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: a ?? h,
        children: /* @__PURE__ */ R.jsx(Oit, { asChild: !0, ...s, focusable: !n, children: /* @__PURE__ */ R.jsx(
          Mo.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...i,
            ref: c,
            onPointerMove: Oa(
              t.onPointerMove,
              mE((g) => {
                n ? o.onItemLeave(g) : (o.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Oa(
              t.onPointerLeave,
              mE((g) => o.onItemLeave(g))
            ),
            onFocus: Oa(t.onFocus, () => f(!0)),
            onBlur: Oa(t.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), m9r = "MenuCheckboxItem", Got = P.forwardRef(
  (t, e) => {
    const { checked: r = !1, onCheckedChange: n, ...a } = t;
    return /* @__PURE__ */ R.jsx(qot, { scope: t.__scopeMenu, checked: r, children: /* @__PURE__ */ R.jsx(
      PW,
      {
        role: "menuitemcheckbox",
        "aria-checked": oj(r) ? "mixed" : r,
        ...a,
        ref: e,
        "data-state": rve(r),
        onSelect: Oa(
          a.onSelect,
          () => n == null ? void 0 : n(oj(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Got.displayName = m9r;
var Wot = "MenuRadioGroup", [g9r, v9r] = m6(
  Wot,
  { value: void 0, onValueChange: () => {
  } }
), Hot = P.forwardRef(
  (t, e) => {
    const { value: r, onValueChange: n, ...a } = t, i = K1(n);
    return /* @__PURE__ */ R.jsx(g9r, { scope: t.__scopeMenu, value: r, onValueChange: i, children: /* @__PURE__ */ R.jsx(eve, { ...a, ref: e }) });
  }
);
Hot.displayName = Wot;
var Uot = "MenuRadioItem", Vot = P.forwardRef(
  (t, e) => {
    const { value: r, ...n } = t, a = v9r(Uot, t.__scopeMenu), i = r === a.value;
    return /* @__PURE__ */ R.jsx(qot, { scope: t.__scopeMenu, checked: i, children: /* @__PURE__ */ R.jsx(
      PW,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...n,
        ref: e,
        "data-state": rve(i),
        onSelect: Oa(
          n.onSelect,
          () => {
            var o;
            return (o = a.onValueChange) == null ? void 0 : o.call(a, r);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Vot.displayName = Uot;
var tve = "MenuItemIndicator", [qot, y9r] = m6(
  tve,
  { checked: !1 }
), Kot = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, forceMount: n, ...a } = t, i = y9r(tve, r);
    return /* @__PURE__ */ R.jsx(
      kf,
      {
        present: n || oj(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ R.jsx(
          Mo.span,
          {
            ...a,
            ref: e,
            "data-state": rve(i.checked)
          }
        )
      }
    );
  }
);
Kot.displayName = tve;
var b9r = "MenuSeparator", Zot = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t;
    return /* @__PURE__ */ R.jsx(
      Mo.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: e
      }
    );
  }
);
Zot.displayName = b9r;
var x9r = "MenuArrow", Jot = P.forwardRef(
  (t, e) => {
    const { __scopeMenu: r, ...n } = t, a = MW(r);
    return /* @__PURE__ */ R.jsx(h4r, { ...a, ...n, ref: e });
  }
);
Jot.displayName = x9r;
var C9r = "MenuSub", [F3n, Yot] = m6(C9r), a_ = "MenuSubTrigger", Xot = P.forwardRef(
  (t, e) => {
    const r = g6(a_, t.__scopeMenu), n = eP(a_, t.__scopeMenu), a = Yot(a_, t.__scopeMenu), i = Xge(a_, t.__scopeMenu), o = P.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = i, c = { __scopeMenu: t.__scopeMenu }, u = P.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return P.useEffect(() => u, [u]), P.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [s, l]), /* @__PURE__ */ R.jsx(Jge, { asChild: !0, ...c, children: /* @__PURE__ */ R.jsx(
      zot,
      {
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": a.contentId,
        "data-state": tst(r.open),
        ...t,
        ref: K8(e, a.onTriggerChange),
        onClick: (f) => {
          var h;
          (h = t.onClick) == null || h.call(t, f), !(t.disabled || f.defaultPrevented) && (f.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: Oa(
          t.onPointerMove,
          mE((f) => {
            i.onItemEnter(f), !f.defaultPrevented && !t.disabled && !r.open && !o.current && (i.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              r.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Oa(
          t.onPointerLeave,
          mE((f) => {
            var p, g;
            u();
            const h = (p = r.content) == null ? void 0 : p.getBoundingClientRect();
            if (h) {
              const y = (g = r.content) == null ? void 0 : g.dataset.side, b = y === "right", w = b ? -5 : 5, _ = h[b ? "left" : "right"], C = h[b ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + w, y: f.clientY },
                  { x: _, y: h.top },
                  { x: C, y: h.top },
                  { x: C, y: h.bottom },
                  { x: _, y: h.bottom }
                ],
                side: y
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(f), f.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Oa(t.onKeyDown, (f) => {
          var p;
          const h = i.searchRef.current !== "";
          t.disabled || h && f.key === " " || r9r[n.dir].includes(f.key) && (r.onOpenChange(!0), (p = r.content) == null || p.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Xot.displayName = a_;
var Qot = "MenuSubContent", est = P.forwardRef(
  (t, e) => {
    const r = Dot(tf, t.__scopeMenu), { forceMount: n = r.forceMount, ...a } = t, i = g6(tf, t.__scopeMenu), o = eP(tf, t.__scopeMenu), s = Yot(Qot, t.__scopeMenu), l = P.useRef(null), c = El(e, l);
    return /* @__PURE__ */ R.jsx(pE.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: /* @__PURE__ */ R.jsx(pE.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ R.jsx(
      Qge,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...a,
        ref: c,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          o.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Oa(t.onFocusOutside, (u) => {
          u.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: Oa(t.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: Oa(t.onKeyDown, (u) => {
          var p;
          const f = u.currentTarget.contains(u.target), h = n9r[o.dir].includes(u.key);
          f && h && (i.onOpenChange(!1), (p = s.trigger) == null || p.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
est.displayName = Qot;
function tst(t) {
  return t ? "open" : "closed";
}
function oj(t) {
  return t === "indeterminate";
}
function rve(t) {
  return oj(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function w9r(t) {
  const e = document.activeElement;
  for (const r of t)
    if (r === e || (r.focus(), document.activeElement !== e)) return;
}
function S9r(t, e) {
  return t.map((r, n) => t[(e + n) % t.length]);
}
function _9r(t, e, r) {
  const a = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, i = r ? t.indexOf(r) : -1;
  let o = S9r(t, Math.max(i, 0));
  a.length === 1 && (o = o.filter((c) => c !== r));
  const l = o.find(
    (c) => c.toLowerCase().startsWith(a.toLowerCase())
  );
  return l !== r ? l : void 0;
}
function k9r(t, e) {
  const { x: r, y: n } = t;
  let a = !1;
  for (let i = 0, o = e.length - 1; i < e.length; o = i++) {
    const s = e[i].x, l = e[i].y, c = e[o].x, u = e[o].y;
    l > n != u > n && r < (c - s) * (n - l) / (u - l) + s && (a = !a);
  }
  return a;
}
function A9r(t, e) {
  if (!e) return !1;
  const r = { x: t.clientX, y: t.clientY };
  return k9r(r, e);
}
function mE(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var T9r = $ot, E9r = Jge, I9r = Lot, M9r = jot, P9r = eve, R9r = Fot, O9r = PW, B9r = Got, N9r = Hot, $9r = Vot, D9r = Kot, L9r = Zot, j9r = Jot, F9r = Xot, z9r = est, nve = "DropdownMenu", [G9r, z3n] = qy(
  nve,
  [Bot]
), Wu = Bot(), [W9r, rst] = G9r(nve), nst = (t) => {
  const {
    __scopeDropdownMenu: e,
    children: r,
    dir: n,
    open: a,
    defaultOpen: i,
    onOpenChange: o,
    modal: s = !0
  } = t, l = Wu(e), c = P.useRef(null), [u = !1, f] = Z8({
    prop: a,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ R.jsx(
    W9r,
    {
      scope: e,
      triggerId: bh(),
      triggerRef: c,
      contentId: bh(),
      open: u,
      onOpenChange: f,
      onOpenToggle: P.useCallback(() => f((h) => !h), [f]),
      modal: s,
      children: /* @__PURE__ */ R.jsx(T9r, { ...l, open: u, onOpenChange: f, dir: n, modal: s, children: r })
    }
  );
};
nst.displayName = nve;
var ast = "DropdownMenuTrigger", ist = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...a } = t, i = rst(ast, r), o = Wu(r);
    return /* @__PURE__ */ R.jsx(E9r, { asChild: !0, ...o, children: /* @__PURE__ */ R.jsx(
      Mo.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...a,
        ref: K8(e, i.triggerRef),
        onPointerDown: Oa(t.onPointerDown, (s) => {
          !n && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: Oa(t.onKeyDown, (s) => {
          n || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
ist.displayName = ast;
var H9r = "DropdownMenuPortal", ost = (t) => {
  const { __scopeDropdownMenu: e, ...r } = t, n = Wu(e);
  return /* @__PURE__ */ R.jsx(I9r, { ...n, ...r });
};
ost.displayName = H9r;
var sst = "DropdownMenuContent", lst = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, ...n } = t, a = rst(sst, r), i = Wu(r), o = P.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      M9r,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ...n,
        ref: e,
        onCloseAutoFocus: Oa(t.onCloseAutoFocus, (s) => {
          var l;
          o.current || (l = a.triggerRef.current) == null || l.focus(), o.current = !1, s.preventDefault();
        }),
        onInteractOutside: Oa(t.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!a.modal || u) && (o.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
lst.displayName = sst;
var U9r = "DropdownMenuGroup", cst = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
    return /* @__PURE__ */ R.jsx(P9r, { ...a, ...n, ref: e });
  }
);
cst.displayName = U9r;
var V9r = "DropdownMenuLabel", ust = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
    return /* @__PURE__ */ R.jsx(R9r, { ...a, ...n, ref: e });
  }
);
ust.displayName = V9r;
var q9r = "DropdownMenuItem", dst = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
    return /* @__PURE__ */ R.jsx(O9r, { ...a, ...n, ref: e });
  }
);
dst.displayName = q9r;
var K9r = "DropdownMenuCheckboxItem", fst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(B9r, { ...a, ...n, ref: e });
});
fst.displayName = K9r;
var Z9r = "DropdownMenuRadioGroup", J9r = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(N9r, { ...a, ...n, ref: e });
});
J9r.displayName = Z9r;
var Y9r = "DropdownMenuRadioItem", hst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx($9r, { ...a, ...n, ref: e });
});
hst.displayName = Y9r;
var X9r = "DropdownMenuItemIndicator", pst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(D9r, { ...a, ...n, ref: e });
});
pst.displayName = X9r;
var Q9r = "DropdownMenuSeparator", mst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(L9r, { ...a, ...n, ref: e });
});
mst.displayName = Q9r;
var e7r = "DropdownMenuArrow", t7r = P.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
    return /* @__PURE__ */ R.jsx(j9r, { ...a, ...n, ref: e });
  }
);
t7r.displayName = e7r;
var r7r = "DropdownMenuSubTrigger", gst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(F9r, { ...a, ...n, ref: e });
});
gst.displayName = r7r;
var n7r = "DropdownMenuSubContent", vst = P.forwardRef((t, e) => {
  const { __scopeDropdownMenu: r, ...n } = t, a = Wu(r);
  return /* @__PURE__ */ R.jsx(
    z9r,
    {
      ...a,
      ...n,
      ref: e,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
vst.displayName = n7r;
var a7r = nst, i7r = ist, o7r = ost, yst = lst, s7r = cst, bst = ust, xst = dst, Cst = fst, wst = hst, Sst = pst, _st = mst, kst = gst, Ast = vst;
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l7r = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Tst = (...t) => t.filter((e, r, n) => !!e && e.trim() !== "" && n.indexOf(e) === r).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var c7r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u7r = Ml(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: a = "",
    children: i,
    iconNode: o,
    ...s
  }, l) => Ds(
    "svg",
    {
      ref: l,
      ...c7r,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: n ? Number(r) * 24 / Number(e) : r,
      className: Tst("lucide", a),
      ...s
    },
    [
      ...o.map(([c, u]) => Ds(c, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RW = (t, e) => {
  const r = Ml(
    ({ className: n, ...a }, i) => Ds(u7r, {
      ref: i,
      iconNode: e,
      className: Tst(`lucide-${l7r(t)}`, n),
      ...a
    })
  );
  return r.displayName = `${t}`, r;
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const d7r = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], f7r = RW("Check", d7r);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const h7r = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], p7r = RW("ChevronRight", h7r);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m7r = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], g7r = RW("Circle", m7r);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v7r = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], y7r = RW("X", v7r), b7r = a7r, x7r = i7r, PTe = s7r, C7r = P.forwardRef(({ className: t, inset: e, children: r, ...n }, a) => /* @__PURE__ */ R.jsxs(
  kst,
  {
    ref: a,
    className: Tc(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      e && "pl-8",
      t
    ),
    ...n,
    children: [
      r,
      /* @__PURE__ */ R.jsx(p7r, { className: "ml-auto" })
    ]
  }
));
C7r.displayName = kst.displayName;
const w7r = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Ast,
  {
    ref: r,
    className: Tc(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...e
  }
));
w7r.displayName = Ast.displayName;
const Est = P.forwardRef(({ className: t, sideOffset: e = 4, ...r }, n) => /* @__PURE__ */ R.jsx(o7r, { children: /* @__PURE__ */ R.jsx(
  yst,
  {
    ref: n,
    sideOffset: e,
    className: Tc(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...r
  }
) }));
Est.displayName = yst.displayName;
const fde = P.forwardRef(({ className: t, inset: e, ...r }, n) => /* @__PURE__ */ R.jsx(
  xst,
  {
    ref: n,
    className: Tc(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&>svg]:size-4 [&>svg]:shrink-0",
      e && "pl-8",
      t
    ),
    ...r
  }
));
fde.displayName = xst.displayName;
const S7r = P.forwardRef(({ className: t, children: e, checked: r, ...n }, a) => /* @__PURE__ */ R.jsxs(
  Cst,
  {
    ref: a,
    className: Tc(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: r,
    ...n,
    children: [
      /* @__PURE__ */ R.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ R.jsx(Sst, { children: /* @__PURE__ */ R.jsx(f7r, { className: "h-4 w-4" }) }) }),
      e
    ]
  }
));
S7r.displayName = Cst.displayName;
const _7r = P.forwardRef(({ className: t, children: e, ...r }, n) => /* @__PURE__ */ R.jsxs(
  wst,
  {
    ref: n,
    className: Tc(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...r,
    children: [
      /* @__PURE__ */ R.jsx("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ R.jsx(Sst, { children: /* @__PURE__ */ R.jsx(g7r, { className: "h-2 w-2 fill-current" }) }) }),
      e
    ]
  }
));
_7r.displayName = wst.displayName;
const k7r = P.forwardRef(({ className: t, inset: e, ...r }, n) => /* @__PURE__ */ R.jsx(
  bst,
  {
    ref: n,
    className: Tc(
      "px-2 py-1.5 text-sm font-semibold",
      e && "pl-8",
      t
    ),
    ...r
  }
));
k7r.displayName = bst.displayName;
const Ist = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  _st,
  {
    ref: r,
    className: Tc("-mx-1 my-1 h-px bg-muted", t),
    ...e
  }
));
Ist.displayName = _st.displayName;
var ave = P.forwardRef((t, e) => {
  const { children: r, ...n } = t, a = P.Children.toArray(r), i = a.find(T7r);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? P.Children.count(o) > 1 ? P.Children.only(null) : P.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ R.jsx(hde, { ...n, ref: e, children: P.isValidElement(o) ? P.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(hde, { ...n, ref: e, children: r });
});
ave.displayName = "Slot";
var hde = P.forwardRef((t, e) => {
  const { children: r, ...n } = t;
  if (P.isValidElement(r)) {
    const a = I7r(r), i = E7r(n, r.props);
    return r.type !== P.Fragment && (i.ref = e ? K8(e, a) : a), P.cloneElement(r, i);
  }
  return P.Children.count(r) > 1 ? P.Children.only(null) : null;
});
hde.displayName = "SlotClone";
var A7r = ({ children: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
function T7r(t) {
  return P.isValidElement(t) && t.type === A7r;
}
function E7r(t, e) {
  const r = { ...e };
  for (const n in e) {
    const a = t[n], i = e[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...t, ...r };
}
function I7r(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var ive = "Dialog", [Mst, G3n] = qy(ive), [M7r, f2] = Mst(ive), Pst = (t) => {
  const {
    __scopeDialog: e,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: i,
    modal: o = !0
  } = t, s = P.useRef(null), l = P.useRef(null), [c = !1, u] = Z8({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ R.jsx(
    M7r,
    {
      scope: e,
      triggerRef: s,
      contentRef: l,
      contentId: bh(),
      titleId: bh(),
      descriptionId: bh(),
      open: c,
      onOpenChange: u,
      onOpenToggle: P.useCallback(() => u((f) => !f), [u]),
      modal: o,
      children: r
    }
  );
};
Pst.displayName = ive;
var Rst = "DialogTrigger", Ost = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = f2(Rst, r), i = El(e, a.triggerRef);
    return /* @__PURE__ */ R.jsx(
      Mo.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": lve(a.open),
        ...n,
        ref: i,
        onClick: Oa(t.onClick, a.onOpenToggle)
      }
    );
  }
);
Ost.displayName = Rst;
var ove = "DialogPortal", [P7r, Bst] = Mst(ove, {
  forceMount: void 0
}), Nst = (t) => {
  const { __scopeDialog: e, forceMount: r, children: n, container: a } = t, i = f2(ove, e);
  return /* @__PURE__ */ R.jsx(P7r, { scope: e, forceMount: r, children: P.Children.map(n, (o) => /* @__PURE__ */ R.jsx(kf, { present: r || i.open, children: /* @__PURE__ */ R.jsx(TW, { asChild: !0, container: a, children: o }) })) });
};
Nst.displayName = ove;
var sj = "DialogOverlay", $st = P.forwardRef(
  (t, e) => {
    const r = Bst(sj, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, i = f2(sj, t.__scopeDialog);
    return i.modal ? /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: /* @__PURE__ */ R.jsx(R7r, { ...a, ref: e }) }) : null;
  }
);
$st.displayName = sj;
var R7r = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = f2(sj, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ R.jsx(IW, { as: ave, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ R.jsx(
        Mo.div,
        {
          "data-state": lve(a.open),
          ...n,
          ref: e,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), I5 = "DialogContent", Dst = P.forwardRef(
  (t, e) => {
    const r = Bst(I5, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, i = f2(I5, t.__scopeDialog);
    return /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: i.modal ? /* @__PURE__ */ R.jsx(O7r, { ...a, ref: e }) : /* @__PURE__ */ R.jsx(B7r, { ...a, ref: e }) });
  }
);
Dst.displayName = I5;
var O7r = P.forwardRef(
  (t, e) => {
    const r = f2(I5, t.__scopeDialog), n = P.useRef(null), a = El(e, r.contentRef, n);
    return P.useEffect(() => {
      const i = n.current;
      if (i) return Zge(i);
    }, []), /* @__PURE__ */ R.jsx(
      Lst,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oa(t.onCloseAutoFocus, (i) => {
          var o;
          i.preventDefault(), (o = r.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Oa(t.onPointerDownOutside, (i) => {
          const o = i.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Oa(
          t.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), B7r = P.forwardRef(
  (t, e) => {
    const r = f2(I5, t.__scopeDialog), n = P.useRef(!1), a = P.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      Lst,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var o, s;
          (o = t.onCloseAutoFocus) == null || o.call(t, i), i.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), i.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const o = i.target;
          ((c = r.triggerRef.current) == null ? void 0 : c.contains(o)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), Lst = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, ...o } = t, s = f2(I5, r), l = P.useRef(null), c = El(e, l);
    return jge(), /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        SW,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ R.jsx(
            wW,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": lve(s.open),
              ...o,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(N7r, { titleId: s.titleId }),
        /* @__PURE__ */ R.jsx(D7r, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), sve = "DialogTitle", jst = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = f2(sve, r);
    return /* @__PURE__ */ R.jsx(Mo.h2, { id: a.titleId, ...n, ref: e });
  }
);
jst.displayName = sve;
var Fst = "DialogDescription", zst = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = f2(Fst, r);
    return /* @__PURE__ */ R.jsx(Mo.p, { id: a.descriptionId, ...n, ref: e });
  }
);
zst.displayName = Fst;
var Gst = "DialogClose", Wst = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = f2(Gst, r);
    return /* @__PURE__ */ R.jsx(
      Mo.button,
      {
        type: "button",
        ...n,
        ref: e,
        onClick: Oa(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Wst.displayName = Gst;
function lve(t) {
  return t ? "open" : "closed";
}
var Hst = "DialogTitleWarning", [W3n, Ust] = _it(Hst, {
  contentName: I5,
  titleName: sve,
  docsSlug: "dialog"
}), N7r = ({ titleId: t }) => {
  const e = Ust(Hst), r = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return P.useEffect(() => {
    t && (document.getElementById(t) || console.error(r));
  }, [r, t]), null;
}, $7r = "DialogDescriptionWarning", D7r = ({ contentRef: t, descriptionId: e }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ust($7r).contentName}}.`;
  return P.useEffect(() => {
    var i;
    const a = (i = t.current) == null ? void 0 : i.getAttribute("aria-describedby");
    e && a && (document.getElementById(e) || console.warn(n));
  }, [n, t, e]), null;
}, L7r = Pst, j7r = Ost, F7r = Nst, Vst = $st, qst = Dst, Kst = jst, Zst = zst, z7r = Wst;
const Jst = L7r, G7r = j7r, W7r = F7r, Yst = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Vst,
  {
    ref: r,
    className: Tc(
      "fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      t
    ),
    ...e
  }
));
Yst.displayName = Vst.displayName;
const cve = P.forwardRef(
  ({
    className: t,
    children: e,
    showDialogClose: r = !0,
    fullscreen: n = !1,
    ...a
  }, i) => /* @__PURE__ */ R.jsxs(W7r, { children: [
    /* @__PURE__ */ R.jsx(Yst, {}),
    /* @__PURE__ */ R.jsxs(
      qst,
      {
        ref: i,
        className: Tc(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          t,
          n ? "max-w-screen h-screen border-0 sm:rounded-none p-0" : ""
        ),
        ...a,
        children: [
          e,
          r && /* @__PURE__ */ R.jsxs(z7r, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
            /* @__PURE__ */ R.jsx(y7r, { className: "h-4 w-4" }),
            /* @__PURE__ */ R.jsx("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] })
);
cve.displayName = qst.displayName;
const H7r = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Kst,
  {
    ref: r,
    className: Tc(
      "text-lg font-semibold leading-none tracking-tight",
      t
    ),
    ...e
  }
));
H7r.displayName = Kst.displayName;
const U7r = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  Zst,
  {
    ref: r,
    className: Tc("text-sm text-muted-foreground", t),
    ...e
  }
));
U7r.displayName = Zst.displayName;
const RTe = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, OTe = Kit, Xst = (t, e) => (r) => {
  var n;
  if ((e == null ? void 0 : e.variants) == null) return OTe(t, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: a, defaultVariants: i } = e, o = Object.keys(a).map((c) => {
    const u = r == null ? void 0 : r[c], f = i == null ? void 0 : i[c];
    if (u === null) return null;
    const h = RTe(u) || RTe(f);
    return a[c][h];
  }), s = r && Object.entries(r).reduce((c, u) => {
    let [f, h] = u;
    return h === void 0 || (c[f] = h), c;
  }, {}), l = e == null || (n = e.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((c, u) => {
    let { class: f, className: h, ...p } = u;
    return Object.entries(p).every((g) => {
      let [y, b] = g;
      return Array.isArray(b) ? b.includes({
        ...i,
        ...s
      }[y]) : {
        ...i,
        ...s
      }[y] === b;
    }) ? [
      ...c,
      f,
      h
    ] : c;
  }, []);
  return OTe(t, o, l, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
}, V7r = Xst(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), S$ = P.forwardRef(
  ({ className: t, variant: e, size: r, asChild: n = !1, ...a }, i) => {
    const o = n ? ave : "button";
    return /* @__PURE__ */ R.jsx(
      o,
      {
        className: Tc(V7r({ variant: e, size: r, className: t })),
        ref: i,
        ...a
      }
    );
  }
);
S$.displayName = "Button";
var q7r = "Toggle", Qst = P.forwardRef((t, e) => {
  const { pressed: r, defaultPressed: n = !1, onPressedChange: a, ...i } = t, [o = !1, s] = Z8({
    prop: r,
    onChange: a,
    defaultProp: n
  });
  return /* @__PURE__ */ R.jsx(
    Mo.button,
    {
      type: "button",
      "aria-pressed": o,
      "data-state": o ? "on" : "off",
      "data-disabled": t.disabled ? "" : void 0,
      ...i,
      ref: e,
      onClick: Oa(t.onClick, () => {
        t.disabled || s(!o);
      })
    }
  );
});
Qst.displayName = q7r;
var elt = Qst;
const K7r = Xst(
  "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted hover:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "border border-input bg-transparent shadow-sm hover:bg-accent hover:text-accent-foreground"
      },
      size: {
        default: "h-9 px-2 min-w-9",
        sm: "h-8 px-1.5 min-w-8",
        lg: "h-10 px-2.5 min-w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ud = P.forwardRef(({ className: t, variant: e, size: r, ...n }, a) => /* @__PURE__ */ R.jsx(
  elt,
  {
    ref: a,
    className: Tc(K7r({ variant: e, size: r, className: t })),
    ...n
  }
));
Ud.displayName = elt.displayName;
const BTe = (t) => {
  const { href: e, icon: r, label: n } = t, a = (i) => new RegExp("^https?:\\/\\/", "i").test(i);
  return /* @__PURE__ */ R.jsxs(
    _r,
    {
      as: "a",
      className: "flex gap-2 w-full",
      href: e,
      rel: a(e) ? "noreferrer" : void 0,
      target: a(e) ? "_blank" : void 0,
      children: [
        r && /* @__PURE__ */ R.jsx(_lr, { name: r }),
        /* @__PURE__ */ R.jsx(
          kb,
          {
            as: "span",
            display: "flex",
            textDecoration: "none",
            children: n
          }
        )
      ]
    }
  );
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z7r = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), tlt = (...t) => t.filter((e, r, n) => !!e && e.trim() !== "" && n.indexOf(e) === r).join(" ").trim();
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var J7r = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Y7r = Ml(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: a = "",
    children: i,
    iconNode: o,
    ...s
  }, l) => Ds(
    "svg",
    {
      ref: l,
      ...J7r,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: n ? Number(r) * 24 / Number(e) : r,
      className: tlt("lucide", a),
      ...s
    },
    [
      ...o.map(([c, u]) => Ds(c, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Po = (t, e) => {
  const r = Ml(
    ({ className: n, ...a }, i) => Ds(Y7r, {
      ref: i,
      iconNode: e,
      className: tlt(`lucide-${Z7r(t)}`, n),
      ...a
    })
  );
  return r.displayName = `${t}`, r;
};
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X7r = [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
], Q7r = Po("Bold", X7r);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const exr = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
], txr = Po("BookOpenText", exr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rxr = [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
], nxr = Po("BotMessageSquare", rxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const axr = [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
], ixr = Po("Brain", axr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oxr = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], sxr = Po("Check", oxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lxr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], cxr = Po("CircleHelp", lxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uxr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
], dxr = Po("CirclePlay", uxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fxr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
], hxr = Po("CircleStop", fxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pxr = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
], mxr = Po("ClipboardCheck", pxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gxr = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
], vxr = Po("ClipboardList", gxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yxr = [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
], bxr = Po("Code", yxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xxr = [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
], Cxr = Po("Copy", xxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wxr = [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
], Sxr = Po("Cuboid", wxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _xr = [["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]], lj = Po("Dot", _xr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kxr = [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
], Axr = Po("FilePen", kxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Txr = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
], Exr = Po("Heading1", Txr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ixr = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
], Mxr = Po("Heading2", Ixr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pxr = [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
], Rxr = Po("Heading3", Pxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oxr = [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
], Bxr = Po("Italic", Oxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nxr = [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
], $xr = Po("ListOrdered", Nxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dxr = [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
], Lxr = Po("List", Dxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jxr = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Fxr = Po("Loader", jxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zxr = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], Gxr = Po("Lock", zxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wxr = [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
], Hxr = Po("MessageSquareText", Wxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Uxr = [["path", { d: "M5 12h14", key: "1ays0h" }]], Vxr = Po("Minus", Uxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qxr = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
], Kxr = Po("SquareChevronRight", qxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zxr = [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
], Jxr = Po("Strikethrough", Zxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yxr = [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
], Xxr = Po("TextQuote", Yxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qxr = [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
], e8r = Po("Wrench", Qxr);
/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const t8r = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], r8r = Po("X", t8r), n8r = [
  {
    id: "quick-start-guide",
    href: "https://help.twilio.com/articles/18133722687643",
    icon: "documentation",
    label: "Quick Start Guide",
    position: "top"
  },
  {
    id: "terms-of-service",
    href: "https://www.twilio.com/en-us/legal/tos",
    label: "Terms of Service",
    position: "bottom"
  },
  {
    id: "privacy-policy",
    href: "https://www.twilio.com/en-us/legal/privacy",
    label: "Privacy Policy",
    position: "bottom"
  }
], a8r = ({ links: t, onlyShowIcons: e = !1 }) => {
  const r = (i) => {
    const o = n8r.map((u) => {
      const f = i.find((h) => h.id === u.id);
      return f ? {
        ...u,
        ...f
      } : u;
    }), s = i.filter((u) => !u.id), l = o.filter((u) => u.position === "bottom"), c = [
      ...o.filter((u) => u.position === "top"),
      ...s
    ];
    return {
      bottomLinks: l,
      topLinks: c
    };
  }, { bottomLinks: n, topLinks: a } = r(t);
  return /* @__PURE__ */ R.jsxs(b7r, { children: [
    /* @__PURE__ */ R.jsx(
      PL,
      {
        text: "More",
        isActive: e,
        placement: "right",
        children: /* @__PURE__ */ R.jsx(x7r, { asChild: !0, children: /* @__PURE__ */ R.jsx(ML, { size: "small", children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", columnGap: "space20", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(cxr, { size: "20px" }),
          e ? "" : "More"
        ] }) }) })
      }
    ),
    /* @__PURE__ */ R.jsxs(Est, { className: "w-56", children: [
      /* @__PURE__ */ R.jsx(PTe, { children: a.map((i) => /* @__PURE__ */ R.jsx(fde, { children: /* @__PURE__ */ R.jsx(
        BTe,
        {
          href: i.href,
          icon: i.icon,
          label: i.label
        }
      ) }, i.href)) }),
      /* @__PURE__ */ R.jsx(Ist, {}),
      /* @__PURE__ */ R.jsx(PTe, { children: n.map((i) => /* @__PURE__ */ R.jsx(fde, { children: /* @__PURE__ */ R.jsx(
        BTe,
        {
          href: i.href,
          icon: i.icon,
          label: i.label
        }
      ) }, i.href)) })
    ] })
  ] });
}, rlt = Ml(
  ({ className: t, onChange: e, value: r, style: n, minRows: a = 1, maxRows: i = 5, ...o }, s) => {
    const l = Zt(null), c = sr(
      (f) => {
        l.current = f, typeof s == "function" ? s(f) : s && (s.current = f);
      },
      [s]
    ), u = () => {
      const f = l.current;
      if (!f) return;
      f.style.height = "auto";
      const h = getComputedStyle(f), g = parseFloat(h.lineHeight) * i;
      f.style.height = `${Math.min(f.scrollHeight, g)}px`;
    };
    return Ut(() => {
      u();
    }, [r, i]), /* @__PURE__ */ R.jsx(
      "textarea",
      {
        className: t,
        ref: c,
        value: r,
        onChange: (f) => {
          e == null || e(f), u();
        },
        rows: a,
        style: {
          scrollbarColor: "#999 transparent",
          width: "100%",
          resize: "none",
          overflowY: "auto",
          fontSize: "0.875rem",
          lineHeight: "1.5rem",
          maxHeight: `calc(1.5rem * ${i})`,
          padding: "0rem",
          outline: "none",
          border: "none",
          boxShadow: "none",
          ...n
        },
        ...o
      }
    );
  }
);
rlt.displayName = "ExpandingTextarea";
const i8r = ({
  showPrompts: t,
  setSelectedItem: e,
  onKeyDown: r,
  onKeyUp: n,
  value: a,
  setValue: i,
  loading: o,
  onSubmit: s,
  onComboboxOpenChange: l,
  hideCombobox: c,
  promptClickHandler: u,
  onClickCanvas: f,
  showCanvasButton: h,
  showPromptLibraryButton: p,
  moreLinks: g,
  containerRef: y,
  onlyShowIcons: b,
  placeholder: w
}) => {
  const _ = Zt(null);
  return Ut(() => {
    !t && _.current && _.current.focus();
  }, [t]), /* @__PURE__ */ R.jsxs(
    is,
    {
      ref: y,
      padding: "space40",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      rowGap: "space40",
      borderRadius: "borderRadius40",
      children: [
        /* @__PURE__ */ R.jsxs(_r, { paddingTop: "space40", paddingX: "space40", children: [
          t && /* @__PURE__ */ R.jsx(
            Nbr,
            {
              hideCombobox: c,
              value: a,
              setValue: i,
              onComboboxOpenChange: l,
              setSelectedItem: e,
              showPromptLibrary: u
            }
          ),
          /* @__PURE__ */ R.jsx(
            rlt,
            {
              onKeyDown: r,
              onKeyUp: n,
              value: a,
              onChange: (C) => i(C.target.value),
              placeholder: w
            }
          )
        ] }),
        /* @__PURE__ */ R.jsxs(_r, { className: "flex", children: [
          h && /* @__PURE__ */ R.jsx(
            PL,
            {
              text: "Canvas",
              placement: "right",
              isActive: b,
              children: /* @__PURE__ */ R.jsx(ML, { size: "small", onClick: f, children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", columnGap: "space20", alignItems: "center", children: [
                /* @__PURE__ */ R.jsx(lQe, { decorative: !0 }),
                b ? "" : "Canvas"
              ] }) })
            }
          ),
          p && /* @__PURE__ */ R.jsx(
            PL,
            {
              text: "Prompts",
              placement: "right",
              isActive: b,
              children: /* @__PURE__ */ R.jsx(ML, { size: "small", onClick: u, children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", columnGap: "space20", alignItems: "center", children: [
                /* @__PURE__ */ R.jsx(
                  "img",
                  {
                    width: "19px",
                    height: "19px",
                    src: Flr,
                    alt: "Prompt Icon",
                    style: {
                      marginBottom: "2.5px"
                      // This icon is a bit lower than the other icons
                    }
                  }
                ),
                b ? "" : "Prompts"
              ] }) })
            }
          ),
          /* @__PURE__ */ R.jsx($br, { onlyShowIcons: b }),
          /* @__PURE__ */ R.jsx(
            a8r,
            {
              links: g,
              onlyShowIcons: b
            }
          ),
          /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
          /* @__PURE__ */ R.jsx(
            as,
            {
              variant: "primary_icon",
              size: "small",
              onClick: () => !o && s && s(),
              disabled: o || a.trim().length === 0,
              children: o ? /* @__PURE__ */ R.jsx(YGe, { decorative: !1, title: "Loading" }) : /* @__PURE__ */ R.jsx(j2e, { decorative: !1, title: "Send" })
            }
          )
        ] })
      ]
    }
  );
}, nlt = (t = null) => {
  const e = Zt(null), [r, n] = Yt(t), a = sr(() => {
    e.current && n(e.current.offsetWidth);
  }, []);
  return Ut(() => {
    if (typeof ResizeObserver > "u") {
      console.warn("ResizeObserver is not supported in this browser.");
      return;
    }
    const i = new ResizeObserver(() => {
      window.requestAnimationFrame(a);
    });
    return e.current && (i.observe(e.current), a()), () => {
      e.current && i.unobserve(e.current), i.disconnect();
    };
  }, [a]), [e, r];
}, o8r = "WISE_OWL:", s8r = (t, e) => (r, n = void 0, a) => {
  if (!r)
    throw new Error(
      `"storageKey" must be a nonempty string, but "${r}" was passed.`
    );
  const [i, o] = Yt(() => {
    const s = t.getItem(e + r);
    if (s && a) {
      const l = JSON.parse(s);
      return a.fromJson(l);
    } else return s ? s === "undefined" ? void 0 : JSON.parse(s) : n;
  });
  return Ut(() => {
    if (a) {
      const s = a.toJson(i);
      t.setItem(e + r, JSON.stringify(s));
    } else
      i == null ? t.removeItem(e + r) : t.setItem(e + r, JSON.stringify(i));
  }, [i, r, a]), [i, o];
}, uve = s8r(sessionStorage, o8r), alt = ({
  value: t,
  setValue: e,
  onSubmit: r,
  loading: n,
  showCanvasButton: a,
  showPromptLibraryButton: i,
  placeholder: o
}) => {
  const [s, l] = Yt(!1), c = Rge(), u = Gn(
    (N) => N.conversation.isCanvasOpen
  ), f = s2(), h = Gn((N) => N.config.applicationId), { requestTransformer: p } = Ja(), { data: g } = WI({
    applicationId: h,
    requestTransformer: p
  }), [y, b] = nlt(), [w, _] = Yt(!0);
  Ut(() => {
    _(!b || b < 500);
  }, [b]);
  const C = (N) => N.trim().charAt(0) === "/", x = (N) => {
    C(N.currentTarget.value) && l(!0);
  }, S = (N) => {
    N.key === "Enter" && !N.shiftKey && !n && (N.preventDefault(), t.trim().length > 0 && (r == null || r()));
  }, A = (N) => {
    setTimeout(() => {
      e(N.template), l(!1);
    }, 0);
  }, I = () => {
    l(!1);
  }, M = () => {
    c.show();
  }, B = (N) => {
    N.isOpen === !1 && (e(t.slice(1)), I());
  }, L = () => {
    f(oz(!u));
  };
  return /* @__PURE__ */ R.jsx(
    i8r,
    {
      moreLinks: (g == null ? void 0 : g.application.moreLinks) || [],
      value: t,
      setValue: e,
      showPrompts: s,
      loading: n,
      promptClickHandler: M,
      onSubmit: r,
      onComboboxOpenChange: B,
      onKeyDown: S,
      onKeyUp: x,
      setSelectedItem: A,
      hideCombobox: I,
      onClickCanvas: L,
      showCanvasButton: a,
      showPromptLibraryButton: i,
      containerRef: y,
      onlyShowIcons: w,
      placeholder: o
    }
  );
}, dve = Bo({});
function fve(t) {
  const e = Zt(null);
  return e.current === null && (e.current = t()), e.current;
}
const OW = /* @__PURE__ */ Bo(null), hve = Bo({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
class l8r extends P.Component {
  getSnapshotBeforeUpdate(e) {
    const r = this.props.childRef.current;
    if (r && e.isPresent && !this.props.isPresent) {
      const n = r.offsetParent, a = n instanceof HTMLElement && n.offsetWidth || 0, i = this.props.sizeRef.current;
      i.height = r.offsetHeight || 0, i.width = r.offsetWidth || 0, i.top = r.offsetTop, i.left = r.offsetLeft, i.right = a - i.width - i.left;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function c8r({ children: t, isPresent: e, anchorX: r }) {
  const n = s1e(), a = Zt(null), i = Zt({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0
  }), { nonce: o } = Qn(hve);
  return VGe(() => {
    const { width: s, height: l, top: c, left: u, right: f } = i.current;
    if (e || !a.current || !s || !l)
      return;
    const h = r === "left" ? `left: ${u}` : `right: ${f}`;
    a.current.dataset.motionPopId = n;
    const p = document.createElement("style");
    return o && (p.nonce = o), document.head.appendChild(p), p.sheet && p.sheet.insertRule(`
          [data-motion-pop-id="${n}"] {
            position: absolute !important;
            width: ${s}px !important;
            height: ${l}px !important;
            ${h}px !important;
            top: ${c}px !important;
          }
        `), () => {
      document.head.removeChild(p);
    };
  }, [e]), R.jsx(l8r, { isPresent: e, childRef: a, sizeRef: i, children: P.cloneElement(t, { ref: a }) });
}
const u8r = ({ children: t, initial: e, isPresent: r, onExitComplete: n, custom: a, presenceAffectsLayout: i, mode: o, anchorX: s }) => {
  const l = fve(d8r), c = s1e(), u = sr((h) => {
    l.set(h, !0);
    for (const p of l.values())
      if (!p)
        return;
    n && n();
  }, [l, n]), f = fa(
    () => ({
      id: c,
      initial: e,
      isPresent: r,
      custom: a,
      onExitComplete: u,
      register: (h) => (l.set(h, !1), () => l.delete(h))
    }),
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    i ? [Math.random(), u] : [r, u]
  );
  return fa(() => {
    l.forEach((h, p) => l.set(p, !1));
  }, [r]), P.useEffect(() => {
    !r && !l.size && n && n();
  }, [r]), o === "popLayout" && (t = R.jsx(c8r, { isPresent: r, anchorX: s, children: t })), R.jsx(OW.Provider, { value: f, children: t });
};
function d8r() {
  return /* @__PURE__ */ new Map();
}
function ilt(t = !0) {
  const e = Qn(OW);
  if (e === null)
    return [!0, null];
  const { isPresent: r, onExitComplete: n, register: a } = e, i = s1e();
  Ut(() => {
    t && a(i);
  }, [t]);
  const o = sr(() => t && n && n(i), [i, n, t]);
  return !r && n ? [!1, o] : [!0];
}
const UB = (t) => t.key || "";
function NTe(t) {
  const e = [];
  return Pv.forEach(t, (r) => {
    ef(r) && e.push(r);
  }), e;
}
const pve = typeof window < "u", olt = pve ? qh : Ut, f8r = ({ children: t, custom: e, initial: r = !0, onExitComplete: n, presenceAffectsLayout: a = !0, mode: i = "sync", propagate: o = !1, anchorX: s = "left" }) => {
  const [l, c] = ilt(o), u = fa(() => NTe(t), [t]), f = o && !l ? [] : u.map(UB), h = Zt(!0), p = Zt(u), g = fve(() => /* @__PURE__ */ new Map()), [y, b] = Yt(u), [w, _] = Yt(u);
  olt(() => {
    h.current = !1, p.current = u;
    for (let S = 0; S < w.length; S++) {
      const A = UB(w[S]);
      f.includes(A) ? g.delete(A) : g.get(A) !== !0 && g.set(A, !1);
    }
  }, [w, f.length, f.join("-")]);
  const C = [];
  if (u !== y) {
    let S = [...u];
    for (let A = 0; A < w.length; A++) {
      const I = w[A], M = UB(I);
      f.includes(M) || (S.splice(A, 0, I), C.push(I));
    }
    return i === "wait" && C.length && (S = C), _(NTe(S)), b(u), null;
  }
  Ar.env.NODE_ENV !== "production" && i === "wait" && w.length > 1 && console.warn(`You're attempting to animate multiple children within AnimatePresence, but its mode is set to "wait". This will lead to odd visual behaviour.`);
  const { forceRender: x } = Qn(dve);
  return R.jsx(R.Fragment, { children: w.map((S) => {
    const A = UB(S), I = o && !l ? !1 : u === w || f.includes(A), M = () => {
      if (g.has(A))
        g.set(A, !0);
      else
        return;
      let B = !0;
      g.forEach((L) => {
        L || (B = !1);
      }), B && (x == null || x(), _(p.current), o && (c == null || c()), n && n());
    };
    return R.jsx(u8r, { isPresent: I, initial: !h.current || r ? void 0 : !1, custom: e, presenceAffectsLayout: a, mode: i, onExitComplete: I ? void 0 : M, anchorX: s, children: S }, A);
  }) });
}, gd = /* @__NO_SIDE_EFFECTS__ */ (t) => t;
let Q8 = gd, Cy = gd;
Ar.env.NODE_ENV !== "production" && (Q8 = (t, e) => {
  !t && typeof console < "u" && console.warn(e);
}, Cy = (t, e) => {
  if (!t)
    throw new Error(e);
});
const h8r = {
  useManualTiming: !1
}, VB = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], $Te = {
  value: null
};
function p8r(t, e) {
  let r = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), a = !1, i = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, l = 0;
  function c(f) {
    o.has(f) && (u.schedule(f), t()), l++, f(s);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (f, h = !1, p = !1) => {
      const y = p && a ? r : n;
      return h && o.add(f), y.has(f) || y.add(f), f;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (f) => {
      n.delete(f), o.delete(f);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (f) => {
      if (s = f, a) {
        i = !0;
        return;
      }
      a = !0, [r, n] = [n, r], r.forEach(c), e && $Te.value && $Te.value.frameloop[e].push(l), l = 0, r.clear(), a = !1, i && (i = !1, u.process(f));
    }
  };
  return u;
}
const m8r = 40;
function slt(t, e) {
  let r = !1, n = !0;
  const a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, i = () => r = !0, o = VB.reduce((w, _) => (w[_] = p8r(i, e ? _ : void 0), w), {}), { read: s, resolveKeyframes: l, update: c, preRender: u, render: f, postRender: h } = o, p = () => {
    const w = performance.now();
    r = !1, a.delta = n ? 1e3 / 60 : Math.max(Math.min(w - a.timestamp, m8r), 1), a.timestamp = w, a.isProcessing = !0, s.process(a), l.process(a), c.process(a), u.process(a), f.process(a), h.process(a), a.isProcessing = !1, r && e && (n = !1, t(p));
  }, g = () => {
    r = !0, n = !0, a.isProcessing || t(p);
  };
  return { schedule: VB.reduce((w, _) => {
    const C = o[_];
    return w[_] = (x, S = !1, A = !1) => (r || g(), C.schedule(x, S, A)), w;
  }, {}), cancel: (w) => {
    for (let _ = 0; _ < VB.length; _++)
      o[VB[_]].cancel(w);
  }, state: a, steps: o };
}
const { schedule: cs, cancel: wy, state: Cc, steps: xee } = slt(typeof requestAnimationFrame < "u" ? requestAnimationFrame : gd, !0), llt = Bo({ strict: !1 }), DTe = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, kx = {};
for (const t in DTe)
  kx[t] = {
    isEnabled: (e) => DTe[t].some((r) => !!e[r])
  };
function g8r(t) {
  for (const e in t)
    kx[e] = {
      ...kx[e],
      ...t[e]
    };
}
const v8r = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function cj(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || v8r.has(t);
}
let clt = (t) => !cj(t);
function y8r(t) {
  t && (clt = (e) => e.startsWith("on") ? !cj(e) : t(e));
}
try {
  y8r(require("@emotion/is-prop-valid").default);
} catch {
}
function b8r(t, e, r) {
  const n = {};
  for (const a in t)
    a === "values" && typeof t.values == "object" || (clt(a) || r === !0 && cj(a) || !e && !cj(a) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && a.startsWith("onDrag")) && (n[a] = t[a]);
  return n;
}
const LTe = /* @__PURE__ */ new Set();
function BW(t, e, r) {
  t || LTe.has(e) || (console.warn(e), LTe.add(e));
}
function x8r(t) {
  if (typeof Proxy > "u")
    return t;
  const e = /* @__PURE__ */ new Map(), r = (...n) => (Ar.env.NODE_ENV !== "production" && BW(!1, "motion() is deprecated. Use motion.create() instead."), t(...n));
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (n, a) => a === "create" ? t : (e.has(a) || e.set(a, t(a)), e.get(a))
  });
}
const NW = /* @__PURE__ */ Bo({});
function $W(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function gE(t) {
  return typeof t == "string" || Array.isArray(t);
}
const mve = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], gve = ["initial", ...mve];
function DW(t) {
  return $W(t.animate) || gve.some((e) => gE(t[e]));
}
function ult(t) {
  return !!(DW(t) || t.variants);
}
function C8r(t, e) {
  if (DW(t)) {
    const { initial: r, animate: n } = t;
    return {
      initial: r === !1 || gE(r) ? r : void 0,
      animate: gE(n) ? n : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function w8r(t) {
  const { initial: e, animate: r } = C8r(t, Qn(NW));
  return fa(() => ({ initial: e, animate: r }), [jTe(e), jTe(r)]);
}
function jTe(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const S8r = Symbol.for("motionComponentSymbol");
function G9(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function _8r(t, e, r) {
  return sr(
    (n) => {
      n && t.onMount && t.onMount(n), e && (n ? e.mount(n) : e.unmount()), r && (typeof r == "function" ? r(n) : G9(r) && (r.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
const vve = (t) => t.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), k8r = "framerAppearId", dlt = "data-" + vve(k8r), { schedule: yve } = slt(queueMicrotask, !1), flt = Bo({});
function A8r(t, e, r, n, a) {
  var i, o;
  const { visualElement: s } = Qn(NW), l = Qn(llt), c = Qn(OW), u = Qn(hve).reducedMotion, f = Zt(null);
  n = n || l.renderer, !f.current && n && (f.current = n(t, {
    visualState: e,
    parent: s,
    props: r,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const h = f.current, p = Qn(flt);
  h && !h.projection && a && (h.type === "html" || h.type === "svg") && T8r(f.current, r, a, p);
  const g = Zt(!1);
  VGe(() => {
    h && g.current && h.update(r, c);
  });
  const y = r[dlt], b = Zt(!!y && !(!((i = window.MotionHandoffIsComplete) === null || i === void 0) && i.call(window, y)) && ((o = window.MotionHasOptimisedAnimation) === null || o === void 0 ? void 0 : o.call(window, y)));
  return olt(() => {
    h && (g.current = !0, window.MotionIsMounted = !0, h.updateFeatures(), yve.render(h.render), b.current && h.animationState && h.animationState.animateChanges());
  }), Ut(() => {
    h && (!b.current && h.animationState && h.animationState.animateChanges(), b.current && (queueMicrotask(() => {
      var w;
      (w = window.MotionHandoffMarkAsComplete) === null || w === void 0 || w.call(window, y);
    }), b.current = !1));
  }), h;
}
function T8r(t, e, r, n) {
  const { layoutId: a, layout: i, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: c } = e;
  t.projection = new r(t.latestValues, e["data-framer-portal-id"] ? void 0 : hlt(t.parent)), t.projection.setOptions({
    layoutId: a,
    layout: i,
    alwaysMeasureLayout: !!o || s && G9(s),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof i == "string" ? i : "both",
    initialPromotionConfig: n,
    layoutScroll: l,
    layoutRoot: c
  });
}
function hlt(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : hlt(t.parent);
}
function E8r({ preloadedFeatures: t, createVisualElement: e, useRender: r, useVisualState: n, Component: a }) {
  var i, o;
  t && g8r(t);
  function s(c, u) {
    let f;
    const h = {
      ...Qn(hve),
      ...c,
      layoutId: I8r(c)
    }, { isStatic: p } = h, g = w8r(c), y = n(c, p);
    if (!p && pve) {
      M8r(h, t);
      const b = P8r(h);
      f = b.MeasureLayout, g.visualElement = A8r(a, y, h, e, b.ProjectionNode);
    }
    return R.jsxs(NW.Provider, { value: g, children: [f && g.visualElement ? R.jsx(f, { visualElement: g.visualElement, ...h }) : null, r(a, c, _8r(y, g.visualElement, u), y, p, g.visualElement)] });
  }
  s.displayName = `motion.${typeof a == "string" ? a : `create(${(o = (i = a.displayName) !== null && i !== void 0 ? i : a.name) !== null && o !== void 0 ? o : ""})`}`;
  const l = Ml(s);
  return l[S8r] = a, l;
}
function I8r({ layoutId: t }) {
  const e = Qn(dve).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function M8r(t, e) {
  const r = Qn(llt).strict;
  if (Ar.env.NODE_ENV !== "production" && e && r) {
    const n = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? Q8(!1, n) : Cy(!1, n);
  }
}
function P8r(t) {
  const { drag: e, layout: r } = kx;
  if (!e && !r)
    return {};
  const n = { ...e, ...r };
  return {
    MeasureLayout: e != null && e.isEnabled(t) || r != null && r.isEnabled(t) ? n.MeasureLayout : void 0,
    ProjectionNode: n.ProjectionNode
  };
}
const plt = (t) => (e) => typeof e == "string" && e.startsWith(t), bve = /* @__PURE__ */ plt("--"), R8r = /* @__PURE__ */ plt("var(--"), xve = (t) => R8r(t) ? O8r.test(t.split("/*")[0].trim()) : !1, O8r = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, vE = {};
function B8r(t) {
  for (const e in t)
    vE[e] = t[e], bve(e) && (vE[e].isCSSVariable = !0);
}
const eC = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], v6 = new Set(eC);
function mlt(t, { layout: e, layoutId: r }) {
  return v6.has(t) || t.startsWith("origin") || (e || r !== void 0) && (!!vE[t] || t === "opacity");
}
const Jc = (t) => !!(t && t.getVelocity), glt = (t, e) => e && typeof t == "number" ? e.transform(t) : t, Ym = (t, e, r) => r > e ? e : r < t ? t : r, tC = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, yE = {
  ...tC,
  transform: (t) => Ym(0, 1, t)
}, qB = {
  ...tC,
  default: 1
}, tP = (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), cv = /* @__PURE__ */ tP("deg"), Ch = /* @__PURE__ */ tP("%"), ca = /* @__PURE__ */ tP("px"), N8r = /* @__PURE__ */ tP("vh"), $8r = /* @__PURE__ */ tP("vw"), FTe = {
  ...Ch,
  parse: (t) => Ch.parse(t) / 100,
  transform: (t) => Ch.transform(t * 100)
}, D8r = {
  // Border props
  borderWidth: ca,
  borderTopWidth: ca,
  borderRightWidth: ca,
  borderBottomWidth: ca,
  borderLeftWidth: ca,
  borderRadius: ca,
  radius: ca,
  borderTopLeftRadius: ca,
  borderTopRightRadius: ca,
  borderBottomRightRadius: ca,
  borderBottomLeftRadius: ca,
  // Positioning props
  width: ca,
  maxWidth: ca,
  height: ca,
  maxHeight: ca,
  top: ca,
  right: ca,
  bottom: ca,
  left: ca,
  // Spacing props
  padding: ca,
  paddingTop: ca,
  paddingRight: ca,
  paddingBottom: ca,
  paddingLeft: ca,
  margin: ca,
  marginTop: ca,
  marginRight: ca,
  marginBottom: ca,
  marginLeft: ca,
  // Misc
  backgroundPositionX: ca,
  backgroundPositionY: ca
}, L8r = {
  rotate: cv,
  rotateX: cv,
  rotateY: cv,
  rotateZ: cv,
  scale: qB,
  scaleX: qB,
  scaleY: qB,
  scaleZ: qB,
  skew: cv,
  skewX: cv,
  skewY: cv,
  distance: ca,
  translateX: ca,
  translateY: ca,
  translateZ: ca,
  x: ca,
  y: ca,
  z: ca,
  perspective: ca,
  transformPerspective: ca,
  opacity: yE,
  originX: FTe,
  originY: FTe,
  originZ: ca
}, zTe = {
  ...tC,
  transform: Math.round
}, Cve = {
  ...D8r,
  ...L8r,
  zIndex: zTe,
  size: ca,
  // SVG
  fillOpacity: yE,
  strokeOpacity: yE,
  numOctaves: zTe
}, j8r = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, F8r = eC.length;
function z8r(t, e, r) {
  let n = "", a = !0;
  for (let i = 0; i < F8r; i++) {
    const o = eC[i], s = t[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || r) {
      const c = glt(s, Cve[o]);
      if (!l) {
        a = !1;
        const u = j8r[o] || o;
        n += `${u}(${c}) `;
      }
      r && (e[o] = c);
    }
  }
  return n = n.trim(), r ? n = r(e, a ? "" : n) : a && (n = "none"), n;
}
function wve(t, e, r) {
  const { style: n, vars: a, transformOrigin: i } = t;
  let o = !1, s = !1;
  for (const l in e) {
    const c = e[l];
    if (v6.has(l)) {
      o = !0;
      continue;
    } else if (bve(l)) {
      a[l] = c;
      continue;
    } else {
      const u = glt(c, Cve[l]);
      l.startsWith("origin") ? (s = !0, i[l] = u) : n[l] = u;
    }
  }
  if (e.transform || (o || r ? n.transform = z8r(e, t.transform, r) : n.transform && (n.transform = "none")), s) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = i;
    n.transformOrigin = `${l} ${c} ${u}`;
  }
}
const Sve = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function vlt(t, e, r) {
  for (const n in e)
    !Jc(e[n]) && !mlt(n, r) && (t[n] = e[n]);
}
function G8r({ transformTemplate: t }, e) {
  return fa(() => {
    const r = Sve();
    return wve(r, e, t), Object.assign({}, r.vars, r.style);
  }, [e]);
}
function W8r(t, e) {
  const r = t.style || {}, n = {};
  return vlt(n, r, t), Object.assign(n, G8r(t, e)), n;
}
function H8r(t, e) {
  const r = {}, n = W8r(t, e);
  return t.drag && t.dragListener !== !1 && (r.draggable = !1, n.userSelect = n.WebkitUserSelect = n.WebkitTouchCallout = "none", n.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (r.tabIndex = 0), r.style = n, r;
}
const U8r = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function _ve(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(U8r.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
const V8r = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, q8r = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function K8r(t, e, r = 1, n = 0, a = !0) {
  t.pathLength = 1;
  const i = a ? V8r : q8r;
  t[i.offset] = ca.transform(-n);
  const o = ca.transform(e), s = ca.transform(r);
  t[i.array] = `${o} ${s}`;
}
function GTe(t, e, r) {
  return typeof t == "string" ? t : ca.transform(e + r * t);
}
function Z8r(t, e, r) {
  const n = GTe(e, t.x, t.width), a = GTe(r, t.y, t.height);
  return `${n} ${a}`;
}
function kve(t, {
  attrX: e,
  attrY: r,
  attrScale: n,
  originX: a,
  originY: i,
  pathLength: o,
  pathSpacing: s = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, f) {
  if (wve(t, c, f), u) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: h, style: p, dimensions: g } = t;
  h.transform && (g && (p.transform = h.transform), delete h.transform), g && (a !== void 0 || i !== void 0 || p.transform) && (p.transformOrigin = Z8r(g, a !== void 0 ? a : 0.5, i !== void 0 ? i : 0.5)), e !== void 0 && (h.x = e), r !== void 0 && (h.y = r), n !== void 0 && (h.scale = n), o !== void 0 && K8r(h, o, s, l, !1);
}
const ylt = () => ({
  ...Sve(),
  attrs: {}
}), Ave = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function J8r(t, e, r, n) {
  const a = fa(() => {
    const i = ylt();
    return kve(i, e, Ave(n), t.transformTemplate), {
      ...i.attrs,
      style: { ...i.style }
    };
  }, [e]);
  if (t.style) {
    const i = {};
    vlt(i, t.style, t), a.style = { ...i, ...a.style };
  }
  return a;
}
function Y8r(t = !1) {
  return (r, n, a, { latestValues: i }, o) => {
    const l = (_ve(r) ? J8r : H8r)(n, i, o, r), c = b8r(n, typeof r == "string", t), u = r !== qGe ? { ...c, ...l, ref: a } : {}, { children: f } = n, h = fa(() => Jc(f) ? f.get() : f, [f]);
    return Ds(r, {
      ...u,
      children: h
    });
  };
}
function WTe(t) {
  const e = [{}, {}];
  return t == null || t.values.forEach((r, n) => {
    e[0][n] = r.get(), e[1][n] = r.getVelocity();
  }), e;
}
function Tve(t, e, r, n) {
  if (typeof e == "function") {
    const [a, i] = WTe(n);
    e = e(r !== void 0 ? r : t.custom, a, i);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [a, i] = WTe(n);
    e = e(r !== void 0 ? r : t.custom, a, i);
  }
  return e;
}
const pde = (t) => Array.isArray(t), X8r = (t) => !!(t && typeof t == "object" && t.mix && t.toValue), Q8r = (t) => pde(t) ? t[t.length - 1] || 0 : t;
function _$(t) {
  const e = Jc(t) ? t.get() : t;
  return X8r(e) ? e.toValue() : e;
}
function eCr({ scrapeMotionValuesFromProps: t, createRenderState: e, onUpdate: r }, n, a, i) {
  const o = {
    latestValues: tCr(n, a, i, t),
    renderState: e()
  };
  return r && (o.onMount = (s) => r({ props: n, current: s, ...o }), o.onUpdate = (s) => r(s)), o;
}
const blt = (t) => (e, r) => {
  const n = Qn(NW), a = Qn(OW), i = () => eCr(t, e, n, a);
  return r ? i() : fve(i);
};
function tCr(t, e, r, n) {
  const a = {}, i = n(t, {});
  for (const h in i)
    a[h] = _$(i[h]);
  let { initial: o, animate: s } = t;
  const l = DW(t), c = ult(t);
  e && c && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), s === void 0 && (s = e.animate));
  let u = r ? r.initial === !1 : !1;
  u = u || o === !1;
  const f = u ? s : o;
  if (f && typeof f != "boolean" && !$W(f)) {
    const h = Array.isArray(f) ? f : [f];
    for (let p = 0; p < h.length; p++) {
      const g = Tve(t, h[p]);
      if (g) {
        const { transitionEnd: y, transition: b, ...w } = g;
        for (const _ in w) {
          let C = w[_];
          if (Array.isArray(C)) {
            const x = u ? C.length - 1 : 0;
            C = C[x];
          }
          C !== null && (a[_] = C);
        }
        for (const _ in y)
          a[_] = y[_];
      }
    }
  }
  return a;
}
function Eve(t, e, r) {
  var n;
  const { style: a } = t, i = {};
  for (const o in a)
    (Jc(a[o]) || e.style && Jc(e.style[o]) || mlt(o, t) || ((n = r == null ? void 0 : r.getValue(o)) === null || n === void 0 ? void 0 : n.liveStyle) !== void 0) && (i[o] = a[o]);
  return i;
}
const rCr = {
  useVisualState: blt({
    scrapeMotionValuesFromProps: Eve,
    createRenderState: Sve
  })
};
function xlt(t, e) {
  try {
    e.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
  } catch {
    e.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
function Clt(t, { style: e, vars: r }, n, a) {
  Object.assign(t.style, e, a && a.getProjectionStyles(n));
  for (const i in r)
    t.style.setProperty(i, r[i]);
}
const wlt = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Slt(t, e, r, n) {
  Clt(t, e, void 0, n);
  for (const a in e.attrs)
    t.setAttribute(wlt.has(a) ? a : vve(a), e.attrs[a]);
}
function _lt(t, e, r) {
  const n = Eve(t, e, r);
  for (const a in t)
    if (Jc(t[a]) || Jc(e[a])) {
      const i = eC.indexOf(a) !== -1 ? "attr" + a.charAt(0).toUpperCase() + a.substring(1) : a;
      n[i] = t[a];
    }
  return n;
}
const HTe = ["x", "y", "width", "height", "cx", "cy", "r"], nCr = {
  useVisualState: blt({
    scrapeMotionValuesFromProps: _lt,
    createRenderState: ylt,
    onUpdate: ({ props: t, prevProps: e, current: r, renderState: n, latestValues: a }) => {
      if (!r)
        return;
      let i = !!t.drag;
      if (!i) {
        for (const s in a)
          if (v6.has(s)) {
            i = !0;
            break;
          }
      }
      if (!i)
        return;
      let o = !e;
      if (e)
        for (let s = 0; s < HTe.length; s++) {
          const l = HTe[s];
          t[l] !== e[l] && (o = !0);
        }
      o && cs.read(() => {
        xlt(r, n), cs.render(() => {
          kve(n, a, Ave(r.tagName), t.transformTemplate), Slt(r, n);
        });
      });
    }
  })
};
function aCr(t, e) {
  return function(n, { forwardMotionProps: a } = { forwardMotionProps: !1 }) {
    const o = {
      ..._ve(n) ? nCr : rCr,
      preloadedFeatures: t,
      useRender: Y8r(a),
      createVisualElement: e,
      Component: n
    };
    return E8r(o);
  };
}
function bE(t, e, r) {
  const n = t.getProps();
  return Tve(n, e, r !== void 0 ? r : n.custom, t);
}
function Ive(t, e) {
  return t ? t[e] || t.default || t : void 0;
}
const klt = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...eC
]);
let k$;
function iCr() {
  k$ = void 0;
}
const wh = {
  now: () => (k$ === void 0 && wh.set(Cc.isProcessing || h8r.useManualTiming ? Cc.timestamp : performance.now()), k$),
  set: (t) => {
    k$ = t, queueMicrotask(iCr);
  }
};
function Mve(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Pve(t, e) {
  const r = t.indexOf(e);
  r > -1 && t.splice(r, 1);
}
class Rve {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return Mve(this.subscriptions, e), () => Pve(this.subscriptions, e);
  }
  notify(e, r, n) {
    const a = this.subscriptions.length;
    if (a)
      if (a === 1)
        this.subscriptions[0](e, r, n);
      else
        for (let i = 0; i < a; i++) {
          const o = this.subscriptions[i];
          o && o(e, r, n);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function Alt(t, e) {
  return e ? t * (1e3 / e) : 0;
}
const UTe = 30, oCr = (t) => !isNaN(parseFloat(t));
class sCr {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(e, r = {}) {
    this.version = "12.4.5", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (n, a = !0) => {
      const i = wh.now();
      this.updatedAt !== i && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(n), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), a && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = r.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = wh.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = oCr(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return Ar.env.NODE_ENV !== "production" && BW(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, r) {
    this.events[e] || (this.events[e] = new Rve());
    const n = this.events[e].add(r);
    return e === "change" ? () => {
      n(), cs.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : n;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(e, r) {
    this.passiveEffect = e, this.stopPassiveEffect = r;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e, r = !0) {
    !r || !this.passiveEffect ? this.updateAndNotify(e, r) : this.passiveEffect(e, this.updateAndNotify);
  }
  setWithVelocity(e, r, n) {
    this.set(r), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - n;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, r = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, r && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = wh.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > UTe)
      return 0;
    const r = Math.min(this.updatedAt - this.prevUpdatedAt, UTe);
    return Alt(parseFloat(this.current) - parseFloat(this.prevFrameValue), r);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(e) {
    return this.stop(), new Promise((r) => {
      this.hasAnimated = !0, this.animation = e(r), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function xE(t, e) {
  return new sCr(t, e);
}
function lCr(t, e, r) {
  t.hasValue(e) ? t.getValue(e).set(r) : t.addValue(e, xE(r));
}
function cCr(t, e) {
  const r = bE(t, e);
  let { transitionEnd: n = {}, transition: a = {}, ...i } = r || {};
  i = { ...i, ...n };
  for (const o in i) {
    const s = Q8r(i[o]);
    lCr(t, o, s);
  }
}
function uCr(t) {
  return !!(Jc(t) && t.add);
}
function mde(t, e) {
  const r = t.getValue("willChange");
  if (uCr(r))
    return r.add(e);
}
function Tlt(t) {
  return t.props[dlt];
}
// @__NO_SIDE_EFFECTS__
function Ove(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const dCr = /* @__PURE__ */ Ove(() => window.ScrollTimeline !== void 0);
class fCr {
  constructor(e) {
    this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((e) => "finished" in e ? e.finished : e));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(e) {
    return this.animations[0][e];
  }
  setAll(e, r) {
    for (let n = 0; n < this.animations.length; n++)
      this.animations[n][e] = r;
  }
  attachTimeline(e, r) {
    const n = this.animations.map((a) => {
      if (dCr() && a.attachTimeline)
        return a.attachTimeline(e);
      if (typeof r == "function")
        return r(a);
    });
    return () => {
      n.forEach((a, i) => {
        a && a(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(e) {
    this.setAll("time", e);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(e) {
    this.setAll("speed", e);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let e = 0;
    for (let r = 0; r < this.animations.length; r++)
      e = Math.max(e, this.animations[r].duration);
    return e;
  }
  runAll(e) {
    this.animations.forEach((r) => r[e]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class hCr extends fCr {
  then(e, r) {
    return Promise.all(this.animations).then(e).catch(r);
  }
}
const Sh = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, Em = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3;
function Bve(t) {
  return typeof t == "function";
}
function VTe(t, e) {
  t.timeline = e, t.onfinish = null;
}
const Nve = (t) => Array.isArray(t) && typeof t[0] == "number", pCr = {
  linearEasing: void 0
};
function mCr(t, e) {
  const r = /* @__PURE__ */ Ove(t);
  return () => {
    var n;
    return (n = pCr[e]) !== null && n !== void 0 ? n : r();
  };
}
const uj = /* @__PURE__ */ mCr(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Ax = /* @__NO_SIDE_EFFECTS__ */ (t, e, r) => {
  const n = e - t;
  return n === 0 ? 1 : (r - t) / n;
}, Elt = (t, e, r = 10) => {
  let n = "";
  const a = Math.max(Math.round(e / r), 2);
  for (let i = 0; i < a; i++)
    n += t(/* @__PURE__ */ Ax(0, a - 1, i)) + ", ";
  return `linear(${n.substring(0, n.length - 2)})`;
};
function Ilt(t) {
  return !!(typeof t == "function" && uj() || !t || typeof t == "string" && (t in gde || uj()) || Nve(t) || Array.isArray(t) && t.every(Ilt));
}
const i_ = ([t, e, r, n]) => `cubic-bezier(${t}, ${e}, ${r}, ${n})`, gde = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ i_([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ i_([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ i_([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ i_([0.33, 1.53, 0.69, 0.99])
};
function Mlt(t, e) {
  if (t)
    return typeof t == "function" && uj() ? Elt(t, e) : Nve(t) ? i_(t) : Array.isArray(t) ? t.map((r) => Mlt(r, e) || gde.easeOut) : gde[t];
}
const Plt = (t, e, r) => (((1 - 3 * r + 3 * e) * t + (3 * r - 6 * e)) * t + 3 * e) * t, gCr = 1e-7, vCr = 12;
function yCr(t, e, r, n, a) {
  let i, o, s = 0;
  do
    o = e + (r - e) / 2, i = Plt(o, n, a) - t, i > 0 ? r = o : e = o;
  while (Math.abs(i) > gCr && ++s < vCr);
  return o;
}
function rP(t, e, r, n) {
  if (t === e && r === n)
    return gd;
  const a = (i) => yCr(i, 0, 1, t, r);
  return (i) => i === 0 || i === 1 ? i : Plt(a(i), e, n);
}
const Rlt = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Olt = (t) => (e) => 1 - t(1 - e), Blt = /* @__PURE__ */ rP(0.33, 1.53, 0.69, 0.99), $ve = /* @__PURE__ */ Olt(Blt), Nlt = /* @__PURE__ */ Rlt($ve), $lt = (t) => (t *= 2) < 1 ? 0.5 * $ve(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), Dve = (t) => 1 - Math.sin(Math.acos(t)), Dlt = Olt(Dve), Llt = Rlt(Dve), jlt = (t) => /^0[^.\s]+$/u.test(t);
function bCr(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || jlt(t) : !0;
}
const L_ = (t) => Math.round(t * 1e5) / 1e5, Lve = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function xCr(t) {
  return t == null;
}
const CCr = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, jve = (t, e) => (r) => !!(typeof r == "string" && CCr.test(r) && r.startsWith(t) || e && !xCr(r) && Object.prototype.hasOwnProperty.call(r, e)), Flt = (t, e, r) => (n) => {
  if (typeof n != "string")
    return n;
  const [a, i, o, s] = n.match(Lve);
  return {
    [t]: parseFloat(a),
    [e]: parseFloat(i),
    [r]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, wCr = (t) => Ym(0, 255, t), Cee = {
  ...tC,
  transform: (t) => Math.round(wCr(t))
}, gb = {
  test: /* @__PURE__ */ jve("rgb", "red"),
  parse: /* @__PURE__ */ Flt("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: r, alpha: n = 1 }) => "rgba(" + Cee.transform(t) + ", " + Cee.transform(e) + ", " + Cee.transform(r) + ", " + L_(yE.transform(n)) + ")"
};
function SCr(t) {
  let e = "", r = "", n = "", a = "";
  return t.length > 5 ? (e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7), a = t.substring(7, 9)) : (e = t.substring(1, 2), r = t.substring(2, 3), n = t.substring(3, 4), a = t.substring(4, 5), e += e, r += r, n += n, a += a), {
    red: parseInt(e, 16),
    green: parseInt(r, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const vde = {
  test: /* @__PURE__ */ jve("#"),
  parse: SCr,
  transform: gb.transform
}, W9 = {
  test: /* @__PURE__ */ jve("hsl", "hue"),
  parse: /* @__PURE__ */ Flt("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: r, alpha: n = 1 }) => "hsla(" + Math.round(t) + ", " + Ch.transform(L_(e)) + ", " + Ch.transform(L_(r)) + ", " + L_(yE.transform(n)) + ")"
}, Hc = {
  test: (t) => gb.test(t) || vde.test(t) || W9.test(t),
  parse: (t) => gb.test(t) ? gb.parse(t) : W9.test(t) ? W9.parse(t) : vde.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? gb.transform(t) : W9.transform(t)
}, _Cr = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function kCr(t) {
  var e, r;
  return isNaN(t) && typeof t == "string" && (((e = t.match(Lve)) === null || e === void 0 ? void 0 : e.length) || 0) + (((r = t.match(_Cr)) === null || r === void 0 ? void 0 : r.length) || 0) > 0;
}
const zlt = "number", Glt = "color", ACr = "var", TCr = "var(", qTe = "${}", ECr = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function CE(t) {
  const e = t.toString(), r = [], n = {
    color: [],
    number: [],
    var: []
  }, a = [];
  let i = 0;
  const s = e.replace(ECr, (l) => (Hc.test(l) ? (n.color.push(i), a.push(Glt), r.push(Hc.parse(l))) : l.startsWith(TCr) ? (n.var.push(i), a.push(ACr), r.push(l)) : (n.number.push(i), a.push(zlt), r.push(parseFloat(l))), ++i, qTe)).split(qTe);
  return { values: r, split: s, indexes: n, types: a };
}
function Wlt(t) {
  return CE(t).values;
}
function Hlt(t) {
  const { split: e, types: r } = CE(t), n = e.length;
  return (a) => {
    let i = "";
    for (let o = 0; o < n; o++)
      if (i += e[o], a[o] !== void 0) {
        const s = r[o];
        s === zlt ? i += L_(a[o]) : s === Glt ? i += Hc.transform(a[o]) : i += a[o];
      }
    return i;
  };
}
const ICr = (t) => typeof t == "number" ? 0 : t;
function MCr(t) {
  const e = Wlt(t);
  return Hlt(t)(e.map(ICr));
}
const Sy = {
  test: kCr,
  parse: Wlt,
  createTransformer: Hlt,
  getAnimatableNone: MCr
}, PCr = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function RCr(t) {
  const [e, r] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [n] = r.match(Lve) || [];
  if (!n)
    return t;
  const a = r.replace(n, "");
  let i = PCr.has(e) ? 1 : 0;
  return n !== r && (i *= 100), e + "(" + i + a + ")";
}
const OCr = /\b([a-z-]*)\(.*?\)/gu, yde = {
  ...Sy,
  getAnimatableNone: (t) => {
    const e = t.match(OCr);
    return e ? e.map(RCr).join(" ") : t;
  }
}, BCr = {
  ...Cve,
  // Color props
  color: Hc,
  backgroundColor: Hc,
  outlineColor: Hc,
  fill: Hc,
  stroke: Hc,
  // Border props
  borderColor: Hc,
  borderTopColor: Hc,
  borderRightColor: Hc,
  borderBottomColor: Hc,
  borderLeftColor: Hc,
  filter: yde,
  WebkitFilter: yde
}, Fve = (t) => BCr[t];
function Ult(t, e) {
  let r = Fve(t);
  return r !== yde && (r = Sy), r.getAnimatableNone ? r.getAnimatableNone(e) : void 0;
}
const NCr = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function $Cr(t, e, r) {
  let n = 0, a;
  for (; n < t.length && !a; ) {
    const i = t[n];
    typeof i == "string" && !NCr.has(i) && CE(i).values.length && (a = t[n]), n++;
  }
  if (a && r)
    for (const i of e)
      t[i] = Ult(r, a);
}
const KTe = (t) => t === tC || t === ca, ZTe = (t, e) => parseFloat(t.split(", ")[e]), JTe = (t, e) => (r, { transform: n }) => {
  if (n === "none" || !n)
    return 0;
  const a = n.match(/^matrix3d\((.+)\)$/u);
  if (a)
    return ZTe(a[1], e);
  {
    const i = n.match(/^matrix\((.+)\)$/u);
    return i ? ZTe(i[1], t) : 0;
  }
}, DCr = /* @__PURE__ */ new Set(["x", "y", "z"]), LCr = eC.filter((t) => !DCr.has(t));
function jCr(t) {
  const e = [];
  return LCr.forEach((r) => {
    const n = t.getValue(r);
    n !== void 0 && (e.push([r, n.get()]), n.set(r.startsWith("scale") ? 1 : 0));
  }), e;
}
const Tx = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: r = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(r),
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: r = "0" }) => t.max - t.min - parseFloat(e) - parseFloat(r),
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: JTe(4, 13),
  y: JTe(5, 14)
};
Tx.translateX = Tx.x;
Tx.translateY = Tx.y;
const Fb = /* @__PURE__ */ new Set();
let bde = !1, xde = !1;
function Vlt() {
  if (xde) {
    const t = Array.from(Fb).filter((n) => n.needsMeasurement), e = new Set(t.map((n) => n.element)), r = /* @__PURE__ */ new Map();
    e.forEach((n) => {
      const a = jCr(n);
      a.length && (r.set(n, a), n.render());
    }), t.forEach((n) => n.measureInitialState()), e.forEach((n) => {
      n.render();
      const a = r.get(n);
      a && a.forEach(([i, o]) => {
        var s;
        (s = n.getValue(i)) === null || s === void 0 || s.set(o);
      });
    }), t.forEach((n) => n.measureEndState()), t.forEach((n) => {
      n.suspendedScrollY !== void 0 && window.scrollTo(0, n.suspendedScrollY);
    });
  }
  xde = !1, bde = !1, Fb.forEach((t) => t.complete()), Fb.clear();
}
function qlt() {
  Fb.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (xde = !0);
  });
}
function FCr() {
  qlt(), Vlt();
}
class zve {
  constructor(e, r, n, a, i, o = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = r, this.name = n, this.motionValue = a, this.element = i, this.isAsync = o;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? (Fb.add(this), bde || (bde = !0, cs.read(qlt), cs.resolveKeyframes(Vlt))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: r, element: n, motionValue: a } = this;
    for (let i = 0; i < e.length; i++)
      if (e[i] === null)
        if (i === 0) {
          const o = a == null ? void 0 : a.get(), s = e[e.length - 1];
          if (o !== void 0)
            e[0] = o;
          else if (n && r) {
            const l = n.readValue(r, s);
            l != null && (e[0] = l);
          }
          e[0] === void 0 && (e[0] = s), a && o === void 0 && a.set(e[0]);
        } else
          e[i] = e[i - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), Fb.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, Fb.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const Klt = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), zCr = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function GCr(t) {
  const e = zCr.exec(t);
  if (!e)
    return [,];
  const [, r, n, a] = e;
  return [`--${r ?? n}`, a];
}
const WCr = 4;
function Zlt(t, e, r = 1) {
  Cy(r <= WCr, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
  const [n, a] = GCr(t);
  if (!n)
    return;
  const i = window.getComputedStyle(e).getPropertyValue(n);
  if (i) {
    const o = i.trim();
    return Klt(o) ? parseFloat(o) : o;
  }
  return xve(a) ? Zlt(a, e, r + 1) : a;
}
const Jlt = (t) => (e) => e.test(t), HCr = {
  test: (t) => t === "auto",
  parse: (t) => t
}, Ylt = [tC, ca, Ch, cv, $8r, N8r, HCr], YTe = (t) => Ylt.find(Jlt(t));
class Xlt extends zve {
  constructor(e, r, n, a, i) {
    super(e, r, n, a, i, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: r, name: n } = this;
    if (!r || !r.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < e.length; l++) {
      let c = e[l];
      if (typeof c == "string" && (c = c.trim(), xve(c))) {
        const u = Zlt(c, r.current);
        u !== void 0 && (e[l] = u), l === e.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !klt.has(n) || e.length !== 2)
      return;
    const [a, i] = e, o = YTe(a), s = YTe(i);
    if (o !== s)
      if (KTe(o) && KTe(s))
        for (let l = 0; l < e.length; l++) {
          const c = e[l];
          typeof c == "string" && (e[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: r } = this, n = [];
    for (let a = 0; a < e.length; a++)
      bCr(e[a]) && n.push(a);
    n.length && $Cr(e, n, r);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: r, name: n } = this;
    if (!e || !e.current)
      return;
    n === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = Tx[n](e.measureViewportBox(), window.getComputedStyle(e.current)), r[0] = this.measuredOrigin;
    const a = r[r.length - 1];
    a !== void 0 && e.getValue(n, a).jump(a, !1);
  }
  measureEndState() {
    var e;
    const { element: r, name: n, unresolvedKeyframes: a } = this;
    if (!r || !r.current)
      return;
    const i = r.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const o = a.length - 1, s = a[o];
    a[o] = Tx[n](r.measureViewportBox(), window.getComputedStyle(r.current)), s !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = s), !((e = this.removedTransforms) === null || e === void 0) && e.length && this.removedTransforms.forEach(([l, c]) => {
      r.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const XTe = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(Sy.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function UCr(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let r = 0; r < t.length; r++)
    if (t[r] !== e)
      return !0;
}
function VCr(t, e, r, n) {
  const a = t[0];
  if (a === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const i = t[t.length - 1], o = XTe(a, e), s = XTe(i, e);
  return Q8(o === s, `You are trying to animate ${e} from "${a}" to "${i}". ${a} is not an animatable value - to enable this animation set ${a} to a value animatable to ${i} via the \`style\` property.`), !o || !s ? !1 : UCr(t) || (r === "spring" || Bve(r)) && n;
}
const qCr = (t) => t !== null;
function LW(t, { repeat: e, repeatType: r = "loop" }, n) {
  const a = t.filter(qCr), i = e && r !== "loop" && e % 2 === 1 ? 0 : a.length - 1;
  return !i || n === void 0 ? a[i] : n;
}
const KCr = 40;
class Qlt {
  constructor({ autoplay: e = !0, delay: r = 0, type: n = "keyframes", repeat: a = 0, repeatDelay: i = 0, repeatType: o = "loop", ...s }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = wh.now(), this.options = {
      autoplay: e,
      delay: r,
      type: n,
      repeat: a,
      repeatDelay: i,
      repeatType: o,
      ...s
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > KCr ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && FCr(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(e, r) {
    this.resolvedAt = wh.now(), this.hasAttemptedResolve = !0;
    const { name: n, type: a, velocity: i, delay: o, onComplete: s, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !VCr(e, n, a, i))
      if (o)
        this.options.duration = 0;
      else {
        l && l(LW(e, this.options, r)), s && s(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(e, r);
    u !== !1 && (this._resolved = {
      keyframes: e,
      finalKeyframe: r,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, r) {
    return this.currentFinishedPromise.then(e, r);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((e) => {
      this.resolveFinishedPromise = e;
    });
  }
}
const Cde = 2e4;
function ect(t) {
  let e = 0;
  const r = 50;
  let n = t.next(e);
  for (; !n.done && e < Cde; )
    e += r, n = t.next(e);
  return e >= Cde ? 1 / 0 : e;
}
const $s = (t, e, r) => t + (e - t) * r;
function wee(t, e, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + (e - t) * 6 * r : r < 1 / 2 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}
function ZCr({ hue: t, saturation: e, lightness: r, alpha: n }) {
  t /= 360, e /= 100, r /= 100;
  let a = 0, i = 0, o = 0;
  if (!e)
    a = i = o = r;
  else {
    const s = r < 0.5 ? r * (1 + e) : r + e - r * e, l = 2 * r - s;
    a = wee(l, s, t + 1 / 3), i = wee(l, s, t), o = wee(l, s, t - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(i * 255),
    blue: Math.round(o * 255),
    alpha: n
  };
}
function dj(t, e) {
  return (r) => r > 0 ? e : t;
}
const See = (t, e, r) => {
  const n = t * t, a = r * (e * e - n) + n;
  return a < 0 ? 0 : Math.sqrt(a);
}, JCr = [vde, gb, W9], YCr = (t) => JCr.find((e) => e.test(t));
function QTe(t) {
  const e = YCr(t);
  if (Q8(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`), !e)
    return !1;
  let r = e.parse(t);
  return e === W9 && (r = ZCr(r)), r;
}
const eEe = (t, e) => {
  const r = QTe(t), n = QTe(e);
  if (!r || !n)
    return dj(t, e);
  const a = { ...r };
  return (i) => (a.red = See(r.red, n.red, i), a.green = See(r.green, n.green, i), a.blue = See(r.blue, n.blue, i), a.alpha = $s(r.alpha, n.alpha, i), gb.transform(a));
}, XCr = (t, e) => (r) => e(t(r)), nP = (...t) => t.reduce(XCr), wde = /* @__PURE__ */ new Set(["none", "hidden"]);
function QCr(t, e) {
  return wde.has(t) ? (r) => r <= 0 ? t : e : (r) => r >= 1 ? e : t;
}
function ewr(t, e) {
  return (r) => $s(t, e, r);
}
function Gve(t) {
  return typeof t == "number" ? ewr : typeof t == "string" ? xve(t) ? dj : Hc.test(t) ? eEe : nwr : Array.isArray(t) ? tct : typeof t == "object" ? Hc.test(t) ? eEe : twr : dj;
}
function tct(t, e) {
  const r = [...t], n = r.length, a = t.map((i, o) => Gve(i)(i, e[o]));
  return (i) => {
    for (let o = 0; o < n; o++)
      r[o] = a[o](i);
    return r;
  };
}
function twr(t, e) {
  const r = { ...t, ...e }, n = {};
  for (const a in r)
    t[a] !== void 0 && e[a] !== void 0 && (n[a] = Gve(t[a])(t[a], e[a]));
  return (a) => {
    for (const i in n)
      r[i] = n[i](a);
    return r;
  };
}
function rwr(t, e) {
  var r;
  const n = [], a = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < e.values.length; i++) {
    const o = e.types[i], s = t.indexes[o][a[o]], l = (r = t.values[s]) !== null && r !== void 0 ? r : 0;
    n[i] = l, a[o]++;
  }
  return n;
}
const nwr = (t, e) => {
  const r = Sy.createTransformer(e), n = CE(t), a = CE(e);
  return n.indexes.var.length === a.indexes.var.length && n.indexes.color.length === a.indexes.color.length && n.indexes.number.length >= a.indexes.number.length ? wde.has(t) && !a.values.length || wde.has(e) && !n.values.length ? QCr(t, e) : nP(tct(rwr(n, a), a.values), r) : (Q8(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), dj(t, e));
};
function rct(t, e, r) {
  return typeof t == "number" && typeof e == "number" && typeof r == "number" ? $s(t, e, r) : Gve(t)(t, e);
}
const awr = 5;
function nct(t, e, r) {
  const n = Math.max(e - awr, 0);
  return Alt(r - t(n), e - n);
}
const Bs = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, tEe = 1e-3;
function iwr({ duration: t = Bs.duration, bounce: e = Bs.bounce, velocity: r = Bs.velocity, mass: n = Bs.mass }) {
  let a, i;
  Q8(t <= /* @__PURE__ */ Sh(Bs.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - e;
  o = Ym(Bs.minDamping, Bs.maxDamping, o), t = Ym(Bs.minDuration, Bs.maxDuration, /* @__PURE__ */ Em(t)), o < 1 ? (a = (c) => {
    const u = c * o, f = u * t, h = u - r, p = Sde(c, o), g = Math.exp(-f);
    return tEe - h / p * g;
  }, i = (c) => {
    const f = c * o * t, h = f * r + r, p = Math.pow(o, 2) * Math.pow(c, 2) * t, g = Math.exp(-f), y = Sde(Math.pow(c, 2), o);
    return (-a(c) + tEe > 0 ? -1 : 1) * ((h - p) * g) / y;
  }) : (a = (c) => {
    const u = Math.exp(-c * t), f = (c - r) * t + 1;
    return -1e-3 + u * f;
  }, i = (c) => {
    const u = Math.exp(-c * t), f = (r - c) * (t * t);
    return u * f;
  });
  const s = 5 / t, l = swr(a, i, s);
  if (t = /* @__PURE__ */ Sh(t), isNaN(l))
    return {
      stiffness: Bs.stiffness,
      damping: Bs.damping,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * n;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(n * c),
      duration: t
    };
  }
}
const owr = 12;
function swr(t, e, r) {
  let n = r;
  for (let a = 1; a < owr; a++)
    n = n - t(n) / e(n);
  return n;
}
function Sde(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const lwr = ["duration", "bounce"], cwr = ["stiffness", "damping", "mass"];
function rEe(t, e) {
  return e.some((r) => t[r] !== void 0);
}
function uwr(t) {
  let e = {
    velocity: Bs.velocity,
    stiffness: Bs.stiffness,
    damping: Bs.damping,
    mass: Bs.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!rEe(t, cwr) && rEe(t, lwr))
    if (t.visualDuration) {
      const r = t.visualDuration, n = 2 * Math.PI / (r * 1.2), a = n * n, i = 2 * Ym(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(a);
      e = {
        ...e,
        mass: Bs.mass,
        stiffness: a,
        damping: i
      };
    } else {
      const r = iwr(t);
      e = {
        ...e,
        ...r,
        mass: Bs.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function act(t = Bs.visualDuration, e = Bs.bounce) {
  const r = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: n, restDelta: a } = r;
  const i = r.keyframes[0], o = r.keyframes[r.keyframes.length - 1], s = { done: !1, value: i }, { stiffness: l, damping: c, mass: u, duration: f, velocity: h, isResolvedFromDuration: p } = uwr({
    ...r,
    velocity: -/* @__PURE__ */ Em(r.velocity || 0)
  }), g = h || 0, y = c / (2 * Math.sqrt(l * u)), b = o - i, w = /* @__PURE__ */ Em(Math.sqrt(l / u)), _ = Math.abs(b) < 5;
  n || (n = _ ? Bs.restSpeed.granular : Bs.restSpeed.default), a || (a = _ ? Bs.restDelta.granular : Bs.restDelta.default);
  let C;
  if (y < 1) {
    const S = Sde(w, y);
    C = (A) => {
      const I = Math.exp(-y * w * A);
      return o - I * ((g + y * w * b) / S * Math.sin(S * A) + b * Math.cos(S * A));
    };
  } else if (y === 1)
    C = (S) => o - Math.exp(-w * S) * (b + (g + w * b) * S);
  else {
    const S = w * Math.sqrt(y * y - 1);
    C = (A) => {
      const I = Math.exp(-y * w * A), M = Math.min(S * A, 300);
      return o - I * ((g + y * w * b) * Math.sinh(M) + S * b * Math.cosh(M)) / S;
    };
  }
  const x = {
    calculatedDuration: p && f || null,
    next: (S) => {
      const A = C(S);
      if (p)
        s.done = S >= f;
      else {
        let I = 0;
        y < 1 && (I = S === 0 ? /* @__PURE__ */ Sh(g) : nct(C, S, A));
        const M = Math.abs(I) <= n, B = Math.abs(o - A) <= a;
        s.done = M && B;
      }
      return s.value = s.done ? o : A, s;
    },
    toString: () => {
      const S = Math.min(ect(x), Cde), A = Elt((I) => x.next(S * I).value, S, 30);
      return S + "ms " + A;
    }
  };
  return x;
}
function nEe({ keyframes: t, velocity: e = 0, power: r = 0.8, timeConstant: n = 325, bounceDamping: a = 10, bounceStiffness: i = 500, modifyTarget: o, min: s, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const f = t[0], h = {
    done: !1,
    value: f
  }, p = (M) => s !== void 0 && M < s || l !== void 0 && M > l, g = (M) => s === void 0 ? l : l === void 0 || Math.abs(s - M) < Math.abs(l - M) ? s : l;
  let y = r * e;
  const b = f + y, w = o === void 0 ? b : o(b);
  w !== b && (y = w - f);
  const _ = (M) => -y * Math.exp(-M / n), C = (M) => w + _(M), x = (M) => {
    const B = _(M), L = C(M);
    h.done = Math.abs(B) <= c, h.value = h.done ? w : L;
  };
  let S, A;
  const I = (M) => {
    p(h.value) && (S = M, A = act({
      keyframes: [h.value, g(h.value)],
      velocity: nct(C, M, h.value),
      // TODO: This should be passing * 1000
      damping: a,
      stiffness: i,
      restDelta: c,
      restSpeed: u
    }));
  };
  return I(0), {
    calculatedDuration: null,
    next: (M) => {
      let B = !1;
      return !A && S === void 0 && (B = !0, x(M), I(M)), S !== void 0 && M >= S ? A.next(M - S) : (!B && x(M), h);
    }
  };
}
const dwr = /* @__PURE__ */ rP(0.42, 0, 1, 1), fwr = /* @__PURE__ */ rP(0, 0, 0.58, 1), ict = /* @__PURE__ */ rP(0.42, 0, 0.58, 1), hwr = (t) => Array.isArray(t) && typeof t[0] != "number", aEe = {
  linear: gd,
  easeIn: dwr,
  easeInOut: ict,
  easeOut: fwr,
  circIn: Dve,
  circInOut: Llt,
  circOut: Dlt,
  backIn: $ve,
  backInOut: Nlt,
  backOut: Blt,
  anticipate: $lt
}, iEe = (t) => {
  if (Nve(t)) {
    Cy(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [e, r, n, a] = t;
    return rP(e, r, n, a);
  } else if (typeof t == "string")
    return Cy(aEe[t] !== void 0, `Invalid easing type '${t}'`), aEe[t];
  return t;
};
function pwr(t, e, r) {
  const n = [], a = r || rct, i = t.length - 1;
  for (let o = 0; o < i; o++) {
    let s = a(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || gd : e;
      s = nP(l, s);
    }
    n.push(s);
  }
  return n;
}
function mwr(t, e, { clamp: r = !0, ease: n, mixer: a } = {}) {
  const i = t.length;
  if (Cy(i === e.length, "Both input and output ranges must be the same length"), i === 1)
    return () => e[0];
  if (i === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[i - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const s = pwr(e, n, a), l = s.length, c = (u) => {
    if (o && u < t[0])
      return e[0];
    let f = 0;
    if (l > 1)
      for (; f < t.length - 2 && !(u < t[f + 1]); f++)
        ;
    const h = /* @__PURE__ */ Ax(t[f], t[f + 1], u);
    return s[f](h);
  };
  return r ? (u) => c(Ym(t[0], t[i - 1], u)) : c;
}
function gwr(t, e) {
  const r = t[t.length - 1];
  for (let n = 1; n <= e; n++) {
    const a = /* @__PURE__ */ Ax(0, e, n);
    t.push($s(r, 1, a));
  }
}
function vwr(t) {
  const e = [0];
  return gwr(e, t.length - 1), e;
}
function ywr(t, e) {
  return t.map((r) => r * e);
}
function bwr(t, e) {
  return t.map(() => e || ict).splice(0, t.length - 1);
}
function j_({ duration: t = 300, keyframes: e, times: r, ease: n = "easeInOut" }) {
  const a = hwr(n) ? n.map(iEe) : iEe(n), i = {
    done: !1,
    value: e[0]
  }, o = ywr(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    r && r.length === e.length ? r : vwr(e),
    t
  ), s = mwr(o, e, {
    ease: Array.isArray(a) ? a : bwr(e, a)
  });
  return {
    calculatedDuration: t,
    next: (l) => (i.value = s(l), i.done = l >= t, i)
  };
}
const xwr = (t) => {
  const e = ({ timestamp: r }) => t(r);
  return {
    start: () => cs.update(e, !0),
    stop: () => wy(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => Cc.isProcessing ? Cc.timestamp : wh.now()
  };
}, Cwr = {
  decay: nEe,
  inertia: nEe,
  tween: j_,
  keyframes: j_,
  spring: act
}, wwr = (t) => t / 100;
class Wve extends Qlt {
  constructor(e) {
    super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: r, motionValue: n, element: a, keyframes: i } = this.options, o = (a == null ? void 0 : a.KeyframeResolver) || zve, s = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new o(i, s, r, n, a), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(e) {
    const { type: r = "keyframes", repeat: n = 0, repeatDelay: a = 0, repeatType: i, velocity: o = 0 } = this.options, s = Bve(r) ? r : Cwr[r] || j_;
    let l, c;
    Ar.env.NODE_ENV !== "production" && s !== j_ && Cy(e.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`), s !== j_ && typeof e[0] != "number" && (l = nP(wwr, rct(e[0], e[1])), e = [0, 100]);
    const u = s({ ...this.options, keyframes: e });
    i === "mirror" && (c = s({
      ...this.options,
      keyframes: [...e].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = ect(u));
    const { calculatedDuration: f } = u, h = f + a, p = h * (n + 1) - a;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: f,
      resolvedDuration: h,
      totalDuration: p
    };
  }
  onPostResolved() {
    const { autoplay: e = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !e ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(e, r = !1) {
    const { resolved: n } = this;
    if (!n) {
      const { keyframes: M } = this.options;
      return { done: !0, value: M[M.length - 1] };
    }
    const { finalKeyframe: a, generator: i, mirroredGenerator: o, mapPercentToKeyframes: s, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: f } = n;
    if (this.startTime === null)
      return i.next(0);
    const { delay: h, repeat: p, repeatType: g, repeatDelay: y, onUpdate: b } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - u / this.speed, this.startTime)), r ? this.currentTime = e : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
    const w = this.currentTime - h * (this.speed >= 0 ? 1 : -1), _ = this.speed >= 0 ? w < 0 : w > u;
    this.currentTime = Math.max(w, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let C = this.currentTime, x = i;
    if (p) {
      const M = Math.min(this.currentTime, u) / f;
      let B = Math.floor(M), L = M % 1;
      !L && M >= 1 && (L = 1), L === 1 && B--, B = Math.min(B, p + 1), !!(B % 2) && (g === "reverse" ? (L = 1 - L, y && (L -= y / f)) : g === "mirror" && (x = o)), C = Ym(0, 1, L) * f;
    }
    const S = _ ? { done: !1, value: l[0] } : x.next(C);
    s && (S.value = s(S.value));
    let { done: A } = S;
    !_ && c !== null && (A = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const I = this.holdTime === null && (this.state === "finished" || this.state === "running" && A);
    return I && a !== void 0 && (S.value = LW(l, this.options, a)), b && b(S.value), I && this.finish(), S;
  }
  get duration() {
    const { resolved: e } = this;
    return e ? /* @__PURE__ */ Em(e.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ Em(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ Sh(e), this.currentTime = e, this.holdTime !== null || this.speed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const r = this.playbackSpeed !== e;
    this.playbackSpeed = e, r && (this.time = /* @__PURE__ */ Em(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: e = xwr, onPlay: r, startTime: n } = this.options;
    this.driver || (this.driver = e((i) => this.tick(i))), r && r();
    const a = this.driver.now();
    this.holdTime !== null ? this.startTime = a - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = a) : this.startTime = n ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var e;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (e = this.currentTime) !== null && e !== void 0 ? e : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: e } = this.options;
    e && e();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
}
const Swr = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function _wr(t, e, r, { delay: n = 0, duration: a = 300, repeat: i = 0, repeatType: o = "loop", ease: s = "easeInOut", times: l } = {}) {
  const c = { [e]: r };
  l && (c.offset = l);
  const u = Mlt(s, a);
  return Array.isArray(u) && (c.easing = u), t.animate(c, {
    delay: n,
    duration: a,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: i + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  });
}
const kwr = /* @__PURE__ */ Ove(() => Object.hasOwnProperty.call(Element.prototype, "animate")), fj = 10, Awr = 2e4;
function Twr(t) {
  return Bve(t.type) || t.type === "spring" || !Ilt(t.ease);
}
function Ewr(t, e) {
  const r = new Wve({
    ...e,
    keyframes: t,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let n = { done: !1, value: t[0] };
  const a = [];
  let i = 0;
  for (; !n.done && i < Awr; )
    n = r.sample(i), a.push(n.value), i += fj;
  return {
    times: void 0,
    keyframes: a,
    duration: i - fj,
    ease: "linear"
  };
}
const oct = {
  anticipate: $lt,
  backInOut: Nlt,
  circInOut: Llt
};
function Iwr(t) {
  return t in oct;
}
class oEe extends Qlt {
  constructor(e) {
    super(e);
    const { name: r, motionValue: n, element: a, keyframes: i } = this.options;
    this.resolver = new Xlt(i, (o, s) => this.onKeyframesResolved(o, s), r, n, a), this.resolver.scheduleResolve();
  }
  initPlayback(e, r) {
    let { duration: n = 300, times: a, ease: i, type: o, motionValue: s, name: l, startTime: c } = this.options;
    if (!s.owner || !s.owner.current)
      return !1;
    if (typeof i == "string" && uj() && Iwr(i) && (i = oct[i]), Twr(this.options)) {
      const { onComplete: f, onUpdate: h, motionValue: p, element: g, ...y } = this.options, b = Ewr(e, y);
      e = b.keyframes, e.length === 1 && (e[1] = e[0]), n = b.duration, a = b.times, i = b.ease, o = "keyframes";
    }
    const u = _wr(s.owner.current, l, e, { ...this.options, duration: n, times: a, ease: i });
    return u.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (VTe(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: f } = this.options;
      s.set(LW(e, this.options, r)), f && f(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: n,
      times: a,
      type: o,
      ease: i,
      keyframes: e
    };
  }
  get duration() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { duration: r } = e;
    return /* @__PURE__ */ Em(r);
  }
  get time() {
    const { resolved: e } = this;
    if (!e)
      return 0;
    const { animation: r } = e;
    return /* @__PURE__ */ Em(r.currentTime || 0);
  }
  set time(e) {
    const { resolved: r } = this;
    if (!r)
      return;
    const { animation: n } = r;
    n.currentTime = /* @__PURE__ */ Sh(e);
  }
  get speed() {
    const { resolved: e } = this;
    if (!e)
      return 1;
    const { animation: r } = e;
    return r.playbackRate;
  }
  set speed(e) {
    const { resolved: r } = this;
    if (!r)
      return;
    const { animation: n } = r;
    n.playbackRate = e;
  }
  get state() {
    const { resolved: e } = this;
    if (!e)
      return "idle";
    const { animation: r } = e;
    return r.playState;
  }
  get startTime() {
    const { resolved: e } = this;
    if (!e)
      return null;
    const { animation: r } = e;
    return r.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(e) {
    if (!this._resolved)
      this.pendingTimeline = e;
    else {
      const { resolved: r } = this;
      if (!r)
        return gd;
      const { animation: n } = r;
      VTe(n, e);
    }
    return gd;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: r } = e;
    r.playState === "finished" && this.updateFinishedPromise(), r.play();
  }
  pause() {
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: r } = e;
    r.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: e } = this;
    if (!e)
      return;
    const { animation: r, keyframes: n, duration: a, type: i, ease: o, times: s } = e;
    if (r.playState === "idle" || r.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: f, element: h, ...p } = this.options, g = new Wve({
        ...p,
        keyframes: n,
        duration: a,
        type: i,
        ease: o,
        times: s,
        isGenerator: !0
      }), y = /* @__PURE__ */ Sh(this.time);
      c.setWithVelocity(g.sample(y - fj).value, g.sample(y).value, fj);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: e } = this;
    e && e.animation.finish();
  }
  cancel() {
    const { resolved: e } = this;
    e && e.animation.cancel();
  }
  static supports(e) {
    const { motionValue: r, name: n, repeatDelay: a, repeatType: i, damping: o, type: s } = e;
    if (!r || !r.owner || !(r.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: l, transformTemplate: c } = r.owner.getProps();
    return kwr() && n && Swr.has(n) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !l && !c && !a && i !== "mirror" && o !== 0 && s !== "inertia";
  }
}
const Mwr = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Pwr = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Rwr = {
  type: "keyframes",
  duration: 0.8
}, Owr = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, Bwr = (t, { keyframes: e }) => e.length > 2 ? Rwr : v6.has(t) ? t.startsWith("scale") ? Pwr(e[1]) : Mwr : Owr;
function Nwr({ when: t, delay: e, delayChildren: r, staggerChildren: n, staggerDirection: a, repeat: i, repeatType: o, repeatDelay: s, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const Hve = (t, e, r, n = {}, a, i) => (o) => {
  const s = Ive(n, t) || {}, l = s.delay || n.delay || 0;
  let { elapsed: c = 0 } = n;
  c = c - /* @__PURE__ */ Sh(l);
  let u = {
    keyframes: Array.isArray(r) ? r : [null, r],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...s,
    delay: -c,
    onUpdate: (h) => {
      e.set(h), s.onUpdate && s.onUpdate(h);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: t,
    motionValue: e,
    element: i ? void 0 : a
  };
  Nwr(s) || (u = {
    ...u,
    ...Bwr(t, u)
  }), u.duration && (u.duration = /* @__PURE__ */ Sh(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Sh(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (f = !0)), f && !i && e.get() !== void 0) {
    const h = LW(u.keyframes, s);
    if (h !== void 0)
      return cs.update(() => {
        u.onUpdate(h), u.onComplete();
      }), new hCr([]);
  }
  return !i && oEe.supports(u) ? new oEe(u) : new Wve(u);
};
function $wr({ protectedKeys: t, needsAnimating: e }, r) {
  const n = t.hasOwnProperty(r) && e[r] !== !0;
  return e[r] = !1, n;
}
function sct(t, e, { delay: r = 0, transitionOverride: n, type: a } = {}) {
  var i;
  let { transition: o = t.getDefaultTransition(), transitionEnd: s, ...l } = e;
  n && (o = n);
  const c = [], u = a && t.animationState && t.animationState.getState()[a];
  for (const f in l) {
    const h = t.getValue(f, (i = t.latestValues[f]) !== null && i !== void 0 ? i : null), p = l[f];
    if (p === void 0 || u && $wr(u, f))
      continue;
    const g = {
      delay: r,
      ...Ive(o || {}, f)
    };
    let y = !1;
    if (window.MotionHandoffAnimation) {
      const w = Tlt(t);
      if (w) {
        const _ = window.MotionHandoffAnimation(w, f, cs);
        _ !== null && (g.startTime = _, y = !0);
      }
    }
    mde(t, f), h.start(Hve(f, h, p, t.shouldReduceMotion && klt.has(f) ? { type: !1 } : g, t, y));
    const b = h.animation;
    b && c.push(b);
  }
  return s && Promise.all(c).then(() => {
    cs.update(() => {
      s && cCr(t, s);
    });
  }), c;
}
function _de(t, e, r = {}) {
  var n;
  const a = bE(t, e, r.type === "exit" ? (n = t.presenceContext) === null || n === void 0 ? void 0 : n.custom : void 0);
  let { transition: i = t.getDefaultTransition() || {} } = a || {};
  r.transitionOverride && (i = r.transitionOverride);
  const o = a ? () => Promise.all(sct(t, a, r)) : () => Promise.resolve(), s = t.variantChildren && t.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: h } = i;
    return Dwr(t, e, u + c, f, h, r);
  } : () => Promise.resolve(), { when: l } = i;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [o, s] : [s, o];
    return c().then(() => u());
  } else
    return Promise.all([o(), s(r.delay)]);
}
function Dwr(t, e, r = 0, n = 0, a = 1, i) {
  const o = [], s = (t.variantChildren.size - 1) * n, l = a === 1 ? (c = 0) => c * n : (c = 0) => s - c * n;
  return Array.from(t.variantChildren).sort(Lwr).forEach((c, u) => {
    c.notify("AnimationStart", e), o.push(_de(c, e, {
      ...i,
      delay: r + l(u)
    }).then(() => c.notify("AnimationComplete", e)));
  }), Promise.all(o);
}
function Lwr(t, e) {
  return t.sortNodePosition(e);
}
function jwr(t, e, r = {}) {
  t.notify("AnimationStart", e);
  let n;
  if (Array.isArray(e)) {
    const a = e.map((i) => _de(t, i, r));
    n = Promise.all(a);
  } else if (typeof e == "string")
    n = _de(t, e, r);
  else {
    const a = typeof e == "function" ? bE(t, e, r.custom) : e;
    n = Promise.all(sct(t, a, r));
  }
  return n.then(() => {
    t.notify("AnimationComplete", e);
  });
}
function lct(t, e) {
  if (!Array.isArray(e))
    return !1;
  const r = e.length;
  if (r !== t.length)
    return !1;
  for (let n = 0; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
const Fwr = gve.length;
function cct(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const r = t.parent ? cct(t.parent) || {} : {};
    return t.props.initial !== void 0 && (r.initial = t.props.initial), r;
  }
  const e = {};
  for (let r = 0; r < Fwr; r++) {
    const n = gve[r], a = t.props[n];
    (gE(a) || a === !1) && (e[n] = a);
  }
  return e;
}
const zwr = [...mve].reverse(), Gwr = mve.length;
function Wwr(t) {
  return (e) => Promise.all(e.map(({ animation: r, options: n }) => jwr(t, r, n)));
}
function Hwr(t) {
  let e = Wwr(t), r = sEe(), n = !0;
  const a = (l) => (c, u) => {
    var f;
    const h = bE(t, u, l === "exit" ? (f = t.presenceContext) === null || f === void 0 ? void 0 : f.custom : void 0);
    if (h) {
      const { transition: p, transitionEnd: g, ...y } = h;
      c = { ...c, ...y, ...g };
    }
    return c;
  };
  function i(l) {
    e = l(t);
  }
  function o(l) {
    const { props: c } = t, u = cct(t.parent) || {}, f = [], h = /* @__PURE__ */ new Set();
    let p = {}, g = 1 / 0;
    for (let b = 0; b < Gwr; b++) {
      const w = zwr[b], _ = r[w], C = c[w] !== void 0 ? c[w] : u[w], x = gE(C), S = w === l ? _.isActive : null;
      S === !1 && (g = b);
      let A = C === u[w] && C !== c[w] && x;
      if (A && n && t.manuallyAnimateOnMount && (A = !1), _.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !_.isActive && S === null || // If we didn't and don't have any defined prop for this animation type
      !C && !_.prevProp || // Or if the prop doesn't define an animation
      $W(C) || typeof C == "boolean")
        continue;
      const I = Uwr(_.prevProp, C);
      let M = I || // If we're making this variant active, we want to always make it active
      w === l && _.isActive && !A && x || // If we removed a higher-priority variant (i is in reverse order)
      b > g && x, B = !1;
      const L = Array.isArray(C) ? C : [C];
      let N = L.reduce(a(w), {});
      S === !1 && (N = {});
      const { prevResolvedValues: d = {} } = _, m = {
        ...d,
        ...N
      }, v = (G) => {
        M = !0, h.has(G) && (B = !0, h.delete(G)), _.needsAnimating[G] = !0;
        const H = t.getValue(G);
        H && (H.liveStyle = !1);
      };
      for (const G in m) {
        const H = N[G], j = d[G];
        if (p.hasOwnProperty(G))
          continue;
        let F = !1;
        pde(H) && pde(j) ? F = !lct(H, j) : F = H !== j, F ? H != null ? v(G) : h.add(G) : H !== void 0 && h.has(G) ? v(G) : _.protectedKeys[G] = !0;
      }
      _.prevProp = C, _.prevResolvedValues = N, _.isActive && (p = { ...p, ...N }), n && t.blockInitialAnimation && (M = !1), M && (!(A && I) || B) && f.push(...L.map((G) => ({
        animation: G,
        options: { type: w }
      })));
    }
    if (h.size) {
      const b = {};
      if (typeof c.initial != "boolean") {
        const w = bE(t, Array.isArray(c.initial) ? c.initial[0] : c.initial);
        w && w.transition && (b.transition = w.transition);
      }
      h.forEach((w) => {
        const _ = t.getBaseTarget(w), C = t.getValue(w);
        C && (C.liveStyle = !0), b[w] = _ ?? null;
      }), f.push({ animation: b });
    }
    let y = !!f.length;
    return n && (c.initial === !1 || c.initial === c.animate) && !t.manuallyAnimateOnMount && (y = !1), n = !1, y ? e(f) : Promise.resolve();
  }
  function s(l, c) {
    var u;
    if (r[l].isActive === c)
      return Promise.resolve();
    (u = t.variantChildren) === null || u === void 0 || u.forEach((h) => {
      var p;
      return (p = h.animationState) === null || p === void 0 ? void 0 : p.setActive(l, c);
    }), r[l].isActive = c;
    const f = o(l);
    for (const h in r)
      r[h].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: i,
    getState: () => r,
    reset: () => {
      r = sEe(), n = !0;
    }
  };
}
function Uwr(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !lct(e, t) : !1;
}
function U3(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function sEe() {
  return {
    animate: U3(!0),
    whileInView: U3(),
    whileHover: U3(),
    whileTap: U3(),
    whileDrag: U3(),
    whileFocus: U3(),
    exit: U3()
  };
}
class Ky {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
class Vwr extends Ky {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = Hwr(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    $W(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: r } = this.node.prevProps || {};
    e !== r && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var e;
    this.node.animationState.reset(), (e = this.unmountControls) === null || e === void 0 || e.call(this);
  }
}
let qwr = 0;
class Kwr extends Ky {
  constructor() {
    super(...arguments), this.id = qwr++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: r } = this.node.presenceContext, { isPresent: n } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === n)
      return;
    const a = this.node.animationState.setActive("exit", !e);
    r && !e && a.then(() => {
      r(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: r } = this.node.presenceContext || {};
    r && r(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const Zwr = {
  animation: {
    Feature: Vwr
  },
  exit: {
    Feature: Kwr
  }
}, n1 = {
  x: !1,
  y: !1
};
function uct() {
  return n1.x || n1.y;
}
function Jwr(t) {
  return t === "x" || t === "y" ? n1[t] ? null : (n1[t] = !0, () => {
    n1[t] = !1;
  }) : n1.x || n1.y ? null : (n1.x = n1.y = !0, () => {
    n1.x = n1.y = !1;
  });
}
function wE(t, e, r, n = { passive: !0 }) {
  return t.addEventListener(e, r, n), () => t.removeEventListener(e, r);
}
const Uve = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1;
function aP(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const Ywr = (t) => (e) => Uve(e) && t(e, aP(e));
function H9(t, e, r, n) {
  return wE(t, e, Ywr(r), n);
}
function dct({ top: t, left: e, right: r, bottom: n }) {
  return {
    x: { min: e, max: r },
    y: { min: t, max: n }
  };
}
function Xwr({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function Qwr(t, e) {
  if (!e)
    return t;
  const r = e({ x: t.left, y: t.top }), n = e({ x: t.right, y: t.bottom });
  return {
    top: r.y,
    left: r.x,
    bottom: n.y,
    right: n.x
  };
}
const fct = 1e-4, eSr = 1 - fct, tSr = 1 + fct, hct = 0.01, rSr = 0 - hct, nSr = 0 + hct;
function wu(t) {
  return t.max - t.min;
}
function aSr(t, e, r) {
  return Math.abs(t - e) <= r;
}
function lEe(t, e, r, n = 0.5) {
  t.origin = n, t.originPoint = $s(e.min, e.max, t.origin), t.scale = wu(r) / wu(e), t.translate = $s(r.min, r.max, t.origin) - t.originPoint, (t.scale >= eSr && t.scale <= tSr || isNaN(t.scale)) && (t.scale = 1), (t.translate >= rSr && t.translate <= nSr || isNaN(t.translate)) && (t.translate = 0);
}
function F_(t, e, r, n) {
  lEe(t.x, e.x, r.x, n ? n.originX : void 0), lEe(t.y, e.y, r.y, n ? n.originY : void 0);
}
function cEe(t, e, r) {
  t.min = r.min + e.min, t.max = t.min + wu(e);
}
function iSr(t, e, r) {
  cEe(t.x, e.x, r.x), cEe(t.y, e.y, r.y);
}
function uEe(t, e, r) {
  t.min = e.min - r.min, t.max = t.min + wu(e);
}
function z_(t, e, r) {
  uEe(t.x, e.x, r.x), uEe(t.y, e.y, r.y);
}
const dEe = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), U9 = () => ({
  x: dEe(),
  y: dEe()
}), fEe = () => ({ min: 0, max: 0 }), nl = () => ({
  x: fEe(),
  y: fEe()
});
function z0(t) {
  return [t("x"), t("y")];
}
function _ee(t) {
  return t === void 0 || t === 1;
}
function kde({ scale: t, scaleX: e, scaleY: r }) {
  return !_ee(t) || !_ee(e) || !_ee(r);
}
function X3(t) {
  return kde(t) || pct(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function pct(t) {
  return hEe(t.x) || hEe(t.y);
}
function hEe(t) {
  return t && t !== "0%";
}
function hj(t, e, r) {
  const n = t - r, a = e * n;
  return r + a;
}
function pEe(t, e, r, n, a) {
  return a !== void 0 && (t = hj(t, a, n)), hj(t, r, n) + e;
}
function Ade(t, e = 0, r = 1, n, a) {
  t.min = pEe(t.min, e, r, n, a), t.max = pEe(t.max, e, r, n, a);
}
function mct(t, { x: e, y: r }) {
  Ade(t.x, e.translate, e.scale, e.originPoint), Ade(t.y, r.translate, r.scale, r.originPoint);
}
const mEe = 0.999999999999, gEe = 1.0000000000001;
function oSr(t, e, r, n = !1) {
  const a = r.length;
  if (!a)
    return;
  e.x = e.y = 1;
  let i, o;
  for (let s = 0; s < a; s++) {
    i = r[s], o = i.projectionDelta;
    const { visualElement: l } = i.options;
    l && l.props.style && l.props.style.display === "contents" || (n && i.options.layoutScroll && i.scroll && i !== i.root && q9(t, {
      x: -i.scroll.offset.x,
      y: -i.scroll.offset.y
    }), o && (e.x *= o.x.scale, e.y *= o.y.scale, mct(t, o)), n && X3(i.latestValues) && q9(t, i.latestValues));
  }
  e.x < gEe && e.x > mEe && (e.x = 1), e.y < gEe && e.y > mEe && (e.y = 1);
}
function V9(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function vEe(t, e, r, n, a = 0.5) {
  const i = $s(t.min, t.max, a);
  Ade(t, e, r, i, n);
}
function q9(t, e) {
  vEe(t.x, e.x, e.scaleX, e.scale, e.originX), vEe(t.y, e.y, e.scaleY, e.scale, e.originY);
}
function gct(t, e) {
  return dct(Qwr(t.getBoundingClientRect(), e));
}
function sSr(t, e, r) {
  const n = gct(t, r), { scroll: a } = e;
  return a && (V9(n.x, a.offset.x), V9(n.y, a.offset.y)), n;
}
function pj(t, e) {
  const r = `${e}PointerCapture`;
  if (t.target instanceof Element && r in t.target && t.pointerId !== void 0)
    try {
      t.target[r](t.pointerId);
    } catch {
    }
}
const yEe = (t, e) => Math.abs(t - e);
function lSr(t, e) {
  const r = yEe(t.x, e.x), n = yEe(t.y, e.y);
  return Math.sqrt(r ** 2 + n ** 2);
}
class vct {
  constructor(e, r, { transformPagePoint: n, dragSnapToOrigin: a = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const u = Aee(this.lastMoveEventInfo, this.history), f = this.startEvent !== null, h = lSr(u.offset, { x: 0, y: 0 }) >= 3;
      if (!f && !h)
        return;
      const { point: p } = u, { timestamp: g } = Cc;
      this.history.push({ ...p, timestamp: g });
      const { onStart: y, onMove: b } = this.handlers;
      f || (y && y(this.lastMoveEvent, u), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, u);
    }, this.handlePointerMove = (u, f) => {
      if (u.currentTarget instanceof Element && u.currentTarget.hasPointerCapture && u.pointerId !== void 0)
        try {
          if (!u.currentTarget.hasPointerCapture(u.pointerId))
            return;
        } catch {
        }
      this.lastMoveEvent = u, this.lastMoveEventInfo = kee(f, this.transformPagePoint), cs.update(this.updatePoint, !0);
    }, this.handlePointerUp = (u, f) => {
      pj(u, "release"), this.end();
      const { onEnd: h, onSessionEnd: p, resumeAnimation: g } = this.handlers;
      if (this.dragSnapToOrigin && g && g(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Aee(u.type === "pointercancel" || u.type === "lostpointercapture" ? this.lastMoveEventInfo : kee(f, this.transformPagePoint), this.history);
      this.startEvent && h && h(u, y), p && p(u, y);
    }, !Uve(e))
      return;
    this.dragSnapToOrigin = a, this.handlers = r, this.transformPagePoint = n;
    const i = aP(e), o = kee(i, this.transformPagePoint), { point: s } = o, { timestamp: l } = Cc;
    this.history = [{ ...s, timestamp: l }];
    const { onSessionStart: c } = r;
    c && c(e, Aee(o, this.history)), pj(e, "set"), this.removeListeners = nP(H9(e.currentTarget, "pointermove", this.handlePointerMove), H9(e.currentTarget, "pointerup", this.handlePointerUp), H9(e.currentTarget, "pointercancel", this.handlePointerUp), H9(e.currentTarget, "lostpointercapture", this.handlePointerUp));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), wy(this.updatePoint);
  }
}
function kee(t, e) {
  return e ? { point: e(t.point) } : t;
}
function bEe(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function Aee({ point: t }, e) {
  return {
    point: t,
    delta: bEe(t, yct(e)),
    offset: bEe(t, cSr(e)),
    velocity: uSr(e, 0.1)
  };
}
function cSr(t) {
  return t[0];
}
function yct(t) {
  return t[t.length - 1];
}
function uSr(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let r = t.length - 1, n = null;
  const a = yct(t);
  for (; r >= 0 && (n = t[r], !(a.timestamp - n.timestamp > /* @__PURE__ */ Sh(e))); )
    r--;
  if (!n)
    return { x: 0, y: 0 };
  const i = /* @__PURE__ */ Em(a.timestamp - n.timestamp);
  if (i === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function dSr(t, { min: e, max: r }, n) {
  return e !== void 0 && t < e ? t = n ? $s(e, t, n.min) : Math.max(t, e) : r !== void 0 && t > r && (t = n ? $s(r, t, n.max) : Math.min(t, r)), t;
}
function xEe(t, e, r) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: r !== void 0 ? t.max + r - (t.max - t.min) : void 0
  };
}
function fSr(t, { top: e, left: r, bottom: n, right: a }) {
  return {
    x: xEe(t.x, r, a),
    y: xEe(t.y, e, n)
  };
}
function CEe(t, e) {
  let r = e.min - t.min, n = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([r, n] = [n, r]), { min: r, max: n };
}
function hSr(t, e) {
  return {
    x: CEe(t.x, e.x),
    y: CEe(t.y, e.y)
  };
}
function pSr(t, e) {
  let r = 0.5;
  const n = wu(t), a = wu(e);
  return a > n ? r = /* @__PURE__ */ Ax(e.min, e.max - n, t.min) : n > a && (r = /* @__PURE__ */ Ax(t.min, t.max - a, e.min)), Ym(0, 1, r);
}
function mSr(t, e) {
  const r = {};
  return e.min !== void 0 && (r.min = e.min - t.min), e.max !== void 0 && (r.max = e.max - t.min), r;
}
const Tde = 0.35;
function gSr(t = Tde) {
  return t === !1 ? t = 0 : t === !0 && (t = Tde), {
    x: wEe(t, "left", "right"),
    y: wEe(t, "top", "bottom")
  };
}
function wEe(t, e, r) {
  return {
    min: SEe(t, e),
    max: SEe(t, r)
  };
}
function SEe(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const vSr = /* @__PURE__ */ new WeakMap();
class ySr {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = nl(), this.visualElement = e;
  }
  start(e, { snapToCursor: r = !1 } = {}) {
    const { presenceContext: n } = this.visualElement;
    if (n && n.isPresent === !1)
      return;
    const a = (u) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), r && this.snapToCursor(aP(u).point);
    }, i = (u, f) => {
      const { drag: h, dragPropagation: p, onDragStart: g } = this.getProps();
      if (h && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = Jwr(h), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), z0((b) => {
        let w = this.getAxisMotionValue(b).get() || 0;
        if (Ch.test(w)) {
          const { projection: _ } = this.visualElement;
          if (_ && _.layout) {
            const C = _.layout.layoutBox[b];
            C && (w = wu(C) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[b] = w;
      }), g && cs.postRender(() => g(u, f)), mde(this.visualElement, "transform");
      const { animationState: y } = this.visualElement;
      y && y.setActive("whileDrag", !0);
    }, o = (u, f) => {
      const { dragPropagation: h, dragDirectionLock: p, onDirectionLock: g, onDrag: y } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: b } = f;
      if (p && this.currentDirection === null) {
        this.currentDirection = bSr(b), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, b), this.updateAxis("y", f.point, b), this.visualElement.render(), y && y(u, f);
    }, s = (u, f) => this.stop(u, f), l = () => z0((u) => {
      var f;
      return this.getAnimationState(u) === "paused" && ((f = this.getAxisMotionValue(u).animation) === null || f === void 0 ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new vct(e, {
      onSessionStart: a,
      onStart: i,
      onMove: o,
      onSessionEnd: s,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c
    });
  }
  stop(e, r) {
    const n = this.isDragging;
    if (this.cancel(), !n)
      return;
    const { velocity: a } = r;
    this.startAnimation(a);
    const { onDragEnd: i } = this.getProps();
    i && cs.postRender(() => i(e, r));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: r } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: n } = this.getProps();
    !n && this.openDragLock && (this.openDragLock(), this.openDragLock = null), r && r.setActive("whileDrag", !1);
  }
  updateAxis(e, r, n) {
    const { drag: a } = this.getProps();
    if (!n || !KB(e, a, this.currentDirection))
      return;
    const i = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + n[e];
    this.constraints && this.constraints[e] && (o = dSr(o, this.constraints[e], this.elastic[e])), i.set(o);
  }
  resolveConstraints() {
    var e;
    const { dragConstraints: r, dragElastic: n } = this.getProps(), a = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (e = this.visualElement.projection) === null || e === void 0 ? void 0 : e.layout, i = this.constraints;
    r && G9(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && a ? this.constraints = fSr(a.layoutBox, r) : this.constraints = !1, this.elastic = gSr(n), i !== this.constraints && a && this.constraints && !this.hasMutatedConstraints && z0((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = mSr(a.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: r } = this.getProps();
    if (!e || !G9(e))
      return !1;
    const n = e.current;
    Cy(n !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: a } = this.visualElement;
    if (!a || !a.layout)
      return !1;
    const i = sSr(n, a.root, this.visualElement.getTransformPagePoint());
    let o = hSr(a.layout.layoutBox, i);
    if (r) {
      const s = r(Xwr(o));
      this.hasMutatedConstraints = !!s, s && (o = dct(s));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: r, dragMomentum: n, dragElastic: a, dragTransition: i, dragSnapToOrigin: o, onDragTransitionEnd: s } = this.getProps(), l = this.constraints || {}, c = z0((u) => {
      if (!KB(u, r, this.currentDirection))
        return;
      let f = l && l[u] || {};
      o && (f = { min: 0, max: 0 });
      const h = a ? 200 : 1e6, p = a ? 40 : 1e7, g = {
        type: "inertia",
        velocity: n ? e[u] : 0,
        bounceStiffness: h,
        bounceDamping: p,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...i,
        ...f
      };
      return this.startAxisValueAnimation(u, g);
    });
    return Promise.all(c).then(s);
  }
  startAxisValueAnimation(e, r) {
    const n = this.getAxisMotionValue(e);
    return mde(this.visualElement, e), n.start(Hve(e, n, 0, r, this.visualElement, !1));
  }
  stopAnimation() {
    z0((e) => this.getAxisMotionValue(e).stop());
  }
  pauseAnimation() {
    z0((e) => {
      var r;
      return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.pause();
    });
  }
  getAnimationState(e) {
    var r;
    return (r = this.getAxisMotionValue(e).animation) === null || r === void 0 ? void 0 : r.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const r = `_drag${e.toUpperCase()}`, n = this.visualElement.getProps(), a = n[r];
    return a || this.visualElement.getValue(e, (n.initial ? n.initial[e] : void 0) || 0);
  }
  snapToCursor(e) {
    z0((r) => {
      const { drag: n } = this.getProps();
      if (!KB(r, n, this.currentDirection))
        return;
      const { projection: a } = this.visualElement, i = this.getAxisMotionValue(r);
      if (a && a.layout) {
        const { min: o, max: s } = a.layout.layoutBox[r];
        i.set(e[r] - $s(o, s, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: r } = this.getProps(), { projection: n } = this.visualElement;
    if (!G9(r) || !n || !this.constraints)
      return;
    this.stopAnimation();
    const a = { x: 0, y: 0 };
    z0((o) => {
      const s = this.getAxisMotionValue(o);
      if (s && this.constraints !== !1) {
        const l = s.get();
        a[o] = pSr({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: i } = this.visualElement.getProps();
    this.visualElement.current.style.transform = i ? i({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), z0((o) => {
      if (!KB(o, e, null))
        return;
      const s = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      s.set($s(l, c, a[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    vSr.set(this.visualElement, this);
    const e = this.visualElement.current, r = H9(e, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), n = () => {
      const { dragConstraints: l } = this.getProps();
      G9(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: a } = this.visualElement, i = a.addEventListener("measure", n);
    a && !a.layout && (a.root && a.root.updateScroll(), a.updateLayout()), cs.read(n);
    const o = wE(window, "resize", () => this.scalePositionWithinConstraints()), s = a.addEventListener("didUpdate", ({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && (z0((u) => {
        const f = this.getAxisMotionValue(u);
        f && (this.originPoint[u] += l[u].translate, f.set(f.get() + l[u].translate));
      }), this.visualElement.render());
    });
    return () => {
      o(), r(), i(), s && s();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: r = !1, dragDirectionLock: n = !1, dragPropagation: a = !1, dragConstraints: i = !1, dragElastic: o = Tde, dragMomentum: s = !0 } = e;
    return {
      ...e,
      drag: r,
      dragDirectionLock: n,
      dragPropagation: a,
      dragConstraints: i,
      dragElastic: o,
      dragMomentum: s
    };
  }
}
function KB(t, e, r) {
  return (e === !0 || e === t) && (r === null || r === t);
}
function bSr(t, e = 10) {
  let r = null;
  return Math.abs(t.y) > e ? r = "y" : Math.abs(t.x) > e && (r = "x"), r;
}
class xSr extends Ky {
  constructor(e) {
    super(e), this.removeGroupControls = gd, this.removeListeners = gd, this.controls = new ySr(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || gd;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const _Ee = (t) => (e, r) => {
  t && cs.postRender(() => t(e, r));
};
class CSr extends Ky {
  constructor() {
    super(...arguments), this.removePointerDownListener = gd;
  }
  onPointerDown(e) {
    this.session = new vct(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint()
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: r, onPan: n, onPanEnd: a } = this.node.getProps();
    return {
      onSessionStart: _Ee(e),
      onStart: _Ee(r),
      onMove: n,
      onEnd: (i, o) => {
        delete this.session, a && cs.postRender(() => a(i, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = H9(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const A$ = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function kEe(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const iS = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (ca.test(t))
        t = parseFloat(t);
      else
        return t;
    const r = kEe(t, e.target.x), n = kEe(t, e.target.y);
    return `${r}% ${n}%`;
  }
}, wSr = {
  correct: (t, { treeScale: e, projectionDelta: r }) => {
    const n = t, a = Sy.parse(t);
    if (a.length > 5)
      return n;
    const i = Sy.createTransformer(t), o = typeof a[0] != "number" ? 1 : 0, s = r.x.scale * e.x, l = r.y.scale * e.y;
    a[0 + o] /= s, a[1 + o] /= l;
    const c = $s(s, l, 0.5);
    return typeof a[2 + o] == "number" && (a[2 + o] /= c), typeof a[3 + o] == "number" && (a[3 + o] /= c), i(a);
  }
};
class SSr extends QF {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: r, switchLayoutGroup: n, layoutId: a } = this.props, { projection: i } = e;
    B8r(_Sr), i && (r.group && r.group.add(i), n && n.register && a && n.register(i), i.root.didUpdate(), i.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), i.setOptions({
      ...i.options,
      onExitComplete: () => this.safeToRemove()
    })), A$.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: r, visualElement: n, drag: a, isPresent: i } = this.props, o = n.projection;
    return o && (o.isPresent = i, a || e.layoutDependency !== r || r === void 0 ? o.willUpdate() : this.safeToRemove(), e.isPresent !== i && (i ? o.promote() : o.relegate() || cs.postRender(() => {
      const s = o.getStack();
      (!s || !s.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement;
    e && (e.root.didUpdate(), yve.postRender(() => {
      !e.currentAnimation && e.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: r, switchLayoutGroup: n } = this.props, { projection: a } = e;
    a && (a.scheduleCheckAfterUnmount(), r && r.group && r.group.remove(a), n && n.deregister && n.deregister(a));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function bct(t) {
  const [e, r] = ilt(), n = Qn(dve);
  return R.jsx(SSr, { ...t, layoutGroup: n, switchLayoutGroup: Qn(flt), isPresent: e, safeToRemove: r });
}
const _Sr = {
  borderRadius: {
    ...iS,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: iS,
  borderTopRightRadius: iS,
  borderBottomLeftRadius: iS,
  borderBottomRightRadius: iS,
  boxShadow: wSr
};
function kSr(t, e, r) {
  const n = Jc(t) ? t : xE(t);
  return n.start(Hve("", n, e, r)), n.animation;
}
function ASr(t) {
  return t instanceof SVGElement && t.tagName !== "svg";
}
const TSr = (t, e) => t.depth - e.depth;
class ESr {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    Mve(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    Pve(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(TSr), this.isDirty = !1, this.children.forEach(e);
  }
}
function ISr(t, e) {
  const r = wh.now(), n = ({ timestamp: a }) => {
    const i = a - r;
    i >= e && (wy(n), t(i - e));
  };
  return cs.read(n, !0), () => wy(n);
}
const xct = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], MSr = xct.length, AEe = (t) => typeof t == "string" ? parseFloat(t) : t, TEe = (t) => typeof t == "number" || ca.test(t);
function PSr(t, e, r, n, a, i) {
  a ? (t.opacity = $s(
    0,
    // TODO Reinstate this if only child
    r.opacity !== void 0 ? r.opacity : 1,
    RSr(n)
  ), t.opacityExit = $s(e.opacity !== void 0 ? e.opacity : 1, 0, OSr(n))) : i && (t.opacity = $s(e.opacity !== void 0 ? e.opacity : 1, r.opacity !== void 0 ? r.opacity : 1, n));
  for (let o = 0; o < MSr; o++) {
    const s = `border${xct[o]}Radius`;
    let l = EEe(e, s), c = EEe(r, s);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || TEe(l) === TEe(c) ? (t[s] = Math.max($s(AEe(l), AEe(c), n), 0), (Ch.test(c) || Ch.test(l)) && (t[s] += "%")) : t[s] = c;
  }
  (e.rotate || r.rotate) && (t.rotate = $s(e.rotate || 0, r.rotate || 0, n));
}
function EEe(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const RSr = /* @__PURE__ */ Cct(0, 0.5, Dlt), OSr = /* @__PURE__ */ Cct(0.5, 0.95, gd);
function Cct(t, e, r) {
  return (n) => n < t ? 0 : n > e ? 1 : r(/* @__PURE__ */ Ax(t, e, n));
}
function IEe(t, e) {
  t.min = e.min, t.max = e.max;
}
function L0(t, e) {
  IEe(t.x, e.x), IEe(t.y, e.y);
}
function MEe(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
function PEe(t, e, r, n, a) {
  return t -= e, t = hj(t, 1 / r, n), a !== void 0 && (t = hj(t, 1 / a, n)), t;
}
function BSr(t, e = 0, r = 1, n = 0.5, a, i = t, o = t) {
  if (Ch.test(e) && (e = parseFloat(e), e = $s(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let s = $s(i.min, i.max, n);
  t === i && (s -= e), t.min = PEe(t.min, e, r, s, a), t.max = PEe(t.max, e, r, s, a);
}
function REe(t, e, [r, n, a], i, o) {
  BSr(t, e[r], e[n], e[a], e.scale, i, o);
}
const NSr = ["x", "scaleX", "originX"], $Sr = ["y", "scaleY", "originY"];
function OEe(t, e, r, n) {
  REe(t.x, e, NSr, r ? r.x : void 0, n ? n.x : void 0), REe(t.y, e, $Sr, r ? r.y : void 0, n ? n.y : void 0);
}
function BEe(t) {
  return t.translate === 0 && t.scale === 1;
}
function wct(t) {
  return BEe(t.x) && BEe(t.y);
}
function NEe(t, e) {
  return t.min === e.min && t.max === e.max;
}
function DSr(t, e) {
  return NEe(t.x, e.x) && NEe(t.y, e.y);
}
function $Ee(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Sct(t, e) {
  return $Ee(t.x, e.x) && $Ee(t.y, e.y);
}
function DEe(t) {
  return wu(t.x) / wu(t.y);
}
function LEe(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
class LSr {
  constructor() {
    this.members = [];
  }
  add(e) {
    Mve(this.members, e), e.scheduleRender();
  }
  remove(e) {
    if (Pve(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const r = this.members[this.members.length - 1];
      r && this.promote(r);
    }
  }
  relegate(e) {
    const r = this.members.findIndex((a) => e === a);
    if (r === 0)
      return !1;
    let n;
    for (let a = r; a >= 0; a--) {
      const i = this.members[a];
      if (i.isPresent !== !1) {
        n = i;
        break;
      }
    }
    return n ? (this.promote(n), !0) : !1;
  }
  promote(e, r) {
    const n = this.lead;
    if (e !== n && (this.prevLead = n, this.lead = e, e.show(), n)) {
      n.instance && n.scheduleRender(), e.scheduleRender(), e.resumeFrom = n, r && (e.resumeFrom.preserveOpacity = !0), n.snapshot && (e.snapshot = n.snapshot, e.snapshot.latestValues = n.animationValues || n.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
      const { crossfade: a } = e.options;
      a === !1 && n.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: r, resumingFrom: n } = e;
      r.onExitComplete && r.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function jSr(t, e, r) {
  let n = "";
  const a = t.x.translate / e.x, i = t.y.translate / e.y, o = (r == null ? void 0 : r.z) || 0;
  if ((a || i || o) && (n = `translate3d(${a}px, ${i}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (n += `scale(${1 / e.x}, ${1 / e.y}) `), r) {
    const { transformPerspective: c, rotate: u, rotateX: f, rotateY: h, skewX: p, skewY: g } = r;
    c && (n = `perspective(${c}px) ${n}`), u && (n += `rotate(${u}deg) `), f && (n += `rotateX(${f}deg) `), h && (n += `rotateY(${h}deg) `), p && (n += `skewX(${p}deg) `), g && (n += `skewY(${g}deg) `);
  }
  const s = t.x.scale * e.x, l = t.y.scale * e.y;
  return (s !== 1 || l !== 1) && (n += `scale(${s}, ${l})`), n || "none";
}
const Tee = ["", "X", "Y", "Z"], FSr = { visibility: "hidden" }, jEe = 1e3;
let zSr = 0;
function Eee(t, e, r, n) {
  const { latestValues: a } = e;
  a[t] && (r[t] = a[t], e.setStaticValue(t, 0), n && (n[t] = 0));
}
function _ct(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const r = Tlt(e);
  if (window.MotionHasOptimisedAnimation(r, "transform")) {
    const { layout: a, layoutId: i } = t.options;
    window.MotionCancelOptimisedAnimation(r, "transform", cs, !(a || i));
  }
  const { parent: n } = t;
  n && !n.hasCheckedOptimisedAppear && _ct(n);
}
function kct({ attachResizeListener: t, defaultParent: e, measureScroll: r, checkIsScrollRoot: n, resetTransform: a }) {
  return class {
    constructor(o = {}, s = e == null ? void 0 : e()) {
      this.id = zSr++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(HSr), this.nodes.forEach(ZSr), this.nodes.forEach(JSr), this.nodes.forEach(USr);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = s ? s.root || s : this, this.path = s ? [...s.path, s] : [], this.parent = s, this.depth = s ? s.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new ESr());
    }
    addEventListener(o, s) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new Rve()), this.eventHandlers.get(o).add(s);
    }
    notifyListeners(o, ...s) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...s);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o, s = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = ASr(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), s && (c || l) && (this.isLayoutDirty = !0), t) {
        let f;
        const h = () => this.root.updateBlockedByResize = !1;
        t(o, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = ISr(h, 250), A$.hasAnimatedSinceResize && (A$.hasAnimatedSinceResize = !1, this.nodes.forEach(zEe));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: h, hasRelativeLayoutChanged: p, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || t_r, { onLayoutAnimationStart: b, onLayoutAnimationComplete: w } = u.getProps(), _ = !this.targetLayout || !Sct(this.targetLayout, g), C = !h && p;
        if (this.options.layoutRoot || this.resumeFrom || C || h && (_ || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, C);
          const x = {
            ...Ive(y, "layout"),
            onPlay: b,
            onComplete: w
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (x.delay = 0, x.type = !1), this.startAnimation(x);
        } else
          h || zEe(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, wy(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(YSr), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && _ct(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: s, layout: l } = this.options;
      if (s === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(FEe);
        return;
      }
      this.isUpdating || this.nodes.forEach(qSr), this.isUpdating = !1, this.nodes.forEach(KSr), this.nodes.forEach(GSr), this.nodes.forEach(WSr), this.clearAllSnapshots();
      const s = wh.now();
      Cc.delta = Ym(0, 1e3 / 60, s - Cc.timestamp), Cc.timestamp = s, Cc.isProcessing = !0, xee.update.process(Cc), xee.preRender.process(Cc), xee.render.process(Cc), Cc.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, yve.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(VSr), this.sharedNodes.forEach(XSr);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, cs.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      cs.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !wu(this.snapshot.measuredBox.x) && !wu(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = nl(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: s } = this.options;
      s && s.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let s = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (s = !1), s) {
        const l = n(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: r(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!a)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, s = this.projectionDelta && !wct(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      o && (s || X3(this.latestValues) || u) && (a(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const s = this.measurePageBox();
      let l = this.removeElementScroll(s);
      return o && (l = this.removeTransform(l)), r_r(l), {
        animationId: this.root.animationId,
        measuredBox: s,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var o;
      const { visualElement: s } = this.options;
      if (!s)
        return nl();
      const l = s.measureViewportBox();
      if (!(((o = this.scroll) === null || o === void 0 ? void 0 : o.wasRoot) || this.path.some(n_r))) {
        const { scroll: u } = this.root;
        u && (V9(l.x, u.offset.x), V9(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var s;
      const l = nl();
      if (L0(l, o), !((s = this.scroll) === null || s === void 0) && s.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: f, options: h } = u;
        u !== this.root && f && h.layoutScroll && (f.wasRoot && L0(l, o), V9(l.x, f.offset.x), V9(l.y, f.offset.y));
      }
      return l;
    }
    applyTransform(o, s = !1) {
      const l = nl();
      L0(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !s && u.options.layoutScroll && u.scroll && u !== u.root && q9(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), X3(u.latestValues) && q9(l, u.latestValues);
      }
      return X3(this.latestValues) && q9(l, this.latestValues), l;
    }
    removeTransform(o) {
      const s = nl();
      L0(s, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !X3(c.latestValues))
          continue;
        kde(c.latestValues) && c.updateSnapshot();
        const u = nl(), f = c.measurePageBox();
        L0(u, f), OEe(s, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return X3(this.latestValues) && OEe(s, this.latestValues), s;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== Cc.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var s;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((s = this.parent) === null || s === void 0) && s.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: f, layoutId: h } = this.options;
      if (!(!this.layout || !(f || h))) {
        if (this.resolvedRelativeTargetAt = Cc.timestamp, !this.targetDelta && !this.relativeTarget) {
          const p = this.getClosestProjectingParent();
          p && p.layout && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = nl(), this.relativeTargetOrigin = nl(), z_(this.relativeTargetOrigin, this.layout.layoutBox, p.layout.layoutBox), L0(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = nl(), this.targetWithTransforms = nl()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), iSr(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : L0(this.target, this.layout.layoutBox), mct(this.target, this.targetDelta)) : L0(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const p = this.getClosestProjectingParent();
          p && !!p.resumingFrom == !!this.resumingFrom && !p.options.layoutScroll && p.target && this.animationProgress !== 1 ? (this.relativeParent = p, this.forceRelativeParentToResolveTarget(), this.relativeTarget = nl(), this.relativeTargetOrigin = nl(), z_(this.relativeTargetOrigin, this.target, p.target), L0(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || kde(this.parent.latestValues) || pct(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var o;
      const s = this.getLead(), l = !!this.resumingFrom || this !== s;
      let c = !0;
      if ((this.isProjectionDirty || !((o = this.parent) === null || o === void 0) && o.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === Cc.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: f } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || f))
        return;
      L0(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, p = this.treeScale.y;
      oSr(this.layoutCorrected, this.treeScale, this.path, l), s.layout && !s.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (s.target = s.layout.layoutBox, s.targetWithTransforms = nl());
      const { target: g } = s;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (MEe(this.prevProjectionDelta.x, this.projectionDelta.x), MEe(this.prevProjectionDelta.y, this.projectionDelta.y)), F_(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== p || !LEe(this.projectionDelta.x, this.prevProjectionDelta.x) || !LEe(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var s;
      if ((s = this.options.visualElement) === null || s === void 0 || s.scheduleRender(), o) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = U9(), this.projectionDelta = U9(), this.projectionDeltaWithTransform = U9();
    }
    setAnimationOrigin(o, s = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, f = U9();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !s;
      const h = nl(), p = l ? l.source : void 0, g = this.layout ? this.layout.source : void 0, y = p !== g, b = this.getStack(), w = !b || b.members.length <= 1, _ = !!(y && !w && this.options.crossfade === !0 && !this.path.some(e_r));
      this.animationProgress = 0;
      let C;
      this.mixTargetDelta = (x) => {
        const S = x / 1e3;
        GEe(f.x, o.x, S), GEe(f.y, o.y, S), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (z_(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), QSr(this.relativeTarget, this.relativeTargetOrigin, h, S), C && DSr(this.relativeTarget, C) && (this.isProjectionDirty = !1), C || (C = nl()), L0(C, this.relativeTarget)), y && (this.animationValues = u, PSr(u, c, this.latestValues, S, _, w)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = S;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (wy(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = cs.update(() => {
        A$.hasAnimatedSinceResize = !0, this.currentAnimation = kSr(0, jEe, {
          ...o,
          onUpdate: (s) => {
            this.mixTargetDelta(s), o.onUpdate && o.onUpdate(s);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(jEe), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: s, target: l, layout: c, latestValues: u } = o;
      if (!(!s || !l || !c)) {
        if (this !== o && this.layout && c && Act(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || nl();
          const f = wu(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + f;
          const h = wu(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + h;
        }
        L0(s, l), q9(s, u), F_(this.projectionDeltaWithTransform, this.layoutCorrected, s, u);
      }
    }
    registerSharedNode(o, s) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new LSr()), this.sharedNodes.get(o).add(s);
      const c = s.options.initialPromotionConfig;
      s.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(s) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? ((o = this.getStack()) === null || o === void 0 ? void 0 : o.lead) || this : this;
    }
    getPrevLead() {
      var o;
      const { layoutId: s } = this.options;
      return s ? (o = this.getStack()) === null || o === void 0 ? void 0 : o.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: s, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), s && this.setOptions({ transition: s });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let s = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (s = !0), !s)
        return;
      const c = {};
      l.z && Eee("z", o, c, this.animationValues);
      for (let u = 0; u < Tee.length; u++)
        Eee(`rotate${Tee[u]}`, o, c, this.animationValues), Eee(`skew${Tee[u]}`, o, c, this.animationValues);
      o.render();
      for (const u in c)
        o.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      o.scheduleRender();
    }
    getProjectionStyles(o) {
      var s, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return FSr;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = _$(o == null ? void 0 : o.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const f = this.getLead();
      if (!this.projectionDelta || !this.layout || !f.target) {
        const y = {};
        return this.options.layoutId && (y.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, y.pointerEvents = _$(o == null ? void 0 : o.pointerEvents) || ""), this.hasProjected && !X3(this.latestValues) && (y.transform = u ? u({}, "") : "none", this.hasProjected = !1), y;
      }
      const h = f.animationValues || f.latestValues;
      this.applyTransformsToTarget(), c.transform = jSr(this.projectionDeltaWithTransform, this.treeScale, h), u && (c.transform = u(h, c.transform));
      const { x: p, y: g } = this.projectionDelta;
      c.transformOrigin = `${p.origin * 100}% ${g.origin * 100}% 0`, f.animationValues ? c.opacity = f === this ? (l = (s = h.opacity) !== null && s !== void 0 ? s : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : h.opacityExit : c.opacity = f === this ? h.opacity !== void 0 ? h.opacity : "" : h.opacityExit !== void 0 ? h.opacityExit : 0;
      for (const y in vE) {
        if (h[y] === void 0)
          continue;
        const { correct: b, applyTo: w, isCSSVariable: _ } = vE[y], C = c.transform === "none" ? h[y] : b(h[y], f);
        if (w) {
          const x = w.length;
          for (let S = 0; S < x; S++)
            c[w[S]] = C;
        } else
          _ ? this.options.visualElement.renderState.vars[y] = C : c[y] = C;
      }
      return this.options.layoutId && (c.pointerEvents = f === this ? _$(o == null ? void 0 : o.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var s;
        return (s = o.currentAnimation) === null || s === void 0 ? void 0 : s.stop();
      }), this.root.nodes.forEach(FEe), this.root.sharedNodes.clear();
    }
  };
}
function GSr(t) {
  t.updateLayout();
}
function WSr(t) {
  var e;
  const r = ((e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) || t.snapshot;
  if (t.isLead() && t.layout && r && t.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: a } = t.layout, { animationType: i } = t.options, o = r.source !== t.layout.source;
    i === "size" ? z0((f) => {
      const h = o ? r.measuredBox[f] : r.layoutBox[f], p = wu(h);
      h.min = n[f].min, h.max = h.min + p;
    }) : Act(i, r.layoutBox, n) && z0((f) => {
      const h = o ? r.measuredBox[f] : r.layoutBox[f], p = wu(n[f]);
      h.max = h.min + p, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[f].max = t.relativeTarget[f].min + p);
    });
    const s = U9();
    F_(s, n, r.layoutBox);
    const l = U9();
    o ? F_(l, t.applyTransform(a, !0), r.measuredBox) : F_(l, n, r.layoutBox);
    const c = !wct(s);
    let u = !1;
    if (!t.resumeFrom) {
      const f = t.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: h, layout: p } = f;
        if (h && p) {
          const g = nl();
          z_(g, r.layoutBox, h.layoutBox);
          const y = nl();
          z_(y, n, p.layoutBox), Sct(g, y) || (u = !0), f.options.layoutRoot && (t.relativeTarget = y, t.relativeTargetOrigin = g, t.relativeParent = f);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: n,
      snapshot: r,
      delta: l,
      layoutDelta: s,
      hasLayoutChanged: c,
      hasRelativeLayoutChanged: u
    });
  } else if (t.isLead()) {
    const { onExitComplete: n } = t.options;
    n && n();
  }
  t.options.transition = void 0;
}
function HSr(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function USr(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function VSr(t) {
  t.clearSnapshot();
}
function FEe(t) {
  t.clearMeasurements();
}
function qSr(t) {
  t.isLayoutDirty = !1;
}
function KSr(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function zEe(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function ZSr(t) {
  t.resolveTargetDelta();
}
function JSr(t) {
  t.calcProjection();
}
function YSr(t) {
  t.resetSkewAndRotation();
}
function XSr(t) {
  t.removeLeadSnapshot();
}
function GEe(t, e, r) {
  t.translate = $s(e.translate, 0, r), t.scale = $s(e.scale, 1, r), t.origin = e.origin, t.originPoint = e.originPoint;
}
function WEe(t, e, r, n) {
  t.min = $s(e.min, r.min, n), t.max = $s(e.max, r.max, n);
}
function QSr(t, e, r, n) {
  WEe(t.x, e.x, r.x, n), WEe(t.y, e.y, r.y, n);
}
function e_r(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const t_r = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, HEe = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), UEe = HEe("applewebkit/") && !HEe("chrome/") ? Math.round : gd;
function VEe(t) {
  t.min = UEe(t.min), t.max = UEe(t.max);
}
function r_r(t) {
  VEe(t.x), VEe(t.y);
}
function Act(t, e, r) {
  return t === "position" || t === "preserve-aspect" && !aSr(DEe(e), DEe(r), 0.2);
}
function n_r(t) {
  var e;
  return t !== t.root && ((e = t.scroll) === null || e === void 0 ? void 0 : e.wasRoot);
}
const a_r = kct({
  attachResizeListener: (t, e) => wE(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), Iee = {
  current: void 0
}, Tct = kct({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!Iee.current) {
      const t = new a_r({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), Iee.current = t;
    }
    return Iee.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), i_r = {
  pan: {
    Feature: CSr
  },
  drag: {
    Feature: xSr,
    ProjectionNode: Tct,
    MeasureLayout: bct
  }
};
function o_r(t, e, r) {
  var n;
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let a = document;
    const i = (n = void 0) !== null && n !== void 0 ? n : a.querySelectorAll(t);
    return i ? Array.from(i) : [];
  }
  return Array.from(t);
}
function Ect(t, e) {
  const r = o_r(t), n = new AbortController(), a = {
    passive: !0,
    ...e,
    signal: n.signal
  };
  return [r, a, () => n.abort()];
}
function qEe(t) {
  return !(t.pointerType === "touch" || uct());
}
function s_r(t, e, r = {}) {
  const [n, a, i] = Ect(t, r), o = (s) => {
    if (!qEe(s))
      return;
    const { target: l } = s, c = e(l, s);
    if (typeof c != "function" || !l)
      return;
    const u = (f) => {
      qEe(f) && (c(f), l.removeEventListener("pointerleave", u));
    };
    l.addEventListener("pointerleave", u, a);
  };
  return n.forEach((s) => {
    s.addEventListener("pointerenter", o, a);
  }), i;
}
function KEe(t, e, r) {
  const { props: n } = t;
  t.animationState && n.whileHover && t.animationState.setActive("whileHover", r === "Start");
  const a = "onHover" + r, i = n[a];
  i && cs.postRender(() => i(e, aP(e)));
}
class l_r extends Ky {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = s_r(e, (r, n) => (KEe(this.node, n, "Start"), (a) => KEe(this.node, a, "End"))));
  }
  unmount() {
  }
}
class c_r extends Ky {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = nP(wE(this.node.current, "focus", () => this.onFocus()), wE(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Ict = (t, e) => e ? t === e ? !0 : Ict(t, e.parentElement) : !1, u_r = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function d_r(t) {
  return u_r.has(t.tagName) || t.tabIndex !== -1;
}
const o_ = /* @__PURE__ */ new WeakSet();
function ZEe(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function Mee(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const f_r = (t, e) => {
  const r = t.currentTarget;
  if (!r)
    return;
  const n = ZEe(() => {
    if (o_.has(r))
      return;
    Mee(r, "down");
    const a = ZEe(() => {
      Mee(r, "up");
    }), i = () => Mee(r, "cancel");
    r.addEventListener("keyup", a, e), r.addEventListener("blur", i, e);
  });
  r.addEventListener("keydown", n, e), r.addEventListener("blur", () => r.removeEventListener("keydown", n), e);
};
function JEe(t) {
  return Uve(t) && !uct();
}
function h_r(t, e, r = {}) {
  const [n, a, i] = Ect(t, r), o = (s) => {
    const l = s.currentTarget;
    if (!l || !JEe(s) || o_.has(l))
      return;
    o_.add(l), pj(s, "set");
    const c = e(l, s), u = (p, g) => {
      l.removeEventListener("pointerup", f), l.removeEventListener("pointercancel", h), pj(p, "release"), !(!JEe(p) || !o_.has(l)) && (o_.delete(l), typeof c == "function" && c(p, { success: g }));
    }, f = (p) => {
      (p.isTrusted ? p_r(p, l instanceof Element ? l.getBoundingClientRect() : {
        left: 0,
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight
      }) : !1) ? u(p, !1) : u(p, !(l instanceof Element) || Ict(l, p.target));
    }, h = (p) => {
      u(p, !1);
    };
    l.addEventListener("pointerup", f, a), l.addEventListener("pointercancel", h, a), l.addEventListener("lostpointercapture", h, a);
  };
  return n.forEach((s) => {
    s = r.useGlobalTarget ? window : s;
    let l = !1;
    s instanceof HTMLElement && (l = !0, !d_r(s) && s.getAttribute("tabindex") === null && (s.tabIndex = 0)), s.addEventListener("pointerdown", o, a), l && s.addEventListener("focus", (c) => f_r(c, a), a);
  }), i;
}
function p_r(t, e) {
  return t.clientX < e.left || t.clientX > e.right || t.clientY < e.top || t.clientY > e.bottom;
}
function YEe(t, e, r) {
  const { props: n } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && n.whileTap && t.animationState.setActive("whileTap", r === "Start");
  const a = "onTap" + (r === "End" ? "" : r), i = n[a];
  i && cs.postRender(() => i(e, aP(e)));
}
class m_r extends Ky {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = h_r(e, (r, n) => (YEe(this.node, n, "Start"), (a, { success: i }) => YEe(this.node, a, i ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Ede = /* @__PURE__ */ new WeakMap(), Pee = /* @__PURE__ */ new WeakMap(), g_r = (t) => {
  const e = Ede.get(t.target);
  e && e(t);
}, v_r = (t) => {
  t.forEach(g_r);
};
function y_r({ root: t, ...e }) {
  const r = t || document;
  Pee.has(r) || Pee.set(r, {});
  const n = Pee.get(r), a = JSON.stringify(e);
  return n[a] || (n[a] = new IntersectionObserver(v_r, { root: t, ...e })), n[a];
}
function b_r(t, e, r) {
  const n = y_r(e);
  return Ede.set(t, r), n.observe(t), () => {
    Ede.delete(t), n.unobserve(t);
  };
}
const x_r = {
  some: 0,
  all: 1
};
class C_r extends Ky {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: e = {} } = this.node.getProps(), { root: r, margin: n, amount: a = "some", once: i } = e, o = {
      root: r ? r.current : void 0,
      rootMargin: n,
      threshold: typeof a == "number" ? a : x_r[a]
    }, s = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, i && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: f } = this.node.getProps(), h = c ? u : f;
      h && h(l);
    };
    return b_r(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: r } = this.node;
    ["amount", "margin", "root"].some(w_r(e, r)) && this.startObserver();
  }
  unmount() {
  }
}
function w_r({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (r) => t[r] !== e[r];
}
const S_r = {
  inView: {
    Feature: C_r
  },
  tap: {
    Feature: m_r
  },
  focus: {
    Feature: c_r
  },
  hover: {
    Feature: l_r
  }
}, __r = {
  layout: {
    ProjectionNode: Tct,
    MeasureLayout: bct
  }
}, Ide = { current: null }, Mct = { current: !1 };
function k_r() {
  if (Mct.current = !0, !!pve)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => Ide.current = t.matches;
      t.addListener(e), e();
    } else
      Ide.current = !1;
}
const A_r = [...Ylt, Hc, Sy], T_r = (t) => A_r.find(Jlt(t)), E_r = /* @__PURE__ */ new WeakMap();
function I_r(t, e, r) {
  for (const n in e) {
    const a = e[n], i = r[n];
    if (Jc(a))
      t.addValue(n, a), Ar.env.NODE_ENV === "development" && BW(a.version === "12.4.5", `Attempting to mix Motion versions ${a.version} with 12.4.5 may not work as expected.`);
    else if (Jc(i))
      t.addValue(n, xE(a, { owner: t }));
    else if (i !== a)
      if (t.hasValue(n)) {
        const o = t.getValue(n);
        o.liveStyle === !0 ? o.jump(a) : o.hasAnimated || o.set(a);
      } else {
        const o = t.getStaticValue(n);
        t.addValue(n, xE(o !== void 0 ? o : a, { owner: t }));
      }
  }
  for (const n in r)
    e[n] === void 0 && t.removeValue(n);
  return e;
}
const XEe = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class M_r {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, r, n) {
    return {};
  }
  constructor({ parent: e, props: r, presenceContext: n, reducedMotionConfig: a, blockInitialAnimation: i, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = zve, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = wh.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, cs.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c, onUpdate: u } = o;
    this.onUpdate = u, this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = r.initial ? { ...l } : {}, this.renderState = c, this.parent = e, this.props = r, this.presenceContext = n, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = a, this.options = s, this.blockInitialAnimation = !!i, this.isControllingVariants = DW(r), this.isVariantNode = ult(r), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: f, ...h } = this.scrapeMotionValuesFromProps(r, {}, this);
    for (const p in h) {
      const g = h[p];
      l[p] !== void 0 && Jc(g) && g.set(l[p], !1);
    }
  }
  mount(e) {
    this.current = e, E_r.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, n) => this.bindToMotionValue(n, r)), Mct.current || k_r(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ide.current, Ar.env.NODE_ENV !== "production" && BW(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), wy(this.notifyUpdate), wy(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const r = this.features[e];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(e, r) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
    const n = v6.has(e);
    n && this.onBindTransform && this.onBindTransform();
    const a = r.on("change", (s) => {
      this.latestValues[e] = s, this.props.onUpdate && cs.preRender(this.notifyUpdate), n && this.projection && (this.projection.isTransformDirty = !0);
    }), i = r.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, e, r)), this.valueSubscriptions.set(e, () => {
      a(), i(), o && o(), r.owner && r.stop();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in kx) {
      const r = kx[e];
      if (!r)
        continue;
      const { isEnabled: n, Feature: a } = r;
      if (!this.features[e] && a && n(this.props) && (this.features[e] = new a(this)), this.features[e]) {
        const i = this.features[e];
        i.isMounted ? i.update() : (i.mount(), i.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : nl();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, r) {
    this.latestValues[e] = r;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, r) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = r;
    for (let n = 0; n < XEe.length; n++) {
      const a = XEe[n];
      this.propEventSubscriptions[a] && (this.propEventSubscriptions[a](), delete this.propEventSubscriptions[a]);
      const i = "on" + a, o = e[i];
      o && (this.propEventSubscriptions[a] = this.on(a, o));
    }
    this.prevMotionValues = I_r(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const r = this.getClosestVariantNode();
    if (r)
      return r.variantChildren && r.variantChildren.add(e), () => r.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, r) {
    const n = this.values.get(e);
    r !== n && (n && this.removeValue(e), this.bindToMotionValue(e, r), this.values.set(e, r), this.latestValues[e] = r.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const r = this.valueSubscriptions.get(e);
    r && (r(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, r) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let n = this.values.get(e);
    return n === void 0 && r !== void 0 && (n = xE(r === null ? void 0 : r, { owner: this }), this.addValue(e, n)), n;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, r) {
    var n;
    let a = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : (n = this.getBaseTargetFromProps(this.props, e)) !== null && n !== void 0 ? n : this.readValueFromInstance(this.current, e, this.options);
    return a != null && (typeof a == "string" && (Klt(a) || jlt(a)) ? a = parseFloat(a) : !T_r(a) && Sy.test(r) && (a = Ult(e, r)), this.setBaseTarget(e, Jc(a) ? a.get() : a)), Jc(a) ? a.get() : a;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, r) {
    this.baseTarget[e] = r;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    var r;
    const { initial: n } = this.props;
    let a;
    if (typeof n == "string" || typeof n == "object") {
      const o = Tve(this.props, n, (r = this.presenceContext) === null || r === void 0 ? void 0 : r.custom);
      o && (a = o[e]);
    }
    if (n && a !== void 0)
      return a;
    const i = this.getBaseTargetFromProps(this.props, e);
    return i !== void 0 && !Jc(i) ? i : this.initialValues[e] !== void 0 && a === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, r) {
    return this.events[e] || (this.events[e] = new Rve()), this.events[e].add(r);
  }
  notify(e, ...r) {
    this.events[e] && this.events[e].notify(...r);
  }
}
class Pct extends M_r {
  constructor() {
    super(...arguments), this.KeyframeResolver = Xlt;
  }
  sortInstanceNodePosition(e, r) {
    return e.compareDocumentPosition(r) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, r) {
    return e.style ? e.style[r] : void 0;
  }
  removeValueFromRenderState(e, { vars: r, style: n }) {
    delete r[e], delete n[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    Jc(e) && (this.childSubscription = e.on("change", (r) => {
      this.current && (this.current.textContent = `${r}`);
    }));
  }
}
function P_r(t) {
  return window.getComputedStyle(t);
}
class R_r extends Pct {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Clt;
  }
  readValueFromInstance(e, r) {
    if (v6.has(r)) {
      const n = Fve(r);
      return n && n.default || 0;
    } else {
      const n = P_r(e), a = (bve(r) ? n.getPropertyValue(r) : n[r]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: r }) {
    return gct(e, r);
  }
  build(e, r, n) {
    wve(e, r, n.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, r, n) {
    return Eve(e, r, n);
  }
}
class O_r extends Pct {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = nl, this.updateDimensions = () => {
      this.current && !this.renderState.dimensions && xlt(this.current, this.renderState);
    };
  }
  getBaseTargetFromProps(e, r) {
    return e[r];
  }
  readValueFromInstance(e, r) {
    if (v6.has(r)) {
      const n = Fve(r);
      return n && n.default || 0;
    }
    return r = wlt.has(r) ? r : vve(r), e.getAttribute(r);
  }
  scrapeMotionValuesFromProps(e, r, n) {
    return _lt(e, r, n);
  }
  onBindTransform() {
    this.current && !this.renderState.dimensions && cs.postRender(this.updateDimensions);
  }
  build(e, r, n) {
    kve(e, r, this.isSVGTag, n.transformTemplate);
  }
  renderInstance(e, r, n, a) {
    Slt(e, r, n, a);
  }
  mount(e) {
    this.isSVGTag = Ave(e.tagName), super.mount(e);
  }
}
const B_r = (t, e) => _ve(t) ? new O_r(e) : new R_r(e, {
  allowProjection: t !== qGe
}), N_r = /* @__PURE__ */ aCr({
  ...Zwr,
  ...S_r,
  ...i_r,
  ...__r
}, B_r), Vve = /* @__PURE__ */ x8r(N_r), Rct = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `AcceptIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[AcceptIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M16.669 6.315c.435.427.442 1.126.016 1.561L9.49 15.22a1.104 1.104 0 01-1.576 0l-3.598-3.663a1.104 1.104 0 111.575-1.546l2.81 2.86 6.407-6.539a1.104 1.104 0 011.56-.016z" })));
});
Rct.displayName = "AcceptIcon";
const $_r = ({
  verticalTravelDistancePx: t = 8,
  period: e = 0.15,
  numDots: r = 3,
  dotRadius: n = 2
}) => /* @__PURE__ */ R.jsx(_r, { display: "flex", columnGap: "space20", children: new Array(r).fill(null).map((a, i) => /* @__PURE__ */ R.jsx(
  Vve.div,
  {
    animate: {
      y: [0, -t, 0]
    },
    transition: {
      delay: i * e,
      duration: e * r,
      repeat: 1 / 0,
      ease: "easeInOut",
      repeatDelay: e * r + e
    },
    children: /* @__PURE__ */ R.jsx(
      "svg",
      {
        height: 2 * n,
        width: 2 * n,
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ R.jsx("circle", { cx: n, cy: n, r: n })
      }
    )
  },
  i
)) }), Oct = ({
  message: t,
  isComplete: e
}) => /* @__PURE__ */ R.jsx(
  Vve.div,
  {
    layout: !0,
    initial: { y: "100%" },
    animate: { y: "0%" },
    transition: { duration: 0.25 },
    children: /* @__PURE__ */ R.jsx("div", { className: "flex ", children: /* @__PURE__ */ R.jsxs(
      is,
      {
        backgroundColor: "colorBackgroundDecorative20Weakest",
        fontWeight: "fontWeightBold",
        paddingY: "space20",
        paddingX: "space40",
        display: "flex",
        columnGap: "space20",
        alignItems: e ? "center" : "end",
        children: [
          t,
          !e && /* @__PURE__ */ R.jsx(_r, { paddingBottom: "space20", paddingLeft: "space20", children: /* @__PURE__ */ R.jsx($_r, {}) }),
          e && /* @__PURE__ */ R.jsx(Rct, { decorative: !0, size: "sizeIcon10" })
        ]
      }
    ) })
  }
);
var Ree = {}, D_r = { ERROR: "alert", NEUTRAL: "status", WARNING: "alert" }, Oee = { ERROR: "error", NEUTRAL: "neutral", WARNING: "warning" }, L_r = { ERROR: "colorBackgroundErrorWeakest", NEUTRAL: "colorBackgroundNeutralWeakest", WARNING: "colorBackgroundWarningWeakest" }, j_r = { ERROR: "colorBorderErrorWeaker", NEUTRAL: "colorBorderNeutralWeaker", WARNING: "colorBorderWarningWeaker" }, F_r = { ERROR: "colorTextError", NEUTRAL: "colorTextNeutral", WARNING: "colorTextWarningStrong" }, z_r = (t, e, r) => {
  switch (t) {
    case Oee.ERROR:
      return P.createElement(fy, { element: `${e}_ICON`, color: "colorTextIconError", decorative: !1, title: r, size: "sizeIcon20" });
    case Oee.WARNING:
      return P.createElement(hM, { element: `${e}_ICON`, color: "colorTextIconWarning", decorative: !1, title: r, size: "sizeIcon20" });
    case Oee.NEUTRAL:
    default:
      return P.createElement(vW, { element: `${e}_ICON`, color: "colorTextIconNeutral", decorative: !1, title: r, size: "sizeIcon20" });
  }
}, Bct = P.forwardRef(({ children: t, onDismiss: e, variant: r, role: n, element: a = "ALERT", i18nDismissLabel: i = "Dismiss alert", i18nErrorLabel: o = "(error)", i18nNeutralLabel: s = "(information)", i18nWarningLabel: l = "(warning)", ...c }, u) => {
  let f = { error: o, neutral: s, warning: l };
  return P.createElement(ht, { ...Xt(c), backgroundColor: L_r[r.toUpperCase()], borderColor: j_r[r.toUpperCase()], borderStyle: "solid", borderWidth: "borderWidth10", borderRadius: "borderRadius30", padding: "space50", element: a, variant: r, ref: u, role: n ?? D_r[r.toUpperCase()] }, P.createElement(Q5, { as: "div" }, P.createElement(qm, { as: "div", spacing: "space30" }, z_r(r, a, f[r])), P.createElement(e6, { as: "div" }, P.createElement(ht, { color: F_r[r.toUpperCase()] }, t)), e && typeof e == "function" && P.createElement(qm, { align: "end", spacing: "space60" }, P.createElement(Zs, { onClick: e, variant: "secondary_icon", size: "reset", element: `${a}_DISMISS_BUTTON` }, P.createElement(Dy, { element: `${a}_DISMISS_ICON`, color: "colorTextIcon", decorative: !0, size: "sizeIcon20" }), P.createElement(Ul, null, i)))));
});
Bct.displayName = "Alert";
const G_r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Alert: Bct
}, Symbol.toStringTag, { value: "Module" })), W_r = /* @__PURE__ */ aa(G_r);
var QEe;
function H_r() {
  return QEe || (QEe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = W_r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Ree)), Ree;
}
var U_r = /* @__PURE__ */ H_r();
const V_r = ha.object({
  hAlignContent: ha.enum(["center", "right", "left", "around", "between"]).default("left"),
  vAlignContent: ha.enum(["center", "top", "bottom", "stretch"]).default("top"),
  wrap: ha.boolean().default(!1)
}), Nct = ha.object({
  label: A5,
  variant: ha.enum(["primary", "secondary", "destructive", "link"]),
  size: ha.enum(["default", "small", "rounded_small"]).default("default"),
  action: ha.object({
    type: ha.enum([
      l0.SEND_MESSAGE,
      l0.OPEN_URL,
      l0.DIRECT_LIVE_CHAT_TRANSFER
    ]),
    values: ha.record(ha.any()).optional()
  }).optional()
}), q_r = ha.object({
  buttonGroup: V_r,
  buttons: ha.array(Nct)
}), K_r = ({ block: t }) => {
  let e;
  try {
    e = q_r.parse(t.values);
  } catch {
    return /* @__PURE__ */ R.jsx($a, { error: "Invalid values" });
  }
  const r = Ume(), n = (a) => {
    if (!a.action) {
      console.warn("Button has no action");
      return;
    }
    const i = r[a.action.type];
    if (!i) {
      console.warn(`Action ${a.action.type} not implemented`);
      return;
    }
    i(a.action.values);
  };
  return /* @__PURE__ */ R.jsx(
    Hnt.Flex,
    {
      hAlignContent: e.buttonGroup.hAlignContent || "left",
      vAlignContent: e.buttonGroup.vAlignContent || "top",
      wrap: e.buttonGroup.wrap || !1,
      children: e.buttons.map((a) => /* @__PURE__ */ R.jsx(ar.Box, { marginBottom: "space40", marginRight: "space40", children: /* @__PURE__ */ R.jsx(
        zi.Button,
        {
          variant: a.variant,
          size: a.size,
          onClick: () => n(a),
          children: a.label
        }
      ) }, a.label))
    }
  );
};
var Bee = {}, $ct = P.forwardRef(({ children: t, element: e = "OPTION", ...r }, n) => (r.selected && console.warn('"selected" is a blocked prop on this component, please use "value" on the select element.'), P.createElement(ht, { as: "option", ref: n, ...Xt(r), element: e, size: void 0, height: void 0, width: void 0, backgroundColor: "inherit", color: "inherit", fontFamily: "inherit", lineHeight: "lineHeight50", paddingTop: "space30", paddingBottom: "space30", paddingLeft: "space20" }, t)));
$ct.displayName = "Option";
var Dct = P.forwardRef(({ label: t, children: e, element: r = "OPTION_GROUP", ...n }, a) => P.createElement(ht, { ref: a, label: t, ...Xt(n), element: r, as: "optgroup", backgroundColor: "inherit", color: "inherit", fontFamily: "inherit", fontWeight: "fontWeightMedium", fontStyle: "normal", margin: "space20" }, e));
Dct.displayName = "OptionGroup";
var mj = P.forwardRef(({ element: t = "SELECT_ELEMENT", variant: e, size: r, ...n }, a) => P.createElement(ht, { ...Xt(n), element: t, as: "select", ref: a, size: r, height: void 0, appearance: "none", backgroundColor: e === "inverse" ? "colorBackgroundInverse" : "colorBackgroundBody", border: "none", borderRadius: "borderRadius20", boxShadow: "none", color: "inherit", cursor: "pointer", display: "block", fontFamily: "inherit", fontSize: "fontSize30", fontWeight: "fontWeightMedium", lineHeight: "lineHeight20", margin: "space0", outline: "none", paddingBottom: "space30", paddingLeft: "space40", paddingRight: "space100", paddingTop: "space30", resize: "none", width: "100%", _disabled: { color: e === "inverse" ? "colorTextInverseWeakest" : "colorTextWeaker", backgroundColor: "transparent", cursor: "not-allowed", opacity: 1 }, variant: e }));
mj.displayName = "SelectElement";
var Lct = P.forwardRef(({ disabled: t, element: e = "SELECT", hasError: r, insertBefore: n, insertAfter: a, children: i, size: o, multiple: s, variant: l = "default", ...c }, u) => {
  let [f, h] = P.useState(!1);
  return P.useEffect(() => {
    h(!0);
  }, []), P.createElement(M8, { disabled: t, element: e, hasError: r, insertAfter: a, insertBefore: n, variant: l }, P.createElement(ht, { display: "flex", width: "100%", position: "relative" }, f ? P.createElement(mj, { "aria-invalid": r, "data-not-selectize": "true", disabled: t, ref: u, element: `${e}_ELEMENT`, ...c, multiple: s, size: s ? o : 0, variant: l, key: "mounted" }, i) : P.createElement(mj, { key: "unmounted" }), !s && P.createElement(sG, { element: `${e}_CHEVRON_WRAPPER` }, P.createElement(I8, { "aria-hidden": "true", decorative: !0, element: `${e}_ICON`, color: Gpe(l, t, !1), size: "sizeIcon30" }))));
});
Lct.displayName = "Select";
const Z_r = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Option: $ct,
  OptionGroup: Dct,
  Select: Lct,
  SelectElement: mj
}, Symbol.toStringTag, { value: "Module" })), J_r = /* @__PURE__ */ aa(Z_r);
var eIe;
function Y_r() {
  return eIe || (eIe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = J_r;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Bee)), Bee;
}
var K0 = /* @__PURE__ */ Y_r();
const qve = ({ color: t = "currentColor", size: e = 24, className: r, ...n }) => Te.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...n, className: "remixicon " + (r || "") }, Te.createElement("path", { d: "M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" })), Kve = ({ color: t = "currentColor", size: e = 24, className: r, ...n }) => Te.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...n, className: "remixicon " + (r || "") }, Te.createElement("path", { d: "M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" })), X_r = ({ color: t = "currentColor", size: e = 24, className: r, ...n }) => Te.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...n, className: "remixicon " + (r || "") }, Te.createElement("path", { d: "M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" })), Q_r = ({ color: t = "currentColor", size: e = 24, className: r, ...n }) => Te.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: e, height: e, fill: t, ...n, className: "remixicon " + (r || "") }, Te.createElement("path", { d: "M12 2C12.5523 2 13 2.44772 13 3V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V3C11 2.44772 11.4477 2 12 2ZM12 17C12.5523 17 13 17.4477 13 18V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18C11 17.4477 11.4477 17 12 17ZM22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21C21.5523 11 22 11.4477 22 12ZM7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6C6.55228 11 7 11.4477 7 12ZM19.0711 19.0711C18.6805 19.4616 18.0474 19.4616 17.6569 19.0711L15.5355 16.9497C15.145 16.5592 15.145 15.9261 15.5355 15.5355C15.9261 15.145 16.5592 15.145 16.9497 15.5355L19.0711 17.6569C19.4616 18.0474 19.4616 18.6805 19.0711 19.0711ZM8.46447 8.46447C8.07394 8.85499 7.44078 8.85499 7.05025 8.46447L4.92893 6.34315C4.53841 5.95262 4.53841 5.31946 4.92893 4.92893C5.31946 4.53841 5.95262 4.53841 6.34315 4.92893L8.46447 7.05025C8.85499 7.44078 8.85499 8.07394 8.46447 8.46447ZM4.92893 19.0711C4.53841 18.6805 4.53841 18.0474 4.92893 17.6569L7.05025 15.5355C7.44078 15.145 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 8.85499 16.5592 8.46447 16.9497L6.34315 19.0711C5.95262 19.4616 5.31946 19.4616 4.92893 19.0711ZM15.5355 8.46447C15.145 8.07394 15.145 7.44078 15.5355 7.05025L17.6569 4.92893C18.0474 4.53841 18.6805 4.53841 19.0711 4.92893C19.4616 5.31946 19.4616 5.95262 19.0711 6.34315L16.9497 8.46447C16.5592 8.85499 15.9261 8.85499 15.5355 8.46447Z" }));
function jct(t) {
  var e, r, n = "";
  if (typeof t == "string" || typeof t == "number") n += t;
  else if (typeof t == "object") if (Array.isArray(t)) {
    var a = t.length;
    for (e = 0; e < a; e++) t[e] && (r = jct(t[e])) && (n && (n += " "), n += r);
  } else for (r in t) t[r] && (n && (n += " "), n += r);
  return n;
}
function ti() {
  for (var t, e, r = 0, n = "", a = arguments.length; r < a; r++) (t = arguments[r]) && (e = jct(t)) && (n && (n += " "), n += e);
  return n;
}
var Nee, tIe;
function Od() {
  if (tIe) return Nee;
  tIe = 1;
  var t = Array.isArray;
  return Nee = t, Nee;
}
var $ee, rIe;
function Fct() {
  if (rIe) return $ee;
  rIe = 1;
  var t = typeof wl == "object" && wl && wl.Object === Object && wl;
  return $ee = t, $ee;
}
var Dee, nIe;
function op() {
  if (nIe) return Dee;
  nIe = 1;
  var t = Fct(), e = typeof self == "object" && self && self.Object === Object && self, r = t || e || Function("return this")();
  return Dee = r, Dee;
}
var Lee, aIe;
function iP() {
  if (aIe) return Lee;
  aIe = 1;
  var t = op(), e = t.Symbol;
  return Lee = e, Lee;
}
var jee, iIe;
function ekr() {
  if (iIe) return jee;
  iIe = 1;
  var t = iP(), e = Object.prototype, r = e.hasOwnProperty, n = e.toString, a = t ? t.toStringTag : void 0;
  function i(o) {
    var s = r.call(o, a), l = o[a];
    try {
      o[a] = void 0;
      var c = !0;
    } catch {
    }
    var u = n.call(o);
    return c && (s ? o[a] = l : delete o[a]), u;
  }
  return jee = i, jee;
}
var Fee, oIe;
function tkr() {
  if (oIe) return Fee;
  oIe = 1;
  var t = Object.prototype, e = t.toString;
  function r(n) {
    return e.call(n);
  }
  return Fee = r, Fee;
}
var zee, sIe;
function yg() {
  if (sIe) return zee;
  sIe = 1;
  var t = iP(), e = ekr(), r = tkr(), n = "[object Null]", a = "[object Undefined]", i = t ? t.toStringTag : void 0;
  function o(s) {
    return s == null ? s === void 0 ? a : n : i && i in Object(s) ? e(s) : r(s);
  }
  return zee = o, zee;
}
var Gee, lIe;
function bg() {
  if (lIe) return Gee;
  lIe = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return Gee = t, Gee;
}
var Wee, cIe;
function rC() {
  if (cIe) return Wee;
  cIe = 1;
  var t = yg(), e = bg(), r = "[object Symbol]";
  function n(a) {
    return typeof a == "symbol" || e(a) && t(a) == r;
  }
  return Wee = n, Wee;
}
var Hee, uIe;
function Zve() {
  if (uIe) return Hee;
  uIe = 1;
  var t = Od(), e = rC(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function a(i, o) {
    if (t(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || e(i) ? !0 : n.test(i) || !r.test(i) || o != null && i in Object(o);
  }
  return Hee = a, Hee;
}
var Uee, dIe;
function Zy() {
  if (dIe) return Uee;
  dIe = 1;
  function t(e) {
    var r = typeof e;
    return e != null && (r == "object" || r == "function");
  }
  return Uee = t, Uee;
}
var Vee, fIe;
function Jve() {
  if (fIe) return Vee;
  fIe = 1;
  var t = yg(), e = Zy(), r = "[object AsyncFunction]", n = "[object Function]", a = "[object GeneratorFunction]", i = "[object Proxy]";
  function o(s) {
    if (!e(s))
      return !1;
    var l = t(s);
    return l == n || l == a || l == r || l == i;
  }
  return Vee = o, Vee;
}
var qee, hIe;
function rkr() {
  if (hIe) return qee;
  hIe = 1;
  var t = op(), e = t["__core-js_shared__"];
  return qee = e, qee;
}
var Kee, pIe;
function nkr() {
  if (pIe) return Kee;
  pIe = 1;
  var t = rkr(), e = function() {
    var n = /[^.]+$/.exec(t && t.keys && t.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!e && e in n;
  }
  return Kee = r, Kee;
}
var Zee, mIe;
function zct() {
  if (mIe) return Zee;
  mIe = 1;
  var t = Function.prototype, e = t.toString;
  function r(n) {
    if (n != null) {
      try {
        return e.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Zee = r, Zee;
}
var Jee, gIe;
function akr() {
  if (gIe) return Jee;
  gIe = 1;
  var t = Jve(), e = nkr(), r = Zy(), n = zct(), a = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, o = Function.prototype, s = Object.prototype, l = o.toString, c = s.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || e(h))
      return !1;
    var p = t(h) ? u : i;
    return p.test(n(h));
  }
  return Jee = f, Jee;
}
var Yee, vIe;
function ikr() {
  if (vIe) return Yee;
  vIe = 1;
  function t(e, r) {
    return e == null ? void 0 : e[r];
  }
  return Yee = t, Yee;
}
var Xee, yIe;
function y6() {
  if (yIe) return Xee;
  yIe = 1;
  var t = akr(), e = ikr();
  function r(n, a) {
    var i = e(n, a);
    return t(i) ? i : void 0;
  }
  return Xee = r, Xee;
}
var Qee, bIe;
function jW() {
  if (bIe) return Qee;
  bIe = 1;
  var t = y6(), e = t(Object, "create");
  return Qee = e, Qee;
}
var ete, xIe;
function okr() {
  if (xIe) return ete;
  xIe = 1;
  var t = jW();
  function e() {
    this.__data__ = t ? t(null) : {}, this.size = 0;
  }
  return ete = e, ete;
}
var tte, CIe;
function skr() {
  if (CIe) return tte;
  CIe = 1;
  function t(e) {
    var r = this.has(e) && delete this.__data__[e];
    return this.size -= r ? 1 : 0, r;
  }
  return tte = t, tte;
}
var rte, wIe;
function lkr() {
  if (wIe) return rte;
  wIe = 1;
  var t = jW(), e = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    var o = this.__data__;
    if (t) {
      var s = o[i];
      return s === e ? void 0 : s;
    }
    return n.call(o, i) ? o[i] : void 0;
  }
  return rte = a, rte;
}
var nte, SIe;
function ckr() {
  if (SIe) return nte;
  SIe = 1;
  var t = jW(), e = Object.prototype, r = e.hasOwnProperty;
  function n(a) {
    var i = this.__data__;
    return t ? i[a] !== void 0 : r.call(i, a);
  }
  return nte = n, nte;
}
var ate, _Ie;
function ukr() {
  if (_Ie) return ate;
  _Ie = 1;
  var t = jW(), e = "__lodash_hash_undefined__";
  function r(n, a) {
    var i = this.__data__;
    return this.size += this.has(n) ? 0 : 1, i[n] = t && a === void 0 ? e : a, this;
  }
  return ate = r, ate;
}
var ite, kIe;
function dkr() {
  if (kIe) return ite;
  kIe = 1;
  var t = okr(), e = skr(), r = lkr(), n = ckr(), a = ukr();
  function i(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, ite = i, ite;
}
var ote, AIe;
function fkr() {
  if (AIe) return ote;
  AIe = 1;
  function t() {
    this.__data__ = [], this.size = 0;
  }
  return ote = t, ote;
}
var ste, TIe;
function Yve() {
  if (TIe) return ste;
  TIe = 1;
  function t(e, r) {
    return e === r || e !== e && r !== r;
  }
  return ste = t, ste;
}
var lte, EIe;
function FW() {
  if (EIe) return lte;
  EIe = 1;
  var t = Yve();
  function e(r, n) {
    for (var a = r.length; a--; )
      if (t(r[a][0], n))
        return a;
    return -1;
  }
  return lte = e, lte;
}
var cte, IIe;
function hkr() {
  if (IIe) return cte;
  IIe = 1;
  var t = FW(), e = Array.prototype, r = e.splice;
  function n(a) {
    var i = this.__data__, o = t(i, a);
    if (o < 0)
      return !1;
    var s = i.length - 1;
    return o == s ? i.pop() : r.call(i, o, 1), --this.size, !0;
  }
  return cte = n, cte;
}
var ute, MIe;
function pkr() {
  if (MIe) return ute;
  MIe = 1;
  var t = FW();
  function e(r) {
    var n = this.__data__, a = t(n, r);
    return a < 0 ? void 0 : n[a][1];
  }
  return ute = e, ute;
}
var dte, PIe;
function mkr() {
  if (PIe) return dte;
  PIe = 1;
  var t = FW();
  function e(r) {
    return t(this.__data__, r) > -1;
  }
  return dte = e, dte;
}
var fte, RIe;
function gkr() {
  if (RIe) return fte;
  RIe = 1;
  var t = FW();
  function e(r, n) {
    var a = this.__data__, i = t(a, r);
    return i < 0 ? (++this.size, a.push([r, n])) : a[i][1] = n, this;
  }
  return fte = e, fte;
}
var hte, OIe;
function zW() {
  if (OIe) return hte;
  OIe = 1;
  var t = fkr(), e = hkr(), r = pkr(), n = mkr(), a = gkr();
  function i(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, hte = i, hte;
}
var pte, BIe;
function Xve() {
  if (BIe) return pte;
  BIe = 1;
  var t = y6(), e = op(), r = t(e, "Map");
  return pte = r, pte;
}
var mte, NIe;
function vkr() {
  if (NIe) return mte;
  NIe = 1;
  var t = dkr(), e = zW(), r = Xve();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new t(),
      map: new (r || e)(),
      string: new t()
    };
  }
  return mte = n, mte;
}
var gte, $Ie;
function ykr() {
  if ($Ie) return gte;
  $Ie = 1;
  function t(e) {
    var r = typeof e;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
  }
  return gte = t, gte;
}
var vte, DIe;
function GW() {
  if (DIe) return vte;
  DIe = 1;
  var t = ykr();
  function e(r, n) {
    var a = r.__data__;
    return t(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
  }
  return vte = e, vte;
}
var yte, LIe;
function bkr() {
  if (LIe) return yte;
  LIe = 1;
  var t = GW();
  function e(r) {
    var n = t(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return yte = e, yte;
}
var bte, jIe;
function xkr() {
  if (jIe) return bte;
  jIe = 1;
  var t = GW();
  function e(r) {
    return t(this, r).get(r);
  }
  return bte = e, bte;
}
var xte, FIe;
function Ckr() {
  if (FIe) return xte;
  FIe = 1;
  var t = GW();
  function e(r) {
    return t(this, r).has(r);
  }
  return xte = e, xte;
}
var Cte, zIe;
function wkr() {
  if (zIe) return Cte;
  zIe = 1;
  var t = GW();
  function e(r, n) {
    var a = t(this, r), i = a.size;
    return a.set(r, n), this.size += a.size == i ? 0 : 1, this;
  }
  return Cte = e, Cte;
}
var wte, GIe;
function Qve() {
  if (GIe) return wte;
  GIe = 1;
  var t = vkr(), e = bkr(), r = xkr(), n = Ckr(), a = wkr();
  function i(o) {
    var s = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++s < l; ) {
      var c = o[s];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = r, i.prototype.has = n, i.prototype.set = a, wte = i, wte;
}
var Ste, WIe;
function Gct() {
  if (WIe) return Ste;
  WIe = 1;
  var t = Qve(), e = "Expected a function";
  function r(n, a) {
    if (typeof n != "function" || a != null && typeof a != "function")
      throw new TypeError(e);
    var i = function() {
      var o = arguments, s = a ? a.apply(this, o) : o[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var c = n.apply(this, o);
      return i.cache = l.set(s, c) || l, c;
    };
    return i.cache = new (r.Cache || t)(), i;
  }
  return r.Cache = t, Ste = r, Ste;
}
var _te, HIe;
function Skr() {
  if (HIe) return _te;
  HIe = 1;
  var t = Gct(), e = 500;
  function r(n) {
    var a = t(n, function(o) {
      return i.size === e && i.clear(), o;
    }), i = a.cache;
    return a;
  }
  return _te = r, _te;
}
var kte, UIe;
function _kr() {
  if (UIe) return kte;
  UIe = 1;
  var t = Skr(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = t(function(a) {
    var i = [];
    return a.charCodeAt(0) === 46 && i.push(""), a.replace(e, function(o, s, l, c) {
      i.push(l ? c.replace(r, "$1") : s || o);
    }), i;
  });
  return kte = n, kte;
}
var Ate, VIe;
function eye() {
  if (VIe) return Ate;
  VIe = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length, i = Array(a); ++n < a; )
      i[n] = r(e[n], n, e);
    return i;
  }
  return Ate = t, Ate;
}
var Tte, qIe;
function kkr() {
  if (qIe) return Tte;
  qIe = 1;
  var t = iP(), e = eye(), r = Od(), n = rC(), a = t ? t.prototype : void 0, i = a ? a.toString : void 0;
  function o(s) {
    if (typeof s == "string")
      return s;
    if (r(s))
      return e(s, o) + "";
    if (n(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return Tte = o, Tte;
}
var Ete, KIe;
function Wct() {
  if (KIe) return Ete;
  KIe = 1;
  var t = kkr();
  function e(r) {
    return r == null ? "" : t(r);
  }
  return Ete = e, Ete;
}
var Ite, ZIe;
function Hct() {
  if (ZIe) return Ite;
  ZIe = 1;
  var t = Od(), e = Zve(), r = _kr(), n = Wct();
  function a(i, o) {
    return t(i) ? i : e(i, o) ? [i] : r(n(i));
  }
  return Ite = a, Ite;
}
var Mte, JIe;
function WW() {
  if (JIe) return Mte;
  JIe = 1;
  var t = rC();
  function e(r) {
    if (typeof r == "string" || t(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return Mte = e, Mte;
}
var Pte, YIe;
function tye() {
  if (YIe) return Pte;
  YIe = 1;
  var t = Hct(), e = WW();
  function r(n, a) {
    a = t(a, n);
    for (var i = 0, o = a.length; n != null && i < o; )
      n = n[e(a[i++])];
    return i && i == o ? n : void 0;
  }
  return Pte = r, Pte;
}
var Rte, XIe;
function Uct() {
  if (XIe) return Rte;
  XIe = 1;
  var t = tye();
  function e(r, n, a) {
    var i = r == null ? void 0 : t(r, n);
    return i === void 0 ? a : i;
  }
  return Rte = e, Rte;
}
var Akr = Uct();
const u0 = /* @__PURE__ */ Gi(Akr);
var Ote, QIe;
function Tkr() {
  if (QIe) return Ote;
  QIe = 1;
  function t(e) {
    return e == null;
  }
  return Ote = t, Ote;
}
var Ekr = Tkr();
const Va = /* @__PURE__ */ Gi(Ekr);
var Bte, eMe;
function Ikr() {
  if (eMe) return Bte;
  eMe = 1;
  var t = yg(), e = Od(), r = bg(), n = "[object String]";
  function a(i) {
    return typeof i == "string" || !e(i) && r(i) && t(i) == n;
  }
  return Bte = a, Bte;
}
var Mkr = Ikr();
const oP = /* @__PURE__ */ Gi(Mkr);
var Pkr = Jve();
const ua = /* @__PURE__ */ Gi(Pkr);
var Rkr = Zy();
const nC = /* @__PURE__ */ Gi(Rkr);
var ZB = { exports: {} }, To = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tMe;
function Okr() {
  if (tMe) return To;
  tMe = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function y(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case t:
          switch (b = b.type, b) {
            case r:
            case a:
            case n:
            case c:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case o:
                case l:
                case h:
                case f:
                case i:
                  return b;
                default:
                  return w;
              }
          }
        case e:
          return w;
      }
    }
  }
  return To.ContextConsumer = o, To.ContextProvider = i, To.Element = t, To.ForwardRef = l, To.Fragment = r, To.Lazy = h, To.Memo = f, To.Portal = e, To.Profiler = a, To.StrictMode = n, To.Suspense = c, To.SuspenseList = u, To.isAsyncMode = function() {
    return !1;
  }, To.isConcurrentMode = function() {
    return !1;
  }, To.isContextConsumer = function(b) {
    return y(b) === o;
  }, To.isContextProvider = function(b) {
    return y(b) === i;
  }, To.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, To.isForwardRef = function(b) {
    return y(b) === l;
  }, To.isFragment = function(b) {
    return y(b) === r;
  }, To.isLazy = function(b) {
    return y(b) === h;
  }, To.isMemo = function(b) {
    return y(b) === f;
  }, To.isPortal = function(b) {
    return y(b) === e;
  }, To.isProfiler = function(b) {
    return y(b) === a;
  }, To.isStrictMode = function(b) {
    return y(b) === n;
  }, To.isSuspense = function(b) {
    return y(b) === c;
  }, To.isSuspenseList = function(b) {
    return y(b) === u;
  }, To.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === r || b === a || b === n || b === c || b === u || b === p || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === f || b.$$typeof === i || b.$$typeof === o || b.$$typeof === l || b.$$typeof === g || b.getModuleId !== void 0);
  }, To.typeOf = y, To;
}
var Eo = {}, rMe;
function Bkr() {
  return rMe || (rMe = 1, Qa.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = !1, y = !1, b = !1, w = !1, _ = !1, C;
    C = Symbol.for("react.module.reference");
    function x(Fe) {
      return !!(typeof Fe == "string" || typeof Fe == "function" || Fe === r || Fe === a || _ || Fe === n || Fe === c || Fe === u || w || Fe === p || g || y || b || typeof Fe == "object" && Fe !== null && (Fe.$$typeof === h || Fe.$$typeof === f || Fe.$$typeof === i || Fe.$$typeof === o || Fe.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Fe.$$typeof === C || Fe.getModuleId !== void 0));
    }
    function S(Fe) {
      if (typeof Fe == "object" && Fe !== null) {
        var it = Fe.$$typeof;
        switch (it) {
          case t:
            var gt = Fe.type;
            switch (gt) {
              case r:
              case a:
              case n:
              case c:
              case u:
                return gt;
              default:
                var Ze = gt && gt.$$typeof;
                switch (Ze) {
                  case s:
                  case o:
                  case l:
                  case h:
                  case f:
                  case i:
                    return Ze;
                  default:
                    return it;
                }
            }
          case e:
            return it;
        }
      }
    }
    var A = o, I = i, M = t, B = l, L = r, N = h, d = f, m = e, v = a, k = n, O = c, G = u, H = !1, j = !1;
    function F(Fe) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(Fe) {
      return j || (j = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function W(Fe) {
      return S(Fe) === o;
    }
    function U(Fe) {
      return S(Fe) === i;
    }
    function Z(Fe) {
      return typeof Fe == "object" && Fe !== null && Fe.$$typeof === t;
    }
    function V(Fe) {
      return S(Fe) === l;
    }
    function Y(Fe) {
      return S(Fe) === r;
    }
    function ge(Fe) {
      return S(Fe) === h;
    }
    function ce(Fe) {
      return S(Fe) === f;
    }
    function ee(Fe) {
      return S(Fe) === e;
    }
    function Se(Fe) {
      return S(Fe) === a;
    }
    function Ce(Fe) {
      return S(Fe) === n;
    }
    function we(Fe) {
      return S(Fe) === c;
    }
    function We(Fe) {
      return S(Fe) === u;
    }
    Eo.ContextConsumer = A, Eo.ContextProvider = I, Eo.Element = M, Eo.ForwardRef = B, Eo.Fragment = L, Eo.Lazy = N, Eo.Memo = d, Eo.Portal = m, Eo.Profiler = v, Eo.StrictMode = k, Eo.Suspense = O, Eo.SuspenseList = G, Eo.isAsyncMode = F, Eo.isConcurrentMode = z, Eo.isContextConsumer = W, Eo.isContextProvider = U, Eo.isElement = Z, Eo.isForwardRef = V, Eo.isFragment = Y, Eo.isLazy = ge, Eo.isMemo = ce, Eo.isPortal = ee, Eo.isProfiler = Se, Eo.isStrictMode = Ce, Eo.isSuspense = we, Eo.isSuspenseList = We, Eo.isValidElementType = x, Eo.typeOf = S;
  }()), Eo;
}
var nMe;
function rye() {
  return nMe || (nMe = 1, Qa.env.NODE_ENV === "production" ? ZB.exports = Okr() : ZB.exports = Bkr()), ZB.exports;
}
var Nkr = rye(), Nte, aMe;
function Vct() {
  if (aMe) return Nte;
  aMe = 1;
  var t = yg(), e = bg(), r = "[object Number]";
  function n(a) {
    return typeof a == "number" || e(a) && t(a) == r;
  }
  return Nte = n, Nte;
}
var $te, iMe;
function $kr() {
  if (iMe) return $te;
  iMe = 1;
  var t = Vct();
  function e(r) {
    return t(r) && r != +r;
  }
  return $te = e, $te;
}
var Dkr = $kr();
const aC = /* @__PURE__ */ Gi(Dkr);
var Lkr = Vct();
const jkr = /* @__PURE__ */ Gi(Lkr);
var Su = function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}, vb = function(e) {
  return oP(e) && e.indexOf("%") === e.length - 1;
}, Ur = function(e) {
  return jkr(e) && !aC(e);
}, Hl = function(e) {
  return Ur(e) || oP(e);
}, Fkr = 0, b6 = function(e) {
  var r = ++Fkr;
  return "".concat(e || "").concat(r);
}, _u = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!Ur(e) && !oP(e))
    return n;
  var i;
  if (vb(e)) {
    var o = e.indexOf("%");
    i = r * parseFloat(e.slice(0, o)) / 100;
  } else
    i = +e;
  return aC(i) && (i = n), a && i > r && (i = r), i;
}, vv = function(e) {
  if (!e)
    return null;
  var r = Object.keys(e);
  return r && r.length ? e[r[0]] : null;
}, zkr = function(e) {
  if (!Array.isArray(e))
    return !1;
  for (var r = e.length, n = {}, a = 0; a < r; a++)
    if (!n[e[a]])
      n[e[a]] = !0;
    else
      return !0;
  return !1;
}, Gl = function(e, r) {
  return Ur(e) && Ur(r) ? function(n) {
    return e + n * (r - e);
  } : function() {
    return r;
  };
};
function gj(t, e, r) {
  return !t || !t.length ? null : t.find(function(n) {
    return n && (typeof e == "function" ? e(n) : u0(n, e)) === r;
  });
}
function k7(t, e) {
  for (var r in t)
    if ({}.hasOwnProperty.call(t, r) && (!{}.hasOwnProperty.call(e, r) || t[r] !== e[r]))
      return !1;
  for (var n in e)
    if ({}.hasOwnProperty.call(e, n) && !{}.hasOwnProperty.call(t, n))
      return !1;
  return !0;
}
function Mde(t) {
  "@babel/helpers - typeof";
  return Mde = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mde(t);
}
var Gkr = ["viewBox", "children"], Wkr = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], oMe = ["points", "pathLength"], Dte = {
  svg: Gkr,
  polygon: oMe,
  polyline: oMe
}, nye = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], vj = function(e, r) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var n = e;
  if (/* @__PURE__ */ ef(e) && (n = e.props), !nC(n))
    return null;
  var a = {};
  return Object.keys(n).forEach(function(i) {
    nye.includes(i) && (a[i] = r || function(o) {
      return n[i](n, o);
    });
  }), a;
}, Hkr = function(e, r, n) {
  return function(a) {
    return e(r, n, a), null;
  };
}, M5 = function(e, r, n) {
  if (!nC(e) || Mde(e) !== "object")
    return null;
  var a = null;
  return Object.keys(e).forEach(function(i) {
    var o = e[i];
    nye.includes(i) && typeof o == "function" && (a || (a = {}), a[i] = Hkr(o, r, n));
  }), a;
}, Ukr = ["children"], Vkr = ["children"];
function sMe(t, e) {
  if (t == null) return {};
  var r = qkr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function qkr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Pde(t) {
  "@babel/helpers - typeof";
  return Pde = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pde(t);
}
var lMe = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Im = function(e) {
  return typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "";
}, cMe = null, Lte = null, aye = function t(e) {
  if (e === cMe && Array.isArray(Lte))
    return Lte;
  var r = [];
  return Pv.forEach(e, function(n) {
    Va(n) || (Nkr.isFragment(n) ? r = r.concat(t(n.props.children)) : r.push(n));
  }), Lte = r, cMe = e, r;
};
function d0(t, e) {
  var r = [], n = [];
  return Array.isArray(e) ? n = e.map(function(a) {
    return Im(a);
  }) : n = [Im(e)], aye(t).forEach(function(a) {
    var i = u0(a, "type.displayName") || u0(a, "type.name");
    n.indexOf(i) !== -1 && r.push(a);
  }), r;
}
function Zd(t, e) {
  var r = d0(t, e);
  return r && r[0];
}
var uMe = function(e) {
  if (!e || !e.props)
    return !1;
  var r = e.props, n = r.width, a = r.height;
  return !(!Ur(n) || n <= 0 || !Ur(a) || a <= 0);
}, Kkr = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], Zkr = function(e) {
  return e && e.type && oP(e.type) && Kkr.indexOf(e.type) >= 0;
}, qct = function(e) {
  return e && Pde(e) === "object" && "clipDot" in e;
}, Jkr = function(e, r, n, a) {
  var i, o = (i = Dte == null ? void 0 : Dte[a]) !== null && i !== void 0 ? i : [];
  return !ua(e) && (a && o.includes(r) || Wkr.includes(r)) || n && nye.includes(r);
}, Un = function(e, r, n) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var a = e;
  if (/* @__PURE__ */ ef(e) && (a = e.props), !nC(a))
    return null;
  var i = {};
  return Object.keys(a).forEach(function(o) {
    var s;
    Jkr((s = a) === null || s === void 0 ? void 0 : s[o], o, r, n) && (i[o] = a[o]);
  }), i;
}, Rde = function t(e, r) {
  if (e === r)
    return !0;
  var n = Pv.count(e);
  if (n !== Pv.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return dMe(Array.isArray(e) ? e[0] : e, Array.isArray(r) ? r[0] : r);
  for (var a = 0; a < n; a++) {
    var i = e[a], o = r[a];
    if (Array.isArray(i) || Array.isArray(o)) {
      if (!t(i, o))
        return !1;
    } else if (!dMe(i, o))
      return !1;
  }
  return !0;
}, dMe = function(e, r) {
  if (Va(e) && Va(r))
    return !0;
  if (!Va(e) && !Va(r)) {
    var n = e.props || {}, a = n.children, i = sMe(n, Ukr), o = r.props || {}, s = o.children, l = sMe(o, Vkr);
    return a && s ? k7(i, l) && Rde(a, s) : !a && !s ? k7(i, l) : !1;
  }
  return !1;
}, fMe = function(e, r) {
  var n = [], a = {};
  return aye(e).forEach(function(i, o) {
    if (Zkr(i))
      n.push(i);
    else if (i) {
      var s = Im(i.type), l = r[s] || {}, c = l.handler, u = l.once;
      if (c && (!u || !a[s])) {
        var f = c(i, s, o);
        n.push(f), a[s] = !0;
      }
    }
  }), n;
}, Ykr = function(e) {
  var r = e && e.type;
  return r && lMe[r] ? lMe[r] : null;
}, Xkr = function(e, r) {
  return aye(r).indexOf(e);
}, Qkr = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function Ode() {
  return Ode = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Ode.apply(this, arguments);
}
function eAr(t, e) {
  if (t == null) return {};
  var r = tAr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function tAr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Bde(t) {
  var e = t.children, r = t.width, n = t.height, a = t.viewBox, i = t.className, o = t.style, s = t.title, l = t.desc, c = eAr(t, Qkr), u = a || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = ti("recharts-surface", i);
  return /* @__PURE__ */ Te.createElement("svg", Ode({}, Un(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ Te.createElement("title", null, s), /* @__PURE__ */ Te.createElement("desc", null, l), e);
}
var rAr = ["children", "className"];
function Nde() {
  return Nde = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Nde.apply(this, arguments);
}
function nAr(t, e) {
  if (t == null) return {};
  var r = aAr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function aAr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var Fi = /* @__PURE__ */ Te.forwardRef(function(t, e) {
  var r = t.children, n = t.className, a = nAr(t, rAr), i = ti("recharts-layer", n);
  return /* @__PURE__ */ Te.createElement("g", Nde({
    className: i
  }, Un(a, !0), {
    ref: e
  }), r);
}), iAr = Ar.env.NODE_ENV !== "production", O1 = function(e, r) {
  for (var n = arguments.length, a = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    a[i - 2] = arguments[i];
  if (iAr && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return a[o++];
      }));
    }
}, jte, hMe;
function oAr() {
  if (hMe) return jte;
  hMe = 1;
  function t(e, r, n) {
    var a = -1, i = e.length;
    r < 0 && (r = -r > i ? 0 : i + r), n = n > i ? i : n, n < 0 && (n += i), i = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(i); ++a < i; )
      o[a] = e[a + r];
    return o;
  }
  return jte = t, jte;
}
var Fte, pMe;
function sAr() {
  if (pMe) return Fte;
  pMe = 1;
  var t = oAr();
  function e(r, n, a) {
    var i = r.length;
    return a = a === void 0 ? i : a, !n && a >= i ? r : t(r, n, a);
  }
  return Fte = e, Fte;
}
var zte, mMe;
function Kct() {
  if (mMe) return zte;
  mMe = 1;
  var t = "\\ud800-\\udfff", e = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = e + r + n, i = "\\ufe0e\\ufe0f", o = "\\u200d", s = RegExp("[" + o + t + a + i + "]");
  function l(c) {
    return s.test(c);
  }
  return zte = l, zte;
}
var Gte, gMe;
function lAr() {
  if (gMe) return Gte;
  gMe = 1;
  function t(e) {
    return e.split("");
  }
  return Gte = t, Gte;
}
var Wte, vMe;
function cAr() {
  if (vMe) return Wte;
  vMe = 1;
  var t = "\\ud800-\\udfff", e = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", a = e + r + n, i = "\\ufe0e\\ufe0f", o = "[" + t + "]", s = "[" + a + "]", l = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + s + "|" + l + ")", u = "[^" + t + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", p = "\\u200d", g = c + "?", y = "[" + i + "]?", b = "(?:" + p + "(?:" + [u, f, h].join("|") + ")" + y + g + ")*", w = y + g + b, _ = "(?:" + [u + s + "?", s, f, h, o].join("|") + ")", C = RegExp(l + "(?=" + l + ")|" + _ + w, "g");
  function x(S) {
    return S.match(C) || [];
  }
  return Wte = x, Wte;
}
var Hte, yMe;
function uAr() {
  if (yMe) return Hte;
  yMe = 1;
  var t = lAr(), e = Kct(), r = cAr();
  function n(a) {
    return e(a) ? r(a) : t(a);
  }
  return Hte = n, Hte;
}
var Ute, bMe;
function dAr() {
  if (bMe) return Ute;
  bMe = 1;
  var t = sAr(), e = Kct(), r = uAr(), n = Wct();
  function a(i) {
    return function(o) {
      o = n(o);
      var s = e(o) ? r(o) : void 0, l = s ? s[0] : o.charAt(0), c = s ? t(s, 1).join("") : o.slice(1);
      return l[i]() + c;
    };
  }
  return Ute = a, Ute;
}
var Vte, xMe;
function fAr() {
  if (xMe) return Vte;
  xMe = 1;
  var t = dAr(), e = t("toUpperCase");
  return Vte = e, Vte;
}
var hAr = fAr();
const HW = /* @__PURE__ */ Gi(hAr);
function ts(t) {
  return function() {
    return t;
  };
}
const Zct = Math.cos, yj = Math.sin, h2 = Math.sqrt, bj = Math.PI, UW = 2 * bj, $de = Math.PI, Dde = 2 * $de, Q3 = 1e-6, pAr = Dde - Q3;
function Jct(t) {
  this._ += t[0];
  for (let e = 1, r = t.length; e < r; ++e)
    this._ += arguments[e] + t[e];
}
function mAr(t) {
  let e = Math.floor(t);
  if (!(e >= 0)) throw new Error(`invalid digits: ${t}`);
  if (e > 15) return Jct;
  const r = 10 ** e;
  return function(n) {
    this._ += n[0];
    for (let a = 1, i = n.length; a < i; ++a)
      this._ += Math.round(arguments[a] * r) / r + n[a];
  };
}
class gAr {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? Jct : mAr(e);
  }
  moveTo(e, r) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, r) {
    this._append`L${this._x1 = +e},${this._y1 = +r}`;
  }
  quadraticCurveTo(e, r, n, a) {
    this._append`Q${+e},${+r},${this._x1 = +n},${this._y1 = +a}`;
  }
  bezierCurveTo(e, r, n, a, i, o) {
    this._append`C${+e},${+r},${+n},${+a},${this._x1 = +i},${this._y1 = +o}`;
  }
  arcTo(e, r, n, a, i) {
    if (e = +e, r = +r, n = +n, a = +a, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let o = this._x1, s = this._y1, l = n - e, c = a - r, u = o - e, f = s - r, h = u * u + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = r}`;
    else if (h > Q3) if (!(Math.abs(f * l - c * u) > Q3) || !i)
      this._append`L${this._x1 = e},${this._y1 = r}`;
    else {
      let p = n - o, g = a - s, y = l * l + c * c, b = p * p + g * g, w = Math.sqrt(y), _ = Math.sqrt(h), C = i * Math.tan(($de - Math.acos((y + h - b) / (2 * w * _))) / 2), x = C / _, S = C / w;
      Math.abs(x - 1) > Q3 && this._append`L${e + x * u},${r + x * f}`, this._append`A${i},${i},0,0,${+(f * p > u * g)},${this._x1 = e + S * l},${this._y1 = r + S * c}`;
    }
  }
  arc(e, r, n, a, i, o) {
    if (e = +e, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let s = n * Math.cos(a), l = n * Math.sin(a), c = e + s, u = r + l, f = 1 ^ o, h = o ? a - i : i - a;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > Q3 || Math.abs(this._y1 - u) > Q3) && this._append`L${c},${u}`, n && (h < 0 && (h = h % Dde + Dde), h > pAr ? this._append`A${n},${n},0,1,${f},${e - s},${r - l}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = u}` : h > Q3 && this._append`A${n},${n},0,${+(h >= $de)},${f},${this._x1 = e + n * Math.cos(i)},${this._y1 = r + n * Math.sin(i)}`);
  }
  rect(e, r, n, a) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +r}h${n = +n}v${+a}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function iye(t) {
  let e = 3;
  return t.digits = function(r) {
    if (!arguments.length) return e;
    if (r == null)
      e = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      e = n;
    }
    return t;
  }, () => new gAr(e);
}
function oye(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Yct(t) {
  this._context = t;
}
Yct.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(t, e);
        break;
    }
  }
};
function VW(t) {
  return new Yct(t);
}
function Xct(t) {
  return t[0];
}
function Qct(t) {
  return t[1];
}
function eut(t, e) {
  var r = ts(!0), n = null, a = VW, i = null, o = iye(s);
  t = typeof t == "function" ? t : t === void 0 ? Xct : ts(t), e = typeof e == "function" ? e : e === void 0 ? Qct : ts(e);
  function s(l) {
    var c, u = (l = oye(l)).length, f, h = !1, p;
    for (n == null && (i = a(p = o())), c = 0; c <= u; ++c)
      !(c < u && r(f = l[c], c, l)) === h && ((h = !h) ? i.lineStart() : i.lineEnd()), h && i.point(+t(f, c, l), +e(f, c, l));
    if (p) return i = null, p + "" || null;
  }
  return s.x = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : ts(+l), s) : t;
  }, s.y = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : ts(+l), s) : e;
  }, s.defined = function(l) {
    return arguments.length ? (r = typeof l == "function" ? l : ts(!!l), s) : r;
  }, s.curve = function(l) {
    return arguments.length ? (a = l, n != null && (i = a(n)), s) : a;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? n = i = null : i = a(n = l), s) : n;
  }, s;
}
function JB(t, e, r) {
  var n = null, a = ts(!0), i = null, o = VW, s = null, l = iye(c);
  t = typeof t == "function" ? t : t === void 0 ? Xct : ts(+t), e = typeof e == "function" ? e : ts(e === void 0 ? 0 : +e), r = typeof r == "function" ? r : r === void 0 ? Qct : ts(+r);
  function c(f) {
    var h, p, g, y = (f = oye(f)).length, b, w = !1, _, C = new Array(y), x = new Array(y);
    for (i == null && (s = o(_ = l())), h = 0; h <= y; ++h) {
      if (!(h < y && a(b = f[h], h, f)) === w)
        if (w = !w)
          p = h, s.areaStart(), s.lineStart();
        else {
          for (s.lineEnd(), s.lineStart(), g = h - 1; g >= p; --g)
            s.point(C[g], x[g]);
          s.lineEnd(), s.areaEnd();
        }
      w && (C[h] = +t(b, h, f), x[h] = +e(b, h, f), s.point(n ? +n(b, h, f) : C[h], r ? +r(b, h, f) : x[h]));
    }
    if (_) return s = null, _ + "" || null;
  }
  function u() {
    return eut().defined(a).curve(o).context(i);
  }
  return c.x = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : ts(+f), n = null, c) : t;
  }, c.x0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : ts(+f), c) : t;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : ts(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : ts(+f), r = null, c) : e;
  }, c.y0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : ts(+f), c) : e;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : ts(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return u().x(t).y(e);
  }, c.lineY1 = function() {
    return u().x(t).y(r);
  }, c.lineX1 = function() {
    return u().x(n).y(e);
  }, c.defined = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : ts(!!f), c) : a;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, i != null && (s = o(i)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? i = s = null : s = o(i = f), c) : i;
  }, c;
}
class tut {
  constructor(e, r) {
    this._context = e, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, r) {
    switch (e = +e, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, r, e, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, e, this._y0, e, r);
        break;
      }
    }
    this._x0 = e, this._y0 = r;
  }
}
function vAr(t) {
  return new tut(t, !0);
}
function yAr(t) {
  return new tut(t, !1);
}
const sye = {
  draw(t, e) {
    const r = h2(e / bj);
    t.moveTo(r, 0), t.arc(0, 0, r, 0, UW);
  }
}, bAr = {
  draw(t, e) {
    const r = h2(e / 5) / 2;
    t.moveTo(-3 * r, -r), t.lineTo(-r, -r), t.lineTo(-r, -3 * r), t.lineTo(r, -3 * r), t.lineTo(r, -r), t.lineTo(3 * r, -r), t.lineTo(3 * r, r), t.lineTo(r, r), t.lineTo(r, 3 * r), t.lineTo(-r, 3 * r), t.lineTo(-r, r), t.lineTo(-3 * r, r), t.closePath();
  }
}, rut = h2(1 / 3), xAr = rut * 2, CAr = {
  draw(t, e) {
    const r = h2(e / xAr), n = r * rut;
    t.moveTo(0, -r), t.lineTo(n, 0), t.lineTo(0, r), t.lineTo(-n, 0), t.closePath();
  }
}, wAr = {
  draw(t, e) {
    const r = h2(e), n = -r / 2;
    t.rect(n, n, r, r);
  }
}, SAr = 0.8908130915292852, nut = yj(bj / 10) / yj(7 * bj / 10), _Ar = yj(UW / 10) * nut, kAr = -Zct(UW / 10) * nut, AAr = {
  draw(t, e) {
    const r = h2(e * SAr), n = _Ar * r, a = kAr * r;
    t.moveTo(0, -r), t.lineTo(n, a);
    for (let i = 1; i < 5; ++i) {
      const o = UW * i / 5, s = Zct(o), l = yj(o);
      t.lineTo(l * r, -s * r), t.lineTo(s * n - l * a, l * n + s * a);
    }
    t.closePath();
  }
}, qte = h2(3), TAr = {
  draw(t, e) {
    const r = -h2(e / (qte * 3));
    t.moveTo(0, r * 2), t.lineTo(-qte * r, -r), t.lineTo(qte * r, -r), t.closePath();
  }
}, j0 = -0.5, F0 = h2(3) / 2, Lde = 1 / h2(12), EAr = (Lde / 2 + 1) * 3, IAr = {
  draw(t, e) {
    const r = h2(e / EAr), n = r / 2, a = r * Lde, i = n, o = r * Lde + r, s = -i, l = o;
    t.moveTo(n, a), t.lineTo(i, o), t.lineTo(s, l), t.lineTo(j0 * n - F0 * a, F0 * n + j0 * a), t.lineTo(j0 * i - F0 * o, F0 * i + j0 * o), t.lineTo(j0 * s - F0 * l, F0 * s + j0 * l), t.lineTo(j0 * n + F0 * a, j0 * a - F0 * n), t.lineTo(j0 * i + F0 * o, j0 * o - F0 * i), t.lineTo(j0 * s + F0 * l, j0 * l - F0 * s), t.closePath();
  }
};
function MAr(t, e) {
  let r = null, n = iye(a);
  t = typeof t == "function" ? t : ts(t || sye), e = typeof e == "function" ? e : ts(e === void 0 ? 64 : +e);
  function a() {
    let i;
    if (r || (r = i = n()), t.apply(this, arguments).draw(r, +e.apply(this, arguments)), i) return r = null, i + "" || null;
  }
  return a.type = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ts(i), a) : t;
  }, a.size = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : ts(+i), a) : e;
  }, a.context = function(i) {
    return arguments.length ? (r = i ?? null, a) : r;
  }, a;
}
function xj() {
}
function Cj(t, e, r) {
  t._context.bezierCurveTo(
    (2 * t._x0 + t._x1) / 3,
    (2 * t._y0 + t._y1) / 3,
    (t._x0 + 2 * t._x1) / 3,
    (t._y0 + 2 * t._y1) / 3,
    (t._x0 + 4 * t._x1 + e) / 6,
    (t._y0 + 4 * t._y1 + r) / 6
  );
}
function aut(t) {
  this._context = t;
}
aut.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Cj(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        Cj(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function PAr(t) {
  return new aut(t);
}
function iut(t) {
  this._context = t;
}
iut.prototype = {
  areaStart: xj,
  areaEnd: xj,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = t, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = t, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = t, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + t) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        Cj(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function RAr(t) {
  return new iut(t);
}
function out(t) {
  this._context = t;
}
out.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + t) / 6, n = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        Cj(this, t, e);
        break;
    }
    this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e;
  }
};
function OAr(t) {
  return new out(t);
}
function sut(t) {
  this._context = t;
}
sut.prototype = {
  areaStart: xj,
  areaEnd: xj,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(t, e) {
    t = +t, e = +e, this._point ? this._context.lineTo(t, e) : (this._point = 1, this._context.moveTo(t, e));
  }
};
function BAr(t) {
  return new sut(t);
}
function CMe(t) {
  return t < 0 ? -1 : 1;
}
function wMe(t, e, r) {
  var n = t._x1 - t._x0, a = e - t._x1, i = (t._y1 - t._y0) / (n || a < 0 && -0), o = (r - t._y1) / (a || n < 0 && -0), s = (i * a + o * n) / (n + a);
  return (CMe(i) + CMe(o)) * Math.min(Math.abs(i), Math.abs(o), 0.5 * Math.abs(s)) || 0;
}
function SMe(t, e) {
  var r = t._x1 - t._x0;
  return r ? (3 * (t._y1 - t._y0) / r - e) / 2 : e;
}
function Kte(t, e, r) {
  var n = t._x0, a = t._y0, i = t._x1, o = t._y1, s = (i - n) / 3;
  t._context.bezierCurveTo(n + s, a + s * e, i - s, o - s * r, i, o);
}
function wj(t) {
  this._context = t;
}
wj.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Kte(this, this._t0, SMe(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(t, e) {
    var r = NaN;
    if (t = +t, e = +e, !(t === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Kte(this, SMe(this, r = wMe(this, t, e)), r);
          break;
        default:
          Kte(this, this._t0, r = wMe(this, t, e));
          break;
      }
      this._x0 = this._x1, this._x1 = t, this._y0 = this._y1, this._y1 = e, this._t0 = r;
    }
  }
};
function lut(t) {
  this._context = new cut(t);
}
(lut.prototype = Object.create(wj.prototype)).point = function(t, e) {
  wj.prototype.point.call(this, e, t);
};
function cut(t) {
  this._context = t;
}
cut.prototype = {
  moveTo: function(t, e) {
    this._context.moveTo(e, t);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(t, e) {
    this._context.lineTo(e, t);
  },
  bezierCurveTo: function(t, e, r, n, a, i) {
    this._context.bezierCurveTo(e, t, n, r, i, a);
  }
};
function NAr(t) {
  return new wj(t);
}
function $Ar(t) {
  return new lut(t);
}
function uut(t) {
  this._context = t;
}
uut.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var t = this._x, e = this._y, r = t.length;
    if (r)
      if (this._line ? this._context.lineTo(t[0], e[0]) : this._context.moveTo(t[0], e[0]), r === 2)
        this._context.lineTo(t[1], e[1]);
      else
        for (var n = _Me(t), a = _Me(e), i = 0, o = 1; o < r; ++i, ++o)
          this._context.bezierCurveTo(n[0][i], a[0][i], n[1][i], a[1][i], t[o], e[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(t, e) {
    this._x.push(+t), this._y.push(+e);
  }
};
function _Me(t) {
  var e, r = t.length - 1, n, a = new Array(r), i = new Array(r), o = new Array(r);
  for (a[0] = 0, i[0] = 2, o[0] = t[0] + 2 * t[1], e = 1; e < r - 1; ++e) a[e] = 1, i[e] = 4, o[e] = 4 * t[e] + 2 * t[e + 1];
  for (a[r - 1] = 2, i[r - 1] = 7, o[r - 1] = 8 * t[r - 1] + t[r], e = 1; e < r; ++e) n = a[e] / i[e - 1], i[e] -= n, o[e] -= n * o[e - 1];
  for (a[r - 1] = o[r - 1] / i[r - 1], e = r - 2; e >= 0; --e) a[e] = (o[e] - a[e + 1]) / i[e];
  for (i[r - 1] = (t[r] + a[r - 1]) / 2, e = 0; e < r - 1; ++e) i[e] = 2 * t[e + 1] - a[e + 1];
  return [a, i];
}
function DAr(t) {
  return new uut(t);
}
function qW(t, e) {
  this._context = t, this._t = e;
}
qW.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(t, e) {
    switch (t = +t, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(t, e) : this._context.moveTo(t, e);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(t, e);
        else {
          var r = this._x * (1 - this._t) + t * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, e);
        }
        break;
      }
    }
    this._x = t, this._y = e;
  }
};
function LAr(t) {
  return new qW(t, 0.5);
}
function jAr(t) {
  return new qW(t, 0);
}
function FAr(t) {
  return new qW(t, 1);
}
function Ex(t, e) {
  if ((o = t.length) > 1)
    for (var r = 1, n, a, i = t[e[0]], o, s = i.length; r < o; ++r)
      for (a = i, i = t[e[r]], n = 0; n < s; ++n)
        i[n][1] += i[n][0] = isNaN(a[n][1]) ? a[n][0] : a[n][1];
}
function jde(t) {
  for (var e = t.length, r = new Array(e); --e >= 0; ) r[e] = e;
  return r;
}
function zAr(t, e) {
  return t[e];
}
function GAr(t) {
  const e = [];
  return e.key = t, e;
}
function WAr() {
  var t = ts([]), e = jde, r = Ex, n = zAr;
  function a(i) {
    var o = Array.from(t.apply(this, arguments), GAr), s, l = o.length, c = -1, u;
    for (const f of i)
      for (s = 0, ++c; s < l; ++s)
        (o[s][c] = [0, +n(f, o[s].key, c, i)]).data = f;
    for (s = 0, u = oye(e(o)); s < l; ++s)
      o[u[s]].index = s;
    return r(o, u), o;
  }
  return a.keys = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : ts(Array.from(i)), a) : t;
  }, a.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : ts(+i), a) : n;
  }, a.order = function(i) {
    return arguments.length ? (e = i == null ? jde : typeof i == "function" ? i : ts(Array.from(i)), a) : e;
  }, a.offset = function(i) {
    return arguments.length ? (r = i ?? Ex, a) : r;
  }, a;
}
function HAr(t, e) {
  if ((n = t.length) > 0) {
    for (var r, n, a = 0, i = t[0].length, o; a < i; ++a) {
      for (o = r = 0; r < n; ++r) o += t[r][a][1] || 0;
      if (o) for (r = 0; r < n; ++r) t[r][a][1] /= o;
    }
    Ex(t, e);
  }
}
function UAr(t, e) {
  if ((a = t.length) > 0) {
    for (var r = 0, n = t[e[0]], a, i = n.length; r < i; ++r) {
      for (var o = 0, s = 0; o < a; ++o) s += t[o][r][1] || 0;
      n[r][1] += n[r][0] = -s / 2;
    }
    Ex(t, e);
  }
}
function VAr(t, e) {
  if (!(!((o = t.length) > 0) || !((i = (a = t[e[0]]).length) > 0))) {
    for (var r = 0, n = 1, a, i, o; n < i; ++n) {
      for (var s = 0, l = 0, c = 0; s < o; ++s) {
        for (var u = t[e[s]], f = u[n][1] || 0, h = u[n - 1][1] || 0, p = (f - h) / 2, g = 0; g < s; ++g) {
          var y = t[e[g]], b = y[n][1] || 0, w = y[n - 1][1] || 0;
          p += b - w;
        }
        l += f, c += p * f;
      }
      a[n - 1][1] += a[n - 1][0] = r, l && (r -= c / l);
    }
    a[n - 1][1] += a[n - 1][0] = r, Ex(t, e);
  }
}
function SE(t) {
  "@babel/helpers - typeof";
  return SE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, SE(t);
}
var qAr = ["type", "size", "sizeType"];
function Fde() {
  return Fde = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Fde.apply(this, arguments);
}
function kMe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function AMe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kMe(Object(r), !0).forEach(function(n) {
      KAr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kMe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function KAr(t, e, r) {
  return e = ZAr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ZAr(t) {
  var e = JAr(t, "string");
  return SE(e) == "symbol" ? e : e + "";
}
function JAr(t, e) {
  if (SE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (SE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function YAr(t, e) {
  if (t == null) return {};
  var r = XAr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function XAr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var dut = {
  symbolCircle: sye,
  symbolCross: bAr,
  symbolDiamond: CAr,
  symbolSquare: wAr,
  symbolStar: AAr,
  symbolTriangle: TAr,
  symbolWye: IAr
}, QAr = Math.PI / 180, eTr = function(e) {
  var r = "symbol".concat(HW(e));
  return dut[r] || sye;
}, tTr = function(e, r, n) {
  if (r === "area")
    return e;
  switch (n) {
    case "cross":
      return 5 * e * e / 9;
    case "diamond":
      return 0.5 * e * e / Math.sqrt(3);
    case "square":
      return e * e;
    case "star": {
      var a = 18 * QAr;
      return 1.25 * e * e * (Math.tan(a) - Math.tan(a * 2) * Math.pow(Math.tan(a), 2));
    }
    case "triangle":
      return Math.sqrt(3) * e * e / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * e * e / 8;
    default:
      return Math.PI * e * e / 4;
  }
}, rTr = function(e, r) {
  dut["symbol".concat(HW(e))] = r;
}, lye = function(e) {
  var r = e.type, n = r === void 0 ? "circle" : r, a = e.size, i = a === void 0 ? 64 : a, o = e.sizeType, s = o === void 0 ? "area" : o, l = YAr(e, qAr), c = AMe(AMe({}, l), {}, {
    type: n,
    size: i,
    sizeType: s
  }), u = function() {
    var b = eTr(n), w = MAr().type(b).size(tTr(i, s, n));
    return w();
  }, f = c.className, h = c.cx, p = c.cy, g = Un(c, !0);
  return h === +h && p === +p && i === +i ? /* @__PURE__ */ Te.createElement("path", Fde({}, g, {
    className: ti("recharts-symbols", f),
    transform: "translate(".concat(h, ", ").concat(p, ")"),
    d: u()
  })) : null;
};
lye.registerSymbol = rTr;
function Ix(t) {
  "@babel/helpers - typeof";
  return Ix = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ix(t);
}
function zde() {
  return zde = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, zde.apply(this, arguments);
}
function TMe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nTr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? TMe(Object(r), !0).forEach(function(n) {
      _E(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : TMe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function aTr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function iTr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, hut(n.key), n);
  }
}
function oTr(t, e, r) {
  return e && iTr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function sTr(t, e, r) {
  return e = Sj(e), lTr(t, fut() ? Reflect.construct(e, r || [], Sj(t).constructor) : e.apply(t, r));
}
function lTr(t, e) {
  if (e && (Ix(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cTr(t);
}
function cTr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function fut() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fut = function() {
    return !!t;
  })();
}
function Sj(t) {
  return Sj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Sj(t);
}
function uTr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Gde(t, e);
}
function Gde(t, e) {
  return Gde = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Gde(t, e);
}
function _E(t, e, r) {
  return e = hut(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function hut(t) {
  var e = dTr(t, "string");
  return Ix(e) == "symbol" ? e : e + "";
}
function dTr(t, e) {
  if (Ix(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Ix(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Vf = 32, cye = /* @__PURE__ */ function(t) {
  function e() {
    return aTr(this, e), sTr(this, e, arguments);
  }
  return uTr(e, t), oTr(e, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var a = this.props.inactiveColor, i = Vf / 2, o = Vf / 6, s = Vf / 3, l = n.inactive ? a : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ Te.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: i,
            x2: Vf,
            y2: i,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ Te.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(i, "h").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * s, ",").concat(i, `
            H`).concat(Vf, "M").concat(2 * s, ",").concat(i, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(s, ",").concat(i),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ Te.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(Vf / 8, "h").concat(Vf, "v").concat(Vf * 3 / 4, "h").concat(-32, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ Te.isValidElement(n.legendIcon)) {
          var c = nTr({}, n);
          return delete c.legendIcon, /* @__PURE__ */ Te.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ Te.createElement(lye, {
          fill: l,
          cx: i,
          cy: i,
          size: Vf,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, a = this.props, i = a.payload, o = a.iconSize, s = a.layout, l = a.formatter, c = a.inactiveColor, u = {
        x: 0,
        y: 0,
        width: Vf,
        height: Vf
      }, f = {
        display: s === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, h = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return i.map(function(p, g) {
        var y = p.formatter || l, b = ti(_E(_E({
          "recharts-legend-item": !0
        }, "legend-item-".concat(g), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var w = ua(p.value) ? null : p.value;
        O1(
          !ua(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var _ = p.inactive ? c : p.color;
        return /* @__PURE__ */ Te.createElement("li", zde({
          className: b,
          style: f,
          key: "legend-item-".concat(g)
        }, M5(n.props, p, g)), /* @__PURE__ */ Te.createElement(Bde, {
          width: o,
          height: o,
          viewBox: u,
          style: h
        }, n.renderIcon(p)), /* @__PURE__ */ Te.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: _
          }
        }, y ? y(w, p, g) : w));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.payload, i = n.layout, o = n.align;
      if (!a || !a.length)
        return null;
      var s = {
        padding: 0,
        margin: 0,
        textAlign: i === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ Te.createElement("ul", {
        className: "recharts-default-legend",
        style: s
      }, this.renderItems());
    }
  }]);
}(g0);
_E(cye, "displayName", "Legend");
_E(cye, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Zte, EMe;
function fTr() {
  if (EMe) return Zte;
  EMe = 1;
  var t = zW();
  function e() {
    this.__data__ = new t(), this.size = 0;
  }
  return Zte = e, Zte;
}
var Jte, IMe;
function hTr() {
  if (IMe) return Jte;
  IMe = 1;
  function t(e) {
    var r = this.__data__, n = r.delete(e);
    return this.size = r.size, n;
  }
  return Jte = t, Jte;
}
var Yte, MMe;
function pTr() {
  if (MMe) return Yte;
  MMe = 1;
  function t(e) {
    return this.__data__.get(e);
  }
  return Yte = t, Yte;
}
var Xte, PMe;
function mTr() {
  if (PMe) return Xte;
  PMe = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return Xte = t, Xte;
}
var Qte, RMe;
function gTr() {
  if (RMe) return Qte;
  RMe = 1;
  var t = zW(), e = Xve(), r = Qve(), n = 200;
  function a(i, o) {
    var s = this.__data__;
    if (s instanceof t) {
      var l = s.__data__;
      if (!e || l.length < n - 1)
        return l.push([i, o]), this.size = ++s.size, this;
      s = this.__data__ = new r(l);
    }
    return s.set(i, o), this.size = s.size, this;
  }
  return Qte = a, Qte;
}
var ere, OMe;
function put() {
  if (OMe) return ere;
  OMe = 1;
  var t = zW(), e = fTr(), r = hTr(), n = pTr(), a = mTr(), i = gTr();
  function o(s) {
    var l = this.__data__ = new t(s);
    this.size = l.size;
  }
  return o.prototype.clear = e, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = a, o.prototype.set = i, ere = o, ere;
}
var tre, BMe;
function vTr() {
  if (BMe) return tre;
  BMe = 1;
  var t = "__lodash_hash_undefined__";
  function e(r) {
    return this.__data__.set(r, t), this;
  }
  return tre = e, tre;
}
var rre, NMe;
function yTr() {
  if (NMe) return rre;
  NMe = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return rre = t, rre;
}
var nre, $Me;
function mut() {
  if ($Me) return nre;
  $Me = 1;
  var t = Qve(), e = vTr(), r = yTr();
  function n(a) {
    var i = -1, o = a == null ? 0 : a.length;
    for (this.__data__ = new t(); ++i < o; )
      this.add(a[i]);
  }
  return n.prototype.add = n.prototype.push = e, n.prototype.has = r, nre = n, nre;
}
var are, DMe;
function gut() {
  if (DMe) return are;
  DMe = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
      if (r(e[n], n, e))
        return !0;
    return !1;
  }
  return are = t, are;
}
var ire, LMe;
function vut() {
  if (LMe) return ire;
  LMe = 1;
  function t(e, r) {
    return e.has(r);
  }
  return ire = t, ire;
}
var ore, jMe;
function yut() {
  if (jMe) return ore;
  jMe = 1;
  var t = mut(), e = gut(), r = vut(), n = 1, a = 2;
  function i(o, s, l, c, u, f) {
    var h = l & n, p = o.length, g = s.length;
    if (p != g && !(h && g > p))
      return !1;
    var y = f.get(o), b = f.get(s);
    if (y && b)
      return y == s && b == o;
    var w = -1, _ = !0, C = l & a ? new t() : void 0;
    for (f.set(o, s), f.set(s, o); ++w < p; ) {
      var x = o[w], S = s[w];
      if (c)
        var A = h ? c(S, x, w, s, o, f) : c(x, S, w, o, s, f);
      if (A !== void 0) {
        if (A)
          continue;
        _ = !1;
        break;
      }
      if (C) {
        if (!e(s, function(I, M) {
          if (!r(C, M) && (x === I || u(x, I, l, c, f)))
            return C.push(M);
        })) {
          _ = !1;
          break;
        }
      } else if (!(x === S || u(x, S, l, c, f))) {
        _ = !1;
        break;
      }
    }
    return f.delete(o), f.delete(s), _;
  }
  return ore = i, ore;
}
var sre, FMe;
function bTr() {
  if (FMe) return sre;
  FMe = 1;
  var t = op(), e = t.Uint8Array;
  return sre = e, sre;
}
var lre, zMe;
function xTr() {
  if (zMe) return lre;
  zMe = 1;
  function t(e) {
    var r = -1, n = Array(e.size);
    return e.forEach(function(a, i) {
      n[++r] = [i, a];
    }), n;
  }
  return lre = t, lre;
}
var cre, GMe;
function uye() {
  if (GMe) return cre;
  GMe = 1;
  function t(e) {
    var r = -1, n = Array(e.size);
    return e.forEach(function(a) {
      n[++r] = a;
    }), n;
  }
  return cre = t, cre;
}
var ure, WMe;
function CTr() {
  if (WMe) return ure;
  WMe = 1;
  var t = iP(), e = bTr(), r = Yve(), n = yut(), a = xTr(), i = uye(), o = 1, s = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", f = "[object Map]", h = "[object Number]", p = "[object RegExp]", g = "[object Set]", y = "[object String]", b = "[object Symbol]", w = "[object ArrayBuffer]", _ = "[object DataView]", C = t ? t.prototype : void 0, x = C ? C.valueOf : void 0;
  function S(A, I, M, B, L, N, d) {
    switch (M) {
      case _:
        if (A.byteLength != I.byteLength || A.byteOffset != I.byteOffset)
          return !1;
        A = A.buffer, I = I.buffer;
      case w:
        return !(A.byteLength != I.byteLength || !N(new e(A), new e(I)));
      case l:
      case c:
      case h:
        return r(+A, +I);
      case u:
        return A.name == I.name && A.message == I.message;
      case p:
      case y:
        return A == I + "";
      case f:
        var m = a;
      case g:
        var v = B & o;
        if (m || (m = i), A.size != I.size && !v)
          return !1;
        var k = d.get(A);
        if (k)
          return k == I;
        B |= s, d.set(A, I);
        var O = n(m(A), m(I), B, L, N, d);
        return d.delete(A), O;
      case b:
        if (x)
          return x.call(A) == x.call(I);
    }
    return !1;
  }
  return ure = S, ure;
}
var dre, HMe;
function but() {
  if (HMe) return dre;
  HMe = 1;
  function t(e, r) {
    for (var n = -1, a = r.length, i = e.length; ++n < a; )
      e[i + n] = r[n];
    return e;
  }
  return dre = t, dre;
}
var fre, UMe;
function wTr() {
  if (UMe) return fre;
  UMe = 1;
  var t = but(), e = Od();
  function r(n, a, i) {
    var o = a(n);
    return e(n) ? o : t(o, i(n));
  }
  return fre = r, fre;
}
var hre, VMe;
function STr() {
  if (VMe) return hre;
  VMe = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length, i = 0, o = []; ++n < a; ) {
      var s = e[n];
      r(s, n, e) && (o[i++] = s);
    }
    return o;
  }
  return hre = t, hre;
}
var pre, qMe;
function _Tr() {
  if (qMe) return pre;
  qMe = 1;
  function t() {
    return [];
  }
  return pre = t, pre;
}
var mre, KMe;
function kTr() {
  if (KMe) return mre;
  KMe = 1;
  var t = STr(), e = _Tr(), r = Object.prototype, n = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, i = a ? function(o) {
    return o == null ? [] : (o = Object(o), t(a(o), function(s) {
      return n.call(o, s);
    }));
  } : e;
  return mre = i, mre;
}
var gre, ZMe;
function ATr() {
  if (ZMe) return gre;
  ZMe = 1;
  function t(e, r) {
    for (var n = -1, a = Array(e); ++n < e; )
      a[n] = r(n);
    return a;
  }
  return gre = t, gre;
}
var vre, JMe;
function TTr() {
  if (JMe) return vre;
  JMe = 1;
  var t = yg(), e = bg(), r = "[object Arguments]";
  function n(a) {
    return e(a) && t(a) == r;
  }
  return vre = n, vre;
}
var yre, YMe;
function dye() {
  if (YMe) return yre;
  YMe = 1;
  var t = TTr(), e = bg(), r = Object.prototype, n = r.hasOwnProperty, a = r.propertyIsEnumerable, i = t(/* @__PURE__ */ function() {
    return arguments;
  }()) ? t : function(o) {
    return e(o) && n.call(o, "callee") && !a.call(o, "callee");
  };
  return yre = i, yre;
}
var s_ = { exports: {} }, bre, XMe;
function ETr() {
  if (XMe) return bre;
  XMe = 1;
  function t() {
    return !1;
  }
  return bre = t, bre;
}
s_.exports;
var QMe;
function xut() {
  return QMe || (QMe = 1, function(t, e) {
    var r = op(), n = ETr(), a = e && !e.nodeType && e, i = a && !0 && t && !t.nodeType && t, o = i && i.exports === a, s = o ? r.Buffer : void 0, l = s ? s.isBuffer : void 0, c = l || n;
    t.exports = c;
  }(s_, s_.exports)), s_.exports;
}
var xre, ePe;
function fye() {
  if (ePe) return xre;
  ePe = 1;
  var t = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function r(n, a) {
    var i = typeof n;
    return a = a ?? t, !!a && (i == "number" || i != "symbol" && e.test(n)) && n > -1 && n % 1 == 0 && n < a;
  }
  return xre = r, xre;
}
var Cre, tPe;
function hye() {
  if (tPe) return Cre;
  tPe = 1;
  var t = 9007199254740991;
  function e(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= t;
  }
  return Cre = e, Cre;
}
var wre, rPe;
function ITr() {
  if (rPe) return wre;
  rPe = 1;
  var t = yg(), e = hye(), r = bg(), n = "[object Arguments]", a = "[object Array]", i = "[object Boolean]", o = "[object Date]", s = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", p = "[object Set]", g = "[object String]", y = "[object WeakMap]", b = "[object ArrayBuffer]", w = "[object DataView]", _ = "[object Float32Array]", C = "[object Float64Array]", x = "[object Int8Array]", S = "[object Int16Array]", A = "[object Int32Array]", I = "[object Uint8Array]", M = "[object Uint8ClampedArray]", B = "[object Uint16Array]", L = "[object Uint32Array]", N = {};
  N[_] = N[C] = N[x] = N[S] = N[A] = N[I] = N[M] = N[B] = N[L] = !0, N[n] = N[a] = N[b] = N[i] = N[w] = N[o] = N[s] = N[l] = N[c] = N[u] = N[f] = N[h] = N[p] = N[g] = N[y] = !1;
  function d(m) {
    return r(m) && e(m.length) && !!N[t(m)];
  }
  return wre = d, wre;
}
var Sre, nPe;
function Cut() {
  if (nPe) return Sre;
  nPe = 1;
  function t(e) {
    return function(r) {
      return e(r);
    };
  }
  return Sre = t, Sre;
}
var l_ = { exports: {} };
l_.exports;
var aPe;
function MTr() {
  return aPe || (aPe = 1, function(t, e) {
    var r = Fct(), n = e && !e.nodeType && e, a = n && !0 && t && !t.nodeType && t, i = a && a.exports === n, o = i && r.process, s = function() {
      try {
        var l = a && a.require && a.require("util").types;
        return l || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    t.exports = s;
  }(l_, l_.exports)), l_.exports;
}
var _re, iPe;
function wut() {
  if (iPe) return _re;
  iPe = 1;
  var t = ITr(), e = Cut(), r = MTr(), n = r && r.isTypedArray, a = n ? e(n) : t;
  return _re = a, _re;
}
var kre, oPe;
function PTr() {
  if (oPe) return kre;
  oPe = 1;
  var t = ATr(), e = dye(), r = Od(), n = xut(), a = fye(), i = wut(), o = Object.prototype, s = o.hasOwnProperty;
  function l(c, u) {
    var f = r(c), h = !f && e(c), p = !f && !h && n(c), g = !f && !h && !p && i(c), y = f || h || p || g, b = y ? t(c.length, String) : [], w = b.length;
    for (var _ in c)
      (u || s.call(c, _)) && !(y && // Safari 9 has enumerable `arguments.length` in strict mode.
      (_ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (_ == "offset" || _ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      g && (_ == "buffer" || _ == "byteLength" || _ == "byteOffset") || // Skip index properties.
      a(_, w))) && b.push(_);
    return b;
  }
  return kre = l, kre;
}
var Are, sPe;
function RTr() {
  if (sPe) return Are;
  sPe = 1;
  var t = Object.prototype;
  function e(r) {
    var n = r && r.constructor, a = typeof n == "function" && n.prototype || t;
    return r === a;
  }
  return Are = e, Are;
}
var Tre, lPe;
function Sut() {
  if (lPe) return Tre;
  lPe = 1;
  function t(e, r) {
    return function(n) {
      return e(r(n));
    };
  }
  return Tre = t, Tre;
}
var Ere, cPe;
function OTr() {
  if (cPe) return Ere;
  cPe = 1;
  var t = Sut(), e = t(Object.keys, Object);
  return Ere = e, Ere;
}
var Ire, uPe;
function BTr() {
  if (uPe) return Ire;
  uPe = 1;
  var t = RTr(), e = OTr(), r = Object.prototype, n = r.hasOwnProperty;
  function a(i) {
    if (!t(i))
      return e(i);
    var o = [];
    for (var s in Object(i))
      n.call(i, s) && s != "constructor" && o.push(s);
    return o;
  }
  return Ire = a, Ire;
}
var Mre, dPe;
function sP() {
  if (dPe) return Mre;
  dPe = 1;
  var t = Jve(), e = hye();
  function r(n) {
    return n != null && e(n.length) && !t(n);
  }
  return Mre = r, Mre;
}
var Pre, fPe;
function KW() {
  if (fPe) return Pre;
  fPe = 1;
  var t = PTr(), e = BTr(), r = sP();
  function n(a) {
    return r(a) ? t(a) : e(a);
  }
  return Pre = n, Pre;
}
var Rre, hPe;
function NTr() {
  if (hPe) return Rre;
  hPe = 1;
  var t = wTr(), e = kTr(), r = KW();
  function n(a) {
    return t(a, r, e);
  }
  return Rre = n, Rre;
}
var Ore, pPe;
function $Tr() {
  if (pPe) return Ore;
  pPe = 1;
  var t = NTr(), e = 1, r = Object.prototype, n = r.hasOwnProperty;
  function a(i, o, s, l, c, u) {
    var f = s & e, h = t(i), p = h.length, g = t(o), y = g.length;
    if (p != y && !f)
      return !1;
    for (var b = p; b--; ) {
      var w = h[b];
      if (!(f ? w in o : n.call(o, w)))
        return !1;
    }
    var _ = u.get(i), C = u.get(o);
    if (_ && C)
      return _ == o && C == i;
    var x = !0;
    u.set(i, o), u.set(o, i);
    for (var S = f; ++b < p; ) {
      w = h[b];
      var A = i[w], I = o[w];
      if (l)
        var M = f ? l(I, A, w, o, i, u) : l(A, I, w, i, o, u);
      if (!(M === void 0 ? A === I || c(A, I, s, l, u) : M)) {
        x = !1;
        break;
      }
      S || (S = w == "constructor");
    }
    if (x && !S) {
      var B = i.constructor, L = o.constructor;
      B != L && "constructor" in i && "constructor" in o && !(typeof B == "function" && B instanceof B && typeof L == "function" && L instanceof L) && (x = !1);
    }
    return u.delete(i), u.delete(o), x;
  }
  return Ore = a, Ore;
}
var Bre, mPe;
function DTr() {
  if (mPe) return Bre;
  mPe = 1;
  var t = y6(), e = op(), r = t(e, "DataView");
  return Bre = r, Bre;
}
var Nre, gPe;
function LTr() {
  if (gPe) return Nre;
  gPe = 1;
  var t = y6(), e = op(), r = t(e, "Promise");
  return Nre = r, Nre;
}
var $re, vPe;
function _ut() {
  if (vPe) return $re;
  vPe = 1;
  var t = y6(), e = op(), r = t(e, "Set");
  return $re = r, $re;
}
var Dre, yPe;
function jTr() {
  if (yPe) return Dre;
  yPe = 1;
  var t = y6(), e = op(), r = t(e, "WeakMap");
  return Dre = r, Dre;
}
var Lre, bPe;
function FTr() {
  if (bPe) return Lre;
  bPe = 1;
  var t = DTr(), e = Xve(), r = LTr(), n = _ut(), a = jTr(), i = yg(), o = zct(), s = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", p = o(t), g = o(e), y = o(r), b = o(n), w = o(a), _ = i;
  return (t && _(new t(new ArrayBuffer(1))) != h || e && _(new e()) != s || r && _(r.resolve()) != c || n && _(new n()) != u || a && _(new a()) != f) && (_ = function(C) {
    var x = i(C), S = x == l ? C.constructor : void 0, A = S ? o(S) : "";
    if (A)
      switch (A) {
        case p:
          return h;
        case g:
          return s;
        case y:
          return c;
        case b:
          return u;
        case w:
          return f;
      }
    return x;
  }), Lre = _, Lre;
}
var jre, xPe;
function zTr() {
  if (xPe) return jre;
  xPe = 1;
  var t = put(), e = yut(), r = CTr(), n = $Tr(), a = FTr(), i = Od(), o = xut(), s = wut(), l = 1, c = "[object Arguments]", u = "[object Array]", f = "[object Object]", h = Object.prototype, p = h.hasOwnProperty;
  function g(y, b, w, _, C, x) {
    var S = i(y), A = i(b), I = S ? u : a(y), M = A ? u : a(b);
    I = I == c ? f : I, M = M == c ? f : M;
    var B = I == f, L = M == f, N = I == M;
    if (N && o(y)) {
      if (!o(b))
        return !1;
      S = !0, B = !1;
    }
    if (N && !B)
      return x || (x = new t()), S || s(y) ? e(y, b, w, _, C, x) : r(y, b, I, w, _, C, x);
    if (!(w & l)) {
      var d = B && p.call(y, "__wrapped__"), m = L && p.call(b, "__wrapped__");
      if (d || m) {
        var v = d ? y.value() : y, k = m ? b.value() : b;
        return x || (x = new t()), C(v, k, w, _, x);
      }
    }
    return N ? (x || (x = new t()), n(y, b, w, _, C, x)) : !1;
  }
  return jre = g, jre;
}
var Fre, CPe;
function pye() {
  if (CPe) return Fre;
  CPe = 1;
  var t = zTr(), e = bg();
  function r(n, a, i, o, s) {
    return n === a ? !0 : n == null || a == null || !e(n) && !e(a) ? n !== n && a !== a : t(n, a, i, o, r, s);
  }
  return Fre = r, Fre;
}
var zre, wPe;
function GTr() {
  if (wPe) return zre;
  wPe = 1;
  var t = put(), e = pye(), r = 1, n = 2;
  function a(i, o, s, l) {
    var c = s.length, u = c, f = !l;
    if (i == null)
      return !u;
    for (i = Object(i); c--; ) {
      var h = s[c];
      if (f && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++c < u; ) {
      h = s[c];
      var p = h[0], g = i[p], y = h[1];
      if (f && h[2]) {
        if (g === void 0 && !(p in i))
          return !1;
      } else {
        var b = new t();
        if (l)
          var w = l(g, y, p, i, o, b);
        if (!(w === void 0 ? e(y, g, r | n, l, b) : w))
          return !1;
      }
    }
    return !0;
  }
  return zre = a, zre;
}
var Gre, SPe;
function kut() {
  if (SPe) return Gre;
  SPe = 1;
  var t = Zy();
  function e(r) {
    return r === r && !t(r);
  }
  return Gre = e, Gre;
}
var Wre, _Pe;
function WTr() {
  if (_Pe) return Wre;
  _Pe = 1;
  var t = kut(), e = KW();
  function r(n) {
    for (var a = e(n), i = a.length; i--; ) {
      var o = a[i], s = n[o];
      a[i] = [o, s, t(s)];
    }
    return a;
  }
  return Wre = r, Wre;
}
var Hre, kPe;
function Aut() {
  if (kPe) return Hre;
  kPe = 1;
  function t(e, r) {
    return function(n) {
      return n == null ? !1 : n[e] === r && (r !== void 0 || e in Object(n));
    };
  }
  return Hre = t, Hre;
}
var Ure, APe;
function HTr() {
  if (APe) return Ure;
  APe = 1;
  var t = GTr(), e = WTr(), r = Aut();
  function n(a) {
    var i = e(a);
    return i.length == 1 && i[0][2] ? r(i[0][0], i[0][1]) : function(o) {
      return o === a || t(o, a, i);
    };
  }
  return Ure = n, Ure;
}
var Vre, TPe;
function UTr() {
  if (TPe) return Vre;
  TPe = 1;
  function t(e, r) {
    return e != null && r in Object(e);
  }
  return Vre = t, Vre;
}
var qre, EPe;
function VTr() {
  if (EPe) return qre;
  EPe = 1;
  var t = Hct(), e = dye(), r = Od(), n = fye(), a = hye(), i = WW();
  function o(s, l, c) {
    l = t(l, s);
    for (var u = -1, f = l.length, h = !1; ++u < f; ) {
      var p = i(l[u]);
      if (!(h = s != null && c(s, p)))
        break;
      s = s[p];
    }
    return h || ++u != f ? h : (f = s == null ? 0 : s.length, !!f && a(f) && n(p, f) && (r(s) || e(s)));
  }
  return qre = o, qre;
}
var Kre, IPe;
function qTr() {
  if (IPe) return Kre;
  IPe = 1;
  var t = UTr(), e = VTr();
  function r(n, a) {
    return n != null && e(n, a, t);
  }
  return Kre = r, Kre;
}
var Zre, MPe;
function KTr() {
  if (MPe) return Zre;
  MPe = 1;
  var t = pye(), e = Uct(), r = qTr(), n = Zve(), a = kut(), i = Aut(), o = WW(), s = 1, l = 2;
  function c(u, f) {
    return n(u) && a(f) ? i(o(u), f) : function(h) {
      var p = e(h, u);
      return p === void 0 && p === f ? r(h, u) : t(f, p, s | l);
    };
  }
  return Zre = c, Zre;
}
var Jre, PPe;
function iC() {
  if (PPe) return Jre;
  PPe = 1;
  function t(e) {
    return e;
  }
  return Jre = t, Jre;
}
var Yre, RPe;
function ZTr() {
  if (RPe) return Yre;
  RPe = 1;
  function t(e) {
    return function(r) {
      return r == null ? void 0 : r[e];
    };
  }
  return Yre = t, Yre;
}
var Xre, OPe;
function JTr() {
  if (OPe) return Xre;
  OPe = 1;
  var t = tye();
  function e(r) {
    return function(n) {
      return t(n, r);
    };
  }
  return Xre = e, Xre;
}
var Qre, BPe;
function YTr() {
  if (BPe) return Qre;
  BPe = 1;
  var t = ZTr(), e = JTr(), r = Zve(), n = WW();
  function a(i) {
    return r(i) ? t(n(i)) : e(i);
  }
  return Qre = a, Qre;
}
var ene, NPe;
function sp() {
  if (NPe) return ene;
  NPe = 1;
  var t = HTr(), e = KTr(), r = iC(), n = Od(), a = YTr();
  function i(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? e(o[0], o[1]) : t(o) : a(o);
  }
  return ene = i, ene;
}
var tne, $Pe;
function Tut() {
  if ($Pe) return tne;
  $Pe = 1;
  function t(e, r, n, a) {
    for (var i = e.length, o = n + (a ? 1 : -1); a ? o-- : ++o < i; )
      if (r(e[o], o, e))
        return o;
    return -1;
  }
  return tne = t, tne;
}
var rne, DPe;
function XTr() {
  if (DPe) return rne;
  DPe = 1;
  function t(e) {
    return e !== e;
  }
  return rne = t, rne;
}
var nne, LPe;
function QTr() {
  if (LPe) return nne;
  LPe = 1;
  function t(e, r, n) {
    for (var a = n - 1, i = e.length; ++a < i; )
      if (e[a] === r)
        return a;
    return -1;
  }
  return nne = t, nne;
}
var ane, jPe;
function eEr() {
  if (jPe) return ane;
  jPe = 1;
  var t = Tut(), e = XTr(), r = QTr();
  function n(a, i, o) {
    return i === i ? r(a, i, o) : t(a, e, o);
  }
  return ane = n, ane;
}
var ine, FPe;
function tEr() {
  if (FPe) return ine;
  FPe = 1;
  var t = eEr();
  function e(r, n) {
    var a = r == null ? 0 : r.length;
    return !!a && t(r, n, 0) > -1;
  }
  return ine = e, ine;
}
var one, zPe;
function rEr() {
  if (zPe) return one;
  zPe = 1;
  function t(e, r, n) {
    for (var a = -1, i = e == null ? 0 : e.length; ++a < i; )
      if (n(r, e[a]))
        return !0;
    return !1;
  }
  return one = t, one;
}
var sne, GPe;
function nEr() {
  if (GPe) return sne;
  GPe = 1;
  function t() {
  }
  return sne = t, sne;
}
var lne, WPe;
function aEr() {
  if (WPe) return lne;
  WPe = 1;
  var t = _ut(), e = nEr(), r = uye(), n = 1 / 0, a = t && 1 / r(new t([, -0]))[1] == n ? function(i) {
    return new t(i);
  } : e;
  return lne = a, lne;
}
var cne, HPe;
function iEr() {
  if (HPe) return cne;
  HPe = 1;
  var t = mut(), e = tEr(), r = rEr(), n = vut(), a = aEr(), i = uye(), o = 200;
  function s(l, c, u) {
    var f = -1, h = e, p = l.length, g = !0, y = [], b = y;
    if (u)
      g = !1, h = r;
    else if (p >= o) {
      var w = c ? null : a(l);
      if (w)
        return i(w);
      g = !1, h = n, b = new t();
    } else
      b = c ? [] : y;
    e:
      for (; ++f < p; ) {
        var _ = l[f], C = c ? c(_) : _;
        if (_ = u || _ !== 0 ? _ : 0, g && C === C) {
          for (var x = b.length; x--; )
            if (b[x] === C)
              continue e;
          c && b.push(C), y.push(_);
        } else h(b, C, u) || (b !== y && b.push(C), y.push(_));
      }
    return y;
  }
  return cne = s, cne;
}
var une, UPe;
function oEr() {
  if (UPe) return une;
  UPe = 1;
  var t = sp(), e = iEr();
  function r(n, a) {
    return n && n.length ? e(n, t(a, 2)) : [];
  }
  return une = r, une;
}
var sEr = oEr();
const VPe = /* @__PURE__ */ Gi(sEr);
function Eut(t, e, r) {
  return e === !0 ? VPe(t, r) : ua(e) ? VPe(t, e) : t;
}
function Mx(t) {
  "@babel/helpers - typeof";
  return Mx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mx(t);
}
var lEr = ["ref"];
function qPe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Lp(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qPe(Object(r), !0).forEach(function(n) {
      ZW(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qPe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function cEr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function KPe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Mut(n.key), n);
  }
}
function uEr(t, e, r) {
  return e && KPe(t.prototype, e), r && KPe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function dEr(t, e, r) {
  return e = _j(e), fEr(t, Iut() ? Reflect.construct(e, r || [], _j(t).constructor) : e.apply(t, r));
}
function fEr(t, e) {
  if (e && (Mx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return hEr(t);
}
function hEr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Iut() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Iut = function() {
    return !!t;
  })();
}
function _j(t) {
  return _j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _j(t);
}
function pEr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Wde(t, e);
}
function Wde(t, e) {
  return Wde = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Wde(t, e);
}
function ZW(t, e, r) {
  return e = Mut(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Mut(t) {
  var e = mEr(t, "string");
  return Mx(e) == "symbol" ? e : e + "";
}
function mEr(t, e) {
  if (Mx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Mx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function gEr(t, e) {
  if (t == null) return {};
  var r = vEr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function vEr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function yEr(t) {
  return t.value;
}
function bEr(t, e) {
  if (/* @__PURE__ */ Te.isValidElement(t))
    return /* @__PURE__ */ Te.cloneElement(t, e);
  if (typeof t == "function")
    return /* @__PURE__ */ Te.createElement(t, e);
  e.ref;
  var r = gEr(e, lEr);
  return /* @__PURE__ */ Te.createElement(cye, r);
}
var ZPe = 1, Mm = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    cEr(this, e);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = dEr(this, e, [].concat(a)), ZW(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return pEr(e, t), uEr(e, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, a = this.getBBox();
      a ? (Math.abs(a.width - this.lastBoundingBox.width) > ZPe || Math.abs(a.height - this.lastBoundingBox.height) > ZPe) && (this.lastBoundingBox.width = a.width, this.lastBoundingBox.height = a.height, n && n(a)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Lp({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var a = this.props, i = a.layout, o = a.align, s = a.verticalAlign, l = a.margin, c = a.chartWidth, u = a.chartHeight, f, h;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && i === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - p.width) / 2
          };
        } else
          f = o === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (s === "middle") {
          var g = this.getBBoxSnapshot();
          h = {
            top: ((u || 0) - g.height) / 2
          };
        } else
          h = s === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return Lp(Lp({}, f), h);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.content, o = a.width, s = a.height, l = a.wrapperStyle, c = a.payloadUniqBy, u = a.payload, f = Lp(Lp({
        position: "absolute",
        width: o || "auto",
        height: s || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ Te.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, bEr(i, Lp(Lp({}, this.props), {}, {
        payload: Eut(u, c, yEr)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, a) {
      var i = Lp(Lp({}, this.defaultProps), n.props), o = i.layout;
      return o === "vertical" && Ur(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || a
      } : null;
    }
  }]);
}(g0);
ZW(Mm, "displayName", "Legend");
ZW(Mm, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var dne, JPe;
function xEr() {
  if (JPe) return dne;
  JPe = 1;
  var t = iP(), e = dye(), r = Od(), n = t ? t.isConcatSpreadable : void 0;
  function a(i) {
    return r(i) || e(i) || !!(n && i && i[n]);
  }
  return dne = a, dne;
}
var fne, YPe;
function Put() {
  if (YPe) return fne;
  YPe = 1;
  var t = but(), e = xEr();
  function r(n, a, i, o, s) {
    var l = -1, c = n.length;
    for (i || (i = e), s || (s = []); ++l < c; ) {
      var u = n[l];
      a > 0 && i(u) ? a > 1 ? r(u, a - 1, i, o, s) : t(s, u) : o || (s[s.length] = u);
    }
    return s;
  }
  return fne = r, fne;
}
var hne, XPe;
function CEr() {
  if (XPe) return hne;
  XPe = 1;
  function t(e) {
    return function(r, n, a) {
      for (var i = -1, o = Object(r), s = a(r), l = s.length; l--; ) {
        var c = s[e ? l : ++i];
        if (n(o[c], c, o) === !1)
          break;
      }
      return r;
    };
  }
  return hne = t, hne;
}
var pne, QPe;
function wEr() {
  if (QPe) return pne;
  QPe = 1;
  var t = CEr(), e = t();
  return pne = e, pne;
}
var mne, eRe;
function Rut() {
  if (eRe) return mne;
  eRe = 1;
  var t = wEr(), e = KW();
  function r(n, a) {
    return n && t(n, a, e);
  }
  return mne = r, mne;
}
var gne, tRe;
function SEr() {
  if (tRe) return gne;
  tRe = 1;
  var t = sP();
  function e(r, n) {
    return function(a, i) {
      if (a == null)
        return a;
      if (!t(a))
        return r(a, i);
      for (var o = a.length, s = n ? o : -1, l = Object(a); (n ? s-- : ++s < o) && i(l[s], s, l) !== !1; )
        ;
      return a;
    };
  }
  return gne = e, gne;
}
var vne, rRe;
function mye() {
  if (rRe) return vne;
  rRe = 1;
  var t = Rut(), e = SEr(), r = e(t);
  return vne = r, vne;
}
var yne, nRe;
function Out() {
  if (nRe) return yne;
  nRe = 1;
  var t = mye(), e = sP();
  function r(n, a) {
    var i = -1, o = e(n) ? Array(n.length) : [];
    return t(n, function(s, l, c) {
      o[++i] = a(s, l, c);
    }), o;
  }
  return yne = r, yne;
}
var bne, aRe;
function _Er() {
  if (aRe) return bne;
  aRe = 1;
  function t(e, r) {
    var n = e.length;
    for (e.sort(r); n--; )
      e[n] = e[n].value;
    return e;
  }
  return bne = t, bne;
}
var xne, iRe;
function kEr() {
  if (iRe) return xne;
  iRe = 1;
  var t = rC();
  function e(r, n) {
    if (r !== n) {
      var a = r !== void 0, i = r === null, o = r === r, s = t(r), l = n !== void 0, c = n === null, u = n === n, f = t(n);
      if (!c && !f && !s && r > n || s && l && u && !c && !f || i && l && u || !a && u || !o)
        return 1;
      if (!i && !s && !f && r < n || f && a && o && !i && !s || c && a && o || !l && o || !u)
        return -1;
    }
    return 0;
  }
  return xne = e, xne;
}
var Cne, oRe;
function AEr() {
  if (oRe) return Cne;
  oRe = 1;
  var t = kEr();
  function e(r, n, a) {
    for (var i = -1, o = r.criteria, s = n.criteria, l = o.length, c = a.length; ++i < l; ) {
      var u = t(o[i], s[i]);
      if (u) {
        if (i >= c)
          return u;
        var f = a[i];
        return u * (f == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Cne = e, Cne;
}
var wne, sRe;
function TEr() {
  if (sRe) return wne;
  sRe = 1;
  var t = eye(), e = tye(), r = sp(), n = Out(), a = _Er(), i = Cut(), o = AEr(), s = iC(), l = Od();
  function c(u, f, h) {
    f.length ? f = t(f, function(y) {
      return l(y) ? function(b) {
        return e(b, y.length === 1 ? y[0] : y);
      } : y;
    }) : f = [s];
    var p = -1;
    f = t(f, i(r));
    var g = n(u, function(y, b, w) {
      var _ = t(f, function(C) {
        return C(y);
      });
      return { criteria: _, index: ++p, value: y };
    });
    return a(g, function(y, b) {
      return o(y, b, h);
    });
  }
  return wne = c, wne;
}
var Sne, lRe;
function EEr() {
  if (lRe) return Sne;
  lRe = 1;
  function t(e, r, n) {
    switch (n.length) {
      case 0:
        return e.call(r);
      case 1:
        return e.call(r, n[0]);
      case 2:
        return e.call(r, n[0], n[1]);
      case 3:
        return e.call(r, n[0], n[1], n[2]);
    }
    return e.apply(r, n);
  }
  return Sne = t, Sne;
}
var _ne, cRe;
function IEr() {
  if (cRe) return _ne;
  cRe = 1;
  var t = EEr(), e = Math.max;
  function r(n, a, i) {
    return a = e(a === void 0 ? n.length - 1 : a, 0), function() {
      for (var o = arguments, s = -1, l = e(o.length - a, 0), c = Array(l); ++s < l; )
        c[s] = o[a + s];
      s = -1;
      for (var u = Array(a + 1); ++s < a; )
        u[s] = o[s];
      return u[a] = i(c), t(n, this, u);
    };
  }
  return _ne = r, _ne;
}
var kne, uRe;
function MEr() {
  if (uRe) return kne;
  uRe = 1;
  function t(e) {
    return function() {
      return e;
    };
  }
  return kne = t, kne;
}
var Ane, dRe;
function But() {
  if (dRe) return Ane;
  dRe = 1;
  var t = y6(), e = function() {
    try {
      var r = t(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return Ane = e, Ane;
}
var Tne, fRe;
function PEr() {
  if (fRe) return Tne;
  fRe = 1;
  var t = MEr(), e = But(), r = iC(), n = e ? function(a, i) {
    return e(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: t(i),
      writable: !0
    });
  } : r;
  return Tne = n, Tne;
}
var Ene, hRe;
function REr() {
  if (hRe) return Ene;
  hRe = 1;
  var t = 800, e = 16, r = Date.now;
  function n(a) {
    var i = 0, o = 0;
    return function() {
      var s = r(), l = e - (s - o);
      if (o = s, l > 0) {
        if (++i >= t)
          return arguments[0];
      } else
        i = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Ene = n, Ene;
}
var Ine, pRe;
function OEr() {
  if (pRe) return Ine;
  pRe = 1;
  var t = PEr(), e = REr(), r = e(t);
  return Ine = r, Ine;
}
var Mne, mRe;
function BEr() {
  if (mRe) return Mne;
  mRe = 1;
  var t = iC(), e = IEr(), r = OEr();
  function n(a, i) {
    return r(e(a, i, t), a + "");
  }
  return Mne = n, Mne;
}
var Pne, gRe;
function JW() {
  if (gRe) return Pne;
  gRe = 1;
  var t = Yve(), e = sP(), r = fye(), n = Zy();
  function a(i, o, s) {
    if (!n(s))
      return !1;
    var l = typeof o;
    return (l == "number" ? e(s) && r(o, s.length) : l == "string" && o in s) ? t(s[o], i) : !1;
  }
  return Pne = a, Pne;
}
var Rne, vRe;
function NEr() {
  if (vRe) return Rne;
  vRe = 1;
  var t = Put(), e = TEr(), r = BEr(), n = JW(), a = r(function(i, o) {
    if (i == null)
      return [];
    var s = o.length;
    return s > 1 && n(i, o[0], o[1]) ? o = [] : s > 2 && n(o[0], o[1], o[2]) && (o = [o[0]]), e(i, t(o, 1), []);
  });
  return Rne = a, Rne;
}
var $Er = NEr();
const gye = /* @__PURE__ */ Gi($Er);
function kE(t) {
  "@babel/helpers - typeof";
  return kE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, kE(t);
}
function Hde() {
  return Hde = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Hde.apply(this, arguments);
}
function DEr(t, e) {
  return zEr(t) || FEr(t, e) || jEr(t, e) || LEr();
}
function LEr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jEr(t, e) {
  if (t) {
    if (typeof t == "string") return yRe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return yRe(t, e);
  }
}
function yRe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function FEr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function zEr(t) {
  if (Array.isArray(t)) return t;
}
function bRe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function One(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bRe(Object(r), !0).forEach(function(n) {
      GEr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : bRe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function GEr(t, e, r) {
  return e = WEr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function WEr(t) {
  var e = HEr(t, "string");
  return kE(e) == "symbol" ? e : e + "";
}
function HEr(t, e) {
  if (kE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (kE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function UEr(t) {
  return Array.isArray(t) && Hl(t[0]) && Hl(t[1]) ? t.join(" ~ ") : t;
}
var VEr = function(e) {
  var r = e.separator, n = r === void 0 ? " : " : r, a = e.contentStyle, i = a === void 0 ? {} : a, o = e.itemStyle, s = o === void 0 ? {} : o, l = e.labelStyle, c = l === void 0 ? {} : l, u = e.payload, f = e.formatter, h = e.itemSorter, p = e.wrapperClassName, g = e.labelClassName, y = e.label, b = e.labelFormatter, w = e.accessibilityLayer, _ = w === void 0 ? !1 : w, C = function() {
    if (u && u.length) {
      var d = {
        padding: 0,
        margin: 0
      }, m = (h ? gye(u, h) : u).map(function(v, k) {
        if (v.type === "none")
          return null;
        var O = One({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: v.color || "#000"
        }, s), G = v.formatter || f || UEr, H = v.value, j = v.name, F = H, z = j;
        if (G && F != null && z != null) {
          var W = G(H, j, v, k, u);
          if (Array.isArray(W)) {
            var U = DEr(W, 2);
            F = U[0], z = U[1];
          } else
            F = W;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ Te.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(k),
            style: O
          }, Hl(z) ? /* @__PURE__ */ Te.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, z) : null, Hl(z) ? /* @__PURE__ */ Te.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ Te.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, F), /* @__PURE__ */ Te.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, v.unit || ""))
        );
      });
      return /* @__PURE__ */ Te.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: d
      }, m);
    }
    return null;
  }, x = One({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, i), S = One({
    margin: 0
  }, c), A = !Va(y), I = A ? y : "", M = ti("recharts-default-tooltip", p), B = ti("recharts-tooltip-label", g);
  A && b && u !== void 0 && u !== null && (I = b(y, u));
  var L = _ ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ Te.createElement("div", Hde({
    className: M,
    style: x
  }, L), /* @__PURE__ */ Te.createElement("p", {
    className: B,
    style: S
  }, /* @__PURE__ */ Te.isValidElement(I) ? I : "".concat(I)), C());
};
function AE(t) {
  "@babel/helpers - typeof";
  return AE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, AE(t);
}
function YB(t, e, r) {
  return e = qEr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function qEr(t) {
  var e = KEr(t, "string");
  return AE(e) == "symbol" ? e : e + "";
}
function KEr(t, e) {
  if (AE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (AE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var oS = "recharts-tooltip-wrapper", ZEr = {
  visibility: "hidden"
};
function JEr(t) {
  var e = t.coordinate, r = t.translateX, n = t.translateY;
  return ti(oS, YB(YB(YB(YB({}, "".concat(oS, "-right"), Ur(r) && e && Ur(e.x) && r >= e.x), "".concat(oS, "-left"), Ur(r) && e && Ur(e.x) && r < e.x), "".concat(oS, "-bottom"), Ur(n) && e && Ur(e.y) && n >= e.y), "".concat(oS, "-top"), Ur(n) && e && Ur(e.y) && n < e.y));
}
function xRe(t) {
  var e = t.allowEscapeViewBox, r = t.coordinate, n = t.key, a = t.offsetTopLeft, i = t.position, o = t.reverseDirection, s = t.tooltipDimension, l = t.viewBox, c = t.viewBoxDimension;
  if (i && Ur(i[n]))
    return i[n];
  var u = r[n] - s - a, f = r[n] + a;
  if (e[n])
    return o[n] ? u : f;
  if (o[n]) {
    var h = u, p = l[n];
    return h < p ? Math.max(f, l[n]) : Math.max(u, l[n]);
  }
  var g = f + s, y = l[n] + c;
  return g > y ? Math.max(u, l[n]) : Math.max(f, l[n]);
}
function YEr(t) {
  var e = t.translateX, r = t.translateY, n = t.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(e, "px, ").concat(r, "px, 0)") : "translate(".concat(e, "px, ").concat(r, "px)")
  };
}
function XEr(t) {
  var e = t.allowEscapeViewBox, r = t.coordinate, n = t.offsetTopLeft, a = t.position, i = t.reverseDirection, o = t.tooltipBox, s = t.useTranslate3d, l = t.viewBox, c, u, f;
  return o.height > 0 && o.width > 0 && r ? (u = xRe({
    allowEscapeViewBox: e,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), f = xRe({
    allowEscapeViewBox: e,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: a,
    reverseDirection: i,
    tooltipDimension: o.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = YEr({
    translateX: u,
    translateY: f,
    useTranslate3d: s
  })) : c = ZEr, {
    cssProperties: c,
    cssClasses: JEr({
      translateX: u,
      translateY: f,
      coordinate: r
    })
  };
}
function Px(t) {
  "@babel/helpers - typeof";
  return Px = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Px(t);
}
function CRe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wRe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? CRe(Object(r), !0).forEach(function(n) {
      Vde(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : CRe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function QEr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function eIr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, $ut(n.key), n);
  }
}
function tIr(t, e, r) {
  return e && eIr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function rIr(t, e, r) {
  return e = kj(e), nIr(t, Nut() ? Reflect.construct(e, r || [], kj(t).constructor) : e.apply(t, r));
}
function nIr(t, e) {
  if (e && (Px(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aIr(t);
}
function aIr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Nut() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Nut = function() {
    return !!t;
  })();
}
function kj(t) {
  return kj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, kj(t);
}
function iIr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && Ude(t, e);
}
function Ude(t, e) {
  return Ude = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, Ude(t, e);
}
function Vde(t, e, r) {
  return e = $ut(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function $ut(t) {
  var e = oIr(t, "string");
  return Px(e) == "symbol" ? e : e + "";
}
function oIr(t, e) {
  if (Px(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Px(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var SRe = 1, sIr = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    QEr(this, e);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = rIr(this, e, [].concat(a)), Vde(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Vde(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var s, l, c, u;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (s = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && s !== void 0 ? s : 0,
            y: (c = (u = r.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return iIr(e, t), tIr(e, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > SRe || Math.abs(n.height - this.state.lastBoundingBox.height) > SRe) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, a;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((a = this.props.coordinate) === null || a === void 0 ? void 0 : a.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.children, u = a.coordinate, f = a.hasPayload, h = a.isAnimationActive, p = a.offset, g = a.position, y = a.reverseDirection, b = a.useTranslate3d, w = a.viewBox, _ = a.wrapperStyle, C = XEr({
        allowEscapeViewBox: o,
        coordinate: u,
        offsetTopLeft: p,
        position: g,
        reverseDirection: y,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: b,
        viewBox: w
      }), x = C.cssClasses, S = C.cssProperties, A = wRe(wRe({
        transition: h && i ? "transform ".concat(s, "ms ").concat(l) : void 0
      }, S), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && i && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, _);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ Te.createElement("div", {
          tabIndex: -1,
          className: x,
          style: A,
          ref: function(M) {
            n.wrapperNode = M;
          }
        }, c)
      );
    }
  }]);
}(g0), lIr = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Jy = {
  isSsr: lIr()
};
function Rx(t) {
  "@babel/helpers - typeof";
  return Rx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rx(t);
}
function _Re(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function kRe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _Re(Object(r), !0).forEach(function(n) {
      vye(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : _Re(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function cIr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uIr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Lut(n.key), n);
  }
}
function dIr(t, e, r) {
  return e && uIr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function fIr(t, e, r) {
  return e = Aj(e), hIr(t, Dut() ? Reflect.construct(e, r || [], Aj(t).constructor) : e.apply(t, r));
}
function hIr(t, e) {
  if (e && (Rx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pIr(t);
}
function pIr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Dut() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Dut = function() {
    return !!t;
  })();
}
function Aj(t) {
  return Aj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Aj(t);
}
function mIr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && qde(t, e);
}
function qde(t, e) {
  return qde = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, qde(t, e);
}
function vye(t, e, r) {
  return e = Lut(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Lut(t) {
  var e = gIr(t, "string");
  return Rx(e) == "symbol" ? e : e + "";
}
function gIr(t, e) {
  if (Rx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Rx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function vIr(t) {
  return t.dataKey;
}
function yIr(t, e) {
  return /* @__PURE__ */ Te.isValidElement(t) ? /* @__PURE__ */ Te.cloneElement(t, e) : typeof t == "function" ? /* @__PURE__ */ Te.createElement(t, e) : /* @__PURE__ */ Te.createElement(VEr, e);
}
var Jd = /* @__PURE__ */ function(t) {
  function e() {
    return cIr(this, e), fIr(this, e, arguments);
  }
  return mIr(e, t), dIr(e, [{
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.active, o = a.allowEscapeViewBox, s = a.animationDuration, l = a.animationEasing, c = a.content, u = a.coordinate, f = a.filterNull, h = a.isAnimationActive, p = a.offset, g = a.payload, y = a.payloadUniqBy, b = a.position, w = a.reverseDirection, _ = a.useTranslate3d, C = a.viewBox, x = a.wrapperStyle, S = g ?? [];
      f && S.length && (S = Eut(g.filter(function(I) {
        return I.value != null && (I.hide !== !0 || n.props.includeHidden);
      }), y, vIr));
      var A = S.length > 0;
      return /* @__PURE__ */ Te.createElement(sIr, {
        allowEscapeViewBox: o,
        animationDuration: s,
        animationEasing: l,
        isAnimationActive: h,
        active: i,
        coordinate: u,
        hasPayload: A,
        offset: p,
        position: b,
        reverseDirection: w,
        useTranslate3d: _,
        viewBox: C,
        wrapperStyle: x
      }, yIr(c, kRe(kRe({}, this.props), {}, {
        payload: S
      })));
    }
  }]);
}(g0);
vye(Jd, "displayName", "Tooltip");
vye(Jd, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Jy.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var Bne, ARe;
function bIr() {
  if (ARe) return Bne;
  ARe = 1;
  var t = op(), e = function() {
    return t.Date.now();
  };
  return Bne = e, Bne;
}
var Nne, TRe;
function xIr() {
  if (TRe) return Nne;
  TRe = 1;
  var t = /\s/;
  function e(r) {
    for (var n = r.length; n-- && t.test(r.charAt(n)); )
      ;
    return n;
  }
  return Nne = e, Nne;
}
var $ne, ERe;
function CIr() {
  if (ERe) return $ne;
  ERe = 1;
  var t = xIr(), e = /^\s+/;
  function r(n) {
    return n && n.slice(0, t(n) + 1).replace(e, "");
  }
  return $ne = r, $ne;
}
var Dne, IRe;
function jut() {
  if (IRe) return Dne;
  IRe = 1;
  var t = CIr(), e = Zy(), r = rC(), n = NaN, a = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, o = /^0o[0-7]+$/i, s = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (r(c))
      return n;
    if (e(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = t(c);
    var f = i.test(c);
    return f || o.test(c) ? s(c.slice(2), f ? 2 : 8) : a.test(c) ? n : +c;
  }
  return Dne = l, Dne;
}
var Lne, MRe;
function wIr() {
  if (MRe) return Lne;
  MRe = 1;
  var t = Zy(), e = bIr(), r = jut(), n = "Expected a function", a = Math.max, i = Math.min;
  function o(s, l, c) {
    var u, f, h, p, g, y, b = 0, w = !1, _ = !1, C = !0;
    if (typeof s != "function")
      throw new TypeError(n);
    l = r(l) || 0, t(c) && (w = !!c.leading, _ = "maxWait" in c, h = _ ? a(r(c.maxWait) || 0, l) : h, C = "trailing" in c ? !!c.trailing : C);
    function x(m) {
      var v = u, k = f;
      return u = f = void 0, b = m, p = s.apply(k, v), p;
    }
    function S(m) {
      return b = m, g = setTimeout(M, l), w ? x(m) : p;
    }
    function A(m) {
      var v = m - y, k = m - b, O = l - v;
      return _ ? i(O, h - k) : O;
    }
    function I(m) {
      var v = m - y, k = m - b;
      return y === void 0 || v >= l || v < 0 || _ && k >= h;
    }
    function M() {
      var m = e();
      if (I(m))
        return B(m);
      g = setTimeout(M, A(m));
    }
    function B(m) {
      return g = void 0, C && u ? x(m) : (u = f = void 0, p);
    }
    function L() {
      g !== void 0 && clearTimeout(g), b = 0, u = y = f = g = void 0;
    }
    function N() {
      return g === void 0 ? p : B(e());
    }
    function d() {
      var m = e(), v = I(m);
      if (u = arguments, f = this, y = m, v) {
        if (g === void 0)
          return S(y);
        if (_)
          return clearTimeout(g), g = setTimeout(M, l), x(y);
      }
      return g === void 0 && (g = setTimeout(M, l)), p;
    }
    return d.cancel = L, d.flush = N, d;
  }
  return Lne = o, Lne;
}
var jne, PRe;
function SIr() {
  if (PRe) return jne;
  PRe = 1;
  var t = wIr(), e = Zy(), r = "Expected a function";
  function n(a, i, o) {
    var s = !0, l = !0;
    if (typeof a != "function")
      throw new TypeError(r);
    return e(o) && (s = "leading" in o ? !!o.leading : s, l = "trailing" in o ? !!o.trailing : l), t(a, i, {
      leading: s,
      maxWait: i,
      trailing: l
    });
  }
  return jne = n, jne;
}
var _Ir = SIr();
const Fut = /* @__PURE__ */ Gi(_Ir);
function TE(t) {
  "@babel/helpers - typeof";
  return TE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, TE(t);
}
function RRe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function XB(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? RRe(Object(r), !0).forEach(function(n) {
      kIr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : RRe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function kIr(t, e, r) {
  return e = AIr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function AIr(t) {
  var e = TIr(t, "string");
  return TE(e) == "symbol" ? e : e + "";
}
function TIr(t, e) {
  if (TE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (TE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function EIr(t, e) {
  return RIr(t) || PIr(t, e) || MIr(t, e) || IIr();
}
function IIr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MIr(t, e) {
  if (t) {
    if (typeof t == "string") return ORe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ORe(t, e);
  }
}
function ORe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function PIr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function RIr(t) {
  if (Array.isArray(t)) return t;
}
var YW = /* @__PURE__ */ Ml(function(t, e) {
  var r = t.aspect, n = t.initialDimension, a = n === void 0 ? {
    width: -1,
    height: -1
  } : n, i = t.width, o = i === void 0 ? "100%" : i, s = t.height, l = s === void 0 ? "100%" : s, c = t.minWidth, u = c === void 0 ? 0 : c, f = t.minHeight, h = t.maxHeight, p = t.children, g = t.debounce, y = g === void 0 ? 0 : g, b = t.id, w = t.className, _ = t.onResize, C = t.style, x = C === void 0 ? {} : C, S = Zt(null), A = Zt();
  A.current = _, KGe(e, function() {
    return Object.defineProperty(S.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), S.current;
      },
      configurable: !0
    });
  });
  var I = Yt({
    containerWidth: a.width,
    containerHeight: a.height
  }), M = EIr(I, 2), B = M[0], L = M[1], N = sr(function(m, v) {
    L(function(k) {
      var O = Math.round(m), G = Math.round(v);
      return k.containerWidth === O && k.containerHeight === G ? k : {
        containerWidth: O,
        containerHeight: G
      };
    });
  }, []);
  Ut(function() {
    var m = function(j) {
      var F, z = j[0].contentRect, W = z.width, U = z.height;
      N(W, U), (F = A.current) === null || F === void 0 || F.call(A, W, U);
    };
    y > 0 && (m = Fut(m, y, {
      trailing: !0,
      leading: !1
    }));
    var v = new ResizeObserver(m), k = S.current.getBoundingClientRect(), O = k.width, G = k.height;
    return N(O, G), v.observe(S.current), function() {
      v.disconnect();
    };
  }, [N, y]);
  var d = fa(function() {
    var m = B.containerWidth, v = B.containerHeight;
    if (m < 0 || v < 0)
      return null;
    O1(vb(o) || vb(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, l), O1(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var k = vb(o) ? m : o, O = vb(l) ? v : l;
    r && r > 0 && (k ? O = k / r : O && (k = O * r), h && O > h && (O = h)), O1(k > 0 || O > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, k, O, o, l, u, f, r);
    var G = !Array.isArray(p) && Im(p.type).endsWith("Chart");
    return Te.Children.map(p, function(H) {
      return /* @__PURE__ */ Te.isValidElement(H) ? /* @__PURE__ */ xl(H, XB({
        width: k,
        height: O
      }, G ? {
        style: XB({
          height: "100%",
          width: "100%",
          maxHeight: O,
          maxWidth: k
        }, H.props.style)
      } : {})) : H;
    });
  }, [r, p, l, h, f, u, B, o]);
  return /* @__PURE__ */ Te.createElement("div", {
    id: b ? "".concat(b) : void 0,
    className: ti("recharts-responsive-container", w),
    style: XB(XB({}, x), {}, {
      width: o,
      height: l,
      minWidth: u,
      minHeight: f,
      maxHeight: h
    }),
    ref: S
  }, d);
}), yye = function(e) {
  return null;
};
yye.displayName = "Cell";
function EE(t) {
  "@babel/helpers - typeof";
  return EE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, EE(t);
}
function BRe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kde(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? BRe(Object(r), !0).forEach(function(n) {
      OIr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : BRe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function OIr(t, e, r) {
  return e = BIr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function BIr(t) {
  var e = NIr(t, "string");
  return EE(e) == "symbol" ? e : e + "";
}
function NIr(t, e) {
  if (EE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (EE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var n9 = {
  widthCache: {},
  cacheCount: 0
}, $Ir = 2e3, DIr = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, NRe = "recharts_measurement_span";
function LIr(t) {
  var e = Kde({}, t);
  return Object.keys(e).forEach(function(r) {
    e[r] || delete e[r];
  }), e;
}
var G_ = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (e == null || Jy.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = LIr(r), a = JSON.stringify({
    text: e,
    copyStyle: n
  });
  if (n9.widthCache[a])
    return n9.widthCache[a];
  try {
    var i = document.getElementById(NRe);
    i || (i = document.createElement("span"), i.setAttribute("id", NRe), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    var o = Kde(Kde({}, DIr), n);
    Object.assign(i.style, o), i.textContent = "".concat(e);
    var s = i.getBoundingClientRect(), l = {
      width: s.width,
      height: s.height
    };
    return n9.widthCache[a] = l, ++n9.cacheCount > $Ir && (n9.cacheCount = 0, n9.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, jIr = function(e) {
  return {
    top: e.top + window.scrollY - document.documentElement.clientTop,
    left: e.left + window.scrollX - document.documentElement.clientLeft
  };
};
function IE(t) {
  "@babel/helpers - typeof";
  return IE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, IE(t);
}
function Tj(t, e) {
  return WIr(t) || GIr(t, e) || zIr(t, e) || FIr();
}
function FIr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zIr(t, e) {
  if (t) {
    if (typeof t == "string") return $Re(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $Re(t, e);
  }
}
function $Re(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function GIr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function WIr(t) {
  if (Array.isArray(t)) return t;
}
function HIr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function DRe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, VIr(n.key), n);
  }
}
function UIr(t, e, r) {
  return e && DRe(t.prototype, e), r && DRe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function VIr(t) {
  var e = qIr(t, "string");
  return IE(e) == "symbol" ? e : e + "";
}
function qIr(t, e) {
  if (IE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (IE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var LRe = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, jRe = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, KIr = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, ZIr = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, zut = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, JIr = Object.keys(zut), K9 = "NaN";
function YIr(t, e) {
  return t * zut[e];
}
var QB = /* @__PURE__ */ function() {
  function t(e, r) {
    HIr(this, t), this.num = e, this.unit = r, this.num = e, this.unit = r, Number.isNaN(e) && (this.unit = ""), r !== "" && !KIr.test(r) && (this.num = NaN, this.unit = ""), JIr.includes(r) && (this.num = YIr(e, r), this.unit = "px");
  }
  return UIr(t, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new t(NaN, "") : new t(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new t(NaN, "") : new t(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new t(NaN, "") : new t(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new t(NaN, "") : new t(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, a = (n = ZIr.exec(r)) !== null && n !== void 0 ? n : [], i = Tj(a, 3), o = i[1], s = i[2];
      return new t(parseFloat(o), s ?? "");
    }
  }]);
}();
function Gut(t) {
  if (t.includes(K9))
    return K9;
  for (var e = t; e.includes("*") || e.includes("/"); ) {
    var r, n = (r = LRe.exec(e)) !== null && r !== void 0 ? r : [], a = Tj(n, 4), i = a[1], o = a[2], s = a[3], l = QB.parse(i ?? ""), c = QB.parse(s ?? ""), u = o === "*" ? l.multiply(c) : l.divide(c);
    if (u.isNaN())
      return K9;
    e = e.replace(LRe, u.toString());
  }
  for (; e.includes("+") || /.-\d+(?:\.\d+)?/.test(e); ) {
    var f, h = (f = jRe.exec(e)) !== null && f !== void 0 ? f : [], p = Tj(h, 4), g = p[1], y = p[2], b = p[3], w = QB.parse(g ?? ""), _ = QB.parse(b ?? ""), C = y === "+" ? w.add(_) : w.subtract(_);
    if (C.isNaN())
      return K9;
    e = e.replace(jRe, C.toString());
  }
  return e;
}
var FRe = /\(([^()]*)\)/;
function XIr(t) {
  for (var e = t; e.includes("("); ) {
    var r = FRe.exec(e), n = Tj(r, 2), a = n[1];
    e = e.replace(FRe, Gut(a));
  }
  return e;
}
function QIr(t) {
  var e = t.replace(/\s+/g, "");
  return e = XIr(e), e = Gut(e), e;
}
function eMr(t) {
  try {
    return QIr(t);
  } catch {
    return K9;
  }
}
function Fne(t) {
  var e = eMr(t.slice(5, -1));
  return e === K9 ? "" : e;
}
var tMr = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], rMr = ["dx", "dy", "angle", "className", "breakAll"];
function Zde() {
  return Zde = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Zde.apply(this, arguments);
}
function zRe(t, e) {
  if (t == null) return {};
  var r = nMr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function nMr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function GRe(t, e) {
  return sMr(t) || oMr(t, e) || iMr(t, e) || aMr();
}
function aMr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iMr(t, e) {
  if (t) {
    if (typeof t == "string") return WRe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return WRe(t, e);
  }
}
function WRe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function oMr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e === 0) {
        if (Object(r) !== r) return;
        l = !1;
      } else for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function sMr(t) {
  if (Array.isArray(t)) return t;
}
var Wut = /[ \f\n\r\t\v\u2028\u2029]+/, Hut = function(e) {
  var r = e.children, n = e.breakAll, a = e.style;
  try {
    var i = [];
    Va(r) || (n ? i = r.toString().split("") : i = r.toString().split(Wut));
    var o = i.map(function(l) {
      return {
        word: l,
        width: G_(l, a).width
      };
    }), s = n ? 0 : G_(" ", a).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: s
    };
  } catch {
    return null;
  }
}, lMr = function(e, r, n, a, i) {
  var o = e.maxLines, s = e.children, l = e.style, c = e.breakAll, u = Ur(o), f = s, h = function() {
    var k = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return k.reduce(function(O, G) {
      var H = G.word, j = G.width, F = O[O.length - 1];
      if (F && (a == null || i || F.width + j + n < Number(a)))
        F.words.push(H), F.width += j + n;
      else {
        var z = {
          words: [H],
          width: j
        };
        O.push(z);
      }
      return O;
    }, []);
  }, p = h(r), g = function(k) {
    return k.reduce(function(O, G) {
      return O.width > G.width ? O : G;
    });
  };
  if (!u)
    return p;
  for (var y = "…", b = function(k) {
    var O = f.slice(0, k), G = Hut({
      breakAll: c,
      style: l,
      children: O + y
    }).wordsWithComputedWidth, H = h(G), j = H.length > o || g(H).width > Number(a);
    return [j, H];
  }, w = 0, _ = f.length - 1, C = 0, x; w <= _ && C <= f.length - 1; ) {
    var S = Math.floor((w + _) / 2), A = S - 1, I = b(A), M = GRe(I, 2), B = M[0], L = M[1], N = b(S), d = GRe(N, 1), m = d[0];
    if (!B && !m && (w = S + 1), B && m && (_ = S - 1), !B && m) {
      x = L;
      break;
    }
    C++;
  }
  return x || p;
}, HRe = function(e) {
  var r = Va(e) ? [] : e.toString().split(Wut);
  return [{
    words: r
  }];
}, cMr = function(e) {
  var r = e.width, n = e.scaleToFit, a = e.children, i = e.style, o = e.breakAll, s = e.maxLines;
  if ((r || n) && !Jy.isSsr) {
    var l, c, u = Hut({
      breakAll: o,
      children: a,
      style: i
    });
    if (u) {
      var f = u.wordsWithComputedWidth, h = u.spaceWidth;
      l = f, c = h;
    } else
      return HRe(a);
    return lMr({
      breakAll: o,
      children: a,
      maxLines: s,
      style: i
    }, l, c, r, n);
  }
  return HRe(a);
}, URe = "#808080", P5 = function(e) {
  var r = e.x, n = r === void 0 ? 0 : r, a = e.y, i = a === void 0 ? 0 : a, o = e.lineHeight, s = o === void 0 ? "1em" : o, l = e.capHeight, c = l === void 0 ? "0.71em" : l, u = e.scaleToFit, f = u === void 0 ? !1 : u, h = e.textAnchor, p = h === void 0 ? "start" : h, g = e.verticalAnchor, y = g === void 0 ? "end" : g, b = e.fill, w = b === void 0 ? URe : b, _ = zRe(e, tMr), C = fa(function() {
    return cMr({
      breakAll: _.breakAll,
      children: _.children,
      maxLines: _.maxLines,
      scaleToFit: f,
      style: _.style,
      width: _.width
    });
  }, [_.breakAll, _.children, _.maxLines, f, _.style, _.width]), x = _.dx, S = _.dy, A = _.angle, I = _.className, M = _.breakAll, B = zRe(_, rMr);
  if (!Hl(n) || !Hl(i))
    return null;
  var L = n + (Ur(x) ? x : 0), N = i + (Ur(S) ? S : 0), d;
  switch (y) {
    case "start":
      d = Fne("calc(".concat(c, ")"));
      break;
    case "middle":
      d = Fne("calc(".concat((C.length - 1) / 2, " * -").concat(s, " + (").concat(c, " / 2))"));
      break;
    default:
      d = Fne("calc(".concat(C.length - 1, " * -").concat(s, ")"));
      break;
  }
  var m = [];
  if (f) {
    var v = C[0].width, k = _.width;
    m.push("scale(".concat((Ur(k) ? k / v : 1) / v, ")"));
  }
  return A && m.push("rotate(".concat(A, ", ").concat(L, ", ").concat(N, ")")), m.length && (B.transform = m.join(" ")), /* @__PURE__ */ Te.createElement("text", Zde({}, Un(B, !0), {
    x: L,
    y: N,
    className: ti("recharts-text", I),
    textAnchor: p,
    fill: w.includes("url") ? URe : w
  }), C.map(function(O, G) {
    var H = O.words.join(M ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ Te.createElement("tspan", {
        x: L,
        dy: G === 0 ? d : s,
        key: "".concat(H, "-").concat(G)
      }, H)
    );
  }));
};
function $v(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function uMr(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function bye(t) {
  let e, r, n;
  t.length !== 2 ? (e = $v, r = (s, l) => $v(t(s), l), n = (s, l) => t(s) - l) : (e = t === $v || t === uMr ? t : dMr, r = t, n = t);
  function a(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const f = c + u >>> 1;
        r(s[f], l) < 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function i(s, l, c = 0, u = s.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const f = c + u >>> 1;
        r(s[f], l) <= 0 ? c = f + 1 : u = f;
      } while (c < u);
    }
    return c;
  }
  function o(s, l, c = 0, u = s.length) {
    const f = a(s, l, c, u - 1);
    return f > c && n(s[f - 1], l) > -n(s[f], l) ? f - 1 : f;
  }
  return { left: a, center: o, right: i };
}
function dMr() {
  return 0;
}
function Uut(t) {
  return t === null ? NaN : +t;
}
function* fMr(t, e) {
  for (let r of t)
    r != null && (r = +r) >= r && (yield r);
}
const hMr = bye($v), lP = hMr.right;
bye(Uut).center;
class VRe extends Map {
  constructor(e, r = gMr) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), e != null) for (const [n, a] of e) this.set(n, a);
  }
  get(e) {
    return super.get(qRe(this, e));
  }
  has(e) {
    return super.has(qRe(this, e));
  }
  set(e, r) {
    return super.set(pMr(this, e), r);
  }
  delete(e) {
    return super.delete(mMr(this, e));
  }
}
function qRe({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) ? t.get(n) : r;
}
function pMr({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) ? t.get(n) : (t.set(n, r), r);
}
function mMr({ _intern: t, _key: e }, r) {
  const n = e(r);
  return t.has(n) && (r = t.get(n), t.delete(n)), r;
}
function gMr(t) {
  return t !== null && typeof t == "object" ? t.valueOf() : t;
}
function vMr(t = $v) {
  if (t === $v) return Vut;
  if (typeof t != "function") throw new TypeError("compare is not a function");
  return (e, r) => {
    const n = t(e, r);
    return n || n === 0 ? n : (t(r, r) === 0) - (t(e, e) === 0);
  };
}
function Vut(t, e) {
  return (t == null || !(t >= t)) - (e == null || !(e >= e)) || (t < e ? -1 : t > e ? 1 : 0);
}
const yMr = Math.sqrt(50), bMr = Math.sqrt(10), xMr = Math.sqrt(2);
function Ej(t, e, r) {
  const n = (e - t) / Math.max(0, r), a = Math.floor(Math.log10(n)), i = n / Math.pow(10, a), o = i >= yMr ? 10 : i >= bMr ? 5 : i >= xMr ? 2 : 1;
  let s, l, c;
  return a < 0 ? (c = Math.pow(10, -a) / o, s = Math.round(t * c), l = Math.round(e * c), s / c < t && ++s, l / c > e && --l, c = -c) : (c = Math.pow(10, a) * o, s = Math.round(t / c), l = Math.round(e / c), s * c < t && ++s, l * c > e && --l), l < s && 0.5 <= r && r < 2 ? Ej(t, e, r * 2) : [s, l, c];
}
function Jde(t, e, r) {
  if (e = +e, t = +t, r = +r, !(r > 0)) return [];
  if (t === e) return [t];
  const n = e < t, [a, i, o] = n ? Ej(e, t, r) : Ej(t, e, r);
  if (!(i >= a)) return [];
  const s = i - a + 1, l = new Array(s);
  if (n)
    if (o < 0) for (let c = 0; c < s; ++c) l[c] = (i - c) / -o;
    else for (let c = 0; c < s; ++c) l[c] = (i - c) * o;
  else if (o < 0) for (let c = 0; c < s; ++c) l[c] = (a + c) / -o;
  else for (let c = 0; c < s; ++c) l[c] = (a + c) * o;
  return l;
}
function Yde(t, e, r) {
  return e = +e, t = +t, r = +r, Ej(t, e, r)[2];
}
function Xde(t, e, r) {
  e = +e, t = +t, r = +r;
  const n = e < t, a = n ? Yde(e, t, r) : Yde(t, e, r);
  return (n ? -1 : 1) * (a < 0 ? 1 / -a : a);
}
function KRe(t, e) {
  let r;
  for (const n of t)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function ZRe(t, e) {
  let r;
  for (const n of t)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function qut(t, e, r = 0, n = 1 / 0, a) {
  if (e = Math.floor(e), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(t.length - 1, n)), !(r <= e && e <= n)) return t;
  for (a = a === void 0 ? Vut : vMr(a); n > r; ) {
    if (n - r > 600) {
      const l = n - r + 1, c = e - r + 1, u = Math.log(l), f = 0.5 * Math.exp(2 * u / 3), h = 0.5 * Math.sqrt(u * f * (l - f) / l) * (c - l / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(e - c * f / l + h)), g = Math.min(n, Math.floor(e + (l - c) * f / l + h));
      qut(t, e, p, g, a);
    }
    const i = t[e];
    let o = r, s = n;
    for (sS(t, r, e), a(t[n], i) > 0 && sS(t, r, n); o < s; ) {
      for (sS(t, o, s), ++o, --s; a(t[o], i) < 0; ) ++o;
      for (; a(t[s], i) > 0; ) --s;
    }
    a(t[r], i) === 0 ? sS(t, r, s) : (++s, sS(t, s, n)), s <= e && (r = s + 1), e <= s && (n = s - 1);
  }
  return t;
}
function sS(t, e, r) {
  const n = t[e];
  t[e] = t[r], t[r] = n;
}
function CMr(t, e, r) {
  if (t = Float64Array.from(fMr(t)), !(!(n = t.length) || isNaN(e = +e))) {
    if (e <= 0 || n < 2) return ZRe(t);
    if (e >= 1) return KRe(t);
    var n, a = (n - 1) * e, i = Math.floor(a), o = KRe(qut(t, i).subarray(0, i + 1)), s = ZRe(t.subarray(i + 1));
    return o + (s - o) * (a - i);
  }
}
function wMr(t, e, r = Uut) {
  if (!(!(n = t.length) || isNaN(e = +e))) {
    if (e <= 0 || n < 2) return +r(t[0], 0, t);
    if (e >= 1) return +r(t[n - 1], n - 1, t);
    var n, a = (n - 1) * e, i = Math.floor(a), o = +r(t[i], i, t), s = +r(t[i + 1], i + 1, t);
    return o + (s - o) * (a - i);
  }
}
function SMr(t, e, r) {
  t = +t, e = +e, r = (a = arguments.length) < 2 ? (e = t, t = 0, 1) : a < 3 ? 1 : +r;
  for (var n = -1, a = Math.max(0, Math.ceil((e - t) / r)) | 0, i = new Array(a); ++n < a; )
    i[n] = t + n * r;
  return i;
}
function Af(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function xg(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
    default: {
      this.domain(t), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const Qde = Symbol("implicit");
function xye() {
  var t = new VRe(), e = [], r = [], n = Qde;
  function a(i) {
    let o = t.get(i);
    if (o === void 0) {
      if (n !== Qde) return n;
      t.set(i, o = e.push(i) - 1);
    }
    return r[o % r.length];
  }
  return a.domain = function(i) {
    if (!arguments.length) return e.slice();
    e = [], t = new VRe();
    for (const o of i)
      t.has(o) || t.set(o, e.push(o) - 1);
    return a;
  }, a.range = function(i) {
    return arguments.length ? (r = Array.from(i), a) : r.slice();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return xye(e, r).unknown(n);
  }, Af.apply(a, arguments), a;
}
function ME() {
  var t = xye().unknown(void 0), e = t.domain, r = t.range, n = 0, a = 1, i, o, s = !1, l = 0, c = 0, u = 0.5;
  delete t.unknown;
  function f() {
    var h = e().length, p = a < n, g = p ? a : n, y = p ? n : a;
    i = (y - g) / Math.max(1, h - l + c * 2), s && (i = Math.floor(i)), g += (y - g - i * (h - l)) * u, o = i * (1 - l), s && (g = Math.round(g), o = Math.round(o));
    var b = SMr(h).map(function(w) {
      return g + i * w;
    });
    return r(p ? b.reverse() : b);
  }
  return t.domain = function(h) {
    return arguments.length ? (e(h), f()) : e();
  }, t.range = function(h) {
    return arguments.length ? ([n, a] = h, n = +n, a = +a, f()) : [n, a];
  }, t.rangeRound = function(h) {
    return [n, a] = h, n = +n, a = +a, s = !0, f();
  }, t.bandwidth = function() {
    return o;
  }, t.step = function() {
    return i;
  }, t.round = function(h) {
    return arguments.length ? (s = !!h, f()) : s;
  }, t.padding = function(h) {
    return arguments.length ? (l = Math.min(1, c = +h), f()) : l;
  }, t.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), f()) : l;
  }, t.paddingOuter = function(h) {
    return arguments.length ? (c = +h, f()) : c;
  }, t.align = function(h) {
    return arguments.length ? (u = Math.max(0, Math.min(1, h)), f()) : u;
  }, t.copy = function() {
    return ME(e(), [n, a]).round(s).paddingInner(l).paddingOuter(c).align(u);
  }, Af.apply(f(), arguments);
}
function Kut(t) {
  var e = t.copy;
  return t.padding = t.paddingOuter, delete t.paddingInner, delete t.paddingOuter, t.copy = function() {
    return Kut(e());
  }, t;
}
function W_() {
  return Kut(ME.apply(null, arguments).paddingInner(1));
}
function Cye(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}
function Zut(t, e) {
  var r = Object.create(t.prototype);
  for (var n in e) r[n] = e[n];
  return r;
}
function cP() {
}
var PE = 0.7, Ij = 1 / PE, A7 = "\\s*([+-]?\\d+)\\s*", RE = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", _h = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", _Mr = /^#([0-9a-f]{3,8})$/, kMr = new RegExp(`^rgb\\(${A7},${A7},${A7}\\)$`), AMr = new RegExp(`^rgb\\(${_h},${_h},${_h}\\)$`), TMr = new RegExp(`^rgba\\(${A7},${A7},${A7},${RE}\\)$`), EMr = new RegExp(`^rgba\\(${_h},${_h},${_h},${RE}\\)$`), IMr = new RegExp(`^hsl\\(${RE},${_h},${_h}\\)$`), MMr = new RegExp(`^hsla\\(${RE},${_h},${_h},${RE}\\)$`), JRe = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Cye(cP, R5, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: YRe,
  // Deprecated! Use color.formatHex.
  formatHex: YRe,
  formatHex8: PMr,
  formatHsl: RMr,
  formatRgb: XRe,
  toString: XRe
});
function YRe() {
  return this.rgb().formatHex();
}
function PMr() {
  return this.rgb().formatHex8();
}
function RMr() {
  return Jut(this).formatHsl();
}
function XRe() {
  return this.rgb().formatRgb();
}
function R5(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = _Mr.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? QRe(e) : r === 3 ? new hd(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? eN(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? eN(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = kMr.exec(t)) ? new hd(e[1], e[2], e[3], 1) : (e = AMr.exec(t)) ? new hd(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = TMr.exec(t)) ? eN(e[1], e[2], e[3], e[4]) : (e = EMr.exec(t)) ? eN(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = IMr.exec(t)) ? rOe(e[1], e[2] / 100, e[3] / 100, 1) : (e = MMr.exec(t)) ? rOe(e[1], e[2] / 100, e[3] / 100, e[4]) : JRe.hasOwnProperty(t) ? QRe(JRe[t]) : t === "transparent" ? new hd(NaN, NaN, NaN, 0) : null;
}
function QRe(t) {
  return new hd(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function eN(t, e, r, n) {
  return n <= 0 && (t = e = r = NaN), new hd(t, e, r, n);
}
function OMr(t) {
  return t instanceof cP || (t = R5(t)), t ? (t = t.rgb(), new hd(t.r, t.g, t.b, t.opacity)) : new hd();
}
function e0e(t, e, r, n) {
  return arguments.length === 1 ? OMr(t) : new hd(t, e, r, n ?? 1);
}
function hd(t, e, r, n) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
}
Cye(hd, e0e, Zut(cP, {
  brighter(t) {
    return t = t == null ? Ij : Math.pow(Ij, t), new hd(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? PE : Math.pow(PE, t), new hd(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new hd(zb(this.r), zb(this.g), zb(this.b), Mj(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: eOe,
  // Deprecated! Use color.formatHex.
  formatHex: eOe,
  formatHex8: BMr,
  formatRgb: tOe,
  toString: tOe
}));
function eOe() {
  return `#${yb(this.r)}${yb(this.g)}${yb(this.b)}`;
}
function BMr() {
  return `#${yb(this.r)}${yb(this.g)}${yb(this.b)}${yb((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function tOe() {
  const t = Mj(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${zb(this.r)}, ${zb(this.g)}, ${zb(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function Mj(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function zb(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function yb(t) {
  return t = zb(t), (t < 16 ? "0" : "") + t.toString(16);
}
function rOe(t, e, r, n) {
  return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new g1(t, e, r, n);
}
function Jut(t) {
  if (t instanceof g1) return new g1(t.h, t.s, t.l, t.opacity);
  if (t instanceof cP || (t = R5(t)), !t) return new g1();
  if (t instanceof g1) return t;
  t = t.rgb();
  var e = t.r / 255, r = t.g / 255, n = t.b / 255, a = Math.min(e, r, n), i = Math.max(e, r, n), o = NaN, s = i - a, l = (i + a) / 2;
  return s ? (e === i ? o = (r - n) / s + (r < n) * 6 : r === i ? o = (n - e) / s + 2 : o = (e - r) / s + 4, s /= l < 0.5 ? i + a : 2 - i - a, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new g1(o, s, l, t.opacity);
}
function NMr(t, e, r, n) {
  return arguments.length === 1 ? Jut(t) : new g1(t, e, r, n ?? 1);
}
function g1(t, e, r, n) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
}
Cye(g1, NMr, Zut(cP, {
  brighter(t) {
    return t = t == null ? Ij : Math.pow(Ij, t), new g1(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? PE : Math.pow(PE, t), new g1(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * e, a = 2 * r - n;
    return new hd(
      zne(t >= 240 ? t - 240 : t + 120, a, n),
      zne(t, a, n),
      zne(t < 120 ? t + 240 : t - 120, a, n),
      this.opacity
    );
  },
  clamp() {
    return new g1(nOe(this.h), tN(this.s), tN(this.l), Mj(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = Mj(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${nOe(this.h)}, ${tN(this.s) * 100}%, ${tN(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function nOe(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function tN(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function zne(t, e, r) {
  return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
const wye = (t) => () => t;
function $Mr(t, e) {
  return function(r) {
    return t + r * e;
  };
}
function DMr(t, e, r) {
  return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(n) {
    return Math.pow(t + n * e, r);
  };
}
function LMr(t) {
  return (t = +t) == 1 ? Yut : function(e, r) {
    return r - e ? DMr(e, r, t) : wye(isNaN(e) ? r : e);
  };
}
function Yut(t, e) {
  var r = e - t;
  return r ? $Mr(t, r) : wye(isNaN(t) ? e : t);
}
const Pj = function t(e) {
  var r = LMr(e);
  function n(a, i) {
    var o = r((a = e0e(a)).r, (i = e0e(i)).r), s = r(a.g, i.g), l = r(a.b, i.b), c = Yut(a.opacity, i.opacity);
    return function(u) {
      return a.r = o(u), a.g = s(u), a.b = l(u), a.opacity = c(u), a + "";
    };
  }
  return n.gamma = t, n;
}(1);
function jMr(t, e) {
  e || (e = []);
  var r = t ? Math.min(e.length, t.length) : 0, n = e.slice(), a;
  return function(i) {
    for (a = 0; a < r; ++a) n[a] = t[a] * (1 - i) + e[a] * i;
    return n;
  };
}
function FMr(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function zMr(t, e) {
  var r = e ? e.length : 0, n = t ? Math.min(r, t.length) : 0, a = new Array(n), i = new Array(r), o;
  for (o = 0; o < n; ++o) a[o] = oC(t[o], e[o]);
  for (; o < r; ++o) i[o] = e[o];
  return function(s) {
    for (o = 0; o < n; ++o) i[o] = a[o](s);
    return i;
  };
}
function GMr(t, e) {
  var r = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(n) {
    return r.setTime(t * (1 - n) + e * n), r;
  };
}
function f1(t, e) {
  return t = +t, e = +e, function(r) {
    return t * (1 - r) + e * r;
  };
}
function WMr(t, e) {
  var r = {}, n = {}, a;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (a in e)
    a in t ? r[a] = oC(t[a], e[a]) : n[a] = e[a];
  return function(i) {
    for (a in r) n[a] = r[a](i);
    return n;
  };
}
var t0e = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Gne = new RegExp(t0e.source, "g");
function HMr(t) {
  return function() {
    return t;
  };
}
function UMr(t) {
  return function(e) {
    return t(e) + "";
  };
}
function Xut(t, e) {
  var r = t0e.lastIndex = Gne.lastIndex = 0, n, a, i, o = -1, s = [], l = [];
  for (t = t + "", e = e + ""; (n = t0e.exec(t)) && (a = Gne.exec(e)); )
    (i = a.index) > r && (i = e.slice(r, i), s[o] ? s[o] += i : s[++o] = i), (n = n[0]) === (a = a[0]) ? s[o] ? s[o] += a : s[++o] = a : (s[++o] = null, l.push({ i: o, x: f1(n, a) })), r = Gne.lastIndex;
  return r < e.length && (i = e.slice(r), s[o] ? s[o] += i : s[++o] = i), s.length < 2 ? l[0] ? UMr(l[0].x) : HMr(e) : (e = l.length, function(c) {
    for (var u = 0, f; u < e; ++u) s[(f = l[u]).i] = f.x(c);
    return s.join("");
  });
}
function oC(t, e) {
  var r = typeof e, n;
  return e == null || r === "boolean" ? wye(e) : (r === "number" ? f1 : r === "string" ? (n = R5(e)) ? (e = n, Pj) : Xut : e instanceof R5 ? Pj : e instanceof Date ? GMr : FMr(e) ? jMr : Array.isArray(e) ? zMr : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? WMr : f1)(t, e);
}
function Sye(t, e) {
  return t = +t, e = +e, function(r) {
    return Math.round(t * (1 - r) + e * r);
  };
}
var aOe = 180 / Math.PI, r0e = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function Qut(t, e, r, n, a, i) {
  var o, s, l;
  return (o = Math.sqrt(t * t + e * e)) && (t /= o, e /= o), (l = t * r + e * n) && (r -= t * l, n -= e * l), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, l /= s), t * n < e * r && (t = -t, e = -e, l = -l, o = -o), {
    translateX: a,
    translateY: i,
    rotate: Math.atan2(e, t) * aOe,
    skewX: Math.atan(l) * aOe,
    scaleX: o,
    scaleY: s
  };
}
var rN;
function VMr(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? r0e : Qut(e.a, e.b, e.c, e.d, e.e, e.f);
}
function qMr(t) {
  return t == null || (rN || (rN = document.createElementNS("http://www.w3.org/2000/svg", "g")), rN.setAttribute("transform", t), !(t = rN.transform.baseVal.consolidate())) ? r0e : (t = t.matrix, Qut(t.a, t.b, t.c, t.d, t.e, t.f));
}
function edt(t, e, r, n) {
  function a(c) {
    return c.length ? c.pop() + " " : "";
  }
  function i(c, u, f, h, p, g) {
    if (c !== f || u !== h) {
      var y = p.push("translate(", null, e, null, r);
      g.push({ i: y - 4, x: f1(c, f) }, { i: y - 2, x: f1(u, h) });
    } else (f || h) && p.push("translate(" + f + e + h + r);
  }
  function o(c, u, f, h) {
    c !== u ? (c - u > 180 ? u += 360 : u - c > 180 && (c += 360), h.push({ i: f.push(a(f) + "rotate(", null, n) - 2, x: f1(c, u) })) : u && f.push(a(f) + "rotate(" + u + n);
  }
  function s(c, u, f, h) {
    c !== u ? h.push({ i: f.push(a(f) + "skewX(", null, n) - 2, x: f1(c, u) }) : u && f.push(a(f) + "skewX(" + u + n);
  }
  function l(c, u, f, h, p, g) {
    if (c !== f || u !== h) {
      var y = p.push(a(p) + "scale(", null, ",", null, ")");
      g.push({ i: y - 4, x: f1(c, f) }, { i: y - 2, x: f1(u, h) });
    } else (f !== 1 || h !== 1) && p.push(a(p) + "scale(" + f + "," + h + ")");
  }
  return function(c, u) {
    var f = [], h = [];
    return c = t(c), u = t(u), i(c.translateX, c.translateY, u.translateX, u.translateY, f, h), o(c.rotate, u.rotate, f, h), s(c.skewX, u.skewX, f, h), l(c.scaleX, c.scaleY, u.scaleX, u.scaleY, f, h), c = u = null, function(p) {
      for (var g = -1, y = h.length, b; ++g < y; ) f[(b = h[g]).i] = b.x(p);
      return f.join("");
    };
  };
}
var KMr = edt(VMr, "px, ", "px)", "deg)"), ZMr = edt(qMr, ", ", ")", ")"), JMr = 1e-12;
function iOe(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function YMr(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function XMr(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const QMr = function t(e, r, n) {
  function a(i, o) {
    var s = i[0], l = i[1], c = i[2], u = o[0], f = o[1], h = o[2], p = u - s, g = f - l, y = p * p + g * g, b, w;
    if (y < JMr)
      w = Math.log(h / c) / e, b = function(I) {
        return [
          s + I * p,
          l + I * g,
          c * Math.exp(e * I * w)
        ];
      };
    else {
      var _ = Math.sqrt(y), C = (h * h - c * c + n * y) / (2 * c * r * _), x = (h * h - c * c - n * y) / (2 * h * r * _), S = Math.log(Math.sqrt(C * C + 1) - C), A = Math.log(Math.sqrt(x * x + 1) - x);
      w = (A - S) / e, b = function(I) {
        var M = I * w, B = iOe(S), L = c / (r * _) * (B * XMr(e * M + S) - YMr(S));
        return [
          s + L * p,
          l + L * g,
          c * B / iOe(e * M + S)
        ];
      };
    }
    return b.duration = w * 1e3 * e / Math.SQRT2, b;
  }
  return a.rho = function(i) {
    var o = Math.max(1e-3, +i), s = o * o, l = s * s;
    return t(o, s, l);
  }, a;
}(Math.SQRT2, 2, 4);
function ePr(t, e) {
  e === void 0 && (e = t, t = oC);
  for (var r = 0, n = e.length - 1, a = e[0], i = new Array(n < 0 ? 0 : n); r < n; ) i[r] = t(a, a = e[++r]);
  return function(o) {
    var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return i[s](o - s);
  };
}
function tPr(t) {
  return function() {
    return t;
  };
}
function Rj(t) {
  return +t;
}
var oOe = [0, 1];
function ku(t) {
  return t;
}
function n0e(t, e) {
  return (e -= t = +t) ? function(r) {
    return (r - t) / e;
  } : tPr(isNaN(e) ? NaN : 0.5);
}
function rPr(t, e) {
  var r;
  return t > e && (r = t, t = e, e = r), function(n) {
    return Math.max(t, Math.min(e, n));
  };
}
function nPr(t, e, r) {
  var n = t[0], a = t[1], i = e[0], o = e[1];
  return a < n ? (n = n0e(a, n), i = r(o, i)) : (n = n0e(n, a), i = r(i, o)), function(s) {
    return i(n(s));
  };
}
function aPr(t, e, r) {
  var n = Math.min(t.length, e.length) - 1, a = new Array(n), i = new Array(n), o = -1;
  for (t[n] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++o < n; )
    a[o] = n0e(t[o], t[o + 1]), i[o] = r(e[o], e[o + 1]);
  return function(s) {
    var l = lP(t, s, 1, n) - 1;
    return i[l](a[l](s));
  };
}
function uP(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function XW() {
  var t = oOe, e = oOe, r = oC, n, a, i, o = ku, s, l, c;
  function u() {
    var h = Math.min(t.length, e.length);
    return o !== ku && (o = rPr(t[0], t[h - 1])), s = h > 2 ? aPr : nPr, l = c = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? i : (l || (l = s(t.map(n), e, r)))(n(o(h)));
  }
  return f.invert = function(h) {
    return o(a((c || (c = s(e, t.map(n), f1)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (t = Array.from(h, Rj), u()) : t.slice();
  }, f.range = function(h) {
    return arguments.length ? (e = Array.from(h), u()) : e.slice();
  }, f.rangeRound = function(h) {
    return e = Array.from(h), r = Sye, u();
  }, f.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : ku, u()) : o !== ku;
  }, f.interpolate = function(h) {
    return arguments.length ? (r = h, u()) : r;
  }, f.unknown = function(h) {
    return arguments.length ? (i = h, f) : i;
  }, function(h, p) {
    return n = h, a = p, u();
  };
}
function _ye() {
  return XW()(ku, ku);
}
function iPr(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function Oj(t, e) {
  if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0) return null;
  var r, n = t.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +t.slice(r + 1)
  ];
}
function Ox(t) {
  return t = Oj(Math.abs(t)), t ? t[1] : NaN;
}
function oPr(t, e) {
  return function(r, n) {
    for (var a = r.length, i = [], o = 0, s = t[0], l = 0; a > 0 && s > 0 && (l + s + 1 > n && (s = Math.max(1, n - l)), i.push(r.substring(a -= s, a + s)), !((l += s + 1) > n)); )
      s = t[o = (o + 1) % t.length];
    return i.reverse().join(e);
  };
}
function sPr(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(r) {
      return t[+r];
    });
  };
}
var lPr = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function OE(t) {
  if (!(e = lPr.exec(t))) throw new Error("invalid format: " + t);
  var e;
  return new kye({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
OE.prototype = kye.prototype;
function kye(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
kye.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function cPr(t) {
  e: for (var e = t.length, r = 1, n = -1, a; r < e; ++r)
    switch (t[r]) {
      case ".":
        n = a = r;
        break;
      case "0":
        n === 0 && (n = r), a = r;
        break;
      default:
        if (!+t[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? t.slice(0, n) + t.slice(a + 1) : t;
}
var tdt;
function uPr(t, e) {
  var r = Oj(t, e);
  if (!r) return t + "";
  var n = r[0], a = r[1], i = a - (tdt = Math.max(-8, Math.min(8, Math.floor(a / 3))) * 3) + 1, o = n.length;
  return i === o ? n : i > o ? n + new Array(i - o + 1).join("0") : i > 0 ? n.slice(0, i) + "." + n.slice(i) : "0." + new Array(1 - i).join("0") + Oj(t, Math.max(0, e + i - 1))[0];
}
function sOe(t, e) {
  var r = Oj(t, e);
  if (!r) return t + "";
  var n = r[0], a = r[1];
  return a < 0 ? "0." + new Array(-a).join("0") + n : n.length > a + 1 ? n.slice(0, a + 1) + "." + n.slice(a + 1) : n + new Array(a - n.length + 2).join("0");
}
const lOe = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: iPr,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => sOe(t * 100, e),
  r: sOe,
  s: uPr,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function cOe(t) {
  return t;
}
var uOe = Array.prototype.map, dOe = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function dPr(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? cOe : oPr(uOe.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", n = t.currency === void 0 ? "" : t.currency[1] + "", a = t.decimal === void 0 ? "." : t.decimal + "", i = t.numerals === void 0 ? cOe : sPr(uOe.call(t.numerals, String)), o = t.percent === void 0 ? "%" : t.percent + "", s = t.minus === void 0 ? "−" : t.minus + "", l = t.nan === void 0 ? "NaN" : t.nan + "";
  function c(f) {
    f = OE(f);
    var h = f.fill, p = f.align, g = f.sign, y = f.symbol, b = f.zero, w = f.width, _ = f.comma, C = f.precision, x = f.trim, S = f.type;
    S === "n" ? (_ = !0, S = "g") : lOe[S] || (C === void 0 && (C = 12), x = !0, S = "g"), (b || h === "0" && p === "=") && (b = !0, h = "0", p = "=");
    var A = y === "$" ? r : y === "#" && /[boxX]/.test(S) ? "0" + S.toLowerCase() : "", I = y === "$" ? n : /[%p]/.test(S) ? o : "", M = lOe[S], B = /[defgprs%]/.test(S);
    C = C === void 0 ? 6 : /[gprs]/.test(S) ? Math.max(1, Math.min(21, C)) : Math.max(0, Math.min(20, C));
    function L(N) {
      var d = A, m = I, v, k, O;
      if (S === "c")
        m = M(N) + m, N = "";
      else {
        N = +N;
        var G = N < 0 || 1 / N < 0;
        if (N = isNaN(N) ? l : M(Math.abs(N), C), x && (N = cPr(N)), G && +N == 0 && g !== "+" && (G = !1), d = (G ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + d, m = (S === "s" ? dOe[8 + tdt / 3] : "") + m + (G && g === "(" ? ")" : ""), B) {
          for (v = -1, k = N.length; ++v < k; )
            if (O = N.charCodeAt(v), 48 > O || O > 57) {
              m = (O === 46 ? a + N.slice(v + 1) : N.slice(v)) + m, N = N.slice(0, v);
              break;
            }
        }
      }
      _ && !b && (N = e(N, 1 / 0));
      var H = d.length + N.length + m.length, j = H < w ? new Array(w - H + 1).join(h) : "";
      switch (_ && b && (N = e(j + N, j.length ? w - m.length : 1 / 0), j = ""), p) {
        case "<":
          N = d + N + m + j;
          break;
        case "=":
          N = d + j + N + m;
          break;
        case "^":
          N = j.slice(0, H = j.length >> 1) + d + N + m + j.slice(H);
          break;
        default:
          N = j + d + N + m;
          break;
      }
      return i(N);
    }
    return L.toString = function() {
      return f + "";
    }, L;
  }
  function u(f, h) {
    var p = c((f = OE(f), f.type = "f", f)), g = Math.max(-8, Math.min(8, Math.floor(Ox(h) / 3))) * 3, y = Math.pow(10, -g), b = dOe[8 + g / 3];
    return function(w) {
      return p(y * w) + b;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var nN, Aye, rdt;
fPr({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function fPr(t) {
  return nN = dPr(t), Aye = nN.format, rdt = nN.formatPrefix, nN;
}
function hPr(t) {
  return Math.max(0, -Ox(Math.abs(t)));
}
function pPr(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Ox(e) / 3))) * 3 - Ox(Math.abs(t)));
}
function mPr(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Ox(e) - Ox(t)) + 1;
}
function ndt(t, e, r, n) {
  var a = Xde(t, e, r), i;
  switch (n = OE(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(t), Math.abs(e));
      return n.precision == null && !isNaN(i = pPr(a, o)) && (n.precision = i), rdt(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(i = mPr(a, Math.max(Math.abs(t), Math.abs(e)))) && (n.precision = i - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(i = hPr(a)) && (n.precision = i - (n.type === "%") * 2);
      break;
    }
  }
  return Aye(n);
}
function Yy(t) {
  var e = t.domain;
  return t.ticks = function(r) {
    var n = e();
    return Jde(n[0], n[n.length - 1], r ?? 10);
  }, t.tickFormat = function(r, n) {
    var a = e();
    return ndt(a[0], a[a.length - 1], r ?? 10, n);
  }, t.nice = function(r) {
    r == null && (r = 10);
    var n = e(), a = 0, i = n.length - 1, o = n[a], s = n[i], l, c, u = 10;
    for (s < o && (c = o, o = s, s = c, c = a, a = i, i = c); u-- > 0; ) {
      if (c = Yde(o, s, r), c === l)
        return n[a] = o, n[i] = s, e(n);
      if (c > 0)
        o = Math.floor(o / c) * c, s = Math.ceil(s / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, s = Math.floor(s * c) / c;
      else
        break;
      l = c;
    }
    return t;
  }, t;
}
function Bj() {
  var t = _ye();
  return t.copy = function() {
    return uP(t, Bj());
  }, Af.apply(t, arguments), Yy(t);
}
function adt(t) {
  var e;
  function r(n) {
    return n == null || isNaN(n = +n) ? e : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (t = Array.from(n, Rj), r) : t.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (e = n, r) : e;
  }, r.copy = function() {
    return adt(t).unknown(e);
  }, t = arguments.length ? Array.from(t, Rj) : [0, 1], Yy(r);
}
function idt(t, e) {
  t = t.slice();
  var r = 0, n = t.length - 1, a = t[r], i = t[n], o;
  return i < a && (o = r, r = n, n = o, o = a, a = i, i = o), t[r] = e.floor(a), t[n] = e.ceil(i), t;
}
function fOe(t) {
  return Math.log(t);
}
function hOe(t) {
  return Math.exp(t);
}
function gPr(t) {
  return -Math.log(-t);
}
function vPr(t) {
  return -Math.exp(-t);
}
function yPr(t) {
  return isFinite(t) ? +("1e" + t) : t < 0 ? 0 : t;
}
function bPr(t) {
  return t === 10 ? yPr : t === Math.E ? Math.exp : (e) => Math.pow(t, e);
}
function xPr(t) {
  return t === Math.E ? Math.log : t === 10 && Math.log10 || t === 2 && Math.log2 || (t = Math.log(t), (e) => Math.log(e) / t);
}
function pOe(t) {
  return (e, r) => -t(-e, r);
}
function Tye(t) {
  const e = t(fOe, hOe), r = e.domain;
  let n = 10, a, i;
  function o() {
    return a = xPr(n), i = bPr(n), r()[0] < 0 ? (a = pOe(a), i = pOe(i), t(gPr, vPr)) : t(fOe, hOe), e;
  }
  return e.base = function(s) {
    return arguments.length ? (n = +s, o()) : n;
  }, e.domain = function(s) {
    return arguments.length ? (r(s), o()) : r();
  }, e.ticks = (s) => {
    const l = r();
    let c = l[0], u = l[l.length - 1];
    const f = u < c;
    f && ([c, u] = [u, c]);
    let h = a(c), p = a(u), g, y;
    const b = s == null ? 10 : +s;
    let w = [];
    if (!(n % 1) && p - h < b) {
      if (h = Math.floor(h), p = Math.ceil(p), c > 0) {
        for (; h <= p; ++h)
          for (g = 1; g < n; ++g)
            if (y = h < 0 ? g / i(-h) : g * i(h), !(y < c)) {
              if (y > u) break;
              w.push(y);
            }
      } else for (; h <= p; ++h)
        for (g = n - 1; g >= 1; --g)
          if (y = h > 0 ? g / i(-h) : g * i(h), !(y < c)) {
            if (y > u) break;
            w.push(y);
          }
      w.length * 2 < b && (w = Jde(c, u, b));
    } else
      w = Jde(h, p, Math.min(p - h, b)).map(i);
    return f ? w.reverse() : w;
  }, e.tickFormat = (s, l) => {
    if (s == null && (s = 10), l == null && (l = n === 10 ? "s" : ","), typeof l != "function" && (!(n % 1) && (l = OE(l)).precision == null && (l.trim = !0), l = Aye(l)), s === 1 / 0) return l;
    const c = Math.max(1, n * s / e.ticks().length);
    return (u) => {
      let f = u / i(Math.round(a(u)));
      return f * n < n - 0.5 && (f *= n), f <= c ? l(u) : "";
    };
  }, e.nice = () => r(idt(r(), {
    floor: (s) => i(Math.floor(a(s))),
    ceil: (s) => i(Math.ceil(a(s)))
  })), e;
}
function odt() {
  const t = Tye(XW()).domain([1, 10]);
  return t.copy = () => uP(t, odt()).base(t.base()), Af.apply(t, arguments), t;
}
function mOe(t) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / t));
  };
}
function gOe(t) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * t;
  };
}
function Eye(t) {
  var e = 1, r = t(mOe(e), gOe(e));
  return r.constant = function(n) {
    return arguments.length ? t(mOe(e = +n), gOe(e)) : e;
  }, Yy(r);
}
function sdt() {
  var t = Eye(XW());
  return t.copy = function() {
    return uP(t, sdt()).constant(t.constant());
  }, Af.apply(t, arguments);
}
function vOe(t) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, t) : Math.pow(e, t);
  };
}
function CPr(t) {
  return t < 0 ? -Math.sqrt(-t) : Math.sqrt(t);
}
function wPr(t) {
  return t < 0 ? -t * t : t * t;
}
function Iye(t) {
  var e = t(ku, ku), r = 1;
  function n() {
    return r === 1 ? t(ku, ku) : r === 0.5 ? t(CPr, wPr) : t(vOe(r), vOe(1 / r));
  }
  return e.exponent = function(a) {
    return arguments.length ? (r = +a, n()) : r;
  }, Yy(e);
}
function Mye() {
  var t = Iye(XW());
  return t.copy = function() {
    return uP(t, Mye()).exponent(t.exponent());
  }, Af.apply(t, arguments), t;
}
function SPr() {
  return Mye.apply(null, arguments).exponent(0.5);
}
function yOe(t) {
  return Math.sign(t) * t * t;
}
function _Pr(t) {
  return Math.sign(t) * Math.sqrt(Math.abs(t));
}
function ldt() {
  var t = _ye(), e = [0, 1], r = !1, n;
  function a(i) {
    var o = _Pr(t(i));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return a.invert = function(i) {
    return t.invert(yOe(i));
  }, a.domain = function(i) {
    return arguments.length ? (t.domain(i), a) : t.domain();
  }, a.range = function(i) {
    return arguments.length ? (t.range((e = Array.from(i, Rj)).map(yOe)), a) : e.slice();
  }, a.rangeRound = function(i) {
    return a.range(i).round(!0);
  }, a.round = function(i) {
    return arguments.length ? (r = !!i, a) : r;
  }, a.clamp = function(i) {
    return arguments.length ? (t.clamp(i), a) : t.clamp();
  }, a.unknown = function(i) {
    return arguments.length ? (n = i, a) : n;
  }, a.copy = function() {
    return ldt(t.domain(), e).round(r).clamp(t.clamp()).unknown(n);
  }, Af.apply(a, arguments), Yy(a);
}
function cdt() {
  var t = [], e = [], r = [], n;
  function a() {
    var o = 0, s = Math.max(1, e.length);
    for (r = new Array(s - 1); ++o < s; ) r[o - 1] = wMr(t, o / s);
    return i;
  }
  function i(o) {
    return o == null || isNaN(o = +o) ? n : e[lP(r, o)];
  }
  return i.invertExtent = function(o) {
    var s = e.indexOf(o);
    return s < 0 ? [NaN, NaN] : [
      s > 0 ? r[s - 1] : t[0],
      s < r.length ? r[s] : t[t.length - 1]
    ];
  }, i.domain = function(o) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let s of o) s != null && !isNaN(s = +s) && t.push(s);
    return t.sort($v), a();
  }, i.range = function(o) {
    return arguments.length ? (e = Array.from(o), a()) : e.slice();
  }, i.unknown = function(o) {
    return arguments.length ? (n = o, i) : n;
  }, i.quantiles = function() {
    return r.slice();
  }, i.copy = function() {
    return cdt().domain(t).range(e).unknown(n);
  }, Af.apply(i, arguments);
}
function udt() {
  var t = 0, e = 1, r = 1, n = [0.5], a = [0, 1], i;
  function o(l) {
    return l != null && l <= l ? a[lP(n, l, 0, r)] : i;
  }
  function s() {
    var l = -1;
    for (n = new Array(r); ++l < r; ) n[l] = ((l + 1) * e - (l - r) * t) / (r + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([t, e] = l, t = +t, e = +e, s()) : [t, e];
  }, o.range = function(l) {
    return arguments.length ? (r = (a = Array.from(l)).length - 1, s()) : a.slice();
  }, o.invertExtent = function(l) {
    var c = a.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [t, n[0]] : c >= r ? [n[r - 1], e] : [n[c - 1], n[c]];
  }, o.unknown = function(l) {
    return arguments.length && (i = l), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return udt().domain([t, e]).range(a).unknown(i);
  }, Af.apply(Yy(o), arguments);
}
function ddt() {
  var t = [0.5], e = [0, 1], r, n = 1;
  function a(i) {
    return i != null && i <= i ? e[lP(t, i, 0, n)] : r;
  }
  return a.domain = function(i) {
    return arguments.length ? (t = Array.from(i), n = Math.min(t.length, e.length - 1), a) : t.slice();
  }, a.range = function(i) {
    return arguments.length ? (e = Array.from(i), n = Math.min(t.length, e.length - 1), a) : e.slice();
  }, a.invertExtent = function(i) {
    var o = e.indexOf(i);
    return [t[o - 1], t[o]];
  }, a.unknown = function(i) {
    return arguments.length ? (r = i, a) : r;
  }, a.copy = function() {
    return ddt().domain(t).range(e).unknown(r);
  }, Af.apply(a, arguments);
}
const Wne = /* @__PURE__ */ new Date(), Hne = /* @__PURE__ */ new Date();
function ql(t, e, r, n) {
  function a(i) {
    return t(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return a.floor = (i) => (t(i = /* @__PURE__ */ new Date(+i)), i), a.ceil = (i) => (t(i = new Date(i - 1)), e(i, 1), t(i), i), a.round = (i) => {
    const o = a(i), s = a.ceil(i);
    return i - o < s - i ? o : s;
  }, a.offset = (i, o) => (e(i = /* @__PURE__ */ new Date(+i), o == null ? 1 : Math.floor(o)), i), a.range = (i, o, s) => {
    const l = [];
    if (i = a.ceil(i), s = s == null ? 1 : Math.floor(s), !(i < o) || !(s > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+i)), e(i, s), t(i);
    while (c < i && i < o);
    return l;
  }, a.filter = (i) => ql((o) => {
    if (o >= o) for (; t(o), !i(o); ) o.setTime(o - 1);
  }, (o, s) => {
    if (o >= o)
      if (s < 0) for (; ++s <= 0; )
        for (; e(o, -1), !i(o); )
          ;
      else for (; --s >= 0; )
        for (; e(o, 1), !i(o); )
          ;
  }), r && (a.count = (i, o) => (Wne.setTime(+i), Hne.setTime(+o), t(Wne), t(Hne), Math.floor(r(Wne, Hne))), a.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? a.filter(n ? (o) => n(o) % i === 0 : (o) => a.count(0, o) % i === 0) : a)), a;
}
const Nj = ql(() => {
}, (t, e) => {
  t.setTime(+t + e);
}, (t, e) => e - t);
Nj.every = (t) => (t = Math.floor(t), !isFinite(t) || !(t > 0) ? null : t > 1 ? ql((e) => {
  e.setTime(Math.floor(e / t) * t);
}, (e, r) => {
  e.setTime(+e + r * t);
}, (e, r) => (r - e) / t) : Nj);
Nj.range;
const Cm = 1e3, X0 = Cm * 60, wm = X0 * 60, Xm = wm * 24, Pye = Xm * 7, bOe = Xm * 30, Une = Xm * 365, bb = ql((t) => {
  t.setTime(t - t.getMilliseconds());
}, (t, e) => {
  t.setTime(+t + e * Cm);
}, (t, e) => (e - t) / Cm, (t) => t.getUTCSeconds());
bb.range;
const Rye = ql((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Cm);
}, (t, e) => {
  t.setTime(+t + e * X0);
}, (t, e) => (e - t) / X0, (t) => t.getMinutes());
Rye.range;
const Oye = ql((t) => {
  t.setUTCSeconds(0, 0);
}, (t, e) => {
  t.setTime(+t + e * X0);
}, (t, e) => (e - t) / X0, (t) => t.getUTCMinutes());
Oye.range;
const Bye = ql((t) => {
  t.setTime(t - t.getMilliseconds() - t.getSeconds() * Cm - t.getMinutes() * X0);
}, (t, e) => {
  t.setTime(+t + e * wm);
}, (t, e) => (e - t) / wm, (t) => t.getHours());
Bye.range;
const Nye = ql((t) => {
  t.setUTCMinutes(0, 0, 0);
}, (t, e) => {
  t.setTime(+t + e * wm);
}, (t, e) => (e - t) / wm, (t) => t.getUTCHours());
Nye.range;
const dP = ql(
  (t) => t.setHours(0, 0, 0, 0),
  (t, e) => t.setDate(t.getDate() + e),
  (t, e) => (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * X0) / Xm,
  (t) => t.getDate() - 1
);
dP.range;
const QW = ql((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / Xm, (t) => t.getUTCDate() - 1);
QW.range;
const fdt = ql((t) => {
  t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCDate(t.getUTCDate() + e);
}, (t, e) => (e - t) / Xm, (t) => Math.floor(t / Xm));
fdt.range;
function x6(t) {
  return ql((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - t) % 7), e.setHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setDate(e.getDate() + r * 7);
  }, (e, r) => (r - e - (r.getTimezoneOffset() - e.getTimezoneOffset()) * X0) / Pye);
}
const eH = x6(0), $j = x6(1), kPr = x6(2), APr = x6(3), Bx = x6(4), TPr = x6(5), EPr = x6(6);
eH.range;
$j.range;
kPr.range;
APr.range;
Bx.range;
TPr.range;
EPr.range;
function C6(t) {
  return ql((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - t) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, r) => {
    e.setUTCDate(e.getUTCDate() + r * 7);
  }, (e, r) => (r - e) / Pye);
}
const tH = C6(0), Dj = C6(1), IPr = C6(2), MPr = C6(3), Nx = C6(4), PPr = C6(5), RPr = C6(6);
tH.range;
Dj.range;
IPr.range;
MPr.range;
Nx.range;
PPr.range;
RPr.range;
const $ye = ql((t) => {
  t.setDate(1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setMonth(t.getMonth() + e);
}, (t, e) => e.getMonth() - t.getMonth() + (e.getFullYear() - t.getFullYear()) * 12, (t) => t.getMonth());
$ye.range;
const Dye = ql((t) => {
  t.setUTCDate(1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCMonth(t.getUTCMonth() + e);
}, (t, e) => e.getUTCMonth() - t.getUTCMonth() + (e.getUTCFullYear() - t.getUTCFullYear()) * 12, (t) => t.getUTCMonth());
Dye.range;
const Qm = ql((t) => {
  t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, e) => {
  t.setFullYear(t.getFullYear() + e);
}, (t, e) => e.getFullYear() - t.getFullYear(), (t) => t.getFullYear());
Qm.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : ql((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / t) * t), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, r) => {
  e.setFullYear(e.getFullYear() + r * t);
});
Qm.range;
const eg = ql((t) => {
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, e) => {
  t.setUTCFullYear(t.getUTCFullYear() + e);
}, (t, e) => e.getUTCFullYear() - t.getUTCFullYear(), (t) => t.getUTCFullYear());
eg.every = (t) => !isFinite(t = Math.floor(t)) || !(t > 0) ? null : ql((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / t) * t), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, r) => {
  e.setUTCFullYear(e.getUTCFullYear() + r * t);
});
eg.range;
function hdt(t, e, r, n, a, i) {
  const o = [
    [bb, 1, Cm],
    [bb, 5, 5 * Cm],
    [bb, 15, 15 * Cm],
    [bb, 30, 30 * Cm],
    [i, 1, X0],
    [i, 5, 5 * X0],
    [i, 15, 15 * X0],
    [i, 30, 30 * X0],
    [a, 1, wm],
    [a, 3, 3 * wm],
    [a, 6, 6 * wm],
    [a, 12, 12 * wm],
    [n, 1, Xm],
    [n, 2, 2 * Xm],
    [r, 1, Pye],
    [e, 1, bOe],
    [e, 3, 3 * bOe],
    [t, 1, Une]
  ];
  function s(c, u, f) {
    const h = u < c;
    h && ([c, u] = [u, c]);
    const p = f && typeof f.range == "function" ? f : l(c, u, f), g = p ? p.range(c, +u + 1) : [];
    return h ? g.reverse() : g;
  }
  function l(c, u, f) {
    const h = Math.abs(u - c) / f, p = bye(([, , b]) => b).right(o, h);
    if (p === o.length) return t.every(Xde(c / Une, u / Une, f));
    if (p === 0) return Nj.every(Math.max(Xde(c, u, f), 1));
    const [g, y] = o[h / o[p - 1][2] < o[p][2] / h ? p - 1 : p];
    return g.every(y);
  }
  return [s, l];
}
const [OPr, BPr] = hdt(eg, Dye, tH, fdt, Nye, Oye), [NPr, $Pr] = hdt(Qm, $ye, eH, dP, Bye, Rye);
function Vne(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(-1, t.m, t.d, t.H, t.M, t.S, t.L);
    return e.setFullYear(t.y), e;
  }
  return new Date(t.y, t.m, t.d, t.H, t.M, t.S, t.L);
}
function qne(t) {
  if (0 <= t.y && t.y < 100) {
    var e = new Date(Date.UTC(-1, t.m, t.d, t.H, t.M, t.S, t.L));
    return e.setUTCFullYear(t.y), e;
  }
  return new Date(Date.UTC(t.y, t.m, t.d, t.H, t.M, t.S, t.L));
}
function lS(t, e, r) {
  return { y: t, m: e, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function DPr(t) {
  var e = t.dateTime, r = t.date, n = t.time, a = t.periods, i = t.days, o = t.shortDays, s = t.months, l = t.shortMonths, c = cS(a), u = uS(a), f = cS(i), h = uS(i), p = cS(o), g = uS(o), y = cS(s), b = uS(s), w = cS(l), _ = uS(l), C = {
    a: G,
    A: H,
    b: j,
    B: F,
    c: null,
    d: kOe,
    e: kOe,
    f: oRr,
    g: gRr,
    G: yRr,
    H: nRr,
    I: aRr,
    j: iRr,
    L: pdt,
    m: sRr,
    M: lRr,
    p: z,
    q: W,
    Q: EOe,
    s: IOe,
    S: cRr,
    u: uRr,
    U: dRr,
    V: fRr,
    w: hRr,
    W: pRr,
    x: null,
    X: null,
    y: mRr,
    Y: vRr,
    Z: bRr,
    "%": TOe
  }, x = {
    a: U,
    A: Z,
    b: V,
    B: Y,
    c: null,
    d: AOe,
    e: AOe,
    f: SRr,
    g: ORr,
    G: NRr,
    H: xRr,
    I: CRr,
    j: wRr,
    L: gdt,
    m: _Rr,
    M: kRr,
    p: ge,
    q: ce,
    Q: EOe,
    s: IOe,
    S: ARr,
    u: TRr,
    U: ERr,
    V: IRr,
    w: MRr,
    W: PRr,
    x: null,
    X: null,
    y: RRr,
    Y: BRr,
    Z: $Rr,
    "%": TOe
  }, S = {
    a: L,
    A: N,
    b: d,
    B: m,
    c: v,
    d: SOe,
    e: SOe,
    f: QPr,
    g: wOe,
    G: COe,
    H: _Oe,
    I: _Oe,
    j: ZPr,
    L: XPr,
    m: KPr,
    M: JPr,
    p: B,
    q: qPr,
    Q: tRr,
    s: rRr,
    S: YPr,
    u: GPr,
    U: WPr,
    V: HPr,
    w: zPr,
    W: UPr,
    x: k,
    X: O,
    y: wOe,
    Y: COe,
    Z: VPr,
    "%": eRr
  };
  C.x = A(r, C), C.X = A(n, C), C.c = A(e, C), x.x = A(r, x), x.X = A(n, x), x.c = A(e, x);
  function A(ee, Se) {
    return function(Ce) {
      var we = [], We = -1, Fe = 0, it = ee.length, gt, Ze, Ne;
      for (Ce instanceof Date || (Ce = /* @__PURE__ */ new Date(+Ce)); ++We < it; )
        ee.charCodeAt(We) === 37 && (we.push(ee.slice(Fe, We)), (Ze = xOe[gt = ee.charAt(++We)]) != null ? gt = ee.charAt(++We) : Ze = gt === "e" ? " " : "0", (Ne = Se[gt]) && (gt = Ne(Ce, Ze)), we.push(gt), Fe = We + 1);
      return we.push(ee.slice(Fe, We)), we.join("");
    };
  }
  function I(ee, Se) {
    return function(Ce) {
      var we = lS(1900, void 0, 1), We = M(we, ee, Ce += "", 0), Fe, it;
      if (We != Ce.length) return null;
      if ("Q" in we) return new Date(we.Q);
      if ("s" in we) return new Date(we.s * 1e3 + ("L" in we ? we.L : 0));
      if (Se && !("Z" in we) && (we.Z = 0), "p" in we && (we.H = we.H % 12 + we.p * 12), we.m === void 0 && (we.m = "q" in we ? we.q : 0), "V" in we) {
        if (we.V < 1 || we.V > 53) return null;
        "w" in we || (we.w = 1), "Z" in we ? (Fe = qne(lS(we.y, 0, 1)), it = Fe.getUTCDay(), Fe = it > 4 || it === 0 ? Dj.ceil(Fe) : Dj(Fe), Fe = QW.offset(Fe, (we.V - 1) * 7), we.y = Fe.getUTCFullYear(), we.m = Fe.getUTCMonth(), we.d = Fe.getUTCDate() + (we.w + 6) % 7) : (Fe = Vne(lS(we.y, 0, 1)), it = Fe.getDay(), Fe = it > 4 || it === 0 ? $j.ceil(Fe) : $j(Fe), Fe = dP.offset(Fe, (we.V - 1) * 7), we.y = Fe.getFullYear(), we.m = Fe.getMonth(), we.d = Fe.getDate() + (we.w + 6) % 7);
      } else ("W" in we || "U" in we) && ("w" in we || (we.w = "u" in we ? we.u % 7 : "W" in we ? 1 : 0), it = "Z" in we ? qne(lS(we.y, 0, 1)).getUTCDay() : Vne(lS(we.y, 0, 1)).getDay(), we.m = 0, we.d = "W" in we ? (we.w + 6) % 7 + we.W * 7 - (it + 5) % 7 : we.w + we.U * 7 - (it + 6) % 7);
      return "Z" in we ? (we.H += we.Z / 100 | 0, we.M += we.Z % 100, qne(we)) : Vne(we);
    };
  }
  function M(ee, Se, Ce, we) {
    for (var We = 0, Fe = Se.length, it = Ce.length, gt, Ze; We < Fe; ) {
      if (we >= it) return -1;
      if (gt = Se.charCodeAt(We++), gt === 37) {
        if (gt = Se.charAt(We++), Ze = S[gt in xOe ? Se.charAt(We++) : gt], !Ze || (we = Ze(ee, Ce, we)) < 0) return -1;
      } else if (gt != Ce.charCodeAt(we++))
        return -1;
    }
    return we;
  }
  function B(ee, Se, Ce) {
    var we = c.exec(Se.slice(Ce));
    return we ? (ee.p = u.get(we[0].toLowerCase()), Ce + we[0].length) : -1;
  }
  function L(ee, Se, Ce) {
    var we = p.exec(Se.slice(Ce));
    return we ? (ee.w = g.get(we[0].toLowerCase()), Ce + we[0].length) : -1;
  }
  function N(ee, Se, Ce) {
    var we = f.exec(Se.slice(Ce));
    return we ? (ee.w = h.get(we[0].toLowerCase()), Ce + we[0].length) : -1;
  }
  function d(ee, Se, Ce) {
    var we = w.exec(Se.slice(Ce));
    return we ? (ee.m = _.get(we[0].toLowerCase()), Ce + we[0].length) : -1;
  }
  function m(ee, Se, Ce) {
    var we = y.exec(Se.slice(Ce));
    return we ? (ee.m = b.get(we[0].toLowerCase()), Ce + we[0].length) : -1;
  }
  function v(ee, Se, Ce) {
    return M(ee, e, Se, Ce);
  }
  function k(ee, Se, Ce) {
    return M(ee, r, Se, Ce);
  }
  function O(ee, Se, Ce) {
    return M(ee, n, Se, Ce);
  }
  function G(ee) {
    return o[ee.getDay()];
  }
  function H(ee) {
    return i[ee.getDay()];
  }
  function j(ee) {
    return l[ee.getMonth()];
  }
  function F(ee) {
    return s[ee.getMonth()];
  }
  function z(ee) {
    return a[+(ee.getHours() >= 12)];
  }
  function W(ee) {
    return 1 + ~~(ee.getMonth() / 3);
  }
  function U(ee) {
    return o[ee.getUTCDay()];
  }
  function Z(ee) {
    return i[ee.getUTCDay()];
  }
  function V(ee) {
    return l[ee.getUTCMonth()];
  }
  function Y(ee) {
    return s[ee.getUTCMonth()];
  }
  function ge(ee) {
    return a[+(ee.getUTCHours() >= 12)];
  }
  function ce(ee) {
    return 1 + ~~(ee.getUTCMonth() / 3);
  }
  return {
    format: function(ee) {
      var Se = A(ee += "", C);
      return Se.toString = function() {
        return ee;
      }, Se;
    },
    parse: function(ee) {
      var Se = I(ee += "", !1);
      return Se.toString = function() {
        return ee;
      }, Se;
    },
    utcFormat: function(ee) {
      var Se = A(ee += "", x);
      return Se.toString = function() {
        return ee;
      }, Se;
    },
    utcParse: function(ee) {
      var Se = I(ee += "", !0);
      return Se.toString = function() {
        return ee;
      }, Se;
    }
  };
}
var xOe = { "-": "", _: " ", 0: "0" }, lc = /^\s*\d+/, LPr = /^%/, jPr = /[\\^$*+?|[\]().{}]/g;
function yo(t, e, r) {
  var n = t < 0 ? "-" : "", a = (n ? -t : t) + "", i = a.length;
  return n + (i < r ? new Array(r - i + 1).join(e) + a : a);
}
function FPr(t) {
  return t.replace(jPr, "\\$&");
}
function cS(t) {
  return new RegExp("^(?:" + t.map(FPr).join("|") + ")", "i");
}
function uS(t) {
  return new Map(t.map((e, r) => [e.toLowerCase(), r]));
}
function zPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 1));
  return n ? (t.w = +n[0], r + n[0].length) : -1;
}
function GPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 1));
  return n ? (t.u = +n[0], r + n[0].length) : -1;
}
function WPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.U = +n[0], r + n[0].length) : -1;
}
function HPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.V = +n[0], r + n[0].length) : -1;
}
function UPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.W = +n[0], r + n[0].length) : -1;
}
function COe(t, e, r) {
  var n = lc.exec(e.slice(r, r + 4));
  return n ? (t.y = +n[0], r + n[0].length) : -1;
}
function wOe(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function VPr(t, e, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(r, r + 6));
  return n ? (t.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function qPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 1));
  return n ? (t.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function KPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.m = n[0] - 1, r + n[0].length) : -1;
}
function SOe(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.d = +n[0], r + n[0].length) : -1;
}
function ZPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 3));
  return n ? (t.m = 0, t.d = +n[0], r + n[0].length) : -1;
}
function _Oe(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.H = +n[0], r + n[0].length) : -1;
}
function JPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.M = +n[0], r + n[0].length) : -1;
}
function YPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 2));
  return n ? (t.S = +n[0], r + n[0].length) : -1;
}
function XPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 3));
  return n ? (t.L = +n[0], r + n[0].length) : -1;
}
function QPr(t, e, r) {
  var n = lc.exec(e.slice(r, r + 6));
  return n ? (t.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function eRr(t, e, r) {
  var n = LPr.exec(e.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function tRr(t, e, r) {
  var n = lc.exec(e.slice(r));
  return n ? (t.Q = +n[0], r + n[0].length) : -1;
}
function rRr(t, e, r) {
  var n = lc.exec(e.slice(r));
  return n ? (t.s = +n[0], r + n[0].length) : -1;
}
function kOe(t, e) {
  return yo(t.getDate(), e, 2);
}
function nRr(t, e) {
  return yo(t.getHours(), e, 2);
}
function aRr(t, e) {
  return yo(t.getHours() % 12 || 12, e, 2);
}
function iRr(t, e) {
  return yo(1 + dP.count(Qm(t), t), e, 3);
}
function pdt(t, e) {
  return yo(t.getMilliseconds(), e, 3);
}
function oRr(t, e) {
  return pdt(t, e) + "000";
}
function sRr(t, e) {
  return yo(t.getMonth() + 1, e, 2);
}
function lRr(t, e) {
  return yo(t.getMinutes(), e, 2);
}
function cRr(t, e) {
  return yo(t.getSeconds(), e, 2);
}
function uRr(t) {
  var e = t.getDay();
  return e === 0 ? 7 : e;
}
function dRr(t, e) {
  return yo(eH.count(Qm(t) - 1, t), e, 2);
}
function mdt(t) {
  var e = t.getDay();
  return e >= 4 || e === 0 ? Bx(t) : Bx.ceil(t);
}
function fRr(t, e) {
  return t = mdt(t), yo(Bx.count(Qm(t), t) + (Qm(t).getDay() === 4), e, 2);
}
function hRr(t) {
  return t.getDay();
}
function pRr(t, e) {
  return yo($j.count(Qm(t) - 1, t), e, 2);
}
function mRr(t, e) {
  return yo(t.getFullYear() % 100, e, 2);
}
function gRr(t, e) {
  return t = mdt(t), yo(t.getFullYear() % 100, e, 2);
}
function vRr(t, e) {
  return yo(t.getFullYear() % 1e4, e, 4);
}
function yRr(t, e) {
  var r = t.getDay();
  return t = r >= 4 || r === 0 ? Bx(t) : Bx.ceil(t), yo(t.getFullYear() % 1e4, e, 4);
}
function bRr(t) {
  var e = t.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + yo(e / 60 | 0, "0", 2) + yo(e % 60, "0", 2);
}
function AOe(t, e) {
  return yo(t.getUTCDate(), e, 2);
}
function xRr(t, e) {
  return yo(t.getUTCHours(), e, 2);
}
function CRr(t, e) {
  return yo(t.getUTCHours() % 12 || 12, e, 2);
}
function wRr(t, e) {
  return yo(1 + QW.count(eg(t), t), e, 3);
}
function gdt(t, e) {
  return yo(t.getUTCMilliseconds(), e, 3);
}
function SRr(t, e) {
  return gdt(t, e) + "000";
}
function _Rr(t, e) {
  return yo(t.getUTCMonth() + 1, e, 2);
}
function kRr(t, e) {
  return yo(t.getUTCMinutes(), e, 2);
}
function ARr(t, e) {
  return yo(t.getUTCSeconds(), e, 2);
}
function TRr(t) {
  var e = t.getUTCDay();
  return e === 0 ? 7 : e;
}
function ERr(t, e) {
  return yo(tH.count(eg(t) - 1, t), e, 2);
}
function vdt(t) {
  var e = t.getUTCDay();
  return e >= 4 || e === 0 ? Nx(t) : Nx.ceil(t);
}
function IRr(t, e) {
  return t = vdt(t), yo(Nx.count(eg(t), t) + (eg(t).getUTCDay() === 4), e, 2);
}
function MRr(t) {
  return t.getUTCDay();
}
function PRr(t, e) {
  return yo(Dj.count(eg(t) - 1, t), e, 2);
}
function RRr(t, e) {
  return yo(t.getUTCFullYear() % 100, e, 2);
}
function ORr(t, e) {
  return t = vdt(t), yo(t.getUTCFullYear() % 100, e, 2);
}
function BRr(t, e) {
  return yo(t.getUTCFullYear() % 1e4, e, 4);
}
function NRr(t, e) {
  var r = t.getUTCDay();
  return t = r >= 4 || r === 0 ? Nx(t) : Nx.ceil(t), yo(t.getUTCFullYear() % 1e4, e, 4);
}
function $Rr() {
  return "+0000";
}
function TOe() {
  return "%";
}
function EOe(t) {
  return +t;
}
function IOe(t) {
  return Math.floor(+t / 1e3);
}
var a9, ydt, bdt;
DRr({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function DRr(t) {
  return a9 = DPr(t), ydt = a9.format, a9.parse, bdt = a9.utcFormat, a9.utcParse, a9;
}
function LRr(t) {
  return new Date(t);
}
function jRr(t) {
  return t instanceof Date ? +t : +/* @__PURE__ */ new Date(+t);
}
function Lye(t, e, r, n, a, i, o, s, l, c) {
  var u = _ye(), f = u.invert, h = u.domain, p = c(".%L"), g = c(":%S"), y = c("%I:%M"), b = c("%I %p"), w = c("%a %d"), _ = c("%b %d"), C = c("%B"), x = c("%Y");
  function S(A) {
    return (l(A) < A ? p : s(A) < A ? g : o(A) < A ? y : i(A) < A ? b : n(A) < A ? a(A) < A ? w : _ : r(A) < A ? C : x)(A);
  }
  return u.invert = function(A) {
    return new Date(f(A));
  }, u.domain = function(A) {
    return arguments.length ? h(Array.from(A, jRr)) : h().map(LRr);
  }, u.ticks = function(A) {
    var I = h();
    return t(I[0], I[I.length - 1], A ?? 10);
  }, u.tickFormat = function(A, I) {
    return I == null ? S : c(I);
  }, u.nice = function(A) {
    var I = h();
    return (!A || typeof A.range != "function") && (A = e(I[0], I[I.length - 1], A ?? 10)), A ? h(idt(I, A)) : u;
  }, u.copy = function() {
    return uP(u, Lye(t, e, r, n, a, i, o, s, l, c));
  }, u;
}
function FRr() {
  return Af.apply(Lye(NPr, $Pr, Qm, $ye, eH, dP, Bye, Rye, bb, ydt).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function zRr() {
  return Af.apply(Lye(OPr, BPr, eg, Dye, tH, QW, Nye, Oye, bb, bdt).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function rH() {
  var t = 0, e = 1, r, n, a, i, o = ku, s = !1, l;
  function c(f) {
    return f == null || isNaN(f = +f) ? l : o(a === 0 ? 0.5 : (f = (i(f) - r) * a, s ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([t, e] = f, r = i(t = +t), n = i(e = +e), a = r === n ? 0 : 1 / (n - r), c) : [t, e];
  }, c.clamp = function(f) {
    return arguments.length ? (s = !!f, c) : s;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function u(f) {
    return function(h) {
      var p, g;
      return arguments.length ? ([p, g] = h, o = f(p, g), c) : [o(0), o(1)];
    };
  }
  return c.range = u(oC), c.rangeRound = u(Sye), c.unknown = function(f) {
    return arguments.length ? (l = f, c) : l;
  }, function(f) {
    return i = f, r = f(t), n = f(e), a = r === n ? 0 : 1 / (n - r), c;
  };
}
function Xy(t, e) {
  return e.domain(t.domain()).interpolator(t.interpolator()).clamp(t.clamp()).unknown(t.unknown());
}
function xdt() {
  var t = Yy(rH()(ku));
  return t.copy = function() {
    return Xy(t, xdt());
  }, xg.apply(t, arguments);
}
function Cdt() {
  var t = Tye(rH()).domain([1, 10]);
  return t.copy = function() {
    return Xy(t, Cdt()).base(t.base());
  }, xg.apply(t, arguments);
}
function wdt() {
  var t = Eye(rH());
  return t.copy = function() {
    return Xy(t, wdt()).constant(t.constant());
  }, xg.apply(t, arguments);
}
function jye() {
  var t = Iye(rH());
  return t.copy = function() {
    return Xy(t, jye()).exponent(t.exponent());
  }, xg.apply(t, arguments);
}
function GRr() {
  return jye.apply(null, arguments).exponent(0.5);
}
function Sdt() {
  var t = [], e = ku;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return e((lP(t, n, 1) - 1) / (t.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return t.slice();
    t = [];
    for (let a of n) a != null && !isNaN(a = +a) && t.push(a);
    return t.sort($v), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (e = n, r) : e;
  }, r.range = function() {
    return t.map((n, a) => e(a / (t.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (a, i) => CMr(t, i / n));
  }, r.copy = function() {
    return Sdt(e).domain(t);
  }, xg.apply(r, arguments);
}
function nH() {
  var t = 0, e = 0.5, r = 1, n = 1, a, i, o, s, l, c = ku, u, f = !1, h;
  function p(y) {
    return isNaN(y = +y) ? h : (y = 0.5 + ((y = +u(y)) - i) * (n * y < n * i ? s : l), c(f ? Math.max(0, Math.min(1, y)) : y));
  }
  p.domain = function(y) {
    return arguments.length ? ([t, e, r] = y, a = u(t = +t), i = u(e = +e), o = u(r = +r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p) : [t, e, r];
  }, p.clamp = function(y) {
    return arguments.length ? (f = !!y, p) : f;
  }, p.interpolator = function(y) {
    return arguments.length ? (c = y, p) : c;
  };
  function g(y) {
    return function(b) {
      var w, _, C;
      return arguments.length ? ([w, _, C] = b, c = ePr(y, [w, _, C]), p) : [c(0), c(0.5), c(1)];
    };
  }
  return p.range = g(oC), p.rangeRound = g(Sye), p.unknown = function(y) {
    return arguments.length ? (h = y, p) : h;
  }, function(y) {
    return u = y, a = y(t), i = y(e), o = y(r), s = a === i ? 0 : 0.5 / (i - a), l = i === o ? 0 : 0.5 / (o - i), n = i < a ? -1 : 1, p;
  };
}
function _dt() {
  var t = Yy(nH()(ku));
  return t.copy = function() {
    return Xy(t, _dt());
  }, xg.apply(t, arguments);
}
function kdt() {
  var t = Tye(nH()).domain([0.1, 1, 10]);
  return t.copy = function() {
    return Xy(t, kdt()).base(t.base());
  }, xg.apply(t, arguments);
}
function Adt() {
  var t = Eye(nH());
  return t.copy = function() {
    return Xy(t, Adt()).constant(t.constant());
  }, xg.apply(t, arguments);
}
function Fye() {
  var t = Iye(nH());
  return t.copy = function() {
    return Xy(t, Fye()).exponent(t.exponent());
  }, xg.apply(t, arguments);
}
function WRr() {
  return Fye.apply(null, arguments).exponent(0.5);
}
const MOe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: ME,
  scaleDiverging: _dt,
  scaleDivergingLog: kdt,
  scaleDivergingPow: Fye,
  scaleDivergingSqrt: WRr,
  scaleDivergingSymlog: Adt,
  scaleIdentity: adt,
  scaleImplicit: Qde,
  scaleLinear: Bj,
  scaleLog: odt,
  scaleOrdinal: xye,
  scalePoint: W_,
  scalePow: Mye,
  scaleQuantile: cdt,
  scaleQuantize: udt,
  scaleRadial: ldt,
  scaleSequential: xdt,
  scaleSequentialLog: Cdt,
  scaleSequentialPow: jye,
  scaleSequentialQuantile: Sdt,
  scaleSequentialSqrt: GRr,
  scaleSequentialSymlog: wdt,
  scaleSqrt: SPr,
  scaleSymlog: sdt,
  scaleThreshold: ddt,
  scaleTime: FRr,
  scaleUtc: zRr,
  tickFormat: ndt
}, Symbol.toStringTag, { value: "Module" }));
var Kne, POe;
function aH() {
  if (POe) return Kne;
  POe = 1;
  var t = rC();
  function e(r, n, a) {
    for (var i = -1, o = r.length; ++i < o; ) {
      var s = r[i], l = n(s);
      if (l != null && (c === void 0 ? l === l && !t(l) : a(l, c)))
        var c = l, u = s;
    }
    return u;
  }
  return Kne = e, Kne;
}
var Zne, ROe;
function Tdt() {
  if (ROe) return Zne;
  ROe = 1;
  function t(e, r) {
    return e > r;
  }
  return Zne = t, Zne;
}
var Jne, OOe;
function HRr() {
  if (OOe) return Jne;
  OOe = 1;
  var t = aH(), e = Tdt(), r = iC();
  function n(a) {
    return a && a.length ? t(a, r, e) : void 0;
  }
  return Jne = n, Jne;
}
var URr = HRr();
const kv = /* @__PURE__ */ Gi(URr);
var Yne, BOe;
function Edt() {
  if (BOe) return Yne;
  BOe = 1;
  function t(e, r) {
    return e < r;
  }
  return Yne = t, Yne;
}
var Xne, NOe;
function VRr() {
  if (NOe) return Xne;
  NOe = 1;
  var t = aH(), e = Edt(), r = iC();
  function n(a) {
    return a && a.length ? t(a, r, e) : void 0;
  }
  return Xne = n, Xne;
}
var qRr = VRr();
const iH = /* @__PURE__ */ Gi(qRr);
var Qne, $Oe;
function KRr() {
  if ($Oe) return Qne;
  $Oe = 1;
  var t = eye(), e = sp(), r = Out(), n = Od();
  function a(i, o) {
    var s = n(i) ? t : r;
    return s(i, e(o, 3));
  }
  return Qne = a, Qne;
}
var eae, DOe;
function ZRr() {
  if (DOe) return eae;
  DOe = 1;
  var t = Put(), e = KRr();
  function r(n, a) {
    return t(e(n, a), 1);
  }
  return eae = r, eae;
}
var JRr = ZRr();
const YRr = /* @__PURE__ */ Gi(JRr);
var tae, LOe;
function XRr() {
  if (LOe) return tae;
  LOe = 1;
  var t = pye();
  function e(r, n) {
    return t(r, n);
  }
  return tae = e, tae;
}
var QRr = XRr();
const O5 = /* @__PURE__ */ Gi(QRr);
var sC = 1e9, eOr = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Gye, ks = !0, mf = "[DecimalError] ", Gb = mf + "Invalid argument: ", zye = mf + "Exponent out of range: ", lC = Math.floor, eb = Math.pow, tOr = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, r0, tc = 1e7, xs = 7, Idt = 9007199254740991, Lj = lC(Idt / xs), En = {};
En.absoluteValue = En.abs = function() {
  var t = new this.constructor(this);
  return t.s && (t.s = 1), t;
};
En.comparedTo = En.cmp = function(t) {
  var e, r, n, a, i = this;
  if (t = new i.constructor(t), i.s !== t.s) return i.s || -t.s;
  if (i.e !== t.e) return i.e > t.e ^ i.s < 0 ? 1 : -1;
  for (n = i.d.length, a = t.d.length, e = 0, r = n < a ? n : a; e < r; ++e)
    if (i.d[e] !== t.d[e]) return i.d[e] > t.d[e] ^ i.s < 0 ? 1 : -1;
  return n === a ? 0 : n > a ^ i.s < 0 ? 1 : -1;
};
En.decimalPlaces = En.dp = function() {
  var t = this, e = t.d.length - 1, r = (e - t.e) * xs;
  if (e = t.d[e], e) for (; e % 10 == 0; e /= 10) r--;
  return r < 0 ? 0 : r;
};
En.dividedBy = En.div = function(t) {
  return Pm(this, new this.constructor(t));
};
En.dividedToIntegerBy = En.idiv = function(t) {
  var e = this, r = e.constructor;
  return Ko(Pm(e, new r(t), 0, 1), r.precision);
};
En.equals = En.eq = function(t) {
  return !this.cmp(t);
};
En.exponent = function() {
  return _l(this);
};
En.greaterThan = En.gt = function(t) {
  return this.cmp(t) > 0;
};
En.greaterThanOrEqualTo = En.gte = function(t) {
  return this.cmp(t) >= 0;
};
En.isInteger = En.isint = function() {
  return this.e > this.d.length - 2;
};
En.isNegative = En.isneg = function() {
  return this.s < 0;
};
En.isPositive = En.ispos = function() {
  return this.s > 0;
};
En.isZero = function() {
  return this.s === 0;
};
En.lessThan = En.lt = function(t) {
  return this.cmp(t) < 0;
};
En.lessThanOrEqualTo = En.lte = function(t) {
  return this.cmp(t) < 1;
};
En.logarithm = En.log = function(t) {
  var e, r = this, n = r.constructor, a = n.precision, i = a + 5;
  if (t === void 0)
    t = new n(10);
  else if (t = new n(t), t.s < 1 || t.eq(r0)) throw Error(mf + "NaN");
  if (r.s < 1) throw Error(mf + (r.s ? "NaN" : "-Infinity"));
  return r.eq(r0) ? new n(0) : (ks = !1, e = Pm(BE(r, i), BE(t, i), i), ks = !0, Ko(e, a));
};
En.minus = En.sub = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? Rdt(e, t) : Mdt(e, (t.s = -t.s, t));
};
En.modulo = En.mod = function(t) {
  var e, r = this, n = r.constructor, a = n.precision;
  if (t = new n(t), !t.s) throw Error(mf + "NaN");
  return r.s ? (ks = !1, e = Pm(r, t, 0, 1).times(t), ks = !0, r.minus(e)) : Ko(new n(r), a);
};
En.naturalExponential = En.exp = function() {
  return Pdt(this);
};
En.naturalLogarithm = En.ln = function() {
  return BE(this);
};
En.negated = En.neg = function() {
  var t = new this.constructor(this);
  return t.s = -t.s || 0, t;
};
En.plus = En.add = function(t) {
  var e = this;
  return t = new e.constructor(t), e.s == t.s ? Mdt(e, t) : Rdt(e, (t.s = -t.s, t));
};
En.precision = En.sd = function(t) {
  var e, r, n, a = this;
  if (t !== void 0 && t !== !!t && t !== 1 && t !== 0) throw Error(Gb + t);
  if (e = _l(a) + 1, n = a.d.length - 1, r = n * xs + 1, n = a.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = a.d[0]; n >= 10; n /= 10) r++;
  }
  return t && e > r ? e : r;
};
En.squareRoot = En.sqrt = function() {
  var t, e, r, n, a, i, o, s = this, l = s.constructor;
  if (s.s < 1) {
    if (!s.s) return new l(0);
    throw Error(mf + "NaN");
  }
  for (t = _l(s), ks = !1, a = Math.sqrt(+s), a == 0 || a == 1 / 0 ? (e = ah(s.d), (e.length + t) % 2 == 0 && (e += "0"), a = Math.sqrt(e), t = lC((t + 1) / 2) - (t < 0 || t % 2), a == 1 / 0 ? e = "5e" + t : (e = a.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + t), n = new l(e)) : n = new l(a.toString()), r = l.precision, a = o = r + 3; ; )
    if (i = n, n = i.plus(Pm(s, i, o + 2)).times(0.5), ah(i.d).slice(0, o) === (e = ah(n.d)).slice(0, o)) {
      if (e = e.slice(o - 3, o + 1), a == o && e == "4999") {
        if (Ko(i, r + 1, 0), i.times(i).eq(s)) {
          n = i;
          break;
        }
      } else if (e != "9999")
        break;
      o += 4;
    }
  return ks = !0, Ko(n, r);
};
En.times = En.mul = function(t) {
  var e, r, n, a, i, o, s, l, c, u = this, f = u.constructor, h = u.d, p = (t = new f(t)).d;
  if (!u.s || !t.s) return new f(0);
  for (t.s *= u.s, r = u.e + t.e, l = h.length, c = p.length, l < c && (i = h, h = p, p = i, o = l, l = c, c = o), i = [], o = l + c, n = o; n--; ) i.push(0);
  for (n = c; --n >= 0; ) {
    for (e = 0, a = l + n; a > n; )
      s = i[a] + p[n] * h[a - n - 1] + e, i[a--] = s % tc | 0, e = s / tc | 0;
    i[a] = (i[a] + e) % tc | 0;
  }
  for (; !i[--o]; ) i.pop();
  return e ? ++r : i.shift(), t.d = i, t.e = r, ks ? Ko(t, f.precision) : t;
};
En.toDecimalPlaces = En.todp = function(t, e) {
  var r = this, n = r.constructor;
  return r = new n(r), t === void 0 ? r : (Hh(t, 0, sC), e === void 0 ? e = n.rounding : Hh(e, 0, 8), Ko(r, t + _l(r) + 1, e));
};
En.toExponential = function(t, e) {
  var r, n = this, a = n.constructor;
  return t === void 0 ? r = B5(n, !0) : (Hh(t, 0, sC), e === void 0 ? e = a.rounding : Hh(e, 0, 8), n = Ko(new a(n), t + 1, e), r = B5(n, !0, t + 1)), r;
};
En.toFixed = function(t, e) {
  var r, n, a = this, i = a.constructor;
  return t === void 0 ? B5(a) : (Hh(t, 0, sC), e === void 0 ? e = i.rounding : Hh(e, 0, 8), n = Ko(new i(a), t + _l(a) + 1, e), r = B5(n.abs(), !1, t + _l(n) + 1), a.isneg() && !a.isZero() ? "-" + r : r);
};
En.toInteger = En.toint = function() {
  var t = this, e = t.constructor;
  return Ko(new e(t), _l(t) + 1, e.rounding);
};
En.toNumber = function() {
  return +this;
};
En.toPower = En.pow = function(t) {
  var e, r, n, a, i, o, s = this, l = s.constructor, c = 12, u = +(t = new l(t));
  if (!t.s) return new l(r0);
  if (s = new l(s), !s.s) {
    if (t.s < 1) throw Error(mf + "Infinity");
    return s;
  }
  if (s.eq(r0)) return s;
  if (n = l.precision, t.eq(r0)) return Ko(s, n);
  if (e = t.e, r = t.d.length - 1, o = e >= r, i = s.s, o) {
    if ((r = u < 0 ? -u : u) <= Idt) {
      for (a = new l(r0), e = Math.ceil(n / xs + 4), ks = !1; r % 2 && (a = a.times(s), FOe(a.d, e)), r = lC(r / 2), r !== 0; )
        s = s.times(s), FOe(s.d, e);
      return ks = !0, t.s < 0 ? new l(r0).div(a) : Ko(a, n);
    }
  } else if (i < 0) throw Error(mf + "NaN");
  return i = i < 0 && t.d[Math.max(e, r)] & 1 ? -1 : 1, s.s = 1, ks = !1, a = t.times(BE(s, n + c)), ks = !0, a = Pdt(a), a.s = i, a;
};
En.toPrecision = function(t, e) {
  var r, n, a = this, i = a.constructor;
  return t === void 0 ? (r = _l(a), n = B5(a, r <= i.toExpNeg || r >= i.toExpPos)) : (Hh(t, 1, sC), e === void 0 ? e = i.rounding : Hh(e, 0, 8), a = Ko(new i(a), t, e), r = _l(a), n = B5(a, t <= r || r <= i.toExpNeg, t)), n;
};
En.toSignificantDigits = En.tosd = function(t, e) {
  var r = this, n = r.constructor;
  return t === void 0 ? (t = n.precision, e = n.rounding) : (Hh(t, 1, sC), e === void 0 ? e = n.rounding : Hh(e, 0, 8)), Ko(new n(r), t, e);
};
En.toString = En.valueOf = En.val = En.toJSON = En[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var t = this, e = _l(t), r = t.constructor;
  return B5(t, e <= r.toExpNeg || e >= r.toExpPos);
};
function Mdt(t, e) {
  var r, n, a, i, o, s, l, c, u = t.constructor, f = u.precision;
  if (!t.s || !e.s)
    return e.s || (e = new u(t)), ks ? Ko(e, f) : e;
  if (l = t.d, c = e.d, o = t.e, a = e.e, l = l.slice(), i = o - a, i) {
    for (i < 0 ? (n = l, i = -i, s = c.length) : (n = c, a = o, s = l.length), o = Math.ceil(f / xs), s = o > s ? o + 1 : s + 1, i > s && (i = s, n.length = 1), n.reverse(); i--; ) n.push(0);
    n.reverse();
  }
  for (s = l.length, i = c.length, s - i < 0 && (i = s, n = c, c = l, l = n), r = 0; i; )
    r = (l[--i] = l[i] + c[i] + r) / tc | 0, l[i] %= tc;
  for (r && (l.unshift(r), ++a), s = l.length; l[--s] == 0; ) l.pop();
  return e.d = l, e.e = a, ks ? Ko(e, f) : e;
}
function Hh(t, e, r) {
  if (t !== ~~t || t < e || t > r)
    throw Error(Gb + t);
}
function ah(t) {
  var e, r, n, a = t.length - 1, i = "", o = t[0];
  if (a > 0) {
    for (i += o, e = 1; e < a; e++)
      n = t[e] + "", r = xs - n.length, r && (i += hv(r)), i += n;
    o = t[e], n = o + "", r = xs - n.length, r && (i += hv(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return i + o;
}
var Pm = /* @__PURE__ */ function() {
  function t(n, a) {
    var i, o = 0, s = n.length;
    for (n = n.slice(); s--; )
      i = n[s] * a + o, n[s] = i % tc | 0, o = i / tc | 0;
    return o && n.unshift(o), n;
  }
  function e(n, a, i, o) {
    var s, l;
    if (i != o)
      l = i > o ? 1 : -1;
    else
      for (s = l = 0; s < i; s++)
        if (n[s] != a[s]) {
          l = n[s] > a[s] ? 1 : -1;
          break;
        }
    return l;
  }
  function r(n, a, i) {
    for (var o = 0; i--; )
      n[i] -= o, o = n[i] < a[i] ? 1 : 0, n[i] = o * tc + n[i] - a[i];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, a, i, o) {
    var s, l, c, u, f, h, p, g, y, b, w, _, C, x, S, A, I, M, B = n.constructor, L = n.s == a.s ? 1 : -1, N = n.d, d = a.d;
    if (!n.s) return new B(n);
    if (!a.s) throw Error(mf + "Division by zero");
    for (l = n.e - a.e, I = d.length, S = N.length, p = new B(L), g = p.d = [], c = 0; d[c] == (N[c] || 0); ) ++c;
    if (d[c] > (N[c] || 0) && --l, i == null ? _ = i = B.precision : o ? _ = i + (_l(n) - _l(a)) + 1 : _ = i, _ < 0) return new B(0);
    if (_ = _ / xs + 2 | 0, c = 0, I == 1)
      for (u = 0, d = d[0], _++; (c < S || u) && _--; c++)
        C = u * tc + (N[c] || 0), g[c] = C / d | 0, u = C % d | 0;
    else {
      for (u = tc / (d[0] + 1) | 0, u > 1 && (d = t(d, u), N = t(N, u), I = d.length, S = N.length), x = I, y = N.slice(0, I), b = y.length; b < I; ) y[b++] = 0;
      M = d.slice(), M.unshift(0), A = d[0], d[1] >= tc / 2 && ++A;
      do
        u = 0, s = e(d, y, I, b), s < 0 ? (w = y[0], I != b && (w = w * tc + (y[1] || 0)), u = w / A | 0, u > 1 ? (u >= tc && (u = tc - 1), f = t(d, u), h = f.length, b = y.length, s = e(f, y, h, b), s == 1 && (u--, r(f, I < h ? M : d, h))) : (u == 0 && (s = u = 1), f = d.slice()), h = f.length, h < b && f.unshift(0), r(y, f, b), s == -1 && (b = y.length, s = e(d, y, I, b), s < 1 && (u++, r(y, I < b ? M : d, b))), b = y.length) : s === 0 && (u++, y = [0]), g[c++] = u, s && y[0] ? y[b++] = N[x] || 0 : (y = [N[x]], b = 1);
      while ((x++ < S || y[0] !== void 0) && _--);
    }
    return g[0] || g.shift(), p.e = l, Ko(p, o ? i + _l(p) + 1 : i);
  };
}();
function Pdt(t, e) {
  var r, n, a, i, o, s, l = 0, c = 0, u = t.constructor, f = u.precision;
  if (_l(t) > 16) throw Error(zye + _l(t));
  if (!t.s) return new u(r0);
  for (ks = !1, s = f, o = new u(0.03125); t.abs().gte(0.1); )
    t = t.times(o), c += 5;
  for (n = Math.log(eb(2, c)) / Math.LN10 * 2 + 5 | 0, s += n, r = a = i = new u(r0), u.precision = s; ; ) {
    if (a = Ko(a.times(t), s), r = r.times(++l), o = i.plus(Pm(a, r, s)), ah(o.d).slice(0, s) === ah(i.d).slice(0, s)) {
      for (; c--; ) i = Ko(i.times(i), s);
      return u.precision = f, e == null ? (ks = !0, Ko(i, f)) : i;
    }
    i = o;
  }
}
function _l(t) {
  for (var e = t.e * xs, r = t.d[0]; r >= 10; r /= 10) e++;
  return e;
}
function rae(t, e, r) {
  if (e > t.LN10.sd())
    throw ks = !0, r && (t.precision = r), Error(mf + "LN10 precision limit exceeded");
  return Ko(new t(t.LN10), e);
}
function hv(t) {
  for (var e = ""; t--; ) e += "0";
  return e;
}
function BE(t, e) {
  var r, n, a, i, o, s, l, c, u, f = 1, h = 10, p = t, g = p.d, y = p.constructor, b = y.precision;
  if (p.s < 1) throw Error(mf + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(r0)) return new y(0);
  if (e == null ? (ks = !1, c = b) : c = e, p.eq(10))
    return e == null && (ks = !0), rae(y, c);
  if (c += h, y.precision = c, r = ah(g), n = r.charAt(0), i = _l(p), Math.abs(i) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(t), r = ah(p.d), n = r.charAt(0), f++;
    i = _l(p), n > 1 ? (p = new y("0." + r), i++) : p = new y(n + "." + r.slice(1));
  } else
    return l = rae(y, c + 2, b).times(i + ""), p = BE(new y(n + "." + r.slice(1)), c - h).plus(l), y.precision = b, e == null ? (ks = !0, Ko(p, b)) : p;
  for (s = o = p = Pm(p.minus(r0), p.plus(r0), c), u = Ko(p.times(p), c), a = 3; ; ) {
    if (o = Ko(o.times(u), c), l = s.plus(Pm(o, new y(a), c)), ah(l.d).slice(0, c) === ah(s.d).slice(0, c))
      return s = s.times(2), i !== 0 && (s = s.plus(rae(y, c + 2, b).times(i + ""))), s = Pm(s, new y(f), c), y.precision = b, e == null ? (ks = !0, Ko(s, b)) : s;
    s = l, a += 2;
  }
}
function jOe(t, e) {
  var r, n, a;
  for ((r = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (n = e.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +e.slice(n + 1), e = e.substring(0, n)) : r < 0 && (r = e.length), n = 0; e.charCodeAt(n) === 48; ) ++n;
  for (a = e.length; e.charCodeAt(a - 1) === 48; ) --a;
  if (e = e.slice(n, a), e) {
    if (a -= n, r = r - n - 1, t.e = lC(r / xs), t.d = [], n = (r + 1) % xs, r < 0 && (n += xs), n < a) {
      for (n && t.d.push(+e.slice(0, n)), a -= xs; n < a; ) t.d.push(+e.slice(n, n += xs));
      e = e.slice(n), n = xs - e.length;
    } else
      n -= a;
    for (; n--; ) e += "0";
    if (t.d.push(+e), ks && (t.e > Lj || t.e < -Lj)) throw Error(zye + r);
  } else
    t.s = 0, t.e = 0, t.d = [0];
  return t;
}
function Ko(t, e, r) {
  var n, a, i, o, s, l, c, u, f = t.d;
  for (o = 1, i = f[0]; i >= 10; i /= 10) o++;
  if (n = e - o, n < 0)
    n += xs, a = e, c = f[u = 0];
  else {
    if (u = Math.ceil((n + 1) / xs), i = f.length, u >= i) return t;
    for (c = i = f[u], o = 1; i >= 10; i /= 10) o++;
    n %= xs, a = n - xs + o;
  }
  if (r !== void 0 && (i = eb(10, o - a - 1), s = c / i % 10 | 0, l = e < 0 || f[u + 1] !== void 0 || c % i, l = r < 4 ? (s || l) && (r == 0 || r == (t.s < 0 ? 3 : 2)) : s > 5 || s == 5 && (r == 4 || l || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? a > 0 ? c / eb(10, o - a) : 0 : f[u - 1]) % 10 & 1 || r == (t.s < 0 ? 8 : 7))), e < 1 || !f[0])
    return l ? (i = _l(t), f.length = 1, e = e - i - 1, f[0] = eb(10, (xs - e % xs) % xs), t.e = lC(-e / xs) || 0) : (f.length = 1, f[0] = t.e = t.s = 0), t;
  if (n == 0 ? (f.length = u, i = 1, u--) : (f.length = u + 1, i = eb(10, xs - n), f[u] = a > 0 ? (c / eb(10, o - a) % eb(10, a) | 0) * i : 0), l)
    for (; ; )
      if (u == 0) {
        (f[0] += i) == tc && (f[0] = 1, ++t.e);
        break;
      } else {
        if (f[u] += i, f[u] != tc) break;
        f[u--] = 0, i = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (ks && (t.e > Lj || t.e < -Lj))
    throw Error(zye + _l(t));
  return t;
}
function Rdt(t, e) {
  var r, n, a, i, o, s, l, c, u, f, h = t.constructor, p = h.precision;
  if (!t.s || !e.s)
    return e.s ? e.s = -e.s : e = new h(t), ks ? Ko(e, p) : e;
  if (l = t.d, f = e.d, n = e.e, c = t.e, l = l.slice(), o = c - n, o) {
    for (u = o < 0, u ? (r = l, o = -o, s = f.length) : (r = f, n = c, s = l.length), a = Math.max(Math.ceil(p / xs), s) + 2, o > a && (o = a, r.length = 1), r.reverse(), a = o; a--; ) r.push(0);
    r.reverse();
  } else {
    for (a = l.length, s = f.length, u = a < s, u && (s = a), a = 0; a < s; a++)
      if (l[a] != f[a]) {
        u = l[a] < f[a];
        break;
      }
    o = 0;
  }
  for (u && (r = l, l = f, f = r, e.s = -e.s), s = l.length, a = f.length - s; a > 0; --a) l[s++] = 0;
  for (a = f.length; a > o; ) {
    if (l[--a] < f[a]) {
      for (i = a; i && l[--i] === 0; ) l[i] = tc - 1;
      --l[i], l[a] += tc;
    }
    l[a] -= f[a];
  }
  for (; l[--s] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --n;
  return l[0] ? (e.d = l, e.e = n, ks ? Ko(e, p) : e) : new h(0);
}
function B5(t, e, r) {
  var n, a = _l(t), i = ah(t.d), o = i.length;
  return e ? (r && (n = r - o) > 0 ? i = i.charAt(0) + "." + i.slice(1) + hv(n) : o > 1 && (i = i.charAt(0) + "." + i.slice(1)), i = i + (a < 0 ? "e" : "e+") + a) : a < 0 ? (i = "0." + hv(-a - 1) + i, r && (n = r - o) > 0 && (i += hv(n))) : a >= o ? (i += hv(a + 1 - o), r && (n = r - a - 1) > 0 && (i = i + "." + hv(n))) : ((n = a + 1) < o && (i = i.slice(0, n) + "." + i.slice(n)), r && (n = r - o) > 0 && (a + 1 === o && (i += "."), i += hv(n))), t.s < 0 ? "-" + i : i;
}
function FOe(t, e) {
  if (t.length > e)
    return t.length = e, !0;
}
function Odt(t) {
  var e, r, n;
  function a(i) {
    var o = this;
    if (!(o instanceof a)) return new a(i);
    if (o.constructor = a, i instanceof a) {
      o.s = i.s, o.e = i.e, o.d = (i = i.d) ? i.slice() : i;
      return;
    }
    if (typeof i == "number") {
      if (i * 0 !== 0)
        throw Error(Gb + i);
      if (i > 0)
        o.s = 1;
      else if (i < 0)
        i = -i, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (i === ~~i && i < 1e7) {
        o.e = 0, o.d = [i];
        return;
      }
      return jOe(o, i.toString());
    } else if (typeof i != "string")
      throw Error(Gb + i);
    if (i.charCodeAt(0) === 45 ? (i = i.slice(1), o.s = -1) : o.s = 1, tOr.test(i)) jOe(o, i);
    else throw Error(Gb + i);
  }
  if (a.prototype = En, a.ROUND_UP = 0, a.ROUND_DOWN = 1, a.ROUND_CEIL = 2, a.ROUND_FLOOR = 3, a.ROUND_HALF_UP = 4, a.ROUND_HALF_DOWN = 5, a.ROUND_HALF_EVEN = 6, a.ROUND_HALF_CEIL = 7, a.ROUND_HALF_FLOOR = 8, a.clone = Odt, a.config = a.set = rOr, t === void 0 && (t = {}), t)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], e = 0; e < n.length; ) t.hasOwnProperty(r = n[e++]) || (t[r] = this[r]);
  return a.config(t), a;
}
function rOr(t) {
  if (!t || typeof t != "object")
    throw Error(mf + "Object expected");
  var e, r, n, a = [
    "precision",
    1,
    sC,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (e = 0; e < a.length; e += 3)
    if ((n = t[r = a[e]]) !== void 0)
      if (lC(n) === n && n >= a[e + 1] && n <= a[e + 2]) this[r] = n;
      else throw Error(Gb + r + ": " + n);
  if ((n = t[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Gb + r + ": " + n);
  return this;
}
var Gye = Odt(eOr);
r0 = new Gye(1);
const zo = Gye;
function nOr(t) {
  return sOr(t) || oOr(t) || iOr(t) || aOr();
}
function aOr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iOr(t, e) {
  if (t) {
    if (typeof t == "string") return a0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return a0e(t, e);
  }
}
function oOr(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
}
function sOr(t) {
  if (Array.isArray(t)) return a0e(t);
}
function a0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var lOr = function(e) {
  return e;
}, Bdt = {}, Ndt = function(e) {
  return e === Bdt;
}, zOe = function(e) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && Ndt(arguments.length <= 0 ? void 0 : arguments[0]) ? r : e.apply(void 0, arguments);
  };
}, cOr = function t(e, r) {
  return e === 1 ? r : zOe(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    var o = a.filter(function(s) {
      return s !== Bdt;
    }).length;
    return o >= e ? r.apply(void 0, a) : t(e - o, zOe(function() {
      for (var s = arguments.length, l = new Array(s), c = 0; c < s; c++)
        l[c] = arguments[c];
      var u = a.map(function(f) {
        return Ndt(f) ? l.shift() : f;
      });
      return r.apply(void 0, nOr(u).concat(l));
    }));
  });
}, oH = function(e) {
  return cOr(e.length, e);
}, i0e = function(e, r) {
  for (var n = [], a = e; a < r; ++a)
    n[a - e] = a;
  return n;
}, uOr = oH(function(t, e) {
  return Array.isArray(e) ? e.map(t) : Object.keys(e).map(function(r) {
    return e[r];
  }).map(t);
}), dOr = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  if (!r.length)
    return lOr;
  var a = r.reverse(), i = a[0], o = a.slice(1);
  return function() {
    return o.reduce(function(s, l) {
      return l(s);
    }, i.apply(void 0, arguments));
  };
}, o0e = function(e) {
  return Array.isArray(e) ? e.reverse() : e.split("").reverse.join("");
}, $dt = function(e) {
  var r = null, n = null;
  return function() {
    for (var a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r && i.every(function(s, l) {
      return s === r[l];
    }) || (r = i, n = e.apply(void 0, i)), n;
  };
};
function fOr(t) {
  var e;
  return t === 0 ? e = 1 : e = Math.floor(new zo(t).abs().log(10).toNumber()) + 1, e;
}
function hOr(t, e, r) {
  for (var n = new zo(t), a = 0, i = []; n.lt(e) && a < 1e5; )
    i.push(n.toNumber()), n = n.add(r), a++;
  return i;
}
var pOr = oH(function(t, e, r) {
  var n = +t, a = +e;
  return n + r * (a - n);
}), mOr = oH(function(t, e, r) {
  var n = e - +t;
  return n = n || 1 / 0, (r - t) / n;
}), gOr = oH(function(t, e, r) {
  var n = e - +t;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - t) / n));
});
const sH = {
  rangeStep: hOr,
  getDigitCount: fOr,
  interpolateNumber: pOr,
  uninterpolateNumber: mOr,
  uninterpolateTruncation: gOr
};
function s0e(t) {
  return bOr(t) || yOr(t) || Ddt(t) || vOr();
}
function vOr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yOr(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
}
function bOr(t) {
  if (Array.isArray(t)) return l0e(t);
}
function NE(t, e) {
  return wOr(t) || COr(t, e) || Ddt(t, e) || xOr();
}
function xOr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ddt(t, e) {
  if (t) {
    if (typeof t == "string") return l0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return l0e(t, e);
  }
}
function l0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function COr(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = t[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(e && r.length === e)); n = !0)
        ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a) throw i;
      }
    }
    return r;
  }
}
function wOr(t) {
  if (Array.isArray(t)) return t;
}
function Ldt(t) {
  var e = NE(t, 2), r = e[0], n = e[1], a = r, i = n;
  return r > n && (a = n, i = r), [a, i];
}
function jdt(t, e, r) {
  if (t.lte(0))
    return new zo(0);
  var n = sH.getDigitCount(t.toNumber()), a = new zo(10).pow(n), i = t.div(a), o = n !== 1 ? 0.05 : 0.1, s = new zo(Math.ceil(i.div(o).toNumber())).add(r).mul(o), l = s.mul(a);
  return e ? l : new zo(Math.ceil(l));
}
function SOr(t, e, r) {
  var n = 1, a = new zo(t);
  if (!a.isint() && r) {
    var i = Math.abs(t);
    i < 1 ? (n = new zo(10).pow(sH.getDigitCount(t) - 1), a = new zo(Math.floor(a.div(n).toNumber())).mul(n)) : i > 1 && (a = new zo(Math.floor(t)));
  } else t === 0 ? a = new zo(Math.floor((e - 1) / 2)) : r || (a = new zo(Math.floor(t)));
  var o = Math.floor((e - 1) / 2), s = dOr(uOr(function(l) {
    return a.add(new zo(l - o).mul(n)).toNumber();
  }), i0e);
  return s(0, e);
}
function Fdt(t, e, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((e - t) / (r - 1)))
    return {
      step: new zo(0),
      tickMin: new zo(0),
      tickMax: new zo(0)
    };
  var i = jdt(new zo(e).sub(t).div(r - 1), n, a), o;
  t <= 0 && e >= 0 ? o = new zo(0) : (o = new zo(t).add(e).div(2), o = o.sub(new zo(o).mod(i)));
  var s = Math.ceil(o.sub(t).div(i).toNumber()), l = Math.ceil(new zo(e).sub(o).div(i).toNumber()), c = s + l + 1;
  return c > r ? Fdt(t, e, r, n, a + 1) : (c < r && (l = e > 0 ? l + (r - c) : l, s = e > 0 ? s : s + (r - c)), {
    step: i,
    tickMin: o.sub(new zo(s).mul(i)),
    tickMax: o.add(new zo(l).mul(i))
  });
}
function _Or(t) {
  var e = NE(t, 2), r = e[0], n = e[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(a, 2), s = Ldt([r, n]), l = NE(s, 2), c = l[0], u = l[1];
  if (c === -1 / 0 || u === 1 / 0) {
    var f = u === 1 / 0 ? [c].concat(s0e(i0e(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(s0e(i0e(0, a - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return r > n ? o0e(f) : f;
  }
  if (c === u)
    return SOr(c, a, i);
  var h = Fdt(c, u, o, i), p = h.step, g = h.tickMin, y = h.tickMax, b = sH.rangeStep(g, y.add(new zo(0.1).mul(p)), p);
  return r > n ? o0e(b) : b;
}
function kOr(t, e) {
  var r = NE(t, 2), n = r[0], a = r[1], i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Ldt([n, a]), s = NE(o, 2), l = s[0], c = s[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [n, a];
  if (l === c)
    return [l];
  var u = Math.max(e, 2), f = jdt(new zo(c).sub(l).div(u - 1), i, 0), h = [].concat(s0e(sH.rangeStep(new zo(l), new zo(c).sub(new zo(0.99).mul(f)), f)), [c]);
  return n > a ? o0e(h) : h;
}
var AOr = $dt(_Or), TOr = $dt(kOr), EOr = Qa.env.NODE_ENV === "production", nae = "Invariant failed";
function pd(t, e) {
  if (EOr)
    throw new Error(nae);
  var r = typeof e == "function" ? e() : e, n = r ? "".concat(nae, ": ").concat(r) : nae;
  throw new Error(n);
}
var IOr = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function $x(t) {
  "@babel/helpers - typeof";
  return $x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $x(t);
}
function jj() {
  return jj = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, jj.apply(this, arguments);
}
function MOr(t, e) {
  return BOr(t) || OOr(t, e) || ROr(t, e) || POr();
}
function POr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ROr(t, e) {
  if (t) {
    if (typeof t == "string") return GOe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return GOe(t, e);
  }
}
function GOe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function OOr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function BOr(t) {
  if (Array.isArray(t)) return t;
}
function NOr(t, e) {
  if (t == null) return {};
  var r = $Or(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function $Or(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function DOr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LOr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Wdt(n.key), n);
  }
}
function jOr(t, e, r) {
  return e && LOr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function FOr(t, e, r) {
  return e = Fj(e), zOr(t, zdt() ? Reflect.construct(e, r || [], Fj(t).constructor) : e.apply(t, r));
}
function zOr(t, e) {
  if (e && ($x(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return GOr(t);
}
function GOr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function zdt() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zdt = function() {
    return !!t;
  })();
}
function Fj(t) {
  return Fj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Fj(t);
}
function WOr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && c0e(t, e);
}
function c0e(t, e) {
  return c0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, c0e(t, e);
}
function Gdt(t, e, r) {
  return e = Wdt(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Wdt(t) {
  var e = HOr(t, "string");
  return $x(e) == "symbol" ? e : e + "";
}
function HOr(t, e) {
  if ($x(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if ($x(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var fP = /* @__PURE__ */ function(t) {
  function e() {
    return DOr(this, e), FOr(this, e, arguments);
  }
  return WOr(e, t), jOr(e, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.offset, i = n.layout, o = n.width, s = n.dataKey, l = n.data, c = n.dataPointFormatter, u = n.xAxis, f = n.yAxis, h = NOr(n, IOr), p = Un(h, !1);
      this.props.direction === "x" && u.type !== "number" && (Ar.env.NODE_ENV !== "production" ? pd(!1, 'ErrorBar requires Axis type property to be "number".') : pd());
      var g = l.map(function(y) {
        var b = c(y, s), w = b.x, _ = b.y, C = b.value, x = b.errorVal;
        if (!x)
          return null;
        var S = [], A, I;
        if (Array.isArray(x)) {
          var M = MOr(x, 2);
          A = M[0], I = M[1];
        } else
          A = I = x;
        if (i === "vertical") {
          var B = u.scale, L = _ + a, N = L + o, d = L - o, m = B(C - A), v = B(C + I);
          S.push({
            x1: v,
            y1: N,
            x2: v,
            y2: d
          }), S.push({
            x1: m,
            y1: L,
            x2: v,
            y2: L
          }), S.push({
            x1: m,
            y1: N,
            x2: m,
            y2: d
          });
        } else if (i === "horizontal") {
          var k = f.scale, O = w + a, G = O - o, H = O + o, j = k(C - A), F = k(C + I);
          S.push({
            x1: G,
            y1: F,
            x2: H,
            y2: F
          }), S.push({
            x1: O,
            y1: j,
            x2: O,
            y2: F
          }), S.push({
            x1: G,
            y1: j,
            x2: H,
            y2: j
          });
        }
        return /* @__PURE__ */ Te.createElement(Fi, jj({
          className: "recharts-errorBar",
          key: "bar-".concat(S.map(function(z) {
            return "".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2);
          }))
        }, p), S.map(function(z) {
          return /* @__PURE__ */ Te.createElement("line", jj({}, z, {
            key: "line-".concat(z.x1, "-").concat(z.x2, "-").concat(z.y1, "-").concat(z.y2)
          }));
        }));
      });
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-errorBars"
      }, g);
    }
  }]);
}(Te.Component);
Gdt(fP, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
Gdt(fP, "displayName", "ErrorBar");
function $E(t) {
  "@babel/helpers - typeof";
  return $E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $E(t);
}
function WOe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function V3(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? WOe(Object(r), !0).forEach(function(n) {
      UOr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : WOe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function UOr(t, e, r) {
  return e = VOr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function VOr(t) {
  var e = qOr(t, "string");
  return $E(e) == "symbol" ? e : e + "";
}
function qOr(t, e) {
  if ($E(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if ($E(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var Hdt = function(e) {
  var r = e.children, n = e.formattedGraphicalItems, a = e.legendWidth, i = e.legendContent, o = Zd(r, Mm);
  if (!o)
    return null;
  var s = Mm.defaultProps, l = s !== void 0 ? V3(V3({}, s), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : i === "children" ? c = (n || []).reduce(function(u, f) {
    var h = f.item, p = f.props, g = p.sectors || p.data || [];
    return u.concat(g.map(function(y) {
      return {
        type: o.props.iconType || h.props.legendType,
        value: y.name,
        color: y.fill,
        payload: y
      };
    }));
  }, []) : c = (n || []).map(function(u) {
    var f = u.item, h = f.type.defaultProps, p = h !== void 0 ? V3(V3({}, h), f.props) : {}, g = p.dataKey, y = p.name, b = p.legendType, w = p.hide;
    return {
      inactive: w,
      dataKey: g,
      type: l.iconType || b || "square",
      color: Wye(f),
      value: y || g,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), V3(V3(V3({}, l), Mm.getWithHeight(o, a)), {}, {
    payload: c,
    item: o
  });
};
function DE(t) {
  "@babel/helpers - typeof";
  return DE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, DE(t);
}
function HOe(t) {
  return YOr(t) || JOr(t) || ZOr(t) || KOr();
}
function KOr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZOr(t, e) {
  if (t) {
    if (typeof t == "string") return u0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return u0e(t, e);
  }
}
function JOr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function YOr(t) {
  if (Array.isArray(t)) return u0e(t);
}
function u0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function UOe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vs(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? UOe(Object(r), !0).forEach(function(n) {
      T7(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : UOe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function T7(t, e, r) {
  return e = XOr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function XOr(t) {
  var e = QOr(t, "string");
  return DE(e) == "symbol" ? e : e + "";
}
function QOr(t, e) {
  if (DE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (DE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ll(t, e, r) {
  return Va(t) || Va(e) ? r : Hl(e) ? u0(t, e, r) : ua(e) ? e(t) : r;
}
function H_(t, e, r, n) {
  var a = YRr(t, function(s) {
    return ll(s, e);
  });
  if (r === "number") {
    var i = a.filter(function(s) {
      return Ur(s) || parseFloat(s);
    });
    return i.length ? [iH(i), kv(i)] : [1 / 0, -1 / 0];
  }
  var o = n ? a.filter(function(s) {
    return !Va(s);
  }) : a;
  return o.map(function(s) {
    return Hl(s) || s instanceof Date ? s : "";
  });
}
var eBr = function(e) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], a = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, o = -1, s = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (s <= 1)
    return 0;
  if (i && i.axisType === "angleAxis" && Math.abs(Math.abs(i.range[1] - i.range[0]) - 360) <= 1e-6)
    for (var l = i.range, c = 0; c < s; c++) {
      var u = c > 0 ? a[c - 1].coordinate : a[s - 1].coordinate, f = a[c].coordinate, h = c >= s - 1 ? a[0].coordinate : a[c + 1].coordinate, p = void 0;
      if (Su(f - u) !== Su(h - f)) {
        var g = [];
        if (Su(h - f) === Su(l[1] - l[0])) {
          p = h;
          var y = f + l[1] - l[0];
          g[0] = Math.min(y, (y + u) / 2), g[1] = Math.max(y, (y + u) / 2);
        } else {
          p = u;
          var b = h + l[1] - l[0];
          g[0] = Math.min(f, (b + f) / 2), g[1] = Math.max(f, (b + f) / 2);
        }
        var w = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (e > w[0] && e <= w[1] || e >= g[0] && e <= g[1]) {
          o = a[c].index;
          break;
        }
      } else {
        var _ = Math.min(u, h), C = Math.max(u, h);
        if (e > (_ + f) / 2 && e <= (C + f) / 2) {
          o = a[c].index;
          break;
        }
      }
    }
  else
    for (var x = 0; x < s; x++)
      if (x === 0 && e <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x > 0 && x < s - 1 && e > (n[x].coordinate + n[x - 1].coordinate) / 2 && e <= (n[x].coordinate + n[x + 1].coordinate) / 2 || x === s - 1 && e > (n[x].coordinate + n[x - 1].coordinate) / 2) {
        o = n[x].index;
        break;
      }
  return o;
}, Wye = function(e) {
  var r, n = e, a = n.type.displayName, i = (r = e.type) !== null && r !== void 0 && r.defaultProps ? Vs(Vs({}, e.type.defaultProps), e.props) : e.props, o = i.stroke, s = i.fill, l;
  switch (a) {
    case "Line":
      l = o;
      break;
    case "Area":
    case "Radar":
      l = o && o !== "none" ? o : s;
      break;
    default:
      l = s;
      break;
  }
  return l;
}, tBr = function(e) {
  var r = e.barSize, n = e.totalSize, a = e.stackGroups, i = a === void 0 ? {} : a;
  if (!i)
    return {};
  for (var o = {}, s = Object.keys(i), l = 0, c = s.length; l < c; l++)
    for (var u = i[s[l]].stackGroups, f = Object.keys(u), h = 0, p = f.length; h < p; h++) {
      var g = u[f[h]], y = g.items, b = g.cateAxisId, w = y.filter(function(I) {
        return Im(I.type).indexOf("Bar") >= 0;
      });
      if (w && w.length) {
        var _ = w[0].type.defaultProps, C = _ !== void 0 ? Vs(Vs({}, _), w[0].props) : w[0].props, x = C.barSize, S = C[b];
        o[S] || (o[S] = []);
        var A = Va(x) ? r : x;
        o[S].push({
          item: w[0],
          stackList: w.slice(1),
          barSize: Va(A) ? void 0 : _u(A, n, 0)
        });
      }
    }
  return o;
}, rBr = function(e) {
  var r = e.barGap, n = e.barCategoryGap, a = e.bandSize, i = e.sizeList, o = i === void 0 ? [] : i, s = e.maxBarSize, l = o.length;
  if (l < 1) return null;
  var c = _u(r, a, 0, !0), u, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var h = !1, p = a / l, g = o.reduce(function(x, S) {
      return x + S.barSize || 0;
    }, 0);
    g += (l - 1) * c, g >= a && (g -= (l - 1) * c, c = 0), g >= a && p > 0 && (h = !0, p *= 0.9, g = l * p);
    var y = (a - g) / 2 >> 0, b = {
      offset: y - c,
      size: 0
    };
    u = o.reduce(function(x, S) {
      var A = {
        item: S.item,
        position: {
          offset: b.offset + b.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: h ? p : S.barSize
        }
      }, I = [].concat(HOe(x), [A]);
      return b = I[I.length - 1].position, S.stackList && S.stackList.length && S.stackList.forEach(function(M) {
        I.push({
          item: M,
          position: b
        });
      }), I;
    }, f);
  } else {
    var w = _u(n, a, 0, !0);
    a - 2 * w - (l - 1) * c <= 0 && (c = 0);
    var _ = (a - 2 * w - (l - 1) * c) / l;
    _ > 1 && (_ >>= 0);
    var C = s === +s ? Math.min(_, s) : _;
    u = o.reduce(function(x, S, A) {
      var I = [].concat(HOe(x), [{
        item: S.item,
        position: {
          offset: w + (_ + c) * A + (_ - C) / 2,
          size: C
        }
      }]);
      return S.stackList && S.stackList.length && S.stackList.forEach(function(M) {
        I.push({
          item: M,
          position: I[I.length - 1].position
        });
      }), I;
    }, f);
  }
  return u;
}, nBr = function(e, r, n, a) {
  var i = n.children, o = n.width, s = n.margin, l = o - (s.left || 0) - (s.right || 0), c = Hdt({
    children: i,
    legendWidth: l
  });
  if (c) {
    var u = a || {}, f = u.width, h = u.height, p = c.align, g = c.verticalAlign, y = c.layout;
    if ((y === "vertical" || y === "horizontal" && g === "middle") && p !== "center" && Ur(e[p]))
      return Vs(Vs({}, e), {}, T7({}, p, e[p] + (f || 0)));
    if ((y === "horizontal" || y === "vertical" && p === "center") && g !== "middle" && Ur(e[g]))
      return Vs(Vs({}, e), {}, T7({}, g, e[g] + (h || 0)));
  }
  return e;
}, aBr = function(e, r, n) {
  return Va(r) ? !0 : e === "horizontal" ? r === "yAxis" : e === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, Udt = function(e, r, n, a, i) {
  var o = r.props.children, s = d0(o, fP).filter(function(c) {
    return aBr(a, i, c.props.direction);
  });
  if (s && s.length) {
    var l = s.map(function(c) {
      return c.props.dataKey;
    });
    return e.reduce(function(c, u) {
      var f = ll(u, n);
      if (Va(f)) return c;
      var h = Array.isArray(f) ? [iH(f), kv(f)] : [f, f], p = l.reduce(function(g, y) {
        var b = ll(u, y, 0), w = h[0] - Math.abs(Array.isArray(b) ? b[0] : b), _ = h[1] + Math.abs(Array.isArray(b) ? b[1] : b);
        return [Math.min(w, g[0]), Math.max(_, g[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], c[0]), Math.max(p[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, iBr = function(e, r, n, a, i) {
  var o = r.map(function(s) {
    return Udt(e, s, n, i, a);
  }).filter(function(s) {
    return !Va(s);
  });
  return o && o.length ? o.reduce(function(s, l) {
    return [Math.min(s[0], l[0]), Math.max(s[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, Vdt = function(e, r, n, a, i) {
  var o = r.map(function(l) {
    var c = l.props.dataKey;
    return n === "number" && c && Udt(e, l, c, a) || H_(e, c, n, i);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var s = {};
  return o.reduce(function(l, c) {
    for (var u = 0, f = c.length; u < f; u++)
      s[c[u]] || (s[c[u]] = !0, l.push(c[u]));
    return l;
  }, []);
}, qdt = function(e, r) {
  return e === "horizontal" && r === "xAxis" || e === "vertical" && r === "yAxis" || e === "centric" && r === "angleAxis" || e === "radial" && r === "radiusAxis";
}, Kdt = function(e, r, n, a) {
  if (a)
    return e.map(function(l) {
      return l.coordinate;
    });
  var i, o, s = e.map(function(l) {
    return l.coordinate === r && (i = !0), l.coordinate === n && (o = !0), l.coordinate;
  });
  return i || s.push(r), o || s.push(n), s;
}, Sm = function(e, r, n) {
  if (!e) return null;
  var a = e.scale, i = e.duplicateDomain, o = e.type, s = e.range, l = e.realScaleType === "scaleBand" ? a.bandwidth() / 2 : 2, c = (r || n) && o === "category" && a.bandwidth ? a.bandwidth() / l : 0;
  if (c = e.axisType === "angleAxis" && (s == null ? void 0 : s.length) >= 2 ? Su(s[0] - s[1]) * 2 * c : c, r && (e.ticks || e.niceTicks)) {
    var u = (e.ticks || e.niceTicks).map(function(f) {
      var h = i ? i.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: a(h) + c,
        value: f,
        offset: c
      };
    });
    return u.filter(function(f) {
      return !aC(f.coordinate);
    });
  }
  return e.isCategorical && e.categoricalDomain ? e.categoricalDomain.map(function(f, h) {
    return {
      coordinate: a(f) + c,
      value: f,
      index: h,
      offset: c
    };
  }) : a.ticks && !n ? a.ticks(e.tickCount).map(function(f) {
    return {
      coordinate: a(f) + c,
      value: f,
      offset: c
    };
  }) : a.domain().map(function(f, h) {
    return {
      coordinate: a(f) + c,
      value: i ? i[f] : f,
      index: h,
      offset: c
    };
  });
}, aae = /* @__PURE__ */ new WeakMap(), aN = function(e, r) {
  if (typeof r != "function")
    return e;
  aae.has(e) || aae.set(e, /* @__PURE__ */ new WeakMap());
  var n = aae.get(e);
  if (n.has(r))
    return n.get(r);
  var a = function() {
    e.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, a), a;
}, Zdt = function(e, r, n) {
  var a = e.scale, i = e.type, o = e.layout, s = e.axisType;
  if (a === "auto")
    return o === "radial" && s === "radiusAxis" ? {
      scale: ME(),
      realScaleType: "band"
    } : o === "radial" && s === "angleAxis" ? {
      scale: Bj(),
      realScaleType: "linear"
    } : i === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: W_(),
      realScaleType: "point"
    } : i === "category" ? {
      scale: ME(),
      realScaleType: "band"
    } : {
      scale: Bj(),
      realScaleType: "linear"
    };
  if (oP(a)) {
    var l = "scale".concat(HW(a));
    return {
      scale: (MOe[l] || W_)(),
      realScaleType: MOe[l] ? l : "point"
    };
  }
  return ua(a) ? {
    scale: a
  } : {
    scale: W_(),
    realScaleType: "point"
  };
}, VOe = 1e-4, Jdt = function(e) {
  var r = e.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, a = e.range(), i = Math.min(a[0], a[1]) - VOe, o = Math.max(a[0], a[1]) + VOe, s = e(r[0]), l = e(r[n - 1]);
    (s < i || s > o || l < i || l > o) && e.domain([r[0], r[n - 1]]);
  }
}, oBr = function(e, r) {
  if (!e)
    return null;
  for (var n = 0, a = e.length; n < a; n++)
    if (e[n].item === r)
      return e[n].position;
  return null;
}, sBr = function(e, r) {
  if (!r || r.length !== 2 || !Ur(r[0]) || !Ur(r[1]))
    return e;
  var n = Math.min(r[0], r[1]), a = Math.max(r[0], r[1]), i = [e[0], e[1]];
  return (!Ur(e[0]) || e[0] < n) && (i[0] = n), (!Ur(e[1]) || e[1] > a) && (i[1] = a), i[0] > a && (i[0] = a), i[1] < n && (i[1] = n), i;
}, lBr = function(e) {
  var r = e.length;
  if (!(r <= 0))
    for (var n = 0, a = e[0].length; n < a; ++n)
      for (var i = 0, o = 0, s = 0; s < r; ++s) {
        var l = aC(e[s][n][1]) ? e[s][n][0] : e[s][n][1];
        l >= 0 ? (e[s][n][0] = i, e[s][n][1] = i + l, i = e[s][n][1]) : (e[s][n][0] = o, e[s][n][1] = o + l, o = e[s][n][1]);
      }
}, cBr = function(e) {
  var r = e.length;
  if (!(r <= 0))
    for (var n = 0, a = e[0].length; n < a; ++n)
      for (var i = 0, o = 0; o < r; ++o) {
        var s = aC(e[o][n][1]) ? e[o][n][0] : e[o][n][1];
        s >= 0 ? (e[o][n][0] = i, e[o][n][1] = i + s, i = e[o][n][1]) : (e[o][n][0] = 0, e[o][n][1] = 0);
      }
}, uBr = {
  sign: lBr,
  // @ts-expect-error definitelytyped types are incorrect
  expand: HAr,
  // @ts-expect-error definitelytyped types are incorrect
  none: Ex,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: UAr,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: VAr,
  positive: cBr
}, dBr = function(e, r, n) {
  var a = r.map(function(s) {
    return s.props.dataKey;
  }), i = uBr[n], o = WAr().keys(a).value(function(s, l) {
    return +ll(s, l, 0);
  }).order(jde).offset(i);
  return o(e);
}, fBr = function(e, r, n, a, i, o) {
  if (!e)
    return null;
  var s = o ? r.reverse() : r, l = {}, c = s.reduce(function(f, h) {
    var p, g = (p = h.type) !== null && p !== void 0 && p.defaultProps ? Vs(Vs({}, h.type.defaultProps), h.props) : h.props, y = g.stackId, b = g.hide;
    if (b)
      return f;
    var w = g[n], _ = f[w] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Hl(y)) {
      var C = _.stackGroups[y] || {
        numericAxisId: n,
        cateAxisId: a,
        items: []
      };
      C.items.push(h), _.hasStack = !0, _.stackGroups[y] = C;
    } else
      _.stackGroups[b6("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: a,
        items: [h]
      };
    return Vs(Vs({}, f), {}, T7({}, w, _));
  }, l), u = {};
  return Object.keys(c).reduce(function(f, h) {
    var p = c[h];
    if (p.hasStack) {
      var g = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(y, b) {
        var w = p.stackGroups[b];
        return Vs(Vs({}, y), {}, T7({}, b, {
          numericAxisId: n,
          cateAxisId: a,
          items: w.items,
          stackedData: dBr(e, w.items, i)
        }));
      }, g);
    }
    return Vs(Vs({}, f), {}, T7({}, h, p));
  }, u);
}, Ydt = function(e, r) {
  var n = r.realScaleType, a = r.type, i = r.tickCount, o = r.originalDomain, s = r.allowDecimals, l = n || r.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (i && a === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = e.domain();
    if (!c.length)
      return null;
    var u = AOr(c, i, s);
    return e.domain([iH(u), kv(u)]), {
      niceTicks: u
    };
  }
  if (i && a === "number") {
    var f = e.domain(), h = TOr(f, i, s);
    return {
      niceTicks: h
    };
  }
  return null;
};
function zj(t) {
  var e = t.axis, r = t.ticks, n = t.bandSize, a = t.entry, i = t.index, o = t.dataKey;
  if (e.type === "category") {
    if (!e.allowDuplicatedCategory && e.dataKey && !Va(a[e.dataKey])) {
      var s = gj(r, "value", a[e.dataKey]);
      if (s)
        return s.coordinate + n / 2;
    }
    return r[i] ? r[i].coordinate + n / 2 : null;
  }
  var l = ll(a, Va(o) ? e.dataKey : o);
  return Va(l) ? null : e.scale(l);
}
var qOe = function(e) {
  var r = e.axis, n = e.ticks, a = e.offset, i = e.bandSize, o = e.entry, s = e.index;
  if (r.type === "category")
    return n[s] ? n[s].coordinate + a : null;
  var l = ll(o, r.dataKey, r.domain[s]);
  return Va(l) ? null : r.scale(l) - i / 2 + a;
}, hBr = function(e) {
  var r = e.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var a = Math.min(n[0], n[1]), i = Math.max(n[0], n[1]);
    return a <= 0 && i >= 0 ? 0 : i < 0 ? i : a;
  }
  return n[0];
}, pBr = function(e, r) {
  var n, a = (n = e.type) !== null && n !== void 0 && n.defaultProps ? Vs(Vs({}, e.type.defaultProps), e.props) : e.props, i = a.stackId;
  if (Hl(i)) {
    var o = r[i];
    if (o) {
      var s = o.items.indexOf(e);
      return s >= 0 ? o.stackedData[s] : null;
    }
  }
  return null;
}, mBr = function(e) {
  return e.reduce(function(r, n) {
    return [iH(n.concat([r[0]]).filter(Ur)), kv(n.concat([r[1]]).filter(Ur))];
  }, [1 / 0, -1 / 0]);
}, Xdt = function(e, r, n) {
  return Object.keys(e).reduce(function(a, i) {
    var o = e[i], s = o.stackedData, l = s.reduce(function(c, u) {
      var f = mBr(u.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], a[0]), Math.max(l[1], a[1])];
  }, [1 / 0, -1 / 0]).map(function(a) {
    return a === 1 / 0 || a === -1 / 0 ? 0 : a;
  });
}, KOe = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, ZOe = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, d0e = function(e, r, n) {
  if (ua(e))
    return e(r, n);
  if (!Array.isArray(e))
    return r;
  var a = [];
  if (Ur(e[0]))
    a[0] = n ? e[0] : Math.min(e[0], r[0]);
  else if (KOe.test(e[0])) {
    var i = +KOe.exec(e[0])[1];
    a[0] = r[0] - i;
  } else ua(e[0]) ? a[0] = e[0](r[0]) : a[0] = r[0];
  if (Ur(e[1]))
    a[1] = n ? e[1] : Math.max(e[1], r[1]);
  else if (ZOe.test(e[1])) {
    var o = +ZOe.exec(e[1])[1];
    a[1] = r[1] + o;
  } else ua(e[1]) ? a[1] = e[1](r[1]) : a[1] = r[1];
  return a;
}, Gj = function(e, r, n) {
  if (e && e.scale && e.scale.bandwidth) {
    var a = e.scale.bandwidth();
    if (!n || a > 0)
      return a;
  }
  if (e && r && r.length >= 2) {
    for (var i = gye(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, s = 1, l = i.length; s < l; s++) {
      var c = i[s], u = i[s - 1];
      o = Math.min((c.coordinate || 0) - (u.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, JOe = function(e, r, n) {
  return !e || !e.length || O5(e, u0(n, "type.defaultProps.domain")) ? r : e;
}, Qdt = function(e, r) {
  var n = e.type.defaultProps ? Vs(Vs({}, e.type.defaultProps), e.props) : e.props, a = n.dataKey, i = n.name, o = n.unit, s = n.formatter, l = n.tooltipType, c = n.chartType, u = n.hide;
  return Vs(Vs({}, Un(e, !1)), {}, {
    dataKey: a,
    unit: o,
    formatter: s,
    name: i || a,
    color: Wye(e),
    value: ll(r, a),
    type: l,
    payload: r,
    chartType: c,
    hide: u
  });
};
function LE(t) {
  "@babel/helpers - typeof";
  return LE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, LE(t);
}
function YOe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xp(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? YOe(Object(r), !0).forEach(function(n) {
      e0t(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : YOe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function e0t(t, e, r) {
  return e = gBr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function gBr(t) {
  var e = vBr(t, "string");
  return LE(e) == "symbol" ? e : e + "";
}
function vBr(t, e) {
  if (LE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (LE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function yBr(t, e) {
  return wBr(t) || CBr(t, e) || xBr(t, e) || bBr();
}
function bBr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xBr(t, e) {
  if (t) {
    if (typeof t == "string") return XOe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return XOe(t, e);
  }
}
function XOe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function CBr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function wBr(t) {
  if (Array.isArray(t)) return t;
}
var Wj = Math.PI / 180, SBr = function(e) {
  return e * 180 / Math.PI;
}, ls = function(e, r, n, a) {
  return {
    x: e + Math.cos(-Wj * a) * n,
    y: r + Math.sin(-Wj * a) * n
  };
}, t0t = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(e - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, _Br = function(e, r, n, a, i) {
  var o = e.width, s = e.height, l = e.startAngle, c = e.endAngle, u = _u(e.cx, o, o / 2), f = _u(e.cy, s, s / 2), h = t0t(o, s, n), p = _u(e.innerRadius, h, 0), g = _u(e.outerRadius, h, h * 0.8), y = Object.keys(r);
  return y.reduce(function(b, w) {
    var _ = r[w], C = _.domain, x = _.reversed, S;
    if (Va(_.range))
      a === "angleAxis" ? S = [l, c] : a === "radiusAxis" && (S = [p, g]), x && (S = [S[1], S[0]]);
    else {
      S = _.range;
      var A = S, I = yBr(A, 2);
      l = I[0], c = I[1];
    }
    var M = Zdt(_, i), B = M.realScaleType, L = M.scale;
    L.domain(C).range(S), Jdt(L);
    var N = Ydt(L, Xp(Xp({}, _), {}, {
      realScaleType: B
    })), d = Xp(Xp(Xp({}, _), N), {}, {
      range: S,
      radius: g,
      realScaleType: B,
      scale: L,
      cx: u,
      cy: f,
      innerRadius: p,
      outerRadius: g,
      startAngle: l,
      endAngle: c
    });
    return Xp(Xp({}, b), {}, e0t({}, w, d));
  }, {});
}, kBr = function(e, r) {
  var n = e.x, a = e.y, i = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - i, 2) + Math.pow(a - o, 2));
}, ABr = function(e, r) {
  var n = e.x, a = e.y, i = r.cx, o = r.cy, s = kBr({
    x: n,
    y: a
  }, {
    x: i,
    y: o
  });
  if (s <= 0)
    return {
      radius: s
    };
  var l = (n - i) / s, c = Math.acos(l);
  return a > o && (c = 2 * Math.PI - c), {
    radius: s,
    angle: SBr(c),
    angleInRadian: c
  };
}, TBr = function(e) {
  var r = e.startAngle, n = e.endAngle, a = Math.floor(r / 360), i = Math.floor(n / 360), o = Math.min(a, i);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, EBr = function(e, r) {
  var n = r.startAngle, a = r.endAngle, i = Math.floor(n / 360), o = Math.floor(a / 360), s = Math.min(i, o);
  return e + s * 360;
}, QOe = function(e, r) {
  var n = e.x, a = e.y, i = ABr({
    x: n,
    y: a
  }, r), o = i.radius, s = i.angle, l = r.innerRadius, c = r.outerRadius;
  if (o < l || o > c)
    return !1;
  if (o === 0)
    return !0;
  var u = TBr(r), f = u.startAngle, h = u.endAngle, p = s, g;
  if (f <= h) {
    for (; p > h; )
      p -= 360;
    for (; p < f; )
      p += 360;
    g = p >= f && p <= h;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < h; )
      p += 360;
    g = p >= h && p <= f;
  }
  return g ? Xp(Xp({}, r), {}, {
    radius: o,
    angle: EBr(p, r)
  }) : null;
}, r0t = function(e) {
  return !/* @__PURE__ */ ef(e) && !ua(e) && typeof e != "boolean" ? e.className : "";
};
function jE(t) {
  "@babel/helpers - typeof";
  return jE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jE(t);
}
var IBr = ["offset"];
function MBr(t) {
  return BBr(t) || OBr(t) || RBr(t) || PBr();
}
function PBr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function RBr(t, e) {
  if (t) {
    if (typeof t == "string") return f0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return f0e(t, e);
  }
}
function OBr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function BBr(t) {
  if (Array.isArray(t)) return f0e(t);
}
function f0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function NBr(t, e) {
  if (t == null) return {};
  var r = $Br(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function $Br(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function eBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? eBe(Object(r), !0).forEach(function(n) {
      DBr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : eBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function DBr(t, e, r) {
  return e = LBr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function LBr(t) {
  var e = jBr(t, "string");
  return jE(e) == "symbol" ? e : e + "";
}
function jBr(t, e) {
  if (jE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (jE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function FE() {
  return FE = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, FE.apply(this, arguments);
}
var FBr = function(e) {
  var r = e.value, n = e.formatter, a = Va(e.children) ? r : e.children;
  return ua(n) ? n(a) : a;
}, zBr = function(e, r) {
  var n = Su(r - e), a = Math.min(Math.abs(r - e), 360);
  return n * a;
}, GBr = function(e, r, n) {
  var a = e.position, i = e.viewBox, o = e.offset, s = e.className, l = i, c = l.cx, u = l.cy, f = l.innerRadius, h = l.outerRadius, p = l.startAngle, g = l.endAngle, y = l.clockWise, b = (f + h) / 2, w = zBr(p, g), _ = w >= 0 ? 1 : -1, C, x;
  a === "insideStart" ? (C = p + _ * o, x = y) : a === "insideEnd" ? (C = g - _ * o, x = !y) : a === "end" && (C = g + _ * o, x = y), x = w <= 0 ? x : !x;
  var S = ls(c, u, b, C), A = ls(c, u, b, C + (x ? 1 : -1) * 359), I = "M".concat(S.x, ",").concat(S.y, `
    A`).concat(b, ",").concat(b, ",0,1,").concat(x ? 0 : 1, `,
    `).concat(A.x, ",").concat(A.y), M = Va(e.id) ? b6("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ Te.createElement("text", FE({}, n, {
    dominantBaseline: "central",
    className: ti("recharts-radial-bar-label", s)
  }), /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("path", {
    id: M,
    d: I
  })), /* @__PURE__ */ Te.createElement("textPath", {
    xlinkHref: "#".concat(M)
  }, r));
}, WBr = function(e) {
  var r = e.viewBox, n = e.offset, a = e.position, i = r, o = i.cx, s = i.cy, l = i.innerRadius, c = i.outerRadius, u = i.startAngle, f = i.endAngle, h = (u + f) / 2;
  if (a === "outside") {
    var p = ls(o, s, c + n, h), g = p.x, y = p.y;
    return {
      x: g,
      y,
      textAnchor: g >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (a === "center")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (a === "centerTop")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (a === "centerBottom")
    return {
      x: o,
      y: s,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var b = (l + c) / 2, w = ls(o, s, b, h), _ = w.x, C = w.y;
  return {
    x: _,
    y: C,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, HBr = function(e) {
  var r = e.viewBox, n = e.parentViewBox, a = e.offset, i = e.position, o = r, s = o.x, l = o.y, c = o.width, u = o.height, f = u >= 0 ? 1 : -1, h = f * a, p = f > 0 ? "end" : "start", g = f > 0 ? "start" : "end", y = c >= 0 ? 1 : -1, b = y * a, w = y > 0 ? "end" : "start", _ = y > 0 ? "start" : "end";
  if (i === "top") {
    var C = {
      x: s + c / 2,
      y: l - f * a,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return jl(jl({}, C), n ? {
      height: Math.max(l - n.y, 0),
      width: c
    } : {});
  }
  if (i === "bottom") {
    var x = {
      x: s + c / 2,
      y: l + u + h,
      textAnchor: "middle",
      verticalAnchor: g
    };
    return jl(jl({}, x), n ? {
      height: Math.max(n.y + n.height - (l + u), 0),
      width: c
    } : {});
  }
  if (i === "left") {
    var S = {
      x: s - b,
      y: l + u / 2,
      textAnchor: w,
      verticalAnchor: "middle"
    };
    return jl(jl({}, S), n ? {
      width: Math.max(S.x - n.x, 0),
      height: u
    } : {});
  }
  if (i === "right") {
    var A = {
      x: s + c + b,
      y: l + u / 2,
      textAnchor: _,
      verticalAnchor: "middle"
    };
    return jl(jl({}, A), n ? {
      width: Math.max(n.x + n.width - A.x, 0),
      height: u
    } : {});
  }
  var I = n ? {
    width: c,
    height: u
  } : {};
  return i === "insideLeft" ? jl({
    x: s + b,
    y: l + u / 2,
    textAnchor: _,
    verticalAnchor: "middle"
  }, I) : i === "insideRight" ? jl({
    x: s + c - b,
    y: l + u / 2,
    textAnchor: w,
    verticalAnchor: "middle"
  }, I) : i === "insideTop" ? jl({
    x: s + c / 2,
    y: l + h,
    textAnchor: "middle",
    verticalAnchor: g
  }, I) : i === "insideBottom" ? jl({
    x: s + c / 2,
    y: l + u - h,
    textAnchor: "middle",
    verticalAnchor: p
  }, I) : i === "insideTopLeft" ? jl({
    x: s + b,
    y: l + h,
    textAnchor: _,
    verticalAnchor: g
  }, I) : i === "insideTopRight" ? jl({
    x: s + c - b,
    y: l + h,
    textAnchor: w,
    verticalAnchor: g
  }, I) : i === "insideBottomLeft" ? jl({
    x: s + b,
    y: l + u - h,
    textAnchor: _,
    verticalAnchor: p
  }, I) : i === "insideBottomRight" ? jl({
    x: s + c - b,
    y: l + u - h,
    textAnchor: w,
    verticalAnchor: p
  }, I) : nC(i) && (Ur(i.x) || vb(i.x)) && (Ur(i.y) || vb(i.y)) ? jl({
    x: s + _u(i.x, c),
    y: l + _u(i.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, I) : jl({
    x: s + c / 2,
    y: l + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, I);
}, UBr = function(e) {
  return "cx" in e && Ur(e.cx);
};
function Ss(t) {
  var e = t.offset, r = e === void 0 ? 5 : e, n = NBr(t, IBr), a = jl({
    offset: r
  }, n), i = a.viewBox, o = a.position, s = a.value, l = a.children, c = a.content, u = a.className, f = u === void 0 ? "" : u, h = a.textBreakAll;
  if (!i || Va(s) && Va(l) && !/* @__PURE__ */ ef(c) && !ua(c))
    return null;
  if (/* @__PURE__ */ ef(c))
    return /* @__PURE__ */ xl(c, a);
  var p;
  if (ua(c)) {
    if (p = /* @__PURE__ */ Ds(c, a), /* @__PURE__ */ ef(p))
      return p;
  } else
    p = FBr(a);
  var g = UBr(i), y = Un(a, !0);
  if (g && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return GBr(a, p, y);
  var b = g ? WBr(a) : HBr(a);
  return /* @__PURE__ */ Te.createElement(P5, FE({
    className: ti("recharts-label", f)
  }, y, b, {
    breakAll: h
  }), p);
}
Ss.displayName = "Label";
var n0t = function(e) {
  var r = e.cx, n = e.cy, a = e.angle, i = e.startAngle, o = e.endAngle, s = e.r, l = e.radius, c = e.innerRadius, u = e.outerRadius, f = e.x, h = e.y, p = e.top, g = e.left, y = e.width, b = e.height, w = e.clockWise, _ = e.labelViewBox;
  if (_)
    return _;
  if (Ur(y) && Ur(b)) {
    if (Ur(f) && Ur(h))
      return {
        x: f,
        y: h,
        width: y,
        height: b
      };
    if (Ur(p) && Ur(g))
      return {
        x: p,
        y: g,
        width: y,
        height: b
      };
  }
  return Ur(f) && Ur(h) ? {
    x: f,
    y: h,
    width: 0,
    height: 0
  } : Ur(r) && Ur(n) ? {
    cx: r,
    cy: n,
    startAngle: i || a || 0,
    endAngle: o || a || 0,
    innerRadius: c || 0,
    outerRadius: u || l || s || 0,
    clockWise: w
  } : e.viewBox ? e.viewBox : {};
}, VBr = function(e, r) {
  return e ? e === !0 ? /* @__PURE__ */ Te.createElement(Ss, {
    key: "label-implicit",
    viewBox: r
  }) : Hl(e) ? /* @__PURE__ */ Te.createElement(Ss, {
    key: "label-implicit",
    viewBox: r,
    value: e
  }) : /* @__PURE__ */ ef(e) ? e.type === Ss ? /* @__PURE__ */ xl(e, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ Te.createElement(Ss, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : ua(e) ? /* @__PURE__ */ Te.createElement(Ss, {
    key: "label-implicit",
    content: e,
    viewBox: r
  }) : nC(e) ? /* @__PURE__ */ Te.createElement(Ss, FE({
    viewBox: r
  }, e, {
    key: "label-implicit"
  })) : null : null;
}, qBr = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && n && !e.label)
    return null;
  var a = e.children, i = n0t(e), o = d0(a, Ss).map(function(l, c) {
    return /* @__PURE__ */ xl(l, {
      viewBox: r || i,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var s = VBr(e.label, r || i);
  return [s].concat(MBr(o));
};
Ss.parseViewBox = n0t;
Ss.renderCallByParent = qBr;
var iae, tBe;
function KBr() {
  if (tBe) return iae;
  tBe = 1;
  function t(e) {
    var r = e == null ? 0 : e.length;
    return r ? e[r - 1] : void 0;
  }
  return iae = t, iae;
}
var ZBr = KBr();
const JBr = /* @__PURE__ */ Gi(ZBr);
function zE(t) {
  "@babel/helpers - typeof";
  return zE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zE(t);
}
var YBr = ["valueAccessor"], XBr = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function QBr(t) {
  return nNr(t) || rNr(t) || tNr(t) || eNr();
}
function eNr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tNr(t, e) {
  if (t) {
    if (typeof t == "string") return h0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return h0e(t, e);
  }
}
function rNr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function nNr(t) {
  if (Array.isArray(t)) return h0e(t);
}
function h0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Hj() {
  return Hj = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Hj.apply(this, arguments);
}
function rBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function nBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rBe(Object(r), !0).forEach(function(n) {
      aNr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : rBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function aNr(t, e, r) {
  return e = iNr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function iNr(t) {
  var e = oNr(t, "string");
  return zE(e) == "symbol" ? e : e + "";
}
function oNr(t, e) {
  if (zE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (zE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function aBe(t, e) {
  if (t == null) return {};
  var r = sNr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function sNr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var lNr = function(e) {
  return Array.isArray(e.value) ? JBr(e.value) : e.value;
};
function kh(t) {
  var e = t.valueAccessor, r = e === void 0 ? lNr : e, n = aBe(t, YBr), a = n.data, i = n.dataKey, o = n.clockWise, s = n.id, l = n.textBreakAll, c = aBe(n, XBr);
  return !a || !a.length ? null : /* @__PURE__ */ Te.createElement(Fi, {
    className: "recharts-label-list"
  }, a.map(function(u, f) {
    var h = Va(i) ? r(u, f) : ll(u && u.payload, i), p = Va(s) ? {} : {
      id: "".concat(s, "-").concat(f)
    };
    return /* @__PURE__ */ Te.createElement(Ss, Hj({}, Un(u, !0), c, p, {
      parentViewBox: u.parentViewBox,
      value: h,
      textBreakAll: l,
      viewBox: Ss.parseViewBox(Va(o) ? u : nBe(nBe({}, u), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
kh.displayName = "LabelList";
function cNr(t, e) {
  return t ? t === !0 ? /* @__PURE__ */ Te.createElement(kh, {
    key: "labelList-implicit",
    data: e
  }) : /* @__PURE__ */ Te.isValidElement(t) || ua(t) ? /* @__PURE__ */ Te.createElement(kh, {
    key: "labelList-implicit",
    data: e,
    content: t
  }) : nC(t) ? /* @__PURE__ */ Te.createElement(kh, Hj({
    data: e
  }, t, {
    key: "labelList-implicit"
  })) : null : null;
}
function uNr(t, e) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && r && !t.label)
    return null;
  var n = t.children, a = d0(n, kh).map(function(o, s) {
    return /* @__PURE__ */ xl(o, {
      data: e,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(s)
    });
  });
  if (!r)
    return a;
  var i = cNr(t.label, e);
  return [i].concat(QBr(a));
}
kh.renderCallByParent = uNr;
function GE(t) {
  "@babel/helpers - typeof";
  return GE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, GE(t);
}
function p0e() {
  return p0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, p0e.apply(this, arguments);
}
function iBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? iBe(Object(r), !0).forEach(function(n) {
      dNr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : iBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function dNr(t, e, r) {
  return e = fNr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function fNr(t) {
  var e = hNr(t, "string");
  return GE(e) == "symbol" ? e : e + "";
}
function hNr(t, e) {
  if (GE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (GE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var pNr = function(e, r) {
  var n = Su(r - e), a = Math.min(Math.abs(r - e), 359.999);
  return n * a;
}, iN = function(e) {
  var r = e.cx, n = e.cy, a = e.radius, i = e.angle, o = e.sign, s = e.isExternal, l = e.cornerRadius, c = e.cornerIsExternal, u = l * (s ? 1 : -1) + a, f = Math.asin(l / u) / Wj, h = c ? i : i + o * f, p = ls(r, n, u, h), g = ls(r, n, a, h), y = c ? i - o * f : i, b = ls(r, n, u * Math.cos(f * Wj), y);
  return {
    center: p,
    circleTangency: g,
    lineTangency: b,
    theta: f
  };
}, a0t = function(e) {
  var r = e.cx, n = e.cy, a = e.innerRadius, i = e.outerRadius, o = e.startAngle, s = e.endAngle, l = pNr(o, s), c = o + l, u = ls(r, n, i, o), f = ls(r, n, i, c), h = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(i, ",").concat(i, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (a > 0) {
    var p = ls(r, n, a, o), g = ls(r, n, a, c);
    h += "L ".concat(g.x, ",").concat(g.y, `
            A `).concat(a, ",").concat(a, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(o <= c), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    h += "L ".concat(r, ",").concat(n, " Z");
  return h;
}, mNr = function(e) {
  var r = e.cx, n = e.cy, a = e.innerRadius, i = e.outerRadius, o = e.cornerRadius, s = e.forceCornerRadius, l = e.cornerIsExternal, c = e.startAngle, u = e.endAngle, f = Su(u - c), h = iN({
    cx: r,
    cy: n,
    radius: i,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: l
  }), p = h.circleTangency, g = h.lineTangency, y = h.theta, b = iN({
    cx: r,
    cy: n,
    radius: i,
    angle: u,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: l
  }), w = b.circleTangency, _ = b.lineTangency, C = b.theta, x = l ? Math.abs(c - u) : Math.abs(c - u) - y - C;
  if (x < 0)
    return s ? "M ".concat(g.x, ",").concat(g.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : a0t({
      cx: r,
      cy: n,
      innerRadius: a,
      outerRadius: i,
      startAngle: c,
      endAngle: u
    });
  var S = "M ".concat(g.x, ",").concat(g.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(i, ",").concat(i, ",0,").concat(+(x > 180), ",").concat(+(f < 0), ",").concat(w.x, ",").concat(w.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(_.x, ",").concat(_.y, `
  `);
  if (a > 0) {
    var A = iN({
      cx: r,
      cy: n,
      radius: a,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), I = A.circleTangency, M = A.lineTangency, B = A.theta, L = iN({
      cx: r,
      cy: n,
      radius: a,
      angle: u,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), N = L.circleTangency, d = L.lineTangency, m = L.theta, v = l ? Math.abs(c - u) : Math.abs(c - u) - B - m;
    if (v < 0 && o === 0)
      return "".concat(S, "L").concat(r, ",").concat(n, "Z");
    S += "L".concat(d.x, ",").concat(d.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(N.x, ",").concat(N.y, `
      A`).concat(a, ",").concat(a, ",0,").concat(+(v > 180), ",").concat(+(f > 0), ",").concat(I.x, ",").concat(I.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(M.x, ",").concat(M.y, "Z");
  } else
    S += "L".concat(r, ",").concat(n, "Z");
  return S;
}, gNr = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Hye = function(e) {
  var r = oBe(oBe({}, gNr), e), n = r.cx, a = r.cy, i = r.innerRadius, o = r.outerRadius, s = r.cornerRadius, l = r.forceCornerRadius, c = r.cornerIsExternal, u = r.startAngle, f = r.endAngle, h = r.className;
  if (o < i || u === f)
    return null;
  var p = ti("recharts-sector", h), g = o - i, y = _u(s, g, 0, !0), b;
  return y > 0 && Math.abs(u - f) < 360 ? b = mNr({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    cornerRadius: Math.min(y, g / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: u,
    endAngle: f
  }) : b = a0t({
    cx: n,
    cy: a,
    innerRadius: i,
    outerRadius: o,
    startAngle: u,
    endAngle: f
  }), /* @__PURE__ */ Te.createElement("path", p0e({}, Un(r, !0), {
    className: p,
    d: b,
    role: "img"
  }));
};
function WE(t) {
  "@babel/helpers - typeof";
  return WE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, WE(t);
}
function m0e() {
  return m0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, m0e.apply(this, arguments);
}
function sBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sBe(Object(r), !0).forEach(function(n) {
      vNr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function vNr(t, e, r) {
  return e = yNr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function yNr(t) {
  var e = bNr(t, "string");
  return WE(e) == "symbol" ? e : e + "";
}
function bNr(t, e) {
  if (WE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (WE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var cBe = {
  curveBasisClosed: RAr,
  curveBasisOpen: OAr,
  curveBasis: PAr,
  curveBumpX: vAr,
  curveBumpY: yAr,
  curveLinearClosed: BAr,
  curveLinear: VW,
  curveMonotoneX: NAr,
  curveMonotoneY: $Ar,
  curveNatural: DAr,
  curveStep: LAr,
  curveStepAfter: FAr,
  curveStepBefore: jAr
}, oN = function(e) {
  return e.x === +e.x && e.y === +e.y;
}, dS = function(e) {
  return e.x;
}, fS = function(e) {
  return e.y;
}, xNr = function(e, r) {
  if (ua(e))
    return e;
  var n = "curve".concat(HW(e));
  return (n === "curveMonotone" || n === "curveBump") && r ? cBe["".concat(n).concat(r === "vertical" ? "Y" : "X")] : cBe[n] || VW;
}, CNr = function(e) {
  var r = e.type, n = r === void 0 ? "linear" : r, a = e.points, i = a === void 0 ? [] : a, o = e.baseLine, s = e.layout, l = e.connectNulls, c = l === void 0 ? !1 : l, u = xNr(n, s), f = c ? i.filter(function(y) {
    return oN(y);
  }) : i, h;
  if (Array.isArray(o)) {
    var p = c ? o.filter(function(y) {
      return oN(y);
    }) : o, g = f.map(function(y, b) {
      return lBe(lBe({}, y), {}, {
        base: p[b]
      });
    });
    return s === "vertical" ? h = JB().y(fS).x1(dS).x0(function(y) {
      return y.base.x;
    }) : h = JB().x(dS).y1(fS).y0(function(y) {
      return y.base.y;
    }), h.defined(oN).curve(u), h(g);
  }
  return s === "vertical" && Ur(o) ? h = JB().y(fS).x1(dS).x0(o) : Ur(o) ? h = JB().x(dS).y1(fS).y0(o) : h = eut().x(dS).y(fS), h.defined(oN).curve(u), h(f);
}, Wb = function(e) {
  var r = e.className, n = e.points, a = e.path, i = e.pathRef;
  if ((!n || !n.length) && !a)
    return null;
  var o = n && n.length ? CNr(e) : a;
  return /* @__PURE__ */ Te.createElement("path", m0e({}, Un(e, !1), vj(e), {
    className: ti("recharts-curve", r),
    d: o,
    ref: i
  }));
}, sN = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var oae, uBe;
function wNr() {
  if (uBe) return oae;
  uBe = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return oae = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        e.call(s, f) && (l[f] = s[f]);
      if (t) {
        c = t(s);
        for (var h = 0; h < c.length; h++)
          r.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, oae;
}
var sae, dBe;
function Uye() {
  if (dBe) return sae;
  dBe = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return sae = t, sae;
}
var lae, fBe;
function i0t() {
  return fBe || (fBe = 1, lae = Function.call.bind(Object.prototype.hasOwnProperty)), lae;
}
var cae, hBe;
function SNr() {
  if (hBe) return cae;
  hBe = 1;
  var t = function() {
  };
  if (Qa.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ Uye(), r = {}, n = /* @__PURE__ */ i0t();
    t = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, l, c) {
    if (Qa.env.NODE_ENV !== "production") {
      for (var u in i)
        if (n(i, u)) {
          var f;
          try {
            if (typeof i[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[u](o, u, l, s, null, e);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && t(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            t(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    Qa.env.NODE_ENV !== "production" && (r = {});
  }, cae = a, cae;
}
var uae, pBe;
function _Nr() {
  if (pBe) return uae;
  pBe = 1;
  var t = rye(), e = wNr(), r = /* @__PURE__ */ Uye(), n = /* @__PURE__ */ i0t(), a = /* @__PURE__ */ SNr(), i = function() {
  };
  Qa.env.NODE_ENV !== "production" && (i = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return uae = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(F) {
      var z = F && (c && F[c] || F[u]);
      if (typeof z == "function")
        return z;
    }
    var h = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: _(),
      arrayOf: C,
      element: x(),
      elementType: S(),
      instanceOf: A,
      node: L(),
      objectOf: M,
      oneOf: I,
      oneOfType: B,
      shape: d,
      exact: m
    };
    function g(F, z) {
      return F === z ? F !== 0 || 1 / F === 1 / z : F !== F && z !== z;
    }
    function y(F, z) {
      this.message = F, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function b(F) {
      if (Qa.env.NODE_ENV !== "production")
        var z = {}, W = 0;
      function U(V, Y, ge, ce, ee, Se, Ce) {
        if (ce = ce || h, Se = Se || ge, Ce !== r) {
          if (l) {
            var we = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw we.name = "Invariant Violation", we;
          } else if (Qa.env.NODE_ENV !== "production" && typeof console < "u") {
            var We = ce + ":" + ge;
            !z[We] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Se + "` prop on `" + ce + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[We] = !0, W++);
          }
        }
        return Y[ge] == null ? V ? Y[ge] === null ? new y("The " + ee + " `" + Se + "` is marked as required " + ("in `" + ce + "`, but its value is `null`.")) : new y("The " + ee + " `" + Se + "` is marked as required in " + ("`" + ce + "`, but its value is `undefined`.")) : null : F(Y, ge, ce, ee, Se);
      }
      var Z = U.bind(null, !1);
      return Z.isRequired = U.bind(null, !0), Z;
    }
    function w(F) {
      function z(W, U, Z, V, Y, ge) {
        var ce = W[U], ee = O(ce);
        if (ee !== F) {
          var Se = G(ce);
          return new y(
            "Invalid " + V + " `" + Y + "` of type " + ("`" + Se + "` supplied to `" + Z + "`, expected ") + ("`" + F + "`."),
            { expectedType: F }
          );
        }
        return null;
      }
      return b(z);
    }
    function _() {
      return b(o);
    }
    function C(F) {
      function z(W, U, Z, V, Y) {
        if (typeof F != "function")
          return new y("Property `" + Y + "` of component `" + Z + "` has invalid PropType notation inside arrayOf.");
        var ge = W[U];
        if (!Array.isArray(ge)) {
          var ce = O(ge);
          return new y("Invalid " + V + " `" + Y + "` of type " + ("`" + ce + "` supplied to `" + Z + "`, expected an array."));
        }
        for (var ee = 0; ee < ge.length; ee++) {
          var Se = F(ge, ee, Z, V, Y + "[" + ee + "]", r);
          if (Se instanceof Error)
            return Se;
        }
        return null;
      }
      return b(z);
    }
    function x() {
      function F(z, W, U, Z, V) {
        var Y = z[W];
        if (!s(Y)) {
          var ge = O(Y);
          return new y("Invalid " + Z + " `" + V + "` of type " + ("`" + ge + "` supplied to `" + U + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(F);
    }
    function S() {
      function F(z, W, U, Z, V) {
        var Y = z[W];
        if (!t.isValidElementType(Y)) {
          var ge = O(Y);
          return new y("Invalid " + Z + " `" + V + "` of type " + ("`" + ge + "` supplied to `" + U + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(F);
    }
    function A(F) {
      function z(W, U, Z, V, Y) {
        if (!(W[U] instanceof F)) {
          var ge = F.name || h, ce = j(W[U]);
          return new y("Invalid " + V + " `" + Y + "` of type " + ("`" + ce + "` supplied to `" + Z + "`, expected ") + ("instance of `" + ge + "`."));
        }
        return null;
      }
      return b(z);
    }
    function I(F) {
      if (!Array.isArray(F))
        return Qa.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function z(W, U, Z, V, Y) {
        for (var ge = W[U], ce = 0; ce < F.length; ce++)
          if (g(ge, F[ce]))
            return null;
        var ee = JSON.stringify(F, function(Ce, we) {
          var We = G(we);
          return We === "symbol" ? String(we) : we;
        });
        return new y("Invalid " + V + " `" + Y + "` of value `" + String(ge) + "` " + ("supplied to `" + Z + "`, expected one of " + ee + "."));
      }
      return b(z);
    }
    function M(F) {
      function z(W, U, Z, V, Y) {
        if (typeof F != "function")
          return new y("Property `" + Y + "` of component `" + Z + "` has invalid PropType notation inside objectOf.");
        var ge = W[U], ce = O(ge);
        if (ce !== "object")
          return new y("Invalid " + V + " `" + Y + "` of type " + ("`" + ce + "` supplied to `" + Z + "`, expected an object."));
        for (var ee in ge)
          if (n(ge, ee)) {
            var Se = F(ge, ee, Z, V, Y + "." + ee, r);
            if (Se instanceof Error)
              return Se;
          }
        return null;
      }
      return b(z);
    }
    function B(F) {
      if (!Array.isArray(F))
        return Qa.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var z = 0; z < F.length; z++) {
        var W = F[z];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + H(W) + " at index " + z + "."
          ), o;
      }
      function U(Z, V, Y, ge, ce) {
        for (var ee = [], Se = 0; Se < F.length; Se++) {
          var Ce = F[Se], we = Ce(Z, V, Y, ge, ce, r);
          if (we == null)
            return null;
          we.data && n(we.data, "expectedType") && ee.push(we.data.expectedType);
        }
        var We = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new y("Invalid " + ge + " `" + ce + "` supplied to " + ("`" + Y + "`" + We + "."));
      }
      return b(U);
    }
    function L() {
      function F(z, W, U, Z, V) {
        return v(z[W]) ? null : new y("Invalid " + Z + " `" + V + "` supplied to " + ("`" + U + "`, expected a ReactNode."));
      }
      return b(F);
    }
    function N(F, z, W, U, Z) {
      return new y(
        (F || "React class") + ": " + z + " type `" + W + "." + U + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Z + "`."
      );
    }
    function d(F) {
      function z(W, U, Z, V, Y) {
        var ge = W[U], ce = O(ge);
        if (ce !== "object")
          return new y("Invalid " + V + " `" + Y + "` of type `" + ce + "` " + ("supplied to `" + Z + "`, expected `object`."));
        for (var ee in F) {
          var Se = F[ee];
          if (typeof Se != "function")
            return N(Z, V, Y, ee, G(Se));
          var Ce = Se(ge, ee, Z, V, Y + "." + ee, r);
          if (Ce)
            return Ce;
        }
        return null;
      }
      return b(z);
    }
    function m(F) {
      function z(W, U, Z, V, Y) {
        var ge = W[U], ce = O(ge);
        if (ce !== "object")
          return new y("Invalid " + V + " `" + Y + "` of type `" + ce + "` " + ("supplied to `" + Z + "`, expected `object`."));
        var ee = e({}, W[U], F);
        for (var Se in ee) {
          var Ce = F[Se];
          if (n(F, Se) && typeof Ce != "function")
            return N(Z, V, Y, Se, G(Ce));
          if (!Ce)
            return new y(
              "Invalid " + V + " `" + Y + "` key `" + Se + "` supplied to `" + Z + "`.\nBad object: " + JSON.stringify(W[U], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
            );
          var we = Ce(ge, Se, Z, V, Y + "." + Se, r);
          if (we)
            return we;
        }
        return null;
      }
      return b(z);
    }
    function v(F) {
      switch (typeof F) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !F;
        case "object":
          if (Array.isArray(F))
            return F.every(v);
          if (F === null || s(F))
            return !0;
          var z = f(F);
          if (z) {
            var W = z.call(F), U;
            if (z !== F.entries) {
              for (; !(U = W.next()).done; )
                if (!v(U.value))
                  return !1;
            } else
              for (; !(U = W.next()).done; ) {
                var Z = U.value;
                if (Z && !v(Z[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k(F, z) {
      return F === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function O(F) {
      var z = typeof F;
      return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : k(z, F) ? "symbol" : z;
    }
    function G(F) {
      if (typeof F > "u" || F === null)
        return "" + F;
      var z = O(F);
      if (z === "object") {
        if (F instanceof Date)
          return "date";
        if (F instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function H(F) {
      var z = G(F);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function j(F) {
      return !F.constructor || !F.constructor.name ? h : F.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, uae;
}
var dae, mBe;
function kNr() {
  if (mBe) return dae;
  mBe = 1;
  var t = /* @__PURE__ */ Uye();
  function e() {
  }
  function r() {
  }
  return r.resetWarningCache = e, dae = function() {
    function n(o, s, l, c, u, f) {
      if (f !== t) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, dae;
}
var gBe;
function ANr() {
  if (gBe) return sN.exports;
  if (gBe = 1, Qa.env.NODE_ENV !== "production") {
    var t = rye(), e = !0;
    sN.exports = /* @__PURE__ */ _Nr()(t.isElement, e);
  } else
    sN.exports = /* @__PURE__ */ kNr()();
  return sN.exports;
}
var TNr = /* @__PURE__ */ ANr();
const Io = /* @__PURE__ */ Gi(TNr);
function o0t(t) {
  return function(r, n, a, i, o, s, l) {
    return t(r, n, l);
  };
}
function lH(t) {
  return function(r, n, a, i) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return t(r, n, a, i);
    var o = i.get(r), s = i.get(n);
    if (o && s)
      return o === n && s === r;
    i.set(r, n), i.set(n, r);
    var l = t(r, n, a, i);
    return i.delete(r), i.delete(n), l;
  };
}
function s0t(t, e) {
  var r = {};
  for (var n in t)
    r[n] = t[n];
  for (var n in e)
    r[n] = e[n];
  return r;
}
function vBe(t) {
  return t.constructor === Object || t.constructor == null;
}
function yBe(t) {
  return typeof t.then == "function";
}
function cH(t, e) {
  return t === e || t !== t && e !== e;
}
var ENr = "[object Arguments]", INr = "[object Boolean]", MNr = "[object Date]", PNr = "[object RegExp]", RNr = "[object Map]", ONr = "[object Number]", BNr = "[object Object]", NNr = "[object Set]", $Nr = "[object String]", bBe = Object.prototype.toString;
function uH(t) {
  var e = t.areArraysEqual, r = t.areDatesEqual, n = t.areMapsEqual, a = t.areObjectsEqual, i = t.areRegExpsEqual, o = t.areSetsEqual, s = t.createIsNestedEqual, l = s(c);
  function c(u, f, h) {
    if (u === f)
      return !0;
    if (!u || !f || typeof u != "object" || typeof f != "object")
      return u !== u && f !== f;
    if (vBe(u) && vBe(f))
      return a(u, f, l, h);
    var p = Array.isArray(u), g = Array.isArray(f);
    if (p || g)
      return p === g && e(u, f, l, h);
    var y = bBe.call(u);
    return y !== bBe.call(f) ? !1 : y === MNr ? r(u, f, l, h) : y === PNr ? i(u, f, l, h) : y === RNr ? n(u, f, l, h) : y === NNr ? o(u, f, l, h) : y === BNr || y === ENr ? yBe(u) || yBe(f) ? !1 : a(u, f, l, h) : y === INr || y === ONr || y === $Nr ? cH(u.valueOf(), f.valueOf()) : !1;
  }
  return c;
}
function l0t(t, e, r, n) {
  var a = t.length;
  if (e.length !== a)
    return !1;
  for (; a-- > 0; )
    if (!r(t[a], e[a], a, a, t, e, n))
      return !1;
  return !0;
}
var DNr = lH(l0t);
function c0t(t, e) {
  return cH(t.valueOf(), e.valueOf());
}
function u0t(t, e, r, n) {
  var a = t.size === e.size;
  if (!a)
    return !1;
  if (!t.size)
    return !0;
  var i = {}, o = 0;
  return t.forEach(function(s, l) {
    if (a) {
      var c = !1, u = 0;
      e.forEach(function(f, h) {
        !c && !i[u] && (c = r(l, h, o, u, t, e, n) && r(s, f, l, h, t, e, n)) && (i[u] = !0), u++;
      }), o++, a = c;
    }
  }), a;
}
var LNr = lH(u0t), jNr = "_owner", FNr = Object.prototype.hasOwnProperty;
function d0t(t, e, r, n) {
  var a = Object.keys(t), i = a.length;
  if (Object.keys(e).length !== i)
    return !1;
  for (var o; i-- > 0; ) {
    if (o = a[i], o === jNr) {
      var s = !!t.$$typeof, l = !!e.$$typeof;
      if ((s || l) && s !== l)
        return !1;
    }
    if (!FNr.call(e, o) || !r(t[o], e[o], o, o, t, e, n))
      return !1;
  }
  return !0;
}
var zNr = lH(d0t);
function f0t(t, e) {
  return t.source === e.source && t.flags === e.flags;
}
function h0t(t, e, r, n) {
  var a = t.size === e.size;
  if (!a)
    return !1;
  if (!t.size)
    return !0;
  var i = {};
  return t.forEach(function(o, s) {
    if (a) {
      var l = !1, c = 0;
      e.forEach(function(u, f) {
        !l && !i[c] && (l = r(o, u, s, f, t, e, n)) && (i[c] = !0), c++;
      }), a = l;
    }
  }), a;
}
var GNr = lH(h0t), p0t = Object.freeze({
  areArraysEqual: l0t,
  areDatesEqual: c0t,
  areMapsEqual: u0t,
  areObjectsEqual: d0t,
  areRegExpsEqual: f0t,
  areSetsEqual: h0t,
  createIsNestedEqual: o0t
}), m0t = Object.freeze({
  areArraysEqual: DNr,
  areDatesEqual: c0t,
  areMapsEqual: LNr,
  areObjectsEqual: zNr,
  areRegExpsEqual: f0t,
  areSetsEqual: GNr,
  createIsNestedEqual: o0t
}), WNr = uH(p0t);
function HNr(t, e) {
  return WNr(t, e, void 0);
}
uH(s0t(p0t, { createIsNestedEqual: function() {
  return cH;
} }));
uH(m0t);
uH(s0t(m0t, {
  createIsNestedEqual: function() {
    return cH;
  }
}));
function UNr(t) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(t);
}
function xBe(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function a(i) {
    r < 0 && (r = i), i - r > e ? (t(i), r = -1) : UNr(a);
  };
  requestAnimationFrame(n);
}
function g0e(t) {
  "@babel/helpers - typeof";
  return g0e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, g0e(t);
}
function VNr(t) {
  return JNr(t) || ZNr(t) || KNr(t) || qNr();
}
function qNr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function KNr(t, e) {
  if (t) {
    if (typeof t == "string") return CBe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return CBe(t, e);
  }
}
function CBe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function ZNr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function JNr(t) {
  if (Array.isArray(t)) return t;
}
function YNr() {
  var t = {}, e = function() {
    return null;
  }, r = !1, n = function a(i) {
    if (!r) {
      if (Array.isArray(i)) {
        if (!i.length)
          return;
        var o = i, s = VNr(o), l = s[0], c = s.slice(1);
        if (typeof l == "number") {
          xBe(a.bind(null, c), l);
          return;
        }
        a(l), xBe(a.bind(null, c));
        return;
      }
      g0e(i) === "object" && (t = i, e(t)), typeof i == "function" && i();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(i) {
      r = !1, n(i);
    },
    subscribe: function(i) {
      return e = i, function() {
        e = function() {
          return null;
        };
      };
    }
  };
}
function HE(t) {
  "@babel/helpers - typeof";
  return HE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, HE(t);
}
function wBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function SBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wBe(Object(r), !0).forEach(function(n) {
      g0t(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function g0t(t, e, r) {
  return e = XNr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function XNr(t) {
  var e = QNr(t, "string");
  return HE(e) === "symbol" ? e : String(e);
}
function QNr(t, e) {
  if (HE(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (HE(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var e$r = function(e, r) {
  return [Object.keys(e), Object.keys(r)].reduce(function(n, a) {
    return n.filter(function(i) {
      return a.includes(i);
    });
  });
}, t$r = function(e) {
  return e;
}, r$r = function(e) {
  return e.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, U_ = function(e, r) {
  return Object.keys(r).reduce(function(n, a) {
    return SBe(SBe({}, n), {}, g0t({}, a, e(a, r[a])));
  }, {});
}, _Be = function(e, r, n) {
  return e.map(function(a) {
    return "".concat(r$r(a), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, n$r = Qa.env.NODE_ENV !== "production", Uj = function(e, r, n, a, i, o, s, l) {
  if (n$r && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, a, i, o, s, l], u = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[u++];
      }));
    }
};
function a$r(t, e) {
  return s$r(t) || o$r(t, e) || v0t(t, e) || i$r();
}
function i$r() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o$r(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function s$r(t) {
  if (Array.isArray(t)) return t;
}
function l$r(t) {
  return d$r(t) || u$r(t) || v0t(t) || c$r();
}
function c$r() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function v0t(t, e) {
  if (t) {
    if (typeof t == "string") return v0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return v0e(t, e);
  }
}
function u$r(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function d$r(t) {
  if (Array.isArray(t)) return v0e(t);
}
function v0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var Vj = 1e-4, y0t = function(e, r) {
  return [0, 3 * e, 3 * r - 6 * e, 3 * e - 3 * r + 1];
}, b0t = function(e, r) {
  return e.map(function(n, a) {
    return n * Math.pow(r, a);
  }).reduce(function(n, a) {
    return n + a;
  });
}, kBe = function(e, r) {
  return function(n) {
    var a = y0t(e, r);
    return b0t(a, n);
  };
}, f$r = function(e, r) {
  return function(n) {
    var a = y0t(e, r), i = [].concat(l$r(a.map(function(o, s) {
      return o * s;
    }).slice(1)), [0]);
    return b0t(i, n);
  };
}, ABe = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  var a = r[0], i = r[1], o = r[2], s = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        a = 0, i = 0, o = 1, s = 1;
        break;
      case "ease":
        a = 0.25, i = 0.1, o = 0.25, s = 1;
        break;
      case "ease-in":
        a = 0.42, i = 0, o = 1, s = 1;
        break;
      case "ease-out":
        a = 0.42, i = 0, o = 0.58, s = 1;
        break;
      case "ease-in-out":
        a = 0, i = 0, o = 0.58, s = 1;
        break;
      default: {
        var l = r[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(b) {
            return parseFloat(b);
          }), u = a$r(c, 4);
          a = u[0], i = u[1], o = u[2], s = u[3];
        } else
          Uj(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Uj([a, o, i, s].every(function(b) {
    return typeof b == "number" && b >= 0 && b <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = kBe(a, o), h = kBe(i, s), p = f$r(a, o), g = function(w) {
    return w > 1 ? 1 : w < 0 ? 0 : w;
  }, y = function(w) {
    for (var _ = w > 1 ? 1 : w, C = _, x = 0; x < 8; ++x) {
      var S = f(C) - _, A = p(C);
      if (Math.abs(S - _) < Vj || A < Vj)
        return h(C);
      C = g(C - S / A);
    }
    return h(C);
  };
  return y.isStepper = !1, y;
}, h$r = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.stiff, n = r === void 0 ? 100 : r, a = e.damping, i = a === void 0 ? 8 : a, o = e.dt, s = o === void 0 ? 17 : o, l = function(u, f, h) {
    var p = -(u - f) * n, g = h * i, y = h + (p - g) * s / 1e3, b = h * s / 1e3 + u;
    return Math.abs(b - f) < Vj && Math.abs(y) < Vj ? [f, 0] : [b, y];
  };
  return l.isStepper = !0, l.dt = s, l;
}, p$r = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  var a = r[0];
  if (typeof a == "string")
    switch (a) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return ABe(a);
      case "spring":
        return h$r();
      default:
        if (a.split("(")[0] === "cubic-bezier")
          return ABe(a);
        Uj(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof a == "function" ? a : (Uj(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function UE(t) {
  "@babel/helpers - typeof";
  return UE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, UE(t);
}
function TBe(t) {
  return v$r(t) || g$r(t) || x0t(t) || m$r();
}
function m$r() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g$r(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function v$r(t) {
  if (Array.isArray(t)) return b0e(t);
}
function EBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? EBe(Object(r), !0).forEach(function(n) {
      y0e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : EBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function y0e(t, e, r) {
  return e = y$r(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function y$r(t) {
  var e = b$r(t, "string");
  return UE(e) === "symbol" ? e : String(e);
}
function b$r(t, e) {
  if (UE(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (UE(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function x$r(t, e) {
  return S$r(t) || w$r(t, e) || x0t(t, e) || C$r();
}
function C$r() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x0t(t, e) {
  if (t) {
    if (typeof t == "string") return b0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return b0e(t, e);
  }
}
function b0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function w$r(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function S$r(t) {
  if (Array.isArray(t)) return t;
}
var qj = function(e, r, n) {
  return e + (r - e) * n;
}, x0e = function(e) {
  var r = e.from, n = e.to;
  return r !== n;
}, _$r = function t(e, r, n) {
  var a = U_(function(i, o) {
    if (x0e(o)) {
      var s = e(o.from, o.to, o.velocity), l = x$r(s, 2), c = l[0], u = l[1];
      return bc(bc({}, o), {}, {
        from: c,
        velocity: u
      });
    }
    return o;
  }, r);
  return n < 1 ? U_(function(i, o) {
    return x0e(o) ? bc(bc({}, o), {}, {
      velocity: qj(o.velocity, a[i].velocity, n),
      from: qj(o.from, a[i].from, n)
    }) : o;
  }, r) : t(e, a, n - 1);
};
const k$r = function(t, e, r, n, a) {
  var i = e$r(t, e), o = i.reduce(function(b, w) {
    return bc(bc({}, b), {}, y0e({}, w, [t[w], e[w]]));
  }, {}), s = i.reduce(function(b, w) {
    return bc(bc({}, b), {}, y0e({}, w, {
      from: t[w],
      velocity: 0,
      to: e[w]
    }));
  }, {}), l = -1, c, u, f = function() {
    return null;
  }, h = function() {
    return U_(function(w, _) {
      return _.from;
    }, s);
  }, p = function() {
    return !Object.values(s).filter(x0e).length;
  }, g = function(w) {
    c || (c = w);
    var _ = w - c, C = _ / r.dt;
    s = _$r(r, s, C), a(bc(bc(bc({}, t), e), h())), c = w, p() || (l = requestAnimationFrame(f));
  }, y = function(w) {
    u || (u = w);
    var _ = (w - u) / n, C = U_(function(S, A) {
      return qj.apply(void 0, TBe(A).concat([r(_)]));
    }, o);
    if (a(bc(bc(bc({}, t), e), C)), _ < 1)
      l = requestAnimationFrame(f);
    else {
      var x = U_(function(S, A) {
        return qj.apply(void 0, TBe(A).concat([r(1)]));
      }, o);
      a(bc(bc(bc({}, t), e), x));
    }
  };
  return f = r.isStepper ? g : y, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(l);
    };
  };
};
function Dx(t) {
  "@babel/helpers - typeof";
  return Dx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dx(t);
}
var A$r = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function T$r(t, e) {
  if (t == null) return {};
  var r = E$r(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function E$r(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function fae(t) {
  return R$r(t) || P$r(t) || M$r(t) || I$r();
}
function I$r() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M$r(t, e) {
  if (t) {
    if (typeof t == "string") return C0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return C0e(t, e);
  }
}
function P$r(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function R$r(t) {
  if (Array.isArray(t)) return C0e(t);
}
function C0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function IBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qf(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? IBe(Object(r), !0).forEach(function(n) {
      c_(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : IBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function c_(t, e, r) {
  return e = C0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function O$r(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function B$r(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, C0t(n.key), n);
  }
}
function N$r(t, e, r) {
  return e && B$r(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function C0t(t) {
  var e = $$r(t, "string");
  return Dx(e) === "symbol" ? e : String(e);
}
function $$r(t, e) {
  if (Dx(t) !== "object" || t === null) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Dx(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function D$r(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && w0e(t, e);
}
function w0e(t, e) {
  return w0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, w0e(t, e);
}
function L$r(t) {
  var e = j$r();
  return function() {
    var n = Kj(t), a;
    if (e) {
      var i = Kj(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return S0e(this, a);
  };
}
function S0e(t, e) {
  if (e && (Dx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _0e(t);
}
function _0e(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function j$r() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Kj(t) {
  return Kj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Kj(t);
}
var Y1 = /* @__PURE__ */ function(t) {
  D$r(r, t);
  var e = L$r(r);
  function r(n, a) {
    var i;
    O$r(this, r), i = e.call(this, n, a);
    var o = i.props, s = o.isActive, l = o.attributeName, c = o.from, u = o.to, f = o.steps, h = o.children, p = o.duration;
    if (i.handleStyleChange = i.handleStyleChange.bind(_0e(i)), i.changeStyle = i.changeStyle.bind(_0e(i)), !s || p <= 0)
      return i.state = {
        style: {}
      }, typeof h == "function" && (i.state = {
        style: u
      }), S0e(i);
    if (f && f.length)
      i.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof h == "function")
        return i.state = {
          style: c
        }, S0e(i);
      i.state = {
        style: l ? c_({}, l, c) : c
      };
    } else
      i.state = {
        style: {}
      };
    return i;
  }
  return N$r(r, [{
    key: "componentDidMount",
    value: function() {
      var a = this.props, i = a.isActive, o = a.canBegin;
      this.mounted = !0, !(!i || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(a) {
      var i = this.props, o = i.isActive, s = i.canBegin, l = i.attributeName, c = i.shouldReAnimate, u = i.to, f = i.from, h = this.state.style;
      if (s) {
        if (!o) {
          var p = {
            style: l ? c_({}, l, u) : u
          };
          this.state && h && (l && h[l] !== u || !l && h !== u) && this.setState(p);
          return;
        }
        if (!(HNr(a.to, u) && a.canBegin && a.isActive)) {
          var g = !a.canBegin || !a.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var y = g || c ? f : a.to;
          if (this.state && h) {
            var b = {
              style: l ? c_({}, l, y) : y
            };
            (l && h[l] !== y || !l && h !== y) && this.setState(b);
          }
          this.runAnimation(qf(qf({}, this.props), {}, {
            from: y,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var a = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), a && a();
    }
  }, {
    key: "handleStyleChange",
    value: function(a) {
      this.changeStyle(a);
    }
  }, {
    key: "changeStyle",
    value: function(a) {
      this.mounted && this.setState({
        style: a
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(a) {
      var i = this, o = a.from, s = a.to, l = a.duration, c = a.easing, u = a.begin, f = a.onAnimationEnd, h = a.onAnimationStart, p = k$r(o, s, p$r(c), l, this.changeStyle), g = function() {
        i.stopJSAnimation = p();
      };
      this.manager.start([h, u, g, l, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(a) {
      var i = this, o = a.steps, s = a.begin, l = a.onAnimationStart, c = o[0], u = c.style, f = c.duration, h = f === void 0 ? 0 : f, p = function(y, b, w) {
        if (w === 0)
          return y;
        var _ = b.duration, C = b.easing, x = C === void 0 ? "ease" : C, S = b.style, A = b.properties, I = b.onAnimationEnd, M = w > 0 ? o[w - 1] : b, B = A || Object.keys(S);
        if (typeof x == "function" || x === "spring")
          return [].concat(fae(y), [i.runJSAnimation.bind(i, {
            from: M.style,
            to: S,
            duration: _,
            easing: x
          }), _]);
        var L = _Be(B, _, x), N = qf(qf(qf({}, M.style), S), {}, {
          transition: L
        });
        return [].concat(fae(y), [N, _, I]).filter(t$r);
      };
      return this.manager.start([l].concat(fae(o.reduce(p, [u, Math.max(h, s)])), [a.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(a) {
      this.manager || (this.manager = YNr());
      var i = a.begin, o = a.duration, s = a.attributeName, l = a.to, c = a.easing, u = a.onAnimationStart, f = a.onAnimationEnd, h = a.steps, p = a.children, g = this.manager;
      if (this.unSubscribe = g.subscribe(this.handleStyleChange), typeof c == "function" || typeof p == "function" || c === "spring") {
        this.runJSAnimation(a);
        return;
      }
      if (h.length > 1) {
        this.runStepAnimation(a);
        return;
      }
      var y = s ? c_({}, s, l) : l, b = _Be(Object.keys(y), o, c);
      g.start([u, i, qf(qf({}, y), {}, {
        transition: b
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var a = this.props, i = a.children;
      a.begin;
      var o = a.duration;
      a.attributeName, a.easing;
      var s = a.isActive;
      a.steps, a.from, a.to, a.canBegin, a.onAnimationEnd, a.shouldReAnimate, a.onAnimationReStart;
      var l = T$r(a, A$r), c = Pv.count(i), u = this.state.style;
      if (typeof i == "function")
        return i(u);
      if (!s || c === 0 || o <= 0)
        return i;
      var f = function(p) {
        var g = p.props, y = g.style, b = y === void 0 ? {} : y, w = g.className, _ = /* @__PURE__ */ xl(p, qf(qf({}, l), {}, {
          style: qf(qf({}, b), u),
          className: w
        }));
        return _;
      };
      return c === 1 ? f(Pv.only(i)) : /* @__PURE__ */ Te.createElement("div", null, Pv.map(i, function(h) {
        return f(h);
      }));
    }
  }]), r;
}(g0);
Y1.displayName = "Animate";
Y1.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Y1.propTypes = {
  from: Io.oneOfType([Io.object, Io.string]),
  to: Io.oneOfType([Io.object, Io.string]),
  attributeName: Io.string,
  // animation duration
  duration: Io.number,
  begin: Io.number,
  easing: Io.oneOfType([Io.string, Io.func]),
  steps: Io.arrayOf(Io.shape({
    duration: Io.number.isRequired,
    style: Io.object.isRequired,
    easing: Io.oneOfType([Io.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), Io.func]),
    // transition css properties(dash case), optional
    properties: Io.arrayOf("string"),
    onAnimationEnd: Io.func
  })),
  children: Io.oneOfType([Io.node, Io.func]),
  isActive: Io.bool,
  canBegin: Io.bool,
  onAnimationEnd: Io.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: Io.bool,
  onAnimationStart: Io.func,
  onAnimationReStart: Io.func
};
function VE(t) {
  "@babel/helpers - typeof";
  return VE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, VE(t);
}
function Zj() {
  return Zj = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Zj.apply(this, arguments);
}
function F$r(t, e) {
  return H$r(t) || W$r(t, e) || G$r(t, e) || z$r();
}
function z$r() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function G$r(t, e) {
  if (t) {
    if (typeof t == "string") return MBe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return MBe(t, e);
  }
}
function MBe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function W$r(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function H$r(t) {
  if (Array.isArray(t)) return t;
}
function PBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function RBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? PBe(Object(r), !0).forEach(function(n) {
      U$r(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : PBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function U$r(t, e, r) {
  return e = V$r(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function V$r(t) {
  var e = q$r(t, "string");
  return VE(e) == "symbol" ? e : e + "";
}
function q$r(t, e) {
  if (VE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (VE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var OBe = function(e, r, n, a, i) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(a) / 2), s = a >= 0 ? 1 : -1, l = n >= 0 ? 1 : -1, c = a >= 0 && n >= 0 || a < 0 && n < 0 ? 1 : 0, u;
  if (o > 0 && i instanceof Array) {
    for (var f = [0, 0, 0, 0], h = 0, p = 4; h < p; h++)
      f[h] = i[h] > o ? o : i[h];
    u = "M".concat(e, ",").concat(r + s * f[0]), f[0] > 0 && (u += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(e + l * f[0], ",").concat(r)), u += "L ".concat(e + n - l * f[1], ",").concat(r), f[1] > 0 && (u += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(e + n, ",").concat(r + s * f[1])), u += "L ".concat(e + n, ",").concat(r + a - s * f[2]), f[2] > 0 && (u += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(e + n - l * f[2], ",").concat(r + a)), u += "L ".concat(e + l * f[3], ",").concat(r + a), f[3] > 0 && (u += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(e, ",").concat(r + a - s * f[3])), u += "Z";
  } else if (o > 0 && i === +i && i > 0) {
    var g = Math.min(o, i);
    u = "M ".concat(e, ",").concat(r + s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + l * g, ",").concat(r, `
            L `).concat(e + n - l * g, ",").concat(r, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + n, ",").concat(r + s * g, `
            L `).concat(e + n, ",").concat(r + a - s * g, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e + n - l * g, ",").concat(r + a, `
            L `).concat(e + l * g, ",").concat(r + a, `
            A `).concat(g, ",").concat(g, ",0,0,").concat(c, ",").concat(e, ",").concat(r + a - s * g, " Z");
  } else
    u = "M ".concat(e, ",").concat(r, " h ").concat(n, " v ").concat(a, " h ").concat(-n, " Z");
  return u;
}, K$r = function(e, r) {
  if (!e || !r)
    return !1;
  var n = e.x, a = e.y, i = r.x, o = r.y, s = r.width, l = r.height;
  if (Math.abs(s) > 0 && Math.abs(l) > 0) {
    var c = Math.min(i, i + s), u = Math.max(i, i + s), f = Math.min(o, o + l), h = Math.max(o, o + l);
    return n >= c && n <= u && a >= f && a <= h;
  }
  return !1;
}, Z$r = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Vye = function(e) {
  var r = RBe(RBe({}, Z$r), e), n = Zt(), a = Yt(-1), i = F$r(a, 2), o = i[0], s = i[1];
  Ut(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var x = n.current.getTotalLength();
        x && s(x);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.width, f = r.height, h = r.radius, p = r.className, g = r.animationEasing, y = r.animationDuration, b = r.animationBegin, w = r.isAnimationActive, _ = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || u === 0 || f === 0)
    return null;
  var C = ti("recharts-rectangle", p);
  return _ ? /* @__PURE__ */ Te.createElement(Y1, {
    canBegin: o > 0,
    from: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    to: {
      width: u,
      height: f,
      x: l,
      y: c
    },
    duration: y,
    animationEasing: g,
    isActive: _
  }, function(x) {
    var S = x.width, A = x.height, I = x.x, M = x.y;
    return /* @__PURE__ */ Te.createElement(Y1, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: b,
      duration: y,
      isActive: w,
      easing: g
    }, /* @__PURE__ */ Te.createElement("path", Zj({}, Un(r, !0), {
      className: C,
      d: OBe(I, M, S, A, h),
      ref: n
    })));
  }) : /* @__PURE__ */ Te.createElement("path", Zj({}, Un(r, !0), {
    className: C,
    d: OBe(l, c, u, f, h)
  }));
}, J$r = ["points", "className", "baseLinePoints", "connectNulls"];
function Z9() {
  return Z9 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Z9.apply(this, arguments);
}
function Y$r(t, e) {
  if (t == null) return {};
  var r = X$r(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function X$r(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function BBe(t) {
  return rDr(t) || tDr(t) || eDr(t) || Q$r();
}
function Q$r() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eDr(t, e) {
  if (t) {
    if (typeof t == "string") return k0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return k0e(t, e);
  }
}
function tDr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function rDr(t) {
  if (Array.isArray(t)) return k0e(t);
}
function k0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var NBe = function(e) {
  return e && e.x === +e.x && e.y === +e.y;
}, nDr = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return e.forEach(function(n) {
    NBe(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), NBe(e[0]) && r[r.length - 1].push(e[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, V_ = function(e, r) {
  var n = nDr(e);
  r && (n = [n.reduce(function(i, o) {
    return [].concat(BBe(i), BBe(o));
  }, [])]);
  var a = n.map(function(i) {
    return i.reduce(function(o, s, l) {
      return "".concat(o).concat(l === 0 ? "M" : "L").concat(s.x, ",").concat(s.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(a, "Z") : a;
}, aDr = function(e, r, n) {
  var a = V_(e, n);
  return "".concat(a.slice(-1) === "Z" ? a.slice(0, -1) : a, "L").concat(V_(r.reverse(), n).slice(1));
}, iDr = function(e) {
  var r = e.points, n = e.className, a = e.baseLinePoints, i = e.connectNulls, o = Y$r(e, J$r);
  if (!r || !r.length)
    return null;
  var s = ti("recharts-polygon", n);
  if (a && a.length) {
    var l = o.stroke && o.stroke !== "none", c = aDr(r, a, i);
    return /* @__PURE__ */ Te.createElement("g", {
      className: s
    }, /* @__PURE__ */ Te.createElement("path", Z9({}, Un(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), l ? /* @__PURE__ */ Te.createElement("path", Z9({}, Un(o, !0), {
      fill: "none",
      d: V_(r, i)
    })) : null, l ? /* @__PURE__ */ Te.createElement("path", Z9({}, Un(o, !0), {
      fill: "none",
      d: V_(a, i)
    })) : null);
  }
  var u = V_(r, i);
  return /* @__PURE__ */ Te.createElement("path", Z9({}, Un(o, !0), {
    fill: u.slice(-1) === "Z" ? o.fill : "none",
    className: s,
    d: u
  }));
};
function A0e() {
  return A0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, A0e.apply(this, arguments);
}
var tg = function(e) {
  var r = e.cx, n = e.cy, a = e.r, i = e.className, o = ti("recharts-dot", i);
  return r === +r && n === +n && a === +a ? /* @__PURE__ */ Te.createElement("circle", A0e({}, Un(e, !1), vj(e), {
    className: o,
    cx: r,
    cy: n,
    r: a
  })) : null;
};
function qE(t) {
  "@babel/helpers - typeof";
  return qE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qE(t);
}
var oDr = ["x", "y", "top", "left", "width", "height", "className"];
function T0e() {
  return T0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, T0e.apply(this, arguments);
}
function $Be(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function sDr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $Be(Object(r), !0).forEach(function(n) {
      lDr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $Be(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function lDr(t, e, r) {
  return e = cDr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cDr(t) {
  var e = uDr(t, "string");
  return qE(e) == "symbol" ? e : e + "";
}
function uDr(t, e) {
  if (qE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (qE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function dDr(t, e) {
  if (t == null) return {};
  var r = fDr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function fDr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var hDr = function(e, r, n, a, i, o) {
  return "M".concat(e, ",").concat(i, "v").concat(a, "M").concat(o, ",").concat(r, "h").concat(n);
}, pDr = function(e) {
  var r = e.x, n = r === void 0 ? 0 : r, a = e.y, i = a === void 0 ? 0 : a, o = e.top, s = o === void 0 ? 0 : o, l = e.left, c = l === void 0 ? 0 : l, u = e.width, f = u === void 0 ? 0 : u, h = e.height, p = h === void 0 ? 0 : h, g = e.className, y = dDr(e, oDr), b = sDr({
    x: n,
    y: i,
    top: s,
    left: c,
    width: f,
    height: p
  }, y);
  return !Ur(n) || !Ur(i) || !Ur(f) || !Ur(p) || !Ur(s) || !Ur(c) ? null : /* @__PURE__ */ Te.createElement("path", T0e({}, Un(b, !0), {
    className: ti("recharts-cross", g),
    d: hDr(n, i, f, p, s, c)
  }));
}, hae, DBe;
function mDr() {
  if (DBe) return hae;
  DBe = 1;
  var t = aH(), e = Tdt(), r = sp();
  function n(a, i) {
    return a && a.length ? t(a, r(i, 2), e) : void 0;
  }
  return hae = n, hae;
}
var gDr = mDr();
const vDr = /* @__PURE__ */ Gi(gDr);
var pae, LBe;
function yDr() {
  if (LBe) return pae;
  LBe = 1;
  var t = aH(), e = sp(), r = Edt();
  function n(a, i) {
    return a && a.length ? t(a, e(i, 2), r) : void 0;
  }
  return pae = n, pae;
}
var bDr = yDr();
const xDr = /* @__PURE__ */ Gi(bDr);
var CDr = ["cx", "cy", "angle", "ticks", "axisLine"], wDr = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function Lx(t) {
  "@babel/helpers - typeof";
  return Lx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Lx(t);
}
function q_() {
  return q_ = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, q_.apply(this, arguments);
}
function jBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function q3(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jBe(Object(r), !0).forEach(function(n) {
      dH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : jBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function FBe(t, e) {
  if (t == null) return {};
  var r = SDr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function SDr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function _Dr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function zBe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, S0t(n.key), n);
  }
}
function kDr(t, e, r) {
  return e && zBe(t.prototype, e), r && zBe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ADr(t, e, r) {
  return e = Jj(e), TDr(t, w0t() ? Reflect.construct(e, r || [], Jj(t).constructor) : e.apply(t, r));
}
function TDr(t, e) {
  if (e && (Lx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return EDr(t);
}
function EDr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function w0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (w0t = function() {
    return !!t;
  })();
}
function Jj(t) {
  return Jj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Jj(t);
}
function IDr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && E0e(t, e);
}
function E0e(t, e) {
  return E0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, E0e(t, e);
}
function dH(t, e, r) {
  return e = S0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function S0t(t) {
  var e = MDr(t, "string");
  return Lx(e) == "symbol" ? e : e + "";
}
function MDr(t, e) {
  if (Lx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Lx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var fH = /* @__PURE__ */ function(t) {
  function e() {
    return _Dr(this, e), ADr(this, e, arguments);
  }
  return IDr(e, t), kDr(e, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var a = n.coordinate, i = this.props, o = i.angle, s = i.cx, l = i.cy;
        return ls(s, l, a, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, a;
      switch (n) {
        case "left":
          a = "end";
          break;
        case "right":
          a = "start";
          break;
        default:
          a = "middle";
          break;
      }
      return a;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = vDr(s, function(u) {
        return u.coordinate || 0;
      }), c = xDr(s, function(u) {
        return u.coordinate || 0;
      });
      return {
        cx: a,
        cy: i,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: l.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.angle, s = n.ticks, l = n.axisLine, c = FBe(n, CDr), u = s.reduce(function(g, y) {
        return [Math.min(g[0], y.coordinate), Math.max(g[1], y.coordinate)];
      }, [1 / 0, -1 / 0]), f = ls(a, i, u[0], o), h = ls(a, i, u[1], o), p = q3(q3(q3({}, Un(c, !1)), {}, {
        fill: "none"
      }, Un(l, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: h.x,
        y2: h.y
      });
      return /* @__PURE__ */ Te.createElement("line", q_({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.angle, l = a.tickFormatter, c = a.stroke, u = FBe(a, wDr), f = this.getTickTextAnchor(), h = Un(u, !1), p = Un(o, !1), g = i.map(function(y, b) {
        var w = n.getTickValueCoord(y), _ = q3(q3(q3(q3({
          textAnchor: f,
          transform: "rotate(".concat(90 - s, ", ").concat(w.x, ", ").concat(w.y, ")")
        }, h), {}, {
          stroke: "none",
          fill: c
        }, p), {}, {
          index: b
        }, w), {}, {
          payload: y
        });
        return /* @__PURE__ */ Te.createElement(Fi, q_({
          className: ti("recharts-polar-radius-axis-tick", r0t(o)),
          key: "tick-".concat(y.coordinate)
        }, M5(n.props, y, b)), e.renderTickItem(o, _, l ? l(y.value, b) : y.value));
      });
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-polar-radius-axis-ticks"
      }, g);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.axisLine, o = n.tick;
      return !a || !a.length ? null : /* @__PURE__ */ Te.createElement(Fi, {
        className: ti("recharts-polar-radius-axis", this.props.className)
      }, i && this.renderAxisLine(), o && this.renderTicks(), Ss.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ Te.isValidElement(n) ? o = /* @__PURE__ */ Te.cloneElement(n, a) : ua(n) ? o = n(a) : o = /* @__PURE__ */ Te.createElement(P5, q_({}, a, {
        className: "recharts-polar-radius-axis-tick-value"
      }), i), o;
    }
  }]);
}(g0);
dH(fH, "displayName", "PolarRadiusAxis");
dH(fH, "axisType", "radiusAxis");
dH(fH, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function jx(t) {
  "@babel/helpers - typeof";
  return jx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jx(t);
}
function ib() {
  return ib = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, ib.apply(this, arguments);
}
function GBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function K3(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? GBe(Object(r), !0).forEach(function(n) {
      hH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : GBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function PDr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function WBe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, k0t(n.key), n);
  }
}
function RDr(t, e, r) {
  return e && WBe(t.prototype, e), r && WBe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ODr(t, e, r) {
  return e = Yj(e), BDr(t, _0t() ? Reflect.construct(e, r || [], Yj(t).constructor) : e.apply(t, r));
}
function BDr(t, e) {
  if (e && (jx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return NDr(t);
}
function NDr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function _0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_0t = function() {
    return !!t;
  })();
}
function Yj(t) {
  return Yj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Yj(t);
}
function $Dr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && I0e(t, e);
}
function I0e(t, e) {
  return I0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, I0e(t, e);
}
function hH(t, e, r) {
  return e = k0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function k0t(t) {
  var e = DDr(t, "string");
  return jx(e) == "symbol" ? e : e + "";
}
function DDr(t, e) {
  if (jx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (jx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var LDr = Math.PI / 180, jDr = 1e-5, pH = /* @__PURE__ */ function(t) {
  function e() {
    return PDr(this, e), ODr(this, e, arguments);
  }
  return $Dr(e, t), RDr(e, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var a = this.props, i = a.cx, o = a.cy, s = a.radius, l = a.orientation, c = a.tickSize, u = c || 8, f = ls(i, o, s, n.coordinate), h = ls(i, o, s + (l === "inner" ? -1 : 1) * u, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: h.x,
          y2: h.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var a = this.props.orientation, i = Math.cos(-n.coordinate * LDr), o;
      return i > jDr ? o = a === "outer" ? "start" : "end" : i < -1e-5 ? o = a === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.cx, i = n.cy, o = n.radius, s = n.axisLine, l = n.axisLineType, c = K3(K3({}, Un(this.props, !1)), {}, {
        fill: "none"
      }, Un(s, !1));
      if (l === "circle")
        return /* @__PURE__ */ Te.createElement(tg, ib({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: a,
          cy: i,
          r: o
        }));
      var u = this.props.ticks, f = u.map(function(h) {
        return ls(a, i, o, h.coordinate);
      });
      return /* @__PURE__ */ Te.createElement(iDr, ib({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, a = this.props, i = a.ticks, o = a.tick, s = a.tickLine, l = a.tickFormatter, c = a.stroke, u = Un(this.props, !1), f = Un(o, !1), h = K3(K3({}, u), {}, {
        fill: "none"
      }, Un(s, !1)), p = i.map(function(g, y) {
        var b = n.getTickLineCoord(g), w = n.getTickTextAnchor(g), _ = K3(K3(K3({
          textAnchor: w
        }, u), {}, {
          stroke: "none",
          fill: c
        }, f), {}, {
          index: y,
          payload: g,
          x: b.x2,
          y: b.y2
        });
        return /* @__PURE__ */ Te.createElement(Fi, ib({
          className: ti("recharts-polar-angle-axis-tick", r0t(o)),
          key: "tick-".concat(g.coordinate)
        }, M5(n.props, g, y)), s && /* @__PURE__ */ Te.createElement("line", ib({
          className: "recharts-polar-angle-axis-tick-line"
        }, h, b)), o && e.renderTickItem(o, _, l ? l(g.value, y) : g.value));
      });
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.ticks, i = n.radius, o = n.axisLine;
      return i <= 0 || !a || !a.length ? null : /* @__PURE__ */ Te.createElement(Fi, {
        className: ti("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ Te.isValidElement(n) ? o = /* @__PURE__ */ Te.cloneElement(n, a) : ua(n) ? o = n(a) : o = /* @__PURE__ */ Te.createElement(P5, ib({}, a, {
        className: "recharts-polar-angle-axis-tick-value"
      }), i), o;
    }
  }]);
}(g0);
hH(pH, "displayName", "PolarAngleAxis");
hH(pH, "axisType", "angleAxis");
hH(pH, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var mae, HBe;
function FDr() {
  if (HBe) return mae;
  HBe = 1;
  var t = Sut(), e = t(Object.getPrototypeOf, Object);
  return mae = e, mae;
}
var gae, UBe;
function zDr() {
  if (UBe) return gae;
  UBe = 1;
  var t = yg(), e = FDr(), r = bg(), n = "[object Object]", a = Function.prototype, i = Object.prototype, o = a.toString, s = i.hasOwnProperty, l = o.call(Object);
  function c(u) {
    if (!r(u) || t(u) != n)
      return !1;
    var f = e(u);
    if (f === null)
      return !0;
    var h = s.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && o.call(h) == l;
  }
  return gae = c, gae;
}
var GDr = zDr();
const WDr = /* @__PURE__ */ Gi(GDr);
var vae, VBe;
function HDr() {
  if (VBe) return vae;
  VBe = 1;
  var t = yg(), e = bg(), r = "[object Boolean]";
  function n(a) {
    return a === !0 || a === !1 || e(a) && t(a) == r;
  }
  return vae = n, vae;
}
var UDr = HDr();
const VDr = /* @__PURE__ */ Gi(UDr);
function KE(t) {
  "@babel/helpers - typeof";
  return KE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, KE(t);
}
function Xj() {
  return Xj = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Xj.apply(this, arguments);
}
function qDr(t, e) {
  return YDr(t) || JDr(t, e) || ZDr(t, e) || KDr();
}
function KDr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ZDr(t, e) {
  if (t) {
    if (typeof t == "string") return qBe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qBe(t, e);
  }
}
function qBe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function JDr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function YDr(t) {
  if (Array.isArray(t)) return t;
}
function KBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ZBe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? KBe(Object(r), !0).forEach(function(n) {
      XDr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : KBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function XDr(t, e, r) {
  return e = QDr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function QDr(t) {
  var e = eLr(t, "string");
  return KE(e) == "symbol" ? e : e + "";
}
function eLr(t, e) {
  if (KE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (KE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var JBe = function(e, r, n, a, i) {
  var o = n - a, s;
  return s = "M ".concat(e, ",").concat(r), s += "L ".concat(e + n, ",").concat(r), s += "L ".concat(e + n - o / 2, ",").concat(r + i), s += "L ".concat(e + n - o / 2 - a, ",").concat(r + i), s += "L ".concat(e, ",").concat(r, " Z"), s;
}, tLr = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, rLr = function(e) {
  var r = ZBe(ZBe({}, tLr), e), n = Zt(), a = Yt(-1), i = qDr(a, 2), o = i[0], s = i[1];
  Ut(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var C = n.current.getTotalLength();
        C && s(C);
      } catch {
      }
  }, []);
  var l = r.x, c = r.y, u = r.upperWidth, f = r.lowerWidth, h = r.height, p = r.className, g = r.animationEasing, y = r.animationDuration, b = r.animationBegin, w = r.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || f !== +f || h !== +h || u === 0 && f === 0 || h === 0)
    return null;
  var _ = ti("recharts-trapezoid", p);
  return w ? /* @__PURE__ */ Te.createElement(Y1, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: h,
      x: l,
      y: c
    },
    to: {
      upperWidth: u,
      lowerWidth: f,
      height: h,
      x: l,
      y: c
    },
    duration: y,
    animationEasing: g,
    isActive: w
  }, function(C) {
    var x = C.upperWidth, S = C.lowerWidth, A = C.height, I = C.x, M = C.y;
    return /* @__PURE__ */ Te.createElement(Y1, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: b,
      duration: y,
      easing: g
    }, /* @__PURE__ */ Te.createElement("path", Xj({}, Un(r, !0), {
      className: _,
      d: JBe(I, M, x, S, A),
      ref: n
    })));
  }) : /* @__PURE__ */ Te.createElement("g", null, /* @__PURE__ */ Te.createElement("path", Xj({}, Un(r, !0), {
    className: _,
    d: JBe(l, c, u, f, h)
  })));
}, nLr = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function ZE(t) {
  "@babel/helpers - typeof";
  return ZE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ZE(t);
}
function aLr(t, e) {
  if (t == null) return {};
  var r = iLr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function iLr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function YBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qj(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? YBe(Object(r), !0).forEach(function(n) {
      oLr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : YBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function oLr(t, e, r) {
  return e = sLr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function sLr(t) {
  var e = lLr(t, "string");
  return ZE(e) == "symbol" ? e : e + "";
}
function lLr(t, e) {
  if (ZE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (ZE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function cLr(t, e) {
  return Qj(Qj({}, e), t);
}
function uLr(t, e) {
  return t === "symbols";
}
function XBe(t) {
  var e = t.shapeType, r = t.elementProps;
  switch (e) {
    case "rectangle":
      return /* @__PURE__ */ Te.createElement(Vye, r);
    case "trapezoid":
      return /* @__PURE__ */ Te.createElement(rLr, r);
    case "sector":
      return /* @__PURE__ */ Te.createElement(Hye, r);
    case "symbols":
      if (uLr(e))
        return /* @__PURE__ */ Te.createElement(lye, r);
      break;
    default:
      return null;
  }
}
function dLr(t) {
  return /* @__PURE__ */ ef(t) ? t.props : t;
}
function A0t(t) {
  var e = t.option, r = t.shapeType, n = t.propTransformer, a = n === void 0 ? cLr : n, i = t.activeClassName, o = i === void 0 ? "recharts-active-shape" : i, s = t.isActive, l = aLr(t, nLr), c;
  if (/* @__PURE__ */ ef(e))
    c = /* @__PURE__ */ xl(e, Qj(Qj({}, l), dLr(e)));
  else if (ua(e))
    c = e(l);
  else if (WDr(e) && !VDr(e)) {
    var u = a(e, l);
    c = /* @__PURE__ */ Te.createElement(XBe, {
      shapeType: r,
      elementProps: u
    });
  } else {
    var f = l;
    c = /* @__PURE__ */ Te.createElement(XBe, {
      shapeType: r,
      elementProps: f
    });
  }
  return s ? /* @__PURE__ */ Te.createElement(Fi, {
    className: o
  }, c) : c;
}
function mH(t, e) {
  return e != null && "trapezoids" in t.props;
}
function gH(t, e) {
  return e != null && "sectors" in t.props;
}
function JE(t, e) {
  return e != null && "points" in t.props;
}
function fLr(t, e) {
  var r, n, a = t.x === (e == null || (r = e.labelViewBox) === null || r === void 0 ? void 0 : r.x) || t.x === e.x, i = t.y === (e == null || (n = e.labelViewBox) === null || n === void 0 ? void 0 : n.y) || t.y === e.y;
  return a && i;
}
function hLr(t, e) {
  var r = t.endAngle === e.endAngle, n = t.startAngle === e.startAngle;
  return r && n;
}
function pLr(t, e) {
  var r = t.x === e.x, n = t.y === e.y, a = t.z === e.z;
  return r && n && a;
}
function mLr(t, e) {
  var r;
  return mH(t, e) ? r = fLr : gH(t, e) ? r = hLr : JE(t, e) && (r = pLr), r;
}
function gLr(t, e) {
  var r;
  return mH(t, e) ? r = "trapezoids" : gH(t, e) ? r = "sectors" : JE(t, e) && (r = "points"), r;
}
function vLr(t, e) {
  if (mH(t, e)) {
    var r;
    return (r = e.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (gH(t, e)) {
    var n;
    return (n = e.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return JE(t, e) ? e.payload : {};
}
function yLr(t) {
  var e = t.activeTooltipItem, r = t.graphicalItem, n = t.itemData, a = gLr(r, e), i = vLr(r, e), o = n.filter(function(l, c) {
    var u = O5(i, l), f = r.props[a].filter(function(g) {
      var y = mLr(r, e);
      return y(g, e);
    }), h = r.props[a].indexOf(f[f.length - 1]), p = c === h;
    return u && p;
  }), s = n.indexOf(o[o.length - 1]);
  return s;
}
var T$;
function Fx(t) {
  "@babel/helpers - typeof";
  return Fx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Fx(t);
}
function J9() {
  return J9 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, J9.apply(this, arguments);
}
function QBe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function es(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? QBe(Object(r), !0).forEach(function(n) {
      Z0(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : QBe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function bLr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function eNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, E0t(n.key), n);
  }
}
function xLr(t, e, r) {
  return e && eNe(t.prototype, e), r && eNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function CLr(t, e, r) {
  return e = eF(e), wLr(t, T0t() ? Reflect.construct(e, r || [], eF(t).constructor) : e.apply(t, r));
}
function wLr(t, e) {
  if (e && (Fx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return SLr(t);
}
function SLr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function T0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (T0t = function() {
    return !!t;
  })();
}
function eF(t) {
  return eF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, eF(t);
}
function _Lr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && M0e(t, e);
}
function M0e(t, e) {
  return M0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, M0e(t, e);
}
function Z0(t, e, r) {
  return e = E0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function E0t(t) {
  var e = kLr(t, "string");
  return Fx(e) == "symbol" ? e : e + "";
}
function kLr(t, e) {
  if (Fx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Fx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Cg = /* @__PURE__ */ function(t) {
  function e(r) {
    var n;
    return bLr(this, e), n = CLr(this, e, [r]), Z0(n, "pieRef", null), Z0(n, "sectorRefs", []), Z0(n, "id", b6("recharts-pie-")), Z0(n, "handleAnimationEnd", function() {
      var a = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), ua(a) && a();
    }), Z0(n, "handleAnimationStart", function() {
      var a = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), ua(a) && a();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return _Lr(e, t), xLr(e, [{
    key: "isActiveIndex",
    value: function(n) {
      var a = this.props.activeIndex;
      return Array.isArray(a) ? a.indexOf(n) !== -1 : n === a;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var a = this.props.isAnimationActive;
      if (a && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.label, s = i.labelLine, l = i.dataKey, c = i.valueKey, u = Un(this.props, !1), f = Un(o, !1), h = Un(s, !1), p = o && o.offsetRadius || 20, g = n.map(function(y, b) {
        var w = (y.startAngle + y.endAngle) / 2, _ = ls(y.cx, y.cy, y.outerRadius + p, w), C = es(es(es(es({}, u), y), {}, {
          stroke: "none"
        }, f), {}, {
          index: b,
          textAnchor: e.getTextAnchor(_.x, y.cx)
        }, _), x = es(es(es(es({}, u), y), {}, {
          fill: "none",
          stroke: y.fill
        }, h), {}, {
          index: b,
          points: [ls(y.cx, y.cy, y.outerRadius, w), _]
        }), S = l;
        return Va(l) && Va(c) ? S = "value" : Va(l) && (S = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ Te.createElement(Fi, {
          key: "label-".concat(y.startAngle, "-").concat(y.endAngle, "-").concat(y.midAngle, "-").concat(b)
        }, s && e.renderLabelLineItem(s, x, "line"), e.renderLabelItem(o, C, ll(y, S)));
      });
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-pie-labels"
      }, g);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.activeShape, s = i.blendStroke, l = i.inactiveShape;
      return n.map(function(c, u) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && n.length !== 1) return null;
        var f = a.isActiveIndex(u), h = l && a.hasActiveIndex() ? l : null, p = f ? o : h, g = es(es({}, c), {}, {
          stroke: s ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ Te.createElement(Fi, J9({
          ref: function(b) {
            b && !a.sectorRefs.includes(b) && a.sectorRefs.push(b);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, M5(a.props, c, u), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(u)
        }), /* @__PURE__ */ Te.createElement(A0t, J9({
          option: p,
          isActive: f,
          shapeType: "sector"
        }, g)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.sectors, o = a.isAnimationActive, s = a.animationBegin, l = a.animationDuration, c = a.animationEasing, u = a.animationId, f = this.state, h = f.prevSectors, p = f.prevIsAnimationActive;
      return /* @__PURE__ */ Te.createElement(Y1, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(u, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(g) {
        var y = g.t, b = [], w = i && i[0], _ = w.startAngle;
        return i.forEach(function(C, x) {
          var S = h && h[x], A = x > 0 ? u0(C, "paddingAngle", 0) : 0;
          if (S) {
            var I = Gl(S.endAngle - S.startAngle, C.endAngle - C.startAngle), M = es(es({}, C), {}, {
              startAngle: _ + A,
              endAngle: _ + I(y) + A
            });
            b.push(M), _ = M.endAngle;
          } else {
            var B = C.endAngle, L = C.startAngle, N = Gl(0, B - L), d = N(y), m = es(es({}, C), {}, {
              startAngle: _ + A,
              endAngle: _ + d + A
            });
            b.push(m), _ = m.endAngle;
          }
        }), /* @__PURE__ */ Te.createElement(Fi, null, n.renderSectorsStatically(b));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var a = this;
      n.onkeydown = function(i) {
        if (!i.altKey)
          switch (i.key) {
            case "ArrowLeft": {
              var o = ++a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[o].focus(), a.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var s = --a.state.sectorToFocus < 0 ? a.sectorRefs.length - 1 : a.state.sectorToFocus % a.sectorRefs.length;
              a.sectorRefs[s].focus(), a.setState({
                sectorToFocus: s
              });
              break;
            }
            case "Escape": {
              a.sectorRefs[a.state.sectorToFocus].blur(), a.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, a = n.sectors, i = n.isAnimationActive, o = this.state.prevSectors;
      return i && a && a.length && (!o || !O5(o, a)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(a);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.hide, o = a.sectors, s = a.className, l = a.label, c = a.cx, u = a.cy, f = a.innerRadius, h = a.outerRadius, p = a.isAnimationActive, g = this.state.isAnimationFinished;
      if (i || !o || !o.length || !Ur(c) || !Ur(u) || !Ur(f) || !Ur(h))
        return null;
      var y = ti("recharts-pie", s);
      return /* @__PURE__ */ Te.createElement(Fi, {
        tabIndex: this.props.rootTabIndex,
        className: y,
        ref: function(w) {
          n.pieRef = w;
        }
      }, this.renderSectors(), l && this.renderLabels(o), Ss.renderCallByParent(this.props, null, !1), (!p || g) && kh.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return a.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: a.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== a.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, a) {
      return n > a ? "start" : n < a ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ Te.isValidElement(n))
        return /* @__PURE__ */ Te.cloneElement(n, a);
      if (ua(n))
        return n(a);
      var o = ti("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ Te.createElement(Wb, J9({}, a, {
        key: i,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, a, i) {
      if (/* @__PURE__ */ Te.isValidElement(n))
        return /* @__PURE__ */ Te.cloneElement(n, a);
      var o = i;
      if (ua(n) && (o = n(a), /* @__PURE__ */ Te.isValidElement(o)))
        return o;
      var s = ti("recharts-pie-label-text", typeof n != "boolean" && !ua(n) ? n.className : "");
      return /* @__PURE__ */ Te.createElement(P5, J9({}, a, {
        alignmentBaseline: "middle",
        className: s
      }), o);
    }
  }]);
}(g0);
T$ = Cg;
Z0(Cg, "displayName", "Pie");
Z0(Cg, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Jy.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
Z0(Cg, "parseDeltaAngle", function(t, e) {
  var r = Su(e - t), n = Math.min(Math.abs(e - t), 360);
  return r * n;
});
Z0(Cg, "getRealPieData", function(t) {
  var e = t.data, r = t.children, n = Un(t, !1), a = d0(r, yye);
  return e && e.length ? e.map(function(i, o) {
    return es(es(es({
      payload: i
    }, n), i), a && a[o] && a[o].props);
  }) : a && a.length ? a.map(function(i) {
    return es(es({}, n), i.props);
  }) : [];
});
Z0(Cg, "parseCoordinateOfPie", function(t, e) {
  var r = e.top, n = e.left, a = e.width, i = e.height, o = t0t(a, i), s = n + _u(t.cx, a, a / 2), l = r + _u(t.cy, i, i / 2), c = _u(t.innerRadius, o, 0), u = _u(t.outerRadius, o, o * 0.8), f = t.maxRadius || Math.sqrt(a * a + i * i) / 2;
  return {
    cx: s,
    cy: l,
    innerRadius: c,
    outerRadius: u,
    maxRadius: f
  };
});
Z0(Cg, "getComposedData", function(t) {
  var e = t.item, r = t.offset, n = e.type.defaultProps !== void 0 ? es(es({}, e.type.defaultProps), e.props) : e.props, a = T$.getRealPieData(n);
  if (!a || !a.length)
    return null;
  var i = n.cornerRadius, o = n.startAngle, s = n.endAngle, l = n.paddingAngle, c = n.dataKey, u = n.nameKey, f = n.valueKey, h = n.tooltipType, p = Math.abs(n.minAngle), g = T$.parseCoordinateOfPie(n, r), y = T$.parseDeltaAngle(o, s), b = Math.abs(y), w = c;
  Va(c) && Va(f) ? (O1(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), w = "value") : Va(c) && (O1(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), w = f);
  var _ = a.filter(function(M) {
    return ll(M, w, 0) !== 0;
  }).length, C = (b >= 360 ? _ : _ - 1) * l, x = b - _ * p - C, S = a.reduce(function(M, B) {
    var L = ll(B, w, 0);
    return M + (Ur(L) ? L : 0);
  }, 0), A;
  if (S > 0) {
    var I;
    A = a.map(function(M, B) {
      var L = ll(M, w, 0), N = ll(M, u, B), d = (Ur(L) ? L : 0) / S, m;
      B ? m = I.endAngle + Su(y) * l * (L !== 0 ? 1 : 0) : m = o;
      var v = m + Su(y) * ((L !== 0 ? p : 0) + d * x), k = (m + v) / 2, O = (g.innerRadius + g.outerRadius) / 2, G = [{
        name: N,
        value: L,
        payload: M,
        dataKey: w,
        type: h
      }], H = ls(g.cx, g.cy, O, k);
      return I = es(es(es({
        percent: d,
        cornerRadius: i,
        name: N,
        tooltipPayload: G,
        midAngle: k,
        middleRadius: O,
        tooltipPosition: H
      }, M), g), {}, {
        value: ll(M, w),
        startAngle: m,
        endAngle: v,
        payload: M,
        paddingAngle: Su(y) * l
      }), I;
    });
  }
  return es(es({}, g), {}, {
    sectors: A,
    data: a
  });
});
var yae, tNe;
function ALr() {
  if (tNe) return yae;
  tNe = 1;
  var t = Math.ceil, e = Math.max;
  function r(n, a, i, o) {
    for (var s = -1, l = e(t((a - n) / (i || 1)), 0), c = Array(l); l--; )
      c[o ? l : ++s] = n, n += i;
    return c;
  }
  return yae = r, yae;
}
var bae, rNe;
function I0t() {
  if (rNe) return bae;
  rNe = 1;
  var t = jut(), e = 1 / 0, r = 17976931348623157e292;
  function n(a) {
    if (!a)
      return a === 0 ? a : 0;
    if (a = t(a), a === e || a === -1 / 0) {
      var i = a < 0 ? -1 : 1;
      return i * r;
    }
    return a === a ? a : 0;
  }
  return bae = n, bae;
}
var xae, nNe;
function TLr() {
  if (nNe) return xae;
  nNe = 1;
  var t = ALr(), e = JW(), r = I0t();
  function n(a) {
    return function(i, o, s) {
      return s && typeof s != "number" && e(i, o, s) && (o = s = void 0), i = r(i), o === void 0 ? (o = i, i = 0) : o = r(o), s = s === void 0 ? i < o ? 1 : -1 : r(s), t(i, o, s, a);
    };
  }
  return xae = n, xae;
}
var Cae, aNe;
function ELr() {
  if (aNe) return Cae;
  aNe = 1;
  var t = TLr(), e = t();
  return Cae = e, Cae;
}
var ILr = ELr();
const tF = /* @__PURE__ */ Gi(ILr);
function YE(t) {
  "@babel/helpers - typeof";
  return YE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, YE(t);
}
function iNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function oNe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? iNe(Object(r), !0).forEach(function(n) {
      M0t(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : iNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function M0t(t, e, r) {
  return e = MLr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function MLr(t) {
  var e = PLr(t, "string");
  return YE(e) == "symbol" ? e : e + "";
}
function PLr(t, e) {
  if (YE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (YE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var RLr = ["Webkit", "Moz", "O", "ms"], OLr = function(e, r) {
  var n = e.replace(/(\w)/, function(i) {
    return i.toUpperCase();
  }), a = RLr.reduce(function(i, o) {
    return oNe(oNe({}, i), {}, M0t({}, o + n, r));
  }, {});
  return a[e] = r, a;
};
function zx(t) {
  "@babel/helpers - typeof";
  return zx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zx(t);
}
function rF() {
  return rF = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, rF.apply(this, arguments);
}
function sNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wae(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sNe(Object(r), !0).forEach(function(n) {
      qd(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function BLr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function lNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, R0t(n.key), n);
  }
}
function NLr(t, e, r) {
  return e && lNe(t.prototype, e), r && lNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function $Lr(t, e, r) {
  return e = nF(e), DLr(t, P0t() ? Reflect.construct(e, r || [], nF(t).constructor) : e.apply(t, r));
}
function DLr(t, e) {
  if (e && (zx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return LLr(t);
}
function LLr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function P0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (P0t = function() {
    return !!t;
  })();
}
function nF(t) {
  return nF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, nF(t);
}
function jLr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && P0e(t, e);
}
function P0e(t, e) {
  return P0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, P0e(t, e);
}
function qd(t, e, r) {
  return e = R0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function R0t(t) {
  var e = FLr(t, "string");
  return zx(e) == "symbol" ? e : e + "";
}
function FLr(t, e) {
  if (zx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (zx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var zLr = function(e) {
  var r = e.data, n = e.startIndex, a = e.endIndex, i = e.x, o = e.width, s = e.travellerWidth;
  if (!r || !r.length)
    return {};
  var l = r.length, c = W_().domain(tF(0, l)).range([i, i + o - s]), u = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(a),
    scale: c,
    scaleValues: u
  };
}, cNe = function(e) {
  return e.changedTouches && !!e.changedTouches.length;
}, Gx = /* @__PURE__ */ function(t) {
  function e(r) {
    var n;
    return BLr(this, e), n = $Lr(this, e, [r]), qd(n, "handleDrag", function(a) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(a) : n.state.isSlideMoving && n.handleSlideDrag(a);
    }), qd(n, "handleTouchMove", function(a) {
      a.changedTouches != null && a.changedTouches.length > 0 && n.handleDrag(a.changedTouches[0]);
    }), qd(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var a = n.props, i = a.endIndex, o = a.onDragEnd, s = a.startIndex;
        o == null || o({
          endIndex: i,
          startIndex: s
        });
      }), n.detachDragEndListener();
    }), qd(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), qd(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), qd(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), qd(n, "handleSlideDragStart", function(a) {
      var i = cNe(a) ? a.changedTouches[0] : a;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: i.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return jLr(e, t), NLr(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var a = n.startX, i = n.endX, o = this.state.scaleValues, s = this.props, l = s.gap, c = s.data, u = c.length - 1, f = Math.min(a, i), h = Math.max(a, i), p = e.getIndexInRange(o, f), g = e.getIndexInRange(o, h);
      return {
        startIndex: p - p % l,
        endIndex: g === u ? u : g - g % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var a = this.props, i = a.data, o = a.tickFormatter, s = a.dataKey, l = ll(i[n], s, n);
      return ua(o) ? o(l, n) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var a = this.state, i = a.slideMoveStartX, o = a.startX, s = a.endX, l = this.props, c = l.x, u = l.width, f = l.travellerWidth, h = l.startIndex, p = l.endIndex, g = l.onChange, y = n.pageX - i;
      y > 0 ? y = Math.min(y, c + u - f - s, c + u - f - o) : y < 0 && (y = Math.max(y, c - o, c - s));
      var b = this.getIndex({
        startX: o + y,
        endX: s + y
      });
      (b.startIndex !== h || b.endIndex !== p) && g && g(b), this.setState({
        startX: o + y,
        endX: s + y,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, a) {
      var i = cNe(a) ? a.changedTouches[0] : a;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: i.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var a = this.state, i = a.brushMoveStartX, o = a.movingTravellerId, s = a.endX, l = a.startX, c = this.state[o], u = this.props, f = u.x, h = u.width, p = u.travellerWidth, g = u.onChange, y = u.gap, b = u.data, w = {
        startX: this.state.startX,
        endX: this.state.endX
      }, _ = n.pageX - i;
      _ > 0 ? _ = Math.min(_, f + h - p - c) : _ < 0 && (_ = Math.max(_, f - c)), w[o] = c + _;
      var C = this.getIndex(w), x = C.startIndex, S = C.endIndex, A = function() {
        var M = b.length - 1;
        return o === "startX" && (s > l ? x % y === 0 : S % y === 0) || s < l && S === M || o === "endX" && (s > l ? S % y === 0 : x % y === 0) || s > l && S === M;
      };
      this.setState(qd(qd({}, o, c + _), "brushMoveStartX", n.pageX), function() {
        g && A() && g(C);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, a) {
      var i = this, o = this.state, s = o.scaleValues, l = o.startX, c = o.endX, u = this.state[a], f = s.indexOf(u);
      if (f !== -1) {
        var h = f + n;
        if (!(h === -1 || h >= s.length)) {
          var p = s[h];
          a === "startX" && p >= c || a === "endX" && p <= l || this.setState(qd({}, a, p), function() {
            i.props.onChange(i.getIndex({
              startX: i.state.startX,
              endX: i.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.fill, c = n.stroke;
      return /* @__PURE__ */ Te.createElement("rect", {
        stroke: c,
        fill: l,
        x: a,
        y: i,
        width: o,
        height: s
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.data, c = n.children, u = n.padding, f = Pv.only(c);
      return f ? /* @__PURE__ */ Te.cloneElement(f, {
        x: a,
        y: i,
        width: o,
        height: s,
        margin: u,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, a) {
      var i, o, s = this, l = this.props, c = l.y, u = l.travellerWidth, f = l.height, h = l.traveller, p = l.ariaLabel, g = l.data, y = l.startIndex, b = l.endIndex, w = Math.max(n, this.props.x), _ = wae(wae({}, Un(this.props, !1)), {}, {
        x: w,
        y: c,
        width: u,
        height: f
      }), C = p || "Min value: ".concat((i = g[y]) === null || i === void 0 ? void 0 : i.name, ", Max value: ").concat((o = g[b]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ Te.createElement(Fi, {
        tabIndex: 0,
        role: "slider",
        "aria-label": C,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[a],
        onTouchStart: this.travellerDragStartHandlers[a],
        onKeyDown: function(S) {
          ["ArrowLeft", "ArrowRight"].includes(S.key) && (S.preventDefault(), S.stopPropagation(), s.handleTravellerMoveKeyboard(S.key === "ArrowRight" ? 1 : -1, a));
        },
        onFocus: function() {
          s.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          s.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, e.renderTraveller(h, _));
    }
  }, {
    key: "renderSlide",
    value: function(n, a) {
      var i = this.props, o = i.y, s = i.height, l = i.stroke, c = i.travellerWidth, u = Math.min(n, a) + c, f = Math.max(Math.abs(a - n) - c, 0);
      return /* @__PURE__ */ Te.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: u,
        y: o,
        width: f,
        height: s
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, a = n.startIndex, i = n.endIndex, o = n.y, s = n.height, l = n.travellerWidth, c = n.stroke, u = this.state, f = u.startX, h = u.endX, p = 5, g = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ Te.createElement(P5, rF({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, h) - p,
        y: o + s / 2
      }, g), this.getTextOfTick(a)), /* @__PURE__ */ Te.createElement(P5, rF({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, h) + l + p,
        y: o + s / 2
      }, g), this.getTextOfTick(i)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.data, i = n.className, o = n.children, s = n.x, l = n.y, c = n.width, u = n.height, f = n.alwaysShowText, h = this.state, p = h.startX, g = h.endX, y = h.isTextActive, b = h.isSlideMoving, w = h.isTravellerMoving, _ = h.isTravellerFocused;
      if (!a || !a.length || !Ur(s) || !Ur(l) || !Ur(c) || !Ur(u) || c <= 0 || u <= 0)
        return null;
      var C = ti("recharts-brush", i), x = Te.Children.count(o) === 1, S = OLr("userSelect", "none");
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: C,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: S
      }, this.renderBackground(), x && this.renderPanorama(), this.renderSlide(p, g), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(g, "endX"), (y || b || w || _ || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var a = n.x, i = n.y, o = n.width, s = n.height, l = n.stroke, c = Math.floor(i + s / 2) - 1;
      return /* @__PURE__ */ Te.createElement(Te.Fragment, null, /* @__PURE__ */ Te.createElement("rect", {
        x: a,
        y: i,
        width: o,
        height: s,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ Te.createElement("line", {
        x1: a + 1,
        y1: c,
        x2: a + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ Te.createElement("line", {
        x1: a + 1,
        y1: c + 2,
        x2: a + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, a) {
      var i;
      return /* @__PURE__ */ Te.isValidElement(n) ? i = /* @__PURE__ */ Te.cloneElement(n, a) : ua(n) ? i = n(a) : i = e.renderDefaultTraveller(a), i;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      var i = n.data, o = n.width, s = n.x, l = n.travellerWidth, c = n.updateId, u = n.startIndex, f = n.endIndex;
      if (i !== a.prevData || c !== a.prevUpdateId)
        return wae({
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o
        }, i && i.length ? zLr({
          data: i,
          width: o,
          x: s,
          travellerWidth: l,
          startIndex: u,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (a.scale && (o !== a.prevWidth || s !== a.prevX || l !== a.prevTravellerWidth)) {
        a.scale.range([s, s + o - l]);
        var h = a.scale.domain().map(function(p) {
          return a.scale(p);
        });
        return {
          prevData: i,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: s,
          prevWidth: o,
          startX: a.scale(n.startIndex),
          endX: a.scale(n.endIndex),
          scaleValues: h
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, a) {
      for (var i = n.length, o = 0, s = i - 1; s - o > 1; ) {
        var l = Math.floor((o + s) / 2);
        n[l] > a ? s = l : o = l;
      }
      return a >= n[s] ? s : o;
    }
  }]);
}(g0);
qd(Gx, "displayName", "Brush");
qd(Gx, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Sae, uNe;
function GLr() {
  if (uNe) return Sae;
  uNe = 1;
  var t = mye();
  function e(r, n) {
    var a;
    return t(r, function(i, o, s) {
      return a = n(i, o, s), !a;
    }), !!a;
  }
  return Sae = e, Sae;
}
var _ae, dNe;
function WLr() {
  if (dNe) return _ae;
  dNe = 1;
  var t = gut(), e = sp(), r = GLr(), n = Od(), a = JW();
  function i(o, s, l) {
    var c = n(o) ? t : r;
    return l && a(o, s, l) && (s = void 0), c(o, e(s, 3));
  }
  return _ae = i, _ae;
}
var HLr = WLr();
const ULr = /* @__PURE__ */ Gi(HLr);
var Ah = function(e, r) {
  var n = e.alwaysShow, a = e.ifOverflow;
  return n && (a = "extendDomain"), a === r;
}, kae, fNe;
function VLr() {
  if (fNe) return kae;
  fNe = 1;
  var t = But();
  function e(r, n, a) {
    n == "__proto__" && t ? t(r, n, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[n] = a;
  }
  return kae = e, kae;
}
var Aae, hNe;
function qLr() {
  if (hNe) return Aae;
  hNe = 1;
  var t = VLr(), e = Rut(), r = sp();
  function n(a, i) {
    var o = {};
    return i = r(i, 3), e(a, function(s, l, c) {
      t(o, l, i(s, l, c));
    }), o;
  }
  return Aae = n, Aae;
}
var KLr = qLr();
const ZLr = /* @__PURE__ */ Gi(KLr);
var Tae, pNe;
function JLr() {
  if (pNe) return Tae;
  pNe = 1;
  function t(e, r) {
    for (var n = -1, a = e == null ? 0 : e.length; ++n < a; )
      if (!r(e[n], n, e))
        return !1;
    return !0;
  }
  return Tae = t, Tae;
}
var Eae, mNe;
function YLr() {
  if (mNe) return Eae;
  mNe = 1;
  var t = mye();
  function e(r, n) {
    var a = !0;
    return t(r, function(i, o, s) {
      return a = !!n(i, o, s), a;
    }), a;
  }
  return Eae = e, Eae;
}
var Iae, gNe;
function XLr() {
  if (gNe) return Iae;
  gNe = 1;
  var t = JLr(), e = YLr(), r = sp(), n = Od(), a = JW();
  function i(o, s, l) {
    var c = n(o) ? t : e;
    return l && a(o, s, l) && (s = void 0), c(o, r(s, 3));
  }
  return Iae = i, Iae;
}
var QLr = XLr();
const O0t = /* @__PURE__ */ Gi(QLr);
var ejr = ["x", "y"];
function Wx(t) {
  "@babel/helpers - typeof";
  return Wx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wx(t);
}
function R0e() {
  return R0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, R0e.apply(this, arguments);
}
function vNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hS(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vNe(Object(r), !0).forEach(function(n) {
      tjr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function tjr(t, e, r) {
  return e = rjr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function rjr(t) {
  var e = njr(t, "string");
  return Wx(e) == "symbol" ? e : e + "";
}
function njr(t, e) {
  if (Wx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Wx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function ajr(t, e) {
  if (t == null) return {};
  var r = ijr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function ijr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function ojr(t, e) {
  var r = t.x, n = t.y, a = ajr(t, ejr), i = "".concat(r), o = parseInt(i, 10), s = "".concat(n), l = parseInt(s, 10), c = "".concat(e.height || a.height), u = parseInt(c, 10), f = "".concat(e.width || a.width), h = parseInt(f, 10);
  return hS(hS(hS(hS(hS({}, e), a), o ? {
    x: o
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: u,
    width: h,
    name: e.name,
    radius: e.radius
  });
}
function yNe(t) {
  return /* @__PURE__ */ Te.createElement(A0t, R0e({
    shapeType: "rectangle",
    propTransformer: ojr,
    activeClassName: "recharts-active-bar"
  }, t));
}
var sjr = function(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, a) {
    if (typeof e == "number") return e;
    var i = typeof n == "number";
    return i ? e(n, a) : (i || (Ar.env.NODE_ENV !== "production" ? pd(!1, "minPointSize callback function received a value with type of ".concat(Wx(n), ". Currently only numbers are supported.")) : pd()), r);
  };
}, ljr = ["value", "background"], B0t;
function Hx(t) {
  "@babel/helpers - typeof";
  return Hx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hx(t);
}
function cjr(t, e) {
  if (t == null) return {};
  var r = ujr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function ujr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function aF() {
  return aF = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, aF.apply(this, arguments);
}
function bNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function bl(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bNe(Object(r), !0).forEach(function(n) {
      Av(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : bNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function djr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function xNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, $0t(n.key), n);
  }
}
function fjr(t, e, r) {
  return e && xNe(t.prototype, e), r && xNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function hjr(t, e, r) {
  return e = iF(e), pjr(t, N0t() ? Reflect.construct(e, r || [], iF(t).constructor) : e.apply(t, r));
}
function pjr(t, e) {
  if (e && (Hx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return mjr(t);
}
function mjr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function N0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (N0t = function() {
    return !!t;
  })();
}
function iF(t) {
  return iF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, iF(t);
}
function gjr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && O0e(t, e);
}
function O0e(t, e) {
  return O0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, O0e(t, e);
}
function Av(t, e, r) {
  return e = $0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function $0t(t) {
  var e = vjr(t, "string");
  return Hx(e) == "symbol" ? e : e + "";
}
function vjr(t, e) {
  if (Hx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Hx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var w6 = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    djr(this, e);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = hjr(this, e, [].concat(a)), Av(r, "state", {
      isAnimationFinished: !1
    }), Av(r, "id", b6("recharts-bar-")), Av(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Av(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return gjr(e, t), fjr(e, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var a = this, i = this.props, o = i.shape, s = i.dataKey, l = i.activeIndex, c = i.activeBar, u = Un(this.props, !1);
      return n && n.map(function(f, h) {
        var p = h === l, g = p ? c : o, y = bl(bl(bl({}, u), f), {}, {
          isActive: p,
          option: g,
          index: h,
          dataKey: s,
          onAnimationStart: a.handleAnimationStart,
          onAnimationEnd: a.handleAnimationEnd
        });
        return /* @__PURE__ */ Te.createElement(Fi, aF({
          className: "recharts-bar-rectangle"
        }, M5(a.props, f, h), {
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value)
        }), /* @__PURE__ */ Te.createElement(yNe, y));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.layout, s = a.isAnimationActive, l = a.animationBegin, c = a.animationDuration, u = a.animationEasing, f = a.animationId, h = this.state.prevData;
      return /* @__PURE__ */ Te.createElement(Y1, {
        begin: l,
        duration: c,
        isActive: s,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var g = p.t, y = i.map(function(b, w) {
          var _ = h && h[w];
          if (_) {
            var C = Gl(_.x, b.x), x = Gl(_.y, b.y), S = Gl(_.width, b.width), A = Gl(_.height, b.height);
            return bl(bl({}, b), {}, {
              x: C(g),
              y: x(g),
              width: S(g),
              height: A(g)
            });
          }
          if (o === "horizontal") {
            var I = Gl(0, b.height), M = I(g);
            return bl(bl({}, b), {}, {
              y: b.y + b.height - M,
              height: M
            });
          }
          var B = Gl(0, b.width), L = B(g);
          return bl(bl({}, b), {}, {
            width: L
          });
        });
        return /* @__PURE__ */ Te.createElement(Fi, null, n.renderRectanglesStatically(y));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, a = n.data, i = n.isAnimationActive, o = this.state.prevData;
      return i && a && a.length && (!o || !O5(o, a)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(a);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, a = this.props, i = a.data, o = a.dataKey, s = a.activeIndex, l = Un(this.props.background, !1);
      return i.map(function(c, u) {
        c.value;
        var f = c.background, h = cjr(c, ljr);
        if (!f)
          return null;
        var p = bl(bl(bl(bl(bl({}, h), {}, {
          fill: "#eee"
        }, f), l), M5(n.props, c, u)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ Te.createElement(yNe, aF({
          key: "background-bar-".concat(u),
          option: n.props.background,
          isActive: u === s
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.data, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = d0(u, fP);
      if (!f)
        return null;
      var h = c === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(b, w) {
        var _ = Array.isArray(b.value) ? b.value[1] : b.value;
        return {
          x: b.x,
          y: b.y,
          value: _,
          errorVal: ll(b, w)
        };
      }, g = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ Te.createElement(Fi, g, f.map(function(y) {
        return /* @__PURE__ */ Te.cloneElement(y, {
          key: "error-bar-".concat(a, "-").concat(y.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          offset: h,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, a = n.hide, i = n.data, o = n.className, s = n.xAxis, l = n.yAxis, c = n.left, u = n.top, f = n.width, h = n.height, p = n.isAnimationActive, g = n.background, y = n.id;
      if (a || !i || !i.length)
        return null;
      var b = this.state.isAnimationFinished, w = ti("recharts-bar", o), _ = s && s.allowDataOverflow, C = l && l.allowDataOverflow, x = _ || C, S = Va(y) ? this.id : y;
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: w
      }, _ || C ? /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("clipPath", {
        id: "clipPath-".concat(S)
      }, /* @__PURE__ */ Te.createElement("rect", {
        x: _ ? c : c - f / 2,
        y: C ? u : u - h / 2,
        width: _ ? f : f * 2,
        height: C ? h : h * 2
      }))) : null, /* @__PURE__ */ Te.createElement(Fi, {
        className: "recharts-bar-rectangles",
        clipPath: x ? "url(#clipPath-".concat(S, ")") : null
      }, g ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(x, S), (!p || b) && kh.renderCallByParent(this.props, i));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: a.curData
      } : n.data !== a.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(g0);
B0t = w6;
Av(w6, "displayName", "Bar");
Av(w6, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Jy.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Av(w6, "getComposedData", function(t) {
  var e = t.props, r = t.item, n = t.barPosition, a = t.bandSize, i = t.xAxis, o = t.yAxis, s = t.xAxisTicks, l = t.yAxisTicks, c = t.stackedData, u = t.dataStartIndex, f = t.displayedData, h = t.offset, p = oBr(n, r);
  if (!p)
    return null;
  var g = e.layout, y = r.type.defaultProps, b = y !== void 0 ? bl(bl({}, y), r.props) : r.props, w = b.dataKey, _ = b.children, C = b.minPointSize, x = g === "horizontal" ? o : i, S = c ? x.scale.domain() : null, A = hBr({
    numericAxis: x
  }), I = d0(_, yye), M = f.map(function(B, L) {
    var N, d, m, v, k, O;
    c ? N = sBr(c[u + L], S) : (N = ll(B, w), Array.isArray(N) || (N = [A, N]));
    var G = sjr(C, B0t.defaultProps.minPointSize)(N[1], L);
    if (g === "horizontal") {
      var H, j = [o.scale(N[0]), o.scale(N[1])], F = j[0], z = j[1];
      d = qOe({
        axis: i,
        ticks: s,
        bandSize: a,
        offset: p.offset,
        entry: B,
        index: L
      }), m = (H = z ?? F) !== null && H !== void 0 ? H : void 0, v = p.size;
      var W = F - z;
      if (k = Number.isNaN(W) ? 0 : W, O = {
        x: d,
        y: o.y,
        width: v,
        height: o.height
      }, Math.abs(G) > 0 && Math.abs(k) < Math.abs(G)) {
        var U = Su(k || G) * (Math.abs(G) - Math.abs(k));
        m -= U, k += U;
      }
    } else {
      var Z = [i.scale(N[0]), i.scale(N[1])], V = Z[0], Y = Z[1];
      if (d = V, m = qOe({
        axis: o,
        ticks: l,
        bandSize: a,
        offset: p.offset,
        entry: B,
        index: L
      }), v = Y - V, k = p.size, O = {
        x: i.x,
        y: m,
        width: i.width,
        height: k
      }, Math.abs(G) > 0 && Math.abs(v) < Math.abs(G)) {
        var ge = Su(v || G) * (Math.abs(G) - Math.abs(v));
        v += ge;
      }
    }
    return bl(bl(bl({}, B), {}, {
      x: d,
      y: m,
      width: v,
      height: k,
      value: c ? N : N[1],
      payload: B,
      background: O
    }, I && I[L] && I[L].props), {}, {
      tooltipPayload: [Qdt(r, B)],
      tooltipPosition: {
        x: d + v / 2,
        y: m + k / 2
      }
    });
  });
  return bl({
    data: M,
    layout: g
  }, h);
});
function XE(t) {
  "@babel/helpers - typeof";
  return XE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, XE(t);
}
function yjr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function CNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, D0t(n.key), n);
  }
}
function bjr(t, e, r) {
  return e && CNe(t.prototype, e), r && CNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function wNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function s1(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wNe(Object(r), !0).forEach(function(n) {
      vH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : wNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function vH(t, e, r) {
  return e = D0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function D0t(t) {
  var e = xjr(t, "string");
  return XE(e) == "symbol" ? e : e + "";
}
function xjr(t, e) {
  if (XE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (XE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var qye = function(e, r, n, a, i) {
  var o = e.width, s = e.height, l = e.layout, c = e.children, u = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: s - n.bottom,
    bottomMirror: s - n.bottom
  }, h = !!Zd(c, w6);
  return u.reduce(function(p, g) {
    var y = r[g], b = y.orientation, w = y.domain, _ = y.padding, C = _ === void 0 ? {} : _, x = y.mirror, S = y.reversed, A = "".concat(b).concat(x ? "Mirror" : ""), I, M, B, L, N;
    if (y.type === "number" && (y.padding === "gap" || y.padding === "no-gap")) {
      var d = w[1] - w[0], m = 1 / 0, v = y.categoricalDomain.sort();
      if (v.forEach(function(Z, V) {
        V > 0 && (m = Math.min((Z || 0) - (v[V - 1] || 0), m));
      }), Number.isFinite(m)) {
        var k = m / d, O = y.layout === "vertical" ? n.height : n.width;
        if (y.padding === "gap" && (I = k * O / 2), y.padding === "no-gap") {
          var G = _u(e.barCategoryGap, k * O), H = k * O / 2;
          I = H - G - (H - G) / O * G;
        }
      }
    }
    a === "xAxis" ? M = [n.left + (C.left || 0) + (I || 0), n.left + n.width - (C.right || 0) - (I || 0)] : a === "yAxis" ? M = l === "horizontal" ? [n.top + n.height - (C.bottom || 0), n.top + (C.top || 0)] : [n.top + (C.top || 0) + (I || 0), n.top + n.height - (C.bottom || 0) - (I || 0)] : M = y.range, S && (M = [M[1], M[0]]);
    var j = Zdt(y, i, h), F = j.scale, z = j.realScaleType;
    F.domain(w).range(M), Jdt(F);
    var W = Ydt(F, s1(s1({}, y), {}, {
      realScaleType: z
    }));
    a === "xAxis" ? (N = b === "top" && !x || b === "bottom" && x, B = n.left, L = f[A] - N * y.height) : a === "yAxis" && (N = b === "left" && !x || b === "right" && x, B = f[A] - N * y.width, L = n.top);
    var U = s1(s1(s1({}, y), W), {}, {
      realScaleType: z,
      x: B,
      y: L,
      scale: F,
      width: a === "xAxis" ? n.width : y.width,
      height: a === "yAxis" ? n.height : y.height
    });
    return U.bandSize = Gj(U, W), !y.hide && a === "xAxis" ? f[A] += (N ? -1 : 1) * U.height : y.hide || (f[A] += (N ? -1 : 1) * U.width), s1(s1({}, p), {}, vH({}, g, U));
  }, {});
}, L0t = function(e, r) {
  var n = e.x, a = e.y, i = r.x, o = r.y;
  return {
    x: Math.min(n, i),
    y: Math.min(a, o),
    width: Math.abs(i - n),
    height: Math.abs(o - a)
  };
}, Cjr = function(e) {
  var r = e.x1, n = e.y1, a = e.x2, i = e.y2;
  return L0t({
    x: r,
    y: n
  }, {
    x: a,
    y: i
  });
}, j0t = /* @__PURE__ */ function() {
  function t(e) {
    yjr(this, t), this.scale = e;
  }
  return bjr(t, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = n.bandAware, i = n.position;
      if (r !== void 0) {
        if (i)
          switch (i) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var s = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + s;
            }
            default:
              return this.scale(r);
          }
        if (a) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + l;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), a = n[0], i = n[n.length - 1];
      return a <= i ? r >= a && r <= i : r >= i && r <= a;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new t(r);
    }
  }]);
}();
vH(j0t, "EPS", 1e-4);
var Kye = function(e) {
  var r = Object.keys(e).reduce(function(n, a) {
    return s1(s1({}, n), {}, vH({}, a, j0t.create(e[a])));
  }, {});
  return s1(s1({}, r), {}, {
    apply: function(a) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.bandAware, s = i.position;
      return ZLr(a, function(l, c) {
        return r[c].apply(l, {
          bandAware: o,
          position: s
        });
      });
    },
    isInRange: function(a) {
      return O0t(a, function(i, o) {
        return r[o].isInRange(i);
      });
    }
  });
};
function wjr(t) {
  return (t % 180 + 180) % 180;
}
var Sjr = function(e) {
  var r = e.width, n = e.height, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = wjr(a), o = i * Math.PI / 180, s = Math.atan(n / r), l = o > s && o < Math.PI - s ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(l);
}, Mae, SNe;
function _jr() {
  if (SNe) return Mae;
  SNe = 1;
  var t = sp(), e = sP(), r = KW();
  function n(a) {
    return function(i, o, s) {
      var l = Object(i);
      if (!e(i)) {
        var c = t(o, 3);
        i = r(i), o = function(f) {
          return c(l[f], f, l);
        };
      }
      var u = a(i, o, s);
      return u > -1 ? l[c ? i[u] : u] : void 0;
    };
  }
  return Mae = n, Mae;
}
var Pae, _Ne;
function kjr() {
  if (_Ne) return Pae;
  _Ne = 1;
  var t = I0t();
  function e(r) {
    var n = t(r), a = n % 1;
    return n === n ? a ? n - a : n : 0;
  }
  return Pae = e, Pae;
}
var Rae, kNe;
function Ajr() {
  if (kNe) return Rae;
  kNe = 1;
  var t = Tut(), e = sp(), r = kjr(), n = Math.max;
  function a(i, o, s) {
    var l = i == null ? 0 : i.length;
    if (!l)
      return -1;
    var c = s == null ? 0 : r(s);
    return c < 0 && (c = n(l + c, 0)), t(i, e(o, 3), c);
  }
  return Rae = a, Rae;
}
var Oae, ANe;
function Tjr() {
  if (ANe) return Oae;
  ANe = 1;
  var t = _jr(), e = Ajr(), r = t(e);
  return Oae = r, Oae;
}
var Ejr = Tjr();
const Ijr = /* @__PURE__ */ Gi(Ejr);
var Mjr = Gct();
const Pjr = /* @__PURE__ */ Gi(Mjr);
var Rjr = Pjr(function(t) {
  return {
    x: t.left,
    y: t.top,
    width: t.width,
    height: t.height
  };
}, function(t) {
  return ["l", t.left, "t", t.top, "w", t.width, "h", t.height].join("");
});
function oF(t) {
  "@babel/helpers - typeof";
  return oF = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, oF(t);
}
var Zye = /* @__PURE__ */ Bo(void 0), Jye = /* @__PURE__ */ Bo(void 0), F0t = /* @__PURE__ */ Bo(void 0), z0t = /* @__PURE__ */ Bo({}), G0t = /* @__PURE__ */ Bo(void 0), W0t = /* @__PURE__ */ Bo(0), H0t = /* @__PURE__ */ Bo(0), TNe = function(e) {
  var r = e.state, n = r.xAxisMap, a = r.yAxisMap, i = r.offset, o = e.clipPathId, s = e.children, l = e.width, c = e.height, u = Rjr(i);
  return /* @__PURE__ */ Te.createElement(Zye.Provider, {
    value: n
  }, /* @__PURE__ */ Te.createElement(Jye.Provider, {
    value: a
  }, /* @__PURE__ */ Te.createElement(z0t.Provider, {
    value: i
  }, /* @__PURE__ */ Te.createElement(F0t.Provider, {
    value: u
  }, /* @__PURE__ */ Te.createElement(G0t.Provider, {
    value: o
  }, /* @__PURE__ */ Te.createElement(W0t.Provider, {
    value: c
  }, /* @__PURE__ */ Te.createElement(H0t.Provider, {
    value: l
  }, s)))))));
}, Ojr = function() {
  return Qn(G0t);
};
function U0t(t) {
  var e = Object.keys(t);
  return e.length === 0 ? "There are no available ids." : "Available ids are: ".concat(e, ".");
}
var V0t = function(e) {
  var r = Qn(Zye);
  r == null && (Ar.env.NODE_ENV !== "production" ? pd(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : pd());
  var n = r[e];
  return n == null && (Ar.env.NODE_ENV !== "production" ? pd(!1, 'Could not find xAxis by id "'.concat(e, '" [').concat(oF(e), "]. ").concat(U0t(r))) : pd()), n;
}, Bjr = function() {
  var e = Qn(Zye);
  return vv(e);
}, Njr = function() {
  var e = Qn(Jye), r = Ijr(e, function(n) {
    return O0t(n.domain, Number.isFinite);
  });
  return r || vv(e);
}, q0t = function(e) {
  var r = Qn(Jye);
  r == null && (Ar.env.NODE_ENV !== "production" ? pd(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : pd());
  var n = r[e];
  return n == null && (Ar.env.NODE_ENV !== "production" ? pd(!1, 'Could not find yAxis by id "'.concat(e, '" [').concat(oF(e), "]. ").concat(U0t(r))) : pd()), n;
}, $jr = function() {
  var e = Qn(F0t);
  return e;
}, Djr = function() {
  return Qn(z0t);
}, Yye = function() {
  return Qn(H0t);
}, Xye = function() {
  return Qn(W0t);
};
function Ux(t) {
  "@babel/helpers - typeof";
  return Ux = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ux(t);
}
function Ljr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function jjr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Z0t(n.key), n);
  }
}
function Fjr(t, e, r) {
  return e && jjr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function zjr(t, e, r) {
  return e = sF(e), Gjr(t, K0t() ? Reflect.construct(e, r || [], sF(t).constructor) : e.apply(t, r));
}
function Gjr(t, e) {
  if (e && (Ux(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Wjr(t);
}
function Wjr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function K0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (K0t = function() {
    return !!t;
  })();
}
function sF(t) {
  return sF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, sF(t);
}
function Hjr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && B0e(t, e);
}
function B0e(t, e) {
  return B0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, B0e(t, e);
}
function ENe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function INe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ENe(Object(r), !0).forEach(function(n) {
      Qye(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ENe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Qye(t, e, r) {
  return e = Z0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Z0t(t) {
  var e = Ujr(t, "string");
  return Ux(e) == "symbol" ? e : e + "";
}
function Ujr(t, e) {
  if (Ux(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Ux(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function Vjr(t, e) {
  return Jjr(t) || Zjr(t, e) || Kjr(t, e) || qjr();
}
function qjr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kjr(t, e) {
  if (t) {
    if (typeof t == "string") return MNe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return MNe(t, e);
  }
}
function MNe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Zjr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function Jjr(t) {
  if (Array.isArray(t)) return t;
}
function N0e() {
  return N0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, N0e.apply(this, arguments);
}
var Yjr = function(e, r) {
  var n;
  return /* @__PURE__ */ Te.isValidElement(e) ? n = /* @__PURE__ */ Te.cloneElement(e, r) : ua(e) ? n = e(r) : n = /* @__PURE__ */ Te.createElement("line", N0e({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, Xjr = function(e, r, n, a, i, o, s, l, c) {
  var u = i.x, f = i.y, h = i.width, p = i.height;
  if (n) {
    var g = c.y, y = e.y.apply(g, {
      position: o
    });
    if (Ah(c, "discard") && !e.y.isInRange(y))
      return null;
    var b = [{
      x: u + h,
      y
    }, {
      x: u,
      y
    }];
    return l === "left" ? b.reverse() : b;
  }
  if (r) {
    var w = c.x, _ = e.x.apply(w, {
      position: o
    });
    if (Ah(c, "discard") && !e.x.isInRange(_))
      return null;
    var C = [{
      x: _,
      y: f + p
    }, {
      x: _,
      y: f
    }];
    return s === "top" ? C.reverse() : C;
  }
  if (a) {
    var x = c.segment, S = x.map(function(A) {
      return e.apply(A, {
        position: o
      });
    });
    return Ah(c, "discard") && ULr(S, function(A) {
      return !e.isInRange(A);
    }) ? null : S;
  }
  return null;
};
function Qjr(t) {
  var e = t.x, r = t.y, n = t.segment, a = t.xAxisId, i = t.yAxisId, o = t.shape, s = t.className, l = t.alwaysShow, c = Ojr(), u = V0t(a), f = q0t(i), h = $jr();
  if (!c || !h)
    return null;
  O1(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = Kye({
    x: u.scale,
    y: f.scale
  }), g = Hl(e), y = Hl(r), b = n && n.length === 2, w = Xjr(p, g, y, b, h, t.position, u.orientation, f.orientation, t);
  if (!w)
    return null;
  var _ = Vjr(w, 2), C = _[0], x = C.x, S = C.y, A = _[1], I = A.x, M = A.y, B = Ah(t, "hidden") ? "url(#".concat(c, ")") : void 0, L = INe(INe({
    clipPath: B
  }, Un(t, !0)), {}, {
    x1: x,
    y1: S,
    x2: I,
    y2: M
  });
  return /* @__PURE__ */ Te.createElement(Fi, {
    className: ti("recharts-reference-line", s)
  }, Yjr(o, L), Ss.renderCallByParent(t, Cjr({
    x1: x,
    y1: S,
    x2: I,
    y2: M
  })));
}
var e3e = /* @__PURE__ */ function(t) {
  function e() {
    return Ljr(this, e), zjr(this, e, arguments);
  }
  return Hjr(e, t), Fjr(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ Te.createElement(Qjr, this.props);
    }
  }]);
}(Te.Component);
Qye(e3e, "displayName", "ReferenceLine");
Qye(e3e, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function $0e() {
  return $0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, $0e.apply(this, arguments);
}
function Vx(t) {
  "@babel/helpers - typeof";
  return Vx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vx(t);
}
function PNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function RNe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? PNe(Object(r), !0).forEach(function(n) {
      yH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : PNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function eFr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function tFr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Y0t(n.key), n);
  }
}
function rFr(t, e, r) {
  return e && tFr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function nFr(t, e, r) {
  return e = lF(e), aFr(t, J0t() ? Reflect.construct(e, r || [], lF(t).constructor) : e.apply(t, r));
}
function aFr(t, e) {
  if (e && (Vx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return iFr(t);
}
function iFr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function J0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (J0t = function() {
    return !!t;
  })();
}
function lF(t) {
  return lF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, lF(t);
}
function oFr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && D0e(t, e);
}
function D0e(t, e) {
  return D0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, D0e(t, e);
}
function yH(t, e, r) {
  return e = Y0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Y0t(t) {
  var e = sFr(t, "string");
  return Vx(e) == "symbol" ? e : e + "";
}
function sFr(t, e) {
  if (Vx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Vx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var lFr = function(e) {
  var r = e.x, n = e.y, a = e.xAxis, i = e.yAxis, o = Kye({
    x: a.scale,
    y: i.scale
  }), s = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Ah(e, "discard") && !o.isInRange(s) ? null : s;
}, bH = /* @__PURE__ */ function(t) {
  function e() {
    return eFr(this, e), nFr(this, e, arguments);
  }
  return oFr(e, t), rFr(e, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.r, s = n.alwaysShow, l = n.clipPathId, c = Hl(a), u = Hl(i);
      if (O1(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !u)
        return null;
      var f = lFr(this.props);
      if (!f)
        return null;
      var h = f.x, p = f.y, g = this.props, y = g.shape, b = g.className, w = Ah(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, _ = RNe(RNe({
        clipPath: w
      }, Un(this.props, !0)), {}, {
        cx: h,
        cy: p
      });
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: ti("recharts-reference-dot", b)
      }, e.renderDot(y, _), Ss.renderCallByParent(this.props, {
        x: h - o,
        y: p - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(Te.Component);
yH(bH, "displayName", "ReferenceDot");
yH(bH, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
yH(bH, "renderDot", function(t, e) {
  var r;
  return /* @__PURE__ */ Te.isValidElement(t) ? r = /* @__PURE__ */ Te.cloneElement(t, e) : ua(t) ? r = t(e) : r = /* @__PURE__ */ Te.createElement(tg, $0e({}, e, {
    cx: e.cx,
    cy: e.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function L0e() {
  return L0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, L0e.apply(this, arguments);
}
function qx(t) {
  "@babel/helpers - typeof";
  return qx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qx(t);
}
function ONe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function BNe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ONe(Object(r), !0).forEach(function(n) {
      xH(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ONe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function cFr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uFr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, Q0t(n.key), n);
  }
}
function dFr(t, e, r) {
  return e && uFr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function fFr(t, e, r) {
  return e = cF(e), hFr(t, X0t() ? Reflect.construct(e, r || [], cF(t).constructor) : e.apply(t, r));
}
function hFr(t, e) {
  if (e && (qx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pFr(t);
}
function pFr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function X0t() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (X0t = function() {
    return !!t;
  })();
}
function cF(t) {
  return cF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, cF(t);
}
function mFr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && j0e(t, e);
}
function j0e(t, e) {
  return j0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, j0e(t, e);
}
function xH(t, e, r) {
  return e = Q0t(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Q0t(t) {
  var e = gFr(t, "string");
  return qx(e) == "symbol" ? e : e + "";
}
function gFr(t, e) {
  if (qx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (qx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var vFr = function(e, r, n, a, i) {
  var o = i.x1, s = i.x2, l = i.y1, c = i.y2, u = i.xAxis, f = i.yAxis;
  if (!u || !f) return null;
  var h = Kye({
    x: u.scale,
    y: f.scale
  }), p = {
    x: e ? h.x.apply(o, {
      position: "start"
    }) : h.x.rangeMin,
    y: n ? h.y.apply(l, {
      position: "start"
    }) : h.y.rangeMin
  }, g = {
    x: r ? h.x.apply(s, {
      position: "end"
    }) : h.x.rangeMax,
    y: a ? h.y.apply(c, {
      position: "end"
    }) : h.y.rangeMax
  };
  return Ah(i, "discard") && (!h.isInRange(p) || !h.isInRange(g)) ? null : L0t(p, g);
}, CH = /* @__PURE__ */ function(t) {
  function e() {
    return cFr(this, e), fFr(this, e, arguments);
  }
  return mFr(e, t), dFr(e, [{
    key: "render",
    value: function() {
      var n = this.props, a = n.x1, i = n.x2, o = n.y1, s = n.y2, l = n.className, c = n.alwaysShow, u = n.clipPathId;
      O1(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = Hl(a), h = Hl(i), p = Hl(o), g = Hl(s), y = this.props.shape;
      if (!f && !h && !p && !g && !y)
        return null;
      var b = vFr(f, h, p, g, this.props);
      if (!b && !y)
        return null;
      var w = Ah(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: ti("recharts-reference-area", l)
      }, e.renderRect(y, BNe(BNe({
        clipPath: w
      }, Un(this.props, !0)), b)), Ss.renderCallByParent(this.props, b));
    }
  }]);
}(Te.Component);
xH(CH, "displayName", "ReferenceArea");
xH(CH, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
xH(CH, "renderRect", function(t, e) {
  var r;
  return /* @__PURE__ */ Te.isValidElement(t) ? r = /* @__PURE__ */ Te.cloneElement(t, e) : ua(t) ? r = t(e) : r = /* @__PURE__ */ Te.createElement(Vye, L0e({}, e, {
    className: "recharts-reference-area-rect"
  })), r;
});
function eft(t, e, r) {
  if (e < 1)
    return [];
  if (e === 1 && r === void 0)
    return t;
  for (var n = [], a = 0; a < t.length; a += e)
    n.push(t[a]);
  return n;
}
function yFr(t, e, r) {
  var n = {
    width: t.width + e.width,
    height: t.height + e.height
  };
  return Sjr(n, r);
}
function bFr(t, e, r) {
  var n = r === "width", a = t.x, i = t.y, o = t.width, s = t.height;
  return e === 1 ? {
    start: n ? a : i,
    end: n ? a + o : i + s
  } : {
    start: n ? a + o : i + s,
    end: n ? a : i
  };
}
function uF(t, e, r, n, a) {
  if (t * e < t * n || t * e > t * a)
    return !1;
  var i = r();
  return t * (e - t * i / 2 - n) >= 0 && t * (e + t * i / 2 - a) <= 0;
}
function xFr(t, e) {
  return eft(t, e + 1);
}
function CFr(t, e, r, n, a) {
  for (var i = (n || []).slice(), o = e.start, s = e.end, l = 0, c = 1, u = o, f = function() {
    var g = n == null ? void 0 : n[l];
    if (g === void 0)
      return {
        v: eft(n, c)
      };
    var y = l, b, w = function() {
      return b === void 0 && (b = r(g, y)), b;
    }, _ = g.coordinate, C = l === 0 || uF(t, _, w, u, s);
    C || (l = 0, u = o, c += 1), C && (u = _ + t * (w() / 2 + a), l += c);
  }, h; c <= i.length; )
    if (h = f(), h) return h.v;
  return [];
}
function QE(t) {
  "@babel/helpers - typeof";
  return QE = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, QE(t);
}
function NNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Uc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? NNe(Object(r), !0).forEach(function(n) {
      wFr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : NNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function wFr(t, e, r) {
  return e = SFr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function SFr(t) {
  var e = _Fr(t, "string");
  return QE(e) == "symbol" ? e : e + "";
}
function _Fr(t, e) {
  if (QE(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (QE(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function kFr(t, e, r, n, a) {
  for (var i = (n || []).slice(), o = i.length, s = e.start, l = e.end, c = function(h) {
    var p = i[h], g, y = function() {
      return g === void 0 && (g = r(p, h)), g;
    };
    if (h === o - 1) {
      var b = t * (p.coordinate + t * y() / 2 - l);
      i[h] = p = Uc(Uc({}, p), {}, {
        tickCoord: b > 0 ? p.coordinate - b * t : p.coordinate
      });
    } else
      i[h] = p = Uc(Uc({}, p), {}, {
        tickCoord: p.coordinate
      });
    var w = uF(t, p.tickCoord, y, s, l);
    w && (l = p.tickCoord - t * (y() / 2 + a), i[h] = Uc(Uc({}, p), {}, {
      isShow: !0
    }));
  }, u = o - 1; u >= 0; u--)
    c(u);
  return i;
}
function AFr(t, e, r, n, a, i) {
  var o = (n || []).slice(), s = o.length, l = e.start, c = e.end;
  if (i) {
    var u = n[s - 1], f = r(u, s - 1), h = t * (u.coordinate + t * f / 2 - c);
    o[s - 1] = u = Uc(Uc({}, u), {}, {
      tickCoord: h > 0 ? u.coordinate - h * t : u.coordinate
    });
    var p = uF(t, u.tickCoord, function() {
      return f;
    }, l, c);
    p && (c = u.tickCoord - t * (f / 2 + a), o[s - 1] = Uc(Uc({}, u), {}, {
      isShow: !0
    }));
  }
  for (var g = i ? s - 1 : s, y = function(_) {
    var C = o[_], x, S = function() {
      return x === void 0 && (x = r(C, _)), x;
    };
    if (_ === 0) {
      var A = t * (C.coordinate - t * S() / 2 - l);
      o[_] = C = Uc(Uc({}, C), {}, {
        tickCoord: A < 0 ? C.coordinate - A * t : C.coordinate
      });
    } else
      o[_] = C = Uc(Uc({}, C), {}, {
        tickCoord: C.coordinate
      });
    var I = uF(t, C.tickCoord, S, l, c);
    I && (l = C.tickCoord + t * (S() / 2 + a), o[_] = Uc(Uc({}, C), {}, {
      isShow: !0
    }));
  }, b = 0; b < g; b++)
    y(b);
  return o;
}
function t3e(t, e, r) {
  var n = t.tick, a = t.ticks, i = t.viewBox, o = t.minTickGap, s = t.orientation, l = t.interval, c = t.tickFormatter, u = t.unit, f = t.angle;
  if (!a || !a.length || !n)
    return [];
  if (Ur(l) || Jy.isSsr)
    return xFr(a, typeof l == "number" && Ur(l) ? l : 0);
  var h = [], p = s === "top" || s === "bottom" ? "width" : "height", g = u && p === "width" ? G_(u, {
    fontSize: e,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, y = function(C, x) {
    var S = ua(c) ? c(C.value, x) : C.value;
    return p === "width" ? yFr(G_(S, {
      fontSize: e,
      letterSpacing: r
    }), g, f) : G_(S, {
      fontSize: e,
      letterSpacing: r
    })[p];
  }, b = a.length >= 2 ? Su(a[1].coordinate - a[0].coordinate) : 1, w = bFr(i, b, p);
  return l === "equidistantPreserveStart" ? CFr(b, w, y, a, o) : (l === "preserveStart" || l === "preserveStartEnd" ? h = AFr(b, w, y, a, o, l === "preserveStartEnd") : h = kFr(b, w, y, a, o), h.filter(function(_) {
    return _.isShow;
  }));
}
var TFr = ["viewBox"], EFr = ["viewBox"], IFr = ["ticks"];
function Kx(t) {
  "@babel/helpers - typeof";
  return Kx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kx(t);
}
function Y9() {
  return Y9 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Y9.apply(this, arguments);
}
function $Ne(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vu(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $Ne(Object(r), !0).forEach(function(n) {
      r3e(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $Ne(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Bae(t, e) {
  if (t == null) return {};
  var r = MFr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function MFr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function PFr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function DNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, rft(n.key), n);
  }
}
function RFr(t, e, r) {
  return e && DNe(t.prototype, e), r && DNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function OFr(t, e, r) {
  return e = dF(e), BFr(t, tft() ? Reflect.construct(e, r || [], dF(t).constructor) : e.apply(t, r));
}
function BFr(t, e) {
  if (e && (Kx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return NFr(t);
}
function NFr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function tft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (tft = function() {
    return !!t;
  })();
}
function dF(t) {
  return dF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, dF(t);
}
function $Fr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && F0e(t, e);
}
function F0e(t, e) {
  return F0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, F0e(t, e);
}
function r3e(t, e, r) {
  return e = rft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function rft(t) {
  var e = DFr(t, "string");
  return Kx(e) == "symbol" ? e : e + "";
}
function DFr(t, e) {
  if (Kx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Kx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var cC = /* @__PURE__ */ function(t) {
  function e(r) {
    var n;
    return PFr(this, e), n = OFr(this, e, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return $Fr(e, t), RFr(e, [{
    key: "shouldComponentUpdate",
    value: function(n, a) {
      var i = n.viewBox, o = Bae(n, TFr), s = this.props, l = s.viewBox, c = Bae(s, EFr);
      return !k7(i, l) || !k7(o, c) || !k7(a, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var a = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        a && this.setState({
          fontSize: window.getComputedStyle(a).fontSize,
          letterSpacing: window.getComputedStyle(a).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var a = this.props, i = a.x, o = a.y, s = a.width, l = a.height, c = a.orientation, u = a.tickSize, f = a.mirror, h = a.tickMargin, p, g, y, b, w, _, C = f ? -1 : 1, x = n.tickSize || u, S = Ur(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          p = g = n.coordinate, b = o + +!f * l, y = b - C * x, _ = y - C * h, w = S;
          break;
        case "left":
          y = b = n.coordinate, g = i + +!f * s, p = g - C * x, w = p - C * h, _ = S;
          break;
        case "right":
          y = b = n.coordinate, g = i + +f * s, p = g + C * x, w = p + C * h, _ = S;
          break;
        default:
          p = g = n.coordinate, b = o + +f * l, y = b + C * x, _ = y + C * h, w = S;
          break;
      }
      return {
        line: {
          x1: p,
          y1: y,
          x2: g,
          y2: b
        },
        tick: {
          x: w,
          y: _
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o;
      switch (a) {
        case "left":
          o = i ? "start" : "end";
          break;
        case "right":
          o = i ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, a = n.orientation, i = n.mirror, o = "end";
      switch (a) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = i ? "start" : "end";
          break;
        default:
          o = i ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, a = n.x, i = n.y, o = n.width, s = n.height, l = n.orientation, c = n.mirror, u = n.axisLine, f = vu(vu(vu({}, Un(this.props, !1)), Un(u, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var h = +(l === "top" && !c || l === "bottom" && c);
        f = vu(vu({}, f), {}, {
          x1: a,
          y1: i + h * s,
          x2: a + o,
          y2: i + h * s
        });
      } else {
        var p = +(l === "left" && !c || l === "right" && c);
        f = vu(vu({}, f), {}, {
          x1: a + p * o,
          y1: i,
          x2: a + p * o,
          y2: i + s
        });
      }
      return /* @__PURE__ */ Te.createElement("line", Y9({}, f, {
        className: ti("recharts-cartesian-axis-line", u0(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, a, i) {
        var o = this, s = this.props, l = s.tickLine, c = s.stroke, u = s.tick, f = s.tickFormatter, h = s.unit, p = t3e(vu(vu({}, this.props), {}, {
          ticks: n
        }), a, i), g = this.getTickTextAnchor(), y = this.getTickVerticalAnchor(), b = Un(this.props, !1), w = Un(u, !1), _ = vu(vu({}, b), {}, {
          fill: "none"
        }, Un(l, !1)), C = p.map(function(x, S) {
          var A = o.getTickLineCoord(x), I = A.line, M = A.tick, B = vu(vu(vu(vu({
            textAnchor: g,
            verticalAnchor: y
          }, b), {}, {
            stroke: "none",
            fill: c
          }, w), M), {}, {
            index: S,
            payload: x,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ Te.createElement(Fi, Y9({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(x.value, "-").concat(x.coordinate, "-").concat(x.tickCoord)
          }, M5(o.props, x, S)), l && /* @__PURE__ */ Te.createElement("line", Y9({}, _, I, {
            className: ti("recharts-cartesian-axis-tick-line", u0(l, "className"))
          })), u && e.renderTickItem(u, B, "".concat(ua(f) ? f(x.value, S) : x.value).concat(h || "")));
        });
        return /* @__PURE__ */ Te.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, C);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, a = this.props, i = a.axisLine, o = a.width, s = a.height, l = a.ticksGenerator, c = a.className, u = a.hide;
      if (u)
        return null;
      var f = this.props, h = f.ticks, p = Bae(f, IFr), g = h;
      return ua(l) && (g = h && h.length > 0 ? l(this.props) : l(p)), o <= 0 || s <= 0 || !g || !g.length ? null : /* @__PURE__ */ Te.createElement(Fi, {
        className: ti("recharts-cartesian-axis", c),
        ref: function(b) {
          n.layerReference = b;
        }
      }, i && this.renderAxisLine(), this.renderTicks(g, this.state.fontSize, this.state.letterSpacing), Ss.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, a, i) {
      var o;
      return /* @__PURE__ */ Te.isValidElement(n) ? o = /* @__PURE__ */ Te.cloneElement(n, a) : ua(n) ? o = n(a) : o = /* @__PURE__ */ Te.createElement(P5, Y9({}, a, {
        className: "recharts-cartesian-axis-tick-value"
      }), i), o;
    }
  }]);
}(QF);
r3e(cC, "displayName", "CartesianAxis");
r3e(cC, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var LFr = ["x1", "y1", "x2", "y2", "key"], jFr = ["offset"];
function N5(t) {
  "@babel/helpers - typeof";
  return N5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, N5(t);
}
function LNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Kc(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? LNe(Object(r), !0).forEach(function(n) {
      FFr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : LNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function FFr(t, e, r) {
  return e = zFr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function zFr(t) {
  var e = GFr(t, "string");
  return N5(e) == "symbol" ? e : e + "";
}
function GFr(t, e) {
  if (N5(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (N5(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function xb() {
  return xb = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, xb.apply(this, arguments);
}
function jNe(t, e) {
  if (t == null) return {};
  var r = WFr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function WFr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
var HFr = function(e) {
  var r = e.fill;
  if (!r || r === "none")
    return null;
  var n = e.fillOpacity, a = e.x, i = e.y, o = e.width, s = e.height, l = e.ry;
  return /* @__PURE__ */ Te.createElement("rect", {
    x: a,
    y: i,
    ry: l,
    width: o,
    height: s,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function nft(t, e) {
  var r;
  if (/* @__PURE__ */ Te.isValidElement(t))
    r = /* @__PURE__ */ Te.cloneElement(t, e);
  else if (ua(t))
    r = t(e);
  else {
    var n = e.x1, a = e.y1, i = e.x2, o = e.y2, s = e.key, l = jNe(e, LFr), c = Un(l, !1);
    c.offset;
    var u = jNe(c, jFr);
    r = /* @__PURE__ */ Te.createElement("line", xb({}, u, {
      x1: n,
      y1: a,
      x2: i,
      y2: o,
      fill: "none",
      key: s
    }));
  }
  return r;
}
function UFr(t) {
  var e = t.x, r = t.width, n = t.horizontal, a = n === void 0 ? !0 : n, i = t.horizontalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = Kc(Kc({}, t), {}, {
      x1: e,
      y1: s,
      x2: e + r,
      y2: s,
      key: "line-".concat(l),
      index: l
    });
    return nft(a, c);
  });
  return /* @__PURE__ */ Te.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function VFr(t) {
  var e = t.y, r = t.height, n = t.vertical, a = n === void 0 ? !0 : n, i = t.verticalPoints;
  if (!a || !i || !i.length)
    return null;
  var o = i.map(function(s, l) {
    var c = Kc(Kc({}, t), {}, {
      x1: s,
      y1: e,
      x2: s,
      y2: e + r,
      key: "line-".concat(l),
      index: l
    });
    return nft(a, c);
  });
  return /* @__PURE__ */ Te.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function qFr(t) {
  var e = t.horizontalFill, r = t.fillOpacity, n = t.x, a = t.y, i = t.width, o = t.height, s = t.horizontalPoints, l = t.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !e || !e.length)
    return null;
  var u = s.map(function(h) {
    return Math.round(h + a - a);
  }).sort(function(h, p) {
    return h - p;
  });
  a !== u[0] && u.unshift(0);
  var f = u.map(function(h, p) {
    var g = !u[p + 1], y = g ? a + o - h : u[p + 1] - h;
    if (y <= 0)
      return null;
    var b = p % e.length;
    return /* @__PURE__ */ Te.createElement("rect", {
      key: "react-".concat(p),
      y: h,
      x: n,
      height: y,
      width: i,
      stroke: "none",
      fill: e[b],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ Te.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function KFr(t) {
  var e = t.vertical, r = e === void 0 ? !0 : e, n = t.verticalFill, a = t.fillOpacity, i = t.x, o = t.y, s = t.width, l = t.height, c = t.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var u = c.map(function(h) {
    return Math.round(h + i - i);
  }).sort(function(h, p) {
    return h - p;
  });
  i !== u[0] && u.unshift(0);
  var f = u.map(function(h, p) {
    var g = !u[p + 1], y = g ? i + s - h : u[p + 1] - h;
    if (y <= 0)
      return null;
    var b = p % n.length;
    return /* @__PURE__ */ Te.createElement("rect", {
      key: "react-".concat(p),
      x: h,
      y: o,
      width: y,
      height: l,
      stroke: "none",
      fill: n[b],
      fillOpacity: a,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ Te.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var ZFr = function(e, r) {
  var n = e.xAxis, a = e.width, i = e.height, o = e.offset;
  return Kdt(t3e(Kc(Kc(Kc({}, cC.defaultProps), n), {}, {
    ticks: Sm(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.left, o.left + o.width, r);
}, JFr = function(e, r) {
  var n = e.yAxis, a = e.width, i = e.height, o = e.offset;
  return Kdt(t3e(Kc(Kc(Kc({}, cC.defaultProps), n), {}, {
    ticks: Sm(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: a,
      height: i
    }
  })), o.top, o.top + o.height, r);
}, i9 = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function wH(t) {
  var e, r, n, a, i, o, s = Yye(), l = Xye(), c = Djr(), u = Kc(Kc({}, t), {}, {
    stroke: (e = t.stroke) !== null && e !== void 0 ? e : i9.stroke,
    fill: (r = t.fill) !== null && r !== void 0 ? r : i9.fill,
    horizontal: (n = t.horizontal) !== null && n !== void 0 ? n : i9.horizontal,
    horizontalFill: (a = t.horizontalFill) !== null && a !== void 0 ? a : i9.horizontalFill,
    vertical: (i = t.vertical) !== null && i !== void 0 ? i : i9.vertical,
    verticalFill: (o = t.verticalFill) !== null && o !== void 0 ? o : i9.verticalFill,
    x: Ur(t.x) ? t.x : c.left,
    y: Ur(t.y) ? t.y : c.top,
    width: Ur(t.width) ? t.width : c.width,
    height: Ur(t.height) ? t.height : c.height
  }), f = u.x, h = u.y, p = u.width, g = u.height, y = u.syncWithTicks, b = u.horizontalValues, w = u.verticalValues, _ = Bjr(), C = Njr();
  if (!Ur(p) || p <= 0 || !Ur(g) || g <= 0 || !Ur(f) || f !== +f || !Ur(h) || h !== +h)
    return null;
  var x = u.verticalCoordinatesGenerator || ZFr, S = u.horizontalCoordinatesGenerator || JFr, A = u.horizontalPoints, I = u.verticalPoints;
  if ((!A || !A.length) && ua(S)) {
    var M = b && b.length, B = S({
      yAxis: C ? Kc(Kc({}, C), {}, {
        ticks: M ? b : C.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, M ? !0 : y);
    O1(Array.isArray(B), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(N5(B), "]")), Array.isArray(B) && (A = B);
  }
  if ((!I || !I.length) && ua(x)) {
    var L = w && w.length, N = x({
      xAxis: _ ? Kc(Kc({}, _), {}, {
        ticks: L ? w : _.ticks
      }) : void 0,
      width: s,
      height: l,
      offset: c
    }, L ? !0 : y);
    O1(Array.isArray(N), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(N5(N), "]")), Array.isArray(N) && (I = N);
  }
  return /* @__PURE__ */ Te.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ Te.createElement(HFr, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ Te.createElement(UFr, xb({}, u, {
    offset: c,
    horizontalPoints: A,
    xAxis: _,
    yAxis: C
  })), /* @__PURE__ */ Te.createElement(VFr, xb({}, u, {
    offset: c,
    verticalPoints: I,
    xAxis: _,
    yAxis: C
  })), /* @__PURE__ */ Te.createElement(qFr, xb({}, u, {
    horizontalPoints: A
  })), /* @__PURE__ */ Te.createElement(KFr, xb({}, u, {
    verticalPoints: I
  })));
}
wH.displayName = "CartesianGrid";
var YFr = ["type", "layout", "connectNulls", "ref"], XFr = ["key"];
function Zx(t) {
  "@babel/helpers - typeof";
  return Zx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zx(t);
}
function FNe(t, e) {
  if (t == null) return {};
  var r = QFr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function QFr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function K_() {
  return K_ = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, K_.apply(this, arguments);
}
function zNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? zNe(Object(r), !0).forEach(function(n) {
      l1(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : zNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function o9(t) {
  return nzr(t) || rzr(t) || tzr(t) || ezr();
}
function ezr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tzr(t, e) {
  if (t) {
    if (typeof t == "string") return z0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return z0e(t, e);
  }
}
function rzr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function nzr(t) {
  if (Array.isArray(t)) return z0e(t);
}
function z0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function azr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function GNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, ift(n.key), n);
  }
}
function izr(t, e, r) {
  return e && GNe(t.prototype, e), r && GNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ozr(t, e, r) {
  return e = fF(e), szr(t, aft() ? Reflect.construct(e, r || [], fF(t).constructor) : e.apply(t, r));
}
function szr(t, e) {
  if (e && (Zx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lzr(t);
}
function lzr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function aft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (aft = function() {
    return !!t;
  })();
}
function fF(t) {
  return fF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fF(t);
}
function czr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && G0e(t, e);
}
function G0e(t, e) {
  return G0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, G0e(t, e);
}
function l1(t, e, r) {
  return e = ift(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function ift(t) {
  var e = uzr(t, "string");
  return Zx(e) == "symbol" ? e : e + "";
}
function uzr(t, e) {
  if (Zx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Zx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var $5 = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    azr(this, e);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = ozr(this, e, [].concat(a)), l1(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), l1(r, "generateSimpleStrokeDasharray", function(o, s) {
      return "".concat(s, "px ").concat(o - s, "px");
    }), l1(r, "getStrokeDasharray", function(o, s, l) {
      var c = l.reduce(function(w, _) {
        return w + _;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(s, o);
      for (var u = Math.floor(o / c), f = o % c, h = s - o, p = [], g = 0, y = 0; g < l.length; y += l[g], ++g)
        if (y + l[g] > f) {
          p = [].concat(o9(l.slice(0, g)), [f - y]);
          break;
        }
      var b = p.length % 2 === 0 ? [0, h] : [h];
      return [].concat(o9(e.repeat(l, u)), o9(p), b).map(function(w) {
        return "".concat(w, "px");
      }).join(", ");
    }), l1(r, "id", b6("recharts-line-")), l1(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), l1(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), l1(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return czr(e, t), izr(e, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, a) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var i = this.props, o = i.points, s = i.xAxis, l = i.yAxis, c = i.layout, u = i.children, f = d0(u, fP);
      if (!f)
        return null;
      var h = function(y, b) {
        return {
          x: y.x,
          y: y.y,
          value: y.value,
          errorVal: ll(y.payload, b)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(a, ")") : null
      };
      return /* @__PURE__ */ Te.createElement(Fi, p, f.map(function(g) {
        return /* @__PURE__ */ Te.cloneElement(g, {
          key: "bar-".concat(g.props.dataKey),
          data: o,
          xAxis: s,
          yAxis: l,
          layout: c,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var s = this.props, l = s.dot, c = s.points, u = s.dataKey, f = Un(this.props, !1), h = Un(l, !0), p = c.map(function(y, b) {
        var w = Vd(Vd(Vd({
          key: "dot-".concat(b),
          r: 3
        }, f), h), {}, {
          value: y.value,
          dataKey: u,
          cx: y.x,
          cy: y.y,
          index: b,
          payload: y.payload
        });
        return e.renderDotItem(l, w);
      }), g = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ Te.createElement(Fi, K_({
        className: "recharts-line-dots",
        key: "dots"
      }, g), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.type, c = s.layout, u = s.connectNulls;
      s.ref;
      var f = FNe(s, YFr), h = Vd(Vd(Vd({}, Un(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: a ? "url(#clipPath-".concat(i, ")") : null,
        points: n
      }, o), {}, {
        type: l,
        layout: c,
        connectNulls: u
      });
      return /* @__PURE__ */ Te.createElement(Wb, K_({}, h, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.strokeDasharray, c = o.isAnimationActive, u = o.animationBegin, f = o.animationDuration, h = o.animationEasing, p = o.animationId, g = o.animateNewValues, y = o.width, b = o.height, w = this.state, _ = w.prevPoints, C = w.totalLength;
      return /* @__PURE__ */ Te.createElement(Y1, {
        begin: u,
        duration: f,
        isActive: c,
        easing: h,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var S = x.t;
        if (_) {
          var A = _.length / s.length, I = s.map(function(d, m) {
            var v = Math.floor(m * A);
            if (_[v]) {
              var k = _[v], O = Gl(k.x, d.x), G = Gl(k.y, d.y);
              return Vd(Vd({}, d), {}, {
                x: O(S),
                y: G(S)
              });
            }
            if (g) {
              var H = Gl(y * 2, d.x), j = Gl(b / 2, d.y);
              return Vd(Vd({}, d), {}, {
                x: H(S),
                y: j(S)
              });
            }
            return Vd(Vd({}, d), {}, {
              x: d.x,
              y: d.y
            });
          });
          return i.renderCurveStatically(I, n, a);
        }
        var M = Gl(0, C), B = M(S), L;
        if (l) {
          var N = "".concat(l).split(/[,\s]+/gim).map(function(d) {
            return parseFloat(d);
          });
          L = i.getStrokeDasharray(B, C, N);
        } else
          L = i.generateSimpleStrokeDasharray(C, B);
        return i.renderCurveStatically(s, n, a, {
          strokeDasharray: L
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.isAnimationActive, l = this.state, c = l.prevPoints, u = l.totalLength;
      return s && o && o.length && (!c && u > 0 || !O5(c, o)) ? this.renderCurveWithAnimation(n, a) : this.renderCurveStatically(o, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.xAxis, u = a.yAxis, f = a.top, h = a.left, p = a.width, g = a.height, y = a.isAnimationActive, b = a.id;
      if (i || !s || !s.length)
        return null;
      var w = this.state.isAnimationFinished, _ = s.length === 1, C = ti("recharts-line", l), x = c && c.allowDataOverflow, S = u && u.allowDataOverflow, A = x || S, I = Va(b) ? this.id : b, M = (n = Un(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, B = M.r, L = B === void 0 ? 3 : B, N = M.strokeWidth, d = N === void 0 ? 2 : N, m = qct(o) ? o : {}, v = m.clipDot, k = v === void 0 ? !0 : v, O = L * 2 + d;
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: C
      }, x || S ? /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("clipPath", {
        id: "clipPath-".concat(I)
      }, /* @__PURE__ */ Te.createElement("rect", {
        x: x ? h : h - p / 2,
        y: S ? f : f - g / 2,
        width: x ? p : p * 2,
        height: S ? g : g * 2
      })), !k && /* @__PURE__ */ Te.createElement("clipPath", {
        id: "clipPath-dots-".concat(I)
      }, /* @__PURE__ */ Te.createElement("rect", {
        x: h - O / 2,
        y: f - O / 2,
        width: p + O,
        height: g + O
      }))) : null, !_ && this.renderCurve(A, I), this.renderErrorBar(A, I), (_ || o) && this.renderDots(A, k, I), (!y || w) && kh.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: a.curPoints
      } : n.points !== a.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, a) {
      for (var i = n.length % 2 !== 0 ? [].concat(o9(n), [0]) : n, o = [], s = 0; s < a; ++s)
        o = [].concat(o9(o), o9(i));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, a) {
      var i;
      if (/* @__PURE__ */ Te.isValidElement(n))
        i = /* @__PURE__ */ Te.cloneElement(n, a);
      else if (ua(n))
        i = n(a);
      else {
        var o = a.key, s = FNe(a, XFr), l = ti("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        i = /* @__PURE__ */ Te.createElement(tg, K_({
          key: o
        }, s, {
          className: l
        }));
      }
      return i;
    }
  }]);
}(g0);
l1($5, "displayName", "Line");
l1($5, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Jy.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
l1($5, "getComposedData", function(t) {
  var e = t.props, r = t.xAxis, n = t.yAxis, a = t.xAxisTicks, i = t.yAxisTicks, o = t.dataKey, s = t.bandSize, l = t.displayedData, c = t.offset, u = e.layout, f = l.map(function(h, p) {
    var g = ll(h, o);
    return u === "horizontal" ? {
      x: zj({
        axis: r,
        ticks: a,
        bandSize: s,
        entry: h,
        index: p
      }),
      y: Va(g) ? null : n.scale(g),
      value: g,
      payload: h
    } : {
      x: Va(g) ? null : r.scale(g),
      y: zj({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: h,
        index: p
      }),
      value: g,
      payload: h
    };
  });
  return Vd({
    points: f,
    layout: u
  }, c);
});
var dzr = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], fzr = ["key"], oft;
function Jx(t) {
  "@babel/helpers - typeof";
  return Jx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jx(t);
}
function sft(t, e) {
  if (t == null) return {};
  var r = hzr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function hzr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function Cb() {
  return Cb = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Cb.apply(this, arguments);
}
function WNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function uv(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? WNe(Object(r), !0).forEach(function(n) {
      ih(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : WNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function pzr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function HNe(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, cft(n.key), n);
  }
}
function mzr(t, e, r) {
  return e && HNe(t.prototype, e), r && HNe(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function gzr(t, e, r) {
  return e = hF(e), vzr(t, lft() ? Reflect.construct(e, r || [], hF(t).constructor) : e.apply(t, r));
}
function vzr(t, e) {
  if (e && (Jx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return yzr(t);
}
function yzr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function lft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (lft = function() {
    return !!t;
  })();
}
function hF(t) {
  return hF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, hF(t);
}
function bzr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && W0e(t, e);
}
function W0e(t, e) {
  return W0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, W0e(t, e);
}
function ih(t, e, r) {
  return e = cft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cft(t) {
  var e = xzr(t, "string");
  return Jx(e) == "symbol" ? e : e + "";
}
function xzr(t, e) {
  if (Jx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Jx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Qy = /* @__PURE__ */ function(t) {
  function e() {
    var r;
    pzr(this, e);
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return r = gzr(this, e, [].concat(a)), ih(r, "state", {
      isAnimationFinished: !0
    }), ih(r, "id", b6("recharts-area-")), ih(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), ua(o) && o();
    }), ih(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), ua(o) && o();
    }), r;
  }
  return bzr(e, t), mzr(e, [{
    key: "renderDots",
    value: function(n, a, i) {
      var o = this.props.isAnimationActive, s = this.state.isAnimationFinished;
      if (o && !s)
        return null;
      var l = this.props, c = l.dot, u = l.points, f = l.dataKey, h = Un(this.props, !1), p = Un(c, !0), g = u.map(function(b, w) {
        var _ = uv(uv(uv({
          key: "dot-".concat(w),
          r: 3
        }, h), p), {}, {
          index: w,
          cx: b.x,
          cy: b.y,
          dataKey: f,
          value: b.value,
          payload: b.payload,
          points: u
        });
        return e.renderDotItem(c, _);
      }), y = {
        clipPath: n ? "url(#clipPath-".concat(a ? "" : "dots-").concat(i, ")") : null
      };
      return /* @__PURE__ */ Te.createElement(Fi, Cb({
        className: "recharts-area-dots"
      }, y), g);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].x, c = o[o.length - 1].x, u = n * Math.abs(l - c), f = kv(o.map(function(h) {
        return h.y || 0;
      }));
      return Ur(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(kv(i.map(function(h) {
        return h.y || 0;
      })), f)), Ur(f) ? /* @__PURE__ */ Te.createElement("rect", {
        x: l < c ? l : l - u,
        y: 0,
        width: u,
        height: Math.floor(f + (s ? parseInt("".concat(s), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var a = this.props, i = a.baseLine, o = a.points, s = a.strokeWidth, l = o[0].y, c = o[o.length - 1].y, u = n * Math.abs(l - c), f = kv(o.map(function(h) {
        return h.x || 0;
      }));
      return Ur(i) && typeof i == "number" ? f = Math.max(i, f) : i && Array.isArray(i) && i.length && (f = Math.max(kv(i.map(function(h) {
        return h.x || 0;
      })), f)), Ur(f) ? /* @__PURE__ */ Te.createElement("rect", {
        x: 0,
        y: l < c ? l : l - u,
        width: f + (s ? parseInt("".concat(s), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var a = this.props.layout;
      return a === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, a, i, o) {
      var s = this.props, l = s.layout, c = s.type, u = s.stroke, f = s.connectNulls, h = s.isRange;
      s.ref;
      var p = sft(s, dzr);
      return /* @__PURE__ */ Te.createElement(Fi, {
        clipPath: i ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ Te.createElement(Wb, Cb({}, Un(p, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: a,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ Te.createElement(Wb, Cb({}, Un(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), u !== "none" && h && /* @__PURE__ */ Te.createElement(Wb, Cb({}, Un(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: f,
        fill: "none",
        points: a
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, a) {
      var i = this, o = this.props, s = o.points, l = o.baseLine, c = o.isAnimationActive, u = o.animationBegin, f = o.animationDuration, h = o.animationEasing, p = o.animationId, g = this.state, y = g.prevPoints, b = g.prevBaseLine;
      return /* @__PURE__ */ Te.createElement(Y1, {
        begin: u,
        duration: f,
        isActive: c,
        easing: h,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(w) {
        var _ = w.t;
        if (y) {
          var C = y.length / s.length, x = s.map(function(M, B) {
            var L = Math.floor(B * C);
            if (y[L]) {
              var N = y[L], d = Gl(N.x, M.x), m = Gl(N.y, M.y);
              return uv(uv({}, M), {}, {
                x: d(_),
                y: m(_)
              });
            }
            return M;
          }), S;
          if (Ur(l) && typeof l == "number") {
            var A = Gl(b, l);
            S = A(_);
          } else if (Va(l) || aC(l)) {
            var I = Gl(b, 0);
            S = I(_);
          } else
            S = l.map(function(M, B) {
              var L = Math.floor(B * C);
              if (b[L]) {
                var N = b[L], d = Gl(N.x, M.x), m = Gl(N.y, M.y);
                return uv(uv({}, M), {}, {
                  x: d(_),
                  y: m(_)
                });
              }
              return M;
            });
          return i.renderAreaStatically(x, S, n, a);
        }
        return /* @__PURE__ */ Te.createElement(Fi, null, /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("clipPath", {
          id: "animationClipPath-".concat(a)
        }, i.renderClipRect(_))), /* @__PURE__ */ Te.createElement(Fi, {
          clipPath: "url(#animationClipPath-".concat(a, ")")
        }, i.renderAreaStatically(s, l, n, a)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, a) {
      var i = this.props, o = i.points, s = i.baseLine, l = i.isAnimationActive, c = this.state, u = c.prevPoints, f = c.prevBaseLine, h = c.totalLength;
      return l && o && o.length && (!u && h > 0 || !O5(u, o) || !O5(f, s)) ? this.renderAreaWithAnimation(n, a) : this.renderAreaStatically(o, s, n, a);
    }
  }, {
    key: "render",
    value: function() {
      var n, a = this.props, i = a.hide, o = a.dot, s = a.points, l = a.className, c = a.top, u = a.left, f = a.xAxis, h = a.yAxis, p = a.width, g = a.height, y = a.isAnimationActive, b = a.id;
      if (i || !s || !s.length)
        return null;
      var w = this.state.isAnimationFinished, _ = s.length === 1, C = ti("recharts-area", l), x = f && f.allowDataOverflow, S = h && h.allowDataOverflow, A = x || S, I = Va(b) ? this.id : b, M = (n = Un(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, B = M.r, L = B === void 0 ? 3 : B, N = M.strokeWidth, d = N === void 0 ? 2 : N, m = qct(o) ? o : {}, v = m.clipDot, k = v === void 0 ? !0 : v, O = L * 2 + d;
      return /* @__PURE__ */ Te.createElement(Fi, {
        className: C
      }, x || S ? /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("clipPath", {
        id: "clipPath-".concat(I)
      }, /* @__PURE__ */ Te.createElement("rect", {
        x: x ? u : u - p / 2,
        y: S ? c : c - g / 2,
        width: x ? p : p * 2,
        height: S ? g : g * 2
      })), !k && /* @__PURE__ */ Te.createElement("clipPath", {
        id: "clipPath-dots-".concat(I)
      }, /* @__PURE__ */ Te.createElement("rect", {
        x: u - O / 2,
        y: c - O / 2,
        width: p + O,
        height: g + O
      }))) : null, _ ? null : this.renderArea(A, I), (o || _) && this.renderDots(A, k, I), (!y || w) && kh.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, a) {
      return n.animationId !== a.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: a.curPoints,
        prevBaseLine: a.curBaseLine
      } : n.points !== a.curPoints || n.baseLine !== a.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(g0);
oft = Qy;
ih(Qy, "displayName", "Area");
ih(Qy, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Jy.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
ih(Qy, "getBaseValue", function(t, e, r, n) {
  var a = t.layout, i = t.baseValue, o = e.props.baseValue, s = o ?? i;
  if (Ur(s) && typeof s == "number")
    return s;
  var l = a === "horizontal" ? n : r, c = l.scale.domain();
  if (l.type === "number") {
    var u = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return s === "dataMin" ? f : s === "dataMax" || u < 0 ? u : Math.max(Math.min(c[0], c[1]), 0);
  }
  return s === "dataMin" ? c[0] : s === "dataMax" ? c[1] : c[0];
});
ih(Qy, "getComposedData", function(t) {
  var e = t.props, r = t.item, n = t.xAxis, a = t.yAxis, i = t.xAxisTicks, o = t.yAxisTicks, s = t.bandSize, l = t.dataKey, c = t.stackedData, u = t.dataStartIndex, f = t.displayedData, h = t.offset, p = e.layout, g = c && c.length, y = oft.getBaseValue(e, r, n, a), b = p === "horizontal", w = !1, _ = f.map(function(x, S) {
    var A;
    g ? A = c[u + S] : (A = ll(x, l), Array.isArray(A) ? w = !0 : A = [y, A]);
    var I = A[1] == null || g && ll(x, l) == null;
    return b ? {
      x: zj({
        axis: n,
        ticks: i,
        bandSize: s,
        entry: x,
        index: S
      }),
      y: I ? null : a.scale(A[1]),
      value: A,
      payload: x
    } : {
      x: I ? null : n.scale(A[1]),
      y: zj({
        axis: a,
        ticks: o,
        bandSize: s,
        entry: x,
        index: S
      }),
      value: A,
      payload: x
    };
  }), C;
  return g || w ? C = _.map(function(x) {
    var S = Array.isArray(x.value) ? x.value[0] : null;
    return b ? {
      x: x.x,
      y: S != null && x.y != null ? a.scale(S) : null
    } : {
      x: S != null ? n.scale(S) : null,
      y: x.y
    };
  }) : C = b ? a.scale(y) : n.scale(y), uv({
    points: _,
    baseLine: C,
    layout: p,
    isRange: w
  }, h);
});
ih(Qy, "renderDotItem", function(t, e) {
  var r;
  if (/* @__PURE__ */ Te.isValidElement(t))
    r = /* @__PURE__ */ Te.cloneElement(t, e);
  else if (ua(t))
    r = t(e);
  else {
    var n = ti("recharts-area-dot", typeof t != "boolean" ? t.className : ""), a = e.key, i = sft(e, fzr);
    r = /* @__PURE__ */ Te.createElement(tg, Cb({}, i, {
      key: a,
      className: n
    }));
  }
  return r;
});
function Yx(t) {
  "@babel/helpers - typeof";
  return Yx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Yx(t);
}
function Czr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function wzr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, fft(n.key), n);
  }
}
function Szr(t, e, r) {
  return e && wzr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function _zr(t, e, r) {
  return e = pF(e), kzr(t, uft() ? Reflect.construct(e, r || [], pF(t).constructor) : e.apply(t, r));
}
function kzr(t, e) {
  if (e && (Yx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Azr(t);
}
function Azr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function uft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (uft = function() {
    return !!t;
  })();
}
function pF(t) {
  return pF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, pF(t);
}
function Tzr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && H0e(t, e);
}
function H0e(t, e) {
  return H0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, H0e(t, e);
}
function dft(t, e, r) {
  return e = fft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function fft(t) {
  var e = Ezr(t, "string");
  return Yx(e) == "symbol" ? e : e + "";
}
function Ezr(t, e) {
  if (Yx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Yx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function U0e() {
  return U0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, U0e.apply(this, arguments);
}
function Izr(t) {
  var e = t.xAxisId, r = Yye(), n = Xye(), a = V0t(e);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ Te.createElement(cC, U0e({}, a, {
      className: ti("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return Sm(o, !0);
      }
    }))
  );
}
var e3 = /* @__PURE__ */ function(t) {
  function e() {
    return Czr(this, e), _zr(this, e, arguments);
  }
  return Tzr(e, t), Szr(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ Te.createElement(Izr, this.props);
    }
  }]);
}(Te.Component);
dft(e3, "displayName", "XAxis");
dft(e3, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Xx(t) {
  "@babel/helpers - typeof";
  return Xx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xx(t);
}
function Mzr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Pzr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, mft(n.key), n);
  }
}
function Rzr(t, e, r) {
  return e && Pzr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Ozr(t, e, r) {
  return e = mF(e), Bzr(t, hft() ? Reflect.construct(e, r || [], mF(t).constructor) : e.apply(t, r));
}
function Bzr(t, e) {
  if (e && (Xx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Nzr(t);
}
function Nzr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function hft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (hft = function() {
    return !!t;
  })();
}
function mF(t) {
  return mF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, mF(t);
}
function $zr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && V0e(t, e);
}
function V0e(t, e) {
  return V0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, V0e(t, e);
}
function pft(t, e, r) {
  return e = mft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function mft(t) {
  var e = Dzr(t, "string");
  return Xx(e) == "symbol" ? e : e + "";
}
function Dzr(t, e) {
  if (Xx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Xx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function q0e() {
  return q0e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, q0e.apply(this, arguments);
}
var Lzr = function(e) {
  var r = e.yAxisId, n = Yye(), a = Xye(), i = q0t(r);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ Te.createElement(cC, q0e({}, i, {
      className: ti("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: a
      },
      ticksGenerator: function(s) {
        return Sm(s, !0);
      }
    }))
  );
}, t3 = /* @__PURE__ */ function(t) {
  function e() {
    return Mzr(this, e), Ozr(this, e, arguments);
  }
  return $zr(e, t), Rzr(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ Te.createElement(Lzr, this.props);
    }
  }]);
}(Te.Component);
pft(t3, "displayName", "YAxis");
pft(t3, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function UNe(t) {
  return Gzr(t) || zzr(t) || Fzr(t) || jzr();
}
function jzr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fzr(t, e) {
  if (t) {
    if (typeof t == "string") return K0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return K0e(t, e);
  }
}
function zzr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Gzr(t) {
  if (Array.isArray(t)) return K0e(t);
}
function K0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
var Z0e = function(e, r, n, a, i) {
  var o = d0(e, e3e), s = d0(e, bH), l = [].concat(UNe(o), UNe(s)), c = d0(e, CH), u = "".concat(a, "Id"), f = a[0], h = r;
  if (l.length && (h = l.reduce(function(y, b) {
    if (b.props[u] === n && Ah(b.props, "extendDomain") && Ur(b.props[f])) {
      var w = b.props[f];
      return [Math.min(y[0], w), Math.max(y[1], w)];
    }
    return y;
  }, h)), c.length) {
    var p = "".concat(f, "1"), g = "".concat(f, "2");
    h = c.reduce(function(y, b) {
      if (b.props[u] === n && Ah(b.props, "extendDomain") && Ur(b.props[p]) && Ur(b.props[g])) {
        var w = b.props[p], _ = b.props[g];
        return [Math.min(y[0], w, _), Math.max(y[1], w, _)];
      }
      return y;
    }, h);
  }
  return i && i.length && (h = i.reduce(function(y, b) {
    return Ur(b) ? [Math.min(y[0], b), Math.max(y[1], b)] : y;
  }, h)), h;
}, Nae = { exports: {} }, VNe;
function Wzr() {
  return VNe || (VNe = 1, function(t) {
    var e = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function a(l, c, u) {
      this.fn = l, this.context = c, this.once = u || !1;
    }
    function i(l, c, u, f, h) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var p = new a(u, f || l, h), g = r ? r + c : c;
      return l._events[g] ? l._events[g].fn ? l._events[g] = [l._events[g], p] : l._events[g].push(p) : (l._events[g] = p, l._eventsCount++), l;
    }
    function o(l, c) {
      --l._eventsCount === 0 ? l._events = new n() : delete l._events[c];
    }
    function s() {
      this._events = new n(), this._eventsCount = 0;
    }
    s.prototype.eventNames = function() {
      var c = [], u, f;
      if (this._eventsCount === 0) return c;
      for (f in u = this._events)
        e.call(u, f) && c.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
    }, s.prototype.listeners = function(c) {
      var u = r ? r + c : c, f = this._events[u];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var h = 0, p = f.length, g = new Array(p); h < p; h++)
        g[h] = f[h].fn;
      return g;
    }, s.prototype.listenerCount = function(c) {
      var u = r ? r + c : c, f = this._events[u];
      return f ? f.fn ? 1 : f.length : 0;
    }, s.prototype.emit = function(c, u, f, h, p, g) {
      var y = r ? r + c : c;
      if (!this._events[y]) return !1;
      var b = this._events[y], w = arguments.length, _, C;
      if (b.fn) {
        switch (b.once && this.removeListener(c, b.fn, void 0, !0), w) {
          case 1:
            return b.fn.call(b.context), !0;
          case 2:
            return b.fn.call(b.context, u), !0;
          case 3:
            return b.fn.call(b.context, u, f), !0;
          case 4:
            return b.fn.call(b.context, u, f, h), !0;
          case 5:
            return b.fn.call(b.context, u, f, h, p), !0;
          case 6:
            return b.fn.call(b.context, u, f, h, p, g), !0;
        }
        for (C = 1, _ = new Array(w - 1); C < w; C++)
          _[C - 1] = arguments[C];
        b.fn.apply(b.context, _);
      } else {
        var x = b.length, S;
        for (C = 0; C < x; C++)
          switch (b[C].once && this.removeListener(c, b[C].fn, void 0, !0), w) {
            case 1:
              b[C].fn.call(b[C].context);
              break;
            case 2:
              b[C].fn.call(b[C].context, u);
              break;
            case 3:
              b[C].fn.call(b[C].context, u, f);
              break;
            case 4:
              b[C].fn.call(b[C].context, u, f, h);
              break;
            default:
              if (!_) for (S = 1, _ = new Array(w - 1); S < w; S++)
                _[S - 1] = arguments[S];
              b[C].fn.apply(b[C].context, _);
          }
      }
      return !0;
    }, s.prototype.on = function(c, u, f) {
      return i(this, c, u, f, !1);
    }, s.prototype.once = function(c, u, f) {
      return i(this, c, u, f, !0);
    }, s.prototype.removeListener = function(c, u, f, h) {
      var p = r ? r + c : c;
      if (!this._events[p]) return this;
      if (!u)
        return o(this, p), this;
      var g = this._events[p];
      if (g.fn)
        g.fn === u && (!h || g.once) && (!f || g.context === f) && o(this, p);
      else {
        for (var y = 0, b = [], w = g.length; y < w; y++)
          (g[y].fn !== u || h && !g[y].once || f && g[y].context !== f) && b.push(g[y]);
        b.length ? this._events[p] = b.length === 1 ? b[0] : b : o(this, p);
      }
      return this;
    }, s.prototype.removeAllListeners = function(c) {
      var u;
      return c ? (u = r ? r + c : c, this._events[u] && o(this, u)) : (this._events = new n(), this._eventsCount = 0), this;
    }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, t.exports = s;
  }(Nae)), Nae.exports;
}
var Hzr = Wzr();
const Uzr = /* @__PURE__ */ Gi(Hzr);
var $ae = new Uzr(), Dae = "recharts.syncMouseEvents";
function eI(t) {
  "@babel/helpers - typeof";
  return eI = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, eI(t);
}
function Vzr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qzr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, gft(n.key), n);
  }
}
function Kzr(t, e, r) {
  return e && qzr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function Lae(t, e, r) {
  return e = gft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function gft(t) {
  var e = Zzr(t, "string");
  return eI(e) == "symbol" ? e : e + "";
}
function Zzr(t, e) {
  if (eI(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (eI(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var Jzr = /* @__PURE__ */ function() {
  function t() {
    Vzr(this, t), Lae(this, "activeIndex", 0), Lae(this, "coordinateList", []), Lae(this, "layout", "horizontal");
  }
  return Kzr(t, [{
    key: "setDetails",
    value: function(r) {
      var n, a = r.coordinateList, i = a === void 0 ? null : a, o = r.container, s = o === void 0 ? null : o, l = r.layout, c = l === void 0 ? null : l, u = r.offset, f = u === void 0 ? null : u, h = r.mouseHandlerCallback, p = h === void 0 ? null : h;
      this.coordinateList = (n = i ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = s ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var a = this.container.getBoundingClientRect(), i = a.x, o = a.y, s = a.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, u = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = i + l + c, h = o + this.offset.top + s / 2 + u;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: h
        });
      }
    }
  }]);
}();
function Yzr(t, e, r) {
  if (r === "number" && e === !0 && Array.isArray(t)) {
    var n = t == null ? void 0 : t[0], a = t == null ? void 0 : t[1];
    if (n && a && Ur(n) && Ur(a))
      return !0;
  }
  return !1;
}
function Xzr(t, e, r, n) {
  var a = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: t === "horizontal" ? e.x - a : r.left + 0.5,
    y: t === "horizontal" ? r.top + 0.5 : e.y - a,
    width: t === "horizontal" ? n : r.width - 1,
    height: t === "horizontal" ? r.height - 1 : n
  };
}
function vft(t) {
  var e = t.cx, r = t.cy, n = t.radius, a = t.startAngle, i = t.endAngle, o = ls(e, r, n, a), s = ls(e, r, n, i);
  return {
    points: [o, s],
    cx: e,
    cy: r,
    radius: n,
    startAngle: a,
    endAngle: i
  };
}
function Qzr(t, e, r) {
  var n, a, i, o;
  if (t === "horizontal")
    n = e.x, i = n, a = r.top, o = r.top + r.height;
  else if (t === "vertical")
    a = e.y, o = a, n = r.left, i = r.left + r.width;
  else if (e.cx != null && e.cy != null)
    if (t === "centric") {
      var s = e.cx, l = e.cy, c = e.innerRadius, u = e.outerRadius, f = e.angle, h = ls(s, l, c, f), p = ls(s, l, u, f);
      n = h.x, a = h.y, i = p.x, o = p.y;
    } else
      return vft(e);
  return [{
    x: n,
    y: a
  }, {
    x: i,
    y: o
  }];
}
function tI(t) {
  "@babel/helpers - typeof";
  return tI = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, tI(t);
}
function qNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lN(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? qNe(Object(r), !0).forEach(function(n) {
      eGr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : qNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function eGr(t, e, r) {
  return e = tGr(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function tGr(t) {
  var e = rGr(t, "string");
  return tI(e) == "symbol" ? e : e + "";
}
function rGr(t, e) {
  if (tI(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (tI(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function nGr(t) {
  var e, r, n = t.element, a = t.tooltipEventType, i = t.isActive, o = t.activeCoordinate, s = t.activePayload, l = t.offset, c = t.activeTooltipIndex, u = t.tooltipAxisBandSize, f = t.layout, h = t.chartName, p = (e = n.props.cursor) !== null && e !== void 0 ? e : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !p || !i || !o || h !== "ScatterChart" && a !== "axis")
    return null;
  var g, y = Wb;
  if (h === "ScatterChart")
    g = o, y = pDr;
  else if (h === "BarChart")
    g = Xzr(f, o, l, u), y = Vye;
  else if (f === "radial") {
    var b = vft(o), w = b.cx, _ = b.cy, C = b.radius, x = b.startAngle, S = b.endAngle;
    g = {
      cx: w,
      cy: _,
      startAngle: x,
      endAngle: S,
      innerRadius: C,
      outerRadius: C
    }, y = Hye;
  } else
    g = {
      points: Qzr(f, o, l)
    }, y = Wb;
  var A = lN(lN(lN(lN({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), g), Un(p, !1)), {}, {
    payload: s,
    payloadIndex: c,
    className: ti("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ ef(p) ? /* @__PURE__ */ xl(p, A) : /* @__PURE__ */ Ds(y, A);
}
var aGr = ["item"], iGr = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Qx(t) {
  "@babel/helpers - typeof";
  return Qx = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qx(t);
}
function X9() {
  return X9 = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, X9.apply(this, arguments);
}
function KNe(t, e) {
  return lGr(t) || sGr(t, e) || bft(t, e) || oGr();
}
function oGr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sGr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, a, i, o, s = [], l = !0, c = !1;
    try {
      if (i = (r = r.call(t)).next, e !== 0) for (; !(l = (n = i.call(r)).done) && (s.push(n.value), s.length !== e); l = !0) ;
    } catch (u) {
      c = !0, a = u;
    } finally {
      try {
        if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw a;
      }
    }
    return s;
  }
}
function lGr(t) {
  if (Array.isArray(t)) return t;
}
function ZNe(t, e) {
  if (t == null) return {};
  var r = cGr(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++)
      n = i[a], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function cGr(t, e) {
  if (t == null) return {};
  var r = {};
  for (var n in t)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      if (e.indexOf(n) >= 0) continue;
      r[n] = t[n];
    }
  return r;
}
function uGr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function dGr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, xft(n.key), n);
  }
}
function fGr(t, e, r) {
  return e && dGr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function hGr(t, e, r) {
  return e = gF(e), pGr(t, yft() ? Reflect.construct(e, r || [], gF(t).constructor) : e.apply(t, r));
}
function pGr(t, e) {
  if (e && (Qx(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return mGr(t);
}
function mGr(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function yft() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yft = function() {
    return !!t;
  })();
}
function gF(t) {
  return gF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, gF(t);
}
function gGr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && J0e(t, e);
}
function J0e(t, e) {
  return J0e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, J0e(t, e);
}
function e8(t) {
  return bGr(t) || yGr(t) || bft(t) || vGr();
}
function vGr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bft(t, e) {
  if (t) {
    if (typeof t == "string") return Y0e(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Y0e(t, e);
  }
}
function yGr(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function bGr(t) {
  if (Array.isArray(t)) return Y0e(t);
}
function Y0e(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function JNe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ur(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? JNe(Object(r), !0).forEach(function(n) {
      la(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : JNe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function la(t, e, r) {
  return e = xft(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function xft(t) {
  var e = xGr(t, "string");
  return Qx(e) == "symbol" ? e : e + "";
}
function xGr(t, e) {
  if (Qx(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (Qx(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var CGr = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, wGr = {
  width: "100%",
  height: "100%"
}, Cft = {
  x: 0,
  y: 0
};
function cN(t) {
  return t;
}
var SGr = function(e, r) {
  return r === "horizontal" ? e.x : r === "vertical" ? e.y : r === "centric" ? e.angle : e.radius;
}, _Gr = function(e, r, n, a) {
  var i = r.find(function(u) {
    return u && u.index === n;
  });
  if (i) {
    if (e === "horizontal")
      return {
        x: i.coordinate,
        y: a.y
      };
    if (e === "vertical")
      return {
        x: a.x,
        y: i.coordinate
      };
    if (e === "centric") {
      var o = i.coordinate, s = a.radius;
      return ur(ur(ur({}, a), ls(a.cx, a.cy, s, o)), {}, {
        angle: o,
        radius: s
      });
    }
    var l = i.coordinate, c = a.angle;
    return ur(ur(ur({}, a), ls(a.cx, a.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return Cft;
}, SH = function(e, r) {
  var n = r.graphicalItems, a = r.dataStartIndex, i = r.dataEndIndex, o = (n ?? []).reduce(function(s, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(e8(s), e8(c)) : s;
  }, []);
  return o.length > 0 ? o : e && e.length && Ur(a) && Ur(i) ? e.slice(a, i + 1) : [];
};
function wft(t) {
  return t === "number" ? [0, "auto"] : void 0;
}
var X0e = function(e, r, n, a) {
  var i = e.graphicalItems, o = e.tooltipAxis, s = SH(r, e);
  return n < 0 || !i || !i.length || n >= s.length ? null : i.reduce(function(l, c) {
    var u, f = (u = c.props.data) !== null && u !== void 0 ? u : r;
    f && e.dataStartIndex + e.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    e.dataEndIndex - e.dataStartIndex >= n && (f = f.slice(e.dataStartIndex, e.dataEndIndex + 1));
    var h;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = f === void 0 ? s : f;
      h = gj(p, o.dataKey, a);
    } else
      h = f && f[n] || s[n];
    return h ? [].concat(e8(l), [Qdt(c, h)]) : l;
  }, []);
}, YNe = function(e, r, n, a) {
  var i = a || {
    x: e.chartX,
    y: e.chartY
  }, o = SGr(i, n), s = e.orderedTooltipTicks, l = e.tooltipAxis, c = e.tooltipTicks, u = eBr(o, s, c, l);
  if (u >= 0 && c) {
    var f = c[u] && c[u].value, h = X0e(e, r, u, f), p = _Gr(n, s, u, i);
    return {
      activeTooltipIndex: u,
      activeLabel: f,
      activePayload: h,
      activeCoordinate: p
    };
  }
  return null;
}, kGr = function(e, r) {
  var n = r.axes, a = r.graphicalItems, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = e.layout, f = e.children, h = e.stackOffset, p = qdt(u, i);
  return n.reduce(function(g, y) {
    var b, w = y.type.defaultProps !== void 0 ? ur(ur({}, y.type.defaultProps), y.props) : y.props, _ = w.type, C = w.dataKey, x = w.allowDataOverflow, S = w.allowDuplicatedCategory, A = w.scale, I = w.ticks, M = w.includeHidden, B = w[o];
    if (g[B])
      return g;
    var L = SH(e.data, {
      graphicalItems: a.filter(function(W) {
        var U, Z = o in W.props ? W.props[o] : (U = W.type.defaultProps) === null || U === void 0 ? void 0 : U[o];
        return Z === B;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), N = L.length, d, m, v;
    Yzr(w.domain, x, _) && (d = d0e(w.domain, null, x), p && (_ === "number" || A !== "auto") && (v = H_(L, C, "category")));
    var k = wft(_);
    if (!d || d.length === 0) {
      var O, G = (O = w.domain) !== null && O !== void 0 ? O : k;
      if (C) {
        if (d = H_(L, C, _), _ === "category" && p) {
          var H = zkr(d);
          S && H ? (m = d, d = tF(0, N)) : S || (d = JOe(G, d, y).reduce(function(W, U) {
            return W.indexOf(U) >= 0 ? W : [].concat(e8(W), [U]);
          }, []));
        } else if (_ === "category")
          S ? d = d.filter(function(W) {
            return W !== "" && !Va(W);
          }) : d = JOe(G, d, y).reduce(function(W, U) {
            return W.indexOf(U) >= 0 || U === "" || Va(U) ? W : [].concat(e8(W), [U]);
          }, []);
        else if (_ === "number") {
          var j = iBr(L, a.filter(function(W) {
            var U, Z, V = o in W.props ? W.props[o] : (U = W.type.defaultProps) === null || U === void 0 ? void 0 : U[o], Y = "hide" in W.props ? W.props.hide : (Z = W.type.defaultProps) === null || Z === void 0 ? void 0 : Z.hide;
            return V === B && (M || !Y);
          }), C, i, u);
          j && (d = j);
        }
        p && (_ === "number" || A !== "auto") && (v = H_(L, C, "category"));
      } else p ? d = tF(0, N) : s && s[B] && s[B].hasStack && _ === "number" ? d = h === "expand" ? [0, 1] : Xdt(s[B].stackGroups, l, c) : d = Vdt(L, a.filter(function(W) {
        var U = o in W.props ? W.props[o] : W.type.defaultProps[o], Z = "hide" in W.props ? W.props.hide : W.type.defaultProps.hide;
        return U === B && (M || !Z);
      }), _, u, !0);
      if (_ === "number")
        d = Z0e(f, d, B, i, I), G && (d = d0e(G, d, x));
      else if (_ === "category" && G) {
        var F = G, z = d.every(function(W) {
          return F.indexOf(W) >= 0;
        });
        z && (d = F);
      }
    }
    return ur(ur({}, g), {}, la({}, B, ur(ur({}, w), {}, {
      axisType: i,
      domain: d,
      categoricalDomain: v,
      duplicateDomain: m,
      originalDomain: (b = w.domain) !== null && b !== void 0 ? b : k,
      isCategorical: p,
      layout: u
    })));
  }, {});
}, AGr = function(e, r) {
  var n = r.graphicalItems, a = r.Axis, i = r.axisType, o = r.axisIdKey, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = e.layout, f = e.children, h = SH(e.data, {
    graphicalItems: n,
    dataStartIndex: l,
    dataEndIndex: c
  }), p = h.length, g = qdt(u, i), y = -1;
  return n.reduce(function(b, w) {
    var _ = w.type.defaultProps !== void 0 ? ur(ur({}, w.type.defaultProps), w.props) : w.props, C = _[o], x = wft("number");
    if (!b[C]) {
      y++;
      var S;
      return g ? S = tF(0, p) : s && s[C] && s[C].hasStack ? (S = Xdt(s[C].stackGroups, l, c), S = Z0e(f, S, C, i)) : (S = d0e(x, Vdt(h, n.filter(function(A) {
        var I, M, B = o in A.props ? A.props[o] : (I = A.type.defaultProps) === null || I === void 0 ? void 0 : I[o], L = "hide" in A.props ? A.props.hide : (M = A.type.defaultProps) === null || M === void 0 ? void 0 : M.hide;
        return B === C && !L;
      }), "number", u), a.defaultProps.allowDataOverflow), S = Z0e(f, S, C, i)), ur(ur({}, b), {}, la({}, C, ur(ur({
        axisType: i
      }, a.defaultProps), {}, {
        hide: !0,
        orientation: u0(CGr, "".concat(i, ".").concat(y % 2), null),
        domain: S,
        originalDomain: x,
        isCategorical: g,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return b;
  }, {});
}, TGr = function(e, r) {
  var n = r.axisType, a = n === void 0 ? "xAxis" : n, i = r.AxisComp, o = r.graphicalItems, s = r.stackGroups, l = r.dataStartIndex, c = r.dataEndIndex, u = e.children, f = "".concat(a, "Id"), h = d0(u, i), p = {};
  return h && h.length ? p = kGr(e, {
    axes: h,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  }) : o && o.length && (p = AGr(e, {
    Axis: i,
    graphicalItems: o,
    axisType: a,
    axisIdKey: f,
    stackGroups: s,
    dataStartIndex: l,
    dataEndIndex: c
  })), p;
}, EGr = function(e) {
  var r = vv(e), n = Sm(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: gye(n, function(a) {
      return a.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Gj(r, n)
  };
}, XNe = function(e) {
  var r = e.children, n = e.defaultShowTooltip, a = Zd(r, Gx), i = 0, o = 0;
  return e.data && e.data.length !== 0 && (o = e.data.length - 1), a && a.props && (a.props.startIndex >= 0 && (i = a.props.startIndex), a.props.endIndex >= 0 && (o = a.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: i,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, IGr = function(e) {
  return !e || !e.length ? !1 : e.some(function(r) {
    var n = Im(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, QNe = function(e) {
  return e === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : e === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : e === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, MGr = function(e, r) {
  var n = e.props, a = e.graphicalItems, i = e.xAxisMap, o = i === void 0 ? {} : i, s = e.yAxisMap, l = s === void 0 ? {} : s, c = n.width, u = n.height, f = n.children, h = n.margin || {}, p = Zd(f, Gx), g = Zd(f, Mm), y = Object.keys(l).reduce(function(S, A) {
    var I = l[A], M = I.orientation;
    return !I.mirror && !I.hide ? ur(ur({}, S), {}, la({}, M, S[M] + I.width)) : S;
  }, {
    left: h.left || 0,
    right: h.right || 0
  }), b = Object.keys(o).reduce(function(S, A) {
    var I = o[A], M = I.orientation;
    return !I.mirror && !I.hide ? ur(ur({}, S), {}, la({}, M, u0(S, "".concat(M)) + I.height)) : S;
  }, {
    top: h.top || 0,
    bottom: h.bottom || 0
  }), w = ur(ur({}, b), y), _ = w.bottom;
  p && (w.bottom += p.props.height || Gx.defaultProps.height), g && r && (w = nBr(w, a, n, r));
  var C = c - w.left - w.right, x = u - w.top - w.bottom;
  return ur(ur({
    brushBottom: _
  }, w), {}, {
    // never return negative values for height and width
    width: Math.max(C, 0),
    height: Math.max(x, 0)
  });
}, PGr = function(e, r) {
  if (r === "xAxis")
    return e[r].width;
  if (r === "yAxis")
    return e[r].height;
}, _H = function(e) {
  var r = e.chartName, n = e.GraphicalChild, a = e.defaultTooltipEventType, i = a === void 0 ? "axis" : a, o = e.validateTooltipEventTypes, s = o === void 0 ? ["axis"] : o, l = e.axisComponents, c = e.legendContent, u = e.formatAxisMap, f = e.defaultProps, h = function(w, _) {
    var C = _.graphicalItems, x = _.stackGroups, S = _.offset, A = _.updateId, I = _.dataStartIndex, M = _.dataEndIndex, B = w.barSize, L = w.layout, N = w.barGap, d = w.barCategoryGap, m = w.maxBarSize, v = QNe(L), k = v.numericAxisName, O = v.cateAxisName, G = IGr(C), H = [];
    return C.forEach(function(j, F) {
      var z = SH(w.data, {
        graphicalItems: [j],
        dataStartIndex: I,
        dataEndIndex: M
      }), W = j.type.defaultProps !== void 0 ? ur(ur({}, j.type.defaultProps), j.props) : j.props, U = W.dataKey, Z = W.maxBarSize, V = W["".concat(k, "Id")], Y = W["".concat(O, "Id")], ge = {}, ce = l.reduce(function(rt, qe) {
        var nt, Rt, Ot = _["".concat(qe.axisType, "Map")], lt = W["".concat(qe.axisType, "Id")];
        Ot && Ot[lt] || qe.axisType === "zAxis" || (Ar.env.NODE_ENV !== "production" ? pd(!1, "Specifying a(n) ".concat(qe.axisType, "Id requires a corresponding ").concat(
          qe.axisType,
          "Id on the targeted graphical component "
        ).concat((nt = j == null || (Rt = j.type) === null || Rt === void 0 ? void 0 : Rt.displayName) !== null && nt !== void 0 ? nt : "")) : pd());
        var mt = Ot[lt];
        return ur(ur({}, rt), {}, la(la({}, qe.axisType, mt), "".concat(qe.axisType, "Ticks"), Sm(mt)));
      }, ge), ee = ce[O], Se = ce["".concat(O, "Ticks")], Ce = x && x[V] && x[V].hasStack && pBr(j, x[V].stackGroups), we = Im(j.type).indexOf("Bar") >= 0, We = Gj(ee, Se), Fe = [], it = G && tBr({
        barSize: B,
        stackGroups: x,
        totalSize: PGr(ce, O)
      });
      if (we) {
        var gt, Ze, Ne = Va(Z) ? m : Z, ze = (gt = (Ze = Gj(ee, Se, !0)) !== null && Ze !== void 0 ? Ze : Ne) !== null && gt !== void 0 ? gt : 0;
        Fe = rBr({
          barGap: N,
          barCategoryGap: d,
          bandSize: ze !== We ? ze : We,
          sizeList: it[Y],
          maxBarSize: Ne
        }), ze !== We && (Fe = Fe.map(function(rt) {
          return ur(ur({}, rt), {}, {
            position: ur(ur({}, rt.position), {}, {
              offset: rt.position.offset - ze / 2
            })
          });
        }));
      }
      var ct = j && j.type && j.type.getComposedData;
      ct && H.push({
        props: ur(ur({}, ct(ur(ur({}, ce), {}, {
          displayedData: z,
          props: w,
          dataKey: U,
          item: j,
          bandSize: We,
          barPosition: Fe,
          offset: S,
          stackedData: Ce,
          layout: L,
          dataStartIndex: I,
          dataEndIndex: M
        }))), {}, la(la(la({
          key: j.key || "item-".concat(F)
        }, k, ce[k]), O, ce[O]), "animationId", A)),
        childIndex: Xkr(j, w.children),
        item: j
      });
    }), H;
  }, p = function(w, _) {
    var C = w.props, x = w.dataStartIndex, S = w.dataEndIndex, A = w.updateId;
    if (!uMe({
      props: C
    }))
      return null;
    var I = C.children, M = C.layout, B = C.stackOffset, L = C.data, N = C.reverseStackOrder, d = QNe(M), m = d.numericAxisName, v = d.cateAxisName, k = d0(I, n), O = fBr(L, k, "".concat(m, "Id"), "".concat(v, "Id"), B, N), G = l.reduce(function(W, U) {
      var Z = "".concat(U.axisType, "Map");
      return ur(ur({}, W), {}, la({}, Z, TGr(C, ur(ur({}, U), {}, {
        graphicalItems: k,
        stackGroups: U.axisType === m && O,
        dataStartIndex: x,
        dataEndIndex: S
      }))));
    }, {}), H = MGr(ur(ur({}, G), {}, {
      props: C,
      graphicalItems: k
    }), _ == null ? void 0 : _.legendBBox);
    Object.keys(G).forEach(function(W) {
      G[W] = u(C, G[W], H, W.replace("Map", ""), r);
    });
    var j = G["".concat(v, "Map")], F = EGr(j), z = h(C, ur(ur({}, G), {}, {
      dataStartIndex: x,
      dataEndIndex: S,
      updateId: A,
      graphicalItems: k,
      stackGroups: O,
      offset: H
    }));
    return ur(ur({
      formattedGraphicalItems: z,
      graphicalItems: k,
      offset: H,
      stackGroups: O
    }, F), G);
  }, g = /* @__PURE__ */ function(b) {
    function w(_) {
      var C, x, S;
      return uGr(this, w), S = hGr(this, w, [_]), la(S, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), la(S, "accessibilityManager", new Jzr()), la(S, "handleLegendBBoxUpdate", function(A) {
        if (A) {
          var I = S.state, M = I.dataStartIndex, B = I.dataEndIndex, L = I.updateId;
          S.setState(ur({
            legendBBox: A
          }, p({
            props: S.props,
            dataStartIndex: M,
            dataEndIndex: B,
            updateId: L
          }, ur(ur({}, S.state), {}, {
            legendBBox: A
          }))));
        }
      }), la(S, "handleReceiveSyncEvent", function(A, I, M) {
        if (S.props.syncId === A) {
          if (M === S.eventEmitterSymbol && typeof S.props.syncMethod != "function")
            return;
          S.applySyncEvent(I);
        }
      }), la(S, "handleBrushChange", function(A) {
        var I = A.startIndex, M = A.endIndex;
        if (I !== S.state.dataStartIndex || M !== S.state.dataEndIndex) {
          var B = S.state.updateId;
          S.setState(function() {
            return ur({
              dataStartIndex: I,
              dataEndIndex: M
            }, p({
              props: S.props,
              dataStartIndex: I,
              dataEndIndex: M,
              updateId: B
            }, S.state));
          }), S.triggerSyncEvent({
            dataStartIndex: I,
            dataEndIndex: M
          });
        }
      }), la(S, "handleMouseEnter", function(A) {
        var I = S.getMouseInfo(A);
        if (I) {
          var M = ur(ur({}, I), {}, {
            isTooltipActive: !0
          });
          S.setState(M), S.triggerSyncEvent(M);
          var B = S.props.onMouseEnter;
          ua(B) && B(M, A);
        }
      }), la(S, "triggeredAfterMouseMove", function(A) {
        var I = S.getMouseInfo(A), M = I ? ur(ur({}, I), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        S.setState(M), S.triggerSyncEvent(M);
        var B = S.props.onMouseMove;
        ua(B) && B(M, A);
      }), la(S, "handleItemMouseEnter", function(A) {
        S.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: A,
            activePayload: A.tooltipPayload,
            activeCoordinate: A.tooltipPosition || {
              x: A.cx,
              y: A.cy
            }
          };
        });
      }), la(S, "handleItemMouseLeave", function() {
        S.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), la(S, "handleMouseMove", function(A) {
        A.persist(), S.throttleTriggeredAfterMouseMove(A);
      }), la(S, "handleMouseLeave", function(A) {
        S.throttleTriggeredAfterMouseMove.cancel();
        var I = {
          isTooltipActive: !1
        };
        S.setState(I), S.triggerSyncEvent(I);
        var M = S.props.onMouseLeave;
        ua(M) && M(I, A);
      }), la(S, "handleOuterEvent", function(A) {
        var I = Ykr(A), M = u0(S.props, "".concat(I));
        if (I && ua(M)) {
          var B, L;
          /.*touch.*/i.test(I) ? L = S.getMouseInfo(A.changedTouches[0]) : L = S.getMouseInfo(A), M((B = L) !== null && B !== void 0 ? B : {}, A);
        }
      }), la(S, "handleClick", function(A) {
        var I = S.getMouseInfo(A);
        if (I) {
          var M = ur(ur({}, I), {}, {
            isTooltipActive: !0
          });
          S.setState(M), S.triggerSyncEvent(M);
          var B = S.props.onClick;
          ua(B) && B(M, A);
        }
      }), la(S, "handleMouseDown", function(A) {
        var I = S.props.onMouseDown;
        if (ua(I)) {
          var M = S.getMouseInfo(A);
          I(M, A);
        }
      }), la(S, "handleMouseUp", function(A) {
        var I = S.props.onMouseUp;
        if (ua(I)) {
          var M = S.getMouseInfo(A);
          I(M, A);
        }
      }), la(S, "handleTouchMove", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && S.throttleTriggeredAfterMouseMove(A.changedTouches[0]);
      }), la(S, "handleTouchStart", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && S.handleMouseDown(A.changedTouches[0]);
      }), la(S, "handleTouchEnd", function(A) {
        A.changedTouches != null && A.changedTouches.length > 0 && S.handleMouseUp(A.changedTouches[0]);
      }), la(S, "handleDoubleClick", function(A) {
        var I = S.props.onDoubleClick;
        if (ua(I)) {
          var M = S.getMouseInfo(A);
          I(M, A);
        }
      }), la(S, "handleContextMenu", function(A) {
        var I = S.props.onContextMenu;
        if (ua(I)) {
          var M = S.getMouseInfo(A);
          I(M, A);
        }
      }), la(S, "triggerSyncEvent", function(A) {
        S.props.syncId !== void 0 && $ae.emit(Dae, S.props.syncId, A, S.eventEmitterSymbol);
      }), la(S, "applySyncEvent", function(A) {
        var I = S.props, M = I.layout, B = I.syncMethod, L = S.state.updateId, N = A.dataStartIndex, d = A.dataEndIndex;
        if (A.dataStartIndex !== void 0 || A.dataEndIndex !== void 0)
          S.setState(ur({
            dataStartIndex: N,
            dataEndIndex: d
          }, p({
            props: S.props,
            dataStartIndex: N,
            dataEndIndex: d,
            updateId: L
          }, S.state)));
        else if (A.activeTooltipIndex !== void 0) {
          var m = A.chartX, v = A.chartY, k = A.activeTooltipIndex, O = S.state, G = O.offset, H = O.tooltipTicks;
          if (!G)
            return;
          if (typeof B == "function")
            k = B(H, A);
          else if (B === "value") {
            k = -1;
            for (var j = 0; j < H.length; j++)
              if (H[j].value === A.activeLabel) {
                k = j;
                break;
              }
          }
          var F = ur(ur({}, G), {}, {
            x: G.left,
            y: G.top
          }), z = Math.min(m, F.x + F.width), W = Math.min(v, F.y + F.height), U = H[k] && H[k].value, Z = X0e(S.state, S.props.data, k), V = H[k] ? {
            x: M === "horizontal" ? H[k].coordinate : z,
            y: M === "horizontal" ? W : H[k].coordinate
          } : Cft;
          S.setState(ur(ur({}, A), {}, {
            activeLabel: U,
            activeCoordinate: V,
            activePayload: Z,
            activeTooltipIndex: k
          }));
        } else
          S.setState(A);
      }), la(S, "renderCursor", function(A) {
        var I, M = S.state, B = M.isTooltipActive, L = M.activeCoordinate, N = M.activePayload, d = M.offset, m = M.activeTooltipIndex, v = M.tooltipAxisBandSize, k = S.getTooltipEventType(), O = (I = A.props.active) !== null && I !== void 0 ? I : B, G = S.props.layout, H = A.key || "_recharts-cursor";
        return /* @__PURE__ */ Te.createElement(nGr, {
          key: H,
          activeCoordinate: L,
          activePayload: N,
          activeTooltipIndex: m,
          chartName: r,
          element: A,
          isActive: O,
          layout: G,
          offset: d,
          tooltipAxisBandSize: v,
          tooltipEventType: k
        });
      }), la(S, "renderPolarAxis", function(A, I, M) {
        var B = u0(A, "type.axisType"), L = u0(S.state, "".concat(B, "Map")), N = A.type.defaultProps, d = N !== void 0 ? ur(ur({}, N), A.props) : A.props, m = L && L[d["".concat(B, "Id")]];
        return /* @__PURE__ */ xl(A, ur(ur({}, m), {}, {
          className: ti(B, m.className),
          key: A.key || "".concat(I, "-").concat(M),
          ticks: Sm(m, !0)
        }));
      }), la(S, "renderPolarGrid", function(A) {
        var I = A.props, M = I.radialLines, B = I.polarAngles, L = I.polarRadius, N = S.state, d = N.radiusAxisMap, m = N.angleAxisMap, v = vv(d), k = vv(m), O = k.cx, G = k.cy, H = k.innerRadius, j = k.outerRadius;
        return /* @__PURE__ */ xl(A, {
          polarAngles: Array.isArray(B) ? B : Sm(k, !0).map(function(F) {
            return F.coordinate;
          }),
          polarRadius: Array.isArray(L) ? L : Sm(v, !0).map(function(F) {
            return F.coordinate;
          }),
          cx: O,
          cy: G,
          innerRadius: H,
          outerRadius: j,
          key: A.key || "polar-grid",
          radialLines: M
        });
      }), la(S, "renderLegend", function() {
        var A = S.state.formattedGraphicalItems, I = S.props, M = I.children, B = I.width, L = I.height, N = S.props.margin || {}, d = B - (N.left || 0) - (N.right || 0), m = Hdt({
          children: M,
          formattedGraphicalItems: A,
          legendWidth: d,
          legendContent: c
        });
        if (!m)
          return null;
        var v = m.item, k = ZNe(m, aGr);
        return /* @__PURE__ */ xl(v, ur(ur({}, k), {}, {
          chartWidth: B,
          chartHeight: L,
          margin: N,
          onBBoxUpdate: S.handleLegendBBoxUpdate
        }));
      }), la(S, "renderTooltip", function() {
        var A, I = S.props, M = I.children, B = I.accessibilityLayer, L = Zd(M, Jd);
        if (!L)
          return null;
        var N = S.state, d = N.isTooltipActive, m = N.activeCoordinate, v = N.activePayload, k = N.activeLabel, O = N.offset, G = (A = L.props.active) !== null && A !== void 0 ? A : d;
        return /* @__PURE__ */ xl(L, {
          viewBox: ur(ur({}, O), {}, {
            x: O.left,
            y: O.top
          }),
          active: G,
          label: k,
          payload: G ? v : [],
          coordinate: m,
          accessibilityLayer: B
        });
      }), la(S, "renderBrush", function(A) {
        var I = S.props, M = I.margin, B = I.data, L = S.state, N = L.offset, d = L.dataStartIndex, m = L.dataEndIndex, v = L.updateId;
        return /* @__PURE__ */ xl(A, {
          key: A.key || "_recharts-brush",
          onChange: aN(S.handleBrushChange, A.props.onChange),
          data: B,
          x: Ur(A.props.x) ? A.props.x : N.left,
          y: Ur(A.props.y) ? A.props.y : N.top + N.height + N.brushBottom - (M.bottom || 0),
          width: Ur(A.props.width) ? A.props.width : N.width,
          startIndex: d,
          endIndex: m,
          updateId: "brush-".concat(v)
        });
      }), la(S, "renderReferenceElement", function(A, I, M) {
        if (!A)
          return null;
        var B = S, L = B.clipPathId, N = S.state, d = N.xAxisMap, m = N.yAxisMap, v = N.offset, k = A.type.defaultProps || {}, O = A.props, G = O.xAxisId, H = G === void 0 ? k.xAxisId : G, j = O.yAxisId, F = j === void 0 ? k.yAxisId : j;
        return /* @__PURE__ */ xl(A, {
          key: A.key || "".concat(I, "-").concat(M),
          xAxis: d[H],
          yAxis: m[F],
          viewBox: {
            x: v.left,
            y: v.top,
            width: v.width,
            height: v.height
          },
          clipPathId: L
        });
      }), la(S, "renderActivePoints", function(A) {
        var I = A.item, M = A.activePoint, B = A.basePoint, L = A.childIndex, N = A.isRange, d = [], m = I.props.key, v = I.item.type.defaultProps !== void 0 ? ur(ur({}, I.item.type.defaultProps), I.item.props) : I.item.props, k = v.activeDot, O = v.dataKey, G = ur(ur({
          index: L,
          dataKey: O,
          cx: M.x,
          cy: M.y,
          r: 4,
          fill: Wye(I.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: M.payload,
          value: M.value
        }, Un(k, !1)), vj(k));
        return d.push(w.renderActiveDot(k, G, "".concat(m, "-activePoint-").concat(L))), B ? d.push(w.renderActiveDot(k, ur(ur({}, G), {}, {
          cx: B.x,
          cy: B.y
        }), "".concat(m, "-basePoint-").concat(L))) : N && d.push(null), d;
      }), la(S, "renderGraphicChild", function(A, I, M) {
        var B = S.filterFormatItem(A, I, M);
        if (!B)
          return null;
        var L = S.getTooltipEventType(), N = S.state, d = N.isTooltipActive, m = N.tooltipAxis, v = N.activeTooltipIndex, k = N.activeLabel, O = S.props.children, G = Zd(O, Jd), H = B.props, j = H.points, F = H.isRange, z = H.baseLine, W = B.item.type.defaultProps !== void 0 ? ur(ur({}, B.item.type.defaultProps), B.item.props) : B.item.props, U = W.activeDot, Z = W.hide, V = W.activeBar, Y = W.activeShape, ge = !!(!Z && d && G && (U || V || Y)), ce = {};
        L !== "axis" && G && G.props.trigger === "click" ? ce = {
          onClick: aN(S.handleItemMouseEnter, A.props.onClick)
        } : L !== "axis" && (ce = {
          onMouseLeave: aN(S.handleItemMouseLeave, A.props.onMouseLeave),
          onMouseEnter: aN(S.handleItemMouseEnter, A.props.onMouseEnter)
        });
        var ee = /* @__PURE__ */ xl(A, ur(ur({}, B.props), ce));
        function Se(qe) {
          return typeof m.dataKey == "function" ? m.dataKey(qe.payload) : null;
        }
        if (ge)
          if (v >= 0) {
            var Ce, we;
            if (m.dataKey && !m.allowDuplicatedCategory) {
              var We = typeof m.dataKey == "function" ? Se : "payload.".concat(m.dataKey.toString());
              Ce = gj(j, We, k), we = F && z && gj(z, We, k);
            } else
              Ce = j == null ? void 0 : j[v], we = F && z && z[v];
            if (Y || V) {
              var Fe = A.props.activeIndex !== void 0 ? A.props.activeIndex : v;
              return [/* @__PURE__ */ xl(A, ur(ur(ur({}, B.props), ce), {}, {
                activeIndex: Fe
              })), null, null];
            }
            if (!Va(Ce))
              return [ee].concat(e8(S.renderActivePoints({
                item: B,
                activePoint: Ce,
                basePoint: we,
                childIndex: v,
                isRange: F
              })));
          } else {
            var it, gt = (it = S.getItemByXY(S.state.activeCoordinate)) !== null && it !== void 0 ? it : {
              graphicalItem: ee
            }, Ze = gt.graphicalItem, Ne = Ze.item, ze = Ne === void 0 ? A : Ne, ct = Ze.childIndex, rt = ur(ur(ur({}, B.props), ce), {}, {
              activeIndex: ct
            });
            return [/* @__PURE__ */ xl(ze, rt), null, null];
          }
        return F ? [ee, null, null] : [ee, null];
      }), la(S, "renderCustomized", function(A, I, M) {
        return /* @__PURE__ */ xl(A, ur(ur({
          key: "recharts-customized-".concat(M)
        }, S.props), S.state));
      }), la(S, "renderMap", {
        CartesianGrid: {
          handler: cN,
          once: !0
        },
        ReferenceArea: {
          handler: S.renderReferenceElement
        },
        ReferenceLine: {
          handler: cN
        },
        ReferenceDot: {
          handler: S.renderReferenceElement
        },
        XAxis: {
          handler: cN
        },
        YAxis: {
          handler: cN
        },
        Brush: {
          handler: S.renderBrush,
          once: !0
        },
        Bar: {
          handler: S.renderGraphicChild
        },
        Line: {
          handler: S.renderGraphicChild
        },
        Area: {
          handler: S.renderGraphicChild
        },
        Radar: {
          handler: S.renderGraphicChild
        },
        RadialBar: {
          handler: S.renderGraphicChild
        },
        Scatter: {
          handler: S.renderGraphicChild
        },
        Pie: {
          handler: S.renderGraphicChild
        },
        Funnel: {
          handler: S.renderGraphicChild
        },
        Tooltip: {
          handler: S.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: S.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: S.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: S.renderPolarAxis
        },
        Customized: {
          handler: S.renderCustomized
        }
      }), S.clipPathId = "".concat((C = _.id) !== null && C !== void 0 ? C : b6("recharts"), "-clip"), S.throttleTriggeredAfterMouseMove = Fut(S.triggeredAfterMouseMove, (x = _.throttleDelay) !== null && x !== void 0 ? x : 1e3 / 60), S.state = {}, S;
    }
    return gGr(w, b), fGr(w, [{
      key: "componentDidMount",
      value: function() {
        var C, x;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (C = this.props.margin.left) !== null && C !== void 0 ? C : 0,
            top: (x = this.props.margin.top) !== null && x !== void 0 ? x : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var C = this.props, x = C.children, S = C.data, A = C.height, I = C.layout, M = Zd(x, Jd);
        if (M) {
          var B = M.props.defaultIndex;
          if (!(typeof B != "number" || B < 0 || B > this.state.tooltipTicks.length - 1)) {
            var L = this.state.tooltipTicks[B] && this.state.tooltipTicks[B].value, N = X0e(this.state, S, B, L), d = this.state.tooltipTicks[B].coordinate, m = (this.state.offset.top + A) / 2, v = I === "horizontal", k = v ? {
              x: d,
              y: m
            } : {
              y: d,
              x: m
            }, O = this.state.formattedGraphicalItems.find(function(H) {
              var j = H.item;
              return j.type.name === "Scatter";
            });
            O && (k = ur(ur({}, k), O.props.points[B].tooltipPosition), N = O.props.points[B].tooltipPayload);
            var G = {
              activeTooltipIndex: B,
              isTooltipActive: !0,
              activeLabel: L,
              activePayload: N,
              activeCoordinate: k
            };
            this.setState(G), this.renderCursor(M), this.accessibilityManager.setIndex(B);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(C, x) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== x.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== C.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== C.margin) {
          var S, A;
          this.accessibilityManager.setDetails({
            offset: {
              left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
              top: (A = this.props.margin.top) !== null && A !== void 0 ? A : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(C) {
        Rde([Zd(C.children, Jd)], [Zd(this.props.children, Jd)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var C = Zd(this.props.children, Jd);
        if (C && typeof C.props.shared == "boolean") {
          var x = C.props.shared ? "axis" : "item";
          return s.indexOf(x) >= 0 ? x : i;
        }
        return i;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(C) {
        if (!this.container)
          return null;
        var x = this.container, S = x.getBoundingClientRect(), A = jIr(S), I = {
          chartX: Math.round(C.pageX - A.left),
          chartY: Math.round(C.pageY - A.top)
        }, M = S.width / x.offsetWidth || 1, B = this.inRange(I.chartX, I.chartY, M);
        if (!B)
          return null;
        var L = this.state, N = L.xAxisMap, d = L.yAxisMap, m = this.getTooltipEventType();
        if (m !== "axis" && N && d) {
          var v = vv(N).scale, k = vv(d).scale, O = v && v.invert ? v.invert(I.chartX) : null, G = k && k.invert ? k.invert(I.chartY) : null;
          return ur(ur({}, I), {}, {
            xValue: O,
            yValue: G
          });
        }
        var H = YNe(this.state, this.props.data, this.props.layout, B);
        return H ? ur(ur({}, I), H) : null;
      }
    }, {
      key: "inRange",
      value: function(C, x) {
        var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, A = this.props.layout, I = C / S, M = x / S;
        if (A === "horizontal" || A === "vertical") {
          var B = this.state.offset, L = I >= B.left && I <= B.left + B.width && M >= B.top && M <= B.top + B.height;
          return L ? {
            x: I,
            y: M
          } : null;
        }
        var N = this.state, d = N.angleAxisMap, m = N.radiusAxisMap;
        if (d && m) {
          var v = vv(d);
          return QOe({
            x: I,
            y: M
          }, v);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var C = this.props.children, x = this.getTooltipEventType(), S = Zd(C, Jd), A = {};
        S && x === "axis" && (S.props.trigger === "click" ? A = {
          onClick: this.handleClick
        } : A = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var I = vj(this.props, this.handleOuterEvent);
        return ur(ur({}, I), A);
      }
    }, {
      key: "addListener",
      value: function() {
        $ae.on(Dae, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        $ae.removeListener(Dae, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(C, x, S) {
        for (var A = this.state.formattedGraphicalItems, I = 0, M = A.length; I < M; I++) {
          var B = A[I];
          if (B.item === C || B.props.key === C.key || x === Im(B.item.type) && S === B.childIndex)
            return B;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var C = this.clipPathId, x = this.state.offset, S = x.left, A = x.top, I = x.height, M = x.width;
        return /* @__PURE__ */ Te.createElement("defs", null, /* @__PURE__ */ Te.createElement("clipPath", {
          id: C
        }, /* @__PURE__ */ Te.createElement("rect", {
          x: S,
          y: A,
          height: I,
          width: M
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var C = this.state.xAxisMap;
        return C ? Object.entries(C).reduce(function(x, S) {
          var A = KNe(S, 2), I = A[0], M = A[1];
          return ur(ur({}, x), {}, la({}, I, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var C = this.state.yAxisMap;
        return C ? Object.entries(C).reduce(function(x, S) {
          var A = KNe(S, 2), I = A[0], M = A[1];
          return ur(ur({}, x), {}, la({}, I, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(C) {
        var x;
        return (x = this.state.xAxisMap) === null || x === void 0 || (x = x[C]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(C) {
        var x;
        return (x = this.state.yAxisMap) === null || x === void 0 || (x = x[C]) === null || x === void 0 ? void 0 : x.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(C) {
        var x = this.state, S = x.formattedGraphicalItems, A = x.activeItem;
        if (S && S.length)
          for (var I = 0, M = S.length; I < M; I++) {
            var B = S[I], L = B.props, N = B.item, d = N.type.defaultProps !== void 0 ? ur(ur({}, N.type.defaultProps), N.props) : N.props, m = Im(N.type);
            if (m === "Bar") {
              var v = (L.data || []).find(function(H) {
                return K$r(C, H);
              });
              if (v)
                return {
                  graphicalItem: B,
                  payload: v
                };
            } else if (m === "RadialBar") {
              var k = (L.data || []).find(function(H) {
                return QOe(C, H);
              });
              if (k)
                return {
                  graphicalItem: B,
                  payload: k
                };
            } else if (mH(B, A) || gH(B, A) || JE(B, A)) {
              var O = yLr({
                graphicalItem: B,
                activeTooltipItem: A,
                itemData: d.data
              }), G = d.activeIndex === void 0 ? O : d.activeIndex;
              return {
                graphicalItem: ur(ur({}, B), {}, {
                  childIndex: G
                }),
                payload: JE(B, A) ? d.data[O] : B.props.data[O]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var C = this;
        if (!uMe(this))
          return null;
        var x = this.props, S = x.children, A = x.className, I = x.width, M = x.height, B = x.style, L = x.compact, N = x.title, d = x.desc, m = ZNe(x, iGr), v = Un(m, !1);
        if (L)
          return /* @__PURE__ */ Te.createElement(TNe, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ Te.createElement(Bde, X9({}, v, {
            width: I,
            height: M,
            title: N,
            desc: d
          }), this.renderClipPath(), fMe(S, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var k, O;
          v.tabIndex = (k = this.props.tabIndex) !== null && k !== void 0 ? k : 0, v.role = (O = this.props.role) !== null && O !== void 0 ? O : "application", v.onKeyDown = function(H) {
            C.accessibilityManager.keyboardEvent(H);
          }, v.onFocus = function() {
            C.accessibilityManager.focus();
          };
        }
        var G = this.parseEventsOfWrapper();
        return /* @__PURE__ */ Te.createElement(TNe, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ Te.createElement("div", X9({
          className: ti("recharts-wrapper", A),
          style: ur({
            position: "relative",
            cursor: "default",
            width: I,
            height: M
          }, B)
        }, G, {
          ref: function(j) {
            C.container = j;
          }
        }), /* @__PURE__ */ Te.createElement(Bde, X9({}, v, {
          width: I,
          height: M,
          title: N,
          desc: d,
          style: wGr
        }), this.renderClipPath(), fMe(S, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(QF);
  la(g, "displayName", r), la(g, "defaultProps", ur({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), la(g, "getDerivedStateFromProps", function(b, w) {
    var _ = b.dataKey, C = b.data, x = b.children, S = b.width, A = b.height, I = b.layout, M = b.stackOffset, B = b.margin, L = w.dataStartIndex, N = w.dataEndIndex;
    if (w.updateId === void 0) {
      var d = XNe(b);
      return ur(ur(ur({}, d), {}, {
        updateId: 0
      }, p(ur(ur({
        props: b
      }, d), {}, {
        updateId: 0
      }), w)), {}, {
        prevDataKey: _,
        prevData: C,
        prevWidth: S,
        prevHeight: A,
        prevLayout: I,
        prevStackOffset: M,
        prevMargin: B,
        prevChildren: x
      });
    }
    if (_ !== w.prevDataKey || C !== w.prevData || S !== w.prevWidth || A !== w.prevHeight || I !== w.prevLayout || M !== w.prevStackOffset || !k7(B, w.prevMargin)) {
      var m = XNe(b), v = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: w.chartX,
        chartY: w.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: w.isTooltipActive
      }, k = ur(ur({}, YNe(w, C, I)), {}, {
        updateId: w.updateId + 1
      }), O = ur(ur(ur({}, m), v), k);
      return ur(ur(ur({}, O), p(ur({
        props: b
      }, O), w)), {}, {
        prevDataKey: _,
        prevData: C,
        prevWidth: S,
        prevHeight: A,
        prevLayout: I,
        prevStackOffset: M,
        prevMargin: B,
        prevChildren: x
      });
    }
    if (!Rde(x, w.prevChildren)) {
      var G, H, j, F, z = Zd(x, Gx), W = z && (G = (H = z.props) === null || H === void 0 ? void 0 : H.startIndex) !== null && G !== void 0 ? G : L, U = z && (j = (F = z.props) === null || F === void 0 ? void 0 : F.endIndex) !== null && j !== void 0 ? j : N, Z = W !== L || U !== N, V = !Va(C), Y = V && !Z ? w.updateId : w.updateId + 1;
      return ur(ur({
        updateId: Y
      }, p(ur(ur({
        props: b
      }, w), {}, {
        updateId: Y,
        dataStartIndex: W,
        dataEndIndex: U
      }), w)), {}, {
        prevChildren: x,
        dataStartIndex: W,
        dataEndIndex: U
      });
    }
    return null;
  }), la(g, "renderActiveDot", function(b, w, _) {
    var C;
    return /* @__PURE__ */ ef(b) ? C = /* @__PURE__ */ xl(b, w) : ua(b) ? C = b(w) : C = /* @__PURE__ */ Te.createElement(tg, w), /* @__PURE__ */ Te.createElement(Fi, {
      className: "recharts-active-dot",
      key: _
    }, C);
  });
  var y = /* @__PURE__ */ Ml(function(w, _) {
    return /* @__PURE__ */ Te.createElement(g, X9({}, w, {
      ref: _
    }));
  });
  return y.displayName = g.displayName, y;
}, RGr = _H({
  chartName: "LineChart",
  GraphicalChild: $5,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: e3
  }, {
    axisType: "yAxis",
    AxisComp: t3
  }],
  formatAxisMap: qye
}), OGr = _H({
  chartName: "BarChart",
  GraphicalChild: w6,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: e3
  }, {
    axisType: "yAxis",
    AxisComp: t3
  }],
  formatAxisMap: qye
}), BGr = _H({
  chartName: "PieChart",
  GraphicalChild: Cg,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: pH
  }, {
    axisType: "radiusAxis",
    AxisComp: fH
  }],
  formatAxisMap: _Br,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), NGr = _H({
  chartName: "AreaChart",
  GraphicalChild: Qy,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: e3
  }, {
    axisType: "yAxis",
    AxisComp: t3
  }],
  formatAxisMap: qye
});
const Sft = {
  blue: {
    bg: "bg-blue-500",
    stroke: "stroke-blue-500",
    fill: "fill-blue-500",
    text: "text-blue-500"
  },
  emerald: {
    bg: "bg-emerald-500",
    stroke: "stroke-emerald-500",
    fill: "fill-emerald-500",
    text: "text-emerald-500"
  },
  violet: {
    bg: "bg-violet-500",
    stroke: "stroke-violet-500",
    fill: "fill-violet-500",
    text: "text-violet-500"
  },
  amber: {
    bg: "bg-amber-500",
    stroke: "stroke-amber-500",
    fill: "fill-amber-500",
    text: "text-amber-500"
  },
  gray: {
    bg: "bg-gray-500",
    stroke: "stroke-gray-500",
    fill: "fill-gray-500",
    text: "text-gray-500"
  },
  cyan: {
    bg: "bg-cyan-500",
    stroke: "stroke-cyan-500",
    fill: "fill-cyan-500",
    text: "text-cyan-500"
  },
  pink: {
    bg: "bg-pink-500",
    stroke: "stroke-pink-500",
    fill: "fill-pink-500",
    text: "text-pink-500"
  },
  lime: {
    bg: "bg-lime-500",
    stroke: "stroke-lime-500",
    fill: "fill-lime-500",
    text: "text-lime-500"
  },
  fuchsia: {
    bg: "bg-fuchsia-500",
    stroke: "stroke-fuchsia-500",
    fill: "fill-fuchsia-500",
    text: "text-fuchsia-500"
  }
}, rg = Object.keys(
  Sft
), kH = (t, e) => {
  const r = /* @__PURE__ */ new Map();
  return t.forEach((n, a) => {
    r.set(n, e[a % e.length]);
  }), r;
}, Yc = (t, e) => {
  var n;
  const r = {
    bg: "bg-gray-500",
    stroke: "stroke-gray-500",
    fill: "fill-gray-500",
    text: "text-gray-500"
  };
  return ((n = Sft[t]) == null ? void 0 : n[e]) ?? r[e];
}, n3e = (t, e, r) => [t ? "auto" : e ?? 0, r ?? "auto"];
function E7(t, e) {
  const r = [];
  for (const n of t)
    if (Object.prototype.hasOwnProperty.call(n, e) && (r.push(n[e]), r.length > 1))
      return !1;
  return !0;
}
const a3e = (t) => {
  P.useEffect(() => {
    const e = () => {
      t();
    };
    return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
  }, [t]);
}, i3e = "-", $Gr = (t) => {
  const e = LGr(t), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = t;
  return {
    getClassGroupId: (o) => {
      const s = o.split(i3e);
      return s[0] === "" && s.length !== 1 && s.shift(), _ft(s, e) || DGr(o);
    },
    getConflictingClassGroupIds: (o, s) => {
      const l = r[o] || [];
      return s && n[o] ? [...l, ...n[o]] : l;
    }
  };
}, _ft = (t, e) => {
  var o;
  if (t.length === 0)
    return e.classGroupId;
  const r = t[0], n = e.nextPart.get(r), a = n ? _ft(t.slice(1), n) : void 0;
  if (a)
    return a;
  if (e.validators.length === 0)
    return;
  const i = t.join(i3e);
  return (o = e.validators.find(({
    validator: s
  }) => s(i))) == null ? void 0 : o.classGroupId;
}, e$e = /^\[(.+)\]$/, DGr = (t) => {
  if (e$e.test(t)) {
    const e = e$e.exec(t)[1], r = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, LGr = (t) => {
  const {
    theme: e,
    prefix: r
  } = t, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return FGr(Object.entries(t.classGroups), r).forEach(([i, o]) => {
    Q0e(o, n, i, e);
  }), n;
}, Q0e = (t, e, r, n) => {
  t.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? e : t$e(e, a);
      i.classGroupId = r;
      return;
    }
    if (typeof a == "function") {
      if (jGr(a)) {
        Q0e(a(n), e, r, n);
        return;
      }
      e.validators.push({
        validator: a,
        classGroupId: r
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      Q0e(o, t$e(e, i), r, n);
    });
  });
}, t$e = (t, e) => {
  let r = t;
  return e.split(i3e).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, jGr = (t) => t.isThemeGetter, FGr = (t, e) => e ? t.map(([r, n]) => {
  const a = n.map((i) => typeof i == "string" ? e + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, s]) => [e + o, s])) : i);
  return [r, a];
}) : t, zGr = (t) => {
  if (t < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const a = (i, o) => {
    r.set(i, o), e++, e > t && (e = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let o = r.get(i);
      if (o !== void 0)
        return o;
      if ((o = n.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      r.has(i) ? r.set(i, o) : a(i, o);
    }
  };
}, kft = "!", GGr = (t) => {
  const {
    separator: e,
    experimentalParseClassName: r
  } = t, n = e.length === 1, a = e[0], i = e.length, o = (s) => {
    const l = [];
    let c = 0, u = 0, f;
    for (let b = 0; b < s.length; b++) {
      let w = s[b];
      if (c === 0) {
        if (w === a && (n || s.slice(b, b + i) === e)) {
          l.push(s.slice(u, b)), u = b + i;
          continue;
        }
        if (w === "/") {
          f = b;
          continue;
        }
      }
      w === "[" ? c++ : w === "]" && c--;
    }
    const h = l.length === 0 ? s : s.substring(u), p = h.startsWith(kft), g = p ? h.substring(1) : h, y = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: y
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: o
  }) : o;
}, WGr = (t) => {
  if (t.length <= 1)
    return t;
  const e = [];
  let r = [];
  return t.forEach((n) => {
    n[0] === "[" ? (e.push(...r.sort(), n), r = []) : r.push(n);
  }), e.push(...r.sort()), e;
}, HGr = (t) => ({
  cache: zGr(t.cacheSize),
  parseClassName: GGr(t),
  ...$Gr(t)
}), UGr = /\s+/, VGr = (t, e) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: a
  } = e, i = [], o = t.trim().split(UGr);
  let s = "";
  for (let l = o.length - 1; l >= 0; l -= 1) {
    const c = o[l], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: p
    } = r(c);
    let g = !!p, y = n(g ? h.substring(0, p) : h);
    if (!y) {
      if (!g) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (y = n(h), !y) {
        s = c + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const b = WGr(u).join(":"), w = f ? b + kft : b, _ = w + y;
    if (i.includes(_))
      continue;
    i.push(_);
    const C = a(y, g);
    for (let x = 0; x < C.length; ++x) {
      const S = C[x];
      i.push(w + S);
    }
    s = c + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function qGr() {
  let t = 0, e, r, n = "";
  for (; t < arguments.length; )
    (e = arguments[t++]) && (r = Aft(e)) && (n && (n += " "), n += r);
  return n;
}
const Aft = (t) => {
  if (typeof t == "string")
    return t;
  let e, r = "";
  for (let n = 0; n < t.length; n++)
    t[n] && (e = Aft(t[n])) && (r && (r += " "), r += e);
  return r;
};
function efe(t, ...e) {
  let r, n, a, i = o;
  function o(l) {
    const c = e.reduce((u, f) => f(u), t());
    return r = HGr(c), n = r.cache.get, a = r.cache.set, i = s, s(l);
  }
  function s(l) {
    const c = n(l);
    if (c)
      return c;
    const u = VGr(l, r);
    return a(l, u), u;
  }
  return function() {
    return i(qGr.apply(null, arguments));
  };
}
const ys = (t) => {
  const e = (r) => r[t] || [];
  return e.isThemeGetter = !0, e;
}, Tft = /^\[(?:([a-z-]+):)?(.+)\]$/i, KGr = /^\d+\/\d+$/, ZGr = /* @__PURE__ */ new Set(["px", "full", "screen"]), JGr = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, YGr = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, XGr = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, QGr = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, eWr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, jp = (t) => I7(t) || ZGr.has(t) || KGr.test(t), Xg = (t) => uC(t, "length", lWr), I7 = (t) => !!t && !Number.isNaN(Number(t)), jae = (t) => uC(t, "number", I7), pS = (t) => !!t && Number.isInteger(Number(t)), tWr = (t) => t.endsWith("%") && I7(t.slice(0, -1)), xi = (t) => Tft.test(t), Qg = (t) => JGr.test(t), rWr = /* @__PURE__ */ new Set(["length", "size", "percentage"]), nWr = (t) => uC(t, rWr, Eft), aWr = (t) => uC(t, "position", Eft), iWr = /* @__PURE__ */ new Set(["image", "url"]), oWr = (t) => uC(t, iWr, uWr), sWr = (t) => uC(t, "", cWr), mS = () => !0, uC = (t, e, r) => {
  const n = Tft.exec(t);
  return n ? n[1] ? typeof e == "string" ? n[1] === e : e.has(n[1]) : r(n[2]) : !1;
}, lWr = (t) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  YGr.test(t) && !XGr.test(t)
), Eft = () => !1, cWr = (t) => QGr.test(t), uWr = (t) => eWr.test(t), tfe = () => {
  const t = ys("colors"), e = ys("spacing"), r = ys("blur"), n = ys("brightness"), a = ys("borderColor"), i = ys("borderRadius"), o = ys("borderSpacing"), s = ys("borderWidth"), l = ys("contrast"), c = ys("grayscale"), u = ys("hueRotate"), f = ys("invert"), h = ys("gap"), p = ys("gradientColorStops"), g = ys("gradientColorStopPositions"), y = ys("inset"), b = ys("margin"), w = ys("opacity"), _ = ys("padding"), C = ys("saturate"), x = ys("scale"), S = ys("sepia"), A = ys("skew"), I = ys("space"), M = ys("translate"), B = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], N = () => ["auto", xi, e], d = () => [xi, e], m = () => ["", jp, Xg], v = () => ["auto", I7, xi], k = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], O = () => ["solid", "dashed", "dotted", "double", "none"], G = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], H = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], j = () => ["", "0", xi], F = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], z = () => [I7, xi];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [mS],
      spacing: [jp, Xg],
      blur: ["none", "", Qg, xi],
      brightness: z(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Qg, xi],
      borderSpacing: d(),
      borderWidth: m(),
      contrast: z(),
      grayscale: j(),
      hueRotate: z(),
      invert: j(),
      gap: d(),
      gradientColorStops: [t],
      gradientColorStopPositions: [tWr, Xg],
      inset: N(),
      margin: N(),
      opacity: z(),
      padding: d(),
      saturate: z(),
      scale: z(),
      sepia: j(),
      skew: z(),
      space: d(),
      translate: d()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", xi]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Qg]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": F()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": F()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...k(), xi]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: B()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": B()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": B()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [y]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [y]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [y]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [y]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [y]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [y]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [y]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [y]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [y]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", pS, xi]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: N()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", xi]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: j()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: j()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", pS, xi]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [mS]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", pS, xi]
        }, xi]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": v()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": v()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [mS]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [pS, xi]
        }, xi]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": v()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": v()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", xi]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", xi]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...H()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...H(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...H(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [_]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [_]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [_]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [_]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [_]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [_]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [_]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [_]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [_]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [b]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [b]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [b]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [b]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [b]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [b]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [b]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [b]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [b]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", xi, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [xi, e, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [xi, e, "none", "full", "min", "max", "fit", "prose", {
          screen: [Qg]
        }, Qg]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [xi, e, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [xi, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [xi, e, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [xi, e, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Qg, Xg]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", jae]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [mS]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", xi]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", I7, jae]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", jp, xi]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", xi]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", xi]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [w]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [w]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...O(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", jp, Xg]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", jp, xi]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: d()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", xi]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", xi]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [w]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...k(), aWr]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", nWr]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, oWr]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [w]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...O(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [w]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: O()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [a]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...O()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [jp, xi]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [jp, Xg]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: m()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [w]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [jp, Xg]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Qg, sWr]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [mS]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [w]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...G(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": G()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Qg, xi]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [w]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", xi]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: z()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", xi]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: z()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", xi]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [pS, xi]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [M]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [M]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", xi]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", xi]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": d()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": d()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": d()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": d()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": d()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": d()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": d()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": d()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": d()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": d()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": d()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": d()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": d()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": d()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": d()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": d()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": d()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": d()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", xi]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [jp, Xg, jae]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, dWr = (t, {
  cacheSize: e,
  prefix: r,
  separator: n,
  experimentalParseClassName: a,
  extend: i = {},
  override: o = {}
}) => {
  u_(t, "cacheSize", e), u_(t, "prefix", r), u_(t, "separator", n), u_(t, "experimentalParseClassName", a);
  for (const s in o)
    fWr(t[s], o[s]);
  for (const s in i)
    hWr(t[s], i[s]);
  return t;
}, u_ = (t, e, r) => {
  r !== void 0 && (t[e] = r);
}, fWr = (t, e) => {
  if (e)
    for (const r in e)
      u_(t, r, e[r]);
}, hWr = (t, e) => {
  if (e)
    for (const r in e) {
      const n = e[r];
      n !== void 0 && (t[r] = (t[r] || []).concat(n));
    }
}, pWr = (t, ...e) => typeof t == "function" ? efe(tfe, t, ...e) : efe(() => dWr(tfe(), t), ...e), Ift = /* @__PURE__ */ efe(tfe);
function Hr(...t) {
  return Ift(ti(...t));
}
const vF = [
  // base
  "outline outline-offset-2 outline-0 focus-visible:outline-2",
  // outline color
  "outline-blue-500 dark:outline-blue-500"
], mWr = ({
  name: t,
  color: e,
  onClick: r,
  activeLegend: n
}) => {
  const a = !!r;
  return /* @__PURE__ */ R.jsxs(
    "li",
    {
      className: Hr(
        // base
        "group inline-flex flex-nowrap items-center gap-1.5 whitespace-nowrap rounded px-2 py-1 transition",
        a ? "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800" : "cursor-default"
      ),
      onClick: (i) => {
        i.stopPropagation(), r == null || r(t, e);
      },
      children: [
        /* @__PURE__ */ R.jsx(
          "span",
          {
            className: Hr(
              "h-[3px] w-3.5 shrink-0 rounded-full",
              Yc(e, "bg"),
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            "aria-hidden": !0
          }
        ),
        /* @__PURE__ */ R.jsx(
          "p",
          {
            className: Hr(
              // base
              "truncate whitespace-nowrap text-xs",
              // text color
              "text-gray-700 dark:text-gray-300",
              a && "group-hover:text-gray-900 dark:group-hover:text-gray-50",
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            children: t
          }
        )
      ]
    }
  );
}, r$e = ({ icon: t, onClick: e, disabled: r }) => {
  const n = t, [a, i] = Te.useState(!1), o = Te.useRef(null);
  return Te.useEffect(() => (a ? o.current = setInterval(() => {
    e == null || e();
  }, 300) : clearInterval(o.current), () => clearInterval(o.current)), [a, e]), Te.useEffect(() => {
    r && (clearInterval(o.current), i(!1));
  }, [r]), /* @__PURE__ */ R.jsx(
    "button",
    {
      type: "button",
      className: Hr(
        // base
        "group inline-flex size-5 items-center truncate rounded transition",
        r ? "cursor-not-allowed text-gray-400 dark:text-gray-600" : "cursor-pointer text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-50"
      ),
      disabled: r,
      onClick: (s) => {
        s.stopPropagation(), e == null || e();
      },
      onMouseDown: (s) => {
        s.stopPropagation(), i(!0);
      },
      onMouseUp: (s) => {
        s.stopPropagation(), i(!1);
      },
      children: /* @__PURE__ */ R.jsx(n, { className: "size-full", "aria-hidden": "true" })
    }
  );
}, Mft = Te.forwardRef((t, e) => {
  const {
    categories: r,
    colors: n = rg,
    className: a,
    onClickLegendItem: i,
    activeLegend: o,
    enableLegendSlider: s = !1,
    ...l
  } = t, c = Te.useRef(null), u = Te.useRef(null), [f, h] = Te.useState(null), [p, g] = Te.useState(null), y = Te.useRef(null), b = Te.useCallback(() => {
    const x = c == null ? void 0 : c.current;
    if (!x) return;
    const S = x.scrollLeft > 0, A = x.scrollWidth - x.clientWidth > x.scrollLeft;
    h({ left: S, right: A });
  }, [h]), w = Te.useCallback(
    (x) => {
      const S = c == null ? void 0 : c.current, A = u == null ? void 0 : u.current, I = (A == null ? void 0 : A.clientWidth) ?? 0, M = (S == null ? void 0 : S.clientWidth) ?? 0;
      S && s && (S.scrollTo({
        left: x === "left" ? S.scrollLeft - M + I : S.scrollLeft + M - I,
        behavior: "smooth"
      }), setTimeout(() => {
        b();
      }, 400));
    },
    [s, b]
  );
  Te.useEffect(() => {
    const x = (S) => {
      S === "ArrowLeft" ? w("left") : S === "ArrowRight" && w("right");
    };
    return p ? (x(p), y.current = setInterval(() => {
      x(p);
    }, 300)) : clearInterval(y.current), () => clearInterval(y.current);
  }, [p, w]);
  const _ = (x) => {
    x.stopPropagation(), (x.key === "ArrowLeft" || x.key === "ArrowRight") && (x.preventDefault(), g(x.key));
  }, C = (x) => {
    x.stopPropagation(), g(null);
  };
  return Te.useEffect(() => {
    const x = c == null ? void 0 : c.current;
    return s && (b(), x == null || x.addEventListener("keydown", _), x == null || x.addEventListener("keyup", C)), () => {
      x == null || x.removeEventListener("keydown", _), x == null || x.removeEventListener("keyup", C);
    };
  }, [b, s]), /* @__PURE__ */ R.jsxs(
    "ol",
    {
      ref: e,
      className: Hr("relative overflow-hidden", a),
      ...l,
      children: [
        /* @__PURE__ */ R.jsx(
          "div",
          {
            ref: c,
            tabIndex: 0,
            className: Hr(
              "flex h-full",
              s ? f != null && f.right || f != null && f.left ? "snap-mandatory items-center overflow-auto pl-4 pr-12 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" : "" : "flex-wrap"
            ),
            children: r.map((x, S) => /* @__PURE__ */ R.jsx(
              mWr,
              {
                name: x,
                color: n[S],
                onClick: i,
                activeLegend: o
              },
              `item-${S}`
            ))
          }
        ),
        s && (f != null && f.right || f != null && f.left) ? /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsxs(
          "div",
          {
            className: Hr(
              // base
              "absolute bottom-0 right-0 top-0 flex h-full items-center justify-center pr-1",
              // background color
              "bg-white dark:bg-gray-950"
            ),
            children: [
              /* @__PURE__ */ R.jsx(
                r$e,
                {
                  icon: qve,
                  onClick: () => {
                    g(null), w("left");
                  },
                  disabled: !(f != null && f.left)
                }
              ),
              /* @__PURE__ */ R.jsx(
                r$e,
                {
                  icon: Kve,
                  onClick: () => {
                    g(null), w("right");
                  },
                  disabled: !(f != null && f.right)
                }
              )
            ]
          }
        ) }) : null
      ]
    }
  );
});
Mft.displayName = "Legend";
const gWr = ({ payload: t }, e, r, n, a, i, o, s) => {
  const l = Te.useRef(null);
  a3e(() => {
    var h;
    r(((p) => p ? Number(p) + 15 : 60)((h = l.current) == null ? void 0 : h.clientHeight));
  });
  const c = t.filter((f) => f.type !== "none"), u = o === "left" && s ? s - 8 : 0;
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      ref: l,
      style: { paddingLeft: u },
      className: Hr(
        "flex items-center",
        { "justify-center": o === "center" },
        { "justify-start": o === "left" },
        { "justify-end": o === "right" }
      ),
      children: /* @__PURE__ */ R.jsx(
        Mft,
        {
          categories: c.map((f) => f.value),
          colors: c.map(
            (f) => e.get(f.value)
          ),
          onClickLegendItem: a,
          activeLegend: n,
          enableLegendSlider: i
        }
      )
    }
  );
}, vWr = ({
  active: t,
  payload: e,
  label: r,
  valueFormatter: n
}) => t && e && e.length ? /* @__PURE__ */ R.jsxs(
  "div",
  {
    className: Hr(
      // base
      "rounded-md border text-sm shadow-md",
      // border color
      "border-gray-200 dark:border-gray-800",
      // background color
      "bg-white dark:bg-gray-950"
    ),
    children: [
      /* @__PURE__ */ R.jsx("div", { className: Hr("border-b border-inherit px-4 py-2"), children: /* @__PURE__ */ R.jsx(
        "p",
        {
          className: Hr(
            // base
            "font-medium",
            // text color
            "text-gray-900 dark:text-gray-50"
          ),
          children: r
        }
      ) }),
      /* @__PURE__ */ R.jsx("div", { className: Hr("space-y-1 px-4 py-2"), children: e.map(({ value: a, category: i, color: o }, s) => /* @__PURE__ */ R.jsxs(
        "div",
        {
          className: "flex items-center justify-between space-x-8",
          children: [
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
              /* @__PURE__ */ R.jsx(
                "span",
                {
                  "aria-hidden": "true",
                  className: Hr(
                    "h-[3px] w-3.5 shrink-0 rounded-full",
                    Yc(o, "bg")
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                "p",
                {
                  className: Hr(
                    // base
                    "whitespace-nowrap text-right",
                    // text color
                    "text-gray-700 dark:text-gray-300"
                  ),
                  children: i
                }
              )
            ] }),
            /* @__PURE__ */ R.jsx(
              "p",
              {
                className: Hr(
                  // base
                  "whitespace-nowrap text-right font-medium tabular-nums",
                  // text color
                  "text-gray-900 dark:text-gray-50"
                ),
                children: n(a)
              }
            )
          ]
        },
        `id-${s}`
      )) })
    ]
  }
) : null, Pft = Te.forwardRef(
  (t, e) => {
    const {
      data: r = [],
      categories: n = [],
      index: a,
      colors: i = rg,
      valueFormatter: o = (it) => it.toString(),
      startEndOnly: s = !1,
      showXAxis: l = !0,
      showYAxis: c = !0,
      showGridLines: u = !0,
      yAxisWidth: f = 56,
      intervalType: h = "equidistantPreserveStart",
      showTooltip: p = !0,
      showLegend: g = !0,
      autoMinValue: y = !1,
      minValue: b,
      maxValue: w,
      allowDecimals: _ = !0,
      connectNulls: C = !1,
      className: x,
      onValueChange: S,
      enableLegendSlider: A = !1,
      tickGap: I = 5,
      xAxisLabel: M,
      yAxisLabel: B,
      type: L = "default",
      legendPosition: N = "right",
      fill: d = "gradient",
      tooltipCallback: m,
      customTooltip: v,
      ...k
    } = t, O = v, G = !l && !c || s && !c ? 0 : 20, [H, j] = Te.useState(60), [F, z] = Te.useState(
      void 0
    ), [W, U] = Te.useState(
      void 0
    ), Z = kH(n, i), V = n3e(y, b, w), Y = !!S, ge = L === "stacked" || L === "percent", ce = Te.useId(), ee = Te.useRef(void 0), Se = Te.useRef(void 0), Ce = ({
      fillType: it,
      activeDot: gt,
      activeLegend: Ze,
      category: Ne
    }) => {
      const ze = gt || Ze && Ze !== Ne ? 0.1 : 0.3;
      switch (it) {
        case "none":
          return /* @__PURE__ */ R.jsx("stop", { stopColor: "currentColor", stopOpacity: 0 });
        case "gradient":
          return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
            /* @__PURE__ */ R.jsx(
              "stop",
              {
                offset: "5%",
                stopColor: "currentColor",
                stopOpacity: ze
              }
            ),
            /* @__PURE__ */ R.jsx("stop", { offset: "95%", stopColor: "currentColor", stopOpacity: 0 })
          ] });
        case "solid":
        default:
          return /* @__PURE__ */ R.jsx("stop", { stopColor: "currentColor", stopOpacity: ze });
      }
    };
    function we(it) {
      return `${(it * 100).toFixed(0)}%`;
    }
    function We(it, gt) {
      gt.stopPropagation(), Y && (it.index === (F == null ? void 0 : F.index) && it.dataKey === (F == null ? void 0 : F.dataKey) || E7(r, it.dataKey) && W && W === it.dataKey ? (U(void 0), z(void 0), S == null || S(null)) : (U(it.dataKey), z({
        index: it.index,
        dataKey: it.dataKey
      }), S == null || S({
        eventType: "dot",
        categoryClicked: it.dataKey,
        ...it.payload
      })));
    }
    function Fe(it) {
      Y && (it === W && !F || E7(r, it) && F && F.dataKey === it ? (U(void 0), S == null || S(null)) : (U(it), S == null || S({
        eventType: "category",
        categoryClicked: it
      })), z(void 0));
    }
    return /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: e,
        className: Hr("h-80 w-full", x),
        "tremor-id": "tremor-raw",
        ...k,
        children: /* @__PURE__ */ R.jsx(YW, { children: /* @__PURE__ */ R.jsxs(
          NGr,
          {
            data: r,
            onClick: Y && (W || F) ? () => {
              z(void 0), U(void 0), S == null || S(null);
            } : void 0,
            margin: {
              bottom: M ? 30 : void 0,
              left: B ? 20 : void 0,
              right: B ? 5 : void 0,
              top: 5
            },
            stackOffset: L === "percent" ? "expand" : void 0,
            children: [
              u ? /* @__PURE__ */ R.jsx(
                wH,
                {
                  className: Hr("stroke-gray-200 stroke-1 dark:stroke-gray-800"),
                  horizontal: !0,
                  vertical: !1
                }
              ) : null,
              /* @__PURE__ */ R.jsx(
                e3,
                {
                  padding: { left: G, right: G },
                  hide: !l,
                  dataKey: a,
                  interval: s ? "preserveStartEnd" : h,
                  tick: { transform: "translate(0, 6)" },
                  ticks: s ? [r[0][a], r[r.length - 1][a]] : void 0,
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500"
                  ),
                  tickLine: !1,
                  axisLine: !1,
                  minTickGap: I,
                  children: M && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideBottom",
                      offset: -20,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: M
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                t3,
                {
                  width: f,
                  hide: !c,
                  axisLine: !1,
                  tickLine: !1,
                  type: "number",
                  domain: V,
                  tick: { transform: "translate(-3, 0)" },
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500"
                  ),
                  tickFormatter: L === "percent" ? we : o,
                  allowDecimals: _,
                  children: B && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideLeft",
                      style: { textAnchor: "middle" },
                      angle: -90,
                      offset: -15,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: B
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                Jd,
                {
                  wrapperStyle: { outline: "none" },
                  isAnimationActive: !0,
                  animationDuration: 100,
                  cursor: { stroke: "#d1d5db", strokeWidth: 1 },
                  offset: 20,
                  position: { y: 0 },
                  content: ({ active: it, payload: gt, label: Ze }) => {
                    const Ne = gt ? gt.map((ze) => ({
                      category: ze.dataKey,
                      value: ze.value,
                      index: ze.payload[a],
                      color: Z.get(
                        ze.dataKey
                      ),
                      type: ze.type,
                      payload: ze.payload
                    })) : [];
                    return m && (it !== ee.current || Ze !== Se.current) && (m({ active: it, payload: Ne, label: Ze }), ee.current = it, Se.current = Ze), p && it ? O ? /* @__PURE__ */ R.jsx(
                      O,
                      {
                        active: it,
                        payload: Ne,
                        label: Ze
                      }
                    ) : /* @__PURE__ */ R.jsx(
                      vWr,
                      {
                        active: it,
                        payload: Ne,
                        label: Ze,
                        valueFormatter: o
                      }
                    ) : null;
                  }
                }
              ),
              g ? /* @__PURE__ */ R.jsx(
                Mm,
                {
                  verticalAlign: "top",
                  height: H,
                  content: ({ payload: it }) => gWr(
                    { payload: it },
                    Z,
                    j,
                    W,
                    Y ? (gt) => Fe(gt) : void 0,
                    A,
                    N,
                    f
                  )
                }
              ) : null,
              n.map((it) => {
                const gt = `${ce}-${it.replace(
                  /[^a-zA-Z0-9]/g,
                  ""
                )}`;
                return /* @__PURE__ */ R.jsxs(Te.Fragment, { children: [
                  /* @__PURE__ */ R.jsx("defs", { children: /* @__PURE__ */ R.jsx(
                    "linearGradient",
                    {
                      className: Hr(
                        Yc(
                          Z.get(
                            it
                          ),
                          "text"
                        )
                      ),
                      id: gt,
                      x1: "0",
                      y1: "0",
                      x2: "0",
                      y2: "1",
                      children: Ce({
                        fillType: d,
                        activeDot: F,
                        activeLegend: W,
                        category: it
                      })
                    },
                    it
                  ) }, it),
                  /* @__PURE__ */ R.jsx(
                    Qy,
                    {
                      className: Hr(
                        Yc(
                          Z.get(
                            it
                          ),
                          "stroke"
                        )
                      ),
                      strokeOpacity: F || W && W !== it ? 0.3 : 1,
                      activeDot: (Ze) => {
                        const {
                          cx: Ne,
                          cy: ze,
                          stroke: ct,
                          strokeLinecap: rt,
                          strokeLinejoin: qe,
                          strokeWidth: nt,
                          dataKey: Rt
                        } = Ze;
                        return /* @__PURE__ */ R.jsx(
                          tg,
                          {
                            className: Hr(
                              "stroke-white dark:stroke-gray-950",
                              S ? "cursor-pointer" : "",
                              Yc(
                                Z.get(
                                  Rt
                                ),
                                "fill"
                              )
                            ),
                            cx: Ne,
                            cy: ze,
                            r: 5,
                            fill: "",
                            stroke: ct,
                            strokeLinecap: rt,
                            strokeLinejoin: qe,
                            strokeWidth: nt,
                            onClick: (Ot, lt) => We(Ze, lt)
                          }
                        );
                      },
                      dot: (Ze) => {
                        const {
                          stroke: Ne,
                          strokeLinecap: ze,
                          strokeLinejoin: ct,
                          strokeWidth: rt,
                          cx: qe,
                          cy: nt,
                          dataKey: Rt,
                          index: Ot
                        } = Ze;
                        return E7(r, it) && !(F || W && W !== it) || (F == null ? void 0 : F.index) === Ot && (F == null ? void 0 : F.dataKey) === it ? /* @__PURE__ */ R.jsx(
                          tg,
                          {
                            cx: qe,
                            cy: nt,
                            r: 5,
                            stroke: Ne,
                            fill: "",
                            strokeLinecap: ze,
                            strokeLinejoin: ct,
                            strokeWidth: rt,
                            className: Hr(
                              "stroke-white dark:stroke-gray-950",
                              S ? "cursor-pointer" : "",
                              Yc(
                                Z.get(
                                  Rt
                                ),
                                "fill"
                              )
                            )
                          },
                          Ot
                        ) : /* @__PURE__ */ R.jsx(Te.Fragment, {}, Ot);
                      },
                      name: it,
                      type: "linear",
                      dataKey: it,
                      stroke: "",
                      strokeWidth: 2,
                      strokeLinejoin: "round",
                      strokeLinecap: "round",
                      isAnimationActive: !1,
                      connectNulls: C,
                      stackId: ge ? "stack" : void 0,
                      fill: `url(#${gt})`
                    },
                    it
                  )
                ] }, it);
              }),
              S ? n.map((it) => /* @__PURE__ */ R.jsx(
                $5,
                {
                  className: Hr("cursor-pointer"),
                  strokeOpacity: 0,
                  name: it,
                  type: "linear",
                  dataKey: it,
                  stroke: "transparent",
                  fill: "transparent",
                  legendType: "none",
                  tooltipType: "none",
                  strokeWidth: 12,
                  connectNulls: C,
                  onClick: (gt, Ze) => {
                    Ze.stopPropagation();
                    const { name: Ne } = gt;
                    Fe(Ne);
                  }
                },
                it
              )) : null
            ]
          }
        ) })
      }
    );
  }
);
Pft.displayName = "AreaChart";
function o3e(t, e) {
  if (t === e) return !0;
  if (typeof t != "object" || typeof e != "object" || t === null || e === null)
    return !1;
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length) return !1;
  for (const a of r)
    if (!n.includes(a) || !o3e(t[a], e[a])) return !1;
  return !0;
}
const yWr = (t, e, r, n) => {
  const { fillOpacity: a, name: i, payload: o, value: s } = t;
  let { x: l, width: c, y: u, height: f } = t;
  return n === "horizontal" && f < 0 ? (u += f, f = Math.abs(f)) : n === "vertical" && c < 0 && (l += c, c = Math.abs(c)), /* @__PURE__ */ R.jsx(
    "rect",
    {
      x: l,
      y: u,
      width: c,
      height: f,
      opacity: e || r && r !== i ? o3e(e, { ...o, value: s }) ? a : 0.3 : a
    }
  );
}, bWr = ({
  name: t,
  color: e,
  onClick: r,
  activeLegend: n
}) => {
  const a = !!r;
  return /* @__PURE__ */ R.jsxs(
    "li",
    {
      className: Hr(
        // base
        "group inline-flex flex-nowrap items-center gap-1.5 whitespace-nowrap rounded px-2 py-1 transition",
        a ? "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800" : "cursor-default"
      ),
      onClick: (i) => {
        i.stopPropagation(), r == null || r(t, e);
      },
      children: [
        /* @__PURE__ */ R.jsx(
          "span",
          {
            className: Hr(
              "size-2 shrink-0 rounded-sm",
              Yc(e, "bg"),
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            "aria-hidden": !0
          }
        ),
        /* @__PURE__ */ R.jsx(
          "p",
          {
            className: Hr(
              // base
              "truncate whitespace-nowrap text-xs",
              // text color
              "text-gray-700 dark:text-gray-300",
              a && "group-hover:text-gray-900 dark:group-hover:text-gray-50",
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            children: t
          }
        )
      ]
    }
  );
}, n$e = ({ icon: t, onClick: e, disabled: r }) => {
  const n = t, [a, i] = Te.useState(!1), o = Te.useRef(null);
  return Te.useEffect(() => (a ? o.current = setInterval(() => {
    e == null || e();
  }, 300) : clearInterval(o.current), () => clearInterval(o.current)), [a, e]), Te.useEffect(() => {
    r && (clearInterval(o.current), i(!1));
  }, [r]), /* @__PURE__ */ R.jsx(
    "button",
    {
      type: "button",
      className: Hr(
        // base
        "group inline-flex size-5 items-center truncate rounded transition",
        r ? "cursor-not-allowed text-gray-400 dark:text-gray-600" : "cursor-pointer text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-50"
      ),
      disabled: r,
      onClick: (s) => {
        s.stopPropagation(), e == null || e();
      },
      onMouseDown: (s) => {
        s.stopPropagation(), i(!0);
      },
      onMouseUp: (s) => {
        s.stopPropagation(), i(!1);
      },
      children: /* @__PURE__ */ R.jsx(n, { className: "size-full", "aria-hidden": "true" })
    }
  );
}, Rft = Te.forwardRef((t, e) => {
  const {
    categories: r,
    colors: n = rg,
    className: a,
    onClickLegendItem: i,
    activeLegend: o,
    enableLegendSlider: s = !1,
    ...l
  } = t, c = Te.useRef(null), u = Te.useRef(null), [f, h] = Te.useState(null), [p, g] = Te.useState(null), y = Te.useRef(null), b = Te.useCallback(() => {
    const x = c == null ? void 0 : c.current;
    if (!x) return;
    const S = x.scrollLeft > 0, A = x.scrollWidth - x.clientWidth > x.scrollLeft;
    h({ left: S, right: A });
  }, [h]), w = Te.useCallback(
    (x) => {
      const S = c == null ? void 0 : c.current, A = u == null ? void 0 : u.current, I = (A == null ? void 0 : A.clientWidth) ?? 0, M = (S == null ? void 0 : S.clientWidth) ?? 0;
      S && s && (S.scrollTo({
        left: x === "left" ? S.scrollLeft - M + I : S.scrollLeft + M - I,
        behavior: "smooth"
      }), setTimeout(() => {
        b();
      }, 400));
    },
    [s, b]
  );
  Te.useEffect(() => {
    const x = (S) => {
      S === "ArrowLeft" ? w("left") : S === "ArrowRight" && w("right");
    };
    return p ? (x(p), y.current = setInterval(() => {
      x(p);
    }, 300)) : clearInterval(y.current), () => clearInterval(y.current);
  }, [p, w]);
  const _ = (x) => {
    x.stopPropagation(), (x.key === "ArrowLeft" || x.key === "ArrowRight") && (x.preventDefault(), g(x.key));
  }, C = (x) => {
    x.stopPropagation(), g(null);
  };
  return Te.useEffect(() => {
    const x = c == null ? void 0 : c.current;
    return s && (b(), x == null || x.addEventListener("keydown", _), x == null || x.addEventListener("keyup", C)), () => {
      x == null || x.removeEventListener("keydown", _), x == null || x.removeEventListener("keyup", C);
    };
  }, [b, s]), /* @__PURE__ */ R.jsxs(
    "ol",
    {
      ref: e,
      className: Hr("relative overflow-hidden", a),
      ...l,
      children: [
        /* @__PURE__ */ R.jsx(
          "div",
          {
            ref: c,
            tabIndex: 0,
            className: Hr(
              "flex h-full",
              s ? f != null && f.right || f != null && f.left ? "snap-mandatory items-center overflow-auto pl-4 pr-12 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" : "" : "flex-wrap"
            ),
            children: r.map((x, S) => /* @__PURE__ */ R.jsx(
              bWr,
              {
                name: x,
                color: n[S],
                onClick: i,
                activeLegend: o
              },
              `item-${S}`
            ))
          }
        ),
        s && (f != null && f.right || f != null && f.left) ? /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsxs(
          "div",
          {
            className: Hr(
              // base
              "absolute bottom-0 right-0 top-0 flex h-full items-center justify-center pr-1",
              // background color
              "bg-white dark:bg-gray-950"
            ),
            children: [
              /* @__PURE__ */ R.jsx(
                n$e,
                {
                  icon: qve,
                  onClick: () => {
                    g(null), w("left");
                  },
                  disabled: !(f != null && f.left)
                }
              ),
              /* @__PURE__ */ R.jsx(
                n$e,
                {
                  icon: Kve,
                  onClick: () => {
                    g(null), w("right");
                  },
                  disabled: !(f != null && f.right)
                }
              )
            ]
          }
        ) }) : null
      ]
    }
  );
});
Rft.displayName = "Legend";
const xWr = ({ payload: t }, e, r, n, a, i, o, s) => {
  const l = Te.useRef(null);
  a3e(() => {
    var h;
    r(((p) => p ? Number(p) + 15 : 60)((h = l.current) == null ? void 0 : h.clientHeight));
  });
  const c = t.filter((f) => f.type !== "none"), u = o === "left" && s ? s - 8 : 0;
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      style: { paddingLeft: u },
      ref: l,
      className: Hr(
        "flex items-center",
        { "justify-center": o === "center" },
        {
          "justify-start": o === "left"
        },
        { "justify-end": o === "right" }
      ),
      children: /* @__PURE__ */ R.jsx(
        Rft,
        {
          categories: c.map((f) => f.value),
          colors: c.map(
            (f) => e.get(f.value)
          ),
          onClickLegendItem: a,
          activeLegend: n,
          enableLegendSlider: i
        }
      )
    }
  );
}, CWr = ({
  active: t,
  payload: e,
  label: r,
  valueFormatter: n
}) => t && e && e.length ? /* @__PURE__ */ R.jsxs(
  "div",
  {
    className: Hr(
      // base
      "rounded-md border text-sm shadow-md",
      // border color
      "border-gray-200 dark:border-gray-800",
      // background color
      "bg-white dark:bg-gray-950"
    ),
    children: [
      /* @__PURE__ */ R.jsx("div", { className: Hr("border-b border-inherit px-4 py-2"), children: /* @__PURE__ */ R.jsx(
        "p",
        {
          className: Hr(
            // base
            "font-medium",
            // text color
            "text-gray-900 dark:text-gray-50"
          ),
          children: r
        }
      ) }),
      /* @__PURE__ */ R.jsx("div", { className: Hr("space-y-1 px-4 py-2"), children: e.map(({ value: a, category: i, color: o }, s) => /* @__PURE__ */ R.jsxs(
        "div",
        {
          className: "flex items-center justify-between space-x-8",
          children: [
            /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
              /* @__PURE__ */ R.jsx(
                "span",
                {
                  "aria-hidden": "true",
                  className: Hr(
                    "size-2 shrink-0 rounded-sm",
                    Yc(o, "bg")
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                "p",
                {
                  className: Hr(
                    // base
                    "whitespace-nowrap text-right",
                    // text color
                    "text-gray-700 dark:text-gray-300"
                  ),
                  children: i
                }
              )
            ] }),
            /* @__PURE__ */ R.jsx(
              "p",
              {
                className: Hr(
                  // base
                  "whitespace-nowrap text-right font-medium tabular-nums",
                  // text color
                  "text-gray-900 dark:text-gray-50"
                ),
                children: n(a)
              }
            )
          ]
        },
        `id-${s}`
      )) })
    ]
  }
) : null, s3e = Te.forwardRef(
  (t, e) => {
    const {
      data: r = [],
      categories: n = [],
      index: a,
      colors: i = rg,
      valueFormatter: o = (We) => We.toString(),
      startEndOnly: s = !1,
      showXAxis: l = !0,
      showYAxis: c = !0,
      showGridLines: u = !0,
      yAxisWidth: f = 56,
      intervalType: h = "equidistantPreserveStart",
      showTooltip: p = !0,
      showLegend: g = !0,
      autoMinValue: y = !1,
      minValue: b,
      maxValue: w,
      allowDecimals: _ = !0,
      className: C,
      onValueChange: x,
      enableLegendSlider: S = !1,
      barCategoryGap: A,
      tickGap: I = 5,
      xAxisLabel: M,
      yAxisLabel: B,
      layout: L = "horizontal",
      type: N = "default",
      legendPosition: d = "right",
      tooltipCallback: m,
      customTooltip: v,
      ...k
    } = t, O = v, G = !l && !c || s && !c ? 0 : 20, [H, j] = Te.useState(60), [F, z] = Te.useState(
      void 0
    ), W = kH(n, i), [U, Z] = Te.useState(
      void 0
    ), V = n3e(y, b, w), Y = !!x, ge = N === "stacked" || N === "percent", ce = Te.useRef(void 0), ee = Te.useRef(void 0);
    function Se(We) {
      return `${(We * 100).toFixed(0)}%`;
    }
    function Ce(We, Fe, it) {
      var gt, Ze, Ne, ze;
      it.stopPropagation(), x && (o3e(U, { ...We.payload, value: We.value }) ? (z(void 0), Z(void 0), x == null || x(null)) : (z((Ze = (gt = We.tooltipPayload) == null ? void 0 : gt[0]) == null ? void 0 : Ze.dataKey), Z({
        ...We.payload,
        value: We.value
      }), x == null || x({
        eventType: "bar",
        categoryClicked: (ze = (Ne = We.tooltipPayload) == null ? void 0 : Ne[0]) == null ? void 0 : ze.dataKey,
        ...We.payload
      })));
    }
    function we(We) {
      Y && (We === F && !U ? (z(void 0), x == null || x(null)) : (z(We), x == null || x({
        eventType: "category",
        categoryClicked: We
      })), Z(void 0));
    }
    return /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: e,
        className: Hr("h-80 w-full", C),
        "tremor-id": "tremor-raw",
        ...k,
        children: /* @__PURE__ */ R.jsx(YW, { children: /* @__PURE__ */ R.jsxs(
          OGr,
          {
            data: r,
            onClick: Y && (F || U) ? () => {
              Z(void 0), z(void 0), x == null || x(null);
            } : void 0,
            margin: {
              bottom: M ? 30 : void 0,
              left: B ? 20 : void 0,
              right: B ? 5 : void 0,
              top: 5
            },
            stackOffset: N === "percent" ? "expand" : void 0,
            layout: L,
            barCategoryGap: A,
            children: [
              u ? /* @__PURE__ */ R.jsx(
                wH,
                {
                  className: Hr("stroke-gray-200 stroke-1 dark:stroke-gray-800"),
                  horizontal: L !== "vertical",
                  vertical: L === "vertical"
                }
              ) : null,
              /* @__PURE__ */ R.jsx(
                e3,
                {
                  hide: !l,
                  tick: {
                    transform: L !== "vertical" ? "translate(0, 6)" : void 0
                  },
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500",
                    { "mt-4": L !== "vertical" }
                  ),
                  tickLine: !1,
                  axisLine: !1,
                  minTickGap: I,
                  ...L !== "vertical" ? {
                    padding: {
                      left: G,
                      right: G
                    },
                    dataKey: a,
                    interval: s ? "preserveStartEnd" : h,
                    ticks: s ? [r[0][a], r[r.length - 1][a]] : void 0
                  } : {
                    type: "number",
                    domain: V,
                    tickFormatter: N === "percent" ? Se : o,
                    allowDecimals: _
                  },
                  children: M && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideBottom",
                      offset: -20,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: M
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                t3,
                {
                  width: f,
                  hide: !c,
                  axisLine: !1,
                  tickLine: !1,
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500"
                  ),
                  tick: {
                    transform: L !== "vertical" ? "translate(-3, 0)" : "translate(0, 0)"
                  },
                  ...L !== "vertical" ? {
                    type: "number",
                    domain: V,
                    tickFormatter: N === "percent" ? Se : o,
                    allowDecimals: _
                  } : {
                    dataKey: a,
                    ticks: s ? [r[0][a], r[r.length - 1][a]] : void 0,
                    type: "category",
                    interval: "equidistantPreserveStart"
                  },
                  children: B && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideLeft",
                      style: { textAnchor: "middle" },
                      angle: -90,
                      offset: -15,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: B
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                Jd,
                {
                  wrapperStyle: { outline: "none" },
                  isAnimationActive: !0,
                  animationDuration: 100,
                  cursor: { fill: "#d1d5db", opacity: "0.15" },
                  offset: 20,
                  position: {
                    y: L === "horizontal" ? 0 : void 0,
                    x: L === "horizontal" ? void 0 : f + 20
                  },
                  content: ({ active: We, payload: Fe, label: it }) => {
                    const gt = Fe ? Fe.map((Ze) => ({
                      category: Ze.dataKey,
                      value: Ze.value,
                      index: Ze.payload[a],
                      color: W.get(
                        Ze.dataKey
                      ),
                      type: Ze.type,
                      payload: Ze.payload
                    })) : [];
                    return m && (We !== ce.current || it !== ee.current) && (m({ active: We, payload: gt, label: it }), ce.current = We, ee.current = it), p && We ? O ? /* @__PURE__ */ R.jsx(
                      O,
                      {
                        active: We,
                        payload: gt,
                        label: it
                      }
                    ) : /* @__PURE__ */ R.jsx(
                      CWr,
                      {
                        active: We,
                        payload: gt,
                        label: it,
                        valueFormatter: o
                      }
                    ) : null;
                  }
                }
              ),
              g ? /* @__PURE__ */ R.jsx(
                Mm,
                {
                  verticalAlign: "top",
                  height: H,
                  content: ({ payload: We }) => xWr(
                    { payload: We },
                    W,
                    j,
                    F,
                    Y ? (Fe) => we(Fe) : void 0,
                    S,
                    d,
                    f
                  )
                }
              ) : null,
              n.map((We) => /* @__PURE__ */ R.jsx(
                w6,
                {
                  className: Hr(
                    Yc(
                      W.get(We),
                      "fill"
                    ),
                    x ? "cursor-pointer" : ""
                  ),
                  name: We,
                  type: "linear",
                  dataKey: We,
                  stackId: ge ? "stack" : void 0,
                  isAnimationActive: !1,
                  fill: "",
                  shape: (Fe) => yWr(Fe, U, F, L),
                  onClick: Ce
                },
                We
              ))
            ]
          }
        ) })
      }
    );
  }
);
s3e.displayName = "BarChart";
function Oft({
  data: t = [],
  valueFormatter: e = (l) => l.toString(),
  showAnimation: r = !1,
  onValueChange: n,
  sortOrder: a = "descending",
  className: i,
  ...o
}, s) {
  const l = n ? "button" : "div", c = Te.useMemo(() => a === "none" ? t : [...t].sort((h, p) => a === "ascending" ? h.value - p.value : p.value - h.value), [t, a]), u = Te.useMemo(() => {
    const h = Math.max(...c.map((p) => p.value), 0);
    return c.map(
      (p) => p.value === 0 ? 0 : Math.max(p.value / h * 100, 2)
    );
  }, [c]), f = "h-8";
  return /* @__PURE__ */ R.jsxs(
    "div",
    {
      ref: s,
      className: Hr("flex justify-between space-x-6", i),
      "aria-sort": a,
      "tremor-id": "tremor-raw",
      ...o,
      children: [
        /* @__PURE__ */ R.jsx("div", { className: "relative w-full space-y-1.5", children: c.map((h, p) => /* @__PURE__ */ R.jsx(
          l,
          {
            onClick: () => {
              n == null || n(h);
            },
            className: Hr(
              // base
              "group w-full rounded",
              // focus
              vF,
              n ? [
                "!-m-0 cursor-pointer",
                // hover
                "hover:bg-gray-50 hover:dark:bg-gray-900"
              ] : ""
            ),
            children: /* @__PURE__ */ R.jsx(
              "div",
              {
                className: Hr(
                  // base
                  "flex items-center rounded transition-all",
                  f,
                  // background color
                  "bg-blue-200 dark:bg-blue-900",
                  n ? "group-hover:bg-blue-300 group-hover:dark:bg-blue-800" : "",
                  // margin and duration
                  {
                    "mb-0": p === c.length - 1,
                    "duration-800": r
                  }
                ),
                style: { width: `${u[p]}%` },
                children: /* @__PURE__ */ R.jsx("div", { className: Hr("absolute left-2 flex max-w-full pr-2"), children: h.href ? /* @__PURE__ */ R.jsx(
                  "a",
                  {
                    href: h.href,
                    className: Hr(
                      // base
                      "truncate whitespace-nowrap rounded text-sm",
                      // text color
                      "text-gray-900 dark:text-gray-50",
                      // hover
                      "hover:underline hover:underline-offset-2",
                      // focus
                      vF
                    ),
                    target: "_blank",
                    rel: "noreferrer",
                    onClick: (g) => g.stopPropagation(),
                    children: h.name
                  }
                ) : /* @__PURE__ */ R.jsx(
                  "p",
                  {
                    className: Hr(
                      // base
                      "truncate whitespace-nowrap text-sm",
                      // text color
                      "text-gray-900 dark:text-gray-50"
                    ),
                    children: h.name
                  }
                ) })
              }
            )
          },
          h.key ?? h.name
        )) }),
        /* @__PURE__ */ R.jsx("div", { children: c.map((h, p) => /* @__PURE__ */ R.jsx(
          "div",
          {
            className: Hr(
              "flex items-center justify-end",
              f,
              p === c.length - 1 ? "mb-0" : "mb-1.5"
            ),
            children: /* @__PURE__ */ R.jsx(
              "p",
              {
                className: Hr(
                  // base
                  "truncate whitespace-nowrap text-sm leading-none",
                  // text color
                  "text-gray-900 dark:text-gray-50"
                ),
                children: e(h.value)
              }
            )
          },
          h.key ?? h.name
        )) })
      ]
    }
  );
}
Oft.displayName = "BarList";
const wWr = Te.forwardRef(Oft), SWr = (t) => t.reduce((e, r) => e + r, 0), _Wr = (t, e, r) => t.map((n) => ({
  ...n,
  color: e.get(n[r]) || rg[0],
  className: Yc(
    e.get(n[r]) || rg[0],
    "fill"
  )
})), kWr = (t, e) => SWr(t.map((r) => r[e])), AWr = (t, e, r, n) => t || e(kWr(r, n)), TWr = ({
  active: t,
  payload: e,
  valueFormatter: r
}) => t && e && e.length ? /* @__PURE__ */ R.jsx(
  "div",
  {
    className: Hr(
      // base
      "rounded-md border text-sm shadow-md",
      // border color
      "border-gray-200 dark:border-gray-800",
      // background color
      "bg-white dark:bg-gray-950"
    ),
    children: /* @__PURE__ */ R.jsx("div", { className: Hr("space-y-1 px-4 py-2"), children: e.map(({ value: n, category: a, color: i }, o) => /* @__PURE__ */ R.jsxs(
      "div",
      {
        className: "flex items-center justify-between space-x-8",
        children: [
          /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ R.jsx(
              "span",
              {
                "aria-hidden": "true",
                className: Hr(
                  "size-2 shrink-0 rounded-full",
                  Yc(i, "bg")
                )
              }
            ),
            /* @__PURE__ */ R.jsx(
              "p",
              {
                className: Hr(
                  // base
                  "whitespace-nowrap text-right",
                  // text color
                  "text-gray-700 dark:text-gray-300"
                ),
                children: a
              }
            )
          ] }),
          /* @__PURE__ */ R.jsx(
            "p",
            {
              className: Hr(
                // base
                "whitespace-nowrap text-right font-medium tabular-nums",
                // text color
                "text-gray-900 dark:text-gray-50"
              ),
              children: r(n)
            }
          )
        ]
      },
      `id-${o}`
    )) })
  }
) : null, EWr = (t) => {
  const { cx: e, cy: r, innerRadius: n, outerRadius: a, startAngle: i, endAngle: o, className: s } = t;
  return /* @__PURE__ */ R.jsx(
    Hye,
    {
      cx: e,
      cy: r,
      innerRadius: n,
      outerRadius: a,
      startAngle: i,
      endAngle: o,
      className: s,
      fill: "",
      opacity: 0.3,
      style: { outline: "none" }
    }
  );
}, rfe = Te.forwardRef(
  ({
    data: t = [],
    value: e,
    category: r,
    colors: n = rg,
    variant: a = "donut",
    valueFormatter: i = (y) => y.toString(),
    label: o,
    showLabel: s = !1,
    showTooltip: l = !0,
    onValueChange: c,
    tooltipCallback: u,
    customTooltip: f,
    className: h,
    ...p
  }, g) => {
    const y = f, [b, w] = Te.useState(
      void 0
    ), _ = a === "donut", C = AWr(
      o,
      i,
      t,
      e
    ), x = Array.from(new Set(t.map((B) => B[r]))), S = kH(x, n), A = Te.useRef(void 0), I = Te.useRef(void 0), M = (B, L, N) => {
      N.stopPropagation(), c && (b === L ? (w(void 0), c(null)) : (w(L), c({
        eventType: "sector",
        categoryClicked: B.payload[r],
        ...B.payload
      })));
    };
    return /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: g,
        className: Hr("h-40 w-40", h),
        "tremor-id": "tremor-raw",
        ...p,
        children: /* @__PURE__ */ R.jsx(YW, { className: "size-full", children: /* @__PURE__ */ R.jsxs(
          BGr,
          {
            onClick: c && b !== void 0 ? () => {
              w(void 0), c(null);
            } : void 0,
            margin: { top: 0, left: 0, right: 0, bottom: 0 },
            children: [
              s && _ && /* @__PURE__ */ R.jsx(
                "text",
                {
                  className: "fill-gray-700 dark:fill-gray-300",
                  x: "50%",
                  y: "50%",
                  textAnchor: "middle",
                  dominantBaseline: "middle",
                  children: C
                }
              ),
              /* @__PURE__ */ R.jsx(
                Cg,
                {
                  className: Hr(
                    "stroke-white dark:stroke-gray-950 [&_.recharts-pie-sector]:outline-none",
                    c ? "cursor-pointer" : "cursor-default"
                  ),
                  data: _Wr(t, S, r),
                  cx: "50%",
                  cy: "50%",
                  startAngle: 90,
                  endAngle: -270,
                  innerRadius: _ ? "75%" : "0%",
                  outerRadius: "100%",
                  stroke: "",
                  strokeLinejoin: "round",
                  dataKey: e,
                  nameKey: r,
                  isAnimationActive: !1,
                  onClick: M,
                  activeIndex: b,
                  inactiveShape: EWr,
                  style: { outline: "none" }
                }
              ),
              l && /* @__PURE__ */ R.jsx(
                Jd,
                {
                  wrapperStyle: { outline: "none" },
                  isAnimationActive: !1,
                  content: ({ active: B, payload: L }) => {
                    var m;
                    const N = L ? L.map((v) => ({
                      category: v.payload[r],
                      value: v.value,
                      color: S.get(
                        v.payload[r]
                      )
                    })) : [], d = (m = N[0]) == null ? void 0 : m.category;
                    return u && (B !== A.current || d !== I.current) && (u({
                      active: B,
                      payload: N
                    }), A.current = B, I.current = d), l && B ? y ? /* @__PURE__ */ R.jsx(y, { active: B, payload: N }) : /* @__PURE__ */ R.jsx(
                      TWr,
                      {
                        active: B,
                        payload: N,
                        valueFormatter: i
                      }
                    ) : null;
                  }
                }
              )
            ]
          }
        ) })
      }
    );
  }
);
rfe.displayName = "DonutChart";
const IWr = ({
  name: t,
  color: e,
  onClick: r,
  activeLegend: n
}) => {
  const a = !!r;
  return /* @__PURE__ */ R.jsxs(
    "li",
    {
      className: Hr(
        // base
        "group inline-flex flex-nowrap items-center gap-1.5 whitespace-nowrap rounded px-2 py-1 transition",
        a ? "cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800" : "cursor-default"
      ),
      onClick: (i) => {
        i.stopPropagation(), r == null || r(t, e);
      },
      children: [
        /* @__PURE__ */ R.jsx(
          "span",
          {
            className: Hr(
              "h-[3px] w-3.5 shrink-0 rounded-full",
              Yc(e, "bg"),
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            "aria-hidden": !0
          }
        ),
        /* @__PURE__ */ R.jsx(
          "p",
          {
            className: Hr(
              // base
              "truncate whitespace-nowrap text-xs",
              // text color
              "text-gray-700 dark:text-gray-300",
              a && "group-hover:text-gray-900 dark:group-hover:text-gray-50",
              n && n !== t ? "opacity-40" : "opacity-100"
            ),
            children: t
          }
        )
      ]
    }
  );
}, a$e = ({ icon: t, onClick: e, disabled: r }) => {
  const n = t, [a, i] = Te.useState(!1), o = Te.useRef(null);
  return Te.useEffect(() => (a ? o.current = setInterval(() => {
    e == null || e();
  }, 300) : clearInterval(o.current), () => clearInterval(o.current)), [a, e]), Te.useEffect(() => {
    r && (clearInterval(o.current), i(!1));
  }, [r]), /* @__PURE__ */ R.jsx(
    "button",
    {
      type: "button",
      className: Hr(
        // base
        "group inline-flex size-5 items-center truncate rounded transition",
        r ? "cursor-not-allowed text-gray-400 dark:text-gray-600" : "cursor-pointer text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-gray-50"
      ),
      disabled: r,
      onClick: (s) => {
        s.stopPropagation(), e == null || e();
      },
      onMouseDown: (s) => {
        s.stopPropagation(), i(!0);
      },
      onMouseUp: (s) => {
        s.stopPropagation(), i(!1);
      },
      children: /* @__PURE__ */ R.jsx(n, { className: "size-full", "aria-hidden": "true" })
    }
  );
}, Bft = Te.forwardRef((t, e) => {
  const {
    categories: r,
    colors: n = rg,
    className: a,
    onClickLegendItem: i,
    activeLegend: o,
    enableLegendSlider: s = !1,
    ...l
  } = t, c = Te.useRef(null), u = Te.useRef(null), [f, h] = Te.useState(null), [p, g] = Te.useState(null), y = Te.useRef(null), b = Te.useCallback(() => {
    const x = c == null ? void 0 : c.current;
    if (!x) return;
    const S = x.scrollLeft > 0, A = x.scrollWidth - x.clientWidth > x.scrollLeft;
    h({ left: S, right: A });
  }, [h]), w = Te.useCallback(
    (x) => {
      const S = c == null ? void 0 : c.current, A = u == null ? void 0 : u.current, I = (A == null ? void 0 : A.clientWidth) ?? 0, M = (S == null ? void 0 : S.clientWidth) ?? 0;
      S && s && (S.scrollTo({
        left: x === "left" ? S.scrollLeft - M + I : S.scrollLeft + M - I,
        behavior: "smooth"
      }), setTimeout(() => {
        b();
      }, 400));
    },
    [s, b]
  );
  Te.useEffect(() => {
    const x = (S) => {
      S === "ArrowLeft" ? w("left") : S === "ArrowRight" && w("right");
    };
    return p ? (x(p), y.current = setInterval(() => {
      x(p);
    }, 300)) : clearInterval(y.current), () => clearInterval(y.current);
  }, [p, w]);
  const _ = (x) => {
    x.stopPropagation(), (x.key === "ArrowLeft" || x.key === "ArrowRight") && (x.preventDefault(), g(x.key));
  }, C = (x) => {
    x.stopPropagation(), g(null);
  };
  return Te.useEffect(() => {
    const x = c == null ? void 0 : c.current;
    return s && (b(), x == null || x.addEventListener("keydown", _), x == null || x.addEventListener("keyup", C)), () => {
      x == null || x.removeEventListener("keydown", _), x == null || x.removeEventListener("keyup", C);
    };
  }, [b, s]), /* @__PURE__ */ R.jsxs(
    "ol",
    {
      ref: e,
      className: Hr("relative overflow-hidden", a),
      ...l,
      children: [
        /* @__PURE__ */ R.jsx(
          "div",
          {
            ref: c,
            tabIndex: 0,
            className: Hr(
              "flex h-full",
              s ? f != null && f.right || f != null && f.left ? "snap-mandatory items-center overflow-auto pl-4 pr-12 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" : "" : "flex-wrap"
            ),
            children: r.map((x, S) => /* @__PURE__ */ R.jsx(
              IWr,
              {
                name: x,
                color: n[S],
                onClick: i,
                activeLegend: o
              },
              `item-${S}`
            ))
          }
        ),
        s && (f != null && f.right || f != null && f.left) ? /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsxs(
          "div",
          {
            className: Hr(
              // base
              "absolute bottom-0 right-0 top-0 flex h-full items-center justify-center pr-1",
              // background color
              "bg-white dark:bg-gray-950"
            ),
            children: [
              /* @__PURE__ */ R.jsx(
                a$e,
                {
                  icon: qve,
                  onClick: () => {
                    g(null), w("left");
                  },
                  disabled: !(f != null && f.left)
                }
              ),
              /* @__PURE__ */ R.jsx(
                a$e,
                {
                  icon: Kve,
                  onClick: () => {
                    g(null), w("right");
                  },
                  disabled: !(f != null && f.right)
                }
              )
            ]
          }
        ) }) : null
      ]
    }
  );
});
Bft.displayName = "Legend";
const MWr = ({ payload: t }, e, r, n, a, i, o, s) => {
  const l = Te.useRef(null);
  a3e(() => {
    var h;
    r(((p) => p ? Number(p) + 15 : 60)((h = l.current) == null ? void 0 : h.clientHeight));
  });
  const c = t.filter((f) => f.type !== "none"), u = o === "left" && s ? s - 8 : 0;
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      ref: l,
      style: { paddingLeft: u },
      className: Hr(
        "flex items-center",
        { "justify-center": o === "center" },
        { "justify-start": o === "left" },
        { "justify-end": o === "right" }
      ),
      children: /* @__PURE__ */ R.jsx(
        Bft,
        {
          categories: c.map((f) => f.value),
          colors: c.map(
            (f) => e.get(f.value)
          ),
          onClickLegendItem: a,
          activeLegend: n,
          enableLegendSlider: i
        }
      )
    }
  );
}, PWr = ({
  active: t,
  payload: e,
  label: r,
  valueFormatter: n
}) => {
  if (t && e && e.length) {
    const a = e.filter((i) => i.type !== "none");
    return /* @__PURE__ */ R.jsxs(
      "div",
      {
        className: Hr(
          // base
          "rounded-md border text-sm shadow-md",
          // border color
          "border-gray-200 dark:border-gray-800",
          // background color
          "bg-white dark:bg-gray-950"
        ),
        children: [
          /* @__PURE__ */ R.jsx("div", { className: Hr("border-b border-inherit px-4 py-2"), children: /* @__PURE__ */ R.jsx(
            "p",
            {
              className: Hr(
                // base
                "font-medium",
                // text color
                "text-gray-900 dark:text-gray-50"
              ),
              children: r
            }
          ) }),
          /* @__PURE__ */ R.jsx("div", { className: Hr("space-y-1 px-4 py-2"), children: a.map(({ value: i, category: o, color: s }, l) => /* @__PURE__ */ R.jsxs(
            "div",
            {
              className: "flex items-center justify-between space-x-8",
              children: [
                /* @__PURE__ */ R.jsxs("div", { className: "flex items-center space-x-2", children: [
                  /* @__PURE__ */ R.jsx(
                    "span",
                    {
                      "aria-hidden": "true",
                      className: Hr(
                        "h-[3px] w-3.5 shrink-0 rounded-full",
                        Yc(s, "bg")
                      )
                    }
                  ),
                  /* @__PURE__ */ R.jsx(
                    "p",
                    {
                      className: Hr(
                        // base
                        "whitespace-nowrap text-right",
                        // text color
                        "text-gray-700 dark:text-gray-300"
                      ),
                      children: o
                    }
                  )
                ] }),
                /* @__PURE__ */ R.jsx(
                  "p",
                  {
                    className: Hr(
                      // base
                      "whitespace-nowrap text-right font-medium tabular-nums",
                      // text color
                      "text-gray-900 dark:text-gray-50"
                    ),
                    children: n(i)
                  }
                )
              ]
            },
            `id-${l}`
          )) })
        ]
      }
    );
  }
  return null;
}, Nft = Te.forwardRef(
  (t, e) => {
    const {
      data: r = [],
      categories: n = [],
      index: a,
      colors: i = rg,
      valueFormatter: o = (ee) => ee.toString(),
      startEndOnly: s = !1,
      showXAxis: l = !0,
      showYAxis: c = !0,
      showGridLines: u = !0,
      yAxisWidth: f = 56,
      intervalType: h = "equidistantPreserveStart",
      showTooltip: p = !0,
      showLegend: g = !0,
      autoMinValue: y = !1,
      minValue: b,
      maxValue: w,
      allowDecimals: _ = !0,
      connectNulls: C = !1,
      className: x,
      onValueChange: S,
      enableLegendSlider: A = !1,
      tickGap: I = 5,
      xAxisLabel: M,
      yAxisLabel: B,
      legendPosition: L = "right",
      tooltipCallback: N,
      customTooltip: d,
      ...m
    } = t, v = d, k = !l && !c || s && !c ? 0 : 20, [O, G] = Te.useState(60), [H, j] = Te.useState(
      void 0
    ), [F, z] = Te.useState(
      void 0
    ), W = kH(n, i), U = n3e(y, b, w), Z = !!S, V = Te.useRef(void 0), Y = Te.useRef(void 0);
    function ge(ee, Se) {
      Se.stopPropagation(), Z && (ee.index === (H == null ? void 0 : H.index) && ee.dataKey === (H == null ? void 0 : H.dataKey) || E7(r, ee.dataKey) && F && F === ee.dataKey ? (z(void 0), j(void 0), S == null || S(null)) : (z(ee.dataKey), j({
        index: ee.index,
        dataKey: ee.dataKey
      }), S == null || S({
        eventType: "dot",
        categoryClicked: ee.dataKey,
        ...ee.payload
      })));
    }
    function ce(ee) {
      Z && (ee === F && !H || E7(r, ee) && H && H.dataKey === ee ? (z(void 0), S == null || S(null)) : (z(ee), S == null || S({
        eventType: "category",
        categoryClicked: ee
      })), j(void 0));
    }
    return /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: e,
        className: Hr("h-80 w-full", x),
        "tremor-id": "tremor-raw",
        ...m,
        children: /* @__PURE__ */ R.jsx(YW, { children: /* @__PURE__ */ R.jsxs(
          RGr,
          {
            data: r,
            onClick: Z && (F || H) ? () => {
              j(void 0), z(void 0), S == null || S(null);
            } : void 0,
            margin: {
              bottom: M ? 30 : void 0,
              left: B ? 20 : void 0,
              right: B ? 5 : void 0,
              top: 5
            },
            children: [
              u ? /* @__PURE__ */ R.jsx(
                wH,
                {
                  className: Hr("stroke-gray-200 stroke-1 dark:stroke-gray-800"),
                  horizontal: !0,
                  vertical: !1
                }
              ) : null,
              /* @__PURE__ */ R.jsx(
                e3,
                {
                  padding: { left: k, right: k },
                  hide: !l,
                  dataKey: a,
                  interval: s ? "preserveStartEnd" : h,
                  tick: { transform: "translate(0, 6)" },
                  ticks: s ? [r[0][a], r[r.length - 1][a]] : void 0,
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500"
                  ),
                  tickLine: !1,
                  axisLine: !1,
                  minTickGap: I,
                  children: M && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideBottom",
                      offset: -20,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: M
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                t3,
                {
                  width: f,
                  hide: !c,
                  axisLine: !1,
                  tickLine: !1,
                  type: "number",
                  domain: U,
                  tick: { transform: "translate(-3, 0)" },
                  fill: "",
                  stroke: "",
                  className: Hr(
                    // base
                    "text-xs",
                    // text fill
                    "fill-gray-500 dark:fill-gray-500"
                  ),
                  tickFormatter: o,
                  allowDecimals: _,
                  children: B && /* @__PURE__ */ R.jsx(
                    Ss,
                    {
                      position: "insideLeft",
                      style: { textAnchor: "middle" },
                      angle: -90,
                      offset: -15,
                      className: "fill-gray-800 text-sm font-medium dark:fill-gray-200",
                      children: B
                    }
                  )
                }
              ),
              /* @__PURE__ */ R.jsx(
                Jd,
                {
                  wrapperStyle: { outline: "none" },
                  isAnimationActive: !0,
                  animationDuration: 100,
                  cursor: { stroke: "#d1d5db", strokeWidth: 1 },
                  offset: 20,
                  position: { y: 0 },
                  content: ({ active: ee, payload: Se, label: Ce }) => {
                    const we = Se ? Se.map((We) => ({
                      category: We.dataKey,
                      value: We.value,
                      index: We.payload[a],
                      color: W.get(
                        We.dataKey
                      ),
                      type: We.type,
                      payload: We.payload
                    })) : [];
                    return N && (ee !== V.current || Ce !== Y.current) && (N({ active: ee, payload: we, label: Ce }), V.current = ee, Y.current = Ce), p && ee ? v ? /* @__PURE__ */ R.jsx(
                      v,
                      {
                        active: ee,
                        payload: we,
                        label: Ce
                      }
                    ) : /* @__PURE__ */ R.jsx(
                      PWr,
                      {
                        active: ee,
                        payload: we,
                        label: Ce,
                        valueFormatter: o
                      }
                    ) : null;
                  }
                }
              ),
              g ? /* @__PURE__ */ R.jsx(
                Mm,
                {
                  verticalAlign: "top",
                  height: O,
                  content: ({ payload: ee }) => MWr(
                    { payload: ee },
                    W,
                    G,
                    F,
                    Z ? (Se) => ce(Se) : void 0,
                    A,
                    L,
                    f
                  )
                }
              ) : null,
              n.map((ee) => /* @__PURE__ */ R.jsx(
                $5,
                {
                  className: Hr(
                    Yc(
                      W.get(ee),
                      "stroke"
                    )
                  ),
                  strokeOpacity: H || F && F !== ee ? 0.3 : 1,
                  activeDot: (Se) => {
                    const {
                      cx: Ce,
                      cy: we,
                      stroke: We,
                      strokeLinecap: Fe,
                      strokeLinejoin: it,
                      strokeWidth: gt,
                      dataKey: Ze
                    } = Se;
                    return /* @__PURE__ */ R.jsx(
                      tg,
                      {
                        className: Hr(
                          "stroke-white dark:stroke-gray-950",
                          S ? "cursor-pointer" : "",
                          Yc(
                            W.get(
                              Ze
                            ),
                            "fill"
                          )
                        ),
                        cx: Ce,
                        cy: we,
                        r: 5,
                        fill: "",
                        stroke: We,
                        strokeLinecap: Fe,
                        strokeLinejoin: it,
                        strokeWidth: gt,
                        onClick: (Ne, ze) => ge(Se, ze)
                      }
                    );
                  },
                  dot: (Se) => {
                    const {
                      stroke: Ce,
                      strokeLinecap: we,
                      strokeLinejoin: We,
                      strokeWidth: Fe,
                      cx: it,
                      cy: gt,
                      dataKey: Ze,
                      index: Ne
                    } = Se;
                    return E7(r, ee) && !(H || F && F !== ee) || (H == null ? void 0 : H.index) === Ne && (H == null ? void 0 : H.dataKey) === ee ? /* @__PURE__ */ R.jsx(
                      tg,
                      {
                        cx: it,
                        cy: gt,
                        r: 5,
                        stroke: Ce,
                        fill: "",
                        strokeLinecap: we,
                        strokeLinejoin: We,
                        strokeWidth: Fe,
                        className: Hr(
                          "stroke-white dark:stroke-gray-950",
                          S ? "cursor-pointer" : "",
                          Yc(
                            W.get(
                              Ze
                            ),
                            "fill"
                          )
                        )
                      },
                      Ne
                    ) : /* @__PURE__ */ R.jsx(Te.Fragment, {}, Ne);
                  },
                  name: ee,
                  type: "linear",
                  dataKey: ee,
                  stroke: "",
                  strokeWidth: 2,
                  strokeLinejoin: "round",
                  strokeLinecap: "round",
                  isAnimationActive: !1,
                  connectNulls: C
                },
                ee
              )),
              S ? n.map((ee) => /* @__PURE__ */ R.jsx(
                $5,
                {
                  className: Hr("cursor-pointer"),
                  strokeOpacity: 0,
                  name: ee,
                  type: "linear",
                  dataKey: ee,
                  stroke: "transparent",
                  fill: "transparent",
                  legendType: "none",
                  tooltipType: "none",
                  strokeWidth: 12,
                  connectNulls: C,
                  onClick: (Se, Ce) => {
                    Ce.stopPropagation();
                    const { name: we } = Se;
                    ce(we);
                  }
                },
                ee
              )) : null
            ]
          }
        ) })
      }
    );
  }
);
Nft.displayName = "LineChart";
var l3e = P.forwardRef((t, e) => {
  const { children: r, ...n } = t, a = P.Children.toArray(r), i = a.find(OWr);
  if (i) {
    const o = i.props.children, s = a.map((l) => l === i ? P.Children.count(o) > 1 ? P.Children.only(null) : P.isValidElement(o) ? o.props.children : null : l);
    return /* @__PURE__ */ R.jsx(nfe, { ...n, ref: e, children: P.isValidElement(o) ? P.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(nfe, { ...n, ref: e, children: r });
});
l3e.displayName = "Slot";
var nfe = P.forwardRef((t, e) => {
  const { children: r, ...n } = t;
  if (P.isValidElement(r)) {
    const a = NWr(r), i = BWr(n, r.props);
    return r.type !== P.Fragment && (i.ref = e ? K8(e, a) : a), P.cloneElement(r, i);
  }
  return P.Children.count(r) > 1 ? P.Children.only(null) : null;
});
nfe.displayName = "SlotClone";
var RWr = ({ children: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t });
function OWr(t) {
  return P.isValidElement(t) && t.type === RWr;
}
function BWr(t, e) {
  const r = { ...e };
  for (const n in e) {
    const a = t[n], i = e[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...s) => {
      i(...s), a(...s);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...t, ...r };
}
function NWr(t) {
  var n, a;
  let e = (n = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : n.get, r = e && "isReactWarning" in e && e.isReactWarning;
  return r ? t.ref : (e = (a = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : a.get, r = e && "isReactWarning" in e && e.isReactWarning, r ? t.props.ref : t.props.ref || t.ref);
}
var c3e = "Dialog", [$ft, U3n] = qy(c3e), [$Wr, p2] = $ft(c3e), Dft = (t) => {
  const {
    __scopeDialog: e,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: i,
    modal: o = !0
  } = t, s = P.useRef(null), l = P.useRef(null), [c = !1, u] = Z8({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ R.jsx(
    $Wr,
    {
      scope: e,
      triggerRef: s,
      contentRef: l,
      contentId: bh(),
      titleId: bh(),
      descriptionId: bh(),
      open: c,
      onOpenChange: u,
      onOpenToggle: P.useCallback(() => u((f) => !f), [u]),
      modal: o,
      children: r
    }
  );
};
Dft.displayName = c3e;
var Lft = "DialogTrigger", jft = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = p2(Lft, r), i = El(e, a.triggerRef);
    return /* @__PURE__ */ R.jsx(
      Mo.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": f3e(a.open),
        ...n,
        ref: i,
        onClick: Oa(t.onClick, a.onOpenToggle)
      }
    );
  }
);
jft.displayName = Lft;
var u3e = "DialogPortal", [DWr, Fft] = $ft(u3e, {
  forceMount: void 0
}), zft = (t) => {
  const { __scopeDialog: e, forceMount: r, children: n, container: a } = t, i = p2(u3e, e);
  return /* @__PURE__ */ R.jsx(DWr, { scope: e, forceMount: r, children: P.Children.map(n, (o) => /* @__PURE__ */ R.jsx(kf, { present: r || i.open, children: /* @__PURE__ */ R.jsx(TW, { asChild: !0, container: a, children: o }) })) });
};
zft.displayName = u3e;
var yF = "DialogOverlay", Gft = P.forwardRef(
  (t, e) => {
    const r = Fft(yF, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, i = p2(yF, t.__scopeDialog);
    return i.modal ? /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: /* @__PURE__ */ R.jsx(LWr, { ...a, ref: e }) }) : null;
  }
);
Gft.displayName = yF;
var LWr = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = p2(yF, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ R.jsx(IW, { as: l3e, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ R.jsx(
        Mo.div,
        {
          "data-state": f3e(a.open),
          ...n,
          ref: e,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), D5 = "DialogContent", Wft = P.forwardRef(
  (t, e) => {
    const r = Fft(D5, t.__scopeDialog), { forceMount: n = r.forceMount, ...a } = t, i = p2(D5, t.__scopeDialog);
    return /* @__PURE__ */ R.jsx(kf, { present: n || i.open, children: i.modal ? /* @__PURE__ */ R.jsx(jWr, { ...a, ref: e }) : /* @__PURE__ */ R.jsx(FWr, { ...a, ref: e }) });
  }
);
Wft.displayName = D5;
var jWr = P.forwardRef(
  (t, e) => {
    const r = p2(D5, t.__scopeDialog), n = P.useRef(null), a = El(e, r.contentRef, n);
    return P.useEffect(() => {
      const i = n.current;
      if (i) return Zge(i);
    }, []), /* @__PURE__ */ R.jsx(
      Hft,
      {
        ...t,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Oa(t.onCloseAutoFocus, (i) => {
          var o;
          i.preventDefault(), (o = r.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Oa(t.onPointerDownOutside, (i) => {
          const o = i.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Oa(
          t.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), FWr = P.forwardRef(
  (t, e) => {
    const r = p2(D5, t.__scopeDialog), n = P.useRef(!1), a = P.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      Hft,
      {
        ...t,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var o, s;
          (o = t.onCloseAutoFocus) == null || o.call(t, i), i.defaultPrevented || (n.current || (s = r.triggerRef.current) == null || s.focus(), i.preventDefault()), n.current = !1, a.current = !1;
        },
        onInteractOutside: (i) => {
          var l, c;
          (l = t.onInteractOutside) == null || l.call(t, i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          const o = i.target;
          ((c = r.triggerRef.current) == null ? void 0 : c.contains(o)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }
      }
    );
  }
), Hft = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, ...o } = t, s = p2(D5, r), l = P.useRef(null), c = El(e, l);
    return jge(), /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        SW,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ R.jsx(
            wW,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": f3e(s.open),
              ...o,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(zWr, { titleId: s.titleId }),
        /* @__PURE__ */ R.jsx(WWr, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), d3e = "DialogTitle", Uft = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = p2(d3e, r);
    return /* @__PURE__ */ R.jsx(Mo.h2, { id: a.titleId, ...n, ref: e });
  }
);
Uft.displayName = d3e;
var Vft = "DialogDescription", qft = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = p2(Vft, r);
    return /* @__PURE__ */ R.jsx(Mo.p, { id: a.descriptionId, ...n, ref: e });
  }
);
qft.displayName = Vft;
var Kft = "DialogClose", Zft = P.forwardRef(
  (t, e) => {
    const { __scopeDialog: r, ...n } = t, a = p2(Kft, r);
    return /* @__PURE__ */ R.jsx(
      Mo.button,
      {
        type: "button",
        ...n,
        ref: e,
        onClick: Oa(t.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Zft.displayName = Kft;
function f3e(t) {
  return t ? "open" : "closed";
}
var Jft = "DialogTitleWarning", [V3n, Yft] = _it(Jft, {
  contentName: D5,
  titleName: d3e,
  docsSlug: "dialog"
}), zWr = ({ titleId: t }) => {
  const e = Yft(Jft), r = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return P.useEffect(() => {
    t && (document.getElementById(t) || console.error(r));
  }, [r, t]), null;
}, GWr = "DialogDescriptionWarning", WWr = ({ contentRef: t, descriptionId: e }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Yft(GWr).contentName}}.`;
  return P.useEffect(() => {
    var i;
    const a = (i = t.current) == null ? void 0 : i.getAttribute("aria-describedby");
    e && a && (document.getElementById(e) || console.warn(n));
  }, [n, t, e]), null;
}, HWr = Dft, UWr = jft, VWr = zft, qWr = Gft, KWr = Wft, ZWr = Uft, JWr = qft, Xft = Zft, i$e = (t) => typeof t == "boolean" ? `${t}` : t === 0 ? "0" : t, ld = (t) => !t || typeof t != "object" || Object.keys(t).length === 0, YWr = (t, e) => JSON.stringify(t) === JSON.stringify(e);
function Qft(t, e) {
  t.forEach(function(r) {
    Array.isArray(r) ? Qft(r, e) : e.push(r);
  });
}
function e1t(t) {
  let e = [];
  return Qft(t, e), e;
}
var t1t = (...t) => e1t(t).filter(Boolean), r1t = (t, e) => {
  let r = {}, n = Object.keys(t), a = Object.keys(e);
  for (let i of n) if (a.includes(i)) {
    let o = t[i], s = e[i];
    typeof o == "object" && typeof s == "object" ? r[i] = r1t(o, s) : Array.isArray(o) || Array.isArray(s) ? r[i] = t1t(s, o) : r[i] = s + " " + o;
  } else r[i] = t[i];
  for (let i of a) n.includes(i) || (r[i] = e[i]);
  return r;
}, o$e = (t) => !t || typeof t != "string" ? t : t.replace(/\s+/g, " ").trim(), XWr = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, n1t = (t) => t || void 0, rI = (...t) => n1t(e1t(t).filter(Boolean).join(" ")), Fae = null, Qp = {}, afe = !1, gS = (...t) => (e) => e.twMerge ? ((!Fae || afe) && (afe = !1, Fae = ld(Qp) ? Ift : pWr({ ...Qp, extend: { theme: Qp.theme, classGroups: Qp.classGroups, conflictingClassGroupModifiers: Qp.conflictingClassGroupModifiers, conflictingClassGroups: Qp.conflictingClassGroups, ...Qp.extend } })), n1t(Fae(rI(t)))) : rI(t), s$e = (t, e) => {
  for (let r in e) t.hasOwnProperty(r) ? t[r] = rI(t[r], e[r]) : t[r] = e[r];
  return t;
}, QWr = (t, e) => {
  let { extend: r = null, slots: n = {}, variants: a = {}, compoundVariants: i = [], compoundSlots: o = [], defaultVariants: s = {} } = t, l = { ...XWr, ...e }, c = r != null && r.base ? rI(r.base, t == null ? void 0 : t.base) : t == null ? void 0 : t.base, u = r != null && r.variants && !ld(r.variants) ? r1t(a, r.variants) : a, f = r != null && r.defaultVariants && !ld(r.defaultVariants) ? { ...r.defaultVariants, ...s } : s;
  !ld(l.twMergeConfig) && !YWr(l.twMergeConfig, Qp) && (afe = !0, Qp = l.twMergeConfig);
  let h = ld(r == null ? void 0 : r.slots), p = ld(n) ? {} : { base: rI(t == null ? void 0 : t.base, h && (r == null ? void 0 : r.base)), ...n }, g = h ? p : s$e({ ...r == null ? void 0 : r.slots }, ld(p) ? { base: t == null ? void 0 : t.base } : p), y = ld(r == null ? void 0 : r.compoundVariants) ? i : t1t(r == null ? void 0 : r.compoundVariants, i), b = (_) => {
    if (ld(u) && ld(n) && h) return gS(c, _ == null ? void 0 : _.class, _ == null ? void 0 : _.className)(l);
    if (y && !Array.isArray(y)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof y}`);
    if (o && !Array.isArray(o)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof o}`);
    let C = (d, m, v = [], k) => {
      let O = v;
      if (typeof m == "string") O = O.concat(o$e(m).split(" ").map((G) => `${d}:${G}`));
      else if (Array.isArray(m)) O = O.concat(m.reduce((G, H) => G.concat(`${d}:${H}`), []));
      else if (typeof m == "object" && typeof k == "string") {
        for (let G in m) if (m.hasOwnProperty(G) && G === k) {
          let H = m[G];
          if (H && typeof H == "string") {
            let j = o$e(H);
            O[k] ? O[k] = O[k].concat(j.split(" ").map((F) => `${d}:${F}`)) : O[k] = j.split(" ").map((F) => `${d}:${F}`);
          } else Array.isArray(H) && H.length > 0 && (O[k] = H.reduce((j, F) => j.concat(`${d}:${F}`), []));
        }
      }
      return O;
    }, x = (d, m = u, v = null, k = null) => {
      var O;
      let G = m[d];
      if (!G || ld(G)) return null;
      let H = (O = k == null ? void 0 : k[d]) != null ? O : _ == null ? void 0 : _[d];
      if (H === null) return null;
      let j = i$e(H), F = Array.isArray(l.responsiveVariants) && l.responsiveVariants.length > 0 || l.responsiveVariants === !0, z = f == null ? void 0 : f[d], W = [];
      if (typeof j == "object" && F) for (let [V, Y] of Object.entries(j)) {
        let ge = G[Y];
        if (V === "initial") {
          z = Y;
          continue;
        }
        Array.isArray(l.responsiveVariants) && !l.responsiveVariants.includes(V) || (W = C(V, ge, W, v));
      }
      let U = j != null && typeof j != "object" ? j : i$e(z), Z = G[U || "false"];
      return typeof W == "object" && typeof v == "string" && W[v] ? s$e(W, Z) : W.length > 0 ? (W.push(Z), W) : Z;
    }, S = () => u ? Object.keys(u).map((d) => x(d, u)) : null, A = (d, m) => {
      if (!u || typeof u != "object") return null;
      let v = new Array();
      for (let k in u) {
        let O = x(k, u, d, m), G = d === "base" && typeof O == "string" ? O : O && O[d];
        G && (v[v.length] = G);
      }
      return v;
    }, I = {};
    for (let d in _) _[d] !== void 0 && (I[d] = _[d]);
    let M = (d, m) => {
      var v;
      let k = typeof (_ == null ? void 0 : _[d]) == "object" ? { [d]: (v = _[d]) == null ? void 0 : v.initial } : {};
      return { ...f, ...I, ...k, ...m };
    }, B = (d = [], m) => {
      let v = [];
      for (let { class: k, className: O, ...G } of d) {
        let H = !0;
        for (let [j, F] of Object.entries(G)) {
          let z = M(j, m);
          if (Array.isArray(F)) {
            if (!F.includes(z[j])) {
              H = !1;
              break;
            }
          } else if (z[j] !== F) {
            H = !1;
            break;
          }
        }
        H && (k && v.push(k), O && v.push(O));
      }
      return v;
    }, L = (d) => {
      let m = B(y, d);
      if (!Array.isArray(m)) return m;
      let v = {};
      for (let k of m) if (typeof k == "string" && (v.base = gS(v.base, k)(l)), typeof k == "object") for (let [O, G] of Object.entries(k)) v[O] = gS(v[O], G)(l);
      return v;
    }, N = (d) => {
      if (o.length < 1) return null;
      let m = {};
      for (let { slots: v = [], class: k, className: O, ...G } of o) {
        if (!ld(G)) {
          let H = !0;
          for (let j of Object.keys(G)) {
            let F = M(j, d)[j];
            if (F === void 0 || (Array.isArray(G[j]) ? !G[j].includes(F) : G[j] !== F)) {
              H = !1;
              break;
            }
          }
          if (!H) continue;
        }
        for (let H of v) m[H] = m[H] || [], m[H].push([k, O]);
      }
      return m;
    };
    if (!ld(n) || !h) {
      let d = {};
      if (typeof g == "object" && !ld(g)) for (let m of Object.keys(g)) d[m] = (v) => {
        var k, O;
        return gS(g[m], A(m, v), ((k = L(v)) != null ? k : [])[m], ((O = N(v)) != null ? O : [])[m], v == null ? void 0 : v.class, v == null ? void 0 : v.className)(l);
      };
      return d;
    }
    return gS(c, S(), B(y), _ == null ? void 0 : _.class, _ == null ? void 0 : _.className)(l);
  }, w = () => {
    if (!(!u || typeof u != "object")) return Object.keys(u);
  };
  return b.variantKeys = w(), b.extend = r, b.base = c, b.slots = g, b.variants = u, b.defaultVariants = f, b.compoundSlots = o, b.compoundVariants = y, b;
};
const eHr = QWr({
  base: [
    // base
    "relative inline-flex items-center justify-center whitespace-nowrap rounded-md border px-3 py-2 text-center text-sm font-medium shadow-sm transition-all duration-100 ease-in-out",
    // disabled
    "disabled:pointer-events-none disabled:shadow-none",
    // focus
    vF
  ],
  variants: {
    variant: {
      primary: [
        // border
        "border-transparent",
        // text color
        "text-white dark:text-white",
        // background color
        "bg-blue-500 dark:bg-blue-500",
        // hover color
        "hover:bg-blue-600 dark:hover:bg-blue-600",
        // disabled
        "disabled:bg-blue-300 disabled:text-white",
        "disabled:dark:bg-blue-800 disabled:dark:text-blue-400"
      ],
      secondary: [
        // border
        "border-gray-300 dark:border-gray-800",
        // text color
        "text-gray-900 dark:text-gray-50",
        // background color
        "bg-white dark:bg-gray-950",
        //hover color
        "hover:bg-gray-50 dark:hover:bg-gray-900/60",
        // disabled
        "disabled:text-gray-400",
        "disabled:dark:text-gray-600"
      ],
      light: [
        // base
        "shadow-none",
        // border
        "border-transparent",
        // text color
        "text-gray-900 dark:text-gray-50",
        // background color
        "bg-gray-200 dark:bg-gray-900",
        // hover color
        "hover:bg-gray-300/70 dark:hover:bg-gray-800/80",
        // disabled
        "disabled:bg-gray-100 disabled:text-gray-400",
        "disabled:dark:bg-gray-800 disabled:dark:text-gray-600"
      ],
      ghost: [
        // base
        "shadow-none",
        // border
        "border-transparent",
        // text color
        "text-gray-900 dark:text-gray-50",
        // hover color
        "bg-transparent hover:bg-gray-100 dark:hover:bg-gray-800/80",
        // disabled
        "disabled:text-gray-400",
        "disabled:dark:text-gray-600"
      ],
      destructive: [
        // text color
        "text-white",
        // border
        "border-transparent",
        // background color
        "bg-red-600 dark:bg-red-700",
        // hover color
        "hover:bg-red-700 dark:hover:bg-red-600",
        // disabled
        "disabled:bg-red-300 disabled:text-white",
        "disabled:dark:bg-red-950 disabled:dark:text-red-400"
      ]
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}), a1t = Te.forwardRef(
  ({
    asChild: t,
    isLoading: e = !1,
    loadingText: r,
    className: n,
    disabled: a,
    variant: i,
    children: o,
    ...s
  }, l) => {
    const c = t ? l3e : "button";
    return /* @__PURE__ */ R.jsx(
      c,
      {
        ref: l,
        className: Hr(eHr({ variant: i }), n),
        disabled: a || e,
        "tremor-id": "tremor-raw",
        ...s,
        children: e ? /* @__PURE__ */ R.jsxs("span", { className: "pointer-events-none flex shrink-0 items-center justify-center gap-1.5", children: [
          /* @__PURE__ */ R.jsx(
            Q_r,
            {
              className: "size-4 shrink-0 animate-spin",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ R.jsx("span", { className: "sr-only", children: r || "Loading" }),
          r || o
        ] }) : o
      }
    );
  }
);
a1t.displayName = "Button";
const i1t = (t) => /* @__PURE__ */ R.jsx(HWr, { "tremor-id": "tremor-raw", ...t });
i1t.displayName = "Drawer";
const o1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(UWr, { ref: r, className: Hr(t), ...e }));
o1t.displayName = "Drawer.Trigger";
const tHr = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(Xft, { ref: r, className: Hr(t), ...e }));
tHr.displayName = "Drawer.Close";
const s1t = VWr;
s1t.displayName = "DrawerPortal";
const l1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  qWr,
  {
    ref: r,
    className: Hr(
      // base
      "fixed inset-0 z-50 overflow-y-auto",
      // background color
      "bg-black/30",
      // transition
      "data-[state=closed]:animate-hide data-[state=open]:animate-dialogOverlayShow",
      t
    ),
    ...e,
    style: {
      animationDuration: "400ms",
      animationFillMode: "backwards"
    }
  }
));
l1t.displayName = "DrawerOverlay";
const c1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(s1t, { children: /* @__PURE__ */ R.jsx(l1t, { children: /* @__PURE__ */ R.jsx(
  KWr,
  {
    ref: r,
    className: Hr(
      // base
      "fixed inset-y-2 mx-auto flex w-[95vw] flex-1 flex-col overflow-y-auto rounded-md border p-4 shadow-lg focus:outline-none max-sm:inset-x-2 sm:inset-y-2 sm:right-2 sm:max-w-lg sm:p-6",
      // border color
      "border-gray-200 dark:border-gray-900",
      // background color
      "bg-white dark:bg-[#090E1A]",
      // transition
      "data-[state=closed]:animate-drawerSlideRightAndFade data-[state=open]:animate-drawerSlideLeftAndFade",
      vF,
      t
    ),
    ...e
  }
) }) }));
c1t.displayName = "DrawerContent";
const u1t = P.forwardRef(({ children: t, className: e, ...r }, n) => /* @__PURE__ */ R.jsxs(
  "div",
  {
    ref: n,
    className: "flex items-start justify-between gap-x-4 border-b border-gray-200 pb-4 dark:border-gray-900",
    ...r,
    children: [
      /* @__PURE__ */ R.jsx("div", { className: Hr("mt-1 flex flex-col gap-y-1", e), children: t }),
      /* @__PURE__ */ R.jsx(Xft, { asChild: !0, children: /* @__PURE__ */ R.jsx(
        a1t,
        {
          variant: "ghost",
          className: "aspect-square p-1 hover:bg-gray-100 hover:dark:bg-gray-400/10",
          children: /* @__PURE__ */ R.jsx(X_r, { className: "size-6", "aria-hidden": "true" })
        }
      ) })
    ]
  }
));
u1t.displayName = "Drawer.Header";
const d1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  ZWr,
  {
    ref: r,
    className: Hr(
      // base
      "text-base font-semibold",
      // text color
      "text-gray-900 dark:text-gray-50",
      t
    ),
    ...e
  }
));
d1t.displayName = "DrawerTitle";
const f1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx("div", { ref: r, className: Hr("flex-1 py-4", t), ...e }));
f1t.displayName = "Drawer.Body";
const h1t = P.forwardRef(({ className: t, ...e }, r) => /* @__PURE__ */ R.jsx(
  JWr,
  {
    ref: r,
    className: Hr("text-gray-500 dark:text-gray-500", t),
    ...e
  }
));
h1t.displayName = "DrawerDescription";
const rHr = ({ block: t }) => {
  const [e, r] = Te.useState(
    t.values.visualizationType
  );
  return /* @__PURE__ */ R.jsxs(ar.Box, { children: [
    /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ R.jsx(hy.Heading, { as: "h3", variant: "heading30", children: t.values.title }),
      /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsxs(
        K0.Select,
        {
          id: "vis-type",
          value: e,
          onChange: (n) => r(
            n.target.value
          ),
          children: [
            /* @__PURE__ */ R.jsx(K0.Option, { value: "bar-list", children: "Bar List" }),
            /* @__PURE__ */ R.jsx(K0.Option, { value: "bar-chart", children: "Bar Chart" }),
            /* @__PURE__ */ R.jsx(K0.Option, { value: "donut-chart", children: "Donut Chart" }),
            /* @__PURE__ */ R.jsx(K0.Option, { value: "pie-chart", children: "Pie Chart" })
          ]
        }
      ) })
    ] }),
    e === "bar-list" && /* @__PURE__ */ R.jsx(ar.Box, { paddingTop: "space40", children: /* @__PURE__ */ R.jsx(wWr, { data: t.values.data }) }),
    e === "bar-chart" && /* @__PURE__ */ R.jsx(
      s3e,
      {
        data: t.values.data,
        index: "name",
        categories: ["value"],
        xAxisLabel: t.values.xLabel,
        yAxisLabel: t.values.yLabel
      }
    ),
    e === "donut-chart" && /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", justifyContent: "center", paddingTop: "space40", children: /* @__PURE__ */ R.jsx(
      rfe,
      {
        variant: "donut",
        data: t.values.data,
        category: "name",
        value: "value",
        showLabel: !0
      }
    ) }),
    e === "pie-chart" && /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", justifyContent: "center", paddingTop: "space40", children: /* @__PURE__ */ R.jsx(
      rfe,
      {
        variant: "pie",
        data: t.values.data,
        category: "name",
        value: "value",
        showLabel: !0
      }
    ) })
  ] });
}, nHr = ({ block: t }) => {
  const e = Object.keys(t.values.data[0]).filter(
    (a) => a !== t.values.index
  ), [r, n] = Te.useState(t.values.visualizationType);
  return /* @__PURE__ */ R.jsxs(ar.Box, { minWidth: "500px", maxWidth: "1000px", children: [
    /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ R.jsx(hy.Heading, { as: "h3", variant: "heading30", children: t.values.title }),
      /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsxs(
        K0.Select,
        {
          id: "vis-type",
          value: r,
          onChange: (a) => n(
            a.target.value
          ),
          children: [
            /* @__PURE__ */ R.jsx(K0.Option, { value: "line-chart", children: "Line Chart" }),
            /* @__PURE__ */ R.jsx(K0.Option, { value: "bar-chart", children: "Bar Chart" }),
            /* @__PURE__ */ R.jsx(K0.Option, { value: "area-chart", children: "Area Chart" })
          ]
        }
      ) })
    ] }),
    r === "bar-chart" && /* @__PURE__ */ R.jsx(
      s3e,
      {
        data: t.values.data,
        index: t.values.index,
        categories: e,
        xAxisLabel: t.values.xLabel,
        yAxisLabel: t.values.yLabel
      }
    ),
    r === "line-chart" && /* @__PURE__ */ R.jsx(
      Nft,
      {
        data: t.values.data,
        index: t.values.index,
        categories: e,
        xAxisLabel: t.values.xLabel,
        yAxisLabel: t.values.yLabel
      }
    ),
    r === "area-chart" && /* @__PURE__ */ R.jsx(
      Pft,
      {
        data: t.values.data,
        index: t.values.index,
        categories: e,
        xAxisLabel: t.values.xLabel,
        yAxisLabel: t.values.yLabel
      }
    )
  ] });
};
var zae = {}, p1t = P.createContext({ striped: !1 }), h3e = P.forwardRef(({ element: t = "TABLE", id: e, isActionable: r, scrollHorizontally: n, noWrap: a, striped: i = !1, tableLayout: o = "auto", variant: s = "default", ...l }, c) => {
  let u = { striped: i };
  return P.createElement(p1t.Provider, { value: u }, P.createElement(ht, { id: e, element: `${t}_WRAPPER`, overflowX: n ? "auto" : null, whiteSpace: a ? "nowrap" : null, boxShadow: r ? "shadowFocus" : null }, P.createElement(ht, { ...Xt(l), ref: c, as: "table", borderCollapse: "separate", borderColor: "colorBorderWeaker", borderSpacing: "0", borderStyle: "solid", borderWidth: s === "borderless" ? "borderWidth0" : "borderWidth10", element: t, tableLayout: o === "fixed" ? "fixed" : "auto", width: "100%" })));
});
h3e.displayName = "Table";
var aHr = ({ stickyHeader: t }) => t ? { position: "sticky", zIndex: "zIndex10" } : {}, iHr = ds.thead(us({ backgroundColor: "colorBackgroundWeak", color: "colorTextWeak", top: (t) => t.top })), p3e = P.forwardRef(({ element: t = "THEAD", stickyHeader: e = !1, top: r = e ? "-1px" : null, ...n }, a) => P.createElement(ht, { ...Xt(n), ref: a, as: iHr, element: t, top: r, ...aHr({ stickyHeader: e }) }));
p3e.displayName = "THead";
var l$e = { borderBottomWidth: "borderWidth0" }, oHr = ds.tbody(us({ backgroundColor: "colorBackgroundWeakest", "& > tr:last-of-type > td": l$e, "& > tr:last-of-type > th": l$e })), m3e = P.forwardRef(({ element: t = "TBODY", children: e, ...r }, n) => P.createElement(ht, { as: oHr, ...Xt(r), ref: n, element: t, color: "colorText" }, e));
m3e.displayName = "TBody";
var c$e = { borderBottomWidth: "borderWidth0", borderTopWidth: "borderWidth10", fontWeight: "fontWeightSemibold", paddingY: "space40" }, sHr = ds.tfoot(us({ "& > tr > td": c$e, "& > tr > th": c$e })), g3e = P.forwardRef(({ element: t = "TFOOT", ...e }, r) => P.createElement(ht, { ...Xt(e), ref: r, as: sHr, backgroundColor: "colorBackgroundWeak", color: "colorTextWeak", element: t }));
g3e.displayName = "TFoot";
var m1t = P.forwardRef(({ element: t = "TR", verticalAlign: e = "middle", ...r }, n) => {
  let { striped: a } = P.useContext(p1t);
  return P.createElement(ht, { ...Xt(r), ref: n, as: "tr", element: t, verticalAlign: e, _even: { backgroundColor: a ? "colorBackgroundRowStriped" : "transparent" }, _last: { borderWidth: "borderWidth0" } });
});
m1t.displayName = "Tr";
var g1t = P.forwardRef(({ element: t = "TD", textAlign: e = "left", whiteSpace: r, ...n }, a) => P.createElement(ht, { ...Xt(n), ref: a, as: "td", borderStyle: "solid", borderColor: "colorBorderWeaker", borderWidth: "borderWidth0", borderBottomWidth: "borderWidth10", element: t, fontSize: "fontSize30", lineHeight: "lineHeight30", padding: "space50", position: "relative", textAlign: e, whiteSpace: r, verticalAlign: "inherit", wordWrap: "break-word", color: "inherit" }));
g1t.displayName = "Td";
var v1t = P.forwardRef(({ element: t = "TH", textAlign: e = "left", whiteSpace: r, width: n, ...a }, i) => P.createElement(ht, { ...Xt(a), ref: i, as: "th", borderBottomStyle: "solid", borderBottomColor: "colorBorderWeaker", borderBottomWidth: "borderWidth10", element: t, fontSize: "fontSize30", lineHeight: "lineHeight30", fontWeight: "fontWeightSemibold", paddingBottom: "space40", paddingLeft: "space50", paddingRight: "space50", paddingTop: "space40", position: "relative", textAlign: e, whiteSpace: r, verticalAlign: "inherit", width: n, wordWrap: "break-word", color: "inherit" }));
v1t.displayName = "Th";
const lHr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TBody: m3e,
  TFoot: g3e,
  THead: p3e,
  Table: h3e,
  Td: g1t,
  Th: v1t,
  Tr: m1t
}, Symbol.toStringTag, { value: "Module" })), cHr = /* @__PURE__ */ aa(lHr);
var u$e;
function uHr() {
  return u$e || (u$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = cHr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(zae)), zae;
}
var qc = /* @__PURE__ */ uHr();
const dHr = ha.object({
  title: ha.string(),
  columns: ha.array(
    ha.object({
      displayName: ha.string(),
      key: ha.string()
    })
  ),
  rows: ha.array(ha.record(ha.any()))
}), fHr = ({ block: t }) => {
  let e;
  try {
    e = dHr.parse(t.values);
  } catch {
    return /* @__PURE__ */ R.jsx($a, { error: "Invalid values" });
  }
  return /* @__PURE__ */ R.jsxs(qc.Table, { children: [
    /* @__PURE__ */ R.jsx(qc.THead, { children: /* @__PURE__ */ R.jsx(qc.Tr, { children: e.columns.map((r, n) => /* @__PURE__ */ R.jsx(qc.Th, { children: r.displayName }, n)) }) }),
    /* @__PURE__ */ R.jsx(qc.TBody, { children: e.rows.map((r, n) => /* @__PURE__ */ R.jsx(qc.Tr, { children: e.columns.map((a, i) => /* @__PURE__ */ R.jsx(qc.Td, { children: /* @__PURE__ */ R.jsx(pf.Text, { as: "span", fontFamily: "fontFamilyCode", children: r[a.key] }) }, i)) }, n)) })
  ] });
};
var Gae, d$e;
function y1t() {
  if (d$e) return Gae;
  d$e = 1;
  var t = Object.create, e = Object.defineProperty, r = Object.defineProperties, n = Object.getOwnPropertyDescriptor, a = Object.getOwnPropertyDescriptors, i = Object.getOwnPropertyNames, o = Object.getOwnPropertySymbols, s = Object.getPrototypeOf, l = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable, u = (A, I, M) => I in A ? e(A, I, { enumerable: !0, configurable: !0, writable: !0, value: M }) : A[I] = M, f = (A, I) => {
    for (var M in I || (I = {})) l.call(I, M) && u(A, M, I[M]);
    if (o) for (var M of o(I)) c.call(I, M) && u(A, M, I[M]);
    return A;
  }, h = (A, I) => r(A, a(I)), p = (A, I) => {
    var M = {};
    for (var B in A) l.call(A, B) && I.indexOf(B) < 0 && (M[B] = A[B]);
    if (A != null && o) for (var B of o(A)) I.indexOf(B) < 0 && c.call(A, B) && (M[B] = A[B]);
    return M;
  }, g = (A, I) => {
    for (var M in I) e(A, M, { get: I[M], enumerable: !0 });
  }, y = (A, I, M, B) => {
    if (I && typeof I == "object" || typeof I == "function") for (let L of i(I)) !l.call(A, L) && L !== M && e(A, L, { get: () => I[L], enumerable: !(B = n(I, L)) || B.enumerable });
    return A;
  }, b = (A, I, M) => (M = A != null ? t(s(A)) : {}, y(!A || !A.__esModule ? e(M, "default", { value: A, enumerable: !0 }) : M, A)), w = (A) => y(e({}, "__esModule", { value: !0 }), A), _ = {};
  g(_, { IconWrapper: () => S }), Gae = w(_);
  var C = TKe, x = b(Te);
  const S = x.forwardRef((A, I) => {
    var M = A, { as: B = "span", color: L = "currentColor", display: N = "block", element: d = "ICON", size: m = "sizeIcon30" } = M, v = p(M, ["as", "color", "display", "element", "size"]);
    return x.createElement(C.Box, h(f({}, (0, C.safelySpreadBoxProps)(v)), { as: B, element: d, lineHeight: "lineHeight0", display: N, color: L, size: m, ref: I, flexShrink: 0 }));
  });
  return S.displayName = "IconWrapper", Gae;
}
var Wae, f$e;
function hHr() {
  if (f$e) return Wae;
  f$e = 1;
  var t = Object.create, e = Object.defineProperty, r = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, a = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, o = (y, b) => {
    for (var w in b) e(y, w, { get: b[w], enumerable: !0 });
  }, s = (y, b, w, _) => {
    if (b && typeof b == "object" || typeof b == "function") for (let C of n(b)) !i.call(y, C) && C !== w && e(y, C, { get: () => b[C], enumerable: !(_ = r(b, C)) || _.enumerable });
    return y;
  }, l = (y, b, w) => (w = y != null ? t(a(y)) : {}, s(!y || !y.__esModule ? e(w, "default", { value: y, enumerable: !0 }) : w, y)), c = (y) => s(e({}, "__esModule", { value: !0 }), y), u = {};
  o(u, { SearchIcon: () => g }), Wae = c(u);
  var f = sge, h = l(Te), p = /* @__PURE__ */ y1t();
  const g = h.forwardRef(({ as: y, display: b, element: w = "ICON", size: _, color: C, title: x, decorative: S }, A) => {
    const I = `SearchIcon-${(0, f.useUID)()}`;
    if (!S && x == null) throw new Error("[SearchIcon]: Missing a title for non-decorative icon.");
    return h.createElement(p.IconWrapper, { as: y, display: b, element: w, size: _, color: C, ref: A }, h.createElement("svg", { role: "img", "aria-hidden": S, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": I }, x ? h.createElement("title", { id: I }, x) : null, h.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.43 5.43a4.882 4.882 0 017.383 6.347l2.973 2.973a.732.732 0 01-1.036 1.036l-2.973-2.973A4.883 4.883 0 015.43 5.43zm1.035 1.035a3.417 3.417 0 104.833 4.833 3.417 3.417 0 00-4.833-4.833z" })));
  });
  return g.displayName = "SearchIcon", Wae;
}
var pHr = /* @__PURE__ */ hHr();
const mHr = ha.object({
  label: A5,
  value: A5
}), gHr = ha.object({
  label: A5,
  options: ha.array(mHr)
}), vHr = ({ block: t }) => {
  const { sendMessage: e } = Ume(), [r, n] = Yt(), [a, i] = Yt(null), [o, s] = Yt(null), [l, c] = Yt();
  Ut(() => {
    try {
      c(gHr.parse(t.values));
    } catch {
      s("Invalid values");
    }
  }, []), Ut(() => {
    l && (n(l.options), i(l.options[0]));
  }, [l]);
  const u = (f) => {
    if (!l)
      return;
    const { selectedItem: h } = f, p = l.options.find(
      (g) => g.label === h.label
    );
    p && i(p);
  };
  return /* @__PURE__ */ R.jsxs(tWe, { children: [
    o && /* @__PURE__ */ R.jsx($a, { error: o }),
    r && l && /* @__PURE__ */ R.jsx(
      htt.Combobox,
      {
        autocomplete: !0,
        labelText: l.label,
        items: r,
        initialSelectedItem: r[0],
        optionTemplate: (f) => f.label,
        itemToString: (f) => f ? f.label : null,
        onInputValueChange: ({ inputValue: f }) => {
          f !== void 0 && n(
            l.options.filter(
              (h) => h.label.toLowerCase().startsWith(f.toLowerCase())
            )
          );
        },
        insertAfter: /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", children: /* @__PURE__ */ R.jsx(
          pHr.SearchIcon,
          {
            decorative: !1,
            size: "sizeIcon20",
            title: "Search Accounts"
          }
        ) }),
        onSelectedItemChange: u
      }
    ),
    /* @__PURE__ */ R.jsx(ar.Box, { width: "100%", marginTop: "space40", children: /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", justifyContent: "space-between", marginTop: "space50", children: [
      /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", onClick: () => e({ message: "Nevermind, I don't want make this selection." }), children: "Cancel" }),
      a && /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", onClick: () => e({ message: a.value }), children: "Submit" })
    ] }) })
  ] });
}, b1t = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowForwardIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowForwardIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.991 9.91l.007.05v.08l-.01.07-.01.029a.489.489 0 01-.205.272l-3.832 3.444a.596.596 0 01-.78 0 .459.459 0 01-.063-.632l.063-.069 2.957-2.659H5.513A.504.504 0 015 10a.5.5 0 01.42-.488l.093-.008h7.604l-2.956-2.658a.459.459 0 01-.063-.632l.063-.069a.598.598 0 01.704-.057l.076.057 3.832 3.444c.098.064.172.16.206.272l.012.049z" })));
});
b1t.displayName = "ArrowForwardIcon";
const hP = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArtificialIntelligenceIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArtificialIntelligenceIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M13.699 2.447c-.01 2.674-1.297 3.917-3.962 3.955-.595.008-.588.899.007.898 2.735-.004 3.928 1.287 3.955 3.957.005.58.868.598.897.017.135-2.699 1.396-3.984 3.953-3.974.594.002.605-.885.012-.898-2.739-.062-3.974-1.345-3.964-3.951.002-.599-.896-.602-.898-.004zm.444 2.432l.06.131c.394.81 1.015 1.41 1.864 1.794l.105.045-.035.016c-.837.387-1.463 1.015-1.873 1.872l-.078.17-.017-.044c-.37-.89-.98-1.547-1.838-1.958l-.155-.07c.837-.37 1.46-.95 1.866-1.743l.101-.213z" }), P.createElement("path", { fill: "currentColor", d: "M4.5 10.132a5.87 5.87 0 015.871-5.868.5.5 0 100-1A6.87 6.87 0 003.5 10.132a6.87 6.87 0 004.417 6.417.5.5 0 00.357-.934A5.87 5.87 0 014.5 10.132zm8.368 5.358a.5.5 0 01.202.96 6.851 6.851 0 01-2.67.55h-.029a.5.5 0 110-1h.024a5.85 5.85 0 002.282-.47.499.499 0 01.191-.04zm3.657-3.628a.5.5 0 01.297.642 6.863 6.863 0 01-1.187 2.043.5.5 0 01-.766-.643 5.86 5.86 0 001.014-1.745.5.5 0 01.642-.297z" })));
});
hP.displayName = "ArtificialIntelligenceIcon";
const yHr = ha.object({
  title: ha.string(),
  body: ha.string(),
  icon: ha.string(),
  cta: ha.object({
    text: ha.string(),
    url: ha.string()
  })
}), bHr = ({ block: t }) => {
  let e;
  try {
    e = yHr.parse(t.values);
  } catch {
    return /* @__PURE__ */ R.jsx($a, { error: "Invalid values" });
  }
  return /* @__PURE__ */ R.jsx(
    _r,
    {
      backgroundColor: "colorBackgroundBodyInverse",
      borderRadius: "borderRadius30",
      padding: "space70",
      children: /* @__PURE__ */ R.jsxs(_r, { columnGap: "space40", display: "flex", rowGap: "space40", children: [
        /* @__PURE__ */ R.jsx(_r, { flexShrink: 0, children: /* @__PURE__ */ R.jsx(
          hP,
          {
            color: "colorTextBrandInverse",
            decorative: !0,
            size: "sizeIcon50",
            title: "Description of icon"
          }
        ) }),
        /* @__PURE__ */ R.jsxs(_r, { children: [
          /* @__PURE__ */ R.jsx(
            kb,
            {
              as: "h3",
              color: "colorTextBrandInverse",
              className: "font-semibold",
              fontSize: "fontSize30",
              marginBottom: "space10",
              children: e.title
            }
          ),
          /* @__PURE__ */ R.jsx(
            kb,
            {
              as: "p",
              color: "colorTextBrandInverse",
              fontSize: "fontSize20",
              marginBottom: "space60",
              children: e.body
            }
          ),
          /* @__PURE__ */ R.jsx(ZGe, { href: e.cta.url, children: /* @__PURE__ */ R.jsxs(
            kb,
            {
              as: "span",
              color: "colorTextBrandInverse",
              display: "inline-flex",
              fontWeight: "fontWeightMedium",
              href: e.cta.url,
              children: [
                e.cta.text,
                /* @__PURE__ */ R.jsx(b1t, { decorative: !0 })
              ]
            }
          ) })
        ] })
      ] })
    }
  );
}, v3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChatIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChatIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M3.302 2.755A3.458 3.458 0 015.466 2h2.268a3.468 3.468 0 013.322 2.476.5.5 0 00.959-.286A4.468 4.468 0 007.734 1H5.468a4.458 4.458 0 00-2.2 8.34v3.493a.5.5 0 00.853.353l2.267-2.266a.5.5 0 00-.708-.707l-1.413 1.413V9.037a.5.5 0 00-.286-.452 3.458 3.458 0 01-.68-5.83zm8.965 3.911a4.466 4.466 0 100 8.933h.36l3.253 3.254a.5.5 0 00.853-.354v-3.492A4.459 4.459 0 0019 11.134a4.469 4.469 0 00-4.466-4.468h-2.267zM9.816 8.682a3.466 3.466 0 012.451-1.016h2.267A3.467 3.467 0 0118 11.132a3.459 3.459 0 01-1.98 3.12.5.5 0 00-.287.451v2.589l-2.546-2.546a.5.5 0 00-.353-.147h-.567a3.466 3.466 0 01-2.451-5.917z" })));
});
v3e.displayName = "ChatIcon";
var Hae = {};
const x1t = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ClearIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ClearIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M10 16.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm.897-6.5l1.917 1.917a.635.635 0 01-.897.897L10 10.897l-1.917 1.917a.635.635 0 01-.897-.897L9.103 10 7.186 8.083a.635.635 0 01.897-.897L10 9.103l1.917-1.917a.635.635 0 01.897.897L10.897 10z" })));
});
x1t.displayName = "ClearIcon";
var dC = P.createContext("inbound"), xHr = { inbound: { backgroundColor: "colorBackgroundElevation", alignSelf: "flex-start" }, outbound: { backgroundColor: "colorBackgroundInverseStrongerElevation", alignSelf: "flex-end", color: "colorTextInverse" } }, C1t = P.forwardRef(({ children: t, element: e = "CHAT_BUBBLE", ...r }, n) => {
  let a = P.useContext(dC);
  return P.createElement(ht, { display: "inline-block", fontSize: "fontSize30", lineHeight: "lineHeight20", borderRadius: "borderRadius20", paddingY: "space30", paddingX: "space40", marginBottom: "space30", wordWrap: "break-word", maxWidth: "100%", minWidth: 0, element: e, ref: n, variant: a, whiteSpace: "pre-wrap", ...xHr[a], ...Xt(r) }, t);
});
C1t.displayName = "ChatBubble";
var CHr = { inbound: { marginRight: "space70" }, outbound: { marginLeft: "space70" } }, w1t = P.forwardRef(({ children: t, variant: e, element: r = "CHAT_MESSAGE", ...n }, a) => P.createElement(dC.Provider, { value: e }, P.createElement(ht, { role: "listitem", display: "flex", flexDirection: "column", ref: a, element: r, variant: e, ...CHr[e], ...Xt(n) }, t)));
w1t.displayName = "ChatMessage";
var S1t = P.forwardRef(({ children: t, element: e = "CHAT_MESSAGE_META", ...r }, n) => {
  let a = P.useContext(dC);
  return P.createElement(ht, { ...Xt(r), ref: n, element: e, display: "flex", justifyContent: a === "inbound" ? "flex-start" : "flex-end", textAlign: a === "outbound" ? "right" : "left", alignItems: "center", variant: a, columnGap: "space30", fontWeight: "fontWeightMedium" }, t);
});
S1t.displayName = "ChatMessageMeta";
var _1t = P.forwardRef(({ children: t, element: e = "CHAT_MESSAGE_META_ITEM", ...r }, n) => P.createElement(ht, { ref: n, element: e, display: "flex", alignItems: "flex-start", columnGap: "space30", color: "colorTextWeak", lineHeight: "lineHeight20", fontSize: "fontSize20", ...Xt(r) }, t));
_1t.displayName = "ChatMessageMetaItem";
var y3e = P.forwardRef(({ children: t, element: e = "CHAT_LOG", ...r }, n) => P.createElement(ht, { role: "log", padding: "space70", element: e, ref: n, ...Xt(r) }, P.createElement(ht, { as: "div", role: "list", margin: "space0", padding: "space0", display: "flex", flexDirection: "column", rowGap: "space80" }, t)));
y3e.displayName = "ChatLog";
var wHr = { backgroundColor: "colorBackgroundBody", borderRadius: "borderRadiusCircle", width: "12px", height: "12px", display: "flex", justifyContent: "center", alignItems: "center" }, k1t = P.forwardRef(({ children: t, onDismiss: e, i18nDismissLabel: r = "Remove attachment", element: n = "COMPOSER_ATTACHMENT_CARD", ...a }, i) => P.createElement(ht, { ...Xt(a), ref: i, paddingY: "space30", paddingX: "space40", borderRadius: "borderRadius30", backgroundColor: "colorBackgroundBodyElevation", position: "relative", display: "inline-block", width: "100%", element: n }, t, e && P.createElement(ht, { position: "absolute", top: "space0", right: "space0", transform: "translate(50%, -50%)", ...wHr }, P.createElement(Zs, { element: `${n}_REMOVE_BUTTON`, variant: "secondary_icon", size: "icon", onClick: e }, P.createElement(x1t, { decorative: !0 }), P.createElement(Ul, null, r)))));
k1t.displayName = "ComposerAttachmentCard";
var A1t = P.forwardRef(({ children: t, element: e = "CHAT_ATTACHMENT", attachmentIcon: r, ...n }, a) => {
  let i = P.useContext(dC);
  return P.createElement(Q5, { ...n, as: "div", ref: a, verticalAlign: "center", element: e }, P.createElement(qm, { as: "div", spacing: "space30" }, P.createElement(ht, { color: i === "inbound" ? "colorTextIcon" : "colorTextInverse", element: `${e}_ICON` }, r)), P.createElement(e6, { as: "div", element: `${e}_BODY` }, P.createElement(J5, { orientation: "vertical", spacing: "space10" }, t)));
});
A1t.displayName = "ChatAttachment";
var T1t = P.forwardRef(({ children: t, href: e, element: r = "CHAT_ATTACHMENT_LINK", ...n }, a) => {
  let i = P.useContext(dC);
  return P.createElement(m7, { href: e, ref: a, element: r, variant: i === "inbound" ? "default" : "inverse", ...n }, P.createElement(mG, { title: t }, t));
});
T1t.displayName = "ChatAttachmentLink";
var E1t = P.forwardRef(({ children: t, element: e = "CHAT_ATTACHMENT_DESCRIPTION", ...r }, n) => {
  let a = P.useContext(dC);
  return P.createElement(cl, { ...lg(r), element: e, ref: n, as: "div", fontSize: "fontSize20", color: a === "inbound" ? "colorTextWeak" : "colorTextInverse", lineHeight: "lineHeight20" }, t);
});
E1t.displayName = "ChatAttachmentDescription";
var I1t = P.forwardRef(({ children: t, element: e = "CHAT_BOOKEND", ...r }, n) => P.createElement(ht, { ...Xt(r), as: "div", role: "listitem", color: "colorTextWeak", element: e, textAlign: "center", marginBottom: "space20", lineHeight: "lineHeight20", fontSize: "fontSize20", fontWeight: "fontWeightMedium", ref: n }, t));
I1t.displayName = "ChatBookend";
var M1t = P.forwardRef(({ children: t, element: e = "CHAT_BOOKEND_ITEM", ...r }, n) => P.createElement(ht, { ...Xt(r), as: "div", element: e, ref: n }, t));
M1t.displayName = "ChatBookendItem";
var P1t = P.forwardRef(({ children: t, element: e = "CHAT_EVENT", ...r }, n) => P.createElement(ht, { ...Xt(r), as: "div", role: "listitem", color: "colorTextWeak", element: e, textAlign: "center", lineHeight: "lineHeight20", fontSize: "fontSize20", fontWeight: "fontWeightMedium", ref: n }, t));
P1t.displayName = "ChatEvent";
var SHr = Zh(ht), h$e = (t) => t.variant === "inbound" ? -100 : t.variant === "outbound" ? 100 : 0, R1t = P.forwardRef(({ chats: t, ...e }, r) => {
  let n = A8(t, { keys: (i) => i.id, from: (i) => ({ opacity: 0, x: h$e(i) }), enter: { opacity: 1, x: 0 }, leave: (i) => ({ opacity: 0, x: h$e(i) }), config: { mass: 0.7, tension: 190, friction: 16 } }), a = iM() ? t.map((i) => P.cloneElement(i.content, { key: i.id })) : n((i, o, { key: s }) => P.createElement(SHr, { as: "div", style: i, key: s }, o.content));
  return P.createElement(y3e, { ...e, ref: r }, a);
});
R1t.displayName = "ChatLogger";
var p$e = (t) => ({ ...t, id: t.id || D2e(t.content) }), _Hr = (...t) => {
  let e = P.useMemo(() => t.map(p$e), [t]), [r, n] = P.useState(e), a = P.useCallback((s) => {
    n((l) => l.concat(p$e(s)));
  }, []), i = P.useCallback((s) => {
    n((l) => s ? l.filter((c) => c.id !== s) : l.slice(0, -1));
  }, []), o = P.useCallback(() => n([]), []);
  return { push: a, pop: i, chats: r, clear: o };
};
const kHr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatAttachment: A1t,
  ChatAttachmentDescription: E1t,
  ChatAttachmentLink: T1t,
  ChatBookend: I1t,
  ChatBookendItem: M1t,
  ChatBubble: C1t,
  ChatEvent: P1t,
  ChatLog: y3e,
  ChatLogger: R1t,
  ChatMessage: w1t,
  ChatMessageMeta: S1t,
  ChatMessageMetaItem: _1t,
  ComposerAttachmentCard: k1t,
  useChatLogger: _Hr
}, Symbol.toStringTag, { value: "Module" })), AHr = /* @__PURE__ */ aa(kHr);
var m$e;
function THr() {
  return m$e || (m$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = AHr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Hae)), Hae;
}
var Ks = /* @__PURE__ */ THr(), Uae = {};
const EHr = /* @__PURE__ */ aa(XOt);
var g$e;
function IHr() {
  return g$e || (g$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = EHr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Uae)), Uae;
}
var S6 = /* @__PURE__ */ IHr();
const O1t = 6048e5, MHr = 864e5, v$e = Symbol.for("constructDateFrom");
function gf(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && v$e in t ? t[v$e](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Il(t, e) {
  return gf(e || t, t);
}
function PHr(t, e, r) {
  const n = Il(t, r == null ? void 0 : r.in);
  return isNaN(e) ? gf(t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function RHr(t, e, r) {
  const n = Il(t, r == null ? void 0 : r.in);
  if (isNaN(e)) return gf(t, NaN);
  if (!e)
    return n;
  const a = n.getDate(), i = gf(t, n.getTime());
  i.setMonth(n.getMonth() + e + 1, 0);
  const o = i.getDate();
  return a >= o ? i : (n.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    a
  ), n);
}
function OHr(t, e, r) {
  const {
    years: n = 0,
    months: a = 0,
    weeks: i = 0,
    days: o = 0,
    hours: s = 0,
    minutes: l = 0,
    seconds: c = 0
  } = e, u = Il(t, r == null ? void 0 : r.in), f = a || n ? RHr(u, a + n * 12) : u, h = o || i ? PHr(f, o + i * 7) : f, p = l + s * 60, y = (c + p * 60) * 1e3;
  return gf(t, +h + y);
}
let BHr = {};
function AH() {
  return BHr;
}
function nI(t, e) {
  var s, l, c, u;
  const r = AH(), n = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? r.weekStartsOn ?? ((u = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, a = Il(t, e == null ? void 0 : e.in), i = a.getDay(), o = (i < n ? 7 : 0) + i - n;
  return a.setDate(a.getDate() - o), a.setHours(0, 0, 0, 0), a;
}
function bF(t, e) {
  return nI(t, { ...e, weekStartsOn: 1 });
}
function B1t(t, e) {
  const r = Il(t, e == null ? void 0 : e.in), n = r.getFullYear(), a = gf(r, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const i = bF(a), o = gf(r, 0);
  o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0);
  const s = bF(o);
  return r.getTime() >= i.getTime() ? n + 1 : r.getTime() >= s.getTime() ? n : n - 1;
}
function y$e(t) {
  const e = Il(t), r = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return r.setUTCFullYear(e.getFullYear()), +t - +r;
}
function N1t(t, ...e) {
  const r = gf.bind(
    null,
    e.find((n) => typeof n == "object")
  );
  return e.map(r);
}
function xF(t, e) {
  const r = Il(t, e == null ? void 0 : e.in);
  return r.setHours(0, 0, 0, 0), r;
}
function NHr(t, e, r) {
  const [n, a] = N1t(
    r == null ? void 0 : r.in,
    t,
    e
  ), i = xF(n), o = xF(a), s = +i - y$e(i), l = +o - y$e(o);
  return Math.round((s - l) / MHr);
}
function $Hr(t, e) {
  const r = B1t(t, e), n = gf(t, 0);
  return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), bF(n);
}
function DHr(t, e, r) {
  const [n, a] = N1t(
    r == null ? void 0 : r.in,
    t,
    e
  );
  return +xF(n) == +xF(a);
}
function LHr(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function jHr(t) {
  return !(!LHr(t) && typeof t != "number" || isNaN(+Il(t)));
}
function FHr(t, e) {
  const r = Il(t, e == null ? void 0 : e.in);
  return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
const zHr = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, GHr = (t, e, r) => {
  let n;
  const a = zHr[t];
  return typeof a == "string" ? n = a : e === 1 ? n = a.one : n = a.other.replace("{{count}}", e.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Vae(t) {
  return (e = {}) => {
    const r = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[r] || t.formats[t.defaultWidth];
  };
}
const WHr = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, HHr = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, UHr = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, VHr = {
  date: Vae({
    formats: WHr,
    defaultWidth: "full"
  }),
  time: Vae({
    formats: HHr,
    defaultWidth: "full"
  }),
  dateTime: Vae({
    formats: UHr,
    defaultWidth: "full"
  })
}, qHr = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, KHr = (t, e, r, n) => qHr[t];
function vS(t) {
  return (e, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let a;
    if (n === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = r != null && r.width ? String(r.width) : o;
      a = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = r != null && r.width ? String(r.width) : t.defaultWidth;
      a = t.values[s] || t.values[o];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return a[i];
  };
}
const ZHr = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, JHr = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, YHr = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, XHr = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, QHr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, eUr = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, tUr = (t, e) => {
  const r = Number(t), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, rUr = {
  ordinalNumber: tUr,
  era: vS({
    values: ZHr,
    defaultWidth: "wide"
  }),
  quarter: vS({
    values: JHr,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: vS({
    values: YHr,
    defaultWidth: "wide"
  }),
  day: vS({
    values: XHr,
    defaultWidth: "wide"
  }),
  dayPeriod: vS({
    values: QHr,
    defaultWidth: "wide",
    formattingValues: eUr,
    defaultFormattingWidth: "wide"
  })
};
function yS(t) {
  return (e, r = {}) => {
    const n = r.width, a = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], i = e.match(a);
    if (!i)
      return null;
    const o = i[0], s = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? aUr(s, (f) => f.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      nUr(s, (f) => f.test(o))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = r.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      r.valueCallback(c)
    ) : c;
    const u = e.slice(o.length);
    return { value: c, rest: u };
  };
}
function nUr(t, e) {
  for (const r in t)
    if (Object.prototype.hasOwnProperty.call(t, r) && e(t[r]))
      return r;
}
function aUr(t, e) {
  for (let r = 0; r < t.length; r++)
    if (e(t[r]))
      return r;
}
function iUr(t) {
  return (e, r = {}) => {
    const n = e.match(t.matchPattern);
    if (!n) return null;
    const a = n[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let o = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    o = r.valueCallback ? r.valueCallback(o) : o;
    const s = e.slice(a.length);
    return { value: o, rest: s };
  };
}
const oUr = /^(\d+)(th|st|nd|rd)?/i, sUr = /\d+/i, lUr = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, cUr = {
  any: [/^b/i, /^(a|c)/i]
}, uUr = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, dUr = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fUr = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, hUr = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, pUr = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, mUr = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, gUr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, vUr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yUr = {
  ordinalNumber: iUr({
    matchPattern: oUr,
    parsePattern: sUr,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: yS({
    matchPatterns: lUr,
    defaultMatchWidth: "wide",
    parsePatterns: cUr,
    defaultParseWidth: "any"
  }),
  quarter: yS({
    matchPatterns: uUr,
    defaultMatchWidth: "wide",
    parsePatterns: dUr,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: yS({
    matchPatterns: fUr,
    defaultMatchWidth: "wide",
    parsePatterns: hUr,
    defaultParseWidth: "any"
  }),
  day: yS({
    matchPatterns: pUr,
    defaultMatchWidth: "wide",
    parsePatterns: mUr,
    defaultParseWidth: "any"
  }),
  dayPeriod: yS({
    matchPatterns: gUr,
    defaultMatchWidth: "any",
    parsePatterns: vUr,
    defaultParseWidth: "any"
  })
}, bUr = {
  code: "en-US",
  formatDistance: GHr,
  formatLong: VHr,
  formatRelative: KHr,
  localize: rUr,
  match: yUr,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function xUr(t, e) {
  const r = Il(t, e == null ? void 0 : e.in);
  return NHr(r, FHr(r)) + 1;
}
function CUr(t, e) {
  const r = Il(t, e == null ? void 0 : e.in), n = +bF(r) - +$Hr(r);
  return Math.round(n / O1t) + 1;
}
function $1t(t, e) {
  var u, f, h, p;
  const r = Il(t, e == null ? void 0 : e.in), n = r.getFullYear(), a = AH(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((p = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, o = gf((e == null ? void 0 : e.in) || t, 0);
  o.setFullYear(n + 1, 0, i), o.setHours(0, 0, 0, 0);
  const s = nI(o, e), l = gf((e == null ? void 0 : e.in) || t, 0);
  l.setFullYear(n, 0, i), l.setHours(0, 0, 0, 0);
  const c = nI(l, e);
  return +r >= +s ? n + 1 : +r >= +c ? n : n - 1;
}
function wUr(t, e) {
  var s, l, c, u;
  const r = AH(), n = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((u = (c = r.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, a = $1t(t, e), i = gf((e == null ? void 0 : e.in) || t, 0);
  return i.setFullYear(a, 0, n), i.setHours(0, 0, 0, 0), nI(i, e);
}
function SUr(t, e) {
  const r = Il(t, e == null ? void 0 : e.in), n = +nI(r, e) - +wUr(r, e);
  return Math.round(n / O1t) + 1;
}
function Oo(t, e) {
  const r = t < 0 ? "-" : "", n = Math.abs(t).toString().padStart(e, "0");
  return r + n;
}
const ev = {
  // Year
  y(t, e) {
    const r = t.getFullYear(), n = r > 0 ? r : 1 - r;
    return Oo(e === "yy" ? n % 100 : n, e.length);
  },
  // Month
  M(t, e) {
    const r = t.getMonth();
    return e === "M" ? String(r + 1) : Oo(r + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Oo(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Oo(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Oo(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Oo(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Oo(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const r = e.length, n = t.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return Oo(a, e.length);
  }
}, s9 = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, b$e = {
  // Era
  G: function(t, e, r) {
    const n = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, r) {
    if (e === "yo") {
      const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, { unit: "year" });
    }
    return ev.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, r, n) {
    const a = $1t(t, n), i = a > 0 ? a : 1 - a;
    if (e === "YY") {
      const o = i % 100;
      return Oo(o, 2);
    }
    return e === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : Oo(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const r = B1t(t);
    return Oo(r, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const r = t.getFullYear();
    return Oo(r, e.length);
  },
  // Quarter
  Q: function(t, e, r) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return Oo(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, r) {
    const n = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return Oo(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, r) {
    const n = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return ev.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, r) {
    const n = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return Oo(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, r, n) {
    const a = SUr(t, n);
    return e === "wo" ? r.ordinalNumber(a, { unit: "week" }) : Oo(a, e.length);
  },
  // ISO week of year
  I: function(t, e, r) {
    const n = CUr(t);
    return e === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Oo(n, e.length);
  },
  // Day of the month
  d: function(t, e, r) {
    return e === "do" ? r.ordinalNumber(t.getDate(), { unit: "date" }) : ev.d(t, e);
  },
  // Day of year
  D: function(t, e, r) {
    const n = xUr(t);
    return e === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Oo(n, e.length);
  },
  // Day of week
  E: function(t, e, r) {
    const n = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, r, n) {
    const a = t.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Oo(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, r, n) {
    const a = t.getDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Oo(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, r) {
    const n = t.getDay(), a = n === 0 ? 7 : n;
    switch (e) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Oo(a, e.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, r) {
    const a = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, r) {
    const n = t.getHours();
    let a;
    switch (n === 12 ? a = s9.noon : n === 0 ? a = s9.midnight : a = n / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, r) {
    const n = t.getHours();
    let a;
    switch (n >= 17 ? a = s9.evening : n >= 12 ? a = s9.afternoon : n >= 4 ? a = s9.morning : a = s9.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, r) {
    if (e === "ho") {
      let n = t.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return ev.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, r) {
    return e === "Ho" ? r.ordinalNumber(t.getHours(), { unit: "hour" }) : ev.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, r) {
    const n = t.getHours() % 12;
    return e === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Oo(n, e.length);
  },
  // Hour [1-24]
  k: function(t, e, r) {
    let n = t.getHours();
    return n === 0 && (n = 24), e === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Oo(n, e.length);
  },
  // Minute
  m: function(t, e, r) {
    return e === "mo" ? r.ordinalNumber(t.getMinutes(), { unit: "minute" }) : ev.m(t, e);
  },
  // Second
  s: function(t, e, r) {
    return e === "so" ? r.ordinalNumber(t.getSeconds(), { unit: "second" }) : ev.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return ev.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, r) {
    const n = t.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return C$e(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return tb(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return tb(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return C$e(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return tb(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return tb(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + x$e(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + tb(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, r) {
    const n = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + x$e(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + tb(n, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, r) {
    const n = Math.trunc(+t / 1e3);
    return Oo(n, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, r) {
    return Oo(+t, e.length);
  }
};
function x$e(t, e = "") {
  const r = t > 0 ? "-" : "+", n = Math.abs(t), a = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(a) : r + String(a) + e + Oo(i, 2);
}
function C$e(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Oo(Math.abs(t) / 60, 2) : tb(t, e);
}
function tb(t, e = "") {
  const r = t > 0 ? "-" : "+", n = Math.abs(t), a = Oo(Math.trunc(n / 60), 2), i = Oo(n % 60, 2);
  return r + a + e + i;
}
const w$e = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, D1t = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, _Ur = (t, e) => {
  const r = t.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return w$e(t, e);
  let i;
  switch (n) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", w$e(n, e)).replace("{{time}}", D1t(a, e));
}, kUr = {
  p: D1t,
  P: _Ur
}, AUr = /^D+$/, TUr = /^Y+$/, EUr = ["D", "DD", "YY", "YYYY"];
function IUr(t) {
  return AUr.test(t);
}
function MUr(t) {
  return TUr.test(t);
}
function PUr(t, e, r) {
  const n = RUr(t, e, r);
  if (console.warn(n), EUr.includes(t)) throw new RangeError(n);
}
function RUr(t, e, r) {
  const n = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const OUr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, BUr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, NUr = /^'([^]*?)'?$/, $Ur = /''/g, DUr = /[a-zA-Z]/;
function LUr(t, e, r) {
  var u, f, h, p;
  const n = AH(), a = n.locale ?? bUr, i = n.firstWeekContainsDate ?? ((f = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, o = n.weekStartsOn ?? ((p = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, s = Il(t, r == null ? void 0 : r.in);
  if (!jHr(s))
    throw new RangeError("Invalid time value");
  let l = e.match(BUr).map((g) => {
    const y = g[0];
    if (y === "p" || y === "P") {
      const b = kUr[y];
      return b(g, a.formatLong);
    }
    return g;
  }).join("").match(OUr).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const y = g[0];
    if (y === "'")
      return { isToken: !1, value: jUr(g) };
    if (b$e[y])
      return { isToken: !0, value: g };
    if (y.match(DUr))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: g };
  });
  a.localize.preprocessor && (l = a.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: o,
    locale: a
  };
  return l.map((g) => {
    if (!g.isToken) return g.value;
    const y = g.value;
    (MUr(y) || IUr(y)) && PUr(y, e, String(t));
    const b = b$e[y[0]];
    return b(s, y, a.localize, c);
  }).join("");
}
function jUr(t) {
  const e = t.match(NUr);
  return e ? e[1].replace($Ur, "'") : t;
}
function FUr(t, e) {
  return Il(t, e == null ? void 0 : e.in).getDay();
}
function zUr(t, e) {
  return Il(t, e == null ? void 0 : e.in).getHours();
}
function GUr(t, e) {
  return +Il(t) > +Il(e);
}
function WUr(t, e) {
  return +Il(t) < +Il(e);
}
function HUr(t, e) {
  const r = ZUr(e);
  return "formatToParts" in r ? VUr(r, t) : qUr(r, t);
}
const UUr = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function VUr(t, e) {
  try {
    const r = t.formatToParts(e), n = [];
    for (let a = 0; a < r.length; a++) {
      const i = UUr[r[a].type];
      i !== void 0 && (n[i] = parseInt(r[a].value, 10));
    }
    return n;
  } catch (r) {
    if (r instanceof RangeError)
      return [NaN];
    throw r;
  }
}
function qUr(t, e) {
  const r = t.format(e), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [
    parseInt(n[3], 10),
    parseInt(n[1], 10),
    parseInt(n[2], 10),
    parseInt(n[4], 10),
    parseInt(n[5], 10),
    parseInt(n[6], 10)
  ];
}
const qae = {}, S$e = new Intl.DateTimeFormat("en-US", {
  hourCycle: "h23",
  timeZone: "America/New_York",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), KUr = S$e === "06/25/2014, 00:00:00" || S$e === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function ZUr(t) {
  return qae[t] || (qae[t] = KUr ? new Intl.DateTimeFormat("en-US", {
    hourCycle: "h23",
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }) : new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: t,
    year: "numeric",
    month: "numeric",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  })), qae[t];
}
function L1t(t, e, r, n, a, i, o) {
  const s = /* @__PURE__ */ new Date(0);
  return s.setUTCFullYear(t, e, r), s.setUTCHours(n, a, i, o), s;
}
const _$e = 36e5, JUr = 6e4, Kae = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function j1t(t, e, r) {
  if (!t)
    return 0;
  let n = Kae.timezoneZ.exec(t);
  if (n)
    return 0;
  let a, i;
  if (n = Kae.timezoneHH.exec(t), n)
    return a = parseInt(n[1], 10), k$e(a) ? -(a * _$e) : NaN;
  if (n = Kae.timezoneHHMM.exec(t), n) {
    a = parseInt(n[2], 10);
    const o = parseInt(n[3], 10);
    return k$e(a, o) ? (i = Math.abs(a) * _$e + o * JUr, n[1] === "+" ? -i : i) : NaN;
  }
  if (QUr(t)) {
    e = new Date(e || Date.now());
    const o = r ? e : YUr(e), s = ife(o, t);
    return -(r ? s : XUr(e, s, t));
  }
  return NaN;
}
function YUr(t) {
  return L1t(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds());
}
function ife(t, e) {
  const r = HUr(t, e), n = L1t(r[0], r[1] - 1, r[2], r[3] % 24, r[4], r[5], 0).getTime();
  let a = t.getTime();
  const i = a % 1e3;
  return a -= i >= 0 ? i : 1e3 + i, n - a;
}
function XUr(t, e, r) {
  let a = t.getTime() - e;
  const i = ife(new Date(a), r);
  if (e === i)
    return e;
  a -= i - e;
  const o = ife(new Date(a), r);
  return i === o ? i : Math.max(i, o);
}
function k$e(t, e) {
  return -23 <= t && t <= 23 && (e == null || 0 <= e && e <= 59);
}
const A$e = {};
function QUr(t) {
  if (A$e[t])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), A$e[t] = !0, !0;
  } catch {
    return !1;
  }
}
function T$e(t) {
  const e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), +t - +e;
}
const eVr = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Zae = 36e5, E$e = 6e4, tVr = 2, xu = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: eVr
};
function rVr(t, e = {}) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  const r = e.additionalDigits == null ? tVr : Number(e.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (Object.prototype.toString.call(t) !== "[object String]")
    return /* @__PURE__ */ new Date(NaN);
  const n = nVr(t), { year: a, restDateString: i } = aVr(n.date, r), o = iVr(i, a);
  if (o === null || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  if (o) {
    const s = o.getTime();
    let l = 0, c;
    if (n.time && (l = oVr(n.time), l === null || isNaN(l)))
      return /* @__PURE__ */ new Date(NaN);
    if (n.timeZone || e.timeZone) {
      if (c = j1t(n.timeZone || e.timeZone, new Date(s + l)), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = T$e(new Date(s + l)), c = T$e(new Date(s + l + c));
    return new Date(s + l + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function nVr(t) {
  const e = {};
  let r = xu.dateTimePattern.exec(t), n;
  if (r ? (e.date = r[1], n = r[3]) : (r = xu.datePattern.exec(t), r ? (e.date = r[1], n = r[2]) : (e.date = null, n = t)), n) {
    const a = xu.timeZone.exec(n);
    a ? (e.time = n.replace(a[1], ""), e.timeZone = a[1].trim()) : e.time = n;
  }
  return e;
}
function aVr(t, e) {
  if (t) {
    const r = xu.YYY[e], n = xu.YYYYY[e];
    let a = xu.YYYY.exec(t) || n.exec(t);
    if (a) {
      const i = a[1];
      return {
        year: parseInt(i, 10),
        restDateString: t.slice(i.length)
      };
    }
    if (a = xu.YY.exec(t) || r.exec(t), a) {
      const i = a[1];
      return {
        year: parseInt(i, 10) * 100,
        restDateString: t.slice(i.length)
      };
    }
  }
  return {
    year: null
  };
}
function iVr(t, e) {
  if (e === null)
    return null;
  let r, n, a;
  if (!t || !t.length)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(e), r;
  let i = xu.MM.exec(t);
  if (i)
    return r = /* @__PURE__ */ new Date(0), n = parseInt(i[1], 10) - 1, M$e(e, n) ? (r.setUTCFullYear(e, n), r) : /* @__PURE__ */ new Date(NaN);
  if (i = xu.DDD.exec(t), i) {
    r = /* @__PURE__ */ new Date(0);
    const o = parseInt(i[1], 10);
    return cVr(e, o) ? (r.setUTCFullYear(e, 0, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = xu.MMDD.exec(t), i) {
    r = /* @__PURE__ */ new Date(0), n = parseInt(i[1], 10) - 1;
    const o = parseInt(i[2], 10);
    return M$e(e, n, o) ? (r.setUTCFullYear(e, n, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (i = xu.Www.exec(t), i)
    return a = parseInt(i[1], 10) - 1, P$e(a) ? I$e(e, a) : /* @__PURE__ */ new Date(NaN);
  if (i = xu.WwwD.exec(t), i) {
    a = parseInt(i[1], 10) - 1;
    const o = parseInt(i[2], 10) - 1;
    return P$e(a, o) ? I$e(e, a, o) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function oVr(t) {
  let e, r, n = xu.HH.exec(t);
  if (n)
    return e = parseFloat(n[1].replace(",", ".")), Jae(e) ? e % 24 * Zae : NaN;
  if (n = xu.HHMM.exec(t), n)
    return e = parseInt(n[1], 10), r = parseFloat(n[2].replace(",", ".")), Jae(e, r) ? e % 24 * Zae + r * E$e : NaN;
  if (n = xu.HHMMSS.exec(t), n) {
    e = parseInt(n[1], 10), r = parseInt(n[2], 10);
    const a = parseFloat(n[3].replace(",", "."));
    return Jae(e, r, a) ? e % 24 * Zae + r * E$e + a * 1e3 : NaN;
  }
  return null;
}
function I$e(t, e, r) {
  e = e || 0, r = r || 0;
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4);
  const a = n.getUTCDay() || 7, i = e * 7 + r + 1 - a;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
const sVr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], lVr = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function F1t(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function M$e(t, e, r) {
  if (e < 0 || e > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    const n = F1t(t);
    if (n && r > lVr[e] || !n && r > sVr[e])
      return !1;
  }
  return !0;
}
function cVr(t, e) {
  if (e < 1)
    return !1;
  const r = F1t(t);
  return !(r && e > 366 || !r && e > 365);
}
function P$e(t, e) {
  return !(t < 0 || t > 52 || e != null && (e < 0 || e > 6));
}
function Jae(t, e, r) {
  return !(t < 0 || t >= 25 || e != null && (e < 0 || e >= 60) || r != null && (r < 0 || r >= 60));
}
function uVr(t, e, r) {
  t = rVr(t, r);
  const n = j1t(e, t, !0), a = new Date(t.getTime() - n), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), i.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), i;
}
class aI {
  constructor(e) {
    this.getRelativeTimeFromToday = () => {
      const r = {
        0: "Yesterday",
        7: "This week",
        14: "More than a week ago",
        default: "More than two weeks ago"
      }, n = /* @__PURE__ */ new Date();
      n.setHours(0), n.setMinutes(0), n.setSeconds(0), n.setMilliseconds(0);
      const a = Math.floor(
        (n.getTime() - this.dateTime.getTime()) / (1e3 * 60 * 60 * 24)
      );
      return a > 14 ? r.default : a <= 14 && a > 7 ? r[14] : a <= 7 && a >= 2 ? r[7] : a < 0 ? "Today" : r[0];
    }, this.dateTime = e ? new Date(e) : /* @__PURE__ */ new Date(), this.value = this.dateTime;
  }
  add(e) {
    return this.value = OHr(this.value, e), this;
  }
  format(e) {
    try {
      return LUr(this.value, e);
    } catch {
      return this.value.toLocaleString();
    }
  }
  getDay() {
    return FUr(this.value);
  }
  getHour() {
    return zUr(this.value);
  }
  isAfter(e) {
    return GUr(this.value, e);
  }
  isBefore(e) {
    return WUr(this.value, e);
  }
  toLocal() {
    return this.value;
  }
  isSameDay(e) {
    return DHr(this.value, e);
  }
  setTimeZone(e) {
    return uVr(this.value, e);
  }
}
const iI = {
  bookend: {
    started: "Chat started"
  },
  event: {
    agent: {
      join: (t) => `${t} has joined the chat`,
      leave: (t) => `${t} has left the chat`
    }
  },
  message: {
    ariaLabel: (t, e) => `Sent by ${t} on ${e}`
  },
  isTyping: (t) => `${t} is typing...`
}, z1t = "hh:mm aa", dVr = ({ dateCreated: t }) => {
  const e = t && new aI(t), r = e == null ? void 0 : e.getRelativeTimeFromToday(), n = e == null ? void 0 : e.format(z1t), a = iI.bookend.started;
  return /* @__PURE__ */ R.jsxs(Ks.ChatBookend, { children: [
    /* @__PURE__ */ R.jsx(Ks.ChatBookendItem, { children: r }),
    /* @__PURE__ */ R.jsxs(Ks.ChatBookendItem, { children: [
      /* @__PURE__ */ R.jsx("strong", { children: a }),
      " ・ ",
      n
    ] })
  ] });
}, CF = {
  Join: "join",
  Leave: "leave"
}, bs = {
  NewMessage: "newMessage",
  AllMessages: "allMessages",
  Typing: "typing",
  Agent: "agent",
  Error: "error",
  Ready: "ready",
  Updated: "updated"
}, fVr = ({
  name: t = "",
  action: e
}) => {
  const r = e === CF.Join ? iI.event.agent.join(t) : iI.event.agent.leave(t);
  return /* @__PURE__ */ R.jsx(Ks.ChatEvent, { children: r });
};
var Yae = {}, hVr = Object.create, G1t = Object.defineProperty, pVr = Object.getOwnPropertyDescriptor, W1t = Object.getOwnPropertyNames, mVr = Object.getPrototypeOf, gVr = Object.prototype.hasOwnProperty, H1t = (t, e) => function() {
  return e || (0, t[W1t(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, vVr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of W1t(e)) !gVr.call(t, a) && a !== r && G1t(t, a, { get: () => e[a], enumerable: !(n = pVr(e, a)) || n.enumerable });
  return t;
}, yVr = (t, e, r) => (r = t != null ? hVr(mVr(t)) : {}, vVr(!t || !t.__esModule ? G1t(r, "default", { value: t, enumerable: !0 }) : r, t)), bVr = H1t({ "../../../../node_modules/react-is/cjs/react-is.production.min.js"(t) {
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), y = Symbol.for("react.module.reference");
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case e:
          switch (w = w.type, w) {
            case n:
            case i:
            case a:
            case u:
            case f:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case l:
                case s:
                case c:
                case p:
                case h:
                case o:
                  return w;
                default:
                  return _;
              }
          }
        case r:
          return _;
      }
    }
  }
  t.ContextConsumer = s, t.ContextProvider = o, t.Element = e, t.ForwardRef = c, t.Fragment = n, t.Lazy = p, t.Memo = h, t.Portal = r, t.Profiler = i, t.StrictMode = a, t.Suspense = u, t.SuspenseList = f, t.isAsyncMode = function() {
    return !1;
  }, t.isConcurrentMode = function() {
    return !1;
  }, t.isContextConsumer = function(w) {
    return b(w) === s;
  }, t.isContextProvider = function(w) {
    return b(w) === o;
  }, t.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, t.isForwardRef = function(w) {
    return b(w) === c;
  }, t.isFragment = function(w) {
    return b(w) === n;
  }, t.isLazy = function(w) {
    return b(w) === p;
  }, t.isMemo = function(w) {
    return b(w) === h;
  }, t.isPortal = function(w) {
    return b(w) === r;
  }, t.isProfiler = function(w) {
    return b(w) === i;
  }, t.isStrictMode = function(w) {
    return b(w) === a;
  }, t.isSuspense = function(w) {
    return b(w) === u;
  }, t.isSuspenseList = function(w) {
    return b(w) === f;
  }, t.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === i || w === a || w === u || w === f || w === g || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === o || w.$$typeof === s || w.$$typeof === c || w.$$typeof === y || w.getModuleId !== void 0);
  }, t.typeOf = b;
} }), xVr = H1t({ "../../../../node_modules/react-is/index.js"(t, e) {
  e.exports = bVr();
} }), CVr = yVr(xVr()), wVr = (t) => t.split(" ").map((e) => e.slice(0, 1)).reduce((e, r, n, a) => n === 0 || n === a.length - 1 ? `${e}${r}` : e, ""), R$e = (t) => {
  if (typeof t == "string" && t.includes("sizeIcon")) return t.replace("sizeIcon", "lineHeight");
  throw new Error("[Avatar]: size must be of type IconSizeOptions.");
}, O$e = (t) => {
  if (typeof t == "string" && t.includes("sizeIcon")) switch (t) {
    case "sizeIcon10":
    case "sizeIcon20":
    case "sizeIcon30":
    case "sizeIcon40":
    case "sizeIcon50":
    case "sizeIcon60":
    default:
      return "fontSize10";
    case "sizeIcon70":
      return "fontSize20";
    case "sizeIcon80":
      return "fontSize30";
    case "sizeIcon90":
      return "fontSize40";
    case "sizeIcon100":
      return "fontSize60";
    case "sizeIcon110":
      return "fontSize70";
  }
  throw new Error("[Avatar]: size must be of type IconSizeOptions.");
}, B$e = (t) => {
  if (typeof t == "string" && t.includes("sizeIcon")) switch (t) {
    case "sizeIcon10":
    case "sizeIcon20":
    case "sizeIcon30":
    case "sizeIcon40":
    default:
      return "sizeIcon10";
    case "sizeIcon50":
    case "sizeIcon60":
      return "sizeIcon20";
    case "sizeIcon70":
      return "sizeIcon30";
    case "sizeIcon80":
      return "sizeIcon40";
    case "sizeIcon90":
      return "sizeIcon50";
    case "sizeIcon100":
      return "sizeIcon70";
    case "sizeIcon110":
      return "sizeIcon80";
  }
  throw new Error("[Avatar]: size must be of type IconSizeOptions.");
}, SVr = (t) => {
  if (typeof t == "string") return { lineHeight: R$e(t), fontSize: O$e(t), iconSize: B$e(t) };
  if (Array.isArray(t)) return { lineHeight: t.map((e) => e != null ? R$e(e) : null), fontSize: t.map((e) => e != null ? O$e(e) : null), iconSize: t.map((e) => e != null ? B$e(e) : null) };
  throw new Error("[Avatar]: size must be a string or an array");
}, _Vr = (t, e) => {
  if (e === "user") switch (t) {
    case "sizeIcon10":
    case "sizeIcon20":
    case "sizeIcon30":
      return "spaceNegative10";
    case "sizeIcon40":
    case "sizeIcon50":
    case "sizeIcon60":
    case "sizeIcon70":
      return "spaceNegative20";
    case "sizeIcon80":
    case "sizeIcon90":
      return "spaceNegative30";
    case "sizeIcon100":
      return "spaceNegative40";
    case "sizeIcon110":
      return "spaceNegative50";
  }
  switch (t) {
    case "sizeIcon10":
    case "sizeIcon20":
    case "sizeIcon30":
      return "spaceNegative10";
    case "sizeIcon40":
    case "sizeIcon50":
    case "sizeIcon60":
    case "sizeIcon70":
    case "sizeIcon80":
    case "sizeIcon90":
    case "sizeIcon100":
    case "sizeIcon110":
      return "spaceNegative20";
    default:
      return "spaceNegative20";
  }
}, b3e = P.createContext({}), U1t = P.forwardRef(({ variant: t, size: e, children: r, element: n = "AVATAR_GROUP" }, a) => P.createElement(b3e.Provider, { value: { variant: t, size: e } }, P.createElement(J5, { orientation: "horizontal", spacing: _Vr(e, t), element: n, ref: a }, r)));
U1t.displayName = "AvatarGroup";
var V1t = "sizeIcon70", q1t = ({ name: t, size: e = V1t, src: r, icon: n }) => {
  let { size: a } = P.useContext(b3e), i = SVr(a || e);
  if (r != null) return P.createElement(ht, { as: "img", alt: t, maxWidth: "100%", boxShadow: "shadowBorderWeaker", src: r, size: e, title: t });
  if (n != null) {
    if (!(0, CVr.isValidElementType)(n) || typeof n.displayName != "string" || !n.displayName.includes("Icon")) throw new Error("[Paste Avatar]: icon prop expected to be a Paste icon only.");
    return P.createElement(ht, { maxWidth: "100%", size: e, display: "flex", alignItems: "center", justifyContent: "center" }, P.createElement(n, { decorative: !1, title: t, size: i.iconSize }));
  }
  return P.createElement(cl, { as: "abbr", display: "inline-block", fontSize: i.fontSize, fontWeight: "fontWeightSemibold", lineHeight: i.lineHeight, verticalAlign: "top", textDecoration: "none", title: t, color: "inherit" }, wVr(t));
};
q1t.displayName = "AvatarContents";
var kVr = { default: { backgroundColor: "colorBackgroundUser", boxShadow: "shadowBorderUser", color: "colorTextUser" }, decorative10: { backgroundColor: "colorBackgroundDecorative10Weakest", boxShadow: "shadowBorderDecorative10Weaker", color: "colorTextDecorative10" }, decorative20: { backgroundColor: "colorBackgroundDecorative20Weakest", boxShadow: "shadowBorderDecorative20Weaker", color: "colorTextDecorative20" }, decorative30: { backgroundColor: "colorBackgroundDecorative30Weakest", boxShadow: "shadowBorderDecorative30Weaker", color: "colorTextDecorative30" }, decorative40: { backgroundColor: "colorBackgroundDecorative40Weakest", boxShadow: "shadowBorderDecorative40Weaker", color: "colorTextDecorative40" } }, AVr = { user: { borderRadius: "borderRadiusCircle" }, entity: { borderRadius: "borderRadius30" } }, K1t = P.forwardRef(({ name: t, size: e = V1t, element: r = "AVATAR", src: n, icon: a, color: i = "default", variant: o = "user", ...s }, l) => {
  t === void 0 && console.error("[Paste Avatar]: name prop is required");
  let { variant: c, size: u } = P.useContext(b3e);
  return P.createElement(ht, { ...Xt(s), as: "div", element: r, overflow: "hidden", textAlign: "center", flexShrink: 0, ref: l, size: u || e, ...kVr[i], ...AVr[c || o], ...n && { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker" } }, P.createElement(q1t, { name: t, size: u || e, icon: a, src: n }));
});
K1t.displayName = "Avatar";
/**
* @license React
* react-is.production.min.js
*
* Copyright (c) Facebook, Inc. and its affiliates.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/
const TVr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Avatar: K1t,
  AvatarGroup: U1t
}, Symbol.toStringTag, { value: "Module" })), EVr = /* @__PURE__ */ aa(TVr);
var N$e;
function IVr() {
  return N$e || (N$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = EVr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Yae)), Yae;
}
var Z1t = /* @__PURE__ */ IVr(), Xae = {};
const MVr = /* @__PURE__ */ aa(jtr);
var $$e;
function PVr() {
  return $$e || ($$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = MVr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Xae)), Xae;
}
var wF = /* @__PURE__ */ PVr(), Qae, D$e;
function RVr() {
  if (D$e) return Qae;
  D$e = 1;
  var t = Object.create, e = Object.defineProperty, r = Object.getOwnPropertyDescriptor, n = Object.getOwnPropertyNames, a = Object.getPrototypeOf, i = Object.prototype.hasOwnProperty, o = (y, b) => {
    for (var w in b) e(y, w, { get: b[w], enumerable: !0 });
  }, s = (y, b, w, _) => {
    if (b && typeof b == "object" || typeof b == "function") for (let C of n(b)) !i.call(y, C) && C !== w && e(y, C, { get: () => b[C], enumerable: !(_ = r(b, C)) || _.enumerable });
    return y;
  }, l = (y, b, w) => (w = y != null ? t(a(y)) : {}, s(!y || !y.__esModule ? e(w, "default", { value: y, enumerable: !0 }) : w, y)), c = (y) => s(e({}, "__esModule", { value: !0 }), y), u = {};
  o(u, { DownloadIcon: () => g }), Qae = c(u);
  var f = sge, h = l(Te), p = /* @__PURE__ */ y1t();
  const g = h.forwardRef(({ as: y, display: b, element: w = "ICON", size: _, color: C, title: x, decorative: S }, A) => {
    const I = `DownloadIcon-${(0, f.useUID)()}`;
    if (!S && x == null) throw new Error("[DownloadIcon]: Missing a title for non-decorative icon.");
    return h.createElement(p.IconWrapper, { as: y, display: b, element: w, size: _, color: C, ref: A }, h.createElement("svg", { role: "img", "aria-hidden": S, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": I }, x ? h.createElement("title", { id: I }, x) : null, h.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M10.625 3.5a.625.625 0 10-1.25 0v8.491L7.342 9.958a.625.625 0 10-.884.884l3.125 3.125c.244.244.64.244.884 0l3.125-3.125a.625.625 0 00-.884-.884l-2.083 2.083V3.5zm-7.75 13c0-.345.28-.625.625-.625h13a.625.625 0 110 1.25h-13a.625.625 0 01-.625-.625z" })));
  });
  return g.displayName = "DownloadIcon", Qae;
}
var OVr = /* @__PURE__ */ RVr();
const BVr = (t, e) => t.sid ? t.sid === e.participantSid ? "outbound" : "inbound" : t.identity === e.author ? "outbound" : "inbound", NVr = (t) => t !== null && typeof t == "object" && !Array.isArray(t), J1t = (t) => Object.keys(t).length === 0 && t.constructor === Object, ob = ({
  attributes: t,
  key: e,
  fallbackValue: r = null
}) => !t || !NVr(t) || J1t(t) ? r : t[e] || r, $Vr = (t, e) => {
  const r = document.createElement("a");
  r.style.display = "none", r.setAttribute("href", t), r.setAttribute("download", e), r.setAttribute("target", "_blank"), r.setAttribute("rel", "noopener noreferrer"), document.body.appendChild(r), r.click(), setTimeout(() => {
    document.body.removeChild(r);
  }, 200);
}, DVr = async (t) => {
  try {
    const r = await (await fetch(t)).blob();
    return URL.createObjectURL(r);
  } catch (e) {
    console.error(e);
  }
}, LVr = (t, e) => t.size < e * 1024 * 1024, oh = {
  local: "local",
  dev: "dev",
  stage: "stage",
  prod: "prod"
}, jVr = {
  "localhost:3000": oh.local,
  "sendgridtest.zendesk.com": oh.dev,
  "d3v-twlo.zendesk.com": oh.stage,
  "support.sendgrid.com": oh.prod
}, FVr = {
  "help.local.twilio.com": oh.local,
  "help.dev.twilio.com": oh.dev,
  "help.stage.twilio.com": oh.stage,
  "help.twilio.com": oh.prod
}, zVr = () => {
  const t = jVr[window.location.host] || oh.local;
  return {
    prod: {
      zendeskTicketFormId: 360001809233,
      zendeskFieldIdSendGridUsername: 360027232094,
      zendeskFieldIdSendGridUserId: 360027567533,
      zendeskFieldIdSendGridMarketingPackage: 360027570713,
      zendeskFieldIdSendGridEmailPackage: 360027136013,
      zendeskFieldIdSendGridProduct: 360050708414,
      zendeskFieldIdTwilioAccountSid: 21625377,
      zendeskFieldIdTwilioUserSid: 21619471,
      zendeskFieldIdPriorityLevel: 20551717
    },
    stage: {
      zendeskTicketFormId: 360005394714,
      zendeskFieldIdSendGridUsername: 360039320654,
      zendeskFieldIdSendGridUserId: 360039306513,
      zendeskFieldIdSendGridMarketingPackage: 1260804540189,
      zendeskFieldIdSendGridEmailPackage: 1260804568230,
      zendeskFieldIdSendGridProduct: 360051782433,
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 20551717
    },
    dev: {
      zendeskTicketFormId: 360005394714,
      zendeskFieldIdSendGridUsername: 360039320654,
      zendeskFieldIdSendGridUserId: 360039306513,
      zendeskFieldIdSendGridMarketingPackage: 1260804540189,
      zendeskFieldIdSendGridEmailPackage: 1260804568230,
      zendeskFieldIdSendGridProduct: 360051782433,
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 28245318
    },
    local: {
      zendeskTicketFormId: 360005394714,
      zendeskFieldIdSendGridUsername: 360039320654,
      zendeskFieldIdSendGridUserId: 360039306513,
      zendeskFieldIdSendGridMarketingPackage: 1260804540189,
      zendeskFieldIdSendGridEmailPackage: 1260804568230,
      zendeskFieldIdSendGridProduct: 360051782433,
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 28245318
    }
  }[t];
}, GVr = () => {
  const t = FVr[window.location.host] || oh.local;
  return {
    prod: {
      zendeskFieldIdTwilioAccountSid: 21625377,
      zendeskFieldIdTwilioUserSid: 21619471,
      zendeskFieldIdPriorityLevel: 20551717
    },
    stage: {
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 20551717
    },
    dev: {
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 28245318
    },
    local: {
      zendeskFieldIdTwilioAccountSid: 28239607,
      zendeskFieldIdTwilioUserSid: 28239617,
      zendeskFieldIdPriorityLevel: 28245318
    }
  }[t];
}, WVr = (t, e) => {
  const {
    zendeskFieldIdSendGridUsername: r,
    zendeskFieldIdSendGridUserId: n,
    zendeskFieldIdSendGridEmailPackage: a,
    zendeskFieldIdSendGridMarketingPackage: i,
    zendeskFieldIdSendGridProduct: o,
    zendeskFieldIdPriorityLevel: s
  } = zVr();
  return [
    {
      id: r,
      value: t == null ? void 0 : t.email
    },
    {
      id: n,
      value: t == null ? void 0 : t.userSid
    },
    {
      id: a,
      value: window.EI_Plan
    },
    {
      id: i,
      value: window.MC_Plan
    },
    {
      id: o,
      value: e || ""
    },
    {
      id: s,
      value: "p3_general_issue"
    }
  ];
}, HVr = (t) => {
  const {
    zendeskFieldIdPriorityLevel: e,
    zendeskFieldIdTwilioAccountSid: r,
    zendeskFieldIdTwilioUserSid: n
  } = GVr();
  return [
    {
      id: r,
      value: t == null ? void 0 : t.accountSid
    },
    {
      id: n,
      value: t == null ? void 0 : t.userSid
    },
    {
      id: e,
      value: "p3_general_issue"
    }
  ];
}, UVr = (t, e, r, n) => {
  const { tags: a = [], hcaCsatProps: i } = r || {};
  let o;
  e === "help-center-assistant-sendgrid" ? o = WVr(
    t,
    n
  ) : o = HVr(t);
  const s = {
    account: {
      sid: t == null ? void 0 : t.accountSid
    },
    user: {
      sid: t == null ? void 0 : t.userSid,
      email: t == null ? void 0 : t.email,
      fullName: t == null ? void 0 : t.friendlyName
    },
    customFields: o,
    tags: [...a || [], "sof_chat"],
    hcaCsatProps: i || null
  };
  return encodeURIComponent(JSON.stringify(s));
}, Y1t = (t) => {
  const {
    question: e,
    applicationPreEngagementData: r,
    productCategory: n,
    additionalMetadata: a,
    subProduct: i,
    username: o,
    applicationId: s
  } = t, l = {
    question: e,
    friendlyName: r == null ? void 0 : r.friendlyName,
    email: r == null ? void 0 : r.email,
    productCategory: n,
    url: window.location.origin,
    userSid: r == null ? void 0 : r.userSid,
    accountSid: r == null ? void 0 : r.accountSid,
    identity: r == null ? void 0 : r.identity,
    metadata: UVr(
      r,
      s,
      a,
      i
    ),
    location: window.location.origin,
    // Username and subProduct are only used for SGHC
    username: o,
    subProduct: i
  };
  return JSON.stringify(l);
}, VVr = (t) => ({
  support_email: "the Email support team",
  support_voice: "the Voice support team",
  support_phone_numbers: "the Phone numbers support team",
  support_messaging: "the Messaging support team",
  support_accounts_billing: "the Account administration support team"
})[t] || "an another support team", qVr = (t) => {
  const [e, r] = Yt([]), [n, a] = Yt([]), [i, o] = Yt({}), [s, l] = Yt({}), c = (h, p) => {
    const g = (y) => y.map(
      (b) => b.sid === h.sid ? h : b
    );
    p.includes("image") ? a((y) => g(y)) : r((y) => g(y)), o((y) => ({ ...y, [h.sid]: !1 }));
  }, u = sr(async (h) => {
    o((p) => ({ ...p, [h.sid]: !0 }));
    try {
      const p = await h.getContentTemporaryUrl(), g = p ? await DVr(p) : "", y = {
        sid: h.sid,
        filename: h.filename,
        size: h.size,
        contentUrl: p,
        blobUrl: g
      };
      c(y, h.contentType);
    } catch (p) {
      l((g) => ({ ...g, [h.sid]: !1 })), console.error(p);
    }
  }, []), f = (h) => {
    const p = [], g = [];
    h.forEach((y) => {
      y.contentType.includes("image") ? g.push(y) : p.push(y);
    }), r(p), a(g);
  };
  return Ut(() => {
    if (!t.attachedMedia || t.attachedMedia.length === 0)
      return;
    f(t.attachedMedia), (async () => {
      var g;
      const p = ((g = t.attachedMedia) == null ? void 0 : g.map(u)) || [];
      await Promise.allSettled(p);
    })();
  }, [t, u]), {
    errors: s,
    files: e,
    images: n,
    isLoadingMedia: i
  };
};
var eie = {};
const Hb = "\\d+(?:[\\.,]\\d+)?", KVr = `(${Hb}W)`, ZVr = `(${Hb}Y)?(${Hb}M)?(${Hb}D)?`, JVr = `T(${Hb}H)?(${Hb}M)?(${Hb}S)?`, YVr = `P(?:${KVr}|${ZVr}(?:${JVr})?)`, XVr = ["weeks", "years", "months", "days", "hours", "minutes", "seconds"], x3e = new RegExp(YVr), X1t = (t) => t.match(x3e).slice(1).reduce((e, r, n) => (e[XVr[n]] = parseFloat(r) || 0, e), {}), C3e = (t, e) => {
  const r = e ? e.getTime() : Date.now(), n = new Date(r);
  return n.setFullYear(n.getFullYear() + t.years), n.setMonth(n.getMonth() + t.months), n.setDate(n.getDate() + t.days), n.setHours(n.getHours() + t.hours), n.setMinutes(n.getMinutes() + t.minutes), n.setMilliseconds(n.getMilliseconds() + t.seconds * 1e3), n.setDate(n.getDate() + t.weeks * 7), n;
}, Q1t = (t, e) => {
  const r = e ? e.getTime() : Date.now(), n = new Date(r);
  return (C3e(t, n).getTime() - n.getTime()) / 1e3;
}, QVr = {
  end: C3e,
  toSeconds: Q1t,
  pattern: x3e,
  parse: X1t
}, eqr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: QVr,
  end: C3e,
  parse: X1t,
  pattern: x3e,
  toSeconds: Q1t
}, Symbol.toStringTag, { value: "Module" })), tqr = /* @__PURE__ */ aa(eqr);
var d_ = { exports: {} };
d_.exports;
var L$e;
function rqr() {
  return L$e || (L$e = 1, function(t, e) {
    var r = 200, n = "__lodash_hash_undefined__", a = 1, i = 2, o = 9007199254740991, s = "[object Arguments]", l = "[object Array]", c = "[object AsyncFunction]", u = "[object Boolean]", f = "[object Date]", h = "[object Error]", p = "[object Function]", g = "[object GeneratorFunction]", y = "[object Map]", b = "[object Number]", w = "[object Null]", _ = "[object Object]", C = "[object Promise]", x = "[object Proxy]", S = "[object RegExp]", A = "[object Set]", I = "[object String]", M = "[object Symbol]", B = "[object Undefined]", L = "[object WeakMap]", N = "[object ArrayBuffer]", d = "[object DataView]", m = "[object Float32Array]", v = "[object Float64Array]", k = "[object Int8Array]", O = "[object Int16Array]", G = "[object Int32Array]", H = "[object Uint8Array]", j = "[object Uint8ClampedArray]", F = "[object Uint16Array]", z = "[object Uint32Array]", W = /[\\^$.*+?()[\]{}|]/g, U = /^\[object .+?Constructor\]$/, Z = /^(?:0|[1-9]\d*)$/, V = {};
    V[m] = V[v] = V[k] = V[O] = V[G] = V[H] = V[j] = V[F] = V[z] = !0, V[s] = V[l] = V[N] = V[u] = V[d] = V[f] = V[h] = V[p] = V[y] = V[b] = V[_] = V[S] = V[A] = V[I] = V[L] = !1;
    var Y = typeof wl == "object" && wl && wl.Object === Object && wl, ge = typeof self == "object" && self && self.Object === Object && self, ce = Y || ge || Function("return this")(), ee = e && !e.nodeType && e, Se = ee && !0 && t && !t.nodeType && t, Ce = Se && Se.exports === ee, we = Ce && Y.process, We = function() {
      try {
        return we && we.binding && we.binding("util");
      } catch {
      }
    }(), Fe = We && We.isTypedArray;
    function it(X, he) {
      for (var $e = -1, Ct = X == null ? 0 : X.length, Bt = 0, St = []; ++$e < Ct; ) {
        var ir = X[$e];
        he(ir, $e, X) && (St[Bt++] = ir);
      }
      return St;
    }
    function gt(X, he) {
      for (var $e = -1, Ct = he.length, Bt = X.length; ++$e < Ct; )
        X[Bt + $e] = he[$e];
      return X;
    }
    function Ze(X, he) {
      for (var $e = -1, Ct = X == null ? 0 : X.length; ++$e < Ct; )
        if (he(X[$e], $e, X))
          return !0;
      return !1;
    }
    function Ne(X, he) {
      for (var $e = -1, Ct = Array(X); ++$e < X; )
        Ct[$e] = he($e);
      return Ct;
    }
    function ze(X) {
      return function(he) {
        return X(he);
      };
    }
    function ct(X, he) {
      return X.has(he);
    }
    function rt(X, he) {
      return X == null ? void 0 : X[he];
    }
    function qe(X) {
      var he = -1, $e = Array(X.size);
      return X.forEach(function(Ct, Bt) {
        $e[++he] = [Bt, Ct];
      }), $e;
    }
    function nt(X, he) {
      return function($e) {
        return X(he($e));
      };
    }
    function Rt(X) {
      var he = -1, $e = Array(X.size);
      return X.forEach(function(Ct) {
        $e[++he] = Ct;
      }), $e;
    }
    var Ot = Array.prototype, lt = Function.prototype, mt = Object.prototype, jt = ce["__core-js_shared__"], Jt = lt.toString, ne = mt.hasOwnProperty, re = function() {
      var X = /[^.]+$/.exec(jt && jt.keys && jt.keys.IE_PROTO || "");
      return X ? "Symbol(src)_1." + X : "";
    }(), ie = mt.toString, Ie = RegExp(
      "^" + Jt.call(ne).replace(W, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Ke = Ce ? ce.Buffer : void 0, Le = ce.Symbol, Ge = ce.Uint8Array, ft = mt.propertyIsEnumerable, ot = Ot.splice, Ye = Le ? Le.toStringTag : void 0, Je = Object.getOwnPropertySymbols, tt = Ke ? Ke.isBuffer : void 0, kt = nt(Object.keys, Object), Ft = Lo(ce, "DataView"), bt = Lo(ce, "Map"), At = Lo(ce, "Promise"), vt = Lo(ce, "Set"), _t = Lo(ce, "WeakMap"), yt = Lo(Object, "create"), xr = Be(Ft), dr = Be(bt), Er = Be(At), gr = Be(vt), pr = Be(_t), Xr = Le ? Le.prototype : void 0, Yr = Xr ? Xr.valueOf : void 0;
    function at(X) {
      var he = -1, $e = X == null ? 0 : X.length;
      for (this.clear(); ++he < $e; ) {
        var Ct = X[he];
        this.set(Ct[0], Ct[1]);
      }
    }
    function Vt() {
      this.__data__ = yt ? yt(null) : {}, this.size = 0;
    }
    function er(X) {
      var he = this.has(X) && delete this.__data__[X];
      return this.size -= he ? 1 : 0, he;
    }
    function fr(X) {
      var he = this.__data__;
      if (yt) {
        var $e = he[X];
        return $e === n ? void 0 : $e;
      }
      return ne.call(he, X) ? he[X] : void 0;
    }
    function tn(X) {
      var he = this.__data__;
      return yt ? he[X] !== void 0 : ne.call(he, X);
    }
    function Kn(X, he) {
      var $e = this.__data__;
      return this.size += this.has(X) ? 0 : 1, $e[X] = yt && he === void 0 ? n : he, this;
    }
    at.prototype.clear = Vt, at.prototype.delete = er, at.prototype.get = fr, at.prototype.has = tn, at.prototype.set = Kn;
    function Pr(X) {
      var he = -1, $e = X == null ? 0 : X.length;
      for (this.clear(); ++he < $e; ) {
        var Ct = X[he];
        this.set(Ct[0], Ct[1]);
      }
    }
    function Pt() {
      this.__data__ = [], this.size = 0;
    }
    function or(X) {
      var he = this.__data__, $e = So(he, X);
      if ($e < 0)
        return !1;
      var Ct = he.length - 1;
      return $e == Ct ? he.pop() : ot.call(he, $e, 1), --this.size, !0;
    }
    function Ht(X) {
      var he = this.__data__, $e = So(he, X);
      return $e < 0 ? void 0 : he[$e][1];
    }
    function Mt(X) {
      return So(this.__data__, X) > -1;
    }
    function Qt(X, he) {
      var $e = this.__data__, Ct = So($e, X);
      return Ct < 0 ? (++this.size, $e.push([X, he])) : $e[Ct][1] = he, this;
    }
    Pr.prototype.clear = Pt, Pr.prototype.delete = or, Pr.prototype.get = Ht, Pr.prototype.has = Mt, Pr.prototype.set = Qt;
    function pn(X) {
      var he = -1, $e = X == null ? 0 : X.length;
      for (this.clear(); ++he < $e; ) {
        var Ct = X[he];
        this.set(Ct[0], Ct[1]);
      }
    }
    function Kr() {
      this.size = 0, this.__data__ = {
        hash: new at(),
        map: new (bt || Pr)(),
        string: new at()
      };
    }
    function Da(X) {
      var he = Oc(this, X).delete(X);
      return this.size -= he ? 1 : 0, he;
    }
    function La(X) {
      return Oc(this, X).get(X);
    }
    function ji(X) {
      return Oc(this, X).has(X);
    }
    function Zo(X, he) {
      var $e = Oc(this, X), Ct = $e.size;
      return $e.set(X, he), this.size += $e.size == Ct ? 0 : 1, this;
    }
    pn.prototype.clear = Kr, pn.prototype.delete = Da, pn.prototype.get = La, pn.prototype.has = ji, pn.prototype.set = Zo;
    function kr(X) {
      var he = -1, $e = X == null ? 0 : X.length;
      for (this.__data__ = new pn(); ++he < $e; )
        this.add(X[he]);
    }
    function qi(X) {
      return this.__data__.set(X, n), this;
    }
    function vi(X) {
      return this.__data__.has(X);
    }
    kr.prototype.add = kr.prototype.push = qi, kr.prototype.has = vi;
    function Ho(X) {
      var he = this.__data__ = new Pr(X);
      this.size = he.size;
    }
    function Ec() {
      this.__data__ = new Pr(), this.size = 0;
    }
    function Uu(X) {
      var he = this.__data__, $e = he.delete(X);
      return this.size = he.size, $e;
    }
    function Ic(X) {
      return this.__data__.get(X);
    }
    function js(X) {
      return this.__data__.has(X);
    }
    function Mc(X, he) {
      var $e = this.__data__;
      if ($e instanceof Pr) {
        var Ct = $e.__data__;
        if (!bt || Ct.length < r - 1)
          return Ct.push([X, he]), this.size = ++$e.size, this;
        $e = this.__data__ = new pn(Ct);
      }
      return $e.set(X, he), this.size = $e.size, this;
    }
    Ho.prototype.clear = Ec, Ho.prototype.delete = Uu, Ho.prototype.get = Ic, Ho.prototype.has = js, Ho.prototype.set = Mc;
    function Vu(X, he) {
      var $e = Ve(X), Ct = !$e && ut(X), Bt = !$e && !Ct && qt(X), St = !$e && !Ct && !Bt && J(X), ir = $e || Ct || Bt || St, Ir = ir ? Ne(X.length, String) : [], Sr = Ir.length;
      for (var Vr in X)
        ne.call(X, Vr) && !(ir && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Vr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        Bt && (Vr == "offset" || Vr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        St && (Vr == "buffer" || Vr == "byteLength" || Vr == "byteOffset") || // Skip index properties.
        Nc(Vr, Sr))) && Ir.push(Vr);
      return Ir;
    }
    function So(X, he) {
      for (var $e = X.length; $e--; )
        if (Me(X[$e][0], he))
          return $e;
      return -1;
    }
    function Kl(X, he, $e) {
      var Ct = he(X);
      return Ve(X) ? Ct : gt(Ct, $e(X));
    }
    function Vi(X) {
      return X == null ? X === void 0 ? B : w : Ye && Ye in Object(X) ? Rl(X) : De(X);
    }
    function iu(X) {
      return te(X) && Vi(X) == s;
    }
    function cc(X, he, $e, Ct, Bt) {
      return X === he ? !0 : X == null || he == null || !te(X) && !te(he) ? X !== X && he !== he : Pc(X, he, $e, Ct, cc, Bt);
    }
    function Pc(X, he, $e, Ct, Bt, St) {
      var ir = Ve(X), Ir = Ve(he), Sr = ir ? l : Bc(X), Vr = Ir ? l : Bc(he);
      Sr = Sr == s ? _ : Sr, Vr = Vr == s ? _ : Vr;
      var ri = Sr == _, ni = Vr == _, Yn = Sr == Vr;
      if (Yn && qt(X)) {
        if (!qt(he))
          return !1;
        ir = !0, ri = !1;
      }
      if (Yn && !ri)
        return St || (St = new Ho()), ir || J(X) ? qu(X, he, $e, Ct, Bt, St) : dp(X, he, Sr, $e, Ct, Bt, St);
      if (!($e & a)) {
        var ja = ri && ne.call(X, "__wrapped__"), Rr = ni && ne.call(he, "__wrapped__");
        if (ja || Rr) {
          var _o = ja ? X.value() : X, Ee = Rr ? he.value() : he;
          return St || (St = new Ho()), Bt(_o, Ee, $e, Ct, St);
        }
      }
      return Yn ? (St || (St = new Ho()), Nd(X, he, $e, Ct, Bt, St)) : !1;
    }
    function Jo(X) {
      if (!Q(X) || st(X))
        return !1;
      var he = _e(X) ? Ie : U;
      return he.test(Be(X));
    }
    function Ka(X) {
      return te(X) && Pe(X.length) && !!V[Vi(X)];
    }
    function y2(X) {
      if (!dt(X))
        return kt(X);
      var he = [];
      for (var $e in Object(X))
        ne.call(X, $e) && $e != "constructor" && he.push($e);
      return he;
    }
    function qu(X, he, $e, Ct, Bt, St) {
      var ir = $e & a, Ir = X.length, Sr = he.length;
      if (Ir != Sr && !(ir && Sr > Ir))
        return !1;
      var Vr = St.get(X);
      if (Vr && St.get(he))
        return Vr == he;
      var ri = -1, ni = !0, Yn = $e & i ? new kr() : void 0;
      for (St.set(X, he), St.set(he, X); ++ri < Ir; ) {
        var ja = X[ri], Rr = he[ri];
        if (Ct)
          var _o = ir ? Ct(Rr, ja, ri, he, X, St) : Ct(ja, Rr, ri, X, he, St);
        if (_o !== void 0) {
          if (_o)
            continue;
          ni = !1;
          break;
        }
        if (Yn) {
          if (!Ze(he, function(Ee, je) {
            if (!ct(Yn, je) && (ja === Ee || Bt(ja, Ee, $e, Ct, St)))
              return Yn.push(je);
          })) {
            ni = !1;
            break;
          }
        } else if (!(ja === Rr || Bt(ja, Rr, $e, Ct, St))) {
          ni = !1;
          break;
        }
      }
      return St.delete(X), St.delete(he), ni;
    }
    function dp(X, he, $e, Ct, Bt, St, ir) {
      switch ($e) {
        case d:
          if (X.byteLength != he.byteLength || X.byteOffset != he.byteOffset)
            return !1;
          X = X.buffer, he = he.buffer;
        case N:
          return !(X.byteLength != he.byteLength || !St(new Ge(X), new Ge(he)));
        case u:
        case f:
        case b:
          return Me(+X, +he);
        case h:
          return X.name == he.name && X.message == he.message;
        case S:
        case I:
          return X == he + "";
        case y:
          var Ir = qe;
        case A:
          var Sr = Ct & a;
          if (Ir || (Ir = Rt), X.size != he.size && !Sr)
            return !1;
          var Vr = ir.get(X);
          if (Vr)
            return Vr == he;
          Ct |= i, ir.set(X, he);
          var ri = qu(Ir(X), Ir(he), Ct, Bt, St, ir);
          return ir.delete(X), ri;
        case M:
          if (Yr)
            return Yr.call(X) == Yr.call(he);
      }
      return !1;
    }
    function Nd(X, he, $e, Ct, Bt, St) {
      var ir = $e & a, Ir = Rc(X), Sr = Ir.length, Vr = Rc(he), ri = Vr.length;
      if (Sr != ri && !ir)
        return !1;
      for (var ni = Sr; ni--; ) {
        var Yn = Ir[ni];
        if (!(ir ? Yn in he : ne.call(he, Yn)))
          return !1;
      }
      var ja = St.get(X);
      if (ja && St.get(he))
        return ja == he;
      var Rr = !0;
      St.set(X, he), St.set(he, X);
      for (var _o = ir; ++ni < Sr; ) {
        Yn = Ir[ni];
        var Ee = X[Yn], je = he[Yn];
        if (Ct)
          var be = ir ? Ct(je, Ee, Yn, he, X, St) : Ct(Ee, je, Yn, X, he, St);
        if (!(be === void 0 ? Ee === je || Bt(Ee, je, $e, Ct, St) : be)) {
          Rr = !1;
          break;
        }
        _o || (_o = Yn == "constructor");
      }
      if (Rr && !_o) {
        var oe = X.constructor, ae = he.constructor;
        oe != ae && "constructor" in X && "constructor" in he && !(typeof oe == "function" && oe instanceof oe && typeof ae == "function" && ae instanceof ae) && (Rr = !1);
      }
      return St.delete(X), St.delete(he), Rr;
    }
    function Rc(X) {
      return Kl(X, fe, hs);
    }
    function Oc(X, he) {
      var $e = X.__data__;
      return b2(he) ? $e[typeof he == "string" ? "string" : "hash"] : $e.map;
    }
    function Lo(X, he) {
      var $e = rt(X, he);
      return Jo($e) ? $e : void 0;
    }
    function Rl(X) {
      var he = ne.call(X, Ye), $e = X[Ye];
      try {
        X[Ye] = void 0;
        var Ct = !0;
      } catch {
      }
      var Bt = ie.call(X);
      return Ct && (he ? X[Ye] = $e : delete X[Ye]), Bt;
    }
    var hs = Je ? function(X) {
      return X == null ? [] : (X = Object(X), it(Je(X), function(he) {
        return ft.call(X, he);
      }));
    } : le, Bc = Vi;
    (Ft && Bc(new Ft(new ArrayBuffer(1))) != d || bt && Bc(new bt()) != y || At && Bc(At.resolve()) != C || vt && Bc(new vt()) != A || _t && Bc(new _t()) != L) && (Bc = function(X) {
      var he = Vi(X), $e = he == _ ? X.constructor : void 0, Ct = $e ? Be($e) : "";
      if (Ct)
        switch (Ct) {
          case xr:
            return d;
          case dr:
            return y;
          case Er:
            return C;
          case gr:
            return A;
          case pr:
            return L;
        }
      return he;
    });
    function Nc(X, he) {
      return he = he ?? o, !!he && (typeof X == "number" || Z.test(X)) && X > -1 && X % 1 == 0 && X < he;
    }
    function b2(X) {
      var he = typeof X;
      return he == "string" || he == "number" || he == "symbol" || he == "boolean" ? X !== "__proto__" : X === null;
    }
    function st(X) {
      return !!re && re in X;
    }
    function dt(X) {
      var he = X && X.constructor, $e = typeof he == "function" && he.prototype || mt;
      return X === $e;
    }
    function De(X) {
      return ie.call(X);
    }
    function Be(X) {
      if (X != null) {
        try {
          return Jt.call(X);
        } catch {
        }
        try {
          return X + "";
        } catch {
        }
      }
      return "";
    }
    function Me(X, he) {
      return X === he || X !== X && he !== he;
    }
    var ut = iu(/* @__PURE__ */ function() {
      return arguments;
    }()) ? iu : function(X) {
      return te(X) && ne.call(X, "callee") && !ft.call(X, "callee");
    }, Ve = Array.isArray;
    function Kt(X) {
      return X != null && Pe(X.length) && !_e(X);
    }
    var qt = tt || ke;
    function vr(X, he) {
      return cc(X, he);
    }
    function _e(X) {
      if (!Q(X))
        return !1;
      var he = Vi(X);
      return he == p || he == g || he == c || he == x;
    }
    function Pe(X) {
      return typeof X == "number" && X > -1 && X % 1 == 0 && X <= o;
    }
    function Q(X) {
      var he = typeof X;
      return X != null && (he == "object" || he == "function");
    }
    function te(X) {
      return X != null && typeof X == "object";
    }
    var J = Fe ? ze(Fe) : Ka;
    function fe(X) {
      return Kt(X) ? Vu(X) : y2(X);
    }
    function le() {
      return [];
    }
    function ke() {
      return !1;
    }
    t.exports = vr;
  }(d_, d_.exports)), d_.exports;
}
var tie = {};
/*
@license
The MIT License (MIT)

Copyright (c) 2016 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/
var j$e;
function nqr() {
  return j$e || (j$e = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), G8(), s6();
    var e = OM(), r = zy(), n = Gy(), a = Wy(), i = Hy(), o = np(), s = FM();
    vg(), VM(), u6(), h6(), H8(), f6(), PM(), d6();
    var l = rp(), c = Wme(), u = l6(), f = c6();
    lrt(), U8(), Hme();
    var h = UM(), p = WG(), g = GM();
    Lme(), MM();
    var y = V8(), b = /* @__PURE__ */ QG(), w = HM();
    function _(ft) {
      return ft && typeof ft == "object" && "default" in ft ? ft : { default: ft };
    }
    function C(ft) {
      if (ft && ft.__esModule) return ft;
      var ot = /* @__PURE__ */ Object.create(null);
      return ft && Object.keys(ft).forEach(function(Ye) {
        if (Ye !== "default") {
          var Je = Object.getOwnPropertyDescriptor(ft, Ye);
          Object.defineProperty(ot, Ye, Je.get ? Je : {
            enumerable: !0,
            get: function() {
              return ft[Ye];
            }
          });
        }
      }), ot.default = ft, Object.freeze(ot);
    }
    var x = /* @__PURE__ */ _(e), S = /* @__PURE__ */ _(r), A = /* @__PURE__ */ _(n), I = /* @__PURE__ */ _(a), M = /* @__PURE__ */ _(i), B = /* @__PURE__ */ _(o), L = /* @__PURE__ */ _(s), N = /* @__PURE__ */ _(l), d = /* @__PURE__ */ _(u), m = /* @__PURE__ */ _(f), v = /* @__PURE__ */ _(p), k = /* @__PURE__ */ _(g), O = /* @__PURE__ */ C(y), G = /* @__PURE__ */ C(b);
    function H(ft, ot, Ye, Je) {
      var tt = arguments.length, kt = tt < 3 ? ot : Je === null ? Je = Object.getOwnPropertyDescriptor(ot, Ye) : Je, Ft;
      if ((typeof Reflect > "u" ? "undefined" : N.default(Reflect)) === "object" && typeof Reflect.decorate == "function") kt = Reflect.decorate(ft, ot, Ye, Je);
      else for (var bt = ft.length - 1; bt >= 0; bt--)
        (Ft = ft[bt]) && (kt = (tt < 3 ? Ft(kt) : tt > 3 ? Ft(ot, Ye, kt) : Ft(ot, Ye)) || kt);
      return tt > 3 && kt && Object.defineProperty(ot, Ye, kt), kt;
    }
    function j(ft, ot) {
      if ((typeof Reflect > "u" ? "undefined" : N.default(Reflect)) === "object" && typeof Reflect.metadata == "function") return Reflect.metadata(ft, ot);
    }
    var F;
    function z() {
    }
    z.prototype = /* @__PURE__ */ Object.create(null);
    function W() {
      W.init.call(this);
    }
    W.EventEmitter = W, W.usingDomains = !1, W.prototype.domain = void 0, W.prototype._events = void 0, W.prototype._maxListeners = void 0, W.defaultMaxListeners = 10, W.init = function() {
      this.domain = null, W.usingDomains && F.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new z(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, W.prototype.setMaxListeners = function(ot) {
      if (typeof ot != "number" || ot < 0 || isNaN(ot))
        throw new TypeError('"n" argument must be a positive number');
      return this._maxListeners = ot, this;
    };
    function U(ft) {
      return ft._maxListeners === void 0 ? W.defaultMaxListeners : ft._maxListeners;
    }
    W.prototype.getMaxListeners = function() {
      return U(this);
    };
    function Z(ft, ot, Ye) {
      if (ot)
        ft.call(Ye);
      else
        for (var Je = ft.length, tt = Fe(ft, Je), kt = 0; kt < Je; ++kt)
          tt[kt].call(Ye);
    }
    function V(ft, ot, Ye, Je) {
      if (ot)
        ft.call(Ye, Je);
      else
        for (var tt = ft.length, kt = Fe(ft, tt), Ft = 0; Ft < tt; ++Ft)
          kt[Ft].call(Ye, Je);
    }
    function Y(ft, ot, Ye, Je, tt) {
      if (ot)
        ft.call(Ye, Je, tt);
      else
        for (var kt = ft.length, Ft = Fe(ft, kt), bt = 0; bt < kt; ++bt)
          Ft[bt].call(Ye, Je, tt);
    }
    function ge(ft, ot, Ye, Je, tt, kt) {
      if (ot)
        ft.call(Ye, Je, tt, kt);
      else
        for (var Ft = ft.length, bt = Fe(ft, Ft), At = 0; At < Ft; ++At)
          bt[At].call(Ye, Je, tt, kt);
    }
    function ce(ft, ot, Ye, Je) {
      if (ot)
        ft.apply(Ye, Je);
      else
        for (var tt = ft.length, kt = Fe(ft, tt), Ft = 0; Ft < tt; ++Ft)
          kt[Ft].apply(Ye, Je);
    }
    W.prototype.emit = function(ot) {
      var Ye, Je, tt, kt, Ft, bt, At, vt = ot === "error";
      if (bt = this._events, bt)
        vt = vt && bt.error == null;
      else if (!vt)
        return !1;
      if (At = this.domain, vt) {
        if (Ye = arguments[1], At)
          Ye || (Ye = new Error('Uncaught, unspecified "error" event')), Ye.domainEmitter = this, Ye.domain = At, Ye.domainThrown = !1, At.emit("error", Ye);
        else {
          if (Ye instanceof Error)
            throw Ye;
          var _t = new Error('Uncaught, unspecified "error" event. (' + Ye + ")");
          throw _t.context = Ye, _t;
        }
        return !1;
      }
      if (Je = bt[ot], !Je)
        return !1;
      var yt = typeof Je == "function";
      switch (tt = arguments.length, tt) {
        // fast cases
        case 1:
          Z(Je, yt, this);
          break;
        case 2:
          V(Je, yt, this, arguments[1]);
          break;
        case 3:
          Y(Je, yt, this, arguments[1], arguments[2]);
          break;
        case 4:
          ge(Je, yt, this, arguments[1], arguments[2], arguments[3]);
          break;
        // slower
        default:
          for (kt = new Array(tt - 1), Ft = 1; Ft < tt; Ft++)
            kt[Ft - 1] = arguments[Ft];
          ce(Je, yt, this, kt);
      }
      return !0;
    };
    function ee(ft, ot, Ye, Je) {
      var tt, kt, Ft;
      if (typeof Ye != "function")
        throw new TypeError('"listener" argument must be a function');
      if (kt = ft._events, kt ? (kt.newListener && (ft.emit(
        "newListener",
        ot,
        Ye.listener ? Ye.listener : Ye
      ), kt = ft._events), Ft = kt[ot]) : (kt = ft._events = new z(), ft._eventsCount = 0), !Ft)
        Ft = kt[ot] = Ye, ++ft._eventsCount;
      else if (typeof Ft == "function" ? Ft = kt[ot] = Je ? [Ye, Ft] : [Ft, Ye] : Je ? Ft.unshift(Ye) : Ft.push(Ye), !Ft.warned && (tt = U(ft), tt && tt > 0 && Ft.length > tt)) {
        Ft.warned = !0;
        var bt = new Error("Possible EventEmitter memory leak detected. " + Ft.length + " " + ot + " listeners added. Use emitter.setMaxListeners() to increase limit");
        bt.name = "MaxListenersExceededWarning", bt.emitter = ft, bt.type = ot, bt.count = Ft.length, Se(bt);
      }
      return ft;
    }
    function Se(ft) {
      typeof console.warn == "function" ? console.warn(ft) : console.log(ft);
    }
    W.prototype.addListener = function(ot, Ye) {
      return ee(this, ot, Ye, !1);
    }, W.prototype.on = W.prototype.addListener, W.prototype.prependListener = function(ot, Ye) {
      return ee(this, ot, Ye, !0);
    };
    function Ce(ft, ot, Ye) {
      var Je = !1;
      function tt() {
        ft.removeListener(ot, tt), Je || (Je = !0, Ye.apply(ft, arguments));
      }
      return tt.listener = Ye, tt;
    }
    W.prototype.once = function(ot, Ye) {
      if (typeof Ye != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.on(ot, Ce(this, ot, Ye)), this;
    }, W.prototype.prependOnceListener = function(ot, Ye) {
      if (typeof Ye != "function")
        throw new TypeError('"listener" argument must be a function');
      return this.prependListener(ot, Ce(this, ot, Ye)), this;
    }, W.prototype.removeListener = function(ot, Ye) {
      var Je, tt, kt, Ft, bt;
      if (typeof Ye != "function")
        throw new TypeError('"listener" argument must be a function');
      if (tt = this._events, !tt)
        return this;
      if (Je = tt[ot], !Je)
        return this;
      if (Je === Ye || Je.listener && Je.listener === Ye)
        --this._eventsCount === 0 ? this._events = new z() : (delete tt[ot], tt.removeListener && this.emit("removeListener", ot, Je.listener || Ye));
      else if (typeof Je != "function") {
        for (kt = -1, Ft = Je.length; Ft-- > 0; )
          if (Je[Ft] === Ye || Je[Ft].listener && Je[Ft].listener === Ye) {
            bt = Je[Ft].listener, kt = Ft;
            break;
          }
        if (kt < 0)
          return this;
        if (Je.length === 1) {
          if (Je[0] = void 0, --this._eventsCount === 0)
            return this._events = new z(), this;
          delete tt[ot];
        } else
          We(Je, kt);
        tt.removeListener && this.emit("removeListener", ot, bt || Ye);
      }
      return this;
    }, W.prototype.off = function(ft, ot) {
      return this.removeListener(ft, ot);
    }, W.prototype.removeAllListeners = function(ot) {
      var Ye, Je;
      if (Je = this._events, !Je)
        return this;
      if (!Je.removeListener)
        return arguments.length === 0 ? (this._events = new z(), this._eventsCount = 0) : Je[ot] && (--this._eventsCount === 0 ? this._events = new z() : delete Je[ot]), this;
      if (arguments.length === 0) {
        for (var tt = Object.keys(Je), kt = 0, Ft; kt < tt.length; ++kt)
          Ft = tt[kt], Ft !== "removeListener" && this.removeAllListeners(Ft);
        return this.removeAllListeners("removeListener"), this._events = new z(), this._eventsCount = 0, this;
      }
      if (Ye = Je[ot], typeof Ye == "function")
        this.removeListener(ot, Ye);
      else if (Ye)
        do
          this.removeListener(ot, Ye[Ye.length - 1]);
        while (Ye[0]);
      return this;
    }, W.prototype.listeners = function(ot) {
      var Ye, Je, tt = this._events;
      return tt ? (Ye = tt[ot], Ye ? typeof Ye == "function" ? Je = [Ye.listener || Ye] : Je = it(Ye) : Je = []) : Je = [], Je;
    }, W.listenerCount = function(ft, ot) {
      return typeof ft.listenerCount == "function" ? ft.listenerCount(ot) : we.call(ft, ot);
    }, W.prototype.listenerCount = we;
    function we(ft) {
      var ot = this._events;
      if (ot) {
        var Ye = ot[ft];
        if (typeof Ye == "function")
          return 1;
        if (Ye)
          return Ye.length;
      }
      return 0;
    }
    W.prototype.eventNames = function() {
      return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
    };
    function We(ft, ot) {
      for (var Ye = ot, Je = Ye + 1, tt = ft.length; Je < tt; Ye += 1, Je += 1)
        ft[Ye] = ft[Je];
      ft.pop();
    }
    function Fe(ft, ot) {
      for (var Ye = new Array(ot); ot--; )
        Ye[ot] = ft[ot];
      return Ye;
    }
    function it(ft) {
      for (var ot = new Array(ft.length), Ye = 0; Ye < ot.length; ++Ye)
        ot[Ye] = ft[Ye].listener || ft[Ye];
      return ot;
    }
    var gt = O.getLogger("twilio-notificatiions");
    function Ze(ft, ot) {
      return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Twilio.Notifications ").concat(ft, ":")].concat(Array.from(ot));
    }
    var Ne = /* @__PURE__ */ function() {
      function ft() {
        S.default(this, ft);
      }
      return A.default(ft, [{
        key: "setLevel",
        value: function(Ye) {
          gt.setLevel(Ye);
        }
      }, {
        key: "trace",
        value: function() {
          if (gt.getLevel() == gt.levels.TRACE) {
            for (var Ye = arguments.length, Je = new Array(Ye), tt = 0; tt < Ye; tt++)
              Je[tt] = arguments[tt];
            gt.debug.apply(null, Ze("T", Je));
          }
        }
      }, {
        key: "debug",
        value: function() {
          for (var Ye = arguments.length, Je = new Array(Ye), tt = 0; tt < Ye; tt++)
            Je[tt] = arguments[tt];
          gt.debug.apply(null, Ze("D", Je));
        }
      }, {
        key: "info",
        value: function() {
          for (var Ye = arguments.length, Je = new Array(Ye), tt = 0; tt < Ye; tt++)
            Je[tt] = arguments[tt];
          gt.info.apply(null, Ze("I", Je));
        }
      }, {
        key: "warn",
        value: function() {
          for (var Ye = arguments.length, Je = new Array(Ye), tt = 0; tt < Ye; tt++)
            Je[tt] = arguments[tt];
          gt.warn.apply(null, Ze("W", Je));
        }
      }, {
        key: "error",
        value: function() {
          for (var Ye = arguments.length, Je = new Array(Ye), tt = 0; tt < Ye; tt++)
            Je[tt] = arguments[tt];
          gt.error.apply(null, Ze("E", Je));
        }
      }]), ft;
    }(), ze = new Ne();
    function ct(ft) {
      var ot = rt();
      return function() {
        var Je = B.default(ft), tt;
        if (ot) {
          var kt = B.default(this).constructor;
          tt = Reflect.construct(Je, arguments, kt);
        } else
          tt = Je.apply(this, arguments);
        return M.default(this, tt);
      };
    }
    function rt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var qe = /* @__PURE__ */ A.default(function ft() {
      var ot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", Ye = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", Je = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
      S.default(this, ft), this.token = ot, this.notificationId = Ye, this.messageTypes = Je;
    });
    function nt(ft, ot) {
      return [].concat(k.default(k.default(ft).filter(function(Ye) {
        return !ot.has(Ye);
      })), k.default(k.default(ot).filter(function(Ye) {
        return !ft.has(Ye);
      })));
    }
    function Rt(ft, ot) {
      var Ye = /* @__PURE__ */ new Set();
      return ft.notificationId !== ot.notificationId && Ye.add("notificationId"), ft.token !== ot.token && Ye.add("token"), nt(ft.messageTypes, ot.messageTypes).length > 0 && Ye.add("messageType"), [Ye.size > 0, Ye];
    }
    var Ot = /* @__PURE__ */ function(ft) {
      I.default(Ye, ft);
      var ot = ct(Ye);
      function Ye(Je) {
        var tt;
        return S.default(this, Ye), tt = ot.call(this), m.default(d.default(tt), "desiredState", new qe()), m.default(d.default(tt), "currentState", new qe()), m.default(d.default(tt), "_hasActiveAttempt", !1), tt.channelType = Je, tt;
      }
      return A.default(Ye, [{
        key: "setNotificationId",
        value: function(tt) {
          this.desiredState.notificationId = tt;
        }
        /**
         * Return true is this connector is in usable state and should be able to commit changes.
         */
      }, {
        key: "isActive",
        value: function() {
          return this.desiredState.notificationId !== "";
        }
      }, {
        key: "subscribe",
        value: function(tt) {
          if (this.desiredState.messageTypes.has(tt)) {
            ze.debug("message type '".concat(tt, "' for channel ").concat(this.channelType, " is already registered"));
            return;
          }
          this.desiredState.messageTypes.add(tt);
        }
      }, {
        key: "unsubscribe",
        value: function(tt) {
          this.desiredState.messageTypes.has(tt) && this.desiredState.messageTypes.delete(tt);
        }
      }, {
        key: "updateToken",
        value: function(tt) {
          this.desiredState.token = tt;
        }
        /**
         * Perform actual registration after all required changes are settled.
         */
      }, {
        key: "commitChanges",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt() {
            var Ft, bt, At, vt, _t, yt;
            return L.default.wrap(function(dr) {
              for (; ; )
                switch (dr.prev = dr.next) {
                  case 0:
                    if (!this._hasActiveAttempt) {
                      dr.next = 3;
                      break;
                    }
                    throw ze.error("One registration attempt is already in progress"), new Error("One registration attempt is already in progress");
                  case 3:
                    if (Ft = Rt(this.desiredState, this.currentState), bt = v.default(Ft, 2), At = bt[0], vt = bt[1], At) {
                      dr.next = 6;
                      break;
                    }
                    return dr.abrupt("return");
                  case 6:
                    if (this.currentState.notificationId || vt.delete("notificationId"), ze.trace("Persisting ".concat(this.channelType, " registration"), vt, this.desiredState), dr.prev = 8, this._hasActiveAttempt = !0, _t = new qe(), _t.token = this.desiredState.token, _t.notificationId = this.desiredState.notificationId, _t.messageTypes = new Set(this.desiredState.messageTypes), !(_t.messageTypes.size > 0)) {
                      dr.next = 24;
                      break;
                    }
                    return dr.next = 17, this.updateRegistration(_t, vt);
                  case 17:
                    yt = dr.sent, this.currentState.token = yt.token, this.currentState.notificationId = yt.notificationId, this.currentState.messageTypes = new Set(yt.messageTypes), this.emit("stateChanged", this.channelType, "registered", this.currentState), dr.next = 30;
                    break;
                  case 24:
                    return dr.next = 26, this.removeRegistration();
                  case 26:
                    this.currentState.token = _t.token, this.currentState.notificationId = _t.notificationId, this.currentState.messageTypes.clear(), this.emit("stateChanged", this.channelType, "unregistered", this.currentState);
                  case 30:
                    dr.next = 35;
                    break;
                  case 32:
                    throw dr.prev = 32, dr.t0 = dr.catch(8), dr.t0;
                  case 35:
                    return dr.prev = 35, this._hasActiveAttempt = !1, dr.finish(35);
                  case 38:
                  case "end":
                    return dr.stop();
                }
            }, kt, this, [[8, 32, 35, 38]]);
          }));
          function tt() {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }]), Ye;
    }(W);
    function lt(ft) {
      var ot = mt();
      return function() {
        var Je = B.default(ft), tt;
        if (ot) {
          var kt = B.default(this).constructor;
          tt = Reflect.construct(Je, arguments, kt);
        } else
          tt = Je.apply(this, arguments);
        return M.default(this, tt);
      };
    }
    function mt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var jt = {
      min: 2e3,
      max: 12e4,
      randomness: 0.2
    }, Jt = /* @__PURE__ */ function(ft) {
      I.default(Ye, ft);
      var ot = lt(Ye);
      function Ye(Je, tt, kt, Ft) {
        var bt;
        return S.default(this, Ye), bt = ot.call(this, Je), m.default(d.default(bt), "registrationId", null), bt.context = tt, bt.twilsock = kt, bt.registrarUrl = Ft, bt;
      }
      return A.default(Ye, [{
        key: "updateRegistration",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt(Ft, bt) {
            var At = this, vt, _t, yt, xr, dr;
            return L.default.wrap(function(gr) {
              for (; ; )
                switch (gr.prev = gr.next) {
                  case 0:
                    if (!bt.has("notificationId")) {
                      gr.next = 3;
                      break;
                    }
                    return gr.next = 3, this.removeRegistration();
                  case 3:
                    if (!(!Ft.notificationId || !Ft.notificationId.length)) {
                      gr.next = 6;
                      break;
                    }
                    throw ze.error("No push notification ID for registration"), new Error("No push notification ID for registration");
                  case 6:
                    return ze.trace("Registering", this.channelType, Ft), vt = {
                      endpoint_platform: this.context.platform,
                      channel_type: this.channelType,
                      version: this.context.protocolVersion.toString(),
                      message_types: Array.from(Ft.messageTypes),
                      data: {
                        registration_id: Ft.notificationId
                      }
                      //ttl: 'PT24H' - This is totally ignored by notify, all bindings use PT1Y ttl.
                    }, _t = this.context.productId, yt = "".concat(this.registrarUrl, "?productId=").concat(_t), xr = {
                      "Content-Type": "application/json"
                      // 'X-Twilio-Token': registration.token
                    }, ze.trace("Creating registration for channel ".concat(this.channelType)), gr.prev = 12, gr.next = 15, new h.AsyncRetrier(jt).run(function() {
                      return At.twilsock.post(yt, xr, vt, _t);
                    });
                  case 15:
                    dr = gr.sent, this.registrationId = dr.body.id, ze.debug("Registration created: ", dr), gr.next = 24;
                    break;
                  case 20:
                    throw gr.prev = 20, gr.t0 = gr.catch(12), ze.error("Registration failed: ", gr.t0), gr.t0;
                  case 24:
                    return gr.abrupt("return", Ft);
                  case 25:
                  case "end":
                    return gr.stop();
                }
            }, kt, this, [[12, 20]]);
          }));
          function tt(kt, Ft) {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }, {
        key: "removeRegistration",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt() {
            var Ft = this, bt, At, vt;
            return L.default.wrap(function(yt) {
              for (; ; )
                switch (yt.prev = yt.next) {
                  case 0:
                    if (this.registrationId) {
                      yt.next = 2;
                      break;
                    }
                    return yt.abrupt("return");
                  case 2:
                    return bt = this.context.productId, At = "".concat(this.registrarUrl, "/").concat(this.registrationId, "?productId=").concat(bt), vt = {
                      "Content-Type": "application/json"
                      // 'X-Twilio-Token': this.config.token
                    }, ze.trace("Removing registration for ".concat(this.channelType)), yt.prev = 6, yt.next = 9, new h.AsyncRetrier(Object.assign(jt, {
                      maxAttemptsCount: 3
                    })).run(function() {
                      return Ft.twilsock.delete(At, vt, {}, bt);
                    });
                  case 9:
                    this.registrationId = null, this.currentState.notificationId = "", ze.debug("Registration removed for ".concat(this.channelType)), yt.next = 18;
                    break;
                  case 14:
                    throw yt.prev = 14, yt.t0 = yt.catch(6), ze.error("Failed to remove registration ", this.channelType, yt.t0), yt.t0;
                  case 18:
                  case "end":
                    return yt.stop();
                }
            }, kt, this, [[6, 14]]);
          }));
          function tt() {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }, {
        key: "sendDeviceRemoveRequest",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt(Ft) {
            var bt = this, At, vt, _t, yt;
            return L.default.wrap(function(dr) {
              for (; ; )
                switch (dr.prev = dr.next) {
                  case 0:
                    if (Ft !== "") {
                      dr.next = 2;
                      break;
                    }
                    throw new Error("Empty registration ID");
                  case 2:
                    return At = this.context.productId, vt = "".concat(this.registrarUrl, "?productId=").concat(At), _t = {
                      "Content-Type": "application/json"
                      // @todo Content-Length??
                    }, yt = {
                      binding_type: this.channelType,
                      address: Ft
                    }, dr.prev = 6, ze.trace("Removing old registrations for ".concat(this.channelType)), dr.next = 10, new h.AsyncRetrier(Object.assign(jt, {
                      maxAttemptsCount: 3
                    })).run(function() {
                      return bt.twilsock.delete(vt, _t, yt, At);
                    });
                  case 10:
                    this.registrationId = null, this.currentState.notificationId = "", ze.debug("Registration removed for ".concat(this.channelType)), dr.next = 19;
                    break;
                  case 15:
                    throw dr.prev = 15, dr.t0 = dr.catch(6), ze.error("Failed to remove registration ", this.channelType, dr.t0), dr.t0;
                  case 19:
                  case "end":
                    return dr.stop();
                }
            }, kt, this, [[6, 15]]);
          }));
          function tt(kt) {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }]), Ye;
    }(Ot);
    function ne(ft) {
      var ot = re();
      return function() {
        var Je = B.default(ft), tt;
        if (ot) {
          var kt = B.default(this).constructor;
          tt = Reflect.construct(Je, arguments, kt);
        } else
          tt = Je.apply(this, arguments);
        return M.default(this, tt);
      };
    }
    function re() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var ie = /* @__PURE__ */ function(ft) {
      I.default(Ye, ft);
      var ot = ne(Ye);
      function Ye(Je, tt, kt) {
        var Ft;
        return S.default(this, Ye), Ft = ot.call(this, "twilsock"), m.default(d.default(Ft), "contextId", G.v4()), Ft.productId = Je, Ft.platform = tt, Ft.twilsock = kt, Ft;
      }
      return A.default(Ye, [{
        key: "updateRegistration",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt(Ft, bt) {
            var At, vt;
            return L.default.wrap(function(yt) {
              for (; ; )
                switch (yt.prev = yt.next) {
                  case 0:
                    if (bt.has("messageType")) {
                      yt.next = 2;
                      break;
                    }
                    return yt.abrupt("return", Ft);
                  case 2:
                    return At = Array.from(Ft.messageTypes), vt = {
                      product_id: this.productId,
                      notification_protocol_version: 4,
                      endpoint_platform: this.platform,
                      message_types: At
                    }, yt.prev = 4, yt.next = 7, this.twilsock.setNotificationsContext(this.contextId, vt);
                  case 7:
                    yt.next = 13;
                    break;
                  case 9:
                    throw yt.prev = 9, yt.t0 = yt.catch(4), ze.error("Failed to update twilsock notification context: ".concat(yt.t0)), yt.t0;
                  case 13:
                    return yt.abrupt("return", Ft);
                  case 14:
                  case "end":
                    return yt.stop();
                }
            }, kt, this, [[4, 9]]);
          }));
          function tt(kt, Ft) {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }, {
        key: "removeRegistration",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt() {
            return L.default.wrap(function(bt) {
              for (; ; )
                switch (bt.prev = bt.next) {
                  case 0:
                    return bt.prev = 0, bt.next = 3, this.twilsock.removeNotificationsContext(this.contextId);
                  case 3:
                    bt.next = 9;
                    break;
                  case 5:
                    throw bt.prev = 5, bt.t0 = bt.catch(0), ze.error("Failed to remove twilsock notification context: ".concat(bt.t0)), bt.t0;
                  case 9:
                  case "end":
                    return bt.stop();
                }
            }, kt, this, [[0, 5]]);
          }));
          function tt() {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      }, {
        key: "sendDeviceRemoveRequest",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt(Ft) {
            return L.default.wrap(function(At) {
              for (; ; )
                switch (At.prev = At.next) {
                  case 0:
                  case "end":
                    return At.stop();
                }
            }, kt);
          }));
          function tt(kt) {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
      }]), Ye;
    }(Ot);
    function Ie(ft) {
      var ot = Ke();
      return function() {
        var Je = B.default(ft), tt;
        if (ot) {
          var kt = B.default(this).constructor;
          tt = Reflect.construct(Je, arguments, kt);
        } else
          tt = Je.apply(this, arguments);
        return M.default(this, tt);
      };
    }
    function Ke() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Le, Ge = w.literal("apn", "fcm", "twilsock");
    t.Notifications = Le = /* @__PURE__ */ function(ft) {
      I.default(Ye, ft);
      var ot = Ie(Ye);
      function Ye(Je) {
        var tt, kt, Ft, bt, At, vt, _t, yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        S.default(this, Ye), _t = ot.call(this), yt.logLevel = (tt = yt.logLevel) !== null && tt !== void 0 ? tt : "error", ze.setLevel(yt.logLevel);
        var xr = (kt = yt.productId) !== null && kt !== void 0 ? kt : "notifications", dr = !yt.twilsockClient, Er = yt.twilsockClient = (Ft = yt.twilsockClient) !== null && Ft !== void 0 ? Ft : new c.TwilsockClient(Je, xr, yt), gr = (bt = yt.notifications) !== null && bt !== void 0 ? bt : {}, pr = (At = (vt = gr.region) !== null && vt !== void 0 ? vt : yt.region) !== null && At !== void 0 ? At : "us1", Xr = "https://ers.".concat(pr, ".twilio.com/v1/registrations"), Yr = gr.ersUrl || Xr;
        _t.connectors = /* @__PURE__ */ new Map();
        var at = Le._detectPlatform();
        return _t.connectors.set("apn", new Jt("apn", {
          protocolVersion: 4,
          productId: xr,
          platform: at
        }, Er, Yr)), _t.connectors.set("fcm", new Jt("fcm", {
          protocolVersion: 3,
          productId: xr,
          platform: at
        }, Er, Yr)), _t.connectors.set("twilsock", new ie(xr, at, Er)), Er.on("stateChanged", function(Vt) {
          return _t.emit("transportState", Vt);
        }), _t._connector("twilsock").on("stateChanged", function(Vt, er, fr) {
          return _t.emit("stateChanged", Vt, er, fr);
        }), _t._connector("apn").on("stateChanged", function(Vt, er, fr) {
          return _t.emit("stateChanged", Vt, er, fr);
        }), _t._connector("fcm").on("stateChanged", function(Vt, er, fr) {
          return _t.emit("stateChanged", Vt, er, fr);
        }), Er.on("message", function(Vt, er) {
          return _t._routeMessage(Vt, er);
        }), _t.updateToken(Je), dr && (Er.connect(), _t.twilsock = Er), _t;
      }
      return A.default(Ye, [{
        key: "shutdown",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt() {
            return L.default.wrap(function(bt) {
              for (; ; )
                switch (bt.prev = bt.next) {
                  case 0:
                    if (this.connectors.clear(), !this.twilsock) {
                      bt.next = 4;
                      break;
                    }
                    return bt.next = 4, this.twilsock.disconnect();
                  case 4:
                  case "end":
                    return bt.stop();
                }
            }, kt, this);
          }));
          function tt() {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
        /**
         * Set OS-provided APNS/FCM registration binding for the given channel type. Not used for 'twilsock'.
         *
         * You must call this function once you've received the ID of your device from the underlying OS.
         *
         * @param {ChannelType} channelType Channel type ('apn'/'fcm').
         * @param {string} pushRegistrationId Token received from FCM/APNS system on device.
         */
      }, {
        key: "setPushRegistrationId",
        value: function(tt, kt) {
          ze.debug("Set ".concat(tt, " push registration id '").concat(kt, "'")), this._connector(tt).setNotificationId(kt);
        }
        /**
         * Subscribe to a given message type for a given channel type.
         *
         * Creates a subscriptions to receive incoming messages according to message type.
         * Subscription establishes a binding and you will receive a signal when a notification
         * of this type has been received by the library.
         *
         * Subscribed binding is preserved for 1 year, after which time it needs to be re-subscribed.
         * This is the responsibility of the client SDK.
         *
         * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
         * @param {string} messageType The type of message that you want to receive
         */
      }, {
        key: "subscribe",
        value: function(tt, kt) {
          ze.debug("Add ".concat(tt, " subscriptions for message type ").concat(kt)), this._connector(tt).subscribe(kt);
        }
        /**
         * Unsubscribe from a given message type.
         *
         * Unsubscribing breaks a binding and you will not receive more notifications for this message type.
         * Please note that you have to call commitChanges() and receive a successful result before
         * the subscription is actually removed.
         *
         * @param {ChannelType} channelType Supported are 'twilsock', 'apn' and 'fcm'
         * @param {string} messageType The type of message that you don't want to receive anymore
         */
      }, {
        key: "unsubscribe",
        value: function(tt, kt) {
          ze.debug("Remove ".concat(tt, " subscriptions for message type ").concat(kt)), this._connector(tt).unsubscribe(kt);
        }
        /**
         * Update subscription token. You must update the token when the old one expires.
         *
         * When you receive onTokenWillExpire event from twilsock, call this function with the new refreshed
         * token _after_ you have updated twilsock and other associated objects with the new token.
         *
         * @param {string} token Authentication token for registrations
         */
      }, {
        key: "updateToken",
        value: function(tt) {
          this.connectors.forEach(function(kt) {
            return kt.updateToken(tt);
          });
        }
        /**
         * Commit all collected subscription changes as a batched update. This function tries to reduce
         * number of network calls necessary to update bindings status.
         */
      }, {
        key: "commitChanges",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt() {
            var Ft;
            return L.default.wrap(function(At) {
              for (; ; )
                switch (At.prev = At.next) {
                  case 0:
                    return Ft = [], this.connectors.forEach(function(vt) {
                      vt.isActive() && Ft.push(vt.commitChanges());
                    }), At.next = 4, Promise.all(Ft);
                  case 4:
                  case "end":
                    return At.stop();
                }
            }, kt, this);
          }));
          function tt() {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
        /**
         * Clear existing registrations directly using provided device token.
         * This is useful to ensure stopped subscriptions without resubscribing.
         *
         * This function goes completely beside the state machine and removes all registrations.
         * Use with caution: if it races with current state machine operations, madness will ensue.
         *
         * @param {ChannelType} channelType Channel type ('apn'/'fcm').
         * @param {string} registrationId Token received from FCM/APNS system on device.
         */
      }, {
        key: "removeRegistrations",
        value: function() {
          var Je = x.default(/* @__PURE__ */ L.default.mark(function kt(Ft, bt) {
            return L.default.wrap(function(vt) {
              for (; ; )
                switch (vt.prev = vt.next) {
                  case 0:
                    return vt.next = 2, this._connector(Ft).sendDeviceRemoveRequest(bt);
                  case 2:
                  case "end":
                    return vt.stop();
                }
            }, kt, this);
          }));
          function tt(kt, Ft) {
            return Je.apply(this, arguments);
          }
          return tt;
        }()
        /**
         * Handle incoming push notification.
         * Client application should call this method when it receives push notifications and pass the received data.
         * @param {Object} message push message
         * @return {PushNotification} A reformatted payload with extracted message type.
         */
      }, {
        key: "handlePushNotification",
        value: function(tt) {
          return {
            messageType: tt.twi_message_type,
            payload: tt.payload
          };
        }
        /**
         * Routes messages to the external subscribers
         */
      }, {
        key: "_routeMessage",
        value: function(tt, kt) {
          ze.debug("Notification message arrived: ", tt, kt), this.emit("message", tt, kt);
        }
        /**
         * @param {String} type Channel type
         * @throws {Error} Error with description
         */
      }, {
        key: "_connector",
        value: function(tt) {
          var kt = this.connectors.get(tt);
          if (!kt)
            throw new Error("Unknown channel type: ".concat(tt));
          return kt;
        }
        /**
         * Returns platform string limited to max 128 chars
         */
      }], [{
        key: "_detectPlatform",
        value: function() {
          var tt = "";
          return typeof navigator < "u" ? (tt = "unknown", typeof navigator.product < "u" && (tt = navigator.product), typeof navigator.userAgent < "u" && (tt = navigator.userAgent)) : tt = "web", tt.substring(0, 128);
        }
      }]), Ye;
    }(W), H([w.validateTypes(Ge, w.nonEmptyString), j("design:type", Function), j("design:paramtypes", [String, String]), j("design:returntype", void 0)], t.Notifications.prototype, "setPushRegistrationId", null), H([w.validateTypes(Ge, w.nonEmptyString), j("design:type", Function), j("design:paramtypes", [String, String]), j("design:returntype", void 0)], t.Notifications.prototype, "subscribe", null), H([w.validateTypes(Ge, w.nonEmptyString), j("design:type", Function), j("design:paramtypes", [String, String]), j("design:returntype", void 0)], t.Notifications.prototype, "unsubscribe", null), H([w.validateTypes(w.nonEmptyString), j("design:type", Function), j("design:paramtypes", [String]), j("design:returntype", void 0)], t.Notifications.prototype, "updateToken", null), H([w.validateTypesAsync(Ge, w.nonEmptyString), j("design:type", Function), j("design:paramtypes", [String, String]), j("design:returntype", Promise)], t.Notifications.prototype, "removeRegistrations", null), t.Notifications = Le = H([w.validateConstructorTypes(w.nonEmptyString, [w.pureObject, "undefined", w.literal(null)]), j("design:paramtypes", [String, Object])], t.Notifications);
  }(tie)), tie;
}
var rie = {}, F$e = {}, nie, z$e;
function aqr() {
  if (z$e) return nie;
  z$e = 1;
  var t = fs(), e = Yh(), r = Do(), n = r("match");
  return nie = function(a) {
    var i;
    return t(a) && ((i = a[n]) !== void 0 ? !!i : e(a) === "RegExp");
  }, nie;
}
var aie, G$e;
function e2t() {
  if (G$e) return aie;
  G$e = 1;
  var t = aqr(), e = TypeError;
  return aie = function(r) {
    if (t(r))
      throw new e("The method doesn't accept regular expressions");
    return r;
  }, aie;
}
var iie, W$e;
function t2t() {
  if (W$e) return iie;
  W$e = 1;
  var t = Do(), e = t("match");
  return iie = function(r) {
    var n = /./;
    try {
      "/./"[r](n);
    } catch {
      try {
        return n[e] = !1, "/./"[r](n);
      } catch {
      }
    }
    return !1;
  }, iie;
}
var H$e;
function r2t() {
  if (H$e) return F$e;
  H$e = 1;
  var t = Ya(), e = yme(), r = Fy().f, n = hg(), a = Vl(), i = e2t(), o = d2(), s = t2t(), l = _f(), c = e("".slice), u = Math.min, f = s("startsWith"), h = !l && !f && !!function() {
    var p = r(String.prototype, "startsWith");
    return p && !p.writable;
  }();
  return t({ target: "String", proto: !0, forced: !h && !f }, {
    startsWith: function(g) {
      var y = a(o(this));
      i(g);
      var b = n(u(arguments.length > 1 ? arguments[1] : void 0, y.length)), w = a(g);
      return c(y, b, b + w.length) === w;
    }
  }), F$e;
}
var U$e = {}, V$e = {}, oie, q$e;
function n2t() {
  if (q$e) return oie;
  q$e = 1;
  var t = Ba(), e = Do(), r = Go(), n = _f(), a = e("iterator");
  return oie = !t(function() {
    var i = new URL("b?a=1&b=2&c=3", "https://a"), o = i.searchParams, s = new URLSearchParams("a=1&a=2&b=3"), l = "";
    return i.pathname = "c%20d", o.forEach(function(c, u) {
      o.delete("b"), l += u + c;
    }), s.delete("a", 2), s.delete("b", void 0), n && (!i.toJSON || !s.has("a", 1) || s.has("a", 2) || !s.has("a", void 0) || s.has("b")) || !o.size && (n || !r) || !o.sort || i.href !== "https://a/c%20d?a=1&c=3" || o.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !o[a] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || l !== "a1c3" || new URL("https://x", void 0).host !== "x";
  }), oie;
}
var sie, K$e;
function iqr() {
  if (K$e) return sie;
  K$e = 1;
  var t = Wa(), e = 2147483647, r = 36, n = 1, a = 26, i = 38, o = 700, s = 72, l = 128, c = "-", u = /[^\0-\u007E]/, f = /[.\u3002\uFF0E\uFF61]/g, h = "Overflow: input needs wider integers to process", p = r - n, g = RangeError, y = t(f.exec), b = Math.floor, w = String.fromCharCode, _ = t("".charCodeAt), C = t([].join), x = t([].push), S = t("".replace), A = t("".split), I = t("".toLowerCase), M = function(d) {
    for (var m = [], v = 0, k = d.length; v < k; ) {
      var O = _(d, v++);
      if (O >= 55296 && O <= 56319 && v < k) {
        var G = _(d, v++);
        (G & 64512) === 56320 ? x(m, ((O & 1023) << 10) + (G & 1023) + 65536) : (x(m, O), v--);
      } else
        x(m, O);
    }
    return m;
  }, B = function(d) {
    return d + 22 + 75 * (d < 26);
  }, L = function(d, m, v) {
    var k = 0;
    for (d = v ? b(d / o) : d >> 1, d += b(d / m); d > p * a >> 1; )
      d = b(d / p), k += r;
    return b(k + (p + 1) * d / (d + i));
  }, N = function(d) {
    var m = [];
    d = M(d);
    var v = d.length, k = l, O = 0, G = s, H, j;
    for (H = 0; H < d.length; H++)
      j = d[H], j < 128 && x(m, w(j));
    var F = m.length, z = F;
    for (F && x(m, c); z < v; ) {
      var W = e;
      for (H = 0; H < d.length; H++)
        j = d[H], j >= k && j < W && (W = j);
      var U = z + 1;
      if (W - k > b((e - O) / U))
        throw new g(h);
      for (O += (W - k) * U, k = W, H = 0; H < d.length; H++) {
        if (j = d[H], j < k && ++O > e)
          throw new g(h);
        if (j === k) {
          for (var Z = O, V = r; ; ) {
            var Y = V <= G ? n : V >= G + a ? a : V - G;
            if (Z < Y) break;
            var ge = Z - Y, ce = r - Y;
            x(m, w(B(Y + ge % ce))), Z = b(ge / ce), V += r;
          }
          x(m, w(B(Z))), G = L(O, U, z === F), O = 0, z++;
        }
      }
      O++, k++;
    }
    return C(m, "");
  };
  return sie = function(d) {
    var m = [], v = A(S(I(d), f, "."), "."), k, O;
    for (k = 0; k < v.length; k++)
      O = v[k], x(m, y(u, O) ? "xn--" + N(O) : O);
    return C(m, ".");
  }, sie;
}
var Z$e = {}, J$e;
function oqr() {
  if (J$e) return Z$e;
  J$e = 1;
  var t = Ya(), e = Wa(), r = i6(), n = RangeError, a = String.fromCharCode, i = String.fromCodePoint, o = e([].join), s = !!i && i.length !== 1;
  return t({ target: "String", stat: !0, arity: 1, forced: s }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function(c) {
      for (var u = [], f = arguments.length, h = 0, p; f > h; ) {
        if (p = +arguments[h++], r(p, 1114111) !== p) throw new n(p + " is not a valid code point");
        u[h] = p < 65536 ? a(p) : a(((p -= 65536) >> 10) + 55296, p % 1024 + 56320);
      }
      return o(u, "");
    }
  }), Z$e;
}
var lie, Y$e;
function a2t() {
  if (Y$e) return lie;
  Y$e = 1, vg(), oqr();
  var t = Ya(), e = wi(), r = qtt(), n = wf(), a = No(), i = Wa(), o = Go(), s = n2t(), l = Gu(), c = ep(), u = JG(), f = tp(), h = ert(), p = _0(), g = Uy(), y = $o(), b = Es(), w = gg(), _ = pg(), C = Ys(), x = fs(), S = Vl(), A = mg(), I = r6(), M = zG(), B = LM(), L = HG(), N = kme(), d = Do(), m = Gme(), v = d("iterator"), k = "URLSearchParams", O = k + "Iterator", G = p.set, H = p.getterFor(k), j = p.getterFor(O), F = r("fetch"), z = r("Request"), W = r("Headers"), U = z && z.prototype, Z = W && W.prototype, V = e.TypeError, Y = e.encodeURIComponent, ge = String.fromCharCode, ce = n("String", "fromCodePoint"), ee = parseInt, Se = i("".charAt), Ce = i([].join), we = i([].push), We = i("".replace), Fe = i([].shift), it = i([].splice), gt = i("".split), Ze = i("".slice), Ne = i(/./.exec), ze = /\+/g, ct = "�", rt = /^[0-9a-f]+$/i, qe = function(ot, Ye) {
    var Je = Ze(ot, Ye, Ye + 2);
    return Ne(rt, Je) ? ee(Je, 16) : NaN;
  }, nt = function(ot) {
    for (var Ye = 0, Je = 128; Je > 0 && ot & Je; Je >>= 1)
      Ye++;
    return Ye;
  }, Rt = function(ot) {
    var Ye = null;
    switch (ot.length) {
      case 1:
        Ye = ot[0];
        break;
      case 2:
        Ye = (ot[0] & 31) << 6 | ot[1] & 63;
        break;
      case 3:
        Ye = (ot[0] & 15) << 12 | (ot[1] & 63) << 6 | ot[2] & 63;
        break;
      case 4:
        Ye = (ot[0] & 7) << 18 | (ot[1] & 63) << 12 | (ot[2] & 63) << 6 | ot[3] & 63;
        break;
    }
    return Ye > 1114111 ? null : Ye;
  }, Ot = function(ot) {
    ot = We(ot, ze, " ");
    for (var Ye = ot.length, Je = "", tt = 0; tt < Ye; ) {
      var kt = Se(ot, tt);
      if (kt === "%") {
        if (Se(ot, tt + 1) === "%" || tt + 3 > Ye) {
          Je += "%", tt++;
          continue;
        }
        var Ft = qe(ot, tt + 1);
        if (Ft !== Ft) {
          Je += kt, tt++;
          continue;
        }
        tt += 2;
        var bt = nt(Ft);
        if (bt === 0)
          kt = ge(Ft);
        else {
          if (bt === 1 || bt > 4) {
            Je += ct, tt++;
            continue;
          }
          for (var At = [Ft], vt = 1; vt < bt && (tt++, !(tt + 3 > Ye || Se(ot, tt) !== "%")); ) {
            var _t = qe(ot, tt + 1);
            if (_t !== _t) {
              tt += 3;
              break;
            }
            if (_t > 191 || _t < 128) break;
            we(At, _t), tt += 2, vt++;
          }
          if (At.length !== bt) {
            Je += ct;
            continue;
          }
          var yt = Rt(At);
          yt === null ? Je += ct : kt = ce(yt);
        }
      }
      Je += kt, tt++;
    }
    return Je;
  }, lt = /[!'()~]|%20/g, mt = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  }, jt = function(ot) {
    return mt[ot];
  }, Jt = function(ot) {
    return We(Y(ot), lt, jt);
  }, ne = h(function(Ye, Je) {
    G(this, {
      type: O,
      target: H(Ye).entries,
      index: 0,
      kind: Je
    });
  }, k, function() {
    var Ye = j(this), Je = Ye.target, tt = Ye.index++;
    if (!Je || tt >= Je.length)
      return Ye.target = null, L(void 0, !0);
    var kt = Je[tt];
    switch (Ye.kind) {
      case "keys":
        return L(kt.key, !1);
      case "values":
        return L(kt.value, !1);
    }
    return L([kt.key, kt.value], !1);
  }, !0), re = function(ot) {
    this.entries = [], this.url = null, ot !== void 0 && (x(ot) ? this.parseObject(ot) : this.parseQuery(typeof ot == "string" ? Se(ot, 0) === "?" ? Ze(ot, 1) : ot : S(ot)));
  };
  re.prototype = {
    type: k,
    bindURL: function(ot) {
      this.url = ot, this.update();
    },
    parseObject: function(ot) {
      var Ye = this.entries, Je = B(ot), tt, kt, Ft, bt, At, vt, _t;
      if (Je)
        for (tt = M(ot, Je), kt = tt.next; !(Ft = a(kt, tt)).done; ) {
          if (bt = M(C(Ft.value)), At = bt.next, (vt = a(At, bt)).done || (_t = a(At, bt)).done || !a(At, bt).done) throw new V("Expected sequence with length 2");
          we(Ye, { key: S(vt.value), value: S(_t.value) });
        }
      else for (var yt in ot) b(ot, yt) && we(Ye, { key: yt, value: S(ot[yt]) });
    },
    parseQuery: function(ot) {
      if (ot)
        for (var Ye = this.entries, Je = gt(ot, "&"), tt = 0, kt, Ft; tt < Je.length; )
          kt = Je[tt++], kt.length && (Ft = gt(kt, "="), we(Ye, {
            key: Ot(Fe(Ft)),
            value: Ot(Ce(Ft, "="))
          }));
    },
    serialize: function() {
      for (var ot = this.entries, Ye = [], Je = 0, tt; Je < ot.length; )
        tt = ot[Je++], we(Ye, Jt(tt.key) + "=" + Jt(tt.value));
      return Ce(Ye, "&");
    },
    update: function() {
      this.entries.length = 0, this.parseQuery(this.url.query);
    },
    updateURL: function() {
      this.url && this.url.update();
    }
  };
  var ie = function() {
    g(this, Ie);
    var Ye = arguments.length > 0 ? arguments[0] : void 0, Je = G(this, new re(Ye));
    o || (this.size = Je.entries.length);
  }, Ie = ie.prototype;
  if (u(Ie, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function(Ye, Je) {
      var tt = H(this);
      N(arguments.length, 2), we(tt.entries, { key: S(Ye), value: S(Je) }), o || this.length++, tt.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    delete: function(ot) {
      for (var Ye = H(this), Je = N(arguments.length, 1), tt = Ye.entries, kt = S(ot), Ft = Je < 2 ? void 0 : arguments[1], bt = Ft === void 0 ? Ft : S(Ft), At = 0; At < tt.length; ) {
        var vt = tt[At];
        if (vt.key === kt && (bt === void 0 || vt.value === bt)) {
          if (it(tt, At, 1), bt !== void 0) break;
        } else At++;
      }
      o || (this.size = tt.length), Ye.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function(Ye) {
      var Je = H(this).entries;
      N(arguments.length, 1);
      for (var tt = S(Ye), kt = 0; kt < Je.length; kt++)
        if (Je[kt].key === tt) return Je[kt].value;
      return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function(Ye) {
      var Je = H(this).entries;
      N(arguments.length, 1);
      for (var tt = S(Ye), kt = [], Ft = 0; Ft < Je.length; Ft++)
        Je[Ft].key === tt && we(kt, Je[Ft].value);
      return kt;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function(Ye) {
      for (var Je = H(this).entries, tt = N(arguments.length, 1), kt = S(Ye), Ft = tt < 2 ? void 0 : arguments[1], bt = Ft === void 0 ? Ft : S(Ft), At = 0; At < Je.length; ) {
        var vt = Je[At++];
        if (vt.key === kt && (bt === void 0 || vt.value === bt)) return !0;
      }
      return !1;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function(Ye, Je) {
      var tt = H(this);
      N(arguments.length, 1);
      for (var kt = tt.entries, Ft = !1, bt = S(Ye), At = S(Je), vt = 0, _t; vt < kt.length; vt++)
        _t = kt[vt], _t.key === bt && (Ft ? it(kt, vt--, 1) : (Ft = !0, _t.value = At));
      Ft || we(kt, { key: bt, value: At }), o || (this.size = kt.length), tt.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function() {
      var Ye = H(this);
      m(Ye.entries, function(Je, tt) {
        return Je.key > tt.key ? 1 : -1;
      }), Ye.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function(Ye) {
      for (var Je = H(this).entries, tt = w(Ye, arguments.length > 1 ? arguments[1] : void 0), kt = 0, Ft; kt < Je.length; )
        Ft = Je[kt++], tt(Ft.value, Ft.key, this);
    },
    // `URLSearchParams.prototype.keys` method
    keys: function() {
      return new ne(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function() {
      return new ne(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function() {
      return new ne(this, "entries");
    }
  }, { enumerable: !0 }), l(Ie, v, Ie.entries, { name: "entries" }), l(Ie, "toString", function() {
    return H(this).serialize();
  }, { enumerable: !0 }), o && c(Ie, "size", {
    get: function() {
      return H(this).entries.length;
    },
    configurable: !0,
    enumerable: !0
  }), f(ie, k), t({ global: !0, constructor: !0, forced: !s }, {
    URLSearchParams: ie
  }), !s && y(W)) {
    var Ke = i(Z.has), Le = i(Z.set), Ge = function(ot) {
      if (x(ot)) {
        var Ye = ot.body, Je;
        if (_(Ye) === k)
          return Je = ot.headers ? new W(ot.headers) : new W(), Ke(Je, "content-type") || Le(Je, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), A(ot, {
            body: I(0, S(Ye)),
            headers: I(0, Je)
          });
      }
      return ot;
    };
    if (y(F) && t({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
      fetch: function(Ye) {
        return F(Ye, arguments.length > 1 ? Ge(arguments[1]) : {});
      }
    }), y(z)) {
      var ft = function(Ye) {
        return g(this, U), new z(Ye, arguments.length > 1 ? Ge(arguments[1]) : {});
      };
      U.constructor = ft, ft.prototype = U, t({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
        Request: ft
      });
    }
  }
  return lie = {
    URLSearchParams: ie,
    getState: H
  }, lie;
}
var X$e;
function sqr() {
  if (X$e) return V$e;
  X$e = 1, h6();
  var t = Ya(), e = Go(), r = n2t(), n = wi(), a = gg(), i = Wa(), o = Gu(), s = ep(), l = Uy(), c = Es(), u = Xrt(), f = rrt(), h = Qh(), p = Pme().codeAt, g = iqr(), y = Vl(), b = tp(), w = kme(), _ = a2t(), C = _0(), x = C.set, S = C.getterFor("URL"), A = _.URLSearchParams, I = _.getState, M = n.URL, B = n.TypeError, L = n.parseInt, N = Math.floor, d = Math.pow, m = i("".charAt), v = i(/./.exec), k = i([].join), O = i(1 .toString), G = i([].pop), H = i([].push), j = i("".replace), F = i([].shift), z = i("".split), W = i("".slice), U = i("".toLowerCase), Z = i([].unshift), V = "Invalid authority", Y = "Invalid scheme", ge = "Invalid host", ce = "Invalid port", ee = /[a-z]/i, Se = /[\d+-.a-z]/i, Ce = /\d/, we = /^0x/i, We = /^[0-7]+$/, Fe = /^\d+$/, it = /^[\da-f]+$/i, gt = /[\0\t\n\r #%/:<>?@[\\\]^|]/, Ze = /[\0\t\n\r #/:<>?@[\\\]^|]/, Ne = /^[\u0000-\u0020]+/, ze = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, ct = /[\t\n\r]/g, rt, qe = function(Pt) {
    var or = z(Pt, "."), Ht, Mt, Qt, pn, Kr, Da, La;
    if (or.length && or[or.length - 1] === "" && or.length--, Ht = or.length, Ht > 4) return Pt;
    for (Mt = [], Qt = 0; Qt < Ht; Qt++) {
      if (pn = or[Qt], pn === "") return Pt;
      if (Kr = 10, pn.length > 1 && m(pn, 0) === "0" && (Kr = v(we, pn) ? 16 : 8, pn = W(pn, Kr === 8 ? 1 : 2)), pn === "")
        Da = 0;
      else {
        if (!v(Kr === 10 ? Fe : Kr === 8 ? We : it, pn)) return Pt;
        Da = L(pn, Kr);
      }
      H(Mt, Da);
    }
    for (Qt = 0; Qt < Ht; Qt++)
      if (Da = Mt[Qt], Qt === Ht - 1) {
        if (Da >= d(256, 5 - Ht)) return null;
      } else if (Da > 255) return null;
    for (La = G(Mt), Qt = 0; Qt < Mt.length; Qt++)
      La += Mt[Qt] * d(256, 3 - Qt);
    return La;
  }, nt = function(Pt) {
    var or = [0, 0, 0, 0, 0, 0, 0, 0], Ht = 0, Mt = null, Qt = 0, pn, Kr, Da, La, ji, Zo, kr, qi = function() {
      return m(Pt, Qt);
    };
    if (qi() === ":") {
      if (m(Pt, 1) !== ":") return;
      Qt += 2, Ht++, Mt = Ht;
    }
    for (; qi(); ) {
      if (Ht === 8) return;
      if (qi() === ":") {
        if (Mt !== null) return;
        Qt++, Ht++, Mt = Ht;
        continue;
      }
      for (pn = Kr = 0; Kr < 4 && v(it, qi()); )
        pn = pn * 16 + L(qi(), 16), Qt++, Kr++;
      if (qi() === ".") {
        if (Kr === 0 || (Qt -= Kr, Ht > 6)) return;
        for (Da = 0; qi(); ) {
          if (La = null, Da > 0)
            if (qi() === "." && Da < 4) Qt++;
            else return;
          if (!v(Ce, qi())) return;
          for (; v(Ce, qi()); ) {
            if (ji = L(qi(), 10), La === null) La = ji;
            else {
              if (La === 0) return;
              La = La * 10 + ji;
            }
            if (La > 255) return;
            Qt++;
          }
          or[Ht] = or[Ht] * 256 + La, Da++, (Da === 2 || Da === 4) && Ht++;
        }
        if (Da !== 4) return;
        break;
      } else if (qi() === ":") {
        if (Qt++, !qi()) return;
      } else if (qi()) return;
      or[Ht++] = pn;
    }
    if (Mt !== null)
      for (Zo = Ht - Mt, Ht = 7; Ht !== 0 && Zo > 0; )
        kr = or[Ht], or[Ht--] = or[Mt + Zo - 1], or[Mt + --Zo] = kr;
    else if (Ht !== 8) return;
    return or;
  }, Rt = function(Pt) {
    for (var or = null, Ht = 1, Mt = null, Qt = 0, pn = 0; pn < 8; pn++)
      Pt[pn] !== 0 ? (Qt > Ht && (or = Mt, Ht = Qt), Mt = null, Qt = 0) : (Mt === null && (Mt = pn), ++Qt);
    return Qt > Ht ? Mt : or;
  }, Ot = function(Pt) {
    var or, Ht, Mt, Qt;
    if (typeof Pt == "number") {
      for (or = [], Ht = 0; Ht < 4; Ht++)
        Z(or, Pt % 256), Pt = N(Pt / 256);
      return k(or, ".");
    }
    if (typeof Pt == "object") {
      for (or = "", Mt = Rt(Pt), Ht = 0; Ht < 8; Ht++)
        Qt && Pt[Ht] === 0 || (Qt && (Qt = !1), Mt === Ht ? (or += Ht ? ":" : "::", Qt = !0) : (or += O(Pt[Ht], 16), Ht < 7 && (or += ":")));
      return "[" + or + "]";
    }
    return Pt;
  }, lt = {}, mt = u({}, lt, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
  }), jt = u({}, mt, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
  }), Jt = u({}, jt, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
  }), ne = function(Pt, or) {
    var Ht = p(Pt, 0);
    return Ht > 32 && Ht < 127 && !c(or, Pt) ? Pt : encodeURIComponent(Pt);
  }, re = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
  }, ie = function(Pt, or) {
    var Ht;
    return Pt.length === 2 && v(ee, m(Pt, 0)) && ((Ht = m(Pt, 1)) === ":" || !or && Ht === "|");
  }, Ie = function(Pt) {
    var or;
    return Pt.length > 1 && ie(W(Pt, 0, 2)) && (Pt.length === 2 || (or = m(Pt, 2)) === "/" || or === "\\" || or === "?" || or === "#");
  }, Ke = function(Pt) {
    return Pt === "." || U(Pt) === "%2e";
  }, Le = function(Pt) {
    return Pt = U(Pt), Pt === ".." || Pt === "%2e." || Pt === ".%2e" || Pt === "%2e%2e";
  }, Ge = {}, ft = {}, ot = {}, Ye = {}, Je = {}, tt = {}, kt = {}, Ft = {}, bt = {}, At = {}, vt = {}, _t = {}, yt = {}, xr = {}, dr = {}, Er = {}, gr = {}, pr = {}, Xr = {}, Yr = {}, at = {}, Vt = function(Pt, or, Ht) {
    var Mt = y(Pt), Qt, pn, Kr;
    if (or) {
      if (pn = this.parse(Mt), pn) throw new B(pn);
      this.searchParams = null;
    } else {
      if (Ht !== void 0 && (Qt = new Vt(Ht, !0)), pn = this.parse(Mt, null, Qt), pn) throw new B(pn);
      Kr = I(new A()), Kr.bindURL(this), this.searchParams = Kr;
    }
  };
  Vt.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(Pt, or, Ht) {
      var Mt = this, Qt = or || Ge, pn = 0, Kr = "", Da = !1, La = !1, ji = !1, Zo, kr, qi, vi;
      for (Pt = y(Pt), or || (Mt.scheme = "", Mt.username = "", Mt.password = "", Mt.host = null, Mt.port = null, Mt.path = [], Mt.query = null, Mt.fragment = null, Mt.cannotBeABaseURL = !1, Pt = j(Pt, Ne, ""), Pt = j(Pt, ze, "$1")), Pt = j(Pt, ct, ""), Zo = f(Pt); pn <= Zo.length; ) {
        switch (kr = Zo[pn], Qt) {
          case Ge:
            if (kr && v(ee, kr))
              Kr += U(kr), Qt = ft;
            else {
              if (or)
                return Y;
              Qt = ot;
              continue;
            }
            break;
          case ft:
            if (kr && (v(Se, kr) || kr === "+" || kr === "-" || kr === "."))
              Kr += U(kr);
            else if (kr === ":") {
              if (or && (Mt.isSpecial() !== c(re, Kr) || Kr === "file" && (Mt.includesCredentials() || Mt.port !== null) || Mt.scheme === "file" && !Mt.host)) return;
              if (Mt.scheme = Kr, or) {
                Mt.isSpecial() && re[Mt.scheme] === Mt.port && (Mt.port = null);
                return;
              }
              Kr = "", Mt.scheme === "file" ? Qt = xr : Mt.isSpecial() && Ht && Ht.scheme === Mt.scheme ? Qt = Ye : Mt.isSpecial() ? Qt = Ft : Zo[pn + 1] === "/" ? (Qt = Je, pn++) : (Mt.cannotBeABaseURL = !0, H(Mt.path, ""), Qt = Xr);
            } else {
              if (or)
                return Y;
              Kr = "", Qt = ot, pn = 0;
              continue;
            }
            break;
          case ot:
            if (!Ht || Ht.cannotBeABaseURL && kr !== "#") return Y;
            if (Ht.cannotBeABaseURL && kr === "#") {
              Mt.scheme = Ht.scheme, Mt.path = h(Ht.path), Mt.query = Ht.query, Mt.fragment = "", Mt.cannotBeABaseURL = !0, Qt = at;
              break;
            }
            Qt = Ht.scheme === "file" ? xr : tt;
            continue;
          case Ye:
            if (kr === "/" && Zo[pn + 1] === "/")
              Qt = bt, pn++;
            else {
              Qt = tt;
              continue;
            }
            break;
          case Je:
            if (kr === "/") {
              Qt = At;
              break;
            } else {
              Qt = pr;
              continue;
            }
          case tt:
            if (Mt.scheme = Ht.scheme, kr === rt)
              Mt.username = Ht.username, Mt.password = Ht.password, Mt.host = Ht.host, Mt.port = Ht.port, Mt.path = h(Ht.path), Mt.query = Ht.query;
            else if (kr === "/" || kr === "\\" && Mt.isSpecial())
              Qt = kt;
            else if (kr === "?")
              Mt.username = Ht.username, Mt.password = Ht.password, Mt.host = Ht.host, Mt.port = Ht.port, Mt.path = h(Ht.path), Mt.query = "", Qt = Yr;
            else if (kr === "#")
              Mt.username = Ht.username, Mt.password = Ht.password, Mt.host = Ht.host, Mt.port = Ht.port, Mt.path = h(Ht.path), Mt.query = Ht.query, Mt.fragment = "", Qt = at;
            else {
              Mt.username = Ht.username, Mt.password = Ht.password, Mt.host = Ht.host, Mt.port = Ht.port, Mt.path = h(Ht.path), Mt.path.length--, Qt = pr;
              continue;
            }
            break;
          case kt:
            if (Mt.isSpecial() && (kr === "/" || kr === "\\"))
              Qt = bt;
            else if (kr === "/")
              Qt = At;
            else {
              Mt.username = Ht.username, Mt.password = Ht.password, Mt.host = Ht.host, Mt.port = Ht.port, Qt = pr;
              continue;
            }
            break;
          case Ft:
            if (Qt = bt, kr !== "/" || m(Kr, pn + 1) !== "/") continue;
            pn++;
            break;
          case bt:
            if (kr !== "/" && kr !== "\\") {
              Qt = At;
              continue;
            }
            break;
          case At:
            if (kr === "@") {
              Da && (Kr = "%40" + Kr), Da = !0, qi = f(Kr);
              for (var Ho = 0; Ho < qi.length; Ho++) {
                var Ec = qi[Ho];
                if (Ec === ":" && !ji) {
                  ji = !0;
                  continue;
                }
                var Uu = ne(Ec, Jt);
                ji ? Mt.password += Uu : Mt.username += Uu;
              }
              Kr = "";
            } else if (kr === rt || kr === "/" || kr === "?" || kr === "#" || kr === "\\" && Mt.isSpecial()) {
              if (Da && Kr === "") return V;
              pn -= f(Kr).length + 1, Kr = "", Qt = vt;
            } else Kr += kr;
            break;
          case vt:
          case _t:
            if (or && Mt.scheme === "file") {
              Qt = Er;
              continue;
            } else if (kr === ":" && !La) {
              if (Kr === "") return ge;
              if (vi = Mt.parseHost(Kr), vi) return vi;
              if (Kr = "", Qt = yt, or === _t) return;
            } else if (kr === rt || kr === "/" || kr === "?" || kr === "#" || kr === "\\" && Mt.isSpecial()) {
              if (Mt.isSpecial() && Kr === "") return ge;
              if (or && Kr === "" && (Mt.includesCredentials() || Mt.port !== null)) return;
              if (vi = Mt.parseHost(Kr), vi) return vi;
              if (Kr = "", Qt = gr, or) return;
              continue;
            } else
              kr === "[" ? La = !0 : kr === "]" && (La = !1), Kr += kr;
            break;
          case yt:
            if (v(Ce, kr))
              Kr += kr;
            else if (kr === rt || kr === "/" || kr === "?" || kr === "#" || kr === "\\" && Mt.isSpecial() || or) {
              if (Kr !== "") {
                var Ic = L(Kr, 10);
                if (Ic > 65535) return ce;
                Mt.port = Mt.isSpecial() && Ic === re[Mt.scheme] ? null : Ic, Kr = "";
              }
              if (or) return;
              Qt = gr;
              continue;
            } else return ce;
            break;
          case xr:
            if (Mt.scheme = "file", kr === "/" || kr === "\\") Qt = dr;
            else if (Ht && Ht.scheme === "file")
              switch (kr) {
                case rt:
                  Mt.host = Ht.host, Mt.path = h(Ht.path), Mt.query = Ht.query;
                  break;
                case "?":
                  Mt.host = Ht.host, Mt.path = h(Ht.path), Mt.query = "", Qt = Yr;
                  break;
                case "#":
                  Mt.host = Ht.host, Mt.path = h(Ht.path), Mt.query = Ht.query, Mt.fragment = "", Qt = at;
                  break;
                default:
                  Ie(k(h(Zo, pn), "")) || (Mt.host = Ht.host, Mt.path = h(Ht.path), Mt.shortenPath()), Qt = pr;
                  continue;
              }
            else {
              Qt = pr;
              continue;
            }
            break;
          case dr:
            if (kr === "/" || kr === "\\") {
              Qt = Er;
              break;
            }
            Ht && Ht.scheme === "file" && !Ie(k(h(Zo, pn), "")) && (ie(Ht.path[0], !0) ? H(Mt.path, Ht.path[0]) : Mt.host = Ht.host), Qt = pr;
            continue;
          case Er:
            if (kr === rt || kr === "/" || kr === "\\" || kr === "?" || kr === "#") {
              if (!or && ie(Kr))
                Qt = pr;
              else if (Kr === "") {
                if (Mt.host = "", or) return;
                Qt = gr;
              } else {
                if (vi = Mt.parseHost(Kr), vi) return vi;
                if (Mt.host === "localhost" && (Mt.host = ""), or) return;
                Kr = "", Qt = gr;
              }
              continue;
            } else Kr += kr;
            break;
          case gr:
            if (Mt.isSpecial()) {
              if (Qt = pr, kr !== "/" && kr !== "\\") continue;
            } else if (!or && kr === "?")
              Mt.query = "", Qt = Yr;
            else if (!or && kr === "#")
              Mt.fragment = "", Qt = at;
            else if (kr !== rt && (Qt = pr, kr !== "/"))
              continue;
            break;
          case pr:
            if (kr === rt || kr === "/" || kr === "\\" && Mt.isSpecial() || !or && (kr === "?" || kr === "#")) {
              if (Le(Kr) ? (Mt.shortenPath(), kr !== "/" && !(kr === "\\" && Mt.isSpecial()) && H(Mt.path, "")) : Ke(Kr) ? kr !== "/" && !(kr === "\\" && Mt.isSpecial()) && H(Mt.path, "") : (Mt.scheme === "file" && !Mt.path.length && ie(Kr) && (Mt.host && (Mt.host = ""), Kr = m(Kr, 0) + ":"), H(Mt.path, Kr)), Kr = "", Mt.scheme === "file" && (kr === rt || kr === "?" || kr === "#"))
                for (; Mt.path.length > 1 && Mt.path[0] === ""; )
                  F(Mt.path);
              kr === "?" ? (Mt.query = "", Qt = Yr) : kr === "#" && (Mt.fragment = "", Qt = at);
            } else
              Kr += ne(kr, jt);
            break;
          case Xr:
            kr === "?" ? (Mt.query = "", Qt = Yr) : kr === "#" ? (Mt.fragment = "", Qt = at) : kr !== rt && (Mt.path[0] += ne(kr, lt));
            break;
          case Yr:
            !or && kr === "#" ? (Mt.fragment = "", Qt = at) : kr !== rt && (kr === "'" && Mt.isSpecial() ? Mt.query += "%27" : kr === "#" ? Mt.query += "%23" : Mt.query += ne(kr, lt));
            break;
          case at:
            kr !== rt && (Mt.fragment += ne(kr, mt));
            break;
        }
        pn++;
      }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(Pt) {
      var or, Ht, Mt;
      if (m(Pt, 0) === "[") {
        if (m(Pt, Pt.length - 1) !== "]" || (or = nt(W(Pt, 1, -1)), !or)) return ge;
        this.host = or;
      } else if (this.isSpecial()) {
        if (Pt = g(Pt), v(gt, Pt) || (or = qe(Pt), or === null)) return ge;
        this.host = or;
      } else {
        if (v(Ze, Pt)) return ge;
        for (or = "", Ht = f(Pt), Mt = 0; Mt < Ht.length; Mt++)
          or += ne(Ht[Mt], lt);
        this.host = or;
      }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
      return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
      return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
      return c(re, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
      var Pt = this.path, or = Pt.length;
      or && (this.scheme !== "file" || or !== 1 || !ie(Pt[0], !0)) && Pt.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
      var Pt = this, or = Pt.scheme, Ht = Pt.username, Mt = Pt.password, Qt = Pt.host, pn = Pt.port, Kr = Pt.path, Da = Pt.query, La = Pt.fragment, ji = or + ":";
      return Qt !== null ? (ji += "//", Pt.includesCredentials() && (ji += Ht + (Mt ? ":" + Mt : "") + "@"), ji += Ot(Qt), pn !== null && (ji += ":" + pn)) : or === "file" && (ji += "//"), ji += Pt.cannotBeABaseURL ? Kr[0] : Kr.length ? "/" + k(Kr, "/") : "", Da !== null && (ji += "?" + Da), La !== null && (ji += "#" + La), ji;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(Pt) {
      var or = this.parse(Pt);
      if (or) throw new B(or);
      this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
      var Pt = this.scheme, or = this.port;
      if (Pt === "blob") try {
        return new er(Pt.path[0]).origin;
      } catch {
        return "null";
      }
      return Pt === "file" || !this.isSpecial() ? "null" : Pt + "://" + Ot(this.host) + (or !== null ? ":" + or : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
      return this.scheme + ":";
    },
    setProtocol: function(Pt) {
      this.parse(y(Pt) + ":", Ge);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
      return this.username;
    },
    setUsername: function(Pt) {
      var or = f(y(Pt));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.username = "";
        for (var Ht = 0; Ht < or.length; Ht++)
          this.username += ne(or[Ht], Jt);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
      return this.password;
    },
    setPassword: function(Pt) {
      var or = f(y(Pt));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.password = "";
        for (var Ht = 0; Ht < or.length; Ht++)
          this.password += ne(or[Ht], Jt);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
      var Pt = this.host, or = this.port;
      return Pt === null ? "" : or === null ? Ot(Pt) : Ot(Pt) + ":" + or;
    },
    setHost: function(Pt) {
      this.cannotBeABaseURL || this.parse(Pt, vt);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
      var Pt = this.host;
      return Pt === null ? "" : Ot(Pt);
    },
    setHostname: function(Pt) {
      this.cannotBeABaseURL || this.parse(Pt, _t);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
      var Pt = this.port;
      return Pt === null ? "" : y(Pt);
    },
    setPort: function(Pt) {
      this.cannotHaveUsernamePasswordPort() || (Pt = y(Pt), Pt === "" ? this.port = null : this.parse(Pt, yt));
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
      var Pt = this.path;
      return this.cannotBeABaseURL ? Pt[0] : Pt.length ? "/" + k(Pt, "/") : "";
    },
    setPathname: function(Pt) {
      this.cannotBeABaseURL || (this.path = [], this.parse(Pt, gr));
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
      var Pt = this.query;
      return Pt ? "?" + Pt : "";
    },
    setSearch: function(Pt) {
      Pt = y(Pt), Pt === "" ? this.query = null : (m(Pt, 0) === "?" && (Pt = W(Pt, 1)), this.query = "", this.parse(Pt, Yr)), this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
      return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
      var Pt = this.fragment;
      return Pt ? "#" + Pt : "";
    },
    setHash: function(Pt) {
      if (Pt = y(Pt), Pt === "") {
        this.fragment = null;
        return;
      }
      m(Pt, 0) === "#" && (Pt = W(Pt, 1)), this.fragment = "", this.parse(Pt, at);
    },
    update: function() {
      this.query = this.searchParams.serialize() || null;
    }
  };
  var er = function(or) {
    var Ht = l(this, fr), Mt = w(arguments.length, 1) > 1 ? arguments[1] : void 0, Qt = x(Ht, new Vt(or, !1, Mt));
    e || (Ht.href = Qt.serialize(), Ht.origin = Qt.getOrigin(), Ht.protocol = Qt.getProtocol(), Ht.username = Qt.getUsername(), Ht.password = Qt.getPassword(), Ht.host = Qt.getHost(), Ht.hostname = Qt.getHostname(), Ht.port = Qt.getPort(), Ht.pathname = Qt.getPathname(), Ht.search = Qt.getSearch(), Ht.searchParams = Qt.getSearchParams(), Ht.hash = Qt.getHash());
  }, fr = er.prototype, tn = function(Pt, or) {
    return {
      get: function() {
        return S(this)[Pt]();
      },
      set: or && function(Ht) {
        return S(this)[or](Ht);
      },
      configurable: !0,
      enumerable: !0
    };
  };
  if (e && (s(fr, "href", tn("serialize", "setHref")), s(fr, "origin", tn("getOrigin")), s(fr, "protocol", tn("getProtocol", "setProtocol")), s(fr, "username", tn("getUsername", "setUsername")), s(fr, "password", tn("getPassword", "setPassword")), s(fr, "host", tn("getHost", "setHost")), s(fr, "hostname", tn("getHostname", "setHostname")), s(fr, "port", tn("getPort", "setPort")), s(fr, "pathname", tn("getPathname", "setPathname")), s(fr, "search", tn("getSearch", "setSearch")), s(fr, "searchParams", tn("getSearchParams")), s(fr, "hash", tn("getHash", "setHash"))), o(fr, "toJSON", function() {
    return S(this).serialize();
  }, { enumerable: !0 }), o(fr, "toString", function() {
    return S(this).serialize();
  }, { enumerable: !0 }), M) {
    var Kn = M.createObjectURL, Pr = M.revokeObjectURL;
    Kn && o(er, "createObjectURL", a(Kn, M)), Pr && o(er, "revokeObjectURL", a(Pr, M));
  }
  return b(er, "URL"), t({ global: !0, constructor: !0, forced: !r, sham: !e }, {
    URL: er
  }), V$e;
}
var Q$e;
function lqr() {
  return Q$e || (Q$e = 1, sqr()), U$e;
}
var eDe = {}, tDe;
function cqr() {
  return tDe || (tDe = 1, a2t()), eDe;
}
/*
@license
Copyright (c) 2018, Twilio, Inc.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY
SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION
OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.

*/
var rDe;
function uqr() {
  return rDe || (rDe = 1, function(t) {
    var e = typeof e < "u" ? e : typeof self < "u" ? self : typeof window < "u" ? window : {};
    Object.defineProperty(t, "__esModule", { value: !0 }), G8(), s6();
    var r = zy(), n = Gy(), a = Wy(), i = Hy(), o = np(), s = nW(), l = c6();
    u6(), d6(), vg(), VM(), h6(), H8();
    var c = OM(), u = FM();
    f6(), jG(), PM();
    var f = rp();
    U8();
    var h = V8();
    r2t(), MM(), p6(), Krt(), rW(), WM(), UG(), $G(), Hme(), lqr(), cqr();
    var p = UM(), g = HM();
    function y(bt) {
      return bt && typeof bt == "object" && "default" in bt ? bt : { default: bt };
    }
    function b(bt) {
      if (bt && bt.__esModule) return bt;
      var At = /* @__PURE__ */ Object.create(null);
      return bt && Object.keys(bt).forEach(function(vt) {
        if (vt !== "default") {
          var _t = Object.getOwnPropertyDescriptor(bt, vt);
          Object.defineProperty(At, vt, _t.get ? _t : {
            enumerable: !0,
            get: function() {
              return bt[vt];
            }
          });
        }
      }), At.default = bt, Object.freeze(At);
    }
    var w = /* @__PURE__ */ y(r), _ = /* @__PURE__ */ y(n), C = /* @__PURE__ */ y(a), x = /* @__PURE__ */ y(i), S = /* @__PURE__ */ y(o), A = /* @__PURE__ */ y(s), I = /* @__PURE__ */ y(l), M = /* @__PURE__ */ y(c), B = /* @__PURE__ */ y(u), L = /* @__PURE__ */ y(f), N = /* @__PURE__ */ b(h), d = { exports: {} }, m = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (m) {
      var v = new Uint8Array(16);
      d.exports = function() {
        return m(v), v;
      };
    } else {
      var k = new Array(16);
      d.exports = function() {
        for (var At = 0, vt; At < 16; At++)
          At & 3 || (vt = Math.random() * 4294967296), k[At] = vt >>> ((At & 3) << 3) & 255;
        return k;
      };
    }
    for (var O = [], G = 0; G < 256; ++G)
      O[G] = (G + 256).toString(16).substr(1);
    function H(bt, At) {
      var vt = At || 0, _t = O;
      return [_t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]], "-", _t[bt[vt++]], _t[bt[vt++]], "-", _t[bt[vt++]], _t[bt[vt++]], "-", _t[bt[vt++]], _t[bt[vt++]], "-", _t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]], _t[bt[vt++]]].join("");
    }
    var j = H, F = d.exports, z = j, W, U, Z = 0, V = 0;
    function Y(bt, At, vt) {
      var _t = At && vt || 0, yt = At || [];
      bt = bt || {};
      var xr = bt.node || W, dr = bt.clockseq !== void 0 ? bt.clockseq : U;
      if (xr == null || dr == null) {
        var Er = F();
        xr == null && (xr = W = [Er[0] | 1, Er[1], Er[2], Er[3], Er[4], Er[5]]), dr == null && (dr = U = (Er[6] << 8 | Er[7]) & 16383);
      }
      var gr = bt.msecs !== void 0 ? bt.msecs : (/* @__PURE__ */ new Date()).getTime(), pr = bt.nsecs !== void 0 ? bt.nsecs : V + 1, Xr = gr - Z + (pr - V) / 1e4;
      if (Xr < 0 && bt.clockseq === void 0 && (dr = dr + 1 & 16383), (Xr < 0 || gr > Z) && bt.nsecs === void 0 && (pr = 0), pr >= 1e4)
        throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
      Z = gr, V = pr, U = dr, gr += 122192928e5;
      var Yr = ((gr & 268435455) * 1e4 + pr) % 4294967296;
      yt[_t++] = Yr >>> 24 & 255, yt[_t++] = Yr >>> 16 & 255, yt[_t++] = Yr >>> 8 & 255, yt[_t++] = Yr & 255;
      var at = gr / 4294967296 * 1e4 & 268435455;
      yt[_t++] = at >>> 8 & 255, yt[_t++] = at & 255, yt[_t++] = at >>> 24 & 15 | 16, yt[_t++] = at >>> 16 & 255, yt[_t++] = dr >>> 8 | 128, yt[_t++] = dr & 255;
      for (var Vt = 0; Vt < 6; ++Vt)
        yt[_t + Vt] = xr[Vt];
      return At || z(yt);
    }
    var ge = Y, ce = d.exports, ee = j;
    function Se(bt, At, vt) {
      var _t = At && vt || 0;
      typeof bt == "string" && (At = bt === "binary" ? new Array(16) : null, bt = null), bt = bt || {};
      var yt = bt.random || (bt.rng || ce)();
      if (yt[6] = yt[6] & 15 | 64, yt[8] = yt[8] & 63 | 128, At)
        for (var xr = 0; xr < 16; ++xr)
          At[_t + xr] = yt[xr];
      return At || ee(yt);
    }
    var Ce = Se, we = ge, We = Ce, Fe = We;
    Fe.v1 = we, Fe.v4 = We;
    var it = Fe;
    function gt(bt) {
      var At = Ze();
      return function() {
        var _t = S.default(bt), yt;
        if (At) {
          var xr = S.default(this).constructor;
          yt = Reflect.construct(_t, arguments, xr);
        } else
          yt = _t.apply(this, arguments);
        return x.default(this, yt);
      };
    }
    function Ze() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ne = /* @__PURE__ */ function(bt) {
      C.default(vt, bt);
      var At = gt(vt);
      function vt(_t) {
        var yt;
        w.default(this, vt);
        var xr = it.v4(), dr;
        return yt = At.call(this, function(Er, gr) {
          return dr = gr, _t(function(pr) {
            vt.cancellationMap.delete(xr), Er(pr);
          }, function(pr) {
            vt.cancellationMap.delete(xr), gr(pr);
          }, function(pr) {
            vt.cancellationMap.set(xr, pr);
          });
        }), yt.id = xr, yt.rejectPromise = dr, yt;
      }
      return _.default(vt, [{
        key: "cancel",
        value: function() {
          var yt = vt.cancellationMap.get(this.id);
          return yt == null || yt(), this.rejectPromise && (this.catch(function() {
          }), this.rejectPromise(new Error("Promise was cancelled"))), this;
        }
      }]), vt;
    }(/* @__PURE__ */ A.default(Promise));
    I.default(Ne, "cancellationMap", /* @__PURE__ */ new Map());
    function ze(bt, At, vt, _t) {
      var yt = arguments.length, xr = yt < 3 ? At : _t === null ? _t = Object.getOwnPropertyDescriptor(At, vt) : _t, dr;
      if ((typeof Reflect > "u" ? "undefined" : L.default(Reflect)) === "object" && typeof Reflect.decorate == "function") xr = Reflect.decorate(bt, At, vt, _t);
      else for (var Er = bt.length - 1; Er >= 0; Er--)
        (dr = bt[Er]) && (xr = (yt < 3 ? dr(xr) : yt > 3 ? dr(At, vt, xr) : dr(At, vt)) || xr);
      return yt > 3 && xr && Object.defineProperty(At, vt, xr), xr;
    }
    function ct(bt, At) {
      if ((typeof Reflect > "u" ? "undefined" : L.default(Reflect)) === "object" && typeof Reflect.metadata == "function") return Reflect.metadata(bt, At);
    }
    function rt(bt, At) {
      return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " MCS Client ").concat(bt, ":")].concat(Array.from(At));
    }
    var qe = /* @__PURE__ */ function() {
      function bt(At) {
        w.default(this, bt), I.default(this, "prefix", ""), this.prefix = At != null && At.length > 0 ? At + " " : "";
      }
      return _.default(bt, [{
        key: "setLevel",
        value: function(vt) {
          N.setLevel(vt);
        }
      }, {
        key: "trace",
        value: (
          /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
          function() {
            if (N.getLevel() == N.levels.TRACE) {
              for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
                _t[yt] = arguments[yt];
              N.debug.apply(null, rt(this.prefix + "T", _t));
            }
          }
        )
      }, {
        key: "debug",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.debug.apply(null, rt(this.prefix + "D", _t));
        }
      }, {
        key: "info",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.info.apply(null, rt(this.prefix + "I", _t));
        }
      }, {
        key: "warn",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.warn.apply(null, rt(this.prefix + "W", _t));
        }
      }, {
        key: "error",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.error.apply(null, rt(this.prefix + "E", _t));
        }
      }], [{
        key: "scope",
        value: function(vt) {
          return new bt(vt);
        }
      }, {
        key: "setLevel",
        value: function(vt) {
          N.setLevel(vt);
        }
      }, {
        key: "trace",
        value: function() {
          if (N.getLevel() == N.levels.TRACE) {
            for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
              _t[yt] = arguments[yt];
            N.debug.apply(null, rt("T", _t));
          }
        }
      }, {
        key: "debug",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.debug.apply(null, rt("D", _t));
        }
      }, {
        key: "info",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.info.apply(null, rt("I", _t));
        }
      }, {
        key: "warn",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.warn.apply(null, rt("W", _t));
        }
      }, {
        key: "error",
        value: function() {
          for (var vt = arguments.length, _t = new Array(vt), yt = 0; yt < vt; yt++)
            _t[yt] = arguments[yt];
          N.error.apply(null, rt("E", _t));
        }
      }]), bt;
    }(), nt = 1e3, Rt = 4e3, Ot = 3, lt = !0, mt = function(At) {
      return "https://mcs.".concat(At ?? "us1", ".twilio.com");
    }, jt = function(At) {
      return At.startsWith("http");
    }, Jt = function(At, vt) {
      return "".concat(jt(At) ? "" : mt(vt)).concat(At);
    }, ne = /* @__PURE__ */ function() {
      function bt(At, vt, _t, yt) {
        var xr, dr, Er, gr, pr, Xr;
        w.default(this, bt);
        var Yr = (xr = (dr = yt.MCS) !== null && dr !== void 0 ? dr : yt) !== null && xr !== void 0 ? xr : {};
        this.region = (Er = (gr = Yr.region) !== null && gr !== void 0 ? gr : yt.region) !== null && Er !== void 0 ? Er : "us1", this.mediaUrl = Jt(vt, this.region), this.mediaSetUrl = _t ? Jt(_t) : "".concat(this.mediaUrl, "Set"), this.token = At, this.retryWhenThrottledOverride = (pr = Yr.retryWhenThrottledOverride) !== null && pr !== void 0 ? pr : lt, this.backoffConfigOverride = (Xr = Yr.backoffConfigOverride) !== null && Xr !== void 0 ? Xr : bt.backoffConfigDefault;
      }
      return _.default(bt, [{
        key: "updateToken",
        value: function(vt) {
          this.token = vt;
        }
      }], [{
        key: "backoffConfigDefault",
        get: function() {
          return {
            min: nt,
            max: Rt,
            maxAttemptsCount: Ot
          };
        }
      }, {
        key: "retryWhenThrottledDefault",
        get: function() {
          return lt;
        }
      }]), bt;
    }(), re = /* @__PURE__ */ function() {
      function bt(At, vt, _t) {
        w.default(this, bt), this.config = At, this.network = vt, this._update(_t);
      }
      return _.default(bt, [{
        key: "sid",
        get: function() {
          return this.state.sid;
        }
      }, {
        key: "serviceSid",
        get: function() {
          return this.state.serviceSid;
        }
      }, {
        key: "dateCreated",
        get: function() {
          return this.state.dateCreated;
        }
      }, {
        key: "dateUpdated",
        get: function() {
          return this.state.dateUpdated;
        }
      }, {
        key: "contentType",
        get: function() {
          return this.state.contentType;
        }
      }, {
        key: "size",
        get: function() {
          return this.state.size;
        }
        /** @deprecated Use filename instead */
      }, {
        key: "fileName",
        get: function() {
          return this.state.filename;
        }
      }, {
        key: "filename",
        get: function() {
          return this.state.filename;
        }
      }, {
        key: "category",
        get: function() {
          return this.state.category;
        }
        /**
         * Returns direct content URL to uploaded binary. This URL will expire after some time.
         * This function gets a new URL every time, preventing it from expiring but putting additional load on backend.
         * See getCachedContentUrl() for a function that reduces the amount of network requests.
         *
         * It is reasonable to build your own refresh logic upon these two functions: as soon as URL returned
         * by getCachedContentUrl() returns 40x status you should call getContentUrl() to refresh it.
         */
      }, {
        key: "getContentUrl",
        value: function() {
          var vt = this;
          return new Ne(/* @__PURE__ */ function() {
            var _t = M.default(/* @__PURE__ */ B.default.mark(function yt(xr, dr, Er) {
              var gr, pr;
              return B.default.wrap(function(Yr) {
                for (; ; )
                  switch (Yr.prev = Yr.next) {
                    case 0:
                      return gr = vt.network.get("".concat(vt.config.mediaUrl, "/").concat(vt.sid)), Er(function() {
                        return gr.cancel();
                      }), Yr.prev = 2, Yr.next = 5, gr;
                    case 5:
                      pr = Yr.sent, vt._update(pr.body), xr(vt.state.contentDirectUrl), Yr.next = 13;
                      break;
                    case 10:
                      Yr.prev = 10, Yr.t0 = Yr.catch(2), dr(Yr.t0);
                    case 13:
                    case "end":
                      return Yr.stop();
                  }
              }, yt, null, [[2, 10]]);
            }));
            return function(yt, xr, dr) {
              return _t.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "_update",
        value: function(vt) {
          var _t, yt, xr, dr;
          this.state = {
            sid: vt.sid,
            serviceSid: vt.service_sid,
            channelSid: vt.channel_sid,
            messageSid: vt.message_sid,
            dateCreated: vt.date_created ? new Date(vt.date_created) : null,
            dateUploadUpdated: vt.date_upload_updated ? new Date(vt.date_upload_updated) : null,
            dateUpdated: vt.date_updated ? new Date(vt.date_updated) : null,
            size: vt.size,
            contentType: vt.content_type,
            author: vt.author,
            url: vt.url,
            contentUrl: vt.links.content,
            contentDirectUrl: (_t = vt.links.content_direct_temporary) !== null && _t !== void 0 ? _t : null,
            filename: (yt = vt.filename) !== null && yt !== void 0 ? yt : null,
            category: (xr = vt.category) !== null && xr !== void 0 ? xr : "media",
            isMultipartUpstream: (dr = vt.is_multipart_upstream) !== null && dr !== void 0 ? dr : !1
          };
        }
        /**
         * @internal
         * This payload is compatible with Conversations' media object _state().
         */
      }, {
        key: "_state",
        value: function() {
          var vt;
          return {
            sid: this.state.sid,
            category: this.state.category,
            filename: (vt = this.state.filename) !== null && vt !== void 0 ? vt : null,
            contentType: this.state.contentType,
            size: this.state.size
          };
        }
      }]), bt;
    }();
    function ie(bt) {
      var At = Ie();
      return function() {
        var _t = S.default(bt), yt;
        if (At) {
          var xr = S.default(this).constructor;
          yt = Reflect.construct(_t, arguments, xr);
        } else
          yt = _t.apply(this, arguments);
        return x.default(this, yt);
      };
    }
    function Ie() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ke = /* @__PURE__ */ function(bt) {
      C.default(vt, bt);
      var At = ie(vt);
      function vt(_t, yt, xr, dr, Er) {
        var gr;
        return w.default(this, vt), gr = At.call(this, _t), gr.code = yt, gr.body = xr, gr.status = dr, gr.headers = Er, gr;
      }
      return _.default(vt);
    }(/* @__PURE__ */ A.default(Error)), Le = e.XMLHttpRequest || {};
    function Ge(bt) {
      return bt ? bt.split(`\r
`).map(function(At) {
        return At.split(": ");
      }).filter(function(At) {
        return At.length === 2 && At[1].length > 0;
      }).reduce(function(At, vt) {
        return At[vt[0]] = vt[1], At;
      }, {}) : {};
    }
    function ft(bt) {
      var At = bt.getResponseHeader("Content-Type");
      if (!At || At.indexOf("application/json") !== 0 || bt.responseText.length === 0)
        return bt.responseText;
      try {
        return JSON.parse(bt.responseText);
      } catch {
        return bt.responseText;
      }
    }
    var ot = /* @__PURE__ */ function() {
      function bt() {
        w.default(this, bt);
      }
      return _.default(bt, [{
        key: "get",
        value: (
          /**
           * Make a GET request by given URL
           */
          function(vt, _t) {
            return bt.request("GET", vt, _t);
          }
        )
        /**
         * Make a POST request by given URL
         */
      }, {
        key: "post",
        value: function(vt, _t, yt) {
          return bt.request("POST", vt, _t, yt);
        }
      }], [{
        key: "request",
        value: function(vt, _t, yt, xr) {
          return new Ne(function(dr, Er, gr) {
            var pr = new Le(), Xr = !1;
            gr(function() {
              pr.abort(), Xr = !0;
            }), pr.open(vt, _t, !0), pr.onreadystatechange = function() {
              if (!(pr.readyState !== 4 || Xr)) {
                var Vt = Ge(pr.getAllResponseHeaders()), er = ft(pr);
                if (200 <= pr.status && pr.status < 300)
                  dr({
                    status: pr.status,
                    headers: Vt,
                    body: er
                  });
                else {
                  var fr, tn = (fr = pr.statusText) !== null && fr !== void 0 ? fr : "NONE", Kn;
                  if (typeof er == "string")
                    if (er && er.split(`
`, 2).length === 1) Kn = er;
                    else {
                      var Pr, Pt = (Pr = er.replace(/<.*?>/g, "").split(/\r\n/g).filter(function(Ht) {
                        return Ht.length;
                      })[0]) === null || Pr === void 0 ? void 0 : Pr.split(" ");
                      Kn = (Pt == null ? void 0 : Pt.length) > 2 ? Pt == null ? void 0 : Pt.slice(1).join(" ") : "";
                    }
                  else
                    Kn = JSON.stringify(er);
                  var or = "".concat(pr.status, ": [").concat(tn, "] ").concat(Kn);
                  Er(new Ke(or, pr.status, er, tn, Vt));
                }
              }
            };
            for (var Yr in yt)
              pr.setRequestHeader(Yr, yt[Yr]), Yr === "Content-Type" && yt[Yr] === "application/json" && (xr = JSON.stringify(xr));
            pr.send(xr);
          });
        }
      }]), bt;
    }(), Ye = qe.scope("Network"), Je = /* @__PURE__ */ function() {
      function bt(At, vt) {
        w.default(this, bt), this.config = At, this.transport = vt;
      }
      return _.default(bt, [{
        key: "backoffConfig",
        value: function() {
          return Object.assign(ne.backoffConfigDefault, this.config.backoffConfigOverride);
        }
      }, {
        key: "retryWhenThrottled",
        value: function() {
          var vt, _t;
          return (vt = (_t = this.config.retryWhenThrottledOverride) !== null && _t !== void 0 ? _t : ne.retryWhenThrottledDefault) !== null && vt !== void 0 ? vt : !1;
        }
      }, {
        key: "executeWithRetry",
        value: function(vt, _t) {
          var yt = this;
          return new Ne(/* @__PURE__ */ function() {
            var xr = M.default(/* @__PURE__ */ B.default.mark(function dr(Er, gr, pr) {
              var Xr, Yr;
              return B.default.wrap(function(Vt) {
                for (; ; )
                  switch (Vt.prev = Vt.next) {
                    case 0:
                      Xr = new p.Retrier(yt.backoffConfig()), Yr = [502, 503, 504], _t && Yr.push(429), pr(function() {
                        Xr.cancel(), Xr.removeAllListeners();
                      }), Xr.on("attempt", /* @__PURE__ */ M.default(/* @__PURE__ */ B.default.mark(function er() {
                        var fr, tn;
                        return B.default.wrap(function(Pr) {
                          for (; ; )
                            switch (Pr.prev = Pr.next) {
                              case 0:
                                return Pr.prev = 0, fr = vt(), pr(function() {
                                  fr.cancel(), Xr.cancel(), Xr.removeAllListeners();
                                }), Pr.next = 5, fr;
                              case 5:
                                tn = Pr.sent, Xr.succeeded(tn), Pr.next = 12;
                                break;
                              case 9:
                                Pr.prev = 9, Pr.t0 = Pr.catch(0), Yr.indexOf(Pr.t0.status) > -1 || Pr.t0.message === "Twilsock disconnected" ? Xr.failed(Pr.t0) : (Xr.removeAllListeners(), Xr.cancel(), gr(Pr.t0));
                              case 12:
                              case "end":
                                return Pr.stop();
                            }
                        }, er, null, [[0, 9]]);
                      }))), Xr.on("succeeded", function(er) {
                        Er(er);
                      }), Xr.on("cancelled", function(er) {
                        return gr(er);
                      }), Xr.on("failed", function(er) {
                        return gr(er);
                      }), Xr.start();
                    case 9:
                    case "end":
                      return Vt.stop();
                  }
              }, dr);
            }));
            return function(dr, Er, gr) {
              return xr.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "get",
        value: function(vt) {
          var _t = this;
          return new Ne(/* @__PURE__ */ function() {
            var yt = M.default(/* @__PURE__ */ B.default.mark(function xr(dr, Er, gr) {
              var pr, Xr, Yr;
              return B.default.wrap(function(Vt) {
                for (; ; )
                  switch (Vt.prev = Vt.next) {
                    case 0:
                      return pr = {
                        "X-Twilio-Token": _t.config.token
                      }, Xr = _t.executeWithRetry(function() {
                        return _t.transport.get(vt, pr);
                      }, _t.retryWhenThrottled()), Ye.trace("sending GET request to ", vt, " headers ", pr), gr(function() {
                        return Xr.cancel();
                      }), Vt.prev = 4, Vt.next = 7, Xr;
                    case 7:
                      Yr = Vt.sent, Ye.trace("response", Yr), dr(Yr), Vt.next = 16;
                      break;
                    case 12:
                      Vt.prev = 12, Vt.t0 = Vt.catch(4), Ye.debug("get() error ".concat(Vt.t0)), Er(Vt.t0);
                    case 16:
                    case "end":
                      return Vt.stop();
                  }
              }, xr, null, [[4, 12]]);
            }));
            return function(xr, dr, Er) {
              return yt.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "post",
        value: function(vt, _t, yt, xr, dr) {
          var Er = this, gr = {
            "X-Twilio-Token": this.config.token
          };
          (typeof FormData > "u" || !(yt instanceof FormData)) && xr && Object.assign(gr, {
            "Content-Type": xr
          });
          var pr = new URL(vt);
          return _t && pr.searchParams.append("Category", _t), dr && pr.searchParams.append("Filename", dr), new Ne(/* @__PURE__ */ function() {
            var Xr = M.default(/* @__PURE__ */ B.default.mark(function Yr(at, Vt, er) {
              var fr, tn;
              return B.default.wrap(function(Pr) {
                for (; ; )
                  switch (Pr.prev = Pr.next) {
                    case 0:
                      return fr = Er.transport.post(pr.href, gr, yt), er(function() {
                        return fr.cancel();
                      }), Ye.trace("sending POST request to ".concat(vt, " with headers ").concat(gr)), Pr.prev = 3, Pr.next = 6, fr;
                    case 6:
                      tn = Pr.sent, Pr.next = 17;
                      break;
                    case 9:
                      if (Pr.prev = 9, Pr.t0 = Pr.catch(3), !(e.XMLHttpRequest === void 0 && yt instanceof FormData)) {
                        Pr.next = 14;
                        break;
                      }
                      return Vt(new TypeError("Posting FormData supported only with browser engine's FormData")), Pr.abrupt("return");
                    case 14:
                      return Ye.debug("post() error ".concat(Pr.t0)), Vt(Pr.t0), Pr.abrupt("return");
                    case 17:
                      Ye.trace("response", tn), at(tn);
                    case 19:
                    case "end":
                      return Pr.stop();
                  }
              }, Yr, null, [[3, 9]]);
            }));
            return function(Yr, at, Vt) {
              return Xr.apply(this, arguments);
            };
          }());
        }
      }]), bt;
    }(), tt = "0.6.10", kt, Ft = qe.scope("");
    t.default = (kt = /* @__PURE__ */ function() {
      function bt(At, vt, _t) {
        var yt, xr, dr = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        w.default(this, bt), this.options = dr, this.options.logLevel = (yt = this.options.logLevel) !== null && yt !== void 0 ? yt : "silent", this.config = new ne(At, vt, _t, this.options), Ft.setLevel(this.options.logLevel), this.options.transport = (xr = this.options.transport) !== null && xr !== void 0 ? xr : new ot(), this.transport = this.options.transport, this.network = new Je(this.config, this.transport);
      }
      return _.default(bt, [{
        key: "updateToken",
        value: function(vt) {
          Ft.info("updateToken"), this.config.updateToken(vt);
        }
        /**
         * Gets media from media service
         * @param {String} sid - Media's SID
         */
      }, {
        key: "get",
        value: function(vt) {
          var _t = this;
          return new Ne(/* @__PURE__ */ function() {
            var yt = M.default(/* @__PURE__ */ B.default.mark(function xr(dr, Er, gr) {
              var pr, Xr;
              return B.default.wrap(function(at) {
                for (; ; )
                  switch (at.prev = at.next) {
                    case 0:
                      return pr = _t.network.get("".concat(_t.config.mediaUrl, "/").concat(vt)), gr(function() {
                        return pr.cancel();
                      }), at.prev = 2, at.next = 5, pr;
                    case 5:
                      Xr = at.sent, dr(new re(_t.config, _t.network, Xr.body)), at.next = 12;
                      break;
                    case 9:
                      at.prev = 9, at.t0 = at.catch(2), Er(at.t0);
                    case 12:
                    case "end":
                      return at.stop();
                  }
              }, xr, null, [[2, 9]]);
            }));
            return function(xr, dr, Er) {
              return yt.apply(this, arguments);
            };
          }());
        }
        /**
         * Posts raw content to media service
         * @param {String} contentType - content type of media
         * @param {String|Buffer|Blob} media - content to post
         * @param {MediaCategory|null} category - category for the media
         */
      }, {
        key: "post",
        value: function(vt, _t, yt, xr) {
          var dr = this;
          return new Ne(/* @__PURE__ */ function() {
            var Er = M.default(/* @__PURE__ */ B.default.mark(function gr(pr, Xr, Yr) {
              var at, Vt;
              return B.default.wrap(function(fr) {
                for (; ; )
                  switch (fr.prev = fr.next) {
                    case 0:
                      return at = dr.network.post(dr.config.mediaUrl, yt ?? "media", _t, vt, xr), Yr(function() {
                        return at.cancel();
                      }), fr.prev = 2, fr.next = 5, at;
                    case 5:
                      Vt = fr.sent, pr(new re(dr.config, dr.network, Vt.body)), fr.next = 12;
                      break;
                    case 9:
                      fr.prev = 9, fr.t0 = fr.catch(2), Xr(fr.t0);
                    case 12:
                    case "end":
                      return fr.stop();
                  }
              }, gr, null, [[2, 9]]);
            }));
            return function(gr, pr, Xr) {
              return Er.apply(this, arguments);
            };
          }());
        }
        /**
         * Posts FormData to media service. Can be used only with browser engine's FormData.
         * In non-browser FormData case the method will do promise reject with
         * new TypeError("Posting FormData supported only with browser engine's FormData")
         * @param {FormData} formData - form data to post
         * @param {MediaCategory|null} category - category for the media
         */
      }, {
        key: "postFormData",
        value: function(vt, _t) {
          var yt = this;
          return new Ne(/* @__PURE__ */ function() {
            var xr = M.default(/* @__PURE__ */ B.default.mark(function dr(Er, gr, pr) {
              var Xr, Yr;
              return B.default.wrap(function(Vt) {
                for (; ; )
                  switch (Vt.prev = Vt.next) {
                    case 0:
                      return Xr = yt.network.post(yt.config.mediaUrl, _t ?? "media", vt), pr(function() {
                        return Xr.cancel();
                      }), Vt.prev = 2, Vt.next = 5, Xr;
                    case 5:
                      Yr = Vt.sent, Er(new re(yt.config, yt.network, Yr.body)), Vt.next = 12;
                      break;
                    case 9:
                      Vt.prev = 9, Vt.t0 = Vt.catch(2), gr(Vt.t0);
                    case 12:
                    case "end":
                      return Vt.stop();
                  }
              }, dr, null, [[2, 9]]);
            }));
            return function(dr, Er, gr) {
              return xr.apply(this, arguments);
            };
          }());
        }
        /**
         * Retrieve information about multiple media SIDs at the same time.
         * @param mediaSids Array of Media SIDs to get information from.
         */
      }, {
        key: "mediaSetGet",
        value: function(vt) {
          var _t = this;
          return new Ne(/* @__PURE__ */ function() {
            var yt = M.default(/* @__PURE__ */ B.default.mark(function xr(dr, Er, gr) {
              var pr, Xr, Yr, at;
              return B.default.wrap(function(er) {
                for (; ; )
                  switch (er.prev = er.next) {
                    case 0:
                      return pr = {
                        command: "get",
                        list: vt.map(function(fr) {
                          return {
                            media_sid: fr
                          };
                        })
                      }, Xr = _t.network.post("".concat(_t.config.mediaSetUrl), null, pr, "application/json"), gr(function() {
                        return Xr.cancel();
                      }), er.prev = 3, er.next = 6, Xr;
                    case 6:
                      Yr = er.sent, at = Yr.body.map(function(fr) {
                        if (fr.code !== 200) {
                          Er("Failed to obtain detailed information about Media items (failed SID ".concat(fr.media_record.sid, ")"));
                          return;
                        }
                        return new re(_t.config, _t.network, fr.media_record);
                      }), dr(at), er.next = 14;
                      break;
                    case 11:
                      er.prev = 11, er.t0 = er.catch(3), Er(er.t0);
                    case 14:
                    case "end":
                      return er.stop();
                  }
              }, xr, null, [[3, 11]]);
            }));
            return function(xr, dr, Er) {
              return yt.apply(this, arguments);
            };
          }());
        }
        /**
         * Retrieve temporary URLs for a set of media SIDs.
         * @param mediaSids array of the media SIDs to get URLs from.
         */
      }, {
        key: "mediaSetGetContentUrls",
        value: function(vt) {
          var _t = this;
          return new Ne(/* @__PURE__ */ function() {
            var yt = M.default(/* @__PURE__ */ B.default.mark(function xr(dr, Er, gr) {
              var pr, Xr, Yr, at;
              return B.default.wrap(function(er) {
                for (; ; )
                  switch (er.prev = er.next) {
                    case 0:
                      return pr = {
                        command: "get",
                        list: vt.map(function(fr) {
                          return {
                            media_sid: fr
                          };
                        })
                      }, Xr = _t.network.post("".concat(_t.config.mediaSetUrl), null, pr, "application/json"), gr(function() {
                        return Xr.cancel();
                      }), er.prev = 3, er.next = 6, Xr;
                    case 6:
                      Yr = er.sent, at = /* @__PURE__ */ new Map(), Yr.body.forEach(function(fr) {
                        if (fr.code !== 200) {
                          Er("Failed to obtain detailed information about Media items (failed SID ".concat(fr.media_record.sid, ")"));
                          return;
                        }
                        at.set(fr.media_record.sid, fr.media_record.links.content_direct_temporary);
                      }), dr(at), er.next = 15;
                      break;
                    case 12:
                      er.prev = 12, er.t0 = er.catch(3), Er(er.t0);
                    case 15:
                    case "end":
                      return er.stop();
                  }
              }, xr, null, [[3, 12]]);
            }));
            return function(xr, dr, Er) {
              return yt.apply(this, arguments);
            };
          }());
        }
      }]), bt;
    }(), I.default(kt, "version", tt), kt), ze([g.validateTypes(g.nonEmptyString), ct("design:type", Function), ct("design:paramtypes", [String]), ct("design:returntype", void 0)], t.default.prototype, "updateToken", null), ze([g.validateTypesAsync(g.nonEmptyString), ct("design:type", Function), ct("design:paramtypes", [String]), ct("design:returntype", Ne)], t.default.prototype, "get", null), t.default = ze([g.validateConstructorTypes(g.nonEmptyString, g.nonEmptyString, [g.nonEmptyString, g.literal(null)], [g.pureObject, "undefined"]), ct("design:paramtypes", [String, String, Object, Object])], t.default), t.CancellablePromise = Ne, t.Client = t.default, t.McsClient = t.default, t.McsMedia = re, t.Media = re;
  }(rie)), rie;
}
var nDe = {}, aDe;
function dqr() {
  if (aDe) return nDe;
  aDe = 1;
  var t = Wo(), e = nu(), r = Xh(), n = t.aTypedArray, a = t.exportTypedArrayMethod;
  return a("at", function(o) {
    var s = n(this), l = e(s), c = r(o), u = c >= 0 ? c : l + c;
    return u < 0 || u >= l ? void 0 : s[u];
  }), nDe;
}
var iDe = {}, oDe;
function fqr() {
  if (oDe) return iDe;
  oDe = 1;
  var t = Ya(), e = wi(), r = grt(), n = FG(), a = "ArrayBuffer", i = r[a], o = e[a];
  return t({ global: !0, constructor: !0, forced: o !== i }, {
    ArrayBuffer: i
  }), n(a), iDe;
}
var sDe = {}, lDe;
function hqr() {
  if (lDe) return sDe;
  lDe = 1;
  var t = Ya(), e = Wa(), r = e2t(), n = d2(), a = Vl(), i = t2t(), o = e("".indexOf);
  return t({ target: "String", proto: !0, forced: !i("includes") }, {
    includes: function(l) {
      return !!~o(
        a(n(this)),
        a(r(l)),
        arguments.length > 1 ? arguments[1] : void 0
      );
    }
  }), sDe;
}
var cDe = {}, uDe = {}, cie, dDe;
function pqr() {
  if (dDe) return cie;
  dDe = 1;
  var t = Wa(), e = JG(), r = ZG().getWeakData, n = Uy(), a = Ys(), i = u2(), o = fs(), s = jM(), l = Rd(), c = Es(), u = _0(), f = u.set, h = u.getterFor, p = l.find, g = l.findIndex, y = t([].splice), b = 0, w = function(x) {
    return x.frozen || (x.frozen = new _());
  }, _ = function() {
    this.entries = [];
  }, C = function(x, S) {
    return p(x.entries, function(A) {
      return A[0] === S;
    });
  };
  return _.prototype = {
    get: function(x) {
      var S = C(this, x);
      if (S) return S[1];
    },
    has: function(x) {
      return !!C(this, x);
    },
    set: function(x, S) {
      var A = C(this, x);
      A ? A[1] = S : this.entries.push([x, S]);
    },
    delete: function(x) {
      var S = g(this.entries, function(A) {
        return A[0] === x;
      });
      return ~S && y(this.entries, S, 1), !!~S;
    }
  }, cie = {
    getConstructor: function(x, S, A, I) {
      var M = x(function(d, m) {
        n(d, B), f(d, {
          type: S,
          id: b++,
          frozen: null
        }), i(m) || s(m, d[I], { that: d, AS_ENTRIES: A });
      }), B = M.prototype, L = h(S), N = function(d, m, v) {
        var k = L(d), O = r(a(m), !0);
        return O === !0 ? w(k).set(m, v) : O[k.id] = v, d;
      };
      return e(B, {
        // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
        // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
        // https://tc39.es/ecma262/#sec-weakset.prototype.delete
        delete: function(d) {
          var m = L(this);
          if (!o(d)) return !1;
          var v = r(d);
          return v === !0 ? w(m).delete(d) : v && c(v, m.id) && delete v[m.id];
        },
        // `{ WeakMap, WeakSet }.prototype.has(key)` methods
        // https://tc39.es/ecma262/#sec-weakmap.prototype.has
        // https://tc39.es/ecma262/#sec-weakset.prototype.has
        has: function(m) {
          var v = L(this);
          if (!o(m)) return !1;
          var k = r(m);
          return k === !0 ? w(v).has(m) : k && c(k, v.id);
        }
      }), e(B, A ? {
        // `WeakMap.prototype.get(key)` method
        // https://tc39.es/ecma262/#sec-weakmap.prototype.get
        get: function(m) {
          var v = L(this);
          if (o(m)) {
            var k = r(m);
            if (k === !0) return w(v).get(m);
            if (k) return k[v.id];
          }
        },
        // `WeakMap.prototype.set(key, value)` method
        // https://tc39.es/ecma262/#sec-weakmap.prototype.set
        set: function(m, v) {
          return N(this, m, v);
        }
      } : {
        // `WeakSet.prototype.add(value)` method
        // https://tc39.es/ecma262/#sec-weakset.prototype.add
        add: function(m) {
          return N(this, m, !0);
        }
      }), M;
    }
  }, cie;
}
var fDe;
function mqr() {
  if (fDe) return uDe;
  fDe = 1;
  var t = Dme(), e = pqr();
  return t("WeakSet", function(r) {
    return function() {
      return r(this, arguments.length ? arguments[0] : void 0);
    };
  }, e), uDe;
}
var hDe;
function gqr() {
  return hDe || (hDe = 1, mqr()), cDe;
}
var bS = {};
/*
@license
Copyright (c) 2022 Twilio Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


*/
var pDe;
function vqr() {
  if (pDe) return bS;
  pDe = 1, Object.defineProperty(bS, "__esModule", { value: !0 }), f6();
  var t = V8();
  function e(i) {
    return i && typeof i == "object" && "default" in i ? i : { default: i };
  }
  var r = /* @__PURE__ */ e(t), n = function(o, s, l) {
    return function(c, u, f) {
      if (typeof f.value != "function" && (f == null ? void 0 : f.get) === void 0)
        throw new Error("The deprecated decorator can only be applied to methods or getters");
      if (typeof f.value == "function") {
        var h = f.value;
        f.value = function() {
          a("The method ".concat(o, " is deprecated").concat(s ? ", use " + s + " instead" : "").concat(l ? ", " + l : "."));
          for (var g = arguments.length, y = new Array(g), b = 0; b < g; b++)
            y[b] = arguments[b];
          return h.apply(this, y);
        };
        return;
      }
      var p = f.get;
      f.get = function() {
        return a("The getter ".concat(o, " is deprecated").concat(s ? ", use " + s + " instead" : "").concat(l ? ", " + l : ".")), p == null ? void 0 : p.apply(this);
      };
    };
  }, a = function(o) {
    var s = r.default.getLevel();
    r.default.setLevel("warn"), r.default.warn(o), r.default.setLevel(s);
  };
  return bS.deprecated = n, bS.deprecationWarning = a, bS;
}
var mDe = {}, gDe;
function yqr() {
  if (gDe) return mDe;
  gDe = 1;
  var t = Ya(), e = Rd().find, r = Ime(), n = "find", a = !0;
  return n in [] && Array(1)[n](function() {
    a = !1;
  }), t({ target: "Array", proto: !0, forced: a }, {
    find: function(o) {
      return e(this, o, arguments.length > 1 ? arguments[1] : void 0);
    }
  }), r(n), mDe;
}
var vDe = {}, yDe;
function bqr() {
  if (yDe) return vDe;
  yDe = 1;
  var t = Ya(), e = crt(), r = Ba(), n = fs(), a = ZG().onFreeze, i = Object.freeze, o = r(function() {
    i(1);
  });
  return t({ target: "Object", stat: !0, forced: o, sham: !e }, {
    freeze: function(l) {
      return i && n(l) ? i(a(l)) : l;
    }
  }), vDe;
}
var bDe;
function xqr() {
  return bDe || (bDe = 1, function(t) {
    var e = typeof e < "u" ? e : typeof self < "u" ? self : typeof window < "u" ? window : {};
    Object.defineProperty(t, "__esModule", { value: !0 }), G8(), s6(), gme(), DG(), MM(), xme(), Cme();
    var r = OM(), n = l6(), a = Wy(), i = Hy(), o = np(), s = c6(), l = Gy(), c = zy();
    jG(), u6(), PM(), d6();
    var u = FM(), f = rp();
    f6(), U8(), h6();
    var h = V8(), p = tqr;
    vg(), H8(), $G(), KG(), p6(), rW(), WM();
    var g = HM(), y = GM();
    Nme();
    var b = Qrt(), w = rqr();
    UG(), Eme(), Ome(), VG(), Bme();
    var _ = WG();
    VM();
    var C = UM(), x = Wme(), S = nqr(), A = tnt(), I = uqr();
    Lme(), ort(), xrt(), dqr(), Crt(), wrt(), Srt(), _rt(), krt(), Art(), Trt(), Ert(), Irt(), Mrt(), Prt(), Rrt(), Ort(), Nrt(), $rt(), Drt(), Lrt(), jrt(), Frt(), Hrt(), Urt(), Vrt(), qrt(), fqr(), ent(), hqr(), r2t(), gqr();
    var M = vqr();
    srt(), yqr(), Yrt();
    var B = nW(), L = /* @__PURE__ */ QG();
    bqr();
    function N(Ee) {
      return Ee && typeof Ee == "object" && "default" in Ee ? Ee : { default: Ee };
    }
    function d(Ee) {
      if (Ee && Ee.__esModule) return Ee;
      var je = /* @__PURE__ */ Object.create(null);
      return Ee && Object.keys(Ee).forEach(function(be) {
        if (be !== "default") {
          var oe = Object.getOwnPropertyDescriptor(Ee, be);
          Object.defineProperty(je, be, oe.get ? oe : {
            enumerable: !0,
            get: function() {
              return Ee[be];
            }
          });
        }
      }), je.default = Ee, Object.freeze(je);
    }
    var m = /* @__PURE__ */ N(r), v = /* @__PURE__ */ N(n), k = /* @__PURE__ */ N(a), O = /* @__PURE__ */ N(i), G = /* @__PURE__ */ N(o), H = /* @__PURE__ */ N(s), j = /* @__PURE__ */ N(l), F = /* @__PURE__ */ N(c), z = /* @__PURE__ */ N(u), W = /* @__PURE__ */ N(f), U = /* @__PURE__ */ d(h), Z = /* @__PURE__ */ N(y), V = /* @__PURE__ */ N(w), Y = /* @__PURE__ */ N(_), ge = /* @__PURE__ */ N(B);
    function ce(Ee, je, be, oe) {
      var ae = arguments.length, xe = ae < 3 ? je : oe === null ? oe = Object.getOwnPropertyDescriptor(je, be) : oe, ue;
      if ((typeof Reflect > "u" ? "undefined" : W.default(Reflect)) === "object" && typeof Reflect.decorate == "function") xe = Reflect.decorate(Ee, je, be, oe);
      else for (var pe = Ee.length - 1; pe >= 0; pe--)
        (ue = Ee[pe]) && (xe = (ae < 3 ? ue(xe) : ae > 3 ? ue(je, be, xe) : ue(je, be)) || xe);
      return ae > 3 && xe && Object.defineProperty(je, be, xe), xe;
    }
    function ee(Ee, je) {
      if ((typeof Reflect > "u" ? "undefined" : W.default(Reflect)) === "object" && typeof Reflect.metadata == "function") return Reflect.metadata(Ee, je);
    }
    function Se(Ee, je) {
      return ["".concat((/* @__PURE__ */ new Date()).toISOString(), " Conversations ").concat(Ee, ":")].concat(Array.from(je));
    }
    var Ce = U.getLogger("twilio-conversations"), we = /* @__PURE__ */ function() {
      function Ee(je) {
        F.default(this, Ee), H.default(this, "prefix", ""), this.prefix = je != null && je.length > 0 ? je + " " : "";
      }
      return j.default(Ee, [{
        key: "setLevel",
        value: function(be) {
          Ce.setLevel(be);
        }
      }, {
        key: "trace",
        value: function() {
          if (Ce.getLevel() == Ce.levels.TRACE) {
            for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
              oe[ae] = arguments[ae];
            Ce.debug.apply(null, Se(this.prefix + "T", oe));
          }
        }
      }, {
        key: "debug",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.debug.apply(null, Se(this.prefix + "D", oe));
        }
      }, {
        key: "info",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.info.apply(null, Se(this.prefix + "I", oe));
        }
      }, {
        key: "warn",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.warn.apply(null, Se(this.prefix + "W", oe));
        }
      }, {
        key: "error",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.error.apply(null, Se(this.prefix + "E", oe));
        }
      }], [{
        key: "scope",
        value: function(be) {
          return new Ee(be);
        }
      }, {
        key: "setLevel",
        value: function(be) {
          Ce.setLevel(be);
        }
      }, {
        key: "trace",
        value: function() {
          if (Ce.getLevel() == Ce.levels.TRACE) {
            for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
              oe[ae] = arguments[ae];
            Ce.debug.apply(null, Se("T", oe));
          }
        }
      }, {
        key: "debug",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.debug.apply(null, Se("D", oe));
        }
      }, {
        key: "info",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.info.apply(null, Se("I", oe));
        }
      }, {
        key: "warn",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.warn.apply(null, Se("W", oe));
        }
      }, {
        key: "error",
        value: function() {
          for (var be = arguments.length, oe = new Array(be), ae = 0; ae < be; ae++)
            oe[ae] = arguments[ae];
          Ce.error.apply(null, Se("E", oe));
        }
      }]), Ee;
    }();
    function We(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function Fe(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? We(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : We(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    var it = 5, gt = "PT5S", Ze = "PT5S", Ne = 100, ze = 1e3, ct = 4e3, rt = 3, qe = !0, nt = 100, Rt = 1e3, Ot = /* @__PURE__ */ j.default(function Ee() {
      var je, be, oe, ae, xe, ue, pe, ve, ye = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ae = arguments.length > 1 ? arguments[1] : void 0, Qe = arguments.length > 2 ? arguments[2] : void 0;
      F.default(this, Ee), H.default(this, "typingIndicatorTimeoutDefault", it * 1e3);
      var pt = ye.Chat || ye.IPMessaging || ye || {};
      this.productId = pt.productId, this.links = {
        myConversations: Ae.links.my_conversations,
        conversations: Ae.links.conversations,
        users: Ae.links.users,
        currentUser: Ae.links.current_user,
        typing: Ae.links.typing,
        mediaService: Ae.links.media_service,
        mediaSetService: Ae.links.media_set_service,
        messagesReceipts: Ae.links.messages_receipts
      }, this.limits = {
        mediaAttachmentsCountLimit: Ae.options.media_attachments_count_limit,
        mediaAttachmentSizeLimitInMb: Ae.options.media_attachment_size_limit_in_mb,
        mediaAttachmentsTotalSizeLimitInMb: Ae.options.media_attachments_total_size_limit_in_mb,
        emailHistoriesAllowedContentTypes: Ae.options.email_histories_allowed_mime_types,
        emailBodiesAllowedContentTypes: Ae.options.email_bodies_allowed_mime_types
      }, this.typingIndicatorTimeoutOverride = pt.typingIndicatorTimeoutOverride, this.backoffConfiguration = Fe({
        min: ze,
        max: ct,
        maxAttemptsCount: rt
      }, pt.backoffConfigOverride), this.retryWhenThrottled = pt.retryWhenThrottledOverride !== void 0 ? pt.retryWhenThrottledOverride : qe, this.userInfosToSubscribe = (je = (be = pt.userInfosToSubscribeOverride) !== null && be !== void 0 ? be : Ae.options.user_infos_to_subscribe) !== null && je !== void 0 ? je : Ne, this.reachabilityEnabled = Ae.options.reachability_enabled, this.userIdentity = Ae.identity, this.userInfo = Ae.sync_objects.my_user_info, this.myConversations = Ae.sync_objects.my_conversations;
      var Tt = (oe = (ae = pt.httpCacheIntervalOverride) !== null && ae !== void 0 ? ae : Ae.options.http_cache_interval) !== null && oe !== void 0 ? oe : gt;
      try {
        this.httpCacheInterval = p.toSeconds(p.parse(Tt));
      } catch {
        Qe.error("Failed to parse http cache interval ".concat(Tt, ", using default value ").concat(gt)), this.httpCacheInterval = p.toSeconds(p.parse(gt));
      }
      var zt = (xe = (ue = pt.consumptionReportIntervalOverride) !== null && ue !== void 0 ? ue : Ae.options.consumption_report_interval) !== null && xe !== void 0 ? xe : Ze;
      try {
        this.consumptionReportInterval = p.toSeconds(p.parse(zt));
      } catch {
        Qe.error("Failed to parse consumption report interval ".concat(zt, ", using default value ").concat(Ze)), this.consumptionReportInterval = p.toSeconds(p.parse(Ze));
      }
      this.channelMetadataCacheCapacity = (pe = ye.channelMetadataCacheCapacity) !== null && pe !== void 0 ? pe : nt, this.messageRecipientsCacheCapacity = (ve = ye.messageRecipientsCacheCapacity) !== null && ve !== void 0 ? ve : Rt;
    });
    function lt(Ee) {
      return JSON.parse(JSON.stringify(Ee));
    }
    function mt(Ee) {
      return typeof Ee < "u" && !isNaN(Number(Ee)) ? Number(Ee) : null;
    }
    function jt(Ee) {
      try {
        return new Date(Ee);
      } catch {
        return null;
      }
    }
    function Jt(Ee, je, be) {
      var oe = {};
      if (Ee)
        try {
          oe = JSON.parse(Ee);
        } catch (ae) {
          be.warn(je, ae);
        }
      return oe;
    }
    var ne = /* @__PURE__ */ function() {
      function Ee(je) {
        F.default(this, Ee), this.base = je.replace(/\/$/, ""), this.args = [], this.paths = [];
      }
      return j.default(Ee, [{
        key: "arg",
        value: function(be, oe) {
          return typeof oe < "u" && this.args.push(encodeURIComponent(be) + "=" + encodeURIComponent(oe)), this;
        }
      }, {
        key: "path",
        value: function(be) {
          return this.paths.push(encodeURIComponent(be)), this;
        }
      }, {
        key: "build",
        value: function() {
          var be = this.base;
          return this.paths.length && (be += "/" + this.paths.join("/")), this.args.length && (be += "?" + this.args.join("&")), be;
        }
      }]), Ee;
    }(), re = g.custom(function(Ee) {
      return [["string", "number", "boolean", "object"].includes(W.default(Ee)), "a JSON type"];
    }), ie = g.custom(function(Ee) {
      return [["undefined", "string", "number", "boolean", "object"].includes(W.default(Ee)), "an optional JSON type"];
    }), Ie = g.objectSchema("send media options", {
      contentType: [g.literal(null), "string"],
      filename: ["string", "undefined"],
      media: [g.literal("null"), "string"].concat(Z.default(typeof nc == "function" ? [nc] : []), Z.default(typeof Blob == "function" ? [Blob] : []))
    });
    function Ke(Ee) {
      var je = Le();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function Le() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Ge = we.scope("User"), ft = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Ke(be);
      function be(oe, ae, xe, ue) {
        var pe;
        return F.default(this, be), pe = je.call(this), H.default(v.default(pe), "promiseToFetch", null), H.default(v.default(pe), "updated", "updated"), H.default(v.default(pe), "userSubscribed", "userSubscribed"), H.default(v.default(pe), "userUnsubscribed", "userUnsubscribed"), pe.services = ue, pe.subscribed = "initializing", pe.setMaxListeners(0), pe.state = {
          identity: oe,
          entityName: ae,
          friendlyName: null,
          attributes: {},
          online: null,
          notifiable: null
        }, pe._initializationPromise = new Promise(function(ve) {
          pe._resolveInitializationPromise = ve;
        }), xe !== null && pe._resolveInitialization(xe, oe, ae, !1), pe;
      }
      return j.default(be, [{
        key: "identity",
        get: (
          /**
           * User identity.
           */
          function() {
            return this.state.identity;
          }
        ),
        set: function(ae) {
          this.state.identity = ae;
        }
      }, {
        key: "entityName",
        set: function(ae) {
          this.state.entityName = ae;
        }
        /**
         * Custom attributes of the user.
         */
      }, {
        key: "attributes",
        get: function() {
          return this.state.attributes;
        }
        /**
         * Friendly name of the user, null if not set.
         */
      }, {
        key: "friendlyName",
        get: function() {
          return this.state.friendlyName;
        }
        /**
         * Status of the real-time conversation connection of the user.
         */
      }, {
        key: "isOnline",
        get: function() {
          return this.state.online;
        }
        /**
         * User push notification registration status.
         */
      }, {
        key: "isNotifiable",
        get: function() {
          return this.state.notifiable;
        }
        /**
         * True if this user is receiving real-time status updates.
         */
      }, {
        key: "isSubscribed",
        get: function() {
          return this.subscribed == "subscribed";
        }
        // Handles service updates
      }, {
        key: "_update",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve, ye;
            return z.default.wrap(function(Qe) {
              for (; ; )
                switch (Qe.prev = Qe.next) {
                  case 0:
                    return Qe.next = 2, this._initializationPromise;
                  case 2:
                    ve = [], Ge.debug("User for", this.state.identity, "updated:", ue, pe), Qe.t0 = ue, Qe.next = Qe.t0 === "friendlyName" ? 7 : Qe.t0 === "attributes" ? 9 : Qe.t0 === "reachability" ? 12 : 15;
                    break;
                  case 7:
                    return this.state.friendlyName !== pe.value && (ve.push("friendlyName"), this.state.friendlyName = pe.value), Qe.abrupt("break", 16);
                  case 9:
                    return ye = Jt(pe.value, "Retrieved malformed attributes from the server for user: ".concat(this.state.identity), Ge), V.default(this.state.attributes, ye) || (this.state.attributes = ye, ve.push("attributes")), Qe.abrupt("break", 16);
                  case 12:
                    return this.state.online !== pe.online && (this.state.online = pe.online, ve.push("reachabilityOnline")), this.state.notifiable !== pe.notifiable && (this.state.notifiable = pe.notifiable, ve.push("reachabilityNotifiable")), Qe.abrupt("break", 16);
                  case 15:
                    return Qe.abrupt("return");
                  case 16:
                    ve.length > 0 && this.emit("updated", {
                      user: this,
                      updateReasons: ve
                    });
                  case 17:
                  case "end":
                    return Qe.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        // Fetch reachability info
      }, {
        key: "_updateReachabilityInfo",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve = this;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return Ae.next = 2, this._initializationPromise;
                  case 2:
                    if (this.configuration.reachabilityEnabled) {
                      Ae.next = 4;
                      break;
                    }
                    return Ae.abrupt("return", Promise.resolve());
                  case 4:
                    return Ae.abrupt("return", ue.get("reachability").then(pe).catch(function(Qe) {
                      Ge.warn("Failed to get reachability info for ", ve.state.identity, Qe);
                    }));
                  case 5:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        // Fetch user
      }, {
        key: "_fetch",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._initializationPromise;
                  case 2:
                    if (this.state.entityName) {
                      ve.next = 4;
                      break;
                    }
                    return ve.abrupt("return", this);
                  case 4:
                    return this.promiseToFetch = this.services.syncClient.map({
                      id: this.state.entityName,
                      mode: "open_existing",
                      includeItems: !0
                    }).then(function(ye) {
                      return ue.entity = ye, ye.on("itemUpdated", function(Ae) {
                        return Ge.debug(ue.state.entityName + " (" + ue.state.identity + ") itemUpdated: " + Ae.item.key), ue._update(Ae.item.key, Ae.item.data);
                      }), ye.on("itemAdded", function(Ae) {
                        return Ge.debug(ue.state.entityName + " (" + ue.state.identity + ") itemAdded: " + Ae.item.key), ue._update(Ae.item.key, Ae.item.data);
                      }), Promise.all([ye.get("friendlyName").then(function(Ae) {
                        return ue._update(Ae.key, Ae.data);
                      }), ye.get("attributes").then(function(Ae) {
                        return ue._update(Ae.key, Ae.data);
                      }), ue._updateReachabilityInfo(ye, function(Ae) {
                        return ue._update(Ae.key, Ae.data);
                      })]);
                    }).then(function() {
                      return Ge.debug("Fetched for", ue.identity), ue.subscribed = "subscribed", ue.emit("userSubscribed", ue), ue;
                    }).catch(function(ye) {
                      throw ue.promiseToFetch = null, ye;
                    }), ve.abrupt("return", this.promiseToFetch);
                  case 6:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_ensureFetched",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._initializationPromise;
                  case 2:
                    return pe.abrupt("return", this.promiseToFetch || this._fetch());
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Edit user attributes.
         * @param attributes New attributes.
         */
      }, {
        key: "updateAttributes",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._initializationPromise;
                  case 2:
                    if (this.subscribed != "unsubscribed") {
                      ve.next = 4;
                      break;
                    }
                    throw new Error("Can't modify unsubscribed object");
                  case 4:
                    return ve.next = 6, this.services.commandExecutor.mutateResource("post", this.links.self, {
                      attributes: JSON.stringify(ue)
                    });
                  case 6:
                    return ve.abrupt("return", this);
                  case 7:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Update the friendly name of the user.
         * @param friendlyName New friendly name.
         */
      }, {
        key: "updateFriendlyName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._initializationPromise;
                  case 2:
                    if (this.subscribed != "unsubscribed") {
                      ve.next = 4;
                      break;
                    }
                    throw new Error("Can't modify unsubscribed object");
                  case 4:
                    return ve.next = 6, this.services.commandExecutor.mutateResource("post", this.links.self, {
                      friendly_name: ue
                    });
                  case 6:
                    return ve.abrupt("return", this);
                  case 7:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Remove the user from the subscription list.
         * @return A promise of completion.
         */
      }, {
        key: "unsubscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._initializationPromise;
                  case 2:
                    if (!this.promiseToFetch) {
                      pe.next = 9;
                      break;
                    }
                    return pe.next = 5, this.promiseToFetch;
                  case 5:
                    this.entity.close(), this.promiseToFetch = null, this.subscribed = "unsubscribed", this.emit("userUnsubscribed", this);
                  case 9:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_resolveInitialization",
        value: function(ae, xe, ue, pe) {
          this.configuration = ae, this.identity = xe, this.entityName = ue, this.links = {
            self: "".concat(this.configuration.links.users, "/").concat(encodeURIComponent(this.identity))
          }, this._resolveInitializationPromise(), pe && this.emit("updated", {
            user: this,
            updateReasons: ["friendlyName", "attributes", "reachabilityOnline", "reachabilityNotifiable"]
          });
        }
      }]), be;
    }(b.ReplayEventEmitter);
    ce([g.validateTypesAsync(re), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], ft.prototype, "updateAttributes", null), ce([g.validateTypesAsync(["string"]), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], ft.prototype, "updateFriendlyName", null);
    function ot(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = Ye(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function Ye(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return Je(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return Je(Ee, je);
      }
    }
    function Je(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    var tt = /* @__PURE__ */ function() {
      function Ee(je, be) {
        F.default(this, Ee), this.configuration = je, this.services = be, this.cache = /* @__PURE__ */ new Map(), this.cacheLifetime = this.configuration.httpCacheInterval * 100, this.cleanupCache();
      }
      return j.default(Ee, [{
        key: "isExpired",
        value: function(be) {
          return !this.cacheLifetime || Date.now() - be > this.cacheLifetime;
        }
      }, {
        key: "cleanupCache",
        value: function() {
          var be = ot(this.cache), oe;
          try {
            for (be.s(); !(oe = be.n()).done; ) {
              var ae = Y.default(oe.value, 2), xe = ae[0], ue = ae[1];
              this.isExpired(ue.timestamp) && this.cache.delete(xe);
            }
          } catch (pe) {
            be.e(pe);
          } finally {
            be.f();
          }
          this.cache.size === 0 && clearInterval(this.timer);
        }
      }, {
        key: "pokeTimer",
        value: function() {
          var be = this;
          this.timer = this.timer || setInterval(function() {
            return be.cleanupCache();
          }, this.cacheLifetime * 2);
        }
      }, {
        key: "executeWithRetry",
        value: function(be) {
          var oe = this, ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          return new Promise(function(xe, ue) {
            var pe = [502, 503, 504];
            ae && pe.push(429);
            var ve = new C.Retrier(oe.configuration.backoffConfiguration);
            ve.on("attempt", function() {
              be().then(function(ye) {
                return ve.succeeded(ye);
              }).catch(function(ye) {
                pe.indexOf(ye.status) > -1 || ye.message === "Twilsock disconnected" ? ve.failed(ye) : (ve.removeAllListeners(), ve.cancel(), ue(ye));
              });
            }), ve.on("succeeded", function(ye) {
              xe(ye);
            }), ve.on("cancelled", function(ye) {
              return ue(ye);
            }), ve.on("failed", function(ye) {
              return ue(ye);
            }), ve.start();
          });
        }
      }, {
        key: "get",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae) {
            var xe = this, ue, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    if (ue = this.cache.get(ae), !(ue && !this.isExpired(ue.timestamp))) {
                      Ae.next = 3;
                      break;
                    }
                    return Ae.abrupt("return", ue.response);
                  case 3:
                    return pe = {}, Ae.next = 6, this.executeWithRetry(function() {
                      return xe.services.transport.get(ae, pe, xe.configuration.productId);
                    }, this.configuration.retryWhenThrottled);
                  case 6:
                    return ve = Ae.sent, this.cache.set(ae, {
                      response: ve,
                      timestamp: Date.now()
                    }), this.pokeTimer(), Ae.abrupt("return", ve);
                  case 10:
                  case "end":
                    return Ae.stop();
                }
            }, oe, this);
          }));
          function be(oe) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }]), Ee;
    }(), kt = /* @__PURE__ */ j.default(function Ee() {
      F.default(this, Ee);
    });
    H.default(kt, "TYPING_INDICATOR", "twilio.ipmsg.typing_indicator"), H.default(kt, "NEW_MESSAGE", "twilio.conversations.new_message"), H.default(kt, "ADDED_TO_CONVERSATION", "twilio.conversations.added_to_conversation"), H.default(kt, "REMOVED_FROM_CONVERSATION", "twilio.conversations.removed_from_conversation"), H.default(kt, "CONSUMPTION_UPDATE", "twilio.channel.consumption_update");
    function Ft(Ee) {
      var je = bt();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function bt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var At = we.scope("Participant"), vt = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Ft(be);
      function be(oe, ae, xe, ue, pe) {
        var ve, ye, Ae;
        if (F.default(this, be), Ae = je.call(this), Ae.conversation = xe, Ae.links = ue, Ae.services = pe, Ae.state = {
          attributes: Jt(oe.attributes, "Retrieved malformed attributes from the server for participant: " + ae, At),
          dateCreated: oe.dateCreated ? jt(oe.dateCreated) : null,
          dateUpdated: oe.dateCreated ? jt(oe.dateUpdated) : null,
          sid: ae,
          typingTimeout: null,
          isTyping: !1,
          identity: oe.identity,
          roleSid: (ve = oe.roleSid) !== null && ve !== void 0 ? ve : "",
          lastReadMessageIndex: Number.isInteger(oe.lastConsumedMessageIndex) ? oe.lastConsumedMessageIndex : null,
          lastReadTimestamp: oe.lastConsumptionTimestamp ? jt(oe.lastConsumptionTimestamp) : null,
          type: oe.type || "chat",
          userInfo: oe.userInfo,
          bindings: (ye = oe.bindings) !== null && ye !== void 0 ? ye : {}
        }, !oe.identity && !oe.type)
          throw new Error("Received invalid Participant object from server: Missing identity or type of Participant.");
        return Ae;
      }
      return j.default(be, [{
        key: "sid",
        get: (
          /**
           * Conversation that the remote client is a participant of.
           */
          /**
           * The server-assigned unique identifier for the participant.
           */
          function() {
            return this.state.sid;
          }
        )
        /**
         * Custom attributes of the participant.
         */
      }, {
        key: "attributes",
        get: function() {
          return this.state.attributes;
        }
        /**
         * Date this participant was created on.
         */
      }, {
        key: "dateCreated",
        get: function() {
          return this.state.dateCreated;
        }
        /**
         * Date this participant was last updated on.
         */
      }, {
        key: "dateUpdated",
        get: function() {
          return this.state.dateUpdated;
        }
        /**
         * Identity of the participant.
         */
      }, {
        key: "identity",
        get: function() {
          return this.state.identity;
        }
        /**
         * Indicates whether the participant is currently typing.
         */
      }, {
        key: "isTyping",
        get: function() {
          return this.state.isTyping;
        }
        /**
         * The index of the last read message by the participant.
         * Note that retrieving messages on a client endpoint does not mean that messages are read,
         * please consider reading about the [Read Horizon feature](https://www.twilio.com/docs/api/chat/guides/consumption-horizon)
         * to find out about the proper way to mark messages as read.
         */
      }, {
        key: "lastReadMessageIndex",
        get: function() {
          return this.state.lastReadMessageIndex;
        }
        /**
         * Date of the most recent read horizon update.
         */
      }, {
        key: "lastReadTimestamp",
        get: function() {
          return this.state.lastReadTimestamp;
        }
      }, {
        key: "roleSid",
        get: function() {
          return this.state.roleSid;
        }
        /**
         * Type of the participant.
         */
      }, {
        key: "type",
        get: function() {
          return this.state.type;
        }
        /**
         * Get the bindings mapping for the current participant.
         * Available binding depends on the participant type.
         * You could access it as `participant.bindings.sms?.address` or
         * using the type dynamically `participant.bindings[participant.type]`
         * just be aware that the binding information has different structure for
         * each participant type.
         * See also {ParticipantEmailBinding}, the only available currently binding descriptor.
         */
      }, {
        key: "bindings",
        get: function() {
          var ae;
          return (ae = this.state.bindings) !== null && ae !== void 0 ? ae : {};
        }
      }, {
        key: "_startTyping",
        value: (
          /**
           * Internal method used to start or reset the typing indicator timeout (with event emitting).
           * @internal
           */
          function(ae) {
            var xe = this;
            return this.state.typingTimeout && clearTimeout(this.state.typingTimeout), this.state.isTyping = !0, this.emit(be.typingStarted, this), this.conversation.emit(Ka.typingStarted, this), this.state.typingTimeout = Number(setTimeout(function() {
              return xe._endTyping();
            }, ae)), this;
          }
        )
        /**
         * Internal method function used to stop the typing indicator timeout (with event emitting).
         * @internal
         */
      }, {
        key: "_endTyping",
        value: function() {
          this.state.typingTimeout && (this.state.isTyping = !1, this.emit(be.typingEnded, this), this.conversation.emit(Ka.typingEnded, this), clearInterval(this.state.typingTimeout), this.state.typingTimeout = null);
        }
        /**
         * Internal method function used update local object's property roleSid with a new value.
         * @internal
         */
      }, {
        key: "_update",
        value: function(ae) {
          var xe = [], ue = Jt(ae.attributes, "Retrieved malformed attributes from the server for participant: " + this.state.sid, At);
          ae.attributes && !V.default(this.state.attributes, ue) && (this.state.attributes = ue, xe.push("attributes"));
          var pe = jt(ae.dateUpdated);
          ae.dateUpdated && (pe == null ? void 0 : pe.getTime()) !== (this.state.dateUpdated && this.state.dateUpdated.getTime()) && (this.state.dateUpdated = pe, xe.push("dateUpdated"));
          var ve = jt(ae.dateCreated);
          if (ae.dateCreated && (ve == null ? void 0 : ve.getTime()) !== (this.state.dateCreated && this.state.dateCreated.getTime()) && (this.state.dateCreated = ve, xe.push("dateCreated")), ae.roleSid && this.state.roleSid !== ae.roleSid && (this.state.roleSid = ae.roleSid, xe.push("roleSid")), (Number.isInteger(ae.lastConsumedMessageIndex) || ae.lastConsumedMessageIndex === null) && this.state.lastReadMessageIndex !== ae.lastConsumedMessageIndex && (this.state.lastReadMessageIndex = ae.lastConsumedMessageIndex, xe.push("lastReadMessageIndex")), ae.lastConsumptionTimestamp) {
            var ye = new Date(ae.lastConsumptionTimestamp);
            (!this.state.lastReadTimestamp || this.state.lastReadTimestamp.getTime() !== ye.getTime()) && (this.state.lastReadTimestamp = ye, xe.push("lastReadTimestamp"));
          }
          return ae.bindings && !V.default(this.state.bindings, ae.bindings) && (this.state.bindings = ae.bindings, xe.push("bindings")), xe.length > 0 && this.emit(be.updated, {
            participant: this,
            updateReasons: xe
          }), this;
        }
        /**
         * Get the user for this participant and subscribes to it. Supported only for participants of type `chat`.
         */
      }, {
        key: "getUser",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    if (this.type == "chat") {
                      pe.next = 2;
                      break;
                    }
                    throw new Error("Getting User is not supported for this Participant type: " + this.type);
                  case 2:
                    return pe.abrupt("return", this.services.users.getUser(this.state.identity, this.state.userInfo));
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Remove the participant from the conversation.
         */
      }, {
        key: "remove",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.abrupt("return", this.conversation.removeParticipant(this));
                  case 1:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Update the attributes of the participant.
         * @param attributes New attributes.
         */
      }, {
        key: "updateAttributes",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                      attributes: JSON.stringify(ue)
                    });
                  case 2:
                    return ve.abrupt("return", this);
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }]), be;
    }(b.ReplayEventEmitter);
    H.default(vt, "typingStarted", "typingStarted"), H.default(vt, "typingEnded", "typingEnded"), H.default(vt, "updated", "updated"), ce([g.validateTypesAsync(re), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], vt.prototype, "updateAttributes", null);
    function _t(Ee) {
      var je = yt();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function yt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var xr = we.scope("Participants"), dr = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = _t(be);
      function be(oe, ae, xe, ue) {
        var pe;
        return F.default(this, be), pe = je.call(this), H.default(v.default(pe), "rosterEntityPromise", null), pe.conversation = oe, pe.participants = ae, pe.links = xe, pe.services = ue, pe;
      }
      return j.default(be, [{
        key: "unsubscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (!this.rosterEntityPromise) {
                      ve.next = 6;
                      break;
                    }
                    return ve.next = 3, this.rosterEntityPromise;
                  case 3:
                    ue = ve.sent, ue.close(), this.rosterEntityPromise = null;
                  case 6:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "subscribe",
        value: function(ae) {
          var xe = this, ue = typeof ae == "string" ? this.services.syncClient.map({
            id: ae,
            mode: "open_existing"
          }) : Promise.resolve(ae);
          return this.rosterEntityPromise = this.rosterEntityPromise || ue.then(function(pe) {
            pe.on(A.SyncMap.itemAdded, function(Ae) {
              xr.debug(xe.conversation.sid + " itemAdded: " + Ae.item.key), xe.upsertParticipant(Ae.item.key, Ae.item.data).then(function(Qe) {
                xe.emit(Ka.participantJoined, Qe);
              });
            }), pe.on(A.SyncMap.itemRemoved, function(Ae) {
              xr.debug(xe.conversation.sid + " itemRemoved: " + Ae.key);
              var Qe = Ae.key;
              if (xe.participants.has(Qe)) {
                var pt = xe.participants.get(Qe);
                xe.participants.delete(Qe), pt && xe.emit(Ka.participantLeft, pt);
              }
            }), pe.on(A.SyncMap.itemUpdated, function(Ae) {
              xr.debug(xe.conversation.sid + " itemUpdated: " + Ae.item.key), xe.upsertParticipant(Ae.item.key, Ae.item.data).catch(function(Qe) {
                return xr.error(Qe);
              });
            });
            var ve = [], ye = function Ae(Qe) {
              return Qe.items.forEach(function(pt) {
                ve.push(xe.upsertParticipant(pt.key, pt.data));
              }), Qe.hasNextPage ? Qe.nextPage().then(Ae) : null;
            };
            return pe.getItems().then(ye).then(function() {
              return Promise.all(ve);
            }).then(function() {
              return pe;
            });
          }).catch(function(pe) {
            throw xe.rosterEntityPromise = null, xe.services.syncClient.connectionState != "disconnected" && xr.error("Failed to get roster object for conversation", xe.conversation.sid, pe), xr.debug("ERROR: Failed to get roster object for conversation", xe.conversation.sid, pe), pe;
          });
        }
      }, {
        key: "upsertParticipantFromResponse",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae, Qe, pt, Tt, zt;
            return z.default.wrap(function(Tn) {
              for (; ; )
                switch (Tn.prev = Tn.next) {
                  case 0:
                    return ve = ue.sid, ye = ue.attributes, Ae = ue.date_created, Qe = ue.date_updated, pt = ue.identity, Tt = ue.role_sid, zt = ue.messaging_binding, Tn.next = 3, this.upsertParticipant(ve, {
                      attributes: ye,
                      dateCreated: new Date(Ae),
                      dateUpdated: new Date(Qe),
                      identity: pt,
                      roleSid: Tt,
                      lastConsumedMessageIndex: null,
                      lastConsumptionTimestamp: null,
                      type: (pe = zt == null ? void 0 : zt.type) !== null && pe !== void 0 ? pe : "chat"
                    });
                  case 3:
                    return Tn.abrupt("return", Tn.sent);
                  case 4:
                  case "end":
                    return Tn.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "upsertParticipant",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve = this, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    if (ye = this.participants.get(ue), !ye) {
                      pt.next = 3;
                      break;
                    }
                    return pt.abrupt("return", ye._update(pe));
                  case 3:
                    return Ae = {
                      self: "".concat(this.links.participants, "/").concat(ue)
                    }, ye = new vt(pe, ue, this.conversation, Ae, this.services), this.participants.set(ue, ye), ye.on(vt.updated, function(Tt) {
                      return ve.emit(Ka.participantUpdated, Tt);
                    }), pt.abrupt("return", ye);
                  case 8:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * @returns {Promise<Array<Participant>>} returns list of participants {@see Participant}
         */
      }, {
        key: "getParticipants",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                      var ye = [];
                      return ue.participants.forEach(function(Ae) {
                        return ye.push(Ae);
                      }), ye;
                    }) : []);
                  case 1:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get participant by SID from conversation
         * @returns {Promise<Participant>}
         */
      }, {
        key: "getParticipantBySid",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                      var Ae = pe.participants.get(ue);
                      if (!Ae)
                        throw new Error("Participant with SID " + ue + " was not found");
                      return Ae;
                    }) : null);
                  case 1:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get participant by identity from conversation
         * @returns {Promise<Participant>}
         */
      }, {
        key: "getParticipantByIdentity",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return ve = null, Ae.abrupt("return", this.rosterEntityPromise ? this.rosterEntityPromise.then(function() {
                      if (pe.participants.forEach(function(Qe) {
                        Qe.identity === ue && (ve = Qe);
                      }), !ve)
                        throw new Error("Participant with identity " + ue + " was not found");
                      return ve;
                    }) : null);
                  case 2:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Add a chat participant to the conversation
         */
      }, {
        key: "add",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this.services.commandExecutor.mutateResource("post", this.links.participants, {
                      identity: ue,
                      attributes: typeof pe < "u" ? JSON.stringify(pe) : void 0
                    });
                  case 2:
                    return ye.abrupt("return", ye.sent);
                  case 3:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Add a non-chat participant to the conversation.
         */
      }, {
        key: "addNonChatParticipant",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve, ye, Ae, Qe, pt = arguments;
            return z.default.wrap(function(zt) {
              for (; ; )
                switch (zt.prev = zt.next) {
                  case 0:
                    return Ae = pt.length > 2 && pt[2] !== void 0 ? pt[2] : {}, Qe = pt.length > 3 && pt[3] !== void 0 ? pt[3] : {}, zt.next = 4, this.services.commandExecutor.mutateResource("post", this.links.participants, {
                      attributes: typeof Ae < "u" ? JSON.stringify(Ae) : void 0,
                      messaging_binding: {
                        address: pe,
                        proxy_address: ue,
                        name: Qe == null || (ve = Qe.email) === null || ve === void 0 ? void 0 : ve.name,
                        level: Qe == null || (ye = Qe.email) === null || ye === void 0 ? void 0 : ye.level
                      }
                    });
                  case 4:
                    return zt.abrupt("return", zt.sent);
                  case 5:
                  case "end":
                    return zt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Remove the participant with a given identity from a conversation.
         */
      }, {
        key: "remove",
        value: function(ae) {
          return this.services.commandExecutor.mutateResource("delete", "".concat(this.links.participants, "/").concat(encodeURIComponent(ae)));
        }
      }]), be;
    }(b.ReplayEventEmitter), Er = /* @__PURE__ */ function() {
      function Ee(je, be) {
        var oe;
        F.default(this, Ee), H.default(this, "mcsMedia", null), this.services = be, je instanceof I.McsMedia && (this.mcsMedia = je), this.state = {
          sid: je.sid,
          category: je.category,
          filename: (oe = je.filename) !== null && oe !== void 0 ? oe : null,
          contentType: je.contentType,
          size: je.size
        };
      }
      return j.default(Ee, [{
        key: "sid",
        get: function() {
          return this.state.sid;
        }
        /**
         * File name. Null if absent.
         */
      }, {
        key: "filename",
        get: function() {
          return this.state.filename;
        }
        /**
         * Content type of the media.
         */
      }, {
        key: "contentType",
        get: function() {
          return this.state.contentType;
        }
        /**
         * Size of the media in bytes.
         */
      }, {
        key: "size",
        get: function() {
          return this.state.size;
        }
        /**
         * Media category, can be one of the {@link MediaCategory} values.
         */
      }, {
        key: "category",
        get: function() {
          return this.state.category;
        }
        /**
         * Returns the direct content URL for the media.
         *
         * This URL is impermanent, it will expire in several minutes and cannot be cached.
         * If the URL becomes expired, you need to request a new one.
         * Each call to this function produces a new temporary URL.
         */
      }, {
        key: "getContentTemporaryUrl",
        value: function() {
          var be = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function ae(xe, ue, pe) {
              var ve, ye, Ae, Qe;
              return z.default.wrap(function(Tt) {
                for (; ; )
                  switch (Tt.prev = Tt.next) {
                    case 0:
                      if (ye = be.mcsMedia ? void 0 : be._fetchMcsMedia(), Ae = (ve = be.mcsMedia) === null || ve === void 0 ? void 0 : ve.getContentUrl(), pe(function() {
                        ye && ye.cancel(), Ae && Ae.cancel();
                      }), Tt.prev = 3, Ae) {
                        Tt.next = 9;
                        break;
                      }
                      return Tt.next = 7, ye;
                    case 7:
                      Qe = Tt.sent, Ae = Qe == null ? void 0 : Qe.getContentUrl();
                    case 9:
                      if (Tt.t0 = xe, !Ae) {
                        Tt.next = 16;
                        break;
                      }
                      return Tt.next = 13, Ae;
                    case 13:
                      Tt.t1 = Tt.sent, Tt.next = 17;
                      break;
                    case 16:
                      Tt.t1 = null;
                    case 17:
                      Tt.t2 = Tt.t1, (0, Tt.t0)(Tt.t2), Tt.next = 24;
                      break;
                    case 21:
                      Tt.prev = 21, Tt.t3 = Tt.catch(3), ue(Tt.t3);
                    case 24:
                    case "end":
                      return Tt.stop();
                  }
              }, ae, null, [[3, 21]]);
            }));
            return function(ae, xe, ue) {
              return oe.apply(this, arguments);
            };
          }());
        }
      }, {
        key: "_fetchMcsMedia",
        value: function() {
          var be = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function ae(xe, ue, pe) {
              var ve;
              return z.default.wrap(function(Ae) {
                for (; ; )
                  switch (Ae.prev = Ae.next) {
                    case 0:
                      return be.services.mcsClient === null && ue(new Error("Media Content Service is unavailable")), ve = be.services.mcsClient.get(be.state.sid), pe(function() {
                        return ve.cancel();
                      }), Ae.prev = 3, Ae.next = 6, ve;
                    case 6:
                      be.mcsMedia = Ae.sent, be.state = be.mcsMedia._state(), xe(be.mcsMedia), Ae.next = 14;
                      break;
                    case 11:
                      Ae.prev = 11, Ae.t0 = Ae.catch(3), ue(Ae.t0);
                    case 14:
                    case "end":
                      return Ae.stop();
                  }
              }, ae, null, [[3, 11]]);
            }));
            return function(ae, xe, ue) {
              return oe.apply(this, arguments);
            };
          }());
        }
        /**
         * @internal
         */
      }, {
        key: "_state",
        value: function() {
          return this.state;
        }
      }]), Ee;
    }(), gr = /* @__PURE__ */ function() {
      function Ee(je) {
        F.default(this, Ee), this.state = je;
      }
      return j.default(Ee, [{
        key: "total",
        get: function() {
          return this.state.total;
        }
        /**
         * Message is considered as **sent** to a participant if the nearest upstream carrier accepted the message.
         *
         * @return Amount of participants that have the **sent** delivery status for the message.
         */
      }, {
        key: "sent",
        get: function() {
          return this.state.sent;
        }
        /**
         * Message is considered as **delivered** to a participant if Twilio has received confirmation of message
         * delivery from the upstream carrier, and, where available, the destination handset.
         *
         * @return Amount of participants that have the **delivered** delivery status for the message.
         */
      }, {
        key: "delivered",
        get: function() {
          return this.state.delivered;
        }
        /**
         * Message is considered as **read** by a participant, if the message has been delivered and opened by the
         * recipient in a conversation. The recipient must have enabled the read receipts.
         *
         * @return Amount of participants that have the **read** delivery status for the message.
         */
      }, {
        key: "read",
        get: function() {
          return this.state.read;
        }
        /**
         * Message is considered as **undelivered** to a participant if Twilio has received a delivery receipt
         * indicating that the message was not delivered. This can happen for many reasons including carrier content
         * filtering and the availability of the destination handset.
         *
         * @return Ammount of participants that have the **undelivered** delivery status for the message.
         */
      }, {
        key: "undelivered",
        get: function() {
          return this.state.undelivered;
        }
        /**
         * Message is considered as **failed** to be delivered to a participant if the message could not be sent.
         * This can happen for various reasons including queue overflows, account suspensions and media
         * errors (in the case of MMS for instance). Twilio does not charge you for failed messages.
         *
         * @return Amount of participants that have the **failed** delivery status for the message.
         */
      }, {
        key: "failed",
        get: function() {
          return this.state.failed;
        }
      }, {
        key: "_update",
        value: function(be) {
          this.state = be;
        }
      }, {
        key: "_isEquals",
        value: function(be) {
          var oe = this.total === be.total, ae = this.sent === be.sent, xe = this.delivered === be.delivered, ue = this.read === be.read, pe = this.undelivered === be.undelivered, ve = this.failed === be.failed;
          return oe && ae && xe && ue && pe && ve;
        }
      }]), Ee;
    }(), pr = /* @__PURE__ */ function() {
      function Ee(je, be, oe, ae) {
        F.default(this, Ee), this.state = {
          prevToken: oe,
          nextToken: ae,
          source: be,
          items: je
        };
      }
      return j.default(Ee, [{
        key: "hasNextPage",
        get: (
          /**
           * Indicates the existence of the next page.
           */
          function() {
            return !!this.state.nextToken;
          }
        )
        /**
         * Indicates the existence of the previous page
         */
      }, {
        key: "hasPrevPage",
        get: function() {
          return !!this.state.prevToken;
        }
        /**
         * Array of elements on the current page.
         */
      }, {
        key: "items",
        get: function() {
          return this.state.items;
        }
      }, {
        key: "nextPage",
        value: function() {
          return this.hasNextPage ? this.state.source(this.state.nextToken) : Promise.reject(new Error("No next page"));
        }
        /**
         * Request the previous page. Does not modify the existing object.
         */
      }, {
        key: "prevPage",
        value: function() {
          return this.hasPrevPage ? this.state.source(this.state.prevToken) : Promise.reject(new Error("No previous page"));
        }
      }]), Ee;
    }(), Xr = /* @__PURE__ */ j.default(
      /**
       * Unique identifier for the delivery receipt.
       */
      /**
       * Unique identifier for the message in the conversation.
       */
      /**
       * Unique identifier for the conversation.
       */
      /**
       * Unique identifier for the `‘channel’` message (e.g., `WAxx` for WhatsApp, `SMxx` for SMS).
       */
      /**
       * Unique identifier for the participant.
       */
      /**
       * Status of the message delivery.
       */
      /**
       * Numeric error code mapped from Status callback code. Information about the error codes can be found
       * [here](https://www.twilio.com/docs/sms/api/message-resource#delivery-related-errors).
       */
      /**
       * Date this delivery receipt was created on.
       */
      /**
       * Date this delivery receipt was last updated on.
       */
      /**
       * @internal
       */
      function Ee(je) {
        F.default(this, Ee), this.sid = je.sid, this.messageSid = je.message_sid, this.conversationSid = je.conversation_sid, this.channelMessageSid = je.channel_message_sid, this.participantSid = je.participant_sid, this.status = je.status || "queued", this.errorCode = je.error_code || 0, this.dateCreated = je.date_created, this.dateUpdated = je.date_updated;
      }
    ), Yr = function(je) {
      return je.map(function(be) {
        var oe, ae, xe, ue, pe = JSON.stringify(be);
        switch (be.type) {
          case "QUICK_REPLY":
            return {
              type: "reply",
              title: be.title,
              id: (oe = be.id) !== null && oe !== void 0 ? oe : "",
              index: (ae = be.index) !== null && ae !== void 0 ? ae : 0,
              rawData: pe
            };
          case "PHONE_NUMBER":
            return {
              type: "phone",
              title: be.title,
              phone: (xe = be.phone) !== null && xe !== void 0 ? xe : "",
              rawData: pe
            };
          case "URL":
            return {
              type: "url",
              title: be.title,
              url: (ue = be.url) !== null && ue !== void 0 ? ue : "",
              rawData: pe
            };
          default:
            return {
              type: "other",
              rawData: pe
            };
        }
      });
    }, at = function(je, be) {
      var oe = JSON.stringify(be);
      switch (je) {
        case "twilio/text": {
          var ae = be;
          return {
            type: "text",
            body: ae.body,
            rawData: oe
          };
        }
        case "twilio/media": {
          var xe = be;
          return {
            type: "media",
            body: xe.body,
            media: xe.media,
            rawData: oe
          };
        }
        case "twilio/location": {
          var ue = be;
          return {
            type: "location",
            longitude: ue.longitude,
            latitude: ue.latitude,
            label: ue.label,
            rawData: oe
          };
        }
        case "twilio/quick-reply": {
          var pe = be;
          return {
            type: "quickReply",
            body: pe.body,
            replies: pe.actions,
            rawData: oe
          };
        }
        case "twilio/call-to-action": {
          var ve = be;
          return {
            type: "callToAction",
            body: ve.body,
            actions: Yr(ve.actions),
            rawData: oe
          };
        }
        case "twilio/list-picker": {
          var ye = be;
          return {
            type: "listPicker",
            body: ye.body,
            button: ye.button,
            items: ye.items,
            rawData: oe
          };
        }
        case "twilio/card": {
          var Ae, Qe, pt = be;
          return {
            type: "card",
            title: pt.title,
            subtitle: pt.subtitle,
            media: (Ae = pt.media) !== null && Ae !== void 0 ? Ae : [],
            actions: Yr((Qe = pt.actions) !== null && Qe !== void 0 ? Qe : []),
            rawData: oe
          };
        }
        default:
          return {
            type: "other",
            rawData: oe
          };
      }
    }, Vt = function(je) {
      for (var be = /* @__PURE__ */ new Map(), oe = 0, ae = Object.entries(je); oe < ae.length; oe++) {
        var xe = Y.default(ae[oe], 2), ue = xe[0], pe = xe[1];
        be.set(ue, at(ue, pe));
      }
      return be;
    }, er = /* @__PURE__ */ function() {
      function Ee(je, be) {
        F.default(this, Ee), this.name = je, this.value = be;
      }
      return j.default(Ee, [{
        key: "copyWithValue",
        value: function(be) {
          return new Ee(this.name, be);
        }
      }]), Ee;
    }(), fr = /* @__PURE__ */ j.default(
      /**
       * The server-assigned unique identifier for the template.
       */
      /**
       * Friendly name used to describe the content. Not visible to the recipient.
       */
      /**
       * Variables used by this template.
       */
      /**
       * Variants of the content. See {@link ContentData}.
       */
      /**
       * Date of creation.
       */
      /**
       * Date of the last update.
       */
      /**
       * @internal
       */
      function Ee(je) {
        F.default(this, Ee), this.sid = je.sid, this.friendlyName = je.friendly_name, this.variables = Object.entries(JSON.parse(je.variables)).map(function(be) {
          var oe = Y.default(be, 2), ae = oe[0], xe = oe[1];
          return new er(ae, xe);
        }), this.variants = Vt(je.variants), this.dateCreated = new Date(je.date_created), this.dateUpdated = new Date(je.date_updated);
      }
    );
    function tn(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function Kn(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? tn(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : tn(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    function Pr(Ee) {
      var je = Pt();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function Pt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function or(Ee, je) {
      Ht(Ee, je), je.add(Ee);
    }
    function Ht(Ee, je) {
      if (je.has(Ee))
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function Mt(Ee, je, be) {
      if (!je.has(Ee))
        throw new TypeError("attempted to get private field on non-instance");
      return be;
    }
    var Qt = we.scope("Message"), pn = (
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      e.XMLHttpRequest || {}
    ), Kr = /* @__PURE__ */ new WeakSet(), Da = /* @__PURE__ */ new WeakSet(), La = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Pr(be);
      function be(oe, ae, xe, ue, pe, ve) {
        var ye, Ae, Qe, pt, Tt, zt, mn, Tn;
        return F.default(this, be), Tn = je.call(this), or(v.default(Tn), Da), or(v.default(Tn), Kr), Tn.conversation = xe, Tn.links = ue, Tn.configuration = pe, Tn.services = ve, Tn.state = {
          sid: ae.sid,
          index: oe,
          author: ae.author,
          subject: ae.subject,
          contentSid: ae.contentSid,
          body: (ye = ae.text) !== null && ye !== void 0 ? ye : null,
          timestamp: ae.timestamp ? new Date(ae.timestamp) : null,
          dateUpdated: ae.dateUpdated ? new Date(ae.dateUpdated) : null,
          lastUpdatedBy: (Ae = ae.lastUpdatedBy) !== null && Ae !== void 0 ? Ae : null,
          attributes: Jt(ae.attributes, "Got malformed attributes for the message ".concat(ae.sid), Qt),
          type: (Qe = ae.type) !== null && Qe !== void 0 ? Qe : "text",
          media: null,
          medias: null,
          participantSid: (pt = ae.memberSid) !== null && pt !== void 0 ? pt : null,
          aggregatedDeliveryReceipt: ae.delivery ? new gr(ae.delivery) : null,
          hasChannelMetadata: (Tt = ae.channelMetadata) !== null && Tt !== void 0 ? Tt : !1
        }, Mt(v.default(Tn), Da, Zo).call(v.default(Tn), (zt = ae.medias) !== null && zt !== void 0 ? zt : null, (mn = ae.media) !== null && mn !== void 0 ? mn : null), Tn;
      }
      return j.default(be, [{
        key: "sid",
        get: (
          /**
           * The server-assigned unique identifier for the message.
           */
          function() {
            return this.state.sid;
          }
        )
        /**
         * Name of the user that sent the message.
         */
      }, {
        key: "author",
        get: function() {
          return this.state.author;
        }
        /**
         * Message subject. Used only in email conversations.
         */
      }, {
        key: "subject",
        get: function() {
          return this.state.subject;
        }
        /**
         * Unique identifier of {@link ContentTemplate} for this message.
         */
      }, {
        key: "contentSid",
        get: function() {
          return this.state.contentSid;
        }
        /**
         * Body of the message.
         */
      }, {
        key: "body",
        get: function() {
          return this.state.body;
        }
        /**
         * Date this message was last updated on.
         */
      }, {
        key: "dateUpdated",
        get: function() {
          return this.state.dateUpdated;
        }
        /**
         * Index of this message in the conversation's list of messages.
         *
         * By design, the message indices may have arbitrary gaps between them,
         * that does not necessarily mean they were deleted or otherwise modified - just that
         * messages may have some non-contiguous indices even if they are being sent immediately one after another.
         *
         * Trying to use indices for some calculations is going to be unreliable.
         *
         * To calculate the number of unread messages, it is better to use the Read Horizon API.
         * See {@link Conversation.getUnreadMessagesCount} for details.
         */
      }, {
        key: "index",
        get: function() {
          return this.state.index;
        }
        /**
         * Identity of the last user that updated the message.
         */
      }, {
        key: "lastUpdatedBy",
        get: function() {
          return this.state.lastUpdatedBy;
        }
        /**
         * Date this message was created on.
         */
      }, {
        key: "dateCreated",
        get: function() {
          return this.state.timestamp;
        }
        /**
         * Custom attributes of the message.
         */
      }, {
        key: "attributes",
        get: function() {
          return this.state.attributes;
        }
        /**
         * Type of the message.
         */
      }, {
        key: "type",
        get: function() {
          return this.state.type;
        }
        /**
         * One of the attached media (if present).
         * @deprecated Use attachedMedia instead. Note that the latter is now an array.
         */
      }, {
        key: "media",
        get: function() {
          return this.state.media;
        }
        /**
         * Return all media attachments, except email body/history attachments, without temporary urls.
         */
      }, {
        key: "attachedMedia",
        get: function() {
          return this.getMediaByCategories(["media"]);
        }
        /**
         * The server-assigned unique identifier of the authoring participant.
         */
      }, {
        key: "participantSid",
        get: function() {
          return this.state.participantSid;
        }
        /**
         * Aggregated information about the message delivery statuses across all participants of a conversation..
         */
      }, {
        key: "aggregatedDeliveryReceipt",
        get: function() {
          return this.state.aggregatedDeliveryReceipt;
        }
        /**
         * @deprecated
         * Return a (possibly empty) array of media matching a specific set of categories.
         * Allowed category is so far only 'media'.
         * @param categories Array of categories to match.
         * @returns Array of media descriptors matching given categories.
         */
      }, {
        key: "getMediaByCategory",
        value: function(ae) {
          return this.getMediaByCategories(ae);
        }
        /**
         * Return a (possibly empty) array of media matching a specific set of categories.
         * Allowed category is so far only 'media'.
         * @param categories Array of categories to match.
         * @returns Array of media descriptors matching given categories.
         */
      }, {
        key: "getMediaByCategories",
        value: function(ae) {
          var xe;
          return ((xe = this.state.medias) !== null && xe !== void 0 ? xe : []).filter(function(ue) {
            return ae.includes(ue.category);
          });
        }
        /**
         * Get a media descriptor for an email body attachment of a provided type.
         * Allowed body types are returned in the Conversation.limits().emailBodiesAllowedContentTypes array.
         * @param type Type of email body to request, defaults to `text/plain`.
         */
      }, {
        key: "getEmailBody",
        value: function() {
          var ae, xe, ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
          return (ae = (xe = this.getMediaByCategories(["body"])) === null || xe === void 0 ? void 0 : xe.filter(function(pe) {
            return pe.contentType == ue;
          }).shift()) !== null && ae !== void 0 ? ae : null;
        }
        /**
         * Get a media descriptor for an email history attachment of a provided type.
         * Allowed body types are returned in the Conversation.limits().emailHistoriesAllowedContentTypes array.
         * @param type Type of email history to request, defaults to `text/plain`.
         */
      }, {
        key: "getEmailHistory",
        value: function() {
          var ae, xe, ue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "text/plain";
          return (ae = (xe = this.getMediaByCategories(["history"])) === null || xe === void 0 ? void 0 : xe.filter(function(pe) {
            return pe.contentType == ue;
          }).shift()) !== null && ae !== void 0 ? ae : null;
        }
      }, {
        key: "_update",
        value: function(ae) {
          var xe, ue = this, pe, ve, ye, Ae = [];
          (ae.text || typeof ae.text == "string") && ae.text !== this.state.body && (this.state.body = ae.text, Ae.push("body")), ae.subject && ae.subject !== this.state.subject && (this.state.subject = ae.subject, Ae.push("subject")), ae.lastUpdatedBy && ae.lastUpdatedBy !== this.state.lastUpdatedBy && (this.state.lastUpdatedBy = ae.lastUpdatedBy, Ae.push("lastUpdatedBy")), ae.author && ae.author !== this.state.author && (this.state.author = ae.author, Ae.push("author")), ae.dateUpdated && new Date(ae.dateUpdated).getTime() !== (this.state.dateUpdated && this.state.dateUpdated.getTime()) && (this.state.dateUpdated = new Date(ae.dateUpdated), Ae.push("dateUpdated")), ae.timestamp && new Date(ae.timestamp).getTime() !== (this.state.timestamp && this.state.timestamp.getTime()) && (this.state.timestamp = new Date(ae.timestamp), Ae.push("dateCreated"));
          var Qe = Jt(ae.attributes, "Got malformed attributes for the message ".concat(this.sid), Qt);
          V.default(this.state.attributes, Qe) || (this.state.attributes = Qe, Ae.push("attributes"));
          var pt = ae.delivery, Tt = this.state.aggregatedDeliveryReceipt, zt = !!pt && !!pt.total && !!pt.delivered && !!pt.failed && !!pt.read && !!pt.sent && !!pt.undelivered;
          zt && (Tt ? Tt._isEquals(pt) || (Tt._update(pt), Ae.push("deliveryReceipt")) : (this.state.aggregatedDeliveryReceipt = new gr(pt), Ae.push("deliveryReceipt")));
          var mn = ((xe = ae.medias) !== null && xe !== void 0 ? xe : []).map(function(Fs) {
            var Ki;
            return (Ki = Mt(ue, Kr, ji).call(ue, Fs)) === null || Ki === void 0 ? void 0 : Ki._state();
          }).filter(function(Fs) {
            return Fs !== null;
          }), Tn = ((pe = this.state.medias) !== null && pe !== void 0 ? pe : []).map(function(Fs) {
            return Fs._state();
          }).filter(function(Fs) {
            return Fs !== null;
          });
          if (!V.default(mn, Tn) || !V.default((ve = Mt(this, Kr, ji).call(this, ae.media)) === null || ve === void 0 ? void 0 : ve._state(), (ye = this.state.media) === null || ye === void 0 ? void 0 : ye._state())) {
            var Zn, ia;
            Mt(this, Da, Zo).call(this, (Zn = ae.medias) !== null && Zn !== void 0 ? Zn : null, (ia = ae.media) !== null && ia !== void 0 ? ia : null), Ae.push("media");
          }
          Ae.length > 0 && this.emit("updated", {
            message: this,
            updateReasons: Ae
          });
        }
        /**
         * Get the participant who is the author of the message.
         */
      }, {
        key: "getParticipant",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    if (pe = null, !this.state.participantSid) {
                      Ae.next = 5;
                      break;
                    }
                    return Ae.next = 4, this.conversation.getParticipantBySid(this.state.participantSid).catch(function() {
                      return Qt.debug('Participant with sid "'.concat(ue.participantSid, '" not found for message ').concat(ue.sid)), null;
                    });
                  case 4:
                    pe = Ae.sent;
                  case 5:
                    if (!(!pe && this.state.author)) {
                      Ae.next = 9;
                      break;
                    }
                    return Ae.next = 8, this.conversation.getParticipantByIdentity(this.state.author).catch(function() {
                      return Qt.debug('Participant with identity "'.concat(ue.author, '" not found for message ').concat(ue.sid)), null;
                    });
                  case 8:
                    pe = Ae.sent;
                  case 9:
                    if (!pe) {
                      Ae.next = 11;
                      break;
                    }
                    return Ae.abrupt("return", pe);
                  case 11:
                    throw ve = "Participant with ", this.state.participantSid && (ve += "SID '" + this.state.participantSid + "' "), this.state.author && (this.state.participantSid && (ve += "or "), ve += "identity '" + this.state.author + "' "), ve === "Participant with " && (ve = "Participant "), ve += "was not found", new Error(ve);
                  case 17:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get the delivery receipts of the message.
         */
      }, {
        key: "getDetailedDeliveryReceipts",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._getDetailedDeliveryReceiptsPaginator();
                  case 2:
                    ue = ye.sent, pe = ue.items;
                  case 4:
                    if (!ue.hasNextPage) {
                      ye.next = 11;
                      break;
                    }
                    return ye.next = 7, ue.nextPage();
                  case 7:
                    ue = ye.sent, pe = [].concat(Z.default(pe), Z.default(ue.items)), ye.next = 4;
                    break;
                  case 11:
                    return ye.abrupt("return", pe);
                  case 12:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Remove the message.
         */
      }, {
        key: "remove",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this.services.commandExecutor.mutateResource("delete", this.links.self);
                  case 2:
                    return pe.abrupt("return", this);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Edit the message body.
         * @param body New body of the message.
         */
      }, {
        key: "updateBody",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                      body: ue
                    });
                  case 2:
                    return ve.abrupt("return", this);
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Edit the message attributes.
         * @param attributes New attributes.
         */
      }, {
        key: "updateAttributes",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this.services.commandExecutor.mutateResource("post", this.links.self, {
                      attributes: typeof ue < "u" ? JSON.stringify(ue) : void 0
                    });
                  case 2:
                    return ve.abrupt("return", this);
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * @deprecated
         * Get content URLs for all media attachments in the given set using a single operation.
         * @param contentSet Set of media attachments to query content URLs.
         */
      }, {
        key: "attachTemporaryUrlsFor",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    if (ve = ue == null ? void 0 : ue.map(function(Qe) {
                      return Qe.sid;
                    }), !(this.services.mcsClient && ve)) {
                      Ae.next = 7;
                      break;
                    }
                    return Ae.next = 4, this.services.mcsClient.mediaSetGet(ve);
                  case 4:
                    return Ae.abrupt("return", Ae.sent.map(function(Qe) {
                      return new Er(Qe, pe.services);
                    }));
                  case 7:
                    throw new Error("Media Content Service is unavailable");
                  case 8:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get content URLs for all media attachments in the given set using a single operation.
         * @param contentSet Set of media attachments to query content URLs.
         */
      }, {
        key: "getTemporaryContentUrlsForMedia",
        value: function(ae) {
          var xe = ae.map(function(ue) {
            return ue.sid;
          });
          return this.getTemporaryContentUrlsForMediaSids(xe);
        }
        /**
         * Get content URLs for all media attachments in the given set of media sids using a single operation.
         * @param mediaSids Set of media sids to query for the content URL.
         */
      }, {
        key: "getTemporaryContentUrlsForMediaSids",
        value: function(ae) {
          var xe = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var ue = m.default(/* @__PURE__ */ z.default.mark(function pe(ve, ye, Ae) {
              var Qe, pt;
              return z.default.wrap(function(zt) {
                for (; ; )
                  switch (zt.prev = zt.next) {
                    case 0:
                      if (Qe = xe.services.mcsClient.mediaSetGetContentUrls(ae ?? []), !(!xe.services.mcsClient || !ae)) {
                        zt.next = 4;
                        break;
                      }
                      return ye(new Error("Media Content Service is unavailable")), zt.abrupt("return");
                    case 4:
                      return Ae(function() {
                        Qe.cancel();
                      }), zt.prev = 5, zt.next = 8, Qe;
                    case 8:
                      pt = zt.sent, ve(pt), zt.next = 15;
                      break;
                    case 12:
                      zt.prev = 12, zt.t0 = zt.catch(5), ye(zt.t0);
                    case 15:
                    case "end":
                      return zt.stop();
                  }
              }, pe, null, [[5, 12]]);
            }));
            return function(pe, ve, ye) {
              return ue.apply(this, arguments);
            };
          }());
        }
        /**
         * Get content URLs for all media attached to the message.
         */
      }, {
        key: "getTemporaryContentUrlsForAttachedMedia",
        value: function() {
          var ae, xe = this.attachedMedia, ue = (ae = xe == null ? void 0 : xe.map(function(pe) {
            return pe.sid;
          })) !== null && ae !== void 0 ? ae : [];
          return this.getTemporaryContentUrlsForMediaSids(ue);
        }
      }, {
        key: "_getDetailedDeliveryReceiptsPaginator",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this, ve, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    return ve = this.configuration.links.messagesReceipts.replace("%s", this.conversation.sid).replace("%s", this.sid), ye = new ne(ve).arg("PageToken", ue == null ? void 0 : ue.pageToken).arg("PageSize", ue == null ? void 0 : ue.pageSize).build(), pt.next = 4, this.services.network.get(ye);
                  case 4:
                    return Ae = pt.sent, pt.abrupt("return", new pr(Ae.body.delivery_receipts.map(function(Tt) {
                      return new Xr(Tt);
                    }), function(Tt, zt) {
                      return pe._getDetailedDeliveryReceiptsPaginator({
                        pageToken: Tt,
                        pageSize: zt
                      });
                    }, Ae.body.meta.previous_token, Ae.body.meta.next_token));
                  case 6:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get the {@link ContentData} for this message. Resolves to `null` when
         * {@link Message.contentSid} is null.
         */
      }, {
        key: "getContentData",
        value: function() {
          var ae = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var xe = m.default(/* @__PURE__ */ z.default.mark(function ue(pe, ve, ye) {
              var Ae, Qe, pt, Tt, zt, mn, Tn, Zn, ia, Fs;
              return z.default.wrap(function(Wn) {
                for (; ; )
                  switch (Wn.prev = Wn.next) {
                    case 0:
                      if (ae.state.contentSid !== null) {
                        Wn.next = 3;
                        break;
                      }
                      return pe(null), Wn.abrupt("return");
                    case 3:
                      if (Ae = ae.getMediaByCategories(["body"]), Ae !== null) {
                        Wn.next = 7;
                        break;
                      }
                      return pe(null), Wn.abrupt("return");
                    case 7:
                      if (Qe = "application/x-vnd.com.twilio.rich.", pt = Ae.filter(function(Xs) {
                        return Xs.contentType.startsWith(Qe);
                      }), pt.length !== 0) {
                        Wn.next = 12;
                        break;
                      }
                      return pe(null), Wn.abrupt("return");
                    case 12:
                      return Tt = pt[0], zt = Tt.getContentTemporaryUrl(), ye(function() {
                        zt.cancel();
                      }), Wn.prev = 15, Wn.next = 18, zt;
                    case 18:
                      mn = Wn.sent, Wn.next = 25;
                      break;
                    case 21:
                      return Wn.prev = 21, Wn.t0 = Wn.catch(15), ve(Wn.t0), Wn.abrupt("return");
                    case 25:
                      if (mn !== null) {
                        Wn.next = 28;
                        break;
                      }
                      return pe(null), Wn.abrupt("return");
                    case 28:
                      return Tn = new Promise(function(Xs, Ef) {
                        var Mn, Ku = !1, jo = new pn();
                        jo.open("GET", (Mn = mn) !== null && Mn !== void 0 ? Mn : "", !0), jo.responseType = "text", jo.onreadystatechange = function() {
                          jo.readyState !== 4 || Ku || Xs(jo.responseText);
                        }, jo.onerror = function() {
                          Ef(jo.statusText);
                        }, ye(function() {
                          Ku = !0, jo.abort(), Ef(new Error("XHR has been aborted"));
                        }), jo.send();
                      }), Wn.prev = 29, Wn.next = 32, Tn;
                    case 32:
                      ia = Wn.sent, Zn = JSON.parse(ia), Wn.next = 40;
                      break;
                    case 36:
                      return Wn.prev = 36, Wn.t1 = Wn.catch(29), ve(Wn.t1), Wn.abrupt("return");
                    case 40:
                      Fs = Tt.contentType.replace(Qe, "").replace(".", "/"), pe(at(Fs, Zn.data));
                    case 42:
                    case "end":
                      return Wn.stop();
                  }
              }, ue, null, [[15, 21], [29, 36]]);
            }));
            return function(ue, pe, ve) {
              return xe.apply(this, arguments);
            };
          }());
        }
        /**
         * Get the {@link ChannelMetadata} for this message. Resolves to `null` if
         * the message doesn't have any channel metadata.
         */
      }, {
        key: "getChannelMetadata",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    if (this.state.hasChannelMetadata) {
                      pe.next = 2;
                      break;
                    }
                    return pe.abrupt("return", null);
                  case 2:
                    return pe.next = 4, this.services.channelMetadataClient.getChannelMetadata(this.conversation.sid, this.sid);
                  case 4:
                    return pe.abrupt("return", pe.sent);
                  case 5:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get recipients of the message.
         */
      }, {
        key: "getMessageRecipients",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this.services.messageRecipientsClient.getRecipientsFromMessage(this.conversation.sid, this.sid);
                  case 2:
                    return pe.abrupt("return", pe.sent);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }]), be;
    }(b.ReplayEventEmitter);
    function ji(Ee) {
      var je = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      return Ee ? je ? new Er(Kn(Kn({}, Ee), {}, {
        category: je
      }), this.services) : new Er(Ee, this.services) : null;
    }
    function Zo(Ee, je) {
      var be = this;
      this.state.media = Mt(this, Kr, ji).call(this, je), this.state.medias = Ee ? Ee.map(function(oe) {
        return Mt(be, Kr, ji).call(be, oe);
      }).filter(function(oe) {
        return oe !== null;
      }) : je && !Ee ? [Mt(this, Kr, ji).call(this, je, "media")].filter(function(oe) {
        return oe !== null;
      }) : null;
    }
    H.default(La, "updated", "updated"), ce([M.deprecated("getMediaByCategory", "getMediaByCategories"), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", Array)], La.prototype, "getMediaByCategory", null), ce([g.validateTypes([g.nonEmptyString, "undefined"]), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Er)], La.prototype, "getEmailBody", null), ce([g.validateTypes([g.nonEmptyString, "undefined"]), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Er)], La.prototype, "getEmailHistory", null), ce([g.validateTypesAsync("string"), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], La.prototype, "updateBody", null), ce([g.validateTypesAsync(re), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], La.prototype, "updateAttributes", null), ce([M.deprecated("attachTemporaryUrlsFor", "getTemporaryContentUrlsForMedia"), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", Promise)], La.prototype, "attachTemporaryUrlsFor", null), ce([g.validateTypesAsync(g.nonEmptyArray("media", Er)), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", I.CancellablePromise)], La.prototype, "getTemporaryContentUrlsForMedia", null), ce([g.validateTypesAsync(g.nonEmptyArray("strings", "string")), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", I.CancellablePromise)], La.prototype, "getTemporaryContentUrlsForMediaSids", null);
    function kr(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function qi(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? kr(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : kr(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    function vi(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = Ho(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function Ho(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return Ec(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return Ec(Ee, je);
      }
    }
    function Ec(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    function Uu(Ee) {
      var je = Ic();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function Ic() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var js = we.scope("Messages"), Mc = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Uu(be);
      function be(oe, ae, xe) {
        var ue;
        return F.default(this, be), ue = je.call(this), ue.conversation = oe, ue.configuration = ae, ue.services = xe, ue.messagesByIndex = /* @__PURE__ */ new Map(), ue.messagesListPromise = null, ue;
      }
      return j.default(be, [{
        key: "subscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    if (!this.messagesListPromise) {
                      Ae.next = 2;
                      break;
                    }
                    return Ae.abrupt("return", this.messagesListPromise);
                  case 2:
                    return this.messagesListPromise = typeof ue == "string" ? this.services.syncClient.list({
                      id: ue,
                      mode: "open_existing"
                    }) : Promise.resolve(ue), Ae.prev = 3, Ae.next = 6, this.messagesListPromise;
                  case 6:
                    return ve = Ae.sent, ve.on("itemAdded", function(Qe) {
                      js.debug("".concat(pe.conversation.sid, " itemAdded: ").concat(Qe.item.index));
                      var pt = {
                        self: "".concat(pe.conversation._links.messages, "/").concat(Qe.item.data.sid),
                        conversation: pe.conversation._links.self,
                        messages_receipts: "".concat(pe.conversation._links.messages, "/").concat(Qe.item.data.sid, "/Receipts")
                      }, Tt = new La(Qe.item.index, Qe.item.data, pe.conversation, pt, pe.configuration, pe.services);
                      if (pe.messagesByIndex.has(Tt.index)) {
                        js.debug("Message arrived, but is already known and ignored", pe.conversation.sid, Tt.index);
                        return;
                      }
                      pe.messagesByIndex.set(Tt.index, Tt), Tt.on("updated", function(zt) {
                        return pe.emit("messageUpdated", zt);
                      }), pe.emit("messageAdded", Tt);
                    }), ve.on("itemRemoved", function(Qe) {
                      js.debug("#{this.conversation.sid} itemRemoved: ".concat(Qe.index));
                      var pt = Qe.index;
                      if (pe.messagesByIndex.has(pt)) {
                        var Tt = pe.messagesByIndex.get(pt);
                        if (!Tt)
                          return;
                        pe.messagesByIndex.delete(Tt.index), Tt.removeAllListeners("updated"), pe.emit("messageRemoved", Tt);
                      }
                    }), ve.on("itemUpdated", function(Qe) {
                      js.debug("".concat(pe.conversation.sid, " itemUpdated: ").concat(Qe.item.index));
                      var pt = pe.messagesByIndex.get(Qe.item.index);
                      pt && pt._update(Qe.item.data);
                    }), Ae.abrupt("return", ve);
                  case 13:
                    throw Ae.prev = 13, Ae.t0 = Ae.catch(3), this.messagesListPromise = null, this.services.syncClient.connectionState !== "disconnected" && js.error("Failed to get messages object for conversation", this.conversation.sid, Ae.t0), js.debug("ERROR: Failed to get messages object for conversation", this.conversation.sid, Ae.t0), Ae.t0;
                  case 19:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this, [[3, 13]]);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "unsubscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (this.messagesListPromise) {
                      ve.next = 2;
                      break;
                    }
                    return ve.abrupt("return");
                  case 2:
                    return ve.next = 4, this.messagesListPromise;
                  case 4:
                    ue = ve.sent, ue.close(), this.messagesListPromise = null;
                  case 7:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Send a message to the conversation. The message could include text and multiple media attachments.
         * @param message Message to post
         */
      }, {
        key: "sendV2",
        value: function(ae) {
          var xe = this;
          return js.debug("Sending message V2", ae.mediaContent, ae.attributes, ae.emailOptions), new I.CancellablePromise(/* @__PURE__ */ function() {
            var ue = m.default(/* @__PURE__ */ z.default.mark(function pe(ve, ye, Ae) {
              var Qe, pt, Tt, zt, mn, Tn, Zn, ia, Fs, Ki, Wn, Xs;
              return z.default.wrap(function(Mn) {
                for (; ; )
                  switch (Mn.prev = Mn.next) {
                    case 0:
                      pt = [], Tt = [], Ae(function() {
                        Tt.forEach(function(Ku) {
                          return Ku.cancel();
                        });
                      }), zt = vi(ae.mediaContent), Mn.prev = 4, zt.s();
                    case 6:
                      if ((mn = zt.n()).done) {
                        Mn.next = 25;
                        break;
                      }
                      return Tn = Y.default(mn.value, 2), Zn = Tn[0], ia = Tn[1], Mn.prev = 8, js.debug("Adding media to a message as ".concat(ia instanceof FormData ? "FormData" : "SendMediaOptions"), ia), Wn = ia instanceof FormData ? xe.services.mcsClient.postFormData(ia, Zn) : xe.services.mcsClient.post((Fs = ia.contentType) !== null && Fs !== void 0 ? Fs : "", (Ki = ia.media) !== null && Ki !== void 0 ? Ki : "", Zn, ia.filename), Tt.push(Wn), Mn.t0 = pt, Mn.next = 15, Wn;
                    case 15:
                      Mn.t1 = Mn.sent, Mn.t0.push.call(Mn.t0, Mn.t1), Mn.next = 23;
                      break;
                    case 19:
                      return Mn.prev = 19, Mn.t2 = Mn.catch(8), ye(Mn.t2), Mn.abrupt("return");
                    case 23:
                      Mn.next = 6;
                      break;
                    case 25:
                      Mn.next = 30;
                      break;
                    case 27:
                      Mn.prev = 27, Mn.t3 = Mn.catch(4), zt.e(Mn.t3);
                    case 30:
                      return Mn.prev = 30, zt.f(), Mn.finish(30);
                    case 33:
                      return Xs = xe.services.commandExecutor.mutateResource("post", xe.conversation._links.messages, {
                        body: ae.text,
                        subject: (Qe = ae.emailOptions) === null || Qe === void 0 ? void 0 : Qe.subject,
                        media_sids: pt.map(function(Ku) {
                          return Ku.sid;
                        }),
                        attributes: typeof ae.attributes < "u" ? JSON.stringify(ae.attributes) : void 0,
                        content_sid: ae.contentSid,
                        content_variables: typeof ae.contentVariables < "u" ? JSON.stringify(ae.contentVariables.reduce(function(Ku, jo) {
                          return qi(qi({}, Ku), {}, H.default({}, jo.name, jo.value));
                        }, {})) : void 0
                      }), Mn.prev = 34, Mn.t4 = ve, Mn.next = 38, Xs;
                    case 38:
                      Mn.t5 = Mn.sent, (0, Mn.t4)(Mn.t5), Mn.next = 45;
                      break;
                    case 42:
                      Mn.prev = 42, Mn.t6 = Mn.catch(34), ye(Mn.t6);
                    case 45:
                    case "end":
                      return Mn.stop();
                  }
              }, pe, null, [[4, 27, 30, 33], [8, 19], [34, 42]]);
            }));
            return function(pe, ve, ye) {
              return ue.apply(this, arguments);
            };
          }());
        }
        /**
         * Send Message to the conversation
         * @param message Message to post
         * @param attributes Message attributes
         * @param emailOptions Options that modify E-mail integration behaviors.
         * @returns Returns promise which can fail
         */
      }, {
        key: "send",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye = arguments;
            return z.default.wrap(function(Qe) {
              for (; ; )
                switch (Qe.prev = Qe.next) {
                  case 0:
                    return pe = ye.length > 1 && ye[1] !== void 0 ? ye[1] : {}, ve = ye.length > 2 ? ye[2] : void 0, js.debug("Sending text message", ue, pe, ve), Qe.abrupt("return", this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                      body: ue ?? "",
                      attributes: typeof pe < "u" ? JSON.stringify(pe) : void 0,
                      subject: ve == null ? void 0 : ve.subject
                    }));
                  case 4:
                  case "end":
                    return Qe.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Send Media Message to the conversation
         * @param mediaContent Media content to post
         * @param attributes Message attributes
         * @param emailOptions Email options
         * @returns Returns promise which can fail
         */
      }, {
        key: "sendMedia",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae, Qe, pt = arguments;
            return z.default.wrap(function(zt) {
              for (; ; )
                switch (zt.prev = zt.next) {
                  case 0:
                    if (ye = pt.length > 1 && pt[1] !== void 0 ? pt[1] : {}, Ae = pt.length > 2 ? pt[2] : void 0, js.debug("Sending media message", ue, ye, Ae), js.debug("Sending media message as ".concat(ue instanceof FormData ? "FormData" : "SendMediaOptions"), ue, ye), !(ue instanceof FormData)) {
                      zt.next = 10;
                      break;
                    }
                    return zt.next = 7, this.services.mcsClient.postFormData(ue);
                  case 7:
                    zt.t0 = zt.sent, zt.next = 13;
                    break;
                  case 10:
                    return zt.next = 12, this.services.mcsClient.post((pe = ue.contentType) !== null && pe !== void 0 ? pe : "", (ve = ue.media) !== null && ve !== void 0 ? ve : "", "media", ue.filename);
                  case 12:
                    zt.t0 = zt.sent;
                  case 13:
                    return Qe = zt.t0, zt.next = 16, this.services.commandExecutor.mutateResource("post", this.conversation._links.messages, {
                      media_sids: [Qe.sid],
                      attributes: typeof ye < "u" ? JSON.stringify(ye) : void 0
                    });
                  case 16:
                    return zt.abrupt("return", zt.sent);
                  case 17:
                  case "end":
                    return zt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Returns messages from conversation using paginator interface
         * @param pageSize Number of messages to return in single chunk. By default it's 30.
         * @param anchor Most early message id which is already known, or 'end' by default
         * @param direction Pagination order 'backwards' or 'forward', 'forward' by default
         * @returns Last page of messages by default
         */
      }, {
        key: "getMessages",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve, ye = arguments;
            return z.default.wrap(function(Qe) {
              for (; ; )
                switch (Qe.prev = Qe.next) {
                  case 0:
                    return ve = ye.length > 2 && ye[2] !== void 0 ? ye[2] : "backwards", Qe.abrupt("return", this._getMessages(ue, pe, ve));
                  case 2:
                  case "end":
                    return Qe.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_wrapPaginator",
        value: function(ae, xe, ue) {
          var pe = this, ve = ae === "desc", ye = function() {
            return xe.nextPage().then(function(pt) {
              return pe._wrapPaginator(ae, pt, ue);
            });
          }, Ae = function() {
            return xe.prevPage().then(function(pt) {
              return pe._wrapPaginator(ae, pt, ue);
            });
          };
          return ue(xe.items).then(function(Qe) {
            return {
              items: Qe.sort(function(pt, Tt) {
                return pt.index - Tt.index;
              }),
              hasPrevPage: ve ? xe.hasNextPage : xe.hasPrevPage,
              hasNextPage: ve ? xe.hasPrevPage : xe.hasNextPage,
              prevPage: ve ? ye : Ae,
              nextPage: ve ? Ae : ye
            };
          });
        }
      }, {
        key: "_upsertMessage",
        value: function(ae, xe) {
          var ue = this, pe = this.messagesByIndex.get(ae);
          if (pe)
            return pe;
          var ve = {
            self: "".concat(this.conversation._links.messages, "/").concat(xe.sid),
            conversation: this.conversation._links.self,
            messages_receipts: "".concat(this.conversation._links.messages, "/").concat(xe.sid, "/Receipts")
          }, ye = new La(ae, xe, this.conversation, ve, this.configuration, this.services);
          return this.messagesByIndex.set(ye.index, ye), ye.on("updated", function(Ae) {
            return ue.emit("messageUpdated", Ae);
          }), ye;
        }
        /**
         * Returns last messages from conversation
         * @param {Number} [pageSize] Number of messages to return in single chunk. By default it's 30.
         * @param {String} [anchor] Most early message id which is already known, or 'end' by default
         * @param {String} [direction] Pagination order 'backwards' or 'forward', or 'forward' by default
         * @returns {Promise<SyncPaginator<Message>>} last page of messages by default
         * @private
         */
      }, {
        key: "_getMessages",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this, pe, ve, ye, Ae, Qe, pt, Tt = arguments;
            return z.default.wrap(function(mn) {
              for (; ; )
                switch (mn.prev = mn.next) {
                  case 0:
                    return pe = Tt.length > 0 && Tt[0] !== void 0 ? Tt[0] : 30, ve = Tt.length > 1 && Tt[1] !== void 0 ? Tt[1] : "end", ye = Tt.length > 2 && Tt[2] !== void 0 ? Tt[2] : "forward", Ae = ye === "backwards" ? "desc" : "asc", mn.next = 6, this.messagesListPromise;
                  case 6:
                    return Qe = mn.sent, mn.next = 9, Qe == null ? void 0 : Qe.getItems({
                      from: ve !== "end" ? ve : void 0,
                      pageSize: pe,
                      order: Ae,
                      limit: pe
                      // @todo Limit equals pageSize by default in Sync. This is probably not ideal.
                    });
                  case 9:
                    return pt = mn.sent, mn.next = 12, this._wrapPaginator(Ae, pt, function(Tn) {
                      return Promise.all(Tn.map(function(Zn) {
                        return ue._upsertMessage(Zn.index, Zn.data);
                      }));
                    });
                  case 12:
                    return mn.abrupt("return", mn.sent);
                  case 13:
                  case "end":
                    return mn.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }]), be;
    }(b.ReplayEventEmitter), Vu = /* @__PURE__ */ function() {
      function Ee(je) {
        F.default(this, Ee), H.default(this, "attributes", {}), H.default(this, "mediaContent", []), H.default(this, "emailOptions", {}), this.messagesEntity = je;
      }
      return j.default(Ee, [{
        key: "send",
        value: function() {
          var be = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function ae(xe, ue, pe) {
              var ve, ye;
              return z.default.wrap(function(Qe) {
                for (; ; )
                  switch (Qe.prev = Qe.next) {
                    case 0:
                      return ve = be.messagesEntity.sendV2(be), pe(function() {
                        return ve.cancel();
                      }), Qe.prev = 2, Qe.next = 5, ve;
                    case 5:
                      ye = Qe.sent, xe(mt(ye.index)), Qe.next = 12;
                      break;
                    case 9:
                      Qe.prev = 9, Qe.t0 = Qe.catch(2), ue(Qe.t0);
                    case 12:
                    case "end":
                      return Qe.stop();
                  }
              }, ae, null, [[2, 9]]);
            }));
            return function(ae, xe, ue) {
              return oe.apply(this, arguments);
            };
          }());
        }
      }]), Ee;
    }(), So = /* @__PURE__ */ function() {
      function Ee(je, be) {
        F.default(this, Ee), this.limits = je, this.message = new Vu(be), this.emailBodies = /* @__PURE__ */ new Map(), this.emailHistories = /* @__PURE__ */ new Map();
      }
      return j.default(Ee, [{
        key: "setBody",
        value: function(be) {
          return this.message.text = be, this;
        }
        /**
         * Sets the message subject.
         * @param subject Contents of the subject.
         */
      }, {
        key: "setSubject",
        value: function(be) {
          return this.message.emailOptions.subject = be, this;
        }
        /**
         * Sets the message attributes.
         * @param attributes Message attributes.
         */
      }, {
        key: "setAttributes",
        value: function(be) {
          return this.message.attributes = be, this;
        }
        /**
         * Set the email body with a given content type.
         * @param contentType Format of the body to set (text/plain or text/html).
         * @param body Body payload in the selected format.
         */
      }, {
        key: "setEmailBody",
        value: function(be, oe) {
          return this.emailBodies.set(be, oe), this;
        }
        /**
         * Set the email history with a given content type.
         * @param contentType Format of the history to set (text/plain or text/html).
         * @param history History payload in the selected format.
         */
      }, {
        key: "setEmailHistory",
        value: function(be, oe) {
          return this.emailHistories.set(be, oe), this;
        }
        /**
         * Adds {@link ContentTemplate} SID for the message alongside optional
         * variables. When no variables provided, the default values will be used.
         *
         * Adding the content SID converts the message to a rich message. In this
         * case, other fields are ignored and the message is sent using the content
         * from the the {@link ContentTemplate}.
         *
         * Use {@link Client.getContentTemplates} to request all available
         * {@link ContentTemplate}s.
         *
         * @param contentSid SID of the {@link ContentTemplate}
         * @param variables Custom variables to resolve the template.
         */
      }, {
        key: "setContentTemplate",
        value: function(be) {
          var oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
          return this.message.contentSid = be, this.message.contentVariables = oe, this;
        }
        /**
         * Adds media to the message.
         * @param payload Media to add.
         */
      }, {
        key: "addMedia",
        value: function(be) {
          if (typeof FormData > "u" && be instanceof FormData)
            throw new Error("Could not add FormData content whilst not in a browser");
          if (!(be instanceof FormData)) {
            var oe = be;
            if (!oe.contentType || !oe.media)
              throw new Error("Media content in SendMediaOptions must contain non-empty contentType and media");
          }
          return this.message.mediaContent.push(["media", be]), this;
        }
        /**
         * Builds the message, making it ready to be sent.
         */
      }, {
        key: "build",
        value: function() {
          var be = this;
          if (this.emailBodies.forEach(function(oe, ae) {
            if (!be.limits.emailBodiesAllowedContentTypes.includes(ae))
              throw new Error("Unsupported email body content type ".concat(ae));
          }), this.emailHistories.forEach(function(oe, ae) {
            if (!be.limits.emailHistoriesAllowedContentTypes.includes(ae))
              throw new Error("Unsupported email history content type ".concat(ae));
          }), this.emailBodies.size > this.limits.emailBodiesAllowedContentTypes.length)
            throw new Error("Too many email bodies attached to the message (".concat(this.emailBodies.size, " > ").concat(this.limits.emailBodiesAllowedContentTypes.length, ")"));
          if (this.emailHistories.size > this.limits.emailHistoriesAllowedContentTypes.length)
            throw new Error("Too many email histories attached to the message (".concat(this.emailHistories.size, " > ").concat(this.limits.emailHistoriesAllowedContentTypes.length, ")"));
          if (this.message.mediaContent.length > this.limits.mediaAttachmentsCountLimit)
            throw new Error("Too many media attachments in the message (".concat(this.message.mediaContent.length, " > ").concat(this.limits.mediaAttachmentsCountLimit, ")"));
          return this.emailBodies.forEach(function(oe) {
            be.message.mediaContent.push(["body", oe]);
          }), this.emailHistories.forEach(function(oe) {
            be.message.mediaContent.push(["history", oe]);
          }), this.message;
        }
        /**
         * Prepares a message and sends it to the conversation.
         */
      }, {
        key: "buildAndSend",
        value: function() {
          return this.build().send();
        }
      }]), Ee;
    }();
    ce([g.validateTypes("string"), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", So)], So.prototype, "setBody", null), ce([g.validateTypes("string"), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", So)], So.prototype, "setSubject", null), ce([g.validateTypes(re), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", So)], So.prototype, "setAttributes", null), ce([g.validateTypes("string", [FormData, Ie]), ee("design:type", Function), ee("design:paramtypes", [String, Object]), ee("design:returntype", So)], So.prototype, "setEmailBody", null), ce([g.validateTypes("string", [FormData, Ie]), ee("design:type", Function), ee("design:paramtypes", [String, Object]), ee("design:returntype", So)], So.prototype, "setEmailHistory", null), ce([g.validateTypes("string", [g.array("content variables", er), "undefined"]), ee("design:type", Function), ee("design:paramtypes", [String, Array]), ee("design:returntype", So)], So.prototype, "setContentTemplate", null), ce([g.validateTypes([FormData, Ie]), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", So)], So.prototype, "addMedia", null);
    function Kl(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = Vi(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function Vi(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return iu(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return iu(Ee, je);
      }
    }
    function iu(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    function cc(Ee) {
      var je = Pc();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function Pc() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Jo = {
      lastMessage: "lastMessage",
      attributes: "attributes",
      createdBy: "createdBy",
      dateCreated: "dateCreated",
      dateUpdated: "dateUpdated",
      friendlyName: "friendlyName",
      lastConsumedMessageIndex: "lastConsumedMessageIndex",
      notificationLevel: "notificationLevel",
      sid: "sid",
      status: "status",
      uniqueName: "uniqueName",
      state: "state",
      bindings: "bindings"
    }, Ka = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = cc(be);
      function be(oe, ae, xe, ue, pe) {
        var ve, ye, Ae;
        F.default(this, be), Ae = je.call(this), Ae.sid = ae, Ae._links = xe, Ae._configuration = ue, Ae._services = pe, Ae._entityName = oe.channel, Ae._internalState = {
          uniqueName: oe.uniqueName || null,
          status: "notParticipating",
          attributes: (ve = oe.attributes) !== null && ve !== void 0 ? ve : {},
          createdBy: oe.createdBy,
          dateCreated: jt(oe.dateCreated),
          dateUpdated: jt(oe.dateUpdated),
          friendlyName: oe.friendlyName || null,
          lastReadMessageIndex: Number.isInteger(oe.lastConsumedMessageIndex) ? oe.lastConsumedMessageIndex : null,
          bindings: (ye = oe.bindings) !== null && ye !== void 0 ? ye : {}
        }, oe.notificationLevel && (Ae._internalState.notificationLevel = oe.notificationLevel);
        var Qe = {
          participants: Ae._links.participants
        };
        return Ae._participants = /* @__PURE__ */ new Map(), Ae._participantsEntity = new dr(
          v.default(Ae),
          Ae._participants,
          // state leak
          Qe,
          Ae._services
        ), Ae._participantsEntity.on(be.participantJoined, function(pt) {
          return (
            // @todo update participants map here??
            Ae.emit(be.participantJoined, pt)
          );
        }), Ae._participantsEntity.on(be.participantLeft, function(pt) {
          return (
            // @todo update participants map here??
            Ae.emit(be.participantLeft, pt)
          );
        }), Ae._participantsEntity.on(be.participantUpdated, function(pt) {
          return (
            // @todo update participants map here??
            Ae.emit(be.participantUpdated, pt)
          );
        }), Ae._messagesEntity = new Mc(v.default(Ae), ue, pe), Ae._messagesEntity.on(be.messageAdded, function(pt) {
          return Ae._onMessageAdded(pt);
        }), Ae._messagesEntity.on(be.messageUpdated, function(pt) {
          return Ae.emit(be.messageUpdated, pt);
        }), Ae._messagesEntity.on(be.messageRemoved, function(pt) {
          return Ae.emit(be.messageRemoved, pt);
        }), Ae;
      }
      return j.default(be, [{
        key: "uniqueName",
        get: function() {
          return this._internalState.uniqueName;
        }
        /**
         * Status of the conversation.
         */
      }, {
        key: "status",
        get: function() {
          return this._internalState.status;
        }
        /**
         * Name of the conversation.
         */
      }, {
        key: "friendlyName",
        get: function() {
          return this._internalState.friendlyName;
        }
        /**
         * Date this conversation was last updated on.
         */
      }, {
        key: "dateUpdated",
        get: function() {
          return this._internalState.dateUpdated;
        }
        /**
         * Date this conversation was created on.
         */
      }, {
        key: "dateCreated",
        get: function() {
          return this._internalState.dateCreated;
        }
        /**
         * Identity of the user that created this conversation.
         */
      }, {
        key: "createdBy",
        get: function() {
          var ae;
          return (ae = this._internalState.createdBy) !== null && ae !== void 0 ? ae : "";
        }
        /**
         * Custom attributes of the conversation.
         */
      }, {
        key: "attributes",
        get: function() {
          return this._internalState.attributes;
        }
        /**
         * Index of the last message the user has read in this conversation.
         */
      }, {
        key: "lastReadMessageIndex",
        get: function() {
          return this._internalState.lastReadMessageIndex;
        }
        /**
         * Last message sent to this conversation.
         */
      }, {
        key: "lastMessage",
        get: function() {
          var ae;
          return (ae = this._internalState.lastMessage) !== null && ae !== void 0 ? ae : void 0;
        }
        /**
         * User notification level for this conversation.
         */
      }, {
        key: "notificationLevel",
        get: function() {
          var ae;
          return (ae = this._internalState.notificationLevel) !== null && ae !== void 0 ? ae : "default";
        }
        /**
         * Conversation bindings. An undocumented feature (for now).
         * @internal
         */
      }, {
        key: "bindings",
        get: function() {
          return this._internalState.bindings;
        }
        /**
         * Current conversation limits.
         */
      }, {
        key: "limits",
        get: function() {
          return this._configuration.limits;
        }
        /**
         * State of the conversation.
         */
      }, {
        key: "state",
        get: function() {
          return this._internalState.state;
        }
        /**
         * Source of the conversation update.
         * @internal
         */
      }, {
        key: "_statusSource",
        get: function() {
          return this._dataSource;
        }
        /**
         * Preprocess the update object.
         * @param update The update object received from Sync.
         * @param conversationSid The SID of the conversation in question.
         */
      }, {
        key: "add",
        value: (
          /**
           * Add a participant to the conversation by its identity.
           * @param identity Identity of the Client to add.
           * @param attributes Attributes to be attached to the participant.
           * @returns The added participant.
           */
          function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
              return z.default.wrap(function(ye) {
                for (; ; )
                  switch (ye.prev = ye.next) {
                    case 0:
                      return ye.abrupt("return", this._participantsEntity.add(ue, pe ?? {}));
                    case 1:
                    case "end":
                      return ye.stop();
                  }
              }, xe, this);
            }));
            function ae(xe, ue) {
              return oe.apply(this, arguments);
            }
            return ae;
          }()
        )
        /**
         * Add a non-chat participant to the conversation.
         * @param proxyAddress Proxy (Twilio) address of the participant.
         * @param address User address of the participant.
         * @param attributes Attributes to be attached to the participant.
         * @param bindingOptions Options for adding email participants - name and
         * CC/To level.
         * @returns The added participant.
         */
      }, {
        key: "addNonChatParticipant",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve, ye, Ae = arguments;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    return ve = Ae.length > 2 && Ae[2] !== void 0 ? Ae[2] : {}, ye = Ae.length > 3 && Ae[3] !== void 0 ? Ae[3] : {}, pt.abrupt("return", this._participantsEntity.addNonChatParticipant(ue, pe, ve ?? {}, ye ?? {}));
                  case 3:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Advance the conversation's last read message index to the current read
         * horizon. Rejects if the user is not a participant of the conversation. Last
         * read message index is updated only if the new index value is higher than
         * the previous.
         * @param index Message index to advance to.
         * @return Resulting unread messages count in the conversation.
         */
      }, {
        key: "advanceLastReadMessageIndex",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._subscribeStreams();
                  case 2:
                    if (!(ue < ((pe = this.lastReadMessageIndex) !== null && pe !== void 0 ? pe : 0))) {
                      ye.next = 6;
                      break;
                    }
                    return ye.next = 5, this._setLastReadMessageIndex(this.lastReadMessageIndex);
                  case 5:
                    return ye.abrupt("return", ye.sent);
                  case 6:
                    return ye.next = 8, this._setLastReadMessageIndex(ue);
                  case 8:
                    return ye.abrupt("return", ye.sent);
                  case 9:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Delete the conversation and unsubscribe from its events.
         */
      }, {
        key: "delete",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._services.commandExecutor.mutateResource("delete", this._links.self);
                  case 2:
                    return pe.abrupt("return", this);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get the custom attributes of this Conversation.
         */
      }, {
        key: "getAttributes",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._subscribe();
                  case 2:
                    return pe.abrupt("return", this.attributes);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Returns messages from the conversation using the paginator interface.
         * @param pageSize Number of messages to return in a single chunk. Default is
         * 30.
         * @param anchor Index of the newest message to fetch. Default is from the
         * end.
         * @param direction Query direction. By default, it queries backwards
         * from newer to older. The `"forward"` value will query in the opposite
         * direction.
         * @return A page of messages.
         */
      }, {
        key: "getMessages",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe, ve) {
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return Ae.next = 2, this._subscribeStreams();
                  case 2:
                    return Ae.abrupt("return", this._messagesEntity.getMessages(ue, pe, ve));
                  case 3:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue, pe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a list of all the participants who are joined to this conversation.
         */
      }, {
        key: "getParticipants",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._subscribeStreams();
                  case 2:
                    return pe.abrupt("return", this._participantsEntity.getParticipants());
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get conversation participants count.
         *
         * This method is semi-realtime. This means that this data will be eventually
         * correct, but will also be possibly incorrect for a few seconds. The
         * Conversations system does not provide real time events for counter values
         * changes.
         *
         * This is useful for any UI badges, but it is not recommended to build any
         * core application logic based on these counters being accurate in real time.
         */
      }, {
        key: "getParticipantsCount",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return pe = new ne(this._configuration.links.conversations).path(this.sid).build(), Ae.next = 3, this._services.network.get(pe);
                  case 3:
                    return ve = Ae.sent, Ae.abrupt("return", (ue = ve.body.participants_count) !== null && ue !== void 0 ? ue : 0);
                  case 5:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a participant by its SID.
         * @param participantSid Participant SID.
         */
      }, {
        key: "getParticipantBySid",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.abrupt("return", this._participantsEntity.getParticipantBySid(ue));
                  case 1:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a participant by its identity.
         * @param identity Participant identity.
         */
      }, {
        key: "getParticipantByIdentity",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe = arguments;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ue = pe.length > 0 && pe[0] !== void 0 ? pe[0] : "", ye.abrupt("return", this._participantsEntity.getParticipantByIdentity(ue ?? ""));
                  case 2:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get the total message count in the conversation.
         *
         * This method is semi-realtime. This means that this data will be eventually
         * correct, but will also be possibly incorrect for a few seconds. The
         * Conversations system does not provide real time events for counter values
         * changes.
         *
         * This is useful for any UI badges, but it is not recommended to build any
         * core application logic based on these counters being accurate in real time.
         */
      }, {
        key: "getMessagesCount",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return pe = new ne(this._configuration.links.conversations).path(this.sid).build(), Ae.next = 3, this._services.network.get(pe);
                  case 3:
                    return ve = Ae.sent, Ae.abrupt("return", (ue = ve.body.messages_count) !== null && ue !== void 0 ? ue : 0);
                  case 5:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get count of unread messages for the user if they are a participant of this
         * conversation. Rejects if the user is not a participant of the conversation.
         *
         * Use this method to obtain the number of unread messages together with
         * {@link Conversation.updateLastReadMessageIndex} instead of relying on the
         * message indices which may have gaps. See {@link Message.index} for details.
         *
         * This method is semi-realtime. This means that this data will be eventually
         * correct, but it will also be possibly incorrect for a few seconds. The
         * Conversations system does not provide real time events for counter values
         * changes.
         *
         * This is useful for any UI badges, but it is not recommended to build any
         * core application logic based on these counters being accurate in real time.
         *
         * If the read horizon is not set, this function will return null. This could mean
         * that all messages in the conversation are unread, or that the read horizon system
         * is not being used. How to interpret this `null` value is up to the customer application.
         *
         * @return Number of unread messages based on the current read horizon set for
         * the user or `null` if the read horizon is not set.
         */
      }, {
        key: "getUnreadMessagesCount",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return ue = new ne(this._configuration.links.myConversations).path(this.sid).build(), Ae.next = 3, this._services.network.get(ue);
                  case 3:
                    if (pe = Ae.sent, pe.body.conversation_sid === this.sid) {
                      Ae.next = 6;
                      break;
                    }
                    throw new Error("Conversation was not found in the user conversations list");
                  case 6:
                    if (ve = pe.body.unread_messages_count, typeof ve != "number") {
                      Ae.next = 9;
                      break;
                    }
                    return Ae.abrupt("return", ve);
                  case 9:
                    return Ae.abrupt("return", null);
                  case 10:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Join the conversation and subscribe to its events.
         */
      }, {
        key: "join",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._services.commandExecutor.mutateResource("post", this._links.participants, {
                      identity: this._configuration.userIdentity
                    });
                  case 2:
                    return pe.abrupt("return", this);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Leave the conversation.
         */
      }, {
        key: "leave",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    if (this._internalState.status !== "joined") {
                      pe.next = 3;
                      break;
                    }
                    return pe.next = 3, this._services.commandExecutor.mutateResource("delete", "".concat(this._links.participants, "/").concat(encodeURIComponent(this._configuration.userIdentity)));
                  case 3:
                    return pe.abrupt("return", this);
                  case 4:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Remove a participant from the conversation. When a string is passed as the
         * argument, it will assume that the string is an identity or SID.
         * @param participant Identity, SID or the participant object to remove.
         */
      }, {
        key: "removeParticipant",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._participantsEntity.remove(typeof ue == "string" ? ue : ue.sid);
                  case 2:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Send a message to the conversation.
         * @param message Message body for the text message,
         * `FormData` or {@link SendMediaOptions} for media content. Sending FormData
         * is supported only with the browser engine.
         * @param messageAttributes Attributes for the message.
         * @param emailOptions Email options for the message.
         * @return Index of the new message.
         */
      }, {
        key: "sendMessage",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe, ve) {
            var ye, Ae, Qe, pt;
            return z.default.wrap(function(zt) {
              for (; ; )
                switch (zt.prev = zt.next) {
                  case 0:
                    if (!(typeof ue == "string" || ue === null)) {
                      zt.next = 5;
                      break;
                    }
                    return zt.next = 3, this._messagesEntity.send(ue, pe, ve);
                  case 3:
                    return Qe = zt.sent, zt.abrupt("return", (Ae = mt(Qe.index)) !== null && Ae !== void 0 ? Ae : 0);
                  case 5:
                    return zt.next = 7, this._messagesEntity.sendMedia(ue, pe, ve);
                  case 7:
                    return pt = zt.sent, zt.abrupt("return", (ye = mt(pt.index)) !== null && ye !== void 0 ? ye : 0);
                  case 9:
                  case "end":
                    return zt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue, pe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * New interface to prepare for sending a message.
         * Use this instead of {@link Conversation.sendMessage}.
         * @return A MessageBuilder to help set all message sending options.
         */
      }, {
        key: "prepareMessage",
        value: function() {
          return new So(this.limits, this._messagesEntity);
        }
        /**
         * Set last read message index of the conversation to the index of the last
         * known message.
         * @return Resulting unread messages count in the conversation.
         */
      }, {
        key: "setAllMessagesRead",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._subscribeStreams();
                  case 2:
                    return ve.next = 4, this.getMessages(1);
                  case 4:
                    if (ue = ve.sent, !(ue.items.length > 0)) {
                      ve.next = 7;
                      break;
                    }
                    return ve.abrupt("return", this.advanceLastReadMessageIndex(ue.items[0].index));
                  case 7:
                    return ve.abrupt("return", 0);
                  case 8:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Set all messages in the conversation unread.
         * @returns New count of unread messages after this update.
         */
      }, {
        key: "setAllMessagesUnread",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._subscribeStreams();
                  case 2:
                    return pe.next = 4, this._setLastReadMessageIndex(null);
                  case 4:
                    return pe.abrupt("return", pe.sent);
                  case 5:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Set user notification level for this conversation.
         * @param notificationLevel New user notification level.
         */
      }, {
        key: "setUserNotificationLevel",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                      notification_level: ue
                    });
                  case 2:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Send a notification to the server indicating that this client is currently
         * typing in this conversation. Typing ended notification is sent after a
         * while automatically, but by calling this method again you ensure that
         * typing ended is not received.
         */
      }, {
        key: "typing",
        value: function() {
          return this._services.typingIndicator.send(this.sid);
        }
        /**
         * Update the attributes of the conversation.
         * @param attributes New attributes.
         */
      }, {
        key: "updateAttributes",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._services.commandExecutor.mutateResource("post", this._links.self, {
                      attributes: ue !== void 0 ? JSON.stringify(ue) : void 0
                    });
                  case 2:
                    return ve.abrupt("return", this);
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Update the friendly name of the conversation.
         * @param friendlyName New friendly name.
         */
      }, {
        key: "updateFriendlyName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (this._internalState.friendlyName === ue) {
                      ve.next = 3;
                      break;
                    }
                    return ve.next = 3, this._services.commandExecutor.mutateResource("post", this._links.self, {
                      friendly_name: ue
                    });
                  case 3:
                    return ve.abrupt("return", this);
                  case 4:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Set the last read message index to the current read horizon.
         * @param index Message index to set as last read. If null is provided, then
         * the behavior is identical to {@link Conversation.setAllMessagesUnread}.
         * @returns New count of unread messages after this update.
         */
      }, {
        key: "updateLastReadMessageIndex",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._subscribeStreams();
                  case 2:
                    return ve.abrupt("return", this._setLastReadMessageIndex(ue));
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Update the unique name of the conversation.
         * @param uniqueName New unique name for the conversation. Setting unique name
         * to null removes it.
         */
      }, {
        key: "updateUniqueName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (this._internalState.uniqueName === ue) {
                      ve.next = 4;
                      break;
                    }
                    return ue || (ue = ""), ve.next = 4, this._services.commandExecutor.mutateResource("post", this._links.self, {
                      unique_name: ue
                    });
                  case 4:
                    return ve.abrupt("return", this);
                  case 5:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get recipients of all messages in the conversation.
         * @param options Optional configuration, set pageSize to request a specific pagination page size. Page size specifies a number of messages to include in a single batch. Each message may include multiple recipients.
         */
      }, {
        key: "getMessageRecipients",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._services.messageRecipientsClient.getRecipientsFromConversation(this.sid, ue);
                  case 2:
                    return ve.abrupt("return", ve.sent);
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Load and subscribe to this conversation and do not subscribe to its
         * participants and messages. This or _subscribeStreams will need to be called
         * before any events in the conversation will fire.
         * @internal
         */
      }, {
        key: "_subscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    if (!this._entityPromise) {
                      ve.next = 2;
                      break;
                    }
                    return ve.abrupt("return", this._entityPromise);
                  case 2:
                    return this._entityPromise = this._services.syncClient.document({
                      id: this._entityName,
                      mode: "open_existing"
                    }), ve.prev = 3, ve.next = 6, this._entityPromise;
                  case 6:
                    return this._entity = ve.sent, this._entity.on(A.SyncDocument.updated, function(ye) {
                      return ue._update(ye.data);
                    }), this._entity.on(A.SyncDocument.removed, function() {
                      return ue.emit(be.removed, ue);
                    }), this._update(this._entity.data), ve.abrupt("return", this._entity);
                  case 13:
                    throw ve.prev = 13, ve.t0 = ve.catch(3), this._entity = null, this._entityPromise = null, this._services.syncClient.connectionState != "disconnected" && be._logger.error("Failed to get conversation object", ve.t0), be._logger.debug("ERROR: Failed to get conversation object", ve.t0), ve.t0;
                  case 20:
                  case "end":
                    return ve.stop();
                }
            }, xe, this, [[3, 13]]);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Fetch participants and messages of the conversation. This method needs to
         * be called during conversation initialization to catch broken conversations
         * (broken conversations are conversations that have essential Sync entities
         * missing, i.e. the conversation document, the messages list or the
         * participant map). In case of this conversation being broken, the method
         * will throw an exception that will be caught and handled gracefully.
         * @internal
         */
      }, {
        key: "_fetchStreams",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return Ae.next = 2, this._subscribe();
                  case 2:
                    return be._logger.trace("_streamsAvailable, this.entity.data=", (ue = this._entity) === null || ue === void 0 ? void 0 : ue.data), ve = (pe = this._entity) === null || pe === void 0 ? void 0 : pe.data, Ae.next = 6, this._services.syncClient.list({
                      id: ve.messages,
                      mode: "open_existing"
                    });
                  case 6:
                    return this._messagesList = Ae.sent, Ae.next = 9, this._services.syncClient.map({
                      id: ve.roster,
                      mode: "open_existing"
                    });
                  case 9:
                    this._participantsMap = Ae.sent;
                  case 10:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Load the attributes of this conversation and instantiate its participants
         * and messages. This or _subscribe will need to be called before any events
         * on the conversation will fire. This will need to be called before any
         * events on participants or messages will fire
         * @internal
         */
      }, {
        key: "_subscribeStreams",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve, ye, Ae, Qe, pt;
            return z.default.wrap(function(zt) {
              for (; ; )
                switch (zt.prev = zt.next) {
                  case 0:
                    return zt.prev = 0, zt.next = 3, this._subscribe();
                  case 3:
                    return be._logger.trace("_subscribeStreams, this.entity.data=", (ue = this._entity) === null || ue === void 0 ? void 0 : ue.data), Ae = (pe = this._entity) === null || pe === void 0 ? void 0 : pe.data, Qe = Ae.messages, pt = Ae.roster, zt.next = 9, Promise.all([this._messagesEntity.subscribe((ve = this._messagesList) !== null && ve !== void 0 ? ve : Qe), this._participantsEntity.subscribe((ye = this._participantsMap) !== null && ye !== void 0 ? ye : pt)]);
                  case 9:
                    zt.next = 16;
                    break;
                  case 11:
                    throw zt.prev = 11, zt.t0 = zt.catch(0), this._services.syncClient.connectionState !== "disconnected" && be._logger.error("Failed to subscribe on conversation objects", this.sid, zt.t0), be._logger.debug("ERROR: Failed to subscribe on conversation objects", this.sid, zt.t0), zt.t0;
                  case 16:
                  case "end":
                    return zt.stop();
                }
            }, xe, this, [[0, 11]]);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Stop listening for and firing events on this conversation.
         * @internal
         */
      }, {
        key: "_unsubscribe",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return this._entity && (this._entity.close(), this._entity = null, this._entityPromise = null), pe.abrupt("return", Promise.all([this._participantsEntity.unsubscribe(), this._messagesEntity.unsubscribe()]));
                  case 2:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Set conversation status.
         * @internal
         */
      }, {
        key: "_setStatus",
        value: function(ae, xe) {
          var ue = this;
          if (this._dataSource = xe, this._internalState.status !== ae) {
            if (this._internalState.status = ae, ae === "joined") {
              this._subscribeStreams().catch(function(pe) {
                if (be._logger.debug("ERROR while setting conversation status " + ae, pe), ue._services.syncClient.connectionState !== "disconnected")
                  throw pe;
              });
              return;
            }
            this._entityPromise && this._unsubscribe().catch(function(pe) {
              if (be._logger.debug("ERROR while setting conversation status " + ae, pe), ue._services.syncClient.connectionState !== "disconnected")
                throw pe;
            });
          }
        }
        /**
         * Update the local conversation object with new values.
         * @internal
         */
      }, {
        key: "_update",
        value: function(ae) {
          var xe, ue, pe, ve, ye;
          be._logger.trace("_update", ae), be.preprocessUpdate(ae, this.sid);
          for (var Ae = /* @__PURE__ */ new Set(), Qe = 0, pt = Object.keys(ae); Qe < pt.length; Qe++) {
            var Tt = pt[Qe], zt = Jo[Tt];
            if (zt)
              switch (zt) {
                case Jo.status:
                  if (!ae.status || ae.status === "unknown" || this._internalState.status === ae.status)
                    break;
                  this._internalState.status = ae.status, Ae.add(zt);
                  break;
                case Jo.attributes:
                  if (V.default(this._internalState.attributes, ae.attributes))
                    break;
                  this._internalState.attributes = ae.attributes, Ae.add(zt);
                  break;
                case Jo.lastConsumedMessageIndex:
                  if (ae.lastConsumedMessageIndex === void 0 || ae.lastConsumedMessageIndex === this._internalState.lastReadMessageIndex)
                    break;
                  this._internalState.lastReadMessageIndex = ae.lastConsumedMessageIndex, Ae.add("lastReadMessageIndex");
                  break;
                case Jo.lastMessage:
                  if (this._internalState.lastMessage && !ae.lastMessage) {
                    delete this._internalState.lastMessage, Ae.add(zt);
                    break;
                  }
                  this._internalState.lastMessage = this._internalState.lastMessage || {}, ((xe = ae.lastMessage) === null || xe === void 0 ? void 0 : xe.index) !== void 0 && ae.lastMessage.index !== this._internalState.lastMessage.index && (this._internalState.lastMessage.index = ae.lastMessage.index, Ae.add(zt)), ((ue = ae.lastMessage) === null || ue === void 0 ? void 0 : ue.timestamp) !== void 0 && ((pe = this._internalState.lastMessage) === null || pe === void 0 || (ve = pe.dateCreated) === null || ve === void 0 ? void 0 : ve.getTime()) !== ae.lastMessage.timestamp.getTime() && (this._internalState.lastMessage.dateCreated = ae.lastMessage.timestamp, Ae.add(zt)), V.default(this._internalState.lastMessage, {}) && delete this._internalState.lastMessage;
                  break;
                case Jo.state:
                  var mn = ae.state || void 0;
                  if (mn !== void 0 && (mn.dateUpdated = new Date(mn.dateUpdated)), V.default(this._internalState.state, mn))
                    break;
                  this._internalState.state = mn, Ae.add(zt);
                  break;
                case Jo.bindings:
                  if (V.default(this._internalState.bindings, ae.bindings))
                    break;
                  this._internalState.bindings = ae.bindings, Ae.add(zt);
                  break;
                default:
                  var Tn = ae[Tt] instanceof Date, Zn = Tn && ((ye = this._internalState[zt]) === null || ye === void 0 ? void 0 : ye.getTime()) === ae[Tt].getTime(), ia = !Tn && this[zt] === ae[Tt];
                  if (Zn || ia)
                    break;
                  this._internalState[zt] = ae[Tt], Ae.add(zt);
              }
          }
          Ae.size > 0 && this.emit(be.updated, {
            conversation: this,
            updateReasons: Z.default(Ae)
          });
        }
        /**
         * Handle onMessageAdded event.
         */
      }, {
        key: "_onMessageAdded",
        value: function(ae) {
          var xe = Kl(this._participants.values()), ue;
          try {
            for (xe.s(); !(ue = xe.n()).done; ) {
              var pe = ue.value;
              if (pe.identity === ae.author) {
                pe._endTyping();
                break;
              }
            }
          } catch (ve) {
            xe.e(ve);
          } finally {
            xe.f();
          }
          this.emit(be.messageAdded, ae);
        }
        /**
         * Set last read message index.
         * @param index New index to set.
         */
      }, {
        key: "_setLastReadMessageIndex",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._services.commandExecutor.mutateResource("post", "".concat(this._configuration.links.myConversations, "/").concat(this.sid), {
                      last_read_message_index: ue
                    });
                  case 2:
                    return pe = ye.sent, ye.abrupt("return", pe.unread_messages_count);
                  case 4:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }], [{
        key: "preprocessUpdate",
        value: function(ae, xe) {
          try {
            typeof ae.attributes == "string" ? ae.attributes = JSON.parse(ae.attributes) : ae.attributes && JSON.stringify(ae.attributes);
          } catch {
            be._logger.warn("Retrieved malformed attributes from the server for conversation: " + xe), ae.attributes = {};
          }
          try {
            ae.dateCreated && (ae.dateCreated = new Date(ae.dateCreated));
          } catch {
            be._logger.warn("Retrieved malformed dateCreated from the server for conversation: " + xe), delete ae.dateCreated;
          }
          try {
            ae.dateUpdated && (ae.dateUpdated = new Date(ae.dateUpdated));
          } catch {
            be._logger.warn("Retrieved malformed dateUpdated from the server for conversation: " + xe), delete ae.dateUpdated;
          }
          try {
            ae.lastMessage && ae.lastMessage.timestamp && (ae.lastMessage.timestamp = new Date(ae.lastMessage.timestamp));
          } catch {
            be._logger.warn("Retrieved malformed lastMessage.timestamp from the server for conversation: " + xe), delete ae.lastMessage.timestamp;
          }
        }
      }]), be;
    }(b.ReplayEventEmitter);
    H.default(Ka, "participantJoined", "participantJoined"), H.default(Ka, "participantLeft", "participantLeft"), H.default(Ka, "participantUpdated", "participantUpdated"), H.default(Ka, "messageAdded", "messageAdded"), H.default(Ka, "messageRemoved", "messageRemoved"), H.default(Ka, "messageUpdated", "messageUpdated"), H.default(Ka, "typingEnded", "typingEnded"), H.default(Ka, "typingStarted", "typingStarted"), H.default(Ka, "updated", "updated"), H.default(Ka, "removed", "removed"), H.default(Ka, "_logger", we.scope("Conversation")), ce([g.validateTypesAsync(g.nonEmptyString, ie), ee("design:type", Function), ee("design:paramtypes", [String, Object]), ee("design:returntype", Promise)], Ka.prototype, "add", null), ce([g.validateTypesAsync(g.nonEmptyString, g.nonEmptyString, ie, ie), ee("design:type", Function), ee("design:paramtypes", [String, String, Object, Object]), ee("design:returntype", Promise)], Ka.prototype, "addNonChatParticipant", null), ce([g.validateTypesAsync(g.nonNegativeInteger), ee("design:type", Function), ee("design:paramtypes", [Number]), ee("design:returntype", Promise)], Ka.prototype, "advanceLastReadMessageIndex", null), ce([g.validateTypesAsync(["undefined", g.nonNegativeInteger], ["undefined", g.nonNegativeInteger], ["undefined", g.literal("backwards", "forward")]), ee("design:type", Function), ee("design:paramtypes", [Number, Number, String]), ee("design:returntype", Promise)], Ka.prototype, "getMessages", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], Ka.prototype, "getParticipantBySid", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], Ka.prototype, "getParticipantByIdentity", null), ce([g.validateTypesAsync([g.nonEmptyString, vt]), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], Ka.prototype, "removeParticipant", null), ce([g.validateTypesAsync(["string", FormData, g.literal(null), g.objectSchema("media options", {
      contentType: g.nonEmptyString,
      media: g.custom(function(Ee) {
        var je = typeof Ee == "string" && Ee.length > 0 || Ee instanceof Uint8Array || Ee instanceof ArrayBuffer;
        return typeof Blob == "function" && (je = je || Ee instanceof Blob), [je, "a non-empty string, an instance of Buffer or an instance of Blob"];
      })
    })], ie, ["undefined", g.literal(null), g.objectSchema("email attributes", {
      subject: [g.nonEmptyString, "undefined"]
    })]), ee("design:type", Function), ee("design:paramtypes", [Object, Object, Object]), ee("design:returntype", Promise)], Ka.prototype, "sendMessage", null), ce([g.validateTypesAsync(g.literal("default", "muted")), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], Ka.prototype, "setUserNotificationLevel", null), ce([g.validateTypesAsync(re), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], Ka.prototype, "updateAttributes", null), ce([g.validateTypesAsync("string"), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], Ka.prototype, "updateFriendlyName", null), ce([g.validateTypesAsync([g.literal(null), g.nonNegativeInteger]), ee("design:type", Function), ee("design:paramtypes", [Number]), ee("design:returntype", Promise)], Ka.prototype, "updateLastReadMessageIndex", null), ce([g.validateTypesAsync(["string", g.literal(null)]), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], Ka.prototype, "updateUniqueName", null);
    var y2 = /* @__PURE__ */ function() {
      function Ee() {
        var je = this;
        F.default(this, Ee), this._promise = new Promise(function(be, oe) {
          je._resolve = be, je._reject = oe;
        });
      }
      return j.default(Ee, [{
        key: "promise",
        get: function() {
          return this._promise;
        }
      }, {
        key: "update",
        value: function(be) {
          this._resolve(be);
        }
      }, {
        key: "set",
        value: function(be) {
          this.current = be, this._resolve(be);
        }
      }, {
        key: "fail",
        value: function(be) {
          this._reject(be);
        }
      }]), Ee;
    }();
    function qu(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = dp(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function dp(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return Nd(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return Nd(Ee, je);
      }
    }
    function Nd(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    function Rc(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function Oc(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? Rc(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : Rc(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    function Lo(Ee) {
      var je = Rl();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function Rl() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var hs = we.scope("Conversations"), Bc = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Lo(be);
      function be(oe, ae) {
        var xe;
        return F.default(this, be), xe = je.call(this), H.default(v.default(xe), "conversations", /* @__PURE__ */ new Map()), H.default(v.default(xe), "myConversationsRead", new y2()), H.default(v.default(xe), "tombstones", /* @__PURE__ */ new Set()), H.default(v.default(xe), "myConversationsFetched", !1), xe.configuration = oe, xe.services = ae, xe;
      }
      return j.default(be, [{
        key: "addConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae, Qe, pt, Tt, zt, mn, Tn;
            return z.default.wrap(function(ia) {
              for (; ; )
                switch (ia.prev = ia.next) {
                  case 0:
                    return Ae = typeof (ue == null ? void 0 : ue.attributes) < "u" ? ue.attributes : {}, ia.next = 3, this.services.commandExecutor.mutateResource("post", this.configuration.links.conversations, {
                      friendly_name: ue.friendlyName,
                      unique_name: ue.uniqueName,
                      access: ue.access,
                      attributes: typeof Ae < "u" ? JSON.stringify(Ae) : void 0
                    });
                  case 3:
                    if (Qe = ia.sent, pt = (pe = Qe.sid) !== null && pe !== void 0 ? pe : null, Tt = (ve = (ye = Qe.sync_objects) === null || ye === void 0 ? void 0 : ye.conversation) !== null && ve !== void 0 ? ve : null, zt = Oc({
                      self: Qe.url
                    }, Qe.links), mn = this.conversations.get(pt), !mn) {
                      ia.next = 12;
                      break;
                    }
                    return ia.next = 11, mn._subscribe();
                  case 11:
                    return ia.abrupt("return", mn);
                  case 12:
                    return Tn = new Ka({
                      channel: Tt,
                      entityName: "",
                      uniqueName: "",
                      attributes: null,
                      createdBy: "",
                      friendlyName: "",
                      lastConsumedMessageIndex: 0,
                      dateCreated: null,
                      dateUpdated: null
                    }, pt, zt, this.configuration, this.services), this.conversations.set(Tn.sid, Tn), this._registerForEvents(Tn), ia.next = 17, Tn._subscribe();
                  case 17:
                    return this.emit("conversationAdded", Tn), ia.abrupt("return", Tn);
                  case 19:
                  case "end":
                    return ia.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Fetch conversations' list and instantiate all necessary objects
         */
      }, {
        key: "fetchConversations",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this, pe, ve, ye, Ae, Qe, pt, Tt;
            return z.default.wrap(function(mn) {
              for (; ; )
                switch (mn.prev = mn.next) {
                  case 0:
                    return mn.prev = 0, mn.next = 3, this._getMap();
                  case 3:
                    return pe = mn.sent, pe.on(A.SyncMap.itemAdded, function(Tn) {
                      hs.debug("itemAdded: ".concat(Tn.item.key)), ue._upsertConversation("sync", Tn.item.key, Tn.item.data);
                    }), pe.on(A.SyncMap.itemRemoved, function(Tn) {
                      hs.debug("itemRemoved: ".concat(Tn.key));
                      var Zn = Tn.key;
                      ue.myConversationsFetched || ue.tombstones.add(Zn);
                      var ia = ue.conversations.get(Zn);
                      ia && (ia.status === "joined" && (ia._setStatus("notParticipating", "sync"), ue.emit("conversationLeft", ia)), ue.conversations.delete(Zn), ue.emit("conversationRemoved", ia), ia.emit("removed", ia));
                    }), pe.on(A.SyncMap.itemUpdated, function(Tn) {
                      hs.debug("itemUpdated: ".concat(Tn.item.key)), ue._upsertConversation("sync", Tn.item.key, Tn.item.data);
                    }), mn.next = 9, this._fetchMyConversations();
                  case 9:
                    ve = mn.sent, ye = [], Ae = qu(ve);
                    try {
                      for (Ae.s(); !(Qe = Ae.n()).done; )
                        pt = Qe.value, ye.push(this._upsertConversation("rest", pt.channel_sid, pt));
                    } catch (Tn) {
                      Ae.e(Tn);
                    } finally {
                      Ae.f();
                    }
                    return this.myConversationsRead.set(!0), mn.next = 16, Promise.all(ye);
                  case 16:
                    return this.myConversationsFetched = !0, this.tombstones.clear(), hs.debug("The conversations list has been successfully fetched"), mn.abrupt("return", this);
                  case 22:
                    throw mn.prev = 22, mn.t0 = mn.catch(0), Tt = "Failed to fetch the conversations list", this.services.syncClient.connectionState !== "disconnected" && hs.error(Tt, mn.t0), hs.debug("ERROR: ".concat(Tt), mn.t0), mn.t0;
                  case 28:
                  case "end":
                    return mn.stop();
                }
            }, xe, this, [[0, 22]]);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "getConversations",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this, pe, ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    return Ae.next = 2, this._getMap();
                  case 2:
                    return pe = Ae.sent, Ae.next = 5, pe.getItems();
                  case 5:
                    return ve = Ae.sent, Ae.abrupt("return", this._wrapPaginator(ve, function(Qe) {
                      return Promise.all(Qe.map(function(pt) {
                        return ue._upsertConversation("sync", pt.key, pt.data);
                      }));
                    }));
                  case 7:
                  case "end":
                    return Ae.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "getConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe = this, ve, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    return pt.next = 2, this._getMap();
                  case 2:
                    return ve = pt.sent, pt.next = 5, ve.getItems({
                      key: ue
                    });
                  case 5:
                    return ye = pt.sent, Ae = ye.items.map(function(Tt) {
                      return pe._upsertConversation("sync", Tt.key, Tt.data);
                    }), pt.abrupt("return", Ae.length > 0 ? Ae[0] : null);
                  case 8:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "getConversationByUniqueName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    return pe = new ne(this.configuration.links.myConversations).path(ue).build(), Tt.next = 3, this.services.network.get(pe);
                  case 3:
                    return ve = Tt.sent, ye = ve.body, Ae = ye.conversation_sid, Qe = {
                      entityName: null,
                      lastConsumedMessageIndex: ye.last_read_message_index,
                      status: (ye == null ? void 0 : ye.status) || "unknown",
                      friendlyName: ye.friendly_name,
                      dateUpdated: ye.date_updated,
                      dateCreated: ye.date_created,
                      uniqueName: ye.unique_name,
                      createdBy: ye.created_by,
                      attributes: ye.attributes,
                      channel: ye.sync_objects.conversation,
                      roster: ye.sync_objects.participants,
                      messages: ye.sync_objects.messages,
                      notificationLevel: ye == null ? void 0 : ye.notification_level,
                      sid: Ae
                    }, Tt.abrupt("return", Ae ? this._upsertConversation("sync", Ae, Qe) : null);
                  case 8:
                  case "end":
                    return Tt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "peekConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    return pe = new ne(this.configuration.links.conversations).path(ue).build(), pt.next = 3, this.services.network.get(pe);
                  case 3:
                    return ve = pt.sent, ye = ve.body, Ae = {
                      entityName: null,
                      // lastConsumedMessageIndex: body.last_read_message_index,
                      status: (ye == null ? void 0 : ye.status) || "unknown",
                      friendlyName: ye.friendly_name,
                      dateUpdated: ye.date_updated,
                      dateCreated: ye.date_created,
                      uniqueName: ye.unique_name,
                      createdBy: ye.created_by,
                      attributes: ye.attributes,
                      channel: ye.sync_objects.conversation || "".concat(ue, ".channel"),
                      roster: ye.sync_objects.participants,
                      messages: ye.sync_objects.messages,
                      notificationLevel: ye == null ? void 0 : ye.notification_level,
                      sid: ue
                    }, pt.abrupt("return", this._upsertConversation("sync", ue, Ae));
                  case 7:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_getMap",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this.services.syncClient.map({
                      id: this.configuration.myConversations,
                      mode: "open_existing"
                    });
                  case 2:
                    return pe.abrupt("return", pe.sent);
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_wrapPaginator",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve = this, ye;
            return z.default.wrap(function(Qe) {
              for (; ; )
                switch (Qe.prev = Qe.next) {
                  case 0:
                    return Qe.next = 2, pe(ue.items);
                  case 2:
                    return ye = Qe.sent, Qe.abrupt("return", {
                      items: ye.filter(function(pt) {
                        return pt !== null;
                      }),
                      hasNextPage: ue.hasNextPage,
                      hasPrevPage: ue.hasPrevPage,
                      nextPage: function() {
                        return ue.nextPage().then(function(Tt) {
                          return ve._wrapPaginator(Tt, pe);
                        });
                      },
                      prevPage: function() {
                        return ue.prevPage().then(function(Tt) {
                          return ve._wrapPaginator(Tt, pe);
                        });
                      }
                    });
                  case 4:
                  case "end":
                    return Qe.stop();
                }
            }, xe);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_updateConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe, ve) {
            var ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    if (ye = pe._statusSource !== void 0 && ue !== pe._statusSource, Ae = ue !== "rest" || pe._statusSource === "sync", !(ye && Ae && ue !== "sync")) {
                      Tt.next = 5;
                      break;
                    }
                    return hs.trace("upsertConversation: conversation is known from sync and came from REST, ignoring", {
                      sid: pe.sid,
                      data: ve.status,
                      conversation: pe.status
                    }), Tt.abrupt("return");
                  case 5:
                    if (!(ve.status === "joined" && pe.status !== "joined")) {
                      Tt.next = 15;
                      break;
                    }
                    return pe._setStatus("joined", ue), Qe = {}, typeof ve.notificationLevel < "u" && (Qe.notificationLevel = ve.notificationLevel), typeof ve.lastConsumedMessageIndex < "u" && (Qe.lastConsumedMessageIndex = ve.lastConsumedMessageIndex), V.default(Qe, {}) || pe._update(Qe), Tt.next = 13, pe._subscribe();
                  case 13:
                    return this.emit("conversationJoined", pe), Tt.abrupt("return");
                  case 15:
                    if (!(ve.status === "notParticipating" && pe.status === "joined")) {
                      Tt.next = 22;
                      break;
                    }
                    return pe._setStatus("notParticipating", ue), pe._update(ve), Tt.next = 20, pe._subscribe();
                  case 20:
                    return this.emit("conversationLeft", pe), Tt.abrupt("return");
                  case 22:
                    if (ve.status !== "notParticipating") {
                      Tt.next = 26;
                      break;
                    }
                    return Tt.next = 25, pe._subscribe();
                  case 25:
                    return Tt.abrupt("return");
                  case 26:
                    pe._update(ve);
                  case 27:
                  case "end":
                    return Tt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue, pe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_upsertConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe, ve) {
            var ye, Ae, Qe, pt;
            return z.default.wrap(function(zt) {
              for (; ; )
                switch (zt.prev = zt.next) {
                  case 0:
                    if (hs.trace("upsertConversation called for ".concat(pe), ve), ye = this.conversations.get(pe), !ye) {
                      zt.next = 9;
                      break;
                    }
                    return hs.trace("upsertConversation: the conversation ".concat(ye.sid, " is known;") + "its status is known from the source ".concat(ye._statusSource, " ") + "and the update came from the source ".concat(ue), ye), zt.next = 6, this._updateConversation(ue, ye, ve);
                  case 6:
                    return zt.next = 8, ye._subscribe();
                  case 8:
                    return zt.abrupt("return", ye);
                  case 9:
                    if (!(ue === "rest" && this.tombstones.has(pe))) {
                      zt.next = 12;
                      break;
                    }
                    return hs.trace("upsertChannel: the conversation is deleted but reappeared again from REST, ignoring", pe), zt.abrupt("return", null);
                  case 12:
                    return hs.trace("upsertConversation: creating a local conversation object with sid " + pe, ve), Ae = "".concat(this.configuration.links.conversations, "/").concat(pe), Qe = {
                      self: Ae,
                      messages: "".concat(Ae, "/Messages"),
                      participants: "".concat(Ae, "/Participants")
                    }, pt = new Ka(ve, pe, Qe, this.configuration, this.services), this.conversations.set(pe, pt), zt.prev = 17, zt.next = 20, pt._subscribe();
                  case 20:
                    if (ve.status !== "joined") {
                      zt.next = 23;
                      break;
                    }
                    return zt.next = 23, pt._fetchStreams();
                  case 23:
                    zt.next = 32;
                    break;
                  case 25:
                    if (zt.prev = 25, zt.t0 = zt.catch(17), zt.t0.name === "SyncError") {
                      zt.next = 29;
                      break;
                    }
                    throw zt.t0;
                  case 29:
                    return hs.trace("upsertChannel: the conversation is missing some Sync entity(ies), ignoring", pe, zt.t0), this.conversations.delete(pe), zt.abrupt("return", null);
                  case 32:
                    return this._registerForEvents(pt), this.emit("conversationAdded", pt), ve.status === "joined" && (pt._setStatus("joined", ue), this.emit("conversationJoined", pt)), zt.abrupt("return", pt);
                  case 36:
                  case "end":
                    return zt.stop();
                }
            }, xe, this, [[17, 25]]);
          }));
          function ae(xe, ue, pe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_fetchMyConversations",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue, pe, ve, ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    ue = [], pe = null;
                  case 2:
                    return ye = new ne(this.configuration.links.myConversations), pe && ye.arg("PageToken", pe), Tt.next = 6, this.services.network.get(ye.build());
                  case 6:
                    Ae = Tt.sent, Qe = (ve = Ae.body) === null || ve === void 0 ? void 0 : ve.conversations.map(function(zt) {
                      return {
                        descriptor: zt,
                        channel_sid: zt.conversation_sid,
                        status: zt.status,
                        channel: zt.sync_objects.conversation,
                        messages: zt.sync_objects.messages,
                        roster: zt.sync_objects.participants || "".concat(zt.conversation_sid, ".roster"),
                        lastConsumedMessageIndex: zt.last_read_message_index,
                        notificationLevel: zt.notification_level
                      };
                    }), pe = Ae.body.meta.next_token, ue = [].concat(Z.default(ue), Z.default(Qe));
                  case 10:
                    if (pe) {
                      Tt.next = 2;
                      break;
                    }
                  case 11:
                    return Tt.abrupt("return", ue);
                  case 12:
                  case "end":
                    return Tt.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }, {
        key: "_onConversationRemoved",
        value: function(ae) {
          var xe = this.conversations.get(ae);
          xe && (this.conversations.delete(ae), this.emit("conversationRemoved", xe));
        }
      }, {
        key: "_registerForEvents",
        value: function(ae) {
          var xe = this;
          ae.on("removed", function() {
            return xe._onConversationRemoved(ae.sid);
          }), ae.on("updated", function(ue) {
            return xe.emit("conversationUpdated", ue);
          }), ae.on("participantJoined", function(ue) {
            return xe.emit("participantJoined", ue);
          }), ae.on("participantLeft", function(ue) {
            return xe.emit("participantLeft", ue);
          }), ae.on("participantUpdated", function(ue) {
            return xe.emit("participantUpdated", ue);
          }), ae.on("messageAdded", function(ue) {
            return xe.emit("messageAdded", ue);
          }), ae.on("messageUpdated", function(ue) {
            return xe.emit("messageUpdated", ue);
          }), ae.on("messageRemoved", function(ue) {
            return xe.emit("messageRemoved", ue);
          }), ae.on("typingStarted", function(ue) {
            return xe.emit("typingStarted", ue);
          }), ae.on("typingEnded", function(ue) {
            return xe.emit("typingEnded", ue);
          });
        }
      }]), be;
    }(b.ReplayEventEmitter);
    function Nc(Ee) {
      var je = b2();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function b2() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var st = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Nc(be);
      function be(oe, ae, xe) {
        var ue;
        return F.default(this, be), ue = je.call(this), ue.configuration = ae, ue.services = xe, ue.fifoStack = [], ue.myself = oe, ue.myself.on("updated", function(pe) {
          return ue.emit("userUpdated", pe);
        }), ue.myself.on("userSubscribed", function() {
          return ue.emit("userSubscribed", ue.myself);
        }), ue.myself.on("userUnsubscribed", function() {
          ue.emit("userUnsubscribed", ue.myself), ue.myself._ensureFetched();
        }), ue.subscribedUsers = /* @__PURE__ */ new Map(), ue;
      }
      return j.default(be, [{
        key: "handleUnsubscribeUser",
        value: function(ae) {
          this.subscribedUsers.has(ae.identity) && this.subscribedUsers.delete(ae.identity);
          var xe = 0, ue = this.fifoStack.find(function(pe, ve) {
            return pe == ae.identity ? (xe = ve, !0) : !1;
          });
          ue && this.fifoStack.splice(xe, 1), this.emit("userUnsubscribed", ae);
        }
      }, {
        key: "handleSubscribeUser",
        value: function(ae) {
          if (!this.subscribedUsers.has(ae.identity)) {
            if (this.fifoStack.length >= this.configuration.userInfosToSubscribe) {
              var xe, ue, pe = this.fifoStack.shift();
              (xe = this.subscribedUsers) === null || xe === void 0 || (ue = xe.get(pe)) === null || ue === void 0 || ue.unsubscribe();
            }
            this.fifoStack.push(ae.identity), this.subscribedUsers.set(ae.identity, ae), this.emit("userSubscribed", ae);
          }
        }
        /**
         * Gets user, if it's in subscribed list - then return the user object from it,
         * if not - then subscribes and adds user to the FIFO stack
         * @returns {Promise<User>} Fully initialized user
         */
      }, {
        key: "getUser",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve, ye = this, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    return Tt.next = 2, this.myself._ensureFetched();
                  case 2:
                    if (ue != this.myself.identity) {
                      Tt.next = 4;
                      break;
                    }
                    return Tt.abrupt("return", this.myself);
                  case 4:
                    if (Ae = this.subscribedUsers.get(ue), !Ae) {
                      Tt.next = 7;
                      break;
                    }
                    return Tt.abrupt("return", Ae);
                  case 7:
                    if (!((ve = pe) !== null && ve !== void 0)) {
                      Tt.next = 11;
                      break;
                    }
                    Tt.next = 14;
                    break;
                  case 11:
                    return Tt.next = 13, this.getSyncUniqueName(ue);
                  case 13:
                    pe = Tt.sent;
                  case 14:
                    return Qe = new ft(ue, pe, this.configuration, this.services), Qe.on("updated", function(zt) {
                      return ye.emit("userUpdated", zt);
                    }), Qe.on("userSubscribed", function() {
                      return ye.handleSubscribeUser(Qe);
                    }), Qe.on("userUnsubscribed", function() {
                      return ye.handleUnsubscribeUser(Qe);
                    }), Tt.next = 20, Qe._ensureFetched();
                  case 20:
                    return Tt.abrupt("return", Qe);
                  case 21:
                  case "end":
                    return Tt.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * @returns {Promise<Array<User>>} returns list of subscribed User objects {@see User}
         */
      }, {
        key: "getSubscribedUsers",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue;
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this.myself._ensureFetched();
                  case 2:
                    return ue = [this.myself], this.subscribedUsers.forEach(function(ye) {
                      return ue.push(ye);
                    }), ve.abrupt("return", ue);
                  case 5:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * @returns {Promise<string>} User's sync unique name
         */
      }, {
        key: "getSyncUniqueName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe, ve, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    return ye = new ne(this.configuration.links.users).path(ue).build(), pt.next = 3, this.services.network.get(ye);
                  case 3:
                    return Ae = pt.sent, pt.abrupt("return", (pe = (ve = Ae.body) === null || ve === void 0 ? void 0 : ve.sync_objects.user_info_map) !== null && pe !== void 0 ? pe : "");
                  case 5:
                  case "end":
                    return pt.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
      }]), be;
    }(b.ReplayEventEmitter), dt = we.scope("TypingIndicator"), De = /* @__PURE__ */ function() {
      function Ee(je, be, oe) {
        F.default(this, Ee), this.configuration = be, this.services = oe, this.getConversation = je, this.serviceTypingTimeout = null, this.sentUpdates = /* @__PURE__ */ new Map();
      }
      return j.default(Ee, [{
        key: "typingTimeout",
        get: function() {
          return this.configuration.typingIndicatorTimeoutOverride || this.serviceTypingTimeout || this.configuration.typingIndicatorTimeoutDefault;
        }
        /**
         * Initialize TypingIndicator controller
         * Registers for needed message types and sets listeners
         * @private
         */
      }, {
        key: "initialize",
        value: function() {
          var be = this;
          this.services.notificationClient.on("message", /* @__PURE__ */ function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function ae(xe, ue) {
              return z.default.wrap(function(ve) {
                for (; ; )
                  switch (ve.prev = ve.next) {
                    case 0:
                      if (xe !== kt.TYPING_INDICATOR) {
                        ve.next = 3;
                        break;
                      }
                      return ve.next = 3, be._handleRemoteTyping(ue);
                    case 3:
                    case "end":
                      return ve.stop();
                  }
              }, ae);
            }));
            return function(ae, xe) {
              return oe.apply(this, arguments);
            };
          }());
        }
        /**
         * Remote participants typing events handler
         */
      }, {
        key: "_handleRemoteTyping",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae) {
            var xe = this;
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    dt.trace("Got new typing indicator ", ae), this.getConversation(ae.channel_sid).then(function(ve) {
                      ve && ve._participants.forEach(function(ye) {
                        if (!(ye.identity !== ae.identity && ye.type !== "apple")) {
                          var Ae = xe.configuration.typingIndicatorTimeoutOverride ? xe.configuration.typingIndicatorTimeoutOverride + 1e3 : ae.typing_timeout * 1e3;
                          ye._startTyping(Ae);
                        }
                      });
                    }).catch(function(ve) {
                      throw dt.error(ve), ve;
                    });
                  case 2:
                  case "end":
                    return pe.stop();
                }
            }, oe, this);
          }));
          function be(oe) {
            return je.apply(this, arguments);
          }
          return be;
        }()
        /**
         * Send typing event for the given conversation sid
         * @param {String} conversationSid
         */
      }, {
        key: "send",
        value: function(be) {
          var oe = this.sentUpdates.get(be);
          return oe && oe > Date.now() - this.typingTimeout ? Promise.resolve() : (this.sentUpdates.set(be, Date.now()), this._send(be));
        }
      }, {
        key: "_send",
        value: function(be) {
          var oe = this;
          dt.trace("Sending typing indicator");
          var ae = this.configuration.links.typing, xe = {
            "Content-Type": "application/x-www-form-urlencoded"
          }, ue = "ChannelSid=".concat(be);
          return this.services.twilsockClient.post(ae, xe, ue, this.configuration.productId).then(function(pe) {
            pe.body.hasOwnProperty("typing_timeout") && (oe.serviceTypingTimeout = pe.body.typing_timeout * 1e3);
          }).catch(function(pe) {
            throw dt.error("Failed to send typing indicator:", pe), pe;
          });
        }
      }]), Ee;
    }(), Be = /* @__PURE__ */ j.default(
      /**
       * Title of the notification.
       */
      /**
       * Text of the notification.
       */
      /**
       * Sound of the notification.
       */
      /**
       * Number of the badge.
       */
      /**
       * Notification action (`click_action` in FCM terms and `category` in APN terms).
       */
      /**
       * Type of the notification.
       */
      /**
       * Additional data of the conversation.
       */
      /**
       * @internal
       */
      function Ee(je) {
        F.default(this, Ee), this.title = je.title || null, this.body = je.body || null, this.sound = je.sound || null, this.badge = je.badge || null, this.action = je.action || null, this.type = je.type || null, this.data = je.data || {};
      }
    ), Me = "2.6.2";
    function ut(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function Ve(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? ut(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : ut(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    function Kt(Ee) {
      var je = qt();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function qt() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var vr = function(je) {
      return je.replace(/(^\/+|\/+$)/g, "");
    }, _e = function(je) {
      return je.status.code === 202;
    }, Pe = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Kt(be);
      function be(oe) {
        return F.default(this, be), je.call(this, oe);
      }
      return j.default(be);
    }(/* @__PURE__ */ ge.default(Error)), Q = /* @__PURE__ */ function() {
      function Ee(je, be, oe) {
        F.default(this, Ee), this._serviceUrl = je, this._services = be, this._productId = oe;
      }
      return j.default(Ee, [{
        key: "_preProcessUrl",
        value: function(be) {
          var oe = vr(be);
          return /^https?:\/\//.test(be) ? oe : "".concat(vr(this._serviceUrl), "/").concat(oe);
        }
      }, {
        key: "_makeRequest",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe, ue, pe) {
            var ve, ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    ve = this._preProcessUrl(xe), ye = Ve({
                      "Content-Type": "application/json; charset=utf-8"
                    }, pe || {}), Tt.t0 = ae, Tt.next = Tt.t0 === "get" ? 5 : Tt.t0 === "post" ? 11 : Tt.t0 === "delete" ? 15 : 19;
                    break;
                  case 5:
                    return Qe = ve, ue && (Qe += "?" + Object.entries(ue).map(function(zt) {
                      return zt.map(encodeURIComponent).join("=");
                    }).join("&")), Tt.next = 9, this._services.transport.get(Qe, ye, this._productId);
                  case 9:
                    return Ae = Tt.sent, Tt.abrupt("break", 19);
                  case 11:
                    return Tt.next = 13, this._services.transport.post(ve, ye, JSON.stringify(ue), this._productId);
                  case 13:
                    return Ae = Tt.sent, Tt.abrupt("break", 19);
                  case 15:
                    return Tt.next = 17, this._services.transport.delete(ve, ye, {}, this._productId);
                  case 17:
                    return Ae = Tt.sent, Tt.abrupt("break", 19);
                  case 19:
                    if (!(Ae.status.code < 200 || Ae.status.code >= 300)) {
                      Tt.next = 21;
                      break;
                    }
                    throw new Error("Request responded with a non-success code ".concat(Ae.status.code));
                  case 21:
                    return Tt.abrupt("return", Ae);
                  case 22:
                  case "end":
                    return Tt.stop();
                }
            }, oe, this);
          }));
          function be(oe, ae, xe, ue) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }, {
        key: "fetchResource",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe) {
            var ue = this, pe, ve, ye;
            return z.default.wrap(function(Qe) {
              for (; ; )
                switch (Qe.prev = Qe.next) {
                  case 0:
                    return pe = 6, ve = new C.AsyncRetrier({
                      min: 50,
                      max: 1600,
                      maxAttemptsCount: pe
                    }), Qe.prev = 2, Qe.next = 5, ve.run(/* @__PURE__ */ m.default(/* @__PURE__ */ z.default.mark(function pt() {
                      var Tt, zt, mn;
                      return z.default.wrap(function(Zn) {
                        for (; ; )
                          switch (Zn.prev = Zn.next) {
                            case 0:
                              return Zn.prev = 0, Zn.next = 3, ue._makeRequest("get", ae, xe);
                            case 3:
                              return Tt = Zn.sent, Zn.abrupt("return", {
                                type: "success",
                                data: Tt.body
                              });
                            case 7:
                              if (Zn.prev = 7, Zn.t0 = Zn.catch(0), !((Zn.t0 === null || Zn.t0 === void 0 || (zt = Zn.t0.body) === null || zt === void 0 ? void 0 : zt.status) === 404 && (Zn.t0 === null || Zn.t0 === void 0 || (mn = Zn.t0.body) === null || mn === void 0 ? void 0 : mn.code) === 50530)) {
                                Zn.next = 11;
                                break;
                              }
                              return Zn.abrupt("return", {
                                type: "noMetadata"
                              });
                            case 11:
                              throw Zn.t0;
                            case 12:
                            case "end":
                              return Zn.stop();
                          }
                      }, pt, null, [[0, 7]]);
                    })));
                  case 5:
                    ye = Qe.sent, Qe.next = 11;
                    break;
                  case 8:
                    throw Qe.prev = 8, Qe.t0 = Qe.catch(2), new Error('Fetch resource from "'.concat(ae, '" failed.'));
                  case 11:
                    if (ye.type !== "noMetadata") {
                      Qe.next = 13;
                      break;
                    }
                    throw new Pe("No metadata found.");
                  case 13:
                    return Qe.abrupt("return", ye.data);
                  case 14:
                  case "end":
                    return Qe.stop();
                }
            }, oe, null, [[2, 8]]);
          }));
          function be(oe, ae) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }, {
        key: "mutateResource",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe, ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._makeRequest(ae, xe, ue, {
                      "X-Twilio-Mutation-Id": L.v4()
                    });
                  case 2:
                    if (pe = ye.sent, !_e(pe)) {
                      ye.next = 7;
                      break;
                    }
                    return ye.next = 6, this.fetchResource(pe.body.resource_url);
                  case 6:
                    return ye.abrupt("return", ye.sent);
                  case 7:
                    return ye.abrupt("return", pe.body);
                  case 8:
                  case "end":
                    return ye.stop();
                }
            }, oe, this);
          }));
          function be(oe, ae, xe) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }]), Ee;
    }(), te = /* @__PURE__ */ function() {
      function Ee(je) {
        var be = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
        F.default(this, Ee), H.default(this, "_cachedTemplates", null), this._services = je, this._pageSize = be, this._cacheTtlMs = oe;
      }
      return j.default(Ee, [{
        key: "getContentTemplates",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe() {
            var ae = this, xe, ue, pe, ve, ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    if (this._cachedTemplates === null) {
                      Tt.next = 2;
                      break;
                    }
                    return Tt.abrupt("return", this._cachedTemplates);
                  case 2:
                    return Tt.next = 4, this._fetchContentTemplates();
                  case 4:
                    xe = Tt.sent, ue = Y.default(xe, 2), pe = ue[0], ve = ue[1], ye = pe;
                  case 9:
                    if (ve === null) {
                      Tt.next = 19;
                      break;
                    }
                    return Tt.next = 12, this._fetchContentTemplates(ve);
                  case 12:
                    Ae = Tt.sent, Qe = Y.default(Ae, 2), pe = Qe[0], ve = Qe[1], ye = [].concat(Z.default(ye), Z.default(pe)), Tt.next = 9;
                    break;
                  case 19:
                    return this._cachedTemplates = Object.freeze(ye), setTimeout(function() {
                      ae._cachedTemplates = null;
                    }, this._cacheTtlMs), Tt.abrupt("return", ye);
                  case 22:
                  case "end":
                    return Tt.stop();
                }
            }, oe, this);
          }));
          function be() {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }, {
        key: "_fetchContentTemplates",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae) {
            var xe, ue, pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return xe = "Client/v2/ContentTemplates", ue = new ne(xe), ue.arg("PageSize", this._pageSize), ae !== void 0 && ue.arg("PageToken", ae), ye.next = 6, this._services.commandExecutor.fetchResource(ue.build());
                  case 6:
                    return pe = ye.sent, ye.abrupt("return", [pe.templates.map(function(Ae) {
                      return new fr(Ae);
                    }), pe.meta.next_token]);
                  case 8:
                  case "end":
                    return ye.stop();
                }
            }, oe, this);
          }));
          function be(oe) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }]), Ee;
    }();
    function J(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = fe(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function fe(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return le(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return le(Ee, je);
      }
    }
    function le(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    var ke = /* @__PURE__ */ function(Ee) {
      function je() {
        var be = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (F.default(this, je), !(be.maxSize && be.maxSize > 0))
          throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = be.maxSize, this.onEviction = be.onEviction, this.cache = /* @__PURE__ */ new Map(), this.oldCache = /* @__PURE__ */ new Map(), this._size = 0;
      }
      return j.default(je, [{
        key: "_set",
        value: function(oe, ae) {
          if (this.cache.set(oe, ae), this._size++, this._size >= this.maxSize) {
            if (this._size = 0, typeof this.onEviction == "function") {
              var xe = J(this.oldCache.entries()), ue;
              try {
                for (xe.s(); !(ue = xe.n()).done; ) {
                  var pe = Y.default(ue.value, 2), ve = pe[0], ye = pe[1];
                  this.onEviction(ve, ye);
                }
              } catch (Ae) {
                xe.e(Ae);
              } finally {
                xe.f();
              }
            }
            this.oldCache = this.cache, this.cache = /* @__PURE__ */ new Map();
          }
        }
      }, {
        key: "get",
        value: function(oe) {
          if (this.cache.has(oe))
            return this.cache.get(oe);
          if (this.oldCache.has(oe)) {
            var ae = this.oldCache.get(oe);
            return this.oldCache.delete(oe), this._set(oe, ae), ae;
          }
        }
      }, {
        key: "set",
        value: function(oe, ae) {
          return this.cache.has(oe) ? this.cache.set(oe, ae) : this._set(oe, ae), this;
        }
      }, {
        key: "has",
        value: function(oe) {
          return this.cache.has(oe) || this.oldCache.has(oe);
        }
      }, {
        key: "peek",
        value: function(oe) {
          if (this.cache.has(oe))
            return this.cache.get(oe);
          if (this.oldCache.has(oe))
            return this.oldCache.get(oe);
        }
      }, {
        key: "delete",
        value: function(oe) {
          var ae = this.cache.delete(oe);
          return ae && this._size--, this.oldCache.delete(oe) || ae;
        }
      }, {
        key: "clear",
        value: function() {
          this.cache.clear(), this.oldCache.clear(), this._size = 0;
        }
      }, {
        key: "keys",
        value: /* @__PURE__ */ z.default.mark(function be() {
          var oe, ae, xe, ue;
          return z.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  oe = J(this), ve.prev = 1, oe.s();
                case 3:
                  if ((ae = oe.n()).done) {
                    ve.next = 9;
                    break;
                  }
                  return xe = Y.default(ae.value, 1), ue = xe[0], ve.next = 7, ue;
                case 7:
                  ve.next = 3;
                  break;
                case 9:
                  ve.next = 14;
                  break;
                case 11:
                  ve.prev = 11, ve.t0 = ve.catch(1), oe.e(ve.t0);
                case 14:
                  return ve.prev = 14, oe.f(), ve.finish(14);
                case 17:
                case "end":
                  return ve.stop();
              }
          }, be, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "values",
        value: /* @__PURE__ */ z.default.mark(function be() {
          var oe, ae, xe, ue;
          return z.default.wrap(function(ve) {
            for (; ; )
              switch (ve.prev = ve.next) {
                case 0:
                  oe = J(this), ve.prev = 1, oe.s();
                case 3:
                  if ((ae = oe.n()).done) {
                    ve.next = 9;
                    break;
                  }
                  return xe = Y.default(ae.value, 2), ue = xe[1], ve.next = 7, ue;
                case 7:
                  ve.next = 3;
                  break;
                case 9:
                  ve.next = 14;
                  break;
                case 11:
                  ve.prev = 11, ve.t0 = ve.catch(1), oe.e(ve.t0);
                case 14:
                  return ve.prev = 14, oe.f(), ve.finish(14);
                case 17:
                case "end":
                  return ve.stop();
              }
          }, be, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: Ee,
        value: /* @__PURE__ */ z.default.mark(function be() {
          var oe, ae, xe, ue, pe, ve, ye, Ae;
          return z.default.wrap(function(pt) {
            for (; ; )
              switch (pt.prev = pt.next) {
                case 0:
                  oe = J(this.cache), pt.prev = 1, oe.s();
                case 3:
                  if ((ae = oe.n()).done) {
                    pt.next = 9;
                    break;
                  }
                  return xe = ae.value, pt.next = 7, xe;
                case 7:
                  pt.next = 3;
                  break;
                case 9:
                  pt.next = 14;
                  break;
                case 11:
                  pt.prev = 11, pt.t0 = pt.catch(1), oe.e(pt.t0);
                case 14:
                  return pt.prev = 14, oe.f(), pt.finish(14);
                case 17:
                  ue = J(this.oldCache), pt.prev = 18, ue.s();
                case 20:
                  if ((pe = ue.n()).done) {
                    pt.next = 28;
                    break;
                  }
                  if (ve = pe.value, ye = Y.default(ve, 1), Ae = ye[0], this.cache.has(Ae)) {
                    pt.next = 26;
                    break;
                  }
                  return pt.next = 26, ve;
                case 26:
                  pt.next = 20;
                  break;
                case 28:
                  pt.next = 33;
                  break;
                case 30:
                  pt.prev = 30, pt.t1 = pt.catch(18), ue.e(pt.t1);
                case 33:
                  return pt.prev = 33, ue.f(), pt.finish(33);
                case 36:
                case "end":
                  return pt.stop();
              }
          }, be, this, [[1, 11, 14, 17], [18, 30, 33, 36]]);
        })
      }, {
        key: "size",
        get: function() {
          var oe = 0, ae = J(this.oldCache.keys()), xe;
          try {
            for (ae.s(); !(xe = ae.n()).done; ) {
              var ue = xe.value;
              this.cache.has(ue) || oe++;
            }
          } catch (pe) {
            ae.e(pe);
          } finally {
            ae.f();
          }
          return Math.min(this._size + oe, this.maxSize);
        }
      }]), je;
    }(Symbol.iterator), X = ke, he = /* @__PURE__ */ j.default(
      /**
       * Communication channel type.
       */
      /**
       * The actual metadata.
       */
      /**
       * @internal
       */
      function Ee(je, be) {
        F.default(this, Ee), this.type = je, this.data = be, Object.freeze(be);
      }
    ), $e = /* @__PURE__ */ function() {
      function Ee(je, be) {
        F.default(this, Ee), this._services = je, this._configuration = be, this._cache = new X({
          maxSize: be.channelMetadataCacheCapacity
        });
      }
      return j.default(Ee, [{
        key: "getChannelMetadata",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe) {
            var ue, pe, ve, ye, Ae;
            return z.default.wrap(function(pt) {
              for (; ; )
                switch (pt.prev = pt.next) {
                  case 0:
                    if (ue = "".concat(ae, ",").concat(xe), pe = this._cache.get(ue), !pe) {
                      pt.next = 4;
                      break;
                    }
                    return pt.abrupt("return", pe.item);
                  case 4:
                    return ve = "".concat(this._configuration.links.conversations, "/").concat(ae, "/Messages/").concat(xe, "/ChannelMetadata"), pt.prev = 5, pt.next = 8, this._services.commandExecutor.fetchResource(ve);
                  case 8:
                    ye = pt.sent, pt.next = 17;
                    break;
                  case 11:
                    if (pt.prev = 11, pt.t0 = pt.catch(5), !(pt.t0 instanceof Pe)) {
                      pt.next = 16;
                      break;
                    }
                    return this._cache.set(ue, {
                      item: null
                    }), pt.abrupt("return", null);
                  case 16:
                    throw new Error(pt.t0);
                  case 17:
                    return Ae = new he(ye.type, ye.data), this._cache.set(ue, {
                      item: Ae
                    }), pt.abrupt("return", Ae);
                  case 20:
                  case "end":
                    return pt.stop();
                }
            }, oe, this, [[5, 11]]);
          }));
          function be(oe, ae) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }]), Ee;
    }();
    function Ct(Ee, je) {
      var be = typeof Symbol < "u" && Ee[Symbol.iterator] || Ee["@@iterator"];
      if (!be) {
        if (Array.isArray(Ee) || (be = Bt(Ee)) || je) {
          be && (Ee = be);
          var oe = 0, ae = function() {
          };
          return { s: ae, n: function() {
            return oe >= Ee.length ? { done: !0 } : { done: !1, value: Ee[oe++] };
          }, e: function(ye) {
            throw ye;
          }, f: ae };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var xe = !0, ue = !1, pe;
      return { s: function() {
        be = be.call(Ee);
      }, n: function() {
        var ye = be.next();
        return xe = ye.done, ye;
      }, e: function(ye) {
        ue = !0, pe = ye;
      }, f: function() {
        try {
          !xe && be.return != null && be.return();
        } finally {
          if (ue) throw pe;
        }
      } };
    }
    function Bt(Ee, je) {
      if (Ee) {
        if (typeof Ee == "string") return St(Ee, je);
        var be = Object.prototype.toString.call(Ee).slice(8, -1);
        if (be === "Object" && Ee.constructor && (be = Ee.constructor.name), be === "Map" || be === "Set") return Array.from(Ee);
        if (be === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(be)) return St(Ee, je);
      }
    }
    function St(Ee, je) {
      (je == null || je > Ee.length) && (je = Ee.length);
      for (var be = 0, oe = new Array(je); be < je; be++)
        oe[be] = Ee[be];
      return oe;
    }
    var ir = /* @__PURE__ */ j.default(
      /**
       * Type of recipient.
       */
      /**
       * Sid of the message that this recipient belongs to.
       */
      /**
       * Email recipient level.
       */
      /**
       * Name of the recipient.
       */
      /**
       * Address of the recipient.
       */
      /**
       * @internal
       */
      function Ee(je) {
        F.default(this, Ee), H.default(this, "type", "email"), this.messageSid = je.message_sid, this.level = je.level, this.name = je.name, this.address = je.address;
      }
    ), Ir = /* @__PURE__ */ j.default(
      /**
       * Type of recipient.
       */
      /**
       * Sid of the message that this recipient belongs to.
       */
      /**
       * Recipient data as a JSON string.
       */
      /**
       * @internal
       */
      function Ee(je) {
        F.default(this, Ee), this.type = je.type, this.messageSid = je.message_sid, this.rawData = JSON.stringify(je);
      }
    ), Sr = /* @__PURE__ */ function() {
      function Ee(je, be) {
        F.default(this, Ee), this._services = je, this._configuration = be, this._cache = new X({
          maxSize: be.messageRecipientsCacheCapacity
        });
      }
      return j.default(Ee, [{
        key: "getRecipientsFromMessage",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe) {
            var ue = this, pe, ve, ye, Ae, Qe;
            return z.default.wrap(function(Tt) {
              for (; ; )
                switch (Tt.prev = Tt.next) {
                  case 0:
                    if (pe = "".concat(ae, ",").concat(xe), ve = this._cache.get(pe), !ve) {
                      Tt.next = 4;
                      break;
                    }
                    return Tt.abrupt("return", ve.item);
                  case 4:
                    return ye = new ne(this._configuration.links.conversations).path(ae).path("MessageRecipients").arg("MessageSid", xe).build(), Tt.next = 7, this._services.commandExecutor.fetchResource(ye);
                  case 7:
                    return Ae = Tt.sent, Qe = Ae.message_recipients.map(function(zt) {
                      return ue._wrapResponse(zt);
                    }), Qe.length > 0 && this._cache.set(pe, {
                      item: Qe
                    }), Tt.abrupt("return", Qe);
                  case 11:
                  case "end":
                    return Tt.stop();
                }
            }, oe, this);
          }));
          function be(oe, ae) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }, {
        key: "getRecipientsFromConversation",
        value: function() {
          var je = m.default(/* @__PURE__ */ z.default.mark(function oe(ae, xe) {
            var ue, pe, ve = this, ye, Ae, Qe, pt, Tt, zt, mn, Tn, Zn, ia;
            return z.default.wrap(function(Ki) {
              for (; ; )
                switch (Ki.prev = Ki.next) {
                  case 0:
                    return ye = new ne(this._configuration.links.conversations).path(ae).path("MessageRecipients").arg("PageToken", (ue = xe == null ? void 0 : xe.pageToken) !== null && ue !== void 0 ? ue : void 0).arg("PageSize", (pe = xe == null ? void 0 : xe.pageSize) !== null && pe !== void 0 ? pe : void 0).build(), Ki.next = 3, this._services.commandExecutor.fetchResource(ye);
                  case 3:
                    Ae = Ki.sent, Qe = Ae.message_recipients.map(function(Wn) {
                      return ve._wrapResponse(Wn);
                    }), pt = Ct(Qe);
                    try {
                      for (pt.s(); !(Tt = pt.n()).done; )
                        Tn = Tt.value, Zn = "".concat(ae, ",").concat(Tn.messageSid), ia = (zt = (mn = this._cache.get(Zn)) === null || mn === void 0 ? void 0 : mn.item) !== null && zt !== void 0 ? zt : [], this._cache.set(Zn, {
                          item: [].concat(Z.default(ia), [Tn])
                        });
                    } catch (Wn) {
                      pt.e(Wn);
                    } finally {
                      pt.f();
                    }
                    return Ki.abrupt("return", new pr(Qe, function(Wn, Xs) {
                      return ve.getRecipientsFromConversation(ae, {
                        pageToken: Wn,
                        pageSize: Xs
                      });
                    }, Ae.meta.previous_token, Ae.meta.next_token));
                  case 8:
                  case "end":
                    return Ki.stop();
                }
            }, oe, this);
          }));
          function be(oe, ae) {
            return je.apply(this, arguments);
          }
          return be;
        }()
      }, {
        key: "_wrapResponse",
        value: function(be) {
          switch (be.type) {
            case "email":
              return new ir(be);
            default:
              return new Ir(be);
          }
        }
      }]), Ee;
    }(), Vr;
    function ri(Ee, je) {
      var be = Object.keys(Ee);
      if (Object.getOwnPropertySymbols) {
        var oe = Object.getOwnPropertySymbols(Ee);
        je && (oe = oe.filter(function(ae) {
          return Object.getOwnPropertyDescriptor(Ee, ae).enumerable;
        })), be.push.apply(be, oe);
      }
      return be;
    }
    function ni(Ee) {
      for (var je = 1; je < arguments.length; je++) {
        var be = arguments[je] != null ? arguments[je] : {};
        je % 2 ? ri(Object(be), !0).forEach(function(oe) {
          H.default(Ee, oe, be[oe]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ee, Object.getOwnPropertyDescriptors(be)) : ri(Object(be)).forEach(function(oe) {
          Object.defineProperty(Ee, oe, Object.getOwnPropertyDescriptor(be, oe));
        });
      }
      return Ee;
    }
    function Yn(Ee) {
      var je = ja();
      return function() {
        var oe = G.default(Ee), ae;
        if (je) {
          var xe = G.default(this).constructor;
          ae = Reflect.construct(oe, arguments, xe);
        } else
          ae = oe.apply(this, arguments);
        return O.default(this, ae);
      };
    }
    function ja() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var Rr, _o = /* @__PURE__ */ j.default(function Ee() {
      F.default(this, Ee);
    });
    t.Client = Rr = (Vr = /* @__PURE__ */ function(Ee) {
      k.default(be, Ee);
      var je = Yn(be);
      function be(oe) {
        var ae, xe, ue, pe, ve, ye, Ae = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (F.default(this, be), ye = je.call(this), H.default(v.default(ye), "version", Me), H.default(v.default(ye), "connectionState", "unknown"), H.default(v.default(ye), "parsePushNotification", Rr.parsePushNotification), ye._fpaToken = oe ?? "", ye._options = Ae ?? {}, !ye._options.disableDeepClone) {
          var Qe = ni(ni({}, ye._options), {}, {
            transport: void 0,
            twilsockClient: void 0
          });
          Qe = lt(Qe), Qe.transport = ye._options.transport, Qe.twilsockClient = ye._options.twilsockClient, ye._options = Qe;
        }
        ye._options.logLevel = (ae = ye._options.logLevel) !== null && ae !== void 0 ? ae : "silent", Rr._logger.setLevel(ye._options.logLevel);
        var pt = ye._options.productId = "ip_messaging";
        if (ye._options.clientMetadata = ye._options.clientMetadata || {}, ye._options.clientMetadata.hasOwnProperty("type") || (ye._options.clientMetadata.type = "conversations"), ye._options.clientMetadata.hasOwnProperty("sdk") || (ye._options.clientMetadata.sdk = "JS", ye._options.clientMetadata.sdkv = Me), ye._options.Sync = ye._options.Sync || {}, typeof ye._options.Sync.enableSessionStorage > "u" && (ye._options.Sync.enableSessionStorage = !0), ye._options.region && (ye._options.Sync.region = ye._options.region), !oe)
          throw new Error("A valid Twilio token should be provided");
        ye._services = new _o(), ye._myself = new ft("", "", null, ye._services);
        var Tt = !ye._options.twilsockClient;
        if (!ye._options.initRegistrations) {
          var zt = new x.InitRegistration(pt);
          Rr.populateInitRegistrations(zt), ye._options.initRegistrations = [zt];
        }
        ye._services.twilsockClient = ye._options.twilsockClient = (xe = ye._options.twilsockClient) !== null && xe !== void 0 ? xe : new x.TwilsockClient(oe, pt, ye._options), ye._services.twilsockClient.on(Rr.tokenAboutToExpire, function() {
          return ye.emit(Rr.tokenAboutToExpire);
        }), ye._services.twilsockClient.on(Rr.tokenExpired, function() {
          return ye.emit(Rr.tokenExpired);
        }), ye._services.twilsockClient.on(Rr.connectionError, function(Ki) {
          return ye.emit(Rr.connectionError, Ki);
        }), ye._services.twilsockClient.on("stateChanged", function(Ki) {
          Rr._logger.debug("Handling stateChanged for ConversationsClient: new state ".concat(Ki)), Ki !== ye.connectionState && (ye.connectionState = Ki, ye.emit(Rr.connectionStateChanged, ye.connectionState));
        }), ye._services.transport = ye._options.transport = (ue = ye._options.transport) !== null && ue !== void 0 ? ue : ye._options.twilsockClient, ye._services.notificationClient = ye._options.notificationsClient = (pe = ye._options.notificationsClient) !== null && pe !== void 0 ? pe : new S.Notifications(oe, ye._options), ye._services.syncClient = ye._options.syncClient = (ve = ye._options.syncClient) !== null && ve !== void 0 ? ve : new A.SyncClient(oe, ye._options);
        var mn = (Ae == null ? void 0 : Ae.Chat) || (Ae == null ? void 0 : Ae.IPMessaging) || Ae || {}, Tn = mn.region || (Ae == null ? void 0 : Ae.region), Zn = mn.apiUri || mn.typingUri || "https://aim.".concat(Tn || "us1", ".twilio.com");
        ye._services.commandExecutor = new Q(Zn, {
          transport: ye._options.transport
        }, pt), ye._services.contentClient = new te(ye._services);
        var ia = function(Wn) {
          ye._rejectEnsureReady(Wn), ye.emit(Rr.stateChanged, "failed"), ye.emit(Rr.initFailed, {
            error: Wn
          });
        }, Fs = function() {
          ia({
            terminal: !0,
            message: "Twilsock has disconnected."
          }), ye._initializeEnsureReady((Ae == null ? void 0 : Ae.throwErrorsAlways) || !1);
        };
        return ye._services.twilsockClient.once("connectionError", ia), ye._services.twilsockClient.once("disconnected", Fs), ye._services.twilsockClient.once("connected", /* @__PURE__ */ m.default(/* @__PURE__ */ z.default.mark(function Ki() {
          var Wn, Xs;
          return z.default.wrap(function(Mn) {
            for (; ; )
              switch (Mn.prev = Mn.next) {
                case 0:
                  return Rr._logger.debug("ConversationsClient started INITIALIZING"), ye._services.twilsockClient.off("connectionError", ia), ye._services.twilsockClient.off("disconnected", Fs), Mn.prev = 3, Wn = "conversations.client.startup", ye._services.twilsockClient.addPartialTelemetryEvent(new x.TelemetryEventDescription(Wn, "Conversations client startup", /* @__PURE__ */ new Date()), Wn, x.TelemetryPoint.Start), Mn.next = 8, ye._initialize();
                case 8:
                  ye._services.twilsockClient.addPartialTelemetryEvent(new x.TelemetryEventDescription("", "", /* @__PURE__ */ new Date()), Wn, x.TelemetryPoint.End), Mn.next = 17;
                  break;
                case 11:
                  Mn.prev = 11, Mn.t0 = Mn.catch(3), Xs = {
                    terminal: !0,
                    message: Mn.t0.message
                  }, ye._rejectEnsureReady(Xs), ye.emit(Rr.stateChanged, "failed"), ye.emit(Rr.initFailed, {
                    error: Xs
                  });
                case 17:
                case "end":
                  return Mn.stop();
              }
          }, Ki, null, [[3, 11]]);
        }))), ye._initializeEnsureReady((Ae == null ? void 0 : Ae.throwErrorsAlways) || !1), Tt && ye._services.twilsockClient.connect(), ye;
      }
      return j.default(be, [{
        key: "user",
        get: function() {
          return this._myself;
        }
        /**
         * Client reachability state. Throws an error if accessed before the client
         * initialization was completed.
         */
      }, {
        key: "reachabilityEnabled",
        get: function() {
          if (!this._configuration)
            throw new Error("Reachability information could not yet be accessed as the client has not yet been initialized. Subscribe to the 'stateChanged' event to properly react to the client initialization.");
          return this._configuration.reachabilityEnabled;
        }
        /**
         * @deprecated
         * Current token.
         * @internal
         */
      }, {
        key: "token",
        get: function() {
          return this._fpaToken;
        }
        /**
         * @deprecated Call constructor directly.
         *
         * Factory method to create a Conversations client instance.
         *
         * The factory method will automatically trigger connection.
         * Do not use it if you need finer-grained control.
         *
         * Since this method returns an already-initialized client, some of the events
         * will be lost because they happen *before* the initialization. It is
         * recommended that `client.onWithReplay` is used as opposed to `client.on`
         * for subscribing to client events. The `client.onWithReplay` will re-emit
         * the most recent value for a given event if it emitted before the
         * subscription.
         *
         * @param token Access token.
         * @param options Options to customize the client.
         * @returns Returns a fully initialized client.
         */
      }, {
        key: "shutdown",
        value: (
          /**
           * Gracefully shut down the client.
           */
          function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
              return z.default.wrap(function(pe) {
                for (; ; )
                  switch (pe.prev = pe.next) {
                    case 0:
                      return pe.next = 2, this._ensureReady;
                    case 2:
                      return pe.next = 4, this._services.twilsockClient.disconnect();
                    case 4:
                    case "end":
                      return pe.stop();
                  }
              }, xe, this);
            }));
            function ae() {
              return oe.apply(this, arguments);
            }
            return ae;
          }()
        )
        /**
         * Update the token used by the client and re-register with the Conversations services.
         * @param token New access token.
         */
      }, {
        key: "updateToken",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._ensureReady;
                  case 2:
                    if (Rr._logger.info("updateToken"), this._fpaToken !== ue) {
                      ve.next = 5;
                      break;
                    }
                    return ve.abrupt("return", this);
                  case 5:
                    return ve.next = 7, this._services.twilsockClient.updateToken(ue);
                  case 7:
                    return ve.next = 9, this._services.notificationClient.updateToken(ue);
                  case 9:
                    return ve.next = 11, this._services.mcsClient.updateToken(ue);
                  case 11:
                    return this._fpaToken = ue, ve.abrupt("return", this);
                  case 13:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a known conversation by its SID.
         * @param conversationSid Conversation sid
         */
      }, {
        key: "getConversationBySid",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._ensureReady;
                  case 2:
                    return ye.next = 4, this._conversationsEntity.myConversationsRead.promise;
                  case 4:
                    return ye.next = 6, this._conversationsEntity.getConversation(ue);
                  case 6:
                    if (pe = ye.sent, pe) {
                      ye.next = 12;
                      break;
                    }
                    return ye.next = 10, this.peekConversationBySid(ue);
                  case 10:
                    pe = ye.sent, pe && M.deprecationWarning("The method getConversationBySid is deprecated to retrieve conversations you're not part of. Use peekConversationBySid instead.");
                  case 12:
                    if (pe) {
                      ye.next = 14;
                      break;
                    }
                    throw new Error("Conversation with SID ".concat(ue, " was not found."));
                  case 14:
                    return ye.abrupt("return", pe);
                  case 15:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Peek a conversation by its SID.
         * @param conversationSid Conversation sid
         * @internal
         */
      }, {
        key: "peekConversationBySid",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._ensureReady;
                  case 2:
                    return ye.next = 4, this._conversationsEntity.peekConversation(ue);
                  case 4:
                    if (pe = ye.sent, pe) {
                      ye.next = 7;
                      break;
                    }
                    throw new Error("Conversation with SID ".concat(ue, " was not found."));
                  case 7:
                    return ye.abrupt("return", pe);
                  case 8:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a known conversation by its unique identifier name.
         * @param uniqueName The unique identifier name of the conversation.
         */
      }, {
        key: "getConversationByUniqueName",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            var pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._ensureReady;
                  case 2:
                    return ye.next = 4, this._conversationsEntity.myConversationsRead.promise;
                  case 4:
                    return ye.next = 6, this._conversationsEntity.getConversationByUniqueName(ue);
                  case 6:
                    if (pe = ye.sent, pe) {
                      ye.next = 9;
                      break;
                    }
                    throw new Error("Conversation with unique name ".concat(ue, " was not found."));
                  case 9:
                    return ye.abrupt("return", pe);
                  case 10:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get the current list of all the subscribed conversations.
         */
      }, {
        key: "getSubscribedConversations",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._ensureReady;
                  case 2:
                    return pe.abrupt("return", this._conversationsPromise.then(function(ve) {
                      return ve.getConversations();
                    }));
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Create a conversation on the server and subscribe to its events.
         * The default is a conversation with an empty friendly name.
         * @param options Options for the conversation.
         */
      }, {
        key: "createConversation",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._ensureReady;
                  case 2:
                    return ue = ue || {}, ve.abrupt("return", this._conversationsPromise.then(function(ye) {
                      return ye.addConversation(ue);
                    }));
                  case 4:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Register for push notifications.
         * @param channelType Channel type.
         * @param registrationId Push notification ID provided by the FCM/APNS service
         * on the platform.
         */
      }, {
        key: "setPushRegistrationId",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._ensureReady;
                  case 2:
                    return this._subscribeToPushNotifications(ue), this._services.notificationClient.setPushRegistrationId(ue, pe), ye.next = 6, this._services.notificationClient.commitChanges();
                  case 6:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Unregister from push notifications.
         * @param channelType Channel type.
         * @deprecated Use removePushRegistrations() instead.
         */
      }, {
        key: "unsetPushRegistrationId",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._ensureReady;
                  case 2:
                    return this._unsubscribeFromPushNotifications(ue), ve.next = 5, this._services.notificationClient.commitChanges();
                  case 5:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Clear existing registrations directly using provided device token.
         * This is useful to ensure stopped subscriptions without resubscribing.
         *
         * This function goes completely beside the state machine and removes all
         * registrations.
         * Use with caution: if it races with current state machine operations,
         * madness will ensue.
         *
         * @param channelType Channel type.
         * @param registrationId Push notification ID provided by the FCM/APNS service
         * on the platform.
         */
      }, {
        key: "removePushRegistrations",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._services.notificationClient.removeRegistrations(ue, pe);
                  case 2:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Parse a push notification payload.
         */
      }, {
        key: "handlePushNotification",
        value: (
          /**
           * Handle push notification payload parsing and emit the
           * {@link Client.pushNotification} event on this {@link Client} instance.
           * @param notificationPayload Push notification payload
           */
          function() {
            var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
              return z.default.wrap(function(ve) {
                for (; ; )
                  switch (ve.prev = ve.next) {
                    case 0:
                      return ve.next = 2, this._ensureReady;
                    case 2:
                      Rr._logger.debug("handlePushNotification, notificationPayload=", ue), this.emit("pushNotification", Rr.parsePushNotification(ue));
                    case 4:
                    case "end":
                      return ve.stop();
                  }
              }, xe, this);
            }));
            function ae(xe) {
              return oe.apply(this, arguments);
            }
            return ae;
          }()
        )
        /**
         * Gets a user with the given identity. If it's in the subscribed list, then
         * return the user object from it;
         * if not, then subscribe and add user to the subscribed list.
         * @param identity Identity of the user.
         * @returns A fully initialized user.
         */
      }, {
        key: "getUser",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue) {
            return z.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.next = 2, this._ensureReady;
                  case 2:
                    return ve.abrupt("return", this._services.users.getUser(ue));
                  case 3:
                  case "end":
                    return ve.stop();
                }
            }, xe, this);
          }));
          function ae(xe) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get a list of subscribed user objects.
         */
      }, {
        key: "getSubscribedUsers",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._ensureReady;
                  case 2:
                    return pe.abrupt("return", this._services.users.getSubscribedUsers());
                  case 3:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Get content URLs for all media attachments in the given set of media sids
         * using a single operation.
         * @param mediaSids Set of media sids to query for the content URL.
         */
      }, {
        key: "getTemporaryContentUrlsForMediaSids",
        value: function(ae) {
          var xe = this;
          return new I.CancellablePromise(/* @__PURE__ */ function() {
            var ue = m.default(/* @__PURE__ */ z.default.mark(function pe(ve, ye, Ae) {
              var Qe, pt;
              return z.default.wrap(function(zt) {
                for (; ; )
                  switch (zt.prev = zt.next) {
                    case 0:
                      if (!(!xe._services.mcsClient || !ae)) {
                        zt.next = 3;
                        break;
                      }
                      return ye(new Error("Media Content Service is unavailable")), zt.abrupt("return");
                    case 3:
                      return Qe = xe._services.mcsClient.mediaSetGetContentUrls(ae), Ae(function() {
                        Qe.cancel();
                      }), zt.prev = 5, zt.next = 8, Qe;
                    case 8:
                      pt = zt.sent, ve(pt), zt.next = 15;
                      break;
                    case 12:
                      zt.prev = 12, zt.t0 = zt.catch(5), ye(zt.t0);
                    case 15:
                    case "end":
                      return zt.stop();
                  }
              }, pe, null, [[5, 12]]);
            }));
            return function(pe, ve, ye) {
              return ue.apply(this, arguments);
            };
          }());
        }
        /**
         * Get content URLs for all media attachments in the given set using a single
         * operation.
         * @param contentSet Set of media attachments to query content URLs.
         */
      }, {
        key: "getTemporaryContentUrlsForMedia",
        value: function(ae) {
          var xe = ae.map(function(ue) {
            return ue.sid;
          });
          return this.getTemporaryContentUrlsForMediaSids(xe);
        }
        /**
         * Returns rich content templates belonging to the account. Rich content
         * templates can be created via the Twilio console or the REST API.
         */
      }, {
        key: "getContentTemplates",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            return z.default.wrap(function(pe) {
              for (; ; )
                switch (pe.prev = pe.next) {
                  case 0:
                    return pe.next = 2, this._ensureReady;
                  case 2:
                    return pe.next = 4, this._services.contentClient.getContentTemplates();
                  case 4:
                    return pe.abrupt("return", pe.sent);
                  case 5:
                  case "end":
                    return pe.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Initialize the client.
         */
      }, {
        key: "_initialize",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe() {
            var ue = this, pe;
            return z.default.wrap(function(ye) {
              for (; ; )
                switch (ye.prev = ye.next) {
                  case 0:
                    return ye.next = 2, this._services.commandExecutor.fetchResource("Client/v2/Configuration");
                  case 2:
                    return pe = ye.sent, this._configuration = new Ot(this._options, pe, Rr._logger), this._services.channelMetadataClient = new $e(this._services, this._configuration), this._services.messageRecipientsClient = new Sr(this._services, this._configuration), this._myself._resolveInitialization(this._configuration, this._configuration.userIdentity, this._configuration.userInfo, !0), this._services.typingIndicator = new De(this.getConversationBySid.bind(this), this._configuration, this._services), this._services.network = new tt(this._configuration, this._services), this._services.users = new st(this._myself, this._configuration, this._services), this._services.users.on("userSubscribed", function(Ae) {
                      ue.emit("userSubscribed", Ae);
                    }), this._services.users.on("userUpdated", function(Ae) {
                      return ue.emit("userUpdated", Ae);
                    }), this._services.users.on("userUnsubscribed", function(Ae) {
                      ue.emit("userUnsubscribed", Ae);
                    }), this._conversationsEntity = new Bc(this._configuration, this._services), this._conversationsEntity.on("conversationAdded", function(Ae) {
                      ue.emit("conversationAdded", Ae);
                    }), this._conversationsEntity.on("conversationRemoved", function(Ae) {
                      ue.emit("conversationRemoved", Ae);
                    }), this._conversationsEntity.on("conversationJoined", function(Ae) {
                      ue.emit("conversationJoined", Ae);
                    }), this._conversationsEntity.on("conversationLeft", function(Ae) {
                      ue.emit("conversationLeft", Ae);
                    }), this._conversationsEntity.on("conversationUpdated", function(Ae) {
                      return ue.emit("conversationUpdated", Ae);
                    }), this._conversationsEntity.on("participantJoined", function(Ae) {
                      ue.emit("participantJoined", Ae);
                    }), this._conversationsEntity.on("participantLeft", function(Ae) {
                      ue.emit("participantLeft", Ae);
                    }), this._conversationsEntity.on("participantUpdated", function(Ae) {
                      return ue.emit("participantUpdated", Ae);
                    }), this._conversationsEntity.on("messageAdded", function(Ae) {
                      return ue.emit("messageAdded", Ae);
                    }), this._conversationsEntity.on("messageUpdated", function(Ae) {
                      return ue.emit("messageUpdated", Ae);
                    }), this._conversationsEntity.on("messageRemoved", function(Ae) {
                      return ue.emit("messageRemoved", Ae);
                    }), this._conversationsEntity.on("typingStarted", function(Ae) {
                      return ue.emit("typingStarted", Ae);
                    }), this._conversationsEntity.on("typingEnded", function(Ae) {
                      return ue.emit("typingEnded", Ae);
                    }), this._conversationsPromise = this._conversationsEntity.fetchConversations().then(function() {
                      return ue._conversationsEntity;
                    }).catch(function(Ae) {
                      throw console.error("Failed to fetch conversations _conversationsPromise -> client.ts", Ae), Ae;
                    }), ye.next = 30, this._services.users.myself._ensureFetched();
                  case 30:
                    Rr._supportedPushChannels.forEach(function(Ae) {
                      return ue._subscribeToPushNotifications(Ae);
                    }), this._services.typingIndicator.initialize(), this._services.mcsClient = new I.McsClient(this._fpaToken, this._configuration.links.mediaService, this._configuration.links.mediaSetService, ni(ni({}, this._options), {}, {
                      transport: void 0
                    })), this._resolveEnsureReady(), this.emit(Rr.stateChanged, "initialized"), this.emit(Rr.initialized);
                  case 36:
                  case "end":
                    return ye.stop();
                }
            }, xe, this);
          }));
          function ae() {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Subscribe to push notifications.
         * @param channelType The channel type to subscribe to.
         */
      }, {
        key: "_subscribeToPushNotifications",
        value: function(ae) {
          var xe = this;
          [kt.NEW_MESSAGE, kt.ADDED_TO_CONVERSATION, kt.REMOVED_FROM_CONVERSATION, kt.TYPING_INDICATOR, kt.CONSUMPTION_UPDATE].forEach(function(ue) {
            xe._services.notificationClient.subscribe(ae, ue);
          });
        }
        /**
         * Unsubscribe from push notifications.
         * @param channelType The channel type to unsubscribe from.
         */
      }, {
        key: "_unsubscribeFromPushNotifications",
        value: function(ae) {
          var xe = this;
          [kt.NEW_MESSAGE, kt.ADDED_TO_CONVERSATION, kt.REMOVED_FROM_CONVERSATION, kt.TYPING_INDICATOR, kt.CONSUMPTION_UPDATE].forEach(function(ue) {
            xe._services.notificationClient.unsubscribe(ae, ue);
          });
        }
        /**
         * Initialize the ensureReady promise.
         */
      }, {
        key: "_initializeEnsureReady",
        value: function(ae) {
          var xe = this;
          this._ensureReady = new Promise(function(ue, pe) {
            xe._resolveEnsureReady = ue, xe._rejectEnsureReady = pe;
          }).catch(function(ue) {
            if (ae)
              throw ue;
          });
        }
      }], [{
        key: "create",
        value: function() {
          var oe = m.default(/* @__PURE__ */ z.default.mark(function xe(ue, pe) {
            var ve;
            return z.default.wrap(function(Ae) {
              for (; ; )
                switch (Ae.prev = Ae.next) {
                  case 0:
                    if (!(pe != null && pe.twilsockClient)) {
                      Ae.next = 2;
                      break;
                    }
                    throw new Error("Obsolete usage of ConversationsClient.create() factory method: if you pass twilsock from the outside then you must use ConversationsClient constructor and be prepared to work with uninitialized client.");
                  case 2:
                    return ve = new Rr(ue, pe), Ae.next = 5, ve._ensureReady;
                  case 5:
                    return Ae.abrupt("return", ve);
                  case 6:
                  case "end":
                    return Ae.stop();
                }
            }, xe);
          }));
          function ae(xe, ue) {
            return oe.apply(this, arguments);
          }
          return ae;
        }()
        /**
         * Static method for push notification payload parsing. Returns parsed push as
         * a {@link PushNotification} object.
         * @param notificationPayload Push notification payload.
         */
      }, {
        key: "parsePushNotification",
        value: function(ae) {
          if (Rr._logger.debug("parsePushNotification, notificationPayload=", ae), typeof ae.aps < "u") {
            if (!ae.twi_message_type)
              throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
            var xe = Rr._parsePushNotificationChatData(ae), ue = ae.aps, pe, ve = null;
            if (typeof ue.alert == "string")
              pe = ue.alert || null;
            else {
              var ye, Ae;
              pe = ((ye = ue.alert) === null || ye === void 0 ? void 0 : ye.body) || null, ve = ((Ae = ue.alert) === null || Ae === void 0 ? void 0 : Ae.title) || null;
            }
            return new Be({
              title: ve,
              body: pe,
              sound: ue.sound || null,
              badge: ue.badge || null,
              action: ue.category || null,
              type: ae.twi_message_type,
              data: xe
            });
          }
          if (typeof ae.data < "u") {
            var Qe = ae.data;
            if (!Qe.twi_message_type)
              throw new Error("Provided push notification payload does not contain Programmable Chat push notification type");
            var pt = Rr._parsePushNotificationChatData(ae.data);
            return new Be({
              title: Qe.twi_title || null,
              body: Qe.twi_body || null,
              sound: Qe.twi_sound || null,
              badge: null,
              action: Qe.twi_action || null,
              type: Qe.twi_message_type,
              data: pt
            });
          }
          throw new Error("Provided push notification payload is not Programmable Chat notification");
        }
        /**
         * Static method for parsing push notification chat data.
         * @param data Data to parse
         */
      }, {
        key: "_parsePushNotificationChatData",
        value: function(ae) {
          var xe = {};
          for (var ue in Rr._supportedPushDataFields) {
            var pe = ae[ue];
            if (!(typeof pe > "u" || pe === null)) {
              if (ue === "message_index" || ue === "media_count") {
                var ve = mt(pe);
                ve !== null && (xe[Rr._supportedPushDataFields[ue]] = ve);
                continue;
              }
              if (ue === "media") {
                if (typeof pe == "string")
                  try {
                    xe[Rr._supportedPushDataFields[ue]] = JSON.parse(pe);
                  } catch {
                    Rr._logger.debug("Media message notification parsing error");
                  }
                continue;
              }
              xe[Rr._supportedPushDataFields[ue]] = pe;
            }
          }
          return xe;
        }
        /**
         * Populate the client with init registrations.
         * @param reg The init registration to populate.
         */
      }, {
        key: "populateInitRegistrations",
        value: function(ae) {
          ae.populateInitRegistrations([kt.TYPING_INDICATOR]), A.SyncClient.populateInitRegistrations(ae);
        }
      }]), be;
    }(b.ReplayEventEmitter), H.default(Vr, "conversationAdded", "conversationAdded"), H.default(Vr, "conversationJoined", "conversationJoined"), H.default(Vr, "conversationLeft", "conversationLeft"), H.default(Vr, "conversationRemoved", "conversationRemoved"), H.default(Vr, "conversationUpdated", "conversationUpdated"), H.default(Vr, "participantJoined", "participantJoined"), H.default(Vr, "participantLeft", "participantLeft"), H.default(Vr, "participantUpdated", "participantUpdated"), H.default(Vr, "messageAdded", "messageAdded"), H.default(Vr, "messageRemoved", "messageRemoved"), H.default(Vr, "messageUpdated", "messageUpdated"), H.default(Vr, "tokenAboutToExpire", "tokenAboutToExpire"), H.default(Vr, "tokenExpired", "tokenExpired"), H.default(Vr, "typingEnded", "typingEnded"), H.default(Vr, "typingStarted", "typingStarted"), H.default(Vr, "pushNotification", "pushNotification"), H.default(Vr, "userSubscribed", "userSubscribed"), H.default(Vr, "userUnsubscribed", "userUnsubscribed"), H.default(Vr, "userUpdated", "userUpdated"), H.default(Vr, "stateChanged", "stateChanged"), H.default(Vr, "initialized", "initialized"), H.default(Vr, "initFailed", "initFailed"), H.default(Vr, "connectionStateChanged", "connectionStateChanged"), H.default(Vr, "connectionError", "connectionError"), H.default(Vr, "version", Me), H.default(Vr, "_logger", we.scope("Client")), H.default(Vr, "_supportedPushChannels", ["fcm", "apn"]), H.default(Vr, "_supportedPushDataFields", {
      conversation_sid: "conversationSid",
      conversation_title: "conversationTitle",
      message_sid: "messageSid",
      message_index: "messageIndex",
      media_count: "mediaCount",
      media: "media"
      // object
    }), Vr), ce([M.deprecated("token"), ee("design:type", String), ee("design:paramtypes", [])], t.Client.prototype, "token", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "updateToken", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "getConversationBySid", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "peekConversationBySid", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "getConversationByUniqueName", null), ce([g.validateTypesAsync(["undefined", g.objectSchema("conversation options", {
      friendlyName: ["string", "undefined"],
      isPrivate: ["boolean", "undefined"],
      uniqueName: ["string", "undefined"]
    })]), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], t.Client.prototype, "createConversation", null), ce([g.validateTypesAsync(g.literal("fcm", "apn"), "string"), ee("design:type", Function), ee("design:paramtypes", [String, String]), ee("design:returntype", Promise)], t.Client.prototype, "setPushRegistrationId", null), ce([g.validateTypesAsync(g.literal("fcm", "apn")), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "unsetPushRegistrationId", null), ce([g.validateTypesAsync(g.literal("fcm", "apn"), g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String, String]), ee("design:returntype", Promise)], t.Client.prototype, "removePushRegistrations", null), ce([g.validateTypesAsync(g.pureObject), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Promise)], t.Client.prototype, "handlePushNotification", null), ce([g.validateTypesAsync(g.nonEmptyString), ee("design:type", Function), ee("design:paramtypes", [String]), ee("design:returntype", Promise)], t.Client.prototype, "getUser", null), ce([g.validateTypesAsync(g.nonEmptyArray("strings", "string")), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", I.CancellablePromise)], t.Client.prototype, "getTemporaryContentUrlsForMediaSids", null), ce([g.validateTypesAsync(g.nonEmptyArray("media", Er)), ee("design:type", Function), ee("design:paramtypes", [Array]), ee("design:returntype", I.CancellablePromise)], t.Client.prototype, "getTemporaryContentUrlsForMedia", null), ce([M.deprecated("Client.create()", "new Client()"), g.validateTypesAsync("string", ["undefined", g.pureObject]), ee("design:type", Function), ee("design:paramtypes", [String, Object]), ee("design:returntype", Promise)], t.Client, "create", null), ce([g.validateTypes(g.pureObject), ee("design:type", Function), ee("design:paramtypes", [Object]), ee("design:returntype", Be)], t.Client, "parsePushNotification", null), t.Client = Rr = ce([g.validateConstructorTypes(g.nonEmptyString, [g.pureObject, "undefined"]), ee("design:paramtypes", [String, Object])], t.Client), Object.defineProperty(t, "CancellablePromise", {
      enumerable: !0,
      get: function() {
        return I.CancellablePromise;
      }
    }), t.AggregatedDeliveryReceipt = gr, t.ChannelMetadata = he, t.ContentTemplate = fr, t.ContentTemplateVariable = er, t.Conversation = Ka, t.DetailedDeliveryReceipt = Xr, t.EmailRecipientDescriptor = ir, t.Media = Er, t.Message = La, t.MessageBuilder = So, t.NotificationTypes = kt, t.Participant = vt, t.PushNotification = Be, t.RestPaginator = pr, t.UnknownRecipientDescriptor = Ir, t.UnsentMessage = Vu, t.User = ft;
  }(eie)), eie;
}
var Cqr = xqr();
const tv = {
  errors: {
    authToken: {
      invalidToken: "Invalid conversation token",
      identityNotFound: "No identity found on conversation",
      refreshFailed: "Failed to refresh token"
    },
    conversationNotFound: "Conversation could not be found",
    invalidConversationSid: "Invalid Conversation Identifier"
  }
};
class wqr {
  constructor() {
    Za(this, "client");
    Za(this, "conversation");
    Za(this, "chatIdentity");
    Za(this, "listeners", {});
    Za(this, "isServiceReady", !1);
    Za(this, "initTypingEvents", (e) => {
      const r = (n) => (a) => {
        var i;
        a.identity !== this.chatIdentity && ((i = this.listeners[bs.Typing]) == null || i.forEach(
          (o) => o(n)
        ));
      };
      e.on("typingStarted", r(!0)), e.on("typingEnded", r(!1));
    });
    Za(this, "initMessageEvents", (e) => {
      const r = async (a) => {
        var i;
        (i = this.listeners[bs.NewMessage]) == null || i.forEach(
          (o) => o(a)
        );
      }, n = async () => {
        var i;
        const a = await this.fetchAllMessages(e);
        (i = this.listeners[bs.AllMessages]) == null || i.forEach(
          (o) => o(a)
        );
      };
      e.on("messageAdded", r), e.on("messageUpdated", n), e.on("messageRemoved", n), n();
    });
    Za(this, "initParticipantEvents", async (e) => {
      const r = (n) => async (a) => {
        var s;
        const i = this.getAgentDetails(a), o = { action: n, agent: i };
        (s = this.listeners[bs.Agent]) == null || s.forEach(
          (l) => l(o)
        );
      };
      e.on(
        "participantLeft",
        r(CF.Leave)
      ), e.on(
        "participantJoined",
        r(CF.Join)
      );
    });
    Za(this, "initUpdatedEvents", (e) => {
      e.on("updated", (r) => {
        var n;
        (n = this.listeners[bs.Updated]) == null || n.forEach(
          (a) => a(r)
        );
      });
    });
    // Init all event listeners from SDK
    Za(this, "initConversation", async (e) => {
      this.initTypingEvents(e), this.initMessageEvents(e), this.initParticipantEvents(e), this.initUpdatedEvents(e);
    });
    Za(this, "getAgentDetails", ({ sid: e, identity: r }) => ({
      sid: e,
      identity: r || ""
    }));
    Za(this, "handleTokenError", (e) => {
      console.error("Token Error:", e), this.setError(tv.errors.authToken.refreshFailed);
    });
    Za(this, "refreshAuthToken", async () => {
      var e;
      if (!this.chatIdentity) {
        this.handleTokenError(tv.errors.authToken.identityNotFound);
        return;
      }
      try {
        const r = await fetch(
          "undefined/v1/live-chats/refreshToken",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ identity: this.chatIdentity })
          }
        );
        if (!r.ok)
          throw new Error("Failed to refresh token");
        const { data: n } = await r.json();
        await ((e = this.client) == null ? void 0 : e.updateToken(n.token));
      } catch {
        this.handleTokenError(tv.errors.authToken.refreshFailed);
      }
    });
    Za(this, "endLiveChat", async ({
      requestTransformer: e
    }) => {
      if (this.conversation)
        try {
          const r = {
            url: `undefined/v1/live-chats/${this.conversation.sid}`,
            method: "PATCH",
            headers: {
              "Content-Type": "application/json"
            },
            body: {
              action: "end",
              chat_ended_by: "client"
            }
          }, { url: n, method: a, headers: i, body: o, credentials: s } = e(
            r,
            yz.helpCenter
          );
          if (!(await fetch(n, {
            method: a,
            headers: i,
            body: JSON.stringify(o),
            credentials: s
          })).ok)
            throw new Error("Failed to end live chat");
        } catch (r) {
          throw console.error("Failed to end live chat:", r), r;
        }
    });
    Za(this, "composeConversationMetadata", async (e, r) => {
      try {
        const n = await e.getParticipants(), a = n.find(
          (s) => s.identity === r
        ), i = {
          agent: null,
          attributes: e.attributes,
          customer: { sid: (a == null ? void 0 : a.sid) || "", identity: r },
          dateCreated: e.dateCreated
        }, o = n.find(
          (s) => s.identity !== r
        );
        return o && (i.agent = this.getAgentDetails(o)), i;
      } catch (n) {
        throw console.error("composeConversationMetadata", n), n;
      }
    });
    Za(this, "fetchAllMessages", async (e) => {
      let r = [], n = await e.getMessages();
      for (; n; )
        r = [...n.items, ...r], n.hasPrevPage ? n = await n.prevPage() : n = null;
      return r;
    });
    Za(this, "setError", (e) => {
      var r;
      e && (console.error(e), (r = this.listeners[bs.Error]) == null || r.forEach(
        (n) => n(e)
      ));
    });
    Za(this, "initService", ({
      token: e,
      liveChatId: r,
      identity: n
    }) => {
      if (!e || e.length < 32)
        return this.setError(tv.errors.authToken.invalidToken), !1;
      if (!r || r.length < 32)
        return this.setError(tv.errors.invalidConversationSid), !1;
      this.chatIdentity = n;
      const a = new Cqr.Client(e);
      return a.on("initialized", async () => {
        var i;
        try {
          this.conversation = await a.getConversationBySid(r), await this.initConversation(this.conversation), a.on("tokenAboutToExpire", this.refreshAuthToken), a.on("tokenExpired", this.refreshAuthToken), this.isServiceReady = !0;
          const s = {
            ...await this.composeConversationMetadata(
              this.conversation,
              n
            ),
            isServiceReady: this.isServiceReady
          };
          (i = this.listeners[bs.Ready]) == null || i.forEach(
            (l) => l(s)
          );
        } catch (o) {
          console.error("initService", o.message), this.setError(tv.errors.conversationNotFound);
        }
      }), a.on("initFailed", (i) => {
        console.error("Fail on client SDK", i), this.setError(tv.errors.authToken.invalidToken);
      }), a.on("connectionStateChanged", (i) => {
        console.log("Connection state changed:", i);
      }), this.client = a, !0;
    });
    // Public way to send messages to conversations SDK
    Za(this, "sendMessage", async ({ body: e, files: r }) => {
      if (!this.conversation)
        return this.setError(tv.errors.conversationNotFound);
      const n = this.conversation.prepareMessage();
      return e && n.setBody(e), r == null || r.forEach((a) => {
        n.addMedia({
          media: a,
          contentType: a.type,
          filename: a.name
        });
      }), n.build().send();
    });
    Za(this, "startTyping", () => {
      var e;
      (e = this.conversation) == null || e.typing();
    });
    Za(this, "addEventListener", (e, r) => {
      this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(r);
    });
    Za(this, "removeEventListener", (e, r) => {
      const n = this.listeners[e];
      if (n) {
        const a = n.indexOf(r) || -1;
        a > -1 && n.splice(a, 1);
      }
    });
  }
}
const Vo = new wqr(), Sqr = ({ liveChatId: t, token: e, identity: r }) => {
  const [n, a] = Yt([]), [i, o] = Yt(null), [s, l] = Yt(null), [c, u] = Yt(null), [f, h] = Yt(null), [p, g] = Yt(!1), [y, b] = Yt(!1), [w, _] = Yt([]), [C, x] = Yt(""), [S, A] = Yt(!1), I = (v) => {
    const k = ob({
      attributes: v,
      key: "chatPhase",
      fallbackValue: hm.Waiting
    });
    A(k === hm.Active);
  }, M = (v) => {
    l((k) => {
      var G;
      const O = (G = v.conversation) == null ? void 0 : G.attributes;
      return O ? { ...k, ...O } : k;
    });
  }, B = (v) => {
    v.updateReasons.includes("attributes") && M(v);
  }, L = (v) => {
    b(v.isServiceReady), o(v.agent), u(v.customer), h(v.dateCreated), l(v.attributes), I(v == null ? void 0 : v.attributes);
  }, N = (v) => {
    a((k) => [...k, v]), v.action === CF.Join ? o(v.agent) : o(null);
  }, d = () => {
    x("");
  };
  Ut(() => {
    if (!Vo.isServiceReady)
      return Vo.addEventListener(
        bs.Error,
        x
      ), Vo.addEventListener(
        bs.Typing,
        g
      ), Vo.addEventListener(
        bs.NewMessage,
        (v) => _((k) => [...k, v])
      ), Vo.addEventListener(
        bs.AllMessages,
        _
      ), Vo.addEventListener(
        bs.Ready,
        L
      ), Vo.addEventListener(
        bs.Agent,
        N
      ), Vo.addEventListener(
        bs.Updated,
        B
      ), Vo.initService({
        token: e,
        liveChatId: t,
        identity: r
      }), () => {
        m();
      };
  }, []);
  const m = () => {
    Vo.removeEventListener(
      bs.Error,
      x
    ), Vo.removeEventListener(
      bs.Typing,
      g
    ), Vo.removeEventListener(
      bs.AllMessages,
      _
    ), Vo.removeEventListener(
      bs.NewMessage,
      (v) => _((k) => [...k, v])
    ), Vo.removeEventListener(
      bs.Ready,
      L
    ), Vo.removeEventListener(
      bs.Updated,
      B
    ), Vo.removeEventListener(
      bs.Agent,
      N
    ), Vo.isServiceReady = !1;
  };
  return {
    agentEvents: n,
    agent: i,
    customer: c,
    dateCreated: f,
    clearError: d,
    liveChatAttributes: s,
    messages: w,
    isAgentTyping: p,
    isChatActive: S,
    isLiveChatReady: y,
    sdkError: C
  };
}, _qr = "_imageContainer_bh8rp_1", kqr = "_image_bh8rp_1", xDe = {
  imageContainer: _qr,
  image: kqr
}, Aqr = ({ message: t, messageDirection: e }) => {
  const { files: r, images: n, isLoadingMedia: a } = qVr(t), i = e === "inbound" ? "colorText" : "colorTextInverse", o = (u) => {
    const f = a[u.sid];
    return /* @__PURE__ */ R.jsx(ar.Box, { className: xDe.imageContainer, children: f ? /* @__PURE__ */ R.jsx(
      wF.Spinner,
      {
        decorative: !1,
        color: i,
        size: "sizeIcon60",
        title: "Loading"
      }
    ) : /* @__PURE__ */ R.jsx(
      ar.Box,
      {
        as: "img",
        src: u.blobUrl || "",
        className: xDe.image,
        onClick: () => $Vr(u.blobUrl || "", u.filename || "")
      }
    ) }, u.sid);
  }, s = (u) => {
    const f = a[u.sid], h = Math.round(u.size / 1024 ** 2 * 100) / 100, p = f ? /* @__PURE__ */ R.jsx(wF.Spinner, { decorative: !1, title: "Loading" }) : /* @__PURE__ */ R.jsx(OVr.DownloadIcon, { decorative: !0 });
    if (u.blobUrl && u.filename)
      return /* @__PURE__ */ R.jsxs(Ks.ChatAttachment, { attachmentIcon: p, children: [
        /* @__PURE__ */ R.jsx(Ks.ChatAttachmentLink, { href: u.blobUrl, download: u.filename, children: u.filename }),
        /* @__PURE__ */ R.jsx(Ks.ChatAttachmentDescription, { children: `${h} MB` })
      ] }, u.filename);
  }, l = () => /* @__PURE__ */ R.jsx(R1.Stack, { orientation: "vertical", spacing: "space30", children: n.map(o) }), c = () => /* @__PURE__ */ R.jsx(R1.Stack, { orientation: "vertical", spacing: "space30", children: r.map(s) });
  return /* @__PURE__ */ R.jsxs(ar.Box, { marginY: "space30", children: [
    l(),
    c()
  ] });
}, Tqr = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", CDe = [], wDe = { allowDangerousHtml: !0 }, Eqr = /^(https?|ircs?|mailto|xmpp)$/i, Iqr = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Mqr(t) {
  const e = t.allowedElements, r = t.allowElement, n = t.children || "", a = t.className, i = t.components, o = t.disallowedElements, s = t.rehypePlugins || CDe, l = t.remarkPlugins || CDe, c = t.remarkRehypeOptions ? { ...t.remarkRehypeOptions, ...wDe } : wDe, u = t.skipHtml, f = t.unwrapDisallowed, h = t.urlTransform || Pqr, p = yZe().use(cZe).use(l).use(vZe, c).use(s), g = new ehe();
  typeof n == "string" && (g.value = n);
  for (const _ of Iqr)
    Object.hasOwn(t, _.from) && ("" + _.from + (_.to ? "use `" + _.to + "` instead" : "remove it") + Tqr + _.id, void 0);
  const y = p.parse(g);
  let b = p.runSync(y, g);
  return a && (b = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      b.type === "root" ? b.children : [b]
    )
  }), Q2e(b, w), VKe(b, {
    Fragment: R.Fragment,
    components: i,
    ignoreInvalidStyle: !0,
    jsx: R.jsx,
    jsxs: R.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(_, C, x) {
    if (_.type === "raw" && x && typeof C == "number")
      return u ? x.children.splice(C, 1) : x.children[C] = { type: "text", value: _.value }, C;
    if (_.type === "element") {
      let S;
      for (S in d7)
        if (Object.hasOwn(d7, S) && Object.hasOwn(_.properties, S)) {
          const A = _.properties[S], I = d7[S];
          (I === null || I.includes(_.tagName)) && (_.properties[S] = h(String(A || ""), S, _));
        }
    }
    if (_.type === "element") {
      let S = e ? !e.includes(_.tagName) : o ? o.includes(_.tagName) : !1;
      if (!S && r && typeof C == "number" && (S = !r(_, C, x)), S && x && typeof C == "number")
        return f && _.children ? x.children.splice(C, 1, ..._.children) : x.children.splice(C, 1), C;
    }
  }
}
function Pqr(t) {
  const e = t.indexOf(":"), r = t.indexOf("?"), n = t.indexOf("#"), a = t.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    e < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && e > a || r > -1 && e > r || n > -1 && e > n || // It is a protocol, it should be allowed.
    Eqr.test(t.slice(0, e)) ? t : ""
  );
}
var uie = {}, SDe;
function Rqr() {
  return SDe || (SDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = QXe;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(uie)), uie;
}
var i2t = /* @__PURE__ */ Rqr(), die = {}, o2t = P.forwardRef(({ children: t, element: e = "INLINE_CODE", variant: r = "default", ...n }, a) => P.createElement(ht, { as: "code", element: e, variant: r, ...Xt(n), borderWidth: "borderWidth10", borderStyle: "solid", borderRadius: "borderRadius20", fontFamily: "fontFamilyCode", fontSize: "inherit", lineHeight: "inherit", paddingX: "space20", color: "inherit", backgroundColor: "colorBackgroundWeak", borderColor: "colorBorderWeak", ref: a }, t));
o2t.displayName = "InlineCode";
const Oqr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InlineCode: o2t
}, Symbol.toStringTag, { value: "Module" })), Bqr = /* @__PURE__ */ aa(Oqr);
var _De;
function Nqr() {
  return _De || (_De = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Bqr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(die)), die;
}
var $qr = /* @__PURE__ */ Nqr(), fie = {};
const Dqr = /* @__PURE__ */ aa(Rtr);
var kDe;
function Lqr() {
  return kDe || (kDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Dqr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(fie)), fie;
}
var s2t = /* @__PURE__ */ Lqr();
const jqr = ({ markdown: t }) => /* @__PURE__ */ R.jsx(
  Mqr,
  {
    components: {
      code({ children: e, className: r }) {
        const n = /language-(\w+)/.exec(r || ""), a = n ? n[1] : "", i = e == null ? void 0 : e.toString();
        return i ? i.includes(`
`) ? /* @__PURE__ */ R.jsx(
          i2t.CodeBlock,
          {
            language: a,
            code: i,
            maxLines: 10
          }
        ) : /* @__PURE__ */ R.jsx($qr.InlineCode, { children: i }) : null;
      },
      a({ children: e, href: r }) {
        return r ? /* @__PURE__ */ R.jsx(s2t.Anchor, { href: r, showExternal: !0, children: (e == null ? void 0 : e.toString()) || "" }) : null;
      }
    },
    children: t
  }
), Fqr = ({
  message: t,
  messageDirection: e,
  participantFriendlyNames: r = {}
}) => {
  const { attachedMedia: n, author: a, body: i, dateCreated: o } = t, s = n && n.length > 0, c = r[a || ""] || "Agent", u = (o && new aI(o).format(z1t)) ?? "", f = () => e === "outbound" ? /* @__PURE__ */ R.jsx(Ks.ChatMessageMetaItem, { children: u }) : /* @__PURE__ */ R.jsxs(Ks.ChatMessageMetaItem, { children: [
    /* @__PURE__ */ R.jsx(Z1t.Avatar, { name: c, size: "sizeIcon20" }),
    `${c} ・ ${u}`
  ] });
  return /* @__PURE__ */ R.jsxs(Ks.ChatMessage, { variant: e, children: [
    /* @__PURE__ */ R.jsxs(Ks.ChatBubble, { children: [
      i && /* @__PURE__ */ R.jsx(jqr, { markdown: i }),
      s && /* @__PURE__ */ R.jsx(Aqr, { message: t, messageDirection: e })
    ] }),
    /* @__PURE__ */ R.jsx(
      Ks.ChatMessageMeta,
      {
        "aria-label": iI.message.ariaLabel(
          e === "outbound" && t.author ? t.author : c,
          u
        ),
        children: f()
      }
    )
  ] });
}, zqr = ({
  agent: t,
  isTyping: e,
  participantFriendlyNames: r
}) => {
  const n = t.identity || "", a = r[n] || "Agent";
  return e ? /* @__PURE__ */ R.jsx(ar.Box, { padding: "space80", children: /* @__PURE__ */ R.jsx(pf.Text, { as: "p", color: "colorTextWeak", children: iI.isTyping(a) }) }) : /* @__PURE__ */ R.jsx(R.Fragment, {});
};
var hie = {}, Gqr = Object.create, l2t = Object.defineProperty, Wqr = Object.getOwnPropertyDescriptor, c2t = Object.getOwnPropertyNames, Hqr = Object.getPrototypeOf, Uqr = Object.prototype.hasOwnProperty, Vqr = (t, e) => function() {
  return e || (0, t[c2t(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, qqr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of c2t(e)) !Uqr.call(t, a) && a !== r && l2t(t, a, { get: () => e[a], enumerable: !(n = Wqr(e, a)) || n.enumerable });
  return t;
}, Kqr = (t, e, r) => (r = t != null ? Gqr(Hqr(t)) : {}, qqr(!t || !t.__esModule ? l2t(r, "default", { value: t, enumerable: !0 }) : r, t)), Zqr = Vqr({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), Jqr = Kqr(Zqr()), Yqr = /(?:(?:https?:\/\/(?:www\.)?)|(?:www\.))[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/, Xqr = /(?:(?:[^\s"(),.:;<>@[\\\]]+(?:\.[^\s"(),.:;<>@[\\\]]+)*)|(?:".+"))@(?:(?:\[(?:\d{1,3}\.){3}\d{1,3}])|(?:(?:[\dA-Za-z\-]+\.)+[A-Za-z]{2,}))/, Qqr = [(t) => {
  let e = Yqr.exec(t);
  return e && { index: e.index, length: e[0].length, text: e[0], url: e[0] };
}, (t) => {
  let e = Xqr.exec(t);
  return e && { index: e.index, length: e[0].length, text: e[0], url: `mailto:${e[0]}` };
}], u2t = () => P.createElement(G5t, { matchers: Qqr });
u2t.displayName = "AutoLinkPlugin";
var pP = P.createContext({ isDisabled: !1 }), d2t = ({ placeholder: t, element: e }) => {
  let { isDisabled: r } = P.useContext(pP);
  return P.createElement(ht, { position: "absolute", top: "space30", left: "space40", right: "space40", display: "flex", alignItems: "center", color: r ? "colorTextWeaker" : "colorTextWeak", pointerEvents: "none", userSelect: "none", fontStyle: "italic", element: e }, t);
};
d2t.displayName = "PlaceholderWrapper";
var f2t = ({ disabled: t }) => {
  let [e] = W5t(), { setIsDisabled: r } = P.useContext(pP);
  return P.useEffect(() => {
    t !== void 0 && (r !== void 0 && r(t), e.setEditable(!t));
  }, [t]), null;
};
f2t.displayName = "ToggleEditablePlugin";
var eKr = (t) => {
  let e = j5t();
  if (e.getFirstChild() === null) {
    let r = F5t();
    r.append(z5t(t)), e.append(r);
  }
}, tKr = { theme: { paragraph: "paste-chat-composer-paragraph" }, nodes: [R5t] }, rKr = M2e`
.paste-chat-composer-paragraph {
  margin: 0;
  position: relative;
}

.paste-chat-composer-content-editable:focus {
  outline: none;
}
`, h2t = P.forwardRef(({ children: t, element: e = "CHAT_COMPOSER", onChange: r, placeholder: n = "", initialValue: a, config: i, maxHeight: o = "size30", disabled: s, fontSize: l, lineHeight: c, editorInstanceRef: u, ...f }, h) => {
  let { setIsDisabled: p } = P.useContext(pP), g = { ...tKr, editable: !s, editorState: a ? () => eKr(a) : void 0 }, y = P.useCallback(() => p !== void 0 ? {} : { color: "colorTextWeaker", backgroundColor: "colorBackground" }, [!!p]);
  return P.createElement(ht, { flexGrow: 1, ref: h, element: e, position: "relative", transition: "background-color 100ms ease-in,box-shadow 100ms ease-in,color 100ms ease-in", paddingY: "space30", paddingX: "space40", borderRadius: "borderRadius20", _focusWithin: { boxShadow: "shadowFocus" }, overflowY: "auto", maxHeight: o, disabled: s, "aria-disabled": s, _disabled: y(), fontSize: l, lineHeight: c, gridArea: "1/1" }, P.createElement(fb, { styles: rKr }), P.createElement(P5t, { initialConfig: (0, Jqr.default)(g, i) }, P.createElement(P.Fragment, null, P.createElement(O5t, { contentEditable: P.createElement(N5t, { ...f, className: "paste-chat-composer-content-editable" }), placeholder: P.createElement(d2t, { element: `${e}_PLACEHOLDER_WRAPPER`, placeholder: n }), ErrorBoundary: B5t }), r && P.createElement($5t, { onChange: r }), P.createElement(D5t, null), P.createElement(u2t, null), P.createElement(f2t, { disabled: s }), u && P.createElement(L5t, { editorRef: u }), t)));
});
h2t.displayName = "ChatComposer";
var p2t = P.forwardRef(({ element: t = "CHAT_COMPOSER_ACTION_GROUP", children: e, ...r }, n) => P.createElement(ht, { ...Xt(r), element: t, ref: n, gridArea: "1/2", display: "inline-flex", alignSelf: "end", role: "group", columnGap: "space30", marginBottom: "space30", marginLeft: "space30", marginRight: "space20" }, e));
p2t.displayName = "ChatComposerActionGroup";
var m2t = P.forwardRef(({ element: t = "CHAT_COMPOSER_ATTACHMENT_GROUP", columns: e = 2, children: r, ...n }, a) => {
  let i = () => Array.isArray(e) ? e.map((o) => `repeat(${o}, minmax(0,1fr))`) : `repeat(${e}, 1fr)`;
  return P.createElement(ht, { ...Xt(n), element: t, ref: a, gridArea: "2/1/3/3", role: "group", display: "grid", gridTemplateColumns: i(), flexWrap: "wrap", columnGap: "space40", paddingBottom: "space30", paddingX: "space10", rowGap: "space40" }, r);
});
m2t.displayName = "ChatComposerAttachmentGroup";
var nKr = { default: { backgroundColor: "colorBackgroundWeaker" }, contained: { borderRadius: "borderRadius30", boxShadow: "shadowElevation10", backgroundColor: "colorBackgroundWeaker" } }, g2t = P.forwardRef(({ variant: t = "default", element: e = "CHAT_COMPOSER_CONTAINER", maxHeight: r = "size40", children: n, ...a }, i) => {
  let [o, s] = P.useState(!1);
  return P.createElement(pP.Provider, { value: { isDisabled: o, setIsDisabled: s } }, P.createElement(ht, { ...Xt(a), element: e, ref: i, display: "grid", gridTemplateRows: "auto-fit", gridAutoColumns: "1fr auto", disabled: o, "aria-disabled": o, _disabled: { color: "colorTextWeaker", backgroundColor: "colorBackground" }, padding: "space30", maxHeight: r, overflowY: "auto", rowGap: "space50", width: "100%", ...nKr[t] }, n));
});
g2t.displayName = "ChatComposerContainer";
var aKr = function() {
  var t = 1, e = /* @__PURE__ */ new WeakMap(), r = function(n, a) {
    return typeof n == "number" || typeof n == "string" ? a ? "idx-".concat(a) : "val-".concat(n) : e.has(n) ? "uid" + e.get(n) : (e.set(n, t++), r(n));
  };
  return r;
}, v2t = function(t) {
  return t === void 0 && (t = ""), { value: 1, prefix: t, uid: aKr() };
}, iKr = v2t(), oKr = P.createContext(v2t()), sKr = function(t) {
  return t.value++;
}, lKr = function(t) {
  return t ? t.prefix : "";
}, cKr = function(t) {
  var e = t || iKr, r = lKr(e), n = sKr(e), a = r + n, i = function(o) {
    return a + e.uid(o);
  };
  return { uid: a, gen: i };
}, y2t = function() {
  var t = Qn(oKr), e = Yt(function() {
    return cKr(t);
  })[0];
  return e;
}, uKr = function() {
  var t = y2t().uid;
  return t;
}, dKr = function() {
  var t = y2t().gen;
  return t;
}, fKr = "useId", SF = Te[fKr], TH = SF !== void 0 ? SF : uKr, hKr = SF !== void 0 ? () => {
  let t = SF();
  return (e) => `${t}-${e}`;
} : dKr, pKr = Object.defineProperty, mKr = Object.defineProperties, gKr = Object.getOwnPropertyDescriptors, _F = Object.getOwnPropertySymbols, b2t = Object.prototype.hasOwnProperty, x2t = Object.prototype.propertyIsEnumerable, ADe = (t, e, r) => e in t ? pKr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, vKr = (t, e) => {
  for (var r in e || (e = {})) b2t.call(e, r) && ADe(t, r, e[r]);
  if (_F) for (var r of _F(e)) x2t.call(e, r) && ADe(t, r, e[r]);
  return t;
}, yKr = (t, e) => mKr(t, gKr(e)), bKr = (t, e) => {
  var r = {};
  for (var n in t) b2t.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
  if (t != null && _F) for (var n of _F(t)) e.indexOf(n) < 0 && x2t.call(t, n) && (r[n] = t[n]);
  return r;
}, mP = P.forwardRef((t, e) => {
  var r = t, { as: n = "span", color: a = "currentColor", display: i = "block", element: o = "ICON", size: s = "sizeIcon30" } = r, l = bKr(r, ["as", "color", "display", "element", "size"]);
  return P.createElement(ht, yKr(vKr({}, Xt(l)), { as: n, element: o, lineHeight: "lineHeight0", display: i, color: a, size: s, ref: e, flexShrink: 0 }));
});
mP.displayName = "IconWrapper";
var w3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  let l = `LinkExternalIcon-${TH()}`;
  if (!o && i == null) throw new Error("[LinkExternalIcon]: Missing a title for non-decorative icon.");
  return P.createElement(mP, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.4 4.5a.5.5 0 01.5.5v.1a.5.5 0 01-.5.5H5.6v8.8h8.8v-2.8a.5.5 0 01.41-.492l.09-.008h.1a.5.5 0 01.492.41l.008.09V15a.5.5 0 01-.41.492L15 15.5H5a.5.5 0 01-.492-.41L4.5 15V5a.5.5 0 01.41-.492L5 4.5h3.4zm6.6 0a.5.5 0 01.5.5v.1l-.001.01.001 3.29a.5.5 0 01-.5.5h-.1a.5.5 0 01-.5-.5l-.001-1.935-3.967 3.967a.611.611 0 01-.78.07l-.084-.07a.611.611 0 01-.07-.78l.07-.084L13.534 5.6H11.6a.5.5 0 01-.5-.5V5a.5.5 0 01.5-.5H15z" })));
});
w3e.displayName = "LinkExternalIcon";
var C2t = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "a", color: "colorTextLink", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", outline: "none", ref: e, textDecoration: "underline", _active: { color: "colorTextLinkStrongest", textDecoration: "none" }, _focus: { boxShadow: "shadowFocus", color: "colorTextLink", textDecoration: "underline", borderRadius: "borderRadius20" }, _hover: { color: "colorTextLinkStronger", textDecoration: "none" } }, t.children));
C2t.displayName = "DefaultAnchor";
var w2t = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "a", color: "colorTextInverse", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit", outline: "none", ref: e, textDecoration: "underline", _active: { color: "colorTextInverse", textDecoration: "none" }, _focus: { boxShadow: "shadowFocusInverse", color: "colorTextInverse", textDecoration: "underline", borderRadius: "borderRadius20" }, _hover: { color: "colorTextInverse", textDecoration: "none" } }, t.children));
w2t.displayName = "InverseAnchor";
var xKr = { inverse: w2t, default: C2t }, CKr = /^(https?:)\S*$/, wKr = "_blank", SKr = "noreferrer noopener", _Kr = (t) => CKr.test(t), S2t = (t) => {
  if (_Kr(t)) return { rel: SKr, target: wKr };
}, _2t = P.forwardRef(({ element: t = "ANCHOR", variant: e = "default", showExternal: r, display: n, height: a, minHeight: i, maxHeight: o, width: s, minWidth: l, maxWidth: c, size: u, margin: f, marginBottom: h, marginLeft: p, marginRight: g, marginTop: y, marginX: b = null, marginY: w = null, padding: _, paddingBottom: C, paddingLeft: x, paddingRight: S, paddingTop: A, paddingX: I = null, paddingY: M = null, verticalAlign: B, i18nExternalLinkLabel: L = "(link takes you to an external page)", ...N }, d) => {
  let m = xKr[e];
  return P.createElement(m, { href: N.href, ref: d, variant: e, ...S2t(N.href), ...Xt(N), element: t, display: n, height: a, minHeight: i, maxHeight: o, width: s, minWidth: l, maxWidth: c, size: u, margin: f, marginBottom: h, marginLeft: p, marginRight: g, marginTop: y, marginX: b, marginY: w, padding: _, paddingBottom: C, paddingLeft: x, paddingRight: S, paddingTop: A, paddingX: I, paddingY: M, verticalAlign: B }, r ? P.createElement(ht, { as: "span" }, N.children, P.createElement(ht, { as: "span", display: "inline-block", flexShrink: 0, verticalAlign: "middle" }, P.createElement(w3e, { decorative: !1, title: L }))) : N.children);
});
_2t.displayName = "Anchor";
var k2t = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  let l = `ArrowForwardIcon-${TH()}`;
  if (!o && i == null) throw new Error("[ArrowForwardIcon]: Missing a title for non-decorative icon.");
  return P.createElement(mP, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14.991 9.91l.007.05v.08l-.01.07-.01.029a.489.489 0 01-.205.272l-3.832 3.444a.596.596 0 01-.78 0 .459.459 0 01-.063-.632l.063-.069 2.957-2.659H5.513A.504.504 0 015 10a.5.5 0 01.42-.488l.093-.008h7.604l-2.956-2.658a.459.459 0 01-.063-.632l.063-.069a.598.598 0 01.704-.057l.076.057 3.832 3.444c.098.064.172.16.206.272l.012.049z" })));
});
k2t.displayName = "ArrowForwardIcon";
var TDe = { cx: 50, cy: 50, r: 45 }, E$ = Math.PI * 2 * 45, kKr = Ey`
  0%,
  15% {
    stroke-dashoffset: ${E$ * 0.9999};
    transform: rotate(0);
  }

  50%,
  75% {
    stroke-dashoffset: ${E$ * 0.2};
    transform: rotate(45deg);
  }

  100% {
    stroke-dashoffset: ${E$ * 0.9999};
    transform: rotate(360deg);
  }
`, AKr = Ey`
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
`, TKr = Ey`
  0%,
  75% {
    stroke-dashoffset: 90%;
  }

  100% {
    stroke-dashoffset: 90%;
    transform: rotate(360deg);
  }
`, EKr = ds.circle({ transformOrigin: "center", opacity: 0.25 }), IKr = ds.circle(({ show: t, isSafari: e }) => ({ transformOrigin: "center", animation: e ? "none" : `1.5s ease-in-out infinite both ${AKr}`, strokeDasharray: E$, opacity: t ? 1 : 0 })), MKr = ds.svg(({ isSafari: t }) => ({ height: "100%", width: "100%", display: "block", animation: t ? `1s infinite linear ${TKr}` : `4.25s linear infinite both ${kKr}` })), A2t = P.forwardRef(({ size: t, color: e = "currentColor", title: r, as: n, display: a, decorative: i, delay: o = 250, element: s = "SPINNER" }, l) => {
  let c = `spinner-${TH()}`, { borderWidths: { borderWidth40: u } } = Md(), [f, h] = P.useState(o === 0);
  if (!i && r == null) throw new Error("[Spinner]: Missing a title for non-decorative icon.");
  P.useEffect(() => {
    if (o === 0) return;
    let y = setTimeout(() => h(!0), o);
    return () => clearTimeout(y);
  }, [o]);
  let [p, g] = P.useState(null);
  return P.useEffect(() => {
    g(navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome"));
  }, []), p == null ? null : P.createElement(mP, { as: n, element: s, display: a, size: t, color: e, "aria-hidden": i, ref: l }, P.createElement(MKr, { viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": c, isSafari: p }, r ? P.createElement("title", { id: c }, r) : null, P.createElement("g", { strokeWidth: u, stroke: "currentColor", strokeLinecap: "round", fill: "transparent" }, P.createElement(EKr, { ...TDe }), P.createElement(IKr, { show: f, ...TDe, isSafari: p }))));
});
A2t.displayName = "Spinner";
var PKr = Object.create, T2t = Object.defineProperty, RKr = Object.getOwnPropertyDescriptor, E2t = Object.getOwnPropertyNames, OKr = Object.getPrototypeOf, BKr = Object.prototype.hasOwnProperty, NKr = (t, e) => function() {
  return e || (0, t[E2t(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, $Kr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of E2t(e)) !BKr.call(t, a) && a !== r && T2t(t, a, { get: () => e[a], enumerable: !(n = RKr(e, a)) || n.enumerable });
  return t;
}, k0 = (t, e, r) => (r = t != null ? PKr(OKr(t)) : {}, $Kr(!t || !t.__esModule ? T2t(r, "default", { value: t, enumerable: !0 }) : r, t)), A0 = NKr({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), S3e = k0(A0()), pie = k0(A0()), mie = { appearance: "none", background: "none", display: "inline-block", border: "none", outline: "none", transition: "background-color 100ms ease-in, box-shadow 100ms ease-in, color 100ms ease-in", fontFamily: "inherit", fontWeight: "fontWeightSemibold", textDecoration: "none", position: "relative", margin: "space0", borderRadius: "borderRadius20", _hover: { textDecoration: "none" }, _focus: { textDecoration: "none", boxShadow: "shadowFocus" }, _active: { textDecoration: "none" } }, Ui = { default: (0, pie.default)(mie, { cursor: "pointer", _active: { boxShadow: "none" } }), disabled: (0, pie.default)(mie, { cursor: "not-allowed" }), loading: (0, pie.default)(mie, { cursor: "wait" }) }, Tf = { default: { paddingTop: "space30", paddingBottom: "space30", paddingLeft: "space40", paddingRight: "space40", borderRadius: "borderRadius20", fontSize: "fontSize30", lineHeight: "lineHeight20" }, small: { paddingTop: "space20", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", borderRadius: "borderRadius10", fontSize: "fontSize30", lineHeight: "lineHeight20" }, icon: { padding: "space30", borderRadius: "borderRadius20" }, icon_small: { padding: "space20", borderRadius: "borderRadius20" }, reset: { paddingTop: "space0", paddingRight: "space0", paddingBottom: "space0", paddingLeft: "space0", borderWidth: "borderWidth0", fontSize: "inherit" }, rounded_small: { borderRadius: "borderRadiusPill", paddingTop: "space20", paddingBottom: "space20", paddingLeft: "space30", paddingRight: "space30", fontSize: "fontSize30", lineHeight: "lineHeight20" }, circle: { padding: "space30", borderRadius: "borderRadiusCircle" }, circle_small: { padding: "space20", borderRadius: "borderRadiusCircle" } }, DKr = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorText", backgroundColor: "colorBackgroundBody", _disabled: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker", color: "colorTextWeaker" }, _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _pressed: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _pressed_hover: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStronger", color: "colorTextPrimaryStronger" }, _pressed_active: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _pressed_focus: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextPrimary" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, LKr = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorTextError", backgroundColor: "colorBackgroundBody", _disabled: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker", color: "colorTextWeaker" }, _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderError", color: "colorTextError" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderErrorStrongest", color: "colorTextErrorStrongest" }, _pressed: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderError", color: "colorTextError" }, _pressed_hover: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderErrorStronger", color: "colorTextErrorStronger" }, _pressed_active: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowBorderError", color: "colorTextError" }, _pressed_focus: { backgroundColor: "colorBackgroundErrorWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextError" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, jKr = { transition: "background-color 150ms ease-in, box-shadow 150ms ease-in, color 150ms ease-in", color: "colorTextIcon", backgroundColor: "colorBackgroundBody", _hover: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimary", color: "colorTextPrimaryStronger" }, _active: { backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderPrimaryStrongest", color: "colorTextPrimaryStrongest" }, _disabled: { backgroundColor: "colorBackgroundBody", color: "colorTextWeaker" }, _pressed: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimary", color: "colorTextPrimary" }, _pressed_hover: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStronger", color: "colorTextPrimaryStronger" }, _pressed_focus: { backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowFocusShadowBorder", color: "colorTextPrimary" }, _pressed_disabled: { backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker", color: "colorTextWeakest" } }, FKr = (0, S3e.default)(Ui.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundDestructive", boxShadow: "shadowBorderDestructive", _hover: { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderDestructive" }, _focus: { boxShadow: "shadowFocus" }, _active: { color: "colorTextDestructive", backgroundColor: "colorBackgroundDestructiveWeakest", boxShadow: "shadowBorderDestructive" } }), zKr = (0, S3e.default)(Ui.loading, { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }), GKr = (0, S3e.default)(Ui.disabled, { color: "colorTextWeakest", backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker" }), WKr = { default: FKr, loading: zKr, disabled: GKr }, I2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...WKr[e], ...Tf[t] }));
I2t.displayName = "DestructiveButton";
var _3e = k0(A0()), HKr = (0, _3e.default)(Ui.default, { color: "colorTextDestructive", _hover: { color: "colorTextDestructiveStrongest" }, _active: { color: "colorTextDestructiveStrongest" } }), UKr = (0, _3e.default)(Ui.loading, { color: "colorTextDestructive" }), VKr = (0, _3e.default)(Ui.disabled, { color: "colorTextWeaker" }), qKr = { default: HKr, loading: UKr, disabled: VKr }, M2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...qKr[e], ...Tf[t] }));
M2t.displayName = "DestructiveIconButton";
var k3e = k0(A0()), KKr = (0, k3e.default)(Ui.default, { color: "colorTextLinkDestructive", textAlign: "left", transition: "none", _hover: { color: "colorTextLinkDestructiveStrongest", textDecoration: "underline" }, _active: { color: "colorTextLinkDestructiveStrongest", textDecoration: "underline" } }), ZKr = (0, k3e.default)(Ui.loading, { color: "colorTextLinkDestructive", textAlign: "left", _hover: { color: "colorTextLinkDestructiveStronger" }, _active: { color: "colorTextLinkDestructiveStronger" }, _focus: { color: "colorTextLinkDestructiveStronger" } }), JKr = (0, k3e.default)(Ui.disabled, { color: "colorTextWeaker", textAlign: "left", _hover: { color: "colorTextLinkDestructiveWeak" }, _active: { color: "colorTextLinkDestructiveWeak" }, _focus: { color: "colorTextLinkDestructiveWeak" } }), YKr = { default: KKr, loading: ZKr, disabled: JKr }, P2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...YKr[e], ...Tf[t] }));
P2t.displayName = "DestructiveLinkButton";
var A3e = k0(A0()), XKr = (0, A3e.default)(Ui.default, { color: "colorTextDestructive", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderWeak", _hover: { color: "colorTextDestructive", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderDestructive" }, _focus: { boxShadow: "shadowFocusShadowBorder" }, _active: { color: "colorTextDestructive", backgroundColor: "colorBackgroundDestructiveWeakest", boxShadow: "shadowBorderDestructive" } }), uN = { color: "colorTextDestructive", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }, QKr = (0, A3e.default)(Ui.loading, { ...uN, _hover: uN, _active: uN, _focus: uN }), dN = { color: "colorTextWeaker", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker" }, eZr = (0, A3e.default)(Ui.disabled, { ...dN, _hover: dN, _active: dN, _focus: dN }), tZr = { default: XKr, loading: QKr, disabled: eZr }, R2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : LKr;
  return P.createElement(ht, { ref: o, width: r ? "100%" : "auto", "aria-pressed": n, ...Xt({ as: a, ...i }), ...tZr[e], ...s, ...Tf[t] });
});
R2t.displayName = "DestructiveSecondaryButton";
var T3e = k0(A0()), rZr = (0, T3e.default)(Ui.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundInverse", boxShadow: "shadowBorderInverseWeaker", _hover: { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseStronger" }, _focus: { boxShadow: "shadowFocusInverse" }, _active: { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseStrongest" } }), nZr = (0, T3e.default)(Ui.loading, { color: "colorTextInverse", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseWeaker" }), aZr = (0, T3e.default)(Ui.disabled, { color: "colorTextInverseWeakest", backgroundColor: "colorBackgroundInverseStrong", boxShadow: "shadowBorderInverseWeakest" }), iZr = { default: rZr, loading: nZr, disabled: aZr }, O2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...iZr[e], ...Tf[t] }));
O2t.displayName = "InverseButton";
var E3e = k0(A0()), oZr = (0, E3e.default)(Ui.default, { color: "colorTextInverse", textAlign: "left", transition: "none", _hover: { color: "colorTextInverseWeaker", textDecoration: "underline" }, _focus: { boxShadow: "shadowFocusInverse" }, _active: { color: "colorTextInverseWeaker", textDecoration: "underline" } }), sZr = (0, E3e.default)(Ui.loading, { color: "colorTextInverse", textAlign: "left" }), lZr = (0, E3e.default)(Ui.disabled, { color: "colorTextInverseWeakest", textAlign: "left" }), cZr = { default: oZr, loading: sZr, disabled: lZr }, B2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...cZr[e], ...Tf[t] }));
B2t.displayName = "InverseLinkButton";
var I3e = k0(A0()), uZr = (0, I3e.default)(Ui.default, { color: "colorTextPrimary", textAlign: "left", transition: "none", _hover: { color: "colorTextPrimaryStrongest", textDecoration: "underline" }, _active: { color: "colorTextPrimaryStrongest", textDecoration: "underline" } }), dZr = (0, I3e.default)(Ui.loading, { color: "colorTextPrimary", textAlign: "left" }), fZr = (0, I3e.default)(Ui.disabled, { color: "colorTextWeaker", textAlign: "left" }), hZr = { default: uZr, loading: dZr, disabled: fZr }, N2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "a", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...hZr[e], ...Tf[t] }));
N2t.displayName = "LinkButton";
var M3e = k0(A0()), pZr = (0, M3e.default)(Ui.default, { color: "colorTextInverse", backgroundColor: "colorBackgroundPrimary", boxShadow: "shadowBorderPrimary", _hover: { color: "colorTextPrimary", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderPrimary" }, _focus: { boxShadow: "shadowFocus" }, _active: { color: "colorTextPrimaryStrong", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrong" } }), mZr = (0, M3e.default)(Ui.loading, { color: "colorTextPrimary", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }), gZr = (0, M3e.default)(Ui.disabled, { color: "colorTextWeakest", backgroundColor: "colorBackgroundStrong", boxShadow: "shadowBorderWeaker" }), vZr = { default: pZr, loading: mZr, disabled: gZr }, $2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...vZr[e], ...Tf[t] }));
$2t.displayName = "PrimaryButton";
var P3e = k0(A0()), yZr = (0, P3e.default)(Ui.default, { color: "colorTextPrimary", _hover: { color: "colorTextPrimaryStrongest" }, _active: { color: "colorTextPrimaryStrongest" } }), bZr = (0, P3e.default)(Ui.loading, { color: "colorTextPrimary" }), xZr = (0, P3e.default)(Ui.disabled, { color: "colorTextWeaker" }), CZr = { default: yZr, loading: bZr, disabled: xZr }, D2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...Xt({ as: n, ...a }), ...CZr[e], ...Tf[t] }));
D2t.displayName = "PrimaryIconButton";
var R3e = k0(A0()), wZr = (0, R3e.default)(Ui.default, { fontWeight: "inherit", color: "inherit" }), SZr = (0, R3e.default)(Ui.loading, { fontSize: "inherit", fontWeight: "inherit" }), _Zr = (0, R3e.default)(Ui.disabled, { fontSize: "inherit", fontWeight: "inherit" }), kZr = { default: wZr, loading: SZr, disabled: _Zr }, L2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, as: n = "button", ...a }, i) => P.createElement(ht, { ref: i, width: r ? "100%" : "auto", ...kZr[e], ...Tf[t], as: n, ...a }));
L2t.displayName = "ResetButton";
var O3e = k0(A0()), AZr = (0, O3e.default)(Ui.default, { color: "colorText", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderWeak", _hover: { color: "colorTextPrimary", backgroundColor: "colorBackgroundWeakest", boxShadow: "shadowBorderPrimary" }, _focus: { boxShadow: "shadowFocusShadowBorder" }, _active: { color: "colorTextPrimaryStrong", backgroundColor: "colorBackgroundPrimaryWeakest", boxShadow: "shadowBorderPrimaryStrong" } }), fN = { color: "colorTextPrimary", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeak" }, TZr = (0, O3e.default)(Ui.loading, { ...fN, _hover: fN, _active: fN, _focus: fN }), hN = { color: "colorTextWeaker", backgroundColor: "colorBackgroundBody", boxShadow: "shadowBorderWeaker" }, EZr = (0, O3e.default)(Ui.disabled, { ...hN, _hover: hN, _active: hN, _focus: hN, _pressed: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak", boxShadow: "none" }, _pressed_hover: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak", boxShadow: "none" } }), IZr = { default: AZr, loading: TZr, disabled: EZr }, j2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : DKr;
  return P.createElement(ht, { ref: o, width: r ? "100%" : "auto", "aria-pressed": n, ...Xt({ as: a, ...i }), ...IZr[e], ...s, ...Tf[t] });
});
j2t.displayName = "SecondaryButton";
var B3e = k0(A0()), MZr = (0, B3e.default)(Ui.default, { color: "colorTextIcon", _hover: { color: "colorTextPrimaryStrongest" }, _active: { color: "colorTextPrimaryStrongest" } }), PZr = (0, B3e.default)(Ui.loading, { color: "colorTextPrimary" }), RZr = (0, B3e.default)(Ui.disabled, { color: "colorTextWeaker", _pressed: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak" }, _pressed_hover: { backgroundColor: "colorBackgroundStrong", color: "colorTextWeak" } }), OZr = { default: MZr, loading: PZr, disabled: RZr }, F2t = P.forwardRef(({ size: t, buttonState: e, fullWidth: r, pressed: n, as: a = "button", ...i }, o) => {
  let s = n === void 0 ? {} : jKr;
  return P.createElement(ht, { ref: o, "aria-pressed": n, width: r ? "100%" : "auto", ...Xt({ as: a, ...i }), ...s, ...OZr[e], ...Tf[t] });
});
F2t.displayName = "SecondaryIconButton";
var BZr = Zh(ht), NZr = (t, e, r) => {
  let n = "default";
  return r != null ? n = r : t === "link" || t === "destructive_link" || t === "reset" ? n = "reset" : P.Children.count(e) === 1 && P.Children.forEach(e, (a) => {
    P.isValidElement(a) && typeof a.type.displayName == "string" && a.type.displayName.includes("Icon") && (n = "icon");
  }), n;
}, $Zr = (t, e) => t ? "disabled" : e ? "loading" : "default", DZr = ({ as: t, href: e, tabIndex: r, variant: n, size: a, fullWidth: i, children: o, disabled: s, loading: l, pressed: c }) => {
  let u = e != null && e !== "", f = r != null;
  if (t !== "a" && u) throw new Error(`[Paste: Button] You cannot pass href into a button without the 'a' tag.  Use 'as="a"'.`);
  if (t === "a") {
    if (!u) throw new Error("[Paste: Button] Missing href prop for link button.");
    if (n === "link" || n === "inverse_link") throw new Error("[Paste: Button] Using Button component as an Anchor. Use the Paste Anchor component instead.");
    if (n !== "primary" && n !== "secondary" && n !== "reset" && n !== "inverse") throw new Error('[Paste: Button] <Button as="a"> only works with the following variants: primary and secondary.');
    if (s || l) throw new Error('[Paste: Button] <Button as="a"> cannot be disabled or loading.');
  }
  if (n === "reset" && a !== "reset") throw new Error('[Paste: Button] The "RESET" variant can only be used with the "RESET" size.');
  if ((a === "icon" || a === "icon_small" || a === "circle" || a === "circle_small") && i) throw new Error("[Paste: Button] Icon buttons should not be fullWidth.");
  if (o == null) throw new Error("[Paste: Button] Must have non-null children.");
  if (f && !(r === 0 || r === -1)) throw console.error("tabIndex", r), new Error("[Paste: Button] tabIndex must be 0 or -1.");
  if (c && !(n === "secondary" || n === "secondary_icon" || n === "destructive_secondary")) throw console.error("variant", n, "pressed", c), new Error('[Paste: Button] pressed can only be used with "secondary" and "secondary_icon" and "destructive_secondary" variants.');
}, LZr = /* @__PURE__ */ new Set(["link", "destructive_link", "inverse_link", "reset"]), z2t = ({ buttonState: t, children: e, showLoading: r, variant: n }) => {
  let a = n && LZr.has(n);
  return P.createElement(P.Fragment, null, P.createElement(ht, { as: "span", display: "flex", textDecoration: "inherit", opacity: t === "loading" ? "0" : "1", justifyContent: a ? null : "center", columnGap: "space20", alignItems: "center", width: "100%" }, e), r ? P.createElement(ht, { as: "span", position: "absolute", top: 0, right: 0, bottom: 0, left: 0, display: "flex", justifyContent: "center", alignItems: "center", lineHeight: "lineHeight30" }, P.createElement(A2t, { decorative: !0, delay: 0 })) : null);
};
z2t.displayName = "ButtonContents";
var jZr = (t) => {
  switch (t) {
    case "primary_icon":
      return D2t;
    case "secondary":
      return j2t;
    case "secondary_icon":
      return F2t;
    case "destructive":
      return I2t;
    case "destructive_icon":
      return M2t;
    case "destructive_secondary":
      return R2t;
    case "link":
      return N2t;
    case "destructive_link":
      return P2t;
    case "reset":
      return L2t;
    case "inverse":
      return O2t;
    case "inverse_link":
      return B2t;
    case "primary":
    default:
      return $2t;
  }
}, G2t = P.forwardRef(({ element: t = "BUTTON", i18nExternalLinkLabel: e = "(link takes you to an external page)", as: r = "button", fullWidth: n = !1, disabled: a = !1, loading: i = !1, variant: o = "primary", type: s = "button", ...l }, c) => {
  let { size: u, children: f, ...h } = l, [p, g] = P.useState(!1), y = aM({ translateX: p ? "4px" : "0px", config: { mass: 0.1, tension: 275, friction: 16 } }), b = P.useMemo(() => NZr(o, f, u), [u, o, f]);
  DZr({ ...l, as: r, children: f, fullWidth: n, disabled: a, loading: i, variant: o, size: b });
  let w = $Zr(a, i), _ = w === "loading", C = w !== "default", x = jZr(o), S = l.href != null ? S2t(l.href) : null, A = f;
  return r === "a" && l.href != null && typeof f == "string" && o !== "reset" && (A = P.createElement(P.Fragment, null, f, S != null ? P.createElement(w3e, { decorative: !1, title: e }) : P.createElement(BZr, { style: y }, P.createElement(k2t, { decorative: !0 })))), P.createElement(x, { ...S, ...h, onMouseEnter: (I) => {
    typeof h.onMouseEnter == "function" && h.onMouseEnter(I), g(!0);
  }, onMouseLeave: (I) => {
    typeof h.onMouseLeave == "function" && h.onMouseLeave(I), g(!1);
  }, buttonState: w, disabled: C, element: t, variant: o, size: b, "aria-busy": w === "loading" ? "true" : "false", as: r, type: s, fullWidth: n, ref: c }, P.createElement(z2t, { buttonState: w, showLoading: _, variant: o }, A));
});
G2t.displayName = "Button";
var W2t = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  let l = `ClearIcon-${TH()}`;
  if (!o && i == null) throw new Error("[ClearIcon]: Missing a title for non-decorative icon.");
  return P.createElement(mP, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M10 16.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm.897-6.5l1.917 1.917a.635.635 0 01-.897.897L10 10.897l-1.917 1.917a.635.635 0 01-.897-.897L9.103 10 7.186 8.083a.635.635 0 01.897-.897L10 9.103l1.917-1.917a.635.635 0 01.897.897L10.897 10z" })));
});
W2t.displayName = "ClearIcon";
var H2t = P.forwardRef(({ as: t = "span", children: e, element: r = "MEDIA_OBJECT", marginBottom: n, marginTop: a, verticalAlign: i = "top", ...o }, s) => P.createElement(ht, { ...Xt(o), alignItems: i === "top" ? "flex-start" : "center", as: t, display: "flex", element: r, marginBottom: n, marginTop: a, ref: s }, e));
H2t.displayName = "MediaObject";
var U2t = P.forwardRef(({ align: t = "start", as: e = "span", children: r, element: n = "MEDIA_FIGURE", spacing: a = "space0", ...i }, o) => P.createElement(ht, { ...Xt(i), as: e, display: "flex", element: n, flexShrink: 0, marginLeft: t === "end" ? a : void 0, marginRight: t === "start" ? a : void 0, ref: o }, r));
U2t.displayName = "MediaFigure";
var V2t = P.forwardRef(({ as: t = "span", children: e, element: r = "MEDIA_BODY", ...n }, a) => P.createElement(ht, { ...Xt(n), as: t, element: r, flex: 1, minWidth: "size0", ref: a }, e));
V2t.displayName = "MediaBody";
var q2t = P.forwardRef(({ as: t = "span", children: e, ...r }, n) => P.createElement(ht, { ...r, as: t, border: "none", clip: "rect(0 0 0 0)", height: "1px", margin: "spaceNegative10", overflow: "hidden", padding: "space0", position: "absolute", ref: n, textTransform: "none", whiteSpace: "nowrap", width: "1px" }, e));
q2t.displayName = "ScreenReaderOnly";
var FZr = (t) => Array.isArray(t) ? t.map((e) => e === "horizontal" ? "flex" : "block") : t === "horizontal" ? "flex" : "block", zZr = (t) => ({ display: FZr(t), alignItems: "center", flexWrap: "wrap" }), GZr = (t, e) => {
  let r = {};
  if (Array.isArray(t)) {
    let n = [], a = [];
    t.forEach((i, o) => {
      n[o] = i === "horizontal" ? e : "space0", a[o] = i === "horizontal" ? "space0" : e;
    }), r = { marginRight: n, marginBottom: a };
  }
  return t === "horizontal" && (r = { marginRight: e }), t === "vertical" && (r = { marginBottom: e }), r;
}, K2t = P.forwardRef(({ children: t, orientation: e, spacing: r, element: n = "STACK", ...a }, i) => {
  let [o, s] = P.useMemo(() => {
    let f = P.Children.toArray(t).filter((h) => P.isValidElement(h) || typeof h == "string");
    return [f.length, f];
  }, [t]), l = P.useMemo(() => zZr(e), [e]), c = P.useMemo(() => GZr(e, r), [e, r]), u = hKr();
  return P.createElement(ht, { element: n, ...Xt(a), ...l, ref: i }, s.map((f, h) => P.createElement(ht, { element: `${n}_CHILD`, ...o !== h + 1 ? c : null, key: u(`stack-${h}`) }, f)));
});
K2t.displayName = "Stack";
var WZr = { backgroundColor: "colorBackgroundBody", borderRadius: "borderRadiusCircle", width: "12px", height: "12px", display: "flex", justifyContent: "center", alignItems: "center" }, Z2t = P.forwardRef(({ children: t, onDismiss: e, i18nDismissLabel: r = "Remove attachment", element: n = "CHAT_COMPOSER_ATTACHMENT_CARD", attachmentIcon: a, ...i }, o) => {
  let { isDisabled: s } = P.useContext(pP);
  return P.createElement(ht, { ...Xt(i), ref: o, paddingY: "space30", paddingX: "space40", borderRadius: "borderRadius30", backgroundColor: "colorBackgroundBodyElevation", position: "relative", display: "inline-block", width: "100%", element: n }, P.createElement(H2t, { as: "div", ref: o, verticalAlign: "center", element: `${n}_MEDIA_OBJECT` }, P.createElement(U2t, { as: "div", spacing: "space30" }, P.createElement(ht, { color: "colorTextIcon", element: `${n}_ICON` }, a)), P.createElement(V2t, { as: "div", element: `${n}_BODY` }, P.createElement(K2t, { orientation: "vertical", spacing: "space10" }, t))), e && P.createElement(ht, { position: "absolute", top: "space0", right: "space0", transform: "translate(50%, -50%)", ...WZr }, P.createElement(G2t, { "aria-disabled": s, disabled: s, element: `${n}_REMOVE_BUTTON`, variant: "secondary_icon", size: "reset", onClick: e }, P.createElement(W2t, { decorative: !0 }), P.createElement(q2t, null, r))));
});
Z2t.displayName = "ChatComposerAttachmentCard";
var HZr = Object.create, J2t = Object.defineProperty, UZr = Object.getOwnPropertyDescriptor, Y2t = Object.getOwnPropertyNames, VZr = Object.getPrototypeOf, qZr = Object.prototype.hasOwnProperty, KZr = (t, e) => function() {
  return e || (0, t[Y2t(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, ZZr = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Y2t(e)) !qZr.call(t, a) && a !== r && J2t(t, a, { get: () => e[a], enumerable: !(n = UZr(e, a)) || n.enumerable });
  return t;
}, JZr = (t, e, r) => (r = t != null ? HZr(VZr(t)) : {}, ZZr(!t || !t.__esModule ? J2t(r, "default", { value: t, enumerable: !0 }) : r, t)), YZr = KZr({ "../../../../node_modules/deepmerge/dist/cjs.js"(t, e) {
  var r = function(C) {
    return n(C) && !a(C);
  };
  function n(C) {
    return !!C && typeof C == "object";
  }
  function a(C) {
    var x = Object.prototype.toString.call(C);
    return x === "[object RegExp]" || x === "[object Date]" || s(C);
  }
  var i = typeof Symbol == "function" && Symbol.for, o = i ? Symbol.for("react.element") : 60103;
  function s(C) {
    return C.$$typeof === o;
  }
  function l(C) {
    return Array.isArray(C) ? [] : {};
  }
  function c(C, x) {
    return x.clone !== !1 && x.isMergeableObject(C) ? w(l(C), C, x) : C;
  }
  function u(C, x, S) {
    return C.concat(x).map(function(A) {
      return c(A, S);
    });
  }
  function f(C, x) {
    if (!x.customMerge) return w;
    var S = x.customMerge(C);
    return typeof S == "function" ? S : w;
  }
  function h(C) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(C).filter(function(x) {
      return C.propertyIsEnumerable(x);
    }) : [];
  }
  function p(C) {
    return Object.keys(C).concat(h(C));
  }
  function g(C, x) {
    try {
      return x in C;
    } catch {
      return !1;
    }
  }
  function y(C, x) {
    return g(C, x) && !(Object.hasOwnProperty.call(C, x) && Object.propertyIsEnumerable.call(C, x));
  }
  function b(C, x, S) {
    var A = {};
    return S.isMergeableObject(C) && p(C).forEach(function(I) {
      A[I] = c(C[I], S);
    }), p(x).forEach(function(I) {
      y(C, I) || (g(C, I) && S.isMergeableObject(x[I]) ? A[I] = f(I, S)(C[I], x[I], S) : A[I] = c(x[I], S));
    }), A;
  }
  function w(C, x, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || u, S.isMergeableObject = S.isMergeableObject || r, S.cloneUnlessOtherwiseSpecified = c;
    var A = Array.isArray(x), I = Array.isArray(C), M = A === I;
    return M ? A ? S.arrayMerge(C, x, S) : b(C, x, S) : c(x, S);
  }
  w.all = function(C, x) {
    if (!Array.isArray(C)) throw new Error("first argument should be an array");
    return C.reduce(function(S, A) {
      return w(S, A, x);
    }, {});
  };
  var _ = w;
  e.exports = _;
} }), X2t = { color: { property: "color", scale: "textColors" }, cursor: !0, outline: !0, transition: !0, transitionDelay: !0, textDecoration: !0, textTransform: !0, whiteSpace: !0, wordBreak: !0, wordWrap: !0, fontVariantNumeric: !0, textOverflow: !0, overflowWrap: !0, listStyleType: !0, listStylePosition: !0, listStyleImage: !0 }, kF = { _hover: "&:hover", _active: "&:active, &[data-active=true]", _focus: "&:focus", _visited: "&:visited", _even: "&:nth-of-type(even)", _odd: "&:nth-of-type(odd)", _disabled: "&:disabled, &:disabled:focus, &:disabled:hover, &[aria-disabled=true], &[aria-disabled=true]:focus, &[aria-disabled=true]:hover", _checked: "&:checked, &[aria-checked=true]", _mixed: "&:indeterminate, &[aria-checked=mixed]", _selected: "&[aria-selected=true]", _selected_hover: "&[aria-selected=true]:hover", _selected_focus: "&[aria-selected=true]:focus", _selected_focusVisible: "&[aria-selected=true]:focus-visible", _invalid: "&:invalid, &[aria-invalid=true]", _pressed: "&[aria-pressed=true]", _readOnly: "&[aria-readonly=true], &[readonly]", _first: "&:first-of-type", _last: "&:last-of-type", _expanded: "&[aria-expanded=true]", _grabbed: "&[aria-grabbed=true]", _notFirst: "&:not(:first-of-type)", _notLast: "&:not(:last-of-type)", _before: "&:before", _after: "&:after", _focusWithin: "&:focus-within" }, XZr = JZr(YZr()), QZr = zu(X2t), eJr = (t) => {
  let e = Object.keys(t).filter((n) => n.startsWith("_"));
  if (e.length === 0) return {};
  let r = {};
  return e.forEach((n) => {
    kF[n] != null && (r[kF[n]] = t[n]);
  }), us(r);
}, tJr = (t) => {
  if (t != null && t.theme != null && t.theme.elements != null) {
    let e = t.theme.elements, r = t["data-paste-element"];
    if (e[r] != null) {
      let n = e[r], a = us(n)(t), { variants: i, ...o } = a, s = {};
      return t.variant != null && i != null && i[t.variant] != null && (s = i[t.variant]), () => (0, XZr.default)(o, s);
    }
  }
  return {};
}, rJr = [...O2e, ...B2e, ...N2e, ...R2e, ...Object.keys(kF), "display", "verticalAlign", "className", "style"], nJr = (t) => Object.keys(t).reduce((e, r) => (rJr.includes(r) || (e[r] = t[r]), e), {}), aJr = "21.0.0", iJr = ZI([...KI, ...Object.keys({ ...X2t, ...kF })]), oJr = ds("div", { shouldForwardProp: iJr })({ margin: 0, padding: 0 }, x8(wT, E2e, I2e, w8, qI, C8, T2e, QZr), eJr, tJr), Q2t = P.forwardRef(({ children: t, color: e = "colorText", fontSize: r = "fontSize30", lineHeight: n = "lineHeight30", element: a = "TEXT", ...i }, o) => P.createElement(oJr, { "data-paste-element": a, "data-paste-core-version": aJr, ref: o, color: e, fontSize: r, lineHeight: n, ...i }, t));
Q2t.displayName = "Text";
var eht = P.forwardRef(({ children: t, element: e = "CHAT_COMPOSER_ATTACHMENT_DESCRIPTION", ...r }, n) => P.createElement(Q2t, { ...nJr(r), element: e, ref: n, as: "div", fontSize: "fontSize20", color: "colorTextWeak", lineHeight: "lineHeight20" }, t));
eht.displayName = "ChatComposerAttachmentDescription";
var tht = P.forwardRef(({ children: t, ...e }, r) => P.createElement(ht, { ...e, as: "span", display: "inline-block", verticalAlign: "bottom", textDecoration: "inherit", maxWidth: "100%", overflow: "hidden", ref: r, textOverflow: "ellipsis", whiteSpace: "nowrap" }, t));
tht.displayName = "Truncate";
var rht = P.forwardRef(({ children: t, href: e, element: r = "CHAT_COMPOSER_ATTACHMENT_LINK", ...n }, a) => P.createElement(_2t, { href: e, ref: a, element: r, variant: "default", ...n }, P.createElement(tht, { title: t }, t)));
rht.displayName = "ChatComposerAttachmentLink";
const sJr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ChatComposer: h2t,
  ChatComposerActionGroup: p2t,
  ChatComposerAttachmentCard: Z2t,
  ChatComposerAttachmentDescription: eht,
  ChatComposerAttachmentGroup: m2t,
  ChatComposerAttachmentLink: rht,
  ChatComposerContainer: g2t
}, Symbol.toStringTag, { value: "Module" })), lJr = /* @__PURE__ */ aa(sJr);
var EDe;
function cJr() {
  return EDe || (EDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = lJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(hie)), hie;
}
var uJr = /* @__PURE__ */ cJr();
const dJr = Ml(
  ({ onChange: t, config: e, ...r }, n) => {
    const a = (i) => {
      i.read(() => {
        const o = k5t().getTextContent();
        t(o);
      });
    };
    return /* @__PURE__ */ R.jsx(ar.Box, { as: "div", children: /* @__PURE__ */ R.jsx(
      hpe.CustomizationProvider,
      {
        elements: {
          CHAT_COMPOSER: {
            boxShadow: "shadowLow",
            borderColor: "colorBorderWeaker",
            borderWidth: "borderWidth10",
            borderRadius: "borderRadius30",
            borderStyle: "solid",
            paddingY: "space50",
            paddingLeft: "space70",
            paddingRight: "space200"
          },
          CHAT_COMPOSER_PLACEHOLDER_WRAPPER: {
            top: "space50",
            left: "space70"
          }
        },
        children: /* @__PURE__ */ R.jsx(HT.Theme.Provider, { theme: "twilio", children: /* @__PURE__ */ R.jsx(
          uJr.ChatComposer,
          {
            config: e,
            ref: n,
            onChange: a,
            ...r,
            children: r.children && r.children
          }
        ) })
      }
    ) });
  }
);
var gie = {};
const fJr = /* @__PURE__ */ aa(Lsr);
var IDe;
function hJr() {
  return IDe || (IDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = fJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(gie)), gie;
}
var ofe = /* @__PURE__ */ hJr();
const pJr = "data:image/svg+xml,%3csvg%20width='20'%20height='20'%20viewBox='0%200%2020%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1309_4300)'%3e%3cpath%20d='M4.31421%2015.6933L6.45707%2013.5504L4.31421%2011.4076'%20stroke='%230263E0'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M8.59998%2015.6933H10.7428'%20stroke='%230263E0'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M0.714233%207.85718H9.28566'%20stroke='%230263E0'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M7.85709%203.57141H2.1428C1.76392%203.57141%201.40056%203.72193%201.13265%203.98983C0.864743%204.25774%200.714233%204.6211%200.714233%204.99998V17.8571C0.714233%2018.236%200.864743%2018.5994%201.13265%2018.8673C1.40056%2019.1351%201.76392%2019.2857%202.1428%2019.2857H16.4285C17.2175%2019.2857%2017.8571%2018.6461%2017.8571%2017.8571V9.99998'%20stroke='%230263E0'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M10.7273%205.62621C10.2336%205.53888%2010.2336%204.81828%2010.7273%204.73095C12.5157%204.41458%2013.9381%203.02942%2014.3263%201.22626L14.3561%201.08805C14.4629%200.591937%2015.1575%200.588849%2015.2686%201.08399L15.3048%201.24507C15.7072%203.03972%2017.1301%204.41317%2018.9135%204.72867C19.4096%204.81644%2019.4096%205.54072%2018.9135%205.62849C17.1301%205.94399%2015.7072%207.31744%2015.3048%209.11209L15.2686%209.27317C15.1575%209.76831%2014.4629%209.76522%2014.3561%209.26911L14.3263%209.13089C13.9381%207.32774%2012.5157%205.94258%2010.7273%205.62621Z'%20stroke='%230263E0'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1309_4300'%3e%3crect%20width='20'%20height='20'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", mJr = {
  tooltip: {
    promptLibrary: "Open your Prompt Library"
  }
}, gJr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  pluginsCopy: mJr
}, Symbol.toStringTag, { value: "Module" })), { pluginsCopy: vJr } = gJr, yJr = {
  PROMPT_LIBRARY_TRIGGER: "PROMPT_LIBRARY_TRIGGER"
}, bJr = ({
  isChatActive: t,
  loading: e,
  shouldClearInput: r,
  disabled: n = !1,
  ingress: a,
  handleOnClick: i,
  handleOnEnter: o,
  handleChatButtonToolClick: s
}) => {
  const [l] = A5t();
  Ut(() => {
    if (o)
      return l.registerCommand(
        T5t,
        (h) => (h !== null && !h.shiftKey && !e && !n && (h.preventDefault(), h.stopPropagation(), o(), u()), !0),
        E5t
      );
  }, [o, t, e, n]), Ut(() => {
    r && l.dispatchCommand(I5t, void 0);
  }, [l, r]);
  const c = () => {
    i && (i(), u());
  }, u = () => {
    const h = document.querySelector(
      `[data-testid="${tk.liveChat.chatComposer}"]`
    );
    h && setTimeout(() => {
      h.focus();
    }, 300);
  }, f = () => {
    s && (s(yJr.PROMPT_LIBRARY_TRIGGER), u());
  };
  return /* @__PURE__ */ R.jsxs(ar.Box, { position: "absolute", top: "space50", right: "space70", children: [
    a && a === ol.wiseOwlApp && /* @__PURE__ */ R.jsx(ar.Box, { as: "span", marginRight: "space30", children: /* @__PURE__ */ R.jsx(ofe.Tooltip, { text: vJr.tooltip.promptLibrary, children: /* @__PURE__ */ R.jsx(
      zi.Button,
      {
        variant: "primary_icon",
        size: "reset",
        onClick: f,
        disabled: e,
        children: /* @__PURE__ */ R.jsx(
          "img",
          {
            src: pJr,
            alt: "Logo",
            color: e ? "currentColor" : "colorTextPrimary"
          }
        )
      }
    ) }) }),
    /* @__PURE__ */ R.jsx(
      zi.Button,
      {
        loading: e,
        variant: "primary_icon",
        size: "reset",
        onClick: c,
        type: "submit",
        disabled: !e && n,
        "data-testid": tk.wiseOwlChat.submitButton,
        children: /* @__PURE__ */ R.jsx(
          j2e,
          {
            decorative: !1,
            title: "Send message",
            color: n ? "currentColor" : "colorTextPrimary"
          }
        )
      }
    )
  ] });
}, nht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `AttachIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[AttachIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.879 9.264l5.59-5.73a3.251 3.251 0 013.214-.924 3.347 3.347 0 012.36 2.42 3.447 3.447 0 01-.75 3.135l-.145.153-5.623 5.767a1.87 1.87 0 01-2.668-.023 1.987 1.987 0 01-.116-2.627l.099-.113 5.618-5.761c.195-.2.512-.2.708 0a.523.523 0 01.058.655l-.058.07-5.612 5.755a.94.94 0 00.011 1.295.885.885 0 001.174.09l.083-.073 5.624-5.767a2.4 2.4 0 00.628-2.296 2.333 2.333 0 00-1.645-1.686 2.264 2.264 0 00-2.117.523l-.129.127L4.587 9.99a3.866 3.866 0 000 5.371 3.64 3.64 0 005.097.139l.143-.139 6.818-6.99c.196-.2.513-.2.708 0a.523.523 0 01.058.655l-.058.071-6.818 6.99a4.626 4.626 0 01-6.656 0c-1.787-1.832-1.837-4.77-.15-6.663l.15-.16z" })));
});
nht.displayName = "AttachIcon";
const MDe = 150, PDe = [
  "image/*",
  ".txt",
  ".rtf",
  ".csv",
  ".json",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".xls",
  ".xlsx",
  ".pdf"
], vie = {
  tooltip: {
    description: "Click here to attach a file.",
    fileLimit: (t) => `File limit: ${t} MB`,
    files: (t) => `Accepted file types: ${t.join(", ")}`
  }
}, aht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DownloadIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DownloadIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M10.625 3.5a.625.625 0 10-1.25 0v8.491L7.342 9.958a.625.625 0 10-.884.884l3.125 3.125c.244.244.64.244.884 0l3.125-3.125a.625.625 0 00-.884-.884l-2.083 2.083V3.5zm-7.75 13c0-.345.28-.625.625-.625h13a.625.625 0 110 1.25h-13a.625.625 0 01-.625-.625z" })));
});
aht.displayName = "DownloadIcon";
var yie = {};
const xJr = /* @__PURE__ */ aa(a0r);
var RDe;
function CJr() {
  return RDe || (RDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = xJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(yie)), yie;
}
var wJr = /* @__PURE__ */ CJr();
const SJr = (t) => t.type.includes("image") ? /* @__PURE__ */ R.jsx(
  "img",
  {
    src: URL.createObjectURL(t),
    alt: "Preview",
    style: { maxHeight: "2.5rem" }
  }
) : /* @__PURE__ */ R.jsx(aht, { color: "colorTextIcon", decorative: !0 }), _Jr = () => /* @__PURE__ */ R.jsx(wF.Spinner, { decorative: !1, title: "Loading" }), kJr = ({
  files: t,
  onDeleteFile: e,
  isSending: r = !1,
  disabled: n = !1
}) => {
  const a = (i) => {
    const o = i.size / 1024;
    return o < 1024 ? `${o.toFixed(2)} KB` : `${(o / 1024).toFixed(2)} MB`;
  };
  return /* @__PURE__ */ R.jsx(
    ar.Box,
    {
      display: "flex",
      flexDirection: "row",
      columnGap: "space40",
      overflowX: "scroll",
      paddingY: "space50",
      children: t.map((i, o) => /* @__PURE__ */ R.jsx(
        ar.Box,
        {
          maxWidth: "size20",
          style: {
            pointerEvents: n ? "none" : "auto",
            opacity: r ? 0.5 : 1
          },
          children: /* @__PURE__ */ R.jsx(
            Ks.ComposerAttachmentCard,
            {
              onDismiss: () => {
                !n && !r && e(i);
              },
              children: /* @__PURE__ */ R.jsxs(
                Ks.ChatAttachment,
                {
                  attachmentIcon: r ? _Jr() : SJr(i),
                  children: [
                    /* @__PURE__ */ R.jsx(pf.Text, { as: "span", color: "colorTextPrimary", children: /* @__PURE__ */ R.jsx(wJr.Truncate, { title: i.name, children: i.name }) }),
                    /* @__PURE__ */ R.jsx(Ks.ChatAttachmentDescription, { children: a(i) })
                  ]
                }
              )
            }
          )
        },
        o
      ))
    }
  );
}, AJr = ({
  onAttachmentSelected: t,
  onDeleteAttachment: e,
  onError: r,
  disabled: n = !1,
  isSending: a = !1,
  files: i
}) => {
  const [o, s] = Yt(!1), l = ofe.useTooltipState(), c = () => {
    l.setVisible(!1);
    const f = document.createElement("input");
    f.type = "file", f.accept = PDe.join(","), f.onchange = (h) => {
      s(!0), l.setVisible(!1);
      const p = h.target;
      if (p.files && p.files.length > 0) {
        const g = p.files[0];
        if (!LVr(g, MDe))
          return s(!1), r(new Error("File size is too large"));
        t(g), s(!1);
      }
    }, f.click();
  }, u = `
    ${vie.tooltip.description}
    ${vie.tooltip.fileLimit(MDe)}
    ${vie.tooltip.files(PDe)}
    `;
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(
      ar.Box,
      {
        position: "absolute",
        top: "space50",
        right: "space160",
        className: "attachment-button-container",
        children: /* @__PURE__ */ R.jsx(ofe.Tooltip, { text: u, state: l, children: /* @__PURE__ */ R.jsx(
          zi.Button,
          {
            loading: o,
            disabled: n || a,
            variant: "secondary_icon",
            size: "reset",
            onClick: c,
            type: "button",
            children: /* @__PURE__ */ R.jsx(
              nht,
              {
                decorative: !1,
                title: u,
                color: n || a ? "currentColor" : "colorTextPrimary"
              }
            )
          }
        ) })
      }
    ),
    i && i.length > 0 && /* @__PURE__ */ R.jsx(
      kJr,
      {
        files: i,
        onDeleteFile: e,
        disabled: n,
        isSending: a
      }
    )
  ] });
}, TJr = () => {
  const [t, e] = Yt(!1);
  return Ut(() => {
    const o = (c) => {
      const u = ob({
        attributes: c,
        key: "chatPhase",
        fallbackValue: hm.Waiting
      });
      e(u === hm.Active);
    }, s = (c) => {
      o(c.conversation.attributes);
    }, l = (c) => {
      o(c.attributes);
    };
    return Vo.addEventListener(
      bs.Updated,
      s
    ), Vo.addEventListener(
      bs.Ready,
      l
    ), () => {
      Vo.removeEventListener(
        bs.Updated,
        s
      ), Vo.removeEventListener(
        bs.Ready,
        l
      );
    };
  }, []), {
    sendChatMessage: ({ body: o, files: s }) => Vo.sendMessage({ body: o, files: s }),
    isChatActive: t,
    onChatError: (o) => {
      Vo.setError(o.message);
    },
    notifyStartTyping: () => {
      Vo.startTyping();
    }
  };
}, ODe = {
  input: {
    ariaLabel: "input",
    placeholder: "Enter a message"
  }
}, bie = 3, EJr = S6.styled(ar.Box)`
  ${({ customStyles: t }) => t || ""}
`, IJr = ({
  isChatActive: t
}) => {
  const { handleSubmit: e, control: r, formState: n, reset: a } = Xme(), { isValid: i, isSubmitting: o } = n, [s, l] = Yt(bie), [c, u] = Yt([]), [f, h] = Yt(!0), [p, g] = Yt(!1), { sendChatMessage: y, notifyStartTyping: b, onChatError: w } = TJr(), _ = (I) => {
    h(!0), g(!0), y({
      body: I.input,
      files: c
    }).then(() => {
      u([]), a({ input: "" });
    }).catch((M) => {
      w(M);
    }).finally(() => {
      h(!1), g(!1), l(bie);
    });
  };
  Ut(() => {
    h(!t), l(c.length === 0 ? bie : 0);
  }, [c, t]);
  const C = (I) => {
    I.key !== "Enter" && b();
  }, x = (I) => {
    u([...c, I]);
  }, S = (I) => {
    u(c.filter((M) => M !== I));
  };
  return /* @__PURE__ */ R.jsx(EJr, { customStyles: `
  div[data-paste-element=CHAT_COMPOSER],
  div[data-paste-element=CHAT_COMPOSER]:hover {
    background-color: white;
  }`, children: /* @__PURE__ */ R.jsx(
    Vue,
    {
      name: "input",
      control: r,
      rules: { required: c.length === 0, minLength: s },
      render: ({ field: I }) => /* @__PURE__ */ R.jsxs(
        dJr,
        {
          config: {
            namespace: "live-chat-message",
            onError: w
          },
          disabled: f,
          ariaLabel: ODe.input.ariaLabel,
          placeholder: ODe.input.placeholder,
          required: c.length === 0,
          ...I,
          onKeyDown: C,
          "data-testid": tk.liveChat.chatComposer,
          children: [
            /* @__PURE__ */ R.jsx(M5t, {}),
            /* @__PURE__ */ R.jsx(
              bJr,
              {
                loading: o || p,
                isChatActive: f,
                shouldClearInput: i && o,
                disabled: f,
                handleOnEnter: e(_),
                handleOnClick: e(_)
              }
            ),
            /* @__PURE__ */ R.jsx(
              AJr,
              {
                onAttachmentSelected: x,
                onDeleteAttachment: S,
                onError: w,
                disabled: !t && f,
                isSending: p,
                files: c
              }
            )
          ]
        }
      )
    }
  ) });
};
var xie = {};
const MJr = /* @__PURE__ */ aa(vbr);
var BDe;
function PJr() {
  return BDe || (BDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = MJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(xie)), xie;
}
var _s = /* @__PURE__ */ PJr();
const xS = {
  button: "End live chat",
  modal: {
    header: "Are you sure you want to end this chat?",
    body: "Ending the chat means you will not receive follow-up messages pertaining to this chat. You cannot undo this action.",
    actions: {
      confirm: "Confirm",
      close: "Close"
    }
  }
}, RJr = ({ onConfirm: t }) => {
  const e = "end-chat-modal-heading", [r, n] = Yt(!1), [a, i] = Yt(!1), o = () => i(!0), s = () => i(!1), l = (c) => {
    n(!0), s(), t(c);
  };
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(
      zi.Button,
      {
        variant: "secondary",
        size: "rounded_small",
        onClick: o,
        loading: r,
        children: xS.button
      }
    ),
    /* @__PURE__ */ R.jsxs(
      _s.Modal,
      {
        ariaLabelledby: e,
        isOpen: a,
        onDismiss: s,
        size: "default",
        children: [
          /* @__PURE__ */ R.jsx(_s.ModalHeader, { children: /* @__PURE__ */ R.jsx(_s.ModalHeading, { as: "h3", id: e, children: xS.modal.header }) }),
          /* @__PURE__ */ R.jsx(_s.ModalBody, { children: /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: xS.modal.body }) }),
          /* @__PURE__ */ R.jsx(_s.ModalFooter, { children: /* @__PURE__ */ R.jsxs(_s.ModalFooterActions, { children: [
            /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: s, children: xS.modal.actions.close }),
            /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", onClick: l, children: xS.modal.actions.confirm })
          ] }) })
        ]
      }
    )
  ] });
}, iht = ({ isChatActive: t }) => {
  const { requestTransformer: e } = Ja(), r = async () => Vo.endLiveChat({ requestTransformer: e });
  return t ? /* @__PURE__ */ R.jsx(ar.Box, { marginBottom: "space50", marginTop: "auto", children: /* @__PURE__ */ R.jsx(RJr, { onConfirm: r }) }) : /* @__PURE__ */ R.jsx(R.Fragment, {});
}, OJr = (t) => {
  const [e, r] = Yt(0), [n, a] = Yt(0), i = () => {
    t && (r(t.scrollHeight - t.offsetHeight), a(t.scrollTop));
  };
  Ut(() => {
    if (i(), t)
      return t.addEventListener("scroll", i), () => {
        t.removeEventListener("scroll", i);
      };
  }, [t]);
  const o = (c) => {
    t && t.scrollTo({ top: c, behavior: "smooth" });
  };
  return {
    maxScroll: e,
    currentScroll: n,
    scrollToBottom: () => {
      o(e);
    },
    updateScrollState: i,
    updateScrollBottom: () => {
      t && o(t.scrollHeight), i();
    }
  };
}, BJr = S6.styled(ar.Box)`
  ${({ customStyles: t }) => t || ""}
  display: flex;
  flex-direction: column;
  max-height: 80vh;
`, NJr = S6.styled(ar.Box)`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 80vh;
`, $Jr = ({
  agent: t,
  agentEvents: e,
  chatMessages: r,
  customer: n,
  dateCreated: a,
  participantFriendlyNames: i = {},
  isAgentTyping: o,
  isChatActive: s
}) => {
  const l = Zt(null), c = Zt(r.length), u = Zt(0), f = Zt(/* @__PURE__ */ new Set()), { chats: h, push: p } = Ks.useChatLogger(), { updateScrollBottom: g } = OJr(l.current), y = (C) => {
    const x = BVr(n, C);
    return {
      id: C.sid,
      content: /* @__PURE__ */ R.jsx(
        Fqr,
        {
          message: C,
          messageDirection: x,
          participantFriendlyNames: i
        }
      ),
      variant: x
    };
  }, b = (C) => {
    var I;
    const x = `${(I = C.agent) == null ? void 0 : I.sid}_${C.action}`, S = C.agent.identity || "", A = i[S] || "Agent";
    return {
      id: x,
      content: /* @__PURE__ */ R.jsx(fVr, { action: C.action, name: A })
    };
  };
  Ut(() => {
    if (!h.length && !f.current.size) {
      r.forEach((x) => {
        if (!f.current.has(x.sid)) {
          const S = y(x);
          p(S), f.current.add(x.sid);
        }
      }), c.current = r.length;
      return;
    }
    if (c.current < r.length) {
      const x = r[r.length - 1];
      if (!f.current.has(x.sid)) {
        const S = y(x);
        p(S), f.current.add(x.sid);
      }
    }
    c.current = r.length;
  }, [r]), Ut(() => {
    const C = (t == null ? void 0 : t.identity) || "", x = u.current < e.length, S = J1t(i), A = i[C];
    if (x && !S && A) {
      const I = e[e.length - 1], M = b(I);
      p(M), u.current = e.length;
    }
  }, [e, i]), Ut(() => {
    setTimeout(g, 1);
  }, [h, o]);
  const w = `
  code[data-paste-element=INLINE_CODE] {
    color: rgb(18, 28, 45);
  }
  `, _ = (C) => {
    throw C;
  };
  return /* @__PURE__ */ R.jsxs(
    BJr,
    {
      backgroundColor: "colorBackgroundBody",
      position: "relative",
      height: "100%",
      customStyles: w,
      children: [
        /* @__PURE__ */ R.jsxs(NJr, { ref: l, children: [
          /* @__PURE__ */ R.jsx(dVr, { dateCreated: a, type: "started" }),
          /* @__PURE__ */ R.jsx(Ks.ChatLogger, { chats: h }),
          t && /* @__PURE__ */ R.jsx(
            zqr,
            {
              agent: t,
              isTyping: o,
              participantFriendlyNames: i
            }
          )
        ] }),
        /* @__PURE__ */ R.jsx(iht, { isChatActive: s }),
        /* @__PURE__ */ R.jsx(IJr, { onError: _, isChatActive: s })
      ]
    }
  );
};
var Cie = {};
const DJr = /* @__PURE__ */ aa(lur);
var NDe;
function LJr() {
  return NDe || (NDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = DJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Cie)), Cie;
}
var wie = /* @__PURE__ */ LJr();
const jJr = S6.styled(ar.Box)`
  > [data-paste-element="MEDIA_OBJECT"] {
    flex-direction: column;
    gap: 0.75rem;
  }
  * [data-paste-element="MEDIA_BODY"] {
    width: 100%;
  }
`, FJr = S6.styled(ar.Box)`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  padding-top: 0.75rem;
  padding-left: 0.125rem;
`, N3e = ({
  children: t,
  element: e,
  author: r,
  role: n,
  // BoxProps from Paste
  ...a
}) => {
  const i = n === Hv.Assistant, o = i ? Z5e : h6t, s = i ? tk.wiseOwlChat.helpAssistantMediaObject : tk.wiseOwlChat.userMediaObject;
  return /* @__PURE__ */ R.jsx(jJr, { element: e, ...a, children: /* @__PURE__ */ R.jsxs(wie.MediaObject, { verticalAlign: "top", "data-testid": s, children: [
    /* @__PURE__ */ R.jsx(wie.MediaFigure, { spacing: "space50", children: /* @__PURE__ */ R.jsxs(FJr, { children: [
      /* @__PURE__ */ R.jsx(
        Z1t.Avatar,
        {
          size: "sizeIcon50",
          color: i ? "decorative20" : "decorative30",
          ...n === Hv.Assistant ? {
            name: Z5e,
            icon: hP
          } : { name: r }
        }
      ),
      /* @__PURE__ */ R.jsx(pf.Text, { as: "p", fontSize: "fontSize30", fontWeight: "fontWeightBold", children: o })
    ] }) }),
    /* @__PURE__ */ R.jsx(wie.MediaBody, { children: t })
  ] }) });
}, oht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `HistoryIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[HistoryIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", d: "M8.197 2.641a7.966 7.966 0 113.049 15.326.625.625 0 110-1.25 6.716 6.716 0 10-6.71-6.994l1.575-1.65a.625.625 0 01.904.864l-2.837 2.97a.625.625 0 01-.987-.108L1.027 8.224a.625.625 0 111.07-.648l1.196 1.976a7.966 7.966 0 014.904-6.91z" }), P.createElement("path", { fill: "currentColor", d: "M11.712 6.5a.625.625 0 00-1.25 0v3.358c0 .308.16.593.425.75l2.378 1.428a.625.625 0 00.643-1.072l-2.196-1.318V6.5z" })));
});
oht.displayName = "HistoryIcon";
const $3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowBackIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowBackIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M5.009 9.91l-.007.05v.08l.01.07.01.029a.489.489 0 00.205.272l3.832 3.444a.596.596 0 00.78 0 .459.459 0 00.063-.632l-.063-.069-2.957-2.659h7.605A.504.504 0 0015 10a.5.5 0 00-.42-.488l-.093-.008H6.883l2.956-2.658a.459.459 0 00.063-.632l-.063-.069a.598.598 0 00-.704-.057l-.076.057L5.227 9.59a.498.498 0 00-.206.272l-.012.049z" })));
});
$3e.displayName = "ArrowBackIcon";
const zJr = "ACTION_BTN";
var Sie = {}, GJr = ds(ht)(({ _activeSibling: t, _boxChild: e, _checkedAndActiveSibling: r, _checkedAndDisabledSibling: n, _checkedAndFocusSibling: a, _checkedAndHoverSibling: i, _checkedAndInvalidSibling: o, _checkedAndInvalidAndDisabledSibling: s, _checkedAndInvalidAndHoverSibling: l, _checkedSibling: c, _checkedSiblingAndBoxChild: u, _disabledSibling: f, _focusSibling: h, _hoverSibling: p, _invalidSibling: g, _invalidAndHoverSibling: y, _invalidAndDisabledSibling: b, type: w = "checkbox" }) => {
  let _ = `input[type=${w}]:active + label &`, C = `input[type=${w}]:checked + label &, input[type=${w}][aria-checked=mixed] + label &`, x = `input[type=${w}]:checked:active + label &, input[type=${w}][aria-checked=mixed]:active + label &`, S = `input[type=${w}]:checked + label & > *, input[type=${w}][aria-checked=mixed] + label & > *`, A = `input[type=${w}]:checked:disabled + label &, input[type=${w}][aria-checked=mixed]:disabled + label &`, I = `input[type=${w}]:checked:focus + label &, input[type=${w}][aria-checked=mixed]:focus + label &`, M = `input[type=${w}]:checked:hover:not(:disabled) + label &, input[type=${w}][aria-checked=mixed]:hover:not(:disabled) + label &`, B = `input[type=${w}][aria-invalid=true]:checked + label &`, L = `input[type=${w}][aria-invalid=true]:checked:disabled + label &`, N = `input[type=${w}][aria-invalid=true]:checked:hover:not(:disabled) + label &`, d = `input[type=${w}] + label & > *`, m = `input[type=${w}]:disabled + label &`, v = `input[type=${w}]:focus + label &`, k = `input[type=${w}]:hover:not(:disabled):not(:checked) + label &`, O = `input[type=${w}][aria-invalid=true] + label &`, G = `input[type=${w}][aria-invalid=true]:hover:not(:disabled) + label &`, H = `input[type=${w}][aria-invalid=true]:disabled + label &`;
  return us({ [_]: t, [C]: c, [x]: r, [S]: u, [A]: n, [I]: a, [M]: i, [B]: o, [L]: s, [N]: l, [d]: e, [m]: f, [v]: h, [k]: p, [O]: g, [G]: y, [H]: b });
}), sht = P.forwardRef(({ "aria-hidden": t = "true", alignItems: e = "center", display: r = "inline-flex", element: n = "SIBLING_BOX", flexShrink: a = 0, justifyContent: i = "center", transition: o = "all 120ms", ...s }, l) => P.createElement(GJr, { alignItems: e, "aria-hidden": t, display: r, element: n, flexShrink: a, justifyContent: i, ref: l, transition: o, ...s }));
sht.displayName = "SiblingBox";
var lht = P.forwardRef(({ children: t, disabled: e, applyHoverStyles: r = !1, element: n = "BASE_RADIO_CHECKBOX_CONTROL", ...a }, i) => P.createElement(sht, { as: "span", ref: i, display: "flex", element: n, backgroundColor: "colorBackgroundBody", borderColor: r ? "colorBorderPrimaryStronger" : "colorBorder", borderStyle: "solid", borderWidth: "borderWidth10", height: "sizeSquare50", marginRight: "space20", marginY: "space10", width: "sizeSquare50", color: "colorTextWeakest", _hoverSibling: { borderColor: "colorBorderPrimaryStronger", color: "colorTextWeakest" }, _focusSibling: { borderColor: "colorBorder", boxShadow: "shadowFocus", color: "colorTextInverse" }, _activeSibling: e ? void 0 : { borderColor: "colorBorderPrimaryStronger", backgroundColor: "colorBackgroundPrimaryStronger", color: "colorTextWeakest" }, _checkedSibling: { borderColor: "colorBorderPrimary", backgroundColor: "colorBackgroundPrimary", color: "colorTextInverse" }, _disabledSibling: { borderColor: "colorBorderWeaker", backgroundColor: "colorBackgroundStrong" }, _invalidSibling: { borderColor: "colorBorderError" }, _invalidAndHoverSibling: { borderColor: "colorBorderErrorStronger" }, _invalidAndDisabledSibling: { borderColor: "colorBorderWeaker" }, _checkedAndHoverSibling: { borderColor: "colorBorderPrimaryStronger", backgroundColor: "colorBackgroundPrimaryStronger", color: "colorTextWeakest" }, _checkedAndFocusSibling: { borderColor: "colorBorderPrimary", backgroundColor: "colorBackgroundPrimary", color: "colorTextInverse" }, _checkedAndActiveSibling: e ? void 0 : { borderColor: "colorBorderPrimaryStronger", backgroundColor: "colorBackgroundPrimaryStronger" }, _checkedAndDisabledSibling: { borderColor: "colorBorderWeaker", backgroundColor: "colorBackgroundStrong", color: "colorTextWeaker" }, _checkedAndInvalidSibling: { borderColor: "colorBorderError", backgroundColor: "colorBackgroundError", color: "colorTextInverse" }, _checkedAndInvalidAndHoverSibling: { borderColor: "colorBorderErrorStronger", backgroundColor: "colorBackgroundErrorStronger" }, _checkedAndInvalidAndDisabledSibling: { borderColor: "colorBorderWeaker", backgroundColor: "colorBackgroundStrong", color: "colorTextWeaker" }, ...a }, t));
lht.displayName = "BaseRadioCheckboxControl";
var cht = P.forwardRef(({ children: t, ...e }, r) => P.createElement(P8, { ...e, marginBottom: "space0", ref: r }, P.createElement(ht, { as: "span", display: "flex" }, t)));
cht.displayName = "BaseRadioCheckboxLabel";
var uht = P.forwardRef(({ children: t, element: e = "BASE_RADIO_CHECKBOX_LABEL_TEXT", ...r }, n) => P.createElement(cl, { as: "span", color: "currentColor", marginLeft: "space20", element: e, ref: n, ...r }, t));
uht.displayName = "BaseRadioCheckboxLabelText";
var dht = P.forwardRef(({ children: t, helpTextId: e, element: r = "BASE_RADIO_CHECKBOX_HELP_TEXT_WRAPPER" }, n) => P.createElement(ht, { as: "span", display: "block", element: r, marginLeft: "space70", ref: n }, P.createElement(w5, { id: e, marginTop: "space0" }, t)));
dht.displayName = "BaseRadioCheckboxHelpText";
var fht = P.forwardRef(({ children: t, disabled: e, element: r = "INLINE_CONTROL_GROUP", errorText: n, helpText: a, legend: i, orientation: o = "vertical", required: s, i18nRequiredLabel: l, fieldStyleProps: c, ...u }, f) => {
  let h = !!c;
  return P.createElement(ht, { ...Xt(u), as: "fieldset", element: r, margin: "space0", padding: "space0", minWidth: "0px", borderWidth: "borderWidth0", ref: f }, P.createElement(P8, { as: "legend", element: "LEGEND", htmlFor: void 0, required: s, marginBottom: "space0", disabled: e, i18nRequiredLabel: l }, i), a && P.createElement(w5, { marginTop: "space0" }, a), P.createElement(ht, { element: `${r}_SET`, marginRight: h ? void 0 : "space20" }, P.createElement(ht, { display: h && o === "horizontal" ? "inline-flex" : "block", width: h ? "100%" : void 0 }, P.Children.map(t, (p, g) => P.createElement(ht, { element: `${r}_FIELD`, display: o === "horizontal" ? "inline-block" : "block", flexBasis: h ? "50%" : void 0, marginTop: c != null && c.marginTop ? g === 0 && o === "vertical" ? "space40" : c == null ? void 0 : c.marginTop : "space40", marginRight: o === "horizontal" && !h ? "space70" : null, marginLeft: h && o === "horizontal" ? g === 0 ? "space0" : "space30" : "space0" }, p))), n && P.createElement(ht, { element: `${r}_ERROR_TEXT_WRAPPER`, marginTop: "space40" }, P.createElement(w5, { variant: "error" }, n))));
});
fht.displayName = "InlineControlGroup";
var hht = P.createContext({ name: "", value: "", disabled: !1, hasError: !1, onChange: () => {
} }), D3e = P.forwardRef((t, e) => P.createElement(ht, { as: "input", type: "radio", size: "size0", border: "none", overflow: "hidden", padding: "space0", margin: "space0", whiteSpace: "nowrap", textTransform: "none", position: "absolute", clip: "rect(0 0 0 0)", ref: e, ...t }));
D3e.displayName = "HiddenRadio";
var pht = P.forwardRef(({ id: t, name: e, element: r = "RADIO", value: n, checked: a, defaultChecked: i, disabled: o, hasError: s, onChange: l, children: c, helpText: u, ...f }, h) => {
  if (a != null && i != null) throw new Error("[Paste Radio] Do not provide both 'defaultChecked' and 'checked' to Radio at the same time. Please consider if you want this component to be controlled or uncontrolled.");
  let [p, g] = P.useState(i), y = P.useContext(hht), b = Jr(), w = t || Jr(), _ = P.useMemo(() => a !== void 0 || y.value !== "", []), C = P.useCallback((A) => {
    l ? l(A) : y.onChange(A), _ || g(A.target.checked);
  }, [l, y, _]), x = { name: e ?? y.name, disabled: o ?? y.disabled, hasError: s ?? y.hasError };
  _ ? y.value !== "" ? x.checked = y.value === n : x.checked = a : x.defaultChecked = i;
  let S = _ ? x.checked || x.defaultChecked : p;
  return P.createElement(ht, { element: r, position: "relative", display: "inline-flex", alignItems: "flex-start", flexDirection: "column", verticalAlign: "top" }, P.createElement(D3e, { ...f, ...x, value: n, "aria-describedby": b, "aria-invalid": x.hasError, onChange: C, id: w, ref: h }), P.createElement(cht, { disabled: x.disabled, htmlFor: w }, P.createElement(lht, { element: `${r}_CONTROL`, borderRadius: "borderRadiusCircle", disabled: x.disabled, type: "radio", _checkedAndDisabledSibling: { color: "colorTextWeaker" } }, P.createElement(ht, { as: "span", element: `${r}_CONTROL_CIRCLE`, lineHeight: "lineHeight0", display: S ? "block" : "none", color: "inherit", size: "sizeIcon10" }, P.createElement("svg", { role: "img", "aria-hidden": !0, width: "100%", height: "100%", viewBox: "0 0 16 16", fill: "none" }, P.createElement("circle", { fill: "currentColor", cx: 8, cy: 8, r: 3 })))), P.createElement(uht, { element: `${r}_LABEL_TEXT`, fontWeight: "fontWeightMedium" }, c)), u && P.createElement(dht, { element: `${r}_HELP_TEXT_WRAPPER`, helpTextId: b }, u));
});
pht.displayName = "Radio";
var mht = P.forwardRef(({ name: t, element: e = "RADIO_GROUP", value: r, onChange: n, disabled: a = !1, errorText: i, children: o, i18nRequiredLabel: s = "(required)", ...l }, c) => {
  let u = P.useCallback((h) => {
    n == null || n(h.target.value);
  }, [n]), f = P.useMemo(() => ({ name: t, value: r || "", disabled: a, hasError: i != null, onChange: u }), [t, r, a, i, u]);
  return P.createElement(hht.Provider, { value: f }, P.createElement(fht, { element: e, ...l, disabled: a, errorText: i, name: t, ref: c, i18nRequiredLabel: s }, o));
});
mht.displayName = "RadioGroup";
const WJr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HiddenRadio: D3e,
  Radio: pht,
  RadioGroup: mht
}, Symbol.toStringTag, { value: "Module" })), HJr = /* @__PURE__ */ aa(WJr);
var $De;
function UJr() {
  return $De || ($De = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = HJr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Sie)), Sie;
}
var DDe = /* @__PURE__ */ UJr();
const L3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SuccessIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SuccessIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 2a8 8 0 110 16 8 8 0 010-16zm2.997 5c-.266 0-.521.106-.71.294l-3.286 3.294L7.712 9.29a1.003 1.003 0 00-1.418 1.418l1.998 1.997a1 1 0 001.418 0l3.996-3.994A1.002 1.002 0 0012.996 7z" })));
});
L3e.displayName = "SuccessIcon";
const VJr = () => /* @__PURE__ */ R.jsxs(ar.Box, { as: "section", children: [
  /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space20", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "90%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "30%" })
  ] }),
  /* @__PURE__ */ R.jsx(ar.Box, { as: "div", marginTop: "space40", children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space40", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "25%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "20%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "40%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "20%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "25%" })
  ] }) }),
  /* @__PURE__ */ R.jsx(ar.Box, { as: "div", marginTop: "space60", children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "vertical", spacing: "space20", children: [
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "90%" }),
    /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "100%", height: "100px" })
  ] }) }),
  /* @__PURE__ */ R.jsxs(
    ar.Box,
    {
      as: "div",
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "space30",
      marginTop: "space60",
      children: [
        /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "75px", height: "36px" }),
        /* @__PURE__ */ R.jsx(Qo.SkeletonLoader, { width: "140px", height: "36px" })
      ]
    }
  )
] }), qJr = ({
  displayName: t,
  onFetchSurveyQuestions: e,
  onSubmitFeedback: r,
  onCancelSurvey: n,
  isDisabled: a,
  isQueryError: i,
  isLoading: o,
  isSubmitting: s,
  isSurveySubmitted: l,
  surveyResponse: c,
  surveyQuestions: u,
  setResponse: f
}) => {
  const h = () => /* @__PURE__ */ R.jsx(ar.Box, { as: "main", margin: "space60", children: /* @__PURE__ */ R.jsx(
    lme,
    {
      heading: o1.errors.emptyState.heading(t),
      description: o1.errors.emptyState.description,
      variant: AG.oops,
      maxWidth: "40rem",
      children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "horizontal", spacing: "space30", children: [
        /* @__PURE__ */ R.jsx(
          zi.Button,
          {
            variant: "secondary",
            onClick: n,
            disabled: o,
            children: o1.formButton.cancel
          }
        ),
        /* @__PURE__ */ R.jsx(
          zi.Button,
          {
            variant: "primary",
            loading: o,
            onClick: e,
            children: o1.formButton.retry
          }
        )
      ] })
    }
  ) });
  if (i)
    return h();
  const p = () => u.map((g, y) => {
    if (g.type === Zce.MultipleChoice)
      return /* @__PURE__ */ R.jsx(
        ar.Box,
        {
          as: "section",
          marginBottom: "space60",
          children: /* @__PURE__ */ R.jsx(
            DDe.RadioGroup,
            {
              legend: g.display,
              name: g.questionId,
              onChange: (b) => {
                f({
                  ...c,
                  [g.questionId]: {
                    [b]: {
                      selected: !0
                    }
                  }
                });
              },
              children: (g == null ? void 0 : g.choices) && g.choices.map((b, w) => {
                const _ = `${w}-${g.questionId}-${b.choiceId}`;
                return /* @__PURE__ */ R.jsx(
                  DDe.Radio,
                  {
                    id: _,
                    name: g.questionId,
                    value: b.choiceId,
                    children: b.display
                  },
                  _
                );
              })
            },
            `${y}-${g.questionId}-${g.display}`
          )
        },
        `box-${y}-${g.questionId}-${g.display}`
      );
    if (g.type === Zce.TextEntry)
      return /* @__PURE__ */ R.jsxs(
        ar.Box,
        {
          as: "section",
          marginTop: "space60",
          children: [
            /* @__PURE__ */ R.jsx(Db.Label, { htmlFor: g.questionId, children: g.display }),
            /* @__PURE__ */ R.jsx(
              oge.TextArea,
              {
                "aria-label": g.display,
                id: g.questionId,
                name: g.display,
                onChange: (b) => f({
                  ...c,
                  [g.questionId]: b.target.value
                })
              }
            )
          ]
        },
        `box-${y}-${g.questionId}-${g.display}`
      );
  });
  return /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", flexDirection: "column", rowGap: "space80", children: [
    /* @__PURE__ */ R.jsx(ez, { variant: "bot", children: /* @__PURE__ */ R.jsx(tz, { "aria-label": "AI said", children: t }) }),
    l ? /* @__PURE__ */ R.jsx(
      ar.Box,
      {
        display: "flex",
        columnGap: "space80",
        marginBottom: "space60",
        paddingY: "space30",
        children: /* @__PURE__ */ R.jsxs(JM.Badge, { as: "span", variant: "success", children: [
          /* @__PURE__ */ R.jsx(L3e, { decorative: !0 }),
          o1.feedbackSubmitted
        ] })
      }
    ) : (
      /** Survey Form */
      /* @__PURE__ */ R.jsx(ar.Box, { as: "section", children: /* @__PURE__ */ R.jsxs(
        ar.Box,
        {
          as: "form",
          borderWidth: "borderWidth10",
          borderColor: "colorBorderWeaker",
          borderStyle: "solid",
          borderRadius: "borderRadius20",
          padding: "space60",
          onSubmit: r,
          children: [
            o && /* @__PURE__ */ R.jsx(VJr, {}),
            u && !o && p(),
            !o && u.length && /* @__PURE__ */ R.jsxs(
              ar.Box,
              {
                as: "div",
                display: "flex",
                justifyContent: "space-between",
                marginTop: "space60",
                children: [
                  /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: n, children: o1.formButton.cancel }),
                  /* @__PURE__ */ R.jsx(
                    zi.Button,
                    {
                      variant: "primary",
                      disabled: a,
                      loading: s,
                      onClick: r,
                      children: o1.formButton.submit
                    }
                  )
                ]
              }
            )
          ]
        }
      ) })
    )
  ] });
}, KJr = ({
  chatId: t,
  surveyId: e
}) => {
  const r = l5t(), n = s2(), { requestTransformer: a } = Ja(), [i, o] = Yt([]), [s, l] = Yt(""), [
    c,
    { isLoading: u, isError: f }
  ] = EPt({
    fixedCacheKey: "survey-session"
  }), [h, { isLoading: p }] = IPt(), [g] = MPt(), y = Gn(
    (O) => O.csatSurvey.isSurveyVisible
  ), b = Gn(
    (O) => O.csatSurvey.surveyResponse
  ), w = Gn(
    (O) => O.csatSurvey.isSurveySubmitted
  ), _ = Gn(
    (O) => O.csatSurvey.SurveyVariant
  ), C = Gn((O) => O.liveChat.liveChatId), x = Gn((O) => O.liveChat.ticketId), S = Gn((O) => O.config.ingress), A = Gn((O) => O.config.user), I = i && i.filter((O) => O.type === Zce.MultipleChoice).map((O) => O.questionId), B = !(Object.keys(b).length && I.every((O) => Object.keys(b).includes(O)));
  Ut(() => {
    y && N();
  }, [y]), Ut(() => {
    L();
  }, [C]);
  const L = async () => {
    if (C) {
      const {
        data: { responseReceipts: O }
      } = await g({
        requestTransformer: a,
        liveChatId: C
      }).unwrap();
      O.length > 0 && !w && k();
    }
  }, N = async () => {
    const {
      data: { result: O }
    } = await c({
      requestTransformer: a,
      surveyId: e,
      surveyVariant: _
    }).unwrap();
    o(O.questions), l(O.sessionId);
  }, d = async () => {
    try {
      await h({
        requestTransformer: a,
        embeddedData: {
          // TODO: Replace chatId with conversationId when the API is updated
          chatId: t,
          chatTimestamp: (/* @__PURE__ */ new Date()).toISOString(),
          ingress: S,
          firstName: A == null ? void 0 : A.firstName,
          lastName: A == null ? void 0 : A.lastName,
          liveChatId: C,
          sendGridUserId: A == null ? void 0 : A.sendGridUserId,
          surveyVariant: _,
          ticketId: x
        },
        surveyId: e,
        sessionId: s,
        responses: b
      }).unwrap(), k();
    } catch {
      r.push({
        message: o1.errors.toast,
        variant: "error",
        dismissAfter: 5e3
      });
    }
  }, m = () => {
    n(yPt());
  }, v = (O) => {
    n(xPt(O));
  }, k = () => {
    n(CPt());
  };
  return {
    isDisabled: B,
    isSurveyVisible: y,
    isSubmitting: p,
    isQueryError: f,
    isLoadingQuestions: u,
    isSurveySubmitted: w,
    surveyQuestions: i,
    surveyResponse: b,
    surveyVariant: _,
    toaster: r,
    handleHideSurvey: m,
    handleSubmitFeedback: d,
    handleSetResponse: v,
    handleCreateSurveySession: N
  };
}, ght = () => {
  const t = Gn((i) => i.config.displayName), e = Gn((i) => i.config.user), r = Gn((i) => i.config.surveyId), n = Gn((i) => i.conversation.conversationId), a = Gn((i) => i.conversation.chatId);
  return !n || !r || !a ? /* @__PURE__ */ R.jsx("div", {}) : /* @__PURE__ */ R.jsx(
    ZJr,
    {
      conversationId: n,
      chatId: a,
      displayName: t,
      user: e,
      surveyId: r
    }
  );
}, ZJr = ({
  conversationId: t,
  chatId: e,
  displayName: r,
  user: n,
  surveyId: a
}) => {
  const {
    isDisabled: i,
    isSurveyVisible: o,
    isSubmitting: s,
    isQueryError: l,
    isLoadingQuestions: c,
    isSurveySubmitted: u,
    surveyQuestions: f,
    surveyResponse: h,
    surveyVariant: p,
    toaster: g,
    handleCreateSurveySession: y,
    handleHideSurvey: b,
    handleSubmitFeedback: w,
    handleSetResponse: _
  } = KJr({
    chatId: e,
    surveyId: a
  });
  return /* @__PURE__ */ R.jsx(R.Fragment, { children: o && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(c5t, { left: ["space40", "unset", "unset"], ...g }),
    p === g2e.AGENT && /* @__PURE__ */ R.jsxs(
      ar.Box,
      {
        display: "flex",
        flexDirection: "column",
        rowGap: "space80",
        marginTop: "space40",
        marginBottom: "space80",
        children: [
          /* @__PURE__ */ R.jsx(ez, { variant: "user", children: /* @__PURE__ */ R.jsx(tz, { "aria-label": "You said", children: `${n.firstName} ${n.lastName}` }) }),
          o1.automatedUserResponse
        ]
      }
    ),
    /* @__PURE__ */ R.jsx(
      qJr,
      {
        displayName: r,
        onFetchSurveyQuestions: y,
        onSubmitFeedback: w,
        onCancelSurvey: b,
        isDisabled: i,
        isQueryError: l,
        isLoading: c,
        isSubmitting: s,
        isSurveySubmitted: u,
        surveyResponse: h,
        surveyQuestions: f,
        setResponse: _
      }
    )
  ] }) });
}, JJr = S6.styled(ar.Box)`
  [data-paste-element='ACTION_BTN'] {
    margin-bottom: 8px;
  }
`, YJr = ({ ticketId: t }) => {
  const e = s2(), r = Gn(
    (a) => a.csatSurvey.isSurveySubmitted
  ), n = [
    {
      label: "Home",
      icon: /* @__PURE__ */ R.jsx($3e, { decorative: !0 }),
      handleActionButtonClick: () => window.location.replace("/")
    },
    {
      label: "Ticket Details",
      icon: /* @__PURE__ */ R.jsx(oht, { decorative: !0 }),
      handleActionButtonClick: () => window.location.replace(`/tickets/${t}`)
    },
    {
      label: "Provide feedback on live chat",
      icon: /* @__PURE__ */ R.jsx(bW, { decorative: !0 }),
      handleActionButtonClick: () => {
        e(lKe(g2e.AGENT));
      },
      disabled: r
    }
  ];
  return /* @__PURE__ */ R.jsxs(JJr, { as: "section", children: [
    /* @__PURE__ */ R.jsx(R1.Stack, { orientation: ["vertical", "horizontal"], spacing: "space30", children: n.map(
      ({
        disabled: a,
        icon: i,
        handleActionButtonClick: o,
        label: s,
        pressed: l,
        variant: c = "secondary"
      }) => /* @__PURE__ */ R.jsx(ar.Box, { marginTop: "space30", children: /* @__PURE__ */ R.jsxs(
        zi.Button,
        {
          variant: c,
          size: "rounded_small",
          onClick: o,
          disabled: a,
          pressed: l,
          element: zJr,
          children: [
            i,
            s
          ]
        },
        s
      ) }, s)
    ) }),
    /* @__PURE__ */ R.jsx(ght, {})
  ] });
}, XJr = {
  assistantMessage: "Thanks for chatting with Twilio support! This conversation has been closed and was recorded into a ticket. You can go back to the home screen, view the transcript in the ticket details page, or provide feedback."
}, QJr = (t) => /* @__PURE__ */ R.jsxs(N3e, { role: Hv.Assistant, children: [
  /* @__PURE__ */ R.jsx(pf.Text, { as: "p", children: XJr.assistantMessage }),
  /* @__PURE__ */ R.jsx(ar.Box, { marginTop: "space60", children: /* @__PURE__ */ R.jsx(YJr, { ...t }) })
] }), eYr = 60;
function tYr(t) {
  const e = t / eYr;
  return Math.trunc(e);
}
var _ie = {};
const rYr = /* @__PURE__ */ aa(uGt);
var LDe;
function nYr() {
  return LDe || (LDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = rYr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(_ie)), _ie;
}
var Q9 = /* @__PURE__ */ nYr();
const pN = {
  waitMessages: {
    heading: "Connecting you with a live agent...",
    headingForTransferToQueue: (t) => `Connecting you with a live agent from ${VVr(
      t
    )}...`,
    estimatedMinutes: (t) => `Your estimated wait time for this live chat is ${t > 1 ? `${t} min` : "less than a minute"}.`,
    nextInLine: "You're next in line!"
  }
};
var vht = /* @__PURE__ */ ((t) => (t.Queue = "queue", t.Agent = "agent", t))(vht || {});
const aYr = 1, yht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `SMSIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[SMSIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M8.693 2.693A2.367 2.367 0 0110.367 2h5.263A2.37 2.37 0 0118 4.367v1.866a2.37 2.37 0 01-.697 1.674c-.258.259-.588.403-.896.484a3.6 3.6 0 01-.907.109h-.261l-2.388 2.356A.5.5 0 0112 10.5v-2h-1.633c-.548 0-1.186-.105-1.674-.593A2.367 2.367 0 018 6.233V4.367c0-.628.25-1.23.693-1.674zM10.367 3A1.367 1.367 0 009 4.367v1.866c0 .363.144.71.4.967.212.212.525.3.967.3H12.5a.5.5 0 01.5.5v1.304l1.682-1.66a.5.5 0 01.351-.144h.467c.218 0 .448-.022.651-.075.207-.055.354-.134.445-.225A1.37 1.37 0 0017 6.233V4.367A1.37 1.37 0 0015.63 3h-5.263zM6.2 3h.3a.5.5 0 010 1h-.3c-.373 0-.654.093-.846.285A1.203 1.203 0 005 5.134V14.8A1.203 1.203 0 006.2 16h3.567c.328 0 .661-.133.88-.351.226-.226.353-.532.353-.849V13a.5.5 0 011 0v1.8c0 .585-.235 1.144-.646 1.556A2.275 2.275 0 019.767 17H6.2A2.202 2.202 0 014 14.8V5.134c0-.585.235-1.144.646-1.556C5.092 3.132 5.672 3 6.2 3zm1.3 11a.5.5 0 000 1h1a.5.5 0 000-1h-1z" })));
});
yht.displayName = "SMSIcon";
var kie = {};
const iYr = /* @__PURE__ */ aa(Qvr);
var jDe;
function oYr() {
  return jDe || (jDe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = iYr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(kie)), kie;
}
var bht = /* @__PURE__ */ oYr();
const sYr = ({
  children: t,
  heading: e,
  headingIcon: r,
  inactive: n = !1
}) => /* @__PURE__ */ R.jsxs(
  ar.Box,
  {
    backgroundColor: n ? "colorBackgroundWeak" : void 0,
    borderColor: "colorBorderWeaker",
    borderRadius: "borderRadius20",
    borderStyle: "solid",
    borderWidth: "borderWidth10",
    padding: "space60",
    flexGrow: 1,
    children: [
      /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", marginBottom: "space30", children: [
        r,
        /* @__PURE__ */ R.jsx(
          pf.Text,
          {
            as: "p",
            marginLeft: "space20",
            fontSize: "fontSize40",
            fontWeight: "fontWeightBold",
            children: e
          }
        )
      ] }),
      /* @__PURE__ */ R.jsx(bht.Separator, { orientation: "horizontal" }),
      /* @__PURE__ */ R.jsx(ar.Box, { marginTop: "space40", children: t })
    ]
  }
), lYr = {
  actionButton: {
    label: "Get started"
  }
}, mN = {
  modal: {
    header: "Are you sure you want to end this chat?",
    body: "By submitting a ticket, you will be ending this live chat. You cannot undo this action.",
    actions: {
      confirm: "Confirm",
      close: "Close"
    }
  }
}, cYr = (t) => {
  const e = W5(), { setIsModalOpen: r, isModalOpen: n, submitTicketParams: a } = t, { requestTransformer: i } = Ja(), o = "submit-ticket-modal-heading", s = () => r(!1), l = async () => {
    s(), await Vo.endLiveChat({ requestTransformer: i }), e(`/submit?${a}`);
  };
  return /* @__PURE__ */ R.jsxs(
    _s.Modal,
    {
      ariaLabelledby: o,
      isOpen: n,
      onDismiss: s,
      size: "default",
      children: [
        /* @__PURE__ */ R.jsx(_s.ModalHeader, { children: /* @__PURE__ */ R.jsx(_s.ModalHeading, { as: "h3", id: o, children: mN.modal.header }) }),
        /* @__PURE__ */ R.jsx(_s.ModalBody, { children: /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: mN.modal.body }) }),
        /* @__PURE__ */ R.jsx(_s.ModalFooter, { children: /* @__PURE__ */ R.jsxs(_s.ModalFooterActions, { children: [
          /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: s, children: mN.modal.actions.close }),
          /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", onClick: l, children: mN.modal.actions.confirm })
        ] }) })
      ]
    }
  );
}, I$ = {
  action: {
    formDescription: "Please verify that this is the correct phone number to text you.  By clicking 'Submit', you agree to receive a text message when you are next in line for live chat support.",
    notificationRequested: (t) => `We will send you a text message at ${t} when you are next in line.  Feel free to continue waiting or come back after you receive a text.`,
    requestSubmittedCTA: "Request submitted"
  },
  notificationUnreachable: "We could not reach you at the provided number. Sorry for the inconvenience."
}, uYr = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function xht(t, e) {
  var r = Array.prototype.slice.call(e);
  return r.push(uYr), t.apply(this, r);
}
function FDe(t, e) {
  t = t.split("-"), e = e.split("-");
  for (var r = t[0].split("."), n = e[0].split("."), a = 0; a < 3; a++) {
    var i = Number(r[a]), o = Number(n[a]);
    if (i > o) return 1;
    if (o > i) return -1;
    if (!isNaN(i) && isNaN(o)) return 1;
    if (isNaN(i) && !isNaN(o)) return -1;
  }
  return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
}
var dYr = {}.constructor;
function Ub(t) {
  return t != null && t.constructor === dYr;
}
function sfe(t) {
  "@babel/helpers - typeof";
  return sfe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, sfe(t);
}
function EH(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function fYr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function IH(t, e, r) {
  return e && fYr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var hYr = "1.2.0", pYr = "1.7.35", zDe = " ext. ", mYr = /^\d+$/, Hu = /* @__PURE__ */ function() {
  function t(e) {
    EH(this, t), Cht(e), this.metadata = e, wht.call(this, e);
  }
  return IH(t, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(r) {
        return r !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(r) {
      return this.metadata.countries[r];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(r) {
      return this.getCountryMetadata(r) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(r) {
      if (this.getCountryCodesForCallingCode(r))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[r])
          return !0;
      } else {
        var n = this.countryCallingCodes()[r];
        if (n && n.length === 1 && n[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(r) {
      return this.nonGeographic() ? !!this.nonGeographic()[r] : !this.getCountryCodesForCallingCode(r);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(r, n) {
      if (r && mYr.test(r) && (n = r, r = null), r && r !== "001") {
        if (!this.hasCountry(r))
          throw new Error("Unknown country: ".concat(r));
        this.numberingPlan = new GDe(this.getCountryMetadata(r), this);
      } else if (n) {
        if (!this.hasCallingCode(n))
          throw new Error("Unknown calling code: ".concat(n));
        this.numberingPlan = new GDe(this.getNumberingPlanMetadata(n), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(r) {
      var n = this.countryCallingCodes()[r];
      if (n)
        return n.length === 1 && n[0].length === 3 ? void 0 : n;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(r) {
      var n = this.getCountryCodesForCallingCode(r);
      if (n)
        return n[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(r) {
      var n = this.getCountryCodeForCallingCode(r);
      if (n)
        return this.getCountryMetadata(n);
      if (this.nonGeographic()) {
        var a = this.nonGeographic()[r];
        if (a)
          return a;
      } else {
        var i = this.countryCallingCodes()[r];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(r) {
      return this.numberingPlan.type(r);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(r) {
      return this.selectNumberingPlan(r);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), t;
}(), GDe = /* @__PURE__ */ function() {
  function t(e, r) {
    EH(this, t), this.globalMetadataObject = r, this.metadata = e, wht.call(this, r.metadata);
  }
  return IH(t, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(r) {
      return r[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var r = this, n = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return n.map(function(a) {
        return new gYr(a, r);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(r) {
      return r[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(r) {
      if (this.hasTypes() && WDe(this.types(), r))
        return new yYr(WDe(this.types(), r), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? zDe : this.metadata[13] || zDe;
    }
  }]), t;
}(), gYr = /* @__PURE__ */ function() {
  function t(e, r) {
    EH(this, t), this._format = e, this.metadata = r;
  }
  return IH(t, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !vYr.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), t;
}(), vYr = /^\(?\$1\)?$/, yYr = /* @__PURE__ */ function() {
  function t(e, r) {
    EH(this, t), this.type = e, this.metadata = r;
  }
  return IH(t, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), t;
}();
function WDe(t, e) {
  switch (e) {
    case "FIXED_LINE":
      return t[0];
    case "MOBILE":
      return t[1];
    case "TOLL_FREE":
      return t[2];
    case "PREMIUM_RATE":
      return t[3];
    case "PERSONAL_NUMBER":
      return t[4];
    case "VOICEMAIL":
      return t[5];
    case "UAN":
      return t[6];
    case "PAGER":
      return t[7];
    case "VOIP":
      return t[8];
    case "SHARED_COST":
      return t[9];
  }
}
function Cht(t) {
  if (!t)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Ub(t) || !Ub(t.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Ub(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + bYr(t) + ": " + t, "."));
}
var bYr = function(e) {
  return sfe(e);
};
function j3e(t, e) {
  if (e = new Hu(e), e.hasCountry(t))
    return e.country(t).countryCallingCode();
  throw new Error("Unknown country: ".concat(t));
}
function xYr(t, e) {
  return e.countries.hasOwnProperty(t);
}
function wht(t) {
  var e = t.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? FDe(e, hYr) === -1 ? this.v2 = !0 : FDe(e, pYr) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function F3e(t, e) {
  return CYr(t, void 0, e);
}
function CYr(t, e, r) {
  var n = r.type(e), a = n && n.possibleLengths() || r.possibleLengths();
  if (!a)
    return "IS_POSSIBLE";
  var i = t.length, o = a[0];
  return o === i ? "IS_POSSIBLE" : o > i ? "TOO_SHORT" : a[a.length - 1] < i ? "TOO_LONG" : a.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function wYr(t, e, r) {
  if (e === void 0 && (e = {}), r = new Hu(r), e.v2) {
    if (!t.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(t.countryCallingCode);
  } else {
    if (!t.phone)
      return !1;
    if (t.country) {
      if (!r.hasCountry(t.country))
        throw new Error("Unknown country: ".concat(t.country));
      r.country(t.country);
    } else {
      if (!t.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(t.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return Sht(t.phone || t.nationalNumber, r);
  if (t.countryCallingCode && r.isNonGeographicCallingCode(t.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Sht(t, e) {
  switch (F3e(t, e)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function ng(t, e) {
  return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
}
function SYr(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = _Yr(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _Yr(t, e) {
  if (t) {
    if (typeof t == "string") return HDe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return HDe(t, e);
  }
}
function HDe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
var kYr = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function z3e(t, e, r) {
  if (e = e || {}, !(!t.country && !t.countryCallingCode)) {
    r = new Hu(r), r.selectNumberingPlan(t.country, t.countryCallingCode);
    var n = e.v2 ? t.nationalNumber : t.phone;
    if (ng(n, r.nationalNumberPattern())) {
      if (Aie(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || Aie(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var a = SYr(kYr), i; !(i = a()).done; ) {
        var o = i.value;
        if (Aie(n, o, r))
          return o;
      }
    }
  }
}
function Aie(t, e, r) {
  return e = r.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0 ? !1 : ng(t, e.pattern());
}
function AYr(t, e, r) {
  if (e = e || {}, r = new Hu(r), r.selectNumberingPlan(t.country, t.countryCallingCode), r.hasTypes())
    return z3e(t, e, r.metadata) !== void 0;
  var n = e.v2 ? t.nationalNumber : t.phone;
  return ng(n, r.nationalNumberPattern());
}
function TYr(t, e, r) {
  var n = new Hu(r), a = n.getCountryCodesForCallingCode(t);
  return a ? a.filter(function(i) {
    return EYr(e, i, r);
  }) : [];
}
function EYr(t, e, r) {
  var n = new Hu(r);
  return n.selectNumberingPlan(e), n.numberingPlan.possibleLengths().indexOf(t.length) >= 0;
}
var G3e = 2, IYr = 17, MYr = 3, X1 = "0-9０-９٠-٩۰-۹", PYr = "-‐-―−ー－", RYr = "／/", OYr = "．.", BYr = "  ­​⁠　", NYr = "()（）［］\\[\\]", $Yr = "~⁓∼～", AF = "".concat(PYr).concat(RYr).concat(OYr).concat(BYr).concat(NYr).concat($Yr), W3e = "+＋", DYr = new RegExp("([" + X1 + "])");
function LYr(t, e, r, n) {
  if (e) {
    var a = new Hu(n);
    a.selectNumberingPlan(e, r);
    var i = new RegExp(a.IDDPrefix());
    if (t.search(i) === 0) {
      t = t.slice(t.match(i)[0].length);
      var o = t.match(DYr);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return t;
    }
  }
}
function jYr(t, e) {
  if (t && e.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(t);
    if (n) {
      var a, i, o = n.length - 1, s = o > 0 && n[o];
      if (e.nationalPrefixTransformRule() && s)
        a = t.replace(r, e.nationalPrefixTransformRule()), o > 1 && (i = n[1]);
      else {
        var l = n[0];
        a = t.slice(l.length), s && (i = n[1]);
      }
      var c;
      if (s) {
        var u = t.indexOf(n[1]), f = t.slice(0, u);
        f === e.numberingPlan.nationalPrefix() && (c = e.numberingPlan.nationalPrefix());
      } else
        c = n[0];
      return {
        nationalNumber: a,
        nationalPrefix: c,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: t
  };
}
function lfe(t, e) {
  var r = jYr(t, e), n = r.carrierCode, a = r.nationalNumber;
  if (a !== t) {
    if (!FYr(t, a, e))
      return {
        nationalNumber: t
      };
    if (e.possibleLengths() && !zYr(a, e))
      return {
        nationalNumber: t
      };
  }
  return {
    nationalNumber: a,
    carrierCode: n
  };
}
function FYr(t, e, r) {
  return !(ng(t, r.nationalNumberPattern()) && !ng(e, r.nationalNumberPattern()));
}
function zYr(t, e) {
  switch (F3e(t, e)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function GYr(t, e, r, n) {
  var a = e ? j3e(e, n) : r;
  if (t.indexOf(a) === 0) {
    n = new Hu(n), n.selectNumberingPlan(e, r);
    var i = t.slice(a.length), o = lfe(i, n), s = o.nationalNumber, l = lfe(t, n), c = l.nationalNumber;
    if (!ng(c, n.nationalNumberPattern()) && ng(s, n.nationalNumberPattern()) || F3e(c, n) === "TOO_LONG")
      return {
        countryCallingCode: a,
        number: i
      };
  }
  return {
    number: t
  };
}
function _ht(t, e, r, n) {
  if (!t)
    return {};
  var a;
  if (t[0] !== "+") {
    var i = LYr(t, e, r, n);
    if (i && i !== t)
      a = !0, t = "+" + i;
    else {
      if (e || r) {
        var o = GYr(t, e, r, n), s = o.countryCallingCode, l = o.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: t
      };
    }
  }
  if (t[1] === "0")
    return {};
  n = new Hu(n);
  for (var c = 2; c - 1 <= MYr && c <= t.length; ) {
    var u = t.slice(1, c);
    if (n.hasCallingCode(u))
      return n.selectNumberingPlan(u), {
        countryCallingCodeSource: a ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: t.slice(c)
      };
    c++;
  }
  return {};
}
function WYr(t) {
  return t.replace(new RegExp("[".concat(AF, "]+"), "g"), " ").trim();
}
var HYr = /(\$\d)/;
function UYr(t, e, r) {
  var n = r.useInternationalFormat, a = r.withNationalPrefix, i = t.replace(new RegExp(e.pattern()), n ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    a && e.nationalPrefixFormattingRule() ? e.format().replace(HYr, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return n ? WYr(i) : i;
}
var VYr = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function qYr(t, e, r) {
  var n = new Hu(r);
  if (n.selectNumberingPlan(t, e), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (VYr.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var KYr = ";ext=", l9 = function(e) {
  return "([".concat(X1, "]{1,").concat(e, "})");
};
function kht(t) {
  var e = "20", r = "15", n = "9", a = "6", i = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", f = "[  \\t]*", h = "(?:,{2}|;)", p = KYr + l9(e), g = i + l + o + l9(e) + s, y = i + c + o + l9(n) + s, b = u + l9(a) + "#", w = f + h + o + l9(r) + s, _ = f + "(?:,)+" + o + l9(n) + s;
  return p + "|" + g + "|" + y + "|" + b + "|" + w + "|" + _;
}
var ZYr = "[" + X1 + "]{" + G3e + "}", JYr = "[" + W3e + "]{0,1}(?:[" + AF + "]*[" + X1 + "]){3,}[" + AF + X1 + "]*", YYr = new RegExp("^[" + W3e + "]{0,1}(?:[" + AF + "]*[" + X1 + "]){1,2}$", "i"), XYr = JYr + // Phone number extensions
"(?:" + kht() + ")?", QYr = new RegExp(
  // Either a short two-digit-only phone number
  "^" + ZYr + "$|^" + XYr + "$",
  "i"
);
function eXr(t) {
  return t.length >= G3e && QYr.test(t);
}
function tXr(t) {
  return YYr.test(t);
}
function rXr(t) {
  var e = t.number, r = t.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(r ? ";ext=" + r : "");
}
function nXr(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = aXr(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aXr(t, e) {
  if (t) {
    if (typeof t == "string") return UDe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return UDe(t, e);
  }
}
function UDe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function VDe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qDe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? VDe(Object(r), !0).forEach(function(n) {
      iXr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : VDe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function iXr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var KDe = {
  formatExtension: function(e, r, n) {
    return "".concat(e).concat(n.ext()).concat(r);
  }
};
function Aht(t, e, r, n) {
  if (r ? r = qDe(qDe({}, KDe), r) : r = KDe, n = new Hu(n), t.country && t.country !== "001") {
    if (!n.hasCountry(t.country))
      throw new Error("Unknown country: ".concat(t.country));
    n.country(t.country);
  } else if (t.countryCallingCode)
    n.selectNumberingPlan(t.countryCallingCode);
  else return t.phone || "";
  var a = n.countryCallingCode(), i = r.v2 ? t.nationalNumber : t.phone, o;
  switch (e) {
    case "NATIONAL":
      return i ? (o = TF(i, t.carrierCode, "NATIONAL", n, r), Tie(o, t.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (o = TF(i, null, "INTERNATIONAL", n, r), o = "+".concat(a, " ").concat(o), Tie(o, t.ext, n, r.formatExtension)) : "+".concat(a);
    case "E.164":
      return "+".concat(a).concat(i);
    case "RFC3966":
      return rXr({
        number: "+".concat(a).concat(i),
        ext: t.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var s = sXr(i, t.carrierCode, a, r.fromCountry, n);
      return Tie(s, t.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function TF(t, e, r, n, a) {
  var i = oXr(n.formats(), t);
  return i ? UYr(t, i, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && a && a.nationalPrefix === !1)
  }) : t;
}
function oXr(t, e) {
  for (var r = nXr(t), n; !(n = r()).done; ) {
    var a = n.value;
    if (a.leadingDigitsPatterns().length > 0) {
      var i = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
      if (e.search(i) !== 0)
        continue;
    }
    if (ng(e, a.pattern()))
      return a;
  }
}
function Tie(t, e, r, n) {
  return e ? n(t, e, r) : t;
}
function sXr(t, e, r, n, a) {
  var i = j3e(n, a.metadata);
  if (i === r) {
    var o = TF(t, e, "NATIONAL", a);
    return r === "1" ? r + " " + o : o;
  }
  var s = qYr(n, void 0, a.metadata);
  if (s)
    return "".concat(s, " ").concat(r, " ").concat(TF(t, null, "INTERNATIONAL", a));
}
function ZDe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function JDe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ZDe(Object(r), !0).forEach(function(n) {
      lXr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ZDe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function lXr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function cXr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function uXr(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function dXr(t, e, r) {
  return e && uXr(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var fXr = /* @__PURE__ */ function() {
  function t(e, r, n) {
    if (cXr(this, t), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (typeof e == "string") {
      if (e[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (Ub(r) && Ub(r.countries)) {
        n = r;
        var a = e;
        if (!mXr.test(a))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var i = _ht(a, void 0, void 0, n), o = i.countryCallingCode, s = i.number;
        if (r = s, e = o, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Cht(n);
    var l = pXr(e, n), c = l.country, u = l.countryCallingCode;
    this.country = c, this.countryCallingCode = u, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return dXr(t, [{
    key: "setExt",
    value: function(r) {
      this.ext = r;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : TYr(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return wYr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return AYr(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var r = new Hu(this.getMetadata());
      return r.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(r) {
      return this.number === r.number && this.ext === r.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return z3e(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(r, n) {
      return Aht(this, r, n ? JDe(JDe({}, n), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(r) {
      return this.format("NATIONAL", r);
    }
  }, {
    key: "formatInternational",
    value: function(r) {
      return this.format("INTERNATIONAL", r);
    }
  }, {
    key: "getURI",
    value: function(r) {
      return this.format("RFC3966", r);
    }
  }]), t;
}(), hXr = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function pXr(t, e) {
  var r, n, a = new Hu(e);
  return hXr(t) ? (r = t, a.selectNumberingPlan(r), n = a.countryCallingCode()) : n = t, {
    country: r,
    countryCallingCode: n
  };
}
var mXr = /^\+\d+$/;
function cfe(t) {
  "@babel/helpers - typeof";
  return cfe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, cfe(t);
}
function gXr(t, e, r) {
  return Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function vXr(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function yXr(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && oI(t, e);
}
function bXr(t) {
  var e = Eht();
  return function() {
    var n = sI(t), a;
    if (e) {
      var i = sI(this).constructor;
      a = Reflect.construct(n, arguments, i);
    } else
      a = n.apply(this, arguments);
    return xXr(this, a);
  };
}
function xXr(t, e) {
  if (e && (cfe(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Tht(t);
}
function Tht(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ufe(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ufe = function(n) {
    if (n === null || !CXr(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n)) return e.get(n);
      e.set(n, a);
    }
    function a() {
      return M$(n, arguments, sI(this).constructor);
    }
    return a.prototype = Object.create(n.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), oI(a, n);
  }, ufe(t);
}
function M$(t, e, r) {
  return Eht() ? M$ = Reflect.construct : M$ = function(a, i, o) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(a, s), c = new l();
    return o && oI(c, o.prototype), c;
  }, M$.apply(null, arguments);
}
function Eht() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function CXr(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function oI(t, e) {
  return oI = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, oI(t, e);
}
function sI(t) {
  return sI = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, sI(t);
}
var fm = /* @__PURE__ */ function(t) {
  yXr(r, t);
  var e = bXr(r);
  function r(n) {
    var a;
    return vXr(this, r), a = e.call(this, n), Object.setPrototypeOf(Tht(a), r.prototype), a.name = a.constructor.name, a;
  }
  return gXr(r);
}(/* @__PURE__ */ ufe(Error)), YDe = new RegExp("(?:" + kht() + ")$", "i");
function wXr(t) {
  var e = t.search(YDe);
  if (e < 0)
    return {};
  for (var r = t.slice(0, e), n = t.match(YDe), a = 1; a < n.length; ) {
    if (n[a])
      return {
        number: r,
        ext: n[a]
      };
    a++;
  }
}
var SXr = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function _Xr(t) {
  return SXr[t];
}
function kXr(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = AXr(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AXr(t, e) {
  if (t) {
    if (typeof t == "string") return XDe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return XDe(t, e);
  }
}
function XDe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function QDe(t) {
  for (var e = "", r = kXr(t.split("")), n; !(n = r()).done; ) {
    var a = n.value;
    e += TXr(a, e) || "";
  }
  return e;
}
function TXr(t, e, r) {
  return t === "+" ? e ? void 0 : "+" : _Xr(t);
}
function EXr(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r) return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = IXr(t)) || e) {
    r && (t = r);
    var n = 0;
    return function() {
      return n >= t.length ? { done: !0 } : { done: !1, value: t[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function IXr(t, e) {
  if (t) {
    if (typeof t == "string") return eLe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return eLe(t, e);
  }
}
function eLe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function MXr(t, e) {
  var r = e.countries, n = e.metadata;
  n = new Hu(n);
  for (var a = EXr(r), i; !(i = a()).done; ) {
    var o = i.value;
    if (n.country(o), n.leadingDigits()) {
      if (t && t.search(n.leadingDigits()) === 0)
        return o;
    } else if (z3e({
      phone: t,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function PXr(t, e) {
  var r = e.nationalNumber, n = e.metadata, a = n.getCountryCodesForCallingCode(t);
  if (a)
    return a.length === 1 ? a[0] : MXr(r, {
      countries: a,
      metadata: n.metadata
    });
}
var Iht = "+", RXr = "[\\-\\.\\(\\)]?", tLe = "([" + X1 + "]|" + RXr + ")", OXr = "^\\" + Iht + tLe + "*[" + X1 + "]" + tLe + "*$", BXr = new RegExp(OXr, "g"), dfe = X1, NXr = "[" + dfe + "]+((\\-)*[" + dfe + "])*", $Xr = "a-zA-Z", DXr = "[" + $Xr + "]+((\\-)*[" + dfe + "])*", LXr = "^(" + NXr + "\\.)*" + DXr + "\\.?$", jXr = new RegExp(LXr, "g"), rLe = "tel:", ffe = ";phone-context=", FXr = ";isub=";
function zXr(t) {
  var e = t.indexOf(ffe);
  if (e < 0)
    return null;
  var r = e + ffe.length;
  if (r >= t.length)
    return "";
  var n = t.indexOf(";", r);
  return n >= 0 ? t.substring(r, n) : t.substring(r);
}
function GXr(t) {
  return t === null ? !0 : t.length === 0 ? !1 : BXr.test(t) || jXr.test(t);
}
function WXr(t, e) {
  var r = e.extractFormattedPhoneNumber, n = zXr(t);
  if (!GXr(n))
    throw new fm("NOT_A_NUMBER");
  var a;
  if (n === null)
    a = r(t) || "";
  else {
    a = "", n.charAt(0) === Iht && (a += n);
    var i = t.indexOf(rLe), o;
    i >= 0 ? o = i + rLe.length : o = 0;
    var s = t.indexOf(ffe);
    a += t.substring(o, s);
  }
  var l = a.indexOf(FXr);
  if (l > 0 && (a = a.substring(0, l)), a !== "")
    return a;
}
var HXr = 250, UXr = new RegExp("[" + W3e + X1 + "]"), VXr = new RegExp("[^" + X1 + "#]+$");
function hfe(t, e, r) {
  if (e = e || {}, r = new Hu(r), e.defaultCountry && !r.hasCountry(e.defaultCountry))
    throw e.v2 ? new fm("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var n = KXr(t, e.v2, e.extract), a = n.number, i = n.ext, o = n.error;
  if (!a) {
    if (e.v2)
      throw o === "TOO_SHORT" ? new fm("TOO_SHORT") : new fm("NOT_A_NUMBER");
    return {};
  }
  var s = JXr(a, e.defaultCountry, e.defaultCallingCode, r), l = s.country, c = s.nationalNumber, u = s.countryCallingCode, f = s.countryCallingCodeSource, h = s.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new fm("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < G3e) {
    if (e.v2)
      throw new fm("TOO_SHORT");
    return {};
  }
  if (c.length > IYr) {
    if (e.v2)
      throw new fm("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var p = new fXr(u, c, r.metadata);
    return l && (p.country = l), h && (p.carrierCode = h), i && (p.ext = i), p.__countryCallingCodeSource = f, p;
  }
  var g = (e.extended ? r.hasSelectedNumberingPlan() : l) ? ng(c, r.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: h,
    valid: g,
    possible: g ? !0 : !!(e.extended === !0 && r.possibleLengths() && Sht(c, r)),
    phone: c,
    ext: i
  } : g ? ZXr(l, c, i) : {};
}
function qXr(t, e, r) {
  if (t) {
    if (t.length > HXr) {
      if (r)
        throw new fm("TOO_LONG");
      return;
    }
    if (e === !1)
      return t;
    var n = t.search(UXr);
    if (!(n < 0))
      return t.slice(n).replace(VXr, "");
  }
}
function KXr(t, e, r) {
  var n = WXr(t, {
    extractFormattedPhoneNumber: function(o) {
      return qXr(o, r, e);
    }
  });
  if (!n)
    return {};
  if (!eXr(n))
    return tXr(n) ? {
      error: "TOO_SHORT"
    } : {};
  var a = wXr(n);
  return a.ext ? a : {
    number: n
  };
}
function ZXr(t, e, r) {
  var n = {
    country: t,
    phone: e
  };
  return r && (n.ext = r), n;
}
function JXr(t, e, r, n) {
  var a = _ht(QDe(t), e, r, n.metadata), i = a.countryCallingCodeSource, o = a.countryCallingCode, s = a.number, l;
  if (o)
    n.selectNumberingPlan(o);
  else if (s && (e || r))
    n.selectNumberingPlan(e, r), e && (l = e), o = r || j3e(e, n.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: o
    };
  var c = lfe(QDe(s), n), u = c.nationalNumber, f = c.carrierCode, h = PXr(o, {
    nationalNumber: u,
    metadata: n
  });
  return h && (l = h, h === "001" || n.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: i,
    nationalNumber: u,
    carrierCode: f
  };
}
function nLe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function aLe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nLe(Object(r), !0).forEach(function(n) {
      YXr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : nLe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function YXr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function XXr(t, e, r) {
  return hfe(t, aLe(aLe({}, e), {}, {
    v2: !0
  }), r);
}
function iLe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function QXr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? iLe(Object(r), !0).forEach(function(n) {
      eQr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : iLe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function eQr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function tQr(t, e) {
  return iQr(t) || aQr(t, e) || nQr(t, e) || rQr();
}
function rQr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nQr(t, e) {
  if (t) {
    if (typeof t == "string") return oLe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return oLe(t, e);
  }
}
function oLe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function aQr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, s;
    try {
      for (r = r.call(t); !(a = (o = r.next()).done) && (n.push(o.value), !(e && n.length === e)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
    return n;
  }
}
function iQr(t) {
  if (Array.isArray(t)) return t;
}
function oQr(t) {
  var e = Array.prototype.slice.call(t), r = tQr(e, 4), n = r[0], a = r[1], i = r[2], o = r[3], s, l, c;
  if (typeof n == "string")
    s = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    o ? (l = i, c = o) : (l = void 0, c = i), a && (l = QXr({
      defaultCountry: a
    }, l));
  else if (Ub(a))
    i ? (l = a, c = i) : c = a;
  else throw new Error("Invalid second argument: ".concat(a));
  return {
    text: s,
    options: l,
    metadata: c
  };
}
function sLe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function lLe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? sLe(Object(r), !0).forEach(function(n) {
      sQr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : sLe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function sQr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function lQr(t, e, r) {
  e && e.defaultCountry && !xYr(e.defaultCountry, r) && (e = lLe(lLe({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return XXr(t, e, r);
  } catch (n) {
    if (!(n instanceof fm)) throw n;
  }
}
function cLe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function uLe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cLe(Object(r), !0).forEach(function(n) {
      cQr(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : cLe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function cQr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function uQr() {
  var t = oQr(arguments), e = t.text, r = t.options, n = t.metadata;
  r = uLe(uLe({}, r), {}, {
    extract: !1
  });
  var a = lQr(e, r, n);
  return a && a.isValid() || !1;
}
function dQr() {
  return xht(uQr, arguments);
}
function fQr(t, e) {
  return gQr(t) || mQr(t, e) || pQr(t, e) || hQr();
}
function hQr() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pQr(t, e) {
  if (t) {
    if (typeof t == "string") return dLe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dLe(t, e);
  }
}
function dLe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++)
    n[r] = t[r];
  return n;
}
function mQr(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, o, s;
    try {
      for (r = r.call(t); !(a = (o = r.next()).done) && (n.push(o.value), !(e && n.length === e)); a = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i) throw s;
      }
    }
    return n;
  }
}
function gQr(t) {
  if (Array.isArray(t)) return t;
}
function vQr() {
  var t = yQr(arguments), e = t.input, r = t.format, n = t.options, a = t.metadata;
  return Aht(e, r, n, a);
}
function yQr(t) {
  var e = Array.prototype.slice.call(t), r = fQr(e, 5), n = r[0], a = r[1], i = r[2], o = r[3], s = r[4], l, c, u, f;
  if (typeof n == "string")
    if (typeof i == "string")
      c = i, s ? (u = o, f = s) : f = o, l = hfe(n, {
        defaultCountry: a,
        extended: !0
      }, f);
    else {
      if (typeof a != "string")
        throw new Error("`format` argument not passed to `formatNumber(number, format)`");
      c = a, o ? (u = i, f = o) : f = i, l = hfe(n, {
        extended: !0
      }, f);
    }
  else if (Ub(n))
    l = n, c = a, o ? (u = i, f = o) : f = i;
  else throw new TypeError("A phone number must either be a string or an object of shape { phone, [country] }.");
  return c === "International" ? c = "INTERNATIONAL" : c === "National" && (c = "NATIONAL"), {
    input: l,
    format: c,
    options: u,
    metadata: f
  };
}
function bQr() {
  return xht(vQr, arguments);
}
const CS = {
  label: "Phone number",
  actions: {
    cancel: "Cancel",
    submit: "Submit"
  },
  errors: {
    invalidPhone: "Please enter a valid phone number"
  }
}, H3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronDownIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronDownIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.293 8.293a1 1 0 011.32-.083l.094.083L10 10.585l2.293-2.292a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-3 3a1 1 0 01-1.32.083l-.094-.083-3-3a1 1 0 010-1.414z" })));
});
H3e.displayName = "ChevronDownIcon";
const P$ = [
  {
    country: "Afghanistan",
    countryCodes: ["93"],
    isoCode2: "AF"
  },
  {
    country: "Albania",
    countryCodes: ["355"],
    isoCode2: "AL"
  },
  {
    country: "Algeria",
    countryCodes: ["213"],
    isoCode2: "DZ"
  },
  {
    country: "American Samoa",
    countryCodes: ["1-684"],
    isoCode2: "AS"
  },
  {
    country: "Andorra",
    countryCodes: ["376"],
    isoCode2: "AD"
  },
  {
    country: "Angola",
    countryCodes: ["244"],
    isoCode2: "AO"
  },
  {
    country: "Anguilla",
    countryCodes: ["1-264"],
    isoCode2: "AI"
  },
  {
    country: "Antarctica",
    countryCodes: ["672"],
    isoCode2: "AQ"
  },
  {
    country: "Antigua and Barbuda",
    countryCodes: ["1-268"],
    isoCode2: "AG"
  },
  {
    country: "Argentina",
    countryCodes: ["54"],
    isoCode2: "AR"
  },
  {
    country: "Armenia",
    countryCodes: ["374"],
    isoCode2: "AM"
  },
  {
    country: "Aruba",
    countryCodes: ["297"],
    isoCode2: "AW"
  },
  {
    country: "Australia",
    countryCodes: ["61"],
    isoCode2: "AU"
  },
  {
    country: "Austria",
    countryCodes: ["43"],
    isoCode2: "AT"
  },
  {
    country: "Azerbaijan",
    countryCodes: ["994"],
    isoCode2: "AZ"
  },
  {
    country: "Bahamas",
    countryCodes: ["1-242"],
    isoCode2: "BS"
  },
  {
    country: "Bahrain",
    countryCodes: ["973"],
    isoCode2: "BH"
  },
  {
    country: "Bangladesh",
    countryCodes: ["880"],
    isoCode2: "BD"
  },
  {
    country: "Barbados",
    countryCodes: ["1-246"],
    isoCode2: "BB"
  },
  {
    country: "Belarus",
    countryCodes: ["375"],
    isoCode2: "BY"
  },
  {
    country: "Belgium",
    countryCodes: ["32"],
    isoCode2: "BE"
  },
  {
    country: "Belize",
    countryCodes: ["501"],
    isoCode2: "BZ"
  },
  {
    country: "Benin",
    countryCodes: ["229"],
    isoCode2: "BJ"
  },
  {
    country: "Bermuda",
    countryCodes: ["1-441"],
    isoCode2: "BM"
  },
  {
    country: "Bhutan",
    countryCodes: ["975"],
    isoCode2: "BT"
  },
  {
    country: "Bolivia",
    countryCodes: ["591"],
    isoCode2: "BO"
  },
  {
    country: "Bosnia and Herzegovina",
    countryCodes: ["387"],
    isoCode2: "BA"
  },
  {
    country: "Botswana",
    countryCodes: ["267"],
    isoCode2: "BW"
  },
  {
    country: "Brazil",
    countryCodes: ["55"],
    isoCode2: "BR"
  },
  {
    country: "British Indian Ocean Territory",
    countryCodes: ["246"],
    isoCode2: "IO"
  },
  {
    country: "British Virgin Islands",
    countryCodes: ["1-284"],
    isoCode2: "VG"
  },
  {
    country: "Brunei",
    countryCodes: ["673"],
    isoCode2: "BN"
  },
  {
    country: "Bulgaria",
    countryCodes: ["359"],
    isoCode2: "BG"
  },
  {
    country: "Burkina Faso",
    countryCodes: ["226"],
    isoCode2: "BF"
  },
  {
    country: "Burundi",
    countryCodes: ["257"],
    isoCode2: "BI"
  },
  {
    country: "Cambodia",
    countryCodes: ["855"],
    isoCode2: "KH"
  },
  {
    country: "Cameroon",
    countryCodes: ["237"],
    isoCode2: "CM"
  },
  {
    country: "Canada",
    countryCodes: ["1"],
    isoCode2: "CA"
  },
  {
    country: "Cape Verde",
    countryCodes: ["238"],
    isoCode2: "CV"
  },
  {
    country: "Cayman Islands",
    countryCodes: ["1-345"],
    isoCode2: "KY"
  },
  {
    country: "Central African Republic",
    countryCodes: ["236"],
    isoCode2: "CF"
  },
  {
    country: "Chad",
    countryCodes: ["235"],
    isoCode2: "TD"
  },
  {
    country: "Chile",
    countryCodes: ["56"],
    isoCode2: "CL"
  },
  {
    country: "China",
    countryCodes: ["86"],
    isoCode2: "CN"
  },
  {
    country: "Christmas Island",
    countryCodes: ["61"],
    isoCode2: "CX"
  },
  {
    country: "Cocos Islands",
    countryCodes: ["61"],
    isoCode2: "CC"
  },
  {
    country: "Colombia",
    countryCodes: ["57"],
    isoCode2: "CO"
  },
  {
    country: "Comoros",
    countryCodes: ["269"],
    isoCode2: "KM"
  },
  {
    country: "Cook Islands",
    countryCodes: ["682"],
    isoCode2: "CK"
  },
  {
    country: "Costa Rica",
    countryCodes: ["506"],
    isoCode2: "CR"
  },
  {
    country: "Croatia",
    countryCodes: ["385"],
    isoCode2: "HR"
  },
  {
    country: "Cuba",
    countryCodes: ["53"],
    isoCode2: "CU"
  },
  {
    country: "Curacao",
    countryCodes: ["599"],
    isoCode2: "CW"
  },
  {
    country: "Cyprus",
    countryCodes: ["357"],
    isoCode2: "CY"
  },
  {
    country: "Czech Republic",
    countryCodes: ["420"],
    isoCode2: "CZ"
  },
  {
    country: "Democratic Republic of the Congo",
    countryCodes: ["243"],
    isoCode2: "CD"
  },
  {
    country: "Denmark",
    countryCodes: ["45"],
    isoCode2: "DK"
  },
  {
    country: "Djibouti",
    countryCodes: ["253"],
    isoCode2: "DJ"
  },
  {
    country: "Dominica",
    countryCodes: ["1-767"],
    isoCode2: "DM"
  },
  {
    country: "Dominican Republic",
    countryCodes: ["1-809", "1-829", "1-849"],
    isoCode2: "DO"
  },
  {
    country: "East Timor",
    countryCodes: ["670"],
    isoCode2: "TL"
  },
  {
    country: "Ecuador",
    countryCodes: ["593"],
    isoCode2: "EC"
  },
  {
    country: "Egypt",
    countryCodes: ["20"],
    isoCode2: "EG"
  },
  {
    country: "El Salvador",
    countryCodes: ["503"],
    isoCode2: "SV"
  },
  {
    country: "Equatorial Guinea",
    countryCodes: ["240"],
    isoCode2: "GQ"
  },
  {
    country: "Eritrea",
    countryCodes: ["291"],
    isoCode2: "ER"
  },
  {
    country: "Estonia",
    countryCodes: ["372"],
    isoCode2: "EE"
  },
  {
    country: "Ethiopia",
    countryCodes: ["251"],
    isoCode2: "ET"
  },
  {
    country: "Falkland Islands",
    countryCodes: ["500"],
    isoCode2: "FK"
  },
  {
    country: "Faroe Islands",
    countryCodes: ["298"],
    isoCode2: "FO"
  },
  {
    country: "Fiji",
    countryCodes: ["679"],
    isoCode2: "FJ"
  },
  {
    country: "Finland",
    countryCodes: ["358"],
    isoCode2: "FI"
  },
  {
    country: "France",
    countryCodes: ["33"],
    isoCode2: "FR"
  },
  {
    country: "French Polynesia",
    countryCodes: ["689"],
    isoCode2: "PF"
  },
  {
    country: "Gabon",
    countryCodes: ["241"],
    isoCode2: "GA"
  },
  {
    country: "Gambia",
    countryCodes: ["220"],
    isoCode2: "GM"
  },
  {
    country: "Georgia",
    countryCodes: ["995"],
    isoCode2: "GE"
  },
  {
    country: "Germany",
    countryCodes: ["49"],
    isoCode2: "DE"
  },
  {
    country: "Ghana",
    countryCodes: ["233"],
    isoCode2: "GH"
  },
  {
    country: "Gibraltar",
    countryCodes: ["350"],
    isoCode2: "GI"
  },
  {
    country: "Greece",
    countryCodes: ["30"],
    isoCode2: "GR"
  },
  {
    country: "Greenland",
    countryCodes: ["299"],
    isoCode2: "GL"
  },
  {
    country: "Grenada",
    countryCodes: ["1-473"],
    isoCode2: "GD"
  },
  {
    country: "Guam",
    countryCodes: ["1-671"],
    isoCode2: "GU"
  },
  {
    country: "Guatemala",
    countryCodes: ["502"],
    isoCode2: "GT"
  },
  {
    country: "Guernsey",
    countryCodes: ["44-1481"],
    isoCode2: "GG"
  },
  {
    country: "Guinea",
    countryCodes: ["224"],
    isoCode2: "GN"
  },
  {
    country: "Guinea-Bissau",
    countryCodes: ["245"],
    isoCode2: "GW"
  },
  {
    country: "Guyana",
    countryCodes: ["592"],
    isoCode2: "GY"
  },
  {
    country: "Haiti",
    countryCodes: ["509"],
    isoCode2: "HT"
  },
  {
    country: "Honduras",
    countryCodes: ["504"],
    isoCode2: "HN"
  },
  {
    country: "Hong Kong",
    countryCodes: ["852"],
    isoCode2: "HK"
  },
  {
    country: "Hungary",
    countryCodes: ["36"],
    isoCode2: "HU"
  },
  {
    country: "Iceland",
    countryCodes: ["354"],
    isoCode2: "IS"
  },
  {
    country: "India",
    countryCodes: ["91"],
    isoCode2: "IN"
  },
  {
    country: "Indonesia",
    countryCodes: ["62"],
    isoCode2: "ID"
  },
  {
    country: "Iran",
    countryCodes: ["98"],
    isoCode2: "IR"
  },
  {
    country: "Iraq",
    countryCodes: ["964"],
    isoCode2: "IQ"
  },
  {
    country: "Ireland",
    countryCodes: ["353"],
    isoCode2: "IE"
  },
  {
    country: "Isle of Man",
    countryCodes: ["44-1624"],
    isoCode2: "IM"
  },
  {
    country: "Israel",
    countryCodes: ["972"],
    isoCode2: "IL"
  },
  {
    country: "Italy",
    countryCodes: ["39"],
    isoCode2: "IT"
  },
  {
    country: "Ivory Coast",
    countryCodes: ["225"],
    isoCode2: "CI"
  },
  {
    country: "Jamaica",
    countryCodes: ["1-876"],
    isoCode2: "JM"
  },
  {
    country: "Japan",
    countryCodes: ["81"],
    isoCode2: "JP"
  },
  {
    country: "Jersey",
    countryCodes: ["44-1534"],
    isoCode2: "JE"
  },
  {
    country: "Jordan",
    countryCodes: ["962"],
    isoCode2: "JO"
  },
  {
    country: "Kazakhstan",
    countryCodes: ["7"],
    isoCode2: "KZ"
  },
  {
    country: "Kenya",
    countryCodes: ["254"],
    isoCode2: "KE"
  },
  {
    country: "Kiribati",
    countryCodes: ["686"],
    isoCode2: "KI"
  },
  {
    country: "Kosovo",
    countryCodes: ["383"],
    isoCode2: "XK"
  },
  {
    country: "Kuwait",
    countryCodes: ["965"],
    isoCode2: "KW"
  },
  {
    country: "Kyrgyzstan",
    countryCodes: ["996"],
    isoCode2: "KG"
  },
  {
    country: "Laos",
    countryCodes: ["856"],
    isoCode2: "LA"
  },
  {
    country: "Latvia",
    countryCodes: ["371"],
    isoCode2: "LV"
  },
  {
    country: "Lebanon",
    countryCodes: ["961"],
    isoCode2: "LB"
  },
  {
    country: "Lesotho",
    countryCodes: ["266"],
    isoCode2: "LS"
  },
  {
    country: "Liberia",
    countryCodes: ["231"],
    isoCode2: "LR"
  },
  {
    country: "Libya",
    countryCodes: ["218"],
    isoCode2: "LY"
  },
  {
    country: "Liechtenstein",
    countryCodes: ["423"],
    isoCode2: "LI"
  },
  {
    country: "Lithuania",
    countryCodes: ["370"],
    isoCode2: "LT"
  },
  {
    country: "Luxembourg",
    countryCodes: ["352"],
    isoCode2: "LU"
  },
  {
    country: "Macau",
    countryCodes: ["853"],
    isoCode2: "MO"
  },
  {
    country: "Macedonia",
    countryCodes: ["389"],
    isoCode2: "MK"
  },
  {
    country: "Madagascar",
    countryCodes: ["261"],
    isoCode2: "MG"
  },
  {
    country: "Malawi",
    countryCodes: ["265"],
    isoCode2: "MW"
  },
  {
    country: "Malaysia",
    countryCodes: ["60"],
    isoCode2: "MY"
  },
  {
    country: "Maldives",
    countryCodes: ["960"],
    isoCode2: "MV"
  },
  {
    country: "Mali",
    countryCodes: ["223"],
    isoCode2: "ML"
  },
  {
    country: "Malta",
    countryCodes: ["356"],
    isoCode2: "MT"
  },
  {
    country: "Marshall Islands",
    countryCodes: ["692"],
    isoCode2: "MH"
  },
  {
    country: "Mauritania",
    countryCodes: ["222"],
    isoCode2: "MR"
  },
  {
    country: "Mauritius",
    countryCodes: ["230"],
    isoCode2: "MU"
  },
  {
    country: "Mayotte",
    countryCodes: ["262"],
    isoCode2: "YT"
  },
  {
    country: "Mexico",
    countryCodes: ["52"],
    isoCode2: "MX"
  },
  {
    country: "Micronesia",
    countryCodes: ["691"],
    isoCode2: "FM"
  },
  {
    country: "Moldova",
    countryCodes: ["373"],
    isoCode2: "MD"
  },
  {
    country: "Monaco",
    countryCodes: ["377"],
    isoCode2: "MC"
  },
  {
    country: "Mongolia",
    countryCodes: ["976"],
    isoCode2: "MN"
  },
  {
    country: "Montenegro",
    countryCodes: ["382"],
    isoCode2: "ME"
  },
  {
    country: "Montserrat",
    countryCodes: ["1-664"],
    isoCode2: "MS"
  },
  {
    country: "Morocco",
    countryCodes: ["212"],
    isoCode2: "MA"
  },
  {
    country: "Mozambique",
    countryCodes: ["258"],
    isoCode2: "MZ"
  },
  {
    country: "Myanmar",
    countryCodes: ["95"],
    isoCode2: "MM"
  },
  {
    country: "Namibia",
    countryCodes: ["264"],
    isoCode2: "NA"
  },
  {
    country: "Nauru",
    countryCodes: ["674"],
    isoCode2: "NR"
  },
  {
    country: "Nepal",
    countryCodes: ["977"],
    isoCode2: "NP"
  },
  {
    country: "Netherlands",
    countryCodes: ["31"],
    isoCode2: "NL"
  },
  // {
  //   country: 'Netherlands Antilles',
  //   countryCodes: ['599'],
  //   isoCode2: 'AN', // is a valid country? if so, pending flag!
  // },
  {
    country: "New Caledonia",
    countryCodes: ["687"],
    isoCode2: "NC"
  },
  {
    country: "New Zealand",
    countryCodes: ["64"],
    isoCode2: "NZ"
  },
  {
    country: "Nicaragua",
    countryCodes: ["505"],
    isoCode2: "NI"
  },
  {
    country: "Niger",
    countryCodes: ["227"],
    isoCode2: "NE"
  },
  {
    country: "Nigeria",
    countryCodes: ["234"],
    isoCode2: "NG"
  },
  {
    country: "Niue",
    countryCodes: ["683"],
    isoCode2: "NU"
  },
  {
    country: "North Korea",
    countryCodes: ["850"],
    isoCode2: "KP"
  },
  {
    country: "Northern Mariana Islands",
    countryCodes: ["1-670"],
    isoCode2: "MP"
  },
  {
    country: "Norway",
    countryCodes: ["47"],
    isoCode2: "NO"
  },
  {
    country: "Oman",
    countryCodes: ["968"],
    isoCode2: "OM"
  },
  {
    country: "Pakistan",
    countryCodes: ["92"],
    isoCode2: "PK"
  },
  {
    country: "Palau",
    countryCodes: ["680"],
    isoCode2: "PW"
  },
  {
    country: "Palestine",
    countryCodes: ["970"],
    isoCode2: "PS"
  },
  {
    country: "Panama",
    countryCodes: ["507"],
    isoCode2: "PA"
  },
  {
    country: "Papua New Guinea",
    countryCodes: ["675"],
    isoCode2: "PG"
  },
  {
    country: "Paraguay",
    countryCodes: ["595"],
    isoCode2: "PY"
  },
  {
    country: "Peru",
    countryCodes: ["51"],
    isoCode2: "PE"
  },
  {
    country: "Philippines",
    countryCodes: ["63"],
    isoCode2: "PH"
  },
  {
    country: "Pitcairn",
    countryCodes: ["64"],
    isoCode2: "PN"
  },
  {
    country: "Poland",
    countryCodes: ["48"],
    isoCode2: "PL"
  },
  {
    country: "Portugal",
    countryCodes: ["351"],
    isoCode2: "PT"
  },
  {
    country: "Puerto Rico",
    countryCodes: ["1-787", "1-939"],
    isoCode2: "PR"
  },
  {
    country: "Qatar",
    countryCodes: ["974"],
    isoCode2: "QA"
  },
  {
    country: "Republic of the Congo",
    countryCodes: ["242"],
    isoCode2: "CG"
  },
  {
    country: "Reunion",
    countryCodes: ["262"],
    isoCode2: "RE"
  },
  {
    country: "Romania",
    countryCodes: ["40"],
    isoCode2: "RO"
  },
  {
    country: "Russia",
    countryCodes: ["7"],
    isoCode2: "RU"
  },
  {
    country: "Rwanda",
    countryCodes: ["250"],
    isoCode2: "RW"
  },
  {
    country: "Saint Barthelemy",
    countryCodes: ["590"],
    isoCode2: "BL"
  },
  {
    country: "Saint Helena",
    countryCodes: ["290"],
    isoCode2: "SH"
  },
  {
    country: "Saint Kitts and Nevis",
    countryCodes: ["1-869"],
    isoCode2: "KN"
  },
  {
    country: "Saint Lucia",
    countryCodes: ["1-758"],
    isoCode2: "LC"
  },
  {
    country: "Saint Martin",
    countryCodes: ["590"],
    isoCode2: "MF"
  },
  {
    country: "Saint Pierre and Miquelon",
    countryCodes: ["508"],
    isoCode2: "PM"
  },
  {
    country: "Saint Vincent and the Grenadines",
    countryCodes: ["1-784"],
    isoCode2: "VC"
  },
  {
    country: "Samoa",
    countryCodes: ["685"],
    isoCode2: "WS"
  },
  {
    country: "San Marino",
    countryCodes: ["378"],
    isoCode2: "SM"
  },
  {
    country: "Sao Tome and Principe",
    countryCodes: ["239"],
    isoCode2: "ST"
  },
  {
    country: "Saudi Arabia",
    countryCodes: ["966"],
    isoCode2: "SA"
  },
  {
    country: "Senegal",
    countryCodes: ["221"],
    isoCode2: "SN"
  },
  {
    country: "Serbia",
    countryCodes: ["381"],
    isoCode2: "RS"
  },
  {
    country: "Seychelles",
    countryCodes: ["248"],
    isoCode2: "SC"
  },
  {
    country: "Sierra Leone",
    countryCodes: ["232"],
    isoCode2: "SL"
  },
  {
    country: "Singapore",
    countryCodes: ["65"],
    isoCode2: "SG"
  },
  {
    country: "Sint Maarten",
    countryCodes: ["1-721"],
    isoCode2: "SX"
  },
  {
    country: "Slovakia",
    countryCodes: ["421"],
    isoCode2: "SK"
  },
  {
    country: "Slovenia",
    countryCodes: ["386"],
    isoCode2: "SI"
  },
  {
    country: "Solomon Islands",
    countryCodes: ["677"],
    isoCode2: "SB"
  },
  {
    country: "Somalia",
    countryCodes: ["252"],
    isoCode2: "SO"
  },
  {
    country: "South Africa",
    countryCodes: ["27"],
    isoCode2: "ZA"
  },
  {
    country: "South Korea",
    countryCodes: ["82"],
    isoCode2: "KR"
  },
  {
    country: "South Sudan",
    countryCodes: ["211"],
    isoCode2: "SS"
  },
  {
    country: "Spain",
    countryCodes: ["34"],
    isoCode2: "ES"
  },
  {
    country: "Sri Lanka",
    countryCodes: ["94"],
    isoCode2: "LK"
  },
  {
    country: "Sudan",
    countryCodes: ["249"],
    isoCode2: "SD"
  },
  {
    country: "Suriname",
    countryCodes: ["597"],
    isoCode2: "SR"
  },
  {
    country: "Svalbard and Jan Mayen",
    countryCodes: ["47"],
    isoCode2: "SJ"
  },
  {
    country: "Swaziland",
    countryCodes: ["268"],
    isoCode2: "SZ"
  },
  {
    country: "Sweden",
    countryCodes: ["46"],
    isoCode2: "SE"
  },
  {
    country: "Switzerland",
    countryCodes: ["41"],
    isoCode2: "CH"
  },
  {
    country: "Syria",
    countryCodes: ["963"],
    isoCode2: "SY"
  },
  {
    country: "Taiwan",
    countryCodes: ["886"],
    isoCode2: "TW"
  },
  {
    country: "Tajikistan",
    countryCodes: ["992"],
    isoCode2: "TJ"
  },
  {
    country: "Tanzania",
    countryCodes: ["255"],
    isoCode2: "TZ"
  },
  {
    country: "Thailand",
    countryCodes: ["66"],
    isoCode2: "TH"
  },
  {
    country: "Togo",
    countryCodes: ["228"],
    isoCode2: "TG"
  },
  {
    country: "Tokelau",
    countryCodes: ["690"],
    isoCode2: "TK"
  },
  {
    country: "Tonga",
    countryCodes: ["676"],
    isoCode2: "TO"
  },
  {
    country: "Trinidad and Tobago",
    countryCodes: ["1-868"],
    isoCode2: "TT"
  },
  {
    country: "Tunisia",
    countryCodes: ["216"],
    isoCode2: "TN"
  },
  {
    country: "Turkey",
    countryCodes: ["90"],
    isoCode2: "TR"
  },
  {
    country: "Turkmenistan",
    countryCodes: ["993"],
    isoCode2: "TM"
  },
  {
    country: "Turks and Caicos Islands",
    countryCodes: ["1-649"],
    isoCode2: "TC"
  },
  {
    country: "Tuvalu",
    countryCodes: ["688"],
    isoCode2: "TV"
  },
  {
    country: "U.S. Virgin Islands",
    countryCodes: ["1-340"],
    isoCode2: "VI"
  },
  {
    country: "Uganda",
    countryCodes: ["256"],
    isoCode2: "UG"
  },
  {
    country: "Ukraine",
    countryCodes: ["380"],
    isoCode2: "UA"
  },
  {
    country: "United Arab Emirates",
    countryCodes: ["971"],
    isoCode2: "AE"
  },
  {
    country: "United Kingdom",
    countryCodes: ["44"],
    isoCode2: "GB"
  },
  {
    country: "United States",
    countryCodes: ["1"],
    isoCode2: "US"
  },
  {
    country: "Uruguay",
    countryCodes: ["598"],
    isoCode2: "UY"
  },
  {
    country: "Uzbekistan",
    countryCodes: ["998"],
    isoCode2: "UZ"
  },
  {
    country: "Vanuatu",
    countryCodes: ["678"],
    isoCode2: "VU"
  },
  {
    country: "Vatican",
    countryCodes: ["379"],
    isoCode2: "VA"
  },
  {
    country: "Venezuela",
    countryCodes: ["58"],
    isoCode2: "VE"
  },
  {
    country: "Vietnam",
    countryCodes: ["84"],
    isoCode2: "VN"
  },
  {
    country: "Wallis and Futuna",
    countryCodes: ["681"],
    isoCode2: "WF"
  },
  {
    country: "Western Sahara",
    countryCodes: ["212"],
    isoCode2: "EH"
  },
  {
    country: "Yemen",
    countryCodes: ["967"],
    isoCode2: "YE"
  },
  {
    country: "Zambia",
    countryCodes: ["260"],
    isoCode2: "ZM"
  },
  {
    country: "Zimbabwe",
    countryCodes: ["263"],
    isoCode2: "ZW"
  }
];
P$.map((t) => t.isoCode2);
const xQr = "https://cdn.jsdelivr.net/npm/flag-icon-css@3.5.0/flags/4x3/", fLe = ({
  country: t,
  size: e = "sizeIcon40",
  marginRight: r = "space30"
}) => {
  const n = `${xQr}${t.toLowerCase()}.svg`;
  return /* @__PURE__ */ R.jsx(ar.Box, { as: "img", src: n, size: e, marginRight: r });
}, hLe = navigator.language.split("-")[1] || "US", CQr = Ml(
  ({
    id: t,
    error: e,
    label: r,
    placeholder: n,
    countryRef: a,
    defaultCountry: i = hLe,
    placement: o,
    onEnter: s,
    onChange: l
  }, c) => {
    const u = {
      placement: o ?? "bottom-start"
    };
    (u.placement === "top-start" || u.placement === "bottom-start") && (u.unstable_offset = [-10, 12]);
    const f = i1.useMenuState(u), h = Zt(null);
    KGe(c, () => h.current);
    const p = i ? i.toUpperCase() : hLe.toUpperCase(), g = P$.find((x) => x.isoCode2 === p) || P$[0], [y, b] = Yt(g);
    Ut(() => {
      a != null && a.current && (a.current.value = y.countryCodes[0]);
    }, []);
    const w = (x) => {
      var S;
      x.key === "Enter" && (x.preventDefault(), x.stopPropagation(), (S = h.current) != null && S.value && s && s());
    }, _ = (x) => {
      var S;
      b(x), f.hide(), (S = h.current) == null || S.focus(), a && a.current && (a.current.value = x.countryCodes[0]);
    }, C = () => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsxs(i1.MenuButton, { ...f, variant: "reset", children: [
        /* @__PURE__ */ R.jsx(fLe, { country: y.isoCode2 }),
        `+${y.countryCodes[0]}`,
        /* @__PURE__ */ R.jsx(H3e, { decorative: !0 })
      ] }),
      /* @__PURE__ */ R.jsx(
        i1.Menu,
        {
          ref: a,
          ...f,
          "aria-label": "Select Country Code",
          element: "MENU_COUNTRIES_PHONE",
          children: P$.map((x) => /* @__PURE__ */ R.jsx(
            i1.MenuItem,
            {
              ...f,
              onClick: () => _(x),
              children: /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", alignItems: "center", children: [
                /* @__PURE__ */ R.jsx(fLe, { country: x.isoCode2 }),
                /* @__PURE__ */ R.jsx(pf.Text, { as: "span", children: `${x.country} +${x.countryCodes[0]}` })
              ] })
            },
            x.isoCode2
          ))
        }
      )
    ] });
    return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      r && /* @__PURE__ */ R.jsx(Db.Label, { htmlFor: t, required: !0, children: r }),
      /* @__PURE__ */ R.jsx(
        Kue.Input,
        {
          id: t,
          name: "phone_number",
          placeholder: n,
          type: "tel",
          required: !0,
          ref: h,
          onKeyUp: w,
          onChange: l,
          autoFocus: !0,
          insertBefore: C()
        }
      ),
      e && /* @__PURE__ */ R.jsx(g$.HelpText, { variant: "error", children: e })
    ] });
  }
), wQr = S6.styled(ar.Box)`
  div[data-paste-element='MENU_COUNTRIES_PHONE'] {
    max-height: 22rem;
    overflow: scroll;
  }
`, SQr = ({
  description: t,
  label: e = CS.label,
  placeholder: r,
  menuPlacement: n,
  loading: a = !1,
  onCancel: i,
  onSubmit: o
}) => {
  const s = Zt(null), l = r5t(), [c, u] = Yt(), f = async () => {
    var g, y;
    const h = (g = s.current) == null ? void 0 : g.value, p = (y = l.current) == null ? void 0 : y.value;
    if (h && p) {
      const b = `+${p}${h}`;
      if (!dQr(b)) {
        u(CS.errors.invalidPhone);
        return;
      }
      const _ = bQr(b, "INTERNATIONAL");
      await o(_);
      return;
    }
    u(CS.errors.invalidPhone);
  };
  return /* @__PURE__ */ R.jsx(wQr, { children: /* @__PURE__ */ R.jsxs(vh.Card, { padding: "space70", element: "CARD_PHONE_NUMBER", children: [
    /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: t }),
    /* @__PURE__ */ R.jsx(
      CQr,
      {
        id: "request-phone-number",
        ref: s,
        countryRef: l,
        label: e,
        placeholder: r,
        placement: n,
        error: c,
        onChange: () => u(void 0),
        onEnter: f
      }
    ),
    /* @__PURE__ */ R.jsxs(
      ar.Box,
      {
        display: "flex",
        justifyContent: "space-between",
        paddingTop: "space70",
        children: [
          /* @__PURE__ */ R.jsx(zi.Button, { onClick: i, variant: "secondary", children: CS.actions.cancel }),
          /* @__PURE__ */ R.jsx(zi.Button, { onClick: f, variant: "primary", loading: a, children: CS.actions.submit })
        ]
      }
    )
  ] }) });
}, _Qr = ({
  loading: t,
  phoneNumber: e,
  onSubmit: r,
  onClose: n
}) => {
  const a = () => /* @__PURE__ */ R.jsx(
    SQr,
    {
      menuPlacement: "top-start",
      description: I$.action.formDescription,
      loading: t,
      onSubmit: r,
      onCancel: n
    }
  ), i = () => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: I$.action.notificationRequested(e) }),
    /* @__PURE__ */ R.jsx(
      ar.Box,
      {
        display: "flex",
        columnGap: "space80",
        marginBottom: "space60",
        paddingY: "space30",
        children: /* @__PURE__ */ R.jsxs(JM.Badge, { as: "span", variant: "success", children: [
          /* @__PURE__ */ R.jsx(L3e, { decorative: !0 }),
          I$.action.requestSubmittedCTA
        ] })
      }
    )
  ] });
  return /* @__PURE__ */ R.jsx(N3e, { role: Hv.Assistant, children: e && e.length > 10 ? i() : a() });
}, kQr = ({
  liveChatId: t,
  onClose: e
}) => {
  const { requestTransformer: r } = Ja(), [n, a] = Yt(""), [i, { isLoading: o }] = TPt(), s = async (l) => {
    try {
      const c = l.replace(/ /g, "-"), u = l.replace(/ /g, "");
      await i({
        liveChatId: t,
        phoneNumber: u,
        preferredContactMethod: "sms",
        requestTransformer: r
      }).unwrap(), a(c);
    } catch {
      Vo.setError(I$.notificationUnreachable);
    }
  };
  return /* @__PURE__ */ R.jsx(
    _Qr,
    {
      loading: o,
      phoneNumber: n,
      onSubmit: s,
      onClose: e
    }
  );
}, AQr = ({
  liveChatId: t,
  submitTicketParams: e
}) => {
  const [r, n] = Yt(!1), [a, i] = Yt(!1), o = [
    {
      label: "Submit Ticket",
      icon: /* @__PURE__ */ R.jsx(bW, { color: "colorTextIcon", decorative: !0 }),
      handleActionButtonClick: () => n(!0)
    },
    {
      label: "Receive Text",
      icon: /* @__PURE__ */ R.jsx(yht, { color: "colorTextIcon", decorative: !0 }),
      handleActionButtonClick: () => i(!0)
    }
  ], s = () => /* @__PURE__ */ R.jsx(
    cYr,
    {
      setIsModalOpen: n,
      isModalOpen: r,
      submitTicketParams: e
    }
  ), l = () => /* @__PURE__ */ R.jsx(
    kQr,
    {
      onClose: () => {
        i(!1);
      },
      liveChatId: t
    }
  );
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(
      ar.Box,
      {
        display: "flex",
        flexDirection: { base: "column", md: "row" },
        flexWrap: "wrap",
        rowGap: "space40",
        columnGap: "space40",
        marginBottom: "space80",
        children: o.map(({ label: c, icon: u, handleActionButtonClick: f }, h) => /* @__PURE__ */ R.jsx(
          sYr,
          {
            heading: c,
            headingIcon: u,
            children: /* @__PURE__ */ R.jsx(ar.Box, { paddingTop: "space50", children: /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: f, children: lYr.actionButton.label }) })
          },
          `${h}-${c}`
        ))
      }
    ),
    r && s(),
    a && l()
  ] });
}, TQr = ({
  onItemAdded: t,
  onItemRemoved: e,
  onItemUpdated: r,
  onInitialize: n,
  onError: a,
  accessToken: i,
  syncMapId: o
}) => {
  const [s, l] = Yt(null);
  return Ut(() => {
    if (!i || !o)
      throw new Error("accessToken and syncMapId are required");
    const c = new rnt.Client(i);
    return c.map(o).then((u) => {
      l(u), u.on(
        "itemAdded",
        (f) => {
          t && t(f);
        }
      ), u.on(
        "itemRemoved",
        (f) => {
          e && e(f);
        }
      ), u.on(
        "itemUpdated",
        (f) => {
          r && r(f);
        }
      ), n && n(u);
    }).catch(a), () => {
      s && (s.close(), l(null)), c && c.shutdown();
    };
  }, []), {
    syncMap: s
  };
}, EQr = (t) => {
  const {
    liveChatId: e,
    token: r,
    chatActivitySyncMapId: n,
    transfer: a,
    submitTicketParams: i
  } = t, [o, s] = Yt(!0), [l, c] = Yt(null), [u, f] = Yt(null), h = u === aYr, p = !o && !h, g = Q9.useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    delay: 250
  }), y = Q9.animated(N3e), b = (x) => {
    if (!x)
      return;
    const { taskQueueEstWaitTime: S, taskQueuePosition: A } = x;
    c(tYr(S)), f(A), s(!1);
  };
  TQr({
    accessToken: r,
    syncMapId: n,
    onItemUpdated: (x) => {
      const { key: S } = x.item;
      S === e && b(x.item.data);
    },
    onInitialize: async (x) => {
      try {
        const { data: S } = await x.get(e);
        b(S);
      } catch {
        console.warn(
          "SyncMap is not ready yet, waiting for the item update event..."
        );
      }
    },
    onError: (x) => {
      console.error("Error syncing chat activity map", x);
    },
    onItemAdded: (x) => {
      const { key: S } = x.item;
      S === e && b(x.item.data);
    }
  });
  const w = () => p ? /* @__PURE__ */ R.jsx(y, { style: g, role: Hv.Assistant, children: /* @__PURE__ */ R.jsx(
    AQr,
    {
      liveChatId: e,
      submitTicketParams: i
    }
  ) }) : null, _ = () => a && a.type === vht.Queue ? pN.waitMessages.headingForTransferToQueue(a.queue) : pN.waitMessages.heading, C = () => o || l === null ? /* @__PURE__ */ R.jsx(Ks.ChatBookendItem, { children: _() }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(Ks.ChatBookendItem, { children: _() }),
    /* @__PURE__ */ R.jsx(Ks.ChatBookendItem, { children: pN.waitMessages.estimatedMinutes(l) }),
    h && /* @__PURE__ */ R.jsx(Ks.ChatBookendItem, { children: pN.waitMessages.nextInLine })
  ] });
  return /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsx(Ks.ChatBookend, { children: C() }),
    w(),
    /* @__PURE__ */ R.jsx(iht, { isChatActive: !0 })
  ] });
};
var Eie = {}, IQr = ({ prefix: t, responsive: e, defaultValue: r }) => {
  let n = () => r;
  return { [`${t}Top`]: n(), [`${t}Bottom`]: n(), [`${t}Right`]: n(), [`${t}Left`]: n() };
}, Mht = (t) => t === "margin" ? "auto" : "space0", Pht = (t, e, r) => {
  let n = Mht(e), a = IQr({ prefix: e, responsive: !1, defaultValue: n });
  return r === void 0 || (t ? (a[`${e}Top`] = r, a[`${e}Bottom`] = r) : (a[`${e}Right`] = r, a[`${e}Left`] = r)), a;
}, Rht = (t, e, r) => {
  let n = Mht(e), a = { [`${e}Top`]: [n, n, n], [`${e}Bottom`]: [n, n, n], [`${e}Right`]: [n, n, n], [`${e}Left`]: [n, n, n] }, i = Array.isArray(r) && r.length === 0;
  return r === void 0 || i || t.forEach((o, s) => {
    let l = Array.isArray(r) ? r[s] : r;
    o ? (a[`${e}Top`][s] = l, a[`${e}Bottom`][s] = l) : (a[`${e}Right`][s] = l, a[`${e}Left`][s] = l);
  }), a;
}, MQr = (t) => Array.isArray(t) ? t.map((e) => e !== "space0" ? e.replace("space", "spaceNegative") : e === "space0" ? "space0" : null) : t === "space0" ? "space0" : t && typeof t == "string" ? t.replace("space", "spaceNegative") : "auto", PQr = (t) => Array.isArray(t) ? t.map((e) => typeof e == "boolean" ? e === !0 ? "100%" : "0" : null) : t ? "100%" : "0", RQr = ({ vertical: t, gutter: e }) => Array.isArray(t) ? Rht(t, "padding", e) : Pht(t, "padding", e), OQr = ({ count: t, span: e }) => Array.isArray(e) && t ? e.map((r) => `${r / 12 * 100}%`) : typeof e == "number" && t && t <= 12 ? `${e / 12 * 100}%` : t !== void 0 ? `${1 / t * 100}%` : `${8.333333333333332}%`, BQr = (t) => Array.isArray(t) ? t.map((e) => `${e / 12 * 100}%`) : `${t / 12 * 100}%`, NQr = (t, e = !1) => {
  let r = MQr(t);
  return Array.isArray(e) ? Rht(e, "margin", r) : Pht(e, "margin", r);
}, $Qr = (t) => Array.isArray(t) ? t.map((e) => typeof e == "boolean" && e === !0 ? "column" : "row") : t ? "column" : "row", Oht = P.forwardRef(({ as: t, children: e, element: r = "GRID", equalColumnHeights: n, gutter: a, marginTop: i, marginBottom: o, vertical: s = !1, ...l }, c) => {
  let u = P.useMemo(() => P.Children.map(e, (p) => P.isValidElement(p) ? P.cloneElement(p, { count: P.Children.count(e), gutter: a, vertical: s, stretchColumnContent: n }) : p), [e, s, n, a]), f = P.useMemo(() => NQr(a, s), [a, s]), h = P.useMemo(() => $Qr(s), [s]);
  return P.createElement(ht, { ...Xt(l), ref: c, as: t, alignItems: n ? "stretch" : null, element: r, flexDirection: h, flexWrap: "wrap", display: "flex", ...f, marginTop: i, marginBottom: o, minWidth: "size0", rowGap: l.rowGap, columnGap: l.columnGap }, u);
});
Oht.displayName = "Grid";
var DQr = ({ count: t, span: e, gutter: r, offset: n, vertical: a, stretchColumnContent: i }) => {
  let o = { width: OQr({ count: t, span: e }), ...RQr({ gutter: r, vertical: a }) };
  return n && (o.marginLeft = BQr(n)), a && !n && (o.minWidth = PQr(a), o.marginLeft = "space0"), i && (o.alignContent = "stretch", o.display = "flex"), o;
}, Bht = P.forwardRef(({ as: t, children: e, count: r, element: n = "COLUMN", gutter: a, offset: i, span: o, stretchColumnContent: s, vertical: l, ...c }, u) => {
  let f = P.useMemo(() => DQr({ count: r, gutter: a, offset: i, span: o, stretchColumnContent: s, vertical: l }), [r, a, i, o, s, l]);
  return P.createElement(ht, { ...Xt(c), ...f, as: t, element: n, ref: u }, e);
});
Bht.displayName = "Column";
const LQr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Column: Bht,
  Grid: Oht
}, Symbol.toStringTag, { value: "Module" })), jQr = /* @__PURE__ */ aa(LQr);
var pLe;
function FQr() {
  return pLe || (pLe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = jQr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Eie)), Eie;
}
var mLe = /* @__PURE__ */ FQr(), Iie = {};
const Nht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `NewIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[NewIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.991 7.507c.003-.679 1.021-.675 1.019.004-.012 2.956 1.388 4.41 4.492 4.48.673.016.66 1.021-.013 1.019-2.898-.011-4.327 1.446-4.48 4.506-.033.658-1.01.639-1.018-.02-.03-3.027-1.382-4.49-4.481-4.486-.675 0-.682-1.009-.008-1.019 3.02-.042 4.478-1.452 4.49-4.484zm.505 2.757l-.115.242c-.459.9-1.166 1.558-2.115 1.976l.176.08c.973.465 1.664 1.211 2.083 2.22l.02.05.088-.192c.464-.973 1.173-1.685 2.123-2.124l.039-.018-.118-.05c-.963-.435-1.667-1.117-2.113-2.034l-.068-.15zm10.357-8.12c.174.17.194.434.058.625l-.058.068-1.954 1.905 1.954 1.908a.482.482 0 010 .694.512.512 0 01-.641.056l-.07-.056-1.954-1.908-1.954 1.908a.511.511 0 01-.71 0 .482.482 0 01-.058-.626l.058-.068 1.954-1.908-1.954-1.905a.482.482 0 010-.693.512.512 0 01.64-.057l.07.057 1.954 1.905 1.954-1.905a.511.511 0 01.71 0z" })));
});
Nht.displayName = "NewIcon";
var zQr = { success: { backgroundColor: "colorBackgroundBodyElevation", color: "colorTextSuccess", borderColor: "colorBorderSuccessWeak" }, error: { backgroundColor: "colorBackgroundErrorWeakest", color: "colorTextError", borderColor: "colorBorderErrorWeak" }, warning: { backgroundColor: "colorBackgroundBodyElevation", color: "colorTextWarningStrong", borderColor: "colorBorderWarningWeak" }, new: { backgroundColor: "colorBackgroundBodyElevation", color: "colorTextNew", borderColor: "colorBorderNewWeak" }, neutral: { backgroundColor: "colorBackgroundBodyElevation", color: "colorTextNeutral", borderColor: "colorBorderNeutralWeak" } }, GQr = { success: P.createElement(oG, { decorative: !0, color: "colorTextIconSuccess" }), error: P.createElement(fy, { decorative: !0, color: "colorTextIconError" }), warning: P.createElement(hM, { decorative: !0, color: "colorTextIconWarning" }), new: P.createElement(Nht, { decorative: !0, color: "colorTextIconNew" }), neutral: P.createElement(vW, { decorative: !0, color: "colorTextIconNeutral" }) }, WQr = { success: "(success)", error: "(error)", warning: "(warning)", new: "(new)", neutral: "(information)" }, $ht = P.forwardRef(({ children: t, variant: e, element: r = "CALLOUT", i18nLabel: n, marginY: a, onDismiss: i, i18nDismissLabel: o = "Dismiss callout", ...s }, l) => {
  let c = GQr[e], u = n || WQr[e];
  return P.createElement(ht, { ...Xt(s), ref: l, element: r, display: "flex", marginY: a, padding: "space70", borderLeftStyle: "solid", borderLeftWidth: "borderWidth20", variant: e, alignItems: "start", columnGap: "space50", ...zQr[e] }, P.createElement(ht, { element: `${r}_ICON` }, c, P.createElement(Ul, null, u)), P.createElement(ht, { display: "flex", flexDirection: "column", rowGap: "space30", flex: "1" }, t), i && typeof i == "function" && P.createElement(Zs, { onClick: i, variant: "secondary_icon", size: "reset", element: `${r}_DISMISS_BUTTON` }, P.createElement(Dy, { element: `${r}_DISMISS_ICON`, decorative: !0, size: "sizeIcon20" }), P.createElement(Ul, null, o)));
});
$ht.displayName = "Callout";
var Dht = P.forwardRef(({ element: t = "CALLOUT_HEADING", children: e, as: r = "h3", ...n }, a) => P.createElement(cl, { ...lg(n), as: r, ref: a, element: t, color: "currentColor", fontWeight: "fontWeightSemibold" }, e));
Dht.displayName = "CalloutHeading";
var Lht = P.forwardRef(({ element: t = "CALLOUT_LIST", children: e, as: r, ...n }, a) => P.createElement(ht, { ...Xt(n), element: t, ref: a, as: r, margin: "space0", display: "flex", flexDirection: "column", rowGap: "space30", paddingLeft: "space60" }, e));
Lht.displayName = "CalloutList";
var jht = P.forwardRef(({ element: t = "CALLOUT_LIST_ITEM", children: e, ...r }, n) => P.createElement(cl, { ...lg(r), element: t, ref: n, as: "li", color: "currentColor" }, e));
jht.displayName = "CalloutListItem";
var Fht = P.forwardRef(({ element: t = "CALLOUT_TEXT", children: e, ...r }, n) => P.createElement(cl, { ...lg(r), as: "p", ref: n, element: t, color: "currentColor" }, e));
Fht.displayName = "CalloutText";
const HQr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Callout: $ht,
  CalloutHeading: Dht,
  CalloutList: Lht,
  CalloutListItem: jht,
  CalloutText: Fht
}, Symbol.toStringTag, { value: "Module" })), UQr = /* @__PURE__ */ aa(HQr);
var gLe;
function VQr() {
  return gLe || (gLe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = UQr;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Iie)), Iie;
}
var Mie = /* @__PURE__ */ VQr();
const Z3 = {
  liveChatPreEngagement: {
    heading: "Chat with a live agent",
    supportedProducts: {
      label: "Supported product"
    },
    startLiveChatButton: "Start live chat",
    closeFormButton: "Close",
    message: {
      label: "Message"
    },
    unsupportedProductCallout: {
      heading: "We do not support other products.",
      description: (t) => [
        "Please ",
        /* @__PURE__ */ R.jsx(iWe, { to: t, children: "submit a ticket" }),
        " so we can better help you."
      ]
    }
  }
}, vLe = "unsupported_product", pfe = "support_messaging_insights", mfe = "support_suspension_ato", yLe = (t) => t && {
  prod_numbers: "support_phone_numbers",
  prod_voice: "support_voice",
  prod_messaging: "support_messaging",
  prod_accounts_billing: "prod_account_admin",
  prod_email_api: "prod_email_api",
  prod_marketing_campaigns: "prod_marketing_campaigns",
  [pfe]: pfe,
  [mfe]: mfe
}[t] || "", Kf = {
  Product: "product",
  Message: "message"
}, zht = ({
  isOpen: t = !1,
  handleStartEngagement: e,
  handleToggleVisibility: r,
  supportedProducts: n,
  selectedProductCategory: a,
  message: i,
  inferredProductCategory: o,
  inferredSummary: s
}) => {
  const {
    control: l,
    handleSubmit: c,
    getValues: u,
    setValue: f,
    formState: { errors: h },
    watch: p,
    reset: g
  } = Xme({
    defaultValues: {
      product: yLe(o) || "",
      message: s || ""
    }
  });
  Ut(() => {
    a && f(
      "product",
      yLe(a)
    ), i && f("message", i);
  }, [a, i, t]);
  const y = !(a === pfe || a === mfe);
  p(Kf.Product), p(Kf.Message);
  const b = () => {
    g(), r();
  }, w = (L) => {
    const { product: N, message: d } = L;
    e(N, d), b();
  }, _ = "live-chat-pre-engagement-modal", C = () => {
    const L = u("product");
    return L ? L === vLe ? /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsx(Mie.Callout, { variant: "neutral", children: /* @__PURE__ */ R.jsxs(ar.Box, { children: [
      /* @__PURE__ */ R.jsx(Mie.CalloutHeading, { as: "h2", children: Z3.liveChatPreEngagement.unsupportedProductCallout.heading }),
      /* @__PURE__ */ R.jsx(Mie.CalloutText, { children: Z3.liveChatPreEngagement.unsupportedProductCallout.description(
        "/submit"
      ) })
    ] }) }) }) : /* @__PURE__ */ R.jsxs(ar.Box, { marginBottom: "space10", children: [
      /* @__PURE__ */ R.jsx(Db.Label, { required: !0, htmlFor: Kf.Message, children: Z3.liveChatPreEngagement.message.label }),
      /* @__PURE__ */ R.jsx(
        Vue,
        {
          name: Kf.Message,
          control: l,
          rules: {
            required: !0
          },
          render: ({ field: N }) => /* @__PURE__ */ R.jsx(
            oge.TextArea,
            {
              id: Kf.Message,
              required: !0,
              ...N
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsx(ar.Box, { marginTop: "space40", children: /* @__PURE__ */ R.jsx(pf.Text, { as: "summary", color: "colorTextWeak", fontSize: "fontSize20", children: p6t.liveChatDisclaimer }) })
    ] }) : null;
  }, x = h[Kf.Product], S = h[Kf.Message], A = !!x || !!S, I = !u("product") || u("product") === vLe, M = !u("message").trim().length, B = I || M || A;
  return /* @__PURE__ */ R.jsxs(
    _s.Modal,
    {
      ariaLabelledby: _,
      isOpen: t,
      onDismiss: b,
      size: "default",
      children: [
        /* @__PURE__ */ R.jsx(_s.ModalHeader, { children: /* @__PURE__ */ R.jsx(_s.ModalHeading, { as: "h3", id: _, children: Z3.liveChatPreEngagement.heading }) }),
        /* @__PURE__ */ R.jsx(_s.ModalBody, { children: /* @__PURE__ */ R.jsx(mLe.Grid, { children: /* @__PURE__ */ R.jsxs(mLe.Column, { as: "form", children: [
          y && /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsxs(ar.Box, { marginBottom: "space50", children: [
            /* @__PURE__ */ R.jsx(
              Db.Label,
              {
                required: !0,
                htmlFor: Kf.Product,
                children: Z3.liveChatPreEngagement.supportedProducts.label
              }
            ),
            /* @__PURE__ */ R.jsx(
              Vue,
              {
                name: Kf.Product,
                control: l,
                rules: {
                  required: !0
                },
                render: ({ field: L }) => /* @__PURE__ */ R.jsxs(
                  K0.Select,
                  {
                    id: Kf.Product,
                    required: !0,
                    ...L,
                    children: [
                      !u(
                        Kf.Product
                      ) && /* @__PURE__ */ R.jsx(K0.Option, { value: "", children: " " }),
                      n == null ? void 0 : n.map((N) => /* @__PURE__ */ R.jsx(K0.Option, { value: N.value, children: N.label }, N.value))
                    ]
                  }
                )
              }
            )
          ] }) }),
          C()
        ] }) }) }),
        /* @__PURE__ */ R.jsx(_s.ModalFooter, { children: /* @__PURE__ */ R.jsxs(_s.ModalFooterActions, { children: [
          /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: b, children: Z3.liveChatPreEngagement.closeFormButton }),
          /* @__PURE__ */ R.jsx(
            zi.Button,
            {
              onClick: c(w),
              variant: "primary",
              disabled: B,
              children: Z3.liveChatPreEngagement.startLiveChatButton
            }
          )
        ] }) })
      ]
    }
  );
}, Ght = (t) => {
  const { applicationId: e, conversationId: r, updateOnly: n = !1 } = t;
  let a = window.location.pathname !== "/" ? window.location.pathname : "", i = `${a}/${r}`;
  const o = (l) => {
    if (n) {
      window.history.pushState({}, "", l);
      return;
    }
    window.location.assign(l);
  };
  if (window.location.host === "localhost:4200") {
    o(i);
    return;
  }
  switch (e) {
    case "help-center-application":
      i = `${a}/chat/${r}`, o(i);
      break;
    default:
      o(i);
      break;
  }
}, qQr = (t, e) => {
  const r = s2(), [n, { isLoading: a }] = dPt(), { requestTransformer: i } = Ja();
  return {
    isTransferringToLiveChat: a,
    handleTransferToLiveChat: async (s, l, c) => {
      r(K$(!0));
      try {
        const u = Y1t({
          applicationPreEngagementData: c,
          productCategory: s,
          question: l,
          applicationId: e
        }), f = c.friendlyName || "Chat User", { data: h } = await n({
          body: {
            customerFriendlyName: f,
            preEngagementData: u,
            chatFriendlyName: `Live Chat from ${f}`
          },
          conversationId: t,
          requestTransformer: i
        });
        h && (r(v1e(h.liveChatId)), r(v2e(h)), r(y2e({ isConnected: !0 })));
      } catch (u) {
        console.error(u);
      } finally {
        r(K$(!1));
      }
    }
  };
}, Wht = (t) => {
  const e = s2(), [r, { isLoading: n }] = hPt(), { requestTransformer: a } = Ja();
  return {
    isTransferringToLiveChat: n,
    handleTransferToLiveChat: async (o, s, l) => {
      e(K$(!0));
      try {
        const c = Y1t({
          applicationPreEngagementData: l,
          productCategory: o,
          question: s,
          applicationId: t
        }), u = l.friendlyName || "Chat User", { data: f } = await r({
          body: {
            customerFriendlyName: u,
            preEngagementData: c,
            chatFriendlyName: `Live Chat from ${u}`
          },
          requestTransformer: a
        });
        f && (e(v1e(f.liveChatId)), e(v2e(f)), e(y2e({ isConnected: !0 })), Ght({
          applicationId: t,
          conversationId: f.conversationId,
          updateOnly: !0
        }));
      } catch (c) {
        console.error(c);
      } finally {
        e(K$(!1));
      }
    }
  };
}, KQr = {
  osc: "osc"
}, ZQr = {
  submitTicket: {
    subject: "Need Assistance"
  }
}, bLe = {
  DIRECT_LIVE_CHAT_TAG: "direct_live_chat"
}, JQr = ({
  message: t,
  linkText: e,
  supportedProducts: r
}) => {
  const n = Gn((h) => h.config.applicationId), a = Gn((h) => h.config.user), i = {
    friendlyName: `${a.firstName} ${a.lastName}`,
    identity: a.emailAddr,
    email: a.emailAddr,
    userSid: a.userSid,
    accountSid: a.accountSid
  }, [o, s] = Yt(!1), { isTransferringToLiveChat: l, handleTransferToLiveChat: c } = Wht(n), u = () => {
    s(!o);
  }, f = async (h, p) => {
    await c(
      h,
      p,
      i
    );
  };
  return /* @__PURE__ */ R.jsxs(ar.Box, { as: "div", paddingY: "space30", width: "100%", children: [
    /* @__PURE__ */ R.jsx(vh.Card, { padding: "space60", children: /* @__PURE__ */ R.jsxs(R1.Stack, { orientation: "horizontal", spacing: "space40", children: [
      /* @__PURE__ */ R.jsx(v3e, { decorative: !0 }),
      /* @__PURE__ */ R.jsx(ar.Box, { as: "span", children: t }),
      /* @__PURE__ */ R.jsx(
        zi.Button,
        {
          onClick: u,
          loading: l,
          variant: "link",
          children: e
        }
      )
    ] }) }),
    /* @__PURE__ */ R.jsx(
      zht,
      {
        supportedProducts: r,
        handleStartEngagement: f,
        handleToggleVisibility: u,
        isOpen: o,
        inferredProductCategory: "",
        inferredSummary: "",
        ingress: KQr.osc
      }
    )
  ] });
}, YQr = ({ block: t }) => {
  const {
    values: { channel: e, supportedProducts: r }
  } = t;
  switch (e) {
    case Q5t.LiveChat:
      return /* @__PURE__ */ R.jsx(
        JQr,
        {
          message: "Need help?",
          linkText: "Chat with a live agent",
          supportedProducts: r
        }
      );
  }
}, XQr = ha.object({
  variant: ha.enum(["error", "neutral", "warning"]),
  heading: ha.string(),
  bodyText: ha.string(),
  buttons: Nct.array()
}), QQr = ({ block: t }) => {
  let e;
  const r = Gn((g) => g.config.user), n = Gn((g) => g.config.applicationId);
  try {
    e = XQr.parse(t.values);
  } catch (g) {
    return /* @__PURE__ */ R.jsx(
      $a,
      {
        error: g instanceof Error ? g.message : "Invalid values"
      }
    );
  }
  const a = Ume(), i = (g) => (g == null ? void 0 : g.type) === l0.DIRECT_LIVE_CHAT_TRANSFER, o = {
    friendlyName: `${r.firstName} ${r.lastName}`,
    identity: r.emailAddr,
    email: r.emailAddr,
    userSid: r.userSid,
    accountSid: r.accountSid
  }, { isTransferringToLiveChat: s, handleTransferToLiveChat: l } = Wht(n), c = (g) => {
    if (!g) {
      console.warn("Button has no action");
      return;
    }
    const y = g.values || {};
    if (i(g)) {
      const { productCategory: w, question: _ } = y;
      l(
        w,
        _,
        o
      );
      return;
    }
    const b = a[g.type];
    if (!b) {
      console.warn(`Action ${g.type} not implemented`);
      return;
    }
    b(y);
  }, { variant: u, heading: f, bodyText: h, buttons: p } = e;
  return /* @__PURE__ */ R.jsx(_r, { textAlign: "left", as: "section", children: /* @__PURE__ */ R.jsxs(XGe, { variant: u, children: [
    /* @__PURE__ */ R.jsx("strong", { children: f }),
    /* @__PURE__ */ R.jsx(_r, { children: h }),
    /* @__PURE__ */ R.jsx(_r, { marginTop: "space30", children: p.map(({ label: g, variant: y, size: b, action: w }) => /* @__PURE__ */ R.jsx(_r, { as: "span", marginRight: "space30", children: /* @__PURE__ */ R.jsx(
      as,
      {
        loading: i(w) && s,
        variant: y,
        size: b,
        onClick: () => c(w),
        children: g
      }
    ) }, g)) })
  ] }) });
}, een = {
  "button-group-block": K_r,
  "call-to-action-block": bHr,
  "categorical-data-block": rHr,
  "series-data-block": nHr,
  "table-block": fHr,
  "combobox-block": vHr,
  "support-cta-block": YQr,
  "alert-block": QQr
}, gP = ({ block: t }) => {
  try {
    return een[t.id]({ block: t });
  } catch {
    return /* @__PURE__ */ R.jsx(U_r.Alert, { variant: "error", children: "Not Implemented" });
  }
}, Hht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CopyIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CopyIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.469 2.5c.63 0 1.15.48 1.212 1.094l.007.125-.001 1.593h1.407c.73 0 1.331.558 1.4 1.271l.006.136v9.375c0 .776-.63 1.406-1.406 1.406H6.719c-.777 0-1.407-.63-1.407-1.406v-1.407H3.719c-.631 0-1.15-.48-1.213-1.094L2.5 13.47v-9.75c0-.631.48-1.15 1.094-1.213L3.72 2.5h9.75zm2.625 3.75H6.719a.469.469 0 00-.469.469v9.375c0 .259.21.468.469.468h9.375c.259 0 .468-.21.468-.468V6.719a.469.469 0 00-.468-.469zm-2.625-2.813h-9.75a.281.281 0 00-.274.217l-.007.065v9.75c0 .133.092.244.216.274l.065.007 1.593-.001v-7.03c0-.731.558-1.332 1.271-1.4l.136-.006 7.031-.001V3.719a.281.281 0 00-.217-.274l-.064-.007z" })));
});
Hht.displayName = "CopyIcon";
const Uht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ThumbsDownIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ThumbsDownIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 12.55c-.194.215-.406.451-.628.707-.799.921-1.608 1.972-1.898 2.838-.314.938-1.139 1.487-1.966 1.395a1.57 1.57 0 01-1.085-.621c-.277-.363-.423-.85-.423-1.43 0-.327.081-.645.174-.924.062-.186.139-.383.208-.56l.088-.226c.092-.245.15-.432.166-.582.014-.134-.01-.19-.033-.222l-.001-.001a.416.416 0 00-.1-.058 1.902 1.902 0 00-.371-.11 7.35 7.35 0 00-1.152-.124 22.958 22.958 0 00-1.634.002 14.2 14.2 0 01-.345.008c-.25 0-.731-.008-1.158-.218a1.451 1.451 0 01-.603-.537c-.159-.257-.239-.567-.239-.924 0-1.218.524-3.648 1.553-5.696.31-.616.693-.884 1.18-1.192C5.807 3.71 6.378 3.5 7 3.5h3c1.116 0 2.204.417 3.002.883.178.104.345.212.498.321v-.37a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V13a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-.45zm-3.474 3.227c-.186.554-.611.752-.909.72a.571.571 0 01-.399-.234c-.114-.15-.218-.409-.218-.824a2 2 0 01.123-.61c.054-.16.113-.312.177-.475.034-.086.07-.176.105-.272.095-.252.194-.542.225-.828.032-.296-.005-.635-.23-.934a1.23 1.23 0 00-.491-.367 2.874 2.874 0 00-.571-.176 8.31 8.31 0 00-1.317-.144c-.676-.029-1.381-.008-1.767.003-.118.003-.206.006-.254.006-.25 0-.519-.018-.717-.115a.452.452 0 01-.194-.168c-.044-.07-.089-.19-.089-.396 0-1.04.476-3.316 1.447-5.247.184-.366.375-.515.82-.796.468-.296.855-.42 1.233-.42h3c.884 0 1.796.337 2.498.747.349.203.628.414.813.59.093.09.152.16.184.208l.005.007v4.98a7.245 7.245 0 01-.329.39 54.1 54.1 0 01-.308.342c-.223.247-.483.534-.746.838-.788.909-1.73 2.096-2.091 3.175zM14.5 12.5h2V4.833h-2V12.5z" })));
});
Uht.displayName = "ThumbsDownIcon";
const Vht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ThumbsUpIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ThumbsUpIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 7.45c.194-.216.406-.451.628-.707.799-.922 1.608-1.972 1.898-2.838.314-.938 1.139-1.487 1.966-1.395a1.57 1.57 0 011.085.621c.277.363.423.85.423 1.43 0 .327-.081.645-.174.924-.062.186-.139.383-.208.56l-.088.226c-.092.245-.15.432-.166.582-.014.134.01.19.033.222l.001.001a.415.415 0 00.1.058 1.9 1.9 0 00.371.11c.32.068.725.106 1.152.124.632.026 1.237.01 1.634-.002.147-.004.265-.008.345-.008.25 0 .731.008 1.158.218.224.11.443.28.603.537.159.256.239.567.239.924 0 1.218-.524 3.647-1.553 5.695-.31.616-.693.885-1.18 1.193-.574.364-1.145.575-1.767.575h-3c-1.116 0-2.204-.418-3.002-.883a6.393 6.393 0 01-.498-.322v.372a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V7a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v.45zm3.474-3.228c.186-.554.611-.751.909-.718a.57.57 0 01.399.233c.114.15.218.409.218.824 0 .17-.044.37-.123.61a9.287 9.287 0 01-.177.474c-.034.087-.07.177-.105.273-.095.252-.194.542-.225.827-.032.297.005.636.23.935.135.178.322.291.491.367.175.078.372.134.571.176.4.084.869.125 1.317.144.676.028 1.382.008 1.767-.003.118-.003.206-.006.254-.006.25 0 .519.018.717.115.088.044.15.098.194.168.044.07.089.19.089.396 0 1.04-.476 3.316-1.447 5.246-.184.367-.375.516-.82.797-.468.296-.855.42-1.233.42h-3c-.884 0-1.796-.338-2.498-.747a4.464 4.464 0 01-.813-.591 1.36 1.36 0 01-.184-.207l-.005-.008V8.968a7.331 7.331 0 01.329-.39l.308-.343c.223-.246.483-.534.746-.837.788-.909 1.73-2.097 2.091-3.176zM5.5 7.5h-2v7.667h2V7.5z" })));
});
Vht.displayName = "ThumbsUpIcon";
const ten = ({
  handleThumbsUp: t,
  handleThumbsDown: e,
  sentFeedbackType: r
}) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ R.jsx(al, { text: "Good response", placement: "bottom", children: /* @__PURE__ */ R.jsx(
    as,
    {
      variant: r === bm.THUMBS_UP ? "primary" : "secondary",
      size: "icon_small",
      onClick: t,
      disabled: !!r,
      children: /* @__PURE__ */ R.jsx(Vht, { decorative: !1, title: "Bad response" })
    }
  ) }),
  /* @__PURE__ */ R.jsx(al, { text: "Bad response", placement: "bottom", children: /* @__PURE__ */ R.jsx(
    as,
    {
      variant: r === bm.THUMBS_DOWN ? "primary" : "secondary",
      size: "icon_small",
      onClick: e,
      disabled: !!r,
      children: /* @__PURE__ */ R.jsx(Uht, { decorative: !1, title: "Bad response" })
    }
  ) })
] }), ren = ({
  message: t,
  setIsMoreFeedbackVisible: e,
  setSentFeedbackType: r,
  sentFeedbackType: n,
  setFeedbackId: a
}) => {
  const [i] = cPt(), { requestTransformer: o } = Ja(), s = async () => {
    r(bm.THUMBS_UP), e(!0);
    const { feedback: c } = await i({
      body: {
        messageId: t.id,
        type: bm.THUMBS_UP
      },
      messageId: t.id,
      conversationId: t.conversationId,
      requestTransformer: o
    }).unwrap();
    a(c.id);
  }, l = async () => {
    r(bm.THUMBS_DOWN), e(!0);
    const { feedback: c } = await i({
      body: {
        messageId: t.id,
        type: bm.THUMBS_DOWN
      },
      messageId: t.id,
      conversationId: t.conversationId,
      requestTransformer: o
    }).unwrap();
    a(c.id);
  };
  return /* @__PURE__ */ R.jsx(
    ten,
    {
      message: t,
      handleThumbsUp: s,
      handleThumbsDown: l,
      sentFeedbackType: n
    }
  );
}, gfe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CloseIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CloseIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M15.16 13.514L11.645 10l3.515-3.514a1.165 1.165 0 00-1.646-1.646L10 8.355 6.486 4.84A1.165 1.165 0 004.84 6.486L8.355 10 4.84 13.514a1.165 1.165 0 001.646 1.646L10 11.645l3.514 3.515a1.165 1.165 0 001.646-1.646z" })));
});
gfe.displayName = "CloseIcon";
const nen = ({
  onClose: t,
  onClickCategory: e,
  onClickOther: r,
  isOtherFeedbackFormVisible: n,
  setIsOtherFeedbackFormVisible: a,
  onSubmitOtherFeedback: i,
  categories: o,
  onChangeOtherFeedback: s,
  scrollableRef: l
}) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  !n && /* @__PURE__ */ R.jsxs(is, { padding: "space40", color: "colorTextWeak", ref: l, children: [
    /* @__PURE__ */ R.jsxs(
      _r,
      {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "space40",
        children: [
          /* @__PURE__ */ R.jsx(_r, { children: "Tell us more:" }),
          /* @__PURE__ */ R.jsx(as, { variant: "secondary_icon", size: "icon_small", onClick: t, children: /* @__PURE__ */ R.jsx(gfe, { decorative: !1, title: "Close" }) })
        ]
      }
    ),
    /* @__PURE__ */ R.jsxs(
      _r,
      {
        display: "flex",
        flexWrap: "wrap",
        rowGap: "space40",
        columnGap: "space40",
        children: [
          o.map((c) => /* @__PURE__ */ R.jsx(
            is,
            {
              padding: "space20",
              cursor: "pointer",
              onClick: () => e(c),
              children: c
            },
            c
          )),
          /* @__PURE__ */ R.jsx(
            is,
            {
              padding: "space20",
              cursor: "pointer",
              onClick: r,
              children: "Other"
            }
          )
        ]
      }
    )
  ] }),
  n && /* @__PURE__ */ R.jsxs(is, { padding: "space40", color: "colorTextWeak", ref: l, children: [
    /* @__PURE__ */ R.jsxs(
      _r,
      {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "space40",
        children: [
          /* @__PURE__ */ R.jsx(_r, { children: "Tell us more:" }),
          /* @__PURE__ */ R.jsx(as, { variant: "secondary_icon", size: "icon_small", onClick: t, children: /* @__PURE__ */ R.jsx(gfe, { decorative: !1, title: "Close" }) })
        ]
      }
    ),
    /* @__PURE__ */ R.jsx(_r, { marginBottom: "space40", children: /* @__PURE__ */ R.jsx(u5t, { onChange: s }) }),
    /* @__PURE__ */ R.jsxs(_r, { display: "flex", columnGap: "space40", justifyContent: "end", children: [
      /* @__PURE__ */ R.jsx(
        as,
        {
          variant: "secondary",
          onClick: () => a(!1),
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ R.jsx(as, { variant: "secondary", onClick: i, children: "Submit" })
    ] })
  ] })
] }), qht = Bo(void 0), aen = ({ children: t }) => {
  const e = Zt(null), [r, n] = Yt(!0), a = () => {
    const s = e.current, l = !!s && s.scrollTop + s.clientHeight >= s.scrollHeight - 100;
    n(l);
  }, i = () => {
    const s = e.current;
    s && setTimeout(() => {
      s.scrollTo({
        top: s.scrollHeight,
        behavior: "smooth"
      });
    }, 100);
  }, o = (s) => {
    if (e.current && s) {
      const l = e.current, c = s.offsetTop + s.offsetHeight + 100, u = l.offsetTop + l.clientHeight;
      c > u && l.scrollTo({
        top: c - l.clientHeight - l.offsetTop,
        behavior: "smooth"
      });
    }
  };
  return Ut(() => {
    const s = e.current;
    if (s)
      return s.addEventListener("scroll", a), () => s.removeEventListener("scroll", a);
  }, []), /* @__PURE__ */ R.jsx(
    qht.Provider,
    {
      value: {
        scrollableRef: e,
        isScrolledToBottom: r,
        scrollToBottom: i,
        scrollIntoView: o
      },
      children: t
    }
  );
}, Kht = () => {
  const t = Qn(qht);
  if (!t)
    throw new Error(
      "useConversationScroll must be used within a WiseOwlConversationScrollProvider"
    );
  return t;
}, ien = ({
  feedbackId: t,
  setIsMoreFeedbackVisible: e,
  setIsFeedbackSuccessVisible: r,
  sentFeedbackType: n,
  message: a
}) => {
  const [i, o] = Yt(!1), [s, l] = Yt(""), [c] = pPt(), { requestTransformer: u } = Ja(), f = Zt(null), { scrollIntoView: h } = Kht();
  Ut(() => {
    const C = f.current;
    C && h(C);
  }, []);
  const p = async (C) => {
    c({
      body: {
        id: t,
        type: n,
        content: C,
        messageId: a.id
      },
      feedbackId: t,
      messageId: a.id,
      conversationId: a.conversationId,
      requestTransformer: u
    }), e(!1), r(!0);
  }, g = () => {
    o(!0);
  }, y = () => {
    e(!1);
  }, b = () => {
    c({
      body: {
        id: t,
        type: n,
        content: s,
        messageId: a.id
      },
      feedbackId: t,
      messageId: a.id,
      conversationId: a.conversationId,
      requestTransformer: u
    }), o(!1), e(!1), r(!0);
  }, w = [
    "Factually correct",
    "Followed instructions",
    "Content is the correct length",
    "Like the style",
    "Used the correct Tool",
    "Followed the correct Workflow"
  ], _ = [
    "Not factually correct",
    "Didn't follow instructions",
    "Content is too long",
    "Content is too short",
    "Don't like the style",
    "Didn't retrieve the correct information",
    "Didnt' use the correct Tool",
    "Didn't follow the correct Workflow"
  ];
  return /* @__PURE__ */ R.jsx(
    nen,
    {
      scrollableRef: f,
      onClose: y,
      onClickCategory: p,
      onClickOther: g,
      isOtherFeedbackFormVisible: i,
      setIsOtherFeedbackFormVisible: o,
      onSubmitOtherFeedback: b,
      categories: n === bm.THUMBS_UP ? w : _,
      onChangeOtherFeedback: (C) => l(C.target.value)
    }
  );
}, oen = ({
  feedbackId: t,
  message: e,
  handleCopyToClipboard: r,
  isMoreFeedbackVisible: n,
  setIsMoreFeedbackVisible: a,
  isFeedbackSuccessVisible: i,
  setIsFeedbackSuccessVisible: o,
  sentFeedbackType: s,
  setSentFeedbackType: l,
  setFeedbackId: c,
  onClickSubmitTicket: u,
  isFetchingSummary: f,
  isTransferToHumanEnabled: h
}) => /* @__PURE__ */ R.jsxs(_r, { children: [
  /* @__PURE__ */ R.jsxs(_r, { display: "flex", columnGap: "space40", children: [
    /* @__PURE__ */ R.jsx(al, { text: "Copy", placement: "bottom", children: /* @__PURE__ */ R.jsx(
      as,
      {
        variant: "secondary",
        size: "icon_small",
        onClick: r,
        children: /* @__PURE__ */ R.jsx(Hht, { decorative: !1, title: "ThumbsUp" })
      }
    ) }),
    /* @__PURE__ */ R.jsx(
      ren,
      {
        message: e,
        setIsMoreFeedbackVisible: a,
        sentFeedbackType: s,
        setSentFeedbackType: l,
        setFeedbackId: c
      }
    )
  ] }),
  n && s && t && /* @__PURE__ */ R.jsx(_r, { marginTop: "space40", children: /* @__PURE__ */ R.jsx(
    ien,
    {
      feedbackId: t,
      message: e,
      setIsMoreFeedbackVisible: a,
      setIsFeedbackSuccessVisible: o,
      sentFeedbackType: s
    }
  ) }),
  /* @__PURE__ */ R.jsx(f8r, { children: i && /* @__PURE__ */ R.jsx(
    Vve.div,
    {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 0.25 },
      children: /* @__PURE__ */ R.jsx(_r, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ R.jsx(
        is,
        {
          marginTop: "space40",
          padding: "space40",
          className: "fade-in",
          children: "Thank you for your feedback!"
        }
      ) })
    }
  ) }),
  h && s === bm.THUMBS_DOWN && /* @__PURE__ */ R.jsxs(
    is,
    {
      alignItems: "center",
      color: "colorTextWeak",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "space40",
      padding: "space40",
      children: [
        "Need additional support?",
        /* @__PURE__ */ R.jsx(
          as,
          {
            loading: f,
            onClick: u,
            variant: "primary",
            size: "small",
            children: "Submit a ticket"
          }
        )
      ]
    }
  )
] }), U3e = () => {
  const t = Gn((c) => c.config.applicationId), { requestTransformer: e } = Ja(), { data: { application: r } = {} } = WI({
    applicationId: t,
    requestTransformer: e
  }), [n, a] = Yt(!1), [i, o] = Yt(!1), [s, l] = Yt(!1);
  return Ut(() => {
    r && (a(
      r.optionalFeatures.includes(QN.canvas)
    ), o(
      r.optionalFeatures.includes(QN.promptLibrary)
    ), l(
      r.optionalFeatures.includes(QN.transferToHuman)
    ));
  }, [r]), {
    isCanvasEnabled: n,
    isPromptLibraryEnabled: i,
    isTransferToHumanEnabled: s
  };
}, sen = ({ message: t }) => {
  var b;
  const [e, r] = Yt(!1), [
    n,
    a
  ] = Yt(!1), [i, o] = Yt(), { requestTransformer: s } = Ja(), { isTransferToHumanEnabled: l } = U3e(), [
    c,
    { isFetching: u }
  ] = WMt(), [f, h] = Yt((b = t.feedback) == null ? void 0 : b.type);
  Ut(() => {
    if (n) {
      const w = setTimeout(() => {
        a(!1);
      }, 3e3);
      return () => clearTimeout(w);
    }
  }, [n]);
  const p = () => {
    const w = t.parts.filter(
      (_) => _.type === e0.MARKDOWN
    ).map((_) => _.content).join(`
`);
    navigator.clipboard.writeText(w);
  }, g = (w) => {
    const _ = "feedback", C = w.description, x = w.subject, S = new URL("https://help.twilio.com/submit");
    S.search = new URLSearchParams({
      source: _,
      conversationId: t.conversationId,
      description: C,
      subject: x
    }).toString(), window.open(S.toString(), "_blank", "noopener,noreferrer");
  }, y = async () => {
    const w = await c({
      conversationId: t.conversationId,
      requestTransformer: s
    });
    w.data && g(w.data.summary);
  };
  return /* @__PURE__ */ R.jsx(
    oen,
    {
      feedbackId: i,
      message: t,
      handleCopyToClipboard: p,
      isMoreFeedbackVisible: e,
      setIsMoreFeedbackVisible: r,
      isFeedbackSuccessVisible: n,
      setIsFeedbackSuccessVisible: a,
      sentFeedbackType: f,
      setSentFeedbackType: h,
      setFeedbackId: o,
      onClickSubmitTicket: y,
      isFetchingSummary: u,
      isTransferToHumanEnabled: l
    }
  );
}, Zht = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronUpIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronUpIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.293 7.293a1 1 0 011.32-.083l.094.083 3 3a1 1 0 01-1.32 1.497l-.094-.083L10 9.415l-2.293 2.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 3-3z" })));
});
Zht.displayName = "ChevronUpIcon";
const V3e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `LogoTwilioIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[LogoTwilioIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0010 0zm0 17.333a7.333 7.333 0 110-14.666 7.333 7.333 0 010 14.666zm4.533-9.8a2.067 2.067 0 11-2.066-2.066 2.08 2.08 0 012.066 2.066zm0 4.934a2.067 2.067 0 11-2.066-2.067 2.08 2.08 0 012.066 2.067zm-4.933 0A2.067 2.067 0 117.533 10.4 2.08 2.08 0 019.6 12.467zm0-4.934a2.067 2.067 0 11-2.067-2.066A2.08 2.08 0 019.6 7.533z" })));
});
V3e.displayName = "LogoTwilioIcon";
const len = ({
  retrievedKnowledge: t,
  handleOpenLink: e,
  containerRef: r,
  citationsPerLine: n,
  showAllCitations: a,
  toggleShowAllCitations: i,
  hasMoreCitations: o
}) => /* @__PURE__ */ R.jsxs("div", { children: [
  /* @__PURE__ */ R.jsx(
    "div",
    {
      ref: r,
      className: "grid gap-2",
      style: {
        gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`
      },
      children: t.map((s, l) => /* @__PURE__ */ R.jsxs(
        is,
        {
          height: "85px",
          padding: "space40",
          display: "flex",
          flexDirection: "column",
          cursor: "pointer",
          justifyContent: "space-between",
          className: "hover:shadow",
          onClick: () => e(s.uri),
          fontSize: "fontSize20",
          children: [
            /* @__PURE__ */ R.jsx(
              _r,
              {
                style: {
                  fontWeight: "bold",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                },
                children: s.title
              }
            ),
            /* @__PURE__ */ R.jsxs(
              _r,
              {
                color: "colorTextWeak",
                display: "flex",
                alignItems: "center",
                columnGap: "space20",
                fontSize: "fontSize10",
                children: [
                  /* @__PURE__ */ R.jsx(V3e, { decorative: !0, size: "sizeIcon05" }),
                  s.sourceName
                ]
              }
            )
          ]
        },
        l
      ))
    }
  ),
  o && /* @__PURE__ */ R.jsx(_r, { display: "flex", justifyContent: "center", marginTop: "space40", children: /* @__PURE__ */ R.jsxs(as, { variant: "link", onClick: i, children: [
    "View ",
    a ? "less" : "more",
    " sources",
    a ? /* @__PURE__ */ R.jsx(Zht, { decorative: !0, size: "sizeIcon40" }) : /* @__PURE__ */ R.jsx(H3e, { decorative: !0, size: "sizeIcon40" })
  ] }) })
] }), Jht = ({
  retrievedKnowledge: t,
  showAllCitations: e,
  setShowAllCitations: r
}) => {
  const [n, a] = nlt(), i = /* @__PURE__ */ new Set(), o = [];
  for (const h of t)
    i.has(h.uri) || (i.add(h.uri), o.push(h));
  const s = (h) => {
    window.open(h, "_blank", "noopener,noreferrer");
  }, l = a ? Math.floor(a / 200) : 1, c = e ? o : o.slice(0, l), u = o.length > l, f = () => {
    r((h) => !h);
  };
  return /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsx(
    len,
    {
      retrievedKnowledge: c,
      handleOpenLink: s,
      containerRef: n,
      citationsPerLine: l,
      showAllCitations: e,
      toggleShowAllCitations: f,
      hasMoreCitations: u
    }
  ) });
};
function xc(t) {
  this.content = t;
}
xc.prototype = {
  constructor: xc,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, r) {
    var n = r && r != t ? this.remove(r) : this, a = n.find(t), i = n.content.slice();
    return a == -1 ? i.push(r || t, e) : (i[a + 1] = e, r && (i[a] = r)), new xc(i);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var r = this.content.slice();
    return r.splice(e, 2), new xc(r);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new xc([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var r = this.remove(t).content.slice();
    return r.push(t, e), new xc(r);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, r) {
    var n = this.remove(e), a = n.content.slice(), i = n.find(t);
    return a.splice(i == -1 ? a.length : i, 0, e, r), new xc(a);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = xc.from(t), t.size ? new xc(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = xc.from(t), t.size ? new xc(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = xc.from(t);
    for (var r = 0; r < t.content.length; r += 2)
      e = e.remove(t.content[r]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, r) {
      t[e] = r;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
xc.from = function(t) {
  if (t instanceof xc) return t;
  var e = [];
  if (t) for (var r in t) e.push(r, t[r]);
  return new xc(e);
};
function Yht(t, e, r) {
  for (let n = 0; ; n++) {
    if (n == t.childCount || n == e.childCount)
      return t.childCount == e.childCount ? null : r;
    let a = t.child(n), i = e.child(n);
    if (a == i) {
      r += a.nodeSize;
      continue;
    }
    if (!a.sameMarkup(i))
      return r;
    if (a.isText && a.text != i.text) {
      for (let o = 0; a.text[o] == i.text[o]; o++)
        r++;
      return r;
    }
    if (a.content.size || i.content.size) {
      let o = Yht(a.content, i.content, r + 1);
      if (o != null)
        return o;
    }
    r += a.nodeSize;
  }
}
function Xht(t, e, r, n) {
  for (let a = t.childCount, i = e.childCount; ; ) {
    if (a == 0 || i == 0)
      return a == i ? null : { a: r, b: n };
    let o = t.child(--a), s = e.child(--i), l = o.nodeSize;
    if (o == s) {
      r -= l, n -= l;
      continue;
    }
    if (!o.sameMarkup(s))
      return { a: r, b: n };
    if (o.isText && o.text != s.text) {
      let c = 0, u = Math.min(o.text.length, s.text.length);
      for (; c < u && o.text[o.text.length - c - 1] == s.text[s.text.length - c - 1]; )
        c++, r--, n--;
      return { a: r, b: n };
    }
    if (o.content.size || s.content.size) {
      let c = Xht(o.content, s.content, r - 1, n - 1);
      if (c)
        return c;
    }
    r -= l, n -= l;
  }
}
class Mr {
  /**
  @internal
  */
  constructor(e, r) {
    if (this.content = e, this.size = r || 0, r == null)
      for (let n = 0; n < e.length; n++)
        this.size += e[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, r, n, a = 0, i) {
    for (let o = 0, s = 0; s < r; o++) {
      let l = this.content[o], c = s + l.nodeSize;
      if (c > e && n(l, a + s, i || null, o) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, r - u), n, a + u);
      }
      s = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, r, n, a) {
    let i = "", o = !0;
    return this.nodesBetween(e, r, (s, l) => {
      let c = s.isText ? s.text.slice(Math.max(e, l) - l, r - l) : s.isLeaf ? a ? typeof a == "function" ? a(s) : a : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && c || s.isTextblock) && n && (o ? o = !1 : i += n), i += c;
    }, 0), i;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let r = this.lastChild, n = e.firstChild, a = this.content.slice(), i = 0;
    for (r.isText && r.sameMarkup(n) && (a[a.length - 1] = r.withText(r.text + n.text), i = 1); i < e.content.length; i++)
      a.push(e.content[i]);
    return new Mr(a, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, r = this.size) {
    if (e == 0 && r == this.size)
      return this;
    let n = [], a = 0;
    if (r > e)
      for (let i = 0, o = 0; o < r; i++) {
        let s = this.content[i], l = o + s.nodeSize;
        l > e && ((o < e || l > r) && (s.isText ? s = s.cut(Math.max(0, e - o), Math.min(s.text.length, r - o)) : s = s.cut(Math.max(0, e - o - 1), Math.min(s.content.size, r - o - 1))), n.push(s), a += s.nodeSize), o = l;
      }
    return new Mr(n, a);
  }
  /**
  @internal
  */
  cutByIndex(e, r) {
    return e == r ? Mr.empty : e == 0 && r == this.content.length ? this : new Mr(this.content.slice(e, r));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, r) {
    let n = this.content[e];
    if (n == r)
      return this;
    let a = this.content.slice(), i = this.size + r.nodeSize - n.nodeSize;
    return a[e] = r, new Mr(a, i);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new Mr([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new Mr(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let r = 0; r < this.content.length; r++)
      if (!this.content[r].eq(e.content[r]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let r = this.content[e];
    if (!r)
      throw new RangeError("Index " + e + " out of range for " + this);
    return r;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let r = 0, n = 0; r < this.content.length; r++) {
      let a = this.content[r];
      e(a, n, r), n += a.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, r = 0) {
    return Yht(this, e, r);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, r = this.size, n = e.size) {
    return Xht(this, e, r, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, r = -1) {
    if (e == 0)
      return gN(0, e);
    if (e == this.size)
      return gN(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, a = 0; ; n++) {
      let i = this.child(n), o = a + i.nodeSize;
      if (o >= e)
        return o == e || r > 0 ? gN(n + 1, o) : gN(n, a);
      a = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return Mr.empty;
    if (!Array.isArray(r))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Mr(r.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return Mr.empty;
    let r, n = 0;
    for (let a = 0; a < e.length; a++) {
      let i = e[a];
      n += i.nodeSize, a && i.isText && e[a - 1].sameMarkup(i) ? (r || (r = e.slice(0, a)), r[r.length - 1] = i.withText(r[r.length - 1].text + i.text)) : r && r.push(i);
    }
    return new Mr(r || e, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return Mr.empty;
    if (e instanceof Mr)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new Mr([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Mr.empty = new Mr([], 0);
const Pie = { index: 0, offset: 0 };
function gN(t, e) {
  return Pie.index = t, Pie.offset = e, Pie;
}
function EF(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let r = Array.isArray(t);
  if (Array.isArray(e) != r)
    return !1;
  if (r) {
    if (t.length != e.length)
      return !1;
    for (let n = 0; n < t.length; n++)
      if (!EF(t[n], e[n]))
        return !1;
  } else {
    for (let n in t)
      if (!(n in e) || !EF(t[n], e[n]))
        return !1;
    for (let n in e)
      if (!(n in t))
        return !1;
  }
  return !0;
}
let qo = class vfe {
  /**
  @internal
  */
  constructor(e, r) {
    this.type = e, this.attrs = r;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let r, n = !1;
    for (let a = 0; a < e.length; a++) {
      let i = e[a];
      if (this.eq(i))
        return e;
      if (this.type.excludes(i.type))
        r || (r = e.slice(0, a));
      else {
        if (i.type.excludes(this.type))
          return e;
        !n && i.type.rank > this.type.rank && (r || (r = e.slice(0, a)), r.push(this), n = !0), r && r.push(i);
      }
    }
    return r || (r = e.slice()), n || r.push(this), r;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return e.slice(0, r).concat(e.slice(r + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (this.eq(e[r]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && EF(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = e.marks[r.type];
    if (!n)
      throw new RangeError(`There is no mark type ${r.type} in this schema`);
    let a = n.create(r.attrs);
    return n.checkAttrs(a.attrs), a;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, r) {
    if (e == r)
      return !0;
    if (e.length != r.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!e[n].eq(r[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return vfe.none;
    if (e instanceof vfe)
      return [e];
    let r = e.slice();
    return r.sort((n, a) => n.type.rank - a.type.rank), r;
  }
};
qo.none = [];
class IF extends Error {
}
class hn {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, r, n) {
    this.content = e, this.openStart = r, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, r) {
    let n = ept(this.content, e + this.openStart, r);
    return n && new hn(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, r) {
    return new hn(Qht(this.content, e + this.openStart, r + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      return hn.empty;
    let n = r.openStart || 0, a = r.openEnd || 0;
    if (typeof n != "number" || typeof a != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new hn(Mr.fromJSON(e, r.content), n, a);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, r = !0) {
    let n = 0, a = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (r || !i.type.spec.isolating); i = i.firstChild)
      n++;
    for (let i = e.lastChild; i && !i.isLeaf && (r || !i.type.spec.isolating); i = i.lastChild)
      a++;
    return new hn(e, n, a);
  }
}
hn.empty = new hn(Mr.empty, 0, 0);
function Qht(t, e, r) {
  let { index: n, offset: a } = t.findIndex(e), i = t.maybeChild(n), { index: o, offset: s } = t.findIndex(r);
  if (a == e || i.isText) {
    if (s != r && !t.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(r));
  }
  if (n != o)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(n, i.copy(Qht(i.content, e - a - 1, r - a - 1)));
}
function ept(t, e, r, n) {
  let { index: a, offset: i } = t.findIndex(e), o = t.maybeChild(a);
  if (i == e || o.isText)
    return t.cut(0, e).append(r).append(t.cut(e));
  let s = ept(o.content, e - i - 1, r);
  return s && t.replaceChild(a, o.copy(s));
}
function cen(t, e, r) {
  if (r.openStart > t.depth)
    throw new IF("Inserted content deeper than insertion position");
  if (t.depth - r.openStart != e.depth - r.openEnd)
    throw new IF("Inconsistent open depths");
  return tpt(t, e, r, 0);
}
function tpt(t, e, r, n) {
  let a = t.index(n), i = t.node(n);
  if (a == e.index(n) && n < t.depth - r.openStart) {
    let o = tpt(t, e, r, n + 1);
    return i.copy(i.content.replaceChild(a, o));
  } else if (r.content.size)
    if (!r.openStart && !r.openEnd && t.depth == n && e.depth == n) {
      let o = t.parent, s = o.content;
      return qb(o, s.cut(0, t.parentOffset).append(r.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: o, end: s } = uen(r, t);
      return qb(i, npt(t, o, s, e, n));
    }
  else return qb(i, MF(t, e, n));
}
function rpt(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new IF("Cannot join " + e.type.name + " onto " + t.type.name);
}
function yfe(t, e, r) {
  let n = t.node(r);
  return rpt(n, e.node(r)), n;
}
function Vb(t, e) {
  let r = e.length - 1;
  r >= 0 && t.isText && t.sameMarkup(e[r]) ? e[r] = t.withText(e[r].text + t.text) : e.push(t);
}
function Z_(t, e, r, n) {
  let a = (e || t).node(r), i = 0, o = e ? e.index(r) : a.childCount;
  t && (i = t.index(r), t.depth > r ? i++ : t.textOffset && (Vb(t.nodeAfter, n), i++));
  for (let s = i; s < o; s++)
    Vb(a.child(s), n);
  e && e.depth == r && e.textOffset && Vb(e.nodeBefore, n);
}
function qb(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function npt(t, e, r, n, a) {
  let i = t.depth > a && yfe(t, e, a + 1), o = n.depth > a && yfe(r, n, a + 1), s = [];
  return Z_(null, t, a, s), i && o && e.index(a) == r.index(a) ? (rpt(i, o), Vb(qb(i, npt(t, e, r, n, a + 1)), s)) : (i && Vb(qb(i, MF(t, e, a + 1)), s), Z_(e, r, a, s), o && Vb(qb(o, MF(r, n, a + 1)), s)), Z_(n, null, a, s), new Mr(s);
}
function MF(t, e, r) {
  let n = [];
  if (Z_(null, t, r, n), t.depth > r) {
    let a = yfe(t, e, r + 1);
    Vb(qb(a, MF(t, e, r + 1)), n);
  }
  return Z_(e, null, r, n), new Mr(n);
}
function uen(t, e) {
  let r = e.depth - t.openStart, a = e.node(r).copy(t.content);
  for (let i = r - 1; i >= 0; i--)
    a = e.node(i).copy(Mr.from(a));
  return {
    start: a.resolveNoCache(t.openStart + r),
    end: a.resolveNoCache(a.content.size - t.openEnd - r)
  };
}
class lI {
  /**
  @internal
  */
  constructor(e, r, n) {
    this.pos = e, this.path = r, this.parentOffset = n, this.depth = r.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, r = this.index(this.depth);
    if (r == e.childCount)
      return null;
    let n = this.pos - this.path[this.path.length - 1], a = e.child(r);
    return n ? e.child(r).cut(n) : a;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), r = this.pos - this.path[this.path.length - 1];
    return r ? this.parent.child(e).cut(0, r) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, r) {
    r = this.resolveDepth(r);
    let n = this.path[r * 3], a = r == 0 ? 0 : this.path[r * 3 - 1] + 1;
    for (let i = 0; i < e; i++)
      a += n.child(i).nodeSize;
    return a;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, r = this.index();
    if (e.content.size == 0)
      return qo.none;
    if (this.textOffset)
      return e.child(r).marks;
    let n = e.maybeChild(r - 1), a = e.maybeChild(r);
    if (!n) {
      let s = n;
      n = a, a = s;
    }
    let i = n.marks;
    for (var o = 0; o < i.length; o++)
      i[o].type.spec.inclusive === !1 && (!a || !i[o].isInSet(a.marks)) && (i = i[o--].removeFromSet(i));
    return i;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let r = this.parent.maybeChild(this.index());
    if (!r || !r.isInline)
      return null;
    let n = r.marks, a = e.parent.maybeChild(e.index());
    for (var i = 0; i < n.length; i++)
      n[i].type.spec.inclusive === !1 && (!a || !n[i].isInSet(a.marks)) && (n = n[i--].removeFromSet(n));
    return n;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let r = this.depth; r > 0; r--)
      if (this.start(r) <= e && this.end(r) >= e)
        return r;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, r) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let n = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); n >= 0; n--)
      if (e.pos <= this.end(n) && (!r || r(this.node(n))))
        return new PF(this, e, n);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let r = 1; r <= this.depth; r++)
      e += (e ? "/" : "") + this.node(r).type.name + "_" + this.index(r - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, r) {
    if (!(r >= 0 && r <= e.content.size))
      throw new RangeError("Position " + r + " out of range");
    let n = [], a = 0, i = r;
    for (let o = e; ; ) {
      let { index: s, offset: l } = o.content.findIndex(i), c = i - l;
      if (n.push(o, s, a + l), !c || (o = o.child(s), o.isText))
        break;
      i = c - 1, a += l + 1;
    }
    return new lI(r, n, i);
  }
  /**
  @internal
  */
  static resolveCached(e, r) {
    let n = xLe.get(e);
    if (n)
      for (let i = 0; i < n.elts.length; i++) {
        let o = n.elts[i];
        if (o.pos == r)
          return o;
      }
    else
      xLe.set(e, n = new den());
    let a = n.elts[n.i] = lI.resolve(e, r);
    return n.i = (n.i + 1) % fen, a;
  }
}
class den {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const fen = 12, xLe = /* @__PURE__ */ new WeakMap();
class PF {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, r, n) {
    this.$from = e, this.$to = r, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const hen = /* @__PURE__ */ Object.create(null);
let Dv = class bfe {
  /**
  @internal
  */
  constructor(e, r, n, a = qo.none) {
    this.type = e, this.attrs = r, this.marks = a, this.content = n || Mr.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, r, n, a = 0) {
    this.content.nodesBetween(e, r, n, a, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, r, n, a) {
    return this.content.textBetween(e, r, n, a);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, r, n) {
    return this.type == e && EF(this.attrs, r || e.defaultAttrs || hen) && qo.sameSet(this.marks, n || qo.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new bfe(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new bfe(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, r = this.content.size) {
    return e == 0 && r == this.content.size ? this : this.copy(this.content.cut(e, r));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, r = this.content.size, n = !1) {
    if (e == r)
      return hn.empty;
    let a = this.resolve(e), i = this.resolve(r), o = n ? 0 : a.sharedDepth(r), s = a.start(o), c = a.node(o).content.cut(a.pos - s, i.pos - s);
    return new hn(c, a.depth - o, i.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, r, n) {
    return cen(this.resolve(e), this.resolve(r), n);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let r = this; ; ) {
      let { index: n, offset: a } = r.content.findIndex(e);
      if (r = r.maybeChild(n), !r)
        return null;
      if (a == e || r.isText)
        return r;
      e -= a + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: r, offset: n } = this.content.findIndex(e);
    return { node: this.content.maybeChild(r), index: r, offset: n };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: r, offset: n } = this.content.findIndex(e);
    if (n < e)
      return { node: this.content.child(r), index: r, offset: n };
    let a = this.content.child(r - 1);
    return { node: a, index: r - 1, offset: n - a.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return lI.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return lI.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, r, n) {
    let a = !1;
    return r > e && this.nodesBetween(e, r, (i) => (n.isInSet(i.marks) && (a = !0), !a)), a;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), apt(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let r = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!r)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return r;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, r, n = Mr.empty, a = 0, i = n.childCount) {
    let o = this.contentMatchAt(e).matchFragment(n, a, i), s = o && o.matchFragment(this.content, r);
    if (!s || !s.validEnd)
      return !1;
    for (let l = a; l < i; l++)
      if (!this.type.allowsMarks(n.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, r, n, a) {
    if (a && !this.type.allowsMarks(a))
      return !1;
    let i = this.contentMatchAt(e).matchType(n), o = i && i.matchFragment(this.content, r);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = qo.none;
    for (let r = 0; r < this.marks.length; r++) {
      let n = this.marks[r];
      n.type.checkAttrs(n.attrs), e = n.addToSet(e);
    }
    if (!qo.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((r) => r.type.name)}`);
    this.content.forEach((r) => r.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let r in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((r) => r.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, r) {
    if (!r)
      throw new RangeError("Invalid input for Node.fromJSON");
    let n;
    if (r.marks) {
      if (!Array.isArray(r.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      n = r.marks.map(e.markFromJSON);
    }
    if (r.type == "text") {
      if (typeof r.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(r.text, n);
    }
    let a = Mr.fromJSON(e, r.content), i = e.nodeType(r.type).create(r.attrs, a, n);
    return i.type.checkAttrs(i.attrs), i;
  }
};
Dv.prototype.text = void 0;
class RF extends Dv {
  /**
  @internal
  */
  constructor(e, r, n, a) {
    if (super(e, r, null, a), !n)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = n;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : apt(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, r) {
    return this.text.slice(e, r);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new RF(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new RF(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, r = this.text.length) {
    return e == 0 && r == this.text.length ? this : this.withText(this.text.slice(e, r));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function apt(t, e) {
  for (let r = t.length - 1; r >= 0; r--)
    e = t[r].type.name + "(" + e + ")";
  return e;
}
class L5 {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, r) {
    let n = new pen(e, r);
    if (n.next == null)
      return L5.empty;
    let a = ipt(n);
    n.next && n.err("Unexpected trailing text");
    let i = Cen(xen(a));
    return wen(i, n), i;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let r = 0; r < this.next.length; r++)
      if (this.next[r].type == e)
        return this.next[r].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, r = 0, n = e.childCount) {
    let a = this;
    for (let i = r; a && i < n; i++)
      a = a.matchType(e.child(i).type);
    return a;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: r } = this.next[e];
      if (!(r.isText || r.hasRequiredAttrs()))
        return r;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let r = 0; r < this.next.length; r++)
      for (let n = 0; n < e.next.length; n++)
        if (this.next[r].type == e.next[n].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, r = !1, n = 0) {
    let a = [this];
    function i(o, s) {
      let l = o.matchFragment(e, n);
      if (l && (!r || l.validEnd))
        return Mr.from(s.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: u, next: f } = o.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && a.indexOf(f) == -1) {
          a.push(f);
          let h = i(f, s.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return i(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let n = 0; n < this.wrapCache.length; n += 2)
      if (this.wrapCache[n] == e)
        return this.wrapCache[n + 1];
    let r = this.computeWrapping(e);
    return this.wrapCache.push(e, r), r;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let r = /* @__PURE__ */ Object.create(null), n = [{ match: this, type: null, via: null }];
    for (; n.length; ) {
      let a = n.shift(), i = a.match;
      if (i.matchType(e)) {
        let o = [];
        for (let s = a; s.type; s = s.via)
          o.push(s.type);
        return o.reverse();
      }
      for (let o = 0; o < i.next.length; o++) {
        let { type: s, next: l } = i.next[o];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in r) && (!a.type || l.validEnd) && (n.push({ match: s.contentMatch, type: s, via: a }), r[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function r(n) {
      e.push(n);
      for (let a = 0; a < n.next.length; a++)
        e.indexOf(n.next[a].next) == -1 && r(n.next[a].next);
    }
    return r(this), e.map((n, a) => {
      let i = a + (n.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < n.next.length; o++)
        i += (o ? ", " : "") + n.next[o].type.name + "->" + e.indexOf(n.next[o].next);
      return i;
    }).join(`
`);
  }
}
L5.empty = new L5(!0);
class pen {
  constructor(e, r) {
    this.string = e, this.nodeTypes = r, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function ipt(t) {
  let e = [];
  do
    e.push(men(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function men(t) {
  let e = [];
  do
    e.push(gen(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function gen(t) {
  let e = ben(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = ven(t, e);
    else
      break;
  return e;
}
function CLe(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function ven(t, e) {
  let r = CLe(t), n = r;
  return t.eat(",") && (t.next != "}" ? n = CLe(t) : n = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: r, max: n, expr: e };
}
function yen(t, e) {
  let r = t.nodeTypes, n = r[e];
  if (n)
    return [n];
  let a = [];
  for (let i in r) {
    let o = r[i];
    o.isInGroup(e) && a.push(o);
  }
  return a.length == 0 && t.err("No node type or group '" + e + "' found"), a;
}
function ben(t) {
  if (t.eat("(")) {
    let e = ipt(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = yen(t, t.next).map((r) => (t.inline == null ? t.inline = r.isInline : t.inline != r.isInline && t.err("Mixing inline and block content"), { type: "name", value: r }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function xen(t) {
  let e = [[]];
  return a(i(t, 0), r()), e;
  function r() {
    return e.push([]) - 1;
  }
  function n(o, s, l) {
    let c = { term: l, to: s };
    return e[o].push(c), c;
  }
  function a(o, s) {
    o.forEach((l) => l.to = s);
  }
  function i(o, s) {
    if (o.type == "choice")
      return o.exprs.reduce((l, c) => l.concat(i(c, s)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let c = i(o.exprs[l], s);
        if (l == o.exprs.length - 1)
          return c;
        a(c, s = r());
      }
    else if (o.type == "star") {
      let l = r();
      return n(s, l), a(i(o.expr, l), l), [n(l)];
    } else if (o.type == "plus") {
      let l = r();
      return a(i(o.expr, s), l), a(i(o.expr, l), l), [n(l)];
    } else {
      if (o.type == "opt")
        return [n(s)].concat(i(o.expr, s));
      if (o.type == "range") {
        let l = s;
        for (let c = 0; c < o.min; c++) {
          let u = r();
          a(i(o.expr, l), u), l = u;
        }
        if (o.max == -1)
          a(i(o.expr, l), l);
        else
          for (let c = o.min; c < o.max; c++) {
            let u = r();
            n(l, u), a(i(o.expr, l), u), l = u;
          }
        return [n(l)];
      } else {
        if (o.type == "name")
          return [n(s, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function opt(t, e) {
  return e - t;
}
function wLe(t, e) {
  let r = [];
  return n(e), r.sort(opt);
  function n(a) {
    let i = t[a];
    if (i.length == 1 && !i[0].term)
      return n(i[0].to);
    r.push(a);
    for (let o = 0; o < i.length; o++) {
      let { term: s, to: l } = i[o];
      !s && r.indexOf(l) == -1 && n(l);
    }
  }
}
function Cen(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return r(wLe(t, 0));
  function r(n) {
    let a = [];
    n.forEach((o) => {
      t[o].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let c;
        for (let u = 0; u < a.length; u++)
          a[u][0] == s && (c = a[u][1]);
        wLe(t, l).forEach((u) => {
          c || a.push([s, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let i = e[n.join(",")] = new L5(n.indexOf(t.length - 1) > -1);
    for (let o = 0; o < a.length; o++) {
      let s = a[o][1].sort(opt);
      i.next.push({ type: a[o][0], next: e[s.join(",")] || r(s) });
    }
    return i;
  }
}
function wen(t, e) {
  for (let r = 0, n = [t]; r < n.length; r++) {
    let a = n[r], i = !a.validEnd, o = [];
    for (let s = 0; s < a.next.length; s++) {
      let { type: l, next: c } = a.next[s];
      o.push(l.name), i && !(l.isText || l.hasRequiredAttrs()) && (i = !1), n.indexOf(c) == -1 && n.push(c);
    }
    i && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function spt(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let r in t) {
    let n = t[r];
    if (!n.hasDefault)
      return null;
    e[r] = n.default;
  }
  return e;
}
function lpt(t, e) {
  let r = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let a = e && e[n];
    if (a === void 0) {
      let i = t[n];
      if (i.hasDefault)
        a = i.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    r[n] = a;
  }
  return r;
}
function cpt(t, e, r, n) {
  for (let a in e)
    if (!(a in t))
      throw new RangeError(`Unsupported attribute ${a} for ${r} of type ${a}`);
  for (let a in t) {
    let i = t[a];
    i.validate && i.validate(e[a]);
  }
}
function upt(t, e) {
  let r = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let n in e)
      r[n] = new _en(t, n, e[n]);
  return r;
}
let SLe = class dpt {
  /**
  @internal
  */
  constructor(e, r, n) {
    this.name = e, this.schema = r, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = upt(e, n.attrs), this.defaultAttrs = spt(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == L5.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : lpt(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, r, n) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new Dv(this, this.computeAttrs(e), Mr.from(r), qo.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, r, n) {
    return r = Mr.from(r), this.checkContent(r), new Dv(this, this.computeAttrs(e), r, qo.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, r, n) {
    if (e = this.computeAttrs(e), r = Mr.from(r), r.size) {
      let o = this.contentMatch.fillBefore(r);
      if (!o)
        return null;
      r = o.append(r);
    }
    let a = this.contentMatch.matchFragment(r), i = a && a.fillBefore(Mr.empty, !0);
    return i ? new Dv(this, e, r.append(i), qo.setFrom(n)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let r = this.contentMatch.matchFragment(e);
    if (!r || !r.validEnd)
      return !1;
    for (let n = 0; n < e.childCount; n++)
      if (!this.allowsMarks(e.child(n).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    cpt(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let r = 0; r < e.length; r++)
      if (!this.allowsMarkType(e[r].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let r;
    for (let n = 0; n < e.length; n++)
      this.allowsMarkType(e[n].type) ? r && r.push(e[n]) : r || (r = e.slice(0, n));
    return r ? r.length ? r : qo.none : e;
  }
  /**
  @internal
  */
  static compile(e, r) {
    let n = /* @__PURE__ */ Object.create(null);
    e.forEach((i, o) => n[i] = new dpt(i, r, o));
    let a = r.spec.topNode || "doc";
    if (!n[a])
      throw new RangeError("Schema is missing its top node type ('" + a + "')");
    if (!n.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let i in n.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return n;
  }
};
function Sen(t, e, r) {
  let n = r.split("|");
  return (a) => {
    let i = a === null ? "null" : typeof a;
    if (n.indexOf(i) < 0)
      throw new RangeError(`Expected value of type ${n} for attribute ${e} on type ${t}, got ${i}`);
  };
}
class _en {
  constructor(e, r, n) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(n, "default"), this.default = n.default, this.validate = typeof n.validate == "string" ? Sen(e, r, n.validate) : n.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class MH {
  /**
  @internal
  */
  constructor(e, r, n, a) {
    this.name = e, this.rank = r, this.schema = n, this.spec = a, this.attrs = upt(e, a.attrs), this.excluded = null;
    let i = spt(this.attrs);
    this.instance = i ? new qo(this, i) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new qo(this, lpt(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, r) {
    let n = /* @__PURE__ */ Object.create(null), a = 0;
    return e.forEach((i, o) => n[i] = new MH(i, a++, r, o)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var r = 0; r < e.length; r++)
      e[r].type == this && (e = e.slice(0, r).concat(e.slice(r + 1)), r--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let r = 0; r < e.length; r++)
      if (e[r].type == this)
        return e[r];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    cpt(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class fpt {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let r = this.spec = {};
    for (let a in e)
      r[a] = e[a];
    r.nodes = xc.from(e.nodes), r.marks = xc.from(e.marks || {}), this.nodes = SLe.compile(this.spec.nodes, this), this.marks = MH.compile(this.spec.marks, this);
    let n = /* @__PURE__ */ Object.create(null);
    for (let a in this.nodes) {
      if (a in this.marks)
        throw new RangeError(a + " can not be both a node and a mark");
      let i = this.nodes[a], o = i.spec.content || "", s = i.spec.marks;
      if (i.contentMatch = n[o] || (n[o] = L5.parse(o, this.nodes)), i.inlineContent = i.contentMatch.inlineContent, i.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!i.isInline || !i.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = i;
      }
      i.markSet = s == "_" ? null : s ? _Le(this, s.split(" ")) : s == "" || !i.inlineContent ? [] : null;
    }
    for (let a in this.marks) {
      let i = this.marks[a], o = i.spec.excludes;
      i.excluded = o == null ? [i] : o == "" ? [] : _Le(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, r = null, n, a) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof SLe) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(r, n, a);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, r) {
    let n = this.nodes.text;
    return new RF(n, n.defaultAttrs, e, qo.setFrom(r));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, r) {
    return typeof e == "string" && (e = this.marks[e]), e.create(r);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return Dv.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return qo.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let r = this.nodes[e];
    if (!r)
      throw new RangeError("Unknown node type: " + e);
    return r;
  }
}
function _Le(t, e) {
  let r = [];
  for (let n = 0; n < e.length; n++) {
    let a = e[n], i = t.marks[a], o = i;
    if (i)
      r.push(i);
    else
      for (let s in t.marks) {
        let l = t.marks[s];
        (a == "_" || l.spec.group && l.spec.group.split(" ").indexOf(a) > -1) && r.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[n] + "'");
  }
  return r;
}
function ken(t) {
  return t.tag != null;
}
function Aen(t) {
  return t.style != null;
}
class Lv {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, r) {
    this.schema = e, this.rules = r, this.tags = [], this.styles = [];
    let n = this.matchedStyles = [];
    r.forEach((a) => {
      if (ken(a))
        this.tags.push(a);
      else if (Aen(a)) {
        let i = /[^=]*/.exec(a.style)[0];
        n.indexOf(i) < 0 && n.push(i), this.styles.push(a);
      }
    }), this.normalizeLists = !this.tags.some((a) => {
      if (!/^(ul|ol)\b/.test(a.tag) || !a.node)
        return !1;
      let i = e.nodes[a.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, r = {}) {
    let n = new ALe(this, r, !1);
    return n.addAll(e, qo.none, r.from, r.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, r = {}) {
    let n = new ALe(this, r, !0);
    return n.addAll(e, qo.none, r.from, r.to), hn.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(e, r, n) {
    for (let a = n ? this.tags.indexOf(n) + 1 : 0; a < this.tags.length; a++) {
      let i = this.tags[a];
      if (Ien(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || r.matchesContext(i.context))) {
        if (i.getAttrs) {
          let o = i.getAttrs(e);
          if (o === !1)
            continue;
          i.attrs = o || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, r, n, a) {
    for (let i = a ? this.styles.indexOf(a) + 1 : 0; i < this.styles.length; i++) {
      let o = this.styles[i], s = o.style;
      if (!(s.indexOf(e) != 0 || o.context && !n.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != r))) {
        if (o.getAttrs) {
          let l = o.getAttrs(r);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let r = [];
    function n(a) {
      let i = a.priority == null ? 50 : a.priority, o = 0;
      for (; o < r.length; o++) {
        let s = r[o];
        if ((s.priority == null ? 50 : s.priority) < i)
          break;
      }
      r.splice(o, 0, a);
    }
    for (let a in e.marks) {
      let i = e.marks[a].spec.parseDOM;
      i && i.forEach((o) => {
        n(o = TLe(o)), o.mark || o.ignore || o.clearMark || (o.mark = a);
      });
    }
    for (let a in e.nodes) {
      let i = e.nodes[a].spec.parseDOM;
      i && i.forEach((o) => {
        n(o = TLe(o)), o.node || o.ignore || o.mark || (o.node = a);
      });
    }
    return r;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Lv(e, Lv.schemaRules(e)));
  }
}
const hpt = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Ten = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, ppt = { ol: !0, ul: !0 }, cI = 1, xfe = 2, R$ = 4;
function kLe(t, e, r) {
  return e != null ? (e ? cI : 0) | (e === "full" ? xfe : 0) : t && t.whitespace == "pre" ? cI | xfe : r & -5;
}
class vN {
  constructor(e, r, n, a, i, o) {
    this.type = e, this.attrs = r, this.marks = n, this.solid = a, this.options = o, this.content = [], this.activeMarks = qo.none, this.match = i || (o & R$ ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let r = this.type.contentMatch.fillBefore(Mr.from(e));
      if (r)
        this.match = this.type.contentMatch.matchFragment(r);
      else {
        let n = this.type.contentMatch, a;
        return (a = n.findWrapping(e.type)) ? (this.match = n, a) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & cI)) {
      let n = this.content[this.content.length - 1], a;
      if (n && n.isText && (a = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let i = n;
        n.text.length == a[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - a[0].length));
      }
    }
    let r = Mr.from(this.content);
    return !e && this.match && (r = r.append(this.match.fillBefore(Mr.empty, !0))), this.type ? this.type.create(this.attrs, r, this.marks) : r;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !hpt.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class ALe {
  constructor(e, r, n) {
    this.parser = e, this.options = r, this.isOpen = n, this.open = 0, this.localPreserveWS = !1;
    let a = r.topNode, i, o = kLe(null, r.preserveWhitespace, 0) | (n ? R$ : 0);
    a ? i = new vN(a.type, a.attrs, qo.none, !0, r.topMatch || a.type.contentMatch, o) : n ? i = new vN(null, null, qo.none, !0, null, o) : i = new vN(e.schema.topNodeType, null, qo.none, !0, null, o), this.nodes = [i], this.find = r.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, r) {
    e.nodeType == 3 ? this.addTextNode(e, r) : e.nodeType == 1 && this.addElement(e, r);
  }
  addTextNode(e, r) {
    let n = e.nodeValue, a = this.top, i = a.options & xfe ? "full" : this.localPreserveWS || (a.options & cI) > 0;
    if (i === "full" || a.inlineContext(e) || /[^ \t\r\n\u000c]/.test(n)) {
      if (i)
        i !== "full" ? n = n.replace(/\r?\n|\r/g, " ") : n = n.replace(/\r\n?/g, `
`);
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let o = a.content[a.content.length - 1], s = e.previousSibling;
        (!o || s && s.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (n = n.slice(1));
      }
      n && this.insertNode(this.parser.schema.text(n), r), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, r, n) {
    let a = this.localPreserveWS, i = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), s;
    ppt.hasOwnProperty(o) && this.parser.normalizeLists && Een(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, n));
    e: if (l ? l.ignore : Ten.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, r);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (hpt.hasOwnProperty(o))
        i.content.length && i.content[0].isInline && this.open && (this.open--, i = this.top), c = !0, i.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, r);
        break e;
      }
      let f = l && l.skip ? r : this.readStyles(e, r);
      f && this.addAll(e, f), c && this.sync(i), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, r);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? s : void 0);
    }
    this.localPreserveWS = a;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, r) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), r);
  }
  // Called for ignored nodes
  ignoreFallback(e, r) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), r);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, r) {
    let n = e.style;
    if (n && n.length)
      for (let a = 0; a < this.parser.matchedStyles.length; a++) {
        let i = this.parser.matchedStyles[a], o = n.getPropertyValue(i);
        if (o)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(i, o, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? r = r.filter((c) => !l.clearMark(c)) : r = r.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return r;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, r, n, a) {
    let i, o;
    if (r.node)
      if (o = this.parser.schema.nodes[r.node], o.isLeaf)
        this.insertNode(o.create(r.attrs), n) || this.leafFallback(e, n);
      else {
        let l = this.enter(o, r.attrs || null, n, r.preserveWhitespace);
        l && (i = !0, n = l);
      }
    else {
      let l = this.parser.schema.marks[r.mark];
      n = n.concat(l.create(r.attrs));
    }
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (a)
      this.addElement(e, n, a);
    else if (r.getContent)
      this.findInside(e), r.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, n));
    else {
      let l = e;
      typeof r.contentElement == "string" ? l = e.querySelector(r.contentElement) : typeof r.contentElement == "function" ? l = r.contentElement(e) : r.contentElement && (l = r.contentElement), this.findAround(e, l, !0), this.addAll(l, n), this.findAround(e, l, !1);
    }
    i && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, r, n, a) {
    let i = n || 0;
    for (let o = n ? e.childNodes[n] : e.firstChild, s = a == null ? null : e.childNodes[a]; o != s; o = o.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(o, r);
    this.findAtPoint(e, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, r) {
    let n, a;
    for (let i = this.open; i >= 0; i--) {
      let o = this.nodes[i], s = o.findWrapping(e);
      if (s && (!n || n.length > s.length) && (n = s, a = o, !s.length) || o.solid)
        break;
    }
    if (!n)
      return null;
    this.sync(a);
    for (let i = 0; i < n.length; i++)
      r = this.enterInner(n[i], null, r, !1);
    return r;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let a = this.textblockFromContext();
      a && (r = this.enterInner(a, null, r));
    }
    let n = this.findPlace(e, r);
    if (n) {
      this.closeExtra();
      let a = this.top;
      a.match && (a.match = a.match.matchType(e.type));
      let i = qo.none;
      for (let o of n.concat(e.marks))
        (a.type ? a.type.allowsMarkType(o.type) : ELe(o.type, e.type)) && (i = o.addToSet(i));
      return a.content.push(e.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, r, n, a) {
    let i = this.findPlace(e.create(r), n);
    return i && (i = this.enterInner(e, r, n, !0, a)), i;
  }
  // Open a node of the given type
  enterInner(e, r, n, a = !1, i) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let s = kLe(e, i, o.options);
    o.options & R$ && o.content.length == 0 && (s |= R$);
    let l = qo.none;
    return n = n.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : ELe(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new vN(e, r, l, a, null, s)), this.open++, n;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let r = this.nodes.length - 1;
    if (r > this.open) {
      for (; r > this.open; r--)
        this.nodes[r - 1].content.push(this.nodes[r].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let r = this.open; r >= 0; r--) {
      if (this.nodes[r] == e)
        return this.open = r, !0;
      this.localPreserveWS && (this.nodes[r].options |= cI);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let r = this.open; r >= 0; r--) {
      let n = this.nodes[r].content;
      for (let a = n.length - 1; a >= 0; a--)
        e += n[a].nodeSize;
      r && e++;
    }
    return e;
  }
  findAtPoint(e, r) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && this.find[n].offset == r && (this.find[n].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && (this.find[r].pos = this.currentPos);
  }
  findAround(e, r, n) {
    if (e != r && this.find)
      for (let a = 0; a < this.find.length; a++)
        this.find[a].pos == null && e.nodeType == 1 && e.contains(this.find[a].node) && r.compareDocumentPosition(this.find[a].node) & (n ? 2 : 4) && (this.find[a].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && (this.find[r].pos = this.currentPos - (e.nodeValue.length - this.find[r].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let r = e.split("/"), n = this.options.context, a = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), i = -(n ? n.depth + 1 : 0) + (a ? 0 : 1), o = (s, l) => {
      for (; s >= 0; s--) {
        let c = r[s];
        if (c == "") {
          if (s == r.length - 1 || s == 0)
            continue;
          for (; l >= i; l--)
            if (o(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && a ? this.nodes[l].type : n && l >= i ? n.node(l - i).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(r.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let r = e.depth; r >= 0; r--) {
        let n = e.node(r).contentMatchAt(e.indexAfter(r)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let r in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[r];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
}
function Een(t) {
  for (let e = t.firstChild, r = null; e; e = e.nextSibling) {
    let n = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    n && ppt.hasOwnProperty(n) && r ? (r.appendChild(e), e = r) : n == "li" ? r = e : n && (r = null);
  }
}
function Ien(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function TLe(t) {
  let e = {};
  for (let r in t)
    e[r] = t[r];
  return e;
}
function ELe(t, e) {
  let r = e.schema.nodes;
  for (let n in r) {
    let a = r[n];
    if (!a.allowsMarkType(t))
      continue;
    let i = [], o = (s) => {
      i.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: c, next: u } = s.edge(l);
        if (c == e || i.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(a.contentMatch))
      return !0;
  }
}
class _6 {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, r) {
    this.nodes = e, this.marks = r;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, r = {}, n) {
    n || (n = Rie(r).createDocumentFragment());
    let a = n, i = [];
    return e.forEach((o) => {
      if (i.length || o.marks.length) {
        let s = 0, l = 0;
        for (; s < i.length && l < o.marks.length; ) {
          let c = o.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(i[s][0]) || c.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < i.length; )
          a = i.pop()[1];
        for (; l < o.marks.length; ) {
          let c = o.marks[l++], u = this.serializeMark(c, o.isInline, r);
          u && (i.push([c, a]), a.appendChild(u.dom), a = u.contentDOM || u.dom);
        }
      }
      a.appendChild(this.serializeNodeInner(o, r));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(e, r) {
    let { dom: n, contentDOM: a } = O$(Rie(r), this.nodes[e.type.name](e), null, e.attrs);
    if (a) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, r, a);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, r = {}) {
    let n = this.serializeNodeInner(e, r);
    for (let a = e.marks.length - 1; a >= 0; a--) {
      let i = this.serializeMark(e.marks[a], e.isInline, r);
      i && ((i.contentDOM || i.dom).appendChild(n), n = i.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(e, r, n = {}) {
    let a = this.marks[e.type.name];
    return a && O$(Rie(n), a(e, r), null, e.attrs);
  }
  static renderSpec(e, r, n = null, a) {
    return O$(e, r, n, a);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new _6(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let r = ILe(e.nodes);
    return r.text || (r.text = (n) => n.text), r;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return ILe(e.marks);
  }
}
function ILe(t) {
  let e = {};
  for (let r in t) {
    let n = t[r].spec.toDOM;
    n && (e[r] = n);
  }
  return e;
}
function Rie(t) {
  return t.document || window.document;
}
const MLe = /* @__PURE__ */ new WeakMap();
function Men(t) {
  let e = MLe.get(t);
  return e === void 0 && MLe.set(t, e = Pen(t)), e;
}
function Pen(t) {
  let e = null;
  function r(n) {
    if (n && typeof n == "object")
      if (Array.isArray(n))
        if (typeof n[0] == "string")
          e || (e = []), e.push(n);
        else
          for (let a = 0; a < n.length; a++)
            r(n[a]);
      else
        for (let a in n)
          r(n[a]);
  }
  return r(t), e;
}
function O$(t, e, r, n) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let a = e[0], i;
  if (typeof a != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (n && (i = Men(n)) && i.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = a.indexOf(" ");
  o > 0 && (r = a.slice(0, o), a = a.slice(o + 1));
  let s, l = r ? t.createElementNS(r, a) : t.createElement(a), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let f in c)
      if (c[f] != null) {
        let h = f.indexOf(" ");
        h > 0 ? l.setAttributeNS(f.slice(0, h), f.slice(h + 1), c[f]) : l.setAttribute(f, c[f]);
      }
  }
  for (let f = u; f < e.length; f++) {
    let h = e[f];
    if (h === 0) {
      if (f < e.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: p, contentDOM: g } = O$(t, h, r, n);
      if (l.appendChild(p), g) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = g;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const mpt = 65535, gpt = Math.pow(2, 16);
function Ren(t, e) {
  return t + e * gpt;
}
function PLe(t) {
  return t & mpt;
}
function Oen(t) {
  return (t - (t & mpt)) / gpt;
}
const vpt = 1, ypt = 2, B$ = 4, bpt = 8;
class Cfe {
  /**
  @internal
  */
  constructor(e, r, n) {
    this.pos = e, this.delInfo = r, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & bpt) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (vpt | B$)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (ypt | B$)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & B$) > 0;
  }
}
class n0 {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, r = !1) {
    if (this.ranges = e, this.inverted = r, !e.length && n0.empty)
      return n0.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let r = 0, n = PLe(e);
    if (!this.inverted)
      for (let a = 0; a < n; a++)
        r += this.ranges[a * 3 + 2] - this.ranges[a * 3 + 1];
    return this.ranges[n * 3] + r + Oen(e);
  }
  mapResult(e, r = 1) {
    return this._map(e, r, !1);
  }
  map(e, r = 1) {
    return this._map(e, r, !0);
  }
  /**
  @internal
  */
  _map(e, r, n) {
    let a = 0, i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? a : 0);
      if (l > e)
        break;
      let c = this.ranges[s + i], u = this.ranges[s + o], f = l + c;
      if (e <= f) {
        let h = c ? e == l ? -1 : e == f ? 1 : r : r, p = l + a + (h < 0 ? 0 : u);
        if (n)
          return p;
        let g = e == (r < 0 ? l : f) ? null : Ren(s / 3, e - l), y = e == l ? ypt : e == f ? vpt : B$;
        return (r < 0 ? e != l : e != f) && (y |= bpt), new Cfe(p, y, g);
      }
      a += u - c;
    }
    return n ? e + a : new Cfe(e + a, 0, null);
  }
  /**
  @internal
  */
  touches(e, r) {
    let n = 0, a = PLe(r), i = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? n : 0);
      if (l > e)
        break;
      let c = this.ranges[s + i], u = l + c;
      if (e <= u && s == a * 3)
        return !0;
      n += this.ranges[s + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let r = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let a = 0, i = 0; a < this.ranges.length; a += 3) {
      let o = this.ranges[a], s = o - (this.inverted ? i : 0), l = o + (this.inverted ? 0 : i), c = this.ranges[a + r], u = this.ranges[a + n];
      e(s, s + c, l, l + u), i += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new n0(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? n0.empty : new n0(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
n0.empty = new n0([]);
class uI {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, r, n = 0, a = e ? e.length : 0) {
    this.mirror = r, this.from = n, this.to = a, this._maps = e || [], this.ownData = !(e || r);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, r = this.maps.length) {
    return new uI(this._maps, this.mirror, e, r);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, r) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), r != null && this.setMirror(this._maps.length - 1, r);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let r = 0, n = this._maps.length; r < e._maps.length; r++) {
      let a = e.getMirror(r);
      this.appendMap(e._maps[r], a != null && a < r ? n + a : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let r = 0; r < this.mirror.length; r++)
        if (this.mirror[r] == e)
          return this.mirror[r + (r % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, r) {
    this.mirror || (this.mirror = []), this.mirror.push(e, r);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let r = e.maps.length - 1, n = this._maps.length + e._maps.length; r >= 0; r--) {
      let a = e.getMirror(r);
      this.appendMap(e._maps[r].invert(), a != null && a > r ? n - a - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new uI();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, r = 1) {
    if (this.mirror)
      return this._map(e, r, !0);
    for (let n = this.from; n < this.to; n++)
      e = this._maps[n].map(e, r);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, r = 1) {
    return this._map(e, r, !1);
  }
  /**
  @internal
  */
  _map(e, r, n) {
    let a = 0;
    for (let i = this.from; i < this.to; i++) {
      let o = this._maps[i], s = o.mapResult(e, r);
      if (s.recover != null) {
        let l = this.getMirror(i);
        if (l != null && l > i && l < this.to) {
          i = l, e = this._maps[l].recover(s.recover);
          continue;
        }
      }
      a |= s.delInfo, e = s.pos;
    }
    return n ? e : new Cfe(e, a, null);
  }
}
const Oie = /* @__PURE__ */ Object.create(null);
class au {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return n0.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, r) {
    if (!r || !r.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = Oie[r.stepType];
    if (!n)
      throw new RangeError(`No step type ${r.stepType} defined`);
    return n.fromJSON(e, r);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, r) {
    if (e in Oie)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Oie[e] = r, r.prototype.jsonID = e, r;
  }
}
class Sl {
  /**
  @internal
  */
  constructor(e, r) {
    this.doc = e, this.failed = r;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Sl(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Sl(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, r, n, a) {
    try {
      return Sl.ok(e.replace(r, n, a));
    } catch (i) {
      if (i instanceof IF)
        return Sl.fail(i.message);
      throw i;
    }
  }
}
function q3e(t, e, r) {
  let n = [];
  for (let a = 0; a < t.childCount; a++) {
    let i = t.child(a);
    i.content.size && (i = i.copy(q3e(i.content, e, i))), i.isInline && (i = e(i, r, a)), n.push(i);
  }
  return Mr.fromArray(n);
}
class Tv extends au {
  /**
  Create a mark step.
  */
  constructor(e, r, n) {
    super(), this.from = e, this.to = r, this.mark = n;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), n = e.resolve(this.from), a = n.node(n.sharedDepth(this.to)), i = new hn(q3e(r.content, (o, s) => !o.isAtom || !s.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), a), r.openStart, r.openEnd);
    return Sl.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new sh(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new Tv(r.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof Tv && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Tv(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Tv(r.from, r.to, e.markFromJSON(r.mark));
  }
}
au.jsonID("addMark", Tv);
class sh extends au {
  /**
  Create a mark-removing step.
  */
  constructor(e, r, n) {
    super(), this.from = e, this.to = r, this.mark = n;
  }
  apply(e) {
    let r = e.slice(this.from, this.to), n = new hn(q3e(r.content, (a) => a.mark(this.mark.removeFromSet(a.marks)), e), r.openStart, r.openEnd);
    return Sl.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new Tv(this.from, this.to, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return r.deleted && n.deleted || r.pos >= n.pos ? null : new sh(r.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof sh && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new sh(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new sh(r.from, r.to, e.markFromJSON(r.mark));
  }
}
au.jsonID("removeMark", sh);
class Ev extends au {
  /**
  Create a node mark step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return Sl.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.addToSet(r.marks));
    return Sl.fromReplace(e, this.pos, this.pos + 1, new hn(Mr.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    if (r) {
      let n = this.mark.addToSet(r.marks);
      if (n.length == r.marks.length) {
        for (let a = 0; a < r.marks.length; a++)
          if (!r.marks[a].isInSet(n))
            return new Ev(this.pos, r.marks[a]);
        return new Ev(this.pos, this.mark);
      }
    }
    return new t8(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new Ev(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ev(r.pos, e.markFromJSON(r.mark));
  }
}
au.jsonID("addNodeMark", Ev);
class t8 extends au {
  /**
  Create a mark-removing step.
  */
  constructor(e, r) {
    super(), this.pos = e, this.mark = r;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return Sl.fail("No node at mark step's position");
    let n = r.type.create(r.attrs, null, this.mark.removeFromSet(r.marks));
    return Sl.fromReplace(e, this.pos, this.pos + 1, new hn(Mr.from(n), 0, r.isLeaf ? 0 : 1));
  }
  invert(e) {
    let r = e.nodeAt(this.pos);
    return !r || !this.mark.isInSet(r.marks) ? this : new Ev(this.pos, this.mark);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new t8(r.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new t8(r.pos, e.markFromJSON(r.mark));
  }
}
au.jsonID("removeNodeMark", t8);
class rc extends au {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, r, n, a = !1) {
    super(), this.from = e, this.to = r, this.slice = n, this.structure = a;
  }
  apply(e) {
    return this.structure && wfe(e, this.from, this.to) ? Sl.fail("Structure replace would overwrite content") : Sl.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new n0([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new rc(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let r = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return r.deletedAcross && n.deletedAcross ? null : new rc(r.pos, Math.max(r.pos, n.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof rc) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let r = this.slice.size + e.slice.size == 0 ? hn.empty : new hn(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new rc(this.from, this.to + (e.to - e.from), r, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let r = this.slice.size + e.slice.size == 0 ? hn.empty : new hn(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new rc(e.from, this.to, r, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new rc(r.from, r.to, hn.fromJSON(e, r.slice), !!r.structure);
  }
}
au.jsonID("replace", rc);
class ac extends au {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, r, n, a, i, o, s = !1) {
    super(), this.from = e, this.to = r, this.gapFrom = n, this.gapTo = a, this.slice = i, this.insert = o, this.structure = s;
  }
  apply(e) {
    if (this.structure && (wfe(e, this.from, this.gapFrom) || wfe(e, this.gapTo, this.to)))
      return Sl.fail("Structure gap-replace would overwrite content");
    let r = e.slice(this.gapFrom, this.gapTo);
    if (r.openStart || r.openEnd)
      return Sl.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, r.content);
    return n ? Sl.fromReplace(e, this.from, this.to, n) : Sl.fail("Content does not fit in gap");
  }
  getMap() {
    return new n0([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let r = this.gapTo - this.gapFrom;
    return new ac(this.from, this.from + this.slice.size + r, this.from + this.insert, this.from + this.insert + r, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let r = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1), a = this.from == this.gapFrom ? r.pos : e.map(this.gapFrom, -1), i = this.to == this.gapTo ? n.pos : e.map(this.gapTo, 1);
    return r.deletedAcross && n.deletedAcross || a < r.pos || i > n.pos ? null : new ac(r.pos, n.pos, a, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.from != "number" || typeof r.to != "number" || typeof r.gapFrom != "number" || typeof r.gapTo != "number" || typeof r.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new ac(r.from, r.to, r.gapFrom, r.gapTo, hn.fromJSON(e, r.slice), r.insert, !!r.structure);
  }
}
au.jsonID("replaceAround", ac);
function wfe(t, e, r) {
  let n = t.resolve(e), a = r - e, i = n.depth;
  for (; a > 0 && i > 0 && n.indexAfter(i) == n.node(i).childCount; )
    i--, a--;
  if (a > 0) {
    let o = n.node(i).maybeChild(n.indexAfter(i));
    for (; a > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, a--;
    }
  }
  return !1;
}
function Ben(t, e, r, n) {
  let a = [], i = [], o, s;
  t.doc.nodesBetween(e, r, (l, c, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!n.isInSet(f) && u.type.allowsMarkType(n.type)) {
      let h = Math.max(c, e), p = Math.min(c + l.nodeSize, r), g = n.addToSet(f);
      for (let y = 0; y < f.length; y++)
        f[y].isInSet(g) || (o && o.to == h && o.mark.eq(f[y]) ? o.to = p : a.push(o = new sh(h, p, f[y])));
      s && s.to == h ? s.to = p : i.push(s = new Tv(h, p, n));
    }
  }), a.forEach((l) => t.step(l)), i.forEach((l) => t.step(l));
}
function Nen(t, e, r, n) {
  let a = [], i = 0;
  t.doc.nodesBetween(e, r, (o, s) => {
    if (!o.isInline)
      return;
    i++;
    let l = null;
    if (n instanceof MH) {
      let c = o.marks, u;
      for (; u = n.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else n ? n.isInSet(o.marks) && (l = [n]) : l = o.marks;
    if (l && l.length) {
      let c = Math.min(s + o.nodeSize, r);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], h;
        for (let p = 0; p < a.length; p++) {
          let g = a[p];
          g.step == i - 1 && f.eq(a[p].style) && (h = g);
        }
        h ? (h.to = c, h.step = i) : a.push({ style: f, from: Math.max(s, e), to: c, step: i });
      }
    }
  }), a.forEach((o) => t.step(new sh(o.from, o.to, o.style)));
}
function K3e(t, e, r, n = r.contentMatch, a = !0) {
  let i = t.doc.nodeAt(e), o = [], s = e + 1;
  for (let l = 0; l < i.childCount; l++) {
    let c = i.child(l), u = s + c.nodeSize, f = n.matchType(c.type);
    if (!f)
      o.push(new rc(s, u, hn.empty));
    else {
      n = f;
      for (let h = 0; h < c.marks.length; h++)
        r.allowsMarkType(c.marks[h].type) || t.step(new sh(s, u, c.marks[h]));
      if (a && c.isText && r.whitespace != "pre") {
        let h, p = /\r?\n|\r/g, g;
        for (; h = p.exec(c.text); )
          g || (g = new hn(Mr.from(r.schema.text(" ", r.allowedMarks(c.marks))), 0, 0)), o.push(new rc(s + h.index, s + h.index + h[0].length, g));
      }
    }
    s = u;
  }
  if (!n.validEnd) {
    let l = n.fillBefore(Mr.empty, !0);
    t.replace(s, s, new hn(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    t.step(o[l]);
}
function $en(t, e, r) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (r == t.childCount || t.canReplace(0, r));
}
function fC(t) {
  let r = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let n = t.depth; ; --n) {
    let a = t.$from.node(n), i = t.$from.index(n), o = t.$to.indexAfter(n);
    if (n < t.depth && a.canReplace(i, o, r))
      return n;
    if (n == 0 || a.type.spec.isolating || !$en(a, i, o))
      break;
  }
  return null;
}
function Den(t, e, r) {
  let { $from: n, $to: a, depth: i } = e, o = n.before(i + 1), s = a.after(i + 1), l = o, c = s, u = Mr.empty, f = 0;
  for (let g = i, y = !1; g > r; g--)
    y || n.index(g) > 0 ? (y = !0, u = Mr.from(n.node(g).copy(u)), f++) : l--;
  let h = Mr.empty, p = 0;
  for (let g = i, y = !1; g > r; g--)
    y || a.after(g + 1) < a.end(g) ? (y = !0, h = Mr.from(a.node(g).copy(h)), p++) : c++;
  t.step(new ac(l, c, o, s, new hn(u.append(h), f, p), u.size - f, !0));
}
function Z3e(t, e, r = null, n = t) {
  let a = Len(t, e), i = a && jen(n, e);
  return i ? a.map(RLe).concat({ type: e, attrs: r }).concat(i.map(RLe)) : null;
}
function RLe(t) {
  return { type: t, attrs: null };
}
function Len(t, e) {
  let { parent: r, startIndex: n, endIndex: a } = t, i = r.contentMatchAt(n).findWrapping(e);
  if (!i)
    return null;
  let o = i.length ? i[0] : e;
  return r.canReplaceWith(n, a, o) ? i : null;
}
function jen(t, e) {
  let { parent: r, startIndex: n, endIndex: a } = t, i = r.child(n), o = e.contentMatch.findWrapping(i.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = n; l && c < a; c++)
    l = l.matchType(r.child(c).type);
  return !l || !l.validEnd ? null : o;
}
function Fen(t, e, r) {
  let n = Mr.empty;
  for (let o = r.length - 1; o >= 0; o--) {
    if (n.size) {
      let s = r[o].type.contentMatch.matchFragment(n);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = Mr.from(r[o].type.create(r[o].attrs, n));
  }
  let a = e.start, i = e.end;
  t.step(new ac(a, i, a, i, new hn(n, 0, 0), r.length, !0));
}
function zen(t, e, r, n, a) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let i = t.steps.length;
  t.doc.nodesBetween(e, r, (o, s) => {
    let l = typeof a == "function" ? a(o) : a;
    if (o.isTextblock && !o.hasMarkup(n, l) && Gen(t.doc, t.mapping.slice(i).map(s), n)) {
      let c = null;
      if (n.schema.linebreakReplacement) {
        let p = n.whitespace == "pre", g = !!n.contentMatch.matchType(n.schema.linebreakReplacement);
        p && !g ? c = !1 : !p && g && (c = !0);
      }
      c === !1 && Cpt(t, o, s, i), K3e(t, t.mapping.slice(i).map(s, 1), n, void 0, c === null);
      let u = t.mapping.slice(i), f = u.map(s, 1), h = u.map(s + o.nodeSize, 1);
      return t.step(new ac(f, h, f + 1, h - 1, new hn(Mr.from(n.create(l, null, o.marks)), 0, 0), 1, !0)), c === !0 && xpt(t, o, s, i), !1;
    }
  });
}
function xpt(t, e, r, n) {
  e.forEach((a, i) => {
    if (a.isText) {
      let o, s = /\r?\n|\r/g;
      for (; o = s.exec(a.text); ) {
        let l = t.mapping.slice(n).map(r + 1 + i + o.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Cpt(t, e, r, n) {
  e.forEach((a, i) => {
    if (a.type == a.type.schema.linebreakReplacement) {
      let o = t.mapping.slice(n).map(r + 1 + i);
      t.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function Gen(t, e, r) {
  let n = t.resolve(e), a = n.index();
  return n.parent.canReplaceWith(a, a + 1, r);
}
function Wen(t, e, r, n, a) {
  let i = t.doc.nodeAt(e);
  if (!i)
    throw new RangeError("No node at given position");
  r || (r = i.type);
  let o = r.create(n, null, a || i.marks);
  if (i.isLeaf)
    return t.replaceWith(e, e + i.nodeSize, o);
  if (!r.validContent(i.content))
    throw new RangeError("Invalid content for node type " + r.name);
  t.step(new ac(e, e + i.nodeSize, e + 1, e + i.nodeSize - 1, new hn(Mr.from(o), 0, 0), 1, !0));
}
function Rm(t, e, r = 1, n) {
  let a = t.resolve(e), i = a.depth - r, o = n && n[n.length - 1] || a.parent;
  if (i < 0 || a.parent.type.spec.isolating || !a.parent.canReplace(a.index(), a.parent.childCount) || !o.type.validContent(a.parent.content.cutByIndex(a.index(), a.parent.childCount)))
    return !1;
  for (let c = a.depth - 1, u = r - 2; c > i; c--, u--) {
    let f = a.node(c), h = a.index(c);
    if (f.type.spec.isolating)
      return !1;
    let p = f.content.cutByIndex(h, f.childCount), g = n && n[u + 1];
    g && (p = p.replaceChild(0, g.type.create(g.attrs)));
    let y = n && n[u] || f;
    if (!f.canReplace(h + 1, f.childCount) || !y.type.validContent(p))
      return !1;
  }
  let s = a.indexAfter(i), l = n && n[0];
  return a.node(i).canReplaceWith(s, s, l ? l.type : a.node(i + 1).type);
}
function Hen(t, e, r = 1, n) {
  let a = t.doc.resolve(e), i = Mr.empty, o = Mr.empty;
  for (let s = a.depth, l = a.depth - r, c = r - 1; s > l; s--, c--) {
    i = Mr.from(a.node(s).copy(i));
    let u = n && n[c];
    o = Mr.from(u ? u.type.create(u.attrs, o) : a.node(s).copy(o));
  }
  t.step(new rc(e, e, new hn(i.append(o), r, r), !0));
}
function r3(t, e) {
  let r = t.resolve(e), n = r.index();
  return wpt(r.nodeBefore, r.nodeAfter) && r.parent.canReplace(n, n + 1);
}
function Uen(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let r = t.contentMatchAt(t.childCount), { linebreakReplacement: n } = t.type.schema;
  for (let a = 0; a < e.childCount; a++) {
    let i = e.child(a), o = i.type == n ? t.type.schema.nodes.text : i.type;
    if (r = r.matchType(o), !r || !t.type.allowsMarks(i.marks))
      return !1;
  }
  return r.validEnd;
}
function wpt(t, e) {
  return !!(t && e && !t.isLeaf && Uen(t, e));
}
function PH(t, e, r = -1) {
  let n = t.resolve(e);
  for (let a = n.depth; ; a--) {
    let i, o, s = n.index(a);
    if (a == n.depth ? (i = n.nodeBefore, o = n.nodeAfter) : r > 0 ? (i = n.node(a + 1), s++, o = n.node(a).maybeChild(s)) : (i = n.node(a).maybeChild(s - 1), o = n.node(a + 1)), i && !i.isTextblock && wpt(i, o) && n.node(a).canReplace(s, s + 1))
      return e;
    if (a == 0)
      break;
    e = r < 0 ? n.before(a) : n.after(a);
  }
}
function Ven(t, e, r) {
  let n = null, { linebreakReplacement: a } = t.doc.type.schema, i = t.doc.resolve(e - r), o = i.node().type;
  if (a && o.inlineContent) {
    let u = o.whitespace == "pre", f = !!o.contentMatch.matchType(a);
    u && !f ? n = !1 : !u && f && (n = !0);
  }
  let s = t.steps.length;
  if (n === !1) {
    let u = t.doc.resolve(e + r);
    Cpt(t, u.node(), u.before(), s);
  }
  o.inlineContent && K3e(t, e + r - 1, o, i.node().contentMatchAt(i.index()), n == null);
  let l = t.mapping.slice(s), c = l.map(e - r);
  if (t.step(new rc(c, l.map(e + r, -1), hn.empty, !0)), n === !0) {
    let u = t.doc.resolve(c);
    xpt(t, u.node(), u.before(), t.steps.length);
  }
  return t;
}
function qen(t, e, r) {
  let n = t.resolve(e);
  if (n.parent.canReplaceWith(n.index(), n.index(), r))
    return e;
  if (n.parentOffset == 0)
    for (let a = n.depth - 1; a >= 0; a--) {
      let i = n.index(a);
      if (n.node(a).canReplaceWith(i, i, r))
        return n.before(a + 1);
      if (i > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let a = n.depth - 1; a >= 0; a--) {
      let i = n.indexAfter(a);
      if (n.node(a).canReplaceWith(i, i, r))
        return n.after(a + 1);
      if (i < n.node(a).childCount)
        return null;
    }
  return null;
}
function Spt(t, e, r) {
  let n = t.resolve(e);
  if (!r.content.size)
    return e;
  let a = r.content;
  for (let i = 0; i < r.openStart; i++)
    a = a.firstChild.content;
  for (let i = 1; i <= (r.openStart == 0 && r.size ? 2 : 1); i++)
    for (let o = n.depth; o >= 0; o--) {
      let s = o == n.depth ? 0 : n.pos <= (n.start(o + 1) + n.end(o + 1)) / 2 ? -1 : 1, l = n.index(o) + (s > 0 ? 1 : 0), c = n.node(o), u = !1;
      if (i == 1)
        u = c.canReplace(l, l, a);
      else {
        let f = c.contentMatchAt(l).findWrapping(a.firstChild.type);
        u = f && c.canReplaceWith(l, l, f[0]);
      }
      if (u)
        return s == 0 ? n.pos : s < 0 ? n.before(o + 1) : n.after(o + 1);
    }
  return null;
}
function RH(t, e, r = e, n = hn.empty) {
  if (e == r && !n.size)
    return null;
  let a = t.resolve(e), i = t.resolve(r);
  return _pt(a, i, n) ? new rc(e, r, n) : new Ken(a, i, n).fit();
}
function _pt(t, e, r) {
  return !r.openStart && !r.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), r.content);
}
class Ken {
  constructor(e, r, n) {
    this.$from = e, this.$to = r, this.unplaced = n, this.frontier = [], this.placed = Mr.empty;
    for (let a = 0; a <= e.depth; a++) {
      let i = e.node(a);
      this.frontier.push({
        type: i.type,
        match: i.contentMatchAt(e.indexAfter(a))
      });
    }
    for (let a = e.depth; a > 0; a--)
      this.placed = Mr.from(e.node(a).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), r = this.placed.size - this.depth - this.$from.depth, n = this.$from, a = this.close(e < 0 ? this.$to : n.doc.resolve(e));
    if (!a)
      return null;
    let i = this.placed, o = n.depth, s = a.depth;
    for (; o && s && i.childCount == 1; )
      i = i.firstChild.content, o--, s--;
    let l = new hn(i, o, s);
    return e > -1 ? new ac(n.pos, e, this.$to.pos, this.$to.end(), l, r) : l.size || n.pos != this.$to.pos ? new rc(n.pos, a.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let r = this.unplaced.content, n = 0, a = this.unplaced.openEnd; n < e; n++) {
      let i = r.firstChild;
      if (r.childCount > 1 && (a = 0), i.type.spec.isolating && a <= n) {
        e = n;
        break;
      }
      r = i.content;
    }
    for (let r = 1; r <= 2; r++)
      for (let n = r == 1 ? e : this.unplaced.openStart; n >= 0; n--) {
        let a, i = null;
        n ? (i = Bie(this.unplaced.content, n - 1).firstChild, a = i.content) : a = this.unplaced.content;
        let o = a.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: c } = this.frontier[s], u, f = null;
          if (r == 1 && (o ? c.matchType(o.type) || (f = c.fillBefore(Mr.from(o), !1)) : i && l.compatibleContent(i.type)))
            return { sliceDepth: n, frontierDepth: s, parent: i, inject: f };
          if (r == 2 && o && (u = c.findWrapping(o.type)))
            return { sliceDepth: n, frontierDepth: s, parent: i, wrap: u };
          if (i && c.matchType(i.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: r, openEnd: n } = this.unplaced, a = Bie(e, r);
    return !a.childCount || a.firstChild.isLeaf ? !1 : (this.unplaced = new hn(e, r + 1, Math.max(n, a.size + r >= e.size - n ? r + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: r, openEnd: n } = this.unplaced, a = Bie(e, r);
    if (a.childCount <= 1 && r > 0) {
      let i = e.size - r <= r + a.size;
      this.unplaced = new hn(f_(e, r - 1, 1), r - 1, i ? r - 1 : n);
    } else
      this.unplaced = new hn(f_(e, r, 1), r, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: r, parent: n, inject: a, wrap: i }) {
    for (; this.depth > r; )
      this.closeFrontierNode();
    if (i)
      for (let y = 0; y < i.length; y++)
        this.openFrontierNode(i[y]);
    let o = this.unplaced, s = n ? n.content : o.content, l = o.openStart - e, c = 0, u = [], { match: f, type: h } = this.frontier[r];
    if (a) {
      for (let y = 0; y < a.childCount; y++)
        u.push(a.child(y));
      f = f.matchFragment(a);
    }
    let p = s.size + e - (o.content.size - o.openEnd);
    for (; c < s.childCount; ) {
      let y = s.child(c), b = f.matchType(y.type);
      if (!b)
        break;
      c++, (c > 1 || l == 0 || y.content.size) && (f = b, u.push(kpt(y.mark(h.allowedMarks(y.marks)), c == 1 ? l : 0, c == s.childCount ? p : -1)));
    }
    let g = c == s.childCount;
    g || (p = -1), this.placed = h_(this.placed, r, Mr.from(u)), this.frontier[r].match = f, g && p < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let y = 0, b = s; y < p; y++) {
      let w = b.lastChild;
      this.frontier.push({ type: w.type, match: w.contentMatchAt(w.childCount) }), b = w.content;
    }
    this.unplaced = g ? e == 0 ? hn.empty : new hn(f_(o.content, e - 1, 1), e - 1, p < 0 ? o.openEnd : e - 1) : new hn(f_(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], r;
    if (!e.type.isTextblock || !Nie(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (r = this.findCloseLevel(this.$to)) && r.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, a = this.$to.after(n);
    for (; n > 1 && a == this.$to.end(--n); )
      ++a;
    return a;
  }
  findCloseLevel(e) {
    e: for (let r = Math.min(this.depth, e.depth); r >= 0; r--) {
      let { match: n, type: a } = this.frontier[r], i = r < e.depth && e.end(r + 1) == e.pos + (e.depth - (r + 1)), o = Nie(e, r, a, n, i);
      if (o) {
        for (let s = r - 1; s >= 0; s--) {
          let { match: l, type: c } = this.frontier[s], u = Nie(e, s, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: r, fit: o, move: i ? e.doc.resolve(e.after(r + 1)) : e };
      }
    }
  }
  close(e) {
    let r = this.findCloseLevel(e);
    if (!r)
      return null;
    for (; this.depth > r.depth; )
      this.closeFrontierNode();
    r.fit.childCount && (this.placed = h_(this.placed, r.depth, r.fit)), e = r.move;
    for (let n = r.depth + 1; n <= e.depth; n++) {
      let a = e.node(n), i = a.type.contentMatch.fillBefore(a.content, !0, e.index(n));
      this.openFrontierNode(a.type, a.attrs, i);
    }
    return e;
  }
  openFrontierNode(e, r = null, n) {
    let a = this.frontier[this.depth];
    a.match = a.match.matchType(e), this.placed = h_(this.placed, this.depth, Mr.from(e.create(r, n))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let r = this.frontier.pop().match.fillBefore(Mr.empty, !0);
    r.childCount && (this.placed = h_(this.placed, this.frontier.length, r));
  }
}
function f_(t, e, r) {
  return e == 0 ? t.cutByIndex(r, t.childCount) : t.replaceChild(0, t.firstChild.copy(f_(t.firstChild.content, e - 1, r)));
}
function h_(t, e, r) {
  return e == 0 ? t.append(r) : t.replaceChild(t.childCount - 1, t.lastChild.copy(h_(t.lastChild.content, e - 1, r)));
}
function Bie(t, e) {
  for (let r = 0; r < e; r++)
    t = t.firstChild.content;
  return t;
}
function kpt(t, e, r) {
  if (e <= 0)
    return t;
  let n = t.content;
  return e > 1 && (n = n.replaceChild(0, kpt(n.firstChild, e - 1, n.childCount == 1 ? r - 1 : 0))), e > 0 && (n = t.type.contentMatch.fillBefore(n).append(n), r <= 0 && (n = n.append(t.type.contentMatch.matchFragment(n).fillBefore(Mr.empty, !0)))), t.copy(n);
}
function Nie(t, e, r, n, a) {
  let i = t.node(e), o = a ? t.indexAfter(e) : t.index(e);
  if (o == i.childCount && !r.compatibleContent(i.type))
    return null;
  let s = n.fillBefore(i.content, !0, o);
  return s && !Zen(r, i.content, o) ? s : null;
}
function Zen(t, e, r) {
  for (let n = r; n < e.childCount; n++)
    if (!t.allowsMarks(e.child(n).marks))
      return !0;
  return !1;
}
function Jen(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function Yen(t, e, r, n) {
  if (!n.size)
    return t.deleteRange(e, r);
  let a = t.doc.resolve(e), i = t.doc.resolve(r);
  if (_pt(a, i, n))
    return t.step(new rc(e, r, n));
  let o = Tpt(a, t.doc.resolve(r));
  o[o.length - 1] == 0 && o.pop();
  let s = -(a.depth + 1);
  o.unshift(s);
  for (let h = a.depth, p = a.pos - 1; h > 0; h--, p--) {
    let g = a.node(h).type.spec;
    if (g.defining || g.definingAsContext || g.isolating)
      break;
    o.indexOf(h) > -1 ? s = h : a.before(h) == p && o.splice(1, 0, -h);
  }
  let l = o.indexOf(s), c = [], u = n.openStart;
  for (let h = n.content, p = 0; ; p++) {
    let g = h.firstChild;
    if (c.push(g), p == n.openStart)
      break;
    h = g.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let p = c[h], g = Jen(p.type);
    if (g && !p.sameMarkup(a.node(Math.abs(s) - 1)))
      u = h;
    else if (g || !p.type.isTextblock)
      break;
  }
  for (let h = n.openStart; h >= 0; h--) {
    let p = (h + u + 1) % (n.openStart + 1), g = c[p];
    if (g)
      for (let y = 0; y < o.length; y++) {
        let b = o[(y + l) % o.length], w = !0;
        b < 0 && (w = !1, b = -b);
        let _ = a.node(b - 1), C = a.index(b - 1);
        if (_.canReplaceWith(C, C, g.type, g.marks))
          return t.replace(a.before(b), w ? i.after(b) : r, new hn(Apt(n.content, 0, n.openStart, p), p, n.openEnd));
      }
  }
  let f = t.steps.length;
  for (let h = o.length - 1; h >= 0 && (t.replace(e, r, n), !(t.steps.length > f)); h--) {
    let p = o[h];
    p < 0 || (e = a.before(p), r = i.after(p));
  }
}
function Apt(t, e, r, n, a) {
  if (e < r) {
    let i = t.firstChild;
    t = t.replaceChild(0, i.copy(Apt(i.content, e + 1, r, n, i)));
  }
  if (e > n) {
    let i = a.contentMatchAt(0), o = i.fillBefore(t).append(t);
    t = o.append(i.matchFragment(o).fillBefore(Mr.empty, !0));
  }
  return t;
}
function Xen(t, e, r, n) {
  if (!n.isInline && e == r && t.doc.resolve(e).parent.content.size) {
    let a = qen(t.doc, e, n.type);
    a != null && (e = r = a);
  }
  t.replaceRange(e, r, new hn(Mr.from(n), 0, 0));
}
function Qen(t, e, r) {
  let n = t.doc.resolve(e), a = t.doc.resolve(r), i = Tpt(n, a);
  for (let o = 0; o < i.length; o++) {
    let s = i[o], l = o == i.length - 1;
    if (l && s == 0 || n.node(s).type.contentMatch.validEnd)
      return t.delete(n.start(s), a.end(s));
    if (s > 0 && (l || n.node(s - 1).canReplace(n.index(s - 1), a.indexAfter(s - 1))))
      return t.delete(n.before(s), a.after(s));
  }
  for (let o = 1; o <= n.depth && o <= a.depth; o++)
    if (e - n.start(o) == n.depth - o && r > n.end(o) && a.end(o) - r != a.depth - o && n.start(o - 1) == a.start(o - 1) && n.node(o - 1).canReplace(n.index(o - 1), a.index(o - 1)))
      return t.delete(n.before(o), r);
  t.delete(e, r);
}
function Tpt(t, e) {
  let r = [], n = Math.min(t.depth, e.depth);
  for (let a = n; a >= 0; a--) {
    let i = t.start(a);
    if (i < t.pos - (t.depth - a) || e.end(a) > e.pos + (e.depth - a) || t.node(a).type.spec.isolating || e.node(a).type.spec.isolating)
      break;
    (i == e.start(a) || a == t.depth && a == e.depth && t.parent.inlineContent && e.parent.inlineContent && a && e.start(a - 1) == i - 1) && r.push(a);
  }
  return r;
}
class M7 extends au {
  /**
  Construct an attribute step.
  */
  constructor(e, r, n) {
    super(), this.pos = e, this.attr = r, this.value = n;
  }
  apply(e) {
    let r = e.nodeAt(this.pos);
    if (!r)
      return Sl.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in r.attrs)
      n[i] = r.attrs[i];
    n[this.attr] = this.value;
    let a = r.type.create(n, null, r.marks);
    return Sl.fromReplace(e, this.pos, this.pos + 1, new hn(Mr.from(a), 0, r.isLeaf ? 0 : 1));
  }
  getMap() {
    return n0.empty;
  }
  invert(e) {
    return new M7(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let r = e.mapResult(this.pos, 1);
    return r.deletedAfter ? null : new M7(r.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.pos != "number" || typeof r.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new M7(r.pos, r.attr, r.value);
  }
}
au.jsonID("attr", M7);
class dI extends au {
  /**
  Construct an attribute step.
  */
  constructor(e, r) {
    super(), this.attr = e, this.value = r;
  }
  apply(e) {
    let r = /* @__PURE__ */ Object.create(null);
    for (let a in e.attrs)
      r[a] = e.attrs[a];
    r[this.attr] = this.value;
    let n = e.type.create(r, e.content, e.marks);
    return Sl.ok(n);
  }
  getMap() {
    return n0.empty;
  }
  invert(e) {
    return new dI(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, r) {
    if (typeof r.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new dI(r.attr, r.value);
  }
}
au.jsonID("docAttr", dI);
let r8 = class extends Error {
};
r8 = function t(e) {
  let r = Error.call(this, e);
  return r.__proto__ = t.prototype, r;
};
r8.prototype = Object.create(Error.prototype);
r8.prototype.constructor = r8;
r8.prototype.name = "TransformError";
let etn = class {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new uI();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let r = this.maybeStep(e);
    if (r.failed)
      throw new r8(r.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let r = e.apply(this.doc);
    return r.failed || this.addStep(e, r.doc), r;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, r) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = r;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, r = e, n = hn.empty) {
    let a = RH(this.doc, e, r, n);
    return a && this.step(a), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, r, n) {
    return this.replace(e, r, new hn(Mr.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, r) {
    return this.replace(e, r, hn.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, r) {
    return this.replaceWith(e, e, r);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, r, n) {
    return Yen(this, e, r, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, r, n) {
    return Xen(this, e, r, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, r) {
    return Qen(this, e, r), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, r) {
    return Den(this, e, r), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, r = 1) {
    return Ven(this, e, r), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, r) {
    return Fen(this, e, r), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, r = e, n, a = null) {
    return zen(this, e, r, n, a), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, r, n = null, a) {
    return Wen(this, e, r, n, a), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, r, n) {
    return this.step(new M7(e, r, n)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, r) {
    return this.step(new dI(e, r)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, r) {
    return this.step(new Ev(e, r)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, r) {
    if (!(r instanceof qo)) {
      let n = this.doc.nodeAt(e);
      if (!n)
        throw new RangeError("No node at position " + e);
      if (r = r.isInSet(n.marks), !r)
        return this;
    }
    return this.step(new t8(e, r)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, r = 1, n) {
    return Hen(this, e, r, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, r, n) {
    return Ben(this, e, r, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, r, n) {
    return Nen(this, e, r, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, r, n) {
    return K3e(this, e, r, n), this;
  }
};
const $ie = /* @__PURE__ */ Object.create(null);
let Ci = class {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, r, n) {
    this.$anchor = e, this.$head = r, this.ranges = n || [new ttn(e.min(r), e.max(r))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let r = 0; r < e.length; r++)
      if (e[r].$from.pos != e[r].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, r = hn.empty) {
    let n = r.content.lastChild, a = null;
    for (let s = 0; s < r.openEnd; s++)
      a = n, n = n.lastChild;
    let i = e.steps.length, o = this.ranges;
    for (let s = 0; s < o.length; s++) {
      let { $from: l, $to: c } = o[s], u = e.mapping.slice(i);
      e.replaceRange(u.map(l.pos), u.map(c.pos), s ? hn.empty : r), s == 0 && NLe(e, i, (n ? n.isInline : a && a.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, r) {
    let n = e.steps.length, a = this.ranges;
    for (let i = 0; i < a.length; i++) {
      let { $from: o, $to: s } = a[i], l = e.mapping.slice(n), c = l.map(o.pos), u = l.map(s.pos);
      i ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, r), NLe(e, n, r.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, r, n = !1) {
    let a = e.parent.inlineContent ? new qa(e) : S9(e.node(0), e.parent, e.pos, e.index(), r, n);
    if (a)
      return a;
    for (let i = e.depth - 1; i >= 0; i--) {
      let o = r < 0 ? S9(e.node(0), e.node(i), e.before(i + 1), e.index(i), r, n) : S9(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, r, n);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, r = 1) {
    return this.findFrom(e, r) || this.findFrom(e, -r) || new f0(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return S9(e, e, 0, 0, 1) || new f0(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return S9(e, e, e.content.size, e.childCount, -1) || new f0(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, r) {
    if (!r || !r.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = $ie[r.type];
    if (!n)
      throw new RangeError(`No selection type ${r.type} defined`);
    return n.fromJSON(e, r);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, r) {
    if (e in $ie)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return $ie[e] = r, r.prototype.jsonID = e, r;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return qa.between(this.$anchor, this.$head).getBookmark();
  }
};
Ci.prototype.visible = !0;
class ttn {
  /**
  Create a range.
  */
  constructor(e, r) {
    this.$from = e, this.$to = r;
  }
}
let OLe = !1;
function BLe(t) {
  !OLe && !t.parent.inlineContent && (OLe = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class qa extends Ci {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, r = e) {
    BLe(e), BLe(r), super(e, r);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, r) {
    let n = e.resolve(r.map(this.head));
    if (!n.parent.inlineContent)
      return Ci.near(n);
    let a = e.resolve(r.map(this.anchor));
    return new qa(a.parent.inlineContent ? a : n, n);
  }
  replace(e, r = hn.empty) {
    if (super.replace(e, r), r == hn.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && e.ensureMarks(n);
    }
  }
  eq(e) {
    return e instanceof qa && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new OH(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number" || typeof r.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new qa(e.resolve(r.anchor), e.resolve(r.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, r, n = r) {
    let a = e.resolve(r);
    return new this(a, n == r ? a : e.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, r, n) {
    let a = e.pos - r.pos;
    if ((!n || a) && (n = a >= 0 ? 1 : -1), !r.parent.inlineContent) {
      let i = Ci.findFrom(r, n, !0) || Ci.findFrom(r, -n, !0);
      if (i)
        r = i.$head;
      else
        return Ci.near(r, n);
    }
    return e.parent.inlineContent || (a == 0 ? e = r : (e = (Ci.findFrom(e, -n, !0) || Ci.findFrom(e, n, !0)).$anchor, e.pos < r.pos != a < 0 && (e = r))), new qa(e, r);
  }
}
Ci.jsonID("text", qa);
class OH {
  constructor(e, r) {
    this.anchor = e, this.head = r;
  }
  map(e) {
    return new OH(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return qa.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class ea extends Ci {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let r = e.nodeAfter, n = e.node(0).resolve(e.pos + r.nodeSize);
    super(e, n), this.node = r;
  }
  map(e, r) {
    let { deleted: n, pos: a } = r.mapResult(this.anchor), i = e.resolve(a);
    return n ? Ci.near(i) : new ea(i);
  }
  content() {
    return new hn(Mr.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof ea && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new J3e(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new ea(e.resolve(r.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, r) {
    return new ea(e.resolve(r));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
ea.prototype.visible = !1;
Ci.jsonID("node", ea);
class J3e {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: r, pos: n } = e.mapResult(this.anchor);
    return r ? new OH(n, n) : new J3e(n);
  }
  resolve(e) {
    let r = e.resolve(this.anchor), n = r.nodeAfter;
    return n && ea.isSelectable(n) ? new ea(r) : Ci.near(r);
  }
}
class f0 extends Ci {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, r = hn.empty) {
    if (r == hn.empty) {
      e.delete(0, e.doc.content.size);
      let n = Ci.atStart(e.doc);
      n.eq(e.selection) || e.setSelection(n);
    } else
      super.replace(e, r);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new f0(e);
  }
  map(e) {
    return new f0(e);
  }
  eq(e) {
    return e instanceof f0;
  }
  getBookmark() {
    return rtn;
  }
}
Ci.jsonID("all", f0);
const rtn = {
  map() {
    return this;
  },
  resolve(t) {
    return new f0(t);
  }
};
function S9(t, e, r, n, a, i = !1) {
  if (e.inlineContent)
    return qa.create(t, r);
  for (let o = n - (a > 0 ? 0 : 1); a > 0 ? o < e.childCount : o >= 0; o += a) {
    let s = e.child(o);
    if (s.isAtom) {
      if (!i && ea.isSelectable(s))
        return ea.create(t, r - (a < 0 ? s.nodeSize : 0));
    } else {
      let l = S9(t, s, r + a, a < 0 ? s.childCount : 0, a, i);
      if (l)
        return l;
    }
    r += s.nodeSize * a;
  }
  return null;
}
function NLe(t, e, r) {
  let n = t.steps.length - 1;
  if (n < e)
    return;
  let a = t.steps[n];
  if (!(a instanceof rc || a instanceof ac))
    return;
  let i = t.mapping.maps[n], o;
  i.forEach((s, l, c, u) => {
    o == null && (o = u);
  }), t.setSelection(Ci.near(t.doc.resolve(o), r));
}
const $Le = 1, DLe = 2, LLe = 4;
class ntn extends etn {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | $Le) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & $Le) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= DLe, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return qo.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & DLe) > 0;
  }
  /**
  @internal
  */
  addStep(e, r) {
    super.addStep(e, r), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, r = !0) {
    let n = this.selection;
    return r && (e = e.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || qo.none))), n.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, r, n) {
    let a = this.doc.type.schema;
    if (r == null)
      return e ? this.replaceSelectionWith(a.text(e), !0) : this.deleteSelection();
    {
      if (n == null && (n = r), n = n ?? r, !e)
        return this.deleteRange(r, n);
      let i = this.storedMarks;
      if (!i) {
        let o = this.doc.resolve(r);
        i = n == r ? o.marks() : o.marksAcross(this.doc.resolve(n));
      }
      return this.replaceRangeWith(r, n, a.text(e, i)), this.selection.empty || this.setSelection(Ci.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, r) {
    return this.meta[typeof e == "string" ? e : e.key] = r, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= LLe, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & LLe) > 0;
  }
}
function jLe(t, e) {
  return !e || !t ? t : t.bind(e);
}
class p_ {
  constructor(e, r, n) {
    this.name = e, this.init = jLe(r.init, n), this.apply = jLe(r.apply, n);
  }
}
const atn = [
  new p_("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new p_("selection", {
    init(t, e) {
      return t.selection || Ci.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new p_("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, r, n) {
      return n.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new p_("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Die {
  constructor(e, r) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = atn.slice(), r && r.forEach((n) => {
      if (this.pluginsByKey[n.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + n.key + ")");
      this.plugins.push(n), this.pluginsByKey[n.key] = n, n.spec.state && this.fields.push(new p_(n.key, n.spec.state, n));
    });
  }
}
class e7 {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, r = -1) {
    for (let n = 0; n < this.config.plugins.length; n++)
      if (n != r) {
        let a = this.config.plugins[n];
        if (a.spec.filterTransaction && !a.spec.filterTransaction.call(a, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let r = [e], n = this.applyInner(e), a = null;
    for (; ; ) {
      let i = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let s = this.config.plugins[o];
        if (s.spec.appendTransaction) {
          let l = a ? a[o].n : 0, c = a ? a[o].state : this, u = l < r.length && s.spec.appendTransaction.call(s, l ? r.slice(l) : r, c, n);
          if (u && n.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", e), !a) {
              a = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                a.push(f < o ? { state: n, n: r.length } : { state: this, n: 0 });
            }
            r.push(u), n = n.applyInner(u), i = !0;
          }
          a && (a[o] = { state: n, n: r.length });
        }
      }
      if (!i)
        return { state: n, transactions: r };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let r = new e7(this.config), n = this.config.fields;
    for (let a = 0; a < n.length; a++) {
      let i = n[a];
      r[i.name] = i.apply(e, this[i.name], this, r);
    }
    return r;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new ntn(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let r = new Die(e.doc ? e.doc.type.schema : e.schema, e.plugins), n = new e7(r);
    for (let a = 0; a < r.fields.length; a++)
      n[r.fields[a].name] = r.fields[a].init(e, n);
    return n;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let r = new Die(this.schema, e.plugins), n = r.fields, a = new e7(r);
    for (let i = 0; i < n.length; i++) {
      let o = n[i].name;
      a[o] = this.hasOwnProperty(o) ? this[o] : n[i].init(e, a);
    }
    return a;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let r = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (r.storedMarks = this.storedMarks.map((n) => n.toJSON())), e && typeof e == "object")
      for (let n in e) {
        if (n == "doc" || n == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let a = e[n], i = a.spec.state;
        i && i.toJSON && (r[n] = i.toJSON.call(a, this[a.key]));
      }
    return r;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, r, n) {
    if (!r)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let a = new Die(e.schema, e.plugins), i = new e7(a);
    return a.fields.forEach((o) => {
      if (o.name == "doc")
        i.doc = Dv.fromJSON(e.schema, r.doc);
      else if (o.name == "selection")
        i.selection = Ci.fromJSON(i.doc, r.selection);
      else if (o.name == "storedMarks")
        r.storedMarks && (i.storedMarks = r.storedMarks.map(e.schema.markFromJSON));
      else {
        if (n)
          for (let s in n) {
            let l = n[s], c = l.spec.state;
            if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(r, s)) {
              i[o.name] = c.fromJSON.call(l, e, r[s], i);
              return;
            }
          }
        i[o.name] = o.init(e, i);
      }
    }), i;
  }
}
function Ept(t, e, r) {
  for (let n in t) {
    let a = t[n];
    a instanceof Function ? a = a.bind(e) : n == "handleDOMEvents" && (a = Ept(a, e, {})), r[n] = a;
  }
  return r;
}
class Bd {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Ept(e.props, this, this.props), this.key = e.key ? e.key.key : Ipt("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Lie = /* @__PURE__ */ Object.create(null);
function Ipt(t) {
  return t in Lie ? t + "$" + ++Lie[t] : (Lie[t] = 0, t + "$");
}
class lp {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Ipt(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Sc = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, n8 = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Sfe = null;
const em = function(t, e, r) {
  let n = Sfe || (Sfe = document.createRange());
  return n.setEnd(t, r ?? t.nodeValue.length), n.setStart(t, e || 0), n;
}, itn = function() {
  Sfe = null;
}, j5 = function(t, e, r, n) {
  return r && (FLe(t, e, r, n, -1) || FLe(t, e, r, n, 1));
}, otn = /^(img|br|input|textarea|hr)$/i;
function FLe(t, e, r, n, a) {
  for (; ; ) {
    if (t == r && e == n)
      return !0;
    if (e == (a < 0 ? 0 : J0(t))) {
      let i = t.parentNode;
      if (!i || i.nodeType != 1 || vP(t) || otn.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = Sc(t) + (a < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (a < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = a < 0 ? J0(t) : 0;
    } else
      return !1;
  }
}
function J0(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function stn(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = J0(t);
    } else if (t.parentNode && !vP(t))
      e = Sc(t), t = t.parentNode;
    else
      return null;
  }
}
function ltn(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !vP(t))
      e = Sc(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function ctn(t, e, r) {
  for (let n = e == 0, a = e == J0(t); n || a; ) {
    if (t == r)
      return !0;
    let i = Sc(t);
    if (t = t.parentNode, !t)
      return !1;
    n = n && i == 0, a = a && i == J0(t);
  }
}
function vP(t) {
  let e;
  for (let r = t; r && !(e = r.pmViewDesc); r = r.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const BH = function(t) {
  return t.focusNode && j5(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function sb(t, e) {
  let r = document.createEvent("Event");
  return r.initEvent("keydown", !0, !0), r.keyCode = t, r.key = r.code = e, r;
}
function utn(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function dtn(t, e, r) {
  if (t.caretPositionFromPoint)
    try {
      let n = t.caretPositionFromPoint(e, r);
      if (n)
        return { node: n.offsetNode, offset: Math.min(J0(n.offsetNode), n.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let n = t.caretRangeFromPoint(e, r);
    if (n)
      return { node: n.startContainer, offset: Math.min(J0(n.startContainer), n.startOffset) };
  }
}
const Uh = typeof navigator < "u" ? navigator : null, zLe = typeof document < "u" ? document : null, n3 = Uh && Uh.userAgent || "", _fe = /Edge\/(\d+)/.exec(n3), Mpt = /MSIE \d/.exec(n3), kfe = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(n3), vd = !!(Mpt || kfe || _fe), jv = Mpt ? document.documentMode : kfe ? +kfe[1] : _fe ? +_fe[1] : 0, Q1 = !vd && /gecko\/(\d+)/i.test(n3);
Q1 && +(/Firefox\/(\d+)/.exec(n3) || [0, 0])[1];
const Afe = !vd && /Chrome\/(\d+)/.exec(n3), Xc = !!Afe, Ppt = Afe ? +Afe[1] : 0, $u = !vd && !!Uh && /Apple Computer/.test(Uh.vendor), a8 = $u && (/Mobile\/\w+/.test(n3) || !!Uh && Uh.maxTouchPoints > 2), H0 = a8 || (Uh ? /Mac/.test(Uh.platform) : !1), ftn = Uh ? /Win/.test(Uh.platform) : !1, _m = /Android \d/.test(n3), yP = !!zLe && "webkitFontSmoothing" in zLe.documentElement.style, htn = yP ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function ptn(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function Fp(t, e) {
  return typeof t == "number" ? t : t[e];
}
function mtn(t) {
  let e = t.getBoundingClientRect(), r = e.width / t.offsetWidth || 1, n = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * r,
    top: e.top,
    bottom: e.top + t.clientHeight * n
  };
}
function GLe(t, e, r) {
  let n = t.someProp("scrollThreshold") || 0, a = t.someProp("scrollMargin") || 5, i = t.dom.ownerDocument;
  for (let o = r || t.dom; o; ) {
    if (o.nodeType != 1) {
      o = n8(o);
      continue;
    }
    let s = o, l = s == i.body, c = l ? ptn(i) : mtn(s), u = 0, f = 0;
    if (e.top < c.top + Fp(n, "top") ? f = -(c.top - e.top + Fp(a, "top")) : e.bottom > c.bottom - Fp(n, "bottom") && (f = e.bottom - e.top > c.bottom - c.top ? e.top + Fp(a, "top") - c.top : e.bottom - c.bottom + Fp(a, "bottom")), e.left < c.left + Fp(n, "left") ? u = -(c.left - e.left + Fp(a, "left")) : e.right > c.right - Fp(n, "right") && (u = e.right - c.right + Fp(a, "right")), u || f)
      if (l)
        i.defaultView.scrollBy(u, f);
      else {
        let p = s.scrollLeft, g = s.scrollTop;
        f && (s.scrollTop += f), u && (s.scrollLeft += u);
        let y = s.scrollLeft - p, b = s.scrollTop - g;
        e = { left: e.left - y, top: e.top - b, right: e.right - y, bottom: e.bottom - b };
      }
    let h = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(h))
      break;
    o = h == "absolute" ? o.offsetParent : n8(o);
  }
}
function gtn(t) {
  let e = t.dom.getBoundingClientRect(), r = Math.max(0, e.top), n, a;
  for (let i = (e.left + e.right) / 2, o = r + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let s = t.root.elementFromPoint(i, o);
    if (!s || s == t.dom || !t.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= r - 20) {
      n = s, a = l.top;
      break;
    }
  }
  return { refDOM: n, refTop: a, stack: Rpt(t.dom) };
}
function Rpt(t) {
  let e = [], r = t.ownerDocument;
  for (let n = t; n && (e.push({ dom: n, top: n.scrollTop, left: n.scrollLeft }), t != r); n = n8(n))
    ;
  return e;
}
function vtn({ refDOM: t, refTop: e, stack: r }) {
  let n = t ? t.getBoundingClientRect().top : 0;
  Opt(r, n == 0 ? 0 : n - e);
}
function Opt(t, e) {
  for (let r = 0; r < t.length; r++) {
    let { dom: n, top: a, left: i } = t[r];
    n.scrollTop != a + e && (n.scrollTop = a + e), n.scrollLeft != i && (n.scrollLeft = i);
  }
}
let c9 = null;
function ytn(t) {
  if (t.setActive)
    return t.setActive();
  if (c9)
    return t.focus(c9);
  let e = Rpt(t);
  t.focus(c9 == null ? {
    get preventScroll() {
      return c9 = { preventScroll: !0 }, !0;
    }
  } : void 0), c9 || (c9 = !1, Opt(e, 0));
}
function Bpt(t, e) {
  let r, n = 2e8, a, i = 0, o = e.top, s = e.top, l, c;
  for (let u = t.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let h;
    if (u.nodeType == 1)
      h = u.getClientRects();
    else if (u.nodeType == 3)
      h = em(u).getClientRects();
    else
      continue;
    for (let p = 0; p < h.length; p++) {
      let g = h[p];
      if (g.top <= o && g.bottom >= s) {
        o = Math.max(g.bottom, o), s = Math.min(g.top, s);
        let y = g.left > e.left ? g.left - e.left : g.right < e.left ? e.left - g.right : 0;
        if (y < n) {
          r = u, n = y, a = y && r.nodeType == 3 ? {
            left: g.right < e.left ? g.right : g.left,
            top: e.top
          } : e, u.nodeType == 1 && y && (i = f + (e.left >= (g.left + g.right) / 2 ? 1 : 0));
          continue;
        }
      } else g.top > e.top && !l && g.left <= e.left && g.right >= e.left && (l = u, c = { left: Math.max(g.left, Math.min(g.right, e.left)), top: g.top });
      !r && (e.left >= g.right && e.top >= g.top || e.left >= g.left && e.top >= g.bottom) && (i = f + 1);
    }
  }
  return !r && l && (r = l, a = c, n = 0), r && r.nodeType == 3 ? btn(r, a) : !r || n && r.nodeType == 1 ? { node: t, offset: i } : Bpt(r, a);
}
function btn(t, e) {
  let r = t.nodeValue.length, n = document.createRange();
  for (let a = 0; a < r; a++) {
    n.setEnd(t, a + 1), n.setStart(t, a);
    let i = dv(n, 1);
    if (i.top != i.bottom && Y3e(e, i))
      return { node: t, offset: a + (e.left >= (i.left + i.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function Y3e(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function xtn(t, e) {
  let r = t.parentNode;
  return r && /^li$/i.test(r.nodeName) && e.left < t.getBoundingClientRect().left ? r : t;
}
function Ctn(t, e, r) {
  let { node: n, offset: a } = Bpt(e, r), i = -1;
  if (n.nodeType == 1 && !n.firstChild) {
    let o = n.getBoundingClientRect();
    i = o.left != o.right && r.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(n, a, i);
}
function wtn(t, e, r, n) {
  let a = -1;
  for (let i = e, o = !1; i != t.dom; ) {
    let s = t.docView.nearestDesc(i, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && (!o && l.left > n.left || l.top > n.top ? a = s.posBefore : (!o && l.right < n.left || l.bottom < n.top) && (a = s.posAfter), o = !0), !s.contentDOM && a < 0 && !s.node.isText))
      return (s.node.isBlock ? n.top < (l.top + l.bottom) / 2 : n.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    i = s.dom.parentNode;
  }
  return a > -1 ? a : t.docView.posFromDOM(e, r, -1);
}
function Npt(t, e, r) {
  let n = t.childNodes.length;
  if (n && r.top < r.bottom)
    for (let a = Math.max(0, Math.min(n - 1, Math.floor(n * (e.top - r.top) / (r.bottom - r.top)) - 2)), i = a; ; ) {
      let o = t.childNodes[i];
      if (o.nodeType == 1) {
        let s = o.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let c = s[l];
          if (Y3e(e, c))
            return Npt(o, e, c);
        }
      }
      if ((i = (i + 1) % n) == a)
        break;
    }
  return t;
}
function Stn(t, e) {
  let r = t.dom.ownerDocument, n, a = 0, i = dtn(r, e.left, e.top);
  i && ({ node: n, offset: a } = i);
  let o = (t.root.elementFromPoint ? t.root : r).elementFromPoint(e.left, e.top), s;
  if (!o || !t.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = t.dom.getBoundingClientRect();
    if (!Y3e(e, c) || (o = Npt(t.dom, e, c), !o))
      return null;
  }
  if ($u)
    for (let c = o; n && c; c = n8(c))
      c.draggable && (n = void 0);
  if (o = xtn(o, e), n) {
    if (Q1 && n.nodeType == 1 && (a = Math.min(a, n.childNodes.length), a < n.childNodes.length)) {
      let u = n.childNodes[a], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= e.left && f.bottom > e.top && a++;
    }
    let c;
    yP && a && n.nodeType == 1 && (c = n.childNodes[a - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && a--, n == t.dom && a == n.childNodes.length - 1 && n.lastChild.nodeType == 1 && e.top > n.lastChild.getBoundingClientRect().bottom ? s = t.state.doc.content.size : (a == 0 || n.nodeType != 1 || n.childNodes[a - 1].nodeName != "BR") && (s = wtn(t, n, a, e));
  }
  s == null && (s = Ctn(t, o, e));
  let l = t.docView.nearestDesc(o, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function WLe(t) {
  return t.top < t.bottom || t.left < t.right;
}
function dv(t, e) {
  let r = t.getClientRects();
  if (r.length) {
    let n = r[e < 0 ? 0 : r.length - 1];
    if (WLe(n))
      return n;
  }
  return Array.prototype.find.call(r, WLe) || t.getBoundingClientRect();
}
const _tn = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function $pt(t, e, r) {
  let { node: n, offset: a, atom: i } = t.docView.domFromPos(e, r < 0 ? -1 : 1), o = yP || Q1;
  if (n.nodeType == 3)
    if (o && (_tn.test(n.nodeValue) || (r < 0 ? !a : a == n.nodeValue.length))) {
      let l = dv(em(n, a, a), r);
      if (Q1 && a && /\s/.test(n.nodeValue[a - 1]) && a < n.nodeValue.length) {
        let c = dv(em(n, a - 1, a - 1), -1);
        if (c.top == l.top) {
          let u = dv(em(n, a, a + 1), -1);
          if (u.top != l.top)
            return wS(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = a, c = a, u = r < 0 ? 1 : -1;
      return r < 0 && !a ? (c++, u = -1) : r >= 0 && a == n.nodeValue.length ? (l--, u = 1) : r < 0 ? l-- : c++, wS(dv(em(n, l, c), u), u < 0);
    }
  if (!t.state.doc.resolve(e - (i || 0)).parent.inlineContent) {
    if (i == null && a && (r < 0 || a == J0(n))) {
      let l = n.childNodes[a - 1];
      if (l.nodeType == 1)
        return jie(l.getBoundingClientRect(), !1);
    }
    if (i == null && a < J0(n)) {
      let l = n.childNodes[a];
      if (l.nodeType == 1)
        return jie(l.getBoundingClientRect(), !0);
    }
    return jie(n.getBoundingClientRect(), r >= 0);
  }
  if (i == null && a && (r < 0 || a == J0(n))) {
    let l = n.childNodes[a - 1], c = l.nodeType == 3 ? em(l, J0(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return wS(dv(c, 1), !1);
  }
  if (i == null && a < J0(n)) {
    let l = n.childNodes[a];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? em(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return wS(dv(c, -1), !0);
  }
  return wS(dv(n.nodeType == 3 ? em(n) : n, -r), r >= 0);
}
function wS(t, e) {
  if (t.width == 0)
    return t;
  let r = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: r, right: r };
}
function jie(t, e) {
  if (t.height == 0)
    return t;
  let r = e ? t.top : t.bottom;
  return { top: r, bottom: r, left: t.left, right: t.right };
}
function Dpt(t, e, r) {
  let n = t.state, a = t.root.activeElement;
  n != e && t.updateState(e), a != t.dom && t.focus();
  try {
    return r();
  } finally {
    n != e && t.updateState(n), a != t.dom && a && a.focus();
  }
}
function ktn(t, e, r) {
  let n = e.selection, a = r == "up" ? n.$from : n.$to;
  return Dpt(t, e, () => {
    let { node: i } = t.docView.domFromPos(a.pos, r == "up" ? -1 : 1);
    for (; ; ) {
      let s = t.docView.nearestDesc(i, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        i = s.contentDOM || s.dom;
        break;
      }
      i = s.dom.parentNode;
    }
    let o = $pt(t, a.pos, 1);
    for (let s = i.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = em(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (r == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const Atn = /[\u0590-\u08ac]/;
function Ttn(t, e, r) {
  let { $head: n } = e.selection;
  if (!n.parent.isTextblock)
    return !1;
  let a = n.parentOffset, i = !a, o = a == n.parent.content.size, s = t.domSelection();
  return s ? !Atn.test(n.parent.textContent) || !s.modify ? r == "left" || r == "backward" ? i : o : Dpt(t, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: f } = t.domSelectionRange(), h = s.caretBidiLevel;
    s.modify("move", r, "character");
    let p = n.depth ? t.docView.domAfterPos(n.before()) : t.dom, { focusNode: g, focusOffset: y } = t.domSelectionRange(), b = g && !p.contains(g.nodeType == 1 ? g : g.parentNode) || l == g && c == y;
    try {
      s.collapse(u, f), l && (l != u || c != f) && s.extend && s.extend(l, c);
    } catch {
    }
    return h != null && (s.caretBidiLevel = h), b;
  }) : n.pos == n.start() || n.pos == n.end();
}
let HLe = null, ULe = null, VLe = !1;
function Etn(t, e, r) {
  return HLe == e && ULe == r ? VLe : (HLe = e, ULe = r, VLe = r == "up" || r == "down" ? ktn(t, e, r) : Ttn(t, e, r));
}
const rf = 0, qLe = 1, wb = 2, Vh = 3;
class bP {
  constructor(e, r, n, a) {
    this.parent = e, this.children = r, this.dom = n, this.contentDOM = a, this.dirty = rf, n.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, r, n) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let r = 0; r < this.children.length; r++)
      e += this.children[r].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let r = 0, n = this.posAtStart; ; r++) {
      let a = this.children[r];
      if (a == e)
        return n;
      n += a.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, r, n) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (n < 0) {
        let i, o;
        if (e == this.contentDOM)
          i = e.childNodes[r - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.previousSibling;
        }
        for (; i && !((o = i.pmViewDesc) && o.parent == this); )
          i = i.previousSibling;
        return i ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let i, o;
        if (e == this.contentDOM)
          i = e.childNodes[r];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          i = e.nextSibling;
        }
        for (; i && !((o = i.pmViewDesc) && o.parent == this); )
          i = i.nextSibling;
        return i ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let a;
    if (e == this.dom && this.contentDOM)
      a = r > Sc(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      a = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (r == 0)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            a = !1;
            break;
          }
          if (i.previousSibling)
            break;
        }
      if (a == null && r == e.childNodes.length)
        for (let i = e; ; i = i.parentNode) {
          if (i == this.dom) {
            a = !0;
            break;
          }
          if (i.nextSibling)
            break;
        }
    }
    return a ?? n > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, r = !1) {
    for (let n = !0, a = e; a; a = a.parentNode) {
      let i = this.getDesc(a), o;
      if (i && (!r || i.node))
        if (n && (o = i.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          n = !1;
        else
          return i;
    }
  }
  getDesc(e) {
    let r = e.pmViewDesc;
    for (let n = r; n; n = n.parent)
      if (n == this)
        return r;
  }
  posFromDOM(e, r, n) {
    for (let a = e; a; a = a.parentNode) {
      let i = this.getDesc(a);
      if (i)
        return i.localPosFromDOM(e, r, n);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let r = 0, n = 0; r < this.children.length; r++) {
      let a = this.children[r], i = n + a.size;
      if (n == e && i != n) {
        for (; !a.border && a.children.length; )
          for (let o = 0; o < a.children.length; o++) {
            let s = a.children[o];
            if (s.size) {
              a = s;
              break;
            }
          }
        return a;
      }
      if (e < i)
        return a.descAt(e - n - a.border);
      n = i;
    }
  }
  domFromPos(e, r) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let n = 0, a = 0;
    for (let i = 0; n < this.children.length; n++) {
      let o = this.children[n], s = i + o.size;
      if (s > e || o instanceof jpt) {
        a = e - i;
        break;
      }
      i = s;
    }
    if (a)
      return this.children[n].domFromPos(a - this.children[n].border, r);
    for (let i; n && !(i = this.children[n - 1]).size && i instanceof Lpt && i.side >= 0; n--)
      ;
    if (r <= 0) {
      let i, o = !0;
      for (; i = n ? this.children[n - 1] : null, !(!i || i.dom.parentNode == this.contentDOM); n--, o = !1)
        ;
      return i && r && o && !i.border && !i.domAtom ? i.domFromPos(i.size, r) : { node: this.contentDOM, offset: i ? Sc(i.dom) + 1 : 0 };
    } else {
      let i, o = !0;
      for (; i = n < this.children.length ? this.children[n] : null, !(!i || i.dom.parentNode == this.contentDOM); n++, o = !1)
        ;
      return i && o && !i.border && !i.domAtom ? i.domFromPos(0, r) : { node: this.contentDOM, offset: i ? Sc(i.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, r, n = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: r, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let a = -1, i = -1;
    for (let o = n, s = 0; ; s++) {
      let l = this.children[s], c = o + l.size;
      if (a == -1 && e <= c) {
        let u = o + l.border;
        if (e >= u && r <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, r, u);
        e = o;
        for (let f = s; f > 0; f--) {
          let h = this.children[f - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            a = Sc(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        a == -1 && (a = 0);
      }
      if (a > -1 && (c > r || s == this.children.length - 1)) {
        r = c;
        for (let u = s + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            i = Sc(f.dom);
            break;
          }
          r += f.size;
        }
        i == -1 && (i = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: r, fromOffset: a, toOffset: i };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let r = this.children[e < 0 ? 0 : this.children.length - 1];
    return r.size == 0 || r.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: r, offset: n } = this.domFromPos(e, 0);
    if (r.nodeType != 1 || n == r.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return r.childNodes[n];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, r, n, a = !1) {
    let i = Math.min(e, r), o = Math.max(e, r);
    for (let p = 0, g = 0; p < this.children.length; p++) {
      let y = this.children[p], b = g + y.size;
      if (i > g && o < b)
        return y.setSelection(e - g - y.border, r - g - y.border, n, a);
      g = b;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = r == e ? s : this.domFromPos(r, r ? -1 : 1), c = n.root.getSelection(), u = n.domSelectionRange(), f = !1;
    if ((Q1 || $u) && e == r) {
      let { node: p, offset: g } = s;
      if (p.nodeType == 3) {
        if (f = !!(g && p.nodeValue[g - 1] == `
`), f && g == p.nodeValue.length)
          for (let y = p, b; y; y = y.parentNode) {
            if (b = y.nextSibling) {
              b.nodeName == "BR" && (s = l = { node: b.parentNode, offset: Sc(b) + 1 });
              break;
            }
            let w = y.pmViewDesc;
            if (w && w.node && w.node.isBlock)
              break;
          }
      } else {
        let y = p.childNodes[g - 1];
        f = y && (y.nodeName == "BR" || y.contentEditable == "false");
      }
    }
    if (Q1 && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let p = u.focusNode.childNodes[u.focusOffset];
      p && p.contentEditable == "false" && (a = !0);
    }
    if (!(a || f && $u) && j5(s.node, s.offset, u.anchorNode, u.anchorOffset) && j5(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let h = !1;
    if ((c.extend || e == r) && !f) {
      c.collapse(s.node, s.offset);
      try {
        e != r && c.extend(l.node, l.offset), h = !0;
      } catch {
      }
    }
    if (!h) {
      if (e > r) {
        let g = s;
        s = l, l = g;
      }
      let p = document.createRange();
      p.setEnd(l.node, l.offset), p.setStart(s.node, s.offset), c.removeAllRanges(), c.addRange(p);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, r) {
    for (let n = 0, a = 0; a < this.children.length; a++) {
      let i = this.children[a], o = n + i.size;
      if (n == o ? e <= o && r >= n : e < o && r > n) {
        let s = n + i.border, l = o - i.border;
        if (e >= s && r <= l) {
          this.dirty = e == n || r == o ? wb : qLe, e == s && r == l && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = Vh : i.markDirty(e - s, r - s);
          return;
        } else
          i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? wb : Vh;
      }
      n = o;
    }
    this.dirty = wb;
  }
  markParentsDirty() {
    let e = 1;
    for (let r = this.parent; r; r = r.parent, e++) {
      let n = e == 1 ? wb : qLe;
      r.dirty < n && (r.dirty = n);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Lpt extends bP {
  constructor(e, r, n, a) {
    let i, o = r.type.toDOM;
    if (typeof o == "function" && (o = o(n, () => {
      if (!i)
        return a;
      if (i.parent)
        return i.parent.posBeforeChild(i);
    })), !r.type.spec.raw) {
      if (o.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(o), o = s;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = r, this.widget = r, i = this;
  }
  matchesWidget(e) {
    return this.dirty == rf && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let r = this.widget.spec.stopEvent;
    return r ? r(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Itn extends bP {
  constructor(e, r, n, a) {
    super(e, [], r, null), this.textDOM = n, this.text = a;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, r) {
    return e != this.textDOM ? this.posAtStart + (r ? this.size : 0) : this.posAtStart + r;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class F5 extends bP {
  constructor(e, r, n, a, i) {
    super(e, [], n, a), this.mark = r, this.spec = i;
  }
  static create(e, r, n, a) {
    let i = a.nodeViews[r.type.name], o = i && i(r, a, n);
    return (!o || !o.dom) && (o = _6.renderSpec(document, r.type.spec.toDOM(r, n), null, r.attrs)), new F5(e, r, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & Vh || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Vh && this.mark.eq(e);
  }
  markDirty(e, r) {
    if (super.markDirty(e, r), this.dirty != rf) {
      let n = this.parent;
      for (; !n.node; )
        n = n.parent;
      n.dirty < this.dirty && (n.dirty = this.dirty), this.dirty = rf;
    }
  }
  slice(e, r, n) {
    let a = F5.create(this.parent, this.mark, !0, n), i = this.children, o = this.size;
    r < o && (i = Efe(i, r, o, n)), e > 0 && (i = Efe(i, 0, e, n));
    for (let s = 0; s < i.length; s++)
      i[s].parent = a;
    return a.children = i, a;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class Fv extends bP {
  constructor(e, r, n, a, i, o, s, l, c) {
    super(e, [], i, o), this.node = r, this.outerDeco = n, this.innerDeco = a, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, r, n, a, i, o) {
    let s = i.nodeViews[r.type.name], l, c = s && s(r, i, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, n, a), u = c && c.dom, f = c && c.contentDOM;
    if (r.isText) {
      if (!u)
        u = document.createTextNode(r.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = _6.renderSpec(document, r.type.spec.toDOM(r), null, r.attrs));
    !f && !r.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), r.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = Gpt(u, n, r), c ? l = new Mtn(e, r, n, a, u, f || null, h, c, i, o + 1) : r.isText ? new NH(e, r, n, a, u, h, i) : new Fv(e, r, n, a, u, f || null, h, i, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let r = this.children.length - 1; r >= 0; r--) {
        let n = this.children[r];
        if (this.dom.contains(n.dom.parentNode)) {
          e.contentElement = n.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => Mr.empty);
    }
    return e;
  }
  matchesNode(e, r, n) {
    return this.dirty == rf && e.eq(this.node) && OF(r, this.outerDeco) && n.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, r) {
    let n = this.node.inlineContent, a = r, i = e.composing ? this.localCompositionInfo(e, r) : null, o = i && i.pos > -1 ? i : null, s = i && i.pos < 0, l = new Rtn(this, o && o.node, e);
    Ntn(this.node, this.innerDeco, (c, u, f) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, n, e) : c.type.side >= 0 && !f && l.syncToMarks(u == this.node.childCount ? qo.none : this.node.child(u).marks, n, e), l.placeWidget(c, e, a);
    }, (c, u, f, h) => {
      l.syncToMarks(c.marks, n, e);
      let p;
      l.findNodeMatch(c, u, f, h) || s && e.state.selection.from > a && e.state.selection.to < a + c.nodeSize && (p = l.findIndexWithChild(i.node)) > -1 && l.updateNodeAt(c, u, f, p, e) || l.updateNextNode(c, u, f, e, h, a) || l.addNode(c, u, f, e, a), a += c.nodeSize;
    }), l.syncToMarks([], n, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == wb) && (o && this.protectLocalComposition(e, o), Fpt(this.contentDOM, this.children, e), a8 && $tn(this.dom));
  }
  localCompositionInfo(e, r) {
    let { from: n, to: a } = e.state.selection;
    if (!(e.state.selection instanceof qa) || n < r || a > r + this.node.content.size)
      return null;
    let i = e.input.compositionNode;
    if (!i || !this.dom.contains(i.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = i.nodeValue, s = Dtn(this.node.content, o, n - r, a - r);
      return s < 0 ? null : { node: i, pos: s, text: o };
    } else
      return { node: i, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: r, pos: n, text: a }) {
    if (this.getDesc(r))
      return;
    let i = r;
    for (; i.parentNode != this.contentDOM; i = i.parentNode) {
      for (; i.previousSibling; )
        i.parentNode.removeChild(i.previousSibling);
      for (; i.nextSibling; )
        i.parentNode.removeChild(i.nextSibling);
      i.pmViewDesc && (i.pmViewDesc = void 0);
    }
    let o = new Itn(this, i, r, a);
    e.input.compositionNodes.push(o), this.children = Efe(this.children, n, n + a.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, r, n, a) {
    return this.dirty == Vh || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, r, n, a), !0);
  }
  updateInner(e, r, n, a) {
    this.updateOuterDeco(r), this.node = e, this.innerDeco = n, this.contentDOM && this.updateChildren(a, this.posAtStart), this.dirty = rf;
  }
  updateOuterDeco(e) {
    if (OF(e, this.outerDeco))
      return;
    let r = this.nodeDOM.nodeType != 1, n = this.dom;
    this.dom = zpt(this.dom, this.nodeDOM, Tfe(this.outerDeco, this.node, r), Tfe(e, this.node, r)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function KLe(t, e, r, n, a) {
  Gpt(n, e, t);
  let i = new Fv(void 0, t, e, r, n, n, n, a, 0);
  return i.contentDOM && i.updateChildren(a, 0), i;
}
class NH extends Fv {
  constructor(e, r, n, a, i, o, s) {
    super(e, r, n, a, i, null, o, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, r, n, a) {
    return this.dirty == Vh || this.dirty != rf && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(r), (this.dirty != rf || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, a.trackWrites == this.nodeDOM && (a.trackWrites = null)), this.node = e, this.dirty = rf, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let r = this.nodeDOM; r; r = r.parentNode)
      if (r == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, r, n) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(r, this.node.text.length) : super.localPosFromDOM(e, r, n);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, r, n) {
    let a = this.node.cut(e, r), i = document.createTextNode(a.text);
    return new NH(this.parent, a, this.outerDeco, this.innerDeco, i, i, n);
  }
  markDirty(e, r) {
    super.markDirty(e, r), this.dom != this.nodeDOM && (e == 0 || r == this.nodeDOM.nodeValue.length) && (this.dirty = Vh);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class jpt extends bP {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == rf && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Mtn extends Fv {
  constructor(e, r, n, a, i, o, s, l, c, u) {
    super(e, r, n, a, i, o, s, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, r, n, a) {
    if (this.dirty == Vh)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let i = this.spec.update(e, r, n);
      return i && this.updateInner(e, r, n, a), i;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, r, n, a);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, r, n, a) {
    this.spec.setSelection ? this.spec.setSelection(e, r, n.root) : super.setSelection(e, r, n, a);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Fpt(t, e, r) {
  let n = t.firstChild, a = !1;
  for (let i = 0; i < e.length; i++) {
    let o = e[i], s = o.dom;
    if (s.parentNode == t) {
      for (; s != n; )
        n = ZLe(n), a = !0;
      n = n.nextSibling;
    } else
      a = !0, t.insertBefore(s, n);
    if (o instanceof F5) {
      let l = n ? n.previousSibling : t.lastChild;
      Fpt(o.contentDOM, o.children, r), n = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; n; )
    n = ZLe(n), a = !0;
  a && r.trackWrites == t && (r.trackWrites = null);
}
const J_ = function(t) {
  t && (this.nodeName = t);
};
J_.prototype = /* @__PURE__ */ Object.create(null);
const Sb = [new J_()];
function Tfe(t, e, r) {
  if (t.length == 0)
    return Sb;
  let n = r ? Sb[0] : new J_(), a = [n];
  for (let i = 0; i < t.length; i++) {
    let o = t[i].type.attrs;
    if (o) {
      o.nodeName && a.push(n = new J_(o.nodeName));
      for (let s in o) {
        let l = o[s];
        l != null && (r && a.length == 1 && a.push(n = new J_(e.isInline ? "span" : "div")), s == "class" ? n.class = (n.class ? n.class + " " : "") + l : s == "style" ? n.style = (n.style ? n.style + ";" : "") + l : s != "nodeName" && (n[s] = l));
      }
    }
  }
  return a;
}
function zpt(t, e, r, n) {
  if (r == Sb && n == Sb)
    return e;
  let a = e;
  for (let i = 0; i < n.length; i++) {
    let o = n[i], s = r[i];
    if (i) {
      let l;
      s && s.nodeName == o.nodeName && a != t && (l = a.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(a), s = Sb[0]), a = l;
    }
    Ptn(a, s || Sb[0], o);
  }
  return a;
}
function Ptn(t, e, r) {
  for (let n in e)
    n != "class" && n != "style" && n != "nodeName" && !(n in r) && t.removeAttribute(n);
  for (let n in r)
    n != "class" && n != "style" && n != "nodeName" && r[n] != e[n] && t.setAttribute(n, r[n]);
  if (e.class != r.class) {
    let n = e.class ? e.class.split(" ").filter(Boolean) : [], a = r.class ? r.class.split(" ").filter(Boolean) : [];
    for (let i = 0; i < n.length; i++)
      a.indexOf(n[i]) == -1 && t.classList.remove(n[i]);
    for (let i = 0; i < a.length; i++)
      n.indexOf(a[i]) == -1 && t.classList.add(a[i]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != r.style) {
    if (e.style) {
      let n = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, a;
      for (; a = n.exec(e.style); )
        t.style.removeProperty(a[1]);
    }
    r.style && (t.style.cssText += r.style);
  }
}
function Gpt(t, e, r) {
  return zpt(t, t, Sb, Tfe(e, r, t.nodeType != 1));
}
function OF(t, e) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!t[r].type.eq(e[r].type))
      return !1;
  return !0;
}
function ZLe(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class Rtn {
  constructor(e, r, n) {
    this.lock = r, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Otn(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, r) {
    if (e != r) {
      for (let n = e; n < r; n++)
        this.top.children[n].destroy();
      this.top.children.splice(e, r - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, r, n) {
    let a = 0, i = this.stack.length >> 1, o = Math.min(i, e.length);
    for (; a < o && (a == i - 1 ? this.top : this.stack[a + 1 << 1]).matchesMark(e[a]) && e[a].type.spec.spanning !== !1; )
      a++;
    for (; a < i; )
      this.destroyRest(), this.top.dirty = rf, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[i]) && !this.isLocked(c.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = F5.create(this.top, e[i], r, n);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, r, n, a) {
    let i = -1, o;
    if (a >= this.preMatch.index && (o = this.preMatch.matches[a - this.preMatch.index]).parent == this.top && o.matchesNode(e, r, n))
      i = this.top.children.indexOf(o, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let c = this.top.children[s];
        if (c.matchesNode(e, r, n) && !this.preMatch.matched.has(c)) {
          i = s;
          break;
        }
      }
    return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(e, r, n, a, i) {
    let o = this.top.children[a];
    return o.dirty == Vh && o.dom == o.contentDOM && (o.dirty = wb), o.update(e, r, n, i) ? (this.destroyBetween(this.index, a), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let r = e.parentNode;
      if (!r)
        return -1;
      if (r == this.top.contentDOM) {
        let n = e.pmViewDesc;
        if (n) {
          for (let a = this.index; a < this.top.children.length; a++)
            if (this.top.children[a] == n)
              return a;
        }
        return -1;
      }
      e = r;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, r, n, a, i, o) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof Fv) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != i)
          return !1;
        let u = l.dom, f, h = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != Vh && OF(r, l.outerDeco));
        if (!h && l.update(e, r, n, a))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!h && (f = this.recreateWrapper(l, e, r, n, a, o)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = f, f.contentDOM && (f.dirty = wb, f.updateChildren(a, o + 1), f.dirty = rf), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, r, n, a, i, o) {
    if (e.dirty || r.isAtom || !e.children.length || !e.node.content.eq(r.content) || !OF(n, e.outerDeco) || !a.eq(e.innerDeco))
      return null;
    let s = Fv.create(this.top, r, n, a, i, o);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, r, n, a, i) {
    let o = Fv.create(this.top, e, r, n, a, i);
    o.contentDOM && o.updateChildren(a, i + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, r, n) {
    let a = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (a && a.matchesWidget(e) && (e == a.widget || !a.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let i = new Lpt(this.top, e, r, n);
      this.top.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], r = this.top;
    for (; e instanceof F5; )
      r = e, e = r.children[r.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof NH) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && (($u || Xc) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", r), this.addHackNode("BR", this.top));
  }
  addHackNode(e, r) {
    if (r == this.top && this.index < r.children.length && r.children[this.index].matchesHack(e))
      this.index++;
    else {
      let n = document.createElement(e);
      e == "IMG" && (n.className = "ProseMirror-separator", n.alt = ""), e == "BR" && (n.className = "ProseMirror-trailingBreak");
      let a = new jpt(this.top, [], n, null);
      r != this.top ? r.children.push(a) : r.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Otn(t, e) {
  let r = e, n = r.children.length, a = t.childCount, i = /* @__PURE__ */ new Map(), o = [];
  e: for (; a > 0; ) {
    let s;
    for (; ; )
      if (n) {
        let c = r.children[n - 1];
        if (c instanceof F5)
          r = c, n = c.children.length;
        else {
          s = c, n--;
          break;
        }
      } else {
        if (r == e)
          break e;
        n = r.parent.children.indexOf(r), r = r.parent;
      }
    let l = s.node;
    if (l) {
      if (l != t.child(a - 1))
        break;
      --a, i.set(s, a), o.push(s);
    }
  }
  return { index: a, matched: i, matches: o.reverse() };
}
function Btn(t, e) {
  return t.type.side - e.type.side;
}
function Ntn(t, e, r, n) {
  let a = e.locals(t), i = 0;
  if (a.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let u = t.child(c);
      n(u, a, e.forChild(i, u), c), i += u.nodeSize;
    }
    return;
  }
  let o = 0, s = [], l = null;
  for (let c = 0; ; ) {
    let u, f;
    for (; o < a.length && a[o].to == i; ) {
      let b = a[o++];
      b.widget && (u ? (f || (f = [u])).push(b) : u = b);
    }
    if (u)
      if (f) {
        f.sort(Btn);
        for (let b = 0; b < f.length; b++)
          r(f[b], c, !!l);
      } else
        r(u, c, !!l);
    let h, p;
    if (l)
      p = -1, h = l, l = null;
    else if (c < t.childCount)
      p = c, h = t.child(c++);
    else
      break;
    for (let b = 0; b < s.length; b++)
      s[b].to <= i && s.splice(b--, 1);
    for (; o < a.length && a[o].from <= i && a[o].to > i; )
      s.push(a[o++]);
    let g = i + h.nodeSize;
    if (h.isText) {
      let b = g;
      o < a.length && a[o].from < b && (b = a[o].from);
      for (let w = 0; w < s.length; w++)
        s[w].to < b && (b = s[w].to);
      b < g && (l = h.cut(b - i), h = h.cut(0, b - i), g = b, p = -1);
    } else
      for (; o < a.length && a[o].to < g; )
        o++;
    let y = h.isInline && !h.isLeaf ? s.filter((b) => !b.inline) : s.slice();
    n(h, y, e.forChild(i, h), p), i = g;
  }
}
function $tn(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function Dtn(t, e, r, n) {
  for (let a = 0, i = 0; a < t.childCount && i <= n; ) {
    let o = t.child(a++), s = i;
    if (i += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; a < t.childCount; ) {
      let c = t.child(a++);
      if (i += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (i >= r) {
      if (i >= n && l.slice(n - e.length - s, n - s) == e)
        return n - e.length;
      let c = s < n ? l.lastIndexOf(e, n - s - 1) : -1;
      if (c >= 0 && c + e.length + s >= r)
        return s + c;
      if (r == n && l.length >= n + e.length - s && l.slice(n - s, n - s + e.length) == e)
        return n;
    }
  }
  return -1;
}
function Efe(t, e, r, n, a) {
  let i = [];
  for (let o = 0, s = 0; o < t.length; o++) {
    let l = t[o], c = s, u = s += l.size;
    c >= r || u <= e ? i.push(l) : (c < e && i.push(l.slice(0, e - c, n)), a && (i.push(a), a = void 0), u > r && i.push(l.slice(r - c, l.size, n)));
  }
  return i;
}
function X3e(t, e = null) {
  let r = t.domSelectionRange(), n = t.state.doc;
  if (!r.focusNode)
    return null;
  let a = t.docView.nearestDesc(r.focusNode), i = a && a.size == 0, o = t.docView.posFromDOM(r.focusNode, r.focusOffset, 1);
  if (o < 0)
    return null;
  let s = n.resolve(o), l, c;
  if (BH(r)) {
    for (l = o; a && !a.node; )
      a = a.parent;
    let f = a.node;
    if (a && f.isAtom && ea.isSelectable(f) && a.parent && !(f.isInline && ctn(r.focusNode, r.focusOffset, a.dom))) {
      let h = a.posBefore;
      c = new ea(o == h ? s : n.resolve(h));
    }
  } else {
    if (r instanceof t.dom.ownerDocument.defaultView.Selection && r.rangeCount > 1) {
      let f = o, h = o;
      for (let p = 0; p < r.rangeCount; p++) {
        let g = r.getRangeAt(p);
        f = Math.min(f, t.docView.posFromDOM(g.startContainer, g.startOffset, 1)), h = Math.max(h, t.docView.posFromDOM(g.endContainer, g.endOffset, -1));
      }
      if (f < 0)
        return null;
      [l, o] = h == t.state.selection.anchor ? [h, f] : [f, h], s = n.resolve(o);
    } else
      l = t.docView.posFromDOM(r.anchorNode, r.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = n.resolve(l);
  if (!c) {
    let f = e == "pointer" || t.state.selection.head < s.pos && !i ? 1 : -1;
    c = Q3e(t, u, s, f);
  }
  return c;
}
function Wpt(t) {
  return t.editable ? t.hasFocus() : Upt(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function Om(t, e = !1) {
  let r = t.state.selection;
  if (Hpt(t, r), !!Wpt(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && Xc) {
      let n = t.domSelectionRange(), a = t.domObserver.currentSelection;
      if (n.anchorNode && a.anchorNode && j5(n.anchorNode, n.anchorOffset, a.anchorNode, a.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      jtn(t);
    else {
      let { anchor: n, head: a } = r, i, o;
      JLe && !(r instanceof qa) && (r.$from.parent.inlineContent || (i = YLe(t, r.from)), !r.empty && !r.$from.parent.inlineContent && (o = YLe(t, r.to))), t.docView.setSelection(n, a, t, e), JLe && (i && XLe(i), o && XLe(o)), r.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Ltn(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const JLe = $u || Xc && Ppt < 63;
function YLe(t, e) {
  let { node: r, offset: n } = t.docView.domFromPos(e, 0), a = n < r.childNodes.length ? r.childNodes[n] : null, i = n ? r.childNodes[n - 1] : null;
  if ($u && a && a.contentEditable == "false")
    return Fie(a);
  if ((!a || a.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (a)
      return Fie(a);
    if (i)
      return Fie(i);
  }
}
function Fie(t) {
  return t.contentEditable = "true", $u && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function XLe(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function Ltn(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let r = t.domSelectionRange(), n = r.anchorNode, a = r.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (r.anchorNode != n || r.anchorOffset != a) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!Wpt(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function jtn(t) {
  let e = t.domSelection(), r = document.createRange();
  if (!e)
    return;
  let n = t.cursorWrapper.dom, a = n.nodeName == "IMG";
  a ? r.setStart(n.parentNode, Sc(n) + 1) : r.setStart(n, 0), r.collapse(!0), e.removeAllRanges(), e.addRange(r), !a && !t.state.selection.visible && vd && jv <= 11 && (n.disabled = !0, n.disabled = !1);
}
function Hpt(t, e) {
  if (e instanceof ea) {
    let r = t.docView.descAt(e.from);
    r != t.lastSelectedViewDesc && (QLe(t), r && r.selectNode(), t.lastSelectedViewDesc = r);
  } else
    QLe(t);
}
function QLe(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function Q3e(t, e, r, n) {
  return t.someProp("createSelectionBetween", (a) => a(t, e, r)) || qa.between(e, r, n);
}
function eje(t) {
  return t.editable && !t.hasFocus() ? !1 : Upt(t);
}
function Upt(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Ftn(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), r = t.domSelectionRange();
  return j5(e.node, e.offset, r.anchorNode, r.anchorOffset);
}
function Ife(t, e) {
  let { $anchor: r, $head: n } = t.selection, a = e > 0 ? r.max(n) : r.min(n), i = a.parent.inlineContent ? a.depth ? t.doc.resolve(e > 0 ? a.after() : a.before()) : null : a;
  return i && Ci.findFrom(i, e);
}
function pv(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function tje(t, e, r) {
  let n = t.state.selection;
  if (n instanceof qa)
    if (r.indexOf("s") > -1) {
      let { $head: a } = n, i = a.textOffset ? null : e < 0 ? a.nodeBefore : a.nodeAfter;
      if (!i || i.isText || !i.isLeaf)
        return !1;
      let o = t.state.doc.resolve(a.pos + i.nodeSize * (e < 0 ? -1 : 1));
      return pv(t, new qa(n.$anchor, o));
    } else if (n.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let a = Ife(t.state, e);
        return a && a instanceof ea ? pv(t, a) : !1;
      } else if (!(H0 && r.indexOf("m") > -1)) {
        let a = n.$head, i = a.textOffset ? null : e < 0 ? a.nodeBefore : a.nodeAfter, o;
        if (!i || i.isText)
          return !1;
        let s = e < 0 ? a.pos - i.nodeSize : a.pos;
        return i.isAtom || (o = t.docView.descAt(s)) && !o.contentDOM ? ea.isSelectable(i) ? pv(t, new ea(e < 0 ? t.state.doc.resolve(a.pos - i.nodeSize) : a)) : yP ? pv(t, new qa(t.state.doc.resolve(e < 0 ? s : s + i.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (n instanceof ea && n.node.isInline)
      return pv(t, new qa(e > 0 ? n.$to : n.$from));
    {
      let a = Ife(t.state, e);
      return a ? pv(t, a) : !1;
    }
  }
}
function BF(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Y_(t, e) {
  let r = t.pmViewDesc;
  return r && r.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function u9(t, e) {
  return e < 0 ? ztn(t) : Gtn(t);
}
function ztn(t) {
  let e = t.domSelectionRange(), r = e.focusNode, n = e.focusOffset;
  if (!r)
    return;
  let a, i, o = !1;
  for (Q1 && r.nodeType == 1 && n < BF(r) && Y_(r.childNodes[n], -1) && (o = !0); ; )
    if (n > 0) {
      if (r.nodeType != 1)
        break;
      {
        let s = r.childNodes[n - 1];
        if (Y_(s, -1))
          a = r, i = --n;
        else if (s.nodeType == 3)
          r = s, n = r.nodeValue.length;
        else
          break;
      }
    } else {
      if (Vpt(r))
        break;
      {
        let s = r.previousSibling;
        for (; s && Y_(s, -1); )
          a = r.parentNode, i = Sc(s), s = s.previousSibling;
        if (s)
          r = s, n = BF(r);
        else {
          if (r = r.parentNode, r == t.dom)
            break;
          n = 0;
        }
      }
    }
  o ? Mfe(t, r, n) : a && Mfe(t, a, i);
}
function Gtn(t) {
  let e = t.domSelectionRange(), r = e.focusNode, n = e.focusOffset;
  if (!r)
    return;
  let a = BF(r), i, o;
  for (; ; )
    if (n < a) {
      if (r.nodeType != 1)
        break;
      let s = r.childNodes[n];
      if (Y_(s, 1))
        i = r, o = ++n;
      else
        break;
    } else {
      if (Vpt(r))
        break;
      {
        let s = r.nextSibling;
        for (; s && Y_(s, 1); )
          i = s.parentNode, o = Sc(s) + 1, s = s.nextSibling;
        if (s)
          r = s, n = 0, a = BF(r);
        else {
          if (r = r.parentNode, r == t.dom)
            break;
          n = a = 0;
        }
      }
    }
  i && Mfe(t, i, o);
}
function Vpt(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Wtn(t, e) {
  for (; t && e == t.childNodes.length && !vP(t); )
    e = Sc(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let r = t.childNodes[e];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    t = r, e = 0;
  }
}
function Htn(t, e) {
  for (; t && !e && !vP(t); )
    e = Sc(t), t = t.parentNode;
  for (; t && e; ) {
    let r = t.childNodes[e - 1];
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && r.contentEditable == "false")
      break;
    t = r, e = t.childNodes.length;
  }
}
function Mfe(t, e, r) {
  if (e.nodeType != 3) {
    let i, o;
    (o = Wtn(e, r)) ? (e = o, r = 0) : (i = Htn(e, r)) && (e = i, r = i.nodeValue.length);
  }
  let n = t.domSelection();
  if (!n)
    return;
  if (BH(n)) {
    let i = document.createRange();
    i.setEnd(e, r), i.setStart(e, r), n.removeAllRanges(), n.addRange(i);
  } else n.extend && n.extend(e, r);
  t.domObserver.setCurSelection();
  let { state: a } = t;
  setTimeout(() => {
    t.state == a && Om(t);
  }, 50);
}
function rje(t, e) {
  let r = t.state.doc.resolve(e);
  if (!(Xc || ftn) && r.parent.inlineContent) {
    let a = t.coordsAtPos(e);
    if (e > r.start()) {
      let i = t.coordsAtPos(e - 1), o = (i.top + i.bottom) / 2;
      if (o > a.top && o < a.bottom && Math.abs(i.left - a.left) > 1)
        return i.left < a.left ? "ltr" : "rtl";
    }
    if (e < r.end()) {
      let i = t.coordsAtPos(e + 1), o = (i.top + i.bottom) / 2;
      if (o > a.top && o < a.bottom && Math.abs(i.left - a.left) > 1)
        return i.left > a.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function nje(t, e, r) {
  let n = t.state.selection;
  if (n instanceof qa && !n.empty || r.indexOf("s") > -1 || H0 && r.indexOf("m") > -1)
    return !1;
  let { $from: a, $to: i } = n;
  if (!a.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = Ife(t.state, e);
    if (o && o instanceof ea)
      return pv(t, o);
  }
  if (!a.parent.inlineContent) {
    let o = e < 0 ? a : i, s = n instanceof f0 ? Ci.near(o, e) : Ci.findFrom(o, e);
    return s ? pv(t, s) : !1;
  }
  return !1;
}
function aje(t, e) {
  if (!(t.state.selection instanceof qa))
    return !0;
  let { $head: r, $anchor: n, empty: a } = t.state.selection;
  if (!r.sameParent(n))
    return !0;
  if (!a)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let i = !r.textOffset && (e < 0 ? r.nodeBefore : r.nodeAfter);
  if (i && !i.isText) {
    let o = t.state.tr;
    return e < 0 ? o.delete(r.pos - i.nodeSize, r.pos) : o.delete(r.pos, r.pos + i.nodeSize), t.dispatch(o), !0;
  }
  return !1;
}
function ije(t, e, r) {
  t.domObserver.stop(), e.contentEditable = r, t.domObserver.start();
}
function Utn(t) {
  if (!$u || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: r } = t.domSelectionRange();
  if (e && e.nodeType == 1 && r == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let n = e.firstChild;
    ije(t, n, "true"), setTimeout(() => ije(t, n, "false"), 20);
  }
  return !1;
}
function Vtn(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function qtn(t, e) {
  let r = e.keyCode, n = Vtn(e);
  if (r == 8 || H0 && r == 72 && n == "c")
    return aje(t, -1) || u9(t, -1);
  if (r == 46 && !e.shiftKey || H0 && r == 68 && n == "c")
    return aje(t, 1) || u9(t, 1);
  if (r == 13 || r == 27)
    return !0;
  if (r == 37 || H0 && r == 66 && n == "c") {
    let a = r == 37 ? rje(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return tje(t, a, n) || u9(t, a);
  } else if (r == 39 || H0 && r == 70 && n == "c") {
    let a = r == 39 ? rje(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return tje(t, a, n) || u9(t, a);
  } else {
    if (r == 38 || H0 && r == 80 && n == "c")
      return nje(t, -1, n) || u9(t, -1);
    if (r == 40 || H0 && r == 78 && n == "c")
      return Utn(t) || nje(t, 1, n) || u9(t, 1);
    if (n == (H0 ? "m" : "c") && (r == 66 || r == 73 || r == 89 || r == 90))
      return !0;
  }
  return !1;
}
function ebe(t, e) {
  t.someProp("transformCopied", (p) => {
    e = p(e, t);
  });
  let r = [], { content: n, openStart: a, openEnd: i } = e;
  for (; a > 1 && i > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    a--, i--;
    let p = n.firstChild;
    r.push(p.type.name, p.attrs != p.type.defaultAttrs ? p.attrs : null), n = p.content;
  }
  let o = t.someProp("clipboardSerializer") || _6.fromSchema(t.state.schema), s = Xpt(), l = s.createElement("div");
  l.appendChild(o.serializeFragment(n, { document: s }));
  let c = l.firstChild, u, f = 0;
  for (; c && c.nodeType == 1 && (u = Ypt[c.nodeName.toLowerCase()]); ) {
    for (let p = u.length - 1; p >= 0; p--) {
      let g = s.createElement(u[p]);
      for (; l.firstChild; )
        g.appendChild(l.firstChild);
      l.appendChild(g), f++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${a} ${i}${f ? ` -${f}` : ""} ${JSON.stringify(r)}`);
  let h = t.someProp("clipboardTextSerializer", (p) => p(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: h, slice: e };
}
function qpt(t, e, r, n, a) {
  let i = a.parent.type.spec.code, o, s;
  if (!r && !e)
    return null;
  let l = e && (n || i || !r);
  if (l) {
    if (t.someProp("transformPastedText", (h) => {
      e = h(e, i || n, t);
    }), i)
      return e ? new hn(Mr.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : hn.empty;
    let f = t.someProp("clipboardTextParser", (h) => h(e, a, n, t));
    if (f)
      s = f;
    else {
      let h = a.marks(), { schema: p } = t.state, g = _6.fromSchema(p);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((y) => {
        let b = o.appendChild(document.createElement("p"));
        y && b.appendChild(g.serializeNode(p.text(y, h)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (f) => {
      r = f(r, t);
    }), o = Ytn(r), yP && Xtn(o);
  let c = o && o.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let h = o.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      o = h;
    }
  if (s || (s = (t.someProp("clipboardParser") || t.someProp("domParser") || Lv.fromSchema(t.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || u),
    context: a,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !Ktn.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = Qtn(oje(s, +u[1], +u[2]), u[4]);
  else if (s = hn.maxOpen(Ztn(s.content, a), !0), s.openStart || s.openEnd) {
    let f = 0, h = 0;
    for (let p = s.content.firstChild; f < s.openStart && !p.type.spec.isolating; f++, p = p.firstChild)
      ;
    for (let p = s.content.lastChild; h < s.openEnd && !p.type.spec.isolating; h++, p = p.lastChild)
      ;
    s = oje(s, f, h);
  }
  return t.someProp("transformPasted", (f) => {
    s = f(s, t);
  }), s;
}
const Ktn = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Ztn(t, e) {
  if (t.childCount < 2)
    return t;
  for (let r = e.depth; r >= 0; r--) {
    let a = e.node(r).contentMatchAt(e.index(r)), i, o = [];
    if (t.forEach((s) => {
      if (!o)
        return;
      let l = a.findWrapping(s.type), c;
      if (!l)
        return o = null;
      if (c = o.length && i.length && Zpt(l, i, s, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = Jpt(o[o.length - 1], i.length));
        let u = Kpt(s, l);
        o.push(u), a = a.matchType(u.type), i = l;
      }
    }), o)
      return Mr.from(o);
  }
  return t;
}
function Kpt(t, e, r = 0) {
  for (let n = e.length - 1; n >= r; n--)
    t = e[n].create(null, Mr.from(t));
  return t;
}
function Zpt(t, e, r, n, a) {
  if (a < t.length && a < e.length && t[a] == e[a]) {
    let i = Zpt(t, e, r, n.lastChild, a + 1);
    if (i)
      return n.copy(n.content.replaceChild(n.childCount - 1, i));
    if (n.contentMatchAt(n.childCount).matchType(a == t.length - 1 ? r.type : t[a + 1]))
      return n.copy(n.content.append(Mr.from(Kpt(r, t, a + 1))));
  }
}
function Jpt(t, e) {
  if (e == 0)
    return t;
  let r = t.content.replaceChild(t.childCount - 1, Jpt(t.lastChild, e - 1)), n = t.contentMatchAt(t.childCount).fillBefore(Mr.empty, !0);
  return t.copy(r.append(n));
}
function Pfe(t, e, r, n, a, i) {
  let o = e < 0 ? t.firstChild : t.lastChild, s = o.content;
  return t.childCount > 1 && (i = 0), a < n - 1 && (s = Pfe(s, e, r, n, a + 1, i)), a >= r && (s = e < 0 ? o.contentMatchAt(0).fillBefore(s, i <= a).append(s) : s.append(o.contentMatchAt(o.childCount).fillBefore(Mr.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, o.copy(s));
}
function oje(t, e, r) {
  return e < t.openStart && (t = new hn(Pfe(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), r < t.openEnd && (t = new hn(Pfe(t.content, 1, r, t.openEnd, 0, 0), t.openStart, r)), t;
}
const Ypt = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let sje = null;
function Xpt() {
  return sje || (sje = document.implementation.createHTMLDocument("title"));
}
let zie = null;
function Jtn(t) {
  let e = window.trustedTypes;
  return e ? (zie || (zie = e.createPolicy("ProseMirrorClipboard", { createHTML: (r) => r })), zie.createHTML(t)) : t;
}
function Ytn(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let r = Xpt().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(t), a;
  if ((a = n && Ypt[n[1].toLowerCase()]) && (t = a.map((i) => "<" + i + ">").join("") + t + a.map((i) => "</" + i + ">").reverse().join("")), r.innerHTML = Jtn(t), a)
    for (let i = 0; i < a.length; i++)
      r = r.querySelector(a[i]) || r;
  return r;
}
function Xtn(t) {
  let e = t.querySelectorAll(Xc ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let r = 0; r < e.length; r++) {
    let n = e[r];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), n);
  }
}
function Qtn(t, e) {
  if (!t.size)
    return t;
  let r = t.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: a, openStart: i, openEnd: o } = t;
  for (let s = n.length - 2; s >= 0; s -= 2) {
    let l = r.nodes[n[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    a = Mr.from(l.create(n[s + 1], a)), i++, o++;
  }
  return new hn(a, i, o);
}
const Du = {}, Lu = {}, ern = { touchstart: !0, touchmove: !0 };
class trn {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function rrn(t) {
  for (let e in Du) {
    let r = Du[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (n) => {
      arn(t, n) && !tbe(t, n) && (t.editable || !(n.type in Lu)) && r(t, n);
    }, ern[e] ? { passive: !0 } : void 0);
  }
  $u && t.dom.addEventListener("input", () => null), Rfe(t);
}
function Iv(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function nrn(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function Rfe(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let r in e)
      t.input.eventHandlers[r] || t.dom.addEventListener(r, t.input.eventHandlers[r] = (n) => tbe(t, n));
  });
}
function tbe(t, e) {
  return t.someProp("handleDOMEvents", (r) => {
    let n = r[e.type];
    return n ? n(t, e) || e.defaultPrevented : !1;
  });
}
function arn(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let r = e.target; r != t.dom; r = r.parentNode)
    if (!r || r.nodeType == 11 || r.pmViewDesc && r.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function irn(t, e) {
  !tbe(t, e) && Du[e.type] && (t.editable || !(e.type in Lu)) && Du[e.type](t, e);
}
Lu.keydown = (t, e) => {
  let r = e;
  if (t.input.shiftKey = r.keyCode == 16 || r.shiftKey, !emt(t, r) && (t.input.lastKeyCode = r.keyCode, t.input.lastKeyCodeTime = Date.now(), !(_m && Xc && r.keyCode == 13)))
    if (r.keyCode != 229 && t.domObserver.forceFlush(), a8 && r.keyCode == 13 && !r.ctrlKey && !r.altKey && !r.metaKey) {
      let n = Date.now();
      t.input.lastIOSEnter = n, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == n && (t.someProp("handleKeyDown", (a) => a(t, sb(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (n) => n(t, r)) || qtn(t, r) ? r.preventDefault() : Iv(t, "key");
};
Lu.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Lu.keypress = (t, e) => {
  let r = e;
  if (emt(t, r) || !r.charCode || r.ctrlKey && !r.altKey || H0 && r.metaKey)
    return;
  if (t.someProp("handleKeyPress", (a) => a(t, r))) {
    r.preventDefault();
    return;
  }
  let n = t.state.selection;
  if (!(n instanceof qa) || !n.$from.sameParent(n.$to)) {
    let a = String.fromCharCode(r.charCode);
    !/[\r\n]/.test(a) && !t.someProp("handleTextInput", (i) => i(t, n.$from.pos, n.$to.pos, a)) && t.dispatch(t.state.tr.insertText(a).scrollIntoView()), r.preventDefault();
  }
};
function $H(t) {
  return { left: t.clientX, top: t.clientY };
}
function orn(t, e) {
  let r = e.x - t.clientX, n = e.y - t.clientY;
  return r * r + n * n < 100;
}
function rbe(t, e, r, n, a) {
  if (n == -1)
    return !1;
  let i = t.state.doc.resolve(n);
  for (let o = i.depth + 1; o > 0; o--)
    if (t.someProp(e, (s) => o > i.depth ? s(t, r, i.nodeAfter, i.before(o), a, !0) : s(t, r, i.node(o), i.before(o), a, !1)))
      return !0;
  return !1;
}
function P7(t, e, r) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let n = t.state.tr.setSelection(e);
  n.setMeta("pointer", !0), t.dispatch(n);
}
function srn(t, e) {
  if (e == -1)
    return !1;
  let r = t.state.doc.resolve(e), n = r.nodeAfter;
  return n && n.isAtom && ea.isSelectable(n) ? (P7(t, new ea(r)), !0) : !1;
}
function lrn(t, e) {
  if (e == -1)
    return !1;
  let r = t.state.selection, n, a;
  r instanceof ea && (n = r.node);
  let i = t.state.doc.resolve(e);
  for (let o = i.depth + 1; o > 0; o--) {
    let s = o > i.depth ? i.nodeAfter : i.node(o);
    if (ea.isSelectable(s)) {
      n && r.$from.depth > 0 && o >= r.$from.depth && i.before(r.$from.depth + 1) == r.$from.pos ? a = i.before(r.$from.depth) : a = i.before(o);
      break;
    }
  }
  return a != null ? (P7(t, ea.create(t.state.doc, a)), !0) : !1;
}
function crn(t, e, r, n, a) {
  return rbe(t, "handleClickOn", e, r, n) || t.someProp("handleClick", (i) => i(t, e, n)) || (a ? lrn(t, r) : srn(t, r));
}
function urn(t, e, r, n) {
  return rbe(t, "handleDoubleClickOn", e, r, n) || t.someProp("handleDoubleClick", (a) => a(t, e, n));
}
function drn(t, e, r, n) {
  return rbe(t, "handleTripleClickOn", e, r, n) || t.someProp("handleTripleClick", (a) => a(t, e, n)) || frn(t, r, n);
}
function frn(t, e, r) {
  if (r.button != 0)
    return !1;
  let n = t.state.doc;
  if (e == -1)
    return n.inlineContent ? (P7(t, qa.create(n, 0, n.content.size)), !0) : !1;
  let a = n.resolve(e);
  for (let i = a.depth + 1; i > 0; i--) {
    let o = i > a.depth ? a.nodeAfter : a.node(i), s = a.before(i);
    if (o.inlineContent)
      P7(t, qa.create(n, s + 1, s + 1 + o.content.size));
    else if (ea.isSelectable(o))
      P7(t, ea.create(n, s));
    else
      continue;
    return !0;
  }
}
function nbe(t) {
  return NF(t);
}
const Qpt = H0 ? "metaKey" : "ctrlKey";
Du.mousedown = (t, e) => {
  let r = e;
  t.input.shiftKey = r.shiftKey;
  let n = nbe(t), a = Date.now(), i = "singleClick";
  a - t.input.lastClick.time < 500 && orn(r, t.input.lastClick) && !r[Qpt] && (t.input.lastClick.type == "singleClick" ? i = "doubleClick" : t.input.lastClick.type == "doubleClick" && (i = "tripleClick")), t.input.lastClick = { time: a, x: r.clientX, y: r.clientY, type: i };
  let o = t.posAtCoords($H(r));
  o && (i == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new hrn(t, o, r, !!n)) : (i == "doubleClick" ? urn : drn)(t, o.pos, o.inside, r) ? r.preventDefault() : Iv(t, "pointer"));
};
class hrn {
  constructor(e, r, n, a) {
    this.view = e, this.pos = r, this.event = n, this.flushed = a, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!n[Qpt], this.allowDefault = n.shiftKey;
    let i, o;
    if (r.inside > -1)
      i = e.state.doc.nodeAt(r.inside), o = r.inside;
    else {
      let u = e.state.doc.resolve(r.pos);
      i = u.parent, o = u.depth ? u.before() : 0;
    }
    const s = a ? null : n.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: c } = e.state;
    (n.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof ea && c.from <= o && c.to > o) && (this.mightDrag = {
      node: i,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Q1 && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Iv(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Om(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let r = this.pos;
    this.view.state.doc != this.startDoc && (r = this.view.posAtCoords($H(e))), this.updateAllowDefault(e), this.allowDefault || !r ? Iv(this.view, "pointer") : crn(this.view, r.pos, r.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    $u && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Xc && !this.view.state.selection.visible && Math.min(Math.abs(r.pos - this.view.state.selection.from), Math.abs(r.pos - this.view.state.selection.to)) <= 2) ? (P7(this.view, Ci.near(this.view.state.doc.resolve(r.pos))), e.preventDefault()) : Iv(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Iv(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Du.touchstart = (t) => {
  t.input.lastTouch = Date.now(), nbe(t), Iv(t, "pointer");
};
Du.touchmove = (t) => {
  t.input.lastTouch = Date.now(), Iv(t, "pointer");
};
Du.contextmenu = (t) => nbe(t);
function emt(t, e) {
  return t.composing ? !0 : $u && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const prn = _m ? 5e3 : -1;
Lu.compositionstart = Lu.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, r = e.selection.$to;
    if (e.selection instanceof qa && (e.storedMarks || !r.textOffset && r.parentOffset && r.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || r.marks(), NF(t, !0), t.markCursor = null;
    else if (NF(t, !e.selection.empty), Q1 && e.selection.empty && r.parentOffset && !r.textOffset && r.nodeBefore.marks.length) {
      let n = t.domSelectionRange();
      for (let a = n.focusNode, i = n.focusOffset; a && a.nodeType == 1 && i != 0; ) {
        let o = i < 0 ? a.lastChild : a.childNodes[i - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let s = t.domSelection();
          s && s.collapse(o, o.nodeValue.length);
          break;
        } else
          a = o, i = -1;
      }
    }
    t.input.composing = !0;
  }
  tmt(t, prn);
};
Lu.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, tmt(t, 20));
};
function tmt(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => NF(t), e));
}
function rmt(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = grn()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function mrn(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let r = stn(e.focusNode, e.focusOffset), n = ltn(e.focusNode, e.focusOffset);
  if (r && n && r != n) {
    let a = n.pmViewDesc, i = t.domObserver.lastChangedTextNode;
    if (r == i || n == i)
      return i;
    if (!a || !a.isText(n.nodeValue))
      return n;
    if (t.input.compositionNode == n) {
      let o = r.pmViewDesc;
      if (!(!o || !o.isText(r.nodeValue)))
        return n;
    }
  }
  return r || n;
}
function grn() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function NF(t, e = !1) {
  if (!(_m && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), rmt(t), e || t.docView && t.docView.dirty) {
      let r = X3e(t);
      return r && !r.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(r)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function vrn(t, e) {
  if (!t.dom.parentNode)
    return;
  let r = t.dom.parentNode.appendChild(document.createElement("div"));
  r.appendChild(e), r.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), a = document.createRange();
  a.selectNodeContents(e), t.dom.blur(), n.removeAllRanges(), n.addRange(a), setTimeout(() => {
    r.parentNode && r.parentNode.removeChild(r), t.focus();
  }, 50);
}
const fI = vd && jv < 15 || a8 && htn < 604;
Du.copy = Lu.cut = (t, e) => {
  let r = e, n = t.state.selection, a = r.type == "cut";
  if (n.empty)
    return;
  let i = fI ? null : r.clipboardData, o = n.content(), { dom: s, text: l } = ebe(t, o);
  i ? (r.preventDefault(), i.clearData(), i.setData("text/html", s.innerHTML), i.setData("text/plain", l)) : vrn(t, s), a && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function yrn(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function brn(t, e) {
  if (!t.dom.parentNode)
    return;
  let r = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, n = t.dom.parentNode.appendChild(document.createElement(r ? "textarea" : "div"));
  r || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus();
  let a = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), n.parentNode && n.parentNode.removeChild(n), r ? hI(t, n.value, null, a, e) : hI(t, n.textContent, n.innerHTML, a, e);
  }, 50);
}
function hI(t, e, r, n, a) {
  let i = qpt(t, e, r, n, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, a, i || hn.empty)))
    return !0;
  if (!i)
    return !1;
  let o = yrn(i), s = o ? t.state.tr.replaceSelectionWith(o, n) : t.state.tr.replaceSelection(i);
  return t.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function nmt(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let r = t.getData("text/uri-list");
  return r ? r.replace(/\r?\n/g, " ") : "";
}
Lu.paste = (t, e) => {
  let r = e;
  if (t.composing && !_m)
    return;
  let n = fI ? null : r.clipboardData, a = t.input.shiftKey && t.input.lastKeyCode != 45;
  n && hI(t, nmt(n), n.getData("text/html"), a, r) ? r.preventDefault() : brn(t, r);
};
class amt {
  constructor(e, r, n) {
    this.slice = e, this.move = r, this.node = n;
  }
}
const imt = H0 ? "altKey" : "ctrlKey";
Du.dragstart = (t, e) => {
  let r = e, n = t.input.mouseDown;
  if (n && n.done(), !r.dataTransfer)
    return;
  let a = t.state.selection, i = a.empty ? null : t.posAtCoords($H(r)), o;
  if (!(i && i.pos >= a.from && i.pos <= (a instanceof ea ? a.to - 1 : a.to))) {
    if (n && n.mightDrag)
      o = ea.create(t.state.doc, n.mightDrag.pos);
    else if (r.target && r.target.nodeType == 1) {
      let f = t.docView.nearestDesc(r.target, !0);
      f && f.node.type.spec.draggable && f != t.docView && (o = ea.create(t.state.doc, f.posBefore));
    }
  }
  let s = (o || t.state.selection).content(), { dom: l, text: c, slice: u } = ebe(t, s);
  (!r.dataTransfer.files.length || !Xc || Ppt > 120) && r.dataTransfer.clearData(), r.dataTransfer.setData(fI ? "Text" : "text/html", l.innerHTML), r.dataTransfer.effectAllowed = "copyMove", fI || r.dataTransfer.setData("text/plain", c), t.dragging = new amt(u, !r[imt], o);
};
Du.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Lu.dragover = Lu.dragenter = (t, e) => e.preventDefault();
Lu.drop = (t, e) => {
  let r = e, n = t.dragging;
  if (t.dragging = null, !r.dataTransfer)
    return;
  let a = t.posAtCoords($H(r));
  if (!a)
    return;
  let i = t.state.doc.resolve(a.pos), o = n && n.slice;
  o ? t.someProp("transformPasted", (g) => {
    o = g(o, t);
  }) : o = qpt(t, nmt(r.dataTransfer), fI ? null : r.dataTransfer.getData("text/html"), !1, i);
  let s = !!(n && !r[imt]);
  if (t.someProp("handleDrop", (g) => g(t, r, o || hn.empty, s))) {
    r.preventDefault();
    return;
  }
  if (!o)
    return;
  r.preventDefault();
  let l = o ? Spt(t.state.doc, i.pos, o) : i.pos;
  l == null && (l = i.pos);
  let c = t.state.tr;
  if (s) {
    let { node: g } = n;
    g ? g.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), f = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, h = c.doc;
  if (f ? c.replaceRangeWith(u, u, o.content.firstChild) : c.replaceRange(u, u, o), c.doc.eq(h))
    return;
  let p = c.doc.resolve(u);
  if (f && ea.isSelectable(o.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(o.content.firstChild))
    c.setSelection(new ea(p));
  else {
    let g = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((y, b, w, _) => g = _), c.setSelection(Q3e(t, p, c.doc.resolve(g)));
  }
  t.focus(), t.dispatch(c.setMeta("uiEvent", "drop"));
};
Du.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && Om(t);
  }, 20));
};
Du.blur = (t, e) => {
  let r = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), r.relatedTarget && t.dom.contains(r.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
Du.beforeinput = (t, e) => {
  if (Xc && _m && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: n } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != n || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (i) => i(t, sb(8, "Backspace")))))
        return;
      let { $cursor: a } = t.state.selection;
      a && a.pos > 0 && t.dispatch(t.state.tr.delete(a.pos - 1, a.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Lu)
  Du[t] = Lu[t];
function pI(t, e) {
  if (t == e)
    return !0;
  for (let r in t)
    if (t[r] !== e[r])
      return !1;
  for (let r in e)
    if (!(r in t))
      return !1;
  return !0;
}
class $F {
  constructor(e, r) {
    this.toDOM = e, this.spec = r || Kb, this.side = this.spec.side || 0;
  }
  map(e, r, n, a) {
    let { pos: i, deleted: o } = e.mapResult(r.from + a, this.side < 0 ? -1 : 1);
    return o ? null : new Q0(i - n, i - n, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof $F && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && pI(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class zv {
  constructor(e, r) {
    this.attrs = e, this.spec = r || Kb;
  }
  map(e, r, n, a) {
    let i = e.map(r.from + a, this.spec.inclusiveStart ? -1 : 1) - n, o = e.map(r.to + a, this.spec.inclusiveEnd ? 1 : -1) - n;
    return i >= o ? null : new Q0(i, o, this);
  }
  valid(e, r) {
    return r.from < r.to;
  }
  eq(e) {
    return this == e || e instanceof zv && pI(this.attrs, e.attrs) && pI(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof zv;
  }
  destroy() {
  }
}
class abe {
  constructor(e, r) {
    this.attrs = e, this.spec = r || Kb;
  }
  map(e, r, n, a) {
    let i = e.mapResult(r.from + a, 1);
    if (i.deleted)
      return null;
    let o = e.mapResult(r.to + a, -1);
    return o.deleted || o.pos <= i.pos ? null : new Q0(i.pos - n, o.pos - n, this);
  }
  valid(e, r) {
    let { index: n, offset: a } = e.content.findIndex(r.from), i;
    return a == r.from && !(i = e.child(n)).isText && a + i.nodeSize == r.to;
  }
  eq(e) {
    return this == e || e instanceof abe && pI(this.attrs, e.attrs) && pI(this.spec, e.spec);
  }
  destroy() {
  }
}
class Q0 {
  /**
  @internal
  */
  constructor(e, r, n) {
    this.from = e, this.to = r, this.type = n;
  }
  /**
  @internal
  */
  copy(e, r) {
    return new Q0(e, r, this.type);
  }
  /**
  @internal
  */
  eq(e, r = 0) {
    return this.type.eq(e.type) && this.from + r == e.from && this.to + r == e.to;
  }
  /**
  @internal
  */
  map(e, r, n) {
    return this.type.map(e, this, r, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, r, n) {
    return new Q0(e, e, new $F(r, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, r, n, a) {
    return new Q0(e, r, new zv(n, a));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, r, n, a) {
    return new Q0(e, r, new abe(n, a));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof zv;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof $F;
  }
}
const _9 = [], Kb = {};
class zl {
  /**
  @internal
  */
  constructor(e, r) {
    this.local = e.length ? e : _9, this.children = r.length ? r : _9;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, r) {
    return r.length ? DF(r, e, 0, Kb) : Vc;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, r, n) {
    let a = [];
    return this.findInner(e ?? 0, r ?? 1e9, a, 0, n), a;
  }
  findInner(e, r, n, a, i) {
    for (let o = 0; o < this.local.length; o++) {
      let s = this.local[o];
      s.from <= r && s.to >= e && (!i || i(s.spec)) && n.push(s.copy(s.from + a, s.to + a));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < r && this.children[o + 1] > e) {
        let s = this.children[o] + 1;
        this.children[o + 2].findInner(e - s, r - s, n, a + s, i);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, r, n) {
    return this == Vc || e.maps.length == 0 ? this : this.mapInner(e, r, 0, 0, n || Kb);
  }
  /**
  @internal
  */
  mapInner(e, r, n, a, i) {
    let o;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, n, a);
      l && l.type.valid(r, l) ? (o || (o = [])).push(l) : i.onRemove && i.onRemove(this.local[s].spec);
    }
    return this.children.length ? xrn(this.children, o || [], e, r, n, a, i) : o ? new zl(o.sort(Zb), _9) : Vc;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, r) {
    return r.length ? this == Vc ? zl.create(e, r) : this.addInner(e, r, 0) : this;
  }
  addInner(e, r, n) {
    let a, i = 0;
    e.forEach((s, l) => {
      let c = l + n, u;
      if (u = smt(r, s, c)) {
        for (a || (a = this.children.slice()); i < a.length && a[i] < l; )
          i += 3;
        a[i] == l ? a[i + 2] = a[i + 2].addInner(s, u, c + 1) : a.splice(i, 0, l, l + s.nodeSize, DF(u, s, c + 1, Kb)), i += 3;
      }
    });
    let o = omt(i ? lmt(r) : r, -n);
    for (let s = 0; s < o.length; s++)
      o[s].type.valid(e, o[s]) || o.splice(s--, 1);
    return new zl(o.length ? this.local.concat(o).sort(Zb) : this.local, a || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Vc ? this : this.removeInner(e, 0);
  }
  removeInner(e, r) {
    let n = this.children, a = this.local;
    for (let i = 0; i < n.length; i += 3) {
      let o, s = n[i] + r, l = n[i + 1] + r;
      for (let u = 0, f; u < e.length; u++)
        (f = e[u]) && f.from > s && f.to < l && (e[u] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      n == this.children && (n = this.children.slice());
      let c = n[i + 2].removeInner(o, s + 1);
      c != Vc ? n[i + 2] = c : (n.splice(i, 3), i -= 3);
    }
    if (a.length) {
      for (let i = 0, o; i < e.length; i++)
        if (o = e[i])
          for (let s = 0; s < a.length; s++)
            a[s].eq(o, r) && (a == this.local && (a = this.local.slice()), a.splice(s--, 1));
    }
    return n == this.children && a == this.local ? this : a.length || n.length ? new zl(a, n) : Vc;
  }
  forChild(e, r) {
    if (this == Vc)
      return this;
    if (r.isLeaf)
      return zl.empty;
    let n, a;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (n = this.children[s + 2]);
        break;
      }
    let i = e + 1, o = i + r.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < o && l.to > i && l.type instanceof zv) {
        let c = Math.max(i, l.from) - i, u = Math.min(o, l.to) - i;
        c < u && (a || (a = [])).push(l.copy(c, u));
      }
    }
    if (a) {
      let s = new zl(a.sort(Zb), _9);
      return n ? new yv([s, n]) : s;
    }
    return n || Vc;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof zl) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let r = 0; r < this.local.length; r++)
      if (!this.local[r].eq(e.local[r]))
        return !1;
    for (let r = 0; r < this.children.length; r += 3)
      if (this.children[r] != e.children[r] || this.children[r + 1] != e.children[r + 1] || !this.children[r + 2].eq(e.children[r + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return ibe(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Vc)
      return _9;
    if (e.inlineContent || !this.local.some(zv.is))
      return this.local;
    let r = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof zv || r.push(this.local[n]);
    return r;
  }
  forEachSet(e) {
    e(this);
  }
}
zl.empty = new zl([], []);
zl.removeOverlap = ibe;
const Vc = zl.empty;
class yv {
  constructor(e) {
    this.members = e;
  }
  map(e, r) {
    const n = this.members.map((a) => a.map(e, r, Kb));
    return yv.from(n);
  }
  forChild(e, r) {
    if (r.isLeaf)
      return zl.empty;
    let n = [];
    for (let a = 0; a < this.members.length; a++) {
      let i = this.members[a].forChild(e, r);
      i != Vc && (i instanceof yv ? n = n.concat(i.members) : n.push(i));
    }
    return yv.from(n);
  }
  eq(e) {
    if (!(e instanceof yv) || e.members.length != this.members.length)
      return !1;
    for (let r = 0; r < this.members.length; r++)
      if (!this.members[r].eq(e.members[r]))
        return !1;
    return !0;
  }
  locals(e) {
    let r, n = !0;
    for (let a = 0; a < this.members.length; a++) {
      let i = this.members[a].localsInner(e);
      if (i.length)
        if (!r)
          r = i;
        else {
          n && (r = r.slice(), n = !1);
          for (let o = 0; o < i.length; o++)
            r.push(i[o]);
        }
    }
    return r ? ibe(n ? r : r.sort(Zb)) : _9;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Vc;
      case 1:
        return e[0];
      default:
        return new yv(e.every((r) => r instanceof zl) ? e : e.reduce((r, n) => r.concat(n instanceof zl ? n : n.members), []));
    }
  }
  forEachSet(e) {
    for (let r = 0; r < this.members.length; r++)
      this.members[r].forEachSet(e);
  }
}
function xrn(t, e, r, n, a, i, o) {
  let s = t.slice();
  for (let c = 0, u = i; c < r.maps.length; c++) {
    let f = 0;
    r.maps[c].forEach((h, p, g, y) => {
      let b = y - g - (p - h);
      for (let w = 0; w < s.length; w += 3) {
        let _ = s[w + 1];
        if (_ < 0 || h > _ + u - f)
          continue;
        let C = s[w] + u - f;
        p >= C ? s[w + 1] = h <= C ? -2 : -1 : h >= u && b && (s[w] += b, s[w + 1] += b);
      }
      f += b;
    }), u = r.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < s.length; c += 3)
    if (s[c + 1] < 0) {
      if (s[c + 1] == -2) {
        l = !0, s[c + 1] = -1;
        continue;
      }
      let u = r.map(t[c] + i), f = u - a;
      if (f < 0 || f >= n.content.size) {
        l = !0;
        continue;
      }
      let h = r.map(t[c + 1] + i, -1), p = h - a, { index: g, offset: y } = n.content.findIndex(f), b = n.maybeChild(g);
      if (b && y == f && y + b.nodeSize == p) {
        let w = s[c + 2].mapInner(r, b, u + 1, t[c] + i + 1, o);
        w != Vc ? (s[c] = f, s[c + 1] = p, s[c + 2] = w) : (s[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = Crn(s, t, e, r, a, i, o), u = DF(c, n, 0, o);
    e = u.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, h = 0; f < u.children.length; f += 3) {
      let p = u.children[f];
      for (; h < s.length && s[h] < p; )
        h += 3;
      s.splice(h, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new zl(e.sort(Zb), s);
}
function omt(t, e) {
  if (!e || !t.length)
    return t;
  let r = [];
  for (let n = 0; n < t.length; n++) {
    let a = t[n];
    r.push(new Q0(a.from + e, a.to + e, a.type));
  }
  return r;
}
function Crn(t, e, r, n, a, i, o) {
  function s(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let f = l.local[u].map(n, a, c);
      f ? r.push(f) : o.onRemove && o.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && s(t[l + 2], e[l] + i + 1);
  return r;
}
function smt(t, e, r) {
  if (e.isLeaf)
    return null;
  let n = r + e.nodeSize, a = null;
  for (let i = 0, o; i < t.length; i++)
    (o = t[i]) && o.from > r && o.to < n && ((a || (a = [])).push(o), t[i] = null);
  return a;
}
function lmt(t) {
  let e = [];
  for (let r = 0; r < t.length; r++)
    t[r] != null && e.push(t[r]);
  return e;
}
function DF(t, e, r, n) {
  let a = [], i = !1;
  e.forEach((s, l) => {
    let c = smt(t, s, l + r);
    if (c) {
      i = !0;
      let u = DF(c, s, r + l + 1, n);
      u != Vc && a.push(l, l + s.nodeSize, u);
    }
  });
  let o = omt(i ? lmt(t) : t, -r).sort(Zb);
  for (let s = 0; s < o.length; s++)
    o[s].type.valid(e, o[s]) || (n.onRemove && n.onRemove(o[s].spec), o.splice(s--, 1));
  return o.length || a.length ? new zl(o, a) : Vc;
}
function Zb(t, e) {
  return t.from - e.from || t.to - e.to;
}
function ibe(t) {
  let e = t;
  for (let r = 0; r < e.length - 1; r++) {
    let n = e[r];
    if (n.from != n.to)
      for (let a = r + 1; a < e.length; a++) {
        let i = e[a];
        if (i.from == n.from) {
          i.to != n.to && (e == t && (e = t.slice()), e[a] = i.copy(i.from, n.to), lje(e, a + 1, i.copy(n.to, i.to)));
          continue;
        } else {
          i.from < n.to && (e == t && (e = t.slice()), e[r] = n.copy(n.from, i.from), lje(e, a, n.copy(i.from, n.to)));
          break;
        }
      }
  }
  return e;
}
function lje(t, e, r) {
  for (; e < t.length && Zb(r, t[e]) > 0; )
    e++;
  t.splice(e, 0, r);
}
function Gie(t) {
  let e = [];
  return t.someProp("decorations", (r) => {
    let n = r(t.state);
    n && n != Vc && e.push(n);
  }), t.cursorWrapper && e.push(zl.create(t.state.doc, [t.cursorWrapper.deco])), yv.from(e);
}
const wrn = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, Srn = vd && jv <= 11;
class _rn {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class krn {
  constructor(e, r) {
    this.view = e, this.handleDOMChange = r, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new _rn(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((n) => {
      for (let a = 0; a < n.length; a++)
        this.queue.push(n[a]);
      vd && jv <= 11 && n.some((a) => a.type == "childList" && a.removedNodes.length || a.type == "characterData" && a.oldValue.length > a.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), Srn && (this.onCharData = (n) => {
      this.queue.push({ target: n.target, type: "characterData", oldValue: n.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, wrn)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let r = 0; r < e.length; r++)
          this.queue.push(e[r]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (eje(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Om(this.view);
      if (vd && jv <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && j5(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let r = /* @__PURE__ */ new Set(), n;
    for (let i = e.focusNode; i; i = n8(i))
      r.add(i);
    for (let i = e.anchorNode; i; i = n8(i))
      if (r.has(i)) {
        n = i;
        break;
      }
    let a = n && this.view.docView.nearestDesc(n);
    if (a && a.ignoreMutation({
      type: "selection",
      target: n.nodeType == 3 ? n.parentNode : n
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let r = this.pendingRecords();
    r.length && (this.queue = []);
    let n = e.domSelectionRange(), a = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && eje(e) && !this.ignoreSelectionChange(n), i = -1, o = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < r.length; u++) {
        let f = this.registerMutation(r[u], l);
        f && (i = i < 0 ? f.from : Math.min(f.from, i), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (s = !0));
      }
    if (Q1 && l.length) {
      let u = l.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, h] = u;
        f.parentNode && f.parentNode.parentNode == h.parentNode ? h.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let h of u) {
          let p = h.parentNode;
          p && p.nodeName == "LI" && (!f || Ern(e, f) != p) && h.remove();
        }
      }
    }
    let c = null;
    i < 0 && a && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && BH(n) && (c = X3e(e)) && c.eq(Ci.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Om(e), this.currentSelection.set(n), e.scrollToSelection()) : (i > -1 || a) && (i > -1 && (e.docView.markDirty(i, o), Arn(e)), this.handleDOMChange(i, o, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(n) || Om(e), this.currentSelection.set(n));
  }
  registerMutation(e, r) {
    if (r.indexOf(e.target) > -1)
      return null;
    let n = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (n == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !n || n.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let f = e.addedNodes[u];
        r.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(e.target))
        return { from: n.posBefore, to: n.posAfter };
      let a = e.previousSibling, i = e.nextSibling;
      if (vd && jv <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: h } = e.addedNodes[u];
          (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (a = f), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (i = h);
        }
      let o = a && a.parentNode == e.target ? Sc(a) + 1 : 0, s = n.localPosFromDOM(e.target, o, -1), l = i && i.parentNode == e.target ? Sc(i) : e.target.childNodes.length, c = n.localPosFromDOM(e.target, l, 1);
      return { from: s, to: c };
    } else return e.type == "attributes" ? { from: n.posAtStart - n.border, to: n.posAtEnd + n.border } : (this.lastChangedTextNode = e.target, {
      from: n.posAtStart,
      to: n.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let cje = /* @__PURE__ */ new WeakMap(), uje = !1;
function Arn(t) {
  if (!cje.has(t) && (cje.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = Q1, uje)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), uje = !0;
  }
}
function dje(t, e) {
  let r = e.startContainer, n = e.startOffset, a = e.endContainer, i = e.endOffset, o = t.domAtPos(t.state.selection.anchor);
  return j5(o.node, o.offset, a, i) && ([r, n, a, i] = [a, i, r, n]), { anchorNode: r, anchorOffset: n, focusNode: a, focusOffset: i };
}
function Trn(t, e) {
  if (e.getComposedRanges) {
    let a = e.getComposedRanges(t.root)[0];
    if (a)
      return dje(t, a);
  }
  let r;
  function n(a) {
    a.preventDefault(), a.stopImmediatePropagation(), r = a.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", n, !0), r ? dje(t, r) : null;
}
function Ern(t, e) {
  for (let r = e.parentNode; r && r != t.dom; r = r.parentNode) {
    let n = t.docView.nearestDesc(r, !0);
    if (n && n.node.isBlock)
      return r;
  }
  return null;
}
function Irn(t, e, r) {
  let { node: n, fromOffset: a, toOffset: i, from: o, to: s } = t.docView.parseRange(e, r), l = t.domSelectionRange(), c, u = l.anchorNode;
  if (u && t.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], BH(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), Xc && t.input.lastKeyCode === 8)
    for (let b = i; b > a; b--) {
      let w = n.childNodes[b - 1], _ = w.pmViewDesc;
      if (w.nodeName == "BR" && !_) {
        i = b;
        break;
      }
      if (!_ || _.size)
        break;
    }
  let f = t.state.doc, h = t.someProp("domParser") || Lv.fromSchema(t.state.schema), p = f.resolve(o), g = null, y = h.parse(n, {
    topNode: p.parent,
    topMatch: p.parent.contentMatchAt(p.index()),
    topOpen: !0,
    from: a,
    to: i,
    preserveWhitespace: p.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: Mrn,
    context: p
  });
  if (c && c[0].pos != null) {
    let b = c[0].pos, w = c[1] && c[1].pos;
    w == null && (w = b), g = { anchor: b + o, head: w + o };
  }
  return { doc: y, sel: g, from: o, to: s };
}
function Mrn(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if ($u && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let r = document.createElement("div");
      return r.appendChild(document.createElement("li")), { skip: r };
    } else if (t.parentNode.lastChild == t || $u && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Prn = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Rrn(t, e, r, n, a) {
  let i = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let B = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, L = X3e(t, B);
    if (L && !t.state.selection.eq(L)) {
      if (Xc && _m && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (d) => d(t, sb(13, "Enter"))))
        return;
      let N = t.state.tr.setSelection(L);
      B == "pointer" ? N.setMeta("pointer", !0) : B == "key" && N.scrollIntoView(), i && N.setMeta("composition", i), t.dispatch(N);
    }
    return;
  }
  let o = t.state.doc.resolve(e), s = o.sharedDepth(r);
  e = o.before(s + 1), r = t.state.doc.resolve(r).after(s + 1);
  let l = t.state.selection, c = Irn(t, e, r), u = t.state.doc, f = u.slice(c.from, c.to), h, p;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (h = t.state.selection.to, p = "end") : (h = t.state.selection.from, p = "start"), t.input.lastKeyCode = null;
  let g = Nrn(f.content, c.doc.content, c.from, h, p);
  if (g && t.input.domChangeCount++, (a8 && t.input.lastIOSEnter > Date.now() - 225 || _m) && a.some((B) => B.nodeType == 1 && !Prn.test(B.nodeName)) && (!g || g.endA >= g.endB) && t.someProp("handleKeyDown", (B) => B(t, sb(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!g)
    if (n && l instanceof qa && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      g = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let B = fje(t, t.state.doc, c.sel);
        if (B && !B.eq(t.state.selection)) {
          let L = t.state.tr.setSelection(B);
          i && L.setMeta("composition", i), t.dispatch(L);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && g.start == g.endB && t.state.selection instanceof qa && (g.start > t.state.selection.from && g.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? g.start = t.state.selection.from : g.endA < t.state.selection.to && g.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (g.endB += t.state.selection.to - g.endA, g.endA = t.state.selection.to)), vd && jv <= 11 && g.endB == g.start + 1 && g.endA == g.start && g.start > c.from && c.doc.textBetween(g.start - c.from - 1, g.start - c.from + 1) == "  " && (g.start--, g.endA--, g.endB--);
  let y = c.doc.resolveNoCache(g.start - c.from), b = c.doc.resolveNoCache(g.endB - c.from), w = u.resolve(g.start), _ = y.sameParent(b) && y.parent.inlineContent && w.end() >= g.endA, C;
  if ((a8 && t.input.lastIOSEnter > Date.now() - 225 && (!_ || a.some((B) => B.nodeName == "DIV" || B.nodeName == "P")) || !_ && y.pos < c.doc.content.size && !y.sameParent(b) && (C = Ci.findFrom(c.doc.resolve(y.pos + 1), 1, !0)) && C.head == b.pos) && t.someProp("handleKeyDown", (B) => B(t, sb(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > g.start && Brn(u, g.start, g.endA, y, b) && t.someProp("handleKeyDown", (B) => B(t, sb(8, "Backspace")))) {
    _m && Xc && t.domObserver.suppressSelectionUpdates();
    return;
  }
  Xc && g.endB == g.start && (t.input.lastChromeDelete = Date.now()), _m && !_ && y.start() != b.start() && b.parentOffset == 0 && y.depth == b.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == g.endA && (g.endB -= 2, b = c.doc.resolveNoCache(g.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(B) {
      return B(t, sb(13, "Enter"));
    });
  }, 20));
  let x = g.start, S = g.endA, A, I, M;
  if (_) {
    if (y.pos == b.pos)
      vd && jv <= 11 && y.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => Om(t), 20)), A = t.state.tr.delete(x, S), I = u.resolve(g.start).marksAcross(u.resolve(g.endA));
    else if (
      // Adding or removing a mark
      g.endA == g.endB && (M = Orn(y.parent.content.cut(y.parentOffset, b.parentOffset), w.parent.content.cut(w.parentOffset, g.endA - w.start())))
    )
      A = t.state.tr, M.type == "add" ? A.addMark(x, S, M.mark) : A.removeMark(x, S, M.mark);
    else if (y.parent.child(y.index()).isText && y.index() == b.index() - (b.textOffset ? 0 : 1)) {
      let B = y.parent.textBetween(y.parentOffset, b.parentOffset);
      if (t.someProp("handleTextInput", (L) => L(t, x, S, B)))
        return;
      A = t.state.tr.insertText(B, x, S);
    }
  }
  if (A || (A = t.state.tr.replace(x, S, c.doc.slice(g.start - c.from, g.endB - c.from))), c.sel) {
    let B = fje(t, A.doc, c.sel);
    B && !(Xc && t.composing && B.empty && (g.start != g.endB || t.input.lastChromeDelete < Date.now() - 100) && (B.head == x || B.head == A.mapping.map(S) - 1) || vd && B.empty && B.head == x) && A.setSelection(B);
  }
  I && A.ensureMarks(I), i && A.setMeta("composition", i), t.dispatch(A.scrollIntoView());
}
function fje(t, e, r) {
  return Math.max(r.anchor, r.head) > e.content.size ? null : Q3e(t, e.resolve(r.anchor), e.resolve(r.head));
}
function Orn(t, e) {
  let r = t.firstChild.marks, n = e.firstChild.marks, a = r, i = n, o, s, l;
  for (let u = 0; u < n.length; u++)
    a = n[u].removeFromSet(a);
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  if (a.length == 1 && i.length == 0)
    s = a[0], o = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (a.length == 0 && i.length == 1)
    s = i[0], o = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (Mr.from(c).eq(t))
    return { mark: s, type: o };
}
function Brn(t, e, r, n, a) {
  if (
    // The content must have shrunk
    r - e <= a.pos - n.pos || // newEnd must point directly at or after the end of the block that newStart points into
    Wie(n, !0, !1) < a.pos
  )
    return !1;
  let i = t.resolve(e);
  if (!n.parent.isTextblock) {
    let s = i.nodeAfter;
    return s != null && r == e + s.nodeSize;
  }
  if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock)
    return !1;
  let o = t.resolve(Wie(i, !0, !0));
  return !o.parent.isTextblock || o.pos > r || Wie(o, !0, !1) < r ? !1 : n.parent.content.cut(n.parentOffset).eq(o.parent.content);
}
function Wie(t, e, r) {
  let n = t.depth, a = e ? t.end() : t.pos;
  for (; n > 0 && (e || t.indexAfter(n) == t.node(n).childCount); )
    n--, a++, e = !1;
  if (r) {
    let i = t.node(n).maybeChild(t.indexAfter(n));
    for (; i && !i.isLeaf; )
      i = i.firstChild, a++;
  }
  return a;
}
function Nrn(t, e, r, n, a) {
  let i = t.findDiffStart(e, r);
  if (i == null)
    return null;
  let { a: o, b: s } = t.findDiffEnd(e, r + t.size, r + e.size);
  if (a == "end") {
    let l = Math.max(0, i - Math.min(o, s));
    n -= o + l - i;
  }
  if (o < i && t.size < e.size) {
    let l = n <= i && n >= o ? i - n : 0;
    i -= l, i && i < e.size && hje(e.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), s = i + (s - o), o = i;
  } else if (s < i) {
    let l = n <= i && n >= s ? i - n : 0;
    i -= l, i && i < t.size && hje(t.textBetween(i - 1, i + 1)) && (i += l ? 1 : -1), o = i + (o - s), s = i;
  }
  return { start: i, endA: o, endB: s };
}
function hje(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), r = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && r >= 55296 && r <= 56319;
}
class $rn {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, r) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new trn(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = r, this.state = r.state, this.directPlugins = r.plugins || [], this.directPlugins.forEach(yje), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = gje(this), mje(this), this.nodeViews = vje(this), this.docView = KLe(this.state.doc, pje(this), Gie(this), this.dom, this), this.domObserver = new krn(this, (n, a, i, o) => Rrn(this, n, a, i, o)), this.domObserver.start(), rrn(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let r in e)
        this._props[r] = e[r];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Rfe(this);
    let r = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(yje), this.directPlugins = e.plugins), this.updateStateInner(e.state, r);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let r = {};
    for (let n in this._props)
      r[n] = this._props[n];
    r.state = this.state;
    for (let n in e)
      r[n] = e[n];
    this.update(r);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, r) {
    var n;
    let a = this.state, i = !1, o = !1;
    e.storedMarks && this.composing && (rmt(this), o = !0), this.state = e;
    let s = a.plugins != e.plugins || this._props.plugins != r.plugins;
    if (s || this._props.plugins != r.plugins || this._props.nodeViews != r.nodeViews) {
      let p = vje(this);
      Lrn(p, this.nodeViews) && (this.nodeViews = p, i = !0);
    }
    (s || r.handleDOMEvents != this._props.handleDOMEvents) && Rfe(this), this.editable = gje(this), mje(this);
    let l = Gie(this), c = pje(this), u = a.plugins != e.plugins && !a.doc.eq(e.doc) ? "reset" : e.scrollToSelection > a.scrollToSelection ? "to selection" : "preserve", f = i || !this.docView.matchesNode(e.doc, c, l);
    (f || !e.selection.eq(a.selection)) && (o = !0);
    let h = u == "preserve" && o && this.dom.style.overflowAnchor == null && gtn(this);
    if (o) {
      this.domObserver.stop();
      let p = f && (vd || Xc) && !this.composing && !a.selection.empty && !e.selection.empty && Drn(a.selection, e.selection);
      if (f) {
        let g = Xc ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = mrn(this)), (i || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = KLe(e.doc, c, l, this.dom, this)), g && !this.trackWrites && (p = !0);
      }
      p || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Ftn(this)) ? Om(this, p) : (Hpt(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(a), !((n = this.dragging) === null || n === void 0) && n.node && !a.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, a), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : h && vtn(h);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (r) => r(this))) if (this.state.selection instanceof ea) {
        let r = this.docView.domAfterPos(this.state.selection.from);
        r.nodeType == 1 && GLe(this, r.getBoundingClientRect(), e);
      } else
        GLe(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let r = 0; r < this.directPlugins.length; r++) {
        let n = this.directPlugins[r];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
      for (let r = 0; r < this.state.plugins.length; r++) {
        let n = this.state.plugins[r];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
    } else
      for (let r = 0; r < this.pluginViews.length; r++) {
        let n = this.pluginViews[r];
        n.update && n.update(this, e);
      }
  }
  updateDraggedNode(e, r) {
    let n = e.node, a = -1;
    if (this.state.doc.nodeAt(n.from) == n.node)
      a = n.from;
    else {
      let i = n.from + (this.state.doc.content.size - r.doc.content.size);
      (i > 0 && this.state.doc.nodeAt(i)) == n.node && (a = i);
    }
    this.dragging = new amt(e.slice, e.move, a < 0 ? void 0 : ea.create(this.state.doc, a));
  }
  someProp(e, r) {
    let n = this._props && this._props[e], a;
    if (n != null && (a = r ? r(n) : n))
      return a;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let s = this.directPlugins[o].props[e];
      if (s != null && (a = r ? r(s) : s))
        return a;
    }
    let i = this.state.plugins;
    if (i)
      for (let o = 0; o < i.length; o++) {
        let s = i[o].props[e];
        if (s != null && (a = r ? r(s) : s))
          return a;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (vd) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && ytn(this.dom), Om(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let r = this.dom.parentNode; r; r = r.parentNode)
        if (r.nodeType == 9 || r.nodeType == 11 && r.host)
          return r.getSelection || (Object.getPrototypeOf(r).getSelection = () => r.ownerDocument.getSelection()), this._root = r;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return Stn(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, r = 1) {
    return $pt(this, e, r);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, r = 0) {
    return this.docView.domFromPos(e, r);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let r = this.docView.descAt(e);
    return r ? r.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, r, n = -1) {
    let a = this.docView.posFromDOM(e, r, n);
    if (a == null)
      throw new RangeError("DOM position not inside the editor");
    return a;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, r) {
    return Etn(this, r || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, r) {
    return hI(this, "", e, !1, r || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, r) {
    return hI(this, e, null, !0, r || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return ebe(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (nrn(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], Gie(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, itn());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return irn(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let r = this._props.dispatchTransaction;
    r ? r.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? $u && this.root.nodeType === 11 && utn(this.dom.ownerDocument) == this.dom && Trn(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function pje(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (r) => {
    if (typeof r == "function" && (r = r(t.state)), r)
      for (let n in r)
        n == "class" ? e.class += " " + r[n] : n == "style" ? e.style = (e.style ? e.style + ";" : "") + r[n] : !e[n] && n != "contenteditable" && n != "nodeName" && (e[n] = String(r[n]));
  }), e.translate || (e.translate = "no"), [Q0.node(0, t.state.doc.content.size, e)];
}
function mje(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: Q0.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function gje(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function Drn(t, e) {
  let r = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(r) != e.$anchor.start(r);
}
function vje(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function r(n) {
    for (let a in n)
      Object.prototype.hasOwnProperty.call(e, a) || (e[a] = n[a]);
  }
  return t.someProp("nodeViews", r), t.someProp("markViews", r), e;
}
function Lrn(t, e) {
  let r = 0, n = 0;
  for (let a in t) {
    if (t[a] != e[a])
      return !0;
    r++;
  }
  for (let a in e)
    n++;
  return r != n;
}
function yje(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var _y = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, LF = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, jrn = typeof navigator < "u" && /Mac/.test(navigator.platform), Frn = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var _c = 0; _c < 10; _c++) _y[48 + _c] = _y[96 + _c] = String(_c);
for (var _c = 1; _c <= 24; _c++) _y[_c + 111] = "F" + _c;
for (var _c = 65; _c <= 90; _c++)
  _y[_c] = String.fromCharCode(_c + 32), LF[_c] = String.fromCharCode(_c);
for (var Hie in _y) LF.hasOwnProperty(Hie) || (LF[Hie] = _y[Hie]);
function zrn(t) {
  var e = jrn && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || Frn && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", r = !e && t.key || (t.shiftKey ? LF : _y)[t.keyCode] || t.key || "Unidentified";
  return r == "Esc" && (r = "Escape"), r == "Del" && (r = "Delete"), r == "Left" && (r = "ArrowLeft"), r == "Up" && (r = "ArrowUp"), r == "Right" && (r = "ArrowRight"), r == "Down" && (r = "ArrowDown"), r;
}
const Grn = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function Wrn(t) {
  let e = t.split(/-(?!$)/), r = e[e.length - 1];
  r == "Space" && (r = " ");
  let n, a, i, o;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      a = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      Grn ? o = !0 : a = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return n && (r = "Alt-" + r), a && (r = "Ctrl-" + r), o && (r = "Meta-" + r), i && (r = "Shift-" + r), r;
}
function Hrn(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let r in t)
    e[Wrn(r)] = t[r];
  return e;
}
function Uie(t, e, r = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), r && e.shiftKey && (t = "Shift-" + t), t;
}
function Urn(t) {
  return new Bd({ props: { handleKeyDown: cmt(t) } });
}
function cmt(t) {
  let e = Hrn(t);
  return function(r, n) {
    let a = zrn(n), i, o = e[Uie(a, n)];
    if (o && o(r.state, r.dispatch, r))
      return !0;
    if (a.length == 1 && a != " ") {
      if (n.shiftKey) {
        let s = e[Uie(a, n, !1)];
        if (s && s(r.state, r.dispatch, r))
          return !0;
      }
      if ((n.shiftKey || n.altKey || n.metaKey || a.charCodeAt(0) > 127) && (i = _y[n.keyCode]) && i != a) {
        let s = e[Uie(i, n)];
        if (s && s(r.state, r.dispatch, r))
          return !0;
      }
    }
    return !1;
  };
}
const obe = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function umt(t, e) {
  let { $cursor: r } = t.selection;
  return !r || (e ? !e.endOfTextblock("backward", t) : r.parentOffset > 0) ? null : r;
}
const dmt = (t, e, r) => {
  let n = umt(t, r);
  if (!n)
    return !1;
  let a = sbe(n);
  if (!a) {
    let o = n.blockRange(), s = o && fC(o);
    return s == null ? !1 : (e && e(t.tr.lift(o, s).scrollIntoView()), !0);
  }
  let i = a.nodeBefore;
  if (xmt(t, a, e, -1))
    return !0;
  if (n.parent.content.size == 0 && (i8(i, "end") || ea.isSelectable(i)))
    for (let o = n.depth; ; o--) {
      let s = RH(t.doc, n.before(o), n.after(o), hn.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = t.tr.step(s);
          l.setSelection(i8(i, "end") ? Ci.findFrom(l.doc.resolve(l.mapping.map(a.pos, -1)), -1) : ea.create(l.doc, a.pos - i.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || n.node(o - 1).childCount > 1)
        break;
    }
  return i.isAtom && a.depth == n.depth - 1 ? (e && e(t.tr.delete(a.pos - i.nodeSize, a.pos).scrollIntoView()), !0) : !1;
}, Vrn = (t, e, r) => {
  let n = umt(t, r);
  if (!n)
    return !1;
  let a = sbe(n);
  return a ? fmt(t, a, e) : !1;
}, qrn = (t, e, r) => {
  let n = pmt(t, r);
  if (!n)
    return !1;
  let a = lbe(n);
  return a ? fmt(t, a, e) : !1;
};
function fmt(t, e, r) {
  let n = e.nodeBefore, a = n, i = e.pos - 1;
  for (; !a.isTextblock; i--) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.lastChild;
    if (!u)
      return !1;
    a = u;
  }
  let o = e.nodeAfter, s = o, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let c = RH(t.doc, i, l, hn.empty);
  if (!c || c.from != i || c instanceof rc && c.slice.size >= l - i)
    return !1;
  if (r) {
    let u = t.tr.step(c);
    u.setSelection(qa.create(u.doc, i)), r(u.scrollIntoView());
  }
  return !0;
}
function i8(t, e, r = !1) {
  for (let n = t; n; n = e == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (r && n.childCount != 1)
      return !1;
  }
  return !1;
}
const hmt = (t, e, r) => {
  let { $head: n, empty: a } = t.selection, i = n;
  if (!a)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("backward", t) : n.parentOffset > 0)
      return !1;
    i = sbe(n);
  }
  let o = i && i.nodeBefore;
  return !o || !ea.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(ea.create(t.doc, i.pos - o.nodeSize)).scrollIntoView()), !0);
};
function sbe(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function pmt(t, e) {
  let { $cursor: r } = t.selection;
  return !r || (e ? !e.endOfTextblock("forward", t) : r.parentOffset < r.parent.content.size) ? null : r;
}
const mmt = (t, e, r) => {
  let n = pmt(t, r);
  if (!n)
    return !1;
  let a = lbe(n);
  if (!a)
    return !1;
  let i = a.nodeAfter;
  if (xmt(t, a, e, 1))
    return !0;
  if (n.parent.content.size == 0 && (i8(i, "start") || ea.isSelectable(i))) {
    let o = RH(t.doc, n.before(), n.after(), hn.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let s = t.tr.step(o);
        s.setSelection(i8(i, "start") ? Ci.findFrom(s.doc.resolve(s.mapping.map(a.pos)), 1) : ea.create(s.doc, s.mapping.map(a.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return i.isAtom && a.depth == n.depth - 1 ? (e && e(t.tr.delete(a.pos, a.pos + i.nodeSize).scrollIntoView()), !0) : !1;
}, gmt = (t, e, r) => {
  let { $head: n, empty: a } = t.selection, i = n;
  if (!a)
    return !1;
  if (n.parent.isTextblock) {
    if (r ? !r.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size)
      return !1;
    i = lbe(n);
  }
  let o = i && i.nodeAfter;
  return !o || !ea.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(ea.create(t.doc, i.pos)).scrollIntoView()), !0);
};
function lbe(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let r = t.node(e);
      if (t.index(e) + 1 < r.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (r.type.spec.isolating)
        break;
    }
  return null;
}
const Krn = (t, e) => {
  let r = t.selection, n = r instanceof ea, a;
  if (n) {
    if (r.node.isTextblock || !r3(t.doc, r.from))
      return !1;
    a = r.from;
  } else if (a = PH(t.doc, r.from, -1), a == null)
    return !1;
  if (e) {
    let i = t.tr.join(a);
    n && i.setSelection(ea.create(i.doc, a - t.doc.resolve(a).nodeBefore.nodeSize)), e(i.scrollIntoView());
  }
  return !0;
}, Zrn = (t, e) => {
  let r = t.selection, n;
  if (r instanceof ea) {
    if (r.node.isTextblock || !r3(t.doc, r.to))
      return !1;
    n = r.to;
  } else if (n = PH(t.doc, r.to, 1), n == null)
    return !1;
  return e && e(t.tr.join(n).scrollIntoView()), !0;
}, Jrn = (t, e) => {
  let { $from: r, $to: n } = t.selection, a = r.blockRange(n), i = a && fC(a);
  return i == null ? !1 : (e && e(t.tr.lift(a, i).scrollIntoView()), !0);
}, vmt = (t, e) => {
  let { $head: r, $anchor: n } = t.selection;
  return !r.parent.type.spec.code || !r.sameParent(n) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function cbe(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: r } = t.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
const Yrn = (t, e) => {
  let { $head: r, $anchor: n } = t.selection;
  if (!r.parent.type.spec.code || !r.sameParent(n))
    return !1;
  let a = r.node(-1), i = r.indexAfter(-1), o = cbe(a.contentMatchAt(i));
  if (!o || !a.canReplaceWith(i, i, o))
    return !1;
  if (e) {
    let s = r.after(), l = t.tr.replaceWith(s, s, o.createAndFill());
    l.setSelection(Ci.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, ymt = (t, e) => {
  let r = t.selection, { $from: n, $to: a } = r;
  if (r instanceof f0 || n.parent.inlineContent || a.parent.inlineContent)
    return !1;
  let i = cbe(a.parent.contentMatchAt(a.indexAfter()));
  if (!i || !i.isTextblock)
    return !1;
  if (e) {
    let o = (!n.parentOffset && a.index() < a.parent.childCount ? n : a).pos, s = t.tr.insert(o, i.createAndFill());
    s.setSelection(qa.create(s.doc, o + 1)), e(s.scrollIntoView());
  }
  return !0;
}, bmt = (t, e) => {
  let { $cursor: r } = t.selection;
  if (!r || r.parent.content.size)
    return !1;
  if (r.depth > 1 && r.after() != r.end(-1)) {
    let i = r.before();
    if (Rm(t.doc, i))
      return e && e(t.tr.split(i).scrollIntoView()), !0;
  }
  let n = r.blockRange(), a = n && fC(n);
  return a == null ? !1 : (e && e(t.tr.lift(n, a).scrollIntoView()), !0);
};
function Xrn(t) {
  return (e, r) => {
    let { $from: n, $to: a } = e.selection;
    if (e.selection instanceof ea && e.selection.node.isBlock)
      return !n.parentOffset || !Rm(e.doc, n.pos) ? !1 : (r && r(e.tr.split(n.pos).scrollIntoView()), !0);
    if (!n.depth)
      return !1;
    let i = [], o, s, l = !1, c = !1;
    for (let p = n.depth; ; p--)
      if (n.node(p).isBlock) {
        l = n.end(p) == n.pos + (n.depth - p), c = n.start(p) == n.pos - (n.depth - p), s = cbe(n.node(p - 1).contentMatchAt(n.indexAfter(p - 1))), i.unshift(l && s ? { type: s } : null), o = p;
        break;
      } else {
        if (p == 1)
          return !1;
        i.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof qa || e.selection instanceof f0) && u.deleteSelection();
    let f = u.mapping.map(n.pos), h = Rm(u.doc, f, i.length, i);
    if (h || (i[0] = s ? { type: s } : null, h = Rm(u.doc, f, i.length, i)), u.split(f, i.length, i), !l && c && n.node(o).type != s) {
      let p = u.mapping.map(n.before(o)), g = u.doc.resolve(p);
      s && n.node(o - 1).canReplaceWith(g.index(), g.index() + 1, s) && u.setNodeMarkup(u.mapping.map(n.before(o)), s);
    }
    return r && r(u.scrollIntoView()), !0;
  };
}
const Qrn = Xrn(), enn = (t, e) => {
  let { $from: r, to: n } = t.selection, a, i = r.sharedDepth(n);
  return i == 0 ? !1 : (a = r.before(i), e && e(t.tr.setSelection(ea.create(t.doc, a))), !0);
};
function tnn(t, e, r) {
  let n = e.nodeBefore, a = e.nodeAfter, i = e.index();
  return !n || !a || !n.type.compatibleContent(a.type) ? !1 : !n.content.size && e.parent.canReplace(i - 1, i) ? (r && r(t.tr.delete(e.pos - n.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(i, i + 1) || !(a.isTextblock || r3(t.doc, e.pos)) ? !1 : (r && r(t.tr.join(e.pos).scrollIntoView()), !0);
}
function xmt(t, e, r, n) {
  let a = e.nodeBefore, i = e.nodeAfter, o, s, l = a.type.spec.isolating || i.type.spec.isolating;
  if (!l && tnn(t, e, r))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (s = a.contentMatchAt(a.childCount)).findWrapping(i.type)) && s.matchType(o[0] || i.type).validEnd) {
    if (r) {
      let p = e.pos + i.nodeSize, g = Mr.empty;
      for (let w = o.length - 1; w >= 0; w--)
        g = Mr.from(o[w].create(null, g));
      g = Mr.from(a.copy(g));
      let y = t.tr.step(new ac(e.pos - 1, p, e.pos, p, new hn(g, 1, 0), o.length, !0)), b = y.doc.resolve(p + 2 * o.length);
      b.nodeAfter && b.nodeAfter.type == a.type && r3(y.doc, b.pos) && y.join(b.pos), r(y.scrollIntoView());
    }
    return !0;
  }
  let u = i.type.spec.isolating || n > 0 && l ? null : Ci.findFrom(e, 1), f = u && u.$from.blockRange(u.$to), h = f && fC(f);
  if (h != null && h >= e.depth)
    return r && r(t.tr.lift(f, h).scrollIntoView()), !0;
  if (c && i8(i, "start", !0) && i8(a, "end")) {
    let p = a, g = [];
    for (; g.push(p), !p.isTextblock; )
      p = p.lastChild;
    let y = i, b = 1;
    for (; !y.isTextblock; y = y.firstChild)
      b++;
    if (p.canReplace(p.childCount, p.childCount, y.content)) {
      if (r) {
        let w = Mr.empty;
        for (let C = g.length - 1; C >= 0; C--)
          w = Mr.from(g[C].copy(w));
        let _ = t.tr.step(new ac(e.pos - g.length, e.pos + i.nodeSize, e.pos + b, e.pos + i.nodeSize - b, new hn(w, g.length, 0), 0, !0));
        r(_.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function Cmt(t) {
  return function(e, r) {
    let n = e.selection, a = t < 0 ? n.$from : n.$to, i = a.depth;
    for (; a.node(i).isInline; ) {
      if (!i)
        return !1;
      i--;
    }
    return a.node(i).isTextblock ? (r && r(e.tr.setSelection(qa.create(e.doc, t < 0 ? a.start(i) : a.end(i)))), !0) : !1;
  };
}
const rnn = Cmt(-1), nnn = Cmt(1);
function ann(t, e = null) {
  return function(r, n) {
    let { $from: a, $to: i } = r.selection, o = a.blockRange(i), s = o && Z3e(o, t, e);
    return s ? (n && n(r.tr.wrap(o, s).scrollIntoView()), !0) : !1;
  };
}
function bje(t, e = null) {
  return function(r, n) {
    let a = !1;
    for (let i = 0; i < r.selection.ranges.length && !a; i++) {
      let { $from: { pos: o }, $to: { pos: s } } = r.selection.ranges[i];
      r.doc.nodesBetween(o, s, (l, c) => {
        if (a)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            a = !0;
          else {
            let u = r.doc.resolve(c), f = u.index();
            a = u.parent.canReplaceWith(f, f + 1, t);
          }
      });
    }
    if (!a)
      return !1;
    if (n) {
      let i = r.tr;
      for (let o = 0; o < r.selection.ranges.length; o++) {
        let { $from: { pos: s }, $to: { pos: l } } = r.selection.ranges[o];
        i.setBlockType(s, l, t, e);
      }
      n(i.scrollIntoView());
    }
    return !0;
  };
}
function ube(...t) {
  return function(e, r, n) {
    for (let a = 0; a < t.length; a++)
      if (t[a](e, r, n))
        return !0;
    return !1;
  };
}
ube(obe, dmt, hmt);
ube(obe, mmt, gmt);
ube(vmt, ymt, bmt, Qrn);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function inn(t, e = null) {
  return function(r, n) {
    let { $from: a, $to: i } = r.selection, o = a.blockRange(i);
    if (!o)
      return !1;
    let s = n ? r.tr : null;
    return onn(s, o, t, e) ? (n && n(s.scrollIntoView()), !0) : !1;
  };
}
function onn(t, e, r, n = null) {
  let a = !1, i = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(r) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    i = new PF(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new PF(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), a = !0;
  }
  let s = Z3e(i, r, n, e);
  return s ? (t && snn(t, e, s, a, r), !0) : !1;
}
function snn(t, e, r, n, a) {
  let i = Mr.empty;
  for (let u = r.length - 1; u >= 0; u--)
    i = Mr.from(r[u].type.create(r[u].attrs, i));
  t.step(new ac(e.start - (n ? 2 : 0), e.end, e.start, e.end, new hn(i, 0, 0), r.length, !0));
  let o = 0;
  for (let u = 0; u < r.length; u++)
    r[u].type == a && (o = u + 1);
  let s = r.length - o, l = e.start + r.length - (n ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, f = e.endIndex, h = !0; u < f; u++, h = !1)
    !h && Rm(t.doc, l, s) && (t.split(l, s), l += 2 * s), l += c.child(u).nodeSize;
  return t;
}
function lnn(t) {
  return function(e, r) {
    let { $from: n, $to: a } = e.selection, i = n.blockRange(a, (o) => o.childCount > 0 && o.firstChild.type == t);
    return i ? r ? n.node(i.depth - 1).type == t ? cnn(e, r, t, i) : unn(e, r, i) : !0 : !1;
  };
}
function cnn(t, e, r, n) {
  let a = t.tr, i = n.end, o = n.$to.end(n.depth);
  i < o && (a.step(new ac(i - 1, o, i, o, new hn(Mr.from(r.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new PF(a.doc.resolve(n.$from.pos), a.doc.resolve(o), n.depth));
  const s = fC(n);
  if (s == null)
    return !1;
  a.lift(n, s);
  let l = a.doc.resolve(a.mapping.map(i, -1) - 1);
  return r3(a.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && a.join(l.pos), e(a.scrollIntoView()), !0;
}
function unn(t, e, r) {
  let n = t.tr, a = r.parent;
  for (let p = r.end, g = r.endIndex - 1, y = r.startIndex; g > y; g--)
    p -= a.child(g).nodeSize, n.delete(p - 1, p + 1);
  let i = n.doc.resolve(r.start), o = i.nodeAfter;
  if (n.mapping.map(r.end) != r.start + i.nodeAfter.nodeSize)
    return !1;
  let s = r.startIndex == 0, l = r.endIndex == a.childCount, c = i.node(-1), u = i.index(-1);
  if (!c.canReplace(u + (s ? 0 : 1), u + 1, o.content.append(l ? Mr.empty : Mr.from(a))))
    return !1;
  let f = i.pos, h = f + o.nodeSize;
  return n.step(new ac(f - (s ? 1 : 0), h + (l ? 1 : 0), f + 1, h - 1, new hn((s ? Mr.empty : Mr.from(a.copy(Mr.empty))).append(l ? Mr.empty : Mr.from(a.copy(Mr.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(n.scrollIntoView()), !0;
}
function dnn(t) {
  return function(e, r) {
    let { $from: n, $to: a } = e.selection, i = n.blockRange(a, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!i)
      return !1;
    let o = i.startIndex;
    if (o == 0)
      return !1;
    let s = i.parent, l = s.child(o - 1);
    if (l.type != t)
      return !1;
    if (r) {
      let c = l.lastChild && l.lastChild.type == s.type, u = Mr.from(c ? t.create() : null), f = new hn(Mr.from(t.create(null, Mr.from(s.type.create(null, u)))), c ? 3 : 1, 0), h = i.start, p = i.end;
      r(e.tr.step(new ac(h - (c ? 3 : 1), p, h, p, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function DH(t) {
  const { state: e, transaction: r } = t;
  let { selection: n } = r, { doc: a } = r, { storedMarks: i } = r;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return i;
    },
    get selection() {
      return n;
    },
    get doc() {
      return a;
    },
    get tr() {
      return n = r.selection, a = r.doc, i = r.storedMarks, r;
    }
  };
}
class LH {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: r, state: n } = this, { view: a } = r, { tr: i } = n, o = this.buildProps(i);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const f = l(...u)(o);
      return !i.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(i), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, r = !0) {
    const { rawCommands: n, editor: a, state: i } = this, { view: o } = a, s = [], l = !!e, c = e || i.tr, u = () => (!l && r && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), s.every((h) => h === !0)), f = {
      ...Object.fromEntries(Object.entries(n).map(([h, p]) => [h, (...y) => {
        const b = this.buildProps(c, r), w = p(...y)(b);
        return s.push(w), f;
      }])),
      run: u
    };
    return f;
  }
  createCan(e) {
    const { rawCommands: r, state: n } = this, a = !1, i = e || n.tr, o = this.buildProps(i, a);
    return {
      ...Object.fromEntries(Object.entries(r).map(([l, c]) => [l, (...u) => c(...u)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(i, a)
    };
  }
  buildProps(e, r = !0) {
    const { rawCommands: n, editor: a, state: i } = this, { view: o } = a, s = {
      tr: e,
      editor: a,
      view: o,
      state: DH({
        state: i,
        transaction: e
      }),
      dispatch: r ? () => {
      } : void 0,
      chain: () => this.createChain(e, r),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)(s)]));
      }
    };
    return s;
  }
}
class fnn {
  constructor() {
    this.callbacks = {};
  }
  on(e, r) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(r), this;
  }
  emit(e, ...r) {
    const n = this.callbacks[e];
    return n && n.forEach((a) => a.apply(this, r)), this;
  }
  off(e, r) {
    const n = this.callbacks[e];
    return n && (r ? this.callbacks[e] = n.filter((a) => a !== r) : delete this.callbacks[e]), this;
  }
  once(e, r) {
    const n = (...a) => {
      this.off(e, n), r.apply(this, a);
    };
    return this.on(e, n);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function In(t, e, r) {
  return t.config[e] === void 0 && t.parent ? In(t.parent, e, r) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...r,
    parent: t.parent ? In(t.parent, e, r) : null
  }) : t.config[e];
}
function jH(t) {
  const e = t.filter((a) => a.type === "extension"), r = t.filter((a) => a.type === "node"), n = t.filter((a) => a.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: r,
    markExtensions: n
  };
}
function wmt(t) {
  const e = [], { nodeExtensions: r, markExtensions: n } = jH(t), a = [...r, ...n], i = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: a
    }, l = In(o, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((f) => {
        Object.entries(u.attributes).forEach(([h, p]) => {
          e.push({
            type: f,
            name: h,
            attribute: {
              ...i,
              ...p
            }
          });
        });
      });
    });
  }), a.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = In(o, "addAttributes", s);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, f]) => {
      const h = {
        ...i,
        ...f
      };
      typeof (h == null ? void 0 : h.default) == "function" && (h.default = h.default()), h != null && h.isRequired && (h == null ? void 0 : h.default) === void 0 && delete h.default, e.push({
        type: o.name,
        name: u,
        attribute: h
      });
    });
  }), e;
}
function oc(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function ju(...t) {
  return t.filter((e) => !!e).reduce((e, r) => {
    const n = { ...e };
    return Object.entries(r).forEach(([a, i]) => {
      if (!n[a]) {
        n[a] = i;
        return;
      }
      if (a === "class") {
        const s = i ? String(i).split(" ") : [], l = n[a] ? n[a].split(" ") : [], c = s.filter((u) => !l.includes(u));
        n[a] = [...l, ...c].join(" ");
      } else if (a === "style") {
        const s = i ? i.split(";").map((u) => u.trim()).filter(Boolean) : [], l = n[a] ? n[a].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [f, h] = u.split(":").map((p) => p.trim());
          c.set(f, h);
        }), s.forEach((u) => {
          const [f, h] = u.split(":").map((p) => p.trim());
          c.set(f, h);
        }), n[a] = Array.from(c.entries()).map(([u, f]) => `${u}: ${f}`).join("; ");
      } else
        n[a] = i;
    }), n;
  }, {});
}
function Ofe(t, e) {
  return e.filter((r) => r.type === t.type.name).filter((r) => r.attribute.rendered).map((r) => r.attribute.renderHTML ? r.attribute.renderHTML(t.attrs) || {} : {
    [r.name]: t.attrs[r.name]
  }).reduce((r, n) => ju(r, n), {});
}
function Smt(t) {
  return typeof t == "function";
}
function Ni(t, e = void 0, ...r) {
  return Smt(t) ? e ? t.bind(e)(...r) : t(...r) : t;
}
function hnn(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function pnn(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function xje(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (r) => {
      const n = t.getAttrs ? t.getAttrs(r) : t.attrs;
      if (n === !1)
        return !1;
      const a = e.reduce((i, o) => {
        const s = o.attribute.parseHTML ? o.attribute.parseHTML(r) : pnn(r.getAttribute(o.name));
        return s == null ? i : {
          ...i,
          [o.name]: s
        };
      }, {});
      return { ...n, ...a };
    }
  };
}
function Cje(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, r]) => e === "attrs" && hnn(r) ? !1 : r != null)
  );
}
function mnn(t, e) {
  var r;
  const n = wmt(t), { nodeExtensions: a, markExtensions: i } = jH(t), o = (r = a.find((c) => In(c, "topNode"))) === null || r === void 0 ? void 0 : r.name, s = Object.fromEntries(a.map((c) => {
    const u = n.filter((w) => w.type === c.name), f = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = t.reduce((w, _) => {
      const C = In(_, "extendNodeSchema", f);
      return {
        ...w,
        ...C ? C(c) : {}
      };
    }, {}), p = Cje({
      ...h,
      content: Ni(In(c, "content", f)),
      marks: Ni(In(c, "marks", f)),
      group: Ni(In(c, "group", f)),
      inline: Ni(In(c, "inline", f)),
      atom: Ni(In(c, "atom", f)),
      selectable: Ni(In(c, "selectable", f)),
      draggable: Ni(In(c, "draggable", f)),
      code: Ni(In(c, "code", f)),
      whitespace: Ni(In(c, "whitespace", f)),
      linebreakReplacement: Ni(In(c, "linebreakReplacement", f)),
      defining: Ni(In(c, "defining", f)),
      isolating: Ni(In(c, "isolating", f)),
      attrs: Object.fromEntries(u.map((w) => {
        var _;
        return [w.name, { default: (_ = w == null ? void 0 : w.attribute) === null || _ === void 0 ? void 0 : _.default }];
      }))
    }), g = Ni(In(c, "parseHTML", f));
    g && (p.parseDOM = g.map((w) => xje(w, u)));
    const y = In(c, "renderHTML", f);
    y && (p.toDOM = (w) => y({
      node: w,
      HTMLAttributes: Ofe(w, u)
    }));
    const b = In(c, "renderText", f);
    return b && (p.toText = b), [c.name, p];
  })), l = Object.fromEntries(i.map((c) => {
    const u = n.filter((b) => b.type === c.name), f = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, h = t.reduce((b, w) => {
      const _ = In(w, "extendMarkSchema", f);
      return {
        ...b,
        ..._ ? _(c) : {}
      };
    }, {}), p = Cje({
      ...h,
      inclusive: Ni(In(c, "inclusive", f)),
      excludes: Ni(In(c, "excludes", f)),
      group: Ni(In(c, "group", f)),
      spanning: Ni(In(c, "spanning", f)),
      code: Ni(In(c, "code", f)),
      attrs: Object.fromEntries(u.map((b) => {
        var w;
        return [b.name, { default: (w = b == null ? void 0 : b.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), g = Ni(In(c, "parseHTML", f));
    g && (p.parseDOM = g.map((b) => xje(b, u)));
    const y = In(c, "renderHTML", f);
    return y && (p.toDOM = (b) => y({
      mark: b,
      HTMLAttributes: Ofe(b, u)
    })), [c.name, p];
  }));
  return new fpt({
    topNode: o,
    nodes: s,
    marks: l
  });
}
function Vie(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function wje(t, e) {
  return Array.isArray(e) ? e.some((r) => (typeof r == "string" ? r : r.name) === t.name) : e;
}
function dbe(t, e) {
  const r = _6.fromSchema(e).serializeFragment(t), a = document.implementation.createHTMLDocument().createElement("div");
  return a.appendChild(r), a.innerHTML;
}
const gnn = (t, e = 500) => {
  let r = "";
  const n = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, n - e), n, (a, i, o, s) => {
    var l, c;
    const u = ((c = (l = a.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: a,
      pos: i,
      parent: o,
      index: s
    })) || a.textContent || "%leaf%";
    r += a.isAtom && !a.isText ? u : u.slice(0, Math.max(0, n - i));
  }), r;
};
function fbe(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class FH {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const vnn = (t, e) => {
  if (fbe(e))
    return e.exec(t);
  const r = e(t);
  if (!r)
    return null;
  const n = [r.text];
  return n.index = r.index, n.input = t, n.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), n.push(r.replaceWith)), n;
};
function yN(t) {
  var e;
  const { editor: r, from: n, to: a, text: i, rules: o, plugin: s } = t, { view: l } = r;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(n);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((h) => h.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = gnn(c) + i;
  return o.forEach((h) => {
    if (u)
      return;
    const p = vnn(f, h.find);
    if (!p)
      return;
    const g = l.state.tr, y = DH({
      state: l.state,
      transaction: g
    }), b = {
      from: n - (p[0].length - i.length),
      to: a
    }, { commands: w, chain: _, can: C } = new LH({
      editor: r,
      state: y
    });
    h.handler({
      state: y,
      range: b,
      match: p,
      commands: w,
      chain: _,
      can: C
    }) === null || !g.steps.length || (g.setMeta(s, {
      transform: g,
      from: n,
      to: a,
      text: i
    }), l.dispatch(g), u = !0);
  }), u;
}
function ynn(t) {
  const { editor: e, rules: r } = t, n = new Bd({
    state: {
      init() {
        return null;
      },
      apply(a, i, o) {
        const s = a.getMeta(n);
        if (s)
          return s;
        const l = a.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = dbe(Mr.from(u), o.schema);
          const { from: f } = l, h = f + u.length;
          yN({
            editor: e,
            from: f,
            to: h,
            text: u,
            rules: r,
            plugin: n
          });
        }), a.selectionSet || a.docChanged ? null : i;
      }
    },
    props: {
      handleTextInput(a, i, o, s) {
        return yN({
          editor: e,
          from: i,
          to: o,
          text: s,
          rules: r,
          plugin: n
        });
      },
      handleDOMEvents: {
        compositionend: (a) => (setTimeout(() => {
          const { $cursor: i } = a.state.selection;
          i && yN({
            editor: e,
            from: i.pos,
            to: i.pos,
            text: "",
            rules: r,
            plugin: n
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(a, i) {
        if (i.key !== "Enter")
          return !1;
        const { $cursor: o } = a.state.selection;
        return o ? yN({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: r,
          plugin: n
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return n;
}
function bnn(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function bN(t) {
  return bnn(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function zH(t, e) {
  const r = { ...t };
  return bN(t) && bN(e) && Object.keys(e).forEach((n) => {
    bN(e[n]) && bN(t[n]) ? r[n] = zH(t[n], e[n]) : r[n] = e[n];
  }), r;
}
class ky {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ni(In(this, "addOptions", {
      name: this.name
    }))), this.storage = Ni(In(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new ky(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => zH(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new ky(e);
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Ni(In(r, "addOptions", {
      name: r.name
    })), r.storage = Ni(In(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
  static handleExit({ editor: e, mark: r }) {
    const { tr: n } = e.state, a = e.state.selection.$from;
    if (a.pos === a.end()) {
      const o = a.marks();
      if (!!!o.find((c) => (c == null ? void 0 : c.type.name) === r.name))
        return !1;
      const l = o.find((c) => (c == null ? void 0 : c.type.name) === r.name);
      return l && n.removeStoredMark(l), n.insertText(" ", a.pos), e.view.dispatch(n), !0;
    }
    return !1;
  }
}
function xnn(t) {
  return typeof t == "number";
}
class Cnn {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const wnn = (t, e, r) => {
  if (fbe(e))
    return [...t.matchAll(e)];
  const n = e(t, r);
  return n ? n.map((a) => {
    const i = [a.text];
    return i.index = a.index, i.input = t, i.data = a.data, a.replaceWith && (a.text.includes(a.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), i.push(a.replaceWith)), i;
  }) : [];
};
function Snn(t) {
  const { editor: e, state: r, from: n, to: a, rule: i, pasteEvent: o, dropEvent: s } = t, { commands: l, chain: c, can: u } = new LH({
    editor: e,
    state: r
  }), f = [];
  return r.doc.nodesBetween(n, a, (p, g) => {
    if (!p.isTextblock || p.type.spec.code)
      return;
    const y = Math.max(n, g), b = Math.min(a, g + p.content.size), w = p.textBetween(y - g, b - g, void 0, "￼");
    wnn(w, i.find, o).forEach((C) => {
      if (C.index === void 0)
        return;
      const x = y + C.index + 1, S = x + C[0].length, A = {
        from: r.tr.mapping.map(x),
        to: r.tr.mapping.map(S)
      }, I = i.handler({
        state: r,
        range: A,
        match: C,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: o,
        dropEvent: s
      });
      f.push(I);
    });
  }), f.every((p) => p !== null);
}
let xN = null;
const _nn = (t) => {
  var e;
  const r = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = r.clipboardData) === null || e === void 0 || e.setData("text/html", t), r;
};
function knn(t) {
  const { editor: e, rules: r } = t;
  let n = null, a = !1, i = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const l = ({ state: u, from: f, to: h, rule: p, pasteEvt: g }) => {
    const y = u.tr, b = DH({
      state: u,
      transaction: y
    });
    if (!(!Snn({
      editor: e,
      state: b,
      from: Math.max(f - 1, 0),
      to: h.b - 1,
      rule: p,
      pasteEvent: g,
      dropEvent: s
    }) || !y.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, y;
    }
  };
  return r.map((u) => new Bd({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const h = (g) => {
        var y;
        n = !((y = f.dom.parentElement) === null || y === void 0) && y.contains(g.target) ? f.dom.parentElement : null, n && (xN = e);
      }, p = () => {
        xN && (xN = null);
      };
      return window.addEventListener("dragstart", h), window.addEventListener("dragend", p), {
        destroy() {
          window.removeEventListener("dragstart", h), window.removeEventListener("dragend", p);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, h) => {
          if (i = n === f.dom.parentElement, s = h, !i) {
            const p = xN;
            p && setTimeout(() => {
              const g = p.state.selection;
              g && p.commands.deleteRange({ from: g.from, to: g.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, h) => {
          var p;
          const g = (p = h.clipboardData) === null || p === void 0 ? void 0 : p.getData("text/html");
          return o = h, a = !!(g != null && g.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, h, p) => {
      const g = f[0], y = g.getMeta("uiEvent") === "paste" && !a, b = g.getMeta("uiEvent") === "drop" && !i, w = g.getMeta("applyPasteRules"), _ = !!w;
      if (!y && !b && !_)
        return;
      if (_) {
        let { text: S } = w;
        typeof S == "string" ? S = S : S = dbe(Mr.from(S), p.schema);
        const { from: A } = w, I = A + S.length, M = _nn(S);
        return l({
          rule: u,
          state: p,
          from: A,
          to: { b: I },
          pasteEvt: M
        });
      }
      const C = h.doc.content.findDiffStart(p.doc.content), x = h.doc.content.findDiffEnd(p.doc.content);
      if (!(!xnn(C) || !x || C === x.b))
        return l({
          rule: u,
          state: p,
          from: C,
          to: x,
          pasteEvt: o
        });
    }
  }));
}
function Ann(t) {
  const e = t.filter((r, n) => t.indexOf(r) !== n);
  return Array.from(new Set(e));
}
class t7 {
  constructor(e, r) {
    this.splittableMarks = [], this.editor = r, this.extensions = t7.resolve(e), this.schema = mnn(this.extensions, r), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const r = t7.sort(t7.flatten(e)), n = Ann(r.map((a) => a.name));
    return n.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${n.map((a) => `'${a}'`).join(", ")}]. This can lead to issues.`), r;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((r) => {
      const n = {
        name: r.name,
        options: r.options,
        storage: r.storage
      }, a = In(r, "addExtensions", n);
      return a ? [r, ...this.flatten(a())] : r;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((n, a) => {
      const i = In(n, "priority") || 100, o = In(a, "priority") || 100;
      return i > o ? -1 : i < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, r) => {
      const n = {
        name: r.name,
        options: r.options,
        storage: r.storage,
        editor: this.editor,
        type: Vie(r.name, this.schema)
      }, a = In(r, "addCommands", n);
      return a ? {
        ...e,
        ...a()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, r = t7.sort([...this.extensions].reverse()), n = [], a = [], i = r.map((o) => {
      const s = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: Vie(o.name, this.schema)
      }, l = [], c = In(o, "addKeyboardShortcuts", s);
      let u = {};
      if (o.type === "mark" && In(o, "exitable", s) && (u.ArrowRight = () => ky.handleExit({ editor: e, mark: o })), c) {
        const y = Object.fromEntries(Object.entries(c()).map(([b, w]) => [b, () => w({ editor: e })]));
        u = { ...u, ...y };
      }
      const f = Urn(u);
      l.push(f);
      const h = In(o, "addInputRules", s);
      wje(o, e.options.enableInputRules) && h && n.push(...h());
      const p = In(o, "addPasteRules", s);
      wje(o, e.options.enablePasteRules) && p && a.push(...p());
      const g = In(o, "addProseMirrorPlugins", s);
      if (g) {
        const y = g();
        l.push(...y);
      }
      return l;
    }).flat();
    return [
      ynn({
        editor: e,
        rules: n
      }),
      ...knn({
        editor: e,
        rules: a
      }),
      ...i
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return wmt(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: r } = jH(this.extensions);
    return Object.fromEntries(r.filter((n) => !!In(n, "addNodeView")).map((n) => {
      const a = this.attributes.filter((l) => l.type === n.name), i = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: e,
        type: oc(n.name, this.schema)
      }, o = In(n, "addNodeView", i);
      if (!o)
        return [];
      const s = (l, c, u, f, h) => {
        const p = Ofe(l, a);
        return o()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: f,
          innerDecorations: h,
          // tiptap-specific
          editor: e,
          extension: n,
          HTMLAttributes: p
        });
      };
      return [n.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var r;
      this.editor.extensionStorage[e.name] = e.storage;
      const n = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: Vie(e.name, this.schema)
      };
      e.type === "mark" && (!((r = Ni(In(e, "keepOnSplit", n))) !== null && r !== void 0) || r) && this.splittableMarks.push(e.name);
      const a = In(e, "onBeforeCreate", n), i = In(e, "onCreate", n), o = In(e, "onUpdate", n), s = In(e, "onSelectionUpdate", n), l = In(e, "onTransaction", n), c = In(e, "onFocus", n), u = In(e, "onBlur", n), f = In(e, "onDestroy", n);
      a && this.editor.on("beforeCreate", a), i && this.editor.on("create", i), o && this.editor.on("update", o), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
}
class Fu {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ni(In(this, "addOptions", {
      name: this.name
    }))), this.storage = Ni(In(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Fu(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => zH(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new Fu({ ...this.config, ...e });
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Ni(In(r, "addOptions", {
      name: r.name
    })), r.storage = Ni(In(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
}
function _mt(t, e, r) {
  const { from: n, to: a } = e, { blockSeparator: i = `

`, textSerializers: o = {} } = r || {};
  let s = "";
  return t.nodesBetween(n, a, (l, c, u, f) => {
    var h;
    l.isBlock && c > n && (s += i);
    const p = o == null ? void 0 : o[l.type.name];
    if (p)
      return u && (s += p({
        node: l,
        pos: c,
        parent: u,
        index: f,
        range: e
      })), !1;
    l.isText && (s += (h = l == null ? void 0 : l.text) === null || h === void 0 ? void 0 : h.slice(Math.max(n, c) - c, a - c));
  }), s;
}
function kmt(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, r]) => [e, r.spec.toText]));
}
const Tnn = Fu.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Bd({
        key: new lp("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: r } = t, { doc: n, selection: a } = e, { ranges: i } = a, o = Math.min(...i.map((u) => u.$from.pos)), s = Math.max(...i.map((u) => u.$to.pos)), l = kmt(r);
            return _mt(n, { from: o, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), Enn = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var r;
  t.isDestroyed || (e.dom.blur(), (r = window == null ? void 0 : window.getSelection()) === null || r === void 0 || r.removeAllRanges());
}), !0), Inn = (t = !1) => ({ commands: e }) => e.setContent("", t), Mnn = () => ({ state: t, tr: e, dispatch: r }) => {
  const { selection: n } = e, { ranges: a } = n;
  return r && a.forEach(({ $from: i, $to: o }) => {
    t.doc.nodesBetween(i.pos, o.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: c, mapping: u } = e, f = c.resolve(u.map(l)), h = c.resolve(u.map(l + s.nodeSize)), p = f.blockRange(h);
      if (!p)
        return;
      const g = fC(p);
      if (s.type.isTextblock) {
        const { defaultType: y } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(p.start, y);
      }
      (g || g === 0) && e.lift(p, g);
    });
  }), !0;
}, Pnn = (t) => (e) => t(e), Rnn = () => ({ state: t, dispatch: e }) => ymt(t, e), Onn = (t, e) => ({ editor: r, tr: n }) => {
  const { state: a } = r, i = a.doc.slice(t.from, t.to);
  n.deleteRange(t.from, t.to);
  const o = n.mapping.map(e);
  return n.insert(o, i.content), n.setSelection(new qa(n.doc.resolve(o - 1))), !0;
}, Bnn = () => ({ tr: t, dispatch: e }) => {
  const { selection: r } = t, n = r.$anchor.node();
  if (n.content.size > 0)
    return !1;
  const a = t.selection.$anchor;
  for (let i = a.depth; i > 0; i -= 1)
    if (a.node(i).type === n.type) {
      if (e) {
        const s = a.before(i), l = a.after(i);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Nnn = (t) => ({ tr: e, state: r, dispatch: n }) => {
  const a = oc(t, r.schema), i = e.selection.$anchor;
  for (let o = i.depth; o > 0; o -= 1)
    if (i.node(o).type === a) {
      if (n) {
        const l = i.before(o), c = i.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, $nn = (t) => ({ tr: e, dispatch: r }) => {
  const { from: n, to: a } = t;
  return r && e.delete(n, a), !0;
}, Dnn = () => ({ state: t, dispatch: e }) => obe(t, e), Lnn = () => ({ commands: t }) => t.keyboardShortcut("Enter"), jnn = () => ({ state: t, dispatch: e }) => Yrn(t, e);
function jF(t, e, r = { strict: !0 }) {
  const n = Object.keys(e);
  return n.length ? n.every((a) => r.strict ? e[a] === t[a] : fbe(e[a]) ? e[a].test(t[a]) : e[a] === t[a]) : !0;
}
function Amt(t, e, r = {}) {
  return t.find((n) => n.type === e && jF(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(r).map((a) => [a, n.attrs[a]])),
    r
  ));
}
function Sje(t, e, r = {}) {
  return !!Amt(t, e, r);
}
function hbe(t, e, r) {
  var n;
  if (!t || !e)
    return;
  let a = t.parent.childAfter(t.parentOffset);
  if ((!a.node || !a.node.marks.some((u) => u.type === e)) && (a = t.parent.childBefore(t.parentOffset)), !a.node || !a.node.marks.some((u) => u.type === e) || (r = r || ((n = a.node.marks[0]) === null || n === void 0 ? void 0 : n.attrs), !Amt([...a.node.marks], e, r)))
    return;
  let o = a.index, s = t.start() + a.offset, l = o + 1, c = s + a.node.nodeSize;
  for (; o > 0 && Sje([...t.parent.child(o - 1).marks], e, r); )
    o -= 1, s -= t.parent.child(o).nodeSize;
  for (; l < t.parent.childCount && Sje([...t.parent.child(l).marks], e, r); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: c
  };
}
function a3(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const Fnn = (t, e = {}) => ({ tr: r, state: n, dispatch: a }) => {
  const i = a3(t, n.schema), { doc: o, selection: s } = r, { $from: l, from: c, to: u } = s;
  if (a) {
    const f = hbe(l, i, e);
    if (f && f.from <= c && f.to >= u) {
      const h = qa.create(o, f.from, f.to);
      r.setSelection(h);
    }
  }
  return !0;
}, znn = (t) => (e) => {
  const r = typeof t == "function" ? t(e) : t;
  for (let n = 0; n < r.length; n += 1)
    if (r[n](e))
      return !0;
  return !1;
};
function Tmt(t) {
  return t instanceof qa;
}
function _b(t = 0, e = 0, r = 0) {
  return Math.min(Math.max(t, e), r);
}
function Emt(t, e = null) {
  if (!e)
    return null;
  const r = Ci.atStart(t), n = Ci.atEnd(t);
  if (e === "start" || e === !0)
    return r;
  if (e === "end")
    return n;
  const a = r.from, i = n.to;
  return e === "all" ? qa.create(t, _b(0, a, i), _b(t.content.size, a, i)) : qa.create(t, _b(e, a, i), _b(e, a, i));
}
function Gnn() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function pbe() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const Wnn = (t = null, e = {}) => ({ editor: r, view: n, tr: a, dispatch: i }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (pbe() || Gnn()) && n.dom.focus(), requestAnimationFrame(() => {
      r.isDestroyed || (n.focus(), e != null && e.scrollIntoView && r.commands.scrollIntoView());
    });
  };
  if (n.hasFocus() && t === null || t === !1)
    return !0;
  if (i && t === null && !Tmt(r.state.selection))
    return o(), !0;
  const s = Emt(a.doc, t) || r.state.selection, l = r.state.selection.eq(s);
  return i && (l || a.setSelection(s), l && a.storedMarks && a.setStoredMarks(a.storedMarks), o()), !0;
}, Hnn = (t, e) => (r) => t.every((n, a) => e(n, { ...r, index: a })), Unn = (t, e) => ({ tr: r, commands: n }) => n.insertContentAt({ from: r.selection.from, to: r.selection.to }, t, e), Imt = (t) => {
  const e = t.childNodes;
  for (let r = e.length - 1; r >= 0; r -= 1) {
    const n = e[r];
    n.nodeType === 3 && n.nodeValue && /^(\n\s\s|\n)$/.test(n.nodeValue) ? t.removeChild(n) : n.nodeType === 1 && Imt(n);
  }
  return t;
};
function CN(t) {
  const e = `<body>${t}</body>`, r = new window.DOMParser().parseFromString(e, "text/html").body;
  return Imt(r);
}
function FF(t, e, r) {
  if (t instanceof Dv || t instanceof Mr)
    return t;
  r = {
    slice: !0,
    parseOptions: {},
    ...r
  };
  const n = typeof t == "object" && t !== null, a = typeof t == "string";
  if (n)
    try {
      if (Array.isArray(t) && t.length > 0)
        return Mr.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const o = e.nodeFromJSON(t);
      return r.errorOnInvalidContent && o.check(), o;
    } catch (i) {
      if (r.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: i });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", i), FF("", e, r);
    }
  if (a) {
    if (r.errorOnInvalidContent) {
      let o = !1, s = "";
      const l = new fpt({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, s = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (r.slice ? Lv.fromSchema(l).parseSlice(CN(t), r.parseOptions) : Lv.fromSchema(l).parse(CN(t), r.parseOptions), r.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const i = Lv.fromSchema(e);
    return r.slice ? i.parseSlice(CN(t), r.parseOptions).content : i.parse(CN(t), r.parseOptions);
  }
  return FF("", e, r);
}
function Vnn(t, e, r) {
  const n = t.steps.length - 1;
  if (n < e)
    return;
  const a = t.steps[n];
  if (!(a instanceof rc || a instanceof ac))
    return;
  const i = t.mapping.maps[n];
  let o = 0;
  i.forEach((s, l, c, u) => {
    o === 0 && (o = u);
  }), t.setSelection(Ci.near(t.doc.resolve(o), r));
}
const qnn = (t) => !("type" in t), Knn = (t, e, r) => ({ tr: n, dispatch: a, editor: i }) => {
  var o;
  if (a) {
    r = {
      parseOptions: i.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...r
    };
    let s;
    try {
      s = FF(e, i.schema, {
        parseOptions: {
          preserveWhitespace: "full",
          ...r.parseOptions
        },
        errorOnInvalidContent: (o = r.errorOnInvalidContent) !== null && o !== void 0 ? o : i.options.enableContentCheck
      });
    } catch (g) {
      return i.emit("contentError", {
        editor: i,
        error: g,
        disableCollaboration: () => {
          i.storage.collaboration && (i.storage.collaboration.isDisabled = !0);
        }
      }), !1;
    }
    let { from: l, to: c } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, u = !0, f = !0;
    if ((qnn(s) ? s : [s]).forEach((g) => {
      g.check(), u = u ? g.isText && g.marks.length === 0 : !1, f = f ? g.isBlock : !1;
    }), l === c && f) {
      const { parent: g } = n.doc.resolve(l);
      g.isTextblock && !g.type.spec.code && !g.childCount && (l -= 1, c += 1);
    }
    let p;
    if (u) {
      if (Array.isArray(e))
        p = e.map((g) => g.text || "").join("");
      else if (e instanceof Mr) {
        let g = "";
        e.forEach((y) => {
          y.text && (g += y.text);
        }), p = g;
      } else typeof e == "object" && e && e.text ? p = e.text : p = e;
      n.insertText(p, l, c);
    } else
      p = s, n.replaceWith(l, c, p);
    r.updateSelection && Vnn(n, n.steps.length - 1, -1), r.applyInputRules && n.setMeta("applyInputRules", { from: l, text: p }), r.applyPasteRules && n.setMeta("applyPasteRules", { from: l, text: p });
  }
  return !0;
}, Znn = () => ({ state: t, dispatch: e }) => Krn(t, e), Jnn = () => ({ state: t, dispatch: e }) => Zrn(t, e), Ynn = () => ({ state: t, dispatch: e }) => dmt(t, e), Xnn = () => ({ state: t, dispatch: e }) => mmt(t, e), Qnn = () => ({ state: t, dispatch: e, tr: r }) => {
  try {
    const n = PH(t.doc, t.selection.$from.pos, -1);
    return n == null ? !1 : (r.join(n, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, ean = () => ({ state: t, dispatch: e, tr: r }) => {
  try {
    const n = PH(t.doc, t.selection.$from.pos, 1);
    return n == null ? !1 : (r.join(n, 2), e && e(r), !0);
  } catch {
    return !1;
  }
}, tan = () => ({ state: t, dispatch: e }) => Vrn(t, e), ran = () => ({ state: t, dispatch: e }) => qrn(t, e);
function Mmt() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function nan(t) {
  const e = t.split(/-(?!$)/);
  let r = e[e.length - 1];
  r === "Space" && (r = " ");
  let n, a, i, o;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      a = !0;
    else if (/^s(hift)?$/i.test(l))
      i = !0;
    else if (/^mod$/i.test(l))
      pbe() || Mmt() ? o = !0 : a = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return n && (r = `Alt-${r}`), a && (r = `Ctrl-${r}`), o && (r = `Meta-${r}`), i && (r = `Shift-${r}`), r;
}
const aan = (t) => ({ editor: e, view: r, tr: n, dispatch: a }) => {
  const i = nan(t).split(/-(?!$)/), o = i.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), s = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: i.includes("Alt"),
    ctrlKey: i.includes("Ctrl"),
    metaKey: i.includes("Meta"),
    shiftKey: i.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    r.someProp("handleKeyDown", (c) => c(r, s));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(n.mapping);
    u && a && n.maybeStep(u);
  }), !0;
};
function mI(t, e, r = {}) {
  const { from: n, to: a, empty: i } = t.selection, o = e ? oc(e, t.schema) : null, s = [];
  t.doc.nodesBetween(n, a, (f, h) => {
    if (f.isText)
      return;
    const p = Math.max(n, h), g = Math.min(a, h + f.nodeSize);
    s.push({
      node: f,
      from: p,
      to: g
    });
  });
  const l = a - n, c = s.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => jF(f.node.attrs, r, { strict: !1 }));
  return i ? !!c.length : c.reduce((f, h) => f + h.to - h.from, 0) >= l;
}
const ian = (t, e = {}) => ({ state: r, dispatch: n }) => {
  const a = oc(t, r.schema);
  return mI(r, a, e) ? Jrn(r, n) : !1;
}, oan = () => ({ state: t, dispatch: e }) => bmt(t, e), san = (t) => ({ state: e, dispatch: r }) => {
  const n = oc(t, e.schema);
  return lnn(n)(e, r);
}, lan = () => ({ state: t, dispatch: e }) => vmt(t, e);
function GH(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function _je(t, e) {
  const r = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((n, a) => (r.includes(a) || (n[a] = t[a]), n), {});
}
const can = (t, e) => ({ tr: r, state: n, dispatch: a }) => {
  let i = null, o = null;
  const s = GH(typeof t == "string" ? t : t.name, n.schema);
  return s ? (s === "node" && (i = oc(t, n.schema)), s === "mark" && (o = a3(t, n.schema)), a && r.selection.ranges.forEach((l) => {
    n.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      i && i === c.type && r.setNodeMarkup(u, void 0, _je(c.attrs, e)), o && c.marks.length && c.marks.forEach((f) => {
        o === f.type && r.addMark(u, u + c.nodeSize, o.create(_je(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, uan = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), dan = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const r = new f0(t.doc);
    t.setSelection(r);
  }
  return !0;
}, fan = () => ({ state: t, dispatch: e }) => hmt(t, e), han = () => ({ state: t, dispatch: e }) => gmt(t, e), pan = () => ({ state: t, dispatch: e }) => enn(t, e), man = () => ({ state: t, dispatch: e }) => nnn(t, e), gan = () => ({ state: t, dispatch: e }) => rnn(t, e);
function Bfe(t, e, r = {}, n = {}) {
  return FF(t, e, {
    slice: !1,
    parseOptions: r,
    errorOnInvalidContent: n.errorOnInvalidContent
  });
}
const van = (t, e = !1, r = {}, n = {}) => ({ editor: a, tr: i, dispatch: o, commands: s }) => {
  var l, c;
  const { doc: u } = i;
  if (r.preserveWhitespace !== "full") {
    const f = Bfe(t, a.schema, r, {
      errorOnInvalidContent: (l = n.errorOnInvalidContent) !== null && l !== void 0 ? l : a.options.enableContentCheck
    });
    return o && i.replaceWith(0, u.content.size, f).setMeta("preventUpdate", !e), !0;
  }
  return o && i.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: r,
    errorOnInvalidContent: (c = n.errorOnInvalidContent) !== null && c !== void 0 ? c : a.options.enableContentCheck
  });
};
function Pmt(t, e) {
  const r = a3(e, t.schema), { from: n, to: a, empty: i } = t.selection, o = [];
  i ? (t.storedMarks && o.push(...t.storedMarks), o.push(...t.selection.$head.marks())) : t.doc.nodesBetween(n, a, (l) => {
    o.push(...l.marks);
  });
  const s = o.find((l) => l.type.name === r.name);
  return s ? { ...s.attrs } : {};
}
function yan(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: r } = t.edge(e);
    if (r.isTextblock && !r.hasRequiredAttrs())
      return r;
  }
  return null;
}
function ban(t, e) {
  for (let r = t.depth; r > 0; r -= 1) {
    const n = t.node(r);
    if (e(n))
      return {
        pos: r > 0 ? t.before(r) : 0,
        start: t.start(r),
        depth: r,
        node: n
      };
  }
}
function mbe(t) {
  return (e) => ban(e.$from, t);
}
function xan(t, e) {
  const r = {
    from: 0,
    to: t.content.size
  };
  return _mt(t, r, e);
}
function Can(t, e) {
  const r = oc(e, t.schema), { from: n, to: a } = t.selection, i = [];
  t.doc.nodesBetween(n, a, (s) => {
    i.push(s);
  });
  const o = i.reverse().find((s) => s.type.name === r.name);
  return o ? { ...o.attrs } : {};
}
function wan(t, e) {
  const r = GH(typeof e == "string" ? e : e.name, t.schema);
  return r === "node" ? Can(t, e) : r === "mark" ? Pmt(t, e) : {};
}
function Rmt(t, e, r) {
  const n = [];
  return t === e ? r.resolve(t).marks().forEach((a) => {
    const i = r.resolve(t), o = hbe(i, a.type);
    o && n.push({
      mark: a,
      ...o
    });
  }) : r.nodesBetween(t, e, (a, i) => {
    !a || (a == null ? void 0 : a.nodeSize) === void 0 || n.push(...a.marks.map((o) => ({
      from: i,
      to: i + a.nodeSize,
      mark: o
    })));
  }), n;
}
function N$(t, e, r) {
  return Object.fromEntries(Object.entries(r).filter(([n]) => {
    const a = t.find((i) => i.type === e && i.name === n);
    return a ? a.attribute.keepOnSplit : !1;
  }));
}
function Nfe(t, e, r = {}) {
  const { empty: n, ranges: a } = t.selection, i = e ? a3(e, t.schema) : null;
  if (n)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((f) => i ? i.name === f.type.name : !0).find((f) => jF(f.attrs, r, { strict: !1 }));
  let o = 0;
  const s = [];
  if (a.forEach(({ $from: f, $to: h }) => {
    const p = f.pos, g = h.pos;
    t.doc.nodesBetween(p, g, (y, b) => {
      if (!y.isText && !y.marks.length)
        return;
      const w = Math.max(p, b), _ = Math.min(g, b + y.nodeSize), C = _ - w;
      o += C, s.push(...y.marks.map((x) => ({
        mark: x,
        from: w,
        to: _
      })));
    });
  }), o === 0)
    return !1;
  const l = s.filter((f) => i ? i.name === f.mark.type.name : !0).filter((f) => jF(f.mark.attrs, r, { strict: !1 })).reduce((f, h) => f + h.to - h.from, 0), c = s.filter((f) => i ? f.mark.type !== i && f.mark.type.excludes(i) : !0).reduce((f, h) => f + h.to - h.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function San(t, e, r = {}) {
  if (!e)
    return mI(t, null, r) || Nfe(t, null, r);
  const n = GH(e, t.schema);
  return n === "node" ? mI(t, e, r) : n === "mark" ? Nfe(t, e, r) : !1;
}
function kje(t, e) {
  const { nodeExtensions: r } = jH(e), n = r.find((o) => o.name === t);
  if (!n)
    return !1;
  const a = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, i = Ni(In(n, "group", a));
  return typeof i != "string" ? !1 : i.split(" ").includes("list");
}
function gbe(t, { checkChildren: e = !0, ignoreWhitespace: r = !1 } = {}) {
  var n;
  if (r) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((n = t.text) !== null && n !== void 0 ? n : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let a = !0;
    return t.content.forEach((i) => {
      a !== !1 && (gbe(i, { ignoreWhitespace: r, checkChildren: e }) || (a = !1));
    }), a;
  }
  return !1;
}
function _an(t) {
  return t instanceof ea;
}
function kan(t, e, r) {
  var n;
  const { selection: a } = e;
  let i = null;
  if (Tmt(a) && (i = a.$cursor), i) {
    const s = (n = t.storedMarks) !== null && n !== void 0 ? n : i.marks();
    return !!r.isInSet(s) || !s.some((l) => l.type.excludes(r));
  }
  const { ranges: o } = a;
  return o.some(({ $from: s, $to: l }) => {
    let c = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(r) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (u, f, h) => {
      if (c)
        return !1;
      if (u.isInline) {
        const p = !h || h.type.allowsMarkType(r), g = !!r.isInSet(u.marks) || !u.marks.some((y) => y.type.excludes(r));
        c = p && g;
      }
      return !c;
    }), c;
  });
}
const Aan = (t, e = {}) => ({ tr: r, state: n, dispatch: a }) => {
  const { selection: i } = r, { empty: o, ranges: s } = i, l = a3(t, n.schema);
  if (a)
    if (o) {
      const c = Pmt(n, l);
      r.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      s.forEach((c) => {
        const u = c.$from.pos, f = c.$to.pos;
        n.doc.nodesBetween(u, f, (h, p) => {
          const g = Math.max(p, u), y = Math.min(p + h.nodeSize, f);
          h.marks.find((w) => w.type === l) ? h.marks.forEach((w) => {
            l === w.type && r.addMark(g, y, l.create({
              ...w.attrs,
              ...e
            }));
          }) : r.addMark(g, y, l.create(e));
        });
      });
  return kan(n, r, l);
}, Tan = (t, e) => ({ tr: r }) => (r.setMeta(t, e), !0), Ean = (t, e = {}) => ({ state: r, dispatch: n, chain: a }) => {
  const i = oc(t, r.schema);
  let o;
  return r.selection.$anchor.sameParent(r.selection.$head) && (o = r.selection.$anchor.parent.attrs), i.isTextblock ? a().command(({ commands: s }) => bje(i, { ...o, ...e })(r) ? !0 : s.clearNodes()).command(({ state: s }) => bje(i, { ...o, ...e })(s, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Ian = (t) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: n } = e, a = _b(t, 0, n.content.size), i = ea.create(n, a);
    e.setSelection(i);
  }
  return !0;
}, Man = (t) => ({ tr: e, dispatch: r }) => {
  if (r) {
    const { doc: n } = e, { from: a, to: i } = typeof t == "number" ? { from: t, to: t } : t, o = qa.atStart(n).from, s = qa.atEnd(n).to, l = _b(a, o, s), c = _b(i, o, s), u = qa.create(n, l, c);
    e.setSelection(u);
  }
  return !0;
}, Pan = (t) => ({ state: e, dispatch: r }) => {
  const n = oc(t, e.schema);
  return dnn(n)(e, r);
};
function Aje(t, e) {
  const r = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (r) {
    const n = r.filter((a) => e == null ? void 0 : e.includes(a.type.name));
    t.tr.ensureMarks(n);
  }
}
const Ran = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: r, dispatch: n, editor: a }) => {
  const { selection: i, doc: o } = e, { $from: s, $to: l } = i, c = a.extensionManager.attributes, u = N$(c, s.node().type.name, s.node().attrs);
  if (i instanceof ea && i.node.isBlock)
    return !s.parentOffset || !Rm(o, s.pos) ? !1 : (n && (t && Aje(r, a.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, h = s.depth === 0 ? void 0 : yan(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let p = f && h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0, g = Rm(e.doc, e.mapping.map(s.pos), 1, p);
  if (!p && !g && Rm(e.doc, e.mapping.map(s.pos), 1, h ? [{ type: h }] : void 0) && (g = !0, p = h ? [
    {
      type: h,
      attrs: u
    }
  ] : void 0), n) {
    if (g && (i instanceof qa && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, p), h && !f && !s.parentOffset && s.parent.type !== h)) {
      const y = e.mapping.map(s.before()), b = e.doc.resolve(y);
      s.node(-1).canReplaceWith(b.index(), b.index() + 1, h) && e.setNodeMarkup(e.mapping.map(s.before()), h);
    }
    t && Aje(r, a.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return g;
}, Oan = (t, e = {}) => ({ tr: r, state: n, dispatch: a, editor: i }) => {
  var o;
  const s = oc(t, n.schema), { $from: l, $to: c } = n.selection, u = n.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const f = l.node(-1);
  if (f.type !== s)
    return !1;
  const h = i.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (a) {
      let w = Mr.empty;
      const _ = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - _; M >= l.depth - 3; M -= 1)
        w = Mr.from(l.node(M).copy(w));
      const C = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, x = {
        ...N$(h, l.node().type.name, l.node().attrs),
        ...e
      }, S = ((o = s.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(x)) || void 0;
      w = w.append(Mr.from(s.createAndFill(null, S) || void 0));
      const A = l.before(l.depth - (_ - 1));
      r.replace(A, l.after(-C), new hn(w, 4 - _, 0));
      let I = -1;
      r.doc.nodesBetween(A, r.doc.content.size, (M, B) => {
        if (I > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (I = B + 1);
      }), I > -1 && r.setSelection(qa.near(r.doc.resolve(I))), r.scrollIntoView();
    }
    return !0;
  }
  const p = c.pos === l.end() ? f.contentMatchAt(0).defaultType : null, g = {
    ...N$(h, f.type.name, f.attrs),
    ...e
  }, y = {
    ...N$(h, l.node().type.name, l.node().attrs),
    ...e
  };
  r.delete(l.pos, c.pos);
  const b = p ? [
    { type: s, attrs: g },
    { type: p, attrs: y }
  ] : [{ type: s, attrs: g }];
  if (!Rm(r.doc, l.pos, 2))
    return !1;
  if (a) {
    const { selection: w, storedMarks: _ } = n, { splittableMarks: C } = i.extensionManager, x = _ || w.$to.parentOffset && w.$from.marks();
    if (r.split(l.pos, 2, b).scrollIntoView(), !x || !a)
      return !0;
    const S = x.filter((A) => C.includes(A.type.name));
    r.ensureMarks(S);
  }
  return !0;
}, qie = (t, e) => {
  const r = mbe((o) => o.type === e)(t.selection);
  if (!r)
    return !0;
  const n = t.doc.resolve(Math.max(0, r.pos - 1)).before(r.depth);
  if (n === void 0)
    return !0;
  const a = t.doc.nodeAt(n);
  return r.node.type === (a == null ? void 0 : a.type) && r3(t.doc, r.pos) && t.join(r.pos), !0;
}, Kie = (t, e) => {
  const r = mbe((o) => o.type === e)(t.selection);
  if (!r)
    return !0;
  const n = t.doc.resolve(r.start).after(r.depth);
  if (n === void 0)
    return !0;
  const a = t.doc.nodeAt(n);
  return r.node.type === (a == null ? void 0 : a.type) && r3(t.doc, n) && t.join(n), !0;
}, Ban = (t, e, r, n = {}) => ({ editor: a, tr: i, state: o, dispatch: s, chain: l, commands: c, can: u }) => {
  const { extensions: f, splittableMarks: h } = a.extensionManager, p = oc(t, o.schema), g = oc(e, o.schema), { selection: y, storedMarks: b } = o, { $from: w, $to: _ } = y, C = w.blockRange(_), x = b || y.$to.parentOffset && y.$from.marks();
  if (!C)
    return !1;
  const S = mbe((A) => kje(A.type.name, f))(y);
  if (C.depth >= 1 && S && C.depth - S.depth <= 1) {
    if (S.node.type === p)
      return c.liftListItem(g);
    if (kje(S.node.type.name, f) && p.validContent(S.node.content) && s)
      return l().command(() => (i.setNodeMarkup(S.pos, p), !0)).command(() => qie(i, p)).command(() => Kie(i, p)).run();
  }
  return !r || !x || !s ? l().command(() => u().wrapInList(p, n) ? !0 : c.clearNodes()).wrapInList(p, n).command(() => qie(i, p)).command(() => Kie(i, p)).run() : l().command(() => {
    const A = u().wrapInList(p, n), I = x.filter((M) => h.includes(M.type.name));
    return i.ensureMarks(I), A ? !0 : c.clearNodes();
  }).wrapInList(p, n).command(() => qie(i, p)).command(() => Kie(i, p)).run();
}, Nan = (t, e = {}, r = {}) => ({ state: n, commands: a }) => {
  const { extendEmptyMarkRange: i = !1 } = r, o = a3(t, n.schema);
  return Nfe(n, o, e) ? a.unsetMark(o, { extendEmptyMarkRange: i }) : a.setMark(o, e);
}, $an = (t, e, r = {}) => ({ state: n, commands: a }) => {
  const i = oc(t, n.schema), o = oc(e, n.schema), s = mI(n, i, r);
  let l;
  return n.selection.$anchor.sameParent(n.selection.$head) && (l = n.selection.$anchor.parent.attrs), s ? a.setNode(o, l) : a.setNode(i, { ...l, ...r });
}, Dan = (t, e = {}) => ({ state: r, commands: n }) => {
  const a = oc(t, r.schema);
  return mI(r, a, e) ? n.lift(a) : n.wrapIn(a, e);
}, Lan = () => ({ state: t, dispatch: e }) => {
  const r = t.plugins;
  for (let n = 0; n < r.length; n += 1) {
    const a = r[n];
    let i;
    if (a.spec.isInputRules && (i = a.getState(t))) {
      if (e) {
        const o = t.tr, s = i.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          o.step(s.steps[l].invert(s.docs[l]));
        if (i.text) {
          const l = o.doc.resolve(i.from).marks();
          o.replaceWith(i.from, i.to, t.schema.text(i.text, l));
        } else
          o.delete(i.from, i.to);
      }
      return !0;
    }
  }
  return !1;
}, jan = () => ({ tr: t, dispatch: e }) => {
  const { selection: r } = t, { empty: n, ranges: a } = r;
  return n || e && a.forEach((i) => {
    t.removeMark(i.$from.pos, i.$to.pos);
  }), !0;
}, Fan = (t, e = {}) => ({ tr: r, state: n, dispatch: a }) => {
  var i;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: s } = r, l = a3(t, n.schema), { $from: c, empty: u, ranges: f } = s;
  if (!a)
    return !0;
  if (u && o) {
    let { from: h, to: p } = s;
    const g = (i = c.marks().find((b) => b.type === l)) === null || i === void 0 ? void 0 : i.attrs, y = hbe(c, l, g);
    y && (h = y.from, p = y.to), r.removeMark(h, p, l);
  } else
    f.forEach((h) => {
      r.removeMark(h.$from.pos, h.$to.pos, l);
    });
  return r.removeStoredMark(l), !0;
}, zan = (t, e = {}) => ({ tr: r, state: n, dispatch: a }) => {
  let i = null, o = null;
  const s = GH(typeof t == "string" ? t : t.name, n.schema);
  return s ? (s === "node" && (i = oc(t, n.schema)), s === "mark" && (o = a3(t, n.schema)), a && r.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let f, h, p, g;
    r.selection.empty ? n.doc.nodesBetween(c, u, (y, b) => {
      i && i === y.type && (p = Math.max(b, c), g = Math.min(b + y.nodeSize, u), f = b, h = y);
    }) : n.doc.nodesBetween(c, u, (y, b) => {
      b < c && i && i === y.type && (p = Math.max(b, c), g = Math.min(b + y.nodeSize, u), f = b, h = y), b >= c && b <= u && (i && i === y.type && r.setNodeMarkup(b, void 0, {
        ...y.attrs,
        ...e
      }), o && y.marks.length && y.marks.forEach((w) => {
        if (o === w.type) {
          const _ = Math.max(b, c), C = Math.min(b + y.nodeSize, u);
          r.addMark(_, C, o.create({
            ...w.attrs,
            ...e
          }));
        }
      }));
    }), h && (f !== void 0 && r.setNodeMarkup(f, void 0, {
      ...h.attrs,
      ...e
    }), o && h.marks.length && h.marks.forEach((y) => {
      o === y.type && r.addMark(p, g, o.create({
        ...y.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, Gan = (t, e = {}) => ({ state: r, dispatch: n }) => {
  const a = oc(t, r.schema);
  return ann(a, e)(r, n);
}, Wan = (t, e = {}) => ({ state: r, dispatch: n }) => {
  const a = oc(t, r.schema);
  return inn(a, e)(r, n);
};
var Han = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: Enn,
  clearContent: Inn,
  clearNodes: Mnn,
  command: Pnn,
  createParagraphNear: Rnn,
  cut: Onn,
  deleteCurrentNode: Bnn,
  deleteNode: Nnn,
  deleteRange: $nn,
  deleteSelection: Dnn,
  enter: Lnn,
  exitCode: jnn,
  extendMarkRange: Fnn,
  first: znn,
  focus: Wnn,
  forEach: Hnn,
  insertContent: Unn,
  insertContentAt: Knn,
  joinBackward: Ynn,
  joinDown: Jnn,
  joinForward: Xnn,
  joinItemBackward: Qnn,
  joinItemForward: ean,
  joinTextblockBackward: tan,
  joinTextblockForward: ran,
  joinUp: Znn,
  keyboardShortcut: aan,
  lift: ian,
  liftEmptyBlock: oan,
  liftListItem: san,
  newlineInCode: lan,
  resetAttributes: can,
  scrollIntoView: uan,
  selectAll: dan,
  selectNodeBackward: fan,
  selectNodeForward: han,
  selectParentNode: pan,
  selectTextblockEnd: man,
  selectTextblockStart: gan,
  setContent: van,
  setMark: Aan,
  setMeta: Tan,
  setNode: Ean,
  setNodeSelection: Ian,
  setTextSelection: Man,
  sinkListItem: Pan,
  splitBlock: Ran,
  splitListItem: Oan,
  toggleList: Ban,
  toggleMark: Nan,
  toggleNode: $an,
  toggleWrap: Dan,
  undoInputRule: Lan,
  unsetAllMarks: jan,
  unsetMark: Fan,
  updateAttributes: zan,
  wrapIn: Gan,
  wrapInList: Wan
});
const Uan = Fu.create({
  name: "commands",
  addCommands() {
    return {
      ...Han
    };
  }
}), Van = Fu.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Bd({
        key: new lp("tiptapDrop"),
        props: {
          handleDrop: (t, e, r, n) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: r,
              moved: n
            });
          }
        }
      })
    ];
  }
}), qan = Fu.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Bd({
        key: new lp("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Kan = Fu.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new Bd({
        key: new lp("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (e, r) => {
              t.isFocused = !0;
              const n = t.state.tr.setMeta("focus", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            },
            blur: (e, r) => {
              t.isFocused = !1;
              const n = t.state.tr.setMeta("blur", { event: r }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
}), Zan = Fu.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: s }) => {
        const { selection: l, doc: c } = s, { empty: u, $anchor: f } = l, { pos: h, parent: p } = f, g = f.parent.isTextblock && h > 0 ? s.doc.resolve(h - 1) : f, y = g.parent.type.spec.isolating, b = f.pos - f.parentOffset, w = y && g.parent.childCount === 1 ? b === f.pos : Ci.atStart(c).from === h;
        return !u || !p.type.isTextblock || p.textContent.length || !w || w && f.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, a = {
      ...n
    }, i = {
      ...n,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return pbe() || Mmt() ? i : a;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Bd({
        key: new lp("clearDocument"),
        appendTransaction: (t, e, r) => {
          if (t.some((y) => y.getMeta("composition")))
            return;
          const n = t.some((y) => y.docChanged) && !e.doc.eq(r.doc), a = t.some((y) => y.getMeta("preventClearDocument"));
          if (!n || a)
            return;
          const { empty: i, from: o, to: s } = e.selection, l = Ci.atStart(e.doc).from, c = Ci.atEnd(e.doc).to;
          if (i || !(o === l && s === c) || !gbe(r.doc))
            return;
          const h = r.tr, p = DH({
            state: r,
            transaction: h
          }), { commands: g } = new LH({
            editor: this.editor,
            state: p
          });
          if (g.clearNodes(), !!h.steps.length)
            return h;
        }
      })
    ];
  }
}), Jan = Fu.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Bd({
        key: new lp("tiptapPaste"),
        props: {
          handlePaste: (t, e, r) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: r
            });
          }
        }
      })
    ];
  }
}), Yan = Fu.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Bd({
        key: new lp("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class lb {
  get name() {
    return this.node.type.name;
  }
  constructor(e, r, n = !1, a = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = n, this.resolvedPos = e, this.editor = r, this.currentNode = a;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let r = this.from, n = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      r = this.from + 1, n = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: r, to: n }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), r = this.resolvedPos.doc.resolve(e);
    return new lb(r, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new lb(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new lb(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((r, n) => {
      const a = r.isBlock && !r.isTextblock, i = r.isAtom && !r.isText, o = this.pos + n + (i ? 0 : 1), s = this.resolvedPos.doc.resolve(o);
      if (!a && s.depth <= this.depth)
        return;
      const l = new lb(s, this.editor, a, a ? r : null);
      a && (l.actualDepth = this.depth + 1), e.push(new lb(s, this.editor, a, a ? r : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, r = {}) {
    let n = null, a = this.parent;
    for (; a && !n; ) {
      if (a.node.type.name === e)
        if (Object.keys(r).length > 0) {
          const i = a.node.attrs, o = Object.keys(r);
          for (let s = 0; s < o.length; s += 1) {
            const l = o[s];
            if (i[l] !== r[l])
              break;
          }
        } else
          n = a;
      a = a.parent;
    }
    return n;
  }
  querySelector(e, r = {}) {
    return this.querySelectorAll(e, r, !0)[0] || null;
  }
  querySelectorAll(e, r = {}, n = !1) {
    let a = [];
    if (!this.children || this.children.length === 0)
      return a;
    const i = Object.keys(r);
    return this.children.forEach((o) => {
      n && a.length > 0 || (o.node.type.name === e && i.every((l) => r[l] === o.node.attrs[l]) && a.push(o), !(n && a.length > 0) && (a = a.concat(o.querySelectorAll(e, r, n))));
    }), a;
  }
  setAttribute(e) {
    const { tr: r } = this.editor.state;
    r.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(r);
  }
}
const Xan = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function Qan(t, e, r) {
  const n = document.querySelector("style[data-tiptap-style]");
  if (n !== null)
    return n;
  const a = document.createElement("style");
  return e && a.setAttribute("nonce", e), a.setAttribute("data-tiptap-style", ""), a.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(a), a;
}
class ein extends fnn {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: r }) => {
        throw r;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: r, slice: n, moved: a }) => this.options.onDrop(r, n, a)), this.on("paste", ({ event: r, slice: n }) => this.options.onPaste(r, n)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = Qan(Xan, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, r = !0) {
    this.setOptions({ editable: e }), r && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, r) {
    const n = Smt(r) ? r(e, [...this.state.plugins]) : [...this.state.plugins, e], a = this.state.reconfigure({ plugins: n });
    return this.view.updateState(a), a;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const r = this.state.plugins;
    let n = r;
    if ([].concat(e).forEach((i) => {
      const o = typeof i == "string" ? `${i}$` : i.key;
      n = r.filter((s) => !s.key.startsWith(o));
    }), r.length === n.length)
      return;
    const a = this.state.reconfigure({
      plugins: n
    });
    return this.view.updateState(a), a;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, r;
    const a = [...this.options.enableCoreExtensions ? [
      qan,
      Tnn.configure({
        blockSeparator: (r = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || r === void 0 ? void 0 : r.blockSeparator
      }),
      Uan,
      Kan,
      Zan,
      Yan,
      Van,
      Jan
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i == null ? void 0 : i.type));
    this.extensionManager = new t7(a, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new LH({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let r;
    try {
      r = Bfe(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((s) => s.name !== "collaboration"), this.createExtensionManager();
        }
      }), r = Bfe(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const n = Emt(r, this.options.autofocus);
    this.view = new $rn(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: e7.create({
        doc: r,
        selection: n || void 0
      })
    });
    const a = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(a), this.createNodeViews(), this.prependClass();
    const i = this.view.dom;
    i.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const r = this.capturedTransaction;
    return this.capturedTransaction = null, r;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(o);
      });
      return;
    }
    const r = this.state.apply(e), n = !this.state.selection.eq(r.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: r
    }), this.view.updateState(r), this.emit("transaction", {
      editor: this,
      transaction: e
    }), n && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const a = e.getMeta("focus"), i = e.getMeta("blur");
    a && this.emit("focus", {
      editor: this,
      event: a.event,
      transaction: e
    }), i && this.emit("blur", {
      editor: this,
      event: i.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return wan(this.state, e);
  }
  isActive(e, r) {
    const n = typeof e == "string" ? e : null, a = typeof e == "string" ? r : e;
    return San(this.state, n, a);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return dbe(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: r = `

`, textSerializers: n = {} } = e || {};
    return xan(this.state.doc, {
      blockSeparator: r,
      textSerializers: {
        ...kmt(this.schema),
        ...n
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return gbe(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, r) {
    var n;
    return ((n = this.$doc) === null || n === void 0 ? void 0 : n.querySelector(e, r)) || null;
  }
  $nodes(e, r) {
    var n;
    return ((n = this.$doc) === null || n === void 0 ? void 0 : n.querySelectorAll(e, r)) || null;
  }
  $pos(e) {
    const r = this.state.doc.resolve(e);
    return new lb(r, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function o8(t) {
  return new FH({
    find: t.find,
    handler: ({ state: e, range: r, match: n }) => {
      const a = Ni(t.getAttributes, void 0, n);
      if (a === !1 || a === null)
        return null;
      const { tr: i } = e, o = n[n.length - 1], s = n[0];
      if (o) {
        const l = s.search(/\S/), c = r.from + s.indexOf(o), u = c + o.length;
        if (Rmt(r.from, r.to, e.doc).filter((p) => p.mark.type.excluded.find((y) => y === t.type && y !== p.mark.type)).filter((p) => p.to > c).length)
          return null;
        u < r.to && i.delete(u, r.to), c > r.from && i.delete(r.from + l, c);
        const h = r.from + l + o.length;
        i.addMark(r.from + l, h, t.type.create(a || {})), i.removeStoredMark(t.type);
      }
    }
  });
}
function tin(t) {
  return new FH({
    find: t.find,
    handler: ({ state: e, range: r, match: n }) => {
      const a = Ni(t.getAttributes, void 0, n) || {}, { tr: i } = e, o = r.from;
      let s = r.to;
      const l = t.type.create(a);
      if (n[1]) {
        const c = n[0].lastIndexOf(n[1]);
        let u = o + c;
        u > s ? u = s : s = u + n[1].length;
        const f = n[0][n[0].length - 1];
        i.insertText(f, o + n[0].length - 1), i.replaceWith(u, s, l);
      } else if (n[0]) {
        const c = t.type.isInline ? o : o - 1;
        i.insert(c, t.type.create(a)).delete(i.mapping.map(o), i.mapping.map(s));
      }
      i.scrollIntoView();
    }
  });
}
function $fe(t) {
  return new FH({
    find: t.find,
    handler: ({ state: e, range: r, match: n }) => {
      const a = e.doc.resolve(r.from), i = Ni(t.getAttributes, void 0, n) || {};
      if (!a.node(-1).canReplaceWith(a.index(-1), a.indexAfter(-1), t.type))
        return null;
      e.tr.delete(r.from, r.to).setBlockType(r.from, r.from, t.type, i);
    }
  });
}
function gI(t) {
  return new FH({
    find: t.find,
    handler: ({ state: e, range: r, match: n, chain: a }) => {
      const i = Ni(t.getAttributes, void 0, n) || {}, o = e.tr.delete(r.from, r.to), l = o.doc.resolve(r.from).blockRange(), c = l && Z3e(l, t.type, i);
      if (!c)
        return null;
      if (o.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: f, storedMarks: h } = e, { splittableMarks: p } = t.editor.extensionManager, g = h || f.$to.parentOffset && f.$from.marks();
        if (g) {
          const y = g.filter((b) => p.includes(b.type.name));
          o.ensureMarks(y);
        }
      }
      if (t.keepAttributes) {
        const f = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        a().updateAttributes(f, i).run();
      }
      const u = o.doc.resolve(r.from - 1).nodeBefore;
      u && u.type === t.type && r3(o.doc, r.from - 1) && (!t.joinPredicate || t.joinPredicate(n, u)) && o.join(r.from - 1);
    }
  });
}
let m2 = class Dfe {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Ni(In(this, "addOptions", {
      name: this.name
    }))), this.storage = Ni(In(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Dfe(e);
  }
  configure(e = {}) {
    const r = this.extend({
      ...this.config,
      addOptions: () => zH(this.options, e)
    });
    return r.name = this.name, r.parent = this.parent, r;
  }
  extend(e = {}) {
    const r = new Dfe(e);
    return r.parent = this, this.child = r, r.name = e.name ? e.name : r.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${r.name}".`), r.options = Ni(In(r, "addOptions", {
      name: r.name
    })), r.storage = Ni(In(r, "addStorage", {
      name: r.name,
      options: r.options
    })), r;
  }
};
function s8(t) {
  return new Cnn({
    find: t.find,
    handler: ({ state: e, range: r, match: n, pasteEvent: a }) => {
      const i = Ni(t.getAttributes, void 0, n, a);
      if (i === !1 || i === null)
        return null;
      const { tr: o } = e, s = n[n.length - 1], l = n[0];
      let c = r.to;
      if (s) {
        const u = l.search(/\S/), f = r.from + l.indexOf(s), h = f + s.length;
        if (Rmt(r.from, r.to, e.doc).filter((g) => g.mark.type.excluded.find((b) => b === t.type && b !== g.mark.type)).filter((g) => g.to > f).length)
          return null;
        h < r.to && o.delete(h, r.to), f > r.from && o.delete(r.from + u, f), c = r.from + u + s.length, o.addMark(r.from + u, c, t.type.create(i || {})), o.removeStoredMark(t.type);
      }
    }
  });
}
function rin(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Lfe = { exports: {} }, Zie = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tje;
function nin() {
  if (Tje) return Zie;
  Tje = 1;
  var t = Te;
  function e(f, h) {
    return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, a = t.useEffect, i = t.useLayoutEffect, o = t.useDebugValue;
  function s(f, h) {
    var p = h(), g = n({ inst: { value: p, getSnapshot: h } }), y = g[0].inst, b = g[1];
    return i(function() {
      y.value = p, y.getSnapshot = h, l(y) && b({ inst: y });
    }, [f, p, h]), a(function() {
      return l(y) && b({ inst: y }), f(function() {
        l(y) && b({ inst: y });
      });
    }, [f]), o(p), p;
  }
  function l(f) {
    var h = f.getSnapshot;
    f = f.value;
    try {
      var p = h();
      return !r(f, p);
    } catch {
      return !0;
    }
  }
  function c(f, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return Zie.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, Zie;
}
var Jie = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Eje;
function ain() {
  return Eje || (Eje = 1, Ar.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Te, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(C) {
      {
        for (var x = arguments.length, S = new Array(x > 1 ? x - 1 : 0), A = 1; A < x; A++)
          S[A - 1] = arguments[A];
        n("error", C, S);
      }
    }
    function n(C, x, S) {
      {
        var A = e.ReactDebugCurrentFrame, I = A.getStackAddendum();
        I !== "" && (x += "%s", S = S.concat([I]));
        var M = S.map(function(B) {
          return String(B);
        });
        M.unshift("Warning: " + x), Function.prototype.apply.call(console[C], console, M);
      }
    }
    function a(C, x) {
      return C === x && (C !== 0 || 1 / C === 1 / x) || C !== C && x !== x;
    }
    var i = typeof Object.is == "function" ? Object.is : a, o = t.useState, s = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, f = !1;
    function h(C, x, S) {
      u || t.startTransition !== void 0 && (u = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var A = x();
      if (!f) {
        var I = x();
        i(A, I) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var M = o({
        inst: {
          value: A,
          getSnapshot: x
        }
      }), B = M[0].inst, L = M[1];
      return l(function() {
        B.value = A, B.getSnapshot = x, p(B) && L({
          inst: B
        });
      }, [C, A, x]), s(function() {
        p(B) && L({
          inst: B
        });
        var N = function() {
          p(B) && L({
            inst: B
          });
        };
        return C(N);
      }, [C]), c(A), A;
    }
    function p(C) {
      var x = C.getSnapshot, S = C.value;
      try {
        var A = x();
        return !i(S, A);
      } catch {
        return !0;
      }
    }
    function g(C, x, S) {
      return x();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", b = !y, w = b ? g : h, _ = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : w;
    Jie.useSyncExternalStore = _, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Jie;
}
Ar.env.NODE_ENV === "production" ? Lfe.exports = nin() : Lfe.exports = ain();
var WH = Lfe.exports;
const iin = (...t) => (e) => {
  t.forEach((r) => {
    typeof r == "function" ? r(e) : r && (r.current = e);
  });
}, oin = ({ contentComponent: t }) => {
  const e = WH.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getServerSnapshot);
  return Te.createElement(Te.Fragment, null, Object.values(e));
};
function sin() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(r) {
      return t.add(r), () => {
        t.delete(r);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(r, n) {
      e = {
        ...e,
        [r]: nWe.createPortal(n.reactElement, n.element, r)
      }, t.forEach((a) => a());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(r) {
      const n = { ...e };
      delete n[r], e = n, t.forEach((a) => a());
    }
  };
}
class lin extends Te.Component {
  constructor(e) {
    var r;
    super(e), this.editorContentRef = Te.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((r = e.editor) === null || r === void 0) && r.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const r = this.editorContentRef.current;
      r.append(...e.options.element.childNodes), e.setOptions({
        element: r
      }), e.contentComponent = sin(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((n) => n.hasContentComponentInitialized ? n : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const r = document.createElement("div");
    r.append(...e.options.element.childNodes), e.setOptions({
      element: r
    });
  }
  render() {
    const { editor: e, innerRef: r, ...n } = this.props;
    return Te.createElement(
      Te.Fragment,
      null,
      Te.createElement("div", { ref: iin(r, this.editorContentRef), ...n }),
      (e == null ? void 0 : e.contentComponent) && Te.createElement(oin, { contentComponent: e.contentComponent })
    );
  }
}
const cin = Ml((t, e) => {
  const r = Te.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
  return Te.createElement(lin, {
    key: r,
    innerRef: e,
    ...t
  });
}), uin = Te.memo(cin);
var din = function t(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var n, a, i;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length) return !1;
      for (a = n; a-- !== 0; )
        if (!t(e[a], r[a])) return !1;
      return !0;
    }
    if (e instanceof Map && r instanceof Map) {
      if (e.size !== r.size) return !1;
      for (a of e.entries())
        if (!r.has(a[0])) return !1;
      for (a of e.entries())
        if (!t(a[1], r.get(a[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && r instanceof Set) {
      if (e.size !== r.size) return !1;
      for (a of e.entries())
        if (!r.has(a[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (n = e.length, n != r.length) return !1;
      for (a = n; a-- !== 0; )
        if (e[a] !== r[a]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
    if (i = Object.keys(e), n = i.length, n !== Object.keys(r).length) return !1;
    for (a = n; a-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, i[a])) return !1;
    for (a = n; a-- !== 0; ) {
      var o = i[a];
      if (!(o === "_owner" && e.$$typeof) && !t(e[o], r[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}, fin = /* @__PURE__ */ rin(din), jfe = { exports: {} }, Yie = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ije;
function hin() {
  if (Ije) return Yie;
  Ije = 1;
  var t = Te, e = WH;
  function r(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var n = typeof Object.is == "function" ? Object.is : r, a = e.useSyncExternalStore, i = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return Yie.useSyncExternalStoreWithSelector = function(c, u, f, h, p) {
    var g = i(null);
    if (g.current === null) {
      var y = { hasValue: !1, value: null };
      g.current = y;
    } else y = g.current;
    g = s(function() {
      function w(A) {
        if (!_) {
          if (_ = !0, C = A, A = h(A), p !== void 0 && y.hasValue) {
            var I = y.value;
            if (p(I, A)) return x = I;
          }
          return x = A;
        }
        if (I = x, n(C, A)) return I;
        var M = h(A);
        return p !== void 0 && p(I, M) ? I : (C = A, x = M);
      }
      var _ = !1, C, x, S = f === void 0 ? null : f;
      return [function() {
        return w(u());
      }, S === null ? void 0 : function() {
        return w(S());
      }];
    }, [u, f, h, p]);
    var b = a(c, g[0], g[1]);
    return o(function() {
      y.hasValue = !0, y.value = b;
    }, [b]), l(b), b;
  }, Yie;
}
var Xie = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mje;
function pin() {
  return Mje || (Mje = 1, Ar.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = Te, e = WH;
    function r(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var n = typeof Object.is == "function" ? Object.is : r, a = e.useSyncExternalStore, i = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    function c(u, f, h, p, g) {
      var y = i(null), b;
      y.current === null ? (b = {
        hasValue: !1,
        value: null
      }, y.current = b) : b = y.current;
      var w = s(function() {
        var S = !1, A, I, M = function(d) {
          if (!S) {
            S = !0, A = d;
            var m = p(d);
            if (g !== void 0 && b.hasValue) {
              var v = b.value;
              if (g(v, m))
                return I = v, v;
            }
            return I = m, m;
          }
          var k = A, O = I;
          if (n(k, d))
            return O;
          var G = p(d);
          return g !== void 0 && g(O, G) ? O : (A = d, I = G, G);
        }, B = h === void 0 ? null : h, L = function() {
          return M(f());
        }, N = B === null ? void 0 : function() {
          return M(B());
        };
        return [L, N];
      }, [f, h, p, g]), _ = w[0], C = w[1], x = a(u, _, C);
      return o(function() {
        b.hasValue = !0, b.value = x;
      }, [x]), l(x), x;
    }
    Xie.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Xie;
}
Ar.env.NODE_ENV === "production" ? jfe.exports = hin() : jfe.exports = pin();
var min = jfe.exports;
const gin = typeof window < "u" ? qh : Ut;
class vin {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const r = () => {
        this.transactionNumber += 1, this.subscribers.forEach((a) => a());
      }, n = this.editor;
      return n.on("transaction", r), () => {
        n.off("transaction", r);
      };
    }
  }
}
function yin(t) {
  var e;
  const [r] = Yt(() => new vin(t.editor)), n = min.useSyncExternalStoreWithSelector(r.subscribe, r.getSnapshot, r.getServerSnapshot, t.selector, (e = t.equalityFn) !== null && e !== void 0 ? e : fin);
  return gin(() => r.watch(t.editor), [t.editor, r]), Mv(n), n;
}
const Pje = Ar.env.NODE_ENV !== "production", Ffe = typeof window > "u", bin = Ffe || !!(typeof window < "u" && window.next);
class vbe {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((r) => r());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return Ffe || bin ? (Pje && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && Ffe && Pje)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onBeforeCreate) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onBlur: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onBlur) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onCreate: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onCreate) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onDestroy: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onDestroy) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onFocus: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onFocus) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onSelectionUpdate: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onSelectionUpdate) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onTransaction: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onTransaction) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onUpdate: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onUpdate) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onContentError: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onContentError) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onDrop: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onDrop) === null || i === void 0 ? void 0 : i.call(a, ...n);
      },
      onPaste: (...n) => {
        var a, i;
        return (i = (a = this.options.current).onPaste) === null || i === void 0 ? void 0 : i.call(a, ...n);
      }
    };
    return new ein(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, r) {
    return Object.keys(e).every((n) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(n) ? !0 : n === "extensions" && e.extensions && r.extensions ? e.extensions.length !== r.extensions.length ? !1 : e.extensions.every((a, i) => {
      var o;
      return a === ((o = r.extensions) === null || o === void 0 ? void 0 : o[i]);
    }) : e[n] === r[n]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? vbe.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((n, a) => n === e[a]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, r = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        r && r.setOptions(this.options.current);
        return;
      }
      r && !r.isDestroyed && (r.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function xin(t = {}, e = []) {
  const r = Zt(t);
  r.current = t;
  const [n] = Yt(() => new vbe(r)), a = WH.useSyncExternalStore(n.subscribe, n.getEditor, n.getServerSnapshot);
  return Mv(a), Ut(n.onRender(e)), yin({
    editor: a,
    selector: ({ transactionNumber: i }) => t.shouldRerenderOnTransaction === !1 ? null : t.immediatelyRender && i === 0 ? 0 : i + 1
  }), a;
}
const Cin = Bo({
  editor: null
});
Cin.Consumer;
const win = Bo({
  onDragStart: void 0
}), Sin = () => Qn(win);
Te.forwardRef((t, e) => {
  const { onDragStart: r } = Sin(), n = t.as || "div";
  return (
    // @ts-ignore
    Te.createElement(n, { ...t, ref: e, "data-node-view-wrapper": "", onDragStart: r, style: {
      whiteSpace: "normal",
      ...t.style
    } })
  );
});
const _in = /^\s*>\s$/, kin = m2.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      gI({
        find: _in,
        type: this.type
      })
    ];
  }
}), Ain = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, Tin = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, Ein = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, Iin = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, Min = ky.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      o8({
        find: Ain,
        type: this.type
      }),
      o8({
        find: Ein,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      s8({
        find: Tin,
        type: this.type
      }),
      s8({
        find: Iin,
        type: this.type
      })
    ];
  }
}), Pin = "listItem", Rje = "textStyle", Oje = /^\s*([-+*])\s$/, Rin = m2.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Pin, this.editor.getAttributes(Rje)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = gI({
      find: Oje,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = gI({
      find: Oje,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(Rje),
      editor: this.editor
    })), [
      t
    ];
  }
}), Oin = /(^|[^`])`([^`]+)`(?!`)/, Bin = /(^|[^`])`([^`]+)`(?!`)/g, Nin = ky.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      o8({
        find: Oin,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      s8({
        find: Bin,
        type: this.type
      })
    ];
  }
}), $in = /^```([a-z]+)?[\s\n]$/, Din = /^~~~([a-z]+)?[\s\n]$/, Lin = m2.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: r } = this.options, i = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(r)).map((o) => o.replace(r, ""))[0];
          return i || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      ju(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, r = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : r || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: r } = e, { $from: n, empty: a } = r;
        if (!a || n.parent.type !== this.type)
          return !1;
        const i = n.parentOffset === n.parent.nodeSize - 2, o = n.parent.textContent.endsWith(`

`);
        return !i || !o ? !1 : t.chain().command(({ tr: s }) => (s.delete(n.pos - 2, n.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: r, doc: n } = e, { $from: a, empty: i } = r;
        if (!i || a.parent.type !== this.type || !(a.parentOffset === a.parent.nodeSize - 2))
          return !1;
        const s = a.after();
        return s === void 0 ? !1 : n.nodeAt(s) ? t.commands.command(({ tr: c }) => (c.setSelection(Ci.near(n.resolve(s))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      $fe({
        find: $in,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      $fe({
        find: Din,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Bd({
        key: new lp("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const r = e.clipboardData.getData("text/plain"), n = e.clipboardData.getData("vscode-editor-data"), a = n ? JSON.parse(n) : void 0, i = a == null ? void 0 : a.mode;
            if (!r || !i)
              return !1;
            const { tr: o, schema: s } = t.state, l = s.text(r.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: i }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(qa.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), t.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), jin = m2.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function Fin(t = {}) {
  return new Bd({
    view(e) {
      return new zin(e, t);
    }
  });
}
class zin {
  constructor(e, r) {
    var n;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (n = r.width) !== null && n !== void 0 ? n : 1, this.color = r.color === !1 ? void 0 : r.color || "black", this.class = r.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((a) => {
      let i = (o) => {
        this[a](o);
      };
      return e.dom.addEventListener(a, i), { name: a, handler: i };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: r }) => this.editorView.dom.removeEventListener(e, r));
  }
  update(e, r) {
    this.cursorPos != null && r.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), r = !e.parent.inlineContent, n;
    if (r) {
      let s = e.nodeBefore, l = e.nodeAfter;
      if (s || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), f = s ? u.bottom : u.top;
          s && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), n = { left: u.left, right: u.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!n) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      n = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let a = this.editorView.dom.offsetParent;
    this.element || (this.element = a.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", r), this.element.classList.toggle("prosemirror-dropcursor-inline", !r);
    let i, o;
    if (!a || a == document.body && getComputedStyle(a).position == "static")
      i = -pageXOffset, o = -pageYOffset;
    else {
      let s = a.getBoundingClientRect();
      i = s.left - a.scrollLeft, o = s.top - a.scrollTop;
    }
    this.element.style.left = n.left - i + "px", this.element.style.top = n.top - o + "px", this.element.style.width = n.right - n.left + "px", this.element.style.height = n.bottom - n.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let r = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), n = r && r.inside >= 0 && this.editorView.state.doc.nodeAt(r.inside), a = n && n.type.spec.disableDropCursor, i = typeof a == "function" ? a(this.editorView, r, e) : a;
    if (r && !i) {
      let o = r.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = Spt(this.editorView.state.doc, o, this.editorView.dragging.slice);
        s != null && (o = s);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const Gin = Fu.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      Fin(this.options)
    ];
  }
});
class qs extends Ci {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, r) {
    let n = e.resolve(r.map(this.head));
    return qs.valid(n) ? new qs(n) : Ci.near(n);
  }
  content() {
    return hn.empty;
  }
  eq(e) {
    return e instanceof qs && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, r) {
    if (typeof r.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new qs(e.resolve(r.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new ybe(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let r = e.parent;
    if (r.isTextblock || !Win(e) || !Hin(e))
      return !1;
    let n = r.type.spec.allowGapCursor;
    if (n != null)
      return n;
    let a = r.contentMatchAt(e.index()).defaultType;
    return a && a.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, r, n = !1) {
    e: for (; ; ) {
      if (!n && qs.valid(e))
        return e;
      let a = e.pos, i = null;
      for (let o = e.depth; ; o--) {
        let s = e.node(o);
        if (r > 0 ? e.indexAfter(o) < s.childCount : e.index(o) > 0) {
          i = s.child(r > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        a += r;
        let l = e.doc.resolve(a);
        if (qs.valid(l))
          return l;
      }
      for (; ; ) {
        let o = r > 0 ? i.firstChild : i.lastChild;
        if (!o) {
          if (i.isAtom && !i.isText && !ea.isSelectable(i)) {
            e = e.doc.resolve(a + i.nodeSize * r), n = !1;
            continue e;
          }
          break;
        }
        i = o, a += r;
        let s = e.doc.resolve(a);
        if (qs.valid(s))
          return s;
      }
      return null;
    }
  }
}
qs.prototype.visible = !1;
qs.findFrom = qs.findGapCursorFrom;
Ci.jsonID("gapcursor", qs);
class ybe {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new ybe(e.map(this.pos));
  }
  resolve(e) {
    let r = e.resolve(this.pos);
    return qs.valid(r) ? new qs(r) : Ci.near(r);
  }
}
function Win(t) {
  for (let e = t.depth; e >= 0; e--) {
    let r = t.index(e), n = t.node(e);
    if (r == 0) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let a = n.child(r - 1); ; a = a.lastChild) {
      if (a.childCount == 0 && !a.inlineContent || a.isAtom || a.type.spec.isolating)
        return !0;
      if (a.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Hin(t) {
  for (let e = t.depth; e >= 0; e--) {
    let r = t.indexAfter(e), n = t.node(e);
    if (r == n.childCount) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let a = n.child(r); ; a = a.firstChild) {
      if (a.childCount == 0 && !a.inlineContent || a.isAtom || a.type.spec.isolating)
        return !0;
      if (a.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Uin() {
  return new Bd({
    props: {
      decorations: Zin,
      createSelectionBetween(t, e, r) {
        return e.pos == r.pos && qs.valid(r) ? new qs(r) : null;
      },
      handleClick: qin,
      handleKeyDown: Vin,
      handleDOMEvents: { beforeinput: Kin }
    }
  });
}
const Vin = cmt({
  ArrowLeft: wN("horiz", -1),
  ArrowRight: wN("horiz", 1),
  ArrowUp: wN("vert", -1),
  ArrowDown: wN("vert", 1)
});
function wN(t, e) {
  const r = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(n, a, i) {
    let o = n.selection, s = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof qa) {
      if (!i.endOfTextblock(r) || s.depth == 0)
        return !1;
      l = !1, s = n.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let c = qs.findGapCursorFrom(s, e, l);
    return c ? (a && a(n.tr.setSelection(new qs(c))), !0) : !1;
  };
}
function qin(t, e, r) {
  if (!t || !t.editable)
    return !1;
  let n = t.state.doc.resolve(e);
  if (!qs.valid(n))
    return !1;
  let a = t.posAtCoords({ left: r.clientX, top: r.clientY });
  return a && a.inside > -1 && ea.isSelectable(t.state.doc.nodeAt(a.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new qs(n))), !0);
}
function Kin(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof qs))
    return !1;
  let { $from: r } = t.state.selection, n = r.parent.contentMatchAt(r.index()).findWrapping(t.state.schema.nodes.text);
  if (!n)
    return !1;
  let a = Mr.empty;
  for (let o = n.length - 1; o >= 0; o--)
    a = Mr.from(n[o].createAndFill(null, a));
  let i = t.state.tr.replace(r.pos, r.pos, new hn(a, 0, 0));
  return i.setSelection(qa.near(i.doc.resolve(r.pos + 1))), t.dispatch(i), !1;
}
function Zin(t) {
  if (!(t.selection instanceof qs))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", zl.create(t.doc, [Q0.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const Jin = Fu.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      Uin()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const r = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Ni(In(t, "allowGapCursor", r))) !== null && e !== void 0 ? e : null
    };
  }
}), Yin = m2.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", ju(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: r, editor: n }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: a, storedMarks: i } = r;
          if (a.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: s } = n.extensionManager, l = i || a.$to.parentOffset && a.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && o) {
              const f = l.filter((h) => s.includes(h.type.name));
              c.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), Xin = m2.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, ju(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => $fe({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var zF = 200, ic = function() {
};
ic.prototype.append = function(e) {
  return e.length ? (e = ic.from(e), !this.length && e || e.length < zF && this.leafAppend(e) || this.length < zF && e.leafPrepend(this) || this.appendInner(e)) : this;
};
ic.prototype.prepend = function(e) {
  return e.length ? ic.from(e).append(this) : this;
};
ic.prototype.appendInner = function(e) {
  return new Qin(this, e);
};
ic.prototype.slice = function(e, r) {
  return e === void 0 && (e = 0), r === void 0 && (r = this.length), e >= r ? ic.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, r));
};
ic.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
ic.prototype.forEach = function(e, r, n) {
  r === void 0 && (r = 0), n === void 0 && (n = this.length), r <= n ? this.forEachInner(e, r, n, 0) : this.forEachInvertedInner(e, r, n, 0);
};
ic.prototype.map = function(e, r, n) {
  r === void 0 && (r = 0), n === void 0 && (n = this.length);
  var a = [];
  return this.forEach(function(i, o) {
    return a.push(e(i, o));
  }, r, n), a;
};
ic.from = function(e) {
  return e instanceof ic ? e : e && e.length ? new Omt(e) : ic.empty;
};
var Omt = /* @__PURE__ */ function(t) {
  function e(n) {
    t.call(this), this.values = n;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var r = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(a, i) {
    return a == 0 && i == this.length ? this : new e(this.values.slice(a, i));
  }, e.prototype.getInner = function(a) {
    return this.values[a];
  }, e.prototype.forEachInner = function(a, i, o, s) {
    for (var l = i; l < o; l++)
      if (a(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(a, i, o, s) {
    for (var l = i - 1; l >= o; l--)
      if (a(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(a) {
    if (this.length + a.length <= zF)
      return new e(this.values.concat(a.flatten()));
  }, e.prototype.leafPrepend = function(a) {
    if (this.length + a.length <= zF)
      return new e(a.flatten().concat(this.values));
  }, r.length.get = function() {
    return this.values.length;
  }, r.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, r), e;
}(ic);
ic.empty = new Omt([]);
var Qin = /* @__PURE__ */ function(t) {
  function e(r, n) {
    t.call(this), this.left = r, this.right = n, this.length = r.length + n.length, this.depth = Math.max(r.depth, n.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(n) {
    return n < this.left.length ? this.left.get(n) : this.right.get(n - this.left.length);
  }, e.prototype.forEachInner = function(n, a, i, o) {
    var s = this.left.length;
    if (a < s && this.left.forEachInner(n, a, Math.min(i, s), o) === !1 || i > s && this.right.forEachInner(n, Math.max(a - s, 0), Math.min(this.length, i) - s, o + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(n, a, i, o) {
    var s = this.left.length;
    if (a > s && this.right.forEachInvertedInner(n, a - s, Math.max(i, s) - s, o + s) === !1 || i < s && this.left.forEachInvertedInner(n, Math.min(a, s), i, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(n, a) {
    if (n == 0 && a == this.length)
      return this;
    var i = this.left.length;
    return a <= i ? this.left.slice(n, a) : n >= i ? this.right.slice(n - i, a - i) : this.left.slice(n, i).append(this.right.slice(0, a - i));
  }, e.prototype.leafAppend = function(n) {
    var a = this.right.leafAppend(n);
    if (a)
      return new e(this.left, a);
  }, e.prototype.leafPrepend = function(n) {
    var a = this.left.leafPrepend(n);
    if (a)
      return new e(a, this.right);
  }, e.prototype.appendInner = function(n) {
    return this.left.depth >= Math.max(this.right.depth, n.depth) + 1 ? new e(this.left, new e(this.right, n)) : new e(this, n);
  }, e;
}(ic);
const eon = 500;
class v1 {
  constructor(e, r) {
    this.items = e, this.eventCount = r;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, r) {
    if (this.eventCount == 0)
      return null;
    let n = this.items.length;
    for (; ; n--)
      if (this.items.get(n - 1).selection) {
        --n;
        break;
      }
    let a, i;
    r && (a = this.remapping(n, this.items.length), i = a.maps.length);
    let o = e.tr, s, l, c = [], u = [];
    return this.items.forEach((f, h) => {
      if (!f.step) {
        a || (a = this.remapping(n, h + 1), i = a.maps.length), i--, u.push(f);
        return;
      }
      if (a) {
        u.push(new z2(f.map));
        let p = f.step.map(a.slice(i)), g;
        p && o.maybeStep(p).doc && (g = o.mapping.maps[o.mapping.maps.length - 1], c.push(new z2(g, void 0, void 0, c.length + u.length))), i--, g && a.appendMap(g, i);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return s = a ? f.selection.map(a.slice(i)) : f.selection, l = new v1(this.items.slice(0, n).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, r, n, a) {
    let i = [], o = this.eventCount, s = this.items, l = !a && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let f = e.steps[u].invert(e.docs[u]), h = new z2(e.mapping.maps[u], f, r), p;
      (p = l && l.merge(h)) && (h = p, u ? i.pop() : s = s.slice(0, s.length - 1)), i.push(h), r && (o++, r = void 0), a || (l = h);
    }
    let c = o - n.depth;
    return c > ron && (s = ton(s, c), o -= c), new v1(s.append(i), o);
  }
  remapping(e, r) {
    let n = new uI();
    return this.items.forEach((a, i) => {
      let o = a.mirrorOffset != null && i - a.mirrorOffset >= e ? n.maps.length - a.mirrorOffset : void 0;
      n.appendMap(a.map, o);
    }, e, r), n;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new v1(this.items.append(e.map((r) => new z2(r))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, r) {
    if (!this.eventCount)
      return this;
    let n = [], a = Math.max(0, this.items.length - r), i = e.mapping, o = e.steps.length, s = this.eventCount;
    this.items.forEach((h) => {
      h.selection && s--;
    }, a);
    let l = r;
    this.items.forEach((h) => {
      let p = i.getMirror(--l);
      if (p == null)
        return;
      o = Math.min(o, p);
      let g = i.maps[p];
      if (h.step) {
        let y = e.steps[p].invert(e.docs[p]), b = h.selection && h.selection.map(i.slice(l + 1, p));
        b && s++, n.push(new z2(g, y, b));
      } else
        n.push(new z2(g));
    }, a);
    let c = [];
    for (let h = r; h < o; h++)
      c.push(new z2(i.maps[h]));
    let u = this.items.slice(0, a).append(c).append(n), f = new v1(u, s);
    return f.emptyItemCount() > eon && (f = f.compress(this.items.length - n.length)), f;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((r) => {
      r.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let r = this.remapping(0, e), n = r.maps.length, a = [], i = 0;
    return this.items.forEach((o, s) => {
      if (s >= e)
        a.push(o), o.selection && i++;
      else if (o.step) {
        let l = o.step.map(r.slice(n)), c = l && l.getMap();
        if (n--, c && r.appendMap(c, n), l) {
          let u = o.selection && o.selection.map(r.slice(n));
          u && i++;
          let f = new z2(c.invert(), l, u), h, p = a.length - 1;
          (h = a.length && a[p].merge(f)) ? a[p] = h : a.push(f);
        }
      } else o.map && n--;
    }, this.items.length, 0), new v1(ic.from(a.reverse()), i);
  }
}
v1.empty = new v1(ic.empty, 0);
function ton(t, e) {
  let r;
  return t.forEach((n, a) => {
    if (n.selection && e-- == 0)
      return r = a, !1;
  }), t.slice(r);
}
class z2 {
  constructor(e, r, n, a) {
    this.map = e, this.step = r, this.selection = n, this.mirrorOffset = a;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let r = e.step.merge(this.step);
      if (r)
        return new z2(r.getMap().invert(), r, this.selection);
    }
  }
}
class mv {
  constructor(e, r, n, a, i) {
    this.done = e, this.undone = r, this.prevRanges = n, this.prevTime = a, this.prevComposition = i;
  }
}
const ron = 20;
function non(t, e, r, n) {
  let a = r.getMeta(Jb), i;
  if (a)
    return a.historyState;
  r.getMeta(oon) && (t = new mv(t.done, t.undone, null, 0, -1));
  let o = r.getMeta("appendedTransaction");
  if (r.steps.length == 0)
    return t;
  if (o && o.getMeta(Jb))
    return o.getMeta(Jb).redo ? new mv(t.done.addTransform(r, void 0, n, $$(e)), t.undone, Bje(r.mapping.maps), t.prevTime, t.prevComposition) : new mv(t.done, t.undone.addTransform(r, void 0, n, $$(e)), null, t.prevTime, t.prevComposition);
  if (r.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let s = r.getMeta("composition"), l = t.prevTime == 0 || !o && t.prevComposition != s && (t.prevTime < (r.time || 0) - n.newGroupDelay || !aon(r, t.prevRanges)), c = o ? Qie(t.prevRanges, r.mapping) : Bje(r.mapping.maps);
    return new mv(t.done.addTransform(r, l ? e.selection.getBookmark() : void 0, n, $$(e)), v1.empty, c, r.time, s ?? t.prevComposition);
  } else return (i = r.getMeta("rebased")) ? new mv(t.done.rebased(r, i), t.undone.rebased(r, i), Qie(t.prevRanges, r.mapping), t.prevTime, t.prevComposition) : new mv(t.done.addMaps(r.mapping.maps), t.undone.addMaps(r.mapping.maps), Qie(t.prevRanges, r.mapping), t.prevTime, t.prevComposition);
}
function aon(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let r = !1;
  return t.mapping.maps[0].forEach((n, a) => {
    for (let i = 0; i < e.length; i += 2)
      n <= e[i + 1] && a >= e[i] && (r = !0);
  }), r;
}
function Bje(t) {
  let e = [];
  for (let r = t.length - 1; r >= 0 && e.length == 0; r--)
    t[r].forEach((n, a, i, o) => e.push(i, o));
  return e;
}
function Qie(t, e) {
  if (!t)
    return null;
  let r = [];
  for (let n = 0; n < t.length; n += 2) {
    let a = e.map(t[n], 1), i = e.map(t[n + 1], -1);
    a <= i && r.push(a, i);
  }
  return r;
}
function ion(t, e, r) {
  let n = $$(e), a = Jb.get(e).spec.config, i = (r ? t.undone : t.done).popEvent(e, n);
  if (!i)
    return null;
  let o = i.selection.resolve(i.transform.doc), s = (r ? t.done : t.undone).addTransform(i.transform, e.selection.getBookmark(), a, n), l = new mv(r ? s : i.remaining, r ? i.remaining : s, null, 0, -1);
  return i.transform.setSelection(o).setMeta(Jb, { redo: r, historyState: l });
}
let eoe = !1, Nje = null;
function $$(t) {
  let e = t.plugins;
  if (Nje != e) {
    eoe = !1, Nje = e;
    for (let r = 0; r < e.length; r++)
      if (e[r].spec.historyPreserveItems) {
        eoe = !0;
        break;
      }
  }
  return eoe;
}
const Jb = new lp("history"), oon = new lp("closeHistory");
function son(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new Bd({
    key: Jb,
    state: {
      init() {
        return new mv(v1.empty, v1.empty, null, 0, -1);
      },
      apply(e, r, n) {
        return non(r, n, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, r) {
          let n = r.inputType, a = n == "historyUndo" ? Nmt : n == "historyRedo" ? $mt : null;
          return a ? (r.preventDefault(), a(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function Bmt(t, e) {
  return (r, n) => {
    let a = Jb.getState(r);
    if (!a || (t ? a.undone : a.done).eventCount == 0)
      return !1;
    if (n) {
      let i = ion(a, r, t);
      i && n(e ? i.scrollIntoView() : i);
    }
    return !0;
  };
}
const Nmt = Bmt(!1, !0), $mt = Bmt(!0, !0), lon = Fu.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => Nmt(t, e),
      redo: () => ({ state: t, dispatch: e }) => $mt(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      son(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), con = m2.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", ju(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: r } = e, { $from: n, $to: a } = r, i = t();
        return n.parentOffset === 0 ? i.insertContentAt({
          from: Math.max(n.pos - 1, 0),
          to: a.pos
        }, {
          type: this.name
        }) : _an(r) ? i.insertContentAt(a.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ tr: o, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: c } = o.selection, u = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? o.setSelection(qa.create(o.doc, c.pos + 1)) : c.nodeAfter.isBlock ? o.setSelection(ea.create(o.doc, c.pos)) : o.setSelection(qa.create(o.doc, c.pos));
            else {
              const f = (l = c.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              f && (o.insert(u, f), o.setSelection(qa.create(o.doc, u + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      tin({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), uon = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, don = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, fon = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, hon = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, pon = ky.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      o8({
        find: uon,
        type: this.type
      }),
      o8({
        find: fon,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      s8({
        find: don,
        type: this.type
      }),
      s8({
        find: hon,
        type: this.type
      })
    ];
  }
}), mon = m2.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", ju(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), gon = "listItem", $je = "textStyle", Dje = /^(\d+)\.\s$/, von = m2.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: void 0,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...r } = t;
    return e === 1 ? ["ol", ju(this.options.HTMLAttributes, r), 0] : ["ol", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(gon, this.editor.getAttributes($je)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = gI({
      find: Dje,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, r) => r.childCount + r.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = gI({
      find: Dje,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes($je) }),
      joinPredicate: (e, r) => r.childCount + r.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), yon = m2.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), bon = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, xon = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, Con = ky.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", ju(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      o8({
        find: bon,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      s8({
        find: xon,
        type: this.type
      })
    ];
  }
}), won = m2.create({
  name: "text",
  group: "inline"
}), Son = Fu.create({
  name: "starterKit",
  addExtensions() {
    var t, e, r, n, a, i, o, s, l, c, u, f, h, p, g, y, b, w;
    const _ = [];
    return this.options.bold !== !1 && _.push(Min.configure((t = this.options) === null || t === void 0 ? void 0 : t.bold)), this.options.blockquote !== !1 && _.push(kin.configure((e = this.options) === null || e === void 0 ? void 0 : e.blockquote)), this.options.bulletList !== !1 && _.push(Rin.configure((r = this.options) === null || r === void 0 ? void 0 : r.bulletList)), this.options.code !== !1 && _.push(Nin.configure((n = this.options) === null || n === void 0 ? void 0 : n.code)), this.options.codeBlock !== !1 && _.push(Lin.configure((a = this.options) === null || a === void 0 ? void 0 : a.codeBlock)), this.options.document !== !1 && _.push(jin.configure((i = this.options) === null || i === void 0 ? void 0 : i.document)), this.options.dropcursor !== !1 && _.push(Gin.configure((o = this.options) === null || o === void 0 ? void 0 : o.dropcursor)), this.options.gapcursor !== !1 && _.push(Jin.configure((s = this.options) === null || s === void 0 ? void 0 : s.gapcursor)), this.options.hardBreak !== !1 && _.push(Yin.configure((l = this.options) === null || l === void 0 ? void 0 : l.hardBreak)), this.options.heading !== !1 && _.push(Xin.configure((c = this.options) === null || c === void 0 ? void 0 : c.heading)), this.options.history !== !1 && _.push(lon.configure((u = this.options) === null || u === void 0 ? void 0 : u.history)), this.options.horizontalRule !== !1 && _.push(con.configure((f = this.options) === null || f === void 0 ? void 0 : f.horizontalRule)), this.options.italic !== !1 && _.push(pon.configure((h = this.options) === null || h === void 0 ? void 0 : h.italic)), this.options.listItem !== !1 && _.push(mon.configure((p = this.options) === null || p === void 0 ? void 0 : p.listItem)), this.options.orderedList !== !1 && _.push(von.configure((g = this.options) === null || g === void 0 ? void 0 : g.orderedList)), this.options.paragraph !== !1 && _.push(yon.configure((y = this.options) === null || y === void 0 ? void 0 : y.paragraph)), this.options.strike !== !1 && _.push(Con.configure((b = this.options) === null || b === void 0 ? void 0 : b.strike)), this.options.text !== !1 && _.push(won.configure((w = this.options) === null || w === void 0 ? void 0 : w.text)), _;
  }
}), _on = "_tiptap_bi719_2", Lje = {
  tiptap: _on
}, kon = ({
  editor: t,
  readonly: e = !1
}) => /* @__PURE__ */ R.jsx(
  _r,
  {
    margin: "space40",
    flexGrow: 1,
    flexBasis: 0,
    overflowY: "scroll",
    style: {
      scrollbarColor: "#999 transparent"
    },
    children: /* @__PURE__ */ R.jsx(
      uin,
      {
        editor: t,
        className: `${Lje.tiptap} ${e ? Lje.readonly : ""}`
      }
    )
  }
), Aon = ({
  editor: t,
  readonly: e = !1,
  isSaved: r,
  onClose: n,
  onCopy: a
}) => /* @__PURE__ */ R.jsxs(
  _r,
  {
    borderColor: "colorBorderWeaker",
    borderBottomWidth: "borderWidth10",
    padding: "space20",
    display: "flex",
    columnGap: "space20",
    children: [
      /* @__PURE__ */ R.jsx(al, { text: "Heading 1", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("heading", { level: 1 }),
          onClick: () => !e && t.chain().focus().toggleHeading({ level: 1 }).run(),
          children: /* @__PURE__ */ R.jsx(Exr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Heading 2", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("heading", { level: 2 }),
          onClick: () => !e && t.chain().focus().toggleHeading({ level: 2 }).run(),
          children: /* @__PURE__ */ R.jsx(Mxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Heading 3", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("heading", { level: 3 }),
          onClick: () => !e && t.chain().focus().toggleHeading({ level: 3 }).run(),
          children: /* @__PURE__ */ R.jsx(Rxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Bold", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("bold"),
          onClick: () => !e && t.chain().focus().toggleBold().run(),
          children: /* @__PURE__ */ R.jsx(Q7r, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Italic", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("italic"),
          onClick: () => !e && t.chain().focus().toggleItalic().run(),
          children: /* @__PURE__ */ R.jsx(Bxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Strike", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("strike"),
          onClick: () => !e && t.chain().focus().toggleStrike().run(),
          children: /* @__PURE__ */ R.jsx(Jxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Code", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("code"),
          onClick: () => !e && t.chain().focus().toggleCode().run(),
          children: /* @__PURE__ */ R.jsx(bxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "List", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("bulletList"),
          onClick: () => !e && t.chain().focus().toggleBulletList().run(),
          children: /* @__PURE__ */ R.jsx(Lxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Ordered List", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("orderedList"),
          onClick: () => !e && t.chain().focus().toggleOrderedList().run(),
          children: /* @__PURE__ */ R.jsx($xr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Blockquote", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("blockquote"),
          onClick: () => !e && t.chain().focus().toggleBlockquote().run(),
          children: /* @__PURE__ */ R.jsx(Xxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Code Block", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: t.isActive("codeBlock"),
          onClick: () => !e && t.chain().focus().toggleCodeBlock().run(),
          children: /* @__PURE__ */ R.jsx(Kxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(al, { text: "Horizontal Rule", children: /* @__PURE__ */ R.jsx(
        Ud,
        {
          pressed: !1,
          onClick: () => !e && t.chain().focus().setHorizontalRule().run(),
          children: /* @__PURE__ */ R.jsx(Vxr, {})
        }
      ) }),
      /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
      /* @__PURE__ */ R.jsx(al, { text: r ? "Saved" : "Unsaved", children: /* @__PURE__ */ R.jsx(S$, { variant: "ghost", size: "icon", children: r ? /* @__PURE__ */ R.jsx(sxr, {}) : /* @__PURE__ */ R.jsx(Fxr, { className: "animate-spin" }) }) }),
      /* @__PURE__ */ R.jsx(al, { text: "Copy", children: /* @__PURE__ */ R.jsx(S$, { variant: "ghost", size: "icon", onClick: a, children: /* @__PURE__ */ R.jsx(Cxr, {}) }) }),
      /* @__PURE__ */ R.jsx(al, { text: "Close", children: /* @__PURE__ */ R.jsx(S$, { variant: "ghost", size: "icon", onClick: n, children: /* @__PURE__ */ R.jsx(r8r, {}) }) })
    ]
  }
), Dmt = ({
  value: t,
  setValue: e,
  readonly: r,
  showToolbar: n = !0,
  isSaved: a,
  onClose: i
}) => {
  const o = xin({
    extensions: [Son],
    content: t,
    editable: !r,
    onUpdate: ({ editor: l }) => {
      e(l.getHTML());
    },
    editorProps: {
      attributes: {
        style: "outline: none; height: 100%;"
      }
    }
  });
  if (Ut(() => {
    o && o.getHTML() !== t && o.commands.setContent(t);
  }, [t, o]), !o)
    return null;
  const s = () => {
    const l = o.getText();
    navigator.clipboard.writeText(l);
  };
  return /* @__PURE__ */ R.jsxs("div", { style: { height: "100%", display: "flex", flexDirection: "column" }, children: [
    n && /* @__PURE__ */ R.jsx(
      Aon,
      {
        editor: o,
        readonly: r,
        isSaved: a,
        onClose: i,
        onCopy: s
      }
    ),
    /* @__PURE__ */ R.jsx(kon, { editor: o, readonly: r })
  ] });
}, Ton = ({
  canvasContents: t,
  onClick: e,
  variant: r
}) => r === "compact" ? /* @__PURE__ */ R.jsx(_r, { display: "flex", children: /* @__PURE__ */ R.jsx(is, { padding: "space40", fontWeight: "fontWeightBold", children: "Canvas Updated" }) }) : /* @__PURE__ */ R.jsx(
  is,
  {
    width: "225px",
    height: "300px",
    overflow: "hidden",
    onClick: e,
    cursor: "pointer",
    _hover: {
      boxShadow: "shadowBorderPrimary"
    },
    children: /* @__PURE__ */ R.jsx(
      Dmt,
      {
        value: t,
        setValue: () => {
        },
        readonly: !0,
        showToolbar: !1,
        isSaved: !0,
        onClose: () => {
        }
      }
    )
  }
), Eon = ({
  variant: t
}) => {
  const e = s2(), r = Gn(
    (a) => a.conversation.canvasContents
  ), n = () => {
    e(oz(!0));
  };
  return /* @__PURE__ */ R.jsx(
    Ton,
    {
      canvasContents: r,
      onClick: n,
      variant: t
    }
  );
}, bbe = ({
  heading: t,
  headingIcon: e,
  body: r,
  buttonProps: n = {
    label: "Get started",
    disabled: !1,
    onClick: () => {
    },
    loading: !1
  }
}) => /* @__PURE__ */ R.jsx(vh.Card, { padding: "space50", children: /* @__PURE__ */ R.jsxs(
  ar.Box,
  {
    textAlign: "left",
    margin: "space10",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
    children: [
      /* @__PURE__ */ R.jsxs(ar.Box, { children: [
        /* @__PURE__ */ R.jsx(
          hy.Heading,
          {
            as: "h4",
            variant: "heading60",
            marginBottom: "space0",
            display: "flex",
            children: /* @__PURE__ */ R.jsxs(ar.Box, { paddingRight: "space30", children: [
              e && e,
              t
            ] })
          }
        ),
        /* @__PURE__ */ R.jsx(bht.Separator, { orientation: "horizontal", verticalSpacing: "space40" }),
        /* @__PURE__ */ R.jsx(Ly.Paragraph, { children: r })
      ] }),
      /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsx(
        zi.Button,
        {
          variant: "secondary",
          onClick: n.onClick,
          disabled: !n.loading && n.disabled,
          loading: n.loading,
          children: n.label
        }
      ) })
    ]
  }
) }), jje = "phone-support-modal-heading", Fje = {
  heading: "Submit a ticket",
  buttonLabel: "Get started"
}, SN = {
  heading: "Call support",
  body: "Upgrade to a paid plan for 24/7 phone support.",
  buttonLabel: "Explore plans",
  modal: {
    buttonLabel: "Close"
  }
}, Ion = {
  defaultHeading: "Chat with live agent"
}, Mon = ({
  conversationId: t = "",
  productCategories: e,
  disabled: r,
  cardValues: n,
  inferredProductCategory: a,
  inferredSummary: i,
  upgradeLink: o,
  isEntitled: s
}) => {
  const l = Gn((x) => x.config.applicationId), c = Gn((x) => x.config.user), [u, f] = Yt(!1), { heading: h = "", buttonLabel: p = "", body: g } = n || {}, y = {
    friendlyName: `${c.firstName} ${c.lastName}`,
    identity: c.emailAddr,
    email: c.emailAddr,
    userSid: c.userSid,
    accountSid: c.accountSid
  }, { isTransferringToLiveChat: b, handleTransferToLiveChat: w } = qQr(t, l), _ = () => {
    if (!s)
      return window.location.assign(o || "");
    f(!u);
  }, C = async (x, S) => {
    await w(
      x,
      S,
      y
    );
  };
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(
      bbe,
      {
        heading: h,
        body: g,
        headingIcon: /* @__PURE__ */ R.jsx(
          v3e,
          {
            decorative: !1,
            title: Ion.defaultHeading
          }
        ),
        buttonProps: {
          onClick: _,
          disabled: r,
          loading: b,
          label: p
        }
      }
    ),
    /* @__PURE__ */ R.jsx(
      zht,
      {
        supportedProducts: e,
        handleStartEngagement: C,
        handleToggleVisibility: _,
        isOpen: u,
        inferredProductCategory: a,
        inferredSummary: i,
        ingress: ol.osc
      }
    )
  ] });
}, xbe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DocumentationIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DocumentationIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M9.374 5.458c.05.034.091.065.126.092v9.992a7.543 7.543 0 00-.822-.389c-1.145-.464-2.951-.92-5.678-.972V4.003c2.614.05 4.5.535 5.304.897.43.194.861.414 1.07.558zm.262 11.385zm.003.003l-.002-.002-.003-.003a2.543 2.543 0 00-.26-.203 5.623 5.623 0 00-1.072-.558c-1.034-.42-2.763-.866-5.475-.901h-.008a.85.85 0 01-.576-.248.824.824 0 01-.243-.587V3.834a.829.829 0 01.53-.775A.85.85 0 012.852 3c2.811.036 4.663.5 5.828.974a6.595 6.595 0 011.32.702 6.598 6.598 0 011.32-.702c1.165-.474 3.017-.938 5.828-.974a.85.85 0 01.599.238.83.83 0 01.253.596v10.51a.824.824 0 01-.242.587.85.85 0 01-.577.248h-.008c-2.712.035-4.44.481-5.475.9a5.63 5.63 0 00-1.072.558 2.53 2.53 0 00-.26.204l-.003.003-.002.002a.499.499 0 01-.361.15.499.499 0 01-.361-.15zm.725-.003zm.958-1.69a7.539 7.539 0 00-.822.39V5.55c.035-.027.077-.058.126-.092.209-.144.64-.364 1.07-.558.804-.362 2.69-.848 5.304-.897V14.18c-2.727.052-4.533.508-5.678.972zm-7.46-6.055a.5.5 0 01.534-.463c1.156.082 2.298.311 3.397.68a.5.5 0 01-.32.949 12.725 12.725 0 00-3.148-.632.5.5 0 01-.463-.534zm0 2.61a.5.5 0 01.534-.463c1.156.083 2.298.312 3.397.681a.5.5 0 11-.32.948 12.726 12.726 0 00-3.148-.632.5.5 0 01-.463-.534zm11.817-2.076a.5.5 0 00-.072-.997 13.726 13.726 0 00-3.396.68.5.5 0 00.318.949 12.724 12.724 0 013.15-.632zm.463 2.076a.5.5 0 01-.463.534c-1.073.077-2.13.29-3.15.632a.5.5 0 01-.318-.948c1.098-.37 2.24-.598 3.396-.681a.5.5 0 01.535.463z" })));
});
xbe.displayName = "DocumentationIcon";
const Pon = ({
  redirectLink: t,
  cardValues: e,
  disabled: r
}) => {
  const {
    heading: n = Fje.heading,
    buttonLabel: a = Fje.buttonLabel
  } = e || {}, i = () => {
    if (t) {
      const o = new URL(t);
      window.location.assign(o.toString());
    }
  };
  return /* @__PURE__ */ R.jsx(
    bbe,
    {
      heading: n,
      headingIcon: /* @__PURE__ */ R.jsx(xbe, { decorative: !1, title: n }),
      buttonProps: {
        onClick: i,
        disabled: r,
        label: a
      }
    }
  );
}, Lmt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CallIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CallIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M4.141 2.98a1.643 1.643 0 012.322.001l2.03 2.026a1.656 1.656 0 01.359 1.812 1.657 1.657 0 01-.36.538.63.63 0 000 .892l3.245 3.241a.654.654 0 00.924 0 1.646 1.646 0 011.789-.356c.199.082.38.203.534.356l2.03 2.026a1.656 1.656 0 01.486 1.175 1.662 1.662 0 01-.487 1.175l-.48.48a3.94 3.94 0 01-4.918.527l-.004-.003a31.55 31.55 0 01-8.494-8.491v-.002a3.953 3.953 0 01.542-4.915l.482-.481zm1.161.54c-.175 0-.34.07-.461.19l-.482.48a2.922 2.922 0 00-.4 3.637l.005.009a30.541 30.541 0 008.202 8.185l.006.005a2.954 2.954 0 003.66-.408l.482-.48a.637.637 0 00.186-.447.626.626 0 00-.186-.446l-2.03-2.026a.647.647 0 00-.462-.19.656.656 0 00-.462.19 1.644 1.644 0 01-2.322 0L7.793 8.977a1.66 1.66 0 010-2.349.637.637 0 00.186-.446.626.626 0 00-.186-.447L5.763 3.71a.653.653 0 00-.46-.19z" })));
});
Lmt.displayName = "CallIcon";
const Ron = ({
  upgradeLink: t,
  cardValues: e,
  isEntitled: r,
  disabled: n
}) => {
  const [a, i] = Yt(!1), {
    heading: o = SN.heading,
    body: s = SN.body,
    buttonLabel: l = SN.buttonLabel,
    modalBody: c
  } = e || {}, u = () => i(!0), f = () => i(!1), h = () => r ? u() : window.location.assign(t || "");
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(
      bbe,
      {
        heading: o,
        headingIcon: /* @__PURE__ */ R.jsx(Lmt, { decorative: !1, title: o }),
        body: s,
        buttonProps: {
          onClick: h,
          disabled: n,
          label: l
        }
      }
    ),
    /* @__PURE__ */ R.jsxs(
      _s.Modal,
      {
        ariaLabelledby: jje,
        isOpen: a,
        onDismiss: f,
        size: "default",
        children: [
          /* @__PURE__ */ R.jsx(_s.ModalHeader, { children: /* @__PURE__ */ R.jsx(_s.ModalHeading, { as: "h3", id: jje, children: o }) }),
          /* @__PURE__ */ R.jsx(_s.ModalBody, { children: /* @__PURE__ */ R.jsx(ar.Box, { as: "div", style: { whiteSpace: "pre-line" }, children: c }) }),
          /* @__PURE__ */ R.jsx(_s.ModalFooter, { children: /* @__PURE__ */ R.jsx(_s.ModalFooterActions, { children: /* @__PURE__ */ R.jsx(zi.Button, { variant: "secondary", onClick: f, children: SN.modal.buttonLabel }) }) })
        ]
      }
    )
  ] });
}, Oon = ({
  loading: t,
  data: e
}) => {
  const r = Gn(
    (c) => c.conversation.isTransferring
  ), n = Gn(
    (c) => c.conversation.conversationId
  ), a = Gn((c) => c.conversation.transfer), i = (a == null ? void 0 : a.status) === vz.COMPLETE || r, o = () => !e || !e.liveChat ? null : /* @__PURE__ */ R.jsx(
    Mon,
    {
      conversationId: n,
      disabled: i,
      ...e.liveChat
    }
  ), s = () => !e || !e.ticketSubmission ? null : /* @__PURE__ */ R.jsx(
    Pon,
    {
      disabled: i,
      ...e.ticketSubmission
    }
  ), l = () => !e || !e.phoneSupport ? null : /* @__PURE__ */ R.jsx(
    Ron,
    {
      disabled: i,
      ...e.phoneSupport
    }
  );
  return t ? /* @__PURE__ */ R.jsx(
    Oct,
    {
      message: "Preparing support options",
      isComplete: !t
    }
  ) : /* @__PURE__ */ R.jsxs(
    ar.Box,
    {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr));",
      columnGap: "space30",
      rowGap: "space30",
      children: [
        s(),
        o(),
        l()
      ]
    }
  );
}, jmt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ProductSupportIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ProductSupportIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1.5 10a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0ZM10 2.686a7.314 7.314 0 1 0 0 14.628 7.314 7.314 0 0 0 0-14.628Zm.227 3.67a1.987 1.987 0 0 0-2.213 1.977l.001.593-1.186.002v-.594a3.173 3.173 0 1 1 3.857 3.094l-.013.003a.1.1 0 0 0-.08.094v.946H9.407v-.96a1.286 1.286 0 0 1 1.028-1.242 1.986 1.986 0 0 0-.208-3.913Zm-.99 8.044a.765.765 0 1 1 1.529 0 .765.765 0 0 1-1.53 0Z", clipRule: "evenodd" })));
});
jmt.displayName = "ProductSupportIcon";
var toe, zje;
function Fmt() {
  return zje || (zje = 1, toe = Object), toe;
}
var roe, Gje;
function Bon() {
  return Gje || (Gje = 1, roe = Error), roe;
}
var noe, Wje;
function Non() {
  return Wje || (Wje = 1, noe = EvalError), noe;
}
var aoe, Hje;
function $on() {
  return Hje || (Hje = 1, aoe = RangeError), aoe;
}
var ioe, Uje;
function Don() {
  return Uje || (Uje = 1, ioe = ReferenceError), ioe;
}
var ooe, Vje;
function zmt() {
  return Vje || (Vje = 1, ooe = SyntaxError), ooe;
}
var soe, qje;
function xP() {
  return qje || (qje = 1, soe = TypeError), soe;
}
var loe, Kje;
function Lon() {
  return Kje || (Kje = 1, loe = URIError), loe;
}
var coe, Zje;
function jon() {
  return Zje || (Zje = 1, coe = Math.abs), coe;
}
var uoe, Jje;
function Fon() {
  return Jje || (Jje = 1, uoe = Math.floor), uoe;
}
var doe, Yje;
function zon() {
  return Yje || (Yje = 1, doe = Math.max), doe;
}
var foe, Xje;
function Gon() {
  return Xje || (Xje = 1, foe = Math.min), foe;
}
var hoe, Qje;
function Won() {
  return Qje || (Qje = 1, hoe = Math.pow), hoe;
}
var poe, eFe;
function Hon() {
  return eFe || (eFe = 1, poe = Math.round), poe;
}
var moe, tFe;
function Uon() {
  return tFe || (tFe = 1, moe = Number.isNaN || function(e) {
    return e !== e;
  }), moe;
}
var goe, rFe;
function Von() {
  if (rFe) return goe;
  rFe = 1;
  var t = /* @__PURE__ */ Uon();
  return goe = function(r) {
    return t(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, goe;
}
var voe, nFe;
function qon() {
  return nFe || (nFe = 1, voe = Object.getOwnPropertyDescriptor), voe;
}
var yoe, aFe;
function HH() {
  if (aFe) return yoe;
  aFe = 1;
  var t = /* @__PURE__ */ qon();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return yoe = t, yoe;
}
var boe, iFe;
function UH() {
  if (iFe) return boe;
  iFe = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return boe = t, boe;
}
var xoe, oFe;
function Kon() {
  return oFe || (oFe = 1, xoe = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var a = 42;
    e[r] = a;
    for (var i in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var o = Object.getOwnPropertySymbols(e);
    if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(e, r)
      );
      if (s.value !== a || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), xoe;
}
var Coe, sFe;
function Zon() {
  if (sFe) return Coe;
  sFe = 1;
  var t = typeof Symbol < "u" && Symbol, e = Kon();
  return Coe = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, Coe;
}
var woe, lFe;
function Gmt() {
  return lFe || (lFe = 1, woe = typeof Reflect < "u" && Reflect.getPrototypeOf || null), woe;
}
var Soe, cFe;
function Wmt() {
  if (cFe) return Soe;
  cFe = 1;
  var t = /* @__PURE__ */ Fmt();
  return Soe = t.getPrototypeOf || null, Soe;
}
var _oe, uFe;
function Jon() {
  if (uFe) return _oe;
  uFe = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, r = Math.max, n = "[object Function]", a = function(l, c) {
    for (var u = [], f = 0; f < l.length; f += 1)
      u[f] = l[f];
    for (var h = 0; h < c.length; h += 1)
      u[h + l.length] = c[h];
    return u;
  }, i = function(l, c) {
    for (var u = [], f = c, h = 0; f < l.length; f += 1, h += 1)
      u[h] = l[f];
    return u;
  }, o = function(s, l) {
    for (var c = "", u = 0; u < s.length; u += 1)
      c += s[u], u + 1 < s.length && (c += l);
    return c;
  };
  return _oe = function(l) {
    var c = this;
    if (typeof c != "function" || e.apply(c) !== n)
      throw new TypeError(t + c);
    for (var u = i(arguments, 1), f, h = function() {
      if (this instanceof f) {
        var w = c.apply(
          this,
          a(u, arguments)
        );
        return Object(w) === w ? w : this;
      }
      return c.apply(
        l,
        a(u, arguments)
      );
    }, p = r(0, c.length - u.length), g = [], y = 0; y < p; y++)
      g[y] = "$" + y;
    if (f = Function("binder", "return function (" + o(g, ",") + "){ return binder.apply(this,arguments); }")(h), c.prototype) {
      var b = function() {
      };
      b.prototype = c.prototype, f.prototype = new b(), b.prototype = null;
    }
    return f;
  }, _oe;
}
var koe, dFe;
function CP() {
  if (dFe) return koe;
  dFe = 1;
  var t = Jon();
  return koe = Function.prototype.bind || t, koe;
}
var Aoe, fFe;
function Cbe() {
  return fFe || (fFe = 1, Aoe = Function.prototype.call), Aoe;
}
var Toe, hFe;
function wbe() {
  return hFe || (hFe = 1, Toe = Function.prototype.apply), Toe;
}
var Eoe, pFe;
function Yon() {
  return pFe || (pFe = 1, Eoe = typeof Reflect < "u" && Reflect && Reflect.apply), Eoe;
}
var Ioe, mFe;
function Hmt() {
  if (mFe) return Ioe;
  mFe = 1;
  var t = CP(), e = wbe(), r = Cbe(), n = Yon();
  return Ioe = n || t.call(r, e), Ioe;
}
var Moe, gFe;
function Umt() {
  if (gFe) return Moe;
  gFe = 1;
  var t = CP(), e = /* @__PURE__ */ xP(), r = Cbe(), n = Hmt();
  return Moe = function(i) {
    if (i.length < 1 || typeof i[0] != "function")
      throw new e("a function is required");
    return n(t, r, i);
  }, Moe;
}
var Poe, vFe;
function Xon() {
  if (vFe) return Poe;
  vFe = 1;
  var t = Umt(), e = /* @__PURE__ */ HH(), r;
  try {
    r = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (o) {
    if (!o || typeof o != "object" || !("code" in o) || o.code !== "ERR_PROTO_ACCESS")
      throw o;
  }
  var n = !!r && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), a = Object, i = a.getPrototypeOf;
  return Poe = n && typeof n.get == "function" ? t([n.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return i(s == null ? s : a(s));
    }
  ) : !1, Poe;
}
var Roe, yFe;
function Qon() {
  if (yFe) return Roe;
  yFe = 1;
  var t = Gmt(), e = Wmt(), r = /* @__PURE__ */ Xon();
  return Roe = t ? function(a) {
    return t(a);
  } : e ? function(a) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new TypeError("getProto: not an object");
    return e(a);
  } : r ? function(a) {
    return r(a);
  } : null, Roe;
}
var Ooe, bFe;
function esn() {
  if (bFe) return Ooe;
  bFe = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, r = CP();
  return Ooe = r.call(t, e), Ooe;
}
var Boe, xFe;
function Sbe() {
  if (xFe) return Boe;
  xFe = 1;
  var t, e = /* @__PURE__ */ Fmt(), r = /* @__PURE__ */ Bon(), n = /* @__PURE__ */ Non(), a = /* @__PURE__ */ $on(), i = /* @__PURE__ */ Don(), o = /* @__PURE__ */ zmt(), s = /* @__PURE__ */ xP(), l = /* @__PURE__ */ Lon(), c = /* @__PURE__ */ jon(), u = /* @__PURE__ */ Fon(), f = /* @__PURE__ */ zon(), h = /* @__PURE__ */ Gon(), p = /* @__PURE__ */ Won(), g = /* @__PURE__ */ Hon(), y = /* @__PURE__ */ Von(), b = Function, w = function(ee) {
    try {
      return b('"use strict"; return (' + ee + ").constructor;")();
    } catch {
    }
  }, _ = /* @__PURE__ */ HH(), C = /* @__PURE__ */ UH(), x = function() {
    throw new s();
  }, S = _ ? function() {
    try {
      return arguments.callee, x;
    } catch {
      try {
        return _(arguments, "callee").get;
      } catch {
        return x;
      }
    }
  }() : x, A = Zon()(), I = Qon(), M = Wmt(), B = Gmt(), L = wbe(), N = Cbe(), d = {}, m = typeof Uint8Array > "u" || !I ? t : I(Uint8Array), v = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": A && I ? I([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": d,
    "%AsyncGenerator%": d,
    "%AsyncGeneratorFunction%": d,
    "%AsyncIteratorPrototype%": d,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": r,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": n,
    "%Float16Array%": typeof Float16Array > "u" ? t : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": b,
    "%GeneratorFunction%": d,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": A && I ? I(I([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !A || !I ? t : I((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": _,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": a,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !A || !I ? t : I((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": A && I ? I(""[Symbol.iterator]()) : t,
    "%Symbol%": A ? Symbol : t,
    "%SyntaxError%": o,
    "%ThrowTypeError%": S,
    "%TypedArray%": m,
    "%TypeError%": s,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": N,
    "%Function.prototype.apply%": L,
    "%Object.defineProperty%": C,
    "%Object.getPrototypeOf%": M,
    "%Math.abs%": c,
    "%Math.floor%": u,
    "%Math.max%": f,
    "%Math.min%": h,
    "%Math.pow%": p,
    "%Math.round%": g,
    "%Math.sign%": y,
    "%Reflect.getPrototypeOf%": B
  };
  if (I)
    try {
      null.error;
    } catch (ee) {
      var k = I(I(ee));
      v["%Error.prototype%"] = k;
    }
  var O = function ee(Se) {
    var Ce;
    if (Se === "%AsyncFunction%")
      Ce = w("async function () {}");
    else if (Se === "%GeneratorFunction%")
      Ce = w("function* () {}");
    else if (Se === "%AsyncGeneratorFunction%")
      Ce = w("async function* () {}");
    else if (Se === "%AsyncGenerator%") {
      var we = ee("%AsyncGeneratorFunction%");
      we && (Ce = we.prototype);
    } else if (Se === "%AsyncIteratorPrototype%") {
      var We = ee("%AsyncGenerator%");
      We && I && (Ce = I(We.prototype));
    }
    return v[Se] = Ce, Ce;
  }, G = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, H = CP(), j = /* @__PURE__ */ esn(), F = H.call(N, Array.prototype.concat), z = H.call(L, Array.prototype.splice), W = H.call(N, String.prototype.replace), U = H.call(N, String.prototype.slice), Z = H.call(N, RegExp.prototype.exec), V = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Y = /\\(\\)?/g, ge = function(Se) {
    var Ce = U(Se, 0, 1), we = U(Se, -1);
    if (Ce === "%" && we !== "%")
      throw new o("invalid intrinsic syntax, expected closing `%`");
    if (we === "%" && Ce !== "%")
      throw new o("invalid intrinsic syntax, expected opening `%`");
    var We = [];
    return W(Se, V, function(Fe, it, gt, Ze) {
      We[We.length] = gt ? W(Ze, Y, "$1") : it || Fe;
    }), We;
  }, ce = function(Se, Ce) {
    var we = Se, We;
    if (j(G, we) && (We = G[we], we = "%" + We[0] + "%"), j(v, we)) {
      var Fe = v[we];
      if (Fe === d && (Fe = O(we)), typeof Fe > "u" && !Ce)
        throw new s("intrinsic " + Se + " exists, but is not available. Please file an issue!");
      return {
        alias: We,
        name: we,
        value: Fe
      };
    }
    throw new o("intrinsic " + Se + " does not exist!");
  };
  return Boe = function(Se, Ce) {
    if (typeof Se != "string" || Se.length === 0)
      throw new s("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Ce != "boolean")
      throw new s('"allowMissing" argument must be a boolean');
    if (Z(/^%?[^%]*%?$/, Se) === null)
      throw new o("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var we = ge(Se), We = we.length > 0 ? we[0] : "", Fe = ce("%" + We + "%", Ce), it = Fe.name, gt = Fe.value, Ze = !1, Ne = Fe.alias;
    Ne && (We = Ne[0], z(we, F([0, 1], Ne)));
    for (var ze = 1, ct = !0; ze < we.length; ze += 1) {
      var rt = we[ze], qe = U(rt, 0, 1), nt = U(rt, -1);
      if ((qe === '"' || qe === "'" || qe === "`" || nt === '"' || nt === "'" || nt === "`") && qe !== nt)
        throw new o("property names with quotes must have matching quotes");
      if ((rt === "constructor" || !ct) && (Ze = !0), We += "." + rt, it = "%" + We + "%", j(v, it))
        gt = v[it];
      else if (gt != null) {
        if (!(rt in gt)) {
          if (!Ce)
            throw new s("base intrinsic for " + Se + " exists, but the property is not available.");
          return;
        }
        if (_ && ze + 1 >= we.length) {
          var Rt = _(gt, rt);
          ct = !!Rt, ct && "get" in Rt && !("originalValue" in Rt.get) ? gt = Rt.get : gt = gt[rt];
        } else
          ct = j(gt, rt), gt = gt[rt];
        ct && !Ze && (v[it] = gt);
      }
    }
    return gt;
  }, Boe;
}
var Noe = { exports: {} }, $oe, CFe;
function tsn() {
  if (CFe) return $oe;
  CFe = 1;
  var t = /* @__PURE__ */ UH(), e = /* @__PURE__ */ zmt(), r = /* @__PURE__ */ xP(), n = /* @__PURE__ */ HH();
  return $oe = function(i, o, s) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new r("`obj` must be an object or a function`");
    if (typeof o != "string" && typeof o != "symbol")
      throw new r("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new r("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new r("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new r("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new r("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, c = arguments.length > 4 ? arguments[4] : null, u = arguments.length > 5 ? arguments[5] : null, f = arguments.length > 6 ? arguments[6] : !1, h = !!n && n(i, o);
    if (t)
      t(i, o, {
        configurable: u === null && h ? h.configurable : !u,
        enumerable: l === null && h ? h.enumerable : !l,
        value: s,
        writable: c === null && h ? h.writable : !c
      });
    else if (f || !l && !c && !u)
      i[o] = s;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, $oe;
}
var Doe, wFe;
function rsn() {
  if (wFe) return Doe;
  wFe = 1;
  var t = /* @__PURE__ */ UH(), e = function() {
    return !!t;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!t)
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, Doe = e, Doe;
}
var Loe, SFe;
function nsn() {
  if (SFe) return Loe;
  SFe = 1;
  var t = /* @__PURE__ */ Sbe(), e = /* @__PURE__ */ tsn(), r = /* @__PURE__ */ rsn()(), n = /* @__PURE__ */ HH(), a = /* @__PURE__ */ xP(), i = t("%Math.floor%");
  return Loe = function(s, l) {
    if (typeof s != "function")
      throw new a("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || i(l) !== l)
      throw new a("`length` must be a positive 32-bit integer");
    var c = arguments.length > 2 && !!arguments[2], u = !0, f = !0;
    if ("length" in s && n) {
      var h = n(s, "length");
      h && !h.configurable && (u = !1), h && !h.writable && (f = !1);
    }
    return (u || f || !c) && (r ? e(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l
    )), s;
  }, Loe;
}
var joe, _Fe;
function asn() {
  if (_Fe) return joe;
  _Fe = 1;
  var t = CP(), e = wbe(), r = Hmt();
  return joe = function() {
    return r(t, e, arguments);
  }, joe;
}
var kFe;
function isn() {
  return kFe || (kFe = 1, function(t) {
    var e = /* @__PURE__ */ nsn(), r = /* @__PURE__ */ UH(), n = Umt(), a = asn();
    t.exports = function(o) {
      var s = n(arguments), l = o.length - (arguments.length - 1);
      return e(
        s,
        1 + (l > 0 ? l : 0),
        !0
      );
    }, r ? r(t.exports, "apply", { value: a }) : t.exports.apply = a;
  }(Noe)), Noe.exports;
}
var Foe, AFe;
function osn() {
  if (AFe) return Foe;
  AFe = 1;
  var t = /* @__PURE__ */ Sbe(), e = isn(), r = e(t("String.prototype.indexOf"));
  return Foe = function(a, i) {
    var o = t(a, !!i);
    return typeof o == "function" && r(a, ".prototype.") > -1 ? e(o) : o;
  }, Foe;
}
const ssn = {}, lsn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ssn
}, Symbol.toStringTag, { value: "Module" })), csn = /* @__PURE__ */ aa(lsn);
var zoe, TFe;
function usn() {
  if (TFe) return zoe;
  TFe = 1;
  var t = typeof Map == "function" && Map.prototype, e = Object.getOwnPropertyDescriptor && t ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = t && e && typeof e.get == "function" ? e.get : null, n = t && Map.prototype.forEach, a = typeof Set == "function" && Set.prototype, i = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, o = a && i && typeof i.get == "function" ? i.get : null, s = a && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, c = l ? WeakMap.prototype.has : null, u = typeof WeakSet == "function" && WeakSet.prototype, f = u ? WeakSet.prototype.has : null, h = typeof WeakRef == "function" && WeakRef.prototype, p = h ? WeakRef.prototype.deref : null, g = Boolean.prototype.valueOf, y = Object.prototype.toString, b = Function.prototype.toString, w = String.prototype.match, _ = String.prototype.slice, C = String.prototype.replace, x = String.prototype.toUpperCase, S = String.prototype.toLowerCase, A = RegExp.prototype.test, I = Array.prototype.concat, M = Array.prototype.join, B = Array.prototype.slice, L = Math.floor, N = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, d = Object.getOwnPropertySymbols, m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, v = typeof Symbol == "function" && typeof Symbol.iterator == "object", k = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === v || !0) ? Symbol.toStringTag : null, O = Object.prototype.propertyIsEnumerable, G = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(Le) {
    return Le.__proto__;
  } : null);
  function H(Le, Ge) {
    if (Le === 1 / 0 || Le === -1 / 0 || Le !== Le || Le && Le > -1e3 && Le < 1e3 || A.call(/e/, Ge))
      return Ge;
    var ft = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof Le == "number") {
      var ot = Le < 0 ? -L(-Le) : L(Le);
      if (ot !== Le) {
        var Ye = String(ot), Je = _.call(Ge, Ye.length + 1);
        return C.call(Ye, ft, "$&_") + "." + C.call(C.call(Je, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return C.call(Ge, ft, "$&_");
  }
  var j = csn, F = j.custom, z = We(F) ? F : null, W = {
    __proto__: null,
    double: '"',
    single: "'"
  }, U = {
    __proto__: null,
    double: /(["\\])/g,
    single: /(['\\])/g
  };
  zoe = function Le(Ge, ft, ot, Ye) {
    var Je = ft || {};
    if (gt(Je, "quoteStyle") && !gt(W, Je.quoteStyle))
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (gt(Je, "maxStringLength") && (typeof Je.maxStringLength == "number" ? Je.maxStringLength < 0 && Je.maxStringLength !== 1 / 0 : Je.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var tt = gt(Je, "customInspect") ? Je.customInspect : !0;
    if (typeof tt != "boolean" && tt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (gt(Je, "indent") && Je.indent !== null && Je.indent !== "	" && !(parseInt(Je.indent, 10) === Je.indent && Je.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (gt(Je, "numericSeparator") && typeof Je.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var kt = Je.numericSeparator;
    if (typeof Ge > "u")
      return "undefined";
    if (Ge === null)
      return "null";
    if (typeof Ge == "boolean")
      return Ge ? "true" : "false";
    if (typeof Ge == "string")
      return lt(Ge, Je);
    if (typeof Ge == "number") {
      if (Ge === 0)
        return 1 / 0 / Ge > 0 ? "0" : "-0";
      var Ft = String(Ge);
      return kt ? H(Ge, Ft) : Ft;
    }
    if (typeof Ge == "bigint") {
      var bt = String(Ge) + "n";
      return kt ? H(Ge, bt) : bt;
    }
    var At = typeof Je.depth > "u" ? 5 : Je.depth;
    if (typeof ot > "u" && (ot = 0), ot >= At && At > 0 && typeof Ge == "object")
      return Y(Ge) ? "[Array]" : "[Object]";
    var vt = ie(Je, ot);
    if (typeof Ye > "u")
      Ye = [];
    else if (ze(Ye, Ge) >= 0)
      return "[Circular]";
    function _t(or, Ht, Mt) {
      if (Ht && (Ye = B.call(Ye), Ye.push(Ht)), Mt) {
        var Qt = {
          depth: Je.depth
        };
        return gt(Je, "quoteStyle") && (Qt.quoteStyle = Je.quoteStyle), Le(or, Qt, ot + 1, Ye);
      }
      return Le(or, Je, ot + 1, Ye);
    }
    if (typeof Ge == "function" && !ce(Ge)) {
      var yt = Ne(Ge), xr = Ke(Ge, _t);
      return "[Function" + (yt ? ": " + yt : " (anonymous)") + "]" + (xr.length > 0 ? " { " + M.call(xr, ", ") + " }" : "");
    }
    if (We(Ge)) {
      var dr = v ? C.call(String(Ge), /^(Symbol\(.*\))_[^)]*$/, "$1") : m.call(Ge);
      return typeof Ge == "object" && !v ? jt(dr) : dr;
    }
    if (Ot(Ge)) {
      for (var Er = "<" + S.call(String(Ge.nodeName)), gr = Ge.attributes || [], pr = 0; pr < gr.length; pr++)
        Er += " " + gr[pr].name + "=" + Z(V(gr[pr].value), "double", Je);
      return Er += ">", Ge.childNodes && Ge.childNodes.length && (Er += "..."), Er += "</" + S.call(String(Ge.nodeName)) + ">", Er;
    }
    if (Y(Ge)) {
      if (Ge.length === 0)
        return "[]";
      var Xr = Ke(Ge, _t);
      return vt && !re(Xr) ? "[" + Ie(Xr, vt) + "]" : "[ " + M.call(Xr, ", ") + " ]";
    }
    if (ee(Ge)) {
      var Yr = Ke(Ge, _t);
      return !("cause" in Error.prototype) && "cause" in Ge && !O.call(Ge, "cause") ? "{ [" + String(Ge) + "] " + M.call(I.call("[cause]: " + _t(Ge.cause), Yr), ", ") + " }" : Yr.length === 0 ? "[" + String(Ge) + "]" : "{ [" + String(Ge) + "] " + M.call(Yr, ", ") + " }";
    }
    if (typeof Ge == "object" && tt) {
      if (z && typeof Ge[z] == "function" && j)
        return j(Ge, { depth: At - ot });
      if (tt !== "symbol" && typeof Ge.inspect == "function")
        return Ge.inspect();
    }
    if (ct(Ge)) {
      var at = [];
      return n && n.call(Ge, function(or, Ht) {
        at.push(_t(Ht, Ge, !0) + " => " + _t(or, Ge));
      }), ne("Map", r.call(Ge), at, vt);
    }
    if (nt(Ge)) {
      var Vt = [];
      return s && s.call(Ge, function(or) {
        Vt.push(_t(or, Ge));
      }), ne("Set", o.call(Ge), Vt, vt);
    }
    if (rt(Ge))
      return Jt("WeakMap");
    if (Rt(Ge))
      return Jt("WeakSet");
    if (qe(Ge))
      return Jt("WeakRef");
    if (Ce(Ge))
      return jt(_t(Number(Ge)));
    if (Fe(Ge))
      return jt(_t(N.call(Ge)));
    if (we(Ge))
      return jt(g.call(Ge));
    if (Se(Ge))
      return jt(_t(String(Ge)));
    if (typeof window < "u" && Ge === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && Ge === globalThis || typeof wl < "u" && Ge === wl)
      return "{ [object globalThis] }";
    if (!ge(Ge) && !ce(Ge)) {
      var er = Ke(Ge, _t), fr = G ? G(Ge) === Object.prototype : Ge instanceof Object || Ge.constructor === Object, tn = Ge instanceof Object ? "" : "null prototype", Kn = !fr && k && Object(Ge) === Ge && k in Ge ? _.call(Ze(Ge), 8, -1) : tn ? "Object" : "", Pr = fr || typeof Ge.constructor != "function" ? "" : Ge.constructor.name ? Ge.constructor.name + " " : "", Pt = Pr + (Kn || tn ? "[" + M.call(I.call([], Kn || [], tn || []), ": ") + "] " : "");
      return er.length === 0 ? Pt + "{}" : vt ? Pt + "{" + Ie(er, vt) + "}" : Pt + "{ " + M.call(er, ", ") + " }";
    }
    return String(Ge);
  };
  function Z(Le, Ge, ft) {
    var ot = ft.quoteStyle || Ge, Ye = W[ot];
    return Ye + Le + Ye;
  }
  function V(Le) {
    return C.call(String(Le), /"/g, "&quot;");
  }
  function Y(Le) {
    return Ze(Le) === "[object Array]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function ge(Le) {
    return Ze(Le) === "[object Date]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function ce(Le) {
    return Ze(Le) === "[object RegExp]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function ee(Le) {
    return Ze(Le) === "[object Error]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function Se(Le) {
    return Ze(Le) === "[object String]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function Ce(Le) {
    return Ze(Le) === "[object Number]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function we(Le) {
    return Ze(Le) === "[object Boolean]" && (!k || !(typeof Le == "object" && k in Le));
  }
  function We(Le) {
    if (v)
      return Le && typeof Le == "object" && Le instanceof Symbol;
    if (typeof Le == "symbol")
      return !0;
    if (!Le || typeof Le != "object" || !m)
      return !1;
    try {
      return m.call(Le), !0;
    } catch {
    }
    return !1;
  }
  function Fe(Le) {
    if (!Le || typeof Le != "object" || !N)
      return !1;
    try {
      return N.call(Le), !0;
    } catch {
    }
    return !1;
  }
  var it = Object.prototype.hasOwnProperty || function(Le) {
    return Le in this;
  };
  function gt(Le, Ge) {
    return it.call(Le, Ge);
  }
  function Ze(Le) {
    return y.call(Le);
  }
  function Ne(Le) {
    if (Le.name)
      return Le.name;
    var Ge = w.call(b.call(Le), /^function\s*([\w$]+)/);
    return Ge ? Ge[1] : null;
  }
  function ze(Le, Ge) {
    if (Le.indexOf)
      return Le.indexOf(Ge);
    for (var ft = 0, ot = Le.length; ft < ot; ft++)
      if (Le[ft] === Ge)
        return ft;
    return -1;
  }
  function ct(Le) {
    if (!r || !Le || typeof Le != "object")
      return !1;
    try {
      r.call(Le);
      try {
        o.call(Le);
      } catch {
        return !0;
      }
      return Le instanceof Map;
    } catch {
    }
    return !1;
  }
  function rt(Le) {
    if (!c || !Le || typeof Le != "object")
      return !1;
    try {
      c.call(Le, c);
      try {
        f.call(Le, f);
      } catch {
        return !0;
      }
      return Le instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function qe(Le) {
    if (!p || !Le || typeof Le != "object")
      return !1;
    try {
      return p.call(Le), !0;
    } catch {
    }
    return !1;
  }
  function nt(Le) {
    if (!o || !Le || typeof Le != "object")
      return !1;
    try {
      o.call(Le);
      try {
        r.call(Le);
      } catch {
        return !0;
      }
      return Le instanceof Set;
    } catch {
    }
    return !1;
  }
  function Rt(Le) {
    if (!f || !Le || typeof Le != "object")
      return !1;
    try {
      f.call(Le, f);
      try {
        c.call(Le, c);
      } catch {
        return !0;
      }
      return Le instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function Ot(Le) {
    return !Le || typeof Le != "object" ? !1 : typeof HTMLElement < "u" && Le instanceof HTMLElement ? !0 : typeof Le.nodeName == "string" && typeof Le.getAttribute == "function";
  }
  function lt(Le, Ge) {
    if (Le.length > Ge.maxStringLength) {
      var ft = Le.length - Ge.maxStringLength, ot = "... " + ft + " more character" + (ft > 1 ? "s" : "");
      return lt(_.call(Le, 0, Ge.maxStringLength), Ge) + ot;
    }
    var Ye = U[Ge.quoteStyle || "single"];
    Ye.lastIndex = 0;
    var Je = C.call(C.call(Le, Ye, "\\$1"), /[\x00-\x1f]/g, mt);
    return Z(Je, "single", Ge);
  }
  function mt(Le) {
    var Ge = Le.charCodeAt(0), ft = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[Ge];
    return ft ? "\\" + ft : "\\x" + (Ge < 16 ? "0" : "") + x.call(Ge.toString(16));
  }
  function jt(Le) {
    return "Object(" + Le + ")";
  }
  function Jt(Le) {
    return Le + " { ? }";
  }
  function ne(Le, Ge, ft, ot) {
    var Ye = ot ? Ie(ft, ot) : M.call(ft, ", ");
    return Le + " (" + Ge + ") {" + Ye + "}";
  }
  function re(Le) {
    for (var Ge = 0; Ge < Le.length; Ge++)
      if (ze(Le[Ge], `
`) >= 0)
        return !1;
    return !0;
  }
  function ie(Le, Ge) {
    var ft;
    if (Le.indent === "	")
      ft = "	";
    else if (typeof Le.indent == "number" && Le.indent > 0)
      ft = M.call(Array(Le.indent + 1), " ");
    else
      return null;
    return {
      base: ft,
      prev: M.call(Array(Ge + 1), ft)
    };
  }
  function Ie(Le, Ge) {
    if (Le.length === 0)
      return "";
    var ft = `
` + Ge.prev + Ge.base;
    return ft + M.call(Le, "," + ft) + `
` + Ge.prev;
  }
  function Ke(Le, Ge) {
    var ft = Y(Le), ot = [];
    if (ft) {
      ot.length = Le.length;
      for (var Ye = 0; Ye < Le.length; Ye++)
        ot[Ye] = gt(Le, Ye) ? Ge(Le[Ye], Le) : "";
    }
    var Je = typeof d == "function" ? d(Le) : [], tt;
    if (v) {
      tt = {};
      for (var kt = 0; kt < Je.length; kt++)
        tt["$" + Je[kt]] = Je[kt];
    }
    for (var Ft in Le)
      gt(Le, Ft) && (ft && String(Number(Ft)) === Ft && Ft < Le.length || v && tt["$" + Ft] instanceof Symbol || (A.call(/[^\w$]/, Ft) ? ot.push(Ge(Ft, Le) + ": " + Ge(Le[Ft], Le)) : ot.push(Ft + ": " + Ge(Le[Ft], Le))));
    if (typeof d == "function")
      for (var bt = 0; bt < Je.length; bt++)
        O.call(Le, Je[bt]) && ot.push("[" + Ge(Je[bt]) + "]: " + Ge(Le[Je[bt]], Le));
    return ot;
  }
  return zoe;
}
var Goe, EFe;
function dsn() {
  if (EFe) return Goe;
  EFe = 1;
  var t = /* @__PURE__ */ Sbe(), e = osn(), r = /* @__PURE__ */ usn(), n = /* @__PURE__ */ xP(), a = t("%WeakMap%", !0), i = t("%Map%", !0), o = e("WeakMap.prototype.get", !0), s = e("WeakMap.prototype.set", !0), l = e("WeakMap.prototype.has", !0), c = e("Map.prototype.get", !0), u = e("Map.prototype.set", !0), f = e("Map.prototype.has", !0), h = function(b, w) {
    for (var _ = b, C; (C = _.next) !== null; _ = C)
      if (C.key === w)
        return _.next = C.next, C.next = /** @type {NonNullable<typeof list.next>} */
        b.next, b.next = C, C;
  }, p = function(b, w) {
    var _ = h(b, w);
    return _ && _.value;
  }, g = function(b, w, _) {
    var C = h(b, w);
    C ? C.value = _ : b.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: w,
      next: b.next,
      value: _
    };
  }, y = function(b, w) {
    return !!h(b, w);
  };
  return Goe = function() {
    var w, _, C, x = {
      assert: function(S) {
        if (!x.has(S))
          throw new n("Side channel does not contain " + r(S));
      },
      get: function(S) {
        if (a && S && (typeof S == "object" || typeof S == "function")) {
          if (w)
            return o(w, S);
        } else if (i) {
          if (_)
            return c(_, S);
        } else if (C)
          return p(C, S);
      },
      has: function(S) {
        if (a && S && (typeof S == "object" || typeof S == "function")) {
          if (w)
            return l(w, S);
        } else if (i) {
          if (_)
            return f(_, S);
        } else if (C)
          return y(C, S);
        return !1;
      },
      set: function(S, A) {
        a && S && (typeof S == "object" || typeof S == "function") ? (w || (w = new a()), s(w, S, A)) : i ? (_ || (_ = new i()), u(_, S, A)) : (C || (C = { key: {}, next: null }), g(C, S, A));
      }
    };
    return x;
  }, Goe;
}
var Woe, IFe;
function _be() {
  if (IFe) return Woe;
  IFe = 1;
  var t = String.prototype.replace, e = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return Woe = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return t.call(n, e, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, Woe;
}
var Hoe, MFe;
function Vmt() {
  if (MFe) return Hoe;
  MFe = 1;
  var t = _be(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var y = [], b = 0; b < 256; ++b)
      y.push("%" + ((b < 16 ? "0" : "") + b.toString(16)).toUpperCase());
    return y;
  }(), a = function(b) {
    for (; b.length > 1; ) {
      var w = b.pop(), _ = w.obj[w.prop];
      if (r(_)) {
        for (var C = [], x = 0; x < _.length; ++x)
          typeof _[x] < "u" && C.push(_[x]);
        w.obj[w.prop] = C;
      }
    }
  }, i = function(b, w) {
    for (var _ = w && w.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, C = 0; C < b.length; ++C)
      typeof b[C] < "u" && (_[C] = b[C]);
    return _;
  }, o = function y(b, w, _) {
    if (!w)
      return b;
    if (typeof w != "object") {
      if (r(b))
        b.push(w);
      else if (b && typeof b == "object")
        (_ && (_.plainObjects || _.allowPrototypes) || !e.call(Object.prototype, w)) && (b[w] = !0);
      else
        return [b, w];
      return b;
    }
    if (!b || typeof b != "object")
      return [b].concat(w);
    var C = b;
    return r(b) && !r(w) && (C = i(b, _)), r(b) && r(w) ? (w.forEach(function(x, S) {
      if (e.call(b, S)) {
        var A = b[S];
        A && typeof A == "object" && x && typeof x == "object" ? b[S] = y(A, x, _) : b.push(x);
      } else
        b[S] = x;
    }), b) : Object.keys(w).reduce(function(x, S) {
      var A = w[S];
      return e.call(x, S) ? x[S] = y(x[S], A, _) : x[S] = A, x;
    }, C);
  }, s = function(b, w) {
    return Object.keys(w).reduce(function(_, C) {
      return _[C] = w[C], _;
    }, b);
  }, l = function(y, b, w) {
    var _ = y.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return _.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(_);
    } catch {
      return _;
    }
  }, c = function(b, w, _, C, x) {
    if (b.length === 0)
      return b;
    var S = b;
    if (typeof b == "symbol" ? S = Symbol.prototype.toString.call(b) : typeof b != "string" && (S = String(b)), _ === "iso-8859-1")
      return escape(S).replace(/%u[0-9a-f]{4}/gi, function(B) {
        return "%26%23" + parseInt(B.slice(2), 16) + "%3B";
      });
    for (var A = "", I = 0; I < S.length; ++I) {
      var M = S.charCodeAt(I);
      if (M === 45 || M === 46 || M === 95 || M === 126 || M >= 48 && M <= 57 || M >= 65 && M <= 90 || M >= 97 && M <= 122 || x === t.RFC1738 && (M === 40 || M === 41)) {
        A += S.charAt(I);
        continue;
      }
      if (M < 128) {
        A = A + n[M];
        continue;
      }
      if (M < 2048) {
        A = A + (n[192 | M >> 6] + n[128 | M & 63]);
        continue;
      }
      if (M < 55296 || M >= 57344) {
        A = A + (n[224 | M >> 12] + n[128 | M >> 6 & 63] + n[128 | M & 63]);
        continue;
      }
      I += 1, M = 65536 + ((M & 1023) << 10 | S.charCodeAt(I) & 1023), A += n[240 | M >> 18] + n[128 | M >> 12 & 63] + n[128 | M >> 6 & 63] + n[128 | M & 63];
    }
    return A;
  }, u = function(b) {
    for (var w = [{ obj: { o: b }, prop: "o" }], _ = [], C = 0; C < w.length; ++C)
      for (var x = w[C], S = x.obj[x.prop], A = Object.keys(S), I = 0; I < A.length; ++I) {
        var M = A[I], B = S[M];
        typeof B == "object" && B !== null && _.indexOf(B) === -1 && (w.push({ obj: S, prop: M }), _.push(B));
      }
    return a(w), b;
  }, f = function(b) {
    return Object.prototype.toString.call(b) === "[object RegExp]";
  }, h = function(b) {
    return !b || typeof b != "object" ? !1 : !!(b.constructor && b.constructor.isBuffer && b.constructor.isBuffer(b));
  }, p = function(b, w) {
    return [].concat(b, w);
  }, g = function(b, w) {
    if (r(b)) {
      for (var _ = [], C = 0; C < b.length; C += 1)
        _.push(w(b[C]));
      return _;
    }
    return w(b);
  };
  return Hoe = {
    arrayToObject: i,
    assign: s,
    combine: p,
    compact: u,
    decode: l,
    encode: c,
    isBuffer: h,
    isRegExp: f,
    maybeMap: g,
    merge: o
  }, Hoe;
}
var Uoe, PFe;
function fsn() {
  if (PFe) return Uoe;
  PFe = 1;
  var t = dsn(), e = Vmt(), r = _be(), n = Object.prototype.hasOwnProperty, a = {
    brackets: function(b) {
      return b + "[]";
    },
    comma: "comma",
    indices: function(b, w) {
      return b + "[" + w + "]";
    },
    repeat: function(b) {
      return b;
    }
  }, i = Array.isArray, o = Array.prototype.push, s = function(y, b) {
    o.apply(y, i(b) ? b : [b]);
  }, l = Date.prototype.toISOString, c = r.default, u = {
    addQueryPrefix: !1,
    allowDots: !1,
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encoder: e.encode,
    encodeValuesOnly: !1,
    format: c,
    formatter: r.formatters[c],
    // deprecated
    indices: !1,
    serializeDate: function(b) {
      return l.call(b);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, f = function(b) {
    return typeof b == "string" || typeof b == "number" || typeof b == "boolean" || typeof b == "symbol" || typeof b == "bigint";
  }, h = {}, p = function y(b, w, _, C, x, S, A, I, M, B, L, N, d, m, v, k) {
    for (var O = b, G = k, H = 0, j = !1; (G = G.get(h)) !== void 0 && !j; ) {
      var F = G.get(b);
      if (H += 1, typeof F < "u") {
        if (F === H)
          throw new RangeError("Cyclic object value");
        j = !0;
      }
      typeof G.get(h) > "u" && (H = 0);
    }
    if (typeof I == "function" ? O = I(w, O) : O instanceof Date ? O = L(O) : _ === "comma" && i(O) && (O = e.maybeMap(O, function(Ce) {
      return Ce instanceof Date ? L(Ce) : Ce;
    })), O === null) {
      if (x)
        return A && !m ? A(w, u.encoder, v, "key", N) : w;
      O = "";
    }
    if (f(O) || e.isBuffer(O)) {
      if (A) {
        var z = m ? w : A(w, u.encoder, v, "key", N);
        return [d(z) + "=" + d(A(O, u.encoder, v, "value", N))];
      }
      return [d(w) + "=" + d(String(O))];
    }
    var W = [];
    if (typeof O > "u")
      return W;
    var U;
    if (_ === "comma" && i(O))
      m && A && (O = e.maybeMap(O, A)), U = [{ value: O.length > 0 ? O.join(",") || null : void 0 }];
    else if (i(I))
      U = I;
    else {
      var Z = Object.keys(O);
      U = M ? Z.sort(M) : Z;
    }
    for (var V = C && i(O) && O.length === 1 ? w + "[]" : w, Y = 0; Y < U.length; ++Y) {
      var ge = U[Y], ce = typeof ge == "object" && typeof ge.value < "u" ? ge.value : O[ge];
      if (!(S && ce === null)) {
        var ee = i(O) ? typeof _ == "function" ? _(V, ge) : V : V + (B ? "." + ge : "[" + ge + "]");
        k.set(b, H);
        var Se = t();
        Se.set(h, k), s(W, y(
          ce,
          ee,
          _,
          C,
          x,
          S,
          _ === "comma" && m && i(O) ? null : A,
          I,
          M,
          B,
          L,
          N,
          d,
          m,
          v,
          Se
        ));
      }
    }
    return W;
  }, g = function(b) {
    if (!b)
      return u;
    if (b.encoder !== null && typeof b.encoder < "u" && typeof b.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var w = b.charset || u.charset;
    if (typeof b.charset < "u" && b.charset !== "utf-8" && b.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var _ = r.default;
    if (typeof b.format < "u") {
      if (!n.call(r.formatters, b.format))
        throw new TypeError("Unknown format option provided.");
      _ = b.format;
    }
    var C = r.formatters[_], x = u.filter;
    return (typeof b.filter == "function" || i(b.filter)) && (x = b.filter), {
      addQueryPrefix: typeof b.addQueryPrefix == "boolean" ? b.addQueryPrefix : u.addQueryPrefix,
      allowDots: typeof b.allowDots > "u" ? u.allowDots : !!b.allowDots,
      charset: w,
      charsetSentinel: typeof b.charsetSentinel == "boolean" ? b.charsetSentinel : u.charsetSentinel,
      delimiter: typeof b.delimiter > "u" ? u.delimiter : b.delimiter,
      encode: typeof b.encode == "boolean" ? b.encode : u.encode,
      encoder: typeof b.encoder == "function" ? b.encoder : u.encoder,
      encodeValuesOnly: typeof b.encodeValuesOnly == "boolean" ? b.encodeValuesOnly : u.encodeValuesOnly,
      filter: x,
      format: _,
      formatter: C,
      serializeDate: typeof b.serializeDate == "function" ? b.serializeDate : u.serializeDate,
      skipNulls: typeof b.skipNulls == "boolean" ? b.skipNulls : u.skipNulls,
      sort: typeof b.sort == "function" ? b.sort : null,
      strictNullHandling: typeof b.strictNullHandling == "boolean" ? b.strictNullHandling : u.strictNullHandling
    };
  };
  return Uoe = function(y, b) {
    var w = y, _ = g(b), C, x;
    typeof _.filter == "function" ? (x = _.filter, w = x("", w)) : i(_.filter) && (x = _.filter, C = x);
    var S = [];
    if (typeof w != "object" || w === null)
      return "";
    var A;
    b && b.arrayFormat in a ? A = b.arrayFormat : b && "indices" in b ? A = b.indices ? "indices" : "repeat" : A = "indices";
    var I = a[A];
    if (b && "commaRoundTrip" in b && typeof b.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var M = I === "comma" && b && b.commaRoundTrip;
    C || (C = Object.keys(w)), _.sort && C.sort(_.sort);
    for (var B = t(), L = 0; L < C.length; ++L) {
      var N = C[L];
      _.skipNulls && w[N] === null || s(S, p(
        w[N],
        N,
        I,
        M,
        _.strictNullHandling,
        _.skipNulls,
        _.encode ? _.encoder : null,
        _.filter,
        _.sort,
        _.allowDots,
        _.serializeDate,
        _.format,
        _.formatter,
        _.encodeValuesOnly,
        _.charset,
        B
      ));
    }
    var d = S.join(_.delimiter), m = _.addQueryPrefix === !0 ? "?" : "";
    return _.charsetSentinel && (_.charset === "iso-8859-1" ? m += "utf8=%26%2310003%3B&" : m += "utf8=%E2%9C%93&"), d.length > 0 ? m + d : "";
  }, Uoe;
}
var Voe, RFe;
function hsn() {
  if (RFe) return Voe;
  RFe = 1;
  var t = Vmt(), e = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decoder: t.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictNullHandling: !1
  }, a = function(h) {
    return h.replace(/&#(\d+);/g, function(p, g) {
      return String.fromCharCode(parseInt(g, 10));
    });
  }, i = function(h, p) {
    return h && typeof h == "string" && p.comma && h.indexOf(",") > -1 ? h.split(",") : h;
  }, o = "utf8=%26%2310003%3B", s = "utf8=%E2%9C%93", l = function(p, g) {
    var y = { __proto__: null }, b = g.ignoreQueryPrefix ? p.replace(/^\?/, "") : p, w = g.parameterLimit === 1 / 0 ? void 0 : g.parameterLimit, _ = b.split(g.delimiter, w), C = -1, x, S = g.charset;
    if (g.charsetSentinel)
      for (x = 0; x < _.length; ++x)
        _[x].indexOf("utf8=") === 0 && (_[x] === s ? S = "utf-8" : _[x] === o && (S = "iso-8859-1"), C = x, x = _.length);
    for (x = 0; x < _.length; ++x)
      if (x !== C) {
        var A = _[x], I = A.indexOf("]="), M = I === -1 ? A.indexOf("=") : I + 1, B, L;
        M === -1 ? (B = g.decoder(A, n.decoder, S, "key"), L = g.strictNullHandling ? null : "") : (B = g.decoder(A.slice(0, M), n.decoder, S, "key"), L = t.maybeMap(
          i(A.slice(M + 1), g),
          function(N) {
            return g.decoder(N, n.decoder, S, "value");
          }
        )), L && g.interpretNumericEntities && S === "iso-8859-1" && (L = a(L)), A.indexOf("[]=") > -1 && (L = r(L) ? [L] : L), e.call(y, B) ? y[B] = t.combine(y[B], L) : y[B] = L;
      }
    return y;
  }, c = function(h, p, g, y) {
    for (var b = y ? p : i(p, g), w = h.length - 1; w >= 0; --w) {
      var _, C = h[w];
      if (C === "[]" && g.parseArrays)
        _ = [].concat(b);
      else {
        _ = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var x = C.charAt(0) === "[" && C.charAt(C.length - 1) === "]" ? C.slice(1, -1) : C, S = parseInt(x, 10);
        !g.parseArrays && x === "" ? _ = { 0: b } : !isNaN(S) && C !== x && String(S) === x && S >= 0 && g.parseArrays && S <= g.arrayLimit ? (_ = [], _[S] = b) : x !== "__proto__" && (_[x] = b);
      }
      b = _;
    }
    return b;
  }, u = function(p, g, y, b) {
    if (p) {
      var w = y.allowDots ? p.replace(/\.([^.[]+)/g, "[$1]") : p, _ = /(\[[^[\]]*])/, C = /(\[[^[\]]*])/g, x = y.depth > 0 && _.exec(w), S = x ? w.slice(0, x.index) : w, A = [];
      if (S) {
        if (!y.plainObjects && e.call(Object.prototype, S) && !y.allowPrototypes)
          return;
        A.push(S);
      }
      for (var I = 0; y.depth > 0 && (x = C.exec(w)) !== null && I < y.depth; ) {
        if (I += 1, !y.plainObjects && e.call(Object.prototype, x[1].slice(1, -1)) && !y.allowPrototypes)
          return;
        A.push(x[1]);
      }
      return x && A.push("[" + w.slice(x.index) + "]"), c(A, g, y, b);
    }
  }, f = function(p) {
    if (!p)
      return n;
    if (p.decoder !== null && p.decoder !== void 0 && typeof p.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof p.charset < "u" && p.charset !== "utf-8" && p.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var g = typeof p.charset > "u" ? n.charset : p.charset;
    return {
      allowDots: typeof p.allowDots > "u" ? n.allowDots : !!p.allowDots,
      allowPrototypes: typeof p.allowPrototypes == "boolean" ? p.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof p.allowSparse == "boolean" ? p.allowSparse : n.allowSparse,
      arrayLimit: typeof p.arrayLimit == "number" ? p.arrayLimit : n.arrayLimit,
      charset: g,
      charsetSentinel: typeof p.charsetSentinel == "boolean" ? p.charsetSentinel : n.charsetSentinel,
      comma: typeof p.comma == "boolean" ? p.comma : n.comma,
      decoder: typeof p.decoder == "function" ? p.decoder : n.decoder,
      delimiter: typeof p.delimiter == "string" || t.isRegExp(p.delimiter) ? p.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof p.depth == "number" || p.depth === !1 ? +p.depth : n.depth,
      ignoreQueryPrefix: p.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof p.interpretNumericEntities == "boolean" ? p.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof p.parameterLimit == "number" ? p.parameterLimit : n.parameterLimit,
      parseArrays: p.parseArrays !== !1,
      plainObjects: typeof p.plainObjects == "boolean" ? p.plainObjects : n.plainObjects,
      strictNullHandling: typeof p.strictNullHandling == "boolean" ? p.strictNullHandling : n.strictNullHandling
    };
  };
  return Voe = function(h, p) {
    var g = f(p);
    if (h === "" || h === null || typeof h > "u")
      return g.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var y = typeof h == "string" ? l(h, g) : h, b = g.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, w = Object.keys(y), _ = 0; _ < w.length; ++_) {
      var C = w[_], x = u(C, y[C], g, typeof h == "string");
      b = t.merge(b, x, g);
    }
    return g.allowSparse === !0 ? b : t.compact(b);
  }, Voe;
}
var qoe, OFe;
function psn() {
  if (OFe) return qoe;
  OFe = 1;
  var t = fsn(), e = hsn(), r = _be();
  return qoe = {
    formats: r,
    parse: e,
    stringify: t
  }, qoe;
}
var msn = psn();
const gsn = /* @__PURE__ */ Gi(msn), vsn = ({
  conversationId: t,
  sessionId: e
}) => {
  const r = gsn.stringify(
    {
      conversationId: t,
      sessionId: e
    },
    {
      addQueryPrefix: !0
    }
  ), n = `${window.location.origin}/${f6t.ticketSubmission.slice(
    1
  )}${r}`;
  window.location.assign(n);
};
var Koe = {}, ysn = ds.span(us({ "& > button": { zIndex: 1 }, "& > button:hover, & > button[aria-pressed=true]": { zIndex: 2 }, "& > button:focus": { zIndex: 3 }, "& > button:disabled": { zIndex: 0 }, "& > button:first-of-type": { borderTopRightRadius: 0, borderBottomRightRadius: 0 }, "& > button:not(:first-of-type):not(:last-of-type)": { borderRadius: 0, marginLeft: "1px" }, "& > button:last-of-type": { marginLeft: "1px", borderTopLeftRadius: 0, borderBottomLeftRadius: 0 } })), bsn = ds.span(us({ display: "flex", columnGap: "space40" })), qmt = P.forwardRef(({ element: t = "BUTTON_GROUP", children: e, attached: r = !1, justifyContent: n = "flex-start", ...a }, i) => P.createElement(ht, { ...Xt(a), as: r ? ysn : bsn, ref: i, element: t, display: "inline-flex", flexWrap: r ? "nowrap" : "wrap", justifyContent: r ? "flex-start" : n, rowGap: "space40", role: "group" }, e));
qmt.displayName = "ButtonGroup";
const xsn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ButtonGroup: qmt
}, Symbol.toStringTag, { value: "Module" })), Csn = /* @__PURE__ */ aa(xsn);
var BFe;
function wsn() {
  return BFe || (BFe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Csn;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Koe)), Koe;
}
var Ssn = /* @__PURE__ */ wsn(), zfe = /* @__PURE__ */ ((t) => (t.Monkey = "Monkey", t.Console = "Console", t.OneAdmin = "OneAdmin", t.OneSupportCenter = "OneSupportCenter", t.WiseOwl = "WiseOwl", t.Unknown = "Unknown", t))(zfe || {}), vI = /* @__PURE__ */ ((t) => (t.Production = "Production", t.Stage = "Stage", t.Dev = "Dev", t.Local = "Local", t))(vI || {}), Gfe = /* @__PURE__ */ ((t) => (t.us1 = "us1", t.us2 = "us2", t.au1 = "au1", t.ie1 = "ie1", t.Unknown = "Unknown", t))(Gfe || {});
function NFe(t) {
  switch (t) {
    case "admin":
    case "oneadmin":
    case "oneadmin.internal":
      return "OneAdmin";
    case "console":
      return "Console";
    case "monkey":
      return "Monkey";
    case "help":
      return "OneSupportCenter";
    case "wiseowl":
      return "OneSupportCenter";
    default:
      return "Unknown";
  }
}
function _sn(t) {
  switch (t) {
    case "dev":
      return "Dev";
    case "local":
      return "Local";
    case "stage":
      return "Stage";
    default:
      return "Production";
  }
}
function $Fe(t) {
  switch (t) {
    case "us1":
      return "us1";
    case "us2":
      return "us2";
    case "au1":
      return "au1";
    case "ie1":
      return "ie1";
    // default to us1 if no region is given.
    default:
      return "us1";
  }
}
const ksn = (t) => {
  if (t.match(/localhost/))
    return {
      runtime: zfe.Unknown,
      region: Gfe.Unknown,
      environment: vI.Local
    };
  const r = /(console|monkey|oneadmin\.internal|oneadmin|help|admin|wiseowl)\.(dev|stage|local)-?(us1|us2|ie1|au1)?\.twilio/, n = t.match(r);
  if (n) {
    const [, o, s, l] = n;
    return {
      runtime: NFe(o),
      environment: _sn(s),
      region: $Fe(l)
    };
  }
  const a = /(console|monkey|oneadmin\.internal|oneadmin|help|admin|wiseowl)\.?(ie1|au1|us1|us2)?\.twilio/, i = t.match(a);
  if (i) {
    const [, o, s] = i;
    return {
      runtime: NFe(o),
      environment: vI.Production,
      region: $Fe(s)
    };
  }
  return {
    runtime: zfe.Unknown,
    region: Gfe.Unknown
  };
}, Asn = "http", DFe = "https";
function Tsn(t) {
  return t.protocol ? t.protocol : t.environment && t.environment === vI.Local ? Asn : DFe;
}
function Esn(t) {
  if (t.environment && t.environment !== vI.Production)
    return t.environment.toLowerCase();
}
function Isn(t, e) {
  return !t && !e ? "" : t && !e ? `${t}.` : !t && e ? `${e}.` : `${t}-${e}.`;
}
function Msn(t) {
  const e = Tsn(t), r = t.api ? `${t.api}.` : "www.", n = Esn(t), a = t.region, i = Isn(n, a);
  return `${e}://${r}${i}twilio.com`;
}
const Psn = () => {
  const { environment: t } = ksn(window.location.hostname);
  return Msn({
    environment: t
  });
}, Kmt = Psn(), Rsn = {
  CNB_GENERAL_RPC: `${Kmt}/console/api/navigation/rpc`
}, Osn = "/console-zen", Bsn = async (t, e) => {
  const r = e || `${Osn}/${window.location}`, n = new URL(t, Kmt), a = `${Rsn.CNB_GENERAL_RPC}/public?name=deeplinkToken&args=%7B"url"%3A"${r}"%7D`;
  try {
    const i = await fetch(a, {
      credentials: "include"
    });
    if (i != null && i.ok && (i == null ? void 0 : i.status) === 200) {
      const { result: o } = await (i == null ? void 0 : i.json());
      n.search = o == null ? void 0 : o.queryString;
    }
  } catch (i) {
    console.error(i);
  }
  return window.location.assign(n.toString());
}, Nsn = async ({
  authLink: t,
  path: e = "/",
  hostname: r = window.location.hostname
}) => {
  const n = `/post-auth-redirect/${r}${e}`;
  await Bsn(t, n);
}, kbe = {
  INTERRUPTED_CHAT_ID: "interruptedchatid"
}, LFe = {
  LOGIN: "login",
  SIGN_UP: "try-twilio"
}, GF = {
  CANT_LOGIN: "Can't Login?",
  SUBMIT_TICKET: "Submit a ticket without logging in",
  LOGIN: "Login",
  SIGN_UP: "Sign Up"
}, { hostName: $sn } = TI(), Dsn = ({ element: t }) => {
  const { conversationId: e } = Gn((i) => i.conversation), [r, n] = uve(
    kbe.INTERRUPTED_CHAT_ID,
    null
  ), a = async (i, o) => {
    e && n(e), await Nsn({
      authLink: `/${i}`,
      hostname: $sn
    });
  };
  return /* @__PURE__ */ R.jsxs(Ssn.ButtonGroup, { element: t, children: [
    /* @__PURE__ */ R.jsx(
      zi.Button,
      {
        variant: "secondary",
        size: "rounded_small",
        onClick: async () => await a(LFe.LOGIN),
        children: GF.LOGIN
      }
    ),
    /* @__PURE__ */ R.jsx(
      zi.Button,
      {
        variant: "secondary",
        size: "rounded_small",
        onClick: async () => await a(LFe.SIGN_UP),
        children: GF.SIGN_UP
      }
    )
  ] });
}, Lsn = () => {
  const t = Gn((n) => n.config.user), e = Gn(
    (n) => n.conversation.conversationId
  ), r = () => {
    e && t.sessionId ? vsn({
      conversationId: e,
      sessionId: t.sessionId
    }) : console.error(
      "Cannot submit ticket: missing conversationId or sessionId"
    );
  };
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(Dsn, { element: "WISE_OWL_BUTTON_GROUP_BLOCK" }),
    /* @__PURE__ */ R.jsxs(
      ar.Box,
      {
        element: "WISE_OWL_CANNOT_LOGIN_CTA_BLOCK",
        marginTop: "space50",
        border: "initial",
        borderStyle: "solid",
        borderWidth: "borderWidth10",
        borderColor: "colorBorderDecorative10Weaker",
        padding: "space40",
        borderRadius: "borderRadius20",
        display: "flex",
        flexDirection: "row",
        children: [
          /* @__PURE__ */ R.jsx(ar.Box, { marginRight: "space40", children: /* @__PURE__ */ R.jsx(jmt, { decorative: !0, title: "Can't login?" }) }),
          /* @__PURE__ */ R.jsx(pf.Text, { as: "div", marginRight: "space20", children: GF.CANT_LOGIN }),
          /* @__PURE__ */ R.jsx(ar.Box, { as: "div", children: /* @__PURE__ */ R.jsx(zi.Button, { onClick: r, variant: "link", children: GF.SUBMIT_TICKET }) })
        ]
      }
    )
  ] });
}, jsn = ({ message: t, username: e }) => /* @__PURE__ */ R.jsxs(_r, { display: "flex", flexDirection: "column", rowGap: "space80", children: [
  /* @__PURE__ */ R.jsx(ez, { variant: "user", children: /* @__PURE__ */ R.jsx(tz, { "aria-label": "You said", children: e }) }),
  /* @__PURE__ */ R.jsx(bx, { markdown: t.content })
] }), Fsn = ({
  messageLogIndex: t,
  messageLogLength: e,
  message: r,
  showAllCitations: n,
  setShowAllCitations: a,
  isCanvasOpen: i,
  applicationDisplayName: o
}) => /* @__PURE__ */ R.jsxs(_r, { display: "flex", flexDirection: "column", rowGap: "space80", children: [
  /* @__PURE__ */ R.jsx(ez, { variant: "bot", children: /* @__PURE__ */ R.jsx(tz, { "aria-label": "AI said", children: o }) }),
  r.parts.length > 0 && /* @__PURE__ */ R.jsx(_r, { display: "flex", flexDirection: "column", rowGap: "space80", children: r.parts.map((s, l) => {
    var c;
    if (s.type === e0.MARKDOWN)
      return /* @__PURE__ */ R.jsx(_r, { children: /* @__PURE__ */ R.jsx(bx, { markdown: s.content }, l) }, l);
    if (s.type === e0.BLOCK) {
      const u = s.block.displayPersistence === "transient", f = t === e - 1;
      return !u || u && f ? /* @__PURE__ */ R.jsx(gP, { block: s.block }, l) : null;
    }
    if (s.type === e0.GATE)
      return /* @__PURE__ */ R.jsx(Lsn, {}, l);
    if (s.type === e0.CANVAS_PREVIEW)
      return /* @__PURE__ */ R.jsx(
        Eon,
        {
          variant: i ? "compact" : "default"
        }
      );
    if (s.type === e0.TRANSFER_CONVERSATION_TO_HUMAN)
      return /* @__PURE__ */ R.jsx(
        Oon,
        {
          loading: s.data.loading,
          data: (c = s.data) == null ? void 0 : c.options
        },
        l
      );
    throw new Error("Unsupported content type");
  }) }),
  r.complete && r.retrievedKnowledge.length > 0 && /* @__PURE__ */ R.jsx(
    Jht,
    {
      retrievedKnowledge: r.retrievedKnowledge,
      showAllCitations: n,
      setShowAllCitations: a
    }
  ),
  r.complete && /* @__PURE__ */ R.jsx(sen, { message: r })
] }), zsn = ({
  messageLogIndex: t,
  messageLogLength: e,
  message: r,
  username: n,
  showAllCitations: a,
  setShowAllCitations: i,
  isCanvasOpen: o,
  applicationDisplayName: s
}) => r.role === Mu.USER ? /* @__PURE__ */ R.jsx(jsn, { message: r, username: n }) : /* @__PURE__ */ R.jsx(
  Fsn,
  {
    messageLogIndex: t,
    messageLogLength: e,
    message: r,
    showAllCitations: a,
    setShowAllCitations: i,
    isCanvasOpen: o,
    applicationDisplayName: s
  }
), Abe = () => {
  const t = Gn((i) => i.config.applicationId), { requestTransformer: e } = Ja(), {
    data: { application: r } = {},
    isLoading: n,
    isError: a
  } = WI({
    applicationId: t,
    requestTransformer: e
  });
  return {
    application: r,
    isLoading: n,
    isError: a
  };
}, Zmt = ({
  messageLogIndex: t,
  messageLogLength: e,
  message: r
}) => {
  const n = Gn((u) => u.config.user), [a, i] = Yt(!1), o = `${n.firstName} ${n.lastName}`, s = Gn(
    (u) => u.conversation.isCanvasOpen
  ), { application: l } = Abe(), c = (l == null ? void 0 : l.ui.displayName) ?? "";
  return /* @__PURE__ */ R.jsx(
    zsn,
    {
      messageLogIndex: t,
      messageLogLength: e,
      message: r,
      username: o,
      showAllCitations: a,
      setShowAllCitations: i,
      isCanvasOpen: s,
      applicationDisplayName: c
    }
  );
}, Gsn = () => {
  const { sendMessage: t } = qM(), e = Gn(
    (a) => a.conversation.partialUserMessage
  ), r = Gn(
    (a) => a.conversation.retryAttempts
  ), n = () => {
    e && t({ message: e.content });
  };
  return /* @__PURE__ */ R.jsxs(
    is,
    {
      padding: "space40",
      backgroundColor: "colorBackgroundDestructiveWeaker",
      display: "flex",
      alignItems: "center",
      columnGap: "space40",
      children: [
        /* @__PURE__ */ R.jsx(_r, { children: "Something went wrong." }),
        /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
        r > 1 && /* @__PURE__ */ R.jsx(as, { variant: "destructive_secondary", children: "Submit a Ticket" }),
        /* @__PURE__ */ R.jsx(as, { variant: "destructive", onClick: n, children: "Retry" })
      ]
    }
  );
}, Wsn = ({
  messages: t,
  loadingMessages: e,
  conversationStatus: r
}) => {
  const n = e.slice(-3);
  return /* @__PURE__ */ R.jsxs(
    _r,
    {
      display: "flex",
      flexDirection: "column",
      rowGap: "space80",
      paddingX: "space80",
      paddingY: "space40",
      children: [
        t.map((a, i) => /* @__PURE__ */ R.jsx(Zmt, { messageLogIndex: i, messageLogLength: t.length, message: a }, i)),
        r === N7.Error && /* @__PURE__ */ R.jsx(Gsn, {}),
        e.length > 0 && /* @__PURE__ */ R.jsx(_r, { display: "flex", flexDirection: "column", rowGap: "space10", children: n.map((a, i) => /* @__PURE__ */ R.jsx(
          Oct,
          {
            message: a,
            isComplete: i !== n.length - 1
          },
          `${i}-${a}`
        )) }),
        /* @__PURE__ */ R.jsx(_r, { display: "flex", flexDirection: "column", rowGap: "space10", children: /* @__PURE__ */ R.jsx(ght, {}) })
      ]
    }
  );
}, Hsn = ({
  value: t,
  setValue: e,
  isCanvasOpen: r,
  onCloseCanvas: n,
  isSaved: a
}) => /* @__PURE__ */ R.jsx(Jst, { open: r, onOpenChange: n, children: /* @__PURE__ */ R.jsx(cve, { showDialogClose: !1, fullscreen: !0, children: /* @__PURE__ */ R.jsxs(
  _r,
  {
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateColumns: "4fr 6fr",
    children: [
      /* @__PURE__ */ R.jsx(
        _r,
        {
          borderRightWidth: "borderWidth10",
          paddingX: "space40",
          style: {
            boxShadow: "inset -15px 0px 15px -15px lightgray"
          },
          children: /* @__PURE__ */ R.jsx(Jmt, { inCanvas: !0 })
        }
      ),
      /* @__PURE__ */ R.jsx(_r, { display: "flex", flexDirection: "column", children: /* @__PURE__ */ R.jsx(
        Dmt,
        {
          value: t,
          setValue: e,
          isSaved: a,
          onClose: n
        }
      ) })
    ]
  }
) }) }), Usn = () => {
  const t = s2(), e = Gn(
    (y) => y.conversation.isCanvasOpen
  ), r = Gn(
    (y) => y.conversation.conversationId
  ), [n] = uPt(), a = Gn((y) => y.conversation.canvasId), i = Gn(
    (y) => y.conversation.canvasContents
  ), [o, s] = Yt(!0);
  if (!r)
    return null;
  const { requestTransformer: l } = Ja(), c = Zt(i);
  Ut(() => {
    c.current = i;
  }, [i]);
  const u = Zt(a);
  Ut(() => {
    u.current = a;
  }, [a]);
  const f = Zt(n);
  Ut(() => {
    f.current = n;
  }, [n]);
  const h = Zt(
    $2e.throttle(async () => {
      u.current && (await f.current({
        canvasId: u.current,
        text: c.current,
        requestTransformer: l
      }), s(!0));
    }, 1500)
  ).current;
  Ut(() => () => {
    h.cancel();
  }, [h]);
  const p = (y) => {
    t(g1e(y)), s(!1), h();
  }, g = () => {
    t(k_.util.invalidateTags(["Conversation"])), t(oz(!1));
  };
  return /* @__PURE__ */ R.jsx(
    Hsn,
    {
      isCanvasOpen: e,
      onCloseCanvas: g,
      value: i,
      setValue: p,
      isSaved: o
    }
  );
}, Vsn = ({
  inputValue: t,
  setInputValue: e,
  messages: r,
  loadingMessages: n,
  isLoading: a,
  onSubmit: i,
  scrollableRef: o,
  isScrolledToBottom: s,
  scrollToBottom: l,
  conversationStatus: c,
  inCanvas: u,
  isCanvasEnabled: f,
  isPromptLibraryEnabled: h,
  inputPlaceholder: p
}) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  !u && /* @__PURE__ */ R.jsx(Usn, {}),
  /* @__PURE__ */ R.jsxs(
    _r,
    {
      id: "conversation-display",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      paddingY: "space40",
      children: [
        /* @__PURE__ */ R.jsx(
          _r,
          {
            id: "conversation-display",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            paddingY: "space40",
            children: /* @__PURE__ */ R.jsx(
              _r,
              {
                ref: o,
                flexGrow: 1,
                flexBasis: 0,
                className: "hide-scroll-background",
                children: /* @__PURE__ */ R.jsx(_r, { maxWidth: "800px", margin: "auto", paddingBottom: "space80", children: /* @__PURE__ */ R.jsx(
                  Wsn,
                  {
                    messages: r,
                    loadingMessages: n,
                    conversationStatus: c
                  }
                ) })
              }
            )
          }
        ),
        /* @__PURE__ */ R.jsx(_r, { children: /* @__PURE__ */ R.jsxs(_r, { maxWidth: "800px", margin: "auto", className: "input-container", children: [
          !s && !a && /* @__PURE__ */ R.jsx(_r, { className: "scroll-to-bottom-button", children: /* @__PURE__ */ R.jsx(
            is,
            {
              borderRadius: "borderRadiusCircle",
              backgroundColor: "colorBackgroundBody",
              children: /* @__PURE__ */ R.jsx(as, { variant: "primary_icon", onClick: l, children: /* @__PURE__ */ R.jsx(
                BKe,
                {
                  decorative: !1,
                  title: "Scroll to bottom",
                  size: "sizeIcon40"
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ R.jsx(
            alt,
            {
              value: t,
              setValue: e,
              loading: a,
              onSubmit: i,
              showCanvasButton: f,
              showPromptLibraryButton: h,
              placeholder: p
            }
          )
        ] }) })
      ]
    }
  )
] }), Jmt = ({ inCanvas: t = !1 }) => {
  const e = s2(), [r, n] = Yt(""), a = Gn((m) => m.config.applicationId), i = Gn((m) => m.conversation.messages), o = Gn(
    (m) => m.conversation.status
  ), s = Gn(
    (m) => m.conversation.partialUserMessage
  ), l = Gn(
    (m) => m.conversation.partialAssistantMessage
  ), c = Gn(
    (m) => m.conversation.loadingMessages
  ), u = Gn(
    (m) => m.conversation.conversationId
  ), { application: f } = Abe(), h = (f == null ? void 0 : f.ui.inputPlaceholder) ?? "", [p, g] = uve(
    kbe.INTERRUPTED_CHAT_ID
  ), y = Gn(
    (m) => m.csatSurvey.isSurveyVisible
  ), { requestTransformer: b } = Ja(), w = u || p;
  if (!w)
    return /* @__PURE__ */ R.jsx(R.Fragment, { children: "No conversation ID" });
  const { sendMessage: _ } = qM(), { isCanvasEnabled: C, isPromptLibraryEnabled: x } = U3e(), { data: { conversation: S, liveChat: A, transferOptions: I } = {} } = UMt({
    conversationId: w,
    params: p ? { interruptedConversationId: p } : {},
    requestTransformer: b
  });
  Ut(() => {
    var m, v, k, O;
    if (S != null && S.chatId && e(LWe(S.chatId)), (m = S == null ? void 0 : S.messages) != null && m.length && !i.length) {
      if (e(G4t(S.messages)), S.id === p) {
        window.location.pathname.includes(
          p
        ) || Ght({
          applicationId: a,
          conversationId: p,
          updateOnly: !0
        });
        const j = S.messages.slice().reverse().find((F) => F.role === Mu.USER);
        j && (_({ message: j.content }), g(void 0));
      }
      (k = (v = S.canvas) == null ? void 0 : v.canvasVersions) != null && k.length && (e(g1e(S.canvas.canvasVersions[0].text)), e(DWe(S.canvas.id)));
    }
    S != null && S.transfer && e(U4t(S.transfer)), ((O = S == null ? void 0 : S.transfer) == null ? void 0 : O.channel) === gz.LIVE_CHAT && !$2e.isEmpty(A) && (e(v1e(A.liveChatId)), e(y2e({ isConnected: !0 })), e(
      v2e({
        liveChatId: A.liveChatId,
        identity: A.identity,
        token: A.token,
        ticketId: A.ticketId,
        chatActivitySyncMapId: A.chatActivitySyncMapId,
        conversationId: w
      })
    ));
  }, [S]);
  const M = [
    ...i
  ];
  s && M.push(s), l && M.push(l);
  const B = () => {
    _({ message: r }), n("");
  }, { scrollableRef: L, isScrolledToBottom: N, scrollToBottom: d } = Kht();
  return Ut(() => {
    d();
  }, [
    i,
    s,
    l,
    c,
    y
  ]), /* @__PURE__ */ R.jsx(
    Vsn,
    {
      conversationId: u,
      messages: M,
      isLoading: o === N7.Loading,
      onSubmit: B,
      loadingMessages: c,
      inputValue: r,
      setInputValue: n,
      scrollableRef: L,
      isScrolledToBottom: N,
      scrollToBottom: d,
      conversationStatus: o,
      inCanvas: t,
      isCanvasEnabled: C,
      isPromptLibraryEnabled: x,
      inputPlaceholder: h
    }
  );
}, qsn = ({
  application: t,
  user: e
}) => {
  const r = Zt(e), { requestTransformer: n } = Ja(), { id: a, home: i } = t, [o, s] = Yt((i == null ? void 0 : i.blocks) || []), l = ZMt({
    applicationId: a,
    requestTransformer: n
  }), {
    data: c,
    // error: dynamicContentError,
    refetch: u
  } = l;
  return Ut(() => {
    JSON.stringify(r.current) !== JSON.stringify(e) && u();
  }, [e]), Ut(() => {
    if (c != null && c.blocks) {
      const f = i != null && i.blocks ? [...i.blocks, ...c.blocks] : c.blocks;
      s(f);
    }
  }, [c]), /* @__PURE__ */ R.jsx(R.Fragment, { children: o.map((f) => /* @__PURE__ */ R.jsx(gP, { block: f }, f.id)) });
}, Ksn = ({
  application: t,
  header: e,
  isLoading: r,
  isPromptLibraryEnabled: n,
  onSendMessage: a,
  setValue: i,
  value: o,
  user: s
}) => /* @__PURE__ */ R.jsxs(
  ar.Box,
  {
    className: "WiseOwlHomeDisplay",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    rowGap: "space60",
    children: [
      /* @__PURE__ */ R.jsx(hP, { decorative: !0, size: "sizeIcon100" }),
      /* @__PURE__ */ R.jsxs(hy.Heading, { as: "h1", variant: "heading20", marginBottom: "space0", children: [
        /* @__PURE__ */ R.jsx(ar.Box, { children: e }),
        /* @__PURE__ */ R.jsx(ar.Box, { children: t.home.header.secondaryHeading ?? "" })
      ] }),
      /* @__PURE__ */ R.jsx(pf.Text, { as: "p", children: /* @__PURE__ */ R.jsx(bx, { markdown: t.home.header.subHeading || "" }) }),
      /* @__PURE__ */ R.jsx(ar.Box, { width: "100%", textAlign: "left", children: /* @__PURE__ */ R.jsx(
        alt,
        {
          value: o,
          setValue: i,
          loading: r,
          onSubmit: a,
          showCanvasButton: !1,
          showPromptLibraryButton: n,
          placeholder: t.ui.inputPlaceholder
        }
      ) }),
      /* @__PURE__ */ R.jsx(qsn, { application: t, user: s }),
      /* @__PURE__ */ R.jsx(ar.Box, { width: "100%", marginX: "auto", marginBottom: "space100", textAlign: "left", children: /* @__PURE__ */ R.jsx(pf.Text, { as: "p", color: "colorTextWeak", fontSize: "fontSize20", children: /* @__PURE__ */ R.jsx(bx, { markdown: t.home.legalDisclaimer || "" }) }) })
    ]
  }
), Zsn = () => {
  const [t, e] = Yt(""), r = Gn((h) => h.config.user), { application: n, isLoading: a, isError: i } = Abe(), o = Gn(
    (h) => h.conversation.status
  ), { sendMessage: s } = qM(), { isPromptLibraryEnabled: l } = U3e();
  if (a)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (i || !n)
    return /* @__PURE__ */ R.jsx($a, { error: i });
  const c = async () => {
    await s({ message: t });
  }, { firstName: u } = r, f = u ? `Hi ${u}, how can I help?` : "Hi, how can I help?";
  return /* @__PURE__ */ R.jsx(
    Ksn,
    {
      application: n,
      user: r,
      isLoading: o !== "Idle",
      onSendMessage: c,
      value: t,
      setValue: e,
      header: f,
      isPromptLibraryEnabled: l
    }
  );
}, Jsn = ({
  identity: t,
  liveChatId: e,
  token: r,
  ticketId: n,
  chatActivitySyncMapId: a,
  chatId: i,
  appContainerId: o,
  handleGetChatSummary: s,
  ingress: l
}) => {
  const {
    agentEvents: c,
    agent: u,
    liveChatAttributes: f,
    customer: h,
    dateCreated: p,
    isLiveChatReady: g,
    isAgentTyping: y,
    messages: b,
    sdkError: w,
    clearError: _
  } = Sqr({ identity: t, liveChatId: e, token: r }), C = Sx.useToaster(), x = !g || !h || !p, [S, A] = Yt(null), [I, M] = Yt();
  Ut(() => {
    if (!f)
      return;
    const F = ob({
      attributes: f,
      key: "chatPhase",
      fallbackValue: hm.Waiting
    });
    F && A(F);
  }, [f]), Ut(() => {
    w && C.toasts.length === 0 && C.push({
      message: w,
      variant: "error",
      onDismiss: _
    });
  }, [w, C]);
  const B = sr(() => {
    s && (async () => {
      const z = await s();
      M(z);
    })();
  }, [s, M]);
  Ut(() => {
    B();
  }, []);
  const L = () => w ? /* @__PURE__ */ R.jsx(Sx.Toaster, { left: ["space40", "unset", "unset"], ...C }) : null, N = Q9.useTransition(
    S === hm.Active,
    {
      from: { opacity: 1, transform: "translateY(0%)" },
      enter: { opacity: 1, transform: "translateY(0%)" },
      leave: { opacity: 0, transform: "translateY(-25%)" }
    }
  ), d = Q9.useTransition(
    S === hm.Waiting,
    {
      from: { opacity: 0, transform: "translateY(50%)" },
      enter: { opacity: 1, transform: "translateY(0%)" },
      config: { duration: 800 }
    }
  ), m = () => x ? /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ R.jsx(wF.Spinner, { decorative: !1, title: "Loading", size: "sizeIcon80" }) }) : null, v = ob({
    attributes: f,
    key: "pre_engagement_data",
    fallbackValue: {}
  }), k = ob({
    attributes: v,
    key: "metadata",
    fallbackValue: "{}"
  }), O = JSON.parse(decodeURIComponent(k)), G = () => S !== hm.Ended ? null : /* @__PURE__ */ R.jsx(QJr, { ticketId: n }), H = () => {
    if (!h || !p)
      return null;
    const F = ob({
      attributes: f,
      key: "participantFriendlyNames",
      fallbackValue: {}
    });
    return N(
      (z, W) => W ? /* @__PURE__ */ R.jsx(Q9.animated.div, { className: "animated-chat-log", style: z, children: /* @__PURE__ */ R.jsx(
        $Jr,
        {
          agent: u,
          agentEvents: c,
          chatMessages: b,
          customer: h,
          dateCreated: p,
          isAgentTyping: y,
          participantFriendlyNames: F,
          appContainerId: o,
          isChatActive: S === hm.Active
        }
      ) }) : null
    );
  }, j = () => {
    if (x)
      return null;
    const F = ob({
      attributes: f || {},
      key: "transfer",
      fallbackValue: null
    }), { tags: z } = O, W = new URLSearchParams({
      subject: z != null && z.includes(bLe.DIRECT_LIVE_CHAT_TAG) ? ZQr.submitTicket.subject : I == null ? void 0 : I.subject,
      description: z != null && z.includes(bLe.DIRECT_LIVE_CHAT_TAG) ? v.question : I == null ? void 0 : I.description,
      chatId: i || "",
      product: v.productCategory
    }).toString();
    return d(
      (U, Z) => Z ? /* @__PURE__ */ R.jsx(
        Q9.animated.div,
        {
          className: "animated-waiting",
          style: { height: "100%", ...U },
          children: /* @__PURE__ */ R.jsx(
            EQr,
            {
              liveChatId: e,
              token: r,
              chatActivitySyncMapId: a,
              transfer: F,
              submitTicketParams: W,
              ingress: l
            }
          )
        }
      ) : null
    );
  };
  return /* @__PURE__ */ R.jsxs(
    ar.Box,
    {
      maxWidth: "800px",
      height: "100%",
      margin: "auto",
      paddingBottom: "space80",
      children: [
        L(),
        m(),
        j(),
        G(),
        H()
      ]
    }
  );
}, Ysn = ({
  conversationId: t
}) => {
  const e = Gn((r) => r.liveChat);
  return kPt(e) ? /* @__PURE__ */ R.jsx(
    Jsn,
    {
      ...e,
      appContainerId: hle.WISE_OWL_CHAT_LOG_CONTAINER,
      chatId: t,
      element: hle.WISE_OWL_LIVE_CHAT_BLOCK,
      handleGetChatSummary: () => Promise.resolve(void 0)
    }
  ) : t ? /* @__PURE__ */ R.jsx(ar.Box, { height: "100%", children: /* @__PURE__ */ R.jsx(Jmt, {}) }) : /* @__PURE__ */ R.jsx(ar.Box, { height: "100%", children: /* @__PURE__ */ R.jsx(Zsn, {}) });
}, Tbe = (t) => {
  var c;
  const e = s2(), [r, n] = uve(
    kbe.INTERRUPTED_CHAT_ID,
    null
  ), a = Gn(
    (u) => u.conversation.conversationId
  ), i = Gn((u) => u.config.applicationId), o = Gn((u) => u.event.events), { requestTransformer: s } = Ja(), l = WI({
    applicationId: i,
    requestTransformer: s
  });
  return Ut(() => {
    o.forEach((u) => {
      t.handleEvent && t.handleEvent(u), e(gPt());
    });
  }, [o]), Ut(() => {
    const { handleEvent: u, ...f } = t;
    e(
      F4t({
        ...f,
        ingress: t.ingress || ol.osc
      })
    ), e(_le(t.conversationId));
  }, [t]), Ut(() => {
    r && e(_le(r));
  }, [r]), /* @__PURE__ */ R.jsx(
    Ysn,
    {
      application: (c = l.data) == null ? void 0 : c.application,
      element: hle.WISE_OWL_LIVE_CHAT_BLOCK,
      conversationId: a
    }
  );
}, Xsn = ({
  applicationId: t,
  width: e,
  user: r,
  conversationId: n,
  systemContext: a,
  onClickBack: i,
  handleEvent: o
}) => /* @__PURE__ */ R.jsxs(
  "div",
  {
    style: {
      width: e,
      height: "100%",
      border: "1px solid #ccc",
      borderRadius: "6px",
      display: "flex",
      flexDirection: "column"
    },
    children: [
      /* @__PURE__ */ R.jsx(
        _r,
        {
          padding: "space40",
          backgroundColor: "colorBackgroundWeak",
          borderTopLeftRadius: "borderRadius20",
          borderTopRightRadius: "borderRadius20",
          children: /* @__PURE__ */ R.jsx(
            as,
            {
              variant: "secondary",
              size: "icon",
              disabled: !n,
              onClick: i,
              children: /* @__PURE__ */ R.jsx($3e, { decorative: !1, title: "Add to cart" })
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsx(eWe, { orientation: "horizontal", verticalSpacing: "space0" }),
      /* @__PURE__ */ R.jsx(_r, { padding: "space40", flexGrow: 1, children: /* @__PURE__ */ R.jsx(
        Tbe,
        {
          applicationId: t,
          user: r,
          conversationId: n,
          handleEvent: o,
          systemContext: a,
          displayName: "Wise Owl",
          surveyId: "SV_0H8qU82qFh47298"
        }
      ) })
    ]
  }
), Qsn = ({ applicationId: t, user: e, systemContext: r }) => {
  const [n, a] = Yt(), i = () => {
    a(void 0);
  }, o = (s) => {
    s.type === "createConversation" && a(s.data.conversationId);
  };
  return /* @__PURE__ */ R.jsx(
    Xsn,
    {
      applicationId: t,
      user: e,
      conversationId: n,
      systemContext: r,
      onClickBack: i,
      handleEvent: o
    }
  );
}, eln = ({ componentId: t, pageInputValues: e }) => {
  const { requestTransformer: r } = Ja(), n = VMt({
    componentId: t,
    pageInputValues: e,
    requestTransformer: r
  });
  if (n.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (n.isError || !n.data)
    return /* @__PURE__ */ R.jsx($a, { error: n.error });
  const { block: a } = n.data;
  return /* @__PURE__ */ R.jsx(gP, { block: a });
}, tln = ({
  page: t,
  pageInputValues: e,
  setPageInputValues: r,
  pageContents: n
}) => /* @__PURE__ */ R.jsxs(
  _r,
  {
    height: "100%",
    display: "flex",
    position: "relative",
    columnGap: "space40",
    children: [
      /* @__PURE__ */ R.jsxs(_r, { flexGrow: 1, overflowY: "auto", children: [
        /* @__PURE__ */ R.jsx(Am, { as: "h1", variant: "heading10", children: t.name }),
        /* @__PURE__ */ R.jsx(_r, { display: "flex", children: t.inputs.map((a, i) => /* @__PURE__ */ R.jsxs(_r, { children: [
          /* @__PURE__ */ R.jsx(z$, { htmlFor: a.value, children: a.label }),
          /* @__PURE__ */ R.jsx(
            d5t,
            {
              id: a.value,
              defaultValue: a.defaultOption,
              onChange: (o) => r({
                ...e,
                [a.value]: o.currentTarget.value
              }),
              children: a.options.map((o, s) => /* @__PURE__ */ R.jsx(f5t, { value: o.value, children: o.label }, s))
            }
          )
        ] }, i)) }),
        /* @__PURE__ */ R.jsx(
          "div",
          {
            style: {
              display: "grid",
              gridTemplateColumns: t.layout.grid.templateColumns,
              gridTemplateRows: t.layout.grid.templateRows,
              gap: t.layout.grid.gap
            },
            children: t.layout.items.map((a, i) => /* @__PURE__ */ R.jsx(
              _r,
              {
                padding: "space40",
                backgroundColor: "colorBackgroundBody",
                gridColumn: a.gridColumn,
                gridRow: a.gridRow,
                style: {
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  overflow: "auto"
                },
                children: /* @__PURE__ */ R.jsx(
                  eln,
                  {
                    componentId: t.components[i].id,
                    pageInputValues: e
                  }
                )
              },
              i.toString()
            ))
          }
        )
      ] }),
      /* @__PURE__ */ R.jsx(_r, { height: "100%", width: "350px", children: /* @__PURE__ */ R.jsx(
        Qsn,
        {
          user: {
            firstName: "Nick",
            lastName: "Paz"
          },
          applicationId: t.application.id,
          systemContext: {
            wiseOwlPage: n
          }
        }
      ) })
    ]
  }
), rln = ({
  pageId: t
}) => {
  const { requestTransformer: e } = Ja(), {
    data: { page: r } = {},
    isLoading: n,
    isError: a
  } = Yqe({
    pageId: t,
    requestTransformer: e
  }), [i, o] = Yt(""), [s] = qMt(), [l, c] = Yt(null);
  return Ut(() => {
    if (r) {
      const u = {};
      r.inputs.forEach((f) => {
        u[f.value] = f.defaultOption;
      }), c(u);
    }
  }, [r]), Ut(() => {
    (async () => {
      if (r && l) {
        const f = await Promise.all(
          r.components.map(async (h) => {
            const { data: p } = await s({
              componentId: h.id,
              pageInputValues: l,
              requestTransformer: e
            });
            return p;
          })
        );
        o(JSON.stringify(f, null, 2));
      }
    })();
  }, [r]), a ? /* @__PURE__ */ R.jsx(R.Fragment, { children: "Error" }) : n ? /* @__PURE__ */ R.jsx(R.Fragment, { children: "Loading" }) : r ? l ? /* @__PURE__ */ R.jsx(
    tln,
    {
      page: r,
      pageInputValues: l,
      setPageInputValues: c,
      pageContents: i
    }
  ) : /* @__PURE__ */ R.jsx(R.Fragment, { children: "Loading" }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: "No data" });
}, Z3n = ({ children: t, requestTransformer: e }) => /* @__PURE__ */ R.jsx(HT.Theme.Provider, { theme: "twilio", style: { height: "100%" }, children: /* @__PURE__ */ R.jsx(Ohr, { props: { requestTransformer: e }, children: /* @__PURE__ */ R.jsx(
  hpe.CustomizationProvider,
  {
    theme: HT.TwilioTheme,
    elements: {
      SIDE_MODAL: {
        width: "600px"
      },
      SIDE_MODAL_BODY: {
        overflowY: "hidden"
      }
    },
    children: /* @__PURE__ */ R.jsx(l9t, { store: uKe, children: /* @__PURE__ */ R.jsx(Bbr, { children: /* @__PURE__ */ R.jsx(aen, { children: /* @__PURE__ */ R.jsx(Abr, { children: t }) }) }) })
  }
) }) }), rs = {
  index: () => "/",
  // Applications Routes
  applicationIndex: () => "/applications/",
  applicationResource: (t) => `/applications/${t}`,
  applicationHomeView: (t) => `/applications/${t}/view`,
  applicationConversationView: (t, e) => `/applications/${t}/view/${e}`,
  // Assistants Routes
  assistantIndex: () => "/assistants/",
  assistantResource: (t) => `/assistants/${t}`,
  assistantView: (t) => `/assistants/${t}/view`,
  // Blocks Routes
  blockIndex: () => "/blocks/",
  blockResource: (t) => `/blocks/${t}`,
  blockView: (t) => `/blocks/${t}/view`,
  // Component Routes
  componentIndex: () => "/components/",
  componentResource: (t) => `/components/${t}`,
  // Conversation Routes
  conversationDebuggerHome: () => "/debugger",
  conversationDebugger: (t) => `/debugger/${t}`,
  // Forms Routes
  formIndex: () => "/forms/",
  formResource: (t) => `/forms/${t}`,
  formView: (t) => `/forms/${t}/view`,
  // Knolwedge Routes
  knowledgeSourceIndex: () => "/knowledge-sources/",
  knowledgeSourceResource: (t) => `/knowledge-sources/${t}`,
  // Page Routes
  pageIndex: () => "/pages/",
  pageResource: (t) => `/pages/${t}`,
  pageView: (t) => `/pages/${t}/view`,
  // Tools Routes
  toolIndex: () => "/tools/",
  toolResource: (t) => `/tools/${t}`,
  toolView: (t) => `/tools/${t}/view`,
  // Workflows Routes
  workflowIndex: () => "/workflows/",
  workflowResource: (t) => `/workflows/${t}`,
  workflowView: (t) => `/workflows/${t}/view`
}, nln = ({
  value: t,
  size: e = 5,
  cellSize: r = 4
}) => {
  const n = aln(t, e);
  return /* @__PURE__ */ R.jsx(
    "div",
    {
      style: {
        display: "grid",
        gridTemplateColumns: `repeat(${e}, ${r}px)`,
        gridTemplateRows: `repeat(${e}, ${r}px)`,
        border: "2px solid black"
      },
      children: n.flatMap(
        (a, i) => a.map((o, s) => /* @__PURE__ */ R.jsx(
          "div",
          {
            style: {
              width: r,
              height: r,
              //   backgroundColor: filled ? stringToColor(value) : 'transparent',
              backgroundColor: o ? jFe(t)[0] : jFe(t)[1]
            }
          },
          `${s}-${i}`
        ))
      )
    }
  );
};
function jFe(t) {
  const r = Ymt(t).reduce((l, c) => l + c, 0) % 360, n = 65, a = 50, i = `hsl(${r}, ${n}%, ${a}%)`, s = `hsl(${(r + 180) % 360}, ${n}%, ${a}%)`;
  return [i, s];
}
function aln(t, e = 5) {
  const r = Ymt(t), n = [];
  for (let a = 0; a < e; a++) {
    n[a] = [];
    for (let i = 0; i < Math.ceil(e / 2); i++) {
      const o = (a * Math.ceil(e / 2) + i) % r.length, s = r[o] % 2 === 0;
      n[a][i] = s, n[a][e - 1 - i] = s;
    }
  }
  return n;
}
function Ymt(t) {
  const e = new Array(15).fill(0);
  for (let r = 0; r < t.length; r++)
    e[r % e.length] = (e[r % e.length] + t.charCodeAt(r)) % 256;
  return e;
}
const cp = ({
  Icon: t,
  title: e,
  elapsedTime: r,
  tokens: n,
  assistantId: a,
  children: i
}) => /* @__PURE__ */ R.jsxs(is, { borderRadius: "borderRadius20", children: [
  /* @__PURE__ */ R.jsx(
    _r,
    {
      backgroundColor: "colorBackground",
      borderTopLeftRadius: "borderRadius20",
      borderTopRightRadius: "borderRadius20",
      borderBottomWidth: "borderWidth10",
      padding: "space40",
      children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", alignItems: "center", columnGap: "space40", children: [
        /* @__PURE__ */ R.jsx(t, {}),
        /* @__PURE__ */ R.jsx(Am, { as: "h3", variant: "heading40", marginBottom: "space0", children: /* @__PURE__ */ R.jsx(_r, { children: e }) }),
        /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
        a !== null && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          /* @__PURE__ */ R.jsx(nln, { value: a }),
          /* @__PURE__ */ R.jsx(_r, { children: a }),
          /* @__PURE__ */ R.jsx(lj, {})
        ] }),
        n !== null && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          /* @__PURE__ */ R.jsxs(_r, { children: [
            n,
            " tokens"
          ] }),
          /* @__PURE__ */ R.jsx(lj, {})
        ] }),
        r !== null && /* @__PURE__ */ R.jsxs(_r, { children: [
          (r / 1e3).toFixed(1),
          " s"
        ] })
      ] })
    }
  ),
  /* @__PURE__ */ R.jsx(_r, { padding: "space40", children: i })
] }), iln = ({
  event: t
}) => {
  let e;
  try {
    e = JSON.parse(t.values.output);
  } catch {
    e = t.values.output;
  }
  return /* @__PURE__ */ R.jsx(
    cp,
    {
      Icon: e8r,
      title: "Tool Call",
      elapsedTime: t.elapsedTime,
      assistantId: t.assistantId,
      tokens: t.totalTokens,
      children: /* @__PURE__ */ R.jsxs(Ny, { children: [
        /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Tool", children: t.values.toolId }),
        /* @__PURE__ */ R.jsxs(Wl, { variant: "inline", label: "Output Size", children: [
          t.values.tokens,
          " tokens"
        ] }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Input", children: /* @__PURE__ */ R.jsx(
          O7,
          {
            code: JSON.stringify(t.values.input, null, 2),
            language: "javascript",
            wrapLines: !0,
            maxLines: 15
          }
        ) }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Output", children: /* @__PURE__ */ R.jsx(
          O7,
          {
            code: JSON.stringify(e, null, 2),
            language: "javascript",
            wrapLines: !0,
            maxLines: 15
          }
        ) })
      ] })
    }
  );
}, oln = ({ event: t }) => {
  const { prompt: e, thought: r, action: n, workflowId: a, workflowNodeId: i, actionInput: o } = t.values.plan;
  return /* @__PURE__ */ R.jsx(
    cp,
    {
      Icon: ixr,
      title: "Planning",
      elapsedTime: t.elapsedTime,
      assistantId: t.assistantId,
      tokens: t.totalTokens,
      children: /* @__PURE__ */ R.jsxs(Ny, { children: [
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Thought", children: r }),
        a && /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Workflow ID", children: a }),
        i && /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Workflow Node ID", children: i }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Action", children: n }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Action Input", children: /* @__PURE__ */ R.jsx(
          O7,
          {
            language: "json",
            code: JSON.stringify(o, null, 2)
          }
        ) }),
        /* @__PURE__ */ R.jsxs(Jst, { children: [
          /* @__PURE__ */ R.jsx(G7r, { asChild: !0, children: /* @__PURE__ */ R.jsx(as, { variant: "secondary", children: "View Prompt" }) }),
          /* @__PURE__ */ R.jsx(cve, { fullscreen: !0, children: /* @__PURE__ */ R.jsx(_r, { height: "100%", overflowY: "auto", padding: "space40", children: /* @__PURE__ */ R.jsx(bx, { markdown: e }) }) })
        ] })
      ] })
    }
  );
}, sln = ({ event: t }) => {
  const [e, r] = Te.useState(!1);
  return /* @__PURE__ */ R.jsx(
    cp,
    {
      Icon: txr,
      title: "Retrieve Knowledge",
      elapsedTime: t.elapsedTime,
      assistantId: t.assistantId,
      tokens: t.totalTokens,
      children: /* @__PURE__ */ R.jsxs(Ny, { children: [
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Query", children: t.values.query }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Sources", children: t.values.sourceIds.join(", ") }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Retrieved Knowledge", children: /* @__PURE__ */ R.jsx(
          Jht,
          {
            retrievedKnowledge: t.values.retrievedKnowledge,
            showAllCitations: e,
            setShowAllCitations: r
          }
        ) })
      ] })
    }
  );
}, lln = ({ event: t }) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: Sxr,
    title: "Generate Block",
    elapsedTime: t.elapsedTime,
    assistantId: t.assistantId,
    tokens: t.totalTokens,
    children: /* @__PURE__ */ R.jsx(gP, { block: t.values.blockInstance })
  }
), cln = ({ event: t }) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: vxr,
    title: "Assign Task",
    elapsedTime: t.elapsedTime,
    assistantId: t.assistantId,
    tokens: t.totalTokens,
    children: /* @__PURE__ */ R.jsxs(Ny, { children: [
      /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Assistant ID", children: t.values.assistantId }),
      /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Task", children: t.values.task })
    ] })
  }
), uln = ({ event: t }) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: mxr,
    title: "Complete Task",
    elapsedTime: t.elapsedTime,
    assistantId: t.assistantId,
    tokens: t.totalTokens,
    children: /* @__PURE__ */ R.jsx(Ny, { children: /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Task Output", children: /* @__PURE__ */ R.jsx(
      O7,
      {
        code: t.values.output,
        language: "json",
        wrapLines: !0,
        maxLines: 15
      }
    ) }) })
  }
), dln = ({ event: t }) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: Axr,
    title: "Update Canvas",
    tokens: t.totalTokens,
    elapsedTime: t.elapsedTime,
    assistantId: t.assistantId,
    children: /* @__PURE__ */ R.jsx(Ny, { children: /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Updates", children: /* @__PURE__ */ R.jsx(
      O7,
      {
        language: "json",
        code: t.values.text,
        maxLines: 15,
        wrapLines: !0
      }
    ) }) })
  }
), Xmt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `TransferIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[TransferIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M13.585 10.117a.546.546 0 01.773 0L16.84 12.6a.546.546 0 010 .772l-2.482 2.482a.546.546 0 01-.773-.772l2.097-2.096-2.097-2.096a.546.546 0 010-.773zM6.414 4.16a.546.546 0 010 .772L4.318 7.028l2.096 2.096a.546.546 0 01-.772.773L3.16 7.414a.546.546 0 010-.772L5.642 4.16a.546.546 0 01.772 0z" }), P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.028c0-.301.244-.546.546-.546h12.908a.546.546 0 010 1.092H3.546A.546.546 0 013 7.028zM3 12.986c0-.302.244-.546.546-.546h12.908a.546.546 0 010 1.092H3.546A.546.546 0 013 12.986z" })));
});
Xmt.displayName = "TransferIcon";
const fln = ({
  title: t,
  timestamp: e,
  icon: r,
  helpText: n,
  drawerContent: a,
  previewContent: i,
  iconColor: o = "black",
  iconBackgroundColor: s = "white"
}) => {
  const l = i.split(`
`)[0];
  return /* @__PURE__ */ R.jsxs(i1t, { children: [
    /* @__PURE__ */ R.jsx(o1t, { asChild: !0, children: /* @__PURE__ */ R.jsx(
      is,
      {
        cursor: "pointer",
        className: "hover:shadow",
        padding: "space40",
        overflow: "hidden",
        backgroundColor: "colorBackground",
        children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", alignItems: "center", columnGap: "space40", children: [
          /* @__PURE__ */ R.jsx(
            "div",
            {
              className: "rounded-full p-2 border-black border-[1px]",
              style: {
                color: o,
                backgroundColor: s
              },
              children: Te.createElement(r, {
                decorative: !0,
                size: "sizeIcon40"
              })
            }
          ),
          /* @__PURE__ */ R.jsxs(_r, { display: "flex", flexDirection: "column", rowGap: "space20", children: [
            /* @__PURE__ */ R.jsx("b", { children: t }),
            /* @__PURE__ */ R.jsx(_r, { flexGrow: 1, children: /* @__PURE__ */ R.jsx(QGe, { title: l, children: /* @__PURE__ */ R.jsx(bx, { markdown: l }) }) })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ R.jsxs(c1t, { className: "sm:max-w-lg", children: [
      /* @__PURE__ */ R.jsxs(u1t, { children: [
        /* @__PURE__ */ R.jsx(d1t, { children: t }),
        /* @__PURE__ */ R.jsx(h1t, { className: "mt-1 text-sm", children: /* @__PURE__ */ R.jsxs(_r, { display: "flex", flexDirection: "column", rowGap: "space20", children: [
          e.toLocaleString(),
          /* @__PURE__ */ R.jsx("div", { children: n })
        ] }) })
      ] }),
      /* @__PURE__ */ R.jsx(f1t, { children: /* @__PURE__ */ R.jsx("div", { children: a }) })
    ] })
  ] });
}, hln = ({ event: t }) => /* @__PURE__ */ R.jsx(
  fln,
  {
    timestamp: new Date(t.createdAt),
    title: "Transfer Conversation to Human",
    previewContent: "Conversation transfer to human agent has been initiated.",
    icon: Xmt,
    helpText: "The tool returned with output.",
    drawerContent: /* @__PURE__ */ R.jsx(Ny, { children: /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Input", children: /* @__PURE__ */ R.jsx(
      O7,
      {
        code: JSON.stringify(t.values),
        language: "javascript",
        wrapLines: !0
      }
    ) }) })
  }
), pln = ({
  message: t
}) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: Hxr,
    title: "User Message",
    tokens: null,
    assistantId: null,
    elapsedTime: null,
    children: t.content
  }
), mln = ({ message: t }) => /* @__PURE__ */ R.jsx(
  cp,
  {
    Icon: nxr,
    title: "AI Message",
    tokens: null,
    assistantId: null,
    elapsedTime: null,
    children: /* @__PURE__ */ R.jsx(Zmt, { message: t, messageLogIndex: 0, messageLogLength: 0 })
  }
), gln = ({ event: t }) => {
  const { pass: e, description: r } = t.values, n = e ? "true" : "false";
  return /* @__PURE__ */ R.jsx(
    cp,
    {
      Icon: Gxr,
      title: "Gate Event",
      elapsedTime: t.elapsedTime,
      assistantId: t.assistantId,
      tokens: t.totalTokens,
      children: /* @__PURE__ */ R.jsxs(Ny, { children: [
        /* @__PURE__ */ R.jsx(Wl, { variant: "inline", label: "Pass", children: n }),
        /* @__PURE__ */ R.jsx(Wl, { variant: "multiline", label: "Description", children: r })
      ] })
    }
  );
}, vln = ({
  item: t
}) => {
  const e = "role" in t;
  if (e && t.role === Mu.USER)
    return /* @__PURE__ */ R.jsx(pln, { message: t });
  if (e && t.role === Mu.ASSISTANT)
    return /* @__PURE__ */ R.jsx(mln, { message: t });
  switch (t.type) {
    case Us.TOOL_CALL:
      return /* @__PURE__ */ R.jsx(iln, { event: t });
    case Us.ASSISTANT_PLAN:
      return /* @__PURE__ */ R.jsx(oln, { event: t });
    case Us.RETRIEVE_KNOWLEDGE:
      return /* @__PURE__ */ R.jsx(sln, { event: t });
    case Us.GENERATE_BLOCK_INSTANCE:
      return /* @__PURE__ */ R.jsx(lln, { event: t });
    case Us.ASSIGN_TASK:
      return /* @__PURE__ */ R.jsx(cln, { event: t });
    case Us.COMPLETE_TASK:
      return /* @__PURE__ */ R.jsx(uln, { event: t });
    case Us.UPDATE_CANVAS:
      return /* @__PURE__ */ R.jsx(dln, { event: t });
    case Us.TRANSFER_CONVERSATION_TO_HUMAN:
      return /* @__PURE__ */ R.jsx(hln, { event: t });
    case Us.GATE:
      return /* @__PURE__ */ R.jsx(gln, { event: t });
    default:
      return /* @__PURE__ */ R.jsx(
        $a,
        {
          error: `Debug item renderer for event type \`${t.type}\` is not implemented.`
        }
      );
  }
}, yln = (t) => {
  const e = [];
  let r = [], n;
  for (const a of t)
    n === void 0 ? n = a.runId : a.runId !== n && (e.push(r), r = [], n = a.runId), r.push(a);
  r.length > 0 && e.push(r);
  for (let a = 0; a < e.length; a++) {
    const i = e[a], o = i.findIndex(
      (l) => "role" in l && l.role === Mu.USER
    ), s = i.findIndex(
      (l) => "role" in l && l.role === Mu.ASSISTANT
    );
    if (o !== -1) {
      const l = i[o];
      i.splice(o, 1), i.unshift(l);
    }
    if (s !== -1) {
      const l = i[s];
      i.splice(s, 1), i.push(l);
    }
  }
  return e;
}, bln = (t) => {
  const e = t[0];
  return new Date(e.createdAt).toLocaleString();
}, xln = (t) => `Total ${(t.reduce((r, n) => "elapsedTime" in n ? r + n.elapsedTime : r, 0) / 1e3).toFixed(1)} s`, Cln = (t) => `Total ${t.reduce((r, n) => "totalTokens" in n ? r + n.totalTokens : r, 0)} tokens`, FFe = () => /* @__PURE__ */ R.jsx(
  _r,
  {
    paddingTop: "space80",
    borderLeftWidth: "borderWidth20",
    marginLeft: "space80"
  }
), wln = ({
  events: t,
  conversation: e
}) => {
  const r = [
    ...t,
    ...e.messages
  ].sort(
    (i, o) => new Date(i.createdAt).getTime() - new Date(o.createdAt).getTime()
  ), n = () => {
    const i = e.messages.reduce((o, s) => {
      if (s.role === Mu.USER) {
        const l = s.content;
        return `${o}

==========[ User ]==========

${l}`;
      } else if (s.role === Mu.ASSISTANT) {
        const l = s.parts.map((c) => c.type === e0.MARKDOWN ? c.content : c.type === e0.BLOCK ? JSON.stringify(c.block, null, 2) : "").join(`

`);
        return `${o}

==========[ Assistant ]==========

${l}`;
      }
      return o;
    }, "");
    navigator.clipboard.writeText(i);
  }, a = yln(r);
  return /* @__PURE__ */ R.jsxs(_r, { display: "flex", flexDirection: "column", rowGap: "space80", children: [
    /* @__PURE__ */ R.jsxs(
      is,
      {
        display: "flex",
        padding: "space40",
        alignItems: "center",
        columnGap: "space40",
        children: [
          /* @__PURE__ */ R.jsx(Am, { as: "h3", variant: "heading40", marginBottom: "space0", children: /* @__PURE__ */ R.jsx(_r, { children: e.id }) }),
          e.applicationIds.map((i) => /* @__PURE__ */ R.jsx(h5t, { variant: "decorative10", as: "span", children: i }, i)),
          /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
          /* @__PURE__ */ R.jsx(as, { variant: "secondary", onClick: n, children: "Copy" })
        ]
      }
    ),
    a.map((i, o) => /* @__PURE__ */ R.jsxs(_r, { children: [
      /* @__PURE__ */ R.jsx(
        is,
        {
          padding: "space40",
          backgroundColor: "colorBackgroundInverse",
          children: /* @__PURE__ */ R.jsxs(
            _r,
            {
              color: "colorTextInverse",
              display: "flex",
              alignItems: "center",
              columnGap: "space40",
              children: [
                /* @__PURE__ */ R.jsx(dxr, {}),
                /* @__PURE__ */ R.jsx(Am, { as: "h3", variant: "heading40", marginBottom: "space0", children: /* @__PURE__ */ R.jsx(_r, { color: "colorTextInverse", children: "Start" }) }),
                /* @__PURE__ */ R.jsx(_r, { flexGrow: 1 }),
                bln(i),
                /* @__PURE__ */ R.jsx(lj, {}),
                Cln(i),
                /* @__PURE__ */ R.jsx(lj, {}),
                xln(i)
              ]
            }
          )
        }
      ),
      i.map((s, l) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(FFe, {}),
        /* @__PURE__ */ R.jsx(vln, { item: s }, l)
      ] })),
      /* @__PURE__ */ R.jsx(FFe, {}),
      /* @__PURE__ */ R.jsx(
        is,
        {
          padding: "space40",
          backgroundColor: "colorBackgroundInverse",
          children: /* @__PURE__ */ R.jsx(Am, { as: "h3", variant: "heading40", marginBottom: "space0", children: /* @__PURE__ */ R.jsxs(
            _r,
            {
              color: "colorTextInverse",
              display: "flex",
              alignItems: "center",
              columnGap: "space40",
              children: [
                /* @__PURE__ */ R.jsx(hxr, {}),
                "End"
              ]
            }
          ) })
        }
      )
    ] }, o))
  ] });
}, Sln = ({ conversation: t, events: e }) => /* @__PURE__ */ R.jsxs(
  _r,
  {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: "space40",
    children: [
      /* @__PURE__ */ R.jsx(Kh, {}),
      /* @__PURE__ */ R.jsx(wln, { events: e, conversation: t })
    ]
  }
), J3n = () => {
  const { conversationId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing conversationId" });
  const r = nPt({
    conversationId: t,
    requestTransformer: e
  }), n = aPt({
    conversationId: t,
    requestTransformer: e
  });
  if (r.isLoading || n.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data || n.isError || !n.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { events: a } = r.data, { conversation: i } = n.data;
  return /* @__PURE__ */ R.jsx(Sln, { conversation: i, events: a });
};
function Pl(t) {
  if (typeof t == "string" || typeof t == "number") return "" + t;
  let e = "";
  if (Array.isArray(t))
    for (let r = 0, n; r < t.length; r++)
      (n = Pl(t[r])) !== "" && (e += (e && " ") + n);
  else
    for (let r in t)
      t[r] && (e += (e && " ") + r);
  return e;
}
var _ln = { value: () => {
} };
function VH() {
  for (var t = 0, e = arguments.length, r = {}, n; t < e; ++t) {
    if (!(n = arguments[t] + "") || n in r || /[\s.]/.test(n)) throw new Error("illegal type: " + n);
    r[n] = [];
  }
  return new D$(r);
}
function D$(t) {
  this._ = t;
}
function kln(t, e) {
  return t.trim().split(/^|\s+/).map(function(r) {
    var n = "", a = r.indexOf(".");
    if (a >= 0 && (n = r.slice(a + 1), r = r.slice(0, a)), r && !e.hasOwnProperty(r)) throw new Error("unknown type: " + r);
    return { type: r, name: n };
  });
}
D$.prototype = VH.prototype = {
  constructor: D$,
  on: function(t, e) {
    var r = this._, n = kln(t + "", r), a, i = -1, o = n.length;
    if (arguments.length < 2) {
      for (; ++i < o; ) if ((a = (t = n[i]).type) && (a = Aln(r[a], t.name))) return a;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++i < o; )
      if (a = (t = n[i]).type) r[a] = zFe(r[a], t.name, e);
      else if (e == null) for (a in r) r[a] = zFe(r[a], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var r in e) t[r] = e[r].slice();
    return new D$(t);
  },
  call: function(t, e) {
    if ((a = arguments.length - 2) > 0) for (var r = new Array(a), n = 0, a, i; n < a; ++n) r[n] = arguments[n + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (i = this._[t], n = 0, a = i.length; n < a; ++n) i[n].value.apply(e, r);
  },
  apply: function(t, e, r) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var n = this._[t], a = 0, i = n.length; a < i; ++a) n[a].value.apply(e, r);
  }
};
function Aln(t, e) {
  for (var r = 0, n = t.length, a; r < n; ++r)
    if ((a = t[r]).name === e)
      return a.value;
}
function zFe(t, e, r) {
  for (var n = 0, a = t.length; n < a; ++n)
    if (t[n].name === e) {
      t[n] = _ln, t = t.slice(0, n).concat(t.slice(n + 1));
      break;
    }
  return r != null && t.push({ name: e, value: r }), t;
}
var Wfe = "http://www.w3.org/1999/xhtml";
const GFe = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Wfe,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function qH(t) {
  var e = t += "", r = e.indexOf(":");
  return r >= 0 && (e = t.slice(0, r)) !== "xmlns" && (t = t.slice(r + 1)), GFe.hasOwnProperty(e) ? { space: GFe[e], local: t } : t;
}
function Tln(t) {
  return function() {
    var e = this.ownerDocument, r = this.namespaceURI;
    return r === Wfe && e.documentElement.namespaceURI === Wfe ? e.createElement(t) : e.createElementNS(r, t);
  };
}
function Eln(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function Qmt(t) {
  var e = qH(t);
  return (e.local ? Eln : Tln)(e);
}
function Iln() {
}
function Ebe(t) {
  return t == null ? Iln : function() {
    return this.querySelector(t);
  };
}
function Mln(t) {
  typeof t != "function" && (t = Ebe(t));
  for (var e = this._groups, r = e.length, n = new Array(r), a = 0; a < r; ++a)
    for (var i = e[a], o = i.length, s = n[a] = new Array(o), l, c, u = 0; u < o; ++u)
      (l = i[u]) && (c = t.call(l, l.__data__, u, i)) && ("__data__" in l && (c.__data__ = l.__data__), s[u] = c);
  return new p0(n, this._parents);
}
function Pln(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Rln() {
  return [];
}
function egt(t) {
  return t == null ? Rln : function() {
    return this.querySelectorAll(t);
  };
}
function Oln(t) {
  return function() {
    return Pln(t.apply(this, arguments));
  };
}
function Bln(t) {
  typeof t == "function" ? t = Oln(t) : t = egt(t);
  for (var e = this._groups, r = e.length, n = [], a = [], i = 0; i < r; ++i)
    for (var o = e[i], s = o.length, l, c = 0; c < s; ++c)
      (l = o[c]) && (n.push(t.call(l, l.__data__, c, o)), a.push(l));
  return new p0(n, a);
}
function tgt(t) {
  return function() {
    return this.matches(t);
  };
}
function rgt(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Nln = Array.prototype.find;
function $ln(t) {
  return function() {
    return Nln.call(this.children, t);
  };
}
function Dln() {
  return this.firstElementChild;
}
function Lln(t) {
  return this.select(t == null ? Dln : $ln(typeof t == "function" ? t : rgt(t)));
}
var jln = Array.prototype.filter;
function Fln() {
  return Array.from(this.children);
}
function zln(t) {
  return function() {
    return jln.call(this.children, t);
  };
}
function Gln(t) {
  return this.selectAll(t == null ? Fln : zln(typeof t == "function" ? t : rgt(t)));
}
function Wln(t) {
  typeof t != "function" && (t = tgt(t));
  for (var e = this._groups, r = e.length, n = new Array(r), a = 0; a < r; ++a)
    for (var i = e[a], o = i.length, s = n[a] = [], l, c = 0; c < o; ++c)
      (l = i[c]) && t.call(l, l.__data__, c, i) && s.push(l);
  return new p0(n, this._parents);
}
function ngt(t) {
  return new Array(t.length);
}
function Hln() {
  return new p0(this._enter || this._groups.map(ngt), this._parents);
}
function WF(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
WF.prototype = {
  constructor: WF,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function Uln(t) {
  return function() {
    return t;
  };
}
function Vln(t, e, r, n, a, i) {
  for (var o = 0, s, l = e.length, c = i.length; o < c; ++o)
    (s = e[o]) ? (s.__data__ = i[o], n[o] = s) : r[o] = new WF(t, i[o]);
  for (; o < l; ++o)
    (s = e[o]) && (a[o] = s);
}
function qln(t, e, r, n, a, i, o) {
  var s, l, c = /* @__PURE__ */ new Map(), u = e.length, f = i.length, h = new Array(u), p;
  for (s = 0; s < u; ++s)
    (l = e[s]) && (h[s] = p = o.call(l, l.__data__, s, e) + "", c.has(p) ? a[s] = l : c.set(p, l));
  for (s = 0; s < f; ++s)
    p = o.call(t, i[s], s, i) + "", (l = c.get(p)) ? (n[s] = l, l.__data__ = i[s], c.delete(p)) : r[s] = new WF(t, i[s]);
  for (s = 0; s < u; ++s)
    (l = e[s]) && c.get(h[s]) === l && (a[s] = l);
}
function Kln(t) {
  return t.__data__;
}
function Zln(t, e) {
  if (!arguments.length) return Array.from(this, Kln);
  var r = e ? qln : Vln, n = this._parents, a = this._groups;
  typeof t != "function" && (t = Uln(t));
  for (var i = a.length, o = new Array(i), s = new Array(i), l = new Array(i), c = 0; c < i; ++c) {
    var u = n[c], f = a[c], h = f.length, p = Jln(t.call(u, u && u.__data__, c, n)), g = p.length, y = s[c] = new Array(g), b = o[c] = new Array(g), w = l[c] = new Array(h);
    r(u, f, y, b, w, p, e);
    for (var _ = 0, C = 0, x, S; _ < g; ++_)
      if (x = y[_]) {
        for (_ >= C && (C = _ + 1); !(S = b[C]) && ++C < g; ) ;
        x._next = S || null;
      }
  }
  return o = new p0(o, n), o._enter = s, o._exit = l, o;
}
function Jln(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function Yln() {
  return new p0(this._exit || this._groups.map(ngt), this._parents);
}
function Xln(t, e, r) {
  var n = this.enter(), a = this, i = this.exit();
  return typeof t == "function" ? (n = t(n), n && (n = n.selection())) : n = n.append(t + ""), e != null && (a = e(a), a && (a = a.selection())), r == null ? i.remove() : r(i), n && a ? n.merge(a).order() : a;
}
function Qln(t) {
  for (var e = t.selection ? t.selection() : t, r = this._groups, n = e._groups, a = r.length, i = n.length, o = Math.min(a, i), s = new Array(a), l = 0; l < o; ++l)
    for (var c = r[l], u = n[l], f = c.length, h = s[l] = new Array(f), p, g = 0; g < f; ++g)
      (p = c[g] || u[g]) && (h[g] = p);
  for (; l < a; ++l)
    s[l] = r[l];
  return new p0(s, this._parents);
}
function ecn() {
  for (var t = this._groups, e = -1, r = t.length; ++e < r; )
    for (var n = t[e], a = n.length - 1, i = n[a], o; --a >= 0; )
      (o = n[a]) && (i && o.compareDocumentPosition(i) ^ 4 && i.parentNode.insertBefore(o, i), i = o);
  return this;
}
function tcn(t) {
  t || (t = rcn);
  function e(f, h) {
    return f && h ? t(f.__data__, h.__data__) : !f - !h;
  }
  for (var r = this._groups, n = r.length, a = new Array(n), i = 0; i < n; ++i) {
    for (var o = r[i], s = o.length, l = a[i] = new Array(s), c, u = 0; u < s; ++u)
      (c = o[u]) && (l[u] = c);
    l.sort(e);
  }
  return new p0(a, this._parents).order();
}
function rcn(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function ncn() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function acn() {
  return Array.from(this);
}
function icn() {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var n = t[e], a = 0, i = n.length; a < i; ++a) {
      var o = n[a];
      if (o) return o;
    }
  return null;
}
function ocn() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function scn() {
  return !this.node();
}
function lcn(t) {
  for (var e = this._groups, r = 0, n = e.length; r < n; ++r)
    for (var a = e[r], i = 0, o = a.length, s; i < o; ++i)
      (s = a[i]) && t.call(s, s.__data__, i, a);
  return this;
}
function ccn(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function ucn(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function dcn(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function fcn(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function hcn(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.removeAttribute(t) : this.setAttribute(t, r);
  };
}
function pcn(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, r);
  };
}
function mcn(t, e) {
  var r = qH(t);
  if (arguments.length < 2) {
    var n = this.node();
    return r.local ? n.getAttributeNS(r.space, r.local) : n.getAttribute(r);
  }
  return this.each((e == null ? r.local ? ucn : ccn : typeof e == "function" ? r.local ? pcn : hcn : r.local ? fcn : dcn)(r, e));
}
function agt(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function gcn(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function vcn(t, e, r) {
  return function() {
    this.style.setProperty(t, e, r);
  };
}
function ycn(t, e, r) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.style.removeProperty(t) : this.style.setProperty(t, n, r);
  };
}
function bcn(t, e, r) {
  return arguments.length > 1 ? this.each((e == null ? gcn : typeof e == "function" ? ycn : vcn)(t, e, r ?? "")) : l8(this.node(), t);
}
function l8(t, e) {
  return t.style.getPropertyValue(e) || agt(t).getComputedStyle(t, null).getPropertyValue(e);
}
function xcn(t) {
  return function() {
    delete this[t];
  };
}
function Ccn(t, e) {
  return function() {
    this[t] = e;
  };
}
function wcn(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? delete this[t] : this[t] = r;
  };
}
function Scn(t, e) {
  return arguments.length > 1 ? this.each((e == null ? xcn : typeof e == "function" ? wcn : Ccn)(t, e)) : this.node()[t];
}
function igt(t) {
  return t.trim().split(/^|\s+/);
}
function Ibe(t) {
  return t.classList || new ogt(t);
}
function ogt(t) {
  this._node = t, this._names = igt(t.getAttribute("class") || "");
}
ogt.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function sgt(t, e) {
  for (var r = Ibe(t), n = -1, a = e.length; ++n < a; ) r.add(e[n]);
}
function lgt(t, e) {
  for (var r = Ibe(t), n = -1, a = e.length; ++n < a; ) r.remove(e[n]);
}
function _cn(t) {
  return function() {
    sgt(this, t);
  };
}
function kcn(t) {
  return function() {
    lgt(this, t);
  };
}
function Acn(t, e) {
  return function() {
    (e.apply(this, arguments) ? sgt : lgt)(this, t);
  };
}
function Tcn(t, e) {
  var r = igt(t + "");
  if (arguments.length < 2) {
    for (var n = Ibe(this.node()), a = -1, i = r.length; ++a < i; ) if (!n.contains(r[a])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? Acn : e ? _cn : kcn)(r, e));
}
function Ecn() {
  this.textContent = "";
}
function Icn(t) {
  return function() {
    this.textContent = t;
  };
}
function Mcn(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function Pcn(t) {
  return arguments.length ? this.each(t == null ? Ecn : (typeof t == "function" ? Mcn : Icn)(t)) : this.node().textContent;
}
function Rcn() {
  this.innerHTML = "";
}
function Ocn(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Bcn(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function Ncn(t) {
  return arguments.length ? this.each(t == null ? Rcn : (typeof t == "function" ? Bcn : Ocn)(t)) : this.node().innerHTML;
}
function $cn() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Dcn() {
  return this.each($cn);
}
function Lcn() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function jcn() {
  return this.each(Lcn);
}
function Fcn(t) {
  var e = typeof t == "function" ? t : Qmt(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function zcn() {
  return null;
}
function Gcn(t, e) {
  var r = typeof t == "function" ? t : Qmt(t), n = e == null ? zcn : typeof e == "function" ? e : Ebe(e);
  return this.select(function() {
    return this.insertBefore(r.apply(this, arguments), n.apply(this, arguments) || null);
  });
}
function Wcn() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function Hcn() {
  return this.each(Wcn);
}
function Ucn() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function Vcn() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function qcn(t) {
  return this.select(t ? Vcn : Ucn);
}
function Kcn(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function Zcn(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function Jcn(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var r = "", n = e.indexOf(".");
    return n >= 0 && (r = e.slice(n + 1), e = e.slice(0, n)), { type: e, name: r };
  });
}
function Ycn(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var r = 0, n = -1, a = e.length, i; r < a; ++r)
        i = e[r], (!t.type || i.type === t.type) && i.name === t.name ? this.removeEventListener(i.type, i.listener, i.options) : e[++n] = i;
      ++n ? e.length = n : delete this.__on;
    }
  };
}
function Xcn(t, e, r) {
  return function() {
    var n = this.__on, a, i = Zcn(e);
    if (n) {
      for (var o = 0, s = n.length; o < s; ++o)
        if ((a = n[o]).type === t.type && a.name === t.name) {
          this.removeEventListener(a.type, a.listener, a.options), this.addEventListener(a.type, a.listener = i, a.options = r), a.value = e;
          return;
        }
    }
    this.addEventListener(t.type, i, r), a = { type: t.type, name: t.name, value: e, listener: i, options: r }, n ? n.push(a) : this.__on = [a];
  };
}
function Qcn(t, e, r) {
  var n = Jcn(t + ""), a, i = n.length, o;
  if (arguments.length < 2) {
    var s = this.node().__on;
    if (s) {
      for (var l = 0, c = s.length, u; l < c; ++l)
        for (a = 0, u = s[l]; a < i; ++a)
          if ((o = n[a]).type === u.type && o.name === u.name)
            return u.value;
    }
    return;
  }
  for (s = e ? Xcn : Ycn, a = 0; a < i; ++a) this.each(s(n[a], e, r));
  return this;
}
function cgt(t, e, r) {
  var n = agt(t), a = n.CustomEvent;
  typeof a == "function" ? a = new a(e, r) : (a = n.document.createEvent("Event"), r ? (a.initEvent(e, r.bubbles, r.cancelable), a.detail = r.detail) : a.initEvent(e, !1, !1)), t.dispatchEvent(a);
}
function eun(t, e) {
  return function() {
    return cgt(this, t, e);
  };
}
function tun(t, e) {
  return function() {
    return cgt(this, t, e.apply(this, arguments));
  };
}
function run(t, e) {
  return this.each((typeof e == "function" ? tun : eun)(t, e));
}
function* nun() {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var n = t[e], a = 0, i = n.length, o; a < i; ++a)
      (o = n[a]) && (yield o);
}
var ugt = [null];
function p0(t, e) {
  this._groups = t, this._parents = e;
}
function wP() {
  return new p0([[document.documentElement]], ugt);
}
function aun() {
  return this;
}
p0.prototype = wP.prototype = {
  constructor: p0,
  select: Mln,
  selectAll: Bln,
  selectChild: Lln,
  selectChildren: Gln,
  filter: Wln,
  data: Zln,
  enter: Hln,
  exit: Yln,
  join: Xln,
  merge: Qln,
  selection: aun,
  order: ecn,
  sort: tcn,
  call: ncn,
  nodes: acn,
  node: icn,
  size: ocn,
  empty: scn,
  each: lcn,
  attr: mcn,
  style: bcn,
  property: Scn,
  classed: Tcn,
  text: Pcn,
  html: Ncn,
  raise: Dcn,
  lower: jcn,
  append: Fcn,
  insert: Gcn,
  remove: Hcn,
  clone: qcn,
  datum: Kcn,
  on: Qcn,
  dispatch: run,
  [Symbol.iterator]: nun
};
function a0(t) {
  return typeof t == "string" ? new p0([[document.querySelector(t)]], [document.documentElement]) : new p0([[t]], ugt);
}
function iun(t) {
  let e;
  for (; e = t.sourceEvent; ) t = e;
  return t;
}
function c1(t, e) {
  if (t = iun(t), e === void 0 && (e = t.currentTarget), e) {
    var r = e.ownerSVGElement || e;
    if (r.createSVGPoint) {
      var n = r.createSVGPoint();
      return n.x = t.clientX, n.y = t.clientY, n = n.matrixTransform(e.getScreenCTM().inverse()), [n.x, n.y];
    }
    if (e.getBoundingClientRect) {
      var a = e.getBoundingClientRect();
      return [t.clientX - a.left - e.clientLeft, t.clientY - a.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
const oun = { passive: !1 }, yI = { capture: !0, passive: !1 };
function Zoe(t) {
  t.stopImmediatePropagation();
}
function R7(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function dgt(t) {
  var e = t.document.documentElement, r = a0(t).on("dragstart.drag", R7, yI);
  "onselectstart" in e ? r.on("selectstart.drag", R7, yI) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function fgt(t, e) {
  var r = t.document.documentElement, n = a0(t).on("dragstart.drag", null);
  e && (n.on("click.drag", R7, yI), setTimeout(function() {
    n.on("click.drag", null);
  }, 0)), "onselectstart" in r ? n.on("selectstart.drag", null) : (r.style.MozUserSelect = r.__noselect, delete r.__noselect);
}
const _N = (t) => () => t;
function Hfe(t, {
  sourceEvent: e,
  subject: r,
  target: n,
  identifier: a,
  active: i,
  x: o,
  y: s,
  dx: l,
  dy: c,
  dispatch: u
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: r, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    identifier: { value: a, enumerable: !0, configurable: !0 },
    active: { value: i, enumerable: !0, configurable: !0 },
    x: { value: o, enumerable: !0, configurable: !0 },
    y: { value: s, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: c, enumerable: !0, configurable: !0 },
    _: { value: u }
  });
}
Hfe.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function sun(t) {
  return !t.ctrlKey && !t.button;
}
function lun() {
  return this.parentNode;
}
function cun(t, e) {
  return e ?? { x: t.x, y: t.y };
}
function uun() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function hgt() {
  var t = sun, e = lun, r = cun, n = uun, a = {}, i = VH("start", "drag", "end"), o = 0, s, l, c, u, f = 0;
  function h(x) {
    x.on("mousedown.drag", p).filter(n).on("touchstart.drag", b).on("touchmove.drag", w, oun).on("touchend.drag touchcancel.drag", _).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function p(x, S) {
    if (!(u || !t.call(this, x, S))) {
      var A = C(this, e.call(this, x, S), x, S, "mouse");
      A && (a0(x.view).on("mousemove.drag", g, yI).on("mouseup.drag", y, yI), dgt(x.view), Zoe(x), c = !1, s = x.clientX, l = x.clientY, A("start", x));
    }
  }
  function g(x) {
    if (R7(x), !c) {
      var S = x.clientX - s, A = x.clientY - l;
      c = S * S + A * A > f;
    }
    a.mouse("drag", x);
  }
  function y(x) {
    a0(x.view).on("mousemove.drag mouseup.drag", null), fgt(x.view, c), R7(x), a.mouse("end", x);
  }
  function b(x, S) {
    if (t.call(this, x, S)) {
      var A = x.changedTouches, I = e.call(this, x, S), M = A.length, B, L;
      for (B = 0; B < M; ++B)
        (L = C(this, I, x, S, A[B].identifier, A[B])) && (Zoe(x), L("start", x, A[B]));
    }
  }
  function w(x) {
    var S = x.changedTouches, A = S.length, I, M;
    for (I = 0; I < A; ++I)
      (M = a[S[I].identifier]) && (R7(x), M("drag", x, S[I]));
  }
  function _(x) {
    var S = x.changedTouches, A = S.length, I, M;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), I = 0; I < A; ++I)
      (M = a[S[I].identifier]) && (Zoe(x), M("end", x, S[I]));
  }
  function C(x, S, A, I, M, B) {
    var L = i.copy(), N = c1(B || A, S), d, m, v;
    if ((v = r.call(x, new Hfe("beforestart", {
      sourceEvent: A,
      target: h,
      identifier: M,
      active: o,
      x: N[0],
      y: N[1],
      dx: 0,
      dy: 0,
      dispatch: L
    }), I)) != null)
      return d = v.x - N[0] || 0, m = v.y - N[1] || 0, function k(O, G, H) {
        var j = N, F;
        switch (O) {
          case "start":
            a[M] = k, F = o++;
            break;
          case "end":
            delete a[M], --o;
          // falls through
          case "drag":
            N = c1(H || G, S), F = o;
            break;
        }
        L.call(
          O,
          x,
          new Hfe(O, {
            sourceEvent: G,
            subject: v,
            target: h,
            identifier: M,
            active: F,
            x: N[0] + d,
            y: N[1] + m,
            dx: N[0] - j[0],
            dy: N[1] - j[1],
            dispatch: L
          }),
          I
        );
      };
  }
  return h.filter = function(x) {
    return arguments.length ? (t = typeof x == "function" ? x : _N(!!x), h) : t;
  }, h.container = function(x) {
    return arguments.length ? (e = typeof x == "function" ? x : _N(x), h) : e;
  }, h.subject = function(x) {
    return arguments.length ? (r = typeof x == "function" ? x : _N(x), h) : r;
  }, h.touchable = function(x) {
    return arguments.length ? (n = typeof x == "function" ? x : _N(!!x), h) : n;
  }, h.on = function() {
    var x = i.on.apply(i, arguments);
    return x === i ? h : x;
  }, h.clickDistance = function(x) {
    return arguments.length ? (f = (x = +x) * x, h) : Math.sqrt(f);
  }, h;
}
var c8 = 0, m_ = 0, SS = 0, pgt = 1e3, HF, g_, UF = 0, z5 = 0, KH = 0, bI = typeof performance == "object" && performance.now ? performance : Date, mgt = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Mbe() {
  return z5 || (mgt(dun), z5 = bI.now() + KH);
}
function dun() {
  z5 = 0;
}
function VF() {
  this._call = this._time = this._next = null;
}
VF.prototype = ggt.prototype = {
  constructor: VF,
  restart: function(t, e, r) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    r = (r == null ? Mbe() : +r) + (e == null ? 0 : +e), !this._next && g_ !== this && (g_ ? g_._next = this : HF = this, g_ = this), this._call = t, this._time = r, Ufe();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Ufe());
  }
};
function ggt(t, e, r) {
  var n = new VF();
  return n.restart(t, e, r), n;
}
function fun() {
  Mbe(), ++c8;
  for (var t = HF, e; t; )
    (e = z5 - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --c8;
}
function WFe() {
  z5 = (UF = bI.now()) + KH, c8 = m_ = 0;
  try {
    fun();
  } finally {
    c8 = 0, pun(), z5 = 0;
  }
}
function hun() {
  var t = bI.now(), e = t - UF;
  e > pgt && (KH -= e, UF = t);
}
function pun() {
  for (var t, e = HF, r, n = 1 / 0; e; )
    e._call ? (n > e._time && (n = e._time), t = e, e = e._next) : (r = e._next, e._next = null, e = t ? t._next = r : HF = r);
  g_ = t, Ufe(n);
}
function Ufe(t) {
  if (!c8) {
    m_ && (m_ = clearTimeout(m_));
    var e = t - z5;
    e > 24 ? (t < 1 / 0 && (m_ = setTimeout(WFe, t - bI.now() - KH)), SS && (SS = clearInterval(SS))) : (SS || (UF = bI.now(), SS = setInterval(hun, pgt)), c8 = 1, mgt(WFe));
  }
}
function HFe(t, e, r) {
  var n = new VF();
  return e = e == null ? 0 : +e, n.restart((a) => {
    n.stop(), t(a + e);
  }, e, r), n;
}
var mun = VH("start", "end", "cancel", "interrupt"), gun = [], vgt = 0, UFe = 1, Vfe = 2, L$ = 3, VFe = 4, qfe = 5, j$ = 6;
function ZH(t, e, r, n, a, i) {
  var o = t.__transition;
  if (!o) t.__transition = {};
  else if (r in o) return;
  vun(t, r, {
    name: e,
    index: n,
    // For context during callback.
    group: a,
    // For context during callback.
    on: mun,
    tween: gun,
    time: i.time,
    delay: i.delay,
    duration: i.duration,
    ease: i.ease,
    timer: null,
    state: vgt
  });
}
function Pbe(t, e) {
  var r = g2(t, e);
  if (r.state > vgt) throw new Error("too late; already scheduled");
  return r;
}
function up(t, e) {
  var r = g2(t, e);
  if (r.state > L$) throw new Error("too late; already running");
  return r;
}
function g2(t, e) {
  var r = t.__transition;
  if (!r || !(r = r[e])) throw new Error("transition not found");
  return r;
}
function vun(t, e, r) {
  var n = t.__transition, a;
  n[e] = r, r.timer = ggt(i, 0, r.time);
  function i(c) {
    r.state = UFe, r.timer.restart(o, r.delay, r.time), r.delay <= c && o(c - r.delay);
  }
  function o(c) {
    var u, f, h, p;
    if (r.state !== UFe) return l();
    for (u in n)
      if (p = n[u], p.name === r.name) {
        if (p.state === L$) return HFe(o);
        p.state === VFe ? (p.state = j$, p.timer.stop(), p.on.call("interrupt", t, t.__data__, p.index, p.group), delete n[u]) : +u < e && (p.state = j$, p.timer.stop(), p.on.call("cancel", t, t.__data__, p.index, p.group), delete n[u]);
      }
    if (HFe(function() {
      r.state === L$ && (r.state = VFe, r.timer.restart(s, r.delay, r.time), s(c));
    }), r.state = Vfe, r.on.call("start", t, t.__data__, r.index, r.group), r.state === Vfe) {
      for (r.state = L$, a = new Array(h = r.tween.length), u = 0, f = -1; u < h; ++u)
        (p = r.tween[u].value.call(t, t.__data__, r.index, r.group)) && (a[++f] = p);
      a.length = f + 1;
    }
  }
  function s(c) {
    for (var u = c < r.duration ? r.ease.call(null, c / r.duration) : (r.timer.restart(l), r.state = qfe, 1), f = -1, h = a.length; ++f < h; )
      a[f].call(t, u);
    r.state === qfe && (r.on.call("end", t, t.__data__, r.index, r.group), l());
  }
  function l() {
    r.state = j$, r.timer.stop(), delete n[e];
    for (var c in n) return;
    delete t.__transition;
  }
}
function F$(t, e) {
  var r = t.__transition, n, a, i = !0, o;
  if (r) {
    e = e == null ? null : e + "";
    for (o in r) {
      if ((n = r[o]).name !== e) {
        i = !1;
        continue;
      }
      a = n.state > Vfe && n.state < qfe, n.state = j$, n.timer.stop(), n.on.call(a ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete r[o];
    }
    i && delete t.__transition;
  }
}
function yun(t) {
  return this.each(function() {
    F$(this, t);
  });
}
function bun(t, e) {
  var r, n;
  return function() {
    var a = up(this, t), i = a.tween;
    if (i !== r) {
      n = r = i;
      for (var o = 0, s = n.length; o < s; ++o)
        if (n[o].name === e) {
          n = n.slice(), n.splice(o, 1);
          break;
        }
    }
    a.tween = n;
  };
}
function xun(t, e, r) {
  var n, a;
  if (typeof r != "function") throw new Error();
  return function() {
    var i = up(this, t), o = i.tween;
    if (o !== n) {
      a = (n = o).slice();
      for (var s = { name: e, value: r }, l = 0, c = a.length; l < c; ++l)
        if (a[l].name === e) {
          a[l] = s;
          break;
        }
      l === c && a.push(s);
    }
    i.tween = a;
  };
}
function Cun(t, e) {
  var r = this._id;
  if (t += "", arguments.length < 2) {
    for (var n = g2(this.node(), r).tween, a = 0, i = n.length, o; a < i; ++a)
      if ((o = n[a]).name === t)
        return o.value;
    return null;
  }
  return this.each((e == null ? bun : xun)(r, t, e));
}
function Rbe(t, e, r) {
  var n = t._id;
  return t.each(function() {
    var a = up(this, n);
    (a.value || (a.value = {}))[e] = r.apply(this, arguments);
  }), function(a) {
    return g2(a, n).value[e];
  };
}
function ygt(t, e) {
  var r;
  return (typeof e == "number" ? f1 : e instanceof R5 ? Pj : (r = R5(e)) ? (e = r, Pj) : Xut)(t, e);
}
function wun(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Sun(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function _un(t, e, r) {
  var n, a = r + "", i;
  return function() {
    var o = this.getAttribute(t);
    return o === a ? null : o === n ? i : i = e(n = o, r);
  };
}
function kun(t, e, r) {
  var n, a = r + "", i;
  return function() {
    var o = this.getAttributeNS(t.space, t.local);
    return o === a ? null : o === n ? i : i = e(n = o, r);
  };
}
function Aun(t, e, r) {
  var n, a, i;
  return function() {
    var o, s = r(this), l;
    return s == null ? void this.removeAttribute(t) : (o = this.getAttribute(t), l = s + "", o === l ? null : o === n && l === a ? i : (a = l, i = e(n = o, s)));
  };
}
function Tun(t, e, r) {
  var n, a, i;
  return function() {
    var o, s = r(this), l;
    return s == null ? void this.removeAttributeNS(t.space, t.local) : (o = this.getAttributeNS(t.space, t.local), l = s + "", o === l ? null : o === n && l === a ? i : (a = l, i = e(n = o, s)));
  };
}
function Eun(t, e) {
  var r = qH(t), n = r === "transform" ? ZMr : ygt;
  return this.attrTween(t, typeof e == "function" ? (r.local ? Tun : Aun)(r, n, Rbe(this, "attr." + t, e)) : e == null ? (r.local ? Sun : wun)(r) : (r.local ? kun : _un)(r, n, e));
}
function Iun(t, e) {
  return function(r) {
    this.setAttribute(t, e.call(this, r));
  };
}
function Mun(t, e) {
  return function(r) {
    this.setAttributeNS(t.space, t.local, e.call(this, r));
  };
}
function Pun(t, e) {
  var r, n;
  function a() {
    var i = e.apply(this, arguments);
    return i !== n && (r = (n = i) && Mun(t, i)), r;
  }
  return a._value = e, a;
}
function Run(t, e) {
  var r, n;
  function a() {
    var i = e.apply(this, arguments);
    return i !== n && (r = (n = i) && Iun(t, i)), r;
  }
  return a._value = e, a;
}
function Oun(t, e) {
  var r = "attr." + t;
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  var n = qH(t);
  return this.tween(r, (n.local ? Pun : Run)(n, e));
}
function Nun(t, e) {
  return function() {
    Pbe(this, t).delay = +e.apply(this, arguments);
  };
}
function $un(t, e) {
  return e = +e, function() {
    Pbe(this, t).delay = e;
  };
}
function Dun(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Nun : $un)(e, t)) : g2(this.node(), e).delay;
}
function Lun(t, e) {
  return function() {
    up(this, t).duration = +e.apply(this, arguments);
  };
}
function jun(t, e) {
  return e = +e, function() {
    up(this, t).duration = e;
  };
}
function Fun(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Lun : jun)(e, t)) : g2(this.node(), e).duration;
}
function zun(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    up(this, t).ease = e;
  };
}
function Gun(t) {
  var e = this._id;
  return arguments.length ? this.each(zun(e, t)) : g2(this.node(), e).ease;
}
function Wun(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    if (typeof r != "function") throw new Error();
    up(this, t).ease = r;
  };
}
function Hun(t) {
  if (typeof t != "function") throw new Error();
  return this.each(Wun(this._id, t));
}
function Uun(t) {
  typeof t != "function" && (t = tgt(t));
  for (var e = this._groups, r = e.length, n = new Array(r), a = 0; a < r; ++a)
    for (var i = e[a], o = i.length, s = n[a] = [], l, c = 0; c < o; ++c)
      (l = i[c]) && t.call(l, l.__data__, c, i) && s.push(l);
  return new ag(n, this._parents, this._name, this._id);
}
function Vun(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, r = t._groups, n = e.length, a = r.length, i = Math.min(n, a), o = new Array(n), s = 0; s < i; ++s)
    for (var l = e[s], c = r[s], u = l.length, f = o[s] = new Array(u), h, p = 0; p < u; ++p)
      (h = l[p] || c[p]) && (f[p] = h);
  for (; s < n; ++s)
    o[s] = e[s];
  return new ag(o, this._parents, this._name, this._id);
}
function qun(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var r = e.indexOf(".");
    return r >= 0 && (e = e.slice(0, r)), !e || e === "start";
  });
}
function Kun(t, e, r) {
  var n, a, i = qun(e) ? Pbe : up;
  return function() {
    var o = i(this, t), s = o.on;
    s !== n && (a = (n = s).copy()).on(e, r), o.on = a;
  };
}
function Zun(t, e) {
  var r = this._id;
  return arguments.length < 2 ? g2(this.node(), r).on.on(t) : this.each(Kun(r, t, e));
}
function Jun(t) {
  return function() {
    var e = this.parentNode;
    for (var r in this.__transition) if (+r !== t) return;
    e && e.removeChild(this);
  };
}
function Yun() {
  return this.on("end.remove", Jun(this._id));
}
function Xun(t) {
  var e = this._name, r = this._id;
  typeof t != "function" && (t = Ebe(t));
  for (var n = this._groups, a = n.length, i = new Array(a), o = 0; o < a; ++o)
    for (var s = n[o], l = s.length, c = i[o] = new Array(l), u, f, h = 0; h < l; ++h)
      (u = s[h]) && (f = t.call(u, u.__data__, h, s)) && ("__data__" in u && (f.__data__ = u.__data__), c[h] = f, ZH(c[h], e, r, h, c, g2(u, r)));
  return new ag(i, this._parents, e, r);
}
function Qun(t) {
  var e = this._name, r = this._id;
  typeof t != "function" && (t = egt(t));
  for (var n = this._groups, a = n.length, i = [], o = [], s = 0; s < a; ++s)
    for (var l = n[s], c = l.length, u, f = 0; f < c; ++f)
      if (u = l[f]) {
        for (var h = t.call(u, u.__data__, f, l), p, g = g2(u, r), y = 0, b = h.length; y < b; ++y)
          (p = h[y]) && ZH(p, e, r, y, h, g);
        i.push(h), o.push(u);
      }
  return new ag(i, o, e, r);
}
var edn = wP.prototype.constructor;
function tdn() {
  return new edn(this._groups, this._parents);
}
function rdn(t, e) {
  var r, n, a;
  return function() {
    var i = l8(this, t), o = (this.style.removeProperty(t), l8(this, t));
    return i === o ? null : i === r && o === n ? a : a = e(r = i, n = o);
  };
}
function bgt(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function ndn(t, e, r) {
  var n, a = r + "", i;
  return function() {
    var o = l8(this, t);
    return o === a ? null : o === n ? i : i = e(n = o, r);
  };
}
function adn(t, e, r) {
  var n, a, i;
  return function() {
    var o = l8(this, t), s = r(this), l = s + "";
    return s == null && (l = s = (this.style.removeProperty(t), l8(this, t))), o === l ? null : o === n && l === a ? i : (a = l, i = e(n = o, s));
  };
}
function idn(t, e) {
  var r, n, a, i = "style." + e, o = "end." + i, s;
  return function() {
    var l = up(this, t), c = l.on, u = l.value[i] == null ? s || (s = bgt(e)) : void 0;
    (c !== r || a !== u) && (n = (r = c).copy()).on(o, a = u), l.on = n;
  };
}
function odn(t, e, r) {
  var n = (t += "") == "transform" ? KMr : ygt;
  return e == null ? this.styleTween(t, rdn(t, n)).on("end.style." + t, bgt(t)) : typeof e == "function" ? this.styleTween(t, adn(t, n, Rbe(this, "style." + t, e))).each(idn(this._id, t)) : this.styleTween(t, ndn(t, n, e), r).on("end.style." + t, null);
}
function sdn(t, e, r) {
  return function(n) {
    this.style.setProperty(t, e.call(this, n), r);
  };
}
function ldn(t, e, r) {
  var n, a;
  function i() {
    var o = e.apply(this, arguments);
    return o !== a && (n = (a = o) && sdn(t, o, r)), n;
  }
  return i._value = e, i;
}
function cdn(t, e, r) {
  var n = "style." + (t += "");
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  return this.tween(n, ldn(t, e, r ?? ""));
}
function udn(t) {
  return function() {
    this.textContent = t;
  };
}
function ddn(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function fdn(t) {
  return this.tween("text", typeof t == "function" ? ddn(Rbe(this, "text", t)) : udn(t == null ? "" : t + ""));
}
function hdn(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function pdn(t) {
  var e, r;
  function n() {
    var a = t.apply(this, arguments);
    return a !== r && (e = (r = a) && hdn(a)), e;
  }
  return n._value = t, n;
}
function mdn(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, pdn(t));
}
function gdn() {
  for (var t = this._name, e = this._id, r = xgt(), n = this._groups, a = n.length, i = 0; i < a; ++i)
    for (var o = n[i], s = o.length, l, c = 0; c < s; ++c)
      if (l = o[c]) {
        var u = g2(l, e);
        ZH(l, t, r, c, o, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new ag(n, this._parents, t, r);
}
function vdn() {
  var t, e, r = this, n = r._id, a = r.size();
  return new Promise(function(i, o) {
    var s = { value: o }, l = { value: function() {
      --a === 0 && i();
    } };
    r.each(function() {
      var c = up(this, n), u = c.on;
      u !== t && (e = (t = u).copy(), e._.cancel.push(s), e._.interrupt.push(s), e._.end.push(l)), c.on = e;
    }), a === 0 && i();
  });
}
var ydn = 0;
function ag(t, e, r, n) {
  this._groups = t, this._parents = e, this._name = r, this._id = n;
}
function xgt() {
  return ++ydn;
}
var zp = wP.prototype;
ag.prototype = {
  constructor: ag,
  select: Xun,
  selectAll: Qun,
  selectChild: zp.selectChild,
  selectChildren: zp.selectChildren,
  filter: Uun,
  merge: Vun,
  selection: tdn,
  transition: gdn,
  call: zp.call,
  nodes: zp.nodes,
  node: zp.node,
  size: zp.size,
  empty: zp.empty,
  each: zp.each,
  on: Zun,
  attr: Eun,
  attrTween: Oun,
  style: odn,
  styleTween: cdn,
  text: fdn,
  textTween: mdn,
  remove: Yun,
  tween: Cun,
  delay: Dun,
  duration: Fun,
  ease: Gun,
  easeVarying: Hun,
  end: vdn,
  [Symbol.iterator]: zp[Symbol.iterator]
};
function bdn(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var xdn = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: bdn
};
function Cdn(t, e) {
  for (var r; !(r = t.__transition) || !(r = r[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return r;
}
function wdn(t) {
  var e, r;
  t instanceof ag ? (e = t._id, t = t._name) : (e = xgt(), (r = xdn).time = Mbe(), t = t == null ? null : t + "");
  for (var n = this._groups, a = n.length, i = 0; i < a; ++i)
    for (var o = n[i], s = o.length, l, c = 0; c < s; ++c)
      (l = o[c]) && ZH(l, t, e, c, o, r || Cdn(l, e));
  return new ag(n, this._parents, t, e);
}
wP.prototype.interrupt = yun;
wP.prototype.transition = wdn;
const kN = (t) => () => t;
function Sdn(t, {
  sourceEvent: e,
  target: r,
  transform: n,
  dispatch: a
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    transform: { value: n, enumerable: !0, configurable: !0 },
    _: { value: a }
  });
}
function km(t, e, r) {
  this.k = t, this.x = e, this.y = r;
}
km.prototype = {
  constructor: km,
  scale: function(t) {
    return t === 1 ? this : new km(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new km(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var JH = new km(1, 0, 0);
Cgt.prototype = km.prototype;
function Cgt(t) {
  for (; !t.__zoom; ) if (!(t = t.parentNode)) return JH;
  return t.__zoom;
}
function Joe(t) {
  t.stopImmediatePropagation();
}
function _S(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function _dn(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function kdn() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function qFe() {
  return this.__zoom || JH;
}
function Adn(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function Tdn() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function Edn(t, e, r) {
  var n = t.invertX(e[0][0]) - r[0][0], a = t.invertX(e[1][0]) - r[1][0], i = t.invertY(e[0][1]) - r[0][1], o = t.invertY(e[1][1]) - r[1][1];
  return t.translate(
    a > n ? (n + a) / 2 : Math.min(0, n) || Math.max(0, a),
    o > i ? (i + o) / 2 : Math.min(0, i) || Math.max(0, o)
  );
}
function wgt() {
  var t = _dn, e = kdn, r = Edn, n = Adn, a = Tdn, i = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], s = 250, l = QMr, c = VH("start", "zoom", "end"), u, f, h, p = 500, g = 150, y = 0, b = 10;
  function w(v) {
    v.property("__zoom", qFe).on("wheel.zoom", M, { passive: !1 }).on("mousedown.zoom", B).on("dblclick.zoom", L).filter(a).on("touchstart.zoom", N).on("touchmove.zoom", d).on("touchend.zoom touchcancel.zoom", m).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  w.transform = function(v, k, O, G) {
    var H = v.selection ? v.selection() : v;
    H.property("__zoom", qFe), v !== H ? S(v, k, O, G) : H.interrupt().each(function() {
      A(this, arguments).event(G).start().zoom(null, typeof k == "function" ? k.apply(this, arguments) : k).end();
    });
  }, w.scaleBy = function(v, k, O, G) {
    w.scaleTo(v, function() {
      var H = this.__zoom.k, j = typeof k == "function" ? k.apply(this, arguments) : k;
      return H * j;
    }, O, G);
  }, w.scaleTo = function(v, k, O, G) {
    w.transform(v, function() {
      var H = e.apply(this, arguments), j = this.__zoom, F = O == null ? x(H) : typeof O == "function" ? O.apply(this, arguments) : O, z = j.invert(F), W = typeof k == "function" ? k.apply(this, arguments) : k;
      return r(C(_(j, W), F, z), H, o);
    }, O, G);
  }, w.translateBy = function(v, k, O, G) {
    w.transform(v, function() {
      return r(this.__zoom.translate(
        typeof k == "function" ? k.apply(this, arguments) : k,
        typeof O == "function" ? O.apply(this, arguments) : O
      ), e.apply(this, arguments), o);
    }, null, G);
  }, w.translateTo = function(v, k, O, G, H) {
    w.transform(v, function() {
      var j = e.apply(this, arguments), F = this.__zoom, z = G == null ? x(j) : typeof G == "function" ? G.apply(this, arguments) : G;
      return r(JH.translate(z[0], z[1]).scale(F.k).translate(
        typeof k == "function" ? -k.apply(this, arguments) : -k,
        typeof O == "function" ? -O.apply(this, arguments) : -O
      ), j, o);
    }, G, H);
  };
  function _(v, k) {
    return k = Math.max(i[0], Math.min(i[1], k)), k === v.k ? v : new km(k, v.x, v.y);
  }
  function C(v, k, O) {
    var G = k[0] - O[0] * v.k, H = k[1] - O[1] * v.k;
    return G === v.x && H === v.y ? v : new km(v.k, G, H);
  }
  function x(v) {
    return [(+v[0][0] + +v[1][0]) / 2, (+v[0][1] + +v[1][1]) / 2];
  }
  function S(v, k, O, G) {
    v.on("start.zoom", function() {
      A(this, arguments).event(G).start();
    }).on("interrupt.zoom end.zoom", function() {
      A(this, arguments).event(G).end();
    }).tween("zoom", function() {
      var H = this, j = arguments, F = A(H, j).event(G), z = e.apply(H, j), W = O == null ? x(z) : typeof O == "function" ? O.apply(H, j) : O, U = Math.max(z[1][0] - z[0][0], z[1][1] - z[0][1]), Z = H.__zoom, V = typeof k == "function" ? k.apply(H, j) : k, Y = l(Z.invert(W).concat(U / Z.k), V.invert(W).concat(U / V.k));
      return function(ge) {
        if (ge === 1) ge = V;
        else {
          var ce = Y(ge), ee = U / ce[2];
          ge = new km(ee, W[0] - ce[0] * ee, W[1] - ce[1] * ee);
        }
        F.zoom(null, ge);
      };
    });
  }
  function A(v, k, O) {
    return !O && v.__zooming || new I(v, k);
  }
  function I(v, k) {
    this.that = v, this.args = k, this.active = 0, this.sourceEvent = null, this.extent = e.apply(v, k), this.taps = 0;
  }
  I.prototype = {
    event: function(v) {
      return v && (this.sourceEvent = v), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(v, k) {
      return this.mouse && v !== "mouse" && (this.mouse[1] = k.invert(this.mouse[0])), this.touch0 && v !== "touch" && (this.touch0[1] = k.invert(this.touch0[0])), this.touch1 && v !== "touch" && (this.touch1[1] = k.invert(this.touch1[0])), this.that.__zoom = k, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(v) {
      var k = a0(this.that).datum();
      c.call(
        v,
        this.that,
        new Sdn(v, {
          sourceEvent: this.sourceEvent,
          target: w,
          transform: this.that.__zoom,
          dispatch: c
        }),
        k
      );
    }
  };
  function M(v, ...k) {
    if (!t.apply(this, arguments)) return;
    var O = A(this, k).event(v), G = this.__zoom, H = Math.max(i[0], Math.min(i[1], G.k * Math.pow(2, n.apply(this, arguments)))), j = c1(v);
    if (O.wheel)
      (O.mouse[0][0] !== j[0] || O.mouse[0][1] !== j[1]) && (O.mouse[1] = G.invert(O.mouse[0] = j)), clearTimeout(O.wheel);
    else {
      if (G.k === H) return;
      O.mouse = [j, G.invert(j)], F$(this), O.start();
    }
    _S(v), O.wheel = setTimeout(F, g), O.zoom("mouse", r(C(_(G, H), O.mouse[0], O.mouse[1]), O.extent, o));
    function F() {
      O.wheel = null, O.end();
    }
  }
  function B(v, ...k) {
    if (h || !t.apply(this, arguments)) return;
    var O = v.currentTarget, G = A(this, k, !0).event(v), H = a0(v.view).on("mousemove.zoom", W, !0).on("mouseup.zoom", U, !0), j = c1(v, O), F = v.clientX, z = v.clientY;
    dgt(v.view), Joe(v), G.mouse = [j, this.__zoom.invert(j)], F$(this), G.start();
    function W(Z) {
      if (_S(Z), !G.moved) {
        var V = Z.clientX - F, Y = Z.clientY - z;
        G.moved = V * V + Y * Y > y;
      }
      G.event(Z).zoom("mouse", r(C(G.that.__zoom, G.mouse[0] = c1(Z, O), G.mouse[1]), G.extent, o));
    }
    function U(Z) {
      H.on("mousemove.zoom mouseup.zoom", null), fgt(Z.view, G.moved), _S(Z), G.event(Z).end();
    }
  }
  function L(v, ...k) {
    if (t.apply(this, arguments)) {
      var O = this.__zoom, G = c1(v.changedTouches ? v.changedTouches[0] : v, this), H = O.invert(G), j = O.k * (v.shiftKey ? 0.5 : 2), F = r(C(_(O, j), G, H), e.apply(this, k), o);
      _S(v), s > 0 ? a0(this).transition().duration(s).call(S, F, G, v) : a0(this).call(w.transform, F, G, v);
    }
  }
  function N(v, ...k) {
    if (t.apply(this, arguments)) {
      var O = v.touches, G = O.length, H = A(this, k, v.changedTouches.length === G).event(v), j, F, z, W;
      for (Joe(v), F = 0; F < G; ++F)
        z = O[F], W = c1(z, this), W = [W, this.__zoom.invert(W), z.identifier], H.touch0 ? !H.touch1 && H.touch0[2] !== W[2] && (H.touch1 = W, H.taps = 0) : (H.touch0 = W, j = !0, H.taps = 1 + !!u);
      u && (u = clearTimeout(u)), j && (H.taps < 2 && (f = W[0], u = setTimeout(function() {
        u = null;
      }, p)), F$(this), H.start());
    }
  }
  function d(v, ...k) {
    if (this.__zooming) {
      var O = A(this, k).event(v), G = v.changedTouches, H = G.length, j, F, z, W;
      for (_S(v), j = 0; j < H; ++j)
        F = G[j], z = c1(F, this), O.touch0 && O.touch0[2] === F.identifier ? O.touch0[0] = z : O.touch1 && O.touch1[2] === F.identifier && (O.touch1[0] = z);
      if (F = O.that.__zoom, O.touch1) {
        var U = O.touch0[0], Z = O.touch0[1], V = O.touch1[0], Y = O.touch1[1], ge = (ge = V[0] - U[0]) * ge + (ge = V[1] - U[1]) * ge, ce = (ce = Y[0] - Z[0]) * ce + (ce = Y[1] - Z[1]) * ce;
        F = _(F, Math.sqrt(ge / ce)), z = [(U[0] + V[0]) / 2, (U[1] + V[1]) / 2], W = [(Z[0] + Y[0]) / 2, (Z[1] + Y[1]) / 2];
      } else if (O.touch0) z = O.touch0[0], W = O.touch0[1];
      else return;
      O.zoom("touch", r(C(F, z, W), O.extent, o));
    }
  }
  function m(v, ...k) {
    if (this.__zooming) {
      var O = A(this, k).event(v), G = v.changedTouches, H = G.length, j, F;
      for (Joe(v), h && clearTimeout(h), h = setTimeout(function() {
        h = null;
      }, p), j = 0; j < H; ++j)
        F = G[j], O.touch0 && O.touch0[2] === F.identifier ? delete O.touch0 : O.touch1 && O.touch1[2] === F.identifier && delete O.touch1;
      if (O.touch1 && !O.touch0 && (O.touch0 = O.touch1, delete O.touch1), O.touch0) O.touch0[1] = this.__zoom.invert(O.touch0[0]);
      else if (O.end(), O.taps === 2 && (F = c1(F, this), Math.hypot(f[0] - F[0], f[1] - F[1]) < b)) {
        var z = a0(this).on("dblclick.zoom");
        z && z.apply(this, arguments);
      }
    }
  }
  return w.wheelDelta = function(v) {
    return arguments.length ? (n = typeof v == "function" ? v : kN(+v), w) : n;
  }, w.filter = function(v) {
    return arguments.length ? (t = typeof v == "function" ? v : kN(!!v), w) : t;
  }, w.touchable = function(v) {
    return arguments.length ? (a = typeof v == "function" ? v : kN(!!v), w) : a;
  }, w.extent = function(v) {
    return arguments.length ? (e = typeof v == "function" ? v : kN([[+v[0][0], +v[0][1]], [+v[1][0], +v[1][1]]]), w) : e;
  }, w.scaleExtent = function(v) {
    return arguments.length ? (i[0] = +v[0], i[1] = +v[1], w) : [i[0], i[1]];
  }, w.translateExtent = function(v) {
    return arguments.length ? (o[0][0] = +v[0][0], o[1][0] = +v[1][0], o[0][1] = +v[0][1], o[1][1] = +v[1][1], w) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, w.constrain = function(v) {
    return arguments.length ? (r = v, w) : r;
  }, w.duration = function(v) {
    return arguments.length ? (s = +v, w) : s;
  }, w.interpolate = function(v) {
    return arguments.length ? (l = v, w) : l;
  }, w.on = function() {
    var v = c.on.apply(c, arguments);
    return v === c ? w : v;
  }, w.clickDistance = function(v) {
    return arguments.length ? (y = (v = +v) * v, w) : Math.sqrt(y);
  }, w.tapDistance = function(v) {
    return arguments.length ? (b = +v, w) : b;
  }, w;
}
const m0 = {
  error001: () => "[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001",
  error002: () => "It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
  error003: (t) => `Node type "${t}" not found. Using fallback type "default".`,
  error004: () => "The React Flow parent container needs a width and a height to render the graph.",
  error005: () => "Only child nodes can use a parent extent.",
  error006: () => "Can't create edge. An edge needs a source and a target.",
  error007: (t) => `The old edge with id=${t} does not exist.`,
  error009: (t) => `Marker type "${t}" doesn't exist.`,
  error008: (t, { id: e, sourceHandle: r, targetHandle: n }) => `Couldn't create edge for ${t} handle id: "${t === "source" ? r : n}", edge id: ${e}.`,
  error010: () => "Handle: No node id found. Make sure to only use a Handle inside a custom Node.",
  error011: (t) => `Edge type "${t}" not found. Using fallback type "default".`,
  error012: (t) => `Node with id "${t}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`,
  error013: (t = "react") => `It seems that you haven't loaded the styles. Please import '@xyflow/${t}/dist/style.css' or base.css to make sure everything is working properly.`,
  error014: () => "useNodeConnections: No node ID found. Call useNodeConnections inside a custom Node or provide a node ID.",
  error015: () => "It seems that you are trying to drag a node that is not initialized. Please use onNodesChange as explained in the docs."
}, xI = [
  [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
  [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
], Sgt = ["Enter", " ", "Escape"];
var u8;
(function(t) {
  t.Strict = "strict", t.Loose = "loose";
})(u8 || (u8 = {}));
var Yb;
(function(t) {
  t.Free = "free", t.Vertical = "vertical", t.Horizontal = "horizontal";
})(Yb || (Yb = {}));
var CI;
(function(t) {
  t.Partial = "partial", t.Full = "full";
})(CI || (CI = {}));
const _gt = {
  inProgress: !1,
  isValid: null,
  from: null,
  fromHandle: null,
  fromPosition: null,
  fromNode: null,
  to: null,
  toHandle: null,
  toPosition: null,
  toNode: null
};
var bv;
(function(t) {
  t.Bezier = "default", t.Straight = "straight", t.Step = "step", t.SmoothStep = "smoothstep", t.SimpleBezier = "simplebezier";
})(bv || (bv = {}));
var qF;
(function(t) {
  t.Arrow = "arrow", t.ArrowClosed = "arrowclosed";
})(qF || (qF = {}));
var Hn;
(function(t) {
  t.Left = "left", t.Top = "top", t.Right = "right", t.Bottom = "bottom";
})(Hn || (Hn = {}));
const KFe = {
  [Hn.Left]: Hn.Right,
  [Hn.Right]: Hn.Left,
  [Hn.Top]: Hn.Bottom,
  [Hn.Bottom]: Hn.Top
};
function kgt(t) {
  return t === null ? null : t ? "valid" : "invalid";
}
const Agt = (t) => "id" in t && "source" in t && "target" in t, Idn = (t) => "id" in t && "position" in t && !("source" in t) && !("target" in t), Obe = (t) => "id" in t && "internals" in t && !("source" in t) && !("target" in t), SP = (t, e = [0, 0]) => {
  const { width: r, height: n } = wg(t), a = t.origin ?? e, i = r * a[0], o = n * a[1];
  return {
    x: t.position.x - i,
    y: t.position.y - o
  };
}, Mdn = (t, e = { nodeOrigin: [0, 0], nodeLookup: void 0 }) => {
  if (Qa.env.NODE_ENV === "development" && !e.nodeLookup && console.warn("Please use `getNodesBounds` from `useReactFlow`/`useSvelteFlow` hook to ensure correct values for sub flows. If not possible, you have to provide a nodeLookup to support sub flows."), t.length === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  const r = t.reduce((n, a) => {
    const i = typeof a == "string";
    let o = !e.nodeLookup && !i ? a : void 0;
    e.nodeLookup && (o = i ? e.nodeLookup.get(a) : Obe(a) ? a : e.nodeLookup.get(a.id));
    const s = o ? KF(o, e.nodeOrigin) : { x: 0, y: 0, x2: 0, y2: 0 };
    return YH(n, s);
  }, { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 });
  return XH(r);
}, _P = (t, e = {}) => {
  if (t.size === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  let r = { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 };
  return t.forEach((n) => {
    if (e.filter === void 0 || e.filter(n)) {
      const a = KF(n);
      r = YH(r, a);
    }
  }), XH(r);
}, Tgt = (t, e, [r, n, a] = [0, 0, 1], i = !1, o = !1) => {
  const s = {
    ...kP(e, [r, n, a]),
    width: e.width / a,
    height: e.height / a
  }, l = [];
  for (const c of t.values()) {
    const { measured: u, selectable: f = !0, hidden: h = !1 } = c;
    if (o && !f || h)
      continue;
    const p = u.width ?? c.width ?? c.initialWidth ?? null, g = u.height ?? c.height ?? c.initialHeight ?? null, y = wI(s, f8(c)), b = (p ?? 0) * (g ?? 0), w = i && y > 0;
    (!c.internals.handleBounds || w || y >= b || c.dragging) && l.push(c);
  }
  return l;
}, Pdn = (t, e) => {
  const r = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    r.add(n.id);
  }), e.filter((n) => r.has(n.source) || r.has(n.target));
};
function Kfe(t, e) {
  const r = /* @__PURE__ */ new Map(), n = e != null && e.nodes ? new Set(e.nodes.map((a) => a.id)) : null;
  return t.forEach((a) => {
    a.measured.width && a.measured.height && ((e == null ? void 0 : e.includeHiddenNodes) || !a.hidden) && (!n || n.has(a.id)) && r.set(a.id, a);
  }), r;
}
async function Zfe({ nodes: t, width: e, height: r, panZoom: n, minZoom: a, maxZoom: i }, o) {
  if (t.size === 0)
    return Promise.resolve(!1);
  const s = _P(t), l = Bbe(s, e, r, (o == null ? void 0 : o.minZoom) ?? a, (o == null ? void 0 : o.maxZoom) ?? i, (o == null ? void 0 : o.padding) ?? 0.1);
  return await n.setViewport(l, { duration: o == null ? void 0 : o.duration }), Promise.resolve(!0);
}
function Egt({ nodeId: t, nextPosition: e, nodeLookup: r, nodeOrigin: n = [0, 0], nodeExtent: a, onError: i }) {
  const o = r.get(t), s = o.parentId ? r.get(o.parentId) : void 0, { x: l, y: c } = s ? s.internals.positionAbsolute : { x: 0, y: 0 }, u = o.origin ?? n;
  let f = a;
  if (o.extent === "parent" && !o.expandParent)
    if (!s)
      i == null || i("005", m0.error005());
    else {
      const p = s.measured.width, g = s.measured.height;
      p && g && (f = [
        [l, c],
        [l + p, c + g]
      ]);
    }
  else s && h8(o.extent) && (f = [
    [o.extent[0][0] + l, o.extent[0][1] + c],
    [o.extent[1][0] + l, o.extent[1][1] + c]
  ]);
  const h = h8(f) ? G5(e, f, o.measured) : e;
  return (o.measured.width === void 0 || o.measured.height === void 0) && (i == null || i("015", m0.error015())), {
    position: {
      x: h.x - l + (o.measured.width ?? 0) * u[0],
      y: h.y - c + (o.measured.height ?? 0) * u[1]
    },
    positionAbsolute: h
  };
}
async function Rdn({ nodesToRemove: t = [], edgesToRemove: e = [], nodes: r, edges: n, onBeforeDelete: a }) {
  const i = new Set(t.map((h) => h.id)), o = [];
  for (const h of r) {
    if (h.deletable === !1)
      continue;
    const p = i.has(h.id), g = !p && h.parentId && o.find((y) => y.id === h.parentId);
    (p || g) && o.push(h);
  }
  const s = new Set(e.map((h) => h.id)), l = n.filter((h) => h.deletable !== !1), u = Pdn(o, l);
  for (const h of l)
    s.has(h.id) && !u.find((g) => g.id === h.id) && u.push(h);
  if (!a)
    return {
      edges: u,
      nodes: o
    };
  const f = await a({
    nodes: o,
    edges: u
  });
  return typeof f == "boolean" ? f ? { edges: u, nodes: o } : { edges: [], nodes: [] } : f;
}
const d8 = (t, e = 0, r = 1) => Math.min(Math.max(t, e), r), G5 = (t = { x: 0, y: 0 }, e, r) => ({
  x: d8(t.x, e[0][0], e[1][0] - ((r == null ? void 0 : r.width) ?? 0)),
  y: d8(t.y, e[0][1], e[1][1] - ((r == null ? void 0 : r.height) ?? 0))
});
function Igt(t, e, r) {
  const { width: n, height: a } = wg(r), { x: i, y: o } = r.internals.positionAbsolute;
  return G5(t, [
    [i, o],
    [i + n, o + a]
  ], e);
}
const ZFe = (t, e, r) => t < e ? d8(Math.abs(t - e), 1, e) / e : t > r ? -d8(Math.abs(t - r), 1, e) / e : 0, Mgt = (t, e, r = 15, n = 40) => {
  const a = ZFe(t.x, n, e.width - n) * r, i = ZFe(t.y, n, e.height - n) * r;
  return [a, i];
}, YH = (t, e) => ({
  x: Math.min(t.x, e.x),
  y: Math.min(t.y, e.y),
  x2: Math.max(t.x2, e.x2),
  y2: Math.max(t.y2, e.y2)
}), Jfe = ({ x: t, y: e, width: r, height: n }) => ({
  x: t,
  y: e,
  x2: t + r,
  y2: e + n
}), XH = ({ x: t, y: e, x2: r, y2: n }) => ({
  x: t,
  y: e,
  width: r - t,
  height: n - e
}), f8 = (t, e = [0, 0]) => {
  var a, i;
  const { x: r, y: n } = Obe(t) ? t.internals.positionAbsolute : SP(t, e);
  return {
    x: r,
    y: n,
    width: ((a = t.measured) == null ? void 0 : a.width) ?? t.width ?? t.initialWidth ?? 0,
    height: ((i = t.measured) == null ? void 0 : i.height) ?? t.height ?? t.initialHeight ?? 0
  };
}, KF = (t, e = [0, 0]) => {
  var a, i;
  const { x: r, y: n } = Obe(t) ? t.internals.positionAbsolute : SP(t, e);
  return {
    x: r,
    y: n,
    x2: r + (((a = t.measured) == null ? void 0 : a.width) ?? t.width ?? t.initialWidth ?? 0),
    y2: n + (((i = t.measured) == null ? void 0 : i.height) ?? t.height ?? t.initialHeight ?? 0)
  };
}, Pgt = (t, e) => XH(YH(Jfe(t), Jfe(e))), wI = (t, e) => {
  const r = Math.max(0, Math.min(t.x + t.width, e.x + e.width) - Math.max(t.x, e.x)), n = Math.max(0, Math.min(t.y + t.height, e.y + e.height) - Math.max(t.y, e.y));
  return Math.ceil(r * n);
}, JFe = (t) => x1(t.width) && x1(t.height) && x1(t.x) && x1(t.y), x1 = (t) => !isNaN(t) && isFinite(t), Rgt = (t, e) => {
  Qa.env.NODE_ENV === "development" && console.warn(`[React Flow]: ${e} Help: https://reactflow.dev/error#${t}`);
}, QH = (t, e = [1, 1]) => ({
  x: e[0] * Math.round(t.x / e[0]),
  y: e[1] * Math.round(t.y / e[1])
}), kP = ({ x: t, y: e }, [r, n, a], i = !1, o = [1, 1]) => {
  const s = {
    x: (t - r) / a,
    y: (e - n) / a
  };
  return i ? QH(s, o) : s;
}, Ogt = ({ x: t, y: e }, [r, n, a]) => ({
  x: t * a + r,
  y: e * a + n
}), Bbe = (t, e, r, n, a, i) => {
  const o = e / (t.width * (1 + i)), s = r / (t.height * (1 + i)), l = Math.min(o, s), c = d8(l, n, a), u = t.x + t.width / 2, f = t.y + t.height / 2, h = e / 2 - u * c, p = r / 2 - f * c;
  return { x: h, y: p, zoom: c };
}, ZF = () => {
  var t;
  return typeof navigator < "u" && ((t = navigator == null ? void 0 : navigator.userAgent) == null ? void 0 : t.indexOf("Mac")) >= 0;
};
function h8(t) {
  return t !== void 0 && t !== "parent";
}
function wg(t) {
  var e, r;
  return {
    width: ((e = t.measured) == null ? void 0 : e.width) ?? t.width ?? t.initialWidth ?? 0,
    height: ((r = t.measured) == null ? void 0 : r.height) ?? t.height ?? t.initialHeight ?? 0
  };
}
function Nbe(t) {
  var e, r;
  return (((e = t.measured) == null ? void 0 : e.width) ?? t.width ?? t.initialWidth) !== void 0 && (((r = t.measured) == null ? void 0 : r.height) ?? t.height ?? t.initialHeight) !== void 0;
}
function Bgt(t, e = { width: 0, height: 0 }, r, n, a) {
  const i = { ...t }, o = n.get(r);
  if (o) {
    const s = o.origin || a;
    i.x += o.internals.positionAbsolute.x - (e.width ?? 0) * s[0], i.y += o.internals.positionAbsolute.y - (e.height ?? 0) * s[1];
  }
  return i;
}
function YFe(t, e) {
  if (t.size !== e.size)
    return !1;
  for (const r of t)
    if (!e.has(r))
      return !1;
  return !0;
}
function X_(t, { snapGrid: e = [0, 0], snapToGrid: r = !1, transform: n, containerBounds: a }) {
  const { x: i, y: o } = Bm(t), s = kP({ x: i - ((a == null ? void 0 : a.left) ?? 0), y: o - ((a == null ? void 0 : a.top) ?? 0) }, n), { x: l, y: c } = r ? QH(s, e) : s;
  return {
    xSnapped: l,
    ySnapped: c,
    ...s
  };
}
const eU = (t) => ({
  width: t.offsetWidth,
  height: t.offsetHeight
}), Ngt = (t) => {
  var e;
  return ((e = t == null ? void 0 : t.getRootNode) == null ? void 0 : e.call(t)) || (window == null ? void 0 : window.document);
}, Odn = ["INPUT", "SELECT", "TEXTAREA"];
function Yfe(t) {
  var n, a;
  const e = ((a = (n = t.composedPath) == null ? void 0 : n.call(t)) == null ? void 0 : a[0]) || t.target;
  return (e == null ? void 0 : e.nodeType) !== 1 ? !1 : Odn.includes(e.nodeName) || e.hasAttribute("contenteditable") || !!e.closest(".nokey");
}
const $gt = (t) => "clientX" in t, Bm = (t, e) => {
  var i, o;
  const r = $gt(t), n = r ? t.clientX : (i = t.touches) == null ? void 0 : i[0].clientX, a = r ? t.clientY : (o = t.touches) == null ? void 0 : o[0].clientY;
  return {
    x: n - ((e == null ? void 0 : e.left) ?? 0),
    y: a - ((e == null ? void 0 : e.top) ?? 0)
  };
}, XFe = (t, e, r, n, a) => {
  const i = e.querySelectorAll(`.${t}`);
  return !i || !i.length ? null : Array.from(i).map((o) => {
    const s = o.getBoundingClientRect();
    return {
      id: o.getAttribute("data-handleid"),
      type: t,
      nodeId: a,
      position: o.getAttribute("data-handlepos"),
      x: (s.left - r.left) / n,
      y: (s.top - r.top) / n,
      ...eU(o)
    };
  });
};
function Dgt({ sourceX: t, sourceY: e, targetX: r, targetY: n, sourceControlX: a, sourceControlY: i, targetControlX: o, targetControlY: s }) {
  const l = t * 0.125 + a * 0.375 + o * 0.375 + r * 0.125, c = e * 0.125 + i * 0.375 + s * 0.375 + n * 0.125, u = Math.abs(l - t), f = Math.abs(c - e);
  return [l, c, u, f];
}
function AN(t, e) {
  return t >= 0 ? 0.5 * t : e * 25 * Math.sqrt(-t);
}
function QFe({ pos: t, x1: e, y1: r, x2: n, y2: a, c: i }) {
  switch (t) {
    case Hn.Left:
      return [e - AN(e - n, i), r];
    case Hn.Right:
      return [e + AN(n - e, i), r];
    case Hn.Top:
      return [e, r - AN(r - a, i)];
    case Hn.Bottom:
      return [e, r + AN(a - r, i)];
  }
}
function Lgt({ sourceX: t, sourceY: e, sourcePosition: r = Hn.Bottom, targetX: n, targetY: a, targetPosition: i = Hn.Top, curvature: o = 0.25 }) {
  const [s, l] = QFe({
    pos: r,
    x1: t,
    y1: e,
    x2: n,
    y2: a,
    c: o
  }), [c, u] = QFe({
    pos: i,
    x1: n,
    y1: a,
    x2: t,
    y2: e,
    c: o
  }), [f, h, p, g] = Dgt({
    sourceX: t,
    sourceY: e,
    targetX: n,
    targetY: a,
    sourceControlX: s,
    sourceControlY: l,
    targetControlX: c,
    targetControlY: u
  });
  return [
    `M${t},${e} C${s},${l} ${c},${u} ${n},${a}`,
    f,
    h,
    p,
    g
  ];
}
function jgt({ sourceX: t, sourceY: e, targetX: r, targetY: n }) {
  const a = Math.abs(r - t) / 2, i = r < t ? r + a : r - a, o = Math.abs(n - e) / 2, s = n < e ? n + o : n - o;
  return [i, s, a, o];
}
function Bdn({ sourceNode: t, targetNode: e, selected: r = !1, zIndex: n = 0, elevateOnSelect: a = !1 }) {
  if (!a)
    return n;
  const i = r || e.selected || t.selected, o = Math.max(t.internals.z || 0, e.internals.z || 0, 1e3);
  return n + (i ? o : 0);
}
function Ndn({ sourceNode: t, targetNode: e, width: r, height: n, transform: a }) {
  const i = YH(KF(t), KF(e));
  i.x === i.x2 && (i.x2 += 1), i.y === i.y2 && (i.y2 += 1);
  const o = {
    x: -a[0] / a[2],
    y: -a[1] / a[2],
    width: r / a[2],
    height: n / a[2]
  };
  return wI(o, XH(i)) > 0;
}
const $dn = ({ source: t, sourceHandle: e, target: r, targetHandle: n }) => `xy-edge__${t}${e || ""}-${r}${n || ""}`, Ddn = (t, e) => e.some((r) => r.source === t.source && r.target === t.target && (r.sourceHandle === t.sourceHandle || !r.sourceHandle && !t.sourceHandle) && (r.targetHandle === t.targetHandle || !r.targetHandle && !t.targetHandle)), Ldn = (t, e) => {
  if (!t.source || !t.target)
    return Rgt("006", m0.error006()), e;
  let r;
  return Agt(t) ? r = { ...t } : r = {
    ...t,
    id: $dn(t)
  }, Ddn(r, e) ? e : (r.sourceHandle === null && delete r.sourceHandle, r.targetHandle === null && delete r.targetHandle, e.concat(r));
};
function Fgt({ sourceX: t, sourceY: e, targetX: r, targetY: n }) {
  const [a, i, o, s] = jgt({
    sourceX: t,
    sourceY: e,
    targetX: r,
    targetY: n
  });
  return [`M ${t},${e}L ${r},${n}`, a, i, o, s];
}
const eze = {
  [Hn.Left]: { x: -1, y: 0 },
  [Hn.Right]: { x: 1, y: 0 },
  [Hn.Top]: { x: 0, y: -1 },
  [Hn.Bottom]: { x: 0, y: 1 }
}, jdn = ({ source: t, sourcePosition: e = Hn.Bottom, target: r }) => e === Hn.Left || e === Hn.Right ? t.x < r.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : t.y < r.y ? { x: 0, y: 1 } : { x: 0, y: -1 }, tze = (t, e) => Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
function Fdn({ source: t, sourcePosition: e = Hn.Bottom, target: r, targetPosition: n = Hn.Top, center: a, offset: i }) {
  const o = eze[e], s = eze[n], l = { x: t.x + o.x * i, y: t.y + o.y * i }, c = { x: r.x + s.x * i, y: r.y + s.y * i }, u = jdn({
    source: l,
    sourcePosition: e,
    target: c
  }), f = u.x !== 0 ? "x" : "y", h = u[f];
  let p = [], g, y;
  const b = { x: 0, y: 0 }, w = { x: 0, y: 0 }, [_, C, x, S] = jgt({
    sourceX: t.x,
    sourceY: t.y,
    targetX: r.x,
    targetY: r.y
  });
  if (o[f] * s[f] === -1) {
    g = a.x ?? _, y = a.y ?? C;
    const I = [
      { x: g, y: l.y },
      { x: g, y: c.y }
    ], M = [
      { x: l.x, y },
      { x: c.x, y }
    ];
    o[f] === h ? p = f === "x" ? I : M : p = f === "x" ? M : I;
  } else {
    const I = [{ x: l.x, y: c.y }], M = [{ x: c.x, y: l.y }];
    if (f === "x" ? p = o.x === h ? M : I : p = o.y === h ? I : M, e === n) {
      const m = Math.abs(t[f] - r[f]);
      if (m <= i) {
        const v = Math.min(i - 1, i - m);
        o[f] === h ? b[f] = (l[f] > t[f] ? -1 : 1) * v : w[f] = (c[f] > r[f] ? -1 : 1) * v;
      }
    }
    if (e !== n) {
      const m = f === "x" ? "y" : "x", v = o[f] === s[m], k = l[m] > c[m], O = l[m] < c[m];
      (o[f] === 1 && (!v && k || v && O) || o[f] !== 1 && (!v && O || v && k)) && (p = f === "x" ? I : M);
    }
    const B = { x: l.x + b.x, y: l.y + b.y }, L = { x: c.x + w.x, y: c.y + w.y }, N = Math.max(Math.abs(B.x - p[0].x), Math.abs(L.x - p[0].x)), d = Math.max(Math.abs(B.y - p[0].y), Math.abs(L.y - p[0].y));
    N >= d ? (g = (B.x + L.x) / 2, y = p[0].y) : (g = p[0].x, y = (B.y + L.y) / 2);
  }
  return [[
    t,
    { x: l.x + b.x, y: l.y + b.y },
    ...p,
    { x: c.x + w.x, y: c.y + w.y },
    r
  ], g, y, x, S];
}
function zdn(t, e, r, n) {
  const a = Math.min(tze(t, e) / 2, tze(e, r) / 2, n), { x: i, y: o } = e;
  if (t.x === i && i === r.x || t.y === o && o === r.y)
    return `L${i} ${o}`;
  if (t.y === o) {
    const c = t.x < r.x ? -1 : 1, u = t.y < r.y ? 1 : -1;
    return `L ${i + a * c},${o}Q ${i},${o} ${i},${o + a * u}`;
  }
  const s = t.x < r.x ? 1 : -1, l = t.y < r.y ? -1 : 1;
  return `L ${i},${o + a * l}Q ${i},${o} ${i + a * s},${o}`;
}
function Xfe({ sourceX: t, sourceY: e, sourcePosition: r = Hn.Bottom, targetX: n, targetY: a, targetPosition: i = Hn.Top, borderRadius: o = 5, centerX: s, centerY: l, offset: c = 20 }) {
  const [u, f, h, p, g] = Fdn({
    source: { x: t, y: e },
    sourcePosition: r,
    target: { x: n, y: a },
    targetPosition: i,
    center: { x: s, y: l },
    offset: c
  });
  return [u.reduce((b, w, _) => {
    let C = "";
    return _ > 0 && _ < u.length - 1 ? C = zdn(u[_ - 1], w, u[_ + 1], o) : C = `${_ === 0 ? "M" : "L"}${w.x} ${w.y}`, b += C, b;
  }, ""), f, h, p, g];
}
function rze(t) {
  var e;
  return t && !!(t.internals.handleBounds || (e = t.handles) != null && e.length) && !!(t.measured.width || t.width || t.initialWidth);
}
function Gdn(t) {
  var f;
  const { sourceNode: e, targetNode: r } = t;
  if (!rze(e) || !rze(r))
    return null;
  const n = e.internals.handleBounds || nze(e.handles), a = r.internals.handleBounds || nze(r.handles), i = aze((n == null ? void 0 : n.source) ?? [], t.sourceHandle), o = aze(
    // when connection type is loose we can define all handles as sources and connect source -> source
    t.connectionMode === u8.Strict ? (a == null ? void 0 : a.target) ?? [] : ((a == null ? void 0 : a.target) ?? []).concat((a == null ? void 0 : a.source) ?? []),
    t.targetHandle
  );
  if (!i || !o)
    return (f = t.onError) == null || f.call(t, "008", m0.error008(i ? "target" : "source", {
      id: t.id,
      sourceHandle: t.sourceHandle,
      targetHandle: t.targetHandle
    })), null;
  const s = (i == null ? void 0 : i.position) || Hn.Bottom, l = (o == null ? void 0 : o.position) || Hn.Top, c = SI(e, i, s), u = SI(r, o, l);
  return {
    sourceX: c.x,
    sourceY: c.y,
    targetX: u.x,
    targetY: u.y,
    sourcePosition: s,
    targetPosition: l
  };
}
function nze(t) {
  if (!t)
    return null;
  const e = [], r = [];
  for (const n of t)
    n.width = n.width ?? 1, n.height = n.height ?? 1, n.type === "source" ? e.push(n) : n.type === "target" && r.push(n);
  return {
    source: e,
    target: r
  };
}
function SI(t, e, r = Hn.Left, n = !1) {
  const a = ((e == null ? void 0 : e.x) ?? 0) + t.internals.positionAbsolute.x, i = ((e == null ? void 0 : e.y) ?? 0) + t.internals.positionAbsolute.y, { width: o, height: s } = e ?? wg(t);
  if (n)
    return { x: a + o / 2, y: i + s / 2 };
  switch ((e == null ? void 0 : e.position) ?? r) {
    case Hn.Top:
      return { x: a + o / 2, y: i };
    case Hn.Right:
      return { x: a + o, y: i + s / 2 };
    case Hn.Bottom:
      return { x: a + o / 2, y: i + s };
    case Hn.Left:
      return { x: a, y: i + s / 2 };
  }
}
function aze(t, e) {
  return t && (e ? t.find((r) => r.id === e) : t[0]) || null;
}
function Qfe(t, e) {
  return t ? typeof t == "string" ? t : `${e ? `${e}__` : ""}${Object.keys(t).sort().map((n) => `${n}=${t[n]}`).join("&")}` : "";
}
function Wdn(t, { id: e, defaultColor: r, defaultMarkerStart: n, defaultMarkerEnd: a }) {
  const i = /* @__PURE__ */ new Set();
  return t.reduce((o, s) => ([s.markerStart || n, s.markerEnd || a].forEach((l) => {
    if (l && typeof l == "object") {
      const c = Qfe(l, e);
      i.has(c) || (o.push({ id: c, color: l.color || r, ...l }), i.add(c));
    }
  }), o), []).sort((o, s) => o.id.localeCompare(s.id));
}
const $be = {
  nodeOrigin: [0, 0],
  nodeExtent: xI,
  elevateNodesOnSelect: !0,
  defaults: {}
}, Hdn = {
  ...$be,
  checkEquality: !0
};
function Dbe(t, e) {
  const r = { ...t };
  for (const n in e)
    e[n] !== void 0 && (r[n] = e[n]);
  return r;
}
function Udn(t, e, r) {
  const n = Dbe($be, r);
  for (const a of t.values())
    if (a.parentId)
      Lbe(a, t, e, n);
    else {
      const i = SP(a, n.nodeOrigin), o = h8(a.extent) ? a.extent : n.nodeExtent, s = G5(i, o, wg(a));
      a.internals.positionAbsolute = s;
    }
}
function e1e(t, e, r, n) {
  var s, l;
  const a = Dbe(Hdn, n), i = new Map(e), o = a != null && a.elevateNodesOnSelect ? 1e3 : 0;
  e.clear(), r.clear();
  for (const c of t) {
    let u = i.get(c.id);
    if (a.checkEquality && c === (u == null ? void 0 : u.internals.userNode))
      e.set(c.id, u);
    else {
      const f = SP(c, a.nodeOrigin), h = h8(c.extent) ? c.extent : a.nodeExtent, p = G5(f, h, wg(c));
      u = {
        ...a.defaults,
        ...c,
        measured: {
          width: (s = c.measured) == null ? void 0 : s.width,
          height: (l = c.measured) == null ? void 0 : l.height
        },
        internals: {
          positionAbsolute: p,
          // if user re-initializes the node or removes `measured` for whatever reason, we reset the handleBounds so that the node gets re-measured
          handleBounds: c.measured ? u == null ? void 0 : u.internals.handleBounds : void 0,
          z: zgt(c, o),
          userNode: c
        }
      }, e.set(c.id, u);
    }
    c.parentId && Lbe(u, e, r, n);
  }
}
function Vdn(t, e) {
  if (!t.parentId)
    return;
  const r = e.get(t.parentId);
  r ? r.set(t.id, t) : e.set(t.parentId, /* @__PURE__ */ new Map([[t.id, t]]));
}
function Lbe(t, e, r, n) {
  const { elevateNodesOnSelect: a, nodeOrigin: i, nodeExtent: o } = Dbe($be, n), s = t.parentId, l = e.get(s);
  if (!l) {
    console.warn(`Parent node ${s} not found. Please make sure that parent nodes are in front of their child nodes in the nodes array.`);
    return;
  }
  Vdn(t, r);
  const c = a ? 1e3 : 0, { x: u, y: f, z: h } = qdn(t, l, i, o, c), { positionAbsolute: p } = t.internals, g = u !== p.x || f !== p.y;
  (g || h !== t.internals.z) && e.set(t.id, {
    ...t,
    internals: {
      ...t.internals,
      positionAbsolute: g ? { x: u, y: f } : p,
      z: h
    }
  });
}
function zgt(t, e) {
  return (x1(t.zIndex) ? t.zIndex : 0) + (t.selected ? e : 0);
}
function qdn(t, e, r, n, a) {
  const { x: i, y: o } = e.internals.positionAbsolute, s = wg(t), l = SP(t, r), c = h8(t.extent) ? G5(l, t.extent, s) : l;
  let u = G5({ x: i + c.x, y: o + c.y }, n, s);
  t.extent === "parent" && (u = Igt(u, s, e));
  const f = zgt(t, a), h = e.internals.z ?? 0;
  return {
    x: u.x,
    y: u.y,
    z: h > f ? h : f
  };
}
function jbe(t, e, r, n = [0, 0]) {
  var o;
  const a = [], i = /* @__PURE__ */ new Map();
  for (const s of t) {
    const l = e.get(s.parentId);
    if (!l)
      continue;
    const c = ((o = i.get(s.parentId)) == null ? void 0 : o.expandedRect) ?? f8(l), u = Pgt(c, s.rect);
    i.set(s.parentId, { expandedRect: u, parent: l });
  }
  return i.size > 0 && i.forEach(({ expandedRect: s, parent: l }, c) => {
    var C;
    const u = l.internals.positionAbsolute, f = wg(l), h = l.origin ?? n, p = s.x < u.x ? Math.round(Math.abs(u.x - s.x)) : 0, g = s.y < u.y ? Math.round(Math.abs(u.y - s.y)) : 0, y = Math.max(f.width, Math.round(s.width)), b = Math.max(f.height, Math.round(s.height)), w = (y - f.width) * h[0], _ = (b - f.height) * h[1];
    (p > 0 || g > 0 || w || _) && (a.push({
      id: c,
      type: "position",
      position: {
        x: l.position.x - p + w,
        y: l.position.y - g + _
      }
    }), (C = r.get(c)) == null || C.forEach((x) => {
      t.some((S) => S.id === x.id) || a.push({
        id: x.id,
        type: "position",
        position: {
          x: x.position.x + p,
          y: x.position.y + g
        }
      });
    })), (f.width < s.width || f.height < s.height || p || g) && a.push({
      id: c,
      type: "dimensions",
      setAttributes: !0,
      dimensions: {
        width: y + (p ? h[0] * p - w : 0),
        height: b + (g ? h[1] * g - _ : 0)
      }
    });
  }), a;
}
function Kdn(t, e, r, n, a, i) {
  const o = n == null ? void 0 : n.querySelector(".xyflow__viewport");
  let s = !1;
  if (!o)
    return { changes: [], updatedInternals: s };
  const l = [], c = window.getComputedStyle(o), { m22: u } = new window.DOMMatrixReadOnly(c.transform), f = [];
  for (const h of t.values()) {
    const p = e.get(h.id);
    if (!p)
      continue;
    if (p.hidden) {
      e.set(p.id, {
        ...p,
        internals: {
          ...p.internals,
          handleBounds: void 0
        }
      }), s = !0;
      continue;
    }
    const g = eU(h.nodeElement), y = p.measured.width !== g.width || p.measured.height !== g.height;
    if (!!(g.width && g.height && (y || !p.internals.handleBounds || h.force))) {
      const w = h.nodeElement.getBoundingClientRect(), _ = h8(p.extent) ? p.extent : i;
      let { positionAbsolute: C } = p.internals;
      p.parentId && p.extent === "parent" ? C = Igt(C, g, e.get(p.parentId)) : _ && (C = G5(C, _, g));
      const x = {
        ...p,
        measured: g,
        internals: {
          ...p.internals,
          positionAbsolute: C,
          handleBounds: {
            source: XFe("source", h.nodeElement, w, u, p.id),
            target: XFe("target", h.nodeElement, w, u, p.id)
          }
        }
      };
      e.set(p.id, x), p.parentId && Lbe(x, e, r, { nodeOrigin: a }), s = !0, y && (l.push({
        id: p.id,
        type: "dimensions",
        dimensions: g
      }), p.expandParent && p.parentId && f.push({
        id: p.id,
        parentId: p.parentId,
        rect: f8(x, a)
      }));
    }
  }
  if (f.length > 0) {
    const h = jbe(f, e, r, a);
    l.push(...h);
  }
  return { changes: l, updatedInternals: s };
}
async function Zdn({ delta: t, panZoom: e, transform: r, translateExtent: n, width: a, height: i }) {
  if (!e || !t.x && !t.y)
    return Promise.resolve(!1);
  const o = await e.setViewportConstrained({
    x: r[0] + t.x,
    y: r[1] + t.y,
    zoom: r[2]
  }, [
    [0, 0],
    [a, i]
  ], n), s = !!o && (o.x !== r[0] || o.y !== r[1] || o.k !== r[2]);
  return Promise.resolve(s);
}
function ize(t, e, r, n, a, i) {
  let o = a;
  const s = n.get(o) || /* @__PURE__ */ new Map();
  n.set(o, s.set(r, e)), o = `${a}-${t}`;
  const l = n.get(o) || /* @__PURE__ */ new Map();
  if (n.set(o, l.set(r, e)), i) {
    o = `${a}-${t}-${i}`;
    const c = n.get(o) || /* @__PURE__ */ new Map();
    n.set(o, c.set(r, e));
  }
}
function Ggt(t, e, r) {
  t.clear(), e.clear();
  for (const n of r) {
    const { source: a, target: i, sourceHandle: o = null, targetHandle: s = null } = n, l = { edgeId: n.id, source: a, target: i, sourceHandle: o, targetHandle: s }, c = `${a}-${o}--${i}-${s}`, u = `${i}-${s}--${a}-${o}`;
    ize("source", l, u, t, a, o), ize("target", l, c, t, i, s), e.set(n.id, n);
  }
}
function Wgt(t, e) {
  if (!t.parentId)
    return !1;
  const r = e.get(t.parentId);
  return r ? r.selected ? !0 : Wgt(r, e) : !1;
}
function oze(t, e, r) {
  var a;
  let n = t;
  do {
    if ((a = n == null ? void 0 : n.matches) != null && a.call(n, e))
      return !0;
    if (n === r)
      return !1;
    n = n == null ? void 0 : n.parentElement;
  } while (n);
  return !1;
}
function Jdn(t, e, r, n) {
  const a = /* @__PURE__ */ new Map();
  for (const [i, o] of t)
    if ((o.selected || o.id === n) && (!o.parentId || !Wgt(o, t)) && (o.draggable || e && typeof o.draggable > "u")) {
      const s = t.get(i);
      s && a.set(i, {
        id: i,
        position: s.position || { x: 0, y: 0 },
        distance: {
          x: r.x - s.internals.positionAbsolute.x,
          y: r.y - s.internals.positionAbsolute.y
        },
        extent: s.extent,
        parentId: s.parentId,
        origin: s.origin,
        expandParent: s.expandParent,
        internals: {
          positionAbsolute: s.internals.positionAbsolute || { x: 0, y: 0 }
        },
        measured: {
          width: s.measured.width ?? 0,
          height: s.measured.height ?? 0
        }
      });
    }
  return a;
}
function Yoe({ nodeId: t, dragItems: e, nodeLookup: r, dragging: n = !0 }) {
  var o, s, l;
  const a = [];
  for (const [c, u] of e) {
    const f = (o = r.get(c)) == null ? void 0 : o.internals.userNode;
    f && a.push({
      ...f,
      position: u.position,
      dragging: n
    });
  }
  if (!t)
    return [a[0], a];
  const i = (s = r.get(t)) == null ? void 0 : s.internals.userNode;
  return [
    i ? {
      ...i,
      position: ((l = e.get(t)) == null ? void 0 : l.position) || i.position,
      dragging: n
    } : a[0],
    a
  ];
}
function Ydn({ onNodeMouseDown: t, getStoreItems: e, onDragStart: r, onDrag: n, onDragStop: a }) {
  let i = { x: null, y: null }, o = 0, s = /* @__PURE__ */ new Map(), l = !1, c = { x: 0, y: 0 }, u = null, f = !1, h = null, p = !1;
  function g({ noDragClassName: b, handleSelector: w, domNode: _, isSelectable: C, nodeId: x, nodeClickDistance: S = 0 }) {
    h = a0(_);
    function A({ x: L, y: N }, d) {
      const { nodeLookup: m, nodeExtent: v, snapGrid: k, snapToGrid: O, nodeOrigin: G, onNodeDrag: H, onSelectionDrag: j, onError: F, updateNodePositions: z } = e();
      i = { x: L, y: N };
      let W = !1, U = { x: 0, y: 0, x2: 0, y2: 0 };
      if (s.size > 1 && v) {
        const Z = _P(s);
        U = Jfe(Z);
      }
      for (const [Z, V] of s) {
        if (!m.has(Z))
          continue;
        let Y = { x: L - V.distance.x, y: N - V.distance.y };
        O && (Y = QH(Y, k));
        let ge = [
          [v[0][0], v[0][1]],
          [v[1][0], v[1][1]]
        ];
        if (s.size > 1 && v && !V.extent) {
          const { positionAbsolute: Se } = V.internals, Ce = Se.x - U.x + v[0][0], we = Se.x + V.measured.width - U.x2 + v[1][0], We = Se.y - U.y + v[0][1], Fe = Se.y + V.measured.height - U.y2 + v[1][1];
          ge = [
            [Ce, We],
            [we, Fe]
          ];
        }
        const { position: ce, positionAbsolute: ee } = Egt({
          nodeId: Z,
          nextPosition: Y,
          nodeLookup: m,
          nodeExtent: ge,
          nodeOrigin: G,
          onError: F
        });
        W = W || V.position.x !== ce.x || V.position.y !== ce.y, V.position = ce, V.internals.positionAbsolute = ee;
      }
      if (W && (z(s, !0), d && (n || H || !x && j))) {
        const [Z, V] = Yoe({
          nodeId: x,
          dragItems: s,
          nodeLookup: m
        });
        n == null || n(d, s, Z, V), H == null || H(d, Z, V), x || j == null || j(d, V);
      }
    }
    async function I() {
      if (!u)
        return;
      const { transform: L, panBy: N, autoPanSpeed: d, autoPanOnNodeDrag: m } = e();
      if (!m) {
        l = !1, cancelAnimationFrame(o);
        return;
      }
      const [v, k] = Mgt(c, u, d);
      (v !== 0 || k !== 0) && (i.x = (i.x ?? 0) - v / L[2], i.y = (i.y ?? 0) - k / L[2], await N({ x: v, y: k }) && A(i, null)), o = requestAnimationFrame(I);
    }
    function M(L) {
      var W;
      const { nodeLookup: N, multiSelectionActive: d, nodesDraggable: m, transform: v, snapGrid: k, snapToGrid: O, selectNodesOnDrag: G, onNodeDragStart: H, onSelectionDragStart: j, unselectNodesAndEdges: F } = e();
      f = !0, (!G || !C) && !d && x && ((W = N.get(x)) != null && W.selected || F()), C && G && x && (t == null || t(x));
      const z = X_(L.sourceEvent, { transform: v, snapGrid: k, snapToGrid: O, containerBounds: u });
      if (i = z, s = Jdn(N, m, z, x), s.size > 0 && (r || H || !x && j)) {
        const [U, Z] = Yoe({
          nodeId: x,
          dragItems: s,
          nodeLookup: N
        });
        r == null || r(L.sourceEvent, s, U, Z), H == null || H(L.sourceEvent, U, Z), x || j == null || j(L.sourceEvent, Z);
      }
    }
    const B = hgt().clickDistance(S).on("start", (L) => {
      const { domNode: N, nodeDragThreshold: d, transform: m, snapGrid: v, snapToGrid: k } = e();
      u = (N == null ? void 0 : N.getBoundingClientRect()) || null, p = !1, d === 0 && M(L), i = X_(L.sourceEvent, { transform: m, snapGrid: v, snapToGrid: k, containerBounds: u }), c = Bm(L.sourceEvent, u);
    }).on("drag", (L) => {
      const { autoPanOnNodeDrag: N, transform: d, snapGrid: m, snapToGrid: v, nodeDragThreshold: k, nodeLookup: O } = e(), G = X_(L.sourceEvent, { transform: d, snapGrid: m, snapToGrid: v, containerBounds: u });
      if ((L.sourceEvent.type === "touchmove" && L.sourceEvent.touches.length > 1 || // if user deletes a node while dragging, we need to abort the drag to prevent errors
      x && !O.has(x)) && (p = !0), !p) {
        if (!l && N && f && (l = !0, I()), !f) {
          const H = G.xSnapped - (i.x ?? 0), j = G.ySnapped - (i.y ?? 0);
          Math.sqrt(H * H + j * j) > k && M(L);
        }
        (i.x !== G.xSnapped || i.y !== G.ySnapped) && s && f && (c = Bm(L.sourceEvent, u), A(G, L.sourceEvent));
      }
    }).on("end", (L) => {
      if (!(!f || p) && (l = !1, f = !1, cancelAnimationFrame(o), s.size > 0)) {
        const { nodeLookup: N, updateNodePositions: d, onNodeDragStop: m, onSelectionDragStop: v } = e();
        if (d(s, !1), a || m || !x && v) {
          const [k, O] = Yoe({
            nodeId: x,
            dragItems: s,
            nodeLookup: N,
            dragging: !1
          });
          a == null || a(L.sourceEvent, s, k, O), m == null || m(L.sourceEvent, k, O), x || v == null || v(L.sourceEvent, O);
        }
      }
    }).filter((L) => {
      const N = L.target;
      return !L.button && (!b || !oze(N, `.${b}`, _)) && (!w || oze(N, w, _));
    });
    h.call(B);
  }
  function y() {
    h == null || h.on(".drag", null);
  }
  return {
    update: g,
    destroy: y
  };
}
function Xdn(t, e, r) {
  const n = [], a = {
    x: t.x - r,
    y: t.y - r,
    width: r * 2,
    height: r * 2
  };
  for (const i of e.values())
    wI(a, f8(i)) > 0 && n.push(i);
  return n;
}
const Qdn = 250;
function e0n(t, e, r, n) {
  var s, l;
  let a = [], i = 1 / 0;
  const o = Xdn(t, r, e + Qdn);
  for (const c of o) {
    const u = [...((s = c.internals.handleBounds) == null ? void 0 : s.source) ?? [], ...((l = c.internals.handleBounds) == null ? void 0 : l.target) ?? []];
    for (const f of u) {
      if (n.nodeId === f.nodeId && n.type === f.type && n.id === f.id)
        continue;
      const { x: h, y: p } = SI(c, f, f.position, !0), g = Math.sqrt(Math.pow(h - t.x, 2) + Math.pow(p - t.y, 2));
      g > e || (g < i ? (a = [{ ...f, x: h, y: p }], i = g) : g === i && a.push({ ...f, x: h, y: p }));
    }
  }
  if (!a.length)
    return null;
  if (a.length > 1) {
    const c = n.type === "source" ? "target" : "source";
    return a.find((u) => u.type === c) ?? a[0];
  }
  return a[0];
}
function Hgt(t, e, r, n, a, i = !1) {
  var c, u, f;
  const o = n.get(t);
  if (!o)
    return null;
  const s = a === "strict" ? (c = o.internals.handleBounds) == null ? void 0 : c[e] : [...((u = o.internals.handleBounds) == null ? void 0 : u.source) ?? [], ...((f = o.internals.handleBounds) == null ? void 0 : f.target) ?? []], l = (r ? s == null ? void 0 : s.find((h) => h.id === r) : s == null ? void 0 : s[0]) ?? null;
  return l && i ? { ...l, ...SI(o, l, l.position, !0) } : l;
}
function Ugt(t, e) {
  return t || (e != null && e.classList.contains("target") ? "target" : e != null && e.classList.contains("source") ? "source" : null);
}
function t0n(t, e) {
  let r = null;
  return e ? r = !0 : t && !e && (r = !1), r;
}
const Vgt = () => !0;
function r0n(t, { connectionMode: e, connectionRadius: r, handleId: n, nodeId: a, edgeUpdaterType: i, isTarget: o, domNode: s, nodeLookup: l, lib: c, autoPanOnConnect: u, flowId: f, panBy: h, cancelConnection: p, onConnectStart: g, onConnect: y, onConnectEnd: b, isValidConnection: w = Vgt, onReconnectEnd: _, updateConnection: C, getTransform: x, getFromHandle: S, autoPanSpeed: A }) {
  const I = Ngt(t.target);
  let M = 0, B;
  const { x: L, y: N } = Bm(t), d = I == null ? void 0 : I.elementFromPoint(L, N), m = Ugt(i, d), v = s == null ? void 0 : s.getBoundingClientRect();
  if (!v || !m)
    return;
  const k = Hgt(a, m, n, l, e);
  if (!k)
    return;
  let O = Bm(t, v), G = !1, H = null, j = !1, F = null;
  function z() {
    if (!u || !v)
      return;
    const [ee, Se] = Mgt(O, v, A);
    h({ x: ee, y: Se }), M = requestAnimationFrame(z);
  }
  const W = {
    ...k,
    nodeId: a,
    type: m,
    position: k.position
  }, U = l.get(a), V = {
    inProgress: !0,
    isValid: null,
    from: SI(U, W, Hn.Left, !0),
    fromHandle: W,
    fromPosition: W.position,
    fromNode: U,
    to: O,
    toHandle: null,
    toPosition: KFe[W.position],
    toNode: null
  };
  C(V);
  let Y = V;
  g == null || g(t, { nodeId: a, handleId: n, handleType: m });
  function ge(ee) {
    if (!S() || !W) {
      ce(ee);
      return;
    }
    const Se = x();
    O = Bm(ee, v), B = e0n(kP(O, Se, !1, [1, 1]), r, l, W), G || (z(), G = !0);
    const Ce = qgt(ee, {
      handle: B,
      connectionMode: e,
      fromNodeId: a,
      fromHandleId: n,
      fromType: o ? "target" : "source",
      isValidConnection: w,
      doc: I,
      lib: c,
      flowId: f,
      nodeLookup: l
    });
    F = Ce.handleDomNode, H = Ce.connection, j = t0n(!!B, Ce.isValid);
    const we = {
      // from stays the same
      ...Y,
      isValid: j,
      to: B && j ? Ogt({ x: B.x, y: B.y }, Se) : O,
      toHandle: Ce.toHandle,
      toPosition: j && Ce.toHandle ? Ce.toHandle.position : KFe[W.position],
      toNode: Ce.toHandle ? l.get(Ce.toHandle.nodeId) : null
    };
    j && B && Y.toHandle && we.toHandle && Y.toHandle.type === we.toHandle.type && Y.toHandle.nodeId === we.toHandle.nodeId && Y.toHandle.id === we.toHandle.id && Y.to.x === we.to.x && Y.to.y === we.to.y || (C(we), Y = we);
  }
  function ce(ee) {
    (B || F) && H && j && (y == null || y(H));
    const { inProgress: Se, ...Ce } = Y, we = {
      ...Ce,
      toPosition: Y.toHandle ? Y.toPosition : null
    };
    b == null || b(ee, we), i && (_ == null || _(ee, we)), p(), cancelAnimationFrame(M), G = !1, j = !1, H = null, F = null, I.removeEventListener("mousemove", ge), I.removeEventListener("mouseup", ce), I.removeEventListener("touchmove", ge), I.removeEventListener("touchend", ce);
  }
  I.addEventListener("mousemove", ge), I.addEventListener("mouseup", ce), I.addEventListener("touchmove", ge), I.addEventListener("touchend", ce);
}
function qgt(t, { handle: e, connectionMode: r, fromNodeId: n, fromHandleId: a, fromType: i, doc: o, lib: s, flowId: l, isValidConnection: c = Vgt, nodeLookup: u }) {
  const f = i === "target", h = e ? o.querySelector(`.${s}-flow__handle[data-id="${l}-${e == null ? void 0 : e.nodeId}-${e == null ? void 0 : e.id}-${e == null ? void 0 : e.type}"]`) : null, { x: p, y: g } = Bm(t), y = o.elementFromPoint(p, g), b = y != null && y.classList.contains(`${s}-flow__handle`) ? y : h, w = {
    handleDomNode: b,
    isValid: !1,
    connection: null,
    toHandle: null
  };
  if (b) {
    const _ = Ugt(void 0, b), C = b.getAttribute("data-nodeid"), x = b.getAttribute("data-handleid"), S = b.classList.contains("connectable"), A = b.classList.contains("connectableend");
    if (!C || !_)
      return w;
    const I = {
      source: f ? C : n,
      sourceHandle: f ? x : a,
      target: f ? n : C,
      targetHandle: f ? a : x
    };
    w.connection = I;
    const B = S && A && (r === u8.Strict ? f && _ === "source" || !f && _ === "target" : C !== n || x !== a);
    w.isValid = B && c(I), w.toHandle = Hgt(C, _, x, u, r, !1);
  }
  return w;
}
const t1e = {
  onPointerDown: r0n,
  isValid: qgt
};
function n0n({ domNode: t, panZoom: e, getTransform: r, getViewScale: n }) {
  const a = a0(t);
  function i({ translateExtent: s, width: l, height: c, zoomStep: u = 10, pannable: f = !0, zoomable: h = !0, inversePan: p = !1 }) {
    const g = (C) => {
      const x = r();
      if (C.sourceEvent.type !== "wheel" || !e)
        return;
      const S = -C.sourceEvent.deltaY * (C.sourceEvent.deltaMode === 1 ? 0.05 : C.sourceEvent.deltaMode ? 1 : 2e-3) * u, A = x[2] * Math.pow(2, S);
      e.scaleTo(A);
    };
    let y = [0, 0];
    const b = (C) => {
      (C.sourceEvent.type === "mousedown" || C.sourceEvent.type === "touchstart") && (y = [
        C.sourceEvent.clientX ?? C.sourceEvent.touches[0].clientX,
        C.sourceEvent.clientY ?? C.sourceEvent.touches[0].clientY
      ]);
    }, w = (C) => {
      const x = r();
      if (C.sourceEvent.type !== "mousemove" && C.sourceEvent.type !== "touchmove" || !e)
        return;
      const S = [
        C.sourceEvent.clientX ?? C.sourceEvent.touches[0].clientX,
        C.sourceEvent.clientY ?? C.sourceEvent.touches[0].clientY
      ], A = [S[0] - y[0], S[1] - y[1]];
      y = S;
      const I = n() * Math.max(x[2], Math.log(x[2])) * (p ? -1 : 1), M = {
        x: x[0] - A[0] * I,
        y: x[1] - A[1] * I
      }, B = [
        [0, 0],
        [l, c]
      ];
      e.setViewportConstrained({
        x: M.x,
        y: M.y,
        zoom: x[2]
      }, B, s);
    }, _ = wgt().on("start", b).on("zoom", f ? w : null).on("zoom.wheel", h ? g : null);
    a.call(_, {});
  }
  function o() {
    a.on("zoom", null);
  }
  return {
    update: i,
    destroy: o,
    pointer: c1
  };
}
const a0n = (t, e) => t.x !== e.x || t.y !== e.y || t.zoom !== e.k, tU = (t) => ({
  x: t.x,
  y: t.y,
  zoom: t.k
}), Xoe = ({ x: t, y: e, zoom: r }) => JH.translate(t, e).scale(r), r7 = (t, e) => t.target.closest(`.${e}`), Kgt = (t, e) => e === 2 && Array.isArray(t) && t.includes(2), Qoe = (t, e = 0, r = () => {
}) => {
  const n = typeof e == "number" && e > 0;
  return n || r(), n ? t.transition().duration(e).on("end", r) : t;
}, Zgt = (t) => {
  const e = t.ctrlKey && ZF() ? 10 : 1;
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * e;
};
function i0n({ zoomPanValues: t, noWheelClassName: e, d3Selection: r, d3Zoom: n, panOnScrollMode: a, panOnScrollSpeed: i, zoomOnPinch: o, onPanZoomStart: s, onPanZoom: l, onPanZoomEnd: c }) {
  return (u) => {
    if (r7(u, e))
      return !1;
    u.preventDefault(), u.stopImmediatePropagation();
    const f = r.property("__zoom").k || 1;
    if (u.ctrlKey && o) {
      const b = c1(u), w = Zgt(u), _ = f * Math.pow(2, w);
      n.scaleTo(r, _, b, u);
      return;
    }
    const h = u.deltaMode === 1 ? 20 : 1;
    let p = a === Yb.Vertical ? 0 : u.deltaX * h, g = a === Yb.Horizontal ? 0 : u.deltaY * h;
    !ZF() && u.shiftKey && a !== Yb.Vertical && (p = u.deltaY * h, g = 0), n.translateBy(
      r,
      -(p / f) * i,
      -(g / f) * i,
      // @ts-ignore
      { internal: !0 }
    );
    const y = tU(r.property("__zoom"));
    clearTimeout(t.panScrollTimeout), t.isPanScrolling || (t.isPanScrolling = !0, s == null || s(u, y)), t.isPanScrolling && (l == null || l(u, y), t.panScrollTimeout = setTimeout(() => {
      c == null || c(u, y), t.isPanScrolling = !1;
    }, 150));
  };
}
function o0n({ noWheelClassName: t, preventScrolling: e, d3ZoomHandler: r }) {
  return function(n, a) {
    if (!e && n.type === "wheel" && !n.ctrlKey || r7(n, t))
      return null;
    n.preventDefault(), r.call(this, n, a);
  };
}
function s0n({ zoomPanValues: t, onDraggingChange: e, onPanZoomStart: r }) {
  return (n) => {
    var i, o, s;
    if ((i = n.sourceEvent) != null && i.internal)
      return;
    const a = tU(n.transform);
    t.mouseButton = ((o = n.sourceEvent) == null ? void 0 : o.button) || 0, t.isZoomingOrPanning = !0, t.prevViewport = a, ((s = n.sourceEvent) == null ? void 0 : s.type) === "mousedown" && e(!0), r && (r == null || r(n.sourceEvent, a));
  };
}
function l0n({ zoomPanValues: t, panOnDrag: e, onPaneContextMenu: r, onTransformChange: n, onPanZoom: a }) {
  return (i) => {
    var o, s;
    t.usedRightMouseButton = !!(r && Kgt(e, t.mouseButton ?? 0)), (o = i.sourceEvent) != null && o.sync || n([i.transform.x, i.transform.y, i.transform.k]), a && !((s = i.sourceEvent) != null && s.internal) && (a == null || a(i.sourceEvent, tU(i.transform)));
  };
}
function c0n({ zoomPanValues: t, panOnDrag: e, panOnScroll: r, onDraggingChange: n, onPanZoomEnd: a, onPaneContextMenu: i }) {
  return (o) => {
    var s;
    if (!((s = o.sourceEvent) != null && s.internal) && (t.isZoomingOrPanning = !1, i && Kgt(e, t.mouseButton ?? 0) && !t.usedRightMouseButton && o.sourceEvent && i(o.sourceEvent), t.usedRightMouseButton = !1, n(!1), a && a0n(t.prevViewport, o.transform))) {
      const l = tU(o.transform);
      t.prevViewport = l, clearTimeout(t.timerId), t.timerId = setTimeout(
        () => {
          a == null || a(o.sourceEvent, l);
        },
        // we need a setTimeout for panOnScroll to supress multiple end events fired during scroll
        r ? 150 : 0
      );
    }
  };
}
function u0n({ zoomActivationKeyPressed: t, zoomOnScroll: e, zoomOnPinch: r, panOnDrag: n, panOnScroll: a, zoomOnDoubleClick: i, userSelectionActive: o, noWheelClassName: s, noPanClassName: l, lib: c }) {
  return (u) => {
    var g;
    const f = t || e, h = r && u.ctrlKey;
    if (u.button === 1 && u.type === "mousedown" && (r7(u, `${c}-flow__node`) || r7(u, `${c}-flow__edge`)))
      return !0;
    if (!n && !f && !a && !i && !r || o || r7(u, s) && u.type === "wheel" || r7(u, l) && (u.type !== "wheel" || a && u.type === "wheel" && !t) || !r && u.ctrlKey && u.type === "wheel")
      return !1;
    if (!r && u.type === "touchstart" && ((g = u.touches) == null ? void 0 : g.length) > 1)
      return u.preventDefault(), !1;
    if (!f && !a && !h && u.type === "wheel" || !n && (u.type === "mousedown" || u.type === "touchstart") || Array.isArray(n) && !n.includes(u.button) && u.type === "mousedown")
      return !1;
    const p = Array.isArray(n) && n.includes(u.button) || !u.button || u.button <= 1;
    return (!u.ctrlKey || u.type === "wheel") && p;
  };
}
function d0n({ domNode: t, minZoom: e, maxZoom: r, paneClickDistance: n, translateExtent: a, viewport: i, onPanZoom: o, onPanZoomStart: s, onPanZoomEnd: l, onDraggingChange: c }) {
  const u = {
    isZoomingOrPanning: !1,
    usedRightMouseButton: !1,
    prevViewport: { x: 0, y: 0, zoom: 0 },
    mouseButton: 0,
    timerId: void 0,
    panScrollTimeout: void 0,
    isPanScrolling: !1
  }, f = t.getBoundingClientRect(), h = wgt().clickDistance(!x1(n) || n < 0 ? 0 : n).scaleExtent([e, r]).translateExtent(a), p = a0(t).call(h);
  C({
    x: i.x,
    y: i.y,
    zoom: d8(i.zoom, e, r)
  }, [
    [0, 0],
    [f.width, f.height]
  ], a);
  const g = p.on("wheel.zoom"), y = p.on("dblclick.zoom");
  h.wheelDelta(Zgt);
  function b(d, m) {
    return p ? new Promise((v) => {
      h == null || h.transform(Qoe(p, m == null ? void 0 : m.duration, () => v(!0)), d);
    }) : Promise.resolve(!1);
  }
  function w({ noWheelClassName: d, noPanClassName: m, onPaneContextMenu: v, userSelectionActive: k, panOnScroll: O, panOnDrag: G, panOnScrollMode: H, panOnScrollSpeed: j, preventScrolling: F, zoomOnPinch: z, zoomOnScroll: W, zoomOnDoubleClick: U, zoomActivationKeyPressed: Z, lib: V, onTransformChange: Y }) {
    k && !u.isZoomingOrPanning && _();
    const ce = O && !Z && !k ? i0n({
      zoomPanValues: u,
      noWheelClassName: d,
      d3Selection: p,
      d3Zoom: h,
      panOnScrollMode: H,
      panOnScrollSpeed: j,
      zoomOnPinch: z,
      onPanZoomStart: s,
      onPanZoom: o,
      onPanZoomEnd: l
    }) : o0n({
      noWheelClassName: d,
      preventScrolling: F,
      d3ZoomHandler: g
    });
    if (p.on("wheel.zoom", ce, { passive: !1 }), !k) {
      const Se = s0n({
        zoomPanValues: u,
        onDraggingChange: c,
        onPanZoomStart: s
      });
      h.on("start", Se);
      const Ce = l0n({
        zoomPanValues: u,
        panOnDrag: G,
        onPaneContextMenu: !!v,
        onPanZoom: o,
        onTransformChange: Y
      });
      h.on("zoom", Ce);
      const we = c0n({
        zoomPanValues: u,
        panOnDrag: G,
        panOnScroll: O,
        onPaneContextMenu: v,
        onPanZoomEnd: l,
        onDraggingChange: c
      });
      h.on("end", we);
    }
    const ee = u0n({
      zoomActivationKeyPressed: Z,
      panOnDrag: G,
      zoomOnScroll: W,
      panOnScroll: O,
      zoomOnDoubleClick: U,
      zoomOnPinch: z,
      userSelectionActive: k,
      noPanClassName: m,
      noWheelClassName: d,
      lib: V
    });
    h.filter(ee), U ? p.on("dblclick.zoom", y) : p.on("dblclick.zoom", null);
  }
  function _() {
    h.on("zoom", null);
  }
  async function C(d, m, v) {
    const k = Xoe(d), O = h == null ? void 0 : h.constrain()(k, m, v);
    return O && await b(O), new Promise((G) => G(O));
  }
  async function x(d, m) {
    const v = Xoe(d);
    return await b(v, m), new Promise((k) => k(v));
  }
  function S(d) {
    if (p) {
      const m = Xoe(d), v = p.property("__zoom");
      (v.k !== d.zoom || v.x !== d.x || v.y !== d.y) && (h == null || h.transform(p, m, null, { sync: !0 }));
    }
  }
  function A() {
    const d = p ? Cgt(p.node()) : { x: 0, y: 0, k: 1 };
    return { x: d.x, y: d.y, zoom: d.k };
  }
  function I(d, m) {
    return p ? new Promise((v) => {
      h == null || h.scaleTo(Qoe(p, m == null ? void 0 : m.duration, () => v(!0)), d);
    }) : Promise.resolve(!1);
  }
  function M(d, m) {
    return p ? new Promise((v) => {
      h == null || h.scaleBy(Qoe(p, m == null ? void 0 : m.duration, () => v(!0)), d);
    }) : Promise.resolve(!1);
  }
  function B(d) {
    h == null || h.scaleExtent(d);
  }
  function L(d) {
    h == null || h.translateExtent(d);
  }
  function N(d) {
    const m = !x1(d) || d < 0 ? 0 : d;
    h == null || h.clickDistance(m);
  }
  return {
    update: w,
    destroy: _,
    setViewport: x,
    setViewportConstrained: C,
    getViewport: A,
    scaleTo: I,
    scaleBy: M,
    setScaleExtent: B,
    setTranslateExtent: L,
    syncViewport: S,
    setClickDistance: N
  };
}
var Q_;
(function(t) {
  t.Line = "line", t.Handle = "handle";
})(Q_ || (Q_ = {}));
function f0n({ width: t, prevWidth: e, height: r, prevHeight: n, affectsX: a, affectsY: i }) {
  const o = t - e, s = r - n, l = [o > 0 ? 1 : o < 0 ? -1 : 0, s > 0 ? 1 : s < 0 ? -1 : 0];
  return o && a && (l[0] = l[0] * -1), s && i && (l[1] = l[1] * -1), l;
}
function h0n(t) {
  const e = t.includes("right") || t.includes("left"), r = t.includes("bottom") || t.includes("top"), n = t.includes("left"), a = t.includes("top");
  return {
    isHorizontal: e,
    isVertical: r,
    affectsX: n,
    affectsY: a
  };
}
function rv(t, e) {
  return Math.max(0, e - t);
}
function nv(t, e) {
  return Math.max(0, t - e);
}
function TN(t, e, r) {
  return Math.max(0, e - t, t - r);
}
function sze(t, e) {
  return t ? !e : e;
}
function p0n(t, e, r, n, a, i, o, s) {
  let { affectsX: l, affectsY: c } = e;
  const { isHorizontal: u, isVertical: f } = e, h = u && f, { xSnapped: p, ySnapped: g } = r, { minWidth: y, maxWidth: b, minHeight: w, maxHeight: _ } = n, { x: C, y: x, width: S, height: A, aspectRatio: I } = t;
  let M = Math.floor(u ? p - t.pointerX : 0), B = Math.floor(f ? g - t.pointerY : 0);
  const L = S + (l ? -M : M), N = A + (c ? -B : B), d = -i[0] * S, m = -i[1] * A;
  let v = TN(L, y, b), k = TN(N, w, _);
  if (o) {
    let H = 0, j = 0;
    l && M < 0 ? H = rv(C + M + d, o[0][0]) : !l && M > 0 && (H = nv(C + L + d, o[1][0])), c && B < 0 ? j = rv(x + B + m, o[0][1]) : !c && B > 0 && (j = nv(x + N + m, o[1][1])), v = Math.max(v, H), k = Math.max(k, j);
  }
  if (s) {
    let H = 0, j = 0;
    l && M > 0 ? H = nv(C + M, s[0][0]) : !l && M < 0 && (H = rv(C + L, s[1][0])), c && B > 0 ? j = nv(x + B, s[0][1]) : !c && B < 0 && (j = rv(x + N, s[1][1])), v = Math.max(v, H), k = Math.max(k, j);
  }
  if (a) {
    if (u) {
      const H = TN(L / I, w, _) * I;
      if (v = Math.max(v, H), o) {
        let j = 0;
        !l && !c || l && !c && h ? j = nv(x + m + L / I, o[1][1]) * I : j = rv(x + m + (l ? M : -M) / I, o[0][1]) * I, v = Math.max(v, j);
      }
      if (s) {
        let j = 0;
        !l && !c || l && !c && h ? j = rv(x + L / I, s[1][1]) * I : j = nv(x + (l ? M : -M) / I, s[0][1]) * I, v = Math.max(v, j);
      }
    }
    if (f) {
      const H = TN(N * I, y, b) / I;
      if (k = Math.max(k, H), o) {
        let j = 0;
        !l && !c || c && !l && h ? j = nv(C + N * I + d, o[1][0]) / I : j = rv(C + (c ? B : -B) * I + d, o[0][0]) / I, k = Math.max(k, j);
      }
      if (s) {
        let j = 0;
        !l && !c || c && !l && h ? j = rv(C + N * I, s[1][0]) / I : j = nv(C + (c ? B : -B) * I, s[0][0]) / I, k = Math.max(k, j);
      }
    }
  }
  B = B + (B < 0 ? k : -k), M = M + (M < 0 ? v : -v), a && (h ? L > N * I ? B = (sze(l, c) ? -M : M) / I : M = (sze(l, c) ? -B : B) * I : u ? (B = M / I, c = l) : (M = B * I, l = c));
  const O = l ? C + M : C, G = c ? x + B : x;
  return {
    width: S + (l ? -M : M),
    height: A + (c ? -B : B),
    x: i[0] * M * (l ? -1 : 1) + O,
    y: i[1] * B * (c ? -1 : 1) + G
  };
}
const Jgt = { width: 0, height: 0, x: 0, y: 0 }, m0n = {
  ...Jgt,
  pointerX: 0,
  pointerY: 0,
  aspectRatio: 1
};
function g0n(t) {
  return [
    [0, 0],
    [t.measured.width, t.measured.height]
  ];
}
function v0n(t, e, r) {
  const n = e.position.x + t.position.x, a = e.position.y + t.position.y, i = t.measured.width ?? 0, o = t.measured.height ?? 0, s = r[0] * i, l = r[1] * o;
  return [
    [n - s, a - l],
    [n + i - s, a + o - l]
  ];
}
function y0n({ domNode: t, nodeId: e, getStoreItems: r, onChange: n, onEnd: a }) {
  const i = a0(t);
  function o({ controlPosition: l, boundaries: c, keepAspectRatio: u, onResizeStart: f, onResize: h, onResizeEnd: p, shouldResize: g }) {
    let y = { ...Jgt }, b = { ...m0n };
    const w = h0n(l);
    let _, C = null, x = [], S, A, I;
    const M = hgt().on("start", (B) => {
      const { nodeLookup: L, transform: N, snapGrid: d, snapToGrid: m, nodeOrigin: v, paneDomNode: k } = r();
      if (_ = L.get(e), !_)
        return;
      C = (k == null ? void 0 : k.getBoundingClientRect()) ?? null;
      const { xSnapped: O, ySnapped: G } = X_(B.sourceEvent, {
        transform: N,
        snapGrid: d,
        snapToGrid: m,
        containerBounds: C
      });
      y = {
        width: _.measured.width ?? 0,
        height: _.measured.height ?? 0,
        x: _.position.x ?? 0,
        y: _.position.y ?? 0
      }, b = {
        ...y,
        pointerX: O,
        pointerY: G,
        aspectRatio: y.width / y.height
      }, S = void 0, _.parentId && (_.extent === "parent" || _.expandParent) && (S = L.get(_.parentId), A = S && _.extent === "parent" ? g0n(S) : void 0), x = [], I = void 0;
      for (const [H, j] of L)
        if (j.parentId === e && (x.push({
          id: H,
          position: { ...j.position },
          extent: j.extent
        }), j.extent === "parent" || j.expandParent)) {
          const F = v0n(j, _, j.origin ?? v);
          I ? I = [
            [Math.min(F[0][0], I[0][0]), Math.min(F[0][1], I[0][1])],
            [Math.max(F[1][0], I[1][0]), Math.max(F[1][1], I[1][1])]
          ] : I = F;
        }
      f == null || f(B, { ...y });
    }).on("drag", (B) => {
      const { transform: L, snapGrid: N, snapToGrid: d, nodeOrigin: m } = r(), v = X_(B.sourceEvent, {
        transform: L,
        snapGrid: N,
        snapToGrid: d,
        containerBounds: C
      }), k = [];
      if (!_)
        return;
      const { x: O, y: G, width: H, height: j } = y, F = {}, z = _.origin ?? m, { width: W, height: U, x: Z, y: V } = p0n(b, w, v, c, u, z, A, I), Y = W !== H, ge = U !== j, ce = Z !== O && Y, ee = V !== G && ge;
      if (!ce && !ee && !Y && !ge)
        return;
      if ((ce || ee || z[0] === 1 || z[1] === 1) && (F.x = ce ? Z : y.x, F.y = ee ? V : y.y, y.x = F.x, y.y = F.y, x.length > 0)) {
        const We = Z - O, Fe = V - G;
        for (const it of x)
          it.position = {
            x: it.position.x - We + z[0] * (W - H),
            y: it.position.y - Fe + z[1] * (U - j)
          }, k.push(it);
      }
      if ((Y || ge) && (F.width = Y ? W : y.width, F.height = ge ? U : y.height, y.width = F.width, y.height = F.height), S && _.expandParent) {
        const We = z[0] * (F.width ?? 0);
        F.x && F.x < We && (y.x = We, b.x = b.x - (F.x - We));
        const Fe = z[1] * (F.height ?? 0);
        F.y && F.y < Fe && (y.y = Fe, b.y = b.y - (F.y - Fe));
      }
      const Se = f0n({
        width: y.width,
        prevWidth: H,
        height: y.height,
        prevHeight: j,
        affectsX: w.affectsX,
        affectsY: w.affectsY
      }), Ce = { ...y, direction: Se };
      (g == null ? void 0 : g(B, Ce)) !== !1 && (h == null || h(B, Ce), n(F, k));
    }).on("end", (B) => {
      p == null || p(B, { ...y }), a == null || a();
    });
    i.call(M);
  }
  function s() {
    i.on(".drag", null);
  }
  return {
    update: o,
    destroy: s
  };
}
var EN = { exports: {} }, ese = {}, IN = { exports: {} }, tse = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lze;
function b0n() {
  if (lze) return tse;
  lze = 1;
  var t = Te;
  function e(f, h) {
    return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
  }
  var r = typeof Object.is == "function" ? Object.is : e, n = t.useState, a = t.useEffect, i = t.useLayoutEffect, o = t.useDebugValue;
  function s(f, h) {
    var p = h(), g = n({ inst: { value: p, getSnapshot: h } }), y = g[0].inst, b = g[1];
    return i(
      function() {
        y.value = p, y.getSnapshot = h, l(y) && b({ inst: y });
      },
      [f, p, h]
    ), a(
      function() {
        return l(y) && b({ inst: y }), f(function() {
          l(y) && b({ inst: y });
        });
      },
      [f]
    ), o(p), p;
  }
  function l(f) {
    var h = f.getSnapshot;
    f = f.value;
    try {
      var p = h();
      return !r(f, p);
    } catch {
      return !0;
    }
  }
  function c(f, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return tse.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, tse;
}
var rse = {}, cze;
function x0n() {
  return cze || (cze = 1, Qa.env.NODE_ENV !== "production" && function() {
    function t(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function e(p, g) {
      u || a.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var y = g();
      if (!f) {
        var b = g();
        i(y, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      b = o({
        inst: { value: y, getSnapshot: g }
      });
      var w = b[0].inst, _ = b[1];
      return l(
        function() {
          w.value = y, w.getSnapshot = g, r(w) && _({ inst: w });
        },
        [p, y, g]
      ), s(
        function() {
          return r(w) && _({ inst: w }), p(function() {
            r(w) && _({ inst: w });
          });
        },
        [p]
      ), c(y), y;
    }
    function r(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var y = g();
        return !i(p, y);
      } catch {
        return !0;
      }
    }
    function n(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = Te, i = typeof Object.is == "function" ? Object.is : t, o = a.useState, s = a.useEffect, l = a.useLayoutEffect, c = a.useDebugValue, u = !1, f = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? n : e;
    rse.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), rse;
}
var uze;
function Ygt() {
  return uze || (uze = 1, Qa.env.NODE_ENV === "production" ? IN.exports = b0n() : IN.exports = x0n()), IN.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dze;
function C0n() {
  if (dze) return ese;
  dze = 1;
  var t = Te, e = Ygt();
  function r(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var n = typeof Object.is == "function" ? Object.is : r, a = e.useSyncExternalStore, i = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return ese.useSyncExternalStoreWithSelector = function(c, u, f, h, p) {
    var g = i(null);
    if (g.current === null) {
      var y = { hasValue: !1, value: null };
      g.current = y;
    } else y = g.current;
    g = s(
      function() {
        function w(A) {
          if (!_) {
            if (_ = !0, C = A, A = h(A), p !== void 0 && y.hasValue) {
              var I = y.value;
              if (p(I, A))
                return x = I;
            }
            return x = A;
          }
          if (I = x, n(C, A)) return I;
          var M = h(A);
          return p !== void 0 && p(I, M) ? (C = A, I) : (C = A, x = M);
        }
        var _ = !1, C, x, S = f === void 0 ? null : f;
        return [
          function() {
            return w(u());
          },
          S === null ? void 0 : function() {
            return w(S());
          }
        ];
      },
      [u, f, h, p]
    );
    var b = a(c, g[0], g[1]);
    return o(
      function() {
        y.hasValue = !0, y.value = b;
      },
      [b]
    ), l(b), b;
  }, ese;
}
var nse = {}, fze;
function w0n() {
  return fze || (fze = 1, Qa.env.NODE_ENV !== "production" && function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Te, r = Ygt(), n = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, i = e.useRef, o = e.useEffect, s = e.useMemo, l = e.useDebugValue;
    nse.useSyncExternalStoreWithSelector = function(c, u, f, h, p) {
      var g = i(null);
      if (g.current === null) {
        var y = { hasValue: !1, value: null };
        g.current = y;
      } else y = g.current;
      g = s(
        function() {
          function w(A) {
            if (!_) {
              if (_ = !0, C = A, A = h(A), p !== void 0 && y.hasValue) {
                var I = y.value;
                if (p(I, A))
                  return x = I;
              }
              return x = A;
            }
            if (I = x, n(C, A))
              return I;
            var M = h(A);
            return p !== void 0 && p(I, M) ? (C = A, I) : (C = A, x = M);
          }
          var _ = !1, C, x, S = f === void 0 ? null : f;
          return [
            function() {
              return w(u());
            },
            S === null ? void 0 : function() {
              return w(S());
            }
          ];
        },
        [u, f, h, p]
      );
      var b = a(c, g[0], g[1]);
      return o(
        function() {
          y.hasValue = !0, y.value = b;
        },
        [b]
      ), l(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), nse;
}
var hze;
function S0n() {
  return hze || (hze = 1, Qa.env.NODE_ENV === "production" ? EN.exports = C0n() : EN.exports = w0n()), EN.exports;
}
var _0n = S0n();
const k0n = /* @__PURE__ */ Gi(_0n), A0n = {}, pze = (t) => {
  let e;
  const r = /* @__PURE__ */ new Set(), n = (u, f) => {
    const h = typeof u == "function" ? u(e) : u;
    if (!Object.is(h, e)) {
      const p = e;
      e = f ?? (typeof h != "object" || h === null) ? h : Object.assign({}, e, h), r.forEach((g) => g(e, p));
    }
  }, a = () => e, l = { setState: n, getState: a, getInitialState: () => c, subscribe: (u) => (r.add(u), () => r.delete(u)), destroy: () => {
    (A0n ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), r.clear();
  } }, c = e = t(n, a, l);
  return l;
}, T0n = (t) => t ? pze(t) : pze, { useDebugValue: E0n } = Te, { useSyncExternalStoreWithSelector: I0n } = k0n, M0n = (t) => t;
function Xgt(t, e = M0n, r) {
  const n = I0n(
    t.subscribe,
    t.getState,
    t.getServerState || t.getInitialState,
    e,
    r
  );
  return E0n(n), n;
}
const mze = (t, e) => {
  const r = T0n(t), n = (a, i = e) => Xgt(r, a, i);
  return Object.assign(n, r), n;
}, P0n = (t, e) => t ? mze(t, e) : mze;
function Js(t, e) {
  if (Object.is(t, e))
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  if (t instanceof Map && e instanceof Map) {
    if (t.size !== e.size) return !1;
    for (const [n, a] of t)
      if (!Object.is(a, e.get(n)))
        return !1;
    return !0;
  }
  if (t instanceof Set && e instanceof Set) {
    if (t.size !== e.size) return !1;
    for (const n of t)
      if (!e.has(n))
        return !1;
    return !0;
  }
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !1;
  for (const n of r)
    if (!Object.prototype.hasOwnProperty.call(e, n) || !Object.is(t[n], e[n]))
      return !1;
  return !0;
}
const rU = Bo(null), R0n = rU.Provider, Qgt = m0.error001();
function oo(t, e) {
  const r = Qn(rU);
  if (r === null)
    throw new Error(Qgt);
  return Xgt(r, t, e);
}
function Is() {
  const t = Qn(rU);
  if (t === null)
    throw new Error(Qgt);
  return fa(() => ({
    getState: t.getState,
    setState: t.setState,
    subscribe: t.subscribe
  }), [t]);
}
const gze = { display: "none" }, O0n = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0px, 0px, 0px, 0px)",
  clipPath: "inset(100%)"
}, evt = "react-flow__node-desc", tvt = "react-flow__edge-desc", B0n = "react-flow__aria-live", N0n = (t) => t.ariaLiveMessage;
function $0n({ rfId: t }) {
  const e = oo(N0n);
  return R.jsx("div", { id: `${B0n}-${t}`, "aria-live": "assertive", "aria-atomic": "true", style: O0n, children: e });
}
function D0n({ rfId: t, disableKeyboardA11y: e }) {
  return R.jsxs(R.Fragment, { children: [R.jsxs("div", { id: `${evt}-${t}`, style: gze, children: ["Press enter or space to select a node.", !e && "You can then use the arrow keys to move the node around.", " Press delete to remove it and escape to cancel.", " "] }), R.jsx("div", { id: `${tvt}-${t}`, style: gze, children: "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel." }), !e && R.jsx($0n, { rfId: t })] });
}
const L0n = (t) => t.userSelectionActive ? "none" : "all", AP = Ml(({ position: t = "top-left", children: e, className: r, style: n, ...a }, i) => {
  const o = oo(L0n), s = `${t}`.split("-");
  return R.jsx("div", { className: Pl(["react-flow__panel", r, ...s]), style: { ...n, pointerEvents: o }, ref: i, ...a, children: e });
});
AP.displayName = "Panel";
function j0n({ proOptions: t, position: e = "bottom-right" }) {
  return t != null && t.hideAttribution ? null : R.jsx(AP, { position: e, className: "react-flow__attribution", "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://pro.reactflow.dev", children: R.jsx("a", { href: "https://reactflow.dev", target: "_blank", rel: "noopener noreferrer", "aria-label": "React Flow attribution", children: "React Flow" }) });
}
const F0n = (t) => {
  const e = [], r = [];
  for (const [, n] of t.nodeLookup)
    n.selected && e.push(n.internals.userNode);
  for (const [, n] of t.edgeLookup)
    n.selected && r.push(n);
  return { selectedNodes: e, selectedEdges: r };
}, MN = (t) => t.id;
function z0n(t, e) {
  return Js(t.selectedNodes.map(MN), e.selectedNodes.map(MN)) && Js(t.selectedEdges.map(MN), e.selectedEdges.map(MN));
}
function G0n({ onSelectionChange: t }) {
  const e = Is(), { selectedNodes: r, selectedEdges: n } = oo(F0n, z0n);
  return Ut(() => {
    const a = { nodes: r, edges: n };
    t == null || t(a), e.getState().onSelectionChangeHandlers.forEach((i) => i(a));
  }, [r, n, t]), null;
}
const W0n = (t) => !!t.onSelectionChangeHandlers;
function H0n({ onSelectionChange: t }) {
  const e = oo(W0n);
  return t || e ? R.jsx(G0n, { onSelectionChange: t }) : null;
}
const rvt = [0, 0], U0n = { x: 0, y: 0, zoom: 1 }, V0n = [
  "nodes",
  "edges",
  "defaultNodes",
  "defaultEdges",
  "onConnect",
  "onConnectStart",
  "onConnectEnd",
  "onClickConnectStart",
  "onClickConnectEnd",
  "nodesDraggable",
  "nodesConnectable",
  "nodesFocusable",
  "edgesFocusable",
  "edgesReconnectable",
  "elevateNodesOnSelect",
  "elevateEdgesOnSelect",
  "minZoom",
  "maxZoom",
  "nodeExtent",
  "onNodesChange",
  "onEdgesChange",
  "elementsSelectable",
  "connectionMode",
  "snapGrid",
  "snapToGrid",
  "translateExtent",
  "connectOnClick",
  "defaultEdgeOptions",
  "fitView",
  "fitViewOptions",
  "onNodesDelete",
  "onEdgesDelete",
  "onDelete",
  "onNodeDrag",
  "onNodeDragStart",
  "onNodeDragStop",
  "onSelectionDrag",
  "onSelectionDragStart",
  "onSelectionDragStop",
  "onMoveStart",
  "onMove",
  "onMoveEnd",
  "noPanClassName",
  "nodeOrigin",
  "autoPanOnConnect",
  "autoPanOnNodeDrag",
  "onError",
  "connectionRadius",
  "isValidConnection",
  "selectNodesOnDrag",
  "nodeDragThreshold",
  "onBeforeDelete",
  "debug",
  "autoPanSpeed",
  "paneClickDistance"
], vze = [...V0n, "rfId"], q0n = (t) => ({
  setNodes: t.setNodes,
  setEdges: t.setEdges,
  setMinZoom: t.setMinZoom,
  setMaxZoom: t.setMaxZoom,
  setTranslateExtent: t.setTranslateExtent,
  setNodeExtent: t.setNodeExtent,
  reset: t.reset,
  setDefaultNodesAndEdges: t.setDefaultNodesAndEdges,
  setPaneClickDistance: t.setPaneClickDistance
}), yze = {
  /*
   * these are values that are also passed directly to other components
   * than the StoreUpdater. We can reduce the number of setStore calls
   * by setting the same values here as prev fields.
   */
  translateExtent: xI,
  nodeOrigin: rvt,
  minZoom: 0.5,
  maxZoom: 2,
  elementsSelectable: !0,
  noPanClassName: "nopan",
  rfId: "1",
  paneClickDistance: 0
};
function K0n(t) {
  const { setNodes: e, setEdges: r, setMinZoom: n, setMaxZoom: a, setTranslateExtent: i, setNodeExtent: o, reset: s, setDefaultNodesAndEdges: l, setPaneClickDistance: c } = oo(q0n, Js), u = Is();
  Ut(() => (l(t.defaultNodes, t.defaultEdges), () => {
    f.current = yze, s();
  }), []);
  const f = Zt(yze);
  return Ut(
    () => {
      for (const h of vze) {
        const p = t[h], g = f.current[h];
        p !== g && (typeof t[h] > "u" || (h === "nodes" ? e(p) : h === "edges" ? r(p) : h === "minZoom" ? n(p) : h === "maxZoom" ? a(p) : h === "translateExtent" ? i(p) : h === "nodeExtent" ? o(p) : h === "paneClickDistance" ? c(p) : h === "fitView" ? u.setState({ fitViewOnInit: p }) : h === "fitViewOptions" ? u.setState({ fitViewOnInitOptions: p }) : u.setState({ [h]: p })));
      }
      f.current = t;
    },
    // Only re-run the effect if one of the fields we track changes
    vze.map((h) => t[h])
  ), null;
}
function bze() {
  return typeof window > "u" || !window.matchMedia ? null : window.matchMedia("(prefers-color-scheme: dark)");
}
function Z0n(t) {
  var n;
  const [e, r] = Yt(t === "system" ? null : t);
  return Ut(() => {
    if (t !== "system") {
      r(t);
      return;
    }
    const a = bze(), i = () => r(a != null && a.matches ? "dark" : "light");
    return i(), a == null || a.addEventListener("change", i), () => {
      a == null || a.removeEventListener("change", i);
    };
  }, [t]), e !== null ? e : (n = bze()) != null && n.matches ? "dark" : "light";
}
const xze = typeof document < "u" ? document : null;
function _I(t = null, e = { target: xze, actInsideInputWithModifier: !0 }) {
  const [r, n] = Yt(!1), a = Zt(!1), i = Zt(/* @__PURE__ */ new Set([])), [o, s] = fa(() => {
    if (t !== null) {
      const c = (Array.isArray(t) ? t : [t]).filter((f) => typeof f == "string").map((f) => f.replace("+", `
`).replace(`

`, `
+`).split(`
`)), u = c.reduce((f, h) => f.concat(...h), []);
      return [c, u];
    }
    return [[], []];
  }, [t]);
  return Ut(() => {
    const l = (e == null ? void 0 : e.target) || xze;
    if (t !== null) {
      const c = (h) => {
        if (a.current = h.ctrlKey || h.metaKey || h.shiftKey, (!a.current || a.current && !e.actInsideInputWithModifier) && Yfe(h))
          return !1;
        const g = wze(h.code, s);
        i.current.add(h[g]), Cze(o, i.current, !1) && (h.preventDefault(), n(!0));
      }, u = (h) => {
        if ((!a.current || a.current && !e.actInsideInputWithModifier) && Yfe(h))
          return !1;
        const g = wze(h.code, s);
        Cze(o, i.current, !0) ? (n(!1), i.current.clear()) : i.current.delete(h[g]), h.key === "Meta" && i.current.clear(), a.current = !1;
      }, f = () => {
        i.current.clear(), n(!1);
      };
      return l == null || l.addEventListener("keydown", c), l == null || l.addEventListener("keyup", u), window.addEventListener("blur", f), window.addEventListener("contextmenu", f), () => {
        l == null || l.removeEventListener("keydown", c), l == null || l.removeEventListener("keyup", u), window.removeEventListener("blur", f), window.removeEventListener("contextmenu", f);
      };
    }
  }, [t, n]), r;
}
function Cze(t, e, r) {
  return t.filter((n) => r || n.length === e.size).some((n) => n.every((a) => e.has(a)));
}
function wze(t, e) {
  return e.includes(t) ? "code" : "key";
}
const J0n = () => {
  const t = Is();
  return fa(() => ({
    zoomIn: (e) => {
      const { panZoom: r } = t.getState();
      return r ? r.scaleBy(1.2, { duration: e == null ? void 0 : e.duration }) : Promise.resolve(!1);
    },
    zoomOut: (e) => {
      const { panZoom: r } = t.getState();
      return r ? r.scaleBy(1 / 1.2, { duration: e == null ? void 0 : e.duration }) : Promise.resolve(!1);
    },
    zoomTo: (e, r) => {
      const { panZoom: n } = t.getState();
      return n ? n.scaleTo(e, { duration: r == null ? void 0 : r.duration }) : Promise.resolve(!1);
    },
    getZoom: () => t.getState().transform[2],
    setViewport: async (e, r) => {
      const { transform: [n, a, i], panZoom: o } = t.getState();
      return o ? (await o.setViewport({
        x: e.x ?? n,
        y: e.y ?? a,
        zoom: e.zoom ?? i
      }, { duration: r == null ? void 0 : r.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    getViewport: () => {
      const [e, r, n] = t.getState().transform;
      return { x: e, y: r, zoom: n };
    },
    fitView: (e) => {
      const { nodeLookup: r, minZoom: n, maxZoom: a, panZoom: i, domNode: o } = t.getState();
      if (!i || !o)
        return Promise.resolve(!1);
      const s = Kfe(r, e), { width: l, height: c } = eU(o);
      return Zfe({
        nodes: s,
        width: l,
        height: c,
        minZoom: n,
        maxZoom: a,
        panZoom: i
      }, e);
    },
    setCenter: async (e, r, n) => {
      const { width: a, height: i, maxZoom: o, panZoom: s } = t.getState(), l = typeof (n == null ? void 0 : n.zoom) < "u" ? n.zoom : o, c = a / 2 - e * l, u = i / 2 - r * l;
      return s ? (await s.setViewport({
        x: c,
        y: u,
        zoom: l
      }, { duration: n == null ? void 0 : n.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    fitBounds: async (e, r) => {
      const { width: n, height: a, minZoom: i, maxZoom: o, panZoom: s } = t.getState(), l = Bbe(e, n, a, i, o, (r == null ? void 0 : r.padding) ?? 0.1);
      return s ? (await s.setViewport(l, { duration: r == null ? void 0 : r.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    screenToFlowPosition: (e, r = {}) => {
      const { transform: n, snapGrid: a, snapToGrid: i, domNode: o } = t.getState();
      if (!o)
        return e;
      const { x: s, y: l } = o.getBoundingClientRect(), c = {
        x: e.x - s,
        y: e.y - l
      }, u = r.snapGrid ?? a, f = r.snapToGrid ?? i;
      return kP(c, n, f, u);
    },
    flowToScreenPosition: (e) => {
      const { transform: r, domNode: n } = t.getState();
      if (!n)
        return e;
      const { x: a, y: i } = n.getBoundingClientRect(), o = Ogt(e, r);
      return {
        x: o.x + a,
        y: o.y + i
      };
    }
  }), []);
};
function nvt(t, e) {
  const r = [], n = /* @__PURE__ */ new Map(), a = [];
  for (const i of t)
    if (i.type === "add") {
      a.push(i);
      continue;
    } else if (i.type === "remove" || i.type === "replace")
      n.set(i.id, [i]);
    else {
      const o = n.get(i.id);
      o ? o.push(i) : n.set(i.id, [i]);
    }
  for (const i of e) {
    const o = n.get(i.id);
    if (!o) {
      r.push(i);
      continue;
    }
    if (o[0].type === "remove")
      continue;
    if (o[0].type === "replace") {
      r.push({ ...o[0].item });
      continue;
    }
    const s = { ...i };
    for (const l of o)
      Y0n(l, s);
    r.push(s);
  }
  return a.length && a.forEach((i) => {
    i.index !== void 0 ? r.splice(i.index, 0, { ...i.item }) : r.push({ ...i.item });
  }), r;
}
function Y0n(t, e) {
  switch (t.type) {
    case "select": {
      e.selected = t.selected;
      break;
    }
    case "position": {
      typeof t.position < "u" && (e.position = t.position), typeof t.dragging < "u" && (e.dragging = t.dragging);
      break;
    }
    case "dimensions": {
      typeof t.dimensions < "u" && (e.measured ?? (e.measured = {}), e.measured.width = t.dimensions.width, e.measured.height = t.dimensions.height, t.setAttributes && (e.width = t.dimensions.width, e.height = t.dimensions.height)), typeof t.resizing == "boolean" && (e.resizing = t.resizing);
      break;
    }
  }
}
function avt(t, e) {
  return nvt(t, e);
}
function ivt(t, e) {
  return nvt(t, e);
}
function rb(t, e) {
  return {
    id: t,
    type: "select",
    selected: e
  };
}
function n7(t, e = /* @__PURE__ */ new Set(), r = !1) {
  const n = [];
  for (const [a, i] of t) {
    const o = e.has(a);
    !(i.selected === void 0 && !o) && i.selected !== o && (r && (i.selected = o), n.push(rb(i.id, o)));
  }
  return n;
}
function Sze({ items: t = [], lookup: e }) {
  var a;
  const r = [], n = new Map(t.map((i) => [i.id, i]));
  for (const [i, o] of t.entries()) {
    const s = e.get(o.id), l = ((a = s == null ? void 0 : s.internals) == null ? void 0 : a.userNode) ?? s;
    l !== void 0 && l !== o && r.push({ id: o.id, item: o, type: "replace" }), l === void 0 && r.push({ item: o, type: "add", index: i });
  }
  for (const [i] of e)
    n.get(i) === void 0 && r.push({ id: i, type: "remove" });
  return r;
}
function _ze(t) {
  return {
    id: t.id,
    type: "remove"
  };
}
const kze = (t) => Idn(t), X0n = (t) => Agt(t);
function ovt(t) {
  return Ml(t);
}
const Q0n = typeof window < "u" ? qh : Ut;
function Aze(t) {
  const [e, r] = Yt(BigInt(0)), [n] = Yt(() => efn(() => r((a) => a + BigInt(1))));
  return Q0n(() => {
    const a = n.get();
    a.length && (t(a), n.reset());
  }, [e]), n;
}
function efn(t) {
  let e = [];
  return {
    get: () => e,
    reset: () => {
      e = [];
    },
    push: (r) => {
      e.push(r), t();
    }
  };
}
const svt = Bo(null);
function tfn({ children: t }) {
  const e = Is(), r = sr((s) => {
    const { nodes: l = [], setNodes: c, hasDefaultNodes: u, onNodesChange: f, nodeLookup: h } = e.getState();
    let p = l;
    for (const g of s)
      p = typeof g == "function" ? g(p) : g;
    u ? c(p) : f && f(Sze({
      items: p,
      lookup: h
    }));
  }, []), n = Aze(r), a = sr((s) => {
    const { edges: l = [], setEdges: c, hasDefaultEdges: u, onEdgesChange: f, edgeLookup: h } = e.getState();
    let p = l;
    for (const g of s)
      p = typeof g == "function" ? g(p) : g;
    u ? c(p) : f && f(Sze({
      items: p,
      lookup: h
    }));
  }, []), i = Aze(a), o = fa(() => ({ nodeQueue: n, edgeQueue: i }), []);
  return R.jsx(svt.Provider, { value: o, children: t });
}
function rfn() {
  const t = Qn(svt);
  if (!t)
    throw new Error("useBatchContext must be used within a BatchProvider");
  return t;
}
const nfn = (t) => !!t.panZoom;
function nU() {
  const t = J0n(), e = Is(), r = rfn(), n = oo(nfn), a = fa(() => {
    const i = (f) => e.getState().nodeLookup.get(f), o = (f) => {
      r.nodeQueue.push(f);
    }, s = (f) => {
      r.edgeQueue.push(f);
    }, l = (f) => {
      var w, _;
      const { nodeLookup: h, nodeOrigin: p } = e.getState(), g = kze(f) ? f : h.get(f.id), y = g.parentId ? Bgt(g.position, g.measured, g.parentId, h, p) : g.position, b = {
        ...g,
        position: y,
        width: ((w = g.measured) == null ? void 0 : w.width) ?? g.width,
        height: ((_ = g.measured) == null ? void 0 : _.height) ?? g.height
      };
      return f8(b);
    }, c = (f, h, p = { replace: !1 }) => {
      o((g) => g.map((y) => {
        if (y.id === f) {
          const b = typeof h == "function" ? h(y) : h;
          return p.replace && kze(b) ? b : { ...y, ...b };
        }
        return y;
      }));
    }, u = (f, h, p = { replace: !1 }) => {
      s((g) => g.map((y) => {
        if (y.id === f) {
          const b = typeof h == "function" ? h(y) : h;
          return p.replace && X0n(b) ? b : { ...y, ...b };
        }
        return y;
      }));
    };
    return {
      getNodes: () => e.getState().nodes.map((f) => ({ ...f })),
      getNode: (f) => {
        var h;
        return (h = i(f)) == null ? void 0 : h.internals.userNode;
      },
      getInternalNode: i,
      getEdges: () => {
        const { edges: f = [] } = e.getState();
        return f.map((h) => ({ ...h }));
      },
      getEdge: (f) => e.getState().edgeLookup.get(f),
      setNodes: o,
      setEdges: s,
      addNodes: (f) => {
        const h = Array.isArray(f) ? f : [f];
        r.nodeQueue.push((p) => [...p, ...h]);
      },
      addEdges: (f) => {
        const h = Array.isArray(f) ? f : [f];
        r.edgeQueue.push((p) => [...p, ...h]);
      },
      toObject: () => {
        const { nodes: f = [], edges: h = [], transform: p } = e.getState(), [g, y, b] = p;
        return {
          nodes: f.map((w) => ({ ...w })),
          edges: h.map((w) => ({ ...w })),
          viewport: {
            x: g,
            y,
            zoom: b
          }
        };
      },
      deleteElements: async ({ nodes: f = [], edges: h = [] }) => {
        const { nodes: p, edges: g, onNodesDelete: y, onEdgesDelete: b, triggerNodeChanges: w, triggerEdgeChanges: _, onDelete: C, onBeforeDelete: x } = e.getState(), { nodes: S, edges: A } = await Rdn({
          nodesToRemove: f,
          edgesToRemove: h,
          nodes: p,
          edges: g,
          onBeforeDelete: x
        }), I = A.length > 0, M = S.length > 0;
        if (I) {
          const B = A.map(_ze);
          b == null || b(A), _(B);
        }
        if (M) {
          const B = S.map(_ze);
          y == null || y(S), w(B);
        }
        return (M || I) && (C == null || C({ nodes: S, edges: A })), { deletedNodes: S, deletedEdges: A };
      },
      getIntersectingNodes: (f, h = !0, p) => {
        const g = JFe(f), y = g ? f : l(f), b = p !== void 0;
        return y ? (p || e.getState().nodes).filter((w) => {
          const _ = e.getState().nodeLookup.get(w.id);
          if (_ && !g && (w.id === f.id || !_.internals.positionAbsolute))
            return !1;
          const C = f8(b ? w : _), x = wI(C, y);
          return h && x > 0 || x >= y.width * y.height;
        }) : [];
      },
      isNodeIntersecting: (f, h, p = !0) => {
        const y = JFe(f) ? f : l(f);
        if (!y)
          return !1;
        const b = wI(y, h);
        return p && b > 0 || b >= y.width * y.height;
      },
      updateNode: c,
      updateNodeData: (f, h, p = { replace: !1 }) => {
        c(f, (g) => {
          const y = typeof h == "function" ? h(g) : h;
          return p.replace ? { ...g, data: y } : { ...g, data: { ...g.data, ...y } };
        }, p);
      },
      updateEdge: u,
      updateEdgeData: (f, h, p = { replace: !1 }) => {
        u(f, (g) => {
          const y = typeof h == "function" ? h(g) : h;
          return p.replace ? { ...g, data: y } : { ...g, data: { ...g.data, ...y } };
        }, p);
      },
      getNodesBounds: (f) => {
        const { nodeLookup: h, nodeOrigin: p } = e.getState();
        return Mdn(f, { nodeLookup: h, nodeOrigin: p });
      },
      getHandleConnections: ({ type: f, id: h, nodeId: p }) => {
        var g;
        return Array.from(((g = e.getState().connectionLookup.get(`${p}-${f}${h ? `-${h}` : ""}`)) == null ? void 0 : g.values()) ?? []);
      },
      getNodeConnections: ({ type: f, handleId: h, nodeId: p }) => {
        var g;
        return Array.from(((g = e.getState().connectionLookup.get(`${p}${f ? h ? `-${f}-${h}` : `-${f}` : ""}`)) == null ? void 0 : g.values()) ?? []);
      }
    };
  }, []);
  return fa(() => ({
    ...a,
    ...t,
    viewportInitialized: n
  }), [n]);
}
const Tze = (t) => t.selected, afn = { actInsideInputWithModifier: !1 }, ifn = typeof window < "u" ? window : void 0;
function ofn({ deleteKeyCode: t, multiSelectionKeyCode: e }) {
  const r = Is(), { deleteElements: n } = nU(), a = _I(t, afn), i = _I(e, { target: ifn });
  Ut(() => {
    if (a) {
      const { edges: o, nodes: s } = r.getState();
      n({ nodes: s.filter(Tze), edges: o.filter(Tze) }), r.setState({ nodesSelectionActive: !1 });
    }
  }, [a]), Ut(() => {
    r.setState({ multiSelectionActive: i });
  }, [i]);
}
function sfn(t) {
  const e = Is();
  Ut(() => {
    const r = () => {
      var a, i;
      if (!t.current)
        return !1;
      const n = eU(t.current);
      (n.height === 0 || n.width === 0) && ((i = (a = e.getState()).onError) == null || i.call(a, "004", m0.error004())), e.setState({ width: n.width || 500, height: n.height || 500 });
    };
    if (t.current) {
      r(), window.addEventListener("resize", r);
      const n = new ResizeObserver(() => r());
      return n.observe(t.current), () => {
        window.removeEventListener("resize", r), n && t.current && n.unobserve(t.current);
      };
    }
  }, []);
}
const aU = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
}, lfn = (t) => ({
  userSelectionActive: t.userSelectionActive,
  lib: t.lib
});
function cfn({ onPaneContextMenu: t, zoomOnScroll: e = !0, zoomOnPinch: r = !0, panOnScroll: n = !1, panOnScrollSpeed: a = 0.5, panOnScrollMode: i = Yb.Free, zoomOnDoubleClick: o = !0, panOnDrag: s = !0, defaultViewport: l, translateExtent: c, minZoom: u, maxZoom: f, zoomActivationKeyCode: h, preventScrolling: p = !0, children: g, noWheelClassName: y, noPanClassName: b, onViewportChange: w, isControlledViewport: _, paneClickDistance: C }) {
  const x = Is(), S = Zt(null), { userSelectionActive: A, lib: I } = oo(lfn, Js), M = _I(h), B = Zt();
  sfn(S);
  const L = sr((N) => {
    w == null || w({ x: N[0], y: N[1], zoom: N[2] }), _ || x.setState({ transform: N });
  }, [w, _]);
  return Ut(() => {
    if (S.current) {
      B.current = d0n({
        domNode: S.current,
        minZoom: u,
        maxZoom: f,
        translateExtent: c,
        viewport: l,
        paneClickDistance: C,
        onDraggingChange: (v) => x.setState({ paneDragging: v }),
        onPanZoomStart: (v, k) => {
          const { onViewportChangeStart: O, onMoveStart: G } = x.getState();
          G == null || G(v, k), O == null || O(k);
        },
        onPanZoom: (v, k) => {
          const { onViewportChange: O, onMove: G } = x.getState();
          G == null || G(v, k), O == null || O(k);
        },
        onPanZoomEnd: (v, k) => {
          const { onViewportChangeEnd: O, onMoveEnd: G } = x.getState();
          G == null || G(v, k), O == null || O(k);
        }
      });
      const { x: N, y: d, zoom: m } = B.current.getViewport();
      return x.setState({
        panZoom: B.current,
        transform: [N, d, m],
        domNode: S.current.closest(".react-flow")
      }), () => {
        var v;
        (v = B.current) == null || v.destroy();
      };
    }
  }, []), Ut(() => {
    var N;
    (N = B.current) == null || N.update({
      onPaneContextMenu: t,
      zoomOnScroll: e,
      zoomOnPinch: r,
      panOnScroll: n,
      panOnScrollSpeed: a,
      panOnScrollMode: i,
      zoomOnDoubleClick: o,
      panOnDrag: s,
      zoomActivationKeyPressed: M,
      preventScrolling: p,
      noPanClassName: b,
      userSelectionActive: A,
      noWheelClassName: y,
      lib: I,
      onTransformChange: L
    });
  }, [
    t,
    e,
    r,
    n,
    a,
    i,
    o,
    s,
    M,
    p,
    b,
    A,
    y,
    I,
    L
  ]), R.jsx("div", { className: "react-flow__renderer", ref: S, style: aU, children: g });
}
const ufn = (t) => ({
  userSelectionActive: t.userSelectionActive,
  userSelectionRect: t.userSelectionRect
});
function dfn() {
  const { userSelectionActive: t, userSelectionRect: e } = oo(ufn, Js);
  return t && e ? R.jsx("div", { className: "react-flow__selection react-flow__container", style: {
    width: e.width,
    height: e.height,
    transform: `translate(${e.x}px, ${e.y}px)`
  } }) : null;
}
const ase = (t, e) => (r) => {
  r.target === e.current && (t == null || t(r));
}, ffn = (t) => ({
  userSelectionActive: t.userSelectionActive,
  elementsSelectable: t.elementsSelectable,
  dragging: t.paneDragging
});
function hfn({ isSelecting: t, selectionKeyPressed: e, selectionMode: r = CI.Full, panOnDrag: n, selectionOnDrag: a, onSelectionStart: i, onSelectionEnd: o, onPaneClick: s, onPaneContextMenu: l, onPaneScroll: c, onPaneMouseEnter: u, onPaneMouseMove: f, onPaneMouseLeave: h, children: p }) {
  const g = Is(), { userSelectionActive: y, elementsSelectable: b, dragging: w } = oo(ffn, Js), _ = b && (t || y), C = Zt(null), x = Zt(), S = Zt(/* @__PURE__ */ new Set()), A = Zt(/* @__PURE__ */ new Set()), I = Zt(!1), M = Zt(!1), B = (O) => {
    if (I.current) {
      I.current = !1;
      return;
    }
    s == null || s(O), g.getState().resetSelectedElements(), g.setState({ nodesSelectionActive: !1 });
  }, L = (O) => {
    if (Array.isArray(n) && (n != null && n.includes(2))) {
      O.preventDefault();
      return;
    }
    l == null || l(O);
  }, N = c ? (O) => c(O) : void 0, d = (O) => {
    var z, W;
    const { resetSelectedElements: G, domNode: H } = g.getState();
    if (x.current = H == null ? void 0 : H.getBoundingClientRect(), !b || !t || O.button !== 0 || O.target !== C.current || !x.current)
      return;
    (W = (z = O.target) == null ? void 0 : z.setPointerCapture) == null || W.call(z, O.pointerId), M.current = !0, I.current = !1;
    const { x: j, y: F } = Bm(O.nativeEvent, x.current);
    G(), g.setState({
      userSelectionRect: {
        width: 0,
        height: 0,
        startX: j,
        startY: F,
        x: j,
        y: F
      }
    }), i == null || i(O);
  }, m = (O) => {
    const { userSelectionRect: G, transform: H, nodeLookup: j, edgeLookup: F, connectionLookup: z, triggerNodeChanges: W, triggerEdgeChanges: U, defaultEdgeOptions: Z } = g.getState();
    if (!x.current || !G)
      return;
    I.current = !0;
    const { x: V, y: Y } = Bm(O.nativeEvent, x.current), { startX: ge, startY: ce } = G, ee = {
      startX: ge,
      startY: ce,
      x: V < ge ? V : ge,
      y: Y < ce ? Y : ce,
      width: Math.abs(V - ge),
      height: Math.abs(Y - ce)
    }, Se = S.current, Ce = A.current;
    S.current = new Set(Tgt(j, ee, H, r === CI.Partial, !0).map((We) => We.id)), A.current = /* @__PURE__ */ new Set();
    const we = (Z == null ? void 0 : Z.selectable) ?? !0;
    for (const We of S.current) {
      const Fe = z.get(We);
      if (Fe)
        for (const { edgeId: it } of Fe.values()) {
          const gt = F.get(it);
          gt && (gt.selectable ?? we) && A.current.add(it);
        }
    }
    if (!YFe(Se, S.current)) {
      const We = n7(j, S.current, !0);
      W(We);
    }
    if (!YFe(Ce, A.current)) {
      const We = n7(F, A.current);
      U(We);
    }
    g.setState({
      userSelectionRect: ee,
      userSelectionActive: !0,
      nodesSelectionActive: !1
    });
  }, v = (O) => {
    var H, j;
    if (O.button !== 0 || !M.current)
      return;
    (j = (H = O.target) == null ? void 0 : H.releasePointerCapture) == null || j.call(H, O.pointerId);
    const { userSelectionRect: G } = g.getState();
    !y && G && O.target === C.current && (B == null || B(O)), g.setState({
      userSelectionActive: !1,
      userSelectionRect: null,
      nodesSelectionActive: S.current.size > 0
    }), o == null || o(O), (e || a) && (I.current = !1), M.current = !1;
  }, k = n === !0 || Array.isArray(n) && n.includes(0);
  return R.jsxs("div", { className: Pl(["react-flow__pane", { draggable: k, dragging: w, selection: t }]), onClick: _ ? void 0 : ase(B, C), onContextMenu: ase(L, C), onWheel: ase(N, C), onPointerEnter: _ ? void 0 : u, onPointerDown: _ ? d : f, onPointerMove: _ ? m : f, onPointerUp: _ ? v : void 0, onPointerLeave: h, ref: C, style: aU, children: [p, R.jsx(dfn, {})] });
}
function r1e({ id: t, store: e, unselect: r = !1, nodeRef: n }) {
  const { addSelectedNodes: a, unselectNodesAndEdges: i, multiSelectionActive: o, nodeLookup: s, onError: l } = e.getState(), c = s.get(t);
  if (!c) {
    l == null || l("012", m0.error012(t));
    return;
  }
  e.setState({ nodesSelectionActive: !1 }), c.selected ? (r || c.selected && o) && (i({ nodes: [c], edges: [] }), requestAnimationFrame(() => {
    var u;
    return (u = n == null ? void 0 : n.current) == null ? void 0 : u.blur();
  })) : a([t]);
}
function lvt({ nodeRef: t, disabled: e = !1, noDragClassName: r, handleSelector: n, nodeId: a, isSelectable: i, nodeClickDistance: o }) {
  const s = Is(), [l, c] = Yt(!1), u = Zt();
  return Ut(() => {
    u.current = Ydn({
      getStoreItems: () => s.getState(),
      onNodeMouseDown: (f) => {
        r1e({
          id: f,
          store: s,
          nodeRef: t
        });
      },
      onDragStart: () => {
        c(!0);
      },
      onDragStop: () => {
        c(!1);
      }
    });
  }, []), Ut(() => {
    var f, h;
    if (e)
      (f = u.current) == null || f.destroy();
    else if (t.current)
      return (h = u.current) == null || h.update({
        noDragClassName: r,
        handleSelector: n,
        domNode: t.current,
        isSelectable: i,
        nodeId: a,
        nodeClickDistance: o
      }), () => {
        var p;
        (p = u.current) == null || p.destroy();
      };
  }, [r, n, e, i, t, a]), l;
}
const pfn = (t) => (e) => e.selected && (e.draggable || t && typeof e.draggable > "u");
function cvt() {
  const t = Is();
  return sr((r) => {
    const { nodeExtent: n, snapToGrid: a, snapGrid: i, nodesDraggable: o, onError: s, updateNodePositions: l, nodeLookup: c, nodeOrigin: u } = t.getState(), f = /* @__PURE__ */ new Map(), h = pfn(o), p = a ? i[0] : 5, g = a ? i[1] : 5, y = r.direction.x * p * r.factor, b = r.direction.y * g * r.factor;
    for (const [, w] of c) {
      if (!h(w))
        continue;
      let _ = {
        x: w.internals.positionAbsolute.x + y,
        y: w.internals.positionAbsolute.y + b
      };
      a && (_ = QH(_, i));
      const { position: C, positionAbsolute: x } = Egt({
        nodeId: w.id,
        nextPosition: _,
        nodeLookup: c,
        nodeExtent: n,
        nodeOrigin: u,
        onError: s
      });
      w.position = C, w.internals.positionAbsolute = x, f.set(w.id, w);
    }
    l(f);
  }, []);
}
const Fbe = Bo(null), mfn = Fbe.Provider;
Fbe.Consumer;
const uvt = () => Qn(Fbe), gfn = (t) => ({
  connectOnClick: t.connectOnClick,
  noPanClassName: t.noPanClassName,
  rfId: t.rfId
}), vfn = (t, e, r) => (n) => {
  const { connectionClickStartHandle: a, connectionMode: i, connection: o } = n, { fromHandle: s, toHandle: l, isValid: c } = o, u = (l == null ? void 0 : l.nodeId) === t && (l == null ? void 0 : l.id) === e && (l == null ? void 0 : l.type) === r;
  return {
    connectingFrom: (s == null ? void 0 : s.nodeId) === t && (s == null ? void 0 : s.id) === e && (s == null ? void 0 : s.type) === r,
    connectingTo: u,
    clickConnecting: (a == null ? void 0 : a.nodeId) === t && (a == null ? void 0 : a.id) === e && (a == null ? void 0 : a.type) === r,
    isPossibleEndHandle: i === u8.Strict ? (s == null ? void 0 : s.type) !== r : t !== (s == null ? void 0 : s.nodeId) || e !== (s == null ? void 0 : s.id),
    connectionInProcess: !!s,
    clickConnectionInProcess: !!a,
    valid: u && c
  };
};
function yfn({ type: t = "source", position: e = Hn.Top, isValidConnection: r, isConnectable: n = !0, isConnectableStart: a = !0, isConnectableEnd: i = !0, id: o, onConnect: s, children: l, className: c, onMouseDown: u, onTouchStart: f, ...h }, p) {
  var k, O;
  const g = o || null, y = t === "target", b = Is(), w = uvt(), { connectOnClick: _, noPanClassName: C, rfId: x } = oo(gfn, Js), { connectingFrom: S, connectingTo: A, clickConnecting: I, isPossibleEndHandle: M, connectionInProcess: B, clickConnectionInProcess: L, valid: N } = oo(vfn(w, g, t), Js);
  w || (O = (k = b.getState()).onError) == null || O.call(k, "010", m0.error010());
  const d = (G) => {
    const { defaultEdgeOptions: H, onConnect: j, hasDefaultEdges: F } = b.getState(), z = {
      ...H,
      ...G
    };
    if (F) {
      const { edges: W, setEdges: U } = b.getState();
      U(Ldn(z, W));
    }
    j == null || j(z), s == null || s(z);
  }, m = (G) => {
    if (!w)
      return;
    const H = $gt(G.nativeEvent);
    if (a && (H && G.button === 0 || !H)) {
      const j = b.getState();
      t1e.onPointerDown(G.nativeEvent, {
        autoPanOnConnect: j.autoPanOnConnect,
        connectionMode: j.connectionMode,
        connectionRadius: j.connectionRadius,
        domNode: j.domNode,
        nodeLookup: j.nodeLookup,
        lib: j.lib,
        isTarget: y,
        handleId: g,
        nodeId: w,
        flowId: j.rfId,
        panBy: j.panBy,
        cancelConnection: j.cancelConnection,
        onConnectStart: j.onConnectStart,
        onConnectEnd: j.onConnectEnd,
        updateConnection: j.updateConnection,
        onConnect: d,
        isValidConnection: r || j.isValidConnection,
        getTransform: () => b.getState().transform,
        getFromHandle: () => b.getState().connection.fromHandle,
        autoPanSpeed: j.autoPanSpeed
      });
    }
    H ? u == null || u(G) : f == null || f(G);
  }, v = (G) => {
    const { onClickConnectStart: H, onClickConnectEnd: j, connectionClickStartHandle: F, connectionMode: z, isValidConnection: W, lib: U, rfId: Z, nodeLookup: V, connection: Y } = b.getState();
    if (!w || !F && !a)
      return;
    if (!F) {
      H == null || H(G.nativeEvent, { nodeId: w, handleId: g, handleType: t }), b.setState({ connectionClickStartHandle: { nodeId: w, type: t, id: g } });
      return;
    }
    const ge = Ngt(G.target), ce = r || W, { connection: ee, isValid: Se } = t1e.isValid(G.nativeEvent, {
      handle: {
        nodeId: w,
        id: g,
        type: t
      },
      connectionMode: z,
      fromNodeId: F.nodeId,
      fromHandleId: F.id || null,
      fromType: F.type,
      isValidConnection: ce,
      flowId: Z,
      doc: ge,
      lib: U,
      nodeLookup: V
    });
    Se && ee && d(ee);
    const Ce = structuredClone(Y);
    delete Ce.inProgress, Ce.toPosition = Ce.toHandle ? Ce.toHandle.position : null, j == null || j(G, Ce), b.setState({ connectionClickStartHandle: null });
  };
  return R.jsx("div", { "data-handleid": g, "data-nodeid": w, "data-handlepos": e, "data-id": `${x}-${w}-${g}-${t}`, className: Pl([
    "react-flow__handle",
    `react-flow__handle-${e}`,
    "nodrag",
    C,
    c,
    {
      source: !y,
      target: y,
      connectable: n,
      connectablestart: a,
      connectableend: i,
      clickconnecting: I,
      connectingfrom: S,
      connectingto: A,
      valid: N,
      /*
       * shows where you can start a connection from
       * and where you can end it while connecting
       */
      connectionindicator: n && (!B || M) && (B || L ? i : a)
    }
  ]), onMouseDown: m, onTouchStart: m, onClick: _ ? v : void 0, ref: p, ...h, children: l });
}
const Ay = Ls(ovt(yfn));
function bfn({ data: t, isConnectable: e, sourcePosition: r = Hn.Bottom }) {
  return R.jsxs(R.Fragment, { children: [t == null ? void 0 : t.label, R.jsx(Ay, { type: "source", position: r, isConnectable: e })] });
}
function xfn({ data: t, isConnectable: e, targetPosition: r = Hn.Top, sourcePosition: n = Hn.Bottom }) {
  return R.jsxs(R.Fragment, { children: [R.jsx(Ay, { type: "target", position: r, isConnectable: e }), t == null ? void 0 : t.label, R.jsx(Ay, { type: "source", position: n, isConnectable: e })] });
}
function Cfn() {
  return null;
}
function wfn({ data: t, isConnectable: e, targetPosition: r = Hn.Top }) {
  return R.jsxs(R.Fragment, { children: [R.jsx(Ay, { type: "target", position: r, isConnectable: e }), t == null ? void 0 : t.label] });
}
const JF = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
}, Eze = {
  input: bfn,
  default: xfn,
  output: wfn,
  group: Cfn
};
function Sfn(t) {
  var e, r, n, a;
  return t.internals.handleBounds === void 0 ? {
    width: t.width ?? t.initialWidth ?? ((e = t.style) == null ? void 0 : e.width),
    height: t.height ?? t.initialHeight ?? ((r = t.style) == null ? void 0 : r.height)
  } : {
    width: t.width ?? ((n = t.style) == null ? void 0 : n.width),
    height: t.height ?? ((a = t.style) == null ? void 0 : a.height)
  };
}
const _fn = (t) => {
  const { width: e, height: r, x: n, y: a } = _P(t.nodeLookup, {
    filter: (i) => !!i.selected
  });
  return {
    width: x1(e) ? e : null,
    height: x1(r) ? r : null,
    userSelectionActive: t.userSelectionActive,
    transformString: `translate(${t.transform[0]}px,${t.transform[1]}px) scale(${t.transform[2]}) translate(${n}px,${a}px)`
  };
};
function kfn({ onSelectionContextMenu: t, noPanClassName: e, disableKeyboardA11y: r }) {
  const n = Is(), { width: a, height: i, transformString: o, userSelectionActive: s } = oo(_fn, Js), l = cvt(), c = Zt(null);
  if (Ut(() => {
    var h;
    r || (h = c.current) == null || h.focus({
      preventScroll: !0
    });
  }, [r]), lvt({
    nodeRef: c
  }), s || !a || !i)
    return null;
  const u = t ? (h) => {
    const p = n.getState().nodes.filter((g) => g.selected);
    t(h, p);
  } : void 0, f = (h) => {
    Object.prototype.hasOwnProperty.call(JF, h.key) && (h.preventDefault(), l({
      direction: JF[h.key],
      factor: h.shiftKey ? 4 : 1
    }));
  };
  return R.jsx("div", { className: Pl(["react-flow__nodesselection", "react-flow__container", e]), style: {
    transform: o
  }, children: R.jsx("div", { ref: c, className: "react-flow__nodesselection-rect", onContextMenu: u, tabIndex: r ? void 0 : -1, onKeyDown: r ? void 0 : f, style: {
    width: a,
    height: i
  } }) });
}
const Ize = typeof window < "u" ? window : void 0, Afn = (t) => ({ nodesSelectionActive: t.nodesSelectionActive, userSelectionActive: t.userSelectionActive });
function dvt({ children: t, onPaneClick: e, onPaneMouseEnter: r, onPaneMouseMove: n, onPaneMouseLeave: a, onPaneContextMenu: i, onPaneScroll: o, paneClickDistance: s, deleteKeyCode: l, selectionKeyCode: c, selectionOnDrag: u, selectionMode: f, onSelectionStart: h, onSelectionEnd: p, multiSelectionKeyCode: g, panActivationKeyCode: y, zoomActivationKeyCode: b, elementsSelectable: w, zoomOnScroll: _, zoomOnPinch: C, panOnScroll: x, panOnScrollSpeed: S, panOnScrollMode: A, zoomOnDoubleClick: I, panOnDrag: M, defaultViewport: B, translateExtent: L, minZoom: N, maxZoom: d, preventScrolling: m, onSelectionContextMenu: v, noWheelClassName: k, noPanClassName: O, disableKeyboardA11y: G, onViewportChange: H, isControlledViewport: j }) {
  const { nodesSelectionActive: F, userSelectionActive: z } = oo(Afn), W = _I(c, { target: Ize }), U = _I(y, { target: Ize }), Z = U || M, V = U || x, Y = u && Z !== !0, ge = W || z || Y;
  return ofn({ deleteKeyCode: l, multiSelectionKeyCode: g }), R.jsx(cfn, { onPaneContextMenu: i, elementsSelectable: w, zoomOnScroll: _, zoomOnPinch: C, panOnScroll: V, panOnScrollSpeed: S, panOnScrollMode: A, zoomOnDoubleClick: I, panOnDrag: !W && Z, defaultViewport: B, translateExtent: L, minZoom: N, maxZoom: d, zoomActivationKeyCode: b, preventScrolling: m, noWheelClassName: k, noPanClassName: O, onViewportChange: H, isControlledViewport: j, paneClickDistance: s, children: R.jsxs(hfn, { onSelectionStart: h, onSelectionEnd: p, onPaneClick: e, onPaneMouseEnter: r, onPaneMouseMove: n, onPaneMouseLeave: a, onPaneContextMenu: i, onPaneScroll: o, panOnDrag: Z, isSelecting: !!ge, selectionMode: f, selectionKeyPressed: W, selectionOnDrag: Y, children: [t, F && R.jsx(kfn, { onSelectionContextMenu: v, noPanClassName: O, disableKeyboardA11y: G })] }) });
}
dvt.displayName = "FlowRenderer";
const Tfn = Ls(dvt), Efn = (t) => (e) => t ? Tgt(e.nodeLookup, { x: 0, y: 0, width: e.width, height: e.height }, e.transform, !0).map((r) => r.id) : Array.from(e.nodeLookup.keys());
function Ifn(t) {
  return oo(sr(Efn(t), [t]), Js);
}
const Mfn = (t) => t.updateNodeInternals;
function Pfn() {
  const t = oo(Mfn), [e] = Yt(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((r) => {
    const n = /* @__PURE__ */ new Map();
    r.forEach((a) => {
      const i = a.target.getAttribute("data-id");
      n.set(i, {
        id: i,
        nodeElement: a.target,
        force: !0
      });
    }), t(n);
  }));
  return Ut(() => () => {
    e == null || e.disconnect();
  }, [e]), e;
}
function Rfn({ node: t, nodeType: e, hasDimensions: r, resizeObserver: n }) {
  const a = Is(), i = Zt(null), o = Zt(null), s = Zt(t.sourcePosition), l = Zt(t.targetPosition), c = Zt(e), u = r && !!t.internals.handleBounds;
  return Ut(() => {
    i.current && !t.hidden && (!u || o.current !== i.current) && (o.current && (n == null || n.unobserve(o.current)), n == null || n.observe(i.current), o.current = i.current);
  }, [u, t.hidden]), Ut(() => () => {
    o.current && (n == null || n.unobserve(o.current), o.current = null);
  }, []), Ut(() => {
    if (i.current) {
      const f = c.current !== e, h = s.current !== t.sourcePosition, p = l.current !== t.targetPosition;
      (f || h || p) && (c.current = e, s.current = t.sourcePosition, l.current = t.targetPosition, a.getState().updateNodeInternals(/* @__PURE__ */ new Map([[t.id, { id: t.id, nodeElement: i.current, force: !0 }]])));
    }
  }, [t.id, e, t.sourcePosition, t.targetPosition]), i;
}
function Ofn({ id: t, onClick: e, onMouseEnter: r, onMouseMove: n, onMouseLeave: a, onContextMenu: i, onDoubleClick: o, nodesDraggable: s, elementsSelectable: l, nodesConnectable: c, nodesFocusable: u, resizeObserver: f, noDragClassName: h, noPanClassName: p, disableKeyboardA11y: g, rfId: y, nodeTypes: b, nodeClickDistance: w, onError: _ }) {
  const { node: C, internals: x, isParent: S } = oo((ge) => {
    const ce = ge.nodeLookup.get(t), ee = ge.parentLookup.has(t);
    return {
      node: ce,
      internals: ce.internals,
      isParent: ee
    };
  }, Js);
  let A = C.type || "default", I = (b == null ? void 0 : b[A]) || Eze[A];
  I === void 0 && (_ == null || _("003", m0.error003(A)), A = "default", I = Eze.default);
  const M = !!(C.draggable || s && typeof C.draggable > "u"), B = !!(C.selectable || l && typeof C.selectable > "u"), L = !!(C.connectable || c && typeof C.connectable > "u"), N = !!(C.focusable || u && typeof C.focusable > "u"), d = Is(), m = Nbe(C), v = Rfn({ node: C, nodeType: A, hasDimensions: m, resizeObserver: f }), k = lvt({
    nodeRef: v,
    disabled: C.hidden || !M,
    noDragClassName: h,
    handleSelector: C.dragHandle,
    nodeId: t,
    isSelectable: B,
    nodeClickDistance: w
  }), O = cvt();
  if (C.hidden)
    return null;
  const G = wg(C), H = Sfn(C), j = B || M || e || r || n || a, F = r ? (ge) => r(ge, { ...x.userNode }) : void 0, z = n ? (ge) => n(ge, { ...x.userNode }) : void 0, W = a ? (ge) => a(ge, { ...x.userNode }) : void 0, U = i ? (ge) => i(ge, { ...x.userNode }) : void 0, Z = o ? (ge) => o(ge, { ...x.userNode }) : void 0, V = (ge) => {
    const { selectNodesOnDrag: ce, nodeDragThreshold: ee } = d.getState();
    B && (!ce || !M || ee > 0) && r1e({
      id: t,
      store: d,
      nodeRef: v
    }), e && e(ge, { ...x.userNode });
  }, Y = (ge) => {
    if (!(Yfe(ge.nativeEvent) || g))
      if (Sgt.includes(ge.key) && B) {
        const ce = ge.key === "Escape";
        r1e({
          id: t,
          store: d,
          unselect: ce,
          nodeRef: v
        });
      } else M && C.selected && Object.prototype.hasOwnProperty.call(JF, ge.key) && (ge.preventDefault(), d.setState({
        ariaLiveMessage: `Moved selected node ${ge.key.replace("Arrow", "").toLowerCase()}. New position, x: ${~~x.positionAbsolute.x}, y: ${~~x.positionAbsolute.y}`
      }), O({
        direction: JF[ge.key],
        factor: ge.shiftKey ? 4 : 1
      }));
  };
  return R.jsx("div", { className: Pl([
    "react-flow__node",
    `react-flow__node-${A}`,
    {
      // this is overwritable by passing `nopan` as a class name
      [p]: M
    },
    C.className,
    {
      selected: C.selected,
      selectable: B,
      parent: S,
      draggable: M,
      dragging: k
    }
  ]), ref: v, style: {
    zIndex: x.z,
    transform: `translate(${x.positionAbsolute.x}px,${x.positionAbsolute.y}px)`,
    pointerEvents: j ? "all" : "none",
    visibility: m ? "visible" : "hidden",
    ...C.style,
    ...H
  }, "data-id": t, "data-testid": `rf__node-${t}`, onMouseEnter: F, onMouseMove: z, onMouseLeave: W, onContextMenu: U, onClick: V, onDoubleClick: Z, onKeyDown: N ? Y : void 0, tabIndex: N ? 0 : void 0, role: N ? "button" : void 0, "aria-describedby": g ? void 0 : `${evt}-${y}`, "aria-label": C.ariaLabel, children: R.jsx(mfn, { value: t, children: R.jsx(I, { id: t, data: C.data, type: A, positionAbsoluteX: x.positionAbsolute.x, positionAbsoluteY: x.positionAbsolute.y, selected: C.selected ?? !1, selectable: B, draggable: M, deletable: C.deletable ?? !0, isConnectable: L, sourcePosition: C.sourcePosition, targetPosition: C.targetPosition, dragging: k, dragHandle: C.dragHandle, zIndex: x.z, parentId: C.parentId, ...G }) }) });
}
const Bfn = (t) => ({
  nodesDraggable: t.nodesDraggable,
  nodesConnectable: t.nodesConnectable,
  nodesFocusable: t.nodesFocusable,
  elementsSelectable: t.elementsSelectable,
  onError: t.onError
});
function fvt(t) {
  const { nodesDraggable: e, nodesConnectable: r, nodesFocusable: n, elementsSelectable: a, onError: i } = oo(Bfn, Js), o = Ifn(t.onlyRenderVisibleElements), s = Pfn();
  return R.jsx("div", { className: "react-flow__nodes", style: aU, children: o.map((l) => (
    /*
     * The split of responsibilities between NodeRenderer and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For example, when you’re dragging a single node, that node gets
     * updated multiple times per second. If `NodeRenderer` were to update
     * every time, it would have to re-run the `nodes.map()` loop every
     * time. This gets pricey with hundreds of nodes, especially if every
     * loop cycle does more than just rendering a JSX element!
     *
     * As a result of this choice, we took the following implementation
     * decisions:
     * - NodeRenderer subscribes *only* to node IDs – and therefore
     *   rerender *only* when visible nodes are added or removed.
     * - NodeRenderer performs all operations the result of which can be
     *   shared between nodes (such as creating the `ResizeObserver`
     *   instance, or subscribing to `selector`). This means extra prop
     *   drilling into `NodeComponentWrapper`, but it means we need to run
     *   these operations only once – instead of once per node.
     * - Any operations that you’d normally write inside `nodes.map` are
     *   moved into `NodeComponentWrapper`. This ensures they are
     *   memorized – so if `NodeRenderer` *has* to rerender, it only
     *   needs to regenerate the list of nodes, nothing else.
     */
    R.jsx(Ofn, { id: l, nodeTypes: t.nodeTypes, nodeExtent: t.nodeExtent, onClick: t.onNodeClick, onMouseEnter: t.onNodeMouseEnter, onMouseMove: t.onNodeMouseMove, onMouseLeave: t.onNodeMouseLeave, onContextMenu: t.onNodeContextMenu, onDoubleClick: t.onNodeDoubleClick, noDragClassName: t.noDragClassName, noPanClassName: t.noPanClassName, rfId: t.rfId, disableKeyboardA11y: t.disableKeyboardA11y, resizeObserver: s, nodesDraggable: e, nodesConnectable: r, nodesFocusable: n, elementsSelectable: a, nodeClickDistance: t.nodeClickDistance, onError: i }, l)
  )) });
}
fvt.displayName = "NodeRenderer";
const Nfn = Ls(fvt);
function $fn(t) {
  return oo(sr((r) => {
    if (!t)
      return r.edges.map((a) => a.id);
    const n = [];
    if (r.width && r.height)
      for (const a of r.edges) {
        const i = r.nodeLookup.get(a.source), o = r.nodeLookup.get(a.target);
        i && o && Ndn({
          sourceNode: i,
          targetNode: o,
          width: r.width,
          height: r.height,
          transform: r.transform
        }) && n.push(a.id);
      }
    return n;
  }, [t]), Js);
}
const Dfn = ({ color: t = "none", strokeWidth: e = 1 }) => R.jsx("polyline", { style: {
  stroke: t,
  strokeWidth: e
}, strokeLinecap: "round", strokeLinejoin: "round", fill: "none", points: "-5,-4 0,0 -5,4" }), Lfn = ({ color: t = "none", strokeWidth: e = 1 }) => R.jsx("polyline", { style: {
  stroke: t,
  fill: t,
  strokeWidth: e
}, strokeLinecap: "round", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4 -5,-4" }), Mze = {
  [qF.Arrow]: Dfn,
  [qF.ArrowClosed]: Lfn
};
function jfn(t) {
  const e = Is();
  return fa(() => {
    var a, i;
    return Object.prototype.hasOwnProperty.call(Mze, t) ? Mze[t] : ((i = (a = e.getState()).onError) == null || i.call(a, "009", m0.error009(t)), null);
  }, [t]);
}
const Ffn = ({ id: t, type: e, color: r, width: n = 12.5, height: a = 12.5, markerUnits: i = "strokeWidth", strokeWidth: o, orient: s = "auto-start-reverse" }) => {
  const l = jfn(e);
  return l ? R.jsx("marker", { className: "react-flow__arrowhead", id: t, markerWidth: `${n}`, markerHeight: `${a}`, viewBox: "-10 -10 20 20", markerUnits: i, orient: s, refX: "0", refY: "0", children: R.jsx(l, { color: r, strokeWidth: o }) }) : null;
}, hvt = ({ defaultColor: t, rfId: e }) => {
  const r = oo((i) => i.edges), n = oo((i) => i.defaultEdgeOptions), a = fa(() => Wdn(r, {
    id: e,
    defaultColor: t,
    defaultMarkerStart: n == null ? void 0 : n.markerStart,
    defaultMarkerEnd: n == null ? void 0 : n.markerEnd
  }), [r, n, e, t]);
  return a.length ? R.jsx("svg", { className: "react-flow__marker", children: R.jsx("defs", { children: a.map((i) => R.jsx(Ffn, { id: i.id, type: i.type, color: i.color, width: i.width, height: i.height, markerUnits: i.markerUnits, strokeWidth: i.strokeWidth, orient: i.orient }, i.id)) }) }) : null;
};
hvt.displayName = "MarkerDefinitions";
var zfn = Ls(hvt);
function pvt({ x: t, y: e, label: r, labelStyle: n = {}, labelShowBg: a = !0, labelBgStyle: i = {}, labelBgPadding: o = [2, 4], labelBgBorderRadius: s = 2, children: l, className: c, ...u }) {
  const [f, h] = Yt({ x: 1, y: 0, width: 0, height: 0 }), p = Pl(["react-flow__edge-textwrapper", c]), g = Zt(null);
  return Ut(() => {
    if (g.current) {
      const y = g.current.getBBox();
      h({
        x: y.x,
        y: y.y,
        width: y.width,
        height: y.height
      });
    }
  }, [r]), typeof r > "u" || !r ? null : R.jsxs("g", { transform: `translate(${t - f.width / 2} ${e - f.height / 2})`, className: p, visibility: f.width ? "visible" : "hidden", ...u, children: [a && R.jsx("rect", { width: f.width + 2 * o[0], x: -o[0], y: -o[1], height: f.height + 2 * o[1], className: "react-flow__edge-textbg", style: i, rx: s, ry: s }), R.jsx("text", { className: "react-flow__edge-text", y: f.height / 2, dy: "0.3em", ref: g, style: n, children: r }), l] });
}
pvt.displayName = "EdgeText";
const Gfn = Ls(pvt);
function iU({ path: t, labelX: e, labelY: r, label: n, labelStyle: a, labelShowBg: i, labelBgStyle: o, labelBgPadding: s, labelBgBorderRadius: l, interactionWidth: c = 20, ...u }) {
  return R.jsxs(R.Fragment, { children: [R.jsx("path", { ...u, d: t, fill: "none", className: Pl(["react-flow__edge-path", u.className]) }), c && R.jsx("path", { d: t, fill: "none", strokeOpacity: 0, strokeWidth: c, className: "react-flow__edge-interaction" }), n && x1(e) && x1(r) ? R.jsx(Gfn, { x: e, y: r, label: n, labelStyle: a, labelShowBg: i, labelBgStyle: o, labelBgPadding: s, labelBgBorderRadius: l }) : null] });
}
function Pze({ pos: t, x1: e, y1: r, x2: n, y2: a }) {
  return t === Hn.Left || t === Hn.Right ? [0.5 * (e + n), r] : [e, 0.5 * (r + a)];
}
function mvt({ sourceX: t, sourceY: e, sourcePosition: r = Hn.Bottom, targetX: n, targetY: a, targetPosition: i = Hn.Top }) {
  const [o, s] = Pze({
    pos: r,
    x1: t,
    y1: e,
    x2: n,
    y2: a
  }), [l, c] = Pze({
    pos: i,
    x1: n,
    y1: a,
    x2: t,
    y2: e
  }), [u, f, h, p] = Dgt({
    sourceX: t,
    sourceY: e,
    targetX: n,
    targetY: a,
    sourceControlX: o,
    sourceControlY: s,
    targetControlX: l,
    targetControlY: c
  });
  return [
    `M${t},${e} C${o},${s} ${l},${c} ${n},${a}`,
    u,
    f,
    h,
    p
  ];
}
function gvt(t) {
  return Ls(({ id: e, sourceX: r, sourceY: n, targetX: a, targetY: i, sourcePosition: o = Hn.Bottom, targetPosition: s = Hn.Top, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: f, labelBgPadding: h, labelBgBorderRadius: p, style: g, markerEnd: y, markerStart: b, interactionWidth: w }) => {
    const [_, C, x] = mvt({
      sourceX: r,
      sourceY: n,
      sourcePosition: o,
      targetX: a,
      targetY: i,
      targetPosition: s
    }), S = t.isInternal ? void 0 : e;
    return R.jsx(iU, { id: S, path: _, labelX: C, labelY: x, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: f, labelBgPadding: h, labelBgBorderRadius: p, style: g, markerEnd: y, markerStart: b, interactionWidth: w });
  });
}
const Wfn = gvt({ isInternal: !1 }), vvt = gvt({ isInternal: !0 });
Wfn.displayName = "SimpleBezierEdge";
vvt.displayName = "SimpleBezierEdgeInternal";
function yvt(t) {
  return Ls(({ id: e, sourceX: r, sourceY: n, targetX: a, targetY: i, label: o, labelStyle: s, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: f, style: h, sourcePosition: p = Hn.Bottom, targetPosition: g = Hn.Top, markerEnd: y, markerStart: b, pathOptions: w, interactionWidth: _ }) => {
    const [C, x, S] = Xfe({
      sourceX: r,
      sourceY: n,
      sourcePosition: p,
      targetX: a,
      targetY: i,
      targetPosition: g,
      borderRadius: w == null ? void 0 : w.borderRadius,
      offset: w == null ? void 0 : w.offset
    }), A = t.isInternal ? void 0 : e;
    return R.jsx(iU, { id: A, path: C, labelX: x, labelY: S, label: o, labelStyle: s, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: f, style: h, markerEnd: y, markerStart: b, interactionWidth: _ });
  });
}
const bvt = yvt({ isInternal: !1 }), xvt = yvt({ isInternal: !0 });
bvt.displayName = "SmoothStepEdge";
xvt.displayName = "SmoothStepEdgeInternal";
function Cvt(t) {
  return Ls(({ id: e, ...r }) => {
    var a;
    const n = t.isInternal ? void 0 : e;
    return R.jsx(bvt, { ...r, id: n, pathOptions: fa(() => {
      var i;
      return { borderRadius: 0, offset: (i = r.pathOptions) == null ? void 0 : i.offset };
    }, [(a = r.pathOptions) == null ? void 0 : a.offset]) });
  });
}
const Hfn = Cvt({ isInternal: !1 }), wvt = Cvt({ isInternal: !0 });
Hfn.displayName = "StepEdge";
wvt.displayName = "StepEdgeInternal";
function Svt(t) {
  return Ls(({ id: e, sourceX: r, sourceY: n, targetX: a, targetY: i, label: o, labelStyle: s, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: f, style: h, markerEnd: p, markerStart: g, interactionWidth: y }) => {
    const [b, w, _] = Fgt({ sourceX: r, sourceY: n, targetX: a, targetY: i }), C = t.isInternal ? void 0 : e;
    return R.jsx(iU, { id: C, path: b, labelX: w, labelY: _, label: o, labelStyle: s, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: f, style: h, markerEnd: p, markerStart: g, interactionWidth: y });
  });
}
const Ufn = Svt({ isInternal: !1 }), _vt = Svt({ isInternal: !0 });
Ufn.displayName = "StraightEdge";
_vt.displayName = "StraightEdgeInternal";
function kvt(t) {
  return Ls(({ id: e, sourceX: r, sourceY: n, targetX: a, targetY: i, sourcePosition: o = Hn.Bottom, targetPosition: s = Hn.Top, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: f, labelBgPadding: h, labelBgBorderRadius: p, style: g, markerEnd: y, markerStart: b, pathOptions: w, interactionWidth: _ }) => {
    const [C, x, S] = Lgt({
      sourceX: r,
      sourceY: n,
      sourcePosition: o,
      targetX: a,
      targetY: i,
      targetPosition: s,
      curvature: w == null ? void 0 : w.curvature
    }), A = t.isInternal ? void 0 : e;
    return R.jsx(iU, { id: A, path: C, labelX: x, labelY: S, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: f, labelBgPadding: h, labelBgBorderRadius: p, style: g, markerEnd: y, markerStart: b, interactionWidth: _ });
  });
}
const Vfn = kvt({ isInternal: !1 }), Avt = kvt({ isInternal: !0 });
Vfn.displayName = "BezierEdge";
Avt.displayName = "BezierEdgeInternal";
const Rze = {
  default: Avt,
  straight: _vt,
  step: wvt,
  smoothstep: xvt,
  simplebezier: vvt
}, Oze = {
  sourceX: null,
  sourceY: null,
  targetX: null,
  targetY: null,
  sourcePosition: null,
  targetPosition: null
}, qfn = (t, e, r) => r === Hn.Left ? t - e : r === Hn.Right ? t + e : t, Kfn = (t, e, r) => r === Hn.Top ? t - e : r === Hn.Bottom ? t + e : t, Bze = "react-flow__edgeupdater";
function Nze({ position: t, centerX: e, centerY: r, radius: n = 10, onMouseDown: a, onMouseEnter: i, onMouseOut: o, type: s }) {
  return R.jsx("circle", { onMouseDown: a, onMouseEnter: i, onMouseOut: o, className: Pl([Bze, `${Bze}-${s}`]), cx: qfn(e, n, t), cy: Kfn(r, n, t), r: n, stroke: "transparent", fill: "transparent" });
}
function Zfn({ isReconnectable: t, reconnectRadius: e, edge: r, sourceX: n, sourceY: a, targetX: i, targetY: o, sourcePosition: s, targetPosition: l, onReconnect: c, onReconnectStart: u, onReconnectEnd: f, setReconnecting: h, setUpdateHover: p }) {
  const g = Is(), y = (x, S) => {
    if (x.button !== 0)
      return;
    const { autoPanOnConnect: A, domNode: I, isValidConnection: M, connectionMode: B, connectionRadius: L, lib: N, onConnectStart: d, onConnectEnd: m, cancelConnection: v, nodeLookup: k, rfId: O, panBy: G, updateConnection: H } = g.getState(), j = S.type === "target";
    h(!0), u == null || u(x, r, S.type);
    const F = (W, U) => {
      h(!1), f == null || f(W, r, S.type, U);
    }, z = (W) => c == null ? void 0 : c(r, W);
    t1e.onPointerDown(x.nativeEvent, {
      autoPanOnConnect: A,
      connectionMode: B,
      connectionRadius: L,
      domNode: I,
      handleId: S.id,
      nodeId: S.nodeId,
      nodeLookup: k,
      isTarget: j,
      edgeUpdaterType: S.type,
      lib: N,
      flowId: O,
      cancelConnection: v,
      panBy: G,
      isValidConnection: M,
      onConnect: z,
      onConnectStart: d,
      onConnectEnd: m,
      onReconnectEnd: F,
      updateConnection: H,
      getTransform: () => g.getState().transform,
      getFromHandle: () => g.getState().connection.fromHandle
    });
  }, b = (x) => y(x, { nodeId: r.target, id: r.targetHandle ?? null, type: "target" }), w = (x) => y(x, { nodeId: r.source, id: r.sourceHandle ?? null, type: "source" }), _ = () => p(!0), C = () => p(!1);
  return R.jsxs(R.Fragment, { children: [(t === !0 || t === "source") && R.jsx(Nze, { position: s, centerX: n, centerY: a, radius: e, onMouseDown: b, onMouseEnter: _, onMouseOut: C, type: "source" }), (t === !0 || t === "target") && R.jsx(Nze, { position: l, centerX: i, centerY: o, radius: e, onMouseDown: w, onMouseEnter: _, onMouseOut: C, type: "target" })] });
}
function Jfn({ id: t, edgesFocusable: e, edgesReconnectable: r, elementsSelectable: n, onClick: a, onDoubleClick: i, onContextMenu: o, onMouseEnter: s, onMouseMove: l, onMouseLeave: c, reconnectRadius: u, onReconnect: f, onReconnectStart: h, onReconnectEnd: p, rfId: g, edgeTypes: y, noPanClassName: b, onError: w, disableKeyboardA11y: _ }) {
  let C = oo((we) => we.edgeLookup.get(t));
  const x = oo((we) => we.defaultEdgeOptions);
  C = x ? { ...x, ...C } : C;
  let S = C.type || "default", A = (y == null ? void 0 : y[S]) || Rze[S];
  A === void 0 && (w == null || w("011", m0.error011(S)), S = "default", A = Rze.default);
  const I = !!(C.focusable || e && typeof C.focusable > "u"), M = typeof f < "u" && (C.reconnectable || r && typeof C.reconnectable > "u"), B = !!(C.selectable || n && typeof C.selectable > "u"), L = Zt(null), [N, d] = Yt(!1), [m, v] = Yt(!1), k = Is(), { zIndex: O, sourceX: G, sourceY: H, targetX: j, targetY: F, sourcePosition: z, targetPosition: W } = oo(sr((we) => {
    const We = we.nodeLookup.get(C.source), Fe = we.nodeLookup.get(C.target);
    if (!We || !Fe)
      return {
        zIndex: C.zIndex,
        ...Oze
      };
    const it = Gdn({
      id: t,
      sourceNode: We,
      targetNode: Fe,
      sourceHandle: C.sourceHandle || null,
      targetHandle: C.targetHandle || null,
      connectionMode: we.connectionMode,
      onError: w
    });
    return {
      zIndex: Bdn({
        selected: C.selected,
        zIndex: C.zIndex,
        sourceNode: We,
        targetNode: Fe,
        elevateOnSelect: we.elevateEdgesOnSelect
      }),
      ...it || Oze
    };
  }, [C.source, C.target, C.sourceHandle, C.targetHandle, C.selected, C.zIndex]), Js), U = fa(() => C.markerStart ? `url('#${Qfe(C.markerStart, g)}')` : void 0, [C.markerStart, g]), Z = fa(() => C.markerEnd ? `url('#${Qfe(C.markerEnd, g)}')` : void 0, [C.markerEnd, g]);
  if (C.hidden || G === null || H === null || j === null || F === null)
    return null;
  const V = (we) => {
    var gt;
    const { addSelectedEdges: We, unselectNodesAndEdges: Fe, multiSelectionActive: it } = k.getState();
    B && (k.setState({ nodesSelectionActive: !1 }), C.selected && it ? (Fe({ nodes: [], edges: [C] }), (gt = L.current) == null || gt.blur()) : We([t])), a && a(we, C);
  }, Y = i ? (we) => {
    i(we, { ...C });
  } : void 0, ge = o ? (we) => {
    o(we, { ...C });
  } : void 0, ce = s ? (we) => {
    s(we, { ...C });
  } : void 0, ee = l ? (we) => {
    l(we, { ...C });
  } : void 0, Se = c ? (we) => {
    c(we, { ...C });
  } : void 0, Ce = (we) => {
    var We;
    if (!_ && Sgt.includes(we.key) && B) {
      const { unselectNodesAndEdges: Fe, addSelectedEdges: it } = k.getState();
      we.key === "Escape" ? ((We = L.current) == null || We.blur(), Fe({ edges: [C] })) : it([t]);
    }
  };
  return R.jsx("svg", { style: { zIndex: O }, children: R.jsxs("g", { className: Pl([
    "react-flow__edge",
    `react-flow__edge-${S}`,
    C.className,
    b,
    {
      selected: C.selected,
      animated: C.animated,
      inactive: !B && !a,
      updating: N,
      selectable: B
    }
  ]), onClick: V, onDoubleClick: Y, onContextMenu: ge, onMouseEnter: ce, onMouseMove: ee, onMouseLeave: Se, onKeyDown: I ? Ce : void 0, tabIndex: I ? 0 : void 0, role: I ? "button" : "img", "data-id": t, "data-testid": `rf__edge-${t}`, "aria-label": C.ariaLabel === null ? void 0 : C.ariaLabel || `Edge from ${C.source} to ${C.target}`, "aria-describedby": I ? `${tvt}-${g}` : void 0, ref: L, children: [!m && R.jsx(A, { id: t, source: C.source, target: C.target, type: C.type, selected: C.selected, animated: C.animated, selectable: B, deletable: C.deletable ?? !0, label: C.label, labelStyle: C.labelStyle, labelShowBg: C.labelShowBg, labelBgStyle: C.labelBgStyle, labelBgPadding: C.labelBgPadding, labelBgBorderRadius: C.labelBgBorderRadius, sourceX: G, sourceY: H, targetX: j, targetY: F, sourcePosition: z, targetPosition: W, data: C.data, style: C.style, sourceHandleId: C.sourceHandle, targetHandleId: C.targetHandle, markerStart: U, markerEnd: Z, pathOptions: "pathOptions" in C ? C.pathOptions : void 0, interactionWidth: C.interactionWidth }), M && R.jsx(Zfn, { edge: C, isReconnectable: M, reconnectRadius: u, onReconnect: f, onReconnectStart: h, onReconnectEnd: p, sourceX: G, sourceY: H, targetX: j, targetY: F, sourcePosition: z, targetPosition: W, setUpdateHover: d, setReconnecting: v })] }) });
}
const Yfn = (t) => ({
  edgesFocusable: t.edgesFocusable,
  edgesReconnectable: t.edgesReconnectable,
  elementsSelectable: t.elementsSelectable,
  connectionMode: t.connectionMode,
  onError: t.onError
});
function Tvt({ defaultMarkerColor: t, onlyRenderVisibleElements: e, rfId: r, edgeTypes: n, noPanClassName: a, onReconnect: i, onEdgeContextMenu: o, onEdgeMouseEnter: s, onEdgeMouseMove: l, onEdgeMouseLeave: c, onEdgeClick: u, reconnectRadius: f, onEdgeDoubleClick: h, onReconnectStart: p, onReconnectEnd: g, disableKeyboardA11y: y }) {
  const { edgesFocusable: b, edgesReconnectable: w, elementsSelectable: _, onError: C } = oo(Yfn, Js), x = $fn(e);
  return R.jsxs("div", { className: "react-flow__edges", children: [R.jsx(zfn, { defaultColor: t, rfId: r }), x.map((S) => R.jsx(Jfn, { id: S, edgesFocusable: b, edgesReconnectable: w, elementsSelectable: _, noPanClassName: a, onReconnect: i, onContextMenu: o, onMouseEnter: s, onMouseMove: l, onMouseLeave: c, onClick: u, reconnectRadius: f, onDoubleClick: h, onReconnectStart: p, onReconnectEnd: g, rfId: r, onError: C, edgeTypes: n, disableKeyboardA11y: y }, S))] });
}
Tvt.displayName = "EdgeRenderer";
const Xfn = Ls(Tvt), Qfn = (t) => `translate(${t.transform[0]}px,${t.transform[1]}px) scale(${t.transform[2]})`;
function e1n({ children: t }) {
  const e = oo(Qfn);
  return R.jsx("div", { className: "react-flow__viewport xyflow__viewport react-flow__container", style: { transform: e }, children: t });
}
function t1n(t) {
  const e = nU(), r = Zt(!1);
  Ut(() => {
    !r.current && e.viewportInitialized && t && (setTimeout(() => t(e), 1), r.current = !0);
  }, [t, e.viewportInitialized]);
}
const r1n = (t) => {
  var e;
  return (e = t.panZoom) == null ? void 0 : e.syncViewport;
};
function n1n(t) {
  const e = oo(r1n), r = Is();
  return Ut(() => {
    t && (e == null || e(t), r.setState({ transform: [t.x, t.y, t.zoom] }));
  }, [t, e]), null;
}
function a1n(t) {
  return t.connection.inProgress ? { ...t.connection, to: kP(t.connection.to, t.transform) } : { ...t.connection };
}
function i1n(t) {
  return a1n;
}
function o1n(t) {
  const e = i1n();
  return oo(e, Js);
}
const s1n = (t) => ({
  nodesConnectable: t.nodesConnectable,
  isValid: t.connection.isValid,
  inProgress: t.connection.inProgress,
  width: t.width,
  height: t.height
});
function l1n({ containerStyle: t, style: e, type: r, component: n }) {
  const { nodesConnectable: a, width: i, height: o, isValid: s, inProgress: l } = oo(s1n, Js);
  return !(i && a && l) ? null : R.jsx("svg", { style: t, width: i, height: o, className: "react-flow__connectionline react-flow__container", children: R.jsx("g", { className: Pl(["react-flow__connection", kgt(s)]), children: R.jsx(Evt, { style: e, type: r, CustomComponent: n, isValid: s }) }) });
}
const Evt = ({ style: t, type: e = bv.Bezier, CustomComponent: r, isValid: n }) => {
  const { inProgress: a, from: i, fromNode: o, fromHandle: s, fromPosition: l, to: c, toNode: u, toHandle: f, toPosition: h } = o1n();
  if (!a)
    return;
  if (r)
    return R.jsx(r, { connectionLineType: e, connectionLineStyle: t, fromNode: o, fromHandle: s, fromX: i.x, fromY: i.y, toX: c.x, toY: c.y, fromPosition: l, toPosition: h, connectionStatus: kgt(n), toNode: u, toHandle: f });
  let p = "";
  const g = {
    sourceX: i.x,
    sourceY: i.y,
    sourcePosition: l,
    targetX: c.x,
    targetY: c.y,
    targetPosition: h
  };
  switch (e) {
    case bv.Bezier:
      [p] = Lgt(g);
      break;
    case bv.SimpleBezier:
      [p] = mvt(g);
      break;
    case bv.Step:
      [p] = Xfe({
        ...g,
        borderRadius: 0
      });
      break;
    case bv.SmoothStep:
      [p] = Xfe(g);
      break;
    default:
      [p] = Fgt(g);
  }
  return R.jsx("path", { d: p, fill: "none", className: "react-flow__connection-path", style: t });
};
Evt.displayName = "ConnectionLine";
const c1n = {};
function $ze(t = c1n) {
  const e = Zt(t), r = Is();
  Ut(() => {
    var n, a;
    if (Ar.env.NODE_ENV === "development") {
      const i = /* @__PURE__ */ new Set([...Object.keys(e.current), ...Object.keys(t)]);
      for (const o of i)
        if (e.current[o] !== t[o]) {
          (a = (n = r.getState()).onError) == null || a.call(n, "002", m0.error002());
          break;
        }
      e.current = t;
    }
  }, [t]);
}
function u1n() {
  const t = Is(), e = Zt(!1);
  Ut(() => {
    var r, n;
    if (Ar.env.NODE_ENV === "development" && !e.current) {
      const a = document.querySelector(".react-flow__pane");
      a && window.getComputedStyle(a).zIndex !== "1" && ((n = (r = t.getState()).onError) == null || n.call(r, "013", m0.error013("react"))), e.current = !0;
    }
  }, []);
}
function Ivt({ nodeTypes: t, edgeTypes: e, onInit: r, onNodeClick: n, onEdgeClick: a, onNodeDoubleClick: i, onEdgeDoubleClick: o, onNodeMouseEnter: s, onNodeMouseMove: l, onNodeMouseLeave: c, onNodeContextMenu: u, onSelectionContextMenu: f, onSelectionStart: h, onSelectionEnd: p, connectionLineType: g, connectionLineStyle: y, connectionLineComponent: b, connectionLineContainerStyle: w, selectionKeyCode: _, selectionOnDrag: C, selectionMode: x, multiSelectionKeyCode: S, panActivationKeyCode: A, zoomActivationKeyCode: I, deleteKeyCode: M, onlyRenderVisibleElements: B, elementsSelectable: L, defaultViewport: N, translateExtent: d, minZoom: m, maxZoom: v, preventScrolling: k, defaultMarkerColor: O, zoomOnScroll: G, zoomOnPinch: H, panOnScroll: j, panOnScrollSpeed: F, panOnScrollMode: z, zoomOnDoubleClick: W, panOnDrag: U, onPaneClick: Z, onPaneMouseEnter: V, onPaneMouseMove: Y, onPaneMouseLeave: ge, onPaneScroll: ce, onPaneContextMenu: ee, paneClickDistance: Se, nodeClickDistance: Ce, onEdgeContextMenu: we, onEdgeMouseEnter: We, onEdgeMouseMove: Fe, onEdgeMouseLeave: it, reconnectRadius: gt, onReconnect: Ze, onReconnectStart: Ne, onReconnectEnd: ze, noDragClassName: ct, noWheelClassName: rt, noPanClassName: qe, disableKeyboardA11y: nt, nodeExtent: Rt, rfId: Ot, viewport: lt, onViewportChange: mt }) {
  return $ze(t), $ze(e), u1n(), t1n(r), n1n(lt), R.jsx(Tfn, { onPaneClick: Z, onPaneMouseEnter: V, onPaneMouseMove: Y, onPaneMouseLeave: ge, onPaneContextMenu: ee, onPaneScroll: ce, paneClickDistance: Se, deleteKeyCode: M, selectionKeyCode: _, selectionOnDrag: C, selectionMode: x, onSelectionStart: h, onSelectionEnd: p, multiSelectionKeyCode: S, panActivationKeyCode: A, zoomActivationKeyCode: I, elementsSelectable: L, zoomOnScroll: G, zoomOnPinch: H, zoomOnDoubleClick: W, panOnScroll: j, panOnScrollSpeed: F, panOnScrollMode: z, panOnDrag: U, defaultViewport: N, translateExtent: d, minZoom: m, maxZoom: v, onSelectionContextMenu: f, preventScrolling: k, noDragClassName: ct, noWheelClassName: rt, noPanClassName: qe, disableKeyboardA11y: nt, onViewportChange: mt, isControlledViewport: !!lt, children: R.jsxs(e1n, { children: [R.jsx(Xfn, { edgeTypes: e, onEdgeClick: a, onEdgeDoubleClick: o, onReconnect: Ze, onReconnectStart: Ne, onReconnectEnd: ze, onlyRenderVisibleElements: B, onEdgeContextMenu: we, onEdgeMouseEnter: We, onEdgeMouseMove: Fe, onEdgeMouseLeave: it, reconnectRadius: gt, defaultMarkerColor: O, noPanClassName: qe, disableKeyboardA11y: nt, rfId: Ot }), R.jsx(l1n, { style: y, type: g, component: b, containerStyle: w }), R.jsx("div", { className: "react-flow__edgelabel-renderer" }), R.jsx(Nfn, { nodeTypes: t, onNodeClick: n, onNodeDoubleClick: i, onNodeMouseEnter: s, onNodeMouseMove: l, onNodeMouseLeave: c, onNodeContextMenu: u, nodeClickDistance: Ce, onlyRenderVisibleElements: B, noPanClassName: qe, noDragClassName: ct, disableKeyboardA11y: nt, nodeExtent: Rt, rfId: Ot }), R.jsx("div", { className: "react-flow__viewport-portal" })] }) });
}
Ivt.displayName = "GraphView";
const d1n = Ls(Ivt), Dze = ({ nodes: t, edges: e, defaultNodes: r, defaultEdges: n, width: a, height: i, fitView: o, nodeOrigin: s, nodeExtent: l } = {}) => {
  const c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), h = /* @__PURE__ */ new Map(), p = n ?? e ?? [], g = r ?? t ?? [], y = s ?? [0, 0], b = l ?? xI;
  Ggt(f, h, p), e1e(g, c, u, {
    nodeOrigin: y,
    nodeExtent: b,
    elevateNodesOnSelect: !1
  });
  let w = [0, 0, 1];
  if (o && a && i) {
    const _ = _P(c, {
      filter: (A) => !!((A.width || A.initialWidth) && (A.height || A.initialHeight))
    }), { x: C, y: x, zoom: S } = Bbe(_, a, i, 0.5, 2, 0.1);
    w = [C, x, S];
  }
  return {
    rfId: "1",
    width: 0,
    height: 0,
    transform: w,
    nodes: g,
    nodeLookup: c,
    parentLookup: u,
    edges: p,
    edgeLookup: h,
    connectionLookup: f,
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: r !== void 0,
    hasDefaultEdges: n !== void 0,
    panZoom: null,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: xI,
    nodeExtent: b,
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    connectionMode: u8.Strict,
    domNode: null,
    paneDragging: !1,
    noPanClassName: "nopan",
    nodeOrigin: y,
    nodeDragThreshold: 1,
    snapGrid: [15, 15],
    snapToGrid: !1,
    nodesDraggable: !0,
    nodesConnectable: !0,
    nodesFocusable: !0,
    edgesFocusable: !0,
    edgesReconnectable: !0,
    elementsSelectable: !0,
    elevateNodesOnSelect: !0,
    elevateEdgesOnSelect: !1,
    fitViewOnInit: !1,
    fitViewDone: !1,
    fitViewOnInitOptions: void 0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    connection: { ..._gt },
    connectionClickStartHandle: null,
    connectOnClick: !0,
    ariaLiveMessage: "",
    autoPanOnConnect: !0,
    autoPanOnNodeDrag: !0,
    autoPanSpeed: 15,
    connectionRadius: 20,
    onError: Rgt,
    isValidConnection: void 0,
    onSelectionChangeHandlers: [],
    lib: "react",
    debug: !1
  };
}, f1n = ({ nodes: t, edges: e, defaultNodes: r, defaultEdges: n, width: a, height: i, fitView: o, nodeOrigin: s, nodeExtent: l }) => P0n((c, u) => ({
  ...Dze({ nodes: t, edges: e, width: a, height: i, fitView: o, nodeOrigin: s, nodeExtent: l, defaultNodes: r, defaultEdges: n }),
  setNodes: (f) => {
    const { nodeLookup: h, parentLookup: p, nodeOrigin: g, elevateNodesOnSelect: y } = u();
    e1e(f, h, p, {
      nodeOrigin: g,
      nodeExtent: l,
      elevateNodesOnSelect: y,
      checkEquality: !0
    }), c({ nodes: f });
  },
  setEdges: (f) => {
    const { connectionLookup: h, edgeLookup: p } = u();
    Ggt(h, p, f), c({ edges: f });
  },
  setDefaultNodesAndEdges: (f, h) => {
    if (f) {
      const { setNodes: p } = u();
      p(f), c({ hasDefaultNodes: !0 });
    }
    if (h) {
      const { setEdges: p } = u();
      p(h), c({ hasDefaultEdges: !0 });
    }
  },
  /*
   * Every node gets registerd at a ResizeObserver. Whenever a node
   * changes its dimensions, this function is called to measure the
   * new dimensions and update the nodes.
   */
  updateNodeInternals: (f, h = { triggerFitView: !0 }) => {
    const { triggerNodeChanges: p, nodeLookup: g, parentLookup: y, fitViewOnInit: b, fitViewDone: w, fitViewOnInitOptions: _, domNode: C, nodeOrigin: x, nodeExtent: S, debug: A, fitViewSync: I } = u(), { changes: M, updatedInternals: B } = Kdn(f, g, y, C, x, S);
    if (B) {
      if (Udn(g, y, { nodeOrigin: x, nodeExtent: S }), h.triggerFitView) {
        let L = w;
        !w && b && (L = I({
          ..._,
          nodes: _ == null ? void 0 : _.nodes
        })), c({ fitViewDone: L });
      } else
        c({});
      (M == null ? void 0 : M.length) > 0 && (A && console.log("React Flow: trigger node changes", M), p == null || p(M));
    }
  },
  updateNodePositions: (f, h = !1) => {
    const p = [], g = [], { nodeLookup: y, triggerNodeChanges: b } = u();
    for (const [w, _] of f) {
      const C = y.get(w), x = !!(C != null && C.expandParent && (C != null && C.parentId) && (_ != null && _.position)), S = {
        id: w,
        type: "position",
        position: x ? {
          x: Math.max(0, _.position.x),
          y: Math.max(0, _.position.y)
        } : _.position,
        dragging: h
      };
      x && C.parentId && p.push({
        id: w,
        parentId: C.parentId,
        rect: {
          ..._.internals.positionAbsolute,
          width: _.measured.width ?? 0,
          height: _.measured.height ?? 0
        }
      }), g.push(S);
    }
    if (p.length > 0) {
      const { parentLookup: w, nodeOrigin: _ } = u(), C = jbe(p, y, w, _);
      g.push(...C);
    }
    b(g);
  },
  triggerNodeChanges: (f) => {
    const { onNodesChange: h, setNodes: p, nodes: g, hasDefaultNodes: y, debug: b } = u();
    if (f != null && f.length) {
      if (y) {
        const w = avt(f, g);
        p(w);
      }
      b && console.log("React Flow: trigger node changes", f), h == null || h(f);
    }
  },
  triggerEdgeChanges: (f) => {
    const { onEdgesChange: h, setEdges: p, edges: g, hasDefaultEdges: y, debug: b } = u();
    if (f != null && f.length) {
      if (y) {
        const w = ivt(f, g);
        p(w);
      }
      b && console.log("React Flow: trigger edge changes", f), h == null || h(f);
    }
  },
  addSelectedNodes: (f) => {
    const { multiSelectionActive: h, edgeLookup: p, nodeLookup: g, triggerNodeChanges: y, triggerEdgeChanges: b } = u();
    if (h) {
      const w = f.map((_) => rb(_, !0));
      y(w);
      return;
    }
    y(n7(g, /* @__PURE__ */ new Set([...f]), !0)), b(n7(p));
  },
  addSelectedEdges: (f) => {
    const { multiSelectionActive: h, edgeLookup: p, nodeLookup: g, triggerNodeChanges: y, triggerEdgeChanges: b } = u();
    if (h) {
      const w = f.map((_) => rb(_, !0));
      b(w);
      return;
    }
    b(n7(p, /* @__PURE__ */ new Set([...f]))), y(n7(g, /* @__PURE__ */ new Set(), !0));
  },
  unselectNodesAndEdges: ({ nodes: f, edges: h } = {}) => {
    const { edges: p, nodes: g, nodeLookup: y, triggerNodeChanges: b, triggerEdgeChanges: w } = u(), _ = f || g, C = h || p, x = _.map((A) => {
      const I = y.get(A.id);
      return I && (I.selected = !1), rb(A.id, !1);
    }), S = C.map((A) => rb(A.id, !1));
    b(x), w(S);
  },
  setMinZoom: (f) => {
    const { panZoom: h, maxZoom: p } = u();
    h == null || h.setScaleExtent([f, p]), c({ minZoom: f });
  },
  setMaxZoom: (f) => {
    const { panZoom: h, minZoom: p } = u();
    h == null || h.setScaleExtent([p, f]), c({ maxZoom: f });
  },
  setTranslateExtent: (f) => {
    var h;
    (h = u().panZoom) == null || h.setTranslateExtent(f), c({ translateExtent: f });
  },
  setPaneClickDistance: (f) => {
    var h;
    (h = u().panZoom) == null || h.setClickDistance(f);
  },
  resetSelectedElements: () => {
    const { edges: f, nodes: h, triggerNodeChanges: p, triggerEdgeChanges: g } = u(), y = h.reduce((w, _) => _.selected ? [...w, rb(_.id, !1)] : w, []), b = f.reduce((w, _) => _.selected ? [...w, rb(_.id, !1)] : w, []);
    p(y), g(b);
  },
  setNodeExtent: (f) => {
    const { nodes: h, nodeLookup: p, parentLookup: g, nodeOrigin: y, elevateNodesOnSelect: b, nodeExtent: w } = u();
    f[0][0] === w[0][0] && f[0][1] === w[0][1] && f[1][0] === w[1][0] && f[1][1] === w[1][1] || (e1e(h, p, g, {
      nodeOrigin: y,
      nodeExtent: f,
      elevateNodesOnSelect: b,
      checkEquality: !1
    }), c({ nodeExtent: f }));
  },
  panBy: (f) => {
    const { transform: h, width: p, height: g, panZoom: y, translateExtent: b } = u();
    return Zdn({ delta: f, panZoom: y, transform: h, translateExtent: b, width: p, height: g });
  },
  fitView: (f) => {
    const { panZoom: h, width: p, height: g, minZoom: y, maxZoom: b, nodeLookup: w } = u();
    if (!h)
      return Promise.resolve(!1);
    const _ = Kfe(w, f);
    return Zfe({
      nodes: _,
      width: p,
      height: g,
      panZoom: h,
      minZoom: y,
      maxZoom: b
    }, f);
  },
  /*
   * we can't call an asnychronous function in updateNodeInternals
   * for that we created this sync version of fitView
   */
  fitViewSync: (f) => {
    const { panZoom: h, width: p, height: g, minZoom: y, maxZoom: b, nodeLookup: w } = u();
    if (!h)
      return !1;
    const _ = Kfe(w, f);
    return Zfe({
      nodes: _,
      width: p,
      height: g,
      panZoom: h,
      minZoom: y,
      maxZoom: b
    }, f), _.size > 0;
  },
  cancelConnection: () => {
    c({
      connection: { ..._gt }
    });
  },
  updateConnection: (f) => {
    c({ connection: f });
  },
  reset: () => c({ ...Dze() })
}), Object.is);
function Mvt({ initialNodes: t, initialEdges: e, defaultNodes: r, defaultEdges: n, initialWidth: a, initialHeight: i, fitView: o, nodeOrigin: s, nodeExtent: l, children: c }) {
  const [u] = Yt(() => f1n({
    nodes: t,
    edges: e,
    defaultNodes: r,
    defaultEdges: n,
    width: a,
    height: i,
    fitView: o,
    nodeOrigin: s,
    nodeExtent: l
  }));
  return R.jsx(R0n, { value: u, children: R.jsx(tfn, { children: c }) });
}
function h1n({ children: t, nodes: e, edges: r, defaultNodes: n, defaultEdges: a, width: i, height: o, fitView: s, nodeOrigin: l, nodeExtent: c }) {
  return Qn(rU) ? R.jsx(R.Fragment, { children: t }) : R.jsx(Mvt, { initialNodes: e, initialEdges: r, defaultNodes: n, defaultEdges: a, initialWidth: i, initialHeight: o, fitView: s, nodeOrigin: l, nodeExtent: c, children: t });
}
const p1n = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  zIndex: 0
};
function m1n({ nodes: t, edges: e, defaultNodes: r, defaultEdges: n, className: a, nodeTypes: i, edgeTypes: o, onNodeClick: s, onEdgeClick: l, onInit: c, onMove: u, onMoveStart: f, onMoveEnd: h, onConnect: p, onConnectStart: g, onConnectEnd: y, onClickConnectStart: b, onClickConnectEnd: w, onNodeMouseEnter: _, onNodeMouseMove: C, onNodeMouseLeave: x, onNodeContextMenu: S, onNodeDoubleClick: A, onNodeDragStart: I, onNodeDrag: M, onNodeDragStop: B, onNodesDelete: L, onEdgesDelete: N, onDelete: d, onSelectionChange: m, onSelectionDragStart: v, onSelectionDrag: k, onSelectionDragStop: O, onSelectionContextMenu: G, onSelectionStart: H, onSelectionEnd: j, onBeforeDelete: F, connectionMode: z, connectionLineType: W = bv.Bezier, connectionLineStyle: U, connectionLineComponent: Z, connectionLineContainerStyle: V, deleteKeyCode: Y = "Backspace", selectionKeyCode: ge = "Shift", selectionOnDrag: ce = !1, selectionMode: ee = CI.Full, panActivationKeyCode: Se = "Space", multiSelectionKeyCode: Ce = ZF() ? "Meta" : "Control", zoomActivationKeyCode: we = ZF() ? "Meta" : "Control", snapToGrid: We, snapGrid: Fe, onlyRenderVisibleElements: it = !1, selectNodesOnDrag: gt, nodesDraggable: Ze, nodesConnectable: Ne, nodesFocusable: ze, nodeOrigin: ct = rvt, edgesFocusable: rt, edgesReconnectable: qe, elementsSelectable: nt = !0, defaultViewport: Rt = U0n, minZoom: Ot = 0.5, maxZoom: lt = 2, translateExtent: mt = xI, preventScrolling: jt = !0, nodeExtent: Jt, defaultMarkerColor: ne = "#b1b1b7", zoomOnScroll: re = !0, zoomOnPinch: ie = !0, panOnScroll: Ie = !1, panOnScrollSpeed: Ke = 0.5, panOnScrollMode: Le = Yb.Free, zoomOnDoubleClick: Ge = !0, panOnDrag: ft = !0, onPaneClick: ot, onPaneMouseEnter: Ye, onPaneMouseMove: Je, onPaneMouseLeave: tt, onPaneScroll: kt, onPaneContextMenu: Ft, paneClickDistance: bt = 0, nodeClickDistance: At = 0, children: vt, onReconnect: _t, onReconnectStart: yt, onReconnectEnd: xr, onEdgeContextMenu: dr, onEdgeDoubleClick: Er, onEdgeMouseEnter: gr, onEdgeMouseMove: pr, onEdgeMouseLeave: Xr, reconnectRadius: Yr = 10, onNodesChange: at, onEdgesChange: Vt, noDragClassName: er = "nodrag", noWheelClassName: fr = "nowheel", noPanClassName: tn = "nopan", fitView: Kn, fitViewOptions: Pr, connectOnClick: Pt, attributionPosition: or, proOptions: Ht, defaultEdgeOptions: Mt, elevateNodesOnSelect: Qt, elevateEdgesOnSelect: pn, disableKeyboardA11y: Kr = !1, autoPanOnConnect: Da, autoPanOnNodeDrag: La, autoPanSpeed: ji, connectionRadius: Zo, isValidConnection: kr, onError: qi, style: vi, id: Ho, nodeDragThreshold: Ec, viewport: Uu, onViewportChange: Ic, width: js, height: Mc, colorMode: Vu = "light", debug: So, onScroll: Kl, ...Vi }, iu) {
  const cc = Ho || "1", Pc = Z0n(Vu), Jo = sr((Ka) => {
    Ka.currentTarget.scrollTo({ top: 0, left: 0, behavior: "instant" }), Kl == null || Kl(Ka);
  }, [Kl]);
  return R.jsx("div", { "data-testid": "rf__wrapper", ...Vi, onScroll: Jo, style: { ...vi, ...p1n }, ref: iu, className: Pl(["react-flow", a, Pc]), id: Ho, children: R.jsxs(h1n, { nodes: t, edges: e, width: js, height: Mc, fitView: Kn, nodeOrigin: ct, nodeExtent: Jt, children: [R.jsx(d1n, { onInit: c, onNodeClick: s, onEdgeClick: l, onNodeMouseEnter: _, onNodeMouseMove: C, onNodeMouseLeave: x, onNodeContextMenu: S, onNodeDoubleClick: A, nodeTypes: i, edgeTypes: o, connectionLineType: W, connectionLineStyle: U, connectionLineComponent: Z, connectionLineContainerStyle: V, selectionKeyCode: ge, selectionOnDrag: ce, selectionMode: ee, deleteKeyCode: Y, multiSelectionKeyCode: Ce, panActivationKeyCode: Se, zoomActivationKeyCode: we, onlyRenderVisibleElements: it, defaultViewport: Rt, translateExtent: mt, minZoom: Ot, maxZoom: lt, preventScrolling: jt, zoomOnScroll: re, zoomOnPinch: ie, zoomOnDoubleClick: Ge, panOnScroll: Ie, panOnScrollSpeed: Ke, panOnScrollMode: Le, panOnDrag: ft, onPaneClick: ot, onPaneMouseEnter: Ye, onPaneMouseMove: Je, onPaneMouseLeave: tt, onPaneScroll: kt, onPaneContextMenu: Ft, paneClickDistance: bt, nodeClickDistance: At, onSelectionContextMenu: G, onSelectionStart: H, onSelectionEnd: j, onReconnect: _t, onReconnectStart: yt, onReconnectEnd: xr, onEdgeContextMenu: dr, onEdgeDoubleClick: Er, onEdgeMouseEnter: gr, onEdgeMouseMove: pr, onEdgeMouseLeave: Xr, reconnectRadius: Yr, defaultMarkerColor: ne, noDragClassName: er, noWheelClassName: fr, noPanClassName: tn, rfId: cc, disableKeyboardA11y: Kr, nodeExtent: Jt, viewport: Uu, onViewportChange: Ic }), R.jsx(K0n, { nodes: t, edges: e, defaultNodes: r, defaultEdges: n, onConnect: p, onConnectStart: g, onConnectEnd: y, onClickConnectStart: b, onClickConnectEnd: w, nodesDraggable: Ze, nodesConnectable: Ne, nodesFocusable: ze, edgesFocusable: rt, edgesReconnectable: qe, elementsSelectable: nt, elevateNodesOnSelect: Qt, elevateEdgesOnSelect: pn, minZoom: Ot, maxZoom: lt, nodeExtent: Jt, onNodesChange: at, onEdgesChange: Vt, snapToGrid: We, snapGrid: Fe, connectionMode: z, translateExtent: mt, connectOnClick: Pt, defaultEdgeOptions: Mt, fitView: Kn, fitViewOptions: Pr, onNodesDelete: L, onEdgesDelete: N, onDelete: d, onNodeDragStart: I, onNodeDrag: M, onNodeDragStop: B, onSelectionDrag: k, onSelectionDragStart: v, onSelectionDragStop: O, onMove: u, onMoveStart: f, onMoveEnd: h, noPanClassName: tn, nodeOrigin: ct, rfId: cc, autoPanOnConnect: Da, autoPanOnNodeDrag: La, autoPanSpeed: ji, onError: qi, connectionRadius: Zo, isValidConnection: kr, selectNodesOnDrag: gt, nodeDragThreshold: Ec, onBeforeDelete: F, paneClickDistance: bt, debug: So }), R.jsx(H0n, { onSelectionChange: m }), vt, R.jsx(j0n, { proOptions: Ht, position: or }), R.jsx(D0n, { rfId: cc, disableKeyboardA11y: Kr })] }) });
}
var g1n = ovt(m1n);
function v1n(t) {
  const [e, r] = Yt(t), n = sr((a) => r((i) => avt(a, i)), []);
  return [e, r, n];
}
function y1n(t) {
  const [e, r] = Yt(t), n = sr((a) => r((i) => ivt(a, i)), []);
  return [e, r, n];
}
const b1n = (t) => (e) => {
  if (e.nodeLookup.size === 0)
    return !1;
  for (const [, { hidden: r, internals: n }] of e.nodeLookup)
    if ((t.includeHiddenNodes || !r) && (n.handleBounds === void 0 || !Nbe(n.userNode)))
      return !1;
  return !0;
};
function x1n(t = {
  includeHiddenNodes: !1
}) {
  return oo(b1n(t));
}
function C1n({ dimensions: t, lineWidth: e, variant: r, className: n }) {
  return R.jsx("path", { strokeWidth: e, d: `M${t[0] / 2} 0 V${t[1]} M0 ${t[1] / 2} H${t[0]}`, className: Pl(["react-flow__background-pattern", r, n]) });
}
function w1n({ radius: t, className: e }) {
  return R.jsx("circle", { cx: t, cy: t, r: t, className: Pl(["react-flow__background-pattern", "dots", e]) });
}
var Gv;
(function(t) {
  t.Lines = "lines", t.Dots = "dots", t.Cross = "cross";
})(Gv || (Gv = {}));
const S1n = {
  [Gv.Dots]: 1,
  [Gv.Lines]: 1,
  [Gv.Cross]: 6
}, _1n = (t) => ({ transform: t.transform, patternId: `pattern-${t.rfId}` });
function Pvt({
  id: t,
  variant: e = Gv.Dots,
  // only used for dots and cross
  gap: r = 20,
  // only used for lines and cross
  size: n,
  lineWidth: a = 1,
  offset: i = 0,
  color: o,
  bgColor: s,
  style: l,
  className: c,
  patternClassName: u
}) {
  const f = Zt(null), { transform: h, patternId: p } = oo(_1n, Js), g = n || S1n[e], y = e === Gv.Dots, b = e === Gv.Cross, w = Array.isArray(r) ? r : [r, r], _ = [w[0] * h[2] || 1, w[1] * h[2] || 1], C = g * h[2], x = Array.isArray(i) ? i : [i, i], S = b ? [C, C] : _, A = [
    x[0] * h[2] || 1 + S[0] / 2,
    x[1] * h[2] || 1 + S[1] / 2
  ], I = `${p}${t || ""}`;
  return R.jsxs("svg", { className: Pl(["react-flow__background", c]), style: {
    ...l,
    ...aU,
    "--xy-background-color-props": s,
    "--xy-background-pattern-color-props": o
  }, ref: f, "data-testid": "rf__background", children: [R.jsx("pattern", { id: I, x: h[0] % _[0], y: h[1] % _[1], width: _[0], height: _[1], patternUnits: "userSpaceOnUse", patternTransform: `translate(-${A[0]},-${A[1]})`, children: y ? R.jsx(w1n, { radius: C / 2, className: u }) : R.jsx(C1n, { dimensions: S, lineWidth: a, variant: e, className: u }) }), R.jsx("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${I})` })] });
}
Pvt.displayName = "Background";
const k1n = Ls(Pvt);
function A1n() {
  return R.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: R.jsx("path", { d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" }) });
}
function T1n() {
  return R.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 5", children: R.jsx("path", { d: "M0 0h32v4.2H0z" }) });
}
function E1n() {
  return R.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 30", children: R.jsx("path", { d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" }) });
}
function I1n() {
  return R.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: R.jsx("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z" }) });
}
function M1n() {
  return R.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: R.jsx("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z" }) });
}
function PN({ children: t, className: e, ...r }) {
  return R.jsx("button", { type: "button", className: Pl(["react-flow__controls-button", e]), ...r, children: t });
}
const P1n = (t) => ({
  isInteractive: t.nodesDraggable || t.nodesConnectable || t.elementsSelectable,
  minZoomReached: t.transform[2] <= t.minZoom,
  maxZoomReached: t.transform[2] >= t.maxZoom
});
function Rvt({ style: t, showZoom: e = !0, showFitView: r = !0, showInteractive: n = !0, fitViewOptions: a, onZoomIn: i, onZoomOut: o, onFitView: s, onInteractiveChange: l, className: c, children: u, position: f = "bottom-left", orientation: h = "vertical", "aria-label": p = "React Flow controls" }) {
  const g = Is(), { isInteractive: y, minZoomReached: b, maxZoomReached: w } = oo(P1n, Js), { zoomIn: _, zoomOut: C, fitView: x } = nU(), S = () => {
    _(), i == null || i();
  }, A = () => {
    C(), o == null || o();
  }, I = () => {
    x(a), s == null || s();
  }, M = () => {
    g.setState({
      nodesDraggable: !y,
      nodesConnectable: !y,
      elementsSelectable: !y
    }), l == null || l(!y);
  }, B = h === "horizontal" ? "horizontal" : "vertical";
  return R.jsxs(AP, { className: Pl(["react-flow__controls", B, c]), position: f, style: t, "data-testid": "rf__controls", "aria-label": p, children: [e && R.jsxs(R.Fragment, { children: [R.jsx(PN, { onClick: S, className: "react-flow__controls-zoomin", title: "zoom in", "aria-label": "zoom in", disabled: w, children: R.jsx(A1n, {}) }), R.jsx(PN, { onClick: A, className: "react-flow__controls-zoomout", title: "zoom out", "aria-label": "zoom out", disabled: b, children: R.jsx(T1n, {}) })] }), r && R.jsx(PN, { className: "react-flow__controls-fitview", onClick: I, title: "fit view", "aria-label": "fit view", children: R.jsx(E1n, {}) }), n && R.jsx(PN, { className: "react-flow__controls-interactive", onClick: M, title: "toggle interactivity", "aria-label": "toggle interactivity", children: y ? R.jsx(M1n, {}) : R.jsx(I1n, {}) }), u] });
}
Rvt.displayName = "Controls";
const R1n = Ls(Rvt);
function O1n({ id: t, x: e, y: r, width: n, height: a, style: i, color: o, strokeColor: s, strokeWidth: l, className: c, borderRadius: u, shapeRendering: f, selected: h, onClick: p }) {
  const { background: g, backgroundColor: y } = i || {}, b = o || g || y;
  return R.jsx("rect", { className: Pl(["react-flow__minimap-node", { selected: h }, c]), x: e, y: r, rx: u, ry: u, width: n, height: a, style: {
    fill: b,
    stroke: s,
    strokeWidth: l
  }, shapeRendering: f, onClick: p ? (w) => p(w, t) : void 0 });
}
const B1n = Ls(O1n), N1n = (t) => t.nodes.map((e) => e.id), ise = (t) => t instanceof Function ? t : () => t;
function $1n({
  nodeStrokeColor: t,
  nodeColor: e,
  nodeClassName: r = "",
  nodeBorderRadius: n = 5,
  nodeStrokeWidth: a,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: i = B1n,
  onClick: o
}) {
  const s = oo(N1n, Js), l = ise(e), c = ise(t), u = ise(r), f = typeof window > "u" || window.chrome ? "crispEdges" : "geometricPrecision";
  return R.jsx(R.Fragment, { children: s.map((h) => (
    /*
     * The split of responsibilities between MiniMapNodes and
     * NodeComponentWrapper may appear weird. However, it’s designed to
     * minimize the cost of updates when individual nodes change.
     *
     * For more details, see a similar commit in `NodeRenderer/index.tsx`.
     */
    R.jsx(L1n, { id: h, nodeColorFunc: l, nodeStrokeColorFunc: c, nodeClassNameFunc: u, nodeBorderRadius: n, nodeStrokeWidth: a, NodeComponent: i, onClick: o, shapeRendering: f }, h)
  )) });
}
function D1n({ id: t, nodeColorFunc: e, nodeStrokeColorFunc: r, nodeClassNameFunc: n, nodeBorderRadius: a, nodeStrokeWidth: i, shapeRendering: o, NodeComponent: s, onClick: l }) {
  const { node: c, x: u, y: f, width: h, height: p } = oo((g) => {
    const y = g.nodeLookup.get(t), { x: b, y: w } = y.internals.positionAbsolute, { width: _, height: C } = wg(y);
    return {
      node: y,
      x: b,
      y: w,
      width: _,
      height: C
    };
  }, Js);
  return !c || c.hidden || !Nbe(c) ? null : R.jsx(s, { x: u, y: f, width: h, height: p, style: c.style, selected: !!c.selected, className: n(c), color: e(c), borderRadius: a, strokeColor: r(c), strokeWidth: i, shapeRendering: o, onClick: l, id: c.id });
}
const L1n = Ls(D1n);
var j1n = Ls($1n);
const F1n = 200, z1n = 150, G1n = (t) => {
  const e = {
    x: -t.transform[0] / t.transform[2],
    y: -t.transform[1] / t.transform[2],
    width: t.width / t.transform[2],
    height: t.height / t.transform[2]
  };
  return {
    viewBB: e,
    boundingRect: t.nodeLookup.size > 0 ? Pgt(_P(t.nodeLookup), e) : e,
    rfId: t.rfId,
    panZoom: t.panZoom,
    translateExtent: t.translateExtent,
    flowWidth: t.width,
    flowHeight: t.height
  };
}, W1n = "react-flow__minimap-desc";
function Ovt({
  style: t,
  className: e,
  nodeStrokeColor: r,
  nodeColor: n,
  nodeClassName: a = "",
  nodeBorderRadius: i = 5,
  nodeStrokeWidth: o,
  /*
   * We need to rename the prop to be `CapitalCase` so that JSX will render it as
   * a component properly.
   */
  nodeComponent: s,
  bgColor: l,
  maskColor: c,
  maskStrokeColor: u,
  maskStrokeWidth: f,
  position: h = "bottom-right",
  onClick: p,
  onNodeClick: g,
  pannable: y = !1,
  zoomable: b = !1,
  ariaLabel: w = "React Flow mini map",
  inversePan: _,
  zoomStep: C = 10,
  offsetScale: x = 5
}) {
  const S = Is(), A = Zt(null), { boundingRect: I, viewBB: M, rfId: B, panZoom: L, translateExtent: N, flowWidth: d, flowHeight: m } = oo(G1n, Js), v = (t == null ? void 0 : t.width) ?? F1n, k = (t == null ? void 0 : t.height) ?? z1n, O = I.width / v, G = I.height / k, H = Math.max(O, G), j = H * v, F = H * k, z = x * H, W = I.x - (j - I.width) / 2 - z, U = I.y - (F - I.height) / 2 - z, Z = j + z * 2, V = F + z * 2, Y = `${W1n}-${B}`, ge = Zt(0), ce = Zt();
  ge.current = H, Ut(() => {
    if (A.current && L)
      return ce.current = n0n({
        domNode: A.current,
        panZoom: L,
        getTransform: () => S.getState().transform,
        getViewScale: () => ge.current
      }), () => {
        var Ce;
        (Ce = ce.current) == null || Ce.destroy();
      };
  }, [L]), Ut(() => {
    var Ce;
    (Ce = ce.current) == null || Ce.update({
      translateExtent: N,
      width: d,
      height: m,
      inversePan: _,
      pannable: y,
      zoomStep: C,
      zoomable: b
    });
  }, [y, b, _, C, N, d, m]);
  const ee = p ? (Ce) => {
    var Fe;
    const [we, We] = ((Fe = ce.current) == null ? void 0 : Fe.pointer(Ce)) || [0, 0];
    p(Ce, { x: we, y: We });
  } : void 0, Se = g ? sr((Ce, we) => {
    const We = S.getState().nodeLookup.get(we);
    g(Ce, We);
  }, []) : void 0;
  return R.jsx(AP, { position: h, style: {
    ...t,
    "--xy-minimap-background-color-props": typeof l == "string" ? l : void 0,
    "--xy-minimap-mask-background-color-props": typeof c == "string" ? c : void 0,
    "--xy-minimap-mask-stroke-color-props": typeof u == "string" ? u : void 0,
    "--xy-minimap-mask-stroke-width-props": typeof f == "number" ? f * H : void 0,
    "--xy-minimap-node-background-color-props": typeof n == "string" ? n : void 0,
    "--xy-minimap-node-stroke-color-props": typeof r == "string" ? r : void 0,
    "--xy-minimap-node-stroke-width-props": typeof o == "string" ? o : void 0
  }, className: Pl(["react-flow__minimap", e]), "data-testid": "rf__minimap", children: R.jsxs("svg", { width: v, height: k, viewBox: `${W} ${U} ${Z} ${V}`, className: "react-flow__minimap-svg", role: "img", "aria-labelledby": Y, ref: A, onClick: ee, children: [w && R.jsx("title", { id: Y, children: w }), R.jsx(j1n, { onClick: Se, nodeColor: n, nodeStrokeColor: r, nodeBorderRadius: i, nodeClassName: a, nodeStrokeWidth: o, nodeComponent: s }), R.jsx("path", { className: "react-flow__minimap-mask", d: `M${W - z},${U - z}h${Z + z * 2}v${V + z * 2}h${-Z - z * 2}z
        M${M.x},${M.y}h${M.width}v${M.height}h${-M.width}z`, fillRule: "evenodd", pointerEvents: "none" })] }) });
}
Ovt.displayName = "MiniMap";
Ls(Ovt);
function H1n({ nodeId: t, position: e, variant: r = Q_.Handle, className: n, style: a = {}, children: i, color: o, minWidth: s = 10, minHeight: l = 10, maxWidth: c = Number.MAX_VALUE, maxHeight: u = Number.MAX_VALUE, keepAspectRatio: f = !1, shouldResize: h, onResizeStart: p, onResize: g, onResizeEnd: y }) {
  const b = uvt(), w = typeof t == "string" ? t : b, _ = Is(), C = Zt(null), x = r === Q_.Line ? "right" : "bottom-right", S = e ?? x, A = Zt(null);
  Ut(() => {
    if (!(!C.current || !w))
      return A.current || (A.current = y0n({
        domNode: C.current,
        nodeId: w,
        getStoreItems: () => {
          const { nodeLookup: L, transform: N, snapGrid: d, snapToGrid: m, nodeOrigin: v, domNode: k } = _.getState();
          return {
            nodeLookup: L,
            transform: N,
            snapGrid: d,
            snapToGrid: m,
            nodeOrigin: v,
            paneDomNode: k
          };
        },
        onChange: (L, N) => {
          const { triggerNodeChanges: d, nodeLookup: m, parentLookup: v, nodeOrigin: k } = _.getState(), O = [], G = { x: L.x, y: L.y }, H = m.get(w);
          if (H && H.expandParent && H.parentId) {
            const j = H.origin ?? k, F = L.width ?? H.measured.width ?? 0, z = L.height ?? H.measured.height ?? 0, W = {
              id: H.id,
              parentId: H.parentId,
              rect: {
                width: F,
                height: z,
                ...Bgt({
                  x: L.x ?? H.position.x,
                  y: L.y ?? H.position.y
                }, { width: F, height: z }, H.parentId, m, j)
              }
            }, U = jbe([W], m, v, k);
            O.push(...U), G.x = L.x ? Math.max(j[0] * F, L.x) : void 0, G.y = L.y ? Math.max(j[1] * z, L.y) : void 0;
          }
          if (G.x !== void 0 && G.y !== void 0) {
            const j = {
              id: w,
              type: "position",
              position: { ...G }
            };
            O.push(j);
          }
          if (L.width !== void 0 && L.height !== void 0) {
            const j = {
              id: w,
              type: "dimensions",
              resizing: !0,
              setAttributes: !0,
              dimensions: {
                width: L.width,
                height: L.height
              }
            };
            O.push(j);
          }
          for (const j of N) {
            const F = {
              ...j,
              type: "position"
            };
            O.push(F);
          }
          d(O);
        },
        onEnd: () => {
          const L = {
            id: w,
            type: "dimensions",
            resizing: !1
          };
          _.getState().triggerNodeChanges([L]);
        }
      })), A.current.update({
        controlPosition: S,
        boundaries: {
          minWidth: s,
          minHeight: l,
          maxWidth: c,
          maxHeight: u
        },
        keepAspectRatio: f,
        onResizeStart: p,
        onResize: g,
        onResizeEnd: y,
        shouldResize: h
      }), () => {
        var L;
        (L = A.current) == null || L.destroy();
      };
  }, [
    S,
    s,
    l,
    c,
    u,
    f,
    p,
    g,
    y,
    h
  ]);
  const I = S.split("-"), M = r === Q_.Line ? "borderColor" : "backgroundColor", B = o ? { ...a, [M]: o } : a;
  return R.jsx("div", { className: Pl(["react-flow__resize-control", "nodrag", ...I, r, n]), ref: C, style: B, children: i });
}
Ls(H1n);
const mm = (t) => ({ data: e }) => {
  const r = e.label || "Default Node";
  return /* @__PURE__ */ R.jsxs(
    is,
    {
      padding: "space20",
      minHeight: "75px",
      width: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      style: { backgroundColor: t },
      children: [
        /* @__PURE__ */ R.jsx(Ay, { type: "target", position: Hn.Top }),
        /* @__PURE__ */ R.jsx("div", { children: r }),
        /* @__PURE__ */ R.jsx(Ay, { type: "source", position: Hn.Bottom })
      ]
    }
  );
}, U1n = ({ data: t }) => {
  const e = t.label || "Default Node";
  return /* @__PURE__ */ R.jsx(is, { padding: "space10", backgroundColor: "colorBackgroundBody", children: /* @__PURE__ */ R.jsxs(
    is,
    {
      minHeight: "75px",
      width: "150px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      backgroundColor: "colorBackgroundBody",
      children: [
        /* @__PURE__ */ R.jsx(Ay, { type: "target", position: Hn.Top }),
        /* @__PURE__ */ R.jsx("div", { children: e }),
        /* @__PURE__ */ R.jsx(Ay, { type: "source", position: Hn.Bottom })
      ]
    }
  ) });
};
var ose, Lze;
function zbe() {
  if (Lze) return ose;
  Lze = 1;
  var t = "\0", e = "\0", r = "";
  class n {
    constructor(u) {
      Za(this, "_isDirected", !0);
      Za(this, "_isMultigraph", !1);
      Za(this, "_isCompound", !1);
      // Label for the graph itself
      Za(this, "_label");
      // Defaults to be set when creating a new node
      Za(this, "_defaultNodeLabelFn", () => {
      });
      // Defaults to be set when creating a new edge
      Za(this, "_defaultEdgeLabelFn", () => {
      });
      // v -> label
      Za(this, "_nodes", {});
      // v -> edgeObj
      Za(this, "_in", {});
      // u -> v -> Number
      Za(this, "_preds", {});
      // v -> edgeObj
      Za(this, "_out", {});
      // v -> w -> Number
      Za(this, "_sucs", {});
      // e -> edgeObj
      Za(this, "_edgeObjs", {});
      // e -> label
      Za(this, "_edgeLabels", {});
      /* Number of nodes in the graph. Should only be changed by the implementation. */
      Za(this, "_nodeCount", 0);
      /* Number of edges in the graph. Should only be changed by the implementation. */
      Za(this, "_edgeCount", 0);
      Za(this, "_parent");
      Za(this, "_children");
      u && (this._isDirected = Object.hasOwn(u, "directed") ? u.directed : !0, this._isMultigraph = Object.hasOwn(u, "multigraph") ? u.multigraph : !1, this._isCompound = Object.hasOwn(u, "compound") ? u.compound : !1), this._isCompound && (this._parent = {}, this._children = {}, this._children[e] = {});
    }
    /* === Graph functions ========= */
    /**
     * Whether graph was created with 'directed' flag set to true or not.
     */
    isDirected() {
      return this._isDirected;
    }
    /**
     * Whether graph was created with 'multigraph' flag set to true or not.
     */
    isMultigraph() {
      return this._isMultigraph;
    }
    /**
     * Whether graph was created with 'compound' flag set to true or not.
     */
    isCompound() {
      return this._isCompound;
    }
    /**
     * Sets the label of the graph.
     */
    setGraph(u) {
      return this._label = u, this;
    }
    /**
     * Gets the graph label.
     */
    graph() {
      return this._label;
    }
    /* === Node functions ========== */
    /**
     * Sets the default node label. If newDefault is a function, it will be
     * invoked ach time when setting a label for a node. Otherwise, this label
     * will be assigned as default label in case if no label was specified while
     * setting a node.
     * Complexity: O(1).
     */
    setDefaultNodeLabel(u) {
      return this._defaultNodeLabelFn = u, typeof u != "function" && (this._defaultNodeLabelFn = () => u), this;
    }
    /**
     * Gets the number of nodes in the graph.
     * Complexity: O(1).
     */
    nodeCount() {
      return this._nodeCount;
    }
    /**
     * Gets all nodes of the graph. Note, the in case of compound graph subnodes are
     * not included in list.
     * Complexity: O(1).
     */
    nodes() {
      return Object.keys(this._nodes);
    }
    /**
     * Gets list of nodes without in-edges.
     * Complexity: O(|V|).
     */
    sources() {
      var u = this;
      return this.nodes().filter((f) => Object.keys(u._in[f]).length === 0);
    }
    /**
     * Gets list of nodes without out-edges.
     * Complexity: O(|V|).
     */
    sinks() {
      var u = this;
      return this.nodes().filter((f) => Object.keys(u._out[f]).length === 0);
    }
    /**
     * Invokes setNode method for each node in names list.
     * Complexity: O(|names|).
     */
    setNodes(u, f) {
      var h = arguments, p = this;
      return u.forEach(function(g) {
        h.length > 1 ? p.setNode(g, f) : p.setNode(g);
      }), this;
    }
    /**
     * Creates or updates the value for the node v in the graph. If label is supplied
     * it is set as the value for the node. If label is not supplied and the node was
     * created by this call then the default node label will be assigned.
     * Complexity: O(1).
     */
    setNode(u, f) {
      return Object.hasOwn(this._nodes, u) ? (arguments.length > 1 && (this._nodes[u] = f), this) : (this._nodes[u] = arguments.length > 1 ? f : this._defaultNodeLabelFn(u), this._isCompound && (this._parent[u] = e, this._children[u] = {}, this._children[e][u] = !0), this._in[u] = {}, this._preds[u] = {}, this._out[u] = {}, this._sucs[u] = {}, ++this._nodeCount, this);
    }
    /**
     * Gets the label of node with specified name.
     * Complexity: O(|V|).
     */
    node(u) {
      return this._nodes[u];
    }
    /**
     * Detects whether graph has a node with specified name or not.
     */
    hasNode(u) {
      return Object.hasOwn(this._nodes, u);
    }
    /**
     * Remove the node with the name from the graph or do nothing if the node is not in
     * the graph. If the node was removed this function also removes any incident
     * edges.
     * Complexity: O(1).
     */
    removeNode(u) {
      var f = this;
      if (Object.hasOwn(this._nodes, u)) {
        var h = (p) => f.removeEdge(f._edgeObjs[p]);
        delete this._nodes[u], this._isCompound && (this._removeFromParentsChildList(u), delete this._parent[u], this.children(u).forEach(function(p) {
          f.setParent(p);
        }), delete this._children[u]), Object.keys(this._in[u]).forEach(h), delete this._in[u], delete this._preds[u], Object.keys(this._out[u]).forEach(h), delete this._out[u], delete this._sucs[u], --this._nodeCount;
      }
      return this;
    }
    /**
     * Sets node p as a parent for node v if it is defined, or removes the
     * parent for v if p is undefined. Method throws an exception in case of
     * invoking it in context of noncompound graph.
     * Average-case complexity: O(1).
     */
    setParent(u, f) {
      if (!this._isCompound)
        throw new Error("Cannot set parent in a non-compound graph");
      if (f === void 0)
        f = e;
      else {
        f += "";
        for (var h = f; h !== void 0; h = this.parent(h))
          if (h === u)
            throw new Error("Setting " + f + " as parent of " + u + " would create a cycle");
        this.setNode(f);
      }
      return this.setNode(u), this._removeFromParentsChildList(u), this._parent[u] = f, this._children[f][u] = !0, this;
    }
    _removeFromParentsChildList(u) {
      delete this._children[this._parent[u]][u];
    }
    /**
     * Gets parent node for node v.
     * Complexity: O(1).
     */
    parent(u) {
      if (this._isCompound) {
        var f = this._parent[u];
        if (f !== e)
          return f;
      }
    }
    /**
     * Gets list of direct children of node v.
     * Complexity: O(1).
     */
    children(u = e) {
      if (this._isCompound) {
        var f = this._children[u];
        if (f)
          return Object.keys(f);
      } else {
        if (u === e)
          return this.nodes();
        if (this.hasNode(u))
          return [];
      }
    }
    /**
     * Return all nodes that are predecessors of the specified node or undefined if node v is not in
     * the graph. Behavior is undefined for undirected graphs - use neighbors instead.
     * Complexity: O(|V|).
     */
    predecessors(u) {
      var f = this._preds[u];
      if (f)
        return Object.keys(f);
    }
    /**
     * Return all nodes that are successors of the specified node or undefined if node v is not in
     * the graph. Behavior is undefined for undirected graphs - use neighbors instead.
     * Complexity: O(|V|).
     */
    successors(u) {
      var f = this._sucs[u];
      if (f)
        return Object.keys(f);
    }
    /**
     * Return all nodes that are predecessors or successors of the specified node or undefined if
     * node v is not in the graph.
     * Complexity: O(|V|).
     */
    neighbors(u) {
      var f = this.predecessors(u);
      if (f) {
        const p = new Set(f);
        for (var h of this.successors(u))
          p.add(h);
        return Array.from(p.values());
      }
    }
    isLeaf(u) {
      var f;
      return this.isDirected() ? f = this.successors(u) : f = this.neighbors(u), f.length === 0;
    }
    /**
     * Creates new graph with nodes filtered via filter. Edges incident to rejected node
     * are also removed. In case of compound graph, if parent is rejected by filter,
     * than all its children are rejected too.
     * Average-case complexity: O(|E|+|V|).
     */
    filterNodes(u) {
      var f = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
      });
      f.setGraph(this.graph());
      var h = this;
      Object.entries(this._nodes).forEach(function([y, b]) {
        u(y) && f.setNode(y, b);
      }), Object.values(this._edgeObjs).forEach(function(y) {
        f.hasNode(y.v) && f.hasNode(y.w) && f.setEdge(y, h.edge(y));
      });
      var p = {};
      function g(y) {
        var b = h.parent(y);
        return b === void 0 || f.hasNode(b) ? (p[y] = b, b) : b in p ? p[b] : g(b);
      }
      return this._isCompound && f.nodes().forEach((y) => f.setParent(y, g(y))), f;
    }
    /* === Edge functions ========== */
    /**
     * Sets the default edge label or factory function. This label will be
     * assigned as default label in case if no label was specified while setting
     * an edge or this function will be invoked each time when setting an edge
     * with no label specified and returned value * will be used as a label for edge.
     * Complexity: O(1).
     */
    setDefaultEdgeLabel(u) {
      return this._defaultEdgeLabelFn = u, typeof u != "function" && (this._defaultEdgeLabelFn = () => u), this;
    }
    /**
     * Gets the number of edges in the graph.
     * Complexity: O(1).
     */
    edgeCount() {
      return this._edgeCount;
    }
    /**
     * Gets edges of the graph. In case of compound graph subgraphs are not considered.
     * Complexity: O(|E|).
     */
    edges() {
      return Object.values(this._edgeObjs);
    }
    /**
     * Establish an edges path over the nodes in nodes list. If some edge is already
     * exists, it will update its label, otherwise it will create an edge between pair
     * of nodes with label provided or default label if no label provided.
     * Complexity: O(|nodes|).
     */
    setPath(u, f) {
      var h = this, p = arguments;
      return u.reduce(function(g, y) {
        return p.length > 1 ? h.setEdge(g, y, f) : h.setEdge(g, y), y;
      }), this;
    }
    /**
     * Creates or updates the label for the edge (v, w) with the optionally supplied
     * name. If label is supplied it is set as the value for the edge. If label is not
     * supplied and the edge was created by this call then the default edge label will
     * be assigned. The name parameter is only useful with multigraphs.
     */
    setEdge() {
      var u, f, h, p, g = !1, y = arguments[0];
      typeof y == "object" && y !== null && "v" in y ? (u = y.v, f = y.w, h = y.name, arguments.length === 2 && (p = arguments[1], g = !0)) : (u = y, f = arguments[1], h = arguments[3], arguments.length > 2 && (p = arguments[2], g = !0)), u = "" + u, f = "" + f, h !== void 0 && (h = "" + h);
      var b = o(this._isDirected, u, f, h);
      if (Object.hasOwn(this._edgeLabels, b))
        return g && (this._edgeLabels[b] = p), this;
      if (h !== void 0 && !this._isMultigraph)
        throw new Error("Cannot set a named edge when isMultigraph = false");
      this.setNode(u), this.setNode(f), this._edgeLabels[b] = g ? p : this._defaultEdgeLabelFn(u, f, h);
      var w = s(this._isDirected, u, f, h);
      return u = w.v, f = w.w, Object.freeze(w), this._edgeObjs[b] = w, a(this._preds[f], u), a(this._sucs[u], f), this._in[f][b] = w, this._out[u][b] = w, this._edgeCount++, this;
    }
    /**
     * Gets the label for the specified edge.
     * Complexity: O(1).
     */
    edge(u, f, h) {
      var p = arguments.length === 1 ? l(this._isDirected, arguments[0]) : o(this._isDirected, u, f, h);
      return this._edgeLabels[p];
    }
    /**
     * Gets the label for the specified edge and converts it to an object.
     * Complexity: O(1)
     */
    edgeAsObj() {
      const u = this.edge(...arguments);
      return typeof u != "object" ? { label: u } : u;
    }
    /**
     * Detects whether the graph contains specified edge or not. No subgraphs are considered.
     * Complexity: O(1).
     */
    hasEdge(u, f, h) {
      var p = arguments.length === 1 ? l(this._isDirected, arguments[0]) : o(this._isDirected, u, f, h);
      return Object.hasOwn(this._edgeLabels, p);
    }
    /**
     * Removes the specified edge from the graph. No subgraphs are considered.
     * Complexity: O(1).
     */
    removeEdge(u, f, h) {
      var p = arguments.length === 1 ? l(this._isDirected, arguments[0]) : o(this._isDirected, u, f, h), g = this._edgeObjs[p];
      return g && (u = g.v, f = g.w, delete this._edgeLabels[p], delete this._edgeObjs[p], i(this._preds[f], u), i(this._sucs[u], f), delete this._in[f][p], delete this._out[u][p], this._edgeCount--), this;
    }
    /**
     * Return all edges that point to the node v. Optionally filters those edges down to just those
     * coming from node u. Behavior is undefined for undirected graphs - use nodeEdges instead.
     * Complexity: O(|E|).
     */
    inEdges(u, f) {
      var h = this._in[u];
      if (h) {
        var p = Object.values(h);
        return f ? p.filter((g) => g.v === f) : p;
      }
    }
    /**
     * Return all edges that are pointed at by node v. Optionally filters those edges down to just
     * those point to w. Behavior is undefined for undirected graphs - use nodeEdges instead.
     * Complexity: O(|E|).
     */
    outEdges(u, f) {
      var h = this._out[u];
      if (h) {
        var p = Object.values(h);
        return f ? p.filter((g) => g.w === f) : p;
      }
    }
    /**
     * Returns all edges to or from node v regardless of direction. Optionally filters those edges
     * down to just those between nodes v and w regardless of direction.
     * Complexity: O(|E|).
     */
    nodeEdges(u, f) {
      var h = this.inEdges(u, f);
      if (h)
        return h.concat(this.outEdges(u, f));
    }
  }
  function a(c, u) {
    c[u] ? c[u]++ : c[u] = 1;
  }
  function i(c, u) {
    --c[u] || delete c[u];
  }
  function o(c, u, f, h) {
    var p = "" + u, g = "" + f;
    if (!c && p > g) {
      var y = p;
      p = g, g = y;
    }
    return p + r + g + r + (h === void 0 ? t : h);
  }
  function s(c, u, f, h) {
    var p = "" + u, g = "" + f;
    if (!c && p > g) {
      var y = p;
      p = g, g = y;
    }
    var b = { v: p, w: g };
    return h && (b.name = h), b;
  }
  function l(c, u) {
    return o(c, u.v, u.w, u.name);
  }
  return ose = n, ose;
}
var sse, jze;
function V1n() {
  return jze || (jze = 1, sse = "2.2.4"), sse;
}
var lse, Fze;
function q1n() {
  return Fze || (Fze = 1, lse = {
    Graph: zbe(),
    version: V1n()
  }), lse;
}
var cse, zze;
function K1n() {
  if (zze) return cse;
  zze = 1;
  var t = zbe();
  cse = {
    write: e,
    read: a
  };
  function e(i) {
    var o = {
      options: {
        directed: i.isDirected(),
        multigraph: i.isMultigraph(),
        compound: i.isCompound()
      },
      nodes: r(i),
      edges: n(i)
    };
    return i.graph() !== void 0 && (o.value = structuredClone(i.graph())), o;
  }
  function r(i) {
    return i.nodes().map(function(o) {
      var s = i.node(o), l = i.parent(o), c = { v: o };
      return s !== void 0 && (c.value = s), l !== void 0 && (c.parent = l), c;
    });
  }
  function n(i) {
    return i.edges().map(function(o) {
      var s = i.edge(o), l = { v: o.v, w: o.w };
      return o.name !== void 0 && (l.name = o.name), s !== void 0 && (l.value = s), l;
    });
  }
  function a(i) {
    var o = new t(i.options).setGraph(i.value);
    return i.nodes.forEach(function(s) {
      o.setNode(s.v, s.value), s.parent && o.setParent(s.v, s.parent);
    }), i.edges.forEach(function(s) {
      o.setEdge({ v: s.v, w: s.w, name: s.name }, s.value);
    }), o;
  }
  return cse;
}
var use, Gze;
function Z1n() {
  if (Gze) return use;
  Gze = 1, use = t;
  function t(e) {
    var r = {}, n = [], a;
    function i(o) {
      Object.hasOwn(r, o) || (r[o] = !0, a.push(o), e.successors(o).forEach(i), e.predecessors(o).forEach(i));
    }
    return e.nodes().forEach(function(o) {
      a = [], i(o), a.length && n.push(a);
    }), n;
  }
  return use;
}
var dse, Wze;
function Bvt() {
  if (Wze) return dse;
  Wze = 1;
  class t {
    constructor() {
      Za(this, "_arr", []);
      Za(this, "_keyIndices", {});
    }
    /**
     * Returns the number of elements in the queue. Takes `O(1)` time.
     */
    size() {
      return this._arr.length;
    }
    /**
     * Returns the keys that are in the queue. Takes `O(n)` time.
     */
    keys() {
      return this._arr.map(function(r) {
        return r.key;
      });
    }
    /**
     * Returns `true` if **key** is in the queue and `false` if not.
     */
    has(r) {
      return Object.hasOwn(this._keyIndices, r);
    }
    /**
     * Returns the priority for **key**. If **key** is not present in the queue
     * then this function returns `undefined`. Takes `O(1)` time.
     *
     * @param {Object} key
     */
    priority(r) {
      var n = this._keyIndices[r];
      if (n !== void 0)
        return this._arr[n].priority;
    }
    /**
     * Returns the key for the minimum element in this queue. If the queue is
     * empty this function throws an Error. Takes `O(1)` time.
     */
    min() {
      if (this.size() === 0)
        throw new Error("Queue underflow");
      return this._arr[0].key;
    }
    /**
     * Inserts a new key into the priority queue. If the key already exists in
     * the queue this function returns `false`; otherwise it will return `true`.
     * Takes `O(n)` time.
     *
     * @param {Object} key the key to add
     * @param {Number} priority the initial priority for the key
     */
    add(r, n) {
      var a = this._keyIndices;
      if (r = String(r), !Object.hasOwn(a, r)) {
        var i = this._arr, o = i.length;
        return a[r] = o, i.push({ key: r, priority: n }), this._decrease(o), !0;
      }
      return !1;
    }
    /**
     * Removes and returns the smallest key in the queue. Takes `O(log n)` time.
     */
    removeMin() {
      this._swap(0, this._arr.length - 1);
      var r = this._arr.pop();
      return delete this._keyIndices[r.key], this._heapify(0), r.key;
    }
    /**
     * Decreases the priority for **key** to **priority**. If the new priority is
     * greater than the previous priority, this function will throw an Error.
     *
     * @param {Object} key the key for which to raise priority
     * @param {Number} priority the new priority for the key
     */
    decrease(r, n) {
      var a = this._keyIndices[r];
      if (n > this._arr[a].priority)
        throw new Error("New priority is greater than current priority. Key: " + r + " Old: " + this._arr[a].priority + " New: " + n);
      this._arr[a].priority = n, this._decrease(a);
    }
    _heapify(r) {
      var n = this._arr, a = 2 * r, i = a + 1, o = r;
      a < n.length && (o = n[a].priority < n[o].priority ? a : o, i < n.length && (o = n[i].priority < n[o].priority ? i : o), o !== r && (this._swap(r, o), this._heapify(o)));
    }
    _decrease(r) {
      for (var n = this._arr, a = n[r].priority, i; r !== 0 && (i = r >> 1, !(n[i].priority < a)); )
        this._swap(r, i), r = i;
    }
    _swap(r, n) {
      var a = this._arr, i = this._keyIndices, o = a[r], s = a[n];
      a[r] = s, a[n] = o, i[s.key] = r, i[o.key] = n;
    }
  }
  return dse = t, dse;
}
var fse, Hze;
function Nvt() {
  if (Hze) return fse;
  Hze = 1;
  var t = Bvt();
  fse = r;
  var e = () => 1;
  function r(a, i, o, s) {
    return n(
      a,
      String(i),
      o || e,
      s || function(l) {
        return a.outEdges(l);
      }
    );
  }
  function n(a, i, o, s) {
    var l = {}, c = new t(), u, f, h = function(p) {
      var g = p.v !== u ? p.v : p.w, y = l[g], b = o(p), w = f.distance + b;
      if (b < 0)
        throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + p + " Weight: " + b);
      w < y.distance && (y.distance = w, y.predecessor = u, c.decrease(g, w));
    };
    for (a.nodes().forEach(function(p) {
      var g = p === i ? 0 : Number.POSITIVE_INFINITY;
      l[p] = { distance: g }, c.add(p, g);
    }); c.size() > 0 && (u = c.removeMin(), f = l[u], f.distance !== Number.POSITIVE_INFINITY); )
      s(u).forEach(h);
    return l;
  }
  return fse;
}
var hse, Uze;
function J1n() {
  if (Uze) return hse;
  Uze = 1;
  var t = Nvt();
  hse = e;
  function e(r, n, a) {
    return r.nodes().reduce(function(i, o) {
      return i[o] = t(r, o, n, a), i;
    }, {});
  }
  return hse;
}
var pse, Vze;
function $vt() {
  if (Vze) return pse;
  Vze = 1, pse = t;
  function t(e) {
    var r = 0, n = [], a = {}, i = [];
    function o(s) {
      var l = a[s] = {
        onStack: !0,
        lowlink: r,
        index: r++
      };
      if (n.push(s), e.successors(s).forEach(function(f) {
        Object.hasOwn(a, f) ? a[f].onStack && (l.lowlink = Math.min(l.lowlink, a[f].index)) : (o(f), l.lowlink = Math.min(l.lowlink, a[f].lowlink));
      }), l.lowlink === l.index) {
        var c = [], u;
        do
          u = n.pop(), a[u].onStack = !1, c.push(u);
        while (s !== u);
        i.push(c);
      }
    }
    return e.nodes().forEach(function(s) {
      Object.hasOwn(a, s) || o(s);
    }), i;
  }
  return pse;
}
var mse, qze;
function Y1n() {
  if (qze) return mse;
  qze = 1;
  var t = $vt();
  mse = e;
  function e(r) {
    return t(r).filter(function(n) {
      return n.length > 1 || n.length === 1 && r.hasEdge(n[0], n[0]);
    });
  }
  return mse;
}
var gse, Kze;
function X1n() {
  if (Kze) return gse;
  Kze = 1, gse = e;
  var t = () => 1;
  function e(n, a, i) {
    return r(
      n,
      a || t,
      i || function(o) {
        return n.outEdges(o);
      }
    );
  }
  function r(n, a, i) {
    var o = {}, s = n.nodes();
    return s.forEach(function(l) {
      o[l] = {}, o[l][l] = { distance: 0 }, s.forEach(function(c) {
        l !== c && (o[l][c] = { distance: Number.POSITIVE_INFINITY });
      }), i(l).forEach(function(c) {
        var u = c.v === l ? c.w : c.v, f = a(c);
        o[l][u] = { distance: f, predecessor: l };
      });
    }), s.forEach(function(l) {
      var c = o[l];
      s.forEach(function(u) {
        var f = o[u];
        s.forEach(function(h) {
          var p = f[l], g = c[h], y = f[h], b = p.distance + g.distance;
          b < y.distance && (y.distance = b, y.predecessor = g.predecessor);
        });
      });
    }), o;
  }
  return gse;
}
var vse, Zze;
function Dvt() {
  if (Zze) return vse;
  Zze = 1;
  function t(r) {
    var n = {}, a = {}, i = [];
    function o(s) {
      if (Object.hasOwn(a, s))
        throw new e();
      Object.hasOwn(n, s) || (a[s] = !0, n[s] = !0, r.predecessors(s).forEach(o), delete a[s], i.push(s));
    }
    if (r.sinks().forEach(o), Object.keys(n).length !== r.nodeCount())
      throw new e();
    return i;
  }
  class e extends Error {
    constructor() {
      super(...arguments);
    }
  }
  return vse = t, t.CycleException = e, vse;
}
var yse, Jze;
function Q1n() {
  if (Jze) return yse;
  Jze = 1;
  var t = Dvt();
  yse = e;
  function e(r) {
    try {
      t(r);
    } catch (n) {
      if (n instanceof t.CycleException)
        return !1;
      throw n;
    }
    return !0;
  }
  return yse;
}
var bse, Yze;
function Lvt() {
  if (Yze) return bse;
  Yze = 1, bse = t;
  function t(a, i, o) {
    Array.isArray(i) || (i = [i]);
    var s = a.isDirected() ? (f) => a.successors(f) : (f) => a.neighbors(f), l = o === "post" ? e : r, c = [], u = {};
    return i.forEach((f) => {
      if (!a.hasNode(f))
        throw new Error("Graph does not have node: " + f);
      l(f, s, u, c);
    }), c;
  }
  function e(a, i, o, s) {
    for (var l = [[a, !1]]; l.length > 0; ) {
      var c = l.pop();
      c[1] ? s.push(c[0]) : Object.hasOwn(o, c[0]) || (o[c[0]] = !0, l.push([c[0], !0]), n(i(c[0]), (u) => l.push([u, !1])));
    }
  }
  function r(a, i, o, s) {
    for (var l = [a]; l.length > 0; ) {
      var c = l.pop();
      Object.hasOwn(o, c) || (o[c] = !0, s.push(c), n(i(c), (u) => l.push(u)));
    }
  }
  function n(a, i) {
    for (var o = a.length; o--; )
      i(a[o], o, a);
    return a;
  }
  return bse;
}
var xse, Xze;
function e2n() {
  if (Xze) return xse;
  Xze = 1;
  var t = Lvt();
  xse = e;
  function e(r, n) {
    return t(r, n, "post");
  }
  return xse;
}
var Cse, Qze;
function t2n() {
  if (Qze) return Cse;
  Qze = 1;
  var t = Lvt();
  Cse = e;
  function e(r, n) {
    return t(r, n, "pre");
  }
  return Cse;
}
var wse, eGe;
function r2n() {
  if (eGe) return wse;
  eGe = 1;
  var t = zbe(), e = Bvt();
  wse = r;
  function r(n, a) {
    var i = new t(), o = {}, s = new e(), l;
    function c(f) {
      var h = f.v === l ? f.w : f.v, p = s.priority(h);
      if (p !== void 0) {
        var g = a(f);
        g < p && (o[h] = l, s.decrease(h, g));
      }
    }
    if (n.nodeCount() === 0)
      return i;
    n.nodes().forEach(function(f) {
      s.add(f, Number.POSITIVE_INFINITY), i.setNode(f);
    }), s.decrease(n.nodes()[0], 0);
    for (var u = !1; s.size() > 0; ) {
      if (l = s.removeMin(), Object.hasOwn(o, l))
        i.setEdge(l, o[l]);
      else {
        if (u)
          throw new Error("Input graph is not connected: " + n);
        u = !0;
      }
      n.nodeEdges(l).forEach(c);
    }
    return i;
  }
  return wse;
}
var Sse, tGe;
function n2n() {
  return tGe || (tGe = 1, Sse = {
    components: Z1n(),
    dijkstra: Nvt(),
    dijkstraAll: J1n(),
    findCycles: Y1n(),
    floydWarshall: X1n(),
    isAcyclic: Q1n(),
    postorder: e2n(),
    preorder: t2n(),
    prim: r2n(),
    tarjan: $vt(),
    topsort: Dvt()
  }), Sse;
}
var _se, rGe;
function e2() {
  if (rGe) return _se;
  rGe = 1;
  var t = q1n();
  return _se = {
    Graph: t.Graph,
    json: K1n(),
    alg: n2n(),
    version: t.version
  }, _se;
}
var kse, nGe;
function a2n() {
  if (nGe) return kse;
  nGe = 1;
  class t {
    constructor() {
      let a = {};
      a._next = a._prev = a, this._sentinel = a;
    }
    dequeue() {
      let a = this._sentinel, i = a._prev;
      if (i !== a)
        return e(i), i;
    }
    enqueue(a) {
      let i = this._sentinel;
      a._prev && a._next && e(a), a._next = i._next, i._next._prev = a, i._next = a, a._prev = i;
    }
    toString() {
      let a = [], i = this._sentinel, o = i._prev;
      for (; o !== i; )
        a.push(JSON.stringify(o, r)), o = o._prev;
      return "[" + a.join(", ") + "]";
    }
  }
  function e(n) {
    n._prev._next = n._next, n._next._prev = n._prev, delete n._next, delete n._prev;
  }
  function r(n, a) {
    if (n !== "_next" && n !== "_prev")
      return a;
  }
  return kse = t, kse;
}
var Ase, aGe;
function i2n() {
  if (aGe) return Ase;
  aGe = 1;
  let t = e2().Graph, e = a2n();
  Ase = n;
  let r = () => 1;
  function n(c, u) {
    if (c.nodeCount() <= 1)
      return [];
    let f = o(c, u || r);
    return a(f.graph, f.buckets, f.zeroIdx).flatMap((p) => c.outEdges(p.v, p.w));
  }
  function a(c, u, f) {
    let h = [], p = u[u.length - 1], g = u[0], y;
    for (; c.nodeCount(); ) {
      for (; y = g.dequeue(); )
        i(c, u, f, y);
      for (; y = p.dequeue(); )
        i(c, u, f, y);
      if (c.nodeCount()) {
        for (let b = u.length - 2; b > 0; --b)
          if (y = u[b].dequeue(), y) {
            h = h.concat(i(c, u, f, y, !0));
            break;
          }
      }
    }
    return h;
  }
  function i(c, u, f, h, p) {
    let g = p ? [] : void 0;
    return c.inEdges(h.v).forEach((y) => {
      let b = c.edge(y), w = c.node(y.v);
      p && g.push({ v: y.v, w: y.w }), w.out -= b, s(u, f, w);
    }), c.outEdges(h.v).forEach((y) => {
      let b = c.edge(y), w = y.w, _ = c.node(w);
      _.in -= b, s(u, f, _);
    }), c.removeNode(h.v), g;
  }
  function o(c, u) {
    let f = new t(), h = 0, p = 0;
    c.nodes().forEach((b) => {
      f.setNode(b, { v: b, in: 0, out: 0 });
    }), c.edges().forEach((b) => {
      let w = f.edge(b.v, b.w) || 0, _ = u(b), C = w + _;
      f.setEdge(b.v, b.w, C), p = Math.max(p, f.node(b.v).out += _), h = Math.max(h, f.node(b.w).in += _);
    });
    let g = l(p + h + 3).map(() => new e()), y = h + 1;
    return f.nodes().forEach((b) => {
      s(g, y, f.node(b));
    }), { graph: f, buckets: g, zeroIdx: y };
  }
  function s(c, u, f) {
    f.out ? f.in ? c[f.out - f.in + u].enqueue(f) : c[c.length - 1].enqueue(f) : c[0].enqueue(f);
  }
  function l(c) {
    const u = [];
    for (let f = 0; f < c; f++)
      u.push(f);
    return u;
  }
  return Ase;
}
var Tse, iGe;
function kl() {
  if (iGe) return Tse;
  iGe = 1;
  let t = e2().Graph;
  Tse = {
    addBorderNode: u,
    addDummyNode: e,
    applyWithChunking: p,
    asNonCompoundGraph: n,
    buildLayerMatrix: s,
    intersectRect: o,
    mapValues: A,
    maxRank: g,
    normalizeRanks: l,
    notime: w,
    partition: y,
    pick: S,
    predecessorWeights: i,
    range: x,
    removeEmptyRanks: c,
    simplify: r,
    successorWeights: a,
    time: b,
    uniqueId: C,
    zipObject: I
  };
  function e(M, B, L, N) {
    let d;
    do
      d = C(N);
    while (M.hasNode(d));
    return L.dummy = B, M.setNode(d, L), d;
  }
  function r(M) {
    let B = new t().setGraph(M.graph());
    return M.nodes().forEach((L) => B.setNode(L, M.node(L))), M.edges().forEach((L) => {
      let N = B.edge(L.v, L.w) || { weight: 0, minlen: 1 }, d = M.edge(L);
      B.setEdge(L.v, L.w, {
        weight: N.weight + d.weight,
        minlen: Math.max(N.minlen, d.minlen)
      });
    }), B;
  }
  function n(M) {
    let B = new t({ multigraph: M.isMultigraph() }).setGraph(M.graph());
    return M.nodes().forEach((L) => {
      M.children(L).length || B.setNode(L, M.node(L));
    }), M.edges().forEach((L) => {
      B.setEdge(L, M.edge(L));
    }), B;
  }
  function a(M) {
    let B = M.nodes().map((L) => {
      let N = {};
      return M.outEdges(L).forEach((d) => {
        N[d.w] = (N[d.w] || 0) + M.edge(d).weight;
      }), N;
    });
    return I(M.nodes(), B);
  }
  function i(M) {
    let B = M.nodes().map((L) => {
      let N = {};
      return M.inEdges(L).forEach((d) => {
        N[d.v] = (N[d.v] || 0) + M.edge(d).weight;
      }), N;
    });
    return I(M.nodes(), B);
  }
  function o(M, B) {
    let L = M.x, N = M.y, d = B.x - L, m = B.y - N, v = M.width / 2, k = M.height / 2;
    if (!d && !m)
      throw new Error("Not possible to find intersection inside of the rectangle");
    let O, G;
    return Math.abs(m) * v > Math.abs(d) * k ? (m < 0 && (k = -k), O = k * d / m, G = k) : (d < 0 && (v = -v), O = v, G = v * m / d), { x: L + O, y: N + G };
  }
  function s(M) {
    let B = x(g(M) + 1).map(() => []);
    return M.nodes().forEach((L) => {
      let N = M.node(L), d = N.rank;
      d !== void 0 && (B[d][N.order] = L);
    }), B;
  }
  function l(M) {
    let B = M.nodes().map((N) => {
      let d = M.node(N).rank;
      return d === void 0 ? Number.MAX_VALUE : d;
    }), L = p(Math.min, B);
    M.nodes().forEach((N) => {
      let d = M.node(N);
      Object.hasOwn(d, "rank") && (d.rank -= L);
    });
  }
  function c(M) {
    let B = M.nodes().map((v) => M.node(v).rank), L = p(Math.min, B), N = [];
    M.nodes().forEach((v) => {
      let k = M.node(v).rank - L;
      N[k] || (N[k] = []), N[k].push(v);
    });
    let d = 0, m = M.graph().nodeRankFactor;
    Array.from(N).forEach((v, k) => {
      v === void 0 && k % m !== 0 ? --d : v !== void 0 && d && v.forEach((O) => M.node(O).rank += d);
    });
  }
  function u(M, B, L, N) {
    let d = {
      width: 0,
      height: 0
    };
    return arguments.length >= 4 && (d.rank = L, d.order = N), e(M, "border", d, B);
  }
  function f(M, B = h) {
    const L = [];
    for (let N = 0; N < M.length; N += B) {
      const d = M.slice(N, N + B);
      L.push(d);
    }
    return L;
  }
  const h = 65535;
  function p(M, B) {
    if (B.length > h) {
      const L = f(B);
      return M.apply(null, L.map((N) => M.apply(null, N)));
    } else
      return M.apply(null, B);
  }
  function g(M) {
    const L = M.nodes().map((N) => {
      let d = M.node(N).rank;
      return d === void 0 ? Number.MIN_VALUE : d;
    });
    return p(Math.max, L);
  }
  function y(M, B) {
    let L = { lhs: [], rhs: [] };
    return M.forEach((N) => {
      B(N) ? L.lhs.push(N) : L.rhs.push(N);
    }), L;
  }
  function b(M, B) {
    let L = Date.now();
    try {
      return B();
    } finally {
      console.log(M + " time: " + (Date.now() - L) + "ms");
    }
  }
  function w(M, B) {
    return B();
  }
  let _ = 0;
  function C(M) {
    var B = ++_;
    return toString(M) + B;
  }
  function x(M, B, L = 1) {
    B == null && (B = M, M = 0);
    let N = (m) => m < B;
    L < 0 && (N = (m) => B < m);
    const d = [];
    for (let m = M; N(m); m += L)
      d.push(m);
    return d;
  }
  function S(M, B) {
    const L = {};
    for (const N of B)
      M[N] !== void 0 && (L[N] = M[N]);
    return L;
  }
  function A(M, B) {
    let L = B;
    return typeof B == "string" && (L = (N) => N[B]), Object.entries(M).reduce((N, [d, m]) => (N[d] = L(m, d), N), {});
  }
  function I(M, B) {
    return M.reduce((L, N, d) => (L[N] = B[d], L), {});
  }
  return Tse;
}
var Ese, oGe;
function o2n() {
  if (oGe) return Ese;
  oGe = 1;
  let t = i2n(), e = kl().uniqueId;
  Ese = {
    run: r,
    undo: a
  };
  function r(i) {
    (i.graph().acyclicer === "greedy" ? t(i, s(i)) : n(i)).forEach((l) => {
      let c = i.edge(l);
      i.removeEdge(l), c.forwardName = l.name, c.reversed = !0, i.setEdge(l.w, l.v, c, e("rev"));
    });
    function s(l) {
      return (c) => l.edge(c).weight;
    }
  }
  function n(i) {
    let o = [], s = {}, l = {};
    function c(u) {
      Object.hasOwn(l, u) || (l[u] = !0, s[u] = !0, i.outEdges(u).forEach((f) => {
        Object.hasOwn(s, f.w) ? o.push(f) : c(f.w);
      }), delete s[u]);
    }
    return i.nodes().forEach(c), o;
  }
  function a(i) {
    i.edges().forEach((o) => {
      let s = i.edge(o);
      if (s.reversed) {
        i.removeEdge(o);
        let l = s.forwardName;
        delete s.reversed, delete s.forwardName, i.setEdge(o.w, o.v, s, l);
      }
    });
  }
  return Ese;
}
var Ise, sGe;
function s2n() {
  if (sGe) return Ise;
  sGe = 1;
  let t = kl();
  Ise = {
    run: e,
    undo: n
  };
  function e(a) {
    a.graph().dummyChains = [], a.edges().forEach((i) => r(a, i));
  }
  function r(a, i) {
    let o = i.v, s = a.node(o).rank, l = i.w, c = a.node(l).rank, u = i.name, f = a.edge(i), h = f.labelRank;
    if (c === s + 1) return;
    a.removeEdge(i);
    let p, g, y;
    for (y = 0, ++s; s < c; ++y, ++s)
      f.points = [], g = {
        width: 0,
        height: 0,
        edgeLabel: f,
        edgeObj: i,
        rank: s
      }, p = t.addDummyNode(a, "edge", g, "_d"), s === h && (g.width = f.width, g.height = f.height, g.dummy = "edge-label", g.labelpos = f.labelpos), a.setEdge(o, p, { weight: f.weight }, u), y === 0 && a.graph().dummyChains.push(p), o = p;
    a.setEdge(o, l, { weight: f.weight }, u);
  }
  function n(a) {
    a.graph().dummyChains.forEach((i) => {
      let o = a.node(i), s = o.edgeLabel, l;
      for (a.setEdge(o.edgeObj, s); o.dummy; )
        l = a.successors(i)[0], a.removeNode(i), s.points.push({ x: o.x, y: o.y }), o.dummy === "edge-label" && (s.x = o.x, s.y = o.y, s.width = o.width, s.height = o.height), i = l, o = a.node(i);
    });
  }
  return Ise;
}
var Mse, lGe;
function YF() {
  if (lGe) return Mse;
  lGe = 1;
  const { applyWithChunking: t } = kl();
  Mse = {
    longestPath: e,
    slack: r
  };
  function e(n) {
    var a = {};
    function i(o) {
      var s = n.node(o);
      if (Object.hasOwn(a, o))
        return s.rank;
      a[o] = !0;
      let l = n.outEdges(o).map((u) => u == null ? Number.POSITIVE_INFINITY : i(u.w) - n.edge(u).minlen);
      var c = t(Math.min, l);
      return c === Number.POSITIVE_INFINITY && (c = 0), s.rank = c;
    }
    n.sources().forEach(i);
  }
  function r(n, a) {
    return n.node(a.w).rank - n.node(a.v).rank - n.edge(a).minlen;
  }
  return Mse;
}
var Pse, cGe;
function jvt() {
  if (cGe) return Pse;
  cGe = 1;
  var t = e2().Graph, e = YF().slack;
  Pse = r;
  function r(o) {
    var s = new t({ directed: !1 }), l = o.nodes()[0], c = o.nodeCount();
    s.setNode(l, {});
    for (var u, f; n(s, o) < c; )
      u = a(s, o), f = s.hasNode(u.v) ? e(o, u) : -e(o, u), i(s, o, f);
    return s;
  }
  function n(o, s) {
    function l(c) {
      s.nodeEdges(c).forEach((u) => {
        var f = u.v, h = c === f ? u.w : f;
        !o.hasNode(h) && !e(s, u) && (o.setNode(h, {}), o.setEdge(c, h, {}), l(h));
      });
    }
    return o.nodes().forEach(l), o.nodeCount();
  }
  function a(o, s) {
    return s.edges().reduce((c, u) => {
      let f = Number.POSITIVE_INFINITY;
      return o.hasNode(u.v) !== o.hasNode(u.w) && (f = e(s, u)), f < c[0] ? [f, u] : c;
    }, [Number.POSITIVE_INFINITY, null])[1];
  }
  function i(o, s, l) {
    o.nodes().forEach((c) => s.node(c).rank += l);
  }
  return Pse;
}
var Rse, uGe;
function l2n() {
  if (uGe) return Rse;
  uGe = 1;
  var t = jvt(), e = YF().slack, r = YF().longestPath, n = e2().alg.preorder, a = e2().alg.postorder, i = kl().simplify;
  Rse = o, o.initLowLimValues = u, o.initCutValues = s, o.calcCutValue = c, o.leaveEdge = h, o.enterEdge = p, o.exchangeEdges = g;
  function o(_) {
    _ = i(_), r(_);
    var C = t(_);
    u(C), s(C, _);
    for (var x, S; x = h(C); )
      S = p(C, _, x), g(C, _, x, S);
  }
  function s(_, C) {
    var x = a(_, _.nodes());
    x = x.slice(0, x.length - 1), x.forEach((S) => l(_, C, S));
  }
  function l(_, C, x) {
    var S = _.node(x), A = S.parent;
    _.edge(x, A).cutvalue = c(_, C, x);
  }
  function c(_, C, x) {
    var S = _.node(x), A = S.parent, I = !0, M = C.edge(x, A), B = 0;
    return M || (I = !1, M = C.edge(A, x)), B = M.weight, C.nodeEdges(x).forEach((L) => {
      var N = L.v === x, d = N ? L.w : L.v;
      if (d !== A) {
        var m = N === I, v = C.edge(L).weight;
        if (B += m ? v : -v, b(_, x, d)) {
          var k = _.edge(x, d).cutvalue;
          B += m ? -k : k;
        }
      }
    }), B;
  }
  function u(_, C) {
    arguments.length < 2 && (C = _.nodes()[0]), f(_, {}, 1, C);
  }
  function f(_, C, x, S, A) {
    var I = x, M = _.node(S);
    return C[S] = !0, _.neighbors(S).forEach((B) => {
      Object.hasOwn(C, B) || (x = f(_, C, x, B, S));
    }), M.low = I, M.lim = x++, A ? M.parent = A : delete M.parent, x;
  }
  function h(_) {
    return _.edges().find((C) => _.edge(C).cutvalue < 0);
  }
  function p(_, C, x) {
    var S = x.v, A = x.w;
    C.hasEdge(S, A) || (S = x.w, A = x.v);
    var I = _.node(S), M = _.node(A), B = I, L = !1;
    I.lim > M.lim && (B = M, L = !0);
    var N = C.edges().filter((d) => L === w(_, _.node(d.v), B) && L !== w(_, _.node(d.w), B));
    return N.reduce((d, m) => e(C, m) < e(C, d) ? m : d);
  }
  function g(_, C, x, S) {
    var A = x.v, I = x.w;
    _.removeEdge(A, I), _.setEdge(S.v, S.w, {}), u(_), s(_, C), y(_, C);
  }
  function y(_, C) {
    var x = _.nodes().find((A) => !C.node(A).parent), S = n(_, x);
    S = S.slice(1), S.forEach((A) => {
      var I = _.node(A).parent, M = C.edge(A, I), B = !1;
      M || (M = C.edge(I, A), B = !0), C.node(A).rank = C.node(I).rank + (B ? M.minlen : -M.minlen);
    });
  }
  function b(_, C, x) {
    return _.hasEdge(C, x);
  }
  function w(_, C, x) {
    return x.low <= C.lim && C.lim <= x.lim;
  }
  return Rse;
}
var Ose, dGe;
function c2n() {
  if (dGe) return Ose;
  dGe = 1;
  var t = YF(), e = t.longestPath, r = jvt(), n = l2n();
  Ose = a;
  function a(l) {
    switch (l.graph().ranker) {
      case "network-simplex":
        s(l);
        break;
      case "tight-tree":
        o(l);
        break;
      case "longest-path":
        i(l);
        break;
      default:
        s(l);
    }
  }
  var i = e;
  function o(l) {
    e(l), r(l);
  }
  function s(l) {
    n(l);
  }
  return Ose;
}
var Bse, fGe;
function u2n() {
  if (fGe) return Bse;
  fGe = 1, Bse = t;
  function t(n) {
    let a = r(n);
    n.graph().dummyChains.forEach((i) => {
      let o = n.node(i), s = o.edgeObj, l = e(n, a, s.v, s.w), c = l.path, u = l.lca, f = 0, h = c[f], p = !0;
      for (; i !== s.w; ) {
        if (o = n.node(i), p) {
          for (; (h = c[f]) !== u && n.node(h).maxRank < o.rank; )
            f++;
          h === u && (p = !1);
        }
        if (!p) {
          for (; f < c.length - 1 && n.node(h = c[f + 1]).minRank <= o.rank; )
            f++;
          h = c[f];
        }
        n.setParent(i, h), i = n.successors(i)[0];
      }
    });
  }
  function e(n, a, i, o) {
    let s = [], l = [], c = Math.min(a[i].low, a[o].low), u = Math.max(a[i].lim, a[o].lim), f, h;
    f = i;
    do
      f = n.parent(f), s.push(f);
    while (f && (a[f].low > c || u > a[f].lim));
    for (h = f, f = o; (f = n.parent(f)) !== h; )
      l.push(f);
    return { path: s.concat(l.reverse()), lca: h };
  }
  function r(n) {
    let a = {}, i = 0;
    function o(s) {
      let l = i;
      n.children(s).forEach(o), a[s] = { low: l, lim: i++ };
    }
    return n.children().forEach(o), a;
  }
  return Bse;
}
var Nse, hGe;
function d2n() {
  if (hGe) return Nse;
  hGe = 1;
  let t = kl();
  Nse = {
    run: e,
    cleanup: i
  };
  function e(o) {
    let s = t.addDummyNode(o, "root", {}, "_root"), l = n(o), c = Object.values(l), u = t.applyWithChunking(Math.max, c) - 1, f = 2 * u + 1;
    o.graph().nestingRoot = s, o.edges().forEach((p) => o.edge(p).minlen *= f);
    let h = a(o) + 1;
    o.children().forEach((p) => r(o, s, f, h, u, l, p)), o.graph().nodeRankFactor = f;
  }
  function r(o, s, l, c, u, f, h) {
    let p = o.children(h);
    if (!p.length) {
      h !== s && o.setEdge(s, h, { weight: 0, minlen: l });
      return;
    }
    let g = t.addBorderNode(o, "_bt"), y = t.addBorderNode(o, "_bb"), b = o.node(h);
    o.setParent(g, h), b.borderTop = g, o.setParent(y, h), b.borderBottom = y, p.forEach((w) => {
      r(o, s, l, c, u, f, w);
      let _ = o.node(w), C = _.borderTop ? _.borderTop : w, x = _.borderBottom ? _.borderBottom : w, S = _.borderTop ? c : 2 * c, A = C !== x ? 1 : u - f[h] + 1;
      o.setEdge(g, C, {
        weight: S,
        minlen: A,
        nestingEdge: !0
      }), o.setEdge(x, y, {
        weight: S,
        minlen: A,
        nestingEdge: !0
      });
    }), o.parent(h) || o.setEdge(s, g, { weight: 0, minlen: u + f[h] });
  }
  function n(o) {
    var s = {};
    function l(c, u) {
      var f = o.children(c);
      f && f.length && f.forEach((h) => l(h, u + 1)), s[c] = u;
    }
    return o.children().forEach((c) => l(c, 1)), s;
  }
  function a(o) {
    return o.edges().reduce((s, l) => s + o.edge(l).weight, 0);
  }
  function i(o) {
    var s = o.graph();
    o.removeNode(s.nestingRoot), delete s.nestingRoot, o.edges().forEach((l) => {
      var c = o.edge(l);
      c.nestingEdge && o.removeEdge(l);
    });
  }
  return Nse;
}
var $se, pGe;
function f2n() {
  if (pGe) return $se;
  pGe = 1;
  let t = kl();
  $se = e;
  function e(n) {
    function a(i) {
      let o = n.children(i), s = n.node(i);
      if (o.length && o.forEach(a), Object.hasOwn(s, "minRank")) {
        s.borderLeft = [], s.borderRight = [];
        for (let l = s.minRank, c = s.maxRank + 1; l < c; ++l)
          r(n, "borderLeft", "_bl", i, s, l), r(n, "borderRight", "_br", i, s, l);
      }
    }
    n.children().forEach(a);
  }
  function r(n, a, i, o, s, l) {
    let c = { width: 0, height: 0, rank: l, borderType: a }, u = s[a][l - 1], f = t.addDummyNode(n, "border", c, i);
    s[a][l] = f, n.setParent(f, o), u && n.setEdge(u, f, { weight: 1 });
  }
  return $se;
}
var Dse, mGe;
function h2n() {
  if (mGe) return Dse;
  mGe = 1, Dse = {
    adjust: t,
    undo: e
  };
  function t(l) {
    let c = l.graph().rankdir.toLowerCase();
    (c === "lr" || c === "rl") && r(l);
  }
  function e(l) {
    let c = l.graph().rankdir.toLowerCase();
    (c === "bt" || c === "rl") && a(l), (c === "lr" || c === "rl") && (o(l), r(l));
  }
  function r(l) {
    l.nodes().forEach((c) => n(l.node(c))), l.edges().forEach((c) => n(l.edge(c)));
  }
  function n(l) {
    let c = l.width;
    l.width = l.height, l.height = c;
  }
  function a(l) {
    l.nodes().forEach((c) => i(l.node(c))), l.edges().forEach((c) => {
      let u = l.edge(c);
      u.points.forEach(i), Object.hasOwn(u, "y") && i(u);
    });
  }
  function i(l) {
    l.y = -l.y;
  }
  function o(l) {
    l.nodes().forEach((c) => s(l.node(c))), l.edges().forEach((c) => {
      let u = l.edge(c);
      u.points.forEach(s), Object.hasOwn(u, "x") && s(u);
    });
  }
  function s(l) {
    let c = l.x;
    l.x = l.y, l.y = c;
  }
  return Dse;
}
var Lse, gGe;
function p2n() {
  if (gGe) return Lse;
  gGe = 1;
  let t = kl();
  Lse = e;
  function e(r) {
    let n = {}, a = r.nodes().filter((u) => !r.children(u).length), i = a.map((u) => r.node(u).rank), o = t.applyWithChunking(Math.max, i), s = t.range(o + 1).map(() => []);
    function l(u) {
      if (n[u]) return;
      n[u] = !0;
      let f = r.node(u);
      s[f.rank].push(u), r.successors(u).forEach(l);
    }
    return a.sort((u, f) => r.node(u).rank - r.node(f).rank).forEach(l), s;
  }
  return Lse;
}
var jse, vGe;
function m2n() {
  if (vGe) return jse;
  vGe = 1;
  let t = kl().zipObject;
  jse = e;
  function e(n, a) {
    let i = 0;
    for (let o = 1; o < a.length; ++o)
      i += r(n, a[o - 1], a[o]);
    return i;
  }
  function r(n, a, i) {
    let o = t(i, i.map((h, p) => p)), s = a.flatMap((h) => n.outEdges(h).map((p) => ({ pos: o[p.w], weight: n.edge(p).weight })).sort((p, g) => p.pos - g.pos)), l = 1;
    for (; l < i.length; ) l <<= 1;
    let c = 2 * l - 1;
    l -= 1;
    let u = new Array(c).fill(0), f = 0;
    return s.forEach((h) => {
      let p = h.pos + l;
      u[p] += h.weight;
      let g = 0;
      for (; p > 0; )
        p % 2 && (g += u[p + 1]), p = p - 1 >> 1, u[p] += h.weight;
      f += h.weight * g;
    }), f;
  }
  return jse;
}
var Fse, yGe;
function g2n() {
  if (yGe) return Fse;
  yGe = 1, Fse = t;
  function t(e, r = []) {
    return r.map((n) => {
      let a = e.inEdges(n);
      if (a.length) {
        let i = a.reduce((o, s) => {
          let l = e.edge(s), c = e.node(s.v);
          return {
            sum: o.sum + l.weight * c.order,
            weight: o.weight + l.weight
          };
        }, { sum: 0, weight: 0 });
        return {
          v: n,
          barycenter: i.sum / i.weight,
          weight: i.weight
        };
      } else
        return { v: n };
    });
  }
  return Fse;
}
var zse, bGe;
function v2n() {
  if (bGe) return zse;
  bGe = 1;
  let t = kl();
  zse = e;
  function e(a, i) {
    let o = {};
    a.forEach((l, c) => {
      let u = o[l.v] = {
        indegree: 0,
        in: [],
        out: [],
        vs: [l.v],
        i: c
      };
      l.barycenter !== void 0 && (u.barycenter = l.barycenter, u.weight = l.weight);
    }), i.edges().forEach((l) => {
      let c = o[l.v], u = o[l.w];
      c !== void 0 && u !== void 0 && (u.indegree++, c.out.push(o[l.w]));
    });
    let s = Object.values(o).filter((l) => !l.indegree);
    return r(s);
  }
  function r(a) {
    let i = [];
    function o(l) {
      return (c) => {
        c.merged || (c.barycenter === void 0 || l.barycenter === void 0 || c.barycenter >= l.barycenter) && n(l, c);
      };
    }
    function s(l) {
      return (c) => {
        c.in.push(l), --c.indegree === 0 && a.push(c);
      };
    }
    for (; a.length; ) {
      let l = a.pop();
      i.push(l), l.in.reverse().forEach(o(l)), l.out.forEach(s(l));
    }
    return i.filter((l) => !l.merged).map((l) => t.pick(l, ["vs", "i", "barycenter", "weight"]));
  }
  function n(a, i) {
    let o = 0, s = 0;
    a.weight && (o += a.barycenter * a.weight, s += a.weight), i.weight && (o += i.barycenter * i.weight, s += i.weight), a.vs = i.vs.concat(a.vs), a.barycenter = o / s, a.weight = s, a.i = Math.min(i.i, a.i), i.merged = !0;
  }
  return zse;
}
var Gse, xGe;
function y2n() {
  if (xGe) return Gse;
  xGe = 1;
  let t = kl();
  Gse = e;
  function e(a, i) {
    let o = t.partition(a, (g) => Object.hasOwn(g, "barycenter")), s = o.lhs, l = o.rhs.sort((g, y) => y.i - g.i), c = [], u = 0, f = 0, h = 0;
    s.sort(n(!!i)), h = r(c, l, h), s.forEach((g) => {
      h += g.vs.length, c.push(g.vs), u += g.barycenter * g.weight, f += g.weight, h = r(c, l, h);
    });
    let p = { vs: c.flat(!0) };
    return f && (p.barycenter = u / f, p.weight = f), p;
  }
  function r(a, i, o) {
    let s;
    for (; i.length && (s = i[i.length - 1]).i <= o; )
      i.pop(), a.push(s.vs), o++;
    return o;
  }
  function n(a) {
    return (i, o) => i.barycenter < o.barycenter ? -1 : i.barycenter > o.barycenter ? 1 : a ? o.i - i.i : i.i - o.i;
  }
  return Gse;
}
var Wse, CGe;
function b2n() {
  if (CGe) return Wse;
  CGe = 1;
  let t = g2n(), e = v2n(), r = y2n();
  Wse = n;
  function n(o, s, l, c) {
    let u = o.children(s), f = o.node(s), h = f ? f.borderLeft : void 0, p = f ? f.borderRight : void 0, g = {};
    h && (u = u.filter((_) => _ !== h && _ !== p));
    let y = t(o, u);
    y.forEach((_) => {
      if (o.children(_.v).length) {
        let C = n(o, _.v, l, c);
        g[_.v] = C, Object.hasOwn(C, "barycenter") && i(_, C);
      }
    });
    let b = e(y, l);
    a(b, g);
    let w = r(b, c);
    if (h && (w.vs = [h, w.vs, p].flat(!0), o.predecessors(h).length)) {
      let _ = o.node(o.predecessors(h)[0]), C = o.node(o.predecessors(p)[0]);
      Object.hasOwn(w, "barycenter") || (w.barycenter = 0, w.weight = 0), w.barycenter = (w.barycenter * w.weight + _.order + C.order) / (w.weight + 2), w.weight += 2;
    }
    return w;
  }
  function a(o, s) {
    o.forEach((l) => {
      l.vs = l.vs.flatMap((c) => s[c] ? s[c].vs : c);
    });
  }
  function i(o, s) {
    o.barycenter !== void 0 ? (o.barycenter = (o.barycenter * o.weight + s.barycenter * s.weight) / (o.weight + s.weight), o.weight += s.weight) : (o.barycenter = s.barycenter, o.weight = s.weight);
  }
  return Wse;
}
var Hse, wGe;
function x2n() {
  if (wGe) return Hse;
  wGe = 1;
  let t = e2().Graph, e = kl();
  Hse = r;
  function r(a, i, o) {
    let s = n(a), l = new t({ compound: !0 }).setGraph({ root: s }).setDefaultNodeLabel((c) => a.node(c));
    return a.nodes().forEach((c) => {
      let u = a.node(c), f = a.parent(c);
      (u.rank === i || u.minRank <= i && i <= u.maxRank) && (l.setNode(c), l.setParent(c, f || s), a[o](c).forEach((h) => {
        let p = h.v === c ? h.w : h.v, g = l.edge(p, c), y = g !== void 0 ? g.weight : 0;
        l.setEdge(p, c, { weight: a.edge(h).weight + y });
      }), Object.hasOwn(u, "minRank") && l.setNode(c, {
        borderLeft: u.borderLeft[i],
        borderRight: u.borderRight[i]
      }));
    }), l;
  }
  function n(a) {
    for (var i; a.hasNode(i = e.uniqueId("_root")); ) ;
    return i;
  }
  return Hse;
}
var Use, SGe;
function C2n() {
  if (SGe) return Use;
  SGe = 1, Use = t;
  function t(e, r, n) {
    let a = {}, i;
    n.forEach((o) => {
      let s = e.parent(o), l, c;
      for (; s; ) {
        if (l = e.parent(s), l ? (c = a[l], a[l] = s) : (c = i, i = s), c && c !== s) {
          r.setEdge(c, s);
          return;
        }
        s = l;
      }
    });
  }
  return Use;
}
var Vse, _Ge;
function w2n() {
  if (_Ge) return Vse;
  _Ge = 1;
  let t = p2n(), e = m2n(), r = b2n(), n = x2n(), a = C2n(), i = e2().Graph, o = kl();
  Vse = s;
  function s(f, h) {
    if (h && typeof h.customOrder == "function") {
      h.customOrder(f, s);
      return;
    }
    let p = o.maxRank(f), g = l(f, o.range(1, p + 1), "inEdges"), y = l(f, o.range(p - 1, -1, -1), "outEdges"), b = t(f);
    if (u(f, b), h && h.disableOptimalOrderHeuristic)
      return;
    let w = Number.POSITIVE_INFINITY, _;
    for (let C = 0, x = 0; x < 4; ++C, ++x) {
      c(C % 2 ? g : y, C % 4 >= 2), b = o.buildLayerMatrix(f);
      let S = e(f, b);
      S < w && (x = 0, _ = Object.assign({}, b), w = S);
    }
    u(f, _);
  }
  function l(f, h, p) {
    return h.map(function(g) {
      return n(f, g, p);
    });
  }
  function c(f, h) {
    let p = new i();
    f.forEach(function(g) {
      let y = g.graph().root, b = r(g, y, p, h);
      b.vs.forEach((w, _) => g.node(w).order = _), a(g, p, b.vs);
    });
  }
  function u(f, h) {
    Object.values(h).forEach((p) => p.forEach((g, y) => f.node(g).order = y));
  }
  return Vse;
}
var qse, kGe;
function S2n() {
  if (kGe) return qse;
  kGe = 1;
  let t = e2().Graph, e = kl();
  qse = {
    positionX: p,
    findType1Conflicts: r,
    findType2Conflicts: n,
    addConflict: i,
    hasConflict: o,
    verticalAlignment: s,
    horizontalCompaction: l,
    alignCoordinates: f,
    findSmallestWidthAlignment: u,
    balance: h
  };
  function r(b, w) {
    let _ = {};
    function C(x, S) {
      let A = 0, I = 0, M = x.length, B = S[S.length - 1];
      return S.forEach((L, N) => {
        let d = a(b, L), m = d ? b.node(d).order : M;
        (d || L === B) && (S.slice(I, N + 1).forEach((v) => {
          b.predecessors(v).forEach((k) => {
            let O = b.node(k), G = O.order;
            (G < A || m < G) && !(O.dummy && b.node(v).dummy) && i(_, k, v);
          });
        }), I = N + 1, A = m);
      }), S;
    }
    return w.length && w.reduce(C), _;
  }
  function n(b, w) {
    let _ = {};
    function C(S, A, I, M, B) {
      let L;
      e.range(A, I).forEach((N) => {
        L = S[N], b.node(L).dummy && b.predecessors(L).forEach((d) => {
          let m = b.node(d);
          m.dummy && (m.order < M || m.order > B) && i(_, d, L);
        });
      });
    }
    function x(S, A) {
      let I = -1, M, B = 0;
      return A.forEach((L, N) => {
        if (b.node(L).dummy === "border") {
          let d = b.predecessors(L);
          d.length && (M = b.node(d[0]).order, C(A, B, N, I, M), B = N, I = M);
        }
        C(A, B, A.length, M, S.length);
      }), A;
    }
    return w.length && w.reduce(x), _;
  }
  function a(b, w) {
    if (b.node(w).dummy)
      return b.predecessors(w).find((_) => b.node(_).dummy);
  }
  function i(b, w, _) {
    if (w > _) {
      let x = w;
      w = _, _ = x;
    }
    let C = b[w];
    C || (b[w] = C = {}), C[_] = !0;
  }
  function o(b, w, _) {
    if (w > _) {
      let C = w;
      w = _, _ = C;
    }
    return !!b[w] && Object.hasOwn(b[w], _);
  }
  function s(b, w, _, C) {
    let x = {}, S = {}, A = {};
    return w.forEach((I) => {
      I.forEach((M, B) => {
        x[M] = M, S[M] = M, A[M] = B;
      });
    }), w.forEach((I) => {
      let M = -1;
      I.forEach((B) => {
        let L = C(B);
        if (L.length) {
          L = L.sort((d, m) => A[d] - A[m]);
          let N = (L.length - 1) / 2;
          for (let d = Math.floor(N), m = Math.ceil(N); d <= m; ++d) {
            let v = L[d];
            S[B] === B && M < A[v] && !o(_, B, v) && (S[v] = B, S[B] = x[B] = x[v], M = A[v]);
          }
        }
      });
    }), { root: x, align: S };
  }
  function l(b, w, _, C, x) {
    let S = {}, A = c(b, w, _, x), I = x ? "borderLeft" : "borderRight";
    function M(N, d) {
      let m = A.nodes(), v = m.pop(), k = {};
      for (; v; )
        k[v] ? N(v) : (k[v] = !0, m.push(v), m = m.concat(d(v))), v = m.pop();
    }
    function B(N) {
      S[N] = A.inEdges(N).reduce((d, m) => Math.max(d, S[m.v] + A.edge(m)), 0);
    }
    function L(N) {
      let d = A.outEdges(N).reduce((v, k) => Math.min(v, S[k.w] - A.edge(k)), Number.POSITIVE_INFINITY), m = b.node(N);
      d !== Number.POSITIVE_INFINITY && m.borderType !== I && (S[N] = Math.max(S[N], d));
    }
    return M(B, A.predecessors.bind(A)), M(L, A.successors.bind(A)), Object.keys(C).forEach((N) => S[N] = S[_[N]]), S;
  }
  function c(b, w, _, C) {
    let x = new t(), S = b.graph(), A = g(S.nodesep, S.edgesep, C);
    return w.forEach((I) => {
      let M;
      I.forEach((B) => {
        let L = _[B];
        if (x.setNode(L), M) {
          var N = _[M], d = x.edge(N, L);
          x.setEdge(N, L, Math.max(A(b, B, M), d || 0));
        }
        M = B;
      });
    }), x;
  }
  function u(b, w) {
    return Object.values(w).reduce((_, C) => {
      let x = Number.NEGATIVE_INFINITY, S = Number.POSITIVE_INFINITY;
      Object.entries(C).forEach(([I, M]) => {
        let B = y(b, I) / 2;
        x = Math.max(M + B, x), S = Math.min(M - B, S);
      });
      const A = x - S;
      return A < _[0] && (_ = [A, C]), _;
    }, [Number.POSITIVE_INFINITY, null])[1];
  }
  function f(b, w) {
    let _ = Object.values(w), C = e.applyWithChunking(Math.min, _), x = e.applyWithChunking(Math.max, _);
    ["u", "d"].forEach((S) => {
      ["l", "r"].forEach((A) => {
        let I = S + A, M = b[I];
        if (M === w) return;
        let B = Object.values(M), L = C - e.applyWithChunking(Math.min, B);
        A !== "l" && (L = x - e.applyWithChunking(Math.max, B)), L && (b[I] = e.mapValues(M, (N) => N + L));
      });
    });
  }
  function h(b, w) {
    return e.mapValues(b.ul, (_, C) => {
      if (w)
        return b[w.toLowerCase()][C];
      {
        let x = Object.values(b).map((S) => S[C]).sort((S, A) => S - A);
        return (x[1] + x[2]) / 2;
      }
    });
  }
  function p(b) {
    let w = e.buildLayerMatrix(b), _ = Object.assign(
      r(b, w),
      n(b, w)
    ), C = {}, x;
    ["u", "d"].forEach((A) => {
      x = A === "u" ? w : Object.values(w).reverse(), ["l", "r"].forEach((I) => {
        I === "r" && (x = x.map((N) => Object.values(N).reverse()));
        let M = (A === "u" ? b.predecessors : b.successors).bind(b), B = s(b, x, _, M), L = l(
          b,
          x,
          B.root,
          B.align,
          I === "r"
        );
        I === "r" && (L = e.mapValues(L, (N) => -N)), C[A + I] = L;
      });
    });
    let S = u(b, C);
    return f(C, S), h(C, b.graph().align);
  }
  function g(b, w, _) {
    return (C, x, S) => {
      let A = C.node(x), I = C.node(S), M = 0, B;
      if (M += A.width / 2, Object.hasOwn(A, "labelpos"))
        switch (A.labelpos.toLowerCase()) {
          case "l":
            B = -A.width / 2;
            break;
          case "r":
            B = A.width / 2;
            break;
        }
      if (B && (M += _ ? B : -B), B = 0, M += (A.dummy ? w : b) / 2, M += (I.dummy ? w : b) / 2, M += I.width / 2, Object.hasOwn(I, "labelpos"))
        switch (I.labelpos.toLowerCase()) {
          case "l":
            B = I.width / 2;
            break;
          case "r":
            B = -I.width / 2;
            break;
        }
      return B && (M += _ ? B : -B), B = 0, M;
    };
  }
  function y(b, w) {
    return b.node(w).width;
  }
  return qse;
}
var Kse, AGe;
function _2n() {
  if (AGe) return Kse;
  AGe = 1;
  let t = kl(), e = S2n().positionX;
  Kse = r;
  function r(a) {
    a = t.asNonCompoundGraph(a), n(a), Object.entries(e(a)).forEach(([i, o]) => a.node(i).x = o);
  }
  function n(a) {
    let i = t.buildLayerMatrix(a), o = a.graph().ranksep, s = 0;
    i.forEach((l) => {
      const c = l.reduce((u, f) => {
        const h = a.node(f).height;
        return u > h ? u : h;
      }, 0);
      l.forEach((u) => a.node(u).y = s + c / 2), s += c + o;
    });
  }
  return Kse;
}
var Zse, TGe;
function k2n() {
  if (TGe) return Zse;
  TGe = 1;
  let t = o2n(), e = s2n(), r = c2n(), n = kl().normalizeRanks, a = u2n(), i = kl().removeEmptyRanks, o = d2n(), s = f2n(), l = h2n(), c = w2n(), u = _2n(), f = kl(), h = e2().Graph;
  Zse = p;
  function p(U, Z) {
    let V = Z && Z.debugTiming ? f.time : f.notime;
    V("layout", () => {
      let Y = V("  buildLayoutGraph", () => M(U));
      V("  runLayout", () => g(Y, V, Z)), V("  updateInputGraph", () => y(U, Y));
    });
  }
  function g(U, Z, V) {
    Z("    makeSpaceForEdgeLabels", () => B(U)), Z("    removeSelfEdges", () => H(U)), Z("    acyclic", () => t.run(U)), Z("    nestingGraph.run", () => o.run(U)), Z("    rank", () => r(f.asNonCompoundGraph(U))), Z("    injectEdgeLabelProxies", () => L(U)), Z("    removeEmptyRanks", () => i(U)), Z("    nestingGraph.cleanup", () => o.cleanup(U)), Z("    normalizeRanks", () => n(U)), Z("    assignRankMinMax", () => N(U)), Z("    removeEdgeLabelProxies", () => d(U)), Z("    normalize.run", () => e.run(U)), Z("    parentDummyChains", () => a(U)), Z("    addBorderSegments", () => s(U)), Z("    order", () => c(U, V)), Z("    insertSelfEdges", () => j(U)), Z("    adjustCoordinateSystem", () => l.adjust(U)), Z("    position", () => u(U)), Z("    positionSelfEdges", () => F(U)), Z("    removeBorderNodes", () => G(U)), Z("    normalize.undo", () => e.undo(U)), Z("    fixupEdgeLabelCoords", () => k(U)), Z("    undoCoordinateSystem", () => l.undo(U)), Z("    translateGraph", () => m(U)), Z("    assignNodeIntersects", () => v(U)), Z("    reversePoints", () => O(U)), Z("    acyclic.undo", () => t.undo(U));
  }
  function y(U, Z) {
    U.nodes().forEach((V) => {
      let Y = U.node(V), ge = Z.node(V);
      Y && (Y.x = ge.x, Y.y = ge.y, Y.rank = ge.rank, Z.children(V).length && (Y.width = ge.width, Y.height = ge.height));
    }), U.edges().forEach((V) => {
      let Y = U.edge(V), ge = Z.edge(V);
      Y.points = ge.points, Object.hasOwn(ge, "x") && (Y.x = ge.x, Y.y = ge.y);
    }), U.graph().width = Z.graph().width, U.graph().height = Z.graph().height;
  }
  let b = ["nodesep", "edgesep", "ranksep", "marginx", "marginy"], w = { ranksep: 50, edgesep: 20, nodesep: 50, rankdir: "tb" }, _ = ["acyclicer", "ranker", "rankdir", "align"], C = ["width", "height"], x = { width: 0, height: 0 }, S = ["minlen", "weight", "width", "height", "labeloffset"], A = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
  }, I = ["labelpos"];
  function M(U) {
    let Z = new h({ multigraph: !0, compound: !0 }), V = W(U.graph());
    return Z.setGraph(Object.assign(
      {},
      w,
      z(V, b),
      f.pick(V, _)
    )), U.nodes().forEach((Y) => {
      let ge = W(U.node(Y));
      const ce = z(ge, C);
      Object.keys(x).forEach((ee) => {
        ce[ee] === void 0 && (ce[ee] = x[ee]);
      }), Z.setNode(Y, ce), Z.setParent(Y, U.parent(Y));
    }), U.edges().forEach((Y) => {
      let ge = W(U.edge(Y));
      Z.setEdge(Y, Object.assign(
        {},
        A,
        z(ge, S),
        f.pick(ge, I)
      ));
    }), Z;
  }
  function B(U) {
    let Z = U.graph();
    Z.ranksep /= 2, U.edges().forEach((V) => {
      let Y = U.edge(V);
      Y.minlen *= 2, Y.labelpos.toLowerCase() !== "c" && (Z.rankdir === "TB" || Z.rankdir === "BT" ? Y.width += Y.labeloffset : Y.height += Y.labeloffset);
    });
  }
  function L(U) {
    U.edges().forEach((Z) => {
      let V = U.edge(Z);
      if (V.width && V.height) {
        let Y = U.node(Z.v), ce = { rank: (U.node(Z.w).rank - Y.rank) / 2 + Y.rank, e: Z };
        f.addDummyNode(U, "edge-proxy", ce, "_ep");
      }
    });
  }
  function N(U) {
    let Z = 0;
    U.nodes().forEach((V) => {
      let Y = U.node(V);
      Y.borderTop && (Y.minRank = U.node(Y.borderTop).rank, Y.maxRank = U.node(Y.borderBottom).rank, Z = Math.max(Z, Y.maxRank));
    }), U.graph().maxRank = Z;
  }
  function d(U) {
    U.nodes().forEach((Z) => {
      let V = U.node(Z);
      V.dummy === "edge-proxy" && (U.edge(V.e).labelRank = V.rank, U.removeNode(Z));
    });
  }
  function m(U) {
    let Z = Number.POSITIVE_INFINITY, V = 0, Y = Number.POSITIVE_INFINITY, ge = 0, ce = U.graph(), ee = ce.marginx || 0, Se = ce.marginy || 0;
    function Ce(we) {
      let We = we.x, Fe = we.y, it = we.width, gt = we.height;
      Z = Math.min(Z, We - it / 2), V = Math.max(V, We + it / 2), Y = Math.min(Y, Fe - gt / 2), ge = Math.max(ge, Fe + gt / 2);
    }
    U.nodes().forEach((we) => Ce(U.node(we))), U.edges().forEach((we) => {
      let We = U.edge(we);
      Object.hasOwn(We, "x") && Ce(We);
    }), Z -= ee, Y -= Se, U.nodes().forEach((we) => {
      let We = U.node(we);
      We.x -= Z, We.y -= Y;
    }), U.edges().forEach((we) => {
      let We = U.edge(we);
      We.points.forEach((Fe) => {
        Fe.x -= Z, Fe.y -= Y;
      }), Object.hasOwn(We, "x") && (We.x -= Z), Object.hasOwn(We, "y") && (We.y -= Y);
    }), ce.width = V - Z + ee, ce.height = ge - Y + Se;
  }
  function v(U) {
    U.edges().forEach((Z) => {
      let V = U.edge(Z), Y = U.node(Z.v), ge = U.node(Z.w), ce, ee;
      V.points ? (ce = V.points[0], ee = V.points[V.points.length - 1]) : (V.points = [], ce = ge, ee = Y), V.points.unshift(f.intersectRect(Y, ce)), V.points.push(f.intersectRect(ge, ee));
    });
  }
  function k(U) {
    U.edges().forEach((Z) => {
      let V = U.edge(Z);
      if (Object.hasOwn(V, "x"))
        switch ((V.labelpos === "l" || V.labelpos === "r") && (V.width -= V.labeloffset), V.labelpos) {
          case "l":
            V.x -= V.width / 2 + V.labeloffset;
            break;
          case "r":
            V.x += V.width / 2 + V.labeloffset;
            break;
        }
    });
  }
  function O(U) {
    U.edges().forEach((Z) => {
      let V = U.edge(Z);
      V.reversed && V.points.reverse();
    });
  }
  function G(U) {
    U.nodes().forEach((Z) => {
      if (U.children(Z).length) {
        let V = U.node(Z), Y = U.node(V.borderTop), ge = U.node(V.borderBottom), ce = U.node(V.borderLeft[V.borderLeft.length - 1]), ee = U.node(V.borderRight[V.borderRight.length - 1]);
        V.width = Math.abs(ee.x - ce.x), V.height = Math.abs(ge.y - Y.y), V.x = ce.x + V.width / 2, V.y = Y.y + V.height / 2;
      }
    }), U.nodes().forEach((Z) => {
      U.node(Z).dummy === "border" && U.removeNode(Z);
    });
  }
  function H(U) {
    U.edges().forEach((Z) => {
      if (Z.v === Z.w) {
        var V = U.node(Z.v);
        V.selfEdges || (V.selfEdges = []), V.selfEdges.push({ e: Z, label: U.edge(Z) }), U.removeEdge(Z);
      }
    });
  }
  function j(U) {
    var Z = f.buildLayerMatrix(U);
    Z.forEach((V) => {
      var Y = 0;
      V.forEach((ge, ce) => {
        var ee = U.node(ge);
        ee.order = ce + Y, (ee.selfEdges || []).forEach((Se) => {
          f.addDummyNode(U, "selfedge", {
            width: Se.label.width,
            height: Se.label.height,
            rank: ee.rank,
            order: ce + ++Y,
            e: Se.e,
            label: Se.label
          }, "_se");
        }), delete ee.selfEdges;
      });
    });
  }
  function F(U) {
    U.nodes().forEach((Z) => {
      var V = U.node(Z);
      if (V.dummy === "selfedge") {
        var Y = U.node(V.e.v), ge = Y.x + Y.width / 2, ce = Y.y, ee = V.x - ge, Se = Y.height / 2;
        U.setEdge(V.e, V.label), U.removeNode(Z), V.label.points = [
          { x: ge + 2 * ee / 3, y: ce - Se },
          { x: ge + 5 * ee / 6, y: ce - Se },
          { x: ge + ee, y: ce },
          { x: ge + 5 * ee / 6, y: ce + Se },
          { x: ge + 2 * ee / 3, y: ce + Se }
        ], V.label.x = V.x, V.label.y = V.y;
      }
    });
  }
  function z(U, Z) {
    return f.mapValues(f.pick(U, Z), Number);
  }
  function W(U) {
    var Z = {};
    return U && Object.entries(U).forEach(([V, Y]) => {
      typeof V == "string" && (V = V.toLowerCase()), Z[V] = Y;
    }), Z;
  }
  return Zse;
}
var Jse, EGe;
function A2n() {
  if (EGe) return Jse;
  EGe = 1;
  let t = kl(), e = e2().Graph;
  Jse = {
    debugOrdering: r
  };
  function r(n) {
    let a = t.buildLayerMatrix(n), i = new e({ compound: !0, multigraph: !0 }).setGraph({});
    return n.nodes().forEach((o) => {
      i.setNode(o, { label: o }), i.setParent(o, "layer" + n.node(o).rank);
    }), n.edges().forEach((o) => i.setEdge(o.v, o.w, {}, o.name)), a.forEach((o, s) => {
      let l = "layer" + s;
      i.setNode(l, { rank: "same" }), o.reduce((c, u) => (i.setEdge(c, u, { style: "invis" }), u));
    }), i;
  }
  return Jse;
}
var Yse, IGe;
function T2n() {
  return IGe || (IGe = 1, Yse = "1.1.4"), Yse;
}
var Xse, MGe;
function E2n() {
  return MGe || (MGe = 1, Xse = {
    graphlib: e2(),
    layout: k2n(),
    debug: A2n(),
    util: {
      time: kl().time,
      notime: kl().notime
    },
    version: T2n()
  }), Xse;
}
var I2n = E2n();
const PGe = /* @__PURE__ */ Gi(I2n), M2n = (t, e) => {
  const r = (i) => {
    var o;
    return (o = i.measured) != null && o.height ? i.measured.height + 25 : 0;
  }, n = (i) => {
    var o;
    return (o = i.measured) != null && o.width ? i.measured.width + 50 : 0;
  }, a = new PGe.graphlib.Graph().setDefaultEdgeLabel(() => ({}));
  return a.setGraph({ rankdir: "TB" }), e.forEach((i) => a.setEdge(i.source, i.target)), t.forEach(
    (i) => a.setNode(i.id, {
      ...i,
      width: n(i),
      height: r(i)
    })
  ), PGe.layout(a), {
    nodes: t.map((i) => {
      const o = a.node(i.id), s = o.x - n(i) / 2, l = o.y - r(i) / 2;
      return { ...i, position: { x: s, y: l } };
    }),
    edges: e
  };
}, P2n = ({
  initialNodes: t,
  initialEdges: e,
  nodeTypes: r,
  edgeTypes: n,
  panelChildren: a
}) => {
  const [i, o, s] = v1n(t), [l, c, u] = y1n(e), f = x1n({ includeHiddenNodes: !1 }), { fitView: h } = nU(), [p, g] = Te.useState(!1);
  return Ut(() => {
    if (!p && f) {
      const y = M2n(i, l);
      o(y.nodes), c(y.edges), g(!0);
    }
  }, [f]), Ut(() => {
    p && window.requestAnimationFrame(() => {
      h();
    });
  }, [p]), /* @__PURE__ */ R.jsxs(
    g1n,
    {
      nodes: i,
      edges: l,
      fitView: !0,
      nodeTypes: r,
      edgeTypes: n,
      onNodesChange: s,
      onEdgesChange: u,
      children: [
        /* @__PURE__ */ R.jsx(k1n, {}),
        /* @__PURE__ */ R.jsx(R1n, {}),
        a && /* @__PURE__ */ R.jsx(AP, { position: "top-right", children: a })
      ]
    }
  );
}, Fvt = (t) => /* @__PURE__ */ R.jsx(Mvt, { children: /* @__PURE__ */ R.jsx(P2n, { ...t }) }), zvt = ({ items: t }) => /* @__PURE__ */ R.jsx(
  is,
  {
    padding: "space40",
    backgroundColor: "colorBackgroundBody",
    display: "flex",
    flexDirection: "column",
    rowGap: "space20",
    children: t.map(({ label: e, color: r }) => /* @__PURE__ */ R.jsxs(ar.Box, { display: "flex", alignItems: "center", columnGap: "space20", children: [
      /* @__PURE__ */ R.jsx(
        is,
        {
          height: "20px",
          width: "20px",
          borderColor: "colorBorder",
          style: { backgroundColor: r }
        }
      ),
      e
    ] }, e))
  }
), R2n = ({ data: t }) => {
  const e = t.label || "";
  return /* @__PURE__ */ R.jsx("div", { className: "bg-yellow-100 p-4 shadow-xl max-w-[200px] text-gray-700 transform rotate-1", children: e });
}, i3 = ({ item: t, controls: e }) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", rowGap: "space40", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  e && /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", flexDirection: "row-reverse", children: e }),
  /* @__PURE__ */ R.jsx(ar.Box, { flexGrow: 1, overflow: "auto", children: /* @__PURE__ */ R.jsx(
    i2t.CodeBlock,
    {
      language: "javascript",
      wrapLines: !0,
      code: JSON.stringify(t, null, 2)
    }
  ) })
] }), Gbe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DataTableIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DataTableIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M3 5.5A1.5 1.5 0 014.5 4h11A1.5 1.5 0 0117 5.5v9a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 013 14.5v-9zm1 2.389V11h4V7.889H4zm5 0V11h7V7.889H9zm7-1H4V5.5a.5.5 0 01.5-.5h11a.5.5 0 01.5.5v1.389zM4 14.5V12h4v3H4.5a.5.5 0 01-.5-.5zM9 12v3h6.5a.5.5 0 00.5-.5V12H9z" })));
});
Gbe.displayName = "DataTableIcon";
const Wbe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ProductSwitcherIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ProductSwitcherIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M1.4 1.4H9V9H1.4V1.4zm1.2 1.2v5.2h5.2V2.6H2.6zM11 1.4h7.6V9H11V1.4zm1.2 1.2v5.2h5.2V2.6h-5.2zM1.4 11H9v7.6H1.4V11zm1.2 1.2v5.2h5.2v-5.2H2.6zM11 11h7.6v7.6H11V11zm1.2 1.2v5.2h5.2v-5.2h-5.2z" })));
});
Wbe.displayName = "ProductSwitcherIcon";
const o3 = ({
  items: t,
  resourceRoute: e
}) => {
  const r = W5();
  return /* @__PURE__ */ R.jsxs(ar.Box, { children: [
    /* @__PURE__ */ R.jsx(Kh, {}),
    /* @__PURE__ */ R.jsxs(G5r, { defaultValue: "grid", children: [
      /* @__PURE__ */ R.jsx(ar.Box, { display: "flex", flexDirection: "row-reverse", children: /* @__PURE__ */ R.jsxs(eot, { children: [
        /* @__PURE__ */ R.jsx(ade, { value: "grid", children: /* @__PURE__ */ R.jsx(
          Wbe,
          {
            decorative: !1,
            title: "Grid",
            size: "sizeIcon10"
          }
        ) }),
        /* @__PURE__ */ R.jsx(ade, { value: "table", children: /* @__PURE__ */ R.jsx(Gbe, { decorative: !1, title: "Table" }) })
      ] }) }),
      /* @__PURE__ */ R.jsx(ide, { value: "grid", children: /* @__PURE__ */ R.jsx(Alr, { children: t.map((n) => /* @__PURE__ */ R.jsx(
        klr,
        {
          item: n,
          onClick: () => r(e(n.id))
        },
        n.id
      )) }) }),
      /* @__PURE__ */ R.jsx(ide, { value: "table", children: /* @__PURE__ */ R.jsxs(qc.Table, { children: [
        /* @__PURE__ */ R.jsx(qc.THead, { children: /* @__PURE__ */ R.jsxs(qc.Tr, { children: [
          /* @__PURE__ */ R.jsx(qc.Th, { children: "Name" }),
          /* @__PURE__ */ R.jsx(qc.Th, { children: "Description" })
        ] }) }),
        /* @__PURE__ */ R.jsx(qc.TBody, { children: t.map((n) => /* @__PURE__ */ R.jsxs(qc.Tr, { children: [
          /* @__PURE__ */ R.jsx(qc.Td, { children: /* @__PURE__ */ R.jsx(s2t.Anchor, { href: e(n.id), children: n.name }) }),
          /* @__PURE__ */ R.jsx(qc.Td, { children: n.description })
        ] }, n.id)) })
      ] }) })
    ] })
  ] });
};
var Qse = {};
const Gvt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronDoubleLeftIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronDoubleLeftIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.749 5.244c.309.3.333.773.071 1.1l-.071.079L6.07 10l3.679 3.577c.309.3.333.774.071 1.1l-.071.079a.876.876 0 01-1.131.07l-.081-.07-4.286-4.167a.816.816 0 01-.071-1.1l.071-.078 4.286-4.167a.875.875 0 011.212 0zm6 0c.309.3.333.773.071 1.1l-.071.079L12.07 10l3.679 3.577c.309.3.333.774.071 1.1l-.071.079a.876.876 0 01-1.131.07l-.081-.07-4.286-4.167a.816.816 0 01-.071-1.1l.071-.078 4.286-4.167a.875.875 0 011.212 0z" })));
});
Gvt.displayName = "ChevronDoubleLeftIcon";
const Wvt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronDoubleRightIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronDoubleRightIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.382 5.175l.081.07L15.75 9.41c.309.3.333.773.071 1.1l-.071.078-4.286 4.167a.875.875 0 01-1.212 0 .816.816 0 01-.071-1.1l.071-.079L13.93 10l-3.679-3.577a.816.816 0 01-.071-1.1l.071-.079a.876.876 0 011.131-.07zm-6 0l.081.07L9.75 9.41c.309.3.333.773.071 1.1l-.071.078-4.286 4.167a.875.875 0 01-1.212 0 .816.816 0 01-.071-1.1l.071-.079L7.93 10 4.251 6.423a.816.816 0 01-.071-1.1l.071-.079a.876.876 0 011.131-.07z" })));
});
Wvt.displayName = "ChevronDoubleRightIcon";
const Hvt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ChevronDisclosureIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ChevronDisclosureIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M9.707 6.293a1 1 0 00-1.497 1.32l.083.094L10.585 10l-2.292 2.293a1 1 0 00-.083 1.32l.083.094a1 1 0 001.32.083l.094-.083 3-3a1 1 0 00.083-1.32l-.083-.094-3-3z" })));
});
Hvt.displayName = "ChevronDisclosureIcon";
var Sg = P.createContext({}), Uvt = ({ element: t, children: e }) => P.createElement(ht, { element: t, backgroundColor: "colorBackgroundBody", borderRadius: "borderRadius20", boxShadow: "shadowElevation10", left: 10, paddingX: "space60", paddingY: "space30", position: "fixed", top: 10, transform: "translateY(-150%)", transition: "transform 0.1s", zIndex: "zIndex90", display: "flex", columnGap: "space60", _focusWithin: { transform: "translateY(0%)" } }, e);
Uvt.displayName = "SkipLinkContainer";
var Vvt = ({ element: t = "SIDEBAR_SKIPLINKS", mainContentSkipLinkID: e, sidebarNavigationSkipLinkID: r, topbarSkipLinkID: n, i18nMainContentSkipLinkText: a = "Skip to content", i18nNavigationSkipLinkText: i = "Skip to navigation", i18nTopbarSkipLinkText: o = "Skip to topbar" }) => P.createElement(Uvt, { element: t }, P.createElement(m7, { element: `${t}_LINK`, href: `#${e}` }, a), P.createElement(m7, { element: `${t}_LINK`, href: `#${r}` }, i), P.createElement(m7, { element: `${t}_LINK`, href: `#${n}` }, o));
Vvt.displayName = "SkipLinks";
var qvt = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "aside", overflow: "visible", display: "flex", flexDirection: "column", ref: e, boxShadow: "shadowElevationRightInverse05", backgroundColor: "colorBackgroundInverse", zIndex: "zIndex50", position: "fixed", top: 0, left: 0, bottom: 0 }));
qvt.displayName = "StyledSidebar";
var O2n = Zh(qvt), Hbe = { mass: 0.3, tension: 288, friction: 20 }, B2n = (t, e, r) => ({ opacity: 1, width: t ? r : e, transform: "translateX(0%)", config: Hbe }), N2n = (t, e) => ({ opacity: t ? 0 : 1, width: e, transform: t ? "translateX(-100%)" : "translateX(0%)", config: Hbe }), $2n = (t) => ({ opacity: t ? 0 : 1, width: "100%", transform: t ? "translateX(-100%)" : "translateX(0%)", config: Hbe }), Kvt = P.forwardRef(({ collapsed: t = !1, variant: e = "default", element: r = "SIDEBAR", mainContentSkipLinkID: n, sidebarNavigationSkipLinkID: a, topbarSkipLinkID: i, i18nMainContentSkipLinkText: o, i18nNavigationSkipLinkText: s, i18nTopbarSkipLinkText: l, children: c, ...u }, f) => {
  let h = Jr(), { breakpointIndex: p } = O8(), g = Md(), y = p === 0, b = e === "compact", w;
  y ? w = $2n(t) : b ? w = B2n(t, g.sizes.sizeSidebar, g.sizes.sizeSidebarCompact) : w = N2n(t, g.sizes.sizeSidebar);
  let _ = aM(w);
  return P.createElement(Sg.Provider, { value: { collapsed: t, variant: e, sidebarId: h, sidebarNavigationSkipLinkID: a } }, P.createElement(Vvt, { element: `${r}_SKIPLINKS`, mainContentSkipLinkID: n, sidebarNavigationSkipLinkID: a, topbarSkipLinkID: i, i18nMainContentSkipLinkText: o, i18nNavigationSkipLinkText: s, i18nTopbarSkipLinkText: l }), P.createElement(O2n, { ...Xt(u), ref: f, element: r, width: ["100%", b && t ? "sizeSidebarCompact" : "sizeSidebar"], style: _, id: h }, c));
});
Kvt.displayName = "Sidebar";
var Zvt = P.forwardRef(({ element: t = "SIDEBAR_BODY", children: e, ...r }, n) => P.createElement(ht, { ...Xt(r), as: "div", element: t, ref: n, maxHeight: "100%", overflow: "hidden", flexGrow: 1 }, e));
Zvt.displayName = "SidebarBody";
var Jvt = P.forwardRef((t, e) => P.createElement(ht, { ...t, as: "div", position: "relative", ref: e }));
Jvt.displayName = "StyledContentWrapper";
var D2n = Zh(Jvt), Yvt = P.forwardRef(({ collapsed: t = !1, variant: e = "default", element: r = "SIDEBAR_PUSH_CONTENT_WRAPPER", children: n, ...a }, i) => {
  let o = Md(), s = e === "compact", { breakpointIndex: l } = O8(), c = aM({ marginLeft: t ? s ? o.sizes.sizeSidebarCompact : "0rem" : o.sizes.sizeSidebar, config: { mass: 0.3, tension: 288, friction: 20 } });
  return P.createElement(D2n, { ...Xt(a), ref: i, element: r, style: l === void 0 || l === 0 ? void 0 : c, marginLeft: ["space0", o.sizes.sizeSidebar] }, n);
});
Yvt.displayName = "SidebarPushContentWrapper";
var Xvt = P.forwardRef(({ variant: t = "default", element: e = "SIDEBAR_OVERLAY_CONTENT_WRAPPER", children: r, ...n }, a) => {
  let { breakpointIndex: i } = O8();
  return i !== 0 && t === "compact" ? P.createElement(ht, { display: "flex", justifyContent: "flex-start" }, P.createElement(ht, { role: "presentation", width: "sizeSidebarCompact", height: "100%", minHeight: "1px", flexShrink: 0 }), P.createElement(ht, { ...Xt(n), element: e, as: "div", ref: a, width: "100%" }, r)) : P.createElement(ht, { ...Xt(n), element: e, as: "div", ref: a }, r);
});
Xvt.displayName = "SidebarOverlayContentWrapper";
var Qvt = P.forwardRef(({ element: t = "SIDEBAR_HEADER", children: e, ...r }, n) => P.createElement(ht, { ...Xt(r), element: t, ref: n, paddingX: "space60", minHeight: "sizeTopbar", boxShadow: "shadowElevationBottomInverse05", zIndex: "zIndex40", display: "flex", alignItems: "center", justifyContent: "flex-start", flexShrink: 0, columnGap: "space50", overflow: "hidden" }, e));
Qvt.displayName = "SidebarHeader";
var eyt = P.forwardRef(({ element: t = "SIDEBAR_HEADER_LABEL", children: e, ...r }, n) => {
  let { collapsed: a } = P.useContext(Sg);
  return P.createElement(ht, { ref: n, ...Xt(r), opacity: a ? "0" : "1", element: t, fontSize: "fontSize30", fontWeight: "fontWeightSemibold", lineHeight: "lineHeight30", letterSpacing: "-.02em", color: "colorTextInverse", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", margin: "space0" }, e);
});
eyt.displayName = "SidebarHeaderLabel";
var tyt = P.forwardRef(({ element: t = "SIDEBAR_HEADER_ICON_BUTTON", ...e }, r) => P.createElement(Zs, { ...e, size: "icon", variant: "inverse", element: t, ref: r }));
tyt.displayName = "SidebarHeaderIconButton";
var ryt = P.forwardRef(({ element: t = "SIDEBAR_FOOTER", ...e }, r) => P.createElement(ht, { ...Xt(e), flexShrink: 0, position: "relative", padding: "space60", transition: "padding-right 100ms ease", ref: r, element: t }));
ryt.displayName = "SidebarFooter";
var nyt = P.forwardRef(({ i18nExpandLabel: t, i18nCollapseLabel: e, element: r = "SIDEBAR_COLLAPSE_BUTTON", ...n }, a) => {
  let { collapsed: i, sidebarId: o } = P.useContext(Sg);
  return P.createElement(ht, { display: "flex", justifyContent: "flex-end" }, P.createElement(Zs, { ref: a, size: "icon", variant: "inverse", element: r, ...n, tabIndex: 0, "aria-expanded": !i, "aria-controls": o }, i ? P.createElement(P.Fragment, null, P.createElement(Wvt, { size: "sizeIcon20", decorative: !0, element: `${r}_EXPAND` }), P.createElement(Ul, null, t)) : P.createElement(P.Fragment, null, P.createElement(Gvt, { size: "sizeIcon20", decorative: !0, element: `${r}_COLLAPSE` }), P.createElement(Ul, null, e))));
});
nyt.displayName = "SidebarCollapseButton";
var ayt = P.createContext({}), L2n = ds.nav(({ theme: t }) => {
  let { colorBackgroundInverse: e, colorBackgroundInverseStrongerElevation: r, colorBackgroundInverseStrongElevation: n } = t.backgroundColors;
  return us({ overflowScrolling: "touch", background: `linear-gradient(${e} 33%, rgba(20,28,44, 0)),
    linear-gradient(rgba(20,28,44, 0), ${e} 66%) 0 100%,
    radial-gradient(farthest-side at 50% 100%, rgba(57, 71, 98, 0.5), rgba(0,0,0,0)) 0 100%`, backgroundRepeat: "no-repeat", backgroundSize: "100% 15px, 100% 15px, 100% 5px, 100% 5px", backgroundAttachment: "local, local, scroll, scroll", "::-webkit-scrollbar": { width: "6px" }, "::-webkit-scrollbar-track": { marginTop: "8px", background: e }, "::-webkit-scrollbar-thumb": { background: n, borderRadius: "10px" }, "::-webkit-scrollbar-thumb:hover": { background: r } });
}), iyt = P.forwardRef(({ element: t = "SIDEBAR_NAVIGATION", hideItemsOnCollapse: e = !1, hierarchical: r = !1, children: n, ...a }, i) => {
  let { collapsed: o, sidebarNavigationSkipLinkID: s } = P.useContext(Sg);
  return P.createElement(ayt.Provider, { value: { hideItemsOnCollapse: e, hierarchical: r } }, P.createElement(ht, { ...Xt(a), as: L2n, id: s, "aria-label": a["aria-label"], element: t, ref: i, transition: "opacity 150ms ease", maxHeight: "100%", overflowY: "auto", overflowX: "hidden", paddingY: "space50", paddingLeft: "space60", paddingRight: o ? "space40" : "space60", flexGrow: 1 }, n));
});
iyt.displayName = "SidebarNavigation";
var p8 = P.createContext({}), oyt = P.forwardRef(({ children: t, element: e = "SIDEBAR_NAVIGATION_DISCLOSURE", state: r, ...n }, a) => {
  let { collapsed: i } = P.useContext(Sg), { disclosure: o } = P.useContext(p8), s = { disclosure: r || tpe({ animated: !1, ...n }), nested: o != null };
  return P.createElement(p8.Provider, { value: s }, P.createElement(ht, { ...Xt(n), element: e, ref: a, display: i ? "none" : "block", marginBottom: "space30" }, t));
});
oyt.displayName = "SidebarNavigationDisclosure";
var syt = P.forwardRef(({ element: t = "SIDEBAR_NAVIGATION_DISCLOSURE_HEADING_WRAPPER", ...e }, r) => P.createElement(ht, { ...Xt(e), element: t, ref: r, display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "space30" }));
syt.displayName = "SidebarNavigationDisclosureHeadingWrapper";
var Ube = { fontStyle: "normal", fontWeight: "fontWeightNormal", fontSize: "fontSize30", lineHeight: "lineHeight20", color: "colorTextInverseWeak", transition: "all 120ms ease", borderRadius: "borderRadius20", cursor: "pointer", display: "flex", flexGrow: 1, columnGap: "space20", outline: "none", paddingY: "space30", position: "relative", textDecoration: "none", _focus: { boxShadow: "shadowFocusInverseInset" } }, j2n = { ...Ube, paddingY: "space20", fontSize: "fontSize20" }, lyt = { fontWeight: "fontWeightSemibold", color: "colorTextInverse" }, F2n = { ...Ube, background: "none", border: "none", outline: "none", overflow: "hidden", paddingLeft: "space30", paddingRight: "space30", marginBottom: "space30", columnGap: "space30", _hover: { textDecoration: "underline" } }, z2n = { paddingLeft: "space70" }, G2n = { paddingY: "space20", flexGrow: 1, width: "100%", fontSize: "fontSize20", marginBottom: "space20", paddingLeft: "space80" }, W2n = { color: "colorTextIconInverse", _hover: { background: "none", color: "colorTextInverse" } }, H2n = { ...lyt, backgroundColor: "colorBackgroundInverseStrong", color: "colorTextInverse" }, U2n = ({ nested: t, selected: e }) => {
  let r = {};
  return t ? r = j2n : r = Ube, e && (r = { ...r, ...lyt }), r;
}, V2n = ({ icon: t, selected: e }) => P.useMemo(() => t ? t && P.isValidElement(t) && !e ? P.cloneElement(t, { color: "colorTextIconInverse" }) : t : null, [t, e]), cyt = P.forwardRef(({ children: t, element: e = "SIDEBAR_NAVIGATION_DISCLOSURE_HEADING", selected: r, icon: n, ...a }, i) => {
  let { collapsed: o, variant: s } = P.useContext(Sg), [l, c] = P.useState(!1), { nested: u } = P.useContext(p8), f = a["aria-expanded"], h = Md(), p = s === "compact", [g, y] = P.useState(p ? !f : !0), b = P.useRef(0);
  P.useEffect(() => {
    clearTimeout(b.current), p && (b.current = setTimeout(() => {
      y(!o);
    }, 120));
  }, [o, p]);
  let w = U2n({ nested: u, selected: r }), _ = V2n({ icon: n, selected: r });
  return P.createElement(ht, { ...Xt(a), ref: i, element: e, onMouseEnter: () => c(!0), onMouseLeave: () => c(!1), ...w }, P.createElement(ht, { as: "span", element: `${e}_EXPAND_ICON`, display: "flex", color: "colorTextIconInverse", height: "sizeIcon20", width: "sizeIcon20", transition: "transform 150ms ease", transform: `
          ${l ? `translateX(${h.space.space10})` : "translateX(0)"}
          ${f ? "rotate(90deg)" : "rotate(0deg)"}` }, P.createElement(Hvt, { color: "inherit", decorative: !0, size: "sizeIcon20" })), _, P.createElement(ht, { as: "span", display: "block", marginLeft: "space20", transition: "all 120ms ease", float: g ? "none" : "left", opacity: g ? 1 : 0, whiteSpace: g ? "normal" : "nowrap" }, o ? null : t));
});
cyt.displayName = "StyledDisclosureHeading";
var uyt = P.forwardRef((t, e) => {
  let { disclosure: r } = P.useContext(p8);
  return P.createElement(Ror, { ...r, ref: e, ...t, as: cyt });
});
uyt.displayName = "SidebarNavigationDisclosureHeading";
var dyt = P.forwardRef(({ children: t, element: e = "SIDEBAR_NAVIGATION_DISCLOSURE_CONTENT", ...r }, n) => {
  let { disclosure: a } = P.useContext(p8);
  return P.createElement(Yir, { ...a, ...Xt(r), as: ht, element: e, paddingLeft: "space70", color: "colorTextInverseWeak", marginTop: "space20", ref: n }, t);
});
dyt.displayName = "SidebarNavigationDisclosureContent";
var fyt = P.forwardRef(({ element: t = "SIDEBAR_NAVIGATION_ITEM", selected: e, children: r, icon: n, ...a }, i) => {
  let { collapsed: o, variant: s } = P.useContext(Sg), { disclosure: l } = P.useContext(p8), { hideItemsOnCollapse: c, hierarchical: u } = P.useContext(ayt), f = s === "compact", [h, p] = P.useState(f ? !o : !0), g = P.useRef(0);
  P.useEffect(() => {
    clearTimeout(g.current), f && (g.current = setTimeout(() => {
      p(!o);
    }, 120));
  }, [o, f]);
  let y = l != null, b = P.useMemo(() => ({ ...F2n, ...u && z2n, ...y && G2n, ...o && W2n, ...e && H2n, display: o && c ? "none" : "flex", width: o ? "36px" : "100%" }), [y, e, o, c, u]);
  return P.createElement(ht, { ...Xt(a), ...a.href ? T8(a.href) : {}, ref: i, element: t, as: "a", "aria-current": e ? "page" : void 0, ...b }, n && P.createElement(ht, { as: "span", color: e ? "colorTextInverse" : "colorTextIconInverse" }, n), P.createElement(ht, { as: "span", display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "space20", transition: "all 120ms ease", flexGrow: 1, float: h ? "none" : "left", opacity: h ? 1 : 0, whiteSpace: h ? "normal" : "nowrap" }, o ? null : r));
});
fyt.displayName = "SidebarNavigationItem";
var hyt = P.forwardRef(({ element: t = "SIDEBAR_NAVIGATION_SEPARATOR", ...e }, r) => {
  let { collapsed: n } = P.useContext(Sg);
  return P.createElement(ht, { ...Xt(e), display: n ? "none" : "block", "aria-orientation": "horizontal", element: t, marginY: "space50", as: "hr", borderWidth: "borderWidth0", borderColor: "colorBorderInverseWeaker", borderStyle: "solid", borderBottomWidth: "borderWidth10", ref: r });
});
hyt.displayName = "SidebarNavigationSeparator";
var pyt = { ...fge, paddingX: "space20", paddingY: "space10", boxShadow: "shadowBorderInverseNewWeaker", backgroundColor: "colorBackgroundInverseStrong", color: "colorTextInverseNew" }, q2n = { ...pyt, boxShadow: "shadowBorderBottomInverseNewWeaker", cursor: "pointer", _hover: { top: "1px", boxShadow: "none" }, _focus: { top: "1px", boxShadow: "shadowFocusInverse" } }, myt = P.forwardRef(({ children: t, as: e, element: r = "SIDEBAR_BETA_BADGE", onClick: n, ...a }, i) => {
  let o = dge(t), s = e === "button" ? q2n : pyt, l = e === "button" ? n : void 0;
  return P.createElement(ht, { ...Xt(a), ...s, as: e, ref: i, element: r, onClick: l }, o);
});
myt.displayName = "SidebarBetaBadge";
const K2n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Sidebar: Kvt,
  SidebarBetaBadge: myt,
  SidebarBody: Zvt,
  SidebarCollapseButton: nyt,
  SidebarContext: Sg,
  SidebarFooter: ryt,
  SidebarHeader: Qvt,
  SidebarHeaderIconButton: tyt,
  SidebarHeaderLabel: eyt,
  SidebarNavigation: iyt,
  SidebarNavigationDisclosure: oyt,
  SidebarNavigationDisclosureContent: dyt,
  SidebarNavigationDisclosureHeading: uyt,
  SidebarNavigationDisclosureHeadingWrapper: syt,
  SidebarNavigationItem: fyt,
  SidebarNavigationSeparator: hyt,
  SidebarOverlayContentWrapper: Xvt,
  SidebarPushContentWrapper: Yvt,
  useSidebarNavigationDisclosureState: tpe
}, Symbol.toStringTag, { value: "Module" })), Z2n = /* @__PURE__ */ aa(K2n);
var RGe;
function J2n() {
  return RGe || (RGe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Z2n;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(Qse)), Qse;
}
var ec = /* @__PURE__ */ J2n();
const gyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `BuildIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[BuildIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M6.392 3.716a5.38 5.38 0 016.887.272l.022.017.052.046.129.123a246.353 246.353 0 011.369 1.36 1.167 1.167 0 01.26 1.254l-.003.006a.5.5 0 00.822.538l.004-.005a.833.833 0 011.182 0l.705.707.001.001a1.168 1.168 0 010 1.654l-2.362 2.362-.001.001a1.167 1.167 0 01-1.654 0l-.708-.708a.838.838 0 01-.182-.91.833.833 0 01.181-.271.504.504 0 00-.548-.82.503.503 0 00-.164.109l-.918.918a.499.499 0 01-.025.028l-6.471 6.47a1.837 1.837 0 11-2.6-2.598l6.444-6.444a.508.508 0 01.026-.027l.892-.892c.048-.048.051-.073.052-.078.002-.01.003-.044-.025-.113-.064-.154-.22-.348-.447-.575a3.162 3.162 0 00-2.382-.927.836.836 0 01-.822-.553.833.833 0 01.283-.945zm2.803 5.145l1.184 1.184-6.116 6.116a.837.837 0 01-1.185-1.184l6.117-6.116zM7.418 4.225a4.158 4.158 0 012.603 1.21c.233.233.516.546.662.898.077.184.126.404.092.64-.036.244-.154.46-.335.641l-.539.539 1.184 1.184.592-.592a1.504 1.504 0 012.421.418l.826-.825a1.506 1.506 0 01-.787-.91 1.5 1.5 0 01.044-1.01v.001l.002-.006-.002.005a.167.167 0 00-.037-.178 250.558 250.558 0 00-1.357-1.347 6.993 6.993 0 00-.11-.105l-.004-.004a.515.515 0 01-.043-.034 4.38 4.38 0 00-5.212-.525zm9.107 3.926l-2.604 2.603.593.593a.167.167 0 00.236 0l.001-.002 2.364-2.364h.001a.168.168 0 00.037-.183.168.168 0 00-.037-.054l-.001-.002-.59-.591zm-3.203-3.417z", clipRule: "evenodd" })));
});
gyt.displayName = "BuildIcon";
const n1e = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `CodeIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[CodeIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3.576 3.5H16.43c.404.001.797.15 1.094.423.298.275.474.656.475 1.063v10.02c0 .409-.177.793-.476 1.069a1.624 1.624 0 01-1.098.423H3.5c-.386 0-.763-.14-1.046-.403A1.388 1.388 0 012 15.075V4.992c0-.408.177-.792.476-1.068a1.626 1.626 0 011.1-.424zm12.852 1H3.576a.624.624 0 00-.42.159.457.457 0 00-.155.334v10.082a.39.39 0 00.132.286.544.544 0 00.368.137h12.922a.624.624 0 00.422-.158.458.458 0 00.154-.334V4.989a.455.455 0 00-.153-.331.62.62 0 00-.418-.158zm0 0z", clipRule: "evenodd" }), P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.646 7.647a.5.5 0 01.707 0l2 1.998a.5.5 0 010 .707l-2 2a.5.5 0 01-.707-.707l1.647-1.646-1.646-1.645a.5.5 0 010-.707zm-5.292 0a.5.5 0 010 .707L5.706 9.999l1.647 1.646a.5.5 0 01-.708.707l-2-2a.5.5 0 010-.707l2-1.999a.5.5 0 01.708 0zm3.87-.094a.5.5 0 01.223.67l-2 4a.5.5 0 11-.894-.447l2-4a.5.5 0 01.67-.223z", clipRule: "evenodd" })));
});
n1e.displayName = "CodeIcon";
const vyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `DataArrayIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[DataArrayIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, height: "100%", width: "100%", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M5.233 5A.233.233 0 005 5.233v9.534a.233.233 0 00.233.233h1.833a.5.5 0 010 1H5.233A1.233 1.233 0 014 14.767V5.233A1.233 1.233 0 015.233 4h1.833a.5.5 0 010 1H5.233zm7.2-.5a.5.5 0 01.5-.5h1.833A1.233 1.233 0 0116 5.233v9.534A1.233 1.233 0 0114.766 16h-1.833a.5.5 0 010-1h1.833a.234.234 0 00.233-.233V5.233A.234.234 0 0014.766 5h-1.833a.5.5 0 01-.5-.5z" })));
});
vyt.displayName = "DataArrayIcon";
const yyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `FileIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[FileIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, width: "100%", height: "100%", viewBox: "0 0 20 20", fill: "none", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 17h-13a.5.5 0 01-.5-.5v-13a.5.5 0 01.5-.5h9.879a.5.5 0 01.353.146l3.122 3.122A.5.5 0 0117 6.62v9.88a.5.5 0 01-.5.5zM2 3.5A1.5 1.5 0 013.5 2h9.879a1.5 1.5 0 011.06.44l3.122 3.12A1.5 1.5 0 0118 6.622V16.5a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 012 16.5v-13zM5.5 6a.5.5 0 000 1h6a.5.5 0 000-1h-6zM5 10a.5.5 0 01.5-.5h9a.5.5 0 010 1h-9A.5.5 0 015 10zm.5 3a.5.5 0 000 1h8a.5.5 0 000-1h-8z" })));
});
yyt.displayName = "FileIcon";
const Vbe = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ProductDebuggerIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ProductDebuggerIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.466 11.678a.533.533 0 100-1.064h-1.067a6.35 6.35 0 00-.272-1.835 3.176 3.176 0 011.328-.292h.01a.533.533 0 10.003-1.064h-.013c-.594 0-1.182.124-1.725.365l-.017-.036-.008-.016a6.426 6.426 0 00-2.278-2.507c1.202-.861 1.344-1.86 1.344-3.697a.533.533 0 00-1.066 0c0 1.905-.126 2.458-1.386 3.136a6.33 6.33 0 00-4.67.012c-1.282-.683-1.41-1.232-1.41-3.148a.533.533 0 00-1.067 0c0 1.85.145 2.85 1.371 3.715a6.427 6.427 0 00-2.248 2.489l-.008.016-.017.036a4.244 4.244 0 00-1.725-.365h-.013a.533.533 0 10.013 1.064c.459 0 .912.1 1.328.292a6.35 6.35 0 00-.272 1.835H2.534a.533.533 0 100 1.064h1.163c.144.857.463 1.676.938 2.405a3.196 3.196 0 01-2.098.788h-.003a.533.533 0 100 1.065h.003a4.261 4.261 0 002.753-1.014 6.374 6.374 0 009.42 0 4.261 4.261 0 002.753 1.014h.003a.533.533 0 100-1.065h-.003c-.772 0-1.517-.28-2.098-.788a6.32 6.32 0 00.938-2.405h1.163zM10 5.292c.69 0 1.375.135 2.014.397a.53.53 0 00.206.092 5.35 5.35 0 012.036 1.64H5.744A5.326 5.326 0 0110 5.29zm-5.333 5.322c0-.733.153-1.458.449-2.13h4.35v7.425a5.333 5.333 0 01-4.799-5.295zm5.866 5.295V8.485h4.351a5.306 5.306 0 01-.28 4.818 5.327 5.327 0 01-4.07 2.606z", clipRule: "evenodd" })));
});
Vbe.displayName = "ProductDebuggerIcon";
const byt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ProductFlowIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ProductFlowIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.813 11.978a.5.5 0 10.707.707l2.104-2.103h1.932a2.25 2.25 0 100-1H11.79l-2.27-2.27a.5.5 0 10-.707.707l1.563 1.563H6.444a2.25 2.25 0 100 1h3.766l-1.397 1.396zM3 10.082a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0zm11.5 0a1.25 1.25 0 112.5 0 1.25 1.25 0 01-2.5 0z", clipRule: "evenodd" })));
});
byt.displayName = "ProductFlowIcon";
const xyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `TemplateMessageIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[TemplateMessageIcon]: Missing a title for non-decorative icon.");
  return P.createElement(gi, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M3 4.518c0-.28.224-.506.5-.506h9.842c.276 0 .5.227.5.506V8.3c0 .28.224.506.5.506s.5-.227.5-.506V4.518A1.51 1.51 0 0 0 13.342 3H3.5C2.672 3 2 3.68 2 4.518v5.167a1.51 1.51 0 0 0 1.5 1.518h.579c.276 0 .5-.227.5-.506a.503.503 0 0 0-.5-.506H3.5a.503.503 0 0 1-.5-.506V4.518Zm3.158 6.392c0-.28.224-.506.5-.506h.984c.276 0 .5-.227.5-.506a.503.503 0 0 0-.5-.506h-.984c-.829 0-1.5.68-1.5 1.518v.916c0 .28.224.506.5.506s.5-.226.5-.506v-.916Zm4.437-1.518c-.276 0-.5.226-.5.506s.224.506.5.506h1.968c.276 0 .5-.227.5-.506a.503.503 0 0 0-.5-.506h-1.968Zm4.92 0c-.275 0-.5.226-.5.506s.225.506.5.506h.985c.276 0 .5.226.5.506v.873c0 .28.224.507.5.507s.5-.227.5-.506v-.874a1.51 1.51 0 0 0-1.5-1.518h-.984ZM18 14.404a.503.503 0 0 0-.5-.506c-.276 0-.5.227-.5.506v.874c0 .28-.224.506-.5.506h-.905c-.276 0-.5.226-.5.506s.224.506.5.506h.905c.828 0 1.5-.68 1.5-1.518v-.874Zm-11.842.17a.503.503 0 0 0-.5-.505c-.276 0-.5.226-.5.506v.916c0 .72.577 1.305 1.29 1.305.276 0 .5-.227.5-.506a.503.503 0 0 0-.5-.506.291.291 0 0 1-.29-.293v-.916Zm5.816 1.21c-.277 0-.5.226-.5.506s.223.506.5.506h1.974c.275 0 .5-.227.5-.506a.503.503 0 0 0-.5-.506h-1.975ZM6.053 7.1a.794.794 0 0 1-.79.8.794.794 0 0 1-.79-.8c0-.44.354-.799.79-.799.436 0 .79.358.79.8Zm2.368.8c.436 0 .79-.358.79-.8a.794.794 0 0 0-.79-.799.794.794 0 0 0-.79.8c0 .44.354.798.79.798Zm3.947-.8a.794.794 0 0 1-.79.8.794.794 0 0 1-.788-.8c0-.44.353-.799.789-.799.436 0 .79.358.79.8Zm-4.342 9.482c.276 0 .5.226.5.506v.704l.23-.14.987-.599a.497.497 0 0 1 .686.174.51.51 0 0 1-.172.694l-.987.6-.608.369a.75.75 0 0 1-1.136-.651v-1.151c0-.28.224-.506.5-.506Z", clipRule: "evenodd" })));
});
xyt.displayName = "TemplateMessageIcon";
var ele = {}, Cyt = P.forwardRef(({ element: t = "TOPBAR", id: e, children: r, ...n }, a) => P.createElement(ht, { ...Xt(n), id: e, ref: a, element: t, width: "100%", minHeight: "sizeTopbar", backgroundColor: "colorBackgroundWeakElevation", boxShadow: "shadowElevationBottom05", paddingX: "space70", position: "sticky", top: "0", display: "flex", justifyContent: "space-between", alignItems: "center", columnGap: "space70", zIndex: "zIndex40" }, r));
Cyt.displayName = "Topbar";
var wyt = P.forwardRef(({ children: t, element: e = "TOPBAR_ACTIONS", justify: r = "end", display: n = "flex", ...a }, i) => {
  let o = { start: "flex-start", end: "flex-end", center: "center" };
  return P.createElement(ht, { ...Xt(a), display: n, justifyContent: o[r], flexShrink: r === "start" ? null : 0, flexWrap: "wrap", flexGrow: 1, columnGap: "space50", element: e, alignItems: "center", ref: i }, t);
});
wyt.displayName = "TopbarActions";
const Y2n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Topbar: Cyt,
  TopbarActions: wyt
}, Symbol.toStringTag, { value: "Module" })), X2n = /* @__PURE__ */ aa(Y2n);
var OGe;
function Q2n() {
  return OGe || (OGe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = X2n;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(ele)), ele;
}
var ehn = /* @__PURE__ */ Q2n();
const thn = [
  {
    label: "Applications",
    href: rs.applicationIndex(),
    icon: /* @__PURE__ */ R.jsx(Gbe, { decorative: !0 })
  },
  {
    label: "Assistants",
    href: rs.assistantIndex(),
    icon: /* @__PURE__ */ R.jsx(hP, { decorative: !0 })
  },
  {
    label: "Knowledge Sources",
    href: rs.knowledgeSourceIndex(),
    icon: /* @__PURE__ */ R.jsx(xbe, { decorative: !0 })
  },
  {
    label: "Tools",
    href: rs.toolIndex(),
    icon: /* @__PURE__ */ R.jsx(gyt, { decorative: !0 })
  },
  {
    label: "Workflows",
    href: rs.workflowIndex(),
    icon: /* @__PURE__ */ R.jsx(byt, { decorative: !0 })
  },
  {
    label: "Blocks",
    href: rs.blockIndex(),
    icon: /* @__PURE__ */ R.jsx(Wbe, { decorative: !0 })
  },
  {
    label: "Pages",
    href: rs.pageIndex(),
    icon: /* @__PURE__ */ R.jsx(yyt, { decorative: !0 })
  },
  {
    label: "Components",
    href: rs.componentIndex(),
    icon: /* @__PURE__ */ R.jsx(vyt, { decorative: !0 })
  },
  {
    label: "Forms",
    href: rs.formIndex(),
    icon: /* @__PURE__ */ R.jsx(xyt, { decorative: !0 })
  }
], rhn = [
  {
    label: "Debugger",
    href: rs.conversationDebuggerHome(),
    icon: /* @__PURE__ */ R.jsx(Vbe, { decorative: !0 })
  }
], BGe = ({ items: t }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: t.map((e, r) => /* @__PURE__ */ R.jsx(
  ec.SidebarNavigationItem,
  {
    href: e.href,
    icon: e.icon,
    selected: window.location.pathname === e.href || window.location.pathname.startsWith(e.href),
    children: e.label
  },
  r
)) }), Y3n = ({ margin: t = !0 }) => {
  const [e, r] = Te.useState(!1);
  return /* @__PURE__ */ R.jsxs(ar.Box, { children: [
    /* @__PURE__ */ R.jsxs(
      ec.Sidebar,
      {
        sidebarNavigationSkipLinkID: "",
        topbarSkipLinkID: "",
        mainContentSkipLinkID: "",
        collapsed: e,
        variant: "compact",
        children: [
          /* @__PURE__ */ R.jsxs(ec.SidebarHeader, { children: [
            /* @__PURE__ */ R.jsx(ec.SidebarHeaderIconButton, { as: "a", href: "#", children: /* @__PURE__ */ R.jsx(
              V3e,
              {
                size: "sizeIcon20",
                decorative: !1,
                title: "Go to Console homepage"
              }
            ) }),
            /* @__PURE__ */ R.jsx(ec.SidebarHeaderLabel, { children: "Wise Owl" })
          ] }),
          /* @__PURE__ */ R.jsx(ec.SidebarBody, { children: /* @__PURE__ */ R.jsxs(ec.SidebarNavigation, { "aria-label": "main", children: [
            /* @__PURE__ */ R.jsxs(ec.SidebarNavigationDisclosure, { visible: !0, children: [
              /* @__PURE__ */ R.jsx(ec.SidebarNavigationDisclosureHeadingWrapper, { children: /* @__PURE__ */ R.jsx(
                ec.SidebarNavigationDisclosureHeading,
                {
                  icon: /* @__PURE__ */ R.jsx(n1e, { decorative: !0 }),
                  selected: !0,
                  children: "Develop"
                }
              ) }),
              /* @__PURE__ */ R.jsx(ec.SidebarNavigationDisclosureContent, { children: /* @__PURE__ */ R.jsx(BGe, { items: thn }) })
            ] }),
            /* @__PURE__ */ R.jsxs(ec.SidebarNavigationDisclosure, { visible: !0, children: [
              /* @__PURE__ */ R.jsx(ec.SidebarNavigationDisclosureHeadingWrapper, { children: /* @__PURE__ */ R.jsx(
                ec.SidebarNavigationDisclosureHeading,
                {
                  icon: /* @__PURE__ */ R.jsx(n1e, { decorative: !0 }),
                  selected: !0,
                  children: "Monitor"
                }
              ) }),
              /* @__PURE__ */ R.jsx(ec.SidebarNavigationDisclosureContent, { children: /* @__PURE__ */ R.jsx(BGe, { items: rhn }) })
            ] })
          ] }) }),
          /* @__PURE__ */ R.jsx(ec.SidebarFooter, { children: /* @__PURE__ */ R.jsx(
            ec.SidebarCollapseButton,
            {
              i18nCollapseLabel: "Close sidebar",
              i18nExpandLabel: "Open sidebar",
              onClick: () => r(!e)
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ R.jsx(ec.SidebarPushContentWrapper, { collapsed: e, variant: "compact", children: /* @__PURE__ */ R.jsxs(ar.Box, { height: "100vh", display: "flex", flexDirection: "column", children: [
      /* @__PURE__ */ R.jsx(ehn.Topbar, { id: "topbar", children: /* @__PURE__ */ R.jsx(R.Fragment, {}) }),
      /* @__PURE__ */ R.jsx(
        ar.Box,
        {
          flexGrow: 1,
          overflowY: "scroll",
          padding: "space40",
          display: "flex",
          justifyContent: "center",
          children: /* @__PURE__ */ R.jsx("div", { className: `h-full w-full ${t && "lg:w-3/4"}`, children: /* @__PURE__ */ R.jsx(H5t, {}) })
        }
      )
    ] }) })
  ] });
}, nhn = ({
  applicationId: t,
  conversationId: e,
  onClickDebug: r
}) => /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
  /* @__PURE__ */ R.jsx(
    Tbe,
    {
      applicationId: t,
      user: { firstName: "Nick", lastName: "Paz" },
      conversationId: e,
      systemContext: {},
      displayName: "Wise Owl",
      surveyId: "SV_0H8qU82qFh47298"
    }
  ),
  /* @__PURE__ */ R.jsx(ar.Box, { position: "absolute", right: "60px", bottom: "60px", children: /* @__PURE__ */ R.jsx(
    is,
    {
      padding: "space60",
      borderRadius: "borderRadiusCircle",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      onClick: r,
      children: /* @__PURE__ */ R.jsx(
        Vbe,
        {
          decorative: !1,
          title: "Debug",
          size: "sizeIcon40"
        }
      )
    }
  ) })
] }), X3n = () => {
  const { conversationId: t, applicationId: e } = eu(), r = W5();
  if (!t || !e)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Application ID or Conversation ID" });
  const n = () => {
    r(rs.conversationDebugger(t));
  };
  return /* @__PURE__ */ R.jsx(
    nhn,
    {
      applicationId: e,
      conversationId: t,
      onClickDebug: n
    }
  );
}, ahn = ({
  applicationId: t,
  handleEvent: e
}) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsx(ar.Box, { flexGrow: 1, width: "800px", alignSelf: "center", children: /* @__PURE__ */ R.jsx(
    Tbe,
    {
      applicationId: t,
      user: { firstName: "Nick", lastName: "Paz" },
      conversationId: void 0,
      handleEvent: e,
      systemContext: {},
      displayName: "Wise Owl",
      surveyId: "SV_0H8qU82qFh47298"
    }
  ) })
] }), Q3n = () => {
  const t = W5(), { applicationId: e } = eu();
  if (!e)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Application ID" });
  const r = (n) => {
    n.type === l0.CREATE_CONVERSATION && t(
      rs.applicationConversationView(
        e,
        n.data.conversationId
      )
    );
  };
  return /* @__PURE__ */ R.jsx(
    ahn,
    {
      applicationId: e,
      handleEvent: r
    }
  );
}, ihn = ({
  applications: t
}) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.applicationResource
  }
), ebn = () => {
  const { requestTransformer: t } = Ja(), e = tKe({
    requestTransformer: t
  });
  return e.isLoading ? /* @__PURE__ */ R.jsx(Ts, {}) : e.isError || !e.data ? /* @__PURE__ */ R.jsx($a, { error: e.error }) : /* @__PURE__ */ R.jsx(
    ihn,
    {
      applications: e.data.applications
    }
  );
}, ohn = ({
  application: t
}) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(
        zi.Button,
        {
          variant: "primary",
          href: rs.applicationHomeView(t.id),
          as: "a",
          children: "View"
        },
        "view-button"
      )
    ]
  }
), tbn = () => {
  const { applicationId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Application ID" });
  const r = WI({
    applicationId: t,
    requestTransformer: e
  });
  return r.isLoading ? /* @__PURE__ */ R.jsx(Ts, {}) : r.isError || !r.data ? /* @__PURE__ */ R.jsx($a, { error: r.error }) : /* @__PURE__ */ R.jsx(
    ohn,
    {
      application: r.data.application
    }
  );
}, shn = ({
  assistants: t
}) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.assistantResource
  }
), rbn = () => {
  const { requestTransformer: t } = Ja(), e = KMt({
    requestTransformer: t
  });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { assistants: r } = e.data;
  return /* @__PURE__ */ R.jsx(shn, { assistants: r });
}, lhn = ({
  assistant: t,
  onClickView: e
}) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(as, { variant: "primary", onClick: e, children: "View" }, "view-button")
    ]
  }
), nbn = () => {
  const t = W5(), { requestTransformer: e } = Ja(), { assistantId: r } = eu();
  if (!r)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Assistant ID" });
  const n = eKe({
    assistantId: r,
    requestTransformer: e
  });
  if (n.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (n.isError || !n.data)
    return /* @__PURE__ */ R.jsx($a, { error: n.error });
  const { assistant: a } = n.data, i = () => {
    t(rs.assistantView(r));
  };
  return /* @__PURE__ */ R.jsx(lhn, { assistant: a, onClickView: i });
}, chn = ({
  assistantEdges: t,
  assistantNodes: e,
  nodeTypes: r,
  legendItems: n
}) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsx(
    ar.Box,
    {
      flexGrow: 1,
      borderColor: "colorBorderWeaker",
      borderWidth: "borderWidth10",
      borderRadius: "borderRadius20",
      children: /* @__PURE__ */ R.jsx(
        Fvt,
        {
          initialNodes: e,
          initialEdges: t,
          nodeTypes: r,
          panelChildren: [/* @__PURE__ */ R.jsx(zvt, { items: n }, "legend")]
        }
      )
    }
  )
] }), abn = () => {
  const { assistantId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Assistant ID" });
  const r = eKe({
    assistantId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { assistant: n } = r.data, a = [], i = [], o = (c) => {
    const u = {
      id: c.id,
      type: "assistant",
      data: { label: c.name },
      position: { x: 0, y: 0 }
    };
    return a.push(u), c.assistants.forEach((f) => {
      const h = o(f);
      i.push({
        id: `e${u.id}-${h}`,
        source: u.id,
        target: h,
        animated: !0
      });
    }), c.knowledgeSources.forEach((f) => {
      const h = {
        id: `${u.id}-${f.id}`,
        type: "knowledgeSource",
        data: { label: f.name },
        position: { x: 0, y: 0 }
      }, p = {
        id: `e${u.id}-${h.id}`,
        source: u.id,
        target: h.id,
        animated: !0
      };
      a.push(h), i.push(p);
    }), c.toolInstances.forEach((f) => {
      const h = {
        id: `${u.id}-${f.tool.id}`,
        type: "tool",
        data: { label: f.tool.name },
        position: { x: 0, y: 0 }
      }, p = {
        id: `e${u.id}-${h.id}`,
        source: u.id,
        target: h.id,
        animated: !0
      };
      a.push(h), i.push(p);
    }), c.workflows.forEach((f) => {
      const h = {
        id: `${u.id}-${f.id}`,
        type: "workflow",
        data: { label: f.name },
        position: { x: 0, y: 0 }
      }, p = {
        id: `e${u.id}-${h.id}`,
        source: u.id,
        target: h.id,
        animated: !0
      };
      a.push(h), i.push(p);
    }), c.id;
  };
  o(n);
  const s = {
    assistant: mm("lightblue"),
    tool: mm("lightpink"),
    workflow: mm("lightgreen"),
    knowledgeSource: mm("yellow")
  }, l = [
    { label: "Assistant", color: "lightblue" },
    { label: "Tool", color: "lightpink" },
    { label: "Workflow", color: "lightgreen" },
    {
      label: "Knowledge Source",
      color: "yellow"
    }
  ];
  return /* @__PURE__ */ R.jsx(
    chn,
    {
      assistantNodes: a,
      assistantEdges: i,
      nodeTypes: s,
      legendItems: l
    }
  );
}, uhn = ({ blocks: t }) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.blockResource
  }
), ibn = () => {
  const { requestTransformer: t } = Ja(), e = JMt({ requestTransformer: t });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { blocks: r } = e.data;
  return /* @__PURE__ */ R.jsx(uhn, { blocks: r });
}, dhn = ({ block: t }) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(
        as,
        {
          variant: "primary",
          href: rs.blockView(t.id),
          as: "a",
          children: "View"
        },
        "view-button"
      )
    ]
  }
), obn = () => {
  const { blockId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Block ID" });
  const r = rKe({
    blockId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { block: n } = r.data;
  return /* @__PURE__ */ R.jsx(dhn, { block: n });
}, fhn = ({ block: t }) => /* @__PURE__ */ R.jsxs(_r, { height: "100%", display: "flex", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsx(
    _r,
    {
      flexGrow: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ R.jsx(
        _r,
        {
          minWidth: "50%",
          borderColor: "colorBorderWeaker",
          borderWidth: "borderWidth10",
          borderRadius: "borderRadius20",
          padding: "space40",
          children: /* @__PURE__ */ R.jsx(gP, { block: { id: t.id, values: t.exampleValues, displayPersistence: "default" } })
        }
      )
    }
  )
] }), sbn = () => {
  const { blockId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Page ID" });
  const r = rKe({
    blockId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { block: n } = r.data;
  return /* @__PURE__ */ R.jsx(fhn, { block: n });
}, hhn = ({
  components: t
}) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.componentResource
  }
), lbn = () => {
  const { requestTransformer: t } = Ja(), e = QMt({
    requestTransformer: t
  });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { components: r } = e.data;
  return /* @__PURE__ */ R.jsx(hhn, { components: r });
}, phn = ({
  component: t
}) => /* @__PURE__ */ R.jsx(i3, { item: t }), cbn = () => {
  const { componentId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Component ID" });
  const r = XMt({
    componentId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { component: n } = r.data;
  return /* @__PURE__ */ R.jsx(phn, { component: n });
}, mhn = ({
  knowledgeSources: t
}) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.knowledgeSourceResource
  }
), ubn = () => {
  const { requestTransformer: t } = Ja(), e = sPt({
    requestTransformer: t
  });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { knowledgeSources: r } = e.data;
  return /* @__PURE__ */ R.jsx(mhn, { knowledgeSources: r });
}, ghn = ({
  knowledgeSource: t
}) => /* @__PURE__ */ R.jsx(i3, { item: t }), dbn = () => {
  const { knowledgeSourceId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing KnowledgeSource ID" });
  const r = lPt({
    knowledgeSourceId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { knowledgeSource: n } = r.data;
  return /* @__PURE__ */ R.jsx(ghn, { knowledgeSource: n });
}, vhn = ({ pages: t }) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.pageResource
  }
), fbn = () => {
  const { requestTransformer: t } = Ja(), e = YMt({ requestTransformer: t });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { pages: r } = e.data;
  return /* @__PURE__ */ R.jsx(vhn, { pages: r });
}, yhn = ({ page: t }) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(
        as,
        {
          variant: "primary",
          href: rs.pageView(t.id),
          as: "a",
          children: "View"
        },
        "view-button"
      )
    ]
  }
), hbn = () => {
  const { pageId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Page ID" });
  const r = Yqe({
    pageId: t,
    requestTransformer: e
  });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { page: n } = r.data;
  return /* @__PURE__ */ R.jsx(yhn, { page: n });
}, bhn = ({ pageId: t }) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsx(ar.Box, { flexGrow: 1, children: /* @__PURE__ */ R.jsx(rln, { pageId: t }) })
] }), pbn = () => {
  const { pageId: t } = eu();
  return t ? /* @__PURE__ */ R.jsx(bhn, { pageId: t }) : /* @__PURE__ */ R.jsx($a, { error: "Missing Page ID" });
}, xhn = ({ tools: t }) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.toolResource
  }
), mbn = () => {
  const { requestTransformer: t } = Ja(), e = Xqe({ requestTransformer: t });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { tools: r } = e.data;
  return /* @__PURE__ */ R.jsx(xhn, { tools: r });
}, Chn = ({
  tool: t,
  onClickView: e
}) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(as, { variant: "primary", onClick: e, children: "View" }, "view-button")
    ]
  }
), gbn = () => {
  const t = W5(), { requestTransformer: e } = Ja(), { toolId: r } = eu();
  if (!r)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Tool ID" });
  const n = Qqe({
    toolId: r,
    requestTransformer: e
  });
  if (n.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (n.isError || !n.data)
    return /* @__PURE__ */ R.jsx($a, { error: n.error });
  const { tool: a } = n.data, i = () => {
    t(rs.toolView(r));
  };
  return /* @__PURE__ */ R.jsx(Chn, { tool: a, onClickView: i });
};
function whn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function NGe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $Ge(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? NGe(Object(r), !0).forEach(function(n) {
      whn(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : NGe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Shn(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), a, i;
  for (i = 0; i < n.length; i++) a = n[i], !(e.indexOf(a) >= 0) && (r[a] = t[a]);
  return r;
}
function _hn(t, e) {
  if (t == null) return {};
  var r = Shn(t, e), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    for (a = 0; a < i.length; a++) n = i[a], !(e.indexOf(n) >= 0) && (!Object.prototype.propertyIsEnumerable.call(t, n) || (r[n] = t[n]));
  }
  return r;
}
function khn(t, e) {
  return Ahn(t) || Thn(t, e) || Ehn(t, e) || Ihn();
}
function Ahn(t) {
  if (Array.isArray(t)) return t;
}
function Thn(t, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(t)))) {
    var r = [], n = !0, a = !1, i = void 0;
    try {
      for (var o = t[Symbol.iterator](), s; !(n = (s = o.next()).done) && (r.push(s.value), !(e && r.length === e)); n = !0) ;
    } catch (l) {
      a = !0, i = l;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (a) throw i;
      }
    }
    return r;
  }
}
function Ehn(t, e) {
  if (t) {
    if (typeof t == "string") return DGe(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return DGe(t, e);
  }
}
function DGe(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function Ihn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Mhn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function LGe(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(t, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jGe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? LGe(Object(r), !0).forEach(function(n) {
      Mhn(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : LGe(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Phn() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return function(n) {
    return e.reduceRight(function(a, i) {
      return i(a);
    }, n);
  };
}
function v_(t) {
  return function e() {
    for (var r = this, n = arguments.length, a = new Array(n), i = 0; i < n; i++) a[i] = arguments[i];
    return a.length >= t.length ? t.apply(this, a) : function() {
      for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++) s[l] = arguments[l];
      return e.apply(r, [].concat(a, s));
    };
  };
}
function XF(t) {
  return {}.toString.call(t).includes("Object");
}
function Rhn(t) {
  return !Object.keys(t).length;
}
function kI(t) {
  return typeof t == "function";
}
function Ohn(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Bhn(t, e) {
  return XF(e) || Wv("changeType"), Object.keys(e).some(function(r) {
    return !Ohn(t, r);
  }) && Wv("changeField"), e;
}
function Nhn(t) {
  kI(t) || Wv("selectorType");
}
function $hn(t) {
  kI(t) || XF(t) || Wv("handlerType"), XF(t) && Object.values(t).some(function(e) {
    return !kI(e);
  }) && Wv("handlersType");
}
function Dhn(t) {
  t || Wv("initialIsRequired"), XF(t) || Wv("initialType"), Rhn(t) && Wv("initialContent");
}
function Lhn(t, e) {
  throw new Error(t[e] || t.default);
}
var jhn = { initialIsRequired: "initial state is required", initialType: "initial state should be an object", initialContent: "initial state shouldn't be an empty object", handlerType: "handler should be an object or a function", handlersType: "all handlers should be a functions", selectorType: "selector should be a function", changeType: "provided value of changes should be an object", changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state', default: "an unknown error accured in `state-local` package" }, Wv = v_(Lhn)(jhn), RN = { changes: Bhn, selector: Nhn, handler: $hn, initial: Dhn };
function Fhn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  RN.initial(t), RN.handler(e);
  var r = { current: t }, n = v_(Whn)(r, e), a = v_(Ghn)(r), i = v_(RN.changes)(t), o = v_(zhn)(r);
  function s() {
    var c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(u) {
      return u;
    };
    return RN.selector(c), c(r.current);
  }
  function l(c) {
    Phn(n, a, i, o)(c);
  }
  return [s, l];
}
function zhn(t, e) {
  return kI(e) ? e(t.current) : e;
}
function Ghn(t, e) {
  return t.current = jGe(jGe({}, t.current), e), e;
}
function Whn(t, e, r) {
  return kI(e) ? e(t.current) : Object.keys(r).forEach(function(n) {
    var a;
    return (a = e[n]) === null || a === void 0 ? void 0 : a.call(e, t.current[n]);
  }), r;
}
var Hhn = { create: Fhn }, Uhn = Hhn, Vhn = { paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.36.1/min/vs" } }, qhn = Vhn;
function Khn(t) {
  return function e() {
    for (var r = this, n = arguments.length, a = new Array(n), i = 0; i < n; i++) a[i] = arguments[i];
    return a.length >= t.length ? t.apply(this, a) : function() {
      for (var o = arguments.length, s = new Array(o), l = 0; l < o; l++) s[l] = arguments[l];
      return e.apply(r, [].concat(a, s));
    };
  };
}
var Zhn = Khn;
function Jhn(t) {
  return {}.toString.call(t).includes("Object");
}
var Yhn = Jhn;
function Xhn(t) {
  return t || FGe("configIsRequired"), Yhn(t) || FGe("configType"), t.urls ? (Qhn(), { paths: { vs: t.urls.monacoBase } }) : t;
}
function Qhn() {
  console.warn(Syt.deprecation);
}
function epn(t, e) {
  throw new Error(t[e] || t.default);
}
var Syt = { configIsRequired: "the configuration object is required", configType: "the configuration object should be an object", default: "an unknown error accured in `@monaco-editor/loader` package", deprecation: `Deprecation warning!
    You are using deprecated way of configuration.

    Instead of using
      monaco.config({ urls: { monacoBase: '...' } })
    use
      monaco.config({ paths: { vs: '...' } })

    For more please check the link https://github.com/suren-atoyan/monaco-loader#config
  ` }, FGe = Zhn(epn)(Syt), tpn = { config: Xhn }, rpn = tpn, npn = function() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) e[r] = arguments[r];
  return function(n) {
    return e.reduceRight(function(a, i) {
      return i(a);
    }, n);
  };
}, apn = npn;
function _yt(t, e) {
  return Object.keys(e).forEach(function(r) {
    e[r] instanceof Object && t[r] && Object.assign(e[r], _yt(t[r], e[r]));
  }), $Ge($Ge({}, t), e);
}
var ipn = _yt, opn = { type: "cancelation", msg: "operation is manually canceled" };
function spn(t) {
  var e = !1, r = new Promise(function(n, a) {
    t.then(function(i) {
      return e ? a(opn) : n(i);
    }), t.catch(a);
  });
  return r.cancel = function() {
    return e = !0;
  }, r;
}
var tle = spn, lpn = Uhn.create({ config: qhn, isInitialized: !1, resolve: null, reject: null, monaco: null }), kyt = khn(lpn, 2), TP = kyt[0], oU = kyt[1];
function cpn(t) {
  var e = rpn.config(t), r = e.monaco, n = _hn(e, ["monaco"]);
  oU(function(a) {
    return { config: ipn(a.config, n), monaco: r };
  });
}
function upn() {
  var t = TP(function(e) {
    var r = e.monaco, n = e.isInitialized, a = e.resolve;
    return { monaco: r, isInitialized: n, resolve: a };
  });
  if (!t.isInitialized) {
    if (oU({ isInitialized: !0 }), t.monaco) return t.resolve(t.monaco), tle(rle);
    if (window.monaco && window.monaco.editor) return Ayt(window.monaco), t.resolve(window.monaco), tle(rle);
    apn(dpn, hpn)(ppn);
  }
  return tle(rle);
}
function dpn(t) {
  return document.body.appendChild(t);
}
function fpn(t) {
  var e = document.createElement("script");
  return t && (e.src = t), e;
}
function hpn(t) {
  var e = TP(function(n) {
    var a = n.config, i = n.reject;
    return { config: a, reject: i };
  }), r = fpn("".concat(e.config.paths.vs, "/loader.js"));
  return r.onload = function() {
    return t();
  }, r.onerror = e.reject, r;
}
function ppn() {
  var t = TP(function(r) {
    var n = r.config, a = r.resolve, i = r.reject;
    return { config: n, resolve: a, reject: i };
  }), e = window.require;
  e.config(t.config), e(["vs/editor/editor.main"], function(r) {
    Ayt(r), t.resolve(r);
  }, function(r) {
    t.reject(r);
  });
}
function Ayt(t) {
  TP().monaco || oU({ monaco: t });
}
function mpn() {
  return TP(function(t) {
    var e = t.monaco;
    return e;
  });
}
var rle = new Promise(function(t, e) {
  return oU({ resolve: t, reject: e });
}), gpn = { config: cpn, init: upn, __getMonacoInstance: mpn }, Tyt = gpn, vpn = { wrapper: { display: "flex", position: "relative", textAlign: "initial" }, fullWidth: { width: "100%" }, hide: { display: "none" } }, nle = vpn, ypn = { container: { display: "flex", height: "100%", width: "100%", justifyContent: "center", alignItems: "center" } }, bpn = ypn;
function xpn({ children: t }) {
  return Te.createElement("div", { style: bpn.container }, t);
}
var Cpn = xpn, wpn = Cpn;
function Spn({ width: t, height: e, isEditorReady: r, loading: n, _ref: a, className: i, wrapperProps: o }) {
  return Te.createElement("section", { style: { ...nle.wrapper, width: t, height: e }, ...o }, !r && Te.createElement(wpn, null, n), Te.createElement("div", { ref: a, style: { ...nle.fullWidth, ...!r && nle.hide }, className: i }));
}
var _pn = Spn, Eyt = Ls(_pn);
function kpn(t) {
  Ut(t, []);
}
var Iyt = kpn;
function Apn(t, e, r = !0) {
  let n = Zt(!0);
  Ut(n.current || !r ? () => {
    n.current = !1;
  } : t, e);
}
var Yd = Apn;
function ek() {
}
function a7(t, e, r, n) {
  return Tpn(t, n) || Epn(t, e, r, n);
}
function Tpn(t, e) {
  return t.editor.getModel(Myt(t, e));
}
function Epn(t, e, r, n) {
  return t.editor.createModel(e, r, n ? Myt(t, n) : void 0);
}
function Myt(t, e) {
  return t.Uri.parse(e);
}
function Ipn({ original: t, modified: e, language: r, originalLanguage: n, modifiedLanguage: a, originalModelPath: i, modifiedModelPath: o, keepCurrentOriginalModel: s = !1, keepCurrentModifiedModel: l = !1, theme: c = "light", loading: u = "Loading...", options: f = {}, height: h = "100%", width: p = "100%", className: g, wrapperProps: y = {}, beforeMount: b = ek, onMount: w = ek }) {
  let [_, C] = Yt(!1), [x, S] = Yt(!0), A = Zt(null), I = Zt(null), M = Zt(null), B = Zt(w), L = Zt(b), N = Zt(!1);
  Iyt(() => {
    let k = Tyt.init();
    return k.then((O) => (I.current = O) && S(!1)).catch((O) => (O == null ? void 0 : O.type) !== "cancelation" && console.error("Monaco initialization: error:", O)), () => A.current ? v() : k.cancel();
  }), Yd(() => {
    let k = A.current.getModifiedEditor();
    k.getOption(I.current.editor.EditorOption.readOnly) ? k.setValue(e || "") : e !== k.getValue() && (k.executeEdits("", [{ range: k.getModel().getFullModelRange(), text: e || "", forceMoveMarkers: !0 }]), k.pushUndoStop());
  }, [e], _), Yd(() => {
    var k, O;
    (O = (k = A.current) == null ? void 0 : k.getModel()) == null || O.original.setValue(t || "");
  }, [t], _), Yd(() => {
    let { original: k, modified: O } = A.current.getModel();
    I.current.editor.setModelLanguage(k, n || r || "text"), I.current.editor.setModelLanguage(O, a || r || "text");
  }, [r, n, a], _), Yd(() => {
    var k;
    (k = I.current) == null || k.editor.setTheme(c);
  }, [c], _), Yd(() => {
    var k;
    (k = A.current) == null || k.updateOptions(f);
  }, [f], _);
  let d = sr(() => {
    var G;
    if (!I.current) return;
    L.current(I.current);
    let k = a7(I.current, t || "", n || r || "text", i || ""), O = a7(I.current, e || "", a || r || "text", o || "");
    (G = A.current) == null || G.setModel({ original: k, modified: O });
  }, [r, e, a, t, n, i, o]), m = sr(() => {
    var k;
    !N.current && M.current && (A.current = I.current.editor.createDiffEditor(M.current, { automaticLayout: !0, ...f }), d(), (k = I.current) == null || k.editor.setTheme(c), C(!0), N.current = !0);
  }, [f, c, d]);
  Ut(() => {
    _ && B.current(A.current, I.current);
  }, [_]), Ut(() => {
    !x && !_ && m();
  }, [x, _, m]), Yd(() => {
    if (A.current && I.current) {
      let k = A.current.getOriginalEditor(), O = a7(I.current, t || "", n || r || "text", i || "");
      O !== k.getModel() && k.setModel(O);
    }
  }, [i], _), Yd(() => {
    if (A.current && I.current) {
      let k = A.current.getModifiedEditor(), O = a7(I.current, e || "", a || r || "text", o || "");
      O !== k.getModel() && k.setModel(O);
    }
  }, [o], _);
  function v() {
    var O, G, H, j;
    let k = (O = A.current) == null ? void 0 : O.getModel();
    s || ((G = k == null ? void 0 : k.original) == null || G.dispose()), l || ((H = k == null ? void 0 : k.modified) == null || H.dispose()), (j = A.current) == null || j.dispose();
  }
  return Te.createElement(Eyt, { width: p, height: h, isEditorReady: _, loading: u, _ref: M, className: g, wrapperProps: y });
}
var Mpn = Ipn;
Ls(Mpn);
function Ppn(t) {
  let e = Zt();
  return Ut(() => {
    e.current = t;
  }, [t]), e.current;
}
var Rpn = Ppn, ON = /* @__PURE__ */ new Map();
function Opn({ defaultValue: t, defaultLanguage: e, defaultPath: r, value: n, language: a, path: i, theme: o = "light", line: s, loading: l = "Loading...", options: c = {}, overrideServices: u = {}, saveViewState: f = !0, keepCurrentModel: h = !1, width: p = "100%", height: g = "100%", className: y, wrapperProps: b = {}, beforeMount: w = ek, onMount: _ = ek, onChange: C, onValidate: x = ek }) {
  let [S, A] = Yt(!1), [I, M] = Yt(!0), B = Zt(null), L = Zt(null), N = Zt(null), d = Zt(_), m = Zt(w), v = Zt(), k = Zt(n), O = Rpn(i), G = Zt(!1), H = Zt(!1);
  Iyt(() => {
    let z = Tyt.init();
    return z.then((W) => (B.current = W) && M(!1)).catch((W) => (W == null ? void 0 : W.type) !== "cancelation" && console.error("Monaco initialization: error:", W)), () => L.current ? F() : z.cancel();
  }), Yd(() => {
    var W, U, Z, V;
    let z = a7(B.current, t || n || "", e || a || "", i || r || "");
    z !== ((W = L.current) == null ? void 0 : W.getModel()) && (f && ON.set(O, (U = L.current) == null ? void 0 : U.saveViewState()), (Z = L.current) == null || Z.setModel(z), f && ((V = L.current) == null || V.restoreViewState(ON.get(i))));
  }, [i], S), Yd(() => {
    var z;
    (z = L.current) == null || z.updateOptions(c);
  }, [c], S), Yd(() => {
    !L.current || n === void 0 || (L.current.getOption(B.current.editor.EditorOption.readOnly) ? L.current.setValue(n) : n !== L.current.getValue() && (H.current = !0, L.current.executeEdits("", [{ range: L.current.getModel().getFullModelRange(), text: n, forceMoveMarkers: !0 }]), L.current.pushUndoStop(), H.current = !1));
  }, [n], S), Yd(() => {
    var W, U;
    let z = (W = L.current) == null ? void 0 : W.getModel();
    z && a && ((U = B.current) == null || U.editor.setModelLanguage(z, a));
  }, [a], S), Yd(() => {
    var z;
    s !== void 0 && ((z = L.current) == null || z.revealLine(s));
  }, [s], S), Yd(() => {
    var z;
    (z = B.current) == null || z.editor.setTheme(o);
  }, [o], S);
  let j = sr(() => {
    var z;
    if (!(!N.current || !B.current) && !G.current) {
      m.current(B.current);
      let W = i || r, U = a7(B.current, n || t || "", e || a || "", W || "");
      L.current = (z = B.current) == null ? void 0 : z.editor.create(N.current, { model: U, automaticLayout: !0, ...c }, u), f && L.current.restoreViewState(ON.get(W)), B.current.editor.setTheme(o), A(!0), G.current = !0;
    }
  }, [t, e, r, n, a, i, c, u, f, o]);
  Ut(() => {
    S && d.current(L.current, B.current);
  }, [S]), Ut(() => {
    !I && !S && j();
  }, [I, S, j]), k.current = n, Ut(() => {
    var z, W;
    S && C && ((z = v.current) == null || z.dispose(), v.current = (W = L.current) == null ? void 0 : W.onDidChangeModelContent((U) => {
      H.current || C(L.current.getValue(), U);
    }));
  }, [S, C]), Ut(() => {
    if (S) {
      let z = B.current.editor.onDidChangeMarkers((W) => {
        var Z;
        let U = (Z = L.current.getModel()) == null ? void 0 : Z.uri;
        if (U && W.find((V) => V.path === U.path)) {
          let V = B.current.editor.getModelMarkers({ resource: U });
          x == null || x(V);
        }
      });
      return () => {
        z == null || z.dispose();
      };
    }
    return () => {
    };
  }, [S, x]);
  function F() {
    var z, W;
    (z = v.current) == null || z.dispose(), h ? f && ON.set(i, L.current.saveViewState()) : (W = L.current.getModel()) == null || W.dispose(), L.current.dispose();
  }
  return Te.createElement(Eyt, { width: p, height: g, isEditorReady: S, loading: l, _ref: N, className: y, wrapperProps: b });
}
var Bpn = Opn, zGe = Ls(Bpn);
const Npn = ({
  runToolRequest: t,
  setRunToolRequest: e,
  onClickRunTool: r,
  runToolResponse: n,
  isRunToolMutationLoading: a
}) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", rowGap: "space40", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsxs(
    ar.Box,
    {
      flexGrow: 1,
      display: "grid",
      gridTemplateColumns: "1fr 150px 1fr",
      columnGap: "space40",
      children: [
        /* @__PURE__ */ R.jsx(is, { gridColumn: "span 1", padding: "space20", children: /* @__PURE__ */ R.jsx(
          zGe,
          {
            options: {
              minimap: { enabled: !1 }
            },
            height: "100%",
            defaultLanguage: "json",
            value: t,
            onChange: (i) => e(i ?? "")
          }
        ) }),
        /* @__PURE__ */ R.jsx(ar.Box, { children: /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", fullWidth: !0, onClick: r, children: "Run Tool" }) }),
        /* @__PURE__ */ R.jsx(is, { gridColumn: "span 1", padding: "space20", children: a ? /* @__PURE__ */ R.jsx(Ts, {}) : /* @__PURE__ */ R.jsx(
          zGe,
          {
            options: {
              minimap: { enabled: !1 },
              readOnly: !0
            },
            height: "100%",
            defaultLanguage: "json",
            value: n
          }
        ) })
      ]
    }
  )
] }), vbn = () => {
  const { toolId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Tool ID" });
  const [r, n] = Te.useState(""), [a, i] = Te.useState(""), {
    isLoading: o,
    isError: s,
    error: l,
    data: c
  } = Qqe({
    toolId: t,
    requestTransformer: e
  }), [u, { isLoading: f }] = oPt();
  Ut(() => {
    c && n(
      JSON.stringify(
        {
          input: c.tool.exampleInput,
          options: c.tool.exampleOptions
        },
        null,
        2
      )
    );
  }, [c]);
  const h = async () => {
    try {
      const g = yMt.parse(JSON.parse(r)), { output: y } = await u({
        toolId: t,
        body: g,
        requestTransformer: e
      }).unwrap();
      i(JSON.stringify(JSON.parse(y), null, 2));
    } catch (g) {
      alert(g);
    }
  };
  if (o)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (s || !c)
    return /* @__PURE__ */ R.jsx($a, { error: l });
  const { tool: p } = c;
  return /* @__PURE__ */ R.jsx(
    Npn,
    {
      tool: p,
      runToolRequest: r,
      setRunToolRequest: n,
      onClickRunTool: h,
      runToolResponse: a,
      isRunToolMutationLoading: f
    }
  );
}, $pn = ({
  workflows: t
}) => /* @__PURE__ */ R.jsx(
  o3,
  {
    items: t,
    resourceRoute: rs.workflowResource
  }
), ybn = () => {
  const { requestTransformer: t } = Ja(), e = iKe({
    requestTransformer: t
  });
  if (e.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (e.isError || !e.data)
    return /* @__PURE__ */ R.jsx($a, { error: e.error });
  const { workflows: r } = e.data;
  return /* @__PURE__ */ R.jsx($pn, { workflows: r });
}, Dpn = ({
  workflow: t,
  onClickView: e
}) => /* @__PURE__ */ R.jsx(
  i3,
  {
    item: t,
    controls: [
      /* @__PURE__ */ R.jsx(zi.Button, { variant: "primary", onClick: e, children: "View" }, "view-button")
    ]
  }
), bbn = () => {
  const t = W5(), { workflowId: e } = eu(), { requestTransformer: r } = Ja();
  if (!e)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Workflow ID" });
  const n = aKe({
    workflowId: e,
    requestTransformer: r
  });
  if (n.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (n.isError || !n.data)
    return /* @__PURE__ */ R.jsx($a, { error: n.error });
  const { workflow: a } = n.data, i = () => {
    t(rs.workflowView(e));
  };
  return /* @__PURE__ */ R.jsx(Dpn, { workflow: a, onClickView: i });
}, Lpn = ({
  workflowNodes: t,
  workflowEdges: e,
  legendItems: r,
  nodeTypes: n
}) => /* @__PURE__ */ R.jsxs(ar.Box, { height: "100%", display: "flex", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx(Kh, {}),
  /* @__PURE__ */ R.jsx(
    ar.Box,
    {
      flexGrow: 1,
      borderColor: "colorBorderWeaker",
      borderWidth: "borderWidth10",
      borderRadius: "borderRadius20",
      children: /* @__PURE__ */ R.jsx(
        Fvt,
        {
          initialNodes: t,
          initialEdges: e,
          nodeTypes: n,
          panelChildren: [/* @__PURE__ */ R.jsx(zvt, { items: r }, "legend")]
        }
      )
    }
  )
] }), xbn = () => {
  const { workflowId: t } = eu(), { requestTransformer: e } = Ja();
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Workflow ID" });
  const r = aKe({
    workflowId: t,
    requestTransformer: e
  });
  if (!t)
    return /* @__PURE__ */ R.jsx($a, { error: "Missing Workflow ID" });
  if (r.isLoading)
    return /* @__PURE__ */ R.jsx(Ts, {});
  if (r.isError || !r.data)
    return /* @__PURE__ */ R.jsx($a, { error: r.error });
  const { workflow: n } = r.data, a = n.graph.nodes.map((l) => ({
    id: l.id,
    type: l.type,
    data: { label: l.id },
    position: { x: 0, y: 0 }
  })), i = [];
  n.graph.edges.forEach((l) => {
    const c = `e${l.from}-${l.to}`;
    l.condition || i.push({
      id: c,
      source: l.from,
      target: l.to,
      animated: !0
    }), l.condition && (a.push({
      id: c,
      type: "conditional",
      data: { label: l.condition },
      position: { x: 0, y: 0 }
    }), i.push({
      id: `e${l.from}-${c}`,
      source: l.from,
      target: c,
      animated: !0
    }), i.push({
      id: `e${c}-${l.to}`,
      source: c,
      target: l.to,
      animated: !0
    }));
  }), a.push({
    id: "whenToUse",
    type: "note",
    data: { label: n.whenToUse },
    position: { x: 0, y: 0 }
  });
  const o = {
    note: R2n,
    conditional: U1n,
    respond: mm("lightblue"),
    "call-tool": mm("lightpink"),
    "call-assistant": mm("lightgreen"),
    "follow-workflow": mm("lightgray"),
    "retrieve-knowledge": mm("yellow")
  }, s = [
    { label: "Call Tool", color: "lightpink" },
    {
      label: "Call Assistant",
      color: "lightgreen"
    },
    {
      label: "Call Workflow",
      color: "lightgray"
    },
    {
      label: "Retrieve Knowledge",
      color: "yellow"
    },
    {
      label: "Respond",
      color: "lightblue"
    }
  ];
  return /* @__PURE__ */ R.jsx(
    Lpn,
    {
      workflowNodes: a,
      workflowEdges: i,
      nodeTypes: o,
      legendItems: s
    }
  );
}, jpn = {
  pageTitle: "Conversation Debugger"
};
var ale = {};
const Fpn = /* @__PURE__ */ aa(_0r);
var GGe;
function zpn() {
  return GGe || (GGe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Fpn;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(ale)), ale;
}
var a1e = /* @__PURE__ */ zpn();
const qbe = ({ id: t, onApply: e, onClear: r, value: n }) => /* @__PURE__ */ R.jsxs("div", { className: "flex gap-4", children: [
  /* @__PURE__ */ R.jsx(
    as,
    {
      onClick: () => e(t),
      variant: "primary",
      children: "Apply"
    }
  ),
  r && n && /* @__PURE__ */ R.jsx(
    as,
    {
      onClick: () => r(t),
      variant: "link",
      children: "Clear"
    }
  )
] }), Gpn = (t) => {
  const { label: e, id: r, onApply: n, onClear: a, options: i, popover: o, value: s } = t, [l, c] = Yt(s);
  Ut(() => {
    c(s);
  }, [s]);
  const u = (p) => {
    const g = p.target.value;
    c((y) => y ? y.includes(g) ? y.filter((b) => b !== g) : [...y, g] : [g]);
  }, f = () => {
    if (o.hide(), !(l != null && l.length))
      return h();
    n({
      id: r,
      value: l
    });
  }, h = () => {
    o.hide(), c(null), a && a(r);
  };
  return /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ R.jsx(
      p5t,
      {
        legend: e,
        name: r,
        children: i.map((p) => /* @__PURE__ */ R.jsx(
          m5t,
          {
            checked: l ? l.includes(p.value) : !1,
            id: `${r}-${p.value}`,
            onChange: u,
            name: r,
            value: p.value,
            children: p.label
          },
          `${r}-${p.value}`
        ))
      }
    ),
    /* @__PURE__ */ R.jsx(
      qbe,
      {
        id: r,
        onApply: f,
        onClear: h,
        value: l
      }
    )
  ] });
}, Wpn = (t) => {
  const {
    id: e,
    label: r,
    onApply: n,
    onClear: a,
    placeholder: i,
    popover: o,
    value: s
  } = t, [l, c] = Yt(s);
  Ut(() => {
    c(s);
  }, [s]);
  const u = (p) => {
    c(p.target.value);
  }, f = () => {
    if (o.hide(), !l)
      return h();
    n({ value: l, id: e });
  }, h = () => {
    o.hide(), c(""), a(e);
  };
  return /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ R.jsxs(sle, { children: [
      r && /* @__PURE__ */ R.jsx(z$, { htmlFor: e, children: r }),
      /* @__PURE__ */ R.jsx(
        g5t,
        {
          id: e,
          name: e,
          onChange: u,
          placeholder: i,
          value: l || "",
          type: "text"
        }
      )
    ] }),
    /* @__PURE__ */ R.jsx(
      qbe,
      {
        id: e,
        onApply: f,
        onClear: h,
        value: l || ""
      }
    )
  ] });
};
var ile = {}, EP = P.createContext({}), Pyt = ({ children: t, gutter: e, placement: r, state: n, ...a }) => {
  let i = n || aW({ gutter: e, modal: !0, placement: r, ...a });
  return P.createElement(EP.Provider, { value: i }, t);
};
Pyt.displayName = "BasePopoverContainer";
var Ryt = P.memo(Pyt);
Ryt.displayName = "PopoverContainer";
var Oyt = (t) => {
  let e = Md();
  return P.createElement(Bsr, { ...t, size: e.fontSizes.fontSize70, stroke: e.borderColors.colorBorderWeaker, fill: e.backgroundColors.colorBackgroundBody });
};
Oyt.displayName = "PopoverArrow";
var Byt = P.forwardRef(({ style: t, width: e, ...r }, n) => P.createElement(ht, { ...Xt(r), width: e, backgroundColor: "colorBackgroundWeaker", borderRadius: "borderRadius30", boxShadow: "shadowElevation10", maxWidth: "size50", zIndex: "zIndex80", _focus: { outline: "none" }, style: t, ref: n }));
Byt.displayName = "StyledPopover";
var Nyt = P.forwardRef(({ children: t, element: e = "POPOVER", i18nDismissLabel: r = "Close popover", initialFocusRef: n, ...a }, i) => {
  let o = P.useContext(EP);
  return P.useEffect(() => {
    var s;
    o.visible && n && ((s = n.current) == null || s.focus());
  }, [o.visible, n]), P.createElement(xXe, { ...o, ...a, as: Byt, ref: i, preventBodyScroll: !1 }, P.createElement(uy, null, P.createElement(Oyt, { ...o }), P.createElement(ht, { element: e, padding: "space90" }, P.createElement(ht, { position: "absolute", right: 16, top: 16 }, P.createElement(Zs, { element: `${e}_CLOSE_BUTTON`, variant: "secondary_icon", size: "reset", onClick: o.hide }, P.createElement(Dy, { element: `${e}_CLOSE_ICON`, decorative: !0, size: "sizeIcon10" }), P.createElement(Ul, null, r))), t)));
});
Nyt.displayName = "Popover";
var $yt = P.forwardRef(({ children: t, element: e = "POPOVER_BUTTON", ...r }, n) => {
  let a = P.useContext(EP);
  return P.createElement(eG, { element: e, ...a, ...r, as: Zs, ref: n }, t);
});
$yt.displayName = "PopoverButton";
var Dyt = P.forwardRef(function({ children: t, ...e }, r) {
  return P.createElement(hW, { ...e, as: "button", ref: r }, t);
});
Dyt.displayName = "ButtonBadge";
var Lyt = P.forwardRef(({ children: t, element: e = "POPOVER_BADGE", ...r }, n) => {
  let a = P.useContext(EP);
  return P.createElement(eG, { element: e, ...a, ...r, as: Dyt, ref: n }, t);
});
Lyt.displayName = "PopoverBadgeButton";
var jyt = P.forwardRef(({ children: t, element: e = "POPOVER_FORM_PILL", ...r }, n) => {
  let a = P.useContext(EP);
  return P.createElement(eG, { element: e, ...a, ...r, as: gG, ref: n, onSelect: (i) => {
    a.toggle(), r.onSelect && r.onSelect(i);
  }, baseId: a.baseId }, t);
});
jyt.displayName = "PopoverFormPillButton";
const Hpn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Popover: Nyt,
  PopoverBadgeButton: Lyt,
  PopoverButton: $yt,
  PopoverContainer: Ryt,
  PopoverFormPillButton: jyt,
  usePopoverState: aW
}, Symbol.toStringTag, { value: "Module" })), Upn = /* @__PURE__ */ aa(Hpn);
var WGe;
function Vpn() {
  return WGe || (WGe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = Upn;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(ile)), ile;
}
var BN = /* @__PURE__ */ Vpn();
const qpn = (t) => {
  const { children: e, id: r, isSelected: n, label: a, state: i } = t, o = BN.usePopoverState({ baseId: r });
  return /* @__PURE__ */ R.jsxs(BN.PopoverContainer, { state: o, children: [
    /* @__PURE__ */ R.jsx(BN.PopoverButton, { borderRadius: "borderRadiusPill", size: "reset", variant: "reset", children: /* @__PURE__ */ R.jsxs(a1e.FormPill, { ...i, selected: n, children: [
      n ? null : /* @__PURE__ */ R.jsx(fW, { decorative: !0 }),
      a
    ] }) }),
    /* @__PURE__ */ R.jsx(BN.Popover, { "aria-label": r, width: "size40", children: e({ popover: o }) })
  ] }, r);
}, Kpn = (t) => {
  const {
    id: e,
    onApply: r,
    onClear: n,
    options: a,
    popover: i,
    value: o
  } = t, { end: s, start: l } = a, [c, u] = Yt({
    [s.id]: o.end,
    [l.id]: o.start
  }), [f, h] = Yt(null), p = (b) => {
    u((w) => ({
      ...w,
      [b.target.name]: b.target.value
    }));
  }, g = () => {
    const b = c[s.id], w = c[l.id], _ = b ? new aI(b) : null, C = w ? new aI(w) : null;
    if (C && _ && C.isAfter(_.value))
      return h("End date should be greater than start date");
    if (h(null), i.hide(), !s && !l) return;
    const x = Object.entries(c).filter((S) => !!S[1]).map((S) => ({
      id: S[0],
      value: S[1]
    }));
    r(x);
  }, y = () => {
    i.hide(), u({
      end: "",
      start: ""
    }), n([a.end.id, a.start.id]);
  };
  return /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ R.jsxs("div", { className: "flex gap-4", children: [
      /* @__PURE__ */ R.jsxs(sle, { children: [
        /* @__PURE__ */ R.jsx(z$, { htmlFor: s.id, children: "Start date" }),
        /* @__PURE__ */ R.jsx(
          c5e,
          {
            id: l.id,
            name: l.id,
            onChange: p,
            value: c[l.id] || ""
          }
        )
      ] }),
      /* @__PURE__ */ R.jsxs(sle, { children: [
        /* @__PURE__ */ R.jsx(z$, { htmlFor: l.id, children: "End date" }),
        /* @__PURE__ */ R.jsx(
          c5e,
          {
            hasError: !!f,
            id: s.id,
            name: s.id,
            onChange: p,
            value: c[s.id] || ""
          }
        ),
        f && /* @__PURE__ */ R.jsx(v5t, { variant: "error", children: f })
      ] })
    ] }),
    /* @__PURE__ */ R.jsx(
      qbe,
      {
        id: e,
        onApply: g,
        onClear: y,
        value: c[l.id] || c[s.id] || ""
      }
    )
  ] });
}, Zpn = (t) => {
  const {
    filters: e,
    isLoading: r,
    onFilterChange: n,
    onFilterClear: a,
    selectedFilters: i
  } = t, o = a1e.useFormPillState(), s = (f) => {
    n(f);
  }, l = (f) => {
    a(f);
  }, c = (f) => f.type === "date-range" ? !!i[f.options.start.id] || !!i[f.options.end.id] : !!i[f.id], u = (f, h) => f.type === "input" ? /* @__PURE__ */ R.jsx(
    Wpn,
    {
      ...f,
      onApply: s,
      onClear: l,
      popover: h,
      value: i[f.id]
    }
  ) : f.type === "checkbox" ? /* @__PURE__ */ R.jsx(
    Gpn,
    {
      ...f,
      onApply: s,
      onClear: l,
      popover: h,
      value: i[f.id]
    }
  ) : f.type === "date-range" ? /* @__PURE__ */ R.jsx(
    Kpn,
    {
      ...f,
      onApply: s,
      onClear: l,
      popover: h,
      value: {
        end: i[f.options.end.id],
        start: i[f.options.start.id]
      }
    }
  ) : null;
  return r ? /* @__PURE__ */ R.jsxs(_r, { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ R.jsx(
      i7,
      {
        borderRadius: "borderRadius30",
        height: "22px",
        width: "80px"
      }
    ),
    /* @__PURE__ */ R.jsx(_r, { className: "flex gap-4", children: Array.from({ length: 6 }, (f, h) => h).map((f, h) => /* @__PURE__ */ R.jsx(
      i7,
      {
        borderRadius: "borderRadius50",
        height: "28px",
        width: "90px"
      },
      h
    )) })
  ] }) : /* @__PURE__ */ R.jsxs(_r, { children: [
    /* @__PURE__ */ R.jsx(Am, { as: "h1", variant: "heading50", children: "Filters" }),
    /* @__PURE__ */ R.jsx(
      a1e.FormPillGroup,
      {
        "aria-label": "Filters",
        size: "large",
        ...o,
        children: e.map((f) => /* @__PURE__ */ R.jsx(
          qpn,
          {
            id: f.id,
            isSelected: c(f),
            label: f.label,
            state: o,
            children: ({ popover: h }) => /* @__PURE__ */ R.jsx(_r, { children: u(f, h) })
          },
          f.id
        ))
      }
    )
  ] });
}, Jpn = (t, e) => {
  var r, n, a;
  return [
    {
      id: "createdAt",
      type: "date-range",
      label: "Created at",
      options: {
        end: {
          id: "createdAtEnd",
          label: "To"
        },
        start: {
          id: "createdAtStart",
          label: "From"
        }
      },
      value: {
        end: t.createdAtEnd,
        start: t.createdAtStart
      }
    },
    {
      id: "id",
      label: "Conversation ID",
      type: "input",
      value: t.id
    },
    {
      id: "accountId",
      label: "Account ID",
      type: "input",
      value: t.accountId
    },
    {
      id: "userId",
      label: "User ID",
      type: "input",
      value: t.userId
    },
    {
      id: "applicationIds",
      label: "Application IDs",
      type: "checkbox",
      options: ((r = e.applications) == null ? void 0 : r.map((i) => ({
        label: i.name,
        value: i.id
      }))) || [],
      value: t.applicationIds
    },
    {
      id: "toolIds",
      label: "Tool IDs",
      type: "checkbox",
      options: ((n = e.tools) == null ? void 0 : n.map((i) => ({
        label: i.name,
        value: i.id
      }))) || [],
      value: t.toolIds
    },
    {
      id: "workflowIds",
      label: "Workflow IDs",
      type: "checkbox",
      options: ((a = e.workflows) == null ? void 0 : a.map((i) => ({
        label: i.name,
        value: i.id
      }))) || [],
      value: t.workflowIds
    }
  ];
}, i1e = 6, Ypn = (t) => {
  const e = t.getAll("applicationIds"), r = t.getAll("toolIds"), n = t.getAll("workflowIds"), a = t.get("limit");
  return {
    limit: a ? parseInt(a, 10) : i1e,
    cursor: t.get("cursor"),
    order: t.get("order") ?? "desc",
    sortBy: t.get("sortBy") ?? "createdAt",
    selectedFilters: {
      id: t.get("id"),
      accountId: t.get("accountId"),
      userId: t.get("userId"),
      createdAtStart: t.get("createdAtStart"),
      createdAtEnd: t.get("createdAtEnd"),
      applicationIds: e.length ? e : null,
      toolIds: r.length ? r : null,
      workflowIds: n.length ? n : null
    }
  };
}, Xpn = (t, e) => {
  switch (e.type) {
    case "page_change":
      return {
        ...t,
        cursor: e.payload.cursor,
        limit: e.payload.limit
      };
    case "cursor_change":
      return {
        ...t,
        cursor: e.payload.cursor
      };
    case "limit_change":
      return {
        ...t,
        limit: e.payload.limit
      };
    case "filter_change":
      return {
        ...t,
        cursor: null,
        limit: i1e,
        selectedFilters: {
          ...t.selectedFilters,
          ...e.payload
        }
      };
    case "filter_clear_all":
      return {
        ...t,
        selectedFilters: {
          id: null,
          accountId: null,
          userId: null,
          createdAtStart: null,
          createdAtEnd: null,
          applicationIds: null,
          toolIds: null,
          workflowIds: null
        }
      };
    case "filter_clear": {
      const n = e.payload.reduce((a, i) => ({
        ...a,
        [i]: null
      }), {});
      return {
        ...t,
        cursor: null,
        limit: i1e,
        selectedFilters: {
          ...t.selectedFilters,
          ...n
        }
      };
    }
    case "sort_by": {
      const { sortBy: r, order: n } = e.payload;
      return {
        ...t,
        selectedFilters: {
          ...t.selectedFilters
        },
        cursor: null,
        sortBy: r,
        order: n
      };
    }
    default:
      return t;
  }
}, Qpn = (t) => {
  const { hasNextPage: e, hasPreviousPage: r, onPageChange: n } = t, a = (s) => {
    n(s);
  }, i = (s) => {
    e && (a(!0), s.preventDefault());
  }, o = (s) => {
    r && (a(), s.preventDefault());
  };
  return /* @__PURE__ */ R.jsx(y5t, { hAlignContent: "right", children: /* @__PURE__ */ R.jsx(b5t, { label: "default pagination navigation", children: /* @__PURE__ */ R.jsxs(x5t, { children: [
    /* @__PURE__ */ R.jsx(
      u5e,
      {
        disabled: !r,
        label: "Go to previous page",
        onClick: o,
        variant: "back"
      }
    ),
    /* @__PURE__ */ R.jsx(
      u5e,
      {
        disabled: !e,
        label: "Go to next page",
        onClick: i,
        variant: "forward"
      }
    )
  ] }) }) });
};
var ole = {};
const Fyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowDownIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowDownIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.91 14.991l.05.007h.08l.07-.01.029-.01a.489.489 0 00.272-.205l3.444-3.832a.596.596 0 000-.78.459.459 0 00-.632-.063l-.069.063-2.659 2.957V5.513A.504.504 0 0010 5a.5.5 0 00-.488.42l-.008.093v7.604l-2.658-2.956a.459.459 0 00-.632-.063l-.069.063a.598.598 0 00-.057.704l.057.076 3.444 3.832c.064.098.16.172.272.206l.049.012z" })));
});
Fyt.displayName = "ArrowDownIcon";
const zyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `ArrowUpIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[ArrowUpIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M10 5h.011a.45.45 0 01.059.005L10 5c.038 0 .075.004.11.013l.029.009a.489.489 0 01.272.205l3.444 3.832a.596.596 0 010 .78.459.459 0 01-.632.063l-.069-.063-2.659-2.957v7.605A.504.504 0 0110 15a.5.5 0 01-.488-.42l-.008-.093V6.883L6.846 9.839a.459.459 0 01-.632.063l-.069-.063a.598.598 0 01-.057-.704l.057-.076L9.59 5.227a.498.498 0 01.272-.206l.028-.007A.533.533 0 0110 5z" })));
});
zyt.displayName = "ArrowUpIcon";
const Gyt = P.forwardRef(({ as: t, display: e, element: r = "ICON", size: n, color: a, title: i, decorative: o }, s) => {
  const l = `UnsortedIcon-${Jr()}`;
  if (!o && i == null) throw new Error("[UnsortedIcon]: Missing a title for non-decorative icon.");
  return P.createElement(As, { as: t, display: e, element: r, size: n, color: a, ref: s }, P.createElement("svg", { role: "img", "aria-hidden": o, xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", fill: "none", viewBox: "0 0 20 20", "aria-labelledby": l }, i ? P.createElement("title", { id: l }, i) : null, P.createElement("path", { fill: "currentColor", d: "M4.088 7.135a.598.598 0 00.057.704l.069.063c.193.15.46.128.632-.063L6.5 5.914V11.5a.5.5 0 001 0V5.913l1.654 1.926.069.063c.193.15.46.128.632-.063a.596.596 0 000-.78L7.35 4.161l-.068-.063a.459.459 0 00-.632.063L4.145 7.06l-.057.076zm11.824 5.73a.598.598 0 00-.057-.704l-.069-.063a.459.459 0 00-.632.063L13.5 14.086V8.5a.5.5 0 00-1 0v5.587l-1.654-1.926-.069-.063a.459.459 0 00-.632.063.596.596 0 000 .78l2.505 2.898.068.063c.193.15.46.128.632-.063l2.505-2.898.057-.076z" })));
});
Gyt.displayName = "UnsortedIcon";
var emn = Object.create, Wyt = Object.defineProperty, tmn = Object.getOwnPropertyDescriptor, Hyt = Object.getOwnPropertyNames, rmn = Object.getPrototypeOf, nmn = Object.prototype.hasOwnProperty, v2 = (t, e) => function() {
  return e || (0, t[Hyt(t)[0]])((e = { exports: {} }).exports, e), e.exports;
}, amn = (t, e, r, n) => {
  if (e && typeof e == "object" || typeof e == "function") for (let a of Hyt(e)) !nmn.call(t, a) && a !== r && Wyt(t, a, { get: () => e[a], enumerable: !(n = tmn(e, a)) || n.enumerable });
  return t;
}, imn = (t, e, r) => (r = t != null ? emn(rmn(t)) : {}, amn(!t || !t.__esModule ? Wyt(r, "default", { value: t, enumerable: !0 }) : r, t)), Uyt = v2({ "../../../../node_modules/lodash/isObjectLike.js"(t, e) {
  function r(n) {
    return n != null && typeof n == "object";
  }
  e.exports = r;
} }), omn = v2({ "../../../../node_modules/lodash/_freeGlobal.js"(t, e) {
  var r = typeof ss == "object" && ss && ss.Object === Object && ss;
  e.exports = r;
} }), smn = v2({ "../../../../node_modules/lodash/_root.js"(t, e) {
  var r = omn(), n = typeof self == "object" && self && self.Object === Object && self, a = r || n || Function("return this")();
  e.exports = a;
} }), Vyt = v2({ "../../../../node_modules/lodash/_Symbol.js"(t, e) {
  var r = smn(), n = r.Symbol;
  e.exports = n;
} }), lmn = v2({ "../../../../node_modules/lodash/_getRawTag.js"(t, e) {
  var r = Vyt(), n = Object.prototype, a = n.hasOwnProperty, i = n.toString, o = r ? r.toStringTag : void 0;
  function s(l) {
    var c = a.call(l, o), u = l[o];
    try {
      l[o] = void 0;
      var f = !0;
    } catch {
    }
    var h = i.call(l);
    return f && (c ? l[o] = u : delete l[o]), h;
  }
  e.exports = s;
} }), cmn = v2({ "../../../../node_modules/lodash/_objectToString.js"(t, e) {
  var r = Object.prototype, n = r.toString;
  function a(i) {
    return n.call(i);
  }
  e.exports = a;
} }), umn = v2({ "../../../../node_modules/lodash/_baseGetTag.js"(t, e) {
  var r = Vyt(), n = lmn(), a = cmn(), i = "[object Null]", o = "[object Undefined]", s = r ? r.toStringTag : void 0;
  function l(c) {
    return c == null ? c === void 0 ? o : i : s && s in Object(c) ? n(c) : a(c);
  }
  e.exports = l;
} }), dmn = v2({ "../../../../node_modules/lodash/_overArg.js"(t, e) {
  function r(n, a) {
    return function(i) {
      return n(a(i));
    };
  }
  e.exports = r;
} }), fmn = v2({ "../../../../node_modules/lodash/_getPrototype.js"(t, e) {
  var r = dmn(), n = r(Object.getPrototypeOf, Object);
  e.exports = n;
} }), hmn = v2({ "../../../../node_modules/lodash/isPlainObject.js"(t, e) {
  var r = umn(), n = fmn(), a = Uyt(), i = "[object Object]", o = Function.prototype, s = Object.prototype, l = o.toString, c = s.hasOwnProperty, u = l.call(Object);
  function f(h) {
    if (!a(h) || r(h) != i) return !1;
    var p = n(h);
    if (p === null) return !0;
    var g = c.call(p, "constructor") && p.constructor;
    return typeof g == "function" && g instanceof g && l.call(g) == u;
  }
  e.exports = f;
} }), pmn = v2({ "../../../../node_modules/lodash/isElement.js"(t, e) {
  var r = Uyt(), n = hmn();
  function a(i) {
    return r(i) && i.nodeType === 1 && !n(i);
  }
  e.exports = a;
} }), Kbe = P.createContext({ actionable: !1, striped: !1 });
function mmn(t, e) {
  return "matches" in t ? t.matches(e) : "msMatchesSelector" in t ? t.msMatchesSelector(e) : t.webkitMatchesSelector(e);
}
var qyt = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function gmn(t) {
  return mmn(t, qyt);
}
function Kyt(t) {
  return Array.from(t.querySelectorAll(qyt)).filter(gmn);
}
function vmn(t) {
  let [e] = Kyt(t);
  return e || null;
}
function ymn(t) {
  return t ? t.ownerDocument || t : document;
}
function Zbe(t) {
  let { activeElement: e } = ymn(t);
  return e != null && e.nodeName ? e : null;
}
function bmn(t) {
  let e = Zbe(t);
  if (!e) return !1;
  if (e === t) return !0;
  let r = e.getAttribute("aria-activedescendant");
  return r ? r === t.id : !1;
}
function o1e(t, { preventScroll: e, isActive: r = bmn } = {}) {
  return r(t) || (t.focus({ preventScroll: e }), r(t)) ? -1 : requestAnimationFrame(() => {
    t.focus({ preventScroll: e });
  });
}
var xmn = (t, e) => {
  Kyt(t).forEach((r) => {
    r.tabIndex = e ? 0 : -1;
  });
}, HGe = (t) => {
  setTimeout(() => {
    t != null && (t.tabIndex = 0);
  }, 150);
}, Jbe = (t) => t.tagName === "TD" || t.tagName === "TH", Zyt = (t, e) => t == null || !e ? null : t.closest(`[id="${e}"] th, [id="${e}"] td`), Cmn = (t) => {
  let e = Zbe();
  return e ? Jbe(e) ? e : Zyt(e, t) : null;
}, Jyt = P.forwardRef(({ element: t = "DATA_GRID", role: e = "grid", striped: r = !1, ...n }, a) => {
  let i = `data-grid-${Jr()}`, o = P.useRef(null), s = LT({ unstable_virtual: !1 }), [l, c] = P.useState(!1), u = P.useCallback(() => {
    c(!0);
  }, []), f = P.useCallback((y) => {
    y.target != null && (o.current = y.target);
  }, []), h = P.useCallback((y) => {
    if (!y.currentTarget.contains(y.relatedTarget) && (c(!1), o.current != null)) {
      let b = Zyt(o.current, i);
      b && HGe(b);
    }
  }, [i]), p = P.useCallback((y) => {
    switch (y.key) {
      case "Enter": {
        c(!0);
        let b = Zbe();
        if (b && Jbe(b)) {
          let w = vmn(b);
          w && (o1e(w), b.tabIndex = l ? 0 : -1);
        }
        break;
      }
      case "Escape": {
        c(!1);
        let b = Cmn(i);
        b && (o1e(b), HGe(b));
        break;
      }
    }
  }, [l, i]), g = { ...s, actionable: l, striped: r };
  return P.createElement(Kbe.Provider, { value: g }, P.createElement(KYe, { ...n, ...s, id: i, ref: a, as: h3e, element: t, role: e, onKeyDown: p, onMouseDown: u, onFocus: f, onBlur: h, isActionable: l, "data-actionable": l }));
});
Jyt.displayName = "DataGrid";
var Yyt = P.forwardRef(({ element: t = "DATA_GRID_HEAD", ...e }, r) => P.createElement(p3e, { ...e, element: t, ref: r }));
Yyt.displayName = "DataGridHead";
var wmn = ds.tr(us({ "&[aria-selected=true] > td": { borderColor: "colorBorderPrimaryWeaker" }, "&[aria-selected=true] > th": { borderColor: "colorBorderPrimaryWeaker" } })), Xyt = P.forwardRef(({ element: t = "DATA_GRID_TR", striped: e, ...r }, n) => P.createElement(ht, { ...Xt(r), ref: n, element: t, as: wmn, "aria-selected": r.selected, _even: { backgroundColor: e ? "colorBackgroundRowStriped" : "transparent" }, _selected: { backgroundColor: "colorBackgroundPrimaryWeakest" } }));
Xyt.displayName = "Tr";
var Qyt = P.forwardRef(({ element: t = "DATA_GRID_ROW", ...e }, r) => {
  let n = P.useContext(Kbe);
  return P.createElement(Mar, { as: Xyt, ...e, element: t, ...n, ref: r, role: "row" });
});
Qyt.displayName = "DataGridRow";
var Smn = imn(pmn()), e3t = P.forwardRef(({ textAlign: t = "left", whiteSpace: e, element: r = "DATA_GRID_TD", ...n }, a) => P.createElement(ht, { ...Xt(n), ref: a, as: "td", element: r, borderStyle: "solid", borderColor: "colorBorderWeaker", borderWidth: "borderWidth0", borderBottomWidth: "borderWidth10", fontSize: "fontSize30", lineHeight: "lineHeight30", padding: "space50", position: "relative", textAlign: t, whiteSpace: e, verticalAlign: "inherit", wordWrap: "break-word", color: "inherit", _first: { paddingLeft: "space50" }, _last: { paddingRight: "space50" }, _focus: { outline: "none", boxShadow: "shadowFocusInset" } }));
e3t.displayName = "Td";
var t3t = P.forwardRef(({ width: t, textAlign: e = "left", whiteSpace: r, element: n = "DATA_GRID_TH", ...a }, i) => P.createElement(ht, { ...Xt(a), ref: i, element: n, as: "th", borderBottomStyle: "solid", borderBottomColor: "colorBorderWeaker", borderBottomWidth: "borderWidth10", fontSize: "fontSize30", lineHeight: "lineHeight30", fontWeight: "fontWeightSemibold", paddingY: "space40", paddingX: "space50", width: t, position: "relative", textAlign: e, whiteSpace: r, verticalAlign: "inherit", color: "inherit", _first: { paddingLeft: "space50" }, _last: { paddingRight: "space50" }, _focus: { outline: "none", boxShadow: "shadowFocusInset" } }));
t3t.displayName = "Th";
var Ybe = ({ element: t = "DATA_GRID_CELL", as: e = "td", ...r }) => {
  let n = P.useContext(Kbe), a = P.useRef(null), i = P.useCallback(() => {
    a.current && o1e(a.current);
  }, []), o = P.useCallback((s) => {
    s.length !== 0 && s.forEach((l) => {
      if (!(0, Smn.default)(l.target)) return;
      let c = l.target;
      l.attributeName === "tabindex" && n.actionable && c.tabIndex === 0 && Jbe(c) && (c.tabIndex = -1);
    });
  }, [n.actionable]);
  return Ydr(a.current || {}, o), P.useEffect(() => {
    setTimeout(() => {
      a.current && xmn(a.current, n.actionable);
    }, 10);
  }, [n.actionable]), P.createElement(JYe, { ...r, ...n, element: t, ref: a, as: e === "td" ? e3t : t3t, onClick: i });
};
Ybe.displayName = "DataGridCell";
var r3t = ({ element: t = "DATA_GRID_HEADER", ...e }) => P.createElement(Ybe, { element: t, ...e, as: "th" });
r3t.displayName = "DataGridHeader";
var n3t = ({ direction: t, element: e }) => {
  switch (t) {
    case "ascending":
      return P.createElement(zyt, { decorative: !0, element: e });
    case "descending":
      return P.createElement(Fyt, { decorative: !0, element: e });
    case "none":
      return P.createElement(Gyt, { decorative: !0, element: e });
    default:
      return null;
  }
};
n3t.displayName = "DataGridHeaderSortIcon";
var a3t = ({ direction: t, onClick: e, element: r = "DATA_GRID_HEADER_SORT", i18nAscendingLabel: n = "Sort ascending", i18nDescendingLabel: a = "Sort descending", i18nUnsortedLabel: i = "Unsorted", ...o }) => {
  let s = { ascending: n, descending: a, none: i };
  return P.createElement(Zs, { element: r, variant: "reset", size: "reset", onClick: e, ...o }, P.createElement(n3t, { element: `${r}_ICON`, direction: t }), P.createElement(Ul, null, s[t]));
};
a3t.displayName = "DataGridHeaderSort";
var i3t = P.forwardRef(({ element: t = "DATA_GRID_BODY", ...e }, r) => P.createElement(m3e, { ...e, element: t, ref: r }));
i3t.displayName = "DataGridBody";
var o3t = P.forwardRef(({ element: t = "DATA_GRID_FOOT", ...e }, r) => P.createElement(g3e, { ...e, element: t, ref: r }));
o3t.displayName = "DataGridFoot";
const _mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DataGrid: Jyt,
  DataGridBody: i3t,
  DataGridCell: Ybe,
  DataGridFoot: o3t,
  DataGridHead: Yyt,
  DataGridHeader: r3t,
  DataGridHeaderSort: a3t,
  DataGridRow: Qyt
}, Symbol.toStringTag, { value: "Module" })), kmn = /* @__PURE__ */ aa(_mn);
var UGe;
function Amn() {
  return UGe || (UGe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 });
    var e = kmn;
    Object.keys(e).forEach(function(r) {
      r !== "default" && r !== "__esModule" && (r in t && t[r] === e[r] || Object.defineProperty(t, r, { enumerable: !0, get: function() {
        return e[r];
      } }));
    });
  }(ole)), ole;
}
var av = /* @__PURE__ */ Amn();
const Tmn = {
  asc: "ascending",
  desc: "descending"
}, Emn = 6, s3t = [67, 53, 79, 59, 73, 61, 89, 97, 71, 83], Imn = s3t.length, Mmn = ({ headers: t }) => /* @__PURE__ */ R.jsx(C5t, { children: Array.from({ length: Emn }, (e, r) => r).map((e, r) => /* @__PURE__ */ R.jsx(w5t, { children: t.map((n, a) => /* @__PURE__ */ R.jsx(S5t, { children: /* @__PURE__ */ R.jsx(
  i7,
  {
    width: `${s3t[(r + a) % Imn]}%`
  },
  r
) }, `col-${r}-${a}`)) }, `row-${r}`)) }), Pmn = (t, e) => t.map((r) => r.sortable && e && r.key === e[0] ? e[1] : "none"), Rmn = (t) => {
  const {
    ariaLabel: e,
    data: r,
    headers: n,
    isLoading: a = !1,
    noResults: i,
    onColumnSort: o,
    sortBy: s
  } = t, [l, c] = Yt(() => Pmn(n, s)), u = (f, h) => {
    if (!o) return;
    const p = l.map(() => "none");
    l[h] === "asc" ? p[h] = "desc" : p[h] = "asc", c(p), o(f, p[h]);
  };
  return i && !r.length && !a ? /* @__PURE__ */ R.jsx(
    lme,
    {
      description: i.description,
      heading: i.heading,
      variant: AG.noData,
      orientation: jL.horizontal,
      children: i.button && /* @__PURE__ */ R.jsx(_r, { marginTop: "space60", children: /* @__PURE__ */ R.jsx(
        as,
        {
          onClick: i.button.onClick,
          variant: i.button.variant || "primary",
          children: i.button.label
        }
      ) })
    }
  ) : /* @__PURE__ */ R.jsx("div", { className: "flex flex-col gap-4 overflow-x-auto", children: /* @__PURE__ */ R.jsxs(av.DataGrid, { "aria-label": e, striped: !0, variant: "borderless", children: [
    /* @__PURE__ */ R.jsx(av.DataGridHead, { children: /* @__PURE__ */ R.jsx(av.DataGridRow, { children: n.map((f, h) => /* @__PURE__ */ R.jsx(av.DataGridHeader, { width: "150", children: /* @__PURE__ */ R.jsxs(
      _r,
      {
        alignItems: "center",
        columnGap: "space20",
        display: "flex",
        textTransform: "uppercase",
        children: [
          f.label,
          f.sortable && o && /* @__PURE__ */ R.jsx(
            av.DataGridHeaderSort,
            {
              direction: Tmn[l[h]] ?? "none",
              onClick: () => u(f.key, h)
            }
          )
        ]
      }
    ) }, h)) }) }),
    a && /* @__PURE__ */ R.jsx(Mmn, { headers: n }),
    !a && /* @__PURE__ */ R.jsx(av.DataGridBody, { children: r.map((f, h) => /* @__PURE__ */ R.jsx(av.DataGridRow, { children: n.map((p, g) => {
      const y = f[p.key];
      return /* @__PURE__ */ R.jsx(
        av.DataGridCell,
        {
          "data-testid": `cell-${h}-${g + 1}`,
          children: p.customRender ? p.customRender(y, f) : String(y)
        },
        `col-${g}`
      );
    }) }, `row-${h}`)) })
  ] }) });
}, Omn = () => {
  const [t, e] = U5t(), r = Sx.useToaster(), [n, a] = AI(
    Xpn,
    t,
    Ypn
  ), { requestTransformer: i } = Ja(), {
    data: o = {
      conversations: [],
      page: { hasNextPage: !1, hasPrevPage: !1 }
    },
    isError: s,
    isLoading: l,
    error: c
  } = iPt({
    requestTransformer: i,
    filters: n.selectedFilters,
    cursor: n.cursor ?? "",
    limit: n.limit.toString(),
    sortBy: n.sortBy ?? "createdAt",
    order: n.order ?? "desc"
  }), { data: u } = tKe({
    requestTransformer: i
  }), { data: f } = iKe({
    requestTransformer: i
  }), { data: h } = Xqe({
    requestTransformer: i
  });
  Ut(() => {
    o.conversations.length && !o.page.hasPrevPage && e((B) => {
      const L = Object.fromEntries(B.entries());
      return delete L.cursor, delete L.limit, L;
    });
  }, [o.page.hasPrevPage]);
  const p = () => {
    r.push({
      id: Date.now().toString(),
      message: "Copied to clipboard",
      variant: "success",
      dismissAfter: 800
    });
  }, g = (B) => {
    const { conversations: L } = o;
    if (!L.length) return;
    const N = B ? L[L.length - 1].id : L[0].id;
    e((d) => {
      const m = Object.fromEntries(d.entries());
      return B ? (delete m.limit, {
        ...m,
        cursor: N
      }) : {
        ...m,
        limit: String(-Math.abs(n.limit)),
        cursor: N
      };
    }), a({
      type: "page_change",
      payload: {
        cursor: N,
        limit: B ? Math.abs(n.limit) : -Math.abs(n.limit)
      }
    });
  }, y = (B) => {
    const N = (Array.isArray(B) ? B : [B]).reduce((d, { id: m, value: v }) => ({
      ...d,
      [m]: v
    }), {});
    e((d) => ({
      ...Object.fromEntries(d.entries()),
      ...N
    })), a({
      type: "filter_change",
      payload: N
    });
  }, b = (B) => {
    const L = Array.isArray(B) ? B : [B];
    e((N) => {
      const d = Object.fromEntries(N.entries());
      return L.forEach((m) => {
        delete d[m];
      }), delete d.cursor, d;
    }), a({
      type: "filter_clear",
      payload: L
    });
  }, w = () => {
    e({}), a({
      type: "filter_clear_all"
    });
  }, _ = (B, L) => {
    e((N) => {
      const d = Object.fromEntries(N.entries());
      return delete d.cursor, {
        ...d,
        sortBy: B,
        order: L
      };
    }), a({
      type: "sort_by",
      payload: {
        sortBy: B,
        order: L
      }
    });
  }, C = (B) => Object.values(B).some(Boolean), x = (B) => `${B.slice(0, 6)}...${B.slice(-6)}`, S = (B, L) => /* @__PURE__ */ R.jsx(
    _r,
    {
      columnGap: "space30",
      display: "flex",
      flexDirection: "column",
      rowGap: "space30",
      children: B.map((N) => {
        const d = N.split("-").slice(0, -1);
        return /* @__PURE__ */ R.jsx(
          JM.Badge,
          {
            as: "span",
            size: "small",
            variant: L,
            children: d.join(" ")
          },
          N
        );
      })
    }
  ), A = (B, L) => /* @__PURE__ */ R.jsxs(kb, { as: "p", className: "flex gap-2 items-center", fontSize: "fontSize20", children: [
    /* @__PURE__ */ R.jsx(al, { text: B, placement: "right", children: /* @__PURE__ */ R.jsx(_r, { as: "span", className: "hover:cursor-pointer", children: x(B) }) }),
    /* @__PURE__ */ R.jsx(_r, { marginLeft: "space20", display: "inline-flex", children: /* @__PURE__ */ R.jsx(
      P7e,
      {
        onSuccess: p,
        text: B
      }
    ) })
  ] });
  if (s)
    return /* @__PURE__ */ R.jsx($a, { error: c });
  const I = Jpn(n.selectedFilters, {
    applications: u == null ? void 0 : u.applications,
    tools: h == null ? void 0 : h.tools,
    workflows: f == null ? void 0 : f.workflows
  }), M = C(n.selectedFilters);
  return /* @__PURE__ */ R.jsxs("div", { className: "flex flex-col gap-4", children: [
    /* @__PURE__ */ R.jsx(Sx.Toaster, { left: ["space40", "unset", "unset"], ...r }),
    /* @__PURE__ */ R.jsx(
      Zpn,
      {
        filters: I,
        selectedFilters: n.selectedFilters,
        isLoading: l,
        onFilterChange: y,
        onFilterClear: b
      }
    ),
    /* @__PURE__ */ R.jsx(
      Rmn,
      {
        ariaLabel: "Conversations",
        id: "id",
        data: o.conversations,
        headers: [
          {
            key: "createdAt",
            label: "Date",
            sortable: !0,
            customRender: (B) => /* @__PURE__ */ R.jsx(_r, { as: "span", fontSize: "fontSize20", children: new aI(String(B)).format("yyyy-MM-dd HH:mm:ss 'GMT'X") })
          },
          {
            key: "id",
            label: "Conversation ID",
            customRender: (B) => {
              const L = String(B);
              return /* @__PURE__ */ R.jsxs(kb, { as: "p", className: "flex gap-2 items-center", fontSize: "fontSize20", children: [
                /* @__PURE__ */ R.jsx(
                  iWe,
                  {
                    className: "text-blue-700 font-medium hover:underline underline-offset-2",
                    to: `/debugger/${L}`,
                    children: /* @__PURE__ */ R.jsx(al, { text: L, placement: "right", children: /* @__PURE__ */ R.jsx(kb, { as: "span", fontSize: "fontSize20", color: "inherit", children: x(L) }) })
                  }
                ),
                /* @__PURE__ */ R.jsx(_r, { marginLeft: "space20", display: "inline-flex", children: /* @__PURE__ */ R.jsx(
                  P7e,
                  {
                    onSuccess: p,
                    text: L
                  }
                ) })
              ] });
            }
          },
          {
            key: "userId",
            label: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
              "User ID ",
              /* @__PURE__ */ R.jsx("br", {}),
              " Account ID"
            ] }),
            customRender: (B, L) => {
              const N = String(B), { accountId: d } = L;
              return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                A(N),
                d && A(d)
              ] });
            }
          },
          {
            key: "applicationIds",
            label: "Applications",
            customRender(B) {
              return S(B, "decorative20");
            }
          },
          {
            key: "workflowIds",
            label: "Workflows",
            customRender(B) {
              return S(B, "decorative30");
            }
          },
          {
            key: "toolIds",
            label: "Tools",
            customRender(B) {
              return S(B, "decorative40");
            }
          }
        ],
        isLoading: l,
        noResults: {
          heading: "No conversations found",
          description: M ? "Try adjusting your filters or clearing them." : "",
          button: M ? {
            label: "Clear all filters",
            onClick: w
          } : void 0
        },
        onColumnSort: _,
        sortBy: [n.sortBy, n.order]
      }
    ),
    /* @__PURE__ */ R.jsx(_r, { as: "hr" }),
    /* @__PURE__ */ R.jsx(
      Qpn,
      {
        hasNextPage: o.page.hasNextPage,
        hasPreviousPage: o.page.hasPrevPage,
        onPageChange: g
      }
    )
  ] });
}, Cbn = () => /* @__PURE__ */ R.jsxs(
  _r,
  {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    children: [
      /* @__PURE__ */ R.jsx(Kh, {}),
      /* @__PURE__ */ R.jsx(Am, { as: "h1", variant: "heading10", children: jpn.pageTitle }),
      /* @__PURE__ */ R.jsx(
        _r,
        {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          children: /* @__PURE__ */ R.jsx(Omn, {})
        }
      )
    ]
  }
);
export {
  X3n as ApplicationConversationViewContainer,
  nhn as ApplicationConversationViewDisplay,
  Q3n as ApplicationHomeViewContainer,
  ahn as ApplicationHomeViewDisplay,
  ebn as ApplicationIndexContainer,
  ihn as ApplicationIndexDisplay,
  tbn as ApplicationResourceContainer,
  ohn as ApplicationResourceDisplay,
  rbn as AssistantIndexContainer,
  shn as AssistantIndexDisplay,
  nbn as AssistantResourceContainer,
  lhn as AssistantResourceDisplay,
  abn as AssistantViewContainer,
  chn as AssistantViewDisplay,
  ibn as BlockIndexContainer,
  uhn as BlockIndexDisplay,
  gP as BlockRenderer,
  obn as BlockResourceContainer,
  dhn as BlockResourceDisplay,
  sbn as BlockViewContainer,
  fhn as BlockViewDisplay,
  mm as ColoredNode,
  lbn as ComponentIndexContainer,
  hhn as ComponentIndexDisplay,
  cbn as ComponentResourceContainer,
  phn as ComponentResourceDisplay,
  U1n as ConditionalNode,
  J3n as ConversationDebuggerContainer,
  Cbn as ConversationDebuggerHomeContainer,
  Omn as ConversationsList,
  Mhr as CreateConversationEventParser,
  Fvt as DirectedGraph,
  P2n as DirectedGraphInternal,
  ubn as KnowledgeSourceIndexContainer,
  mhn as KnowledgeSourceIndexDisplay,
  dbn as KnowledgeSourceResourceContainer,
  ghn as KnowledgeSourceResourceDisplay,
  zvt as Legend,
  Rhr as MessageDoneEventParser,
  R2n as NoteNode,
  fbn as PageIndexContainer,
  vhn as PageIndexDisplay,
  hbn as PageResourceContainer,
  yhn as PageResourceDisplay,
  pbn as PageViewContainer,
  bhn as PageViewDisplay,
  i3 as ResourcePage,
  Phr as SendMessageEventParser,
  BGe as SideBarItems,
  mbn as ToolIndexContainer,
  xhn as ToolIndexDisplay,
  gbn as ToolResourceContainer,
  Chn as ToolResourceDisplay,
  vbn as ToolViewContainer,
  Npn as ToolViewDisplay,
  Tbe as WiseOwl,
  o3 as WiseOwlAdminIndexPage,
  Y3n as WiseOwlAdminLayout,
  rln as WiseOwlPage,
  Z3n as WiseOwlProvider,
  Qsn as WiseOwlSidebar,
  L3n as WiseOwlUiEventParser,
  l0 as WiseOwlUiEventTypeEnum,
  ybn as WorkflowIndexContainer,
  $pn as WorkflowIndexDisplay,
  bbn as WorkflowResourceContainer,
  Dpn as WorkflowResourceDisplay,
  xbn as WorkflowViewContainer,
  Lpn as WorkflowViewDisplay,
  rhn as monitorSideBarItems,
  A5 as nonEmptyStringCodec,
  uKe as store,
  aPt as useAnalyticsGetConversationQuery,
  nPt as useAnalyticsListConversationEventsQuery,
  s2 as useAppDispatch,
  Gn as useAppSelector,
  uPt as useCreateCanvasVersionMutation,
  HMt as useCreateConversationMutation,
  cPt as useCreateMessageFeedbackMutation,
  ePt as useCreatePromptMutation,
  rPt as useDeletePromptMutation,
  hPt as useDirectTransferToLiveChatMutation,
  ZMt as useGetApplicationHomeQuery,
  WI as useGetApplicationQuery,
  eKe as useGetAssistantQuery,
  rKe as useGetBlockQuery,
  VMt as useGetComponentBlockQuery,
  XMt as useGetComponentQuery,
  UMt as useGetConversationQuery,
  lPt as useGetKnowledgeSourceQuery,
  Yqe as useGetPageQuery,
  Qqe as useGetToolQuery,
  aKe as useGetWorkflowQuery,
  qMt as useLazyGetComponentBlockQuery,
  WMt as useLazyGetConversationSummaryQuery,
  tKe as useListApplicationsQuery,
  KMt as useListAssistantsQuery,
  JMt as useListBlocksQuery,
  QMt as useListComponentsQuery,
  iPt as useListConversationsQuery,
  sPt as useListKnowledgeSourcesQuery,
  YMt as useListPagesQuery,
  nKe as useListPromptsQuery,
  Xqe as useListToolsQuery,
  iKe as useListWorkflowsQuery,
  oPt as useRunToolMutation,
  dPt as useTransferToLiveChatMutation,
  I3n as useUpdateConversationChunkedMutation,
  fPt as useUpdateConversationSyncMutation,
  pPt as useUpdateMessageFeedbackMutation,
  tPt as useUpdatePromptMutation,
  rs as wiseOwlAdminRoutes,
  k_ as wiseOwlApi
};
//# sourceMappingURL=index.es.js.map
